/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		28: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "assets/" + chunkId + "." + "27bb9b833ac0d689e404" + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 914);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1089);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1095)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(1664)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.3';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(68);
var hide = __webpack_require__(53);
var redefine = __webpack_require__(54);
var ctx = __webpack_require__(69);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1188);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sheetsManager = undefined;

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _map = __webpack_require__(1243);

var _map2 = _interopRequireDefault(_map);

var _minSafeInteger = __webpack_require__(1259);

var _minSafeInteger2 = _interopRequireDefault(_minSafeInteger);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _hoistNonReactStatics = __webpack_require__(350);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _getDisplayName = __webpack_require__(533);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _wrapDisplayName = __webpack_require__(191);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _contextTypes = __webpack_require__(1262);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _jss = __webpack_require__(1264);

var _ns = __webpack_require__(534);

var ns = _interopRequireWildcard(_ns);

var _jssPreset = __webpack_require__(516);

var _jssPreset2 = _interopRequireDefault(_jssPreset);

var _createMuiTheme = __webpack_require__(328);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(349);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _createGenerateClassName = __webpack_require__(507);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _getStylesCreator = __webpack_require__(1282);

var _getStylesCreator2 = _interopRequireDefault(_getStylesCreator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset2.default)());

// Use a singleton or the provided one by the context.
var generateClassName = (0, _createGenerateClassName2.default)();

// Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any childs styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = _minSafeInteger2.default;

var sheetsManager = exports.sheetsManager = new _map2.default();

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

// In order to have self-supporting components, we rely on default theme when not provided.
var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === undefined ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === undefined ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties3.default)(options, ['withTheme', 'flip', 'name']);

    var stylesCreator = (0, _getStylesCreator2.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';

    indexCounter += 1;
    stylesCreator.options.index = indexCounter;

     false ? (0, _warning2.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles = function (_React$Component) {
      (0, _inherits3.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        (0, _classCallCheck3.default)(this, WithStyles);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).call(this, props, context));

        _this.state = {};
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;


        _this.jss = _this.context[ns.jss] || jss;

        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        }

        // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107
        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, _this.context[ns.sheetOptions]);
        // We use || as the function call is lazy evaluated.
        _this.theme = listenToTheme ? _themeListener2.default.initial(context) || getDefaultTheme() : noopTheme;

        _this.attach(_this.theme);
        return _this;
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;
            _this2.attach(_this2.theme);

            // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.
            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'attach',
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new _map2.default();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName2.default)(Component);
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));

            sheetManagerTheme.sheet = sheet;
            sheet.attach();

            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: 'detach',
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);

          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var _props = this.props,
              classesProp = _props.classes,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'innerRef']);


          var classes = void 0;
          var renderedClasses = {};

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);
            renderedClasses = sheetsManagerTheme.sheet.classes;
          }

          if (classesProp) {
            classes = (0, _extends3.default)({}, renderedClasses, (0, _keys2.default)(classesProp).reduce(function (accumulator, key) {
               false ? (0, _warning2.default)(renderedClasses[key] || _this3.disableStylesGeneration, ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not implemented in ' + (0, _getDisplayName2.default)(Component) + '.'), 'You can only override one of the following: ' + (0, _keys2.default)(renderedClasses).join(',')].join('\n')) : void 0;

               false ? (0, _warning2.default)(!classesProp[key] || typeof classesProp[key] === 'string', ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not valid for ' + (0, _getDisplayName2.default)(Component) + '.'), 'You need to provide a non empty string instead of: ' + classesProp[key] + '.'].join('\n')) : void 0;

              if (classesProp[key]) {
                accumulator[key] = renderedClasses[key] + ' ' + classesProp[key];
              }

              return accumulator;
            }, {}));
          } else {
            classes = renderedClasses;
          }

          var more = {};

          // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.
          if (withTheme) {
            more.theme = this.theme;
          }

          return _react2.default.createElement(Component, (0, _extends3.default)({ classes: classes }, more, other, { ref: innerRef }));
        }
      }]);
      return WithStyles;
    }(_react2.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Useful to extend the style applied to components.
       */
      classes: _propTypes2.default.object,
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes2.default.func
    } : {};

    WithStyles.contextTypes = (0, _extends3.default)({
      muiThemeProviderOptions: _propTypes2.default.object
    }, _contextTypes2.default, listenToTheme ? _themeListener2.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName2.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics2.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

exports.default = withStyles;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(513);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(513);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1218), __esModule: true };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(343);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1235);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1239);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(343);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = toDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(9);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(98);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(404);
/* unused harmony reexport chainPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(1768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__deepmerge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(1769);
/* unused harmony reexport elementAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(1770);
/* unused harmony reexport elementTypeAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(1771);
/* unused harmony reexport exactProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__ = __webpack_require__(1772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getDisplayName__ = __webpack_require__(1773);
/* unused harmony reexport getDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HTMLElementType__ = __webpack_require__(1775);
/* unused harmony reexport HTMLElementType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ponyfillGlobal__ = __webpack_require__(1776);
/* unused harmony reexport ponyfillGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__refType__ = __webpack_require__(1777);
/* unused harmony reexport refType */
/** @license Material-UI v4.11.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











/***/ }),
/* 20 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1090);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {
	        function F() {}

	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                F.prototype = this;
	                var subtype = new F();

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init')) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(809);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["d" /* withStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(175)('wks');
var uid = __webpack_require__(120);
var Symbol = __webpack_require__(20).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(71);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(23)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(343);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
} //  weak

function contains(obj, pred) {
  return (0, _keys2.default)(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (func) {
    return func != null;
  }).reduce(function (acc, func) {
     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(437);
var toPrimitive = __webpack_require__(79);
var dP = Object.defineProperty;

exports.f = __webpack_require__(34) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(80);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(322);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(1137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(1139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Customizer const
var TOGGLE_COLLAPSED_NAV = exports.TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
var DRAWER_TYPE = exports.DRAWER_TYPE = 'drawer_type';
var FIXED_DRAWER = exports.FIXED_DRAWER = 'fixed_drawer';
var COLLAPSED_DRAWER = exports.COLLAPSED_DRAWER = 'collapsible';
var MINI_DRAWER = exports.MINI_DRAWER = 'mini_drawer';
var THEME_COLOR = exports.THEME_COLOR = 'theme_color';
var DARK_THEME = exports.DARK_THEME = 'dark_theme';
var WINDOW_WIDTH = exports.WINDOW_WIDTH = 'window-width';
var SWITCH_LANGUAGE = exports.SWITCH_LANGUAGE = 'switch-language';

//Contact Module const

var SHOW_MESSAGE = exports.SHOW_MESSAGE = 'show_message';
var HIDE_MESSAGE = exports.HIDE_MESSAGE = 'hide_message';

var FETCH_ALL_CONTACT = exports.FETCH_ALL_CONTACT = 'fetch_all_contact';
var FETCH_ALL_CONTACT_SUCCESS = exports.FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
var ADD_FAVOURITE = exports.ADD_FAVOURITE = 'add_favourite';
var ON_CONTACT_SELECT = exports.ON_CONTACT_SELECT = 'on_contact_select';
var ON_ADD_CONTACT = exports.ON_ADD_CONTACT = 'on_add_contact';
var ON_CONTACT_CLOSE = exports.ON_CONTACT_CLOSE = 'on_contact_close';
var ON_FILTER_OPTION_SELECT = exports.ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
var ON_SAVE_CONTACT = exports.ON_SAVE_CONTACT = 'on_save_contact';
var ON_DELETE_CONTACT = exports.ON_DELETE_CONTACT = 'on_delete_contact';
var ON_DELETE_SELECTED_CONTACT = exports.ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
var FILTER_CONTACT = exports.FILTER_CONTACT = 'filter_contact';
var GET_ALL_CONTACT = exports.GET_ALL_CONTACT = 'get_all_contact';
var GET_UNSELECTED_ALL_CONTACT = exports.GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
var ON_ALL_CONTACT_SELECT = exports.ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
var UPDATE_SEARCH_USER = exports.UPDATE_SEARCH_USER = 'update_search_user';
var ON_TOGGLE_DRAWER = exports.ON_TOGGLE_DRAWER = 'on_toggle_drawer';
var HANDLE_REQUEST_CLOSE = exports.HANDLE_REQUEST_CLOSE = 'handle_request_close';

//Auth const
var SIGNUP_USER = exports.SIGNUP_USER = 'signup_user';
var SIGNUP_USER_SUCCESS = exports.SIGNUP_USER_SUCCESS = 'signup_user_success';
var SIGNIN_GOOGLE_USER = exports.SIGNIN_GOOGLE_USER = 'signin_google_user';
var SIGNIN_GOOGLE_USER_SUCCESS = exports.SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
var SIGNIN_FACEBOOK_USER = exports.SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
var SIGNIN_FACEBOOK_USER_SUCCESS = exports.SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
var SIGNIN_TWITTER_USER = exports.SIGNIN_TWITTER_USER = 'signin_twitter_user';
var SIGNIN_TWITTER_USER_SUCCESS = exports.SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
var SIGNIN_GITHUB_USER = exports.SIGNIN_GITHUB_USER = 'signin_github_user';
var SIGNIN_GITHUB_USER_SUCCESS = exports.SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
var SIGNIN_USER = exports.SIGNIN_USER = 'signin_user';
var SIGNIN_USER_SUCCESS = exports.SIGNIN_USER_SUCCESS = 'signin_user_success';
var SIGNOUT_USER = exports.SIGNOUT_USER = 'signout_user';
var SIGNOUT_USER_SUCCESS = exports.SIGNOUT_USER_SUCCESS = 'signout_user_success';
var INIT_URL = exports.INIT_URL = 'init_url';

// Chat Module const

var FETCH_ALL_CHAT_USER = exports.FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
var FETCH_ALL_CHAT_USER_CONVERSATION = exports.FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
var FETCH_ALL_CHAT_USER_SUCCESS = exports.FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
var FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = exports.FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
var FILTER_USERS = exports.FILTER_USERS = 'filter_users';
var ON_SELECT_USER = exports.ON_SELECT_USER = 'on_select_user';
var ON_SHOW_LOADER = exports.ON_SHOW_LOADER = 'on_show_loader';
var ON_HIDE_LOADER = exports.ON_HIDE_LOADER = 'on_hide_loader';
var USER_INFO_STATE = exports.USER_INFO_STATE = 'user_info_state';
var SUBMIT_COMMENT = exports.SUBMIT_COMMENT = 'submit_comment';
var UPDATE_MESSAGE_VALUE = exports.UPDATE_MESSAGE_VALUE = 'update_message_value';
var UPDATE_SEARCH_CHAT_USER = exports.UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const


var ADD_LABEL = exports.ADD_LABEL = 'ADD_LABEL';
var GET_ALL_MAIL = exports.GET_ALL_MAIL = 'get_all_mail';
var FETCH_ALL_MAIL = exports.FETCH_ALL_MAIL = 'fetch_all_mail';
var FETCH_ALL_MAIL_SUCCESS = exports.FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
var GET_IMPORTANT_MAIL = exports.GET_IMPORTANT_MAIL = 'get_important_mail';
var GET_NAV_FILTERS = exports.GET_NAV_FILTERS = 'get_nav_filters';
var GET_NAV_LABELS = exports.GET_NAV_LABELS = 'get_nav_labels';
var GET_NAV_FOLDER = exports.GET_NAV_FOLDER = 'get_nav_folder';
var GET_READ_MAIL = exports.GET_READ_MAIL = 'get_read_mail';
var GET_STARRED_MAIL = exports.GET_STARRED_MAIL = 'get_starred_mail';
var GET_UNIMPORTANT_MAIL = exports.GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
var GET_UNREAD_MAIL = exports.GET_UNREAD_MAIL = 'get_unread_mail';
var GET_UNSELECTED_ALL_MAIL = exports.GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
var GET_UNSTARRED_MAIL = exports.GET_UNSTARRED_MAIL = 'get_unstarred_mail';
var ON_ALL_MAIL_SELECT = exports.ON_ALL_MAIL_SELECT = 'on_all_mail_select';
var ON_FOLDER_MENU_ITEM_SELECT = exports.ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
var ON_FOLDER_SELECT = exports.ON_FOLDER_SELECT = 'on_folder_select';
var ON_IMPORTANT_SELECT = exports.ON_IMPORTANT_SELECT = 'on_important_select';
var ON_LABEL_MENU_ITEM_SELECT = exports.ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
var GET_MARK_AS_START = exports.GET_MARK_AS_START = 'get_mark_as_start';
var ON_LABEL_SELECT = exports.ON_LABEL_SELECT = 'on_label_select';
var ON_MAIL_CHECKED = exports.ON_MAIL_CHECKED = 'on_mail_checked';
var ON_MAIL_SELECT = exports.ON_MAIL_SELECT = 'on_mail_select';
var ON_MAIL_SEND = exports.ON_MAIL_SEND = 'on_mail_send';
var ON_OPTION_MENU_ITEM_SELECT = exports.ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
var ON_OPTION_MENU_SELECT = exports.ON_OPTION_MENU_SELECT = 'on_option_menu_select';
var ON_START_SELECT = exports.ON_START_SELECT = 'on_start_select';
var SEARCH_MAIL = exports.SEARCH_MAIL = 'search_mail';
var ON_DELETE_MAIL = exports.ON_DELETE_MAIL = 'on_delete_mail';
var SET_CURRENT_MAIL_NULL = exports.SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
var ON_COMPOSE_MAIL = exports.ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

var ON_SORTEND = exports.ON_SORTEND = 'on_sortend';
var FETCH_ALL_TODO = exports.FETCH_ALL_TODO = 'fetch_all_todo';
var FETCH_ALL_TODO_SUCCESS = exports.FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
var FETCH_ALL_TODO_CONVERSATION = exports.FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
var FETCH_ALL_TODO_CONVERSATION_SUCCESS = exports.FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
var SELECT_ALL_TODO = exports.SELECT_ALL_TODO = 'select_all_todo';
var GET_ALL_TODO = exports.GET_ALL_TODO = 'get_all_todo';
var GET_UNSELECTED_ALL_TODO = exports.GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
var GET_STARRED_TODO = exports.GET_STARRED_TODO = 'get_starred_todo';
var GET_UNSTARRED_TODO = exports.GET_UNSTARRED_TODO = 'get_unstarred_todo';
var GET_IMPORTANT_TODO = exports.GET_IMPORTANT_TODO = 'get_important_todo';
var GET_UNIMPORTANT_TODO = exports.GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
var ON_LABEL_UPDATE = exports.ON_LABEL_UPDATE = 'on_label_update';
var ON_TODO_UPDATE = exports.ON_TODO_UPDATE = 'on_todo_update';
var ON_DELETE_TODO = exports.ON_DELETE_TODO = 'on_delete_todo';
var SEARCH_TODO = exports.SEARCH_TODO = 'search_todo';
var SHOW_TODOS = exports.SHOW_TODOS = 'show_todos';
var GET_TODO_CONVERSATION = exports.GET_TODO_CONVERSATION = 'get_todo_conversation';
var ON_TODO_CHECKED = exports.ON_TODO_CHECKED = 'on_todo_checked';
var ON_TODO_ADD = exports.ON_TODO_ADD = 'on_todo_add';
var ON_TODO_SELECT = exports.ON_TODO_SELECT = 'on_todo_select';
var SET_CURRENT_TODO_NULL = exports.SET_CURRENT_TODO_NULL = 'set_current_todo_null';
var REMOVE_LABEL = exports.REMOVE_LABEL = 'remove_label';
var UPDATE_SEARCH = exports.UPDATE_SEARCH = 'update_search';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TOGGLE_COLLAPSED_NAV, 'TOGGLE_COLLAPSED_NAV', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(DRAWER_TYPE, 'DRAWER_TYPE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FIXED_DRAWER, 'FIXED_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(COLLAPSED_DRAWER, 'COLLAPSED_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(MINI_DRAWER, 'MINI_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(THEME_COLOR, 'THEME_COLOR', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(DARK_THEME, 'DARK_THEME', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(WINDOW_WIDTH, 'WINDOW_WIDTH', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SWITCH_LANGUAGE, 'SWITCH_LANGUAGE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SHOW_MESSAGE, 'SHOW_MESSAGE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(HIDE_MESSAGE, 'HIDE_MESSAGE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT, 'FETCH_ALL_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT_SUCCESS, 'FETCH_ALL_CONTACT_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE, 'ADD_FAVOURITE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_CONTACT_SELECT, 'ON_CONTACT_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_ADD_CONTACT, 'ON_ADD_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_CONTACT_CLOSE, 'ON_CONTACT_CLOSE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_FILTER_OPTION_SELECT, 'ON_FILTER_OPTION_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SAVE_CONTACT, 'ON_SAVE_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_CONTACT, 'ON_DELETE_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_CONTACT, 'ON_DELETE_SELECTED_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FILTER_CONTACT, 'FILTER_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_ALL_CONTACT, 'GET_ALL_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_CONTACT, 'GET_UNSELECTED_ALL_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_ALL_CONTACT_SELECT, 'ON_ALL_CONTACT_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_USER, 'UPDATE_SEARCH_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TOGGLE_DRAWER, 'ON_TOGGLE_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(HANDLE_REQUEST_CLOSE, 'HANDLE_REQUEST_CLOSE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNUP_USER, 'SIGNUP_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNUP_USER_SUCCESS, 'SIGNUP_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER, 'SIGNIN_GOOGLE_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER_SUCCESS, 'SIGNIN_GOOGLE_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER, 'SIGNIN_FACEBOOK_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER_SUCCESS, 'SIGNIN_FACEBOOK_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER, 'SIGNIN_TWITTER_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER_SUCCESS, 'SIGNIN_TWITTER_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER, 'SIGNIN_GITHUB_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER_SUCCESS, 'SIGNIN_GITHUB_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_USER, 'SIGNIN_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_USER_SUCCESS, 'SIGNIN_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNOUT_USER, 'SIGNOUT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNOUT_USER_SUCCESS, 'SIGNOUT_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(INIT_URL, 'INIT_URL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER, 'FETCH_ALL_CHAT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION, 'FETCH_ALL_CHAT_USER_CONVERSATION', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_SUCCESS, 'FETCH_ALL_CHAT_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS, 'FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FILTER_USERS, 'FILTER_USERS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SELECT_USER, 'ON_SELECT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SHOW_LOADER, 'ON_SHOW_LOADER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_HIDE_LOADER, 'ON_HIDE_LOADER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(USER_INFO_STATE, 'USER_INFO_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SUBMIT_COMMENT, 'SUBMIT_COMMENT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_MESSAGE_VALUE, 'UPDATE_MESSAGE_VALUE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_CHAT_USER, 'UPDATE_SEARCH_CHAT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ADD_LABEL, 'ADD_LABEL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_ALL_MAIL, 'GET_ALL_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL, 'FETCH_ALL_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL_SUCCESS, 'FETCH_ALL_MAIL_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_MAIL, 'GET_IMPORTANT_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_NAV_FILTERS, 'GET_NAV_FILTERS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_NAV_LABELS, 'GET_NAV_LABELS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_NAV_FOLDER, 'GET_NAV_FOLDER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_READ_MAIL, 'GET_READ_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_STARRED_MAIL, 'GET_STARRED_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_MAIL, 'GET_UNIMPORTANT_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNREAD_MAIL, 'GET_UNREAD_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_MAIL, 'GET_UNSELECTED_ALL_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_MAIL, 'GET_UNSTARRED_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_ALL_MAIL_SELECT, 'ON_ALL_MAIL_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_FOLDER_MENU_ITEM_SELECT, 'ON_FOLDER_MENU_ITEM_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_FOLDER_SELECT, 'ON_FOLDER_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_IMPORTANT_SELECT, 'ON_IMPORTANT_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_LABEL_MENU_ITEM_SELECT, 'ON_LABEL_MENU_ITEM_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_MARK_AS_START, 'GET_MARK_AS_START', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_LABEL_SELECT, 'ON_LABEL_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_MAIL_CHECKED, 'ON_MAIL_CHECKED', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_MAIL_SELECT, 'ON_MAIL_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_MAIL_SEND, 'ON_MAIL_SEND', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_ITEM_SELECT, 'ON_OPTION_MENU_ITEM_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_SELECT, 'ON_OPTION_MENU_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_START_SELECT, 'ON_START_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SEARCH_MAIL, 'SEARCH_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_MAIL, 'ON_DELETE_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SET_CURRENT_MAIL_NULL, 'SET_CURRENT_MAIL_NULL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_COMPOSE_MAIL, 'ON_COMPOSE_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SORTEND, 'ON_SORTEND', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO, 'FETCH_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_SUCCESS, 'FETCH_ALL_TODO_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION, 'FETCH_ALL_TODO_CONVERSATION', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION_SUCCESS, 'FETCH_ALL_TODO_CONVERSATION_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SELECT_ALL_TODO, 'SELECT_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_ALL_TODO, 'GET_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_TODO, 'GET_UNSELECTED_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_STARRED_TODO, 'GET_STARRED_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_TODO, 'GET_UNSTARRED_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_TODO, 'GET_IMPORTANT_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_TODO, 'GET_UNIMPORTANT_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_LABEL_UPDATE, 'ON_LABEL_UPDATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_UPDATE, 'ON_TODO_UPDATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_TODO, 'ON_DELETE_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SEARCH_TODO, 'SEARCH_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SHOW_TODOS, 'SHOW_TODOS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_TODO_CONVERSATION, 'GET_TODO_CONVERSATION', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_CHECKED, 'ON_TODO_CHECKED', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_ADD, 'ON_TODO_ADD', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_SELECT, 'ON_TODO_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SET_CURRENT_TODO_NULL, 'SET_CURRENT_TODO_NULL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(REMOVE_LABEL, 'REMOVE_LABEL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH, 'UPDATE_SEARCH', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TOGGLE_COLLAPSED_NAV, 'TOGGLE_COLLAPSED_NAV', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(DRAWER_TYPE, 'DRAWER_TYPE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FIXED_DRAWER, 'FIXED_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(COLLAPSED_DRAWER, 'COLLAPSED_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(MINI_DRAWER, 'MINI_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(THEME_COLOR, 'THEME_COLOR', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(DARK_THEME, 'DARK_THEME', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(WINDOW_WIDTH, 'WINDOW_WIDTH', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SWITCH_LANGUAGE, 'SWITCH_LANGUAGE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SHOW_MESSAGE, 'SHOW_MESSAGE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(HIDE_MESSAGE, 'HIDE_MESSAGE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT, 'FETCH_ALL_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CONTACT_SUCCESS, 'FETCH_ALL_CONTACT_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ADD_FAVOURITE, 'ADD_FAVOURITE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_CONTACT_SELECT, 'ON_CONTACT_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_ADD_CONTACT, 'ON_ADD_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_CONTACT_CLOSE, 'ON_CONTACT_CLOSE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_FILTER_OPTION_SELECT, 'ON_FILTER_OPTION_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SAVE_CONTACT, 'ON_SAVE_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_CONTACT, 'ON_DELETE_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_SELECTED_CONTACT, 'ON_DELETE_SELECTED_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FILTER_CONTACT, 'FILTER_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_ALL_CONTACT, 'GET_ALL_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_CONTACT, 'GET_UNSELECTED_ALL_CONTACT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_ALL_CONTACT_SELECT, 'ON_ALL_CONTACT_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_USER, 'UPDATE_SEARCH_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TOGGLE_DRAWER, 'ON_TOGGLE_DRAWER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(HANDLE_REQUEST_CLOSE, 'HANDLE_REQUEST_CLOSE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNUP_USER, 'SIGNUP_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNUP_USER_SUCCESS, 'SIGNUP_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER, 'SIGNIN_GOOGLE_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GOOGLE_USER_SUCCESS, 'SIGNIN_GOOGLE_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER, 'SIGNIN_FACEBOOK_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_FACEBOOK_USER_SUCCESS, 'SIGNIN_FACEBOOK_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER, 'SIGNIN_TWITTER_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_TWITTER_USER_SUCCESS, 'SIGNIN_TWITTER_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER, 'SIGNIN_GITHUB_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_GITHUB_USER_SUCCESS, 'SIGNIN_GITHUB_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_USER, 'SIGNIN_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNIN_USER_SUCCESS, 'SIGNIN_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNOUT_USER, 'SIGNOUT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SIGNOUT_USER_SUCCESS, 'SIGNOUT_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(INIT_URL, 'INIT_URL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER, 'FETCH_ALL_CHAT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION, 'FETCH_ALL_CHAT_USER_CONVERSATION', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_SUCCESS, 'FETCH_ALL_CHAT_USER_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS, 'FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FILTER_USERS, 'FILTER_USERS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SELECT_USER, 'ON_SELECT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SHOW_LOADER, 'ON_SHOW_LOADER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_HIDE_LOADER, 'ON_HIDE_LOADER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(USER_INFO_STATE, 'USER_INFO_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SUBMIT_COMMENT, 'SUBMIT_COMMENT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_MESSAGE_VALUE, 'UPDATE_MESSAGE_VALUE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH_CHAT_USER, 'UPDATE_SEARCH_CHAT_USER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ADD_LABEL, 'ADD_LABEL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_ALL_MAIL, 'GET_ALL_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL, 'FETCH_ALL_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_MAIL_SUCCESS, 'FETCH_ALL_MAIL_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_MAIL, 'GET_IMPORTANT_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_NAV_FILTERS, 'GET_NAV_FILTERS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_NAV_LABELS, 'GET_NAV_LABELS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_NAV_FOLDER, 'GET_NAV_FOLDER', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_READ_MAIL, 'GET_READ_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_STARRED_MAIL, 'GET_STARRED_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_MAIL, 'GET_UNIMPORTANT_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNREAD_MAIL, 'GET_UNREAD_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_MAIL, 'GET_UNSELECTED_ALL_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_MAIL, 'GET_UNSTARRED_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_ALL_MAIL_SELECT, 'ON_ALL_MAIL_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_FOLDER_MENU_ITEM_SELECT, 'ON_FOLDER_MENU_ITEM_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_FOLDER_SELECT, 'ON_FOLDER_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_IMPORTANT_SELECT, 'ON_IMPORTANT_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_LABEL_MENU_ITEM_SELECT, 'ON_LABEL_MENU_ITEM_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_MARK_AS_START, 'GET_MARK_AS_START', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_LABEL_SELECT, 'ON_LABEL_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_MAIL_CHECKED, 'ON_MAIL_CHECKED', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_MAIL_SELECT, 'ON_MAIL_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_MAIL_SEND, 'ON_MAIL_SEND', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_ITEM_SELECT, 'ON_OPTION_MENU_ITEM_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_OPTION_MENU_SELECT, 'ON_OPTION_MENU_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_START_SELECT, 'ON_START_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SEARCH_MAIL, 'SEARCH_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_MAIL, 'ON_DELETE_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SET_CURRENT_MAIL_NULL, 'SET_CURRENT_MAIL_NULL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_COMPOSE_MAIL, 'ON_COMPOSE_MAIL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_SORTEND, 'ON_SORTEND', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO, 'FETCH_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_SUCCESS, 'FETCH_ALL_TODO_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION, 'FETCH_ALL_TODO_CONVERSATION', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(FETCH_ALL_TODO_CONVERSATION_SUCCESS, 'FETCH_ALL_TODO_CONVERSATION_SUCCESS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SELECT_ALL_TODO, 'SELECT_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_ALL_TODO, 'GET_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSELECTED_ALL_TODO, 'GET_UNSELECTED_ALL_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_STARRED_TODO, 'GET_STARRED_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNSTARRED_TODO, 'GET_UNSTARRED_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_IMPORTANT_TODO, 'GET_IMPORTANT_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_UNIMPORTANT_TODO, 'GET_UNIMPORTANT_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_LABEL_UPDATE, 'ON_LABEL_UPDATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_UPDATE, 'ON_TODO_UPDATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_DELETE_TODO, 'ON_DELETE_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SEARCH_TODO, 'SEARCH_TODO', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SHOW_TODOS, 'SHOW_TODOS', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(GET_TODO_CONVERSATION, 'GET_TODO_CONVERSATION', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_CHECKED, 'ON_TODO_CHECKED', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_ADD, 'ON_TODO_ADD', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(ON_TODO_SELECT, 'ON_TODO_SELECT', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(SET_CURRENT_TODO_NULL, 'SET_CURRENT_TODO_NULL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(REMOVE_LABEL, 'REMOVE_LABEL', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(UPDATE_SEARCH, 'UPDATE_SEARCH', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ActionTypes.js');
}();

;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;

	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }
	            this._mode = modeCreator.call(mode, this, iv && iv.words);
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(249)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(201)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(1577)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(1632)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(1634)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(1640)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = __webpack_require__(1896);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SvgIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(1527);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(560);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(84);
var core = __webpack_require__(45);
var ctx = __webpack_require__(131);
var hide = __webpack_require__(111);
var has = __webpack_require__(134);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1893);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(1895);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(834);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(191);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(36);
var createDesc = __webpack_require__(119);
module.exports = __webpack_require__(34) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var hide = __webpack_require__(53);
var has = __webpack_require__(61);
var SRC = __webpack_require__(120)('src');
var $toString = __webpack_require__(918);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(68).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var fails = __webpack_require__(23);
var defined = __webpack_require__(80);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61344d74e98f932da514423a6010f683.woff2";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b48ec43aacdb019745719ae98c048059.woff";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Typography = __webpack_require__(1422);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Typography).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThresholdData = getThresholdData;
exports.updateThresholdsData = updateThresholdsData;
exports.mqttClientConnect = mqttClientConnect;
exports.getMqttClient = getMqttClient;
exports.authenticate = authenticate;
exports.requestData = requestData;
exports.requestTechOnSiteData = requestTechOnSiteData;
exports.getLocation = getLocation;
exports.requestWithoutDeviceId = requestWithoutDeviceId;
exports.requestTimedData = requestTimedData;
exports.getNotifications = getNotifications;
exports.closeNotification = closeNotification;
exports.searchDevices = searchDevices;
exports.requestNotificationTimedData = requestNotificationTimedData;
exports.updateThemeConfiguration = updateThemeConfiguration;
exports.getThemeConfiguration = getThemeConfiguration;
exports.requestStateWiseDevices = requestStateWiseDevices;
exports.requestAustraliaLocations = requestAustraliaLocations;
exports.updateDeviceCount = updateDeviceCount;
exports.getDevicesData = getDevicesData;
exports.refreshDevicesData = refreshDevicesData;
exports.getPitStatusLast7Days = getPitStatusLast7Days;
exports.getPitStatusLast30Days = getPitStatusLast30Days;
exports.getTechStatusLast7Days = getTechStatusLast7Days;
exports.getTechStatusLast30Days = getTechStatusLast30Days;
exports.getFilteredRecord = getFilteredRecord;
exports.getCurrentStatusDetails = getCurrentStatusDetails;
exports.getPitStatus = getPitStatus;
exports.getNumberOfPitStatus = getNumberOfPitStatus;
exports.getPitDepth = getPitDepth;
exports.setDepthOfPit = setDepthOfPit;
exports.getAllConfiguration = getAllConfiguration;
exports.setAllConfiguration = setAllConfiguration;
exports.getPitWarningLevel = getPitWarningLevel;
exports.getMultipleReadingsFromAllSensors = getMultipleReadingsFromAllSensors;
exports.getLastNRecordsFromAllSensors = getLastNRecordsFromAllSensors;
exports.getNodeVitals = getNodeVitals;
exports.getDeviceCatalogue = getDeviceCatalogue;
exports.getIndividualNodeVitals = getIndividualNodeVitals;
exports.extractDataForPdf = extractDataForPdf;
exports.alertsModificationData = alertsModificationData;
exports.updateAlertStatus = updateAlertStatus;

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

var AWS = __webpack_require__(572);
var AWSIoTData = __webpack_require__(1438);

var axios = __webpack_require__(1504);

AWS.config.region = CONST.REGION; // Region
// AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//   IdentityPoolId: CONST.IDENTITY_POOL_ID,
// });

AWS.config.update({
  accessKeyId: CONST.ACCESS_KEY_ID,
  secretAccessKey: CONST.SECRET_ACCESS_KEY
});

var docClient = new AWS.DynamoDB.DocumentClient();

var AWSLambda = new AWS.Lambda({
  region: CONST.REGION,
  apiVersion: "2015-03-31"
});

//
// Create a client id to use when connecting to AWS IoT.
//
var clientId = "sym-heartbeat-" + Math.floor(Math.random() * 100000 + 1);

function getThresholdData(deviceID) {
  var promiseForGetThresholdData = new Promise(function (resolve, reject) {
    var pullParams = {
      FunctionName: CONST.GET_THRESHOLDS_DATA,
      InvocationType: "RequestResponse",
      LogType: "None",
      Payload: "{\"deviceID\" : \"" + deviceID + "\"}"
    };

    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        resolve(JSON.parse(data.Payload));
      }
    });
  });

  return promiseForGetThresholdData;
}

function updateThresholdsData(deviceID, thresholdsToUpdate) {
  var promiseForUpdateThresholdsData = new Promise(function (resolve, reject) {
    var pullParams = {
      FunctionName: CONST.UPDATE_THRESHOLDS_DATA,
      InvocationType: "RequestResponse",
      LogType: "None",
      Payload: "{\"deviceID\" : \"" + deviceID + "\",\"thresholds\" : " + JSON.stringify(thresholdsToUpdate) + "}"
    };

    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        resolve(data.Payload);
      }
    });
  });

  return promiseForUpdateThresholdsData;
}

//
// Create the AWS IoT device object.  Note that the credentials must be
// initialized with empty strings; when we successfully authenticate to
// the Cognito Identity Pool, the credentials will be dynamically updated.
//
var mqttClient = void 0;

function mqttClientConnect() {
  mqttClient = AWSIoTData.device({
    //
    // Set the AWS region we will operate in.
    //
    region: AWS.config.region,
    //
    ////Set the AWS IoT Host Endpoint
    host: CONST.IOT_HOST,
    //
    // Use the clientId created earlier.
    //
    clientId: clientId,
    //
    // Connect via secure WebSocket
    //
    protocol: "wss",
    //
    // Set the maximum reconnect time to 8 seconds; this is a browser application
    // so we don't want to leave the user waiting too long for reconnection after
    // re-connecting to the network/re-opening their laptop/etc...
    //
    maximumReconnectTimeMs: 8000,
    //
    // Enable console debugging information (optional)
    //
    // debug: true,
    //
    // IMPORTANT: the AWS access key ID, secret key, and sesion token must be
    // initialized with empty strings.
    //
    accessKeyId: "",
    secretKey: "",
    sessionToken: ""
  });
}

function getMqttClient() {
  return mqttClient;
}

function authenticate() {
  return new Promise(function (resolve, reject) {
    AWS.config.credentials.get(function (err) {
      if (err) {
        reject(err);
      }

      //
      // Attempt to authenticate to the Cognito Identity Pool.
      // TODO: Note that this example only supports use of a pool which allows unauthenticated identities.
      //
      var cognitoIdentity = new AWS.CognitoIdentity();
      var params = {
        IdentityId: AWS.config.credentials.identityId
      };
      cognitoIdentity.getCredentialsForIdentity(params, function (err, data) {
        if (!err) {
          //
          // Update our latest AWS credentials; the MQTT client will use these during its next reconnect attempt.
          //
          mqttClient.updateWebSocketCredentials(data.Credentials.AccessKeyId, data.Credentials.SecretKey, data.Credentials.SessionToken);

          resolve("Success");
        } else {
          reject(err);
        }
      });
    });
  });
}

var queryToFetchDynamoDBData = function queryToFetchDynamoDBData(params) {
  // const docClient = new AWS.DynamoDB.DocumentClient();
  return new Promise(function (resolve, reject) {
    docClient.query(params, function (err, data) {
      if (err || data === null) {
        reject(err);
      } // an error occurred
      else {
          resolve(data);
        } // received data
    });
  });
};

var scanToFetchDynamoDBData = function scanToFetchDynamoDBData(params) {
  var docClient = new AWS.DynamoDB.DocumentClient();
  return new Promise(function (resolve, reject) {
    docClient.scan(params, function (err, data) {
      if (err || data === null) {
        reject(err);
      } // an error occurred
      else {
          resolve(data);
        } // received data
    });
  });
};

function requestData(maxItems, deviceId, tableName) {
  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  var params = {
    TableName: tableName,
    Limit: maxItems,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeValues: {
      ":device_id": deviceId
    },
    KeyConditionExpression: "device_id = :device_id",
    ProjectionExpression: "device_id, timestampepoch, distanceH, distanceV, flood_perc, gasECO2, gasTVOC, humidity, temperature, voltage, x, y, z"
  };

  return queryToFetchDynamoDBData(params);
}

function requestTechOnSiteData(deviceId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/v1.1/" + deviceId + "/security-notes?count=50").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getLocation(deviceId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/v1.1/" + deviceId + "/location").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function requestWithoutDeviceId(minsBack) {
  var toTs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getTime();
  var tableName = arguments[2];

  // Generating a string of the last X hours back
  // const minBack = minsBack; // minBack = 20; //Todo change minBack to 20 for production
  // const toTs = new Date().getTime();
  var fromTs = toTs - minsBack * 60 * 1000;

  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  var params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    FilterExpression: "notificationTimestamp BETWEEN :from_date AND :to_date",
    ExpressionAttributeValues: {
      ":from_date": fromTs,
      ":to_date": toTs
    },
    ProjectionExpression: "deviceID, notificationTimestamp, description, notificationCategory, noticationStatus, notificationType, notificationValue, rsp, sdp, technologyType, accessType, correlationCategory"
  };

  return scanToFetchDynamoDBData(params);
}

function requestTimedData(minsBack, deviceId, tableName) {
  // Generating a string of the last X hours back
  var minBack = minsBack; // minBack = 20; //Todo change minBack to 20 for production
  var toTs = new Date().getTime();
  var fromTs = toTs - minBack * 60 * 1000;
  // 
  // 
  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  var params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeValues: {
      ":device_id": deviceId,
      ":from_date": fromTs,
      ":to_date": toTs
    },
    KeyConditionExpression: "device_id = :device_id AND timestampepoch BETWEEN :from_date AND :to_date",
    ProjectionExpression: "device_id, timestampepoch, distanceH, distanceV, flood_perc, gasECO2, gasTVOC, humidity, temperature, voltage, x, y, z"
  };

  return queryToFetchDynamoDBData(params);
}

function getNotifications(page_num, deviceID) {
  return new Promise(function (resolve, reject) {
    axios.get("https://dla8h8bs7g.execute-api.ap-southeast-2.amazonaws.com/v1/" + deviceID + "/notification").then(function (data) {

      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function closeNotification(notificationTimestamp, deviceID) {
  return new Promise(function (resolve, reject) {
    axios.get("https://dla8h8bs7g.execute-api.ap-southeast-2.amazonaws.com/v1/" + deviceID + "/notification/close?timestamp=" + notificationTimestamp).then(function (data) {
      resolve(data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function searchDevices(searchText, pageNumber) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/v1.1/search?starts=" + searchText).then(function (data) {

      resolve(data.data);
    }).catch(function (err) {});
  });
}

// TODO - Refactor this code to single function
function requestNotificationTimedData(minsBack, deviceId, tableName) {
  // Generating a string of the last X hours back
  var minBack = minsBack; // minBack = 20; //Todo change minBack to 20 for production
  var toTs = new Date().getTime();
  var fromTs = toTs - minBack * 60 * 1000;

  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  var params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeValues: {
      ":deviceID": deviceId,
      ":from_date": fromTs,
      ":to_date": toTs
    },
    KeyConditionExpression: "deviceID = :deviceID AND notificationTimestamp BETWEEN :from_date AND :to_date",
    ProjectionExpression: "deviceID, notificationTimestamp, description, notificationCategory, noticationStatus, notificationType, notificationValue"
  };

  return queryToFetchDynamoDBData(params);
}

var updateDynamoDBData = function updateDynamoDBData(params) {
  var docClient = new AWS.DynamoDB.DocumentClient();
  return new Promise(function (resolve, reject) {
    docClient.update(params, function (err, data) {
      if (err || data === null) {
        reject(err);
      } // an error occurred
      else {
          resolve(data);
        } // received data
    });
  });
};

function updateThemeConfiguration(userpoolID, themeID, layout, link, linkToLogo) {
  var items = void 0;
  if (themeID !== null && layout === null) {
    items = {
      themeID: themeID
    };
  } else if (themeID === null && layout !== null) {
    items = {
      layoutHeartbeat: layout
    };
  } else if (link && linkToLogo) {
    items = {
      link: link,
      linkToLogo: linkToLogo
    };
  } else if (link && !linkToLogo) {
    items = {
      link: link
    };
  } else if (!link && linkToLogo) {
    items = {
      linkToLogo: linkToLogo
    };
  }

  var payloadObject = { userpoolID: userpoolID, themeConfig: items };
  var pullParams = {
    FunctionName: CONST.UPDATE_THEME_CONFIGURATION,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: JSON.stringify(payloadObject)
  };
  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function getThemeConfiguration(userpoolID) {
  var payloadObject = { userpoolID: userpoolID };
  var pullParams = {
    FunctionName: CONST.GET_THEME_CONFIGURATION,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: JSON.stringify(payloadObject)
  };
  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function requestStateWiseDevices(tableName) {
  // Forming the DynamoDB Query
  var params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ProjectionExpression: "NSW, NT, QLD, SA, TA, VI, WA"
  };

  return scanToFetchDynamoDBData(params);
}

function requestAustraliaLocations(tableName) {
  // Forming the DynamoDB Query
  var params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeNames: {
      "#stateCordinate": "location"
    },
    ProjectionExpression: "#stateCordinate"
  };

  return scanToFetchDynamoDBData(params);
}

function updateDeviceCount(tableName, NSWCount, WACount, NTCount, QLDCount, SACount, VICount, TACount) {
  var params = {
    TableName: tableName,
    Key: {
      state_device: "1000"
    },
    UpdateExpression: "set NSW = :NSWCount, WA = :WACount, NT = :NTCount, QLD = :QLDCount, SA = :SACount, VI = :VICount, TA = :TACount",
    ExpressionAttributeValues: {
      ":NSWCount": NSWCount,
      ":WACount": WACount,
      ":NTCount": NTCount,
      ":QLDCount": QLDCount,
      ":SACount": SACount,
      ":VICount": VICount,
      ":TACount": TACount
    },
    ReturnValues: "UPDATED_NEW"
  };
  return updateDynamoDBData(params);
}

function getDevicesData(states, mapBounds) {
  var data = {
    MapData: [{
      deviceID: "Device 1",
      latitude: -26.397,
      longitude: 137.644,
      isTechOnSite: true,
      numberOfActiveNotifications: 0,
      numberOfClosedNotifications: 0
    }, {
      deviceID: "Device 2",
      latitude: -26.397,
      longitude: 138.644,
      isTechOnSite: true,
      numberOfActiveNotifications: 0,
      numberOfClosedNotifications: 0
    }, {
      deviceID: "Device 3",
      latitude: -26.397,
      longitude: 139.644,
      isTechOnSite: true,
      numberOfActiveNotifications: 0,
      numberOfClosedNotifications: 0
    }, {
      deviceID: "Device 4",
      latitude: -26.397,
      longitude: 140.644,
      isTechOnSite: false,
      numberOfActiveNotifications: 7,
      numberOfClosedNotifications: 8
    }, {
      deviceID: "Device 5",
      latitude: -26.397,
      longitude: 141.644,
      isTechOnSite: false,
      numberOfActiveNotifications: 9,
      numberOfClosedNotifications: 10
    }, {
      deviceID: "Device 6",
      latitude: -26.397,
      longitude: 142.644,
      isTechOnSite: false,
      numberOfActiveNotifications: 11,
      numberOfClosedNotifications: 12
    }]
  };

  return new Promise(function (resolve, reject) {
    var markers = data.MapData.filter(function (el) {
      if (el.latitude > mapBounds[0].lat() && el.latitude < mapBounds[1].lat() && el.longitude > mapBounds[0].lng() && el.longitude < mapBounds[1].lng()) {
        return true;
      }
    });

    var numberOfFilteredTechsOnsite = 0;
    var numberOfFilteredActiveNotifications = 0;
    var numberOfFilteredClosedNotifications = 0;

    var numberOfTotalTechsOnsite = 0;
    var numberOfTotalActiveNotifications = 0;
    var numberOfTotalClosedNotifications = 0;

    markers.forEach(function (el) {
      if (el.isTechOnSite) {
        numberOfFilteredTechsOnsite++;
      }

      numberOfFilteredActiveNotifications = numberOfFilteredActiveNotifications + (el.numberOfActiveNotifications > 0 ? 1 : 0);
      numberOfFilteredClosedNotifications = numberOfFilteredClosedNotifications + (el.numberOfClosedNotifications > 0 ? 1 : 0);
    });

    data.MapData.forEach(function (el) {
      if (el.isTechOnSite) {
        numberOfTotalTechsOnsite++;
      }

      numberOfTotalActiveNotifications = numberOfTotalActiveNotifications + (el.numberOfActiveNotifications > 0 ? 1 : 0);
      numberOfTotalClosedNotifications = numberOfTotalClosedNotifications + (el.numberOfClosedNotifications > 0 ? 1 : 0);
    });

    resolve(JSON.stringify({
      MapData: markers,
      Summary: {
        TotalFilteredDevices: markers.length,
        TotalFilteredTechOnsite: numberOfFilteredTechsOnsite,
        TotalFilteredDevicesWithActiveNotificaion: numberOfFilteredActiveNotifications,
        TotalFilteredDevicesWithClosedNotificaion: numberOfFilteredClosedNotifications
      },
      MetaData: {
        TotalDevices: 6,
        TotalTechOnsite: numberOfTotalTechsOnsite,
        TotalDevicesWithActiveNotificaion: numberOfTotalActiveNotifications,
        TotalDevicesWithClosedNotificaion: numberOfTotalClosedNotifications
      }
    }));
  });

  //   let payloadObject = { filterStates: states, mapBounds: mapBounds };

  //   const pullParams = {
  //     FunctionName: CONST.DEVICE_DATA_FUNCTION,
  //     InvocationType: 'RequestResponse',
  //     LogType: 'None',
  //     Payload: JSON.stringify(payloadObject)
  //   };

  //   return new Promise((resolve, reject) => {
  //     AWSLambda.invoke(pullParams, function (err, data) {
  //       if (err) {
  //         reject(err);
  //       } else {
  //         // 
  //         resolve(JSON.parse(data.Payload));
  //       }
  //     });
  //   });
}

function refreshDevicesData() {
  var pullParams = {
    FunctionName: CONST.DEVICE_RAW_DATA_FUNCTION,
    InvocationType: "RequestResponse",
    LogType: "None"
  };

  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve();
      }
    });
  });
}

function getPitStatusLast7Days(deviceID) {
  var pullParams = {
    FunctionName: CONST.PIT_STATUS_7_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: "{\"deviceID\" : \"" + deviceID + "\"}"
  };

  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function getPitStatusLast30Days(deviceID) {
  var pullParams = {
    FunctionName: CONST.PIT_STATUS_30_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: "{\"deviceID\" : \"" + deviceID + "\"}"
  };

  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function getTechStatusLast7Days(deviceID) {
  var pullParams = {
    FunctionName: CONST.TECH_STATUS_7_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: "{\"deviceID\" : \"" + deviceID + "\"}"
  };

  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function getTechStatusLast30Days(deviceID) {
  var pullParams = {
    FunctionName: CONST.TECH_STATUS_30_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: "{\"deviceID\" : \"" + deviceID + "\"}"
  };

  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function getFilteredRecord(data) {
  switch (data) {
    case "Latest 10 Records":
      {
        return 10;
      }
    case "1 Day":
      {
        return 1;
      }
    case "7 Days":
      {
        return 7;
      }
    case "14 Days":
      {
        return 14;
      }
    case "28 Days":
      {
        return 28;
      }
    default:
      return 10;
  }
}

function getCurrentStatusDetails(deviceID) {
  var pullParams = {
    FunctionName: CONST.GET_CURRENT_STATUS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: "{\"deviceID\" : \"" + deviceID + "\"}"
  };

  return new Promise(function (resolve, reject) {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

function getPitStatus(deviceID, numberOfRecordsToFetch) {
  return new Promise(function (resolve, reject) {
    var filter = getFilteredRecord(numberOfRecordsToFetch);
    var url = void 0;
    if (filter === 10) {
      url = "notifications?count=" + filter;
    } else {
      url = "notifications?dd=" + filter;
    }
    axios.get("https://api.senstra.com.au/dev/" + deviceID + "/" + url + "&event=security").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getNumberOfPitStatus(numberOfRecords, deviceID) {
  return new Promise(function (resolve, reject) {
    axios.get("https://dla8h8bs7g.execute-api.ap-southeast-2.amazonaws.com/v1/" + deviceID + "/security?" + numberOfRecords).then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getPitDepth(deviceID) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/v1.1/" + deviceID + "/pit-depth").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function setDepthOfPit(deviceID, pitDepth) {
  return new Promise(function (resolve, reject) {
    axios.put("https://api.senstra.com.au/v1.1/" + deviceID + "/pit-depth", {
      pitDepth: pitDepth
    }).then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getAllConfiguration(deviceID) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/v1.1/" + deviceID + "/shadow").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function setAllConfiguration(deviceID, data) {
  return new Promise(function (resolve, reject) {
    axios.patch("https://api.senstra.com.au/v1.1/" + deviceID + "/shadow", data).then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getPitWarningLevel(deviceID) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/v1.1/" + deviceID).then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getMultipleReadingsFromAllSensors(fromTimestamp, toTimestamp, nodeId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://dpsbfcyz77.execute-api.ap-southeast-2.amazonaws.com/v2/" + nodeId + "/current?start=" + fromTimestamp + "&end=" + toTimestamp).then(function (data) {
      resolve(data.data);
    }).catch(function (err) {

      reject(err);
    });
  });
}

function getLastNRecordsFromAllSensors(numberOfRecordsToFetch, nodeId, sensorType) {
  return new Promise(function (resolve, reject) {
    var filter = getFilteredRecord(numberOfRecordsToFetch);
    var url = void 0;
    if (filter === 10) {
      url = "current?count=" + filter + "&&columns=" + sensorType;
    } else {
      url = "current?dd=" + filter + "&&columns=" + sensorType;
    }
    axios.get("https://api.senstra.com.au/v1.1/" + nodeId + "/" + url).then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getNodeVitals() {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/dev/nodes/catalogue?categories=vitals").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getDeviceCatalogue(nodeId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/dev/nodes/catalogue").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function getIndividualNodeVitals(nodeId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/dev/" + nodeId + "/vitals/current").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function extractDataForPdf(nodeId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/dev/reports/csv?category=sensor&nodes=" + nodeId + "&from=1614039957 ").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function alertsModificationData(nodeId) {
  return new Promise(function (resolve, reject) {
    axios.get("https://api.senstra.com.au/dev/notifications?count=300").then(function (data) {
      resolve(data.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

function updateAlertStatus(data, nodeId) {
  return new Promise(function (resolve, reject) {
    axios.patch("https://api.senstra.com.au/dev/" + nodeId + "/notifications", data).then(function (item) {
      resolve(item);
    }).catch(function (err) {
      reject(err);
    });
  });
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getThresholdData, "getThresholdData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateThresholdsData, "updateThresholdsData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(mqttClientConnect, "mqttClientConnect", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getMqttClient, "getMqttClient", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(authenticate, "authenticate", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestData, "requestData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestTechOnSiteData, "requestTechOnSiteData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getLocation, "getLocation", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestWithoutDeviceId, "requestWithoutDeviceId", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestTimedData, "requestTimedData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getNotifications, "getNotifications", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(closeNotification, "closeNotification", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(searchDevices, "searchDevices", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestNotificationTimedData, "requestNotificationTimedData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateThemeConfiguration, "updateThemeConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getThemeConfiguration, "getThemeConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestStateWiseDevices, "requestStateWiseDevices", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestAustraliaLocations, "requestAustraliaLocations", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateDeviceCount, "updateDeviceCount", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getDevicesData, "getDevicesData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(refreshDevicesData, "refreshDevicesData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitStatusLast7Days, "getPitStatusLast7Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitStatusLast30Days, "getPitStatusLast30Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getTechStatusLast7Days, "getTechStatusLast7Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getTechStatusLast30Days, "getTechStatusLast30Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getFilteredRecord, "getFilteredRecord", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getCurrentStatusDetails, "getCurrentStatusDetails", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitStatus, "getPitStatus", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getNumberOfPitStatus, "getNumberOfPitStatus", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitDepth, "getPitDepth", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(setDepthOfPit, "setDepthOfPit", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getAllConfiguration, "getAllConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(setAllConfiguration, "setAllConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitWarningLevel, "getPitWarningLevel", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getMultipleReadingsFromAllSensors, "getMultipleReadingsFromAllSensors", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getLastNRecordsFromAllSensors, "getLastNRecordsFromAllSensors", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getNodeVitals, "getNodeVitals", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getDeviceCatalogue, "getDeviceCatalogue", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getIndividualNodeVitals, "getIndividualNodeVitals", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(extractDataForPdf, "extractDataForPdf", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(alertsModificationData, "alertsModificationData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateAlertStatus, "updateAlertStatus", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(docClient, "docClient", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(AWSLambda, "AWSLambda", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(clientId, "clientId", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(mqttClient, "mqttClient", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(queryToFetchDynamoDBData, "queryToFetchDynamoDBData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(scanToFetchDynamoDBData, "scanToFetchDynamoDBData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateDynamoDBData, "updateDynamoDBData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(docClient, "docClient", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(AWSLambda, "AWSLambda", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(clientId, "clientId", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getThresholdData, "getThresholdData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateThresholdsData, "updateThresholdsData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(mqttClient, "mqttClient", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(mqttClientConnect, "mqttClientConnect", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getMqttClient, "getMqttClient", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(authenticate, "authenticate", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(queryToFetchDynamoDBData, "queryToFetchDynamoDBData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(scanToFetchDynamoDBData, "scanToFetchDynamoDBData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestData, "requestData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestTechOnSiteData, "requestTechOnSiteData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getLocation, "getLocation", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestWithoutDeviceId, "requestWithoutDeviceId", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestTimedData, "requestTimedData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getNotifications, "getNotifications", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(closeNotification, "closeNotification", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(searchDevices, "searchDevices", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestNotificationTimedData, "requestNotificationTimedData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateDynamoDBData, "updateDynamoDBData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateThemeConfiguration, "updateThemeConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getThemeConfiguration, "getThemeConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestStateWiseDevices, "requestStateWiseDevices", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(requestAustraliaLocations, "requestAustraliaLocations", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateDeviceCount, "updateDeviceCount", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getDevicesData, "getDevicesData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(refreshDevicesData, "refreshDevicesData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitStatusLast7Days, "getPitStatusLast7Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitStatusLast30Days, "getPitStatusLast30Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getTechStatusLast7Days, "getTechStatusLast7Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getTechStatusLast30Days, "getTechStatusLast30Days", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getFilteredRecord, "getFilteredRecord", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getCurrentStatusDetails, "getCurrentStatusDetails", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitStatus, "getPitStatus", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getNumberOfPitStatus, "getNumberOfPitStatus", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitDepth, "getPitDepth", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(setDepthOfPit, "setDepthOfPit", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getAllConfiguration, "getAllConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(setAllConfiguration, "setAllConfiguration", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getPitWarningLevel, "getPitWarningLevel", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getMultipleReadingsFromAllSensors, "getMultipleReadingsFromAllSensors", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getLastNRecordsFromAllSensors, "getLastNRecordsFromAllSensors", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getNodeVitals, "getNodeVitals", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getDeviceCatalogue, "getDeviceCatalogue", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(getIndividualNodeVitals, "getIndividualNodeVitals", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(extractDataForPdf, "extractDataForPdf", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(alertsModificationData, "alertsModificationData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(updateAlertStatus, "updateAlertStatus", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/aws-manager.js");
}();

;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(1353);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 61 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(176);
var defined = __webpack_require__(80);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(177);
var createDesc = __webpack_require__(119);
var toIObject = __webpack_require__(62);
var toPrimitive = __webpack_require__(79);
var has = __webpack_require__(61);
var IE8_DOM_DEFINE = __webpack_require__(437);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(34) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(61);
var toObject = __webpack_require__(37);
var IE_PROTO = __webpack_require__(291)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["h"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["w"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["l"] = deferred;
/* harmony export (immutable) */ __webpack_exports__["g"] = arrayOfDeffered;
/* harmony export (immutable) */ __webpack_exports__["m"] = delay;
/* harmony export (immutable) */ __webpack_exports__["j"] = createMockTask;
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["t"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["s"] = log;
/* harmony export (immutable) */ __webpack_exports__["n"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cloneableGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(335)('wks');
var uid = __webpack_require__(229);
var Symbol = __webpack_require__(84).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(589);
var isBuffer = __webpack_require__(1506);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(47);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(23);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_QUERY_LIMIT = exports.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART = exports.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART = exports.DEFAULT_LOGO_IMG = exports.DEFAULT_PROFILE_IMG = exports.BATTERY_CHARGE_YAXIS_STEPSIZE = exports.POWER_LEAKAGE_YAXIS_STEPSIZE = exports.GAS_LEAKAGE_YAXIS_STEPSIZE = exports.HUMIDITY_YAXIS_STEPSIZE = exports.SPATIAL_DEPTH_YAXIS_STEPSIZE = exports.TEMPERATURE_YAXIS_STEPSIZE = exports.GET_CURRENT_STATUS = exports.PIT_STATUS_30_DAYS = exports.PIT_STATUS_7_DAYS = exports.TECH_STATUS_30_DAYS = exports.TECH_STATUS_7_DAYS = exports.SEARCH_DEVICES = exports.CLOSE_NOTIFICATION = exports.GET_NOTIFICATION = exports.UPDATE_THRESHOLDS_DATA = exports.GET_THRESHOLDS_DATA = exports.UPDATE_THEME_CONFIGURATION = exports.GET_THEME_CONFIGURATION = exports.DEVICE_DATA_FUNCTION = exports.DEVICE_RAW_DATA_FUNCTION = exports.DEVICE_CORRELATION_BREAKDOWN = exports.DEVICES_TABLE_NAME = exports.AUSTRALIA_LOCATIONS_TABLE_NAME = exports.STATEWISE_DEVICES_TABLE_NAME = exports.THRESHOLDS_TABLE_NAME = exports.NOTIFICATION_TABLE_NAME = exports.HEARTBEATDATA_TABLE_NAME = exports.INITIAL_DEVICE_ID = exports.BUCKET_NAME = exports.SECRET_ACCESS_KEY = exports.ACCESS_KEY_ID = exports.IOT_HOST = exports.IDENTITY_POOL_ID = exports.REGION = exports.CLIENT_ID = exports.USER_POOL_ID = exports.THRESHOLDS = exports.NUMBER_OF_LATEST_RECORDS_TO_FETCH = exports.DEVICE_TECH_STATUS_TOPIC = exports.DEVICE_PIT_STATUS_TOPIC = exports.DEVICE_SUBSCRIBE_TOPIC = exports.DEVICE_ID = exports.MINS_BACK = exports.MODAL_DEFAULT_MINS = exports.WIDTH = exports.POLL_MINUTES_BACK = exports.RECORDS_NUMBERS = exports.RECORDS_MINUTES = exports.UPDATE_INTERVAL = undefined;

var _credentials_to_use = __webpack_require__(1146);

var _credentials_to_use2 = _interopRequireDefault(_credentials_to_use);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var UPDATE_INTERVAL = exports.UPDATE_INTERVAL = 5000; // TODO - Production - Change to : 5000
var RECORDS_MINUTES = exports.RECORDS_MINUTES = 5; // mins
var RECORDS_NUMBERS = exports.RECORDS_NUMBERS = 20;
var POLL_MINUTES_BACK = exports.POLL_MINUTES_BACK = 1;
var WIDTH = exports.WIDTH = 170;
var MODAL_DEFAULT_MINS = exports.MODAL_DEFAULT_MINS = 10;
var MINS_BACK = exports.MINS_BACK = 24 * 60 * 30 * 30;
var DEVICE_ID = exports.DEVICE_ID = "deviceID";
var DEVICE_SUBSCRIBE_TOPIC = exports.DEVICE_SUBSCRIBE_TOPIC = "nbiot/" + DEVICE_ID + "/payload";
var DEVICE_PIT_STATUS_TOPIC = exports.DEVICE_PIT_STATUS_TOPIC = "nbiot/" + DEVICE_ID + "/pitstatus";
var DEVICE_TECH_STATUS_TOPIC = exports.DEVICE_TECH_STATUS_TOPIC = "nbiot/" + DEVICE_ID + "/techstatus";
var NUMBER_OF_LATEST_RECORDS_TO_FETCH = exports.NUMBER_OF_LATEST_RECORDS_TO_FETCH = 10;

// -- Thresholds

var THRESHOLDS = exports.THRESHOLDS = {

  above_distanceV: 0,
  above_gasTVOC: 1,
  above_voltage: 1,
  above_z: 1,
  delta_distanceV: 10,
  delta_gasTVOC: 10,
  delta_voltage: 10,
  delta_z: 10,
  deviceID: '',
  deviceState: "NSW",
  latitude: -24.397,
  longitude: 135.644,
  normWater: null,
  norm_x: 10,
  norm_y: 2,
  norm_z: 3,
  sdp: "Telstra",
  thresholdGasTime: 8,
  thresholdGasValue: 12,
  thresholdIntrusionValue: 8,
  thresholdPowerValue: 8,
  thresholdPowerVolt: 8,
  thresholdSpatialValue: 35,
  thresholdWaterTime: 8
};

// export const TEMPERATURE_THRESHOLD = 40;
// export const SPATIAL_DEPTH_THRESHOLD = 500;
// export const HUMIDITY_THRESHOLD = 70;
// export const GAS_LEAKAGE_THRESHOLD = 4000;
// export const BATTERY_CHARGE_THRESHOLD = 3;
// export const POWER_LEAKAGE_THRESHOLD = 240;
// export const WATER_TIME_THRESHOLD = 1;
// export const GAS_TIME_THRESHOLD = 2;
// export const POWER_VOLT_THRESHOLD = 3;
// export const INTRUSION_THRESHOLD = 4;

// Credentials
var USER_POOL_ID = exports.USER_POOL_ID = _credentials_to_use2.default.userPoolId;
var CLIENT_ID = exports.CLIENT_ID = _credentials_to_use2.default.clientID;
var REGION = exports.REGION = _credentials_to_use2.default.regionName;
var IDENTITY_POOL_ID = exports.IDENTITY_POOL_ID = _credentials_to_use2.default.identityPoolId;
var IOT_HOST = exports.IOT_HOST = _credentials_to_use2.default.host;
var ACCESS_KEY_ID = exports.ACCESS_KEY_ID = _credentials_to_use2.default.accessKeyId;
var SECRET_ACCESS_KEY = exports.SECRET_ACCESS_KEY = _credentials_to_use2.default.secretAccessKey;

// Bucket Name
var BUCKET_NAME = exports.BUCKET_NAME = _credentials_to_use2.default.bucketName;

// Initial (Default) deviceId whose data is to be shown
var INITIAL_DEVICE_ID = exports.INITIAL_DEVICE_ID = ''; // '0915edd6-0dc8-4f17-a66d-ffe91c3e8c82'; '13c391c5-b022-4973-a044-71b6ea5c24a6/MPA18HM100016360' or '13c391c5-b022-4973-a044-71b6ea5c24a6/MPA18HM100015640'

// Table Names
var HEARTBEATDATA_TABLE_NAME = exports.HEARTBEATDATA_TABLE_NAME = 'SP_DevicesTimeSeries_BA';
var NOTIFICATION_TABLE_NAME = exports.NOTIFICATION_TABLE_NAME = 'SmartPitLid-NotificationSummary';
var THRESHOLDS_TABLE_NAME = exports.THRESHOLDS_TABLE_NAME = 'SmartPitLid-DeviceThreshold';
var STATEWISE_DEVICES_TABLE_NAME = exports.STATEWISE_DEVICES_TABLE_NAME = 'SmartPitLid-StateWiseDevices';
var AUSTRALIA_LOCATIONS_TABLE_NAME = exports.AUSTRALIA_LOCATIONS_TABLE_NAME = 'SmartPitLid-Configuration';
var DEVICES_TABLE_NAME = exports.DEVICES_TABLE_NAME = 'SmartPitLid-Devices';
var DEVICE_CORRELATION_BREAKDOWN = exports.DEVICE_CORRELATION_BREAKDOWN = 'SmartPitLid-DeviceCorrelationBreakdown';

// Lambda functions
var DEVICE_RAW_DATA_FUNCTION = exports.DEVICE_RAW_DATA_FUNCTION = 'NP_RawDevicesTableHandler';
var DEVICE_DATA_FUNCTION = exports.DEVICE_DATA_FUNCTION = 'NP_ReturnDevicesData';
var GET_THEME_CONFIGURATION = exports.GET_THEME_CONFIGURATION = 'NP_GetThemeConfiguration';
var UPDATE_THEME_CONFIGURATION = exports.UPDATE_THEME_CONFIGURATION = 'NP_UpdateThemeConfiguration';
var GET_THRESHOLDS_DATA = exports.GET_THRESHOLDS_DATA = 'NP_GetThresholdData';
var UPDATE_THRESHOLDS_DATA = exports.UPDATE_THRESHOLDS_DATA = 'NP_UpdateThresholdData';
var GET_NOTIFICATION = exports.GET_NOTIFICATION = 'NP_GetNotifications';
var CLOSE_NOTIFICATION = exports.CLOSE_NOTIFICATION = 'NP_CloseNotification';
var SEARCH_DEVICES = exports.SEARCH_DEVICES = 'NP_SearchDevices';

var TECH_STATUS_7_DAYS = exports.TECH_STATUS_7_DAYS = 'NP_TechStatusLast7Days';
var TECH_STATUS_30_DAYS = exports.TECH_STATUS_30_DAYS = 'NP_TechStatusLast30Days';
var PIT_STATUS_7_DAYS = exports.PIT_STATUS_7_DAYS = 'NP_PitStatusLast7Days';
var PIT_STATUS_30_DAYS = exports.PIT_STATUS_30_DAYS = 'NP_PitStatusLast30Days';
var GET_CURRENT_STATUS = exports.GET_CURRENT_STATUS = 'NP_CurrentStatus';

// Y-Axis stepSize Values
var TEMPERATURE_YAXIS_STEPSIZE = exports.TEMPERATURE_YAXIS_STEPSIZE = 0;
var SPATIAL_DEPTH_YAXIS_STEPSIZE = exports.SPATIAL_DEPTH_YAXIS_STEPSIZE = 100;
var HUMIDITY_YAXIS_STEPSIZE = exports.HUMIDITY_YAXIS_STEPSIZE = 0;
var GAS_LEAKAGE_YAXIS_STEPSIZE = exports.GAS_LEAKAGE_YAXIS_STEPSIZE = 0;
var POWER_LEAKAGE_YAXIS_STEPSIZE = exports.POWER_LEAKAGE_YAXIS_STEPSIZE = 0;
var BATTERY_CHARGE_YAXIS_STEPSIZE = exports.BATTERY_CHARGE_YAXIS_STEPSIZE = 1;

// Default Image | To use for profile image when no image is set or broken image or image not found.
var DEFAULT_PROFILE_IMG = exports.DEFAULT_PROFILE_IMG = 'assets/images/user-placeholder.png';
var DEFAULT_LOGO_IMG = exports.DEFAULT_LOGO_IMG = 'assets/images/logo.png';

//URLs
var MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART = exports.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=';
var MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART = exports.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART = '&result_type=administrative_area_level_1&key=AIzaSyBjjqIGvPrBSjFd_T4se7vXduidGu9qg3c';

//Query Limits
var INITIAL_QUERY_LIMIT = exports.INITIAL_QUERY_LIMIT = 10;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UPDATE_INTERVAL, "UPDATE_INTERVAL", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(RECORDS_MINUTES, "RECORDS_MINUTES", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(RECORDS_NUMBERS, "RECORDS_NUMBERS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(POLL_MINUTES_BACK, "POLL_MINUTES_BACK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(WIDTH, "WIDTH", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MODAL_DEFAULT_MINS, "MODAL_DEFAULT_MINS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MINS_BACK, "MINS_BACK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_ID, "DEVICE_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_SUBSCRIBE_TOPIC, "DEVICE_SUBSCRIBE_TOPIC", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_PIT_STATUS_TOPIC, "DEVICE_PIT_STATUS_TOPIC", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_TECH_STATUS_TOPIC, "DEVICE_TECH_STATUS_TOPIC", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(NUMBER_OF_LATEST_RECORDS_TO_FETCH, "NUMBER_OF_LATEST_RECORDS_TO_FETCH", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(THRESHOLDS, "THRESHOLDS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(USER_POOL_ID, "USER_POOL_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(CLIENT_ID, "CLIENT_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(REGION, "REGION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(IDENTITY_POOL_ID, "IDENTITY_POOL_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(IOT_HOST, "IOT_HOST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(ACCESS_KEY_ID, "ACCESS_KEY_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(SECRET_ACCESS_KEY, "SECRET_ACCESS_KEY", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(BUCKET_NAME, "BUCKET_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(INITIAL_DEVICE_ID, "INITIAL_DEVICE_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(HEARTBEATDATA_TABLE_NAME, "HEARTBEATDATA_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(NOTIFICATION_TABLE_NAME, "NOTIFICATION_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(THRESHOLDS_TABLE_NAME, "THRESHOLDS_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(STATEWISE_DEVICES_TABLE_NAME, "STATEWISE_DEVICES_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(AUSTRALIA_LOCATIONS_TABLE_NAME, "AUSTRALIA_LOCATIONS_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICES_TABLE_NAME, "DEVICES_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_CORRELATION_BREAKDOWN, "DEVICE_CORRELATION_BREAKDOWN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_RAW_DATA_FUNCTION, "DEVICE_RAW_DATA_FUNCTION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_DATA_FUNCTION, "DEVICE_DATA_FUNCTION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_THEME_CONFIGURATION, "GET_THEME_CONFIGURATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(UPDATE_THEME_CONFIGURATION, "UPDATE_THEME_CONFIGURATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_THRESHOLDS_DATA, "GET_THRESHOLDS_DATA", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(UPDATE_THRESHOLDS_DATA, "UPDATE_THRESHOLDS_DATA", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_NOTIFICATION, "GET_NOTIFICATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(CLOSE_NOTIFICATION, "CLOSE_NOTIFICATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(SEARCH_DEVICES, "SEARCH_DEVICES", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(TECH_STATUS_7_DAYS, "TECH_STATUS_7_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(TECH_STATUS_30_DAYS, "TECH_STATUS_30_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(PIT_STATUS_7_DAYS, "PIT_STATUS_7_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(PIT_STATUS_30_DAYS, "PIT_STATUS_30_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_CURRENT_STATUS, "GET_CURRENT_STATUS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(TEMPERATURE_YAXIS_STEPSIZE, "TEMPERATURE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(SPATIAL_DEPTH_YAXIS_STEPSIZE, "SPATIAL_DEPTH_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(HUMIDITY_YAXIS_STEPSIZE, "HUMIDITY_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GAS_LEAKAGE_YAXIS_STEPSIZE, "GAS_LEAKAGE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(POWER_LEAKAGE_YAXIS_STEPSIZE, "POWER_LEAKAGE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(BATTERY_CHARGE_YAXIS_STEPSIZE, "BATTERY_CHARGE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEFAULT_PROFILE_IMG, "DEFAULT_PROFILE_IMG", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEFAULT_LOGO_IMG, "DEFAULT_LOGO_IMG", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART, "MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART, "MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(INITIAL_QUERY_LIMIT, "INITIAL_QUERY_LIMIT", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_credentials_to_use2, "_credentials_to_use2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(UPDATE_INTERVAL, "UPDATE_INTERVAL", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(RECORDS_MINUTES, "RECORDS_MINUTES", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(RECORDS_NUMBERS, "RECORDS_NUMBERS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(POLL_MINUTES_BACK, "POLL_MINUTES_BACK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(WIDTH, "WIDTH", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MODAL_DEFAULT_MINS, "MODAL_DEFAULT_MINS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MINS_BACK, "MINS_BACK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_ID, "DEVICE_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_SUBSCRIBE_TOPIC, "DEVICE_SUBSCRIBE_TOPIC", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_PIT_STATUS_TOPIC, "DEVICE_PIT_STATUS_TOPIC", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_TECH_STATUS_TOPIC, "DEVICE_TECH_STATUS_TOPIC", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(NUMBER_OF_LATEST_RECORDS_TO_FETCH, "NUMBER_OF_LATEST_RECORDS_TO_FETCH", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(THRESHOLDS, "THRESHOLDS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(USER_POOL_ID, "USER_POOL_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(CLIENT_ID, "CLIENT_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(REGION, "REGION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(IDENTITY_POOL_ID, "IDENTITY_POOL_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(IOT_HOST, "IOT_HOST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(ACCESS_KEY_ID, "ACCESS_KEY_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(SECRET_ACCESS_KEY, "SECRET_ACCESS_KEY", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(BUCKET_NAME, "BUCKET_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(INITIAL_DEVICE_ID, "INITIAL_DEVICE_ID", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(HEARTBEATDATA_TABLE_NAME, "HEARTBEATDATA_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(NOTIFICATION_TABLE_NAME, "NOTIFICATION_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(THRESHOLDS_TABLE_NAME, "THRESHOLDS_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(STATEWISE_DEVICES_TABLE_NAME, "STATEWISE_DEVICES_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(AUSTRALIA_LOCATIONS_TABLE_NAME, "AUSTRALIA_LOCATIONS_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICES_TABLE_NAME, "DEVICES_TABLE_NAME", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_CORRELATION_BREAKDOWN, "DEVICE_CORRELATION_BREAKDOWN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_RAW_DATA_FUNCTION, "DEVICE_RAW_DATA_FUNCTION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEVICE_DATA_FUNCTION, "DEVICE_DATA_FUNCTION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_THEME_CONFIGURATION, "GET_THEME_CONFIGURATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(UPDATE_THEME_CONFIGURATION, "UPDATE_THEME_CONFIGURATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_THRESHOLDS_DATA, "GET_THRESHOLDS_DATA", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(UPDATE_THRESHOLDS_DATA, "UPDATE_THRESHOLDS_DATA", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_NOTIFICATION, "GET_NOTIFICATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(CLOSE_NOTIFICATION, "CLOSE_NOTIFICATION", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(SEARCH_DEVICES, "SEARCH_DEVICES", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(TECH_STATUS_7_DAYS, "TECH_STATUS_7_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(TECH_STATUS_30_DAYS, "TECH_STATUS_30_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(PIT_STATUS_7_DAYS, "PIT_STATUS_7_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(PIT_STATUS_30_DAYS, "PIT_STATUS_30_DAYS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GET_CURRENT_STATUS, "GET_CURRENT_STATUS", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(TEMPERATURE_YAXIS_STEPSIZE, "TEMPERATURE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(SPATIAL_DEPTH_YAXIS_STEPSIZE, "SPATIAL_DEPTH_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(HUMIDITY_YAXIS_STEPSIZE, "HUMIDITY_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(GAS_LEAKAGE_YAXIS_STEPSIZE, "GAS_LEAKAGE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(POWER_LEAKAGE_YAXIS_STEPSIZE, "POWER_LEAKAGE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(BATTERY_CHARGE_YAXIS_STEPSIZE, "BATTERY_CHARGE_YAXIS_STEPSIZE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEFAULT_PROFILE_IMG, "DEFAULT_PROFILE_IMG", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(DEFAULT_LOGO_IMG, "DEFAULT_LOGO_IMG", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART, "MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART, "MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(INITIAL_QUERY_LIMIT, "INITIAL_QUERY_LIMIT", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/app-constants.js");
}();

;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(132);
var IE8_DOM_DEFINE = __webpack_require__(509);
var toPrimitive = __webpack_require__(329);
var dP = Object.defineProperty;

exports.f = __webpack_require__(75) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(133)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closenewPasswordModal = exports.opennewPasswordModal = undefined;
exports.toggleEvent = toggleEvent;
exports.deleteFirstAfter20Count = deleteFirstAfter20Count;
exports.getTimeFromTimestamp = getTimeFromTimestamp;
exports.getDateAndTimeFromTimestamp = getDateAndTimeFromTimestamp;
exports.getFormattedDate = getFormattedDate;
exports.getImageSourceFromType = getImageSourceFromType;
exports.getUnitFromType = getUnitFromType;
exports.createNotification = createNotification;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactNotifications = __webpack_require__(78);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function toggleEvent(name, status) {
    if (status) {
        return {
            name: null,
            status: false
        };
    }

    return {
        name: name,
        status: true
    };
}

function deleteFirstAfter20Count(arr) {
    arr.reverse();
    arr.pop();
    return arr.reverse();
}

function getTimeFromTimestamp(timestamp) {
    if (!timestamp) {
        timestamp = new Date().getTime();
    }
    var date = new Date(timestamp);
    var hours = '0' + date.getHours();
    var minutes = '0' + date.getMinutes();
    var seconds = '0' + date.getSeconds();
    // Will display time in 10:30:23 format
    return hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
}

function getDateAndTimeFromTimestamp(timestamp) {
    if (!timestamp) {
        timestamp = new Date().toLocaleString();
    }
    var date = new Date(timestamp * 1000).toLocaleString();
    return date;
}

function getFormattedDate(timestamp, isEpoch) {
    if (!timestamp) {
        timestamp = new Date().getTime();
    } else {
        timestamp = isEpoch ? timestamp : timestamp * 1000;
    }

    var timestamplength = timestamp.toString().length;

    if (timestamplength === 16) {
        timestamp = Math.floor(timestamp / 1000);
    }

    var dt = new Date(timestamp);
    // const months = ['Jan',
    // 'Feb',
    // 'Mar',
    // 'Apr',
    // 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = dt.getFullYear();
    // const month = months[dt.getMonth()];
    var month = '0' + (dt.getMonth() + 1);
    var date = '0' + dt.getDate();
    var hour = '0' + dt.getHours();
    var min = '0' + dt.getMinutes();
    var sec = '0' + dt.getSeconds();

    return date.substr(-2) + '/' + month.substr(-2) + '/' + year + ' ' + hour.substr(-2) + ':' + min.substr(-2) + ':' + sec.substr(-2);
}

// export function getImageSourceFromType(notificationType) {
//     switch (notificationType) {
//         case 'Water Flooding':
//             return '../assets/images/water-droplet.png';
//         case 'Power Leakage':
//             return '../assets/images/power.png';
//         case 'Gas Leakage':
//             return '../assets/images/fire.png';
//         case 'Intrusion Detected':
//             return '../assets/images/lock.png';
//         case 'Birthday':
//             return '../assets/images/birthday.png';
//         case 'Low Battery':
//             return '../assets/images/power.png';
//         default:
//             break;
//     }
//     return ' ';
// }

function getImageSourceFromType(notificationType) {
    switch (notificationType) {
        case 'water':
            return '../assets/images/water-droplet.png';
        case 'Power Leakage':
            return '../assets/images/power.png';
        case 'temperature':
            return '../assets/images/fire.png';
        case 'security':
            return '../assets/images/lock.png';
        case 'Birthday':
            return '../assets/images/birthday.png';
        case 'Low Battery':
            return '../assets/images/power.png';
        default:
            break;
    }
    return ' ';
}

function getUnitFromType(notificationType) {
    switch (notificationType) {
        case 'Water Flooding':
            return _react2.default.createElement('span', null, 'cm');
        case 'Power Leakage':
            return _react2.default.createElement('span', null, 'mA');
        case 'Gas Leakage':
            return _react2.default.createElement('span', null, 'g/m', _react2.default.createElement('sup', null, '3'));
        case 'Intrusion Detected':
            return _react2.default.createElement('span', null, 'cm');
        case 'Birthday':
            return _react2.default.createElement('span', null, 'NA');
        default:
            break;
    }
    return _react2.default.createElement('span', null);
}

function createNotification(message, title, type) {
    if (type === 'Success') {
        _reactNotifications.NotificationManager.success(message, title);
    } else if (type === 'Error') {
        _reactNotifications.NotificationManager.error(message, title);
    }
}

var opennewPasswordModal = exports.opennewPasswordModal = function opennewPasswordModal() {
    $('#signin').toggleClass('d-none');
    $('#newPassword').toggleClass('d-none');
    $('#signin-header').text('Update Password');

    // $('#newPasswordModal').modal('show');
};

var closenewPasswordModal = exports.closenewPasswordModal = function closenewPasswordModal() {
    // $('#newPasswordModal').modal('hide');
    $('#signin').toggleClass('d-none');
    $('#newPassword').toggleClass('d-none');
    $('#signin-header').text('log In');
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(toggleEvent, 'toggleEvent', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(deleteFirstAfter20Count, 'deleteFirstAfter20Count', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getTimeFromTimestamp, 'getTimeFromTimestamp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getDateAndTimeFromTimestamp, 'getDateAndTimeFromTimestamp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getFormattedDate, 'getFormattedDate', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getImageSourceFromType, 'getImageSourceFromType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getUnitFromType, 'getUnitFromType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(createNotification, 'createNotification', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(opennewPasswordModal, 'opennewPasswordModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(closenewPasswordModal, 'closenewPasswordModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(toggleEvent, 'toggleEvent', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(deleteFirstAfter20Count, 'deleteFirstAfter20Count', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getTimeFromTimestamp, 'getTimeFromTimestamp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getDateAndTimeFromTimestamp, 'getDateAndTimeFromTimestamp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getFormattedDate, 'getFormattedDate', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getImageSourceFromType, 'getImageSourceFromType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(getUnitFromType, 'getUnitFromType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(createNotification, 'createNotification', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(opennewPasswordModal, 'opennewPasswordModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(closenewPasswordModal, 'closenewPasswordModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/util.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Notifications", {
  enumerable: true,
  get: function get() {
    return _Notifications.default;
  }
});
Object.defineProperty(exports, "NotificationContainer", {
  enumerable: true,
  get: function get() {
    return _NotificationContainer.default;
  }
});
Object.defineProperty(exports, "NotificationManager", {
  enumerable: true,
  get: function get() {
    return _NotificationManager.default;
  }
});
exports.default = void 0;

var _Notifications = _interopRequireDefault(__webpack_require__(552));

var _NotificationContainer = _interopRequireDefault(__webpack_require__(1387));

var _NotificationManager = _interopRequireDefault(__webpack_require__(556));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Notifications.default;
exports.default = _default;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(26);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(68);
var fails = __webpack_require__(23);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(69);
var IObject = __webpack_require__(176);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(33);
var asc = __webpack_require__(307);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__(1351);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonBase = __webpack_require__(1354);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonBase).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(1396));
var _createClass = _interopDefault(__webpack_require__(1397));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(1398));
var _inherits = _interopDefault(__webpack_require__(1400));
var _typeof = _interopDefault(__webpack_require__(561));
var _objectWithoutProperties = _interopDefault(__webpack_require__(1401));
var _objectSpread = _interopDefault(__webpack_require__(1402));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(1));
var shallowEqual = _interopDefault(__webpack_require__(361));
var warning = _interopDefault(__webpack_require__(24));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _objectSpread({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EventListener, _React$Component);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowEqual(this.props, nextProps);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      this.applyListeners(on);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var target = this.props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(this.props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.Component);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(101)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(408);




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, value);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useForkRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setRef__ = __webpack_require__(411);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refA, refValue);
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return Alert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return Col; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return Navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return NavbarBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarToggler", function() { return NavbarToggler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return Nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavItem", function() { return NavItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return NavDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return Breadcrumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return BreadcrumbItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonDropdown", function() { return ButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return ButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return ButtonToolbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return Dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return DropdownItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return DropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownToggle", function() { return DropdownToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return Fade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return Badge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return Card; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardLink", function() { return CardLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardGroup", function() { return CardGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardDeck", function() { return CardDeck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardColumns", function() { return CardColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardBody", function() { return CardBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardBlock", function() { return CardBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return CardFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return CardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardImg", function() { return CardImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardImgOverlay", function() { return CardImgOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return Carousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCarousel", function() { return UncontrolledCarousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselControl", function() { return CarouselControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return CarouselItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselIndicators", function() { return CarouselIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselCaption", function() { return CarouselCaption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardSubtitle", function() { return CardSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardText", function() { return CardText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardTitle", function() { return CardTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return Popover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverContent", function() { return PopoverContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverBody", function() { return PopoverBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverTitle", function() { return PopoverTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverHeader", function() { return PopoverHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return Progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return ModalFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperContent", function() { return PopperContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperTargetHelper", function() { return PopperTargetHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return ListGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormFeedback", function() { return FormFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormText", function() { return FormText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return InputGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupAddon", function() { return InputGroupAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButton", function() { return InputGroupButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButtonDropdown", function() { return InputGroupButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupText", function() { return InputGroupText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomInput", function() { return CustomInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return Media; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationItem", function() { return PaginationItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationLink", function() { return PaginationLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return TabContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return TabPane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return Jumbotron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return ListGroupItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemText", function() { return ListGroupItemText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemHeading", function() { return ListGroupItemHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledAlert", function() { return UncontrolledAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledButtonDropdown", function() { return UncontrolledButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCollapse", function() { return UncontrolledCollapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledDropdown", function() { return UncontrolledDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledNavDropdown", function() { return UncontrolledNavDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledTooltip", function() { return UncontrolledTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Util", function() { return utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(1376);










var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);

  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule = void 0;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

var targetPropType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any })]);

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function isReactRefObj(target) {
  if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
    return 'current' in target;
  }
  return false;
}

function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }
  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);
    if (!selection.length) {
      selection = document.querySelectorAll('#' + target);
    }
    if (!selection.length) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }
  return target;
}

function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }
  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}

function getTarget(target) {
  var els = findDOMElements(target);
  if (isArrayOrNodeList(els)) {
    return els[0];
  }
  return els;
}

var defaultToggleEvents = ['touchstart', 'click'];

function addMultipleEventListeners(_els, handler, _events) {
  var els = _els;
  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;
  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error('\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ');
  }
  events.forEach(function (event) {
    els.forEach(function (el) {
      el.addEventListener(event, handler);
    });
  });
  return function removeEvents() {
    events.forEach(function (event) {
      els.forEach(function (el) {
        el.removeEventListener(event, handler);
      });
    });
  };
}

var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];



var utils = Object.freeze({
	getScrollbarWidth: getScrollbarWidth,
	setScrollbarWidth: setScrollbarWidth,
	isBodyOverflowing: isBodyOverflowing,
	getOriginalBodyPadding: getOriginalBodyPadding,
	conditionallyUpdateScrollbar: conditionallyUpdateScrollbar,
	setGlobalCssModule: setGlobalCssModule,
	mapToCssModules: mapToCssModules,
	omit: omit,
	pick: pick,
	warnOnce: warnOnce,
	deprecated: deprecated,
	DOMElement: DOMElement,
	targetPropType: targetPropType,
	TransitionTimeouts: TransitionTimeouts,
	TransitionPropTypeKeys: TransitionPropTypeKeys,
	TransitionStatuses: TransitionStatuses,
	keyCodes: keyCodes,
	PopperPlacements: PopperPlacements,
	canUseDOM: canUseDOM,
	isReactRefObj: isReactRefObj,
	findDOMElements: findDOMElements,
	isArrayOrNodeList: isArrayOrNodeList,
	getTarget: getTarget,
	defaultToggleEvents: defaultToggleEvents,
	addMultipleEventListeners: addMultipleEventListeners,
	focusableElements: focusableElements
});

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      form = props.form,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag', 'form']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setActiveFromChild: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$8 = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
        inNavbar: this.props.inNavbar
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if (keyCodes.tab === e.which || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && keyCodes.enter && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');
      if (!items.length) return;

      var index = -1;

      var charPressed = String.fromCharCode(e.which).toLowerCase();

      for (var i = 0; i < items.length; i += 1) {
        var firstLetter = items[i].textContent && items[i].textContent[0].toLowerCase();
        if (firstLetter === charPressed || items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          setActiveFromChild = _omit.setActiveFromChild,
          active = _omit.active,
          addonType = _omit.addonType,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav', 'setActiveFromChild', 'active', 'addonType']);

      var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var subItemIsActive = false;
      if (setActiveFromChild) {
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children[1].props.children, function (dropdownItem) {
          if (dropdownItem.props.active) subItemIsActive = true;
        });
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, direction !== 'down' && 'drop' + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, defineProperty(_classNames, 'input-group-' + addonType, addonType), defineProperty(_classNames, 'btn-group', group), defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group && !addonType), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["b" /* Manager */], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$10 = {
  tag: 'nav',
  listTag: 'ol',
  'aria-label': 'breadcrumb'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = objectWithoutProperties(props, ['className', 'listClassName', 'cssModule', 'children', 'tag', 'listTag', 'aria-label']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className), cssModule);

  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('breadcrumb', listClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes, 'aria-label': label }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ListTag,
      { className: listClasses },
      children
    )
  );
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, 'aria-current': active ? 'page' : undefined }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          ariaLabel = _props['aria-label'],
          block = _props.block,
          className = _props.className,
          close = _props.close,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'aria-label', 'block', 'className', 'close', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      if (close && typeof attributes.children === 'undefined') {
        attributes.children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { 'aria-hidden': true },
          '\xD7'
        );
      }

      var btnOutlineColor = 'btn' + (outline ? '-outline' : '') + '-' + color;

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, { close: close }, close || 'btn', close || btnOutlineColor, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      var defaultAriaLabel = close ? 'Close' : null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick,
        'aria-label': ariaLabel || defaultAriaLabel
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  persist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      persist = props.persist,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip', 'modifiers', 'persist']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (persist || context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["c" /* Popper */];

    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? _extends({}, modifiers, noFlipModifier) : modifiers;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes,
    'x-placement': attrs.placement
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      if (this.context.inNavbar) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: this.onClick,
          'aria-expanded': this.context.isOpen,
          children: children
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["d" /* Target */], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterDone: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitDone: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state = { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   *
   * ## Timing
   *
   * Timing is often the trickiest part of animation, mistakes can result in slight delays
   * that are hard to pin down. A common example is when you want to add an exit transition,
   * you should set the desired final styles when the state is `'exiting'`. That's when the
   * transition to those styles will start and, if you matched the `timeout` prop with the
   * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
   *
   * > **Note**: For simpler transitions the `Transition` component might be enough, but
   * > take into account that it's platform-agnostic, while the `CSSTransition` component
   * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
   * > in order to make more complex transitions more predictable. For example, even though
   * > classes `example-enter` and `example-enter-active` are applied immediately one after
   * > another, you can still transition from one to the other because of the forced reflow
   * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
   * > for more info). Take this into account when choosing between `Transition` and
   * > `CSSTransition`.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEndListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children', 'innerRef']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps, { ref: innerRef }),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, ref: innerRef }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['in', 'children', 'cssModule', 'slide', 'tag', 'className']);


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            { className: itemClasses },
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'left' : 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'right' : 'left' });
      }
      this.setState({ indicatorClicked: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      // filter out booleans, null, or undefined
      var children = this.props.children.filter(function (child) {
        return child !== null && child !== undefined && typeof child !== 'boolean';
      });

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var wrappedOnClick = function wrappedOnClick(e) {
        if (typeof indicators.props.onClickHandler === 'function') {
          _this3.setState({ indicatorClicked: true }, function () {
            return indicators.props.onClickHandler(e);
          });
        }
      };
      var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(indicators, { onClickHandler: wrappedOnClick });
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        wrappedIndicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'd-block w-100', src: item.src, alt: item.altText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.header || item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h5'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

function CustomInput(props) {
  var className = props.className,
      label = props.label,
      inline = props.inline,
      valid = props.valid,
      invalid = props.invalid,
      cssModule = props.cssModule,
      children = props.children,
      bsSize = props.bsSize,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'label', 'inline', 'valid', 'invalid', 'cssModule', 'children', 'bsSize', 'innerRef']);


  var type = attributes.type;

  var customClass = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'custom-' + type, bsSize ? 'custom-' + type + '-' + bsSize : false), cssModule);

  var validationClassNames = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(invalid && 'is-invalid', valid && 'is-valid'), cssModule);

  if (type === 'select') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'select',
      _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, customClass) }),
      children
    );
  }

  if (type === 'file') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: customClass },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, mapToCssModules('custom-file-input', cssModule)) })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { className: mapToCssModules('custom-file-label', cssModule), htmlFor: attributes.id },
        label || 'Choose file'
      )
    );
  }

  if (type !== 'checkbox' && type !== 'radio') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, customClass) }));
  }

  var wrapperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(customClass, mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('custom-control', { 'custom-control-inline': inline }), cssModule));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: wrapperClasses },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, mapToCssModules('custom-control-input', cssModule))
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: mapToCssModules('custom-control-label', cssModule), htmlFor: attributes.id },
      label
    ),
    children
  );
}

CustomInput.propTypes = propTypes$35;

var propTypes$36 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, DOMElement])
};

var defaultProps$33 = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          _arrowClassName = _props.arrowClassName,
          hideArrow = _props.hideArrow,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          modifiers = _props.modifiers,
          boundariesElement = _props.boundariesElement,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'arrowClassName', 'hideArrow', 'className', 'tag', 'container', 'modifiers', 'boundariesElement']);

      var arrowClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('arrow', _arrowClassName), cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var extendedModifiers = _extends({
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        preventOverflow: { boundariesElement: boundariesElement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      }, modifiers);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["c" /* Popper */],
        _extends({ modifiers: extendedModifiers }, attrs, { component: tag, className: popperClassName, 'x-placement': this.state.placement || attrs.placement }),
        children,
        !hideArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["a" /* Arrow */], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$36;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: targetPropType.isRequired
};

var propTypes$37 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  hideArrow: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this._target = null;
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (this._target) {
        if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
          if (this._hideTimeout) {
            this.clearHideTimeout();
          }

          if (this.props.isOpen) {
            this.toggle(e);
          }
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$37));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers,
          offset: this.props.offset,
          boundariesElement: this.props.boundariesElement
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$37;
Popover.defaultProps = defaultProps$34;

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$38;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$39 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$39;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$40 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$40;
Progress.defaultProps = defaultProps$37;

var propTypes$42 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var Portal = function (_React$Component) {
  inherits(Portal, _React$Component);

  function Portal() {
    classCallCheck(this, Portal);
    return possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = propTypes$42;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$41 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var propsToOmit = Object.keys(propTypes$41);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this._element = null;
    _this._originalBodyPadding = null;
    _this.getFocusableChildren = _this.getFocusableChildren.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.handleTab = _this.handleTab.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);

    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      }

      if (this.state.isOpen && this.props.autoFocus) {
        this.setFocus();
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen && !this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen && !this.state.isOpen) {
        this.init();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
        this.setFocus();
      }

      if (this._element && prevProps.zIndex !== this.props.zIndex) {
        this._element.style.zIndex = this.props.zIndex;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onExit) {
        this.props.onExit();
      }

      if (this.state.isOpen) {
        this.destroy();
      }

      this._isMounted = false;
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      // so all methods get called before it is unmounted
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
      this.destroy();

      if (this._isMounted) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
        this._dialog.parentNode.focus();
      }
    }
  }, {
    key: 'getFocusableChildren',
    value: function getFocusableChildren() {
      return this._element.querySelectorAll(focusableElements.join(', '));
    }
  }, {
    key: 'getFocusedChild',
    value: function getFocusedChild() {
      var currentFocus = void 0;
      var focusableChildren = this.getFocusableChildren();

      try {
        currentFocus = document.activeElement;
      } catch (err) {
        currentFocus = focusableChildren[0];
      }
      return currentFocus;
    }

    // not mouseUp because scrollbar fires it, shouldn't close when user scrolls

  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      if (e.target === this._mouseDownElement) {
        e.stopPropagation();
        if (!this.props.isOpen || this.props.backdrop !== true) return;

        var container = this._dialog;

        if (e.target && !container.contains(e.target) && this.props.toggle) {
          this.props.toggle(e);
        }
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(e) {
      if (e.which !== 9) return;

      var focusableChildren = this.getFocusableChildren();
      var totalFocusable = focusableChildren.length;
      var currentFocus = this.getFocusedChild();

      var focusedIndex = 0;

      for (var i = 0; i < totalFocusable; i += 1) {
        if (focusableChildren[i] === currentFocus) {
          focusedIndex = i;
          break;
        }
      }

      if (e.shiftKey && focusedIndex === 0) {
        e.preventDefault();
        focusableChildren[totalFocusable - 1].focus();
      } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
        e.preventDefault();
        focusableChildren[0].focus();
      }
    }
  }, {
    key: 'handleBackdropMouseDown',
    value: function handleBackdropMouseDown(e) {
      this._mouseDownElement = e.target;
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      try {
        this._triggeringElement = document.activeElement;
      } catch (err) {
        this._triggeringElement = null;
      }
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);
      if (Modal.openCount === 0) {
        document.body.className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
      }
      Modal.openCount += 1;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        document.body.removeChild(this._element);
        this._element = null;
      }

      if (this._triggeringElement) {
        if (this._triggeringElement.focus) this._triggeringElement.focus();
        this._triggeringElement = null;
      }

      if (Modal.openCount <= 1) {
        var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule);
        // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
        var modalOpenClassNameRegex = new RegExp('(^| )' + modalOpenClassName + '( |$)');
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
      }
      Modal.openCount -= 1;

      setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _classNames,
          _this2 = this;

      var attributes = omit(this.props, propsToOmit);
      var dialogBaseClass = 'modal-dialog';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, {
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, defineProperty(_classNames, 'modal-' + this.props.size, this.props.size), defineProperty(_classNames, dialogBaseClass + '-centered', this.props.centered), _classNames)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this2._dialog = c;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isOpen) {
        var _props = this.props,
            wrapClassName = _props.wrapClassName,
            modalClassName = _props.modalClassName,
            backdropClassName = _props.backdropClassName,
            cssModule = _props.cssModule,
            isOpen = _props.isOpen,
            backdrop = _props.backdrop,
            role = _props.role,
            labelledBy = _props.labelledBy,
            external = _props.external,
            innerRef = _props.innerRef;


        var modalAttributes = {
          onClick: this.handleBackdropClick,
          onMouseDown: this.handleBackdropMouseDown,
          onKeyUp: this.handleEscape,
          onKeyDown: this.handleTab,
          style: { display: 'block' },
          'aria-labelledby': labelledBy,
          role: role,
          tabIndex: '-1'
        };

        var hasTransition = this.props.fade;
        var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        });
        var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        });

        var Backdrop = hasTransition ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
          'in': isOpen && !!backdrop,
          cssModule: cssModule,
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
        })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', 'show', backdropClassName), cssModule) });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Portal,
          { node: this._element },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: mapToCssModules(wrapClassName) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              _extends({}, modalAttributes, modalTransition, {
                'in': isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule),
                innerRef: innerRef
              }),
              external,
              this.renderModalDialog()
            ),
            Backdrop
          )
        );
      }

      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$41;
Modal.defaultProps = defaultProps$38;
Modal.openCount = 0;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  charCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$39 = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close',
  charCode: 215
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      charCode = props.charCode,
      close = props.close,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel', 'charCode', 'close']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (!close && toggle) {
    var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        closeIcon
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    close || closeButton
  );
};

ModalHeader.propTypes = propTypes$43;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$44 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$44;
ModalBody.defaultProps = defaultProps$40;

var propTypes$45 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$45;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$46 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  boundariesElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, DOMElement]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  hideArrow: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this._target = null;
    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.onEscKeyDown = _this.onEscKeyDown.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearHideTimeout();
      this.clearShowTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip(e) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip(e) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent(e) {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }, {
    key: 'onEscKeyDown',
    value: function onEscKeyDown(e) {
      if (e.key === 'Escape') {
        this.hide(e);
      }
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show(e) {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle(e);
      }
    }
  }, {
    key: 'hide',
    value: function hide(e) {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle(e);
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (this._target !== null && (e.target === this._target || this._target.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle(e);
        }
      } else if (this.props.isOpen && e.target.getAttribute('role') !== 'tooltip') {
        if (this._showTimeout) {
          this.clearShowTimeout();
        }
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      if (this.props.trigger) {
        var triggers = this.props.trigger.split(' ');
        if (triggers.indexOf('manual') === -1) {
          if (triggers.indexOf('click') > -1) {
            ['click', 'touchstart'].forEach(function (event) {
              return document.addEventListener(event, _this2.handleDocumentClick, true);
            });
          }
          if (this._target !== null) {
            if (triggers.indexOf('hover') > -1) {
              this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
              this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
            }
            if (triggers.indexOf('focus') > -1) {
              this._target.addEventListener('focusin', this.show, true);
              this._target.addEventListener('focusout', this.hide, true);
            }
            this._target.addEventListener('keydown', this.onEscKeyDown, true);
          }
        }
      } else {
        if (this._target !== null) {
          this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
          this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
          this._target.addEventListener('keydown', this.onEscKeyDown, true);
          this._target.addEventListener('focusin', this.show, true);
          this._target.addEventListener('focusout', this.hide, true);
        }
        ['click', 'touchstart'].forEach(function (event) {
          return document.addEventListener(event, _this2.handleDocumentClick, true);
        });
      }
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      if (this._target !== null) {
        this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
        this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
        this._target.addEventListener('keydown', this.onEscKeyDown, true);
        this._target.addEventListener('focusin', this.show, true);
        this._target.addEventListener('focusout', this.hide, true);
      }
      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$46));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          boundariesElement: this.props.boundariesElement,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          arrowClassName: this.props.arrowClassName,
          container: this.props.container,
          modifiers: this.props.modifiers,
          offset: this.props.offset,
          cssModule: this.props.cssModule
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          ref: this.props.innerRef,
          className: classes,
          role: 'tooltip',
          'aria-hidden': this.props.isOpen,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent,
          onKeyDown: this.onEscKeyDown
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$46;
Tooltip.defaultProps = defaultProps$42;

var propTypes$47 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  borderless: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      borderless = props.borderless,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'borderless', 'striped', 'inverse', 'dark', 'hover', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : 'table-responsive-' + responsive;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: responsiveClassName },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$47;
Table.defaultProps = defaultProps$43;

var propTypes$48 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$48;
ListGroup.defaultProps = defaultProps$44;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function (_Component) {
  inherits(Form, _Component);

  function Form(props) {
    classCallCheck(this, Form);

    var _this = possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.getRef = _this.getRef.bind(_this);
    _this.submit = _this.submit.bind(_this);
    return _this;
  }

  createClass(Form, [{
    key: 'getRef',
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: 'submit',
    value: function submit() {
      if (this.ref) {
        this.ref.submit();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          inline = _props.inline,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = propTypes$49;
Form.defaultProps = defaultProps$45;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$46 = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'valid', 'tooltip', 'tag']);


  var validMode = tooltip ? 'tooltip' : 'feedback';

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid ? 'valid-' + validMode : 'invalid-' + validMode), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$50;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'position-relative', row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$51;
FormGroup.defaultProps = defaultProps$47;

var propTypes$52 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$52;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$53 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input(props) {
    classCallCheck(this, Input);

    var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.getRef = _this.getRef.bind(_this);
    _this.focus = _this.focus.bind(_this);
    return _this;
  }

  createClass(Input, [{
    key: 'getRef',
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.ref) {
        this.ref.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          invalid = _props.invalid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'invalid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag || 'p';
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
        if (state === 'danger') {
          invalid = true;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input' || tag && typeof tag === 'function') {
        attributes.type = type;
      }

      if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
        warnOnce('Input with a type of "' + type + '" cannot have children. Please use "value"/"defaultValue" instead.');
        delete attributes.children;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$53;
Input.defaultProps = defaultProps$49;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$54;
InputGroup.defaultProps = defaultProps$50;

var propTypes$56 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupText.propTypes = propTypes$56;
InputGroupText.defaultProps = defaultProps$52;

var propTypes$55 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'addonType', 'children']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-' + addonType), cssModule);

  // Convenience to assist with transition
  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupText, { children: children })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupAddon.propTypes = propTypes$55;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$57 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = objectWithoutProperties(props, ['children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = objectWithoutProperties(propsWithoutGroup, ['cssModule', 'tag', 'addonType']);


    var allGroupAttributes = _extends({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InputGroupAddon,
      _extends({}, allGroupAttributes, { className: groupClassName }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { children: children }))
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupAddon, _extends({}, props, { children: children }));
};

InputGroupButton.propTypes = propTypes$57;

var propTypes$58 = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = propTypes$58;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$59 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$59;
Label.defaultProps = defaultProps$53;

var propTypes$60 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (attributes.href) {
    defaultTag = 'a';
  } else if (attributes.src || object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$60;

var propTypes$61 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$54 = {
  tag: 'nav',
  listTag: 'ul',
  'aria-label': 'pagination'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = objectWithoutProperties(props, ['className', 'listClassName', 'cssModule', 'size', 'tag', 'listTag', 'aria-label']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className), cssModule);

  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(listClassName, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    { className: classes, 'aria-label': label },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListTag, _extends({}, attributes, { className: listClasses }))
  );
};

Pagination.propTypes = propTypes$61;
Pagination.defaultProps = defaultProps$54;

var propTypes$62 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$62;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$63 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (!attributes.href && Tag === 'a') {
    Tag = 'button';
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$63;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$64 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);
  createClass(TabContent, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.activeTab !== nextProps.activeTab) {
        return {
          activeTab: nextProps.activeTab
        };
      }
      return null;
    }
  }]);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$64));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["a" /* polyfill */])(TabContent);
TabContent.propTypes = propTypes$64;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$65;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$66 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$66;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$67 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition', 'fade', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  var alertTransition = _extends({}, Fade.defaultProps, transition, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, alertTransition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert', innerRef: innerRef }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$67;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$68 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          innerRef = _props.innerRef,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children', 'innerRef']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes,
              ref: _this2.props.innerRef
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$68;
Collapse.defaultProps = defaultProps$61;

var propTypes$69 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item'), cssModule);

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$69;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$70 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$70;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$71 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$71;
ListGroupItemText.defaultProps = defaultProps$64;

var UncontrolledAlert = function (_Component) {
  inherits(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    classCallCheck(this, UncontrolledAlert);

    var _this = possibleConstructorReturn(this, (UncontrolledAlert.__proto__ || Object.getPrototypeOf(UncontrolledAlert)).call(this, props));

    _this.state = { isOpen: true };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledAlert, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledButtonDropdown = function (_Component) {
  inherits(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    classCallCheck(this, UncontrolledButtonDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledButtonDropdown.__proto__ || Object.getPrototypeOf(UncontrolledButtonDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledButtonDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var propTypes$72 = {
  toggler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  toggleEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

var defaultProps$65 = {
  toggleEvents: defaultToggleEvents
};

var UncontrolledCollapse = function (_Component) {
  inherits(UncontrolledCollapse, _Component);

  function UncontrolledCollapse(props) {
    classCallCheck(this, UncontrolledCollapse);

    var _this = possibleConstructorReturn(this, (UncontrolledCollapse.__proto__ || Object.getPrototypeOf(UncontrolledCollapse)).call(this, props));

    _this.togglers = null;
    _this.removeEventListeners = null;
    _this.toggle = _this.toggle.bind(_this);

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  createClass(UncontrolledCollapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.togglers = findDOMElements(this.props.toggler);
      if (this.togglers.length) {
        this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.togglers.length && this.removeEventListeners) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      this.setState(function (_ref) {
        var isOpen = _ref.isOpen;
        return { isOpen: !isOpen };
      });
      e.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          toggleEvents = _props.toggleEvents,
          rest = objectWithoutProperties(_props, ['toggleEvents']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, _extends({ isOpen: this.state.isOpen }, rest));
    }
  }]);
  return UncontrolledCollapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCollapse.propTypes = propTypes$72;
UncontrolledCollapse.defaultProps = defaultProps$65;

var UncontrolledDropdown = function (_Component) {
  inherits(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    classCallCheck(this, UncontrolledDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledDropdown.__proto__ || Object.getPrototypeOf(UncontrolledDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UncontrolledDropdown, _extends({ nav: true }, props));
};

var UncontrolledTooltip = function (_Component) {
  inherits(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    classCallCheck(this, UncontrolledTooltip);

    var _this = possibleConstructorReturn(this, (UncontrolledTooltip.__proto__ || Object.getPrototypeOf(UncontrolledTooltip)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledTooltip, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var SearchBox = function SearchBox(_ref) {
  var styleName = _ref.styleName,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      value = _ref.value,
      onButtonClick = _ref.onButtonClick,
      onKeyPress = _ref.onKeyPress;

  return _react2.default.createElement("div", { className: "search-bar left-side-icon bg-transparent " + styleName }, _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("input", {
    className: "form-control input-for-search border-0",
    type: "search",
    placeholder: placeholder,
    onChange: onChange,
    value: value,
    onKeyPress: onKeyPress
  }), _react2.default.createElement("button", { className: "search-icon", onClick: onButtonClick }, _react2.default.createElement("i", { className: "zmdi zmdi-search zmdi-hc-lg" }))));
};
var _default = SearchBox;
exports.default = _default;

SearchBox.defaultProps = {
  styleName: '',
  value: ''
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchBox, "SearchBox", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(SearchBox, "SearchBox", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/SearchBox/index.js");
}();

;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(34)) {
  var LIBRARY = __webpack_require__(106);
  var global = __webpack_require__(20);
  var fails = __webpack_require__(23);
  var $export = __webpack_require__(3);
  var $typed = __webpack_require__(216);
  var $buffer = __webpack_require__(315);
  var ctx = __webpack_require__(69);
  var anInstance = __webpack_require__(126);
  var propertyDesc = __webpack_require__(119);
  var hide = __webpack_require__(53);
  var redefineAll = __webpack_require__(128);
  var toInteger = __webpack_require__(71);
  var toLength = __webpack_require__(33);
  var toIndex = __webpack_require__(465);
  var toAbsoluteIndex = __webpack_require__(122);
  var toPrimitive = __webpack_require__(79);
  var has = __webpack_require__(61);
  var classof = __webpack_require__(150);
  var isObject = __webpack_require__(26);
  var toObject = __webpack_require__(37);
  var isArrayIter = __webpack_require__(304);
  var create = __webpack_require__(123);
  var getPrototypeOf = __webpack_require__(64);
  var gOPN = __webpack_require__(124).f;
  var getIterFn = __webpack_require__(306);
  var uid = __webpack_require__(120);
  var wks = __webpack_require__(32);
  var createArrayMethod = __webpack_require__(82);
  var createArrayIncludes = __webpack_require__(206);
  var speciesConstructor = __webpack_require__(179);
  var ArrayIterators = __webpack_require__(309);
  var Iterators = __webpack_require__(152);
  var $iterDetect = __webpack_require__(211);
  var setSpecies = __webpack_require__(125);
  var arrayFill = __webpack_require__(308);
  var arrayCopyWithin = __webpack_require__(454);
  var $DP = __webpack_require__(36);
  var $GOPD = __webpack_require__(63);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(460);
var $export = __webpack_require__(3);
var shared = __webpack_require__(175)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(463))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = {
	overlay: {
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		position: 'fixed',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		zIndex: 5000
	},
	sweetAlert: {
		backgroundColor: '#fff',
		outline: 'none',
		width: 478,
		padding: 17,
		borderRadius: 5,
		textAlign: 'center',
		position: 'fixed',
		left: '50%',
		top: '50%',
		marginLeft: -256,
		marginTop: -200,
		overflow: 'hidden',
		zIndex: 5500,
		animation: 'showSweetAlert 0.3s'
	},
	sweetAlertMobile: {
		width: 'auto',
		marginLeft: 0,
		marginRight: 0,
		left: 15,
		right: 15
	},
	icon: {
		width: 80,
		height: 80,
		borderWidth: 4,
		borderStyle: 'solid',
		borderColor: 'gray',
		borderRadius: '50%',
		margin: '20px auto',
		position: 'relative',
		boxSizing: 'content-box'
	},
	iconError: {
		borderColor: '#d43f3a',
		animation: 'animateErrorIcon 0.5s'
	},
	iconErrorX: {
		position: 'relative',
		display: 'block',
		animation: 'animateXMark 0.5s'
	},
	iconErrorLine: {
		position: 'absolute',
		height: 5,
		width: 47,
		backgroundColor: '#d9534f',
		display: 'block',
		top: 37,
		borderRadius: 2
	},
	iconErrorLineLeft: {
		transform: 'rotate(45deg)',
		left: 17
	},
	iconErrorLineRight: {
		transform: 'rotate(-45deg)',
		right: 16
	},
	iconWarning: {
		borderColor: '#eea236',
		animation: 'pulseWarning 0.75s infinite alternate'
	},
	iconWarningBody: {
		position: 'absolute',
		width: 5,
		height: 47,
		left: '50%',
		top: 10,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconWarningDot: {
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		bottom: 10,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconInfo: {
		borderColor: '#46b8da'
	},
	iconInfoBefore: {
		content: "",
		position: 'absolute',
		width: 5,
		height: 29,
		left: '50%',
		bottom: 17,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#5bc0de'
	},
	iconInfoAfter: {
		content: "",
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		top: 19,
		backgroundColor: '#5bc0de'
	},
	iconSuccess: {
		borderColor: '#4cae4c'
	},
	iconSuccessBeforeAfter: {
		content: '',
		borderRadius: '50%',
		position: 'absolute',
		width: 60,
		height: 120,
		background: 'white',
		transform: 'rotate(45deg)'
	},
	iconSuccessBefore: {
		borderRadius: '120px 0 0 120px',
		height: 100,
		top: -7,
		left: -33,
		transform: 'rotate(-45deg)',
		transformOrigin: '60px 60px'
	},
	iconSuccessAfter: {
		borderRadius: '0 120px 120px 0',
		top: -11,
		left: 30,
		transform: 'rotate(-45deg)',
		transformOrigin: '0px 60px',
		animation: 'rotatePlaceholder 4.25s ease-in'
	},
	iconSuccessPlaceholder: {
		width: 80,
		height: 80,
		border: '4px solid rgba(92, 184, 92, 0.2)',
		borderRadius: '50%',
		boxSizing: 'content-box',
		position: 'absolute',
		left: -4,
		top: -4,
		zIndex: 2
	},
	iconSuccessFix: {
		width: 5,
		height: 90,
		backgroundColor: '#fff',
		position: 'absolute',
		left: 28,
		top: 8,
		zIndex: 1,
		transform: 'rotate(-45deg)'
	},
	iconSuccessLine: {
		height: 5,
		backgroundColor: '#5cb85c',
		display: 'block',
		borderRadius: 2,
		position: 'absolute',
		zIndex: 2
	},
	iconSuccessLineTip: {
		width: 25,
		left: 14,
		top: 46,
		transform: 'rotate(45deg)',
		animation: 'animateSuccessTip 0.75s'
	},
	iconSuccessLineLong: {
		width: 47,
		right: 8,
		top: 38,
		transform: 'rotate(-45deg)',
		animation: 'animateSuccessLong 0.75s'
	},
	iconCustom: {
		backgroundSize: 'contain',
		borderRadius: 0,
		border: 'none',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat'
	},
	button: {
		marginRight: 8
	},
	validationMessage: {
		display: 'block',
		backgroundColor: '#f1f1f1',
	    marginLeft: -17,
	    marginRight: -17,
	    marginTop: 20,
	    overflow: 'hidden',
	    padding: 10,
	    maxHeight: 100,
	    transition: 'padding 0.25s, max-height 0.25s',
	    color: '#797979',
	    fontSize: 16,
	    textAlign: 'center',
	    fontWeight: 300
	},
	exclamationIcon: {
		display: 'inline-block',
	    width: 24,
	    height: 24,
	    borderRadius: '50%',
	    backgroundColor: '#ea7d7d',
	    color: 'white',
	    lineHeight: '24px',
	    textAlign: 'center',
	    marginRight: 5
	},
	inputErrorIcon: {
		position: 'absolute',
	    top: 8,
	    right: 8,
	    width: 20,
	    height: 20,
	    opacity: 0,
	    transform: 'scale(0.5)',
	    transformOrigin: '50% 50%',
	    transition: 'all 0.1s',
	    opacity: 1,
	    transform: 'scale(1)'
	},
	inputErrorIconBeforeAfter: {
		content: "",
	    width: 20,
	    height: 6,
	    backgroundColor: '#f06e57',
	    borderRadius: 3,
	    position: 'absolute',
	    top: '50%',
	    marginTop: -4,
	    left: '50%',
	    marginLeft: -9
	},
	inputErrorIconBefore: {
		transform: 'rotate(-45deg)'
	},
	inputErrorIconAfter: {
		transform: 'rotate(45deg)'
	}
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1443)
var ieee754 = __webpack_require__(1444)
var isArray = __webpack_require__(575)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 102 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__merge__ = __webpack_require__(268);



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__merge__["a" /* default */])(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (compose);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(19);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(120)('meta');
var isObject = __webpack_require__(26);
var has = __webpack_require__(61);
var setDesc = __webpack_require__(36).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(23)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(32)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(53)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1102);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return detach; });
/* harmony export (immutable) */ __webpack_exports__["s"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return takem; });
/* harmony export (immutable) */ __webpack_exports__["n"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["o"] = race;
/* harmony export (immutable) */ __webpack_exports__["e"] = call;
/* harmony export (immutable) */ __webpack_exports__["c"] = apply;
/* harmony export (immutable) */ __webpack_exports__["h"] = cps;
/* harmony export (immutable) */ __webpack_exports__["k"] = fork;
/* harmony export (immutable) */ __webpack_exports__["r"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["m"] = join;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["p"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["g"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["j"] = flush;
/* harmony export (immutable) */ __webpack_exports__["l"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["q"] = setContext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(74);
var createDesc = __webpack_require__(186);
module.exports = __webpack_require__(75) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = undefined;

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNan = __webpack_require__(515);

var _isNan2 = _interopRequireDefault(_isNan);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = exports.easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

/* eslint-disable no-param-reassign */

var duration = exports.duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

var formatMs = exports.formatMs = function formatMs(milliseconds) {
  return Math.round(milliseconds) + 'ms';
};
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};
var isNumber = exports.isNumber = function isNumber(value) {
  return !(0, _isNan2.default)(parseFloat(value));
};

/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */
exports.default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === undefined ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === undefined ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === undefined ? 0 : _options$delay,
        other = (0, _objectWithoutProperties3.default)(options, ['duration', 'easing', 'delay']);


     false ? (0, _warning2.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning2.default)(isNumber(durationOption) || isString(durationOption), 'Material-UI: argument "duration" must be a number or a string but found ' + durationOption + '.') : void 0;
     false ? (0, _warning2.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning2.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unrecognized argument(s) [' + (0, _keys2.default)(other).join(',') + ']') : void 0;

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return animatedProp + ' ' + (typeof durationOption === 'string' ? durationOption : formatMs(durationOption)) + ' ' + easingOption + ' ' + (typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36;

    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1200), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RuleList", function() { return RuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SheetsManager", function() { return SheetsManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SheetsRegistry", function() { return SheetsRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return createJss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGenerateId", function() { return createGenerateId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRule", function() { return createRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDynamicStyles", function() { return getDynamicStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasCSSTOMSupport", function() { return hasCSSTOMSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheets", function() { return sheets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toCssValue", function() { return toCssValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["default"] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["default"])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["default"])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* harmony default export */ __webpack_exports__["default"] = (index);



/***/ }),
/* 115 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1302);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.authenticateUser = authenticateUser;
exports.setFirstTimePassword = setFirstTimePassword;
exports.changePassword = changePassword;
exports.signUp = signUp;
exports.sendVerificationCode = sendVerificationCode;
exports.confirmResetPassword = confirmResetPassword;
exports.signOut = signOut;
exports.verifyEmailAddress = verifyEmailAddress;
exports.resendVerificationCode = resendVerificationCode;
exports.getUserAttributes = getUserAttributes;
exports.updateUserAttributes = updateUserAttributes;

var _amazonCognitoIdentityJs = __webpack_require__(1529);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

var _util = __webpack_require__(77);

var _reactNotifications = __webpack_require__(78);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

// Auth - Cognito import
var poolData = {
    UserPoolId: CONST.USER_POOL_ID,
    ClientId: CONST.CLIENT_ID
};
var userPool = new _amazonCognitoIdentityJs.CognitoUserPool(poolData);

var userData = {
    Username: '',
    Pool: userPool
};

var cognitoUser = void 0;

function authenticateUser(username, password) {
    var authenticationData = {
        Username: username,
        Password: password
    };
    var authenticationDetails = new _amazonCognitoIdentityJs.AuthenticationDetails(authenticationData);

    userData.Username = username;
    cognitoUser = new _amazonCognitoIdentityJs.CognitoUser(userData);

    var promiseForAuthentication = new Promise(function (resolve, reject) {
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function onSuccess(result) {
                resolve(result);
            },
            onFailure: function onFailure(err) {
                // console.log("error: ", err);
                // if (err.statusCode == 200) {
                //     // console.log("Success at: ", err.statusCode);
                //     resolve("Authentication Successful");
                // }
                // else {
                //     reject(err);
                // }
                reject(err);
            },
            newPasswordRequired: function newPasswordRequired() {
                // User was signed up by an admin and must provide new
                // password and required attributes, if any, to complete
                // authentication.

                // userAttributes: object,
                // which is the user's current profile.
                // It will list all attributes that are associated with the user.
                // Required attributes according to schema,
                // which don’t have any values yet, will have blank values.
                // requiredAttributes: list of attributes that must
                // be set by the user along with new password to complete the sign-in.


                // Get these details and call
                // newPassword: password that user has given
                // attributesData: object with key as attribute name and value that the user has given.
                // cognitoUser.completeNewPasswordChallenge(newPassword, attributesData, this);
                (0, _util.opennewPasswordModal)();
                // $('#newPasswordModal').modal('show');
            }
        });
    });

    return promiseForAuthentication;
}

function setFirstTimePassword(newPassword) {

    var promiseNewPassword = new Promise(function (resolve, reject) {

        cognitoUser = userPool.getCurrentUser().getSession(function (err, session) {

            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();

            cognitoUser.completeNewPasswordChallenge(newPassword, null, {
                onSuccess: function onSuccess(result) {
                    (0, _util.closenewPasswordModal)();
                    resolve(result);
                },
                onFailure: function onFailure(error) {
                    _reactNotifications.NotificationManager.error(error.message);
                    reject(error);
                }
            });
        });
    });

    return promiseNewPassword;
}

function changePassword(oldPassword, newPassword) {
    cognitoUser = userPool.getCurrentUser();

    var promiseForPasswordChange = new Promise(function (resolve, reject) {
        cognitoUser = userPool.getCurrentUser().getSession(function (err, session) {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();

            cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
                if (err) {
                    reject(err);
                }
                resolve(result);
            });
        });
    });

    return promiseForPasswordChange;
}

function signUp(username, email, password, mobile) {

    var isValidMobileNumber = null;

    var attributeFullName = {
        Name: 'name',
        Value: username
    };

    // attributePhone;
    var attributePhone = {
        Name: 'phone_number',
        Value: mobile
    };

    var attributeMail = {
        Name: 'email',
        Value: email
    };

    var attributePicture = {
        Name: 'picture',
        Value: ''

    };

    // if(mobile !== null){
    //      let phoneExpression = /^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
    //     // let phoneExpression = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;
    //     if((((mobile).match(phoneExpression))&&((mobile.length === 10)||(mobile.length === 12)))){
    //         isValidMobileNumber = true;
    //     }
    //     else {
    //       attributePhone.Value = null;
    //       isValidMobileNumber = false;
    //     }
    // }

    var attributeEmail = new _amazonCognitoIdentityJs.CognitoUserAttribute(attributeMail);
    var attributeName = new _amazonCognitoIdentityJs.CognitoUserAttribute(attributeFullName);
    var attributePhoneNumber = new _amazonCognitoIdentityJs.CognitoUserAttribute(attributePhone);
    var attributeProfileImage = new _amazonCognitoIdentityJs.CognitoUserAttribute(attributePicture);

    var attributeList = [];

    attributeList.push(attributeEmail);
    attributeList.push(attributeName);
    attributeList.push(attributePhoneNumber);
    attributeList.push(attributeProfileImage);

    var promiseForSignUp = new Promise(function (resolve, reject) {
        userPool.signUp(username, password, attributeList, null, function (err, result) {
            if (err) {
                reject(err);
                // return;
            } else {
                resolve(result);
                cognitoUser = result.user;
            }
        });
    });
    return promiseForSignUp;
}

// Function to get the verification code on Forgot Password
function sendVerificationCode(username) {
    userData.Username = username;
    cognitoUser = new _amazonCognitoIdentityJs.CognitoUser(userData);
    var promiseForVerificationCode = new Promise(function (resolve, reject) {
        cognitoUser.forgotPassword({
            onSuccess: function onSuccess(result) {
                resolve(result);
            },
            onFailure: function onFailure(err) {
                reject(err);
            },

            undefined: undefined
        });
    });
    return promiseForVerificationCode;
}

function confirmResetPassword(verifyCode, newPwd) {
    var promiseForResetToNewPassword = new Promise(function (resolve, reject) {
        cognitoUser.confirmPassword(verifyCode, newPwd, {
            onSuccess: function onSuccess() {
                resolve();
            },
            onFailure: function onFailure(err) {
                reject(err);
            }
        });
    });
    return promiseForResetToNewPassword;
}

function signOut() {
    var promiseForSignOut = new Promise(function (resolve, reject) {
        cognitoUser.globalSignOut({
            onSuccess: function onSuccess(result) {
                resolve(result);
            },
            onFailure: function onFailure(err) {
                reject(err);
            }
        });
    });

    return promiseForSignOut;
}

function verifyEmailAddress(verificationCode) {
    cognitoUser = userPool.getCurrentUser();
    var promiseForEmailVerifcation = new Promise(function (resolve, reject) {
        cognitoUser = userPool.getCurrentUser().getSession(function (err, session) {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();
            cognitoUser.verifyAttribute('email', verificationCode, {
                onSuccess: function onSuccess(result) {
                    resolve(result);
                },
                onFailure: function onFailure(err) {
                    reject(err);
                }
            });
        });
    });

    return promiseForEmailVerifcation;
}

function resendVerificationCode() {
    cognitoUser = userPool.getCurrentUser();
    var promiseForVerificationCode = new Promise(function (resolve, reject) {
        cognitoUser = userPool.getCurrentUser().getSession(function (err, session) {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();
            cognitoUser.getAttributeVerificationCode('email', {
                onSuccess: function onSuccess(result) {
                    resolve(result);
                },
                onFailure: function onFailure(err) {
                    reject(err);
                }
            });
        });
    });

    return promiseForVerificationCode;
}

function getUserAttributes() {
    cognitoUser = userPool.getCurrentUser();
    var promiseForUserAttributes = new Promise(function (resolve, reject) {
        cognitoUser = userPool.getCurrentUser().getSession(function (err, session) {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();

            cognitoUser.getUserAttributes(function (err, result) {
                if (err) {
                    reject(err);
                } else if (result) {
                    resolve(result);
                }
            });
        });
    });

    return promiseForUserAttributes;
}

function updateUserAttributes(attributeList) {
    cognitoUser = userPool.getCurrentUser();
    var promiseForUpdateUserAttributes = new Promise(function (resolve, reject) {
        cognitoUser = userPool.getCurrentUser().getSession(function (err, session) {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();
            cognitoUser.updateAttributes(attributeList, function (err, result) {
                if (err) {
                    reject(err);
                } else if (result) {
                    resolve(result);
                }
            });
        });
    });

    return promiseForUpdateUserAttributes;
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(authenticateUser, 'authenticateUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(setFirstTimePassword, 'setFirstTimePassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(changePassword, 'changePassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(signUp, 'signUp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(sendVerificationCode, 'sendVerificationCode', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(confirmResetPassword, 'confirmResetPassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(signOut, 'signOut', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(verifyEmailAddress, 'verifyEmailAddress', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(resendVerificationCode, 'resendVerificationCode', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(getUserAttributes, 'getUserAttributes', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(updateUserAttributes, 'updateUserAttributes', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(poolData, 'poolData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(userPool, 'userPool', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(userData, 'userData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(cognitoUser, 'cognitoUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(CONST, 'CONST', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(_interopRequireWildcard, '_interopRequireWildcard', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(poolData, 'poolData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(userPool, 'userPool', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(userData, 'userData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(cognitoUser, 'cognitoUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(authenticateUser, 'authenticateUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(setFirstTimePassword, 'setFirstTimePassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(changePassword, 'changePassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(signUp, 'signUp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(sendVerificationCode, 'sendVerificationCode', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(confirmResetPassword, 'confirmResetPassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(signOut, 'signOut', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(verifyEmailAddress, 'verifyEmailAddress', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(resendVerificationCode, 'resendVerificationCode', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(getUserAttributes, 'getUserAttributes', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(updateUserAttributes, 'updateUserAttributes', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/user-manager.js');
}();

;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105),
    now = __webpack_require__(1391),
    toNumber = __webpack_require__(360);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(439);
var enumBugKeys = __webpack_require__(292);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(18);
var dPs = __webpack_require__(440);
var enumBugKeys = __webpack_require__(292);
var IE_PROTO = __webpack_require__(291)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(289)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(293).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(439);
var hiddenKeys = __webpack_require__(292).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var dP = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(34);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(69);
var call = __webpack_require__(452);
var isArrayIter = __webpack_require__(304);
var anObject = __webpack_require__(18);
var toLength = __webpack_require__(33);
var getIterFn = __webpack_require__(306);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(54);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(508);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(332);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

   false ? (0, _warning2.default)(value >= min && value <= max, 'Material-UI: the value provided ' + value + ' is out of range [' + min + ', ' + max + '].') : void 0;

  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
//  weak
/* eslint-disable no-use-before-define */

function convertHexToRGB(color) {
  color = color.substr(1);

  var re = new RegExp('.{1,' + color.length / 3 + '}', 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? 'rgb(' + colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', ') + ')' : '';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  var type = color.type;
  var values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') > -1) {
    values[1] = values[1] + '%';
    values[2] = values[2] + '%';
  }

  return color.type + '(' + values.join(', ') + ')';
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') > -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } else if (decomposedColor.type.indexOf('hsl') > -1) {
    return decomposedColor.values[2] / 100;
  }

  throw new Error('Material-UI: unsupported `' + color + '` color.');
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in fade(' + color + ', ' + value + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return recomposeColor(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in darken(' + color + ', ' + coefficient + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in lighten(' + color + ', ' + coefficient + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toolbar = __webpack_require__(1352);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */

function cloneElementWithClassName(child, className) {
  return _react2.default.cloneElement(child, {
    className: (0, _classnames2.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react2.default.Children.map(children, function (child) {
    return _react2.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react2.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(194);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(195));
util.inherits = __webpack_require__(102);
/*</replacement>*/

var Readable = __webpack_require__(574);
var Writable = __webpack_require__(578);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import React from 'react';

var highlightNavigatedMenu = exports.highlightNavigatedMenu = function highlightNavigatedMenu(newPath, oldPath) {
  var activeLi = $('a[href="#/app/components/' + newPath + '"]');
  var inactiveLi = $('a[href="' + oldPath + '"]');

  inactiveLi.parent().removeClass('open');
  activeLi.parent().addClass('open');
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(highlightNavigatedMenu, 'highlightNavigatedMenu', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/highlightSidebarOption.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(highlightNavigatedMenu, 'highlightNavigatedMenu', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/highlightSidebarOption.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/highlightSidebarOption.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1550),
    getValue = __webpack_require__(1553);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(353);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var InjectMassage = function InjectMassage(props) {
  return _react2.default.createElement(_reactIntl.FormattedMessage, props);
};

var _default = (0, _reactIntl.injectIntl)(InjectMassage, {
  withRef: false
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InjectMassage, 'InjectMassage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');

  __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');

  __REACT_HOT_LOADER__.register(InjectMassage, 'InjectMassage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');

  __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/IntlMessages.js');
}();

;

/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(201),
    isLength = __webpack_require__(382);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(36).f;
var has = __webpack_require__(61);
var TAG = __webpack_require__(32)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(70);
var TAG = __webpack_require__(32)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var defined = __webpack_require__(80);
var fails = __webpack_require__(23);
var spaces = __webpack_require__(295);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(476);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* harmony export (immutable) */ __webpack_exports__["b"] = channel;
/* harmony export (immutable) */ __webpack_exports__["d"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(498);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(330);
var defined = __webpack_require__(332);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(351);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(236);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(350);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wrapDisplayName = __webpack_require__(191);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createMuiTheme = __webpack_require__(328);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(349);

var _themeListener2 = _interopRequireDefault(_themeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Provide the theme object as a property to the input component.
var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme = function (_React$Component) {
      (0, _inherits3.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        (0, _classCallCheck3.default)(this, WithTheme);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));

        _this.state = {};
        _this.unsubscribeId = null;

        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener2.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass3.default)(WithTheme, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            _this2.setState({ theme: theme });
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, (0, _extends3.default)({ theme: this.state.theme }, this.props));
        }
      }]);
      return WithTheme;
    }(_react2.default.Component);

    WithTheme.contextTypes = _themeListener2.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName2.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics2.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

exports.default = withTheme;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1357);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _reactLifecyclesCompat = __webpack_require__(550);

var _PropTypes = __webpack_require__(1365);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex != -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            var words = [];
	            var nBytes = 0;
	            for (var i = 0; i < base64StrLength; i++) {
	                if (i % 4) {
	                    var bits1 = map.indexOf(base64Str.charAt(i - 1)) << ((i % 4) * 2);
	                    var bits2 = map.indexOf(base64Str.charAt(i)) >>> (6 - (i % 4) * 2);
	                    var bitsCombined = bits1 | bits2;
	                    words[nBytes >>> 2] |= (bitsCombined) << (24 - (nBytes % 4) * 8);
	                    nBytes++;
	                }
	            }

	            return WordArray.create(words, nBytes);
	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(368), __webpack_require__(369));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(173)(module)))

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useTheme__ = __webpack_require__(1796);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useTheme__["a"]; });


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__(1899);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(1891);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(172),
    getRawTag = __webpack_require__(1394),
    objectToString = __webpack_require__(1395);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(901),
    baseKeys = __webpack_require__(1585),
    isArrayLike = __webpack_require__(148);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(146);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(49);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CircularProgress = __webpack_require__(1667);

Object.defineProperty(exports, 'CircularProgress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CircularProgress).default;
  }
});

var _LinearProgress = __webpack_require__(1668);

Object.defineProperty(exports, 'LinearProgress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LinearProgress).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(68);
var global = __webpack_require__(20);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(106) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(70);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(18);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(18);
var aFunction = __webpack_require__(47);
var SPECIES = __webpack_require__(32)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(1103);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(1157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["c"]; });




/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebase", function() { return firebase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled || false;
        this.options_ = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepCopy"])(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this._automaticDataCollectionEnabled;
        },
        set: function (val) {
            this.checkDestroyed_();
            this._automaticDataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '4.13.0',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"],
            ErrorFactory: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"],
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"]
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["patchProperty"])(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["patchProperty"])(app, 'App', FirebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error('bad-app-name', { name: name + '' });
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, config, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) { return apps_[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function (appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
        'account is only allowed in a Node.js environment. On client ' +
        'devices, you should instead initialize the SDK with an api key and ' +
        'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.'
};
var appErrors = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('app', 'Firebase', errors);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firebase = createFirebaseNamespace();

/* harmony default export */ __webpack_exports__["default"] = (firebase);



/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideAuthLoader = exports.hideMessage = exports.showAuthLoader = exports.userGithubSignInSuccess = exports.userGithubSignIn = exports.userTwitterSignInSuccess = exports.userTwitterSignIn = exports.setInitUrl = exports.userFacebookSignInSuccess = exports.userFacebookSignIn = exports.userGoogleSignInSuccess = exports.userGoogleSignIn = exports.showAuthMessage = exports.userSignOutSuccess = exports.userSignInSuccess = exports.userSignUpSuccess = exports.userSignOut = exports.userSignIn = exports.userSignUp = undefined;

var _ActionTypes = __webpack_require__(41);

var userSignUp = exports.userSignUp = function userSignUp(user) {
    return {
        type: _ActionTypes.SIGNUP_USER,
        payload: user
    };
};
var userSignIn = exports.userSignIn = function userSignIn(user) {
    return {
        type: _ActionTypes.SIGNIN_USER,
        payload: user
    };
};
var userSignOut = exports.userSignOut = function userSignOut() {
    return {
        type: _ActionTypes.SIGNOUT_USER
    };
};
var userSignUpSuccess = exports.userSignUpSuccess = function userSignUpSuccess(authUser) {
    return {
        type: _ActionTypes.SIGNUP_USER_SUCCESS,
        payload: authUser
    };
};

var userSignInSuccess = exports.userSignInSuccess = function userSignInSuccess(authUser) {
    return {
        type: _ActionTypes.SIGNIN_USER_SUCCESS,
        payload: authUser
    };
};
var userSignOutSuccess = exports.userSignOutSuccess = function userSignOutSuccess() {
    return {
        type: _ActionTypes.SIGNOUT_USER_SUCCESS
    };
};

var showAuthMessage = exports.showAuthMessage = function showAuthMessage(message) {
    return {
        type: _ActionTypes.SHOW_MESSAGE,
        payload: message
    };
};

var userGoogleSignIn = exports.userGoogleSignIn = function userGoogleSignIn() {
    return {
        type: _ActionTypes.SIGNIN_GOOGLE_USER
    };
};
var userGoogleSignInSuccess = exports.userGoogleSignInSuccess = function userGoogleSignInSuccess(authUser) {
    return {
        type: _ActionTypes.SIGNIN_GOOGLE_USER_SUCCESS,
        payload: authUser
    };
};
var userFacebookSignIn = exports.userFacebookSignIn = function userFacebookSignIn() {
    return {
        type: _ActionTypes.SIGNIN_FACEBOOK_USER
    };
};
var userFacebookSignInSuccess = exports.userFacebookSignInSuccess = function userFacebookSignInSuccess(authUser) {
    return {
        type: _ActionTypes.SIGNIN_FACEBOOK_USER_SUCCESS,
        payload: authUser
    };
};
var setInitUrl = exports.setInitUrl = function setInitUrl(url) {
    return {
        type: _ActionTypes.INIT_URL,
        payload: url
    };
};
var userTwitterSignIn = exports.userTwitterSignIn = function userTwitterSignIn() {
    return {
        type: _ActionTypes.SIGNIN_TWITTER_USER
    };
};
var userTwitterSignInSuccess = exports.userTwitterSignInSuccess = function userTwitterSignInSuccess(authUser) {
    return {
        type: _ActionTypes.SIGNIN_TWITTER_USER_SUCCESS,
        payload: authUser
    };
};
var userGithubSignIn = exports.userGithubSignIn = function userGithubSignIn() {
    return {
        type: _ActionTypes.SIGNIN_GITHUB_USER
    };
};
var userGithubSignInSuccess = exports.userGithubSignInSuccess = function userGithubSignInSuccess(authUser) {
    return {
        type: _ActionTypes.SIGNIN_GITHUB_USER_SUCCESS,
        payload: authUser
    };
};
var showAuthLoader = exports.showAuthLoader = function showAuthLoader() {
    return {
        type: _ActionTypes.ON_SHOW_LOADER
    };
};

var hideMessage = exports.hideMessage = function hideMessage() {
    return {
        type: _ActionTypes.HIDE_MESSAGE
    };
};
var hideAuthLoader = exports.hideAuthLoader = function hideAuthLoader() {
    return {
        type: _ActionTypes.ON_HIDE_LOADER
    };
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(userSignUp, 'userSignUp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignIn, 'userSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignOut, 'userSignOut', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignUpSuccess, 'userSignUpSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignInSuccess, 'userSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignOutSuccess, 'userSignOutSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(showAuthMessage, 'showAuthMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGoogleSignIn, 'userGoogleSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGoogleSignInSuccess, 'userGoogleSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userFacebookSignIn, 'userFacebookSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userFacebookSignInSuccess, 'userFacebookSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(setInitUrl, 'setInitUrl', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userTwitterSignIn, 'userTwitterSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userTwitterSignInSuccess, 'userTwitterSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGithubSignIn, 'userGithubSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGithubSignInSuccess, 'userGithubSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(showAuthLoader, 'showAuthLoader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(hideMessage, 'hideMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(hideAuthLoader, 'hideAuthLoader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(userSignUp, 'userSignUp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignIn, 'userSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignOut, 'userSignOut', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignUpSuccess, 'userSignUpSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignInSuccess, 'userSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userSignOutSuccess, 'userSignOutSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(showAuthMessage, 'showAuthMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGoogleSignIn, 'userGoogleSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGoogleSignInSuccess, 'userGoogleSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userFacebookSignIn, 'userFacebookSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userFacebookSignInSuccess, 'userFacebookSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(setInitUrl, 'setInitUrl', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userTwitterSignIn, 'userTwitterSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userTwitterSignInSuccess, 'userTwitterSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGithubSignIn, 'userGithubSignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(userGithubSignInSuccess, 'userGithubSignInSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(showAuthLoader, 'showAuthLoader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(hideMessage, 'hideMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(hideAuthLoader, 'hideAuthLoader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Auth.js');
}();

;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(511);
var enumBugKeys = __webpack_require__(336);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keys = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createBreakpoints;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl'];

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === undefined ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === undefined ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === undefined ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties3.default)(breakpoints, ['values', 'unit', 'step']);


  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return '@media (min-width:' + value + unit + ')';
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return '@media (max-width:' + (value - step / 100) + unit + ')';
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return '@media (min-width:' + values[start] + unit + ') and ' + ('(max-width:' + (values[keys[endIndex]] - step / 100) + unit + ')');
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends3.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specialProperty = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = exactProp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

var specialProperty = exports.specialProperty = 'exact-prop: \u200B';

function exactProp(propTypes, componentNameInError) {
  return (0, _extends4.default)({}, propTypes, (0, _defineProperty3.default)({}, specialProperty, function (props) {
    var unknownProps = (0, _keys2.default)(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unknownProps.length > 0) {
      return new TypeError(componentNameInError + ': unknown props found: ' + unknownProps.join(', ') + '. Please remove the unknown properties.');
    }
    return null;
  }));
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(533);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(237);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(537);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(158);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(1268);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
var reflow = exports.reflow = function reflow(node) {
  return node.scrollTop;
};

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === undefined ? {} : _props$style;


  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(101).Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(786);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(1750)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1791);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

/* harmony default export */ __webpack_exports__["a"] = (Tablelvl2Context);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableCell__ = __webpack_require__(1830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableCell__["a"]; });


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObject = __webpack_require__(105);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1588),
    baseMatchesProperty = __webpack_require__(1621),
    identity = __webpack_require__(147),
    isArray = __webpack_require__(51),
    property = __webpack_require__(1628);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Menu = __webpack_require__(557);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _MenuList = __webpack_require__(569);

Object.defineProperty(exports, 'MenuList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuList).default;
  }
});

var _MenuItem = __webpack_require__(1426);

Object.defineProperty(exports, 'MenuItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(147),
    overRest = __webpack_require__(897),
    setToString = __webpack_require__(428);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(171);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(62);
var toLength = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(122);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(70);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(80);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(26);
var cof = __webpack_require__(70);
var MATCH = __webpack_require__(32)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(32)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(150);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(456);
var redefine = __webpack_require__(54);
var hide = __webpack_require__(53);
var fails = __webpack_require__(23);
var defined = __webpack_require__(80);
var wks = __webpack_require__(32);
var regexpExec = __webpack_require__(310);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(54);
var redefineAll = __webpack_require__(128);
var meta = __webpack_require__(107);
var forOf = __webpack_require__(127);
var anInstance = __webpack_require__(126);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(23);
var $iterDetect = __webpack_require__(211);
var setToStringTag = __webpack_require__(149);
var inheritIfRequired = __webpack_require__(296);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var hide = __webpack_require__(53);
var uid = __webpack_require__(120);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(106) || !__webpack_require__(23)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(20)[K];
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(47);
var ctx = __webpack_require__(69);
var forOf = __webpack_require__(127);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.history = exports.persistConfig = undefined;
exports.default = configureStore;

var _redux = __webpack_require__(182);

var _index = __webpack_require__(497);

var _index2 = _interopRequireDefault(_index);

var _createHashHistory = __webpack_require__(1148);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _reduxSaga = __webpack_require__(1152);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _index3 = __webpack_require__(1159);

var _index4 = _interopRequireDefault(_index3);

var _reactRouterRedux = __webpack_require__(316);

var _reduxThunk = __webpack_require__(1177);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxPersist = __webpack_require__(226);

var _storage = __webpack_require__(1184);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var nextRootReducer = __webpack_require__(497);

var persistConfig = exports.persistConfig = {
  key: 'root',
  storage: _storage2.default
};

var persistedReducer = (0, _reduxPersist.persistReducer)(persistConfig, _index2.default);

var history = (0, _createHashHistory2.default)();
var routeMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);
var sagaMiddleware = (0, _reduxSaga2.default)();

var middlewares = [sagaMiddleware, routeMiddleware, _reduxThunk2.default];

function configureStore(initialState) {
  var store = (0, _redux.createStore)(persistedReducer, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares)));

  sagaMiddleware.run(_index4.default);

  var persistor = (0, _reduxPersist.persistStore)(store);

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', function () {
      store.replaceReducer(nextRootReducer);
    });
  }
  return { store: store, persistor: persistor };
}
exports.history = history;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(persistConfig, 'persistConfig', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(configureStore, 'configureStore', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(persistedReducer, 'persistedReducer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(history, 'history', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(routeMiddleware, 'routeMiddleware', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(sagaMiddleware, 'sagaMiddleware', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(middlewares, 'middlewares', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_index2, '_index2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_createHashHistory2, '_createHashHistory2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_reduxSaga2, '_reduxSaga2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_index4, '_index4', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_reduxThunk2, '_reduxThunk2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_storage2, '_storage2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(persistConfig, 'persistConfig', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(persistedReducer, 'persistedReducer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(history, 'history', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(routeMiddleware, 'routeMiddleware', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(sagaMiddleware, 'sagaMiddleware', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(middlewares, 'middlewares', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(configureStore, 'configureStore', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/store/index.js');
}();

;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INDIGO = exports.INDIGO = "indigo";
var CYAN = exports.CYAN = "cyan";
var AMBER = exports.AMBER = "amber";
var DEEP_ORANGE = exports.DEEP_ORANGE = "deep-orange";
var PINK = exports.PINK = "pink";
var BLUE = exports.BLUE = "blue";
var DEEP_PURPLE = exports.DEEP_PURPLE = "deep-purple";
var GREEN = exports.GREEN = "green";

var DARK_INDIGO = exports.DARK_INDIGO = "dark-indigo";
var DARK_CYAN = exports.DARK_CYAN = "dark-cyan";
var DARK_AMBER = exports.DARK_AMBER = "dark-amber";
var DARK_DEEP_ORANGE = exports.DARK_DEEP_ORANGE = "dark-deep-orange";
var DARK_PINK = exports.DARK_PINK = "dark-pink";
var DARK_BLUE = exports.DARK_BLUE = "dark-blue";
var DARK_DEEP_PURPLE = exports.DARK_DEEP_PURPLE = "dark-deep-purple";
var DARK_GREEN = exports.DARK_GREEN = "dark-green";
var DARK_THEME_COLOR = exports.DARK_THEME_COLOR = "dark-theme";
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INDIGO, "INDIGO", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(CYAN, "CYAN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(AMBER, "AMBER", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_ORANGE, "DEEP_ORANGE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(PINK, "PINK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(BLUE, "BLUE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_PURPLE, "DEEP_PURPLE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(GREEN, "GREEN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_INDIGO, "DARK_INDIGO", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_CYAN, "DARK_CYAN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_AMBER, "DARK_AMBER", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_ORANGE, "DARK_DEEP_ORANGE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_PINK, "DARK_PINK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_BLUE, "DARK_BLUE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_PURPLE, "DARK_DEEP_PURPLE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_GREEN, "DARK_GREEN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_THEME_COLOR, "DARK_THEME_COLOR", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(INDIGO, "INDIGO", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(CYAN, "CYAN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(AMBER, "AMBER", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_ORANGE, "DEEP_ORANGE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(PINK, "PINK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(BLUE, "BLUE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DEEP_PURPLE, "DEEP_PURPLE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(GREEN, "GREEN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_INDIGO, "DARK_INDIGO", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_CYAN, "DARK_CYAN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_AMBER, "DARK_AMBER", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_ORANGE, "DARK_DEEP_ORANGE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_PINK, "DARK_PINK", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_BLUE, "DARK_BLUE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_DEEP_PURPLE, "DARK_DEEP_PURPLE", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_GREEN, "DARK_GREEN", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(DARK_THEME_COLOR, "DARK_THEME_COLOR", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/constants/ThemeColors.js");
}();

;

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.twitterAuthProvider = exports.facebookAuthProvider = exports.githubAuthProvider = exports.googleAuthProvider = exports.database = exports.auth = undefined;

var _firebase = __webpack_require__(1161);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// Initialize Firebase
var config = {
    apiKey: 'AIzaSyCYaTKjfam_qMXDnGfcdnBxScEq89VQtLk',
    authDomain: 'curious-sandbox-196209.firebaseapp.com',
    databaseURL: 'https://curious-sandbox-196209.firebaseio.com',
    projectId: 'curious-sandbox-196209',
    storageBucket: '',
    messagingSenderId: '1034032747860'
};

_firebase2.default.initializeApp(config);
var auth = _firebase2.default.auth();

var googleAuthProvider = new _firebase2.default.auth.GoogleAuthProvider();
var facebookAuthProvider = new _firebase2.default.auth.FacebookAuthProvider();
var githubAuthProvider = new _firebase2.default.auth.GithubAuthProvider();
var twitterAuthProvider = new _firebase2.default.auth.TwitterAuthProvider();

var database = _firebase2.default.database();
exports.auth = auth;
exports.database = database;
exports.googleAuthProvider = googleAuthProvider;
exports.githubAuthProvider = githubAuthProvider;
exports.facebookAuthProvider = facebookAuthProvider;
exports.twitterAuthProvider = twitterAuthProvider;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(config, 'config', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(auth, 'auth', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(googleAuthProvider, 'googleAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(facebookAuthProvider, 'facebookAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(githubAuthProvider, 'githubAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(twitterAuthProvider, 'twitterAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(database, 'database', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_firebase2, '_firebase2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(config, 'config', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(auth, 'auth', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(googleAuthProvider, 'googleAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(facebookAuthProvider, 'facebookAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(githubAuthProvider, 'githubAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(twitterAuthProvider, 'twitterAuthProvider', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(database, 'database', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/firebase/firebase.js');
}();

;

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistReducer", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(1179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistCombineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(1181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistStore", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(1182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMigrate", function() { return __WEBPACK_IMPORTED_MODULE_3__createMigrate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(1183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTransform", function() { return __WEBPACK_IMPORTED_MODULE_4__createTransform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getStoredState", function() { return __WEBPACK_IMPORTED_MODULE_5__getStoredState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createPersistoid", function() { return __WEBPACK_IMPORTED_MODULE_6__createPersistoid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(130);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "KEY_PREFIX", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FLUSH", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "REHYDRATE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PAUSE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PERSIST", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PURGE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "REGISTER", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_VERSION", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["a"]; });











/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(333);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

exports.default = pink;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(132);
var dPs = __webpack_require__(1224);
var enumBugKeys = __webpack_require__(336);
var IE_PROTO = __webpack_require__(334)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(510)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1225).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(74).f;
var has = __webpack_require__(134);
var TAG = __webpack_require__(66)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(131);
var call = __webpack_require__(528);
var isArrayIter = __webpack_require__(529);
var anObject = __webpack_require__(132);
var toLength = __webpack_require__(227);
var getIterFn = __webpack_require__(530);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(158);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(1267);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};

exports.default = deepOrange;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleCollapsedNav = toggleCollapsedNav;
exports.setDrawerType = setDrawerType;
exports.updateWindowWidth = updateWindowWidth;
exports.setThemeColor = setThemeColor;
exports.setDarkTheme = setDarkTheme;
exports.switchLanguage = switchLanguage;

var _ActionTypes = __webpack_require__(41);

function toggleCollapsedNav(isNavCollapsed) {
    return { type: _ActionTypes.TOGGLE_COLLAPSED_NAV, isNavCollapsed: isNavCollapsed };
}

function setDrawerType(drawerType) {
    return { type: _ActionTypes.DRAWER_TYPE, drawerType: drawerType };
}

function updateWindowWidth(width) {
    return { type: _ActionTypes.WINDOW_WIDTH, width: width };
}

function setThemeColor(color) {
    return { type: _ActionTypes.THEME_COLOR, color: color };
}

function setDarkTheme() {
    return { type: _ActionTypes.DARK_THEME };
}

function switchLanguage(locale) {
    return {
        type: _ActionTypes.SWITCH_LANGUAGE,
        payload: locale
    };
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(toggleCollapsedNav, 'toggleCollapsedNav', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(setDrawerType, 'setDrawerType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(updateWindowWidth, 'updateWindowWidth', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(setThemeColor, 'setThemeColor', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(setDarkTheme, 'setDarkTheme', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(switchLanguage, 'switchLanguage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(toggleCollapsedNav, 'toggleCollapsedNav', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(setDrawerType, 'setDrawerType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(updateWindowWidth, 'updateWindowWidth', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(setThemeColor, 'setThemeColor', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(setDarkTheme, 'setDarkTheme', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(switchLanguage, 'switchLanguage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Setting.js');
}();

;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = ownerWindow;

var _ownerDocument = _interopRequireDefault(__webpack_require__(76));

function ownerWindow(node) {
  var doc = (0, _ownerDocument.default)(node);
  return doc && doc.defaultView || doc.parentWindow;
}

module.exports = exports["default"];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(243));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1404);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

var _Backdrop = __webpack_require__(567);

Object.defineProperty(exports, 'Backdrop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Backdrop).default;
  }
});

var _ModalManager = __webpack_require__(565);

Object.defineProperty(exports, 'ModalManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1439);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1440);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(574);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(578);
exports.Duplex = __webpack_require__(139);
exports.Transform = __webpack_require__(580);
exports.PassThrough = __webpack_require__(1449);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 248 */
/***/ (function(module, exports) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps

//app deps

//begin module
/**
 * This is the exposed module.
 * This method determines if an object is undefined.
 *
 * @param {Object} value
 * @access public
 */
module.exports = function(value) {
   return typeof value === 'undefined' || value === null;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(204),
    createWrap = __webpack_require__(1554),
    getHolder = __webpack_require__(380),
    replaceHolders = __webpack_require__(252);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(287),
    isObject = __webpack_require__(105);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1590),
    listCacheDelete = __webpack_require__(1591),
    listCacheGet = __webpack_require__(1592),
    listCacheHas = __webpack_require__(1593),
    listCacheSet = __webpack_require__(1594);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(255);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1608);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(25);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableFooter__ = __webpack_require__(1767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableFooter__["a"]; });


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__ = __webpack_require__(264);
/* unused harmony reexport createGenerateClassName */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(796);
/* unused harmony reexport createStyles */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getThemeProps__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__getThemeProps__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jssPreset__ = __webpack_require__(406);
/* unused harmony reexport jssPreset */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__makeStyles__ = __webpack_require__(265);
/* unused harmony reexport makeStyles */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeClasses__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__mergeClasses__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__ = __webpack_require__(802);
/* unused harmony reexport ServerStyleSheets */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(804);
/* unused harmony reexport styled */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StylesProvider__ = __webpack_require__(266);
/* unused harmony reexport StylesProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(805);
/* unused harmony reexport ThemeProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useTheme__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__useTheme__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withStyles__ = __webpack_require__(806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__withStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withTheme__ = __webpack_require__(807);
/* unused harmony reexport withTheme */
/* unused harmony namespace reexport */
/** @license Material-UI v4.11.5
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */

/* Warning if there are several instances of @material-ui/styles */

if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://mui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}




























/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1774);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__ = __webpack_require__(1778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__["a"]; });


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyles__ = __webpack_require__(1793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__makeStyles__["a"]; });


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StylesProvider__ = __webpack_require__(800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["a"]; });



/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hexToRgb */
/* unused harmony export rgbToHex */
/* unused harmony export hslToRgb */
/* unused harmony export decomposeColor */
/* unused harmony export recomposeColor */
/* harmony export (immutable) */ __webpack_exports__["c"] = getContrastRatio;
/* unused harmony export getLuminance */
/* unused harmony export emphasize */
/* unused harmony export fade */
/* harmony export (immutable) */ __webpack_exports__["a"] = alpha;
/* harmony export (immutable) */ __webpack_exports__["b"] = darken;
/* harmony export (immutable) */ __webpack_exports__["d"] = lighten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(19);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
var warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.', '', "You should use `import { alpha } from '@material-ui/core/styles'`"].join('\n'));
    }
  }

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(19);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["a"] = (merge);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableBody__ = __webpack_require__(1829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableBody__["a"]; });


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableContainer__ = __webpack_require__(1831);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableContainer__["a"]; });


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableHead__ = __webpack_require__(1832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableHead__["a"]; });


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableSortLabel__ = __webpack_require__(1833);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableSortLabel__["a"]; });


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSvgIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgIcon__ = __webpack_require__(1835);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref
    }, props), path);
  };

  if (false) {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */].muiName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(Component));
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TablePagination__ = __webpack_require__(1841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TablePagination__["a"]; });


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputBase__ = __webpack_require__(1842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputBase__["a"]; });


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(809);



function useTheme() {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["c" /* useTheme */])() || __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */];

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableRow__ = __webpack_require__(1890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TableRow__["a"]; });


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' });

var Delete = function Delete(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Delete = (0, _pure2.default)(Delete);
Delete.muiName = 'SvgIcon';

exports.default = Delete;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' });

var FilterList = function FilterList(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

FilterList = (0, _pure2.default)(FilterList);
FilterList.muiName = 'SvgIcon';

exports.default = FilterList;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(417);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _InputAdornment = __webpack_require__(1979);

Object.defineProperty(exports, 'InputAdornment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputAdornment).default;
  }
});

var _InputLabel = __webpack_require__(1980);

Object.defineProperty(exports, 'InputLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.default = asyncComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nprogress = __webpack_require__(2039);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _reactPlaceholder = __webpack_require__(2040);

var _reactPlaceholder2 = _interopRequireDefault(_reactPlaceholder);

__webpack_require__(2045);

__webpack_require__(2047);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function asyncComponent(importComponent) {
  var AsyncFunc = function (_Component) {
    _inherits(AsyncFunc, _Component);

    function AsyncFunc(props) {
      _classCallCheck(this, AsyncFunc);

      var _this = _possibleConstructorReturn(this, (AsyncFunc.__proto__ || Object.getPrototypeOf(AsyncFunc)).call(this, props));

      _this.state = {
        component: null
      };
      return _this;
    }

    _createClass(AsyncFunc, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        _nprogress2.default.start();
      }
    }, {
      key: 'componentDidMount',
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _ref2, Component;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.mounted = true;
                  _context.next = 3;
                  return importComponent();

                case 3:
                  _ref2 = _context.sent;
                  Component = _ref2.default;

                  _nprogress2.default.done();
                  if (this.mounted) {
                    this.setState({
                      component: _react2.default.createElement(Component, this.props)
                    });
                  }

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function componentDidMount() {
          return _ref.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'render',
      value: function render() {
        var Component = this.state.component || _react2.default.createElement('div', null);
        return _react2.default.createElement(_reactPlaceholder2.default, { type: 'text', rows: 7, ready: Component !== null }, Component);
      }
    }]);

    return AsyncFunc;
  }(_react.Component);

  return AsyncFunc;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(asyncComponent, 'asyncComponent', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_nprogress2, "_nprogress2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_reactPlaceholder2, "_reactPlaceholder2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(asyncComponent, "asyncComponent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/AsyncFunc.js");
}();

;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = __webpack_require__(2035);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(900),
    createBaseEach = __webpack_require__(1587);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = __webpack_require__(1525);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Drawer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(423),
    toKey = __webpack_require__(205);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var document = __webpack_require__(20).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(68);
var LIBRARY = __webpack_require__(106);
var wksExt = __webpack_require__(438);
var defineProperty = __webpack_require__(36).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(175)('keys');
var uid = __webpack_require__(120);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(20).document;
module.exports = document && document.documentElement;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(18);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(69)(Function.call, __webpack_require__(63).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var setPrototypeOf = __webpack_require__(294).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(80);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 298 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(106);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(54);
var hide = __webpack_require__(53);
var Iterators = __webpack_require__(152);
var $iterCreate = __webpack_require__(301);
var setToStringTag = __webpack_require__(149);
var getPrototypeOf = __webpack_require__(64);
var ITERATOR = __webpack_require__(32)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(123);
var descriptor = __webpack_require__(119);
var setToStringTag = __webpack_require__(149);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(53)(IteratorPrototype, __webpack_require__(32)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(210);
var defined = __webpack_require__(80);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(32)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(152);
var ITERATOR = __webpack_require__(32)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(36);
var createDesc = __webpack_require__(119);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(150);
var ITERATOR = __webpack_require__(32)('iterator');
var Iterators = __webpack_require__(152);
module.exports = __webpack_require__(68).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(978);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(122);
var toLength = __webpack_require__(33);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(108);
var step = __webpack_require__(455);
var Iterators = __webpack_require__(152);
var toIObject = __webpack_require__(62);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(300)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(178);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(209)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(69);
var invoke = __webpack_require__(445);
var html = __webpack_require__(293);
var cel = __webpack_require__(289);
var global = __webpack_require__(20);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(70)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var macrotask = __webpack_require__(312).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(70)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(47);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(34);
var LIBRARY = __webpack_require__(106);
var $typed = __webpack_require__(216);
var hide = __webpack_require__(53);
var redefineAll = __webpack_require__(128);
var fails = __webpack_require__(23);
var anInstance = __webpack_require__(126);
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(33);
var toIndex = __webpack_require__(465);
var gOPN = __webpack_require__(124).f;
var dP = __webpack_require__(36).f;
var arrayFill = __webpack_require__(308);
var setToStringTag = __webpack_require__(149);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(1094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerReducer", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "push", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "go", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "goForward", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerActions", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middleware__ = __webpack_require__(1100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__middleware__["a"]; });








/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(221);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1120);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28), __webpack_require__(1119)(module)))

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(220);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(325);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = function () {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
};

var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            var err_1 = Error.apply(this, arguments);
            this.name = ERROR_NAME;
            // Make non-enumerable getter for the property.
            Object.defineProperty(this, 'stack', {
                get: function () {
                    return err_1.stack;
                }
            });
        }
    }
    return FirebaseError;
}());
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return (!!decoded.signature &&
        !!claims &&
        typeof claims === 'object' &&
        claims.hasOwnProperty('iat'));
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    tslib_1.__extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(Hash));

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.assert = assert;
exports.assertionError = assertionError;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.CONSTANTS = CONSTANTS;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
exports.Deferred = Deferred;
exports.getUA = getUA;
exports.isMobileCordova = isMobileCordova;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.patchCapture = patchCapture;
exports.jsonEval = jsonEval;
exports.stringify = stringify;
exports.decode = decode;
exports.isAdmin = isAdmin;
exports.issuedAtTime = issuedAtTime;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.clone = clone;
exports.contains = contains;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getValues = getValues;
exports.isEmpty = isEmpty;
exports.isNonNullObject = isNonNullObject;
exports.map = map;
exports.safeGet = safeGet;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.Sha1 = Sha1;
exports.async = async;
exports.createSubscribe = createSubscribe;
exports.errorPrefix = errorPrefix;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(506);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createGenerateClassName = __webpack_require__(507);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName).default;
  }
});

var _createMuiTheme = __webpack_require__(328);

Object.defineProperty(exports, 'createMuiTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createMuiTheme).default;
  }
});

var _jssPreset = __webpack_require__(516);

Object.defineProperty(exports, 'jssPreset', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jssPreset).default;
  }
});

var _MuiThemeProvider = __webpack_require__(1217);

Object.defineProperty(exports, 'MuiThemeProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MuiThemeProvider).default;
  }
});

var _withStyles = __webpack_require__(7);

Object.defineProperty(exports, 'withStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withStyles).default;
  }
});

var _withTheme = __webpack_require__(159);

Object.defineProperty(exports, 'withTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withTheme).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _deepmerge = __webpack_require__(231);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _createTypography = __webpack_require__(1194);

var _createTypography2 = _interopRequireDefault(_createTypography);

var _createBreakpoints = __webpack_require__(188);

var _createBreakpoints2 = _interopRequireDefault(_createBreakpoints);

var _createPalette = __webpack_require__(1195);

var _createPalette2 = _interopRequireDefault(_createPalette);

var _createMixins = __webpack_require__(1196);

var _createMixins2 = _interopRequireDefault(_createMixins);

var _shadows = __webpack_require__(1199);

var _shadows2 = _interopRequireDefault(_shadows);

var _transitions = __webpack_require__(112);

var _transitions2 = _interopRequireDefault(_transitions);

var _zIndex = __webpack_require__(1204);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _spacing = __webpack_require__(1205);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$palette = options.palette,
      paletteInput = _options$palette === undefined ? {} : _options$palette,
      _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === undefined ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === undefined ? {} : _options$mixins,
      _options$typography = options.typography,
      typographyInput = _options$typography === undefined ? {} : _options$typography,
      shadowsInput = options.shadows,
      other = (0, _objectWithoutProperties3.default)(options, ['palette', 'breakpoints', 'mixins', 'typography', 'shadows']);


  var palette = (0, _createPalette2.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints2.default)(breakpointsInput);

  var muiTheme = (0, _extends3.default)({
    direction: 'ltr',
    palette: palette,
    typography: (0, _createTypography2.default)(palette, typographyInput),
    mixins: (0, _createMixins2.default)(breakpoints, _spacing2.default, mixinsInput),
    breakpoints: breakpoints,
    shadows: shadowsInput || _shadows2.default
  }, (0, _deepmerge2.default)({
    transitions: _transitions2.default,
    spacing: _spacing2.default,
    zIndex: _zIndex2.default
  }, other));

   false ? (0, _warning2.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;

  return muiTheme;
} // < 1kb payload overhead when lodash/merge is > 3kb.
exports.default = createMuiTheme;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(99);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(331);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 331 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(335)('keys');
var uid = __webpack_require__(229);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(45);
var global = __webpack_require__(84);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(228) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 337 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

exports.default = indigo;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

exports.default = grey;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  black: '#000',
  white: '#fff'
};

exports.default = common;

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(157);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1220);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1228);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1222)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(345)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(228);
var $export = __webpack_require__(50);
var redefine = __webpack_require__(519);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(189);
var $iterCreate = __webpack_require__(1223);
var setToStringTag = __webpack_require__(234);
var getPrototypeOf = __webpack_require__(518);
var ITERATOR = __webpack_require__(66)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(66);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(229)('meta');
var isObject = __webpack_require__(99);
var has = __webpack_require__(134);
var setDesc = __webpack_require__(74).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(133)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(84);
var core = __webpack_require__(45);
var LIBRARY = __webpack_require__(228);
var wksExt = __webpack_require__(346);
var defineProperty = __webpack_require__(74).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANNEL = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Same value used by react-jss
var CHANNEL = exports.CHANNEL = '__THEMING__';

var themeListener = {
  contextTypes: (0, _defineProperty3.default)({}, CHANNEL, _propTypes2.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};

exports.default = themeListener;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(236);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(535);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(1299);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

exports.default = green;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};

exports.default = amber;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Avatar = __webpack_require__(551);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Avatar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(1379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CSSTransition", function() { return __WEBPACK_IMPORTED_MODULE_0__CSSTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(1383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaceTransition", function() { return __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(1385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SwitchTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transition", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_5__config__["a"]; });







/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* unused harmony export EXITED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(359);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["d"] = (Transition);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(1392),
    isObject = __webpack_require__(105),
    isSymbol = __webpack_require__(171);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(161);

var _Transition2 = _interopRequireDefault(_Transition);

var _transitions = __webpack_require__(112);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _utils = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Transition

var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/demos/modals) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = function (_React$Component) {
  (0, _inherits3.default)(Fade, _React$Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (node) {
      var theme = _this.props.theme;

      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      node.style.transition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      node.style.transition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Fade, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme']);


      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ appear: true, onEnter: this.handleEnter, onExit: this.handleExit }, other),
        function (state, childProps) {
          return _react2.default.cloneElement(children, (0, _extends3.default)({
            style: (0, _extends3.default)({
              opacity: 0
            }, styles[state], style)
          }, childProps));
        }
      );
    }
  }]);
  return Fade;
}(_react2.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Fade);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
var events = __webpack_require__(95);
var inherits = __webpack_require__(245).inherits;

//npm deps
var mqtt = __webpack_require__(1441);
var crypto = __webpack_require__(1471);

//app deps
var exceptions = __webpack_require__(1495);
var isUndefined = __webpack_require__(248);
var tlsReader = __webpack_require__(1496);
var path = __webpack_require__(1498);
var fs = __webpack_require__(370);

//begin module
function makeTwoDigits(n) {
   if (n > 9) {
      return n;
   } else {
      return '0' + n;
   }
}

function getDateTimeString() {
   var d = new Date();

   //
   // The additional ''s are used to force JavaScript to interpret the
   // '+' operator as string concatenation rather than arithmetic.
   //
   return d.getUTCFullYear() + '' +
      makeTwoDigits(d.getUTCMonth() + 1) + '' +
      makeTwoDigits(d.getUTCDate()) + 'T' + '' +
      makeTwoDigits(d.getUTCHours()) + '' +
      makeTwoDigits(d.getUTCMinutes()) + '' +
      makeTwoDigits(d.getUTCSeconds()) + 'Z';
}

function getDateString(dateTimeString) {
   return dateTimeString.substring(0, dateTimeString.indexOf('T'));
}

function getSignatureKey(key, dateStamp, regionName, serviceName) {
   var kDate = crypto.HmacSHA256(dateStamp, 'AWS4' + key, {
      asBytes: true
   });
   var kRegion = crypto.HmacSHA256(regionName, kDate, {
      asBytes: true
   });
   var kService = crypto.HmacSHA256(serviceName, kRegion, {
      asBytes: true
   });
   var kSigning = crypto.HmacSHA256('aws4_request', kService, {
      asBytes: true
   });
   return kSigning;
}

function signUrl(method, scheme, hostname, path, queryParams, accessId, secretKey,
   region, serviceName, payload, today, now, debug, awsSTSToken) {

   var signedHeaders = 'host';

   var canonicalHeaders = 'host:' + hostname.toLowerCase() + '\n';

   var canonicalRequest = method + '\n' + // method
      path + '\n' + // path
      queryParams + '\n' + // query params
      canonicalHeaders + // headers
      '\n' + // required
      signedHeaders + '\n' + // signed header list
      crypto.SHA256(payload, {
         asBytes: true
      }); // hash of payload (empty string)

   if (debug === true) {
      console.log('canonical request: ' + canonicalRequest + '\n');
   }

   var hashedCanonicalRequest = crypto.SHA256(canonicalRequest, {
      asBytes: true
   });

   if (debug === true) {
      console.log('hashed canonical request: ' + hashedCanonicalRequest + '\n');
   }

   var stringToSign = 'AWS4-HMAC-SHA256\n' +
      now + '\n' +
      today + '/' + region + '/' + serviceName + '/aws4_request\n' +
      hashedCanonicalRequest;

   if (debug === true) {
      console.log('string to sign: ' + stringToSign + '\n');
   }

   var signingKey = getSignatureKey(secretKey, today, region, serviceName);

   if (debug === true) {
      console.log('signing key: ' + signingKey + '\n');
   }

   var signature = crypto.HmacSHA256(stringToSign, signingKey, {
      asBytes: true
   });

   if (debug === true) {
      console.log('signature: ' + signature + '\n');
   }

   var finalParams = queryParams + '&X-Amz-Signature=' + signature;

   if (!isUndefined(awsSTSToken)) {
      finalParams += '&X-Amz-Security-Token=' + encodeURIComponent(awsSTSToken);
   }

   var url = scheme + hostname + path + '?' + finalParams;

   if (debug === true) {
      console.log('url: ' + url + '\n');
   }

   return url;
}

function prepareWebSocketUrl(options, awsAccessId, awsSecretKey, awsSTSToken) {
   var now = getDateTimeString();
   var today = getDateString(now);
   var path = '/mqtt';
   var awsServiceName = 'iotdevicegateway';
   var queryParams = 'X-Amz-Algorithm=AWS4-HMAC-SHA256' +
      '&X-Amz-Credential=' + awsAccessId + '%2F' + today + '%2F' + options.region + '%2F' + awsServiceName + '%2Faws4_request' +
      '&X-Amz-Date=' + now +
      '&X-Amz-SignedHeaders=host';
   var hostName = options.host;

   // Include the port number in the hostname if it's not 
   // the standard wss port (443).
   //
   if (!isUndefined(options.port) && options.port !== 443) {
      hostName = options.host + ':' + options.port;
   }
   return signUrl('GET', 'wss://', hostName, path, queryParams,
      awsAccessId, awsSecretKey, options.region, awsServiceName, '', today, now, options.debug, awsSTSToken);
}

function prepareWebSocketCustomAuthUrl(options) {
   var path = '/mqtt';
   var hostName = options.host;

   // Include the port number in the hostname if it's not 
   // the standard wss port (443).
   //
   if (!isUndefined(options.port) && options.port !== 443) {
      hostName = options.host + ':' + options.port;
   }

   return 'wss://' + hostName + path;
}

function arrayEach(array, iterFunction) {
    for (var idx in array) {
        if (Object.prototype.hasOwnProperty.call(array, idx)) {
            iterFunction.call(this, array[idx], parseInt(idx, 10));
        }
    }
}

function getCredentials(ini) {
    //Get shared credential function from AWS SDK.
    var map = {};
    var currentSection ={};
    arrayEach(ini.split(/\r?\n/), function(line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
    });
    return map;
}

//
// This method is the exposed module; it validates the mqtt options,
// creates a secure mqtt connection via TLS, and returns the mqtt
// connection instance.
//
function DeviceClient(options) {
   //
   // Force instantiation using the 'new' operator; this will cause inherited
   // constructors (e.g. the 'events' class) to be called.
   //
   if (!(this instanceof DeviceClient)) {
      return new DeviceClient(options);
   }
   //
   // A copy of 'this' for use inside of closures
   //
   var that = this;

   //
   // Offline Operation
   //
   // The connection to AWS IoT can be in one of three states:
   //
   //   1) Inactive
   //   2) Established
   //   3) Stable
   //
   // During state 1), publish operations are placed in a queue
   // ("filling")
   //
   // During states 2) and 3), any operations present in the queue
   // are sent to the mqtt client for completion ("draining").
   //
   // In all states, subscriptions are tracked in a cache
   //
   // A "draining interval" is used to specify the rate at which
   // which operations are drained from the queue.
   //
   //    +- - - - - - - - - - - - - - - - - - - - - - - - +
   //    |                                                |
   //                                                      
   //    |                    FILLING                     |         
   //                                                      
   //    |                                                |
   //              +-----------------------------+         
   //    |         |                             |        |
   //              |                             |         
   //    |         v                             |        |
   //    +- - Established                     Inactive - -+
   //    |         |                             ^        |
   //              |                             |         
   //    |         |                             |        |
   //              +----------> Stable ----------+        
   //    |                                                |
   //                                                      
   //    |                     DRAINING                   |         
   //                                                      
   //    |                                                |
   //    +- - - - - - - - - - - - - - - - - - - - - - - - +
   //
   //
   // Draining Operation
   //
   // During draining, existing subscriptions are re-sent,
   // followed by any publishes which occurred while offline.
   //    

   //
   // Publish cache used during filling
   //
   var offlinePublishQueue = [];
   var offlineQueueing = true;
   var offlineQueueMaxSize = 0;
   var offlineQueueDropBehavior = 'oldest'; // oldest or newest
   offlinePublishQueue.length = 0;

   //
   // Subscription queue for subscribe/unsubscribe requests received when offline
   // We do not want an unbounded queue so for now limit to current max subs in AWS IoT
   //
   var offlineSubscriptionQueue = [];
   var offlineSubscriptionQueueMaxSize = 50;
   offlineSubscriptionQueue.length = 0;

   //
   // Subscription cache; active if autoResubscribe === true
   //
   var activeSubscriptions = [];
   var autoResubscribe = true;
   activeSubscriptions.length = 0;

   //
   // Cloned subscription cache; active during initial draining.
   //
   var clonedSubscriptions = [];
   clonedSubscriptions.length = 0;

   //
   // Contains the operational state of the connection
   //
   var connectionState = 'inactive';

   //
   // Used to time draining operations; active during draining.
   //
   var drainingTimer = null;
   var drainTimeMs = 250;

   //Default keep alive time interval in seconds.
   var defaultKeepalive = 300;
   //
   // These properties control the reconnect behavior of the MQTT Client.  If 
   // the MQTT client becomes disconnected, it will attempt to reconnect after 
   // a quiet period; this quiet period doubles with each reconnection attempt,
   // e.g. 1 seconds, 2 seconds, 2, 8, 16, 32, etc... up until a maximum 
   // reconnection time is reached.
   //
   // If a connection is active for the minimum connection time, the quiet 
   // period is reset to the initial value.
   //
   // baseReconnectTime: the time in seconds to wait before the first 
   //     reconnect attempt
   //
   // minimumConnectionTime: the time in seconds that a connection must be 
   //     active before resetting the current reconnection time to the base 
   //     reconnection time
   //
   // maximumReconnectTime: the maximum time in seconds to wait between 
   //     reconnect attempts
   //
   // The defaults for these values are:
   //
   // baseReconnectTime: 1 seconds
   // minimumConnectionTime: 20 seconds
   // maximumReconnectTime: 128 seconds
   //
   var baseReconnectTimeMs = 1000;
   var minimumConnectionTimeMs = 20000;
   var maximumReconnectTimeMs = 128000;
   var currentReconnectTimeMs;

   //
   // Used to measure the length of time the connection has been active to
   // know if it's stable or not.  Active beginning from receipt of a 'connect'
   // event (e.g. received CONNACK) until 'minimumConnectionTimeMs' has elapsed.
   //
   var connectionTimer = null;

   //
   // Credentials when authenticating via WebSocket/SigV4
   //
   var awsAccessId;
   var awsSecretKey;
   var awsSTSToken;
   //
   // Validate options, set default reconnect period if not specified.
   //
   var metricPrefix = "?SDK=JavaScript&Version=";
   var pjson = __webpack_require__(1499);
   var sdkVersion = pjson.version;
   var defaultUsername = metricPrefix + sdkVersion;

   if (isUndefined(options) ||
      Object.keys(options).length === 0) {
      throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
   }
   if (isUndefined(options.keepalive)) {
      options.keepalive = defaultKeepalive;
   }
   //
   // Metrics will be enabled by default unless the user explicitly disables it
   //
   if (isUndefined(options.enableMetrics) || options.enableMetrics === true){
      if (isUndefined(options.username)) {
         options.username = defaultUsername;
      } else {
         options.username += defaultUsername;
      }
   }
   if (!isUndefined(options.baseReconnectTimeMs)) {
      baseReconnectTimeMs = options.baseReconnectTimeMs;
   }
   if (!isUndefined(options.minimumConnectionTimeMs)) {
      minimumConnectionTimeMs = options.minimumConnectionTimeMs;
   }
   if (!isUndefined(options.maximumReconnectTimeMs)) {
      maximumReconnectTimeMs = options.maximumReconnectTimeMs;
   }
   if (!isUndefined(options.drainTimeMs)) {
      drainTimeMs = options.drainTimeMs;
   }
   if (!isUndefined(options.autoResubscribe)) {
      autoResubscribe = options.autoResubscribe;
   }
   if (!isUndefined(options.offlineQueueing)) {
      offlineQueueing = options.offlineQueueing;
   }
   if (!isUndefined(options.offlineQueueMaxSize)) {
      offlineQueueMaxSize = options.offlineQueueMaxSize;
   }
   if (!isUndefined(options.offlineQueueDropBehavior)) {
      offlineQueueDropBehavior = options.offlineQueueDropBehavior;
   }
   currentReconnectTimeMs = baseReconnectTimeMs;
   options.reconnectPeriod = currentReconnectTimeMs;
   options.fastDisconnectDetection = true;
   //
   //SDK has its own logic to deal with auto resubscribe
   //
   options.resubscribe = false;

   //
   // Verify that the reconnection timing parameters make sense.
   //
   if (options.baseReconnectTimeMs <= 0) {
      throw new Error(exceptions.INVALID_RECONNECT_TIMING);
   }
   if (maximumReconnectTimeMs < baseReconnectTimeMs) {
      throw new Error(exceptions.INVALID_RECONNECT_TIMING);
   }
   if (minimumConnectionTimeMs < baseReconnectTimeMs) {
      throw new Error(exceptions.INVALID_RECONNECT_TIMING);
   }
   //
   // Verify that the other optional parameters make sense.
   //
   if (offlineQueueDropBehavior !== 'newest' &&
      offlineQueueDropBehavior !== 'oldest') {
      throw new Error(exceptions.INVALID_OFFLINE_QUEUEING_PARAMETERS);
   }
   if (offlineQueueMaxSize < 0) {
      throw new Error(exceptions.INVALID_OFFLINE_QUEUEING_PARAMETERS);
   }

   // set protocol, do not override existing definitions if available
   if (isUndefined(options.protocol)) {
      options.protocol = 'mqtts';
   }

   if (isUndefined(options.host)) {
      throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
   }

   if (options.protocol === 'mqtts') {
      // set port, do not override existing definitions if available
      if (isUndefined(options.port)) {
         options.port = 8883;
      }

      //read and map certificates
      tlsReader(options);
   } else if (options.protocol === 'wss' || options.protocol === 'wss-custom-auth') {
      if (options.protocol === 'wss') {
         //
         // AWS access id and secret key 
         // It first check Input options and Environment variables 
         // If that not available, it will try to load credentials from default credential file
         if (!isUndefined(options.accessKeyId)) {
            awsAccessId = options.accessKeyId;
         } else {
            awsAccessId = process.env.AWS_ACCESS_KEY_ID;
         }
         if (!isUndefined(options.secretKey)) {
            awsSecretKey = options.secretKey;
         } else {
            awsSecretKey = process.env.AWS_SECRET_ACCESS_KEY;
         }
         if (!isUndefined(options.sessionToken)) {
            awsSTSToken = options.sessionToken;
         } else {
            awsSTSToken = process.env.AWS_SESSION_TOKEN;
         }
         if (isUndefined(awsAccessId) || isUndefined(awsSecretKey)) {
            var filename;
            try {
               if (!isUndefined(options.filename)) {
                  filename = options.filename;
               } else {
                  filename = _loadDefaultFilename();
               }
               var user_profile = options.profile || process.env.AWS_PROFILE || 'default';
               var creds = getCredentials(fs.readFileSync(filename, 'utf-8'));
               var profile = creds[user_profile];
               awsAccessId = profile.aws_access_key_id;
               awsSecretKey = profile.aws_secret_access_key;
               awsSTSToken = profile.aws_session_token;
            } catch (e) {
               console.log(e);
               console.log('Failed to read credentials from ' + filename);
            }
         }
         // AWS Access Key ID and AWS Secret Key must be defined
         if (isUndefined(awsAccessId) || (isUndefined(awsSecretKey))) {
            console.log('To connect via WebSocket/SigV4, AWS Access Key ID and AWS Secret Key must be passed either in options or as environment variables; see README.md');
            throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
         }
      } else {
         if (isUndefined(options.customAuthHeaders)) {
            console.log('To authenticate with a custom authorizer, you must provide the required HTTP headers; see README.md');
            throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
         }
      }

      if (!isUndefined(options.host) && isUndefined(options.region)) {
         var pattern = /[a-zA-Z0-9]+\.iot\.([a-z]+-[a-z]+-[0-9]+)\.amazonaws\..+/;
         var region = pattern.exec(options.host);
         if (region === null) {
            console.log('Host endpoint is not valid');
            throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
         } else {
            options.region = region[1];
         }
      }
      // set port, do not override existing definitions if available
      if (isUndefined(options.port)) {
         options.port = 443;
      }
      // check websocketOptions and ensure that the protocol is defined
      if (isUndefined(options.websocketOptions)) {
         options.websocketOptions = {
            protocol: 'mqttv3.1'
         };
      } else {
         options.websocketOptions.protocol = 'mqttv3.1';
      }

      if (options.protocol === 'wss-custom-auth') {
         options.websocketOptions.headers = options.customAuthHeaders;
      }
   } 

   if ((!isUndefined(options)) && (options.debug === true)) {
      console.log(options);
      console.log('attempting new mqtt connection...');
   }
   //connect and return the client instance to map all mqttjs apis

   var protocols = {};
   protocols.mqtts = __webpack_require__(1500);
   protocols.wss = __webpack_require__(1501);

   function _loadDefaultFilename() {
      var home = process.env.HOME ||
           process.env.USERPROFILE || 
           (process.env.HOMEPATH ? ((process.env.HOMEDRIVE || 'C:/') + process.env.HOMEPATH) : null);
      return path.join(home, '.aws', 'credentials');

   }
   function _addToSubscriptionCache(topic, options) {
      var matches = activeSubscriptions.filter(function(element) {
         return element.topic === topic;
      });
      //
      // Add the element only if it doesn't already exist.
      //
      if (matches.length === 0) {
         activeSubscriptions.push({
            topic: topic,
            options: options
         });
      }
   }

   function _deleteFromSubscriptionCache(topic, options) {
      var remaining = activeSubscriptions.filter(function(element) {
         return element.topic !== topic;
      });
      activeSubscriptions = remaining;
   }

   function _updateSubscriptionCache(operation, topics, options) {
      var opFunc = null;

      //
      // Don't cache subscriptions if auto-resubscribe is disabled
      // 
      if (autoResubscribe === false) {
         return;
      }
      if (operation === 'subscribe') {
         opFunc = _addToSubscriptionCache;
      } else if (operation === 'unsubscribe') {
         opFunc = _deleteFromSubscriptionCache;
      }
      //
      // Test to see if 'topics' is an array and if so, iterate.
      //
      if (Object.prototype.toString.call(topics) === '[object Array]') {
         topics.forEach(function(item, index, array) {
            opFunc(item, options);
         });
      } else {
         opFunc(topics, options);
      }
   }

   //
   // Return true if the connection is currently in a 'filling' 
   // state
   //
   function _filling() {
      return connectionState === 'inactive';
   }

   function _wrapper(client) {
      var protocol = options.protocol;
      if (protocol === 'wss') {
         var url;
         //
         // If the access id and secret key are available, prepare the URL. 
         // Otherwise, set the url to an invalid value.
         //
         if (awsAccessId === '' || awsSecretKey === '') {
            url = 'wss://no-credentials-available';
         } else {
            url = prepareWebSocketUrl(options, awsAccessId, awsSecretKey, awsSTSToken);
         }

         if (options.debug === true) {
            console.log('using websockets, will connect to \'' + url + '\'...');
         }

         options.url = url;
      } else if (protocol === 'wss-custom-auth') {
         options.url = prepareWebSocketCustomAuthUrl(options);
         if (options.debug === true) {
            console.log('using websockets custom auth, will connect to \'' + options.url + '\'...');
         }
         // Treat the request as a standard websocket request from here onwards
         protocol = 'wss';
      }
      return protocols[protocol](client, options);
   }

   var device = new mqtt.MqttClient(_wrapper, options);

   //handle events from the mqtt client

   //
   // Timeout expiry function for the connection timer; once a connection
   // is stable, reset the current reconnection time to the base value. 
   //
   function _markConnectionStable() {
      currentReconnectTimeMs = baseReconnectTimeMs;
      device.options.reconnectPeriod = currentReconnectTimeMs;
      //
      // Mark this timeout as expired
      //
      connectionTimer = null;
      connectionState = 'stable';
   }
   //
   // Trim the offline queue if required; returns true if another
   // element can be placed in the queue
   //
   function _trimOfflinePublishQueueIfNecessary() {
      var rc = true;

      if ((offlineQueueMaxSize > 0) &&
         (offlinePublishQueue.length >= offlineQueueMaxSize)) {
         //
         // The queue has reached its maximum size, trim it
         // according to the defined drop behavior.
         //
         if (offlineQueueDropBehavior === 'oldest') {
            offlinePublishQueue.shift();
         } else {
            rc = false;
         }
      }
      return rc;
   }

   //
   // Timeout expiry function for the drain timer; once a connection
   // has been established, begin draining cached transactions.
   //
   function _drainOperationQueue() {

      //
      // Handle our active subscriptions first, using a cloned
      // copy of the array.  We shift them out one-by-one until
      // all have been processed, leaving the official record
      // of active subscriptions untouched.
      // 
      var subscription = clonedSubscriptions.shift();

      if (!isUndefined(subscription)) {
         //
         // If the 3rd argument (namely callback) is not present, we will
         // use two-argument form to call mqtt.Client#subscribe(), which
         // supports both subscribe(topics, options) and subscribe(topics, callback).
         //
         if (!isUndefined(subscription.callback)) {
            device.subscribe(subscription.topic, subscription.options, subscription.callback);
         } else {
            device.subscribe(subscription.topic, subscription.options);
         }
      } else {
         //
         // If no remaining active subscriptions to process,
         // then handle subscription requests queued while offline.
         //
         var req = offlineSubscriptionQueue.shift();

         if (!isUndefined(req)) {
            _updateSubscriptionCache(req.type, req.topics, req.options);
            if (req.type === 'subscribe') {
               if (!isUndefined(req.callback)) {
                  device.subscribe(req.topics, req.options, req.callback);
               } else {
                  device.subscribe(req.topics, req.options);
               }
            } else if (req.type === 'unsubscribe') {
               device.unsubscribe(req.topics, req.callback);
            }
         } else {
            //
            // If no active or queued subscriptions remaining to process,
            // then handle queued publish operations.
            //
            var offlinePublishMessage = offlinePublishQueue.shift();

            if (!isUndefined(offlinePublishMessage)) {
               device.publish(offlinePublishMessage.topic,
                  offlinePublishMessage.message,
                  offlinePublishMessage.options,
                  offlinePublishMessage.callback);
            }
            if (offlinePublishQueue.length === 0) {
               //
               // The subscription and offlinePublishQueue queues are fully drained,
               // cancel the draining timer.
               //
               clearInterval(drainingTimer);
               drainingTimer = null;
            }
         }
      }
   }
   //
   // Event handling - *all* events generated by the mqtt.js client must be
   // handled here, *and* propagated upwards.
   //

   device.on('connect', function(connack) {
      //
      // If not already running, start the connection timer.
      //
      if (connectionTimer === null) {
         connectionTimer = setTimeout(_markConnectionStable,
            minimumConnectionTimeMs);
      }
      connectionState = 'established';
      //
      // If not already running, start the draining timer and 
      // clone the active subscriptions.
      //
      if (drainingTimer === null) {
         clonedSubscriptions = activeSubscriptions.slice(0);
         drainingTimer = setInterval(_drainOperationQueue,
            drainTimeMs);
      }
      that.emit('connect', connack);
   });
   device.on('close', function(err) {
      if (!isUndefined(err)) {
         that.emit('error', err);
      }
      if ((!isUndefined(options)) && (options.debug === true)) {
         console.log('connection lost - will attempt reconnection in ' +
            device.options.reconnectPeriod / 1000 + ' seconds...');
      }
      //
      // Clear the connection and drain timers
      //
      clearTimeout(connectionTimer);
      connectionTimer = null;
      clearInterval(drainingTimer);
      drainingTimer = null;

      //
      // Mark the connection state as inactive
      //
      connectionState = 'inactive';

      that.emit('close');
   });
   device.on('reconnect', function() {
      //
      // Update the current reconnect timeout; this will be the
      // next timeout value used if this connect attempt fails.
      // 
      currentReconnectTimeMs = currentReconnectTimeMs * 2;
      currentReconnectTimeMs = Math.min(maximumReconnectTimeMs, currentReconnectTimeMs);
      device.options.reconnectPeriod = currentReconnectTimeMs;

      that.emit('reconnect');
   });
   device.on('offline', function() {
      that.emit('offline');
   });
   device.on('error', function(error) {
      that.emit('error', error);
   });
   device.on('packetsend', function(packet) {
      that.emit('packetsend', packet);
   });
   device.on('packetreceive', function(packet) {
      that.emit('packetreceive', packet);
   });
   device.on('message', function(topic, message, packet) {
      that.emit('message', topic, message, packet);
   });
   //
   // The signatures of these methods *must* match those of the mqtt.js
   // client.
   //
   this.publish = function(topic, message, options, callback) {
      //
      // If filling or still draining, push this publish operation 
      // into the offline operations queue; otherwise, perform it
      // immediately.
      //
      if (offlineQueueing === true && (_filling() || drainingTimer !== null)) {
         if (_trimOfflinePublishQueueIfNecessary()) {
            offlinePublishQueue.push({
               topic: topic,
               message: message,
               options: options,
               callback: callback
            });
         }
      } else {
         if (offlineQueueing === true || !_filling()) {
            device.publish(topic, message, options, callback);
         }
      }
   };
   this.subscribe = function(topics, options, callback) {
      if (!_filling() || autoResubscribe === false) {
         _updateSubscriptionCache('subscribe', topics, options); // we do not store callback in active cache
         //
         // If the 3rd argument (namely callback) is not present, we will
         // use two-argument form to call mqtt.Client#subscribe(), which
         // supports both subscribe(topics, options) and subscribe(topics, callback).
         //
         if (!isUndefined(callback)) {
            device.subscribe(topics, options, callback);
         } else {
            device.subscribe(topics, options);
         } 
      } else {
         // we're offline - queue this subscription request
         if (offlineSubscriptionQueue.length < offlineSubscriptionQueueMaxSize) {
            offlineSubscriptionQueue.push({
               type: 'subscribe',
               topics: topics,
               options: options,
               callback: callback
            });
         } else {
            that.emit('error', new Error('Maximum queued offline subscription reached'));
         }
      }
   };
   this.unsubscribe = function(topics, callback) {
      if (!_filling() || autoResubscribe === false) {
         _updateSubscriptionCache('unsubscribe', topics);
         device.unsubscribe(topics, callback);
      } else {
         // we're offline - queue this unsubscribe request
         if (offlineSubscriptionQueue.length < offlineSubscriptionQueueMaxSize) {
            offlineSubscriptionQueue.push({
               type: 'unsubscribe',
               topics: topics,
               options: options,
               callback: callback
            });
         }
      }
   };
   this.end = function(force, callback) {
      device.end(force, callback);
   };

   this.handleMessage = device.handleMessage.bind(device);

   device.handleMessage = function(packet, callback) {
      that.handleMessage(packet, callback);
   };

   this.updateWebSocketCredentials = function(accessKeyId, secretKey, sessionToken, expiration) {
      awsAccessId = accessKeyId;
      awsSecretKey = secretKey;
      awsSTSToken = sessionToken;
   };
   this.getWebsocketHeaders = function() {
      return options.websocketOptions.headers;
   };
   //
   // Call this function to update the custom auth headers
   //
   this.updateCustomAuthHeaders = function(newHeaders) {
      options.websocketOptions.headers = newHeaders;
   };
   //
   // Used for integration testing only
   //
   this.simulateNetworkFailure = function() {
      device.stream.emit('error', new Error('simulated connection error'));
      device.stream.end();
   };
}

//
// Allow instances to listen in on events that we produce for them
//
inherits(DeviceClient, events.EventEmitter);

module.exports = DeviceClient;
module.exports.DeviceClient = DeviceClient;

//
// Exported for unit testing only
//
module.exports.prepareWebSocketUrl = prepareWebSocketUrl;
module.exports.prepareWebSocketCustomAuthUrl = prepareWebSocketCustomAuthUrl;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1461);
var util = __webpack_require__(1462);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(1463);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tls = __webpack_require__(1467)

function buildBuilder (mqttClient, opts) {
  var connection
  opts.port = opts.port || 8883
  opts.host = opts.hostname || opts.host || 'localhost'

  opts.rejectUnauthorized = opts.rejectUnauthorized !== false

  delete opts.path

  connection = tls.connect(opts)
  /* eslint no-use-before-define: [2, "nofunc"] */
  connection.on('secureConnect', function () {
    if (opts.rejectUnauthorized && !connection.authorized) {
      connection.emit('error', new Error('TLS not authorized'))
    } else {
      connection.removeListener('error', handleTLSerrors)
    }
  })

  function handleTLSerrors (err) {
    // How can I get verify this error is a tls error?
    if (opts.rejectUnauthorized) {
      mqttClient.emit('error', err)
    }

    // close this connection to match the behaviour of net
    // otherwise all we get is an error from the connection
    // and close event doesn't fire. This is a work around
    // to enable the reconnect code to work the same as with
    // net.createConnection
    connection.end()
  }

  connection.on('error', handleTLSerrors)
  return connection
}

module.exports = buildBuilder


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {

var Transform = __webpack_require__(246).Transform
var duplexify = __webpack_require__(1468)
var WS = __webpack_require__(1470)
var Buffer = __webpack_require__(89).Buffer

module.exports = WebSocketStream

function buildProxy (options, socketWrite, socketEnd) {
  var proxy = new Transform({
    objectMode: options.objectMode
  })

  proxy._write = socketWrite
  proxy._flush = socketEnd

  return proxy
}

function WebSocketStream(target, protocols, options) {
  var stream, socket

  var isBrowser = process.title === 'browser'
  var isNative = !!global.WebSocket
  var socketWrite = isBrowser ? socketWriteBrowser : socketWriteNode

  if (protocols && !Array.isArray(protocols) && 'object' === typeof protocols) {
    // accept the "options" Object as the 2nd argument
    options = protocols
    protocols = null

    if (typeof options.protocol === 'string' || Array.isArray(options.protocol)) {
      protocols = options.protocol;
    }
  }

  if (!options) options = {}

  if (options.objectMode === undefined) {
    options.objectMode = !(options.binary === true || options.binary === undefined)
  }

  var proxy = buildProxy(options, socketWrite, socketEnd)

  if (!options.objectMode) {
    proxy._writev = writev
  }

  // browser only: sets the maximum socket buffer size before throttling
  var bufferSize = options.browserBufferSize || 1024 * 512

  // browser only: how long to wait when throttling
  var bufferTimeout = options.browserBufferTimeout || 1000

  // use existing WebSocket object that was passed in
  if (typeof target === 'object') {
    socket = target
  // otherwise make a new one
  } else {
    // special constructor treatment for native websockets in browsers, see
    // https://github.com/maxogden/websocket-stream/issues/82
    if (isNative && isBrowser) {
      socket = new WS(target, protocols)
    } else {
      socket = new WS(target, protocols, options)
    }

    socket.binaryType = 'arraybuffer'
  }
  
  // according to https://github.com/baygeldin/ws-streamify/issues/1
  // Nodejs WebSocketServer cause memory leak
  // Handlers like onerror, onclose, onmessage and onopen are accessible via setter/getter
  // And setter first of all fires removeAllListeners, that doesnt make inner array of clients on WebSocketServer cleared ever
  var eventListenerSupport = ('undefined' === typeof socket.addEventListener)

  // was already open when passed in
  if (socket.readyState === socket.OPEN) {
    stream = proxy
  } else {
    stream = stream = duplexify(undefined, undefined, options)
    if (!options.objectMode) {
      stream._writev = writev
    }
    
    if (eventListenerSupport) {
       socket.addEventListener('open', onopen)
    } else {
       socket.onopen = onopen
    }
  }

  stream.socket = socket

  if (eventListenerSupport) {
     socket.addEventListener('close', onclose)
     socket.addEventListener('error', onerror)
     socket.addEventListener('message', onmessage)
  } else {
     socket.onclose = onclose
     socket.onerror = onerror
     socket.onmessage = onmessage
  }

  proxy.on('close', destroy)

  var coerceToBuffer = !options.objectMode

  function socketWriteNode(chunk, enc, next) {
    // avoid errors, this never happens unless
    // destroy() is called
    if (socket.readyState !== socket.OPEN) {
      next()
      return
    }

    if (coerceToBuffer && typeof chunk === 'string') {
      chunk = Buffer.from(chunk, 'utf8')
    }
    socket.send(chunk, next)
  }

  function socketWriteBrowser(chunk, enc, next) {
    if (socket.bufferedAmount > bufferSize) {
      setTimeout(socketWriteBrowser, bufferTimeout, chunk, enc, next)
      return
    }

    if (coerceToBuffer && typeof chunk === 'string') {
      chunk = Buffer.from(chunk, 'utf8')
    }

    try {
      socket.send(chunk)
    } catch(err) {
      return next(err)
    }

    next()
  }

  function socketEnd(done) {
    socket.close()
    done()
  }

  function onopen() {
    stream.setReadable(proxy)
    stream.setWritable(proxy)
    stream.emit('connect')
  }

  function onclose() {
    stream.end()
    stream.destroy()
  }

  function onerror(err) {
    stream.destroy(err)
  }

  function onmessage(event) {
    var data = event.data
    if (data instanceof ArrayBuffer) data = Buffer.from(data)
    else data = Buffer.from(data, 'utf8')
    proxy.push(data)
  }

  function destroy() {
    socket.close()
  }

  // this is to be enabled only if objectMode is false
  function writev (chunks, cb) {
    var buffers = new Array(chunks.length)
    for (var i = 0; i < chunks.length; i++) {
      if (typeof chunks[i].chunk === 'string') {
        buffers[i] = Buffer.from(chunks[i], 'utf8')
      } else {
        buffers[i] = chunks[i].chunk
      }
    }

    this._write(Buffer.concat(buffers), 'binary', cb)
  }

  return stream
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43), __webpack_require__(28)))

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 370 */
/***/ (function(module, exports) {



/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(67);
var normalizeHeaderName = __webpack_require__(1508);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(590);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(590);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.setTranslateValue = setTranslateValue;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _Transition = __webpack_require__(161);

var _Transition2 = _interopRequireDefault(_Transition);

var _ownerWindow = __webpack_require__(241);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

var _reactLifecyclesCompat = __webpack_require__(595);

var _reactLifecyclesCompat2 = _interopRequireDefault(_reactLifecyclesCompat);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _transitions = __webpack_require__(112);

var _utils = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GUTTER = 24;

// Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`
// @inheritedComponent Transition

function getTranslateValue(props, node) {
  var direction = props.direction;

  var rect = node.getBoundingClientRect();

  var transform = void 0;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow2.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return 'translateX(100vw) translateX(-' + (rect.left - offsetX) + 'px)';
  } else if (direction === 'right') {
    return 'translateX(-' + (rect.left + rect.width + GUTTER - offsetX) + 'px)';
  } else if (direction === 'up') {
    return 'translateY(100vh) translateY(-' + (rect.top - offsetY) + 'px)';
  }

  // direction === 'down'
  return 'translate3d(0, ' + (0 - (rect.top + rect.height)) + 'px, 0)';
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.transform = transform;
    node.style.webkitTransform = transform;
  }
}

/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = function (_React$Component) {
  (0, _inherits3.default)(Slide, _React$Component);

  function Slide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Slide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.transition = null, _this.handleResize = (0, _debounce2.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      var node = (0, _reactDom.findDOMNode)(_this.transition);
      if (node) {
        setTranslateValue(_this.props, node);
      }
    }, 166), _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.easeOut,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.easeOut,
        delay: delay
      });
      node.style.transform = 'translate3d(0, 0, 0)';
      node.style.webkitTransform = 'translate3d(0, 0, 0)';
      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.sharp,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.sharp,
        delay: delay
      });
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.transition = '';
      node.style.webkitTransition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Slide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var node = (0, _reactDom.findDOMNode)(this.transition);
      if (node) {
        node.style.visibility = 'inherit';
        setTranslateValue(this.props, node);
      }
    } // Corresponds to 10 frames at 60 Hz.

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onEntering', 'onExit', 'onExited', 'style', 'theme']);


      var style = {};

      // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.
      if (!this.props.in && !this.state.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends3.default)({}, style, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _reactEventListener2.default,
        { target: 'window', onResize: this.handleResize },
        _react2.default.createElement(
          _Transition2.default,
          (0, _extends3.default)({
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onExit: this.handleExit,
            onExited: this.handleExited,
            appear: true,
            style: style,
            ref: function ref(node) {
              _this2.transition = node;
            }
          }, other),
          children
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.mounted === 'undefined') {
        return {
          mounted: false
        };
      }

      return {
        mounted: true
      };
    }
  }]);
  return Slide;
}(_react2.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()((0, _reactLifecyclesCompat2.default)(Slide));

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(101).Buffer;
var intSize = 4;
var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
var chrsz = 8;

function toArray(buf, bigEndian) {
  if ((buf.length % intSize) !== 0) {
    var len = buf.length + (intSize - (buf.length % intSize));
    buf = Buffer.concat([buf, zeroBuffer], len);
  }

  var arr = [];
  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
  for (var i = 0; i < buf.length; i += intSize) {
    arr.push(fn.call(buf, i));
  }
  return arr;
}

function toBuffer(arr, size, bigEndian) {
  var buf = new Buffer(size);
  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
  for (var i = 0; i < arr.length; i++) {
    fn.call(buf, arr[i], i * 4, true);
  }
  return buf;
}

function hash(buf, fn, hashSize, bigEndian) {
  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
  return toBuffer(arr, hashSize, bigEndian);
}

module.exports = { hash: hash };


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.realTimeLineChart = realTimeLineChart;
exports.updateRealTimeLineChart = updateRealTimeLineChart;
exports.australiaFusionChartManager = australiaFusionChartManager;
exports.displayDialCharts = displayDialCharts;
exports.doughnutFusionChartManager = doughnutFusionChartManager;
exports.dualYCombination = dualYCombination;
exports.dualLineCombination = dualLineCombination;
exports.bubbleChartFusionCharts = bubbleChartFusionCharts;
exports.heatMapFusionChart = heatMapFusionChart;
exports.fusionChartManager = fusionChartManager;
exports.stackedChart = stackedChart;
exports.horizontalLed = horizontalLed;
exports.horizontalLed2 = horizontalLed2;
exports.pieChartManager = pieChartManager;
exports.msAreaChartFusionChart = msAreaChartFusionChart;
exports.radarFusionChartManager = radarFusionChartManager;
exports.disposeChart = disposeChart;

var _fusioncharts = __webpack_require__(608);

var _fusioncharts2 = _interopRequireDefault(_fusioncharts);

var _fusioncharts3 = __webpack_require__(609);

var _fusioncharts4 = _interopRequireDefault(_fusioncharts3);

var _fusioncharts5 = __webpack_require__(1542);

var _fusioncharts6 = _interopRequireDefault(_fusioncharts5);

var _fusioncharts7 = __webpack_require__(1543);

var _fusioncharts8 = _interopRequireDefault(_fusioncharts7);

var _fusioncharts9 = __webpack_require__(1544);

var _fusioncharts10 = _interopRequireDefault(_fusioncharts9);

var _fusioncharts11 = __webpack_require__(1545);

var _fusioncharts12 = _interopRequireDefault(_fusioncharts11);

var _colorCharts = __webpack_require__(375);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

(0, _fusioncharts12.default)(_fusioncharts2.default);
(0, _fusioncharts4.default)(_fusioncharts2.default);
(0, _fusioncharts10.default)(_fusioncharts2.default);
(0, _fusioncharts6.default)(_fusioncharts2.default);
(0, _fusioncharts8.default)(_fusioncharts2.default);
_fusioncharts2.default.options.creditLabel = false;

function realTimeLineChart(DivId, timestamps, chartData, threshold, valueShouldBeLess) {
    return new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var realTimeAreaChart = new _fusioncharts2.default({
                id: DivId + '-chartId',
                type: 'realtimeline',
                renderAt: DivId,
                width: '100%',
                height: '200',
                dataFormat: 'json',
                dataSource: {
                    "chart": {
                        plotGradientColor: '',
                        theme: 'fint',
                        canvasBgAlpha: '0',
                        alternateHGridColor: _colorCharts.black,
                        alternateHGridAlpha: '0',
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black,
                        legendItemFontColor: _colorCharts.white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                        showRealTimeValue: '0',
                        showValues: "0",
                        setAdaptiveYMin: '1',
                        numDisplaySets: '20'
                    },
                    // "categories": [
                    //     {
                    //         "category": timestamps
                    //     }
                    // ],
                    "dataset": [{
                        "data": []
                    }]
                }
            });

            realTimeAreaChart.render(DivId, undefined, function () {
                // Add data
                var colors = [];
                timestamps.forEach(function (item, index) {
                    var color = _colorCharts.blue;
                    if (threshold) {
                        if (valueShouldBeLess) {
                            color = chartData[index] < threshold ? _colorCharts.blue : _colorCharts.red;
                        } else {
                            color = chartData[index] > threshold ? _colorCharts.blue : _colorCharts.red;
                        }
                    }
                    colors.push(color);
                });
                var strData = '&color=' + colors.join(',') + '&label=' + timestamps.join(',') + '&value=' + chartData.join(',');
                realTimeAreaChart.feedData(strData);
                resolve(realTimeAreaChart);
            });
        });
    });
}

function updateRealTimeLineChart(DivId, timestamp, value, thresholdCrossed) {
    var chartRef = (0, _fusioncharts2.default)(DivId + '-chartId');

    // Build Data String in format &label=...&value=...
    var color = thresholdCrossed ? _colorCharts.red : _colorCharts.blue;

    var strData = '&color=' + color + '&label=' + timestamp + '&value=' + value;
    // Feed it to chart.
    chartRef.feedData(strData);
}

function australiaFusionChartManager(id, type, data) {

    var promiseForAustraliaFusion = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: type,
                renderAt: id,
                dataFormat: 'json',
                showBorder: 0,
                width: '100%',
                height: '100%',
                plotHoverEffect: 1,
                plotBorderHoverColor: _colorCharts.blue,
                hoverColor: _colorCharts.blue,
                plotFillHoverColor: _colorCharts.blue,
                dataSource: {
                    chart: {
                        theme: 'fint',
                        showLabels: 1,
                        includeValueInLabels: 1,
                        formatNumberScale: 0,
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black
                    },
                    data: data
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForAustraliaFusion;
}

function displayDialCharts(id, value, isZAxis, bgColor) {
    var gaugeStartAngle = void 0,
        gaugeEndAngle = void 0,
        lowerLimit = void 0,
        upperLimit = void 0,
        valueX = void 0,
        valueY = void 0;
    if (isZAxis) {
        gaugeStartAngle = 90;
        gaugeEndAngle = -90;
        lowerLimit = 0;
        upperLimit = 180;
        valueX = 120;
        valueY = 160;
    } else {
        gaugeStartAngle = 180;
        gaugeEndAngle = 0;
        lowerLimit = -90;
        upperLimit = 90;
        valueX = 160;
        valueY = 190;
    }

    var chartConfig = {
        manageresize: '1',
        origw: '320',
        origh: '320',
        tickvaluedistance: '-10',
        upperlimit: upperLimit,
        lowerlimit: lowerLimit,
        basefontcolor: _colorCharts.black,
        majortmcolor: _colorCharts.black,
        majortmheight: '5',
        majortmthickness: '2',
        minortmcolor: _colorCharts.black,
        minortmheight: '2',
        minortmthickness: '1',
        pivotradius: '10',
        pivotbgcolor: _colorCharts.blueTranslucent,
        pivotbordercolor: _colorCharts.blue,
        pivotborderthickness: '2',
        tooltipbgcolor: _colorCharts.black,
        gaugeouterradius: '115',
        gaugestartangle: gaugeStartAngle,
        gaugeendangle: gaugeEndAngle,
        decimals: '1',
        placevaluesinside: '1',
        pivotfillmix: '',
        showpivotborder: '1',
        annrenderdelay: '0',
        gaugeoriginx: '160',
        gaugeoriginy: '160',
        showborder: '0',
        showValue: '0',
        valueBelowPivot: '1',
        bgColor: bgColor,
        bgAlpha: '100',
        valueFontBold: '1',
        baseFontColor: _colorCharts.white,
        majorTMColor: _colorCharts.white,
        minorTMColor: _colorCharts.white
    };

    var dialConfig = {
        dial: [{
            value: value,
            bgcolor: _colorCharts.blueTranslucent,
            bordercolor: _colorCharts.blue,
            valuey: valueY,
            valuex: valueX
        }]
    };

    var annotationConfig = {
        groups: [{
            x: '160',
            y: '160',
            items: [{
                type: 'circle',
                radius: '130',
                fillcolor: bgColor,
                fillalpha: '100',
                showborder: '1',
                bordercolor: _colorCharts.blue,
                borderThickness: '5'
            }]
        }]
    };

    var dimension = document.getElementById('MAChartsDiv').offsetHeight;
    dimension *= .27;

    var chart = (0, _fusioncharts2.default)(id + '-chartId');
    if (chart) {
        chart.setJSONData({
            chart: chartConfig,
            dials: dialConfig,
            annotations: annotationConfig
        });
        chart.resizeTo(dimension, dimension);
    } else {
        chart = new _fusioncharts2.default({
            id: id + '-chartId',
            type: 'angulargauge',
            width: dimension,
            renderAt: id,
            height: dimension,
            dataFormat: 'json',
            dataSource: {
                chart: chartConfig,
                dials: dialConfig,
                annotations: annotationConfig
            }
        });
        chart.render();
    }
}

function doughnutFusionChartManager(id, title, data, label, widthByTwo) {
    var promiseForDoughnutFusion = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'doughnut2d',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        caption: title,
                        paletteColors: _colorCharts.grey + ',' + _colorCharts.blue,
                        use3DLighting: '0',
                        animateClockwise: 1,
                        showShadow: '0',
                        enableSmartLabels: '1',
                        startingAngle: '0',
                        showLabels: '0',
                        showPercentValues: '0',
                        legendShadow: '0',
                        legendBorderAlpha: '0',
                        defaultCenterLabel: data[1].value.toString(),
                        centerLabel: '',
                        centerLabelBold: '0',
                        showTooltip: '1',
                        showPercentInTooltip: 0,
                        decimals: '0',
                        enableRotation: '0',
                        captionFontSize: '14',
                        subcaptionFontSize: '14',
                        subcaptionFontBold: '0',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        baseFontSize: '12', // 15
                        toolTipBgColor: _colorCharts.black,
                        legendItemFontColor: _colorCharts.white,
                        showValues: 0,
                        showLegend: 1,
                        legendBgAlpha: '0'
                    },
                    data: data,
                    annotations: {
                        // "origw": "400",
                        // "origh": "190",
                        autoscale: '1',
                        groups: [{
                            id: 'range',
                            items: [{
                                id: '',
                                type: 'text',
                                font: 'aguda_boldregular',
                                fontSize: '12', // 16
                                fillcolor: _colorCharts.white,
                                text: label,
                                x: widthByTwo,
                                y: '$canvasHeight -30'
                            }]
                        }]
                    }
                }
            });

            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForDoughnutFusion;
}

function dualYCombination(id, categories, dataset) {
    var promiseForDualY = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusioncharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'mscombidy2d',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        plotGradientColor: '',
                        sYAxisMaxValue: '50',
                        theme: 'fint',
                        canvasBgAlpha: '0',
                        alternateHGridColor: _colorCharts.black,
                        alternateHGridAlpha: '0',
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black,
                        legendItemFontColor: _colorCharts.white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0'
                    },
                    categories: categories,
                    dataset: dataset
                }
            });
            fusioncharts.render();

            resolve(fusioncharts);
        });
    });

    return promiseForDualY;
}

function dualLineCombination(id, categories, dataset) {

    var promiseForDualLine = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusioncharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'msline',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        plotGradientColor: '',
                        sYAxisMaxValue: '50',
                        theme: 'fint',
                        canvasBgAlpha: '0',
                        alternateHGridColor: _colorCharts.black,
                        alternateHGridAlpha: '0',
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black,
                        legendItemFontColor: _colorCharts.white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                        showYAxisValues: '0',
                        plotSpacePercent: '65'
                    },
                    categories: categories,
                    dataset: dataset
                }
            });
            fusioncharts.render();

            resolve(fusioncharts);
        });
    });

    return promiseForDualLine;
}

function bubbleChartFusionCharts(id) {

    var promiseForBubbleChart = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var conversionChart = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'bubble',
                renderAt: id,
                width: '100%',
                height: '213',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        xAxisMinValue: '0',
                        xAxisMaxValue: '100',
                        yAxisMinValue: '0',
                        yAxisMaxValue: '30000',
                        plotFillAlpha: '100',
                        plotFillHoverColor: _colorCharts.green,
                        showPlotBorder: '0',
                        xAxisName: 'Effort',
                        yAxisName: '',
                        showTrendlineLabels: '0',
                        theme: 'fint',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        showValues: '0',
                        showAlternateHGridColor: '0',
                        showLegend: '1',
                        legendItemFontColor: _colorCharts.black,
                        toolTipBgColor: _colorCharts.black,
                        showYAxisValues: '0',
                        trendValueAlpha: '0'
                    },
                    annotations: {
                        width: '5',
                        height: '5',
                        autoScale: '1',
                        groups: [{
                            id: 'user-images',
                            items: [{
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: _colorCharts.white,
                                fontsize: '11',
                                text: 'Low',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '350',
                                x: '$canvasStartX',
                                y: '$dataset.0.set.4.ENDY'
                            }, {
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: _colorCharts.white,
                                fontsize: '11',
                                text: 'Med',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '350',
                                x: '$canvasStartX',
                                y: '$dataset.0.set.3.STARTY'
                            }, {
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: _colorCharts.white,
                                fontsize: '11',
                                text: 'High',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '350',
                                x: '$canvasStartX',
                                y: '$canvasStartY + 20'
                            }, {
                                type: 'text',
                                fillcolor: _colorCharts.white,
                                fontsize: '11',
                                text: 'value',
                                bold: '1',
                                x: '$canvasStartX',
                                y: '$canvasStartY - 10'
                            }]
                        }]
                    },
                    categories: [{
                        category: [{
                            label: '0',
                            x: '0'
                        }, {
                            label: 'Low',
                            x: '20'
                        }, {
                            label: 'Med',
                            x: '50'
                        }, {
                            label: 'High',
                            x: '80'
                        }]
                    }],
                    dataset: [{
                        color: '#92d050',
                        data: [{
                            x: '80',
                            y: '15000',
                            z: '24'
                        }, {
                            x: '60',
                            y: '18500',
                            z: '26'
                        }, {
                            x: '50',
                            y: '19450',
                            z: '19'
                        }, {
                            x: '65',
                            y: '10500',
                            z: '8'
                        }, {
                            x: '43',
                            y: '8750',
                            z: '5'
                        }, {
                            x: '32',
                            y: '22000',
                            z: '10'
                        }, {
                            x: '44',
                            y: '13000',
                            z: '9'
                        }]
                    }],
                    trendlines: [{

                        line: [{
                            displayValue: ' ',
                            startValue: '20000',
                            endValue: '30000',
                            isTrendZone: '1',
                            color: '#142060',
                            alpha: '100'
                        }, {
                            displayValue: ' ',
                            startValue: '10000',
                            endValue: '20000',
                            isTrendZone: '1',
                            color: '#4eb0eb',
                            alpha: '100'
                        }, {
                            displayValue: ' ',
                            startValue: '0',
                            endValue: '10000',
                            isTrendZone: '1',
                            color: '#bdd7ee',
                            alpha: '100'
                        }]
                    }]
                }
            });
            conversionChart.render();
            resolve();
        });
    });

    return promiseForBubbleChart;
}

function heatMapFusionChart(id, dataset) {

    var promiseForHeatMap = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var salesHMChart = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'heatmap',
                renderAt: id,
                width: '100%',
                height: '560',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        showplotborder: '1',
                        xAxisLabelsOnTop: '1',
                        plottooltext: "<div id='nameDiv' style='font-size: 12px; border-bottom: 1px dashed #666666; font-weight:bold; padding-bottom: 3px; margin-bottom: 5px; display: inline-block; color: #888888;' >$rowLabel :</div>{br}Rating : <b>$dataValue</b>{br}$columnLabel : <b>$tlLabel</b>{br}<b>$trLabel</b>",
                        baseFont: 'Helvetica Neue,Arial',
                        captionFontSize: '14',
                        subcaptionFontSize: '14',
                        subcaptionFontBold: '0',
                        showShadow: '100',
                        usePlotGradientColor: '0',
                        canvasBgColor: _colorCharts.greyShade,
                        canvasBorderAlpha: '0',
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                        legendShadow: '0',
                        legendItemFontSize: '10',
                        toolTipColor: _colorCharts.white,
                        toolTipBorderThickness: '0',
                        toolTipBgAlpha: '80',
                        toolTipBorderRadius: '2',
                        toolTipPadding: '5',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        showValues: '0',
                        gradient: '1'

                    },
                    dataset: dataset,
                    colorrange: {
                        gradient: '1',
                        minvalue: '0',
                        code: '#b4c7e7',
                        startlabel: 'Low Correlation',
                        endlabel: 'High Correlation',
                        color: [{
                            code: 'b4c7e7',
                            minvalue: '1',
                            maxvalue: '5'
                        }, {
                            code: '4fb0f0',
                            minvalue: '5',
                            maxvalue: '7'
                        }, {
                            code: '3870c0',
                            minvalue: '7',
                            maxvalue: '9'
                        }, {
                            code: '142060',
                            minvalue: '9',
                            maxvalue: '10'
                        }]
                    }
                }
            });
            salesHMChart.render();
            resolve();
        });
    });

    return promiseForHeatMap;
}

function fusionChartManager(id, type, data, title) {
    var height = '290';
    if (id === 'deviceNotificationBreakdown' && $(window).height() < 768) {
        height = 250;
    }

    var promiseForFusionChart = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: type,
                renderAt: id,
                dataFormat: 'json',
                showBorder: 0,
                width: '100%',
                height: height,
                plotHoverEffect: 1,
                plotBorderHoverColor: _colorCharts.blue,
                hoverColor: _colorCharts.blue,
                dataSource: {
                    chart: {
                        caption: title,
                        plotGradientColor: '',
                        theme: 'fint',
                        showLabels: 1,
                        includeValueInLabels: 0,
                        formatNumberScale: 0,
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        alternateVGridAlpha: '0',
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black,
                        legendItemFontColor: _colorCharts.white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0'
                    },
                    data: data
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForFusionChart;
}

function stackedChart(id, dataset, categories, height, colorx) {
    var promiseForHorizontal = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                type: 'stackedbar2d',
                renderAt: id,
                width: '100%',
                height: height,
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        fontColor: _colorCharts.white,
                        baseFontColor: _colorCharts.white,
                        legendItemFontColor: _colorCharts.black,
                        toolTipBgColor: _colorCharts.black,
                        tickMarkDistance: '50',
                        numberSuffix: '%',
                        showValue: 0,
                        theme: "fint",
                        showHoverEffect: "1",
                        usePlotGradientColor: "0",
                        stack100Percent: "0",
                        showLegend: "0",
                        paletteColors: _colorCharts.green + ',' + _colorCharts.red,
                        showCanvasBorder: "0",
                        xAxisLineColor: colorx,
                        divlineColor: colorx,
                        divLineIsDashed: "0"
                    },
                    categories: categories,
                    dataset: dataset
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });
    return promiseForHorizontal;
}

function horizontalLed(id, lHSMin, lHSMax, rHSMin, rHSMax) {
    var promiseForHorizontal = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'hled',
                renderAt: id,
                width: '90%',
                height: '80',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        ledGap: '0',
                        lowerLimit: '0',
                        upperLimit: '100',
                        lowerLimitDisplay: ' ',
                        upperLimitDisplay: ' ',
                        showTickMarks: '0',
                        showTickValues: '1',
                        theme: 'fint',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        fontColor: _colorCharts.white,
                        baseFontColor: _colorCharts.white,
                        legendItemFontColor: _colorCharts.black,
                        toolTipBgColor: _colorCharts.black,
                        tickMarkDistance: '50',
                        numberSuffix: '%',
                        showValue: 0
                    },
                    annotations: {
                        width: '5',
                        height: '5',
                        autoScale: '1',
                        groups: [{
                            id: 'user-images',
                            showBelow: '0',
                            items: [{
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: _colorCharts.white,
                                fontsize: '11',
                                text: '',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '70',
                                x: '$gaugeStartX+40',
                                y: '$canvasStartY + 166'
                            }, {
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: _colorCharts.white,
                                fontsize: '11',
                                text: '',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '70',
                                x: '$gaugeEndX-40',
                                y: '$canvasStartY + 166'
                            }]
                        }]
                    },
                    colorrange: {
                        color: [{
                            minvalue: lHSMin,
                            maxvalue: lHSMax,
                            label: 'Residential',
                            code: _colorCharts.blue
                        }, {
                            minvalue: rHSMin,
                            maxvalue: rHSMax,
                            label: 'Business',
                            code: _colorCharts.grey
                        }]
                    },
                    value: lHSMax
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForHorizontal;
}

function horizontalLed2(id, chartId, upperLimit, lowerLimit, value) {
    var promiseForHorizontalLed2 = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                type: 'hled',
                renderAt: id, // unique div it, where to render at
                id: id + '-chartId', // should be unique
                width: '90%',
                height: '80',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        ledGap: '0',
                        // Hiding tick marks and values
                        lowerLimit: '0',
                        upperLimit: '100',
                        lowerLimitDisplay: upperLimit,
                        upperLimitDisplay: lowerLimit,
                        showTickMarks: '0',
                        showTickValues: '1',
                        theme: 'fint',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        fontColor: _colorCharts.white,
                        baseFontColor: _colorCharts.white,
                        legendItemFontColor: _colorCharts.black,
                        toolTipBgColor: _colorCharts.black,
                        tickMarkDistance: '50',
                        numberSuffix: '%',
                        showValue: 0,
                        chartLeftMargin: 0,
                        chartRightMargin: 0,
                        baseFontSize: '8'
                    },
                    colorrange: {
                        color: [{
                            minvalue: '0',
                            maxvalue: value,
                            label: ' ',
                            code: _colorCharts.blue
                        }, {
                            minvalue: value + 1,
                            maxvalue: '100',
                            label: ' ',
                            code: _colorCharts.grey
                        }]
                    },
                    value: value
                }
            });
            fusionCharts.render();

            resolve(fusionCharts);
        });
    });

    return promiseForHorizontalLed2;
}

function pieChartManager(id, data) {
    var promiseForPieChartManager = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: 'pie2d',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        formatnumberscale: '0',
                        showPercentValues: '0',
                        showPercentInTooltip: '0',
                        baseFontSize: '8',
                        placeValuesInside: '1',
                        showpercentvalues: '1',
                        showLegend: '1',
                        pieRadius: '80',
                        enableSmartLabels: '0',
                        ChartNoDataText: 'Data unavailable',
                        enableMultiSlicing: '0',
                        theme: 'fint',
                        palettecolors: '#006EAB,#70ACE2,#4c6c9c,#6f8db9,#9db1cf,#c3cfe1,#dfe5ef,#c0c0c0,#d6d7d9,#eaeaea',
                        decimals: '1',
                        forcedecimals: '1',
                        enableSlicing: '0',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        showLabels: 1,
                        includeValueInLabels: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black,
                        legendPosition: 'BOTTOM',
                        legendBorderColor: '000000',
                        legendItemFontColor: _colorCharts.white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0'
                    },
                    data: data
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForPieChartManager;
}

function msAreaChartFusionChart(id, categories, shapeAnnotationXCordinate, shapeAnnotationXCordinateScore, shapeAnnotationXCordinateText, propensityText) {

    var promiseForMSAreaChart = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            new _fusioncharts2.default({
                type: 'msarea',
                id: id + '-chartId',
                renderAt: id,
                width: '95%',
                height: '200',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        yAxisName: '# of Records',
                        paletteColors: '#d9d9d9,#b4c7e7,#4fb0f0',
                        showCanvasBorder: '0',
                        plotBorderAlpha: '10',
                        usePlotGradientColor: '0',
                        legendBorderAlpha: '0',
                        legendShadow: '0',
                        plotFillAlpha: '60',
                        showXAxisLine: '1',
                        axisLineAlpha: '25',
                        showValues: '0',
                        captionFontSize: '14',
                        subcaptionFontSize: '14',
                        subcaptionFontBold: '0',
                        divlineColor: '#999999',
                        divLineIsDashed: '1',
                        divLineDashLen: '1',
                        divLineGapLen: '1',
                        showAlternateHGridColor: '0',
                        toolTipColor: '#ffffff',
                        toolTipBorderThickness: '0',
                        toolTipBgAlpha: '80',
                        toolTipBorderRadius: '2',
                        toolTipPadding: '5',
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: '#FFFFFF',
                        showYAxisValues: '0',
                        showXAxisValues: '0',
                        legendItemFontColor: '#000000',
                        toolTipBgColor: '#000000',
                        showLegend: '0'
                    },
                    annotations: {
                        width: '5',
                        height: '5',
                        autoScale: '1',
                        groups: [{
                            id: 'user-images',
                            items: [{
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: '#ffffff',
                                fontsize: '7',
                                text: 'Prediction Not Likely (0)',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '350',
                                x: '$canvasStartX + 25',
                                y: '$canvasHeight +20'
                            }, {
                                id: 'dyn-label',
                                type: 'text',
                                fillcolor: '#ffffff',
                                fontsize: '7',
                                text: 'Prediction Likely (1)',
                                bold: '1',
                                wrap: '1',
                                wrapWidth: '350',
                                x: '$canvasEndX - 25',
                                y: '$canvasHeight + 20'
                            }, {

                                type: 'circle',
                                x: shapeAnnotationXCordinate,
                                y: '50',
                                radius: '10',
                                color: '#92d050',
                                text: 'Test'
                            }, {
                                type: 'text',
                                text: 'Propensity Score',
                                x: shapeAnnotationXCordinateScore,
                                y: '50',
                                color: '#92d050'
                            }, {
                                type: 'text',
                                text: propensityText,
                                x: shapeAnnotationXCordinateText,
                                y: '50',
                                color: '#92d050',
                                fontSize: '20'
                            }]
                        }]
                    },

                    categories: categories,

                    dataset: [{
                        seriesname: 'Previous Week',
                        data: [{
                            value: '33000'
                        }, {
                            value: '40000'
                        }, {
                            value: '30000'
                        }, {
                            value: '34000'
                        }, {
                            value: '15000'
                        }, {
                            value: '20000'
                        }, {
                            value: '17300'
                        }, {
                            value: '0'
                        }]
                    }, {
                        seriesname: 'Current Week',
                        data: [{
                            value: '8400'
                        }, {
                            value: '9800'
                        }, {
                            value: '7800'
                        }, {
                            value: '6400'
                        }, {
                            value: '3800'
                        }, {
                            value: '4800'
                        }, {
                            value: '2000'
                        }, {
                            value: '0'
                        }]
                    }, {
                        seriesname: 'test',
                        data: [{
                            value: ''
                        }, {
                            value: ''
                        }, {
                            value: ''
                        }, {
                            value: ''
                        }, {
                            value: ''
                        }, {
                            value: ''
                        }, {
                            value: ''
                        }, {
                            value: '0'
                        }, {
                            value: '10000'
                        }, {
                            value: '13000'
                        }, {
                            value: '11000'
                        }, {
                            value: '15000'
                        }, {
                            value: '12000'
                        }, {
                            value: '16000'
                        }]
                    }]
                }
            }).render();
            resolve();
        });
    });

    return promiseForMSAreaChart;
}

function radarFusionChartManager(id, type, categories, dataset) {

    var promiseForRadarFusionChart = new Promise(function (resolve, reject) {
        _fusioncharts2.default.ready(function () {
            var fusionCharts = new _fusioncharts2.default({
                id: id + '-chartId',
                type: type,
                renderAt: id,
                dataFormat: 'json',
                width: '100%',
                dataSource: {
                    chart: {
                        numberPreffix: '$',
                        theme: 'fint',
                        radarfillcolor: _colorCharts.white,
                        canvasBgAlpha: 0,
                        bgColor: _colorCharts.greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        showLegend: 1,
                        baseFontColor: _colorCharts.white,
                        toolTipBgColor: _colorCharts.black,
                        legendItemFontColor: _colorCharts.white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0'
                    },
                    categories: categories,
                    dataset: dataset
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForRadarFusionChart;
}

// TODO: all references not changed based on new implementation.
function disposeChart(id) {
    var chart = (0, _fusioncharts2.default)(id + '-chartId');
    if (chart) {
        chart.dispose();
    }
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(realTimeLineChart, 'realTimeLineChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(updateRealTimeLineChart, 'updateRealTimeLineChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(australiaFusionChartManager, 'australiaFusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(displayDialCharts, 'displayDialCharts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(doughnutFusionChartManager, 'doughnutFusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(dualYCombination, 'dualYCombination', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(dualLineCombination, 'dualLineCombination', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(bubbleChartFusionCharts, 'bubbleChartFusionCharts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(heatMapFusionChart, 'heatMapFusionChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(fusionChartManager, 'fusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(stackedChart, 'stackedChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(horizontalLed, 'horizontalLed', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(horizontalLed2, 'horizontalLed2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(pieChartManager, 'pieChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(msAreaChartFusionChart, 'msAreaChartFusionChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(radarFusionChartManager, 'radarFusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(disposeChart, 'disposeChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_fusioncharts2, '_fusioncharts2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_fusioncharts4, '_fusioncharts4', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_fusioncharts6, '_fusioncharts6', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_fusioncharts8, '_fusioncharts8', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_fusioncharts10, '_fusioncharts10', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_fusioncharts12, '_fusioncharts12', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(realTimeLineChart, 'realTimeLineChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(updateRealTimeLineChart, 'updateRealTimeLineChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(australiaFusionChartManager, 'australiaFusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(displayDialCharts, 'displayDialCharts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(doughnutFusionChartManager, 'doughnutFusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(dualYCombination, 'dualYCombination', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(dualLineCombination, 'dualLineCombination', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(bubbleChartFusionCharts, 'bubbleChartFusionCharts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(heatMapFusionChart, 'heatMapFusionChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(fusionChartManager, 'fusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(stackedChart, 'stackedChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(horizontalLed, 'horizontalLed', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(horizontalLed2, 'horizontalLed2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(pieChartManager, 'pieChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(msAreaChartFusionChart, 'msAreaChartFusionChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(radarFusionChartManager, 'radarFusionChartManager', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(disposeChart, 'disposeChart', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fusionChartManager.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blue = exports.blue = "#E2E3E5";
var blueTranslucent = exports.blueTranslucent = "rgba(0, 175, 235, 0.2)";
var grey = exports.grey = "#d9d9d9";
var transparent = exports.transparent = "rgba(255, 255, 255, 0)";
var redTranslucent = exports.redTranslucent = 'rgba(255, 99, 132, 0.3)';
var red = exports.red = '#EF5350';
var greyShade = exports.greyShade = "#434F59";
var modalGreyShade = exports.modalGreyShade = "#E2E3E5 !important";
var blueShade = exports.blueShade = "#4fb1ec";
var white = exports.white = "#FFFFFF";
var black = exports.black = "#000000";
var green = exports.green = "#92d050";
var amber = exports.amber = "#ffbf00";
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(blue, "blue", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(blueTranslucent, "blueTranslucent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(grey, "grey", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(transparent, "transparent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(redTranslucent, "redTranslucent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(red, "red", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(greyShade, "greyShade", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(modalGreyShade, "modalGreyShade", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(blueShade, "blueShade", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(white, "white", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(black, "black", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(green, "green", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(amber, "amber", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(blue, "blue", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(blueTranslucent, "blueTranslucent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(grey, "grey", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(transparent, "transparent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(redTranslucent, "redTranslucent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(red, "red", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(greyShade, "greyShade", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(modalGreyShade, "modalGreyShade", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(blueShade, "blueShade", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(white, "white", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(black, "black", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(green, "green", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(amber, "amber", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/styles/colorCharts.js");
}();

;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = __webpack_require__(854);

var _MarkerClusterer = __webpack_require__(911);

var _MarkerClusterer2 = _interopRequireDefault(_MarkerClusterer);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import fetch from "isomorphic-fetch";


var MarkerClustererGoogleMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
  return _react2.default.createElement(_reactGoogleMaps.GoogleMap, {
    ref: props.onMapMounted,
    defaultZoom: 10,
    zoom: 10,
    center: {
      lat: props.markers.length > 0 ? props.markers[0].latitude : -24.397,
      lng: props.markers.length > 0 ? props.markers[0].longitude : 135.644
    },
    defaultCenter: { lat: -24.397, lng: 135.644 },
    onDragEnd: props.onBoundsChanged,
    onZoomChanged: props.onBoundsChanged
  }, _react2.default.createElement(_MarkerClusterer2.default, { averageCenter: true, enableRetinaIcons: true, gridSize: 60 }, props.markers.map(function (marker) {
    return marker.deviceID && marker.deviceID && marker.latitude && marker.longitude ? _react2.default.createElement(_reactGoogleMaps.Marker, {
      onClick: function onClick() {
        props.navigate(marker.deviceID);
      },
      position: { lat: marker.latitude, lng: marker.longitude },
      key: marker.deviceID
    }, _react2.default.createElement(_reactGoogleMaps.InfoWindow, null, _react2.default.createElement("div", {
      style: {
        color: marker.deviceID.includes('rev-nbn') ? 'red' : 'blue',
        padding: 12
      },
      onClick: function onClick() {
        props.navigate(marker.deviceID);
      } }, marker.deviceID))) : "";
  })));
});

var SymbioticMarkerClusterer = function (_Component) {
  _inherits(SymbioticMarkerClusterer, _Component);

  function SymbioticMarkerClusterer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SymbioticMarkerClusterer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SymbioticMarkerClusterer.__proto__ || Object.getPrototypeOf(SymbioticMarkerClusterer)).call.apply(_ref, [this].concat(args))), _this), _this.mapRef = {}, _this.onMapMounted = function (ref) {
      _this.mapRef = ref;
    }, _this.onBoundsChanged = function () {
      _this.props.onBoundsChanged(_this.mapRef.getBounds());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SymbioticMarkerClusterer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.mapRef = {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(MarkerClustererGoogleMap, {
        onMapMounted: this.onMapMounted,
        containerElement: _react2.default.createElement("div", { className: "embed-responsive embed-responsive-16by9 googleMap" }),
        navigate: function navigate(deviceID) {
          _this2.props.navigate(deviceID);
        },
        mapElement: _react2.default.createElement("div", { className: "embed-responsive-item" }),
        markers: this.props.markerData,
        onBoundsChanged: this.onBoundsChanged
      });
    }
  }]);

  return SymbioticMarkerClusterer;
}(_react.Component);

SymbioticMarkerClusterer.propTypes = {
  markerData: _propTypes2.default.array.isRequired
};

var _default = SymbioticMarkerClusterer;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MarkerClustererGoogleMap, "MarkerClustererGoogleMap", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(SymbioticMarkerClusterer, "SymbioticMarkerClusterer", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");
}();

;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_MarkerClusterer2, "_MarkerClusterer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_propTypes2, "_propTypes2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(MarkerClustererGoogleMap, "MarkerClustererGoogleMap", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(SymbioticMarkerClusterer, "SymbioticMarkerClusterer", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");

  __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/Components/SymbioticMarkerClusterer.js");
}();

;

/***/ }),
/* 377 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(287),
    baseLodash = __webpack_require__(379);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1582),
    isObjectLike = __webpack_require__(146);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141),
    root = __webpack_require__(49);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1600),
    mapCacheDelete = __webpack_require__(1607),
    mapCacheGet = __webpack_require__(1609),
    mapCacheHas = __webpack_require__(1610),
    mapCacheSet = __webpack_require__(1611);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(171);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CircularIndeterminate = CircularIndeterminate;
exports.CircularIndeterminate2 = CircularIndeterminate2;
exports.CircularIndeterminate3 = CircularIndeterminate3;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Progress = __webpack_require__(174);

var _colorCharts = __webpack_require__(375);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function CircularIndeterminate() {
    return _react2.default.createElement('div', { className: 'manage-margin' }, _react2.default.createElement(_Progress.CircularProgress, { color: 'inherit', size: 50 }));
}

function CircularIndeterminate2() {
    return _react2.default.createElement('div', { className: 'manage-margin' }, _react2.default.createElement(_Progress.CircularProgress, { color: 'inherit' }));
}

function CircularIndeterminate3() {
    return _react2.default.createElement('div', { className: 'manage-margin' }, _react2.default.createElement(_Progress.CircularProgress, { color: 'inherit', size: 120 }));
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(CircularIndeterminate, 'CircularIndeterminate', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(CircularIndeterminate2, 'CircularIndeterminate2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(CircularIndeterminate3, 'CircularIndeterminate3', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(CircularIndeterminate, 'CircularIndeterminate', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(CircularIndeterminate2, 'CircularIndeterminate2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(CircularIndeterminate3, 'CircularIndeterminate3', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js');
}();

;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _reactstrap = __webpack_require__(92);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactDatepicker = __webpack_require__(1670);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _filterFunction = __webpack_require__(403);

__webpack_require__(1764);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import SearchFilter from "./SearchFilter";


// import SearchBox from "../../components/SearchBox/index";

var numberCondition = [{
  type: '>',
  key: 'greater'
}, {
  type: '<',
  key: 'less'
}, {
  type: '=',
  key: 'equal'
}];

var stringCondition = [{
  type: 'contains',
  key: 'contains'
}, {
  type: 'is equals',
  key: 'equal'
}];

var FilterModal = function (_Component) {
  _inherits(FilterModal, _Component);

  function FilterModal(props) {
    var _this2 = this;

    _classCallCheck(this, FilterModal);

    var _this = _possibleConstructorReturn(this, (FilterModal.__proto__ || Object.getPrototypeOf(FilterModal)).call(this, props));

    _this.setColumnToggle = function () {
      _this.setState({
        columnType: !_this.state.columnType
      });
    };

    _this.selectColumnType = function (event) {
      _this.setState({
        columnSelectedData: event,
        conditionText: {}
      });
    };

    _this.setConditionToggle = function () {
      _this.setState({
        conditionType: !_this.state.conditionType
      });
    };

    _this.selectConditionText = function (event) {
      _this.setState({
        conditionText: event
      });
    };

    _this.addFilter = function () {
      var data = {
        condition: _this.state.conditionText,
        value: _this.state.inputValue === '' ? _this.state.date : _this.state.inputValue,
        key: _this.state.columnSelectedData
      };
      var filter = _this.state.filter;
      // const isExist = filter.findIndex(
      //   (item) => item.key.id === data.key.id
      // );
      // const exist = isExist !== -1;
      // if (exist) {
      // filter.splice(isExist, 1, data);
      // }
      // else {
      filter.push(data);
      // }
      _this.setState({
        filter: filter,
        columnSelectedData: {},
        inputValue: '',
        conditionText: {}
      });
    };

    _this.filterRecords = function () {
      var data = _this.props.data.filteredData;
      var filterData = (0, _filterFunction.filterRecords)(data, _this.state.filter);
      _this.props.setFilteredData(filterData);
    };

    _this.removeAllFilter = function () {
      var data = _this.props.data.filteredData;
      _this.props.setFilteredData(data);
    };

    _this.removeFilter = function (data) {
      var filter = _this.state.filter;
      var isExist = filter.findIndex(function (item) {
        return item.key.id === data.key.id;
      });
      var exist = isExist !== -1;
      if (exist) {
        filter.splice(isExist, 1);
      }
      _this.setState({
        filter: filter
      });
    };

    _this.setStartDate = function (date) {
      _this.setState({
        date: date
      });
    };

    _this.render = function () {
      var _React$createElement;

      var columnData = _this.props.data.columnData;

      var addButton = Object.keys(_this.state.columnSelectedData).length === 0 || Object.keys(_this.state.conditionText).length === 0 || _this.state.inputValue === '' && _this.state.columnSelectedData.type !== 'date';
      var filterButton = _this.state.filter.length > 0;
      return _react2.default.createElement("div", {
        className: "modal fade",
        id: "searchModalComponent",
        style: { top: "25%" }
      }, _react2.default.createElement("div", { className: "modal-dialog modal-lg" }, _react2.default.createElement("div", { className: "modal-content" }, _react2.default.createElement("div", { className: "modal-header py-2 border-0" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "col-9" }, _react2.default.createElement("h4", { className: "modal-title" }, "Filter Results")), _react2.default.createElement("div", { className: "col-3" }, _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "d-flex align-items-center justify-content-end col-6" }, _react2.default.createElement("h5", { className: "mb-0 pl-2" })), _react2.default.createElement("div", { className: "d-flex align-items-center col-6 justify-content-end" }, _react2.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal"
      }, _react2.default.createElement("h6", { className: "input-for-search" }, "\xD7"), _react2.default.createElement("h4", { className: "pl-1 modal-title" }, "Close")))))))), _react2.default.createElement("div", { className: "modal-body" }, _react2.default.createElement("div", { className: "d-flex" }, _react2.default.createElement("div", { className: "col-12 d-flex justify-content-start align-items-center" }, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.columnType,
        toggle: _this.setColumnToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true, className: "mb-0" }, Object.keys(_this.state.columnSelectedData).length === 0 ? "Select type" : _this.state.columnSelectedData.label), _react2.default.createElement(_reactstrap.DropdownMenu, null, columnData && columnData.length > 0 && columnData.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: function onClick() {
            return _this.selectColumnType(data);
          } }, data.label);
      }))), _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.conditionType,
        toggle: _this.setConditionToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true, className: "mb-0" }, Object.keys(_this.state.conditionText).length === 0 ? "Select type" : _this.state.conditionText.type), _react2.default.createElement(_reactstrap.DropdownMenu, null, Object.keys(_this.state.columnSelectedData).length > 0 && (_this.state.columnSelectedData.type === 'number' || _this.state.columnSelectedData.type === 'date') ? numberCondition && numberCondition.length > 0 && numberCondition.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: function onClick() {
            return _this.selectConditionText(data);
          } }, data.type);
      }) : stringCondition && stringCondition.length > 0 && stringCondition.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: function onClick() {
            return _this.selectConditionText(data);
          } }, data.type);
      }))), _this.state.columnSelectedData.type !== 'date' ? _react2.default.createElement("input", {
        onChange: function onChange(e) {
          _this.setState({
            inputValue: e.target.value
          });
        },
        type: "text",
        placeholder: "",
        value: _this.state.inputValue
      }) : _react2.default.createElement(_reactDatepicker2.default, { endDate: new Date(), selected: _this.state.date, onChange: function onChange(date) {
          return _this.setStartDate(date);
        } }), _react2.default.createElement(_Button2.default, (_React$createElement = {
        disabled: addButton,
        onClick: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.addFilter();

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        })),
        variant: "raised",
        color: 'primary'
      }, _defineProperty(_React$createElement, "color", addButton ? "default" : "primary"), _defineProperty(_React$createElement, "className", "jr-btn text-white mx-4"), _React$createElement), "Add"))), _react2.default.createElement("div", {
        className: "slimScrollDiv",
        style: {
          position: "relative",
          overflow: "overlay",
          width: "auto",
          height: "100%"
        }
      }, _react2.default.createElement("div", { className: "inner-height" }, _this.state.filter.length > 0 ? _react2.default.createElement("table", { className: "table search-table mt-3 table-bordered" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "Key"), _react2.default.createElement("th", null, "Condition"), _react2.default.createElement("th", null, "Value"), _react2.default.createElement("th", null, "Remove"))), _react2.default.createElement("tbody", null, _this.state.filter && _this.state.filter.length > 0 && _this.state.filter.map(function (item, index) {
        return _react2.default.createElement("tr", { key: index }, _react2.default.createElement("td", null, item.key.label), _react2.default.createElement("td", null, item.condition.type), _react2.default.createElement("td", null, item.key.type === 'date' ? new Date(item.value).toString() : item.value), _react2.default.createElement("td", null, _react2.default.createElement("a", { onClick: function onClick() {
            _this.removeFilter(item);
            // this.props.onViewPitClick(el);
          }
        }, "Remove")));
      }))) : _react2.default.createElement("h3", null, "Please select filters"))), _react2.default.createElement("div", { className: "d-flex justify-content-end align-items-end" }, _react2.default.createElement(_Button2.default
      // disabled={!filterButton}

      , { onClick: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this.removeAllFilter();

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        })),
        variant: "raised",
        color: 'primary'
        // color={!filterButton ? "default" : "primary"}
        , className: "jr-btn text-white"
      }, "Remove Filter"), _react2.default.createElement(_Button2.default, {
        disabled: !filterButton,
        onClick: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this.filterRecords();

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        })),
        variant: "raised"
        // color={'primary'}
        , color: !filterButton ? "default" : "primary",
        className: "jr-btn text-white"
      }, "Filter"))))));
    };

    _this.state = {
      columnType: false,
      columnSelectedData: {},
      inputValue: '',
      conditionType: false,
      conditionText: {},
      filter: _this.props.filter !== undefined && _this.props.filter,
      date: new Date()
    };
    return _this;
  }

  return FilterModal;
}(_react.Component);

var _default = FilterModal;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(numberCondition, "numberCondition", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(stringCondition, "stringCondition", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(FilterModal, "FilterModal", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_reactDatepicker2, "_reactDatepicker2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(numberCondition, "numberCondition", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(stringCondition, "stringCondition", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(FilterModal, "FilterModal", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterModal.js");
}();

;

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate).getTime();
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__(25);



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDate, {
    weekStartsOn: 1
  });
}

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1742);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 396 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(788);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1746)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(400);
var hasOwn = __webpack_require__(1748);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1747);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(400);
var GetIntrinsic = __webpack_require__(399);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4__hypnosphi_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this)), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var filterRecords = exports.filterRecords = function filterRecords(data, filter) {
  console.log('data, filter: ', data, filter);
  var filteredData = [];
  filteredData = data.filter(function (item) {
    var filtersData = filter.map(function (items) {
      var columnData = item[items.key.id];
      var conditionType = items.condition.key;
      if (items.key.type === 'number') {
        var value = items.value !== null ? items.value : 0;
        switch (conditionType) {
          case 'greater':
            return columnData > parseFloat(value);
          case 'less':
            return columnData < parseFloat(value);
          case 'equal':
            return columnData === parseFloat(value);
        }
      } else if (items.key.type === 'string') {
        columnData = item[items.key.id] !== null && item[items.key.id] !== undefined ? item[items.key.id].toLowerCase() : '';
        var _value = items.value !== null && items.value !== undefined ? items.value : '';
        switch (conditionType) {
          case 'equal':
            return columnData === _value.toLowerCase();
          case 'contains':
            return columnData.includes(_value.toLowerCase());
        }
      } else {
        columnData = item[items.key.id] !== null && item[items.key.id] !== undefined ? item[items.key.id] : '';
        var _value2 = items.value !== null ? items.value : '';
        if (columnData !== '') {
          var time1 = new Date(columnData);
          var time2 = new Date(_value2);
          var month1 = time1.getMonth() + 1;
          var date1 = time1.getDate();
          var year1 = time1.getFullYear();
          var month2 = time2.getMonth() + 1;
          var date2 = time2.getDate();
          var year2 = time2.getFullYear();
          switch (conditionType) {
            case 'greater':
              return year1 > year2 || year1 === year2 && month1 > month2 || year1 === year2 && month1 === month2 && date1 > date2;
            case 'less':
              return year1 < year2 || year1 === year2 && month1 < month2 || year1 === year2 && month1 === month2 && date1 < date2;
            case 'equal':
              return date1 === date2 && month1 === month2 && year1 === year2;
          }
        }
      }
    });
    var isTrue = filtersData.some(function (item) {
      return item === false;
    });
    if (!isTrue) {
      return item;
    }
  });
  return filteredData;
};

var filterDeviceCatalogueData = exports.filterDeviceCatalogueData = function filterDeviceCatalogueData(data) {
  var items = [];
  data.map(function (n, index) {
    var status = n && n.status;
    var temperature1 = n.data && n.data.sensors && n.data.sensors.temperature1;
    var temperature2 = n.data && n.data.sensors && n.data.sensors.temperature2;
    var temperature3 = n.data && n.data.sensors && n.data.sensors.temperature3;
    var current1 = n.data && n.data.sensors && n.data.sensors.current1;
    var current2 = n.data && n.data.sensors && n.data.sensors.current2;
    var water = n.data && n.data.sensors && n.data.sensors.water;
    var lid = n.data && n.data.notification && n.data.notification.eventVal;
    console.log('n.data.sensors.time: ', n.data.sensors);
    var time = n.data && n.data.sensors && undefined.formatDate(n.data.sensors.time);
    var currentThreshold1 = n.data && n.data.thresholds && n.data.thresholds.current1;
    var currentThreshold2 = n.data && n.data.thresholds && n.data.thresholds.current2;
    items.push({
      id: index,
      nodeId: n.nodeId,
      time: time,
      status: status,
      temperature1: temperature1,
      temperature2: temperature2,
      temperature3: temperature3,
      current1: current1,
      current2: current2,
      water: water,
      lid: lid,
      n: n,
      currentThreshold1: currentThreshold1,
      currentThreshold2: currentThreshold2
    });
  });
  return items;
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterRecords, 'filterRecords', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterFunction.js');

  __REACT_HOT_LOADER__.register(filterDeviceCatalogueData, 'filterDeviceCatalogueData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterFunction.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filterRecords, 'filterRecords', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterFunction.js');

  __REACT_HOT_LOADER__.register(filterDeviceCatalogueData, 'filterDeviceCatalogueData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterFunction.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/filterModal/filterFunction.js');
}();

;

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getThemeProps__ = __webpack_require__(1780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getThemeProps__["a"]; });


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jssPreset__ = __webpack_require__(1781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__jssPreset__["a"]; });


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeClasses__ = __webpack_require__(1794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeClasses__["a"]; });


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(268);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var _unused_webpack_default_export = (breakpoints);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1825);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonBase__ = __webpack_require__(1837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ButtonBase__["a"]; });


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRef;
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formControlState;
function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _CheckBoxOutlineBlank = __webpack_require__(1892);

var _CheckBoxOutlineBlank2 = _interopRequireDefault(_CheckBoxOutlineBlank);

var _CheckBox = __webpack_require__(1897);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none'
  },
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  },
  default: {},
  checked: {},
  disabled: {}
};

/**
 * @ignore - internal component.
 */

var SwitchBase = function (_React$Component) {
  (0, _inherits3.default)(SwitchBase, _React$Component);

  function SwitchBase(props, context) {
    (0, _classCallCheck3.default)(this, SwitchBase);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SwitchBase.__proto__ || (0, _getPrototypeOf2.default)(SwitchBase)).call(this, props, context));

    _this.state = {};
    _this.input = null;
    _this.isControlled = null;

    _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({ checked: checked });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    };

    _this.isControlled = props.checked != null;
    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }
    return _this;
  }

  (0, _createClass3.default)(SwitchBase, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          checkedProp = _props.checked,
          checkedIcon = _props.checkedIcon,
          classes = _props.classes,
          classNameProp = _props.className,
          disabledProp = _props.disabled,
          iconProp = _props.icon,
          id = _props.id,
          inputProps = _props.inputProps,
          inputRef = _props.inputRef,
          name = _props.name,
          onChange = _props.onChange,
          tabIndex = _props.tabIndex,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'checkedIcon', 'classes', 'className', 'disabled', 'icon', 'id', 'inputProps', 'inputRef', 'name', 'onChange', 'tabIndex', 'type', 'value']);
      var muiFormControl = this.context.muiFormControl;

      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var className = (0, _classnames2.default)(classes.root, classes.default, classNameProp, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checked, checked), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames));

      var icon = checked ? checkedIcon : iconProp;

      var hasLabelFor = type === 'checkbox' || type === 'radio';

      return _react2.default.createElement(
        _IconButton2.default,
        (0, _extends3.default)({
          component: 'span',
          className: className,
          disabled: disabled,
          tabIndex: null,
          role: undefined
        }, other),
        icon,
        _react2.default.createElement('input', (0, _extends3.default)({
          id: hasLabelFor && id,
          type: type,
          name: name,
          checked: checked,
          onChange: this.handleInputChange,
          className: classes.input,
          disabled: disabled,
          tabIndex: tabIndex,
          value: value,
          ref: inputRef
        }, inputProps))
      );
    }
  }]);
  return SwitchBase;
}(_react2.default.Component);

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes2.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes2.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

SwitchBase.defaultProps = {
  checkedIcon: _react2.default.createElement(_CheckBox2.default, null),
  disableRipple: false,
  icon: _react2.default.createElement(_CheckBoxOutlineBlank2.default, null),
  type: 'checkbox'
};

SwitchBase.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitchBase' })(SwitchBase);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWidthDown = exports.isWidthUp = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _wrapDisplayName = __webpack_require__(191);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _hoistNonReactStatics = __webpack_require__(350);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _createBreakpoints = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = exports.isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }
  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
};

// By default, returns true if screen width is the same or less than the given breakpoint.
var isWidthDown = exports.isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }
  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv,
        _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === undefined ? false : _options$withTheme;

    var WithWidth = function (_React$Component) {
      (0, _inherits3.default)(WithWidth, _React$Component);

      function WithWidth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithWidth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: undefined
        }, _this.handleResize = (0, _debounce2.default)(function () {
          _this.updateWidth(window.innerWidth);
        }, resizeInterval), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithWidth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth(window.innerWidth);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.handleResize.cancel();
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth(innerWidth) {
          var breakpoints = this.props.theme.breakpoints;
          var width = null;

          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */
          var index = 1;
          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index];

            // @media are inclusive, so reproduce the behavior here.
            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              initialWidth = _props.initialWidth,
              theme = _props.theme,
              width = _props.width,
              other = (0, _objectWithoutProperties3.default)(_props, ['initialWidth', 'theme', 'width']);

          var props = (0, _extends3.default)({
            width: width || this.state.width || initialWidth
          }, other);
          var more = {};

          if (withThemeOption) {
            more.theme = theme;
          }

          // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.
          if (props.width === undefined) {
            return null;
          }

          return _react2.default.createElement(
            _reactEventListener2.default,
            { target: 'window', onResize: this.handleResize },
            _react2.default.createElement(Component, (0, _extends3.default)({}, more, props))
          );
        }
      }]);
      return WithWidth;
    }(_react2.default.Component);

    WithWidth.propTypes =  false ? {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty componenent during the first mount.
       * In some situation you might want to use an heristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * http://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
      /**
       * @ignore
       */
      theme: _propTypes2.default.object.isRequired,
      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : {};

    if (false) {
      WithWidth.displayName = (0, _wrapDisplayName2.default)(Component, 'WithWidth');
    }

    (0, _hoistNonReactStatics2.default)(WithWidth, Component);

    return (0, _withTheme2.default)()(WithWidth);
  };
};

exports.default = withWidth;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(161);

var _Transition2 = _interopRequireDefault(_Transition);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _transitions = __webpack_require__(112);

var _utils = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },
    entered: {
      height: 'auto'
    },
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },
    wrapperInner: {
      width: '100%'
    }
  };
};

/**
 * The Collapes transition is used by the
 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
// @inheritedComponent Transition

var Collapse = function (_React$Component) {
  (0, _inherits3.default)(Collapse, _React$Component);

  function Collapse() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Collapse.__proto__ || (0, _getPrototypeOf2.default)(Collapse)).call.apply(_ref, [this].concat(args))), _this), _this.wrapper = null, _this.autoTransitionDuration = undefined, _this.timer = null, _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;

      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = duration2 + 'ms';
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
      }

      node.style.height = wrapperHeight + 'px';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
      node.style.height = wrapperHeight + 'px';

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;

      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = duration2 + 'ms';
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Collapse, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          collapsedHeight = _props.collapsedHeight,
          Component = _props.component,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          style = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'collapsedHeight', 'component', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExiting', 'style', 'theme', 'timeout']);


      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({
          onEntering: this.handleEntering,
          onEnter: this.handleEnter,
          onEntered: this.handleEntered,
          onExiting: this.handleExiting,
          onExit: this.handleExit,
          addEndListener: this.addEndListener,
          timeout: timeout === 'auto' ? null : timeout
        }, other),
        function (state, childProps) {
          return _react2.default.createElement(
            Component,
            (0, _extends3.default)({
              className: (0, _classnames2.default)(classes.container, (0, _defineProperty3.default)({}, classes.entered, state === 'entered'), className),
              style: (0, _extends3.default)({}, style, {
                minHeight: collapsedHeight
              })
            }, childProps),
            _react2.default.createElement(
              'div',
              {
                className: classes.wrapper,
                ref: function ref(node) {
                  _this2.wrapper = node;
                }
              },
              _react2.default.createElement(
                'div',
                { className: classes.wrapperInner },
                children
              )
            )
          );
        }
      );
    }
  }]);
  return Collapse;
}(_react2.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};

exports.default = (0, _withStyles2.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.hasValue = hasValue;
exports.isDirty = isDirty;
exports.isAdornedStart = isAdornedStart;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Textarea = __webpack_require__(1972);

var _Textarea2 = _interopRequireDefault(_Textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}

// Determine if field is dirty (a.k.a. filled).
//
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isDirty(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}

// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles = exports.styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';

  return {
    root: {
      // Mimics the default input display property used by browsers for an input.
      display: 'inline-flex',
      position: 'relative',
      fontFamily: theme.typography.fontFamily,
      color: light ? 'rgba(0, 0, 0, 0.87)' : theme.palette.common.white,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em' // Reset (19px), match the native input line-height
    },
    formControl: {
      'label + &': {
        marginTop: theme.spacing.unit * 2
      }
    },
    focused: {},
    disabled: {
      color: theme.palette.text.disabled
    },
    underline: {
      '&:after': {
        backgroundColor: theme.palette.primary[light ? 'dark' : 'light'],
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&:before': {
        backgroundColor: bottomLineColor,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&:hover:not($disabled):before': {
        backgroundColor: theme.palette.text.primary,
        height: 2
      },
      '&$disabled:before': {
        background: 'transparent',
        backgroundImage: 'linear-gradient(to right, ' + bottomLineColor + ' 33%, transparent 0%)',
        backgroundPosition: 'left top',
        backgroundRepeat: 'repeat-x',
        backgroundSize: '5px 1px'
      }
    },
    error: {
      '&:after': {
        backgroundColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red
      }
    },
    multiline: {
      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px'
    },
    fullWidth: {
      width: '100%'
    },
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px',
      border: 0,
      boxSizing: 'content-box',
      verticalAlign: 'middle',
      background: 'none',
      margin: 0, // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder, // Firefox 19+
      '&:-ms-input-placeholder': placeholder, // IE 11
      '&::-ms-input-placeholder': placeholder, // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden, // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden, // IE 11
        '&::-ms-input-placeholder': placeholderHidden, // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible, // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible, // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
      }
    },
    inputMarginDense: {
      paddingTop: theme.spacing.unit / 2 - 1
    },
    inputDisabled: {
      opacity: 1 // Reset iOS opacity
    },
    inputMultiline: {
      resize: 'none',
      padding: 0
    },
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height
    },
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    }
  };
};

function formControlState(props, context) {
  var disabled = props.disabled;
  var error = props.error;
  var margin = props.margin;

  if (context && context.muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = context.muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = context.muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = context.muiFormControl.margin;
    }
  }

  return {
    disabled: disabled,
    error: error,
    margin: margin
  };
}

var Input = function (_React$Component) {
  (0, _inherits3.default)(Input, _React$Component);

  function Input(props, context) {
    (0, _classCallCheck3.default)(this, Input);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call(this, props, context));

    _this.state = {
      focused: false
    };
    _this.input = null;

    _this.handleFocus = function (event) {
      // Fix an bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState(_this.props, _this.context).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({ focused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({ focused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.checkDirty(_this.input);
      }

      // Perform in the willUpdate
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleRefInput = function (node) {
      _this.input = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        _this.props.inputProps.ref(node);
      }
    };

    _this.isControlled = props.value != null;
    if (_this.isControlled) {
      _this.checkDirty(props);
    }
    return _this;
  }

  (0, _createClass3.default)(Input, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.input);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        this.setState({
          focused: false
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState, nextContext) {
      if (this.isControlled) {
        this.checkDirty(nextProps);
      } // else performed in the onChange

      // Book keep the focused state.
      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        var muiFormControl = this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    }

    // Holds the input reference

  }, {
    key: 'checkDirty',
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;


      if (isDirty(obj)) {
        if (muiFormControl && muiFormControl.onDirty) {
          muiFormControl.onDirty();
        }
        if (this.props.onDirty) {
          this.props.onDirty();
        }
        return;
      }

      if (muiFormControl && muiFormControl.onClean) {
        muiFormControl.onClean();
      }
      if (this.props.onClean) {
        this.props.onClean();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          autoComplete = _props.autoComplete,
          autoFocus = _props.autoFocus,
          classes = _props.classes,
          classNameProp = _props.className,
          defaultValue = _props.defaultValue,
          disabledProp = _props.disabled,
          disableUnderline = _props.disableUnderline,
          endAdornment = _props.endAdornment,
          errorProp = _props.error,
          fullWidth = _props.fullWidth,
          id = _props.id,
          inputComponent = _props.inputComponent,
          _props$inputProps = _props.inputProps;
      _props$inputProps = _props$inputProps === undefined ? {} : _props$inputProps;
      var inputPropsClassName = _props$inputProps.className,
          inputPropsProp = (0, _objectWithoutProperties3.default)(_props$inputProps, ['className']),
          inputRef = _props.inputRef,
          marginProp = _props.margin,
          multiline = _props.multiline,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClean = _props.onClean,
          onDirty = _props.onDirty,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          startAdornment = _props.startAdornment,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoComplete', 'autoFocus', 'classes', 'className', 'defaultValue', 'disabled', 'disableUnderline', 'endAdornment', 'error', 'fullWidth', 'id', 'inputComponent', 'inputProps', 'inputRef', 'margin', 'multiline', 'name', 'onBlur', 'onChange', 'onClean', 'onDirty', 'onFocus', 'onKeyDown', 'onKeyUp', 'placeholder', 'readOnly', 'rows', 'rowsMax', 'startAdornment', 'type', 'value']);
      var muiFormControl = this.context.muiFormControl;

      var _formControlState = formControlState(this.props, this.context),
          disabled = _formControlState.disabled,
          error = _formControlState.error,
          margin = _formControlState.margin;

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty3.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.multiline, multiline), (0, _defineProperty3.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);

      var inputClassName = (0, _classnames2.default)(classes.input, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.inputDisabled, disabled), (0, _defineProperty3.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty3.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty3.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty3.default)(_classNames2, classes.inputMarginDense, margin === 'dense'), _classNames2), inputPropsClassName);

      var required = muiFormControl && muiFormControl.required === true;

      var InputComponent = 'input';
      var inputProps = (0, _extends3.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (inputComponent) {
        InputComponent = inputComponent;
        inputProps = (0, _extends3.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends3.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea2.default;
        }
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: className }, other),
        startAdornment,
        _react2.default.createElement(InputComponent, (0, _extends3.default)({
          'aria-invalid': error,
          'aria-required': required,
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          className: inputClassName,
          defaultValue: defaultValue,
          disabled: disabled,
          id: id,
          name: name,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          placeholder: placeholder,
          readOnly: readOnly,
          required: required ? true : undefined,
          rows: rows,
          type: type,
          value: value
        }, inputProps)),
        endAdornment
      );
    }
  }]);
  return Input;
}(_react2.default.Component);

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes2.default.string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes2.default.string,
  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes2.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes2.default.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense', 'none']),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChange: _propTypes2.default.func,
  /**
   * TODO
   */
  onClean: _propTypes2.default.func,
  /**
   * TODO
   */
  onDirty: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes2.default.string,
  /**
   * @ignore
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes2.default.node,
  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes2.default.string,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

Input.muiName = 'Input';

Input.defaultProps = {
  disableUnderline: false,
  fullWidth: false,
  multiline: false,
  type: 'text'
};

Input.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

Input.childContextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInput' })(Input);

/***/ }),
/* 418 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(255),
    isArrayLike = __webpack_require__(148),
    isIndex = __webpack_require__(251),
    isObject = __webpack_require__(105);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(51),
    isKey = __webpack_require__(385),
    stringToPath = __webpack_require__(1622),
    toString = __webpack_require__(631);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__(281);

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__(1928);

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__(1937);

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__(1938);

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormGroup = __webpack_require__(839);

Object.defineProperty(exports, 'FormGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormGroup).default;
  }
});

var _FormLabel = __webpack_require__(1971);

Object.defineProperty(exports, 'FormLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormLabel).default;
  }
});

var _FormControl = __webpack_require__(840);

Object.defineProperty(exports, 'FormControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormControl).default;
  }
});

var _FormHelperText = __webpack_require__(841);

Object.defineProperty(exports, 'FormHelperText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormHelperText).default;
  }
});

var _FormControlLabel = __webpack_require__(1973);

Object.defineProperty(exports, 'FormControlLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormControlLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleRequestClose = exports.onToggleDrawer = exports.updateContactUser = exports.onAllContactSelect = exports.getUnselectedAllContact = exports.getAllContact = exports.filterContact = exports.onDeleteSelectedContact = exports.onDeleteContact = exports.onSaveContact = exports.onFilterOptionSelect = exports.onContactClose = exports.onAddContact = exports.onContactSelect = exports.addFavourite = exports.showContactMessage = exports.fetchContactsSuccess = exports.fetchContacts = undefined;

var _ActionTypes = __webpack_require__(41);

var fetchContacts = exports.fetchContacts = function fetchContacts() {
    return {
        type: _ActionTypes.FETCH_ALL_CONTACT
    };
};

var fetchContactsSuccess = exports.fetchContactsSuccess = function fetchContactsSuccess(contact) {
    return {
        type: _ActionTypes.FETCH_ALL_CONTACT_SUCCESS,
        payload: contact
    };
};
var showContactMessage = exports.showContactMessage = function showContactMessage(message) {
    return {
        type: _ActionTypes.SHOW_MESSAGE,
        payload: message
    };
};
var addFavourite = exports.addFavourite = function addFavourite(data) {
    return {
        type: _ActionTypes.ADD_FAVOURITE,
        payload: data
    };
};
var onContactSelect = exports.onContactSelect = function onContactSelect(data) {
    return {
        type: _ActionTypes.ON_CONTACT_SELECT,
        payload: data
    };
};

var onAddContact = exports.onAddContact = function onAddContact() {
    return {
        type: _ActionTypes.ON_ADD_CONTACT,
        payload: ''
    };
};
var onContactClose = exports.onContactClose = function onContactClose() {
    return {
        type: _ActionTypes.ON_CONTACT_CLOSE,
        payload: ''
    };
};
var onFilterOptionSelect = exports.onFilterOptionSelect = function onFilterOptionSelect(option) {
    return {
        type: _ActionTypes.ON_FILTER_OPTION_SELECT,
        payload: option
    };
};
var onSaveContact = exports.onSaveContact = function onSaveContact(data) {
    return {
        type: _ActionTypes.ON_SAVE_CONTACT,
        payload: data
    };
};
var onDeleteContact = exports.onDeleteContact = function onDeleteContact(data) {
    return {
        type: _ActionTypes.ON_DELETE_CONTACT,
        payload: data
    };
};
var onDeleteSelectedContact = exports.onDeleteSelectedContact = function onDeleteSelectedContact() {
    return {
        type: _ActionTypes.ON_DELETE_SELECTED_CONTACT,
        payload: ''
    };
};
var filterContact = exports.filterContact = function filterContact(userName) {
    return {
        type: _ActionTypes.FILTER_CONTACT,
        payload: userName
    };
};
var getAllContact = exports.getAllContact = function getAllContact() {
    return {
        type: _ActionTypes.GET_ALL_CONTACT,
        payload: ''
    };
};
var getUnselectedAllContact = exports.getUnselectedAllContact = function getUnselectedAllContact() {
    return {
        type: _ActionTypes.GET_UNSELECTED_ALL_CONTACT,
        payload: ''
    };
};
var onAllContactSelect = exports.onAllContactSelect = function onAllContactSelect() {
    return {
        type: _ActionTypes.ON_ALL_CONTACT_SELECT,
        payload: ''
    };
};
var updateContactUser = exports.updateContactUser = function updateContactUser(userName) {
    return {
        type: _ActionTypes.UPDATE_SEARCH_USER,
        payload: userName
    };
};
var onToggleDrawer = exports.onToggleDrawer = function onToggleDrawer() {
    return {
        type: _ActionTypes.ON_TOGGLE_DRAWER,
        payload: ''
    };
};
var handleRequestClose = exports.handleRequestClose = function handleRequestClose() {
    return {
        type: _ActionTypes.HANDLE_REQUEST_CLOSE,
        payload: ''
    };
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fetchContacts, 'fetchContacts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(fetchContactsSuccess, 'fetchContactsSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(showContactMessage, 'showContactMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(addFavourite, 'addFavourite', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onContactSelect, 'onContactSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onAddContact, 'onAddContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onContactClose, 'onContactClose', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onFilterOptionSelect, 'onFilterOptionSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onSaveContact, 'onSaveContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onDeleteContact, 'onDeleteContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onDeleteSelectedContact, 'onDeleteSelectedContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(filterContact, 'filterContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(getAllContact, 'getAllContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(getUnselectedAllContact, 'getUnselectedAllContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onAllContactSelect, 'onAllContactSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(updateContactUser, 'updateContactUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onToggleDrawer, 'onToggleDrawer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(handleRequestClose, 'handleRequestClose', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fetchContacts, 'fetchContacts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(fetchContactsSuccess, 'fetchContactsSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(showContactMessage, 'showContactMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(addFavourite, 'addFavourite', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onContactSelect, 'onContactSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onAddContact, 'onAddContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onContactClose, 'onContactClose', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onFilterOptionSelect, 'onFilterOptionSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onSaveContact, 'onSaveContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onDeleteContact, 'onDeleteContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onDeleteSelectedContact, 'onDeleteSelectedContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(filterContact, 'filterContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(getAllContact, 'getAllContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(getUnselectedAllContact, 'getUnselectedAllContact', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onAllContactSelect, 'onAllContactSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(updateContactUser, 'updateContactUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(onToggleDrawer, 'onToggleDrawer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(handleRequestClose, 'handleRequestClose', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Contact.js');
}();

;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1427);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1548),
    shortOut = __webpack_require__(612);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(49),
    stubFalse = __webpack_require__(1583);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(253),
    stackClear = __webpack_require__(1595),
    stackDelete = __webpack_require__(1596),
    stackGet = __webpack_require__(1597),
    stackHas = __webpack_require__(1598),
    stackSet = __webpack_require__(1599);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1612),
    isObjectLike = __webpack_require__(146);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(436),
    eq = __webpack_require__(255);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(610);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(34) && !__webpack_require__(23)(function () {
  return Object.defineProperty(__webpack_require__(289)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(32);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(61);
var toIObject = __webpack_require__(62);
var arrayIndexOf = __webpack_require__(206)(false);
var IE_PROTO = __webpack_require__(291)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(36);
var anObject = __webpack_require__(18);
var getKeys = __webpack_require__(121);

module.exports = __webpack_require__(34) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(62);
var gOPN = __webpack_require__(124).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(34);
var getKeys = __webpack_require__(121);
var gOPS = __webpack_require__(207);
var pIE = __webpack_require__(177);
var toObject = __webpack_require__(37);
var IObject = __webpack_require__(176);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(23)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(47);
var isObject = __webpack_require__(26);
var invoke = __webpack_require__(445);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 445 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(20).parseInt;
var $trim = __webpack_require__(151).trim;
var ws = __webpack_require__(295);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(20).parseFloat;
var $trim = __webpack_require__(151).trim;

module.exports = 1 / $parseFloat(__webpack_require__(295) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(70);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(26);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 450 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(298);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(18);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(47);
var toObject = __webpack_require__(37);
var IObject = __webpack_require__(176);
var toLength = __webpack_require__(33);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(122);
var toLength = __webpack_require__(33);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(310);
__webpack_require__(3)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(34) && /./g.flags != 'g') __webpack_require__(36).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(178)
});


/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(18);
var isObject = __webpack_require__(26);
var newPromiseCapability = __webpack_require__(314);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(461);
var validate = __webpack_require__(129);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(215)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(36).f;
var create = __webpack_require__(123);
var redefineAll = __webpack_require__(128);
var ctx = __webpack_require__(69);
var anInstance = __webpack_require__(126);
var forOf = __webpack_require__(127);
var $iterDefine = __webpack_require__(300);
var step = __webpack_require__(455);
var setSpecies = __webpack_require__(125);
var DESCRIPTORS = __webpack_require__(34);
var fastKey = __webpack_require__(107).fastKey;
var validate = __webpack_require__(129);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(461);
var validate = __webpack_require__(129);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(215)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var each = __webpack_require__(82)(0);
var redefine = __webpack_require__(54);
var meta = __webpack_require__(107);
var assign = __webpack_require__(442);
var weak = __webpack_require__(464);
var isObject = __webpack_require__(26);
var validate = __webpack_require__(129);
var NATIVE_WEAK_MAP = __webpack_require__(129);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(215)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(128);
var getWeak = __webpack_require__(107).getWeak;
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(26);
var anInstance = __webpack_require__(126);
var forOf = __webpack_require__(127);
var createArrayMethod = __webpack_require__(82);
var $has = __webpack_require__(61);
var validate = __webpack_require__(129);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(33);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(124);
var gOPS = __webpack_require__(207);
var anObject = __webpack_require__(18);
var Reflect = __webpack_require__(20).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(208);
var isObject = __webpack_require__(26);
var toLength = __webpack_require__(33);
var ctx = __webpack_require__(69);
var IS_CONCAT_SPREADABLE = __webpack_require__(32)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(33);
var repeat = __webpack_require__(297);
var defined = __webpack_require__(80);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(34);
var getKeys = __webpack_require__(121);
var toIObject = __webpack_require__(62);
var isEnum = __webpack_require__(177).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(150);
var from = __webpack_require__(471);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(127);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(220);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}




/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1098)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(221);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(318);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return go; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return goBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return goForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return routerActions; });

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(485);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(321);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1118);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1112);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(493);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(319);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(154);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(318);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(182);

var _reactRouterRedux = __webpack_require__(316);

var _Settings = __webpack_require__(1140);

var _Settings2 = _interopRequireDefault(_Settings);

var _Contact = __webpack_require__(1141);

var _Contact2 = _interopRequireDefault(_Contact);

var _Mail = __webpack_require__(1142);

var _Mail2 = _interopRequireDefault(_Mail);

var _ToDo = __webpack_require__(1143);

var _ToDo2 = _interopRequireDefault(_ToDo);

var _Auth = __webpack_require__(1144);

var _Auth2 = _interopRequireDefault(_Auth);

var _SymbioticReducer = __webpack_require__(1145);

var _SymbioticReducer2 = _interopRequireDefault(_SymbioticReducer);

var _ProfileInfo = __webpack_require__(1147);

var _ProfileInfo2 = _interopRequireDefault(_ProfileInfo);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

// import ChatData from './Chat';
var reducers = (0, _redux.combineReducers)({
    routing: _reactRouterRedux.routerReducer,
    settings: _Settings2.default,
    // chatData: ChatData,
    contacts: _Contact2.default,
    mail: _Mail2.default,
    toDo: _ToDo2.default,
    auth: _Auth2.default,
    symbioticReducer: _SymbioticReducer2.default,
    profileInfo: _ProfileInfo2.default
});

var _default = reducers;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(reducers, 'reducers', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_Settings2, '_Settings2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_Contact2, '_Contact2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_Mail2, '_Mail2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_ToDo2, '_ToDo2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_Auth2, '_Auth2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_SymbioticReducer2, '_SymbioticReducer2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_ProfileInfo2, '_ProfileInfo2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(reducers, 'reducers', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/index.js');
}();

;

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(500);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["b" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["A" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL_END; });
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["b"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(224);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["f" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return takeEvery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return takeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return throttle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onComposeMail = exports.setCurrentMailNull = exports.hideMailLoader = exports.onDeleteMail = exports.onMailToggleDrawer = exports.updateMailSearch = exports.getNavFolders = exports.onMailSelect = exports.onMailSend = exports.onImportantSelect = exports.onStartSelect = exports.onAllMailSelect = exports.onMailChecked = exports.onSearchMail = exports.getMailNavLabels = exports.getUnimportantMail = exports.getImportantMail = exports.getUnStarredMail = exports.getStarredMail = exports.getUnreadMail = exports.getReadMail = exports.getUnselectedAllMail = exports.getAllMail = exports.onOptionMenuItemSelect = exports.onMailOptionMenuSelect = exports.onMailLabelSelect = exports.onFolderSelect = exports.getMailNavFilters = exports.handleMailRequestClose = exports.onMailLabelMenuItemSelect = exports.onFolderMenuItemSelect = exports.showMailMessage = exports.fetchMailsSuccess = exports.fetchMails = undefined;

var _ActionTypes = __webpack_require__(41);

var _ActionTypes2 = __webpack_require__(41);

var fetchMails = exports.fetchMails = function fetchMails() {
    return {
        type: _ActionTypes.FETCH_ALL_MAIL
    };
};

var fetchMailsSuccess = exports.fetchMailsSuccess = function fetchMailsSuccess(mails) {
    return {
        type: _ActionTypes2.FETCH_ALL_MAIL_SUCCESS,
        payload: mails
    };
};
var showMailMessage = exports.showMailMessage = function showMailMessage(message) {
    return {
        type: _ActionTypes2.SHOW_MESSAGE,
        payload: message
    };
};
var onFolderMenuItemSelect = exports.onFolderMenuItemSelect = function onFolderMenuItemSelect(folderId) {
    return {
        type: _ActionTypes.ON_FOLDER_MENU_ITEM_SELECT,
        payload: folderId
    };
};

var onMailLabelMenuItemSelect = exports.onMailLabelMenuItemSelect = function onMailLabelMenuItemSelect(label) {
    return {
        type: _ActionTypes.ON_LABEL_MENU_ITEM_SELECT,
        payload: label
    };
};
var handleMailRequestClose = exports.handleMailRequestClose = function handleMailRequestClose() {
    return {
        type: _ActionTypes.HANDLE_REQUEST_CLOSE
    };
};

var getMailNavFilters = exports.getMailNavFilters = function getMailNavFilters(filter) {
    return {
        type: _ActionTypes.GET_NAV_FILTERS,
        payload: filter
    };
};
var onFolderSelect = exports.onFolderSelect = function onFolderSelect() {
    return {
        type: _ActionTypes.ON_FOLDER_SELECT
    };
};
var onMailLabelSelect = exports.onMailLabelSelect = function onMailLabelSelect() {
    return {
        type: _ActionTypes.ON_LABEL_SELECT
    };
};
var onMailOptionMenuSelect = exports.onMailOptionMenuSelect = function onMailOptionMenuSelect() {
    return {
        type: _ActionTypes.ON_OPTION_MENU_SELECT
    };
};
var onOptionMenuItemSelect = exports.onOptionMenuItemSelect = function onOptionMenuItemSelect(option) {
    return {
        type: _ActionTypes.ON_OPTION_MENU_ITEM_SELECT,
        payload: option
    };
};
var getAllMail = exports.getAllMail = function getAllMail() {
    return {
        type: _ActionTypes.GET_ALL_MAIL
    };
};
var getUnselectedAllMail = exports.getUnselectedAllMail = function getUnselectedAllMail() {
    return {
        type: _ActionTypes.GET_UNSELECTED_ALL_MAIL
    };
};
var getReadMail = exports.getReadMail = function getReadMail() {
    return {
        type: _ActionTypes.GET_READ_MAIL
    };
};
var getUnreadMail = exports.getUnreadMail = function getUnreadMail() {
    return {
        type: _ActionTypes.GET_UNREAD_MAIL
    };
};
var getStarredMail = exports.getStarredMail = function getStarredMail() {
    return {
        type: _ActionTypes.GET_STARRED_MAIL
    };
};

var getUnStarredMail = exports.getUnStarredMail = function getUnStarredMail() {
    return {
        type: _ActionTypes.GET_UNSTARRED_MAIL
    };
};
var getImportantMail = exports.getImportantMail = function getImportantMail() {
    return {
        type: _ActionTypes.GET_IMPORTANT_MAIL
    };
};
var getUnimportantMail = exports.getUnimportantMail = function getUnimportantMail() {
    return {
        type: _ActionTypes.GET_UNIMPORTANT_MAIL
    };
};
var getMailNavLabels = exports.getMailNavLabels = function getMailNavLabels(label) {
    return {
        type: _ActionTypes.GET_NAV_LABELS,
        payload: label
    };
};
var onSearchMail = exports.onSearchMail = function onSearchMail(searchText) {
    return {
        type: _ActionTypes.SEARCH_MAIL,
        payload: searchText
    };
};
var onMailChecked = exports.onMailChecked = function onMailChecked(data) {
    return {
        type: _ActionTypes.ON_MAIL_CHECKED,
        payload: data
    };
};

var onAllMailSelect = exports.onAllMailSelect = function onAllMailSelect() {
    return {
        type: _ActionTypes.ON_ALL_MAIL_SELECT
    };
};
var onStartSelect = exports.onStartSelect = function onStartSelect(data) {
    return {
        type: _ActionTypes.ON_START_SELECT,
        payload: data
    };
};
var onImportantSelect = exports.onImportantSelect = function onImportantSelect(data) {
    return {
        type: _ActionTypes.ON_IMPORTANT_SELECT,
        payload: data
    };
};
var onMailSend = exports.onMailSend = function onMailSend(data) {
    return {
        type: _ActionTypes.ON_MAIL_SEND,
        payload: data
    };
};
var onMailSelect = exports.onMailSelect = function onMailSelect(mail) {
    return {
        type: _ActionTypes.ON_MAIL_SELECT,
        payload: mail
    };
};
var getNavFolders = exports.getNavFolders = function getNavFolders(folder) {
    return {
        type: _ActionTypes.GET_NAV_FOLDER,
        payload: folder
    };
};

var updateMailSearch = exports.updateMailSearch = function updateMailSearch(searchText) {
    return {
        type: _ActionTypes.UPDATE_SEARCH,
        payload: searchText
    };
};
var onMailToggleDrawer = exports.onMailToggleDrawer = function onMailToggleDrawer() {
    return {
        type: _ActionTypes.ON_TOGGLE_DRAWER
    };
};
var onDeleteMail = exports.onDeleteMail = function onDeleteMail() {
    return {
        type: _ActionTypes.ON_DELETE_MAIL
    };
};
var hideMailLoader = exports.hideMailLoader = function hideMailLoader() {
    return {
        type: _ActionTypes.ON_HIDE_LOADER
    };
};
var setCurrentMailNull = exports.setCurrentMailNull = function setCurrentMailNull() {
    return {
        type: _ActionTypes.SET_CURRENT_MAIL_NULL
    };
};
var onComposeMail = exports.onComposeMail = function onComposeMail() {
    return {
        type: _ActionTypes.ON_COMPOSE_MAIL
    };
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fetchMails, 'fetchMails', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(fetchMailsSuccess, 'fetchMailsSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(showMailMessage, 'showMailMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onFolderMenuItemSelect, 'onFolderMenuItemSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailLabelMenuItemSelect, 'onMailLabelMenuItemSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(handleMailRequestClose, 'handleMailRequestClose', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getMailNavFilters, 'getMailNavFilters', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onFolderSelect, 'onFolderSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailLabelSelect, 'onMailLabelSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailOptionMenuSelect, 'onMailOptionMenuSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onOptionMenuItemSelect, 'onOptionMenuItemSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getAllMail, 'getAllMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnselectedAllMail, 'getUnselectedAllMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getReadMail, 'getReadMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnreadMail, 'getUnreadMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getStarredMail, 'getStarredMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnStarredMail, 'getUnStarredMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getImportantMail, 'getImportantMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnimportantMail, 'getUnimportantMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getMailNavLabels, 'getMailNavLabels', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onSearchMail, 'onSearchMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailChecked, 'onMailChecked', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onAllMailSelect, 'onAllMailSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onStartSelect, 'onStartSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onImportantSelect, 'onImportantSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailSend, 'onMailSend', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailSelect, 'onMailSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getNavFolders, 'getNavFolders', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(updateMailSearch, 'updateMailSearch', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailToggleDrawer, 'onMailToggleDrawer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onDeleteMail, 'onDeleteMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(hideMailLoader, 'hideMailLoader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(setCurrentMailNull, 'setCurrentMailNull', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onComposeMail, 'onComposeMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fetchMails, 'fetchMails', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(fetchMailsSuccess, 'fetchMailsSuccess', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(showMailMessage, 'showMailMessage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onFolderMenuItemSelect, 'onFolderMenuItemSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailLabelMenuItemSelect, 'onMailLabelMenuItemSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(handleMailRequestClose, 'handleMailRequestClose', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getMailNavFilters, 'getMailNavFilters', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onFolderSelect, 'onFolderSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailLabelSelect, 'onMailLabelSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailOptionMenuSelect, 'onMailOptionMenuSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onOptionMenuItemSelect, 'onOptionMenuItemSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getAllMail, 'getAllMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnselectedAllMail, 'getUnselectedAllMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getReadMail, 'getReadMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnreadMail, 'getUnreadMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getStarredMail, 'getStarredMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnStarredMail, 'getUnStarredMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getImportantMail, 'getImportantMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getUnimportantMail, 'getUnimportantMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getMailNavLabels, 'getMailNavLabels', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onSearchMail, 'onSearchMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailChecked, 'onMailChecked', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onAllMailSelect, 'onAllMailSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onStartSelect, 'onStartSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onImportantSelect, 'onImportantSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailSend, 'onMailSend', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailSelect, 'onMailSelect', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(getNavFolders, 'getNavFolders', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(updateMailSearch, 'updateMailSearch', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onMailToggleDrawer, 'onMailToggleDrawer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onDeleteMail, 'onDeleteMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(hideMailLoader, 'hideMailLoader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(setCurrentMailNull, 'setCurrentMailNull', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(onComposeMail, 'onComposeMail', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/Mail.js');
}();

;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1164);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(130);


// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    //if any key is missing in the new state which was present in the lastState,
    //add it for processing too
    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined) {
        keysToProcess.push(key);
      }
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });

    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(130);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(130);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generatorCounter = 0;

// Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === undefined ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === undefined ? 'jss' : _options$productionPr;

  var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
  var ruleCounter = 0;

  // - HMR can lead to many class name generators being instantiated,
  // so the warning is only triggered in production.
  // - We expect a class name generator to be instantiated per new request on the server,
  // so the warning is only triggered client side.
  // - You can get away with having multiple class name generators
  // by modifying the `productionPrefix`.
  if ("production" === 'production' && typeof window !== 'undefined' && productionPrefix === 'jss') {
    generatorCounter += 1;

    if (generatorCounter > 2) {
      // eslint-disable-next-line no-console
      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
    }
  }

  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning2.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    // Code branch the whole block at the expense of more code.
    if (dangerouslyUseGlobalCSS) {
      if (styleSheet && styleSheet.options.classNamePrefix) {
        var prefix = styleSheet.options.classNamePrefix;
        // Sanitize the string as will be used to prefix the generated class name.
        prefix = prefix.replace(escapeRegex, '-');

        if (prefix.match(/^Mui/)) {
          return prefix + '-' + rule.key;
        }

        if (false) {
          return prefix + '-' + rule.key + '-' + ruleCounter;
        }
      }

      if (true) {
        return '' + productionPrefix + ruleCounter;
      }

      return rule.key + '-' + ruleCounter;
    }

    if (true) {
      return '' + productionPrefix + ruleCounter;
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = styleSheet.options.classNamePrefix;
      // Sanitize the string as will be used to prefix the generated class name.
      _prefix = _prefix.replace(escapeRegex, '-');

      return _prefix + '-' + rule.key + '-' + ruleCounter;
    }

    return rule.key + '-' + ruleCounter;
  };
}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(75) && !__webpack_require__(133)(function () {
  return Object.defineProperty(__webpack_require__(510)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
var document = __webpack_require__(84).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(134);
var toIObject = __webpack_require__(156);
var arrayIndexOf = __webpack_require__(1192)(false);
var IE_PROTO = __webpack_require__(334)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

exports.default = red;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1197), __esModule: true };

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(50);
var core = __webpack_require__(45);
var fails = __webpack_require__(133);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1202), __esModule: true };

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssGlobal = __webpack_require__(1206);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

var _jssNested = __webpack_require__(1207);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCamelCase = __webpack_require__(1208);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(1209);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssVendorPrefixer = __webpack_require__(1211);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(1216);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal2.default)(), (0, _jssNested2.default)(), (0, _jssCamelCase2.default)(), (0, _jssDefaultUnit2.default)(), (0, _jssVendorPrefixer2.default)(), (0, _jssPropsSort2.default)()]
  };
}

exports.default = jssPreset;

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(134);
var toObject = __webpack_require__(135);
var IE_PROTO = __webpack_require__(334)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(111);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1226);
var global = __webpack_require__(84);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(189);
var TO_STRING_TAG = __webpack_require__(66)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(331);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(511);
var hiddenKeys = __webpack_require__(336).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(230);
var createDesc = __webpack_require__(186);
var toIObject = __webpack_require__(156);
var toPrimitive = __webpack_require__(329);
var has = __webpack_require__(134);
var IE8_DOM_DEFINE = __webpack_require__(509);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(75) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 525 */
/***/ (function(module, exports) {



/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(111);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(132);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(189);
var ITERATOR = __webpack_require__(66)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(531);
var ITERATOR = __webpack_require__(66)('iterator');
var Iterators = __webpack_require__(189);
module.exports = __webpack_require__(45).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(331);
var TAG = __webpack_require__(66)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(321);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(539);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(1269);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(537);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(192);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1284)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1291);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};

exports.default = cyan;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};

exports.default = lightBlue;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};

exports.default = teal;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

exports.default = blue;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};

exports.default = deepPurple;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

exports.default = orange;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Setting = __webpack_require__(240);

Object.keys(_Setting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Setting[key];
    }
  });
});

var _Contact = __webpack_require__(426);

Object.keys(_Contact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Contact[key];
    }
  });
});

var _Mail = __webpack_require__(502);

Object.keys(_Mail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Mail[key];
    }
  });
});

var _ToDo = __webpack_require__(1348);

Object.keys(_ToDo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ToDo[key];
    }
  });
});

var _Auth = __webpack_require__(185);

Object.keys(_Auth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Auth[key];
    }
  });
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/index.js');
}();

;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = __webpack_require__(1350);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AppBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: theme.spacing.unit * 5,
      height: theme.spacing.unit * 5,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE11.
      objectFit: 'cover'
    }
  };
};

function Avatar(props) {
  var alt = props.alt,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = (0, _objectWithoutProperties3.default)(props, ['alt', 'children', 'childrenClassName', 'classes', 'className', 'component', 'imgProps', 'sizes', 'src', 'srcSet']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
  var children = null;

  if (childrenProp) {
    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react2.default.isValidElement(childrenProp)) {
      var childrenClassName = (0, _classnames2.default)(childrenClassNameProp, childrenProp.props.className);
      children = _react2.default.cloneElement(childrenProp, { className: childrenClassName });
    } else {
      children = childrenProp;
    }
  } else if (src || srcSet) {
    children = _react2.default.createElement('img', (0, _extends3.default)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  }

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

Avatar.propTypes =  false ? {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes2.default.string,
  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   * The className of the child element.
   * Used by Chip and ListItemIcon to style the Avatar icon.
   */
  childrenClassName: _propTypes2.default.string,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `img` element when the component
   * is used to display an image.
   */
  imgProps: _propTypes2.default.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes2.default.string,
  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes2.default.string,
  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: _propTypes2.default.string
} : {};

Avatar.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAvatar' })(Avatar);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactTransitionGroup = __webpack_require__(357);

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Notification = _interopRequireDefault(__webpack_require__(1386));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notifications = /*#__PURE__*/function (_React$Component) {
  _inherits(Notifications, _React$Component);

  var _super = _createSuper(Notifications);

  function Notifications() {
    var _this;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
      return function () {
        var onRequestHide = _this.props.onRequestHide;

        if (onRequestHide) {
          onRequestHide(notification);
        }
      };
    });

    return _this;
  }

  _createClass(Notifications, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          notifications = _this$props.notifications,
          enterTimeout = _this$props.enterTimeout,
          leaveTimeout = _this$props.leaveTimeout;
      var className = (0, _classnames.default)('notification-container', {
        'notification-container-empty': notifications.length === 0
      });
      var items = notifications.map(function (notification, i) {
        var key = notification.id || new Date().getTime();
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: i,
          classNames: "notification",
          timeout: {
            enter: enterTimeout,
            exit: leaveTimeout
          }
        }, /*#__PURE__*/_react.default.createElement(_Notification.default, {
          key: key,
          type: notification.type,
          title: notification.title,
          message: notification.message,
          timeOut: notification.timeOut,
          onClick: notification.onClick,
          onRequestHide: _this2.handleRequestHide(notification)
        }));
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, items));
    }
  }]);

  return Notifications;
}(_react.default.Component);

_defineProperty(Notifications, "propTypes", {
  notifications: _propTypes.default.array,
  onRequestHide: _propTypes.default.func,
  enterTimeout: _propTypes.default.number,
  leaveTimeout: _propTypes.default.number
});

_defineProperty(Notifications, "defaultProps", {
  notifications: [],
  onRequestHide: function onRequestHide() {},
  enterTimeout: 400,
  leaveTimeout: 400
});

var _default = Notifications;
exports.default = _default;

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(1384);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" /* getInitialChildMapping */])(nextProps, handleExited) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" /* getNextChildMapping */])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" /* getChildMapping */])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
      value: contextValue
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = __webpack_require__(95);

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var createUUID = function createUUID() {
  var pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var Constants = {
  CHANGE: 'change',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

var NotificationManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(NotificationManager, _EventEmitter);

  var _super = _createSuper(NotificationManager);

  function NotificationManager() {
    var _this;

    _classCallCheck(this, NotificationManager);

    _this = _super.call(this);
    _this.listNotify = [];
    return _this;
  }

  _createClass(NotificationManager, [{
    key: "create",
    value: function create(notify) {
      var defaultNotify = {
        id: createUUID(),
        type: 'info',
        title: null,
        message: null,
        timeOut: 5000
      };

      if (notify.priority) {
        this.listNotify.unshift(Object.assign(defaultNotify, notify));
      } else {
        this.listNotify.push(Object.assign(defaultNotify, notify));
      }

      this.emitChange();
    }
  }, {
    key: "info",
    value: function info(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.INFO,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "success",
    value: function success(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.SUCCESS,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "warning",
    value: function warning(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.WARNING,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "error",
    value: function error(message, title, timeOut, onClick, priority) {
      this.create({
        type: Constants.ERROR,
        message: message,
        title: title,
        timeOut: timeOut,
        onClick: onClick,
        priority: priority
      });
    }
  }, {
    key: "remove",
    value: function remove(notification) {
      this.listNotify = this.listNotify.filter(function (n) {
        return notification.id !== n.id;
      });
      this.emitChange();
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      this.emit(Constants.CHANGE, this.listNotify);
    }
  }, {
    key: "addChangeListener",
    value: function addChangeListener(callback) {
      this.addListener(Constants.CHANGE, callback);
    }
  }, {
    key: "removeChangeListener",
    value: function removeChangeListener(callback) {
      this.removeListener(Constants.CHANGE, callback);
    }
  }]);

  return NotificationManager;
}(_events.EventEmitter);

var _default = new NotificationManager();

exports.default = _default;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _scrollbarSize = __webpack_require__(558);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Popover = __webpack_require__(559);

var _Popover2 = _interopRequireDefault(_Popover);

var _MenuList = __webpack_require__(569);

var _MenuList2 = _interopRequireDefault(_MenuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
}; // @inheritedComponent Popover

var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};

var styles = exports.styles = {
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100vh - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};

var Menu = function (_React$Component) {
  (0, _inherits3.default)(Menu, _React$Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.getContentAnchorEl = function () {
      if (!_this.menuList || !_this.menuList.selectedItem) {
        return (0, _reactDom.findDOMNode)(_this.menuList).firstChild;
      }

      return (0, _reactDom.findDOMNode)(_this.menuList.selectedItem);
    }, _this.menuList = undefined, _this.focus = function () {
      if (_this.menuList && _this.menuList.selectedItem) {
        (0, _reactDom.findDOMNode)(_this.menuList.selectedItem).focus();
        return;
      }

      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);
      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    }, _this.handleEnter = function (element) {
      var theme = _this.props.theme;

      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);

      // Focus so the scroll computation of the Popover works as expected.
      _this.focus();

      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = (0, _scrollbarSize2.default)() + 'px';
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = 'calc(100% + ' + size + ')';
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          MenuListProps = _props.MenuListProps,
          onEnter = _props.onEnter,
          _props$PaperProps = _props.PaperProps,
          PaperProps = _props$PaperProps === undefined ? {} : _props$PaperProps,
          PopoverClasses = _props.PopoverClasses,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'MenuListProps', 'onEnter', 'PaperProps', 'PopoverClasses', 'theme']);


      return _react2.default.createElement(
        _Popover2.default,
        (0, _extends3.default)({
          getContentAnchorEl: this.getContentAnchorEl,
          classes: PopoverClasses,
          onEnter: this.handleEnter,
          anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
          transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
          PaperProps: (0, _extends3.default)({}, PaperProps, {
            classes: (0, _extends3.default)({}, PaperProps.classes, {
              root: classes.paper
            })
          })
        }, other),
        _react2.default.createElement(
          _MenuList2.default,
          (0, _extends3.default)({
            role: 'menu',
            onKeyDown: this.handleListKeyDown
          }, MenuListProps, {
            ref: function ref(node) {
              _this2.menuList = node;
            }
          }),
          children
        )
      );
    }
  }]);
  return Menu;
}(_react2.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * Properties applied to the `MenuList` element.
   */
  MenuListProps: _propTypes2.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: _propTypes2.default.object,
  /**
   * `classes` property applied to the `Popover` element.
   */
  PopoverClasses: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Menu.defaultProps = {
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenu', withTheme: true })(Menu);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(243));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popover = __webpack_require__(1390);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 561 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(76));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 *
 * Internal helper component to allow attaching a ref to a
 * child element that may not accept refs (functional component).
 */
var RefHolder = function (_React$Component) {
  (0, _inherits3.default)(RefHolder, _React$Component);

  function RefHolder() {
    (0, _classCallCheck3.default)(this, RefHolder);
    return (0, _possibleConstructorReturn3.default)(this, (RefHolder.__proto__ || (0, _getPrototypeOf2.default)(RefHolder)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefHolder, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes =  false ? {
  children: _propTypes2.default.node
} : {};

exports.default = RefHolder;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Portal = __webpack_require__(1405);

var _Portal2 = _interopRequireDefault(_Portal);

var _LegacyPortal = __webpack_require__(1406);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactDom2.default.createPortal ? _Portal2.default : _LegacyPortal2.default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _style = __webpack_require__(1408);

var _style2 = _interopRequireDefault(_style);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _scrollbarSize = __webpack_require__(558);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(1416);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1418);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (item) {
    return item.modals.indexOf(modal) !== -1;
  });
}

function getPaddingRight(node) {
  return parseInt((0, _style2.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = { overflow: 'hidden' };

  // We are only interested in the actual `style` here because we will override it.
  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize2.default)();

    // Use computed style, here to get the real padding to add our scrollbar width.
    style.paddingRight = getPaddingRight(container) + scrollbarSize + 'px';

    // .mui-fixed is a global helper.
    var fixedNodes = (0, _ownerDocument2.default)(container).querySelectorAll('.mui-fixed');
    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = paddingRight + scrollbarSize + 'px';
    }
  }

  (0, _keys2.default)(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  (0, _keys2.default)(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });

  var fixedNodes = (0, _ownerDocument2.default)(container).querySelectorAll('.mui-fixed');
  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = data.prevPaddings[i] + 'px';
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class
 * Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function () {
  function ModalManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$hideSiblingNodes = _ref.hideSiblingNodes,
        hideSiblingNodes = _ref$hideSiblingNodes === undefined ? true : _ref$hideSiblingNodes,
        _ref$handleContainerO = _ref.handleContainerOverflow,
        handleContainerOverflow = _ref$handleContainerO === undefined ? true : _ref$handleContainerO;

    (0, _classCallCheck3.default)(this, ModalManager);

    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow;
    // this.modals[modalIdx] = modal
    this.modals = [];
    // this.containers[containerIdx] = container
    this.containers = [];
    // this.data[containerIdx] = {
    //   modals: [],
    // }
    this.data = [];
  }

  (0, _createClass3.default)(ModalManager, [{
    key: 'add',
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);
      var containerIdx = this.containers.indexOf(container);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        overflowing: (0, _isOverflowing2.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.containers.push(container);
      this.data.push(data);

      return modalIdx;
    }
  }, {
    key: 'remove',
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findContainer(this.data, modal);
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];

      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1);

      // If that was the last modal in a container, clean up the container.
      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }
        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a SR.
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }

      return modalIdx;
    }
  }, {
    key: 'isTopModal',
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

exports.default = ModalManager;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1409));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Fade = __webpack_require__(362);

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    zIndex: -1,
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    willChange: 'opacity',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  invisible: {
    backgroundColor: 'transparent'
  }
};

function Backdrop(props) {
  var classes = props.classes,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'invisible', 'open', 'transitionDuration']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.invisible, invisible));

  return _react2.default.createElement(
    _Fade2.default,
    (0, _extends3.default)({ appear: true, 'in': open, timeout: transitionDuration }, other),
    _react2.default.createElement('div', { className: className, 'aria-hidden': 'true' })
  );
}

Backdrop.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes2.default.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Backdrop.defaultProps = {
  invisible: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBackdrop' })(Backdrop);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(161);

var _Transition2 = _interopRequireDefault(_Transition);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _utils = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getScale(value) {
  return 'scale(' + value + ', ' + Math.pow(value, 2) + ')';
} // @inheritedComponent Transition

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: getScale(1)
  }
};

/**
 * The Grow transition is used by the [Popover](/demos/popovers) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = function (_React$Component) {
  (0, _inherits3.default)(Grow, _React$Component);

  function Grow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Grow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Grow.__proto__ || (0, _getPrototypeOf2.default)(Grow)).call.apply(_ref, [this].concat(args))), _this), _this.autoTimeout = undefined, _this.timer = null, _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;

      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;
      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;

      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');

      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Grow, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme', 'timeout']);


      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({
          appear: true,
          onEnter: this.handleEnter,
          onExit: this.handleExit,
          addEndListener: this.addEndListener,
          timeout: timeout === 'auto' ? null : timeout
        }, other),
        function (state, childProps) {
          return _react2.default.cloneElement(children, (0, _extends3.default)({
            style: (0, _extends3.default)({
              opacity: 0,
              transform: getScale(0.75)
            }, styles[state], style)
          }, childProps));
        }
      );
    }
  }]);
  return Grow;
}(_react2.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Grow.defaultProps = {
  timeout: 'auto'
};

exports.default = (0, _withTheme2.default)()(Grow);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(160);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _contains = __webpack_require__(242);

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = __webpack_require__(562);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _List = __webpack_require__(570);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent List

var MenuList = function (_React$Component) {
  (0, _inherits3.default)(MenuList, _React$Component);

  function MenuList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuList.__proto__ || (0, _getPrototypeOf2.default)(MenuList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTabIndex: undefined
    }, _this.list = undefined, _this.selectedItem = undefined, _this.blurTimer = undefined, _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.list) {
          var list = (0, _reactDom.findDOMNode)(_this.list);
          var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
          if (!(0, _contains2.default)(list, currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var list = (0, _reactDom.findDOMNode)(_this.list);
      var key = (0, _keycode2.default)(event);
      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains2.default)(list, currentFocus))) {
        if (_this.selectedItem) {
          (0, _reactDom.findDOMNode)(_this.selectedItem).focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();
        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();
        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    }, _this.handleItemFocus = function (event) {
      var list = (0, _reactDom.findDOMNode)(_this.list);
      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);
            break;
          }
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: 'setTabIndex',
    value: function setTabIndex(index) {
      this.setState({ currentTabIndex: index });
    }
  }, {
    key: 'focus',
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;

      var list = (0, _reactDom.findDOMNode)(this.list);
      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: 'resetTabIndex',
    value: function resetTabIndex() {
      var list = (0, _reactDom.findDOMNode)(this.list);
      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
      var items = [].concat((0, _toConsumableArray3.default)(list.children));
      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItem) {
        return this.setTabIndex(items.indexOf((0, _reactDom.findDOMNode)(this.selectedItem)));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onBlur = _props.onBlur,
          onKeyDown = _props.onKeyDown,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onBlur', 'onKeyDown']);


      return _react2.default.createElement(
        _List2.default,
        (0, _extends3.default)({
          role: 'menu',
          ref: function ref(node) {
            _this2.list = node;
          },
          className: className,
          onKeyDown: this.handleKeyDown,
          onBlur: this.handleBlur
        }, other),
        _react2.default.Children.map(children, function (child, index) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          return _react2.default.cloneElement(child, {
            tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
            ref: child.props.selected ? function (node) {
              _this2.selectedItem = node;
            } : undefined,
            onFocus: _this2.handleItemFocus
          });
        })
      );
    }
  }]);
  return MenuList;
}(_react2.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func
} : {};

exports.default = MenuList;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(1419);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _ListItem = __webpack_require__(571);

Object.defineProperty(exports, 'ListItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItem).default;
  }
});

var _ListItemAvatar = __webpack_require__(1420);

Object.defineProperty(exports, 'ListItemAvatar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemAvatar).default;
  }
});

var _ListItemText = __webpack_require__(1421);

Object.defineProperty(exports, 'ListItemText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemText).default;
  }
});

var _ListItemIcon = __webpack_require__(1423);

Object.defineProperty(exports, 'ListItemIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemIcon).default;
  }
});

var _ListItemSecondaryAction = __webpack_require__(1424);

Object.defineProperty(exports, 'ListItemSecondaryAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemSecondaryAction).default;
  }
});

var _ListSubheader = __webpack_require__(1425);

Object.defineProperty(exports, 'ListSubheader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListSubheader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _reactHelpers = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left'
    },
    container: {
      position: 'relative'
    },
    keyboardFocused: {
      backgroundColor: theme.palette.action.hover
    },
    default: {
      paddingTop: 12,
      paddingBottom: 12
    },
    dense: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: '1px solid ' + theme.palette.divider,
      backgroundClip: 'padding-box'
    },
    gutters: theme.mixins.gutters(),
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: theme.spacing.unit * 4
    }
  };
};

var ListItem = function (_React$Component) {
  (0, _inherits3.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          button = _props.button,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          componentProp = _props.component,
          ContainerComponent = _props.ContainerComponent,
          _props$ContainerProps = _props.ContainerProps;
      _props$ContainerProps = _props$ContainerProps === undefined ? {} : _props$ContainerProps;
      var ContainerClassName = _props$ContainerProps.className,
          ContainerProps = (0, _objectWithoutProperties3.default)(_props$ContainerProps, ['className']),
          dense = _props.dense,
          disabled = _props.disabled,
          disableGutters = _props.disableGutters,
          divider = _props.divider,
          other = (0, _objectWithoutProperties3.default)(_props, ['button', 'children', 'classes', 'className', 'component', 'ContainerComponent', 'ContainerProps', 'dense', 'disabled', 'disableGutters', 'divider']);


      var isDense = dense || this.context.dense || false;
      var children = _react2.default.Children.toArray(childrenProp);
      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);

      var className = (0, _classnames2.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty3.default)(_classNames, classes.divider, divider), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.button, button), (0, _defineProperty3.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);

      var componentProps = (0, _extends3.default)({ className: className, disabled: disabled }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.classes = {
          keyboardFocused: classes.keyboardFocused
        };
        Component = _ButtonBase2.default;
      }

      if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;

        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
          if (Component === 'li') {
            Component = 'div';
          } else if (componentProps.component === 'li') {
            componentProps.component = 'div';
          }
        }

        return _react2.default.createElement(
          ContainerComponent,
          (0, _extends3.default)({
            className: (0, _classnames2.default)(classes.container, ContainerClassName)
          }, ContainerProps),
          _react2.default.createElement(
            Component,
            componentProps,
            children
          ),
          children.pop()
        );
      }

      return _react2.default.createElement(
        Component,
        componentProps,
        children
      );
    }
  }]);
  return ListItem;
}(_react2.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The container component. Useful when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes2.default.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes2.default.bool,
  /**
   * @ignore
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes2.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes2.default.bool
} : {};

ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};

ListItem.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItem.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItem' })(ListItem);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AWS"] = factory();
	else
		root["AWS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(2);

	__webpack_require__(49);
	module.exports = AWS;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(4);

	AWS.util.isBrowser = function() { return true; };
	AWS.util.isNode = function() { return false; };

	// react-native specific modules
	AWS.util.crypto.lib = __webpack_require__(5);
	AWS.util.Buffer = __webpack_require__(8).Buffer;
	AWS.util.url = __webpack_require__(15);
	AWS.util.querystring = __webpack_require__(18);
	AWS.util.realClock = __webpack_require__(21);
	AWS.util.environment = 'js-react-native';
	AWS.util.createEventStream = __webpack_require__(22).createEventStream;

	/**
	 * @api private
	 */
	module.exports = AWS;

	__webpack_require__(28);
	__webpack_require__(29);
	__webpack_require__(30);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(42);

	// Load the DOMParser XML parser
	AWS.XML.Parser = __webpack_require__(43);

	// Load the XHR HttpClient
	__webpack_require__(45);

	// add custom request event handlers
	var addContentType = __webpack_require__(48).addContentType;
	AWS.EventListeners.Core.addNamedListeners(function(add) {
	  add('ADD_CONTENT_TYPE', 'afterBuild', addContentType);
	});

	if (typeof process === 'undefined') {
	  process = {};
	}
	process.browser = true;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["AWS"] = factory();
		else
			root["AWS"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};

	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {

	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;

	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};

	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;

	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}


	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;

	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;

	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";

	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(1);


	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {

		/**
		 * The main AWS namespace
		 */
		var AWS = { util: __webpack_require__(2) };

		/**
		 * @api private
		 * @!macro [new] nobrowser
		 *   @note This feature is not supported in the browser environment of the SDK.
		 */
		var _hidden = {}; _hidden.toString(); // hack to parse macro

		/**
		 * @api private
		 */
		module.exports = AWS;

		AWS.util.update(AWS, {

		  /**
		   * @constant
		   */
		  VERSION: '2.1127.0',

		  /**
		   * @api private
		   */
		  Signers: {},

		  /**
		   * @api private
		   */
		  Protocol: {
		    Json: __webpack_require__(13),
		    Query: __webpack_require__(17),
		    Rest: __webpack_require__(21),
		    RestJson: __webpack_require__(22),
		    RestXml: __webpack_require__(23)
		  },

		  /**
		   * @api private
		   */
		  XML: {
		    Builder: __webpack_require__(24),
		    Parser: null // conditionally set based on environment
		  },

		  /**
		   * @api private
		   */
		  JSON: {
		    Builder: __webpack_require__(14),
		    Parser: __webpack_require__(15)
		  },

		  /**
		   * @api private
		   */
		  Model: {
		    Api: __webpack_require__(29),
		    Operation: __webpack_require__(30),
		    Shape: __webpack_require__(19),
		    Paginator: __webpack_require__(31),
		    ResourceWaiter: __webpack_require__(32)
		  },

		  /**
		   * @api private
		   */
		  apiLoader: __webpack_require__(33),

		  /**
		   * @api private
		   */
		  EndpointCache: __webpack_require__(34).EndpointCache
		});
		__webpack_require__(36);
		__webpack_require__(37);
		__webpack_require__(41);
		__webpack_require__(44);
		__webpack_require__(45);
		__webpack_require__(50);
		__webpack_require__(53);
		__webpack_require__(54);
		__webpack_require__(55);
		__webpack_require__(63);

		/**
		 * @readonly
		 * @return [AWS.SequentialExecutor] a collection of global event listeners that
		 *   are attached to every sent request.
		 * @see AWS.Request AWS.Request for a list of events to listen for
		 * @example Logging the time taken to send a request
		 *   AWS.events.on('send', function startSend(resp) {
		 *     resp.startTime = new Date().getTime();
		 *   }).on('complete', function calculateTime(resp) {
		 *     var time = (new Date().getTime() - resp.startTime) / 1000;
		 *     console.log('Request took ' + time + ' seconds');
		 *   });
		 *
		 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
		 */
		AWS.events = new AWS.SequentialExecutor();

		//create endpoint cache lazily
		AWS.util.memoizedProperty(AWS, 'endpointCache', function() {
		  return new AWS.EndpointCache(AWS.config.endpointCacheSize);
		}, true);


	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
		var AWS;

		/**
		 * A set of utility methods for use with the AWS SDK.
		 *
		 * @!attribute abort
		 *   Return this value from an iterator function {each} or {arrayEach}
		 *   to break out of the iteration.
		 *   @example Breaking out of an iterator function
		 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
		 *       if (key == 'b') return AWS.util.abort;
		 *     });
		 *   @see each
		 *   @see arrayEach
		 * @api private
		 */
		var util = {
		  environment: 'nodejs',
		  engine: function engine() {
		    if (util.isBrowser() && typeof navigator !== 'undefined') {
		      return navigator.userAgent;
		    } else {
		      var engine = process.platform + '/' + process.version;
		      if (process.env.AWS_EXECUTION_ENV) {
		        engine += ' exec-env/' + process.env.AWS_EXECUTION_ENV;
		      }
		      return engine;
		    }
		  },

		  userAgent: function userAgent() {
		    var name = util.environment;
		    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(1).VERSION;
		    if (name === 'nodejs') agent += ' ' + util.engine();
		    return agent;
		  },

		  uriEscape: function uriEscape(string) {
		    var output = encodeURIComponent(string);
		    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

		    // AWS percent-encodes some extra non-standard characters in a URI
		    output = output.replace(/[*]/g, function(ch) {
		      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
		    });

		    return output;
		  },

		  uriEscapePath: function uriEscapePath(string) {
		    var parts = [];
		    util.arrayEach(string.split('/'), function (part) {
		      parts.push(util.uriEscape(part));
		    });
		    return parts.join('/');
		  },

		  urlParse: function urlParse(url) {
		    return util.url.parse(url);
		  },

		  urlFormat: function urlFormat(url) {
		    return util.url.format(url);
		  },

		  queryStringParse: function queryStringParse(qs) {
		    return util.querystring.parse(qs);
		  },

		  queryParamsToString: function queryParamsToString(params) {
		    var items = [];
		    var escape = util.uriEscape;
		    var sortedKeys = Object.keys(params).sort();

		    util.arrayEach(sortedKeys, function(name) {
		      var value = params[name];
		      var ename = escape(name);
		      var result = ename + '=';
		      if (Array.isArray(value)) {
		        var vals = [];
		        util.arrayEach(value, function(item) { vals.push(escape(item)); });
		        result = ename + '=' + vals.sort().join('&' + ename + '=');
		      } else if (value !== undefined && value !== null) {
		        result = ename + '=' + escape(value);
		      }
		      items.push(result);
		    });

		    return items.join('&');
		  },

		  readFileSync: function readFileSync(path) {
		    if (util.isBrowser()) return null;
		    return __webpack_require__(6).readFileSync(path, 'utf-8');
		  },

		  base64: {
		    encode: function encode64(string) {
		      if (typeof string === 'number') {
		        throw util.error(new Error('Cannot base64 encode number ' + string));
		      }
		      if (string === null || typeof string === 'undefined') {
		        return string;
		      }
		      var buf = util.buffer.toBuffer(string);
		      return buf.toString('base64');
		    },

		    decode: function decode64(string) {
		      if (typeof string === 'number') {
		        throw util.error(new Error('Cannot base64 decode number ' + string));
		      }
		      if (string === null || typeof string === 'undefined') {
		        return string;
		      }
		      return util.buffer.toBuffer(string, 'base64');
		    }

		  },

		  buffer: {
		    /**
		     * Buffer constructor for Node buffer and buffer pollyfill
		     */
		    toBuffer: function(data, encoding) {
		      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ?
		        util.Buffer.from(data, encoding) : new util.Buffer(data, encoding);
		    },

		    alloc: function(size, fill, encoding) {
		      if (typeof size !== 'number') {
		        throw new Error('size passed to alloc must be a number.');
		      }
		      if (typeof util.Buffer.alloc === 'function') {
		        return util.Buffer.alloc(size, fill, encoding);
		      } else {
		        var buf = new util.Buffer(size);
		        if (fill !== undefined && typeof buf.fill === 'function') {
		          buf.fill(fill, undefined, undefined, encoding);
		        }
		        return buf;
		      }
		    },

		    toStream: function toStream(buffer) {
		      if (!util.Buffer.isBuffer(buffer)) buffer =  util.buffer.toBuffer(buffer);

		      var readable = new (util.stream.Readable)();
		      var pos = 0;
		      readable._read = function(size) {
		        if (pos >= buffer.length) return readable.push(null);

		        var end = pos + size;
		        if (end > buffer.length) end = buffer.length;
		        readable.push(buffer.slice(pos, end));
		        pos = end;
		      };

		      return readable;
		    },

		    /**
		     * Concatenates a list of Buffer objects.
		     */
		    concat: function(buffers) {
		      var length = 0,
		          offset = 0,
		          buffer = null, i;

		      for (i = 0; i < buffers.length; i++) {
		        length += buffers[i].length;
		      }

		      buffer = util.buffer.alloc(length);

		      for (i = 0; i < buffers.length; i++) {
		        buffers[i].copy(buffer, offset);
		        offset += buffers[i].length;
		      }

		      return buffer;
		    }
		  },

		  string: {
		    byteLength: function byteLength(string) {
		      if (string === null || string === undefined) return 0;
		      if (typeof string === 'string') string = util.buffer.toBuffer(string);

		      if (typeof string.byteLength === 'number') {
		        return string.byteLength;
		      } else if (typeof string.length === 'number') {
		        return string.length;
		      } else if (typeof string.size === 'number') {
		        return string.size;
		      } else if (typeof string.path === 'string') {
		        return __webpack_require__(6).lstatSync(string.path).size;
		      } else {
		        throw util.error(new Error('Cannot determine length of ' + string),
		          { object: string });
		      }
		    },

		    upperFirst: function upperFirst(string) {
		      return string[0].toUpperCase() + string.substr(1);
		    },

		    lowerFirst: function lowerFirst(string) {
		      return string[0].toLowerCase() + string.substr(1);
		    }
		  },

		  ini: {
		    parse: function string(ini) {
		      var currentSection, map = {};
		      util.arrayEach(ini.split(/\r?\n/), function(line) {
		        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
		        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
		        if (section) {
		          currentSection = section[1];
		          if (currentSection === '__proto__' || currentSection.split(/\s/)[1] === '__proto__') {
		            throw util.error(
		              new Error('Cannot load profile name \'' + currentSection + '\' from shared ini file.')
		            );
		          }
		        } else if (currentSection) {
		          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
		          if (item) {
		            map[currentSection] = map[currentSection] || {};
		            map[currentSection][item[1]] = item[2];
		          }
		        }
		      });

		      return map;
		    }
		  },

		  fn: {
		    noop: function() {},
		    callback: function (err) { if (err) throw err; },

		    /**
		     * Turn a synchronous function into as "async" function by making it call
		     * a callback. The underlying function is called with all but the last argument,
		     * which is treated as the callback. The callback is passed passed a first argument
		     * of null on success to mimick standard node callbacks.
		     */
		    makeAsync: function makeAsync(fn, expectedArgs) {
		      if (expectedArgs && expectedArgs <= fn.length) {
		        return fn;
		      }

		      return function() {
		        var args = Array.prototype.slice.call(arguments, 0);
		        var callback = args.pop();
		        var result = fn.apply(null, args);
		        callback(result);
		      };
		    }
		  },

		  /**
		   * Date and time utility functions.
		   */
		  date: {

		    /**
		     * @return [Date] the current JavaScript date object. Since all
		     *   AWS services rely on this date object, you can override
		     *   this function to provide a special time value to AWS service
		     *   requests.
		     */
		    getDate: function getDate() {
		      if (!AWS) AWS = __webpack_require__(1);
		      if (AWS.config.systemClockOffset) { // use offset when non-zero
		        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
		      } else {
		        return new Date();
		      }
		    },

		    /**
		     * @return [String] the date in ISO-8601 format
		     */
		    iso8601: function iso8601(date) {
		      if (date === undefined) { date = util.date.getDate(); }
		      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
		    },

		    /**
		     * @return [String] the date in RFC 822 format
		     */
		    rfc822: function rfc822(date) {
		      if (date === undefined) { date = util.date.getDate(); }
		      return date.toUTCString();
		    },

		    /**
		     * @return [Integer] the UNIX timestamp value for the current time
		     */
		    unixTimestamp: function unixTimestamp(date) {
		      if (date === undefined) { date = util.date.getDate(); }
		      return date.getTime() / 1000;
		    },

		    /**
		     * @param [String,number,Date] date
		     * @return [Date]
		     */
		    from: function format(date) {
		      if (typeof date === 'number') {
		        return new Date(date * 1000); // unix timestamp
		      } else {
		        return new Date(date);
		      }
		    },

		    /**
		     * Given a Date or date-like value, this function formats the
		     * date into a string of the requested value.
		     * @param [String,number,Date] date
		     * @param [String] formatter Valid formats are:
		     #   * 'iso8601'
		     #   * 'rfc822'
		     #   * 'unixTimestamp'
		     * @return [String]
		     */
		    format: function format(date, formatter) {
		      if (!formatter) formatter = 'iso8601';
		      return util.date[formatter](util.date.from(date));
		    },

		    parseTimestamp: function parseTimestamp(value) {
		      if (typeof value === 'number') { // unix timestamp (number)
		        return new Date(value * 1000);
		      } else if (value.match(/^\d+$/)) { // unix timestamp
		        return new Date(value * 1000);
		      } else if (value.match(/^\d{4}/)) { // iso8601
		        return new Date(value);
		      } else if (value.match(/^\w{3},/)) { // rfc822
		        return new Date(value);
		      } else {
		        throw util.error(
		          new Error('unhandled timestamp format: ' + value),
		          {code: 'TimestampParserError'});
		      }
		    }

		  },

		  crypto: {
		    crc32Table: [
		     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
		     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
		     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
		     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
		     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
		     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
		     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
		     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
		     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
		     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
		     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
		     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
		     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
		     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
		     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
		     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
		     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
		     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
		     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
		     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
		     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
		     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
		     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
		     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
		     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
		     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
		     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
		     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
		     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
		     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
		     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
		     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
		     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
		     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
		     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
		     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
		     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
		     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
		     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
		     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
		     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
		     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
		     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
		     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
		     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
		     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
		     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
		     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
		     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
		     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
		     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
		     0x2D02EF8D],

		    crc32: function crc32(data) {
		      var tbl = util.crypto.crc32Table;
		      var crc = 0 ^ -1;

		      if (typeof data === 'string') {
		        data = util.buffer.toBuffer(data);
		      }

		      for (var i = 0; i < data.length; i++) {
		        var code = data.readUInt8(i);
		        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
		      }
		      return (crc ^ -1) >>> 0;
		    },

		    hmac: function hmac(key, string, digest, fn) {
		      if (!digest) digest = 'binary';
		      if (digest === 'buffer') { digest = undefined; }
		      if (!fn) fn = 'sha256';
		      if (typeof string === 'string') string = util.buffer.toBuffer(string);
		      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
		    },

		    md5: function md5(data, digest, callback) {
		      return util.crypto.hash('md5', data, digest, callback);
		    },

		    sha256: function sha256(data, digest, callback) {
		      return util.crypto.hash('sha256', data, digest, callback);
		    },

		    hash: function(algorithm, data, digest, callback) {
		      var hash = util.crypto.createHash(algorithm);
		      if (!digest) { digest = 'binary'; }
		      if (digest === 'buffer') { digest = undefined; }
		      if (typeof data === 'string') data = util.buffer.toBuffer(data);
		      var sliceFn = util.arraySliceFn(data);
		      var isBuffer = util.Buffer.isBuffer(data);
		      //Identifying objects with an ArrayBuffer as buffers
		      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

		      if (callback && typeof data === 'object' &&
		          typeof data.on === 'function' && !isBuffer) {
		        data.on('data', function(chunk) { hash.update(chunk); });
		        data.on('error', function(err) { callback(err); });
		        data.on('end', function() { callback(null, hash.digest(digest)); });
		      } else if (callback && sliceFn && !isBuffer &&
		                 typeof FileReader !== 'undefined') {
		        // this might be a File/Blob
		        var index = 0, size = 1024 * 512;
		        var reader = new FileReader();
		        reader.onerror = function() {
		          callback(new Error('Failed to read data.'));
		        };
		        reader.onload = function() {
		          var buf = new util.Buffer(new Uint8Array(reader.result));
		          hash.update(buf);
		          index += buf.length;
		          reader._continueReading();
		        };
		        reader._continueReading = function() {
		          if (index >= data.size) {
		            callback(null, hash.digest(digest));
		            return;
		          }

		          var back = index + size;
		          if (back > data.size) back = data.size;
		          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
		        };

		        reader._continueReading();
		      } else {
		        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
		          data = new util.Buffer(new Uint8Array(data));
		        }
		        var out = hash.update(data).digest(digest);
		        if (callback) callback(null, out);
		        return out;
		      }
		    },

		    toHex: function toHex(data) {
		      var out = [];
		      for (var i = 0; i < data.length; i++) {
		        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
		      }
		      return out.join('');
		    },

		    createHash: function createHash(algorithm) {
		      return util.crypto.lib.createHash(algorithm);
		    }

		  },

		  /** @!ignore */

		  /* Abort constant */
		  abort: {},

		  each: function each(object, iterFunction) {
		    for (var key in object) {
		      if (Object.prototype.hasOwnProperty.call(object, key)) {
		        var ret = iterFunction.call(this, key, object[key]);
		        if (ret === util.abort) break;
		      }
		    }
		  },

		  arrayEach: function arrayEach(array, iterFunction) {
		    for (var idx in array) {
		      if (Object.prototype.hasOwnProperty.call(array, idx)) {
		        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
		        if (ret === util.abort) break;
		      }
		    }
		  },

		  update: function update(obj1, obj2) {
		    util.each(obj2, function iterator(key, item) {
		      obj1[key] = item;
		    });
		    return obj1;
		  },

		  merge: function merge(obj1, obj2) {
		    return util.update(util.copy(obj1), obj2);
		  },

		  copy: function copy(object) {
		    if (object === null || object === undefined) return object;
		    var dupe = {};
		    // jshint forin:false
		    for (var key in object) {
		      dupe[key] = object[key];
		    }
		    return dupe;
		  },

		  isEmpty: function isEmpty(obj) {
		    for (var prop in obj) {
		      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
		        return false;
		      }
		    }
		    return true;
		  },

		  arraySliceFn: function arraySliceFn(obj) {
		    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
		    return typeof fn === 'function' ? fn : null;
		  },

		  isType: function isType(obj, type) {
		    // handle cross-"frame" objects
		    if (typeof type === 'function') type = util.typeName(type);
		    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
		  },

		  typeName: function typeName(type) {
		    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
		    var str = type.toString();
		    var match = str.match(/^\s*function (.+)\(/);
		    return match ? match[1] : str;
		  },

		  error: function error(err, options) {
		    var originalError = null;
		    if (typeof err.message === 'string' && err.message !== '') {
		      if (typeof options === 'string' || (options && options.message)) {
		        originalError = util.copy(err);
		        originalError.message = err.message;
		      }
		    }
		    err.message = err.message || null;

		    if (typeof options === 'string') {
		      err.message = options;
		    } else if (typeof options === 'object' && options !== null) {
		      util.update(err, options);
		      if (options.message)
		        err.message = options.message;
		      if (options.code || options.name)
		        err.code = options.code || options.name;
		      if (options.stack)
		        err.stack = options.stack;
		    }

		    if (typeof Object.defineProperty === 'function') {
		      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
		      Object.defineProperty(err, 'message', {enumerable: true});
		    }

		    err.name = String(options && options.name || err.name || err.code || 'Error');
		    err.time = new Date();

		    if (originalError) err.originalError = originalError;

		    return err;
		  },

		  /**
		   * @api private
		   */
		  inherit: function inherit(klass, features) {
		    var newObject = null;
		    if (features === undefined) {
		      features = klass;
		      klass = Object;
		      newObject = {};
		    } else {
		      var ctor = function ConstructorWrapper() {};
		      ctor.prototype = klass.prototype;
		      newObject = new ctor();
		    }

		    // constructor not supplied, create pass-through ctor
		    if (features.constructor === Object) {
		      features.constructor = function() {
		        if (klass !== Object) {
		          return klass.apply(this, arguments);
		        }
		      };
		    }

		    features.constructor.prototype = newObject;
		    util.update(features.constructor.prototype, features);
		    features.constructor.__super__ = klass;
		    return features.constructor;
		  },

		  /**
		   * @api private
		   */
		  mixin: function mixin() {
		    var klass = arguments[0];
		    for (var i = 1; i < arguments.length; i++) {
		      // jshint forin:false
		      for (var prop in arguments[i].prototype) {
		        var fn = arguments[i].prototype[prop];
		        if (prop !== 'constructor') {
		          klass.prototype[prop] = fn;
		        }
		      }
		    }
		    return klass;
		  },

		  /**
		   * @api private
		   */
		  hideProperties: function hideProperties(obj, props) {
		    if (typeof Object.defineProperty !== 'function') return;

		    util.arrayEach(props, function (key) {
		      Object.defineProperty(obj, key, {
		        enumerable: false, writable: true, configurable: true });
		    });
		  },

		  /**
		   * @api private
		   */
		  property: function property(obj, name, value, enumerable, isValue) {
		    var opts = {
		      configurable: true,
		      enumerable: enumerable !== undefined ? enumerable : true
		    };
		    if (typeof value === 'function' && !isValue) {
		      opts.get = value;
		    }
		    else {
		      opts.value = value; opts.writable = true;
		    }

		    Object.defineProperty(obj, name, opts);
		  },

		  /**
		   * @api private
		   */
		  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
		    var cachedValue = null;

		    // build enumerable attribute for each value with lazy accessor.
		    util.property(obj, name, function() {
		      if (cachedValue === null) {
		        cachedValue = get();
		      }
		      return cachedValue;
		    }, enumerable);
		  },

		  /**
		   * TODO Remove in major version revision
		   * This backfill populates response data without the
		   * top-level payload name.
		   *
		   * @api private
		   */
		  hoistPayloadMember: function hoistPayloadMember(resp) {
		    var req = resp.request;
		    var operationName = req.operation;
		    var operation = req.service.api.operations[operationName];
		    var output = operation.output;
		    if (output.payload && !operation.hasEventOutput) {
		      var payloadMember = output.members[output.payload];
		      var responsePayload = resp.data[output.payload];
		      if (payloadMember.type === 'structure') {
		        util.each(responsePayload, function(key, value) {
		          util.property(resp.data, key, value, false);
		        });
		      }
		    }
		  },

		  /**
		   * Compute SHA-256 checksums of streams
		   *
		   * @api private
		   */
		  computeSha256: function computeSha256(body, done) {
		    if (util.isNode()) {
		      var Stream = util.stream.Stream;
		      var fs = __webpack_require__(6);
		      if (typeof Stream === 'function' && body instanceof Stream) {
		        if (typeof body.path === 'string') { // assume file object
		          var settings = {};
		          if (typeof body.start === 'number') {
		            settings.start = body.start;
		          }
		          if (typeof body.end === 'number') {
		            settings.end = body.end;
		          }
		          body = fs.createReadStream(body.path, settings);
		        } else { // TODO support other stream types
		          return done(new Error('Non-file stream objects are ' +
		                                'not supported with SigV4'));
		        }
		      }
		    }

		    util.crypto.sha256(body, 'hex', function(err, sha) {
		      if (err) done(err);
		      else done(null, sha);
		    });
		  },

		  /**
		   * @api private
		   */
		  isClockSkewed: function isClockSkewed(serverTime) {
		    if (serverTime) {
		      util.property(AWS.config, 'isClockSkewed',
		        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
		      return AWS.config.isClockSkewed;
		    }
		  },

		  applyClockOffset: function applyClockOffset(serverTime) {
		    if (serverTime)
		      AWS.config.systemClockOffset = serverTime - new Date().getTime();
		  },

		  /**
		   * @api private
		   */
		  extractRequestId: function extractRequestId(resp) {
		    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
		                     resp.httpResponse.headers['x-amzn-requestid'];

		    if (!requestId && resp.data && resp.data.ResponseMetadata) {
		      requestId = resp.data.ResponseMetadata.RequestId;
		    }

		    if (requestId) {
		      resp.requestId = requestId;
		    }

		    if (resp.error) {
		      resp.error.requestId = requestId;
		    }
		  },

		  /**
		   * @api private
		   */
		  addPromises: function addPromises(constructors, PromiseDependency) {
		    var deletePromises = false;
		    if (PromiseDependency === undefined && AWS && AWS.config) {
		      PromiseDependency = AWS.config.getPromisesDependency();
		    }
		    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
		      PromiseDependency = Promise;
		    }
		    if (typeof PromiseDependency !== 'function') deletePromises = true;
		    if (!Array.isArray(constructors)) constructors = [constructors];

		    for (var ind = 0; ind < constructors.length; ind++) {
		      var constructor = constructors[ind];
		      if (deletePromises) {
		        if (constructor.deletePromisesFromClass) {
		          constructor.deletePromisesFromClass();
		        }
		      } else if (constructor.addPromisesToClass) {
		        constructor.addPromisesToClass(PromiseDependency);
		      }
		    }
		  },

		  /**
		   * @api private
		   * Return a function that will return a promise whose fate is decided by the
		   * callback behavior of the given method with `methodName`. The method to be
		   * promisified should conform to node.js convention of accepting a callback as
		   * last argument and calling that callback with error as the first argument
		   * and success value on the second argument.
		   */
		  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
		    return function promise() {
		      var self = this;
		      var args = Array.prototype.slice.call(arguments);
		      return new PromiseDependency(function(resolve, reject) {
		        args.push(function(err, data) {
		          if (err) {
		            reject(err);
		          } else {
		            resolve(data);
		          }
		        });
		        self[methodName].apply(self, args);
		      });
		    };
		  },

		  /**
		   * @api private
		   */
		  isDualstackAvailable: function isDualstackAvailable(service) {
		    if (!service) return false;
		    var metadata = __webpack_require__(7);
		    if (typeof service !== 'string') service = service.serviceIdentifier;
		    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
		    return !!metadata[service].dualstackAvailable;
		  },

		  /**
		   * @api private
		   */
		  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions, err) {
		    if (!retryDelayOptions) retryDelayOptions = {};
		    var customBackoff = retryDelayOptions.customBackoff || null;
		    if (typeof customBackoff === 'function') {
		      return customBackoff(retryCount, err);
		    }
		    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
		    var delay = Math.random() * (Math.pow(2, retryCount) * base);
		    return delay;
		  },

		  /**
		   * @api private
		   */
		  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
		    if (!options) options = {};
		    var http = AWS.HttpClient.getInstance();
		    var httpOptions = options.httpOptions || {};
		    var retryCount = 0;

		    var errCallback = function(err) {
		      var maxRetries = options.maxRetries || 0;
		      if (err && err.code === 'TimeoutError') err.retryable = true;

		      // Call `calculateRetryDelay()` only when relevant, see #3401
		      if (err && err.retryable && retryCount < maxRetries) {
		        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions, err);
		        if (delay >= 0) {
		          retryCount++;
		          setTimeout(sendRequest, delay + (err.retryAfter || 0));
		          return;
		        }
		      }
		      cb(err);
		    };

		    var sendRequest = function() {
		      var data = '';
		      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
		        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
		        httpResponse.on('end', function() {
		          var statusCode = httpResponse.statusCode;
		          if (statusCode < 300) {
		            cb(null, data);
		          } else {
		            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
		            var err = util.error(new Error(),
		              {
		                statusCode: statusCode,
		                retryable: statusCode >= 500 || statusCode === 429
		              }
		            );
		            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
		            errCallback(err);
		          }
		        });
		      }, errCallback);
		    };

		    AWS.util.defer(sendRequest);
		  },

		  /**
		   * @api private
		   */
		  uuid: {
		    v4: function uuidV4() {
		      return __webpack_require__(8).v4();
		    }
		  },

		  /**
		   * @api private
		   */
		  convertPayloadToString: function convertPayloadToString(resp) {
		    var req = resp.request;
		    var operation = req.operation;
		    var rules = req.service.api.operations[operation].output || {};
		    if (rules.payload && resp.data[rules.payload]) {
		      resp.data[rules.payload] = resp.data[rules.payload].toString();
		    }
		  },

		  /**
		   * @api private
		   */
		  defer: function defer(callback) {
		    if (typeof process === 'object' && typeof process.nextTick === 'function') {
		      process.nextTick(callback);
		    } else if (typeof setImmediate === 'function') {
		      setImmediate(callback);
		    } else {
		      setTimeout(callback, 0);
		    }
		  },

		  /**
		   * @api private
		   */
		  getRequestPayloadShape: function getRequestPayloadShape(req) {
		    var operations = req.service.api.operations;
		    if (!operations) return undefined;
		    var operation = (operations || {})[req.operation];
		    if (!operation || !operation.input || !operation.input.payload) return undefined;
		    return operation.input.members[operation.input.payload];
		  },

		  getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
		    var profiles = {};
		    var profilesFromConfig = {};
		    if (process.env[util.configOptInEnv]) {
		      var profilesFromConfig = iniLoader.loadFrom({
		        isConfig: true,
		        filename: process.env[util.sharedConfigFileEnv]
		      });
		    }
		    var profilesFromCreds= {};
		    try {
		      var profilesFromCreds = iniLoader.loadFrom({
		        filename: filename ||
		          (process.env[util.configOptInEnv] && process.env[util.sharedCredentialsFileEnv])
		      });
		    } catch (error) {
		      // if using config, assume it is fully descriptive without a credentials file:
		      if (!process.env[util.configOptInEnv]) throw error;
		    }
		    for (var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++) {
		      profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromConfig[profileNames[i]]);
		    }
		    for (var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++) {
		      profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromCreds[profileNames[i]]);
		    }
		    return profiles;

		    /**
		     * Roughly the semantics of `Object.assign(target, source)`
		     */
		    function objectAssign(target, source) {
		      for (var i = 0, keys = Object.keys(source); i < keys.length; i++) {
		        target[keys[i]] = source[keys[i]];
		      }
		      return target;
		    }
		  },

		  /**
		   * @api private
		   */
		  ARN: {
		    validate: function validateARN(str) {
		      return str && str.indexOf('arn:') === 0 && str.split(':').length >= 6;
		    },
		    parse: function parseARN(arn) {
		      var matched = arn.split(':');
		      return {
		        partition: matched[1],
		        service: matched[2],
		        region: matched[3],
		        accountId: matched[4],
		        resource: matched.slice(5).join(':')
		      };
		    },
		    build: function buildARN(arnObject) {
		      if (
		        arnObject.service === undefined ||
		        arnObject.region === undefined ||
		        arnObject.accountId === undefined ||
		        arnObject.resource === undefined
		      ) throw util.error(new Error('Input ARN object is invalid'));
		      return 'arn:'+ (arnObject.partition || 'aws') + ':' + arnObject.service +
		        ':' + arnObject.region + ':' + arnObject.accountId + ':' + arnObject.resource;
		    }
		  },

		  /**
		   * @api private
		   */
		  defaultProfile: 'default',

		  /**
		   * @api private
		   */
		  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

		  /**
		   * @api private
		   */
		  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

		  /**
		   * @api private
		   */
		  sharedConfigFileEnv: 'AWS_CONFIG_FILE',

		  /**
		   * @api private
		   */
		  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
		};

		/**
		 * @api private
		 */
		module.exports = util;

		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(4).setImmediate))

	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {

		// shim for using process in browser
		var process = module.exports = {};

		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.

		var cachedSetTimeout;
		var cachedClearTimeout;

		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }


		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }



		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;

		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}

		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;

		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}

		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};

		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};

		function noop() {}

		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;

		process.listeners = function (name) { return [] }

		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};

		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };


	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
		            (typeof self !== "undefined" && self) ||
		            window;
		var apply = Function.prototype.apply;

		// DOM APIs, for completeness

		exports.setTimeout = function() {
		  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
		};
		exports.setInterval = function() {
		  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
		};
		exports.clearTimeout =
		exports.clearInterval = function(timeout) {
		  if (timeout) {
		    timeout.close();
		  }
		};

		function Timeout(id, clearFn) {
		  this._id = id;
		  this._clearFn = clearFn;
		}
		Timeout.prototype.unref = Timeout.prototype.ref = function() {};
		Timeout.prototype.close = function() {
		  this._clearFn.call(scope, this._id);
		};

		// Does not start the time, just sets up the members needed.
		exports.enroll = function(item, msecs) {
		  clearTimeout(item._idleTimeoutId);
		  item._idleTimeout = msecs;
		};

		exports.unenroll = function(item) {
		  clearTimeout(item._idleTimeoutId);
		  item._idleTimeout = -1;
		};

		exports._unrefActive = exports.active = function(item) {
		  clearTimeout(item._idleTimeoutId);

		  var msecs = item._idleTimeout;
		  if (msecs >= 0) {
		    item._idleTimeoutId = setTimeout(function onTimeout() {
		      if (item._onTimeout)
		        item._onTimeout();
		    }, msecs);
		  }
		};

		// setimmediate attaches itself to the global object
		__webpack_require__(5);
		// On some exotic environments, it's not clear which object `setimmediate` was
		// able to install onto.  Search each possibility in the same order as the
		// `setimmediate` library.
		exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
		                       (typeof global !== "undefined" && global.setImmediate) ||
		                       (this && this.setImmediate);
		exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
		                         (typeof global !== "undefined" && global.clearImmediate) ||
		                         (this && this.clearImmediate);

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
		    "use strict";

		    if (global.setImmediate) {
		        return;
		    }

		    var nextHandle = 1; // Spec says greater than zero
		    var tasksByHandle = {};
		    var currentlyRunningATask = false;
		    var doc = global.document;
		    var registerImmediate;

		    function setImmediate(callback) {
		      // Callback can either be a function or a string
		      if (typeof callback !== "function") {
		        callback = new Function("" + callback);
		      }
		      // Copy function arguments
		      var args = new Array(arguments.length - 1);
		      for (var i = 0; i < args.length; i++) {
		          args[i] = arguments[i + 1];
		      }
		      // Store and register the task
		      var task = { callback: callback, args: args };
		      tasksByHandle[nextHandle] = task;
		      registerImmediate(nextHandle);
		      return nextHandle++;
		    }

		    function clearImmediate(handle) {
		        delete tasksByHandle[handle];
		    }

		    function run(task) {
		        var callback = task.callback;
		        var args = task.args;
		        switch (args.length) {
		        case 0:
		            callback();
		            break;
		        case 1:
		            callback(args[0]);
		            break;
		        case 2:
		            callback(args[0], args[1]);
		            break;
		        case 3:
		            callback(args[0], args[1], args[2]);
		            break;
		        default:
		            callback.apply(undefined, args);
		            break;
		        }
		    }

		    function runIfPresent(handle) {
		        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
		        // So if we're currently running a task, we'll need to delay this invocation.
		        if (currentlyRunningATask) {
		            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
		            // "too much recursion" error.
		            setTimeout(runIfPresent, 0, handle);
		        } else {
		            var task = tasksByHandle[handle];
		            if (task) {
		                currentlyRunningATask = true;
		                try {
		                    run(task);
		                } finally {
		                    clearImmediate(handle);
		                    currentlyRunningATask = false;
		                }
		            }
		        }
		    }

		    function installNextTickImplementation() {
		        registerImmediate = function(handle) {
		            process.nextTick(function () { runIfPresent(handle); });
		        };
		    }

		    function canUsePostMessage() {
		        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
		        // where `global.postMessage` means something completely different and can't be used for this purpose.
		        if (global.postMessage && !global.importScripts) {
		            var postMessageIsAsynchronous = true;
		            var oldOnMessage = global.onmessage;
		            global.onmessage = function() {
		                postMessageIsAsynchronous = false;
		            };
		            global.postMessage("", "*");
		            global.onmessage = oldOnMessage;
		            return postMessageIsAsynchronous;
		        }
		    }

		    function installPostMessageImplementation() {
		        // Installs an event handler on `global` for the `message` event: see
		        // * https://developer.mozilla.org/en/DOM/window.postMessage
		        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

		        var messagePrefix = "setImmediate$" + Math.random() + "$";
		        var onGlobalMessage = function(event) {
		            if (event.source === global &&
		                typeof event.data === "string" &&
		                event.data.indexOf(messagePrefix) === 0) {
		                runIfPresent(+event.data.slice(messagePrefix.length));
		            }
		        };

		        if (global.addEventListener) {
		            global.addEventListener("message", onGlobalMessage, false);
		        } else {
		            global.attachEvent("onmessage", onGlobalMessage);
		        }

		        registerImmediate = function(handle) {
		            global.postMessage(messagePrefix + handle, "*");
		        };
		    }

		    function installMessageChannelImplementation() {
		        var channel = new MessageChannel();
		        channel.port1.onmessage = function(event) {
		            var handle = event.data;
		            runIfPresent(handle);
		        };

		        registerImmediate = function(handle) {
		            channel.port2.postMessage(handle);
		        };
		    }

		    function installReadyStateChangeImplementation() {
		        var html = doc.documentElement;
		        registerImmediate = function(handle) {
		            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
		            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
		            var script = doc.createElement("script");
		            script.onreadystatechange = function () {
		                runIfPresent(handle);
		                script.onreadystatechange = null;
		                html.removeChild(script);
		                script = null;
		            };
		            html.appendChild(script);
		        };
		    }

		    function installSetTimeoutImplementation() {
		        registerImmediate = function(handle) {
		            setTimeout(runIfPresent, 0, handle);
		        };
		    }

		    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
		    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
		    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

		    // Don't get fooled by e.g. browserify environments.
		    if ({}.toString.call(global.process) === "[object process]") {
		        // For Node.js before 0.9
		        installNextTickImplementation();

		    } else if (canUsePostMessage()) {
		        // For non-IE10 modern browsers
		        installPostMessageImplementation();

		    } else if (global.MessageChannel) {
		        // For web workers, where supported
		        installMessageChannelImplementation();

		    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
		        // For IE 6–8
		        installReadyStateChangeImplementation();

		    } else {
		        // For older browsers
		        installSetTimeoutImplementation();
		    }

		    attachTo.setImmediate = setImmediate;
		    attachTo.clearImmediate = clearImmediate;
		}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3)))

	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {

		/* (ignored) */

	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {

		module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*","2019-03-26*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true,"xmlNoDefaultLists":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay","cors":true},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena","cors":true},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2","cors":true},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect","cors":true},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics","cors":true},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService","cors":true},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService","cors":true},"qldb":{"name":"QLDB"},"qldbsession":{"prefix":"qldb-session","name":"QLDBSession"},"workmailmessageflow":{"name":"WorkMailMessageFlow"},"codestarnotifications":{"prefix":"codestar-notifications","name":"CodeStarNotifications"},"savingsplans":{"name":"SavingsPlans"},"sso":{"name":"SSO"},"ssooidc":{"prefix":"sso-oidc","name":"SSOOIDC"},"marketplacecatalog":{"prefix":"marketplace-catalog","name":"MarketplaceCatalog"},"dataexchange":{"name":"DataExchange"},"sesv2":{"name":"SESV2"},"migrationhubconfig":{"prefix":"migrationhub-config","name":"MigrationHubConfig"},"connectparticipant":{"name":"ConnectParticipant"},"appconfig":{"name":"AppConfig"},"iotsecuretunneling":{"name":"IoTSecureTunneling"},"wafv2":{"name":"WAFV2"},"elasticinference":{"prefix":"elastic-inference","name":"ElasticInference"},"imagebuilder":{"name":"Imagebuilder"},"schemas":{"name":"Schemas"},"accessanalyzer":{"name":"AccessAnalyzer"},"codegurureviewer":{"prefix":"codeguru-reviewer","name":"CodeGuruReviewer"},"codeguruprofiler":{"name":"CodeGuruProfiler"},"computeoptimizer":{"prefix":"compute-optimizer","name":"ComputeOptimizer"},"frauddetector":{"name":"FraudDetector"},"kendra":{"name":"Kendra"},"networkmanager":{"name":"NetworkManager"},"outposts":{"name":"Outposts"},"augmentedairuntime":{"prefix":"sagemaker-a2i-runtime","name":"AugmentedAIRuntime"},"ebs":{"name":"EBS"},"kinesisvideosignalingchannels":{"prefix":"kinesis-video-signaling","name":"KinesisVideoSignalingChannels","cors":true},"detective":{"name":"Detective"},"codestarconnections":{"prefix":"codestar-connections","name":"CodeStarconnections"},"synthetics":{"name":"Synthetics"},"iotsitewise":{"name":"IoTSiteWise"},"macie2":{"name":"Macie2"},"codeartifact":{"name":"CodeArtifact"},"honeycode":{"name":"Honeycode"},"ivs":{"name":"IVS"},"braket":{"name":"Braket"},"identitystore":{"name":"IdentityStore"},"appflow":{"name":"Appflow"},"redshiftdata":{"prefix":"redshift-data","name":"RedshiftData"},"ssoadmin":{"prefix":"sso-admin","name":"SSOAdmin"},"timestreamquery":{"prefix":"timestream-query","name":"TimestreamQuery"},"timestreamwrite":{"prefix":"timestream-write","name":"TimestreamWrite"},"s3outposts":{"name":"S3Outposts"},"databrew":{"name":"DataBrew"},"servicecatalogappregistry":{"prefix":"servicecatalog-appregistry","name":"ServiceCatalogAppRegistry"},"networkfirewall":{"prefix":"network-firewall","name":"NetworkFirewall"},"mwaa":{"name":"MWAA"},"amplifybackend":{"name":"AmplifyBackend"},"appintegrations":{"name":"AppIntegrations"},"connectcontactlens":{"prefix":"connect-contact-lens","name":"ConnectContactLens"},"devopsguru":{"prefix":"devops-guru","name":"DevOpsGuru"},"ecrpublic":{"prefix":"ecr-public","name":"ECRPUBLIC"},"lookoutvision":{"name":"LookoutVision"},"sagemakerfeaturestoreruntime":{"prefix":"sagemaker-featurestore-runtime","name":"SageMakerFeatureStoreRuntime"},"customerprofiles":{"prefix":"customer-profiles","name":"CustomerProfiles"},"auditmanager":{"name":"AuditManager"},"emrcontainers":{"prefix":"emr-containers","name":"EMRcontainers"},"healthlake":{"name":"HealthLake"},"sagemakeredge":{"prefix":"sagemaker-edge","name":"SagemakerEdge"},"amp":{"name":"Amp"},"greengrassv2":{"name":"GreengrassV2"},"iotdeviceadvisor":{"name":"IotDeviceAdvisor"},"iotfleethub":{"name":"IoTFleetHub"},"iotwireless":{"name":"IoTWireless"},"location":{"name":"Location","cors":true},"wellarchitected":{"name":"WellArchitected"},"lexmodelsv2":{"prefix":"models.lex.v2","name":"LexModelsV2"},"lexruntimev2":{"prefix":"runtime.lex.v2","name":"LexRuntimeV2","cors":true},"fis":{"name":"Fis"},"lookoutmetrics":{"name":"LookoutMetrics"},"mgn":{"name":"Mgn"},"lookoutequipment":{"name":"LookoutEquipment"},"nimble":{"name":"Nimble"},"finspace":{"name":"Finspace"},"finspacedata":{"prefix":"finspace-data","name":"Finspacedata"},"ssmcontacts":{"prefix":"ssm-contacts","name":"SSMContacts"},"ssmincidents":{"prefix":"ssm-incidents","name":"SSMIncidents"},"applicationcostprofiler":{"name":"ApplicationCostProfiler"},"apprunner":{"name":"AppRunner"},"proton":{"name":"Proton"},"route53recoverycluster":{"prefix":"route53-recovery-cluster","name":"Route53RecoveryCluster"},"route53recoverycontrolconfig":{"prefix":"route53-recovery-control-config","name":"Route53RecoveryControlConfig"},"route53recoveryreadiness":{"prefix":"route53-recovery-readiness","name":"Route53RecoveryReadiness"},"chimesdkidentity":{"prefix":"chime-sdk-identity","name":"ChimeSDKIdentity"},"chimesdkmessaging":{"prefix":"chime-sdk-messaging","name":"ChimeSDKMessaging"},"snowdevicemanagement":{"prefix":"snow-device-management","name":"SnowDeviceManagement"},"memorydb":{"name":"MemoryDB"},"opensearch":{"name":"OpenSearch"},"kafkaconnect":{"name":"KafkaConnect"},"voiceid":{"prefix":"voice-id","name":"VoiceID"},"wisdom":{"name":"Wisdom"},"account":{"name":"Account"},"cloudcontrol":{"name":"CloudControl"},"grafana":{"name":"Grafana"},"panorama":{"name":"Panorama"},"chimesdkmeetings":{"prefix":"chime-sdk-meetings","name":"ChimeSDKMeetings"},"resiliencehub":{"name":"Resiliencehub"},"migrationhubstrategy":{"name":"MigrationHubStrategy"},"appconfigdata":{"name":"AppConfigData"},"drs":{"name":"Drs"},"migrationhubrefactorspaces":{"prefix":"migration-hub-refactor-spaces","name":"MigrationHubRefactorSpaces"},"evidently":{"name":"Evidently"},"inspector2":{"name":"Inspector2"},"rbin":{"name":"Rbin"},"rum":{"name":"RUM"},"backupgateway":{"prefix":"backup-gateway","name":"BackupGateway"},"iottwinmaker":{"name":"IoTTwinMaker"},"workspacesweb":{"prefix":"workspaces-web","name":"WorkSpacesWeb"},"amplifyuibuilder":{"name":"AmplifyUIBuilder"},"keyspaces":{"name":"Keyspaces"},"billingconductor":{"name":"Billingconductor"},"gamesparks":{"name":"GameSparks"},"pinpointsmsvoicev2":{"prefix":"pinpoint-sms-voice-v2","name":"PinpointSMSVoiceV2"},"ivschat":{"name":"Ivschat"},"chimesdkmediapipelines":{"prefix":"chime-sdk-media-pipelines","name":"ChimeSDKMediaPipelines"}}

	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {

		var v1 = __webpack_require__(9);
		var v4 = __webpack_require__(12);

		var uuid = v4;
		uuid.v1 = v1;
		uuid.v4 = v4;

		module.exports = uuid;


	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {

		var rng = __webpack_require__(10);
		var bytesToUuid = __webpack_require__(11);

		// **`v1()` - Generate time-based UUID**
		//
		// Inspired by https://github.com/LiosK/UUID.js
		// and http://docs.python.org/library/uuid.html

		var _nodeId;
		var _clockseq;

		// Previous uuid creation time
		var _lastMSecs = 0;
		var _lastNSecs = 0;

		// See https://github.com/broofa/node-uuid for API details
		function v1(options, buf, offset) {
		  var i = buf && offset || 0;
		  var b = buf || [];

		  options = options || {};
		  var node = options.node || _nodeId;
		  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

		  // node and clockseq need to be initialized to random values if they're not
		  // specified.  We do this lazily to minimize issues related to insufficient
		  // system entropy.  See #189
		  if (node == null || clockseq == null) {
		    var seedBytes = rng();
		    if (node == null) {
		      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
		      node = _nodeId = [
		        seedBytes[0] | 0x01,
		        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
		      ];
		    }
		    if (clockseq == null) {
		      // Per 4.2.2, randomize (14 bit) clockseq
		      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
		    }
		  }

		  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
		  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
		  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
		  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
		  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

		  // Per 4.2.1.2, use count of uuid's generated during the current clock
		  // cycle to simulate higher resolution clock
		  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

		  // Time since last uuid creation (in msecs)
		  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

		  // Per 4.2.1.2, Bump clockseq on clock regression
		  if (dt < 0 && options.clockseq === undefined) {
		    clockseq = clockseq + 1 & 0x3fff;
		  }

		  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
		  // time interval
		  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
		    nsecs = 0;
		  }

		  // Per 4.2.1.2 Throw error if too many uuids are requested
		  if (nsecs >= 10000) {
		    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
		  }

		  _lastMSecs = msecs;
		  _lastNSecs = nsecs;
		  _clockseq = clockseq;

		  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
		  msecs += 12219292800000;

		  // `time_low`
		  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
		  b[i++] = tl >>> 24 & 0xff;
		  b[i++] = tl >>> 16 & 0xff;
		  b[i++] = tl >>> 8 & 0xff;
		  b[i++] = tl & 0xff;

		  // `time_mid`
		  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
		  b[i++] = tmh >>> 8 & 0xff;
		  b[i++] = tmh & 0xff;

		  // `time_high_and_version`
		  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
		  b[i++] = tmh >>> 16 & 0xff;

		  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
		  b[i++] = clockseq >>> 8 | 0x80;

		  // `clock_seq_low`
		  b[i++] = clockseq & 0xff;

		  // `node`
		  for (var n = 0; n < 6; ++n) {
		    b[i + n] = node[n];
		  }

		  return buf ? buf : bytesToUuid(b);
		}

		module.exports = v1;


	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {

		// Unique ID creation requires a high quality random # generator.  In the
		// browser this is a little complicated due to unknown quality of Math.random()
		// and inconsistent support for the `crypto` API.  We do the best we can via
		// feature-detection

		// getRandomValues needs to be invoked in a context where "this" is a Crypto
		// implementation. Also, find the complete implementation of crypto on IE11.
		var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
		                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

		if (getRandomValues) {
		  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
		  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

		  module.exports = function whatwgRNG() {
		    getRandomValues(rnds8);
		    return rnds8;
		  };
		} else {
		  // Math.random()-based (RNG)
		  //
		  // If all else fails, use Math.random().  It's fast, but is of unspecified
		  // quality.
		  var rnds = new Array(16);

		  module.exports = function mathRNG() {
		    for (var i = 0, r; i < 16; i++) {
		      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
		      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
		    }

		    return rnds;
		  };
		}


	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {

		/**
		 * Convert array of 16 byte values to UUID string format of the form:
		 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
		 */
		var byteToHex = [];
		for (var i = 0; i < 256; ++i) {
		  byteToHex[i] = (i + 0x100).toString(16).substr(1);
		}

		function bytesToUuid(buf, offset) {
		  var i = offset || 0;
		  var bth = byteToHex;
		  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
		  return ([bth[buf[i++]], bth[buf[i++]], 
			bth[buf[i++]], bth[buf[i++]], '-',
			bth[buf[i++]], bth[buf[i++]], '-',
			bth[buf[i++]], bth[buf[i++]], '-',
			bth[buf[i++]], bth[buf[i++]], '-',
			bth[buf[i++]], bth[buf[i++]],
			bth[buf[i++]], bth[buf[i++]],
			bth[buf[i++]], bth[buf[i++]]]).join('');
		}

		module.exports = bytesToUuid;


	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {

		var rng = __webpack_require__(10);
		var bytesToUuid = __webpack_require__(11);

		function v4(options, buf, offset) {
		  var i = buf && offset || 0;

		  if (typeof(options) == 'string') {
		    buf = options === 'binary' ? new Array(16) : null;
		    options = null;
		  }
		  options = options || {};

		  var rnds = options.random || (options.rng || rng)();

		  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
		  rnds[6] = (rnds[6] & 0x0f) | 0x40;
		  rnds[8] = (rnds[8] & 0x3f) | 0x80;

		  // Copy bytes to buffer, if provided
		  if (buf) {
		    for (var ii = 0; ii < 16; ++ii) {
		      buf[i + ii] = rnds[ii];
		    }
		  }

		  return buf || bytesToUuid(rnds);
		}

		module.exports = v4;


	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);
		var JsonBuilder = __webpack_require__(14);
		var JsonParser = __webpack_require__(15);
		var populateHostPrefix = __webpack_require__(16).populateHostPrefix;

		function buildRequest(req) {
		  var httpRequest = req.httpRequest;
		  var api = req.service.api;
		  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
		  var version = api.jsonVersion || '1.0';
		  var input = api.operations[req.operation].input;
		  var builder = new JsonBuilder();

		  if (version === 1) version = '1.0';
		  httpRequest.body = builder.build(req.params || {}, input);
		  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
		  httpRequest.headers['X-Amz-Target'] = target;

		  populateHostPrefix(req);
		}

		function extractError(resp) {
		  var error = {};
		  var httpResponse = resp.httpResponse;

		  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
		  if (typeof error.code === 'string') {
		    error.code = error.code.split(':')[0];
		  }

		  if (httpResponse.body.length > 0) {
		    try {
		      var e = JSON.parse(httpResponse.body.toString());
		      var code = e.__type || e.code || e.Code;
		      if (code) {
		        error.code = code.split('#').pop();
		      }
		      if (error.code === 'RequestEntityTooLarge') {
		        error.message = 'Request body must be less than 1 MB';
		      } else {
		        error.message = (e.message || e.Message || null);
		      }
		    } catch (e) {
		      error.statusCode = httpResponse.statusCode;
		      error.message = httpResponse.statusMessage;
		    }
		  } else {
		    error.statusCode = httpResponse.statusCode;
		    error.message = httpResponse.statusCode.toString();
		  }

		  resp.error = util.error(new Error(), error);
		}

		function extractData(resp) {
		  var body = resp.httpResponse.body.toString() || '{}';
		  if (resp.request.service.config.convertResponseTypes === false) {
		    resp.data = JSON.parse(body);
		  } else {
		    var operation = resp.request.service.api.operations[resp.request.operation];
		    var shape = operation.output || {};
		    var parser = new JsonParser();
		    resp.data = parser.parse(body, shape);
		  }
		}

		/**
		 * @api private
		 */
		module.exports = {
		  buildRequest: buildRequest,
		  extractError: extractError,
		  extractData: extractData
		};


	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);

		function JsonBuilder() { }

		JsonBuilder.prototype.build = function(value, shape) {
		  return JSON.stringify(translate(value, shape));
		};

		function translate(value, shape) {
		  if (!shape || value === undefined || value === null) return undefined;

		  switch (shape.type) {
		    case 'structure': return translateStructure(value, shape);
		    case 'map': return translateMap(value, shape);
		    case 'list': return translateList(value, shape);
		    default: return translateScalar(value, shape);
		  }
		}

		function translateStructure(structure, shape) {
		  if (shape.isDocument) {
		    return structure;
		  }
		  var struct = {};
		  util.each(structure, function(name, value) {
		    var memberShape = shape.members[name];
		    if (memberShape) {
		      if (memberShape.location !== 'body') return;
		      var locationName = memberShape.isLocationName ? memberShape.name : name;
		      var result = translate(value, memberShape);
		      if (result !== undefined) struct[locationName] = result;
		    }
		  });
		  return struct;
		}

		function translateList(list, shape) {
		  var out = [];
		  util.arrayEach(list, function(value) {
		    var result = translate(value, shape.member);
		    if (result !== undefined) out.push(result);
		  });
		  return out;
		}

		function translateMap(map, shape) {
		  var out = {};
		  util.each(map, function(key, value) {
		    var result = translate(value, shape.value);
		    if (result !== undefined) out[key] = result;
		  });
		  return out;
		}

		function translateScalar(value, shape) {
		  return shape.toWireFormat(value);
		}

		/**
		 * @api private
		 */
		module.exports = JsonBuilder;


	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);

		function JsonParser() { }

		JsonParser.prototype.parse = function(value, shape) {
		  return translate(JSON.parse(value), shape);
		};

		function translate(value, shape) {
		  if (!shape || value === undefined) return undefined;

		  switch (shape.type) {
		    case 'structure': return translateStructure(value, shape);
		    case 'map': return translateMap(value, shape);
		    case 'list': return translateList(value, shape);
		    default: return translateScalar(value, shape);
		  }
		}

		function translateStructure(structure, shape) {
		  if (structure == null) return undefined;
		  if (shape.isDocument) return structure;

		  var struct = {};
		  var shapeMembers = shape.members;
		  util.each(shapeMembers, function(name, memberShape) {
		    var locationName = memberShape.isLocationName ? memberShape.name : name;
		    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
		      var value = structure[locationName];
		      var result = translate(value, memberShape);
		      if (result !== undefined) struct[name] = result;
		    }
		  });
		  return struct;
		}

		function translateList(list, shape) {
		  if (list == null) return undefined;

		  var out = [];
		  util.arrayEach(list, function(value) {
		    var result = translate(value, shape.member);
		    if (result === undefined) out.push(null);
		    else out.push(result);
		  });
		  return out;
		}

		function translateMap(map, shape) {
		  if (map == null) return undefined;

		  var out = {};
		  util.each(map, function(key, value) {
		    var result = translate(value, shape.value);
		    if (result === undefined) out[key] = null;
		    else out[key] = result;
		  });
		  return out;
		}

		function translateScalar(value, shape) {
		  return shape.toType(value);
		}

		/**
		 * @api private
		 */
		module.exports = JsonParser;


	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {

		var util =  __webpack_require__(2);
		var AWS = __webpack_require__(1);

		/**
		 * Prepend prefix defined by API model to endpoint that's already
		 * constructed. This feature does not apply to operations using
		 * endpoint discovery and can be disabled.
		 * @api private
		 */
		function populateHostPrefix(request)  {
		  var enabled = request.service.config.hostPrefixEnabled;
		  if (!enabled) return request;
		  var operationModel = request.service.api.operations[request.operation];
		  //don't marshal host prefix when operation has endpoint discovery traits
		  if (hasEndpointDiscover(request)) return request;
		  if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
		    var hostPrefixNotation = operationModel.endpoint.hostPrefix;
		    var hostPrefix = expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
		    prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
		    validateHostname(request.httpRequest.endpoint.hostname);
		  }
		  return request;
		}

		/**
		 * @api private
		 */
		function hasEndpointDiscover(request) {
		  var api = request.service.api;
		  var operationModel = api.operations[request.operation];
		  var isEndpointOperation = api.endpointOperation && (api.endpointOperation === util.string.lowerFirst(operationModel.name));
		  return (operationModel.endpointDiscoveryRequired !== 'NULL' || isEndpointOperation === true);
		}

		/**
		 * @api private
		 */
		function expandHostPrefix(hostPrefixNotation, params, shape) {
		  util.each(shape.members, function(name, member) {
		    if (member.hostLabel === true) {
		      if (typeof params[name] !== 'string' || params[name] === '') {
		        throw util.error(new Error(), {
		          message: 'Parameter ' + name + ' should be a non-empty string.',
		          code: 'InvalidParameter'
		        });
		      }
		      var regex = new RegExp('\\{' + name + '\\}', 'g');
		      hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
		    }
		  });
		  return hostPrefixNotation;
		}

		/**
		 * @api private
		 */
		function prependEndpointPrefix(endpoint, prefix) {
		  if (endpoint.host) {
		    endpoint.host = prefix + endpoint.host;
		  }
		  if (endpoint.hostname) {
		    endpoint.hostname = prefix + endpoint.hostname;
		  }
		}

		/**
		 * @api private
		 */
		function validateHostname(hostname) {
		  var labels = hostname.split('.');
		  //Reference: https://tools.ietf.org/html/rfc1123#section-2
		  var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
		  util.arrayEach(labels, function(label) {
		    if (!label.length || label.length < 1 || label.length > 63) {
		      throw util.error(new Error(), {
		        code: 'ValidationError',
		        message: 'Hostname label length should be between 1 to 63 characters, inclusive.'
		      });
		    }
		    if (!hostPattern.test(label)) {
		      throw AWS.util.error(new Error(),
		        {code: 'ValidationError', message: label + ' is not hostname compatible.'});
		    }
		  });
		}

		module.exports = {
		  populateHostPrefix: populateHostPrefix
		};


	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var util = __webpack_require__(2);
		var QueryParamSerializer = __webpack_require__(18);
		var Shape = __webpack_require__(19);
		var populateHostPrefix = __webpack_require__(16).populateHostPrefix;

		function buildRequest(req) {
		  var operation = req.service.api.operations[req.operation];
		  var httpRequest = req.httpRequest;
		  httpRequest.headers['Content-Type'] =
		    'application/x-www-form-urlencoded; charset=utf-8';
		  httpRequest.params = {
		    Version: req.service.api.apiVersion,
		    Action: operation.name
		  };

		  // convert the request parameters into a list of query params,
		  // e.g. Deeply.NestedParam.0.Name=value
		  var builder = new QueryParamSerializer();
		  builder.serialize(req.params, operation.input, function(name, value) {
		    httpRequest.params[name] = value;
		  });
		  httpRequest.body = util.queryParamsToString(httpRequest.params);

		  populateHostPrefix(req);
		}

		function extractError(resp) {
		  var data, body = resp.httpResponse.body.toString();
		  if (body.match('<UnknownOperationException')) {
		    data = {
		      Code: 'UnknownOperation',
		      Message: 'Unknown operation ' + resp.request.operation
		    };
		  } else {
		    try {
		      data = new AWS.XML.Parser().parse(body);
		    } catch (e) {
		      data = {
		        Code: resp.httpResponse.statusCode,
		        Message: resp.httpResponse.statusMessage
		      };
		    }
		  }

		  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
		  if (data.Errors) data = data.Errors;
		  if (data.Error) data = data.Error;
		  if (data.Code) {
		    resp.error = util.error(new Error(), {
		      code: data.Code,
		      message: data.Message
		    });
		  } else {
		    resp.error = util.error(new Error(), {
		      code: resp.httpResponse.statusCode,
		      message: null
		    });
		  }
		}

		function extractData(resp) {
		  var req = resp.request;
		  var operation = req.service.api.operations[req.operation];
		  var shape = operation.output || {};
		  var origRules = shape;

		  if (origRules.resultWrapper) {
		    var tmp = Shape.create({type: 'structure'});
		    tmp.members[origRules.resultWrapper] = shape;
		    tmp.memberNames = [origRules.resultWrapper];
		    util.property(shape, 'name', shape.resultWrapper);
		    shape = tmp;
		  }

		  var parser = new AWS.XML.Parser();

		  // TODO: Refactor XML Parser to parse RequestId from response.
		  if (shape && shape.members && !shape.members._XAMZRequestId) {
		    var requestIdShape = Shape.create(
		      { type: 'string' },
		      { api: { protocol: 'query' } },
		      'requestId'
		    );
		    shape.members._XAMZRequestId = requestIdShape;
		  }

		  var data = parser.parse(resp.httpResponse.body.toString(), shape);
		  resp.requestId = data._XAMZRequestId || data.requestId;

		  if (data._XAMZRequestId) delete data._XAMZRequestId;

		  if (origRules.resultWrapper) {
		    if (data[origRules.resultWrapper]) {
		      util.update(data, data[origRules.resultWrapper]);
		      delete data[origRules.resultWrapper];
		    }
		  }

		  resp.data = data;
		}

		/**
		 * @api private
		 */
		module.exports = {
		  buildRequest: buildRequest,
		  extractError: extractError,
		  extractData: extractData
		};


	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);

		function QueryParamSerializer() {
		}

		QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
		  serializeStructure('', params, shape, fn);
		};

		function ucfirst(shape) {
		  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
		    return shape.name;
		  } else {
		    return shape.name[0].toUpperCase() + shape.name.substr(1);
		  }
		}

		function serializeStructure(prefix, struct, rules, fn) {
		  util.each(rules.members, function(name, member) {
		    var value = struct[name];
		    if (value === null || value === undefined) return;

		    var memberName = ucfirst(member);
		    memberName = prefix ? prefix + '.' + memberName : memberName;
		    serializeMember(memberName, value, member, fn);
		  });
		}

		function serializeMap(name, map, rules, fn) {
		  var i = 1;
		  util.each(map, function (key, value) {
		    var prefix = rules.flattened ? '.' : '.entry.';
		    var position = prefix + (i++) + '.';
		    var keyName = position + (rules.key.name || 'key');
		    var valueName = position + (rules.value.name || 'value');
		    serializeMember(name + keyName, key, rules.key, fn);
		    serializeMember(name + valueName, value, rules.value, fn);
		  });
		}

		function serializeList(name, list, rules, fn) {
		  var memberRules = rules.member || {};

		  if (list.length === 0) {
		    fn.call(this, name, null);
		    return;
		  }

		  util.arrayEach(list, function (v, n) {
		    var suffix = '.' + (n + 1);
		    if (rules.api.protocol === 'ec2') {
		      // Do nothing for EC2
		      suffix = suffix + ''; // make linter happy
		    } else if (rules.flattened) {
		      if (memberRules.name) {
		        var parts = name.split('.');
		        parts.pop();
		        parts.push(ucfirst(memberRules));
		        name = parts.join('.');
		      }
		    } else {
		      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
		    }
		    serializeMember(name + suffix, v, memberRules, fn);
		  });
		}

		function serializeMember(name, value, rules, fn) {
		  if (value === null || value === undefined) return;
		  if (rules.type === 'structure') {
		    serializeStructure(name, value, rules, fn);
		  } else if (rules.type === 'list') {
		    serializeList(name, value, rules, fn);
		  } else if (rules.type === 'map') {
		    serializeMap(name, value, rules, fn);
		  } else {
		    fn(name, rules.toWireFormat(value).toString());
		  }
		}

		/**
		 * @api private
		 */
		module.exports = QueryParamSerializer;


	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {

		var Collection = __webpack_require__(20);

		var util = __webpack_require__(2);

		function property(obj, name, value) {
		  if (value !== null && value !== undefined) {
		    util.property.apply(this, arguments);
		  }
		}

		function memoizedProperty(obj, name) {
		  if (!obj.constructor.prototype[name]) {
		    util.memoizedProperty.apply(this, arguments);
		  }
		}

		function Shape(shape, options, memberName) {
		  options = options || {};

		  property(this, 'shape', shape.shape);
		  property(this, 'api', options.api, false);
		  property(this, 'type', shape.type);
		  property(this, 'enum', shape.enum);
		  property(this, 'min', shape.min);
		  property(this, 'max', shape.max);
		  property(this, 'pattern', shape.pattern);
		  property(this, 'location', shape.location || this.location || 'body');
		  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
		    shape.locationName || memberName);
		  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
		  property(this, 'requiresLength', shape.requiresLength, false);
		  property(this, 'isComposite', shape.isComposite || false);
		  property(this, 'isShape', true, false);
		  property(this, 'isQueryName', Boolean(shape.queryName), false);
		  property(this, 'isLocationName', Boolean(shape.locationName), false);
		  property(this, 'isIdempotent', shape.idempotencyToken === true);
		  property(this, 'isJsonValue', shape.jsonvalue === true);
		  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
		  property(this, 'isEventStream', Boolean(shape.eventstream), false);
		  property(this, 'isEvent', Boolean(shape.event), false);
		  property(this, 'isEventPayload', Boolean(shape.eventpayload), false);
		  property(this, 'isEventHeader', Boolean(shape.eventheader), false);
		  property(this, 'isTimestampFormatSet', Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
		  property(this, 'endpointDiscoveryId', Boolean(shape.endpointdiscoveryid), false);
		  property(this, 'hostLabel', Boolean(shape.hostLabel), false);

		  if (options.documentation) {
		    property(this, 'documentation', shape.documentation);
		    property(this, 'documentationUrl', shape.documentationUrl);
		  }

		  if (shape.xmlAttribute) {
		    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
		  }

		  // type conversion and parsing
		  property(this, 'defaultValue', null);
		  this.toWireFormat = function(value) {
		    if (value === null || value === undefined) return '';
		    return value;
		  };
		  this.toType = function(value) { return value; };
		}

		/**
		 * @api private
		 */
		Shape.normalizedTypes = {
		  character: 'string',
		  double: 'float',
		  long: 'integer',
		  short: 'integer',
		  biginteger: 'integer',
		  bigdecimal: 'float',
		  blob: 'binary'
		};

		/**
		 * @api private
		 */
		Shape.types = {
		  'structure': StructureShape,
		  'list': ListShape,
		  'map': MapShape,
		  'boolean': BooleanShape,
		  'timestamp': TimestampShape,
		  'float': FloatShape,
		  'integer': IntegerShape,
		  'string': StringShape,
		  'base64': Base64Shape,
		  'binary': BinaryShape
		};

		Shape.resolve = function resolve(shape, options) {
		  if (shape.shape) {
		    var refShape = options.api.shapes[shape.shape];
		    if (!refShape) {
		      throw new Error('Cannot find shape reference: ' + shape.shape);
		    }

		    return refShape;
		  } else {
		    return null;
		  }
		};

		Shape.create = function create(shape, options, memberName) {
		  if (shape.isShape) return shape;

		  var refShape = Shape.resolve(shape, options);
		  if (refShape) {
		    var filteredKeys = Object.keys(shape);
		    if (!options.documentation) {
		      filteredKeys = filteredKeys.filter(function(name) {
		        return !name.match(/documentation/);
		      });
		    }

		    // create an inline shape with extra members
		    var InlineShape = function() {
		      refShape.constructor.call(this, shape, options, memberName);
		    };
		    InlineShape.prototype = refShape;
		    return new InlineShape();
		  } else {
		    // set type if not set
		    if (!shape.type) {
		      if (shape.members) shape.type = 'structure';
		      else if (shape.member) shape.type = 'list';
		      else if (shape.key) shape.type = 'map';
		      else shape.type = 'string';
		    }

		    // normalize types
		    var origType = shape.type;
		    if (Shape.normalizedTypes[shape.type]) {
		      shape.type = Shape.normalizedTypes[shape.type];
		    }

		    if (Shape.types[shape.type]) {
		      return new Shape.types[shape.type](shape, options, memberName);
		    } else {
		      throw new Error('Unrecognized shape type: ' + origType);
		    }
		  }
		};

		function CompositeShape(shape) {
		  Shape.apply(this, arguments);
		  property(this, 'isComposite', true);

		  if (shape.flattened) {
		    property(this, 'flattened', shape.flattened || false);
		  }
		}

		function StructureShape(shape, options) {
		  var self = this;
		  var requiredMap = null, firstInit = !this.isShape;

		  CompositeShape.apply(this, arguments);

		  if (firstInit) {
		    property(this, 'defaultValue', function() { return {}; });
		    property(this, 'members', {});
		    property(this, 'memberNames', []);
		    property(this, 'required', []);
		    property(this, 'isRequired', function() { return false; });
		    property(this, 'isDocument', Boolean(shape.document));
		  }

		  if (shape.members) {
		    property(this, 'members', new Collection(shape.members, options, function(name, member) {
		      return Shape.create(member, options, name);
		    }));
		    memoizedProperty(this, 'memberNames', function() {
		      return shape.xmlOrder || Object.keys(shape.members);
		    });

		    if (shape.event) {
		      memoizedProperty(this, 'eventPayloadMemberName', function() {
		        var members = self.members;
		        var memberNames = self.memberNames;
		        // iterate over members to find ones that are event payloads
		        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
		          if (members[memberNames[i]].isEventPayload) {
		            return memberNames[i];
		          }
		        }
		      });

		      memoizedProperty(this, 'eventHeaderMemberNames', function() {
		        var members = self.members;
		        var memberNames = self.memberNames;
		        var eventHeaderMemberNames = [];
		        // iterate over members to find ones that are event headers
		        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
		          if (members[memberNames[i]].isEventHeader) {
		            eventHeaderMemberNames.push(memberNames[i]);
		          }
		        }
		        return eventHeaderMemberNames;
		      });
		    }
		  }

		  if (shape.required) {
		    property(this, 'required', shape.required);
		    property(this, 'isRequired', function(name) {
		      if (!requiredMap) {
		        requiredMap = {};
		        for (var i = 0; i < shape.required.length; i++) {
		          requiredMap[shape.required[i]] = true;
		        }
		      }

		      return requiredMap[name];
		    }, false, true);
		  }

		  property(this, 'resultWrapper', shape.resultWrapper || null);

		  if (shape.payload) {
		    property(this, 'payload', shape.payload);
		  }

		  if (typeof shape.xmlNamespace === 'string') {
		    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
		  } else if (typeof shape.xmlNamespace === 'object') {
		    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
		    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
		  }
		}

		function ListShape(shape, options) {
		  var self = this, firstInit = !this.isShape;
		  CompositeShape.apply(this, arguments);

		  if (firstInit) {
		    property(this, 'defaultValue', function() { return []; });
		  }

		  if (shape.member) {
		    memoizedProperty(this, 'member', function() {
		      return Shape.create(shape.member, options);
		    });
		  }

		  if (this.flattened) {
		    var oldName = this.name;
		    memoizedProperty(this, 'name', function() {
		      return self.member.name || oldName;
		    });
		  }
		}

		function MapShape(shape, options) {
		  var firstInit = !this.isShape;
		  CompositeShape.apply(this, arguments);

		  if (firstInit) {
		    property(this, 'defaultValue', function() { return {}; });
		    property(this, 'key', Shape.create({type: 'string'}, options));
		    property(this, 'value', Shape.create({type: 'string'}, options));
		  }

		  if (shape.key) {
		    memoizedProperty(this, 'key', function() {
		      return Shape.create(shape.key, options);
		    });
		  }
		  if (shape.value) {
		    memoizedProperty(this, 'value', function() {
		      return Shape.create(shape.value, options);
		    });
		  }
		}

		function TimestampShape(shape) {
		  var self = this;
		  Shape.apply(this, arguments);

		  if (shape.timestampFormat) {
		    property(this, 'timestampFormat', shape.timestampFormat);
		  } else if (self.isTimestampFormatSet && this.timestampFormat) {
		    property(this, 'timestampFormat', this.timestampFormat);
		  } else if (this.location === 'header') {
		    property(this, 'timestampFormat', 'rfc822');
		  } else if (this.location === 'querystring') {
		    property(this, 'timestampFormat', 'iso8601');
		  } else if (this.api) {
		    switch (this.api.protocol) {
		      case 'json':
		      case 'rest-json':
		        property(this, 'timestampFormat', 'unixTimestamp');
		        break;
		      case 'rest-xml':
		      case 'query':
		      case 'ec2':
		        property(this, 'timestampFormat', 'iso8601');
		        break;
		    }
		  }

		  this.toType = function(value) {
		    if (value === null || value === undefined) return null;
		    if (typeof value.toUTCString === 'function') return value;
		    return typeof value === 'string' || typeof value === 'number' ?
		           util.date.parseTimestamp(value) : null;
		  };

		  this.toWireFormat = function(value) {
		    return util.date.format(value, self.timestampFormat);
		  };
		}

		function StringShape() {
		  Shape.apply(this, arguments);

		  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
		  this.toType = function(value) {
		    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
		      value || '' : value;
		    if (this.isJsonValue) {
		      return JSON.parse(value);
		    }

		    return value && typeof value.toString === 'function' ?
		      value.toString() : value;
		  };

		  this.toWireFormat = function(value) {
		    return this.isJsonValue ? JSON.stringify(value) : value;
		  };
		}

		function FloatShape() {
		  Shape.apply(this, arguments);

		  this.toType = function(value) {
		    if (value === null || value === undefined) return null;
		    return parseFloat(value);
		  };
		  this.toWireFormat = this.toType;
		}

		function IntegerShape() {
		  Shape.apply(this, arguments);

		  this.toType = function(value) {
		    if (value === null || value === undefined) return null;
		    return parseInt(value, 10);
		  };
		  this.toWireFormat = this.toType;
		}

		function BinaryShape() {
		  Shape.apply(this, arguments);
		  this.toType = function(value) {
		    var buf = util.base64.decode(value);
		    if (this.isSensitive && util.isNode() && typeof util.Buffer.alloc === 'function') {
		  /* Node.js can create a Buffer that is not isolated.
		   * i.e. buf.byteLength !== buf.buffer.byteLength
		   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
		   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
		   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
		   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
		   */
		      var secureBuf = util.Buffer.alloc(buf.length, buf);
		      buf.fill(0);
		      buf = secureBuf;
		    }
		    return buf;
		  };
		  this.toWireFormat = util.base64.encode;
		}

		function Base64Shape() {
		  BinaryShape.apply(this, arguments);
		}

		function BooleanShape() {
		  Shape.apply(this, arguments);

		  this.toType = function(value) {
		    if (typeof value === 'boolean') return value;
		    if (value === null || value === undefined) return null;
		    return value === 'true';
		  };
		}

		/**
		 * @api private
		 */
		Shape.shapes = {
		  StructureShape: StructureShape,
		  ListShape: ListShape,
		  MapShape: MapShape,
		  StringShape: StringShape,
		  BooleanShape: BooleanShape,
		  Base64Shape: Base64Shape
		};

		/**
		 * @api private
		 */
		module.exports = Shape;


	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {

		var memoizedProperty = __webpack_require__(2).memoizedProperty;

		function memoize(name, value, factory, nameTr) {
		  memoizedProperty(this, nameTr(name), function() {
		    return factory(name, value);
		  });
		}

		function Collection(iterable, options, factory, nameTr, callback) {
		  nameTr = nameTr || String;
		  var self = this;

		  for (var id in iterable) {
		    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
		      memoize.call(self, id, iterable[id], factory, nameTr);
		      if (callback) callback(id, iterable[id]);
		    }
		  }
		}

		/**
		 * @api private
		 */
		module.exports = Collection;


	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);
		var populateHostPrefix = __webpack_require__(16).populateHostPrefix;

		function populateMethod(req) {
		  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
		}

		function generateURI(endpointPath, operationPath, input, params) {
		  var uri = [endpointPath, operationPath].join('/');
		  uri = uri.replace(/\/+/g, '/');

		  var queryString = {}, queryStringSet = false;
		  util.each(input.members, function (name, member) {
		    var paramValue = params[name];
		    if (paramValue === null || paramValue === undefined) return;
		    if (member.location === 'uri') {
		      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
		      uri = uri.replace(regex, function(_, plus) {
		        var fn = plus ? util.uriEscapePath : util.uriEscape;
		        return fn(String(paramValue));
		      });
		    } else if (member.location === 'querystring') {
		      queryStringSet = true;

		      if (member.type === 'list') {
		        queryString[member.name] = paramValue.map(function(val) {
		          return util.uriEscape(member.member.toWireFormat(val).toString());
		        });
		      } else if (member.type === 'map') {
		        util.each(paramValue, function(key, value) {
		          if (Array.isArray(value)) {
		            queryString[key] = value.map(function(val) {
		              return util.uriEscape(String(val));
		            });
		          } else {
		            queryString[key] = util.uriEscape(String(value));
		          }
		        });
		      } else {
		        queryString[member.name] = util.uriEscape(member.toWireFormat(paramValue).toString());
		      }
		    }
		  });

		  if (queryStringSet) {
		    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
		    var parts = [];
		    util.arrayEach(Object.keys(queryString).sort(), function(key) {
		      if (!Array.isArray(queryString[key])) {
		        queryString[key] = [queryString[key]];
		      }
		      for (var i = 0; i < queryString[key].length; i++) {
		        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
		      }
		    });
		    uri += parts.join('&');
		  }

		  return uri;
		}

		function populateURI(req) {
		  var operation = req.service.api.operations[req.operation];
		  var input = operation.input;

		  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
		  req.httpRequest.path = uri;
		}

		function populateHeaders(req) {
		  var operation = req.service.api.operations[req.operation];
		  util.each(operation.input.members, function (name, member) {
		    var value = req.params[name];
		    if (value === null || value === undefined) return;

		    if (member.location === 'headers' && member.type === 'map') {
		      util.each(value, function(key, memberValue) {
		        req.httpRequest.headers[member.name + key] = memberValue;
		      });
		    } else if (member.location === 'header') {
		      value = member.toWireFormat(value).toString();
		      if (member.isJsonValue) {
		        value = util.base64.encode(value);
		      }
		      req.httpRequest.headers[member.name] = value;
		    }
		  });
		}

		function buildRequest(req) {
		  populateMethod(req);
		  populateURI(req);
		  populateHeaders(req);
		  populateHostPrefix(req);
		}

		function extractError() {
		}

		function extractData(resp) {
		  var req = resp.request;
		  var data = {};
		  var r = resp.httpResponse;
		  var operation = req.service.api.operations[req.operation];
		  var output = operation.output;

		  // normalize headers names to lower-cased keys for matching
		  var headers = {};
		  util.each(r.headers, function (k, v) {
		    headers[k.toLowerCase()] = v;
		  });

		  util.each(output.members, function(name, member) {
		    var header = (member.name || name).toLowerCase();
		    if (member.location === 'headers' && member.type === 'map') {
		      data[name] = {};
		      var location = member.isLocationName ? member.name : '';
		      var pattern = new RegExp('^' + location + '(.+)', 'i');
		      util.each(r.headers, function (k, v) {
		        var result = k.match(pattern);
		        if (result !== null) {
		          data[name][result[1]] = v;
		        }
		      });
		    } else if (member.location === 'header') {
		      if (headers[header] !== undefined) {
		        var value = member.isJsonValue ?
		          util.base64.decode(headers[header]) :
		          headers[header];
		        data[name] = member.toType(value);
		      }
		    } else if (member.location === 'statusCode') {
		      data[name] = parseInt(r.statusCode, 10);
		    }
		  });

		  resp.data = data;
		}

		/**
		 * @api private
		 */
		module.exports = {
		  buildRequest: buildRequest,
		  extractError: extractError,
		  extractData: extractData,
		  generateURI: generateURI
		};


	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);
		var Rest = __webpack_require__(21);
		var Json = __webpack_require__(13);
		var JsonBuilder = __webpack_require__(14);
		var JsonParser = __webpack_require__(15);

		function populateBody(req) {
		  var builder = new JsonBuilder();
		  var input = req.service.api.operations[req.operation].input;

		  if (input.payload) {
		    var params = {};
		    var payloadShape = input.members[input.payload];
		    params = req.params[input.payload];

		    if (payloadShape.type === 'structure') {
		      req.httpRequest.body = builder.build(params || {}, payloadShape);
		      applyContentTypeHeader(req);
		    } else if (params !== undefined) {
		      // non-JSON payload
		      req.httpRequest.body = params;
		      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
		        applyContentTypeHeader(req, true);
		      }
		    }
		  } else {
		    req.httpRequest.body = builder.build(req.params, input);
		    applyContentTypeHeader(req);
		  }
		}

		function applyContentTypeHeader(req, isBinary) {
		  if (!req.httpRequest.headers['Content-Type']) {
		    var type = isBinary ? 'binary/octet-stream' : 'application/json';
		    req.httpRequest.headers['Content-Type'] = type;
		  }
		}

		function buildRequest(req) {
		  Rest.buildRequest(req);

		  // never send body payload on GET/HEAD/DELETE
		  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
		    populateBody(req);
		  }
		}

		function extractError(resp) {
		  Json.extractError(resp);
		}

		function extractData(resp) {
		  Rest.extractData(resp);

		  var req = resp.request;
		  var operation = req.service.api.operations[req.operation];
		  var rules = req.service.api.operations[req.operation].output || {};
		  var parser;
		  var hasEventOutput = operation.hasEventOutput;

		  if (rules.payload) {
		    var payloadMember = rules.members[rules.payload];
		    var body = resp.httpResponse.body;
		    if (payloadMember.isEventStream) {
		      parser = new JsonParser();
		      resp.data[payload] = util.createEventStream(
		        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body,
		        parser,
		        payloadMember
		      );
		    } else if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
		      var parser = new JsonParser();
		      resp.data[rules.payload] = parser.parse(body, payloadMember);
		    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
		      resp.data[rules.payload] = body;
		    } else {
		      resp.data[rules.payload] = payloadMember.toType(body);
		    }
		  } else {
		    var data = resp.data;
		    Json.extractData(resp);
		    resp.data = util.merge(data, resp.data);
		  }
		}

		/**
		 * @api private
		 */
		module.exports = {
		  buildRequest: buildRequest,
		  extractError: extractError,
		  extractData: extractData
		};


	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var util = __webpack_require__(2);
		var Rest = __webpack_require__(21);

		function populateBody(req) {
		  var input = req.service.api.operations[req.operation].input;
		  var builder = new AWS.XML.Builder();
		  var params = req.params;

		  var payload = input.payload;
		  if (payload) {
		    var payloadMember = input.members[payload];
		    params = params[payload];
		    if (params === undefined) return;

		    if (payloadMember.type === 'structure') {
		      var rootElement = payloadMember.name;
		      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
		    } else { // non-xml payload
		      req.httpRequest.body = params;
		    }
		  } else {
		    req.httpRequest.body = builder.toXML(params, input, input.name ||
		      input.shape || util.string.upperFirst(req.operation) + 'Request');
		  }
		}

		function buildRequest(req) {
		  Rest.buildRequest(req);

		  // never send body payload on GET/HEAD
		  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
		    populateBody(req);
		  }
		}

		function extractError(resp) {
		  Rest.extractError(resp);

		  var data;
		  try {
		    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
		  } catch (e) {
		    data = {
		      Code: resp.httpResponse.statusCode,
		      Message: resp.httpResponse.statusMessage
		    };
		  }

		  if (data.Errors) data = data.Errors;
		  if (data.Error) data = data.Error;
		  if (data.Code) {
		    resp.error = util.error(new Error(), {
		      code: data.Code,
		      message: data.Message
		    });
		  } else {
		    resp.error = util.error(new Error(), {
		      code: resp.httpResponse.statusCode,
		      message: null
		    });
		  }
		}

		function extractData(resp) {
		  Rest.extractData(resp);

		  var parser;
		  var req = resp.request;
		  var body = resp.httpResponse.body;
		  var operation = req.service.api.operations[req.operation];
		  var output = operation.output;

		  var hasEventOutput = operation.hasEventOutput;

		  var payload = output.payload;
		  if (payload) {
		    var payloadMember = output.members[payload];
		    if (payloadMember.isEventStream) {
		      parser = new AWS.XML.Parser();
		      resp.data[payload] = util.createEventStream(
		        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body,
		        parser,
		        payloadMember
		      );
		    } else if (payloadMember.type === 'structure') {
		      parser = new AWS.XML.Parser();
		      resp.data[payload] = parser.parse(body.toString(), payloadMember);
		    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
		      resp.data[payload] = body;
		    } else {
		      resp.data[payload] = payloadMember.toType(body);
		    }
		  } else if (body.length > 0) {
		    parser = new AWS.XML.Parser();
		    var data = parser.parse(body.toString(), output);
		    util.update(resp.data, data);
		  }
		}

		/**
		 * @api private
		 */
		module.exports = {
		  buildRequest: buildRequest,
		  extractError: extractError,
		  extractData: extractData
		};


	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);
		var XmlNode = __webpack_require__(25).XmlNode;
		var XmlText = __webpack_require__(27).XmlText;

		function XmlBuilder() { }

		XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
		  var xml = new XmlNode(rootElement);
		  applyNamespaces(xml, shape, true);
		  serialize(xml, params, shape);
		  return xml.children.length > 0 || noEmpty ? xml.toString() : '';
		};

		function serialize(xml, value, shape) {
		  switch (shape.type) {
		    case 'structure': return serializeStructure(xml, value, shape);
		    case 'map': return serializeMap(xml, value, shape);
		    case 'list': return serializeList(xml, value, shape);
		    default: return serializeScalar(xml, value, shape);
		  }
		}

		function serializeStructure(xml, params, shape) {
		  util.arrayEach(shape.memberNames, function(memberName) {
		    var memberShape = shape.members[memberName];
		    if (memberShape.location !== 'body') return;

		    var value = params[memberName];
		    var name = memberShape.name;
		    if (value !== undefined && value !== null) {
		      if (memberShape.isXmlAttribute) {
		        xml.addAttribute(name, value);
		      } else if (memberShape.flattened) {
		        serialize(xml, value, memberShape);
		      } else {
		        var element = new XmlNode(name);
		        xml.addChildNode(element);
		        applyNamespaces(element, memberShape);
		        serialize(element, value, memberShape);
		      }
		    }
		  });
		}

		function serializeMap(xml, map, shape) {
		  var xmlKey = shape.key.name || 'key';
		  var xmlValue = shape.value.name || 'value';

		  util.each(map, function(key, value) {
		    var entry = new XmlNode(shape.flattened ? shape.name : 'entry');
		    xml.addChildNode(entry);

		    var entryKey = new XmlNode(xmlKey);
		    var entryValue = new XmlNode(xmlValue);
		    entry.addChildNode(entryKey);
		    entry.addChildNode(entryValue);

		    serialize(entryKey, key, shape.key);
		    serialize(entryValue, value, shape.value);
		  });
		}

		function serializeList(xml, list, shape) {
		  if (shape.flattened) {
		    util.arrayEach(list, function(value) {
		      var name = shape.member.name || shape.name;
		      var element = new XmlNode(name);
		      xml.addChildNode(element);
		      serialize(element, value, shape.member);
		    });
		  } else {
		    util.arrayEach(list, function(value) {
		      var name = shape.member.name || 'member';
		      var element = new XmlNode(name);
		      xml.addChildNode(element);
		      serialize(element, value, shape.member);
		    });
		  }
		}

		function serializeScalar(xml, value, shape) {
		  xml.addChildNode(
		    new XmlText(shape.toWireFormat(value))
		  );
		}

		function applyNamespaces(xml, shape, isRoot) {
		  var uri, prefix = 'xmlns';
		  if (shape.xmlNamespaceUri) {
		    uri = shape.xmlNamespaceUri;
		    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
		  } else if (isRoot && shape.api.xmlNamespaceUri) {
		    uri = shape.api.xmlNamespaceUri;
		  }

		  if (uri) xml.addAttribute(prefix, uri);
		}

		/**
		 * @api private
		 */
		module.exports = XmlBuilder;


	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {

		var escapeAttribute = __webpack_require__(26).escapeAttribute;

		/**
		 * Represents an XML node.
		 * @api private
		 */
		function XmlNode(name, children) {
		    if (children === void 0) { children = []; }
		    this.name = name;
		    this.children = children;
		    this.attributes = {};
		}
		XmlNode.prototype.addAttribute = function (name, value) {
		    this.attributes[name] = value;
		    return this;
		};
		XmlNode.prototype.addChildNode = function (child) {
		    this.children.push(child);
		    return this;
		};
		XmlNode.prototype.removeAttribute = function (name) {
		    delete this.attributes[name];
		    return this;
		};
		XmlNode.prototype.toString = function () {
		    var hasChildren = Boolean(this.children.length);
		    var xmlText = '<' + this.name;
		    // add attributes
		    var attributes = this.attributes;
		    for (var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++) {
		        var attributeName = attributeNames[i];
		        var attribute = attributes[attributeName];
		        if (typeof attribute !== 'undefined' && attribute !== null) {
		            xmlText += ' ' + attributeName + '=\"' + escapeAttribute('' + attribute) + '\"';
		        }
		    }
		    return xmlText += !hasChildren ? '/>' : '>' + this.children.map(function (c) { return c.toString(); }).join('') + '</' + this.name + '>';
		};

		/**
		 * @api private
		 */
		module.exports = {
		    XmlNode: XmlNode
		};


	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {

		/**
		 * Escapes characters that can not be in an XML attribute.
		 */
		function escapeAttribute(value) {
		    return value.replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		}

		/**
		 * @api private
		 */
		module.exports = {
		    escapeAttribute: escapeAttribute
		};


	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {

		var escapeElement = __webpack_require__(28).escapeElement;

		/**
		 * Represents an XML text value.
		 * @api private
		 */
		function XmlText(value) {
		    this.value = value;
		}

		XmlText.prototype.toString = function () {
		    return escapeElement('' + this.value);
		};

		/**
		 * @api private
		 */
		module.exports = {
		    XmlText: XmlText
		};


	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {

		/**
		 * Escapes characters that can not be in an XML element.
		 */
		function escapeElement(value) {
		    return value.replace(/&/g, '&amp;')
		                .replace(/</g, '&lt;')
		                .replace(/>/g, '&gt;')
		                .replace(/\r/g, '&#x0D;')
		                .replace(/\n/g, '&#x0A;')
		                .replace(/\u0085/g, '&#x85;')
		                .replace(/\u2028/, '&#x2028;');
		}

		/**
		 * @api private
		 */
		module.exports = {
		    escapeElement: escapeElement
		};


	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {

		var Collection = __webpack_require__(20);
		var Operation = __webpack_require__(30);
		var Shape = __webpack_require__(19);
		var Paginator = __webpack_require__(31);
		var ResourceWaiter = __webpack_require__(32);
		var metadata = __webpack_require__(7);

		var util = __webpack_require__(2);
		var property = util.property;
		var memoizedProperty = util.memoizedProperty;

		function Api(api, options) {
		  var self = this;
		  api = api || {};
		  options = options || {};
		  options.api = this;

		  api.metadata = api.metadata || {};

		  var serviceIdentifier = options.serviceIdentifier;
		  delete options.serviceIdentifier;

		  property(this, 'isApi', true, false);
		  property(this, 'apiVersion', api.metadata.apiVersion);
		  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
		  property(this, 'signingName', api.metadata.signingName);
		  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
		  property(this, 'signatureVersion', api.metadata.signatureVersion);
		  property(this, 'jsonVersion', api.metadata.jsonVersion);
		  property(this, 'targetPrefix', api.metadata.targetPrefix);
		  property(this, 'protocol', api.metadata.protocol);
		  property(this, 'timestampFormat', api.metadata.timestampFormat);
		  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
		  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
		  property(this, 'fullName', api.metadata.serviceFullName);
		  property(this, 'serviceId', api.metadata.serviceId);
		  if (serviceIdentifier && metadata[serviceIdentifier]) {
		      property(this, 'xmlNoDefaultLists', metadata[serviceIdentifier].xmlNoDefaultLists, false);
		  }

		  memoizedProperty(this, 'className', function() {
		    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
		    if (!name) return null;

		    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
		    if (name === 'ElasticLoadBalancing') name = 'ELB';
		    return name;
		  });

		  function addEndpointOperation(name, operation) {
		    if (operation.endpointoperation === true) {
		      property(self, 'endpointOperation', util.string.lowerFirst(name));
		    }
		    if (operation.endpointdiscovery && !self.hasRequiredEndpointDiscovery) {
		      property(
		        self,
		        'hasRequiredEndpointDiscovery',
		        operation.endpointdiscovery.required === true
		      );
		    }
		  }

		  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
		    return new Operation(name, operation, options);
		  }, util.string.lowerFirst, addEndpointOperation));

		  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
		    return Shape.create(shape, options);
		  }));

		  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
		    return new Paginator(name, paginator, options);
		  }));

		  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
		    return new ResourceWaiter(name, waiter, options);
		  }, util.string.lowerFirst));

		  if (options.documentation) {
		    property(this, 'documentation', api.documentation);
		    property(this, 'documentationUrl', api.documentationUrl);
		  }
		}

		/**
		 * @api private
		 */
		module.exports = Api;


	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {

		var Shape = __webpack_require__(19);

		var util = __webpack_require__(2);
		var property = util.property;
		var memoizedProperty = util.memoizedProperty;

		function Operation(name, operation, options) {
		  var self = this;
		  options = options || {};

		  property(this, 'name', operation.name || name);
		  property(this, 'api', options.api, false);

		  operation.http = operation.http || {};
		  property(this, 'endpoint', operation.endpoint);
		  property(this, 'httpMethod', operation.http.method || 'POST');
		  property(this, 'httpPath', operation.http.requestUri || '/');
		  property(this, 'authtype', operation.authtype || '');
		  property(
		    this,
		    'endpointDiscoveryRequired',
		    operation.endpointdiscovery ?
		      (operation.endpointdiscovery.required ? 'REQUIRED' : 'OPTIONAL') :
		    'NULL'
		  );

		  // httpChecksum replaces usage of httpChecksumRequired, but some APIs
		  // (s3control) still uses old trait.
		  var httpChecksumRequired = operation.httpChecksumRequired
		    || (operation.httpChecksum && operation.httpChecksum.requestChecksumRequired);
		  property(this, 'httpChecksumRequired', httpChecksumRequired, false);

		  memoizedProperty(this, 'input', function() {
		    if (!operation.input) {
		      return new Shape.create({type: 'structure'}, options);
		    }
		    return Shape.create(operation.input, options);
		  });

		  memoizedProperty(this, 'output', function() {
		    if (!operation.output) {
		      return new Shape.create({type: 'structure'}, options);
		    }
		    return Shape.create(operation.output, options);
		  });

		  memoizedProperty(this, 'errors', function() {
		    var list = [];
		    if (!operation.errors) return null;

		    for (var i = 0; i < operation.errors.length; i++) {
		      list.push(Shape.create(operation.errors[i], options));
		    }

		    return list;
		  });

		  memoizedProperty(this, 'paginator', function() {
		    return options.api.paginators[name];
		  });

		  if (options.documentation) {
		    property(this, 'documentation', operation.documentation);
		    property(this, 'documentationUrl', operation.documentationUrl);
		  }

		  // idempotentMembers only tracks top-level input shapes
		  memoizedProperty(this, 'idempotentMembers', function() {
		    var idempotentMembers = [];
		    var input = self.input;
		    var members = input.members;
		    if (!input.members) {
		      return idempotentMembers;
		    }
		    for (var name in members) {
		      if (!members.hasOwnProperty(name)) {
		        continue;
		      }
		      if (members[name].isIdempotent === true) {
		        idempotentMembers.push(name);
		      }
		    }
		    return idempotentMembers;
		  });

		  memoizedProperty(this, 'hasEventOutput', function() {
		    var output = self.output;
		    return hasEventStream(output);
		  });
		}

		function hasEventStream(topLevelShape) {
		  var members = topLevelShape.members;
		  var payload = topLevelShape.payload;

		  if (!topLevelShape.members) {
		    return false;
		  }

		  if (payload) {
		    var payloadMember = members[payload];
		    return payloadMember.isEventStream;
		  }

		  // check if any member is an event stream
		  for (var name in members) {
		    if (!members.hasOwnProperty(name)) {
		      if (members[name].isEventStream === true) {
		        return true;
		      }
		    }
		  }
		  return false;
		}

		/**
		 * @api private
		 */
		module.exports = Operation;


	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {

		var property = __webpack_require__(2).property;

		function Paginator(name, paginator) {
		  property(this, 'inputToken', paginator.input_token);
		  property(this, 'limitKey', paginator.limit_key);
		  property(this, 'moreResults', paginator.more_results);
		  property(this, 'outputToken', paginator.output_token);
		  property(this, 'resultKey', paginator.result_key);
		}

		/**
		 * @api private
		 */
		module.exports = Paginator;


	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);
		var property = util.property;

		function ResourceWaiter(name, waiter, options) {
		  options = options || {};
		  property(this, 'name', name);
		  property(this, 'api', options.api, false);

		  if (waiter.operation) {
		    property(this, 'operation', util.string.lowerFirst(waiter.operation));
		  }

		  var self = this;
		  var keys = [
		    'type',
		    'description',
		    'delay',
		    'maxAttempts',
		    'acceptors'
		  ];

		  keys.forEach(function(key) {
		    var value = waiter[key];
		    if (value) {
		      property(self, key, value);
		    }
		  });
		}

		/**
		 * @api private
		 */
		module.exports = ResourceWaiter;


	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {

		function apiLoader(svc, version) {
		  if (!apiLoader.services.hasOwnProperty(svc)) {
		    throw new Error('InvalidService: Failed to load api for ' + svc);
		  }
		  return apiLoader.services[svc][version];
		}

		/**
		 * @api private
		 *
		 * This member of AWS.apiLoader is private, but changing it will necessitate a
		 * change to ../scripts/services-table-generator.ts
		 */
		apiLoader.services = {};

		/**
		 * @api private
		 */
		module.exports = apiLoader;


	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {

		"use strict";
		Object.defineProperty(exports, "__esModule", { value: true });
		var LRU_1 = __webpack_require__(35);
		var CACHE_SIZE = 1000;
		/**
		 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
		 */
		var EndpointCache = /** @class */ (function () {
		    function EndpointCache(maxSize) {
		        if (maxSize === void 0) { maxSize = CACHE_SIZE; }
		        this.maxSize = maxSize;
		        this.cache = new LRU_1.LRUCache(maxSize);
		    }
		    ;
		    Object.defineProperty(EndpointCache.prototype, "size", {
		        get: function () {
		            return this.cache.length;
		        },
		        enumerable: true,
		        configurable: true
		    });
		    EndpointCache.prototype.put = function (key, value) {
		      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
		        var endpointRecord = this.populateValue(value);
		        this.cache.put(keyString, endpointRecord);
		    };
		    EndpointCache.prototype.get = function (key) {
		      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
		        var now = Date.now();
		        var records = this.cache.get(keyString);
		        if (records) {
		            for (var i = records.length-1; i >= 0; i--) {
		                var record = records[i];
		                if (record.Expire < now) {
		                    records.splice(i, 1);
		                }
		            }
		            if (records.length === 0) {
		                this.cache.remove(keyString);
		                return undefined;
		            }
		        }
		        return records;
		    };
		    EndpointCache.getKeyString = function (key) {
		        var identifiers = [];
		        var identifierNames = Object.keys(key).sort();
		        for (var i = 0; i < identifierNames.length; i++) {
		            var identifierName = identifierNames[i];
		            if (key[identifierName] === undefined)
		                continue;
		            identifiers.push(key[identifierName]);
		        }
		        return identifiers.join(' ');
		    };
		    EndpointCache.prototype.populateValue = function (endpoints) {
		        var now = Date.now();
		        return endpoints.map(function (endpoint) { return ({
		            Address: endpoint.Address || '',
		            Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60 * 1000
		        }); });
		    };
		    EndpointCache.prototype.empty = function () {
		        this.cache.empty();
		    };
		    EndpointCache.prototype.remove = function (key) {
		      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
		        this.cache.remove(keyString);
		    };
		    return EndpointCache;
		}());
		exports.EndpointCache = EndpointCache;

	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {

		"use strict";
		Object.defineProperty(exports, "__esModule", { value: true });
		var LinkedListNode = /** @class */ (function () {
		    function LinkedListNode(key, value) {
		        this.key = key;
		        this.value = value;
		    }
		    return LinkedListNode;
		}());
		var LRUCache = /** @class */ (function () {
		    function LRUCache(size) {
		        this.nodeMap = {};
		        this.size = 0;
		        if (typeof size !== 'number' || size < 1) {
		            throw new Error('Cache size can only be positive number');
		        }
		        this.sizeLimit = size;
		    }
		    Object.defineProperty(LRUCache.prototype, "length", {
		        get: function () {
		            return this.size;
		        },
		        enumerable: true,
		        configurable: true
		    });
		    LRUCache.prototype.prependToList = function (node) {
		        if (!this.headerNode) {
		            this.tailNode = node;
		        }
		        else {
		            this.headerNode.prev = node;
		            node.next = this.headerNode;
		        }
		        this.headerNode = node;
		        this.size++;
		    };
		    LRUCache.prototype.removeFromTail = function () {
		        if (!this.tailNode) {
		            return undefined;
		        }
		        var node = this.tailNode;
		        var prevNode = node.prev;
		        if (prevNode) {
		            prevNode.next = undefined;
		        }
		        node.prev = undefined;
		        this.tailNode = prevNode;
		        this.size--;
		        return node;
		    };
		    LRUCache.prototype.detachFromList = function (node) {
		        if (this.headerNode === node) {
		            this.headerNode = node.next;
		        }
		        if (this.tailNode === node) {
		            this.tailNode = node.prev;
		        }
		        if (node.prev) {
		            node.prev.next = node.next;
		        }
		        if (node.next) {
		            node.next.prev = node.prev;
		        }
		        node.next = undefined;
		        node.prev = undefined;
		        this.size--;
		    };
		    LRUCache.prototype.get = function (key) {
		        if (this.nodeMap[key]) {
		            var node = this.nodeMap[key];
		            this.detachFromList(node);
		            this.prependToList(node);
		            return node.value;
		        }
		    };
		    LRUCache.prototype.remove = function (key) {
		        if (this.nodeMap[key]) {
		            var node = this.nodeMap[key];
		            this.detachFromList(node);
		            delete this.nodeMap[key];
		        }
		    };
		    LRUCache.prototype.put = function (key, value) {
		        if (this.nodeMap[key]) {
		            this.remove(key);
		        }
		        else if (this.size === this.sizeLimit) {
		            var tailNode = this.removeFromTail();
		            var key_1 = tailNode.key;
		            delete this.nodeMap[key_1];
		        }
		        var newNode = new LinkedListNode(key, value);
		        this.nodeMap[key] = newNode;
		        this.prependToList(newNode);
		    };
		    LRUCache.prototype.empty = function () {
		        var keys = Object.keys(this.nodeMap);
		        for (var i = 0; i < keys.length; i++) {
		            var key = keys[i];
		            var node = this.nodeMap[key];
		            this.detachFromList(node);
		            delete this.nodeMap[key];
		        }
		    };
		    return LRUCache;
		}());
		exports.LRUCache = LRUCache;

	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);

		/**
		 * @api private
		 * @!method on(eventName, callback)
		 *   Registers an event listener callback for the event given by `eventName`.
		 *   Parameters passed to the callback function depend on the individual event
		 *   being triggered. See the event documentation for those parameters.
		 *
		 *   @param eventName [String] the event name to register the listener for
		 *   @param callback [Function] the listener callback function
		 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
		 *     Default to be false.
		 *   @return [AWS.SequentialExecutor] the same object for chaining
		 */
		AWS.SequentialExecutor = AWS.util.inherit({

		  constructor: function SequentialExecutor() {
		    this._events = {};
		  },

		  /**
		   * @api private
		   */
		  listeners: function listeners(eventName) {
		    return this._events[eventName] ? this._events[eventName].slice(0) : [];
		  },

		  on: function on(eventName, listener, toHead) {
		    if (this._events[eventName]) {
		      toHead ?
		        this._events[eventName].unshift(listener) :
		        this._events[eventName].push(listener);
		    } else {
		      this._events[eventName] = [listener];
		    }
		    return this;
		  },

		  onAsync: function onAsync(eventName, listener, toHead) {
		    listener._isAsync = true;
		    return this.on(eventName, listener, toHead);
		  },

		  removeListener: function removeListener(eventName, listener) {
		    var listeners = this._events[eventName];
		    if (listeners) {
		      var length = listeners.length;
		      var position = -1;
		      for (var i = 0; i < length; ++i) {
		        if (listeners[i] === listener) {
		          position = i;
		        }
		      }
		      if (position > -1) {
		        listeners.splice(position, 1);
		      }
		    }
		    return this;
		  },

		  removeAllListeners: function removeAllListeners(eventName) {
		    if (eventName) {
		      delete this._events[eventName];
		    } else {
		      this._events = {};
		    }
		    return this;
		  },

		  /**
		   * @api private
		   */
		  emit: function emit(eventName, eventArgs, doneCallback) {
		    if (!doneCallback) doneCallback = function() { };
		    var listeners = this.listeners(eventName);
		    var count = listeners.length;
		    this.callListeners(listeners, eventArgs, doneCallback);
		    return count > 0;
		  },

		  /**
		   * @api private
		   */
		  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
		    var self = this;
		    var error = prevError || null;

		    function callNextListener(err) {
		      if (err) {
		        error = AWS.util.error(error || new Error(), err);
		        if (self._haltHandlersOnError) {
		          return doneCallback.call(self, error);
		        }
		      }
		      self.callListeners(listeners, args, doneCallback, error);
		    }

		    while (listeners.length > 0) {
		      var listener = listeners.shift();
		      if (listener._isAsync) { // asynchronous listener
		        listener.apply(self, args.concat([callNextListener]));
		        return; // stop here, callNextListener will continue
		      } else { // synchronous listener
		        try {
		          listener.apply(self, args);
		        } catch (err) {
		          error = AWS.util.error(error || new Error(), err);
		        }
		        if (error && self._haltHandlersOnError) {
		          doneCallback.call(self, error);
		          return;
		        }
		      }
		    }
		    doneCallback.call(self, error);
		  },

		  /**
		   * Adds or copies a set of listeners from another list of
		   * listeners or SequentialExecutor object.
		   *
		   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
		   *   a list of events and callbacks, or an event emitter object
		   *   containing listeners to add to this emitter object.
		   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
		   * @example Adding listeners from a map of listeners
		   *   emitter.addListeners({
		   *     event1: [function() { ... }, function() { ... }],
		   *     event2: [function() { ... }]
		   *   });
		   *   emitter.emit('event1'); // emitter has event1
		   *   emitter.emit('event2'); // emitter has event2
		   * @example Adding listeners from another emitter object
		   *   var emitter1 = new AWS.SequentialExecutor();
		   *   emitter1.on('event1', function() { ... });
		   *   emitter1.on('event2', function() { ... });
		   *   var emitter2 = new AWS.SequentialExecutor();
		   *   emitter2.addListeners(emitter1);
		   *   emitter2.emit('event1'); // emitter2 has event1
		   *   emitter2.emit('event2'); // emitter2 has event2
		   */
		  addListeners: function addListeners(listeners) {
		    var self = this;

		    // extract listeners if parameter is an SequentialExecutor object
		    if (listeners._events) listeners = listeners._events;

		    AWS.util.each(listeners, function(event, callbacks) {
		      if (typeof callbacks === 'function') callbacks = [callbacks];
		      AWS.util.arrayEach(callbacks, function(callback) {
		        self.on(event, callback);
		      });
		    });

		    return self;
		  },

		  /**
		   * Registers an event with {on} and saves the callback handle function
		   * as a property on the emitter object using a given `name`.
		   *
		   * @param name [String] the property name to set on this object containing
		   *   the callback function handle so that the listener can be removed in
		   *   the future.
		   * @param (see on)
		   * @return (see on)
		   * @example Adding a named listener DATA_CALLBACK
		   *   var listener = function() { doSomething(); };
		   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
		   *
		   *   // the following prints: true
		   *   console.log(emitter.DATA_CALLBACK == listener);
		   */
		  addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
		    this[name] = callback;
		    this.addListener(eventName, callback, toHead);
		    return this;
		  },

		  /**
		   * @api private
		   */
		  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
		    callback._isAsync = true;
		    return this.addNamedListener(name, eventName, callback, toHead);
		  },

		  /**
		   * Helper method to add a set of named listeners using
		   * {addNamedListener}. The callback contains a parameter
		   * with a handle to the `addNamedListener` method.
		   *
		   * @callback callback function(add)
		   *   The callback function is called immediately in order to provide
		   *   the `add` function to the block. This simplifies the addition of
		   *   a large group of named listeners.
		   *   @param add [Function] the {addNamedListener} function to call
		   *     when registering listeners.
		   * @example Adding a set of named listeners
		   *   emitter.addNamedListeners(function(add) {
		   *     add('DATA_CALLBACK', 'data', function() { ... });
		   *     add('OTHER', 'otherEvent', function() { ... });
		   *     add('LAST', 'lastEvent', function() { ... });
		   *   });
		   *
		   *   // these properties are now set:
		   *   emitter.DATA_CALLBACK;
		   *   emitter.OTHER;
		   *   emitter.LAST;
		   */
		  addNamedListeners: function addNamedListeners(callback) {
		    var self = this;
		    callback(
		      function() {
		        self.addNamedListener.apply(self, arguments);
		      },
		      function() {
		        self.addNamedAsyncListener.apply(self, arguments);
		      }
		    );
		    return this;
		  }
		});

		/**
		 * {on} is the prefered method.
		 * @api private
		 */
		AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;

		/**
		 * @api private
		 */
		module.exports = AWS.SequentialExecutor;


	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(1);
		var Api = __webpack_require__(29);
		var regionConfig = __webpack_require__(38);

		var inherit = AWS.util.inherit;
		var clientCount = 0;
		var region_utils = __webpack_require__(40);

		/**
		 * The service class representing an AWS service.
		 *
		 * @class_abstract This class is an abstract class.
		 *
		 * @!attribute apiVersions
		 *   @return [Array<String>] the list of API versions supported by this service.
		 *   @readonly
		 */
		AWS.Service = inherit({
		  /**
		   * Create a new service object with a configuration object
		   *
		   * @param config [map] a map of configuration options
		   */
		  constructor: function Service(config) {
		    if (!this.loadServiceClass) {
		      throw AWS.util.error(new Error(),
		        'Service must be constructed with `new\' operator');
		    }

		    if (config) {
		      if (config.region) {
		        var region = config.region;
		        if (region_utils.isFipsRegion(region)) {
		          config.region = region_utils.getRealRegion(region);
		          config.useFipsEndpoint = true;
		        }
		        if (region_utils.isGlobalRegion(region)) {
		          config.region = region_utils.getRealRegion(region);
		        }
		      }
		      if (typeof config.useDualstack === 'boolean'
		        && typeof config.useDualstackEndpoint !== 'boolean') {
		        config.useDualstackEndpoint = config.useDualstack;
		      }
		    }

		    var ServiceClass = this.loadServiceClass(config || {});
		    if (ServiceClass) {
		      var originalConfig = AWS.util.copy(config);
		      var svc = new ServiceClass(config);
		      Object.defineProperty(svc, '_originalConfig', {
		        get: function() { return originalConfig; },
		        enumerable: false,
		        configurable: true
		      });
		      svc._clientId = ++clientCount;
		      return svc;
		    }
		    this.initialize(config);
		  },

		  /**
		   * @api private
		   */
		  initialize: function initialize(config) {
		    var svcConfig = AWS.config[this.serviceIdentifier];
		    this.config = new AWS.Config(AWS.config);
		    if (svcConfig) this.config.update(svcConfig, true);
		    if (config) this.config.update(config, true);

		    this.validateService();
		    if (!this.config.endpoint) regionConfig.configureEndpoint(this);

		    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
		    this.setEndpoint(this.config.endpoint);
		    //enable attaching listeners to service client
		    AWS.SequentialExecutor.call(this);
		    AWS.Service.addDefaultMonitoringListeners(this);
		    if ((this.config.clientSideMonitoring || AWS.Service._clientSideMonitoring) && this.publisher) {
		      var publisher = this.publisher;
		      this.addNamedListener('PUBLISH_API_CALL', 'apiCall', function PUBLISH_API_CALL(event) {
		        process.nextTick(function() {publisher.eventHandler(event);});
		      });
		      this.addNamedListener('PUBLISH_API_ATTEMPT', 'apiCallAttempt', function PUBLISH_API_ATTEMPT(event) {
		        process.nextTick(function() {publisher.eventHandler(event);});
		      });
		    }
		  },

		  /**
		   * @api private
		   */
		  validateService: function validateService() {
		  },

		  /**
		   * @api private
		   */
		  loadServiceClass: function loadServiceClass(serviceConfig) {
		    var config = serviceConfig;
		    if (!AWS.util.isEmpty(this.api)) {
		      return null;
		    } else if (config.apiConfig) {
		      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
		    } else if (!this.constructor.services) {
		      return null;
		    } else {
		      config = new AWS.Config(AWS.config);
		      config.update(serviceConfig, true);
		      var version = config.apiVersions[this.constructor.serviceIdentifier];
		      version = version || config.apiVersion;
		      return this.getLatestServiceClass(version);
		    }
		  },

		  /**
		   * @api private
		   */
		  getLatestServiceClass: function getLatestServiceClass(version) {
		    version = this.getLatestServiceVersion(version);
		    if (this.constructor.services[version] === null) {
		      AWS.Service.defineServiceApi(this.constructor, version);
		    }

		    return this.constructor.services[version];
		  },

		  /**
		   * @api private
		   */
		  getLatestServiceVersion: function getLatestServiceVersion(version) {
		    if (!this.constructor.services || this.constructor.services.length === 0) {
		      throw new Error('No services defined on ' +
		                      this.constructor.serviceIdentifier);
		    }

		    if (!version) {
		      version = 'latest';
		    } else if (AWS.util.isType(version, Date)) {
		      version = AWS.util.date.iso8601(version).split('T')[0];
		    }

		    if (Object.hasOwnProperty(this.constructor.services, version)) {
		      return version;
		    }

		    var keys = Object.keys(this.constructor.services).sort();
		    var selectedVersion = null;
		    for (var i = keys.length - 1; i >= 0; i--) {
		      // versions that end in "*" are not available on disk and can be
		      // skipped, so do not choose these as selectedVersions
		      if (keys[i][keys[i].length - 1] !== '*') {
		        selectedVersion = keys[i];
		      }
		      if (keys[i].substr(0, 10) <= version) {
		        return selectedVersion;
		      }
		    }

		    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
		                    ' API to satisfy version constraint `' + version + '\'');
		  },

		  /**
		   * @api private
		   */
		  api: {},

		  /**
		   * @api private
		   */
		  defaultRetryCount: 3,

		  /**
		   * @api private
		   */
		  customizeRequests: function customizeRequests(callback) {
		    if (!callback) {
		      this.customRequestHandler = null;
		    } else if (typeof callback === 'function') {
		      this.customRequestHandler = callback;
		    } else {
		      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
		    }
		  },

		  /**
		   * Calls an operation on a service with the given input parameters.
		   *
		   * @param operation [String] the name of the operation to call on the service.
		   * @param params [map] a map of input options for the operation
		   * @callback callback function(err, data)
		   *   If a callback is supplied, it is called when a response is returned
		   *   from the service.
		   *   @param err [Error] the error object returned from the request.
		   *     Set to `null` if the request is successful.
		   *   @param data [Object] the de-serialized data returned from
		   *     the request. Set to `null` if a request error occurs.
		   */
		  makeRequest: function makeRequest(operation, params, callback) {
		    if (typeof params === 'function') {
		      callback = params;
		      params = null;
		    }

		    params = params || {};
		    if (this.config.params) { // copy only toplevel bound params
		      var rules = this.api.operations[operation];
		      if (rules) {
		        params = AWS.util.copy(params);
		        AWS.util.each(this.config.params, function(key, value) {
		          if (rules.input.members[key]) {
		            if (params[key] === undefined || params[key] === null) {
		              params[key] = value;
		            }
		          }
		        });
		      }
		    }

		    var request = new AWS.Request(this, operation, params);
		    this.addAllRequestListeners(request);
		    this.attachMonitoringEmitter(request);
		    if (callback) request.send(callback);
		    return request;
		  },

		  /**
		   * Calls an operation on a service with the given input parameters, without
		   * any authentication data. This method is useful for "public" API operations.
		   *
		   * @param operation [String] the name of the operation to call on the service.
		   * @param params [map] a map of input options for the operation
		   * @callback callback function(err, data)
		   *   If a callback is supplied, it is called when a response is returned
		   *   from the service.
		   *   @param err [Error] the error object returned from the request.
		   *     Set to `null` if the request is successful.
		   *   @param data [Object] the de-serialized data returned from
		   *     the request. Set to `null` if a request error occurs.
		   */
		  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
		    if (typeof params === 'function') {
		      callback = params;
		      params = {};
		    }

		    var request = this.makeRequest(operation, params).toUnauthenticated();
		    return callback ? request.send(callback) : request;
		  },

		  /**
		   * Waits for a given state
		   *
		   * @param state [String] the state on the service to wait for
		   * @param params [map] a map of parameters to pass with each request
		   * @option params $waiter [map] a map of configuration options for the waiter
		   * @option params $waiter.delay [Number] The number of seconds to wait between
		   *                                       requests
		   * @option params $waiter.maxAttempts [Number] The maximum number of requests
		   *                                             to send while waiting
		   * @callback callback function(err, data)
		   *   If a callback is supplied, it is called when a response is returned
		   *   from the service.
		   *   @param err [Error] the error object returned from the request.
		   *     Set to `null` if the request is successful.
		   *   @param data [Object] the de-serialized data returned from
		   *     the request. Set to `null` if a request error occurs.
		   */
		  waitFor: function waitFor(state, params, callback) {
		    var waiter = new AWS.ResourceWaiter(this, state);
		    return waiter.wait(params, callback);
		  },

		  /**
		   * @api private
		   */
		  addAllRequestListeners: function addAllRequestListeners(request) {
		    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
		                AWS.EventListeners.CorePost];
		    for (var i = 0; i < list.length; i++) {
		      if (list[i]) request.addListeners(list[i]);
		    }

		    // disable parameter validation
		    if (!this.config.paramValidation) {
		      request.removeListener('validate',
		        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
		    }

		    if (this.config.logger) { // add logging events
		      request.addListeners(AWS.EventListeners.Logger);
		    }

		    this.setupRequestListeners(request);
		    // call prototype's customRequestHandler
		    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
		      this.constructor.prototype.customRequestHandler(request);
		    }
		    // call instance's customRequestHandler
		    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
		      this.customRequestHandler(request);
		    }
		  },

		  /**
		   * Event recording metrics for a whole API call.
		   * @returns {object} a subset of api call metrics
		   * @api private
		   */
		  apiCallEvent: function apiCallEvent(request) {
		    var api = request.service.api.operations[request.operation];
		    var monitoringEvent = {
		      Type: 'ApiCall',
		      Api: api ? api.name : request.operation,
		      Version: 1,
		      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
		      Region: request.httpRequest.region,
		      MaxRetriesExceeded: 0,
		      UserAgent: request.httpRequest.getUserAgent(),
		    };
		    var response = request.response;
		    if (response.httpResponse.statusCode) {
		      monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
		    }
		    if (response.error) {
		      var error = response.error;
		      var statusCode = response.httpResponse.statusCode;
		      if (statusCode > 299) {
		        if (error.code) monitoringEvent.FinalAwsException = error.code;
		        if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
		      } else {
		        if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
		        if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
		      }
		    }
		    return monitoringEvent;
		  },

		  /**
		   * Event recording metrics for an API call attempt.
		   * @returns {object} a subset of api call attempt metrics
		   * @api private
		   */
		  apiAttemptEvent: function apiAttemptEvent(request) {
		    var api = request.service.api.operations[request.operation];
		    var monitoringEvent = {
		      Type: 'ApiCallAttempt',
		      Api: api ? api.name : request.operation,
		      Version: 1,
		      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
		      Fqdn: request.httpRequest.endpoint.hostname,
		      UserAgent: request.httpRequest.getUserAgent(),
		    };
		    var response = request.response;
		    if (response.httpResponse.statusCode) {
		      monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
		    }
		    if (
		      !request._unAuthenticated &&
		      request.service.config.credentials &&
		      request.service.config.credentials.accessKeyId
		    ) {
		      monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
		    }
		    if (!response.httpResponse.headers) return monitoringEvent;
		    if (request.httpRequest.headers['x-amz-security-token']) {
		      monitoringEvent.SessionToken = request.httpRequest.headers['x-amz-security-token'];
		    }
		    if (response.httpResponse.headers['x-amzn-requestid']) {
		      monitoringEvent.XAmznRequestId = response.httpResponse.headers['x-amzn-requestid'];
		    }
		    if (response.httpResponse.headers['x-amz-request-id']) {
		      monitoringEvent.XAmzRequestId = response.httpResponse.headers['x-amz-request-id'];
		    }
		    if (response.httpResponse.headers['x-amz-id-2']) {
		      monitoringEvent.XAmzId2 = response.httpResponse.headers['x-amz-id-2'];
		    }
		    return monitoringEvent;
		  },

		  /**
		   * Add metrics of failed request.
		   * @api private
		   */
		  attemptFailEvent: function attemptFailEvent(request) {
		    var monitoringEvent = this.apiAttemptEvent(request);
		    var response = request.response;
		    var error = response.error;
		    if (response.httpResponse.statusCode > 299 ) {
		      if (error.code) monitoringEvent.AwsException = error.code;
		      if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
		    } else {
		      if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
		      if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
		    }
		    return monitoringEvent;
		  },

		  /**
		   * Attach listeners to request object to fetch metrics of each request
		   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
		   * @api private
		   */
		  attachMonitoringEmitter: function attachMonitoringEmitter(request) {
		    var attemptTimestamp; //timestamp marking the beginning of a request attempt
		    var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
		    var attemptLatency; //latency from request sent out to http response reaching SDK
		    var callStartRealTime; //Start time of API call. Used to calculating API call latency
		    var attemptCount = 0; //request.retryCount is not reliable here
		    var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
		    var callTimestamp; //timestamp when the request is created
		    var self = this;
		    var addToHead = true;

		    request.on('validate', function () {
		      callStartRealTime = AWS.util.realClock.now();
		      callTimestamp = Date.now();
		    }, addToHead);
		    request.on('sign', function () {
		      attemptStartRealTime = AWS.util.realClock.now();
		      attemptTimestamp = Date.now();
		      region = request.httpRequest.region;
		      attemptCount++;
		    }, addToHead);
		    request.on('validateResponse', function() {
		      attemptLatency = Math.round(AWS.util.realClock.now() - attemptStartRealTime);
		    });
		    request.addNamedListener('API_CALL_ATTEMPT', 'success', function API_CALL_ATTEMPT() {
		      var apiAttemptEvent = self.apiAttemptEvent(request);
		      apiAttemptEvent.Timestamp = attemptTimestamp;
		      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
		      apiAttemptEvent.Region = region;
		      self.emit('apiCallAttempt', [apiAttemptEvent]);
		    });
		    request.addNamedListener('API_CALL_ATTEMPT_RETRY', 'retry', function API_CALL_ATTEMPT_RETRY() {
		      var apiAttemptEvent = self.attemptFailEvent(request);
		      apiAttemptEvent.Timestamp = attemptTimestamp;
		      //attemptLatency may not be available if fail before response
		      attemptLatency = attemptLatency ||
		        Math.round(AWS.util.realClock.now() - attemptStartRealTime);
		      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
		      apiAttemptEvent.Region = region;
		      self.emit('apiCallAttempt', [apiAttemptEvent]);
		    });
		    request.addNamedListener('API_CALL', 'complete', function API_CALL() {
		      var apiCallEvent = self.apiCallEvent(request);
		      apiCallEvent.AttemptCount = attemptCount;
		      if (apiCallEvent.AttemptCount <= 0) return;
		      apiCallEvent.Timestamp = callTimestamp;
		      var latency = Math.round(AWS.util.realClock.now() - callStartRealTime);
		      apiCallEvent.Latency = latency >= 0 ? latency : 0;
		      var response = request.response;
		      if (
		        response.error &&
		        response.error.retryable &&
		        typeof response.retryCount === 'number' &&
		        typeof response.maxRetries === 'number' &&
		        (response.retryCount >= response.maxRetries)
		      ) {
		        apiCallEvent.MaxRetriesExceeded = 1;
		      }
		      self.emit('apiCall', [apiCallEvent]);
		    });
		  },

		  /**
		   * Override this method to setup any custom request listeners for each
		   * new request to the service.
		   *
		   * @method_abstract This is an abstract method.
		   */
		  setupRequestListeners: function setupRequestListeners(request) {
		  },

		  /**
		   * Gets the signing name for a given request
		   * @api private
		   */
		  getSigningName: function getSigningName() {
		    return this.api.signingName || this.api.endpointPrefix;
		  },

		  /**
		   * Gets the signer class for a given request
		   * @api private
		   */
		  getSignerClass: function getSignerClass(request) {
		    var version;
		    // get operation authtype if present
		    var operation = null;
		    var authtype = '';
		    if (request) {
		      var operations = request.service.api.operations || {};
		      operation = operations[request.operation] || null;
		      authtype = operation ? operation.authtype : '';
		    }
		    if (this.config.signatureVersion) {
		      version = this.config.signatureVersion;
		    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
		      version = 'v4';
		    } else {
		      version = this.api.signatureVersion;
		    }
		    return AWS.Signers.RequestSigner.getVersion(version);
		  },

		  /**
		   * @api private
		   */
		  serviceInterface: function serviceInterface() {
		    switch (this.api.protocol) {
		      case 'ec2': return AWS.EventListeners.Query;
		      case 'query': return AWS.EventListeners.Query;
		      case 'json': return AWS.EventListeners.Json;
		      case 'rest-json': return AWS.EventListeners.RestJson;
		      case 'rest-xml': return AWS.EventListeners.RestXml;
		    }
		    if (this.api.protocol) {
		      throw new Error('Invalid service `protocol\' ' +
		        this.api.protocol + ' in API config');
		    }
		  },

		  /**
		   * @api private
		   */
		  successfulResponse: function successfulResponse(resp) {
		    return resp.httpResponse.statusCode < 300;
		  },

		  /**
		   * How many times a failed request should be retried before giving up.
		   * the defaultRetryCount can be overriden by service classes.
		   *
		   * @api private
		   */
		  numRetries: function numRetries() {
		    if (this.config.maxRetries !== undefined) {
		      return this.config.maxRetries;
		    } else {
		      return this.defaultRetryCount;
		    }
		  },

		  /**
		   * @api private
		   */
		  retryDelays: function retryDelays(retryCount, err) {
		    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions, err);
		  },

		  /**
		   * @api private
		   */
		  retryableError: function retryableError(error) {
		    if (this.timeoutError(error)) return true;
		    if (this.networkingError(error)) return true;
		    if (this.expiredCredentialsError(error)) return true;
		    if (this.throttledError(error)) return true;
		    if (error.statusCode >= 500) return true;
		    return false;
		  },

		  /**
		   * @api private
		   */
		  networkingError: function networkingError(error) {
		    return error.code === 'NetworkingError';
		  },

		  /**
		   * @api private
		   */
		  timeoutError: function timeoutError(error) {
		    return error.code === 'TimeoutError';
		  },

		  /**
		   * @api private
		   */
		  expiredCredentialsError: function expiredCredentialsError(error) {
		    // TODO : this only handles *one* of the expired credential codes
		    return (error.code === 'ExpiredTokenException');
		  },

		  /**
		   * @api private
		   */
		  clockSkewError: function clockSkewError(error) {
		    switch (error.code) {
		      case 'RequestTimeTooSkewed':
		      case 'RequestExpired':
		      case 'InvalidSignatureException':
		      case 'SignatureDoesNotMatch':
		      case 'AuthFailure':
		      case 'RequestInTheFuture':
		        return true;
		      default: return false;
		    }
		  },

		  /**
		   * @api private
		   */
		  getSkewCorrectedDate: function getSkewCorrectedDate() {
		    return new Date(Date.now() + this.config.systemClockOffset);
		  },

		  /**
		   * @api private
		   */
		  applyClockOffset: function applyClockOffset(newServerTime) {
		    if (newServerTime) {
		      this.config.systemClockOffset = newServerTime - Date.now();
		    }
		  },

		  /**
		   * @api private
		   */
		  isClockSkewed: function isClockSkewed(newServerTime) {
		    if (newServerTime) {
		      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 300000;
		    }
		  },

		  /**
		   * @api private
		   */
		  throttledError: function throttledError(error) {
		    // this logic varies between services
		    if (error.statusCode === 429) return true;
		    switch (error.code) {
		      case 'ProvisionedThroughputExceededException':
		      case 'Throttling':
		      case 'ThrottlingException':
		      case 'RequestLimitExceeded':
		      case 'RequestThrottled':
		      case 'RequestThrottledException':
		      case 'TooManyRequestsException':
		      case 'TransactionInProgressException': //dynamodb
		      case 'EC2ThrottledException':
		        return true;
		      default:
		        return false;
		    }
		  },

		  /**
		   * @api private
		   */
		  endpointFromTemplate: function endpointFromTemplate(endpoint) {
		    if (typeof endpoint !== 'string') return endpoint;

		    var e = endpoint;
		    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
		    e = e.replace(/\{region\}/g, this.config.region);
		    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
		    return e;
		  },

		  /**
		   * @api private
		   */
		  setEndpoint: function setEndpoint(endpoint) {
		    this.endpoint = new AWS.Endpoint(endpoint, this.config);
		  },

		  /**
		   * @api private
		   */
		  paginationConfig: function paginationConfig(operation, throwException) {
		    var paginator = this.api.operations[operation].paginator;
		    if (!paginator) {
		      if (throwException) {
		        var e = new Error();
		        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
		      }
		      return null;
		    }

		    return paginator;
		  }
		});

		AWS.util.update(AWS.Service, {

		  /**
		   * Adds one method for each operation described in the api configuration
		   *
		   * @api private
		   */
		  defineMethods: function defineMethods(svc) {
		    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
		      if (svc.prototype[method]) return;
		      var operation = svc.prototype.api.operations[method];
		      if (operation.authtype === 'none') {
		        svc.prototype[method] = function (params, callback) {
		          return this.makeUnauthenticatedRequest(method, params, callback);
		        };
		      } else {
		        svc.prototype[method] = function (params, callback) {
		          return this.makeRequest(method, params, callback);
		        };
		      }
		    });
		  },

		  /**
		   * Defines a new Service class using a service identifier and list of versions
		   * including an optional set of features (functions) to apply to the class
		   * prototype.
		   *
		   * @param serviceIdentifier [String] the identifier for the service
		   * @param versions [Array<String>] a list of versions that work with this
		   *   service
		   * @param features [Object] an object to attach to the prototype
		   * @return [Class<Service>] the service class defined by this function.
		   */
		  defineService: function defineService(serviceIdentifier, versions, features) {
		    AWS.Service._serviceMap[serviceIdentifier] = true;
		    if (!Array.isArray(versions)) {
		      features = versions;
		      versions = [];
		    }

		    var svc = inherit(AWS.Service, features || {});

		    if (typeof serviceIdentifier === 'string') {
		      AWS.Service.addVersions(svc, versions);

		      var identifier = svc.serviceIdentifier || serviceIdentifier;
		      svc.serviceIdentifier = identifier;
		    } else { // defineService called with an API
		      svc.prototype.api = serviceIdentifier;
		      AWS.Service.defineMethods(svc);
		    }
		    AWS.SequentialExecutor.call(this.prototype);
		    //util.clientSideMonitoring is only available in node
		    if (!this.prototype.publisher && AWS.util.clientSideMonitoring) {
		      var Publisher = AWS.util.clientSideMonitoring.Publisher;
		      var configProvider = AWS.util.clientSideMonitoring.configProvider;
		      var publisherConfig = configProvider();
		      this.prototype.publisher = new Publisher(publisherConfig);
		      if (publisherConfig.enabled) {
		        //if csm is enabled in environment, SDK should send all metrics
		        AWS.Service._clientSideMonitoring = true;
		      }
		    }
		    AWS.SequentialExecutor.call(svc.prototype);
		    AWS.Service.addDefaultMonitoringListeners(svc.prototype);
		    return svc;
		  },

		  /**
		   * @api private
		   */
		  addVersions: function addVersions(svc, versions) {
		    if (!Array.isArray(versions)) versions = [versions];

		    svc.services = svc.services || {};
		    for (var i = 0; i < versions.length; i++) {
		      if (svc.services[versions[i]] === undefined) {
		        svc.services[versions[i]] = null;
		      }
		    }

		    svc.apiVersions = Object.keys(svc.services).sort();
		  },

		  /**
		   * @api private
		   */
		  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
		    var svc = inherit(superclass, {
		      serviceIdentifier: superclass.serviceIdentifier
		    });

		    function setApi(api) {
		      if (api.isApi) {
		        svc.prototype.api = api;
		      } else {
		        svc.prototype.api = new Api(api, {
		          serviceIdentifier: superclass.serviceIdentifier
		        });
		      }
		    }

		    if (typeof version === 'string') {
		      if (apiConfig) {
		        setApi(apiConfig);
		      } else {
		        try {
		          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
		        } catch (err) {
		          throw AWS.util.error(err, {
		            message: 'Could not find API configuration ' +
		              superclass.serviceIdentifier + '-' + version
		          });
		        }
		      }
		      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
		        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
		      }
		      superclass.services[version] = svc;
		    } else {
		      setApi(version);
		    }

		    AWS.Service.defineMethods(svc);
		    return svc;
		  },

		  /**
		   * @api private
		   */
		  hasService: function(identifier) {
		    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
		  },

		  /**
		   * @param attachOn attach default monitoring listeners to object
		   *
		   * Each monitoring event should be emitted from service client to service constructor prototype and then
		   * to global service prototype like bubbling up. These default monitoring events listener will transfer
		   * the monitoring events to the upper layer.
		   * @api private
		   */
		  addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
		    attachOn.addNamedListener('MONITOR_EVENTS_BUBBLE', 'apiCallAttempt', function EVENTS_BUBBLE(event) {
		      var baseClass = Object.getPrototypeOf(attachOn);
		      if (baseClass._events) baseClass.emit('apiCallAttempt', [event]);
		    });
		    attachOn.addNamedListener('CALL_EVENTS_BUBBLE', 'apiCall', function CALL_EVENTS_BUBBLE(event) {
		      var baseClass = Object.getPrototypeOf(attachOn);
		      if (baseClass._events) baseClass.emit('apiCall', [event]);
		    });
		  },

		  /**
		   * @api private
		   */
		  _serviceMap: {}
		});

		AWS.util.mixin(AWS.Service, AWS.SequentialExecutor);

		/**
		 * @api private
		 */
		module.exports = AWS.Service;

		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {

		var util = __webpack_require__(2);
		var regionConfig = __webpack_require__(39);

		function generateRegionPrefix(region) {
		  if (!region) return null;
		  var parts = region.split('-');
		  if (parts.length < 3) return null;
		  return parts.slice(0, parts.length - 2).join('-') + '-*';
		}

		function derivedKeys(service) {
		  var region = service.config.region;
		  var regionPrefix = generateRegionPrefix(region);
		  var endpointPrefix = service.api.endpointPrefix;

		  return [
		    [region, endpointPrefix],
		    [regionPrefix, endpointPrefix],
		    [region, '*'],
		    [regionPrefix, '*'],
		    ['*', endpointPrefix],
		    ['*', '*']
		  ].map(function(item) {
		    return item[0] && item[1] ? item.join('/') : null;
		  });
		}

		function applyConfig(service, config) {
		  util.each(config, function(key, value) {
		    if (key === 'globalEndpoint') return;
		    if (service.config[key] === undefined || service.config[key] === null) {
		      service.config[key] = value;
		    }
		  });
		}

		function configureEndpoint(service) {
		  var keys = derivedKeys(service);
		  var useFipsEndpoint = service.config.useFipsEndpoint;
		  var useDualstackEndpoint = service.config.useDualstackEndpoint;
		  for (var i = 0; i < keys.length; i++) {
		    var key = keys[i];
		    if (!key) continue;

		    var rules = useFipsEndpoint
		      ? useDualstackEndpoint
		        ? regionConfig.dualstackFipsRules
		        : regionConfig.fipsRules
		      : useDualstackEndpoint
		      ? regionConfig.dualstackRules
		      : regionConfig.rules;

		    if (Object.prototype.hasOwnProperty.call(rules, key)) {
		      var config = rules[key];
		      if (typeof config === 'string') {
		        config = regionConfig.patterns[config];
		      }

		      // set global endpoint
		      service.isGlobalEndpoint = !!config.globalEndpoint;
		      if (config.signingRegion) {
		        service.signingRegion = config.signingRegion;
		      }

		      // signature version
		      if (!config.signatureVersion) config.signatureVersion = 'v4';

		      // merge config
		      applyConfig(service, config);
		      return;
		    }
		  }
		}

		function getEndpointSuffix(region) {
		  var regionRegexes = {
		    '^(us|eu|ap|sa|ca|me)\\-\\w+\\-\\d+$': 'amazonaws.com',
		    '^cn\\-\\w+\\-\\d+$': 'amazonaws.com.cn',
		    '^us\\-gov\\-\\w+\\-\\d+$': 'amazonaws.com',
		    '^us\\-iso\\-\\w+\\-\\d+$': 'c2s.ic.gov',
		    '^us\\-isob\\-\\w+\\-\\d+$': 'sc2s.sgov.gov'
		  };
		  var defaultSuffix = 'amazonaws.com';
		  var regexes = Object.keys(regionRegexes);
		  for (var i = 0; i < regexes.length; i++) {
		    var regionPattern = RegExp(regexes[i]);
		    var dnsSuffix = regionRegexes[regexes[i]];
		    if (regionPattern.test(region)) return dnsSuffix;
		  }
		  return defaultSuffix;
		}

		/**
		 * @api private
		 */
		module.exports = {
		  configureEndpoint: configureEndpoint,
		  getEndpointSuffix: getEndpointSuffix,
		};


	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {

		module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"us-iso-*/*":"usIso","us-isob-*/*":"usIsob","*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":"globalSSL","cn-*/route53":{"endpoint":"{service}.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-northwest-1"},"us-gov-*/route53":"globalGovCloud","us-iso-*/route53":{"endpoint":"{service}.c2s.ic.gov","globalEndpoint":true,"signingRegion":"us-iso-east-1"},"us-isob-*/route53":{"endpoint":"{service}.sc2s.sgov.gov","globalEndpoint":true,"signingRegion":"us-isob-east-1"},"*/waf":"globalSSL","*/iam":"globalSSL","cn-*/iam":{"endpoint":"{service}.cn-north-1.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-north-1"},"us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"fipsRules":{"*/*":"fipsStandard","us-gov-*/*":"fipsStandard","us-iso-*/*":{"endpoint":"{service}-fips.{region}.c2s.ic.gov"},"us-iso-*/dms":"usIso","us-isob-*/*":{"endpoint":"{service}-fips.{region}.sc2s.sgov.gov"},"us-isob-*/dms":"usIsob","cn-*/*":{"endpoint":"{service}-fips.{region}.amazonaws.com.cn"},"*/api.ecr":"fips.api.ecr","*/api.sagemaker":"fips.api.sagemaker","*/batch":"fipsDotPrefix","*/eks":"fipsDotPrefix","*/models.lex":"fips.models.lex","*/runtime.lex":"fips.runtime.lex","*/runtime.sagemaker":{"endpoint":"runtime-fips.sagemaker.{region}.amazonaws.com"},"*/iam":"fipsWithoutRegion","*/route53":"fipsWithoutRegion","*/transcribe":"fipsDotPrefix","*/waf":"fipsWithoutRegion","us-gov-*/transcribe":"fipsDotPrefix","us-gov-*/api.ecr":"fips.api.ecr","us-gov-*/api.sagemaker":"fips.api.sagemaker","us-gov-*/models.lex":"fips.models.lex","us-gov-*/runtime.lex":"fips.runtime.lex","us-gov-*/acm-pca":"fipsWithServiceOnly","us-gov-*/batch":"fipsWithServiceOnly","us-gov-*/config":"fipsWithServiceOnly","us-gov-*/eks":"fipsWithServiceOnly","us-gov-*/elasticmapreduce":"fipsWithServiceOnly","us-gov-*/identitystore":"fipsWithServiceOnly","us-gov-*/dynamodb":"fipsWithServiceOnly","us-gov-*/elasticloadbalancing":"fipsWithServiceOnly","us-gov-*/guardduty":"fipsWithServiceOnly","us-gov-*/monitoring":"fipsWithServiceOnly","us-gov-*/resource-groups":"fipsWithServiceOnly","us-gov-*/runtime.sagemaker":"fipsWithServiceOnly","us-gov-*/servicecatalog-appregistry":"fipsWithServiceOnly","us-gov-*/servicequotas":"fipsWithServiceOnly","us-gov-*/ssm":"fipsWithServiceOnly","us-gov-*/sts":"fipsWithServiceOnly","us-gov-*/support":"fipsWithServiceOnly","us-gov-west-1/states":"fipsWithServiceOnly","us-iso-east-1/elasticfilesystem":{"endpoint":"elasticfilesystem-fips.{region}.c2s.ic.gov"},"us-gov-west-1/organizations":"fipsWithServiceOnly","us-gov-west-1/route53":{"endpoint":"route53.us-gov.amazonaws.com"}},"dualstackRules":{"*/*":{"endpoint":"{service}.{region}.api.aws"},"cn-*/*":{"endpoint":"{service}.{region}.api.amazonwebservices.com.cn"},"*/s3":"dualstackLegacy","cn-*/s3":"dualstackLegacyCn","*/s3-control":"dualstackLegacy","cn-*/s3-control":"dualstackLegacyCn","ap-south-1/ec2":"dualstackLegacyEc2","eu-west-1/ec2":"dualstackLegacyEc2","sa-east-1/ec2":"dualstackLegacyEc2","us-east-1/ec2":"dualstackLegacyEc2","us-east-2/ec2":"dualstackLegacyEc2","us-west-2/ec2":"dualstackLegacyEc2"},"dualstackFipsRules":{"*/*":{"endpoint":"{service}-fips.{region}.api.aws"},"cn-*/*":{"endpoint":"{service}-fips.{region}.api.amazonwebservices.com.cn"},"*/s3":"dualstackFipsLegacy","cn-*/s3":"dualstackFipsLegacyCn","*/s3-control":"dualstackFipsLegacy","cn-*/s3-control":"dualstackFipsLegacyCn"},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true,"signingRegion":"us-east-1"},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com","globalEndpoint":true,"signingRegion":"us-gov-west-1"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"},"usIso":{"endpoint":"{service}.{region}.c2s.ic.gov"},"usIsob":{"endpoint":"{service}.{region}.sc2s.sgov.gov"},"fipsStandard":{"endpoint":"{service}-fips.{region}.amazonaws.com"},"fipsDotPrefix":{"endpoint":"fips.{service}.{region}.amazonaws.com"},"fipsWithoutRegion":{"endpoint":"{service}-fips.amazonaws.com"},"fips.api.ecr":{"endpoint":"ecr-fips.{region}.amazonaws.com"},"fips.api.sagemaker":{"endpoint":"api-fips.sagemaker.{region}.amazonaws.com"},"fips.models.lex":{"endpoint":"models-fips.lex.{region}.amazonaws.com"},"fips.runtime.lex":{"endpoint":"runtime-fips.lex.{region}.amazonaws.com"},"fipsWithServiceOnly":{"endpoint":"{service}.{region}.amazonaws.com"},"dualstackLegacy":{"endpoint":"{service}.dualstack.{region}.amazonaws.com"},"dualstackLegacyCn":{"endpoint":"{service}.dualstack.{region}.amazonaws.com.cn"},"dualstackFipsLegacy":{"endpoint":"{service}-fips.dualstack.{region}.amazonaws.com"},"dualstackFipsLegacyCn":{"endpoint":"{service}-fips.dualstack.{region}.amazonaws.com.cn"},"dualstackLegacyEc2":{"endpoint":"api.ec2.{region}.aws"}}}

	/***/ }),
	/* 40 */
	/***/ (function(module, exports) {

		function isFipsRegion(region) {
		  return typeof region === 'string' && (region.startsWith('fips-') || region.endsWith('-fips'));
		}

		function isGlobalRegion(region) {
		  return typeof region === 'string' && ['aws-global', 'aws-us-gov-global'].includes(region);
		}

		function getRealRegion(region) {
		  return ['fips-aws-global', 'aws-fips', 'aws-global'].includes(region)
		      ? 'us-east-1'
		      : ['fips-aws-us-gov-global', 'aws-us-gov-global'].includes(region)
		      ? 'us-gov-west-1'
		      : region.replace(/fips-(dkr-|prod-)?|-fips/, '');
		}

		module.exports = {
		  isFipsRegion: isFipsRegion,
		  isGlobalRegion: isGlobalRegion,
		  getRealRegion: getRealRegion
		};


	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		__webpack_require__(42);
		__webpack_require__(43);
		var PromisesDependency;

		/**
		 * The main configuration class used by all service objects to set
		 * the region, credentials, and other options for requests.
		 *
		 * By default, credentials and region settings are left unconfigured.
		 * This should be configured by the application before using any
		 * AWS service APIs.
		 *
		 * In order to set global configuration options, properties should
		 * be assigned to the global {AWS.config} object.
		 *
		 * @see AWS.config
		 *
		 * @!group General Configuration Options
		 *
		 * @!attribute credentials
		 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
		 *
		 * @!attribute region
		 *   @example Set the global region setting to us-west-2
		 *     AWS.config.update({region: 'us-west-2'});
		 *   @return [AWS.Credentials] The region to send service requests to.
		 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
		 *     A list of available endpoints for each AWS service
		 *
		 * @!attribute maxRetries
		 *   @return [Integer] the maximum amount of retries to perform for a
		 *     service request. By default this value is calculated by the specific
		 *     service object that the request is being made to.
		 *
		 * @!attribute maxRedirects
		 *   @return [Integer] the maximum amount of redirects to follow for a
		 *     service request. Defaults to 10.
		 *
		 * @!attribute paramValidation
		 *   @return [Boolean|map] whether input parameters should be validated against
		 *     the operation description before sending the request. Defaults to true.
		 *     Pass a map to enable any of the following specific validation features:
		 *
		 *     * **min** [Boolean] &mdash; Validates that a value meets the min
		 *       constraint. This is enabled by default when paramValidation is set
		 *       to `true`.
		 *     * **max** [Boolean] &mdash; Validates that a value meets the max
		 *       constraint.
		 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
		 *       regular expression.
		 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
		 *       of the allowable enum values.
		 *
		 * @!attribute computeChecksums
		 *   @return [Boolean] whether to compute checksums for payload bodies when
		 *     the service accepts it (currently supported in S3 and SQS only).
		 *
		 * @!attribute convertResponseTypes
		 *   @return [Boolean] whether types are converted when parsing response data.
		 *     Currently only supported for JSON based services. Turning this off may
		 *     improve performance on large response payloads. Defaults to `true`.
		 *
		 * @!attribute correctClockSkew
		 *   @return [Boolean] whether to apply a clock skew correction and retry
		 *     requests that fail because of an skewed client clock. Defaults to
		 *     `false`.
		 *
		 * @!attribute sslEnabled
		 *   @return [Boolean] whether SSL is enabled for requests
		 *
		 * @!attribute s3ForcePathStyle
		 *   @return [Boolean] whether to force path style URLs for S3 objects
		 *
		 * @!attribute s3BucketEndpoint
		 *   @note Setting this configuration option requires an `endpoint` to be
		 *     provided explicitly to the service constructor.
		 *   @return [Boolean] whether the provided endpoint addresses an individual
		 *     bucket (false if it addresses the root API endpoint).
		 *
		 * @!attribute s3DisableBodySigning
		 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
		 *     Body signing can only be disabled when using https. Defaults to `true`.
		 *
		 * @!attribute s3UsEast1RegionalEndpoint
		 *   @return ['legacy'|'regional'] when region is set to 'us-east-1', whether to send s3
		 *     request to global endpoints or 'us-east-1' regional endpoints. This config is only
		 *     applicable to S3 client;
		 *     Defaults to 'legacy'
		 * @!attribute s3UseArnRegion
		 *   @return [Boolean] whether to override the request region with the region inferred
		 *     from requested resource's ARN. Only available for S3 buckets
		 *     Defaults to `true`
		 *
		 * @!attribute useAccelerateEndpoint
		 *   @note This configuration option is only compatible with S3 while accessing
		 *     dns-compatible buckets.
		 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
		 *     Defaults to `false`.
		 *
		 * @!attribute retryDelayOptions
		 *   @example Set the base retry delay for all services to 300 ms
		 *     AWS.config.update({retryDelayOptions: {base: 300}});
		 *     // Delays with maxRetries = 3: 300, 600, 1200
		 *   @example Set a custom backoff function to provide delay values on retries
		 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount, err) {
		 *       // returns delay in ms
		 *     }}});
		 *   @return [map] A set of options to configure the retry delay on retryable errors.
		 *     Currently supported options are:
		 *
		 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
		 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
		 *       DynamoDB, where it defaults to 50ms.
		 *
		 *     * **customBackoff ** [function] &mdash; A custom function that accepts a
		 *       retry count and error and returns the amount of time to delay in
		 *       milliseconds. If the result is a non-zero negative value, no further
		 *       retry attempts will be made. The `base` option will be ignored if this
		 *       option is supplied. The function is only called for retryable errors.
		 *
		 * @!attribute httpOptions
		 *   @return [map] A set of options to pass to the low-level HTTP request.
		 *     Currently supported options are:
		 *
		 *     * **proxy** [String] &mdash; the URL to proxy requests through
		 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
		 *       HTTP requests with. Used for connection pooling. Note that for
		 *       SSL connections, a special Agent object is used in order to enable
		 *       peer certificate verification. This feature is only supported in the
		 *       Node.js environment.
		 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
		 *       failing to establish a connection with the server after
		 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
		 *       connection has been established.
		 *     * **timeout** [Integer] &mdash; The number of milliseconds a request can
		 *       take before automatically being terminated.
		 *       Defaults to two minutes (120000).
		 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
		 *       HTTP requests. Used in the browser environment only. Set to false to
		 *       send requests synchronously. Defaults to true (async on).
		 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
		 *       property of an XMLHttpRequest object. Used in the browser environment
		 *       only. Defaults to false.
		 * @!attribute logger
		 *   @return [#write,#log] an object that responds to .write() (like a stream)
		 *     or .log() (like the console object) in order to log information about
		 *     requests
		 *
		 * @!attribute systemClockOffset
		 *   @return [Number] an offset value in milliseconds to apply to all signing
		 *     times. Use this to compensate for clock skew when your system may be
		 *     out of sync with the service time. Note that this configuration option
		 *     can only be applied to the global `AWS.config` object and cannot be
		 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
		 *
		 * @!attribute signatureVersion
		 *   @return [String] the signature version to sign requests with (overriding
		 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
		 *
		 * @!attribute signatureCache
		 *   @return [Boolean] whether the signature to sign requests with (overriding
		 *     the API configuration) is cached. Only applies to the signature version 'v4'.
		 *     Defaults to `true`.
		 *
		 * @!attribute endpointDiscoveryEnabled
		 *   @return [Boolean|undefined] whether to call operations with endpoints
		 *     given by service dynamically. Setting this config to `true` will enable
		 *     endpoint discovery for all applicable operations. Setting it to `false`
		 *     will explicitly disable endpoint discovery even though operations that
		 *     require endpoint discovery will presumably fail. Leaving it to
		 *     `undefined` means SDK only do endpoint discovery when it's required.
		 *     Defaults to `undefined`
		 *
		 * @!attribute endpointCacheSize
		 *   @return [Number] the size of the global cache storing endpoints from endpoint
		 *     discovery operations. Once endpoint cache is created, updating this setting
		 *     cannot change existing cache size.
		 *     Defaults to 1000
		 *
		 * @!attribute hostPrefixEnabled
		 *   @return [Boolean] whether to marshal request parameters to the prefix of
		 *     hostname. Defaults to `true`.
		 *
		 * @!attribute stsRegionalEndpoints
		 *   @return ['legacy'|'regional'] whether to send sts request to global endpoints or
		 *     regional endpoints.
		 *     Defaults to 'legacy'.
		 *
		 * @!attribute useFipsEndpoint
		 *   @return [Boolean] Enables FIPS compatible endpoints. Defaults to `false`.
		 *
		 * @!attribute useDualstackEndpoint
		 *   @return [Boolean] Enables IPv6 dualstack endpoint. Defaults to `false`.
		 */
		AWS.Config = AWS.util.inherit({
		  /**
		   * @!endgroup
		   */

		  /**
		   * Creates a new configuration object. This is the object that passes
		   * option data along to service requests, including credentials, security,
		   * region information, and some service specific settings.
		   *
		   * @example Creating a new configuration object with credentials and region
		   *   var config = new AWS.Config({
		   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
		   *   });
		   * @option options accessKeyId [String] your AWS access key ID.
		   * @option options secretAccessKey [String] your AWS secret access key.
		   * @option options sessionToken [AWS.Credentials] the optional AWS
		   *   session token to sign requests with.
		   * @option options credentials [AWS.Credentials] the AWS credentials
		   *   to sign requests with. You can either specify this object, or
		   *   specify the accessKeyId and secretAccessKey options directly.
		   * @option options credentialProvider [AWS.CredentialProviderChain] the
		   *   provider chain used to resolve credentials if no static `credentials`
		   *   property is set.
		   * @option options region [String] the region to send service requests to.
		   *   See {region} for more information.
		   * @option options maxRetries [Integer] the maximum amount of retries to
		   *   attempt with a request. See {maxRetries} for more information.
		   * @option options maxRedirects [Integer] the maximum amount of redirects to
		   *   follow with a request. See {maxRedirects} for more information.
		   * @option options sslEnabled [Boolean] whether to enable SSL for
		   *   requests.
		   * @option options paramValidation [Boolean|map] whether input parameters
		   *   should be validated against the operation description before sending
		   *   the request. Defaults to true. Pass a map to enable any of the
		   *   following specific validation features:
		   *
		   *   * **min** [Boolean] &mdash; Validates that a value meets the min
		   *     constraint. This is enabled by default when paramValidation is set
		   *     to `true`.
		   *   * **max** [Boolean] &mdash; Validates that a value meets the max
		   *     constraint.
		   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
		   *     regular expression.
		   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
		   *     of the allowable enum values.
		   * @option options computeChecksums [Boolean] whether to compute checksums
		   *   for payload bodies when the service accepts it (currently supported
		   *   in S3 only)
		   * @option options convertResponseTypes [Boolean] whether types are converted
		   *     when parsing response data. Currently only supported for JSON based
		   *     services. Turning this off may improve performance on large response
		   *     payloads. Defaults to `true`.
		   * @option options correctClockSkew [Boolean] whether to apply a clock skew
		   *     correction and retry requests that fail because of an skewed client
		   *     clock. Defaults to `false`.
		   * @option options s3ForcePathStyle [Boolean] whether to force path
		   *   style URLs for S3 objects.
		   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
		   *   addresses an individual bucket (false if it addresses the root API
		   *   endpoint). Note that setting this configuration option requires an
		   *   `endpoint` to be provided explicitly to the service constructor.
		   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
		   *   should be disabled when using signature version `v4`. Body signing
		   *   can only be disabled when using https. Defaults to `true`.
		   * @option options s3UsEast1RegionalEndpoint ['legacy'|'regional'] when region
		   *   is set to 'us-east-1', whether to send s3 request to global endpoints or
		   *   'us-east-1' regional endpoints. This config is only applicable to S3 client.
		   *   Defaults to `legacy`
		   * @option options s3UseArnRegion [Boolean] whether to override the request region
		   *   with the region inferred from requested resource's ARN. Only available for S3 buckets
		   *   Defaults to `true`
		   *
		   * @option options retryDelayOptions [map] A set of options to configure
		   *   the retry delay on retryable errors. Currently supported options are:
		   *
		   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
		   *     exponential backoff for operation retries. Defaults to 100 ms for all
		   *     services except DynamoDB, where it defaults to 50ms.
		   *   * **customBackoff ** [function] &mdash; A custom function that accepts a
		   *     retry count and error and returns the amount of time to delay in
		   *     milliseconds. If the result is a non-zero negative value, no further
		   *     retry attempts will be made. The `base` option will be ignored if this
		   *     option is supplied. The function is only called for retryable errors.
		   * @option options httpOptions [map] A set of options to pass to the low-level
		   *   HTTP request. Currently supported options are:
		   *
		   *   * **proxy** [String] &mdash; the URL to proxy requests through
		   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
		   *     HTTP requests with. Used for connection pooling. Defaults to the global
		   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
		   *     SSL connections, a special Agent object is used in order to enable
		   *     peer certificate verification. This feature is only available in the
		   *     Node.js environment.
		   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
		   *     failing to establish a connection with the server after
		   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
		   *     connection has been established.
		   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
		   *     milliseconds of inactivity on the socket. Defaults to two minutes
		   *     (120000).
		   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
		   *     HTTP requests. Used in the browser environment only. Set to false to
		   *     send requests synchronously. Defaults to true (async on).
		   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
		   *     property of an XMLHttpRequest object. Used in the browser environment
		   *     only. Defaults to false.
		   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
		   *   (or a date) that represents the latest possible API version that can be
		   *   used in all services (unless overridden by `apiVersions`). Specify
		   *   'latest' to use the latest possible version.
		   * @option options apiVersions [map<String, String|Date>] a map of service
		   *   identifiers (the lowercase service class name) with the API version to
		   *   use when instantiating a service. Specify 'latest' for each individual
		   *   that can use the latest available version.
		   * @option options logger [#write,#log] an object that responds to .write()
		   *   (like a stream) or .log() (like the console object) in order to log
		   *   information about requests
		   * @option options systemClockOffset [Number] an offset value in milliseconds
		   *   to apply to all signing times. Use this to compensate for clock skew
		   *   when your system may be out of sync with the service time. Note that
		   *   this configuration option can only be applied to the global `AWS.config`
		   *   object and cannot be overridden in service-specific configuration.
		   *   Defaults to 0 milliseconds.
		   * @option options signatureVersion [String] the signature version to sign
		   *   requests with (overriding the API configuration). Possible values are:
		   *   'v2', 'v3', 'v4'.
		   * @option options signatureCache [Boolean] whether the signature to sign
		   *   requests with (overriding the API configuration) is cached. Only applies
		   *   to the signature version 'v4'. Defaults to `true`.
		   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
		   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
		   * @option options useAccelerateEndpoint [Boolean] Whether to use the
		   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
		   * @option options clientSideMonitoring [Boolean] whether to collect and
		   *   publish this client's performance metrics of all its API requests.
		   * @option options endpointDiscoveryEnabled [Boolean|undefined] whether to
		   *   call operations with endpoints given by service dynamically. Setting this
		   * config to `true` will enable endpoint discovery for all applicable operations.
		   *   Setting it to `false` will explicitly disable endpoint discovery even though
		   *   operations that require endpoint discovery will presumably fail. Leaving it
		   *   to `undefined` means SDK will only do endpoint discovery when it's required.
		   *   Defaults to `undefined`
		   * @option options endpointCacheSize [Number] the size of the global cache storing
		   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
		   *   updating this setting cannot change existing cache size.
		   *   Defaults to 1000
		   * @option options hostPrefixEnabled [Boolean] whether to marshal request
		   *   parameters to the prefix of hostname.
		   *   Defaults to `true`.
		   * @option options stsRegionalEndpoints ['legacy'|'regional'] whether to send sts request
		   *   to global endpoints or regional endpoints.
		   *   Defaults to 'legacy'.
		   * @option options useFipsEndpoint [Boolean] Enables FIPS compatible endpoints.
		   *   Defaults to `false`.
		   * @option options useDualstackEndpoint [Boolean] Enables IPv6 dualstack endpoint.
		   *   Defaults to `false`.
		   */
		  constructor: function Config(options) {
		    if (options === undefined) options = {};
		    options = this.extractCredentials(options);

		    AWS.util.each.call(this, this.keys, function (key, value) {
		      this.set(key, options[key], value);
		    });
		  },

		  /**
		   * @!group Managing Credentials
		   */

		  /**
		   * Loads credentials from the configuration object. This is used internally
		   * by the SDK to ensure that refreshable {Credentials} objects are properly
		   * refreshed and loaded when sending a request. If you want to ensure that
		   * your credentials are loaded prior to a request, you can use this method
		   * directly to provide accurate credential data stored in the object.
		   *
		   * @note If you configure the SDK with static or environment credentials,
		   *   the credential data should already be present in {credentials} attribute.
		   *   This method is primarily necessary to load credentials from asynchronous
		   *   sources, or sources that can refresh credentials periodically.
		   * @example Getting your access key
		   *   AWS.config.getCredentials(function(err) {
		   *     if (err) console.log(err.stack); // credentials not loaded
		   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
		   *   })
		   * @callback callback function(err)
		   *   Called when the {credentials} have been properly set on the configuration
		   *   object.
		   *
		   *   @param err [Error] if this is set, credentials were not successfully
		   *     loaded and this error provides information why.
		   * @see credentials
		   * @see Credentials
		   */
		  getCredentials: function getCredentials(callback) {
		    var self = this;

		    function finish(err) {
		      callback(err, err ? null : self.credentials);
		    }

		    function credError(msg, err) {
		      return new AWS.util.error(err || new Error(), {
		        code: 'CredentialsError',
		        message: msg,
		        name: 'CredentialsError'
		      });
		    }

		    function getAsyncCredentials() {
		      self.credentials.get(function(err) {
		        if (err) {
		          var msg = 'Could not load credentials from ' +
		            self.credentials.constructor.name;
		          err = credError(msg, err);
		        }
		        finish(err);
		      });
		    }

		    function getStaticCredentials() {
		      var err = null;
		      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
		        err = credError('Missing credentials');
		      }
		      finish(err);
		    }

		    if (self.credentials) {
		      if (typeof self.credentials.get === 'function') {
		        getAsyncCredentials();
		      } else { // static credentials
		        getStaticCredentials();
		      }
		    } else if (self.credentialProvider) {
		      self.credentialProvider.resolve(function(err, creds) {
		        if (err) {
		          err = credError('Could not load credentials from any providers', err);
		        }
		        self.credentials = creds;
		        finish(err);
		      });
		    } else {
		      finish(credError('No credentials to load'));
		    }
		  },

		  /**
		   * @!group Loading and Setting Configuration Options
		   */

		  /**
		   * @overload update(options, allowUnknownKeys = false)
		   *   Updates the current configuration object with new options.
		   *
		   *   @example Update maxRetries property of a configuration object
		   *     config.update({maxRetries: 10});
		   *   @param [Object] options a map of option keys and values.
		   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
		   *     the configuration object. Defaults to `false`.
		   *   @see constructor
		   */
		  update: function update(options, allowUnknownKeys) {
		    allowUnknownKeys = allowUnknownKeys || false;
		    options = this.extractCredentials(options);
		    AWS.util.each.call(this, options, function (key, value) {
		      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
		          AWS.Service.hasService(key)) {
		        this.set(key, value);
		      }
		    });
		  },

		  /**
		   * Loads configuration data from a JSON file into this config object.
		   * @note Loading configuration will reset all existing configuration
		   *   on the object.
		   * @!macro nobrowser
		   * @param path [String] the path relative to your process's current
		   *    working directory to load configuration from.
		   * @return [AWS.Config] the same configuration object
		   */
		  loadFromPath: function loadFromPath(path) {
		    this.clear();

		    var options = JSON.parse(AWS.util.readFileSync(path));
		    var fileSystemCreds = new AWS.FileSystemCredentials(path);
		    var chain = new AWS.CredentialProviderChain();
		    chain.providers.unshift(fileSystemCreds);
		    chain.resolve(function (err, creds) {
		      if (err) throw err;
		      else options.credentials = creds;
		    });

		    this.constructor(options);

		    return this;
		  },

		  /**
		   * Clears configuration data on this object
		   *
		   * @api private
		   */
		  clear: function clear() {
		    /*jshint forin:false */
		    AWS.util.each.call(this, this.keys, function (key) {
		      delete this[key];
		    });

		    // reset credential provider
		    this.set('credentials', undefined);
		    this.set('credentialProvider', undefined);
		  },

		  /**
		   * Sets a property on the configuration object, allowing for a
		   * default value
		   * @api private
		   */
		  set: function set(property, value, defaultValue) {
		    if (value === undefined) {
		      if (defaultValue === undefined) {
		        defaultValue = this.keys[property];
		      }
		      if (typeof defaultValue === 'function') {
		        this[property] = defaultValue.call(this);
		      } else {
		        this[property] = defaultValue;
		      }
		    } else if (property === 'httpOptions' && this[property]) {
		      // deep merge httpOptions
		      this[property] = AWS.util.merge(this[property], value);
		    } else {
		      this[property] = value;
		    }
		  },

		  /**
		   * All of the keys with their default values.
		   *
		   * @constant
		   * @api private
		   */
		  keys: {
		    credentials: null,
		    credentialProvider: null,
		    region: null,
		    logger: null,
		    apiVersions: {},
		    apiVersion: null,
		    endpoint: undefined,
		    httpOptions: {
		      timeout: 120000
		    },
		    maxRetries: undefined,
		    maxRedirects: 10,
		    paramValidation: true,
		    sslEnabled: true,
		    s3ForcePathStyle: false,
		    s3BucketEndpoint: false,
		    s3DisableBodySigning: true,
		    s3UsEast1RegionalEndpoint: 'legacy',
		    s3UseArnRegion: undefined,
		    computeChecksums: true,
		    convertResponseTypes: true,
		    correctClockSkew: false,
		    customUserAgent: null,
		    dynamoDbCrc32: true,
		    systemClockOffset: 0,
		    signatureVersion: null,
		    signatureCache: true,
		    retryDelayOptions: {},
		    useAccelerateEndpoint: false,
		    clientSideMonitoring: false,
		    endpointDiscoveryEnabled: undefined,
		    endpointCacheSize: 1000,
		    hostPrefixEnabled: true,
		    stsRegionalEndpoints: 'legacy',
		    useFipsEndpoint: false,
		    useDualstackEndpoint: false
		  },

		  /**
		   * Extracts accessKeyId, secretAccessKey and sessionToken
		   * from a configuration hash.
		   *
		   * @api private
		   */
		  extractCredentials: function extractCredentials(options) {
		    if (options.accessKeyId && options.secretAccessKey) {
		      options = AWS.util.copy(options);
		      options.credentials = new AWS.Credentials(options);
		    }
		    return options;
		  },

		  /**
		   * Sets the promise dependency the SDK will use wherever Promises are returned.
		   * Passing `null` will force the SDK to use native Promises if they are available.
		   * If native Promises are not available, passing `null` will have no effect.
		   * @param [Constructor] dep A reference to a Promise constructor
		   */
		  setPromisesDependency: function setPromisesDependency(dep) {
		    PromisesDependency = dep;
		    // if null was passed in, we should try to use native promises
		    if (dep === null && typeof Promise === 'function') {
		      PromisesDependency = Promise;
		    }
		    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
		    if (AWS.S3) {
		      constructors.push(AWS.S3);
		      if (AWS.S3.ManagedUpload) {
		        constructors.push(AWS.S3.ManagedUpload);
		      }
		    }
		    AWS.util.addPromises(constructors, PromisesDependency);
		  },

		  /**
		   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
		   */
		  getPromisesDependency: function getPromisesDependency() {
		    return PromisesDependency;
		  }
		});

		/**
		 * @return [AWS.Config] The global configuration object singleton instance
		 * @readonly
		 * @see AWS.Config
		 */
		AWS.config = new AWS.Config();


	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);

		/**
		 * Represents your AWS security credentials, specifically the
		 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
		 * Creating a `Credentials` object allows you to pass around your
		 * security information to configuration and service objects.
		 *
		 * Note that this class typically does not need to be constructed manually,
		 * as the {AWS.Config} and {AWS.Service} classes both accept simple
		 * options hashes with the three keys. These structures will be converted
		 * into Credentials objects automatically.
		 *
		 * ## Expiring and Refreshing Credentials
		 *
		 * Occasionally credentials can expire in the middle of a long-running
		 * application. In this case, the SDK will automatically attempt to
		 * refresh the credentials from the storage location if the Credentials
		 * class implements the {refresh} method.
		 *
		 * If you are implementing a credential storage location, you
		 * will want to create a subclass of the `Credentials` class and
		 * override the {refresh} method. This method allows credentials to be
		 * retrieved from the backing store, be it a file system, database, or
		 * some network storage. The method should reset the credential attributes
		 * on the object.
		 *
		 * @!attribute expired
		 *   @return [Boolean] whether the credentials have been expired and
		 *     require a refresh. Used in conjunction with {expireTime}.
		 * @!attribute expireTime
		 *   @return [Date] a time when credentials should be considered expired. Used
		 *     in conjunction with {expired}.
		 * @!attribute accessKeyId
		 *   @return [String] the AWS access key ID
		 * @!attribute secretAccessKey
		 *   @return [String] the AWS secret access key
		 * @!attribute sessionToken
		 *   @return [String] an optional AWS session token
		 */
		AWS.Credentials = AWS.util.inherit({
		  /**
		   * A credentials object can be created using positional arguments or an options
		   * hash.
		   *
		   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
		   *   Creates a Credentials object with a given set of credential information
		   *   as positional arguments.
		   *   @param accessKeyId [String] the AWS access key ID
		   *   @param secretAccessKey [String] the AWS secret access key
		   *   @param sessionToken [String] the optional AWS session token
		   *   @example Create a credentials object with AWS credentials
		   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
		   * @overload AWS.Credentials(options)
		   *   Creates a Credentials object with a given set of credential information
		   *   as an options hash.
		   *   @option options accessKeyId [String] the AWS access key ID
		   *   @option options secretAccessKey [String] the AWS secret access key
		   *   @option options sessionToken [String] the optional AWS session token
		   *   @example Create a credentials object with AWS credentials
		   *     var creds = new AWS.Credentials({
		   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
		   *     });
		   */
		  constructor: function Credentials() {
		    // hide secretAccessKey from being displayed with util.inspect
		    AWS.util.hideProperties(this, ['secretAccessKey']);

		    this.expired = false;
		    this.expireTime = null;
		    this.refreshCallbacks = [];
		    if (arguments.length === 1 && typeof arguments[0] === 'object') {
		      var creds = arguments[0].credentials || arguments[0];
		      this.accessKeyId = creds.accessKeyId;
		      this.secretAccessKey = creds.secretAccessKey;
		      this.sessionToken = creds.sessionToken;
		    } else {
		      this.accessKeyId = arguments[0];
		      this.secretAccessKey = arguments[1];
		      this.sessionToken = arguments[2];
		    }
		  },

		  /**
		   * @return [Integer] the number of seconds before {expireTime} during which
		   *   the credentials will be considered expired.
		   */
		  expiryWindow: 15,

		  /**
		   * @return [Boolean] whether the credentials object should call {refresh}
		   * @note Subclasses should override this method to provide custom refresh
		   *   logic.
		   */
		  needsRefresh: function needsRefresh() {
		    var currentTime = AWS.util.date.getDate().getTime();
		    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

		    if (this.expireTime && adjustedTime > this.expireTime) {
		      return true;
		    } else {
		      return this.expired || !this.accessKeyId || !this.secretAccessKey;
		    }
		  },

		  /**
		   * Gets the existing credentials, refreshing them if they are not yet loaded
		   * or have expired. Users should call this method before using {refresh},
		   * as this will not attempt to reload credentials when they are already
		   * loaded into the object.
		   *
		   * @callback callback function(err)
		   *   When this callback is called with no error, it means either credentials
		   *   do not need to be refreshed or refreshed credentials information has
		   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
		   *   and `sessionToken` properties).
		   *   @param err [Error] if an error occurred, this value will be filled
		   */
		  get: function get(callback) {
		    var self = this;
		    if (this.needsRefresh()) {
		      this.refresh(function(err) {
		        if (!err) self.expired = false; // reset expired flag
		        if (callback) callback(err);
		      });
		    } else if (callback) {
		      callback();
		    }
		  },

		  /**
		   * @!method  getPromise()
		   *   Returns a 'thenable' promise.
		   *   Gets the existing credentials, refreshing them if they are not yet loaded
		   *   or have expired. Users should call this method before using {refresh},
		   *   as this will not attempt to reload credentials when they are already
		   *   loaded into the object.
		   *
		   *   Two callbacks can be provided to the `then` method on the returned promise.
		   *   The first callback will be called if the promise is fulfilled, and the second
		   *   callback will be called if the promise is rejected.
		   *   @callback fulfilledCallback function()
		   *     Called if the promise is fulfilled. When this callback is called, it
		   *     means either credentials do not need to be refreshed or refreshed
		   *     credentials information has been loaded into the object (as the
		   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
		   *   @callback rejectedCallback function(err)
		   *     Called if the promise is rejected.
		   *     @param err [Error] if an error occurred, this value will be filled
		   *   @return [Promise] A promise that represents the state of the `get` call.
		   *   @example Calling the `getPromise` method.
		   *     var promise = credProvider.getPromise();
		   *     promise.then(function() { ... }, function(err) { ... });
		   */

		  /**
		   * @!method  refreshPromise()
		   *   Returns a 'thenable' promise.
		   *   Refreshes the credentials. Users should call {get} before attempting
		   *   to forcibly refresh credentials.
		   *
		   *   Two callbacks can be provided to the `then` method on the returned promise.
		   *   The first callback will be called if the promise is fulfilled, and the second
		   *   callback will be called if the promise is rejected.
		   *   @callback fulfilledCallback function()
		   *     Called if the promise is fulfilled. When this callback is called, it
		   *     means refreshed credentials information has been loaded into the object
		   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
		   *   @callback rejectedCallback function(err)
		   *     Called if the promise is rejected.
		   *     @param err [Error] if an error occurred, this value will be filled
		   *   @return [Promise] A promise that represents the state of the `refresh` call.
		   *   @example Calling the `refreshPromise` method.
		   *     var promise = credProvider.refreshPromise();
		   *     promise.then(function() { ... }, function(err) { ... });
		   */

		  /**
		   * Refreshes the credentials. Users should call {get} before attempting
		   * to forcibly refresh credentials.
		   *
		   * @callback callback function(err)
		   *   When this callback is called with no error, it means refreshed
		   *   credentials information has been loaded into the object (as the
		   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
		   *   @param err [Error] if an error occurred, this value will be filled
		   * @note Subclasses should override this class to reset the
		   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
		   *   on the credentials object and then call the callback with
		   *   any error information.
		   * @see get
		   */
		  refresh: function refresh(callback) {
		    this.expired = false;
		    callback();
		  },

		  /**
		   * @api private
		   * @param callback
		   */
		  coalesceRefresh: function coalesceRefresh(callback, sync) {
		    var self = this;
		    if (self.refreshCallbacks.push(callback) === 1) {
		      self.load(function onLoad(err) {
		        AWS.util.arrayEach(self.refreshCallbacks, function(callback) {
		          if (sync) {
		            callback(err);
		          } else {
		            // callback could throw, so defer to ensure all callbacks are notified
		            AWS.util.defer(function () {
		              callback(err);
		            });
		          }
		        });
		        self.refreshCallbacks.length = 0;
		      });
		    }
		  },

		  /**
		   * @api private
		   * @param callback
		   */
		  load: function load(callback) {
		    callback();
		  }
		});

		/**
		 * @api private
		 */
		AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
		  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
		  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
		};

		/**
		 * @api private
		 */
		AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
		  delete this.prototype.getPromise;
		  delete this.prototype.refreshPromise;
		};

		AWS.util.addPromises(AWS.Credentials);


	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);

		/**
		 * Creates a credential provider chain that searches for AWS credentials
		 * in a list of credential providers specified by the {providers} property.
		 *
		 * By default, the chain will use the {defaultProviders} to resolve credentials.
		 * These providers will look in the environment using the
		 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
		 *
		 * ## Setting Providers
		 *
		 * Each provider in the {providers} list should be a function that returns
		 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
		 * form allows for delayed execution of the credential construction.
		 *
		 * ## Resolving Credentials from a Chain
		 *
		 * Call {resolve} to return the first valid credential object that can be
		 * loaded by the provider chain.
		 *
		 * For example, to resolve a chain with a custom provider that checks a file
		 * on disk after the set of {defaultProviders}:
		 *
		 * ```javascript
		 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
		 * var chain = new AWS.CredentialProviderChain();
		 * chain.providers.push(diskProvider);
		 * chain.resolve();
		 * ```
		 *
		 * The above code will return the `diskProvider` object if the
		 * file contains credentials and the `defaultProviders` do not contain
		 * any credential settings.
		 *
		 * @!attribute providers
		 *   @return [Array<AWS.Credentials, Function>]
		 *     a list of credentials objects or functions that return credentials
		 *     objects. If the provider is a function, the function will be
		 *     executed lazily when the provider needs to be checked for valid
		 *     credentials. By default, this object will be set to the
		 *     {defaultProviders}.
		 *   @see defaultProviders
		 */
		AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

		  /**
		   * Creates a new CredentialProviderChain with a default set of providers
		   * specified by {defaultProviders}.
		   */
		  constructor: function CredentialProviderChain(providers) {
		    if (providers) {
		      this.providers = providers;
		    } else {
		      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
		    }
		    this.resolveCallbacks = [];
		  },

		  /**
		   * @!method  resolvePromise()
		   *   Returns a 'thenable' promise.
		   *   Resolves the provider chain by searching for the first set of
		   *   credentials in {providers}.
		   *
		   *   Two callbacks can be provided to the `then` method on the returned promise.
		   *   The first callback will be called if the promise is fulfilled, and the second
		   *   callback will be called if the promise is rejected.
		   *   @callback fulfilledCallback function(credentials)
		   *     Called if the promise is fulfilled and the provider resolves the chain
		   *     to a credentials object
		   *     @param credentials [AWS.Credentials] the credentials object resolved
		   *       by the provider chain.
		   *   @callback rejectedCallback function(error)
		   *     Called if the promise is rejected.
		   *     @param err [Error] the error object returned if no credentials are found.
		   *   @return [Promise] A promise that represents the state of the `resolve` method call.
		   *   @example Calling the `resolvePromise` method.
		   *     var promise = chain.resolvePromise();
		   *     promise.then(function(credentials) { ... }, function(err) { ... });
		   */

		  /**
		   * Resolves the provider chain by searching for the first set of
		   * credentials in {providers}.
		   *
		   * @callback callback function(err, credentials)
		   *   Called when the provider resolves the chain to a credentials object
		   *   or null if no credentials can be found.
		   *
		   *   @param err [Error] the error object returned if no credentials are
		   *     found.
		   *   @param credentials [AWS.Credentials] the credentials object resolved
		   *     by the provider chain.
		   * @return [AWS.CredentialProviderChain] the provider, for chaining.
		   */
		  resolve: function resolve(callback) {
		    var self = this;
		    if (self.providers.length === 0) {
		      callback(new Error('No providers'));
		      return self;
		    }

		    if (self.resolveCallbacks.push(callback) === 1) {
		      var index = 0;
		      var providers = self.providers.slice(0);

		      function resolveNext(err, creds) {
		        if ((!err && creds) || index === providers.length) {
		          AWS.util.arrayEach(self.resolveCallbacks, function (callback) {
		            callback(err, creds);
		          });
		          self.resolveCallbacks.length = 0;
		          return;
		        }

		        var provider = providers[index++];
		        if (typeof provider === 'function') {
		          creds = provider.call();
		        } else {
		          creds = provider;
		        }

		        if (creds.get) {
		          creds.get(function (getErr) {
		            resolveNext(getErr, getErr ? null : creds);
		          });
		        } else {
		          resolveNext(null, creds);
		        }
		      }

		      resolveNext();
		    }

		    return self;
		  }
		});

		/**
		 * The default set of providers used by a vanilla CredentialProviderChain.
		 *
		 * In the browser:
		 *
		 * ```javascript
		 * AWS.CredentialProviderChain.defaultProviders = []
		 * ```
		 *
		 * In Node.js:
		 *
		 * ```javascript
		 * AWS.CredentialProviderChain.defaultProviders = [
		 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
		 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
		 *   function () { return new AWS.SsoCredentials(); },
		 *   function () { return new AWS.SharedIniFileCredentials(); },
		 *   function () { return new AWS.ECSCredentials(); },
		 *   function () { return new AWS.ProcessCredentials(); },
		 *   function () { return new AWS.TokenFileWebIdentityCredentials(); },
		 *   function () { return new AWS.EC2MetadataCredentials() }
		 * ]
		 * ```
		 */
		AWS.CredentialProviderChain.defaultProviders = [];

		/**
		 * @api private
		 */
		AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
		  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
		};

		/**
		 * @api private
		 */
		AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
		  delete this.prototype.resolvePromise;
		};

		AWS.util.addPromises(AWS.CredentialProviderChain);


	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;

		/**
		 * The endpoint that a service will talk to, for example,
		 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
		 * you need to override an endpoint for a service, you can
		 * set the endpoint on a service by passing the endpoint
		 * object with the `endpoint` option key:
		 *
		 * ```javascript
		 * var ep = new AWS.Endpoint('awsproxy.example.com');
		 * var s3 = new AWS.S3({endpoint: ep});
		 * s3.service.endpoint.hostname == 'awsproxy.example.com'
		 * ```
		 *
		 * Note that if you do not specify a protocol, the protocol will
		 * be selected based on your current {AWS.config} configuration.
		 *
		 * @!attribute protocol
		 *   @return [String] the protocol (http or https) of the endpoint
		 *     URL
		 * @!attribute hostname
		 *   @return [String] the host portion of the endpoint, e.g.,
		 *     example.com
		 * @!attribute host
		 *   @return [String] the host portion of the endpoint including
		 *     the port, e.g., example.com:80
		 * @!attribute port
		 *   @return [Integer] the port of the endpoint
		 * @!attribute href
		 *   @return [String] the full URL of the endpoint
		 */
		AWS.Endpoint = inherit({

		  /**
		   * @overload Endpoint(endpoint)
		   *   Constructs a new endpoint given an endpoint URL. If the
		   *   URL omits a protocol (http or https), the default protocol
		   *   set in the global {AWS.config} will be used.
		   *   @param endpoint [String] the URL to construct an endpoint from
		   */
		  constructor: function Endpoint(endpoint, config) {
		    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

		    if (typeof endpoint === 'undefined' || endpoint === null) {
		      throw new Error('Invalid endpoint: ' + endpoint);
		    } else if (typeof endpoint !== 'string') {
		      return AWS.util.copy(endpoint);
		    }

		    if (!endpoint.match(/^http/)) {
		      var useSSL = config && config.sslEnabled !== undefined ?
		        config.sslEnabled : AWS.config.sslEnabled;
		      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
		    }

		    AWS.util.update(this, AWS.util.urlParse(endpoint));

		    // Ensure the port property is set as an integer
		    if (this.port) {
		      this.port = parseInt(this.port, 10);
		    } else {
		      this.port = this.protocol === 'https:' ? 443 : 80;
		    }
		  }

		});

		/**
		 * The low level HTTP request object, encapsulating all HTTP header
		 * and body data sent by a service request.
		 *
		 * @!attribute method
		 *   @return [String] the HTTP method of the request
		 * @!attribute path
		 *   @return [String] the path portion of the URI, e.g.,
		 *     "/list/?start=5&num=10"
		 * @!attribute headers
		 *   @return [map<String,String>]
		 *     a map of header keys and their respective values
		 * @!attribute body
		 *   @return [String] the request body payload
		 * @!attribute endpoint
		 *   @return [AWS.Endpoint] the endpoint for the request
		 * @!attribute region
		 *   @api private
		 *   @return [String] the region, for signing purposes only.
		 */
		AWS.HttpRequest = inherit({

		  /**
		   * @api private
		   */
		  constructor: function HttpRequest(endpoint, region) {
		    endpoint = new AWS.Endpoint(endpoint);
		    this.method = 'POST';
		    this.path = endpoint.path || '/';
		    this.headers = {};
		    this.body = '';
		    this.endpoint = endpoint;
		    this.region = region;
		    this._userAgent = '';
		    this.setUserAgent();
		  },

		  /**
		   * @api private
		   */
		  setUserAgent: function setUserAgent() {
		    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
		  },

		  getUserAgentHeaderName: function getUserAgentHeaderName() {
		    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
		    return prefix + 'User-Agent';
		  },

		  /**
		   * @api private
		   */
		  appendToUserAgent: function appendToUserAgent(agentPartial) {
		    if (typeof agentPartial === 'string' && agentPartial) {
		      this._userAgent += ' ' + agentPartial;
		    }
		    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
		  },

		  /**
		   * @api private
		   */
		  getUserAgent: function getUserAgent() {
		    return this._userAgent;
		  },

		  /**
		   * @return [String] the part of the {path} excluding the
		   *   query string
		   */
		  pathname: function pathname() {
		    return this.path.split('?', 1)[0];
		  },

		  /**
		   * @return [String] the query string portion of the {path}
		   */
		  search: function search() {
		    var query = this.path.split('?', 2)[1];
		    if (query) {
		      query = AWS.util.queryStringParse(query);
		      return AWS.util.queryParamsToString(query);
		    }
		    return '';
		  },

		  /**
		   * @api private
		   * update httpRequest endpoint with endpoint string
		   */
		  updateEndpoint: function updateEndpoint(endpointStr) {
		    var newEndpoint = new AWS.Endpoint(endpointStr);
		    this.endpoint = newEndpoint;
		    this.path = newEndpoint.path || '/';
		    if (this.headers['Host']) {
		      this.headers['Host'] = newEndpoint.host;
		    }
		  }
		});

		/**
		 * The low level HTTP response object, encapsulating all HTTP header
		 * and body data returned from the request.
		 *
		 * @!attribute statusCode
		 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
		 * @!attribute headers
		 *   @return [map<String,String>]
		 *      a map of response header keys and their respective values
		 * @!attribute body
		 *   @return [String] the response body payload
		 * @!attribute [r] streaming
		 *   @return [Boolean] whether this response is being streamed at a low-level.
		 *     Defaults to `false` (buffered reads). Do not modify this manually, use
		 *     {createUnbufferedStream} to convert the stream to unbuffered mode
		 *     instead.
		 */
		AWS.HttpResponse = inherit({

		  /**
		   * @api private
		   */
		  constructor: function HttpResponse() {
		    this.statusCode = undefined;
		    this.headers = {};
		    this.body = undefined;
		    this.streaming = false;
		    this.stream = null;
		  },

		  /**
		   * Disables buffering on the HTTP response and returns the stream for reading.
		   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
		   *   Use this object to directly read data off of the stream.
		   * @note This object is only available after the {AWS.Request~httpHeaders}
		   *   event has fired. This method must be called prior to
		   *   {AWS.Request~httpData}.
		   * @example Taking control of a stream
		   *   request.on('httpHeaders', function(statusCode, headers) {
		   *     if (statusCode < 300) {
		   *       if (headers.etag === 'xyz') {
		   *         // pipe the stream, disabling buffering
		   *         var stream = this.response.httpResponse.createUnbufferedStream();
		   *         stream.pipe(process.stdout);
		   *       } else { // abort this request and set a better error message
		   *         this.abort();
		   *         this.response.error = new Error('Invalid ETag');
		   *       }
		   *     }
		   *   }).send(console.log);
		   */
		  createUnbufferedStream: function createUnbufferedStream() {
		    this.streaming = true;
		    return this.stream;
		  }
		});


		AWS.HttpClient = inherit({});

		/**
		 * @api private
		 */
		AWS.HttpClient.getInstance = function getInstance() {
		  if (this.singleton === undefined) {
		    this.singleton = new this();
		  }
		  return this.singleton;
		};


	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var SequentialExecutor = __webpack_require__(36);
		var DISCOVER_ENDPOINT = __webpack_require__(46).discoverEndpoint;
		/**
		 * The namespace used to register global event listeners for request building
		 * and sending.
		 */
		AWS.EventListeners = {
		  /**
		   * @!attribute VALIDATE_CREDENTIALS
		   *   A request listener that validates whether the request is being
		   *   sent with credentials.
		   *   Handles the {AWS.Request~validate 'validate' Request event}
		   *   @example Sending a request without validating credentials
		   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
		   *     request.removeListener('validate', listener);
		   *   @readonly
		   *   @return [Function]
		   * @!attribute VALIDATE_REGION
		   *   A request listener that validates whether the region is set
		   *   for a request.
		   *   Handles the {AWS.Request~validate 'validate' Request event}
		   *   @example Sending a request without validating region configuration
		   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
		   *     request.removeListener('validate', listener);
		   *   @readonly
		   *   @return [Function]
		   * @!attribute VALIDATE_PARAMETERS
		   *   A request listener that validates input parameters in a request.
		   *   Handles the {AWS.Request~validate 'validate' Request event}
		   *   @example Sending a request without validating parameters
		   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
		   *     request.removeListener('validate', listener);
		   *   @example Disable parameter validation globally
		   *     AWS.EventListeners.Core.removeListener('validate',
		   *       AWS.EventListeners.Core.VALIDATE_REGION);
		   *   @readonly
		   *   @return [Function]
		   * @!attribute SEND
		   *   A request listener that initiates the HTTP connection for a
		   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
		   *   @example Replacing the HTTP handler
		   *     var listener = AWS.EventListeners.Core.SEND;
		   *     request.removeListener('send', listener);
		   *     request.on('send', function(response) {
		   *       customHandler.send(response);
		   *     });
		   *   @return [Function]
		   *   @readonly
		   * @!attribute HTTP_DATA
		   *   A request listener that reads data from the HTTP connection in order
		   *   to build the response data.
		   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
		   *   Remove this handler if you are overriding the 'httpData' event and
		   *   do not want extra data processing and buffering overhead.
		   *   @example Disabling default data processing
		   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
		   *     request.removeListener('httpData', listener);
		   *   @return [Function]
		   *   @readonly
		   */
		  Core: {} /* doc hack */
		};

		/**
		 * @api private
		 */
		function getOperationAuthtype(req) {
		  if (!req.service.api.operations) {
		    return '';
		  }
		  var operation = req.service.api.operations[req.operation];
		  return operation ? operation.authtype : '';
		}

		AWS.EventListeners = {
		  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
		    addAsync('VALIDATE_CREDENTIALS', 'validate',
		        function VALIDATE_CREDENTIALS(req, done) {
		      if (!req.service.api.signatureVersion && !req.service.config.signatureVersion) return done(); // none
		      req.service.config.getCredentials(function(err) {
		        if (err) {
		          req.response.error = AWS.util.error(err,
		            {code: 'CredentialsError', message: 'Missing credentials in config, if using AWS_CONFIG_FILE, set AWS_SDK_LOAD_CONFIG=1'});
		        }
		        done();
		      });
		    });

		    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
		      if (!req.service.isGlobalEndpoint) {
		        var dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
		        if (!req.service.config.region) {
		          req.response.error = AWS.util.error(new Error(),
		            {code: 'ConfigError', message: 'Missing region in config'});
		        } else if (!dnsHostRegex.test(req.service.config.region)) {
		          req.response.error = AWS.util.error(new Error(),
		            {code: 'ConfigError', message: 'Invalid region in config'});
		        }
		      }
		    });

		    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
		      if (!req.service.api.operations) {
		        return;
		      }
		      var operation = req.service.api.operations[req.operation];
		      if (!operation) {
		        return;
		      }
		      var idempotentMembers = operation.idempotentMembers;
		      if (!idempotentMembers.length) {
		        return;
		      }
		      // creates a copy of params so user's param object isn't mutated
		      var params = AWS.util.copy(req.params);
		      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
		        if (!params[idempotentMembers[i]]) {
		          // add the member
		          params[idempotentMembers[i]] = AWS.util.uuid.v4();
		        }
		      }
		      req.params = params;
		    });

		    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
		      if (!req.service.api.operations) {
		        return;
		      }
		      var rules = req.service.api.operations[req.operation].input;
		      var validation = req.service.config.paramValidation;
		      new AWS.ParamValidator(validation).validate(rules, req.params);
		    });

		    add('COMPUTE_CHECKSUM', 'afterBuild', function COMPUTE_CHECKSUM(req) {
		      if (!req.service.api.operations) {
		        return;
		      }
		      var operation = req.service.api.operations[req.operation];
		      if (!operation) {
		        return;
		      }
		      var body = req.httpRequest.body;
		      var isNonStreamingPayload = body && (AWS.util.Buffer.isBuffer(body) || typeof body === 'string');
		      var headers = req.httpRequest.headers;
		      if (
		        operation.httpChecksumRequired &&
		        req.service.config.computeChecksums &&
		        isNonStreamingPayload &&
		        !headers['Content-MD5']
		      ) {
		        var md5 = AWS.util.crypto.md5(body, 'base64');
		        headers['Content-MD5'] = md5;
		      }
		    });

		    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
		      req.haltHandlersOnError();
		      if (!req.service.api.operations) {
		        return;
		      }
		      var operation = req.service.api.operations[req.operation];
		      var authtype = operation ? operation.authtype : '';
		      if (!req.service.api.signatureVersion && !authtype && !req.service.config.signatureVersion) return done(); // none
		      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
		        var body = req.httpRequest.body || '';
		        if (authtype.indexOf('unsigned-body') >= 0) {
		          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
		          return done();
		        }
		        AWS.util.computeSha256(body, function(err, sha) {
		          if (err) {
		            done(err);
		          }
		          else {
		            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
		            done();
		          }
		        });
		      } else {
		        done();
		      }
		    });

		    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
		      var authtype = getOperationAuthtype(req);
		      var payloadMember = AWS.util.getRequestPayloadShape(req);
		      if (req.httpRequest.headers['Content-Length'] === undefined) {
		        try {
		          var length = AWS.util.string.byteLength(req.httpRequest.body);
		          req.httpRequest.headers['Content-Length'] = length;
		        } catch (err) {
		          if (payloadMember && payloadMember.isStreaming) {
		            if (payloadMember.requiresLength) {
		              //streaming payload requires length(s3, glacier)
		              throw err;
		            } else if (authtype.indexOf('unsigned-body') >= 0) {
		              //unbounded streaming payload(lex, mediastore)
		              req.httpRequest.headers['Transfer-Encoding'] = 'chunked';
		              return;
		            } else {
		              throw err;
		            }
		          }
		          throw err;
		        }
		      }
		    });

		    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
		      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
		    });

		    add('RESTART', 'restart', function RESTART() {
		      var err = this.response.error;
		      if (!err || !err.retryable) return;

		      this.httpRequest = new AWS.HttpRequest(
		        this.service.endpoint,
		        this.service.region
		      );

		      if (this.response.retryCount < this.service.config.maxRetries) {
		        this.response.retryCount++;
		      } else {
		        this.response.error = null;
		      }
		    });

		    var addToHead = true;
		    addAsync('DISCOVER_ENDPOINT', 'sign', DISCOVER_ENDPOINT, addToHead);

		    addAsync('SIGN', 'sign', function SIGN(req, done) {
		      var service = req.service;
		      var operations = req.service.api.operations || {};
		      var operation = operations[req.operation];
		      var authtype = operation ? operation.authtype : '';
		      if (!service.api.signatureVersion && !authtype && !service.config.signatureVersion) return done(); // none

		      service.config.getCredentials(function (err, credentials) {
		        if (err) {
		          req.response.error = err;
		          return done();
		        }

		        try {
		          var date = service.getSkewCorrectedDate();
		          var SignerClass = service.getSignerClass(req);
		          var signer = new SignerClass(req.httpRequest,
		            service.getSigningName(req),
		            {
		              signatureCache: service.config.signatureCache,
		              operation: operation,
		              signatureVersion: service.api.signatureVersion
		            });
		          signer.setServiceClientId(service._clientId);

		          // clear old authorization headers
		          delete req.httpRequest.headers['Authorization'];
		          delete req.httpRequest.headers['Date'];
		          delete req.httpRequest.headers['X-Amz-Date'];

		          // add new authorization
		          signer.addAuthorization(credentials, date);
		          req.signedAt = date;
		        } catch (e) {
		          req.response.error = e;
		        }
		        done();
		      });
		    });

		    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
		      if (this.service.successfulResponse(resp, this)) {
		        resp.data = {};
		        resp.error = null;
		      } else {
		        resp.data = null;
		        resp.error = AWS.util.error(new Error(),
		          {code: 'UnknownError', message: 'An unknown error occurred.'});
		      }
		    });

		    addAsync('SEND', 'send', function SEND(resp, done) {
		      resp.httpResponse._abortCallback = done;
		      resp.error = null;
		      resp.data = null;

		      function callback(httpResp) {
		        resp.httpResponse.stream = httpResp;
		        var stream = resp.request.httpRequest.stream;
		        var service = resp.request.service;
		        var api = service.api;
		        var operationName = resp.request.operation;
		        var operation = api.operations[operationName] || {};

		        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
		          resp.request.emit(
		            'httpHeaders',
		            [statusCode, headers, resp, statusMessage]
		          );

		          if (!resp.httpResponse.streaming) {
		            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
		              // if we detect event streams, we're going to have to
		              // return the stream immediately
		              if (operation.hasEventOutput && service.successfulResponse(resp)) {
		                // skip reading the IncomingStream
		                resp.request.emit('httpDone');
		                done();
		                return;
		              }

		              httpResp.on('readable', function onReadable() {
		                var data = httpResp.read();
		                if (data !== null) {
		                  resp.request.emit('httpData', [data, resp]);
		                }
		              });
		            } else { // legacy streams API
		              httpResp.on('data', function onData(data) {
		                resp.request.emit('httpData', [data, resp]);
		              });
		            }
		          }
		        });

		        httpResp.on('end', function onEnd() {
		          if (!stream || !stream.didCallback) {
		            if (AWS.HttpClient.streamsApiVersion === 2 && (operation.hasEventOutput && service.successfulResponse(resp))) {
		              // don't concatenate response chunks when streaming event stream data when response is successful
		              return;
		            }
		            resp.request.emit('httpDone');
		            done();
		          }
		        });
		      }

		      function progress(httpResp) {
		        httpResp.on('sendProgress', function onSendProgress(value) {
		          resp.request.emit('httpUploadProgress', [value, resp]);
		        });

		        httpResp.on('receiveProgress', function onReceiveProgress(value) {
		          resp.request.emit('httpDownloadProgress', [value, resp]);
		        });
		      }

		      function error(err) {
		        if (err.code !== 'RequestAbortedError') {
		          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
		          err = AWS.util.error(err, {
		            code: errCode,
		            region: resp.request.httpRequest.region,
		            hostname: resp.request.httpRequest.endpoint.hostname,
		            retryable: true
		          });
		        }
		        resp.error = err;
		        resp.request.emit('httpError', [resp.error, resp], function() {
		          done();
		        });
		      }

		      function executeSend() {
		        var http = AWS.HttpClient.getInstance();
		        var httpOptions = resp.request.service.config.httpOptions || {};
		        try {
		          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
		                                          callback, error);
		          progress(stream);
		        } catch (err) {
		          error(err);
		        }
		      }
		      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
		      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
		        this.emit('sign', [this], function(err) {
		          if (err) done(err);
		          else executeSend();
		        });
		      } else {
		        executeSend();
		      }
		    });

		    add('HTTP_HEADERS', 'httpHeaders',
		        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
		      resp.httpResponse.statusCode = statusCode;
		      resp.httpResponse.statusMessage = statusMessage;
		      resp.httpResponse.headers = headers;
		      resp.httpResponse.body = AWS.util.buffer.toBuffer('');
		      resp.httpResponse.buffers = [];
		      resp.httpResponse.numBytes = 0;
		      var dateHeader = headers.date || headers.Date;
		      var service = resp.request.service;
		      if (dateHeader) {
		        var serverTime = Date.parse(dateHeader);
		        if (service.config.correctClockSkew
		            && service.isClockSkewed(serverTime)) {
		          service.applyClockOffset(serverTime);
		        }
		      }
		    });

		    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
		      if (chunk) {
		        if (AWS.util.isNode()) {
		          resp.httpResponse.numBytes += chunk.length;

		          var total = resp.httpResponse.headers['content-length'];
		          var progress = { loaded: resp.httpResponse.numBytes, total: total };
		          resp.request.emit('httpDownloadProgress', [progress, resp]);
		        }

		        resp.httpResponse.buffers.push(AWS.util.buffer.toBuffer(chunk));
		      }
		    });

		    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
		      // convert buffers array into single buffer
		      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
		        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
		        resp.httpResponse.body = body;
		      }
		      delete resp.httpResponse.numBytes;
		      delete resp.httpResponse.buffers;
		    });

		    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
		      if (resp.httpResponse.statusCode) {
		        resp.error.statusCode = resp.httpResponse.statusCode;
		        if (resp.error.retryable === undefined) {
		          resp.error.retryable = this.service.retryableError(resp.error, this);
		        }
		      }
		    });

		    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
		      if (!resp.error) return;
		      switch (resp.error.code) {
		        case 'RequestExpired': // EC2 only
		        case 'ExpiredTokenException':
		        case 'ExpiredToken':
		          resp.error.retryable = true;
		          resp.request.service.config.credentials.expired = true;
		      }
		    });

		    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
		      var err = resp.error;
		      if (!err) return;
		      if (typeof err.code === 'string' && typeof err.message === 'string') {
		        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
		          resp.error.retryable = true;
		        }
		      }
		    });

		    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
		      if (!resp.error) return;
		      if (this.service.clockSkewError(resp.error)
		          && this.service.config.correctClockSkew) {
		        resp.error.retryable = true;
		      }
		    });

		    add('REDIRECT', 'retry', function REDIRECT(resp) {
		      if (resp.error && resp.error.statusCode >= 300 &&
		          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
		        this.httpRequest.endpoint =
		          new AWS.Endpoint(resp.httpResponse.headers['location']);
		        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
		        resp.error.redirect = true;
		        resp.error.retryable = true;
		      }
		    });

		    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
		      if (resp.error) {
		        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
		          resp.error.retryDelay = 0;
		        } else if (resp.retryCount < resp.maxRetries) {
		          resp.error.retryDelay = this.service.retryDelays(resp.retryCount, resp.error) || 0;
		        }
		      }
		    });

		    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
		      var delay, willRetry = false;

		      if (resp.error) {
		        delay = resp.error.retryDelay || 0;
		        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
		          resp.retryCount++;
		          willRetry = true;
		        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
		          resp.redirectCount++;
		          willRetry = true;
		        }
		      }

		      // delay < 0 is a signal from customBackoff to skip retries
		      if (willRetry && delay >= 0) {
		        resp.error = null;
		        setTimeout(done, delay);
		      } else {
		        done();
		      }
		    });
		  }),

		  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
		    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
		    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);

		    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
		      function isDNSError(err) {
		        return err.errno === 'ENOTFOUND' ||
		          typeof err.errno === 'number' &&
		          typeof AWS.util.getSystemErrorName === 'function' &&
		          ['EAI_NONAME', 'EAI_NODATA'].indexOf(AWS.util.getSystemErrorName(err.errno) >= 0);
		      }
		      if (err.code === 'NetworkingError' && isDNSError(err)) {
		        var message = 'Inaccessible host: `' + err.hostname + '\' at port `' + err.port +
		          '\'. This service may not be available in the `' + err.region +
		          '\' region.';
		        this.response.error = AWS.util.error(new Error(message), {
		          code: 'UnknownEndpoint',
		          region: err.region,
		          hostname: err.hostname,
		          retryable: true,
		          originalError: err
		        });
		      }
		    });
		  }),

		  Logger: new SequentialExecutor().addNamedListeners(function(add) {
		    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
		      var req = resp.request;
		      var logger = req.service.config.logger;
		      if (!logger) return;
		      function filterSensitiveLog(inputShape, shape) {
		        if (!shape) {
		          return shape;
		        }
		        if (inputShape.isSensitive) {
		          return '***SensitiveInformation***';
		        }
		        switch (inputShape.type) {
		          case 'structure':
		            var struct = {};
		            AWS.util.each(shape, function(subShapeName, subShape) {
		              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
		                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
		              } else {
		                struct[subShapeName] = subShape;
		              }
		            });
		            return struct;
		          case 'list':
		            var list = [];
		            AWS.util.arrayEach(shape, function(subShape, index) {
		              list.push(filterSensitiveLog(inputShape.member, subShape));
		            });
		            return list;
		          case 'map':
		            var map = {};
		            AWS.util.each(shape, function(key, value) {
		              map[key] = filterSensitiveLog(inputShape.value, value);
		            });
		            return map;
		          default:
		            return shape;
		        }
		      }

		      function buildMessage() {
		        var time = resp.request.service.getSkewCorrectedDate().getTime();
		        var delta = (time - req.startTime.getTime()) / 1000;
		        var ansi = logger.isTTY ? true : false;
		        var status = resp.httpResponse.statusCode;
		        var censoredParams = req.params;
		        if (
		          req.service.api.operations &&
		              req.service.api.operations[req.operation] &&
		              req.service.api.operations[req.operation].input
		        ) {
		          var inputShape = req.service.api.operations[req.operation].input;
		          censoredParams = filterSensitiveLog(inputShape, req.params);
		        }
		        var params = __webpack_require__(47).inspect(censoredParams, true, null);
		        var message = '';
		        if (ansi) message += '\x1B[33m';
		        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
		        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
		        if (ansi) message += '\x1B[0;1m';
		        message += ' ' + AWS.util.string.lowerFirst(req.operation);
		        message += '(' + params + ')';
		        if (ansi) message += '\x1B[0m';
		        return message;
		      }

		      var line = buildMessage();
		      if (typeof logger.log === 'function') {
		        logger.log(line);
		      } else if (typeof logger.write === 'function') {
		        logger.write(line + '\n');
		      }
		    });
		  }),

		  Json: new SequentialExecutor().addNamedListeners(function(add) {
		    var svc = __webpack_require__(13);
		    add('BUILD', 'build', svc.buildRequest);
		    add('EXTRACT_DATA', 'extractData', svc.extractData);
		    add('EXTRACT_ERROR', 'extractError', svc.extractError);
		  }),

		  Rest: new SequentialExecutor().addNamedListeners(function(add) {
		    var svc = __webpack_require__(21);
		    add('BUILD', 'build', svc.buildRequest);
		    add('EXTRACT_DATA', 'extractData', svc.extractData);
		    add('EXTRACT_ERROR', 'extractError', svc.extractError);
		  }),

		  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
		    var svc = __webpack_require__(22);
		    add('BUILD', 'build', svc.buildRequest);
		    add('EXTRACT_DATA', 'extractData', svc.extractData);
		    add('EXTRACT_ERROR', 'extractError', svc.extractError);
		  }),

		  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
		    var svc = __webpack_require__(23);
		    add('BUILD', 'build', svc.buildRequest);
		    add('EXTRACT_DATA', 'extractData', svc.extractData);
		    add('EXTRACT_ERROR', 'extractError', svc.extractError);
		  }),

		  Query: new SequentialExecutor().addNamedListeners(function(add) {
		    var svc = __webpack_require__(17);
		    add('BUILD', 'build', svc.buildRequest);
		    add('EXTRACT_DATA', 'extractData', svc.extractData);
		    add('EXTRACT_ERROR', 'extractError', svc.extractError);
		  })
		};


	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(1);
		var util = __webpack_require__(2);
		var endpointDiscoveryEnabledEnvs = ['AWS_ENABLE_ENDPOINT_DISCOVERY', 'AWS_ENDPOINT_DISCOVERY_ENABLED'];

		/**
		 * Generate key (except resources and operation part) to index the endpoints in the cache
		 * If input shape has endpointdiscoveryid trait then use
		 *   accessKey + operation + resources + region + service as cache key
		 * If input shape doesn't have endpointdiscoveryid trait then use
		 *   accessKey + region + service as cache key
		 * @return [map<String,String>] object with keys to index endpoints.
		 * @api private
		 */
		function getCacheKey(request) {
		  var service = request.service;
		  var api = service.api || {};
		  var operations = api.operations;
		  var identifiers = {};
		  if (service.config.region) {
		    identifiers.region = service.config.region;
		  }
		  if (api.serviceId) {
		    identifiers.serviceId = api.serviceId;
		  }
		  if (service.config.credentials.accessKeyId) {
		    identifiers.accessKeyId = service.config.credentials.accessKeyId;
		  }
		  return identifiers;
		}

		/**
		 * Recursive helper for marshallCustomIdentifiers().
		 * Looks for required string input members that have 'endpointdiscoveryid' trait.
		 * @api private
		 */
		function marshallCustomIdentifiersHelper(result, params, shape) {
		  if (!shape || params === undefined || params === null) return;
		  if (shape.type === 'structure' && shape.required && shape.required.length > 0) {
		    util.arrayEach(shape.required, function(name) {
		      var memberShape = shape.members[name];
		      if (memberShape.endpointDiscoveryId === true) {
		        var locationName = memberShape.isLocationName ? memberShape.name : name;
		        result[locationName] = String(params[name]);
		      } else {
		        marshallCustomIdentifiersHelper(result, params[name], memberShape);
		      }
		    });
		  }
		}

		/**
		 * Get custom identifiers for cache key.
		 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
		 * @param [object] request object
		 * @param [object] input shape of the given operation's api
		 * @api private
		 */
		function marshallCustomIdentifiers(request, shape) {
		  var identifiers = {};
		  marshallCustomIdentifiersHelper(identifiers, request.params, shape);
		  return identifiers;
		}

		/**
		 * Call endpoint discovery operation when it's optional.
		 * When endpoint is available in cache then use the cached endpoints. If endpoints
		 * are unavailable then use regional endpoints and call endpoint discovery operation
		 * asynchronously. This is turned off by default.
		 * @param [object] request object
		 * @api private
		 */
		function optionalDiscoverEndpoint(request) {
		  var service = request.service;
		  var api = service.api;
		  var operationModel = api.operations ? api.operations[request.operation] : undefined;
		  var inputShape = operationModel ? operationModel.input : undefined;

		  var identifiers = marshallCustomIdentifiers(request, inputShape);
		  var cacheKey = getCacheKey(request);
		  if (Object.keys(identifiers).length > 0) {
		    cacheKey = util.update(cacheKey, identifiers);
		    if (operationModel) cacheKey.operation = operationModel.name;
		  }
		  var endpoints = AWS.endpointCache.get(cacheKey);
		  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
		    //endpoint operation is being made but response not yet received
		    //or endpoint operation just failed in 1 minute
		    return;
		  } else if (endpoints && endpoints.length > 0) {
		    //found endpoint record from cache
		    request.httpRequest.updateEndpoint(endpoints[0].Address);
		  } else {
		    //endpoint record not in cache or outdated. make discovery operation
		    var endpointRequest = service.makeRequest(api.endpointOperation, {
		      Operation: operationModel.name,
		      Identifiers: identifiers,
		    });
		    addApiVersionHeader(endpointRequest);
		    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
		    endpointRequest.removeListener('retry', AWS.EventListeners.Core.RETRY_CHECK);
		    //put in a placeholder for endpoints already requested, prevent
		    //too much in-flight calls
		    AWS.endpointCache.put(cacheKey, [{
		      Address: '',
		      CachePeriodInMinutes: 1
		    }]);
		    endpointRequest.send(function(err, data) {
		      if (data && data.Endpoints) {
		        AWS.endpointCache.put(cacheKey, data.Endpoints);
		      } else if (err) {
		        AWS.endpointCache.put(cacheKey, [{
		          Address: '',
		          CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
		        }]);
		      }
		    });
		  }
		}

		var requestQueue = {};

		/**
		 * Call endpoint discovery operation when it's required.
		 * When endpoint is available in cache then use cached ones. If endpoints are
		 * unavailable then SDK should call endpoint operation then use returned new
		 * endpoint for the api call. SDK will automatically attempt to do endpoint
		 * discovery. This is turned off by default
		 * @param [object] request object
		 * @api private
		 */
		function requiredDiscoverEndpoint(request, done) {
		  var service = request.service;
		  var api = service.api;
		  var operationModel = api.operations ? api.operations[request.operation] : undefined;
		  var inputShape = operationModel ? operationModel.input : undefined;

		  var identifiers = marshallCustomIdentifiers(request, inputShape);
		  var cacheKey = getCacheKey(request);
		  if (Object.keys(identifiers).length > 0) {
		    cacheKey = util.update(cacheKey, identifiers);
		    if (operationModel) cacheKey.operation = operationModel.name;
		  }
		  var cacheKeyStr = AWS.EndpointCache.getKeyString(cacheKey);
		  var endpoints = AWS.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
		  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
		    //endpoint operation is being made but response not yet received
		    //push request object to a pending queue
		    if (!requestQueue[cacheKeyStr]) requestQueue[cacheKeyStr] = [];
		    requestQueue[cacheKeyStr].push({request: request, callback: done});
		    return;
		  } else if (endpoints && endpoints.length > 0) {
		    request.httpRequest.updateEndpoint(endpoints[0].Address);
		    done();
		  } else {
		    var endpointRequest = service.makeRequest(api.endpointOperation, {
		      Operation: operationModel.name,
		      Identifiers: identifiers,
		    });
		    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
		    addApiVersionHeader(endpointRequest);

		    //put in a placeholder for endpoints already requested, prevent
		    //too much in-flight calls
		    AWS.endpointCache.put(cacheKeyStr, [{
		      Address: '',
		      CachePeriodInMinutes: 60 //long-live cache
		    }]);
		    endpointRequest.send(function(err, data) {
		      if (err) {
		        request.response.error = util.error(err, { retryable: false });
		        AWS.endpointCache.remove(cacheKey);

		        //fail all the pending requests in batch
		        if (requestQueue[cacheKeyStr]) {
		          var pendingRequests = requestQueue[cacheKeyStr];
		          util.arrayEach(pendingRequests, function(requestContext) {
		            requestContext.request.response.error = util.error(err, { retryable: false });
		            requestContext.callback();
		          });
		          delete requestQueue[cacheKeyStr];
		        }
		      } else if (data) {
		        AWS.endpointCache.put(cacheKeyStr, data.Endpoints);
		        request.httpRequest.updateEndpoint(data.Endpoints[0].Address);

		        //update the endpoint for all the pending requests in batch
		        if (requestQueue[cacheKeyStr]) {
		          var pendingRequests = requestQueue[cacheKeyStr];
		          util.arrayEach(pendingRequests, function(requestContext) {
		            requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
		            requestContext.callback();
		          });
		          delete requestQueue[cacheKeyStr];
		        }
		      }
		      done();
		    });
		  }
		}

		/**
		 * add api version header to endpoint operation
		 * @api private
		 */
		function addApiVersionHeader(endpointRequest) {
		  var api = endpointRequest.service.api;
		  var apiVersion = api.apiVersion;
		  if (apiVersion && !endpointRequest.httpRequest.headers['x-amz-api-version']) {
		    endpointRequest.httpRequest.headers['x-amz-api-version'] = apiVersion;
		  }
		}

		/**
		 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
		 * endpoint from cache.
		 * @api private
		 */
		function invalidateCachedEndpoints(response) {
		  var error = response.error;
		  var httpResponse = response.httpResponse;
		  if (error &&
		    (error.code === 'InvalidEndpointException' || httpResponse.statusCode === 421)
		  ) {
		    var request = response.request;
		    var operations = request.service.api.operations || {};
		    var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
		    var identifiers = marshallCustomIdentifiers(request, inputShape);
		    var cacheKey = getCacheKey(request);
		    if (Object.keys(identifiers).length > 0) {
		      cacheKey = util.update(cacheKey, identifiers);
		      if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
		    }
		    AWS.endpointCache.remove(cacheKey);
		  }
		}

		/**
		 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
		 * @param [object] client Service client object.
		 * @api private
		 */
		function hasCustomEndpoint(client) {
		  //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
		  if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) {
		    throw util.error(new Error(), {
		      code: 'ConfigurationException',
		      message: 'Custom endpoint is supplied; endpointDiscoveryEnabled must not be true.'
		    });
		  };
		  var svcConfig = AWS.config[client.serviceIdentifier] || {};
		  return Boolean(AWS.config.endpoint || svcConfig.endpoint || (client._originalConfig && client._originalConfig.endpoint));
		}

		/**
		 * @api private
		 */
		function isFalsy(value) {
		  return ['false', '0'].indexOf(value) >= 0;
		}

		/**
		 * If endpoint discovery should perform for this request when no operation requires endpoint
		 * discovery for the given service.
		 * SDK performs config resolution in order like below:
		 * 1. If set in client configuration.
		 * 2. If set in env AWS_ENABLE_ENDPOINT_DISCOVERY.
		 * 3. If set in shared ini config file with key 'endpoint_discovery_enabled'.
		 * @param [object] request request object.
		 * @returns [boolean|undefined] if endpoint discovery config is not set in any source, this
		 *  function returns undefined
		 * @api private
		 */
		function resolveEndpointDiscoveryConfig(request) {
		  var service = request.service || {};
		  if (service.config.endpointDiscoveryEnabled !== undefined) {
		    return service.config.endpointDiscoveryEnabled;
		  }

		  //shared ini file is only available in Node
		  //not to check env in browser
		  if (util.isBrowser()) return undefined;

		  // If any of recognized endpoint discovery config env is set
		  for (var i = 0; i < endpointDiscoveryEnabledEnvs.length; i++) {
		    var env = endpointDiscoveryEnabledEnvs[i];
		    if (Object.prototype.hasOwnProperty.call(process.env, env)) {
		      if (process.env[env] === '' || process.env[env] === undefined) {
		        throw util.error(new Error(), {
		          code: 'ConfigurationException',
		          message: 'environmental variable ' + env + ' cannot be set to nothing'
		        });
		      }
		      return !isFalsy(process.env[env]);
		    }
		  }

		  var configFile = {};
		  try {
		    configFile = AWS.util.iniLoader ? AWS.util.iniLoader.loadFrom({
		      isConfig: true,
		      filename: process.env[AWS.util.sharedConfigFileEnv]
		    }) : {};
		  } catch (e) {}
		  var sharedFileConfig = configFile[
		    process.env.AWS_PROFILE || AWS.util.defaultProfile
		  ] || {};
		  if (Object.prototype.hasOwnProperty.call(sharedFileConfig, 'endpoint_discovery_enabled')) {
		    if (sharedFileConfig.endpoint_discovery_enabled === undefined) {
		      throw util.error(new Error(), {
		        code: 'ConfigurationException',
		        message: 'config file entry \'endpoint_discovery_enabled\' cannot be set to nothing'
		      });
		    }
		    return !isFalsy(sharedFileConfig.endpoint_discovery_enabled);
		  }
		  return undefined;
		}

		/**
		 * attach endpoint discovery logic to request object
		 * @param [object] request
		 * @api private
		 */
		function discoverEndpoint(request, done) {
		  var service = request.service || {};
		  if (hasCustomEndpoint(service) || request.isPresigned()) return done();

		  var operations = service.api.operations || {};
		  var operationModel = operations[request.operation];
		  var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : 'NULL';
		  var isEnabled = resolveEndpointDiscoveryConfig(request);
		  var hasRequiredEndpointDiscovery = service.api.hasRequiredEndpointDiscovery;
		  if (isEnabled || hasRequiredEndpointDiscovery) {
		    // Once a customer enables endpoint discovery, the SDK should start appending
		    // the string endpoint-discovery to the user-agent on all requests.
		    request.httpRequest.appendToUserAgent('endpoint-discovery');
		  }
		  switch (isEndpointDiscoveryRequired) {
		    case 'OPTIONAL':
		      if (isEnabled || hasRequiredEndpointDiscovery) {
		        // For a given service; if at least one operation requires endpoint discovery then the SDK must enable endpoint discovery
		        // by default for all operations of that service, including operations where endpoint discovery is optional.
		        optionalDiscoverEndpoint(request);
		        request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
		      }
		      done();
		      break;
		    case 'REQUIRED':
		      if (isEnabled === false) {
		        // For a given operation; if endpoint discovery is required and it has been disabled on the SDK client,
		        // then the SDK must return a clear and actionable exception.
		        request.response.error = util.error(new Error(), {
		          code: 'ConfigurationException',
		          message: 'Endpoint Discovery is disabled but ' + service.api.className + '.' + request.operation +
		                    '() requires it. Please check your configurations.'
		        });
		        done();
		        break;
		      }
		      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
		      requiredDiscoverEndpoint(request, done);
		      break;
		    case 'NULL':
		    default:
		      done();
		      break;
		  }
		}

		module.exports = {
		  discoverEndpoint: discoverEndpoint,
		  requiredDiscoverEndpoint: requiredDiscoverEndpoint,
		  optionalDiscoverEndpoint: optionalDiscoverEndpoint,
		  marshallCustomIdentifiers: marshallCustomIdentifiers,
		  getCacheKey: getCacheKey,
		  invalidateCachedEndpoint: invalidateCachedEndpoints,
		};

		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		var formatRegExp = /%[sdj%]/g;
		exports.format = function(f) {
		  if (!isString(f)) {
		    var objects = [];
		    for (var i = 0; i < arguments.length; i++) {
		      objects.push(inspect(arguments[i]));
		    }
		    return objects.join(' ');
		  }

		  var i = 1;
		  var args = arguments;
		  var len = args.length;
		  var str = String(f).replace(formatRegExp, function(x) {
		    if (x === '%%') return '%';
		    if (i >= len) return x;
		    switch (x) {
		      case '%s': return String(args[i++]);
		      case '%d': return Number(args[i++]);
		      case '%j':
		        try {
		          return JSON.stringify(args[i++]);
		        } catch (_) {
		          return '[Circular]';
		        }
		      default:
		        return x;
		    }
		  });
		  for (var x = args[i]; i < len; x = args[++i]) {
		    if (isNull(x) || !isObject(x)) {
		      str += ' ' + x;
		    } else {
		      str += ' ' + inspect(x);
		    }
		  }
		  return str;
		};


		// Mark that a method should not be used.
		// Returns a modified function which warns once by default.
		// If --no-deprecation is set, then it is a no-op.
		exports.deprecate = function(fn, msg) {
		  // Allow for deprecating things in the process of starting up.
		  if (isUndefined(global.process)) {
		    return function() {
		      return exports.deprecate(fn, msg).apply(this, arguments);
		    };
		  }

		  if (process.noDeprecation === true) {
		    return fn;
		  }

		  var warned = false;
		  function deprecated() {
		    if (!warned) {
		      if (process.throwDeprecation) {
		        throw new Error(msg);
		      } else if (process.traceDeprecation) {
		        console.trace(msg);
		      } else {
		        console.error(msg);
		      }
		      warned = true;
		    }
		    return fn.apply(this, arguments);
		  }

		  return deprecated;
		};


		var debugs = {};
		var debugEnviron;
		exports.debuglog = function(set) {
		  if (isUndefined(debugEnviron))
		    debugEnviron = process.env.NODE_DEBUG || '';
		  set = set.toUpperCase();
		  if (!debugs[set]) {
		    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
		      var pid = process.pid;
		      debugs[set] = function() {
		        var msg = exports.format.apply(exports, arguments);
		        console.error('%s %d: %s', set, pid, msg);
		      };
		    } else {
		      debugs[set] = function() {};
		    }
		  }
		  return debugs[set];
		};


		/**
		 * Echos the value of a value. Trys to print the value out
		 * in the best way possible given the different types.
		 *
		 * @param {Object} obj The object to print out.
		 * @param {Object} opts Optional options object that alters the output.
		 */
		/* legacy: obj, showHidden, depth, colors*/
		function inspect(obj, opts) {
		  // default options
		  var ctx = {
		    seen: [],
		    stylize: stylizeNoColor
		  };
		  // legacy...
		  if (arguments.length >= 3) ctx.depth = arguments[2];
		  if (arguments.length >= 4) ctx.colors = arguments[3];
		  if (isBoolean(opts)) {
		    // legacy...
		    ctx.showHidden = opts;
		  } else if (opts) {
		    // got an "options" object
		    exports._extend(ctx, opts);
		  }
		  // set default options
		  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
		  if (isUndefined(ctx.depth)) ctx.depth = 2;
		  if (isUndefined(ctx.colors)) ctx.colors = false;
		  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
		  if (ctx.colors) ctx.stylize = stylizeWithColor;
		  return formatValue(ctx, obj, ctx.depth);
		}
		exports.inspect = inspect;


		// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
		inspect.colors = {
		  'bold' : [1, 22],
		  'italic' : [3, 23],
		  'underline' : [4, 24],
		  'inverse' : [7, 27],
		  'white' : [37, 39],
		  'grey' : [90, 39],
		  'black' : [30, 39],
		  'blue' : [34, 39],
		  'cyan' : [36, 39],
		  'green' : [32, 39],
		  'magenta' : [35, 39],
		  'red' : [31, 39],
		  'yellow' : [33, 39]
		};

		// Don't use 'blue' not visible on cmd.exe
		inspect.styles = {
		  'special': 'cyan',
		  'number': 'yellow',
		  'boolean': 'yellow',
		  'undefined': 'grey',
		  'null': 'bold',
		  'string': 'green',
		  'date': 'magenta',
		  // "name": intentionally not styling
		  'regexp': 'red'
		};


		function stylizeWithColor(str, styleType) {
		  var style = inspect.styles[styleType];

		  if (style) {
		    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
		           '\u001b[' + inspect.colors[style][1] + 'm';
		  } else {
		    return str;
		  }
		}


		function stylizeNoColor(str, styleType) {
		  return str;
		}


		function arrayToHash(array) {
		  var hash = {};

		  array.forEach(function(val, idx) {
		    hash[val] = true;
		  });

		  return hash;
		}


		function formatValue(ctx, value, recurseTimes) {
		  // Provide a hook for user-specified inspect functions.
		  // Check that value is an object with an inspect function on it
		  if (ctx.customInspect &&
		      value &&
		      isFunction(value.inspect) &&
		      // Filter out the util module, it's inspect function is special
		      value.inspect !== exports.inspect &&
		      // Also filter out any prototype objects using the circular check.
		      !(value.constructor && value.constructor.prototype === value)) {
		    var ret = value.inspect(recurseTimes, ctx);
		    if (!isString(ret)) {
		      ret = formatValue(ctx, ret, recurseTimes);
		    }
		    return ret;
		  }

		  // Primitive types cannot have properties
		  var primitive = formatPrimitive(ctx, value);
		  if (primitive) {
		    return primitive;
		  }

		  // Look up the keys of the object.
		  var keys = Object.keys(value);
		  var visibleKeys = arrayToHash(keys);

		  if (ctx.showHidden) {
		    keys = Object.getOwnPropertyNames(value);
		  }

		  // IE doesn't make error fields non-enumerable
		  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
		  if (isError(value)
		      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
		    return formatError(value);
		  }

		  // Some type of object without properties can be shortcutted.
		  if (keys.length === 0) {
		    if (isFunction(value)) {
		      var name = value.name ? ': ' + value.name : '';
		      return ctx.stylize('[Function' + name + ']', 'special');
		    }
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    }
		    if (isDate(value)) {
		      return ctx.stylize(Date.prototype.toString.call(value), 'date');
		    }
		    if (isError(value)) {
		      return formatError(value);
		    }
		  }

		  var base = '', array = false, braces = ['{', '}'];

		  // Make Array say that they are Array
		  if (isArray(value)) {
		    array = true;
		    braces = ['[', ']'];
		  }

		  // Make functions say that they are functions
		  if (isFunction(value)) {
		    var n = value.name ? ': ' + value.name : '';
		    base = ' [Function' + n + ']';
		  }

		  // Make RegExps say that they are RegExps
		  if (isRegExp(value)) {
		    base = ' ' + RegExp.prototype.toString.call(value);
		  }

		  // Make dates with properties first say the date
		  if (isDate(value)) {
		    base = ' ' + Date.prototype.toUTCString.call(value);
		  }

		  // Make error with message first say the error
		  if (isError(value)) {
		    base = ' ' + formatError(value);
		  }

		  if (keys.length === 0 && (!array || value.length == 0)) {
		    return braces[0] + base + braces[1];
		  }

		  if (recurseTimes < 0) {
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    } else {
		      return ctx.stylize('[Object]', 'special');
		    }
		  }

		  ctx.seen.push(value);

		  var output;
		  if (array) {
		    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
		  } else {
		    output = keys.map(function(key) {
		      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
		    });
		  }

		  ctx.seen.pop();

		  return reduceToSingleString(output, base, braces);
		}


		function formatPrimitive(ctx, value) {
		  if (isUndefined(value))
		    return ctx.stylize('undefined', 'undefined');
		  if (isString(value)) {
		    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
		                                             .replace(/'/g, "\\'")
		                                             .replace(/\\"/g, '"') + '\'';
		    return ctx.stylize(simple, 'string');
		  }
		  if (isNumber(value))
		    return ctx.stylize('' + value, 'number');
		  if (isBoolean(value))
		    return ctx.stylize('' + value, 'boolean');
		  // For some reason typeof null is "object", so special case here.
		  if (isNull(value))
		    return ctx.stylize('null', 'null');
		}


		function formatError(value) {
		  return '[' + Error.prototype.toString.call(value) + ']';
		}


		function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
		  var output = [];
		  for (var i = 0, l = value.length; i < l; ++i) {
		    if (hasOwnProperty(value, String(i))) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
		          String(i), true));
		    } else {
		      output.push('');
		    }
		  }
		  keys.forEach(function(key) {
		    if (!key.match(/^\d+$/)) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
		          key, true));
		    }
		  });
		  return output;
		}


		function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
		  var name, str, desc;
		  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
		  if (desc.get) {
		    if (desc.set) {
		      str = ctx.stylize('[Getter/Setter]', 'special');
		    } else {
		      str = ctx.stylize('[Getter]', 'special');
		    }
		  } else {
		    if (desc.set) {
		      str = ctx.stylize('[Setter]', 'special');
		    }
		  }
		  if (!hasOwnProperty(visibleKeys, key)) {
		    name = '[' + key + ']';
		  }
		  if (!str) {
		    if (ctx.seen.indexOf(desc.value) < 0) {
		      if (isNull(recurseTimes)) {
		        str = formatValue(ctx, desc.value, null);
		      } else {
		        str = formatValue(ctx, desc.value, recurseTimes - 1);
		      }
		      if (str.indexOf('\n') > -1) {
		        if (array) {
		          str = str.split('\n').map(function(line) {
		            return '  ' + line;
		          }).join('\n').substr(2);
		        } else {
		          str = '\n' + str.split('\n').map(function(line) {
		            return '   ' + line;
		          }).join('\n');
		        }
		      }
		    } else {
		      str = ctx.stylize('[Circular]', 'special');
		    }
		  }
		  if (isUndefined(name)) {
		    if (array && key.match(/^\d+$/)) {
		      return str;
		    }
		    name = JSON.stringify('' + key);
		    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
		      name = name.substr(1, name.length - 2);
		      name = ctx.stylize(name, 'name');
		    } else {
		      name = name.replace(/'/g, "\\'")
		                 .replace(/\\"/g, '"')
		                 .replace(/(^"|"$)/g, "'");
		      name = ctx.stylize(name, 'string');
		    }
		  }

		  return name + ': ' + str;
		}


		function reduceToSingleString(output, base, braces) {
		  var numLinesEst = 0;
		  var length = output.reduce(function(prev, cur) {
		    numLinesEst++;
		    if (cur.indexOf('\n') >= 0) numLinesEst++;
		    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
		  }, 0);

		  if (length > 60) {
		    return braces[0] +
		           (base === '' ? '' : base + '\n ') +
		           ' ' +
		           output.join(',\n  ') +
		           ' ' +
		           braces[1];
		  }

		  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
		}


		// NOTE: These type checking functions intentionally don't use `instanceof`
		// because it is fragile and can be easily faked with `Object.create()`.
		function isArray(ar) {
		  return Array.isArray(ar);
		}
		exports.isArray = isArray;

		function isBoolean(arg) {
		  return typeof arg === 'boolean';
		}
		exports.isBoolean = isBoolean;

		function isNull(arg) {
		  return arg === null;
		}
		exports.isNull = isNull;

		function isNullOrUndefined(arg) {
		  return arg == null;
		}
		exports.isNullOrUndefined = isNullOrUndefined;

		function isNumber(arg) {
		  return typeof arg === 'number';
		}
		exports.isNumber = isNumber;

		function isString(arg) {
		  return typeof arg === 'string';
		}
		exports.isString = isString;

		function isSymbol(arg) {
		  return typeof arg === 'symbol';
		}
		exports.isSymbol = isSymbol;

		function isUndefined(arg) {
		  return arg === void 0;
		}
		exports.isUndefined = isUndefined;

		function isRegExp(re) {
		  return isObject(re) && objectToString(re) === '[object RegExp]';
		}
		exports.isRegExp = isRegExp;

		function isObject(arg) {
		  return typeof arg === 'object' && arg !== null;
		}
		exports.isObject = isObject;

		function isDate(d) {
		  return isObject(d) && objectToString(d) === '[object Date]';
		}
		exports.isDate = isDate;

		function isError(e) {
		  return isObject(e) &&
		      (objectToString(e) === '[object Error]' || e instanceof Error);
		}
		exports.isError = isError;

		function isFunction(arg) {
		  return typeof arg === 'function';
		}
		exports.isFunction = isFunction;

		function isPrimitive(arg) {
		  return arg === null ||
		         typeof arg === 'boolean' ||
		         typeof arg === 'number' ||
		         typeof arg === 'string' ||
		         typeof arg === 'symbol' ||  // ES6 symbol
		         typeof arg === 'undefined';
		}
		exports.isPrimitive = isPrimitive;

		exports.isBuffer = __webpack_require__(48);

		function objectToString(o) {
		  return Object.prototype.toString.call(o);
		}


		function pad(n) {
		  return n < 10 ? '0' + n.toString(10) : n.toString(10);
		}


		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
		              'Oct', 'Nov', 'Dec'];

		// 26 Feb 16:19:34
		function timestamp() {
		  var d = new Date();
		  var time = [pad(d.getHours()),
		              pad(d.getMinutes()),
		              pad(d.getSeconds())].join(':');
		  return [d.getDate(), months[d.getMonth()], time].join(' ');
		}


		// log is just a thin wrapper to console.log that prepends a timestamp
		exports.log = function() {
		  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
		};


		/**
		 * Inherit the prototype methods from one constructor into another.
		 *
		 * The Function.prototype.inherits from lang.js rewritten as a standalone
		 * function (not on Function.prototype). NOTE: If this file is to be loaded
		 * during bootstrapping this function needs to be rewritten using some native
		 * functions as prototype setup using normal JavaScript does not work as
		 * expected during bootstrapping (see mirror.js in r114903).
		 *
		 * @param {function} ctor Constructor function which needs to inherit the
		 *     prototype.
		 * @param {function} superCtor Constructor function to inherit prototype from.
		 */
		exports.inherits = __webpack_require__(49);

		exports._extend = function(origin, add) {
		  // Don't do anything if add isn't an object
		  if (!add || !isObject(add)) return origin;

		  var keys = Object.keys(add);
		  var i = keys.length;
		  while (i--) {
		    origin[keys[i]] = add[keys[i]];
		  }
		  return origin;
		};

		function hasOwnProperty(obj, prop) {
		  return Object.prototype.hasOwnProperty.call(obj, prop);
		}

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3)))

	/***/ }),
	/* 48 */
	/***/ (function(module, exports) {

		module.exports = function isBuffer(arg) {
		  return arg && typeof arg === 'object'
		    && typeof arg.copy === 'function'
		    && typeof arg.fill === 'function'
		    && typeof arg.readUInt8 === 'function';
		}

	/***/ }),
	/* 49 */
	/***/ (function(module, exports) {

		if (typeof Object.create === 'function') {
		  // implementation from standard node.js 'util' module
		  module.exports = function inherits(ctor, superCtor) {
		    ctor.super_ = superCtor
		    ctor.prototype = Object.create(superCtor.prototype, {
		      constructor: {
		        value: ctor,
		        enumerable: false,
		        writable: true,
		        configurable: true
		      }
		    });
		  };
		} else {
		  // old school shim for old browsers
		  module.exports = function inherits(ctor, superCtor) {
		    ctor.super_ = superCtor
		    var TempCtor = function () {}
		    TempCtor.prototype = superCtor.prototype
		    ctor.prototype = new TempCtor()
		    ctor.prototype.constructor = ctor
		  }
		}


	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(1);
		var AcceptorStateMachine = __webpack_require__(51);
		var inherit = AWS.util.inherit;
		var domain = AWS.util.domain;
		var jmespath = __webpack_require__(52);

		/**
		 * @api private
		 */
		var hardErrorStates = {success: 1, error: 1, complete: 1};

		function isTerminalState(machine) {
		  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
		}

		var fsm = new AcceptorStateMachine();
		fsm.setupStates = function() {
		  var transition = function(_, done) {
		    var self = this;
		    self._haltHandlersOnError = false;

		    self.emit(self._asm.currentState, function(err) {
		      if (err) {
		        if (isTerminalState(self)) {
		          if (domain && self.domain instanceof domain.Domain) {
		            err.domainEmitter = self;
		            err.domain = self.domain;
		            err.domainThrown = false;
		            self.domain.emit('error', err);
		          } else {
		            throw err;
		          }
		        } else {
		          self.response.error = err;
		          done(err);
		        }
		      } else {
		        done(self.response.error);
		      }
		    });

		  };

		  this.addState('validate', 'build', 'error', transition);
		  this.addState('build', 'afterBuild', 'restart', transition);
		  this.addState('afterBuild', 'sign', 'restart', transition);
		  this.addState('sign', 'send', 'retry', transition);
		  this.addState('retry', 'afterRetry', 'afterRetry', transition);
		  this.addState('afterRetry', 'sign', 'error', transition);
		  this.addState('send', 'validateResponse', 'retry', transition);
		  this.addState('validateResponse', 'extractData', 'extractError', transition);
		  this.addState('extractError', 'extractData', 'retry', transition);
		  this.addState('extractData', 'success', 'retry', transition);
		  this.addState('restart', 'build', 'error', transition);
		  this.addState('success', 'complete', 'complete', transition);
		  this.addState('error', 'complete', 'complete', transition);
		  this.addState('complete', null, null, transition);
		};
		fsm.setupStates();

		/**
		 * ## Asynchronous Requests
		 *
		 * All requests made through the SDK are asynchronous and use a
		 * callback interface. Each service method that kicks off a request
		 * returns an `AWS.Request` object that you can use to register
		 * callbacks.
		 *
		 * For example, the following service method returns the request
		 * object as "request", which can be used to register callbacks:
		 *
		 * ```javascript
		 * // request is an AWS.Request object
		 * var request = ec2.describeInstances();
		 *
		 * // register callbacks on request to retrieve response data
		 * request.on('success', function(response) {
		 *   console.log(response.data);
		 * });
		 * ```
		 *
		 * When a request is ready to be sent, the {send} method should
		 * be called:
		 *
		 * ```javascript
		 * request.send();
		 * ```
		 *
		 * Since registered callbacks may or may not be idempotent, requests should only
		 * be sent once. To perform the same operation multiple times, you will need to
		 * create multiple request objects, each with its own registered callbacks.
		 *
		 * ## Removing Default Listeners for Events
		 *
		 * Request objects are built with default listeners for the various events,
		 * depending on the service type. In some cases, you may want to remove
		 * some built-in listeners to customize behaviour. Doing this requires
		 * access to the built-in listener functions, which are exposed through
		 * the {AWS.EventListeners.Core} namespace. For instance, you may
		 * want to customize the HTTP handler used when sending a request. In this
		 * case, you can remove the built-in listener associated with the 'send'
		 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
		 *
		 * ## Multiple Callbacks and Chaining
		 *
		 * You can register multiple callbacks on any request object. The
		 * callbacks can be registered for different events, or all for the
		 * same event. In addition, you can chain callback registration, for
		 * example:
		 *
		 * ```javascript
		 * request.
		 *   on('success', function(response) {
		 *     console.log("Success!");
		 *   }).
		 *   on('error', function(error, response) {
		 *     console.log("Error!");
		 *   }).
		 *   on('complete', function(response) {
		 *     console.log("Always!");
		 *   }).
		 *   send();
		 * ```
		 *
		 * The above example will print either "Success! Always!", or "Error! Always!",
		 * depending on whether the request succeeded or not.
		 *
		 * @!attribute httpRequest
		 *   @readonly
		 *   @!group HTTP Properties
		 *   @return [AWS.HttpRequest] the raw HTTP request object
		 *     containing request headers and body information
		 *     sent by the service.
		 *
		 * @!attribute startTime
		 *   @readonly
		 *   @!group Operation Properties
		 *   @return [Date] the time that the request started
		 *
		 * @!group Request Building Events
		 *
		 * @!event validate(request)
		 *   Triggered when a request is being validated. Listeners
		 *   should throw an error if the request should not be sent.
		 *   @param request [Request] the request object being sent
		 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
		 *   @see AWS.EventListeners.Core.VALIDATE_REGION
		 *   @example Ensuring that a certain parameter is set before sending a request
		 *     var req = s3.putObject(params);
		 *     req.on('validate', function() {
		 *       if (!req.params.Body.match(/^Hello\s/)) {
		 *         throw new Error('Body must start with "Hello "');
		 *       }
		 *     });
		 *     req.send(function(err, data) { ... });
		 *
		 * @!event build(request)
		 *   Triggered when the request payload is being built. Listeners
		 *   should fill the necessary information to send the request
		 *   over HTTP.
		 *   @param (see AWS.Request~validate)
		 *   @example Add a custom HTTP header to a request
		 *     var req = s3.putObject(params);
		 *     req.on('build', function() {
		 *       req.httpRequest.headers['Custom-Header'] = 'value';
		 *     });
		 *     req.send(function(err, data) { ... });
		 *
		 * @!event sign(request)
		 *   Triggered when the request is being signed. Listeners should
		 *   add the correct authentication headers and/or adjust the body,
		 *   depending on the authentication mechanism being used.
		 *   @param (see AWS.Request~validate)
		 *
		 * @!group Request Sending Events
		 *
		 * @!event send(response)
		 *   Triggered when the request is ready to be sent. Listeners
		 *   should call the underlying transport layer to initiate
		 *   the sending of the request.
		 *   @param response [Response] the response object
		 *   @context [Request] the request object that was sent
		 *   @see AWS.EventListeners.Core.SEND
		 *
		 * @!event retry(response)
		 *   Triggered when a request failed and might need to be retried or redirected.
		 *   If the response is retryable, the listener should set the
		 *   `response.error.retryable` property to `true`, and optionally set
		 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
		 *   In the case of a redirect, `response.error.redirect` should be set to
		 *   `true` with `retryDelay` set to an optional delay on the next request.
		 *
		 *   If a listener decides that a request should not be retried,
		 *   it should set both `retryable` and `redirect` to false.
		 *
		 *   Note that a retryable error will be retried at most
		 *   {AWS.Config.maxRetries} times (based on the service object's config).
		 *   Similarly, a request that is redirected will only redirect at most
		 *   {AWS.Config.maxRedirects} times.
		 *
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *   @example Adding a custom retry for a 404 response
		 *     request.on('retry', function(response) {
		 *       // this resource is not yet available, wait 10 seconds to get it again
		 *       if (response.httpResponse.statusCode === 404 && response.error) {
		 *         response.error.retryable = true;   // retry this error
		 *         response.error.retryDelay = 10000; // wait 10 seconds
		 *       }
		 *     });
		 *
		 * @!group Data Parsing Events
		 *
		 * @!event extractError(response)
		 *   Triggered on all non-2xx requests so that listeners can extract
		 *   error details from the response body. Listeners to this event
		 *   should set the `response.error` property.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @!event extractData(response)
		 *   Triggered in successful requests to allow listeners to
		 *   de-serialize the response body into `response.data`.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @!group Completion Events
		 *
		 * @!event success(response)
		 *   Triggered when the request completed successfully.
		 *   `response.data` will contain the response data and
		 *   `response.error` will be null.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @!event error(error, response)
		 *   Triggered when an error occurs at any point during the
		 *   request. `response.error` will contain details about the error
		 *   that occurred. `response.data` will be null.
		 *   @param error [Error] the error object containing details about
		 *     the error that occurred.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @!event complete(response)
		 *   Triggered whenever a request cycle completes. `response.error`
		 *   should be checked, since the request may have failed.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @!group HTTP Events
		 *
		 * @!event httpHeaders(statusCode, headers, response, statusMessage)
		 *   Triggered when headers are sent by the remote server
		 *   @param statusCode [Integer] the HTTP response code
		 *   @param headers [map<String,String>] the response headers
		 *   @param (see AWS.Request~send)
		 *   @param statusMessage [String] A status message corresponding to the HTTP
		 *                                 response code
		 *   @context (see AWS.Request~send)
		 *
		 * @!event httpData(chunk, response)
		 *   Triggered when data is sent by the remote server
		 *   @param chunk [Buffer] the buffer data containing the next data chunk
		 *     from the server
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *   @see AWS.EventListeners.Core.HTTP_DATA
		 *
		 * @!event httpUploadProgress(progress, response)
		 *   Triggered when the HTTP request has uploaded more data
		 *   @param progress [map] An object containing the `loaded` and `total` bytes
		 *     of the request.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *   @note This event will not be emitted in Node.js 0.8.x.
		 *
		 * @!event httpDownloadProgress(progress, response)
		 *   Triggered when the HTTP request has downloaded more data
		 *   @param progress [map] An object containing the `loaded` and `total` bytes
		 *     of the request.
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *   @note This event will not be emitted in Node.js 0.8.x.
		 *
		 * @!event httpError(error, response)
		 *   Triggered when the HTTP request failed
		 *   @param error [Error] the error object that was thrown
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @!event httpDone(response)
		 *   Triggered when the server is finished sending data
		 *   @param (see AWS.Request~send)
		 *   @context (see AWS.Request~send)
		 *
		 * @see AWS.Response
		 */
		AWS.Request = inherit({

		  /**
		   * Creates a request for an operation on a given service with
		   * a set of input parameters.
		   *
		   * @param service [AWS.Service] the service to perform the operation on
		   * @param operation [String] the operation to perform on the service
		   * @param params [Object] parameters to send to the operation.
		   *   See the operation's documentation for the format of the
		   *   parameters.
		   */
		  constructor: function Request(service, operation, params) {
		    var endpoint = service.endpoint;
		    var region = service.config.region;
		    var customUserAgent = service.config.customUserAgent;

		    if (service.signingRegion) {
		      region = service.signingRegion;
		    } else if (service.isGlobalEndpoint) {
		      region = 'us-east-1';
		    }

		    this.domain = domain && domain.active;
		    this.service = service;
		    this.operation = operation;
		    this.params = params || {};
		    this.httpRequest = new AWS.HttpRequest(endpoint, region);
		    this.httpRequest.appendToUserAgent(customUserAgent);
		    this.startTime = service.getSkewCorrectedDate();

		    this.response = new AWS.Response(this);
		    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
		    this._haltHandlersOnError = false;

		    AWS.SequentialExecutor.call(this);
		    this.emit = this.emitEvent;
		  },

		  /**
		   * @!group Sending a Request
		   */

		  /**
		   * @overload send(callback = null)
		   *   Sends the request object.
		   *
		   *   @callback callback function(err, data)
		   *     If a callback is supplied, it is called when a response is returned
		   *     from the service.
		   *     @context [AWS.Request] the request object being sent.
		   *     @param err [Error] the error object returned from the request.
		   *       Set to `null` if the request is successful.
		   *     @param data [Object] the de-serialized data returned from
		   *       the request. Set to `null` if a request error occurs.
		   *   @example Sending a request with a callback
		   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
		   *     request.send(function(err, data) { console.log(err, data); });
		   *   @example Sending a request with no callback (using event handlers)
		   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
		   *     request.on('complete', function(response) { ... }); // register a callback
		   *     request.send();
		   */
		  send: function send(callback) {
		    if (callback) {
		      // append to user agent
		      this.httpRequest.appendToUserAgent('callback');
		      this.on('complete', function (resp) {
		        callback.call(resp, resp.error, resp.data);
		      });
		    }
		    this.runTo();

		    return this.response;
		  },

		  /**
		   * @!method  promise()
		   *   Sends the request and returns a 'thenable' promise.
		   *
		   *   Two callbacks can be provided to the `then` method on the returned promise.
		   *   The first callback will be called if the promise is fulfilled, and the second
		   *   callback will be called if the promise is rejected.
		   *   @callback fulfilledCallback function(data)
		   *     Called if the promise is fulfilled.
		   *     @param data [Object] the de-serialized data returned from the request.
		   *   @callback rejectedCallback function(error)
		   *     Called if the promise is rejected.
		   *     @param error [Error] the error object returned from the request.
		   *   @return [Promise] A promise that represents the state of the request.
		   *   @example Sending a request using promises.
		   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
		   *     var result = request.promise();
		   *     result.then(function(data) { ... }, function(error) { ... });
		   */

		  /**
		   * @api private
		   */
		  build: function build(callback) {
		    return this.runTo('send', callback);
		  },

		  /**
		   * @api private
		   */
		  runTo: function runTo(state, done) {
		    this._asm.runTo(state, done, this);
		    return this;
		  },

		  /**
		   * Aborts a request, emitting the error and complete events.
		   *
		   * @!macro nobrowser
		   * @example Aborting a request after sending
		   *   var params = {
		   *     Bucket: 'bucket', Key: 'key',
		   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
		   *   };
		   *   var request = s3.putObject(params);
		   *   request.send(function (err, data) {
		   *     if (err) console.log("Error:", err.code, err.message);
		   *     else console.log(data);
		   *   });
		   *
		   *   // abort request in 1 second
		   *   setTimeout(request.abort.bind(request), 1000);
		   *
		   *   // prints "Error: RequestAbortedError Request aborted by user"
		   * @return [AWS.Request] the same request object, for chaining.
		   * @since v1.4.0
		   */
		  abort: function abort() {
		    this.removeAllListeners('validateResponse');
		    this.removeAllListeners('extractError');
		    this.on('validateResponse', function addAbortedError(resp) {
		      resp.error = AWS.util.error(new Error('Request aborted by user'), {
		         code: 'RequestAbortedError', retryable: false
		      });
		    });

		    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
		      this.httpRequest.stream.abort();
		      if (this.httpRequest._abortCallback) {
		         this.httpRequest._abortCallback();
		      } else {
		        this.removeAllListeners('send'); // haven't sent yet, so let's not
		      }
		    }

		    return this;
		  },

		  /**
		   * Iterates over each page of results given a pageable request, calling
		   * the provided callback with each page of data. After all pages have been
		   * retrieved, the callback is called with `null` data.
		   *
		   * @note This operation can generate multiple requests to a service.
		   * @example Iterating over multiple pages of objects in an S3 bucket
		   *   var pages = 1;
		   *   s3.listObjects().eachPage(function(err, data) {
		   *     if (err) return;
		   *     console.log("Page", pages++);
		   *     console.log(data);
		   *   });
		   * @example Iterating over multiple pages with an asynchronous callback
		   *   s3.listObjects(params).eachPage(function(err, data, done) {
		   *     doSomethingAsyncAndOrExpensive(function() {
		   *       // The next page of results isn't fetched until done is called
		   *       done();
		   *     });
		   *   });
		   * @callback callback function(err, data, [doneCallback])
		   *   Called with each page of resulting data from the request. If the
		   *   optional `doneCallback` is provided in the function, it must be called
		   *   when the callback is complete.
		   *
		   *   @param err [Error] an error object, if an error occurred.
		   *   @param data [Object] a single page of response data. If there is no
		   *     more data, this object will be `null`.
		   *   @param doneCallback [Function] an optional done callback. If this
		   *     argument is defined in the function declaration, it should be called
		   *     when the next page is ready to be retrieved. This is useful for
		   *     controlling serial pagination across asynchronous operations.
		   *   @return [Boolean] if the callback returns `false`, pagination will
		   *     stop.
		   *
		   * @see AWS.Request.eachItem
		   * @see AWS.Response.nextPage
		   * @since v1.4.0
		   */
		  eachPage: function eachPage(callback) {
		    // Make all callbacks async-ish
		    callback = AWS.util.fn.makeAsync(callback, 3);

		    function wrappedCallback(response) {
		      callback.call(response, response.error, response.data, function (result) {
		        if (result === false) return;

		        if (response.hasNextPage()) {
		          response.nextPage().on('complete', wrappedCallback).send();
		        } else {
		          callback.call(response, null, null, AWS.util.fn.noop);
		        }
		      });
		    }

		    this.on('complete', wrappedCallback).send();
		  },

		  /**
		   * Enumerates over individual items of a request, paging the responses if
		   * necessary.
		   *
		   * @api experimental
		   * @since v1.4.0
		   */
		  eachItem: function eachItem(callback) {
		    var self = this;
		    function wrappedCallback(err, data) {
		      if (err) return callback(err, null);
		      if (data === null) return callback(null, null);

		      var config = self.service.paginationConfig(self.operation);
		      var resultKey = config.resultKey;
		      if (Array.isArray(resultKey)) resultKey = resultKey[0];
		      var items = jmespath.search(data, resultKey);
		      var continueIteration = true;
		      AWS.util.arrayEach(items, function(item) {
		        continueIteration = callback(null, item);
		        if (continueIteration === false) {
		          return AWS.util.abort;
		        }
		      });
		      return continueIteration;
		    }

		    this.eachPage(wrappedCallback);
		  },

		  /**
		   * @return [Boolean] whether the operation can return multiple pages of
		   *   response data.
		   * @see AWS.Response.eachPage
		   * @since v1.4.0
		   */
		  isPageable: function isPageable() {
		    return this.service.paginationConfig(this.operation) ? true : false;
		  },

		  /**
		   * Sends the request and converts the request object into a readable stream
		   * that can be read from or piped into a writable stream.
		   *
		   * @note The data read from a readable stream contains only
		   *   the raw HTTP body contents.
		   * @example Manually reading from a stream
		   *   request.createReadStream().on('data', function(data) {
		   *     console.log("Got data:", data.toString());
		   *   });
		   * @example Piping a request body into a file
		   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
		   *   s3.service.getObject(params).createReadStream().pipe(out);
		   * @return [Stream] the readable stream object that can be piped
		   *   or read from (by registering 'data' event listeners).
		   * @!macro nobrowser
		   */
		  createReadStream: function createReadStream() {
		    var streams = AWS.util.stream;
		    var req = this;
		    var stream = null;

		    if (AWS.HttpClient.streamsApiVersion === 2) {
		      stream = new streams.PassThrough();
		      process.nextTick(function() { req.send(); });
		    } else {
		      stream = new streams.Stream();
		      stream.readable = true;

		      stream.sent = false;
		      stream.on('newListener', function(event) {
		        if (!stream.sent && event === 'data') {
		          stream.sent = true;
		          process.nextTick(function() { req.send(); });
		        }
		      });
		    }

		    this.on('error', function(err) {
		      stream.emit('error', err);
		    });

		    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
		      if (statusCode < 300) {
		        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
		        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
		        req.on('httpError', function streamHttpError(error) {
		          resp.error = error;
		          resp.error.retryable = false;
		        });

		        var shouldCheckContentLength = false;
		        var expectedLen;
		        if (req.httpRequest.method !== 'HEAD') {
		          expectedLen = parseInt(headers['content-length'], 10);
		        }
		        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
		          shouldCheckContentLength = true;
		          var receivedLen = 0;
		        }

		        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
		          if (shouldCheckContentLength && receivedLen !== expectedLen) {
		            stream.emit('error', AWS.util.error(
		              new Error('Stream content length mismatch. Received ' +
		                receivedLen + ' of ' + expectedLen + ' bytes.'),
		              { code: 'StreamContentLengthMismatch' }
		            ));
		          } else if (AWS.HttpClient.streamsApiVersion === 2) {
		            stream.end();
		          } else {
		            stream.emit('end');
		          }
		        };

		        var httpStream = resp.httpResponse.createUnbufferedStream();

		        if (AWS.HttpClient.streamsApiVersion === 2) {
		          if (shouldCheckContentLength) {
		            var lengthAccumulator = new streams.PassThrough();
		            lengthAccumulator._write = function(chunk) {
		              if (chunk && chunk.length) {
		                receivedLen += chunk.length;
		              }
		              return streams.PassThrough.prototype._write.apply(this, arguments);
		            };

		            lengthAccumulator.on('end', checkContentLengthAndEmit);
		            stream.on('error', function(err) {
		              shouldCheckContentLength = false;
		              httpStream.unpipe(lengthAccumulator);
		              lengthAccumulator.emit('end');
		              lengthAccumulator.end();
		            });
		            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
		          } else {
		            httpStream.pipe(stream);
		          }
		        } else {

		          if (shouldCheckContentLength) {
		            httpStream.on('data', function(arg) {
		              if (arg && arg.length) {
		                receivedLen += arg.length;
		              }
		            });
		          }

		          httpStream.on('data', function(arg) {
		            stream.emit('data', arg);
		          });
		          httpStream.on('end', checkContentLengthAndEmit);
		        }

		        httpStream.on('error', function(err) {
		          shouldCheckContentLength = false;
		          stream.emit('error', err);
		        });
		      }
		    });

		    return stream;
		  },

		  /**
		   * @param [Array,Response] args This should be the response object,
		   *   or an array of args to send to the event.
		   * @api private
		   */
		  emitEvent: function emit(eventName, args, done) {
		    if (typeof args === 'function') { done = args; args = null; }
		    if (!done) done = function() { };
		    if (!args) args = this.eventParameters(eventName, this.response);

		    var origEmit = AWS.SequentialExecutor.prototype.emit;
		    origEmit.call(this, eventName, args, function (err) {
		      if (err) this.response.error = err;
		      done.call(this, err);
		    });
		  },

		  /**
		   * @api private
		   */
		  eventParameters: function eventParameters(eventName) {
		    switch (eventName) {
		      case 'restart':
		      case 'validate':
		      case 'sign':
		      case 'build':
		      case 'afterValidate':
		      case 'afterBuild':
		        return [this];
		      case 'error':
		        return [this.response.error, this.response];
		      default:
		        return [this.response];
		    }
		  },

		  /**
		   * @api private
		   */
		  presign: function presign(expires, callback) {
		    if (!callback && typeof expires === 'function') {
		      callback = expires;
		      expires = null;
		    }
		    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
		  },

		  /**
		   * @api private
		   */
		  isPresigned: function isPresigned() {
		    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
		  },

		  /**
		   * @api private
		   */
		  toUnauthenticated: function toUnauthenticated() {
		    this._unAuthenticated = true;
		    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
		    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
		    return this;
		  },

		  /**
		   * @api private
		   */
		  toGet: function toGet() {
		    if (this.service.api.protocol === 'query' ||
		        this.service.api.protocol === 'ec2') {
		      this.removeListener('build', this.buildAsGet);
		      this.addListener('build', this.buildAsGet);
		    }
		    return this;
		  },

		  /**
		   * @api private
		   */
		  buildAsGet: function buildAsGet(request) {
		    request.httpRequest.method = 'GET';
		    request.httpRequest.path = request.service.endpoint.path +
		                               '?' + request.httpRequest.body;
		    request.httpRequest.body = '';

		    // don't need these headers on a GET request
		    delete request.httpRequest.headers['Content-Length'];
		    delete request.httpRequest.headers['Content-Type'];
		  },

		  /**
		   * @api private
		   */
		  haltHandlersOnError: function haltHandlersOnError() {
		    this._haltHandlersOnError = true;
		  }
		});

		/**
		 * @api private
		 */
		AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
		  this.prototype.promise = function promise() {
		    var self = this;
		    // append to user agent
		    this.httpRequest.appendToUserAgent('promise');
		    return new PromiseDependency(function(resolve, reject) {
		      self.on('complete', function(resp) {
		        if (resp.error) {
		          reject(resp.error);
		        } else {
		          // define $response property so that it is not enumerable
		          // this prevents circular reference errors when stringifying the JSON object
		          resolve(Object.defineProperty(
		            resp.data || {},
		            '$response',
		            {value: resp}
		          ));
		        }
		      });
		      self.runTo();
		    });
		  };
		};

		/**
		 * @api private
		 */
		AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
		  delete this.prototype.promise;
		};

		AWS.util.addPromises(AWS.Request);

		AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);

		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {

		function AcceptorStateMachine(states, state) {
		  this.currentState = state || null;
		  this.states = states || {};
		}

		AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
		  if (typeof finalState === 'function') {
		    inputError = bindObject; bindObject = done;
		    done = finalState; finalState = null;
		  }

		  var self = this;
		  var state = self.states[self.currentState];
		  state.fn.call(bindObject || self, inputError, function(err) {
		    if (err) {
		      if (state.fail) self.currentState = state.fail;
		      else return done ? done.call(bindObject, err) : null;
		    } else {
		      if (state.accept) self.currentState = state.accept;
		      else return done ? done.call(bindObject) : null;
		    }
		    if (self.currentState === finalState) {
		      return done ? done.call(bindObject, err) : null;
		    }

		    self.runTo(finalState, done, bindObject, err);
		  });
		};

		AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
		  if (typeof acceptState === 'function') {
		    fn = acceptState; acceptState = null; failState = null;
		  } else if (typeof failState === 'function') {
		    fn = failState; failState = null;
		  }

		  if (!this.currentState) this.currentState = name;
		  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
		  return this;
		};

		/**
		 * @api private
		 */
		module.exports = AcceptorStateMachine;


	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {

		(function(exports) {
		  "use strict";

		  function isArray(obj) {
		    if (obj !== null) {
		      return Object.prototype.toString.call(obj) === "[object Array]";
		    } else {
		      return false;
		    }
		  }

		  function isObject(obj) {
		    if (obj !== null) {
		      return Object.prototype.toString.call(obj) === "[object Object]";
		    } else {
		      return false;
		    }
		  }

		  function strictDeepEqual(first, second) {
		    // Check the scalar case first.
		    if (first === second) {
		      return true;
		    }

		    // Check if they are the same type.
		    var firstType = Object.prototype.toString.call(first);
		    if (firstType !== Object.prototype.toString.call(second)) {
		      return false;
		    }
		    // We know that first and second have the same type so we can just check the
		    // first type from now on.
		    if (isArray(first) === true) {
		      // Short circuit if they're not the same length;
		      if (first.length !== second.length) {
		        return false;
		      }
		      for (var i = 0; i < first.length; i++) {
		        if (strictDeepEqual(first[i], second[i]) === false) {
		          return false;
		        }
		      }
		      return true;
		    }
		    if (isObject(first) === true) {
		      // An object is equal if it has the same key/value pairs.
		      var keysSeen = {};
		      for (var key in first) {
		        if (hasOwnProperty.call(first, key)) {
		          if (strictDeepEqual(first[key], second[key]) === false) {
		            return false;
		          }
		          keysSeen[key] = true;
		        }
		      }
		      // Now check that there aren't any keys in second that weren't
		      // in first.
		      for (var key2 in second) {
		        if (hasOwnProperty.call(second, key2)) {
		          if (keysSeen[key2] !== true) {
		            return false;
		          }
		        }
		      }
		      return true;
		    }
		    return false;
		  }

		  function isFalse(obj) {
		    // From the spec:
		    // A false value corresponds to the following values:
		    // Empty list
		    // Empty object
		    // Empty string
		    // False boolean
		    // null value

		    // First check the scalar values.
		    if (obj === "" || obj === false || obj === null) {
		        return true;
		    } else if (isArray(obj) && obj.length === 0) {
		        // Check for an empty array.
		        return true;
		    } else if (isObject(obj)) {
		        // Check for an empty object.
		        for (var key in obj) {
		            // If there are any keys, then
		            // the object is not empty so the object
		            // is not false.
		            if (obj.hasOwnProperty(key)) {
		              return false;
		            }
		        }
		        return true;
		    } else {
		        return false;
		    }
		  }

		  function objValues(obj) {
		    var keys = Object.keys(obj);
		    var values = [];
		    for (var i = 0; i < keys.length; i++) {
		      values.push(obj[keys[i]]);
		    }
		    return values;
		  }

		  function merge(a, b) {
		      var merged = {};
		      for (var key in a) {
		          merged[key] = a[key];
		      }
		      for (var key2 in b) {
		          merged[key2] = b[key2];
		      }
		      return merged;
		  }

		  var trimLeft;
		  if (typeof String.prototype.trimLeft === "function") {
		    trimLeft = function(str) {
		      return str.trimLeft();
		    };
		  } else {
		    trimLeft = function(str) {
		      return str.match(/^\s*(.*)/)[1];
		    };
		  }

		  // Type constants used to define functions.
		  var TYPE_NUMBER = 0;
		  var TYPE_ANY = 1;
		  var TYPE_STRING = 2;
		  var TYPE_ARRAY = 3;
		  var TYPE_OBJECT = 4;
		  var TYPE_BOOLEAN = 5;
		  var TYPE_EXPREF = 6;
		  var TYPE_NULL = 7;
		  var TYPE_ARRAY_NUMBER = 8;
		  var TYPE_ARRAY_STRING = 9;
		  var TYPE_NAME_TABLE = {
		    0: 'number',
		    1: 'any',
		    2: 'string',
		    3: 'array',
		    4: 'object',
		    5: 'boolean',
		    6: 'expression',
		    7: 'null',
		    8: 'Array<number>',
		    9: 'Array<string>'
		  };

		  var TOK_EOF = "EOF";
		  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
		  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
		  var TOK_RBRACKET = "Rbracket";
		  var TOK_RPAREN = "Rparen";
		  var TOK_COMMA = "Comma";
		  var TOK_COLON = "Colon";
		  var TOK_RBRACE = "Rbrace";
		  var TOK_NUMBER = "Number";
		  var TOK_CURRENT = "Current";
		  var TOK_EXPREF = "Expref";
		  var TOK_PIPE = "Pipe";
		  var TOK_OR = "Or";
		  var TOK_AND = "And";
		  var TOK_EQ = "EQ";
		  var TOK_GT = "GT";
		  var TOK_LT = "LT";
		  var TOK_GTE = "GTE";
		  var TOK_LTE = "LTE";
		  var TOK_NE = "NE";
		  var TOK_FLATTEN = "Flatten";
		  var TOK_STAR = "Star";
		  var TOK_FILTER = "Filter";
		  var TOK_DOT = "Dot";
		  var TOK_NOT = "Not";
		  var TOK_LBRACE = "Lbrace";
		  var TOK_LBRACKET = "Lbracket";
		  var TOK_LPAREN= "Lparen";
		  var TOK_LITERAL= "Literal";

		  // The "&", "[", "<", ">" tokens
		  // are not in basicToken because
		  // there are two token variants
		  // ("&&", "[?", "<=", ">=").  This is specially handled
		  // below.

		  var basicTokens = {
		    ".": TOK_DOT,
		    "*": TOK_STAR,
		    ",": TOK_COMMA,
		    ":": TOK_COLON,
		    "{": TOK_LBRACE,
		    "}": TOK_RBRACE,
		    "]": TOK_RBRACKET,
		    "(": TOK_LPAREN,
		    ")": TOK_RPAREN,
		    "@": TOK_CURRENT
		  };

		  var operatorStartToken = {
		      "<": true,
		      ">": true,
		      "=": true,
		      "!": true
		  };

		  var skipChars = {
		      " ": true,
		      "\t": true,
		      "\n": true
		  };


		  function isAlpha(ch) {
		      return (ch >= "a" && ch <= "z") ||
		             (ch >= "A" && ch <= "Z") ||
		             ch === "_";
		  }

		  function isNum(ch) {
		      return (ch >= "0" && ch <= "9") ||
		             ch === "-";
		  }
		  function isAlphaNum(ch) {
		      return (ch >= "a" && ch <= "z") ||
		             (ch >= "A" && ch <= "Z") ||
		             (ch >= "0" && ch <= "9") ||
		             ch === "_";
		  }

		  function Lexer() {
		  }
		  Lexer.prototype = {
		      tokenize: function(stream) {
		          var tokens = [];
		          this._current = 0;
		          var start;
		          var identifier;
		          var token;
		          while (this._current < stream.length) {
		              if (isAlpha(stream[this._current])) {
		                  start = this._current;
		                  identifier = this._consumeUnquotedIdentifier(stream);
		                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
		                               value: identifier,
		                               start: start});
		              } else if (basicTokens[stream[this._current]] !== undefined) {
		                  tokens.push({type: basicTokens[stream[this._current]],
		                              value: stream[this._current],
		                              start: this._current});
		                  this._current++;
		              } else if (isNum(stream[this._current])) {
		                  token = this._consumeNumber(stream);
		                  tokens.push(token);
		              } else if (stream[this._current] === "[") {
		                  // No need to increment this._current.  This happens
		                  // in _consumeLBracket
		                  token = this._consumeLBracket(stream);
		                  tokens.push(token);
		              } else if (stream[this._current] === "\"") {
		                  start = this._current;
		                  identifier = this._consumeQuotedIdentifier(stream);
		                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
		                               value: identifier,
		                               start: start});
		              } else if (stream[this._current] === "'") {
		                  start = this._current;
		                  identifier = this._consumeRawStringLiteral(stream);
		                  tokens.push({type: TOK_LITERAL,
		                               value: identifier,
		                               start: start});
		              } else if (stream[this._current] === "`") {
		                  start = this._current;
		                  var literal = this._consumeLiteral(stream);
		                  tokens.push({type: TOK_LITERAL,
		                               value: literal,
		                               start: start});
		              } else if (operatorStartToken[stream[this._current]] !== undefined) {
		                  tokens.push(this._consumeOperator(stream));
		              } else if (skipChars[stream[this._current]] !== undefined) {
		                  // Ignore whitespace.
		                  this._current++;
		              } else if (stream[this._current] === "&") {
		                  start = this._current;
		                  this._current++;
		                  if (stream[this._current] === "&") {
		                      this._current++;
		                      tokens.push({type: TOK_AND, value: "&&", start: start});
		                  } else {
		                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
		                  }
		              } else if (stream[this._current] === "|") {
		                  start = this._current;
		                  this._current++;
		                  if (stream[this._current] === "|") {
		                      this._current++;
		                      tokens.push({type: TOK_OR, value: "||", start: start});
		                  } else {
		                      tokens.push({type: TOK_PIPE, value: "|", start: start});
		                  }
		              } else {
		                  var error = new Error("Unknown character:" + stream[this._current]);
		                  error.name = "LexerError";
		                  throw error;
		              }
		          }
		          return tokens;
		      },

		      _consumeUnquotedIdentifier: function(stream) {
		          var start = this._current;
		          this._current++;
		          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
		              this._current++;
		          }
		          return stream.slice(start, this._current);
		      },

		      _consumeQuotedIdentifier: function(stream) {
		          var start = this._current;
		          this._current++;
		          var maxLength = stream.length;
		          while (stream[this._current] !== "\"" && this._current < maxLength) {
		              // You can escape a double quote and you can escape an escape.
		              var current = this._current;
		              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
		                                               stream[current + 1] === "\"")) {
		                  current += 2;
		              } else {
		                  current++;
		              }
		              this._current = current;
		          }
		          this._current++;
		          return JSON.parse(stream.slice(start, this._current));
		      },

		      _consumeRawStringLiteral: function(stream) {
		          var start = this._current;
		          this._current++;
		          var maxLength = stream.length;
		          while (stream[this._current] !== "'" && this._current < maxLength) {
		              // You can escape a single quote and you can escape an escape.
		              var current = this._current;
		              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
		                                               stream[current + 1] === "'")) {
		                  current += 2;
		              } else {
		                  current++;
		              }
		              this._current = current;
		          }
		          this._current++;
		          var literal = stream.slice(start + 1, this._current - 1);
		          return literal.replace("\\'", "'");
		      },

		      _consumeNumber: function(stream) {
		          var start = this._current;
		          this._current++;
		          var maxLength = stream.length;
		          while (isNum(stream[this._current]) && this._current < maxLength) {
		              this._current++;
		          }
		          var value = parseInt(stream.slice(start, this._current));
		          return {type: TOK_NUMBER, value: value, start: start};
		      },

		      _consumeLBracket: function(stream) {
		          var start = this._current;
		          this._current++;
		          if (stream[this._current] === "?") {
		              this._current++;
		              return {type: TOK_FILTER, value: "[?", start: start};
		          } else if (stream[this._current] === "]") {
		              this._current++;
		              return {type: TOK_FLATTEN, value: "[]", start: start};
		          } else {
		              return {type: TOK_LBRACKET, value: "[", start: start};
		          }
		      },

		      _consumeOperator: function(stream) {
		          var start = this._current;
		          var startingChar = stream[start];
		          this._current++;
		          if (startingChar === "!") {
		              if (stream[this._current] === "=") {
		                  this._current++;
		                  return {type: TOK_NE, value: "!=", start: start};
		              } else {
		                return {type: TOK_NOT, value: "!", start: start};
		              }
		          } else if (startingChar === "<") {
		              if (stream[this._current] === "=") {
		                  this._current++;
		                  return {type: TOK_LTE, value: "<=", start: start};
		              } else {
		                  return {type: TOK_LT, value: "<", start: start};
		              }
		          } else if (startingChar === ">") {
		              if (stream[this._current] === "=") {
		                  this._current++;
		                  return {type: TOK_GTE, value: ">=", start: start};
		              } else {
		                  return {type: TOK_GT, value: ">", start: start};
		              }
		          } else if (startingChar === "=") {
		              if (stream[this._current] === "=") {
		                  this._current++;
		                  return {type: TOK_EQ, value: "==", start: start};
		              }
		          }
		      },

		      _consumeLiteral: function(stream) {
		          this._current++;
		          var start = this._current;
		          var maxLength = stream.length;
		          var literal;
		          while(stream[this._current] !== "`" && this._current < maxLength) {
		              // You can escape a literal char or you can escape the escape.
		              var current = this._current;
		              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
		                                               stream[current + 1] === "`")) {
		                  current += 2;
		              } else {
		                  current++;
		              }
		              this._current = current;
		          }
		          var literalString = trimLeft(stream.slice(start, this._current));
		          literalString = literalString.replace("\\`", "`");
		          if (this._looksLikeJSON(literalString)) {
		              literal = JSON.parse(literalString);
		          } else {
		              // Try to JSON parse it as "<literal>"
		              literal = JSON.parse("\"" + literalString + "\"");
		          }
		          // +1 gets us to the ending "`", +1 to move on to the next char.
		          this._current++;
		          return literal;
		      },

		      _looksLikeJSON: function(literalString) {
		          var startingChars = "[{\"";
		          var jsonLiterals = ["true", "false", "null"];
		          var numberLooking = "-0123456789";

		          if (literalString === "") {
		              return false;
		          } else if (startingChars.indexOf(literalString[0]) >= 0) {
		              return true;
		          } else if (jsonLiterals.indexOf(literalString) >= 0) {
		              return true;
		          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
		              try {
		                  JSON.parse(literalString);
		                  return true;
		              } catch (ex) {
		                  return false;
		              }
		          } else {
		              return false;
		          }
		      }
		  };

		      var bindingPower = {};
		      bindingPower[TOK_EOF] = 0;
		      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
		      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
		      bindingPower[TOK_RBRACKET] = 0;
		      bindingPower[TOK_RPAREN] = 0;
		      bindingPower[TOK_COMMA] = 0;
		      bindingPower[TOK_RBRACE] = 0;
		      bindingPower[TOK_NUMBER] = 0;
		      bindingPower[TOK_CURRENT] = 0;
		      bindingPower[TOK_EXPREF] = 0;
		      bindingPower[TOK_PIPE] = 1;
		      bindingPower[TOK_OR] = 2;
		      bindingPower[TOK_AND] = 3;
		      bindingPower[TOK_EQ] = 5;
		      bindingPower[TOK_GT] = 5;
		      bindingPower[TOK_LT] = 5;
		      bindingPower[TOK_GTE] = 5;
		      bindingPower[TOK_LTE] = 5;
		      bindingPower[TOK_NE] = 5;
		      bindingPower[TOK_FLATTEN] = 9;
		      bindingPower[TOK_STAR] = 20;
		      bindingPower[TOK_FILTER] = 21;
		      bindingPower[TOK_DOT] = 40;
		      bindingPower[TOK_NOT] = 45;
		      bindingPower[TOK_LBRACE] = 50;
		      bindingPower[TOK_LBRACKET] = 55;
		      bindingPower[TOK_LPAREN] = 60;

		  function Parser() {
		  }

		  Parser.prototype = {
		      parse: function(expression) {
		          this._loadTokens(expression);
		          this.index = 0;
		          var ast = this.expression(0);
		          if (this._lookahead(0) !== TOK_EOF) {
		              var t = this._lookaheadToken(0);
		              var error = new Error(
		                  "Unexpected token type: " + t.type + ", value: " + t.value);
		              error.name = "ParserError";
		              throw error;
		          }
		          return ast;
		      },

		      _loadTokens: function(expression) {
		          var lexer = new Lexer();
		          var tokens = lexer.tokenize(expression);
		          tokens.push({type: TOK_EOF, value: "", start: expression.length});
		          this.tokens = tokens;
		      },

		      expression: function(rbp) {
		          var leftToken = this._lookaheadToken(0);
		          this._advance();
		          var left = this.nud(leftToken);
		          var currentToken = this._lookahead(0);
		          while (rbp < bindingPower[currentToken]) {
		              this._advance();
		              left = this.led(currentToken, left);
		              currentToken = this._lookahead(0);
		          }
		          return left;
		      },

		      _lookahead: function(number) {
		          return this.tokens[this.index + number].type;
		      },

		      _lookaheadToken: function(number) {
		          return this.tokens[this.index + number];
		      },

		      _advance: function() {
		          this.index++;
		      },

		      nud: function(token) {
		        var left;
		        var right;
		        var expression;
		        switch (token.type) {
		          case TOK_LITERAL:
		            return {type: "Literal", value: token.value};
		          case TOK_UNQUOTEDIDENTIFIER:
		            return {type: "Field", name: token.value};
		          case TOK_QUOTEDIDENTIFIER:
		            var node = {type: "Field", name: token.value};
		            if (this._lookahead(0) === TOK_LPAREN) {
		                throw new Error("Quoted identifier not allowed for function names.");
		            }
		            return node;
		          case TOK_NOT:
		            right = this.expression(bindingPower.Not);
		            return {type: "NotExpression", children: [right]};
		          case TOK_STAR:
		            left = {type: "Identity"};
		            right = null;
		            if (this._lookahead(0) === TOK_RBRACKET) {
		                // This can happen in a multiselect,
		                // [a, b, *]
		                right = {type: "Identity"};
		            } else {
		                right = this._parseProjectionRHS(bindingPower.Star);
		            }
		            return {type: "ValueProjection", children: [left, right]};
		          case TOK_FILTER:
		            return this.led(token.type, {type: "Identity"});
		          case TOK_LBRACE:
		            return this._parseMultiselectHash();
		          case TOK_FLATTEN:
		            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
		            right = this._parseProjectionRHS(bindingPower.Flatten);
		            return {type: "Projection", children: [left, right]};
		          case TOK_LBRACKET:
		            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
		                right = this._parseIndexExpression();
		                return this._projectIfSlice({type: "Identity"}, right);
		            } else if (this._lookahead(0) === TOK_STAR &&
		                       this._lookahead(1) === TOK_RBRACKET) {
		                this._advance();
		                this._advance();
		                right = this._parseProjectionRHS(bindingPower.Star);
		                return {type: "Projection",
		                        children: [{type: "Identity"}, right]};
		            }
		            return this._parseMultiselectList();
		          case TOK_CURRENT:
		            return {type: TOK_CURRENT};
		          case TOK_EXPREF:
		            expression = this.expression(bindingPower.Expref);
		            return {type: "ExpressionReference", children: [expression]};
		          case TOK_LPAREN:
		            var args = [];
		            while (this._lookahead(0) !== TOK_RPAREN) {
		              if (this._lookahead(0) === TOK_CURRENT) {
		                expression = {type: TOK_CURRENT};
		                this._advance();
		              } else {
		                expression = this.expression(0);
		              }
		              args.push(expression);
		            }
		            this._match(TOK_RPAREN);
		            return args[0];
		          default:
		            this._errorToken(token);
		        }
		      },

		      led: function(tokenName, left) {
		        var right;
		        switch(tokenName) {
		          case TOK_DOT:
		            var rbp = bindingPower.Dot;
		            if (this._lookahead(0) !== TOK_STAR) {
		                right = this._parseDotRHS(rbp);
		                return {type: "Subexpression", children: [left, right]};
		            }
		            // Creating a projection.
		            this._advance();
		            right = this._parseProjectionRHS(rbp);
		            return {type: "ValueProjection", children: [left, right]};
		          case TOK_PIPE:
		            right = this.expression(bindingPower.Pipe);
		            return {type: TOK_PIPE, children: [left, right]};
		          case TOK_OR:
		            right = this.expression(bindingPower.Or);
		            return {type: "OrExpression", children: [left, right]};
		          case TOK_AND:
		            right = this.expression(bindingPower.And);
		            return {type: "AndExpression", children: [left, right]};
		          case TOK_LPAREN:
		            var name = left.name;
		            var args = [];
		            var expression, node;
		            while (this._lookahead(0) !== TOK_RPAREN) {
		              if (this._lookahead(0) === TOK_CURRENT) {
		                expression = {type: TOK_CURRENT};
		                this._advance();
		              } else {
		                expression = this.expression(0);
		              }
		              if (this._lookahead(0) === TOK_COMMA) {
		                this._match(TOK_COMMA);
		              }
		              args.push(expression);
		            }
		            this._match(TOK_RPAREN);
		            node = {type: "Function", name: name, children: args};
		            return node;
		          case TOK_FILTER:
		            var condition = this.expression(0);
		            this._match(TOK_RBRACKET);
		            if (this._lookahead(0) === TOK_FLATTEN) {
		              right = {type: "Identity"};
		            } else {
		              right = this._parseProjectionRHS(bindingPower.Filter);
		            }
		            return {type: "FilterProjection", children: [left, right, condition]};
		          case TOK_FLATTEN:
		            var leftNode = {type: TOK_FLATTEN, children: [left]};
		            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
		            return {type: "Projection", children: [leftNode, rightNode]};
		          case TOK_EQ:
		          case TOK_NE:
		          case TOK_GT:
		          case TOK_GTE:
		          case TOK_LT:
		          case TOK_LTE:
		            return this._parseComparator(left, tokenName);
		          case TOK_LBRACKET:
		            var token = this._lookaheadToken(0);
		            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
		                right = this._parseIndexExpression();
		                return this._projectIfSlice(left, right);
		            }
		            this._match(TOK_STAR);
		            this._match(TOK_RBRACKET);
		            right = this._parseProjectionRHS(bindingPower.Star);
		            return {type: "Projection", children: [left, right]};
		          default:
		            this._errorToken(this._lookaheadToken(0));
		        }
		      },

		      _match: function(tokenType) {
		          if (this._lookahead(0) === tokenType) {
		              this._advance();
		          } else {
		              var t = this._lookaheadToken(0);
		              var error = new Error("Expected " + tokenType + ", got: " + t.type);
		              error.name = "ParserError";
		              throw error;
		          }
		      },

		      _errorToken: function(token) {
		          var error = new Error("Invalid token (" +
		                                token.type + "): \"" +
		                                token.value + "\"");
		          error.name = "ParserError";
		          throw error;
		      },


		      _parseIndexExpression: function() {
		          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
		              return this._parseSliceExpression();
		          } else {
		              var node = {
		                  type: "Index",
		                  value: this._lookaheadToken(0).value};
		              this._advance();
		              this._match(TOK_RBRACKET);
		              return node;
		          }
		      },

		      _projectIfSlice: function(left, right) {
		          var indexExpr = {type: "IndexExpression", children: [left, right]};
		          if (right.type === "Slice") {
		              return {
		                  type: "Projection",
		                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
		              };
		          } else {
		              return indexExpr;
		          }
		      },

		      _parseSliceExpression: function() {
		          // [start:end:step] where each part is optional, as well as the last
		          // colon.
		          var parts = [null, null, null];
		          var index = 0;
		          var currentToken = this._lookahead(0);
		          while (currentToken !== TOK_RBRACKET && index < 3) {
		              if (currentToken === TOK_COLON) {
		                  index++;
		                  this._advance();
		              } else if (currentToken === TOK_NUMBER) {
		                  parts[index] = this._lookaheadToken(0).value;
		                  this._advance();
		              } else {
		                  var t = this._lookahead(0);
		                  var error = new Error("Syntax error, unexpected token: " +
		                                        t.value + "(" + t.type + ")");
		                  error.name = "Parsererror";
		                  throw error;
		              }
		              currentToken = this._lookahead(0);
		          }
		          this._match(TOK_RBRACKET);
		          return {
		              type: "Slice",
		              children: parts
		          };
		      },

		      _parseComparator: function(left, comparator) {
		        var right = this.expression(bindingPower[comparator]);
		        return {type: "Comparator", name: comparator, children: [left, right]};
		      },

		      _parseDotRHS: function(rbp) {
		          var lookahead = this._lookahead(0);
		          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
		          if (exprTokens.indexOf(lookahead) >= 0) {
		              return this.expression(rbp);
		          } else if (lookahead === TOK_LBRACKET) {
		              this._match(TOK_LBRACKET);
		              return this._parseMultiselectList();
		          } else if (lookahead === TOK_LBRACE) {
		              this._match(TOK_LBRACE);
		              return this._parseMultiselectHash();
		          }
		      },

		      _parseProjectionRHS: function(rbp) {
		          var right;
		          if (bindingPower[this._lookahead(0)] < 10) {
		              right = {type: "Identity"};
		          } else if (this._lookahead(0) === TOK_LBRACKET) {
		              right = this.expression(rbp);
		          } else if (this._lookahead(0) === TOK_FILTER) {
		              right = this.expression(rbp);
		          } else if (this._lookahead(0) === TOK_DOT) {
		              this._match(TOK_DOT);
		              right = this._parseDotRHS(rbp);
		          } else {
		              var t = this._lookaheadToken(0);
		              var error = new Error("Sytanx error, unexpected token: " +
		                                    t.value + "(" + t.type + ")");
		              error.name = "ParserError";
		              throw error;
		          }
		          return right;
		      },

		      _parseMultiselectList: function() {
		          var expressions = [];
		          while (this._lookahead(0) !== TOK_RBRACKET) {
		              var expression = this.expression(0);
		              expressions.push(expression);
		              if (this._lookahead(0) === TOK_COMMA) {
		                  this._match(TOK_COMMA);
		                  if (this._lookahead(0) === TOK_RBRACKET) {
		                    throw new Error("Unexpected token Rbracket");
		                  }
		              }
		          }
		          this._match(TOK_RBRACKET);
		          return {type: "MultiSelectList", children: expressions};
		      },

		      _parseMultiselectHash: function() {
		        var pairs = [];
		        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
		        var keyToken, keyName, value, node;
		        for (;;) {
		          keyToken = this._lookaheadToken(0);
		          if (identifierTypes.indexOf(keyToken.type) < 0) {
		            throw new Error("Expecting an identifier token, got: " +
		                            keyToken.type);
		          }
		          keyName = keyToken.value;
		          this._advance();
		          this._match(TOK_COLON);
		          value = this.expression(0);
		          node = {type: "KeyValuePair", name: keyName, value: value};
		          pairs.push(node);
		          if (this._lookahead(0) === TOK_COMMA) {
		            this._match(TOK_COMMA);
		          } else if (this._lookahead(0) === TOK_RBRACE) {
		            this._match(TOK_RBRACE);
		            break;
		          }
		        }
		        return {type: "MultiSelectHash", children: pairs};
		      }
		  };


		  function TreeInterpreter(runtime) {
		    this.runtime = runtime;
		  }

		  TreeInterpreter.prototype = {
		      search: function(node, value) {
		          return this.visit(node, value);
		      },

		      visit: function(node, value) {
		          var matched, current, result, first, second, field, left, right, collected, i;
		          switch (node.type) {
		            case "Field":
		              if (value !== null && isObject(value)) {
		                  field = value[node.name];
		                  if (field === undefined) {
		                      return null;
		                  } else {
		                      return field;
		                  }
		              }
		              return null;
		            case "Subexpression":
		              result = this.visit(node.children[0], value);
		              for (i = 1; i < node.children.length; i++) {
		                  result = this.visit(node.children[1], result);
		                  if (result === null) {
		                      return null;
		                  }
		              }
		              return result;
		            case "IndexExpression":
		              left = this.visit(node.children[0], value);
		              right = this.visit(node.children[1], left);
		              return right;
		            case "Index":
		              if (!isArray(value)) {
		                return null;
		              }
		              var index = node.value;
		              if (index < 0) {
		                index = value.length + index;
		              }
		              result = value[index];
		              if (result === undefined) {
		                result = null;
		              }
		              return result;
		            case "Slice":
		              if (!isArray(value)) {
		                return null;
		              }
		              var sliceParams = node.children.slice(0);
		              var computed = this.computeSliceParams(value.length, sliceParams);
		              var start = computed[0];
		              var stop = computed[1];
		              var step = computed[2];
		              result = [];
		              if (step > 0) {
		                  for (i = start; i < stop; i += step) {
		                      result.push(value[i]);
		                  }
		              } else {
		                  for (i = start; i > stop; i += step) {
		                      result.push(value[i]);
		                  }
		              }
		              return result;
		            case "Projection":
		              // Evaluate left child.
		              var base = this.visit(node.children[0], value);
		              if (!isArray(base)) {
		                return null;
		              }
		              collected = [];
		              for (i = 0; i < base.length; i++) {
		                current = this.visit(node.children[1], base[i]);
		                if (current !== null) {
		                  collected.push(current);
		                }
		              }
		              return collected;
		            case "ValueProjection":
		              // Evaluate left child.
		              base = this.visit(node.children[0], value);
		              if (!isObject(base)) {
		                return null;
		              }
		              collected = [];
		              var values = objValues(base);
		              for (i = 0; i < values.length; i++) {
		                current = this.visit(node.children[1], values[i]);
		                if (current !== null) {
		                  collected.push(current);
		                }
		              }
		              return collected;
		            case "FilterProjection":
		              base = this.visit(node.children[0], value);
		              if (!isArray(base)) {
		                return null;
		              }
		              var filtered = [];
		              var finalResults = [];
		              for (i = 0; i < base.length; i++) {
		                matched = this.visit(node.children[2], base[i]);
		                if (!isFalse(matched)) {
		                  filtered.push(base[i]);
		                }
		              }
		              for (var j = 0; j < filtered.length; j++) {
		                current = this.visit(node.children[1], filtered[j]);
		                if (current !== null) {
		                  finalResults.push(current);
		                }
		              }
		              return finalResults;
		            case "Comparator":
		              first = this.visit(node.children[0], value);
		              second = this.visit(node.children[1], value);
		              switch(node.name) {
		                case TOK_EQ:
		                  result = strictDeepEqual(first, second);
		                  break;
		                case TOK_NE:
		                  result = !strictDeepEqual(first, second);
		                  break;
		                case TOK_GT:
		                  result = first > second;
		                  break;
		                case TOK_GTE:
		                  result = first >= second;
		                  break;
		                case TOK_LT:
		                  result = first < second;
		                  break;
		                case TOK_LTE:
		                  result = first <= second;
		                  break;
		                default:
		                  throw new Error("Unknown comparator: " + node.name);
		              }
		              return result;
		            case TOK_FLATTEN:
		              var original = this.visit(node.children[0], value);
		              if (!isArray(original)) {
		                return null;
		              }
		              var merged = [];
		              for (i = 0; i < original.length; i++) {
		                current = original[i];
		                if (isArray(current)) {
		                  merged.push.apply(merged, current);
		                } else {
		                  merged.push(current);
		                }
		              }
		              return merged;
		            case "Identity":
		              return value;
		            case "MultiSelectList":
		              if (value === null) {
		                return null;
		              }
		              collected = [];
		              for (i = 0; i < node.children.length; i++) {
		                  collected.push(this.visit(node.children[i], value));
		              }
		              return collected;
		            case "MultiSelectHash":
		              if (value === null) {
		                return null;
		              }
		              collected = {};
		              var child;
		              for (i = 0; i < node.children.length; i++) {
		                child = node.children[i];
		                collected[child.name] = this.visit(child.value, value);
		              }
		              return collected;
		            case "OrExpression":
		              matched = this.visit(node.children[0], value);
		              if (isFalse(matched)) {
		                  matched = this.visit(node.children[1], value);
		              }
		              return matched;
		            case "AndExpression":
		              first = this.visit(node.children[0], value);

		              if (isFalse(first) === true) {
		                return first;
		              }
		              return this.visit(node.children[1], value);
		            case "NotExpression":
		              first = this.visit(node.children[0], value);
		              return isFalse(first);
		            case "Literal":
		              return node.value;
		            case TOK_PIPE:
		              left = this.visit(node.children[0], value);
		              return this.visit(node.children[1], left);
		            case TOK_CURRENT:
		              return value;
		            case "Function":
		              var resolvedArgs = [];
		              for (i = 0; i < node.children.length; i++) {
		                  resolvedArgs.push(this.visit(node.children[i], value));
		              }
		              return this.runtime.callFunction(node.name, resolvedArgs);
		            case "ExpressionReference":
		              var refNode = node.children[0];
		              // Tag the node with a specific attribute so the type
		              // checker verify the type.
		              refNode.jmespathType = TOK_EXPREF;
		              return refNode;
		            default:
		              throw new Error("Unknown node type: " + node.type);
		          }
		      },

		      computeSliceParams: function(arrayLength, sliceParams) {
		        var start = sliceParams[0];
		        var stop = sliceParams[1];
		        var step = sliceParams[2];
		        var computed = [null, null, null];
		        if (step === null) {
		          step = 1;
		        } else if (step === 0) {
		          var error = new Error("Invalid slice, step cannot be 0");
		          error.name = "RuntimeError";
		          throw error;
		        }
		        var stepValueNegative = step < 0 ? true : false;

		        if (start === null) {
		            start = stepValueNegative ? arrayLength - 1 : 0;
		        } else {
		            start = this.capSliceRange(arrayLength, start, step);
		        }

		        if (stop === null) {
		            stop = stepValueNegative ? -1 : arrayLength;
		        } else {
		            stop = this.capSliceRange(arrayLength, stop, step);
		        }
		        computed[0] = start;
		        computed[1] = stop;
		        computed[2] = step;
		        return computed;
		      },

		      capSliceRange: function(arrayLength, actualValue, step) {
		          if (actualValue < 0) {
		              actualValue += arrayLength;
		              if (actualValue < 0) {
		                  actualValue = step < 0 ? -1 : 0;
		              }
		          } else if (actualValue >= arrayLength) {
		              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
		          }
		          return actualValue;
		      }

		  };

		  function Runtime(interpreter) {
		    this._interpreter = interpreter;
		    this.functionTable = {
		        // name: [function, <signature>]
		        // The <signature> can be:
		        //
		        // {
		        //   args: [[type1, type2], [type1, type2]],
		        //   variadic: true|false
		        // }
		        //
		        // Each arg in the arg list is a list of valid types
		        // (if the function is overloaded and supports multiple
		        // types.  If the type is "any" then no type checking
		        // occurs on the argument.  Variadic is optional
		        // and if not provided is assumed to be false.
		        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
		        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
		        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
		        contains: {
		            _func: this._functionContains,
		            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
		                        {types: [TYPE_ANY]}]},
		        "ends_with": {
		            _func: this._functionEndsWith,
		            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
		        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
		        length: {
		            _func: this._functionLength,
		            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
		        map: {
		            _func: this._functionMap,
		            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
		        max: {
		            _func: this._functionMax,
		            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
		        "merge": {
		            _func: this._functionMerge,
		            _signature: [{types: [TYPE_OBJECT], variadic: true}]
		        },
		        "max_by": {
		          _func: this._functionMaxBy,
		          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
		        },
		        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
		        "starts_with": {
		            _func: this._functionStartsWith,
		            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
		        min: {
		            _func: this._functionMin,
		            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
		        "min_by": {
		          _func: this._functionMinBy,
		          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
		        },
		        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
		        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
		        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
		        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
		        "sort_by": {
		          _func: this._functionSortBy,
		          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
		        },
		        join: {
		            _func: this._functionJoin,
		            _signature: [
		                {types: [TYPE_STRING]},
		                {types: [TYPE_ARRAY_STRING]}
		            ]
		        },
		        reverse: {
		            _func: this._functionReverse,
		            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
		        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
		        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
		        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
		        "not_null": {
		            _func: this._functionNotNull,
		            _signature: [{types: [TYPE_ANY], variadic: true}]
		        }
		    };
		  }

		  Runtime.prototype = {
		    callFunction: function(name, resolvedArgs) {
		      var functionEntry = this.functionTable[name];
		      if (functionEntry === undefined) {
		          throw new Error("Unknown function: " + name + "()");
		      }
		      this._validateArgs(name, resolvedArgs, functionEntry._signature);
		      return functionEntry._func.call(this, resolvedArgs);
		    },

		    _validateArgs: function(name, args, signature) {
		        // Validating the args requires validating
		        // the correct arity and the correct type of each arg.
		        // If the last argument is declared as variadic, then we need
		        // a minimum number of args to be required.  Otherwise it has to
		        // be an exact amount.
		        var pluralized;
		        if (signature[signature.length - 1].variadic) {
		            if (args.length < signature.length) {
		                pluralized = signature.length === 1 ? " argument" : " arguments";
		                throw new Error("ArgumentError: " + name + "() " +
		                                "takes at least" + signature.length + pluralized +
		                                " but received " + args.length);
		            }
		        } else if (args.length !== signature.length) {
		            pluralized = signature.length === 1 ? " argument" : " arguments";
		            throw new Error("ArgumentError: " + name + "() " +
		                            "takes " + signature.length + pluralized +
		                            " but received " + args.length);
		        }
		        var currentSpec;
		        var actualType;
		        var typeMatched;
		        for (var i = 0; i < signature.length; i++) {
		            typeMatched = false;
		            currentSpec = signature[i].types;
		            actualType = this._getTypeName(args[i]);
		            for (var j = 0; j < currentSpec.length; j++) {
		                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
		                    typeMatched = true;
		                    break;
		                }
		            }
		            if (!typeMatched) {
		                var expected = currentSpec
		                    .map(function(typeIdentifier) {
		                        return TYPE_NAME_TABLE[typeIdentifier];
		                    })
		                    .join(',');
		                throw new Error("TypeError: " + name + "() " +
		                                "expected argument " + (i + 1) +
		                                " to be type " + expected +
		                                " but received type " +
		                                TYPE_NAME_TABLE[actualType] + " instead.");
		            }
		        }
		    },

		    _typeMatches: function(actual, expected, argValue) {
		        if (expected === TYPE_ANY) {
		            return true;
		        }
		        if (expected === TYPE_ARRAY_STRING ||
		            expected === TYPE_ARRAY_NUMBER ||
		            expected === TYPE_ARRAY) {
		            // The expected type can either just be array,
		            // or it can require a specific subtype (array of numbers).
		            //
		            // The simplest case is if "array" with no subtype is specified.
		            if (expected === TYPE_ARRAY) {
		                return actual === TYPE_ARRAY;
		            } else if (actual === TYPE_ARRAY) {
		                // Otherwise we need to check subtypes.
		                // I think this has potential to be improved.
		                var subtype;
		                if (expected === TYPE_ARRAY_NUMBER) {
		                  subtype = TYPE_NUMBER;
		                } else if (expected === TYPE_ARRAY_STRING) {
		                  subtype = TYPE_STRING;
		                }
		                for (var i = 0; i < argValue.length; i++) {
		                    if (!this._typeMatches(
		                            this._getTypeName(argValue[i]), subtype,
		                                             argValue[i])) {
		                        return false;
		                    }
		                }
		                return true;
		            }
		        } else {
		            return actual === expected;
		        }
		    },
		    _getTypeName: function(obj) {
		        switch (Object.prototype.toString.call(obj)) {
		            case "[object String]":
		              return TYPE_STRING;
		            case "[object Number]":
		              return TYPE_NUMBER;
		            case "[object Array]":
		              return TYPE_ARRAY;
		            case "[object Boolean]":
		              return TYPE_BOOLEAN;
		            case "[object Null]":
		              return TYPE_NULL;
		            case "[object Object]":
		              // Check if it's an expref.  If it has, it's been
		              // tagged with a jmespathType attr of 'Expref';
		              if (obj.jmespathType === TOK_EXPREF) {
		                return TYPE_EXPREF;
		              } else {
		                return TYPE_OBJECT;
		              }
		        }
		    },

		    _functionStartsWith: function(resolvedArgs) {
		        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
		    },

		    _functionEndsWith: function(resolvedArgs) {
		        var searchStr = resolvedArgs[0];
		        var suffix = resolvedArgs[1];
		        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
		    },

		    _functionReverse: function(resolvedArgs) {
		        var typeName = this._getTypeName(resolvedArgs[0]);
		        if (typeName === TYPE_STRING) {
		          var originalStr = resolvedArgs[0];
		          var reversedStr = "";
		          for (var i = originalStr.length - 1; i >= 0; i--) {
		              reversedStr += originalStr[i];
		          }
		          return reversedStr;
		        } else {
		          var reversedArray = resolvedArgs[0].slice(0);
		          reversedArray.reverse();
		          return reversedArray;
		        }
		    },

		    _functionAbs: function(resolvedArgs) {
		      return Math.abs(resolvedArgs[0]);
		    },

		    _functionCeil: function(resolvedArgs) {
		        return Math.ceil(resolvedArgs[0]);
		    },

		    _functionAvg: function(resolvedArgs) {
		        var sum = 0;
		        var inputArray = resolvedArgs[0];
		        for (var i = 0; i < inputArray.length; i++) {
		            sum += inputArray[i];
		        }
		        return sum / inputArray.length;
		    },

		    _functionContains: function(resolvedArgs) {
		        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
		    },

		    _functionFloor: function(resolvedArgs) {
		        return Math.floor(resolvedArgs[0]);
		    },

		    _functionLength: function(resolvedArgs) {
		       if (!isObject(resolvedArgs[0])) {
		         return resolvedArgs[0].length;
		       } else {
		         // As far as I can tell, there's no way to get the length
		         // of an object without O(n) iteration through the object.
		         return Object.keys(resolvedArgs[0]).length;
		       }
		    },

		    _functionMap: function(resolvedArgs) {
		      var mapped = [];
		      var interpreter = this._interpreter;
		      var exprefNode = resolvedArgs[0];
		      var elements = resolvedArgs[1];
		      for (var i = 0; i < elements.length; i++) {
		          mapped.push(interpreter.visit(exprefNode, elements[i]));
		      }
		      return mapped;
		    },

		    _functionMerge: function(resolvedArgs) {
		      var merged = {};
		      for (var i = 0; i < resolvedArgs.length; i++) {
		        var current = resolvedArgs[i];
		        for (var key in current) {
		          merged[key] = current[key];
		        }
		      }
		      return merged;
		    },

		    _functionMax: function(resolvedArgs) {
		      if (resolvedArgs[0].length > 0) {
		        var typeName = this._getTypeName(resolvedArgs[0][0]);
		        if (typeName === TYPE_NUMBER) {
		          return Math.max.apply(Math, resolvedArgs[0]);
		        } else {
		          var elements = resolvedArgs[0];
		          var maxElement = elements[0];
		          for (var i = 1; i < elements.length; i++) {
		              if (maxElement.localeCompare(elements[i]) < 0) {
		                  maxElement = elements[i];
		              }
		          }
		          return maxElement;
		        }
		      } else {
		          return null;
		      }
		    },

		    _functionMin: function(resolvedArgs) {
		      if (resolvedArgs[0].length > 0) {
		        var typeName = this._getTypeName(resolvedArgs[0][0]);
		        if (typeName === TYPE_NUMBER) {
		          return Math.min.apply(Math, resolvedArgs[0]);
		        } else {
		          var elements = resolvedArgs[0];
		          var minElement = elements[0];
		          for (var i = 1; i < elements.length; i++) {
		              if (elements[i].localeCompare(minElement) < 0) {
		                  minElement = elements[i];
		              }
		          }
		          return minElement;
		        }
		      } else {
		        return null;
		      }
		    },

		    _functionSum: function(resolvedArgs) {
		      var sum = 0;
		      var listToSum = resolvedArgs[0];
		      for (var i = 0; i < listToSum.length; i++) {
		        sum += listToSum[i];
		      }
		      return sum;
		    },

		    _functionType: function(resolvedArgs) {
		        switch (this._getTypeName(resolvedArgs[0])) {
		          case TYPE_NUMBER:
		            return "number";
		          case TYPE_STRING:
		            return "string";
		          case TYPE_ARRAY:
		            return "array";
		          case TYPE_OBJECT:
		            return "object";
		          case TYPE_BOOLEAN:
		            return "boolean";
		          case TYPE_EXPREF:
		            return "expref";
		          case TYPE_NULL:
		            return "null";
		        }
		    },

		    _functionKeys: function(resolvedArgs) {
		        return Object.keys(resolvedArgs[0]);
		    },

		    _functionValues: function(resolvedArgs) {
		        var obj = resolvedArgs[0];
		        var keys = Object.keys(obj);
		        var values = [];
		        for (var i = 0; i < keys.length; i++) {
		            values.push(obj[keys[i]]);
		        }
		        return values;
		    },

		    _functionJoin: function(resolvedArgs) {
		        var joinChar = resolvedArgs[0];
		        var listJoin = resolvedArgs[1];
		        return listJoin.join(joinChar);
		    },

		    _functionToArray: function(resolvedArgs) {
		        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
		            return resolvedArgs[0];
		        } else {
		            return [resolvedArgs[0]];
		        }
		    },

		    _functionToString: function(resolvedArgs) {
		        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
		            return resolvedArgs[0];
		        } else {
		            return JSON.stringify(resolvedArgs[0]);
		        }
		    },

		    _functionToNumber: function(resolvedArgs) {
		        var typeName = this._getTypeName(resolvedArgs[0]);
		        var convertedValue;
		        if (typeName === TYPE_NUMBER) {
		            return resolvedArgs[0];
		        } else if (typeName === TYPE_STRING) {
		            convertedValue = +resolvedArgs[0];
		            if (!isNaN(convertedValue)) {
		                return convertedValue;
		            }
		        }
		        return null;
		    },

		    _functionNotNull: function(resolvedArgs) {
		        for (var i = 0; i < resolvedArgs.length; i++) {
		            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
		                return resolvedArgs[i];
		            }
		        }
		        return null;
		    },

		    _functionSort: function(resolvedArgs) {
		        var sortedArray = resolvedArgs[0].slice(0);
		        sortedArray.sort();
		        return sortedArray;
		    },

		    _functionSortBy: function(resolvedArgs) {
		        var sortedArray = resolvedArgs[0].slice(0);
		        if (sortedArray.length === 0) {
		            return sortedArray;
		        }
		        var interpreter = this._interpreter;
		        var exprefNode = resolvedArgs[1];
		        var requiredType = this._getTypeName(
		            interpreter.visit(exprefNode, sortedArray[0]));
		        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
		            throw new Error("TypeError");
		        }
		        var that = this;
		        // In order to get a stable sort out of an unstable
		        // sort algorithm, we decorate/sort/undecorate (DSU)
		        // by creating a new list of [index, element] pairs.
		        // In the cmp function, if the evaluated elements are
		        // equal, then the index will be used as the tiebreaker.
		        // After the decorated list has been sorted, it will be
		        // undecorated to extract the original elements.
		        var decorated = [];
		        for (var i = 0; i < sortedArray.length; i++) {
		          decorated.push([i, sortedArray[i]]);
		        }
		        decorated.sort(function(a, b) {
		          var exprA = interpreter.visit(exprefNode, a[1]);
		          var exprB = interpreter.visit(exprefNode, b[1]);
		          if (that._getTypeName(exprA) !== requiredType) {
		              throw new Error(
		                  "TypeError: expected " + requiredType + ", received " +
		                  that._getTypeName(exprA));
		          } else if (that._getTypeName(exprB) !== requiredType) {
		              throw new Error(
		                  "TypeError: expected " + requiredType + ", received " +
		                  that._getTypeName(exprB));
		          }
		          if (exprA > exprB) {
		            return 1;
		          } else if (exprA < exprB) {
		            return -1;
		          } else {
		            // If they're equal compare the items by their
		            // order to maintain relative order of equal keys
		            // (i.e. to get a stable sort).
		            return a[0] - b[0];
		          }
		        });
		        // Undecorate: extract out the original list elements.
		        for (var j = 0; j < decorated.length; j++) {
		          sortedArray[j] = decorated[j][1];
		        }
		        return sortedArray;
		    },

		    _functionMaxBy: function(resolvedArgs) {
		      var exprefNode = resolvedArgs[1];
		      var resolvedArray = resolvedArgs[0];
		      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
		      var maxNumber = -Infinity;
		      var maxRecord;
		      var current;
		      for (var i = 0; i < resolvedArray.length; i++) {
		        current = keyFunction(resolvedArray[i]);
		        if (current > maxNumber) {
		          maxNumber = current;
		          maxRecord = resolvedArray[i];
		        }
		      }
		      return maxRecord;
		    },

		    _functionMinBy: function(resolvedArgs) {
		      var exprefNode = resolvedArgs[1];
		      var resolvedArray = resolvedArgs[0];
		      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
		      var minNumber = Infinity;
		      var minRecord;
		      var current;
		      for (var i = 0; i < resolvedArray.length; i++) {
		        current = keyFunction(resolvedArray[i]);
		        if (current < minNumber) {
		          minNumber = current;
		          minRecord = resolvedArray[i];
		        }
		      }
		      return minRecord;
		    },

		    createKeyFunction: function(exprefNode, allowedTypes) {
		      var that = this;
		      var interpreter = this._interpreter;
		      var keyFunc = function(x) {
		        var current = interpreter.visit(exprefNode, x);
		        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
		          var msg = "TypeError: expected one of " + allowedTypes +
		                    ", received " + that._getTypeName(current);
		          throw new Error(msg);
		        }
		        return current;
		      };
		      return keyFunc;
		    }

		  };

		  function compile(stream) {
		    var parser = new Parser();
		    var ast = parser.parse(stream);
		    return ast;
		  }

		  function tokenize(stream) {
		      var lexer = new Lexer();
		      return lexer.tokenize(stream);
		  }

		  function search(data, expression) {
		      var parser = new Parser();
		      // This needs to be improved.  Both the interpreter and runtime depend on
		      // each other.  The runtime needs the interpreter to support exprefs.
		      // There's likely a clean way to avoid the cyclic dependency.
		      var runtime = new Runtime();
		      var interpreter = new TreeInterpreter(runtime);
		      runtime._interpreter = interpreter;
		      var node = parser.parse(expression);
		      return interpreter.search(node, data);
		  }

		  exports.tokenize = tokenize;
		  exports.compile = compile;
		  exports.search = search;
		  exports.strictDeepEqual = strictDeepEqual;
		})( false ? this.jmespath = {} : exports);


	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;
		var jmespath = __webpack_require__(52);

		/**
		 * This class encapsulates the response information
		 * from a service request operation sent through {AWS.Request}.
		 * The response object has two main properties for getting information
		 * back from a request:
		 *
		 * ## The `data` property
		 *
		 * The `response.data` property contains the serialized object data
		 * retrieved from the service request. For instance, for an
		 * Amazon DynamoDB `listTables` method call, the response data might
		 * look like:
		 *
		 * ```
		 * > resp.data
		 * { TableNames:
		 *    [ 'table1', 'table2', ... ] }
		 * ```
		 *
		 * The `data` property can be null if an error occurs (see below).
		 *
		 * ## The `error` property
		 *
		 * In the event of a service error (or transfer error), the
		 * `response.error` property will be filled with the given
		 * error data in the form:
		 *
		 * ```
		 * { code: 'SHORT_UNIQUE_ERROR_CODE',
		 *   message: 'Some human readable error message' }
		 * ```
		 *
		 * In the case of an error, the `data` property will be `null`.
		 * Note that if you handle events that can be in a failure state,
		 * you should always check whether `response.error` is set
		 * before attempting to access the `response.data` property.
		 *
		 * @!attribute data
		 *   @readonly
		 *   @!group Data Properties
		 *   @note Inside of a {AWS.Request~httpData} event, this
		 *     property contains a single raw packet instead of the
		 *     full de-serialized service response.
		 *   @return [Object] the de-serialized response data
		 *     from the service.
		 *
		 * @!attribute error
		 *   An structure containing information about a service
		 *   or networking error.
		 *   @readonly
		 *   @!group Data Properties
		 *   @note This attribute is only filled if a service or
		 *     networking error occurs.
		 *   @return [Error]
		 *     * code [String] a unique short code representing the
		 *       error that was emitted.
		 *     * message [String] a longer human readable error message
		 *     * retryable [Boolean] whether the error message is
		 *       retryable.
		 *     * statusCode [Numeric] in the case of a request that reached the service,
		 *       this value contains the response status code.
		 *     * time [Date] the date time object when the error occurred.
		 *     * hostname [String] set when a networking error occurs to easily
		 *       identify the endpoint of the request.
		 *     * region [String] set when a networking error occurs to easily
		 *       identify the region of the request.
		 *
		 * @!attribute requestId
		 *   @readonly
		 *   @!group Data Properties
		 *   @return [String] the unique request ID associated with the response.
		 *     Log this value when debugging requests for AWS support.
		 *
		 * @!attribute retryCount
		 *   @readonly
		 *   @!group Operation Properties
		 *   @return [Integer] the number of retries that were
		 *     attempted before the request was completed.
		 *
		 * @!attribute redirectCount
		 *   @readonly
		 *   @!group Operation Properties
		 *   @return [Integer] the number of redirects that were
		 *     followed before the request was completed.
		 *
		 * @!attribute httpResponse
		 *   @readonly
		 *   @!group HTTP Properties
		 *   @return [AWS.HttpResponse] the raw HTTP response object
		 *     containing the response headers and body information
		 *     from the server.
		 *
		 * @see AWS.Request
		 */
		AWS.Response = inherit({

		  /**
		   * @api private
		   */
		  constructor: function Response(request) {
		    this.request = request;
		    this.data = null;
		    this.error = null;
		    this.retryCount = 0;
		    this.redirectCount = 0;
		    this.httpResponse = new AWS.HttpResponse();
		    if (request) {
		      this.maxRetries = request.service.numRetries();
		      this.maxRedirects = request.service.config.maxRedirects;
		    }
		  },

		  /**
		   * Creates a new request for the next page of response data, calling the
		   * callback with the page data if a callback is provided.
		   *
		   * @callback callback function(err, data)
		   *   Called when a page of data is returned from the next request.
		   *
		   *   @param err [Error] an error object, if an error occurred in the request
		   *   @param data [Object] the next page of data, or null, if there are no
		   *     more pages left.
		   * @return [AWS.Request] the request object for the next page of data
		   * @return [null] if no callback is provided and there are no pages left
		   *   to retrieve.
		   * @since v1.4.0
		   */
		  nextPage: function nextPage(callback) {
		    var config;
		    var service = this.request.service;
		    var operation = this.request.operation;
		    try {
		      config = service.paginationConfig(operation, true);
		    } catch (e) { this.error = e; }

		    if (!this.hasNextPage()) {
		      if (callback) callback(this.error, null);
		      else if (this.error) throw this.error;
		      return null;
		    }

		    var params = AWS.util.copy(this.request.params);
		    if (!this.nextPageTokens) {
		      return callback ? callback(null, null) : null;
		    } else {
		      var inputTokens = config.inputToken;
		      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
		      for (var i = 0; i < inputTokens.length; i++) {
		        params[inputTokens[i]] = this.nextPageTokens[i];
		      }
		      return service.makeRequest(this.request.operation, params, callback);
		    }
		  },

		  /**
		   * @return [Boolean] whether more pages of data can be returned by further
		   *   requests
		   * @since v1.4.0
		   */
		  hasNextPage: function hasNextPage() {
		    this.cacheNextPageTokens();
		    if (this.nextPageTokens) return true;
		    if (this.nextPageTokens === undefined) return undefined;
		    else return false;
		  },

		  /**
		   * @api private
		   */
		  cacheNextPageTokens: function cacheNextPageTokens() {
		    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
		    this.nextPageTokens = undefined;

		    var config = this.request.service.paginationConfig(this.request.operation);
		    if (!config) return this.nextPageTokens;

		    this.nextPageTokens = null;
		    if (config.moreResults) {
		      if (!jmespath.search(this.data, config.moreResults)) {
		        return this.nextPageTokens;
		      }
		    }

		    var exprs = config.outputToken;
		    if (typeof exprs === 'string') exprs = [exprs];
		    AWS.util.arrayEach.call(this, exprs, function (expr) {
		      var output = jmespath.search(this.data, expr);
		      if (output) {
		        this.nextPageTokens = this.nextPageTokens || [];
		        this.nextPageTokens.push(output);
		      }
		    });

		    return this.nextPageTokens;
		  }

		});


	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {

		/**
		 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
		 *
		 * Licensed under the Apache License, Version 2.0 (the "License"). You
		 * may not use this file except in compliance with the License. A copy of
		 * the License is located at
		 *
		 *     http://aws.amazon.com/apache2.0/
		 *
		 * or in the "license" file accompanying this file. This file is
		 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
		 * ANY KIND, either express or implied. See the License for the specific
		 * language governing permissions and limitations under the License.
		 */

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;
		var jmespath = __webpack_require__(52);

		/**
		 * @api private
		 */
		function CHECK_ACCEPTORS(resp) {
		  var waiter = resp.request._waiter;
		  var acceptors = waiter.config.acceptors;
		  var acceptorMatched = false;
		  var state = 'retry';

		  acceptors.forEach(function(acceptor) {
		    if (!acceptorMatched) {
		      var matcher = waiter.matchers[acceptor.matcher];
		      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
		        acceptorMatched = true;
		        state = acceptor.state;
		      }
		    }
		  });

		  if (!acceptorMatched && resp.error) state = 'failure';

		  if (state === 'success') {
		    waiter.setSuccess(resp);
		  } else {
		    waiter.setError(resp, state === 'retry');
		  }
		}

		/**
		 * @api private
		 */
		AWS.ResourceWaiter = inherit({
		  /**
		   * Waits for a given state on a service object
		   * @param service [Service] the service object to wait on
		   * @param state [String] the state (defined in waiter configuration) to wait
		   *   for.
		   * @example Create a waiter for running EC2 instances
		   *   var ec2 = new AWS.EC2;
		   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
		   */
		  constructor: function constructor(service, state) {
		    this.service = service;
		    this.state = state;
		    this.loadWaiterConfig(this.state);
		  },

		  service: null,

		  state: null,

		  config: null,

		  matchers: {
		    path: function(resp, expected, argument) {
		      try {
		        var result = jmespath.search(resp.data, argument);
		      } catch (err) {
		        return false;
		      }

		      return jmespath.strictDeepEqual(result,expected);
		    },

		    pathAll: function(resp, expected, argument) {
		      try {
		        var results = jmespath.search(resp.data, argument);
		      } catch (err) {
		        return false;
		      }

		      if (!Array.isArray(results)) results = [results];
		      var numResults = results.length;
		      if (!numResults) return false;
		      for (var ind = 0 ; ind < numResults; ind++) {
		        if (!jmespath.strictDeepEqual(results[ind], expected)) {
		          return false;
		        }
		      }
		      return true;
		    },

		    pathAny: function(resp, expected, argument) {
		      try {
		        var results = jmespath.search(resp.data, argument);
		      } catch (err) {
		        return false;
		      }

		      if (!Array.isArray(results)) results = [results];
		      var numResults = results.length;
		      for (var ind = 0 ; ind < numResults; ind++) {
		        if (jmespath.strictDeepEqual(results[ind], expected)) {
		          return true;
		        }
		      }
		      return false;
		    },

		    status: function(resp, expected) {
		      var statusCode = resp.httpResponse.statusCode;
		      return (typeof statusCode === 'number') && (statusCode === expected);
		    },

		    error: function(resp, expected) {
		      if (typeof expected === 'string' && resp.error) {
		        return expected === resp.error.code;
		      }
		      // if expected is not string, can be boolean indicating presence of error
		      return expected === !!resp.error;
		    }
		  },

		  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
		    add('RETRY_CHECK', 'retry', function(resp) {
		      var waiter = resp.request._waiter;
		      if (resp.error && resp.error.code === 'ResourceNotReady') {
		        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
		      }
		    });

		    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);

		    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
		  }),

		  /**
		   * @return [AWS.Request]
		   */
		  wait: function wait(params, callback) {
		    if (typeof params === 'function') {
		      callback = params; params = undefined;
		    }

		    if (params && params.$waiter) {
		      params = AWS.util.copy(params);
		      if (typeof params.$waiter.delay === 'number') {
		        this.config.delay = params.$waiter.delay;
		      }
		      if (typeof params.$waiter.maxAttempts === 'number') {
		        this.config.maxAttempts = params.$waiter.maxAttempts;
		      }
		      delete params.$waiter;
		    }

		    var request = this.service.makeRequest(this.config.operation, params);
		    request._waiter = this;
		    request.response.maxRetries = this.config.maxAttempts;
		    request.addListeners(this.listeners);

		    if (callback) request.send(callback);
		    return request;
		  },

		  setSuccess: function setSuccess(resp) {
		    resp.error = null;
		    resp.data = resp.data || {};
		    resp.request.removeAllListeners('extractData');
		  },

		  setError: function setError(resp, retryable) {
		    resp.data = null;
		    resp.error = AWS.util.error(resp.error || new Error(), {
		      code: 'ResourceNotReady',
		      message: 'Resource is not in the state ' + this.state,
		      retryable: retryable
		    });
		  },

		  /**
		   * Loads waiter configuration from API configuration
		   *
		   * @api private
		   */
		  loadWaiterConfig: function loadWaiterConfig(state) {
		    if (!this.service.api.waiters[state]) {
		      throw new AWS.util.error(new Error(), {
		        code: 'StateNotFoundError',
		        message: 'State ' + state + ' not found.'
		      });
		    }

		    this.config = AWS.util.copy(this.service.api.waiters[state]);
		  }
		});


	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);

		var inherit = AWS.util.inherit;

		/**
		 * @api private
		 */
		AWS.Signers.RequestSigner = inherit({
		  constructor: function RequestSigner(request) {
		    this.request = request;
		  },

		  setServiceClientId: function setServiceClientId(id) {
		    this.serviceClientId = id;
		  },

		  getServiceClientId: function getServiceClientId() {
		    return this.serviceClientId;
		  }
		});

		AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
		  switch (version) {
		    case 'v2': return AWS.Signers.V2;
		    case 'v3': return AWS.Signers.V3;
		    case 's3v4': return AWS.Signers.V4;
		    case 'v4': return AWS.Signers.V4;
		    case 's3': return AWS.Signers.S3;
		    case 'v3https': return AWS.Signers.V3Https;
		  }
		  throw new Error('Unknown signing version ' + version);
		};

		__webpack_require__(56);
		__webpack_require__(57);
		__webpack_require__(58);
		__webpack_require__(59);
		__webpack_require__(61);
		__webpack_require__(62);


	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;

		/**
		 * @api private
		 */
		AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
		  addAuthorization: function addAuthorization(credentials, date) {

		    if (!date) date = AWS.util.date.getDate();

		    var r = this.request;

		    r.params.Timestamp = AWS.util.date.iso8601(date);
		    r.params.SignatureVersion = '2';
		    r.params.SignatureMethod = 'HmacSHA256';
		    r.params.AWSAccessKeyId = credentials.accessKeyId;

		    if (credentials.sessionToken) {
		      r.params.SecurityToken = credentials.sessionToken;
		    }

		    delete r.params.Signature; // delete old Signature for re-signing
		    r.params.Signature = this.signature(credentials);

		    r.body = AWS.util.queryParamsToString(r.params);
		    r.headers['Content-Length'] = r.body.length;
		  },

		  signature: function signature(credentials) {
		    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
		  },

		  stringToSign: function stringToSign() {
		    var parts = [];
		    parts.push(this.request.method);
		    parts.push(this.request.endpoint.host.toLowerCase());
		    parts.push(this.request.pathname());
		    parts.push(AWS.util.queryParamsToString(this.request.params));
		    return parts.join('\n');
		  }

		});

		/**
		 * @api private
		 */
		module.exports = AWS.Signers.V2;


	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;

		/**
		 * @api private
		 */
		AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
		  addAuthorization: function addAuthorization(credentials, date) {

		    var datetime = AWS.util.date.rfc822(date);

		    this.request.headers['X-Amz-Date'] = datetime;

		    if (credentials.sessionToken) {
		      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
		    }

		    this.request.headers['X-Amzn-Authorization'] =
		      this.authorization(credentials, datetime);

		  },

		  authorization: function authorization(credentials) {
		    return 'AWS3 ' +
		      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
		      'Algorithm=HmacSHA256,' +
		      'SignedHeaders=' + this.signedHeaders() + ',' +
		      'Signature=' + this.signature(credentials);
		  },

		  signedHeaders: function signedHeaders() {
		    var headers = [];
		    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
		      headers.push(h.toLowerCase());
		    });
		    return headers.sort().join(';');
		  },

		  canonicalHeaders: function canonicalHeaders() {
		    var headers = this.request.headers;
		    var parts = [];
		    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
		      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
		    });
		    return parts.sort().join('\n') + '\n';
		  },

		  headersToSign: function headersToSign() {
		    var headers = [];
		    AWS.util.each(this.request.headers, function iterator(k) {
		      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
		        headers.push(k);
		      }
		    });
		    return headers;
		  },

		  signature: function signature(credentials) {
		    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
		  },

		  stringToSign: function stringToSign() {
		    var parts = [];
		    parts.push(this.request.method);
		    parts.push('/');
		    parts.push('');
		    parts.push(this.canonicalHeaders());
		    parts.push(this.request.body);
		    return AWS.util.crypto.sha256(parts.join('\n'));
		  }

		});

		/**
		 * @api private
		 */
		module.exports = AWS.Signers.V3;


	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;

		__webpack_require__(57);

		/**
		 * @api private
		 */
		AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
		  authorization: function authorization(credentials) {
		    return 'AWS3-HTTPS ' +
		      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
		      'Algorithm=HmacSHA256,' +
		      'Signature=' + this.signature(credentials);
		  },

		  stringToSign: function stringToSign() {
		    return this.request.headers['X-Amz-Date'];
		  }
		});

		/**
		 * @api private
		 */
		module.exports = AWS.Signers.V3Https;


	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var v4Credentials = __webpack_require__(60);
		var inherit = AWS.util.inherit;

		/**
		 * @api private
		 */
		var expiresHeader = 'presigned-expires';

		/**
		 * @api private
		 */
		AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
		  constructor: function V4(request, serviceName, options) {
		    AWS.Signers.RequestSigner.call(this, request);
		    this.serviceName = serviceName;
		    options = options || {};
		    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
		    this.operation = options.operation;
		    this.signatureVersion = options.signatureVersion;
		  },

		  algorithm: 'AWS4-HMAC-SHA256',

		  addAuthorization: function addAuthorization(credentials, date) {
		    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');

		    if (this.isPresigned()) {
		      this.updateForPresigned(credentials, datetime);
		    } else {
		      this.addHeaders(credentials, datetime);
		    }

		    this.request.headers['Authorization'] =
		      this.authorization(credentials, datetime);
		  },

		  addHeaders: function addHeaders(credentials, datetime) {
		    this.request.headers['X-Amz-Date'] = datetime;
		    if (credentials.sessionToken) {
		      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
		    }
		  },

		  updateForPresigned: function updateForPresigned(credentials, datetime) {
		    var credString = this.credentialString(datetime);
		    var qs = {
		      'X-Amz-Date': datetime,
		      'X-Amz-Algorithm': this.algorithm,
		      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
		      'X-Amz-Expires': this.request.headers[expiresHeader],
		      'X-Amz-SignedHeaders': this.signedHeaders()
		    };

		    if (credentials.sessionToken) {
		      qs['X-Amz-Security-Token'] = credentials.sessionToken;
		    }

		    if (this.request.headers['Content-Type']) {
		      qs['Content-Type'] = this.request.headers['Content-Type'];
		    }
		    if (this.request.headers['Content-MD5']) {
		      qs['Content-MD5'] = this.request.headers['Content-MD5'];
		    }
		    if (this.request.headers['Cache-Control']) {
		      qs['Cache-Control'] = this.request.headers['Cache-Control'];
		    }

		    // need to pull in any other X-Amz-* headers
		    AWS.util.each.call(this, this.request.headers, function(key, value) {
		      if (key === expiresHeader) return;
		      if (this.isSignableHeader(key)) {
		        var lowerKey = key.toLowerCase();
		        // Metadata should be normalized
		        if (lowerKey.indexOf('x-amz-meta-') === 0) {
		          qs[lowerKey] = value;
		        } else if (lowerKey.indexOf('x-amz-') === 0) {
		          qs[key] = value;
		        }
		      }
		    });

		    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
		    this.request.path += sep + AWS.util.queryParamsToString(qs);
		  },

		  authorization: function authorization(credentials, datetime) {
		    var parts = [];
		    var credString = this.credentialString(datetime);
		    parts.push(this.algorithm + ' Credential=' +
		      credentials.accessKeyId + '/' + credString);
		    parts.push('SignedHeaders=' + this.signedHeaders());
		    parts.push('Signature=' + this.signature(credentials, datetime));
		    return parts.join(', ');
		  },

		  signature: function signature(credentials, datetime) {
		    var signingKey = v4Credentials.getSigningKey(
		      credentials,
		      datetime.substr(0, 8),
		      this.request.region,
		      this.serviceName,
		      this.signatureCache
		    );
		    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
		  },

		  stringToSign: function stringToSign(datetime) {
		    var parts = [];
		    parts.push('AWS4-HMAC-SHA256');
		    parts.push(datetime);
		    parts.push(this.credentialString(datetime));
		    parts.push(this.hexEncodedHash(this.canonicalString()));
		    return parts.join('\n');
		  },

		  canonicalString: function canonicalString() {
		    var parts = [], pathname = this.request.pathname();
		    if (this.serviceName !== 's3' && this.signatureVersion !== 's3v4') pathname = AWS.util.uriEscapePath(pathname);

		    parts.push(this.request.method);
		    parts.push(pathname);
		    parts.push(this.request.search());
		    parts.push(this.canonicalHeaders() + '\n');
		    parts.push(this.signedHeaders());
		    parts.push(this.hexEncodedBodyHash());
		    return parts.join('\n');
		  },

		  canonicalHeaders: function canonicalHeaders() {
		    var headers = [];
		    AWS.util.each.call(this, this.request.headers, function (key, item) {
		      headers.push([key, item]);
		    });
		    headers.sort(function (a, b) {
		      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
		    });
		    var parts = [];
		    AWS.util.arrayEach.call(this, headers, function (item) {
		      var key = item[0].toLowerCase();
		      if (this.isSignableHeader(key)) {
		        var value = item[1];
		        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
		          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
		            code: 'InvalidHeader'
		          });
		        }
		        parts.push(key + ':' +
		          this.canonicalHeaderValues(value.toString()));
		      }
		    });
		    return parts.join('\n');
		  },

		  canonicalHeaderValues: function canonicalHeaderValues(values) {
		    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
		  },

		  signedHeaders: function signedHeaders() {
		    var keys = [];
		    AWS.util.each.call(this, this.request.headers, function (key) {
		      key = key.toLowerCase();
		      if (this.isSignableHeader(key)) keys.push(key);
		    });
		    return keys.sort().join(';');
		  },

		  credentialString: function credentialString(datetime) {
		    return v4Credentials.createScope(
		      datetime.substr(0, 8),
		      this.request.region,
		      this.serviceName
		    );
		  },

		  hexEncodedHash: function hash(string) {
		    return AWS.util.crypto.sha256(string, 'hex');
		  },

		  hexEncodedBodyHash: function hexEncodedBodyHash() {
		    var request = this.request;
		    if (this.isPresigned() && (['s3', 's3-object-lambda'].indexOf(this.serviceName) > -1) && !request.body) {
		      return 'UNSIGNED-PAYLOAD';
		    } else if (request.headers['X-Amz-Content-Sha256']) {
		      return request.headers['X-Amz-Content-Sha256'];
		    } else {
		      return this.hexEncodedHash(this.request.body || '');
		    }
		  },

		  unsignableHeaders: [
		    'authorization',
		    'content-type',
		    'content-length',
		    'user-agent',
		    expiresHeader,
		    'expect',
		    'x-amzn-trace-id'
		  ],

		  isSignableHeader: function isSignableHeader(key) {
		    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
		    return this.unsignableHeaders.indexOf(key) < 0;
		  },

		  isPresigned: function isPresigned() {
		    return this.request.headers[expiresHeader] ? true : false;
		  }

		});

		/**
		 * @api private
		 */
		module.exports = AWS.Signers.V4;


	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);

		/**
		 * @api private
		 */
		var cachedSecret = {};

		/**
		 * @api private
		 */
		var cacheQueue = [];

		/**
		 * @api private
		 */
		var maxCacheEntries = 50;

		/**
		 * @api private
		 */
		var v4Identifier = 'aws4_request';

		/**
		 * @api private
		 */
		module.exports = {
		  /**
		   * @api private
		   *
		   * @param date [String]
		   * @param region [String]
		   * @param serviceName [String]
		   * @return [String]
		   */
		  createScope: function createScope(date, region, serviceName) {
		    return [
		      date.substr(0, 8),
		      region,
		      serviceName,
		      v4Identifier
		    ].join('/');
		  },

		  /**
		   * @api private
		   *
		   * @param credentials [Credentials]
		   * @param date [String]
		   * @param region [String]
		   * @param service [String]
		   * @param shouldCache [Boolean]
		   * @return [String]
		   */
		  getSigningKey: function getSigningKey(
		    credentials,
		    date,
		    region,
		    service,
		    shouldCache
		  ) {
		    var credsIdentifier = AWS.util.crypto
		      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
		    var cacheKey = [credsIdentifier, date, region, service].join('_');
		    shouldCache = shouldCache !== false;
		    if (shouldCache && (cacheKey in cachedSecret)) {
		      return cachedSecret[cacheKey];
		    }

		    var kDate = AWS.util.crypto.hmac(
		      'AWS4' + credentials.secretAccessKey,
		      date,
		      'buffer'
		    );
		    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
		    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

		    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
		    if (shouldCache) {
		      cachedSecret[cacheKey] = signingKey;
		      cacheQueue.push(cacheKey);
		      if (cacheQueue.length > maxCacheEntries) {
		        // remove the oldest entry (not the least recently used)
		        delete cachedSecret[cacheQueue.shift()];
		      }
		    }

		    return signingKey;
		  },

		  /**
		   * @api private
		   *
		   * Empties the derived signing key cache. Made available for testing purposes
		   * only.
		   */
		  emptyCache: function emptyCache() {
		    cachedSecret = {};
		    cacheQueue = [];
		  }
		};


	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;

		/**
		 * @api private
		 */
		AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
		  /**
		   * When building the stringToSign, these sub resource params should be
		   * part of the canonical resource string with their NON-decoded values
		   */
		  subResources: {
		    'acl': 1,
		    'accelerate': 1,
		    'analytics': 1,
		    'cors': 1,
		    'lifecycle': 1,
		    'delete': 1,
		    'inventory': 1,
		    'location': 1,
		    'logging': 1,
		    'metrics': 1,
		    'notification': 1,
		    'partNumber': 1,
		    'policy': 1,
		    'requestPayment': 1,
		    'replication': 1,
		    'restore': 1,
		    'tagging': 1,
		    'torrent': 1,
		    'uploadId': 1,
		    'uploads': 1,
		    'versionId': 1,
		    'versioning': 1,
		    'versions': 1,
		    'website': 1
		  },

		  // when building the stringToSign, these querystring params should be
		  // part of the canonical resource string with their NON-encoded values
		  responseHeaders: {
		    'response-content-type': 1,
		    'response-content-language': 1,
		    'response-expires': 1,
		    'response-cache-control': 1,
		    'response-content-disposition': 1,
		    'response-content-encoding': 1
		  },

		  addAuthorization: function addAuthorization(credentials, date) {
		    if (!this.request.headers['presigned-expires']) {
		      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
		    }

		    if (credentials.sessionToken) {
		      // presigned URLs require this header to be lowercased
		      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
		    }

		    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
		    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;

		    this.request.headers['Authorization'] = auth;
		  },

		  stringToSign: function stringToSign() {
		    var r = this.request;

		    var parts = [];
		    parts.push(r.method);
		    parts.push(r.headers['Content-MD5'] || '');
		    parts.push(r.headers['Content-Type'] || '');

		    // This is the "Date" header, but we use X-Amz-Date.
		    // The S3 signing mechanism requires us to pass an empty
		    // string for this Date header regardless.
		    parts.push(r.headers['presigned-expires'] || '');

		    var headers = this.canonicalizedAmzHeaders();
		    if (headers) parts.push(headers);
		    parts.push(this.canonicalizedResource());

		    return parts.join('\n');

		  },

		  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {

		    var amzHeaders = [];

		    AWS.util.each(this.request.headers, function (name) {
		      if (name.match(/^x-amz-/i))
		        amzHeaders.push(name);
		    });

		    amzHeaders.sort(function (a, b) {
		      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
		    });

		    var parts = [];
		    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
		      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
		    });

		    return parts.join('\n');

		  },

		  canonicalizedResource: function canonicalizedResource() {

		    var r = this.request;

		    var parts = r.path.split('?');
		    var path = parts[0];
		    var querystring = parts[1];

		    var resource = '';

		    if (r.virtualHostedBucket)
		      resource += '/' + r.virtualHostedBucket;

		    resource += path;

		    if (querystring) {

		      // collect a list of sub resources and query params that need to be signed
		      var resources = [];

		      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
		        var name = param.split('=')[0];
		        var value = param.split('=')[1];
		        if (this.subResources[name] || this.responseHeaders[name]) {
		          var subresource = { name: name };
		          if (value !== undefined) {
		            if (this.subResources[name]) {
		              subresource.value = value;
		            } else {
		              subresource.value = decodeURIComponent(value);
		            }
		          }
		          resources.push(subresource);
		        }
		      });

		      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });

		      if (resources.length) {

		        querystring = [];
		        AWS.util.arrayEach(resources, function (res) {
		          if (res.value === undefined) {
		            querystring.push(res.name);
		          } else {
		            querystring.push(res.name + '=' + res.value);
		          }
		        });

		        resource += '?' + querystring.join('&');
		      }

		    }

		    return resource;

		  },

		  sign: function sign(secret, string) {
		    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
		  }
		});

		/**
		 * @api private
		 */
		module.exports = AWS.Signers.S3;


	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);
		var inherit = AWS.util.inherit;

		/**
		 * @api private
		 */
		var expiresHeader = 'presigned-expires';

		/**
		 * @api private
		 */
		function signedUrlBuilder(request) {
		  var expires = request.httpRequest.headers[expiresHeader];
		  var signerClass = request.service.getSignerClass(request);

		  delete request.httpRequest.headers['User-Agent'];
		  delete request.httpRequest.headers['X-Amz-User-Agent'];

		  if (signerClass === AWS.Signers.V4) {
		    if (expires > 604800) { // one week expiry is invalid
		      var message = 'Presigning does not support expiry time greater ' +
		                    'than a week with SigV4 signing.';
		      throw AWS.util.error(new Error(), {
		        code: 'InvalidExpiryTime', message: message, retryable: false
		      });
		    }
		    request.httpRequest.headers[expiresHeader] = expires;
		  } else if (signerClass === AWS.Signers.S3) {
		    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
		    request.httpRequest.headers[expiresHeader] = parseInt(
		      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
		  } else {
		    throw AWS.util.error(new Error(), {
		      message: 'Presigning only supports S3 or SigV4 signing.',
		      code: 'UnsupportedSigner', retryable: false
		    });
		  }
		}

		/**
		 * @api private
		 */
		function signedUrlSigner(request) {
		  var endpoint = request.httpRequest.endpoint;
		  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
		  var queryParams = {};

		  if (parsedUrl.search) {
		    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
		  }

		  var auth = request.httpRequest.headers['Authorization'].split(' ');
		  if (auth[0] === 'AWS') {
		    auth = auth[1].split(':');
		    queryParams['Signature'] = auth.pop();
		    queryParams['AWSAccessKeyId'] = auth.join(':');

		    AWS.util.each(request.httpRequest.headers, function (key, value) {
		      if (key === expiresHeader) key = 'Expires';
		      if (key.indexOf('x-amz-meta-') === 0) {
		        // Delete existing, potentially not normalized key
		        delete queryParams[key];
		        key = key.toLowerCase();
		      }
		      queryParams[key] = value;
		    });
		    delete request.httpRequest.headers[expiresHeader];
		    delete queryParams['Authorization'];
		    delete queryParams['Host'];
		  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
		    auth.shift();
		    var rest = auth.join(' ');
		    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
		    queryParams['X-Amz-Signature'] = signature;
		    delete queryParams['Expires'];
		  }

		  // build URL
		  endpoint.pathname = parsedUrl.pathname;
		  endpoint.search = AWS.util.queryParamsToString(queryParams);
		}

		/**
		 * @api private
		 */
		AWS.Signers.Presign = inherit({
		  /**
		   * @api private
		   */
		  sign: function sign(request, expireTime, callback) {
		    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
		    request.on('build', signedUrlBuilder);
		    request.on('sign', signedUrlSigner);
		    request.removeListener('afterBuild',
		      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
		    request.removeListener('afterBuild',
		      AWS.EventListeners.Core.COMPUTE_SHA256);

		    request.emit('beforePresign', [request]);

		    if (callback) {
		      request.build(function() {
		        if (this.response.error) callback(this.response.error);
		        else {
		          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
		        }
		      });
		    } else {
		      request.build();
		      if (request.response.error) throw request.response.error;
		      return AWS.util.urlFormat(request.httpRequest.endpoint);
		    }
		  }
		});

		/**
		 * @api private
		 */
		module.exports = AWS.Signers.Presign;


	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {

		var AWS = __webpack_require__(1);

		/**
		 * @api private
		 */
		AWS.ParamValidator = AWS.util.inherit({
		  /**
		   * Create a new validator object.
		   *
		   * @param validation [Boolean|map] whether input parameters should be
		   *     validated against the operation description before sending the
		   *     request. Pass a map to enable any of the following specific
		   *     validation features:
		   *
		   *     * **min** [Boolean] &mdash; Validates that a value meets the min
		   *       constraint. This is enabled by default when paramValidation is set
		   *       to `true`.
		   *     * **max** [Boolean] &mdash; Validates that a value meets the max
		   *       constraint.
		   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
		   *       regular expression.
		   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
		   *       of the allowable enum values.
		   */
		  constructor: function ParamValidator(validation) {
		    if (validation === true || validation === undefined) {
		      validation = {'min': true};
		    }
		    this.validation = validation;
		  },

		  validate: function validate(shape, params, context) {
		    this.errors = [];
		    this.validateMember(shape, params || {}, context || 'params');

		    if (this.errors.length > 1) {
		      var msg = this.errors.join('\n* ');
		      msg = 'There were ' + this.errors.length +
		        ' validation errors:\n* ' + msg;
		      throw AWS.util.error(new Error(msg),
		        {code: 'MultipleValidationErrors', errors: this.errors});
		    } else if (this.errors.length === 1) {
		      throw this.errors[0];
		    } else {
		      return true;
		    }
		  },

		  fail: function fail(code, message) {
		    this.errors.push(AWS.util.error(new Error(message), {code: code}));
		  },

		  validateStructure: function validateStructure(shape, params, context) {
		    if (shape.isDocument) return true;

		    this.validateType(params, context, ['object'], 'structure');
		    var paramName;
		    for (var i = 0; shape.required && i < shape.required.length; i++) {
		      paramName = shape.required[i];
		      var value = params[paramName];
		      if (value === undefined || value === null) {
		        this.fail('MissingRequiredParameter',
		          'Missing required key \'' + paramName + '\' in ' + context);
		      }
		    }

		    // validate hash members
		    for (paramName in params) {
		      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;

		      var paramValue = params[paramName],
		          memberShape = shape.members[paramName];

		      if (memberShape !== undefined) {
		        var memberContext = [context, paramName].join('.');
		        this.validateMember(memberShape, paramValue, memberContext);
		      } else if (paramValue !== undefined && paramValue !== null) {
		        this.fail('UnexpectedParameter',
		          'Unexpected key \'' + paramName + '\' found in ' + context);
		      }
		    }

		    return true;
		  },

		  validateMember: function validateMember(shape, param, context) {
		    switch (shape.type) {
		      case 'structure':
		        return this.validateStructure(shape, param, context);
		      case 'list':
		        return this.validateList(shape, param, context);
		      case 'map':
		        return this.validateMap(shape, param, context);
		      default:
		        return this.validateScalar(shape, param, context);
		    }
		  },

		  validateList: function validateList(shape, params, context) {
		    if (this.validateType(params, context, [Array])) {
		      this.validateRange(shape, params.length, context, 'list member count');
		      // validate array members
		      for (var i = 0; i < params.length; i++) {
		        this.validateMember(shape.member, params[i], context + '[' + i + ']');
		      }
		    }
		  },

		  validateMap: function validateMap(shape, params, context) {
		    if (this.validateType(params, context, ['object'], 'map')) {
		      // Build up a count of map members to validate range traits.
		      var mapCount = 0;
		      for (var param in params) {
		        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
		        // Validate any map key trait constraints
		        this.validateMember(shape.key, param,
		                            context + '[key=\'' + param + '\']');
		        this.validateMember(shape.value, params[param],
		                            context + '[\'' + param + '\']');
		        mapCount++;
		      }
		      this.validateRange(shape, mapCount, context, 'map member count');
		    }
		  },

		  validateScalar: function validateScalar(shape, value, context) {
		    switch (shape.type) {
		      case null:
		      case undefined:
		      case 'string':
		        return this.validateString(shape, value, context);
		      case 'base64':
		      case 'binary':
		        return this.validatePayload(value, context);
		      case 'integer':
		      case 'float':
		        return this.validateNumber(shape, value, context);
		      case 'boolean':
		        return this.validateType(value, context, ['boolean']);
		      case 'timestamp':
		        return this.validateType(value, context, [Date,
		          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
		          'Date object, ISO-8601 string, or a UNIX timestamp');
		      default:
		        return this.fail('UnkownType', 'Unhandled type ' +
		                         shape.type + ' for ' + context);
		    }
		  },

		  validateString: function validateString(shape, value, context) {
		    var validTypes = ['string'];
		    if (shape.isJsonValue) {
		      validTypes = validTypes.concat(['number', 'object', 'boolean']);
		    }
		    if (value !== null && this.validateType(value, context, validTypes)) {
		      this.validateEnum(shape, value, context);
		      this.validateRange(shape, value.length, context, 'string length');
		      this.validatePattern(shape, value, context);
		      this.validateUri(shape, value, context);
		    }
		  },

		  validateUri: function validateUri(shape, value, context) {
		    if (shape['location'] === 'uri') {
		      if (value.length === 0) {
		        this.fail('UriParameterError', 'Expected uri parameter to have length >= 1,'
		          + ' but found "' + value +'" for ' + context);
		      }
		    }
		  },

		  validatePattern: function validatePattern(shape, value, context) {
		    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
		      if (!(new RegExp(shape['pattern'])).test(value)) {
		        this.fail('PatternMatchError', 'Provided value "' + value + '" '
		          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
		          + context);
		      }
		    }
		  },

		  validateRange: function validateRange(shape, value, context, descriptor) {
		    if (this.validation['min']) {
		      if (shape['min'] !== undefined && value < shape['min']) {
		        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
		          + shape['min'] + ', but found ' + value + ' for ' + context);
		      }
		    }
		    if (this.validation['max']) {
		      if (shape['max'] !== undefined && value > shape['max']) {
		        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
		          + shape['max'] + ', but found ' + value + ' for ' + context);
		      }
		    }
		  },

		  validateEnum: function validateRange(shape, value, context) {
		    if (this.validation['enum'] && shape['enum'] !== undefined) {
		      // Fail if the string value is not present in the enum list
		      if (shape['enum'].indexOf(value) === -1) {
		        this.fail('EnumError', 'Found string value of ' + value + ', but '
		          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
		      }
		    }
		  },

		  validateType: function validateType(value, context, acceptedTypes, type) {
		    // We will not log an error for null or undefined, but we will return
		    // false so that callers know that the expected type was not strictly met.
		    if (value === null || value === undefined) return false;

		    var foundInvalidType = false;
		    for (var i = 0; i < acceptedTypes.length; i++) {
		      if (typeof acceptedTypes[i] === 'string') {
		        if (typeof value === acceptedTypes[i]) return true;
		      } else if (acceptedTypes[i] instanceof RegExp) {
		        if ((value || '').toString().match(acceptedTypes[i])) return true;
		      } else {
		        if (value instanceof acceptedTypes[i]) return true;
		        if (AWS.util.isType(value, acceptedTypes[i])) return true;
		        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
		        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
		      }
		      foundInvalidType = true;
		    }

		    var acceptedType = type;
		    if (!acceptedType) {
		      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
		    }

		    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
		    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
		              vowel + ' ' + acceptedType);
		    return false;
		  },

		  validateNumber: function validateNumber(shape, value, context) {
		    if (value === null || value === undefined) return;
		    if (typeof value === 'string') {
		      var castedValue = parseFloat(value);
		      if (castedValue.toString() === value) value = castedValue;
		    }
		    if (this.validateType(value, context, ['number'])) {
		      this.validateRange(shape, value, context, 'numeric value');
		    }
		  },

		  validatePayload: function validatePayload(value, context) {
		    if (value === null || value === undefined) return;
		    if (typeof value === 'string') return;
		    if (value && typeof value.byteLength === 'number') return; // typed arrays
		    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
		      var Stream = AWS.util.stream.Stream;
		      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
		    } else {
		      if (typeof Blob !== void 0 && value instanceof Blob) return;
		    }

		    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
		    if (value) {
		      for (var i = 0; i < types.length; i++) {
		        if (AWS.util.isType(value, types[i])) return;
		        if (AWS.util.typeName(value.constructor) === types[i]) return;
		      }
		    }

		    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
		      'string, Buffer, Stream, Blob, or typed array object');
		  }
		});


	/***/ })
	/******/ ])
	});
	;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var Hmac = __webpack_require__(6);
	var Md5 = __webpack_require__(12);
	var Sha1 = __webpack_require__(13);
	var Sha256 = __webpack_require__(14);

	/**
	 * @api private
	 */
	module.exports = exports = {
	    createHash: function createHash(alg) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Md5();
	      } else if (alg === 'sha256') {
	        return new Sha256();
	      } else if (alg === 'sha1') {
	        return new Sha1();
	      }

	      throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createHmac: function createHmac(alg, key) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Hmac(Md5, key);
	      } else if (alg === 'sha256') {
	        return new Hmac(Sha256, key);
	      } else if (alg === 'sha1') {
	        return new Hmac(Sha1, key);
	      }

	      throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createSign: function() {
	      throw new Error('createSign is not implemented in the browser');
	    }
	  };


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var hashUtils = __webpack_require__(7);

	/**
	 * @api private
	 */
	function Hmac(hashCtor, secret) {
	    this.hash = new hashCtor();
	    this.outer = new hashCtor();

	    var inner = bufferFromSecret(hashCtor, secret);
	    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    outer.set(inner);

	    for (var i = 0; i < hashCtor.BLOCK_SIZE; i++) {
	        inner[i] ^= 0x36;
	        outer[i] ^= 0x5c;
	    }

	    this.hash.update(inner);
	    this.outer.update(outer);

	    // Zero out the copied key buffer.
	    for (var i = 0; i < inner.byteLength; i++) {
	        inner[i] = 0;
	    }
	}

	/**
	 * @api private
	 */
	module.exports = exports = Hmac;

	Hmac.prototype.update = function (toHash) {
	    if (hashUtils.isEmptyData(toHash) || this.error) {
	        return this;
	    }

	    try {
	        this.hash.update(hashUtils.convertToBuffer(toHash));
	    } catch (e) {
	        this.error = e;
	    }

	    return this;
	};

	Hmac.prototype.digest = function (encoding) {
	    if (!this.outer.finished) {
	        this.outer.update(this.hash.digest());
	    }

	    return this.outer.digest(encoding);
	};

	function bufferFromSecret(hashCtor, secret) {
	    var input = hashUtils.convertToBuffer(secret);
	    if (input.byteLength > hashCtor.BLOCK_SIZE) {
	        var bufferHash = new hashCtor;
	        bufferHash.update(input);
	        input = bufferHash.digest();
	    }
	    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    buffer.set(input);
	    return buffer;
	}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(8).Buffer;

	/**
	 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
	 * e.g. missing in IE 10.
	 *
	 * @api private
	 */
	if (
	    typeof ArrayBuffer !== 'undefined' &&
	    typeof ArrayBuffer.isView === 'undefined'
	) {
	    ArrayBuffer.isView = function(arg) {
	        return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
	    };
	}

	/**
	 * @api private
	 */
	var viewStrings = [
	    '[object Int8Array]',
	    '[object Uint8Array]',
	    '[object Uint8ClampedArray]',
	    '[object Int16Array]',
	    '[object Uint16Array]',
	    '[object Int32Array]',
	    '[object Uint32Array]',
	    '[object Float32Array]',
	    '[object Float64Array]',
	    '[object DataView]',
	];

	/**
	 * @api private
	 */
	function isEmptyData(data) {
	    if (typeof data === 'string') {
	        return data.length === 0;
	    }
	    return data.byteLength === 0;
	}

	/**
	 * @api private
	 */
	function convertToBuffer(data) {
	    if (typeof data === 'string') {
	        data = new Buffer(data, 'utf8');
	    }

	    if (ArrayBuffer.isView(data)) {
	        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
	    }

	    return new Uint8Array(data);
	}

	/**
	 * @api private
	 */
	module.exports = exports = {
	    isEmptyData: isEmptyData,
	    convertToBuffer: convertToBuffer,
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */

	'use strict'

	var base64 = __webpack_require__(9)
	var ieee754 = __webpack_require__(10)
	var isArray = __webpack_require__(11)

	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50

	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.

	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()

	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()

	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}

	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}

	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }

	  return that
	}

	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */

	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }

	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}

	Buffer.poolSize = 8192 // not used by this implementation

	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}

	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }

	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }

	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }

	  return fromObject(that, value)
	}

	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}

	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}

	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}

	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}

	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}

	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}

	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}

	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }

	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }

	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)

	  var actual = that.write(string, encoding)

	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }

	  return that
	}

	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer

	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }

	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }

	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }

	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}

	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)

	    if (that.length === 0) {
	      return that
	    }

	    obj.copy(that, 0, 0, len)
	    return that
	  }

	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }

	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }

	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}

	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}

	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}

	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}

	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }

	  if (a === b) return 0

	  var x = a.length
	  var y = b.length

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}

	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }

	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }

	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }

	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}

	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }

	  var len = string.length
	  if (len === 0) return 0

	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength

	function slowToString (encoding, start, end) {
	  var loweredCase = false

	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.

	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }

	  if (end === undefined || end > this.length) {
	    end = this.length
	  }

	  if (end <= 0) {
	    return ''
	  }

	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0

	  if (end <= start) {
	    return ''
	  }

	  if (!encoding) encoding = 'utf8'

	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)

	      case 'ascii':
	        return asciiSlice(this, start, end)

	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)

	      case 'base64':
	        return base64Slice(this, start, end)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true

	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}

	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}

	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}

	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}

	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}

	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}

	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}

	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }

	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }

	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }

	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }

	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0

	  if (this === target) return 0

	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)

	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)

	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1

	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }

	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }

	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }

	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }

	  throw new TypeError('val must be string, number or Buffer')
	}

	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length

	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }

	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }

	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }

	  return -1
	}

	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}

	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}

	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}

	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }

	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}

	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}

	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}

	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}

	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}

	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}

	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }

	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining

	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }

	  if (!encoding) encoding = 'utf8'

	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)

	      case 'ascii':
	        return asciiWrite(this, string, offset, length)

	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)

	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}

	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}

	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []

	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1

	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint

	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }

	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }

	    res.push(codePoint)
	    i += bytesPerSequence
	  }

	  return decodeCodePointsArray(res)
	}

	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000

	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }

	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}

	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}

	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}

	function hexSlice (buf, start, end) {
	  var len = buf.length

	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len

	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}

	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}

	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end

	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }

	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }

	  if (end < start) end = start

	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }

	  return newBuf
	}

	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}

	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }

	  return val
	}

	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }

	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }

	  return val
	}

	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}

	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}

	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}

	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}

	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}

	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}

	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}

	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}

	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}

	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}

	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}

	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}

	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}

	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}

	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}

	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}

	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}

	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}

	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}

	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}

	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start

	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0

	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')

	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }

	  var len = end - start
	  var i

	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }

	  return len
	}

	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }

	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }

	  if (end <= start) {
	    return this
	  }

	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0

	  if (!val) val = 0

	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }

	  return this
	}

	// HELPER FUNCTIONS
	// ================

	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}

	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}

	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}

	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []

	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)

	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }

	        // valid lead
	        leadSurrogate = codePoint

	        continue
	      }

	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }

	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }

	    leadSurrogate = null

	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }

	  return bytes
	}

	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}

	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break

	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }

	  return byteArray
	}

	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}

	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}

	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict'

	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray

	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}

	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63

	function getLens (b64) {
	  var len = b64.length

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len

	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)

	  return [validLen, placeHoldersLen]
	}

	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]

	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

	  var curByte = 0

	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen

	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }

	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }

	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }

	  return parts.join('')
	}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]

	  i += d

	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}

	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

	  value = Math.abs(value)

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }

	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var hashUtils = __webpack_require__(7);
	var Buffer = __webpack_require__(8).Buffer;

	var BLOCK_SIZE = 64;

	var DIGEST_LENGTH = 16;

	var INIT = [
	    0x67452301,
	    0xefcdab89,
	    0x98badcfe,
	    0x10325476,
	];

	/**
	 * @api private
	 */
	function Md5() {
	    this.state = [
	        0x67452301,
	        0xefcdab89,
	        0x98badcfe,
	        0x10325476,
	    ];
	    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    this.finished = false;
	}

	/**
	 * @api private
	 */
	module.exports = exports = Md5;

	Md5.BLOCK_SIZE = BLOCK_SIZE;

	Md5.prototype.update = function (sourceData) {
	    if (hashUtils.isEmptyData(sourceData)) {
	        return this;
	    } else if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }

	    var data = hashUtils.convertToBuffer(sourceData);
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    while (byteLength > 0) {
	        this.buffer.setUint8(this.bufferLength++, data[position++]);
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }

	    return this;
	};

	Md5.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
	        var bitsHashed = bytesHashed * 8;
	        buffer.setUint8(this.bufferLength++, 128);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                buffer.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            buffer.setUint8(i, 0);
	        }
	        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
	        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
	    for (var i = 0; i < 4; i++) {
	        out.setUint32(i * 4, this.state[i], true);
	    }
	    var buff = new Buffer(out.buffer, out.byteOffset, out.byteLength);
	    return encoding ? buff.toString(encoding) : buff;
	};

	Md5.prototype.hashBuffer = function () {
	    var _a = this, buffer = _a.buffer, state = _a.state;
	    var a = state[0], b = state[1], c = state[2], d = state[3];
	    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
	    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
	    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
	    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
	    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
	    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
	    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
	    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
	    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
	    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
	    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
	    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
	    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
	    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
	    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
	    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
	    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
	    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
	    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
	    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
	    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
	    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
	    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
	    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
	    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
	    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
	    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
	    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
	    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
	    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
	    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
	    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
	    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
	    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
	    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
	    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
	    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
	    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
	    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
	    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
	    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
	    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
	    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
	    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
	    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
	    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
	    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
	    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
	    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
	    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
	    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
	    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
	    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
	    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
	    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
	    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
	    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
	    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
	    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
	    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
	    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
	    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
	    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
	    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
	    state[0] = (a + state[0]) & 0xFFFFFFFF;
	    state[1] = (b + state[1]) & 0xFFFFFFFF;
	    state[2] = (c + state[2]) & 0xFFFFFFFF;
	    state[3] = (d + state[3]) & 0xFFFFFFFF;
	};

	function cmn(q, a, b, x, s, t) {
	    a = (((a + q) & 0xFFFFFFFF) + ((x + t) & 0xFFFFFFFF)) & 0xFFFFFFFF;
	    return (((a << s) | (a >>> (32 - s))) + b) & 0xFFFFFFFF;
	}

	function ff(a, b, c, d, x, s, t) {
	    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}

	function gg(a, b, c, d, x, s, t) {
	    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}

	function hh(a, b, c, d, x, s, t) {
	    return cmn(b ^ c ^ d, a, b, x, s, t);
	}

	function ii(a, b, c, d, x, s, t) {
	    return cmn(c ^ (b | (~d)), a, b, x, s, t);
	}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(8).Buffer;
	var hashUtils = __webpack_require__(7);

	var BLOCK_SIZE = 64;

	var DIGEST_LENGTH = 20;

	var KEY = new Uint32Array([
	    0x5a827999,
	    0x6ed9eba1,
	    0x8f1bbcdc | 0,
	    0xca62c1d6 | 0
	]);

	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];

	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

	/**
	 * @api private
	 */
	function Sha1() {
	    this.h0 = 0x67452301;
	    this.h1 = 0xEFCDAB89;
	    this.h2 = 0x98BADCFE;
	    this.h3 = 0x10325476;
	    this.h4 = 0xC3D2E1F0;
	    // The first 64 bytes (16 words) is the data chunk
	    this.block = new Uint32Array(80);
	    this.offset = 0;
	    this.shift = 24;
	    this.totalLength = 0;
	}

	/**
	 * @api private
	 */
	module.exports = exports = Sha1;

	Sha1.BLOCK_SIZE = BLOCK_SIZE;

	Sha1.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }

	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }

	    data = hashUtils.convertToBuffer(data);

	    var length = data.length;
	    this.totalLength += length * 8;
	    for (var i = 0; i < length; i++) {
	        this.write(data[i]);
	    }

	    return this;
	};

	Sha1.prototype.write = function write(byte) {
	    this.block[this.offset] |= (byte & 0xff) << this.shift;
	    if (this.shift) {
	        this.shift -= 8;
	    } else {
	        this.offset++;
	        this.shift = 24;
	    }

	    if (this.offset === 16) this.processBlock();
	};

	Sha1.prototype.digest = function (encoding) {
	    // Pad
	    this.write(0x80);
	    if (this.offset > 14 || (this.offset === 14 && this.shift < 24)) {
	      this.processBlock();
	    }
	    this.offset = 14;
	    this.shift = 24;

	    // 64-bit length big-endian
	    this.write(0x00); // numbers this big aren't accurate in javascript anyway
	    this.write(0x00); // ..So just hard-code to zero.
	    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
	    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
	    for (var s = 24; s >= 0; s -= 8) {
	        this.write(this.totalLength >> s);
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    var outView = new DataView(out.buffer);
	    outView.setUint32(0, this.h0, false);
	    outView.setUint32(4, this.h1, false);
	    outView.setUint32(8, this.h2, false);
	    outView.setUint32(12, this.h3, false);
	    outView.setUint32(16, this.h4, false);

	    return encoding ? out.toString(encoding) : out;
	};

	Sha1.prototype.processBlock = function processBlock() {
	    // Extend the sixteen 32-bit words into eighty 32-bit words:
	    for (var i = 16; i < 80; i++) {
	      var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
	      this.block[i] = (w << 1) | (w >>> 31);
	    }

	    // Initialize hash value for this chunk:
	    var a = this.h0;
	    var b = this.h1;
	    var c = this.h2;
	    var d = this.h3;
	    var e = this.h4;
	    var f, k;

	    // Main loop:
	    for (i = 0; i < 80; i++) {
	      if (i < 20) {
	        f = d ^ (b & (c ^ d));
	        k = 0x5A827999;
	      }
	      else if (i < 40) {
	        f = b ^ c ^ d;
	        k = 0x6ED9EBA1;
	      }
	      else if (i < 60) {
	        f = (b & c) | (d & (b | c));
	        k = 0x8F1BBCDC;
	      }
	      else {
	        f = b ^ c ^ d;
	        k = 0xCA62C1D6;
	      }
	      var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i]|0);
	      e = d;
	      d = c;
	      c = (b << 30 | b >>> 2);
	      b = a;
	      a = temp;
	    }

	    // Add this chunk's hash to result so far:
	    this.h0 = (this.h0 + a) | 0;
	    this.h1 = (this.h1 + b) | 0;
	    this.h2 = (this.h2 + c) | 0;
	    this.h3 = (this.h3 + d) | 0;
	    this.h4 = (this.h4 + e) | 0;

	    // The block is now reusable.
	    this.offset = 0;
	    for (i = 0; i < 16; i++) {
	        this.block[i] = 0;
	    }
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(8).Buffer;
	var hashUtils = __webpack_require__(7);

	var BLOCK_SIZE = 64;

	var DIGEST_LENGTH = 32;

	var KEY = new Uint32Array([
	    0x428a2f98,
	    0x71374491,
	    0xb5c0fbcf,
	    0xe9b5dba5,
	    0x3956c25b,
	    0x59f111f1,
	    0x923f82a4,
	    0xab1c5ed5,
	    0xd807aa98,
	    0x12835b01,
	    0x243185be,
	    0x550c7dc3,
	    0x72be5d74,
	    0x80deb1fe,
	    0x9bdc06a7,
	    0xc19bf174,
	    0xe49b69c1,
	    0xefbe4786,
	    0x0fc19dc6,
	    0x240ca1cc,
	    0x2de92c6f,
	    0x4a7484aa,
	    0x5cb0a9dc,
	    0x76f988da,
	    0x983e5152,
	    0xa831c66d,
	    0xb00327c8,
	    0xbf597fc7,
	    0xc6e00bf3,
	    0xd5a79147,
	    0x06ca6351,
	    0x14292967,
	    0x27b70a85,
	    0x2e1b2138,
	    0x4d2c6dfc,
	    0x53380d13,
	    0x650a7354,
	    0x766a0abb,
	    0x81c2c92e,
	    0x92722c85,
	    0xa2bfe8a1,
	    0xa81a664b,
	    0xc24b8b70,
	    0xc76c51a3,
	    0xd192e819,
	    0xd6990624,
	    0xf40e3585,
	    0x106aa070,
	    0x19a4c116,
	    0x1e376c08,
	    0x2748774c,
	    0x34b0bcb5,
	    0x391c0cb3,
	    0x4ed8aa4a,
	    0x5b9cca4f,
	    0x682e6ff3,
	    0x748f82ee,
	    0x78a5636f,
	    0x84c87814,
	    0x8cc70208,
	    0x90befffa,
	    0xa4506ceb,
	    0xbef9a3f7,
	    0xc67178f2
	]);

	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];

	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

	/**
	 * @private
	 */
	function Sha256() {
	    this.state = [
	        0x6a09e667,
	        0xbb67ae85,
	        0x3c6ef372,
	        0xa54ff53a,
	        0x510e527f,
	        0x9b05688c,
	        0x1f83d9ab,
	        0x5be0cd19,
	    ];
	    this.temp = new Int32Array(64);
	    this.buffer = new Uint8Array(64);
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    /**
	     * @private
	     */
	    this.finished = false;
	}

	/**
	 * @api private
	 */
	module.exports = exports = Sha256;

	Sha256.BLOCK_SIZE = BLOCK_SIZE;

	Sha256.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }

	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }

	    data = hashUtils.convertToBuffer(data);

	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
	        throw new Error('Cannot hash more than 2^53 - 1 bits');
	    }

	    while (byteLength > 0) {
	        this.buffer[this.bufferLength++] = data[position++];
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }

	    return this;
	};

	Sha256.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var bitsHashed = this.bytesHashed * 8;
	        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
	        var undecoratedLength = this.bufferLength;
	        bufferView.setUint8(this.bufferLength++, 0x80);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                bufferView.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            bufferView.setUint8(i, 0);
	        }
	        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
	        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    for (var i = 0; i < 8; i++) {
	        out[i * 4] = (this.state[i] >>> 24) & 0xff;
	        out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
	        out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
	        out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
	    }
	    return encoding ? out.toString(encoding) : out;
	};

	Sha256.prototype.hashBuffer = function () {
	    var _a = this,
	        buffer = _a.buffer,
	        state = _a.state;
	    var state0 = state[0],
	        state1 = state[1],
	        state2 = state[2],
	        state3 = state[3],
	        state4 = state[4],
	        state5 = state[5],
	        state6 = state[6],
	        state7 = state[7];
	    for (var i = 0; i < BLOCK_SIZE; i++) {
	        if (i < 16) {
	            this.temp[i] = (((buffer[i * 4] & 0xff) << 24) |
	                ((buffer[(i * 4) + 1] & 0xff) << 16) |
	                ((buffer[(i * 4) + 2] & 0xff) << 8) |
	                (buffer[(i * 4) + 3] & 0xff));
	        }
	        else {
	            var u = this.temp[i - 2];
	            var t1_1 = (u >>> 17 | u << 15) ^
	                (u >>> 19 | u << 13) ^
	                (u >>> 10);
	            u = this.temp[i - 15];
	            var t2_1 = (u >>> 7 | u << 25) ^
	                (u >>> 18 | u << 14) ^
	                (u >>> 3);
	            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) +
	                (t2_1 + this.temp[i - 16] | 0);
	        }
	        var t1 = (((((state4 >>> 6 | state4 << 26) ^
	            (state4 >>> 11 | state4 << 21) ^
	            (state4 >>> 25 | state4 << 7))
	            + ((state4 & state5) ^ (~state4 & state6))) | 0)
	            + ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) | 0;
	        var t2 = (((state0 >>> 2 | state0 << 30) ^
	            (state0 >>> 13 | state0 << 19) ^
	            (state0 >>> 22 | state0 << 10)) + ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) | 0;
	        state7 = state6;
	        state6 = state5;
	        state5 = state4;
	        state4 = (state3 + t1) | 0;
	        state3 = state2;
	        state2 = state1;
	        state1 = state0;
	        state0 = (t1 + t2) | 0;
	    }
	    state[0] += state0;
	    state[1] += state1;
	    state[2] += state2;
	    state[3] += state3;
	    state[4] += state4;
	    state[5] += state5;
	    state[6] += state6;
	    state[7] += state7;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var punycode = __webpack_require__(16);

	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;

	exports.Url = Url;

	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}

	// Reference: RFC 3986, RFC 1808, RFC 2396

	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,

	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(18);

	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;

	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}

	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }

	  var rest = url;

	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();

	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }

	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }

	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {

	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c

	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.

	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }

	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }

	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }

	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;

	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);

	    // pull out port.
	    this.parseHost();

	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';

	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';

	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }

	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }

	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }

	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;

	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }

	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {

	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }


	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }

	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }

	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};

	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}

	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }

	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';

	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }

	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }

	  var search = this.search || (query && ('?' + query)) || '';

	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }

	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;

	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');

	  return protocol + host + pathname + search + hash;
	};

	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}

	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};

	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}

	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }

	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);

	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;

	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }

	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });

	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }

	    result.href = result.format();
	    return result;
	  }

	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }

	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }

	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];

	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }

	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }

	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }

	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');

	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }

	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }

	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }

	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }

	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');

	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }

	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }

	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }

	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};

	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};

	function isString(arg) {
	  return typeof arg === "string";
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {

		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}

		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,

		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'

		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},

		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,

		/** Temporary variable */
		key;

		/*--------------------------------------------------------------------------*/

		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}

		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}

		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}

		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}

		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}

		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}

		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}

		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}

		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;

			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.

			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}

			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}

			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.

			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

					if (index >= inputLength) {
						error('invalid-input');
					}

					digit = basicToDigit(input.charCodeAt(index++));

					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}

					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

					if (digit < t) {
						break;
					}

					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}

					w *= baseMinusT;

				}

				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);

				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}

				n += floor(i / out);
				i %= out;

				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);

			}

			return ucs2encode(output);
		}

		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;

			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);

			// Cache the length
			inputLength = input.length;

			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;

			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}

			handledCPCount = basicLength = output.length;

			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.

			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}

			// Main encoding loop:
			while (handledCPCount < inputLength) {

				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}

				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}

				delta += (m - n) * handledCPCountPlusOne;
				n = m;

				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];

					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}

					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}

						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}

				++delta;
				++n;

			}
			return output.join('');
		}

		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}

		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}

		/*--------------------------------------------------------------------------*/

		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};

		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}

	}(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)(module), (function() { return this; }())))

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.decode = exports.parse = __webpack_require__(19);
	exports.encode = exports.stringify = __webpack_require__(20);


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = {
	  //provide realtime clock for performance measurement
	  now: function now() {
	    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
	      return performance.now();
	    }
	    return Date.now();
	  }
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var eventMessageChunker = __webpack_require__(23).eventMessageChunker;
	var parseEvent = __webpack_require__(24).parseEvent;

	function createEventStream(body, parser, model) {
	    var eventMessages = eventMessageChunker(body);

	    var events = [];

	    for (var i = 0; i < eventMessages.length; i++) {
	        events.push(parseEvent(parser, eventMessages[i], model));
	    }

	    return events;
	}

	/**
	 * @api private
	 */
	module.exports = {
	    createEventStream: createEventStream
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * Takes in a buffer of event messages and splits them into individual messages.
	 * @param {Buffer} buffer
	 * @api private
	 */
	function eventMessageChunker(buffer) {
	    /** @type Buffer[] */
	    var messages = [];
	    var offset = 0;

	    while (offset < buffer.length) {
	        var totalLength = buffer.readInt32BE(offset);

	        // create new buffer for individual message (shares memory with original)
	        var message = buffer.slice(offset, totalLength + offset);
	        // increment offset to it starts at the next message
	        offset += totalLength;

	        messages.push(message);
	    }

	    return messages;
	}

	/**
	 * @api private
	 */
	module.exports = {
	    eventMessageChunker: eventMessageChunker
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var parseMessage = __webpack_require__(25).parseMessage;

	/**
	 *
	 * @param {*} parser
	 * @param {Buffer} message
	 * @param {*} shape
	 * @api private
	 */
	function parseEvent(parser, message, shape) {
	    var parsedMessage = parseMessage(message);

	    // check if message is an event or error
	    var messageType = parsedMessage.headers[':message-type'];
	    if (messageType) {
	        if (messageType.value === 'error') {
	            throw parseError(parsedMessage);
	        } else if (messageType.value !== 'event') {
	            // not sure how to parse non-events/non-errors, ignore for now
	            return;
	        }
	    }

	    // determine event type
	    var eventType = parsedMessage.headers[':event-type'];
	    // check that the event type is modeled
	    var eventModel = shape.members[eventType.value];
	    if (!eventModel) {
	        return;
	    }

	    var result = {};
	    // check if an event payload exists
	    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
	    if (eventPayloadMemberName) {
	        var payloadShape = eventModel.members[eventPayloadMemberName];
	        // if the shape is binary, return the byte array
	        if (payloadShape.type === 'binary') {
	            result[eventPayloadMemberName] = parsedMessage.body;
	        } else {
	            result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
	        }
	    }

	    // read event headers
	    var eventHeaderNames = eventModel.eventHeaderMemberNames;
	    for (var i = 0; i < eventHeaderNames.length; i++) {
	        var name = eventHeaderNames[i];
	        if (parsedMessage.headers[name]) {
	            // parse the header!
	            result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
	        }
	    }

	    var output = {};
	    output[eventType.value] = result;
	    return output;
	}

	function parseError(message) {
	    var errorCode = message.headers[':error-code'];
	    var errorMessage = message.headers[':error-message'];
	    var error = new Error(errorMessage.value || errorMessage);
	    error.code = error.name = errorCode.value || errorCode;
	    return error;
	}

	/**
	 * @api private
	 */
	module.exports = {
	    parseEvent: parseEvent
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var Int64 = __webpack_require__(26).Int64;

	var splitMessage = __webpack_require__(27).splitMessage;

	var BOOLEAN_TAG = 'boolean';
	var BYTE_TAG = 'byte';
	var SHORT_TAG = 'short';
	var INT_TAG = 'integer';
	var LONG_TAG = 'long';
	var BINARY_TAG = 'binary';
	var STRING_TAG = 'string';
	var TIMESTAMP_TAG = 'timestamp';
	var UUID_TAG = 'uuid';

	/**
	 * @api private
	 *
	 * @param {Buffer} headers
	 */
	function parseHeaders(headers) {
	    var out = {};
	    var position = 0;
	    while (position < headers.length) {
	        var nameLength = headers.readUInt8(position++);
	        var name = headers.slice(position, position + nameLength).toString();
	        position += nameLength;
	        switch (headers.readUInt8(position++)) {
	            case 0 /* boolTrue */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: true
	                };
	                break;
	            case 1 /* boolFalse */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: false
	                };
	                break;
	            case 2 /* byte */:
	                out[name] = {
	                    type: BYTE_TAG,
	                    value: headers.readInt8(position++)
	                };
	                break;
	            case 3 /* short */:
	                out[name] = {
	                    type: SHORT_TAG,
	                    value: headers.readInt16BE(position)
	                };
	                position += 2;
	                break;
	            case 4 /* integer */:
	                out[name] = {
	                    type: INT_TAG,
	                    value: headers.readInt32BE(position)
	                };
	                position += 4;
	                break;
	            case 5 /* long */:
	                out[name] = {
	                    type: LONG_TAG,
	                    value: new Int64(headers.slice(position, position + 8))
	                };
	                position += 8;
	                break;
	            case 6 /* byteArray */:
	                var binaryLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: BINARY_TAG,
	                    value: headers.slice(position, position + binaryLength)
	                };
	                position += binaryLength;
	                break;
	            case 7 /* string */:
	                var stringLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: STRING_TAG,
	                    value: headers.slice(
	                        position,
	                        position + stringLength
	                    ).toString()
	                };
	                position += stringLength;
	                break;
	            case 8 /* timestamp */:
	                out[name] = {
	                    type: TIMESTAMP_TAG,
	                    value: new Date(
	                        new Int64(headers.slice(position, position + 8))
	                            .valueOf()
	                    )
	                };
	                position += 8;
	                break;
	            case 9 /* uuid */:
	                var uuidChars = headers.slice(position, position + 16)
	                    .toString('hex');
	                position += 16;
	                out[name] = {
	                    type: UUID_TAG,
	                    value: uuidChars.substr(0, 8) + '-' +
	                        uuidChars.substr(8, 4) + '-' +
	                        uuidChars.substr(12, 4) + '-' +
	                        uuidChars.substr(16, 4) + '-' +
	                        uuidChars.substr(20)
	                };
	                break;
	            default:
	                throw new Error('Unrecognized header type tag');
	        }
	    }
	    return out;
	}

	function parseMessage(message) {
	    var parsed = splitMessage(message);
	    return { headers: parseHeaders(parsed.headers), body: parsed.body };
	}

	/**
	 * @api private
	 */
	module.exports = {
	    parseMessage: parseMessage
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var toBuffer = util.buffer.toBuffer;

	/**
	 * A lossless representation of a signed, 64-bit integer. Instances of this
	 * class may be used in arithmetic expressions as if they were numeric
	 * primitives, but the binary representation will be preserved unchanged as the
	 * `bytes` property of the object. The bytes should be encoded as big-endian,
	 * two's complement integers.
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function Int64(bytes) {
	    if (bytes.length !== 8) {
	        throw new Error('Int64 buffers must be exactly 8 bytes');
	    }
	    if (!util.Buffer.isBuffer(bytes)) bytes = toBuffer(bytes);

	    this.bytes = bytes;
	}

	/**
	 * @param {number} number
	 * @returns {Int64}
	 *
	 * @api private
	 */
	Int64.fromNumber = function(number) {
	    if (number > 9223372036854775807 || number < -9223372036854775808) {
	        throw new Error(
	            number + ' is too large (or, if negative, too small) to represent as an Int64'
	        );
	    }

	    var bytes = new Uint8Array(8);
	    for (
	        var i = 7, remaining = Math.abs(Math.round(number));
	        i > -1 && remaining > 0;
	        i--, remaining /= 256
	    ) {
	        bytes[i] = remaining;
	    }

	    if (number < 0) {
	        negate(bytes);
	    }

	    return new Int64(bytes);
	};

	/**
	 * @returns {number}
	 *
	 * @api private
	 */
	Int64.prototype.valueOf = function() {
	    var bytes = this.bytes.slice(0);
	    var negative = bytes[0] & 128;
	    if (negative) {
	        negate(bytes);
	    }

	    return parseInt(bytes.toString('hex'), 16) * (negative ? -1 : 1);
	};

	Int64.prototype.toString = function() {
	    return String(this.valueOf());
	};

	/**
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function negate(bytes) {
	    for (var i = 0; i < 8; i++) {
	        bytes[i] ^= 0xFF;
	    }
	    for (var i = 7; i > -1; i--) {
	        bytes[i]++;
	        if (bytes[i] !== 0) {
	            break;
	        }
	    }
	}

	/**
	 * @api private
	 */
	module.exports = {
	    Int64: Int64
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var toBuffer = util.buffer.toBuffer;

	// All prelude components are unsigned, 32-bit integers
	var PRELUDE_MEMBER_LENGTH = 4;
	// The prelude consists of two components
	var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
	// Checksums are always CRC32 hashes.
	var CHECKSUM_LENGTH = 4;
	// Messages must include a full prelude, a prelude checksum, and a message checksum
	var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;

	/**
	 * @api private
	 *
	 * @param {Buffer} message
	 */
	function splitMessage(message) {
	    if (!util.Buffer.isBuffer(message)) message = toBuffer(message);

	    if (message.length < MINIMUM_MESSAGE_LENGTH) {
	        throw new Error('Provided message too short to accommodate event stream message overhead');
	    }

	    if (message.length !== message.readUInt32BE(0)) {
	        throw new Error('Reported message length does not match received message length');
	    }

	    var expectedPreludeChecksum = message.readUInt32BE(PRELUDE_LENGTH);

	    if (
	        expectedPreludeChecksum !== util.crypto.crc32(
	            message.slice(0, PRELUDE_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The prelude checksum specified in the message (' +
	            expectedPreludeChecksum +
	            ') does not match the calculated CRC32 checksum.'
	        );
	    }

	    var expectedMessageChecksum = message.readUInt32BE(message.length - CHECKSUM_LENGTH);

	    if (
	        expectedMessageChecksum !== util.crypto.crc32(
	            message.slice(0, message.length - CHECKSUM_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The message checksum did not match the expected value of ' +
	                expectedMessageChecksum
	        );
	    }

	    var headersStart = PRELUDE_LENGTH + CHECKSUM_LENGTH;
	    var headersEnd = headersStart + message.readUInt32BE(PRELUDE_MEMBER_LENGTH);

	    return {
	        headers: message.slice(headersStart, headersEnd),
	        body: message.slice(headersEnd, message.length - CHECKSUM_LENGTH),
	    };
	}

	/**
	 * @api private
	 */
	module.exports = {
	    splitMessage: splitMessage
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	/**
	 * Represents your AWS security credentials, specifically the
	 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
	 * Creating a `Credentials` object allows you to pass around your
	 * security information to configuration and service objects.
	 *
	 * Note that this class typically does not need to be constructed manually,
	 * as the {AWS.Config} and {AWS.Service} classes both accept simple
	 * options hashes with the three keys. These structures will be converted
	 * into Credentials objects automatically.
	 *
	 * ## Expiring and Refreshing Credentials
	 *
	 * Occasionally credentials can expire in the middle of a long-running
	 * application. In this case, the SDK will automatically attempt to
	 * refresh the credentials from the storage location if the Credentials
	 * class implements the {refresh} method.
	 *
	 * If you are implementing a credential storage location, you
	 * will want to create a subclass of the `Credentials` class and
	 * override the {refresh} method. This method allows credentials to be
	 * retrieved from the backing store, be it a file system, database, or
	 * some network storage. The method should reset the credential attributes
	 * on the object.
	 *
	 * @!attribute expired
	 *   @return [Boolean] whether the credentials have been expired and
	 *     require a refresh. Used in conjunction with {expireTime}.
	 * @!attribute expireTime
	 *   @return [Date] a time when credentials should be considered expired. Used
	 *     in conjunction with {expired}.
	 * @!attribute accessKeyId
	 *   @return [String] the AWS access key ID
	 * @!attribute secretAccessKey
	 *   @return [String] the AWS secret access key
	 * @!attribute sessionToken
	 *   @return [String] an optional AWS session token
	 */
	AWS.Credentials = AWS.util.inherit({
	  /**
	   * A credentials object can be created using positional arguments or an options
	   * hash.
	   *
	   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
	   *   Creates a Credentials object with a given set of credential information
	   *   as positional arguments.
	   *   @param accessKeyId [String] the AWS access key ID
	   *   @param secretAccessKey [String] the AWS secret access key
	   *   @param sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
	   * @overload AWS.Credentials(options)
	   *   Creates a Credentials object with a given set of credential information
	   *   as an options hash.
	   *   @option options accessKeyId [String] the AWS access key ID
	   *   @option options secretAccessKey [String] the AWS secret access key
	   *   @option options sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials({
	   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
	   *     });
	   */
	  constructor: function Credentials() {
	    // hide secretAccessKey from being displayed with util.inspect
	    AWS.util.hideProperties(this, ['secretAccessKey']);

	    this.expired = false;
	    this.expireTime = null;
	    this.refreshCallbacks = [];
	    if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      var creds = arguments[0].credentials || arguments[0];
	      this.accessKeyId = creds.accessKeyId;
	      this.secretAccessKey = creds.secretAccessKey;
	      this.sessionToken = creds.sessionToken;
	    } else {
	      this.accessKeyId = arguments[0];
	      this.secretAccessKey = arguments[1];
	      this.sessionToken = arguments[2];
	    }
	  },

	  /**
	   * @return [Integer] the number of seconds before {expireTime} during which
	   *   the credentials will be considered expired.
	   */
	  expiryWindow: 15,

	  /**
	   * @return [Boolean] whether the credentials object should call {refresh}
	   * @note Subclasses should override this method to provide custom refresh
	   *   logic.
	   */
	  needsRefresh: function needsRefresh() {
	    var currentTime = AWS.util.date.getDate().getTime();
	    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

	    if (this.expireTime && adjustedTime > this.expireTime) {
	      return true;
	    } else {
	      return this.expired || !this.accessKeyId || !this.secretAccessKey;
	    }
	  },

	  /**
	   * Gets the existing credentials, refreshing them if they are not yet loaded
	   * or have expired. Users should call this method before using {refresh},
	   * as this will not attempt to reload credentials when they are already
	   * loaded into the object.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means either credentials
	   *   do not need to be refreshed or refreshed credentials information has
	   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
	   *   and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   */
	  get: function get(callback) {
	    var self = this;
	    if (this.needsRefresh()) {
	      this.refresh(function(err) {
	        if (!err) self.expired = false; // reset expired flag
	        if (callback) callback(err);
	      });
	    } else if (callback) {
	      callback();
	    }
	  },

	  /**
	   * @!method  getPromise()
	   *   Returns a 'thenable' promise.
	   *   Gets the existing credentials, refreshing them if they are not yet loaded
	   *   or have expired. Users should call this method before using {refresh},
	   *   as this will not attempt to reload credentials when they are already
	   *   loaded into the object.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means either credentials do not need to be refreshed or refreshed
	   *     credentials information has been loaded into the object (as the
	   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `get` call.
	   *   @example Calling the `getPromise` method.
	   *     var promise = credProvider.getPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */

	  /**
	   * @!method  refreshPromise()
	   *   Returns a 'thenable' promise.
	   *   Refreshes the credentials. Users should call {get} before attempting
	   *   to forcibly refresh credentials.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means refreshed credentials information has been loaded into the object
	   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Calling the `refreshPromise` method.
	   *     var promise = credProvider.refreshPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */

	  /**
	   * Refreshes the credentials. Users should call {get} before attempting
	   * to forcibly refresh credentials.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means refreshed
	   *   credentials information has been loaded into the object (as the
	   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @note Subclasses should override this class to reset the
	   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
	   *   on the credentials object and then call the callback with
	   *   any error information.
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.expired = false;
	    callback();
	  },

	  /**
	   * @api private
	   * @param callback
	   */
	  coalesceRefresh: function coalesceRefresh(callback, sync) {
	    var self = this;
	    if (self.refreshCallbacks.push(callback) === 1) {
	      self.load(function onLoad(err) {
	        AWS.util.arrayEach(self.refreshCallbacks, function(callback) {
	          if (sync) {
	            callback(err);
	          } else {
	            // callback could throw, so defer to ensure all callbacks are notified
	            AWS.util.defer(function () {
	              callback(err);
	            });
	          }
	        });
	        self.refreshCallbacks.length = 0;
	      });
	    }
	  },

	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    callback();
	  }
	});

	/**
	 * @api private
	 */
	AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
	  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
	};

	/**
	 * @api private
	 */
	AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getPromise;
	  delete this.prototype.refreshPromise;
	};

	AWS.util.addPromises(AWS.Credentials);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	/**
	 * Creates a credential provider chain that searches for AWS credentials
	 * in a list of credential providers specified by the {providers} property.
	 *
	 * By default, the chain will use the {defaultProviders} to resolve credentials.
	 * These providers will look in the environment using the
	 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
	 *
	 * ## Setting Providers
	 *
	 * Each provider in the {providers} list should be a function that returns
	 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
	 * form allows for delayed execution of the credential construction.
	 *
	 * ## Resolving Credentials from a Chain
	 *
	 * Call {resolve} to return the first valid credential object that can be
	 * loaded by the provider chain.
	 *
	 * For example, to resolve a chain with a custom provider that checks a file
	 * on disk after the set of {defaultProviders}:
	 *
	 * ```javascript
	 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
	 * var chain = new AWS.CredentialProviderChain();
	 * chain.providers.push(diskProvider);
	 * chain.resolve();
	 * ```
	 *
	 * The above code will return the `diskProvider` object if the
	 * file contains credentials and the `defaultProviders` do not contain
	 * any credential settings.
	 *
	 * @!attribute providers
	 *   @return [Array<AWS.Credentials, Function>]
	 *     a list of credentials objects or functions that return credentials
	 *     objects. If the provider is a function, the function will be
	 *     executed lazily when the provider needs to be checked for valid
	 *     credentials. By default, this object will be set to the
	 *     {defaultProviders}.
	 *   @see defaultProviders
	 */
	AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

	  /**
	   * Creates a new CredentialProviderChain with a default set of providers
	   * specified by {defaultProviders}.
	   */
	  constructor: function CredentialProviderChain(providers) {
	    if (providers) {
	      this.providers = providers;
	    } else {
	      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
	    }
	    this.resolveCallbacks = [];
	  },

	  /**
	   * @!method  resolvePromise()
	   *   Returns a 'thenable' promise.
	   *   Resolves the provider chain by searching for the first set of
	   *   credentials in {providers}.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(credentials)
	   *     Called if the promise is fulfilled and the provider resolves the chain
	   *     to a credentials object
	   *     @param credentials [AWS.Credentials] the credentials object resolved
	   *       by the provider chain.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param err [Error] the error object returned if no credentials are found.
	   *   @return [Promise] A promise that represents the state of the `resolve` method call.
	   *   @example Calling the `resolvePromise` method.
	   *     var promise = chain.resolvePromise();
	   *     promise.then(function(credentials) { ... }, function(err) { ... });
	   */

	  /**
	   * Resolves the provider chain by searching for the first set of
	   * credentials in {providers}.
	   *
	   * @callback callback function(err, credentials)
	   *   Called when the provider resolves the chain to a credentials object
	   *   or null if no credentials can be found.
	   *
	   *   @param err [Error] the error object returned if no credentials are
	   *     found.
	   *   @param credentials [AWS.Credentials] the credentials object resolved
	   *     by the provider chain.
	   * @return [AWS.CredentialProviderChain] the provider, for chaining.
	   */
	  resolve: function resolve(callback) {
	    var self = this;
	    if (self.providers.length === 0) {
	      callback(new Error('No providers'));
	      return self;
	    }

	    if (self.resolveCallbacks.push(callback) === 1) {
	      var index = 0;
	      var providers = self.providers.slice(0);

	      function resolveNext(err, creds) {
	        if ((!err && creds) || index === providers.length) {
	          AWS.util.arrayEach(self.resolveCallbacks, function (callback) {
	            callback(err, creds);
	          });
	          self.resolveCallbacks.length = 0;
	          return;
	        }

	        var provider = providers[index++];
	        if (typeof provider === 'function') {
	          creds = provider.call();
	        } else {
	          creds = provider;
	        }

	        if (creds.get) {
	          creds.get(function (getErr) {
	            resolveNext(getErr, getErr ? null : creds);
	          });
	        } else {
	          resolveNext(null, creds);
	        }
	      }

	      resolveNext();
	    }

	    return self;
	  }
	});

	/**
	 * The default set of providers used by a vanilla CredentialProviderChain.
	 *
	 * In the browser:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = []
	 * ```
	 *
	 * In Node.js:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = [
	 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
	 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
	 *   function () { return new AWS.SsoCredentials(); },
	 *   function () { return new AWS.SharedIniFileCredentials(); },
	 *   function () { return new AWS.ECSCredentials(); },
	 *   function () { return new AWS.ProcessCredentials(); },
	 *   function () { return new AWS.TokenFileWebIdentityCredentials(); },
	 *   function () { return new AWS.EC2MetadataCredentials() }
	 * ]
	 * ```
	 */
	AWS.CredentialProviderChain.defaultProviders = [];

	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
	};

	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.resolvePromise;
	};

	AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(31);

	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * @note AWS.TemporaryCredentials is deprecated, but remains available for
	 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
	 *   preferred class for temporary credentials.
	 *
	 * To setup temporary credentials, configure a set of master credentials
	 * using the standard credentials providers (environment, EC2 instance metadata,
	 * or from the filesystem), then set the global credentials to a new
	 * temporary credentials object:
	 *
	 * ```javascript
	 * // Note that environment credentials are loaded by default,
	 * // the following line is shown for clarity:
	 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
	 *
	 * // Now set temporary credentials seeded from the master credentials
	 * AWS.config.credentials = new AWS.TemporaryCredentials();
	 *
	 * // subsequent requests will now use temporary credentials from AWS STS.
	 * new AWS.S3().listBucket(function(err, data) { ... });
	 * ```
	 *
	 * @!attribute masterCredentials
	 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @note In order to create temporary credentials, you first need to have
	   *   "master" credentials configured in {AWS.Config.credentials}. These
	   *   master credentials are necessary to retrieve the temporary credentials,
	   *   as well as refresh the credentials when they expire.
	   * @param params [map] a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role.
	   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
	   *  used to get and refresh temporary credentials from AWS STS.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.TemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.TemporaryCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function TemporaryCredentials(params, masterCredentials) {
	    AWS.Credentials.call(this);
	    this.loadMasterCredentials(masterCredentials);
	    this.expired = true;

	    this.params = params || {};
	    if (this.params.RoleArn) {
	      this.params.RoleSessionName =
	        this.params.RoleSessionName || 'temporary-credentials';
	    }
	  },

	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh (callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },

	  /**
	   * @api private
	   */
	  load: function load (callback) {
	    var self = this;
	    self.createClients();
	    self.masterCredentials.get(function () {
	      self.service.config.credentials = self.masterCredentials;
	      var operation = self.params.RoleArn ?
	        self.service.assumeRole : self.service.getSessionToken;
	      operation.call(self.service, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },

	  /**
	   * @api private
	   */
	  loadMasterCredentials: function loadMasterCredentials (masterCredentials) {
	    this.masterCredentials = masterCredentials || AWS.config.credentials;
	    while (this.masterCredentials.masterCredentials) {
	      this.masterCredentials = this.masterCredentials.masterCredentials;
	    }

	    if (typeof this.masterCredentials.get !== 'function') {
	      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
	    }
	  },

	  /**
	   * @api private
	   */
	  createClients: function () {
	    this.service = this.service || new STS({params: this.params});
	  }

	});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sts'] = {};
	AWS.STS = Service.defineService('sts', ['2011-06-15']);
	__webpack_require__(32);
	Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
	  get: function get() {
	    var model = __webpack_require__(34);
	    model.paginators = __webpack_require__(35).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.STS;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var resolveRegionalEndpointsFlag = __webpack_require__(33);
	var ENV_REGIONAL_ENDPOINT_ENABLED = 'AWS_STS_REGIONAL_ENDPOINTS';
	var CONFIG_REGIONAL_ENDPOINT_ENABLED = 'sts_regional_endpoints';

	AWS.util.update(AWS.STS.prototype, {
	  /**
	   * @overload credentialsFrom(data, credentials = null)
	   *   Creates a credentials object from STS response data containing
	   *   credentials information. Useful for quickly setting AWS credentials.
	   *
	   *   @note This is a low-level utility function. If you want to load temporary
	   *     credentials into your process for subsequent requests to AWS resources,
	   *     you should use {AWS.TemporaryCredentials} instead.
	   *   @param data [map] data retrieved from a call to {getFederatedToken},
	   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
	   *   @param credentials [AWS.Credentials] an optional credentials object to
	   *     fill instead of creating a new object. Useful when modifying an
	   *     existing credentials object from a refresh call.
	   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
	   *     loaded from a raw STS operation response.
	   *   @example Using credentialsFrom to load global AWS credentials
	   *     var sts = new AWS.STS();
	   *     sts.getSessionToken(function (err, data) {
	   *       if (err) console.log("Error getting credentials");
	   *       else {
	   *         AWS.config.credentials = sts.credentialsFrom(data);
	   *       }
	   *     });
	   *   @see AWS.TemporaryCredentials
	   */
	  credentialsFrom: function credentialsFrom(data, credentials) {
	    if (!data) return null;
	    if (!credentials) credentials = new AWS.TemporaryCredentials();
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	    return credentials;
	  },

	  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
	  },

	  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
	  },

	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('validate', this.optInRegionalEndpoint, true);
	  },

	  /**
	   * @api private
	   */
	  optInRegionalEndpoint: function optInRegionalEndpoint(req) {
	    var service = req.service;
	    var config = service.config;
	    config.stsRegionalEndpoints = resolveRegionalEndpointsFlag(service._originalConfig, {
	      env: ENV_REGIONAL_ENDPOINT_ENABLED,
	      sharedConfig: CONFIG_REGIONAL_ENDPOINT_ENABLED,
	      clientConfig: 'stsRegionalEndpoints'
	    });
	    if (
	      config.stsRegionalEndpoints === 'regional' &&
	      service.isGlobalEndpoint
	    ) {
	      //client will throw if region is not supplied; request will be signed with specified region
	      if (!config.region) {
	        throw AWS.util.error(new Error(),
	          {code: 'ConfigError', message: 'Missing region in config'});
	      }
	      var insertPoint = config.endpoint.indexOf('.amazonaws.com');
	      var regionalEndpoint = config.endpoint.substring(0, insertPoint) +
	        '.' + config.region + config.endpoint.substring(insertPoint);
	      req.httpRequest.updateEndpoint(regionalEndpoint);
	      req.httpRequest.region = config.region;
	    }
	  }

	});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(4);
	/**
	 * @api private
	 */
	function validateRegionalEndpointsFlagValue(configValue, errorOptions) {
	  if (typeof configValue !== 'string') return undefined;
	  else if (['legacy', 'regional'].indexOf(configValue.toLowerCase()) >= 0) {
	    return configValue.toLowerCase();
	  } else {
	    throw AWS.util.error(new Error(), errorOptions);
	  }
	}

	/**
	 * Resolve the configuration value for regional endpoint from difference sources: client
	 * config, environmental variable, shared config file. Value can be case-insensitive
	 * 'legacy' or 'reginal'.
	 * @param originalConfig user-supplied config object to resolve
	 * @param options a map of config property names from individual configuration source
	 *  - env: name of environmental variable that refers to the config
	 *  - sharedConfig: name of shared configuration file property that refers to the config
	 *  - clientConfig: name of client configuration property that refers to the config
	 *
	 * @api private
	 */
	function resolveRegionalEndpointsFlag(originalConfig, options) {
	  originalConfig = originalConfig || {};
	  //validate config value
	  var resolved;
	  if (originalConfig[options.clientConfig]) {
	    resolved = validateRegionalEndpointsFlagValue(originalConfig[options.clientConfig], {
	      code: 'InvalidConfiguration',
	      message: 'invalid "' + options.clientConfig + '" configuration. Expect "legacy" ' +
	      ' or "regional". Got "' + originalConfig[options.clientConfig] + '".'
	    });
	    if (resolved) return resolved;
	  }
	  if (!AWS.util.isNode()) return resolved;
	  //validate environmental variable
	  if (Object.prototype.hasOwnProperty.call(process.env, options.env)) {
	    var envFlag = process.env[options.env];
	    resolved = validateRegionalEndpointsFlagValue(envFlag, {
	      code: 'InvalidEnvironmentalVariable',
	      message: 'invalid ' + options.env + ' environmental variable. Expect "legacy" ' +
	      ' or "regional". Got "' + process.env[options.env] + '".'
	    });
	    if (resolved) return resolved;
	  }
	  //validate shared config file
	  var profile = {};
	  try {
	    var profiles = AWS.util.getProfilesFromSharedConfig(AWS.util.iniLoader);
	    profile = profiles[process.env.AWS_PROFILE || AWS.util.defaultProfile];
	  } catch (e) {};
	  if (profile && Object.prototype.hasOwnProperty.call(profile, options.sharedConfig)) {
	    var fileFlag = profile[options.sharedConfig];
	    resolved = validateRegionalEndpointsFlagValue(fileFlag, {
	      code: 'InvalidConfiguration',
	      message: 'invalid ' + options.sharedConfig + ' profile config. Expect "legacy" ' +
	      ' or "regional". Got "' + profile[options.sharedConfig] + '".'
	    });
	    if (resolved) return resolved;
	  }
	  return resolved;
	}

	module.exports = resolveRegionalEndpointsFlag;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"},"TransitiveTagKeys":{"type":"list","member":{}},"ExternalId":{},"SerialNumber":{},"TokenCode":{},"SourceIdentity":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Si"},"AssumedRoleUser":{"shape":"Sn"},"PackedPolicySize":{"type":"integer"},"SourceIdentity":{}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Si"},"AssumedRoleUser":{"shape":"Sn"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{},"SourceIdentity":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Si"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sn"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{},"SourceIdentity":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Si"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Si"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"S8":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Si":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sn":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(31);

	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
	 * the way masterCredentials and refreshes are handled.
	 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
	 * masterCredentials passed by the user to support chaining of STS credentials.
	 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
	 * during instantiation, precluding the ability to refresh credentials which
	 * require intermediate, temporary credentials.
	 *
	 * For example, if the application should use RoleA, which must be assumed from
	 * RoleB, and the environment provides credentials which can assume RoleB, then
	 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
	 * temporary credentials for RoleA:
	 *
	 * ```javascript
	 * var roleACreds = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: 'RoleA'},
	 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
	 *     params: {RoleArn: 'RoleB'},
	 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
	 *   })
	 * });
	 * ```
	 *
	 * If AWS.TemporaryCredentials had been used in the previous example,
	 * `roleACreds` would fail to refresh because `roleACreds` would
	 * use the environment credentials for the AssumeRole request.
	 *
	 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
	 * service instance during instantiation while AWS.TemporaryCredentials creates
	 * the STS service instance during the first refresh. Creating the service
	 * instance during instantiation effectively captures the master credentials
	 * from the global config, so that subsequent changes to the global config do
	 * not affect the master credentials used to refresh the temporary credentials.
	 *
	 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
	 * to AWS.config.credentials:
	 *
	 * ```javascript
	 * var envCreds = new AWS.EnvironmentCredentials('AWS');
	 * AWS.config.credentials = envCreds;
	 * // masterCredentials will be envCreds
	 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * Similarly, to use the CredentialProviderChain's default providers as the
	 * master credentials, simply create a new instance of
	 * AWS.ChainableTemporaryCredentials:
	 *
	 * ```javascript
	 * AWS.config.credentials = new ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * @!attribute service
	 *   @return [AWS.STS] the STS service instance used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.ChainableTemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @param options [map] a set of options
	   * @option options params [map] ({}) a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
	   *   also be passed in or an error will be thrown.
	   * @option options masterCredentials [AWS.Credentials] the master credentials
	   *   used to get and refresh temporary credentials from AWS STS. By default,
	   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
	   * @option options tokenCodeFn [Function] (null) Function to provide
	   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
	   *   is called with value of `SerialNumber` and `callback`, and should provide
	   *   the `TokenCode` or an error to the callback in the format
	   *   `callback(err, token)`.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	   *     params: {
	   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
	   *     }
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function ChainableTemporaryCredentials(options) {
	    AWS.Credentials.call(this);
	    options = options || {};
	    this.errorCode = 'ChainableTemporaryCredentialsProviderFailure';
	    this.expired = true;
	    this.tokenCodeFn = null;

	    var params = AWS.util.copy(options.params) || {};
	    if (params.RoleArn) {
	      params.RoleSessionName = params.RoleSessionName || 'temporary-credentials';
	    }
	    if (params.SerialNumber) {
	      if (!options.tokenCodeFn || (typeof options.tokenCodeFn !== 'function')) {
	        throw new AWS.util.error(
	          new Error('tokenCodeFn must be a function when params.SerialNumber is given'),
	          {code: this.errorCode}
	        );
	      } else {
	        this.tokenCodeFn = options.tokenCodeFn;
	      }
	    }
	    var config = AWS.util.merge(
	      {
	        params: params,
	        credentials: options.masterCredentials || AWS.config.credentials
	      },
	      options.stsConfig || {}
	    );
	    this.service = new STS(config);
	  },

	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },

	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    var operation = self.service.config.params.RoleArn ? 'assumeRole' : 'getSessionToken';
	    this.getTokenCode(function (err, tokenCode) {
	      var params = {};
	      if (err) {
	        callback(err);
	        return;
	      }
	      if (tokenCode) {
	        params.TokenCode = tokenCode;
	      }
	      self.service[operation](params, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },

	  /**
	   * @api private
	   */
	  getTokenCode: function getTokenCode(callback) {
	    var self = this;
	    if (this.tokenCodeFn) {
	      this.tokenCodeFn(this.service.config.params.SerialNumber, function (err, token) {
	        if (err) {
	          var message = err;
	          if (err instanceof Error) {
	            message = err.message;
	          }
	          callback(
	            AWS.util.error(
	              new Error('Error fetching MFA token: ' + message),
	              { code: self.errorCode}
	            )
	          );
	          return;
	        }
	        callback(null, token);
	      });
	    } else {
	      callback(null);
	    }
	  }
	});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(31);

	/**
	 * Represents credentials retrieved from STS Web Identity Federation support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given. In addition, the
	 * `WebIdentityToken` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn` and `WebIdentityToken` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 */
	AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithWebIdentity)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
	   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
	   *     RoleSessionName: 'web' // optional name, defaults to web-identity
	   *   }, {
	   *     // optionally provide configuration to apply to the underlying AWS.STS service client
	   *     // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *     // specify timeout options
	   *     httpOptions: {
	   *       timeout: 100
	   *     }
	   *   });
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.Config
	   */
	  constructor: function WebIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
	    this.data = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	  },

	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },

	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithWebIdentity(function (err, data) {
	      self.data = null;
	      if (!err) {
	        self.data = data;
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },

	  /**
	   * @api private
	   */
	  createClients: function() {
	    if (!this.service) {
	      var stsConfig = AWS.util.merge({}, this._clientConfig);
	      stsConfig.params = this.params;
	      this.service = new STS(stsConfig);
	    }
	  }

	});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var CognitoIdentity = __webpack_require__(39);
	var STS = __webpack_require__(31);

	/**
	 * Represents credentials retrieved from STS Web Identity Federation using
	 * the Amazon Cognito Identity service.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
	 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
	 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
	 * obtain an `IdentityId`. If the identity or identity pool is not configured in
	 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
	 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
	 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
	 * is provided, then this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
	 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
	 *
	 * In addition, if this credential provider is used to provide authenticated
	 * login, the `Logins` map may be set to the tokens provided by the respective
	 * identity providers. See {constructor} for an example on creating a credentials
	 * object with proper property values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.CognitoIdentity.getId},
	 *     {AWS.CognitoIdentity.getOpenIdToken}, and
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 * @!attribute identityId
	 *   @return [String] the Cognito ID returned by the last call to
	 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
	 *     final resolved identity ID from Amazon Cognito.
	 */
	AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * @api private
	   */
	  localStorageKey: {
	    id: 'aws.cognito.identity-id.',
	    providers: 'aws.cognito.identity-providers.'
	  },

	  /**
	   * Creates a new credentials object.
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
	   *
	   *     // either IdentityPoolId or IdentityId is required
	   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
	   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
	   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
	   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
	   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
	   *
	   *     // optional, only necessary when the identity pool is not configured
	   *     // to use IAM roles in the Amazon Cognito Console
	   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
	   *
	   *     // optional tokens, used for authenticated login
	   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
	   *     Logins: {
	   *       'graph.facebook.com': 'FBTOKEN',
	   *       'www.amazon.com': 'AMAZONTOKEN',
	   *       'accounts.google.com': 'GOOGLETOKEN',
	   *       'api.twitter.com': 'TWITTERTOKEN',
	   *       'www.digits.com': 'DIGITSTOKEN'
	   *     },
	   *
	   *     // optional name, defaults to web-identity
	   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleSessionName: 'web',
	   *
	   *     // optional, only necessary when application runs in a browser
	   *     // and multiple users are signed in at once, used for caching
	   *     LoginId: 'example@gmail.com'
	   *
	   *   }, {
	   *      // optionally provide configuration to apply to the underlying service clients
	   *      // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *      // region should match the region your identity pool is located in
	   *      region: 'us-east-1',
	   *
	   *      // specify timeout options
	   *      httpOptions: {
	   *        timeout: 100
	   *      }
	   *   });
	   * @see AWS.CognitoIdentity.getId
	   * @see AWS.CognitoIdentity.getCredentialsForIdentity
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.CognitoIdentity.getOpenIdToken
	   * @see AWS.Config
	   * @note If a region is not provided in the global AWS.config, or
	   *   specified in the `clientConfig` to the CognitoIdentityCredentials
	   *   constructor, you may encounter a 'Missing credentials in config' error
	   *   when calling making a service call.
	   */
	  constructor: function CognitoIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.data = null;
	    this._identityId = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	    this.loadCachedId();
	    var self = this;
	    Object.defineProperty(this, 'identityId', {
	      get: function() {
	        self.loadCachedId();
	        return self._identityId || self.params.IdentityId;
	      },
	      set: function(identityId) {
	        self._identityId = identityId;
	      }
	    });
	  },

	  /**
	   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
	   * or {AWS.STS.assumeRoleWithWebIdentity}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },

	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.data = null;
	    self._identityId = null;
	    self.getId(function(err) {
	      if (!err) {
	        if (!self.params.RoleArn) {
	          self.getCredentialsForIdentity(callback);
	        } else {
	          self.getCredentialsFromSTS(callback);
	        }
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },

	  /**
	   * Clears the cached Cognito ID associated with the currently configured
	   * identity pool ID. Use this to manually invalidate your cache if
	   * the identity pool ID was deleted.
	   */
	  clearCachedId: function clearCache() {
	    this._identityId = null;
	    delete this.params.IdentityId;

	    var poolId = this.params.IdentityPoolId;
	    var loginId = this.params.LoginId || '';
	    delete this.storage[this.localStorageKey.id + poolId + loginId];
	    delete this.storage[this.localStorageKey.providers + poolId + loginId];
	  },

	  /**
	   * @api private
	   */
	  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
	    var self = this;
	    if (err.code == 'NotAuthorizedException') {
	      self.clearCachedId();
	    }
	  },

	  /**
	   * Retrieves a Cognito ID, loading from cache if it was already retrieved
	   * on this device.
	   *
	   * @callback callback function(err, identityId)
	   *   @param err [Error, null] an error object if the call failed or null if
	   *     it succeeded.
	   *   @param identityId [String, null] if successful, the callback will return
	   *     the Cognito ID.
	   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
	   *   localStorage in the browser environment of a device.
	   * @api private
	   */
	  getId: function getId(callback) {
	    var self = this;
	    if (typeof self.params.IdentityId === 'string') {
	      return callback(null, self.params.IdentityId);
	    }

	    self.cognito.getId(function(err, data) {
	      if (!err && data.IdentityId) {
	        self.params.IdentityId = data.IdentityId;
	        callback(null, data.IdentityId);
	      } else {
	        callback(err);
	      }
	    });
	  },


	  /**
	   * @api private
	   */
	  loadCredentials: function loadCredentials(data, credentials) {
	    if (!data || !credentials) return;
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	  },

	  /**
	   * @api private
	   */
	  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
	    var self = this;
	    self.cognito.getCredentialsForIdentity(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.data = data;
	        self.loadCredentials(self.data, self);
	      } else {
	        self.clearIdOnNotAuthorized(err);
	      }
	      callback(err);
	    });
	  },

	  /**
	   * @api private
	   */
	  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
	    var self = this;
	    self.cognito.getOpenIdToken(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.params.WebIdentityToken = data.Token;
	        self.webIdentityCredentials.refresh(function(webErr) {
	          if (!webErr) {
	            self.data = self.webIdentityCredentials.data;
	            self.sts.credentialsFrom(self.data, self);
	          }
	          callback(webErr);
	        });
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },

	  /**
	   * @api private
	   */
	  loadCachedId: function loadCachedId() {
	    var self = this;

	    // in the browser we source default IdentityId from localStorage
	    if (AWS.util.isBrowser() && !self.params.IdentityId) {
	      var id = self.getStorage('id');
	      if (id && self.params.Logins) {
	        var actualProviders = Object.keys(self.params.Logins);
	        var cachedProviders =
	          (self.getStorage('providers') || '').split(',');

	        // only load ID if at least one provider used this ID before
	        var intersect = cachedProviders.filter(function(n) {
	          return actualProviders.indexOf(n) !== -1;
	        });
	        if (intersect.length !== 0) {
	          self.params.IdentityId = id;
	        }
	      } else if (id) {
	        self.params.IdentityId = id;
	      }
	    }
	  },

	  /**
	   * @api private
	   */
	  createClients: function() {
	    var clientConfig = this._clientConfig;
	    this.webIdentityCredentials = this.webIdentityCredentials ||
	      new AWS.WebIdentityCredentials(this.params, clientConfig);
	    if (!this.cognito) {
	      var cognitoConfig = AWS.util.merge({}, clientConfig);
	      cognitoConfig.params = this.params;
	      this.cognito = new CognitoIdentity(cognitoConfig);
	    }
	    this.sts = this.sts || new STS(clientConfig);
	  },

	  /**
	   * @api private
	   */
	  cacheId: function cacheId(data) {
	    this._identityId = data.IdentityId;
	    this.params.IdentityId = this._identityId;

	    // cache this IdentityId in browser localStorage if possible
	    if (AWS.util.isBrowser()) {
	      this.setStorage('id', data.IdentityId);

	      if (this.params.Logins) {
	        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
	      }
	    }
	  },

	  /**
	   * @api private
	   */
	  getStorage: function getStorage(key) {
	    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
	  },

	  /**
	   * @api private
	   */
	  setStorage: function setStorage(key, val) {
	    try {
	      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
	    } catch (_) {}
	  },

	  /**
	   * @api private
	   */
	  storage: (function() {
	    try {
	      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
	          window.localStorage : {};

	      // Test set/remove which would throw an error in Safari's private browsing
	      storage['aws.test-storage'] = 'foobar';
	      delete storage['aws.test-storage'];

	      return storage;
	    } catch (_) {
	      return {};
	    }
	  })()
	});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cognitoidentity'] = {};
	AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
	Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
	  get: function get() {
	    var model = __webpack_require__(40);
	    model.paginators = __webpack_require__(41).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CognitoIdentity;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"output":{"shape":"Sk"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sv"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sk"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}},"authtype":"none"},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{}}},"authtype":"none"},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}},"authtype":"none"},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"S10"},"PrincipalTags":{"shape":"S1s"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetPrincipalTagAttributeMap":{"input":{"type":"structure","required":["IdentityPoolId","IdentityProviderName"],"members":{"IdentityPoolId":{},"IdentityProviderName":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"IdentityProviderName":{},"UseDefaults":{"type":"boolean"},"PrincipalTags":{"shape":"S1s"}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"SetPrincipalTagAttributeMap":{"input":{"type":"structure","required":["IdentityPoolId","IdentityProviderName"],"members":{"IdentityPoolId":{},"IdentityProviderName":{},"UseDefaults":{"type":"boolean"},"PrincipalTags":{"shape":"S1s"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"IdentityProviderName":{},"UseDefaults":{"type":"boolean"},"PrincipalTags":{"shape":"S1s"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"LoginsToRemove":{"shape":"Sw"}}},"authtype":"none"},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sk"},"output":{"shape":"Sk"}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sg":{"type":"list","member":{}},"Sh":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"Sv":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"map","key":{},"value":{}},"S1c":{"type":"map","key":{},"value":{}},"S1e":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}},"S1s":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListIdentityPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IdentityPools"}}}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(31);

	/**
	 * Represents credentials retrieved from STS SAML support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given, as well as a `PrincipalArn`
	 * representing the ARN for the SAML identity provider. In addition, the
	 * `SAMLAssertion` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the SAMLAssertion, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
	 *     `params.SAMLAssertion` property.
	 */
	AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithSAML)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.SAMLCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
	   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
	   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
	   *   });
	   * @see AWS.STS.assumeRoleWithSAML
	   */
	  constructor: function SAMLCredentials(params) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	  },

	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },

	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithSAML(function (err, data) {
	      if (!err) {
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },

	  /**
	   * @api private
	   */
	  createClients: function() {
	    this.service = this.service || new STS({params: this.params});
	  }

	});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var util = AWS.util;
	var Shape = AWS.Model.Shape;

	var xml2js = __webpack_require__(44);

	/**
	 * @api private
	 */
	var options = {  // options passed to xml2js parser
	  explicitCharkey: false, // undocumented
	  trim: false,            // trim the leading/trailing whitespace from text nodes
	  normalize: false,       // trim interior whitespace inside text nodes
	  explicitRoot: false,    // return the root node in the resulting object?
	  emptyTag: null,         // the default value for empty nodes
	  explicitArray: true,    // always put child nodes in an array
	  ignoreAttrs: false,     // ignore attributes, only create text nodes
	  mergeAttrs: false,      // merge attributes and child elements
	  validator: null         // a callable validator
	};

	function NodeXmlParser() { }

	NodeXmlParser.prototype.parse = function(xml, shape) {
	  shape = shape || {};

	  var result = null;
	  var error = null;

	  var parser = new xml2js.Parser(options);
	  parser.parseString(xml, function (e, r) {
	    error = e;
	    result = r;
	  });

	  if (result) {
	    var data = parseXml(result, shape);
	    if (result.ResponseMetadata) {
	      data.ResponseMetadata = parseXml(result.ResponseMetadata[0], {});
	    }
	    return data;
	  } else if (error) {
	    throw util.error(error, {code: 'XMLParserError', retryable: true});
	  } else { // empty xml document
	    return parseXml({}, shape);
	  }
	};

	function parseXml(xml, shape) {
	  switch (shape.type) {
	    case 'structure': return parseStructure(xml, shape);
	    case 'map': return parseMap(xml, shape);
	    case 'list': return parseList(xml, shape);
	    case undefined: case null: return parseUnknown(xml);
	    default: return parseScalar(xml, shape);
	  }
	}

	function parseStructure(xml, shape) {
	  var data = {};
	  if (xml === null) return data;

	  util.each(shape.members, function(memberName, memberShape) {
	    var xmlName = memberShape.name;
	    if (Object.prototype.hasOwnProperty.call(xml, xmlName) && Array.isArray(xml[xmlName])) {
	      var xmlChild = xml[xmlName];
	      if (!memberShape.flattened) xmlChild = xmlChild[0];

	      data[memberName] = parseXml(xmlChild, memberShape);
	    } else if (memberShape.isXmlAttribute &&
	               xml.$ && Object.prototype.hasOwnProperty.call(xml.$, xmlName)) {
	      data[memberName] = parseScalar(xml.$[xmlName], memberShape);
	    } else if (memberShape.type === 'list' && !shape.api.xmlNoDefaultLists) {
	      data[memberName] = memberShape.defaultValue;
	    }
	  });

	  return data;
	}

	function parseMap(xml, shape) {
	  var data = {};
	  if (xml === null) return data;

	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	  var iterable = shape.flattened ? xml : xml.entry;

	  if (Array.isArray(iterable)) {
	    util.arrayEach(iterable, function(child) {
	      data[child[xmlKey][0]] = parseXml(child[xmlValue][0], shape.value);
	    });
	  }

	  return data;
	}

	function parseList(xml, shape) {
	  var data = [];
	  var name = shape.member.name || 'member';
	  if (shape.flattened) {
	    util.arrayEach(xml, function(xmlChild) {
	      data.push(parseXml(xmlChild, shape.member));
	    });
	  } else if (xml && Array.isArray(xml[name])) {
	    util.arrayEach(xml[name], function(child) {
	      data.push(parseXml(child, shape.member));
	    });
	  }

	  return data;
	}

	function parseScalar(text, shape) {
	  if (text && text.$ && text.$.encoding === 'base64') {
	    shape = new Shape.create({type: text.$.encoding});
	  }
	  if (text && text._) text = text._;

	  if (typeof shape.toType === 'function') {
	    return shape.toType(text);
	  } else {
	    return text;
	  }
	}

	function parseUnknown(xml) {
	  if (xml === undefined || xml === null) return '';
	  if (typeof xml === 'string') return xml;

	  // parse a list
	  if (Array.isArray(xml)) {
	    var arr = [];
	    for (i = 0; i < xml.length; i++) {
	      arr.push(parseXml(xml[i], {}));
	    }
	    return arr;
	  }

	  // empty object
	  var keys = Object.keys(xml), i;
	  if (keys.length === 0 || (keys.length === 1 && keys[0] === '$')) {
	    return {};
	  }

	  // object, parse as structure
	  var data = {};
	  for (i = 0; i < keys.length; i++) {
	    var key = keys[i], value = xml[key];
	    if (key === '$') continue;
	    if (value.length > 1) { // this member is a list
	      data[key] = parseList(value, {member: {}});
	    } else { // this member is a single item
	      data[key] = parseXml(value[0], {});
	    }
	  }
	  return data;
	}

	/**
	 * @api private
	 */
	module.exports = NodeXmlParser;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};

	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {

	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;

	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};

	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;

	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}


	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;

	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;

	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";

	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(1);


	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  "use strict";
		  var builder, defaults, parser, processors,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  defaults = __webpack_require__(2);

		  builder = __webpack_require__(3);

		  parser = __webpack_require__(26);

		  processors = __webpack_require__(60);

		  exports.defaults = defaults.defaults;

		  exports.processors = processors;

		  exports.ValidationError = (function(superClass) {
		    extend(ValidationError, superClass);

		    function ValidationError(message) {
		      this.message = message;
		    }

		    return ValidationError;

		  })(Error);

		  exports.Builder = builder.Builder;

		  exports.Parser = parser.Parser;

		  exports.parseString = parser.parseString;

		}).call(this);


	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  exports.defaults = {
		    "0.1": {
		      explicitCharkey: false,
		      trim: true,
		      normalize: true,
		      normalizeTags: false,
		      attrkey: "@",
		      charkey: "#",
		      explicitArray: false,
		      ignoreAttrs: false,
		      mergeAttrs: false,
		      explicitRoot: false,
		      validator: null,
		      xmlns: false,
		      explicitChildren: false,
		      childkey: '@@',
		      charsAsChildren: false,
		      includeWhiteChars: false,
		      async: false,
		      strict: true,
		      attrNameProcessors: null,
		      attrValueProcessors: null,
		      tagNameProcessors: null,
		      valueProcessors: null,
		      emptyTag: ''
		    },
		    "0.2": {
		      explicitCharkey: false,
		      trim: false,
		      normalize: false,
		      normalizeTags: false,
		      attrkey: "$",
		      charkey: "_",
		      explicitArray: true,
		      ignoreAttrs: false,
		      mergeAttrs: false,
		      explicitRoot: true,
		      validator: null,
		      xmlns: false,
		      explicitChildren: false,
		      preserveChildrenOrder: false,
		      childkey: '$$',
		      charsAsChildren: false,
		      includeWhiteChars: false,
		      async: false,
		      strict: true,
		      attrNameProcessors: null,
		      attrValueProcessors: null,
		      tagNameProcessors: null,
		      valueProcessors: null,
		      rootName: 'root',
		      xmldec: {
		        'version': '1.0',
		        'encoding': 'UTF-8',
		        'standalone': true
		      },
		      doctype: null,
		      renderOpts: {
		        'pretty': true,
		        'indent': '  ',
		        'newline': '\n'
		      },
		      headless: false,
		      chunkSize: 10000,
		      emptyTag: '',
		      cdata: false
		    }
		  };

		}).call(this);


	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  "use strict";
		  var builder, defaults, escapeCDATA, requiresCDATA, wrapCDATA,
		    hasProp = {}.hasOwnProperty;

		  builder = __webpack_require__(4);

		  defaults = __webpack_require__(2).defaults;

		  requiresCDATA = function(entry) {
		    return typeof entry === "string" && (entry.indexOf('&') >= 0 || entry.indexOf('>') >= 0 || entry.indexOf('<') >= 0);
		  };

		  wrapCDATA = function(entry) {
		    return "<![CDATA[" + (escapeCDATA(entry)) + "]]>";
		  };

		  escapeCDATA = function(entry) {
		    return entry.replace(']]>', ']]]]><![CDATA[>');
		  };

		  exports.Builder = (function() {
		    function Builder(opts) {
		      var key, ref, value;
		      this.options = {};
		      ref = defaults["0.2"];
		      for (key in ref) {
		        if (!hasProp.call(ref, key)) continue;
		        value = ref[key];
		        this.options[key] = value;
		      }
		      for (key in opts) {
		        if (!hasProp.call(opts, key)) continue;
		        value = opts[key];
		        this.options[key] = value;
		      }
		    }

		    Builder.prototype.buildObject = function(rootObj) {
		      var attrkey, charkey, render, rootElement, rootName;
		      attrkey = this.options.attrkey;
		      charkey = this.options.charkey;
		      if ((Object.keys(rootObj).length === 1) && (this.options.rootName === defaults['0.2'].rootName)) {
		        rootName = Object.keys(rootObj)[0];
		        rootObj = rootObj[rootName];
		      } else {
		        rootName = this.options.rootName;
		      }
		      render = (function(_this) {
		        return function(element, obj) {
		          var attr, child, entry, index, key, value;
		          if (typeof obj !== 'object') {
		            if (_this.options.cdata && requiresCDATA(obj)) {
		              element.raw(wrapCDATA(obj));
		            } else {
		              element.txt(obj);
		            }
		          } else if (Array.isArray(obj)) {
		            for (index in obj) {
		              if (!hasProp.call(obj, index)) continue;
		              child = obj[index];
		              for (key in child) {
		                entry = child[key];
		                element = render(element.ele(key), entry).up();
		              }
		            }
		          } else {
		            for (key in obj) {
		              if (!hasProp.call(obj, key)) continue;
		              child = obj[key];
		              if (key === attrkey) {
		                if (typeof child === "object") {
		                  for (attr in child) {
		                    value = child[attr];
		                    element = element.att(attr, value);
		                  }
		                }
		              } else if (key === charkey) {
		                if (_this.options.cdata && requiresCDATA(child)) {
		                  element = element.raw(wrapCDATA(child));
		                } else {
		                  element = element.txt(child);
		                }
		              } else if (Array.isArray(child)) {
		                for (index in child) {
		                  if (!hasProp.call(child, index)) continue;
		                  entry = child[index];
		                  if (typeof entry === 'string') {
		                    if (_this.options.cdata && requiresCDATA(entry)) {
		                      element = element.ele(key).raw(wrapCDATA(entry)).up();
		                    } else {
		                      element = element.ele(key, entry).up();
		                    }
		                  } else {
		                    element = render(element.ele(key), entry).up();
		                  }
		                }
		              } else if (typeof child === "object") {
		                element = render(element.ele(key), child).up();
		              } else {
		                if (typeof child === 'string' && _this.options.cdata && requiresCDATA(child)) {
		                  element = element.ele(key).raw(wrapCDATA(child)).up();
		                } else {
		                  if (child == null) {
		                    child = '';
		                  }
		                  element = element.ele(key, child.toString()).up();
		                }
		              }
		            }
		          }
		          return element;
		        };
		      })(this);
		      rootElement = builder.create(rootName, this.options.xmldec, this.options.doctype, {
		        headless: this.options.headless,
		        allowSurrogateChars: this.options.allowSurrogateChars
		      });
		      return render(rootElement, rootObj).end(this.options.renderOpts);
		    };

		    return Builder;

		  })();

		}).call(this);


	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;

		  ref = __webpack_require__(5), assign = ref.assign, isFunction = ref.isFunction;

		  XMLDocument = __webpack_require__(6);

		  XMLDocumentCB = __webpack_require__(24);

		  XMLStringWriter = __webpack_require__(22);

		  XMLStreamWriter = __webpack_require__(25);

		  module.exports.create = function(name, xmldec, doctype, options) {
		    var doc, root;
		    if (name == null) {
		      throw new Error("Root element needs a name");
		    }
		    options = assign({}, xmldec, doctype, options);
		    doc = new XMLDocument(options);
		    root = doc.element(name);
		    if (!options.headless) {
		      doc.declaration(options);
		      if ((options.pubID != null) || (options.sysID != null)) {
		        doc.doctype(options);
		      }
		    }
		    return root;
		  };

		  module.exports.begin = function(options, onData, onEnd) {
		    var ref1;
		    if (isFunction(options)) {
		      ref1 = [options, onData], onData = ref1[0], onEnd = ref1[1];
		      options = {};
		    }
		    if (onData) {
		      return new XMLDocumentCB(options, onData, onEnd);
		    } else {
		      return new XMLDocument(options);
		    }
		  };

		  module.exports.stringWriter = function(options) {
		    return new XMLStringWriter(options);
		  };

		  module.exports.streamWriter = function(stream, options) {
		    return new XMLStreamWriter(stream, options);
		  };

		}).call(this);


	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var assign, isArray, isEmpty, isFunction, isObject, isPlainObject,
		    slice = [].slice,
		    hasProp = {}.hasOwnProperty;

		  assign = function() {
		    var i, key, len, source, sources, target;
		    target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
		    if (isFunction(Object.assign)) {
		      Object.assign.apply(null, arguments);
		    } else {
		      for (i = 0, len = sources.length; i < len; i++) {
		        source = sources[i];
		        if (source != null) {
		          for (key in source) {
		            if (!hasProp.call(source, key)) continue;
		            target[key] = source[key];
		          }
		        }
		      }
		    }
		    return target;
		  };

		  isFunction = function(val) {
		    return !!val && Object.prototype.toString.call(val) === '[object Function]';
		  };

		  isObject = function(val) {
		    var ref;
		    return !!val && ((ref = typeof val) === 'function' || ref === 'object');
		  };

		  isArray = function(val) {
		    if (isFunction(Array.isArray)) {
		      return Array.isArray(val);
		    } else {
		      return Object.prototype.toString.call(val) === '[object Array]';
		    }
		  };

		  isEmpty = function(val) {
		    var key;
		    if (isArray(val)) {
		      return !val.length;
		    } else {
		      for (key in val) {
		        if (!hasProp.call(val, key)) continue;
		        return false;
		      }
		      return true;
		    }
		  };

		  isPlainObject = function(val) {
		    var ctor, proto;
		    return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && (typeof ctor === 'function') && (ctor instanceof ctor) && (Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object));
		  };

		  module.exports.assign = assign;

		  module.exports.isFunction = isFunction;

		  module.exports.isObject = isObject;

		  module.exports.isArray = isArray;

		  module.exports.isEmpty = isEmpty;

		  module.exports.isPlainObject = isPlainObject;

		}).call(this);


	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  isPlainObject = __webpack_require__(5).isPlainObject;

		  XMLNode = __webpack_require__(7);

		  XMLStringifier = __webpack_require__(21);

		  XMLStringWriter = __webpack_require__(22);

		  module.exports = XMLDocument = (function(superClass) {
		    extend(XMLDocument, superClass);

		    function XMLDocument(options) {
		      XMLDocument.__super__.constructor.call(this, null);
		      options || (options = {});
		      if (!options.writer) {
		        options.writer = new XMLStringWriter();
		      }
		      this.options = options;
		      this.stringify = new XMLStringifier(options);
		      this.isDocument = true;
		    }

		    XMLDocument.prototype.end = function(writer) {
		      var writerOptions;
		      if (!writer) {
		        writer = this.options.writer;
		      } else if (isPlainObject(writer)) {
		        writerOptions = writer;
		        writer = this.options.writer.set(writerOptions);
		      }
		      return writer.document(this);
		    };

		    XMLDocument.prototype.toString = function(options) {
		      return this.options.writer.set(options).document(this);
		    };

		    return XMLDocument;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, isEmpty, isFunction, isObject, ref,
		    hasProp = {}.hasOwnProperty;

		  ref = __webpack_require__(5), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty;

		  XMLElement = null;

		  XMLCData = null;

		  XMLComment = null;

		  XMLDeclaration = null;

		  XMLDocType = null;

		  XMLRaw = null;

		  XMLText = null;

		  XMLProcessingInstruction = null;

		  module.exports = XMLNode = (function() {
		    function XMLNode(parent) {
		      this.parent = parent;
		      if (this.parent) {
		        this.options = this.parent.options;
		        this.stringify = this.parent.stringify;
		      }
		      this.children = [];
		      if (!XMLElement) {
		        XMLElement = __webpack_require__(8);
		        XMLCData = __webpack_require__(10);
		        XMLComment = __webpack_require__(11);
		        XMLDeclaration = __webpack_require__(12);
		        XMLDocType = __webpack_require__(13);
		        XMLRaw = __webpack_require__(18);
		        XMLText = __webpack_require__(19);
		        XMLProcessingInstruction = __webpack_require__(20);
		      }
		    }

		    XMLNode.prototype.element = function(name, attributes, text) {
		      var childNode, item, j, k, key, lastChild, len, len1, ref1, val;
		      lastChild = null;
		      if (attributes == null) {
		        attributes = {};
		      }
		      attributes = attributes.valueOf();
		      if (!isObject(attributes)) {
		        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
		      }
		      if (name != null) {
		        name = name.valueOf();
		      }
		      if (Array.isArray(name)) {
		        for (j = 0, len = name.length; j < len; j++) {
		          item = name[j];
		          lastChild = this.element(item);
		        }
		      } else if (isFunction(name)) {
		        lastChild = this.element(name.apply());
		      } else if (isObject(name)) {
		        for (key in name) {
		          if (!hasProp.call(name, key)) continue;
		          val = name[key];
		          if (isFunction(val)) {
		            val = val.apply();
		          }
		          if ((isObject(val)) && (isEmpty(val))) {
		            val = null;
		          }
		          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
		            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
		          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
		            for (k = 0, len1 = val.length; k < len1; k++) {
		              item = val[k];
		              childNode = {};
		              childNode[key] = item;
		              lastChild = this.element(childNode);
		            }
		          } else if (isObject(val)) {
		            lastChild = this.element(key);
		            lastChild.element(val);
		          } else {
		            lastChild = this.element(key, val);
		          }
		        }
		      } else {
		        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
		          lastChild = this.text(text);
		        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
		          lastChild = this.cdata(text);
		        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
		          lastChild = this.comment(text);
		        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
		          lastChild = this.raw(text);
		        } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) {
		          lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
		        } else {
		          lastChild = this.node(name, attributes, text);
		        }
		      }
		      if (lastChild == null) {
		        throw new Error("Could not create any elements with: " + name);
		      }
		      return lastChild;
		    };

		    XMLNode.prototype.insertBefore = function(name, attributes, text) {
		      var child, i, removed;
		      if (this.isRoot) {
		        throw new Error("Cannot insert elements at root level");
		      }
		      i = this.parent.children.indexOf(this);
		      removed = this.parent.children.splice(i);
		      child = this.parent.element(name, attributes, text);
		      Array.prototype.push.apply(this.parent.children, removed);
		      return child;
		    };

		    XMLNode.prototype.insertAfter = function(name, attributes, text) {
		      var child, i, removed;
		      if (this.isRoot) {
		        throw new Error("Cannot insert elements at root level");
		      }
		      i = this.parent.children.indexOf(this);
		      removed = this.parent.children.splice(i + 1);
		      child = this.parent.element(name, attributes, text);
		      Array.prototype.push.apply(this.parent.children, removed);
		      return child;
		    };

		    XMLNode.prototype.remove = function() {
		      var i, ref1;
		      if (this.isRoot) {
		        throw new Error("Cannot remove the root element");
		      }
		      i = this.parent.children.indexOf(this);
		      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref1 = [])), ref1;
		      return this.parent;
		    };

		    XMLNode.prototype.node = function(name, attributes, text) {
		      var child, ref1;
		      if (name != null) {
		        name = name.valueOf();
		      }
		      attributes || (attributes = {});
		      attributes = attributes.valueOf();
		      if (!isObject(attributes)) {
		        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
		      }
		      child = new XMLElement(this, name, attributes);
		      if (text != null) {
		        child.text(text);
		      }
		      this.children.push(child);
		      return child;
		    };

		    XMLNode.prototype.text = function(value) {
		      var child;
		      child = new XMLText(this, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLNode.prototype.cdata = function(value) {
		      var child;
		      child = new XMLCData(this, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLNode.prototype.comment = function(value) {
		      var child;
		      child = new XMLComment(this, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLNode.prototype.commentBefore = function(value) {
		      var child, i, removed;
		      i = this.parent.children.indexOf(this);
		      removed = this.parent.children.splice(i);
		      child = this.parent.comment(value);
		      Array.prototype.push.apply(this.parent.children, removed);
		      return this;
		    };

		    XMLNode.prototype.commentAfter = function(value) {
		      var child, i, removed;
		      i = this.parent.children.indexOf(this);
		      removed = this.parent.children.splice(i + 1);
		      child = this.parent.comment(value);
		      Array.prototype.push.apply(this.parent.children, removed);
		      return this;
		    };

		    XMLNode.prototype.raw = function(value) {
		      var child;
		      child = new XMLRaw(this, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLNode.prototype.instruction = function(target, value) {
		      var insTarget, insValue, instruction, j, len;
		      if (target != null) {
		        target = target.valueOf();
		      }
		      if (value != null) {
		        value = value.valueOf();
		      }
		      if (Array.isArray(target)) {
		        for (j = 0, len = target.length; j < len; j++) {
		          insTarget = target[j];
		          this.instruction(insTarget);
		        }
		      } else if (isObject(target)) {
		        for (insTarget in target) {
		          if (!hasProp.call(target, insTarget)) continue;
		          insValue = target[insTarget];
		          this.instruction(insTarget, insValue);
		        }
		      } else {
		        if (isFunction(value)) {
		          value = value.apply();
		        }
		        instruction = new XMLProcessingInstruction(this, target, value);
		        this.children.push(instruction);
		      }
		      return this;
		    };

		    XMLNode.prototype.instructionBefore = function(target, value) {
		      var child, i, removed;
		      i = this.parent.children.indexOf(this);
		      removed = this.parent.children.splice(i);
		      child = this.parent.instruction(target, value);
		      Array.prototype.push.apply(this.parent.children, removed);
		      return this;
		    };

		    XMLNode.prototype.instructionAfter = function(target, value) {
		      var child, i, removed;
		      i = this.parent.children.indexOf(this);
		      removed = this.parent.children.splice(i + 1);
		      child = this.parent.instruction(target, value);
		      Array.prototype.push.apply(this.parent.children, removed);
		      return this;
		    };

		    XMLNode.prototype.declaration = function(version, encoding, standalone) {
		      var doc, xmldec;
		      doc = this.document();
		      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
		      if (doc.children[0] instanceof XMLDeclaration) {
		        doc.children[0] = xmldec;
		      } else {
		        doc.children.unshift(xmldec);
		      }
		      return doc.root() || doc;
		    };

		    XMLNode.prototype.doctype = function(pubID, sysID) {
		      var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
		      doc = this.document();
		      doctype = new XMLDocType(doc, pubID, sysID);
		      ref1 = doc.children;
		      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
		        child = ref1[i];
		        if (child instanceof XMLDocType) {
		          doc.children[i] = doctype;
		          return doctype;
		        }
		      }
		      ref2 = doc.children;
		      for (i = k = 0, len1 = ref2.length; k < len1; i = ++k) {
		        child = ref2[i];
		        if (child.isRoot) {
		          doc.children.splice(i, 0, doctype);
		          return doctype;
		        }
		      }
		      doc.children.push(doctype);
		      return doctype;
		    };

		    XMLNode.prototype.up = function() {
		      if (this.isRoot) {
		        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
		      }
		      return this.parent;
		    };

		    XMLNode.prototype.root = function() {
		      var node;
		      node = this;
		      while (node) {
		        if (node.isDocument) {
		          return node.rootObject;
		        } else if (node.isRoot) {
		          return node;
		        } else {
		          node = node.parent;
		        }
		      }
		    };

		    XMLNode.prototype.document = function() {
		      var node;
		      node = this;
		      while (node) {
		        if (node.isDocument) {
		          return node;
		        } else {
		          node = node.parent;
		        }
		      }
		    };

		    XMLNode.prototype.end = function(options) {
		      return this.document().end(options);
		    };

		    XMLNode.prototype.prev = function() {
		      var i;
		      i = this.parent.children.indexOf(this);
		      if (i < 1) {
		        throw new Error("Already at the first node");
		      }
		      return this.parent.children[i - 1];
		    };

		    XMLNode.prototype.next = function() {
		      var i;
		      i = this.parent.children.indexOf(this);
		      if (i === -1 || i === this.parent.children.length - 1) {
		        throw new Error("Already at the last node");
		      }
		      return this.parent.children[i + 1];
		    };

		    XMLNode.prototype.importDocument = function(doc) {
		      var clonedRoot;
		      clonedRoot = doc.root().clone();
		      clonedRoot.parent = this;
		      clonedRoot.isRoot = false;
		      this.children.push(clonedRoot);
		      return this;
		    };

		    XMLNode.prototype.ele = function(name, attributes, text) {
		      return this.element(name, attributes, text);
		    };

		    XMLNode.prototype.nod = function(name, attributes, text) {
		      return this.node(name, attributes, text);
		    };

		    XMLNode.prototype.txt = function(value) {
		      return this.text(value);
		    };

		    XMLNode.prototype.dat = function(value) {
		      return this.cdata(value);
		    };

		    XMLNode.prototype.com = function(value) {
		      return this.comment(value);
		    };

		    XMLNode.prototype.ins = function(target, value) {
		      return this.instruction(target, value);
		    };

		    XMLNode.prototype.doc = function() {
		      return this.document();
		    };

		    XMLNode.prototype.dec = function(version, encoding, standalone) {
		      return this.declaration(version, encoding, standalone);
		    };

		    XMLNode.prototype.dtd = function(pubID, sysID) {
		      return this.doctype(pubID, sysID);
		    };

		    XMLNode.prototype.e = function(name, attributes, text) {
		      return this.element(name, attributes, text);
		    };

		    XMLNode.prototype.n = function(name, attributes, text) {
		      return this.node(name, attributes, text);
		    };

		    XMLNode.prototype.t = function(value) {
		      return this.text(value);
		    };

		    XMLNode.prototype.d = function(value) {
		      return this.cdata(value);
		    };

		    XMLNode.prototype.c = function(value) {
		      return this.comment(value);
		    };

		    XMLNode.prototype.r = function(value) {
		      return this.raw(value);
		    };

		    XMLNode.prototype.i = function(target, value) {
		      return this.instruction(target, value);
		    };

		    XMLNode.prototype.u = function() {
		      return this.up();
		    };

		    XMLNode.prototype.importXMLBuilder = function(doc) {
		      return this.importDocument(doc);
		    };

		    return XMLNode;

		  })();

		}).call(this);


	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLAttribute, XMLElement, XMLNode, isFunction, isObject, ref,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  ref = __webpack_require__(5), isObject = ref.isObject, isFunction = ref.isFunction;

		  XMLNode = __webpack_require__(7);

		  XMLAttribute = __webpack_require__(9);

		  module.exports = XMLElement = (function(superClass) {
		    extend(XMLElement, superClass);

		    function XMLElement(parent, name, attributes) {
		      XMLElement.__super__.constructor.call(this, parent);
		      if (name == null) {
		        throw new Error("Missing element name");
		      }
		      this.name = this.stringify.eleName(name);
		      this.attributes = {};
		      if (attributes != null) {
		        this.attribute(attributes);
		      }
		      if (parent.isDocument) {
		        this.isRoot = true;
		        this.documentObject = parent;
		        parent.rootObject = this;
		      }
		    }

		    XMLElement.prototype.clone = function() {
		      var att, attName, clonedSelf, ref1;
		      clonedSelf = Object.create(this);
		      if (clonedSelf.isRoot) {
		        clonedSelf.documentObject = null;
		      }
		      clonedSelf.attributes = {};
		      ref1 = this.attributes;
		      for (attName in ref1) {
		        if (!hasProp.call(ref1, attName)) continue;
		        att = ref1[attName];
		        clonedSelf.attributes[attName] = att.clone();
		      }
		      clonedSelf.children = [];
		      this.children.forEach(function(child) {
		        var clonedChild;
		        clonedChild = child.clone();
		        clonedChild.parent = clonedSelf;
		        return clonedSelf.children.push(clonedChild);
		      });
		      return clonedSelf;
		    };

		    XMLElement.prototype.attribute = function(name, value) {
		      var attName, attValue;
		      if (name != null) {
		        name = name.valueOf();
		      }
		      if (isObject(name)) {
		        for (attName in name) {
		          if (!hasProp.call(name, attName)) continue;
		          attValue = name[attName];
		          this.attribute(attName, attValue);
		        }
		      } else {
		        if (isFunction(value)) {
		          value = value.apply();
		        }
		        if (!this.options.skipNullAttributes || (value != null)) {
		          this.attributes[name] = new XMLAttribute(this, name, value);
		        }
		      }
		      return this;
		    };

		    XMLElement.prototype.removeAttribute = function(name) {
		      var attName, i, len;
		      if (name == null) {
		        throw new Error("Missing attribute name");
		      }
		      name = name.valueOf();
		      if (Array.isArray(name)) {
		        for (i = 0, len = name.length; i < len; i++) {
		          attName = name[i];
		          delete this.attributes[attName];
		        }
		      } else {
		        delete this.attributes[name];
		      }
		      return this;
		    };

		    XMLElement.prototype.toString = function(options) {
		      return this.options.writer.set(options).element(this);
		    };

		    XMLElement.prototype.att = function(name, value) {
		      return this.attribute(name, value);
		    };

		    XMLElement.prototype.a = function(name, value) {
		      return this.attribute(name, value);
		    };

		    return XMLElement;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLAttribute;

		  module.exports = XMLAttribute = (function() {
		    function XMLAttribute(parent, name, value) {
		      this.options = parent.options;
		      this.stringify = parent.stringify;
		      if (name == null) {
		        throw new Error("Missing attribute name of element " + parent.name);
		      }
		      if (value == null) {
		        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
		      }
		      this.name = this.stringify.attName(name);
		      this.value = this.stringify.attValue(value);
		    }

		    XMLAttribute.prototype.clone = function() {
		      return Object.create(this);
		    };

		    XMLAttribute.prototype.toString = function(options) {
		      return this.options.writer.set(options).attribute(this);
		    };

		    return XMLAttribute;

		  })();

		}).call(this);


	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLCData, XMLNode,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLCData = (function(superClass) {
		    extend(XMLCData, superClass);

		    function XMLCData(parent, text) {
		      XMLCData.__super__.constructor.call(this, parent);
		      if (text == null) {
		        throw new Error("Missing CDATA text");
		      }
		      this.text = this.stringify.cdata(text);
		    }

		    XMLCData.prototype.clone = function() {
		      return Object.create(this);
		    };

		    XMLCData.prototype.toString = function(options) {
		      return this.options.writer.set(options).cdata(this);
		    };

		    return XMLCData;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLComment, XMLNode,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLComment = (function(superClass) {
		    extend(XMLComment, superClass);

		    function XMLComment(parent, text) {
		      XMLComment.__super__.constructor.call(this, parent);
		      if (text == null) {
		        throw new Error("Missing comment text");
		      }
		      this.text = this.stringify.comment(text);
		    }

		    XMLComment.prototype.clone = function() {
		      return Object.create(this);
		    };

		    XMLComment.prototype.toString = function(options) {
		      return this.options.writer.set(options).comment(this);
		    };

		    return XMLComment;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDeclaration, XMLNode, isObject,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  isObject = __webpack_require__(5).isObject;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLDeclaration = (function(superClass) {
		    extend(XMLDeclaration, superClass);

		    function XMLDeclaration(parent, version, encoding, standalone) {
		      var ref;
		      XMLDeclaration.__super__.constructor.call(this, parent);
		      if (isObject(version)) {
		        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
		      }
		      if (!version) {
		        version = '1.0';
		      }
		      this.version = this.stringify.xmlVersion(version);
		      if (encoding != null) {
		        this.encoding = this.stringify.xmlEncoding(encoding);
		      }
		      if (standalone != null) {
		        this.standalone = this.stringify.xmlStandalone(standalone);
		      }
		    }

		    XMLDeclaration.prototype.toString = function(options) {
		      return this.options.writer.set(options).declaration(this);
		    };

		    return XMLDeclaration;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  isObject = __webpack_require__(5).isObject;

		  XMLNode = __webpack_require__(7);

		  XMLDTDAttList = __webpack_require__(14);

		  XMLDTDEntity = __webpack_require__(15);

		  XMLDTDElement = __webpack_require__(16);

		  XMLDTDNotation = __webpack_require__(17);

		  module.exports = XMLDocType = (function(superClass) {
		    extend(XMLDocType, superClass);

		    function XMLDocType(parent, pubID, sysID) {
		      var ref, ref1;
		      XMLDocType.__super__.constructor.call(this, parent);
		      this.documentObject = parent;
		      if (isObject(pubID)) {
		        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
		      }
		      if (sysID == null) {
		        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
		      }
		      if (pubID != null) {
		        this.pubID = this.stringify.dtdPubID(pubID);
		      }
		      if (sysID != null) {
		        this.sysID = this.stringify.dtdSysID(sysID);
		      }
		    }

		    XMLDocType.prototype.element = function(name, value) {
		      var child;
		      child = new XMLDTDElement(this, name, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
		      var child;
		      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
		      this.children.push(child);
		      return this;
		    };

		    XMLDocType.prototype.entity = function(name, value) {
		      var child;
		      child = new XMLDTDEntity(this, false, name, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLDocType.prototype.pEntity = function(name, value) {
		      var child;
		      child = new XMLDTDEntity(this, true, name, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLDocType.prototype.notation = function(name, value) {
		      var child;
		      child = new XMLDTDNotation(this, name, value);
		      this.children.push(child);
		      return this;
		    };

		    XMLDocType.prototype.toString = function(options) {
		      return this.options.writer.set(options).docType(this);
		    };

		    XMLDocType.prototype.ele = function(name, value) {
		      return this.element(name, value);
		    };

		    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
		      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
		    };

		    XMLDocType.prototype.ent = function(name, value) {
		      return this.entity(name, value);
		    };

		    XMLDocType.prototype.pent = function(name, value) {
		      return this.pEntity(name, value);
		    };

		    XMLDocType.prototype.not = function(name, value) {
		      return this.notation(name, value);
		    };

		    XMLDocType.prototype.up = function() {
		      return this.root() || this.documentObject;
		    };

		    return XMLDocType;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDTDAttList, XMLNode,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLDTDAttList = (function(superClass) {
		    extend(XMLDTDAttList, superClass);

		    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
		      XMLDTDAttList.__super__.constructor.call(this, parent);
		      if (elementName == null) {
		        throw new Error("Missing DTD element name");
		      }
		      if (attributeName == null) {
		        throw new Error("Missing DTD attribute name");
		      }
		      if (!attributeType) {
		        throw new Error("Missing DTD attribute type");
		      }
		      if (!defaultValueType) {
		        throw new Error("Missing DTD attribute default");
		      }
		      if (defaultValueType.indexOf('#') !== 0) {
		        defaultValueType = '#' + defaultValueType;
		      }
		      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
		        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
		      }
		      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
		        throw new Error("Default value only applies to #FIXED or #DEFAULT");
		      }
		      this.elementName = this.stringify.eleName(elementName);
		      this.attributeName = this.stringify.attName(attributeName);
		      this.attributeType = this.stringify.dtdAttType(attributeType);
		      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
		      this.defaultValueType = defaultValueType;
		    }

		    XMLDTDAttList.prototype.toString = function(options) {
		      return this.options.writer.set(options).dtdAttList(this);
		    };

		    return XMLDTDAttList;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDTDEntity, XMLNode, isObject,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  isObject = __webpack_require__(5).isObject;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLDTDEntity = (function(superClass) {
		    extend(XMLDTDEntity, superClass);

		    function XMLDTDEntity(parent, pe, name, value) {
		      XMLDTDEntity.__super__.constructor.call(this, parent);
		      if (name == null) {
		        throw new Error("Missing entity name");
		      }
		      if (value == null) {
		        throw new Error("Missing entity value");
		      }
		      this.pe = !!pe;
		      this.name = this.stringify.eleName(name);
		      if (!isObject(value)) {
		        this.value = this.stringify.dtdEntityValue(value);
		      } else {
		        if (!value.pubID && !value.sysID) {
		          throw new Error("Public and/or system identifiers are required for an external entity");
		        }
		        if (value.pubID && !value.sysID) {
		          throw new Error("System identifier is required for a public external entity");
		        }
		        if (value.pubID != null) {
		          this.pubID = this.stringify.dtdPubID(value.pubID);
		        }
		        if (value.sysID != null) {
		          this.sysID = this.stringify.dtdSysID(value.sysID);
		        }
		        if (value.nData != null) {
		          this.nData = this.stringify.dtdNData(value.nData);
		        }
		        if (this.pe && this.nData) {
		          throw new Error("Notation declaration is not allowed in a parameter entity");
		        }
		      }
		    }

		    XMLDTDEntity.prototype.toString = function(options) {
		      return this.options.writer.set(options).dtdEntity(this);
		    };

		    return XMLDTDEntity;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDTDElement, XMLNode,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLDTDElement = (function(superClass) {
		    extend(XMLDTDElement, superClass);

		    function XMLDTDElement(parent, name, value) {
		      XMLDTDElement.__super__.constructor.call(this, parent);
		      if (name == null) {
		        throw new Error("Missing DTD element name");
		      }
		      if (!value) {
		        value = '(#PCDATA)';
		      }
		      if (Array.isArray(value)) {
		        value = '(' + value.join(',') + ')';
		      }
		      this.name = this.stringify.eleName(name);
		      this.value = this.stringify.dtdElementValue(value);
		    }

		    XMLDTDElement.prototype.toString = function(options) {
		      return this.options.writer.set(options).dtdElement(this);
		    };

		    return XMLDTDElement;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLDTDNotation, XMLNode,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLDTDNotation = (function(superClass) {
		    extend(XMLDTDNotation, superClass);

		    function XMLDTDNotation(parent, name, value) {
		      XMLDTDNotation.__super__.constructor.call(this, parent);
		      if (name == null) {
		        throw new Error("Missing notation name");
		      }
		      if (!value.pubID && !value.sysID) {
		        throw new Error("Public or system identifiers are required for an external entity");
		      }
		      this.name = this.stringify.eleName(name);
		      if (value.pubID != null) {
		        this.pubID = this.stringify.dtdPubID(value.pubID);
		      }
		      if (value.sysID != null) {
		        this.sysID = this.stringify.dtdSysID(value.sysID);
		      }
		    }

		    XMLDTDNotation.prototype.toString = function(options) {
		      return this.options.writer.set(options).dtdNotation(this);
		    };

		    return XMLDTDNotation;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLNode, XMLRaw,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLRaw = (function(superClass) {
		    extend(XMLRaw, superClass);

		    function XMLRaw(parent, text) {
		      XMLRaw.__super__.constructor.call(this, parent);
		      if (text == null) {
		        throw new Error("Missing raw text");
		      }
		      this.value = this.stringify.raw(text);
		    }

		    XMLRaw.prototype.clone = function() {
		      return Object.create(this);
		    };

		    XMLRaw.prototype.toString = function(options) {
		      return this.options.writer.set(options).raw(this);
		    };

		    return XMLRaw;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLNode, XMLText,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLText = (function(superClass) {
		    extend(XMLText, superClass);

		    function XMLText(parent, text) {
		      XMLText.__super__.constructor.call(this, parent);
		      if (text == null) {
		        throw new Error("Missing element text");
		      }
		      this.value = this.stringify.eleText(text);
		    }

		    XMLText.prototype.clone = function() {
		      return Object.create(this);
		    };

		    XMLText.prototype.toString = function(options) {
		      return this.options.writer.set(options).text(this);
		    };

		    return XMLText;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLNode, XMLProcessingInstruction,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLNode = __webpack_require__(7);

		  module.exports = XMLProcessingInstruction = (function(superClass) {
		    extend(XMLProcessingInstruction, superClass);

		    function XMLProcessingInstruction(parent, target, value) {
		      XMLProcessingInstruction.__super__.constructor.call(this, parent);
		      if (target == null) {
		        throw new Error("Missing instruction target");
		      }
		      this.target = this.stringify.insTarget(target);
		      if (value) {
		        this.value = this.stringify.insValue(value);
		      }
		    }

		    XMLProcessingInstruction.prototype.clone = function() {
		      return Object.create(this);
		    };

		    XMLProcessingInstruction.prototype.toString = function(options) {
		      return this.options.writer.set(options).processingInstruction(this);
		    };

		    return XMLProcessingInstruction;

		  })(XMLNode);

		}).call(this);


	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLStringifier,
		    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
		    hasProp = {}.hasOwnProperty;

		  module.exports = XMLStringifier = (function() {
		    function XMLStringifier(options) {
		      this.assertLegalChar = bind(this.assertLegalChar, this);
		      var key, ref, value;
		      options || (options = {});
		      this.noDoubleEncoding = options.noDoubleEncoding;
		      ref = options.stringify || {};
		      for (key in ref) {
		        if (!hasProp.call(ref, key)) continue;
		        value = ref[key];
		        this[key] = value;
		      }
		    }

		    XMLStringifier.prototype.eleName = function(val) {
		      val = '' + val || '';
		      return this.assertLegalChar(val);
		    };

		    XMLStringifier.prototype.eleText = function(val) {
		      val = '' + val || '';
		      return this.assertLegalChar(this.elEscape(val));
		    };

		    XMLStringifier.prototype.cdata = function(val) {
		      val = '' + val || '';
		      val = val.replace(']]>', ']]]]><![CDATA[>');
		      return this.assertLegalChar(val);
		    };

		    XMLStringifier.prototype.comment = function(val) {
		      val = '' + val || '';
		      if (val.match(/--/)) {
		        throw new Error("Comment text cannot contain double-hypen: " + val);
		      }
		      return this.assertLegalChar(val);
		    };

		    XMLStringifier.prototype.raw = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.attName = function(val) {
		      return val = '' + val || '';
		    };

		    XMLStringifier.prototype.attValue = function(val) {
		      val = '' + val || '';
		      return this.attEscape(val);
		    };

		    XMLStringifier.prototype.insTarget = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.insValue = function(val) {
		      val = '' + val || '';
		      if (val.match(/\?>/)) {
		        throw new Error("Invalid processing instruction value: " + val);
		      }
		      return val;
		    };

		    XMLStringifier.prototype.xmlVersion = function(val) {
		      val = '' + val || '';
		      if (!val.match(/1\.[0-9]+/)) {
		        throw new Error("Invalid version number: " + val);
		      }
		      return val;
		    };

		    XMLStringifier.prototype.xmlEncoding = function(val) {
		      val = '' + val || '';
		      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) {
		        throw new Error("Invalid encoding: " + val);
		      }
		      return val;
		    };

		    XMLStringifier.prototype.xmlStandalone = function(val) {
		      if (val) {
		        return "yes";
		      } else {
		        return "no";
		      }
		    };

		    XMLStringifier.prototype.dtdPubID = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.dtdSysID = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.dtdElementValue = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.dtdAttType = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.dtdAttDefault = function(val) {
		      if (val != null) {
		        return '' + val || '';
		      } else {
		        return val;
		      }
		    };

		    XMLStringifier.prototype.dtdEntityValue = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.dtdNData = function(val) {
		      return '' + val || '';
		    };

		    XMLStringifier.prototype.convertAttKey = '@';

		    XMLStringifier.prototype.convertPIKey = '?';

		    XMLStringifier.prototype.convertTextKey = '#text';

		    XMLStringifier.prototype.convertCDataKey = '#cdata';

		    XMLStringifier.prototype.convertCommentKey = '#comment';

		    XMLStringifier.prototype.convertRawKey = '#raw';

		    XMLStringifier.prototype.assertLegalChar = function(str) {
		      var res;
		      res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
		      if (res) {
		        throw new Error("Invalid character in string: " + str + " at index " + res.index);
		      }
		      return str;
		    };

		    XMLStringifier.prototype.elEscape = function(str) {
		      var ampregex;
		      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
		      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
		    };

		    XMLStringifier.prototype.attEscape = function(str) {
		      var ampregex;
		      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
		      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
		    };

		    return XMLStringifier;

		  })();

		}).call(this);


	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLDeclaration = __webpack_require__(12);

		  XMLDocType = __webpack_require__(13);

		  XMLCData = __webpack_require__(10);

		  XMLComment = __webpack_require__(11);

		  XMLElement = __webpack_require__(8);

		  XMLRaw = __webpack_require__(18);

		  XMLText = __webpack_require__(19);

		  XMLProcessingInstruction = __webpack_require__(20);

		  XMLDTDAttList = __webpack_require__(14);

		  XMLDTDElement = __webpack_require__(16);

		  XMLDTDEntity = __webpack_require__(15);

		  XMLDTDNotation = __webpack_require__(17);

		  XMLWriterBase = __webpack_require__(23);

		  module.exports = XMLStringWriter = (function(superClass) {
		    extend(XMLStringWriter, superClass);

		    function XMLStringWriter(options) {
		      XMLStringWriter.__super__.constructor.call(this, options);
		    }

		    XMLStringWriter.prototype.document = function(doc) {
		      var child, i, len, r, ref;
		      this.textispresent = false;
		      r = '';
		      ref = doc.children;
		      for (i = 0, len = ref.length; i < len; i++) {
		        child = ref[i];
		        r += (function() {
		          switch (false) {
		            case !(child instanceof XMLDeclaration):
		              return this.declaration(child);
		            case !(child instanceof XMLDocType):
		              return this.docType(child);
		            case !(child instanceof XMLComment):
		              return this.comment(child);
		            case !(child instanceof XMLProcessingInstruction):
		              return this.processingInstruction(child);
		            default:
		              return this.element(child, 0);
		          }
		        }).call(this);
		      }
		      if (this.pretty && r.slice(-this.newline.length) === this.newline) {
		        r = r.slice(0, -this.newline.length);
		      }
		      return r;
		    };

		    XMLStringWriter.prototype.attribute = function(att) {
		      return ' ' + att.name + '="' + att.value + '"';
		    };

		    XMLStringWriter.prototype.cdata = function(node, level) {
		      return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
		    };

		    XMLStringWriter.prototype.comment = function(node, level) {
		      return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
		    };

		    XMLStringWriter.prototype.declaration = function(node, level) {
		      var r;
		      r = this.space(level);
		      r += '<?xml version="' + node.version + '"';
		      if (node.encoding != null) {
		        r += ' encoding="' + node.encoding + '"';
		      }
		      if (node.standalone != null) {
		        r += ' standalone="' + node.standalone + '"';
		      }
		      r += this.spacebeforeslash + '?>';
		      r += this.newline;
		      return r;
		    };

		    XMLStringWriter.prototype.docType = function(node, level) {
		      var child, i, len, r, ref;
		      level || (level = 0);
		      r = this.space(level);
		      r += '<!DOCTYPE ' + node.root().name;
		      if (node.pubID && node.sysID) {
		        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
		      } else if (node.sysID) {
		        r += ' SYSTEM "' + node.sysID + '"';
		      }
		      if (node.children.length > 0) {
		        r += ' [';
		        r += this.newline;
		        ref = node.children;
		        for (i = 0, len = ref.length; i < len; i++) {
		          child = ref[i];
		          r += (function() {
		            switch (false) {
		              case !(child instanceof XMLDTDAttList):
		                return this.dtdAttList(child, level + 1);
		              case !(child instanceof XMLDTDElement):
		                return this.dtdElement(child, level + 1);
		              case !(child instanceof XMLDTDEntity):
		                return this.dtdEntity(child, level + 1);
		              case !(child instanceof XMLDTDNotation):
		                return this.dtdNotation(child, level + 1);
		              case !(child instanceof XMLCData):
		                return this.cdata(child, level + 1);
		              case !(child instanceof XMLComment):
		                return this.comment(child, level + 1);
		              case !(child instanceof XMLProcessingInstruction):
		                return this.processingInstruction(child, level + 1);
		              default:
		                throw new Error("Unknown DTD node type: " + child.constructor.name);
		            }
		          }).call(this);
		        }
		        r += ']';
		      }
		      r += this.spacebeforeslash + '>';
		      r += this.newline;
		      return r;
		    };

		    XMLStringWriter.prototype.element = function(node, level) {
		      var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
		      level || (level = 0);
		      textispresentwasset = false;
		      if (this.textispresent) {
		        this.newline = '';
		        this.pretty = false;
		      } else {
		        this.newline = this.newlinedefault;
		        this.pretty = this.prettydefault;
		      }
		      space = this.space(level);
		      r = '';
		      r += space + '<' + node.name;
		      ref = node.attributes;
		      for (name in ref) {
		        if (!hasProp.call(ref, name)) continue;
		        att = ref[name];
		        r += this.attribute(att);
		      }
		      if (node.children.length === 0 || node.children.every(function(e) {
		        return e.value === '';
		      })) {
		        if (this.allowEmpty) {
		          r += '></' + node.name + '>' + this.newline;
		        } else {
		          r += this.spacebeforeslash + '/>' + this.newline;
		        }
		      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
		        r += '>';
		        r += node.children[0].value;
		        r += '</' + node.name + '>' + this.newline;
		      } else {
		        if (this.dontprettytextnodes) {
		          ref1 = node.children;
		          for (i = 0, len = ref1.length; i < len; i++) {
		            child = ref1[i];
		            if (child.value != null) {
		              this.textispresent++;
		              textispresentwasset = true;
		              break;
		            }
		          }
		        }
		        if (this.textispresent) {
		          this.newline = '';
		          this.pretty = false;
		          space = this.space(level);
		        }
		        r += '>' + this.newline;
		        ref2 = node.children;
		        for (j = 0, len1 = ref2.length; j < len1; j++) {
		          child = ref2[j];
		          r += (function() {
		            switch (false) {
		              case !(child instanceof XMLCData):
		                return this.cdata(child, level + 1);
		              case !(child instanceof XMLComment):
		                return this.comment(child, level + 1);
		              case !(child instanceof XMLElement):
		                return this.element(child, level + 1);
		              case !(child instanceof XMLRaw):
		                return this.raw(child, level + 1);
		              case !(child instanceof XMLText):
		                return this.text(child, level + 1);
		              case !(child instanceof XMLProcessingInstruction):
		                return this.processingInstruction(child, level + 1);
		              default:
		                throw new Error("Unknown XML node type: " + child.constructor.name);
		            }
		          }).call(this);
		        }
		        if (textispresentwasset) {
		          this.textispresent--;
		        }
		        if (!this.textispresent) {
		          this.newline = this.newlinedefault;
		          this.pretty = this.prettydefault;
		        }
		        r += space + '</' + node.name + '>' + this.newline;
		      }
		      return r;
		    };

		    XMLStringWriter.prototype.processingInstruction = function(node, level) {
		      var r;
		      r = this.space(level) + '<?' + node.target;
		      if (node.value) {
		        r += ' ' + node.value;
		      }
		      r += this.spacebeforeslash + '?>' + this.newline;
		      return r;
		    };

		    XMLStringWriter.prototype.raw = function(node, level) {
		      return this.space(level) + node.value + this.newline;
		    };

		    XMLStringWriter.prototype.text = function(node, level) {
		      return this.space(level) + node.value + this.newline;
		    };

		    XMLStringWriter.prototype.dtdAttList = function(node, level) {
		      var r;
		      r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
		      if (node.defaultValueType !== '#DEFAULT') {
		        r += ' ' + node.defaultValueType;
		      }
		      if (node.defaultValue) {
		        r += ' "' + node.defaultValue + '"';
		      }
		      r += this.spacebeforeslash + '>' + this.newline;
		      return r;
		    };

		    XMLStringWriter.prototype.dtdElement = function(node, level) {
		      return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
		    };

		    XMLStringWriter.prototype.dtdEntity = function(node, level) {
		      var r;
		      r = this.space(level) + '<!ENTITY';
		      if (node.pe) {
		        r += ' %';
		      }
		      r += ' ' + node.name;
		      if (node.value) {
		        r += ' "' + node.value + '"';
		      } else {
		        if (node.pubID && node.sysID) {
		          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
		        } else if (node.sysID) {
		          r += ' SYSTEM "' + node.sysID + '"';
		        }
		        if (node.nData) {
		          r += ' NDATA ' + node.nData;
		        }
		      }
		      r += this.spacebeforeslash + '>' + this.newline;
		      return r;
		    };

		    XMLStringWriter.prototype.dtdNotation = function(node, level) {
		      var r;
		      r = this.space(level) + '<!NOTATION ' + node.name;
		      if (node.pubID && node.sysID) {
		        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
		      } else if (node.pubID) {
		        r += ' PUBLIC "' + node.pubID + '"';
		      } else if (node.sysID) {
		        r += ' SYSTEM "' + node.sysID + '"';
		      }
		      r += this.spacebeforeslash + '>' + this.newline;
		      return r;
		    };

		    XMLStringWriter.prototype.openNode = function(node, level) {
		      var att, name, r, ref;
		      level || (level = 0);
		      if (node instanceof XMLElement) {
		        r = this.space(level) + '<' + node.name;
		        ref = node.attributes;
		        for (name in ref) {
		          if (!hasProp.call(ref, name)) continue;
		          att = ref[name];
		          r += this.attribute(att);
		        }
		        r += (node.children ? '>' : '/>') + this.newline;
		        return r;
		      } else {
		        r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
		        if (node.pubID && node.sysID) {
		          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
		        } else if (node.sysID) {
		          r += ' SYSTEM "' + node.sysID + '"';
		        }
		        r += (node.children ? ' [' : '>') + this.newline;
		        return r;
		      }
		    };

		    XMLStringWriter.prototype.closeNode = function(node, level) {
		      level || (level = 0);
		      switch (false) {
		        case !(node instanceof XMLElement):
		          return this.space(level) + '</' + node.name + '>' + this.newline;
		        case !(node instanceof XMLDocType):
		          return this.space(level) + ']>' + this.newline;
		      }
		    };

		    return XMLStringWriter;

		  })(XMLWriterBase);

		}).call(this);


	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLWriterBase,
		    hasProp = {}.hasOwnProperty;

		  module.exports = XMLWriterBase = (function() {
		    function XMLWriterBase(options) {
		      var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
		      options || (options = {});
		      this.pretty = options.pretty || false;
		      this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
		      if (this.pretty) {
		        this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
		        this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
		        this.offset = (ref3 = options.offset) != null ? ref3 : 0;
		        this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
		      } else {
		        this.indent = '';
		        this.newline = '';
		        this.offset = 0;
		        this.dontprettytextnodes = 0;
		      }
		      this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
		      if (this.spacebeforeslash === true) {
		        this.spacebeforeslash = ' ';
		      }
		      this.newlinedefault = this.newline;
		      this.prettydefault = this.pretty;
		      ref6 = options.writer || {};
		      for (key in ref6) {
		        if (!hasProp.call(ref6, key)) continue;
		        value = ref6[key];
		        this[key] = value;
		      }
		    }

		    XMLWriterBase.prototype.set = function(options) {
		      var key, ref, value;
		      options || (options = {});
		      if ("pretty" in options) {
		        this.pretty = options.pretty;
		      }
		      if ("allowEmpty" in options) {
		        this.allowEmpty = options.allowEmpty;
		      }
		      if (this.pretty) {
		        this.indent = "indent" in options ? options.indent : '  ';
		        this.newline = "newline" in options ? options.newline : '\n';
		        this.offset = "offset" in options ? options.offset : 0;
		        this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
		      } else {
		        this.indent = '';
		        this.newline = '';
		        this.offset = 0;
		        this.dontprettytextnodes = 0;
		      }
		      this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
		      if (this.spacebeforeslash === true) {
		        this.spacebeforeslash = ' ';
		      }
		      this.newlinedefault = this.newline;
		      this.prettydefault = this.pretty;
		      ref = options.writer || {};
		      for (key in ref) {
		        if (!hasProp.call(ref, key)) continue;
		        value = ref[key];
		        this[key] = value;
		      }
		      return this;
		    };

		    XMLWriterBase.prototype.space = function(level) {
		      var indent;
		      if (this.pretty) {
		        indent = (level || 0) + this.offset + 1;
		        if (indent > 0) {
		          return new Array(indent).join(this.indent);
		        } else {
		          return '';
		        }
		      } else {
		        return '';
		      }
		    };

		    return XMLWriterBase;

		  })();

		}).call(this);


	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, isFunction, isObject, isPlainObject, ref,
		    hasProp = {}.hasOwnProperty;

		  ref = __webpack_require__(5), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject;

		  XMLElement = __webpack_require__(8);

		  XMLCData = __webpack_require__(10);

		  XMLComment = __webpack_require__(11);

		  XMLRaw = __webpack_require__(18);

		  XMLText = __webpack_require__(19);

		  XMLProcessingInstruction = __webpack_require__(20);

		  XMLDeclaration = __webpack_require__(12);

		  XMLDocType = __webpack_require__(13);

		  XMLDTDAttList = __webpack_require__(14);

		  XMLDTDEntity = __webpack_require__(15);

		  XMLDTDElement = __webpack_require__(16);

		  XMLDTDNotation = __webpack_require__(17);

		  XMLAttribute = __webpack_require__(9);

		  XMLStringifier = __webpack_require__(21);

		  XMLStringWriter = __webpack_require__(22);

		  module.exports = XMLDocumentCB = (function() {
		    function XMLDocumentCB(options, onData, onEnd) {
		      var writerOptions;
		      options || (options = {});
		      if (!options.writer) {
		        options.writer = new XMLStringWriter(options);
		      } else if (isPlainObject(options.writer)) {
		        writerOptions = options.writer;
		        options.writer = new XMLStringWriter(writerOptions);
		      }
		      this.options = options;
		      this.writer = options.writer;
		      this.stringify = new XMLStringifier(options);
		      this.onDataCallback = onData || function() {};
		      this.onEndCallback = onEnd || function() {};
		      this.currentNode = null;
		      this.currentLevel = -1;
		      this.openTags = {};
		      this.documentStarted = false;
		      this.documentCompleted = false;
		      this.root = null;
		    }

		    XMLDocumentCB.prototype.node = function(name, attributes, text) {
		      var ref1;
		      if (name == null) {
		        throw new Error("Missing node name");
		      }
		      if (this.root && this.currentLevel === -1) {
		        throw new Error("Document can only have one root node");
		      }
		      this.openCurrent();
		      name = name.valueOf();
		      if (attributes == null) {
		        attributes = {};
		      }
		      attributes = attributes.valueOf();
		      if (!isObject(attributes)) {
		        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
		      }
		      this.currentNode = new XMLElement(this, name, attributes);
		      this.currentNode.children = false;
		      this.currentLevel++;
		      this.openTags[this.currentLevel] = this.currentNode;
		      if (text != null) {
		        this.text(text);
		      }
		      return this;
		    };

		    XMLDocumentCB.prototype.element = function(name, attributes, text) {
		      if (this.currentNode && this.currentNode instanceof XMLDocType) {
		        return this.dtdElement.apply(this, arguments);
		      } else {
		        return this.node(name, attributes, text);
		      }
		    };

		    XMLDocumentCB.prototype.attribute = function(name, value) {
		      var attName, attValue;
		      if (!this.currentNode || this.currentNode.children) {
		        throw new Error("att() can only be used immediately after an ele() call in callback mode");
		      }
		      if (name != null) {
		        name = name.valueOf();
		      }
		      if (isObject(name)) {
		        for (attName in name) {
		          if (!hasProp.call(name, attName)) continue;
		          attValue = name[attName];
		          this.attribute(attName, attValue);
		        }
		      } else {
		        if (isFunction(value)) {
		          value = value.apply();
		        }
		        if (!this.options.skipNullAttributes || (value != null)) {
		          this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
		        }
		      }
		      return this;
		    };

		    XMLDocumentCB.prototype.text = function(value) {
		      var node;
		      this.openCurrent();
		      node = new XMLText(this, value);
		      this.onData(this.writer.text(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.cdata = function(value) {
		      var node;
		      this.openCurrent();
		      node = new XMLCData(this, value);
		      this.onData(this.writer.cdata(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.comment = function(value) {
		      var node;
		      this.openCurrent();
		      node = new XMLComment(this, value);
		      this.onData(this.writer.comment(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.raw = function(value) {
		      var node;
		      this.openCurrent();
		      node = new XMLRaw(this, value);
		      this.onData(this.writer.raw(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.instruction = function(target, value) {
		      var i, insTarget, insValue, len, node;
		      this.openCurrent();
		      if (target != null) {
		        target = target.valueOf();
		      }
		      if (value != null) {
		        value = value.valueOf();
		      }
		      if (Array.isArray(target)) {
		        for (i = 0, len = target.length; i < len; i++) {
		          insTarget = target[i];
		          this.instruction(insTarget);
		        }
		      } else if (isObject(target)) {
		        for (insTarget in target) {
		          if (!hasProp.call(target, insTarget)) continue;
		          insValue = target[insTarget];
		          this.instruction(insTarget, insValue);
		        }
		      } else {
		        if (isFunction(value)) {
		          value = value.apply();
		        }
		        node = new XMLProcessingInstruction(this, target, value);
		        this.onData(this.writer.processingInstruction(node, this.currentLevel + 1));
		      }
		      return this;
		    };

		    XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
		      var node;
		      this.openCurrent();
		      if (this.documentStarted) {
		        throw new Error("declaration() must be the first node");
		      }
		      node = new XMLDeclaration(this, version, encoding, standalone);
		      this.onData(this.writer.declaration(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
		      this.openCurrent();
		      if (root == null) {
		        throw new Error("Missing root node name");
		      }
		      if (this.root) {
		        throw new Error("dtd() must come before the root node");
		      }
		      this.currentNode = new XMLDocType(this, pubID, sysID);
		      this.currentNode.rootNodeName = root;
		      this.currentNode.children = false;
		      this.currentLevel++;
		      this.openTags[this.currentLevel] = this.currentNode;
		      return this;
		    };

		    XMLDocumentCB.prototype.dtdElement = function(name, value) {
		      var node;
		      this.openCurrent();
		      node = new XMLDTDElement(this, name, value);
		      this.onData(this.writer.dtdElement(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
		      var node;
		      this.openCurrent();
		      node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
		      this.onData(this.writer.dtdAttList(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.entity = function(name, value) {
		      var node;
		      this.openCurrent();
		      node = new XMLDTDEntity(this, false, name, value);
		      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.pEntity = function(name, value) {
		      var node;
		      this.openCurrent();
		      node = new XMLDTDEntity(this, true, name, value);
		      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.notation = function(name, value) {
		      var node;
		      this.openCurrent();
		      node = new XMLDTDNotation(this, name, value);
		      this.onData(this.writer.dtdNotation(node, this.currentLevel + 1));
		      return this;
		    };

		    XMLDocumentCB.prototype.up = function() {
		      if (this.currentLevel < 0) {
		        throw new Error("The document node has no parent");
		      }
		      if (this.currentNode) {
		        if (this.currentNode.children) {
		          this.closeNode(this.currentNode);
		        } else {
		          this.openNode(this.currentNode);
		        }
		        this.currentNode = null;
		      } else {
		        this.closeNode(this.openTags[this.currentLevel]);
		      }
		      delete this.openTags[this.currentLevel];
		      this.currentLevel--;
		      return this;
		    };

		    XMLDocumentCB.prototype.end = function() {
		      while (this.currentLevel >= 0) {
		        this.up();
		      }
		      return this.onEnd();
		    };

		    XMLDocumentCB.prototype.openCurrent = function() {
		      if (this.currentNode) {
		        this.currentNode.children = true;
		        return this.openNode(this.currentNode);
		      }
		    };

		    XMLDocumentCB.prototype.openNode = function(node) {
		      if (!node.isOpen) {
		        if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) {
		          this.root = node;
		        }
		        this.onData(this.writer.openNode(node, this.currentLevel));
		        return node.isOpen = true;
		      }
		    };

		    XMLDocumentCB.prototype.closeNode = function(node) {
		      if (!node.isClosed) {
		        this.onData(this.writer.closeNode(node, this.currentLevel));
		        return node.isClosed = true;
		      }
		    };

		    XMLDocumentCB.prototype.onData = function(chunk) {
		      this.documentStarted = true;
		      return this.onDataCallback(chunk);
		    };

		    XMLDocumentCB.prototype.onEnd = function() {
		      this.documentCompleted = true;
		      return this.onEndCallback();
		    };

		    XMLDocumentCB.prototype.ele = function() {
		      return this.element.apply(this, arguments);
		    };

		    XMLDocumentCB.prototype.nod = function(name, attributes, text) {
		      return this.node(name, attributes, text);
		    };

		    XMLDocumentCB.prototype.txt = function(value) {
		      return this.text(value);
		    };

		    XMLDocumentCB.prototype.dat = function(value) {
		      return this.cdata(value);
		    };

		    XMLDocumentCB.prototype.com = function(value) {
		      return this.comment(value);
		    };

		    XMLDocumentCB.prototype.ins = function(target, value) {
		      return this.instruction(target, value);
		    };

		    XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
		      return this.declaration(version, encoding, standalone);
		    };

		    XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
		      return this.doctype(root, pubID, sysID);
		    };

		    XMLDocumentCB.prototype.e = function(name, attributes, text) {
		      return this.element(name, attributes, text);
		    };

		    XMLDocumentCB.prototype.n = function(name, attributes, text) {
		      return this.node(name, attributes, text);
		    };

		    XMLDocumentCB.prototype.t = function(value) {
		      return this.text(value);
		    };

		    XMLDocumentCB.prototype.d = function(value) {
		      return this.cdata(value);
		    };

		    XMLDocumentCB.prototype.c = function(value) {
		      return this.comment(value);
		    };

		    XMLDocumentCB.prototype.r = function(value) {
		      return this.raw(value);
		    };

		    XMLDocumentCB.prototype.i = function(target, value) {
		      return this.instruction(target, value);
		    };

		    XMLDocumentCB.prototype.att = function() {
		      if (this.currentNode && this.currentNode instanceof XMLDocType) {
		        return this.attList.apply(this, arguments);
		      } else {
		        return this.attribute.apply(this, arguments);
		      }
		    };

		    XMLDocumentCB.prototype.a = function() {
		      if (this.currentNode && this.currentNode instanceof XMLDocType) {
		        return this.attList.apply(this, arguments);
		      } else {
		        return this.attribute.apply(this, arguments);
		      }
		    };

		    XMLDocumentCB.prototype.ent = function(name, value) {
		      return this.entity(name, value);
		    };

		    XMLDocumentCB.prototype.pent = function(name, value) {
		      return this.pEntity(name, value);
		    };

		    XMLDocumentCB.prototype.not = function(name, value) {
		      return this.notation(name, value);
		    };

		    return XMLDocumentCB;

		  })();

		}).call(this);


	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase,
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  XMLDeclaration = __webpack_require__(12);

		  XMLDocType = __webpack_require__(13);

		  XMLCData = __webpack_require__(10);

		  XMLComment = __webpack_require__(11);

		  XMLElement = __webpack_require__(8);

		  XMLRaw = __webpack_require__(18);

		  XMLText = __webpack_require__(19);

		  XMLProcessingInstruction = __webpack_require__(20);

		  XMLDTDAttList = __webpack_require__(14);

		  XMLDTDElement = __webpack_require__(16);

		  XMLDTDEntity = __webpack_require__(15);

		  XMLDTDNotation = __webpack_require__(17);

		  XMLWriterBase = __webpack_require__(23);

		  module.exports = XMLStreamWriter = (function(superClass) {
		    extend(XMLStreamWriter, superClass);

		    function XMLStreamWriter(stream, options) {
		      XMLStreamWriter.__super__.constructor.call(this, options);
		      this.stream = stream;
		    }

		    XMLStreamWriter.prototype.document = function(doc) {
		      var child, i, j, len, len1, ref, ref1, results;
		      ref = doc.children;
		      for (i = 0, len = ref.length; i < len; i++) {
		        child = ref[i];
		        child.isLastRootNode = false;
		      }
		      doc.children[doc.children.length - 1].isLastRootNode = true;
		      ref1 = doc.children;
		      results = [];
		      for (j = 0, len1 = ref1.length; j < len1; j++) {
		        child = ref1[j];
		        switch (false) {
		          case !(child instanceof XMLDeclaration):
		            results.push(this.declaration(child));
		            break;
		          case !(child instanceof XMLDocType):
		            results.push(this.docType(child));
		            break;
		          case !(child instanceof XMLComment):
		            results.push(this.comment(child));
		            break;
		          case !(child instanceof XMLProcessingInstruction):
		            results.push(this.processingInstruction(child));
		            break;
		          default:
		            results.push(this.element(child));
		        }
		      }
		      return results;
		    };

		    XMLStreamWriter.prototype.attribute = function(att) {
		      return this.stream.write(' ' + att.name + '="' + att.value + '"');
		    };

		    XMLStreamWriter.prototype.cdata = function(node, level) {
		      return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.comment = function(node, level) {
		      return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.declaration = function(node, level) {
		      this.stream.write(this.space(level));
		      this.stream.write('<?xml version="' + node.version + '"');
		      if (node.encoding != null) {
		        this.stream.write(' encoding="' + node.encoding + '"');
		      }
		      if (node.standalone != null) {
		        this.stream.write(' standalone="' + node.standalone + '"');
		      }
		      this.stream.write(this.spacebeforeslash + '?>');
		      return this.stream.write(this.endline(node));
		    };

		    XMLStreamWriter.prototype.docType = function(node, level) {
		      var child, i, len, ref;
		      level || (level = 0);
		      this.stream.write(this.space(level));
		      this.stream.write('<!DOCTYPE ' + node.root().name);
		      if (node.pubID && node.sysID) {
		        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
		      } else if (node.sysID) {
		        this.stream.write(' SYSTEM "' + node.sysID + '"');
		      }
		      if (node.children.length > 0) {
		        this.stream.write(' [');
		        this.stream.write(this.endline(node));
		        ref = node.children;
		        for (i = 0, len = ref.length; i < len; i++) {
		          child = ref[i];
		          switch (false) {
		            case !(child instanceof XMLDTDAttList):
		              this.dtdAttList(child, level + 1);
		              break;
		            case !(child instanceof XMLDTDElement):
		              this.dtdElement(child, level + 1);
		              break;
		            case !(child instanceof XMLDTDEntity):
		              this.dtdEntity(child, level + 1);
		              break;
		            case !(child instanceof XMLDTDNotation):
		              this.dtdNotation(child, level + 1);
		              break;
		            case !(child instanceof XMLCData):
		              this.cdata(child, level + 1);
		              break;
		            case !(child instanceof XMLComment):
		              this.comment(child, level + 1);
		              break;
		            case !(child instanceof XMLProcessingInstruction):
		              this.processingInstruction(child, level + 1);
		              break;
		            default:
		              throw new Error("Unknown DTD node type: " + child.constructor.name);
		          }
		        }
		        this.stream.write(']');
		      }
		      this.stream.write(this.spacebeforeslash + '>');
		      return this.stream.write(this.endline(node));
		    };

		    XMLStreamWriter.prototype.element = function(node, level) {
		      var att, child, i, len, name, ref, ref1, space;
		      level || (level = 0);
		      space = this.space(level);
		      this.stream.write(space + '<' + node.name);
		      ref = node.attributes;
		      for (name in ref) {
		        if (!hasProp.call(ref, name)) continue;
		        att = ref[name];
		        this.attribute(att);
		      }
		      if (node.children.length === 0 || node.children.every(function(e) {
		        return e.value === '';
		      })) {
		        if (this.allowEmpty) {
		          this.stream.write('></' + node.name + '>');
		        } else {
		          this.stream.write(this.spacebeforeslash + '/>');
		        }
		      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
		        this.stream.write('>');
		        this.stream.write(node.children[0].value);
		        this.stream.write('</' + node.name + '>');
		      } else {
		        this.stream.write('>' + this.newline);
		        ref1 = node.children;
		        for (i = 0, len = ref1.length; i < len; i++) {
		          child = ref1[i];
		          switch (false) {
		            case !(child instanceof XMLCData):
		              this.cdata(child, level + 1);
		              break;
		            case !(child instanceof XMLComment):
		              this.comment(child, level + 1);
		              break;
		            case !(child instanceof XMLElement):
		              this.element(child, level + 1);
		              break;
		            case !(child instanceof XMLRaw):
		              this.raw(child, level + 1);
		              break;
		            case !(child instanceof XMLText):
		              this.text(child, level + 1);
		              break;
		            case !(child instanceof XMLProcessingInstruction):
		              this.processingInstruction(child, level + 1);
		              break;
		            default:
		              throw new Error("Unknown XML node type: " + child.constructor.name);
		          }
		        }
		        this.stream.write(space + '</' + node.name + '>');
		      }
		      return this.stream.write(this.endline(node));
		    };

		    XMLStreamWriter.prototype.processingInstruction = function(node, level) {
		      this.stream.write(this.space(level) + '<?' + node.target);
		      if (node.value) {
		        this.stream.write(' ' + node.value);
		      }
		      return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.raw = function(node, level) {
		      return this.stream.write(this.space(level) + node.value + this.endline(node));
		    };

		    XMLStreamWriter.prototype.text = function(node, level) {
		      return this.stream.write(this.space(level) + node.value + this.endline(node));
		    };

		    XMLStreamWriter.prototype.dtdAttList = function(node, level) {
		      this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
		      if (node.defaultValueType !== '#DEFAULT') {
		        this.stream.write(' ' + node.defaultValueType);
		      }
		      if (node.defaultValue) {
		        this.stream.write(' "' + node.defaultValue + '"');
		      }
		      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.dtdElement = function(node, level) {
		      this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
		      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.dtdEntity = function(node, level) {
		      this.stream.write(this.space(level) + '<!ENTITY');
		      if (node.pe) {
		        this.stream.write(' %');
		      }
		      this.stream.write(' ' + node.name);
		      if (node.value) {
		        this.stream.write(' "' + node.value + '"');
		      } else {
		        if (node.pubID && node.sysID) {
		          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
		        } else if (node.sysID) {
		          this.stream.write(' SYSTEM "' + node.sysID + '"');
		        }
		        if (node.nData) {
		          this.stream.write(' NDATA ' + node.nData);
		        }
		      }
		      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.dtdNotation = function(node, level) {
		      this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
		      if (node.pubID && node.sysID) {
		        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
		      } else if (node.pubID) {
		        this.stream.write(' PUBLIC "' + node.pubID + '"');
		      } else if (node.sysID) {
		        this.stream.write(' SYSTEM "' + node.sysID + '"');
		      }
		      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
		    };

		    XMLStreamWriter.prototype.endline = function(node) {
		      if (!node.isLastRootNode) {
		        return this.newline;
		      } else {
		        return '';
		      }
		    };

		    return XMLStreamWriter;

		  })(XMLWriterBase);

		}).call(this);


	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  "use strict";
		  var bom, defaults, events, isEmpty, processItem, processors, sax, setImmediate,
		    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
		    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		    hasProp = {}.hasOwnProperty;

		  sax = __webpack_require__(27);

		  events = __webpack_require__(33);

		  bom = __webpack_require__(59);

		  processors = __webpack_require__(60);

		  setImmediate = __webpack_require__(48).setImmediate;

		  defaults = __webpack_require__(2).defaults;

		  isEmpty = function(thing) {
		    return typeof thing === "object" && (thing != null) && Object.keys(thing).length === 0;
		  };

		  processItem = function(processors, item, key) {
		    var i, len, process;
		    for (i = 0, len = processors.length; i < len; i++) {
		      process = processors[i];
		      item = process(item, key);
		    }
		    return item;
		  };

		  exports.Parser = (function(superClass) {
		    extend(Parser, superClass);

		    function Parser(opts) {
		      this.parseString = bind(this.parseString, this);
		      this.reset = bind(this.reset, this);
		      this.assignOrPush = bind(this.assignOrPush, this);
		      this.processAsync = bind(this.processAsync, this);
		      var key, ref, value;
		      if (!(this instanceof exports.Parser)) {
		        return new exports.Parser(opts);
		      }
		      this.options = {};
		      ref = defaults["0.2"];
		      for (key in ref) {
		        if (!hasProp.call(ref, key)) continue;
		        value = ref[key];
		        this.options[key] = value;
		      }
		      for (key in opts) {
		        if (!hasProp.call(opts, key)) continue;
		        value = opts[key];
		        this.options[key] = value;
		      }
		      if (this.options.xmlns) {
		        this.options.xmlnskey = this.options.attrkey + "ns";
		      }
		      if (this.options.normalizeTags) {
		        if (!this.options.tagNameProcessors) {
		          this.options.tagNameProcessors = [];
		        }
		        this.options.tagNameProcessors.unshift(processors.normalize);
		      }
		      this.reset();
		    }

		    Parser.prototype.processAsync = function() {
		      var chunk, err;
		      try {
		        if (this.remaining.length <= this.options.chunkSize) {
		          chunk = this.remaining;
		          this.remaining = '';
		          this.saxParser = this.saxParser.write(chunk);
		          return this.saxParser.close();
		        } else {
		          chunk = this.remaining.substr(0, this.options.chunkSize);
		          this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length);
		          this.saxParser = this.saxParser.write(chunk);
		          return setImmediate(this.processAsync);
		        }
		      } catch (error1) {
		        err = error1;
		        if (!this.saxParser.errThrown) {
		          this.saxParser.errThrown = true;
		          return this.emit(err);
		        }
		      }
		    };

		    Parser.prototype.assignOrPush = function(obj, key, newValue) {
		      if (!(key in obj)) {
		        if (!this.options.explicitArray) {
		          return obj[key] = newValue;
		        } else {
		          return obj[key] = [newValue];
		        }
		      } else {
		        if (!(obj[key] instanceof Array)) {
		          obj[key] = [obj[key]];
		        }
		        return obj[key].push(newValue);
		      }
		    };

		    Parser.prototype.reset = function() {
		      var attrkey, charkey, ontext, stack;
		      this.removeAllListeners();
		      this.saxParser = sax.parser(this.options.strict, {
		        trim: false,
		        normalize: false,
		        xmlns: this.options.xmlns
		      });
		      this.saxParser.errThrown = false;
		      this.saxParser.onerror = (function(_this) {
		        return function(error) {
		          _this.saxParser.resume();
		          if (!_this.saxParser.errThrown) {
		            _this.saxParser.errThrown = true;
		            return _this.emit("error", error);
		          }
		        };
		      })(this);
		      this.saxParser.onend = (function(_this) {
		        return function() {
		          if (!_this.saxParser.ended) {
		            _this.saxParser.ended = true;
		            return _this.emit("end", _this.resultObject);
		          }
		        };
		      })(this);
		      this.saxParser.ended = false;
		      this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
		      this.resultObject = null;
		      stack = [];
		      attrkey = this.options.attrkey;
		      charkey = this.options.charkey;
		      this.saxParser.onopentag = (function(_this) {
		        return function(node) {
		          var key, newValue, obj, processedKey, ref;
		          obj = {};
		          obj[charkey] = "";
		          if (!_this.options.ignoreAttrs) {
		            ref = node.attributes;
		            for (key in ref) {
		              if (!hasProp.call(ref, key)) continue;
		              if (!(attrkey in obj) && !_this.options.mergeAttrs) {
		                obj[attrkey] = {};
		              }
		              newValue = _this.options.attrValueProcessors ? processItem(_this.options.attrValueProcessors, node.attributes[key], key) : node.attributes[key];
		              processedKey = _this.options.attrNameProcessors ? processItem(_this.options.attrNameProcessors, key) : key;
		              if (_this.options.mergeAttrs) {
		                _this.assignOrPush(obj, processedKey, newValue);
		              } else {
		                obj[attrkey][processedKey] = newValue;
		              }
		            }
		          }
		          obj["#name"] = _this.options.tagNameProcessors ? processItem(_this.options.tagNameProcessors, node.name) : node.name;
		          if (_this.options.xmlns) {
		            obj[_this.options.xmlnskey] = {
		              uri: node.uri,
		              local: node.local
		            };
		          }
		          return stack.push(obj);
		        };
		      })(this);
		      this.saxParser.onclosetag = (function(_this) {
		        return function() {
		          var cdata, emptyStr, key, node, nodeName, obj, objClone, old, s, xpath;
		          obj = stack.pop();
		          nodeName = obj["#name"];
		          if (!_this.options.explicitChildren || !_this.options.preserveChildrenOrder) {
		            delete obj["#name"];
		          }
		          if (obj.cdata === true) {
		            cdata = obj.cdata;
		            delete obj.cdata;
		          }
		          s = stack[stack.length - 1];
		          if (obj[charkey].match(/^\s*$/) && !cdata) {
		            emptyStr = obj[charkey];
		            delete obj[charkey];
		          } else {
		            if (_this.options.trim) {
		              obj[charkey] = obj[charkey].trim();
		            }
		            if (_this.options.normalize) {
		              obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
		            }
		            obj[charkey] = _this.options.valueProcessors ? processItem(_this.options.valueProcessors, obj[charkey], nodeName) : obj[charkey];
		            if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
		              obj = obj[charkey];
		            }
		          }
		          if (isEmpty(obj)) {
		            obj = _this.options.emptyTag !== '' ? _this.options.emptyTag : emptyStr;
		          }
		          if (_this.options.validator != null) {
		            xpath = "/" + ((function() {
		              var i, len, results;
		              results = [];
		              for (i = 0, len = stack.length; i < len; i++) {
		                node = stack[i];
		                results.push(node["#name"]);
		              }
		              return results;
		            })()).concat(nodeName).join("/");
		            (function() {
		              var err;
		              try {
		                return obj = _this.options.validator(xpath, s && s[nodeName], obj);
		              } catch (error1) {
		                err = error1;
		                return _this.emit("error", err);
		              }
		            })();
		          }
		          if (_this.options.explicitChildren && !_this.options.mergeAttrs && typeof obj === 'object') {
		            if (!_this.options.preserveChildrenOrder) {
		              node = {};
		              if (_this.options.attrkey in obj) {
		                node[_this.options.attrkey] = obj[_this.options.attrkey];
		                delete obj[_this.options.attrkey];
		              }
		              if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
		                node[_this.options.charkey] = obj[_this.options.charkey];
		                delete obj[_this.options.charkey];
		              }
		              if (Object.getOwnPropertyNames(obj).length > 0) {
		                node[_this.options.childkey] = obj;
		              }
		              obj = node;
		            } else if (s) {
		              s[_this.options.childkey] = s[_this.options.childkey] || [];
		              objClone = {};
		              for (key in obj) {
		                if (!hasProp.call(obj, key)) continue;
		                objClone[key] = obj[key];
		              }
		              s[_this.options.childkey].push(objClone);
		              delete obj["#name"];
		              if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
		                obj = obj[charkey];
		              }
		            }
		          }
		          if (stack.length > 0) {
		            return _this.assignOrPush(s, nodeName, obj);
		          } else {
		            if (_this.options.explicitRoot) {
		              old = obj;
		              obj = {};
		              obj[nodeName] = old;
		            }
		            _this.resultObject = obj;
		            _this.saxParser.ended = true;
		            return _this.emit("end", _this.resultObject);
		          }
		        };
		      })(this);
		      ontext = (function(_this) {
		        return function(text) {
		          var charChild, s;
		          s = stack[stack.length - 1];
		          if (s) {
		            s[charkey] += text;
		            if (_this.options.explicitChildren && _this.options.preserveChildrenOrder && _this.options.charsAsChildren && (_this.options.includeWhiteChars || text.replace(/\\n/g, '').trim() !== '')) {
		              s[_this.options.childkey] = s[_this.options.childkey] || [];
		              charChild = {
		                '#name': '__text__'
		              };
		              charChild[charkey] = text;
		              if (_this.options.normalize) {
		                charChild[charkey] = charChild[charkey].replace(/\s{2,}/g, " ").trim();
		              }
		              s[_this.options.childkey].push(charChild);
		            }
		            return s;
		          }
		        };
		      })(this);
		      this.saxParser.ontext = ontext;
		      return this.saxParser.oncdata = (function(_this) {
		        return function(text) {
		          var s;
		          s = ontext(text);
		          if (s) {
		            return s.cdata = true;
		          }
		        };
		      })(this);
		    };

		    Parser.prototype.parseString = function(str, cb) {
		      var err;
		      if ((cb != null) && typeof cb === "function") {
		        this.on("end", function(result) {
		          this.reset();
		          return cb(null, result);
		        });
		        this.on("error", function(err) {
		          this.reset();
		          return cb(err);
		        });
		      }
		      try {
		        str = str.toString();
		        if (str.trim() === '') {
		          this.emit("end", null);
		          return true;
		        }
		        str = bom.stripBOM(str);
		        if (this.options.async) {
		          this.remaining = str;
		          setImmediate(this.processAsync);
		          return this.saxParser;
		        }
		        return this.saxParser.write(str).close();
		      } catch (error1) {
		        err = error1;
		        if (!(this.saxParser.errThrown || this.saxParser.ended)) {
		          this.emit('error', err);
		          return this.saxParser.errThrown = true;
		        } else if (this.saxParser.ended) {
		          throw err;
		        }
		      }
		    };

		    return Parser;

		  })(events.EventEmitter);

		  exports.parseString = function(str, a, b) {
		    var cb, options, parser;
		    if (b != null) {
		      if (typeof b === 'function') {
		        cb = b;
		      }
		      if (typeof a === 'object') {
		        options = a;
		      }
		    } else {
		      if (typeof a === 'function') {
		        cb = a;
		      }
		      options = {};
		    }
		    parser = new exports.Parser(options);
		    return parser.parseString(str, cb);
		  };

		}).call(this);


	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
		  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
		  sax.SAXParser = SAXParser
		  sax.SAXStream = SAXStream
		  sax.createStream = createStream

		  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
		  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
		  // since that's the earliest that a buffer overrun could occur.  This way, checks are
		  // as rare as required, but as often as necessary to ensure never crossing this bound.
		  // Furthermore, buffers are only tested at most once per write(), so passing a very
		  // large string into write() might have undesirable effects, but this is manageable by
		  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
		  // edge case, result in creating at most one complete copy of the string passed in.
		  // Set to Infinity to have unlimited buffers.
		  sax.MAX_BUFFER_LENGTH = 64 * 1024

		  var buffers = [
		    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
		    'procInstName', 'procInstBody', 'entity', 'attribName',
		    'attribValue', 'cdata', 'script'
		  ]

		  sax.EVENTS = [
		    'text',
		    'processinginstruction',
		    'sgmldeclaration',
		    'doctype',
		    'comment',
		    'opentagstart',
		    'attribute',
		    'opentag',
		    'closetag',
		    'opencdata',
		    'cdata',
		    'closecdata',
		    'error',
		    'end',
		    'ready',
		    'script',
		    'opennamespace',
		    'closenamespace'
		  ]

		  function SAXParser (strict, opt) {
		    if (!(this instanceof SAXParser)) {
		      return new SAXParser(strict, opt)
		    }

		    var parser = this
		    clearBuffers(parser)
		    parser.q = parser.c = ''
		    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
		    parser.opt = opt || {}
		    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
		    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
		    parser.tags = []
		    parser.closed = parser.closedRoot = parser.sawRoot = false
		    parser.tag = parser.error = null
		    parser.strict = !!strict
		    parser.noscript = !!(strict || parser.opt.noscript)
		    parser.state = S.BEGIN
		    parser.strictEntities = parser.opt.strictEntities
		    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
		    parser.attribList = []

		    // namespaces form a prototype chain.
		    // it always points at the current tag,
		    // which protos to its parent tag.
		    if (parser.opt.xmlns) {
		      parser.ns = Object.create(rootNS)
		    }

		    // mostly just for error reporting
		    parser.trackPosition = parser.opt.position !== false
		    if (parser.trackPosition) {
		      parser.position = parser.line = parser.column = 0
		    }
		    emit(parser, 'onready')
		  }

		  if (!Object.create) {
		    Object.create = function (o) {
		      function F () {}
		      F.prototype = o
		      var newf = new F()
		      return newf
		    }
		  }

		  if (!Object.keys) {
		    Object.keys = function (o) {
		      var a = []
		      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
		      return a
		    }
		  }

		  function checkBufferLength (parser) {
		    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
		    var maxActual = 0
		    for (var i = 0, l = buffers.length; i < l; i++) {
		      var len = parser[buffers[i]].length
		      if (len > maxAllowed) {
		        // Text/cdata nodes can get big, and since they're buffered,
		        // we can get here under normal conditions.
		        // Avoid issues by emitting the text node now,
		        // so at least it won't get any bigger.
		        switch (buffers[i]) {
		          case 'textNode':
		            closeText(parser)
		            break

		          case 'cdata':
		            emitNode(parser, 'oncdata', parser.cdata)
		            parser.cdata = ''
		            break

		          case 'script':
		            emitNode(parser, 'onscript', parser.script)
		            parser.script = ''
		            break

		          default:
		            error(parser, 'Max buffer length exceeded: ' + buffers[i])
		        }
		      }
		      maxActual = Math.max(maxActual, len)
		    }
		    // schedule the next check for the earliest possible buffer overrun.
		    var m = sax.MAX_BUFFER_LENGTH - maxActual
		    parser.bufferCheckPosition = m + parser.position
		  }

		  function clearBuffers (parser) {
		    for (var i = 0, l = buffers.length; i < l; i++) {
		      parser[buffers[i]] = ''
		    }
		  }

		  function flushBuffers (parser) {
		    closeText(parser)
		    if (parser.cdata !== '') {
		      emitNode(parser, 'oncdata', parser.cdata)
		      parser.cdata = ''
		    }
		    if (parser.script !== '') {
		      emitNode(parser, 'onscript', parser.script)
		      parser.script = ''
		    }
		  }

		  SAXParser.prototype = {
		    end: function () { end(this) },
		    write: write,
		    resume: function () { this.error = null; return this },
		    close: function () { return this.write(null) },
		    flush: function () { flushBuffers(this) }
		  }

		  var Stream
		  try {
		    Stream = __webpack_require__(32).Stream
		  } catch (ex) {
		    Stream = function () {}
		  }

		  var streamWraps = sax.EVENTS.filter(function (ev) {
		    return ev !== 'error' && ev !== 'end'
		  })

		  function createStream (strict, opt) {
		    return new SAXStream(strict, opt)
		  }

		  function SAXStream (strict, opt) {
		    if (!(this instanceof SAXStream)) {
		      return new SAXStream(strict, opt)
		    }

		    Stream.apply(this)

		    this._parser = new SAXParser(strict, opt)
		    this.writable = true
		    this.readable = true

		    var me = this

		    this._parser.onend = function () {
		      me.emit('end')
		    }

		    this._parser.onerror = function (er) {
		      me.emit('error', er)

		      // if didn't throw, then means error was handled.
		      // go ahead and clear error, so we can write again.
		      me._parser.error = null
		    }

		    this._decoder = null

		    streamWraps.forEach(function (ev) {
		      Object.defineProperty(me, 'on' + ev, {
		        get: function () {
		          return me._parser['on' + ev]
		        },
		        set: function (h) {
		          if (!h) {
		            me.removeAllListeners(ev)
		            me._parser['on' + ev] = h
		            return h
		          }
		          me.on(ev, h)
		        },
		        enumerable: true,
		        configurable: false
		      })
		    })
		  }

		  SAXStream.prototype = Object.create(Stream.prototype, {
		    constructor: {
		      value: SAXStream
		    }
		  })

		  SAXStream.prototype.write = function (data) {
		    if (typeof Buffer === 'function' &&
		      typeof Buffer.isBuffer === 'function' &&
		      Buffer.isBuffer(data)) {
		      if (!this._decoder) {
		        var SD = __webpack_require__(58).StringDecoder
		        this._decoder = new SD('utf8')
		      }
		      data = this._decoder.write(data)
		    }

		    this._parser.write(data.toString())
		    this.emit('data', data)
		    return true
		  }

		  SAXStream.prototype.end = function (chunk) {
		    if (chunk && chunk.length) {
		      this.write(chunk)
		    }
		    this._parser.end()
		    return true
		  }

		  SAXStream.prototype.on = function (ev, handler) {
		    var me = this
		    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
		      me._parser['on' + ev] = function () {
		        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
		        args.splice(0, 0, ev)
		        me.emit.apply(me, args)
		      }
		    }

		    return Stream.prototype.on.call(me, ev, handler)
		  }

		  // character classes and tokens
		  var whitespace = '\r\n\t '

		  // this really needs to be replaced with character classes.
		  // XML allows all manner of ridiculous numbers and digits.
		  var number = '0124356789'
		  var letter = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

		  // (Letter | "_" | ":")
		  var quote = '\'"'
		  var attribEnd = whitespace + '>'
		  var CDATA = '[CDATA['
		  var DOCTYPE = 'DOCTYPE'
		  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
		  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
		  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

		  // turn all the string character sets into character class objects.
		  whitespace = charClass(whitespace)
		  number = charClass(number)
		  letter = charClass(letter)

		  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
		  // This implementation works on strings, a single character at a time
		  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
		  // without a significant breaking change to either this  parser, or the
		  // JavaScript language.  Implementation of an emoji-capable xml parser
		  // is left as an exercise for the reader.
		  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

		  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/

		  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
		  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/

		  quote = charClass(quote)
		  attribEnd = charClass(attribEnd)

		  function charClass (str) {
		    return str.split('').reduce(function (s, c) {
		      s[c] = true
		      return s
		    }, {})
		  }

		  function isRegExp (c) {
		    return Object.prototype.toString.call(c) === '[object RegExp]'
		  }

		  function is (charclass, c) {
		    return isRegExp(charclass) ? !!c.match(charclass) : charclass[c]
		  }

		  function not (charclass, c) {
		    return !is(charclass, c)
		  }

		  var S = 0
		  sax.STATE = {
		    BEGIN: S++, // leading byte order mark or whitespace
		    BEGIN_WHITESPACE: S++, // leading whitespace
		    TEXT: S++, // general stuff
		    TEXT_ENTITY: S++, // &amp and such.
		    OPEN_WAKA: S++, // <
		    SGML_DECL: S++, // <!BLARG
		    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
		    DOCTYPE: S++, // <!DOCTYPE
		    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
		    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
		    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
		    COMMENT_STARTING: S++, // <!-
		    COMMENT: S++, // <!--
		    COMMENT_ENDING: S++, // <!-- blah -
		    COMMENT_ENDED: S++, // <!-- blah --
		    CDATA: S++, // <![CDATA[ something
		    CDATA_ENDING: S++, // ]
		    CDATA_ENDING_2: S++, // ]]
		    PROC_INST: S++, // <?hi
		    PROC_INST_BODY: S++, // <?hi there
		    PROC_INST_ENDING: S++, // <?hi "there" ?
		    OPEN_TAG: S++, // <strong
		    OPEN_TAG_SLASH: S++, // <strong /
		    ATTRIB: S++, // <a
		    ATTRIB_NAME: S++, // <a foo
		    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
		    ATTRIB_VALUE: S++, // <a foo=
		    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
		    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
		    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
		    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
		    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
		    CLOSE_TAG: S++, // </a
		    CLOSE_TAG_SAW_WHITE: S++, // </a   >
		    SCRIPT: S++, // <script> ...
		    SCRIPT_ENDING: S++ // <script> ... <
		  }

		  sax.XML_ENTITIES = {
		    'amp': '&',
		    'gt': '>',
		    'lt': '<',
		    'quot': '"',
		    'apos': "'"
		  }

		  sax.ENTITIES = {
		    'amp': '&',
		    'gt': '>',
		    'lt': '<',
		    'quot': '"',
		    'apos': "'",
		    'AElig': 198,
		    'Aacute': 193,
		    'Acirc': 194,
		    'Agrave': 192,
		    'Aring': 197,
		    'Atilde': 195,
		    'Auml': 196,
		    'Ccedil': 199,
		    'ETH': 208,
		    'Eacute': 201,
		    'Ecirc': 202,
		    'Egrave': 200,
		    'Euml': 203,
		    'Iacute': 205,
		    'Icirc': 206,
		    'Igrave': 204,
		    'Iuml': 207,
		    'Ntilde': 209,
		    'Oacute': 211,
		    'Ocirc': 212,
		    'Ograve': 210,
		    'Oslash': 216,
		    'Otilde': 213,
		    'Ouml': 214,
		    'THORN': 222,
		    'Uacute': 218,
		    'Ucirc': 219,
		    'Ugrave': 217,
		    'Uuml': 220,
		    'Yacute': 221,
		    'aacute': 225,
		    'acirc': 226,
		    'aelig': 230,
		    'agrave': 224,
		    'aring': 229,
		    'atilde': 227,
		    'auml': 228,
		    'ccedil': 231,
		    'eacute': 233,
		    'ecirc': 234,
		    'egrave': 232,
		    'eth': 240,
		    'euml': 235,
		    'iacute': 237,
		    'icirc': 238,
		    'igrave': 236,
		    'iuml': 239,
		    'ntilde': 241,
		    'oacute': 243,
		    'ocirc': 244,
		    'ograve': 242,
		    'oslash': 248,
		    'otilde': 245,
		    'ouml': 246,
		    'szlig': 223,
		    'thorn': 254,
		    'uacute': 250,
		    'ucirc': 251,
		    'ugrave': 249,
		    'uuml': 252,
		    'yacute': 253,
		    'yuml': 255,
		    'copy': 169,
		    'reg': 174,
		    'nbsp': 160,
		    'iexcl': 161,
		    'cent': 162,
		    'pound': 163,
		    'curren': 164,
		    'yen': 165,
		    'brvbar': 166,
		    'sect': 167,
		    'uml': 168,
		    'ordf': 170,
		    'laquo': 171,
		    'not': 172,
		    'shy': 173,
		    'macr': 175,
		    'deg': 176,
		    'plusmn': 177,
		    'sup1': 185,
		    'sup2': 178,
		    'sup3': 179,
		    'acute': 180,
		    'micro': 181,
		    'para': 182,
		    'middot': 183,
		    'cedil': 184,
		    'ordm': 186,
		    'raquo': 187,
		    'frac14': 188,
		    'frac12': 189,
		    'frac34': 190,
		    'iquest': 191,
		    'times': 215,
		    'divide': 247,
		    'OElig': 338,
		    'oelig': 339,
		    'Scaron': 352,
		    'scaron': 353,
		    'Yuml': 376,
		    'fnof': 402,
		    'circ': 710,
		    'tilde': 732,
		    'Alpha': 913,
		    'Beta': 914,
		    'Gamma': 915,
		    'Delta': 916,
		    'Epsilon': 917,
		    'Zeta': 918,
		    'Eta': 919,
		    'Theta': 920,
		    'Iota': 921,
		    'Kappa': 922,
		    'Lambda': 923,
		    'Mu': 924,
		    'Nu': 925,
		    'Xi': 926,
		    'Omicron': 927,
		    'Pi': 928,
		    'Rho': 929,
		    'Sigma': 931,
		    'Tau': 932,
		    'Upsilon': 933,
		    'Phi': 934,
		    'Chi': 935,
		    'Psi': 936,
		    'Omega': 937,
		    'alpha': 945,
		    'beta': 946,
		    'gamma': 947,
		    'delta': 948,
		    'epsilon': 949,
		    'zeta': 950,
		    'eta': 951,
		    'theta': 952,
		    'iota': 953,
		    'kappa': 954,
		    'lambda': 955,
		    'mu': 956,
		    'nu': 957,
		    'xi': 958,
		    'omicron': 959,
		    'pi': 960,
		    'rho': 961,
		    'sigmaf': 962,
		    'sigma': 963,
		    'tau': 964,
		    'upsilon': 965,
		    'phi': 966,
		    'chi': 967,
		    'psi': 968,
		    'omega': 969,
		    'thetasym': 977,
		    'upsih': 978,
		    'piv': 982,
		    'ensp': 8194,
		    'emsp': 8195,
		    'thinsp': 8201,
		    'zwnj': 8204,
		    'zwj': 8205,
		    'lrm': 8206,
		    'rlm': 8207,
		    'ndash': 8211,
		    'mdash': 8212,
		    'lsquo': 8216,
		    'rsquo': 8217,
		    'sbquo': 8218,
		    'ldquo': 8220,
		    'rdquo': 8221,
		    'bdquo': 8222,
		    'dagger': 8224,
		    'Dagger': 8225,
		    'bull': 8226,
		    'hellip': 8230,
		    'permil': 8240,
		    'prime': 8242,
		    'Prime': 8243,
		    'lsaquo': 8249,
		    'rsaquo': 8250,
		    'oline': 8254,
		    'frasl': 8260,
		    'euro': 8364,
		    'image': 8465,
		    'weierp': 8472,
		    'real': 8476,
		    'trade': 8482,
		    'alefsym': 8501,
		    'larr': 8592,
		    'uarr': 8593,
		    'rarr': 8594,
		    'darr': 8595,
		    'harr': 8596,
		    'crarr': 8629,
		    'lArr': 8656,
		    'uArr': 8657,
		    'rArr': 8658,
		    'dArr': 8659,
		    'hArr': 8660,
		    'forall': 8704,
		    'part': 8706,
		    'exist': 8707,
		    'empty': 8709,
		    'nabla': 8711,
		    'isin': 8712,
		    'notin': 8713,
		    'ni': 8715,
		    'prod': 8719,
		    'sum': 8721,
		    'minus': 8722,
		    'lowast': 8727,
		    'radic': 8730,
		    'prop': 8733,
		    'infin': 8734,
		    'ang': 8736,
		    'and': 8743,
		    'or': 8744,
		    'cap': 8745,
		    'cup': 8746,
		    'int': 8747,
		    'there4': 8756,
		    'sim': 8764,
		    'cong': 8773,
		    'asymp': 8776,
		    'ne': 8800,
		    'equiv': 8801,
		    'le': 8804,
		    'ge': 8805,
		    'sub': 8834,
		    'sup': 8835,
		    'nsub': 8836,
		    'sube': 8838,
		    'supe': 8839,
		    'oplus': 8853,
		    'otimes': 8855,
		    'perp': 8869,
		    'sdot': 8901,
		    'lceil': 8968,
		    'rceil': 8969,
		    'lfloor': 8970,
		    'rfloor': 8971,
		    'lang': 9001,
		    'rang': 9002,
		    'loz': 9674,
		    'spades': 9824,
		    'clubs': 9827,
		    'hearts': 9829,
		    'diams': 9830
		  }

		  Object.keys(sax.ENTITIES).forEach(function (key) {
		    var e = sax.ENTITIES[key]
		    var s = typeof e === 'number' ? String.fromCharCode(e) : e
		    sax.ENTITIES[key] = s
		  })

		  for (var s in sax.STATE) {
		    sax.STATE[sax.STATE[s]] = s
		  }

		  // shorthand
		  S = sax.STATE

		  function emit (parser, event, data) {
		    parser[event] && parser[event](data)
		  }

		  function emitNode (parser, nodeType, data) {
		    if (parser.textNode) closeText(parser)
		    emit(parser, nodeType, data)
		  }

		  function closeText (parser) {
		    parser.textNode = textopts(parser.opt, parser.textNode)
		    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
		    parser.textNode = ''
		  }

		  function textopts (opt, text) {
		    if (opt.trim) text = text.trim()
		    if (opt.normalize) text = text.replace(/\s+/g, ' ')
		    return text
		  }

		  function error (parser, er) {
		    closeText(parser)
		    if (parser.trackPosition) {
		      er += '\nLine: ' + parser.line +
		        '\nColumn: ' + parser.column +
		        '\nChar: ' + parser.c
		    }
		    er = new Error(er)
		    parser.error = er
		    emit(parser, 'onerror', er)
		    return parser
		  }

		  function end (parser) {
		    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
		    if ((parser.state !== S.BEGIN) &&
		      (parser.state !== S.BEGIN_WHITESPACE) &&
		      (parser.state !== S.TEXT)) {
		      error(parser, 'Unexpected end')
		    }
		    closeText(parser)
		    parser.c = ''
		    parser.closed = true
		    emit(parser, 'onend')
		    SAXParser.call(parser, parser.strict, parser.opt)
		    return parser
		  }

		  function strictFail (parser, message) {
		    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
		      throw new Error('bad call to strictFail')
		    }
		    if (parser.strict) {
		      error(parser, message)
		    }
		  }

		  function newTag (parser) {
		    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
		    var parent = parser.tags[parser.tags.length - 1] || parser
		    var tag = parser.tag = { name: parser.tagName, attributes: {} }

		    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
		    if (parser.opt.xmlns) {
		      tag.ns = parent.ns
		    }
		    parser.attribList.length = 0
		    emitNode(parser, 'onopentagstart', tag)
		  }

		  function qname (name, attribute) {
		    var i = name.indexOf(':')
		    var qualName = i < 0 ? [ '', name ] : name.split(':')
		    var prefix = qualName[0]
		    var local = qualName[1]

		    // <x "xmlns"="http://foo">
		    if (attribute && name === 'xmlns') {
		      prefix = 'xmlns'
		      local = ''
		    }

		    return { prefix: prefix, local: local }
		  }

		  function attrib (parser) {
		    if (!parser.strict) {
		      parser.attribName = parser.attribName[parser.looseCase]()
		    }

		    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
		      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
		      parser.attribName = parser.attribValue = ''
		      return
		    }

		    if (parser.opt.xmlns) {
		      var qn = qname(parser.attribName, true)
		      var prefix = qn.prefix
		      var local = qn.local

		      if (prefix === 'xmlns') {
		        // namespace binding attribute. push the binding into scope
		        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
		          strictFail(parser,
		            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
		            'Actual: ' + parser.attribValue)
		        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
		          strictFail(parser,
		            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
		            'Actual: ' + parser.attribValue)
		        } else {
		          var tag = parser.tag
		          var parent = parser.tags[parser.tags.length - 1] || parser
		          if (tag.ns === parent.ns) {
		            tag.ns = Object.create(parent.ns)
		          }
		          tag.ns[local] = parser.attribValue
		        }
		      }

		      // defer onattribute events until all attributes have been seen
		      // so any new bindings can take effect. preserve attribute order
		      // so deferred events can be emitted in document order
		      parser.attribList.push([parser.attribName, parser.attribValue])
		    } else {
		      // in non-xmlns mode, we can emit the event right away
		      parser.tag.attributes[parser.attribName] = parser.attribValue
		      emitNode(parser, 'onattribute', {
		        name: parser.attribName,
		        value: parser.attribValue
		      })
		    }

		    parser.attribName = parser.attribValue = ''
		  }

		  function openTag (parser, selfClosing) {
		    if (parser.opt.xmlns) {
		      // emit namespace binding events
		      var tag = parser.tag

		      // add namespace info to tag
		      var qn = qname(parser.tagName)
		      tag.prefix = qn.prefix
		      tag.local = qn.local
		      tag.uri = tag.ns[qn.prefix] || ''

		      if (tag.prefix && !tag.uri) {
		        strictFail(parser, 'Unbound namespace prefix: ' +
		          JSON.stringify(parser.tagName))
		        tag.uri = qn.prefix
		      }

		      var parent = parser.tags[parser.tags.length - 1] || parser
		      if (tag.ns && parent.ns !== tag.ns) {
		        Object.keys(tag.ns).forEach(function (p) {
		          emitNode(parser, 'onopennamespace', {
		            prefix: p,
		            uri: tag.ns[p]
		          })
		        })
		      }

		      // handle deferred onattribute events
		      // Note: do not apply default ns to attributes:
		      //   http://www.w3.org/TR/REC-xml-names/#defaulting
		      for (var i = 0, l = parser.attribList.length; i < l; i++) {
		        var nv = parser.attribList[i]
		        var name = nv[0]
		        var value = nv[1]
		        var qualName = qname(name, true)
		        var prefix = qualName.prefix
		        var local = qualName.local
		        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
		        var a = {
		          name: name,
		          value: value,
		          prefix: prefix,
		          local: local,
		          uri: uri
		        }

		        // if there's any attributes with an undefined namespace,
		        // then fail on them now.
		        if (prefix && prefix !== 'xmlns' && !uri) {
		          strictFail(parser, 'Unbound namespace prefix: ' +
		            JSON.stringify(prefix))
		          a.uri = prefix
		        }
		        parser.tag.attributes[name] = a
		        emitNode(parser, 'onattribute', a)
		      }
		      parser.attribList.length = 0
		    }

		    parser.tag.isSelfClosing = !!selfClosing

		    // process the tag
		    parser.sawRoot = true
		    parser.tags.push(parser.tag)
		    emitNode(parser, 'onopentag', parser.tag)
		    if (!selfClosing) {
		      // special case for <script> in non-strict mode.
		      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
		        parser.state = S.SCRIPT
		      } else {
		        parser.state = S.TEXT
		      }
		      parser.tag = null
		      parser.tagName = ''
		    }
		    parser.attribName = parser.attribValue = ''
		    parser.attribList.length = 0
		  }

		  function closeTag (parser) {
		    if (!parser.tagName) {
		      strictFail(parser, 'Weird empty close tag.')
		      parser.textNode += '</>'
		      parser.state = S.TEXT
		      return
		    }

		    if (parser.script) {
		      if (parser.tagName !== 'script') {
		        parser.script += '</' + parser.tagName + '>'
		        parser.tagName = ''
		        parser.state = S.SCRIPT
		        return
		      }
		      emitNode(parser, 'onscript', parser.script)
		      parser.script = ''
		    }

		    // first make sure that the closing tag actually exists.
		    // <a><b></c></b></a> will close everything, otherwise.
		    var t = parser.tags.length
		    var tagName = parser.tagName
		    if (!parser.strict) {
		      tagName = tagName[parser.looseCase]()
		    }
		    var closeTo = tagName
		    while (t--) {
		      var close = parser.tags[t]
		      if (close.name !== closeTo) {
		        // fail the first time in strict mode
		        strictFail(parser, 'Unexpected close tag')
		      } else {
		        break
		      }
		    }

		    // didn't find it.  we already failed for strict, so just abort.
		    if (t < 0) {
		      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
		      parser.textNode += '</' + parser.tagName + '>'
		      parser.state = S.TEXT
		      return
		    }
		    parser.tagName = tagName
		    var s = parser.tags.length
		    while (s-- > t) {
		      var tag = parser.tag = parser.tags.pop()
		      parser.tagName = parser.tag.name
		      emitNode(parser, 'onclosetag', parser.tagName)

		      var x = {}
		      for (var i in tag.ns) {
		        x[i] = tag.ns[i]
		      }

		      var parent = parser.tags[parser.tags.length - 1] || parser
		      if (parser.opt.xmlns && tag.ns !== parent.ns) {
		        // remove namespace bindings introduced by tag
		        Object.keys(tag.ns).forEach(function (p) {
		          var n = tag.ns[p]
		          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
		        })
		      }
		    }
		    if (t === 0) parser.closedRoot = true
		    parser.tagName = parser.attribValue = parser.attribName = ''
		    parser.attribList.length = 0
		    parser.state = S.TEXT
		  }

		  function parseEntity (parser) {
		    var entity = parser.entity
		    var entityLC = entity.toLowerCase()
		    var num
		    var numStr = ''

		    if (parser.ENTITIES[entity]) {
		      return parser.ENTITIES[entity]
		    }
		    if (parser.ENTITIES[entityLC]) {
		      return parser.ENTITIES[entityLC]
		    }
		    entity = entityLC
		    if (entity.charAt(0) === '#') {
		      if (entity.charAt(1) === 'x') {
		        entity = entity.slice(2)
		        num = parseInt(entity, 16)
		        numStr = num.toString(16)
		      } else {
		        entity = entity.slice(1)
		        num = parseInt(entity, 10)
		        numStr = num.toString(10)
		      }
		    }
		    entity = entity.replace(/^0+/, '')
		    if (numStr.toLowerCase() !== entity) {
		      strictFail(parser, 'Invalid character entity')
		      return '&' + parser.entity + ';'
		    }

		    return String.fromCodePoint(num)
		  }

		  function beginWhiteSpace (parser, c) {
		    if (c === '<') {
		      parser.state = S.OPEN_WAKA
		      parser.startTagPosition = parser.position
		    } else if (not(whitespace, c)) {
		      // have to process this as a text node.
		      // weird, but happens.
		      strictFail(parser, 'Non-whitespace before first tag.')
		      parser.textNode = c
		      parser.state = S.TEXT
		    }
		  }

		  function charAt (chunk, i) {
		    var result = ''
		    if (i < chunk.length) {
		      result = chunk.charAt(i)
		    }
		    return result
		  }

		  function write (chunk) {
		    var parser = this
		    if (this.error) {
		      throw this.error
		    }
		    if (parser.closed) {
		      return error(parser,
		        'Cannot write after close. Assign an onready handler.')
		    }
		    if (chunk === null) {
		      return end(parser)
		    }
		    if (typeof chunk === 'object') {
		      chunk = chunk.toString()
		    }
		    var i = 0
		    var c = ''
		    while (true) {
		      c = charAt(chunk, i++)
		      parser.c = c
		      if (!c) {
		        break
		      }
		      if (parser.trackPosition) {
		        parser.position++
		        if (c === '\n') {
		          parser.line++
		          parser.column = 0
		        } else {
		          parser.column++
		        }
		      }
		      switch (parser.state) {
		        case S.BEGIN:
		          parser.state = S.BEGIN_WHITESPACE
		          if (c === '\uFEFF') {
		            continue
		          }
		          beginWhiteSpace(parser, c)
		          continue

		        case S.BEGIN_WHITESPACE:
		          beginWhiteSpace(parser, c)
		          continue

		        case S.TEXT:
		          if (parser.sawRoot && !parser.closedRoot) {
		            var starti = i - 1
		            while (c && c !== '<' && c !== '&') {
		              c = charAt(chunk, i++)
		              if (c && parser.trackPosition) {
		                parser.position++
		                if (c === '\n') {
		                  parser.line++
		                  parser.column = 0
		                } else {
		                  parser.column++
		                }
		              }
		            }
		            parser.textNode += chunk.substring(starti, i - 1)
		          }
		          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
		            parser.state = S.OPEN_WAKA
		            parser.startTagPosition = parser.position
		          } else {
		            if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot)) {
		              strictFail(parser, 'Text data outside of root node.')
		            }
		            if (c === '&') {
		              parser.state = S.TEXT_ENTITY
		            } else {
		              parser.textNode += c
		            }
		          }
		          continue

		        case S.SCRIPT:
		          // only non-strict
		          if (c === '<') {
		            parser.state = S.SCRIPT_ENDING
		          } else {
		            parser.script += c
		          }
		          continue

		        case S.SCRIPT_ENDING:
		          if (c === '/') {
		            parser.state = S.CLOSE_TAG
		          } else {
		            parser.script += '<' + c
		            parser.state = S.SCRIPT
		          }
		          continue

		        case S.OPEN_WAKA:
		          // either a /, ?, !, or text is coming next.
		          if (c === '!') {
		            parser.state = S.SGML_DECL
		            parser.sgmlDecl = ''
		          } else if (is(whitespace, c)) {
		            // wait for it...
		          } else if (is(nameStart, c)) {
		            parser.state = S.OPEN_TAG
		            parser.tagName = c
		          } else if (c === '/') {
		            parser.state = S.CLOSE_TAG
		            parser.tagName = ''
		          } else if (c === '?') {
		            parser.state = S.PROC_INST
		            parser.procInstName = parser.procInstBody = ''
		          } else {
		            strictFail(parser, 'Unencoded <')
		            // if there was some whitespace, then add that in.
		            if (parser.startTagPosition + 1 < parser.position) {
		              var pad = parser.position - parser.startTagPosition
		              c = new Array(pad).join(' ') + c
		            }
		            parser.textNode += '<' + c
		            parser.state = S.TEXT
		          }
		          continue

		        case S.SGML_DECL:
		          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
		            emitNode(parser, 'onopencdata')
		            parser.state = S.CDATA
		            parser.sgmlDecl = ''
		            parser.cdata = ''
		          } else if (parser.sgmlDecl + c === '--') {
		            parser.state = S.COMMENT
		            parser.comment = ''
		            parser.sgmlDecl = ''
		          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
		            parser.state = S.DOCTYPE
		            if (parser.doctype || parser.sawRoot) {
		              strictFail(parser,
		                'Inappropriately located doctype declaration')
		            }
		            parser.doctype = ''
		            parser.sgmlDecl = ''
		          } else if (c === '>') {
		            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
		            parser.sgmlDecl = ''
		            parser.state = S.TEXT
		          } else if (is(quote, c)) {
		            parser.state = S.SGML_DECL_QUOTED
		            parser.sgmlDecl += c
		          } else {
		            parser.sgmlDecl += c
		          }
		          continue

		        case S.SGML_DECL_QUOTED:
		          if (c === parser.q) {
		            parser.state = S.SGML_DECL
		            parser.q = ''
		          }
		          parser.sgmlDecl += c
		          continue

		        case S.DOCTYPE:
		          if (c === '>') {
		            parser.state = S.TEXT
		            emitNode(parser, 'ondoctype', parser.doctype)
		            parser.doctype = true // just remember that we saw it.
		          } else {
		            parser.doctype += c
		            if (c === '[') {
		              parser.state = S.DOCTYPE_DTD
		            } else if (is(quote, c)) {
		              parser.state = S.DOCTYPE_QUOTED
		              parser.q = c
		            }
		          }
		          continue

		        case S.DOCTYPE_QUOTED:
		          parser.doctype += c
		          if (c === parser.q) {
		            parser.q = ''
		            parser.state = S.DOCTYPE
		          }
		          continue

		        case S.DOCTYPE_DTD:
		          parser.doctype += c
		          if (c === ']') {
		            parser.state = S.DOCTYPE
		          } else if (is(quote, c)) {
		            parser.state = S.DOCTYPE_DTD_QUOTED
		            parser.q = c
		          }
		          continue

		        case S.DOCTYPE_DTD_QUOTED:
		          parser.doctype += c
		          if (c === parser.q) {
		            parser.state = S.DOCTYPE_DTD
		            parser.q = ''
		          }
		          continue

		        case S.COMMENT:
		          if (c === '-') {
		            parser.state = S.COMMENT_ENDING
		          } else {
		            parser.comment += c
		          }
		          continue

		        case S.COMMENT_ENDING:
		          if (c === '-') {
		            parser.state = S.COMMENT_ENDED
		            parser.comment = textopts(parser.opt, parser.comment)
		            if (parser.comment) {
		              emitNode(parser, 'oncomment', parser.comment)
		            }
		            parser.comment = ''
		          } else {
		            parser.comment += '-' + c
		            parser.state = S.COMMENT
		          }
		          continue

		        case S.COMMENT_ENDED:
		          if (c !== '>') {
		            strictFail(parser, 'Malformed comment')
		            // allow <!-- blah -- bloo --> in non-strict mode,
		            // which is a comment of " blah -- bloo "
		            parser.comment += '--' + c
		            parser.state = S.COMMENT
		          } else {
		            parser.state = S.TEXT
		          }
		          continue

		        case S.CDATA:
		          if (c === ']') {
		            parser.state = S.CDATA_ENDING
		          } else {
		            parser.cdata += c
		          }
		          continue

		        case S.CDATA_ENDING:
		          if (c === ']') {
		            parser.state = S.CDATA_ENDING_2
		          } else {
		            parser.cdata += ']' + c
		            parser.state = S.CDATA
		          }
		          continue

		        case S.CDATA_ENDING_2:
		          if (c === '>') {
		            if (parser.cdata) {
		              emitNode(parser, 'oncdata', parser.cdata)
		            }
		            emitNode(parser, 'onclosecdata')
		            parser.cdata = ''
		            parser.state = S.TEXT
		          } else if (c === ']') {
		            parser.cdata += ']'
		          } else {
		            parser.cdata += ']]' + c
		            parser.state = S.CDATA
		          }
		          continue

		        case S.PROC_INST:
		          if (c === '?') {
		            parser.state = S.PROC_INST_ENDING
		          } else if (is(whitespace, c)) {
		            parser.state = S.PROC_INST_BODY
		          } else {
		            parser.procInstName += c
		          }
		          continue

		        case S.PROC_INST_BODY:
		          if (!parser.procInstBody && is(whitespace, c)) {
		            continue
		          } else if (c === '?') {
		            parser.state = S.PROC_INST_ENDING
		          } else {
		            parser.procInstBody += c
		          }
		          continue

		        case S.PROC_INST_ENDING:
		          if (c === '>') {
		            emitNode(parser, 'onprocessinginstruction', {
		              name: parser.procInstName,
		              body: parser.procInstBody
		            })
		            parser.procInstName = parser.procInstBody = ''
		            parser.state = S.TEXT
		          } else {
		            parser.procInstBody += '?' + c
		            parser.state = S.PROC_INST_BODY
		          }
		          continue

		        case S.OPEN_TAG:
		          if (is(nameBody, c)) {
		            parser.tagName += c
		          } else {
		            newTag(parser)
		            if (c === '>') {
		              openTag(parser)
		            } else if (c === '/') {
		              parser.state = S.OPEN_TAG_SLASH
		            } else {
		              if (not(whitespace, c)) {
		                strictFail(parser, 'Invalid character in tag name')
		              }
		              parser.state = S.ATTRIB
		            }
		          }
		          continue

		        case S.OPEN_TAG_SLASH:
		          if (c === '>') {
		            openTag(parser, true)
		            closeTag(parser)
		          } else {
		            strictFail(parser, 'Forward-slash in opening tag not followed by >')
		            parser.state = S.ATTRIB
		          }
		          continue

		        case S.ATTRIB:
		          // haven't read the attribute name yet.
		          if (is(whitespace, c)) {
		            continue
		          } else if (c === '>') {
		            openTag(parser)
		          } else if (c === '/') {
		            parser.state = S.OPEN_TAG_SLASH
		          } else if (is(nameStart, c)) {
		            parser.attribName = c
		            parser.attribValue = ''
		            parser.state = S.ATTRIB_NAME
		          } else {
		            strictFail(parser, 'Invalid attribute name')
		          }
		          continue

		        case S.ATTRIB_NAME:
		          if (c === '=') {
		            parser.state = S.ATTRIB_VALUE
		          } else if (c === '>') {
		            strictFail(parser, 'Attribute without value')
		            parser.attribValue = parser.attribName
		            attrib(parser)
		            openTag(parser)
		          } else if (is(whitespace, c)) {
		            parser.state = S.ATTRIB_NAME_SAW_WHITE
		          } else if (is(nameBody, c)) {
		            parser.attribName += c
		          } else {
		            strictFail(parser, 'Invalid attribute name')
		          }
		          continue

		        case S.ATTRIB_NAME_SAW_WHITE:
		          if (c === '=') {
		            parser.state = S.ATTRIB_VALUE
		          } else if (is(whitespace, c)) {
		            continue
		          } else {
		            strictFail(parser, 'Attribute without value')
		            parser.tag.attributes[parser.attribName] = ''
		            parser.attribValue = ''
		            emitNode(parser, 'onattribute', {
		              name: parser.attribName,
		              value: ''
		            })
		            parser.attribName = ''
		            if (c === '>') {
		              openTag(parser)
		            } else if (is(nameStart, c)) {
		              parser.attribName = c
		              parser.state = S.ATTRIB_NAME
		            } else {
		              strictFail(parser, 'Invalid attribute name')
		              parser.state = S.ATTRIB
		            }
		          }
		          continue

		        case S.ATTRIB_VALUE:
		          if (is(whitespace, c)) {
		            continue
		          } else if (is(quote, c)) {
		            parser.q = c
		            parser.state = S.ATTRIB_VALUE_QUOTED
		          } else {
		            strictFail(parser, 'Unquoted attribute value')
		            parser.state = S.ATTRIB_VALUE_UNQUOTED
		            parser.attribValue = c
		          }
		          continue

		        case S.ATTRIB_VALUE_QUOTED:
		          if (c !== parser.q) {
		            if (c === '&') {
		              parser.state = S.ATTRIB_VALUE_ENTITY_Q
		            } else {
		              parser.attribValue += c
		            }
		            continue
		          }
		          attrib(parser)
		          parser.q = ''
		          parser.state = S.ATTRIB_VALUE_CLOSED
		          continue

		        case S.ATTRIB_VALUE_CLOSED:
		          if (is(whitespace, c)) {
		            parser.state = S.ATTRIB
		          } else if (c === '>') {
		            openTag(parser)
		          } else if (c === '/') {
		            parser.state = S.OPEN_TAG_SLASH
		          } else if (is(nameStart, c)) {
		            strictFail(parser, 'No whitespace between attributes')
		            parser.attribName = c
		            parser.attribValue = ''
		            parser.state = S.ATTRIB_NAME
		          } else {
		            strictFail(parser, 'Invalid attribute name')
		          }
		          continue

		        case S.ATTRIB_VALUE_UNQUOTED:
		          if (not(attribEnd, c)) {
		            if (c === '&') {
		              parser.state = S.ATTRIB_VALUE_ENTITY_U
		            } else {
		              parser.attribValue += c
		            }
		            continue
		          }
		          attrib(parser)
		          if (c === '>') {
		            openTag(parser)
		          } else {
		            parser.state = S.ATTRIB
		          }
		          continue

		        case S.CLOSE_TAG:
		          if (!parser.tagName) {
		            if (is(whitespace, c)) {
		              continue
		            } else if (not(nameStart, c)) {
		              if (parser.script) {
		                parser.script += '</' + c
		                parser.state = S.SCRIPT
		              } else {
		                strictFail(parser, 'Invalid tagname in closing tag.')
		              }
		            } else {
		              parser.tagName = c
		            }
		          } else if (c === '>') {
		            closeTag(parser)
		          } else if (is(nameBody, c)) {
		            parser.tagName += c
		          } else if (parser.script) {
		            parser.script += '</' + parser.tagName
		            parser.tagName = ''
		            parser.state = S.SCRIPT
		          } else {
		            if (not(whitespace, c)) {
		              strictFail(parser, 'Invalid tagname in closing tag')
		            }
		            parser.state = S.CLOSE_TAG_SAW_WHITE
		          }
		          continue

		        case S.CLOSE_TAG_SAW_WHITE:
		          if (is(whitespace, c)) {
		            continue
		          }
		          if (c === '>') {
		            closeTag(parser)
		          } else {
		            strictFail(parser, 'Invalid characters in closing tag')
		          }
		          continue

		        case S.TEXT_ENTITY:
		        case S.ATTRIB_VALUE_ENTITY_Q:
		        case S.ATTRIB_VALUE_ENTITY_U:
		          var returnState
		          var buffer
		          switch (parser.state) {
		            case S.TEXT_ENTITY:
		              returnState = S.TEXT
		              buffer = 'textNode'
		              break

		            case S.ATTRIB_VALUE_ENTITY_Q:
		              returnState = S.ATTRIB_VALUE_QUOTED
		              buffer = 'attribValue'
		              break

		            case S.ATTRIB_VALUE_ENTITY_U:
		              returnState = S.ATTRIB_VALUE_UNQUOTED
		              buffer = 'attribValue'
		              break
		          }

		          if (c === ';') {
		            parser[buffer] += parseEntity(parser)
		            parser.entity = ''
		            parser.state = returnState
		          } else if (is(parser.entity.length ? entityBody : entityStart, c)) {
		            parser.entity += c
		          } else {
		            strictFail(parser, 'Invalid character in entity name')
		            parser[buffer] += '&' + parser.entity + c
		            parser.entity = ''
		            parser.state = returnState
		          }

		          continue

		        default:
		          throw new Error(parser, 'Unknown state: ' + parser.state)
		      }
		    } // while

		    if (parser.position >= parser.bufferCheckPosition) {
		      checkBufferLength(parser)
		    }
		    return parser
		  }

		  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
		  if (!String.fromCodePoint) {
		    (function () {
		      var stringFromCharCode = String.fromCharCode
		      var floor = Math.floor
		      var fromCodePoint = function () {
		        var MAX_SIZE = 0x4000
		        var codeUnits = []
		        var highSurrogate
		        var lowSurrogate
		        var index = -1
		        var length = arguments.length
		        if (!length) {
		          return ''
		        }
		        var result = ''
		        while (++index < length) {
		          var codePoint = Number(arguments[index])
		          if (
		            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
		            codePoint < 0 || // not a valid Unicode code point
		            codePoint > 0x10FFFF || // not a valid Unicode code point
		            floor(codePoint) !== codePoint // not an integer
		          ) {
		            throw RangeError('Invalid code point: ' + codePoint)
		          }
		          if (codePoint <= 0xFFFF) { // BMP code point
		            codeUnits.push(codePoint)
		          } else { // Astral code point; split in surrogate halves
		            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		            codePoint -= 0x10000
		            highSurrogate = (codePoint >> 10) + 0xD800
		            lowSurrogate = (codePoint % 0x400) + 0xDC00
		            codeUnits.push(highSurrogate, lowSurrogate)
		          }
		          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
		            result += stringFromCharCode.apply(null, codeUnits)
		            codeUnits.length = 0
		          }
		        }
		        return result
		      }
		      if (Object.defineProperty) {
		        Object.defineProperty(String, 'fromCodePoint', {
		          value: fromCodePoint,
		          configurable: true,
		          writable: true
		        })
		      } else {
		        String.fromCodePoint = fromCodePoint
		      }
		    }())
		  }
		})( false ? this.sax = {} : exports)

		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global) {/*!
		 * The buffer module from node.js, for the browser.
		 *
		 * @author   Feross Aboukhadijeh <http://feross.org>
		 * @license  MIT
		 */
		/* eslint-disable no-proto */

		'use strict'

		var base64 = __webpack_require__(29)
		var ieee754 = __webpack_require__(30)
		var isArray = __webpack_require__(31)

		exports.Buffer = Buffer
		exports.SlowBuffer = SlowBuffer
		exports.INSPECT_MAX_BYTES = 50

		/**
		 * If `Buffer.TYPED_ARRAY_SUPPORT`:
		 *   === true    Use Uint8Array implementation (fastest)
		 *   === false   Use Object implementation (most compatible, even IE6)
		 *
		 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
		 * Opera 11.6+, iOS 4.2+.
		 *
		 * Due to various browser bugs, sometimes the Object implementation will be used even
		 * when the browser supports typed arrays.
		 *
		 * Note:
		 *
		 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
		 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
		 *
		 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
		 *
		 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
		 *     incorrect length in some situations.

		 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
		 * get the Object implementation, which is slower but behaves correctly.
		 */
		Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
		  ? global.TYPED_ARRAY_SUPPORT
		  : typedArraySupport()

		/*
		 * Export kMaxLength after typed array support is determined.
		 */
		exports.kMaxLength = kMaxLength()

		function typedArraySupport () {
		  try {
		    var arr = new Uint8Array(1)
		    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
		    return arr.foo() === 42 && // typed array instances can be augmented
		        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
		        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
		  } catch (e) {
		    return false
		  }
		}

		function kMaxLength () {
		  return Buffer.TYPED_ARRAY_SUPPORT
		    ? 0x7fffffff
		    : 0x3fffffff
		}

		function createBuffer (that, length) {
		  if (kMaxLength() < length) {
		    throw new RangeError('Invalid typed array length')
		  }
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    // Return an augmented `Uint8Array` instance, for best performance
		    that = new Uint8Array(length)
		    that.__proto__ = Buffer.prototype
		  } else {
		    // Fallback: Return an object instance of the Buffer class
		    if (that === null) {
		      that = new Buffer(length)
		    }
		    that.length = length
		  }

		  return that
		}

		/**
		 * The Buffer constructor returns instances of `Uint8Array` that have their
		 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
		 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
		 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
		 * returns a single octet.
		 *
		 * The `Uint8Array` prototype remains unmodified.
		 */

		function Buffer (arg, encodingOrOffset, length) {
		  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
		    return new Buffer(arg, encodingOrOffset, length)
		  }

		  // Common case.
		  if (typeof arg === 'number') {
		    if (typeof encodingOrOffset === 'string') {
		      throw new Error(
		        'If encoding is specified then the first argument must be a string'
		      )
		    }
		    return allocUnsafe(this, arg)
		  }
		  return from(this, arg, encodingOrOffset, length)
		}

		Buffer.poolSize = 8192 // not used by this implementation

		// TODO: Legacy, not needed anymore. Remove in next major version.
		Buffer._augment = function (arr) {
		  arr.__proto__ = Buffer.prototype
		  return arr
		}

		function from (that, value, encodingOrOffset, length) {
		  if (typeof value === 'number') {
		    throw new TypeError('"value" argument must not be a number')
		  }

		  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
		    return fromArrayBuffer(that, value, encodingOrOffset, length)
		  }

		  if (typeof value === 'string') {
		    return fromString(that, value, encodingOrOffset)
		  }

		  return fromObject(that, value)
		}

		/**
		 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
		 * if value is a number.
		 * Buffer.from(str[, encoding])
		 * Buffer.from(array)
		 * Buffer.from(buffer)
		 * Buffer.from(arrayBuffer[, byteOffset[, length]])
		 **/
		Buffer.from = function (value, encodingOrOffset, length) {
		  return from(null, value, encodingOrOffset, length)
		}

		if (Buffer.TYPED_ARRAY_SUPPORT) {
		  Buffer.prototype.__proto__ = Uint8Array.prototype
		  Buffer.__proto__ = Uint8Array
		  if (typeof Symbol !== 'undefined' && Symbol.species &&
		      Buffer[Symbol.species] === Buffer) {
		    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
		    Object.defineProperty(Buffer, Symbol.species, {
		      value: null,
		      configurable: true
		    })
		  }
		}

		function assertSize (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('"size" argument must be a number')
		  } else if (size < 0) {
		    throw new RangeError('"size" argument must not be negative')
		  }
		}

		function alloc (that, size, fill, encoding) {
		  assertSize(size)
		  if (size <= 0) {
		    return createBuffer(that, size)
		  }
		  if (fill !== undefined) {
		    // Only pay attention to encoding if it's a string. This
		    // prevents accidentally sending in a number that would
		    // be interpretted as a start offset.
		    return typeof encoding === 'string'
		      ? createBuffer(that, size).fill(fill, encoding)
		      : createBuffer(that, size).fill(fill)
		  }
		  return createBuffer(that, size)
		}

		/**
		 * Creates a new filled Buffer instance.
		 * alloc(size[, fill[, encoding]])
		 **/
		Buffer.alloc = function (size, fill, encoding) {
		  return alloc(null, size, fill, encoding)
		}

		function allocUnsafe (that, size) {
		  assertSize(size)
		  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
		  if (!Buffer.TYPED_ARRAY_SUPPORT) {
		    for (var i = 0; i < size; ++i) {
		      that[i] = 0
		    }
		  }
		  return that
		}

		/**
		 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
		 * */
		Buffer.allocUnsafe = function (size) {
		  return allocUnsafe(null, size)
		}
		/**
		 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
		 */
		Buffer.allocUnsafeSlow = function (size) {
		  return allocUnsafe(null, size)
		}

		function fromString (that, string, encoding) {
		  if (typeof encoding !== 'string' || encoding === '') {
		    encoding = 'utf8'
		  }

		  if (!Buffer.isEncoding(encoding)) {
		    throw new TypeError('"encoding" must be a valid string encoding')
		  }

		  var length = byteLength(string, encoding) | 0
		  that = createBuffer(that, length)

		  var actual = that.write(string, encoding)

		  if (actual !== length) {
		    // Writing a hex string, for example, that contains invalid characters will
		    // cause everything after the first invalid character to be ignored. (e.g.
		    // 'abxxcd' will be treated as 'ab')
		    that = that.slice(0, actual)
		  }

		  return that
		}

		function fromArrayLike (that, array) {
		  var length = array.length < 0 ? 0 : checked(array.length) | 0
		  that = createBuffer(that, length)
		  for (var i = 0; i < length; i += 1) {
		    that[i] = array[i] & 255
		  }
		  return that
		}

		function fromArrayBuffer (that, array, byteOffset, length) {
		  array.byteLength // this throws if `array` is not a valid ArrayBuffer

		  if (byteOffset < 0 || array.byteLength < byteOffset) {
		    throw new RangeError('\'offset\' is out of bounds')
		  }

		  if (array.byteLength < byteOffset + (length || 0)) {
		    throw new RangeError('\'length\' is out of bounds')
		  }

		  if (byteOffset === undefined && length === undefined) {
		    array = new Uint8Array(array)
		  } else if (length === undefined) {
		    array = new Uint8Array(array, byteOffset)
		  } else {
		    array = new Uint8Array(array, byteOffset, length)
		  }

		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    // Return an augmented `Uint8Array` instance, for best performance
		    that = array
		    that.__proto__ = Buffer.prototype
		  } else {
		    // Fallback: Return an object instance of the Buffer class
		    that = fromArrayLike(that, array)
		  }
		  return that
		}

		function fromObject (that, obj) {
		  if (Buffer.isBuffer(obj)) {
		    var len = checked(obj.length) | 0
		    that = createBuffer(that, len)

		    if (that.length === 0) {
		      return that
		    }

		    obj.copy(that, 0, 0, len)
		    return that
		  }

		  if (obj) {
		    if ((typeof ArrayBuffer !== 'undefined' &&
		        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
		      if (typeof obj.length !== 'number' || isnan(obj.length)) {
		        return createBuffer(that, 0)
		      }
		      return fromArrayLike(that, obj)
		    }

		    if (obj.type === 'Buffer' && isArray(obj.data)) {
		      return fromArrayLike(that, obj.data)
		    }
		  }

		  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
		}

		function checked (length) {
		  // Note: cannot use `length < kMaxLength()` here because that fails when
		  // length is NaN (which is otherwise coerced to zero.)
		  if (length >= kMaxLength()) {
		    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
		                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
		  }
		  return length | 0
		}

		function SlowBuffer (length) {
		  if (+length != length) { // eslint-disable-line eqeqeq
		    length = 0
		  }
		  return Buffer.alloc(+length)
		}

		Buffer.isBuffer = function isBuffer (b) {
		  return !!(b != null && b._isBuffer)
		}

		Buffer.compare = function compare (a, b) {
		  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
		    throw new TypeError('Arguments must be Buffers')
		  }

		  if (a === b) return 0

		  var x = a.length
		  var y = b.length

		  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
		    if (a[i] !== b[i]) {
		      x = a[i]
		      y = b[i]
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		}

		Buffer.isEncoding = function isEncoding (encoding) {
		  switch (String(encoding).toLowerCase()) {
		    case 'hex':
		    case 'utf8':
		    case 'utf-8':
		    case 'ascii':
		    case 'latin1':
		    case 'binary':
		    case 'base64':
		    case 'ucs2':
		    case 'ucs-2':
		    case 'utf16le':
		    case 'utf-16le':
		      return true
		    default:
		      return false
		  }
		}

		Buffer.concat = function concat (list, length) {
		  if (!isArray(list)) {
		    throw new TypeError('"list" argument must be an Array of Buffers')
		  }

		  if (list.length === 0) {
		    return Buffer.alloc(0)
		  }

		  var i
		  if (length === undefined) {
		    length = 0
		    for (i = 0; i < list.length; ++i) {
		      length += list[i].length
		    }
		  }

		  var buffer = Buffer.allocUnsafe(length)
		  var pos = 0
		  for (i = 0; i < list.length; ++i) {
		    var buf = list[i]
		    if (!Buffer.isBuffer(buf)) {
		      throw new TypeError('"list" argument must be an Array of Buffers')
		    }
		    buf.copy(buffer, pos)
		    pos += buf.length
		  }
		  return buffer
		}

		function byteLength (string, encoding) {
		  if (Buffer.isBuffer(string)) {
		    return string.length
		  }
		  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
		      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
		    return string.byteLength
		  }
		  if (typeof string !== 'string') {
		    string = '' + string
		  }

		  var len = string.length
		  if (len === 0) return 0

		  // Use a for loop to avoid recursion
		  var loweredCase = false
		  for (;;) {
		    switch (encoding) {
		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return len
		      case 'utf8':
		      case 'utf-8':
		      case undefined:
		        return utf8ToBytes(string).length
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return len * 2
		      case 'hex':
		        return len >>> 1
		      case 'base64':
		        return base64ToBytes(string).length
		      default:
		        if (loweredCase) return utf8ToBytes(string).length // assume utf8
		        encoding = ('' + encoding).toLowerCase()
		        loweredCase = true
		    }
		  }
		}
		Buffer.byteLength = byteLength

		function slowToString (encoding, start, end) {
		  var loweredCase = false

		  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
		  // property of a typed array.

		  // This behaves neither like String nor Uint8Array in that we set start/end
		  // to their upper/lower bounds if the value passed is out of range.
		  // undefined is handled specially as per ECMA-262 6th Edition,
		  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
		  if (start === undefined || start < 0) {
		    start = 0
		  }
		  // Return early if start > this.length. Done here to prevent potential uint32
		  // coercion fail below.
		  if (start > this.length) {
		    return ''
		  }

		  if (end === undefined || end > this.length) {
		    end = this.length
		  }

		  if (end <= 0) {
		    return ''
		  }

		  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
		  end >>>= 0
		  start >>>= 0

		  if (end <= start) {
		    return ''
		  }

		  if (!encoding) encoding = 'utf8'

		  while (true) {
		    switch (encoding) {
		      case 'hex':
		        return hexSlice(this, start, end)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Slice(this, start, end)

		      case 'ascii':
		        return asciiSlice(this, start, end)

		      case 'latin1':
		      case 'binary':
		        return latin1Slice(this, start, end)

		      case 'base64':
		        return base64Slice(this, start, end)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return utf16leSlice(this, start, end)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = (encoding + '').toLowerCase()
		        loweredCase = true
		    }
		  }
		}

		// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
		// Buffer instances.
		Buffer.prototype._isBuffer = true

		function swap (b, n, m) {
		  var i = b[n]
		  b[n] = b[m]
		  b[m] = i
		}

		Buffer.prototype.swap16 = function swap16 () {
		  var len = this.length
		  if (len % 2 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 16-bits')
		  }
		  for (var i = 0; i < len; i += 2) {
		    swap(this, i, i + 1)
		  }
		  return this
		}

		Buffer.prototype.swap32 = function swap32 () {
		  var len = this.length
		  if (len % 4 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 32-bits')
		  }
		  for (var i = 0; i < len; i += 4) {
		    swap(this, i, i + 3)
		    swap(this, i + 1, i + 2)
		  }
		  return this
		}

		Buffer.prototype.swap64 = function swap64 () {
		  var len = this.length
		  if (len % 8 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 64-bits')
		  }
		  for (var i = 0; i < len; i += 8) {
		    swap(this, i, i + 7)
		    swap(this, i + 1, i + 6)
		    swap(this, i + 2, i + 5)
		    swap(this, i + 3, i + 4)
		  }
		  return this
		}

		Buffer.prototype.toString = function toString () {
		  var length = this.length | 0
		  if (length === 0) return ''
		  if (arguments.length === 0) return utf8Slice(this, 0, length)
		  return slowToString.apply(this, arguments)
		}

		Buffer.prototype.equals = function equals (b) {
		  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
		  if (this === b) return true
		  return Buffer.compare(this, b) === 0
		}

		Buffer.prototype.inspect = function inspect () {
		  var str = ''
		  var max = exports.INSPECT_MAX_BYTES
		  if (this.length > 0) {
		    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
		    if (this.length > max) str += ' ... '
		  }
		  return '<Buffer ' + str + '>'
		}

		Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
		  if (!Buffer.isBuffer(target)) {
		    throw new TypeError('Argument must be a Buffer')
		  }

		  if (start === undefined) {
		    start = 0
		  }
		  if (end === undefined) {
		    end = target ? target.length : 0
		  }
		  if (thisStart === undefined) {
		    thisStart = 0
		  }
		  if (thisEnd === undefined) {
		    thisEnd = this.length
		  }

		  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
		    throw new RangeError('out of range index')
		  }

		  if (thisStart >= thisEnd && start >= end) {
		    return 0
		  }
		  if (thisStart >= thisEnd) {
		    return -1
		  }
		  if (start >= end) {
		    return 1
		  }

		  start >>>= 0
		  end >>>= 0
		  thisStart >>>= 0
		  thisEnd >>>= 0

		  if (this === target) return 0

		  var x = thisEnd - thisStart
		  var y = end - start
		  var len = Math.min(x, y)

		  var thisCopy = this.slice(thisStart, thisEnd)
		  var targetCopy = target.slice(start, end)

		  for (var i = 0; i < len; ++i) {
		    if (thisCopy[i] !== targetCopy[i]) {
		      x = thisCopy[i]
		      y = targetCopy[i]
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		}

		// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
		// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
		//
		// Arguments:
		// - buffer - a Buffer to search
		// - val - a string, Buffer, or number
		// - byteOffset - an index into `buffer`; will be clamped to an int32
		// - encoding - an optional encoding, relevant is val is a string
		// - dir - true for indexOf, false for lastIndexOf
		function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
		  // Empty buffer means no match
		  if (buffer.length === 0) return -1

		  // Normalize byteOffset
		  if (typeof byteOffset === 'string') {
		    encoding = byteOffset
		    byteOffset = 0
		  } else if (byteOffset > 0x7fffffff) {
		    byteOffset = 0x7fffffff
		  } else if (byteOffset < -0x80000000) {
		    byteOffset = -0x80000000
		  }
		  byteOffset = +byteOffset  // Coerce to Number.
		  if (isNaN(byteOffset)) {
		    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
		    byteOffset = dir ? 0 : (buffer.length - 1)
		  }

		  // Normalize byteOffset: negative offsets start from the end of the buffer
		  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
		  if (byteOffset >= buffer.length) {
		    if (dir) return -1
		    else byteOffset = buffer.length - 1
		  } else if (byteOffset < 0) {
		    if (dir) byteOffset = 0
		    else return -1
		  }

		  // Normalize val
		  if (typeof val === 'string') {
		    val = Buffer.from(val, encoding)
		  }

		  // Finally, search either indexOf (if dir is true) or lastIndexOf
		  if (Buffer.isBuffer(val)) {
		    // Special case: looking for empty string/buffer always fails
		    if (val.length === 0) {
		      return -1
		    }
		    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
		  } else if (typeof val === 'number') {
		    val = val & 0xFF // Search for a byte value [0-255]
		    if (Buffer.TYPED_ARRAY_SUPPORT &&
		        typeof Uint8Array.prototype.indexOf === 'function') {
		      if (dir) {
		        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
		      } else {
		        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
		      }
		    }
		    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
		  }

		  throw new TypeError('val must be string, number or Buffer')
		}

		function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
		  var indexSize = 1
		  var arrLength = arr.length
		  var valLength = val.length

		  if (encoding !== undefined) {
		    encoding = String(encoding).toLowerCase()
		    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
		        encoding === 'utf16le' || encoding === 'utf-16le') {
		      if (arr.length < 2 || val.length < 2) {
		        return -1
		      }
		      indexSize = 2
		      arrLength /= 2
		      valLength /= 2
		      byteOffset /= 2
		    }
		  }

		  function read (buf, i) {
		    if (indexSize === 1) {
		      return buf[i]
		    } else {
		      return buf.readUInt16BE(i * indexSize)
		    }
		  }

		  var i
		  if (dir) {
		    var foundIndex = -1
		    for (i = byteOffset; i < arrLength; i++) {
		      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
		        if (foundIndex === -1) foundIndex = i
		        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
		      } else {
		        if (foundIndex !== -1) i -= i - foundIndex
		        foundIndex = -1
		      }
		    }
		  } else {
		    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
		    for (i = byteOffset; i >= 0; i--) {
		      var found = true
		      for (var j = 0; j < valLength; j++) {
		        if (read(arr, i + j) !== read(val, j)) {
		          found = false
		          break
		        }
		      }
		      if (found) return i
		    }
		  }

		  return -1
		}

		Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
		  return this.indexOf(val, byteOffset, encoding) !== -1
		}

		Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
		}

		Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
		}

		function hexWrite (buf, string, offset, length) {
		  offset = Number(offset) || 0
		  var remaining = buf.length - offset
		  if (!length) {
		    length = remaining
		  } else {
		    length = Number(length)
		    if (length > remaining) {
		      length = remaining
		    }
		  }

		  // must be an even number of digits
		  var strLen = string.length
		  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

		  if (length > strLen / 2) {
		    length = strLen / 2
		  }
		  for (var i = 0; i < length; ++i) {
		    var parsed = parseInt(string.substr(i * 2, 2), 16)
		    if (isNaN(parsed)) return i
		    buf[offset + i] = parsed
		  }
		  return i
		}

		function utf8Write (buf, string, offset, length) {
		  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
		}

		function asciiWrite (buf, string, offset, length) {
		  return blitBuffer(asciiToBytes(string), buf, offset, length)
		}

		function latin1Write (buf, string, offset, length) {
		  return asciiWrite(buf, string, offset, length)
		}

		function base64Write (buf, string, offset, length) {
		  return blitBuffer(base64ToBytes(string), buf, offset, length)
		}

		function ucs2Write (buf, string, offset, length) {
		  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
		}

		Buffer.prototype.write = function write (string, offset, length, encoding) {
		  // Buffer#write(string)
		  if (offset === undefined) {
		    encoding = 'utf8'
		    length = this.length
		    offset = 0
		  // Buffer#write(string, encoding)
		  } else if (length === undefined && typeof offset === 'string') {
		    encoding = offset
		    length = this.length
		    offset = 0
		  // Buffer#write(string, offset[, length][, encoding])
		  } else if (isFinite(offset)) {
		    offset = offset | 0
		    if (isFinite(length)) {
		      length = length | 0
		      if (encoding === undefined) encoding = 'utf8'
		    } else {
		      encoding = length
		      length = undefined
		    }
		  // legacy write(string, encoding, offset, length) - remove in v0.13
		  } else {
		    throw new Error(
		      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
		    )
		  }

		  var remaining = this.length - offset
		  if (length === undefined || length > remaining) length = remaining

		  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
		    throw new RangeError('Attempt to write outside buffer bounds')
		  }

		  if (!encoding) encoding = 'utf8'

		  var loweredCase = false
		  for (;;) {
		    switch (encoding) {
		      case 'hex':
		        return hexWrite(this, string, offset, length)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Write(this, string, offset, length)

		      case 'ascii':
		        return asciiWrite(this, string, offset, length)

		      case 'latin1':
		      case 'binary':
		        return latin1Write(this, string, offset, length)

		      case 'base64':
		        // Warning: maxLength not taken into account in base64Write
		        return base64Write(this, string, offset, length)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return ucs2Write(this, string, offset, length)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = ('' + encoding).toLowerCase()
		        loweredCase = true
		    }
		  }
		}

		Buffer.prototype.toJSON = function toJSON () {
		  return {
		    type: 'Buffer',
		    data: Array.prototype.slice.call(this._arr || this, 0)
		  }
		}

		function base64Slice (buf, start, end) {
		  if (start === 0 && end === buf.length) {
		    return base64.fromByteArray(buf)
		  } else {
		    return base64.fromByteArray(buf.slice(start, end))
		  }
		}

		function utf8Slice (buf, start, end) {
		  end = Math.min(buf.length, end)
		  var res = []

		  var i = start
		  while (i < end) {
		    var firstByte = buf[i]
		    var codePoint = null
		    var bytesPerSequence = (firstByte > 0xEF) ? 4
		      : (firstByte > 0xDF) ? 3
		      : (firstByte > 0xBF) ? 2
		      : 1

		    if (i + bytesPerSequence <= end) {
		      var secondByte, thirdByte, fourthByte, tempCodePoint

		      switch (bytesPerSequence) {
		        case 1:
		          if (firstByte < 0x80) {
		            codePoint = firstByte
		          }
		          break
		        case 2:
		          secondByte = buf[i + 1]
		          if ((secondByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
		            if (tempCodePoint > 0x7F) {
		              codePoint = tempCodePoint
		            }
		          }
		          break
		        case 3:
		          secondByte = buf[i + 1]
		          thirdByte = buf[i + 2]
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
		            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
		              codePoint = tempCodePoint
		            }
		          }
		          break
		        case 4:
		          secondByte = buf[i + 1]
		          thirdByte = buf[i + 2]
		          fourthByte = buf[i + 3]
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
		            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
		              codePoint = tempCodePoint
		            }
		          }
		      }
		    }

		    if (codePoint === null) {
		      // we did not generate a valid codePoint so insert a
		      // replacement char (U+FFFD) and advance only 1 byte
		      codePoint = 0xFFFD
		      bytesPerSequence = 1
		    } else if (codePoint > 0xFFFF) {
		      // encode to utf16 (surrogate pair dance)
		      codePoint -= 0x10000
		      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
		      codePoint = 0xDC00 | codePoint & 0x3FF
		    }

		    res.push(codePoint)
		    i += bytesPerSequence
		  }

		  return decodeCodePointsArray(res)
		}

		// Based on http://stackoverflow.com/a/22747272/680742, the browser with
		// the lowest limit is Chrome, with 0x10000 args.
		// We go 1 magnitude less, for safety
		var MAX_ARGUMENTS_LENGTH = 0x1000

		function decodeCodePointsArray (codePoints) {
		  var len = codePoints.length
		  if (len <= MAX_ARGUMENTS_LENGTH) {
		    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
		  }

		  // Decode in chunks to avoid "call stack size exceeded".
		  var res = ''
		  var i = 0
		  while (i < len) {
		    res += String.fromCharCode.apply(
		      String,
		      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
		    )
		  }
		  return res
		}

		function asciiSlice (buf, start, end) {
		  var ret = ''
		  end = Math.min(buf.length, end)

		  for (var i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i] & 0x7F)
		  }
		  return ret
		}

		function latin1Slice (buf, start, end) {
		  var ret = ''
		  end = Math.min(buf.length, end)

		  for (var i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i])
		  }
		  return ret
		}

		function hexSlice (buf, start, end) {
		  var len = buf.length

		  if (!start || start < 0) start = 0
		  if (!end || end < 0 || end > len) end = len

		  var out = ''
		  for (var i = start; i < end; ++i) {
		    out += toHex(buf[i])
		  }
		  return out
		}

		function utf16leSlice (buf, start, end) {
		  var bytes = buf.slice(start, end)
		  var res = ''
		  for (var i = 0; i < bytes.length; i += 2) {
		    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
		  }
		  return res
		}

		Buffer.prototype.slice = function slice (start, end) {
		  var len = this.length
		  start = ~~start
		  end = end === undefined ? len : ~~end

		  if (start < 0) {
		    start += len
		    if (start < 0) start = 0
		  } else if (start > len) {
		    start = len
		  }

		  if (end < 0) {
		    end += len
		    if (end < 0) end = 0
		  } else if (end > len) {
		    end = len
		  }

		  if (end < start) end = start

		  var newBuf
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    newBuf = this.subarray(start, end)
		    newBuf.__proto__ = Buffer.prototype
		  } else {
		    var sliceLen = end - start
		    newBuf = new Buffer(sliceLen, undefined)
		    for (var i = 0; i < sliceLen; ++i) {
		      newBuf[i] = this[i + start]
		    }
		  }

		  return newBuf
		}

		/*
		 * Need to make sure that buffer isn't trying to write out of bounds.
		 */
		function checkOffset (offset, ext, length) {
		  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
		  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
		}

		Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
		  offset = offset | 0
		  byteLength = byteLength | 0
		  if (!noAssert) checkOffset(offset, byteLength, this.length)

		  var val = this[offset]
		  var mul = 1
		  var i = 0
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul
		  }

		  return val
		}

		Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
		  offset = offset | 0
		  byteLength = byteLength | 0
		  if (!noAssert) {
		    checkOffset(offset, byteLength, this.length)
		  }

		  var val = this[offset + --byteLength]
		  var mul = 1
		  while (byteLength > 0 && (mul *= 0x100)) {
		    val += this[offset + --byteLength] * mul
		  }

		  return val
		}

		Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 1, this.length)
		  return this[offset]
		}

		Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length)
		  return this[offset] | (this[offset + 1] << 8)
		}

		Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length)
		  return (this[offset] << 8) | this[offset + 1]
		}

		Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length)

		  return ((this[offset]) |
		      (this[offset + 1] << 8) |
		      (this[offset + 2] << 16)) +
		      (this[offset + 3] * 0x1000000)
		}

		Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length)

		  return (this[offset] * 0x1000000) +
		    ((this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    this[offset + 3])
		}

		Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
		  offset = offset | 0
		  byteLength = byteLength | 0
		  if (!noAssert) checkOffset(offset, byteLength, this.length)

		  var val = this[offset]
		  var mul = 1
		  var i = 0
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul
		  }
		  mul *= 0x80

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

		  return val
		}

		Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
		  offset = offset | 0
		  byteLength = byteLength | 0
		  if (!noAssert) checkOffset(offset, byteLength, this.length)

		  var i = byteLength
		  var mul = 1
		  var val = this[offset + --i]
		  while (i > 0 && (mul *= 0x100)) {
		    val += this[offset + --i] * mul
		  }
		  mul *= 0x80

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

		  return val
		}

		Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 1, this.length)
		  if (!(this[offset] & 0x80)) return (this[offset])
		  return ((0xff - this[offset] + 1) * -1)
		}

		Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length)
		  var val = this[offset] | (this[offset + 1] << 8)
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		}

		Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length)
		  var val = this[offset + 1] | (this[offset] << 8)
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		}

		Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length)

		  return (this[offset]) |
		    (this[offset + 1] << 8) |
		    (this[offset + 2] << 16) |
		    (this[offset + 3] << 24)
		}

		Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length)

		  return (this[offset] << 24) |
		    (this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    (this[offset + 3])
		}

		Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length)
		  return ieee754.read(this, offset, true, 23, 4)
		}

		Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length)
		  return ieee754.read(this, offset, false, 23, 4)
		}

		Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 8, this.length)
		  return ieee754.read(this, offset, true, 52, 8)
		}

		Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 8, this.length)
		  return ieee754.read(this, offset, false, 52, 8)
		}

		function checkInt (buf, value, offset, ext, max, min) {
		  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
		  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		}

		Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
		  value = +value
		  offset = offset | 0
		  byteLength = byteLength | 0
		  if (!noAssert) {
		    var maxBytes = Math.pow(2, 8 * byteLength) - 1
		    checkInt(this, value, offset, byteLength, maxBytes, 0)
		  }

		  var mul = 1
		  var i = 0
		  this[offset] = value & 0xFF
		  while (++i < byteLength && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF
		  }

		  return offset + byteLength
		}

		Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
		  value = +value
		  offset = offset | 0
		  byteLength = byteLength | 0
		  if (!noAssert) {
		    var maxBytes = Math.pow(2, 8 * byteLength) - 1
		    checkInt(this, value, offset, byteLength, maxBytes, 0)
		  }

		  var i = byteLength - 1
		  var mul = 1
		  this[offset + i] = value & 0xFF
		  while (--i >= 0 && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF
		  }

		  return offset + byteLength
		}

		Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
		  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
		  this[offset] = (value & 0xff)
		  return offset + 1
		}

		function objectWriteUInt16 (buf, value, offset, littleEndian) {
		  if (value < 0) value = 0xffff + value + 1
		  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
		    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
		      (littleEndian ? i : 1 - i) * 8
		  }
		}

		Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value & 0xff)
		    this[offset + 1] = (value >>> 8)
		  } else {
		    objectWriteUInt16(this, value, offset, true)
		  }
		  return offset + 2
		}

		Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value >>> 8)
		    this[offset + 1] = (value & 0xff)
		  } else {
		    objectWriteUInt16(this, value, offset, false)
		  }
		  return offset + 2
		}

		function objectWriteUInt32 (buf, value, offset, littleEndian) {
		  if (value < 0) value = 0xffffffff + value + 1
		  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
		    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
		  }
		}

		Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset + 3] = (value >>> 24)
		    this[offset + 2] = (value >>> 16)
		    this[offset + 1] = (value >>> 8)
		    this[offset] = (value & 0xff)
		  } else {
		    objectWriteUInt32(this, value, offset, true)
		  }
		  return offset + 4
		}

		Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value >>> 24)
		    this[offset + 1] = (value >>> 16)
		    this[offset + 2] = (value >>> 8)
		    this[offset + 3] = (value & 0xff)
		  } else {
		    objectWriteUInt32(this, value, offset, false)
		  }
		  return offset + 4
		}

		Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) {
		    var limit = Math.pow(2, 8 * byteLength - 1)

		    checkInt(this, value, offset, byteLength, limit - 1, -limit)
		  }

		  var i = 0
		  var mul = 1
		  var sub = 0
		  this[offset] = value & 0xFF
		  while (++i < byteLength && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
		      sub = 1
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
		  }

		  return offset + byteLength
		}

		Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) {
		    var limit = Math.pow(2, 8 * byteLength - 1)

		    checkInt(this, value, offset, byteLength, limit - 1, -limit)
		  }

		  var i = byteLength - 1
		  var mul = 1
		  var sub = 0
		  this[offset + i] = value & 0xFF
		  while (--i >= 0 && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
		      sub = 1
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
		  }

		  return offset + byteLength
		}

		Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
		  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
		  if (value < 0) value = 0xff + value + 1
		  this[offset] = (value & 0xff)
		  return offset + 1
		}

		Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value & 0xff)
		    this[offset + 1] = (value >>> 8)
		  } else {
		    objectWriteUInt16(this, value, offset, true)
		  }
		  return offset + 2
		}

		Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value >>> 8)
		    this[offset + 1] = (value & 0xff)
		  } else {
		    objectWriteUInt16(this, value, offset, false)
		  }
		  return offset + 2
		}

		Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value & 0xff)
		    this[offset + 1] = (value >>> 8)
		    this[offset + 2] = (value >>> 16)
		    this[offset + 3] = (value >>> 24)
		  } else {
		    objectWriteUInt32(this, value, offset, true)
		  }
		  return offset + 4
		}

		Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
		  value = +value
		  offset = offset | 0
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
		  if (value < 0) value = 0xffffffff + value + 1
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = (value >>> 24)
		    this[offset + 1] = (value >>> 16)
		    this[offset + 2] = (value >>> 8)
		    this[offset + 3] = (value & 0xff)
		  } else {
		    objectWriteUInt32(this, value, offset, false)
		  }
		  return offset + 4
		}

		function checkIEEE754 (buf, value, offset, ext, max, min) {
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		  if (offset < 0) throw new RangeError('Index out of range')
		}

		function writeFloat (buf, value, offset, littleEndian, noAssert) {
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
		  }
		  ieee754.write(buf, value, offset, littleEndian, 23, 4)
		  return offset + 4
		}

		Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, true, noAssert)
		}

		Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, false, noAssert)
		}

		function writeDouble (buf, value, offset, littleEndian, noAssert) {
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
		  }
		  ieee754.write(buf, value, offset, littleEndian, 52, 8)
		  return offset + 8
		}

		Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, true, noAssert)
		}

		Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, false, noAssert)
		}

		// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
		Buffer.prototype.copy = function copy (target, targetStart, start, end) {
		  if (!start) start = 0
		  if (!end && end !== 0) end = this.length
		  if (targetStart >= target.length) targetStart = target.length
		  if (!targetStart) targetStart = 0
		  if (end > 0 && end < start) end = start

		  // Copy 0 bytes; we're done
		  if (end === start) return 0
		  if (target.length === 0 || this.length === 0) return 0

		  // Fatal error conditions
		  if (targetStart < 0) {
		    throw new RangeError('targetStart out of bounds')
		  }
		  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
		  if (end < 0) throw new RangeError('sourceEnd out of bounds')

		  // Are we oob?
		  if (end > this.length) end = this.length
		  if (target.length - targetStart < end - start) {
		    end = target.length - targetStart + start
		  }

		  var len = end - start
		  var i

		  if (this === target && start < targetStart && targetStart < end) {
		    // descending copy from end
		    for (i = len - 1; i >= 0; --i) {
		      target[i + targetStart] = this[i + start]
		    }
		  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
		    // ascending copy from start
		    for (i = 0; i < len; ++i) {
		      target[i + targetStart] = this[i + start]
		    }
		  } else {
		    Uint8Array.prototype.set.call(
		      target,
		      this.subarray(start, start + len),
		      targetStart
		    )
		  }

		  return len
		}

		// Usage:
		//    buffer.fill(number[, offset[, end]])
		//    buffer.fill(buffer[, offset[, end]])
		//    buffer.fill(string[, offset[, end]][, encoding])
		Buffer.prototype.fill = function fill (val, start, end, encoding) {
		  // Handle string cases:
		  if (typeof val === 'string') {
		    if (typeof start === 'string') {
		      encoding = start
		      start = 0
		      end = this.length
		    } else if (typeof end === 'string') {
		      encoding = end
		      end = this.length
		    }
		    if (val.length === 1) {
		      var code = val.charCodeAt(0)
		      if (code < 256) {
		        val = code
		      }
		    }
		    if (encoding !== undefined && typeof encoding !== 'string') {
		      throw new TypeError('encoding must be a string')
		    }
		    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
		      throw new TypeError('Unknown encoding: ' + encoding)
		    }
		  } else if (typeof val === 'number') {
		    val = val & 255
		  }

		  // Invalid ranges are not set to a default, so can range check early.
		  if (start < 0 || this.length < start || this.length < end) {
		    throw new RangeError('Out of range index')
		  }

		  if (end <= start) {
		    return this
		  }

		  start = start >>> 0
		  end = end === undefined ? this.length : end >>> 0

		  if (!val) val = 0

		  var i
		  if (typeof val === 'number') {
		    for (i = start; i < end; ++i) {
		      this[i] = val
		    }
		  } else {
		    var bytes = Buffer.isBuffer(val)
		      ? val
		      : utf8ToBytes(new Buffer(val, encoding).toString())
		    var len = bytes.length
		    for (i = 0; i < end - start; ++i) {
		      this[i + start] = bytes[i % len]
		    }
		  }

		  return this
		}

		// HELPER FUNCTIONS
		// ================

		var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

		function base64clean (str) {
		  // Node strips out invalid characters like \n and \t from the string, base64-js does not
		  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
		  // Node converts strings with length < 2 to ''
		  if (str.length < 2) return ''
		  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
		  while (str.length % 4 !== 0) {
		    str = str + '='
		  }
		  return str
		}

		function stringtrim (str) {
		  if (str.trim) return str.trim()
		  return str.replace(/^\s+|\s+$/g, '')
		}

		function toHex (n) {
		  if (n < 16) return '0' + n.toString(16)
		  return n.toString(16)
		}

		function utf8ToBytes (string, units) {
		  units = units || Infinity
		  var codePoint
		  var length = string.length
		  var leadSurrogate = null
		  var bytes = []

		  for (var i = 0; i < length; ++i) {
		    codePoint = string.charCodeAt(i)

		    // is surrogate component
		    if (codePoint > 0xD7FF && codePoint < 0xE000) {
		      // last char was a lead
		      if (!leadSurrogate) {
		        // no lead yet
		        if (codePoint > 0xDBFF) {
		          // unexpected trail
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
		          continue
		        } else if (i + 1 === length) {
		          // unpaired lead
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
		          continue
		        }

		        // valid lead
		        leadSurrogate = codePoint

		        continue
		      }

		      // 2 leads in a row
		      if (codePoint < 0xDC00) {
		        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
		        leadSurrogate = codePoint
		        continue
		      }

		      // valid surrogate pair
		      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
		    } else if (leadSurrogate) {
		      // valid bmp char, but last char was a lead
		      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
		    }

		    leadSurrogate = null

		    // encode utf8
		    if (codePoint < 0x80) {
		      if ((units -= 1) < 0) break
		      bytes.push(codePoint)
		    } else if (codePoint < 0x800) {
		      if ((units -= 2) < 0) break
		      bytes.push(
		        codePoint >> 0x6 | 0xC0,
		        codePoint & 0x3F | 0x80
		      )
		    } else if (codePoint < 0x10000) {
		      if ((units -= 3) < 0) break
		      bytes.push(
		        codePoint >> 0xC | 0xE0,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      )
		    } else if (codePoint < 0x110000) {
		      if ((units -= 4) < 0) break
		      bytes.push(
		        codePoint >> 0x12 | 0xF0,
		        codePoint >> 0xC & 0x3F | 0x80,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      )
		    } else {
		      throw new Error('Invalid code point')
		    }
		  }

		  return bytes
		}

		function asciiToBytes (str) {
		  var byteArray = []
		  for (var i = 0; i < str.length; ++i) {
		    // Node's code seems to be doing this and not & 0x7F..
		    byteArray.push(str.charCodeAt(i) & 0xFF)
		  }
		  return byteArray
		}

		function utf16leToBytes (str, units) {
		  var c, hi, lo
		  var byteArray = []
		  for (var i = 0; i < str.length; ++i) {
		    if ((units -= 2) < 0) break

		    c = str.charCodeAt(i)
		    hi = c >> 8
		    lo = c % 256
		    byteArray.push(lo)
		    byteArray.push(hi)
		  }

		  return byteArray
		}

		function base64ToBytes (str) {
		  return base64.toByteArray(base64clean(str))
		}

		function blitBuffer (src, dst, offset, length) {
		  for (var i = 0; i < length; ++i) {
		    if ((i + offset >= dst.length) || (i >= src.length)) break
		    dst[i + offset] = src[i]
		  }
		  return i
		}

		function isnan (val) {
		  return val !== val // eslint-disable-line no-self-compare
		}

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {

		'use strict'

		exports.byteLength = byteLength
		exports.toByteArray = toByteArray
		exports.fromByteArray = fromByteArray

		var lookup = []
		var revLookup = []
		var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

		var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
		for (var i = 0, len = code.length; i < len; ++i) {
		  lookup[i] = code[i]
		  revLookup[code.charCodeAt(i)] = i
		}

		// Support decoding URL-safe base64 strings, as Node.js does.
		// See: https://en.wikipedia.org/wiki/Base64#URL_applications
		revLookup['-'.charCodeAt(0)] = 62
		revLookup['_'.charCodeAt(0)] = 63

		function getLens (b64) {
		  var len = b64.length

		  if (len % 4 > 0) {
		    throw new Error('Invalid string. Length must be a multiple of 4')
		  }

		  // Trim off extra bytes after placeholder bytes are found
		  // See: https://github.com/beatgammit/base64-js/issues/42
		  var validLen = b64.indexOf('=')
		  if (validLen === -1) validLen = len

		  var placeHoldersLen = validLen === len
		    ? 0
		    : 4 - (validLen % 4)

		  return [validLen, placeHoldersLen]
		}

		// base64 is 4/3 + up to two characters of the original data
		function byteLength (b64) {
		  var lens = getLens(b64)
		  var validLen = lens[0]
		  var placeHoldersLen = lens[1]
		  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
		}

		function _byteLength (b64, validLen, placeHoldersLen) {
		  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
		}

		function toByteArray (b64) {
		  var tmp
		  var lens = getLens(b64)
		  var validLen = lens[0]
		  var placeHoldersLen = lens[1]

		  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

		  var curByte = 0

		  // if there are placeholders, only get up to the last complete 4 chars
		  var len = placeHoldersLen > 0
		    ? validLen - 4
		    : validLen

		  var i
		  for (i = 0; i < len; i += 4) {
		    tmp =
		      (revLookup[b64.charCodeAt(i)] << 18) |
		      (revLookup[b64.charCodeAt(i + 1)] << 12) |
		      (revLookup[b64.charCodeAt(i + 2)] << 6) |
		      revLookup[b64.charCodeAt(i + 3)]
		    arr[curByte++] = (tmp >> 16) & 0xFF
		    arr[curByte++] = (tmp >> 8) & 0xFF
		    arr[curByte++] = tmp & 0xFF
		  }

		  if (placeHoldersLen === 2) {
		    tmp =
		      (revLookup[b64.charCodeAt(i)] << 2) |
		      (revLookup[b64.charCodeAt(i + 1)] >> 4)
		    arr[curByte++] = tmp & 0xFF
		  }

		  if (placeHoldersLen === 1) {
		    tmp =
		      (revLookup[b64.charCodeAt(i)] << 10) |
		      (revLookup[b64.charCodeAt(i + 1)] << 4) |
		      (revLookup[b64.charCodeAt(i + 2)] >> 2)
		    arr[curByte++] = (tmp >> 8) & 0xFF
		    arr[curByte++] = tmp & 0xFF
		  }

		  return arr
		}

		function tripletToBase64 (num) {
		  return lookup[num >> 18 & 0x3F] +
		    lookup[num >> 12 & 0x3F] +
		    lookup[num >> 6 & 0x3F] +
		    lookup[num & 0x3F]
		}

		function encodeChunk (uint8, start, end) {
		  var tmp
		  var output = []
		  for (var i = start; i < end; i += 3) {
		    tmp =
		      ((uint8[i] << 16) & 0xFF0000) +
		      ((uint8[i + 1] << 8) & 0xFF00) +
		      (uint8[i + 2] & 0xFF)
		    output.push(tripletToBase64(tmp))
		  }
		  return output.join('')
		}

		function fromByteArray (uint8) {
		  var tmp
		  var len = uint8.length
		  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
		  var parts = []
		  var maxChunkLength = 16383 // must be multiple of 3

		  // go through the array every three bytes, we'll deal with trailing stuff later
		  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
		    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
		  }

		  // pad the end with zeros, but make sure to not forget the extra bytes
		  if (extraBytes === 1) {
		    tmp = uint8[len - 1]
		    parts.push(
		      lookup[tmp >> 2] +
		      lookup[(tmp << 4) & 0x3F] +
		      '=='
		    )
		  } else if (extraBytes === 2) {
		    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
		    parts.push(
		      lookup[tmp >> 10] +
		      lookup[(tmp >> 4) & 0x3F] +
		      lookup[(tmp << 2) & 0x3F] +
		      '='
		    )
		  }

		  return parts.join('')
		}


	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {

		exports.read = function (buffer, offset, isLE, mLen, nBytes) {
		  var e, m
		  var eLen = (nBytes * 8) - mLen - 1
		  var eMax = (1 << eLen) - 1
		  var eBias = eMax >> 1
		  var nBits = -7
		  var i = isLE ? (nBytes - 1) : 0
		  var d = isLE ? -1 : 1
		  var s = buffer[offset + i]

		  i += d

		  e = s & ((1 << (-nBits)) - 1)
		  s >>= (-nBits)
		  nBits += eLen
		  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

		  m = e & ((1 << (-nBits)) - 1)
		  e >>= (-nBits)
		  nBits += mLen
		  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

		  if (e === 0) {
		    e = 1 - eBias
		  } else if (e === eMax) {
		    return m ? NaN : ((s ? -1 : 1) * Infinity)
		  } else {
		    m = m + Math.pow(2, mLen)
		    e = e - eBias
		  }
		  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
		}

		exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
		  var e, m, c
		  var eLen = (nBytes * 8) - mLen - 1
		  var eMax = (1 << eLen) - 1
		  var eBias = eMax >> 1
		  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
		  var i = isLE ? 0 : (nBytes - 1)
		  var d = isLE ? 1 : -1
		  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

		  value = Math.abs(value)

		  if (isNaN(value) || value === Infinity) {
		    m = isNaN(value) ? 1 : 0
		    e = eMax
		  } else {
		    e = Math.floor(Math.log(value) / Math.LN2)
		    if (value * (c = Math.pow(2, -e)) < 1) {
		      e--
		      c *= 2
		    }
		    if (e + eBias >= 1) {
		      value += rt / c
		    } else {
		      value += rt * Math.pow(2, 1 - eBias)
		    }
		    if (value * c >= 2) {
		      e++
		      c /= 2
		    }

		    if (e + eBias >= eMax) {
		      m = 0
		      e = eMax
		    } else if (e + eBias >= 1) {
		      m = ((value * c) - 1) * Math.pow(2, mLen)
		      e = e + eBias
		    } else {
		      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
		      e = 0
		    }
		  }

		  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

		  e = (e << mLen) | m
		  eLen += mLen
		  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

		  buffer[offset + i - d] |= s * 128
		}


	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {

		var toString = {}.toString;

		module.exports = Array.isArray || function (arr) {
		  return toString.call(arr) == '[object Array]';
		};


	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		module.exports = Stream;

		var EE = __webpack_require__(33).EventEmitter;
		var inherits = __webpack_require__(34);

		inherits(Stream, EE);
		Stream.Readable = __webpack_require__(35);
		Stream.Writable = __webpack_require__(54);
		Stream.Duplex = __webpack_require__(55);
		Stream.Transform = __webpack_require__(56);
		Stream.PassThrough = __webpack_require__(57);

		// Backwards-compat with node 0.4.x
		Stream.Stream = Stream;



		// old-style streams.  Note that the pipe method (the only relevant
		// part of this class) is overridden in the Readable class.

		function Stream() {
		  EE.call(this);
		}

		Stream.prototype.pipe = function(dest, options) {
		  var source = this;

		  function ondata(chunk) {
		    if (dest.writable) {
		      if (false === dest.write(chunk) && source.pause) {
		        source.pause();
		      }
		    }
		  }

		  source.on('data', ondata);

		  function ondrain() {
		    if (source.readable && source.resume) {
		      source.resume();
		    }
		  }

		  dest.on('drain', ondrain);

		  // If the 'end' option is not supplied, dest.end() will be called when
		  // source gets the 'end' or 'close' events.  Only dest.end() once.
		  if (!dest._isStdio && (!options || options.end !== false)) {
		    source.on('end', onend);
		    source.on('close', onclose);
		  }

		  var didOnEnd = false;
		  function onend() {
		    if (didOnEnd) return;
		    didOnEnd = true;

		    dest.end();
		  }


		  function onclose() {
		    if (didOnEnd) return;
		    didOnEnd = true;

		    if (typeof dest.destroy === 'function') dest.destroy();
		  }

		  // don't leave dangling pipes when there are errors.
		  function onerror(er) {
		    cleanup();
		    if (EE.listenerCount(this, 'error') === 0) {
		      throw er; // Unhandled stream error in pipe.
		    }
		  }

		  source.on('error', onerror);
		  dest.on('error', onerror);

		  // remove all the event listeners that were added.
		  function cleanup() {
		    source.removeListener('data', ondata);
		    dest.removeListener('drain', ondrain);

		    source.removeListener('end', onend);
		    source.removeListener('close', onclose);

		    source.removeListener('error', onerror);
		    dest.removeListener('error', onerror);

		    source.removeListener('end', cleanup);
		    source.removeListener('close', cleanup);

		    dest.removeListener('close', cleanup);
		  }

		  source.on('end', cleanup);
		  source.on('close', cleanup);

		  dest.on('close', cleanup);

		  dest.emit('pipe', source);

		  // Allow for unix-like usage: A.pipe(B).pipe(C)
		  return dest;
		};


	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		function EventEmitter() {
		  this._events = this._events || {};
		  this._maxListeners = this._maxListeners || undefined;
		}
		module.exports = EventEmitter;

		// Backwards-compat with node 0.10.x
		EventEmitter.EventEmitter = EventEmitter;

		EventEmitter.prototype._events = undefined;
		EventEmitter.prototype._maxListeners = undefined;

		// By default EventEmitters will print a warning if more than 10 listeners are
		// added to it. This is a useful default which helps finding memory leaks.
		EventEmitter.defaultMaxListeners = 10;

		// Obviously not all Emitters should be limited to 10. This function allows
		// that to be increased. Set to zero for unlimited.
		EventEmitter.prototype.setMaxListeners = function(n) {
		  if (!isNumber(n) || n < 0 || isNaN(n))
		    throw TypeError('n must be a positive number');
		  this._maxListeners = n;
		  return this;
		};

		EventEmitter.prototype.emit = function(type) {
		  var er, handler, len, args, i, listeners;

		  if (!this._events)
		    this._events = {};

		  // If there is no 'error' event listener then throw.
		  if (type === 'error') {
		    if (!this._events.error ||
		        (isObject(this._events.error) && !this._events.error.length)) {
		      er = arguments[1];
		      if (er instanceof Error) {
		        throw er; // Unhandled 'error' event
		      } else {
		        // At least give some kind of context to the user
		        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
		        err.context = er;
		        throw err;
		      }
		    }
		  }

		  handler = this._events[type];

		  if (isUndefined(handler))
		    return false;

		  if (isFunction(handler)) {
		    switch (arguments.length) {
		      // fast cases
		      case 1:
		        handler.call(this);
		        break;
		      case 2:
		        handler.call(this, arguments[1]);
		        break;
		      case 3:
		        handler.call(this, arguments[1], arguments[2]);
		        break;
		      // slower
		      default:
		        args = Array.prototype.slice.call(arguments, 1);
		        handler.apply(this, args);
		    }
		  } else if (isObject(handler)) {
		    args = Array.prototype.slice.call(arguments, 1);
		    listeners = handler.slice();
		    len = listeners.length;
		    for (i = 0; i < len; i++)
		      listeners[i].apply(this, args);
		  }

		  return true;
		};

		EventEmitter.prototype.addListener = function(type, listener) {
		  var m;

		  if (!isFunction(listener))
		    throw TypeError('listener must be a function');

		  if (!this._events)
		    this._events = {};

		  // To avoid recursion in the case that type === "newListener"! Before
		  // adding it to the listeners, first emit "newListener".
		  if (this._events.newListener)
		    this.emit('newListener', type,
		              isFunction(listener.listener) ?
		              listener.listener : listener);

		  if (!this._events[type])
		    // Optimize the case of one listener. Don't need the extra array object.
		    this._events[type] = listener;
		  else if (isObject(this._events[type]))
		    // If we've already got an array, just append.
		    this._events[type].push(listener);
		  else
		    // Adding the second element, need to change to array.
		    this._events[type] = [this._events[type], listener];

		  // Check for listener leak
		  if (isObject(this._events[type]) && !this._events[type].warned) {
		    if (!isUndefined(this._maxListeners)) {
		      m = this._maxListeners;
		    } else {
		      m = EventEmitter.defaultMaxListeners;
		    }

		    if (m && m > 0 && this._events[type].length > m) {
		      this._events[type].warned = true;
		      console.error('(node) warning: possible EventEmitter memory ' +
		                    'leak detected. %d listeners added. ' +
		                    'Use emitter.setMaxListeners() to increase limit.',
		                    this._events[type].length);
		      if (typeof console.trace === 'function') {
		        // not supported in IE 10
		        console.trace();
		      }
		    }
		  }

		  return this;
		};

		EventEmitter.prototype.on = EventEmitter.prototype.addListener;

		EventEmitter.prototype.once = function(type, listener) {
		  if (!isFunction(listener))
		    throw TypeError('listener must be a function');

		  var fired = false;

		  function g() {
		    this.removeListener(type, g);

		    if (!fired) {
		      fired = true;
		      listener.apply(this, arguments);
		    }
		  }

		  g.listener = listener;
		  this.on(type, g);

		  return this;
		};

		// emits a 'removeListener' event iff the listener was removed
		EventEmitter.prototype.removeListener = function(type, listener) {
		  var list, position, length, i;

		  if (!isFunction(listener))
		    throw TypeError('listener must be a function');

		  if (!this._events || !this._events[type])
		    return this;

		  list = this._events[type];
		  length = list.length;
		  position = -1;

		  if (list === listener ||
		      (isFunction(list.listener) && list.listener === listener)) {
		    delete this._events[type];
		    if (this._events.removeListener)
		      this.emit('removeListener', type, listener);

		  } else if (isObject(list)) {
		    for (i = length; i-- > 0;) {
		      if (list[i] === listener ||
		          (list[i].listener && list[i].listener === listener)) {
		        position = i;
		        break;
		      }
		    }

		    if (position < 0)
		      return this;

		    if (list.length === 1) {
		      list.length = 0;
		      delete this._events[type];
		    } else {
		      list.splice(position, 1);
		    }

		    if (this._events.removeListener)
		      this.emit('removeListener', type, listener);
		  }

		  return this;
		};

		EventEmitter.prototype.removeAllListeners = function(type) {
		  var key, listeners;

		  if (!this._events)
		    return this;

		  // not listening for removeListener, no need to emit
		  if (!this._events.removeListener) {
		    if (arguments.length === 0)
		      this._events = {};
		    else if (this._events[type])
		      delete this._events[type];
		    return this;
		  }

		  // emit removeListener for all listeners on all events
		  if (arguments.length === 0) {
		    for (key in this._events) {
		      if (key === 'removeListener') continue;
		      this.removeAllListeners(key);
		    }
		    this.removeAllListeners('removeListener');
		    this._events = {};
		    return this;
		  }

		  listeners = this._events[type];

		  if (isFunction(listeners)) {
		    this.removeListener(type, listeners);
		  } else if (listeners) {
		    // LIFO order
		    while (listeners.length)
		      this.removeListener(type, listeners[listeners.length - 1]);
		  }
		  delete this._events[type];

		  return this;
		};

		EventEmitter.prototype.listeners = function(type) {
		  var ret;
		  if (!this._events || !this._events[type])
		    ret = [];
		  else if (isFunction(this._events[type]))
		    ret = [this._events[type]];
		  else
		    ret = this._events[type].slice();
		  return ret;
		};

		EventEmitter.prototype.listenerCount = function(type) {
		  if (this._events) {
		    var evlistener = this._events[type];

		    if (isFunction(evlistener))
		      return 1;
		    else if (evlistener)
		      return evlistener.length;
		  }
		  return 0;
		};

		EventEmitter.listenerCount = function(emitter, type) {
		  return emitter.listenerCount(type);
		};

		function isFunction(arg) {
		  return typeof arg === 'function';
		}

		function isNumber(arg) {
		  return typeof arg === 'number';
		}

		function isObject(arg) {
		  return typeof arg === 'object' && arg !== null;
		}

		function isUndefined(arg) {
		  return arg === void 0;
		}


	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {

		if (typeof Object.create === 'function') {
		  // implementation from standard node.js 'util' module
		  module.exports = function inherits(ctor, superCtor) {
		    if (superCtor) {
		      ctor.super_ = superCtor
		      ctor.prototype = Object.create(superCtor.prototype, {
		        constructor: {
		          value: ctor,
		          enumerable: false,
		          writable: true,
		          configurable: true
		        }
		      })
		    }
		  };
		} else {
		  // old school shim for old browsers
		  module.exports = function inherits(ctor, superCtor) {
		    if (superCtor) {
		      ctor.super_ = superCtor
		      var TempCtor = function () {}
		      TempCtor.prototype = superCtor.prototype
		      ctor.prototype = new TempCtor()
		      ctor.prototype.constructor = ctor
		    }
		  }
		}


	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {

		exports = module.exports = __webpack_require__(36);
		exports.Stream = exports;
		exports.Readable = exports;
		exports.Writable = __webpack_require__(47);
		exports.Duplex = __webpack_require__(46);
		exports.Transform = __webpack_require__(52);
		exports.PassThrough = __webpack_require__(53);


	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		'use strict';

		/*<replacement>*/

		var pna = __webpack_require__(38);
		/*</replacement>*/

		module.exports = Readable;

		/*<replacement>*/
		var isArray = __webpack_require__(31);
		/*</replacement>*/

		/*<replacement>*/
		var Duplex;
		/*</replacement>*/

		Readable.ReadableState = ReadableState;

		/*<replacement>*/
		var EE = __webpack_require__(33).EventEmitter;

		var EElistenerCount = function (emitter, type) {
		  return emitter.listeners(type).length;
		};
		/*</replacement>*/

		/*<replacement>*/
		var Stream = __webpack_require__(39);
		/*</replacement>*/

		/*<replacement>*/

		var Buffer = __webpack_require__(40).Buffer;
		var OurUint8Array = global.Uint8Array || function () {};
		function _uint8ArrayToBuffer(chunk) {
		  return Buffer.from(chunk);
		}
		function _isUint8Array(obj) {
		  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
		}

		/*</replacement>*/

		/*<replacement>*/
		var util = Object.create(__webpack_require__(41));
		util.inherits = __webpack_require__(34);
		/*</replacement>*/

		/*<replacement>*/
		var debugUtil = __webpack_require__(42);
		var debug = void 0;
		if (debugUtil && debugUtil.debuglog) {
		  debug = debugUtil.debuglog('stream');
		} else {
		  debug = function () {};
		}
		/*</replacement>*/

		var BufferList = __webpack_require__(43);
		var destroyImpl = __webpack_require__(45);
		var StringDecoder;

		util.inherits(Readable, Stream);

		var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

		function prependListener(emitter, event, fn) {
		  // Sadly this is not cacheable as some libraries bundle their own
		  // event emitter implementation with them.
		  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

		  // This is a hack to make sure that our error handler is attached before any
		  // userland ones.  NEVER DO THIS. This is here only because this code needs
		  // to continue to work with older versions of Node.js that do not include
		  // the prependListener() method. The goal is to eventually remove this hack.
		  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
		}

		function ReadableState(options, stream) {
		  Duplex = Duplex || __webpack_require__(46);

		  options = options || {};

		  // Duplex streams are both readable and writable, but share
		  // the same options object.
		  // However, some cases require setting options to different
		  // values for the readable and the writable sides of the duplex stream.
		  // These options can be provided separately as readableXXX and writableXXX.
		  var isDuplex = stream instanceof Duplex;

		  // object stream flag. Used to make read(n) ignore n and to
		  // make all the buffer merging and length checks go away
		  this.objectMode = !!options.objectMode;

		  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

		  // the point at which it stops calling _read() to fill the buffer
		  // Note: 0 is a valid value, means "don't call _read preemptively ever"
		  var hwm = options.highWaterMark;
		  var readableHwm = options.readableHighWaterMark;
		  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

		  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

		  // cast to ints.
		  this.highWaterMark = Math.floor(this.highWaterMark);

		  // A linked list is used to store data chunks instead of an array because the
		  // linked list can remove elements from the beginning faster than
		  // array.shift()
		  this.buffer = new BufferList();
		  this.length = 0;
		  this.pipes = null;
		  this.pipesCount = 0;
		  this.flowing = null;
		  this.ended = false;
		  this.endEmitted = false;
		  this.reading = false;

		  // a flag to be able to tell if the event 'readable'/'data' is emitted
		  // immediately, or on a later tick.  We set this to true at first, because
		  // any actions that shouldn't happen until "later" should generally also
		  // not happen before the first read call.
		  this.sync = true;

		  // whenever we return null, then we set a flag to say
		  // that we're awaiting a 'readable' event emission.
		  this.needReadable = false;
		  this.emittedReadable = false;
		  this.readableListening = false;
		  this.resumeScheduled = false;

		  // has it been destroyed
		  this.destroyed = false;

		  // Crypto is kind of old and crusty.  Historically, its default string
		  // encoding is 'binary' so we have to make this configurable.
		  // Everything else in the universe uses 'utf8', though.
		  this.defaultEncoding = options.defaultEncoding || 'utf8';

		  // the number of writers that are awaiting a drain event in .pipe()s
		  this.awaitDrain = 0;

		  // if true, a maybeReadMore has been scheduled
		  this.readingMore = false;

		  this.decoder = null;
		  this.encoding = null;
		  if (options.encoding) {
		    if (!StringDecoder) StringDecoder = __webpack_require__(51).StringDecoder;
		    this.decoder = new StringDecoder(options.encoding);
		    this.encoding = options.encoding;
		  }
		}

		function Readable(options) {
		  Duplex = Duplex || __webpack_require__(46);

		  if (!(this instanceof Readable)) return new Readable(options);

		  this._readableState = new ReadableState(options, this);

		  // legacy
		  this.readable = true;

		  if (options) {
		    if (typeof options.read === 'function') this._read = options.read;

		    if (typeof options.destroy === 'function') this._destroy = options.destroy;
		  }

		  Stream.call(this);
		}

		Object.defineProperty(Readable.prototype, 'destroyed', {
		  get: function () {
		    if (this._readableState === undefined) {
		      return false;
		    }
		    return this._readableState.destroyed;
		  },
		  set: function (value) {
		    // we ignore the value if the stream
		    // has not been initialized yet
		    if (!this._readableState) {
		      return;
		    }

		    // backward compatibility, the user is explicitly
		    // managing destroyed
		    this._readableState.destroyed = value;
		  }
		});

		Readable.prototype.destroy = destroyImpl.destroy;
		Readable.prototype._undestroy = destroyImpl.undestroy;
		Readable.prototype._destroy = function (err, cb) {
		  this.push(null);
		  cb(err);
		};

		// Manually shove something into the read() buffer.
		// This returns true if the highWaterMark has not been hit yet,
		// similar to how Writable.write() returns true if you should
		// write() some more.
		Readable.prototype.push = function (chunk, encoding) {
		  var state = this._readableState;
		  var skipChunkCheck;

		  if (!state.objectMode) {
		    if (typeof chunk === 'string') {
		      encoding = encoding || state.defaultEncoding;
		      if (encoding !== state.encoding) {
		        chunk = Buffer.from(chunk, encoding);
		        encoding = '';
		      }
		      skipChunkCheck = true;
		    }
		  } else {
		    skipChunkCheck = true;
		  }

		  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
		};

		// Unshift should *always* be something directly out of read()
		Readable.prototype.unshift = function (chunk) {
		  return readableAddChunk(this, chunk, null, true, false);
		};

		function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
		  var state = stream._readableState;
		  if (chunk === null) {
		    state.reading = false;
		    onEofChunk(stream, state);
		  } else {
		    var er;
		    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
		    if (er) {
		      stream.emit('error', er);
		    } else if (state.objectMode || chunk && chunk.length > 0) {
		      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
		        chunk = _uint8ArrayToBuffer(chunk);
		      }

		      if (addToFront) {
		        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
		      } else if (state.ended) {
		        stream.emit('error', new Error('stream.push() after EOF'));
		      } else {
		        state.reading = false;
		        if (state.decoder && !encoding) {
		          chunk = state.decoder.write(chunk);
		          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
		        } else {
		          addChunk(stream, state, chunk, false);
		        }
		      }
		    } else if (!addToFront) {
		      state.reading = false;
		    }
		  }

		  return needMoreData(state);
		}

		function addChunk(stream, state, chunk, addToFront) {
		  if (state.flowing && state.length === 0 && !state.sync) {
		    stream.emit('data', chunk);
		    stream.read(0);
		  } else {
		    // update the buffer info.
		    state.length += state.objectMode ? 1 : chunk.length;
		    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

		    if (state.needReadable) emitReadable(stream);
		  }
		  maybeReadMore(stream, state);
		}

		function chunkInvalid(state, chunk) {
		  var er;
		  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
		    er = new TypeError('Invalid non-string/buffer chunk');
		  }
		  return er;
		}

		// if it's past the high water mark, we can push in some more.
		// Also, if we have no data yet, we can stand some
		// more bytes.  This is to work around cases where hwm=0,
		// such as the repl.  Also, if the push() triggered a
		// readable event, and the user called read(largeNumber) such that
		// needReadable was set, then we ought to push more, so that another
		// 'readable' event will be triggered.
		function needMoreData(state) {
		  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
		}

		Readable.prototype.isPaused = function () {
		  return this._readableState.flowing === false;
		};

		// backwards compatibility.
		Readable.prototype.setEncoding = function (enc) {
		  if (!StringDecoder) StringDecoder = __webpack_require__(51).StringDecoder;
		  this._readableState.decoder = new StringDecoder(enc);
		  this._readableState.encoding = enc;
		  return this;
		};

		// Don't raise the hwm > 8MB
		var MAX_HWM = 0x800000;
		function computeNewHighWaterMark(n) {
		  if (n >= MAX_HWM) {
		    n = MAX_HWM;
		  } else {
		    // Get the next highest power of 2 to prevent increasing hwm excessively in
		    // tiny amounts
		    n--;
		    n |= n >>> 1;
		    n |= n >>> 2;
		    n |= n >>> 4;
		    n |= n >>> 8;
		    n |= n >>> 16;
		    n++;
		  }
		  return n;
		}

		// This function is designed to be inlinable, so please take care when making
		// changes to the function body.
		function howMuchToRead(n, state) {
		  if (n <= 0 || state.length === 0 && state.ended) return 0;
		  if (state.objectMode) return 1;
		  if (n !== n) {
		    // Only flow one buffer at a time
		    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
		  }
		  // If we're asking for more than the current hwm, then raise the hwm.
		  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
		  if (n <= state.length) return n;
		  // Don't have enough
		  if (!state.ended) {
		    state.needReadable = true;
		    return 0;
		  }
		  return state.length;
		}

		// you can override either this method, or the async _read(n) below.
		Readable.prototype.read = function (n) {
		  debug('read', n);
		  n = parseInt(n, 10);
		  var state = this._readableState;
		  var nOrig = n;

		  if (n !== 0) state.emittedReadable = false;

		  // if we're doing read(0) to trigger a readable event, but we
		  // already have a bunch of data in the buffer, then just trigger
		  // the 'readable' event and move on.
		  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
		    debug('read: emitReadable', state.length, state.ended);
		    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
		    return null;
		  }

		  n = howMuchToRead(n, state);

		  // if we've ended, and we're now clear, then finish it up.
		  if (n === 0 && state.ended) {
		    if (state.length === 0) endReadable(this);
		    return null;
		  }

		  // All the actual chunk generation logic needs to be
		  // *below* the call to _read.  The reason is that in certain
		  // synthetic stream cases, such as passthrough streams, _read
		  // may be a completely synchronous operation which may change
		  // the state of the read buffer, providing enough data when
		  // before there was *not* enough.
		  //
		  // So, the steps are:
		  // 1. Figure out what the state of things will be after we do
		  // a read from the buffer.
		  //
		  // 2. If that resulting state will trigger a _read, then call _read.
		  // Note that this may be asynchronous, or synchronous.  Yes, it is
		  // deeply ugly to write APIs this way, but that still doesn't mean
		  // that the Readable class should behave improperly, as streams are
		  // designed to be sync/async agnostic.
		  // Take note if the _read call is sync or async (ie, if the read call
		  // has returned yet), so that we know whether or not it's safe to emit
		  // 'readable' etc.
		  //
		  // 3. Actually pull the requested chunks out of the buffer and return.

		  // if we need a readable event, then we need to do some reading.
		  var doRead = state.needReadable;
		  debug('need readable', doRead);

		  // if we currently have less than the highWaterMark, then also read some
		  if (state.length === 0 || state.length - n < state.highWaterMark) {
		    doRead = true;
		    debug('length less than watermark', doRead);
		  }

		  // however, if we've ended, then there's no point, and if we're already
		  // reading, then it's unnecessary.
		  if (state.ended || state.reading) {
		    doRead = false;
		    debug('reading or ended', doRead);
		  } else if (doRead) {
		    debug('do read');
		    state.reading = true;
		    state.sync = true;
		    // if the length is currently zero, then we *need* a readable event.
		    if (state.length === 0) state.needReadable = true;
		    // call internal read method
		    this._read(state.highWaterMark);
		    state.sync = false;
		    // If _read pushed data synchronously, then `reading` will be false,
		    // and we need to re-evaluate how much data we can return to the user.
		    if (!state.reading) n = howMuchToRead(nOrig, state);
		  }

		  var ret;
		  if (n > 0) ret = fromList(n, state);else ret = null;

		  if (ret === null) {
		    state.needReadable = true;
		    n = 0;
		  } else {
		    state.length -= n;
		  }

		  if (state.length === 0) {
		    // If we have nothing in the buffer, then we want to know
		    // as soon as we *do* get something into the buffer.
		    if (!state.ended) state.needReadable = true;

		    // If we tried to read() past the EOF, then emit end on the next tick.
		    if (nOrig !== n && state.ended) endReadable(this);
		  }

		  if (ret !== null) this.emit('data', ret);

		  return ret;
		};

		function onEofChunk(stream, state) {
		  if (state.ended) return;
		  if (state.decoder) {
		    var chunk = state.decoder.end();
		    if (chunk && chunk.length) {
		      state.buffer.push(chunk);
		      state.length += state.objectMode ? 1 : chunk.length;
		    }
		  }
		  state.ended = true;

		  // emit 'readable' now to make sure it gets picked up.
		  emitReadable(stream);
		}

		// Don't emit readable right away in sync mode, because this can trigger
		// another read() call => stack overflow.  This way, it might trigger
		// a nextTick recursion warning, but that's not so bad.
		function emitReadable(stream) {
		  var state = stream._readableState;
		  state.needReadable = false;
		  if (!state.emittedReadable) {
		    debug('emitReadable', state.flowing);
		    state.emittedReadable = true;
		    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
		  }
		}

		function emitReadable_(stream) {
		  debug('emit readable');
		  stream.emit('readable');
		  flow(stream);
		}

		// at this point, the user has presumably seen the 'readable' event,
		// and called read() to consume some data.  that may have triggered
		// in turn another _read(n) call, in which case reading = true if
		// it's in progress.
		// However, if we're not ended, or reading, and the length < hwm,
		// then go ahead and try to read some more preemptively.
		function maybeReadMore(stream, state) {
		  if (!state.readingMore) {
		    state.readingMore = true;
		    pna.nextTick(maybeReadMore_, stream, state);
		  }
		}

		function maybeReadMore_(stream, state) {
		  var len = state.length;
		  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
		    debug('maybeReadMore read 0');
		    stream.read(0);
		    if (len === state.length)
		      // didn't get any data, stop spinning.
		      break;else len = state.length;
		  }
		  state.readingMore = false;
		}

		// abstract method.  to be overridden in specific implementation classes.
		// call cb(er, data) where data is <= n in length.
		// for virtual (non-string, non-buffer) streams, "length" is somewhat
		// arbitrary, and perhaps not very meaningful.
		Readable.prototype._read = function (n) {
		  this.emit('error', new Error('_read() is not implemented'));
		};

		Readable.prototype.pipe = function (dest, pipeOpts) {
		  var src = this;
		  var state = this._readableState;

		  switch (state.pipesCount) {
		    case 0:
		      state.pipes = dest;
		      break;
		    case 1:
		      state.pipes = [state.pipes, dest];
		      break;
		    default:
		      state.pipes.push(dest);
		      break;
		  }
		  state.pipesCount += 1;
		  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

		  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

		  var endFn = doEnd ? onend : unpipe;
		  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

		  dest.on('unpipe', onunpipe);
		  function onunpipe(readable, unpipeInfo) {
		    debug('onunpipe');
		    if (readable === src) {
		      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
		        unpipeInfo.hasUnpiped = true;
		        cleanup();
		      }
		    }
		  }

		  function onend() {
		    debug('onend');
		    dest.end();
		  }

		  // when the dest drains, it reduces the awaitDrain counter
		  // on the source.  This would be more elegant with a .once()
		  // handler in flow(), but adding and removing repeatedly is
		  // too slow.
		  var ondrain = pipeOnDrain(src);
		  dest.on('drain', ondrain);

		  var cleanedUp = false;
		  function cleanup() {
		    debug('cleanup');
		    // cleanup event handlers once the pipe is broken
		    dest.removeListener('close', onclose);
		    dest.removeListener('finish', onfinish);
		    dest.removeListener('drain', ondrain);
		    dest.removeListener('error', onerror);
		    dest.removeListener('unpipe', onunpipe);
		    src.removeListener('end', onend);
		    src.removeListener('end', unpipe);
		    src.removeListener('data', ondata);

		    cleanedUp = true;

		    // if the reader is waiting for a drain event from this
		    // specific writer, then it would cause it to never start
		    // flowing again.
		    // So, if this is awaiting a drain, then we just call it now.
		    // If we don't know, then assume that we are waiting for one.
		    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
		  }

		  // If the user pushes more data while we're writing to dest then we'll end up
		  // in ondata again. However, we only want to increase awaitDrain once because
		  // dest will only emit one 'drain' event for the multiple writes.
		  // => Introduce a guard on increasing awaitDrain.
		  var increasedAwaitDrain = false;
		  src.on('data', ondata);
		  function ondata(chunk) {
		    debug('ondata');
		    increasedAwaitDrain = false;
		    var ret = dest.write(chunk);
		    if (false === ret && !increasedAwaitDrain) {
		      // If the user unpiped during `dest.write()`, it is possible
		      // to get stuck in a permanently paused state if that write
		      // also returned false.
		      // => Check whether `dest` is still a piping destination.
		      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
		        debug('false write response, pause', src._readableState.awaitDrain);
		        src._readableState.awaitDrain++;
		        increasedAwaitDrain = true;
		      }
		      src.pause();
		    }
		  }

		  // if the dest has an error, then stop piping into it.
		  // however, don't suppress the throwing behavior for this.
		  function onerror(er) {
		    debug('onerror', er);
		    unpipe();
		    dest.removeListener('error', onerror);
		    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
		  }

		  // Make sure our error handler is attached before userland ones.
		  prependListener(dest, 'error', onerror);

		  // Both close and finish should trigger unpipe, but only once.
		  function onclose() {
		    dest.removeListener('finish', onfinish);
		    unpipe();
		  }
		  dest.once('close', onclose);
		  function onfinish() {
		    debug('onfinish');
		    dest.removeListener('close', onclose);
		    unpipe();
		  }
		  dest.once('finish', onfinish);

		  function unpipe() {
		    debug('unpipe');
		    src.unpipe(dest);
		  }

		  // tell the dest that it's being piped to
		  dest.emit('pipe', src);

		  // start the flow if it hasn't been started already.
		  if (!state.flowing) {
		    debug('pipe resume');
		    src.resume();
		  }

		  return dest;
		};

		function pipeOnDrain(src) {
		  return function () {
		    var state = src._readableState;
		    debug('pipeOnDrain', state.awaitDrain);
		    if (state.awaitDrain) state.awaitDrain--;
		    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
		      state.flowing = true;
		      flow(src);
		    }
		  };
		}

		Readable.prototype.unpipe = function (dest) {
		  var state = this._readableState;
		  var unpipeInfo = { hasUnpiped: false };

		  // if we're not piping anywhere, then do nothing.
		  if (state.pipesCount === 0) return this;

		  // just one destination.  most common case.
		  if (state.pipesCount === 1) {
		    // passed in one, but it's not the right one.
		    if (dest && dest !== state.pipes) return this;

		    if (!dest) dest = state.pipes;

		    // got a match.
		    state.pipes = null;
		    state.pipesCount = 0;
		    state.flowing = false;
		    if (dest) dest.emit('unpipe', this, unpipeInfo);
		    return this;
		  }

		  // slow case. multiple pipe destinations.

		  if (!dest) {
		    // remove all.
		    var dests = state.pipes;
		    var len = state.pipesCount;
		    state.pipes = null;
		    state.pipesCount = 0;
		    state.flowing = false;

		    for (var i = 0; i < len; i++) {
		      dests[i].emit('unpipe', this, unpipeInfo);
		    }return this;
		  }

		  // try to find the right one.
		  var index = indexOf(state.pipes, dest);
		  if (index === -1) return this;

		  state.pipes.splice(index, 1);
		  state.pipesCount -= 1;
		  if (state.pipesCount === 1) state.pipes = state.pipes[0];

		  dest.emit('unpipe', this, unpipeInfo);

		  return this;
		};

		// set up data events if they are asked for
		// Ensure readable listeners eventually get something
		Readable.prototype.on = function (ev, fn) {
		  var res = Stream.prototype.on.call(this, ev, fn);

		  if (ev === 'data') {
		    // Start flowing on next tick if stream isn't explicitly paused
		    if (this._readableState.flowing !== false) this.resume();
		  } else if (ev === 'readable') {
		    var state = this._readableState;
		    if (!state.endEmitted && !state.readableListening) {
		      state.readableListening = state.needReadable = true;
		      state.emittedReadable = false;
		      if (!state.reading) {
		        pna.nextTick(nReadingNextTick, this);
		      } else if (state.length) {
		        emitReadable(this);
		      }
		    }
		  }

		  return res;
		};
		Readable.prototype.addListener = Readable.prototype.on;

		function nReadingNextTick(self) {
		  debug('readable nexttick read 0');
		  self.read(0);
		}

		// pause() and resume() are remnants of the legacy readable stream API
		// If the user uses them, then switch into old mode.
		Readable.prototype.resume = function () {
		  var state = this._readableState;
		  if (!state.flowing) {
		    debug('resume');
		    state.flowing = true;
		    resume(this, state);
		  }
		  return this;
		};

		function resume(stream, state) {
		  if (!state.resumeScheduled) {
		    state.resumeScheduled = true;
		    pna.nextTick(resume_, stream, state);
		  }
		}

		function resume_(stream, state) {
		  if (!state.reading) {
		    debug('resume read 0');
		    stream.read(0);
		  }

		  state.resumeScheduled = false;
		  state.awaitDrain = 0;
		  stream.emit('resume');
		  flow(stream);
		  if (state.flowing && !state.reading) stream.read(0);
		}

		Readable.prototype.pause = function () {
		  debug('call pause flowing=%j', this._readableState.flowing);
		  if (false !== this._readableState.flowing) {
		    debug('pause');
		    this._readableState.flowing = false;
		    this.emit('pause');
		  }
		  return this;
		};

		function flow(stream) {
		  var state = stream._readableState;
		  debug('flow', state.flowing);
		  while (state.flowing && stream.read() !== null) {}
		}

		// wrap an old-style stream as the async data source.
		// This is *not* part of the readable stream interface.
		// It is an ugly unfortunate mess of history.
		Readable.prototype.wrap = function (stream) {
		  var _this = this;

		  var state = this._readableState;
		  var paused = false;

		  stream.on('end', function () {
		    debug('wrapped end');
		    if (state.decoder && !state.ended) {
		      var chunk = state.decoder.end();
		      if (chunk && chunk.length) _this.push(chunk);
		    }

		    _this.push(null);
		  });

		  stream.on('data', function (chunk) {
		    debug('wrapped data');
		    if (state.decoder) chunk = state.decoder.write(chunk);

		    // don't skip over falsy values in objectMode
		    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

		    var ret = _this.push(chunk);
		    if (!ret) {
		      paused = true;
		      stream.pause();
		    }
		  });

		  // proxy all the other methods.
		  // important when wrapping filters and duplexes.
		  for (var i in stream) {
		    if (this[i] === undefined && typeof stream[i] === 'function') {
		      this[i] = function (method) {
		        return function () {
		          return stream[method].apply(stream, arguments);
		        };
		      }(i);
		    }
		  }

		  // proxy certain important events.
		  for (var n = 0; n < kProxyEvents.length; n++) {
		    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
		  }

		  // when we try to consume some more bytes, simply unpause the
		  // underlying stream.
		  this._read = function (n) {
		    debug('wrapped _read', n);
		    if (paused) {
		      paused = false;
		      stream.resume();
		    }
		  };

		  return this;
		};

		Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function () {
		    return this._readableState.highWaterMark;
		  }
		});

		// exposed for testing purposes only.
		Readable._fromList = fromList;

		// Pluck off n bytes from an array of buffers.
		// Length is the combined lengths of all the buffers in the list.
		// This function is designed to be inlinable, so please take care when making
		// changes to the function body.
		function fromList(n, state) {
		  // nothing buffered
		  if (state.length === 0) return null;

		  var ret;
		  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
		    // read it all, truncate the list
		    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
		    state.buffer.clear();
		  } else {
		    // read part of list
		    ret = fromListPartial(n, state.buffer, state.decoder);
		  }

		  return ret;
		}

		// Extracts only enough buffered data to satisfy the amount requested.
		// This function is designed to be inlinable, so please take care when making
		// changes to the function body.
		function fromListPartial(n, list, hasStrings) {
		  var ret;
		  if (n < list.head.data.length) {
		    // slice is the same for buffers and strings
		    ret = list.head.data.slice(0, n);
		    list.head.data = list.head.data.slice(n);
		  } else if (n === list.head.data.length) {
		    // first chunk is a perfect match
		    ret = list.shift();
		  } else {
		    // result spans more than one buffer
		    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
		  }
		  return ret;
		}

		// Copies a specified amount of characters from the list of buffered data
		// chunks.
		// This function is designed to be inlinable, so please take care when making
		// changes to the function body.
		function copyFromBufferString(n, list) {
		  var p = list.head;
		  var c = 1;
		  var ret = p.data;
		  n -= ret.length;
		  while (p = p.next) {
		    var str = p.data;
		    var nb = n > str.length ? str.length : n;
		    if (nb === str.length) ret += str;else ret += str.slice(0, n);
		    n -= nb;
		    if (n === 0) {
		      if (nb === str.length) {
		        ++c;
		        if (p.next) list.head = p.next;else list.head = list.tail = null;
		      } else {
		        list.head = p;
		        p.data = str.slice(nb);
		      }
		      break;
		    }
		    ++c;
		  }
		  list.length -= c;
		  return ret;
		}

		// Copies a specified amount of bytes from the list of buffered data chunks.
		// This function is designed to be inlinable, so please take care when making
		// changes to the function body.
		function copyFromBuffer(n, list) {
		  var ret = Buffer.allocUnsafe(n);
		  var p = list.head;
		  var c = 1;
		  p.data.copy(ret);
		  n -= p.data.length;
		  while (p = p.next) {
		    var buf = p.data;
		    var nb = n > buf.length ? buf.length : n;
		    buf.copy(ret, ret.length - n, 0, nb);
		    n -= nb;
		    if (n === 0) {
		      if (nb === buf.length) {
		        ++c;
		        if (p.next) list.head = p.next;else list.head = list.tail = null;
		      } else {
		        list.head = p;
		        p.data = buf.slice(nb);
		      }
		      break;
		    }
		    ++c;
		  }
		  list.length -= c;
		  return ret;
		}

		function endReadable(stream) {
		  var state = stream._readableState;

		  // If we get here before consuming all the bytes, then that is a
		  // bug in node.  Should never happen.
		  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

		  if (!state.endEmitted) {
		    state.ended = true;
		    pna.nextTick(endReadableNT, state, stream);
		  }
		}

		function endReadableNT(state, stream) {
		  // Check that we didn't get one last unshift.
		  if (!state.endEmitted && state.length === 0) {
		    state.endEmitted = true;
		    stream.readable = false;
		    stream.emit('end');
		  }
		}

		function indexOf(xs, x) {
		  for (var i = 0, l = xs.length; i < l; i++) {
		    if (xs[i] === x) return i;
		  }
		  return -1;
		}
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)))

	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {

		// shim for using process in browser
		var process = module.exports = {};

		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.

		var cachedSetTimeout;
		var cachedClearTimeout;

		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }


		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }



		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;

		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}

		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;

		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}

		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};

		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};

		function noop() {}

		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;

		process.listeners = function (name) { return [] }

		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};

		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };


	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(process) {'use strict';

		if (typeof process === 'undefined' ||
		    !process.version ||
		    process.version.indexOf('v0.') === 0 ||
		    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
		  module.exports = { nextTick: nextTick };
		} else {
		  module.exports = process
		}

		function nextTick(fn, arg1, arg2, arg3) {
		  if (typeof fn !== 'function') {
		    throw new TypeError('"callback" argument must be a function');
		  }
		  var len = arguments.length;
		  var args, i;
		  switch (len) {
		  case 0:
		  case 1:
		    return process.nextTick(fn);
		  case 2:
		    return process.nextTick(function afterTickOne() {
		      fn.call(null, arg1);
		    });
		  case 3:
		    return process.nextTick(function afterTickTwo() {
		      fn.call(null, arg1, arg2);
		    });
		  case 4:
		    return process.nextTick(function afterTickThree() {
		      fn.call(null, arg1, arg2, arg3);
		    });
		  default:
		    args = new Array(len - 1);
		    i = 0;
		    while (i < args.length) {
		      args[i++] = arguments[i];
		    }
		    return process.nextTick(function afterTick() {
		      fn.apply(null, args);
		    });
		  }
		}


		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(33).EventEmitter;


	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {

		/* eslint-disable node/no-deprecated-api */
		var buffer = __webpack_require__(28)
		var Buffer = buffer.Buffer

		// alternative to using Object.keys for old browsers
		function copyProps (src, dst) {
		  for (var key in src) {
		    dst[key] = src[key]
		  }
		}
		if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
		  module.exports = buffer
		} else {
		  // Copy properties from require('buffer')
		  copyProps(buffer, exports)
		  exports.Buffer = SafeBuffer
		}

		function SafeBuffer (arg, encodingOrOffset, length) {
		  return Buffer(arg, encodingOrOffset, length)
		}

		// Copy static methods from Buffer
		copyProps(Buffer, SafeBuffer)

		SafeBuffer.from = function (arg, encodingOrOffset, length) {
		  if (typeof arg === 'number') {
		    throw new TypeError('Argument must not be a number')
		  }
		  return Buffer(arg, encodingOrOffset, length)
		}

		SafeBuffer.alloc = function (size, fill, encoding) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  var buf = Buffer(size)
		  if (fill !== undefined) {
		    if (typeof encoding === 'string') {
		      buf.fill(fill, encoding)
		    } else {
		      buf.fill(fill)
		    }
		  } else {
		    buf.fill(0)
		  }
		  return buf
		}

		SafeBuffer.allocUnsafe = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return Buffer(size)
		}

		SafeBuffer.allocUnsafeSlow = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return buffer.SlowBuffer(size)
		}


	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		// NOTE: These type checking functions intentionally don't use `instanceof`
		// because it is fragile and can be easily faked with `Object.create()`.

		function isArray(arg) {
		  if (Array.isArray) {
		    return Array.isArray(arg);
		  }
		  return objectToString(arg) === '[object Array]';
		}
		exports.isArray = isArray;

		function isBoolean(arg) {
		  return typeof arg === 'boolean';
		}
		exports.isBoolean = isBoolean;

		function isNull(arg) {
		  return arg === null;
		}
		exports.isNull = isNull;

		function isNullOrUndefined(arg) {
		  return arg == null;
		}
		exports.isNullOrUndefined = isNullOrUndefined;

		function isNumber(arg) {
		  return typeof arg === 'number';
		}
		exports.isNumber = isNumber;

		function isString(arg) {
		  return typeof arg === 'string';
		}
		exports.isString = isString;

		function isSymbol(arg) {
		  return typeof arg === 'symbol';
		}
		exports.isSymbol = isSymbol;

		function isUndefined(arg) {
		  return arg === void 0;
		}
		exports.isUndefined = isUndefined;

		function isRegExp(re) {
		  return objectToString(re) === '[object RegExp]';
		}
		exports.isRegExp = isRegExp;

		function isObject(arg) {
		  return typeof arg === 'object' && arg !== null;
		}
		exports.isObject = isObject;

		function isDate(d) {
		  return objectToString(d) === '[object Date]';
		}
		exports.isDate = isDate;

		function isError(e) {
		  return (objectToString(e) === '[object Error]' || e instanceof Error);
		}
		exports.isError = isError;

		function isFunction(arg) {
		  return typeof arg === 'function';
		}
		exports.isFunction = isFunction;

		function isPrimitive(arg) {
		  return arg === null ||
		         typeof arg === 'boolean' ||
		         typeof arg === 'number' ||
		         typeof arg === 'string' ||
		         typeof arg === 'symbol' ||  // ES6 symbol
		         typeof arg === 'undefined';
		}
		exports.isPrimitive = isPrimitive;

		exports.isBuffer = __webpack_require__(28).Buffer.isBuffer;

		function objectToString(o) {
		  return Object.prototype.toString.call(o);
		}


	/***/ }),
	/* 42 */
	/***/ (function(module, exports) {

		/* (ignored) */

	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {

		'use strict';

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		var Buffer = __webpack_require__(40).Buffer;
		var util = __webpack_require__(44);

		function copyBuffer(src, target, offset) {
		  src.copy(target, offset);
		}

		module.exports = function () {
		  function BufferList() {
		    _classCallCheck(this, BufferList);

		    this.head = null;
		    this.tail = null;
		    this.length = 0;
		  }

		  BufferList.prototype.push = function push(v) {
		    var entry = { data: v, next: null };
		    if (this.length > 0) this.tail.next = entry;else this.head = entry;
		    this.tail = entry;
		    ++this.length;
		  };

		  BufferList.prototype.unshift = function unshift(v) {
		    var entry = { data: v, next: this.head };
		    if (this.length === 0) this.tail = entry;
		    this.head = entry;
		    ++this.length;
		  };

		  BufferList.prototype.shift = function shift() {
		    if (this.length === 0) return;
		    var ret = this.head.data;
		    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
		    --this.length;
		    return ret;
		  };

		  BufferList.prototype.clear = function clear() {
		    this.head = this.tail = null;
		    this.length = 0;
		  };

		  BufferList.prototype.join = function join(s) {
		    if (this.length === 0) return '';
		    var p = this.head;
		    var ret = '' + p.data;
		    while (p = p.next) {
		      ret += s + p.data;
		    }return ret;
		  };

		  BufferList.prototype.concat = function concat(n) {
		    if (this.length === 0) return Buffer.alloc(0);
		    if (this.length === 1) return this.head.data;
		    var ret = Buffer.allocUnsafe(n >>> 0);
		    var p = this.head;
		    var i = 0;
		    while (p) {
		      copyBuffer(p.data, ret, i);
		      i += p.data.length;
		      p = p.next;
		    }
		    return ret;
		  };

		  return BufferList;
		}();

		if (util && util.inspect && util.inspect.custom) {
		  module.exports.prototype[util.inspect.custom] = function () {
		    var obj = util.inspect({ length: this.length });
		    return this.constructor.name + ' ' + obj;
		  };
		}

	/***/ }),
	/* 44 */
	/***/ (function(module, exports) {

		/* (ignored) */

	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {

		'use strict';

		/*<replacement>*/

		var pna = __webpack_require__(38);
		/*</replacement>*/

		// undocumented cb() API, needed for core, not for public API
		function destroy(err, cb) {
		  var _this = this;

		  var readableDestroyed = this._readableState && this._readableState.destroyed;
		  var writableDestroyed = this._writableState && this._writableState.destroyed;

		  if (readableDestroyed || writableDestroyed) {
		    if (cb) {
		      cb(err);
		    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
		      pna.nextTick(emitErrorNT, this, err);
		    }
		    return this;
		  }

		  // we set destroyed to true before firing error callbacks in order
		  // to make it re-entrance safe in case destroy() is called within callbacks

		  if (this._readableState) {
		    this._readableState.destroyed = true;
		  }

		  // if this is a duplex stream mark the writable part as destroyed as well
		  if (this._writableState) {
		    this._writableState.destroyed = true;
		  }

		  this._destroy(err || null, function (err) {
		    if (!cb && err) {
		      pna.nextTick(emitErrorNT, _this, err);
		      if (_this._writableState) {
		        _this._writableState.errorEmitted = true;
		      }
		    } else if (cb) {
		      cb(err);
		    }
		  });

		  return this;
		}

		function undestroy() {
		  if (this._readableState) {
		    this._readableState.destroyed = false;
		    this._readableState.reading = false;
		    this._readableState.ended = false;
		    this._readableState.endEmitted = false;
		  }

		  if (this._writableState) {
		    this._writableState.destroyed = false;
		    this._writableState.ended = false;
		    this._writableState.ending = false;
		    this._writableState.finished = false;
		    this._writableState.errorEmitted = false;
		  }
		}

		function emitErrorNT(self, err) {
		  self.emit('error', err);
		}

		module.exports = {
		  destroy: destroy,
		  undestroy: undestroy
		};

	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		// a duplex stream is just a stream that is both readable and writable.
		// Since JS doesn't have multiple prototypal inheritance, this class
		// prototypally inherits from Readable, and then parasitically from
		// Writable.

		'use strict';

		/*<replacement>*/

		var pna = __webpack_require__(38);
		/*</replacement>*/

		/*<replacement>*/
		var objectKeys = Object.keys || function (obj) {
		  var keys = [];
		  for (var key in obj) {
		    keys.push(key);
		  }return keys;
		};
		/*</replacement>*/

		module.exports = Duplex;

		/*<replacement>*/
		var util = Object.create(__webpack_require__(41));
		util.inherits = __webpack_require__(34);
		/*</replacement>*/

		var Readable = __webpack_require__(36);
		var Writable = __webpack_require__(47);

		util.inherits(Duplex, Readable);

		{
		  // avoid scope creep, the keys array can then be collected
		  var keys = objectKeys(Writable.prototype);
		  for (var v = 0; v < keys.length; v++) {
		    var method = keys[v];
		    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
		  }
		}

		function Duplex(options) {
		  if (!(this instanceof Duplex)) return new Duplex(options);

		  Readable.call(this, options);
		  Writable.call(this, options);

		  if (options && options.readable === false) this.readable = false;

		  if (options && options.writable === false) this.writable = false;

		  this.allowHalfOpen = true;
		  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

		  this.once('end', onend);
		}

		Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function () {
		    return this._writableState.highWaterMark;
		  }
		});

		// the no-half-open enforcer
		function onend() {
		  // if we allow half-open state, or if the writable side ended,
		  // then we're ok.
		  if (this.allowHalfOpen || this._writableState.ended) return;

		  // no more data can be written.
		  // But allow more writes to happen in this tick.
		  pna.nextTick(onEndNT, this);
		}

		function onEndNT(self) {
		  self.end();
		}

		Object.defineProperty(Duplex.prototype, 'destroyed', {
		  get: function () {
		    if (this._readableState === undefined || this._writableState === undefined) {
		      return false;
		    }
		    return this._readableState.destroyed && this._writableState.destroyed;
		  },
		  set: function (value) {
		    // we ignore the value if the stream
		    // has not been initialized yet
		    if (this._readableState === undefined || this._writableState === undefined) {
		      return;
		    }

		    // backward compatibility, the user is explicitly
		    // managing destroyed
		    this._readableState.destroyed = value;
		    this._writableState.destroyed = value;
		  }
		});

		Duplex.prototype._destroy = function (err, cb) {
		  this.push(null);
		  this.end();

		  pna.nextTick(cb, err);
		};

	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		// A bit simpler than readable streams.
		// Implement an async ._write(chunk, encoding, cb), and it'll handle all
		// the drain event emission and buffering.

		'use strict';

		/*<replacement>*/

		var pna = __webpack_require__(38);
		/*</replacement>*/

		module.exports = Writable;

		/* <replacement> */
		function WriteReq(chunk, encoding, cb) {
		  this.chunk = chunk;
		  this.encoding = encoding;
		  this.callback = cb;
		  this.next = null;
		}

		// It seems a linked list but it is not
		// there will be only 2 of these for each stream
		function CorkedRequest(state) {
		  var _this = this;

		  this.next = null;
		  this.entry = null;
		  this.finish = function () {
		    onCorkedFinish(_this, state);
		  };
		}
		/* </replacement> */

		/*<replacement>*/
		var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
		/*</replacement>*/

		/*<replacement>*/
		var Duplex;
		/*</replacement>*/

		Writable.WritableState = WritableState;

		/*<replacement>*/
		var util = Object.create(__webpack_require__(41));
		util.inherits = __webpack_require__(34);
		/*</replacement>*/

		/*<replacement>*/
		var internalUtil = {
		  deprecate: __webpack_require__(50)
		};
		/*</replacement>*/

		/*<replacement>*/
		var Stream = __webpack_require__(39);
		/*</replacement>*/

		/*<replacement>*/

		var Buffer = __webpack_require__(40).Buffer;
		var OurUint8Array = global.Uint8Array || function () {};
		function _uint8ArrayToBuffer(chunk) {
		  return Buffer.from(chunk);
		}
		function _isUint8Array(obj) {
		  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
		}

		/*</replacement>*/

		var destroyImpl = __webpack_require__(45);

		util.inherits(Writable, Stream);

		function nop() {}

		function WritableState(options, stream) {
		  Duplex = Duplex || __webpack_require__(46);

		  options = options || {};

		  // Duplex streams are both readable and writable, but share
		  // the same options object.
		  // However, some cases require setting options to different
		  // values for the readable and the writable sides of the duplex stream.
		  // These options can be provided separately as readableXXX and writableXXX.
		  var isDuplex = stream instanceof Duplex;

		  // object stream flag to indicate whether or not this stream
		  // contains buffers or objects.
		  this.objectMode = !!options.objectMode;

		  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

		  // the point at which write() starts returning false
		  // Note: 0 is a valid value, means that we always return false if
		  // the entire buffer is not flushed immediately on write()
		  var hwm = options.highWaterMark;
		  var writableHwm = options.writableHighWaterMark;
		  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

		  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

		  // cast to ints.
		  this.highWaterMark = Math.floor(this.highWaterMark);

		  // if _final has been called
		  this.finalCalled = false;

		  // drain event flag.
		  this.needDrain = false;
		  // at the start of calling end()
		  this.ending = false;
		  // when end() has been called, and returned
		  this.ended = false;
		  // when 'finish' is emitted
		  this.finished = false;

		  // has it been destroyed
		  this.destroyed = false;

		  // should we decode strings into buffers before passing to _write?
		  // this is here so that some node-core streams can optimize string
		  // handling at a lower level.
		  var noDecode = options.decodeStrings === false;
		  this.decodeStrings = !noDecode;

		  // Crypto is kind of old and crusty.  Historically, its default string
		  // encoding is 'binary' so we have to make this configurable.
		  // Everything else in the universe uses 'utf8', though.
		  this.defaultEncoding = options.defaultEncoding || 'utf8';

		  // not an actual buffer we keep track of, but a measurement
		  // of how much we're waiting to get pushed to some underlying
		  // socket or file.
		  this.length = 0;

		  // a flag to see when we're in the middle of a write.
		  this.writing = false;

		  // when true all writes will be buffered until .uncork() call
		  this.corked = 0;

		  // a flag to be able to tell if the onwrite cb is called immediately,
		  // or on a later tick.  We set this to true at first, because any
		  // actions that shouldn't happen until "later" should generally also
		  // not happen before the first write call.
		  this.sync = true;

		  // a flag to know if we're processing previously buffered items, which
		  // may call the _write() callback in the same tick, so that we don't
		  // end up in an overlapped onwrite situation.
		  this.bufferProcessing = false;

		  // the callback that's passed to _write(chunk,cb)
		  this.onwrite = function (er) {
		    onwrite(stream, er);
		  };

		  // the callback that the user supplies to write(chunk,encoding,cb)
		  this.writecb = null;

		  // the amount that is being written when _write is called.
		  this.writelen = 0;

		  this.bufferedRequest = null;
		  this.lastBufferedRequest = null;

		  // number of pending user-supplied write callbacks
		  // this must be 0 before 'finish' can be emitted
		  this.pendingcb = 0;

		  // emit prefinish if the only thing we're waiting for is _write cbs
		  // This is relevant for synchronous Transform streams
		  this.prefinished = false;

		  // True if the error was already emitted and should not be thrown again
		  this.errorEmitted = false;

		  // count buffered requests
		  this.bufferedRequestCount = 0;

		  // allocate the first CorkedRequest, there is always
		  // one allocated and free to use, and we maintain at most two
		  this.corkedRequestsFree = new CorkedRequest(this);
		}

		WritableState.prototype.getBuffer = function getBuffer() {
		  var current = this.bufferedRequest;
		  var out = [];
		  while (current) {
		    out.push(current);
		    current = current.next;
		  }
		  return out;
		};

		(function () {
		  try {
		    Object.defineProperty(WritableState.prototype, 'buffer', {
		      get: internalUtil.deprecate(function () {
		        return this.getBuffer();
		      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
		    });
		  } catch (_) {}
		})();

		// Test _writableState for inheritance to account for Duplex streams,
		// whose prototype chain only points to Readable.
		var realHasInstance;
		if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
		  realHasInstance = Function.prototype[Symbol.hasInstance];
		  Object.defineProperty(Writable, Symbol.hasInstance, {
		    value: function (object) {
		      if (realHasInstance.call(this, object)) return true;
		      if (this !== Writable) return false;

		      return object && object._writableState instanceof WritableState;
		    }
		  });
		} else {
		  realHasInstance = function (object) {
		    return object instanceof this;
		  };
		}

		function Writable(options) {
		  Duplex = Duplex || __webpack_require__(46);

		  // Writable ctor is applied to Duplexes, too.
		  // `realHasInstance` is necessary because using plain `instanceof`
		  // would return false, as no `_writableState` property is attached.

		  // Trying to use the custom `instanceof` for Writable here will also break the
		  // Node.js LazyTransform implementation, which has a non-trivial getter for
		  // `_writableState` that would lead to infinite recursion.
		  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
		    return new Writable(options);
		  }

		  this._writableState = new WritableState(options, this);

		  // legacy.
		  this.writable = true;

		  if (options) {
		    if (typeof options.write === 'function') this._write = options.write;

		    if (typeof options.writev === 'function') this._writev = options.writev;

		    if (typeof options.destroy === 'function') this._destroy = options.destroy;

		    if (typeof options.final === 'function') this._final = options.final;
		  }

		  Stream.call(this);
		}

		// Otherwise people can pipe Writable streams, which is just wrong.
		Writable.prototype.pipe = function () {
		  this.emit('error', new Error('Cannot pipe, not readable'));
		};

		function writeAfterEnd(stream, cb) {
		  var er = new Error('write after end');
		  // TODO: defer error events consistently everywhere, not just the cb
		  stream.emit('error', er);
		  pna.nextTick(cb, er);
		}

		// Checks that a user-supplied chunk is valid, especially for the particular
		// mode the stream is in. Currently this means that `null` is never accepted
		// and undefined/non-string values are only allowed in object mode.
		function validChunk(stream, state, chunk, cb) {
		  var valid = true;
		  var er = false;

		  if (chunk === null) {
		    er = new TypeError('May not write null values to stream');
		  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
		    er = new TypeError('Invalid non-string/buffer chunk');
		  }
		  if (er) {
		    stream.emit('error', er);
		    pna.nextTick(cb, er);
		    valid = false;
		  }
		  return valid;
		}

		Writable.prototype.write = function (chunk, encoding, cb) {
		  var state = this._writableState;
		  var ret = false;
		  var isBuf = !state.objectMode && _isUint8Array(chunk);

		  if (isBuf && !Buffer.isBuffer(chunk)) {
		    chunk = _uint8ArrayToBuffer(chunk);
		  }

		  if (typeof encoding === 'function') {
		    cb = encoding;
		    encoding = null;
		  }

		  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

		  if (typeof cb !== 'function') cb = nop;

		  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
		    state.pendingcb++;
		    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
		  }

		  return ret;
		};

		Writable.prototype.cork = function () {
		  var state = this._writableState;

		  state.corked++;
		};

		Writable.prototype.uncork = function () {
		  var state = this._writableState;

		  if (state.corked) {
		    state.corked--;

		    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
		  }
		};

		Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
		  // node::ParseEncoding() requires lower case.
		  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
		  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
		  this._writableState.defaultEncoding = encoding;
		  return this;
		};

		function decodeChunk(state, chunk, encoding) {
		  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
		    chunk = Buffer.from(chunk, encoding);
		  }
		  return chunk;
		}

		Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function () {
		    return this._writableState.highWaterMark;
		  }
		});

		// if we're already writing something, then just put this
		// in the queue, and wait our turn.  Otherwise, call _write
		// If we return false, then we need a drain event, so set that flag.
		function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
		  if (!isBuf) {
		    var newChunk = decodeChunk(state, chunk, encoding);
		    if (chunk !== newChunk) {
		      isBuf = true;
		      encoding = 'buffer';
		      chunk = newChunk;
		    }
		  }
		  var len = state.objectMode ? 1 : chunk.length;

		  state.length += len;

		  var ret = state.length < state.highWaterMark;
		  // we must ensure that previous needDrain will not be reset to false.
		  if (!ret) state.needDrain = true;

		  if (state.writing || state.corked) {
		    var last = state.lastBufferedRequest;
		    state.lastBufferedRequest = {
		      chunk: chunk,
		      encoding: encoding,
		      isBuf: isBuf,
		      callback: cb,
		      next: null
		    };
		    if (last) {
		      last.next = state.lastBufferedRequest;
		    } else {
		      state.bufferedRequest = state.lastBufferedRequest;
		    }
		    state.bufferedRequestCount += 1;
		  } else {
		    doWrite(stream, state, false, len, chunk, encoding, cb);
		  }

		  return ret;
		}

		function doWrite(stream, state, writev, len, chunk, encoding, cb) {
		  state.writelen = len;
		  state.writecb = cb;
		  state.writing = true;
		  state.sync = true;
		  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
		  state.sync = false;
		}

		function onwriteError(stream, state, sync, er, cb) {
		  --state.pendingcb;

		  if (sync) {
		    // defer the callback if we are being called synchronously
		    // to avoid piling up things on the stack
		    pna.nextTick(cb, er);
		    // this can emit finish, and it will always happen
		    // after error
		    pna.nextTick(finishMaybe, stream, state);
		    stream._writableState.errorEmitted = true;
		    stream.emit('error', er);
		  } else {
		    // the caller expect this to happen before if
		    // it is async
		    cb(er);
		    stream._writableState.errorEmitted = true;
		    stream.emit('error', er);
		    // this can emit finish, but finish must
		    // always follow error
		    finishMaybe(stream, state);
		  }
		}

		function onwriteStateUpdate(state) {
		  state.writing = false;
		  state.writecb = null;
		  state.length -= state.writelen;
		  state.writelen = 0;
		}

		function onwrite(stream, er) {
		  var state = stream._writableState;
		  var sync = state.sync;
		  var cb = state.writecb;

		  onwriteStateUpdate(state);

		  if (er) onwriteError(stream, state, sync, er, cb);else {
		    // Check if we're actually ready to finish, but don't emit yet
		    var finished = needFinish(state);

		    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
		      clearBuffer(stream, state);
		    }

		    if (sync) {
		      /*<replacement>*/
		      asyncWrite(afterWrite, stream, state, finished, cb);
		      /*</replacement>*/
		    } else {
		      afterWrite(stream, state, finished, cb);
		    }
		  }
		}

		function afterWrite(stream, state, finished, cb) {
		  if (!finished) onwriteDrain(stream, state);
		  state.pendingcb--;
		  cb();
		  finishMaybe(stream, state);
		}

		// Must force callback to be called on nextTick, so that we don't
		// emit 'drain' before the write() consumer gets the 'false' return
		// value, and has a chance to attach a 'drain' listener.
		function onwriteDrain(stream, state) {
		  if (state.length === 0 && state.needDrain) {
		    state.needDrain = false;
		    stream.emit('drain');
		  }
		}

		// if there's something in the buffer waiting, then process it
		function clearBuffer(stream, state) {
		  state.bufferProcessing = true;
		  var entry = state.bufferedRequest;

		  if (stream._writev && entry && entry.next) {
		    // Fast case, write everything using _writev()
		    var l = state.bufferedRequestCount;
		    var buffer = new Array(l);
		    var holder = state.corkedRequestsFree;
		    holder.entry = entry;

		    var count = 0;
		    var allBuffers = true;
		    while (entry) {
		      buffer[count] = entry;
		      if (!entry.isBuf) allBuffers = false;
		      entry = entry.next;
		      count += 1;
		    }
		    buffer.allBuffers = allBuffers;

		    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

		    // doWrite is almost always async, defer these to save a bit of time
		    // as the hot path ends with doWrite
		    state.pendingcb++;
		    state.lastBufferedRequest = null;
		    if (holder.next) {
		      state.corkedRequestsFree = holder.next;
		      holder.next = null;
		    } else {
		      state.corkedRequestsFree = new CorkedRequest(state);
		    }
		    state.bufferedRequestCount = 0;
		  } else {
		    // Slow case, write chunks one-by-one
		    while (entry) {
		      var chunk = entry.chunk;
		      var encoding = entry.encoding;
		      var cb = entry.callback;
		      var len = state.objectMode ? 1 : chunk.length;

		      doWrite(stream, state, false, len, chunk, encoding, cb);
		      entry = entry.next;
		      state.bufferedRequestCount--;
		      // if we didn't call the onwrite immediately, then
		      // it means that we need to wait until it does.
		      // also, that means that the chunk and cb are currently
		      // being processed, so move the buffer counter past them.
		      if (state.writing) {
		        break;
		      }
		    }

		    if (entry === null) state.lastBufferedRequest = null;
		  }

		  state.bufferedRequest = entry;
		  state.bufferProcessing = false;
		}

		Writable.prototype._write = function (chunk, encoding, cb) {
		  cb(new Error('_write() is not implemented'));
		};

		Writable.prototype._writev = null;

		Writable.prototype.end = function (chunk, encoding, cb) {
		  var state = this._writableState;

		  if (typeof chunk === 'function') {
		    cb = chunk;
		    chunk = null;
		    encoding = null;
		  } else if (typeof encoding === 'function') {
		    cb = encoding;
		    encoding = null;
		  }

		  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

		  // .end() fully uncorks
		  if (state.corked) {
		    state.corked = 1;
		    this.uncork();
		  }

		  // ignore unnecessary end() calls.
		  if (!state.ending && !state.finished) endWritable(this, state, cb);
		};

		function needFinish(state) {
		  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
		}
		function callFinal(stream, state) {
		  stream._final(function (err) {
		    state.pendingcb--;
		    if (err) {
		      stream.emit('error', err);
		    }
		    state.prefinished = true;
		    stream.emit('prefinish');
		    finishMaybe(stream, state);
		  });
		}
		function prefinish(stream, state) {
		  if (!state.prefinished && !state.finalCalled) {
		    if (typeof stream._final === 'function') {
		      state.pendingcb++;
		      state.finalCalled = true;
		      pna.nextTick(callFinal, stream, state);
		    } else {
		      state.prefinished = true;
		      stream.emit('prefinish');
		    }
		  }
		}

		function finishMaybe(stream, state) {
		  var need = needFinish(state);
		  if (need) {
		    prefinish(stream, state);
		    if (state.pendingcb === 0) {
		      state.finished = true;
		      stream.emit('finish');
		    }
		  }
		  return need;
		}

		function endWritable(stream, state, cb) {
		  state.ending = true;
		  finishMaybe(stream, state);
		  if (cb) {
		    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
		  }
		  state.ended = true;
		  stream.writable = false;
		}

		function onCorkedFinish(corkReq, state, err) {
		  var entry = corkReq.entry;
		  corkReq.entry = null;
		  while (entry) {
		    var cb = entry.callback;
		    state.pendingcb--;
		    cb(err);
		    entry = entry.next;
		  }
		  if (state.corkedRequestsFree) {
		    state.corkedRequestsFree.next = corkReq;
		  } else {
		    state.corkedRequestsFree = corkReq;
		  }
		}

		Object.defineProperty(Writable.prototype, 'destroyed', {
		  get: function () {
		    if (this._writableState === undefined) {
		      return false;
		    }
		    return this._writableState.destroyed;
		  },
		  set: function (value) {
		    // we ignore the value if the stream
		    // has not been initialized yet
		    if (!this._writableState) {
		      return;
		    }

		    // backward compatibility, the user is explicitly
		    // managing destroyed
		    this._writableState.destroyed = value;
		  }
		});

		Writable.prototype.destroy = destroyImpl.destroy;
		Writable.prototype._undestroy = destroyImpl.undestroy;
		Writable.prototype._destroy = function (err, cb) {
		  this.end();
		  cb(err);
		};
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(48).setImmediate, (function() { return this; }())))

	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
		            (typeof self !== "undefined" && self) ||
		            window;
		var apply = Function.prototype.apply;

		// DOM APIs, for completeness

		exports.setTimeout = function() {
		  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
		};
		exports.setInterval = function() {
		  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
		};
		exports.clearTimeout =
		exports.clearInterval = function(timeout) {
		  if (timeout) {
		    timeout.close();
		  }
		};

		function Timeout(id, clearFn) {
		  this._id = id;
		  this._clearFn = clearFn;
		}
		Timeout.prototype.unref = Timeout.prototype.ref = function() {};
		Timeout.prototype.close = function() {
		  this._clearFn.call(scope, this._id);
		};

		// Does not start the time, just sets up the members needed.
		exports.enroll = function(item, msecs) {
		  clearTimeout(item._idleTimeoutId);
		  item._idleTimeout = msecs;
		};

		exports.unenroll = function(item) {
		  clearTimeout(item._idleTimeoutId);
		  item._idleTimeout = -1;
		};

		exports._unrefActive = exports.active = function(item) {
		  clearTimeout(item._idleTimeoutId);

		  var msecs = item._idleTimeout;
		  if (msecs >= 0) {
		    item._idleTimeoutId = setTimeout(function onTimeout() {
		      if (item._onTimeout)
		        item._onTimeout();
		    }, msecs);
		  }
		};

		// setimmediate attaches itself to the global object
		__webpack_require__(49);
		// On some exotic environments, it's not clear which object `setimmediate` was
		// able to install onto.  Search each possibility in the same order as the
		// `setimmediate` library.
		exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
		                       (typeof global !== "undefined" && global.setImmediate) ||
		                       (this && this.setImmediate);
		exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
		                         (typeof global !== "undefined" && global.clearImmediate) ||
		                         (this && this.clearImmediate);

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {

		/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
		    "use strict";

		    if (global.setImmediate) {
		        return;
		    }

		    var nextHandle = 1; // Spec says greater than zero
		    var tasksByHandle = {};
		    var currentlyRunningATask = false;
		    var doc = global.document;
		    var registerImmediate;

		    function setImmediate(callback) {
		      // Callback can either be a function or a string
		      if (typeof callback !== "function") {
		        callback = new Function("" + callback);
		      }
		      // Copy function arguments
		      var args = new Array(arguments.length - 1);
		      for (var i = 0; i < args.length; i++) {
		          args[i] = arguments[i + 1];
		      }
		      // Store and register the task
		      var task = { callback: callback, args: args };
		      tasksByHandle[nextHandle] = task;
		      registerImmediate(nextHandle);
		      return nextHandle++;
		    }

		    function clearImmediate(handle) {
		        delete tasksByHandle[handle];
		    }

		    function run(task) {
		        var callback = task.callback;
		        var args = task.args;
		        switch (args.length) {
		        case 0:
		            callback();
		            break;
		        case 1:
		            callback(args[0]);
		            break;
		        case 2:
		            callback(args[0], args[1]);
		            break;
		        case 3:
		            callback(args[0], args[1], args[2]);
		            break;
		        default:
		            callback.apply(undefined, args);
		            break;
		        }
		    }

		    function runIfPresent(handle) {
		        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
		        // So if we're currently running a task, we'll need to delay this invocation.
		        if (currentlyRunningATask) {
		            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
		            // "too much recursion" error.
		            setTimeout(runIfPresent, 0, handle);
		        } else {
		            var task = tasksByHandle[handle];
		            if (task) {
		                currentlyRunningATask = true;
		                try {
		                    run(task);
		                } finally {
		                    clearImmediate(handle);
		                    currentlyRunningATask = false;
		                }
		            }
		        }
		    }

		    function installNextTickImplementation() {
		        registerImmediate = function(handle) {
		            process.nextTick(function () { runIfPresent(handle); });
		        };
		    }

		    function canUsePostMessage() {
		        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
		        // where `global.postMessage` means something completely different and can't be used for this purpose.
		        if (global.postMessage && !global.importScripts) {
		            var postMessageIsAsynchronous = true;
		            var oldOnMessage = global.onmessage;
		            global.onmessage = function() {
		                postMessageIsAsynchronous = false;
		            };
		            global.postMessage("", "*");
		            global.onmessage = oldOnMessage;
		            return postMessageIsAsynchronous;
		        }
		    }

		    function installPostMessageImplementation() {
		        // Installs an event handler on `global` for the `message` event: see
		        // * https://developer.mozilla.org/en/DOM/window.postMessage
		        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

		        var messagePrefix = "setImmediate$" + Math.random() + "$";
		        var onGlobalMessage = function(event) {
		            if (event.source === global &&
		                typeof event.data === "string" &&
		                event.data.indexOf(messagePrefix) === 0) {
		                runIfPresent(+event.data.slice(messagePrefix.length));
		            }
		        };

		        if (global.addEventListener) {
		            global.addEventListener("message", onGlobalMessage, false);
		        } else {
		            global.attachEvent("onmessage", onGlobalMessage);
		        }

		        registerImmediate = function(handle) {
		            global.postMessage(messagePrefix + handle, "*");
		        };
		    }

		    function installMessageChannelImplementation() {
		        var channel = new MessageChannel();
		        channel.port1.onmessage = function(event) {
		            var handle = event.data;
		            runIfPresent(handle);
		        };

		        registerImmediate = function(handle) {
		            channel.port2.postMessage(handle);
		        };
		    }

		    function installReadyStateChangeImplementation() {
		        var html = doc.documentElement;
		        registerImmediate = function(handle) {
		            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
		            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
		            var script = doc.createElement("script");
		            script.onreadystatechange = function () {
		                runIfPresent(handle);
		                script.onreadystatechange = null;
		                html.removeChild(script);
		                script = null;
		            };
		            html.appendChild(script);
		        };
		    }

		    function installSetTimeoutImplementation() {
		        registerImmediate = function(handle) {
		            setTimeout(runIfPresent, 0, handle);
		        };
		    }

		    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
		    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
		    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

		    // Don't get fooled by e.g. browserify environments.
		    if ({}.toString.call(global.process) === "[object process]") {
		        // For Node.js before 0.9
		        installNextTickImplementation();

		    } else if (canUsePostMessage()) {
		        // For non-IE10 modern browsers
		        installPostMessageImplementation();

		    } else if (global.MessageChannel) {
		        // For web workers, where supported
		        installMessageChannelImplementation();

		    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
		        // For IE 6–8
		        installReadyStateChangeImplementation();

		    } else {
		        // For older browsers
		        installSetTimeoutImplementation();
		    }

		    attachTo.setImmediate = setImmediate;
		    attachTo.clearImmediate = clearImmediate;
		}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)))

	/***/ }),
	/* 50 */
	/***/ (function(module, exports) {

		/* WEBPACK VAR INJECTION */(function(global) {
		/**
		 * Module exports.
		 */

		module.exports = deprecate;

		/**
		 * Mark that a method should not be used.
		 * Returns a modified function which warns once by default.
		 *
		 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
		 *
		 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
		 * will throw an Error when invoked.
		 *
		 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
		 * will invoke `console.trace()` instead of `console.error()`.
		 *
		 * @param {Function} fn - the function to deprecate
		 * @param {String} msg - the string to print to the console when `fn` is invoked
		 * @returns {Function} a new "deprecated" version of `fn`
		 * @api public
		 */

		function deprecate (fn, msg) {
		  if (config('noDeprecation')) {
		    return fn;
		  }

		  var warned = false;
		  function deprecated() {
		    if (!warned) {
		      if (config('throwDeprecation')) {
		        throw new Error(msg);
		      } else if (config('traceDeprecation')) {
		        console.trace(msg);
		      } else {
		        console.warn(msg);
		      }
		      warned = true;
		    }
		    return fn.apply(this, arguments);
		  }

		  return deprecated;
		}

		/**
		 * Checks `localStorage` for boolean values for the given `name`.
		 *
		 * @param {String} name
		 * @returns {Boolean}
		 * @api private
		 */

		function config (name) {
		  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
		  try {
		    if (!global.localStorage) return false;
		  } catch (_) {
		    return false;
		  }
		  var val = global.localStorage[name];
		  if (null == val) return false;
		  return String(val).toLowerCase() === 'true';
		}

		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		'use strict';

		/*<replacement>*/

		var Buffer = __webpack_require__(40).Buffer;
		/*</replacement>*/

		var isEncoding = Buffer.isEncoding || function (encoding) {
		  encoding = '' + encoding;
		  switch (encoding && encoding.toLowerCase()) {
		    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
		      return true;
		    default:
		      return false;
		  }
		};

		function _normalizeEncoding(enc) {
		  if (!enc) return 'utf8';
		  var retried;
		  while (true) {
		    switch (enc) {
		      case 'utf8':
		      case 'utf-8':
		        return 'utf8';
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return 'utf16le';
		      case 'latin1':
		      case 'binary':
		        return 'latin1';
		      case 'base64':
		      case 'ascii':
		      case 'hex':
		        return enc;
		      default:
		        if (retried) return; // undefined
		        enc = ('' + enc).toLowerCase();
		        retried = true;
		    }
		  }
		};

		// Do not cache `Buffer.isEncoding` when checking encoding names as some
		// modules monkey-patch it to support additional encodings
		function normalizeEncoding(enc) {
		  var nenc = _normalizeEncoding(enc);
		  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
		  return nenc || enc;
		}

		// StringDecoder provides an interface for efficiently splitting a series of
		// buffers into a series of JS strings without breaking apart multi-byte
		// characters.
		exports.StringDecoder = StringDecoder;
		function StringDecoder(encoding) {
		  this.encoding = normalizeEncoding(encoding);
		  var nb;
		  switch (this.encoding) {
		    case 'utf16le':
		      this.text = utf16Text;
		      this.end = utf16End;
		      nb = 4;
		      break;
		    case 'utf8':
		      this.fillLast = utf8FillLast;
		      nb = 4;
		      break;
		    case 'base64':
		      this.text = base64Text;
		      this.end = base64End;
		      nb = 3;
		      break;
		    default:
		      this.write = simpleWrite;
		      this.end = simpleEnd;
		      return;
		  }
		  this.lastNeed = 0;
		  this.lastTotal = 0;
		  this.lastChar = Buffer.allocUnsafe(nb);
		}

		StringDecoder.prototype.write = function (buf) {
		  if (buf.length === 0) return '';
		  var r;
		  var i;
		  if (this.lastNeed) {
		    r = this.fillLast(buf);
		    if (r === undefined) return '';
		    i = this.lastNeed;
		    this.lastNeed = 0;
		  } else {
		    i = 0;
		  }
		  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
		  return r || '';
		};

		StringDecoder.prototype.end = utf8End;

		// Returns only complete characters in a Buffer
		StringDecoder.prototype.text = utf8Text;

		// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
		StringDecoder.prototype.fillLast = function (buf) {
		  if (this.lastNeed <= buf.length) {
		    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
		    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
		  }
		  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
		  this.lastNeed -= buf.length;
		};

		// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
		// continuation byte. If an invalid byte is detected, -2 is returned.
		function utf8CheckByte(byte) {
		  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
		  return byte >> 6 === 0x02 ? -1 : -2;
		}

		// Checks at most 3 bytes at the end of a Buffer in order to detect an
		// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
		// needed to complete the UTF-8 character (if applicable) are returned.
		function utf8CheckIncomplete(self, buf, i) {
		  var j = buf.length - 1;
		  if (j < i) return 0;
		  var nb = utf8CheckByte(buf[j]);
		  if (nb >= 0) {
		    if (nb > 0) self.lastNeed = nb - 1;
		    return nb;
		  }
		  if (--j < i || nb === -2) return 0;
		  nb = utf8CheckByte(buf[j]);
		  if (nb >= 0) {
		    if (nb > 0) self.lastNeed = nb - 2;
		    return nb;
		  }
		  if (--j < i || nb === -2) return 0;
		  nb = utf8CheckByte(buf[j]);
		  if (nb >= 0) {
		    if (nb > 0) {
		      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
		    }
		    return nb;
		  }
		  return 0;
		}

		// Validates as many continuation bytes for a multi-byte UTF-8 character as
		// needed or are available. If we see a non-continuation byte where we expect
		// one, we "replace" the validated continuation bytes we've seen so far with
		// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
		// behavior. The continuation byte check is included three times in the case
		// where all of the continuation bytes for a character exist in the same buffer.
		// It is also done this way as a slight performance increase instead of using a
		// loop.
		function utf8CheckExtraBytes(self, buf, p) {
		  if ((buf[0] & 0xC0) !== 0x80) {
		    self.lastNeed = 0;
		    return '\ufffd';
		  }
		  if (self.lastNeed > 1 && buf.length > 1) {
		    if ((buf[1] & 0xC0) !== 0x80) {
		      self.lastNeed = 1;
		      return '\ufffd';
		    }
		    if (self.lastNeed > 2 && buf.length > 2) {
		      if ((buf[2] & 0xC0) !== 0x80) {
		        self.lastNeed = 2;
		        return '\ufffd';
		      }
		    }
		  }
		}

		// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
		function utf8FillLast(buf) {
		  var p = this.lastTotal - this.lastNeed;
		  var r = utf8CheckExtraBytes(this, buf, p);
		  if (r !== undefined) return r;
		  if (this.lastNeed <= buf.length) {
		    buf.copy(this.lastChar, p, 0, this.lastNeed);
		    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
		  }
		  buf.copy(this.lastChar, p, 0, buf.length);
		  this.lastNeed -= buf.length;
		}

		// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
		// partial character, the character's bytes are buffered until the required
		// number of bytes are available.
		function utf8Text(buf, i) {
		  var total = utf8CheckIncomplete(this, buf, i);
		  if (!this.lastNeed) return buf.toString('utf8', i);
		  this.lastTotal = total;
		  var end = buf.length - (total - this.lastNeed);
		  buf.copy(this.lastChar, 0, end);
		  return buf.toString('utf8', i, end);
		}

		// For UTF-8, a replacement character is added when ending on a partial
		// character.
		function utf8End(buf) {
		  var r = buf && buf.length ? this.write(buf) : '';
		  if (this.lastNeed) return r + '\ufffd';
		  return r;
		}

		// UTF-16LE typically needs two bytes per character, but even if we have an even
		// number of bytes available, we need to check if we end on a leading/high
		// surrogate. In that case, we need to wait for the next two bytes in order to
		// decode the last character properly.
		function utf16Text(buf, i) {
		  if ((buf.length - i) % 2 === 0) {
		    var r = buf.toString('utf16le', i);
		    if (r) {
		      var c = r.charCodeAt(r.length - 1);
		      if (c >= 0xD800 && c <= 0xDBFF) {
		        this.lastNeed = 2;
		        this.lastTotal = 4;
		        this.lastChar[0] = buf[buf.length - 2];
		        this.lastChar[1] = buf[buf.length - 1];
		        return r.slice(0, -1);
		      }
		    }
		    return r;
		  }
		  this.lastNeed = 1;
		  this.lastTotal = 2;
		  this.lastChar[0] = buf[buf.length - 1];
		  return buf.toString('utf16le', i, buf.length - 1);
		}

		// For UTF-16LE we do not explicitly append special replacement characters if we
		// end on a partial character, we simply let v8 handle that.
		function utf16End(buf) {
		  var r = buf && buf.length ? this.write(buf) : '';
		  if (this.lastNeed) {
		    var end = this.lastTotal - this.lastNeed;
		    return r + this.lastChar.toString('utf16le', 0, end);
		  }
		  return r;
		}

		function base64Text(buf, i) {
		  var n = (buf.length - i) % 3;
		  if (n === 0) return buf.toString('base64', i);
		  this.lastNeed = 3 - n;
		  this.lastTotal = 3;
		  if (n === 1) {
		    this.lastChar[0] = buf[buf.length - 1];
		  } else {
		    this.lastChar[0] = buf[buf.length - 2];
		    this.lastChar[1] = buf[buf.length - 1];
		  }
		  return buf.toString('base64', i, buf.length - n);
		}

		function base64End(buf) {
		  var r = buf && buf.length ? this.write(buf) : '';
		  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
		  return r;
		}

		// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
		function simpleWrite(buf) {
		  return buf.toString(this.encoding);
		}

		function simpleEnd(buf) {
		  return buf && buf.length ? this.write(buf) : '';
		}

	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		// a transform stream is a readable/writable stream where you do
		// something with the data.  Sometimes it's called a "filter",
		// but that's not a great name for it, since that implies a thing where
		// some bits pass through, and others are simply ignored.  (That would
		// be a valid example of a transform, of course.)
		//
		// While the output is causally related to the input, it's not a
		// necessarily symmetric or synchronous transformation.  For example,
		// a zlib stream might take multiple plain-text writes(), and then
		// emit a single compressed chunk some time in the future.
		//
		// Here's how this works:
		//
		// The Transform stream has all the aspects of the readable and writable
		// stream classes.  When you write(chunk), that calls _write(chunk,cb)
		// internally, and returns false if there's a lot of pending writes
		// buffered up.  When you call read(), that calls _read(n) until
		// there's enough pending readable data buffered up.
		//
		// In a transform stream, the written data is placed in a buffer.  When
		// _read(n) is called, it transforms the queued up data, calling the
		// buffered _write cb's as it consumes chunks.  If consuming a single
		// written chunk would result in multiple output chunks, then the first
		// outputted bit calls the readcb, and subsequent chunks just go into
		// the read buffer, and will cause it to emit 'readable' if necessary.
		//
		// This way, back-pressure is actually determined by the reading side,
		// since _read has to be called to start processing a new chunk.  However,
		// a pathological inflate type of transform can cause excessive buffering
		// here.  For example, imagine a stream where every byte of input is
		// interpreted as an integer from 0-255, and then results in that many
		// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
		// 1kb of data being output.  In this case, you could write a very small
		// amount of input, and end up with a very large amount of output.  In
		// such a pathological inflating mechanism, there'd be no way to tell
		// the system to stop doing the transform.  A single 4MB write could
		// cause the system to run out of memory.
		//
		// However, even in such a pathological case, only a single written chunk
		// would be consumed, and then the rest would wait (un-transformed) until
		// the results of the previous transformed chunk were consumed.

		'use strict';

		module.exports = Transform;

		var Duplex = __webpack_require__(46);

		/*<replacement>*/
		var util = Object.create(__webpack_require__(41));
		util.inherits = __webpack_require__(34);
		/*</replacement>*/

		util.inherits(Transform, Duplex);

		function afterTransform(er, data) {
		  var ts = this._transformState;
		  ts.transforming = false;

		  var cb = ts.writecb;

		  if (!cb) {
		    return this.emit('error', new Error('write callback called multiple times'));
		  }

		  ts.writechunk = null;
		  ts.writecb = null;

		  if (data != null) // single equals check for both `null` and `undefined`
		    this.push(data);

		  cb(er);

		  var rs = this._readableState;
		  rs.reading = false;
		  if (rs.needReadable || rs.length < rs.highWaterMark) {
		    this._read(rs.highWaterMark);
		  }
		}

		function Transform(options) {
		  if (!(this instanceof Transform)) return new Transform(options);

		  Duplex.call(this, options);

		  this._transformState = {
		    afterTransform: afterTransform.bind(this),
		    needTransform: false,
		    transforming: false,
		    writecb: null,
		    writechunk: null,
		    writeencoding: null
		  };

		  // start out asking for a readable event once data is transformed.
		  this._readableState.needReadable = true;

		  // we have implemented the _read method, and done the other things
		  // that Readable wants before the first _read call, so unset the
		  // sync guard flag.
		  this._readableState.sync = false;

		  if (options) {
		    if (typeof options.transform === 'function') this._transform = options.transform;

		    if (typeof options.flush === 'function') this._flush = options.flush;
		  }

		  // When the writable side finishes, then flush out anything remaining.
		  this.on('prefinish', prefinish);
		}

		function prefinish() {
		  var _this = this;

		  if (typeof this._flush === 'function') {
		    this._flush(function (er, data) {
		      done(_this, er, data);
		    });
		  } else {
		    done(this, null, null);
		  }
		}

		Transform.prototype.push = function (chunk, encoding) {
		  this._transformState.needTransform = false;
		  return Duplex.prototype.push.call(this, chunk, encoding);
		};

		// This is the part where you do stuff!
		// override this function in implementation classes.
		// 'chunk' is an input chunk.
		//
		// Call `push(newChunk)` to pass along transformed output
		// to the readable side.  You may call 'push' zero or more times.
		//
		// Call `cb(err)` when you are done with this chunk.  If you pass
		// an error, then that'll put the hurt on the whole operation.  If you
		// never call cb(), then you'll never get another chunk.
		Transform.prototype._transform = function (chunk, encoding, cb) {
		  throw new Error('_transform() is not implemented');
		};

		Transform.prototype._write = function (chunk, encoding, cb) {
		  var ts = this._transformState;
		  ts.writecb = cb;
		  ts.writechunk = chunk;
		  ts.writeencoding = encoding;
		  if (!ts.transforming) {
		    var rs = this._readableState;
		    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
		  }
		};

		// Doesn't matter what the args are here.
		// _transform does all the work.
		// That we got here means that the readable side wants more data.
		Transform.prototype._read = function (n) {
		  var ts = this._transformState;

		  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
		    ts.transforming = true;
		    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
		  } else {
		    // mark that we need a transform, so that any data that comes in
		    // will get processed, now that we've asked for it.
		    ts.needTransform = true;
		  }
		};

		Transform.prototype._destroy = function (err, cb) {
		  var _this2 = this;

		  Duplex.prototype._destroy.call(this, err, function (err2) {
		    cb(err2);
		    _this2.emit('close');
		  });
		};

		function done(stream, er, data) {
		  if (er) return stream.emit('error', er);

		  if (data != null) // single equals check for both `null` and `undefined`
		    stream.push(data);

		  // if there's nothing in the write buffer, then that means
		  // that nothing more will ever be provided
		  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

		  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

		  return stream.push(null);
		}

	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		// a passthrough stream.
		// basically just the most minimal sort of Transform stream.
		// Every written chunk gets output as-is.

		'use strict';

		module.exports = PassThrough;

		var Transform = __webpack_require__(52);

		/*<replacement>*/
		var util = Object.create(__webpack_require__(41));
		util.inherits = __webpack_require__(34);
		/*</replacement>*/

		util.inherits(PassThrough, Transform);

		function PassThrough(options) {
		  if (!(this instanceof PassThrough)) return new PassThrough(options);

		  Transform.call(this, options);
		}

		PassThrough.prototype._transform = function (chunk, encoding, cb) {
		  cb(null, chunk);
		};

	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(47);


	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(46);


	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(35).Transform


	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {

		module.exports = __webpack_require__(35).PassThrough


	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {

		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		var Buffer = __webpack_require__(28).Buffer;

		var isBufferEncoding = Buffer.isEncoding
		  || function(encoding) {
		       switch (encoding && encoding.toLowerCase()) {
		         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
		         default: return false;
		       }
		     }


		function assertEncoding(encoding) {
		  if (encoding && !isBufferEncoding(encoding)) {
		    throw new Error('Unknown encoding: ' + encoding);
		  }
		}

		// StringDecoder provides an interface for efficiently splitting a series of
		// buffers into a series of JS strings without breaking apart multi-byte
		// characters. CESU-8 is handled as part of the UTF-8 encoding.
		//
		// @TODO Handling all encodings inside a single object makes it very difficult
		// to reason about this code, so it should be split up in the future.
		// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
		// points as used by CESU-8.
		var StringDecoder = exports.StringDecoder = function(encoding) {
		  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
		  assertEncoding(encoding);
		  switch (this.encoding) {
		    case 'utf8':
		      // CESU-8 represents each of Surrogate Pair by 3-bytes
		      this.surrogateSize = 3;
		      break;
		    case 'ucs2':
		    case 'utf16le':
		      // UTF-16 represents each of Surrogate Pair by 2-bytes
		      this.surrogateSize = 2;
		      this.detectIncompleteChar = utf16DetectIncompleteChar;
		      break;
		    case 'base64':
		      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
		      this.surrogateSize = 3;
		      this.detectIncompleteChar = base64DetectIncompleteChar;
		      break;
		    default:
		      this.write = passThroughWrite;
		      return;
		  }

		  // Enough space to store all bytes of a single character. UTF-8 needs 4
		  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
		  this.charBuffer = new Buffer(6);
		  // Number of bytes received for the current incomplete multi-byte character.
		  this.charReceived = 0;
		  // Number of bytes expected for the current incomplete multi-byte character.
		  this.charLength = 0;
		};


		// write decodes the given buffer and returns it as JS string that is
		// guaranteed to not contain any partial multi-byte characters. Any partial
		// character found at the end of the buffer is buffered up, and will be
		// returned when calling write again with the remaining bytes.
		//
		// Note: Converting a Buffer containing an orphan surrogate to a String
		// currently works, but converting a String to a Buffer (via `new Buffer`, or
		// Buffer#write) will replace incomplete surrogates with the unicode
		// replacement character. See https://codereview.chromium.org/121173009/ .
		StringDecoder.prototype.write = function(buffer) {
		  var charStr = '';
		  // if our last write ended with an incomplete multibyte character
		  while (this.charLength) {
		    // determine how many remaining bytes this buffer has to offer for this char
		    var available = (buffer.length >= this.charLength - this.charReceived) ?
		        this.charLength - this.charReceived :
		        buffer.length;

		    // add the new bytes to the char buffer
		    buffer.copy(this.charBuffer, this.charReceived, 0, available);
		    this.charReceived += available;

		    if (this.charReceived < this.charLength) {
		      // still not enough chars in this buffer? wait for more ...
		      return '';
		    }

		    // remove bytes belonging to the current character from the buffer
		    buffer = buffer.slice(available, buffer.length);

		    // get the character that was split
		    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

		    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
		    var charCode = charStr.charCodeAt(charStr.length - 1);
		    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
		      this.charLength += this.surrogateSize;
		      charStr = '';
		      continue;
		    }
		    this.charReceived = this.charLength = 0;

		    // if there are no more bytes in this buffer, just emit our char
		    if (buffer.length === 0) {
		      return charStr;
		    }
		    break;
		  }

		  // determine and set charLength / charReceived
		  this.detectIncompleteChar(buffer);

		  var end = buffer.length;
		  if (this.charLength) {
		    // buffer the incomplete character bytes we got
		    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
		    end -= this.charReceived;
		  }

		  charStr += buffer.toString(this.encoding, 0, end);

		  var end = charStr.length - 1;
		  var charCode = charStr.charCodeAt(end);
		  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
		  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
		    var size = this.surrogateSize;
		    this.charLength += size;
		    this.charReceived += size;
		    this.charBuffer.copy(this.charBuffer, size, 0, size);
		    buffer.copy(this.charBuffer, 0, 0, size);
		    return charStr.substring(0, end);
		  }

		  // or just emit the charStr
		  return charStr;
		};

		// detectIncompleteChar determines if there is an incomplete UTF-8 character at
		// the end of the given buffer. If so, it sets this.charLength to the byte
		// length that character, and sets this.charReceived to the number of bytes
		// that are available for this character.
		StringDecoder.prototype.detectIncompleteChar = function(buffer) {
		  // determine how many bytes we have to check at the end of this buffer
		  var i = (buffer.length >= 3) ? 3 : buffer.length;

		  // Figure out if one of the last i bytes of our buffer announces an
		  // incomplete char.
		  for (; i > 0; i--) {
		    var c = buffer[buffer.length - i];

		    // See http://en.wikipedia.org/wiki/UTF-8#Description

		    // 110XXXXX
		    if (i == 1 && c >> 5 == 0x06) {
		      this.charLength = 2;
		      break;
		    }

		    // 1110XXXX
		    if (i <= 2 && c >> 4 == 0x0E) {
		      this.charLength = 3;
		      break;
		    }

		    // 11110XXX
		    if (i <= 3 && c >> 3 == 0x1E) {
		      this.charLength = 4;
		      break;
		    }
		  }
		  this.charReceived = i;
		};

		StringDecoder.prototype.end = function(buffer) {
		  var res = '';
		  if (buffer && buffer.length)
		    res = this.write(buffer);

		  if (this.charReceived) {
		    var cr = this.charReceived;
		    var buf = this.charBuffer;
		    var enc = this.encoding;
		    res += buf.slice(0, cr).toString(enc);
		  }

		  return res;
		};

		function passThroughWrite(buffer) {
		  return buffer.toString(this.encoding);
		}

		function utf16DetectIncompleteChar(buffer) {
		  this.charReceived = buffer.length % 2;
		  this.charLength = this.charReceived ? 2 : 0;
		}

		function base64DetectIncompleteChar(buffer) {
		  this.charReceived = buffer.length % 3;
		  this.charLength = this.charReceived ? 3 : 0;
		}


	/***/ }),
	/* 59 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  "use strict";
		  exports.stripBOM = function(str) {
		    if (str[0] === '\uFEFF') {
		      return str.substring(1);
		    } else {
		      return str;
		    }
		  };

		}).call(this);


	/***/ }),
	/* 60 */
	/***/ (function(module, exports) {

		// Generated by CoffeeScript 1.12.7
		(function() {
		  "use strict";
		  var prefixMatch;

		  prefixMatch = new RegExp(/(?!xmlns)^.*:/);

		  exports.normalize = function(str) {
		    return str.toLowerCase();
		  };

		  exports.firstCharLowerCase = function(str) {
		    return str.charAt(0).toLowerCase() + str.slice(1);
		  };

		  exports.stripPrefix = function(str) {
		    return str.replace(prefixMatch, '');
		  };

		  exports.parseNumbers = function(str) {
		    if (!isNaN(str)) {
		      str = str % 1 === 0 ? parseInt(str, 10) : parseFloat(str);
		    }
		    return str;
		  };

		  exports.parseBooleans = function(str) {
		    if (/^(?:true|false)$/i.test(str)) {
		      str = str.toLowerCase() === 'true';
		    }
		    return str;
		  };

		}).call(this);


	/***/ })
	/******/ ]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var EventEmitter = __webpack_require__(46).EventEmitter;
	__webpack_require__(47);

	/**
	 * @api private
	 */
	AWS.XHRClient = AWS.util.inherit({
	  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
	    var self = this;
	    var endpoint = httpRequest.endpoint;
	    var emitter = new EventEmitter();
	    var href = endpoint.protocol + '//' + endpoint.hostname;
	    if (endpoint.port !== 80 && endpoint.port !== 443) {
	      href += ':' + endpoint.port;
	    }
	    href += httpRequest.path;

	    var xhr = new XMLHttpRequest(), headersEmitted = false;
	    httpRequest.stream = xhr;

	    xhr.addEventListener('readystatechange', function() {
	      try {
	        if (xhr.status === 0) return; // 0 code is invalid
	      } catch (e) { return; }

	      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
	        emitter.statusCode = xhr.status;
	        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
	        emitter.emit(
	          'headers',
	          emitter.statusCode,
	          emitter.headers,
	          xhr.statusText
	        );
	        headersEmitted = true;
	      }
	      if (this.readyState === this.DONE) {
	        self.finishRequest(xhr, emitter);
	      }
	    }, false);
	    xhr.upload.addEventListener('progress', function (evt) {
	      emitter.emit('sendProgress', evt);
	    });
	    xhr.addEventListener('progress', function (evt) {
	      emitter.emit('receiveProgress', evt);
	    }, false);
	    xhr.addEventListener('timeout', function () {
	      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
	    }, false);
	    xhr.addEventListener('error', function () {
	      errCallback(AWS.util.error(new Error('Network Failure'), {
	        code: 'NetworkingError'
	      }));
	    }, false);
	    xhr.addEventListener('abort', function () {
	      errCallback(AWS.util.error(new Error('Request aborted'), {
	        code: 'RequestAbortedError'
	      }));
	    }, false);

	    callback(emitter);
	    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
	    AWS.util.each(httpRequest.headers, function (key, value) {
	      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
	        xhr.setRequestHeader(key, value);
	      }
	    });

	    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
	      xhr.timeout = httpOptions.timeout;
	    }

	    if (httpOptions.xhrWithCredentials) {
	      xhr.withCredentials = true;
	    }
	    try { xhr.responseType = 'arraybuffer'; } catch (e) {}

	    try {
	      if (httpRequest.body) {
	        xhr.send(httpRequest.body);
	      } else {
	        xhr.send();
	      }
	    } catch (err) {
	      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
	        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
	      } else {
	        throw err;
	      }
	    }

	    return emitter;
	  },

	  parseHeaders: function parseHeaders(rawHeaders) {
	    var headers = {};
	    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
	      var key = line.split(':', 1)[0];
	      var value = line.substring(key.length + 2);
	      if (key.length > 0) headers[key.toLowerCase()] = value;
	    });
	    return headers;
	  },

	  finishRequest: function finishRequest(xhr, emitter) {
	    var buffer;
	    if (xhr.responseType === 'arraybuffer' && xhr.response) {
	      var ab = xhr.response;
	      buffer = new AWS.util.Buffer(ab.byteLength);
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < buffer.length; ++i) {
	        buffer[i] = view[i];
	      }
	    }

	    try {
	      if (!buffer && typeof xhr.responseText === 'string') {
	        buffer = new AWS.util.Buffer(xhr.responseText);
	      }
	    } catch (e) {}

	    if (buffer) emitter.emit('data', buffer);
	    emitter.emit('end');
	  }
	});

	/**
	 * @api private
	 */
	AWS.HttpClient.prototype = AWS.XHRClient.prototype;

	/**
	 * @api private
	 */
	AWS.HttpClient.streamsApiVersion = 1;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;

	  if (!this._events)
	    this._events = {};

	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }

	  handler = this._events[type];

	  if (isUndefined(handler))
	    return false;

	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }

	  return true;
	};

	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events)
	    this._events = {};

	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);

	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];

	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }

	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }

	  return this;
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  var fired = false;

	  function g() {
	    this.removeListener(type, g);

	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }

	  g.listener = listener;
	  this.on(type, g);

	  return this;
	};

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events || !this._events[type])
	    return this;

	  list = this._events[type];
	  length = list.length;
	  position = -1;

	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);

	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }

	    if (position < 0)
	      return this;

	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }

	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }

	  return this;
	};

	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;

	  if (!this._events)
	    return this;

	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }

	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }

	  listeners = this._events[type];

	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];

	  return this;
	};

	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};

	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];

	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};

	function isFunction(arg) {
	  return typeof arg === 'function';
	}

	function isNumber(arg) {
	  return typeof arg === 'number';
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;

	/**
	 * The endpoint that a service will talk to, for example,
	 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
	 * you need to override an endpoint for a service, you can
	 * set the endpoint on a service by passing the endpoint
	 * object with the `endpoint` option key:
	 *
	 * ```javascript
	 * var ep = new AWS.Endpoint('awsproxy.example.com');
	 * var s3 = new AWS.S3({endpoint: ep});
	 * s3.service.endpoint.hostname == 'awsproxy.example.com'
	 * ```
	 *
	 * Note that if you do not specify a protocol, the protocol will
	 * be selected based on your current {AWS.config} configuration.
	 *
	 * @!attribute protocol
	 *   @return [String] the protocol (http or https) of the endpoint
	 *     URL
	 * @!attribute hostname
	 *   @return [String] the host portion of the endpoint, e.g.,
	 *     example.com
	 * @!attribute host
	 *   @return [String] the host portion of the endpoint including
	 *     the port, e.g., example.com:80
	 * @!attribute port
	 *   @return [Integer] the port of the endpoint
	 * @!attribute href
	 *   @return [String] the full URL of the endpoint
	 */
	AWS.Endpoint = inherit({

	  /**
	   * @overload Endpoint(endpoint)
	   *   Constructs a new endpoint given an endpoint URL. If the
	   *   URL omits a protocol (http or https), the default protocol
	   *   set in the global {AWS.config} will be used.
	   *   @param endpoint [String] the URL to construct an endpoint from
	   */
	  constructor: function Endpoint(endpoint, config) {
	    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

	    if (typeof endpoint === 'undefined' || endpoint === null) {
	      throw new Error('Invalid endpoint: ' + endpoint);
	    } else if (typeof endpoint !== 'string') {
	      return AWS.util.copy(endpoint);
	    }

	    if (!endpoint.match(/^http/)) {
	      var useSSL = config && config.sslEnabled !== undefined ?
	        config.sslEnabled : AWS.config.sslEnabled;
	      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
	    }

	    AWS.util.update(this, AWS.util.urlParse(endpoint));

	    // Ensure the port property is set as an integer
	    if (this.port) {
	      this.port = parseInt(this.port, 10);
	    } else {
	      this.port = this.protocol === 'https:' ? 443 : 80;
	    }
	  }

	});

	/**
	 * The low level HTTP request object, encapsulating all HTTP header
	 * and body data sent by a service request.
	 *
	 * @!attribute method
	 *   @return [String] the HTTP method of the request
	 * @!attribute path
	 *   @return [String] the path portion of the URI, e.g.,
	 *     "/list/?start=5&num=10"
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *     a map of header keys and their respective values
	 * @!attribute body
	 *   @return [String] the request body payload
	 * @!attribute endpoint
	 *   @return [AWS.Endpoint] the endpoint for the request
	 * @!attribute region
	 *   @api private
	 *   @return [String] the region, for signing purposes only.
	 */
	AWS.HttpRequest = inherit({

	  /**
	   * @api private
	   */
	  constructor: function HttpRequest(endpoint, region) {
	    endpoint = new AWS.Endpoint(endpoint);
	    this.method = 'POST';
	    this.path = endpoint.path || '/';
	    this.headers = {};
	    this.body = '';
	    this.endpoint = endpoint;
	    this.region = region;
	    this._userAgent = '';
	    this.setUserAgent();
	  },

	  /**
	   * @api private
	   */
	  setUserAgent: function setUserAgent() {
	    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
	  },

	  getUserAgentHeaderName: function getUserAgentHeaderName() {
	    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
	    return prefix + 'User-Agent';
	  },

	  /**
	   * @api private
	   */
	  appendToUserAgent: function appendToUserAgent(agentPartial) {
	    if (typeof agentPartial === 'string' && agentPartial) {
	      this._userAgent += ' ' + agentPartial;
	    }
	    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
	  },

	  /**
	   * @api private
	   */
	  getUserAgent: function getUserAgent() {
	    return this._userAgent;
	  },

	  /**
	   * @return [String] the part of the {path} excluding the
	   *   query string
	   */
	  pathname: function pathname() {
	    return this.path.split('?', 1)[0];
	  },

	  /**
	   * @return [String] the query string portion of the {path}
	   */
	  search: function search() {
	    var query = this.path.split('?', 2)[1];
	    if (query) {
	      query = AWS.util.queryStringParse(query);
	      return AWS.util.queryParamsToString(query);
	    }
	    return '';
	  },

	  /**
	   * @api private
	   * update httpRequest endpoint with endpoint string
	   */
	  updateEndpoint: function updateEndpoint(endpointStr) {
	    var newEndpoint = new AWS.Endpoint(endpointStr);
	    this.endpoint = newEndpoint;
	    this.path = newEndpoint.path || '/';
	    if (this.headers['Host']) {
	      this.headers['Host'] = newEndpoint.host;
	    }
	  }
	});

	/**
	 * The low level HTTP response object, encapsulating all HTTP header
	 * and body data returned from the request.
	 *
	 * @!attribute statusCode
	 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *      a map of response header keys and their respective values
	 * @!attribute body
	 *   @return [String] the response body payload
	 * @!attribute [r] streaming
	 *   @return [Boolean] whether this response is being streamed at a low-level.
	 *     Defaults to `false` (buffered reads). Do not modify this manually, use
	 *     {createUnbufferedStream} to convert the stream to unbuffered mode
	 *     instead.
	 */
	AWS.HttpResponse = inherit({

	  /**
	   * @api private
	   */
	  constructor: function HttpResponse() {
	    this.statusCode = undefined;
	    this.headers = {};
	    this.body = undefined;
	    this.streaming = false;
	    this.stream = null;
	  },

	  /**
	   * Disables buffering on the HTTP response and returns the stream for reading.
	   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
	   *   Use this object to directly read data off of the stream.
	   * @note This object is only available after the {AWS.Request~httpHeaders}
	   *   event has fired. This method must be called prior to
	   *   {AWS.Request~httpData}.
	   * @example Taking control of a stream
	   *   request.on('httpHeaders', function(statusCode, headers) {
	   *     if (statusCode < 300) {
	   *       if (headers.etag === 'xyz') {
	   *         // pipe the stream, disabling buffering
	   *         var stream = this.response.httpResponse.createUnbufferedStream();
	   *         stream.pipe(process.stdout);
	   *       } else { // abort this request and set a better error message
	   *         this.abort();
	   *         this.response.error = new Error('Invalid ETag');
	   *       }
	   *     }
	   *   }).send(console.log);
	   */
	  createUnbufferedStream: function createUnbufferedStream() {
	    this.streaming = true;
	    return this.stream;
	  }
	});


	AWS.HttpClient = inherit({});

	/**
	 * @api private
	 */
	AWS.HttpClient.getInstance = function getInstance() {
	  if (this.singleton === undefined) {
	    this.singleton = new this();
	  }
	  return this.singleton;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	function addContentType(req) {
	  var httpRequest = req.httpRequest || {};
	  var headers = httpRequest.headers;
	  // We don't want to force a content type on presigned urls
	  if (headers && !req.isPresigned()) {
	    if (httpRequest.body && !headers['Content-Type']) {
	      // React Native's android XHR requires Content-Type to be defined if there is a body
	      headers['Content-Type'] = '';
	    }
	  }
	}

	/**
	 * @api private
	 */
	module.exports = {
	    addContentType: addContentType
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = {
	  ACM: __webpack_require__(50),
	  APIGateway: __webpack_require__(54),
	  ApplicationAutoScaling: __webpack_require__(58),
	  AppStream: __webpack_require__(61),
	  AutoScaling: __webpack_require__(65),
	  Batch: __webpack_require__(68),
	  Budgets: __webpack_require__(71),
	  CloudDirectory: __webpack_require__(74),
	  CloudFormation: __webpack_require__(79),
	  CloudFront: __webpack_require__(83),
	  CloudHSM: __webpack_require__(107),
	  CloudSearch: __webpack_require__(110),
	  CloudSearchDomain: __webpack_require__(115),
	  CloudTrail: __webpack_require__(118),
	  CloudWatch: __webpack_require__(121),
	  CloudWatchEvents: __webpack_require__(125),
	  CloudWatchLogs: __webpack_require__(128),
	  CodeBuild: __webpack_require__(131),
	  CodeCommit: __webpack_require__(134),
	  CodeDeploy: __webpack_require__(137),
	  CodePipeline: __webpack_require__(141),
	  CognitoIdentity: __webpack_require__(39),
	  CognitoIdentityServiceProvider: __webpack_require__(144),
	  CognitoSync: __webpack_require__(147),
	  ConfigService: __webpack_require__(150),
	  CUR: __webpack_require__(153),
	  DataPipeline: __webpack_require__(156),
	  DeviceFarm: __webpack_require__(159),
	  DirectConnect: __webpack_require__(162),
	  DirectoryService: __webpack_require__(165),
	  Discovery: __webpack_require__(168),
	  DMS: __webpack_require__(171),
	  DynamoDB: __webpack_require__(175),
	  DynamoDBStreams: __webpack_require__(189),
	  EC2: __webpack_require__(192),
	  ECR: __webpack_require__(197),
	  ECS: __webpack_require__(201),
	  EFS: __webpack_require__(205),
	  ElastiCache: __webpack_require__(208),
	  ElasticBeanstalk: __webpack_require__(212),
	  ELB: __webpack_require__(216),
	  ELBv2: __webpack_require__(220),
	  EMR: __webpack_require__(224),
	  ES: __webpack_require__(228),
	  ElasticTranscoder: __webpack_require__(231),
	  Firehose: __webpack_require__(235),
	  GameLift: __webpack_require__(238),
	  Glacier: __webpack_require__(241),
	  Health: __webpack_require__(246),
	  IAM: __webpack_require__(249),
	  ImportExport: __webpack_require__(253),
	  Inspector: __webpack_require__(256),
	  Iot: __webpack_require__(259),
	  IotData: __webpack_require__(262),
	  Kinesis: __webpack_require__(266),
	  KinesisAnalytics: __webpack_require__(270),
	  KMS: __webpack_require__(273),
	  Lambda: __webpack_require__(276),
	  LexRuntime: __webpack_require__(283),
	  Lightsail: __webpack_require__(286),
	  MachineLearning: __webpack_require__(289),
	  MarketplaceCommerceAnalytics: __webpack_require__(294),
	  MarketplaceMetering: __webpack_require__(297),
	  MTurk: __webpack_require__(300),
	  MobileAnalytics: __webpack_require__(303),
	  OpsWorks: __webpack_require__(305),
	  OpsWorksCM: __webpack_require__(309),
	  Organizations: __webpack_require__(313),
	  Pinpoint: __webpack_require__(316),
	  Polly: __webpack_require__(318),
	  RDS: __webpack_require__(323),
	  Redshift: __webpack_require__(339),
	  Rekognition: __webpack_require__(343),
	  ResourceGroupsTaggingAPI: __webpack_require__(347),
	  Route53: __webpack_require__(350),
	  Route53Domains: __webpack_require__(355),
	  S3: __webpack_require__(358),
	  S3Control: __webpack_require__(429),
	  ServiceCatalog: __webpack_require__(433),
	  SES: __webpack_require__(436),
	  Shield: __webpack_require__(440),
	  SimpleDB: __webpack_require__(443),
	  SMS: __webpack_require__(446),
	  Snowball: __webpack_require__(449),
	  SNS: __webpack_require__(452),
	  SQS: __webpack_require__(455),
	  SSM: __webpack_require__(459),
	  StorageGateway: __webpack_require__(463),
	  StepFunctions: __webpack_require__(466),
	  STS: __webpack_require__(31),
	  Support: __webpack_require__(469),
	  SWF: __webpack_require__(472),
	  XRay: __webpack_require__(476),
	  WAF: __webpack_require__(479),
	  WAFRegional: __webpack_require__(482),
	  WorkDocs: __webpack_require__(485),
	  WorkSpaces: __webpack_require__(488),
	  CodeStar: __webpack_require__(491),
	  LexModelBuildingService: __webpack_require__(494),
	  MarketplaceEntitlementService: __webpack_require__(497),
	  Athena: __webpack_require__(500),
	  Greengrass: __webpack_require__(503),
	  DAX: __webpack_require__(505),
	  MigrationHub: __webpack_require__(508),
	  CloudHSMV2: __webpack_require__(511),
	  Glue: __webpack_require__(514),
	  Mobile: __webpack_require__(517),
	  Pricing: __webpack_require__(520),
	  CostExplorer: __webpack_require__(523),
	  MediaConvert: __webpack_require__(526),
	  MediaLive: __webpack_require__(529),
	  MediaPackage: __webpack_require__(533),
	  MediaStore: __webpack_require__(536),
	  MediaStoreData: __webpack_require__(539),
	  AppSync: __webpack_require__(542),
	  GuardDuty: __webpack_require__(545),
	  MQ: __webpack_require__(548),
	  Comprehend: __webpack_require__(551),
	  IoTJobsDataPlane: __webpack_require__(554),
	  KinesisVideoArchivedMedia: __webpack_require__(557),
	  KinesisVideoMedia: __webpack_require__(560),
	  KinesisVideo: __webpack_require__(563),
	  SageMakerRuntime: __webpack_require__(566),
	  SageMaker: __webpack_require__(569),
	  Translate: __webpack_require__(573),
	  ResourceGroups: __webpack_require__(576),
	  AlexaForBusiness: __webpack_require__(579),
	  Cloud9: __webpack_require__(582),
	  ServerlessApplicationRepository: __webpack_require__(585),
	  ServiceDiscovery: __webpack_require__(588),
	  WorkMail: __webpack_require__(591),
	  AutoScalingPlans: __webpack_require__(594),
	  TranscribeService: __webpack_require__(597),
	  Connect: __webpack_require__(600),
	  ACMPCA: __webpack_require__(603),
	  FMS: __webpack_require__(607),
	  SecretsManager: __webpack_require__(610),
	  IoTAnalytics: __webpack_require__(613),
	  IoT1ClickDevicesService: __webpack_require__(616),
	  IoT1ClickProjects: __webpack_require__(618),
	  PI: __webpack_require__(621),
	  Neptune: __webpack_require__(624),
	  MediaTailor: __webpack_require__(629),
	  EKS: __webpack_require__(632),
	  Macie: __webpack_require__(636),
	  DLM: __webpack_require__(639),
	  Signer: __webpack_require__(642),
	  Chime: __webpack_require__(646),
	  PinpointEmail: __webpack_require__(649),
	  RAM: __webpack_require__(652),
	  Route53Resolver: __webpack_require__(655),
	  PinpointSMSVoice: __webpack_require__(658),
	  QuickSight: __webpack_require__(660),
	  RDSDataService: __webpack_require__(663),
	  Amplify: __webpack_require__(667),
	  DataSync: __webpack_require__(670),
	  RoboMaker: __webpack_require__(673),
	  Transfer: __webpack_require__(676),
	  GlobalAccelerator: __webpack_require__(680),
	  ComprehendMedical: __webpack_require__(683),
	  KinesisAnalyticsV2: __webpack_require__(686),
	  MediaConnect: __webpack_require__(689),
	  FSx: __webpack_require__(693),
	  SecurityHub: __webpack_require__(696),
	  AppMesh: __webpack_require__(699),
	  LicenseManager: __webpack_require__(704),
	  Kafka: __webpack_require__(707),
	  ApiGatewayManagementApi: __webpack_require__(710),
	  ApiGatewayV2: __webpack_require__(713),
	  DocDB: __webpack_require__(716),
	  Backup: __webpack_require__(721),
	  WorkLink: __webpack_require__(724),
	  Textract: __webpack_require__(727),
	  ManagedBlockchain: __webpack_require__(730),
	  MediaPackageVod: __webpack_require__(733),
	  GroundStation: __webpack_require__(736),
	  IoTThingsGraph: __webpack_require__(739),
	  IoTEvents: __webpack_require__(742),
	  IoTEventsData: __webpack_require__(745),
	  Personalize: __webpack_require__(748),
	  PersonalizeEvents: __webpack_require__(751),
	  PersonalizeRuntime: __webpack_require__(754),
	  ApplicationInsights: __webpack_require__(757),
	  ServiceQuotas: __webpack_require__(760),
	  EC2InstanceConnect: __webpack_require__(763),
	  EventBridge: __webpack_require__(766),
	  LakeFormation: __webpack_require__(770),
	  ForecastService: __webpack_require__(773),
	  ForecastQueryService: __webpack_require__(776),
	  QLDB: __webpack_require__(779),
	  QLDBSession: __webpack_require__(782),
	  WorkMailMessageFlow: __webpack_require__(785),
	  CodeStarNotifications: __webpack_require__(788),
	  SavingsPlans: __webpack_require__(791),
	  SSO: __webpack_require__(794),
	  SSOOIDC: __webpack_require__(797),
	  MarketplaceCatalog: __webpack_require__(800),
	  DataExchange: __webpack_require__(803),
	  SESV2: __webpack_require__(806),
	  MigrationHubConfig: __webpack_require__(809),
	  ConnectParticipant: __webpack_require__(812),
	  AppConfig: __webpack_require__(815),
	  IoTSecureTunneling: __webpack_require__(818),
	  WAFV2: __webpack_require__(821),
	  ElasticInference: __webpack_require__(824),
	  Imagebuilder: __webpack_require__(827),
	  Schemas: __webpack_require__(830),
	  AccessAnalyzer: __webpack_require__(834),
	  CodeGuruReviewer: __webpack_require__(837),
	  CodeGuruProfiler: __webpack_require__(841),
	  ComputeOptimizer: __webpack_require__(844),
	  FraudDetector: __webpack_require__(847),
	  Kendra: __webpack_require__(850),
	  NetworkManager: __webpack_require__(853),
	  Outposts: __webpack_require__(856),
	  AugmentedAIRuntime: __webpack_require__(859),
	  EBS: __webpack_require__(862),
	  KinesisVideoSignalingChannels: __webpack_require__(865),
	  Detective: __webpack_require__(868),
	  CodeStarconnections: __webpack_require__(871),
	  Synthetics: __webpack_require__(874),
	  IoTSiteWise: __webpack_require__(877),
	  Macie2: __webpack_require__(881),
	  CodeArtifact: __webpack_require__(884),
	  Honeycode: __webpack_require__(887),
	  IVS: __webpack_require__(890),
	  Braket: __webpack_require__(893),
	  IdentityStore: __webpack_require__(896),
	  Appflow: __webpack_require__(899),
	  RedshiftData: __webpack_require__(902),
	  SSOAdmin: __webpack_require__(905),
	  TimestreamQuery: __webpack_require__(908),
	  TimestreamWrite: __webpack_require__(911),
	  S3Outposts: __webpack_require__(914),
	  DataBrew: __webpack_require__(917),
	  ServiceCatalogAppRegistry: __webpack_require__(920),
	  NetworkFirewall: __webpack_require__(923),
	  MWAA: __webpack_require__(926),
	  AmplifyBackend: __webpack_require__(929),
	  AppIntegrations: __webpack_require__(932),
	  ConnectContactLens: __webpack_require__(935),
	  DevOpsGuru: __webpack_require__(938),
	  ECRPUBLIC: __webpack_require__(941),
	  LookoutVision: __webpack_require__(944),
	  SageMakerFeatureStoreRuntime: __webpack_require__(947),
	  CustomerProfiles: __webpack_require__(950),
	  AuditManager: __webpack_require__(953),
	  EMRcontainers: __webpack_require__(956),
	  HealthLake: __webpack_require__(959),
	  SagemakerEdge: __webpack_require__(962),
	  Amp: __webpack_require__(965),
	  GreengrassV2: __webpack_require__(969),
	  IotDeviceAdvisor: __webpack_require__(972),
	  IoTFleetHub: __webpack_require__(975),
	  IoTWireless: __webpack_require__(978),
	  Location: __webpack_require__(981),
	  WellArchitected: __webpack_require__(984),
	  LexModelsV2: __webpack_require__(987),
	  LexRuntimeV2: __webpack_require__(991),
	  Fis: __webpack_require__(994),
	  LookoutMetrics: __webpack_require__(997),
	  Mgn: __webpack_require__(1000),
	  LookoutEquipment: __webpack_require__(1003),
	  Nimble: __webpack_require__(1006),
	  Finspace: __webpack_require__(1010),
	  Finspacedata: __webpack_require__(1013),
	  SSMContacts: __webpack_require__(1016),
	  SSMIncidents: __webpack_require__(1019),
	  ApplicationCostProfiler: __webpack_require__(1023),
	  AppRunner: __webpack_require__(1026),
	  Proton: __webpack_require__(1029),
	  Route53RecoveryCluster: __webpack_require__(1033),
	  Route53RecoveryControlConfig: __webpack_require__(1036),
	  Route53RecoveryReadiness: __webpack_require__(1040),
	  ChimeSDKIdentity: __webpack_require__(1043),
	  ChimeSDKMessaging: __webpack_require__(1046),
	  SnowDeviceManagement: __webpack_require__(1049),
	  MemoryDB: __webpack_require__(1052),
	  OpenSearch: __webpack_require__(1055),
	  KafkaConnect: __webpack_require__(1058),
	  VoiceID: __webpack_require__(1061),
	  Wisdom: __webpack_require__(1064),
	  Account: __webpack_require__(1067),
	  CloudControl: __webpack_require__(1070),
	  Grafana: __webpack_require__(1074),
	  Panorama: __webpack_require__(1077),
	  ChimeSDKMeetings: __webpack_require__(1080),
	  Resiliencehub: __webpack_require__(1083),
	  MigrationHubStrategy: __webpack_require__(1086),
	  AppConfigData: __webpack_require__(1089),
	  Drs: __webpack_require__(1092),
	  MigrationHubRefactorSpaces: __webpack_require__(1095),
	  Evidently: __webpack_require__(1098),
	  Inspector2: __webpack_require__(1101),
	  Rbin: __webpack_require__(1104),
	  RUM: __webpack_require__(1107),
	  BackupGateway: __webpack_require__(1110),
	  IoTTwinMaker: __webpack_require__(1113),
	  WorkSpacesWeb: __webpack_require__(1117),
	  AmplifyUIBuilder: __webpack_require__(1120),
	  Keyspaces: __webpack_require__(1123),
	  Billingconductor: __webpack_require__(1127),
	  GameSparks: __webpack_require__(1131),
	  PinpointSMSVoiceV2: __webpack_require__(1134),
	  Ivschat: __webpack_require__(1138),
	  ChimeSDKMediaPipelines: __webpack_require__(1141)
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['acm'] = {};
	AWS.ACM = Service.defineService('acm', ['2015-12-08']);
	Object.defineProperty(apiLoader.services['acm'], '2015-12-08', {
	  get: function get() {
	    var model = __webpack_require__(51);
	    model.paginators = __webpack_require__(52).pagination;
	    model.waiters = __webpack_require__(53).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ACM;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-08","endpointPrefix":"acm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM","serviceFullName":"AWS Certificate Manager","serviceId":"ACM","signatureVersion":"v4","targetPrefix":"CertificateManager","uid":"acm-2015-12-08"},"operations":{"AddTagsToCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"DescribeCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"DomainValidationOptions":{"shape":"Sd"},"Serial":{},"Subject":{},"Issuer":{},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"Status":{},"RevokedAt":{"type":"timestamp"},"RevocationReason":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"KeyAlgorithm":{},"SignatureAlgorithm":{},"InUseBy":{"type":"list","member":{}},"FailureReason":{},"Type":{},"RenewalSummary":{"type":"structure","required":["RenewalStatus","DomainValidationOptions","UpdatedAt"],"members":{"RenewalStatus":{},"DomainValidationOptions":{"shape":"Sd"},"RenewalStatusReason":{},"UpdatedAt":{"type":"timestamp"}}},"KeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"ExtendedKeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{},"OID":{}}}},"CertificateAuthorityArn":{},"RenewalEligibility":{},"Options":{"shape":"S11"}}}}}},"ExportCertificate":{"input":{"type":"structure","required":["CertificateArn","Passphrase"],"members":{"CertificateArn":{},"Passphrase":{"type":"blob","sensitive":true}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{},"PrivateKey":{"type":"string","sensitive":true}}}},"GetAccountConfiguration":{"output":{"type":"structure","members":{"ExpiryEvents":{"shape":"S1a"}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"CertificateArn":{},"Certificate":{"type":"blob"},"PrivateKey":{"type":"blob","sensitive":true},"CertificateChain":{"type":"blob"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ListCertificates":{"input":{"type":"structure","members":{"CertificateStatuses":{"type":"list","member":{}},"Includes":{"type":"structure","members":{"extendedKeyUsage":{"type":"list","member":{}},"keyUsage":{"type":"list","member":{}},"keyTypes":{"type":"list","member":{}}}},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CertificateSummaryList":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"DomainName":{}}}}}}},"ListTagsForCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"PutAccountConfiguration":{"input":{"type":"structure","required":["IdempotencyToken"],"members":{"ExpiryEvents":{"shape":"S1a"},"IdempotencyToken":{}}}},"RemoveTagsFromCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"RenewCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"RequestCertificate":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationMethod":{},"SubjectAlternativeNames":{"shape":"Sc"},"IdempotencyToken":{},"DomainValidationOptions":{"type":"list","member":{"type":"structure","required":["DomainName","ValidationDomain"],"members":{"DomainName":{},"ValidationDomain":{}}}},"Options":{"shape":"S11"},"CertificateAuthorityArn":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ResendValidationEmail":{"input":{"type":"structure","required":["CertificateArn","Domain","ValidationDomain"],"members":{"CertificateArn":{},"Domain":{},"ValidationDomain":{}}}},"UpdateCertificateOptions":{"input":{"type":"structure","required":["CertificateArn","Options"],"members":{"CertificateArn":{},"Options":{"shape":"S11"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationEmails":{"type":"list","member":{}},"ValidationDomain":{},"ValidationStatus":{},"ResourceRecord":{"type":"structure","required":["Name","Type","Value"],"members":{"Name":{},"Type":{},"Value":{}}},"ValidationMethod":{}}}},"S11":{"type":"structure","members":{"CertificateTransparencyLoggingPreference":{}}},"S1a":{"type":"structure","members":{"DaysBeforeExpiry":{"type":"integer"}}}}}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"CertificateValidated":{"delay":60,"maxAttempts":40,"operation":"DescribeCertificate","acceptors":[{"matcher":"pathAll","expected":"SUCCESS","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"success"},{"matcher":"pathAny","expected":"PENDING_VALIDATION","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"retry"},{"matcher":"path","expected":"FAILED","argument":"Certificate.Status","state":"failure"},{"matcher":"error","expected":"ResourceNotFoundException","state":"failure"}]}}}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['apigateway'] = {};
	AWS.APIGateway = Service.defineService('apigateway', ['2015-07-09']);
	__webpack_require__(55);
	Object.defineProperty(apiLoader.services['apigateway'], '2015-07-09', {
	  get: function get() {
	    var model = __webpack_require__(56);
	    model.paginators = __webpack_require__(57).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.APIGateway;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.APIGateway.prototype, {
	/**
	 * Sets the Accept header to application/json.
	 *
	 * @api private
	 */
	  setAcceptHeader: function setAcceptHeader(req) {
	    var httpRequest = req.httpRequest;
	    if (!httpRequest.headers.Accept) {
	      httpRequest.headers['Accept'] = 'application/json';
	    }
	  },

	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('build', this.setAcceptHeader);
	    if (request.operation === 'getExport') {
	      var params = request.params || {};
	      if (params.exportType === 'swagger') {
	        request.addListener('extractData', AWS.util.convertPayloadToString);
	      }
	    }
	  }
	});



/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"apigateway","protocol":"rest-json","serviceFullName":"Amazon API Gateway","serviceId":"API Gateway","signatureVersion":"v4","uid":"apigateway-2015-07-09"},"operations":{"CreateApiKey":{"http":{"requestUri":"/apikeys","responseCode":201},"input":{"type":"structure","members":{"name":{},"description":{},"enabled":{"type":"boolean"},"generateDistinctId":{"type":"boolean"},"value":{},"stageKeys":{"type":"list","member":{"type":"structure","members":{"restApiId":{},"stageName":{}}}},"customerId":{},"tags":{"shape":"S6"}}},"output":{"shape":"S7"}},"CreateAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers","responseCode":201},"input":{"type":"structure","required":["restApiId","name","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"output":{"shape":"Sf"}},"CreateBasePathMapping":{"http":{"requestUri":"/domainnames/{domain_name}/basepathmappings","responseCode":201},"input":{"type":"structure","required":["domainName","restApiId"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{},"restApiId":{},"stage":{}}},"output":{"shape":"Sh"}},"CreateDeployment":{"http":{"requestUri":"/restapis/{restapi_id}/deployments","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"stageDescription":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"canarySettings":{"type":"structure","members":{"percentTraffic":{"type":"double"},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"tracingEnabled":{"type":"boolean"}}},"output":{"shape":"Sn"}},"CreateDocumentationPart":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/parts","responseCode":201},"input":{"type":"structure","required":["restApiId","location","properties"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"location":{"shape":"Ss"},"properties":{}}},"output":{"shape":"Sv"}},"CreateDocumentationVersion":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/versions","responseCode":201},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{},"stageName":{},"description":{}}},"output":{"shape":"Sx"}},"CreateDomainName":{"http":{"requestUri":"/domainnames","responseCode":201},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"certificateName":{},"certificateBody":{},"certificatePrivateKey":{},"certificateChain":{},"certificateArn":{},"regionalCertificateName":{},"regionalCertificateArn":{},"endpointConfiguration":{"shape":"Sz"},"tags":{"shape":"S6"},"securityPolicy":{},"mutualTlsAuthentication":{"type":"structure","members":{"truststoreUri":{},"truststoreVersion":{}}},"ownershipVerificationCertificateArn":{}}},"output":{"shape":"S14"}},"CreateModel":{"http":{"requestUri":"/restapis/{restapi_id}/models","responseCode":201},"input":{"type":"structure","required":["restApiId","name","contentType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"description":{},"schema":{},"contentType":{}}},"output":{"shape":"S18"}},"CreateRequestValidator":{"http":{"requestUri":"/restapis/{restapi_id}/requestvalidators","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"output":{"shape":"S1a"}},"CreateResource":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{parent_id}","responseCode":201},"input":{"type":"structure","required":["restApiId","parentId","pathPart"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"parentId":{"location":"uri","locationName":"parent_id"},"pathPart":{}}},"output":{"shape":"S1c"}},"CreateRestApi":{"http":{"requestUri":"/restapis","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"version":{},"cloneFrom":{},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"},"disableExecuteApiEndpoint":{"type":"boolean"}}},"output":{"shape":"S1t"}},"CreateStage":{"http":{"requestUri":"/restapis/{restapi_id}/stages","responseCode":201},"input":{"type":"structure","required":["restApiId","stageName","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"deploymentId":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"documentationVersion":{},"canarySettings":{"shape":"S1v"},"tracingEnabled":{"type":"boolean"},"tags":{"shape":"S6"}}},"output":{"shape":"S1w"}},"CreateUsagePlan":{"http":{"requestUri":"/usageplans","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"apiStages":{"shape":"S23"},"throttle":{"shape":"S26"},"quota":{"shape":"S27"},"tags":{"shape":"S6"}}},"output":{"shape":"S29"}},"CreateUsagePlanKey":{"http":{"requestUri":"/usageplans/{usageplanId}/keys","responseCode":201},"input":{"type":"structure","required":["usagePlanId","keyId","keyType"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{},"keyType":{}}},"output":{"shape":"S2b"}},"CreateVpcLink":{"http":{"requestUri":"/vpclinks","responseCode":202},"input":{"type":"structure","required":["name","targetArns"],"members":{"name":{},"description":{},"targetArns":{"shape":"S9"},"tags":{"shape":"S6"}}},"output":{"shape":"S2d"}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/apikeys/{api_Key}","responseCode":202},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"}}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}}},"DeleteBasePathMapping":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}","responseCode":202},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}}},"DeleteClientCertificate":{"http":{"method":"DELETE","requestUri":"/clientcertificates/{clientcertificate_id}","responseCode":202},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"}}}},"DeleteDocumentationPart":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}}},"DeleteDocumentationVersion":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}","responseCode":202},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}}},"DeleteGatewayResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":202},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteMethod":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteMethodResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/models/{model_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}}},"DeleteRequestValidator":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}}},"DeleteResource":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"}}}},"DeleteRestApi":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}","responseCode":202},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"DeleteUsagePlan":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}}},"DeleteUsagePlanKey":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}}},"DeleteVpcLink":{"http":{"method":"DELETE","requestUri":"/vpclinks/{vpclink_id}","responseCode":202},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}}},"FlushStageAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"FlushStageCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/data","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"GenerateClientCertificate":{"http":{"requestUri":"/clientcertificates","responseCode":201},"input":{"type":"structure","members":{"description":{},"tags":{"shape":"S6"}}},"output":{"shape":"S34"}},"GetAccount":{"http":{"method":"GET","requestUri":"/account"},"input":{"type":"structure","members":{}},"output":{"shape":"S36"}},"GetApiKey":{"http":{"method":"GET","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"includeValue":{"location":"querystring","locationName":"includeValue","type":"boolean"}}},"output":{"shape":"S7"}},"GetApiKeys":{"http":{"method":"GET","requestUri":"/apikeys"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"},"customerId":{"location":"querystring","locationName":"customerId"},"includeValues":{"location":"querystring","locationName":"includeValues","type":"boolean"}}},"output":{"type":"structure","members":{"warnings":{"shape":"S9"},"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S7"}}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}},"output":{"shape":"Sf"}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sf"}}}}},"GetBasePathMapping":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}},"output":{"shape":"Sh"}},"GetBasePathMappings":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sh"}}}}},"GetClientCertificate":{"http":{"method":"GET","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}},"output":{"shape":"S34"}},"GetClientCertificates":{"http":{"method":"GET","requestUri":"/clientcertificates"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S34"}}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"Sn"}},"GetDeployments":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sn"}}}}},"GetDocumentationPart":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}},"output":{"shape":"Sv"}},"GetDocumentationParts":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"type":{"location":"querystring","locationName":"type"},"nameQuery":{"location":"querystring","locationName":"name"},"path":{"location":"querystring","locationName":"path"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"locationStatus":{"location":"querystring","locationName":"locationStatus"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sv"}}}}},"GetDocumentationVersion":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}},"output":{"shape":"Sx"}},"GetDocumentationVersions":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sx"}}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}},"output":{"shape":"S14"}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/domainnames"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S14"}}}}},"GetExport":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","exportType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"exportType":{"location":"uri","locationName":"export_type"},"parameters":{"shape":"S6","location":"querystring"},"accepts":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetGatewayResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}},"output":{"shape":"S48"}},"GetGatewayResponses":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S48"}}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1j"}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1p"}},"GetMethod":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1e"}},"GetMethodResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1h"}},"GetModel":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"flatten":{"location":"querystring","locationName":"flatten","type":"boolean"}}},"output":{"shape":"S18"}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}/default_template"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}},"output":{"type":"structure","members":{"value":{}}}},"GetModels":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S18"}}}}},"GetRequestValidator":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}},"output":{"shape":"S1a"}},"GetRequestValidators":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1a"}}}}},"GetResource":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"S1c"}},"GetResources":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1c"}}}}},"GetRestApi":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}},"output":{"shape":"S1t"}},"GetRestApis":{"http":{"method":"GET","requestUri":"/restapis"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1t"}}}}},"GetSdk":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","sdkType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"sdkType":{"location":"uri","locationName":"sdk_type"},"parameters":{"shape":"S6","location":"querystring"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetSdkType":{"http":{"method":"GET","requestUri":"/sdktypes/{sdktype_id}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"sdktype_id"}}},"output":{"shape":"S51"}},"GetSdkTypes":{"http":{"method":"GET","requestUri":"/sdktypes"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S51"}}}}},"GetStage":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}},"output":{"shape":"S1w"}},"GetStages":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"querystring","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"item":{"type":"list","member":{"shape":"S1w"}}}}},"GetTags":{"http":{"method":"GET","requestUri":"/tags/{resource_arn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"S6"}}}},"GetUsage":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/usage"},"input":{"type":"structure","required":["usagePlanId","startDate","endDate"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"querystring","locationName":"keyId"},"startDate":{"location":"querystring","locationName":"startDate"},"endDate":{"location":"querystring","locationName":"endDate"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"shape":"S5e"}},"GetUsagePlan":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}},"output":{"shape":"S29"}},"GetUsagePlanKey":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":200},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}},"output":{"shape":"S2b"}},"GetUsagePlanKeys":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2b"}}}}},"GetUsagePlans":{"http":{"method":"GET","requestUri":"/usageplans"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"keyId":{"location":"querystring","locationName":"keyId"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S29"}}}}},"GetVpcLink":{"http":{"method":"GET","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}},"output":{"shape":"S2d"}},"GetVpcLinks":{"http":{"method":"GET","requestUri":"/vpclinks"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2d"}}}}},"ImportApiKeys":{"http":{"requestUri":"/apikeys?mode=import","responseCode":201},"input":{"type":"structure","required":["body","format"],"members":{"body":{"type":"blob"},"format":{"location":"querystring","locationName":"format"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportDocumentationParts":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"body":{"type":"blob"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportRestApi":{"http":{"requestUri":"/restapis?mode=import","responseCode":201},"input":{"type":"structure","required":["body"],"members":{"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1t"}},"PutGatewayResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":201},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"}}},"output":{"shape":"S48"}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"type":{},"integrationHttpMethod":{"locationName":"httpMethod"},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"tlsConfig":{"shape":"S1q"}}},"output":{"shape":"S1j"}},"PutIntegrationResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"output":{"shape":"S1p"}},"PutMethod":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","authorizationType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"operationName":{},"requestParameters":{"shape":"S1f"},"requestModels":{"shape":"S6"},"requestValidatorId":{},"authorizationScopes":{"shape":"S9"}}},"output":{"shape":"S1e"}},"PutMethodResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"responseParameters":{"shape":"S1f"},"responseModels":{"shape":"S6"}}},"output":{"shape":"S1h"}},"PutRestApi":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1t"}},"TagResource":{"http":{"method":"PUT","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tags":{"shape":"S6"}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S6a"},"pathWithQueryString":{},"body":{},"stageVariables":{"shape":"S6"},"additionalContext":{"shape":"S6"}}},"output":{"type":"structure","members":{"clientStatus":{"type":"integer"},"log":{},"latency":{"type":"long"},"principalId":{},"policy":{},"authorization":{"shape":"S6a"},"claims":{"shape":"S6"}}}},"TestInvokeMethod":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"pathWithQueryString":{},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S6a"},"clientCertificateId":{},"stageVariables":{"shape":"S6"}}},"output":{"type":"structure","members":{"status":{"type":"integer"},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S6a"},"log":{},"latency":{"type":"long"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tagKeys":{"shape":"S9","location":"querystring","locationName":"tagKeys"}}}},"UpdateAccount":{"http":{"method":"PATCH","requestUri":"/account"},"input":{"type":"structure","members":{"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S36"}},"UpdateApiKey":{"http":{"method":"PATCH","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S7"}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sf"}},"UpdateBasePathMapping":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sh"}},"UpdateClientCertificate":{"http":{"method":"PATCH","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S34"}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sn"}},"UpdateDocumentationPart":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sv"}},"UpdateDocumentationVersion":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sx"}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S14"}},"UpdateGatewayResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S48"}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1j"}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1p"}},"UpdateMethod":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1e"}},"UpdateMethodResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1h"}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S18"}},"UpdateRequestValidator":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1a"}},"UpdateResource":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1c"}},"UpdateRestApi":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1t"}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1w"}},"UpdateUsage":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}/keys/{keyId}/usage"},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S5e"}},"UpdateUsagePlan":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S29"}},"UpdateVpcLink":{"http":{"method":"PATCH","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S2d"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"id":{},"value":{},"name":{},"customerId":{},"description":{},"enabled":{"type":"boolean"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"stageKeys":{"shape":"S9"},"tags":{"shape":"S6"}}},"S9":{"type":"list","member":{}},"Sc":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"id":{},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"Sh":{"type":"structure","members":{"basePath":{},"restApiId":{},"stage":{}}},"Sn":{"type":"structure","members":{"id":{},"description":{},"createdDate":{"type":"timestamp"},"apiSummary":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","members":{"authorizationType":{},"apiKeyRequired":{"type":"boolean"}}}}}}},"Ss":{"type":"structure","required":["type"],"members":{"type":{},"path":{},"method":{},"statusCode":{},"name":{}}},"Sv":{"type":"structure","members":{"id":{},"location":{"shape":"Ss"},"properties":{}}},"Sx":{"type":"structure","members":{"version":{},"createdDate":{"type":"timestamp"},"description":{}}},"Sz":{"type":"structure","members":{"types":{"type":"list","member":{}},"vpcEndpointIds":{"shape":"S9"}}},"S14":{"type":"structure","members":{"domainName":{},"certificateName":{},"certificateArn":{},"certificateUploadDate":{"type":"timestamp"},"regionalDomainName":{},"regionalHostedZoneId":{},"regionalCertificateName":{},"regionalCertificateArn":{},"distributionDomainName":{},"distributionHostedZoneId":{},"endpointConfiguration":{"shape":"Sz"},"domainNameStatus":{},"domainNameStatusMessage":{},"securityPolicy":{},"tags":{"shape":"S6"},"mutualTlsAuthentication":{"type":"structure","members":{"truststoreUri":{},"truststoreVersion":{},"truststoreWarnings":{"shape":"S9"}}},"ownershipVerificationCertificateArn":{}}},"S18":{"type":"structure","members":{"id":{},"name":{},"description":{},"schema":{},"contentType":{}}},"S1a":{"type":"structure","members":{"id":{},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"S1c":{"type":"structure","members":{"id":{},"parentId":{},"pathPart":{},"path":{},"resourceMethods":{"type":"map","key":{},"value":{"shape":"S1e"}}}},"S1e":{"type":"structure","members":{"httpMethod":{},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"requestValidatorId":{},"operationName":{},"requestParameters":{"shape":"S1f"},"requestModels":{"shape":"S6"},"methodResponses":{"type":"map","key":{},"value":{"shape":"S1h"}},"methodIntegration":{"shape":"S1j"},"authorizationScopes":{"shape":"S9"}}},"S1f":{"type":"map","key":{},"value":{"type":"boolean"}},"S1h":{"type":"structure","members":{"statusCode":{},"responseParameters":{"shape":"S1f"},"responseModels":{"shape":"S6"}}},"S1j":{"type":"structure","members":{"type":{},"httpMethod":{},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"integrationResponses":{"type":"map","key":{},"value":{"shape":"S1p"}},"tlsConfig":{"shape":"S1q"}}},"S1p":{"type":"structure","members":{"statusCode":{},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"S1q":{"type":"structure","members":{"insecureSkipVerification":{"type":"boolean"}}},"S1t":{"type":"structure","members":{"id":{},"name":{},"description":{},"createdDate":{"type":"timestamp"},"version":{},"warnings":{"shape":"S9"},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"},"disableExecuteApiEndpoint":{"type":"boolean"}}},"S1v":{"type":"structure","members":{"percentTraffic":{"type":"double"},"deploymentId":{},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"S1w":{"type":"structure","members":{"deploymentId":{},"clientCertificateId":{},"stageName":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"cacheClusterStatus":{},"methodSettings":{"type":"map","key":{},"value":{"type":"structure","members":{"metricsEnabled":{"type":"boolean"},"loggingLevel":{},"dataTraceEnabled":{"type":"boolean"},"throttlingBurstLimit":{"type":"integer"},"throttlingRateLimit":{"type":"double"},"cachingEnabled":{"type":"boolean"},"cacheTtlInSeconds":{"type":"integer"},"cacheDataEncrypted":{"type":"boolean"},"requireAuthorizationForCacheControl":{"type":"boolean"},"unauthorizedCacheControlHeaderStrategy":{}}}},"variables":{"shape":"S6"},"documentationVersion":{},"accessLogSettings":{"type":"structure","members":{"format":{},"destinationArn":{}}},"canarySettings":{"shape":"S1v"},"tracingEnabled":{"type":"boolean"},"webAclArn":{},"tags":{"shape":"S6"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"}}},"S23":{"type":"list","member":{"type":"structure","members":{"apiId":{},"stage":{},"throttle":{"type":"map","key":{},"value":{"shape":"S26"}}}}},"S26":{"type":"structure","members":{"burstLimit":{"type":"integer"},"rateLimit":{"type":"double"}}},"S27":{"type":"structure","members":{"limit":{"type":"integer"},"offset":{"type":"integer"},"period":{}}},"S29":{"type":"structure","members":{"id":{},"name":{},"description":{},"apiStages":{"shape":"S23"},"throttle":{"shape":"S26"},"quota":{"shape":"S27"},"productCode":{},"tags":{"shape":"S6"}}},"S2b":{"type":"structure","members":{"id":{},"type":{},"value":{},"name":{}}},"S2d":{"type":"structure","members":{"id":{},"name":{},"description":{},"targetArns":{"shape":"S9"},"status":{},"statusMessage":{},"tags":{"shape":"S6"}}},"S34":{"type":"structure","members":{"clientCertificateId":{},"description":{},"pemEncodedCertificate":{},"createdDate":{"type":"timestamp"},"expirationDate":{"type":"timestamp"},"tags":{"shape":"S6"}}},"S36":{"type":"structure","members":{"cloudwatchRoleArn":{},"throttleSettings":{"shape":"S26"},"features":{"shape":"S9"},"apiKeyVersion":{}}},"S48":{"type":"structure","members":{"responseType":{},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"defaultResponse":{"type":"boolean"}}},"S51":{"type":"structure","members":{"id":{},"friendlyName":{},"description":{},"configurationProperties":{"type":"list","member":{"type":"structure","members":{"name":{},"friendlyName":{},"description":{},"required":{"type":"boolean"},"defaultValue":{}}}}}},"S5e":{"type":"structure","members":{"usagePlanId":{},"startDate":{},"endDate":{},"position":{},"items":{"locationName":"values","type":"map","key":{},"value":{"type":"list","member":{"type":"list","member":{"type":"long"}}}}}},"S6a":{"type":"map","key":{},"value":{"shape":"S9"}},"S6g":{"type":"list","member":{"type":"structure","members":{"op":{},"path":{},"value":{},"from":{}}}}}}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetApiKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetBasePathMappings":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetClientCertificates":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDeployments":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDomainNames":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetModels":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetResources":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetRestApis":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsage":{"input_token":"position","limit_key":"limit","non_aggregate_keys":["usagePlanId","startDate","endDate"],"output_token":"position","result_key":"items"},"GetUsagePlanKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlans":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetVpcLinks":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"}}}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['applicationautoscaling'] = {};
	AWS.ApplicationAutoScaling = Service.defineService('applicationautoscaling', ['2016-02-06']);
	Object.defineProperty(apiLoader.services['applicationautoscaling'], '2016-02-06', {
	  get: function get() {
	    var model = __webpack_require__(59);
	    model.paginators = __webpack_require__(60).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ApplicationAutoScaling;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-06","endpointPrefix":"application-autoscaling","jsonVersion":"1.1","protocol":"json","serviceFullName":"Application Auto Scaling","serviceId":"Application Auto Scaling","signatureVersion":"v4","signingName":"application-autoscaling","targetPrefix":"AnyScaleFrontendService","uid":"application-autoscaling-2016-02-06"},"operations":{"DeleteScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeregisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DescribeScalableTargets":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceIds":{"shape":"Sb"},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalableTargets":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","RoleARN","CreationTime"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"CreationTime":{"type":"timestamp"},"SuspendedState":{"shape":"Sj"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingActivities":{"type":"list","member":{"type":"structure","required":["ActivityId","ServiceNamespace","ResourceId","ScalableDimension","Description","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Details":{}}}},"NextToken":{}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"PolicyNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyARN","PolicyName","ServiceNamespace","ResourceId","ScalableDimension","PolicyType","CreationTime"],"members":{"PolicyARN":{},"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sx"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S16"},"Alarms":{"shape":"S1k"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScheduledActions":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ScheduledActionNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName","ScheduledActionARN","ServiceNamespace","Schedule","ResourceId","CreationTime"],"members":{"ScheduledActionName":{},"ScheduledActionARN":{},"ServiceNamespace":{},"Schedule":{},"Timezone":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1r"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sx"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S16"}}},"output":{"type":"structure","required":["PolicyARN"],"members":{"PolicyARN":{},"Alarms":{"shape":"S1k"}}}},"PutScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"Schedule":{},"Timezone":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1r"}}},"output":{"type":"structure","members":{}}},"RegisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"SuspendedState":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sb":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"DynamicScalingInSuspended":{"type":"boolean"},"DynamicScalingOutSuspended":{"type":"boolean"},"ScheduledScalingSuspended":{"type":"boolean"}}},"Sx":{"type":"structure","members":{"AdjustmentType":{},"StepAdjustments":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"MinAdjustmentMagnitude":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{}}},"S16":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"DisableScaleIn":{"type":"boolean"}}},"S1k":{"type":"list","member":{"type":"structure","required":["AlarmName","AlarmARN"],"members":{"AlarmName":{},"AlarmARN":{}}}},"S1r":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}}}}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeScalableTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalableTargets"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingActivities"},"DescribeScalingPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledActions"}}}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appstream'] = {};
	AWS.AppStream = Service.defineService('appstream', ['2016-12-01']);
	Object.defineProperty(apiLoader.services['appstream'], '2016-12-01', {
	  get: function get() {
	    var model = __webpack_require__(62);
	    model.paginators = __webpack_require__(63).pagination;
	    model.waiters = __webpack_require__(64).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppStream;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-12-01","endpointPrefix":"appstream2","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon AppStream","serviceId":"AppStream","signatureVersion":"v4","signingName":"appstream","targetPrefix":"PhotonAdminProxyService","uid":"appstream-2016-12-01"},"operations":{"AssociateApplicationFleet":{"input":{"type":"structure","required":["FleetName","ApplicationArn"],"members":{"FleetName":{},"ApplicationArn":{}}},"output":{"type":"structure","members":{"ApplicationFleetAssociation":{"shape":"S5"}}}},"AssociateApplicationToEntitlement":{"input":{"type":"structure","required":["StackName","EntitlementName","ApplicationIdentifier"],"members":{"StackName":{},"EntitlementName":{},"ApplicationIdentifier":{}}},"output":{"type":"structure","members":{}}},"AssociateFleet":{"input":{"type":"structure","required":["FleetName","StackName"],"members":{"FleetName":{},"StackName":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateUserStack":{"input":{"type":"structure","required":["UserStackAssociations"],"members":{"UserStackAssociations":{"shape":"Sc"}}},"output":{"type":"structure","members":{"errors":{"shape":"Si"}}}},"BatchDisassociateUserStack":{"input":{"type":"structure","required":["UserStackAssociations"],"members":{"UserStackAssociations":{"shape":"Sc"}}},"output":{"type":"structure","members":{"errors":{"shape":"Si"}}}},"CopyImage":{"input":{"type":"structure","required":["SourceImageName","DestinationImageName","DestinationRegion"],"members":{"SourceImageName":{},"DestinationImageName":{},"DestinationRegion":{},"DestinationImageDescription":{}}},"output":{"type":"structure","members":{"DestinationImageName":{}}}},"CreateAppBlock":{"input":{"type":"structure","required":["Name","SourceS3Location","SetupScriptDetails"],"members":{"Name":{},"Description":{},"DisplayName":{},"SourceS3Location":{"shape":"St"},"SetupScriptDetails":{"shape":"Sw"},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"AppBlock":{"shape":"S12"}}}},"CreateApplication":{"input":{"type":"structure","required":["Name","IconS3Location","LaunchPath","Platforms","InstanceFamilies","AppBlockArn"],"members":{"Name":{},"DisplayName":{},"Description":{},"IconS3Location":{"shape":"St"},"LaunchPath":{},"WorkingDirectory":{},"LaunchParameters":{},"Platforms":{"shape":"S15"},"InstanceFamilies":{"shape":"S17"},"AppBlockArn":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"Application":{"shape":"S19"}}}},"CreateDirectoryConfig":{"input":{"type":"structure","required":["DirectoryName","OrganizationalUnitDistinguishedNames"],"members":{"DirectoryName":{},"OrganizationalUnitDistinguishedNames":{"shape":"S1d"},"ServiceAccountCredentials":{"shape":"S1f"}}},"output":{"type":"structure","members":{"DirectoryConfig":{"shape":"S1j"}}}},"CreateEntitlement":{"input":{"type":"structure","required":["Name","StackName","AppVisibility","Attributes"],"members":{"Name":{},"StackName":{},"Description":{},"AppVisibility":{},"Attributes":{"shape":"S1m"}}},"output":{"type":"structure","members":{"Entitlement":{"shape":"S1p"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","InstanceType"],"members":{"Name":{},"ImageName":{},"ImageArn":{},"InstanceType":{},"FleetType":{},"ComputeCapacity":{"shape":"S1s"},"VpcConfig":{"shape":"S1t"},"MaxUserDurationInSeconds":{"type":"integer"},"DisconnectTimeoutInSeconds":{"type":"integer"},"Description":{},"DisplayName":{},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S1x"},"Tags":{"shape":"Sy"},"IdleDisconnectTimeoutInSeconds":{"type":"integer"},"IamRoleArn":{},"StreamView":{},"Platform":{},"MaxConcurrentSessions":{"type":"integer"},"UsbDeviceFilterStrings":{"shape":"S1z"},"SessionScriptS3Location":{"shape":"St"}}},"output":{"type":"structure","members":{"Fleet":{"shape":"S22"}}}},"CreateImageBuilder":{"input":{"type":"structure","required":["Name","InstanceType"],"members":{"Name":{},"ImageName":{},"ImageArn":{},"InstanceType":{},"Description":{},"DisplayName":{},"VpcConfig":{"shape":"S1t"},"IamRoleArn":{},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S1x"},"AppstreamAgentVersion":{},"Tags":{"shape":"Sy"},"AccessEndpoints":{"shape":"S2a"}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S2e"}}}},"CreateImageBuilderStreamingURL":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Validity":{"type":"long"}}},"output":{"type":"structure","members":{"StreamingURL":{},"Expires":{"type":"timestamp"}}}},"CreateStack":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"DisplayName":{},"StorageConnectors":{"shape":"S2p"},"RedirectURL":{},"FeedbackURL":{},"UserSettings":{"shape":"S2x"},"ApplicationSettings":{"shape":"S31"},"Tags":{"shape":"Sy"},"AccessEndpoints":{"shape":"S2a"},"EmbedHostDomains":{"shape":"S33"}}},"output":{"type":"structure","members":{"Stack":{"shape":"S36"}}}},"CreateStreamingURL":{"input":{"type":"structure","required":["StackName","FleetName","UserId"],"members":{"StackName":{},"FleetName":{},"UserId":{},"ApplicationId":{},"Validity":{"type":"long"},"SessionContext":{}}},"output":{"type":"structure","members":{"StreamingURL":{},"Expires":{"type":"timestamp"}}}},"CreateUpdatedImage":{"input":{"type":"structure","required":["existingImageName","newImageName"],"members":{"existingImageName":{},"newImageName":{},"newImageDescription":{},"newImageDisplayName":{},"newImageTags":{"shape":"Sy"},"dryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"image":{"shape":"S3g"},"canUpdateImage":{"type":"boolean"}}}},"CreateUsageReportSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"S3BucketName":{},"Schedule":{}}}},"CreateUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"Se"},"MessageAction":{},"FirstName":{"shape":"S3s"},"LastName":{"shape":"S3s"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"DeleteAppBlock":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteApplication":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteDirectoryConfig":{"input":{"type":"structure","required":["DirectoryName"],"members":{"DirectoryName":{}}},"output":{"type":"structure","members":{}}},"DeleteEntitlement":{"input":{"type":"structure","required":["Name","StackName"],"members":{"Name":{},"StackName":{}}},"output":{"type":"structure","members":{}}},"DeleteFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteImage":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Image":{"shape":"S3g"}}}},"DeleteImageBuilder":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S2e"}}}},"DeleteImagePermissions":{"input":{"type":"structure","required":["Name","SharedAccountId"],"members":{"Name":{},"SharedAccountId":{}}},"output":{"type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteUsageReportSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"Se"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"DescribeAppBlocks":{"input":{"type":"structure","members":{"Arns":{"shape":"S4i"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AppBlocks":{"type":"list","member":{"shape":"S12"}},"NextToken":{}}}},"DescribeApplicationFleetAssociations":{"input":{"type":"structure","members":{"FleetName":{},"ApplicationArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationFleetAssociations":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"Arns":{"shape":"S4i"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Applications":{"shape":"S3l"},"NextToken":{}}}},"DescribeDirectoryConfigs":{"input":{"type":"structure","members":{"DirectoryNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DirectoryConfigs":{"type":"list","member":{"shape":"S1j"}},"NextToken":{}}}},"DescribeEntitlements":{"input":{"type":"structure","required":["StackName"],"members":{"Name":{},"StackName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entitlements":{"type":"list","member":{"shape":"S1p"}},"NextToken":{}}}},"DescribeFleets":{"input":{"type":"structure","members":{"Names":{"shape":"S17"},"NextToken":{}}},"output":{"type":"structure","members":{"Fleets":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"DescribeImageBuilders":{"input":{"type":"structure","members":{"Names":{"shape":"S17"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImageBuilders":{"type":"list","member":{"shape":"S2e"}},"NextToken":{}}}},"DescribeImagePermissions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"SharedAwsAccountIds":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"Name":{},"SharedImagePermissionsList":{"type":"list","member":{"type":"structure","required":["sharedAccountId","imagePermissions"],"members":{"sharedAccountId":{},"imagePermissions":{"shape":"S3m"}}}},"NextToken":{}}}},"DescribeImages":{"input":{"type":"structure","members":{"Names":{"shape":"S17"},"Arns":{"shape":"S4i"},"Type":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"shape":"S3g"}},"NextToken":{}}}},"DescribeSessions":{"input":{"type":"structure","required":["StackName","FleetName"],"members":{"StackName":{},"FleetName":{},"UserId":{},"NextToken":{},"Limit":{"type":"integer"},"AuthenticationType":{}}},"output":{"type":"structure","members":{"Sessions":{"type":"list","member":{"type":"structure","required":["Id","UserId","StackName","FleetName","State"],"members":{"Id":{},"UserId":{},"StackName":{},"FleetName":{},"State":{},"ConnectionState":{},"StartTime":{"type":"timestamp"},"MaxExpirationTime":{"type":"timestamp"},"AuthenticationType":{},"NetworkAccessConfiguration":{"shape":"S2i"}}}},"NextToken":{}}}},"DescribeStacks":{"input":{"type":"structure","members":{"Names":{"shape":"S17"},"NextToken":{}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"shape":"S36"}},"NextToken":{}}}},"DescribeUsageReportSubscriptions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UsageReportSubscriptions":{"type":"list","member":{"type":"structure","members":{"S3BucketName":{},"Schedule":{},"LastGeneratedReportDate":{"type":"timestamp"},"SubscriptionErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}}}},"NextToken":{}}}},"DescribeUserStackAssociations":{"input":{"type":"structure","members":{"StackName":{},"UserName":{"shape":"Se"},"AuthenticationType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserStackAssociations":{"shape":"Sc"},"NextToken":{}}}},"DescribeUsers":{"input":{"type":"structure","required":["AuthenticationType"],"members":{"AuthenticationType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","required":["AuthenticationType"],"members":{"Arn":{},"UserName":{"shape":"Se"},"Enabled":{"type":"boolean"},"Status":{},"FirstName":{"shape":"S3s"},"LastName":{"shape":"S3s"},"CreatedTime":{"type":"timestamp"},"AuthenticationType":{}}}},"NextToken":{}}}},"DisableUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"Se"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"DisassociateApplicationFleet":{"input":{"type":"structure","required":["FleetName","ApplicationArn"],"members":{"FleetName":{},"ApplicationArn":{}}},"output":{"type":"structure","members":{}}},"DisassociateApplicationFromEntitlement":{"input":{"type":"structure","required":["StackName","EntitlementName","ApplicationIdentifier"],"members":{"StackName":{},"EntitlementName":{},"ApplicationIdentifier":{}}},"output":{"type":"structure","members":{}}},"DisassociateFleet":{"input":{"type":"structure","required":["FleetName","StackName"],"members":{"FleetName":{},"StackName":{}}},"output":{"type":"structure","members":{}}},"EnableUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"Se"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"ExpireSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{}}},"ListAssociatedFleets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"type":"structure","members":{"Names":{"shape":"S17"},"NextToken":{}}}},"ListAssociatedStacks":{"input":{"type":"structure","required":["FleetName"],"members":{"FleetName":{},"NextToken":{}}},"output":{"type":"structure","members":{"Names":{"shape":"S17"},"NextToken":{}}}},"ListEntitledApplications":{"input":{"type":"structure","required":["StackName","EntitlementName"],"members":{"StackName":{},"EntitlementName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntitledApplications":{"type":"list","member":{"type":"structure","required":["ApplicationIdentifier"],"members":{"ApplicationIdentifier":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sy"}}}},"StartFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StartImageBuilder":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"AppstreamAgentVersion":{}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S2e"}}}},"StopFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StopImageBuilder":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S2e"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DisplayName":{},"Description":{},"IconS3Location":{"shape":"St"},"LaunchPath":{},"WorkingDirectory":{},"LaunchParameters":{},"AppBlockArn":{},"AttributesToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Application":{"shape":"S19"}}}},"UpdateDirectoryConfig":{"input":{"type":"structure","required":["DirectoryName"],"members":{"DirectoryName":{},"OrganizationalUnitDistinguishedNames":{"shape":"S1d"},"ServiceAccountCredentials":{"shape":"S1f"}}},"output":{"type":"structure","members":{"DirectoryConfig":{"shape":"S1j"}}}},"UpdateEntitlement":{"input":{"type":"structure","required":["Name","StackName"],"members":{"Name":{},"StackName":{},"Description":{},"AppVisibility":{},"Attributes":{"shape":"S1m"}}},"output":{"type":"structure","members":{"Entitlement":{"shape":"S1p"}}}},"UpdateFleet":{"input":{"type":"structure","members":{"ImageName":{},"ImageArn":{},"Name":{},"InstanceType":{},"ComputeCapacity":{"shape":"S1s"},"VpcConfig":{"shape":"S1t"},"MaxUserDurationInSeconds":{"type":"integer"},"DisconnectTimeoutInSeconds":{"type":"integer"},"DeleteVpcConfig":{"deprecated":true,"type":"boolean"},"Description":{},"DisplayName":{},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S1x"},"IdleDisconnectTimeoutInSeconds":{"type":"integer"},"AttributesToDelete":{"type":"list","member":{}},"IamRoleArn":{},"StreamView":{},"Platform":{},"MaxConcurrentSessions":{"type":"integer"},"UsbDeviceFilterStrings":{"shape":"S1z"},"SessionScriptS3Location":{"shape":"St"}}},"output":{"type":"structure","members":{"Fleet":{"shape":"S22"}}}},"UpdateImagePermissions":{"input":{"type":"structure","required":["Name","SharedAccountId","ImagePermissions"],"members":{"Name":{},"SharedAccountId":{},"ImagePermissions":{"shape":"S3m"}}},"output":{"type":"structure","members":{}}},"UpdateStack":{"input":{"type":"structure","required":["Name"],"members":{"DisplayName":{},"Description":{},"Name":{},"StorageConnectors":{"shape":"S2p"},"DeleteStorageConnectors":{"deprecated":true,"type":"boolean"},"RedirectURL":{},"FeedbackURL":{},"AttributesToDelete":{"type":"list","member":{}},"UserSettings":{"shape":"S2x"},"ApplicationSettings":{"shape":"S31"},"AccessEndpoints":{"shape":"S2a"},"EmbedHostDomains":{"shape":"S33"}}},"output":{"type":"structure","members":{"Stack":{"shape":"S36"}}}}},"shapes":{"S5":{"type":"structure","required":["FleetName","ApplicationArn"],"members":{"FleetName":{},"ApplicationArn":{}}},"Sc":{"type":"list","member":{"shape":"Sd"}},"Sd":{"type":"structure","required":["StackName","UserName","AuthenticationType"],"members":{"StackName":{},"UserName":{"shape":"Se"},"AuthenticationType":{},"SendEmailNotification":{"type":"boolean"}}},"Se":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","members":{"UserStackAssociation":{"shape":"Sd"},"ErrorCode":{},"ErrorMessage":{}}}},"St":{"type":"structure","required":["S3Bucket","S3Key"],"members":{"S3Bucket":{},"S3Key":{}}},"Sw":{"type":"structure","required":["ScriptS3Location","ExecutablePath","TimeoutInSeconds"],"members":{"ScriptS3Location":{"shape":"St"},"ExecutablePath":{},"ExecutableParameters":{},"TimeoutInSeconds":{"type":"integer"}}},"Sy":{"type":"map","key":{},"value":{}},"S12":{"type":"structure","required":["Name","Arn","SetupScriptDetails"],"members":{"Name":{},"Arn":{},"Description":{},"DisplayName":{},"SourceS3Location":{"shape":"St"},"SetupScriptDetails":{"shape":"Sw"},"CreatedTime":{"type":"timestamp"}}},"S15":{"type":"list","member":{}},"S17":{"type":"list","member":{}},"S19":{"type":"structure","members":{"Name":{},"DisplayName":{},"IconURL":{},"LaunchPath":{},"LaunchParameters":{},"Enabled":{"type":"boolean"},"Metadata":{"type":"map","key":{},"value":{}},"WorkingDirectory":{},"Description":{},"Arn":{},"AppBlockArn":{},"IconS3Location":{"shape":"St"},"Platforms":{"shape":"S15"},"InstanceFamilies":{"shape":"S17"},"CreatedTime":{"type":"timestamp"}}},"S1d":{"type":"list","member":{}},"S1f":{"type":"structure","required":["AccountName","AccountPassword"],"members":{"AccountName":{"type":"string","sensitive":true},"AccountPassword":{"type":"string","sensitive":true}}},"S1j":{"type":"structure","required":["DirectoryName"],"members":{"DirectoryName":{},"OrganizationalUnitDistinguishedNames":{"shape":"S1d"},"ServiceAccountCredentials":{"shape":"S1f"},"CreatedTime":{"type":"timestamp"}}},"S1m":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S1p":{"type":"structure","required":["Name","StackName","AppVisibility","Attributes"],"members":{"Name":{},"StackName":{},"Description":{},"AppVisibility":{},"Attributes":{"shape":"S1m"},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}},"S1s":{"type":"structure","required":["DesiredInstances"],"members":{"DesiredInstances":{"type":"integer"}}},"S1t":{"type":"structure","members":{"SubnetIds":{"type":"list","member":{}},"SecurityGroupIds":{"type":"list","member":{}}}},"S1x":{"type":"structure","members":{"DirectoryName":{},"OrganizationalUnitDistinguishedName":{}}},"S1z":{"type":"list","member":{}},"S22":{"type":"structure","required":["Arn","Name","InstanceType","ComputeCapacityStatus","State"],"members":{"Arn":{},"Name":{},"DisplayName":{},"Description":{},"ImageName":{},"ImageArn":{},"InstanceType":{},"FleetType":{},"ComputeCapacityStatus":{"type":"structure","required":["Desired"],"members":{"Desired":{"type":"integer"},"Running":{"type":"integer"},"InUse":{"type":"integer"},"Available":{"type":"integer"}}},"MaxUserDurationInSeconds":{"type":"integer"},"DisconnectTimeoutInSeconds":{"type":"integer"},"State":{},"VpcConfig":{"shape":"S1t"},"CreatedTime":{"type":"timestamp"},"FleetErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S1x"},"IdleDisconnectTimeoutInSeconds":{"type":"integer"},"IamRoleArn":{},"StreamView":{},"Platform":{},"MaxConcurrentSessions":{"type":"integer"},"UsbDeviceFilterStrings":{"shape":"S1z"},"SessionScriptS3Location":{"shape":"St"}}},"S2a":{"type":"list","member":{"type":"structure","required":["EndpointType"],"members":{"EndpointType":{},"VpceId":{}}}},"S2e":{"type":"structure","required":["Name"],"members":{"Name":{},"Arn":{},"ImageArn":{},"Description":{},"DisplayName":{},"VpcConfig":{"shape":"S1t"},"InstanceType":{},"Platform":{},"IamRoleArn":{},"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"CreatedTime":{"type":"timestamp"},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S1x"},"NetworkAccessConfiguration":{"shape":"S2i"},"ImageBuilderErrors":{"shape":"S2j"},"AppstreamAgentVersion":{},"AccessEndpoints":{"shape":"S2a"}}},"S2i":{"type":"structure","members":{"EniPrivateIpAddress":{},"EniId":{}}},"S2j":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{},"ErrorTimestamp":{"type":"timestamp"}}}},"S2p":{"type":"list","member":{"type":"structure","required":["ConnectorType"],"members":{"ConnectorType":{},"ResourceIdentifier":{},"Domains":{"type":"list","member":{}}}}},"S2x":{"type":"list","member":{"type":"structure","required":["Action","Permission"],"members":{"Action":{},"Permission":{}}}},"S31":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"SettingsGroup":{}}},"S33":{"type":"list","member":{}},"S36":{"type":"structure","required":["Name"],"members":{"Arn":{},"Name":{},"Description":{},"DisplayName":{},"CreatedTime":{"type":"timestamp"},"StorageConnectors":{"shape":"S2p"},"RedirectURL":{},"FeedbackURL":{},"StackErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"UserSettings":{"shape":"S2x"},"ApplicationSettings":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SettingsGroup":{},"S3BucketName":{}}},"AccessEndpoints":{"shape":"S2a"},"EmbedHostDomains":{"shape":"S33"}}},"S3g":{"type":"structure","required":["Name"],"members":{"Name":{},"Arn":{},"BaseImageArn":{},"DisplayName":{},"State":{},"Visibility":{},"ImageBuilderSupported":{"type":"boolean"},"ImageBuilderName":{},"Platform":{},"Description":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Applications":{"shape":"S3l"},"CreatedTime":{"type":"timestamp"},"PublicBaseImageReleasedDate":{"type":"timestamp"},"AppstreamAgentVersion":{},"ImagePermissions":{"shape":"S3m"},"ImageErrors":{"shape":"S2j"}}},"S3l":{"type":"list","member":{"shape":"S19"}},"S3m":{"type":"structure","members":{"allowFleet":{"type":"boolean"},"allowImageBuilder":{"type":"boolean"}}},"S3s":{"type":"string","sensitive":true},"S4i":{"type":"list","member":{}}}}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeImagePermissions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeImages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"FleetStarted":{"delay":30,"maxAttempts":40,"operation":"DescribeFleets","acceptors":[{"state":"success","matcher":"pathAll","argument":"Fleets[].State","expected":"ACTIVE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"PENDING_DEACTIVATE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"INACTIVE"}]},"FleetStopped":{"delay":30,"maxAttempts":40,"operation":"DescribeFleets","acceptors":[{"state":"success","matcher":"pathAll","argument":"Fleets[].State","expected":"INACTIVE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"PENDING_ACTIVATE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"ACTIVE"}]}}}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['autoscaling'] = {};
	AWS.AutoScaling = Service.defineService('autoscaling', ['2011-01-01']);
	Object.defineProperty(apiLoader.services['autoscaling'], '2011-01-01', {
	  get: function get() {
	    var model = __webpack_require__(66);
	    model.paginators = __webpack_require__(67).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AutoScaling;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-01-01","endpointPrefix":"autoscaling","protocol":"query","serviceFullName":"Auto Scaling","serviceId":"Auto Scaling","signatureVersion":"v4","uid":"autoscaling-2011-01-01","xmlNamespace":"http://autoscaling.amazonaws.com/doc/2011-01-01/"},"operations":{"AttachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}}},"AttachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"AttachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"AttachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"AttachLoadBalancersResult","type":"structure","members":{}}},"BatchDeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionNames"],"members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Sd"}}},"output":{"resultWrapper":"BatchDeleteScheduledActionResult","type":"structure","members":{"FailedScheduledActions":{"shape":"Sf"}}}},"BatchPutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledUpdateGroupActions"],"members":{"AutoScalingGroupName":{},"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"TimeZone":{}}}}}},"output":{"resultWrapper":"BatchPutScheduledUpdateGroupActionResult","type":"structure","members":{"FailedScheduledUpdateGroupActions":{"shape":"Sf"}}}},"CancelInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{}}},"output":{"resultWrapper":"CancelInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"CompleteLifecycleAction":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName","LifecycleActionResult"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"LifecycleActionResult":{},"InstanceId":{}}},"output":{"resultWrapper":"CompleteLifecycleActionResult","type":"structure","members":{}}},"CreateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"},"InstanceId":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S26"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S29"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"CapacityRebalance":{"type":"boolean"},"LifecycleHookSpecificationList":{"type":"list","member":{"type":"structure","required":["LifecycleHookName","LifecycleTransition"],"members":{"LifecycleHookName":{},"LifecycleTransition":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{},"NotificationTargetARN":{},"RoleARN":{}}}},"Tags":{"shape":"S2j"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"},"Context":{},"DesiredCapacityType":{},"DefaultInstanceWarmup":{"type":"integer"}}}},"CreateLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S2s"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S2t"},"UserData":{},"InstanceId":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S2v"},"InstanceMonitoring":{"shape":"S35"},"SpotPrice":{},"IamInstanceProfile":{},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{},"MetadataOptions":{"shape":"S3a"}}}},"CreateOrUpdateTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2j"}}}},"DeleteAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}}},"DeleteLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{}}}},"DeleteLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"DeleteLifecycleHookResult","type":"structure","members":{}}},"DeleteNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN"],"members":{"AutoScalingGroupName":{},"TopicARN":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2j"}}}},"DeleteWarmPool":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteWarmPoolResult","type":"structure","members":{}}},"DescribeAccountLimits":{"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"MaxNumberOfAutoScalingGroups":{"type":"integer"},"MaxNumberOfLaunchConfigurations":{"type":"integer"},"NumberOfAutoScalingGroups":{"type":"integer"},"NumberOfLaunchConfigurations":{"type":"integer"}}}},"DescribeAdjustmentTypes":{"output":{"resultWrapper":"DescribeAdjustmentTypesResult","type":"structure","members":{"AdjustmentTypes":{"type":"list","member":{"type":"structure","members":{"AdjustmentType":{}}}}}}},"DescribeAutoScalingGroups":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S3z"},"NextToken":{},"MaxRecords":{"type":"integer"},"Filters":{"shape":"S41"}}},"output":{"resultWrapper":"DescribeAutoScalingGroupsResult","type":"structure","required":["AutoScalingGroups"],"members":{"AutoScalingGroups":{"type":"list","member":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize","DesiredCapacity","DefaultCooldown","AvailabilityZones","HealthCheckType","CreatedTime"],"members":{"AutoScalingGroupName":{},"AutoScalingGroupARN":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"PredictedCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S26"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"Instances":{"shape":"S48"},"CreatedTime":{"type":"timestamp"},"SuspendedProcesses":{"type":"list","member":{"type":"structure","members":{"ProcessName":{},"SuspensionReason":{}}}},"PlacementGroup":{},"VPCZoneIdentifier":{},"EnabledMetrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Granularity":{}}}},"Status":{},"Tags":{"shape":"S4f"},"TerminationPolicies":{"shape":"S29"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"},"CapacityRebalance":{"type":"boolean"},"WarmPoolConfiguration":{"shape":"S4h"},"WarmPoolSize":{"type":"integer"},"Context":{},"DesiredCapacityType":{},"DefaultInstanceWarmup":{"type":"integer"}}}},"NextToken":{}}}},"DescribeAutoScalingInstances":{"input":{"type":"structure","members":{"InstanceIds":{"shape":"S2"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAutoScalingInstancesResult","type":"structure","members":{"AutoScalingInstances":{"type":"list","member":{"type":"structure","required":["InstanceId","AutoScalingGroupName","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"InstanceType":{},"AutoScalingGroupName":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"ProtectedFromScaleIn":{"type":"boolean"},"WeightedCapacity":{}}}},"NextToken":{}}}},"DescribeAutoScalingNotificationTypes":{"output":{"resultWrapper":"DescribeAutoScalingNotificationTypesResult","type":"structure","members":{"AutoScalingNotificationTypes":{"shape":"S4u"}}}},"DescribeInstanceRefreshes":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"InstanceRefreshIds":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeInstanceRefreshesResult","type":"structure","members":{"InstanceRefreshes":{"type":"list","member":{"type":"structure","members":{"InstanceRefreshId":{},"AutoScalingGroupName":{},"Status":{},"StatusReason":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"},"ProgressDetails":{"type":"structure","members":{"LivePoolProgress":{"type":"structure","members":{"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"}}},"WarmPoolProgress":{"type":"structure","members":{"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"}}}}},"Preferences":{"shape":"S56"},"DesiredConfiguration":{"shape":"S5c"}}}},"NextToken":{}}}},"DescribeLaunchConfigurations":{"input":{"type":"structure","members":{"LaunchConfigurationNames":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLaunchConfigurationsResult","type":"structure","required":["LaunchConfigurations"],"members":{"LaunchConfigurations":{"type":"list","member":{"type":"structure","required":["LaunchConfigurationName","ImageId","InstanceType","CreatedTime"],"members":{"LaunchConfigurationName":{},"LaunchConfigurationARN":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S2s"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S2t"},"UserData":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S2v"},"InstanceMonitoring":{"shape":"S35"},"SpotPrice":{},"IamInstanceProfile":{},"CreatedTime":{"type":"timestamp"},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{},"MetadataOptions":{"shape":"S3a"}}}},"NextToken":{}}}},"DescribeLifecycleHookTypes":{"output":{"resultWrapper":"DescribeLifecycleHookTypesResult","type":"structure","members":{"LifecycleHookTypes":{"shape":"S4u"}}}},"DescribeLifecycleHooks":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LifecycleHookNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLifecycleHooksResult","type":"structure","members":{"LifecycleHooks":{"type":"list","member":{"type":"structure","members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"NotificationTargetARN":{},"RoleARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"GlobalTimeout":{"type":"integer"},"DefaultResult":{}}}}}}},"DescribeLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancerTargetGroupsResult","type":"structure","members":{"LoadBalancerTargetGroups":{"type":"list","member":{"type":"structure","members":{"LoadBalancerTargetGroupARN":{},"State":{}}}},"NextToken":{}}}},"DescribeLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"State":{}}}},"NextToken":{}}}},"DescribeMetricCollectionTypes":{"output":{"resultWrapper":"DescribeMetricCollectionTypesResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{}}}},"Granularities":{"type":"list","member":{"type":"structure","members":{"Granularity":{}}}}}}},"DescribeNotificationConfigurations":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S3z"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNotificationConfigurationsResult","type":"structure","required":["NotificationConfigurations"],"members":{"NotificationConfigurations":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationType":{}}}},"NextToken":{}}}},"DescribePolicies":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyNames":{"type":"list","member":{}},"PolicyTypes":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePoliciesResult","type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyARN":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S6c"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"StepAdjustments":{"shape":"S6f"},"MetricAggregationType":{},"EstimatedInstanceWarmup":{"type":"integer"},"Alarms":{"shape":"S6j"},"TargetTrackingConfiguration":{"shape":"S6l"},"Enabled":{"type":"boolean"},"PredictiveScalingConfiguration":{"shape":"S6z"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","members":{"ActivityIds":{"type":"list","member":{}},"AutoScalingGroupName":{},"IncludeDeletedGroups":{"type":"boolean"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeScalingActivitiesResult","type":"structure","required":["Activities"],"members":{"Activities":{"shape":"S7q"},"NextToken":{}}}},"DescribeScalingProcessTypes":{"output":{"resultWrapper":"DescribeScalingProcessTypesResult","type":"structure","members":{"Processes":{"type":"list","member":{"type":"structure","required":["ProcessName"],"members":{"ProcessName":{}}}}}}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Sd"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"ScheduledActionARN":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"TimeZone":{}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"Filters":{"shape":"S41"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"Tags":{"shape":"S4f"},"NextToken":{}}}},"DescribeTerminationPolicyTypes":{"output":{"resultWrapper":"DescribeTerminationPolicyTypesResult","type":"structure","members":{"TerminationPolicyTypes":{"shape":"S29"}}}},"DescribeWarmPool":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeWarmPoolResult","type":"structure","members":{"WarmPoolConfiguration":{"shape":"S4h"},"Instances":{"shape":"S48"},"NextToken":{}}}},"DetachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"DetachInstancesResult","type":"structure","members":{"Activities":{"shape":"S7q"}}}},"DetachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"DetachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"DetachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"DetachLoadBalancersResult","type":"structure","members":{}}},"DisableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S8f"}}}},"EnableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName","Granularity"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S8f"},"Granularity":{}}}},"EnterStandby":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"EnterStandbyResult","type":"structure","members":{"Activities":{"shape":"S7q"}}}},"ExecutePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"HonorCooldown":{"type":"boolean"},"MetricValue":{"type":"double"},"BreachThreshold":{"type":"double"}}}},"ExitStandby":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"ExitStandbyResult","type":"structure","members":{"Activities":{"shape":"S7q"}}}},"GetPredictiveScalingForecast":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName","StartTime","EndTime"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"output":{"resultWrapper":"GetPredictiveScalingForecastResult","type":"structure","required":["LoadForecast","CapacityForecast","UpdateTime"],"members":{"LoadForecast":{"type":"list","member":{"type":"structure","required":["Timestamps","Values","MetricSpecification"],"members":{"Timestamps":{"shape":"S8r"},"Values":{"shape":"S8s"},"MetricSpecification":{"shape":"S71"}}}},"CapacityForecast":{"type":"structure","required":["Timestamps","Values"],"members":{"Timestamps":{"shape":"S8r"},"Values":{"shape":"S8s"}}},"UpdateTime":{"type":"timestamp"}}}},"PutLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"RoleARN":{},"NotificationTargetARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{}}},"output":{"resultWrapper":"PutLifecycleHookResult","type":"structure","members":{}}},"PutNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN","NotificationTypes"],"members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationTypes":{"shape":"S4u"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S6c"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{},"StepAdjustments":{"shape":"S6f"},"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"shape":"S6l"},"Enabled":{"type":"boolean"},"PredictiveScalingConfiguration":{"shape":"S6z"}}},"output":{"resultWrapper":"PutScalingPolicyResult","type":"structure","members":{"PolicyARN":{},"Alarms":{"shape":"S6j"}}}},"PutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"TimeZone":{}}}},"PutWarmPool":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"MaxGroupPreparedCapacity":{"type":"integer"},"MinSize":{"type":"integer"},"PoolState":{},"InstanceReusePolicy":{"shape":"S4m"}}},"output":{"resultWrapper":"PutWarmPoolResult","type":"structure","members":{}}},"RecordLifecycleActionHeartbeat":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"InstanceId":{}}},"output":{"resultWrapper":"RecordLifecycleActionHeartbeatResult","type":"structure","members":{}}},"ResumeProcesses":{"input":{"shape":"S94"}},"SetDesiredCapacity":{"input":{"type":"structure","required":["AutoScalingGroupName","DesiredCapacity"],"members":{"AutoScalingGroupName":{},"DesiredCapacity":{"type":"integer"},"HonorCooldown":{"type":"boolean"}}}},"SetInstanceHealth":{"input":{"type":"structure","required":["InstanceId","HealthStatus"],"members":{"InstanceId":{},"HealthStatus":{},"ShouldRespectGracePeriod":{"type":"boolean"}}}},"SetInstanceProtection":{"input":{"type":"structure","required":["InstanceIds","AutoScalingGroupName","ProtectedFromScaleIn"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ProtectedFromScaleIn":{"type":"boolean"}}},"output":{"resultWrapper":"SetInstanceProtectionResult","type":"structure","members":{}}},"StartInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Strategy":{},"DesiredConfiguration":{"shape":"S5c"},"Preferences":{"shape":"S56"}}},"output":{"resultWrapper":"StartInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"SuspendProcesses":{"input":{"shape":"S94"}},"TerminateInstanceInAutoScalingGroup":{"input":{"type":"structure","required":["InstanceId","ShouldDecrementDesiredCapacity"],"members":{"InstanceId":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"TerminateInstanceInAutoScalingGroupResult","type":"structure","members":{"Activity":{"shape":"S7r"}}}},"UpdateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S26"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S29"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"},"CapacityRebalance":{"type":"boolean"},"Context":{},"DesiredCapacityType":{},"DefaultInstanceWarmup":{"type":"integer"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sf":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"ErrorCode":{},"ErrorMessage":{}}}},"S10":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"S12":{"type":"structure","members":{"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S10"},"Overrides":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{},"LaunchTemplateSpecification":{"shape":"S10"},"InstanceRequirements":{"type":"structure","required":["VCpuCount","MemoryMiB"],"members":{"VCpuCount":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"MemoryMiB":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"CpuManufacturers":{"type":"list","member":{}},"MemoryGiBPerVCpu":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"ExcludedInstanceTypes":{"type":"list","member":{}},"InstanceGenerations":{"type":"list","member":{}},"SpotMaxPricePercentageOverLowestPrice":{"type":"integer"},"OnDemandMaxPricePercentageOverLowestPrice":{"type":"integer"},"BareMetal":{},"BurstablePerformance":{},"RequireHibernateSupport":{"type":"boolean"},"NetworkInterfaceCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"LocalStorage":{},"LocalStorageTypes":{"type":"list","member":{}},"TotalLocalStorageGB":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"BaselineEbsBandwidthMbps":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorTypes":{"type":"list","member":{}},"AcceleratorCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorManufacturers":{"type":"list","member":{}},"AcceleratorNames":{"type":"list","member":{}},"AcceleratorTotalMemoryMiB":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}}}}}}}}},"InstancesDistribution":{"type":"structure","members":{"OnDemandAllocationStrategy":{},"OnDemandBaseCapacity":{"type":"integer"},"OnDemandPercentageAboveBaseCapacity":{"type":"integer"},"SpotAllocationStrategy":{},"SpotInstancePools":{"type":"integer"},"SpotMaxPrice":{}}}}},"S26":{"type":"list","member":{}},"S29":{"type":"list","member":{}},"S2j":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S2s":{"type":"list","member":{}},"S2t":{"type":"list","member":{}},"S2v":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"VirtualName":{},"DeviceName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"},"Throughput":{"type":"integer"}}},"NoDevice":{"type":"boolean"}}}},"S35":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S3a":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{}}},"S3z":{"type":"list","member":{}},"S41":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S48":{"type":"list","member":{"type":"structure","required":["InstanceId","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"InstanceType":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S10"},"ProtectedFromScaleIn":{"type":"boolean"},"WeightedCapacity":{}}}},"S4f":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S4h":{"type":"structure","members":{"MaxGroupPreparedCapacity":{"type":"integer"},"MinSize":{"type":"integer"},"PoolState":{},"Status":{},"InstanceReusePolicy":{"shape":"S4m"}}},"S4m":{"type":"structure","members":{"ReuseOnScaleIn":{"type":"boolean"}}},"S4u":{"type":"list","member":{}},"S56":{"type":"structure","members":{"MinHealthyPercentage":{"type":"integer"},"InstanceWarmup":{"type":"integer"},"CheckpointPercentages":{"type":"list","member":{"type":"integer"}},"CheckpointDelay":{"type":"integer"},"SkipMatching":{"type":"boolean"}}},"S5c":{"type":"structure","members":{"LaunchTemplate":{"shape":"S10"},"MixedInstancesPolicy":{"shape":"S12"}}},"S6c":{"type":"integer","deprecated":true},"S6f":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"S6j":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmARN":{}}}},"S6l":{"type":"structure","required":["TargetValue"],"members":{"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"shape":"S6r"},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"}}},"S6r":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S6z":{"type":"structure","required":["MetricSpecifications"],"members":{"MetricSpecifications":{"type":"list","member":{"shape":"S71"}},"Mode":{},"SchedulingBufferTime":{"type":"integer"},"MaxCapacityBreachBehavior":{},"MaxCapacityBuffer":{"type":"integer"}}},"S71":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricPairSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"PredefinedScalingMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"PredefinedLoadMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedScalingMetricSpecification":{"type":"structure","required":["MetricDataQueries"],"members":{"MetricDataQueries":{"shape":"S79"}}},"CustomizedLoadMetricSpecification":{"type":"structure","required":["MetricDataQueries"],"members":{"MetricDataQueries":{"shape":"S79"}}},"CustomizedCapacityMetricSpecification":{"type":"structure","required":["MetricDataQueries"],"members":{"MetricDataQueries":{"shape":"S79"}}}}},"S79":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"Expression":{},"MetricStat":{"type":"structure","required":["Metric","Stat"],"members":{"Metric":{"type":"structure","required":["Namespace","MetricName"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S6r"}}},"Stat":{},"Unit":{}}},"Label":{},"ReturnData":{"type":"boolean"}}}},"S7q":{"type":"list","member":{"shape":"S7r"}},"S7r":{"type":"structure","required":["ActivityId","AutoScalingGroupName","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"AutoScalingGroupName":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Progress":{"type":"integer"},"Details":{},"AutoScalingGroupState":{},"AutoScalingGroupARN":{}}},"S8f":{"type":"list","member":{}},"S8r":{"type":"list","member":{"type":"timestamp"}},"S8s":{"type":"list","member":{"type":"double"}},"S94":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ScalingProcesses":{"type":"list","member":{}}}}}}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAutoScalingGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingGroups"},"DescribeAutoScalingInstances":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingInstances"},"DescribeLaunchConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"LaunchConfigurations"},"DescribeNotificationConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"NotificationConfigurations"},"DescribePolicies":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Activities"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScheduledUpdateGroupActions"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['batch'] = {};
	AWS.Batch = Service.defineService('batch', ['2016-08-10']);
	Object.defineProperty(apiLoader.services['batch'], '2016-08-10', {
	  get: function get() {
	    var model = __webpack_require__(69);
	    model.paginators = __webpack_require__(70).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Batch;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-08-10","endpointPrefix":"batch","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWS Batch","serviceFullName":"AWS Batch","serviceId":"Batch","signatureVersion":"v4","uid":"batch-2016-08-10"},"operations":{"CancelJob":{"http":{"requestUri":"/v1/canceljob"},"input":{"type":"structure","required":["jobId","reason"],"members":{"jobId":{},"reason":{}}},"output":{"type":"structure","members":{}}},"CreateComputeEnvironment":{"http":{"requestUri":"/v1/createcomputeenvironment"},"input":{"type":"structure","required":["computeEnvironmentName","type"],"members":{"computeEnvironmentName":{},"type":{},"state":{},"unmanagedvCpus":{"type":"integer"},"computeResources":{"shape":"S8"},"serviceRole":{},"tags":{"shape":"Si"}}},"output":{"type":"structure","members":{"computeEnvironmentName":{},"computeEnvironmentArn":{}}}},"CreateJobQueue":{"http":{"requestUri":"/v1/createjobqueue"},"input":{"type":"structure","required":["jobQueueName","priority","computeEnvironmentOrder"],"members":{"jobQueueName":{},"state":{},"schedulingPolicyArn":{},"priority":{"type":"integer"},"computeEnvironmentOrder":{"shape":"So"},"tags":{"shape":"Si"}}},"output":{"type":"structure","required":["jobQueueName","jobQueueArn"],"members":{"jobQueueName":{},"jobQueueArn":{}}}},"CreateSchedulingPolicy":{"http":{"requestUri":"/v1/createschedulingpolicy"},"input":{"type":"structure","required":["name"],"members":{"name":{},"fairsharePolicy":{"shape":"Ss"},"tags":{"shape":"Si"}}},"output":{"type":"structure","required":["name","arn"],"members":{"name":{},"arn":{}}}},"DeleteComputeEnvironment":{"http":{"requestUri":"/v1/deletecomputeenvironment"},"input":{"type":"structure","required":["computeEnvironment"],"members":{"computeEnvironment":{}}},"output":{"type":"structure","members":{}}},"DeleteJobQueue":{"http":{"requestUri":"/v1/deletejobqueue"},"input":{"type":"structure","required":["jobQueue"],"members":{"jobQueue":{}}},"output":{"type":"structure","members":{}}},"DeleteSchedulingPolicy":{"http":{"requestUri":"/v1/deleteschedulingpolicy"},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeregisterJobDefinition":{"http":{"requestUri":"/v1/deregisterjobdefinition"},"input":{"type":"structure","required":["jobDefinition"],"members":{"jobDefinition":{}}},"output":{"type":"structure","members":{}}},"DescribeComputeEnvironments":{"http":{"requestUri":"/v1/describecomputeenvironments"},"input":{"type":"structure","members":{"computeEnvironments":{"shape":"Sb"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"computeEnvironments":{"type":"list","member":{"type":"structure","required":["computeEnvironmentName","computeEnvironmentArn"],"members":{"computeEnvironmentName":{},"computeEnvironmentArn":{},"unmanagedvCpus":{"type":"integer"},"ecsClusterArn":{},"tags":{"shape":"Si"},"type":{},"state":{},"status":{},"statusReason":{},"computeResources":{"shape":"S8"},"serviceRole":{},"updatePolicy":{"shape":"S1a"}}}},"nextToken":{}}}},"DescribeJobDefinitions":{"http":{"requestUri":"/v1/describejobdefinitions"},"input":{"type":"structure","members":{"jobDefinitions":{"shape":"Sb"},"maxResults":{"type":"integer"},"jobDefinitionName":{},"status":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobDefinitions":{"type":"list","member":{"type":"structure","required":["jobDefinitionName","jobDefinitionArn","revision","type"],"members":{"jobDefinitionName":{},"jobDefinitionArn":{},"revision":{"type":"integer"},"status":{},"type":{},"schedulingPriority":{"type":"integer"},"parameters":{"shape":"S1h"},"retryStrategy":{"shape":"S1i"},"containerProperties":{"shape":"S1m"},"timeout":{"shape":"S2i"},"nodeProperties":{"shape":"S2j"},"tags":{"shape":"Si"},"propagateTags":{"type":"boolean"},"platformCapabilities":{"shape":"S2m"}}}},"nextToken":{}}}},"DescribeJobQueues":{"http":{"requestUri":"/v1/describejobqueues"},"input":{"type":"structure","members":{"jobQueues":{"shape":"Sb"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"jobQueues":{"type":"list","member":{"type":"structure","required":["jobQueueName","jobQueueArn","state","priority","computeEnvironmentOrder"],"members":{"jobQueueName":{},"jobQueueArn":{},"state":{},"schedulingPolicyArn":{},"status":{},"statusReason":{},"priority":{"type":"integer"},"computeEnvironmentOrder":{"shape":"So"},"tags":{"shape":"Si"}}}},"nextToken":{}}}},"DescribeJobs":{"http":{"requestUri":"/v1/describejobs"},"input":{"type":"structure","required":["jobs"],"members":{"jobs":{"shape":"Sb"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","required":["jobName","jobId","jobQueue","status","startedAt","jobDefinition"],"members":{"jobArn":{},"jobName":{},"jobId":{},"jobQueue":{},"status":{},"shareIdentifier":{},"schedulingPriority":{"type":"integer"},"attempts":{"type":"list","member":{"type":"structure","members":{"container":{"type":"structure","members":{"containerInstanceArn":{},"taskArn":{},"exitCode":{"type":"integer"},"reason":{},"logStreamName":{},"networkInterfaces":{"shape":"S31"}}},"startedAt":{"type":"long"},"stoppedAt":{"type":"long"},"statusReason":{}}}},"statusReason":{},"createdAt":{"type":"long"},"retryStrategy":{"shape":"S1i"},"startedAt":{"type":"long"},"stoppedAt":{"type":"long"},"dependsOn":{"shape":"S34"},"jobDefinition":{},"parameters":{"shape":"S1h"},"container":{"type":"structure","members":{"image":{},"vcpus":{"type":"integer"},"memory":{"type":"integer"},"command":{"shape":"Sb"},"jobRoleArn":{},"executionRoleArn":{},"volumes":{"shape":"S1n"},"environment":{"shape":"S1u"},"mountPoints":{"shape":"S1w"},"readonlyRootFilesystem":{"type":"boolean"},"ulimits":{"shape":"S1y"},"privileged":{"type":"boolean"},"user":{},"exitCode":{"type":"integer"},"reason":{},"containerInstanceArn":{},"taskArn":{},"logStreamName":{},"instanceType":{},"networkInterfaces":{"shape":"S31"},"resourceRequirements":{"shape":"S20"},"linuxParameters":{"shape":"S23"},"logConfiguration":{"shape":"S2a"},"secrets":{"shape":"S2d"},"networkConfiguration":{"shape":"S2f"},"fargatePlatformConfiguration":{"shape":"S2h"}}},"nodeDetails":{"type":"structure","members":{"nodeIndex":{"type":"integer"},"isMainNode":{"type":"boolean"}}},"nodeProperties":{"shape":"S2j"},"arrayProperties":{"type":"structure","members":{"statusSummary":{"type":"map","key":{},"value":{"type":"integer"}},"size":{"type":"integer"},"index":{"type":"integer"}}},"timeout":{"shape":"S2i"},"tags":{"shape":"Si"},"propagateTags":{"type":"boolean"},"platformCapabilities":{"shape":"S2m"}}}}}}},"DescribeSchedulingPolicies":{"http":{"requestUri":"/v1/describeschedulingpolicies"},"input":{"type":"structure","required":["arns"],"members":{"arns":{"shape":"Sb"}}},"output":{"type":"structure","members":{"schedulingPolicies":{"type":"list","member":{"type":"structure","required":["name","arn"],"members":{"name":{},"arn":{},"fairsharePolicy":{"shape":"Ss"},"tags":{"shape":"Si"}}}}}}},"ListJobs":{"http":{"requestUri":"/v1/listjobs"},"input":{"type":"structure","members":{"jobQueue":{},"arrayJobId":{},"multiNodeJobId":{},"jobStatus":{},"maxResults":{"type":"integer"},"nextToken":{},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sb"}}}}}},"output":{"type":"structure","required":["jobSummaryList"],"members":{"jobSummaryList":{"type":"list","member":{"type":"structure","required":["jobId","jobName"],"members":{"jobArn":{},"jobId":{},"jobName":{},"createdAt":{"type":"long"},"status":{},"statusReason":{},"startedAt":{"type":"long"},"stoppedAt":{"type":"long"},"container":{"type":"structure","members":{"exitCode":{"type":"integer"},"reason":{}}},"arrayProperties":{"type":"structure","members":{"size":{"type":"integer"},"index":{"type":"integer"}}},"nodeProperties":{"type":"structure","members":{"isMainNode":{"type":"boolean"},"numNodes":{"type":"integer"},"nodeIndex":{"type":"integer"}}},"jobDefinition":{}}}},"nextToken":{}}}},"ListSchedulingPolicies":{"http":{"requestUri":"/v1/listschedulingpolicies"},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"schedulingPolicies":{"type":"list","member":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Si"}}}},"RegisterJobDefinition":{"http":{"requestUri":"/v1/registerjobdefinition"},"input":{"type":"structure","required":["jobDefinitionName","type"],"members":{"jobDefinitionName":{},"type":{},"parameters":{"shape":"S1h"},"schedulingPriority":{"type":"integer"},"containerProperties":{"shape":"S1m"},"nodeProperties":{"shape":"S2j"},"retryStrategy":{"shape":"S1i"},"propagateTags":{"type":"boolean"},"timeout":{"shape":"S2i"},"tags":{"shape":"Si"},"platformCapabilities":{"shape":"S2m"}}},"output":{"type":"structure","required":["jobDefinitionName","jobDefinitionArn","revision"],"members":{"jobDefinitionName":{},"jobDefinitionArn":{},"revision":{"type":"integer"}}}},"SubmitJob":{"http":{"requestUri":"/v1/submitjob"},"input":{"type":"structure","required":["jobName","jobQueue","jobDefinition"],"members":{"jobName":{},"jobQueue":{},"shareIdentifier":{},"schedulingPriorityOverride":{"type":"integer"},"arrayProperties":{"type":"structure","members":{"size":{"type":"integer"}}},"dependsOn":{"shape":"S34"},"jobDefinition":{},"parameters":{"shape":"S1h"},"containerOverrides":{"shape":"S3z"},"nodeOverrides":{"type":"structure","members":{"numNodes":{"type":"integer"},"nodePropertyOverrides":{"type":"list","member":{"type":"structure","required":["targetNodes"],"members":{"targetNodes":{},"containerOverrides":{"shape":"S3z"}}}}}},"retryStrategy":{"shape":"S1i"},"propagateTags":{"type":"boolean"},"timeout":{"shape":"S2i"},"tags":{"shape":"Si"}}},"output":{"type":"structure","required":["jobName","jobId"],"members":{"jobArn":{},"jobName":{},"jobId":{}}}},"TagResource":{"http":{"requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"TerminateJob":{"http":{"requestUri":"/v1/terminatejob"},"input":{"type":"structure","required":["jobId","reason"],"members":{"jobId":{},"reason":{}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateComputeEnvironment":{"http":{"requestUri":"/v1/updatecomputeenvironment"},"input":{"type":"structure","required":["computeEnvironment"],"members":{"computeEnvironment":{},"state":{},"unmanagedvCpus":{"type":"integer"},"computeResources":{"type":"structure","members":{"minvCpus":{"type":"integer"},"maxvCpus":{"type":"integer"},"desiredvCpus":{"type":"integer"},"subnets":{"shape":"Sb"},"securityGroupIds":{"shape":"Sb"},"allocationStrategy":{},"instanceTypes":{"shape":"Sb"},"ec2KeyPair":{},"instanceRole":{},"tags":{"shape":"Sc"},"placementGroup":{},"bidPercentage":{"type":"integer"},"launchTemplate":{"shape":"Sd"},"ec2Configuration":{"shape":"Se"},"updateToLatestImageVersion":{"type":"boolean"},"type":{},"imageId":{}}},"serviceRole":{},"updatePolicy":{"shape":"S1a"}}},"output":{"type":"structure","members":{"computeEnvironmentName":{},"computeEnvironmentArn":{}}}},"UpdateJobQueue":{"http":{"requestUri":"/v1/updatejobqueue"},"input":{"type":"structure","required":["jobQueue"],"members":{"jobQueue":{},"state":{},"schedulingPolicyArn":{},"priority":{"type":"integer"},"computeEnvironmentOrder":{"shape":"So"}}},"output":{"type":"structure","members":{"jobQueueName":{},"jobQueueArn":{}}}},"UpdateSchedulingPolicy":{"http":{"requestUri":"/v1/updateschedulingpolicy"},"input":{"type":"structure","required":["arn"],"members":{"arn":{},"fairsharePolicy":{"shape":"Ss"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"structure","required":["type","maxvCpus","subnets"],"members":{"type":{},"allocationStrategy":{},"minvCpus":{"type":"integer"},"maxvCpus":{"type":"integer"},"desiredvCpus":{"type":"integer"},"instanceTypes":{"shape":"Sb"},"imageId":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use ec2Configuration[].imageIdOverride instead."},"subnets":{"shape":"Sb"},"securityGroupIds":{"shape":"Sb"},"ec2KeyPair":{},"instanceRole":{},"tags":{"shape":"Sc"},"placementGroup":{},"bidPercentage":{"type":"integer"},"spotIamFleetRole":{},"launchTemplate":{"shape":"Sd"},"ec2Configuration":{"shape":"Se"}}},"Sb":{"type":"list","member":{}},"Sc":{"type":"map","key":{},"value":{}},"Sd":{"type":"structure","members":{"launchTemplateId":{},"launchTemplateName":{},"version":{}}},"Se":{"type":"list","member":{"type":"structure","required":["imageType"],"members":{"imageType":{},"imageIdOverride":{}}}},"Si":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["order","computeEnvironment"],"members":{"order":{"type":"integer"},"computeEnvironment":{}}}},"Ss":{"type":"structure","members":{"shareDecaySeconds":{"type":"integer"},"computeReservation":{"type":"integer"},"shareDistribution":{"type":"list","member":{"type":"structure","required":["shareIdentifier"],"members":{"shareIdentifier":{},"weightFactor":{"type":"float"}}}}}},"S1a":{"type":"structure","members":{"terminateJobsOnUpdate":{"type":"boolean"},"jobExecutionTimeoutMinutes":{"type":"long"}}},"S1h":{"type":"map","key":{},"value":{}},"S1i":{"type":"structure","members":{"attempts":{"type":"integer"},"evaluateOnExit":{"type":"list","member":{"type":"structure","required":["action"],"members":{"onStatusReason":{},"onReason":{},"onExitCode":{},"action":{}}}}}},"S1m":{"type":"structure","members":{"image":{},"vcpus":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use resourceRequirements instead.","type":"integer"},"memory":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use resourceRequirements instead.","type":"integer"},"command":{"shape":"Sb"},"jobRoleArn":{},"executionRoleArn":{},"volumes":{"shape":"S1n"},"environment":{"shape":"S1u"},"mountPoints":{"shape":"S1w"},"readonlyRootFilesystem":{"type":"boolean"},"privileged":{"type":"boolean"},"ulimits":{"shape":"S1y"},"user":{},"instanceType":{},"resourceRequirements":{"shape":"S20"},"linuxParameters":{"shape":"S23"},"logConfiguration":{"shape":"S2a"},"secrets":{"shape":"S2d"},"networkConfiguration":{"shape":"S2f"},"fargatePlatformConfiguration":{"shape":"S2h"}}},"S1n":{"type":"list","member":{"type":"structure","members":{"host":{"type":"structure","members":{"sourcePath":{}}},"name":{},"efsVolumeConfiguration":{"type":"structure","required":["fileSystemId"],"members":{"fileSystemId":{},"rootDirectory":{},"transitEncryption":{},"transitEncryptionPort":{"type":"integer"},"authorizationConfig":{"type":"structure","members":{"accessPointId":{},"iam":{}}}}}}}},"S1u":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"S1w":{"type":"list","member":{"type":"structure","members":{"containerPath":{},"readOnly":{"type":"boolean"},"sourceVolume":{}}}},"S1y":{"type":"list","member":{"type":"structure","required":["hardLimit","name","softLimit"],"members":{"hardLimit":{"type":"integer"},"name":{},"softLimit":{"type":"integer"}}}},"S20":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S23":{"type":"structure","members":{"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}},"initProcessEnabled":{"type":"boolean"},"sharedMemorySize":{"type":"integer"},"tmpfs":{"type":"list","member":{"type":"structure","required":["containerPath","size"],"members":{"containerPath":{},"size":{"type":"integer"},"mountOptions":{"shape":"Sb"}}}},"maxSwap":{"type":"integer"},"swappiness":{"type":"integer"}}},"S2a":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}},"secretOptions":{"shape":"S2d"}}},"S2d":{"type":"list","member":{"type":"structure","required":["name","valueFrom"],"members":{"name":{},"valueFrom":{}}}},"S2f":{"type":"structure","members":{"assignPublicIp":{}}},"S2h":{"type":"structure","members":{"platformVersion":{}}},"S2i":{"type":"structure","members":{"attemptDurationSeconds":{"type":"integer"}}},"S2j":{"type":"structure","required":["numNodes","mainNode","nodeRangeProperties"],"members":{"numNodes":{"type":"integer"},"mainNode":{"type":"integer"},"nodeRangeProperties":{"type":"list","member":{"type":"structure","required":["targetNodes"],"members":{"targetNodes":{},"container":{"shape":"S1m"}}}}}},"S2m":{"type":"list","member":{}},"S31":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"ipv6Address":{},"privateIpv4Address":{}}}},"S34":{"type":"list","member":{"type":"structure","members":{"jobId":{},"type":{}}}},"S3z":{"type":"structure","members":{"vcpus":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use resourceRequirements instead.","type":"integer"},"memory":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use resourceRequirements instead.","type":"integer"},"command":{"shape":"Sb"},"instanceType":{},"environment":{"shape":"S1u"},"resourceRequirements":{"shape":"S20"}}}}}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeComputeEnvironments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"computeEnvironments"},"DescribeJobDefinitions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobDefinitions"},"DescribeJobQueues":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobQueues"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobSummaryList"},"ListSchedulingPolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"schedulingPolicies"}}}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['budgets'] = {};
	AWS.Budgets = Service.defineService('budgets', ['2016-10-20']);
	Object.defineProperty(apiLoader.services['budgets'], '2016-10-20', {
	  get: function get() {
	    var model = __webpack_require__(72);
	    model.paginators = __webpack_require__(73).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Budgets;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-10-20","endpointPrefix":"budgets","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWSBudgets","serviceFullName":"AWS Budgets","serviceId":"Budgets","signatureVersion":"v4","targetPrefix":"AWSBudgetServiceGateway","uid":"budgets-2016-10-20"},"operations":{"CreateBudget":{"input":{"type":"structure","required":["AccountId","Budget"],"members":{"AccountId":{},"Budget":{"shape":"S3"},"NotificationsWithSubscribers":{"type":"list","member":{"type":"structure","required":["Notification","Subscribers"],"members":{"Notification":{"shape":"Sp"},"Subscribers":{"shape":"Sv"}}}}}},"output":{"type":"structure","members":{}}},"CreateBudgetAction":{"input":{"type":"structure","required":["AccountId","BudgetName","NotificationType","ActionType","ActionThreshold","Definition","ExecutionRoleArn","ApprovalModel","Subscribers"],"members":{"AccountId":{},"BudgetName":{},"NotificationType":{},"ActionType":{},"ActionThreshold":{"shape":"S12"},"Definition":{"shape":"S13"},"ExecutionRoleArn":{},"ApprovalModel":{},"Subscribers":{"shape":"Sv"}}},"output":{"type":"structure","required":["AccountId","BudgetName","ActionId"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{}}}},"CreateNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","Subscribers"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sp"},"Subscribers":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"CreateSubscriber":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","Subscriber"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sp"},"Subscriber":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}},"DeleteBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{}}},"output":{"type":"structure","members":{}}},"DeleteBudgetAction":{"input":{"type":"structure","required":["AccountId","BudgetName","ActionId"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{}}},"output":{"type":"structure","required":["AccountId","BudgetName","Action"],"members":{"AccountId":{},"BudgetName":{},"Action":{"shape":"S1x"}}}},"DeleteNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sp"}}},"output":{"type":"structure","members":{}}},"DeleteSubscriber":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","Subscriber"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sp"},"Subscriber":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}},"DescribeBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{}}},"output":{"type":"structure","members":{"Budget":{"shape":"S3"}}}},"DescribeBudgetAction":{"input":{"type":"structure","required":["AccountId","BudgetName","ActionId"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{}}},"output":{"type":"structure","required":["AccountId","BudgetName","Action"],"members":{"AccountId":{},"BudgetName":{},"Action":{"shape":"S1x"}}}},"DescribeBudgetActionHistories":{"input":{"type":"structure","required":["AccountId","BudgetName","ActionId"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{},"TimePeriod":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ActionHistories"],"members":{"ActionHistories":{"type":"list","member":{"type":"structure","required":["Timestamp","Status","EventType","ActionHistoryDetails"],"members":{"Timestamp":{"type":"timestamp"},"Status":{},"EventType":{},"ActionHistoryDetails":{"type":"structure","required":["Message","Action"],"members":{"Message":{},"Action":{"shape":"S1x"}}}}}},"NextToken":{}}}},"DescribeBudgetActionsForAccount":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Actions"],"members":{"Actions":{"shape":"S2g"},"NextToken":{}}}},"DescribeBudgetActionsForBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Actions"],"members":{"Actions":{"shape":"S2g"},"NextToken":{}}}},"DescribeBudgetNotificationsForAccount":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BudgetNotificationsForAccount":{"type":"list","member":{"type":"structure","members":{"Notifications":{"shape":"S2o"},"BudgetName":{}}}},"NextToken":{}}}},"DescribeBudgetPerformanceHistory":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{},"TimePeriod":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BudgetPerformanceHistory":{"type":"structure","members":{"BudgetName":{},"BudgetType":{},"CostFilters":{"shape":"Sa"},"CostTypes":{"shape":"Sc"},"TimeUnit":{},"BudgetedAndActualAmountsList":{"type":"list","member":{"type":"structure","members":{"BudgetedAmount":{"shape":"S5"},"ActualAmount":{"shape":"S5"},"TimePeriod":{"shape":"Sf"}}}}}},"NextToken":{}}}},"DescribeBudgets":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Budgets":{"type":"list","member":{"shape":"S3"}},"NextToken":{}}}},"DescribeNotificationsForBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Notifications":{"shape":"S2o"},"NextToken":{}}}},"DescribeSubscribersForNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Subscribers":{"shape":"Sv"},"NextToken":{}}}},"ExecuteBudgetAction":{"input":{"type":"structure","required":["AccountId","BudgetName","ActionId","ExecutionType"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{},"ExecutionType":{}}},"output":{"type":"structure","required":["AccountId","BudgetName","ActionId","ExecutionType"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{},"ExecutionType":{}}}},"UpdateBudget":{"input":{"type":"structure","required":["AccountId","NewBudget"],"members":{"AccountId":{},"NewBudget":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UpdateBudgetAction":{"input":{"type":"structure","required":["AccountId","BudgetName","ActionId"],"members":{"AccountId":{},"BudgetName":{},"ActionId":{},"NotificationType":{},"ActionThreshold":{"shape":"S12"},"Definition":{"shape":"S13"},"ExecutionRoleArn":{},"ApprovalModel":{},"Subscribers":{"shape":"Sv"}}},"output":{"type":"structure","required":["AccountId","BudgetName","OldAction","NewAction"],"members":{"AccountId":{},"BudgetName":{},"OldAction":{"shape":"S1x"},"NewAction":{"shape":"S1x"}}}},"UpdateNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","OldNotification","NewNotification"],"members":{"AccountId":{},"BudgetName":{},"OldNotification":{"shape":"Sp"},"NewNotification":{"shape":"Sp"}}},"output":{"type":"structure","members":{}}},"UpdateSubscriber":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","OldSubscriber","NewSubscriber"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sp"},"OldSubscriber":{"shape":"Sw"},"NewSubscriber":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","required":["BudgetName","TimeUnit","BudgetType"],"members":{"BudgetName":{},"BudgetLimit":{"shape":"S5"},"PlannedBudgetLimits":{"type":"map","key":{},"value":{"shape":"S5"}},"CostFilters":{"shape":"Sa"},"CostTypes":{"shape":"Sc"},"TimeUnit":{},"TimePeriod":{"shape":"Sf"},"CalculatedSpend":{"type":"structure","required":["ActualSpend"],"members":{"ActualSpend":{"shape":"S5"},"ForecastedSpend":{"shape":"S5"}}},"BudgetType":{},"LastUpdatedTime":{"type":"timestamp"},"AutoAdjustData":{"type":"structure","required":["AutoAdjustType"],"members":{"AutoAdjustType":{},"HistoricalOptions":{"type":"structure","required":["BudgetAdjustmentPeriod"],"members":{"BudgetAdjustmentPeriod":{"type":"integer"},"LookBackAvailablePeriods":{"type":"integer"}}},"LastAutoAdjustTime":{"type":"timestamp"}}}}},"S5":{"type":"structure","required":["Amount","Unit"],"members":{"Amount":{},"Unit":{}}},"Sa":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sc":{"type":"structure","members":{"IncludeTax":{"type":"boolean"},"IncludeSubscription":{"type":"boolean"},"UseBlended":{"type":"boolean"},"IncludeRefund":{"type":"boolean"},"IncludeCredit":{"type":"boolean"},"IncludeUpfront":{"type":"boolean"},"IncludeRecurring":{"type":"boolean"},"IncludeOtherSubscription":{"type":"boolean"},"IncludeSupport":{"type":"boolean"},"IncludeDiscount":{"type":"boolean"},"UseAmortized":{"type":"boolean"}}},"Sf":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"}}},"Sp":{"type":"structure","required":["NotificationType","ComparisonOperator","Threshold"],"members":{"NotificationType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"ThresholdType":{},"NotificationState":{}}},"Sv":{"type":"list","member":{"shape":"Sw"}},"Sw":{"type":"structure","required":["SubscriptionType","Address"],"members":{"SubscriptionType":{},"Address":{"type":"string","sensitive":true}}},"S12":{"type":"structure","required":["ActionThresholdValue","ActionThresholdType"],"members":{"ActionThresholdValue":{"type":"double"},"ActionThresholdType":{}}},"S13":{"type":"structure","members":{"IamActionDefinition":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Roles":{"type":"list","member":{}},"Groups":{"type":"list","member":{}},"Users":{"type":"list","member":{}}}},"ScpActionDefinition":{"type":"structure","required":["PolicyId","TargetIds"],"members":{"PolicyId":{},"TargetIds":{"type":"list","member":{}}}},"SsmActionDefinition":{"type":"structure","required":["ActionSubType","Region","InstanceIds"],"members":{"ActionSubType":{},"Region":{},"InstanceIds":{"type":"list","member":{}}}}}},"S1x":{"type":"structure","required":["ActionId","BudgetName","NotificationType","ActionType","ActionThreshold","Definition","ExecutionRoleArn","ApprovalModel","Status","Subscribers"],"members":{"ActionId":{},"BudgetName":{},"NotificationType":{},"ActionType":{},"ActionThreshold":{"shape":"S12"},"Definition":{"shape":"S13"},"ExecutionRoleArn":{},"ApprovalModel":{},"Status":{},"Subscribers":{"shape":"Sv"}}},"S2g":{"type":"list","member":{"shape":"S1x"}},"S2o":{"type":"list","member":{"shape":"Sp"}}}}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeBudgetActionHistories":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActionHistories"},"DescribeBudgetActionsForAccount":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Actions"},"DescribeBudgetActionsForBudget":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Actions"},"DescribeBudgetNotificationsForAccount":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"BudgetNotificationsForAccount"},"DescribeBudgetPerformanceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"BudgetPerformanceHistory"},"DescribeBudgets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Budgets"},"DescribeNotificationsForBudget":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Notifications"},"DescribeSubscribersForNotification":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Subscribers"}}}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['clouddirectory'] = {};
	AWS.CloudDirectory = Service.defineService('clouddirectory', ['2016-05-10', '2016-05-10*', '2017-01-11']);
	Object.defineProperty(apiLoader.services['clouddirectory'], '2016-05-10', {
	  get: function get() {
	    var model = __webpack_require__(75);
	    model.paginators = __webpack_require__(76).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['clouddirectory'], '2017-01-11', {
	  get: function get() {
	    var model = __webpack_require__(77);
	    model.paginators = __webpack_require__(78).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudDirectory;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-05-10","endpointPrefix":"clouddirectory","protocol":"rest-json","serviceFullName":"Amazon CloudDirectory","serviceId":"CloudDirectory","signatureVersion":"v4","signingName":"clouddirectory","uid":"clouddirectory-2016-05-10"},"operations":{"AddFacetToObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"ApplySchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/apply","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{},"DirectoryArn":{}}}},"AttachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","ChildReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"AttachToIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"output":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}}},"BatchRead":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/batchread","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"FacetFilter":{"shape":"S3"}}},"ListObjectChildren":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListAttachedIndices":{"type":"structure","required":["TargetReference"],"members":{"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListObjectParentPaths":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetObjectInformation":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"GetObjectAttributes":{"type":"structure","required":["ObjectReference","SchemaFacet","AttributeNames"],"members":{"ObjectReference":{"shape":"Sf"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"ListObjectPolicies":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListPolicyAttachments":{"type":"structure","required":["PolicyReference"],"members":{"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"LookupPolicy":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIndex":{"type":"structure","required":["IndexReference"],"members":{"RangesOnIndexedValues":{"shape":"S1f"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIncomingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeNames"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"}}}}}},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"SuccessfulResponse":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}},"ListObjectChildren":{"type":"structure","members":{"Children":{"shape":"S1v"},"NextToken":{}}},"GetObjectInformation":{"type":"structure","members":{"SchemaFacets":{"shape":"S1x"},"ObjectIdentifier":{}}},"GetObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}},"ListAttachedIndices":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}},"ListObjectParentPaths":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S23"},"NextToken":{}}},"ListObjectPolicies":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S26"},"NextToken":{}}},"ListPolicyAttachments":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S26"},"NextToken":{}}},"LookupPolicy":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2a"},"NextToken":{}}},"ListIndex":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2h"},"NextToken":{}}},"ListIncomingTypedLinks":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2h"},"NextToken":{}}},"GetLinkAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}}},"ExceptionResponse":{"type":"structure","members":{"Type":{},"Message":{}}}}}}}}},"BatchWrite":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/batchwrite","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList"],"members":{"SchemaFacet":{"shape":"S1x"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachObject":{"type":"structure","required":["ParentReference","ChildReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"DetachObject":{"type":"structure","required":["ParentReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"UpdateObjectAttributes":{"type":"structure","required":["ObjectReference","AttributeUpdates"],"members":{"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2v"}}},"DeleteObject":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"AddFacetToObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"RemoveFacetFromObject":{"type":"structure","required":["SchemaFacet","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"AttachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"DetachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"CreateIndex":{"type":"structure","required":["OrderedIndexedAttributeList","IsUnique"],"members":{"OrderedIndexedAttributeList":{"shape":"S35"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachToIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"DetachFromIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"AttachTypedLink":{"type":"structure","required":["SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"DetachTypedLink":{"type":"structure","required":["TypedLinkSpecifier"],"members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"UpdateLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeUpdates"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3c"}}}}}}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachObject":{"type":"structure","members":{"attachedObjectIdentifier":{}}},"DetachObject":{"type":"structure","members":{"detachedObjectIdentifier":{}}},"UpdateObjectAttributes":{"type":"structure","members":{"ObjectIdentifier":{}}},"DeleteObject":{"type":"structure","members":{}},"AddFacetToObject":{"type":"structure","members":{}},"RemoveFacetFromObject":{"type":"structure","members":{}},"AttachPolicy":{"type":"structure","members":{}},"DetachPolicy":{"type":"structure","members":{}},"CreateIndex":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachToIndex":{"type":"structure","members":{"AttachedObjectIdentifier":{}}},"DetachFromIndex":{"type":"structure","members":{"DetachedObjectIdentifier":{}}},"AttachTypedLink":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"DetachTypedLink":{"type":"structure","members":{}},"UpdateLinkAttributes":{"type":"structure","members":{}}}}}}}},"CreateDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/create","responseCode":200},"input":{"type":"structure","required":["Name","SchemaArn"],"members":{"Name":{},"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn","Name","ObjectIdentifier","AppliedSchemaArn"],"members":{"DirectoryArn":{},"Name":{},"ObjectIdentifier":{},"AppliedSchemaArn":{}}}},"CreateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name","ObjectType"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"Attributes":{"shape":"S42"},"ObjectType":{}}},"output":{"type":"structure","members":{}}},"CreateIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","OrderedIndexedAttributeList","IsUnique"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"OrderedIndexedAttributeList":{"shape":"S35"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacets"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacets":{"shape":"S1x"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/create","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"CreateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Facet"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Facet":{"type":"structure","required":["Name","Attributes","IdentityAttributeOrder"],"members":{"Name":{},"Attributes":{"shape":"S4q"},"IdentityAttributeOrder":{"shape":"S1a"}}}}},"output":{"type":"structure","members":{}}},"DeleteDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"DeleteFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DeleteSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"DeleteTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DetachFromIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DetachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"}}}},"DisableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/disable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"EnableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/enable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"GetAppliedSchemaVersion":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/getappliedschema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{}}}},"GetDirectory":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["Directory"],"members":{"Directory":{"shape":"S5i"}}}},"GetFacet":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"Facet":{"type":"structure","members":{"Name":{},"ObjectType":{}}}}}},"GetLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","SchemaFacet","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/information","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"SchemaFacets":{"shape":"S1x"},"ObjectIdentifier":{}}}},"GetSchemaAsJson":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"Name":{},"Document":{}}}},"GetTypedLinkFacetInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/get","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"IdentityAttributeOrder":{"shape":"S1a"}}}},"ListAppliedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/applied","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{},"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S61"},"NextToken":{}}}},"ListAttachedIndices":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/indices","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}}},"ListDevelopmentSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/development","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S61"},"NextToken":{}}}},"ListDirectories":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/list","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"state":{}}},"output":{"type":"structure","required":["Directories"],"members":{"Directories":{"type":"list","member":{"shape":"S5i"}},"NextToken":{}}}},"ListFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S42"},"NextToken":{}}}},"ListFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"ListIncomingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/incoming","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2h"},"NextToken":{}}}},"ListIndex":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/index/targets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"RangesOnIndexedValues":{"shape":"S1f"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}}},"ListObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"FacetFilter":{"shape":"S3"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}}},"ListObjectChildren":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/children","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Children":{"shape":"S1v"},"NextToken":{}}}},"ListObjectParentPaths":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parentpaths","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S23"},"NextToken":{}}}},"ListObjectParents":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parent","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Parents":{"type":"map","key":{},"value":{}},"NextToken":{}}}},"ListObjectPolicies":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/policy","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S26"},"NextToken":{}}}},"ListOutgoingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/outgoing","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2h"},"NextToken":{}}}},"ListPolicyAttachments":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/attachment","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S26"},"NextToken":{}}}},"ListPublishedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/published","responseCode":200},"input":{"type":"structure","members":{"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S61"},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/tags","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S72"},"NextToken":{}}}},"ListTypedLinkFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S4q"},"NextToken":{}}}},"ListTypedLinkFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"LookupPolicy":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/lookup","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2a"},"NextToken":{}}}},"PublishSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/publish","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","Version"],"members":{"DevelopmentSchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Version":{},"MinorVersion":{},"Name":{}}},"output":{"type":"structure","members":{"PublishedSchemaArn":{}}}},"PutSchemaFromJson":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Document"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Document":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"RemoveFacetFromObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/add","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S72"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/remove","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","members":{"Attribute":{"shape":"S43"},"Action":{}}}},"ObjectType":{}}},"output":{"type":"structure","members":{}}},"UpdateLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3c"}}},"output":{"type":"structure","members":{}}},"UpdateObjectAttributes":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2v"}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"UpdateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/update","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"UpdateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name","AttributeUpdates","IdentityAttributeOrder"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","required":["Attribute","Action"],"members":{"Attribute":{"shape":"S4r"},"Action":{}}}},"IdentityAttributeOrder":{"shape":"S1a"}}},"output":{"type":"structure","members":{}}},"UpgradeAppliedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradeapplied","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{},"DirectoryArn":{}}}},"UpgradePublishedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradepublished","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","PublishedSchemaArn","MinorVersion"],"members":{"DevelopmentSchemaArn":{},"PublishedSchemaArn":{},"MinorVersion":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{}}}}},"shapes":{"S3":{"type":"structure","members":{"SchemaArn":{},"FacetName":{}}},"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S7"},"Value":{"shape":"S9"}}}},"S7":{"type":"structure","required":["SchemaArn","FacetName","Name"],"members":{"SchemaArn":{},"FacetName":{},"Name":{}}},"S9":{"type":"structure","members":{"StringValue":{},"BinaryValue":{"type":"blob"},"BooleanValue":{"type":"boolean"},"NumberValue":{},"DatetimeValue":{"type":"timestamp"}}},"Sf":{"type":"structure","members":{"Selector":{}}},"St":{"type":"structure","required":["SchemaArn","TypedLinkName"],"members":{"SchemaArn":{},"TypedLinkName":{}}},"Sv":{"type":"list","member":{"type":"structure","required":["AttributeName","Value"],"members":{"AttributeName":{},"Value":{"shape":"S9"}}}},"Sy":{"type":"structure","required":["TypedLinkFacet","SourceObjectReference","TargetObjectReference","IdentityAttributeValues"],"members":{"TypedLinkFacet":{"shape":"St"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"IdentityAttributeValues":{"shape":"Sv"}}},"S1a":{"type":"list","member":{}},"S1f":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"Range":{"shape":"S1h"}}}},"S1h":{"type":"structure","required":["StartMode","EndMode"],"members":{"StartMode":{},"StartValue":{"shape":"S9"},"EndMode":{},"EndValue":{"shape":"S9"}}},"S1k":{"type":"list","member":{"type":"structure","required":["Range"],"members":{"AttributeName":{},"Range":{"shape":"S1h"}}}},"S1v":{"type":"map","key":{},"value":{}},"S1x":{"type":"list","member":{"shape":"S3"}},"S20":{"type":"list","member":{"type":"structure","members":{"IndexedAttributes":{"shape":"S5"},"ObjectIdentifier":{}}}},"S23":{"type":"list","member":{"type":"structure","members":{"Path":{},"ObjectIdentifiers":{"shape":"S26"}}}},"S26":{"type":"list","member":{}},"S2a":{"type":"list","member":{"type":"structure","members":{"Path":{},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"ObjectIdentifier":{},"PolicyType":{}}}}}}},"S2h":{"type":"list","member":{"shape":"Sy"}},"S2v":{"type":"list","member":{"type":"structure","members":{"ObjectAttributeKey":{"shape":"S7"},"ObjectAttributeAction":{"type":"structure","members":{"ObjectAttributeActionType":{},"ObjectAttributeUpdateValue":{"shape":"S9"}}}}}},"S35":{"type":"list","member":{"shape":"S7"}},"S3c":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"AttributeAction":{"type":"structure","members":{"AttributeActionType":{},"AttributeUpdateValue":{"shape":"S9"}}}}}},"S42":{"type":"list","member":{"shape":"S43"}},"S43":{"type":"structure","required":["Name"],"members":{"Name":{},"AttributeDefinition":{"type":"structure","required":["Type"],"members":{"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S46"}}},"AttributeReference":{"type":"structure","required":["TargetFacetName","TargetAttributeName"],"members":{"TargetFacetName":{},"TargetAttributeName":{}}},"RequiredBehavior":{}}},"S46":{"type":"map","key":{},"value":{"type":"structure","members":{"Type":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"S4q":{"type":"list","member":{"shape":"S4r"}},"S4r":{"type":"structure","required":["Name","Type","RequiredBehavior"],"members":{"Name":{},"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S46"},"RequiredBehavior":{}}},"S5i":{"type":"structure","members":{"Name":{},"DirectoryArn":{},"State":{},"CreationDateTime":{"type":"timestamp"}}},"S61":{"type":"list","member":{}},"S72":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAppliedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAttachedIndices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDevelopmentSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDirectories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListIndex":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectChildren":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParentPaths":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPolicyAttachments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPublishedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"LookupPolicy":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-11","endpointPrefix":"clouddirectory","protocol":"rest-json","serviceFullName":"Amazon CloudDirectory","serviceId":"CloudDirectory","signatureVersion":"v4","signingName":"clouddirectory","uid":"clouddirectory-2017-01-11"},"operations":{"AddFacetToObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"ApplySchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/apply","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{},"DirectoryArn":{}}}},"AttachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","ChildReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"AttachToIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"output":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}}},"BatchRead":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/batchread","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"FacetFilter":{"shape":"S3"}}},"ListObjectChildren":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListAttachedIndices":{"type":"structure","required":["TargetReference"],"members":{"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListObjectParentPaths":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetObjectInformation":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"GetObjectAttributes":{"type":"structure","required":["ObjectReference","SchemaFacet","AttributeNames"],"members":{"ObjectReference":{"shape":"Sf"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"ListObjectParents":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListObjectPolicies":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListPolicyAttachments":{"type":"structure","required":["PolicyReference"],"members":{"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"LookupPolicy":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIndex":{"type":"structure","required":["IndexReference"],"members":{"RangesOnIndexedValues":{"shape":"S1g"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIncomingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeNames"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"}}}}}},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"SuccessfulResponse":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}},"ListObjectChildren":{"type":"structure","members":{"Children":{"shape":"S1w"},"NextToken":{}}},"GetObjectInformation":{"type":"structure","members":{"SchemaFacets":{"shape":"S1y"},"ObjectIdentifier":{}}},"GetObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}},"ListAttachedIndices":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}},"ListObjectParentPaths":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S24"},"NextToken":{}}},"ListObjectPolicies":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S27"},"NextToken":{}}},"ListPolicyAttachments":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S27"},"NextToken":{}}},"LookupPolicy":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2b"},"NextToken":{}}},"ListIndex":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2i"},"NextToken":{}}},"ListIncomingTypedLinks":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2i"},"NextToken":{}}},"GetLinkAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}},"ListObjectParents":{"type":"structure","members":{"ParentLinks":{"shape":"S2m"},"NextToken":{}}}}},"ExceptionResponse":{"type":"structure","members":{"Type":{},"Message":{}}}}}}}}},"BatchWrite":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/batchwrite","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList"],"members":{"SchemaFacet":{"shape":"S1y"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachObject":{"type":"structure","required":["ParentReference","ChildReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"DetachObject":{"type":"structure","required":["ParentReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"UpdateObjectAttributes":{"type":"structure","required":["ObjectReference","AttributeUpdates"],"members":{"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2z"}}},"DeleteObject":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"AddFacetToObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"RemoveFacetFromObject":{"type":"structure","required":["SchemaFacet","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"AttachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"DetachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"CreateIndex":{"type":"structure","required":["OrderedIndexedAttributeList","IsUnique"],"members":{"OrderedIndexedAttributeList":{"shape":"S39"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachToIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"DetachFromIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"AttachTypedLink":{"type":"structure","required":["SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"DetachTypedLink":{"type":"structure","required":["TypedLinkSpecifier"],"members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"UpdateLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeUpdates"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3g"}}}}}}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachObject":{"type":"structure","members":{"attachedObjectIdentifier":{}}},"DetachObject":{"type":"structure","members":{"detachedObjectIdentifier":{}}},"UpdateObjectAttributes":{"type":"structure","members":{"ObjectIdentifier":{}}},"DeleteObject":{"type":"structure","members":{}},"AddFacetToObject":{"type":"structure","members":{}},"RemoveFacetFromObject":{"type":"structure","members":{}},"AttachPolicy":{"type":"structure","members":{}},"DetachPolicy":{"type":"structure","members":{}},"CreateIndex":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachToIndex":{"type":"structure","members":{"AttachedObjectIdentifier":{}}},"DetachFromIndex":{"type":"structure","members":{"DetachedObjectIdentifier":{}}},"AttachTypedLink":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"DetachTypedLink":{"type":"structure","members":{}},"UpdateLinkAttributes":{"type":"structure","members":{}}}}}}}},"CreateDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/create","responseCode":200},"input":{"type":"structure","required":["Name","SchemaArn"],"members":{"Name":{},"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn","Name","ObjectIdentifier","AppliedSchemaArn"],"members":{"DirectoryArn":{},"Name":{},"ObjectIdentifier":{},"AppliedSchemaArn":{}}}},"CreateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"Attributes":{"shape":"S46"},"ObjectType":{},"FacetStyle":{}}},"output":{"type":"structure","members":{}}},"CreateIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","OrderedIndexedAttributeList","IsUnique"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"OrderedIndexedAttributeList":{"shape":"S39"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacets"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacets":{"shape":"S1y"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/create","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"CreateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Facet"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Facet":{"type":"structure","required":["Name","Attributes","IdentityAttributeOrder"],"members":{"Name":{},"Attributes":{"shape":"S4v"},"IdentityAttributeOrder":{"shape":"S1a"}}}}},"output":{"type":"structure","members":{}}},"DeleteDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"DeleteFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DeleteSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"DeleteTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DetachFromIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DetachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"}}}},"DisableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/disable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"EnableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/enable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"GetAppliedSchemaVersion":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/getappliedschema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{}}}},"GetDirectory":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["Directory"],"members":{"Directory":{"shape":"S5n"}}}},"GetFacet":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"Facet":{"type":"structure","members":{"Name":{},"ObjectType":{},"FacetStyle":{}}}}}},"GetLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","SchemaFacet","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/information","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"SchemaFacets":{"shape":"S1y"},"ObjectIdentifier":{}}}},"GetSchemaAsJson":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"Name":{},"Document":{}}}},"GetTypedLinkFacetInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/get","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"IdentityAttributeOrder":{"shape":"S1a"}}}},"ListAppliedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/applied","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{},"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListAttachedIndices":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/indices","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}}},"ListDevelopmentSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/development","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListDirectories":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/list","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"state":{}}},"output":{"type":"structure","required":["Directories"],"members":{"Directories":{"type":"list","member":{"shape":"S5n"}},"NextToken":{}}}},"ListFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S46"},"NextToken":{}}}},"ListFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"ListIncomingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/incoming","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2i"},"NextToken":{}}}},"ListIndex":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/index/targets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"RangesOnIndexedValues":{"shape":"S1g"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}}},"ListManagedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/managed","responseCode":200},"input":{"type":"structure","members":{"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"FacetFilter":{"shape":"S3"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}}},"ListObjectChildren":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/children","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Children":{"shape":"S1w"},"NextToken":{}}}},"ListObjectParentPaths":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parentpaths","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S24"},"NextToken":{}}}},"ListObjectParents":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parent","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"IncludeAllLinksToEachParent":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parents":{"type":"map","key":{},"value":{}},"NextToken":{},"ParentLinks":{"shape":"S2m"}}}},"ListObjectPolicies":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/policy","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S27"},"NextToken":{}}}},"ListOutgoingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/outgoing","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2i"},"NextToken":{}}}},"ListPolicyAttachments":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/attachment","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S27"},"NextToken":{}}}},"ListPublishedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/published","responseCode":200},"input":{"type":"structure","members":{"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/tags","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S79"},"NextToken":{}}}},"ListTypedLinkFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S4v"},"NextToken":{}}}},"ListTypedLinkFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"LookupPolicy":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/lookup","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2b"},"NextToken":{}}}},"PublishSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/publish","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","Version"],"members":{"DevelopmentSchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Version":{},"MinorVersion":{},"Name":{}}},"output":{"type":"structure","members":{"PublishedSchemaArn":{}}}},"PutSchemaFromJson":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Document"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Document":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"RemoveFacetFromObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/add","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S79"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/remove","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","members":{"Attribute":{"shape":"S47"},"Action":{}}}},"ObjectType":{}}},"output":{"type":"structure","members":{}}},"UpdateLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3g"}}},"output":{"type":"structure","members":{}}},"UpdateObjectAttributes":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2z"}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"UpdateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/update","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"UpdateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name","AttributeUpdates","IdentityAttributeOrder"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","required":["Attribute","Action"],"members":{"Attribute":{"shape":"S4w"},"Action":{}}}},"IdentityAttributeOrder":{"shape":"S1a"}}},"output":{"type":"structure","members":{}}},"UpgradeAppliedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradeapplied","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{},"DirectoryArn":{}}}},"UpgradePublishedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradepublished","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","PublishedSchemaArn","MinorVersion"],"members":{"DevelopmentSchemaArn":{},"PublishedSchemaArn":{},"MinorVersion":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{}}}}},"shapes":{"S3":{"type":"structure","members":{"SchemaArn":{},"FacetName":{}}},"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S7"},"Value":{"shape":"S9"}}}},"S7":{"type":"structure","required":["SchemaArn","FacetName","Name"],"members":{"SchemaArn":{},"FacetName":{},"Name":{}}},"S9":{"type":"structure","members":{"StringValue":{},"BinaryValue":{"type":"blob"},"BooleanValue":{"type":"boolean"},"NumberValue":{},"DatetimeValue":{"type":"timestamp"}}},"Sf":{"type":"structure","members":{"Selector":{}}},"St":{"type":"structure","required":["SchemaArn","TypedLinkName"],"members":{"SchemaArn":{},"TypedLinkName":{}}},"Sv":{"type":"list","member":{"type":"structure","required":["AttributeName","Value"],"members":{"AttributeName":{},"Value":{"shape":"S9"}}}},"Sy":{"type":"structure","required":["TypedLinkFacet","SourceObjectReference","TargetObjectReference","IdentityAttributeValues"],"members":{"TypedLinkFacet":{"shape":"St"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"IdentityAttributeValues":{"shape":"Sv"}}},"S1a":{"type":"list","member":{}},"S1g":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"Range":{"shape":"S1i"}}}},"S1i":{"type":"structure","required":["StartMode","EndMode"],"members":{"StartMode":{},"StartValue":{"shape":"S9"},"EndMode":{},"EndValue":{"shape":"S9"}}},"S1l":{"type":"list","member":{"type":"structure","required":["Range"],"members":{"AttributeName":{},"Range":{"shape":"S1i"}}}},"S1w":{"type":"map","key":{},"value":{}},"S1y":{"type":"list","member":{"shape":"S3"}},"S21":{"type":"list","member":{"type":"structure","members":{"IndexedAttributes":{"shape":"S5"},"ObjectIdentifier":{}}}},"S24":{"type":"list","member":{"type":"structure","members":{"Path":{},"ObjectIdentifiers":{"shape":"S27"}}}},"S27":{"type":"list","member":{}},"S2b":{"type":"list","member":{"type":"structure","members":{"Path":{},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"ObjectIdentifier":{},"PolicyType":{}}}}}}},"S2i":{"type":"list","member":{"shape":"Sy"}},"S2m":{"type":"list","member":{"type":"structure","members":{"ObjectIdentifier":{},"LinkName":{}}}},"S2z":{"type":"list","member":{"type":"structure","members":{"ObjectAttributeKey":{"shape":"S7"},"ObjectAttributeAction":{"type":"structure","members":{"ObjectAttributeActionType":{},"ObjectAttributeUpdateValue":{"shape":"S9"}}}}}},"S39":{"type":"list","member":{"shape":"S7"}},"S3g":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"AttributeAction":{"type":"structure","members":{"AttributeActionType":{},"AttributeUpdateValue":{"shape":"S9"}}}}}},"S46":{"type":"list","member":{"shape":"S47"}},"S47":{"type":"structure","required":["Name"],"members":{"Name":{},"AttributeDefinition":{"type":"structure","required":["Type"],"members":{"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S4a"}}},"AttributeReference":{"type":"structure","required":["TargetFacetName","TargetAttributeName"],"members":{"TargetFacetName":{},"TargetAttributeName":{}}},"RequiredBehavior":{}}},"S4a":{"type":"map","key":{},"value":{"type":"structure","members":{"Type":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"S4v":{"type":"list","member":{"shape":"S4w"}},"S4w":{"type":"structure","required":["Name","Type","RequiredBehavior"],"members":{"Name":{},"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S4a"},"RequiredBehavior":{}}},"S5n":{"type":"structure","members":{"Name":{},"DirectoryArn":{},"State":{},"CreationDateTime":{"type":"timestamp"}}},"S66":{"type":"list","member":{}},"S79":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAppliedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAttachedIndices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDevelopmentSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDirectories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListIndex":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListManagedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectChildren":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParentPaths":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPolicyAttachments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPublishedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"LookupPolicy":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudformation'] = {};
	AWS.CloudFormation = Service.defineService('cloudformation', ['2010-05-15']);
	Object.defineProperty(apiLoader.services['cloudformation'], '2010-05-15', {
	  get: function get() {
	    var model = __webpack_require__(80);
	    model.paginators = __webpack_require__(81).pagination;
	    model.waiters = __webpack_require__(82).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudFormation;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-15","endpointPrefix":"cloudformation","protocol":"query","serviceFullName":"AWS CloudFormation","serviceId":"CloudFormation","signatureVersion":"v4","uid":"cloudformation-2010-05-15","xmlNamespace":"http://cloudformation.amazonaws.com/doc/2010-05-15/"},"operations":{"ActivateType":{"input":{"type":"structure","members":{"Type":{},"PublicTypeArn":{},"PublisherId":{},"TypeName":{},"TypeNameAlias":{},"AutoUpdate":{"type":"boolean"},"LoggingConfig":{"shape":"S7"},"ExecutionRoleArn":{},"VersionBump":{},"MajorVersion":{"type":"long"}}},"output":{"resultWrapper":"ActivateTypeResult","type":"structure","members":{"Arn":{}}},"idempotent":true},"BatchDescribeTypeConfigurations":{"input":{"type":"structure","required":["TypeConfigurationIdentifiers"],"members":{"TypeConfigurationIdentifiers":{"type":"list","member":{"shape":"Sg"}}}},"output":{"resultWrapper":"BatchDescribeTypeConfigurationsResult","type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{},"TypeConfigurationIdentifier":{"shape":"Sg"}}}},"UnprocessedTypeConfigurations":{"type":"list","member":{"shape":"Sg"}},"TypeConfigurations":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Alias":{},"Configuration":{},"LastUpdated":{"type":"timestamp"},"TypeArn":{},"TypeName":{},"IsDefaultConfiguration":{"type":"boolean"}}}}}}},"CancelUpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"ClientRequestToken":{}}}},"ContinueUpdateRollback":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ResourcesToSkip":{"type":"list","member":{}},"ClientRequestToken":{}}},"output":{"resultWrapper":"ContinueUpdateRollbackResult","type":"structure","members":{}}},"CreateChangeSet":{"input":{"type":"structure","required":["StackName","ChangeSetName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"S18"},"Capabilities":{"shape":"S1d"},"ResourceTypes":{"shape":"S1f"},"RoleARN":{},"RollbackConfiguration":{"shape":"S1h"},"NotificationARNs":{"shape":"S1n"},"Tags":{"shape":"S1p"},"ChangeSetName":{},"ClientToken":{},"Description":{},"ChangeSetType":{},"ResourcesToImport":{"type":"list","member":{"type":"structure","required":["ResourceType","LogicalResourceId","ResourceIdentifier"],"members":{"ResourceType":{},"LogicalResourceId":{},"ResourceIdentifier":{"type":"map","key":{},"value":{}}}}},"IncludeNestedStacks":{"type":"boolean"}}},"output":{"resultWrapper":"CreateChangeSetResult","type":"structure","members":{"Id":{},"StackId":{}}}},"CreateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"S18"},"DisableRollback":{"type":"boolean"},"RollbackConfiguration":{"shape":"S1h"},"TimeoutInMinutes":{"type":"integer"},"NotificationARNs":{"shape":"S1n"},"Capabilities":{"shape":"S1d"},"ResourceTypes":{"shape":"S1f"},"RoleARN":{},"OnFailure":{},"StackPolicyBody":{},"StackPolicyURL":{},"Tags":{"shape":"S1p"},"ClientRequestToken":{},"EnableTerminationProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateStackResult","type":"structure","members":{"StackId":{}}}},"CreateStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S2h"},"DeploymentTargets":{"shape":"S2j"},"Regions":{"shape":"S2n"},"ParameterOverrides":{"shape":"S18"},"OperationPreferences":{"shape":"S2p"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"CreateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"CreateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"StackId":{},"Parameters":{"shape":"S18"},"Capabilities":{"shape":"S1d"},"Tags":{"shape":"S1p"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"PermissionModel":{},"AutoDeployment":{"shape":"S30"},"CallAs":{},"ClientRequestToken":{"idempotencyToken":true},"ManagedExecution":{"shape":"S33"}}},"output":{"resultWrapper":"CreateStackSetResult","type":"structure","members":{"StackSetId":{}}}},"DeactivateType":{"input":{"type":"structure","members":{"TypeName":{},"Type":{},"Arn":{}}},"output":{"resultWrapper":"DeactivateTypeResult","type":"structure","members":{}},"idempotent":true},"DeleteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{}}},"output":{"resultWrapper":"DeleteChangeSetResult","type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RetainResources":{"type":"list","member":{}},"RoleARN":{},"ClientRequestToken":{}}}},"DeleteStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions","RetainStacks"],"members":{"StackSetName":{},"Accounts":{"shape":"S2h"},"DeploymentTargets":{"shape":"S2j"},"Regions":{"shape":"S2n"},"OperationPreferences":{"shape":"S2p"},"RetainStacks":{"type":"boolean"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"DeleteStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"DeleteStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"CallAs":{}}},"output":{"resultWrapper":"DeleteStackSetResult","type":"structure","members":{}}},"DeregisterType":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{}}},"output":{"resultWrapper":"DeregisterTypeResult","type":"structure","members":{}},"idempotent":true},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"integer"}}}},"NextToken":{}}}},"DescribeChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeChangeSetResult","type":"structure","members":{"ChangeSetName":{},"ChangeSetId":{},"StackId":{},"StackName":{},"Description":{},"Parameters":{"shape":"S18"},"CreationTime":{"type":"timestamp"},"ExecutionStatus":{},"Status":{},"StatusReason":{},"NotificationARNs":{"shape":"S1n"},"RollbackConfiguration":{"shape":"S1h"},"Capabilities":{"shape":"S1d"},"Tags":{"shape":"S1p"},"Changes":{"type":"list","member":{"type":"structure","members":{"Type":{},"HookInvocationCount":{"type":"integer"},"ResourceChange":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"ChangeSource":{},"CausingEntity":{}}}},"ChangeSetId":{},"ModuleInfo":{"shape":"S4i"}}}}}},"NextToken":{},"IncludeNestedStacks":{"type":"boolean"},"ParentChangeSetId":{},"RootChangeSetId":{}}}},"DescribeChangeSetHooks":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeChangeSetHooksResult","type":"structure","members":{"ChangeSetId":{},"ChangeSetName":{},"Hooks":{"type":"list","member":{"type":"structure","members":{"InvocationPoint":{},"FailureMode":{},"TypeName":{},"TypeVersionId":{},"TypeConfigurationVersionId":{},"TargetDetails":{"type":"structure","members":{"TargetType":{},"ResourceTargetDetails":{"type":"structure","members":{"LogicalResourceId":{},"ResourceType":{},"ResourceAction":{}}}}}}}},"Status":{},"NextToken":{},"StackId":{},"StackName":{}}}},"DescribePublisher":{"input":{"type":"structure","members":{"PublisherId":{}}},"output":{"resultWrapper":"DescribePublisherResult","type":"structure","members":{"PublisherId":{},"PublisherStatus":{},"IdentityProvider":{},"PublisherProfile":{}}},"idempotent":true},"DescribeStackDriftDetectionStatus":{"input":{"type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}},"output":{"resultWrapper":"DescribeStackDriftDetectionStatusResult","type":"structure","required":["StackId","StackDriftDetectionId","DetectionStatus","Timestamp"],"members":{"StackId":{},"StackDriftDetectionId":{},"StackDriftStatus":{},"DetectionStatus":{},"DetectionStatusReason":{},"DriftedStackResourceCount":{"type":"integer"},"Timestamp":{"type":"timestamp"}}}},"DescribeStackEvents":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStackEventsResult","type":"structure","members":{"StackEvents":{"type":"list","member":{"type":"structure","required":["StackId","EventId","StackName","Timestamp"],"members":{"StackId":{},"EventId":{},"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"ResourceProperties":{},"ClientRequestToken":{},"HookType":{},"HookStatus":{},"HookStatusReason":{},"HookInvocationPoint":{},"HookFailureMode":{}}}},"NextToken":{}}}},"DescribeStackInstance":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion"],"members":{"StackSetName":{},"StackInstanceAccount":{},"StackInstanceRegion":{},"CallAs":{}}},"output":{"resultWrapper":"DescribeStackInstanceResult","type":"structure","members":{"StackInstance":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"ParameterOverrides":{"shape":"S18"},"Status":{},"StackInstanceStatus":{"shape":"S5q"},"StatusReason":{},"OrganizationalUnitId":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"}}}}}},"DescribeStackResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourceResult","type":"structure","members":{"StackResourceDetail":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"Metadata":{},"DriftInformation":{"shape":"S5x"},"ModuleInfo":{"shape":"S4i"}}}}}},"DescribeStackResourceDrifts":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackResourceDriftStatusFilters":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeStackResourceDriftsResult","type":"structure","required":["StackResourceDrifts"],"members":{"StackResourceDrifts":{"type":"list","member":{"shape":"S64"}},"NextToken":{}}}},"DescribeStackResources":{"input":{"type":"structure","members":{"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourcesResult","type":"structure","members":{"StackResources":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","Timestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"DriftInformation":{"shape":"S5x"},"ModuleInfo":{"shape":"S4i"}}}}}}},"DescribeStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"CallAs":{}}},"output":{"resultWrapper":"DescribeStackSetResult","type":"structure","members":{"StackSet":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"TemplateBody":{},"Parameters":{"shape":"S18"},"Capabilities":{"shape":"S1d"},"Tags":{"shape":"S1p"},"StackSetARN":{},"AdministrationRoleARN":{},"ExecutionRoleName":{},"StackSetDriftDetectionDetails":{"shape":"S6o"},"AutoDeployment":{"shape":"S30"},"PermissionModel":{},"OrganizationalUnitIds":{"shape":"S2l"},"ManagedExecution":{"shape":"S33"}}}}}},"DescribeStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"CallAs":{}}},"output":{"resultWrapper":"DescribeStackSetOperationResult","type":"structure","members":{"StackSetOperation":{"type":"structure","members":{"OperationId":{},"StackSetId":{},"Action":{},"Status":{},"OperationPreferences":{"shape":"S2p"},"RetainStacks":{"type":"boolean"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"},"DeploymentTargets":{"shape":"S2j"},"StackSetDriftDetectionDetails":{"shape":"S6o"}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStacksResult","type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"ChangeSetId":{},"Description":{},"Parameters":{"shape":"S18"},"CreationTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RollbackConfiguration":{"shape":"S1h"},"StackStatus":{},"StackStatusReason":{},"DisableRollback":{"type":"boolean"},"NotificationARNs":{"shape":"S1n"},"TimeoutInMinutes":{"type":"integer"},"Capabilities":{"shape":"S1d"},"Outputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{},"ExportName":{}}}},"RoleARN":{},"Tags":{"shape":"S1p"},"EnableTerminationProtection":{"type":"boolean"},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeType":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"Arn":{},"VersionId":{},"PublisherId":{},"PublicVersionNumber":{}}},"output":{"resultWrapper":"DescribeTypeResult","type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"DefaultVersionId":{},"IsDefaultVersion":{"type":"boolean"},"TypeTestsStatus":{},"TypeTestsStatusDescription":{},"Description":{},"Schema":{},"ProvisioningType":{},"DeprecatedStatus":{},"LoggingConfig":{"shape":"S7"},"RequiredActivatedTypes":{"type":"list","member":{"type":"structure","members":{"TypeNameAlias":{},"OriginalTypeName":{},"PublisherId":{},"SupportedMajorVersions":{"type":"list","member":{"type":"integer"}}}}},"ExecutionRoleArn":{},"Visibility":{},"SourceUrl":{},"DocumentationUrl":{},"LastUpdated":{"type":"timestamp"},"TimeCreated":{"type":"timestamp"},"ConfigurationSchema":{},"PublisherId":{},"OriginalTypeName":{},"OriginalTypeArn":{},"PublicVersionNumber":{},"LatestPublicVersion":{},"IsActivated":{"type":"boolean"},"AutoUpdate":{"type":"boolean"}}},"idempotent":true},"DescribeTypeRegistration":{"input":{"type":"structure","required":["RegistrationToken"],"members":{"RegistrationToken":{}}},"output":{"resultWrapper":"DescribeTypeRegistrationResult","type":"structure","members":{"ProgressStatus":{},"Description":{},"TypeArn":{},"TypeVersionArn":{}}},"idempotent":true},"DetectStackDrift":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"LogicalResourceIds":{"shape":"S82"}}},"output":{"resultWrapper":"DetectStackDriftResult","type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}}},"DetectStackResourceDrift":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DetectStackResourceDriftResult","type":"structure","required":["StackResourceDrift"],"members":{"StackResourceDrift":{"shape":"S64"}}}},"DetectStackSetDrift":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"OperationPreferences":{"shape":"S2p"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"DetectStackSetDriftResult","type":"structure","members":{"OperationId":{}}}},"EstimateTemplateCost":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"S18"}}},"output":{"resultWrapper":"EstimateTemplateCostResult","type":"structure","members":{"Url":{}}}},"ExecuteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"ClientRequestToken":{},"DisableRollback":{"type":"boolean"}}},"output":{"resultWrapper":"ExecuteChangeSetResult","type":"structure","members":{}}},"GetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{}}},"output":{"resultWrapper":"GetStackPolicyResult","type":"structure","members":{"StackPolicyBody":{}}}},"GetTemplate":{"input":{"type":"structure","members":{"StackName":{},"ChangeSetName":{},"TemplateStage":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"TemplateBody":{},"StagesAvailable":{"type":"list","member":{}}}}},"GetTemplateSummary":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"StackName":{},"StackSetName":{},"CallAs":{}}},"output":{"resultWrapper":"GetTemplateSummaryResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"NoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"Description":{},"Capabilities":{"shape":"S1d"},"CapabilitiesReason":{},"ResourceTypes":{"shape":"S1f"},"Version":{},"Metadata":{},"DeclaredTransforms":{"shape":"S8v"},"ResourceIdentifierSummaries":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"LogicalResourceIds":{"shape":"S82"},"ResourceIdentifiers":{"type":"list","member":{}}}}}}}},"ImportStacksToStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"StackIds":{"type":"list","member":{}},"StackIdsUrl":{},"OrganizationalUnitIds":{"shape":"S2l"},"OperationPreferences":{"shape":"S2p"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"ImportStacksToStackSetResult","type":"structure","members":{"OperationId":{}}}},"ListChangeSets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListChangeSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackId":{},"StackName":{},"ChangeSetId":{},"ChangeSetName":{},"ExecutionStatus":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"Description":{},"IncludeNestedStacks":{"type":"boolean"},"ParentChangeSetId":{},"RootChangeSetId":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListExportsResult","type":"structure","members":{"Exports":{"type":"list","member":{"type":"structure","members":{"ExportingStackId":{},"Name":{},"Value":{}}}},"NextToken":{}}}},"ListImports":{"input":{"type":"structure","required":["ExportName"],"members":{"ExportName":{},"NextToken":{}}},"output":{"resultWrapper":"ListImportsResult","type":"structure","members":{"Imports":{"type":"list","member":{}},"NextToken":{}}}},"ListStackInstances":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{}}}},"StackInstanceAccount":{},"StackInstanceRegion":{},"CallAs":{}}},"output":{"resultWrapper":"ListStackInstancesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{},"StackInstanceStatus":{"shape":"S5q"},"OrganizationalUnitId":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackResources":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListStackResourcesResult","type":"structure","members":{"StackResourceSummaries":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"DriftInformation":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"ModuleInfo":{"shape":"S4i"}}}},"NextToken":{}}}},"ListStackSetOperationResults":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"CallAs":{}}},"output":{"resultWrapper":"ListStackSetOperationResultsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"Status":{},"StatusReason":{},"AccountGateResult":{"type":"structure","members":{"Status":{},"StatusReason":{}}},"OrganizationalUnitId":{}}}},"NextToken":{}}}},"ListStackSetOperations":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"CallAs":{}}},"output":{"resultWrapper":"ListStackSetOperationsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Action":{},"Status":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{},"CallAs":{}}},"output":{"resultWrapper":"ListStackSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"AutoDeployment":{"shape":"S30"},"PermissionModel":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"ManagedExecution":{"shape":"S33"}}}},"NextToken":{}}}},"ListStacks":{"input":{"type":"structure","members":{"NextToken":{},"StackStatusFilter":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListStacksResult","type":"structure","members":{"StackSummaries":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"TemplateDescription":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"StackStatus":{},"StackStatusReason":{},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"ListTypeRegistrations":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"TypeArn":{},"RegistrationStatusFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListTypeRegistrationsResult","type":"structure","members":{"RegistrationTokenList":{"type":"list","member":{}},"NextToken":{}}},"idempotent":true},"ListTypeVersions":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"Arn":{},"MaxResults":{"type":"integer"},"NextToken":{},"DeprecatedStatus":{},"PublisherId":{}}},"output":{"resultWrapper":"ListTypeVersionsResult","type":"structure","members":{"TypeVersionSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"TypeName":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"Arn":{},"TimeCreated":{"type":"timestamp"},"Description":{},"PublicVersionNumber":{}}}},"NextToken":{}}},"idempotent":true},"ListTypes":{"input":{"type":"structure","members":{"Visibility":{},"ProvisioningType":{},"DeprecatedStatus":{},"Type":{},"Filters":{"type":"structure","members":{"Category":{},"PublisherId":{},"TypeNamePrefix":{}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListTypesResult","type":"structure","members":{"TypeSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"TypeName":{},"DefaultVersionId":{},"TypeArn":{},"LastUpdated":{"type":"timestamp"},"Description":{},"PublisherId":{},"OriginalTypeName":{},"PublicVersionNumber":{},"LatestPublicVersion":{},"PublisherIdentity":{},"PublisherName":{},"IsActivated":{"type":"boolean"}}}},"NextToken":{}}},"idempotent":true},"PublishType":{"input":{"type":"structure","members":{"Type":{},"Arn":{},"TypeName":{},"PublicVersionNumber":{}}},"output":{"resultWrapper":"PublishTypeResult","type":"structure","members":{"PublicTypeArn":{}}},"idempotent":true},"RecordHandlerProgress":{"input":{"type":"structure","required":["BearerToken","OperationStatus"],"members":{"BearerToken":{},"OperationStatus":{},"CurrentOperationStatus":{},"StatusMessage":{},"ErrorCode":{},"ResourceModel":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RecordHandlerProgressResult","type":"structure","members":{}},"idempotent":true},"RegisterPublisher":{"input":{"type":"structure","members":{"AcceptTermsAndConditions":{"type":"boolean"},"ConnectionArn":{}}},"output":{"resultWrapper":"RegisterPublisherResult","type":"structure","members":{"PublisherId":{}}},"idempotent":true},"RegisterType":{"input":{"type":"structure","required":["TypeName","SchemaHandlerPackage"],"members":{"Type":{},"TypeName":{},"SchemaHandlerPackage":{},"LoggingConfig":{"shape":"S7"},"ExecutionRoleArn":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RegisterTypeResult","type":"structure","members":{"RegistrationToken":{}}},"idempotent":true},"RollbackStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RollbackStackResult","type":"structure","members":{"StackId":{}}}},"SetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackPolicyBody":{},"StackPolicyURL":{}}}},"SetTypeConfiguration":{"input":{"type":"structure","required":["Configuration"],"members":{"TypeArn":{},"Configuration":{},"ConfigurationAlias":{},"TypeName":{},"Type":{}}},"output":{"resultWrapper":"SetTypeConfigurationResult","type":"structure","members":{"ConfigurationArn":{}}}},"SetTypeDefaultVersion":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{}}},"output":{"resultWrapper":"SetTypeDefaultVersionResult","type":"structure","members":{}},"idempotent":true},"SignalResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId","UniqueId","Status"],"members":{"StackName":{},"LogicalResourceId":{},"UniqueId":{},"Status":{}}}},"StopStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"CallAs":{}}},"output":{"resultWrapper":"StopStackSetOperationResult","type":"structure","members":{}}},"TestType":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{},"LogDeliveryBucket":{}}},"output":{"resultWrapper":"TestTypeResult","type":"structure","members":{"TypeVersionArn":{}}},"idempotent":true},"UpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"StackPolicyDuringUpdateBody":{},"StackPolicyDuringUpdateURL":{},"Parameters":{"shape":"S18"},"Capabilities":{"shape":"S1d"},"ResourceTypes":{"shape":"S1f"},"RoleARN":{},"RollbackConfiguration":{"shape":"S1h"},"StackPolicyBody":{},"StackPolicyURL":{},"NotificationARNs":{"shape":"S1n"},"Tags":{"shape":"S1p"},"DisableRollback":{"type":"boolean"},"ClientRequestToken":{}}},"output":{"resultWrapper":"UpdateStackResult","type":"structure","members":{"StackId":{}}}},"UpdateStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S2h"},"DeploymentTargets":{"shape":"S2j"},"Regions":{"shape":"S2n"},"ParameterOverrides":{"shape":"S18"},"OperationPreferences":{"shape":"S2p"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"UpdateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"UpdateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"S18"},"Capabilities":{"shape":"S1d"},"Tags":{"shape":"S1p"},"OperationPreferences":{"shape":"S2p"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"DeploymentTargets":{"shape":"S2j"},"PermissionModel":{},"AutoDeployment":{"shape":"S30"},"OperationId":{"idempotencyToken":true},"Accounts":{"shape":"S2h"},"Regions":{"shape":"S2n"},"CallAs":{},"ManagedExecution":{"shape":"S33"}}},"output":{"resultWrapper":"UpdateStackSetResult","type":"structure","members":{"OperationId":{}}}},"UpdateTerminationProtection":{"input":{"type":"structure","required":["EnableTerminationProtection","StackName"],"members":{"EnableTerminationProtection":{"type":"boolean"},"StackName":{}}},"output":{"resultWrapper":"UpdateTerminationProtectionResult","type":"structure","members":{"StackId":{}}}},"ValidateTemplate":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{}}},"output":{"resultWrapper":"ValidateTemplateResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"NoEcho":{"type":"boolean"},"Description":{}}}},"Description":{},"Capabilities":{"shape":"S1d"},"CapabilitiesReason":{},"DeclaredTransforms":{"shape":"S8v"}}}}},"shapes":{"S7":{"type":"structure","required":["LogRoleArn","LogGroupName"],"members":{"LogRoleArn":{},"LogGroupName":{}}},"Sg":{"type":"structure","members":{"TypeArn":{},"TypeConfigurationAlias":{},"TypeConfigurationArn":{},"Type":{},"TypeName":{}}},"S18":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"ParameterValue":{},"UsePreviousValue":{"type":"boolean"},"ResolvedValue":{}}}},"S1d":{"type":"list","member":{}},"S1f":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"RollbackTriggers":{"type":"list","member":{"type":"structure","required":["Arn","Type"],"members":{"Arn":{},"Type":{}}}},"MonitoringTimeInMinutes":{"type":"integer"}}},"S1n":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S2h":{"type":"list","member":{}},"S2j":{"type":"structure","members":{"Accounts":{"shape":"S2h"},"AccountsUrl":{},"OrganizationalUnitIds":{"shape":"S2l"}}},"S2l":{"type":"list","member":{}},"S2n":{"type":"list","member":{}},"S2p":{"type":"structure","members":{"RegionConcurrencyType":{},"RegionOrder":{"shape":"S2n"},"FailureToleranceCount":{"type":"integer"},"FailureTolerancePercentage":{"type":"integer"},"MaxConcurrentCount":{"type":"integer"},"MaxConcurrentPercentage":{"type":"integer"}}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"RetainStacksOnAccountRemoval":{"type":"boolean"}}},"S33":{"type":"structure","members":{"Active":{"type":"boolean"}}},"S4i":{"type":"structure","members":{"TypeHierarchy":{},"LogicalIdHierarchy":{}}},"S5q":{"type":"structure","members":{"DetailedStatus":{}}},"S5x":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"S64":{"type":"structure","required":["StackId","LogicalResourceId","ResourceType","StackResourceDriftStatus","Timestamp"],"members":{"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"PhysicalResourceIdContext":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"ResourceType":{},"ExpectedProperties":{},"ActualProperties":{},"PropertyDifferences":{"type":"list","member":{"type":"structure","required":["PropertyPath","ExpectedValue","ActualValue","DifferenceType"],"members":{"PropertyPath":{},"ExpectedValue":{},"ActualValue":{},"DifferenceType":{}}}},"StackResourceDriftStatus":{},"Timestamp":{"type":"timestamp"},"ModuleInfo":{"shape":"S4i"}}},"S6o":{"type":"structure","members":{"DriftStatus":{},"DriftDetectionStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"TotalStackInstancesCount":{"type":"integer"},"DriftedStackInstancesCount":{"type":"integer"},"InSyncStackInstancesCount":{"type":"integer"},"InProgressStackInstancesCount":{"type":"integer"},"FailedStackInstancesCount":{"type":"integer"}}},"S82":{"type":"list","member":{}},"S8v":{"type":"list","member":{}}}}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAccountLimits":{"input_token":"NextToken","output_token":"NextToken","result_key":"AccountLimits"},"DescribeStackEvents":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackEvents"},"DescribeStackResourceDrifts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribeStackResources":{"result_key":"StackResources"},"DescribeStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"Stacks"},"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","result_key":"Summaries"},"ListExports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Exports"},"ListImports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Imports"},"ListStackInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackResources":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackResourceSummaries"},"ListStackSetOperationResults":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackSetOperations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackSets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackSummaries"},"ListTypeRegistrations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTypeVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TypeSummaries"}}}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"StackExists":{"delay":5,"operation":"DescribeStacks","maxAttempts":20,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"ValidationError","state":"retry"}]},"StackCreateComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is CREATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"CREATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackDeleteComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is DELETE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ValidationError","matcher":"error","state":"success"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"}]},"StackUpdateComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is UPDATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackImportComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is IMPORT_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"IMPORT_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"IMPORT_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"IMPORT_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"IMPORT_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackRollbackComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is UPDATE_ROLLBACK_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"ChangeSetCreateComplete":{"delay":30,"operation":"DescribeChangeSet","maxAttempts":120,"description":"Wait until change set status is CREATE_COMPLETE.","acceptors":[{"argument":"Status","expected":"CREATE_COMPLETE","matcher":"path","state":"success"},{"argument":"Status","expected":"FAILED","matcher":"path","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"TypeRegistrationComplete":{"delay":30,"operation":"DescribeTypeRegistration","maxAttempts":120,"description":"Wait until type registration is COMPLETE.","acceptors":[{"argument":"ProgressStatus","expected":"COMPLETE","matcher":"path","state":"success"},{"argument":"ProgressStatus","expected":"FAILED","matcher":"path","state":"failure"}]}}}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudfront'] = {};
	AWS.CloudFront = Service.defineService('cloudfront', ['2013-05-12*', '2013-11-11*', '2014-05-31*', '2014-10-21*', '2014-11-06*', '2015-04-17*', '2015-07-27*', '2015-09-17*', '2016-01-13*', '2016-01-28*', '2016-08-01*', '2016-08-20*', '2016-09-07*', '2016-09-29*', '2016-11-25', '2016-11-25*', '2017-03-25', '2017-03-25*', '2017-10-30', '2017-10-30*', '2018-06-18', '2018-06-18*', '2018-11-05', '2018-11-05*', '2019-03-26', '2019-03-26*', '2020-05-31']);
	__webpack_require__(84);
	Object.defineProperty(apiLoader.services['cloudfront'], '2016-11-25', {
	  get: function get() {
	    var model = __webpack_require__(86);
	    model.paginators = __webpack_require__(87).pagination;
	    model.waiters = __webpack_require__(88).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2017-03-25', {
	  get: function get() {
	    var model = __webpack_require__(89);
	    model.paginators = __webpack_require__(90).pagination;
	    model.waiters = __webpack_require__(91).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2017-10-30', {
	  get: function get() {
	    var model = __webpack_require__(92);
	    model.paginators = __webpack_require__(93).pagination;
	    model.waiters = __webpack_require__(94).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2018-06-18', {
	  get: function get() {
	    var model = __webpack_require__(95);
	    model.paginators = __webpack_require__(96).pagination;
	    model.waiters = __webpack_require__(97).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2018-11-05', {
	  get: function get() {
	    var model = __webpack_require__(98);
	    model.paginators = __webpack_require__(99).pagination;
	    model.waiters = __webpack_require__(100).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2019-03-26', {
	  get: function get() {
	    var model = __webpack_require__(101);
	    model.paginators = __webpack_require__(102).pagination;
	    model.waiters = __webpack_require__(103).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2020-05-31', {
	  get: function get() {
	    var model = __webpack_require__(104);
	    model.paginators = __webpack_require__(105).pagination;
	    model.waiters = __webpack_require__(106).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudFront;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	// pull in CloudFront signer
	__webpack_require__(85);

	AWS.util.update(AWS.CloudFront.prototype, {

	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	  }

	});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4),
	    url = AWS.util.url,
	    crypto = AWS.util.crypto.lib,
	    base64Encode = AWS.util.base64.encode,
	    inherit = AWS.util.inherit;

	var queryEncode = function (string) {
	    var replacements = {
	        '+': '-',
	        '=': '_',
	        '/': '~'
	    };
	    return string.replace(/[\+=\/]/g, function (match) {
	        return replacements[match];
	    });
	};

	var signPolicy = function (policy, privateKey) {
	    var sign = crypto.createSign('RSA-SHA1');
	    sign.write(policy);
	    return queryEncode(sign.sign(privateKey, 'base64'));
	};

	var signWithCannedPolicy = function (url, expires, keyPairId, privateKey) {
	    var policy = JSON.stringify({
	        Statement: [
	            {
	                Resource: url,
	                Condition: { DateLessThan: { 'AWS:EpochTime': expires } }
	            }
	        ]
	    });

	    return {
	        Expires: expires,
	        'Key-Pair-Id': keyPairId,
	        Signature: signPolicy(policy.toString(), privateKey)
	    };
	};

	var signWithCustomPolicy = function (policy, keyPairId, privateKey) {
	    policy = policy.replace(/\s/mg, '');

	    return {
	        Policy: queryEncode(base64Encode(policy)),
	        'Key-Pair-Id': keyPairId,
	        Signature: signPolicy(policy, privateKey)
	    };
	};

	var determineScheme = function (url) {
	    var parts = url.split('://');
	    if (parts.length < 2) {
	        throw new Error('Invalid URL.');
	    }

	    return parts[0].replace('*', '');
	};

	var getRtmpUrl = function (rtmpUrl) {
	    var parsed = url.parse(rtmpUrl);
	    return parsed.path.replace(/^\//, '') + (parsed.hash || '');
	};

	var getResource = function (url) {
	    switch (determineScheme(url)) {
	        case 'http':
	        case 'https':
	            return url;
	        case 'rtmp':
	            return getRtmpUrl(url);
	        default:
	            throw new Error('Invalid URI scheme. Scheme must be one of'
	                + ' http, https, or rtmp');
	    }
	};

	var handleError = function (err, callback) {
	    if (!callback || typeof callback !== 'function') {
	        throw err;
	    }

	    callback(err);
	};

	var handleSuccess = function (result, callback) {
	    if (!callback || typeof callback !== 'function') {
	        return result;
	    }

	    callback(null, result);
	};

	AWS.CloudFront.Signer = inherit({
	    /**
	     * A signer object can be used to generate signed URLs and cookies for granting
	     * access to content on restricted CloudFront distributions.
	     *
	     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
	     *
	     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
	     *                              being used.
	     * @param privateKey [String]   (Required) A private key in RSA format.
	     */
	    constructor: function Signer(keyPairId, privateKey) {
	        if (keyPairId === void 0 || privateKey === void 0) {
	            throw new Error('A key pair ID and private key are required');
	        }

	        this.keyPairId = keyPairId;
	        this.privateKey = privateKey;
	    },

	    /**
	     * Create a signed Amazon CloudFront Cookie.
	     *
	     * @param options [Object]            The options to create a signed cookie.
	     * @option options url [String]     The URL to which the signature will grant
	     *                                  access. Required unless you pass in a full
	     *                                  policy.
	     * @option options expires [Number] A Unix UTC timestamp indicating when the
	     *                                  signature should expire. Required unless you
	     *                                  pass in a full policy.
	     * @option options policy [String]  A CloudFront JSON policy. Required unless
	     *                                  you pass in a url and an expiry time.
	     *
	     * @param cb [Function] if a callback is provided, this function will
	     *   pass the hash as the second parameter (after the error parameter) to
	     *   the callback function.
	     *
	     * @return [Object] if called synchronously (with no callback), returns the
	     *   signed cookie parameters.
	     * @return [null] nothing is returned if a callback is provided.
	     */
	    getSignedCookie: function (options, cb) {
	        var signatureHash = 'policy' in options
	            ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
	            : signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);

	        var cookieHash = {};
	        for (var key in signatureHash) {
	            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
	                cookieHash['CloudFront-' + key] = signatureHash[key];
	            }
	        }

	        return handleSuccess(cookieHash, cb);
	    },

	    /**
	     * Create a signed Amazon CloudFront URL.
	     *
	     * Keep in mind that URLs meant for use in media/flash players may have
	     * different requirements for URL formats (e.g. some require that the
	     * extension be removed, some require the file name to be prefixed
	     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
	     *
	     * @param options [Object]          The options to create a signed URL.
	     * @option options url [String]     The URL to which the signature will grant
	     *                                  access. Any query params included with
	     *                                  the URL should be encoded. Required.
	     * @option options expires [Number] A Unix UTC timestamp indicating when the
	     *                                  signature should expire. Required unless you
	     *                                  pass in a full policy.
	     * @option options policy [String]  A CloudFront JSON policy. Required unless
	     *                                  you pass in a url and an expiry time.
	     *
	     * @param cb [Function] if a callback is provided, this function will
	     *   pass the URL as the second parameter (after the error parameter) to
	     *   the callback function.
	     *
	     * @return [String] if called synchronously (with no callback), returns the
	     *   signed URL.
	     * @return [null] nothing is returned if a callback is provided.
	     */
	    getSignedUrl: function (options, cb) {
	        try {
	            var resource = getResource(options.url);
	        } catch (err) {
	            return handleError(err, cb);
	        }

	        var parsedUrl = url.parse(options.url, true),
	            signatureHash = Object.prototype.hasOwnProperty.call(options, 'policy')
	                ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
	                : signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);

	        parsedUrl.search = null;
	        for (var key in signatureHash) {
	            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
	                parsedUrl.query[key] = signatureHash[key];
	            }
	        }

	        try {
	            var signedUrl = determineScheme(options.url) === 'rtmp'
	                    ? getRtmpUrl(url.format(parsedUrl))
	                    : url.format(parsedUrl);
	        } catch (err) {
	            return handleError(err, cb);
	        }

	        return handleSuccess(signedUrl, cb);
	    }
	});

	/**
	 * @api private
	 */
	module.exports = AWS.CloudFront.Signer;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2016-11-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2016-11-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2016-11-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2016-11-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2016-11-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2016-11-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2016-11-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2016-11-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","output_token":"DistributionList.NextMarker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","output_token":"InvalidationList.NextMarker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","output_token":"StreamingDistributionList.NextMarker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-03-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-03-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-03-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-03-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-03-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-03-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteServiceLinkedRole":{"http":{"method":"DELETE","requestUri":"/2017-03-25/service-linked-role/{RoleName}","responseCode":204},"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{"location":"uri","locationName":"RoleName"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-03-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-03-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3b":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-30","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-10-30"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-10-30/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-10-30/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-10-30/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2017-10-30/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2017-10-30/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2017-10-30/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-10-30/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-10-30/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2017-10-30/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-10-30/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-10-30/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-18","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-06-18"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-06-18/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-06-18/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-06-18/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-06-18/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-06-18/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-06-18/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-06-18/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-06-18/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-06-18/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-06-18/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-06-18/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-05","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-11-05"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-11-05/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-11-05/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-11-05/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2b"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-11-05/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-11-05/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S34","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-11-05/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-11-05/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-11-05/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3e"},"Tags":{"shape":"S2b"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-11-05/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3a"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-11-05/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2w"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-11-05/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2b"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2b","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1s":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1w":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S22":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"DistributionConfig":{"shape":"S7"}}},"S24":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2b":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2i":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}},"S2j":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2n":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2i"}}},"S2v":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2w"}}},"S2w":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S32":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2v"}}},"S34":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S38":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S34"}}},"S3a":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3c":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3a"}}},"S3e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"StreamingDistributionConfig":{"shape":"S3e"}}},"S4p":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-03-26","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2019-03-26"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2019-03-26/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2019-03-26/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2019-03-26/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2f"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2019-03-26/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2019-03-26/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S38","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2019-03-26/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2019-03-26/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2019-03-26/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3i"},"Tags":{"shape":"S2f"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2019-03-26/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2019-03-26/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S30"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2019-03-26/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2f"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2f","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{"type":"string","sensitive":true},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}},"ConnectionAttempts":{"type":"integer"},"ConnectionTimeout":{"type":"integer"}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1t":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1x":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S23":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"DistributionConfig":{"shape":"S7"},"AliasICPRecordals":{"shape":"S2a"}}},"S25":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2a":{"type":"list","member":{"locationName":"AliasICPRecordal","type":"structure","members":{"CNAME":{},"ICPRecordalStatus":{}}}},"S2f":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2m":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}},"S2n":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2r":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2x":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2m"}}},"S2z":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S30"}}},"S30":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S36":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2z"}}},"S38":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S3c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S38"}}},"S3e":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3g":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3e"}}},"S3i":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3j":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3m":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"StreamingDistributionConfig":{"shape":"S3i"}}},"S4t":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"AliasICPRecordals":{"shape":"S2a"}}}}}}}}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":35,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-05-31","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2020-05-31"},"operations":{"AssociateAlias":{"http":{"method":"PUT","requestUri":"/2020-05-31/distribution/{TargetDistributionId}/associate-alias","responseCode":200},"input":{"type":"structure","required":["TargetDistributionId","Alias"],"members":{"TargetDistributionId":{"location":"uri","locationName":"TargetDistributionId"},"Alias":{"location":"querystring","locationName":"Alias"}}}},"CreateCachePolicy":{"http":{"requestUri":"/2020-05-31/cache-policy","responseCode":201},"input":{"type":"structure","required":["CachePolicyConfig"],"members":{"CachePolicyConfig":{"shape":"S4","locationName":"CachePolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"CachePolicyConfig"},"output":{"type":"structure","members":{"CachePolicy":{"shape":"Sm"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicy"}},"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2020-05-31/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"Sp","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"Sr"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2020-05-31/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"St","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S2r"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2020-05-31/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"St"},"Tags":{"shape":"S35"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S2r"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2020-05-31/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S3c","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S3n"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2020-05-31/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S3p","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S3w"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateFunction":{"http":{"requestUri":"/2020-05-31/function","responseCode":201},"input":{"locationName":"CreateFunctionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["Name","FunctionConfig","FunctionCode"],"members":{"Name":{},"FunctionConfig":{"shape":"S3z"},"FunctionCode":{"shape":"S41"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S43"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FunctionSummary"}},"CreateInvalidation":{"http":{"requestUri":"/2020-05-31/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S47","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S4b"}},"payload":"Invalidation"}},"CreateKeyGroup":{"http":{"requestUri":"/2020-05-31/key-group","responseCode":201},"input":{"type":"structure","required":["KeyGroupConfig"],"members":{"KeyGroupConfig":{"shape":"S4d","locationName":"KeyGroupConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"KeyGroupConfig"},"output":{"type":"structure","members":{"KeyGroup":{"shape":"S4g"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroup"}},"CreateMonitoringSubscription":{"http":{"requestUri":"/2020-05-31/distributions/{DistributionId}/monitoring-subscription"},"input":{"type":"structure","required":["MonitoringSubscription","DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"MonitoringSubscription":{"shape":"S4i","locationName":"MonitoringSubscription","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"MonitoringSubscription"},"output":{"type":"structure","members":{"MonitoringSubscription":{"shape":"S4i"}},"payload":"MonitoringSubscription"}},"CreateOriginRequestPolicy":{"http":{"requestUri":"/2020-05-31/origin-request-policy","responseCode":201},"input":{"type":"structure","required":["OriginRequestPolicyConfig"],"members":{"OriginRequestPolicyConfig":{"shape":"S4n","locationName":"OriginRequestPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"OriginRequestPolicyConfig"},"output":{"type":"structure","members":{"OriginRequestPolicy":{"shape":"S4v"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicy"}},"CreatePublicKey":{"http":{"requestUri":"/2020-05-31/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S4x","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S4z"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/realtime-log-config","responseCode":201},"input":{"locationName":"CreateRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["EndPoints","Fields","Name","SamplingRate"],"members":{"EndPoints":{"shape":"S51"},"Fields":{"shape":"S54"},"Name":{},"SamplingRate":{"type":"long"}}},"output":{"type":"structure","members":{"RealtimeLogConfig":{"shape":"S56"}}}},"CreateResponseHeadersPolicy":{"http":{"requestUri":"/2020-05-31/response-headers-policy","responseCode":201},"input":{"type":"structure","required":["ResponseHeadersPolicyConfig"],"members":{"ResponseHeadersPolicyConfig":{"shape":"S58","locationName":"ResponseHeadersPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"ResponseHeadersPolicyConfig"},"output":{"type":"structure","members":{"ResponseHeadersPolicy":{"shape":"S5y"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicy"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2020-05-31/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S60","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S64"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2020-05-31/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S60"},"Tags":{"shape":"S35"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S64"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCachePolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/cache-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2020-05-31/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2020-05-31/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2020-05-31/function/{Name}","responseCode":204},"input":{"type":"structure","required":["IfMatch","Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteKeyGroup":{"http":{"method":"DELETE","requestUri":"/2020-05-31/key-group/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteMonitoringSubscription":{"http":{"method":"DELETE","requestUri":"/2020-05-31/distributions/{DistributionId}/monitoring-subscription"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"}}},"output":{"type":"structure","members":{}}},"DeleteOriginRequestPolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/origin-request-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2020-05-31/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/delete-realtime-log-config/","responseCode":204},"input":{"locationName":"DeleteRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Name":{},"ARN":{}}}},"DeleteResponseHeadersPolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/response-headers-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2020-05-31/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DescribeFunction":{"http":{"method":"GET","requestUri":"/2020-05-31/function/{Name}/describe"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"Stage":{"location":"querystring","locationName":"Stage"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S43"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FunctionSummary"}},"GetCachePolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/cache-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CachePolicy":{"shape":"Sm"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicy"}},"GetCachePolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/cache-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CachePolicyConfig":{"shape":"S4"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicyConfig"}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"Sr"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"Sp"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S2r"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"St"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S3n"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S3w"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S3p"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2020-05-31/function/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"Stage":{"location":"querystring","locationName":"Stage"}}},"output":{"type":"structure","members":{"FunctionCode":{"shape":"S41"},"ETag":{"location":"header","locationName":"ETag"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"FunctionCode"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S4b"}},"payload":"Invalidation"}},"GetKeyGroup":{"http":{"method":"GET","requestUri":"/2020-05-31/key-group/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"KeyGroup":{"shape":"S4g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroup"}},"GetKeyGroupConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/key-group/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"KeyGroupConfig":{"shape":"S4d"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroupConfig"}},"GetMonitoringSubscription":{"http":{"method":"GET","requestUri":"/2020-05-31/distributions/{DistributionId}/monitoring-subscription"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"}}},"output":{"type":"structure","members":{"MonitoringSubscription":{"shape":"S4i"}},"payload":"MonitoringSubscription"}},"GetOriginRequestPolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-request-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"OriginRequestPolicy":{"shape":"S4v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicy"}},"GetOriginRequestPolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-request-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"OriginRequestPolicyConfig":{"shape":"S4n"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicyConfig"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2020-05-31/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S4z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S4x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/get-realtime-log-config/"},"input":{"locationName":"GetRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Name":{},"ARN":{}}},"output":{"type":"structure","members":{"RealtimeLogConfig":{"shape":"S56"}}}},"GetResponseHeadersPolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/response-headers-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"ResponseHeadersPolicy":{"shape":"S5y"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicy"}},"GetResponseHeadersPolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/response-headers-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"ResponseHeadersPolicyConfig":{"shape":"S58"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2020-05-31/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S64"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S60"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCachePolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/cache-policy"},"input":{"type":"structure","members":{"Type":{"location":"querystring","locationName":"Type"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CachePolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CachePolicySummary","type":"structure","required":["Type","CachePolicy"],"members":{"Type":{},"CachePolicy":{"shape":"Sm"}}}}}}},"payload":"CachePolicyList"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListConflictingAliases":{"http":{"method":"GET","requestUri":"/2020-05-31/conflicting-alias","responseCode":200},"input":{"type":"structure","required":["DistributionId","Alias"],"members":{"DistributionId":{"location":"querystring","locationName":"DistributionId"},"Alias":{"location":"querystring","locationName":"Alias"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"ConflictingAliasesList":{"type":"structure","members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ConflictingAlias","type":"structure","members":{"Alias":{},"DistributionId":{},"AccountId":{}}}}}}},"payload":"ConflictingAliasesList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S8l"}},"payload":"DistributionList"}},"ListDistributionsByCachePolicyId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByCachePolicyId/{CachePolicyId}"},"input":{"type":"structure","required":["CachePolicyId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"CachePolicyId":{"location":"uri","locationName":"CachePolicyId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"S8q"}},"payload":"DistributionIdList"}},"ListDistributionsByKeyGroup":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByKeyGroupId/{KeyGroupId}"},"input":{"type":"structure","required":["KeyGroupId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"KeyGroupId":{"location":"uri","locationName":"KeyGroupId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"S8q"}},"payload":"DistributionIdList"}},"ListDistributionsByOriginRequestPolicyId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByOriginRequestPolicyId/{OriginRequestPolicyId}"},"input":{"type":"structure","required":["OriginRequestPolicyId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"OriginRequestPolicyId":{"location":"uri","locationName":"OriginRequestPolicyId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"S8q"}},"payload":"DistributionIdList"}},"ListDistributionsByRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/distributionsByRealtimeLogConfig/"},"input":{"locationName":"ListDistributionsByRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Marker":{},"MaxItems":{},"RealtimeLogConfigName":{},"RealtimeLogConfigArn":{}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S8l"}},"payload":"DistributionList"}},"ListDistributionsByResponseHeadersPolicyId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByResponseHeadersPolicyId/{ResponseHeadersPolicyId}"},"input":{"type":"structure","required":["ResponseHeadersPolicyId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"ResponseHeadersPolicyId":{"location":"uri","locationName":"ResponseHeadersPolicyId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"S8q"}},"payload":"DistributionIdList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S8l"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S3d"},"ContentTypeProfileConfig":{"shape":"S3h"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S3q"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2020-05-31/function"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"Stage":{"location":"querystring","locationName":"Stage"}}},"output":{"type":"structure","members":{"FunctionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"shape":"S43","locationName":"FunctionSummary"}}}}},"payload":"FunctionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListKeyGroups":{"http":{"method":"GET","requestUri":"/2020-05-31/key-group"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"KeyGroupList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyGroupSummary","type":"structure","required":["KeyGroup"],"members":{"KeyGroup":{"shape":"S4g"}}}}}}},"payload":"KeyGroupList"}},"ListOriginRequestPolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-request-policy"},"input":{"type":"structure","members":{"Type":{"location":"querystring","locationName":"Type"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"OriginRequestPolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginRequestPolicySummary","type":"structure","required":["Type","OriginRequestPolicy"],"members":{"Type":{},"OriginRequestPolicy":{"shape":"S4v"}}}}}}},"payload":"OriginRequestPolicyList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2020-05-31/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListRealtimeLogConfigs":{"http":{"method":"GET","requestUri":"/2020-05-31/realtime-log-config"},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems"},"Marker":{"location":"querystring","locationName":"Marker"}}},"output":{"type":"structure","members":{"RealtimeLogConfigs":{"type":"structure","required":["MaxItems","IsTruncated","Marker"],"members":{"MaxItems":{"type":"integer"},"Items":{"type":"list","member":{"shape":"S56"}},"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{}}}},"payload":"RealtimeLogConfigs"}},"ListResponseHeadersPolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/response-headers-policy"},"input":{"type":"structure","members":{"Type":{"location":"querystring","locationName":"Type"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"ResponseHeadersPolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ResponseHeadersPolicySummary","type":"structure","required":["Type","ResponseHeadersPolicy"],"members":{"Type":{},"ResponseHeadersPolicy":{"shape":"S5y"}}}}}}},"payload":"ResponseHeadersPolicyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2020-05-31/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S61"},"Aliases":{"shape":"Su"},"TrustedSigners":{"shape":"S1l"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2020-05-31/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S35"}},"payload":"Tags"}},"PublishFunction":{"http":{"requestUri":"/2020-05-31/function/{Name}/publish"},"input":{"type":"structure","required":["Name","IfMatch"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S43"}},"payload":"FunctionSummary"}},"TagResource":{"http":{"requestUri":"/2020-05-31/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S35","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"Tags"}},"TestFunction":{"http":{"requestUri":"/2020-05-31/function/{Name}/test"},"input":{"locationName":"TestFunctionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["Name","IfMatch","EventObject"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"},"Stage":{},"EventObject":{"type":"blob","sensitive":true}}},"output":{"type":"structure","members":{"TestResult":{"type":"structure","members":{"FunctionSummary":{"shape":"S43"},"ComputeUtilization":{},"FunctionExecutionLogs":{"type":"list","member":{},"sensitive":true},"FunctionErrorMessage":{"shape":"S12"},"FunctionOutput":{"shape":"S12"}}}},"payload":"TestResult"}},"UntagResource":{"http":{"requestUri":"/2020-05-31/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCachePolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/cache-policy/{Id}"},"input":{"type":"structure","required":["CachePolicyConfig","Id"],"members":{"CachePolicyConfig":{"shape":"S4","locationName":"CachePolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CachePolicyConfig"},"output":{"type":"structure","members":{"CachePolicy":{"shape":"Sm"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicy"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"Sp","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"Sr"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2020-05-31/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"St","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S2r"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2020-05-31/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S3c","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S3n"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S3p","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S3w"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdateFunction":{"http":{"method":"PUT","requestUri":"/2020-05-31/function/{Name}"},"input":{"locationName":"UpdateFunctionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["IfMatch","FunctionConfig","FunctionCode","Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"},"FunctionConfig":{"shape":"S3z"},"FunctionCode":{"shape":"S41"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S43"},"ETag":{"location":"header","locationName":"ETtag"}},"payload":"FunctionSummary"}},"UpdateKeyGroup":{"http":{"method":"PUT","requestUri":"/2020-05-31/key-group/{Id}"},"input":{"type":"structure","required":["KeyGroupConfig","Id"],"members":{"KeyGroupConfig":{"shape":"S4d","locationName":"KeyGroupConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"KeyGroupConfig"},"output":{"type":"structure","members":{"KeyGroup":{"shape":"S4g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroup"}},"UpdateOriginRequestPolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/origin-request-policy/{Id}"},"input":{"type":"structure","required":["OriginRequestPolicyConfig","Id"],"members":{"OriginRequestPolicyConfig":{"shape":"S4n","locationName":"OriginRequestPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"OriginRequestPolicyConfig"},"output":{"type":"structure","members":{"OriginRequestPolicy":{"shape":"S4v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicy"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2020-05-31/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S4x","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S4z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateRealtimeLogConfig":{"http":{"method":"PUT","requestUri":"/2020-05-31/realtime-log-config/"},"input":{"locationName":"UpdateRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"EndPoints":{"shape":"S51"},"Fields":{"shape":"S54"},"Name":{},"ARN":{},"SamplingRate":{"type":"long"}}},"output":{"type":"structure","members":{"RealtimeLogConfig":{"shape":"S56"}}}},"UpdateResponseHeadersPolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/response-headers-policy/{Id}"},"input":{"type":"structure","required":["ResponseHeadersPolicyConfig","Id"],"members":{"ResponseHeadersPolicyConfig":{"shape":"S58","locationName":"ResponseHeadersPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"ResponseHeadersPolicyConfig"},"output":{"type":"structure","members":{"ResponseHeadersPolicy":{"shape":"S5y"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicy"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2020-05-31/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S60","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S64"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S4":{"type":"structure","required":["Name","MinTTL"],"members":{"Comment":{},"Name":{},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"MinTTL":{"type":"long"},"ParametersInCacheKeyAndForwardedToOrigin":{"type":"structure","required":["EnableAcceptEncodingGzip","HeadersConfig","CookiesConfig","QueryStringsConfig"],"members":{"EnableAcceptEncodingGzip":{"type":"boolean"},"EnableAcceptEncodingBrotli":{"type":"boolean"},"HeadersConfig":{"type":"structure","required":["HeaderBehavior"],"members":{"HeaderBehavior":{},"Headers":{"shape":"Sa"}}},"CookiesConfig":{"type":"structure","required":["CookieBehavior"],"members":{"CookieBehavior":{},"Cookies":{"shape":"Sf"}}},"QueryStringsConfig":{"type":"structure","required":["QueryStringBehavior"],"members":{"QueryStringBehavior":{},"QueryStrings":{"shape":"Sj"}}}}}}},"Sa":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"Sf":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"Sj":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"Sm":{"type":"structure","required":["Id","LastModifiedTime","CachePolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"CachePolicyConfig":{"shape":"S4"}}},"Sp":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"Sr":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"Sp"}}},"St":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"Su"},"DefaultRootObject":{},"Origins":{"shape":"Sw"},"OriginGroups":{"shape":"S1b"},"DefaultCacheBehavior":{"shape":"S1k"},"CacheBehaviors":{"shape":"S28"},"CustomErrorResponses":{"shape":"S2b"},"Comment":{"type":"string","sensitive":true},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S2h"},"Restrictions":{"shape":"S2l"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"Su":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sw":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{"shape":"S12"}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}},"ConnectionAttempts":{"type":"integer"},"ConnectionTimeout":{"type":"integer"},"OriginShield":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"OriginShieldRegion":{}}}}}}}},"S12":{"type":"string","sensitive":true},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"S1k":{"type":"structure","required":["TargetOriginId","ViewerProtocolPolicy"],"members":{"TargetOriginId":{},"TrustedSigners":{"shape":"S1l"},"TrustedKeyGroups":{"shape":"S1n"},"ViewerProtocolPolicy":{},"AllowedMethods":{"shape":"S1q"},"SmoothStreaming":{"type":"boolean"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1u"},"FunctionAssociations":{"shape":"S1z"},"FieldLevelEncryptionId":{},"RealtimeLogConfigArn":{},"CachePolicyId":{},"OriginRequestPolicyId":{},"ResponseHeadersPolicyId":{},"ForwardedValues":{"shape":"S23","deprecated":true},"MinTTL":{"deprecated":true,"type":"long"},"DefaultTTL":{"deprecated":true,"type":"long"},"MaxTTL":{"deprecated":true,"type":"long"}}},"S1l":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1n":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyGroup"}}}},"S1q":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1r"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1r"}}}}},"S1r":{"type":"list","member":{"locationName":"Method"}},"S1u":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1z":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FunctionAssociation","type":"structure","required":["FunctionARN","EventType"],"members":{"FunctionARN":{},"EventType":{}}}}}},"S23":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"shape":"Sf"}}},"Headers":{"shape":"Sa"},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S28":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ViewerProtocolPolicy"],"members":{"PathPattern":{},"TargetOriginId":{},"TrustedSigners":{"shape":"S1l"},"TrustedKeyGroups":{"shape":"S1n"},"ViewerProtocolPolicy":{},"AllowedMethods":{"shape":"S1q"},"SmoothStreaming":{"type":"boolean"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1u"},"FunctionAssociations":{"shape":"S1z"},"FieldLevelEncryptionId":{},"RealtimeLogConfigArn":{},"CachePolicyId":{},"OriginRequestPolicyId":{},"ResponseHeadersPolicyId":{},"ForwardedValues":{"shape":"S23","deprecated":true},"MinTTL":{"deprecated":true,"type":"long"},"DefaultTTL":{"deprecated":true,"type":"long"},"MaxTTL":{"deprecated":true,"type":"long"}}}}}},"S2b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S2h":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S2l":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S2r":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S2s"},"ActiveTrustedKeyGroups":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyGroup","type":"structure","members":{"KeyGroupId":{},"KeyPairIds":{"shape":"S2v"}}}}}},"DistributionConfig":{"shape":"St"},"AliasICPRecordals":{"shape":"S30"}}},"S2s":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"shape":"S2v"}}}}}},"S2v":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}},"S30":{"type":"list","member":{"locationName":"AliasICPRecordal","type":"structure","members":{"CNAME":{},"ICPRecordalStatus":{}}}},"S35":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S3c":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S3d"},"ContentTypeProfileConfig":{"shape":"S3h"}}},"S3d":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S3h":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S3n":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S3c"}}},"S3p":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S3q"}}},"S3q":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S3w":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S3p"}}},"S3z":{"type":"structure","required":["Comment","Runtime"],"members":{"Comment":{},"Runtime":{}}},"S41":{"type":"blob","sensitive":true},"S43":{"type":"structure","required":["Name","FunctionConfig","FunctionMetadata"],"members":{"Name":{},"Status":{},"FunctionConfig":{"shape":"S3z"},"FunctionMetadata":{"type":"structure","required":["FunctionARN","LastModifiedTime"],"members":{"FunctionARN":{},"Stage":{},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}}},"S47":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S4b":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S47"}}},"S4d":{"type":"structure","required":["Name","Items"],"members":{"Name":{},"Items":{"type":"list","member":{"locationName":"PublicKey"}},"Comment":{}}},"S4g":{"type":"structure","required":["Id","LastModifiedTime","KeyGroupConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"KeyGroupConfig":{"shape":"S4d"}}},"S4i":{"type":"structure","members":{"RealtimeMetricsSubscriptionConfig":{"type":"structure","required":["RealtimeMetricsSubscriptionStatus"],"members":{"RealtimeMetricsSubscriptionStatus":{}}}}},"S4n":{"type":"structure","required":["Name","HeadersConfig","CookiesConfig","QueryStringsConfig"],"members":{"Comment":{},"Name":{},"HeadersConfig":{"type":"structure","required":["HeaderBehavior"],"members":{"HeaderBehavior":{},"Headers":{"shape":"Sa"}}},"CookiesConfig":{"type":"structure","required":["CookieBehavior"],"members":{"CookieBehavior":{},"Cookies":{"shape":"Sf"}}},"QueryStringsConfig":{"type":"structure","required":["QueryStringBehavior"],"members":{"QueryStringBehavior":{},"QueryStrings":{"shape":"Sj"}}}}},"S4v":{"type":"structure","required":["Id","LastModifiedTime","OriginRequestPolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"OriginRequestPolicyConfig":{"shape":"S4n"}}},"S4x":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S4z":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S4x"}}},"S51":{"type":"list","member":{"type":"structure","required":["StreamType"],"members":{"StreamType":{},"KinesisStreamConfig":{"type":"structure","required":["RoleARN","StreamARN"],"members":{"RoleARN":{},"StreamARN":{}}}}}},"S54":{"type":"list","member":{"locationName":"Field"}},"S56":{"type":"structure","required":["ARN","Name","SamplingRate","EndPoints","Fields"],"members":{"ARN":{},"Name":{},"SamplingRate":{"type":"long"},"EndPoints":{"shape":"S51"},"Fields":{"shape":"S54"}}},"S58":{"type":"structure","required":["Name"],"members":{"Comment":{},"Name":{},"CorsConfig":{"type":"structure","required":["AccessControlAllowOrigins","AccessControlAllowHeaders","AccessControlAllowMethods","AccessControlAllowCredentials","OriginOverride"],"members":{"AccessControlAllowOrigins":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin"}}}},"AccessControlAllowHeaders":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Header"}}}},"AccessControlAllowMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Method"}}}},"AccessControlAllowCredentials":{"type":"boolean"},"AccessControlExposeHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Header"}}}},"AccessControlMaxAgeSec":{"type":"integer"},"OriginOverride":{"type":"boolean"}}},"SecurityHeadersConfig":{"type":"structure","members":{"XSSProtection":{"type":"structure","required":["Override","Protection"],"members":{"Override":{"type":"boolean"},"Protection":{"type":"boolean"},"ModeBlock":{"type":"boolean"},"ReportUri":{}}},"FrameOptions":{"type":"structure","required":["Override","FrameOption"],"members":{"Override":{"type":"boolean"},"FrameOption":{}}},"ReferrerPolicy":{"type":"structure","required":["Override","ReferrerPolicy"],"members":{"Override":{"type":"boolean"},"ReferrerPolicy":{}}},"ContentSecurityPolicy":{"type":"structure","required":["Override","ContentSecurityPolicy"],"members":{"Override":{"type":"boolean"},"ContentSecurityPolicy":{}}},"ContentTypeOptions":{"type":"structure","required":["Override"],"members":{"Override":{"type":"boolean"}}},"StrictTransportSecurity":{"type":"structure","required":["Override","AccessControlMaxAgeSec"],"members":{"Override":{"type":"boolean"},"IncludeSubdomains":{"type":"boolean"},"Preload":{"type":"boolean"},"AccessControlMaxAgeSec":{"type":"integer"}}}}},"CustomHeadersConfig":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ResponseHeadersPolicyCustomHeader","type":"structure","required":["Header","Value","Override"],"members":{"Header":{},"Value":{},"Override":{"type":"boolean"}}}}}},"ServerTimingHeadersConfig":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"SamplingRate":{"type":"double"}}}}},"S5y":{"type":"structure","required":["Id","LastModifiedTime","ResponseHeadersPolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"ResponseHeadersPolicyConfig":{"shape":"S58"}}},"S60":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S61"},"Aliases":{"shape":"Su"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S1l"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S61":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S64":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S2s"},"StreamingDistributionConfig":{"shape":"S60"}}},"S8l":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"Su"},"Origins":{"shape":"Sw"},"OriginGroups":{"shape":"S1b"},"DefaultCacheBehavior":{"shape":"S1k"},"CacheBehaviors":{"shape":"S28"},"CustomErrorResponses":{"shape":"S2b"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S2h"},"Restrictions":{"shape":"S2l"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"AliasICPRecordals":{"shape":"S30"}}}}}},"S8q":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionId"}}}}}}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":35,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudhsm'] = {};
	AWS.CloudHSM = Service.defineService('cloudhsm', ['2014-05-30']);
	Object.defineProperty(apiLoader.services['cloudhsm'], '2014-05-30', {
	  get: function get() {
	    var model = __webpack_require__(108);
	    model.paginators = __webpack_require__(109).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudHSM;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-30","endpointPrefix":"cloudhsm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM","serviceFullName":"Amazon CloudHSM","serviceId":"CloudHSM","signatureVersion":"v4","targetPrefix":"CloudHsmFrontendService","uid":"cloudhsm-2014-05-30"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S3"}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"CreateHapg":{"input":{"type":"structure","required":["Label"],"members":{"Label":{}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"CreateHsm":{"input":{"type":"structure","required":["SubnetId","SshKey","IamRoleArn","SubscriptionType"],"members":{"SubnetId":{},"SshKey":{},"EniIp":{},"IamRoleArn":{},"ExternalId":{},"SubscriptionType":{},"ClientToken":{},"SyslogIp":{}}},"output":{"type":"structure","members":{"HsmArn":{}}}},"CreateLunaClient":{"input":{"type":"structure","required":["Certificate"],"members":{"Label":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"DeleteHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteLunaClient":{"input":{"type":"structure","required":["ClientArn"],"members":{"ClientArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DescribeHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","members":{"HapgArn":{},"HapgSerial":{},"HsmsLastActionFailed":{"shape":"Sz"},"HsmsPendingDeletion":{"shape":"Sz"},"HsmsPendingRegistration":{"shape":"Sz"},"Label":{},"LastModifiedTimestamp":{},"PartitionSerialList":{"shape":"S11"},"State":{}}}},"DescribeHsm":{"input":{"type":"structure","members":{"HsmArn":{},"HsmSerialNumber":{}}},"output":{"type":"structure","members":{"HsmArn":{},"Status":{},"StatusDetails":{},"AvailabilityZone":{},"EniId":{},"EniIp":{},"SubscriptionType":{},"SubscriptionStartDate":{},"SubscriptionEndDate":{},"VpcId":{},"SubnetId":{},"IamRoleArn":{},"SerialNumber":{},"VendorName":{},"HsmType":{},"SoftwareVersion":{},"SshPublicKey":{},"SshKeyLastUpdated":{},"ServerCertUri":{},"ServerCertLastUpdated":{},"Partitions":{"type":"list","member":{}}}}},"DescribeLunaClient":{"input":{"type":"structure","members":{"ClientArn":{},"CertificateFingerprint":{}}},"output":{"type":"structure","members":{"ClientArn":{},"Certificate":{},"CertificateFingerprint":{},"LastModifiedTimestamp":{},"Label":{}}}},"GetConfig":{"input":{"type":"structure","required":["ClientArn","ClientVersion","HapgList"],"members":{"ClientArn":{},"ClientVersion":{},"HapgList":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ConfigType":{},"ConfigFile":{},"ConfigCred":{}}}},"ListAvailableZones":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AZList":{"type":"list","member":{}}}}},"ListHapgs":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["HapgList"],"members":{"HapgList":{"shape":"S1i"},"NextToken":{}}}},"ListHsms":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"HsmList":{"shape":"Sz"},"NextToken":{}}}},"ListLunaClients":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["ClientList"],"members":{"ClientList":{"type":"list","member":{}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S3"}}}},"ModifyHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{},"Label":{},"PartitionSerialList":{"shape":"S11"}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"ModifyHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{},"SubnetId":{},"EniIp":{},"IamRoleArn":{},"ExternalId":{},"SyslogIp":{}}},"output":{"type":"structure","members":{"HsmArn":{}}}},"ModifyLunaClient":{"input":{"type":"structure","required":["ClientArn","Certificate"],"members":{"ClientArn":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1i":{"type":"list","member":{}}}}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudsearch'] = {};
	AWS.CloudSearch = Service.defineService('cloudsearch', ['2011-02-01', '2013-01-01']);
	Object.defineProperty(apiLoader.services['cloudsearch'], '2011-02-01', {
	  get: function get() {
	    var model = __webpack_require__(111);
	    model.paginators = __webpack_require__(112).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudsearch'], '2013-01-01', {
	  get: function get() {
	    var model = __webpack_require__(113);
	    model.paginators = __webpack_require__(114).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudSearch;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2011-02-01","endpointPrefix":"cloudsearch","serviceFullName":"Amazon CloudSearch","serviceId":"CloudSearch","signatureVersion":"v4","xmlNamespace":"http://cloudsearch.amazonaws.com/doc/2011-02-01/","protocol":"query"},"operations":{"CreateDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"CreateDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S4"}}}},"DefineIndexField":{"input":{"type":"structure","required":["DomainName","IndexField"],"members":{"DomainName":{},"IndexField":{"shape":"Sf"}}},"output":{"resultWrapper":"DefineIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"Sx"}}}},"DefineRankExpression":{"input":{"type":"structure","required":["DomainName","RankExpression"],"members":{"DomainName":{},"RankExpression":{"shape":"S12"}}},"output":{"resultWrapper":"DefineRankExpressionResult","type":"structure","required":["RankExpression"],"members":{"RankExpression":{"shape":"S15"}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DeleteDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S4"}}}},"DeleteIndexField":{"input":{"type":"structure","required":["DomainName","IndexFieldName"],"members":{"DomainName":{},"IndexFieldName":{}}},"output":{"resultWrapper":"DeleteIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"Sx"}}}},"DeleteRankExpression":{"input":{"type":"structure","required":["DomainName","RankName"],"members":{"DomainName":{},"RankName":{}}},"output":{"resultWrapper":"DeleteRankExpressionResult","type":"structure","required":["RankExpression"],"members":{"RankExpression":{"shape":"S15"}}}},"DescribeAvailabilityOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S1e"}}}},"DescribeDefaultSearchField":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeDefaultSearchFieldResult","type":"structure","required":["DefaultSearchField"],"members":{"DefaultSearchField":{"shape":"S1i"}}}},"DescribeDomains":{"input":{"type":"structure","members":{"DomainNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeDomainsResult","type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S4"}}}}},"DescribeIndexFields":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"FieldNames":{"shape":"S1o"}}},"output":{"resultWrapper":"DescribeIndexFieldsResult","type":"structure","required":["IndexFields"],"members":{"IndexFields":{"type":"list","member":{"shape":"Sx"}}}}},"DescribeRankExpressions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"RankNames":{"shape":"S1o"}}},"output":{"resultWrapper":"DescribeRankExpressionsResult","type":"structure","required":["RankExpressions"],"members":{"RankExpressions":{"type":"list","member":{"shape":"S15"}}}}},"DescribeServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S1w"}}}},"DescribeStemmingOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeStemmingOptionsResult","type":"structure","required":["Stems"],"members":{"Stems":{"shape":"S20"}}}},"DescribeStopwordOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeStopwordOptionsResult","type":"structure","required":["Stopwords"],"members":{"Stopwords":{"shape":"S24"}}}},"DescribeSynonymOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeSynonymOptionsResult","type":"structure","required":["Synonyms"],"members":{"Synonyms":{"shape":"S28"}}}},"IndexDocuments":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"IndexDocumentsResult","type":"structure","members":{"FieldNames":{"shape":"S1o"}}}},"UpdateAvailabilityOptions":{"input":{"type":"structure","required":["DomainName","MultiAZ"],"members":{"DomainName":{},"MultiAZ":{"type":"boolean"}}},"output":{"resultWrapper":"UpdateAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S1e"}}}},"UpdateDefaultSearchField":{"input":{"type":"structure","required":["DomainName","DefaultSearchField"],"members":{"DomainName":{},"DefaultSearchField":{}}},"output":{"resultWrapper":"UpdateDefaultSearchFieldResult","type":"structure","required":["DefaultSearchField"],"members":{"DefaultSearchField":{"shape":"S1i"}}}},"UpdateServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName","AccessPolicies"],"members":{"DomainName":{},"AccessPolicies":{}}},"output":{"resultWrapper":"UpdateServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S1w"}}}},"UpdateStemmingOptions":{"input":{"type":"structure","required":["DomainName","Stems"],"members":{"DomainName":{},"Stems":{}}},"output":{"resultWrapper":"UpdateStemmingOptionsResult","type":"structure","required":["Stems"],"members":{"Stems":{"shape":"S20"}}}},"UpdateStopwordOptions":{"input":{"type":"structure","required":["DomainName","Stopwords"],"members":{"DomainName":{},"Stopwords":{}}},"output":{"resultWrapper":"UpdateStopwordOptionsResult","type":"structure","required":["Stopwords"],"members":{"Stopwords":{"shape":"S24"}}}},"UpdateSynonymOptions":{"input":{"type":"structure","required":["DomainName","Synonyms"],"members":{"DomainName":{},"Synonyms":{}}},"output":{"resultWrapper":"UpdateSynonymOptionsResult","type":"structure","required":["Synonyms"],"members":{"Synonyms":{"shape":"S28"}}}}},"shapes":{"S4":{"type":"structure","required":["DomainId","DomainName","RequiresIndexDocuments"],"members":{"DomainId":{},"DomainName":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"NumSearchableDocs":{"type":"long"},"DocService":{"shape":"S8"},"SearchService":{"shape":"S8"},"RequiresIndexDocuments":{"type":"boolean"},"Processing":{"type":"boolean"},"SearchInstanceType":{},"SearchPartitionCount":{"type":"integer"},"SearchInstanceCount":{"type":"integer"}}},"S8":{"type":"structure","members":{"Arn":{},"Endpoint":{}}},"Sf":{"type":"structure","required":["IndexFieldName","IndexFieldType"],"members":{"IndexFieldName":{},"IndexFieldType":{},"UIntOptions":{"type":"structure","members":{"DefaultValue":{"type":"integer"}}},"LiteralOptions":{"type":"structure","members":{"DefaultValue":{},"SearchEnabled":{"type":"boolean"},"FacetEnabled":{"type":"boolean"},"ResultEnabled":{"type":"boolean"}}},"TextOptions":{"type":"structure","members":{"DefaultValue":{},"FacetEnabled":{"type":"boolean"},"ResultEnabled":{"type":"boolean"},"TextProcessor":{}}},"SourceAttributes":{"type":"list","member":{"type":"structure","required":["SourceDataFunction"],"members":{"SourceDataFunction":{},"SourceDataCopy":{"type":"structure","required":["SourceName"],"members":{"SourceName":{},"DefaultValue":{}}},"SourceDataTrimTitle":{"type":"structure","required":["SourceName"],"members":{"SourceName":{},"DefaultValue":{},"Separator":{},"Language":{}}},"SourceDataMap":{"type":"structure","required":["SourceName"],"members":{"SourceName":{},"DefaultValue":{},"Cases":{"type":"map","key":{},"value":{}}}}}}}}},"Sx":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sf"},"Status":{"shape":"Sy"}}},"Sy":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"S12":{"type":"structure","required":["RankName","RankExpression"],"members":{"RankName":{},"RankExpression":{}}},"S15":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S12"},"Status":{"shape":"Sy"}}},"S1e":{"type":"structure","required":["Options","Status"],"members":{"Options":{"type":"boolean"},"Status":{"shape":"Sy"}}},"S1i":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S1o":{"type":"list","member":{}},"S1w":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S20":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S24":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S28":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}}}}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDomains":{"result_key":"DomainStatusList"},"DescribeIndexFields":{"result_key":"IndexFields"},"DescribeRankExpressions":{"result_key":"RankExpressions"}}}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-01","endpointPrefix":"cloudsearch","protocol":"query","serviceFullName":"Amazon CloudSearch","serviceId":"CloudSearch","signatureVersion":"v4","uid":"cloudsearch-2013-01-01","xmlNamespace":"http://cloudsearch.amazonaws.com/doc/2013-01-01/"},"operations":{"BuildSuggesters":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"BuildSuggestersResult","type":"structure","members":{"FieldNames":{"shape":"S4"}}}},"CreateDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"CreateDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S8"}}}},"DefineAnalysisScheme":{"input":{"type":"structure","required":["DomainName","AnalysisScheme"],"members":{"DomainName":{},"AnalysisScheme":{"shape":"Sl"}}},"output":{"resultWrapper":"DefineAnalysisSchemeResult","type":"structure","required":["AnalysisScheme"],"members":{"AnalysisScheme":{"shape":"Ss"}}}},"DefineExpression":{"input":{"type":"structure","required":["DomainName","Expression"],"members":{"DomainName":{},"Expression":{"shape":"Sy"}}},"output":{"resultWrapper":"DefineExpressionResult","type":"structure","required":["Expression"],"members":{"Expression":{"shape":"S11"}}}},"DefineIndexField":{"input":{"type":"structure","required":["DomainName","IndexField"],"members":{"DomainName":{},"IndexField":{"shape":"S13"}}},"output":{"resultWrapper":"DefineIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"S1n"}}}},"DefineSuggester":{"input":{"type":"structure","required":["DomainName","Suggester"],"members":{"DomainName":{},"Suggester":{"shape":"S1p"}}},"output":{"resultWrapper":"DefineSuggesterResult","type":"structure","required":["Suggester"],"members":{"Suggester":{"shape":"S1t"}}}},"DeleteAnalysisScheme":{"input":{"type":"structure","required":["DomainName","AnalysisSchemeName"],"members":{"DomainName":{},"AnalysisSchemeName":{}}},"output":{"resultWrapper":"DeleteAnalysisSchemeResult","type":"structure","required":["AnalysisScheme"],"members":{"AnalysisScheme":{"shape":"Ss"}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DeleteDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S8"}}}},"DeleteExpression":{"input":{"type":"structure","required":["DomainName","ExpressionName"],"members":{"DomainName":{},"ExpressionName":{}}},"output":{"resultWrapper":"DeleteExpressionResult","type":"structure","required":["Expression"],"members":{"Expression":{"shape":"S11"}}}},"DeleteIndexField":{"input":{"type":"structure","required":["DomainName","IndexFieldName"],"members":{"DomainName":{},"IndexFieldName":{}}},"output":{"resultWrapper":"DeleteIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"S1n"}}}},"DeleteSuggester":{"input":{"type":"structure","required":["DomainName","SuggesterName"],"members":{"DomainName":{},"SuggesterName":{}}},"output":{"resultWrapper":"DeleteSuggesterResult","type":"structure","required":["Suggester"],"members":{"Suggester":{"shape":"S1t"}}}},"DescribeAnalysisSchemes":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AnalysisSchemeNames":{"shape":"S25"},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeAnalysisSchemesResult","type":"structure","required":["AnalysisSchemes"],"members":{"AnalysisSchemes":{"type":"list","member":{"shape":"Ss"}}}}},"DescribeAvailabilityOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S2a"}}}},"DescribeDomainEndpointOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDomainEndpointOptionsResult","type":"structure","members":{"DomainEndpointOptions":{"shape":"S2e"}}}},"DescribeDomains":{"input":{"type":"structure","members":{"DomainNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeDomainsResult","type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S8"}}}}},"DescribeExpressions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ExpressionNames":{"shape":"S25"},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeExpressionsResult","type":"structure","required":["Expressions"],"members":{"Expressions":{"type":"list","member":{"shape":"S11"}}}}},"DescribeIndexFields":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"FieldNames":{"type":"list","member":{}},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeIndexFieldsResult","type":"structure","required":["IndexFields"],"members":{"IndexFields":{"type":"list","member":{"shape":"S1n"}}}}},"DescribeScalingParameters":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeScalingParametersResult","type":"structure","required":["ScalingParameters"],"members":{"ScalingParameters":{"shape":"S2u"}}}},"DescribeServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S2z"}}}},"DescribeSuggesters":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"SuggesterNames":{"shape":"S25"},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSuggestersResult","type":"structure","required":["Suggesters"],"members":{"Suggesters":{"type":"list","member":{"shape":"S1t"}}}}},"IndexDocuments":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"IndexDocumentsResult","type":"structure","members":{"FieldNames":{"shape":"S4"}}}},"ListDomainNames":{"output":{"resultWrapper":"ListDomainNamesResult","type":"structure","members":{"DomainNames":{"type":"map","key":{},"value":{}}}}},"UpdateAvailabilityOptions":{"input":{"type":"structure","required":["DomainName","MultiAZ"],"members":{"DomainName":{},"MultiAZ":{"type":"boolean"}}},"output":{"resultWrapper":"UpdateAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S2a"}}}},"UpdateDomainEndpointOptions":{"input":{"type":"structure","required":["DomainName","DomainEndpointOptions"],"members":{"DomainName":{},"DomainEndpointOptions":{"shape":"S2f"}}},"output":{"resultWrapper":"UpdateDomainEndpointOptionsResult","type":"structure","members":{"DomainEndpointOptions":{"shape":"S2e"}}}},"UpdateScalingParameters":{"input":{"type":"structure","required":["DomainName","ScalingParameters"],"members":{"DomainName":{},"ScalingParameters":{"shape":"S2v"}}},"output":{"resultWrapper":"UpdateScalingParametersResult","type":"structure","required":["ScalingParameters"],"members":{"ScalingParameters":{"shape":"S2u"}}}},"UpdateServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName","AccessPolicies"],"members":{"DomainName":{},"AccessPolicies":{}}},"output":{"resultWrapper":"UpdateServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S2z"}}}}},"shapes":{"S4":{"type":"list","member":{}},"S8":{"type":"structure","required":["DomainId","DomainName","RequiresIndexDocuments"],"members":{"DomainId":{},"DomainName":{},"ARN":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"DocService":{"shape":"Sc"},"SearchService":{"shape":"Sc"},"RequiresIndexDocuments":{"type":"boolean"},"Processing":{"type":"boolean"},"SearchInstanceType":{},"SearchPartitionCount":{"type":"integer"},"SearchInstanceCount":{"type":"integer"},"Limits":{"type":"structure","required":["MaximumReplicationCount","MaximumPartitionCount"],"members":{"MaximumReplicationCount":{"type":"integer"},"MaximumPartitionCount":{"type":"integer"}}}}},"Sc":{"type":"structure","members":{"Endpoint":{}}},"Sl":{"type":"structure","required":["AnalysisSchemeName","AnalysisSchemeLanguage"],"members":{"AnalysisSchemeName":{},"AnalysisSchemeLanguage":{},"AnalysisOptions":{"type":"structure","members":{"Synonyms":{},"Stopwords":{},"StemmingDictionary":{},"JapaneseTokenizationDictionary":{},"AlgorithmicStemming":{}}}}},"Ss":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sl"},"Status":{"shape":"St"}}},"St":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"Sy":{"type":"structure","required":["ExpressionName","ExpressionValue"],"members":{"ExpressionName":{},"ExpressionValue":{}}},"S11":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sy"},"Status":{"shape":"St"}}},"S13":{"type":"structure","required":["IndexFieldName","IndexFieldType"],"members":{"IndexFieldName":{},"IndexFieldType":{},"IntOptions":{"type":"structure","members":{"DefaultValue":{"type":"long"},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"DoubleOptions":{"type":"structure","members":{"DefaultValue":{"type":"double"},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"LiteralOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"TextOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"},"HighlightEnabled":{"type":"boolean"},"AnalysisScheme":{}}},"DateOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"LatLonOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"IntArrayOptions":{"type":"structure","members":{"DefaultValue":{"type":"long"},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}},"DoubleArrayOptions":{"type":"structure","members":{"DefaultValue":{"type":"double"},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}},"LiteralArrayOptions":{"type":"structure","members":{"DefaultValue":{},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}},"TextArrayOptions":{"type":"structure","members":{"DefaultValue":{},"SourceFields":{},"ReturnEnabled":{"type":"boolean"},"HighlightEnabled":{"type":"boolean"},"AnalysisScheme":{}}},"DateArrayOptions":{"type":"structure","members":{"DefaultValue":{},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}}}},"S1n":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S13"},"Status":{"shape":"St"}}},"S1p":{"type":"structure","required":["SuggesterName","DocumentSuggesterOptions"],"members":{"SuggesterName":{},"DocumentSuggesterOptions":{"type":"structure","required":["SourceField"],"members":{"SourceField":{},"FuzzyMatching":{},"SortExpression":{}}}}},"S1t":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1p"},"Status":{"shape":"St"}}},"S25":{"type":"list","member":{}},"S2a":{"type":"structure","required":["Options","Status"],"members":{"Options":{"type":"boolean"},"Status":{"shape":"St"}}},"S2e":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2f"},"Status":{"shape":"St"}}},"S2f":{"type":"structure","members":{"EnforceHTTPS":{"type":"boolean"},"TLSSecurityPolicy":{}}},"S2u":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2v"},"Status":{"shape":"St"}}},"S2v":{"type":"structure","members":{"DesiredInstanceType":{},"DesiredReplicationCount":{"type":"integer"},"DesiredPartitionCount":{"type":"integer"}}},"S2z":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"St"}}}}}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAnalysisSchemes":{"result_key":"AnalysisSchemes"},"DescribeDomains":{"result_key":"DomainStatusList"},"DescribeExpressions":{"result_key":"Expressions"},"DescribeIndexFields":{"result_key":"IndexFields"},"DescribeSuggesters":{"result_key":"Suggesters"}}}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudsearchdomain'] = {};
	AWS.CloudSearchDomain = Service.defineService('cloudsearchdomain', ['2013-01-01']);
	__webpack_require__(116);
	Object.defineProperty(apiLoader.services['cloudsearchdomain'], '2013-01-01', {
	  get: function get() {
	    var model = __webpack_require__(117);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudSearchDomain;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	/**
	 * Constructs a service interface object. Each API operation is exposed as a
	 * function on service.
	 *
	 * ### Sending a Request Using CloudSearchDomain
	 *
	 * ```javascript
	 * var csd = new AWS.CloudSearchDomain({endpoint: 'my.host.tld'});
	 * csd.search(params, function (err, data) {
	 *   if (err) console.log(err, err.stack); // an error occurred
	 *   else     console.log(data);           // successful response
	 * });
	 * ```
	 *
	 * ### Locking the API Version
	 *
	 * In order to ensure that the CloudSearchDomain object uses this specific API,
	 * you can construct the object by passing the `apiVersion` option to the
	 * constructor:
	 *
	 * ```javascript
	 * var csd = new AWS.CloudSearchDomain({
	 *   endpoint: 'my.host.tld',
	 *   apiVersion: '2013-01-01'
	 * });
	 * ```
	 *
	 * You can also set the API version globally in `AWS.config.apiVersions` using
	 * the **cloudsearchdomain** service identifier:
	 *
	 * ```javascript
	 * AWS.config.apiVersions = {
	 *   cloudsearchdomain: '2013-01-01',
	 *   // other service API versions
	 * };
	 *
	 * var csd = new AWS.CloudSearchDomain({endpoint: 'my.host.tld'});
	 * ```
	 *
	 * @note You *must* provide an `endpoint` configuration parameter when
	 *   constructing this service. See {constructor} for more information.
	 *
	 * @!method constructor(options = {})
	 *   Constructs a service object. This object has one method for each
	 *   API operation.
	 *
	 *   @example Constructing a CloudSearchDomain object
	 *     var csd = new AWS.CloudSearchDomain({endpoint: 'my.host.tld'});
	 *   @note You *must* provide an `endpoint` when constructing this service.
	 *   @option (see AWS.Config.constructor)
	 *
	 * @service cloudsearchdomain
	 * @version 2013-01-01
	 */
	AWS.util.update(AWS.CloudSearchDomain.prototype, {
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	    if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
	      var msg = 'AWS.CloudSearchDomain requires an explicit ' +
	                '`endpoint\' configuration option.';
	      throw AWS.util.error(new Error(),
	        {name: 'InvalidEndpoint', message: msg});
	    }
	  },

	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.removeListener('validate',
	      AWS.EventListeners.Core.VALIDATE_CREDENTIALS
	    );
	    request.onAsync('validate', this.validateCredentials);
	    request.addListener('validate', this.updateRegion);
	    if (request.operation === 'search') {
	      request.addListener('build', this.convertGetToPost);
	    }
	  },

	  /**
	   * @api private
	   */
	  validateCredentials: function(req, done) {
	    if (!req.service.api.signatureVersion) return done(); // none
	    req.service.config.getCredentials(function(err) {
	      if (err) {
	        req.removeListener('sign', AWS.EventListeners.Core.SIGN);
	      }
	      done();
	    });
	  },

	  /**
	   * @api private
	   */
	  convertGetToPost: function(request) {
	    var httpRequest = request.httpRequest;
	    // convert queries to POST to avoid length restrictions
	    var path = httpRequest.path.split('?');
	    httpRequest.method = 'POST';
	    httpRequest.path = path[0];
	    httpRequest.body = path[1];
	    httpRequest.headers['Content-Length'] = httpRequest.body.length;
	    httpRequest.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	  },

	  /**
	   * @api private
	   */
	  updateRegion: function updateRegion(request) {
	    var endpoint = request.httpRequest.endpoint.hostname;
	    var zones = endpoint.split('.');
	    request.httpRequest.region = zones[1] || request.httpRequest.region;
	  }

	});


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-01","endpointPrefix":"cloudsearchdomain","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon CloudSearch Domain","serviceId":"CloudSearch Domain","signatureVersion":"v4","signingName":"cloudsearch","uid":"cloudsearchdomain-2013-01-01"},"operations":{"Search":{"http":{"method":"GET","requestUri":"/2013-01-01/search?format=sdk&pretty=true"},"input":{"type":"structure","required":["query"],"members":{"cursor":{"location":"querystring","locationName":"cursor"},"expr":{"location":"querystring","locationName":"expr"},"facet":{"location":"querystring","locationName":"facet"},"filterQuery":{"location":"querystring","locationName":"fq"},"highlight":{"location":"querystring","locationName":"highlight"},"partial":{"location":"querystring","locationName":"partial","type":"boolean"},"query":{"location":"querystring","locationName":"q"},"queryOptions":{"location":"querystring","locationName":"q.options"},"queryParser":{"location":"querystring","locationName":"q.parser"},"return":{"location":"querystring","locationName":"return"},"size":{"location":"querystring","locationName":"size","type":"long"},"sort":{"location":"querystring","locationName":"sort"},"start":{"location":"querystring","locationName":"start","type":"long"},"stats":{"location":"querystring","locationName":"stats"}}},"output":{"type":"structure","members":{"status":{"type":"structure","members":{"timems":{"type":"long"},"rid":{}}},"hits":{"type":"structure","members":{"found":{"type":"long"},"start":{"type":"long"},"cursor":{},"hit":{"type":"list","member":{"type":"structure","members":{"id":{},"fields":{"type":"map","key":{},"value":{"type":"list","member":{}}},"exprs":{"type":"map","key":{},"value":{}},"highlights":{"type":"map","key":{},"value":{}}}}}}},"facets":{"type":"map","key":{},"value":{"type":"structure","members":{"buckets":{"type":"list","member":{"type":"structure","members":{"value":{},"count":{"type":"long"}}}}}}},"stats":{"type":"map","key":{},"value":{"type":"structure","members":{"min":{},"max":{},"count":{"type":"long"},"missing":{"type":"long"},"sum":{"type":"double"},"sumOfSquares":{"type":"double"},"mean":{},"stddev":{"type":"double"}}}}}}},"Suggest":{"http":{"method":"GET","requestUri":"/2013-01-01/suggest?format=sdk&pretty=true"},"input":{"type":"structure","required":["query","suggester"],"members":{"query":{"location":"querystring","locationName":"q"},"suggester":{"location":"querystring","locationName":"suggester"},"size":{"location":"querystring","locationName":"size","type":"long"}}},"output":{"type":"structure","members":{"status":{"type":"structure","members":{"timems":{"type":"long"},"rid":{}}},"suggest":{"type":"structure","members":{"query":{},"found":{"type":"long"},"suggestions":{"type":"list","member":{"type":"structure","members":{"suggestion":{},"score":{"type":"long"},"id":{}}}}}}}}},"UploadDocuments":{"http":{"requestUri":"/2013-01-01/documents/batch?format=sdk"},"input":{"type":"structure","required":["documents","contentType"],"members":{"documents":{"type":"blob","streaming":true},"contentType":{"location":"header","locationName":"Content-Type"}},"payload":"documents"},"output":{"type":"structure","members":{"status":{},"adds":{"type":"long"},"deletes":{"type":"long"},"warnings":{"type":"list","member":{"type":"structure","members":{"message":{}}}}}}}},"shapes":{}}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudtrail'] = {};
	AWS.CloudTrail = Service.defineService('cloudtrail', ['2013-11-01']);
	Object.defineProperty(apiLoader.services['cloudtrail'], '2013-11-01', {
	  get: function get() {
	    var model = __webpack_require__(119);
	    model.paginators = __webpack_require__(120).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudTrail;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-11-01","endpointPrefix":"cloudtrail","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudTrail","serviceFullName":"AWS CloudTrail","serviceId":"CloudTrail","signatureVersion":"v4","targetPrefix":"com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101","uid":"cloudtrail-2013-11-01"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceId","TagsList"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CancelQuery":{"input":{"type":"structure","required":["EventDataStore","QueryId"],"members":{"EventDataStore":{},"QueryId":{}}},"output":{"type":"structure","required":["QueryId","QueryStatus"],"members":{"QueryId":{},"QueryStatus":{}}},"idempotent":true},"CreateEventDataStore":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"AdvancedEventSelectors":{"shape":"Sf"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"Sf"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"TagsList":{"shape":"S3"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"}}}},"CreateTrail":{"input":{"type":"structure","required":["Name","S3BucketName"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true},"DeleteEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{}}},"DeleteTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeQuery":{"input":{"type":"structure","required":["EventDataStore","QueryId"],"members":{"EventDataStore":{},"QueryId":{}}},"output":{"type":"structure","members":{"QueryId":{},"QueryString":{},"QueryStatus":{},"QueryStatistics":{"type":"structure","members":{"EventsMatched":{"type":"long"},"EventsScanned":{"type":"long"},"BytesScanned":{"type":"long"},"ExecutionTimeInMillis":{"type":"integer"},"CreationTime":{"type":"timestamp"}}},"ErrorMessage":{}}},"idempotent":true},"DescribeTrails":{"input":{"type":"structure","members":{"trailNameList":{"type":"list","member":{}},"includeShadowTrails":{"type":"boolean"}}},"output":{"type":"structure","members":{"trailList":{"type":"list","member":{"shape":"S1a"}}}},"idempotent":true},"GetEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"Sf"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"}}},"idempotent":true},"GetEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"S1f"},"AdvancedEventSelectors":{"shape":"Sf"}}},"idempotent":true},"GetInsightSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"InsightSelectors":{"shape":"S1o"}}},"idempotent":true},"GetQueryResults":{"input":{"type":"structure","required":["EventDataStore","QueryId"],"members":{"EventDataStore":{},"QueryId":{},"NextToken":{},"MaxQueryResults":{"type":"integer"}}},"output":{"type":"structure","members":{"QueryStatus":{},"QueryStatistics":{"type":"structure","members":{"ResultsCount":{"type":"integer"},"TotalResultsCount":{"type":"integer"},"BytesScanned":{"type":"long"}}},"QueryResultRows":{"type":"list","member":{"type":"list","member":{"type":"map","key":{},"value":{}}}},"NextToken":{},"ErrorMessage":{}}}},"GetTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Trail":{"shape":"S1a"}}},"idempotent":true},"GetTrailStatus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"IsLogging":{"type":"boolean"},"LatestDeliveryError":{},"LatestNotificationError":{},"LatestDeliveryTime":{"type":"timestamp"},"LatestNotificationTime":{"type":"timestamp"},"StartLoggingTime":{"type":"timestamp"},"StopLoggingTime":{"type":"timestamp"},"LatestCloudWatchLogsDeliveryError":{},"LatestCloudWatchLogsDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryError":{},"LatestDeliveryAttemptTime":{},"LatestNotificationAttemptTime":{},"LatestNotificationAttemptSucceeded":{},"LatestDeliveryAttemptSucceeded":{},"TimeLoggingStarted":{},"TimeLoggingStopped":{}}},"idempotent":true},"ListEventDataStores":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EventDataStores":{"type":"list","member":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"TerminationProtectionEnabled":{"deprecated":true,"deprecatedMessage":"TerminationProtectionEnabled is no longer returned by ListEventDataStores","type":"boolean"},"Status":{"deprecated":true,"deprecatedMessage":"Status is no longer returned by ListEventDataStores"},"AdvancedEventSelectors":{"shape":"Sf","deprecated":true,"deprecatedMessage":"AdvancedEventSelectors is no longer returned by ListEventDataStores"},"MultiRegionEnabled":{"deprecated":true,"deprecatedMessage":"MultiRegionEnabled is no longer returned by ListEventDataStores","type":"boolean"},"OrganizationEnabled":{"deprecated":true,"deprecatedMessage":"OrganizationEnabled is no longer returned by ListEventDataStores","type":"boolean"},"RetentionPeriod":{"deprecated":true,"deprecatedMessage":"RetentionPeriod is no longer returned by ListEventDataStores","type":"integer"},"CreatedTimestamp":{"deprecated":true,"deprecatedMessage":"CreatedTimestamp is no longer returned by ListEventDataStores","type":"timestamp"},"UpdatedTimestamp":{"deprecated":true,"deprecatedMessage":"UpdatedTimestamp is no longer returned by ListEventDataStores","type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPublicKeys":{"input":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"blob"},"ValidityStartTime":{"type":"timestamp"},"ValidityEndTime":{"type":"timestamp"},"Fingerprint":{}}}},"NextToken":{}}},"idempotent":true},"ListQueries":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{},"NextToken":{},"MaxResults":{"type":"integer"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"QueryStatus":{}}},"output":{"type":"structure","members":{"Queries":{"type":"list","member":{"type":"structure","members":{"QueryId":{},"QueryStatus":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"input":{"type":"structure","required":["ResourceIdList"],"members":{"ResourceIdList":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceTagList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"TagsList":{"shape":"S3"}}}},"NextToken":{}}},"idempotent":true},"ListTrails":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Trails":{"type":"list","member":{"type":"structure","members":{"TrailARN":{},"Name":{},"HomeRegion":{}}}},"NextToken":{}}},"idempotent":true},"LookupEvents":{"input":{"type":"structure","members":{"LookupAttributes":{"type":"list","member":{"type":"structure","required":["AttributeKey","AttributeValue"],"members":{"AttributeKey":{},"AttributeValue":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EventCategory":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventName":{},"ReadOnly":{},"AccessKeyId":{},"EventTime":{"type":"timestamp"},"EventSource":{},"Username":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceName":{}}}},"CloudTrailEvent":{}}}},"NextToken":{}}},"idempotent":true},"PutEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{},"EventSelectors":{"shape":"S1f"},"AdvancedEventSelectors":{"shape":"Sf"}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"S1f"},"AdvancedEventSelectors":{"shape":"Sf"}}},"idempotent":true},"PutInsightSelectors":{"input":{"type":"structure","required":["TrailName","InsightSelectors"],"members":{"TrailName":{},"InsightSelectors":{"shape":"S1o"}}},"output":{"type":"structure","members":{"TrailARN":{},"InsightSelectors":{"shape":"S1o"}}},"idempotent":true},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagsList"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"RestoreEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"Sf"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"}}}},"StartLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartQuery":{"input":{"type":"structure","required":["QueryStatement"],"members":{"QueryStatement":{}}},"output":{"type":"structure","members":{"QueryId":{}}},"idempotent":true},"StopLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{},"Name":{},"AdvancedEventSelectors":{"shape":"Sf"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"Sf"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"}}},"idempotent":true},"UpdateTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sf":{"type":"list","member":{"type":"structure","required":["FieldSelectors"],"members":{"Name":{},"FieldSelectors":{"type":"list","member":{"type":"structure","required":["Field"],"members":{"Field":{},"Equals":{"shape":"Sl"},"StartsWith":{"shape":"Sl"},"EndsWith":{"shape":"Sl"},"NotEquals":{"shape":"Sl"},"NotStartsWith":{"shape":"Sl"},"NotEndsWith":{"shape":"Sl"}}}}}}},"Sl":{"type":"list","member":{}},"S1a":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"HomeRegion":{},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"HasCustomEventSelectors":{"type":"boolean"},"HasInsightSelectors":{"type":"boolean"},"IsOrganizationTrail":{"type":"boolean"}}},"S1f":{"type":"list","member":{"type":"structure","members":{"ReadWriteType":{},"IncludeManagementEvents":{"type":"boolean"},"DataResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Values":{"type":"list","member":{}}}}},"ExcludeManagementEventSources":{"type":"list","member":{}}}}},"S1o":{"type":"list","member":{"type":"structure","members":{"InsightType":{}}}}}}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeTrails":{"result_key":"trailList"},"GetQueryResults":{"input_token":"NextToken","output_token":"NextToken"},"ListEventDataStores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPublicKeys":{"input_token":"NextToken","output_token":"NextToken","result_key":"PublicKeyList"},"ListQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","result_key":"ResourceTagList"},"ListTrails":{"input_token":"NextToken","output_token":"NextToken","result_key":"Trails"},"LookupEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"}}}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudwatch'] = {};
	AWS.CloudWatch = Service.defineService('cloudwatch', ['2010-08-01']);
	Object.defineProperty(apiLoader.services['cloudwatch'], '2010-08-01', {
	  get: function get() {
	    var model = __webpack_require__(122);
	    model.paginators = __webpack_require__(123).pagination;
	    model.waiters = __webpack_require__(124).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudWatch;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-08-01","endpointPrefix":"monitoring","protocol":"query","serviceAbbreviation":"CloudWatch","serviceFullName":"Amazon CloudWatch","serviceId":"CloudWatch","signatureVersion":"v4","uid":"monitoring-2010-08-01","xmlNamespace":"http://monitoring.amazonaws.com/doc/2010-08-01/"},"operations":{"DeleteAlarms":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DeleteAnomalyDetector":{"input":{"type":"structure","members":{"Namespace":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"MetricName":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Dimensions":{"shape":"S7","deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Stat":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"SingleMetricAnomalyDetector":{"shape":"Sc"},"MetricMathAnomalyDetector":{"shape":"Sd"}}},"output":{"resultWrapper":"DeleteAnomalyDetectorResult","type":"structure","members":{}}},"DeleteDashboards":{"input":{"type":"structure","required":["DashboardNames"],"members":{"DashboardNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DeleteDashboardsResult","type":"structure","members":{}}},"DeleteInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Sw"}}},"output":{"resultWrapper":"DeleteInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"DeleteMetricStream":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"resultWrapper":"DeleteMetricStreamResult","type":"structure","members":{}}},"DescribeAlarmHistory":{"input":{"type":"structure","members":{"AlarmName":{},"AlarmTypes":{"shape":"S19"},"HistoryItemType":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{},"ScanBy":{}}},"output":{"resultWrapper":"DescribeAlarmHistoryResult","type":"structure","members":{"AlarmHistoryItems":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmType":{},"Timestamp":{"type":"timestamp"},"HistoryItemType":{},"HistorySummary":{},"HistoryData":{}}}},"NextToken":{}}}},"DescribeAlarms":{"input":{"type":"structure","members":{"AlarmNames":{"shape":"S2"},"AlarmNamePrefix":{},"AlarmTypes":{"shape":"S19"},"ChildrenOfAlarmName":{},"ParentsOfAlarmName":{},"StateValue":{},"ActionPrefix":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmsResult","type":"structure","members":{"CompositeAlarms":{"type":"list","member":{"type":"structure","members":{"ActionsEnabled":{"type":"boolean"},"AlarmActions":{"shape":"S1t"},"AlarmArn":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"AlarmDescription":{},"AlarmName":{},"AlarmRule":{},"InsufficientDataActions":{"shape":"S1t"},"OKActions":{"shape":"S1t"},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"StateValue":{}},"xmlOrder":["ActionsEnabled","AlarmActions","AlarmArn","AlarmConfigurationUpdatedTimestamp","AlarmDescription","AlarmName","AlarmRule","InsufficientDataActions","OKActions","StateReason","StateReasonData","StateUpdatedTimestamp","StateValue"]}},"MetricAlarms":{"shape":"S20"},"NextToken":{}}}},"DescribeAlarmsForMetric":{"input":{"type":"structure","required":["MetricName","Namespace"],"members":{"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{}}},"output":{"resultWrapper":"DescribeAlarmsForMetricResult","type":"structure","members":{"MetricAlarms":{"shape":"S20"}}}},"DescribeAnomalyDetectors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"AnomalyDetectorTypes":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeAnomalyDetectorsResult","type":"structure","members":{"AnomalyDetectors":{"type":"list","member":{"type":"structure","members":{"Namespace":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.Namespace property."},"MetricName":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.MetricName property."},"Dimensions":{"shape":"S7","deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.Dimensions property."},"Stat":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.Stat property."},"Configuration":{"shape":"S2j"},"StateValue":{},"SingleMetricAnomalyDetector":{"shape":"Sc"},"MetricMathAnomalyDetector":{"shape":"Sd"}}}},"NextToken":{}}}},"DescribeInsightRules":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeInsightRulesResult","type":"structure","members":{"NextToken":{},"InsightRules":{"type":"list","member":{"type":"structure","required":["Name","State","Schema","Definition"],"members":{"Name":{},"State":{},"Schema":{},"Definition":{}}}}}}},"DisableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DisableInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Sw"}}},"output":{"resultWrapper":"DisableInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"EnableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"EnableInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Sw"}}},"output":{"resultWrapper":"EnableInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"GetDashboard":{"input":{"type":"structure","required":["DashboardName"],"members":{"DashboardName":{}}},"output":{"resultWrapper":"GetDashboardResult","type":"structure","members":{"DashboardArn":{},"DashboardBody":{},"DashboardName":{}}}},"GetInsightRuleReport":{"input":{"type":"structure","required":["RuleName","StartTime","EndTime","Period"],"members":{"RuleName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"MaxContributorCount":{"type":"integer"},"Metrics":{"type":"list","member":{}},"OrderBy":{}}},"output":{"resultWrapper":"GetInsightRuleReportResult","type":"structure","members":{"KeyLabels":{"type":"list","member":{}},"AggregationStatistic":{},"AggregateValue":{"type":"double"},"ApproximateUniqueCount":{"type":"long"},"Contributors":{"type":"list","member":{"type":"structure","required":["Keys","ApproximateAggregateValue","Datapoints"],"members":{"Keys":{"type":"list","member":{}},"ApproximateAggregateValue":{"type":"double"},"Datapoints":{"type":"list","member":{"type":"structure","required":["Timestamp","ApproximateValue"],"members":{"Timestamp":{"type":"timestamp"},"ApproximateValue":{"type":"double"}}}}}}},"MetricDatapoints":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"UniqueContributors":{"type":"double"},"MaxContributorValue":{"type":"double"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}}}}}},"GetMetricData":{"input":{"type":"structure","required":["MetricDataQueries","StartTime","EndTime"],"members":{"MetricDataQueries":{"shape":"Se"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"ScanBy":{},"MaxDatapoints":{"type":"integer"},"LabelOptions":{"type":"structure","members":{"Timezone":{}}}}},"output":{"resultWrapper":"GetMetricDataResult","type":"structure","members":{"MetricDataResults":{"type":"list","member":{"type":"structure","members":{"Id":{},"Label":{},"Timestamps":{"type":"list","member":{"type":"timestamp"}},"Values":{"type":"list","member":{"type":"double"}},"StatusCode":{},"Messages":{"shape":"S40"}}}},"NextToken":{},"Messages":{"shape":"S40"}}}},"GetMetricStatistics":{"input":{"type":"structure","required":["Namespace","MetricName","StartTime","EndTime","Period"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"Statistics":{"type":"list","member":{}},"ExtendedStatistics":{"type":"list","member":{}},"Unit":{}}},"output":{"resultWrapper":"GetMetricStatisticsResult","type":"structure","members":{"Label":{},"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"},"Unit":{},"ExtendedStatistics":{"type":"map","key":{},"value":{"type":"double"}}},"xmlOrder":["Timestamp","SampleCount","Average","Sum","Minimum","Maximum","Unit","ExtendedStatistics"]}}}}},"GetMetricStream":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"resultWrapper":"GetMetricStreamResult","type":"structure","members":{"Arn":{},"Name":{},"IncludeFilters":{"shape":"S4e"},"ExcludeFilters":{"shape":"S4e"},"FirehoseArn":{},"RoleArn":{},"State":{},"CreationDate":{"type":"timestamp"},"LastUpdateDate":{"type":"timestamp"},"OutputFormat":{},"StatisticsConfigurations":{"shape":"S4i"}}}},"GetMetricWidgetImage":{"input":{"type":"structure","required":["MetricWidget"],"members":{"MetricWidget":{},"OutputFormat":{}}},"output":{"resultWrapper":"GetMetricWidgetImageResult","type":"structure","members":{"MetricWidgetImage":{"type":"blob"}}}},"ListDashboards":{"input":{"type":"structure","members":{"DashboardNamePrefix":{},"NextToken":{}}},"output":{"resultWrapper":"ListDashboardsResult","type":"structure","members":{"DashboardEntries":{"type":"list","member":{"type":"structure","members":{"DashboardName":{},"DashboardArn":{},"LastModified":{"type":"timestamp"},"Size":{"type":"long"}}}},"NextToken":{}}}},"ListMetricStreams":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListMetricStreamsResult","type":"structure","members":{"NextToken":{},"Entries":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationDate":{"type":"timestamp"},"LastUpdateDate":{"type":"timestamp"},"Name":{},"FirehoseArn":{},"State":{},"OutputFormat":{}}}}}}},"ListMetrics":{"input":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}}},"NextToken":{},"RecentlyActive":{}}},"output":{"resultWrapper":"ListMetricsResult","type":"structure","members":{"Metrics":{"type":"list","member":{"shape":"Si"}},"NextToken":{}},"xmlOrder":["Metrics","NextToken"]}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"S5d"}}}},"PutAnomalyDetector":{"input":{"type":"structure","members":{"Namespace":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"MetricName":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Dimensions":{"shape":"S7","deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Stat":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Configuration":{"shape":"S2j"},"SingleMetricAnomalyDetector":{"shape":"Sc"},"MetricMathAnomalyDetector":{"shape":"Sd"}}},"output":{"resultWrapper":"PutAnomalyDetectorResult","type":"structure","members":{}}},"PutCompositeAlarm":{"input":{"type":"structure","required":["AlarmName","AlarmRule"],"members":{"ActionsEnabled":{"type":"boolean"},"AlarmActions":{"shape":"S1t"},"AlarmDescription":{},"AlarmName":{},"AlarmRule":{},"InsufficientDataActions":{"shape":"S1t"},"OKActions":{"shape":"S1t"},"Tags":{"shape":"S5d"}}}},"PutDashboard":{"input":{"type":"structure","required":["DashboardName","DashboardBody"],"members":{"DashboardName":{},"DashboardBody":{}}},"output":{"resultWrapper":"PutDashboardResult","type":"structure","members":{"DashboardValidationMessages":{"type":"list","member":{"type":"structure","members":{"DataPath":{},"Message":{}}}}}}},"PutInsightRule":{"input":{"type":"structure","required":["RuleName","RuleDefinition"],"members":{"RuleName":{},"RuleState":{},"RuleDefinition":{},"Tags":{"shape":"S5d"}}},"output":{"resultWrapper":"PutInsightRuleResult","type":"structure","members":{}}},"PutMetricAlarm":{"input":{"type":"structure","required":["AlarmName","EvaluationPeriods","ComparisonOperator"],"members":{"AlarmName":{},"AlarmDescription":{},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S1t"},"AlarmActions":{"shape":"S1t"},"InsufficientDataActions":{"shape":"S1t"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"Se"},"Tags":{"shape":"S5d"},"ThresholdMetricId":{}}}},"PutMetricData":{"input":{"type":"structure","required":["Namespace","MetricData"],"members":{"Namespace":{},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName"],"members":{"MetricName":{},"Dimensions":{"shape":"S7"},"Timestamp":{"type":"timestamp"},"Value":{"type":"double"},"StatisticValues":{"type":"structure","required":["SampleCount","Sum","Minimum","Maximum"],"members":{"SampleCount":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}},"Values":{"type":"list","member":{"type":"double"}},"Counts":{"type":"list","member":{"type":"double"}},"Unit":{},"StorageResolution":{"type":"integer"}}}}}}},"PutMetricStream":{"input":{"type":"structure","required":["Name","FirehoseArn","RoleArn","OutputFormat"],"members":{"Name":{},"IncludeFilters":{"shape":"S4e"},"ExcludeFilters":{"shape":"S4e"},"FirehoseArn":{},"RoleArn":{},"OutputFormat":{},"Tags":{"shape":"S5d"},"StatisticsConfigurations":{"shape":"S4i"}}},"output":{"resultWrapper":"PutMetricStreamResult","type":"structure","members":{"Arn":{}}}},"SetAlarmState":{"input":{"type":"structure","required":["AlarmName","StateValue","StateReason"],"members":{"AlarmName":{},"StateValue":{},"StateReason":{},"StateReasonData":{}}}},"StartMetricStreams":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S64"}}},"output":{"resultWrapper":"StartMetricStreamsResult","type":"structure","members":{}}},"StopMetricStreams":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S64"}}},"output":{"resultWrapper":"StopMetricStreamsResult","type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5d"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}},"xmlOrder":["Name","Value"]}},"Sc":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{}}},"Sd":{"type":"structure","members":{"MetricDataQueries":{"shape":"Se"}}},"Se":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"MetricStat":{"type":"structure","required":["Metric","Period","Stat"],"members":{"Metric":{"shape":"Si"},"Period":{"type":"integer"},"Stat":{},"Unit":{}}},"Expression":{},"Label":{},"ReturnData":{"type":"boolean"},"Period":{"type":"integer"},"AccountId":{}}}},"Si":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"}},"xmlOrder":["Namespace","MetricName","Dimensions"]},"Sw":{"type":"list","member":{}},"Sz":{"type":"list","member":{"type":"structure","members":{"FailureResource":{},"ExceptionType":{},"FailureCode":{},"FailureDescription":{}}}},"S19":{"type":"list","member":{}},"S1t":{"type":"list","member":{}},"S20":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmArn":{},"AlarmDescription":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S1t"},"AlarmActions":{"shape":"S1t"},"InsufficientDataActions":{"shape":"S1t"},"StateValue":{},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"Se"},"ThresholdMetricId":{}},"xmlOrder":["AlarmName","AlarmArn","AlarmDescription","AlarmConfigurationUpdatedTimestamp","ActionsEnabled","OKActions","AlarmActions","InsufficientDataActions","StateValue","StateReason","StateReasonData","StateUpdatedTimestamp","MetricName","Namespace","Statistic","Dimensions","Period","Unit","EvaluationPeriods","Threshold","ComparisonOperator","ExtendedStatistic","TreatMissingData","EvaluateLowSampleCountPercentile","DatapointsToAlarm","Metrics","ThresholdMetricId"]}},"S2j":{"type":"structure","members":{"ExcludedTimeRanges":{"type":"list","member":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}},"xmlOrder":["StartTime","EndTime"]}},"MetricTimezone":{}}},"S40":{"type":"list","member":{"type":"structure","members":{"Code":{},"Value":{}}}},"S4e":{"type":"list","member":{"type":"structure","members":{"Namespace":{}}}},"S4i":{"type":"list","member":{"type":"structure","required":["IncludeMetrics","AdditionalStatistics"],"members":{"IncludeMetrics":{"type":"list","member":{"type":"structure","required":["Namespace","MetricName"],"members":{"Namespace":{},"MetricName":{}}}},"AdditionalStatistics":{"type":"list","member":{}}}}},"S5d":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S64":{"type":"list","member":{}}}}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAlarmHistory":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AlarmHistoryItems"},"DescribeAlarms":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":["MetricAlarms","CompositeAlarms"]},"DescribeAlarmsForMetric":{"result_key":"MetricAlarms"},"DescribeInsightRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxDatapoints","output_token":"NextToken","result_key":["MetricDataResults","Messages"]},"ListDashboards":{"input_token":"NextToken","output_token":"NextToken","result_key":"DashboardEntries"},"ListMetricStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListMetrics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Metrics"}}}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"AlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(MetricAlarms[]) > `0`","state":"success"}]},"CompositeAlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(CompositeAlarms[]) > `0`","state":"success"}]}}}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudwatchevents'] = {};
	AWS.CloudWatchEvents = Service.defineService('cloudwatchevents', ['2014-02-03*', '2015-10-07']);
	Object.defineProperty(apiLoader.services['cloudwatchevents'], '2015-10-07', {
	  get: function get() {
	    var model = __webpack_require__(126);
	    model.paginators = __webpack_require__(127).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudWatchEvents;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","serviceId":"CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CancelReplay":{"input":{"type":"structure","required":["ReplayName"],"members":{"ReplayName":{}}},"output":{"type":"structure","members":{"ReplayArn":{},"State":{},"StateReason":{}}}},"CreateApiDestination":{"input":{"type":"structure","required":["Name","ConnectionArn","InvocationEndpoint","HttpMethod"],"members":{"Name":{},"Description":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"ApiDestinationState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"CreateArchive":{"input":{"type":"structure","required":["ArchiveName","EventSourceArn"],"members":{"ArchiveName":{},"EventSourceArn":{},"Description":{},"EventPattern":{},"RetentionDays":{"type":"integer"}}},"output":{"type":"structure","members":{"ArchiveArn":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"}}}},"CreateConnection":{"input":{"type":"structure","required":["Name","AuthorizationType","AuthParameters"],"members":{"Name":{},"Description":{},"AuthorizationType":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"OAuthParameters":{"type":"structure","required":["ClientParameters","AuthorizationEndpoint","HttpMethod"],"members":{"ClientParameters":{"type":"structure","required":["ClientID","ClientSecret"],"members":{"ClientID":{},"ClientSecret":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S14"}}},"ApiKeyAuthParameters":{"type":"structure","required":["ApiKeyName","ApiKeyValue"],"members":{"ApiKeyName":{},"ApiKeyValue":{}}},"InvocationHttpParameters":{"shape":"S14"}}}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeauthorizeConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DeleteApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{}}},"output":{"type":"structure","members":{}}},"DeleteConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"Name":{},"Description":{},"ApiDestinationState":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"DescribeArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{}}},"output":{"type":"structure","members":{"ArchiveArn":{},"ArchiveName":{},"EventSourceArn":{},"Description":{},"EventPattern":{},"State":{},"StateReason":{},"RetentionDays":{"type":"integer"},"SizeBytes":{"type":"long"},"EventCount":{"type":"long"},"CreationTime":{"type":"timestamp"}}}},"DescribeConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"Name":{},"Description":{},"ConnectionState":{},"StateReason":{},"AuthorizationType":{},"SecretArn":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","members":{"Username":{}}},"OAuthParameters":{"type":"structure","members":{"ClientParameters":{"type":"structure","members":{"ClientID":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S14"}}},"ApiKeyAuthParameters":{"type":"structure","members":{"ApiKeyName":{}}},"InvocationHttpParameters":{"shape":"S14"}}},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeReplay":{"input":{"type":"structure","required":["ReplayName"],"members":{"ReplayName":{}}},"output":{"type":"structure","members":{"ReplayName":{},"ReplayArn":{},"Description":{},"State":{},"StateReason":{},"EventSourceArn":{},"Destination":{"shape":"S2w"},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"EventLastReplayedTime":{"type":"timestamp"},"ReplayStartTime":{"type":"timestamp"},"ReplayEndTime":{"type":"timestamp"}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{},"CreatedBy":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListApiDestinations":{"input":{"type":"structure","members":{"NamePrefix":{},"ConnectionArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinations":{"type":"list","member":{"type":"structure","members":{"ApiDestinationArn":{},"Name":{},"ApiDestinationState":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListArchives":{"input":{"type":"structure","members":{"NamePrefix":{},"EventSourceArn":{},"State":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Archives":{"type":"list","member":{"type":"structure","members":{"ArchiveName":{},"EventSourceArn":{},"State":{},"StateReason":{},"RetentionDays":{"type":"integer"},"SizeBytes":{"type":"long"},"EventCount":{"type":"long"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListConnections":{"input":{"type":"structure","members":{"NamePrefix":{},"ConnectionState":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"type":"structure","members":{"ConnectionArn":{},"Name":{},"ConnectionState":{},"StateReason":{},"AuthorizationType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListReplays":{"input":{"type":"structure","members":{"NamePrefix":{},"State":{},"EventSourceArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Replays":{"type":"list","member":{"type":"structure","members":{"ReplayName":{},"EventSourceArn":{},"State":{},"StateReason":{},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"EventLastReplayedTime":{"type":"timestamp"},"ReplayStartTime":{"type":"timestamp"},"ReplayEndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1m"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S4l"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S6j"},"DetailType":{},"Detail":{},"EventBusName":{},"TraceHeader":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S6j"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}},"Policy":{}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S1m"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S4l"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","members":{"StatementId":{},"RemoveAllPermissions":{"type":"boolean"},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartReplay":{"input":{"type":"structure","required":["ReplayName","EventSourceArn","EventStartTime","EventEndTime","Destination"],"members":{"ReplayName":{},"Description":{},"EventSourceArn":{},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"Destination":{"shape":"S2w"}}},"output":{"type":"structure","members":{"ReplayArn":{},"State":{},"StateReason":{},"ReplayStartTime":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"ApiDestinationState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"UpdateArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{},"Description":{},"EventPattern":{},"RetentionDays":{"type":"integer"}}},"output":{"type":"structure","members":{"ArchiveArn":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"}}}},"UpdateConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"AuthorizationType":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","members":{"Username":{},"Password":{}}},"OAuthParameters":{"type":"structure","members":{"ClientParameters":{"type":"structure","members":{"ClientID":{},"ClientSecret":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S14"}}},"ApiKeyAuthParameters":{"type":"structure","members":{"ApiKeyName":{},"ApiKeyValue":{}}},"InvocationHttpParameters":{"shape":"S14"}}}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}}},"shapes":{"S14":{"type":"structure","members":{"HeaderParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"IsValueSecret":{"type":"boolean"}}}},"QueryStringParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"IsValueSecret":{"type":"boolean"}}}},"BodyParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"IsValueSecret":{"type":"boolean"}}}}}},"S1m":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S2w":{"type":"structure","required":["Arn"],"members":{"Arn":{},"FilterArns":{"type":"list","member":{}}}},"S4l":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S57"},"SecurityGroups":{"shape":"S57"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{},"CapacityProviderStrategy":{"type":"list","member":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{},"weight":{"type":"integer"},"base":{"type":"integer"}}}},"EnableECSManagedTags":{"type":"boolean"},"EnableExecuteCommand":{"type":"boolean"},"PlacementConstraints":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"PlacementStrategy":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"PropagateTags":{},"ReferenceId":{},"Tags":{"shape":"S1m"}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}},"HttpParameters":{"type":"structure","members":{"PathParameterValues":{"type":"list","member":{}},"HeaderParameters":{"type":"map","key":{},"value":{}},"QueryStringParameters":{"type":"map","key":{},"value":{}}}},"RedshiftDataParameters":{"type":"structure","required":["Database","Sql"],"members":{"SecretManagerArn":{},"Database":{},"DbUser":{},"Sql":{},"StatementName":{},"WithEvent":{"type":"boolean"}}},"SageMakerPipelineParameters":{"type":"structure","members":{"PipelineParameterList":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"DeadLetterConfig":{"type":"structure","members":{"Arn":{}}},"RetryPolicy":{"type":"structure","members":{"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"}}}}}},"S57":{"type":"list","member":{}},"S6j":{"type":"list","member":{}}}}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudwatchlogs'] = {};
	AWS.CloudWatchLogs = Service.defineService('cloudwatchlogs', ['2014-03-28']);
	Object.defineProperty(apiLoader.services['cloudwatchlogs'], '2014-03-28', {
	  get: function get() {
	    var model = __webpack_require__(129);
	    model.paginators = __webpack_require__(130).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudWatchLogs;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","serviceId":"CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["logGroupName","kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Se"}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteQueryDefinition":{"input":{"type":"structure","required":["queryDefinitionId"],"members":{"queryDefinitionId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"S11"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"logGroupNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.","type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1z"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueries":{"input":{"type":"structure","members":{"logGroupName":{},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queries":{"type":"list","member":{"type":"structure","members":{"queryId":{},"queryString":{},"status":{},"createTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueryDefinitions":{"input":{"type":"structure","members":{"queryDefinitionNamePrefix":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queryDefinitions":{"type":"list","member":{"type":"structure","members":{"queryDefinitionId":{},"name":{},"queryString":{},"lastModified":{"type":"long"},"logGroupNames":{"shape":"S2l"}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S2p"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"FilterLogEvents":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNames":{"type":"list","member":{}},"logStreamNamePrefix":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.","type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"GetLogGroupFields":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"time":{"type":"long"}}},"output":{"type":"structure","members":{"logGroupFields":{"type":"list","member":{"type":"structure","members":{"name":{},"percent":{"type":"integer"}}}}}}},"GetLogRecord":{"input":{"type":"structure","required":["logRecordPointer"],"members":{"logRecordPointer":{}}},"output":{"type":"structure","members":{"logRecord":{"type":"map","key":{},"value":{}}}}},"GetQueryResults":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"field":{},"value":{}}}}},"statistics":{"type":"structure","members":{"recordsMatched":{"type":"double"},"recordsScanned":{"type":"double"},"bytesScanned":{"type":"double"}}},"status":{}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{}}},"output":{"type":"structure","members":{"destination":{"shape":"S11"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{},"forceUpdate":{"type":"boolean"}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1z"}}}},"PutQueryDefinition":{"input":{"type":"structure","required":["name","queryString"],"members":{"name":{},"queryDefinitionId":{},"logGroupNames":{"shape":"S2l"},"queryString":{}}},"output":{"type":"structure","members":{"queryDefinitionId":{}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S2p"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"StartQuery":{"input":{"type":"structure","required":["startTime","endTime","queryString"],"members":{"logGroupName":{},"logGroupNames":{"shape":"S2l"},"startTime":{"type":"long"},"endTime":{"type":"long"},"queryString":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"queryId":{}}}},"StopQuery":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Se"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}}}}},"shapes":{"Se":{"type":"map","key":{},"value":{}},"S11":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S1z":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"},"dimensions":{"type":"map","key":{},"value":{}},"unit":{}}}},"S2l":{"type":"list","member":{}},"S2p":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}}}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"}}}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codebuild'] = {};
	AWS.CodeBuild = Service.defineService('codebuild', ['2016-10-06']);
	Object.defineProperty(apiLoader.services['codebuild'], '2016-10-06', {
	  get: function get() {
	    var model = __webpack_require__(132);
	    model.paginators = __webpack_require__(133).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeBuild;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-10-06","endpointPrefix":"codebuild","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS CodeBuild","serviceId":"CodeBuild","signatureVersion":"v4","targetPrefix":"CodeBuild_20161006","uid":"codebuild-2016-10-06"},"operations":{"BatchDeleteBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"buildsDeleted":{"shape":"S2"},"buildsNotDeleted":{"shape":"S5"}}}},"BatchGetBuildBatches":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S9"}}},"output":{"type":"structure","members":{"buildBatches":{"type":"list","member":{"shape":"Sc"}},"buildBatchesNotFound":{"shape":"S9"}}}},"BatchGetBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"builds":{"type":"list","member":{"shape":"S23"}},"buildsNotFound":{"shape":"S2"}}}},"BatchGetProjects":{"input":{"type":"structure","required":["names"],"members":{"names":{"shape":"S2e"}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"S2h"}},"projectsNotFound":{"shape":"S2e"}}}},"BatchGetReportGroups":{"input":{"type":"structure","required":["reportGroupArns"],"members":{"reportGroupArns":{"shape":"S32"}}},"output":{"type":"structure","members":{"reportGroups":{"type":"list","member":{"shape":"S35"}},"reportGroupsNotFound":{"shape":"S32"}}}},"BatchGetReports":{"input":{"type":"structure","required":["reportArns"],"members":{"reportArns":{"shape":"S3e"}}},"output":{"type":"structure","members":{"reports":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"name":{},"reportGroupArn":{},"executionId":{},"status":{},"created":{"type":"timestamp"},"expired":{"type":"timestamp"},"exportConfig":{"shape":"S38"},"truncated":{"type":"boolean"},"testSummary":{"type":"structure","required":["total","statusCounts","durationInNanoSeconds"],"members":{"total":{"type":"integer"},"statusCounts":{"type":"map","key":{},"value":{"type":"integer"}},"durationInNanoSeconds":{"type":"long"}}},"codeCoverageSummary":{"type":"structure","members":{"lineCoveragePercentage":{"type":"double"},"linesCovered":{"type":"integer"},"linesMissed":{"type":"integer"},"branchCoveragePercentage":{"type":"double"},"branchesCovered":{"type":"integer"},"branchesMissed":{"type":"integer"}}}}}},"reportsNotFound":{"shape":"S3e"}}}},"CreateProject":{"input":{"type":"structure","required":["name","source","artifacts","environment","serviceRole"],"members":{"name":{},"description":{},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"S2k"},"secondaryArtifacts":{"shape":"S2n"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S2p"},"vpcConfig":{"shape":"S1i"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S1c"},"fileSystemLocations":{"shape":"S1l"},"buildBatchConfig":{"shape":"S1o"},"concurrentBuildLimit":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"S2h"}}}},"CreateReportGroup":{"input":{"type":"structure","required":["name","type","exportConfig"],"members":{"name":{},"type":{},"exportConfig":{"shape":"S38"},"tags":{"shape":"S2p"}}},"output":{"type":"structure","members":{"reportGroup":{"shape":"S35"}}}},"CreateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"filterGroups":{"shape":"S2u"},"buildType":{}}},"output":{"type":"structure","members":{"webhook":{"shape":"S2t"}}}},"DeleteBuildBatch":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"statusCode":{},"buildsDeleted":{"shape":"S2"},"buildsNotDeleted":{"shape":"S5"}}}},"DeleteProject":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteReport":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteReportGroup":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"deleteReports":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteSourceCredentials":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"arn":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"DescribeCodeCoverages":{"input":{"type":"structure","required":["reportArn"],"members":{"reportArn":{},"nextToken":{},"maxResults":{"type":"integer"},"sortOrder":{},"sortBy":{},"minLineCoveragePercentage":{"type":"double"},"maxLineCoveragePercentage":{"type":"double"}}},"output":{"type":"structure","members":{"nextToken":{},"codeCoverages":{"type":"list","member":{"type":"structure","members":{"id":{},"reportARN":{},"filePath":{},"lineCoveragePercentage":{"type":"double"},"linesCovered":{"type":"integer"},"linesMissed":{"type":"integer"},"branchCoveragePercentage":{"type":"double"},"branchesCovered":{"type":"integer"},"branchesMissed":{"type":"integer"},"expired":{"type":"timestamp"}}}}}}},"DescribeTestCases":{"input":{"type":"structure","required":["reportArn"],"members":{"reportArn":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"status":{},"keyword":{}}}}},"output":{"type":"structure","members":{"nextToken":{},"testCases":{"type":"list","member":{"type":"structure","members":{"reportArn":{},"testRawDataPath":{},"prefix":{},"name":{},"status":{},"durationInNanoSeconds":{"type":"long"},"message":{},"expired":{"type":"timestamp"}}}}}}},"GetReportGroupTrend":{"input":{"type":"structure","required":["reportGroupArn","trendField"],"members":{"reportGroupArn":{},"numOfReports":{"type":"integer"},"trendField":{}}},"output":{"type":"structure","members":{"stats":{"type":"structure","members":{"average":{},"max":{},"min":{}}},"rawData":{"type":"list","member":{"type":"structure","members":{"reportArn":{},"data":{}}}}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"policy":{}}}},"ImportSourceCredentials":{"input":{"type":"structure","required":["token","serverType","authType"],"members":{"username":{},"token":{"type":"string","sensitive":true},"serverType":{},"authType":{},"shouldOverwrite":{"type":"boolean"}}},"output":{"type":"structure","members":{"arn":{}}}},"InvalidateProjectCache":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"ListBuildBatches":{"input":{"type":"structure","members":{"filter":{"shape":"S50"},"maxResults":{"type":"integer"},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"nextToken":{}}}},"ListBuildBatchesForProject":{"input":{"type":"structure","members":{"projectName":{},"filter":{"shape":"S50"},"maxResults":{"type":"integer"},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"nextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListBuildsForProject":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListCuratedEnvironmentImages":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"platforms":{"type":"list","member":{"type":"structure","members":{"platform":{},"languages":{"type":"list","member":{"type":"structure","members":{"language":{},"images":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"versions":{"type":"list","member":{}}}}}}}}}}}}}},"ListProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"shape":"S2e"}}}},"ListReportGroups":{"input":{"type":"structure","members":{"sortOrder":{},"sortBy":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"reportGroups":{"shape":"S32"}}}},"ListReports":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"shape":"S5q"}}},"output":{"type":"structure","members":{"nextToken":{},"reports":{"shape":"S3e"}}}},"ListReportsForReportGroup":{"input":{"type":"structure","required":["reportGroupArn"],"members":{"reportGroupArn":{},"nextToken":{},"sortOrder":{},"maxResults":{"type":"integer"},"filter":{"shape":"S5q"}}},"output":{"type":"structure","members":{"nextToken":{},"reports":{"shape":"S3e"}}}},"ListSharedProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"type":"list","member":{}}}}},"ListSharedReportGroups":{"input":{"type":"structure","members":{"sortOrder":{},"sortBy":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"reportGroups":{"shape":"S32"}}}},"ListSourceCredentials":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"sourceCredentialsInfos":{"type":"list","member":{"type":"structure","members":{"arn":{},"serverType":{},"authType":{}}}}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["policy","resourceArn"],"members":{"policy":{},"resourceArn":{}}},"output":{"type":"structure","members":{"resourceArn":{}}}},"RetryBuild":{"input":{"type":"structure","members":{"id":{},"idempotencyToken":{}}},"output":{"type":"structure","members":{"build":{"shape":"S23"}}}},"RetryBuildBatch":{"input":{"type":"structure","members":{"id":{},"idempotencyToken":{},"retryType":{}}},"output":{"type":"structure","members":{"buildBatch":{"shape":"Sc"}}}},"StartBuild":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"secondarySourcesOverride":{"shape":"St"},"secondarySourcesVersionOverride":{"shape":"Su"},"sourceVersion":{},"artifactsOverride":{"shape":"S2k"},"secondaryArtifactsOverride":{"shape":"S2n"},"environmentVariablesOverride":{"shape":"S16"},"sourceTypeOverride":{},"sourceLocationOverride":{},"sourceAuthOverride":{"shape":"Sq"},"gitCloneDepthOverride":{"type":"integer"},"gitSubmodulesConfigOverride":{"shape":"So"},"buildspecOverride":{},"insecureSslOverride":{"type":"boolean"},"reportBuildStatusOverride":{"type":"boolean"},"buildStatusConfigOverride":{"shape":"Ss"},"environmentTypeOverride":{},"imageOverride":{},"computeTypeOverride":{},"certificateOverride":{},"cacheOverride":{"shape":"Sz"},"serviceRoleOverride":{},"privilegedModeOverride":{"type":"boolean"},"timeoutInMinutesOverride":{"type":"integer"},"queuedTimeoutInMinutesOverride":{"type":"integer"},"encryptionKeyOverride":{},"idempotencyToken":{},"logsConfigOverride":{"shape":"S1c"},"registryCredentialOverride":{"shape":"S19"},"imagePullCredentialsTypeOverride":{},"debugSessionEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"build":{"shape":"S23"}}}},"StartBuildBatch":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"secondarySourcesOverride":{"shape":"St"},"secondarySourcesVersionOverride":{"shape":"Su"},"sourceVersion":{},"artifactsOverride":{"shape":"S2k"},"secondaryArtifactsOverride":{"shape":"S2n"},"environmentVariablesOverride":{"shape":"S16"},"sourceTypeOverride":{},"sourceLocationOverride":{},"sourceAuthOverride":{"shape":"Sq"},"gitCloneDepthOverride":{"type":"integer"},"gitSubmodulesConfigOverride":{"shape":"So"},"buildspecOverride":{},"insecureSslOverride":{"type":"boolean"},"reportBuildBatchStatusOverride":{"type":"boolean"},"environmentTypeOverride":{},"imageOverride":{},"computeTypeOverride":{},"certificateOverride":{},"cacheOverride":{"shape":"Sz"},"serviceRoleOverride":{},"privilegedModeOverride":{"type":"boolean"},"buildTimeoutInMinutesOverride":{"type":"integer"},"queuedTimeoutInMinutesOverride":{"type":"integer"},"encryptionKeyOverride":{},"idempotencyToken":{},"logsConfigOverride":{"shape":"S1c"},"registryCredentialOverride":{"shape":"S19"},"imagePullCredentialsTypeOverride":{},"buildBatchConfigOverride":{"shape":"S1o"},"debugSessionEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"buildBatch":{"shape":"Sc"}}}},"StopBuild":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"build":{"shape":"S23"}}}},"StopBuildBatch":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"buildBatch":{"shape":"Sc"}}}},"UpdateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"S2k"},"secondaryArtifacts":{"shape":"S2n"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S2p"},"vpcConfig":{"shape":"S1i"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S1c"},"fileSystemLocations":{"shape":"S1l"},"buildBatchConfig":{"shape":"S1o"},"concurrentBuildLimit":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"S2h"}}}},"UpdateProjectVisibility":{"input":{"type":"structure","required":["projectArn","projectVisibility"],"members":{"projectArn":{},"projectVisibility":{},"resourceAccessRole":{}}},"output":{"type":"structure","members":{"projectArn":{},"publicProjectAlias":{},"projectVisibility":{}}}},"UpdateReportGroup":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"exportConfig":{"shape":"S38"},"tags":{"shape":"S2p"}}},"output":{"type":"structure","members":{"reportGroup":{"shape":"S35"}}}},"UpdateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"rotateSecret":{"type":"boolean"},"filterGroups":{"shape":"S2u"},"buildType":{}}},"output":{"type":"structure","members":{"webhook":{"shape":"S2t"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S5":{"type":"list","member":{"type":"structure","members":{"id":{},"statusCode":{}}}},"S9":{"type":"list","member":{}},"Sc":{"type":"structure","members":{"id":{},"arn":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"currentPhase":{},"buildBatchStatus":{},"sourceVersion":{},"resolvedSourceVersion":{},"projectName":{},"phases":{"type":"list","member":{"type":"structure","members":{"phaseType":{},"phaseStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"durationInSeconds":{"type":"long"},"contexts":{"shape":"Sj"}}}},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"Sw"},"secondaryArtifacts":{"shape":"Sy"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"logConfig":{"shape":"S1c"},"buildTimeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"complete":{"type":"boolean"},"initiator":{},"vpcConfig":{"shape":"S1i"},"encryptionKey":{},"buildBatchNumber":{"type":"long"},"fileSystemLocations":{"shape":"S1l"},"buildBatchConfig":{"shape":"S1o"},"buildGroups":{"type":"list","member":{"type":"structure","members":{"identifier":{},"dependsOn":{"type":"list","member":{}},"ignoreFailure":{"type":"boolean"},"currentBuildSummary":{"shape":"S1v"},"priorBuildSummaryList":{"type":"list","member":{"shape":"S1v"}}}}},"debugSessionEnabled":{"type":"boolean"}}},"Sj":{"type":"list","member":{"type":"structure","members":{"statusCode":{},"message":{}}}},"Sl":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"gitCloneDepth":{"type":"integer"},"gitSubmodulesConfig":{"shape":"So"},"buildspec":{},"auth":{"shape":"Sq"},"reportBuildStatus":{"type":"boolean"},"buildStatusConfig":{"shape":"Ss"},"insecureSsl":{"type":"boolean"},"sourceIdentifier":{}}},"So":{"type":"structure","required":["fetchSubmodules"],"members":{"fetchSubmodules":{"type":"boolean"}}},"Sq":{"type":"structure","required":["type"],"members":{"type":{},"resource":{}}},"Ss":{"type":"structure","members":{"context":{},"targetUrl":{}}},"St":{"type":"list","member":{"shape":"Sl"}},"Su":{"type":"list","member":{"type":"structure","required":["sourceIdentifier","sourceVersion"],"members":{"sourceIdentifier":{},"sourceVersion":{}}}},"Sw":{"type":"structure","members":{"location":{},"sha256sum":{},"md5sum":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{},"bucketOwnerAccess":{}}},"Sy":{"type":"list","member":{"shape":"Sw"}},"Sz":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"modes":{"type":"list","member":{}}}},"S13":{"type":"structure","required":["type","image","computeType"],"members":{"type":{},"image":{},"computeType":{},"environmentVariables":{"shape":"S16"},"privilegedMode":{"type":"boolean"},"certificate":{},"registryCredential":{"shape":"S19"},"imagePullCredentialsType":{}}},"S16":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"type":{}}}},"S19":{"type":"structure","required":["credential","credentialProvider"],"members":{"credential":{},"credentialProvider":{}}},"S1c":{"type":"structure","members":{"cloudWatchLogs":{"shape":"S1d"},"s3Logs":{"shape":"S1f"}}},"S1d":{"type":"structure","required":["status"],"members":{"status":{},"groupName":{},"streamName":{}}},"S1f":{"type":"structure","required":["status"],"members":{"status":{},"location":{},"encryptionDisabled":{"type":"boolean"},"bucketOwnerAccess":{}}},"S1i":{"type":"structure","members":{"vpcId":{},"subnets":{"type":"list","member":{}},"securityGroupIds":{"type":"list","member":{}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"type":{},"location":{},"mountPoint":{},"identifier":{},"mountOptions":{}}}},"S1o":{"type":"structure","members":{"serviceRole":{},"combineArtifacts":{"type":"boolean"},"restrictions":{"type":"structure","members":{"maximumBuildsAllowed":{"type":"integer"},"computeTypesAllowed":{"type":"list","member":{}}}},"timeoutInMins":{"type":"integer"},"batchReportMode":{}}},"S1v":{"type":"structure","members":{"arn":{},"requestedOn":{"type":"timestamp"},"buildStatus":{},"primaryArtifact":{"shape":"S1w"},"secondaryArtifacts":{"type":"list","member":{"shape":"S1w"}}}},"S1w":{"type":"structure","members":{"type":{},"location":{},"identifier":{}}},"S23":{"type":"structure","members":{"id":{},"arn":{},"buildNumber":{"type":"long"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"currentPhase":{},"buildStatus":{},"sourceVersion":{},"resolvedSourceVersion":{},"projectName":{},"phases":{"type":"list","member":{"type":"structure","members":{"phaseType":{},"phaseStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"durationInSeconds":{"type":"long"},"contexts":{"shape":"Sj"}}}},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"Sw"},"secondaryArtifacts":{"shape":"Sy"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"logs":{"type":"structure","members":{"groupName":{},"streamName":{},"deepLink":{},"s3DeepLink":{},"cloudWatchLogsArn":{},"s3LogsArn":{},"cloudWatchLogs":{"shape":"S1d"},"s3Logs":{"shape":"S1f"}}},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"buildComplete":{"type":"boolean"},"initiator":{},"vpcConfig":{"shape":"S1i"},"networkInterface":{"type":"structure","members":{"subnetId":{},"networkInterfaceId":{}}},"encryptionKey":{},"exportedEnvironmentVariables":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"reportArns":{"type":"list","member":{}},"fileSystemLocations":{"shape":"S1l"},"debugSession":{"type":"structure","members":{"sessionEnabled":{"type":"boolean"},"sessionTarget":{}}},"buildBatchArn":{}}},"S2e":{"type":"list","member":{}},"S2h":{"type":"structure","members":{"name":{},"arn":{},"description":{},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"S2k"},"secondaryArtifacts":{"shape":"S2n"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S2p"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"webhook":{"shape":"S2t"},"vpcConfig":{"shape":"S1i"},"badge":{"type":"structure","members":{"badgeEnabled":{"type":"boolean"},"badgeRequestUrl":{}}},"logsConfig":{"shape":"S1c"},"fileSystemLocations":{"shape":"S1l"},"buildBatchConfig":{"shape":"S1o"},"concurrentBuildLimit":{"type":"integer"},"projectVisibility":{},"publicProjectAlias":{},"resourceAccessRole":{}}},"S2k":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"path":{},"namespaceType":{},"name":{},"packaging":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{},"bucketOwnerAccess":{}}},"S2n":{"type":"list","member":{"shape":"S2k"}},"S2p":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S2t":{"type":"structure","members":{"url":{},"payloadUrl":{},"secret":{},"branchFilter":{},"filterGroups":{"shape":"S2u"},"buildType":{},"lastModifiedSecret":{"type":"timestamp"}}},"S2u":{"type":"list","member":{"type":"list","member":{"type":"structure","required":["type","pattern"],"members":{"type":{},"pattern":{},"excludeMatchedPattern":{"type":"boolean"}}}}},"S32":{"type":"list","member":{}},"S35":{"type":"structure","members":{"arn":{},"name":{},"type":{},"exportConfig":{"shape":"S38"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"tags":{"shape":"S2p"},"status":{}}},"S38":{"type":"structure","members":{"exportConfigType":{},"s3Destination":{"type":"structure","members":{"bucket":{},"bucketOwner":{},"path":{},"packaging":{},"encryptionKey":{},"encryptionDisabled":{"type":"boolean"}}}}},"S3e":{"type":"list","member":{}},"S50":{"type":"structure","members":{"status":{}}},"S5q":{"type":"structure","members":{"status":{}}}}}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCodeCoverages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"codeCoverages"},"DescribeTestCases":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"testCases"},"ListBuildBatches":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"ids"},"ListBuildBatchesForProject":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"ids"},"ListBuilds":{"input_token":"nextToken","output_token":"nextToken","result_key":"ids"},"ListBuildsForProject":{"input_token":"nextToken","output_token":"nextToken","result_key":"ids"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListReportGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reportGroups"},"ListReports":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reports"},"ListReportsForReportGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reports"},"ListSharedProjects":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"projects"},"ListSharedReportGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reportGroups"}}}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codecommit'] = {};
	AWS.CodeCommit = Service.defineService('codecommit', ['2015-04-13']);
	Object.defineProperty(apiLoader.services['codecommit'], '2015-04-13', {
	  get: function get() {
	    var model = __webpack_require__(135);
	    model.paginators = __webpack_require__(136).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeCommit;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-13","endpointPrefix":"codecommit","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeCommit","serviceFullName":"AWS CodeCommit","serviceId":"CodeCommit","signatureVersion":"v4","targetPrefix":"CodeCommit_20150413","uid":"codecommit-2015-04-13"},"operations":{"AssociateApprovalRuleTemplateWithRepository":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryName"],"members":{"approvalRuleTemplateName":{},"repositoryName":{}}}},"BatchAssociateApprovalRuleTemplateWithRepositories":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryNames"],"members":{"approvalRuleTemplateName":{},"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","required":["associatedRepositoryNames","errors"],"members":{"associatedRepositoryNames":{"shape":"S5"},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchDescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"maxConflictFiles":{"type":"integer"},"filePaths":{"type":"list","member":{}},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflicts","destinationCommitId","sourceCommitId"],"members":{"conflicts":{"type":"list","member":{"type":"structure","members":{"conflictMetadata":{"shape":"Sn"},"mergeHunks":{"shape":"S12"}}}},"nextToken":{},"errors":{"type":"list","member":{"type":"structure","required":["filePath","exceptionName","message"],"members":{"filePath":{},"exceptionName":{},"message":{}}}},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"BatchDisassociateApprovalRuleTemplateFromRepositories":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryNames"],"members":{"approvalRuleTemplateName":{},"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","required":["disassociatedRepositoryNames","errors"],"members":{"disassociatedRepositoryNames":{"shape":"S5"},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetCommits":{"input":{"type":"structure","required":["commitIds","repositoryName"],"members":{"commitIds":{"type":"list","member":{}},"repositoryName":{}}},"output":{"type":"structure","members":{"commits":{"type":"list","member":{"shape":"S1l"}},"errors":{"type":"list","member":{"type":"structure","members":{"commitId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetRepositories":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1x"}},"repositoriesNotFound":{"type":"list","member":{}}}}},"CreateApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName","approvalRuleTemplateContent"],"members":{"approvalRuleTemplateName":{},"approvalRuleTemplateContent":{},"approvalRuleTemplateDescription":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"CreateBranch":{"input":{"type":"structure","required":["repositoryName","branchName","commitId"],"members":{"repositoryName":{},"branchName":{},"commitId":{}}}},"CreateCommit":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{},"parentCommitId":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"putFiles":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{},"fileMode":{},"fileContent":{"type":"blob"},"sourceFile":{"type":"structure","required":["filePath"],"members":{"filePath":{},"isMove":{"type":"boolean"}}}}}},"deleteFiles":{"shape":"S2o"},"setFileModes":{"shape":"S2q"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{},"filesAdded":{"shape":"S2t"},"filesUpdated":{"shape":"S2t"},"filesDeleted":{"shape":"S2t"}}}},"CreatePullRequest":{"input":{"type":"structure","required":["title","targets"],"members":{"title":{},"description":{},"targets":{"type":"list","member":{"type":"structure","required":["repositoryName","sourceReference"],"members":{"repositoryName":{},"sourceReference":{},"destinationReference":{}}}},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"CreatePullRequestApprovalRule":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName","approvalRuleContent"],"members":{"pullRequestId":{},"approvalRuleName":{},"approvalRuleContent":{}}},"output":{"type":"structure","required":["approvalRule"],"members":{"approvalRule":{"shape":"S3c"}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{},"tags":{"shape":"S3k"}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1x"}}}},"CreateUnreferencedMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"DeleteApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplateId"],"members":{"approvalRuleTemplateId":{}}}},"DeleteBranch":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"deletedBranch":{"shape":"S3y"}}}},"DeleteCommentContent":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}}},"DeleteFile":{"input":{"type":"structure","required":["repositoryName","branchName","filePath","parentCommitId"],"members":{"repositoryName":{},"branchName":{},"filePath":{},"parentCommitId":{},"keepEmptyFolders":{"type":"boolean"},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId","filePath"],"members":{"commitId":{},"blobId":{},"treeId":{},"filePath":{}}}},"DeletePullRequestApprovalRule":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName"],"members":{"pullRequestId":{},"approvalRuleName":{}}},"output":{"type":"structure","required":["approvalRuleId"],"members":{"approvalRuleId":{}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryId":{}}}},"DescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption","filePath"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"filePath":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflictMetadata","mergeHunks","destinationCommitId","sourceCommitId"],"members":{"conflictMetadata":{"shape":"Sn"},"mergeHunks":{"shape":"S12"},"nextToken":{},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"DescribePullRequestEvents":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"pullRequestEventType":{},"actorArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestEvents"],"members":{"pullRequestEvents":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"eventDate":{"type":"timestamp"},"pullRequestEventType":{},"actorArn":{},"pullRequestCreatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"sourceCommitId":{},"destinationCommitId":{},"mergeBase":{}}},"pullRequestStatusChangedEventMetadata":{"type":"structure","members":{"pullRequestStatus":{}}},"pullRequestSourceReferenceUpdatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"mergeBase":{}}},"pullRequestMergedStateChangedEventMetadata":{"type":"structure","members":{"repositoryName":{},"destinationReference":{},"mergeMetadata":{"shape":"S38"}}},"approvalRuleEventMetadata":{"type":"structure","members":{"approvalRuleName":{},"approvalRuleId":{},"approvalRuleContent":{}}},"approvalStateChangedEventMetadata":{"type":"structure","members":{"revisionId":{},"approvalStatus":{}}},"approvalRuleOverriddenEventMetadata":{"type":"structure","members":{"revisionId":{},"overrideStatus":{}}}}}},"nextToken":{}}}},"DisassociateApprovalRuleTemplateFromRepository":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryName"],"members":{"approvalRuleTemplateName":{},"repositoryName":{}}}},"EvaluatePullRequestApprovalRules":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","required":["evaluation"],"members":{"evaluation":{"type":"structure","members":{"approved":{"type":"boolean"},"overridden":{"type":"boolean"},"approvalRulesSatisfied":{"type":"list","member":{}},"approvalRulesNotSatisfied":{"type":"list","member":{}}}}}}},"GetApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"GetBlob":{"input":{"type":"structure","required":["repositoryName","blobId"],"members":{"repositoryName":{},"blobId":{}}},"output":{"type":"structure","required":["content"],"members":{"content":{"type":"blob"}}}},"GetBranch":{"input":{"type":"structure","members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"branch":{"shape":"S3y"}}}},"GetComment":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}}},"GetCommentReactions":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{},"reactionUserArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["reactionsForComment"],"members":{"reactionsForComment":{"type":"list","member":{"type":"structure","members":{"reaction":{"type":"structure","members":{"emoji":{},"shortCode":{},"unicode":{}}},"reactionUsers":{"type":"list","member":{}},"reactionsFromDeletedUsersCount":{"type":"integer"}}}},"nextToken":{}}}},"GetCommentsForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForComparedCommitData":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comments":{"shape":"S5t"}}}},"nextToken":{}}}},"GetCommentsForPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForPullRequestData":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comments":{"shape":"S5t"}}}},"nextToken":{}}}},"GetCommit":{"input":{"type":"structure","required":["repositoryName","commitId"],"members":{"repositoryName":{},"commitId":{}}},"output":{"type":"structure","required":["commit"],"members":{"commit":{"shape":"S1l"}}}},"GetDifferences":{"input":{"type":"structure","required":["repositoryName","afterCommitSpecifier"],"members":{"repositoryName":{},"beforeCommitSpecifier":{},"afterCommitSpecifier":{},"beforePath":{},"afterPath":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"differences":{"type":"list","member":{"type":"structure","members":{"beforeBlob":{"shape":"S65"},"afterBlob":{"shape":"S65"},"changeType":{}}}},"NextToken":{}}}},"GetFile":{"input":{"type":"structure","required":["repositoryName","filePath"],"members":{"repositoryName":{},"commitSpecifier":{},"filePath":{}}},"output":{"type":"structure","required":["commitId","blobId","filePath","fileMode","fileSize","fileContent"],"members":{"commitId":{},"blobId":{},"filePath":{},"fileMode":{},"fileSize":{"type":"long"},"fileContent":{"type":"blob"}}}},"GetFolder":{"input":{"type":"structure","required":["repositoryName","folderPath"],"members":{"repositoryName":{},"commitSpecifier":{},"folderPath":{}}},"output":{"type":"structure","required":["commitId","folderPath"],"members":{"commitId":{},"folderPath":{},"treeId":{},"subFolders":{"type":"list","member":{"type":"structure","members":{"treeId":{},"absolutePath":{},"relativePath":{}}}},"files":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"symbolicLinks":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"subModules":{"type":"list","member":{"type":"structure","members":{"commitId":{},"absolutePath":{},"relativePath":{}}}}}}},"GetMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","members":{"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{},"mergedCommitId":{}}}},"GetMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"maxConflictFiles":{"type":"integer"},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["mergeable","destinationCommitId","sourceCommitId","conflictMetadataList"],"members":{"mergeable":{"type":"boolean"},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{},"conflictMetadataList":{"type":"list","member":{"shape":"Sn"}},"nextToken":{}}}},"GetMergeOptions":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","required":["mergeOptions","sourceCommitId","destinationCommitId","baseCommitId"],"members":{"mergeOptions":{"type":"list","member":{}},"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{}}}},"GetPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"GetPullRequestApprovalStates":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","members":{"approvals":{"type":"list","member":{"type":"structure","members":{"userArn":{},"approvalState":{}}}}}}},"GetPullRequestOverrideState":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","members":{"overridden":{"type":"boolean"},"overrider":{}}}},"GetRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1x"}}}},"GetRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"configurationId":{},"triggers":{"shape":"S76"}}}},"ListApprovalRuleTemplates":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"approvalRuleTemplateNames":{"shape":"S7f"},"nextToken":{}}}},"ListAssociatedApprovalRuleTemplatesForRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"approvalRuleTemplateNames":{"shape":"S7f"},"nextToken":{}}}},"ListBranches":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{}}},"output":{"type":"structure","members":{"branches":{"shape":"S7a"},"nextToken":{}}}},"ListPullRequests":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"authorArn":{},"pullRequestStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestIds"],"members":{"pullRequestIds":{"type":"list","member":{}},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"nextToken":{},"sortBy":{},"order":{}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"repositoryId":{}}}},"nextToken":{}}}},"ListRepositoriesForApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositoryNames":{"shape":"S5"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S3k"},"nextToken":{}}}},"MergeBranchesByFastForward":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesBySquash":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesByThreeWay":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergePullRequestByFastForward":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S33"}}}},"MergePullRequestBySquash":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S33"}}}},"MergePullRequestByThreeWay":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3p"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S33"}}}},"OverridePullRequestApprovalRules":{"input":{"type":"structure","required":["pullRequestId","revisionId","overrideStatus"],"members":{"pullRequestId":{},"revisionId":{},"overrideStatus":{}}}},"PostCommentForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId","content"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S5q"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comment":{"shape":"S42"}}},"idempotent":true},"PostCommentForPullRequest":{"input":{"type":"structure","required":["pullRequestId","repositoryName","beforeCommitId","afterCommitId","content"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S5q"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"pullRequestId":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5q"},"comment":{"shape":"S42"}}},"idempotent":true},"PostCommentReply":{"input":{"type":"structure","required":["inReplyTo","content"],"members":{"inReplyTo":{},"clientRequestToken":{"idempotencyToken":true},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}},"idempotent":true},"PutCommentReaction":{"input":{"type":"structure","required":["commentId","reactionValue"],"members":{"commentId":{},"reactionValue":{}}}},"PutFile":{"input":{"type":"structure","required":["repositoryName","branchName","fileContent","filePath"],"members":{"repositoryName":{},"branchName":{},"fileContent":{"type":"blob"},"filePath":{},"fileMode":{},"parentCommitId":{},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId"],"members":{"commitId":{},"blobId":{},"treeId":{}}}},"PutRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S76"}}},"output":{"type":"structure","members":{"configurationId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3k"}}}},"TestRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S76"}}},"output":{"type":"structure","members":{"successfulExecutions":{"type":"list","member":{}},"failedExecutions":{"type":"list","member":{"type":"structure","members":{"trigger":{},"failureMessage":{}}}}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}},"UpdateApprovalRuleTemplateContent":{"input":{"type":"structure","required":["approvalRuleTemplateName","newRuleContent"],"members":{"approvalRuleTemplateName":{},"newRuleContent":{},"existingRuleContentSha256":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"UpdateApprovalRuleTemplateDescription":{"input":{"type":"structure","required":["approvalRuleTemplateName","approvalRuleTemplateDescription"],"members":{"approvalRuleTemplateName":{},"approvalRuleTemplateDescription":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"UpdateApprovalRuleTemplateName":{"input":{"type":"structure","required":["oldApprovalRuleTemplateName","newApprovalRuleTemplateName"],"members":{"oldApprovalRuleTemplateName":{},"newApprovalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2c"}}}},"UpdateComment":{"input":{"type":"structure","required":["commentId","content"],"members":{"commentId":{},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S42"}}}},"UpdateDefaultBranch":{"input":{"type":"structure","required":["repositoryName","defaultBranchName"],"members":{"repositoryName":{},"defaultBranchName":{}}}},"UpdatePullRequestApprovalRuleContent":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName","newRuleContent"],"members":{"pullRequestId":{},"approvalRuleName":{},"existingRuleContentSha256":{},"newRuleContent":{}}},"output":{"type":"structure","required":["approvalRule"],"members":{"approvalRule":{"shape":"S3c"}}}},"UpdatePullRequestApprovalState":{"input":{"type":"structure","required":["pullRequestId","revisionId","approvalState"],"members":{"pullRequestId":{},"revisionId":{},"approvalState":{}}}},"UpdatePullRequestDescription":{"input":{"type":"structure","required":["pullRequestId","description"],"members":{"pullRequestId":{},"description":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"UpdatePullRequestStatus":{"input":{"type":"structure","required":["pullRequestId","pullRequestStatus"],"members":{"pullRequestId":{},"pullRequestStatus":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"UpdatePullRequestTitle":{"input":{"type":"structure","required":["pullRequestId","title"],"members":{"pullRequestId":{},"title":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S33"}}}},"UpdateRepositoryDescription":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}}},"UpdateRepositoryName":{"input":{"type":"structure","required":["oldName","newName"],"members":{"oldName":{},"newName":{}}}}},"shapes":{"S5":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"filePath":{},"fileSizes":{"type":"structure","members":{"source":{"type":"long"},"destination":{"type":"long"},"base":{"type":"long"}}},"fileModes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"objectTypes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"numberOfConflicts":{"type":"integer"},"isBinaryFile":{"type":"structure","members":{"source":{"type":"boolean"},"destination":{"type":"boolean"},"base":{"type":"boolean"}}},"contentConflict":{"type":"boolean"},"fileModeConflict":{"type":"boolean"},"objectTypeConflict":{"type":"boolean"},"mergeOperations":{"type":"structure","members":{"source":{},"destination":{}}}}},"S12":{"type":"list","member":{"type":"structure","members":{"isConflict":{"type":"boolean"},"source":{"shape":"S15"},"destination":{"shape":"S15"},"base":{"shape":"S15"}}}},"S15":{"type":"structure","members":{"startLine":{"type":"integer"},"endLine":{"type":"integer"},"hunkContent":{}}},"S1l":{"type":"structure","members":{"commitId":{},"treeId":{},"parents":{"type":"list","member":{}},"message":{},"author":{"shape":"S1n"},"committer":{"shape":"S1n"},"additionalData":{}}},"S1n":{"type":"structure","members":{"name":{},"email":{},"date":{}}},"S1x":{"type":"structure","members":{"accountId":{},"repositoryId":{},"repositoryName":{},"repositoryDescription":{},"defaultBranch":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"cloneUrlHttp":{},"cloneUrlSsh":{},"Arn":{}}},"S2c":{"type":"structure","members":{"approvalRuleTemplateId":{},"approvalRuleTemplateName":{},"approvalRuleTemplateDescription":{},"approvalRuleTemplateContent":{},"ruleContentSha256":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"lastModifiedUser":{}}},"S2o":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{}}}},"S2q":{"type":"list","member":{"type":"structure","required":["filePath","fileMode"],"members":{"filePath":{},"fileMode":{}}}},"S2t":{"type":"list","member":{"type":"structure","members":{"absolutePath":{},"blobId":{},"fileMode":{}}}},"S33":{"type":"structure","members":{"pullRequestId":{},"title":{},"description":{},"lastActivityDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"pullRequestStatus":{},"authorArn":{},"pullRequestTargets":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"sourceReference":{},"destinationReference":{},"destinationCommit":{},"sourceCommit":{},"mergeBase":{},"mergeMetadata":{"shape":"S38"}}}},"clientRequestToken":{},"revisionId":{},"approvalRules":{"type":"list","member":{"shape":"S3c"}}}},"S38":{"type":"structure","members":{"isMerged":{"type":"boolean"},"mergedBy":{},"mergeCommitId":{},"mergeOption":{}}},"S3c":{"type":"structure","members":{"approvalRuleId":{},"approvalRuleName":{},"approvalRuleContent":{},"ruleContentSha256":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"lastModifiedUser":{},"originApprovalRuleTemplate":{"type":"structure","members":{"approvalRuleTemplateId":{},"approvalRuleTemplateName":{}}}}},"S3k":{"type":"map","key":{},"value":{}},"S3p":{"type":"structure","members":{"replaceContents":{"type":"list","member":{"type":"structure","required":["filePath","replacementType"],"members":{"filePath":{},"replacementType":{},"content":{"type":"blob"},"fileMode":{}}}},"deleteFiles":{"shape":"S2o"},"setFileModes":{"shape":"S2q"}}},"S3y":{"type":"structure","members":{"branchName":{},"commitId":{}}},"S42":{"type":"structure","members":{"commentId":{},"content":{},"inReplyTo":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"authorArn":{},"deleted":{"type":"boolean"},"clientRequestToken":{},"callerReactions":{"type":"list","member":{}},"reactionCounts":{"type":"map","key":{},"value":{"type":"integer"}}}},"S5q":{"type":"structure","members":{"filePath":{},"filePosition":{"type":"long"},"relativeFileVersion":{}}},"S5t":{"type":"list","member":{"shape":"S42"}},"S65":{"type":"structure","members":{"blobId":{},"path":{},"mode":{}}},"S76":{"type":"list","member":{"type":"structure","required":["name","destinationArn","events"],"members":{"name":{},"destinationArn":{},"customData":{},"branches":{"shape":"S7a"},"events":{"type":"list","member":{}}}}},"S7a":{"type":"list","member":{}},"S7f":{"type":"list","member":{}}}}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeMergeConflicts":{"input_token":"nextToken","limit_key":"maxMergeHunks","output_token":"nextToken"},"DescribePullRequestEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentReactions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForComparedCommit":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForPullRequest":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetDifferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMergeConflicts":{"input_token":"nextToken","limit_key":"maxConflictFiles","output_token":"nextToken"},"ListApprovalRuleTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListAssociatedApprovalRuleTemplatesForRepository":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListBranches":{"input_token":"nextToken","output_token":"nextToken","result_key":"branches"},"ListPullRequests":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","result_key":"repositories"},"ListRepositoriesForApprovalRuleTemplate":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"}}}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codedeploy'] = {};
	AWS.CodeDeploy = Service.defineService('codedeploy', ['2014-10-06']);
	Object.defineProperty(apiLoader.services['codedeploy'], '2014-10-06', {
	  get: function get() {
	    var model = __webpack_require__(138);
	    model.paginators = __webpack_require__(139).pagination;
	    model.waiters = __webpack_require__(140).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeDeploy;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-06","endpointPrefix":"codedeploy","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeDeploy","serviceFullName":"AWS CodeDeploy","serviceId":"CodeDeploy","signatureVersion":"v4","targetPrefix":"CodeDeploy_20141006","uid":"codedeploy-2014-10-06"},"operations":{"AddTagsToOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"BatchGetApplicationRevisions":{"input":{"type":"structure","required":["applicationName","revisions"],"members":{"applicationName":{},"revisions":{"shape":"Sa"}}},"output":{"type":"structure","members":{"applicationName":{},"errorMessage":{},"revisions":{"type":"list","member":{"type":"structure","members":{"revisionLocation":{"shape":"Sb"},"genericRevisionInfo":{"shape":"Su"}}}}}}},"BatchGetApplications":{"input":{"type":"structure","required":["applicationNames"],"members":{"applicationNames":{"shape":"S10"}}},"output":{"type":"structure","members":{"applicationsInfo":{"type":"list","member":{"shape":"S13"}}}}},"BatchGetDeploymentGroups":{"input":{"type":"structure","required":["applicationName","deploymentGroupNames"],"members":{"applicationName":{},"deploymentGroupNames":{"shape":"Sw"}}},"output":{"type":"structure","members":{"deploymentGroupsInfo":{"type":"list","member":{"shape":"S1b"}},"errorMessage":{}}}},"BatchGetDeploymentInstances":{"input":{"type":"structure","required":["deploymentId","instanceIds"],"members":{"deploymentId":{},"instanceIds":{"shape":"S32"}}},"output":{"type":"structure","members":{"instancesSummary":{"type":"list","member":{"shape":"S36"}},"errorMessage":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use BatchGetDeploymentTargets instead."},"BatchGetDeploymentTargets":{"input":{"type":"structure","members":{"deploymentId":{},"targetIds":{"shape":"S3j"}}},"output":{"type":"structure","members":{"deploymentTargets":{"type":"list","member":{"shape":"S3n"}}}}},"BatchGetDeployments":{"input":{"type":"structure","required":["deploymentIds"],"members":{"deploymentIds":{"shape":"S49"}}},"output":{"type":"structure","members":{"deploymentsInfo":{"type":"list","member":{"shape":"S4c"}}}}},"BatchGetOnPremisesInstances":{"input":{"type":"structure","required":["instanceNames"],"members":{"instanceNames":{"shape":"S6"}}},"output":{"type":"structure","members":{"instanceInfos":{"type":"list","member":{"shape":"S4t"}}}}},"ContinueDeployment":{"input":{"type":"structure","members":{"deploymentId":{},"deploymentWaitType":{}}}},"CreateApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"computePlatform":{},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"applicationId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"deploymentGroupName":{},"revision":{"shape":"Sb"},"deploymentConfigName":{},"description":{},"ignoreApplicationStopFailures":{"type":"boolean"},"targetInstances":{"shape":"S4j"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"fileExistsBehavior":{}}},"output":{"type":"structure","members":{"deploymentId":{}}}},"CreateDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S54"},"trafficRoutingConfig":{"shape":"S57"},"computePlatform":{}}},"output":{"type":"structure","members":{"deploymentConfigId":{}}}},"CreateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName","serviceRoleArn"],"members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4k"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"outdatedInstancesStrategy":{},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"ec2TagSet":{"shape":"S2t"},"ecsServices":{"shape":"S2x"},"onPremisesTagSet":{"shape":"S2v"},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"deploymentGroupId":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}}},"DeleteDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}}},"DeleteDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}},"DeleteGitHubAccountToken":{"input":{"type":"structure","members":{"tokenName":{}}},"output":{"type":"structure","members":{"tokenName":{}}}},"DeleteResourcesByExternalId":{"input":{"type":"structure","members":{"externalId":{}}},"output":{"type":"structure","members":{}}},"DeregisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}}},"GetApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"application":{"shape":"S13"}}}},"GetApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"revision":{"shape":"Sb"}}},"output":{"type":"structure","members":{"applicationName":{},"revision":{"shape":"Sb"},"revisionInfo":{"shape":"Su"}}}},"GetDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{}}},"output":{"type":"structure","members":{"deploymentInfo":{"shape":"S4c"}}}},"GetDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}},"output":{"type":"structure","members":{"deploymentConfigInfo":{"type":"structure","members":{"deploymentConfigId":{},"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S54"},"createTime":{"type":"timestamp"},"computePlatform":{},"trafficRoutingConfig":{"shape":"S57"}}}}}},"GetDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"deploymentGroupInfo":{"shape":"S1b"}}}},"GetDeploymentInstance":{"input":{"type":"structure","required":["deploymentId","instanceId"],"members":{"deploymentId":{},"instanceId":{}}},"output":{"type":"structure","members":{"instanceSummary":{"shape":"S36"}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use GetDeploymentTarget instead."},"GetDeploymentTarget":{"input":{"type":"structure","members":{"deploymentId":{},"targetId":{}}},"output":{"type":"structure","members":{"deploymentTarget":{"shape":"S3n"}}}},"GetOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instanceInfo":{"shape":"S4t"}}}},"ListApplicationRevisions":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"sortBy":{},"sortOrder":{},"s3Bucket":{},"s3KeyPrefix":{},"deployed":{},"nextToken":{}}},"output":{"type":"structure","members":{"revisions":{"shape":"Sa"},"nextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"applications":{"shape":"S10"},"nextToken":{}}}},"ListDeploymentConfigs":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"deploymentConfigsList":{"type":"list","member":{}},"nextToken":{}}}},"ListDeploymentGroups":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"nextToken":{}}},"output":{"type":"structure","members":{"applicationName":{},"deploymentGroups":{"shape":"Sw"},"nextToken":{}}}},"ListDeploymentInstances":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"instanceStatusFilter":{"type":"list","member":{"shape":"S37"}},"instanceTypeFilter":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"instancesList":{"shape":"S32"},"nextToken":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ListDeploymentTargets instead."},"ListDeploymentTargets":{"input":{"type":"structure","members":{"deploymentId":{},"nextToken":{},"targetFilters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"targetIds":{"shape":"S3j"},"nextToken":{}}}},"ListDeployments":{"input":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"externalId":{},"includeOnlyStatuses":{"type":"list","member":{}},"createTimeRange":{"type":"structure","members":{"start":{"type":"timestamp"},"end":{"type":"timestamp"}}},"nextToken":{}}},"output":{"type":"structure","members":{"deployments":{"shape":"S49"},"nextToken":{}}}},"ListGitHubAccountTokenNames":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"tokenNameList":{"type":"list","member":{}},"nextToken":{}}}},"ListOnPremisesInstances":{"input":{"type":"structure","members":{"registrationStatus":{},"tagFilters":{"shape":"S1h"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceNames":{"shape":"S6"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2"},"NextToken":{}}}},"PutLifecycleEventHookExecutionStatus":{"input":{"type":"structure","members":{"deploymentId":{},"lifecycleEventHookExecutionId":{},"status":{}}},"output":{"type":"structure","members":{"lifecycleEventHookExecutionId":{}}}},"RegisterApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"description":{},"revision":{"shape":"Sb"}}}},"RegisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{}}}},"RemoveTagsFromOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"SkipWaitTimeForInstanceTermination":{"input":{"type":"structure","members":{"deploymentId":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ContinueDeployment with DeploymentWaitType instead."},"StopDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"autoRollbackEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusMessage":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S2"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","members":{"applicationName":{},"newApplicationName":{}}}},"UpdateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","currentDeploymentGroupName"],"members":{"applicationName":{},"currentDeploymentGroupName":{},"newDeploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4k"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"outdatedInstancesStrategy":{},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"ec2TagSet":{"shape":"S2t"},"ecsServices":{"shape":"S2x"},"onPremisesTagSet":{"shape":"S2v"}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"revisionType":{},"s3Location":{"type":"structure","members":{"bucket":{},"key":{},"bundleType":{},"version":{},"eTag":{}}},"gitHubLocation":{"type":"structure","members":{"repository":{},"commitId":{}}},"string":{"type":"structure","members":{"content":{},"sha256":{}},"deprecated":true,"deprecatedMessage":"RawString and String revision type are deprecated, use AppSpecContent type instead."},"appSpecContent":{"type":"structure","members":{"content":{},"sha256":{}}}}},"Su":{"type":"structure","members":{"description":{},"deploymentGroups":{"shape":"Sw"},"firstUsedTime":{"type":"timestamp"},"lastUsedTime":{"type":"timestamp"},"registerTime":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"applicationId":{},"applicationName":{},"createTime":{"type":"timestamp"},"linkedToGitHub":{"type":"boolean"},"gitHubAccountName":{},"computePlatform":{}}},"S1b":{"type":"structure","members":{"applicationName":{},"deploymentGroupId":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S1k"},"serviceRoleArn":{},"targetRevision":{"shape":"Sb"},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"outdatedInstancesStrategy":{},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"lastSuccessfulDeployment":{"shape":"S2q"},"lastAttemptedDeployment":{"shape":"S2q"},"ec2TagSet":{"shape":"S2t"},"onPremisesTagSet":{"shape":"S2v"},"computePlatform":{},"ecsServices":{"shape":"S2x"}}},"S1e":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"name":{},"hook":{}}}},"S1p":{"type":"list","member":{"type":"structure","members":{"triggerName":{},"triggerTargetArn":{},"triggerEvents":{"type":"list","member":{}}}}},"S1v":{"type":"structure","members":{"enabled":{"type":"boolean"},"ignorePollAlarmFailure":{"type":"boolean"},"alarms":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S1z":{"type":"structure","members":{"enabled":{"type":"boolean"},"events":{"type":"list","member":{}}}},"S22":{"type":"structure","members":{"deploymentType":{},"deploymentOption":{}}},"S26":{"type":"structure","members":{"terminateBlueInstancesOnDeploymentSuccess":{"type":"structure","members":{"action":{},"terminationWaitTimeInMinutes":{"type":"integer"}}},"deploymentReadyOption":{"type":"structure","members":{"actionOnTimeout":{},"waitTimeInMinutes":{"type":"integer"}}},"greenFleetProvisioningOption":{"type":"structure","members":{"action":{}}}}},"S2e":{"type":"structure","members":{"elbInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"targetGroupInfoList":{"shape":"S2i"},"targetGroupPairInfoList":{"type":"list","member":{"type":"structure","members":{"targetGroups":{"shape":"S2i"},"prodTrafficRoute":{"shape":"S2n"},"testTrafficRoute":{"shape":"S2n"}}}}}},"S2i":{"type":"list","member":{"shape":"S2j"}},"S2j":{"type":"structure","members":{"name":{}}},"S2n":{"type":"structure","members":{"listenerArns":{"type":"list","member":{}}}},"S2q":{"type":"structure","members":{"deploymentId":{},"status":{},"endTime":{"type":"timestamp"},"createTime":{"type":"timestamp"}}},"S2t":{"type":"structure","members":{"ec2TagSetList":{"type":"list","member":{"shape":"S1e"}}}},"S2v":{"type":"structure","members":{"onPremisesTagSetList":{"type":"list","member":{"shape":"S1h"}}}},"S2x":{"type":"list","member":{"type":"structure","members":{"serviceName":{},"clusterName":{}}}},"S32":{"type":"list","member":{}},"S36":{"type":"structure","members":{"deploymentId":{},"instanceId":{},"status":{"shape":"S37"},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"instanceType":{}},"deprecated":true,"deprecatedMessage":"InstanceSummary is deprecated, use DeploymentTarget instead."},"S37":{"type":"string","deprecated":true,"deprecatedMessage":"InstanceStatus is deprecated, use TargetStatus instead."},"S38":{"type":"list","member":{"type":"structure","members":{"lifecycleEventName":{},"diagnostics":{"type":"structure","members":{"errorCode":{},"scriptName":{},"message":{},"logTail":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{}}}},"S3j":{"type":"list","member":{}},"S3n":{"type":"structure","members":{"deploymentTargetType":{},"instanceTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"instanceLabel":{}}},"lambdaTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"lambdaFunctionInfo":{"type":"structure","members":{"functionName":{},"functionAlias":{},"currentVersion":{},"targetVersion":{},"targetVersionWeight":{"type":"double"}}}}},"ecsTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"status":{},"taskSetsInfo":{"type":"list","member":{"type":"structure","members":{"identifer":{},"desiredCount":{"type":"long"},"pendingCount":{"type":"long"},"runningCount":{"type":"long"},"status":{},"trafficWeight":{"type":"double"},"targetGroup":{"shape":"S2j"},"taskSetLabel":{}}}}}},"cloudFormationTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"status":{},"resourceType":{},"targetVersionWeight":{"type":"double"}}}}},"S49":{"type":"list","member":{}},"S4c":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"deploymentId":{},"previousRevision":{"shape":"Sb"},"revision":{"shape":"Sb"},"status":{},"errorInformation":{"type":"structure","members":{"code":{},"message":{}}},"createTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"completeTime":{"type":"timestamp"},"deploymentOverview":{"type":"structure","members":{"Pending":{"type":"long"},"InProgress":{"type":"long"},"Succeeded":{"type":"long"},"Failed":{"type":"long"},"Skipped":{"type":"long"},"Ready":{"type":"long"}}},"description":{},"creator":{},"ignoreApplicationStopFailures":{"type":"boolean"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"rollbackInfo":{"type":"structure","members":{"rollbackDeploymentId":{},"rollbackTriggeringDeploymentId":{},"rollbackMessage":{}}},"deploymentStyle":{"shape":"S22"},"targetInstances":{"shape":"S4j"},"instanceTerminationWaitTimeStarted":{"type":"boolean"},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"additionalDeploymentStatusInfo":{"type":"string","deprecated":true,"deprecatedMessage":"AdditionalDeploymentStatusInfo is deprecated, use DeploymentStatusMessageList instead."},"fileExistsBehavior":{},"deploymentStatusMessages":{"type":"list","member":{}},"computePlatform":{},"externalId":{},"relatedDeployments":{"type":"structure","members":{"autoUpdateOutdatedInstancesRootDeploymentId":{},"autoUpdateOutdatedInstancesDeploymentIds":{"shape":"S49"}}}}},"S4j":{"type":"structure","members":{"tagFilters":{"shape":"S1e"},"autoScalingGroups":{"shape":"S4k"},"ec2TagSet":{"shape":"S2t"}}},"S4k":{"type":"list","member":{}},"S4t":{"type":"structure","members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{},"instanceArn":{},"registerTime":{"type":"timestamp"},"deregisterTime":{"type":"timestamp"},"tags":{"shape":"S2"}}},"S54":{"type":"structure","members":{"type":{},"value":{"type":"integer"}}},"S57":{"type":"structure","members":{"type":{},"timeBasedCanary":{"type":"structure","members":{"canaryPercentage":{"type":"integer"},"canaryInterval":{"type":"integer"}}},"timeBasedLinear":{"type":"structure","members":{"linearPercentage":{"type":"integer"},"linearInterval":{"type":"integer"}}}}}}}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplicationRevisions":{"input_token":"nextToken","output_token":"nextToken","result_key":"revisions"},"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applications"},"ListDeploymentConfigs":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentConfigsList"},"ListDeploymentGroups":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentGroups"},"ListDeploymentInstances":{"input_token":"nextToken","output_token":"nextToken","result_key":"instancesList"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","result_key":"deployments"}}}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DeploymentSuccessful":{"delay":15,"operation":"GetDeployment","maxAttempts":120,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"deploymentInfo.status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"deploymentInfo.status"},{"expected":"Stopped","matcher":"path","state":"failure","argument":"deploymentInfo.status"}]}}}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codepipeline'] = {};
	AWS.CodePipeline = Service.defineService('codepipeline', ['2015-07-09']);
	Object.defineProperty(apiLoader.services['codepipeline'], '2015-07-09', {
	  get: function get() {
	    var model = __webpack_require__(142);
	    model.paginators = __webpack_require__(143).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodePipeline;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"codepipeline","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodePipeline","serviceFullName":"AWS CodePipeline","serviceId":"CodePipeline","signatureVersion":"v4","targetPrefix":"CodePipeline_20150709","uid":"codepipeline-2015-07-09"},"operations":{"AcknowledgeJob":{"input":{"type":"structure","required":["jobId","nonce"],"members":{"jobId":{},"nonce":{}}},"output":{"type":"structure","members":{"status":{}}}},"AcknowledgeThirdPartyJob":{"input":{"type":"structure","required":["jobId","nonce","clientToken"],"members":{"jobId":{},"nonce":{},"clientToken":{}}},"output":{"type":"structure","members":{"status":{}}}},"CreateCustomActionType":{"input":{"type":"structure","required":["category","provider","version","inputArtifactDetails","outputArtifactDetails"],"members":{"category":{},"provider":{},"version":{},"settings":{"shape":"Se"},"configurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"Sv"},"tags":{"shape":"Sq"}}}},"CreatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}}},"DeleteCustomActionType":{"input":{"type":"structure","required":["category","provider","version"],"members":{"category":{},"provider":{},"version":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeregisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"DisableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType","reason"],"members":{"pipelineName":{},"stageName":{},"transitionType":{},"reason":{}}}},"EnableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType"],"members":{"pipelineName":{},"stageName":{},"transitionType":{}}}},"GetActionType":{"input":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"output":{"type":"structure","members":{"actionType":{"shape":"S29"}}}},"GetJobDetails":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"shape":"S31"},"accountId":{}}}}}},"GetPipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{},"version":{"type":"integer"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"metadata":{"type":"structure","members":{"pipelineArn":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}}}},"GetPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{}}},"output":{"type":"structure","members":{"pipelineExecution":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"pipelineExecutionId":{},"status":{},"statusSummary":{},"artifactRevisions":{"type":"list","member":{"type":"structure","members":{"name":{},"revisionId":{},"revisionChangeIdentifier":{},"revisionSummary":{},"created":{"type":"timestamp"},"revisionUrl":{}}}}}}}}},"GetPipelineState":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"stageStates":{"type":"list","member":{"type":"structure","members":{"stageName":{},"inboundExecution":{"shape":"S43"},"inboundTransitionState":{"type":"structure","members":{"enabled":{"type":"boolean"},"lastChangedBy":{},"lastChangedAt":{"type":"timestamp"},"disabledReason":{}}},"actionStates":{"type":"list","member":{"type":"structure","members":{"actionName":{},"currentRevision":{"shape":"S4b"},"latestExecution":{"type":"structure","members":{"actionExecutionId":{},"status":{},"summary":{},"lastStatusChange":{"type":"timestamp"},"token":{},"lastUpdatedBy":{},"externalExecutionId":{},"externalExecutionUrl":{},"percentComplete":{"type":"integer"},"errorDetails":{"type":"structure","members":{"code":{},"message":{}}}}},"entityUrl":{},"revisionUrl":{}}}},"latestExecution":{"shape":"S43"}}}},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"GetThirdPartyJobDetails":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S32"},"pipelineContext":{"shape":"S33"},"inputArtifacts":{"shape":"S39"},"outputArtifacts":{"shape":"S39"},"artifactCredentials":{"shape":"S3h"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"nonce":{}}}}}},"ListActionExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"filter":{"type":"structure","members":{"pipelineExecutionId":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actionExecutionDetails":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"actionExecutionId":{},"pipelineVersion":{"type":"integer"},"stageName":{},"actionName":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"input":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"configuration":{"shape":"S1l"},"resolvedConfiguration":{"type":"map","key":{},"value":{}},"roleArn":{},"region":{},"inputArtifacts":{"shape":"S50"},"namespace":{}}},"output":{"type":"structure","members":{"outputArtifacts":{"shape":"S50"},"executionResult":{"type":"structure","members":{"externalExecutionId":{},"externalExecutionSummary":{},"externalExecutionUrl":{}}},"outputVariables":{"shape":"S59"}}}}}},"nextToken":{}}}},"ListActionTypes":{"input":{"type":"structure","members":{"actionOwnerFilter":{},"nextToken":{},"regionFilter":{}}},"output":{"type":"structure","required":["actionTypes"],"members":{"actionTypes":{"type":"list","member":{"shape":"Sv"}},"nextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"pipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"status":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"sourceRevisions":{"type":"list","member":{"type":"structure","required":["actionName"],"members":{"actionName":{},"revisionId":{},"revisionSummary":{},"revisionUrl":{}}}},"trigger":{"type":"structure","members":{"triggerType":{},"triggerDetail":{}}},"stopTrigger":{"type":"structure","members":{"reason":{}}}}}},"nextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"pipelines":{"type":"list","member":{"type":"structure","members":{"name":{},"version":{"type":"integer"},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"},"nextToken":{}}}},"ListWebhooks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"webhooks":{"type":"list","member":{"shape":"S61"}},"NextToken":{}}}},"PollForJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"},"queryParam":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"id":{},"data":{"shape":"S31"},"nonce":{},"accountId":{}}}}}}},"PollForThirdPartyJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"clientId":{},"jobId":{}}}}}}},"PutActionRevision":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","actionRevision"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"actionRevision":{"shape":"S4b"}}},"output":{"type":"structure","members":{"newRevision":{"type":"boolean"},"pipelineExecutionId":{}}}},"PutApprovalResult":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","result","token"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"result":{"type":"structure","required":["summary","status"],"members":{"summary":{},"status":{}}},"token":{}}},"output":{"type":"structure","members":{"approvedAt":{"type":"timestamp"}}}},"PutJobFailureResult":{"input":{"type":"structure","required":["jobId","failureDetails"],"members":{"jobId":{},"failureDetails":{"shape":"S71"}}}},"PutJobSuccessResult":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{},"currentRevision":{"shape":"S74"},"continuationToken":{},"executionDetails":{"shape":"S76"},"outputVariables":{"shape":"S59"}}}},"PutThirdPartyJobFailureResult":{"input":{"type":"structure","required":["jobId","clientToken","failureDetails"],"members":{"jobId":{},"clientToken":{},"failureDetails":{"shape":"S71"}}}},"PutThirdPartyJobSuccessResult":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{},"currentRevision":{"shape":"S74"},"continuationToken":{},"executionDetails":{"shape":"S76"}}}},"PutWebhook":{"input":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S62"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S61"}}}},"RegisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"RetryStageExecution":{"input":{"type":"structure","required":["pipelineName","stageName","pipelineExecutionId","retryMode"],"members":{"pipelineName":{},"stageName":{},"pipelineExecutionId":{},"retryMode":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["name"],"members":{"name":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StopPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{},"abandon":{"type":"boolean"},"reason":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateActionType":{"input":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"S29"}}}},"UpdatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"}}}}},"shapes":{"Se":{"type":"structure","members":{"thirdPartyConfigurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}},"Sh":{"type":"list","member":{"type":"structure","required":["name","required","key","secret"],"members":{"name":{},"required":{"type":"boolean"},"key":{"type":"boolean"},"secret":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{},"type":{}}}},"Sn":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sv":{"type":"structure","required":["id","inputArtifactDetails","outputArtifactDetails"],"members":{"id":{"shape":"Sw"},"settings":{"shape":"Se"},"actionConfigurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"Sw":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"Sz":{"type":"structure","required":["name","roleArn","stages"],"members":{"name":{},"roleArn":{},"artifactStore":{"shape":"S12"},"artifactStores":{"type":"map","key":{},"value":{"shape":"S12"}},"stages":{"type":"list","member":{"type":"structure","required":["name","actions"],"members":{"name":{},"blockers":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"actions":{"type":"list","member":{"type":"structure","required":["name","actionTypeId"],"members":{"name":{},"actionTypeId":{"shape":"Sw"},"runOrder":{"type":"integer"},"configuration":{"shape":"S1l"},"outputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"inputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"roleArn":{},"region":{},"namespace":{}}}}}}},"version":{"type":"integer"}}},"S12":{"type":"structure","required":["type","location"],"members":{"type":{},"location":{},"encryptionKey":{"shape":"S15"}}},"S15":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S1l":{"type":"map","key":{},"value":{}},"S29":{"type":"structure","required":["executor","id","inputArtifactDetails","outputArtifactDetails"],"members":{"description":{},"executor":{"type":"structure","required":["configuration","type"],"members":{"configuration":{"type":"structure","members":{"lambdaExecutorConfiguration":{"type":"structure","required":["lambdaFunctionArn"],"members":{"lambdaFunctionArn":{}}},"jobWorkerExecutorConfiguration":{"type":"structure","members":{"pollingAccounts":{"type":"list","member":{}},"pollingServicePrincipals":{"type":"list","member":{}}}}}},"type":{},"policyStatementsTemplate":{},"jobTimeout":{"type":"integer"}}},"id":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"inputArtifactDetails":{"shape":"S2o"},"outputArtifactDetails":{"shape":"S2o"},"permissions":{"type":"structure","required":["allowedAccounts"],"members":{"allowedAccounts":{"type":"list","member":{}}}},"properties":{"type":"list","member":{"type":"structure","required":["name","optional","key","noEcho"],"members":{"name":{},"optional":{"type":"boolean"},"key":{"type":"boolean"},"noEcho":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{}}}},"urls":{"type":"structure","members":{"configurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}}}},"S2o":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"S31":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S32"},"pipelineContext":{"shape":"S33"},"inputArtifacts":{"shape":"S39"},"outputArtifacts":{"shape":"S39"},"artifactCredentials":{"shape":"S3h"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"S32":{"type":"structure","members":{"configuration":{"shape":"S1l"}}},"S33":{"type":"structure","members":{"pipelineName":{},"stage":{"type":"structure","members":{"name":{}}},"action":{"type":"structure","members":{"name":{},"actionExecutionId":{}}},"pipelineArn":{},"pipelineExecutionId":{}}},"S39":{"type":"list","member":{"type":"structure","members":{"name":{},"revision":{},"location":{"type":"structure","members":{"type":{},"s3Location":{"type":"structure","required":["bucketName","objectKey"],"members":{"bucketName":{},"objectKey":{}}}}}}}},"S3h":{"type":"structure","required":["accessKeyId","secretAccessKey","sessionToken"],"members":{"accessKeyId":{"type":"string","sensitive":true},"secretAccessKey":{"type":"string","sensitive":true},"sessionToken":{"type":"string","sensitive":true}},"sensitive":true},"S43":{"type":"structure","required":["pipelineExecutionId","status"],"members":{"pipelineExecutionId":{},"status":{}}},"S4b":{"type":"structure","required":["revisionId","revisionChangeId","created"],"members":{"revisionId":{},"revisionChangeId":{},"created":{"type":"timestamp"}}},"S50":{"type":"list","member":{"type":"structure","members":{"name":{},"s3location":{"type":"structure","members":{"bucket":{},"key":{}}}}}},"S59":{"type":"map","key":{},"value":{}},"S61":{"type":"structure","required":["definition","url"],"members":{"definition":{"shape":"S62"},"url":{},"errorMessage":{},"errorCode":{},"lastTriggered":{"type":"timestamp"},"arn":{},"tags":{"shape":"Sq"}}},"S62":{"type":"structure","required":["name","targetPipeline","targetAction","filters","authentication","authenticationConfiguration"],"members":{"name":{},"targetPipeline":{},"targetAction":{},"filters":{"type":"list","member":{"type":"structure","required":["jsonPath"],"members":{"jsonPath":{},"matchEquals":{}}}},"authentication":{},"authenticationConfiguration":{"type":"structure","members":{"AllowedIPRange":{},"SecretToken":{}}}}},"S71":{"type":"structure","required":["type","message"],"members":{"type":{},"message":{},"externalExecutionId":{}}},"S74":{"type":"structure","required":["revision","changeIdentifier"],"members":{"revision":{},"changeIdentifier":{},"created":{"type":"timestamp"},"revisionSummary":{}}},"S76":{"type":"structure","members":{"summary":{},"externalExecutionId":{},"percentComplete":{"type":"integer"}}}}}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListActionExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"actionExecutionDetails"},"ListActionTypes":{"input_token":"nextToken","output_token":"nextToken","result_key":"actionTypes"},"ListPipelineExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"pipelineExecutionSummaries"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"pipelines"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tags"},"ListWebhooks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"webhooks"}}}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cognitoidentityserviceprovider'] = {};
	AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
	Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
	  get: function get() {
	    var model = __webpack_require__(145);
	    model.paginators = __webpack_require__(146).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CognitoIdentityServiceProvider;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","serviceId":"Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"ValidationData":{"shape":"Sj"},"TemporaryPassword":{"shape":"Sn"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"User":{"shape":"St"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1e"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sw"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1h"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"AuthFlow":{},"AuthParameters":{"shape":"S1l"},"ClientMetadata":{"shape":"Sg"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S13"},"SourceUser":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{},"CompromisedCredentialsDetected":{"type":"boolean"}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2y"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S31"},"SoftwareTokenMfaSettings":{"shape":"S32"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username","Password"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Password":{"shape":"Sn"},"Permanent":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sn"},"ProposedPassword":{"shape":"Sn"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sn"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4u"},"LambdaConfig":{"shape":"S4y"},"AutoVerifiedAttributes":{"shape":"S53"},"AliasAttributes":{"shape":"S55"},"UsernameAttributes":{"shape":"S57"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S5c"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5h"},"EmailConfiguration":{"shape":"S5i"},"SmsConfiguration":{"shape":"S5m"},"UserPoolTags":{"shape":"S5o"},"AdminCreateUserConfig":{"shape":"S5r"},"Schema":{"shape":"S5u"},"UserPoolAddOns":{"shape":"S5v"},"UsernameConfiguration":{"shape":"S5x"},"AccountRecoverySetting":{"shape":"S5y"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S64"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"AccessTokenValidity":{"type":"integer"},"IdTokenValidity":{"type":"integer"},"TokenValidityUnits":{"shape":"S6d"},"ReadAttributes":{"shape":"S6f"},"WriteAttributes":{"shape":"S6f"},"ExplicitAuthFlows":{"shape":"S6h"},"SupportedIdentityProviders":{"shape":"S6j"},"CallbackURLs":{"shape":"S6k"},"LogoutURLs":{"shape":"S6m"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6n"},"AllowedOAuthScopes":{"shape":"S6p"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6r"},"PreventUserExistenceErrors":{},"EnableTokenRevocation":{"type":"boolean"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6v"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S6y"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"S10"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S7g"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S64"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6v"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{},"CustomDomainConfig":{"shape":"S6y"}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"UserContextData":{"shape":"S3u"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S8e"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1e"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"GetSigningCertificate":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"Certificate":{}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S8s"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"MFAOptions":{"shape":"Sw"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1h"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S8e"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S92"},"SoftwareTokenMfaConfiguration":{"shape":"S93"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1l"},"ClientMetadata":{"shape":"Sg"},"ClientId":{"shape":"S1j"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}},"authtype":"none"},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4i"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5o"}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4m"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1j"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4y"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"Sa5"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"Sa5"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"UserContextData":{"shape":"S3u"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S8e"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1j"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2y"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}},"authtype":"none"},"RevokeToken":{"input":{"type":"structure","required":["Token","ClientId"],"members":{"Token":{"shape":"S1v"},"ClientId":{"shape":"S1j"},"ClientSecret":{"shape":"S6w"}}},"output":{"type":"structure","members":{}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CompromisedCredentialsRiskConfiguration":{"shape":"S7h"},"AccountTakeoverRiskConfiguration":{"shape":"S7m"},"RiskExceptionConfiguration":{"shape":"S7v"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S7g"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S8s"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S31"},"SoftwareTokenMfaSettings":{"shape":"S32"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S92"},"SoftwareTokenMfaConfiguration":{"shape":"S93"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S92"},"SoftwareTokenMfaConfiguration":{"shape":"S93"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sw"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"Password":{"shape":"Sn"},"UserAttributes":{"shape":"Sj"},"ValidationData":{"shape":"Sj"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S8e"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S5o"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Sj"},"AccessToken":{"shape":"S1v"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S8e"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4u"},"LambdaConfig":{"shape":"S4y"},"AutoVerifiedAttributes":{"shape":"S53"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S5c"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5h"},"EmailConfiguration":{"shape":"S5i"},"SmsConfiguration":{"shape":"S5m"},"UserPoolTags":{"shape":"S5o"},"AdminCreateUserConfig":{"shape":"S5r"},"UserPoolAddOns":{"shape":"S5v"},"AccountRecoverySetting":{"shape":"S5y"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"AccessTokenValidity":{"type":"integer"},"IdTokenValidity":{"type":"integer"},"TokenValidityUnits":{"shape":"S6d"},"ReadAttributes":{"shape":"S6f"},"WriteAttributes":{"shape":"S6f"},"ExplicitAuthFlows":{"shape":"S6h"},"SupportedIdentityProviders":{"shape":"S6j"},"CallbackURLs":{"shape":"S6k"},"LogoutURLs":{"shape":"S6m"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6n"},"AllowedOAuthScopes":{"shape":"S6p"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6r"},"PreventUserExistenceErrors":{},"EnableTokenRevocation":{"type":"boolean"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6v"}}}},"UpdateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId","CustomDomainConfig"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S6y"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sn":{"type":"string","sensitive":true},"St":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Sj"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sw"}}},"Sw":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1e":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Sj"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1h":{"type":"list","member":{}},"S1j":{"type":"string","sensitive":true},"S1l":{"type":"map","key":{},"value":{},"sensitive":true},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1e"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2y":{"type":"map","key":{},"value":{}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S32":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3s":{"type":"string","sensitive":true},"S3u":{"type":"structure","members":{"EncodedData":{}}},"S43":{"type":"map","key":{},"value":{}},"S44":{"type":"map","key":{},"value":{}},"S46":{"type":"list","member":{}},"S49":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4d":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4i":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"S4m":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4u":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"},"TemporaryPasswordValidityDays":{"type":"integer"}}}}},"S4y":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{},"UserMigration":{},"CustomSMSSender":{"type":"structure","required":["LambdaVersion","LambdaArn"],"members":{"LambdaVersion":{},"LambdaArn":{}}},"CustomEmailSender":{"type":"structure","required":["LambdaVersion","LambdaArn"],"members":{"LambdaVersion":{},"LambdaArn":{}}},"KMSKeyID":{}}},"S53":{"type":"list","member":{}},"S55":{"type":"list","member":{}},"S57":{"type":"list","member":{}},"S5c":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S5h":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5i":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{},"EmailSendingAccount":{},"From":{},"ConfigurationSet":{}}},"S5m":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{},"SnsRegion":{}}},"S5o":{"type":"map","key":{},"value":{}},"S5r":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5u":{"type":"list","member":{"shape":"S4"}},"S5v":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5x":{"type":"structure","required":["CaseSensitive"],"members":{"CaseSensitive":{"type":"boolean"}}},"S5y":{"type":"structure","members":{"RecoveryMechanisms":{"type":"list","member":{"type":"structure","required":["Priority","Name"],"members":{"Priority":{"type":"integer"},"Name":{}}}}}},"S64":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4u"},"LambdaConfig":{"shape":"S4y"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5u"},"AutoVerifiedAttributes":{"shape":"S53"},"AliasAttributes":{"shape":"S55"},"UsernameAttributes":{"shape":"S57"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S5c"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5h"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5i"},"SmsConfiguration":{"shape":"S5m"},"UserPoolTags":{"shape":"S5o"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"CustomDomain":{},"AdminCreateUserConfig":{"shape":"S5r"},"UserPoolAddOns":{"shape":"S5v"},"UsernameConfiguration":{"shape":"S5x"},"Arn":{},"AccountRecoverySetting":{"shape":"S5y"}}},"S6d":{"type":"structure","members":{"AccessToken":{},"IdToken":{},"RefreshToken":{}}},"S6f":{"type":"list","member":{}},"S6h":{"type":"list","member":{}},"S6j":{"type":"list","member":{}},"S6k":{"type":"list","member":{}},"S6m":{"type":"list","member":{}},"S6n":{"type":"list","member":{}},"S6p":{"type":"list","member":{}},"S6r":{"type":"structure","members":{"ApplicationId":{},"ApplicationArn":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S6v":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1j"},"ClientSecret":{"shape":"S6w"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"AccessTokenValidity":{"type":"integer"},"IdTokenValidity":{"type":"integer"},"TokenValidityUnits":{"shape":"S6d"},"ReadAttributes":{"shape":"S6f"},"WriteAttributes":{"shape":"S6f"},"ExplicitAuthFlows":{"shape":"S6h"},"SupportedIdentityProviders":{"shape":"S6j"},"CallbackURLs":{"shape":"S6k"},"LogoutURLs":{"shape":"S6m"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6n"},"AllowedOAuthScopes":{"shape":"S6p"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6r"},"PreventUserExistenceErrors":{},"EnableTokenRevocation":{"type":"boolean"}}},"S6w":{"type":"string","sensitive":true},"S6y":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"S7g":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CompromisedCredentialsRiskConfiguration":{"shape":"S7h"},"AccountTakeoverRiskConfiguration":{"shape":"S7m"},"RiskExceptionConfiguration":{"shape":"S7v"},"LastModifiedDate":{"type":"timestamp"}}},"S7h":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S7m":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S7o"},"NoActionEmail":{"shape":"S7o"},"MfaEmail":{"shape":"S7o"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S7s"},"MediumAction":{"shape":"S7s"},"HighAction":{"shape":"S7s"}}}}},"S7o":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S7s":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S7v":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S8e":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S8s":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S92":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5m"}}},"S93":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Sa5":{"type":"list","member":{"shape":"St"}}}}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"AdminListGroupsForUser":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"AdminListUserAuthEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthEvents"},"ListGroups":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"ListIdentityProviders":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Providers"},"ListResourceServers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceServers"},"ListUserPoolClients":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPoolClients"},"ListUserPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPools"},"ListUsers":{"input_token":"PaginationToken","limit_key":"Limit","output_token":"PaginationToken","result_key":"Users"},"ListUsersInGroup":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Users"}}}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cognitosync'] = {};
	AWS.CognitoSync = Service.defineService('cognitosync', ['2014-06-30']);
	Object.defineProperty(apiLoader.services['cognitosync'], '2014-06-30', {
	  get: function get() {
	    var model = __webpack_require__(148);
	    model.paginators = __webpack_require__(149).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CognitoSync;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-sync","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Cognito Sync","serviceId":"Cognito Sync","signatureVersion":"v4","uid":"cognito-sync-2014-06-30"},"operations":{"BulkPublish":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/bulkpublish","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolUsage":{"shape":"Sg"}}}},"DescribeIdentityUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"}}},"output":{"type":"structure","members":{"IdentityUsage":{"type":"structure","members":{"IdentityId":{},"IdentityPoolId":{},"LastModifiedDate":{"type":"timestamp"},"DatasetCount":{"type":"integer"},"DataStorage":{"type":"long"}}}}}},"GetBulkPublishDetails":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/getBulkPublishDetails","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"BulkPublishStartTime":{"type":"timestamp"},"BulkPublishCompleteTime":{"type":"timestamp"},"BulkPublishStatus":{},"FailureMessage":{}}}},"GetCognitoEvents":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"Events":{"shape":"Sq"}}}},"GetIdentityPoolConfiguration":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets","responseCode":200},"input":{"type":"structure","required":["IdentityId","IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"shape":"S8"}},"Count":{"type":"integer"},"NextToken":{}}}},"ListIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IdentityPoolUsages":{"type":"list","member":{"shape":"Sg"}},"MaxResults":{"type":"integer"},"Count":{"type":"integer"},"NextToken":{}}}},"ListRecords":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"LastSyncCount":{"location":"querystring","locationName":"lastSyncCount","type":"long"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SyncSessionToken":{"location":"querystring","locationName":"syncSessionToken"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"},"NextToken":{},"Count":{"type":"integer"},"DatasetSyncCount":{"type":"long"},"LastModifiedBy":{},"MergedDatasetNames":{"type":"list","member":{}},"DatasetExists":{"type":"boolean"},"DatasetDeletedAfterRequestedSyncCount":{"type":"boolean"},"SyncSessionToken":{}}}},"RegisterDevice":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identity/{IdentityId}/device","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","Platform","Token"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"Platform":{},"Token":{}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"SetCognitoEvents":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","Events"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"Events":{"shape":"Sq"}}}},"SetIdentityPoolConfiguration":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"SubscribeToDataset":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UnsubscribeFromDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UpdateRecords":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","SyncSessionToken"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{},"RecordPatches":{"type":"list","member":{"type":"structure","required":["Op","Key","SyncCount"],"members":{"Op":{},"Key":{},"Value":{},"SyncCount":{"type":"long"},"DeviceLastModifiedDate":{"type":"timestamp"}}}},"SyncSessionToken":{},"ClientContext":{"location":"header","locationName":"x-amz-Client-Context"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"}}}}},"shapes":{"S8":{"type":"structure","members":{"IdentityId":{},"DatasetName":{},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DataStorage":{"type":"long"},"NumRecords":{"type":"long"}}},"Sg":{"type":"structure","members":{"IdentityPoolId":{},"SyncSessionsCount":{"type":"long"},"DataStorage":{"type":"long"},"LastModifiedDate":{"type":"timestamp"}}},"Sq":{"type":"map","key":{},"value":{}},"Sv":{"type":"structure","members":{"ApplicationArns":{"type":"list","member":{}},"RoleArn":{}}},"Sz":{"type":"structure","members":{"StreamName":{},"RoleArn":{},"StreamingStatus":{}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"SyncCount":{"type":"long"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DeviceLastModifiedDate":{"type":"timestamp"}}}}}}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['configservice'] = {};
	AWS.ConfigService = Service.defineService('configservice', ['2014-11-12']);
	Object.defineProperty(apiLoader.services['configservice'], '2014-11-12', {
	  get: function get() {
	    var model = __webpack_require__(151);
	    model.paginators = __webpack_require__(152).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ConfigService;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-12","endpointPrefix":"config","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Config Service","serviceFullName":"AWS Config","serviceId":"Config Service","signatureVersion":"v4","targetPrefix":"StarlingDoveService","uid":"config-2014-11-12"},"operations":{"BatchGetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifiers"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"BaseConfigurationItems":{"shape":"Sb"},"UnprocessedResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}}},"BatchGetResourceConfig":{"input":{"type":"structure","required":["resourceKeys"],"members":{"resourceKeys":{"shape":"Sq"}}},"output":{"type":"structure","members":{"baseConfigurationItems":{"shape":"Sb"},"unprocessedResourceKeys":{"shape":"Sq"}}}},"DeleteAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{}}}},"DeleteConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}}},"DeleteConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{}}}},"DeleteConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"DeleteConformancePack":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{}}}},"DeleteDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannelName"],"members":{"DeliveryChannelName":{}}}},"DeleteEvaluationResults":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{}}},"DeleteOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{}}}},"DeleteOrganizationConformancePack":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{}}}},"DeletePendingAggregationRequest":{"input":{"type":"structure","required":["RequesterAccountId","RequesterAwsRegion"],"members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"DeleteRemediationConfiguration":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceType":{}}},"output":{"type":"structure","members":{}}},"DeleteRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1f"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S1f"}}}}}}},"DeleteResourceConfig":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}}},"DeleteRetentionConfiguration":{"input":{"type":"structure","required":["RetentionConfigurationName"],"members":{"RetentionConfigurationName":{}}}},"DeleteStoredQuery":{"input":{"type":"structure","required":["QueryName"],"members":{"QueryName":{}}},"output":{"type":"structure","members":{}}},"DeliverConfigSnapshot":{"input":{"type":"structure","required":["deliveryChannelName"],"members":{"deliveryChannelName":{}}},"output":{"type":"structure","members":{"configSnapshotId":{}}}},"DescribeAggregateComplianceByConfigRules":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{},"AccountId":{},"AwsRegion":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S23"},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"DescribeAggregateComplianceByConformancePacks":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ConformancePackName":{},"ComplianceType":{},"AccountId":{},"AwsRegion":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateComplianceByConformancePacks":{"type":"list","member":{"type":"structure","members":{"ConformancePackName":{},"Compliance":{"type":"structure","members":{"ComplianceType":{},"CompliantRuleCount":{"type":"integer"},"NonCompliantRuleCount":{"type":"integer"},"TotalRuleCount":{"type":"integer"}}},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"DescribeAggregationAuthorizations":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregationAuthorizations":{"type":"list","member":{"shape":"S2i"}},"NextToken":{}}}},"DescribeComplianceByConfigRule":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2l"},"ComplianceTypes":{"shape":"S2m"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S23"}}}},"NextToken":{}}}},"DescribeComplianceByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S2m"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByResources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Compliance":{"shape":"S23"}}}},"NextToken":{}}}},"DescribeConfigRuleEvaluationStatus":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2l"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigRulesEvaluationStatus":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"LastSuccessfulInvocationTime":{"type":"timestamp"},"LastFailedInvocationTime":{"type":"timestamp"},"LastSuccessfulEvaluationTime":{"type":"timestamp"},"LastFailedEvaluationTime":{"type":"timestamp"},"FirstActivatedTime":{"type":"timestamp"},"LastDeactivatedTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{},"FirstEvaluationStarted":{"type":"boolean"},"LastDebugLogDeliveryStatus":{},"LastDebugLogDeliveryStatusReason":{},"LastDebugLogDeliveryTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeConfigRules":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2l"},"NextToken":{}}},"output":{"type":"structure","members":{"ConfigRules":{"type":"list","member":{"shape":"S33"}},"NextToken":{}}}},"DescribeConfigurationAggregatorSourcesStatus":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"UpdateStatus":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"AggregatedSourceStatusList":{"type":"list","member":{"type":"structure","members":{"SourceId":{},"SourceType":{},"AwsRegion":{},"LastUpdateStatus":{},"LastUpdateTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{}}}},"NextToken":{}}}},"DescribeConfigurationAggregators":{"input":{"type":"structure","members":{"ConfigurationAggregatorNames":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationAggregators":{"type":"list","member":{"shape":"S3u"}},"NextToken":{}}}},"DescribeConfigurationRecorderStatus":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S42"}}},"output":{"type":"structure","members":{"ConfigurationRecordersStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"lastStartTime":{"type":"timestamp"},"lastStopTime":{"type":"timestamp"},"recording":{"type":"boolean"},"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}},"DescribeConfigurationRecorders":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S42"}}},"output":{"type":"structure","members":{"ConfigurationRecorders":{"type":"list","member":{"shape":"S4a"}}}}},"DescribeConformancePackCompliance":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"Filters":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S4h"},"ComplianceType":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackName","ConformancePackRuleComplianceList"],"members":{"ConformancePackName":{},"ConformancePackRuleComplianceList":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{},"Controls":{"type":"list","member":{}}}}},"NextToken":{}}}},"DescribeConformancePackStatus":{"input":{"type":"structure","members":{"ConformancePackNames":{"shape":"S4o"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackStatusDetails":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackId","ConformancePackArn","ConformancePackState","StackArn","LastUpdateRequestedTime"],"members":{"ConformancePackName":{},"ConformancePackId":{},"ConformancePackArn":{},"ConformancePackState":{},"StackArn":{},"ConformancePackStatusReason":{},"LastUpdateRequestedTime":{"type":"timestamp"},"LastUpdateCompletedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeConformancePacks":{"input":{"type":"structure","members":{"ConformancePackNames":{"shape":"S4o"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackDetails":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackArn","ConformancePackId"],"members":{"ConformancePackName":{},"ConformancePackArn":{},"ConformancePackId":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S54"},"LastUpdateRequestedTime":{"type":"timestamp"},"CreatedBy":{}}}},"NextToken":{}}}},"DescribeDeliveryChannelStatus":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S59"}}},"output":{"type":"structure","members":{"DeliveryChannelsStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"configSnapshotDeliveryInfo":{"shape":"S5d"},"configHistoryDeliveryInfo":{"shape":"S5d"},"configStreamDeliveryInfo":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}}}},"DescribeDeliveryChannels":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S59"}}},"output":{"type":"structure","members":{"DeliveryChannels":{"type":"list","member":{"shape":"S5j"}}}}},"DescribeOrganizationConfigRuleStatuses":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S5m"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationRuleStatus"],"members":{"OrganizationConfigRuleName":{},"OrganizationRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConfigRules":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S5m"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRules":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationConfigRuleArn"],"members":{"OrganizationConfigRuleName":{},"OrganizationConfigRuleArn":{},"OrganizationManagedRuleMetadata":{"shape":"S5w"},"OrganizationCustomRuleMetadata":{"shape":"S61"},"ExcludedAccounts":{"shape":"S64"},"LastUpdateTime":{"type":"timestamp"},"OrganizationCustomPolicyRuleMetadata":{"type":"structure","members":{"Description":{},"OrganizationConfigRuleTriggerTypes":{"shape":"S66"},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S5z"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{},"PolicyRuntime":{},"DebugLogDeliveryAccounts":{"shape":"S68"}}}}}},"NextToken":{}}}},"DescribeOrganizationConformancePackStatuses":{"input":{"type":"structure","members":{"OrganizationConformancePackNames":{"shape":"S6a"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePackStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConformancePackName","Status"],"members":{"OrganizationConformancePackName":{},"Status":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConformancePacks":{"input":{"type":"structure","members":{"OrganizationConformancePackNames":{"shape":"S6a"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePacks":{"type":"list","member":{"type":"structure","required":["OrganizationConformancePackName","OrganizationConformancePackArn","LastUpdateTime"],"members":{"OrganizationConformancePackName":{},"OrganizationConformancePackArn":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S54"},"ExcludedAccounts":{"shape":"S64"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribePendingAggregationRequests":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PendingAggregationRequests":{"type":"list","member":{"type":"structure","members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"NextToken":{}}}},"DescribeRemediationConfigurations":{"input":{"type":"structure","required":["ConfigRuleNames"],"members":{"ConfigRuleNames":{"shape":"S2l"}}},"output":{"type":"structure","members":{"RemediationConfigurations":{"shape":"S6q"}}}},"DescribeRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1f"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExceptions":{"shape":"S76"},"NextToken":{}}}},"DescribeRemediationExecutionStatus":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Sq"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExecutionStatuses":{"type":"list","member":{"type":"structure","members":{"ResourceKey":{"shape":"Sr"},"State":{},"StepDetails":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"ErrorMessage":{},"StartTime":{"type":"timestamp"},"StopTime":{"type":"timestamp"}}}},"InvocationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeRetentionConfigurations":{"input":{"type":"structure","members":{"RetentionConfigurationNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"RetentionConfigurations":{"type":"list","member":{"shape":"S7k"}},"NextToken":{}}}},"GetAggregateComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ConfigRuleName","AccountId","AwsRegion"],"members":{"ConfigurationAggregatorName":{},"ConfigRuleName":{},"AccountId":{},"AwsRegion":{},"ComplianceType":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateEvaluationResults":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S7q"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"GetAggregateConfigRuleComplianceSummary":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"AccountId":{},"AwsRegion":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GroupByKey":{},"AggregateComplianceCounts":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"ComplianceSummary":{"shape":"S7y"}}}},"NextToken":{}}}},"GetAggregateConformancePackComplianceSummary":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"AccountId":{},"AwsRegion":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateConformancePackComplianceSummaries":{"type":"list","member":{"type":"structure","members":{"ComplianceSummary":{"type":"structure","members":{"CompliantConformancePackCount":{"type":"integer"},"NonCompliantConformancePackCount":{"type":"integer"}}},"GroupName":{}}}},"GroupByKey":{},"NextToken":{}}}},"GetAggregateDiscoveredResourceCounts":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ResourceType":{},"AccountId":{},"Region":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["TotalDiscoveredResources"],"members":{"TotalDiscoveredResources":{"type":"long"},"GroupByKey":{},"GroupedResourceCounts":{"type":"list","member":{"type":"structure","required":["GroupName","ResourceCount"],"members":{"GroupName":{},"ResourceCount":{"type":"long"}}}},"NextToken":{}}}},"GetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifier"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifier":{"shape":"S4"}}},"output":{"type":"structure","members":{"ConfigurationItem":{"shape":"S8f"}}}},"GetComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ComplianceTypes":{"shape":"S2m"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S8r"},"NextToken":{}}}},"GetComplianceDetailsByResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S2m"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S8r"},"NextToken":{}}}},"GetComplianceSummaryByConfigRule":{"output":{"type":"structure","members":{"ComplianceSummary":{"shape":"S7y"}}}},"GetComplianceSummaryByResourceType":{"input":{"type":"structure","members":{"ResourceTypes":{"shape":"S8x"}}},"output":{"type":"structure","members":{"ComplianceSummariesByResourceType":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ComplianceSummary":{"shape":"S7y"}}}}}}},"GetConformancePackComplianceDetails":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"Filters":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S4h"},"ComplianceType":{},"ResourceType":{},"ResourceIds":{"type":"list","member":{}}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"ConformancePackRuleEvaluationResults":{"type":"list","member":{"type":"structure","required":["ComplianceType","EvaluationResultIdentifier","ConfigRuleInvokedTime","ResultRecordedTime"],"members":{"ComplianceType":{},"EvaluationResultIdentifier":{"shape":"S7q"},"ConfigRuleInvokedTime":{"type":"timestamp"},"ResultRecordedTime":{"type":"timestamp"},"Annotation":{}}}},"NextToken":{}}}},"GetConformancePackComplianceSummary":{"input":{"type":"structure","required":["ConformancePackNames"],"members":{"ConformancePackNames":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackComplianceSummaryList":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackComplianceStatus"],"members":{"ConformancePackName":{},"ConformancePackComplianceStatus":{}}}},"NextToken":{}}}},"GetCustomRulePolicy":{"input":{"type":"structure","members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{"PolicyText":{}}}},"GetDiscoveredResourceCounts":{"input":{"type":"structure","members":{"resourceTypes":{"shape":"S8x"},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"totalDiscoveredResources":{"type":"long"},"resourceCounts":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"count":{"type":"long"}}}},"nextToken":{}}}},"GetOrganizationConfigRuleDetailedStatus":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"Filters":{"type":"structure","members":{"AccountId":{},"MemberAccountRuleStatus":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleDetailedStatus":{"type":"list","member":{"type":"structure","required":["AccountId","ConfigRuleName","MemberAccountRuleStatus"],"members":{"AccountId":{},"ConfigRuleName":{},"MemberAccountRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetOrganizationConformancePackDetailedStatus":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{},"Filters":{"type":"structure","members":{"AccountId":{},"Status":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePackDetailedStatuses":{"type":"list","member":{"type":"structure","required":["AccountId","ConformancePackName","Status"],"members":{"AccountId":{},"ConformancePackName":{},"Status":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetOrganizationCustomRulePolicy":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{}}},"output":{"type":"structure","members":{"PolicyText":{}}}},"GetResourceConfigHistory":{"input":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{},"laterTime":{"type":"timestamp"},"earlierTime":{"type":"timestamp"},"chronologicalOrder":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"configurationItems":{"type":"list","member":{"shape":"S8f"}},"nextToken":{}}}},"GetStoredQuery":{"input":{"type":"structure","required":["QueryName"],"members":{"QueryName":{}}},"output":{"type":"structure","members":{"StoredQuery":{"shape":"Sa6"}}}},"ListAggregateDiscoveredResources":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceType"],"members":{"ConfigurationAggregatorName":{},"ResourceType":{},"Filters":{"type":"structure","members":{"AccountId":{},"ResourceId":{},"ResourceName":{},"Region":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"resourceIds":{"type":"list","member":{}},"resourceName":{},"limit":{"type":"integer"},"includeDeletedResources":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","members":{"resourceIdentifiers":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"resourceDeletionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListStoredQueries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"StoredQueryMetadata":{"type":"list","member":{"type":"structure","required":["QueryId","QueryArn","QueryName"],"members":{"QueryId":{},"QueryArn":{},"QueryName":{},"Description":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sas"},"NextToken":{}}}},"PutAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"Tags":{"shape":"Sax"}}},"output":{"type":"structure","members":{"AggregationAuthorization":{"shape":"S2i"}}}},"PutConfigRule":{"input":{"type":"structure","required":["ConfigRule"],"members":{"ConfigRule":{"shape":"S33"},"Tags":{"shape":"Sax"}}}},"PutConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"AccountAggregationSources":{"shape":"S3w"},"OrganizationAggregationSource":{"shape":"S40"},"Tags":{"shape":"Sax"}}},"output":{"type":"structure","members":{"ConfigurationAggregator":{"shape":"S3u"}}}},"PutConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorder"],"members":{"ConfigurationRecorder":{"shape":"S4a"}}}},"PutConformancePack":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"TemplateS3Uri":{},"TemplateBody":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S54"}}},"output":{"type":"structure","members":{"ConformancePackArn":{}}}},"PutDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannel"],"members":{"DeliveryChannel":{"shape":"S5j"}}}},"PutEvaluations":{"input":{"type":"structure","required":["ResultToken"],"members":{"Evaluations":{"shape":"Sb9"},"ResultToken":{},"TestMode":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEvaluations":{"shape":"Sb9"}}}},"PutExternalEvaluation":{"input":{"type":"structure","required":["ConfigRuleName","ExternalEvaluation"],"members":{"ConfigRuleName":{},"ExternalEvaluation":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{}}},"PutOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"OrganizationManagedRuleMetadata":{"shape":"S5w"},"OrganizationCustomRuleMetadata":{"shape":"S61"},"ExcludedAccounts":{"shape":"S64"},"OrganizationCustomPolicyRuleMetadata":{"type":"structure","required":["PolicyRuntime","PolicyText"],"members":{"Description":{},"OrganizationConfigRuleTriggerTypes":{"shape":"S66"},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S5z"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{},"PolicyRuntime":{},"PolicyText":{},"DebugLogDeliveryAccounts":{"shape":"S68"}}}}},"output":{"type":"structure","members":{"OrganizationConfigRuleArn":{}}}},"PutOrganizationConformancePack":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{},"TemplateS3Uri":{},"TemplateBody":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S54"},"ExcludedAccounts":{"shape":"S64"}}},"output":{"type":"structure","members":{"OrganizationConformancePackArn":{}}}},"PutRemediationConfigurations":{"input":{"type":"structure","required":["RemediationConfigurations"],"members":{"RemediationConfigurations":{"shape":"S6q"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S6q"}}}}}}},"PutRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1f"},"Message":{},"ExpirationTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S76"}}}}}}},"PutResourceConfig":{"input":{"type":"structure","required":["ResourceType","SchemaVersionId","ResourceId","Configuration"],"members":{"ResourceType":{},"SchemaVersionId":{},"ResourceId":{},"ResourceName":{},"Configuration":{},"Tags":{"shape":"S8h"}}}},"PutRetentionConfiguration":{"input":{"type":"structure","required":["RetentionPeriodInDays"],"members":{"RetentionPeriodInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"RetentionConfiguration":{"shape":"S7k"}}}},"PutStoredQuery":{"input":{"type":"structure","required":["StoredQuery"],"members":{"StoredQuery":{"shape":"Sa6"},"Tags":{"shape":"Sax"}}},"output":{"type":"structure","members":{"QueryArn":{}}}},"SelectAggregateResourceConfig":{"input":{"type":"structure","required":["Expression","ConfigurationAggregatorName"],"members":{"Expression":{},"ConfigurationAggregatorName":{},"Limit":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"shape":"Sc2"},"QueryInfo":{"shape":"Sc3"},"NextToken":{}}}},"SelectResourceConfig":{"input":{"type":"structure","required":["Expression"],"members":{"Expression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"shape":"Sc2"},"QueryInfo":{"shape":"Sc3"},"NextToken":{}}}},"StartConfigRulesEvaluation":{"input":{"type":"structure","members":{"ConfigRuleNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"StartRemediationExecution":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Sq"}}},"output":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"Sq"}}}},"StopConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sas"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}}},"shapes":{"S4":{"type":"structure","required":["SourceAccountId","SourceRegion","ResourceId","ResourceType"],"members":{"SourceAccountId":{},"SourceRegion":{},"ResourceId":{},"ResourceType":{},"ResourceName":{}}},"Sb":{"type":"list","member":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"}}}},"Sl":{"type":"map","key":{},"value":{}},"Sq":{"type":"list","member":{"shape":"Sr"}},"Sr":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{}}},"S1f":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{}}}},"S23":{"type":"structure","members":{"ComplianceType":{},"ComplianceContributorCount":{"shape":"S24"}}},"S24":{"type":"structure","members":{"CappedCount":{"type":"integer"},"CapExceeded":{"type":"boolean"}}},"S2i":{"type":"structure","members":{"AggregationAuthorizationArn":{},"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"CreationTime":{"type":"timestamp"}}},"S2l":{"type":"list","member":{}},"S2m":{"type":"list","member":{}},"S33":{"type":"structure","required":["Source"],"members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"Description":{},"Scope":{"type":"structure","members":{"ComplianceResourceTypes":{"type":"list","member":{}},"TagKey":{},"TagValue":{},"ComplianceResourceId":{}}},"Source":{"type":"structure","required":["Owner"],"members":{"Owner":{},"SourceIdentifier":{},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"EventSource":{},"MessageType":{},"MaximumExecutionFrequency":{}}}},"CustomPolicyDetails":{"type":"structure","required":["PolicyRuntime","PolicyText"],"members":{"PolicyRuntime":{},"PolicyText":{},"EnableDebugLogDelivery":{"type":"boolean"}}}}},"InputParameters":{},"MaximumExecutionFrequency":{},"ConfigRuleState":{},"CreatedBy":{}}},"S3u":{"type":"structure","members":{"ConfigurationAggregatorName":{},"ConfigurationAggregatorArn":{},"AccountAggregationSources":{"shape":"S3w"},"OrganizationAggregationSource":{"shape":"S40"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"CreatedBy":{}}},"S3w":{"type":"list","member":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"type":"list","member":{}},"AllAwsRegions":{"type":"boolean"},"AwsRegions":{"shape":"S3z"}}}},"S3z":{"type":"list","member":{}},"S40":{"type":"structure","required":["RoleArn"],"members":{"RoleArn":{},"AwsRegions":{"shape":"S3z"},"AllAwsRegions":{"type":"boolean"}}},"S42":{"type":"list","member":{}},"S4a":{"type":"structure","members":{"name":{},"roleARN":{},"recordingGroup":{"type":"structure","members":{"allSupported":{"type":"boolean"},"includeGlobalResourceTypes":{"type":"boolean"},"resourceTypes":{"type":"list","member":{}}}}}},"S4h":{"type":"list","member":{}},"S4o":{"type":"list","member":{}},"S54":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}},"S59":{"type":"list","member":{}},"S5d":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastAttemptTime":{"type":"timestamp"},"lastSuccessfulTime":{"type":"timestamp"},"nextDeliveryTime":{"type":"timestamp"}}},"S5j":{"type":"structure","members":{"name":{},"s3BucketName":{},"s3KeyPrefix":{},"s3KmsKeyArn":{},"snsTopicARN":{},"configSnapshotDeliveryProperties":{"type":"structure","members":{"deliveryFrequency":{}}}}},"S5m":{"type":"list","member":{}},"S5w":{"type":"structure","required":["RuleIdentifier"],"members":{"Description":{},"RuleIdentifier":{},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S5z"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S5z":{"type":"list","member":{}},"S61":{"type":"structure","required":["LambdaFunctionArn","OrganizationConfigRuleTriggerTypes"],"members":{"Description":{},"LambdaFunctionArn":{},"OrganizationConfigRuleTriggerTypes":{"type":"list","member":{}},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S5z"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S64":{"type":"list","member":{}},"S66":{"type":"list","member":{}},"S68":{"type":"list","member":{}},"S6a":{"type":"list","member":{}},"S6q":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","TargetType","TargetId"],"members":{"ConfigRuleName":{},"TargetType":{},"TargetId":{},"TargetVersion":{},"Parameters":{"type":"map","key":{},"value":{"type":"structure","members":{"ResourceValue":{"type":"structure","required":["Value"],"members":{"Value":{}}},"StaticValue":{"type":"structure","required":["Values"],"members":{"Values":{"type":"list","member":{}}}}}}},"ResourceType":{},"Automatic":{"type":"boolean"},"ExecutionControls":{"type":"structure","members":{"SsmControls":{"type":"structure","members":{"ConcurrentExecutionRatePercentage":{"type":"integer"},"ErrorPercentage":{"type":"integer"}}}}},"MaximumAutomaticAttempts":{"type":"integer"},"RetryAttemptSeconds":{"type":"long"},"Arn":{},"CreatedByService":{}}}},"S76":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","ResourceType","ResourceId"],"members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{},"Message":{},"ExpirationTime":{"type":"timestamp"}}}},"S7k":{"type":"structure","required":["Name","RetentionPeriodInDays"],"members":{"Name":{},"RetentionPeriodInDays":{"type":"integer"}}},"S7q":{"type":"structure","members":{"EvaluationResultQualifier":{"type":"structure","members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{}}},"OrderingTimestamp":{"type":"timestamp"}}},"S7y":{"type":"structure","members":{"CompliantResourceCount":{"shape":"S24"},"NonCompliantResourceCount":{"shape":"S24"},"ComplianceSummaryTimestamp":{"type":"timestamp"}}},"S8f":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"configurationItemMD5Hash":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"tags":{"shape":"S8h"},"relatedEvents":{"type":"list","member":{}},"relationships":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"relationshipName":{}}}},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"}}},"S8h":{"type":"map","key":{},"value":{}},"S8r":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S7q"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"ResultToken":{}}}},"S8x":{"type":"list","member":{}},"Sa6":{"type":"structure","required":["QueryName"],"members":{"QueryId":{},"QueryArn":{},"QueryName":{},"Description":{},"Expression":{}}},"Sas":{"type":"list","member":{"shape":"Sat"}},"Sat":{"type":"structure","members":{"Key":{},"Value":{}}},"Sax":{"type":"list","member":{"shape":"Sat"}},"Sb9":{"type":"list","member":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}},"Sc2":{"type":"list","member":{}},"Sc3":{"type":"structure","members":{"SelectFields":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}}}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAggregateComplianceByConfigRules":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeAggregateComplianceByConformancePacks":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregateComplianceByConformancePacks"},"DescribeAggregationAuthorizations":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregationAuthorizations"},"DescribeComplianceByConfigRule":{"input_token":"NextToken","output_token":"NextToken","result_key":"ComplianceByConfigRules"},"DescribeComplianceByResource":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ComplianceByResources"},"DescribeConfigRuleEvaluationStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConfigRulesEvaluationStatus"},"DescribeConfigRules":{"input_token":"NextToken","output_token":"NextToken","result_key":"ConfigRules"},"DescribeConfigurationAggregatorSourcesStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregatedSourceStatusList"},"DescribeConfigurationAggregators":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConfigurationAggregators"},"DescribeConformancePackCompliance":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeConformancePackStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConformancePackStatusDetails"},"DescribeConformancePacks":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConformancePackDetails"},"DescribeOrganizationConfigRuleStatuses":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConfigRuleStatuses"},"DescribeOrganizationConfigRules":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConfigRules"},"DescribeOrganizationConformancePackStatuses":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConformancePackStatuses"},"DescribeOrganizationConformancePacks":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConformancePacks"},"DescribePendingAggregationRequests":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"PendingAggregationRequests"},"DescribeRemediationExceptions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeRemediationExecutionStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"RemediationExecutionStatuses"},"DescribeRetentionConfigurations":{"input_token":"NextToken","output_token":"NextToken","result_key":"RetentionConfigurations"},"GetAggregateComplianceDetailsByConfigRule":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregateEvaluationResults"},"GetAggregateConfigRuleComplianceSummary":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetAggregateConformancePackComplianceSummary":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetAggregateDiscoveredResourceCounts":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetComplianceDetailsByConfigRule":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"EvaluationResults"},"GetComplianceDetailsByResource":{"input_token":"NextToken","output_token":"NextToken","result_key":"EvaluationResults"},"GetConformancePackComplianceDetails":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetConformancePackComplianceSummary":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConformancePackComplianceSummaryList"},"GetDiscoveredResourceCounts":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken"},"GetOrganizationConfigRuleDetailedStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConfigRuleDetailedStatus"},"GetOrganizationConformancePackDetailedStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConformancePackDetailedStatuses"},"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"},"ListAggregateDiscoveredResources":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ResourceIdentifiers"},"ListDiscoveredResources":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"resourceIdentifiers"},"ListStoredQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Tags"},"SelectAggregateResourceConfig":{"input_token":"NextToken","limit_key":"Limit","non_aggregate_keys":["QueryInfo"],"output_token":"NextToken","result_key":"Results"},"SelectResourceConfig":{"input_token":"NextToken","limit_key":"Limit","non_aggregate_keys":["QueryInfo"],"output_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cur'] = {};
	AWS.CUR = Service.defineService('cur', ['2017-01-06']);
	Object.defineProperty(apiLoader.services['cur'], '2017-01-06', {
	  get: function get() {
	    var model = __webpack_require__(154);
	    model.paginators = __webpack_require__(155).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CUR;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-06","endpointPrefix":"cur","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cost and Usage Report Service","serviceId":"Cost and Usage Report Service","signatureVersion":"v4","signingName":"cur","targetPrefix":"AWSOrigamiServiceGatewayService","uid":"cur-2017-01-06"},"operations":{"DeleteReportDefinition":{"input":{"type":"structure","members":{"ReportName":{}}},"output":{"type":"structure","members":{"ResponseMessage":{}}}},"DescribeReportDefinitions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ReportDefinitions":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"ModifyReportDefinition":{"input":{"type":"structure","required":["ReportName","ReportDefinition"],"members":{"ReportName":{},"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"PutReportDefinition":{"input":{"type":"structure","required":["ReportDefinition"],"members":{"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","required":["ReportName","TimeUnit","Format","Compression","AdditionalSchemaElements","S3Bucket","S3Prefix","S3Region"],"members":{"ReportName":{},"TimeUnit":{},"Format":{},"Compression":{},"AdditionalSchemaElements":{"type":"list","member":{}},"S3Bucket":{},"S3Prefix":{},"S3Region":{},"AdditionalArtifacts":{"type":"list","member":{}},"RefreshClosedReports":{"type":"boolean"},"ReportVersioning":{},"BillingViewArn":{}}}}}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeReportDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['datapipeline'] = {};
	AWS.DataPipeline = Service.defineService('datapipeline', ['2012-10-29']);
	Object.defineProperty(apiLoader.services['datapipeline'], '2012-10-29', {
	  get: function get() {
	    var model = __webpack_require__(157);
	    model.paginators = __webpack_require__(158).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DataPipeline;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-10-29","endpointPrefix":"datapipeline","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Data Pipeline","serviceId":"Data Pipeline","signatureVersion":"v4","targetPrefix":"DataPipeline","uid":"datapipeline-2012-10-29"},"operations":{"ActivatePipeline":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{},"parameterValues":{"shape":"S3"},"startTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"AddTags":{"input":{"type":"structure","required":["pipelineId","tags"],"members":{"pipelineId":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"CreatePipeline":{"input":{"type":"structure","required":["name","uniqueId"],"members":{"name":{},"uniqueId":{},"description":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{}}}},"DeactivatePipeline":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{},"cancelActive":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeletePipeline":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{}}}},"DescribeObjects":{"input":{"type":"structure","required":["pipelineId","objectIds"],"members":{"pipelineId":{},"objectIds":{"shape":"Sn"},"evaluateExpressions":{"type":"boolean"},"marker":{}}},"output":{"type":"structure","required":["pipelineObjects"],"members":{"pipelineObjects":{"shape":"Sq"},"marker":{},"hasMoreResults":{"type":"boolean"}}}},"DescribePipelines":{"input":{"type":"structure","required":["pipelineIds"],"members":{"pipelineIds":{"shape":"Sn"}}},"output":{"type":"structure","required":["pipelineDescriptionList"],"members":{"pipelineDescriptionList":{"type":"list","member":{"type":"structure","required":["pipelineId","name","fields"],"members":{"pipelineId":{},"name":{},"fields":{"shape":"Ss"},"description":{},"tags":{"shape":"Sa"}}}}}}},"EvaluateExpression":{"input":{"type":"structure","required":["pipelineId","objectId","expression"],"members":{"pipelineId":{},"objectId":{},"expression":{}}},"output":{"type":"structure","required":["evaluatedExpression"],"members":{"evaluatedExpression":{}}}},"GetPipelineDefinition":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{},"version":{}}},"output":{"type":"structure","members":{"pipelineObjects":{"shape":"Sq"},"parameterObjects":{"shape":"S13"},"parameterValues":{"shape":"S3"}}}},"ListPipelines":{"input":{"type":"structure","members":{"marker":{}}},"output":{"type":"structure","required":["pipelineIdList"],"members":{"pipelineIdList":{"type":"list","member":{"type":"structure","members":{"id":{},"name":{}}}},"marker":{},"hasMoreResults":{"type":"boolean"}}}},"PollForTask":{"input":{"type":"structure","required":["workerGroup"],"members":{"workerGroup":{},"hostname":{},"instanceIdentity":{"type":"structure","members":{"document":{},"signature":{}}}}},"output":{"type":"structure","members":{"taskObject":{"type":"structure","members":{"taskId":{},"pipelineId":{},"attemptId":{},"objects":{"type":"map","key":{},"value":{"shape":"Sr"}}}}}}},"PutPipelineDefinition":{"input":{"type":"structure","required":["pipelineId","pipelineObjects"],"members":{"pipelineId":{},"pipelineObjects":{"shape":"Sq"},"parameterObjects":{"shape":"S13"},"parameterValues":{"shape":"S3"}}},"output":{"type":"structure","required":["errored"],"members":{"validationErrors":{"shape":"S1l"},"validationWarnings":{"shape":"S1p"},"errored":{"type":"boolean"}}}},"QueryObjects":{"input":{"type":"structure","required":["pipelineId","sphere"],"members":{"pipelineId":{},"query":{"type":"structure","members":{"selectors":{"type":"list","member":{"type":"structure","members":{"fieldName":{},"operator":{"type":"structure","members":{"type":{},"values":{"shape":"S1x"}}}}}}}},"sphere":{},"marker":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ids":{"shape":"Sn"},"marker":{},"hasMoreResults":{"type":"boolean"}}}},"RemoveTags":{"input":{"type":"structure","required":["pipelineId","tagKeys"],"members":{"pipelineId":{},"tagKeys":{"shape":"S1x"}}},"output":{"type":"structure","members":{}}},"ReportTaskProgress":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{},"fields":{"shape":"Ss"}}},"output":{"type":"structure","required":["canceled"],"members":{"canceled":{"type":"boolean"}}}},"ReportTaskRunnerHeartbeat":{"input":{"type":"structure","required":["taskrunnerId"],"members":{"taskrunnerId":{},"workerGroup":{},"hostname":{}}},"output":{"type":"structure","required":["terminate"],"members":{"terminate":{"type":"boolean"}}}},"SetStatus":{"input":{"type":"structure","required":["pipelineId","objectIds","status"],"members":{"pipelineId":{},"objectIds":{"shape":"Sn"},"status":{}}}},"SetTaskStatus":{"input":{"type":"structure","required":["taskId","taskStatus"],"members":{"taskId":{},"taskStatus":{},"errorId":{},"errorMessage":{},"errorStackTrace":{}}},"output":{"type":"structure","members":{}}},"ValidatePipelineDefinition":{"input":{"type":"structure","required":["pipelineId","pipelineObjects"],"members":{"pipelineId":{},"pipelineObjects":{"shape":"Sq"},"parameterObjects":{"shape":"S13"},"parameterValues":{"shape":"S3"}}},"output":{"type":"structure","required":["errored"],"members":{"validationErrors":{"shape":"S1l"},"validationWarnings":{"shape":"S1p"},"errored":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["id","stringValue"],"members":{"id":{},"stringValue":{}}}},"Sa":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sn":{"type":"list","member":{}},"Sq":{"type":"list","member":{"shape":"Sr"}},"Sr":{"type":"structure","required":["id","name","fields"],"members":{"id":{},"name":{},"fields":{"shape":"Ss"}}},"Ss":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"stringValue":{},"refValue":{}}}},"S13":{"type":"list","member":{"type":"structure","required":["id","attributes"],"members":{"id":{},"attributes":{"type":"list","member":{"type":"structure","required":["key","stringValue"],"members":{"key":{},"stringValue":{}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"id":{},"errors":{"shape":"S1n"}}}},"S1n":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"id":{},"warnings":{"shape":"S1n"}}}},"S1x":{"type":"list","member":{}}}}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeObjects":{"input_token":"marker","more_results":"hasMoreResults","output_token":"marker","result_key":"pipelineObjects"},"DescribePipelines":{"result_key":"pipelineDescriptionList"},"ListPipelines":{"input_token":"marker","more_results":"hasMoreResults","output_token":"marker","result_key":"pipelineIdList"},"QueryObjects":{"input_token":"marker","limit_key":"limit","more_results":"hasMoreResults","output_token":"marker","result_key":"ids"}}}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['devicefarm'] = {};
	AWS.DeviceFarm = Service.defineService('devicefarm', ['2015-06-23']);
	Object.defineProperty(apiLoader.services['devicefarm'], '2015-06-23', {
	  get: function get() {
	    var model = __webpack_require__(160);
	    model.paginators = __webpack_require__(161).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DeviceFarm;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-06-23","endpointPrefix":"devicefarm","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Device Farm","serviceId":"Device Farm","signatureVersion":"v4","targetPrefix":"DeviceFarm_20150623","uid":"devicefarm-2015-06-23"},"operations":{"CreateDevicePool":{"input":{"type":"structure","required":["projectArn","name","rules"],"members":{"projectArn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["projectArn","name"],"members":{"projectArn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"CreateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"CreateRemoteAccessSession":{"input":{"type":"structure","required":["projectArn","deviceArn"],"members":{"projectArn":{},"deviceArn":{},"instanceArn":{},"sshPublicKey":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"name":{},"clientId":{},"configuration":{"type":"structure","members":{"billingMethod":{},"vpceConfigurationArns":{"shape":"Sz"}}},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"CreateTestGridProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"vpcConfig":{"shape":"S1m"}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1r"}}}},"CreateTestGridUrl":{"input":{"type":"structure","required":["projectArn","expiresInSeconds"],"members":{"projectArn":{},"expiresInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"url":{"shape":"S1w"},"expires":{"type":"timestamp"}}}},"CreateUpload":{"input":{"type":"structure","required":["projectArn","name","type"],"members":{"projectArn":{},"name":{},"type":{},"contentType":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S21"}}}},"CreateVPCEConfiguration":{"input":{"type":"structure","required":["vpceConfigurationName","vpceServiceName","serviceDnsName"],"members":{"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S2c"}}}},"DeleteDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{}}},"output":{"type":"structure","members":{}}},"DeleteUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"type":"structure","members":{"awsAccountNumber":{},"unmeteredDevices":{"shape":"S2z"},"unmeteredRemoteAccessDevices":{"shape":"S2z"},"maxJobTimeoutMinutes":{"type":"integer"},"trialMinutes":{"type":"structure","members":{"total":{"type":"double"},"remaining":{"type":"double"}}},"maxSlots":{"type":"map","key":{},"value":{"type":"integer"}},"defaultJobTimeoutMinutes":{"type":"integer"},"skipAppResign":{"type":"boolean"}}}}}},"GetDevice":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"device":{"shape":"S15"}}}},"GetDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1c"}}}},"GetDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"GetDevicePoolCompatibility":{"input":{"type":"structure","required":["devicePoolArn"],"members":{"devicePoolArn":{},"appArn":{},"testType":{},"test":{"shape":"S3a"},"configuration":{"shape":"S3d"}}},"output":{"type":"structure","members":{"compatibleDevices":{"shape":"S3l"},"incompatibleDevices":{"shape":"S3l"}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"GetJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3t"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"GetOfferingStatus":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"current":{"shape":"S41"},"nextPeriod":{"shape":"S41"},"nextToken":{}}}},"GetProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"GetRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"GetRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S4i"}}}},"GetSuite":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"suite":{"shape":"S4r"}}}},"GetTest":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"test":{"shape":"S4u"}}}},"GetTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1r"}}}},"GetTestGridSession":{"input":{"type":"structure","members":{"projectArn":{},"sessionId":{},"sessionArn":{}}},"output":{"type":"structure","members":{"testGridSession":{"shape":"S50"}}}},"GetUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S21"}}}},"GetVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S2c"}}}},"InstallToRemoteAccessSession":{"input":{"type":"structure","required":["remoteAccessSessionArn","appArn"],"members":{"remoteAccessSessionArn":{},"appArn":{}}},"output":{"type":"structure","members":{"appUpload":{"shape":"S21"}}}},"ListArtifacts":{"input":{"type":"structure","required":["arn","type"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"extension":{},"url":{}}}},"nextToken":{}}}},"ListDeviceInstances":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"deviceInstances":{"shape":"S1b"},"nextToken":{}}}},"ListDevicePools":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"devicePools":{"type":"list","member":{"shape":"Sc"}},"nextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"arn":{},"nextToken":{},"filters":{"shape":"S4l"}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"shape":"S15"}},"nextToken":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceProfiles":{"type":"list","member":{"shape":"Si"}},"nextToken":{}}}},"ListJobs":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"shape":"S3t"}},"nextToken":{}}}},"ListNetworkProfiles":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"networkProfiles":{"type":"list","member":{"shape":"So"}},"nextToken":{}}}},"ListOfferingPromotions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringPromotions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{}}}},"nextToken":{}}}},"ListOfferingTransactions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringTransactions":{"type":"list","member":{"shape":"S64"}},"nextToken":{}}}},"ListOfferings":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offerings":{"type":"list","member":{"shape":"S45"}},"nextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"Ss"}},"nextToken":{}}}},"ListRemoteAccessSessions":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"remoteAccessSessions":{"type":"list","member":{"shape":"S12"}},"nextToken":{}}}},"ListRuns":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"runs":{"type":"list","member":{"shape":"S4i"}},"nextToken":{}}}},"ListSamples":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"samples":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListSuites":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"suites":{"type":"list","member":{"shape":"S4r"}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6s"}}}},"ListTestGridProjects":{"input":{"type":"structure","members":{"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"testGridProjects":{"type":"list","member":{"shape":"S1r"}},"nextToken":{}}}},"ListTestGridSessionActions":{"input":{"type":"structure","required":["sessionArn"],"members":{"sessionArn":{},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actions":{"type":"list","member":{"type":"structure","members":{"action":{},"started":{"type":"timestamp"},"duration":{"type":"long"},"statusCode":{},"requestMethod":{}}}},"nextToken":{}}}},"ListTestGridSessionArtifacts":{"input":{"type":"structure","required":["sessionArn"],"members":{"sessionArn":{},"type":{},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"filename":{},"type":{},"url":{"shape":"S1w"}}}},"nextToken":{}}}},"ListTestGridSessions":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{},"status":{},"creationTimeAfter":{"type":"timestamp"},"creationTimeBefore":{"type":"timestamp"},"endTimeAfter":{"type":"timestamp"},"endTimeBefore":{"type":"timestamp"},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"testGridSessions":{"type":"list","member":{"shape":"S50"}},"nextToken":{}}}},"ListTests":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tests":{"type":"list","member":{"shape":"S4u"}},"nextToken":{}}}},"ListUniqueProblems":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uniqueProblems":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"message":{},"problems":{"type":"list","member":{"type":"structure","members":{"run":{"shape":"S7n"},"job":{"shape":"S7n"},"suite":{"shape":"S7n"},"test":{"shape":"S7n"},"device":{"shape":"S15"},"result":{},"message":{}}}}}}}},"nextToken":{}}}},"ListUploads":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"uploads":{"type":"list","member":{"shape":"S21"}},"nextToken":{}}}},"ListVPCEConfigurations":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"vpceConfigurations":{"type":"list","member":{"shape":"S2c"}},"nextToken":{}}}},"PurchaseOffering":{"input":{"type":"structure","required":["offeringId","quantity"],"members":{"offeringId":{},"quantity":{"type":"integer"},"offeringPromotionId":{}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S64"}}}},"RenewOffering":{"input":{"type":"structure","required":["offeringId","quantity"],"members":{"offeringId":{},"quantity":{"type":"integer"}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S64"}}}},"ScheduleRun":{"input":{"type":"structure","required":["projectArn","test"],"members":{"projectArn":{},"appArn":{},"devicePoolArn":{},"deviceSelectionConfiguration":{"type":"structure","required":["filters","maxDevices"],"members":{"filters":{"shape":"S4l"},"maxDevices":{"type":"integer"}}},"name":{},"test":{"shape":"S3a"},"configuration":{"shape":"S3d"},"executionConfiguration":{"type":"structure","members":{"jobTimeoutMinutes":{"type":"integer"},"accountsCleanup":{"type":"boolean"},"appPackagesCleanup":{"type":"boolean"},"videoCapture":{"type":"boolean"},"skipAppResign":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"run":{"shape":"S4i"}}}},"StopJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3t"}}}},"StopRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"StopRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S4i"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S6s"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"profileArn":{},"labels":{"shape":"S1d"}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1c"}}}},"UpdateDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"},"clearMaxDevices":{"type":"boolean"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"UpdateInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"UpdateProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"UpdateTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{},"name":{},"description":{},"vpcConfig":{"shape":"S1m"}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1r"}}}},"UpdateUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"contentType":{},"editContent":{"type":"boolean"}}},"output":{"type":"structure","members":{"upload":{"shape":"S21"}}}},"UpdateVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S2c"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"value":{}}}},"Sc":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"Sg":{"type":"list","member":{}},"Si":{"type":"structure","members":{"arn":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"},"name":{},"description":{}}},"So":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"Ss":{"type":"structure","members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"created":{"type":"timestamp"}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"status":{},"result":{},"message":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"device":{"shape":"S15"},"instanceArn":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"hostAddress":{},"clientId":{},"billingMethod":{},"deviceMinutes":{"shape":"S1h"},"endpoint":{},"deviceUdid":{},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"S15":{"type":"structure","members":{"arn":{},"name":{},"manufacturer":{},"model":{},"modelId":{},"formFactor":{},"platform":{},"os":{},"cpu":{"type":"structure","members":{"frequency":{},"architecture":{},"clock":{"type":"double"}}},"resolution":{"type":"structure","members":{"width":{"type":"integer"},"height":{"type":"integer"}}},"heapSize":{"type":"long"},"memory":{"type":"long"},"image":{},"carrier":{},"radio":{},"remoteAccessEnabled":{"type":"boolean"},"remoteDebugEnabled":{"type":"boolean"},"fleetType":{},"fleetName":{},"instances":{"shape":"S1b"},"availability":{}}},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","members":{"arn":{},"deviceArn":{},"labels":{"shape":"S1d"},"status":{},"udid":{},"instanceProfile":{"shape":"Si"}}},"S1d":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"total":{"type":"double"},"metered":{"type":"double"},"unmetered":{"type":"double"}}},"S1m":{"type":"structure","required":["securityGroupIds","subnetIds","vpcId"],"members":{"securityGroupIds":{"type":"list","member":{}},"subnetIds":{"type":"list","member":{}},"vpcId":{}}},"S1r":{"type":"structure","members":{"arn":{},"name":{},"description":{},"vpcConfig":{"shape":"S1m"},"created":{"type":"timestamp"}}},"S1w":{"type":"string","sensitive":true},"S21":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"type":{},"status":{},"url":{"type":"string","sensitive":true},"metadata":{},"contentType":{},"message":{},"category":{}}},"S2c":{"type":"structure","members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"S2z":{"type":"map","key":{},"value":{"type":"integer"}},"S3a":{"type":"structure","required":["type"],"members":{"type":{},"testPackageArn":{},"testSpecArn":{},"filter":{},"parameters":{"type":"map","key":{},"value":{}}}},"S3d":{"type":"structure","members":{"extraDataPackageArn":{},"networkProfileArn":{},"locale":{},"location":{"shape":"S3e"},"vpceConfigurationArns":{"shape":"Sz"},"customerArtifactPaths":{"shape":"S3f"},"radios":{"shape":"S3j"},"auxiliaryApps":{"shape":"Sz"},"billingMethod":{}}},"S3e":{"type":"structure","required":["latitude","longitude"],"members":{"latitude":{"type":"double"},"longitude":{"type":"double"}}},"S3f":{"type":"structure","members":{"iosPaths":{"type":"list","member":{}},"androidPaths":{"type":"list","member":{}},"deviceHostPaths":{"type":"list","member":{}}}},"S3j":{"type":"structure","members":{"wifi":{"type":"boolean"},"bluetooth":{"type":"boolean"},"nfc":{"type":"boolean"},"gps":{"type":"boolean"}}},"S3l":{"type":"list","member":{"type":"structure","members":{"device":{"shape":"S15"},"compatible":{"type":"boolean"},"incompatibilityMessages":{"type":"list","member":{"type":"structure","members":{"message":{},"type":{}}}}}}},"S3t":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3u"},"message":{},"device":{"shape":"S15"},"instanceArn":{},"deviceMinutes":{"shape":"S1h"},"videoEndpoint":{},"videoCapture":{"type":"boolean"}}},"S3u":{"type":"structure","members":{"total":{"type":"integer"},"passed":{"type":"integer"},"failed":{"type":"integer"},"warned":{"type":"integer"},"errored":{"type":"integer"},"stopped":{"type":"integer"},"skipped":{"type":"integer"}}},"S41":{"type":"map","key":{},"value":{"shape":"S43"}},"S43":{"type":"structure","members":{"type":{},"offering":{"shape":"S45"},"quantity":{"type":"integer"},"effectiveOn":{"type":"timestamp"}}},"S45":{"type":"structure","members":{"id":{},"description":{},"type":{},"platform":{},"recurringCharges":{"type":"list","member":{"type":"structure","members":{"cost":{"shape":"S49"},"frequency":{}}}}}},"S49":{"type":"structure","members":{"amount":{"type":"double"},"currencyCode":{}}},"S4i":{"type":"structure","members":{"arn":{},"name":{},"type":{},"platform":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3u"},"message":{},"totalJobs":{"type":"integer"},"completedJobs":{"type":"integer"},"billingMethod":{},"deviceMinutes":{"shape":"S1h"},"networkProfile":{"shape":"So"},"parsingResultUrl":{},"resultCode":{},"seed":{"type":"integer"},"appUpload":{},"eventCount":{"type":"integer"},"jobTimeoutMinutes":{"type":"integer"},"devicePoolArn":{},"locale":{},"radios":{"shape":"S3j"},"location":{"shape":"S3e"},"customerArtifactPaths":{"shape":"S3f"},"webUrl":{},"skipAppResign":{"type":"boolean"},"testSpecArn":{},"deviceSelectionResult":{"type":"structure","members":{"filters":{"shape":"S4l"},"matchedDevicesCount":{"type":"integer"},"maxDevices":{"type":"integer"}}}}},"S4l":{"type":"list","member":{"type":"structure","required":["attribute","operator","values"],"members":{"attribute":{},"operator":{},"values":{"type":"list","member":{}}}}},"S4r":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3u"},"message":{},"deviceMinutes":{"shape":"S1h"}}},"S4u":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3u"},"message":{},"deviceMinutes":{"shape":"S1h"}}},"S50":{"type":"structure","members":{"arn":{},"status":{},"created":{"type":"timestamp"},"ended":{"type":"timestamp"},"billingMinutes":{"type":"double"},"seleniumProperties":{}}},"S64":{"type":"structure","members":{"offeringStatus":{"shape":"S43"},"transactionId":{},"offeringPromotionId":{},"createdOn":{"type":"timestamp"},"cost":{"shape":"S49"}}},"S6s":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S7n":{"type":"structure","members":{"arn":{},"name":{}}}}}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetOfferingStatus":{"input_token":"nextToken","output_token":"nextToken","result_key":["current","nextPeriod"]},"ListArtifacts":{"input_token":"nextToken","output_token":"nextToken","result_key":"artifacts"},"ListDevicePools":{"input_token":"nextToken","output_token":"nextToken","result_key":"devicePools"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","result_key":"devices"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","result_key":"jobs"},"ListOfferingTransactions":{"input_token":"nextToken","output_token":"nextToken","result_key":"offeringTransactions"},"ListOfferings":{"input_token":"nextToken","output_token":"nextToken","result_key":"offerings"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListRuns":{"input_token":"nextToken","output_token":"nextToken","result_key":"runs"},"ListSamples":{"input_token":"nextToken","output_token":"nextToken","result_key":"samples"},"ListSuites":{"input_token":"nextToken","output_token":"nextToken","result_key":"suites"},"ListTestGridProjects":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessionActions":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessionArtifacts":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessions":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTests":{"input_token":"nextToken","output_token":"nextToken","result_key":"tests"},"ListUniqueProblems":{"input_token":"nextToken","output_token":"nextToken","result_key":"uniqueProblems"},"ListUploads":{"input_token":"nextToken","output_token":"nextToken","result_key":"uploads"}}}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['directconnect'] = {};
	AWS.DirectConnect = Service.defineService('directconnect', ['2012-10-25']);
	Object.defineProperty(apiLoader.services['directconnect'], '2012-10-25', {
	  get: function get() {
	    var model = __webpack_require__(163);
	    model.paginators = __webpack_require__(164).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DirectConnect;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-10-25","endpointPrefix":"directconnect","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Direct Connect","serviceId":"Direct Connect","signatureVersion":"v4","targetPrefix":"OvertureService","uid":"directconnect-2012-10-25"},"operations":{"AcceptDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","proposalId","associatedGatewayOwnerAccount"],"members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayOwnerAccount":{},"overrideAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"AllocateConnectionOnInterconnect":{"input":{"type":"structure","required":["bandwidth","connectionName","ownerAccount","interconnectId","vlan"],"members":{"bandwidth":{},"connectionName":{},"ownerAccount":{},"interconnectId":{},"vlan":{"type":"integer"}}},"output":{"shape":"So"},"deprecated":true},"AllocateHostedConnection":{"input":{"type":"structure","required":["connectionId","ownerAccount","bandwidth","connectionName","vlan"],"members":{"connectionId":{},"ownerAccount":{},"bandwidth":{},"connectionName":{},"vlan":{"type":"integer"},"tags":{"shape":"S10"}}},"output":{"shape":"So"}},"AllocatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPrivateVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPrivateVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"addressFamily":{},"customerAddress":{},"tags":{"shape":"S10"}}}}},"output":{"shape":"S1o"}},"AllocatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPublicVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPublicVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"S10"}}}}},"output":{"shape":"S1o"}},"AllocateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newTransitVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newTransitVirtualInterfaceAllocation":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"tags":{"shape":"S10"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"AssociateConnectionWithLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"AssociateHostedConnection":{"input":{"type":"structure","required":["connectionId","parentConnectionId"],"members":{"connectionId":{},"parentConnectionId":{}}},"output":{"shape":"So"}},"AssociateMacSecKey":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"secretARN":{},"ckn":{},"cak":{}}},"output":{"type":"structure","members":{"connectionId":{},"macSecKeys":{"shape":"S18"}}}},"AssociateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","connectionId"],"members":{"virtualInterfaceId":{},"connectionId":{}}},"output":{"shape":"S1o"}},"ConfirmConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"type":"structure","members":{"connectionState":{}}}},"ConfirmCustomerAgreement":{"input":{"type":"structure","members":{"agreementName":{}}},"output":{"type":"structure","members":{"status":{}}}},"ConfirmPrivateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"virtualGatewayId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmPublicVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmTransitVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","directConnectGatewayId"],"members":{"virtualInterfaceId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"CreateBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"newBGPPeer":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"CreateConnection":{"input":{"type":"structure","required":["location","bandwidth","connectionName"],"members":{"location":{},"bandwidth":{},"connectionName":{},"lagId":{},"tags":{"shape":"S10"},"providerName":{},"requestMACSec":{"type":"boolean"}}},"output":{"shape":"So"}},"CreateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayName"],"members":{"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2v"}}}},"CreateDirectConnectGatewayAssociation":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"CreateDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","directConnectGatewayOwnerAccount","gatewayId"],"members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S32"}}}},"CreateInterconnect":{"input":{"type":"structure","required":["interconnectName","bandwidth","location"],"members":{"interconnectName":{},"bandwidth":{},"location":{},"lagId":{},"tags":{"shape":"S10"},"providerName":{}}},"output":{"shape":"S36"}},"CreateLag":{"input":{"type":"structure","required":["numberOfConnections","location","connectionsBandwidth","lagName"],"members":{"numberOfConnections":{"type":"integer"},"location":{},"connectionsBandwidth":{},"lagName":{},"connectionId":{},"tags":{"shape":"S10"},"childConnectionTags":{"shape":"S10"},"providerName":{},"requestMACSec":{"type":"boolean"}}},"output":{"shape":"S3b"}},"CreatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPrivateVirtualInterface"],"members":{"connectionId":{},"newPrivateVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualGatewayId":{},"directConnectGatewayId":{},"tags":{"shape":"S10"},"enableSiteLink":{"type":"boolean"}}}}},"output":{"shape":"S1o"}},"CreatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPublicVirtualInterface"],"members":{"connectionId":{},"newPublicVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"S10"}}}}},"output":{"shape":"S1o"}},"CreateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","newTransitVirtualInterface"],"members":{"connectionId":{},"newTransitVirtualInterface":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"directConnectGatewayId":{},"tags":{"shape":"S10"},"enableSiteLink":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"DeleteBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"asn":{"type":"integer"},"customerAddress":{},"bgpPeerId":{}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"DeleteConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"So"}},"DeleteDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2v"}}}},"DeleteDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"directConnectGatewayId":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"DeleteDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["proposalId"],"members":{"proposalId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S32"}}}},"DeleteInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnectState":{}}}},"DeleteLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{}}},"output":{"shape":"S3b"}},"DeleteVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"DescribeConnectionLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S44"}}},"deprecated":true},"DescribeConnections":{"input":{"type":"structure","members":{"connectionId":{}}},"output":{"shape":"S47"}},"DescribeConnectionsOnInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"shape":"S47"},"deprecated":true},"DescribeCustomerMetadata":{"output":{"type":"structure","members":{"agreements":{"type":"list","member":{"type":"structure","members":{"agreementName":{},"status":{}}}},"nniPartnerType":{}}}},"DescribeDirectConnectGatewayAssociationProposals":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposals":{"type":"list","member":{"shape":"S32"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAssociations":{"input":{"type":"structure","members":{"associationId":{},"associatedGatewayId":{},"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociations":{"type":"list","member":{"shape":"S9"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAttachments":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAttachments":{"type":"list","member":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"virtualInterfaceRegion":{},"virtualInterfaceOwnerAccount":{},"attachmentState":{},"attachmentType":{},"stateChangeError":{}}}},"nextToken":{}}}},"DescribeDirectConnectGateways":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGateways":{"type":"list","member":{"shape":"S2v"}},"nextToken":{}}}},"DescribeHostedConnections":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S47"}},"DescribeInterconnectLoa":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S44"}}},"deprecated":true},"DescribeInterconnects":{"input":{"type":"structure","members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnects":{"type":"list","member":{"shape":"S36"}}}}},"DescribeLags":{"input":{"type":"structure","members":{"lagId":{}}},"output":{"type":"structure","members":{"lags":{"type":"list","member":{"shape":"S3b"}}}}},"DescribeLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"shape":"S44"}},"DescribeLocations":{"output":{"type":"structure","members":{"locations":{"type":"list","member":{"type":"structure","members":{"locationCode":{},"locationName":{},"region":{},"availablePortSpeeds":{"type":"list","member":{}},"availableProviders":{"type":"list","member":{}},"availableMacSecPortSpeeds":{"type":"list","member":{}}}}}}}},"DescribeRouterConfiguration":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"routerTypeIdentifier":{}}},"output":{"type":"structure","members":{"customerRouterConfig":{},"router":{"type":"structure","members":{"vendor":{},"platform":{},"software":{},"xsltTemplateName":{},"xsltTemplateNameForMacSec":{},"routerTypeIdentifier":{}}},"virtualInterfaceId":{},"virtualInterfaceName":{}}}},"DescribeTags":{"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceTags":{"type":"list","member":{"type":"structure","members":{"resourceArn":{},"tags":{"shape":"S10"}}}}}}},"DescribeVirtualGateways":{"output":{"type":"structure","members":{"virtualGateways":{"type":"list","member":{"type":"structure","members":{"virtualGatewayId":{},"virtualGatewayState":{}}}}}}},"DescribeVirtualInterfaces":{"input":{"type":"structure","members":{"connectionId":{},"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaces":{"type":"list","member":{"shape":"S1o"}}}}},"DisassociateConnectionFromLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"DisassociateMacSecKey":{"input":{"type":"structure","required":["connectionId","secretARN"],"members":{"connectionId":{},"secretARN":{}}},"output":{"type":"structure","members":{"connectionId":{},"macSecKeys":{"shape":"S18"}}}},"ListVirtualInterfaceTestHistory":{"input":{"type":"structure","members":{"testId":{},"virtualInterfaceId":{},"bgpPeers":{"shape":"S65"},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"virtualInterfaceTestHistory":{"type":"list","member":{"shape":"S69"}},"nextToken":{}}}},"StartBgpFailoverTest":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"bgpPeers":{"shape":"S65"},"testDurationInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"virtualInterfaceTest":{"shape":"S69"}}}},"StopBgpFailoverTest":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceTest":{"shape":"S69"}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"connectionName":{},"encryptionMode":{}}},"output":{"shape":"So"}},"UpdateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId","newDirectConnectGatewayName"],"members":{"directConnectGatewayId":{},"newDirectConnectGatewayName":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2v"}}}},"UpdateDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"UpdateLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{},"lagName":{},"minimumLinks":{"type":"integer"},"encryptionMode":{}}},"output":{"shape":"S3b"}},"UpdateVirtualInterfaceAttributes":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"mtu":{"type":"integer"},"enableSiteLink":{"type":"boolean"},"virtualInterfaceName":{}}},"output":{"shape":"S1o"}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"cidr":{}}}},"S9":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"associationState":{},"stateChangeError":{},"associatedGateway":{"shape":"Sc"},"associationId":{},"allowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{},"virtualGatewayRegion":{"type":"string","deprecated":true},"virtualGatewayOwnerAccount":{}}},"Sc":{"type":"structure","members":{"id":{},"type":{},"ownerAccount":{},"region":{}}},"So":{"type":"structure","members":{"ownerAccount":{},"connectionId":{},"connectionName":{},"connectionState":{},"region":{},"location":{},"bandwidth":{},"vlan":{"type":"integer"},"partnerName":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"awsLogicalDeviceId":{},"hasLogicalRedundancy":{},"tags":{"shape":"S10"},"providerName":{},"macSecCapable":{"type":"boolean"},"portEncryptionStatus":{},"encryptionMode":{},"macSecKeys":{"shape":"S18"}}},"Sv":{"type":"string","deprecated":true},"S10":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"S18":{"type":"list","member":{"type":"structure","members":{"secretARN":{},"ckn":{},"state":{},"startOn":{}}}},"S1o":{"type":"structure","members":{"ownerAccount":{},"virtualInterfaceId":{},"location":{},"connectionId":{},"virtualInterfaceType":{},"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"amazonSideAsn":{"type":"long"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualInterfaceState":{},"customerRouterConfig":{},"mtu":{"type":"integer"},"jumboFrameCapable":{"type":"boolean"},"virtualGatewayId":{},"directConnectGatewayId":{},"routeFilterPrefixes":{"shape":"S5"},"bgpPeers":{"type":"list","member":{"type":"structure","members":{"bgpPeerId":{},"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{},"bgpPeerState":{},"bgpStatus":{},"awsDeviceV2":{},"awsLogicalDeviceId":{}}}},"region":{},"awsDeviceV2":{},"awsLogicalDeviceId":{},"tags":{"shape":"S10"},"siteLinkEnabled":{"type":"boolean"}}},"S2v":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"},"ownerAccount":{},"directConnectGatewayState":{},"stateChangeError":{}}},"S32":{"type":"structure","members":{"proposalId":{},"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"proposalState":{},"associatedGateway":{"shape":"Sc"},"existingAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"requestedAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"S36":{"type":"structure","members":{"interconnectId":{},"interconnectName":{},"interconnectState":{},"region":{},"location":{},"bandwidth":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"awsLogicalDeviceId":{},"hasLogicalRedundancy":{},"tags":{"shape":"S10"},"providerName":{}}},"S3b":{"type":"structure","members":{"connectionsBandwidth":{},"numberOfConnections":{"type":"integer"},"lagId":{},"ownerAccount":{},"lagName":{},"lagState":{},"location":{},"region":{},"minimumLinks":{"type":"integer"},"awsDevice":{"shape":"Sv"},"awsDeviceV2":{},"awsLogicalDeviceId":{},"connections":{"shape":"S3d"},"allowsHostedConnections":{"type":"boolean"},"jumboFrameCapable":{"type":"boolean"},"hasLogicalRedundancy":{},"tags":{"shape":"S10"},"providerName":{},"macSecCapable":{"type":"boolean"},"encryptionMode":{},"macSecKeys":{"shape":"S18"}}},"S3d":{"type":"list","member":{"shape":"So"}},"S44":{"type":"structure","members":{"loaContent":{"type":"blob"},"loaContentType":{}}},"S47":{"type":"structure","members":{"connections":{"shape":"S3d"}}},"S65":{"type":"list","member":{}},"S69":{"type":"structure","members":{"testId":{},"virtualInterfaceId":{},"bgpPeers":{"shape":"S65"},"status":{},"ownerAccount":{},"testDurationInMinutes":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}}}}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeConnections":{"result_key":"connections"},"DescribeConnectionsOnInterconnect":{"result_key":"connections"},"DescribeInterconnects":{"result_key":"interconnects"},"DescribeLocations":{"result_key":"locations"},"DescribeVirtualGateways":{"result_key":"virtualGateways"},"DescribeVirtualInterfaces":{"result_key":"virtualInterfaces"}}}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['directoryservice'] = {};
	AWS.DirectoryService = Service.defineService('directoryservice', ['2015-04-16']);
	Object.defineProperty(apiLoader.services['directoryservice'], '2015-04-16', {
	  get: function get() {
	    var model = __webpack_require__(166);
	    model.paginators = __webpack_require__(167).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DirectoryService;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-16","endpointPrefix":"ds","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Directory Service","serviceFullName":"AWS Directory Service","serviceId":"Directory Service","signatureVersion":"v4","targetPrefix":"DirectoryService_20150416","uid":"ds-2015-04-16"},"operations":{"AcceptSharedDirectory":{"input":{"type":"structure","required":["SharedDirectoryId"],"members":{"SharedDirectoryId":{}}},"output":{"type":"structure","members":{"SharedDirectory":{"shape":"S4"}}}},"AddIpRoutes":{"input":{"type":"structure","required":["DirectoryId","IpRoutes"],"members":{"DirectoryId":{},"IpRoutes":{"type":"list","member":{"type":"structure","members":{"CidrIp":{},"Description":{}}}},"UpdateSecurityGroupForDirectoryControllers":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AddRegion":{"input":{"type":"structure","required":["DirectoryId","RegionName","VPCSettings"],"members":{"DirectoryId":{},"RegionName":{},"VPCSettings":{"shape":"Sk"}}},"output":{"type":"structure","members":{}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{}}},"CancelSchemaExtension":{"input":{"type":"structure","required":["DirectoryId","SchemaExtensionId"],"members":{"DirectoryId":{},"SchemaExtensionId":{}}},"output":{"type":"structure","members":{}}},"ConnectDirectory":{"input":{"type":"structure","required":["Name","Password","Size","ConnectSettings"],"members":{"Name":{},"ShortName":{},"Password":{"shape":"S12"},"Description":{},"Size":{},"ConnectSettings":{"type":"structure","required":["VpcId","SubnetIds","CustomerDnsIps","CustomerUserName"],"members":{"VpcId":{},"SubnetIds":{"shape":"Sm"},"CustomerDnsIps":{"shape":"S15"},"CustomerUserName":{}}},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"CreateAlias":{"input":{"type":"structure","required":["DirectoryId","Alias"],"members":{"DirectoryId":{},"Alias":{}}},"output":{"type":"structure","members":{"DirectoryId":{},"Alias":{}}}},"CreateComputer":{"input":{"type":"structure","required":["DirectoryId","ComputerName","Password"],"members":{"DirectoryId":{},"ComputerName":{},"Password":{"type":"string","sensitive":true},"OrganizationalUnitDistinguishedName":{},"ComputerAttributes":{"shape":"S1g"}}},"output":{"type":"structure","members":{"Computer":{"type":"structure","members":{"ComputerId":{},"ComputerName":{},"ComputerAttributes":{"shape":"S1g"}}}}}},"CreateConditionalForwarder":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName","DnsIpAddrs"],"members":{"DirectoryId":{},"RemoteDomainName":{},"DnsIpAddrs":{"shape":"S15"}}},"output":{"type":"structure","members":{}}},"CreateDirectory":{"input":{"type":"structure","required":["Name","Password","Size"],"members":{"Name":{},"ShortName":{},"Password":{"shape":"S1r"},"Description":{},"Size":{},"VpcSettings":{"shape":"Sk"},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"CreateLogSubscription":{"input":{"type":"structure","required":["DirectoryId","LogGroupName"],"members":{"DirectoryId":{},"LogGroupName":{}}},"output":{"type":"structure","members":{}}},"CreateMicrosoftAD":{"input":{"type":"structure","required":["Name","Password","VpcSettings"],"members":{"Name":{},"ShortName":{},"Password":{"shape":"S1r"},"Description":{},"VpcSettings":{"shape":"Sk"},"Edition":{},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"Name":{}}},"output":{"type":"structure","members":{"SnapshotId":{}}}},"CreateTrust":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName","TrustPassword","TrustDirection"],"members":{"DirectoryId":{},"RemoteDomainName":{},"TrustPassword":{"type":"string","sensitive":true},"TrustDirection":{},"TrustType":{},"ConditionalForwarderIpAddrs":{"shape":"S15"},"SelectiveAuth":{}}},"output":{"type":"structure","members":{"TrustId":{}}}},"DeleteConditionalForwarder":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName"],"members":{"DirectoryId":{},"RemoteDomainName":{}}},"output":{"type":"structure","members":{}}},"DeleteDirectory":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"DeleteLogSubscription":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{}}},"output":{"type":"structure","members":{"SnapshotId":{}}}},"DeleteTrust":{"input":{"type":"structure","required":["TrustId"],"members":{"TrustId":{},"DeleteAssociatedConditionalForwarder":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrustId":{}}}},"DeregisterCertificate":{"input":{"type":"structure","required":["DirectoryId","CertificateId"],"members":{"DirectoryId":{},"CertificateId":{}}},"output":{"type":"structure","members":{}}},"DeregisterEventTopic":{"input":{"type":"structure","required":["DirectoryId","TopicName"],"members":{"DirectoryId":{},"TopicName":{}}},"output":{"type":"structure","members":{}}},"DescribeCertificate":{"input":{"type":"structure","required":["DirectoryId","CertificateId"],"members":{"DirectoryId":{},"CertificateId":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateId":{},"State":{},"StateReason":{},"CommonName":{},"RegisteredDateTime":{"type":"timestamp"},"ExpiryDateTime":{"type":"timestamp"},"Type":{},"ClientCertAuthSettings":{"shape":"S30"}}}}}},"DescribeClientAuthenticationSettings":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"Type":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ClientAuthenticationSettingsInfo":{"type":"list","member":{"type":"structure","members":{"Type":{},"Status":{},"LastUpdatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeConditionalForwarders":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"RemoteDomainNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ConditionalForwarders":{"type":"list","member":{"type":"structure","members":{"RemoteDomainName":{},"DnsIpAddrs":{"shape":"S15"},"ReplicationScope":{}}}}}}},"DescribeDirectories":{"input":{"type":"structure","members":{"DirectoryIds":{"shape":"S3h"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"DirectoryDescriptions":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"Name":{},"ShortName":{},"Size":{},"Edition":{},"Alias":{},"AccessUrl":{},"Description":{},"DnsIpAddrs":{"shape":"S15"},"Stage":{},"ShareStatus":{},"ShareMethod":{},"ShareNotes":{"shape":"S8"},"LaunchTime":{"type":"timestamp"},"StageLastUpdatedDateTime":{"type":"timestamp"},"Type":{},"VpcSettings":{"shape":"S3q"},"ConnectSettings":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"Sm"},"CustomerUserName":{},"SecurityGroupId":{},"AvailabilityZones":{"shape":"S3s"},"ConnectIps":{"type":"list","member":{}}}},"RadiusSettings":{"shape":"S3w"},"RadiusStatus":{},"StageReason":{},"SsoEnabled":{"type":"boolean"},"DesiredNumberOfDomainControllers":{"type":"integer"},"OwnerDirectoryDescription":{"type":"structure","members":{"DirectoryId":{},"AccountId":{},"DnsIpAddrs":{"shape":"S15"},"VpcSettings":{"shape":"S3q"},"RadiusSettings":{"shape":"S3w"},"RadiusStatus":{}}},"RegionsInfo":{"type":"structure","members":{"PrimaryRegion":{},"AdditionalRegions":{"type":"list","member":{}}}}}}},"NextToken":{}}}},"DescribeDomainControllers":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"DomainControllerIds":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"DomainControllers":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"DomainControllerId":{},"DnsIpAddr":{},"VpcId":{},"SubnetId":{},"AvailabilityZone":{},"Status":{},"StatusReason":{},"LaunchTime":{"type":"timestamp"},"StatusLastUpdatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEventTopics":{"input":{"type":"structure","members":{"DirectoryId":{},"TopicNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"EventTopics":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"TopicName":{},"TopicArn":{},"CreatedDateTime":{"type":"timestamp"},"Status":{}}}}}}},"DescribeLDAPSSettings":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"Type":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LDAPSSettingsInfo":{"type":"list","member":{"type":"structure","members":{"LDAPSStatus":{},"LDAPSStatusReason":{},"LastUpdatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeRegions":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"RegionName":{},"NextToken":{}}},"output":{"type":"structure","members":{"RegionsDescription":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"RegionName":{},"RegionType":{},"Status":{},"VpcSettings":{"shape":"Sk"},"DesiredNumberOfDomainControllers":{"type":"integer"},"LaunchTime":{"type":"timestamp"},"StatusLastUpdatedDateTime":{"type":"timestamp"},"LastUpdatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeSharedDirectories":{"input":{"type":"structure","required":["OwnerDirectoryId"],"members":{"OwnerDirectoryId":{},"SharedDirectoryIds":{"shape":"S3h"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"SharedDirectories":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"DirectoryId":{},"SnapshotIds":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Snapshots":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"SnapshotId":{},"Type":{},"Name":{},"Status":{},"StartTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTrusts":{"input":{"type":"structure","members":{"DirectoryId":{},"TrustIds":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Trusts":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"TrustId":{},"RemoteDomainName":{},"TrustType":{},"TrustDirection":{},"TrustState":{},"CreatedDateTime":{"type":"timestamp"},"LastUpdatedDateTime":{"type":"timestamp"},"StateLastUpdatedDateTime":{"type":"timestamp"},"TrustStateReason":{},"SelectiveAuth":{}}}},"NextToken":{}}}},"DisableClientAuthentication":{"input":{"type":"structure","required":["DirectoryId","Type"],"members":{"DirectoryId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"DisableLDAPS":{"input":{"type":"structure","required":["DirectoryId","Type"],"members":{"DirectoryId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"DisableRadius":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{}}},"DisableSso":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"UserName":{},"Password":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"EnableClientAuthentication":{"input":{"type":"structure","required":["DirectoryId","Type"],"members":{"DirectoryId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"EnableLDAPS":{"input":{"type":"structure","required":["DirectoryId","Type"],"members":{"DirectoryId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"EnableRadius":{"input":{"type":"structure","required":["DirectoryId","RadiusSettings"],"members":{"DirectoryId":{},"RadiusSettings":{"shape":"S3w"}}},"output":{"type":"structure","members":{}}},"EnableSso":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"UserName":{},"Password":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"GetDirectoryLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DirectoryLimits":{"type":"structure","members":{"CloudOnlyDirectoriesLimit":{"type":"integer"},"CloudOnlyDirectoriesCurrentCount":{"type":"integer"},"CloudOnlyDirectoriesLimitReached":{"type":"boolean"},"CloudOnlyMicrosoftADLimit":{"type":"integer"},"CloudOnlyMicrosoftADCurrentCount":{"type":"integer"},"CloudOnlyMicrosoftADLimitReached":{"type":"boolean"},"ConnectedDirectoriesLimit":{"type":"integer"},"ConnectedDirectoriesCurrentCount":{"type":"integer"},"ConnectedDirectoriesLimitReached":{"type":"boolean"}}}}}},"GetSnapshotLimits":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{"SnapshotLimits":{"type":"structure","members":{"ManualSnapshotsLimit":{"type":"integer"},"ManualSnapshotsCurrentCount":{"type":"integer"},"ManualSnapshotsLimitReached":{"type":"boolean"}}}}}},"ListCertificates":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CertificatesInfo":{"type":"list","member":{"type":"structure","members":{"CertificateId":{},"CommonName":{},"State":{},"ExpiryDateTime":{"type":"timestamp"},"Type":{}}}}}}},"ListIpRoutes":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"IpRoutesInfo":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"CidrIp":{},"IpRouteStatusMsg":{},"AddedDateTime":{"type":"timestamp"},"IpRouteStatusReason":{},"Description":{}}}},"NextToken":{}}}},"ListLogSubscriptions":{"input":{"type":"structure","members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LogSubscriptions":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"LogGroupName":{},"SubscriptionCreatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListSchemaExtensions":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaExtensionsInfo":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"SchemaExtensionId":{},"Description":{},"SchemaExtensionStatus":{},"SchemaExtensionStatusReason":{},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sr"},"NextToken":{}}}},"RegisterCertificate":{"input":{"type":"structure","required":["DirectoryId","CertificateData"],"members":{"DirectoryId":{},"CertificateData":{},"Type":{},"ClientCertAuthSettings":{"shape":"S30"}}},"output":{"type":"structure","members":{"CertificateId":{}}}},"RegisterEventTopic":{"input":{"type":"structure","required":["DirectoryId","TopicName"],"members":{"DirectoryId":{},"TopicName":{}}},"output":{"type":"structure","members":{}}},"RejectSharedDirectory":{"input":{"type":"structure","required":["SharedDirectoryId"],"members":{"SharedDirectoryId":{}}},"output":{"type":"structure","members":{"SharedDirectoryId":{}}}},"RemoveIpRoutes":{"input":{"type":"structure","required":["DirectoryId","CidrIps"],"members":{"DirectoryId":{},"CidrIps":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"RemoveRegion":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"ResetUserPassword":{"input":{"type":"structure","required":["DirectoryId","UserName","NewPassword"],"members":{"DirectoryId":{},"UserName":{},"NewPassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{}}},"RestoreFromSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{}}},"output":{"type":"structure","members":{}}},"ShareDirectory":{"input":{"type":"structure","required":["DirectoryId","ShareTarget","ShareMethod"],"members":{"DirectoryId":{},"ShareNotes":{"shape":"S8"},"ShareTarget":{"type":"structure","required":["Id","Type"],"members":{"Id":{},"Type":{}}},"ShareMethod":{}}},"output":{"type":"structure","members":{"SharedDirectoryId":{}}}},"StartSchemaExtension":{"input":{"type":"structure","required":["DirectoryId","CreateSnapshotBeforeSchemaExtension","LdifContent","Description"],"members":{"DirectoryId":{},"CreateSnapshotBeforeSchemaExtension":{"type":"boolean"},"LdifContent":{},"Description":{}}},"output":{"type":"structure","members":{"SchemaExtensionId":{}}}},"UnshareDirectory":{"input":{"type":"structure","required":["DirectoryId","UnshareTarget"],"members":{"DirectoryId":{},"UnshareTarget":{"type":"structure","required":["Id","Type"],"members":{"Id":{},"Type":{}}}}},"output":{"type":"structure","members":{"SharedDirectoryId":{}}}},"UpdateConditionalForwarder":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName","DnsIpAddrs"],"members":{"DirectoryId":{},"RemoteDomainName":{},"DnsIpAddrs":{"shape":"S15"}}},"output":{"type":"structure","members":{}}},"UpdateNumberOfDomainControllers":{"input":{"type":"structure","required":["DirectoryId","DesiredNumber"],"members":{"DirectoryId":{},"DesiredNumber":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"UpdateRadius":{"input":{"type":"structure","required":["DirectoryId","RadiusSettings"],"members":{"DirectoryId":{},"RadiusSettings":{"shape":"S3w"}}},"output":{"type":"structure","members":{}}},"UpdateTrust":{"input":{"type":"structure","required":["TrustId"],"members":{"TrustId":{},"SelectiveAuth":{}}},"output":{"type":"structure","members":{"RequestId":{},"TrustId":{}}}},"VerifyTrust":{"input":{"type":"structure","required":["TrustId"],"members":{"TrustId":{}}},"output":{"type":"structure","members":{"TrustId":{}}}}},"shapes":{"S4":{"type":"structure","members":{"OwnerAccountId":{},"OwnerDirectoryId":{},"ShareMethod":{},"SharedAccountId":{},"SharedDirectoryId":{},"ShareStatus":{},"ShareNotes":{"shape":"S8"},"CreatedDateTime":{"type":"timestamp"},"LastUpdatedDateTime":{"type":"timestamp"}}},"S8":{"type":"string","sensitive":true},"Sk":{"type":"structure","required":["VpcId","SubnetIds"],"members":{"VpcId":{},"SubnetIds":{"shape":"Sm"}}},"Sm":{"type":"list","member":{}},"Sr":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S12":{"type":"string","sensitive":true},"S15":{"type":"list","member":{}},"S1g":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"S1r":{"type":"string","sensitive":true},"S30":{"type":"structure","members":{"OCSPUrl":{}}},"S3h":{"type":"list","member":{}},"S3q":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"Sm"},"SecurityGroupId":{},"AvailabilityZones":{"shape":"S3s"}}},"S3s":{"type":"list","member":{}},"S3w":{"type":"structure","members":{"RadiusServers":{"type":"list","member":{}},"RadiusPort":{"type":"integer"},"RadiusTimeout":{"type":"integer"},"RadiusRetries":{"type":"integer"},"SharedSecret":{"type":"string","sensitive":true},"AuthenticationProtocol":{},"DisplayLabel":{},"UseSameUsername":{"type":"boolean"}}}}}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDomainControllers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit"}}}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['discovery'] = {};
	AWS.Discovery = Service.defineService('discovery', ['2015-11-01']);
	Object.defineProperty(apiLoader.services['discovery'], '2015-11-01', {
	  get: function get() {
	    var model = __webpack_require__(169);
	    model.paginators = __webpack_require__(170).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Discovery;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-11-01","endpointPrefix":"discovery","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Application Discovery Service","serviceId":"Application Discovery Service","signatureVersion":"v4","targetPrefix":"AWSPoseidonService_V2015_11_01","uid":"discovery-2015-11-01"},"operations":{"AssociateConfigurationItemsToApplication":{"input":{"type":"structure","required":["applicationConfigurationId","configurationIds"],"members":{"applicationConfigurationId":{},"configurationIds":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"BatchDeleteImportData":{"input":{"type":"structure","required":["importTaskIds"],"members":{"importTaskIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"type":"structure","members":{"importTaskId":{},"errorCode":{},"errorDescription":{}}}}}}},"CreateApplication":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{}}},"output":{"type":"structure","members":{"configurationId":{}}}},"CreateTags":{"input":{"type":"structure","required":["configurationIds","tags"],"members":{"configurationIds":{"shape":"S3"},"tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"DeleteApplications":{"input":{"type":"structure","required":["configurationIds"],"members":{"configurationIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteTags":{"input":{"type":"structure","required":["configurationIds"],"members":{"configurationIds":{"shape":"S3"},"tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"DescribeAgents":{"input":{"type":"structure","members":{"agentIds":{"shape":"St"},"filters":{"shape":"Sv"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"agentsInfo":{"type":"list","member":{"type":"structure","members":{"agentId":{},"hostName":{},"agentNetworkInfoList":{"type":"list","member":{"type":"structure","members":{"ipAddress":{},"macAddress":{}}}},"connectorId":{},"version":{},"health":{},"lastHealthPingTime":{},"collectionStatus":{},"agentType":{},"registeredTime":{}}}},"nextToken":{}}}},"DescribeConfigurations":{"input":{"type":"structure","required":["configurationIds"],"members":{"configurationIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"configurations":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}},"DescribeContinuousExports":{"input":{"type":"structure","members":{"exportIds":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"descriptions":{"type":"list","member":{"type":"structure","members":{"exportId":{},"status":{},"statusDetail":{},"s3Bucket":{},"startTime":{"type":"timestamp"},"stopTime":{"type":"timestamp"},"dataSource":{},"schemaStorageConfig":{"shape":"S1o"}}}},"nextToken":{}}}},"DescribeExportConfigurations":{"input":{"type":"structure","members":{"exportIds":{"shape":"S1r"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"exportsInfo":{"shape":"S1t"},"nextToken":{}}},"deprecated":true},"DescribeExportTasks":{"input":{"type":"structure","members":{"exportIds":{"shape":"S1r"},"filters":{"shape":"S21"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"exportsInfo":{"shape":"S1t"},"nextToken":{}}}},"DescribeImportTasks":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"type":"list","member":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"tasks":{"type":"list","member":{"shape":"S2e"}}}}},"DescribeTags":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","required":["name","values"],"members":{"name":{},"values":{"shape":"Sx"}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"type":"list","member":{"type":"structure","members":{"configurationType":{},"configurationId":{},"key":{},"value":{},"timeOfCreation":{"type":"timestamp"}}}},"nextToken":{}}}},"DisassociateConfigurationItemsFromApplication":{"input":{"type":"structure","required":["applicationConfigurationId","configurationIds"],"members":{"applicationConfigurationId":{},"configurationIds":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"ExportConfigurations":{"output":{"type":"structure","members":{"exportId":{}}},"deprecated":true},"GetDiscoverySummary":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"servers":{"type":"long"},"applications":{"type":"long"},"serversMappedToApplications":{"type":"long"},"serversMappedtoTags":{"type":"long"},"agentSummary":{"type":"structure","required":["activeAgents","healthyAgents","blackListedAgents","shutdownAgents","unhealthyAgents","totalAgents","unknownAgents"],"members":{"activeAgents":{"type":"integer"},"healthyAgents":{"type":"integer"},"blackListedAgents":{"type":"integer"},"shutdownAgents":{"type":"integer"},"unhealthyAgents":{"type":"integer"},"totalAgents":{"type":"integer"},"unknownAgents":{"type":"integer"}}},"connectorSummary":{"type":"structure","required":["activeConnectors","healthyConnectors","blackListedConnectors","shutdownConnectors","unhealthyConnectors","totalConnectors","unknownConnectors"],"members":{"activeConnectors":{"type":"integer"},"healthyConnectors":{"type":"integer"},"blackListedConnectors":{"type":"integer"},"shutdownConnectors":{"type":"integer"},"unhealthyConnectors":{"type":"integer"},"totalConnectors":{"type":"integer"},"unknownConnectors":{"type":"integer"}}}}}},"ListConfigurations":{"input":{"type":"structure","required":["configurationType"],"members":{"configurationType":{},"filters":{"shape":"Sv"},"maxResults":{"type":"integer"},"nextToken":{},"orderBy":{"type":"list","member":{"type":"structure","required":["fieldName"],"members":{"fieldName":{},"sortOrder":{}}}}}},"output":{"type":"structure","members":{"configurations":{"type":"list","member":{"type":"map","key":{},"value":{}}},"nextToken":{}}}},"ListServerNeighbors":{"input":{"type":"structure","required":["configurationId"],"members":{"configurationId":{},"portInformationNeeded":{"type":"boolean"},"neighborConfigurationIds":{"shape":"S3"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["neighbors"],"members":{"neighbors":{"type":"list","member":{"type":"structure","required":["sourceServerId","destinationServerId","connectionsCount"],"members":{"sourceServerId":{},"destinationServerId":{},"destinationPort":{"type":"integer"},"transportProtocol":{},"connectionsCount":{"type":"long"}}}},"nextToken":{},"knownDependencyCount":{"type":"long"}}}},"StartContinuousExport":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"exportId":{},"s3Bucket":{},"startTime":{"type":"timestamp"},"dataSource":{},"schemaStorageConfig":{"shape":"S1o"}}}},"StartDataCollectionByAgentIds":{"input":{"type":"structure","required":["agentIds"],"members":{"agentIds":{"shape":"St"}}},"output":{"type":"structure","members":{"agentsConfigurationStatus":{"shape":"S3f"}}}},"StartExportTask":{"input":{"type":"structure","members":{"exportDataFormat":{"type":"list","member":{}},"filters":{"shape":"S21"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"exportId":{}}}},"StartImportTask":{"input":{"type":"structure","required":["name","importUrl"],"members":{"clientRequestToken":{"idempotencyToken":true},"name":{},"importUrl":{}}},"output":{"type":"structure","members":{"task":{"shape":"S2e"}}}},"StopContinuousExport":{"input":{"type":"structure","required":["exportId"],"members":{"exportId":{}}},"output":{"type":"structure","members":{"startTime":{"type":"timestamp"},"stopTime":{"type":"timestamp"}}}},"StopDataCollectionByAgentIds":{"input":{"type":"structure","required":["agentIds"],"members":{"agentIds":{"shape":"St"}}},"output":{"type":"structure","members":{"agentsConfigurationStatus":{"shape":"S3f"}}}},"UpdateApplication":{"input":{"type":"structure","required":["configurationId"],"members":{"configurationId":{},"name":{},"description":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"list","member":{}},"Si":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["name","values","condition"],"members":{"name":{},"values":{"shape":"Sx"},"condition":{}}}},"Sx":{"type":"list","member":{}},"S1o":{"type":"map","key":{},"value":{}},"S1r":{"type":"list","member":{}},"S1t":{"type":"list","member":{"type":"structure","required":["exportId","exportStatus","statusMessage","exportRequestTime"],"members":{"exportId":{},"exportStatus":{},"statusMessage":{},"configurationsDownloadUrl":{},"exportRequestTime":{"type":"timestamp"},"isTruncated":{"type":"boolean"},"requestedStartTime":{"type":"timestamp"},"requestedEndTime":{"type":"timestamp"}}}},"S21":{"type":"list","member":{"type":"structure","required":["name","values","condition"],"members":{"name":{},"values":{"shape":"Sx"},"condition":{}}}},"S2e":{"type":"structure","members":{"importTaskId":{},"clientRequestToken":{},"name":{},"importUrl":{},"status":{},"importRequestTime":{"type":"timestamp"},"importCompletionTime":{"type":"timestamp"},"importDeletedTime":{"type":"timestamp"},"serverImportSuccess":{"type":"integer"},"serverImportFailure":{"type":"integer"},"applicationImportSuccess":{"type":"integer"},"applicationImportFailure":{"type":"integer"},"errorsAndFailedEntriesZip":{}}},"S3f":{"type":"list","member":{"type":"structure","members":{"agentId":{},"operationSucceeded":{"type":"boolean"},"description":{}}}}}}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeContinuousExports":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"DescribeImportTasks":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['dms'] = {};
	AWS.DMS = Service.defineService('dms', ['2016-01-01']);
	Object.defineProperty(apiLoader.services['dms'], '2016-01-01', {
	  get: function get() {
	    var model = __webpack_require__(172);
	    model.paginators = __webpack_require__(173).pagination;
	    model.waiters = __webpack_require__(174).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DMS;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-01-01","endpointPrefix":"dms","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Database Migration Service","serviceId":"Database Migration Service","signatureVersion":"v4","targetPrefix":"AmazonDMSv20160101","uid":"dms-2016-01-01"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ReplicationInstanceArn","ApplyAction","OptInType"],"members":{"ReplicationInstanceArn":{},"ApplyAction":{},"OptInType":{}}},"output":{"type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"S8"}}}},"CancelReplicationTaskAssessmentRun":{"input":{"type":"structure","required":["ReplicationTaskAssessmentRunArn"],"members":{"ReplicationTaskAssessmentRunArn":{}}},"output":{"type":"structure","members":{"ReplicationTaskAssessmentRun":{"shape":"Se"}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointIdentifier","EndpointType","EngineName"],"members":{"EndpointIdentifier":{},"EndpointType":{},"EngineName":{},"Username":{},"Password":{"shape":"Sj"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"ExtraConnectionAttributes":{},"KmsKeyId":{},"Tags":{"shape":"S3"},"CertificateArn":{},"SslMode":{},"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"DynamoDbSettings":{"shape":"Sm"},"S3Settings":{"shape":"Sn"},"DmsTransferSettings":{"shape":"Sx"},"MongoDbSettings":{"shape":"Sy"},"KinesisSettings":{"shape":"S12"},"KafkaSettings":{"shape":"S14"},"ElasticsearchSettings":{"shape":"S16"},"NeptuneSettings":{"shape":"S17"},"RedshiftSettings":{"shape":"S18"},"PostgreSQLSettings":{"shape":"S19"},"MySQLSettings":{"shape":"S1b"},"OracleSettings":{"shape":"S1d"},"SybaseSettings":{"shape":"S1g"},"MicrosoftSQLServerSettings":{"shape":"S1h"},"IBMDb2Settings":{"shape":"S1j"},"ResourceIdentifier":{},"DocDbSettings":{"shape":"S1k"},"RedisSettings":{"shape":"S1l"},"GcpMySQLSettings":{"shape":"S1o"}}},"output":{"type":"structure","members":{"Endpoint":{"shape":"S1q"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S1s"},"SourceIds":{"shape":"S1t"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"EventSubscription":{"shape":"S1v"}}}},"CreateReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceIdentifier","ReplicationInstanceClass"],"members":{"ReplicationInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"ReplicationInstanceClass":{},"VpcSecurityGroupIds":{"shape":"S1y"},"AvailabilityZone":{},"ReplicationSubnetGroupIdentifier":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"Tags":{"shape":"S3"},"KmsKeyId":{},"PubliclyAccessible":{"type":"boolean"},"DnsNameServers":{},"ResourceIdentifier":{}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S20"}}}},"CreateReplicationSubnetGroup":{"input":{"type":"structure","required":["ReplicationSubnetGroupIdentifier","ReplicationSubnetGroupDescription","SubnetIds"],"members":{"ReplicationSubnetGroupIdentifier":{},"ReplicationSubnetGroupDescription":{},"SubnetIds":{"shape":"S2b"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"ReplicationSubnetGroup":{"shape":"S23"}}}},"CreateReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskIdentifier","SourceEndpointArn","TargetEndpointArn","ReplicationInstanceArn","MigrationType","TableMappings"],"members":{"ReplicationTaskIdentifier":{},"SourceEndpointArn":{},"TargetEndpointArn":{},"ReplicationInstanceArn":{},"MigrationType":{},"TableMappings":{},"ReplicationTaskSettings":{},"CdcStartTime":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{},"Tags":{"shape":"S3"},"TaskData":{},"ResourceIdentifier":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"shape":"S2l"}}}},"DeleteConnection":{"input":{"type":"structure","required":["EndpointArn","ReplicationInstanceArn"],"members":{"EndpointArn":{},"ReplicationInstanceArn":{}}},"output":{"type":"structure","members":{"Connection":{"shape":"S2p"}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"Endpoint":{"shape":"S1q"}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"type":"structure","members":{"EventSubscription":{"shape":"S1v"}}}},"DeleteReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S20"}}}},"DeleteReplicationSubnetGroup":{"input":{"type":"structure","required":["ReplicationSubnetGroupIdentifier"],"members":{"ReplicationSubnetGroupIdentifier":{}}},"output":{"type":"structure","members":{}}},"DeleteReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"DeleteReplicationTaskAssessmentRun":{"input":{"type":"structure","required":["ReplicationTaskAssessmentRunArn"],"members":{"ReplicationTaskAssessmentRunArn":{}}},"output":{"type":"structure","members":{"ReplicationTaskAssessmentRun":{"shape":"Se"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountQuotas":{"type":"list","member":{"type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}}}},"UniqueAccountIdentifier":{}}}},"DescribeApplicableIndividualAssessments":{"input":{"type":"structure","members":{"ReplicationTaskArn":{},"ReplicationInstanceArn":{},"SourceEngineName":{},"TargetEngineName":{},"MigrationType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"IndividualAssessmentNames":{"type":"list","member":{}},"Marker":{}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Certificates":{"type":"list","member":{"shape":"S2l"}}}}},"DescribeConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Connections":{"type":"list","member":{"shape":"S2p"}}}}},"DescribeEndpointSettings":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"EndpointSettings":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"EnumValues":{"type":"list","member":{}},"Sensitive":{"type":"boolean"},"Units":{},"Applicability":{},"IntValueMin":{"type":"integer"},"IntValueMax":{"type":"integer"},"DefaultValue":{}}}}}}},"DescribeEndpointTypes":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"SupportedEndpointTypes":{"type":"list","member":{"type":"structure","members":{"EngineName":{},"SupportsCDC":{"type":"boolean"},"EndpointType":{},"ReplicationInstanceEngineMinimumVersion":{},"EngineDisplayName":{}}}}}}},"DescribeEndpoints":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Endpoints":{"type":"list","member":{"shape":"S1q"}}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S3a"}}},"output":{"type":"structure","members":{"EventCategoryGroupList":{"type":"list","member":{"type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S1s"}}}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S1v"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S1s"},"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S1s"},"Date":{"type":"timestamp"}}}}}}},"DescribeOrderableReplicationInstances":{"input":{"type":"structure","members":{"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"OrderableReplicationInstances":{"type":"list","member":{"type":"structure","members":{"EngineVersion":{},"ReplicationInstanceClass":{},"StorageType":{},"MinAllocatedStorage":{"type":"integer"},"MaxAllocatedStorage":{"type":"integer"},"DefaultAllocatedStorage":{"type":"integer"},"IncludedAllocatedStorage":{"type":"integer"},"AvailabilityZones":{"type":"list","member":{}},"ReleaseStatus":{}}}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ReplicationInstanceArn":{},"Filters":{"shape":"S3a"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"S8"}},"Marker":{}}}},"DescribeRefreshSchemasStatus":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"RefreshSchemasStatus":{"shape":"S4i"}}}},"DescribeReplicationInstanceTaskLogs":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"ReplicationInstanceArn":{},"ReplicationInstanceTaskLogs":{"type":"list","member":{"type":"structure","members":{"ReplicationTaskName":{},"ReplicationTaskArn":{},"ReplicationInstanceTaskLogSize":{"type":"long"}}}},"Marker":{}}}},"DescribeReplicationInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationInstances":{"type":"list","member":{"shape":"S20"}}}}},"DescribeReplicationSubnetGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationSubnetGroups":{"type":"list","member":{"shape":"S23"}}}}},"DescribeReplicationTaskAssessmentResults":{"input":{"type":"structure","members":{"ReplicationTaskArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"BucketName":{},"ReplicationTaskAssessmentResults":{"type":"list","member":{"type":"structure","members":{"ReplicationTaskIdentifier":{},"ReplicationTaskArn":{},"ReplicationTaskLastAssessmentDate":{"type":"timestamp"},"AssessmentStatus":{},"AssessmentResultsFile":{},"AssessmentResults":{},"S3ObjectUrl":{}}}}}}},"DescribeReplicationTaskAssessmentRuns":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationTaskAssessmentRuns":{"type":"list","member":{"shape":"Se"}}}}},"DescribeReplicationTaskIndividualAssessments":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationTaskIndividualAssessments":{"type":"list","member":{"type":"structure","members":{"ReplicationTaskIndividualAssessmentArn":{},"ReplicationTaskAssessmentRunArn":{},"IndividualAssessmentName":{},"Status":{},"ReplicationTaskIndividualAssessmentStartDate":{"type":"timestamp"}}}}}}},"DescribeReplicationTasks":{"input":{"type":"structure","members":{"Filters":{"shape":"S3a"},"MaxRecords":{"type":"integer"},"Marker":{},"WithoutSettings":{"type":"boolean"}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationTasks":{"type":"list","member":{"shape":"S2g"}}}}},"DescribeSchemas":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Schemas":{"type":"list","member":{}}}}},"DescribeTableStatistics":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S3a"}}},"output":{"type":"structure","members":{"ReplicationTaskArn":{},"TableStatistics":{"type":"list","member":{"type":"structure","members":{"SchemaName":{},"TableName":{},"Inserts":{"type":"long"},"Deletes":{"type":"long"},"Updates":{"type":"long"},"Ddls":{"type":"long"},"FullLoadRows":{"type":"long"},"FullLoadCondtnlChkFailedRows":{"type":"long"},"FullLoadErrorRows":{"type":"long"},"FullLoadStartTime":{"type":"timestamp"},"FullLoadEndTime":{"type":"timestamp"},"FullLoadReloaded":{"type":"boolean"},"LastUpdateTime":{"type":"timestamp"},"TableState":{},"ValidationPendingRecords":{"type":"long"},"ValidationFailedRecords":{"type":"long"},"ValidationSuspendedRecords":{"type":"long"},"ValidationState":{},"ValidationStateDetails":{}}}},"Marker":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["CertificateIdentifier"],"members":{"CertificateIdentifier":{},"CertificatePem":{"shape":"Sj"},"CertificateWallet":{"type":"blob"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"Certificate":{"shape":"S2l"}}}},"ListTagsForResource":{"input":{"type":"structure","members":{"ResourceArn":{},"ResourceArnList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"TagList":{"shape":"S3"}}}},"ModifyEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{},"EndpointIdentifier":{},"EndpointType":{},"EngineName":{},"Username":{},"Password":{"shape":"Sj"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"ExtraConnectionAttributes":{},"CertificateArn":{},"SslMode":{},"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"DynamoDbSettings":{"shape":"Sm"},"S3Settings":{"shape":"Sn"},"DmsTransferSettings":{"shape":"Sx"},"MongoDbSettings":{"shape":"Sy"},"KinesisSettings":{"shape":"S12"},"KafkaSettings":{"shape":"S14"},"ElasticsearchSettings":{"shape":"S16"},"NeptuneSettings":{"shape":"S17"},"RedshiftSettings":{"shape":"S18"},"PostgreSQLSettings":{"shape":"S19"},"MySQLSettings":{"shape":"S1b"},"OracleSettings":{"shape":"S1d"},"SybaseSettings":{"shape":"S1g"},"MicrosoftSQLServerSettings":{"shape":"S1h"},"IBMDb2Settings":{"shape":"S1j"},"DocDbSettings":{"shape":"S1k"},"RedisSettings":{"shape":"S1l"},"ExactSettings":{"type":"boolean"},"GcpMySQLSettings":{"shape":"S1o"}}},"output":{"type":"structure","members":{"Endpoint":{"shape":"S1q"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S1s"},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"EventSubscription":{"shape":"S1v"}}}},"ModifyReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{},"AllocatedStorage":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReplicationInstanceClass":{},"VpcSecurityGroupIds":{"shape":"S1y"},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReplicationInstanceIdentifier":{}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S20"}}}},"ModifyReplicationSubnetGroup":{"input":{"type":"structure","required":["ReplicationSubnetGroupIdentifier","SubnetIds"],"members":{"ReplicationSubnetGroupIdentifier":{},"ReplicationSubnetGroupDescription":{},"SubnetIds":{"shape":"S2b"}}},"output":{"type":"structure","members":{"ReplicationSubnetGroup":{"shape":"S23"}}}},"ModifyReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{},"ReplicationTaskIdentifier":{},"MigrationType":{},"TableMappings":{},"ReplicationTaskSettings":{},"CdcStartTime":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{},"TaskData":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"MoveReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn","TargetReplicationInstanceArn"],"members":{"ReplicationTaskArn":{},"TargetReplicationInstanceArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"RebootReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{},"ForceFailover":{"type":"boolean"},"ForcePlannedFailover":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S20"}}}},"RefreshSchemas":{"input":{"type":"structure","required":["EndpointArn","ReplicationInstanceArn"],"members":{"EndpointArn":{},"ReplicationInstanceArn":{}}},"output":{"type":"structure","members":{"RefreshSchemasStatus":{"shape":"S4i"}}}},"ReloadTables":{"input":{"type":"structure","required":["ReplicationTaskArn","TablesToReload"],"members":{"ReplicationTaskArn":{},"TablesToReload":{"type":"list","member":{"type":"structure","required":["SchemaName","TableName"],"members":{"SchemaName":{},"TableName":{}}}},"ReloadOption":{}}},"output":{"type":"structure","members":{"ReplicationTaskArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn","StartReplicationTaskType"],"members":{"ReplicationTaskArn":{},"StartReplicationTaskType":{},"CdcStartTime":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"StartReplicationTaskAssessment":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"StartReplicationTaskAssessmentRun":{"input":{"type":"structure","required":["ReplicationTaskArn","ServiceAccessRoleArn","ResultLocationBucket","AssessmentRunName"],"members":{"ReplicationTaskArn":{},"ServiceAccessRoleArn":{},"ResultLocationBucket":{},"ResultLocationFolder":{},"ResultEncryptionMode":{},"ResultKmsKeyArn":{},"AssessmentRunName":{},"IncludeOnly":{"type":"list","member":{}},"Exclude":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ReplicationTaskAssessmentRun":{"shape":"Se"}}}},"StopReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S2g"}}}},"TestConnection":{"input":{"type":"structure","required":["ReplicationInstanceArn","EndpointArn"],"members":{"ReplicationInstanceArn":{},"EndpointArn":{}}},"output":{"type":"structure","members":{"Connection":{"shape":"S2p"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"ResourceArn":{}}}},"S8":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}}},"Se":{"type":"structure","members":{"ReplicationTaskAssessmentRunArn":{},"ReplicationTaskArn":{},"Status":{},"ReplicationTaskAssessmentRunCreationDate":{"type":"timestamp"},"AssessmentProgress":{"type":"structure","members":{"IndividualAssessmentCount":{"type":"integer"},"IndividualAssessmentCompletedCount":{"type":"integer"}}},"LastFailureMessage":{},"ServiceAccessRoleArn":{},"ResultLocationBucket":{},"ResultLocationFolder":{},"ResultEncryptionMode":{},"ResultKmsKeyArn":{},"AssessmentRunName":{}}},"Sj":{"type":"string","sensitive":true},"Sm":{"type":"structure","required":["ServiceAccessRoleArn"],"members":{"ServiceAccessRoleArn":{}}},"Sn":{"type":"structure","members":{"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"CsvRowDelimiter":{},"CsvDelimiter":{},"BucketFolder":{},"BucketName":{},"CompressionType":{},"EncryptionMode":{},"ServerSideEncryptionKmsKeyId":{},"DataFormat":{},"EncodingType":{},"DictPageSizeLimit":{"type":"integer"},"RowGroupLength":{"type":"integer"},"DataPageSize":{"type":"integer"},"ParquetVersion":{},"EnableStatistics":{"type":"boolean"},"IncludeOpForFullLoad":{"type":"boolean"},"CdcInsertsOnly":{"type":"boolean"},"TimestampColumnName":{},"ParquetTimestampInMillisecond":{"type":"boolean"},"CdcInsertsAndUpdates":{"type":"boolean"},"DatePartitionEnabled":{"type":"boolean"},"DatePartitionSequence":{},"DatePartitionDelimiter":{},"UseCsvNoSupValue":{"type":"boolean"},"CsvNoSupValue":{},"PreserveTransactions":{"type":"boolean"},"CdcPath":{},"UseTaskStartTimeForFullLoadTimestamp":{"type":"boolean"},"CannedAclForObjects":{},"AddColumnName":{"type":"boolean"},"CdcMaxBatchInterval":{"type":"integer"},"CdcMinFileSize":{"type":"integer"},"CsvNullValue":{},"IgnoreHeaderRows":{"type":"integer"},"MaxFileSize":{"type":"integer"},"Rfc4180":{"type":"boolean"},"DatePartitionTimezone":{}}},"Sx":{"type":"structure","members":{"ServiceAccessRoleArn":{},"BucketName":{}}},"Sy":{"type":"structure","members":{"Username":{},"Password":{"shape":"Sj"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"AuthType":{},"AuthMechanism":{},"NestingLevel":{},"ExtractDocId":{},"DocsToInvestigate":{},"AuthSource":{},"KmsKeyId":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S12":{"type":"structure","members":{"StreamArn":{},"MessageFormat":{},"ServiceAccessRoleArn":{},"IncludeTransactionDetails":{"type":"boolean"},"IncludePartitionValue":{"type":"boolean"},"PartitionIncludeSchemaTable":{"type":"boolean"},"IncludeTableAlterOperations":{"type":"boolean"},"IncludeControlDetails":{"type":"boolean"},"IncludeNullAndEmpty":{"type":"boolean"},"NoHexPrefix":{"type":"boolean"}}},"S14":{"type":"structure","members":{"Broker":{},"Topic":{},"MessageFormat":{},"IncludeTransactionDetails":{"type":"boolean"},"IncludePartitionValue":{"type":"boolean"},"PartitionIncludeSchemaTable":{"type":"boolean"},"IncludeTableAlterOperations":{"type":"boolean"},"IncludeControlDetails":{"type":"boolean"},"MessageMaxBytes":{"type":"integer"},"IncludeNullAndEmpty":{"type":"boolean"},"SecurityProtocol":{},"SslClientCertificateArn":{},"SslClientKeyArn":{},"SslClientKeyPassword":{"shape":"Sj"},"SslCaCertificateArn":{},"SaslUsername":{},"SaslPassword":{"shape":"Sj"},"NoHexPrefix":{"type":"boolean"}}},"S16":{"type":"structure","required":["ServiceAccessRoleArn","EndpointUri"],"members":{"ServiceAccessRoleArn":{},"EndpointUri":{},"FullLoadErrorPercentage":{"type":"integer"},"ErrorRetryDuration":{"type":"integer"}}},"S17":{"type":"structure","required":["S3BucketName","S3BucketFolder"],"members":{"ServiceAccessRoleArn":{},"S3BucketName":{},"S3BucketFolder":{},"ErrorRetryDuration":{"type":"integer"},"MaxFileSize":{"type":"integer"},"MaxRetryCount":{"type":"integer"},"IamAuthEnabled":{"type":"boolean"}}},"S18":{"type":"structure","members":{"AcceptAnyDate":{"type":"boolean"},"AfterConnectScript":{},"BucketFolder":{},"BucketName":{},"CaseSensitiveNames":{"type":"boolean"},"CompUpdate":{"type":"boolean"},"ConnectionTimeout":{"type":"integer"},"DatabaseName":{},"DateFormat":{},"EmptyAsNull":{"type":"boolean"},"EncryptionMode":{},"ExplicitIds":{"type":"boolean"},"FileTransferUploadStreams":{"type":"integer"},"LoadTimeout":{"type":"integer"},"MaxFileSize":{"type":"integer"},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"RemoveQuotes":{"type":"boolean"},"ReplaceInvalidChars":{},"ReplaceChars":{},"ServerName":{},"ServiceAccessRoleArn":{},"ServerSideEncryptionKmsKeyId":{},"TimeFormat":{},"TrimBlanks":{"type":"boolean"},"TruncateColumns":{"type":"boolean"},"Username":{},"WriteBufferSize":{"type":"integer"},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S19":{"type":"structure","members":{"AfterConnectScript":{},"CaptureDdls":{"type":"boolean"},"MaxFileSize":{"type":"integer"},"DatabaseName":{},"DdlArtifactsSchema":{},"ExecuteTimeout":{"type":"integer"},"FailTasksOnLobTruncation":{"type":"boolean"},"HeartbeatEnable":{"type":"boolean"},"HeartbeatSchema":{},"HeartbeatFrequency":{"type":"integer"},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"ServerName":{},"Username":{},"SlotName":{},"PluginName":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1b":{"type":"structure","members":{"AfterConnectScript":{},"CleanSourceMetadataOnMismatch":{"type":"boolean"},"DatabaseName":{},"EventsPollInterval":{"type":"integer"},"TargetDbType":{},"MaxFileSize":{"type":"integer"},"ParallelLoadThreads":{"type":"integer"},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"ServerName":{},"ServerTimezone":{},"Username":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1d":{"type":"structure","members":{"AddSupplementalLogging":{"type":"boolean"},"ArchivedLogDestId":{"type":"integer"},"AdditionalArchivedLogDestId":{"type":"integer"},"ExtraArchivedLogDestIds":{"type":"list","member":{"type":"integer"}},"AllowSelectNestedTables":{"type":"boolean"},"ParallelAsmReadThreads":{"type":"integer"},"ReadAheadBlocks":{"type":"integer"},"AccessAlternateDirectly":{"type":"boolean"},"UseAlternateFolderForOnline":{"type":"boolean"},"OraclePathPrefix":{},"UsePathPrefix":{},"ReplacePathPrefix":{"type":"boolean"},"EnableHomogenousTablespace":{"type":"boolean"},"DirectPathNoLog":{"type":"boolean"},"ArchivedLogsOnly":{"type":"boolean"},"AsmPassword":{"shape":"Sj"},"AsmServer":{},"AsmUser":{},"CharLengthSemantics":{},"DatabaseName":{},"DirectPathParallelLoad":{"type":"boolean"},"FailTasksOnLobTruncation":{"type":"boolean"},"NumberDatatypeScale":{"type":"integer"},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"ReadTableSpaceName":{"type":"boolean"},"RetryInterval":{"type":"integer"},"SecurityDbEncryption":{"shape":"Sj"},"SecurityDbEncryptionName":{},"ServerName":{},"SpatialDataOptionToGeoJsonFunctionName":{},"StandbyDelayTime":{"type":"integer"},"Username":{},"UseBFile":{"type":"boolean"},"UseDirectPathFullLoad":{"type":"boolean"},"UseLogminerReader":{"type":"boolean"},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{},"SecretsManagerOracleAsmAccessRoleArn":{},"SecretsManagerOracleAsmSecretId":{}}},"S1g":{"type":"structure","members":{"DatabaseName":{},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"ServerName":{},"Username":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1h":{"type":"structure","members":{"Port":{"type":"integer"},"BcpPacketSize":{"type":"integer"},"DatabaseName":{},"ControlTablesFileGroup":{},"Password":{"shape":"Sj"},"QuerySingleAlwaysOnNode":{"type":"boolean"},"ReadBackupOnly":{"type":"boolean"},"SafeguardPolicy":{},"ServerName":{},"Username":{},"UseBcpFullLoad":{"type":"boolean"},"UseThirdPartyBackupDevice":{"type":"boolean"},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1j":{"type":"structure","members":{"DatabaseName":{},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"ServerName":{},"SetDataCaptureChanges":{"type":"boolean"},"CurrentLsn":{},"MaxKBytesPerRead":{"type":"integer"},"Username":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1k":{"type":"structure","members":{"Username":{},"Password":{"shape":"Sj"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"NestingLevel":{},"ExtractDocId":{"type":"boolean"},"DocsToInvestigate":{"type":"integer"},"KmsKeyId":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1l":{"type":"structure","required":["ServerName","Port"],"members":{"ServerName":{},"Port":{"type":"integer"},"SslSecurityProtocol":{},"AuthType":{},"AuthUserName":{},"AuthPassword":{"shape":"Sj"},"SslCaCertificateArn":{}}},"S1o":{"type":"structure","members":{"AfterConnectScript":{},"CleanSourceMetadataOnMismatch":{"type":"boolean"},"DatabaseName":{},"EventsPollInterval":{"type":"integer"},"TargetDbType":{},"MaxFileSize":{"type":"integer"},"ParallelLoadThreads":{"type":"integer"},"Password":{"shape":"Sj"},"Port":{"type":"integer"},"ServerName":{},"ServerTimezone":{},"Username":{},"SecretsManagerAccessRoleArn":{},"SecretsManagerSecretId":{}}},"S1q":{"type":"structure","members":{"EndpointIdentifier":{},"EndpointType":{},"EngineName":{},"EngineDisplayName":{},"Username":{},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"ExtraConnectionAttributes":{},"Status":{},"KmsKeyId":{},"EndpointArn":{},"CertificateArn":{},"SslMode":{},"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"ExternalId":{},"DynamoDbSettings":{"shape":"Sm"},"S3Settings":{"shape":"Sn"},"DmsTransferSettings":{"shape":"Sx"},"MongoDbSettings":{"shape":"Sy"},"KinesisSettings":{"shape":"S12"},"KafkaSettings":{"shape":"S14"},"ElasticsearchSettings":{"shape":"S16"},"NeptuneSettings":{"shape":"S17"},"RedshiftSettings":{"shape":"S18"},"PostgreSQLSettings":{"shape":"S19"},"MySQLSettings":{"shape":"S1b"},"OracleSettings":{"shape":"S1d"},"SybaseSettings":{"shape":"S1g"},"MicrosoftSQLServerSettings":{"shape":"S1h"},"IBMDb2Settings":{"shape":"S1j"},"DocDbSettings":{"shape":"S1k"},"RedisSettings":{"shape":"S1l"},"GcpMySQLSettings":{"shape":"S1o"}}},"S1s":{"type":"list","member":{}},"S1t":{"type":"list","member":{}},"S1v":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S1t"},"EventCategoriesList":{"shape":"S1s"},"Enabled":{"type":"boolean"}}},"S1y":{"type":"list","member":{}},"S20":{"type":"structure","members":{"ReplicationInstanceIdentifier":{},"ReplicationInstanceClass":{},"ReplicationInstanceStatus":{},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"VpcSecurityGroups":{"type":"list","member":{"type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"AvailabilityZone":{},"ReplicationSubnetGroup":{"shape":"S23"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"ReplicationInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{}}},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"KmsKeyId":{},"ReplicationInstanceArn":{},"ReplicationInstancePublicIpAddress":{"deprecated":true},"ReplicationInstancePrivateIpAddress":{"deprecated":true},"ReplicationInstancePublicIpAddresses":{"type":"list","member":{}},"ReplicationInstancePrivateIpAddresses":{"type":"list","member":{}},"PubliclyAccessible":{"type":"boolean"},"SecondaryAvailabilityZone":{},"FreeUntil":{"type":"timestamp"},"DnsNameServers":{}}},"S23":{"type":"structure","members":{"ReplicationSubnetGroupIdentifier":{},"ReplicationSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}}},"SubnetStatus":{}}}}}},"S2b":{"type":"list","member":{}},"S2g":{"type":"structure","members":{"ReplicationTaskIdentifier":{},"SourceEndpointArn":{},"TargetEndpointArn":{},"ReplicationInstanceArn":{},"MigrationType":{},"TableMappings":{},"ReplicationTaskSettings":{},"Status":{},"LastFailureMessage":{},"StopReason":{},"ReplicationTaskCreationDate":{"type":"timestamp"},"ReplicationTaskStartDate":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{},"RecoveryCheckpoint":{},"ReplicationTaskArn":{},"ReplicationTaskStats":{"type":"structure","members":{"FullLoadProgressPercent":{"type":"integer"},"ElapsedTimeMillis":{"type":"long"},"TablesLoaded":{"type":"integer"},"TablesLoading":{"type":"integer"},"TablesQueued":{"type":"integer"},"TablesErrored":{"type":"integer"},"FreshStartDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"StopDate":{"type":"timestamp"},"FullLoadStartDate":{"type":"timestamp"},"FullLoadFinishDate":{"type":"timestamp"}}},"TaskData":{},"TargetReplicationInstanceArn":{}}},"S2l":{"type":"structure","members":{"CertificateIdentifier":{},"CertificateCreationDate":{"type":"timestamp"},"CertificatePem":{},"CertificateWallet":{"type":"blob"},"CertificateArn":{},"CertificateOwner":{},"ValidFromDate":{"type":"timestamp"},"ValidToDate":{"type":"timestamp"},"SigningAlgorithm":{},"KeyLength":{"type":"integer"}}},"S2p":{"type":"structure","members":{"ReplicationInstanceArn":{},"EndpointArn":{},"Status":{},"LastFailureMessage":{},"EndpointIdentifier":{},"ReplicationInstanceIdentifier":{}}},"S3a":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S4i":{"type":"structure","members":{"EndpointArn":{},"ReplicationInstanceArn":{},"Status":{},"LastRefreshDate":{"type":"timestamp"},"LastFailureMessage":{}}}}}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeApplicableIndividualAssessments":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeCertificates":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeConnections":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEndpointSettings":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEndpointTypes":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEndpoints":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEventSubscriptions":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEvents":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeOrderableReplicationInstances":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribePendingMaintenanceActions":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationInstanceTaskLogs":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationInstances":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationSubnetGroups":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationTaskAssessmentResults":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationTaskAssessmentRuns":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationTaskIndividualAssessments":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationTasks":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeSchemas":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeTableStatistics":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"}}}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"TestConnectionSucceeds":{"acceptors":[{"argument":"Connections[].Status","expected":"successful","matcher":"pathAll","state":"success"},{"argument":"Connections[].Status","expected":"failed","matcher":"pathAny","state":"failure"}],"delay":5,"description":"Wait until testing connection succeeds.","maxAttempts":60,"operation":"DescribeConnections"},"EndpointDeleted":{"acceptors":[{"expected":"ResourceNotFoundFault","matcher":"error","state":"success"},{"argument":"Endpoints[].Status","expected":"active","matcher":"pathAny","state":"failure"},{"argument":"Endpoints[].Status","expected":"creating","matcher":"pathAny","state":"failure"}],"delay":5,"description":"Wait until testing endpoint is deleted.","maxAttempts":60,"operation":"DescribeEndpoints"},"ReplicationInstanceAvailable":{"acceptors":[{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"incompatible-credentials","matcher":"pathAny","state":"failure"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"inaccessible-encryption-credentials","matcher":"pathAny","state":"failure"}],"delay":60,"description":"Wait until DMS replication instance is available.","maxAttempts":60,"operation":"DescribeReplicationInstances"},"ReplicationInstanceDeleted":{"acceptors":[{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ResourceNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until DMS replication instance is deleted.","maxAttempts":60,"operation":"DescribeReplicationInstances"},"ReplicationTaskReady":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAll","state":"success"},{"argument":"ReplicationTasks[].Status","expected":"starting","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopping","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"testing","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"deleting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until DMS replication task is ready.","maxAttempts":60,"operation":"DescribeReplicationTasks"},"ReplicationTaskStopped":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAll","state":"success"},{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"starting","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"testing","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"deleting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until DMS replication task is stopped.","maxAttempts":60,"operation":"DescribeReplicationTasks"},"ReplicationTaskRunning":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAll","state":"success"},{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopping","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"testing","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"deleting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until DMS replication task is running.","maxAttempts":60,"operation":"DescribeReplicationTasks"},"ReplicationTaskDeleted":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"expected":"ResourceNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until DMS replication task is deleted.","maxAttempts":60,"operation":"DescribeReplicationTasks"}}}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['dynamodb'] = {};
	AWS.DynamoDB = Service.defineService('dynamodb', ['2011-12-05', '2012-08-10']);
	__webpack_require__(176);
	Object.defineProperty(apiLoader.services['dynamodb'], '2011-12-05', {
	  get: function get() {
	    var model = __webpack_require__(183);
	    model.paginators = __webpack_require__(184).pagination;
	    model.waiters = __webpack_require__(185).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['dynamodb'], '2012-08-10', {
	  get: function get() {
	    var model = __webpack_require__(186);
	    model.paginators = __webpack_require__(187).pagination;
	    model.waiters = __webpack_require__(188).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DynamoDB;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	__webpack_require__(177);

	AWS.util.update(AWS.DynamoDB.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.service.config.dynamoDbCrc32) {
	      request.removeListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
	      request.addListener('extractData', this.checkCrc32);
	      request.addListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
	    }
	  },

	  /**
	   * @api private
	   */
	  checkCrc32: function checkCrc32(resp) {
	    if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
	      resp.data = null;
	      resp.error = AWS.util.error(new Error(), {
	        code: 'CRC32CheckFailed',
	        message: 'CRC32 integrity check failed',
	        retryable: true
	      });
	      resp.request.haltHandlersOnError();
	      throw (resp.error);
	    }
	  },

	  /**
	   * @api private
	   */
	  crc32IsValid: function crc32IsValid(resp) {
	    var crc = resp.httpResponse.headers['x-amz-crc32'];
	    if (!crc) return true; // no (valid) CRC32 header
	    return parseInt(crc, 10) === AWS.util.crypto.crc32(resp.httpResponse.body);
	  },

	  /**
	   * @api private
	   */
	  defaultRetryCount: 10,

	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount, err) {
	    var retryDelayOptions = AWS.util.copy(this.config.retryDelayOptions);

	    if (typeof retryDelayOptions.base !== 'number') {
	        retryDelayOptions.base = 50; // default for dynamodb
	    }
	    var delay = AWS.util.calculateRetryDelay(retryCount, retryDelayOptions, err);
	    return delay;
	  }
	});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var Translator = __webpack_require__(178);
	var DynamoDBSet = __webpack_require__(181);

	/**
	 * The document client simplifies working with items in Amazon DynamoDB
	 * by abstracting away the notion of attribute values. This abstraction
	 * annotates native JavaScript types supplied as input parameters, as well
	 * as converts annotated response data to native JavaScript types.
	 *
	 * ## Marshalling Input and Unmarshalling Response Data
	 *
	 * The document client affords developers the use of native JavaScript types
	 * instead of `AttributeValue`s to simplify the JavaScript development
	 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
	 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
	 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
	 * by the `DocumentClient`. The `DocumentClient`, does not accept
	 * `AttributeValue`s in favor of native JavaScript types.
	 *
	 * |                             JavaScript Type                            | DynamoDB AttributeValue |
	 * |:----------------------------------------------------------------------:|-------------------------|
	 * | String                                                                 | S                       |
	 * | Number                                                                 | N                       |
	 * | Boolean                                                                | BOOL                    |
	 * | null                                                                   | NULL                    |
	 * | Array                                                                  | L                       |
	 * | Object                                                                 | M                       |
	 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
	 *
	 * ## Support for Sets
	 *
	 * The `DocumentClient` offers a convenient way to create sets from
	 * JavaScript Arrays. The type of set is inferred from the first element
	 * in the array. DynamoDB supports string, number, and binary sets. To
	 * learn more about supported types see the
	 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
	 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
	 *
	 */
	AWS.DynamoDB.DocumentClient = AWS.util.inherit({

	  /**
	   * Creates a DynamoDB document client with a set of configuration options.
	   *
	   * @option options params [map] An optional map of parameters to bind to every
	   *   request sent by this service object.
	   * @option options service [AWS.DynamoDB] An optional pre-configured instance
	   *  of the AWS.DynamoDB service object to use for requests. The object may
	   *  bound parameters used by the document client.
	   * @option options convertEmptyValues [Boolean] set to true if you would like
	   *  the document client to convert empty values (0-length strings, binary
	   *  buffers, and sets) to be converted to NULL types when persisting to
	   *  DynamoDB.
	   * @option options wrapNumbers [Boolean] Set to true to return numbers as a
	   *  NumberValue object instead of converting them to native JavaScript numbers.
	   *  This allows for the safe round-trip transport of numbers of arbitrary size.
	   * @see AWS.DynamoDB.constructor
	   *
	   */
	  constructor: function DocumentClient(options) {
	    var self = this;
	    self.options = options || {};
	    self.configure(self.options);
	  },

	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    var self = this;
	    self.service = options.service;
	    self.bindServiceObject(options);
	    self.attrValue = options.attrValue =
	      self.service.api.operations.putItem.input.members.Item.value.shape;
	  },

	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(options) {
	    var self = this;
	    options = options || {};

	    if (!self.service) {
	      self.service = new AWS.DynamoDB(options);
	    } else {
	      var config = AWS.util.copy(self.service.config);
	      self.service = new self.service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, options.params);
	    }
	  },

	  /**
	   * @api private
	   */
	  makeServiceRequest: function(operation, params, callback) {
	    var self = this;
	    var request = self.service[operation](params);
	    self.setupRequest(request);
	    self.setupResponse(request);
	    if (typeof callback === 'function') {
	      request.send(callback);
	    }
	    return request;
	  },

	  /**
	   * @api private
	   */
	  serviceClientOperationsMap: {
	    batchGet: 'batchGetItem',
	    batchWrite: 'batchWriteItem',
	    delete: 'deleteItem',
	    get: 'getItem',
	    put: 'putItem',
	    query: 'query',
	    scan: 'scan',
	    update: 'updateItem',
	    transactGet: 'transactGetItems',
	    transactWrite: 'transactWriteItems'
	  },

	  /**
	   * Returns the attributes of one or more items from one or more tables
	   * by delegating to `AWS.DynamoDB.batchGetItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.batchGetItem
	   * @example Get items from multiple tables
	   *  var params = {
	   *    RequestItems: {
	   *      'Table-1': {
	   *        Keys: [
	   *          {
	   *             HashKey: 'haskey',
	   *             NumberRangeKey: 1
	   *          }
	   *        ]
	   *      },
	   *      'Table-2': {
	   *        Keys: [
	   *          { foo: 'bar' },
	   *        ]
	   *      }
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.batchGet(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  batchGet: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['batchGet'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Puts or deletes multiple items in one or more tables by delegating
	   * to `AWS.DynamoDB.batchWriteItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.batchWriteItem
	   * @example Write to and delete from a table
	   *  var params = {
	   *    RequestItems: {
	   *      'Table-1': [
	   *        {
	   *          DeleteRequest: {
	   *            Key: { HashKey: 'someKey' }
	   *          }
	   *        },
	   *        {
	   *          PutRequest: {
	   *            Item: {
	   *              HashKey: 'anotherKey',
	   *              NumAttribute: 1,
	   *              BoolAttribute: true,
	   *              ListAttribute: [1, 'two', false],
	   *              MapAttribute: { foo: 'bar' }
	   *            }
	   *          }
	   *        }
	   *      ]
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.batchWrite(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  batchWrite: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['batchWrite'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Deletes a single item in a table by primary key by delegating to
	   * `AWS.DynamoDB.deleteItem()`
	   *
	   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.deleteItem
	   * @example Delete an item from a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Key: {
	   *      HashKey: 'hashkey',
	   *      NumberRangeKey: 1
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.delete(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  delete: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['delete'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Returns a set of attributes for the item with the given primary key
	   * by delegating to `AWS.DynamoDB.getItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.getItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.getItem
	   * @example Get an item from a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Key: {
	   *      HashKey: 'hashkey'
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.get(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  get: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['get'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Creates a new item, or replaces an old item with a new item by
	   * delegating to `AWS.DynamoDB.putItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.putItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.putItem
	   * @example Create a new item in a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Item: {
	   *       HashKey: 'haskey',
	   *       NumAttribute: 1,
	   *       BoolAttribute: true,
	   *       ListAttribute: [1, 'two', false],
	   *       MapAttribute: { foo: 'bar'},
	   *       NullAttribute: null
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.put(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  put: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['put'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Edits an existing item's attributes, or adds a new item to the table if
	   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.updateItem
	   * @example Update an item with expressions
	   *  var params = {
	   *    TableName: 'Table',
	   *    Key: { HashKey : 'hashkey' },
	   *    UpdateExpression: 'set #a = :x + :y',
	   *    ConditionExpression: '#a < :MAX',
	   *    ExpressionAttributeNames: {'#a' : 'Sum'},
	   *    ExpressionAttributeValues: {
	   *      ':x' : 20,
	   *      ':y' : 45,
	   *      ':MAX' : 100,
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.update(params, function(err, data) {
	   *     if (err) console.log(err);
	   *     else console.log(data);
	   *  });
	   *
	   */
	  update: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['update'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Returns one or more items and item attributes by accessing every item
	   * in a table or a secondary index.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.scan} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.scan
	   * @example Scan the table with a filter expression
	   *  var params = {
	   *    TableName : 'Table',
	   *    FilterExpression : 'Year = :this_year',
	   *    ExpressionAttributeValues : {':this_year' : 2015}
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.scan(params, function(err, data) {
	   *     if (err) console.log(err);
	   *     else console.log(data);
	   *  });
	   *
	   */
	  scan: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['scan'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	   /**
	    * Directly access items from a table by primary key or a secondary index.
	    *
	    * Supply the same parameters as {AWS.DynamoDB.query} with
	    * `AttributeValue`s substituted by native JavaScript types.
	    *
	    * @see AWS.DynamoDB.query
	    * @example Query an index
	    *  var params = {
	    *    TableName: 'Table',
	    *    IndexName: 'Index',
	    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
	    *    ExpressionAttributeValues: {
	    *      ':hkey': 'key',
	    *      ':rkey': 2015
	    *    }
	    *  };
	    *
	    *  var documentClient = new AWS.DynamoDB.DocumentClient();
	    *
	    *  documentClient.query(params, function(err, data) {
	    *     if (err) console.log(err);
	    *     else console.log(data);
	    *  });
	    *
	    */
	  query: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['query'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Synchronous write operation that groups up to 25 action requests.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.transactWriteItems} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.transactWriteItems
	   * @example Get items from multiple tables
	   *  var params = {
	   *    TransactItems: [{
	   *      Put: {
	   *        TableName : 'Table0',
	   *        Item: {
	   *          HashKey: 'haskey',
	   *          NumAttribute: 1,
	   *          BoolAttribute: true,
	   *          ListAttribute: [1, 'two', false],
	   *          MapAttribute: { foo: 'bar'},
	   *          NullAttribute: null
	   *        }
	   *      }
	   *    }, {
	   *      Update: {
	   *        TableName: 'Table1',
	   *        Key: { HashKey : 'hashkey' },
	   *        UpdateExpression: 'set #a = :x + :y',
	   *        ConditionExpression: '#a < :MAX',
	   *        ExpressionAttributeNames: {'#a' : 'Sum'},
	   *        ExpressionAttributeValues: {
	   *          ':x' : 20,
	   *          ':y' : 45,
	   *          ':MAX' : 100,
	   *        }
	   *      }
	   *    }]
	   *  };
	   *
	   *  documentClient.transactWrite(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   */
	  transactWrite: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['transactWrite'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Atomically retrieves multiple items from one or more tables (but not from indexes)
	   * in a single account and region.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.transactGetItems} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.transactGetItems
	   * @example Get items from multiple tables
	   *  var params = {
	   *    TransactItems: [{
	   *      Get: {
	   *        TableName : 'Table0',
	   *        Key: {
	   *          HashKey: 'hashkey0'
	   *        }
	   *      }
	   *    }, {
	   *      Get: {
	   *        TableName : 'Table1',
	   *        Key: {
	   *          HashKey: 'hashkey1'
	   *        }
	   *      }
	   *    }]
	   *  };
	   *
	   *  documentClient.transactGet(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   */
	  transactGet: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['transactGet'];
	    return this.makeServiceRequest(operation, params, callback);
	  },

	  /**
	   * Creates a set of elements inferring the type of set from
	   * the type of the first element. Amazon DynamoDB currently supports
	   * the number sets, string sets, and binary sets. For more information
	   * about DynamoDB data types see the documentation on the
	   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
	   *
	   * @param list [Array] Collection to represent your DynamoDB Set
	   * @param options [map]
	   *  * **validate** [Boolean] set to true if you want to validate the type
	   *    of each element in the set. Defaults to `false`.
	   * @example Creating a number set
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  var params = {
	   *    Item: {
	   *      hashkey: 'hashkey'
	   *      numbers: documentClient.createSet([1, 2, 3]);
	   *    }
	   *  };
	   *
	   *  documentClient.put(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  createSet: function(list, options) {
	    options = options || {};
	    return new DynamoDBSet(list, options);
	  },

	  /**
	   * @api private
	   */
	  getTranslator: function() {
	    return new Translator(this.options);
	  },

	  /**
	   * @api private
	   */
	  setupRequest: function setupRequest(request) {
	    var self = this;
	    var translator = self.getTranslator();
	    var operation = request.operation;
	    var inputShape = request.service.api.operations[operation].input;
	    request._events.validate.unshift(function(req) {
	      req.rawParams = AWS.util.copy(req.params);
	      req.params = translator.translateInput(req.rawParams, inputShape);
	    });
	  },

	  /**
	   * @api private
	   */
	  setupResponse: function setupResponse(request) {
	    var self = this;
	    var translator = self.getTranslator();
	    var outputShape = self.service.api.operations[request.operation].output;
	    request.on('extractData', function(response) {
	      response.data = translator.translateOutput(response.data, outputShape);
	    });

	    var response = request.response;
	    response.nextPage = function(cb) {
	      var resp = this;
	      var req = resp.request;
	      var config;
	      var service = req.service;
	      var operation = req.operation;
	      try {
	        config = service.paginationConfig(operation, true);
	      } catch (e) { resp.error = e; }

	      if (!resp.hasNextPage()) {
	        if (cb) cb(resp.error, null);
	        else if (resp.error) throw resp.error;
	        return null;
	      }

	      var params = AWS.util.copy(req.rawParams);
	      if (!resp.nextPageTokens) {
	        return cb ? cb(null, null) : null;
	      } else {
	        var inputTokens = config.inputToken;
	        if (typeof inputTokens === 'string') inputTokens = [inputTokens];
	        for (var i = 0; i < inputTokens.length; i++) {
	          params[inputTokens[i]] = resp.nextPageTokens[i];
	        }
	        return self[operation](params, cb);
	      }
	    };
	  }

	});

	/**
	 * @api private
	 */
	module.exports = AWS.DynamoDB.DocumentClient;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var convert = __webpack_require__(179);

	var Translator = function(options) {
	  options = options || {};
	  this.attrValue = options.attrValue;
	  this.convertEmptyValues = Boolean(options.convertEmptyValues);
	  this.wrapNumbers = Boolean(options.wrapNumbers);
	};

	Translator.prototype.translateInput = function(value, shape) {
	  this.mode = 'input';
	  return this.translate(value, shape);
	};

	Translator.prototype.translateOutput = function(value, shape) {
	  this.mode = 'output';
	  return this.translate(value, shape);
	};

	Translator.prototype.translate = function(value, shape) {
	  var self = this;
	  if (!shape || value === undefined) return undefined;

	  if (shape.shape === self.attrValue) {
	    return convert[self.mode](value, {
	      convertEmptyValues: self.convertEmptyValues,
	      wrapNumbers: self.wrapNumbers,
	    });
	  }
	  switch (shape.type) {
	    case 'structure': return self.translateStructure(value, shape);
	    case 'map': return self.translateMap(value, shape);
	    case 'list': return self.translateList(value, shape);
	    default: return self.translateScalar(value, shape);
	  }
	};

	Translator.prototype.translateStructure = function(structure, shape) {
	  var self = this;
	  if (structure == null) return undefined;

	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      var result = self.translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	};

	Translator.prototype.translateList = function(list, shape) {
	  var self = this;
	  if (list == null) return undefined;

	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = self.translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	};

	Translator.prototype.translateMap = function(map, shape) {
	  var self = this;
	  if (map == null) return undefined;

	  var out = {};
	  util.each(map, function(key, value) {
	    var result = self.translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	};

	Translator.prototype.translateScalar = function(value, shape) {
	  return shape.toType(value);
	};

	/**
	 * @api private
	 */
	module.exports = Translator;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var util = AWS.util;
	var typeOf = __webpack_require__(180).typeOf;
	var DynamoDBSet = __webpack_require__(181);
	var NumberValue = __webpack_require__(182);

	AWS.DynamoDB.Converter = {
	  /**
	   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
	   *
	   * @param data [any] The data to convert to a DynamoDB AttributeValue
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   * @return [map] An object in the Amazon DynamoDB AttributeValue format
	   *
	   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
	   *    convert entire records (rather than individual attributes)
	   */
	  input: function convertInput(data, options) {
	    options = options || {};
	    var type = typeOf(data);
	    if (type === 'Object') {
	      return formatMap(data, options);
	    } else if (type === 'Array') {
	      return formatList(data, options);
	    } else if (type === 'Set') {
	      return formatSet(data, options);
	    } else if (type === 'String') {
	      if (data.length === 0 && options.convertEmptyValues) {
	        return convertInput(null);
	      }
	      return { S: data };
	    } else if (type === 'Number' || type === 'NumberValue') {
	      return { N: data.toString() };
	    } else if (type === 'Binary') {
	      if (data.length === 0 && options.convertEmptyValues) {
	        return convertInput(null);
	      }
	      return { B: data };
	    } else if (type === 'Boolean') {
	      return { BOOL: data };
	    } else if (type === 'null') {
	      return { NULL: true };
	    } else if (type !== 'undefined' && type !== 'Function') {
	      // this value has a custom constructor
	      return formatMap(data, options);
	    }
	  },

	  /**
	   * Convert a JavaScript object into a DynamoDB record.
	   *
	   * @param data [any] The data to convert to a DynamoDB record
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [map] An object in the DynamoDB record format.
	   *
	   * @example Convert a JavaScript object into a DynamoDB record
	   *  var marshalled = AWS.DynamoDB.Converter.marshall({
	   *    string: 'foo',
	   *    list: ['fizz', 'buzz', 'pop'],
	   *    map: {
	   *      nestedMap: {
	   *        key: 'value',
	   *      }
	   *    },
	   *    number: 123,
	   *    nullValue: null,
	   *    boolValue: true,
	   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
	   *  });
	   */
	  marshall: function marshallItem(data, options) {
	    return AWS.DynamoDB.Converter.input(data, options).M;
	  },

	  /**
	   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
	   *
	   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [Object|Array|String|Number|Boolean|null]
	   *
	   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
	   *    convert entire records (rather than individual attributes)
	   */
	  output: function convertOutput(data, options) {
	    options = options || {};
	    var list, map, i;
	    for (var type in data) {
	      var values = data[type];
	      if (type === 'M') {
	        map = {};
	        for (var key in values) {
	          map[key] = convertOutput(values[key], options);
	        }
	        return map;
	      } else if (type === 'L') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(convertOutput(values[i], options));
	        }
	        return list;
	      } else if (type === 'SS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(values[i] + '');
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'NS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(convertNumber(values[i], options.wrapNumbers));
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'BS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(AWS.util.buffer.toBuffer(values[i]));
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'S') {
	        return values + '';
	      } else if (type === 'N') {
	        return convertNumber(values, options.wrapNumbers);
	      } else if (type === 'B') {
	        return util.buffer.toBuffer(values);
	      } else if (type === 'BOOL') {
	        return (values === 'true' || values === 'TRUE' || values === true);
	      } else if (type === 'NULL') {
	        return null;
	      }
	    }
	  },

	  /**
	   * Convert a DynamoDB record into a JavaScript object.
	   *
	   * @param data [any] The DynamoDB record
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [map] An object whose properties have been converted from
	   *    DynamoDB's AttributeValue format into their corresponding native
	   *    JavaScript types.
	   *
	   * @example Convert a record received from a DynamoDB stream
	   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
	   *    string: {S: 'foo'},
	   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
	   *    map: {
	   *      M: {
	   *        nestedMap: {
	   *          M: {
	   *            key: {S: 'value'}
	   *          }
	   *        }
	   *      }
	   *    },
	   *    number: {N: '123'},
	   *    nullValue: {NULL: true},
	   *    boolValue: {BOOL: true}
	   *  });
	   */
	  unmarshall: function unmarshall(data, options) {
	    return AWS.DynamoDB.Converter.output({M: data}, options);
	  }
	};

	/**
	 * @api private
	 * @param data [Array]
	 * @param options [map]
	 */
	function formatList(data, options) {
	  var list = {L: []};
	  for (var i = 0; i < data.length; i++) {
	    list['L'].push(AWS.DynamoDB.Converter.input(data[i], options));
	  }
	  return list;
	}

	/**
	 * @api private
	 * @param value [String]
	 * @param wrapNumbers [Boolean]
	 */
	function convertNumber(value, wrapNumbers) {
	  return wrapNumbers ? new NumberValue(value) : Number(value);
	}

	/**
	 * @api private
	 * @param data [map]
	 * @param options [map]
	 */
	function formatMap(data, options) {
	  var map = {M: {}};
	  for (var key in data) {
	    var formatted = AWS.DynamoDB.Converter.input(data[key], options);
	    if (formatted !== void 0) {
	      map['M'][key] = formatted;
	    }
	  }
	  return map;
	}

	/**
	 * @api private
	 */
	function formatSet(data, options) {
	  options = options || {};
	  var values = data.values;
	  if (options.convertEmptyValues) {
	    values = filterEmptySetValues(data);
	    if (values.length === 0) {
	      return AWS.DynamoDB.Converter.input(null);
	    }
	  }

	  var map = {};
	  switch (data.type) {
	    case 'String': map['SS'] = values; break;
	    case 'Binary': map['BS'] = values; break;
	    case 'Number': map['NS'] = values.map(function (value) {
	      return value.toString();
	    });
	  }
	  return map;
	}

	/**
	 * @api private
	 */
	function filterEmptySetValues(set) {
	    var nonEmptyValues = [];
	    var potentiallyEmptyTypes = {
	        String: true,
	        Binary: true,
	        Number: false
	    };
	    if (potentiallyEmptyTypes[set.type]) {
	        for (var i = 0; i < set.values.length; i++) {
	            if (set.values[i].length === 0) {
	                continue;
	            }
	            nonEmptyValues.push(set.values[i]);
	        }

	        return nonEmptyValues;
	    }

	    return set.values;
	}

	/**
	 * @api private
	 */
	module.exports = AWS.DynamoDB.Converter;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;

	function typeOf(data) {
	  if (data === null && typeof data === 'object') {
	    return 'null';
	  } else if (data !== undefined && isBinary(data)) {
	    return 'Binary';
	  } else if (data !== undefined && data.constructor) {
	    return data.wrapperName || util.typeName(data.constructor);
	  } else if (data !== undefined && typeof data === 'object') {
	    // this object is the result of Object.create(null), hence the absence of a
	    // defined constructor
	    return 'Object';
	  } else {
	    return 'undefined';
	  }
	}

	function isBinary(data) {
	  var types = [
	    'Buffer', 'File', 'Blob', 'ArrayBuffer', 'DataView',
	    'Int8Array', 'Uint8Array', 'Uint8ClampedArray',
	    'Int16Array', 'Uint16Array', 'Int32Array', 'Uint32Array',
	    'Float32Array', 'Float64Array'
	  ];
	  if (util.isNode()) {
	    var Stream = util.stream.Stream;
	    if (util.Buffer.isBuffer(data) || data instanceof Stream) {
	      return true;
	    }
	  }

	  for (var i = 0; i < types.length; i++) {
	    if (data !== undefined && data.constructor) {
	      if (util.isType(data, types[i])) return true;
	      if (util.typeName(data.constructor) === types[i]) return true;
	    }
	  }

	  return false;
	}

	/**
	 * @api private
	 */
	module.exports = {
	  typeOf: typeOf,
	  isBinary: isBinary
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var typeOf = __webpack_require__(180).typeOf;

	/**
	 * @api private
	 */
	var memberTypeToSetType = {
	  'String': 'String',
	  'Number': 'Number',
	  'NumberValue': 'Number',
	  'Binary': 'Binary'
	};

	/**
	 * @api private
	 */
	var DynamoDBSet = util.inherit({

	  constructor: function Set(list, options) {
	    options = options || {};
	    this.wrapperName = 'Set';
	    this.initialize(list, options.validate);
	  },

	  initialize: function(list, validate) {
	    var self = this;
	    self.values = [].concat(list);
	    self.detectType();
	    if (validate) {
	      self.validate();
	    }
	  },

	  detectType: function() {
	    this.type = memberTypeToSetType[typeOf(this.values[0])];
	    if (!this.type) {
	      throw util.error(new Error(), {
	        code: 'InvalidSetType',
	        message: 'Sets can contain string, number, or binary values'
	      });
	    }
	  },

	  validate: function() {
	    var self = this;
	    var length = self.values.length;
	    var values = self.values;
	    for (var i = 0; i < length; i++) {
	      if (memberTypeToSetType[typeOf(values[i])] !== self.type) {
	        throw util.error(new Error(), {
	          code: 'InvalidType',
	          message: self.type + ' Set contains ' + typeOf(values[i]) + ' value'
	        });
	      }
	    }
	  },

	  /**
	   * Render the underlying values only when converting to JSON.
	   */
	  toJSON: function() {
	    var self = this;
	    return self.values;
	  }

	});

	/**
	 * @api private
	 */
	module.exports = DynamoDBSet;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;

	/**
	 * An object recognizable as a numeric value that stores the underlying number
	 * as a string.
	 *
	 * Intended to be a deserialization target for the DynamoDB Document Client when
	 * the `wrapNumbers` flag is set. This allows for numeric values that lose
	 * precision when converted to JavaScript's `number` type.
	 */
	var DynamoDBNumberValue = util.inherit({
	  constructor: function NumberValue(value) {
	    this.wrapperName = 'NumberValue';
	    this.value = value.toString();
	  },

	  /**
	   * Render the underlying value as a number when converting to JSON.
	   */
	  toJSON: function () {
	    return this.toNumber();
	  },

	  /**
	   * Convert the underlying value to a JavaScript number.
	   */
	  toNumber: function () {
	    return Number(this.value);
	  },

	  /**
	   * Return a string representing the unaltered value provided to the
	   * constructor.
	   */
	  toString: function () {
	    return this.value;
	  }
	});

	/**
	 * @api private
	 */
	module.exports = DynamoDBNumberValue;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-12-05","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20111205","uid":"dynamodb-2011-12-05"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"Items":{"shape":"Sk"},"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedKeys":{"shape":"S2"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"So"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedItems":{"shape":"So"}}}},"CreateTable":{"input":{"type":"structure","required":["TableName","KeySchema","ProvisionedThroughput"],"members":{"TableName":{},"KeySchema":{"shape":"Sy"},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S15"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"Ss"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"Query":{"input":{"type":"structure","required":["TableName","HashKeyValue"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"Count":{"type":"boolean"},"HashKeyValue":{"shape":"S7"},"RangeKeyCondition":{"shape":"S1u"},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"Count":{"type":"boolean"},"ScanFilter":{"type":"map","key":{},"value":{"shape":"S1u"}},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key","AttributeUpdates"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Action":{}}}},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName","ProvisionedThroughput"],"members":{"TableName":{},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}}},"S6":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"S7"},"RangeKeyElement":{"shape":"S7"}}},"S7":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}}}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"shape":"Sl"}},"Sl":{"type":"map","key":{},"value":{"shape":"S7"}},"So":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"Ss"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"Ss":{"type":"map","key":{},"value":{"shape":"S7"}},"Sy":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"Sz"},"RangeKeyElement":{"shape":"Sz"}}},"Sz":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}},"S12":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S15":{"type":"structure","members":{"TableName":{},"KeySchema":{"shape":"Sy"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S1b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Exists":{"type":"boolean"}}}},"S1u":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"type":"list","member":{"shape":"S7"}},"ComparisonOperator":{}}}}}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20120810","uid":"dynamodb-2012-08-10"},"operations":{"BatchExecuteStatement":{"input":{"type":"structure","required":["Statements"],"members":{"Statements":{"type":"list","member":{"type":"structure","required":["Statement"],"members":{"Statement":{},"Parameters":{"shape":"S5"},"ConsistentRead":{"type":"boolean"}}}},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"Error":{"type":"structure","members":{"Code":{},"Message":{}}},"TableName":{},"Item":{"shape":"Sr"}}}},"ConsumedCapacity":{"shape":"Ss"}}}},"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"Sz"},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"shape":"S19"}},"UnprocessedKeys":{"shape":"Sz"},"ConsumedCapacity":{"shape":"Ss"}}},"endpointdiscovery":{}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S1b"},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{}}},"output":{"type":"structure","members":{"UnprocessedItems":{"shape":"S1b"},"ItemCollectionMetrics":{"shape":"S1j"},"ConsumedCapacity":{"shape":"Ss"}}},"endpointdiscovery":{}},"CreateBackup":{"input":{"type":"structure","required":["TableName","BackupName"],"members":{"TableName":{},"BackupName":{}}},"output":{"type":"structure","members":{"BackupDetails":{"shape":"S1s"}}},"endpointdiscovery":{}},"CreateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicationGroup"],"members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S20"}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S24"}}},"endpointdiscovery":{}},"CreateTable":{"input":{"type":"structure","required":["AttributeDefinitions","TableName","KeySchema"],"members":{"AttributeDefinitions":{"shape":"S2k"},"TableName":{},"KeySchema":{"shape":"S2o"},"LocalSecondaryIndexes":{"shape":"S2r"},"GlobalSecondaryIndexes":{"shape":"S2x"},"BillingMode":{},"ProvisionedThroughput":{"shape":"S2z"},"StreamSpecification":{"shape":"S31"},"SSESpecification":{"shape":"S34"},"Tags":{"shape":"S37"},"TableClass":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3c"}}},"endpointdiscovery":{}},"DeleteBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S40"}}},"endpointdiscovery":{}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S12"},"Expected":{"shape":"S4d"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sr"},"ConsumedCapacity":{"shape":"St"},"ItemCollectionMetrics":{"shape":"S1l"}}},"endpointdiscovery":{}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3c"}}},"endpointdiscovery":{}},"DescribeBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S40"}}},"endpointdiscovery":{}},"DescribeContinuousBackups":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S4u"}}},"endpointdiscovery":{}},"DescribeContributorInsights":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{}}},"output":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsRuleList":{"type":"list","member":{}},"ContributorInsightsStatus":{},"LastUpdateDateTime":{"type":"timestamp"},"FailureException":{"type":"structure","members":{"ExceptionName":{},"ExceptionDescription":{}}}}}},"DescribeEndpoints":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["Address","CachePeriodInMinutes"],"members":{"Address":{},"CachePeriodInMinutes":{"type":"long"}}}}}},"endpointoperation":true},"DescribeExport":{"input":{"type":"structure","required":["ExportArn"],"members":{"ExportArn":{}}},"output":{"type":"structure","members":{"ExportDescription":{"shape":"S5e"}}}},"DescribeGlobalTable":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S24"}}},"endpointdiscovery":{}},"DescribeGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S5y"}}},"endpointdiscovery":{}},"DescribeKinesisStreamingDestination":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableName":{},"KinesisDataStreamDestinations":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"DestinationStatus":{},"DestinationStatusDescription":{}}}}}},"endpointdiscovery":{}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountMaxReadCapacityUnits":{"type":"long"},"AccountMaxWriteCapacityUnits":{"type":"long"},"TableMaxReadCapacityUnits":{"type":"long"},"TableMaxWriteCapacityUnits":{"type":"long"}}},"endpointdiscovery":{}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S3c"}}},"endpointdiscovery":{}},"DescribeTableReplicaAutoScaling":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableAutoScalingDescription":{"shape":"S6k"}}}},"DescribeTimeToLive":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TimeToLiveDescription":{"shape":"S49"}}},"endpointdiscovery":{}},"DisableKinesisStreamingDestination":{"input":{"shape":"S6r"},"output":{"shape":"S6s"},"endpointdiscovery":{}},"EnableKinesisStreamingDestination":{"input":{"shape":"S6r"},"output":{"shape":"S6s"},"endpointdiscovery":{}},"ExecuteStatement":{"input":{"type":"structure","required":["Statement"],"members":{"Statement":{},"Parameters":{"shape":"S5"},"ConsistentRead":{"type":"boolean"},"NextToken":{},"ReturnConsumedCapacity":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Items":{"shape":"S19"},"NextToken":{},"ConsumedCapacity":{"shape":"St"},"LastEvaluatedKey":{"shape":"S12"}}}},"ExecuteTransaction":{"input":{"type":"structure","required":["TransactStatements"],"members":{"TransactStatements":{"type":"list","member":{"type":"structure","required":["Statement"],"members":{"Statement":{},"Parameters":{"shape":"S5"}}}},"ClientRequestToken":{"idempotencyToken":true},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"shape":"S72"},"ConsumedCapacity":{"shape":"Ss"}}}},"ExportTableToPointInTime":{"input":{"type":"structure","required":["TableArn","S3Bucket"],"members":{"TableArn":{},"ExportTime":{"type":"timestamp"},"ClientToken":{"idempotencyToken":true},"S3Bucket":{},"S3BucketOwner":{},"S3Prefix":{},"S3SseAlgorithm":{},"S3SseKmsKeyId":{},"ExportFormat":{}}},"output":{"type":"structure","members":{"ExportDescription":{"shape":"S5e"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S12"},"AttributesToGet":{"shape":"S13"},"ConsistentRead":{"type":"boolean"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"S15"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sr"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"ListBackups":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"TimeRangeLowerBound":{"type":"timestamp"},"TimeRangeUpperBound":{"type":"timestamp"},"ExclusiveStartBackupArn":{},"BackupType":{}}},"output":{"type":"structure","members":{"BackupSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"TableId":{},"TableArn":{},"BackupArn":{},"BackupName":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"},"BackupStatus":{},"BackupType":{},"BackupSizeBytes":{"type":"long"}}}},"LastEvaluatedBackupArn":{}}},"endpointdiscovery":{}},"ListContributorInsights":{"input":{"type":"structure","members":{"TableName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ContributorInsightsSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsStatus":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"TableArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExportSummaries":{"type":"list","member":{"type":"structure","members":{"ExportArn":{},"ExportStatus":{}}}},"NextToken":{}}}},"ListGlobalTables":{"input":{"type":"structure","members":{"ExclusiveStartGlobalTableName":{},"Limit":{"type":"integer"},"RegionName":{}}},"output":{"type":"structure","members":{"GlobalTables":{"type":"list","member":{"type":"structure","members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S20"}}}},"LastEvaluatedGlobalTableName":{}}},"endpointdiscovery":{}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}},"endpointdiscovery":{}},"ListTagsOfResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S37"},"NextToken":{}}},"endpointdiscovery":{}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"S1f"},"Expected":{"shape":"S4d"},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionalOperator":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sr"},"ConsumedCapacity":{"shape":"St"},"ItemCollectionMetrics":{"shape":"S1l"}}},"endpointdiscovery":{}},"Query":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"Select":{},"AttributesToGet":{"shape":"S13"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"KeyConditions":{"type":"map","key":{},"value":{"shape":"S88"}},"QueryFilter":{"shape":"S89"},"ConditionalOperator":{},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S12"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"FilterExpression":{},"KeyConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"}}},"output":{"type":"structure","members":{"Items":{"shape":"S19"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S12"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"RestoreTableFromBackup":{"input":{"type":"structure","required":["TargetTableName","BackupArn"],"members":{"TargetTableName":{},"BackupArn":{},"BillingModeOverride":{},"GlobalSecondaryIndexOverride":{"shape":"S2x"},"LocalSecondaryIndexOverride":{"shape":"S2r"},"ProvisionedThroughputOverride":{"shape":"S2z"},"SSESpecificationOverride":{"shape":"S34"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3c"}}},"endpointdiscovery":{}},"RestoreTableToPointInTime":{"input":{"type":"structure","required":["TargetTableName"],"members":{"SourceTableArn":{},"SourceTableName":{},"TargetTableName":{},"UseLatestRestorableTime":{"type":"boolean"},"RestoreDateTime":{"type":"timestamp"},"BillingModeOverride":{},"GlobalSecondaryIndexOverride":{"shape":"S2x"},"LocalSecondaryIndexOverride":{"shape":"S2r"},"ProvisionedThroughputOverride":{"shape":"S2z"},"SSESpecificationOverride":{"shape":"S34"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3c"}}},"endpointdiscovery":{}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"AttributesToGet":{"shape":"S13"},"Limit":{"type":"integer"},"Select":{},"ScanFilter":{"shape":"S89"},"ConditionalOperator":{},"ExclusiveStartKey":{"shape":"S12"},"ReturnConsumedCapacity":{},"TotalSegments":{"type":"integer"},"Segment":{"type":"integer"},"ProjectionExpression":{},"FilterExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"S19"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S12"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S37"}}},"endpointdiscovery":{}},"TransactGetItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","required":["Get"],"members":{"Get":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S12"},"TableName":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"S15"}}}}}},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"Ss"},"Responses":{"shape":"S72"}}},"endpointdiscovery":{}},"TransactWriteItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","members":{"ConditionCheck":{"type":"structure","required":["Key","TableName","ConditionExpression"],"members":{"Key":{"shape":"S12"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"},"ReturnValuesOnConditionCheckFailure":{}}},"Put":{"type":"structure","required":["Item","TableName"],"members":{"Item":{"shape":"S1f"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"},"ReturnValuesOnConditionCheckFailure":{}}},"Delete":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S12"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"},"ReturnValuesOnConditionCheckFailure":{}}},"Update":{"type":"structure","required":["Key","UpdateExpression","TableName"],"members":{"Key":{"shape":"S12"},"UpdateExpression":{},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"},"ReturnValuesOnConditionCheckFailure":{}}}}}},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"Ss"},"ItemCollectionMetrics":{"shape":"S1j"}}},"endpointdiscovery":{}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"endpointdiscovery":{}},"UpdateContinuousBackups":{"input":{"type":"structure","required":["TableName","PointInTimeRecoverySpecification"],"members":{"TableName":{},"PointInTimeRecoverySpecification":{"type":"structure","required":["PointInTimeRecoveryEnabled"],"members":{"PointInTimeRecoveryEnabled":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S4u"}}},"endpointdiscovery":{}},"UpdateContributorInsights":{"input":{"type":"structure","required":["TableName","ContributorInsightsAction"],"members":{"TableName":{},"IndexName":{},"ContributorInsightsAction":{}}},"output":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsStatus":{}}}},"UpdateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicaUpdates"],"members":{"GlobalTableName":{},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S24"}}},"endpointdiscovery":{}},"UpdateGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{},"GlobalTableBillingMode":{},"GlobalTableProvisionedWriteCapacityUnits":{"type":"long"},"GlobalTableProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"S9g"},"GlobalTableGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"S9g"}}}},"ReplicaSettingsUpdate":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"S9g"},"ReplicaGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"S9g"}}}},"ReplicaTableClass":{}}}}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S5y"}}},"endpointdiscovery":{}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S12"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S6"},"Action":{}}}},"Expected":{"shape":"S4d"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"UpdateExpression":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S15"},"ExpressionAttributeValues":{"shape":"S4l"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sr"},"ConsumedCapacity":{"shape":"St"},"ItemCollectionMetrics":{"shape":"S1l"}}},"endpointdiscovery":{}},"UpdateTable":{"input":{"type":"structure","required":["TableName"],"members":{"AttributeDefinitions":{"shape":"S2k"},"TableName":{},"BillingMode":{},"ProvisionedThroughput":{"shape":"S2z"},"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"Update":{"type":"structure","required":["IndexName","ProvisionedThroughput"],"members":{"IndexName":{},"ProvisionedThroughput":{"shape":"S2z"}}},"Create":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"},"ProvisionedThroughput":{"shape":"S2z"}}},"Delete":{"type":"structure","required":["IndexName"],"members":{"IndexName":{}}}}}},"StreamSpecification":{"shape":"S31"},"SSESpecification":{"shape":"S34"},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S2b"},"GlobalSecondaryIndexes":{"shape":"Sa5"},"TableClassOverride":{}}},"Update":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S2b"},"GlobalSecondaryIndexes":{"shape":"Sa5"},"TableClassOverride":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}},"TableClass":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3c"}}},"endpointdiscovery":{}},"UpdateTableReplicaAutoScaling":{"input":{"type":"structure","required":["TableName"],"members":{"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedWriteCapacityAutoScalingUpdate":{"shape":"S9g"}}}},"TableName":{},"ProvisionedWriteCapacityAutoScalingUpdate":{"shape":"S9g"},"ReplicaUpdates":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaGlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedReadCapacityAutoScalingUpdate":{"shape":"S9g"}}}},"ReplicaProvisionedReadCapacityAutoScalingUpdate":{"shape":"S9g"}}}}}},"output":{"type":"structure","members":{"TableAutoScalingDescription":{"shape":"S6k"}}}},"UpdateTimeToLive":{"input":{"type":"structure","required":["TableName","TimeToLiveSpecification"],"members":{"TableName":{},"TimeToLiveSpecification":{"shape":"Saj"}}},"output":{"type":"structure","members":{"TimeToLiveSpecification":{"shape":"Saj"}}},"endpointdiscovery":{}}},"shapes":{"S5":{"type":"list","member":{"shape":"S6"}},"S6":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"S6"}},"L":{"type":"list","member":{"shape":"S6"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}},"Sr":{"type":"map","key":{},"value":{"shape":"S6"}},"Ss":{"type":"list","member":{"shape":"St"}},"St":{"type":"structure","members":{"TableName":{},"CapacityUnits":{"type":"double"},"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"Table":{"shape":"Sv"},"LocalSecondaryIndexes":{"shape":"Sw"},"GlobalSecondaryIndexes":{"shape":"Sw"}}},"Sv":{"type":"structure","members":{"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"CapacityUnits":{"type":"double"}}},"Sw":{"type":"map","key":{},"value":{"shape":"Sv"}},"Sz":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S12"}},"AttributesToGet":{"shape":"S13"},"ConsistentRead":{"type":"boolean"},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"S15"}}}},"S12":{"type":"map","key":{},"value":{"shape":"S6"}},"S13":{"type":"list","member":{}},"S15":{"type":"map","key":{},"value":{}},"S19":{"type":"list","member":{"shape":"Sr"}},"S1b":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"S1f"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S12"}}}}}}},"S1f":{"type":"map","key":{},"value":{"shape":"S6"}},"S1j":{"type":"map","key":{},"value":{"type":"list","member":{"shape":"S1l"}}},"S1l":{"type":"structure","members":{"ItemCollectionKey":{"type":"map","key":{},"value":{"shape":"S6"}},"SizeEstimateRangeGB":{"type":"list","member":{"type":"double"}}}},"S1s":{"type":"structure","required":["BackupArn","BackupName","BackupStatus","BackupType","BackupCreationDateTime"],"members":{"BackupArn":{},"BackupName":{},"BackupSizeBytes":{"type":"long"},"BackupStatus":{},"BackupType":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"}}},"S20":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"S24":{"type":"structure","members":{"ReplicationGroup":{"shape":"S25"},"GlobalTableArn":{},"CreationDateTime":{"type":"timestamp"},"GlobalTableStatus":{},"GlobalTableName":{}}},"S25":{"type":"list","member":{"type":"structure","members":{"RegionName":{},"ReplicaStatus":{},"ReplicaStatusDescription":{},"ReplicaStatusPercentProgress":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S2b"},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S2b"}}}},"ReplicaInaccessibleDateTime":{"type":"timestamp"},"ReplicaTableClassSummary":{"shape":"S2f"}}}},"S2b":{"type":"structure","members":{"ReadCapacityUnits":{"type":"long"}}},"S2f":{"type":"structure","members":{"TableClass":{},"LastUpdateDateTime":{"type":"timestamp"}}},"S2k":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}}},"S2o":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"S2r":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"}}}},"S2t":{"type":"structure","members":{"ProjectionType":{},"NonKeyAttributes":{"type":"list","member":{}}}},"S2x":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"},"ProvisionedThroughput":{"shape":"S2z"}}}},"S2z":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S31":{"type":"structure","required":["StreamEnabled"],"members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"S34":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SSEType":{},"KMSMasterKeyId":{}}},"S37":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S3c":{"type":"structure","members":{"AttributeDefinitions":{"shape":"S2k"},"TableName":{},"KeySchema":{"shape":"S2o"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S3e"},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"TableArn":{},"TableId":{},"BillingModeSummary":{"shape":"S3i"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"},"IndexStatus":{},"Backfilling":{"type":"boolean"},"ProvisionedThroughput":{"shape":"S3e"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"StreamSpecification":{"shape":"S31"},"LatestStreamLabel":{},"LatestStreamArn":{},"GlobalTableVersion":{},"Replicas":{"shape":"S25"},"RestoreSummary":{"type":"structure","required":["RestoreDateTime","RestoreInProgress"],"members":{"SourceBackupArn":{},"SourceTableArn":{},"RestoreDateTime":{"type":"timestamp"},"RestoreInProgress":{"type":"boolean"}}},"SSEDescription":{"shape":"S3t"},"ArchivalSummary":{"type":"structure","members":{"ArchivalDateTime":{"type":"timestamp"},"ArchivalReason":{},"ArchivalBackupArn":{}}},"TableClassSummary":{"shape":"S2f"}}},"S3e":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S3i":{"type":"structure","members":{"BillingMode":{},"LastUpdateToPayPerRequestDateTime":{"type":"timestamp"}}},"S3t":{"type":"structure","members":{"Status":{},"SSEType":{},"KMSMasterKeyArn":{},"InaccessibleEncryptionDateTime":{"type":"timestamp"}}},"S40":{"type":"structure","members":{"BackupDetails":{"shape":"S1s"},"SourceTableDetails":{"type":"structure","required":["TableName","TableId","KeySchema","TableCreationDateTime","ProvisionedThroughput"],"members":{"TableName":{},"TableId":{},"TableArn":{},"TableSizeBytes":{"type":"long"},"KeySchema":{"shape":"S2o"},"TableCreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S2z"},"ItemCount":{"type":"long"},"BillingMode":{}}},"SourceTableFeatureDetails":{"type":"structure","members":{"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2o"},"Projection":{"shape":"S2t"},"ProvisionedThroughput":{"shape":"S2z"}}}},"StreamDescription":{"shape":"S31"},"TimeToLiveDescription":{"shape":"S49"},"SSEDescription":{"shape":"S3t"}}}}},"S49":{"type":"structure","members":{"TimeToLiveStatus":{},"AttributeName":{}}},"S4d":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S6"},"Exists":{"type":"boolean"},"ComparisonOperator":{},"AttributeValueList":{"shape":"S4h"}}}},"S4h":{"type":"list","member":{"shape":"S6"}},"S4l":{"type":"map","key":{},"value":{"shape":"S6"}},"S4u":{"type":"structure","required":["ContinuousBackupsStatus"],"members":{"ContinuousBackupsStatus":{},"PointInTimeRecoveryDescription":{"type":"structure","members":{"PointInTimeRecoveryStatus":{},"EarliestRestorableDateTime":{"type":"timestamp"},"LatestRestorableDateTime":{"type":"timestamp"}}}}},"S5e":{"type":"structure","members":{"ExportArn":{},"ExportStatus":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ExportManifest":{},"TableArn":{},"TableId":{},"ExportTime":{"type":"timestamp"},"ClientToken":{},"S3Bucket":{},"S3BucketOwner":{},"S3Prefix":{},"S3SseAlgorithm":{},"S3SseKmsKeyId":{},"FailureCode":{},"FailureMessage":{},"ExportFormat":{},"BilledSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S5y":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaStatus":{},"ReplicaBillingModeSummary":{"shape":"S3i"},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S60"},"ReplicaProvisionedWriteCapacityUnits":{"type":"long"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S60"},"ReplicaGlobalSecondaryIndexSettings":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S60"},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S60"}}}},"ReplicaTableClassSummary":{"shape":"S2f"}}}},"S60":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}}},"S6k":{"type":"structure","members":{"TableName":{},"TableStatus":{},"Replicas":{"type":"list","member":{"type":"structure","members":{"RegionName":{},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S60"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S60"}}}},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S60"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S60"},"ReplicaStatus":{}}}}}},"S6r":{"type":"structure","required":["TableName","StreamArn"],"members":{"TableName":{},"StreamArn":{}}},"S6s":{"type":"structure","members":{"TableName":{},"StreamArn":{},"DestinationStatus":{}}},"S72":{"type":"list","member":{"type":"structure","members":{"Item":{"shape":"Sr"}}}},"S88":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"shape":"S4h"},"ComparisonOperator":{}}},"S89":{"type":"map","key":{},"value":{"shape":"S88"}},"S9g":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicyUpdate":{"type":"structure","required":["TargetTrackingScalingPolicyConfiguration"],"members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}},"Sa5":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S2b"}}}},"Saj":{"type":"structure","required":["Enabled","AttributeName"],"members":{"Enabled":{"type":"boolean"},"AttributeName":{}}}}}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListContributorInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListExports":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['dynamodbstreams'] = {};
	AWS.DynamoDBStreams = Service.defineService('dynamodbstreams', ['2012-08-10']);
	Object.defineProperty(apiLoader.services['dynamodbstreams'], '2012-08-10', {
	  get: function get() {
	    var model = __webpack_require__(190);
	    model.paginators = __webpack_require__(191).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DynamoDBStreams;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"streams.dynamodb","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon DynamoDB Streams","serviceId":"DynamoDB Streams","signatureVersion":"v4","signingName":"dynamodb","targetPrefix":"DynamoDBStreams_20120810","uid":"streams-dynamodb-2012-08-10"},"operations":{"DescribeStream":{"input":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","members":{"StreamDescription":{"type":"structure","members":{"StreamArn":{},"StreamLabel":{},"StreamStatus":{},"StreamViewType":{},"CreationRequestDateTime":{"type":"timestamp"},"TableName":{},"KeySchema":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"Shards":{"type":"list","member":{"type":"structure","members":{"ShardId":{},"SequenceNumberRange":{"type":"structure","members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}},"ParentShardId":{}}}},"LastEvaluatedShardId":{}}}}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"eventID":{},"eventName":{},"eventVersion":{},"eventSource":{},"awsRegion":{},"dynamodb":{"type":"structure","members":{"ApproximateCreationDateTime":{"type":"timestamp"},"Keys":{"shape":"Sr"},"NewImage":{"shape":"Sr"},"OldImage":{"shape":"Sr"},"SequenceNumber":{},"SizeBytes":{"type":"long"},"StreamViewType":{}}},"userIdentity":{"type":"structure","members":{"PrincipalId":{},"Type":{}}}}}},"NextShardIterator":{}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamArn","ShardId","ShardIteratorType"],"members":{"StreamArn":{},"ShardId":{},"ShardIteratorType":{},"SequenceNumber":{}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"ListStreams":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"ExclusiveStartStreamArn":{}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"TableName":{},"StreamLabel":{}}}},"LastEvaluatedStreamArn":{}}}}},"shapes":{"Sr":{"type":"map","key":{},"value":{"shape":"St"}},"St":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"St"}},"L":{"type":"list","member":{"shape":"St"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}}}}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ec2'] = {};
	AWS.EC2 = Service.defineService('ec2', ['2013-06-15*', '2013-10-15*', '2014-02-01*', '2014-05-01*', '2014-06-15*', '2014-09-01*', '2014-10-01*', '2015-03-01*', '2015-04-15*', '2015-10-01*', '2016-04-01*', '2016-09-15*', '2016-11-15']);
	__webpack_require__(193);
	Object.defineProperty(apiLoader.services['ec2'], '2016-11-15', {
	  get: function get() {
	    var model = __webpack_require__(194);
	    model.paginators = __webpack_require__(195).pagination;
	    model.waiters = __webpack_require__(196).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EC2;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.EC2.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.removeListener('extractError', AWS.EventListeners.Query.EXTRACT_ERROR);
	    request.addListener('extractError', this.extractError);

	    if (request.operation === 'copySnapshot') {
	      request.onAsync('validate', this.buildCopySnapshotPresignedUrl);
	    }
	  },

	  /**
	   * @api private
	   */
	  buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
	    if (req.params.PresignedUrl || req._subRequest) {
	      return done();
	    }

	    req.params = AWS.util.copy(req.params);
	    req.params.DestinationRegion = req.service.config.region;

	    var config = AWS.util.copy(req.service.config);
	    delete config.endpoint;
	    config.region = req.params.SourceRegion;
	    var svc = new req.service.constructor(config);
	    var newReq = svc[req.operation](req.params);
	    newReq._subRequest = true;
	    newReq.presign(function(err, url) {
	      if (err) done(err);
	      else {
	        req.params.PresignedUrl = url;
	        done();
	      }
	    });
	  },

	  /**
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    // EC2 nests the error code and message deeper than other AWS Query services.
	    var httpResponse = resp.httpResponse;
	    var data = new AWS.XML.Parser().parse(httpResponse.body.toString() || '');
	    if (data.Errors) {
	      resp.error = AWS.util.error(new Error(), {
	        code: data.Errors.Error.Code,
	        message: data.Errors.Error.Message
	      });
	    } else {
	      resp.error = AWS.util.error(new Error(), {
	        code: httpResponse.statusCode,
	        message: null
	      });
	    }
	    resp.error.requestId = data.RequestID || null;
	  }
	});


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-15","endpointPrefix":"ec2","protocol":"ec2","serviceAbbreviation":"Amazon EC2","serviceFullName":"Amazon Elastic Compute Cloud","serviceId":"EC2","signatureVersion":"v4","uid":"ec2-2016-11-15","xmlNamespace":"http://ec2.amazonaws.com/doc/2016-11-15"},"operations":{"AcceptReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"ExchangeId":{"locationName":"exchangeId"}}}},"AcceptTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"Se"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sg","locationName":"associations"}}}},"AcceptTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sn","locationName":"transitGatewayPeeringAttachment"}}}},"AcceptTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sw","locationName":"transitGatewayVpcAttachment"}}}},"AcceptVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"S13","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"AcceptVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"S1c","locationName":"vpcPeeringConnection"}}}},"AdvertiseByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1n","locationName":"byoipCidr"}}}},"AllocateAddress":{"input":{"type":"structure","members":{"Domain":{},"Address":{},"PublicIpv4Pool":{},"NetworkBorderGroup":{},"CustomerOwnedIpv4Pool":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Domain":{"locationName":"domain"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"CarrierIp":{"locationName":"carrierIp"}}}},"AllocateHosts":{"input":{"type":"structure","required":["AvailabilityZone","Quantity"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"ClientToken":{"locationName":"clientToken"},"InstanceType":{"locationName":"instanceType"},"InstanceFamily":{},"Quantity":{"locationName":"quantity","type":"integer"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"HostRecovery":{},"OutpostArn":{}}},"output":{"type":"structure","members":{"HostIds":{"shape":"S21","locationName":"hostIdSet"}}}},"AllocateIpamPoolCidr":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{},"NetmaskLength":{"type":"integer"},"ClientToken":{"idempotencyToken":true},"Description":{},"PreviewNextCidr":{"type":"boolean"},"DisallowedCidrs":{"locationName":"DisallowedCidr","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"IpamPoolAllocation":{"shape":"S26","locationName":"ipamPoolAllocation"}}}},"ApplySecurityGroupsToClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","VpcId","SecurityGroupIds"],"members":{"ClientVpnEndpointId":{},"VpcId":{},"SecurityGroupIds":{"shape":"S2c","locationName":"SecurityGroupId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S2c","locationName":"securityGroupIds"}}}},"AssignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S2g","locationName":"ipv6Addresses"},"Ipv6PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"S2h","locationName":"Ipv6Prefix"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AssignedIpv6Addresses":{"shape":"S2g","locationName":"assignedIpv6Addresses"},"AssignedIpv6Prefixes":{"shape":"S2h","locationName":"assignedIpv6PrefixSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"AssignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"AllowReassignment":{"locationName":"allowReassignment","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S2l","locationName":"privateIpAddress"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"Ipv4Prefixes":{"shape":"S2h","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AssignedPrivateIpAddresses":{"locationName":"assignedPrivateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"AssignedIpv4Prefixes":{"shape":"S2p","locationName":"assignedIpv4PrefixSet"}}}},"AssociateAddress":{"input":{"type":"structure","members":{"AllocationId":{},"InstanceId":{},"PublicIp":{},"AllowReassociation":{"locationName":"allowReassociation","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","SubnetId"],"members":{"ClientVpnEndpointId":{},"SubnetId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S2y","locationName":"status"}}}},"AssociateDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId","VpcId"],"members":{"DhcpOptionsId":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"AssociateEnclaveCertificateIamRole":{"input":{"type":"structure","members":{"CertificateArn":{},"RoleArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CertificateS3BucketName":{"locationName":"certificateS3BucketName"},"CertificateS3ObjectKey":{"locationName":"certificateS3ObjectKey"},"EncryptionKmsKeyId":{"locationName":"encryptionKmsKeyId"}}}},"AssociateIamInstanceProfile":{"input":{"type":"structure","required":["IamInstanceProfile","InstanceId"],"members":{"IamInstanceProfile":{"shape":"S36"},"InstanceId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S38","locationName":"iamInstanceProfileAssociation"}}}},"AssociateInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId","AssociationTarget"],"members":{"DryRun":{"type":"boolean"},"InstanceEventWindowId":{},"AssociationTarget":{"type":"structure","members":{"InstanceIds":{"shape":"S3e","locationName":"InstanceId"},"InstanceTags":{"shape":"Ss","locationName":"InstanceTag"},"DedicatedHostIds":{"shape":"S3f","locationName":"DedicatedHostId"}}}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S3i","locationName":"instanceEventWindow"}}}},"AssociateRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"},"GatewayId":{}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"AssociationState":{"shape":"S3u","locationName":"associationState"}}}},"AssociateSubnetCidrBlock":{"input":{"type":"structure","required":["Ipv6CidrBlock","SubnetId"],"members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S3y","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"AssociateTransitGatewayMulticastDomain":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"S43"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sg","locationName":"associations"}}}},"AssociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S48","locationName":"association"}}}},"AssociateTrunkInterface":{"input":{"type":"structure","required":["BranchInterfaceId","TrunkInterfaceId"],"members":{"BranchInterfaceId":{},"TrunkInterfaceId":{},"VlanId":{"type":"integer"},"GreKey":{"type":"integer"},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfaceAssociation":{"shape":"S4c","locationName":"interfaceAssociation"},"ClientToken":{"locationName":"clientToken"}}}},"AssociateVpcCidrBlock":{"input":{"type":"structure","required":["VpcId"],"members":{"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"CidrBlock":{},"VpcId":{"locationName":"vpcId"},"Ipv6CidrBlockNetworkBorderGroup":{},"Ipv6Pool":{},"Ipv6CidrBlock":{},"Ipv4IpamPoolId":{},"Ipv4NetmaskLength":{"type":"integer"},"Ipv6IpamPoolId":{},"Ipv6NetmaskLength":{"type":"integer"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S4j","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S4m","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"AttachClassicLinkVpc":{"input":{"type":"structure","required":["Groups","InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S4o","locationName":"SecurityGroupId"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"AttachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"AttachNetworkInterface":{"input":{"type":"structure","required":["DeviceIndex","InstanceId","NetworkInterfaceId"],"members":{"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkCardIndex":{"type":"integer"}}},"output":{"type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"}}}},"AttachVolume":{"input":{"type":"structure","required":["Device","InstanceId","VolumeId"],"members":{"Device":{},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S4w"}},"AttachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S51","locationName":"attachment"}}}},"AuthorizeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"AuthorizeAllGroups":{"type":"boolean"},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S55","locationName":"status"}}}},"AuthorizeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S58","locationName":"ipPermissions"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"SecurityGroupRules":{"shape":"S5j","locationName":"securityGroupRuleSet"}}}},"AuthorizeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S58"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"SecurityGroupRules":{"shape":"S5j","locationName":"securityGroupRuleSet"}}}},"BundleInstance":{"input":{"type":"structure","required":["InstanceId","Storage"],"members":{"InstanceId":{},"Storage":{"shape":"S5s"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S5w","locationName":"bundleInstanceTask"}}}},"CancelBundleTask":{"input":{"type":"structure","required":["BundleId"],"members":{"BundleId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S5w","locationName":"bundleInstanceTask"}}}},"CancelCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CancelCapacityReservationFleets":{"input":{"type":"structure","required":["CapacityReservationFleetIds"],"members":{"DryRun":{"type":"boolean"},"CapacityReservationFleetIds":{"shape":"S66","locationName":"CapacityReservationFleetId"}}},"output":{"type":"structure","members":{"SuccessfulFleetCancellations":{"locationName":"successfulFleetCancellationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentFleetState":{"locationName":"currentFleetState"},"PreviousFleetState":{"locationName":"previousFleetState"},"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"}}}},"FailedFleetCancellations":{"locationName":"failedFleetCancellationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"CancelCapacityReservationFleetError":{"locationName":"cancelCapacityReservationFleetError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"CancelConversionTask":{"input":{"type":"structure","required":["ConversionTaskId"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"ReasonMessage":{"locationName":"reasonMessage"}}}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskId"],"members":{"ExportTaskId":{"locationName":"exportTaskId"}}}},"CancelImportTask":{"input":{"type":"structure","members":{"CancelReason":{},"DryRun":{"type":"boolean"},"ImportTaskId":{}}},"output":{"type":"structure","members":{"ImportTaskId":{"locationName":"importTaskId"},"PreviousState":{"locationName":"previousState"},"State":{"locationName":"state"}}}},"CancelReservedInstancesListing":{"input":{"type":"structure","required":["ReservedInstancesListingId"],"members":{"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S6r","locationName":"reservedInstancesListingsSet"}}}},"CancelSpotFleetRequests":{"input":{"type":"structure","required":["SpotFleetRequestIds","TerminateInstances"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestIds":{"shape":"S73","locationName":"spotFleetRequestId"},"TerminateInstances":{"locationName":"terminateInstances","type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetRequests":{"locationName":"successfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentSpotFleetRequestState":{"locationName":"currentSpotFleetRequestState"},"PreviousSpotFleetRequestState":{"locationName":"previousSpotFleetRequestState"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"UnsuccessfulFleetRequests":{"locationName":"unsuccessfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}}}}},"CancelSpotInstanceRequests":{"input":{"type":"structure","required":["SpotInstanceRequestIds"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S7e","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"CancelledSpotInstanceRequests":{"locationName":"spotInstanceRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"State":{"locationName":"state"}}}}}}},"ConfirmProductInstance":{"input":{"type":"structure","required":["InstanceId","ProductCode"],"members":{"InstanceId":{},"ProductCode":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"Return":{"locationName":"return","type":"boolean"}}}},"CopyFpgaImage":{"input":{"type":"structure","required":["SourceFpgaImageId","SourceRegion"],"members":{"DryRun":{"type":"boolean"},"SourceFpgaImageId":{},"Description":{},"Name":{},"SourceRegion":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"}}}},"CopyImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"ClientToken":{},"Description":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Name":{},"SourceImageId":{},"SourceRegion":{},"DestinationOutpostArn":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceRegion","SourceSnapshotId"],"members":{"Description":{},"DestinationOutpostArn":{},"DestinationRegion":{"locationName":"destinationRegion"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"PresignedUrl":{"locationName":"presignedUrl"},"SourceRegion":{},"SourceSnapshotId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"CreateCapacityReservation":{"input":{"type":"structure","required":["InstanceType","InstancePlatform","InstanceCount"],"members":{"ClientToken":{},"InstanceType":{},"InstancePlatform":{},"AvailabilityZone":{},"AvailabilityZoneId":{},"Tenancy":{},"InstanceCount":{"type":"integer"},"EbsOptimized":{"type":"boolean"},"EphemeralStorage":{"type":"boolean"},"EndDate":{"type":"timestamp"},"EndDateType":{},"InstanceMatchCriteria":{},"TagSpecifications":{"shape":"S1t"},"DryRun":{"type":"boolean"},"OutpostArn":{},"PlacementGroupArn":{}}},"output":{"type":"structure","members":{"CapacityReservation":{"shape":"S81","locationName":"capacityReservation"}}}},"CreateCapacityReservationFleet":{"input":{"type":"structure","required":["InstanceTypeSpecifications","TotalTargetCapacity"],"members":{"AllocationStrategy":{},"ClientToken":{"idempotencyToken":true},"InstanceTypeSpecifications":{"locationName":"InstanceTypeSpecification","type":"list","member":{"type":"structure","members":{"InstanceType":{},"InstancePlatform":{},"Weight":{"type":"double"},"AvailabilityZone":{},"AvailabilityZoneId":{},"EbsOptimized":{"type":"boolean"},"Priority":{"type":"integer"}}}},"Tenancy":{},"TotalTargetCapacity":{"type":"integer"},"EndDate":{"type":"timestamp"},"InstanceMatchCriteria":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"State":{"locationName":"state"},"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"TotalFulfilledCapacity":{"locationName":"totalFulfilledCapacity","type":"double"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"AllocationStrategy":{"locationName":"allocationStrategy"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"Tenancy":{"locationName":"tenancy"},"FleetCapacityReservations":{"shape":"S8d","locationName":"fleetCapacityReservationSet"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"CreateCarrierGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CarrierGateway":{"shape":"S8h","locationName":"carrierGateway"}}}},"CreateClientVpnEndpoint":{"input":{"type":"structure","required":["ClientCidrBlock","ServerCertificateArn","AuthenticationOptions","ConnectionLogOptions"],"members":{"ClientCidrBlock":{},"ServerCertificateArn":{},"AuthenticationOptions":{"locationName":"Authentication","type":"list","member":{"type":"structure","members":{"Type":{},"ActiveDirectory":{"type":"structure","members":{"DirectoryId":{}}},"MutualAuthentication":{"type":"structure","members":{"ClientRootCertificateChainArn":{}}},"FederatedAuthentication":{"type":"structure","members":{"SAMLProviderArn":{},"SelfServiceSAMLProviderArn":{}}}}}},"ConnectionLogOptions":{"shape":"S8r"},"DnsServers":{"shape":"Se"},"TransportProtocol":{},"VpnPort":{"type":"integer"},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"SecurityGroupIds":{"shape":"S2c","locationName":"SecurityGroupId"},"VpcId":{},"SelfServicePortal":{},"ClientConnectOptions":{"shape":"S8u"},"SessionTimeoutHours":{"type":"integer"},"ClientLoginBannerOptions":{"shape":"S8v"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S8x","locationName":"status"},"DnsName":{"locationName":"dnsName"}}}},"CreateClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock","TargetVpcSubnetId"],"members":{"ClientVpnEndpointId":{},"DestinationCidrBlock":{},"TargetVpcSubnetId":{},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S91","locationName":"status"}}}},"CreateCustomerGateway":{"input":{"type":"structure","required":["BgpAsn","Type"],"members":{"BgpAsn":{"type":"integer"},"PublicIp":{"locationName":"IpAddress"},"CertificateArn":{},"Type":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DeviceName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateway":{"shape":"S96","locationName":"customerGateway"}}}},"CreateDefaultSubnet":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"DryRun":{"type":"boolean"},"Ipv6Native":{"type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S99","locationName":"subnet"}}}},"CreateDefaultVpc":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S9h","locationName":"vpc"}}}},"CreateDhcpOptions":{"input":{"type":"structure","required":["DhcpConfigurations"],"members":{"DhcpConfigurations":{"locationName":"dhcpConfiguration","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"shape":"Se","locationName":"Value"}}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"shape":"S9q","locationName":"dhcpOptions"}}}},"CreateEgressOnlyInternetGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"VpcId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"EgressOnlyInternetGateway":{"shape":"S9x","locationName":"egressOnlyInternetGateway"}}}},"CreateFleet":{"input":{"type":"structure","required":["LaunchTemplateConfigs","TargetCapacitySpecification"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"SpotOptions":{"type":"structure","members":{"AllocationStrategy":{},"MaintenanceStrategies":{"type":"structure","members":{"CapacityRebalance":{"type":"structure","members":{"ReplacementStrategy":{},"TerminationDelay":{"type":"integer"}}}}},"InstanceInterruptionBehavior":{},"InstancePoolsToUseCount":{"type":"integer"},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"OnDemandOptions":{"type":"structure","members":{"AllocationStrategy":{},"CapacityReservationOptions":{"type":"structure","members":{"UsageStrategy":{}}},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"ExcessCapacityTerminationPolicy":{},"LaunchTemplateConfigs":{"shape":"Sad"},"TargetCapacitySpecification":{"shape":"Sbc"},"TerminateInstancesWithExpiration":{"type":"boolean"},"Type":{},"ValidFrom":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"},"ReplaceUnhealthyInstances":{"type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"Context":{}}},"output":{"type":"structure","members":{"FleetId":{"locationName":"fleetId"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sbk","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sbk","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"Sc0","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}}}}},"CreateFlowLogs":{"input":{"type":"structure","required":["ResourceIds","ResourceType","TrafficType"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"DeliverLogsPermissionArn":{},"LogGroupName":{},"ResourceIds":{"locationName":"ResourceId","type":"list","member":{"locationName":"item"}},"ResourceType":{},"TrafficType":{},"LogDestinationType":{},"LogDestination":{},"LogFormat":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"MaxAggregationInterval":{"type":"integer"},"DestinationOptions":{"type":"structure","members":{"FileFormat":{},"HiveCompatiblePartitions":{"type":"boolean"},"PerHourPartition":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"FlowLogIds":{"shape":"Se","locationName":"flowLogIdSet"},"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"CreateFpgaImage":{"input":{"type":"structure","required":["InputStorageLocation"],"members":{"DryRun":{"type":"boolean"},"InputStorageLocation":{"shape":"Scc"},"LogsStorageLocation":{"shape":"Scc"},"Description":{},"Name":{},"ClientToken":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"}}}},"CreateImage":{"input":{"type":"structure","required":["InstanceId","Name"],"members":{"BlockDeviceMappings":{"shape":"Scf","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"Name":{"locationName":"name"},"NoReboot":{"locationName":"noReboot","type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateInstanceEventWindow":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Name":{},"TimeRanges":{"shape":"Scm","locationName":"TimeRange"},"CronExpression":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S3i","locationName":"instanceEventWindow"}}}},"CreateInstanceExportTask":{"input":{"type":"structure","required":["ExportToS3Task","InstanceId","TargetEnvironment"],"members":{"Description":{"locationName":"description"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ExportTask":{"shape":"Scv","locationName":"exportTask"}}}},"CreateInternetGateway":{"input":{"type":"structure","members":{"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InternetGateway":{"shape":"Sd1","locationName":"internetGateway"}}}},"CreateIpam":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Description":{},"OperatingRegions":{"shape":"Sd3","locationName":"OperatingRegion"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Ipam":{"shape":"Sd6","locationName":"ipam"}}}},"CreateIpamPool":{"input":{"type":"structure","required":["IpamScopeId","AddressFamily"],"members":{"DryRun":{"type":"boolean"},"IpamScopeId":{},"Locale":{},"SourceIpamPoolId":{},"Description":{},"AddressFamily":{},"AutoImport":{"type":"boolean"},"PubliclyAdvertisable":{"type":"boolean"},"AllocationMinNetmaskLength":{"type":"integer"},"AllocationMaxNetmaskLength":{"type":"integer"},"AllocationDefaultNetmaskLength":{"type":"integer"},"AllocationResourceTags":{"shape":"Sdf","locationName":"AllocationResourceTag"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"AwsService":{}}},"output":{"type":"structure","members":{"IpamPool":{"shape":"Sdj","locationName":"ipamPool"}}}},"CreateIpamScope":{"input":{"type":"structure","required":["IpamId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Description":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"IpamScope":{"shape":"Sdq","locationName":"ipamScope"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyType":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"KeyFormat":{}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyMaterial":{"locationName":"keyMaterial","type":"string","sensitive":true},"KeyName":{"locationName":"keyName"},"KeyPairId":{"locationName":"keyPairId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"CreateLaunchTemplate":{"input":{"type":"structure","required":["LaunchTemplateName","LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateName":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"Sdz"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sfh","locationName":"launchTemplate"},"Warning":{"shape":"Sfi","locationName":"warning"}}}},"CreateLaunchTemplateVersion":{"input":{"type":"structure","required":["LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"SourceVersion":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"Sdz"}}},"output":{"type":"structure","members":{"LaunchTemplateVersion":{"shape":"Sfn","locationName":"launchTemplateVersion"},"Warning":{"shape":"Sfi","locationName":"warning"}}}},"CreateLocalGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","LocalGatewayRouteTableId","LocalGatewayVirtualInterfaceGroupId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"LocalGatewayVirtualInterfaceGroupId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sgr","locationName":"route"}}}},"CreateLocalGatewayRouteTableVpcAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableId","VpcId"],"members":{"LocalGatewayRouteTableId":{},"VpcId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociation":{"shape":"Sgw","locationName":"localGatewayRouteTableVpcAssociation"}}}},"CreateManagedPrefixList":{"input":{"type":"structure","required":["PrefixListName","MaxEntries","AddressFamily"],"members":{"DryRun":{"type":"boolean"},"PrefixListName":{},"Entries":{"shape":"Sgz","locationName":"Entry"},"MaxEntries":{"type":"integer"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"AddressFamily":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sh2","locationName":"prefixList"}}}},"CreateNatGateway":{"input":{"type":"structure","required":["SubnetId"],"members":{"AllocationId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SubnetId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ConnectivityType":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"NatGateway":{"shape":"Sh7","locationName":"natGateway"}}}},"CreateNetworkAcl":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"NetworkAcl":{"shape":"She","locationName":"networkAcl"}}}},"CreateNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Shj","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Shk","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"CreateNetworkInsightsAccessScope":{"input":{"type":"structure","required":["ClientToken"],"members":{"MatchPaths":{"shape":"Shp","locationName":"MatchPath"},"ExcludePaths":{"shape":"Shp","locationName":"ExcludePath"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScope":{"shape":"Shz","locationName":"networkInsightsAccessScope"},"NetworkInsightsAccessScopeContent":{"shape":"Si1","locationName":"networkInsightsAccessScopeContent"}}}},"CreateNetworkInsightsPath":{"input":{"type":"structure","required":["Source","Destination","Protocol","ClientToken"],"members":{"SourceIp":{},"DestinationIp":{},"Source":{},"Destination":{},"Protocol":{},"DestinationPort":{"type":"integer"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkInsightsPath":{"shape":"Sie","locationName":"networkInsightsPath"}}}},"CreateNetworkInterface":{"input":{"type":"structure","required":["SubnetId"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"Se7","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sfv","locationName":"ipv6Addresses"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"Sea","locationName":"privateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"Ipv4Prefixes":{"shape":"Sec","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"See","locationName":"Ipv6Prefix"},"Ipv6PrefixCount":{"type":"integer"},"InterfaceType":{},"SubnetId":{"locationName":"subnetId"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkInterface":{"shape":"Sij","locationName":"networkInterface"},"ClientToken":{"locationName":"clientToken"}}}},"CreateNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfaceId","Permission"],"members":{"NetworkInterfaceId":{},"AwsAccountId":{},"AwsService":{},"Permission":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfacePermission":{"shape":"Siz","locationName":"interfacePermission"}}}},"CreatePlacementGroup":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"type":"integer"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"PlacementGroup":{"shape":"Sj5","locationName":"placementGroup"}}}},"CreatePublicIpv4Pool":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"PoolId":{"locationName":"poolId"}}}},"CreateReplaceRootVolumeTask":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"SnapshotId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ReplaceRootVolumeTask":{"shape":"Sjb","locationName":"replaceRootVolumeTask"}}}},"CreateReservedInstancesListing":{"input":{"type":"structure","required":["ClientToken","InstanceCount","PriceSchedules","ReservedInstancesId"],"members":{"ClientToken":{"locationName":"clientToken"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S6r","locationName":"reservedInstancesListingsSet"}}}},"CreateRestoreImageTask":{"input":{"type":"structure","required":["Bucket","ObjectKey"],"members":{"Bucket":{},"ObjectKey":{},"Name":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcEndpointId":{},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"LocalGatewayId":{},"CarrierGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"CoreNetworkArn":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CreateRouteTable":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"RouteTable":{"shape":"Sjs","locationName":"routeTable"}}}},"CreateSecurityGroup":{"input":{"type":"structure","required":["Description","GroupName"],"members":{"Description":{"locationName":"GroupDescription"},"GroupName":{},"VpcId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"GroupId":{"locationName":"groupId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeId"],"members":{"Description":{},"OutpostArn":{},"VolumeId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"Sk4"}},"CreateSnapshots":{"input":{"type":"structure","required":["InstanceSpecification"],"members":{"Description":{},"InstanceSpecification":{"type":"structure","members":{"InstanceId":{},"ExcludeBootVolume":{"type":"boolean"}}},"OutpostArn":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"CopyTagsFromSource":{}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"Tags":{"shape":"Ss","locationName":"tagSet"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"VolumeId":{"locationName":"volumeId"},"State":{"locationName":"state"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"StartTime":{"locationName":"startTime","type":"timestamp"},"Progress":{"locationName":"progress"},"OwnerId":{"locationName":"ownerId"},"SnapshotId":{"locationName":"snapshotId"},"OutpostArn":{"locationName":"outpostArn"}}}}}}},"CreateSpotDatafeedSubscription":{"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"locationName":"bucket"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Prefix":{"locationName":"prefix"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Skf","locationName":"spotDatafeedSubscription"}}}},"CreateStoreImageTask":{"input":{"type":"structure","required":["ImageId","Bucket"],"members":{"ImageId":{},"Bucket":{},"S3ObjectTags":{"locationName":"S3ObjectTag","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{},"Value":{}}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ObjectKey":{"locationName":"objectKey"}}}},"CreateSubnet":{"input":{"type":"structure","required":["VpcId"],"members":{"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"AvailabilityZone":{},"AvailabilityZoneId":{},"CidrBlock":{},"Ipv6CidrBlock":{},"OutpostArn":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Ipv6Native":{"type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S99","locationName":"subnet"}}}},"CreateSubnetCidrReservation":{"input":{"type":"structure","required":["SubnetId","Cidr","ReservationType"],"members":{"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"SubnetId":{},"Cidr":{},"ReservationType":{},"Description":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SubnetCidrReservation":{"shape":"Skr","locationName":"subnetCidrReservation"}}}},"CreateTags":{"input":{"type":"structure","required":["Resources","Tags"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"Sku","locationName":"ResourceId"},"Tags":{"shape":"Ss","locationName":"Tag"}}}},"CreateTrafficMirrorFilter":{"input":{"type":"structure","members":{"Description":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sky","locationName":"trafficMirrorFilter"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterId","TrafficDirection","RuleNumber","RuleAction","DestinationCidrBlock","SourceCidrBlock"],"members":{"TrafficMirrorFilterId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Sl8"},"SourcePortRange":{"shape":"Sl8"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sl0","locationName":"trafficMirrorFilterRule"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorSession":{"input":{"type":"structure","required":["NetworkInterfaceId","TrafficMirrorTargetId","TrafficMirrorFilterId","SessionNumber"],"members":{"NetworkInterfaceId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sld","locationName":"trafficMirrorSession"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorTarget":{"input":{"type":"structure","members":{"NetworkInterfaceId":{},"NetworkLoadBalancerArn":{},"Description":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorTarget":{"shape":"Slg","locationName":"trafficMirrorTarget"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTransitGateway":{"input":{"type":"structure","members":{"Description":{},"Options":{"type":"structure","members":{"AmazonSideAsn":{"type":"long"},"AutoAcceptSharedAttachments":{},"DefaultRouteTableAssociation":{},"DefaultRouteTablePropagation":{},"VpnEcmpSupport":{},"DnsSupport":{},"MulticastSupport":{},"TransitGatewayCidrBlocks":{"shape":"Slp"}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Slr","locationName":"transitGateway"}}}},"CreateTransitGatewayConnect":{"input":{"type":"structure","required":["TransportTransitGatewayAttachmentId","Options"],"members":{"TransportTransitGatewayAttachmentId":{},"Options":{"type":"structure","required":["Protocol"],"members":{"Protocol":{}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnect":{"shape":"Sly","locationName":"transitGatewayConnect"}}}},"CreateTransitGatewayConnectPeer":{"input":{"type":"structure","required":["TransitGatewayAttachmentId","PeerAddress","InsideCidrBlocks"],"members":{"TransitGatewayAttachmentId":{},"TransitGatewayAddress":{},"PeerAddress":{},"BgpOptions":{"type":"structure","members":{"PeerAsn":{"type":"long"}}},"InsideCidrBlocks":{"shape":"Sm2"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeer":{"shape":"Sm4","locationName":"transitGatewayConnectPeer"}}}},"CreateTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"Options":{"type":"structure","members":{"Igmpv2Support":{},"StaticSourcesSupport":{},"AutoAcceptSharedAssociations":{}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomain":{"shape":"Smh","locationName":"transitGatewayMulticastDomain"}}}},"CreateTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayId","PeerTransitGatewayId","PeerAccountId","PeerRegion"],"members":{"TransitGatewayId":{},"PeerTransitGatewayId":{},"PeerAccountId":{},"PeerRegion":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sn","locationName":"transitGatewayPeeringAttachment"}}}},"CreateTransitGatewayPrefixListReference":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PrefixListId"],"members":{"TransitGatewayRouteTableId":{},"PrefixListId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReference":{"shape":"Smp","locationName":"transitGatewayPrefixListReference"}}}},"CreateTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Smu","locationName":"route"}}}},"CreateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"TagSpecifications":{"shape":"S1t"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sn1","locationName":"transitGatewayRouteTable"}}}},"CreateTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayId","VpcId","SubnetIds"],"members":{"TransitGatewayId":{},"VpcId":{},"SubnetIds":{"shape":"S43"},"Options":{"type":"structure","members":{"DnsSupport":{},"Ipv6Support":{},"ApplianceModeSupport":{}}},"TagSpecifications":{"shape":"S1t"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sw","locationName":"transitGatewayVpcAttachment"}}}},"CreateVolume":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"OutpostArn":{},"Size":{"type":"integer"},"SnapshotId":{},"VolumeType":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"MultiAttachEnabled":{"type":"boolean"},"Throughput":{"type":"integer"},"ClientToken":{"idempotencyToken":true}}},"output":{"shape":"Sn7"}},"CreateVpc":{"input":{"type":"structure","members":{"CidrBlock":{},"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"Ipv6Pool":{},"Ipv6CidrBlock":{},"Ipv4IpamPoolId":{},"Ipv4NetmaskLength":{"type":"integer"},"Ipv6IpamPoolId":{},"Ipv6NetmaskLength":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockNetworkBorderGroup":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S9h","locationName":"vpc"}}}},"CreateVpcEndpoint":{"input":{"type":"structure","required":["VpcId","ServiceName"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointType":{},"VpcId":{},"ServiceName":{},"PolicyDocument":{},"RouteTableIds":{"shape":"Sne","locationName":"RouteTableId"},"SubnetIds":{"shape":"Snf","locationName":"SubnetId"},"SecurityGroupIds":{"shape":"Sng","locationName":"SecurityGroupId"},"ClientToken":{},"PrivateDnsEnabled":{"type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"VpcEndpoint":{"shape":"Sni","locationName":"vpcEndpoint"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationArn","ConnectionEvents"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"Se"},"ClientToken":{}}},"output":{"type":"structure","members":{"ConnectionNotification":{"shape":"Snr","locationName":"connectionNotification"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointServiceConfiguration":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"PrivateDnsName":{},"NetworkLoadBalancerArns":{"shape":"Se","locationName":"NetworkLoadBalancerArn"},"GatewayLoadBalancerArns":{"shape":"Se","locationName":"GatewayLoadBalancerArn"},"ClientToken":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ServiceConfiguration":{"shape":"Snw","locationName":"serviceConfiguration"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PeerOwnerId":{"locationName":"peerOwnerId"},"PeerVpcId":{"locationName":"peerVpcId"},"VpcId":{"locationName":"vpcId"},"PeerRegion":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"S1c","locationName":"vpcPeeringConnection"}}}},"CreateVpnConnection":{"input":{"type":"structure","required":["CustomerGatewayId","Type"],"members":{"CustomerGatewayId":{},"Type":{},"VpnGatewayId":{},"TransitGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Options":{"locationName":"options","type":"structure","members":{"EnableAcceleration":{"type":"boolean"},"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelInsideIpVersion":{},"TunnelOptions":{"type":"list","member":{"type":"structure","members":{"TunnelInsideCidr":{},"TunnelInsideIpv6Cidr":{},"PreSharedKey":{},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2LifetimeSeconds":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"RekeyFuzzPercentage":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"DPDTimeoutSeconds":{"type":"integer"},"DPDTimeoutAction":{},"Phase1EncryptionAlgorithms":{"shape":"Soc","locationName":"Phase1EncryptionAlgorithm"},"Phase2EncryptionAlgorithms":{"shape":"Soe","locationName":"Phase2EncryptionAlgorithm"},"Phase1IntegrityAlgorithms":{"shape":"Sog","locationName":"Phase1IntegrityAlgorithm"},"Phase2IntegrityAlgorithms":{"shape":"Soi","locationName":"Phase2IntegrityAlgorithm"},"Phase1DHGroupNumbers":{"shape":"Sok","locationName":"Phase1DHGroupNumber"},"Phase2DHGroupNumbers":{"shape":"Som","locationName":"Phase2DHGroupNumber"},"IKEVersions":{"shape":"Soo","locationName":"IKEVersion"},"StartupAction":{}}}},"LocalIpv4NetworkCidr":{},"RemoteIpv4NetworkCidr":{},"LocalIpv6NetworkCidr":{},"RemoteIpv6NetworkCidr":{}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Sor","locationName":"vpnConnection"}}}},"CreateVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"CreateVpnGateway":{"input":{"type":"structure","required":["Type"],"members":{"AvailabilityZone":{},"Type":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"AmazonSideAsn":{"type":"long"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateway":{"shape":"Spl","locationName":"vpnGateway"}}}},"DeleteCarrierGateway":{"input":{"type":"structure","required":["CarrierGatewayId"],"members":{"CarrierGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CarrierGateway":{"shape":"S8h","locationName":"carrierGateway"}}}},"DeleteClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S8x","locationName":"status"}}}},"DeleteClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock"],"members":{"ClientVpnEndpointId":{},"TargetVpcSubnetId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S91","locationName":"status"}}}},"DeleteCustomerGateway":{"input":{"type":"structure","required":["CustomerGatewayId"],"members":{"CustomerGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId"],"members":{"DhcpOptionsId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteEgressOnlyInternetGateway":{"input":{"type":"structure","required":["EgressOnlyInternetGatewayId"],"members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayId":{}}},"output":{"type":"structure","members":{"ReturnCode":{"locationName":"returnCode","type":"boolean"}}}},"DeleteFleets":{"input":{"type":"structure","required":["FleetIds","TerminateInstances"],"members":{"DryRun":{"type":"boolean"},"FleetIds":{"shape":"Spz","locationName":"FleetId"},"TerminateInstances":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetDeletions":{"locationName":"successfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentFleetState":{"locationName":"currentFleetState"},"PreviousFleetState":{"locationName":"previousFleetState"},"FleetId":{"locationName":"fleetId"}}}},"UnsuccessfulFleetDeletions":{"locationName":"unsuccessfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"FleetId":{"locationName":"fleetId"}}}}}}},"DeleteFlowLogs":{"input":{"type":"structure","required":["FlowLogIds"],"members":{"DryRun":{"type":"boolean"},"FlowLogIds":{"shape":"Sq9","locationName":"FlowLogId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"DeleteFpgaImage":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId"],"members":{"DryRun":{"type":"boolean"},"ForceDelete":{"type":"boolean"},"InstanceEventWindowId":{}}},"output":{"type":"structure","members":{"InstanceEventWindowState":{"locationName":"instanceEventWindowState","type":"structure","members":{"InstanceEventWindowId":{"locationName":"instanceEventWindowId"},"State":{"locationName":"state"}}}}}},"DeleteInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"}}}},"DeleteIpam":{"input":{"type":"structure","required":["IpamId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Cascade":{"type":"boolean"}}},"output":{"type":"structure","members":{"Ipam":{"shape":"Sd6","locationName":"ipam"}}}},"DeleteIpamPool":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{}}},"output":{"type":"structure","members":{"IpamPool":{"shape":"Sdj","locationName":"ipamPool"}}}},"DeleteIpamScope":{"input":{"type":"structure","required":["IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"IpamScopeId":{}}},"output":{"type":"structure","members":{"IpamScope":{"shape":"Sdq","locationName":"ipamScope"}}}},"DeleteKeyPair":{"input":{"type":"structure","members":{"KeyName":{},"KeyPairId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sfh","locationName":"launchTemplate"}}}},"DeleteLaunchTemplateVersions":{"input":{"type":"structure","required":["Versions"],"members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Squ","locationName":"LaunchTemplateVersion"}}},"output":{"type":"structure","members":{"SuccessfullyDeletedLaunchTemplateVersions":{"locationName":"successfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"}}}},"UnsuccessfullyDeletedLaunchTemplateVersions":{"locationName":"unsuccessfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"ResponseError":{"locationName":"responseError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"DeleteLocalGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","LocalGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sgr","locationName":"route"}}}},"DeleteLocalGatewayRouteTableVpcAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableVpcAssociationId"],"members":{"LocalGatewayRouteTableVpcAssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociation":{"shape":"Sgw","locationName":"localGatewayRouteTableVpcAssociation"}}}},"DeleteManagedPrefixList":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sh2","locationName":"prefixList"}}}},"DeleteNatGateway":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"DryRun":{"type":"boolean"},"NatGatewayId":{}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"}}}},"DeleteNetworkAcl":{"input":{"type":"structure","required":["NetworkAclId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}}},"DeleteNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","RuleNumber"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"DeleteNetworkInsightsAccessScope":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeId"],"members":{"DryRun":{"type":"boolean"},"NetworkInsightsAccessScopeId":{}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"}}}},"DeleteNetworkInsightsAccessScopeAnalysis":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeAnalysisId"],"members":{"NetworkInsightsAccessScopeAnalysisId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"}}}},"DeleteNetworkInsightsAnalysis":{"input":{"type":"structure","required":["NetworkInsightsAnalysisId"],"members":{"DryRun":{"type":"boolean"},"NetworkInsightsAnalysisId":{}}},"output":{"type":"structure","members":{"NetworkInsightsAnalysisId":{"locationName":"networkInsightsAnalysisId"}}}},"DeleteNetworkInsightsPath":{"input":{"type":"structure","required":["NetworkInsightsPathId"],"members":{"DryRun":{"type":"boolean"},"NetworkInsightsPathId":{}}},"output":{"type":"structure","members":{"NetworkInsightsPathId":{"locationName":"networkInsightsPathId"}}}},"DeleteNetworkInterface":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"DeleteNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfacePermissionId"],"members":{"NetworkInterfacePermissionId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeletePlacementGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"}}}},"DeletePublicIpv4Pool":{"input":{"type":"structure","required":["PoolId"],"members":{"DryRun":{"type":"boolean"},"PoolId":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"returnValue","type":"boolean"}}}},"DeleteQueuedReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstancesIds":{"locationName":"ReservedInstancesId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SuccessfulQueuedPurchaseDeletions":{"locationName":"successfulQueuedPurchaseDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"FailedQueuedPurchaseDeletions":{"locationName":"failedQueuedPurchaseDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}}}}},"DeleteRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteSecurityGroup":{"input":{"type":"structure","members":{"GroupId":{},"GroupName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnet":{"input":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnetCidrReservation":{"input":{"type":"structure","required":["SubnetCidrReservationId"],"members":{"SubnetCidrReservationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeletedSubnetCidrReservation":{"shape":"Skr","locationName":"deletedSubnetCidrReservation"}}}},"DeleteTags":{"input":{"type":"structure","required":["Resources"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"Sku","locationName":"resourceId"},"Tags":{"shape":"Ss","locationName":"tag"}}}},"DeleteTrafficMirrorFilter":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"}}}},"DeleteTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"}}}},"DeleteTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"}}}},"DeleteTrafficMirrorTarget":{"input":{"type":"structure","required":["TrafficMirrorTargetId"],"members":{"TrafficMirrorTargetId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"}}}},"DeleteTransitGateway":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Slr","locationName":"transitGateway"}}}},"DeleteTransitGatewayConnect":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnect":{"shape":"Sly","locationName":"transitGatewayConnect"}}}},"DeleteTransitGatewayConnectPeer":{"input":{"type":"structure","required":["TransitGatewayConnectPeerId"],"members":{"TransitGatewayConnectPeerId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeer":{"shape":"Sm4","locationName":"transitGatewayConnectPeer"}}}},"DeleteTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId"],"members":{"TransitGatewayMulticastDomainId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomain":{"shape":"Smh","locationName":"transitGatewayMulticastDomain"}}}},"DeleteTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sn","locationName":"transitGatewayPeeringAttachment"}}}},"DeleteTransitGatewayPrefixListReference":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PrefixListId"],"members":{"TransitGatewayRouteTableId":{},"PrefixListId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReference":{"shape":"Smp","locationName":"transitGatewayPrefixListReference"}}}},"DeleteTransitGatewayRoute":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","DestinationCidrBlock"],"members":{"TransitGatewayRouteTableId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Smu","locationName":"route"}}}},"DeleteTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sn1","locationName":"transitGatewayRouteTable"}}}},"DeleteTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sw","locationName":"transitGatewayVpcAttachment"}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpcEndpointConnectionNotifications":{"input":{"type":"structure","required":["ConnectionNotificationIds"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationIds":{"locationName":"ConnectionNotificationId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"DeleteVpcEndpointServiceConfigurations":{"input":{"type":"structure","required":["ServiceIds"],"members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sta","locationName":"ServiceId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"DeleteVpcEndpoints":{"input":{"type":"structure","required":["VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"S13","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"DeleteVpnGateway":{"input":{"type":"structure","required":["VpnGatewayId"],"members":{"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeprovisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1n","locationName":"byoipCidr"}}}},"DeprovisionIpamPoolCidr":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{}}},"output":{"type":"structure","members":{"IpamPoolCidr":{"shape":"Stn","locationName":"ipamPoolCidr"}}}},"DeprovisionPublicIpv4PoolCidr":{"input":{"type":"structure","required":["PoolId","Cidr"],"members":{"DryRun":{"type":"boolean"},"PoolId":{},"Cidr":{}}},"output":{"type":"structure","members":{"PoolId":{"locationName":"poolId"},"DeprovisionedAddresses":{"locationName":"deprovisionedAddressSet","type":"list","member":{"locationName":"item"}}}}},"DeregisterImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeregisterInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTagAttribute":{"type":"structure","members":{"IncludeAllTagsOfInstance":{"type":"boolean"},"InstanceTagKeys":{"shape":"Stx","locationName":"InstanceTagKey"}}}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Stz","locationName":"instanceTagAttribute"}}}},"DeregisterTransitGatewayMulticastGroupMembers":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Su1"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeregisteredMulticastGroupMembers":{"locationName":"deregisteredMulticastGroupMembers","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"DeregisteredNetworkInterfaceIds":{"shape":"Se","locationName":"deregisteredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"DeregisterTransitGatewayMulticastGroupSources":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Su1"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeregisteredMulticastGroupSources":{"locationName":"deregisteredMulticastGroupSources","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"DeregisteredNetworkInterfaceIds":{"shape":"Se","locationName":"deregisteredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"locationName":"attributeName","type":"list","member":{"locationName":"attributeName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AccountAttributes":{"locationName":"accountAttributeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"AttributeValues":{"locationName":"attributeValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeValue":{"locationName":"attributeValue"}}}}}}}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"PublicIps":{"locationName":"PublicIp","type":"list","member":{"locationName":"PublicIp"}},"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"AllocationId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"Domain":{"locationName":"domain"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceOwnerId":{"locationName":"networkInterfaceOwnerId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"Tags":{"shape":"Ss","locationName":"tagSet"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"CarrierIp":{"locationName":"carrierIp"}}}}}}},"DescribeAddressesAttribute":{"input":{"type":"structure","members":{"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"item"}},"Attribute":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressSet","type":"list","member":{"shape":"Suu","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeAggregateIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UseLongIdsAggregated":{"locationName":"useLongIdsAggregated","type":"boolean"},"Statuses":{"shape":"Suy","locationName":"statusSet"}}}},"DescribeAvailabilityZones":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"ZoneNames":{"locationName":"ZoneName","type":"list","member":{"locationName":"ZoneName"}},"ZoneIds":{"locationName":"ZoneId","type":"list","member":{"locationName":"ZoneId"}},"AllAvailabilityZones":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZoneInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"zoneState"},"OptInStatus":{"locationName":"optInStatus"},"Messages":{"locationName":"messageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Message":{"locationName":"message"}}}},"RegionName":{"locationName":"regionName"},"ZoneName":{"locationName":"zoneName"},"ZoneId":{"locationName":"zoneId"},"GroupName":{"locationName":"groupName"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"ZoneType":{"locationName":"zoneType"},"ParentZoneName":{"locationName":"parentZoneName"},"ParentZoneId":{"locationName":"parentZoneId"}}}}}}},"DescribeBundleTasks":{"input":{"type":"structure","members":{"BundleIds":{"locationName":"BundleId","type":"list","member":{"locationName":"BundleId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTasks":{"locationName":"bundleInstanceTasksSet","type":"list","member":{"shape":"S5w","locationName":"item"}}}}},"DescribeByoipCidrs":{"input":{"type":"structure","required":["MaxResults"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ByoipCidrs":{"locationName":"byoipCidrSet","type":"list","member":{"shape":"S1n","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityReservationFleets":{"input":{"type":"structure","members":{"CapacityReservationFleetIds":{"shape":"S66","locationName":"CapacityReservationFleetId"},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CapacityReservationFleets":{"locationName":"capacityReservationFleetSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"CapacityReservationFleetArn":{"locationName":"capacityReservationFleetArn"},"State":{"locationName":"state"},"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"TotalFulfilledCapacity":{"locationName":"totalFulfilledCapacity","type":"double"},"Tenancy":{"locationName":"tenancy"},"EndDate":{"locationName":"endDate","type":"timestamp"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"AllocationStrategy":{"locationName":"allocationStrategy"},"InstanceTypeSpecifications":{"shape":"S8d","locationName":"instanceTypeSpecificationSet"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityReservations":{"input":{"type":"structure","members":{"CapacityReservationIds":{"locationName":"CapacityReservationId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservations":{"locationName":"capacityReservationSet","type":"list","member":{"shape":"S81","locationName":"item"}}}}},"DescribeCarrierGateways":{"input":{"type":"structure","members":{"CarrierGatewayIds":{"locationName":"CarrierGatewayId","type":"list","member":{}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CarrierGateways":{"locationName":"carrierGatewaySet","type":"list","member":{"shape":"S8h","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClassicLinkInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Groups":{"shape":"Sim","locationName":"groupSet"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnAuthorizationRules":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"},"NextToken":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizationRules":{"locationName":"authorizationRule","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"AccessAll":{"locationName":"accessAll","type":"boolean"},"DestinationCidr":{"locationName":"destinationCidr"},"Status":{"shape":"S55","locationName":"status"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Connections":{"locationName":"connections","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Timestamp":{"locationName":"timestamp"},"ConnectionId":{"locationName":"connectionId"},"Username":{"locationName":"username"},"ConnectionEstablishedTime":{"locationName":"connectionEstablishedTime"},"IngressBytes":{"locationName":"ingressBytes"},"EgressBytes":{"locationName":"egressBytes"},"IngressPackets":{"locationName":"ingressPackets"},"EgressPackets":{"locationName":"egressPackets"},"ClientIp":{"locationName":"clientIp"},"CommonName":{"locationName":"commonName"},"Status":{"shape":"Swd","locationName":"status"},"ConnectionEndTime":{"locationName":"connectionEndTime"},"PostureComplianceStatuses":{"shape":"Se","locationName":"postureComplianceStatusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnEndpoints":{"input":{"type":"structure","members":{"ClientVpnEndpointIds":{"locationName":"ClientVpnEndpointId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpoints":{"locationName":"clientVpnEndpoint","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"Status":{"shape":"S8x","locationName":"status"},"CreationTime":{"locationName":"creationTime"},"DeletionTime":{"locationName":"deletionTime"},"DnsName":{"locationName":"dnsName"},"ClientCidrBlock":{"locationName":"clientCidrBlock"},"DnsServers":{"shape":"Se","locationName":"dnsServer"},"SplitTunnel":{"locationName":"splitTunnel","type":"boolean"},"VpnProtocol":{"locationName":"vpnProtocol"},"TransportProtocol":{"locationName":"transportProtocol"},"VpnPort":{"locationName":"vpnPort","type":"integer"},"AssociatedTargetNetworks":{"deprecated":true,"deprecatedMessage":"This property is deprecated. To view the target networks associated with a Client VPN endpoint, call DescribeClientVpnTargetNetworks and inspect the clientVpnTargetNetworks response element.","locationName":"associatedTargetNetwork","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkId":{"locationName":"networkId"},"NetworkType":{"locationName":"networkType"}}}},"ServerCertificateArn":{"locationName":"serverCertificateArn"},"AuthenticationOptions":{"locationName":"authenticationOptions","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"ActiveDirectory":{"locationName":"activeDirectory","type":"structure","members":{"DirectoryId":{"locationName":"directoryId"}}},"MutualAuthentication":{"locationName":"mutualAuthentication","type":"structure","members":{"ClientRootCertificateChain":{"locationName":"clientRootCertificateChain"}}},"FederatedAuthentication":{"locationName":"federatedAuthentication","type":"structure","members":{"SamlProviderArn":{"locationName":"samlProviderArn"},"SelfServiceSamlProviderArn":{"locationName":"selfServiceSamlProviderArn"}}}}}},"ConnectionLogOptions":{"locationName":"connectionLogOptions","type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"Tags":{"shape":"Ss","locationName":"tagSet"},"SecurityGroupIds":{"shape":"S2c","locationName":"securityGroupIdSet"},"VpcId":{"locationName":"vpcId"},"SelfServicePortalUrl":{"locationName":"selfServicePortalUrl"},"ClientConnectOptions":{"locationName":"clientConnectOptions","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"LambdaFunctionArn":{"locationName":"lambdaFunctionArn"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}},"SessionTimeoutHours":{"locationName":"sessionTimeoutHours","type":"integer"},"ClientLoginBannerOptions":{"locationName":"clientLoginBannerOptions","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"BannerText":{"locationName":"bannerText"}}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnRoutes":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"DestinationCidr":{"locationName":"destinationCidr"},"TargetSubnet":{"locationName":"targetSubnet"},"Type":{"locationName":"type"},"Origin":{"locationName":"origin"},"Status":{"shape":"S91","locationName":"status"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnTargetNetworks":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"AssociationIds":{"shape":"Se"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnTargetNetworks":{"locationName":"clientVpnTargetNetworks","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociationId":{"locationName":"associationId"},"VpcId":{"locationName":"vpcId"},"TargetNetworkId":{"locationName":"targetNetworkId"},"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S2y","locationName":"status"},"SecurityGroups":{"shape":"Se","locationName":"securityGroups"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCoipPools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPools":{"locationName":"coipPoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"PoolCidrs":{"shape":"Se","locationName":"poolCidrSet"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"Tags":{"shape":"Ss","locationName":"tagSet"},"PoolArn":{"locationName":"poolArn"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeConversionTasks":{"input":{"type":"structure","members":{"ConversionTaskIds":{"locationName":"conversionTaskId","type":"list","member":{"locationName":"item"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ConversionTasks":{"locationName":"conversionTasks","type":"list","member":{"shape":"Sxk","locationName":"item"}}}}},"DescribeCustomerGateways":{"input":{"type":"structure","members":{"CustomerGatewayIds":{"locationName":"CustomerGatewayId","type":"list","member":{"locationName":"CustomerGatewayId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateways":{"locationName":"customerGatewaySet","type":"list","member":{"shape":"S96","locationName":"item"}}}}},"DescribeDhcpOptions":{"input":{"type":"structure","members":{"DhcpOptionsIds":{"locationName":"DhcpOptionsId","type":"list","member":{"locationName":"DhcpOptionsId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DhcpOptions":{"locationName":"dhcpOptionsSet","type":"list","member":{"shape":"S9q","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeEgressOnlyInternetGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayIds":{"locationName":"EgressOnlyInternetGatewayId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"EgressOnlyInternetGateways":{"locationName":"egressOnlyInternetGatewaySet","type":"list","member":{"shape":"S9x","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeElasticGpus":{"input":{"type":"structure","members":{"ElasticGpuIds":{"locationName":"ElasticGpuId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ElasticGpuSet":{"locationName":"elasticGpuSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"AvailabilityZone":{"locationName":"availabilityZone"},"ElasticGpuType":{"locationName":"elasticGpuType"},"ElasticGpuHealth":{"locationName":"elasticGpuHealth","type":"structure","members":{"Status":{"locationName":"status"}}},"ElasticGpuState":{"locationName":"elasticGpuState"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"ExportImageTaskIds":{"locationName":"ExportImageTaskId","type":"list","member":{"locationName":"ExportImageTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExportImageTasks":{"locationName":"exportImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"Syn","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIds":{"locationName":"exportTaskId","type":"list","member":{"locationName":"ExportTaskId"}},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"ExportTasks":{"locationName":"exportTaskSet","type":"list","member":{"shape":"Scv","locationName":"item"}}}}},"DescribeFastLaunchImages":{"input":{"type":"structure","members":{"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"ImageId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"FastLaunchImages":{"locationName":"fastLaunchImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ImageId":{"locationName":"imageId"},"ResourceType":{"locationName":"resourceType"},"SnapshotConfiguration":{"shape":"Sz0","locationName":"snapshotConfiguration"},"LaunchTemplate":{"shape":"Sz1","locationName":"launchTemplate"},"MaxParallelLaunches":{"locationName":"maxParallelLaunches","type":"integer"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"StateTransitionTime":{"locationName":"stateTransitionTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFastSnapshotRestores":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"FastSnapshotRestores":{"locationName":"fastSnapshotRestoreSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFleetHistory":{"input":{"type":"structure","required":["FleetId","StartTime"],"members":{"DryRun":{"type":"boolean"},"EventType":{},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"StartTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"Sze","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeFleetInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"Szh","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"}}}},"DescribeFleets":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetIds":{"shape":"Spz","locationName":"FleetId"},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Fleets":{"locationName":"fleetSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"FleetId":{"locationName":"fleetId"},"FleetState":{"locationName":"fleetState"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"FulfilledOnDemandCapacity":{"locationName":"fulfilledOnDemandCapacity","type":"double"},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sbl","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"shape":"Sbm","locationName":"item"}}}}},"TargetCapacitySpecification":{"locationName":"targetCapacitySpecification","type":"structure","members":{"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"SpotTargetCapacity":{"locationName":"spotTargetCapacity","type":"integer"},"DefaultTargetCapacityType":{"locationName":"defaultTargetCapacityType"},"TargetCapacityUnitType":{"locationName":"targetCapacityUnitType"}}},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"MaintenanceStrategies":{"locationName":"maintenanceStrategies","type":"structure","members":{"CapacityRebalance":{"locationName":"capacityRebalance","type":"structure","members":{"ReplacementStrategy":{"locationName":"replacementStrategy"},"TerminationDelay":{"locationName":"terminationDelay","type":"integer"}}}}},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"OnDemandOptions":{"locationName":"onDemandOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"CapacityReservationOptions":{"locationName":"capacityReservationOptions","type":"structure","members":{"UsageStrategy":{"locationName":"usageStrategy"}}},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"Tags":{"shape":"Ss","locationName":"tagSet"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sbk","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sbk","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"Sc0","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}},"Context":{"locationName":"context"}}}}}}},"DescribeFlowLogs":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"Sug"},"FlowLogIds":{"shape":"Sq9","locationName":"FlowLogId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FlowLogs":{"locationName":"flowLogSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CreationTime":{"locationName":"creationTime","type":"timestamp"},"DeliverLogsErrorMessage":{"locationName":"deliverLogsErrorMessage"},"DeliverLogsPermissionArn":{"locationName":"deliverLogsPermissionArn"},"DeliverLogsStatus":{"locationName":"deliverLogsStatus"},"FlowLogId":{"locationName":"flowLogId"},"FlowLogStatus":{"locationName":"flowLogStatus"},"LogGroupName":{"locationName":"logGroupName"},"ResourceId":{"locationName":"resourceId"},"TrafficType":{"locationName":"trafficType"},"LogDestinationType":{"locationName":"logDestinationType"},"LogDestination":{"locationName":"logDestination"},"LogFormat":{"locationName":"logFormat"},"Tags":{"shape":"Ss","locationName":"tagSet"},"MaxAggregationInterval":{"locationName":"maxAggregationInterval","type":"integer"},"DestinationOptions":{"locationName":"destinationOptions","type":"structure","members":{"FileFormat":{"locationName":"fileFormat"},"HiveCompatiblePartitions":{"locationName":"hiveCompatiblePartitions","type":"boolean"},"PerHourPartition":{"locationName":"perHourPartition","type":"boolean"}}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId","Attribute"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"S10a","locationName":"fpgaImageAttribute"}}}},"DescribeFpgaImages":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"FpgaImageIds":{"locationName":"FpgaImageId","type":"list","member":{"locationName":"item"}},"Owners":{"shape":"S10j","locationName":"Owner"},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FpgaImages":{"locationName":"fpgaImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"ShellVersion":{"locationName":"shellVersion"},"PciId":{"locationName":"pciId","type":"structure","members":{"DeviceId":{},"VendorId":{},"SubsystemId":{},"SubsystemVendorId":{}}},"State":{"locationName":"state","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"CreateTime":{"locationName":"createTime","type":"timestamp"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"Tags":{"shape":"Ss","locationName":"tags"},"Public":{"locationName":"public","type":"boolean"},"DataRetentionSupport":{"locationName":"dataRetentionSupport","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHostReservationOfferings":{"input":{"type":"structure","members":{"Filter":{"shape":"Sug"},"MaxDuration":{"type":"integer"},"MaxResults":{"type":"integer"},"MinDuration":{"type":"integer"},"NextToken":{},"OfferingId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"OfferingSet":{"locationName":"offeringSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}}}}},"DescribeHostReservations":{"input":{"type":"structure","members":{"Filter":{"shape":"Sug"},"HostReservationIdSet":{"type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HostReservationSet":{"locationName":"hostReservationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"End":{"locationName":"end","type":"timestamp"},"HostIdSet":{"shape":"S114","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UpfrontPrice":{"locationName":"upfrontPrice"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHosts":{"input":{"type":"structure","members":{"Filter":{"shape":"Sug","locationName":"filter"},"HostIds":{"shape":"S117","locationName":"hostId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Hosts":{"locationName":"hostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableCapacity":{"locationName":"availableCapacity","type":"structure","members":{"AvailableInstanceCapacity":{"locationName":"availableInstanceCapacity","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailableCapacity":{"locationName":"availableCapacity","type":"integer"},"InstanceType":{"locationName":"instanceType"},"TotalCapacity":{"locationName":"totalCapacity","type":"integer"}}}},"AvailableVCpus":{"locationName":"availableVCpus","type":"integer"}}},"ClientToken":{"locationName":"clientToken"},"HostId":{"locationName":"hostId"},"HostProperties":{"locationName":"hostProperties","type":"structure","members":{"Cores":{"locationName":"cores","type":"integer"},"InstanceType":{"locationName":"instanceType"},"InstanceFamily":{"locationName":"instanceFamily"},"Sockets":{"locationName":"sockets","type":"integer"},"TotalVCpus":{"locationName":"totalVCpus","type":"integer"}}},"HostReservationId":{"locationName":"hostReservationId"},"Instances":{"locationName":"instances","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"OwnerId":{"locationName":"ownerId"}}}},"State":{"locationName":"state"},"AllocationTime":{"locationName":"allocationTime","type":"timestamp"},"ReleaseTime":{"locationName":"releaseTime","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"},"HostRecovery":{"locationName":"hostRecovery"},"AllowsMultipleInstanceTypes":{"locationName":"allowsMultipleInstanceTypes"},"OwnerId":{"locationName":"ownerId"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"MemberOfServiceLinkedResourceGroup":{"locationName":"memberOfServiceLinkedResourceGroup","type":"boolean"},"OutpostArn":{"locationName":"outpostArn"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIamInstanceProfileAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"AssociationId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociations":{"locationName":"iamInstanceProfileAssociationSet","type":"list","member":{"shape":"S38","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIdFormat":{"input":{"type":"structure","members":{"Resource":{}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Suy","locationName":"statusSet"}}}},"DescribeIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Suy","locationName":"statusSet"}}}},"DescribeImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BlockDeviceMappings":{"shape":"S11w","locationName":"blockDeviceMapping"},"ImageId":{"locationName":"imageId"},"LaunchPermissions":{"shape":"S11x","locationName":"launchPermission"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"Description":{"shape":"S9u","locationName":"description"},"KernelId":{"shape":"S9u","locationName":"kernel"},"RamdiskId":{"shape":"S9u","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S9u","locationName":"sriovNetSupport"},"BootMode":{"shape":"S9u","locationName":"bootMode"},"LastLaunchedTime":{"shape":"S9u","locationName":"lastLaunchedTime"}}}},"DescribeImages":{"input":{"type":"structure","members":{"ExecutableUsers":{"locationName":"ExecutableBy","type":"list","member":{"locationName":"ExecutableBy"}},"Filters":{"shape":"Sug","locationName":"Filter"},"ImageIds":{"shape":"S121","locationName":"ImageId"},"Owners":{"shape":"S10j","locationName":"Owner"},"IncludeDeprecated":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imagesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"CreationDate":{"locationName":"creationDate"},"ImageId":{"locationName":"imageId"},"ImageLocation":{"locationName":"imageLocation"},"ImageType":{"locationName":"imageType"},"Public":{"locationName":"isPublic","type":"boolean"},"KernelId":{"locationName":"kernelId"},"OwnerId":{"locationName":"imageOwnerId"},"Platform":{"locationName":"platform"},"PlatformDetails":{"locationName":"platformDetails"},"UsageOperation":{"locationName":"usageOperation"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"locationName":"imageState"},"BlockDeviceMappings":{"shape":"S11w","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageOwnerAlias":{"locationName":"imageOwnerAlias"},"Name":{"locationName":"name"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"S12a","locationName":"stateReason"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"},"BootMode":{"locationName":"bootMode"},"DeprecationTime":{"locationName":"deprecationTime"}}}}}}},"DescribeImportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug"},"ImportTaskIds":{"locationName":"ImportTaskId","type":"list","member":{"locationName":"ImportTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportImageTasks":{"locationName":"importImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"S12j","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Ss","locationName":"tagSet"},"LicenseSpecifications":{"shape":"S12m","locationName":"licenseSpecifications"},"UsageOperation":{"locationName":"usageOperation"},"BootMode":{"locationName":"bootMode"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportSnapshotTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug"},"ImportTaskIds":{"locationName":"ImportTaskId","type":"list","member":{"locationName":"ImportTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSnapshotTasks":{"locationName":"importSnapshotTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"S12u","locationName":"snapshotTaskDetail"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}},"output":{"type":"structure","members":{"Groups":{"shape":"Sim","locationName":"groupSet"},"BlockDeviceMappings":{"shape":"S12y","locationName":"blockDeviceMapping"},"DisableApiTermination":{"shape":"S131","locationName":"disableApiTermination"},"EnaSupport":{"shape":"S131","locationName":"enaSupport"},"EnclaveOptions":{"shape":"S132","locationName":"enclaveOptions"},"EbsOptimized":{"shape":"S131","locationName":"ebsOptimized"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S9u","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S9u","locationName":"instanceType"},"KernelId":{"shape":"S9u","locationName":"kernel"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"RamdiskId":{"shape":"S9u","locationName":"ramdisk"},"RootDeviceName":{"shape":"S9u","locationName":"rootDeviceName"},"SourceDestCheck":{"shape":"S131","locationName":"sourceDestCheck"},"SriovNetSupport":{"shape":"S9u","locationName":"sriovNetSupport"},"UserData":{"shape":"S9u","locationName":"userData"}}}},"DescribeInstanceCreditSpecifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceCreditSpecifications":{"locationName":"instanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"CpuCredits":{"locationName":"cpuCredits"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Stz","locationName":"instanceTagAttribute"}}}},"DescribeInstanceEventWindows":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceEventWindowIds":{"locationName":"InstanceEventWindowId","type":"list","member":{"locationName":"InstanceEventWindowId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceEventWindows":{"locationName":"instanceEventWindowSet","type":"list","member":{"shape":"S3i","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludeAllInstances":{"locationName":"includeAllInstances","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceStatuses":{"locationName":"instanceStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"OutpostArn":{"locationName":"outpostArn"},"Events":{"locationName":"eventsSet","type":"list","member":{"shape":"S13k","locationName":"item"}},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"shape":"S13n","locationName":"instanceState"},"InstanceStatus":{"shape":"S13p","locationName":"instanceStatus"},"SystemStatus":{"shape":"S13p","locationName":"systemStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTypeOfferings":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LocationType":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypeOfferings":{"locationName":"instanceTypeOfferingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"LocationType":{"locationName":"locationType"},"Location":{"locationName":"location"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTypes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypes":{"locationName":"instanceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"CurrentGeneration":{"locationName":"currentGeneration","type":"boolean"},"FreeTierEligible":{"locationName":"freeTierEligible","type":"boolean"},"SupportedUsageClasses":{"locationName":"supportedUsageClasses","type":"list","member":{"locationName":"item"}},"SupportedRootDeviceTypes":{"locationName":"supportedRootDeviceTypes","type":"list","member":{"locationName":"item"}},"SupportedVirtualizationTypes":{"locationName":"supportedVirtualizationTypes","type":"list","member":{"locationName":"item"}},"BareMetal":{"locationName":"bareMetal","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ProcessorInfo":{"locationName":"processorInfo","type":"structure","members":{"SupportedArchitectures":{"locationName":"supportedArchitectures","type":"list","member":{"locationName":"item"}},"SustainedClockSpeedInGhz":{"locationName":"sustainedClockSpeedInGhz","type":"double"}}},"VCpuInfo":{"locationName":"vCpuInfo","type":"structure","members":{"DefaultVCpus":{"locationName":"defaultVCpus","type":"integer"},"DefaultCores":{"locationName":"defaultCores","type":"integer"},"DefaultThreadsPerCore":{"locationName":"defaultThreadsPerCore","type":"integer"},"ValidCores":{"locationName":"validCores","type":"list","member":{"locationName":"item","type":"integer"}},"ValidThreadsPerCore":{"locationName":"validThreadsPerCore","type":"list","member":{"locationName":"item","type":"integer"}}}},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"long"}}},"InstanceStorageSupported":{"locationName":"instanceStorageSupported","type":"boolean"},"InstanceStorageInfo":{"locationName":"instanceStorageInfo","type":"structure","members":{"TotalSizeInGB":{"locationName":"totalSizeInGB","type":"long"},"Disks":{"locationName":"disks","type":"list","member":{"locationName":"item","type":"structure","members":{"SizeInGB":{"locationName":"sizeInGB","type":"long"},"Count":{"locationName":"count","type":"integer"},"Type":{"locationName":"type"}}}},"NvmeSupport":{"locationName":"nvmeSupport"},"EncryptionSupport":{"locationName":"encryptionSupport"}}},"EbsInfo":{"locationName":"ebsInfo","type":"structure","members":{"EbsOptimizedSupport":{"locationName":"ebsOptimizedSupport"},"EncryptionSupport":{"locationName":"encryptionSupport"},"EbsOptimizedInfo":{"locationName":"ebsOptimizedInfo","type":"structure","members":{"BaselineBandwidthInMbps":{"locationName":"baselineBandwidthInMbps","type":"integer"},"BaselineThroughputInMBps":{"locationName":"baselineThroughputInMBps","type":"double"},"BaselineIops":{"locationName":"baselineIops","type":"integer"},"MaximumBandwidthInMbps":{"locationName":"maximumBandwidthInMbps","type":"integer"},"MaximumThroughputInMBps":{"locationName":"maximumThroughputInMBps","type":"double"},"MaximumIops":{"locationName":"maximumIops","type":"integer"}}},"NvmeSupport":{"locationName":"nvmeSupport"}}},"NetworkInfo":{"locationName":"networkInfo","type":"structure","members":{"NetworkPerformance":{"locationName":"networkPerformance"},"MaximumNetworkInterfaces":{"locationName":"maximumNetworkInterfaces","type":"integer"},"MaximumNetworkCards":{"locationName":"maximumNetworkCards","type":"integer"},"DefaultNetworkCardIndex":{"locationName":"defaultNetworkCardIndex","type":"integer"},"NetworkCards":{"locationName":"networkCards","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"NetworkPerformance":{"locationName":"networkPerformance"},"MaximumNetworkInterfaces":{"locationName":"maximumNetworkInterfaces","type":"integer"}}}},"Ipv4AddressesPerInterface":{"locationName":"ipv4AddressesPerInterface","type":"integer"},"Ipv6AddressesPerInterface":{"locationName":"ipv6AddressesPerInterface","type":"integer"},"Ipv6Supported":{"locationName":"ipv6Supported","type":"boolean"},"EnaSupport":{"locationName":"enaSupport"},"EfaSupported":{"locationName":"efaSupported","type":"boolean"},"EfaInfo":{"locationName":"efaInfo","type":"structure","members":{"MaximumEfaInterfaces":{"locationName":"maximumEfaInterfaces","type":"integer"}}},"EncryptionInTransitSupported":{"locationName":"encryptionInTransitSupported","type":"boolean"}}},"GpuInfo":{"locationName":"gpuInfo","type":"structure","members":{"Gpus":{"locationName":"gpus","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"Count":{"locationName":"count","type":"integer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalGpuMemoryInMiB":{"locationName":"totalGpuMemoryInMiB","type":"integer"}}},"FpgaInfo":{"locationName":"fpgaInfo","type":"structure","members":{"Fpgas":{"locationName":"fpgas","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"Count":{"locationName":"count","type":"integer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalFpgaMemoryInMiB":{"locationName":"totalFpgaMemoryInMiB","type":"integer"}}},"PlacementGroupInfo":{"locationName":"placementGroupInfo","type":"structure","members":{"SupportedStrategies":{"locationName":"supportedStrategies","type":"list","member":{"locationName":"item"}}}},"InferenceAcceleratorInfo":{"locationName":"inferenceAcceleratorInfo","type":"structure","members":{"Accelerators":{"locationName":"item","type":"list","member":{"type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"}}}}}},"HibernationSupported":{"locationName":"hibernationSupported","type":"boolean"},"BurstablePerformanceSupported":{"locationName":"burstablePerformanceSupported","type":"boolean"},"DedicatedHostsSupported":{"locationName":"dedicatedHostsSupported","type":"boolean"},"AutoRecoverySupported":{"locationName":"autoRecoverySupported","type":"boolean"},"SupportedBootModes":{"locationName":"supportedBootModes","type":"list","member":{"locationName":"item"}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Reservations":{"locationName":"reservationSet","type":"list","member":{"shape":"S16t","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInternetGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayIds":{"locationName":"internetGatewayId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InternetGateways":{"locationName":"internetGatewaySet","type":"list","member":{"shape":"Sd1","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIpamPools":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamPoolIds":{"shape":"Se","locationName":"IpamPoolId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"IpamPools":{"locationName":"ipamPoolSet","type":"list","member":{"shape":"Sdj","locationName":"item"}}}}},"DescribeIpamScopes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamScopeIds":{"shape":"Se","locationName":"IpamScopeId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"IpamScopes":{"locationName":"ipamScopeSet","type":"list","member":{"shape":"Sdq","locationName":"item"}}}}},"DescribeIpams":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamIds":{"shape":"Se","locationName":"IpamId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Ipams":{"locationName":"ipamSet","type":"list","member":{"shape":"Sd6","locationName":"item"}}}}},"DescribeIpv6Pools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"Ipv6Pools":{"locationName":"ipv6PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolCidrBlocks":{"locationName":"poolCidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidr":{"locationName":"poolCidrBlock"}}}},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeKeyPairs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"KeyNames":{"locationName":"KeyName","type":"list","member":{"locationName":"KeyName"}},"KeyPairIds":{"locationName":"KeyPairId","type":"list","member":{"locationName":"KeyPairId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludePublicKey":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyPairs":{"locationName":"keySet","type":"list","member":{"locationName":"item","type":"structure","members":{"KeyPairId":{"locationName":"keyPairId"},"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"},"KeyType":{"locationName":"keyType"},"Tags":{"shape":"Ss","locationName":"tagSet"},"PublicKey":{"locationName":"publicKey"},"CreateTime":{"locationName":"createTime","type":"timestamp"}}}}}}},"DescribeLaunchTemplateVersions":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Squ","locationName":"LaunchTemplateVersion"},"MinVersion":{},"MaxVersion":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"LaunchTemplateVersions":{"locationName":"launchTemplateVersionSet","type":"list","member":{"shape":"Sfn","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLaunchTemplates":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateIds":{"locationName":"LaunchTemplateId","type":"list","member":{"locationName":"item"}},"LaunchTemplateNames":{"locationName":"LaunchTemplateName","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"LaunchTemplates":{"locationName":"launchTemplates","type":"list","member":{"shape":"Sfh","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"input":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationIds":{"locationName":"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId":{"locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociationId"},"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"LocalGatewayId":{"locationName":"localGatewayId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTableVpcAssociations":{"input":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociationIds":{"locationName":"LocalGatewayRouteTableVpcAssociationId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociations":{"locationName":"localGatewayRouteTableVpcAssociationSet","type":"list","member":{"shape":"Sgw","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTables":{"input":{"type":"structure","members":{"LocalGatewayRouteTableIds":{"locationName":"LocalGatewayRouteTableId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTables":{"locationName":"localGatewayRouteTableSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"LocalGatewayId":{"locationName":"localGatewayId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayVirtualInterfaceGroups":{"input":{"type":"structure","members":{"LocalGatewayVirtualInterfaceGroupIds":{"locationName":"LocalGatewayVirtualInterfaceGroupId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayVirtualInterfaceGroups":{"locationName":"localGatewayVirtualInterfaceGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"LocalGatewayVirtualInterfaceIds":{"shape":"S19e","locationName":"localGatewayVirtualInterfaceIdSet"},"LocalGatewayId":{"locationName":"localGatewayId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayVirtualInterfaces":{"input":{"type":"structure","members":{"LocalGatewayVirtualInterfaceIds":{"shape":"S19e","locationName":"LocalGatewayVirtualInterfaceId"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayVirtualInterfaces":{"locationName":"localGatewayVirtualInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayVirtualInterfaceId":{"locationName":"localGatewayVirtualInterfaceId"},"LocalGatewayId":{"locationName":"localGatewayId"},"Vlan":{"locationName":"vlan","type":"integer"},"LocalAddress":{"locationName":"localAddress"},"PeerAddress":{"locationName":"peerAddress"},"LocalBgpAsn":{"locationName":"localBgpAsn","type":"integer"},"PeerBgpAsn":{"locationName":"peerBgpAsn","type":"integer"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGateways":{"input":{"type":"structure","members":{"LocalGatewayIds":{"locationName":"LocalGatewayId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGateways":{"locationName":"localGatewaySet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayId":{"locationName":"localGatewayId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeManagedPrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"shape":"Se","locationName":"PrefixListId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"shape":"Sh2","locationName":"item"}}}}},"DescribeMovingAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"PublicIps":{"shape":"Se","locationName":"publicIp"}}},"output":{"type":"structure","members":{"MovingAddressStatuses":{"locationName":"movingAddressStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"MoveStatus":{"locationName":"moveStatus"},"PublicIp":{"locationName":"publicIp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNatGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"Sug"},"MaxResults":{"type":"integer"},"NatGatewayIds":{"locationName":"NatGatewayId","type":"list","member":{"locationName":"item"}},"NextToken":{}}},"output":{"type":"structure","members":{"NatGateways":{"locationName":"natGatewaySet","type":"list","member":{"shape":"Sh7","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkAcls":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclIds":{"locationName":"NetworkAclId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkAcls":{"locationName":"networkAclSet","type":"list","member":{"shape":"She","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsAccessScopeAnalyses":{"input":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisIds":{"locationName":"NetworkInsightsAccessScopeAnalysisId","type":"list","member":{"locationName":"item"}},"NetworkInsightsAccessScopeId":{},"AnalysisStartTimeBegin":{"type":"timestamp"},"AnalysisStartTimeEnd":{"type":"timestamp"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalyses":{"locationName":"networkInsightsAccessScopeAnalysisSet","type":"list","member":{"shape":"S1ae","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsAccessScopes":{"input":{"type":"structure","members":{"NetworkInsightsAccessScopeIds":{"locationName":"NetworkInsightsAccessScopeId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopes":{"locationName":"networkInsightsAccessScopeSet","type":"list","member":{"shape":"Shz","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsAnalyses":{"input":{"type":"structure","members":{"NetworkInsightsAnalysisIds":{"locationName":"NetworkInsightsAnalysisId","type":"list","member":{"locationName":"item"}},"NetworkInsightsPathId":{},"AnalysisStartTime":{"type":"timestamp"},"AnalysisEndTime":{"type":"timestamp"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsAnalyses":{"locationName":"networkInsightsAnalysisSet","type":"list","member":{"shape":"S1ap","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsPaths":{"input":{"type":"structure","members":{"NetworkInsightsPathIds":{"locationName":"NetworkInsightsPathId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsPaths":{"locationName":"networkInsightsPathSet","type":"list","member":{"shape":"Sie","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"Sil","locationName":"attachment"},"Description":{"shape":"S9u","locationName":"description"},"Groups":{"shape":"Sim","locationName":"groupSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"S131","locationName":"sourceDestCheck"}}}},"DescribeNetworkInterfacePermissions":{"input":{"type":"structure","members":{"NetworkInterfacePermissionIds":{"locationName":"NetworkInterfacePermissionId","type":"list","member":{}},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfacePermissions":{"locationName":"networkInterfacePermissions","type":"list","member":{"shape":"Siz","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaces":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceIds":{"locationName":"NetworkInterfaceId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"shape":"Sij","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribePlacementGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupNames":{"locationName":"groupName","type":"list","member":{}},"GroupIds":{"locationName":"GroupId","type":"list","member":{"locationName":"GroupId"}}}},"output":{"type":"structure","members":{"PlacementGroups":{"locationName":"placementGroupSet","type":"list","member":{"shape":"Sj5","locationName":"item"}}}}},"DescribePrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"locationName":"PrefixListId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidrs":{"shape":"Se","locationName":"cidrSet"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListName":{"locationName":"prefixListName"}}}}}}},"DescribePrincipalIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Resources":{"locationName":"Resource","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Principals":{"locationName":"principalSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"},"Statuses":{"shape":"Suy","locationName":"statusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribePublicIpv4Pools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sug","locationName":"Filter"}}},"output":{"type":"structure","members":{"PublicIpv4Pools":{"locationName":"publicIpv4PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolAddressRanges":{"locationName":"poolAddressRangeSet","type":"list","member":{"shape":"S1cg","locationName":"item"}},"TotalAddressCount":{"locationName":"totalAddressCount","type":"integer"},"TotalAvailableAddressCount":{"locationName":"totalAvailableAddressCount","type":"integer"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRegions":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"RegionNames":{"locationName":"RegionName","type":"list","member":{"locationName":"RegionName"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"AllRegions":{"type":"boolean"}}},"output":{"type":"structure","members":{"Regions":{"locationName":"regionInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Endpoint":{"locationName":"regionEndpoint"},"RegionName":{"locationName":"regionName"},"OptInStatus":{"locationName":"optInStatus"}}}}}}},"DescribeReplaceRootVolumeTasks":{"input":{"type":"structure","members":{"ReplaceRootVolumeTaskIds":{"locationName":"ReplaceRootVolumeTaskId","type":"list","member":{"locationName":"ReplaceRootVolumeTaskId"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReplaceRootVolumeTasks":{"locationName":"replaceRootVolumeTaskSet","type":"list","member":{"shape":"Sjb","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeReservedInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"OfferingClass":{},"ReservedInstancesIds":{"shape":"S1ct","locationName":"ReservedInstancesId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstances":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"End":{"locationName":"end","type":"timestamp"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"RecurringCharges":{"shape":"S1d1","locationName":"recurringCharges"},"Scope":{"locationName":"scope"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}}}}},"DescribeReservedInstancesListings":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S6r","locationName":"reservedInstancesListingsSet"}}}},"DescribeReservedInstancesModifications":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"ReservedInstancesModificationIds":{"locationName":"ReservedInstancesModificationId","type":"list","member":{"locationName":"ReservedInstancesModificationId"}},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReservedInstancesModifications":{"locationName":"reservedInstancesModificationsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"EffectiveDate":{"locationName":"effectiveDate","type":"timestamp"},"ModificationResults":{"locationName":"modificationResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"},"TargetConfiguration":{"shape":"S1df","locationName":"targetConfiguration"}}}},"ReservedInstancesIds":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}}}}},"DescribeReservedInstancesOfferings":{"input":{"type":"structure","members":{"AvailabilityZone":{},"Filters":{"shape":"Sug","locationName":"Filter"},"IncludeMarketplace":{"type":"boolean"},"InstanceType":{},"MaxDuration":{"type":"long"},"MaxInstanceCount":{"type":"integer"},"MinDuration":{"type":"long"},"OfferingClass":{},"ProductDescription":{},"ReservedInstancesOfferingIds":{"locationName":"ReservedInstancesOfferingId","type":"list","member":{}},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstancesOfferings":{"locationName":"reservedInstancesOfferingsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesOfferingId":{"locationName":"reservedInstancesOfferingId"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Marketplace":{"locationName":"marketplace","type":"boolean"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"PricingDetails":{"locationName":"pricingDetailsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Price":{"locationName":"price","type":"double"}}}},"RecurringCharges":{"shape":"S1d1","locationName":"recurringCharges"},"Scope":{"locationName":"scope"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRouteTables":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableIds":{"locationName":"RouteTableId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"RouteTables":{"locationName":"routeTableSet","type":"list","member":{"shape":"Sjs","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeScheduledInstanceAvailability":{"input":{"type":"structure","required":["FirstSlotStartTimeRange","Recurrence"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"FirstSlotStartTimeRange":{"type":"structure","required":["EarliestTime","LatestTime"],"members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"MaxResults":{"type":"integer"},"MaxSlotDurationInHours":{"type":"integer"},"MinSlotDurationInHours":{"type":"integer"},"NextToken":{},"Recurrence":{"type":"structure","members":{"Frequency":{},"Interval":{"type":"integer"},"OccurrenceDays":{"locationName":"OccurrenceDay","type":"list","member":{"locationName":"OccurenceDay","type":"integer"}},"OccurrenceRelativeToEnd":{"type":"boolean"},"OccurrenceUnit":{}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceAvailabilitySet":{"locationName":"scheduledInstanceAvailabilitySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"FirstSlotStartTime":{"locationName":"firstSlotStartTime","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceType":{"locationName":"instanceType"},"MaxTermDurationInDays":{"locationName":"maxTermDurationInDays","type":"integer"},"MinTermDurationInDays":{"locationName":"minTermDurationInDays","type":"integer"},"NetworkPlatform":{"locationName":"networkPlatform"},"Platform":{"locationName":"platform"},"PurchaseToken":{"locationName":"purchaseToken"},"Recurrence":{"shape":"S1e2","locationName":"recurrence"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}}}}}},"DescribeScheduledInstances":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"ScheduledInstanceIds":{"locationName":"ScheduledInstanceId","type":"list","member":{"locationName":"ScheduledInstanceId"}},"SlotStartTimeRange":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"S1ea","locationName":"item"}}}}},"DescribeSecurityGroupReferences":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"type":"boolean"},"GroupId":{"type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SecurityGroupReferenceSet":{"locationName":"securityGroupReferenceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"ReferencingVpcId":{"locationName":"referencingVpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}}}}},"DescribeSecurityGroupRules":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"SecurityGroupRuleIds":{"shape":"S1eh","locationName":"SecurityGroupRuleId"},"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroupRules":{"shape":"S5j","locationName":"securityGroupRuleSet"},"NextToken":{"locationName":"nextToken"}}}},"DescribeSecurityGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"GroupIds":{"shape":"S4o","locationName":"GroupId"},"GroupNames":{"shape":"S1el","locationName":"GroupName"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroups":{"locationName":"securityGroupInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"groupDescription"},"GroupName":{"locationName":"groupName"},"IpPermissions":{"shape":"S58","locationName":"ipPermissions"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"IpPermissionsEgress":{"shape":"S58","locationName":"ipPermissionsEgress"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CreateVolumePermissions":{"shape":"S1et","locationName":"createVolumePermission"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"SnapshotId":{"locationName":"snapshotId"}}}},"DescribeSnapshotTierStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SnapshotTierStatuses":{"locationName":"snapshotTierStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"VolumeId":{"locationName":"volumeId"},"Status":{"locationName":"status"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"},"StorageTier":{"locationName":"storageTier"},"LastTieringStartTime":{"locationName":"lastTieringStartTime","type":"timestamp"},"LastTieringProgress":{"locationName":"lastTieringProgress","type":"integer"},"LastTieringOperationStatus":{"locationName":"lastTieringOperationStatus"},"LastTieringOperationStatusDetail":{"locationName":"lastTieringOperationStatusDetail"},"ArchivalCompleteTime":{"locationName":"archivalCompleteTime","type":"timestamp"},"RestoreExpiryTime":{"locationName":"restoreExpiryTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"OwnerIds":{"shape":"S10j","locationName":"Owner"},"RestorableByUserIds":{"locationName":"RestorableBy","type":"list","member":{}},"SnapshotIds":{"shape":"S1f3","locationName":"SnapshotId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"shape":"Sk4","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Skf","locationName":"spotDatafeedSubscription"}}}},"DescribeSpotFleetInstances":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"Szh","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"DescribeSpotFleetRequestHistory":{"input":{"type":"structure","required":["SpotFleetRequestId","StartTime"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"EventType":{"locationName":"eventType"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"Sze","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeSpotFleetRequests":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestIds":{"shape":"S73","locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotFleetRequestConfigs":{"locationName":"spotFleetRequestConfigSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"SpotFleetRequestConfig":{"shape":"S1fm","locationName":"spotFleetRequestConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"SpotFleetRequestState":{"locationName":"spotFleetRequestState"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}}}}},"DescribeSpotInstanceRequests":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S7e","locationName":"SpotInstanceRequestId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"S1ge","locationName":"spotInstanceRequestSet"},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotPriceHistory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"AvailabilityZone":{"locationName":"availabilityZone"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"ProductDescriptions":{"locationName":"ProductDescription","type":"list","member":{}},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotPriceHistory":{"locationName":"spotPriceHistorySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"SpotPrice":{"locationName":"spotPrice"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}}}}},"DescribeStaleSecurityGroups":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"StaleSecurityGroupSet":{"locationName":"staleSecurityGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"StaleIpPermissions":{"shape":"S1gw","locationName":"staleIpPermissions"},"StaleIpPermissionsEgress":{"shape":"S1gw","locationName":"staleIpPermissionsEgress"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeStoreImageTasks":{"input":{"type":"structure","members":{"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"StoreImageTaskResults":{"locationName":"storeImageTaskResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiId":{"locationName":"amiId"},"TaskStartTime":{"locationName":"taskStartTime","type":"timestamp"},"Bucket":{"locationName":"bucket"},"S3objectKey":{"locationName":"s3objectKey"},"ProgressPercentage":{"locationName":"progressPercentage","type":"integer"},"StoreTaskState":{"locationName":"storeTaskState"},"StoreTaskFailureReason":{"locationName":"storeTaskFailureReason"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSubnets":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"SubnetId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Subnets":{"locationName":"subnetSet","type":"list","member":{"shape":"S99","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTags":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Tags":{"locationName":"tagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Value":{"locationName":"value"}}}}}}},"DescribeTrafficMirrorFilters":{"input":{"type":"structure","members":{"TrafficMirrorFilterIds":{"locationName":"TrafficMirrorFilterId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorFilters":{"locationName":"trafficMirrorFilterSet","type":"list","member":{"shape":"Sky","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorSessions":{"input":{"type":"structure","members":{"TrafficMirrorSessionIds":{"locationName":"TrafficMirrorSessionId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorSessions":{"locationName":"trafficMirrorSessionSet","type":"list","member":{"shape":"Sld","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorTargets":{"input":{"type":"structure","members":{"TrafficMirrorTargetIds":{"locationName":"TrafficMirrorTargetId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorTargets":{"locationName":"trafficMirrorTargetSet","type":"list","member":{"shape":"Slg","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1hu"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayOwnerId":{"locationName":"transitGatewayOwnerId"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"},"State":{"locationName":"state"},"Association":{"locationName":"association","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayConnectPeers":{"input":{"type":"structure","members":{"TransitGatewayConnectPeerIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeers":{"locationName":"transitGatewayConnectPeerSet","type":"list","member":{"shape":"Sm4","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayConnects":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1hu"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnects":{"locationName":"transitGatewayConnectSet","type":"list","member":{"shape":"Sly","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayMulticastDomains":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomains":{"locationName":"transitGatewayMulticastDomains","type":"list","member":{"shape":"Smh","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayPeeringAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1hu"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachments":{"locationName":"transitGatewayPeeringAttachments","type":"list","member":{"shape":"Sn","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayRouteTables":{"input":{"type":"structure","members":{"TransitGatewayRouteTableIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTables":{"locationName":"transitGatewayRouteTables","type":"list","member":{"shape":"Sn1","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayVpcAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1hu"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachments":{"locationName":"transitGatewayVpcAttachments","type":"list","member":{"shape":"Sw","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGateways":{"input":{"type":"structure","members":{"TransitGatewayIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateways":{"locationName":"transitGatewaySet","type":"list","member":{"shape":"Slr","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrunkInterfaceAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InterfaceAssociations":{"locationName":"interfaceAssociationSet","type":"list","member":{"shape":"S4c","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumeAttribute":{"input":{"type":"structure","required":["Attribute","VolumeId"],"members":{"Attribute":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AutoEnableIO":{"shape":"S131","locationName":"autoEnableIO"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"VolumeId":{"locationName":"volumeId"}}}},"DescribeVolumeStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VolumeIds":{"shape":"S1iy","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VolumeStatuses":{"locationName":"volumeStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Actions":{"locationName":"actionsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"}}}},"AvailabilityZone":{"locationName":"availabilityZone"},"OutpostArn":{"locationName":"outpostArn"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"InstanceId":{"locationName":"instanceId"}}}},"VolumeId":{"locationName":"volumeId"},"VolumeStatus":{"locationName":"volumeStatus","type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"AttachmentStatuses":{"locationName":"attachmentStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"IoPerformance":{"locationName":"ioPerformance"},"InstanceId":{"locationName":"instanceId"}}}}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"VolumeIds":{"shape":"S1iy","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Volumes":{"locationName":"volumeSet","type":"list","member":{"shape":"Sn7","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumesModifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VolumeIds":{"shape":"S1iy","locationName":"VolumeId"},"Filters":{"shape":"Sug","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumesModifications":{"locationName":"volumeModificationSet","type":"list","member":{"shape":"S1jj","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcAttribute":{"input":{"type":"structure","required":["Attribute","VpcId"],"members":{"Attribute":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcId":{"locationName":"vpcId"},"EnableDnsHostnames":{"shape":"S131","locationName":"enableDnsHostnames"},"EnableDnsSupport":{"shape":"S131","locationName":"enableDnsSupport"}}}},"DescribeVpcClassicLink":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcIds":{"shape":"S1jp","locationName":"VpcId"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkEnabled":{"locationName":"classicLinkEnabled","type":"boolean"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"VpcIds":{"shape":"S1jp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Vpcs":{"locationName":"vpcs","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkDnsSupported":{"locationName":"classicLinkDnsSupported","type":"boolean"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcEndpointConnectionNotifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConnectionNotificationSet":{"locationName":"connectionNotificationSet","type":"list","member":{"shape":"Snr","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointConnections":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpointConnections":{"locationName":"vpcEndpointConnectionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointOwner":{"locationName":"vpcEndpointOwner"},"VpcEndpointState":{"locationName":"vpcEndpointState"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"DnsEntries":{"shape":"Snm","locationName":"dnsEntrySet"},"NetworkLoadBalancerArns":{"shape":"Se","locationName":"networkLoadBalancerArnSet"},"GatewayLoadBalancerArns":{"shape":"Se","locationName":"gatewayLoadBalancerArnSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServiceConfigurations":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sta","locationName":"ServiceId"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceConfigurations":{"locationName":"serviceConfigurationSet","type":"list","member":{"shape":"Snw","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AllowedPrincipals":{"locationName":"allowedPrincipals","type":"list","member":{"locationName":"item","type":"structure","members":{"PrincipalType":{"locationName":"principalType"},"Principal":{"locationName":"principal"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServices":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceNames":{"shape":"Se","locationName":"ServiceName"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceNames":{"shape":"Se","locationName":"serviceNameSet"},"ServiceDetails":{"locationName":"serviceDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceName":{"locationName":"serviceName"},"ServiceId":{"locationName":"serviceId"},"ServiceType":{"shape":"Snx","locationName":"serviceType"},"AvailabilityZones":{"shape":"Se","locationName":"availabilityZoneSet"},"Owner":{"locationName":"owner"},"BaseEndpointDnsNames":{"shape":"Se","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateDnsNames":{"locationName":"privateDnsNameSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrivateDnsName":{"locationName":"privateDnsName"}}}},"VpcEndpointPolicySupported":{"locationName":"vpcEndpointPolicySupported","type":"boolean"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"PayerResponsibility":{"locationName":"payerResponsibility"},"Tags":{"shape":"Ss","locationName":"tagSet"},"PrivateDnsNameVerificationState":{"locationName":"privateDnsNameVerificationState"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"S13","locationName":"VpcEndpointId"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpoints":{"locationName":"vpcEndpointSet","type":"list","member":{"shape":"Sni","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionIds":{"locationName":"VpcPeeringConnectionId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"locationName":"vpcPeeringConnectionSet","type":"list","member":{"shape":"S1c","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"VpcIds":{"locationName":"VpcId","type":"list","member":{"locationName":"VpcId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"shape":"S9h","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpnConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"VpnConnectionIds":{"locationName":"VpnConnectionId","type":"list","member":{"locationName":"VpnConnectionId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnections":{"locationName":"vpnConnectionSet","type":"list","member":{"shape":"Sor","locationName":"item"}}}}},"DescribeVpnGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sug","locationName":"Filter"},"VpnGatewayIds":{"locationName":"VpnGatewayId","type":"list","member":{"locationName":"VpnGatewayId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateways":{"locationName":"vpnGatewaySet","type":"list","member":{"shape":"Spl","locationName":"item"}}}}},"DetachClassicLinkVpc":{"input":{"type":"structure","required":["InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DetachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"DetachNetworkInterface":{"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"locationName":"attachmentId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"Device":{},"Force":{"type":"boolean"},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S4w"}},"DetachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"DisableFastLaunch":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"},"ResourceType":{"locationName":"resourceType"},"SnapshotConfiguration":{"shape":"Sz0","locationName":"snapshotConfiguration"},"LaunchTemplate":{"shape":"Sz1","locationName":"launchTemplate"},"MaxParallelLaunches":{"locationName":"maxParallelLaunches","type":"integer"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"StateTransitionTime":{"locationName":"stateTransitionTime","type":"timestamp"}}}},"DisableFastSnapshotRestores":{"input":{"type":"structure","required":["AvailabilityZones","SourceSnapshotIds"],"members":{"AvailabilityZones":{"shape":"S1lh","locationName":"AvailabilityZone"},"SourceSnapshotIds":{"shape":"S1f3","locationName":"SourceSnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Successful":{"locationName":"successful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"Unsuccessful":{"locationName":"unsuccessful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"FastSnapshotRestoreStateErrors":{"locationName":"fastSnapshotRestoreStateErrorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}}}}},"DisableImageDeprecation":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableIpamOrganizationAdminAccount":{"input":{"type":"structure","required":["DelegatedAdminAccountId"],"members":{"DryRun":{"type":"boolean"},"DelegatedAdminAccountId":{}}},"output":{"type":"structure","members":{"Success":{"locationName":"success","type":"boolean"}}}},"DisableSerialConsoleAccess":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SerialConsoleAccessEnabled":{"locationName":"serialConsoleAccessEnabled","type":"boolean"}}}},"DisableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Propagation":{"shape":"S1ly","locationName":"propagation"}}}},"DisableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{},"DryRun":{"type":"boolean"}}}},"DisableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateAddress":{"input":{"type":"structure","members":{"AssociationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","AssociationId"],"members":{"ClientVpnEndpointId":{},"AssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S2y","locationName":"status"}}}},"DisassociateEnclaveCertificateIamRole":{"input":{"type":"structure","members":{"CertificateArn":{},"RoleArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateIamInstanceProfile":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S38","locationName":"iamInstanceProfileAssociation"}}}},"DisassociateInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId","AssociationTarget"],"members":{"DryRun":{"type":"boolean"},"InstanceEventWindowId":{},"AssociationTarget":{"type":"structure","members":{"InstanceIds":{"shape":"S3e","locationName":"InstanceId"},"InstanceTags":{"shape":"Ss","locationName":"InstanceTag"},"DedicatedHostIds":{"shape":"S3f","locationName":"DedicatedHostId"}}}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S3i","locationName":"instanceEventWindow"}}}},"DisassociateRouteTable":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateSubnetCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S3y","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"DisassociateTransitGatewayMulticastDomain":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"S43"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sg","locationName":"associations"}}}},"DisassociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S48","locationName":"association"}}}},"DisassociateTrunkInterface":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"ClientToken":{"locationName":"clientToken"}}}},"DisassociateVpcCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S4j","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S4m","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"EnableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"EnableFastLaunch":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"ResourceType":{},"SnapshotConfiguration":{"type":"structure","members":{"TargetResourceCount":{"type":"integer"}}},"LaunchTemplate":{"type":"structure","required":["Version"],"members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"MaxParallelLaunches":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"},"ResourceType":{"locationName":"resourceType"},"SnapshotConfiguration":{"shape":"Sz0","locationName":"snapshotConfiguration"},"LaunchTemplate":{"shape":"Sz1","locationName":"launchTemplate"},"MaxParallelLaunches":{"locationName":"maxParallelLaunches","type":"integer"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"StateTransitionTime":{"locationName":"stateTransitionTime","type":"timestamp"}}}},"EnableFastSnapshotRestores":{"input":{"type":"structure","required":["AvailabilityZones","SourceSnapshotIds"],"members":{"AvailabilityZones":{"shape":"S1lh","locationName":"AvailabilityZone"},"SourceSnapshotIds":{"shape":"S1f3","locationName":"SourceSnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Successful":{"locationName":"successful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"Unsuccessful":{"locationName":"unsuccessful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"FastSnapshotRestoreStateErrors":{"locationName":"fastSnapshotRestoreStateErrorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}}}}},"EnableImageDeprecation":{"input":{"type":"structure","required":["ImageId","DeprecateAt"],"members":{"ImageId":{},"DeprecateAt":{"type":"timestamp"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableIpamOrganizationAdminAccount":{"input":{"type":"structure","required":["DelegatedAdminAccountId"],"members":{"DryRun":{"type":"boolean"},"DelegatedAdminAccountId":{}}},"output":{"type":"structure","members":{"Success":{"locationName":"success","type":"boolean"}}}},"EnableSerialConsoleAccess":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SerialConsoleAccessEnabled":{"locationName":"serialConsoleAccessEnabled","type":"boolean"}}}},"EnableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Propagation":{"shape":"S1ly","locationName":"propagation"}}}},"EnableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{},"DryRun":{"type":"boolean"}}}},"EnableVolumeIO":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}}},"EnableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ExportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CertificateRevocationList":{"locationName":"certificateRevocationList"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"ExportClientVpnClientConfiguration":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientConfiguration":{"locationName":"clientConfiguration"}}}},"ExportImage":{"input":{"type":"structure","required":["DiskImageFormat","ImageId","S3ExportLocation"],"members":{"ClientToken":{"idempotencyToken":true},"Description":{},"DiskImageFormat":{},"DryRun":{"type":"boolean"},"ImageId":{},"S3ExportLocation":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Prefix":{}}},"RoleName":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageFormat":{"locationName":"diskImageFormat"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"RoleName":{"locationName":"roleName"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"Syn","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"ExportTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","S3Bucket"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"S3Bucket":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"S3Location":{"locationName":"s3Location"}}}},"GetAssociatedEnclaveCertificateIamRoles":{"input":{"type":"structure","members":{"CertificateArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociatedRoles":{"locationName":"associatedRoleSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatedRoleArn":{"locationName":"associatedRoleArn"},"CertificateS3BucketName":{"locationName":"certificateS3BucketName"},"CertificateS3ObjectKey":{"locationName":"certificateS3ObjectKey"},"EncryptionKmsKeyId":{"locationName":"encryptionKmsKeyId"}}}}}}},"GetAssociatedIpv6PoolCidrs":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Ipv6CidrAssociations":{"locationName":"ipv6CidrAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Cidr":{"locationName":"ipv6Cidr"},"AssociatedResource":{"locationName":"associatedResource"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetCapacityReservationUsage":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservationId":{"locationName":"capacityReservationId"},"InstanceType":{"locationName":"instanceType"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"State":{"locationName":"state"},"InstanceUsages":{"locationName":"instanceUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AccountId":{"locationName":"accountId"},"UsedInstanceCount":{"locationName":"usedInstanceCount","type":"integer"}}}}}}},"GetCoipPoolUsage":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPoolId":{"locationName":"coipPoolId"},"CoipAddressUsages":{"locationName":"coipAddressUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"CoIp":{"locationName":"coIp"}}}},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"}}}},"GetConsoleOutput":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Latest":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Output":{"locationName":"output"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetConsoleScreenshot":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"WakeUp":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageData":{"locationName":"imageData"},"InstanceId":{"locationName":"instanceId"}}}},"GetDefaultCreditSpecification":{"input":{"type":"structure","required":["InstanceFamily"],"members":{"DryRun":{"type":"boolean"},"InstanceFamily":{}}},"output":{"type":"structure","members":{"InstanceFamilyCreditSpecification":{"shape":"S1om","locationName":"instanceFamilyCreditSpecification"}}}},"GetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"GetEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"GetFlowLogsIntegrationTemplate":{"input":{"type":"structure","required":["FlowLogId","ConfigDeliveryS3DestinationArn","IntegrateServices"],"members":{"DryRun":{"type":"boolean"},"FlowLogId":{},"ConfigDeliveryS3DestinationArn":{},"IntegrateServices":{"locationName":"IntegrateService","type":"structure","members":{"AthenaIntegrations":{"locationName":"AthenaIntegration","type":"list","member":{"locationName":"item","type":"structure","required":["IntegrationResultS3DestinationArn","PartitionLoadFrequency"],"members":{"IntegrationResultS3DestinationArn":{},"PartitionLoadFrequency":{},"PartitionStartDate":{"type":"timestamp"},"PartitionEndDate":{"type":"timestamp"}}}}}}}},"output":{"type":"structure","members":{"Result":{"locationName":"result"}}}},"GetGroupsForCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservationGroups":{"locationName":"capacityReservationGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupArn":{"locationName":"groupArn"},"OwnerId":{"locationName":"ownerId"}}}}}}},"GetHostReservationPurchasePreview":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"HostIdSet":{"shape":"S1p3"},"OfferingId":{}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S1p5","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"GetInstanceTypesFromInstanceRequirements":{"input":{"type":"structure","required":["ArchitectureTypes","VirtualizationTypes","InstanceRequirements"],"members":{"DryRun":{"type":"boolean"},"ArchitectureTypes":{"shape":"S1p8","locationName":"ArchitectureType"},"VirtualizationTypes":{"shape":"S1p9","locationName":"VirtualizationType"},"InstanceRequirements":{"shape":"Sam"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypes":{"locationName":"instanceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamAddressHistory":{"input":{"type":"structure","required":["Cidr","IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"Cidr":{},"IpamScopeId":{},"VpcId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"},"ResourceCidr":{"locationName":"resourceCidr"},"ResourceName":{"locationName":"resourceName"},"ResourceComplianceStatus":{"locationName":"resourceComplianceStatus"},"ResourceOverlapStatus":{"locationName":"resourceOverlapStatus"},"VpcId":{"locationName":"vpcId"},"SampledStartTime":{"locationName":"sampledStartTime","type":"timestamp"},"SampledEndTime":{"locationName":"sampledEndTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamPoolAllocations":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"IpamPoolAllocationId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IpamPoolAllocations":{"locationName":"ipamPoolAllocationSet","type":"list","member":{"shape":"S26","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamPoolCidrs":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IpamPoolCidrs":{"locationName":"ipamPoolCidrSet","type":"list","member":{"shape":"Stn","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamResourceCidrs":{"input":{"type":"structure","required":["IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamScopeId":{},"IpamPoolId":{},"ResourceId":{},"ResourceType":{},"ResourceTag":{"shape":"Sdg"},"ResourceOwner":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"IpamResourceCidrs":{"locationName":"ipamResourceCidrSet","type":"list","member":{"shape":"S1pw","locationName":"item"}}}}},"GetLaunchTemplateData":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{}}},"output":{"type":"structure","members":{"LaunchTemplateData":{"shape":"Sfo","locationName":"launchTemplateData"}}}},"GetManagedPrefixListAssociations":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PrefixListAssociations":{"locationName":"prefixListAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"ResourceOwner":{"locationName":"resourceOwner"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetManagedPrefixListEntries":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"TargetVersion":{"type":"long"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidr":{"locationName":"cidr"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetNetworkInsightsAccessScopeAnalysisFindings":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeAnalysisId"],"members":{"NetworkInsightsAccessScopeAnalysisId":{},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"},"AnalysisStatus":{"locationName":"analysisStatus"},"AnalysisFindings":{"locationName":"analysisFindingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"},"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"FindingId":{"locationName":"findingId"},"FindingComponents":{"shape":"S1ar","locationName":"findingComponentSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetNetworkInsightsAccessScopeContent":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeId"],"members":{"NetworkInsightsAccessScopeId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeContent":{"shape":"Si1","locationName":"networkInsightsAccessScopeContent"}}}},"GetPasswordData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PasswordData":{"locationName":"passwordData"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"IsValidExchange":{"locationName":"isValidExchange","type":"boolean"},"OutputReservedInstancesWillExpireAt":{"locationName":"outputReservedInstancesWillExpireAt","type":"timestamp"},"PaymentDue":{"locationName":"paymentDue"},"ReservedInstanceValueRollup":{"shape":"S1qk","locationName":"reservedInstanceValueRollup"},"ReservedInstanceValueSet":{"locationName":"reservedInstanceValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S1qk","locationName":"reservationValue"},"ReservedInstanceId":{"locationName":"reservedInstanceId"}}}},"TargetConfigurationValueRollup":{"shape":"S1qk","locationName":"targetConfigurationValueRollup"},"TargetConfigurationValueSet":{"locationName":"targetConfigurationValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S1qk","locationName":"reservationValue"},"TargetConfiguration":{"locationName":"targetConfiguration","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"OfferingId":{"locationName":"offeringId"}}}}}},"ValidationFailureReason":{"locationName":"validationFailureReason"}}}},"GetSerialConsoleAccessStatus":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SerialConsoleAccessEnabled":{"locationName":"serialConsoleAccessEnabled","type":"boolean"}}}},"GetSpotPlacementScores":{"input":{"type":"structure","required":["TargetCapacity"],"members":{"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"TargetCapacity":{"type":"integer"},"TargetCapacityUnitType":{},"SingleAvailabilityZone":{"type":"boolean"},"RegionNames":{"locationName":"RegionName","type":"list","member":{}},"InstanceRequirementsWithMetadata":{"type":"structure","members":{"ArchitectureTypes":{"shape":"S1p8","locationName":"ArchitectureType"},"VirtualizationTypes":{"shape":"S1p9","locationName":"VirtualizationType"},"InstanceRequirements":{"shape":"Sam"}}},"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SpotPlacementScores":{"locationName":"spotPlacementScoreSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Region":{"locationName":"region"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"Score":{"locationName":"score","type":"integer"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetSubnetCidrReservations":{"input":{"type":"structure","required":["SubnetId"],"members":{"Filters":{"shape":"Sug","locationName":"Filter"},"SubnetId":{},"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SubnetIpv4CidrReservations":{"shape":"S1r4","locationName":"subnetIpv4CidrReservationSet"},"SubnetIpv6CidrReservations":{"shape":"S1r4","locationName":"subnetIpv6CidrReservationSet"},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayAttachmentPropagations":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachmentPropagations":{"locationName":"transitGatewayAttachmentPropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MulticastDomainAssociations":{"locationName":"multicastDomainAssociations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"Subnet":{"shape":"Sj","locationName":"subnet"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayPrefixListReferences":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReferences":{"locationName":"transitGatewayPrefixListReferenceSet","type":"list","member":{"shape":"Smp","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTableAssociations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"locationName":"associations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTablePropagations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTablePropagations":{"locationName":"transitGatewayRouteTablePropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetVpnConnectionDeviceSampleConfiguration":{"input":{"type":"structure","required":["VpnConnectionId","VpnConnectionDeviceTypeId"],"members":{"VpnConnectionId":{},"VpnConnectionDeviceTypeId":{},"InternetKeyExchangeVersion":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnectionDeviceSampleConfiguration":{"locationName":"vpnConnectionDeviceSampleConfiguration","type":"string","sensitive":true}}}},"GetVpnConnectionDeviceTypes":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnectionDeviceTypes":{"locationName":"vpnConnectionDeviceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"VpnConnectionDeviceTypeId":{"locationName":"vpnConnectionDeviceTypeId"},"Vendor":{"locationName":"vendor"},"Platform":{"locationName":"platform"},"Software":{"locationName":"software"}}}},"NextToken":{"locationName":"nextToken"}}}},"ImportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId","CertificateRevocationList"],"members":{"ClientVpnEndpointId":{},"CertificateRevocationList":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ImportImage":{"input":{"type":"structure","members":{"Architecture":{},"ClientData":{"shape":"S1s0"},"ClientToken":{},"Description":{},"DiskContainers":{"locationName":"DiskContainer","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{},"DeviceName":{},"Format":{},"SnapshotId":{},"Url":{},"UserBucket":{"shape":"S1s3"}}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Hypervisor":{},"KmsKeyId":{},"LicenseType":{},"Platform":{},"RoleName":{},"LicenseSpecifications":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"UsageOperation":{},"BootMode":{}}},"output":{"type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"S12j","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"LicenseSpecifications":{"shape":"S12m","locationName":"licenseSpecifications"},"Tags":{"shape":"Ss","locationName":"tagSet"},"UsageOperation":{"locationName":"usageOperation"}}}},"ImportInstance":{"input":{"type":"structure","required":["Platform"],"members":{"Description":{"locationName":"description"},"DiskImages":{"locationName":"diskImage","type":"list","member":{"type":"structure","members":{"Description":{},"Image":{"shape":"S1sa"},"Volume":{"shape":"S1sb"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"AdditionalInfo":{"locationName":"additionalInfo"},"Architecture":{"locationName":"architecture"},"GroupIds":{"shape":"Se7","locationName":"GroupId"},"GroupNames":{"shape":"Set","locationName":"GroupName"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"locationName":"instanceType"},"Monitoring":{"locationName":"monitoring","type":"boolean"},"Placement":{"shape":"Sak","locationName":"placement"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData","type":"structure","members":{"Data":{"locationName":"data"}},"sensitive":true}}},"Platform":{"locationName":"platform"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Sxk","locationName":"conversionTask"}}}},"ImportKeyPair":{"input":{"type":"structure","required":["KeyName","PublicKeyMaterial"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyName":{"locationName":"keyName"},"PublicKeyMaterial":{"locationName":"publicKeyMaterial","type":"blob"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"},"KeyPairId":{"locationName":"keyPairId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"ImportSnapshot":{"input":{"type":"structure","members":{"ClientData":{"shape":"S1s0"},"ClientToken":{},"Description":{},"DiskContainer":{"type":"structure","members":{"Description":{},"Format":{},"Url":{},"UserBucket":{"shape":"S1s3"}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"RoleName":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"S12u","locationName":"snapshotTaskDetail"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"ImportVolume":{"input":{"type":"structure","required":["AvailabilityZone","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Image":{"shape":"S1sa","locationName":"image"},"Volume":{"shape":"S1sb","locationName":"volume"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Sxk","locationName":"conversionTask"}}}},"ListImagesInRecycleBin":{"input":{"type":"structure","members":{"ImageIds":{"shape":"S121","locationName":"ImageId"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ImageId":{"locationName":"imageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"RecycleBinEnterTime":{"locationName":"recycleBinEnterTime","type":"timestamp"},"RecycleBinExitTime":{"locationName":"recycleBinExitTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListSnapshotsInRecycleBin":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"SnapshotIds":{"shape":"S1f3","locationName":"SnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"RecycleBinEnterTime":{"locationName":"recycleBinEnterTime","type":"timestamp"},"RecycleBinExitTime":{"locationName":"recycleBinExitTime","type":"timestamp"},"Description":{"locationName":"description"},"VolumeId":{"locationName":"volumeId"}}}},"NextToken":{"locationName":"nextToken"}}}},"ModifyAddressAttribute":{"input":{"type":"structure","required":["AllocationId"],"members":{"AllocationId":{},"DomainName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Address":{"shape":"Suu","locationName":"address"}}}},"ModifyAvailabilityZoneGroup":{"input":{"type":"structure","required":["GroupName","OptInStatus"],"members":{"GroupName":{},"OptInStatus":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"InstanceCount":{"type":"integer"},"EndDate":{"type":"timestamp"},"EndDateType":{},"Accept":{"type":"boolean"},"DryRun":{"type":"boolean"},"AdditionalInfo":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyCapacityReservationFleet":{"input":{"type":"structure","required":["CapacityReservationFleetId"],"members":{"CapacityReservationFleetId":{},"TotalTargetCapacity":{"type":"integer"},"EndDate":{"type":"timestamp"},"DryRun":{"type":"boolean"},"RemoveEndDate":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ServerCertificateArn":{},"ConnectionLogOptions":{"shape":"S8r"},"DnsServers":{"type":"structure","members":{"CustomDnsServers":{"shape":"Se"},"Enabled":{"type":"boolean"}}},"VpnPort":{"type":"integer"},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"SecurityGroupIds":{"shape":"S2c","locationName":"SecurityGroupId"},"VpcId":{},"SelfServicePortal":{},"ClientConnectOptions":{"shape":"S8u"},"SessionTimeoutHours":{"type":"integer"},"ClientLoginBannerOptions":{"shape":"S8v"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyDefaultCreditSpecification":{"input":{"type":"structure","required":["InstanceFamily","CpuCredits"],"members":{"DryRun":{"type":"boolean"},"InstanceFamily":{},"CpuCredits":{}}},"output":{"type":"structure","members":{"InstanceFamilyCreditSpecification":{"shape":"S1om","locationName":"instanceFamilyCreditSpecification"}}}},"ModifyEbsDefaultKmsKeyId":{"input":{"type":"structure","required":["KmsKeyId"],"members":{"KmsKeyId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ModifyFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"DryRun":{"type":"boolean"},"ExcessCapacityTerminationPolicy":{},"LaunchTemplateConfigs":{"shape":"Sad","locationName":"LaunchTemplateConfig"},"FleetId":{},"TargetCapacitySpecification":{"shape":"Sbc"},"Context":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{},"OperationType":{},"UserIds":{"shape":"S1tg","locationName":"UserId"},"UserGroups":{"shape":"S1th","locationName":"UserGroup"},"ProductCodes":{"shape":"S1ti","locationName":"ProductCode"},"LoadPermission":{"type":"structure","members":{"Add":{"shape":"S1tk"},"Remove":{"shape":"S1tk"}}},"Description":{},"Name":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"S10a","locationName":"fpgaImageAttribute"}}}},"ModifyHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"HostIds":{"shape":"S117","locationName":"hostId"},"HostRecovery":{},"InstanceType":{},"InstanceFamily":{}}},"output":{"type":"structure","members":{"Successful":{"shape":"S21","locationName":"successful"},"Unsuccessful":{"shape":"S1tp","locationName":"unsuccessful"}}}},"ModifyIdFormat":{"input":{"type":"structure","required":["Resource","UseLongIds"],"members":{"Resource":{},"UseLongIds":{"type":"boolean"}}}},"ModifyIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn","Resource","UseLongIds"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"ModifyImageAttribute":{"input":{"type":"structure","required":["ImageId"],"members":{"Attribute":{},"Description":{"shape":"S9u"},"ImageId":{},"LaunchPermission":{"type":"structure","members":{"Add":{"shape":"S11x"},"Remove":{"shape":"S11x"}}},"OperationType":{},"ProductCodes":{"shape":"S1ti","locationName":"ProductCode"},"UserGroups":{"shape":"S1th","locationName":"UserGroup"},"UserIds":{"shape":"S1tg","locationName":"UserId"},"Value":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"OrganizationArns":{"locationName":"OrganizationArn","type":"list","member":{"locationName":"OrganizationArn"}},"OrganizationalUnitArns":{"locationName":"OrganizationalUnitArn","type":"list","member":{"locationName":"OrganizationalUnitArn"}}}}},"ModifyInstanceAttribute":{"input":{"type":"structure","required":["InstanceId"],"members":{"SourceDestCheck":{"shape":"S131"},"Attribute":{"locationName":"attribute"},"BlockDeviceMappings":{"locationName":"blockDeviceMapping","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}},"NoDevice":{"locationName":"noDevice"},"VirtualName":{"locationName":"virtualName"}}}},"DisableApiTermination":{"shape":"S131","locationName":"disableApiTermination"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"shape":"S131","locationName":"ebsOptimized"},"EnaSupport":{"shape":"S131","locationName":"enaSupport"},"Groups":{"shape":"S4o","locationName":"GroupId"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S9u","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S9u","locationName":"instanceType"},"Kernel":{"shape":"S9u","locationName":"kernel"},"Ramdisk":{"shape":"S9u","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S9u","locationName":"sriovNetSupport"},"UserData":{"locationName":"userData","type":"structure","members":{"Value":{"locationName":"value","type":"blob"}}},"Value":{"locationName":"value"}}}},"ModifyInstanceCapacityReservationAttributes":{"input":{"type":"structure","required":["InstanceId","CapacityReservationSpecification"],"members":{"InstanceId":{},"CapacityReservationSpecification":{"shape":"S1u2"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyInstanceCreditSpecification":{"input":{"type":"structure","required":["InstanceCreditSpecifications"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"InstanceCreditSpecifications":{"locationName":"InstanceCreditSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{},"CpuCredits":{}}}}}},"output":{"type":"structure","members":{"SuccessfulInstanceCreditSpecifications":{"locationName":"successfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"}}}},"UnsuccessfulInstanceCreditSpecifications":{"locationName":"unsuccessfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"ModifyInstanceEventStartTime":{"input":{"type":"structure","required":["InstanceId","InstanceEventId","NotBefore"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"InstanceEventId":{},"NotBefore":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Event":{"shape":"S13k","locationName":"event"}}}},"ModifyInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId"],"members":{"DryRun":{"type":"boolean"},"Name":{},"InstanceEventWindowId":{},"TimeRanges":{"shape":"Scm","locationName":"TimeRange"},"CronExpression":{}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S3i","locationName":"instanceEventWindow"}}}},"ModifyInstanceMaintenanceOptions":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoRecovery":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"AutoRecovery":{"locationName":"autoRecovery"}}}},"ModifyInstanceMetadataOptions":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"DryRun":{"type":"boolean"},"HttpProtocolIpv6":{},"InstanceMetadataTags":{}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceMetadataOptions":{"shape":"S17i","locationName":"instanceMetadataOptions"}}}},"ModifyInstancePlacement":{"input":{"type":"structure","required":["InstanceId"],"members":{"Affinity":{"locationName":"affinity"},"GroupName":{},"HostId":{"locationName":"hostId"},"InstanceId":{"locationName":"instanceId"},"Tenancy":{"locationName":"tenancy"},"PartitionNumber":{"type":"integer"},"HostResourceGroupArn":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyIpam":{"input":{"type":"structure","required":["IpamId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Description":{},"AddOperatingRegions":{"shape":"Sd3","locationName":"AddOperatingRegion"},"RemoveOperatingRegions":{"locationName":"RemoveOperatingRegion","type":"list","member":{"type":"structure","members":{"RegionName":{}}}}}},"output":{"type":"structure","members":{"Ipam":{"shape":"Sd6","locationName":"ipam"}}}},"ModifyIpamPool":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Description":{},"AutoImport":{"type":"boolean"},"AllocationMinNetmaskLength":{"type":"integer"},"AllocationMaxNetmaskLength":{"type":"integer"},"AllocationDefaultNetmaskLength":{"type":"integer"},"ClearAllocationDefaultNetmaskLength":{"type":"boolean"},"AddAllocationResourceTags":{"shape":"Sdf","locationName":"AddAllocationResourceTag"},"RemoveAllocationResourceTags":{"shape":"Sdf","locationName":"RemoveAllocationResourceTag"}}},"output":{"type":"structure","members":{"IpamPool":{"shape":"Sdj","locationName":"ipamPool"}}}},"ModifyIpamResourceCidr":{"input":{"type":"structure","required":["ResourceId","ResourceCidr","ResourceRegion","CurrentIpamScopeId","Monitored"],"members":{"DryRun":{"type":"boolean"},"ResourceId":{},"ResourceCidr":{},"ResourceRegion":{},"CurrentIpamScopeId":{},"DestinationIpamScopeId":{},"Monitored":{"type":"boolean"}}},"output":{"type":"structure","members":{"IpamResourceCidr":{"shape":"S1pw","locationName":"ipamResourceCidr"}}}},"ModifyIpamScope":{"input":{"type":"structure","required":["IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"IpamScopeId":{},"Description":{}}},"output":{"type":"structure","members":{"IpamScope":{"shape":"Sdq","locationName":"ipamScope"}}}},"ModifyLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"DefaultVersion":{"locationName":"SetDefaultVersion"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sfh","locationName":"launchTemplate"}}}},"ModifyManagedPrefixList":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"CurrentVersion":{"type":"long"},"PrefixListName":{},"AddEntries":{"shape":"Sgz","locationName":"AddEntry"},"RemoveEntries":{"locationName":"RemoveEntry","type":"list","member":{"type":"structure","required":["Cidr"],"members":{"Cidr":{}}}},"MaxEntries":{"type":"integer"}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sh2","locationName":"prefixList"}}}},"ModifyNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"Description":{"shape":"S9u","locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"Se7","locationName":"SecurityGroupId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"S131","locationName":"sourceDestCheck"}}}},"ModifyPrivateDnsNameOptions":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceId":{},"PrivateDnsHostnameType":{},"EnableResourceNameDnsARecord":{"type":"boolean"},"EnableResourceNameDnsAAAARecord":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds","TargetConfigurations"],"members":{"ReservedInstancesIds":{"shape":"S1ct","locationName":"ReservedInstancesId"},"ClientToken":{"locationName":"clientToken"},"TargetConfigurations":{"locationName":"ReservedInstancesConfigurationSetItemType","type":"list","member":{"shape":"S1df","locationName":"item"}}}},"output":{"type":"structure","members":{"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"}}}},"ModifySecurityGroupRules":{"input":{"type":"structure","required":["GroupId","SecurityGroupRules"],"members":{"GroupId":{},"SecurityGroupRules":{"locationName":"SecurityGroupRule","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroupRuleId":{},"SecurityGroupRule":{"type":"structure","members":{"IpProtocol":{},"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"CidrIpv4":{},"CidrIpv6":{},"PrefixListId":{},"ReferencedGroupId":{},"Description":{}}}}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySnapshotAttribute":{"input":{"type":"structure","required":["SnapshotId"],"members":{"Attribute":{},"CreateVolumePermission":{"type":"structure","members":{"Add":{"shape":"S1et"},"Remove":{"shape":"S1et"}}},"GroupNames":{"shape":"S1el","locationName":"UserGroup"},"OperationType":{},"SnapshotId":{},"UserIds":{"shape":"S1tg","locationName":"UserId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifySnapshotTier":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"StorageTier":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"TieringStartTime":{"locationName":"tieringStartTime","type":"timestamp"}}}},"ModifySpotFleetRequest":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"LaunchTemplateConfigs":{"shape":"S1g1","locationName":"LaunchTemplateConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"type":"integer"},"Context":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySubnetAttribute":{"input":{"type":"structure","required":["SubnetId"],"members":{"AssignIpv6AddressOnCreation":{"shape":"S131"},"MapPublicIpOnLaunch":{"shape":"S131"},"SubnetId":{"locationName":"subnetId"},"MapCustomerOwnedIpOnLaunch":{"shape":"S131"},"CustomerOwnedIpv4Pool":{},"EnableDns64":{"shape":"S131"},"PrivateDnsHostnameTypeOnLaunch":{},"EnableResourceNameDnsARecordOnLaunch":{"shape":"S131"},"EnableResourceNameDnsAAAARecordOnLaunch":{"shape":"S131"},"EnableLniAtDeviceIndex":{"type":"integer"},"DisableLniAtDeviceIndex":{"shape":"S131"}}}},"ModifyTrafficMirrorFilterNetworkServices":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"AddNetworkServices":{"shape":"Sl4","locationName":"AddNetworkService"},"RemoveNetworkServices":{"shape":"Sl4","locationName":"RemoveNetworkService"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sky","locationName":"trafficMirrorFilter"}}}},"ModifyTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Sl8"},"SourcePortRange":{"shape":"Sl8"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sl0","locationName":"trafficMirrorFilterRule"}}}},"ModifyTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sld","locationName":"trafficMirrorSession"}}}},"ModifyTransitGateway":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"Description":{},"Options":{"type":"structure","members":{"AddTransitGatewayCidrBlocks":{"shape":"Slp"},"RemoveTransitGatewayCidrBlocks":{"shape":"Slp"},"VpnEcmpSupport":{},"DnsSupport":{},"AutoAcceptSharedAttachments":{},"DefaultRouteTableAssociation":{},"AssociationDefaultRouteTableId":{},"DefaultRouteTablePropagation":{},"PropagationDefaultRouteTableId":{}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Slr","locationName":"transitGateway"}}}},"ModifyTransitGatewayPrefixListReference":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PrefixListId"],"members":{"TransitGatewayRouteTableId":{},"PrefixListId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReference":{"shape":"Smp","locationName":"transitGatewayPrefixListReference"}}}},"ModifyTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"AddSubnetIds":{"shape":"S43"},"RemoveSubnetIds":{"shape":"S43"},"Options":{"type":"structure","members":{"DnsSupport":{},"Ipv6Support":{},"ApplianceModeSupport":{}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sw","locationName":"transitGatewayVpcAttachment"}}}},"ModifyVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"type":"boolean"},"VolumeId":{},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Throughput":{"type":"integer"},"MultiAttachEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"VolumeModification":{"shape":"S1jj","locationName":"volumeModification"}}}},"ModifyVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"AutoEnableIO":{"shape":"S131"},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyVpcAttribute":{"input":{"type":"structure","required":["VpcId"],"members":{"EnableDnsHostnames":{"shape":"S131"},"EnableDnsSupport":{"shape":"S131"},"VpcId":{"locationName":"vpcId"}}}},"ModifyVpcEndpoint":{"input":{"type":"structure","required":["VpcEndpointId"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointId":{},"ResetPolicy":{"type":"boolean"},"PolicyDocument":{},"AddRouteTableIds":{"shape":"Sne","locationName":"AddRouteTableId"},"RemoveRouteTableIds":{"shape":"Sne","locationName":"RemoveRouteTableId"},"AddSubnetIds":{"shape":"Snf","locationName":"AddSubnetId"},"RemoveSubnetIds":{"shape":"Snf","locationName":"RemoveSubnetId"},"AddSecurityGroupIds":{"shape":"Sng","locationName":"AddSecurityGroupId"},"RemoveSecurityGroupIds":{"shape":"Sng","locationName":"RemoveSecurityGroupId"},"PrivateDnsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationId"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"Se"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"PrivateDnsName":{},"RemovePrivateDnsName":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"AddNetworkLoadBalancerArns":{"shape":"Se","locationName":"AddNetworkLoadBalancerArn"},"RemoveNetworkLoadBalancerArns":{"shape":"Se","locationName":"RemoveNetworkLoadBalancerArn"},"AddGatewayLoadBalancerArns":{"shape":"Se","locationName":"AddGatewayLoadBalancerArn"},"RemoveGatewayLoadBalancerArns":{"shape":"Se","locationName":"RemoveGatewayLoadBalancerArn"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePayerResponsibility":{"input":{"type":"structure","required":["ServiceId","PayerResponsibility"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"PayerResponsibility":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AddAllowedPrincipals":{"shape":"Se"},"RemoveAllowedPrincipals":{"shape":"Se"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcPeeringConnectionOptions":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"AccepterPeeringConnectionOptions":{"shape":"S1wn"},"DryRun":{"type":"boolean"},"RequesterPeeringConnectionOptions":{"shape":"S1wn"},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{"AccepterPeeringConnectionOptions":{"shape":"S1wp","locationName":"accepterPeeringConnectionOptions"},"RequesterPeeringConnectionOptions":{"shape":"S1wp","locationName":"requesterPeeringConnectionOptions"}}}},"ModifyVpcTenancy":{"input":{"type":"structure","required":["VpcId","InstanceTenancy"],"members":{"VpcId":{},"InstanceTenancy":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"TransitGatewayId":{},"CustomerGatewayId":{},"VpnGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Sor","locationName":"vpnConnection"}}}},"ModifyVpnConnectionOptions":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"LocalIpv4NetworkCidr":{},"RemoteIpv4NetworkCidr":{},"LocalIpv6NetworkCidr":{},"RemoteIpv6NetworkCidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Sor","locationName":"vpnConnection"}}}},"ModifyVpnTunnelCertificate":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Sor","locationName":"vpnConnection"}}}},"ModifyVpnTunnelOptions":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress","TunnelOptions"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"TunnelOptions":{"type":"structure","members":{"TunnelInsideCidr":{},"TunnelInsideIpv6Cidr":{},"PreSharedKey":{},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2LifetimeSeconds":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"RekeyFuzzPercentage":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"DPDTimeoutSeconds":{"type":"integer"},"DPDTimeoutAction":{},"Phase1EncryptionAlgorithms":{"shape":"Soc","locationName":"Phase1EncryptionAlgorithm"},"Phase2EncryptionAlgorithms":{"shape":"Soe","locationName":"Phase2EncryptionAlgorithm"},"Phase1IntegrityAlgorithms":{"shape":"Sog","locationName":"Phase1IntegrityAlgorithm"},"Phase2IntegrityAlgorithms":{"shape":"Soi","locationName":"Phase2IntegrityAlgorithm"},"Phase1DHGroupNumbers":{"shape":"Sok","locationName":"Phase1DHGroupNumber"},"Phase2DHGroupNumbers":{"shape":"Som","locationName":"Phase2DHGroupNumber"},"IKEVersions":{"shape":"Soo","locationName":"IKEVersion"},"StartupAction":{}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Sor","locationName":"vpnConnection"}}}},"MonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S1x4","locationName":"instancesSet"}}}},"MoveAddressToVpc":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"Status":{"locationName":"status"}}}},"MoveByoipCidrToIpam":{"input":{"type":"structure","required":["Cidr","IpamPoolId","IpamPoolOwner"],"members":{"DryRun":{"type":"boolean"},"Cidr":{},"IpamPoolId":{},"IpamPoolOwner":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1n","locationName":"byoipCidr"}}}},"ProvisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"CidrAuthorizationContext":{"type":"structure","required":["Message","Signature"],"members":{"Message":{},"Signature":{}}},"PubliclyAdvertisable":{"type":"boolean"},"Description":{},"DryRun":{"type":"boolean"},"PoolTagSpecifications":{"shape":"S1t","locationName":"PoolTagSpecification"},"MultiRegion":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1n","locationName":"byoipCidr"}}}},"ProvisionIpamPoolCidr":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{},"CidrAuthorizationContext":{"type":"structure","members":{"Message":{},"Signature":{}}}}},"output":{"type":"structure","members":{"IpamPoolCidr":{"shape":"Stn","locationName":"ipamPoolCidr"}}}},"ProvisionPublicIpv4PoolCidr":{"input":{"type":"structure","required":["IpamPoolId","PoolId","NetmaskLength"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"PoolId":{},"NetmaskLength":{"type":"integer"}}},"output":{"type":"structure","members":{"PoolId":{"locationName":"poolId"},"PoolAddressRange":{"shape":"S1cg","locationName":"poolAddressRange"}}}},"PurchaseHostReservation":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"ClientToken":{},"CurrencyCode":{},"HostIdSet":{"shape":"S1p3"},"LimitPrice":{},"OfferingId":{},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S1p5","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"PurchaseReservedInstancesOffering":{"input":{"type":"structure","required":["InstanceCount","ReservedInstancesOfferingId"],"members":{"InstanceCount":{"type":"integer"},"ReservedInstancesOfferingId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"LimitPrice":{"locationName":"limitPrice","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"CurrencyCode":{"locationName":"currencyCode"}}},"PurchaseTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"PurchaseScheduledInstances":{"input":{"type":"structure","required":["PurchaseRequests"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"PurchaseRequests":{"locationName":"PurchaseRequest","type":"list","member":{"locationName":"PurchaseRequest","type":"structure","required":["InstanceCount","PurchaseToken"],"members":{"InstanceCount":{"type":"integer"},"PurchaseToken":{}}}}}},"output":{"type":"structure","members":{"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"S1ea","locationName":"item"}}}}},"RebootInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RegisterImage":{"input":{"type":"structure","required":["Name"],"members":{"ImageLocation":{},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"Scf","locationName":"BlockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"KernelId":{"locationName":"kernelId"},"Name":{"locationName":"name"},"BillingProducts":{"locationName":"BillingProduct","type":"list","member":{"locationName":"item"}},"RamdiskId":{"locationName":"ramdiskId"},"RootDeviceName":{"locationName":"rootDeviceName"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"VirtualizationType":{"locationName":"virtualizationType"},"BootMode":{}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"RegisterInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTagAttribute":{"type":"structure","members":{"IncludeAllTagsOfInstance":{"type":"boolean"},"InstanceTagKeys":{"shape":"Stx","locationName":"InstanceTagKey"}}}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Stz","locationName":"instanceTagAttribute"}}}},"RegisterTransitGatewayMulticastGroupMembers":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Su1"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"RegisteredMulticastGroupMembers":{"locationName":"registeredMulticastGroupMembers","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"RegisteredNetworkInterfaceIds":{"shape":"Se","locationName":"registeredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"RegisterTransitGatewayMulticastGroupSources":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Su1"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"RegisteredMulticastGroupSources":{"locationName":"registeredMulticastGroupSources","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"RegisteredNetworkInterfaceIds":{"shape":"Se","locationName":"registeredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"RejectTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"Se"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sg","locationName":"associations"}}}},"RejectTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sn","locationName":"transitGatewayPeeringAttachment"}}}},"RejectTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sw","locationName":"transitGatewayVpcAttachment"}}}},"RejectVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"S13","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S16","locationName":"unsuccessful"}}}},"RejectVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReleaseAddress":{"input":{"type":"structure","members":{"AllocationId":{},"PublicIp":{},"NetworkBorderGroup":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ReleaseHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"HostIds":{"shape":"S117","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"S21","locationName":"successful"},"Unsuccessful":{"shape":"S1tp","locationName":"unsuccessful"}}}},"ReleaseIpamPoolAllocation":{"input":{"type":"structure","required":["IpamPoolId","Cidr","IpamPoolAllocationId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{},"IpamPoolAllocationId":{}}},"output":{"type":"structure","members":{"Success":{"locationName":"success","type":"boolean"}}}},"ReplaceIamInstanceProfileAssociation":{"input":{"type":"structure","required":["IamInstanceProfile","AssociationId"],"members":{"IamInstanceProfile":{"shape":"S36"},"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S38","locationName":"iamInstanceProfileAssociation"}}}},"ReplaceNetworkAclAssociation":{"input":{"type":"structure","required":["AssociationId","NetworkAclId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Shj","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Shk","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"ReplaceRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcEndpointId":{},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"LocalTarget":{"type":"boolean"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"LocalGatewayId":{},"CarrierGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"CoreNetworkArn":{}}}},"ReplaceRouteTableAssociation":{"input":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"},"AssociationState":{"shape":"S3u","locationName":"associationState"}}}},"ReplaceTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Smu","locationName":"route"}}}},"ReportInstanceStatus":{"input":{"type":"structure","required":["Instances","ReasonCodes","Status"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"Instances":{"shape":"Svy","locationName":"instanceId"},"ReasonCodes":{"locationName":"reasonCode","type":"list","member":{"locationName":"item"}},"StartTime":{"locationName":"startTime","type":"timestamp"},"Status":{"locationName":"status"}}}},"RequestSpotFleet":{"input":{"type":"structure","required":["SpotFleetRequestConfig"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestConfig":{"shape":"S1fm","locationName":"spotFleetRequestConfig"}}},"output":{"type":"structure","members":{"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"RequestSpotInstances":{"input":{"type":"structure","members":{"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ClientToken":{"locationName":"clientToken"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"type":"structure","members":{"SecurityGroupIds":{"locationName":"SecurityGroupId","type":"list","member":{"locationName":"item"}},"SecurityGroups":{"locationName":"SecurityGroup","type":"list","member":{"locationName":"item"}},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"S11w","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S36","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"shape":"S1gh","locationName":"monitoring"},"NetworkInterfaces":{"shape":"S1fw","locationName":"NetworkInterface"},"Placement":{"shape":"S1fy","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"}}},"SpotPrice":{"locationName":"spotPrice"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"InstanceInterruptionBehavior":{}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"S1ge","locationName":"spotInstanceRequestSet"}}}},"ResetAddressAttribute":{"input":{"type":"structure","required":["AllocationId","Attribute"],"members":{"AllocationId":{},"Attribute":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Address":{"shape":"Suu","locationName":"address"}}}},"ResetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ResetFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ResetImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ResetInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}}},"ResetNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"locationName":"sourceDestCheck"}}}},"ResetSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RestoreAddressToClassic":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"Status":{"locationName":"status"}}}},"RestoreImageFromRecycleBin":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"RestoreManagedPrefixListVersion":{"input":{"type":"structure","required":["PrefixListId","PreviousVersion","CurrentVersion"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"PreviousVersion":{"type":"long"},"CurrentVersion":{"type":"long"}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sh2","locationName":"prefixList"}}}},"RestoreSnapshotFromRecycleBin":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"OutpostArn":{"locationName":"outpostArn"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"}}}},"RestoreSnapshotTier":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"TemporaryRestoreDays":{"type":"integer"},"PermanentRestore":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"RestoreStartTime":{"locationName":"restoreStartTime","type":"timestamp"},"RestoreDuration":{"locationName":"restoreDuration","type":"integer"},"IsPermanentRestore":{"locationName":"isPermanentRestore","type":"boolean"}}}},"RevokeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"RevokeAllGroups":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S55","locationName":"status"}}}},"RevokeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S58","locationName":"ipPermissions"},"SecurityGroupRuleIds":{"shape":"S1eh","locationName":"SecurityGroupRuleId"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"UnknownIpPermissions":{"shape":"S58","locationName":"unknownIpPermissionSet"}}}},"RevokeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S58"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SecurityGroupRuleIds":{"shape":"S1eh","locationName":"SecurityGroupRuleId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"UnknownIpPermissions":{"shape":"S58","locationName":"unknownIpPermissionSet"}}}},"RunInstances":{"input":{"type":"structure","required":["MaxCount","MinCount"],"members":{"BlockDeviceMappings":{"shape":"Scf","locationName":"BlockDeviceMapping"},"ImageId":{},"InstanceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"shape":"Sfv","locationName":"Ipv6Address"},"KernelId":{},"KeyName":{},"MaxCount":{"type":"integer"},"MinCount":{"type":"integer"},"Monitoring":{"shape":"S1gh"},"Placement":{"shape":"Sak"},"RamdiskId":{},"SecurityGroupIds":{"shape":"Se7","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Set","locationName":"SecurityGroup"},"SubnetId":{},"UserData":{"type":"string","sensitive":true},"AdditionalInfo":{"locationName":"additionalInfo"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S36","locationName":"iamInstanceProfile"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"NetworkInterfaces":{"shape":"S1fw","locationName":"networkInterface"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ElasticGpuSpecification":{"type":"list","member":{"shape":"Sep","locationName":"item"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{},"Count":{"type":"integer"}}}},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"Sez"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"}}},"CapacityReservationSpecification":{"shape":"S1u2"},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"MetadataOptions":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"HttpProtocolIpv6":{},"InstanceMetadataTags":{}}},"EnclaveOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"PrivateDnsNameOptions":{"type":"structure","members":{"HostnameType":{},"EnableResourceNameDnsARecord":{"type":"boolean"},"EnableResourceNameDnsAAAARecord":{"type":"boolean"}}},"MaintenanceOptions":{"type":"structure","members":{"AutoRecovery":{}}}}},"output":{"shape":"S16t"}},"RunScheduledInstances":{"input":{"type":"structure","required":["LaunchSpecification","ScheduledInstanceId"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"InstanceCount":{"type":"integer"},"LaunchSpecification":{"type":"structure","required":["ImageId"],"members":{"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{},"VirtualName":{}}}},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"ImageId":{},"InstanceType":{},"KernelId":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S20q","locationName":"Group"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"locationName":"Ipv6Address","type":"list","member":{"locationName":"Ipv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddressConfigs":{"locationName":"PrivateIpAddressConfig","type":"list","member":{"locationName":"PrivateIpAddressConfigSet","type":"structure","members":{"Primary":{"type":"boolean"},"PrivateIpAddress":{}}}},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"GroupName":{}}},"RamdiskId":{},"SecurityGroupIds":{"shape":"S20q","locationName":"SecurityGroupId"},"SubnetId":{},"UserData":{}}},"ScheduledInstanceId":{}}},"output":{"type":"structure","members":{"InstanceIdSet":{"locationName":"instanceIdSet","type":"list","member":{"locationName":"item"}}}}},"SearchLocalGatewayRoutes":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"LocalGatewayRouteTableId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Sgr","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"SearchTransitGatewayMulticastGroups":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MulticastGroups":{"locationName":"multicastGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupIpAddress":{"locationName":"groupIpAddress"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"SubnetId":{"locationName":"subnetId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"GroupMember":{"locationName":"groupMember","type":"boolean"},"GroupSource":{"locationName":"groupSource","type":"boolean"},"MemberType":{"locationName":"memberType"},"SourceType":{"locationName":"sourceType"}}}},"NextToken":{"locationName":"nextToken"}}}},"SearchTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","Filters"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sug","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Smu","locationName":"item"}},"AdditionalRoutesAvailable":{"locationName":"additionalRoutesAvailable","type":"boolean"}}}},"SendDiagnosticInterrupt":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"type":"boolean"}}}},"StartInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"AdditionalInfo":{"locationName":"additionalInfo"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"StartingInstances":{"shape":"S21e","locationName":"instancesSet"}}}},"StartNetworkInsightsAccessScopeAnalysis":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeId","ClientToken"],"members":{"NetworkInsightsAccessScopeId":{},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysis":{"shape":"S1ae","locationName":"networkInsightsAccessScopeAnalysis"}}}},"StartNetworkInsightsAnalysis":{"input":{"type":"structure","required":["NetworkInsightsPathId","ClientToken"],"members":{"NetworkInsightsPathId":{},"FilterInArns":{"shape":"S1aq","locationName":"FilterInArn"},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkInsightsAnalysis":{"shape":"S1ap","locationName":"networkInsightsAnalysis"}}}},"StartVpcEndpointServicePrivateDnsVerification":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"StopInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"Hibernate":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"StoppingInstances":{"shape":"S21e","locationName":"instancesSet"}}}},"TerminateClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ConnectionId":{},"Username":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Username":{"locationName":"username"},"ConnectionStatuses":{"locationName":"connectionStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"PreviousStatus":{"shape":"Swd","locationName":"previousStatus"},"CurrentStatus":{"shape":"Swd","locationName":"currentStatus"}}}}}}},"TerminateInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"TerminatingInstances":{"shape":"S21e","locationName":"instancesSet"}}}},"UnassignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6Addresses":{"shape":"S2g","locationName":"ipv6Addresses"},"Ipv6Prefixes":{"shape":"S2h","locationName":"Ipv6Prefix"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"UnassignedIpv6Addresses":{"shape":"S2g","locationName":"unassignedIpv6Addresses"},"UnassignedIpv6Prefixes":{"shape":"S2h","locationName":"unassignedIpv6PrefixSet"}}}},"UnassignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S2l","locationName":"privateIpAddress"},"Ipv4Prefixes":{"shape":"S2h","locationName":"Ipv4Prefix"}}}},"UnmonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Svy","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S1x4","locationName":"instancesSet"}}}},"UpdateSecurityGroupRuleDescriptionsEgress":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S58"},"SecurityGroupRuleDescriptions":{"shape":"S220","locationName":"SecurityGroupRuleDescription"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"UpdateSecurityGroupRuleDescriptionsIngress":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S58"},"SecurityGroupRuleDescriptions":{"shape":"S220","locationName":"SecurityGroupRuleDescription"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"WithdrawByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1n","locationName":"byoipCidr"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"ReservedInstanceId"}},"S5":{"type":"list","member":{"locationName":"TargetConfigurationRequest","type":"structure","required":["OfferingId"],"members":{"InstanceCount":{"type":"integer"},"OfferingId":{}}}},"Se":{"type":"list","member":{"locationName":"item"}},"Sg":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"Subnets":{"locationName":"subnets","type":"list","member":{"shape":"Sj","locationName":"item"}}}},"Sj":{"type":"structure","members":{"SubnetId":{"locationName":"subnetId"},"State":{"locationName":"state"}}},"Sn":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"RequesterTgwInfo":{"shape":"So","locationName":"requesterTgwInfo"},"AccepterTgwInfo":{"shape":"So","locationName":"accepterTgwInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"So":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"OwnerId":{"locationName":"ownerId"},"Region":{"locationName":"region"}}},"Ss":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sw":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"VpcId":{"locationName":"vpcId"},"VpcOwnerId":{"locationName":"vpcOwnerId"},"State":{"locationName":"state"},"SubnetIds":{"shape":"Se","locationName":"subnetIds"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"DnsSupport":{"locationName":"dnsSupport"},"Ipv6Support":{"locationName":"ipv6Support"},"ApplianceModeSupport":{"locationName":"applianceModeSupport"}}},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S13":{"type":"list","member":{"locationName":"item"}},"S16":{"type":"list","member":{"shape":"S17","locationName":"item"}},"S17":{"type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ResourceId":{"locationName":"resourceId"}}},"S1c":{"type":"structure","members":{"AccepterVpcInfo":{"shape":"S1d","locationName":"accepterVpcInfo"},"ExpirationTime":{"locationName":"expirationTime","type":"timestamp"},"RequesterVpcInfo":{"shape":"S1d","locationName":"requesterVpcInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Tags":{"shape":"Ss","locationName":"tagSet"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S1d":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Ipv6CidrBlockSet":{"locationName":"ipv6CidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"}}}},"CidrBlockSet":{"locationName":"cidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"}}}},"OwnerId":{"locationName":"ownerId"},"PeeringOptions":{"locationName":"peeringOptions","type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"VpcId":{"locationName":"vpcId"},"Region":{"locationName":"region"}}},"S1n":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Description":{"locationName":"description"},"StatusMessage":{"locationName":"statusMessage"},"State":{"locationName":"state"}}},"S1t":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Ss","locationName":"Tag"}}}},"S21":{"type":"list","member":{"locationName":"item"}},"S26":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"IpamPoolAllocationId":{"locationName":"ipamPoolAllocationId"},"Description":{"locationName":"description"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceOwner":{"locationName":"resourceOwner"}}},"S2c":{"type":"list","member":{"locationName":"item"}},"S2g":{"type":"list","member":{"locationName":"item"}},"S2h":{"type":"list","member":{"locationName":"item"}},"S2l":{"type":"list","member":{"locationName":"PrivateIpAddress"}},"S2p":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{"locationName":"ipv4Prefix"}}}},"S2y":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S36":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S38":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"InstanceId":{"locationName":"instanceId"},"IamInstanceProfile":{"shape":"S39","locationName":"iamInstanceProfile"},"State":{"locationName":"state"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}},"S39":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"S3e":{"type":"list","member":{"locationName":"item"}},"S3f":{"type":"list","member":{"locationName":"item"}},"S3i":{"type":"structure","members":{"InstanceEventWindowId":{"locationName":"instanceEventWindowId"},"TimeRanges":{"locationName":"timeRangeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"StartWeekDay":{"locationName":"startWeekDay"},"StartHour":{"locationName":"startHour","type":"integer"},"EndWeekDay":{"locationName":"endWeekDay"},"EndHour":{"locationName":"endHour","type":"integer"}}}},"Name":{"locationName":"name"},"CronExpression":{"locationName":"cronExpression"},"AssociationTarget":{"locationName":"associationTarget","type":"structure","members":{"InstanceIds":{"shape":"S3e","locationName":"instanceIdSet"},"Tags":{"shape":"Ss","locationName":"tagSet"},"DedicatedHostIds":{"shape":"S3f","locationName":"dedicatedHostIdSet"}}},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S3u":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S3y":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"locationName":"ipv6CidrBlockState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S43":{"type":"list","member":{"locationName":"item"}},"S48":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}},"S4c":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"BranchInterfaceId":{"locationName":"branchInterfaceId"},"TrunkInterfaceId":{"locationName":"trunkInterfaceId"},"InterfaceProtocol":{"locationName":"interfaceProtocol"},"VlanId":{"locationName":"vlanId","type":"integer"},"GreKey":{"locationName":"greKey","type":"integer"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S4j":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"shape":"S4k","locationName":"ipv6CidrBlockState"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Ipv6Pool":{"locationName":"ipv6Pool"}}},"S4k":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S4m":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"CidrBlock":{"locationName":"cidrBlock"},"CidrBlockState":{"shape":"S4k","locationName":"cidrBlockState"}}},"S4o":{"type":"list","member":{"locationName":"groupId"}},"S4w":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"Device":{"locationName":"device"},"InstanceId":{"locationName":"instanceId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"S51":{"type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}},"S55":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S58":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIp":{"locationName":"cidrIp"},"Description":{"locationName":"description"}}}},"Ipv6Ranges":{"locationName":"ipv6Ranges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIpv6":{"locationName":"cidrIpv6"},"Description":{"locationName":"description"}}}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"PrefixListId":{"locationName":"prefixListId"}}}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S5h","locationName":"item"}}}}},"S5h":{"type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S5j":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroupRuleId":{"locationName":"securityGroupRuleId"},"GroupId":{"locationName":"groupId"},"GroupOwnerId":{"locationName":"groupOwnerId"},"IsEgress":{"locationName":"isEgress","type":"boolean"},"IpProtocol":{"locationName":"ipProtocol"},"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"},"CidrIpv4":{"locationName":"cidrIpv4"},"CidrIpv6":{"locationName":"cidrIpv6"},"PrefixListId":{"locationName":"prefixListId"},"ReferencedGroupInfo":{"locationName":"referencedGroupInfo","type":"structure","members":{"GroupId":{"locationName":"groupId"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"Description":{"locationName":"description"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"S5s":{"type":"structure","members":{"S3":{"type":"structure","members":{"AWSAccessKeyId":{},"Bucket":{"locationName":"bucket"},"Prefix":{"locationName":"prefix"},"UploadPolicy":{"locationName":"uploadPolicy","type":"blob"},"UploadPolicySignature":{"locationName":"uploadPolicySignature"}}}}},"S5w":{"type":"structure","members":{"BundleId":{"locationName":"bundleId"},"BundleTaskError":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"InstanceId":{"locationName":"instanceId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"state"},"Storage":{"shape":"S5s","locationName":"storage"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"S66":{"type":"list","member":{"locationName":"item"}},"S6r":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"InstanceCounts":{"locationName":"instanceCounts","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"State":{"locationName":"state"}}}},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"Active":{"locationName":"active","type":"boolean"},"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Ss","locationName":"tagSet"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}},"S73":{"type":"list","member":{"locationName":"item"}},"S7e":{"type":"list","member":{"locationName":"SpotInstanceRequestId"}},"S81":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"OwnerId":{"locationName":"ownerId"},"CapacityReservationArn":{"locationName":"capacityReservationArn"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"InstanceType":{"locationName":"instanceType"},"InstancePlatform":{"locationName":"instancePlatform"},"AvailabilityZone":{"locationName":"availabilityZone"},"Tenancy":{"locationName":"tenancy"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EphemeralStorage":{"locationName":"ephemeralStorage","type":"boolean"},"State":{"locationName":"state"},"StartDate":{"locationName":"startDate","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"EndDateType":{"locationName":"endDateType"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"},"OutpostArn":{"locationName":"outpostArn"},"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"PlacementGroupArn":{"locationName":"placementGroupArn"}}},"S8d":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"InstanceType":{"locationName":"instanceType"},"InstancePlatform":{"locationName":"instancePlatform"},"AvailabilityZone":{"locationName":"availabilityZone"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"Weight":{"locationName":"weight","type":"double"},"Priority":{"locationName":"priority","type":"integer"}}}},"S8h":{"type":"structure","members":{"CarrierGatewayId":{"locationName":"carrierGatewayId"},"VpcId":{"locationName":"vpcId"},"State":{"locationName":"state"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S8r":{"type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"S8u":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LambdaFunctionArn":{}}},"S8v":{"type":"structure","members":{"Enabled":{"type":"boolean"},"BannerText":{}}},"S8x":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S91":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S96":{"type":"structure","members":{"BgpAsn":{"locationName":"bgpAsn"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"IpAddress":{"locationName":"ipAddress"},"CertificateArn":{"locationName":"certificateArn"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"DeviceName":{"locationName":"deviceName"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S99":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"AvailableIpAddressCount":{"locationName":"availableIpAddressCount","type":"integer"},"CidrBlock":{"locationName":"cidrBlock"},"DefaultForAz":{"locationName":"defaultForAz","type":"boolean"},"EnableLniAtDeviceIndex":{"locationName":"enableLniAtDeviceIndex","type":"integer"},"MapPublicIpOnLaunch":{"locationName":"mapPublicIpOnLaunch","type":"boolean"},"MapCustomerOwnedIpOnLaunch":{"locationName":"mapCustomerOwnedIpOnLaunch","type":"boolean"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"AssignIpv6AddressOnCreation":{"locationName":"assignIpv6AddressOnCreation","type":"boolean"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S3y","locationName":"item"}},"Tags":{"shape":"Ss","locationName":"tagSet"},"SubnetArn":{"locationName":"subnetArn"},"OutpostArn":{"locationName":"outpostArn"},"EnableDns64":{"locationName":"enableDns64","type":"boolean"},"Ipv6Native":{"locationName":"ipv6Native","type":"boolean"},"PrivateDnsNameOptionsOnLaunch":{"locationName":"privateDnsNameOptionsOnLaunch","type":"structure","members":{"HostnameType":{"locationName":"hostnameType"},"EnableResourceNameDnsARecord":{"locationName":"enableResourceNameDnsARecord","type":"boolean"},"EnableResourceNameDnsAAAARecord":{"locationName":"enableResourceNameDnsAAAARecord","type":"boolean"}}}}},"S9h":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S4j","locationName":"item"}},"CidrBlockAssociationSet":{"locationName":"cidrBlockAssociationSet","type":"list","member":{"shape":"S4m","locationName":"item"}},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S9q":{"type":"structure","members":{"DhcpConfigurations":{"locationName":"dhcpConfigurationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"locationName":"valueSet","type":"list","member":{"shape":"S9u","locationName":"item"}}}}},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S9u":{"type":"structure","members":{"Value":{"locationName":"value"}}},"S9x":{"type":"structure","members":{"Attachments":{"shape":"S9y","locationName":"attachmentSet"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S9y":{"type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}}},"Sad":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"Overrides":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{},"MaxPrice":{},"SubnetId":{},"AvailabilityZone":{},"WeightedCapacity":{"type":"double"},"Priority":{"type":"double"},"Placement":{"shape":"Sak"},"InstanceRequirements":{"shape":"Sam"}}}}}}},"Sak":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"},"HostResourceGroupArn":{"locationName":"hostResourceGroupArn"}}},"Sam":{"type":"structure","required":["VCpuCount","MemoryMiB"],"members":{"VCpuCount":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"MemoryMiB":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"CpuManufacturers":{"shape":"Sap","locationName":"CpuManufacturer"},"MemoryGiBPerVCpu":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"ExcludedInstanceTypes":{"shape":"Sas","locationName":"ExcludedInstanceType"},"InstanceGenerations":{"shape":"Sau","locationName":"InstanceGeneration"},"SpotMaxPricePercentageOverLowestPrice":{"type":"integer"},"OnDemandMaxPricePercentageOverLowestPrice":{"type":"integer"},"BareMetal":{},"BurstablePerformance":{},"RequireHibernateSupport":{"type":"boolean"},"NetworkInterfaceCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"LocalStorage":{},"LocalStorageTypes":{"shape":"Sb0","locationName":"LocalStorageType"},"TotalLocalStorageGB":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"BaselineEbsBandwidthMbps":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorTypes":{"shape":"Sb4","locationName":"AcceleratorType"},"AcceleratorCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorManufacturers":{"shape":"Sb7","locationName":"AcceleratorManufacturer"},"AcceleratorNames":{"shape":"Sb9","locationName":"AcceleratorName"},"AcceleratorTotalMemoryMiB":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}}}},"Sap":{"type":"list","member":{"locationName":"item"}},"Sas":{"type":"list","member":{"locationName":"item"}},"Sau":{"type":"list","member":{"locationName":"item"}},"Sb0":{"type":"list","member":{"locationName":"item"}},"Sb4":{"type":"list","member":{"locationName":"item"}},"Sb7":{"type":"list","member":{"locationName":"item"}},"Sb9":{"type":"list","member":{"locationName":"item"}},"Sbc":{"type":"structure","required":["TotalTargetCapacity"],"members":{"TotalTargetCapacity":{"type":"integer"},"OnDemandTargetCapacity":{"type":"integer"},"SpotTargetCapacity":{"type":"integer"},"DefaultTargetCapacityType":{},"TargetCapacityUnitType":{}}},"Sbk":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sbl","locationName":"launchTemplateSpecification"},"Overrides":{"shape":"Sbm","locationName":"overrides"}}},"Sbl":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"Sbm":{"type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"MaxPrice":{"locationName":"maxPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"},"Placement":{"locationName":"placement","type":"structure","members":{"GroupName":{"locationName":"groupName"}}},"InstanceRequirements":{"shape":"Sbo","locationName":"instanceRequirements"}}},"Sbo":{"type":"structure","members":{"VCpuCount":{"locationName":"vCpuCount","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"MemoryMiB":{"locationName":"memoryMiB","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"CpuManufacturers":{"shape":"Sap","locationName":"cpuManufacturerSet"},"MemoryGiBPerVCpu":{"locationName":"memoryGiBPerVCpu","type":"structure","members":{"Min":{"locationName":"min","type":"double"},"Max":{"locationName":"max","type":"double"}}},"ExcludedInstanceTypes":{"shape":"Sas","locationName":"excludedInstanceTypeSet"},"InstanceGenerations":{"shape":"Sau","locationName":"instanceGenerationSet"},"SpotMaxPricePercentageOverLowestPrice":{"locationName":"spotMaxPricePercentageOverLowestPrice","type":"integer"},"OnDemandMaxPricePercentageOverLowestPrice":{"locationName":"onDemandMaxPricePercentageOverLowestPrice","type":"integer"},"BareMetal":{"locationName":"bareMetal"},"BurstablePerformance":{"locationName":"burstablePerformance"},"RequireHibernateSupport":{"locationName":"requireHibernateSupport","type":"boolean"},"NetworkInterfaceCount":{"locationName":"networkInterfaceCount","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"LocalStorage":{"locationName":"localStorage"},"LocalStorageTypes":{"shape":"Sb0","locationName":"localStorageTypeSet"},"TotalLocalStorageGB":{"locationName":"totalLocalStorageGB","type":"structure","members":{"Min":{"locationName":"min","type":"double"},"Max":{"locationName":"max","type":"double"}}},"BaselineEbsBandwidthMbps":{"locationName":"baselineEbsBandwidthMbps","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"AcceleratorTypes":{"shape":"Sb4","locationName":"acceleratorTypeSet"},"AcceleratorCount":{"locationName":"acceleratorCount","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"AcceleratorManufacturers":{"shape":"Sb7","locationName":"acceleratorManufacturerSet"},"AcceleratorNames":{"shape":"Sb9","locationName":"acceleratorNameSet"},"AcceleratorTotalMemoryMiB":{"locationName":"acceleratorTotalMemoryMiB","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}}}},"Sc0":{"type":"list","member":{"locationName":"item"}},"Scc":{"type":"structure","members":{"Bucket":{},"Key":{}}},"Scf":{"type":"list","member":{"shape":"Scg","locationName":"BlockDeviceMapping"}},"Scg":{"type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"},"KmsKeyId":{},"Throughput":{"locationName":"throughput","type":"integer"},"OutpostArn":{"locationName":"outpostArn"},"Encrypted":{"locationName":"encrypted","type":"boolean"}}},"NoDevice":{"locationName":"noDevice"}}},"Scm":{"type":"list","member":{"type":"structure","members":{"StartWeekDay":{},"StartHour":{"type":"integer"},"EndWeekDay":{},"EndHour":{"type":"integer"}}}},"Scv":{"type":"structure","members":{"Description":{"locationName":"description"},"ExportTaskId":{"locationName":"exportTaskId"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"InstanceExportDetails":{"locationName":"instanceExport","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sd1":{"type":"structure","members":{"Attachments":{"shape":"S9y","locationName":"attachmentSet"},"InternetGatewayId":{"locationName":"internetGatewayId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sd3":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"Sd6":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamId":{"locationName":"ipamId"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"PublicDefaultScopeId":{"locationName":"publicDefaultScopeId"},"PrivateDefaultScopeId":{"locationName":"privateDefaultScopeId"},"ScopeCount":{"locationName":"scopeCount","type":"integer"},"Description":{"locationName":"description"},"OperatingRegions":{"locationName":"operatingRegionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"RegionName":{"locationName":"regionName"}}}},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sdf":{"type":"list","member":{"shape":"Sdg","locationName":"item"}},"Sdg":{"type":"structure","members":{"Key":{},"Value":{}}},"Sdj":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamPoolId":{"locationName":"ipamPoolId"},"SourceIpamPoolId":{"locationName":"sourceIpamPoolId"},"IpamPoolArn":{"locationName":"ipamPoolArn"},"IpamScopeArn":{"locationName":"ipamScopeArn"},"IpamScopeType":{"locationName":"ipamScopeType"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"Locale":{"locationName":"locale"},"PoolDepth":{"locationName":"poolDepth","type":"integer"},"State":{"locationName":"state"},"StateMessage":{"locationName":"stateMessage"},"Description":{"locationName":"description"},"AutoImport":{"locationName":"autoImport","type":"boolean"},"PubliclyAdvertisable":{"locationName":"publiclyAdvertisable","type":"boolean"},"AddressFamily":{"locationName":"addressFamily"},"AllocationMinNetmaskLength":{"locationName":"allocationMinNetmaskLength","type":"integer"},"AllocationMaxNetmaskLength":{"locationName":"allocationMaxNetmaskLength","type":"integer"},"AllocationDefaultNetmaskLength":{"locationName":"allocationDefaultNetmaskLength","type":"integer"},"AllocationResourceTags":{"shape":"Sdm","locationName":"allocationResourceTagSet"},"Tags":{"shape":"Ss","locationName":"tagSet"},"AwsService":{"locationName":"awsService"}}},"Sdm":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sdq":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamScopeId":{"locationName":"ipamScopeId"},"IpamScopeArn":{"locationName":"ipamScopeArn"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"IpamScopeType":{"locationName":"ipamScopeType"},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Description":{"locationName":"description"},"PoolCount":{"locationName":"poolCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sdz":{"type":"structure","members":{"KernelId":{},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"Encrypted":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"Throughput":{"type":"integer"}}},"NoDevice":{}}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"InstanceNetworkInterfaceSpecification","type":"structure","members":{"AssociateCarrierIpAddress":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"Se7","locationName":"SecurityGroupId"},"InterfaceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"type":"list","member":{"locationName":"InstanceIpv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddresses":{"shape":"Sea"},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{},"NetworkCardIndex":{"type":"integer"},"Ipv4Prefixes":{"shape":"Sec","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"See","locationName":"Ipv6Prefix"},"Ipv6PrefixCount":{"type":"integer"}}}},"ImageId":{},"InstanceType":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"Affinity":{},"GroupName":{},"HostId":{},"Tenancy":{},"SpreadDomain":{},"HostResourceGroupArn":{},"PartitionNumber":{"type":"integer"}}},"RamDiskId":{},"DisableApiTermination":{"type":"boolean"},"InstanceInitiatedShutdownBehavior":{},"UserData":{},"TagSpecifications":{"locationName":"TagSpecification","type":"list","member":{"locationName":"LaunchTemplateTagSpecificationRequest","type":"structure","members":{"ResourceType":{},"Tags":{"shape":"Ss","locationName":"Tag"}}}},"ElasticGpuSpecifications":{"locationName":"ElasticGpuSpecification","type":"list","member":{"shape":"Sep","locationName":"ElasticGpuSpecification"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{},"Count":{"type":"integer"}}}},"SecurityGroupIds":{"shape":"Se7","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Set","locationName":"SecurityGroup"},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"Sez"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"}}},"CapacityReservationSpecification":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"Sf3"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"MetadataOptions":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"HttpProtocolIpv6":{},"InstanceMetadataTags":{}}},"EnclaveOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InstanceRequirements":{"shape":"Sam"},"PrivateDnsNameOptions":{"type":"structure","members":{"HostnameType":{},"EnableResourceNameDnsARecord":{"type":"boolean"},"EnableResourceNameDnsAAAARecord":{"type":"boolean"}}},"MaintenanceOptions":{"type":"structure","members":{"AutoRecovery":{}}}}},"Se7":{"type":"list","member":{"locationName":"SecurityGroupId"}},"Sea":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Primary":{"locationName":"primary","type":"boolean"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"Sec":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{}}}},"See":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{}}}},"Sep":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Set":{"type":"list","member":{"locationName":"SecurityGroup"}},"Sez":{"type":"structure","required":["CpuCredits"],"members":{"CpuCredits":{}}},"Sf3":{"type":"structure","members":{"CapacityReservationId":{},"CapacityReservationResourceGroupArn":{}}},"Sfh":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersionNumber":{"locationName":"defaultVersionNumber","type":"long"},"LatestVersionNumber":{"locationName":"latestVersionNumber","type":"long"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sfi":{"type":"structure","members":{"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"Sfn":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"VersionDescription":{"locationName":"versionDescription"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersion":{"locationName":"defaultVersion","type":"boolean"},"LaunchTemplateData":{"shape":"Sfo","locationName":"launchTemplateData"}}},"Sfo":{"type":"structure","members":{"KernelId":{"locationName":"kernelId"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"BlockDeviceMappings":{"locationName":"blockDeviceMappingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"KmsKeyId":{"locationName":"kmsKeyId"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"},"Throughput":{"locationName":"throughput","type":"integer"}}},"NoDevice":{"locationName":"noDevice"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociateCarrierIpAddress":{"locationName":"associateCarrierIpAddress","type":"boolean"},"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S4o","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sfv","locationName":"ipv6AddressesSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"Sea","locationName":"privateIpAddressesSet"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"Ipv4Prefixes":{"locationName":"ipv4PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{"locationName":"ipv4Prefix"}}}},"Ipv4PrefixCount":{"locationName":"ipv4PrefixCount","type":"integer"},"Ipv6Prefixes":{"locationName":"ipv6PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{"locationName":"ipv6Prefix"}}}},"Ipv6PrefixCount":{"locationName":"ipv6PrefixCount","type":"integer"}}}},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Placement":{"locationName":"placement","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"},"HostResourceGroupArn":{"locationName":"hostResourceGroupArn"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"}}},"RamDiskId":{"locationName":"ramDiskId"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"UserData":{"locationName":"userData"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Ss","locationName":"tagSet"}}}},"ElasticGpuSpecifications":{"locationName":"elasticGpuSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"}}}},"ElasticInferenceAccelerators":{"locationName":"elasticInferenceAcceleratorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"Count":{"locationName":"count","type":"integer"}}}},"SecurityGroupIds":{"shape":"Se","locationName":"securityGroupIdSet"},"SecurityGroups":{"shape":"Se","locationName":"securityGroupSet"},"InstanceMarketOptions":{"locationName":"instanceMarketOptions","type":"structure","members":{"MarketType":{"locationName":"marketType"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"MaxPrice":{"locationName":"maxPrice"},"SpotInstanceType":{"locationName":"spotInstanceType"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}}},"CreditSpecification":{"locationName":"creditSpecification","type":"structure","members":{"CpuCredits":{"locationName":"cpuCredits"}}},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"}}},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"Sge","locationName":"capacityReservationTarget"}}},"LicenseSpecifications":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"MetadataOptions":{"locationName":"metadataOptions","type":"structure","members":{"State":{"locationName":"state"},"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"},"HttpProtocolIpv6":{"locationName":"httpProtocolIpv6"},"InstanceMetadataTags":{"locationName":"instanceMetadataTags"}}},"EnclaveOptions":{"locationName":"enclaveOptions","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"InstanceRequirements":{"shape":"Sbo","locationName":"instanceRequirements"},"PrivateDnsNameOptions":{"locationName":"privateDnsNameOptions","type":"structure","members":{"HostnameType":{"locationName":"hostnameType"},"EnableResourceNameDnsARecord":{"locationName":"enableResourceNameDnsARecord","type":"boolean"},"EnableResourceNameDnsAAAARecord":{"locationName":"enableResourceNameDnsAAAARecord","type":"boolean"}}},"MaintenanceOptions":{"locationName":"maintenanceOptions","type":"structure","members":{"AutoRecovery":{"locationName":"autoRecovery"}}}}},"Sfv":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"Sge":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"CapacityReservationResourceGroupArn":{"locationName":"capacityReservationResourceGroupArn"}}},"Sgr":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"Type":{"locationName":"type"},"State":{"locationName":"state"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"OwnerId":{"locationName":"ownerId"}}},"Sgw":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociationId":{"locationName":"localGatewayRouteTableVpcAssociationId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"LocalGatewayId":{"locationName":"localGatewayId"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sgz":{"type":"list","member":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"Description":{}}}},"Sh2":{"type":"structure","members":{"PrefixListId":{"locationName":"prefixListId"},"AddressFamily":{"locationName":"addressFamily"},"State":{"locationName":"state"},"StateMessage":{"locationName":"stateMessage"},"PrefixListArn":{"locationName":"prefixListArn"},"PrefixListName":{"locationName":"prefixListName"},"MaxEntries":{"locationName":"maxEntries","type":"integer"},"Version":{"locationName":"version","type":"long"},"Tags":{"shape":"Ss","locationName":"tagSet"},"OwnerId":{"locationName":"ownerId"}}},"Sh7":{"type":"structure","members":{"CreateTime":{"locationName":"createTime","type":"timestamp"},"DeleteTime":{"locationName":"deleteTime","type":"timestamp"},"FailureCode":{"locationName":"failureCode"},"FailureMessage":{"locationName":"failureMessage"},"NatGatewayAddresses":{"locationName":"natGatewayAddressSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIp":{"locationName":"privateIp"},"PublicIp":{"locationName":"publicIp"}}}},"NatGatewayId":{"locationName":"natGatewayId"},"ProvisionedBandwidth":{"locationName":"provisionedBandwidth","type":"structure","members":{"ProvisionTime":{"locationName":"provisionTime","type":"timestamp"},"Provisioned":{"locationName":"provisioned"},"RequestTime":{"locationName":"requestTime","type":"timestamp"},"Requested":{"locationName":"requested"},"Status":{"locationName":"status"}}},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Tags":{"shape":"Ss","locationName":"tagSet"},"ConnectivityType":{"locationName":"connectivityType"}}},"She":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkAclAssociationId":{"locationName":"networkAclAssociationId"},"NetworkAclId":{"locationName":"networkAclId"},"SubnetId":{"locationName":"subnetId"}}}},"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Shj","locationName":"icmpTypeCode"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"PortRange":{"shape":"Shk","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"IsDefault":{"locationName":"default","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Shj":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Type":{"locationName":"type","type":"integer"}}},"Shk":{"type":"structure","members":{"From":{"locationName":"from","type":"integer"},"To":{"locationName":"to","type":"integer"}}},"Shp":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Source":{"shape":"Shr"},"Destination":{"shape":"Shr"},"ThroughResources":{"locationName":"ThroughResource","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceStatement":{"shape":"Shv"}}}}}}},"Shr":{"type":"structure","members":{"PacketHeaderStatement":{"type":"structure","members":{"SourceAddresses":{"shape":"Se","locationName":"SourceAddress"},"DestinationAddresses":{"shape":"Se","locationName":"DestinationAddress"},"SourcePorts":{"shape":"Se","locationName":"SourcePort"},"DestinationPorts":{"shape":"Se","locationName":"DestinationPort"},"SourcePrefixLists":{"shape":"Se","locationName":"SourcePrefixList"},"DestinationPrefixLists":{"shape":"Se","locationName":"DestinationPrefixList"},"Protocols":{"shape":"Sht","locationName":"Protocol"}}},"ResourceStatement":{"shape":"Shv"}}},"Sht":{"type":"list","member":{"locationName":"item"}},"Shv":{"type":"structure","members":{"Resources":{"shape":"Se","locationName":"Resource"},"ResourceTypes":{"shape":"Se","locationName":"ResourceType"}}},"Shz":{"type":"structure","members":{"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"NetworkInsightsAccessScopeArn":{"locationName":"networkInsightsAccessScopeArn"},"CreatedDate":{"locationName":"createdDate","type":"timestamp"},"UpdatedDate":{"locationName":"updatedDate","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Si1":{"type":"structure","members":{"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"MatchPaths":{"shape":"Si2","locationName":"matchPathSet"},"ExcludePaths":{"shape":"Si2","locationName":"excludePathSet"}}},"Si2":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Source":{"shape":"Si4","locationName":"source"},"Destination":{"shape":"Si4","locationName":"destination"},"ThroughResources":{"locationName":"throughResourceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceStatement":{"shape":"Si6","locationName":"resourceStatement"}}}}}}},"Si4":{"type":"structure","members":{"PacketHeaderStatement":{"locationName":"packetHeaderStatement","type":"structure","members":{"SourceAddresses":{"shape":"Se","locationName":"sourceAddressSet"},"DestinationAddresses":{"shape":"Se","locationName":"destinationAddressSet"},"SourcePorts":{"shape":"Se","locationName":"sourcePortSet"},"DestinationPorts":{"shape":"Se","locationName":"destinationPortSet"},"SourcePrefixLists":{"shape":"Se","locationName":"sourcePrefixListSet"},"DestinationPrefixLists":{"shape":"Se","locationName":"destinationPrefixListSet"},"Protocols":{"shape":"Sht","locationName":"protocolSet"}}},"ResourceStatement":{"shape":"Si6","locationName":"resourceStatement"}}},"Si6":{"type":"structure","members":{"Resources":{"shape":"Se","locationName":"resourceSet"},"ResourceTypes":{"shape":"Se","locationName":"resourceTypeSet"}}},"Sie":{"type":"structure","members":{"NetworkInsightsPathId":{"locationName":"networkInsightsPathId"},"NetworkInsightsPathArn":{"locationName":"networkInsightsPathArn"},"CreatedDate":{"locationName":"createdDate","type":"timestamp"},"Source":{"locationName":"source"},"Destination":{"locationName":"destination"},"SourceIp":{"locationName":"sourceIp"},"DestinationIp":{"locationName":"destinationIp"},"Protocol":{"locationName":"protocol"},"DestinationPort":{"locationName":"destinationPort","type":"integer"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sij":{"type":"structure","members":{"Association":{"shape":"Sik","locationName":"association"},"Attachment":{"shape":"Sil","locationName":"attachment"},"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"Groups":{"shape":"Sim","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6Addresses":{"locationName":"ipv6AddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Sik","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"Ipv4Prefixes":{"shape":"S2p","locationName":"ipv4PrefixSet"},"Ipv6Prefixes":{"locationName":"ipv6PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{"locationName":"ipv6Prefix"}}}},"RequesterId":{"locationName":"requesterId"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"TagSet":{"shape":"Ss","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"DenyAllIgwTraffic":{"locationName":"denyAllIgwTraffic","type":"boolean"},"Ipv6Native":{"locationName":"ipv6Native","type":"boolean"},"Ipv6Address":{"locationName":"ipv6Address"}}},"Sik":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CarrierIp":{"locationName":"carrierIp"}}},"Sil":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"Status":{"locationName":"status"}}},"Sim":{"type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"Siz":{"type":"structure","members":{"NetworkInterfacePermissionId":{"locationName":"networkInterfacePermissionId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"Permission":{"locationName":"permission"},"PermissionState":{"locationName":"permissionState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"Sj5":{"type":"structure","members":{"GroupName":{"locationName":"groupName"},"State":{"locationName":"state"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"locationName":"partitionCount","type":"integer"},"GroupId":{"locationName":"groupId"},"Tags":{"shape":"Ss","locationName":"tagSet"},"GroupArn":{"locationName":"groupArn"}}},"Sjb":{"type":"structure","members":{"ReplaceRootVolumeTaskId":{"locationName":"replaceRootVolumeTaskId"},"InstanceId":{"locationName":"instanceId"},"TaskState":{"locationName":"taskState"},"StartTime":{"locationName":"startTime"},"CompleteTime":{"locationName":"completeTime"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sjs":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Main":{"locationName":"main","type":"boolean"},"RouteTableAssociationId":{"locationName":"routeTableAssociationId"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"},"GatewayId":{"locationName":"gatewayId"},"AssociationState":{"shape":"S3u","locationName":"associationState"}}}},"PropagatingVgws":{"locationName":"propagatingVgwSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GatewayId":{"locationName":"gatewayId"}}}},"RouteTableId":{"locationName":"routeTableId"},"Routes":{"locationName":"routeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"LocalGatewayId":{"locationName":"localGatewayId"},"CarrierGatewayId":{"locationName":"carrierGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"State":{"locationName":"state"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"CoreNetworkArn":{"locationName":"coreNetworkArn"}}}},"Tags":{"shape":"Ss","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Sk4":{"type":"structure","members":{"DataEncryptionKeyId":{"locationName":"dataEncryptionKeyId"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"StateMessage":{"locationName":"statusMessage"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"OwnerAlias":{"locationName":"ownerAlias"},"OutpostArn":{"locationName":"outpostArn"},"Tags":{"shape":"Ss","locationName":"tagSet"},"StorageTier":{"locationName":"storageTier"},"RestoreExpiryTime":{"locationName":"restoreExpiryTime","type":"timestamp"}}},"Skf":{"type":"structure","members":{"Bucket":{"locationName":"bucket"},"Fault":{"shape":"Skg","locationName":"fault"},"OwnerId":{"locationName":"ownerId"},"Prefix":{"locationName":"prefix"},"State":{"locationName":"state"}}},"Skg":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Skr":{"type":"structure","members":{"SubnetCidrReservationId":{"locationName":"subnetCidrReservationId"},"SubnetId":{"locationName":"subnetId"},"Cidr":{"locationName":"cidr"},"ReservationType":{"locationName":"reservationType"},"OwnerId":{"locationName":"ownerId"},"Description":{"locationName":"description"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sku":{"type":"list","member":{}},"Sky":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"IngressFilterRules":{"shape":"Skz","locationName":"ingressFilterRuleSet"},"EgressFilterRules":{"shape":"Skz","locationName":"egressFilterRuleSet"},"NetworkServices":{"shape":"Sl4","locationName":"networkServiceSet"},"Description":{"locationName":"description"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Skz":{"type":"list","member":{"shape":"Sl0","locationName":"item"}},"Sl0":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"TrafficDirection":{"locationName":"trafficDirection"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"},"RuleAction":{"locationName":"ruleAction"},"Protocol":{"locationName":"protocol","type":"integer"},"DestinationPortRange":{"shape":"Sl3","locationName":"destinationPortRange"},"SourcePortRange":{"shape":"Sl3","locationName":"sourcePortRange"},"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"SourceCidrBlock":{"locationName":"sourceCidrBlock"},"Description":{"locationName":"description"}}},"Sl3":{"type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"}}},"Sl4":{"type":"list","member":{"locationName":"item"}},"Sl8":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}},"Sld":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"},"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PacketLength":{"locationName":"packetLength","type":"integer"},"SessionNumber":{"locationName":"sessionNumber","type":"integer"},"VirtualNetworkId":{"locationName":"virtualNetworkId","type":"integer"},"Description":{"locationName":"description"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Slg":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkLoadBalancerArn":{"locationName":"networkLoadBalancerArn"},"Type":{"locationName":"type"},"Description":{"locationName":"description"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Slp":{"type":"list","member":{"locationName":"item"}},"Slr":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayArn":{"locationName":"transitGatewayArn"},"State":{"locationName":"state"},"OwnerId":{"locationName":"ownerId"},"Description":{"locationName":"description"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"TransitGatewayCidrBlocks":{"shape":"Se","locationName":"transitGatewayCidrBlocks"},"AutoAcceptSharedAttachments":{"locationName":"autoAcceptSharedAttachments"},"DefaultRouteTableAssociation":{"locationName":"defaultRouteTableAssociation"},"AssociationDefaultRouteTableId":{"locationName":"associationDefaultRouteTableId"},"DefaultRouteTablePropagation":{"locationName":"defaultRouteTablePropagation"},"PropagationDefaultRouteTableId":{"locationName":"propagationDefaultRouteTableId"},"VpnEcmpSupport":{"locationName":"vpnEcmpSupport"},"DnsSupport":{"locationName":"dnsSupport"},"MulticastSupport":{"locationName":"multicastSupport"}}},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sly":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransportTransitGatewayAttachmentId":{"locationName":"transportTransitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"Protocol":{"locationName":"protocol"}}},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sm2":{"type":"list","member":{"locationName":"item"}},"Sm4":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayConnectPeerId":{"locationName":"transitGatewayConnectPeerId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"ConnectPeerConfiguration":{"locationName":"connectPeerConfiguration","type":"structure","members":{"TransitGatewayAddress":{"locationName":"transitGatewayAddress"},"PeerAddress":{"locationName":"peerAddress"},"InsideCidrBlocks":{"shape":"Sm2","locationName":"insideCidrBlocks"},"Protocol":{"locationName":"protocol"},"BgpConfigurations":{"locationName":"bgpConfigurations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAsn":{"locationName":"transitGatewayAsn","type":"long"},"PeerAsn":{"locationName":"peerAsn","type":"long"},"TransitGatewayAddress":{"locationName":"transitGatewayAddress"},"PeerAddress":{"locationName":"peerAddress"},"BgpStatus":{"locationName":"bgpStatus"}}}}}},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Smh":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayMulticastDomainArn":{"locationName":"transitGatewayMulticastDomainArn"},"OwnerId":{"locationName":"ownerId"},"Options":{"locationName":"options","type":"structure","members":{"Igmpv2Support":{"locationName":"igmpv2Support"},"StaticSourcesSupport":{"locationName":"staticSourcesSupport"},"AutoAcceptSharedAssociations":{"locationName":"autoAcceptSharedAssociations"}}},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Smp":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListOwnerId":{"locationName":"prefixListOwnerId"},"State":{"locationName":"state"},"Blackhole":{"locationName":"blackhole","type":"boolean"},"TransitGatewayAttachment":{"locationName":"transitGatewayAttachment","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"}}}}},"Smu":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"PrefixListId":{"locationName":"prefixListId"},"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceType":{"locationName":"resourceType"}}}},"Type":{"locationName":"type"},"State":{"locationName":"state"}}},"Sn1":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"DefaultAssociationRouteTable":{"locationName":"defaultAssociationRouteTable","type":"boolean"},"DefaultPropagationRouteTable":{"locationName":"defaultPropagationRouteTable","type":"boolean"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sn7":{"type":"structure","members":{"Attachments":{"locationName":"attachmentSet","type":"list","member":{"shape":"S4w","locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OutpostArn":{"locationName":"outpostArn"},"Size":{"locationName":"size","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"Iops":{"locationName":"iops","type":"integer"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VolumeType":{"locationName":"volumeType"},"FastRestored":{"locationName":"fastRestored","type":"boolean"},"MultiAttachEnabled":{"locationName":"multiAttachEnabled","type":"boolean"},"Throughput":{"locationName":"throughput","type":"integer"}}},"Sne":{"type":"list","member":{"locationName":"item"}},"Snf":{"type":"list","member":{"locationName":"item"}},"Sng":{"type":"list","member":{"locationName":"item"}},"Sni":{"type":"structure","members":{"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointType":{"locationName":"vpcEndpointType"},"VpcId":{"locationName":"vpcId"},"ServiceName":{"locationName":"serviceName"},"State":{"locationName":"state"},"PolicyDocument":{"locationName":"policyDocument"},"RouteTableIds":{"shape":"Se","locationName":"routeTableIdSet"},"SubnetIds":{"shape":"Se","locationName":"subnetIdSet"},"Groups":{"locationName":"groupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"PrivateDnsEnabled":{"locationName":"privateDnsEnabled","type":"boolean"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"NetworkInterfaceIds":{"shape":"Se","locationName":"networkInterfaceIdSet"},"DnsEntries":{"shape":"Snm","locationName":"dnsEntrySet"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"Tags":{"shape":"Ss","locationName":"tagSet"},"OwnerId":{"locationName":"ownerId"},"LastError":{"locationName":"lastError","type":"structure","members":{"Message":{"locationName":"message"},"Code":{"locationName":"code"}}}}},"Snm":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DnsName":{"locationName":"dnsName"},"HostedZoneId":{"locationName":"hostedZoneId"}}}},"Snr":{"type":"structure","members":{"ConnectionNotificationId":{"locationName":"connectionNotificationId"},"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"ConnectionNotificationType":{"locationName":"connectionNotificationType"},"ConnectionNotificationArn":{"locationName":"connectionNotificationArn"},"ConnectionEvents":{"shape":"Se","locationName":"connectionEvents"},"ConnectionNotificationState":{"locationName":"connectionNotificationState"}}},"Snw":{"type":"structure","members":{"ServiceType":{"shape":"Snx","locationName":"serviceType"},"ServiceId":{"locationName":"serviceId"},"ServiceName":{"locationName":"serviceName"},"ServiceState":{"locationName":"serviceState"},"AvailabilityZones":{"shape":"Se","locationName":"availabilityZoneSet"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"NetworkLoadBalancerArns":{"shape":"Se","locationName":"networkLoadBalancerArnSet"},"GatewayLoadBalancerArns":{"shape":"Se","locationName":"gatewayLoadBalancerArnSet"},"BaseEndpointDnsNames":{"shape":"Se","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateDnsNameConfiguration":{"locationName":"privateDnsNameConfiguration","type":"structure","members":{"State":{"locationName":"state"},"Type":{"locationName":"type"},"Value":{"locationName":"value"},"Name":{"locationName":"name"}}},"PayerResponsibility":{"locationName":"payerResponsibility"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Snx":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceType":{"locationName":"serviceType"}}}},"Soc":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Soe":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Sog":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Soi":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Sok":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"type":"integer"}}}},"Som":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"type":"integer"}}}},"Soo":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Sor":{"type":"structure","members":{"CustomerGatewayConfiguration":{"locationName":"customerGatewayConfiguration"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"Category":{"locationName":"category"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpnConnectionId":{"locationName":"vpnConnectionId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"CoreNetworkArn":{"locationName":"coreNetworkArn"},"CoreNetworkAttachmentArn":{"locationName":"coreNetworkAttachmentArn"},"GatewayAssociationState":{"locationName":"gatewayAssociationState"},"Options":{"locationName":"options","type":"structure","members":{"EnableAcceleration":{"locationName":"enableAcceleration","type":"boolean"},"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"LocalIpv4NetworkCidr":{"locationName":"localIpv4NetworkCidr"},"RemoteIpv4NetworkCidr":{"locationName":"remoteIpv4NetworkCidr"},"LocalIpv6NetworkCidr":{"locationName":"localIpv6NetworkCidr"},"RemoteIpv6NetworkCidr":{"locationName":"remoteIpv6NetworkCidr"},"TunnelInsideIpVersion":{"locationName":"tunnelInsideIpVersion"},"TunnelOptions":{"locationName":"tunnelOptionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"OutsideIpAddress":{"locationName":"outsideIpAddress"},"TunnelInsideCidr":{"locationName":"tunnelInsideCidr"},"TunnelInsideIpv6Cidr":{"locationName":"tunnelInsideIpv6Cidr"},"PreSharedKey":{"locationName":"preSharedKey"},"Phase1LifetimeSeconds":{"locationName":"phase1LifetimeSeconds","type":"integer"},"Phase2LifetimeSeconds":{"locationName":"phase2LifetimeSeconds","type":"integer"},"RekeyMarginTimeSeconds":{"locationName":"rekeyMarginTimeSeconds","type":"integer"},"RekeyFuzzPercentage":{"locationName":"rekeyFuzzPercentage","type":"integer"},"ReplayWindowSize":{"locationName":"replayWindowSize","type":"integer"},"DpdTimeoutSeconds":{"locationName":"dpdTimeoutSeconds","type":"integer"},"DpdTimeoutAction":{"locationName":"dpdTimeoutAction"},"Phase1EncryptionAlgorithms":{"locationName":"phase1EncryptionAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase2EncryptionAlgorithms":{"locationName":"phase2EncryptionAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase1IntegrityAlgorithms":{"locationName":"phase1IntegrityAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase2IntegrityAlgorithms":{"locationName":"phase2IntegrityAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase1DHGroupNumbers":{"locationName":"phase1DHGroupNumberSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value","type":"integer"}}}},"Phase2DHGroupNumbers":{"locationName":"phase2DHGroupNumberSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value","type":"integer"}}}},"IkeVersions":{"locationName":"ikeVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"StartupAction":{"locationName":"startupAction"}}}}}},"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"Source":{"locationName":"source"},"State":{"locationName":"state"}}}},"Tags":{"shape":"Ss","locationName":"tagSet"},"VgwTelemetry":{"locationName":"vgwTelemetry","type":"list","member":{"locationName":"item","type":"structure","members":{"AcceptedRouteCount":{"locationName":"acceptedRouteCount","type":"integer"},"LastStatusChange":{"locationName":"lastStatusChange","type":"timestamp"},"OutsideIpAddress":{"locationName":"outsideIpAddress"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"CertificateArn":{"locationName":"certificateArn"}}}}}},"Spl":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpcAttachments":{"locationName":"attachments","type":"list","member":{"shape":"S51","locationName":"item"}},"VpnGatewayId":{"locationName":"vpnGatewayId"},"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Spz":{"type":"list","member":{}},"Sq9":{"type":"list","member":{"locationName":"item"}},"Squ":{"type":"list","member":{"locationName":"item"}},"Sta":{"type":"list","member":{"locationName":"item"}},"Stn":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"State":{"locationName":"state"},"FailureReason":{"locationName":"failureReason","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}},"Stx":{"type":"list","member":{"locationName":"item"}},"Stz":{"type":"structure","members":{"InstanceTagKeys":{"shape":"Stx","locationName":"instanceTagKeySet"},"IncludeAllTagsOfInstance":{"locationName":"includeAllTagsOfInstance","type":"boolean"}}},"Su1":{"type":"list","member":{"locationName":"item"}},"Sug":{"type":"list","member":{"locationName":"Filter","type":"structure","members":{"Name":{},"Values":{"shape":"Se","locationName":"Value"}}}},"Suu":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"PtrRecord":{"locationName":"ptrRecord"},"PtrRecordUpdate":{"locationName":"ptrRecordUpdate","type":"structure","members":{"Value":{"locationName":"value"},"Status":{"locationName":"status"},"Reason":{"locationName":"reason"}}}}},"Suy":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Deadline":{"locationName":"deadline","type":"timestamp"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"Svy":{"type":"list","member":{"locationName":"InstanceId"}},"Swd":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sxk":{"type":"structure","members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"ExpirationTime":{"locationName":"expirationTime"},"ImportInstance":{"locationName":"importInstance","type":"structure","members":{"Description":{"locationName":"description"},"InstanceId":{"locationName":"instanceId"},"Platform":{"locationName":"platform"},"Volumes":{"locationName":"volumes","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Sxo","locationName":"image"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Volume":{"shape":"Sxp","locationName":"volume"}}}}}},"ImportVolume":{"locationName":"importVolume","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Sxo","locationName":"image"},"Volume":{"shape":"Sxp","locationName":"volume"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"Sxo":{"type":"structure","members":{"Checksum":{"locationName":"checksum"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"},"Size":{"locationName":"size","type":"long"}}},"Sxp":{"type":"structure","members":{"Id":{"locationName":"id"},"Size":{"locationName":"size","type":"long"}}},"Syn":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"Sz0":{"type":"structure","members":{"TargetResourceCount":{"locationName":"targetResourceCount","type":"integer"}}},"Sz1":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"Sze":{"type":"structure","members":{"EventDescription":{"locationName":"eventDescription"},"EventSubType":{"locationName":"eventSubType"},"InstanceId":{"locationName":"instanceId"}}},"Szh":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"InstanceHealth":{"locationName":"instanceHealth"}}}},"S10a":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"LoadPermissions":{"locationName":"loadPermissions","type":"list","member":{"locationName":"item","type":"structure","members":{"UserId":{"locationName":"userId"},"Group":{"locationName":"group"}}}},"ProductCodes":{"shape":"S10e","locationName":"productCodes"}}},"S10e":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ProductCodeId":{"locationName":"productCode"},"ProductCodeType":{"locationName":"type"}}}},"S10j":{"type":"list","member":{"locationName":"Owner"}},"S114":{"type":"list","member":{"locationName":"item"}},"S117":{"type":"list","member":{"locationName":"item"}},"S11w":{"type":"list","member":{"shape":"Scg","locationName":"item"}},"S11x":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"},"OrganizationArn":{"locationName":"organizationArn"},"OrganizationalUnitArn":{"locationName":"organizationalUnitArn"}}}},"S121":{"type":"list","member":{"locationName":"ImageId"}},"S12a":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S12j":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"DeviceName":{"locationName":"deviceName"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"S12l","locationName":"userBucket"}}}},"S12l":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"S12m":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"S12u":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Format":{"locationName":"format"},"KmsKeyId":{"locationName":"kmsKeyId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"S12l","locationName":"userBucket"}}},"S12y":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Status":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"}}}}}},"S131":{"type":"structure","members":{"Value":{"locationName":"value","type":"boolean"}}},"S132":{"type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"S13k":{"type":"structure","members":{"InstanceEventId":{"locationName":"instanceEventId"},"Code":{"locationName":"code"},"Description":{"locationName":"description"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"NotBeforeDeadline":{"locationName":"notBeforeDeadline","type":"timestamp"}}},"S13n":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Name":{"locationName":"name"}}},"S13p":{"type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"ImpairedSince":{"locationName":"impairedSince","type":"timestamp"},"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"S16t":{"type":"structure","members":{"Groups":{"shape":"Sim","locationName":"groupSet"},"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiLaunchIndex":{"locationName":"amiLaunchIndex","type":"integer"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"LaunchTime":{"locationName":"launchTime","type":"timestamp"},"Monitoring":{"shape":"S16w","locationName":"monitoring"},"Placement":{"shape":"Sak","locationName":"placement"},"Platform":{"locationName":"platform"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ProductCodes":{"shape":"S10e","locationName":"productCodes"},"PublicDnsName":{"locationName":"dnsName"},"PublicIpAddress":{"locationName":"ipAddress"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"shape":"S13n","locationName":"instanceState"},"StateTransitionReason":{"locationName":"reason"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"S12y","locationName":"blockDeviceMapping"},"ClientToken":{"locationName":"clientToken"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"IamInstanceProfile":{"shape":"S39","locationName":"iamInstanceProfile"},"InstanceLifecycle":{"locationName":"instanceLifecycle"},"ElasticGpuAssociations":{"locationName":"elasticGpuAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"ElasticGpuAssociationId":{"locationName":"elasticGpuAssociationId"},"ElasticGpuAssociationState":{"locationName":"elasticGpuAssociationState"},"ElasticGpuAssociationTime":{"locationName":"elasticGpuAssociationTime"}}}},"ElasticInferenceAcceleratorAssociations":{"locationName":"elasticInferenceAcceleratorAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticInferenceAcceleratorArn":{"locationName":"elasticInferenceAcceleratorArn"},"ElasticInferenceAcceleratorAssociationId":{"locationName":"elasticInferenceAcceleratorAssociationId"},"ElasticInferenceAcceleratorAssociationState":{"locationName":"elasticInferenceAcceleratorAssociationState"},"ElasticInferenceAcceleratorAssociationTime":{"locationName":"elasticInferenceAcceleratorAssociationTime","type":"timestamp"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"S175","locationName":"association"},"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Status":{"locationName":"status"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"}}},"Description":{"locationName":"description"},"Groups":{"shape":"Sim","locationName":"groupSet"},"Ipv6Addresses":{"shape":"Sfv","locationName":"ipv6AddressesSet"},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"S175","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"InterfaceType":{"locationName":"interfaceType"},"Ipv4Prefixes":{"locationName":"ipv4PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{"locationName":"ipv4Prefix"}}}},"Ipv6Prefixes":{"locationName":"ipv6PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{"locationName":"ipv6Prefix"}}}}}}},"OutpostArn":{"locationName":"outpostArn"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SecurityGroups":{"shape":"Sim","locationName":"groupSet"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"S12a","locationName":"stateReason"},"Tags":{"shape":"Ss","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"}}},"CapacityReservationId":{"locationName":"capacityReservationId"},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"Sge","locationName":"capacityReservationTarget"}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"Licenses":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"MetadataOptions":{"shape":"S17i","locationName":"metadataOptions"},"EnclaveOptions":{"shape":"S132","locationName":"enclaveOptions"},"BootMode":{"locationName":"bootMode"},"PlatformDetails":{"locationName":"platformDetails"},"UsageOperation":{"locationName":"usageOperation"},"UsageOperationUpdateTime":{"locationName":"usageOperationUpdateTime","type":"timestamp"},"PrivateDnsNameOptions":{"locationName":"privateDnsNameOptions","type":"structure","members":{"HostnameType":{"locationName":"hostnameType"},"EnableResourceNameDnsARecord":{"locationName":"enableResourceNameDnsARecord","type":"boolean"},"EnableResourceNameDnsAAAARecord":{"locationName":"enableResourceNameDnsAAAARecord","type":"boolean"}}},"Ipv6Address":{"locationName":"ipv6Address"},"MaintenanceOptions":{"locationName":"maintenanceOptions","type":"structure","members":{"AutoRecovery":{"locationName":"autoRecovery"}}}}}},"OwnerId":{"locationName":"ownerId"},"RequesterId":{"locationName":"requesterId"},"ReservationId":{"locationName":"reservationId"}}},"S16w":{"type":"structure","members":{"State":{"locationName":"state"}}},"S175":{"type":"structure","members":{"CarrierIp":{"locationName":"carrierIp"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"S17i":{"type":"structure","members":{"State":{"locationName":"state"},"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"},"HttpProtocolIpv6":{"locationName":"httpProtocolIpv6"},"InstanceMetadataTags":{"locationName":"instanceMetadataTags"}}},"S19e":{"type":"list","member":{"locationName":"item"}},"S1ae":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"},"NetworkInsightsAccessScopeAnalysisArn":{"locationName":"networkInsightsAccessScopeAnalysisArn"},"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"WarningMessage":{"locationName":"warningMessage"},"StartDate":{"locationName":"startDate","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"FindingsFound":{"locationName":"findingsFound"},"AnalyzedEniCount":{"locationName":"analyzedEniCount","type":"integer"},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S1ap":{"type":"structure","members":{"NetworkInsightsAnalysisId":{"locationName":"networkInsightsAnalysisId"},"NetworkInsightsAnalysisArn":{"locationName":"networkInsightsAnalysisArn"},"NetworkInsightsPathId":{"locationName":"networkInsightsPathId"},"FilterInArns":{"shape":"S1aq","locationName":"filterInArnSet"},"StartDate":{"locationName":"startDate","type":"timestamp"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"WarningMessage":{"locationName":"warningMessage"},"NetworkPathFound":{"locationName":"networkPathFound","type":"boolean"},"ForwardPathComponents":{"shape":"S1ar","locationName":"forwardPathComponentSet"},"ReturnPathComponents":{"shape":"S1ar","locationName":"returnPathComponentSet"},"Explanations":{"locationName":"explanationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Acl":{"shape":"S1au","locationName":"acl"},"AclRule":{"shape":"S1at","locationName":"aclRule"},"Address":{"locationName":"address"},"Addresses":{"shape":"S1aw","locationName":"addressSet"},"AttachedTo":{"shape":"S1au","locationName":"attachedTo"},"AvailabilityZones":{"shape":"Se","locationName":"availabilityZoneSet"},"Cidrs":{"shape":"Se","locationName":"cidrSet"},"Component":{"shape":"S1au","locationName":"component"},"CustomerGateway":{"shape":"S1au","locationName":"customerGateway"},"Destination":{"shape":"S1au","locationName":"destination"},"DestinationVpc":{"shape":"S1au","locationName":"destinationVpc"},"Direction":{"locationName":"direction"},"ExplanationCode":{"locationName":"explanationCode"},"IngressRouteTable":{"shape":"S1au","locationName":"ingressRouteTable"},"InternetGateway":{"shape":"S1au","locationName":"internetGateway"},"LoadBalancerArn":{"locationName":"loadBalancerArn"},"ClassicLoadBalancerListener":{"locationName":"classicLoadBalancerListener","type":"structure","members":{"LoadBalancerPort":{"locationName":"loadBalancerPort","type":"integer"},"InstancePort":{"locationName":"instancePort","type":"integer"}}},"LoadBalancerListenerPort":{"locationName":"loadBalancerListenerPort","type":"integer"},"LoadBalancerTarget":{"locationName":"loadBalancerTarget","type":"structure","members":{"Address":{"locationName":"address"},"AvailabilityZone":{"locationName":"availabilityZone"},"Instance":{"shape":"S1au","locationName":"instance"},"Port":{"locationName":"port","type":"integer"}}},"LoadBalancerTargetGroup":{"shape":"S1au","locationName":"loadBalancerTargetGroup"},"LoadBalancerTargetGroups":{"shape":"S1b7","locationName":"loadBalancerTargetGroupSet"},"LoadBalancerTargetPort":{"locationName":"loadBalancerTargetPort","type":"integer"},"ElasticLoadBalancerListener":{"shape":"S1au","locationName":"elasticLoadBalancerListener"},"MissingComponent":{"locationName":"missingComponent"},"NatGateway":{"shape":"S1au","locationName":"natGateway"},"NetworkInterface":{"shape":"S1au","locationName":"networkInterface"},"PacketField":{"locationName":"packetField"},"VpcPeeringConnection":{"shape":"S1au","locationName":"vpcPeeringConnection"},"Port":{"locationName":"port","type":"integer"},"PortRanges":{"shape":"S1ax","locationName":"portRangeSet"},"PrefixList":{"shape":"S1au","locationName":"prefixList"},"Protocols":{"locationName":"protocolSet","type":"list","member":{"locationName":"item"}},"RouteTableRoute":{"shape":"S1ay","locationName":"routeTableRoute"},"RouteTable":{"shape":"S1au","locationName":"routeTable"},"SecurityGroup":{"shape":"S1au","locationName":"securityGroup"},"SecurityGroupRule":{"shape":"S1az","locationName":"securityGroupRule"},"SecurityGroups":{"shape":"S1b7","locationName":"securityGroupSet"},"SourceVpc":{"shape":"S1au","locationName":"sourceVpc"},"State":{"locationName":"state"},"Subnet":{"shape":"S1au","locationName":"subnet"},"SubnetRouteTable":{"shape":"S1au","locationName":"subnetRouteTable"},"Vpc":{"shape":"S1au","locationName":"vpc"},"VpcEndpoint":{"shape":"S1au","locationName":"vpcEndpoint"},"VpnConnection":{"shape":"S1au","locationName":"vpnConnection"},"VpnGateway":{"shape":"S1au","locationName":"vpnGateway"},"TransitGateway":{"shape":"S1au","locationName":"transitGateway"},"TransitGatewayRouteTable":{"shape":"S1au","locationName":"transitGatewayRouteTable"},"TransitGatewayRouteTableRoute":{"shape":"S1b2","locationName":"transitGatewayRouteTableRoute"},"TransitGatewayAttachment":{"shape":"S1au","locationName":"transitGatewayAttachment"}}}},"AlternatePathHints":{"locationName":"alternatePathHintSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ComponentId":{"locationName":"componentId"},"ComponentArn":{"locationName":"componentArn"}}}},"Tags":{"shape":"Ss","locationName":"tagSet"}}},"S1aq":{"type":"list","member":{"locationName":"item"}},"S1ar":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SequenceNumber":{"locationName":"sequenceNumber","type":"integer"},"AclRule":{"shape":"S1at","locationName":"aclRule"},"AttachedTo":{"shape":"S1au","locationName":"attachedTo"},"Component":{"shape":"S1au","locationName":"component"},"DestinationVpc":{"shape":"S1au","locationName":"destinationVpc"},"OutboundHeader":{"shape":"S1av","locationName":"outboundHeader"},"InboundHeader":{"shape":"S1av","locationName":"inboundHeader"},"RouteTableRoute":{"shape":"S1ay","locationName":"routeTableRoute"},"SecurityGroupRule":{"shape":"S1az","locationName":"securityGroupRule"},"SourceVpc":{"shape":"S1au","locationName":"sourceVpc"},"Subnet":{"shape":"S1au","locationName":"subnet"},"Vpc":{"shape":"S1au","locationName":"vpc"},"AdditionalDetails":{"locationName":"additionalDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AdditionalDetailType":{"locationName":"additionalDetailType"},"Component":{"shape":"S1au","locationName":"component"}}}},"TransitGateway":{"shape":"S1au","locationName":"transitGateway"},"TransitGatewayRouteTableRoute":{"shape":"S1b2","locationName":"transitGatewayRouteTableRoute"}}}},"S1at":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Egress":{"locationName":"egress","type":"boolean"},"PortRange":{"shape":"Shk","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}},"S1au":{"type":"structure","members":{"Id":{"locationName":"id"},"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S1av":{"type":"structure","members":{"DestinationAddresses":{"shape":"S1aw","locationName":"destinationAddressSet"},"DestinationPortRanges":{"shape":"S1ax","locationName":"destinationPortRangeSet"},"Protocol":{"locationName":"protocol"},"SourceAddresses":{"shape":"S1aw","locationName":"sourceAddressSet"},"SourcePortRanges":{"shape":"S1ax","locationName":"sourcePortRangeSet"}}},"S1aw":{"type":"list","member":{"locationName":"item"}},"S1ax":{"type":"list","member":{"shape":"Shk","locationName":"item"}},"S1ay":{"type":"structure","members":{"DestinationCidr":{"locationName":"destinationCidr"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"TransitGatewayId":{"locationName":"transitGatewayId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S1az":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Direction":{"locationName":"direction"},"SecurityGroupId":{"locationName":"securityGroupId"},"PortRange":{"shape":"Shk","locationName":"portRange"},"PrefixListId":{"locationName":"prefixListId"},"Protocol":{"locationName":"protocol"}}},"S1b2":{"type":"structure","members":{"DestinationCidr":{"locationName":"destinationCidr"},"State":{"locationName":"state"},"RouteOrigin":{"locationName":"routeOrigin"},"PrefixListId":{"locationName":"prefixListId"},"AttachmentId":{"locationName":"attachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"}}},"S1b7":{"type":"list","member":{"shape":"S1au","locationName":"item"}},"S1cg":{"type":"structure","members":{"FirstAddress":{"locationName":"firstAddress"},"LastAddress":{"locationName":"lastAddress"},"AddressCount":{"locationName":"addressCount","type":"integer"},"AvailableAddressCount":{"locationName":"availableAddressCount","type":"integer"}}},"S1ct":{"type":"list","member":{"locationName":"ReservedInstancesId"}},"S1d1":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"Frequency":{"locationName":"frequency"}}}},"S1df":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"},"Scope":{"locationName":"scope"}}},"S1e2":{"type":"structure","members":{"Frequency":{"locationName":"frequency"},"Interval":{"locationName":"interval","type":"integer"},"OccurrenceDaySet":{"locationName":"occurrenceDaySet","type":"list","member":{"locationName":"item","type":"integer"}},"OccurrenceRelativeToEnd":{"locationName":"occurrenceRelativeToEnd","type":"boolean"},"OccurrenceUnit":{"locationName":"occurrenceUnit"}}},"S1ea":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"NetworkPlatform":{"locationName":"networkPlatform"},"NextSlotStartTime":{"locationName":"nextSlotStartTime","type":"timestamp"},"Platform":{"locationName":"platform"},"PreviousSlotEndTime":{"locationName":"previousSlotEndTime","type":"timestamp"},"Recurrence":{"shape":"S1e2","locationName":"recurrence"},"ScheduledInstanceId":{"locationName":"scheduledInstanceId"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TermEndDate":{"locationName":"termEndDate","type":"timestamp"},"TermStartDate":{"locationName":"termStartDate","type":"timestamp"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}},"S1eh":{"type":"list","member":{"locationName":"item"}},"S1el":{"type":"list","member":{"locationName":"GroupName"}},"S1et":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"S1f3":{"type":"list","member":{"locationName":"SnapshotId"}},"S1fm":{"type":"structure","required":["IamFleetRole","TargetCapacity"],"members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"OnDemandAllocationStrategy":{"locationName":"onDemandAllocationStrategy"},"SpotMaintenanceStrategies":{"locationName":"spotMaintenanceStrategies","type":"structure","members":{"CapacityRebalance":{"locationName":"capacityRebalance","type":"structure","members":{"ReplacementStrategy":{"locationName":"replacementStrategy"},"TerminationDelay":{"locationName":"terminationDelay","type":"integer"}}}}},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"OnDemandFulfilledCapacity":{"locationName":"onDemandFulfilledCapacity","type":"double"},"IamFleetRole":{"locationName":"iamFleetRole"},"LaunchSpecifications":{"locationName":"launchSpecifications","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroups":{"shape":"Sim","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"S11w","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S36","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"NetworkInterfaces":{"shape":"S1fw","locationName":"networkInterfaceSet"},"Placement":{"shape":"S1fy","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Ss","locationName":"tag"}}}},"InstanceRequirements":{"shape":"Sbo","locationName":"instanceRequirements"}}}},"LaunchTemplateConfigs":{"shape":"S1g1","locationName":"launchTemplateConfigs"},"SpotPrice":{"locationName":"spotPrice"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"OnDemandMaxTotalPrice":{"locationName":"onDemandMaxTotalPrice"},"SpotMaxTotalPrice":{"locationName":"spotMaxTotalPrice"},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"LoadBalancersConfig":{"locationName":"loadBalancersConfig","type":"structure","members":{"ClassicLoadBalancersConfig":{"locationName":"classicLoadBalancersConfig","type":"structure","members":{"ClassicLoadBalancers":{"locationName":"classicLoadBalancers","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"}}}}}},"TargetGroupsConfig":{"locationName":"targetGroupsConfig","type":"structure","members":{"TargetGroups":{"locationName":"targetGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"}}}}}}}},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"Context":{"locationName":"context"},"TargetCapacityUnitType":{"locationName":"targetCapacityUnitType"},"TagSpecifications":{"shape":"S1t","locationName":"TagSpecification"}}},"S1fw":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"Se7","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Sfv","locationName":"ipv6AddressesSet","queryName":"Ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"Sea","locationName":"privateIpAddressesSet","queryName":"PrivateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"},"AssociateCarrierIpAddress":{"type":"boolean"},"InterfaceType":{},"NetworkCardIndex":{"type":"integer"},"Ipv4Prefixes":{"shape":"Sec","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"See","locationName":"Ipv6Prefix"},"Ipv6PrefixCount":{"type":"integer"}}}},"S1fy":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"GroupName":{"locationName":"groupName"},"Tenancy":{"locationName":"tenancy"}}},"S1g1":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sbl","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"},"InstanceRequirements":{"shape":"Sbo","locationName":"instanceRequirements"}}}}}}},"S1ge":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ActualBlockHourlyPrice":{"locationName":"actualBlockHourlyPrice"},"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Fault":{"shape":"Skg","locationName":"fault"},"InstanceId":{"locationName":"instanceId"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"UserData":{"locationName":"userData"},"SecurityGroups":{"shape":"Sim","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"S11w","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S36","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"NetworkInterfaces":{"shape":"S1fw","locationName":"networkInterfaceSet"},"Placement":{"shape":"S1fy","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"Monitoring":{"shape":"S1gh","locationName":"monitoring"}}},"LaunchedAvailabilityZone":{"locationName":"launchedAvailabilityZone"},"ProductDescription":{"locationName":"productDescription"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SpotPrice":{"locationName":"spotPrice"},"State":{"locationName":"state"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"Tags":{"shape":"Ss","locationName":"tagSet"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}},"S1gh":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"S1gw":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item"}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item"}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S5h","locationName":"item"}}}}},"S1hu":{"type":"list","member":{}},"S1iy":{"type":"list","member":{"locationName":"VolumeId"}},"S1jj":{"type":"structure","members":{"VolumeId":{"locationName":"volumeId"},"ModificationState":{"locationName":"modificationState"},"StatusMessage":{"locationName":"statusMessage"},"TargetSize":{"locationName":"targetSize","type":"integer"},"TargetIops":{"locationName":"targetIops","type":"integer"},"TargetVolumeType":{"locationName":"targetVolumeType"},"TargetThroughput":{"locationName":"targetThroughput","type":"integer"},"TargetMultiAttachEnabled":{"locationName":"targetMultiAttachEnabled","type":"boolean"},"OriginalSize":{"locationName":"originalSize","type":"integer"},"OriginalIops":{"locationName":"originalIops","type":"integer"},"OriginalVolumeType":{"locationName":"originalVolumeType"},"OriginalThroughput":{"locationName":"originalThroughput","type":"integer"},"OriginalMultiAttachEnabled":{"locationName":"originalMultiAttachEnabled","type":"boolean"},"Progress":{"locationName":"progress","type":"long"},"StartTime":{"locationName":"startTime","type":"timestamp"},"EndTime":{"locationName":"endTime","type":"timestamp"}}},"S1jp":{"type":"list","member":{"locationName":"VpcId"}},"S1lh":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S1ly":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"S1om":{"type":"structure","members":{"InstanceFamily":{"locationName":"instanceFamily"},"CpuCredits":{"locationName":"cpuCredits"}}},"S1p3":{"type":"list","member":{"locationName":"item"}},"S1p5":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HostIdSet":{"shape":"S114","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"S1p8":{"type":"list","member":{"locationName":"item"}},"S1p9":{"type":"list","member":{"locationName":"item"}},"S1pw":{"type":"structure","members":{"IpamId":{"locationName":"ipamId"},"IpamScopeId":{"locationName":"ipamScopeId"},"IpamPoolId":{"locationName":"ipamPoolId"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceId":{"locationName":"resourceId"},"ResourceName":{"locationName":"resourceName"},"ResourceCidr":{"locationName":"resourceCidr"},"ResourceType":{"locationName":"resourceType"},"ResourceTags":{"shape":"Sdm","locationName":"resourceTagSet"},"IpUsage":{"locationName":"ipUsage","type":"double"},"ComplianceStatus":{"locationName":"complianceStatus"},"ManagementState":{"locationName":"managementState"},"OverlapStatus":{"locationName":"overlapStatus"},"VpcId":{"locationName":"vpcId"}}},"S1qk":{"type":"structure","members":{"HourlyPrice":{"locationName":"hourlyPrice"},"RemainingTotalValue":{"locationName":"remainingTotalValue"},"RemainingUpfrontValue":{"locationName":"remainingUpfrontValue"}}},"S1r4":{"type":"list","member":{"shape":"Skr","locationName":"item"}},"S1s0":{"type":"structure","members":{"Comment":{},"UploadEnd":{"type":"timestamp"},"UploadSize":{"type":"double"},"UploadStart":{"type":"timestamp"}}},"S1s3":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S1sa":{"type":"structure","required":["Bytes","Format","ImportManifestUrl"],"members":{"Bytes":{"locationName":"bytes","type":"long"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"}}},"S1sb":{"type":"structure","required":["Size"],"members":{"Size":{"locationName":"size","type":"long"}}},"S1tg":{"type":"list","member":{"locationName":"UserId"}},"S1th":{"type":"list","member":{"locationName":"UserGroup"}},"S1ti":{"type":"list","member":{"locationName":"ProductCode"}},"S1tk":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{},"UserId":{}}}},"S1tp":{"type":"list","member":{"shape":"S17","locationName":"item"}},"S1u2":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"Sf3"}}},"S1wn":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"type":"boolean"}}},"S1wp":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"S1x4":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Monitoring":{"shape":"S16w","locationName":"monitoring"}}}},"S20q":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S21e":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentState":{"shape":"S13n","locationName":"currentState"},"InstanceId":{"locationName":"instanceId"},"PreviousState":{"shape":"S13n","locationName":"previousState"}}}},"S220":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroupRuleId":{},"Description":{}}}}}}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAccountAttributes":{"result_key":"AccountAttributes"},"DescribeAddresses":{"result_key":"Addresses"},"DescribeAddressesAttribute":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Addresses"},"DescribeAvailabilityZones":{"result_key":"AvailabilityZones"},"DescribeBundleTasks":{"result_key":"BundleTasks"},"DescribeByoipCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ByoipCidrs"},"DescribeCapacityReservationFleets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservationFleets"},"DescribeCapacityReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservations"},"DescribeCarrierGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CarrierGateways"},"DescribeClassicLinkInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Instances"},"DescribeClientVpnAuthorizationRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthorizationRules"},"DescribeClientVpnConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Connections"},"DescribeClientVpnEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnEndpoints"},"DescribeClientVpnRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"DescribeClientVpnTargetNetworks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnTargetNetworks"},"DescribeCoipPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CoipPools"},"DescribeConversionTasks":{"result_key":"ConversionTasks"},"DescribeCustomerGateways":{"result_key":"CustomerGateways"},"DescribeDhcpOptions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DhcpOptions"},"DescribeEgressOnlyInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EgressOnlyInternetGateways"},"DescribeExportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ExportImageTasks"},"DescribeExportTasks":{"result_key":"ExportTasks"},"DescribeFastLaunchImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FastLaunchImages"},"DescribeFastSnapshotRestores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FastSnapshotRestores"},"DescribeFleets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fleets"},"DescribeFlowLogs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FlowLogs"},"DescribeFpgaImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FpgaImages"},"DescribeHostReservationOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OfferingSet"},"DescribeHostReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HostReservationSet"},"DescribeHosts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Hosts"},"DescribeIamInstanceProfileAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IamInstanceProfileAssociations"},"DescribeImages":{"result_key":"Images"},"DescribeImportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportImageTasks"},"DescribeImportSnapshotTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportSnapshotTasks"},"DescribeInstanceCreditSpecifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceCreditSpecifications"},"DescribeInstanceEventWindows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceEventWindows"},"DescribeInstanceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceStatuses"},"DescribeInstanceTypeOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypeOfferings"},"DescribeInstanceTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypes"},"DescribeInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Reservations"},"DescribeInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InternetGateways"},"DescribeIpamPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamPools"},"DescribeIpamScopes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamScopes"},"DescribeIpams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipams"},"DescribeIpv6Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipv6Pools"},"DescribeKeyPairs":{"result_key":"KeyPairs"},"DescribeLaunchTemplateVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplateVersions"},"DescribeLaunchTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplates"},"DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTableVirtualInterfaceGroupAssociations"},"DescribeLocalGatewayRouteTableVpcAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTableVpcAssociations"},"DescribeLocalGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTables"},"DescribeLocalGatewayVirtualInterfaceGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayVirtualInterfaceGroups"},"DescribeLocalGatewayVirtualInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayVirtualInterfaces"},"DescribeLocalGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGateways"},"DescribeManagedPrefixLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixLists"},"DescribeMovingAddresses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MovingAddressStatuses"},"DescribeNatGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NatGateways"},"DescribeNetworkAcls":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkAcls"},"DescribeNetworkInsightsAccessScopeAnalyses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsAccessScopeAnalyses"},"DescribeNetworkInsightsAccessScopes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsAccessScopes"},"DescribeNetworkInsightsAnalyses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsAnalyses"},"DescribeNetworkInsightsPaths":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsPaths"},"DescribeNetworkInterfacePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfacePermissions"},"DescribeNetworkInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfaces"},"DescribePlacementGroups":{"result_key":"PlacementGroups"},"DescribePrefixLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixLists"},"DescribePrincipalIdFormat":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Principals"},"DescribePublicIpv4Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PublicIpv4Pools"},"DescribeRegions":{"result_key":"Regions"},"DescribeReplaceRootVolumeTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReplaceRootVolumeTasks"},"DescribeReservedInstances":{"result_key":"ReservedInstances"},"DescribeReservedInstancesListings":{"result_key":"ReservedInstancesListings"},"DescribeReservedInstancesModifications":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReservedInstancesModifications"},"DescribeReservedInstancesOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReservedInstancesOfferings"},"DescribeRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RouteTables"},"DescribeScheduledInstanceAvailability":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceAvailabilitySet"},"DescribeScheduledInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceSet"},"DescribeSecurityGroupRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroupRules"},"DescribeSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroups"},"DescribeSnapshotTierStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SnapshotTierStatuses"},"DescribeSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"DescribeSpotFleetRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotFleetRequestConfigs"},"DescribeSpotInstanceRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotInstanceRequests"},"DescribeSpotPriceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPriceHistory"},"DescribeStaleSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StaleSecurityGroupSet"},"DescribeStoreImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StoreImageTaskResults"},"DescribeSubnets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Subnets"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"DescribeTrafficMirrorFilters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorFilters"},"DescribeTrafficMirrorSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorSessions"},"DescribeTrafficMirrorTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorTargets"},"DescribeTransitGatewayAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachments"},"DescribeTransitGatewayConnectPeers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayConnectPeers"},"DescribeTransitGatewayConnects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayConnects"},"DescribeTransitGatewayMulticastDomains":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayMulticastDomains"},"DescribeTransitGatewayPeeringAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayPeeringAttachments"},"DescribeTransitGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTables"},"DescribeTransitGatewayVpcAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayVpcAttachments"},"DescribeTransitGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGateways"},"DescribeTrunkInterfaceAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InterfaceAssociations"},"DescribeVolumeStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumeStatuses"},"DescribeVolumes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Volumes"},"DescribeVolumesModifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumesModifications"},"DescribeVpcClassicLinkDnsSupport":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpcEndpointConnectionNotifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ConnectionNotificationSet"},"DescribeVpcEndpointConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpointConnections"},"DescribeVpcEndpointServiceConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServiceConfigurations"},"DescribeVpcEndpointServicePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AllowedPrincipals"},"DescribeVpcEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpoints"},"DescribeVpcPeeringConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcPeeringConnections"},"DescribeVpcs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpnConnections":{"result_key":"VpnConnections"},"DescribeVpnGateways":{"result_key":"VpnGateways"},"GetAssociatedIpv6PoolCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipv6CidrAssociations"},"GetGroupsForCapacityReservation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservationGroups"},"GetInstanceTypesFromInstanceRequirements":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypes"},"GetIpamAddressHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HistoryRecords"},"GetIpamPoolAllocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamPoolAllocations"},"GetIpamPoolCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamPoolCidrs"},"GetIpamResourceCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamResourceCidrs"},"GetManagedPrefixListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixListAssociations"},"GetManagedPrefixListEntries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Entries"},"GetSpotPlacementScores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPlacementScores"},"GetTransitGatewayAttachmentPropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachmentPropagations"},"GetTransitGatewayMulticastDomainAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MulticastDomainAssociations"},"GetTransitGatewayPrefixListReferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayPrefixListReferences"},"GetTransitGatewayRouteTableAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"GetTransitGatewayRouteTablePropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTablePropagations"},"GetVpnConnectionDeviceTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpnConnectionDeviceTypes"},"ListImagesInRecycleBin":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Images"},"ListSnapshotsInRecycleBin":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"SearchLocalGatewayRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"SearchTransitGatewayMulticastGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MulticastGroups"}}}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"InstanceExists":{"delay":5,"maxAttempts":40,"operation":"DescribeInstances","acceptors":[{"matcher":"path","expected":true,"argument":"length(Reservations[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"BundleTaskComplete":{"delay":15,"operation":"DescribeBundleTasks","maxAttempts":40,"acceptors":[{"expected":"complete","matcher":"pathAll","state":"success","argument":"BundleTasks[].State"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"BundleTasks[].State"}]},"ConversionTaskCancelled":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"ConversionTaskCompleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"},{"expected":"cancelled","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"},{"expected":"cancelling","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"}]},"ConversionTaskDeleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"CustomerGatewayAvailable":{"delay":15,"operation":"DescribeCustomerGateways","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"CustomerGateways[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"}]},"ExportTaskCancelled":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ExportTaskCompleted":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ImageExists":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"matcher":"path","expected":true,"argument":"length(Images[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidAMIID.NotFound","state":"retry"}]},"ImageAvailable":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Images[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"Images[].State","expected":"failed"}]},"InstanceRunning":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"running","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"shutting-down","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].InstanceStatus.Status","expected":"ok"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InternetGatewayExists":{"operation":"DescribeInternetGateways","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(InternetGateways[].InternetGatewayId) > `0`"},{"expected":"InvalidInternetGateway.NotFound","matcher":"error","state":"retry"}]},"KeyPairExists":{"operation":"DescribeKeyPairs","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(KeyPairs[].KeyName) > `0`"},{"expected":"InvalidKeyPair.NotFound","matcher":"error","state":"retry"}]},"NatGatewayAvailable":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"failed"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleting"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleted"},{"state":"retry","matcher":"error","expected":"NatGatewayNotFound"}]},"NatGatewayDeleted":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"deleted"},{"state":"success","matcher":"error","expected":"NatGatewayNotFound"}]},"NetworkInterfaceAvailable":{"operation":"DescribeNetworkInterfaces","delay":20,"maxAttempts":10,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"NetworkInterfaces[].Status"},{"expected":"InvalidNetworkInterfaceID.NotFound","matcher":"error","state":"failure"}]},"PasswordDataAvailable":{"operation":"GetPasswordData","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"path","argument":"length(PasswordData) > `0`","expected":true}]},"SnapshotCompleted":{"delay":15,"operation":"DescribeSnapshots","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"Snapshots[].State"},{"expected":"error","matcher":"pathAny","state":"failure","argument":"Snapshots[].State"}]},"SecurityGroupExists":{"operation":"DescribeSecurityGroups","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(SecurityGroups[].GroupId) > `0`"},{"expected":"InvalidGroup.NotFound","matcher":"error","state":"retry"}]},"SpotInstanceRequestFulfilled":{"operation":"DescribeSpotInstanceRequests","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"fulfilled"},{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"request-canceled-and-instance-running"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"schedule-expired"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"canceled-before-fulfillment"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"bad-parameters"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"system-error"},{"state":"retry","matcher":"error","expected":"InvalidSpotInstanceRequestID.NotFound"}]},"SubnetAvailable":{"delay":15,"operation":"DescribeSubnets","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Subnets[].State"}]},"SystemStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].SystemStatus.Status","expected":"ok"}]},"VolumeAvailable":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VolumeDeleted":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"matcher":"error","expected":"InvalidVolume.NotFound","state":"success"}]},"VolumeInUse":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"in-use","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VpcAvailable":{"delay":15,"operation":"DescribeVpcs","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Vpcs[].State"}]},"VpcExists":{"operation":"DescribeVpcs","delay":1,"maxAttempts":5,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcID.NotFound","state":"retry"}]},"VpnConnectionAvailable":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpnConnectionDeleted":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpcPeeringConnectionExists":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"retry"}]},"VpcPeeringConnectionDeleted":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpcPeeringConnections[].Status.Code"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"success"}]}}}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ecr'] = {};
	AWS.ECR = Service.defineService('ecr', ['2015-09-21']);
	Object.defineProperty(apiLoader.services['ecr'], '2015-09-21', {
	  get: function get() {
	    var model = __webpack_require__(198);
	    model.paginators = __webpack_require__(199).pagination;
	    model.waiters = __webpack_require__(200).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ECR;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-09-21","endpointPrefix":"api.ecr","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECR","serviceFullName":"Amazon EC2 Container Registry","serviceId":"ECR","signatureVersion":"v4","signingName":"ecr","targetPrefix":"AmazonEC2ContainerRegistry_V20150921","uid":"ecr-2015-09-21"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"failures":{"shape":"Sn"}}}},"BatchGetImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"acceptedMediaTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"images":{"type":"list","member":{"shape":"Sv"}},"failures":{"shape":"Sn"}}}},"BatchGetRepositoryScanningConfiguration":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"scanningConfigurations":{"type":"list","member":{"type":"structure","members":{"repositoryArn":{},"repositoryName":{},"scanOnPush":{"type":"boolean"},"scanFrequency":{},"appliedScanFilters":{"shape":"S15"}}}},"failures":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"failureCode":{},"failureReason":{}}}}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreatePullThroughCacheRule":{"input":{"type":"structure","required":["ecrRepositoryPrefix","upstreamRegistryUrl"],"members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"registryId":{}}},"output":{"type":"structure","members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"createdAt":{"type":"timestamp"},"registryId":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"tags":{"shape":"S1n"},"imageTagMutability":{},"imageScanningConfiguration":{"shape":"S1s"},"encryptionConfiguration":{"shape":"S1t"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1x"}}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"DeletePullThroughCacheRule":{"input":{"type":"structure","required":["ecrRepositoryPrefix"],"members":{"ecrRepositoryPrefix":{},"registryId":{}}},"output":{"type":"structure","members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"createdAt":{"type":"timestamp"},"registryId":{}}}},"DeleteRegistryPolicy":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"policyText":{}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1x"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImageReplicationStatus":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"repositoryName":{},"imageId":{"shape":"Sj"},"registryId":{}}},"output":{"type":"structure","members":{"repositoryName":{},"imageId":{"shape":"Sj"},"replicationStatuses":{"type":"list","member":{"type":"structure","members":{"region":{},"registryId":{},"status":{},"failureCode":{}}}}}}},"DescribeImageScanFindings":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageScanStatus":{"shape":"S2o"},"imageScanFindings":{"type":"structure","members":{"imageScanCompletedAt":{"type":"timestamp"},"vulnerabilitySourceUpdatedAt":{"type":"timestamp"},"findingSeverityCounts":{"shape":"S2u"},"findings":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"uri":{},"severity":{},"attributes":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}},"enhancedFindings":{"type":"list","member":{"type":"structure","members":{"awsAccountId":{},"description":{},"findingArn":{},"firstObservedAt":{"type":"timestamp"},"lastObservedAt":{"type":"timestamp"},"packageVulnerabilityDetails":{"type":"structure","members":{"cvss":{"type":"list","member":{"type":"structure","members":{"baseScore":{"type":"double"},"scoringVector":{},"source":{},"version":{}}}},"referenceUrls":{"type":"list","member":{}},"relatedVulnerabilities":{"type":"list","member":{}},"source":{},"sourceUrl":{},"vendorCreatedAt":{"type":"timestamp"},"vendorSeverity":{},"vendorUpdatedAt":{"type":"timestamp"},"vulnerabilityId":{},"vulnerablePackages":{"type":"list","member":{"type":"structure","members":{"arch":{},"epoch":{"type":"integer"},"filePath":{},"name":{},"packageManager":{},"release":{},"sourceLayerHash":{},"version":{}}}}}},"remediation":{"type":"structure","members":{"recommendation":{"type":"structure","members":{"url":{},"text":{}}}}},"resources":{"type":"list","member":{"type":"structure","members":{"details":{"type":"structure","members":{"awsEcrContainerImage":{"type":"structure","members":{"architecture":{},"author":{},"imageHash":{},"imageTags":{"type":"list","member":{}},"platform":{},"pushedAt":{"type":"timestamp"},"registry":{},"repositoryName":{}}}}},"id":{},"tags":{"type":"map","key":{},"value":{}},"type":{}}}},"score":{"type":"double"},"scoreDetails":{"type":"structure","members":{"cvss":{"type":"structure","members":{"adjustments":{"type":"list","member":{"type":"structure","members":{"metric":{},"reason":{}}}},"score":{"type":"double"},"scoreSource":{},"scoringVector":{},"version":{}}}}},"severity":{},"status":{},"title":{},"type":{},"updatedAt":{"type":"timestamp"}}}}}},"nextToken":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"shape":"S4m"},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"},"imageScanStatus":{"shape":"S2o"},"imageScanFindingsSummary":{"type":"structure","members":{"imageScanCompletedAt":{"type":"timestamp"},"vulnerabilitySourceUpdatedAt":{"type":"timestamp"},"findingSeverityCounts":{"shape":"S2u"}}},"imageManifestMediaType":{},"artifactMediaType":{},"lastRecordedPullTime":{"type":"timestamp"}}}},"nextToken":{}}}},"DescribePullThroughCacheRules":{"input":{"type":"structure","members":{"registryId":{},"ecrRepositoryPrefixes":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"pullThroughCacheRules":{"type":"list","member":{"type":"structure","members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"createdAt":{"type":"timestamp"},"registryId":{}}}},"nextToken":{}}}},"DescribeRegistry":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"replicationConfiguration":{"shape":"S4y"}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1x"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{"registryIds":{"deprecated":true,"deprecatedMessage":"This field is deprecated. The returned authorization token can be used to access any Amazon ECR registry that the IAM principal has access to, specifying a registry ID doesn't change the permissions scope of the authorization token.","type":"list","member":{}}}},"output":{"type":"structure","members":{"authorizationData":{"type":"list","member":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"},"proxyEndpoint":{}}}}}}},"GetDownloadUrlForLayer":{"input":{"type":"structure","required":["repositoryName","layerDigest"],"members":{"registryId":{},"repositoryName":{},"layerDigest":{}}},"output":{"type":"structure","members":{"downloadUrl":{},"layerDigest":{}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"GetLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{},"nextToken":{},"previewResults":{"type":"list","member":{"type":"structure","members":{"imageTags":{"shape":"S4m"},"imageDigest":{},"imagePushedAt":{"type":"timestamp"},"action":{"type":"structure","members":{"type":{}}},"appliedRulePriority":{"type":"integer"}}}},"summary":{"type":"structure","members":{"expiringImageTotalCount":{"type":"integer"}}}}}},"GetRegistryPolicy":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"policyText":{}}}},"GetRegistryScanningConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"scanningConfiguration":{"shape":"S63"}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S1n"}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageManifestMediaType":{},"imageTag":{},"imageDigest":{}}},"output":{"type":"structure","members":{"image":{"shape":"Sv"}}}},"PutImageScanningConfiguration":{"input":{"type":"structure","required":["repositoryName","imageScanningConfiguration"],"members":{"registryId":{},"repositoryName":{},"imageScanningConfiguration":{"shape":"S1s"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageScanningConfiguration":{"shape":"S1s"}}}},"PutImageTagMutability":{"input":{"type":"structure","required":["repositoryName","imageTagMutability"],"members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName","lifecyclePolicyText"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}}},"PutRegistryPolicy":{"input":{"type":"structure","required":["policyText"],"members":{"policyText":{}}},"output":{"type":"structure","members":{"registryId":{},"policyText":{}}}},"PutRegistryScanningConfiguration":{"input":{"type":"structure","members":{"scanType":{},"rules":{"shape":"S65"}}},"output":{"type":"structure","members":{"registryScanningConfiguration":{"shape":"S63"}}}},"PutReplicationConfiguration":{"input":{"type":"structure","required":["replicationConfiguration"],"members":{"replicationConfiguration":{"shape":"S4y"}}},"output":{"type":"structure","members":{"replicationConfiguration":{"shape":"S4y"}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"StartImageScan":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageScanStatus":{"shape":"S2o"}}}},"StartLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}}},"shapes":{"Si":{"type":"list","member":{"shape":"Sj"}},"Sj":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sn":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sj"},"failureCode":{},"failureReason":{}}}},"Sv":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageManifest":{},"imageManifestMediaType":{}}},"S15":{"type":"list","member":{"type":"structure","required":["filter","filterType"],"members":{"filter":{},"filterType":{}}}},"S1n":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S1s":{"type":"structure","members":{"scanOnPush":{"type":"boolean"}}},"S1t":{"type":"structure","required":["encryptionType"],"members":{"encryptionType":{},"kmsKey":{}}},"S1x":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"},"imageTagMutability":{},"imageScanningConfiguration":{"shape":"S1s"},"encryptionConfiguration":{"shape":"S1t"}}},"S2o":{"type":"structure","members":{"status":{},"description":{}}},"S2u":{"type":"map","key":{},"value":{"type":"integer"}},"S4m":{"type":"list","member":{}},"S4y":{"type":"structure","required":["rules"],"members":{"rules":{"type":"list","member":{"type":"structure","required":["destinations"],"members":{"destinations":{"type":"list","member":{"type":"structure","required":["region","registryId"],"members":{"region":{},"registryId":{}}}},"repositoryFilters":{"type":"list","member":{"type":"structure","required":["filter","filterType"],"members":{"filter":{},"filterType":{}}}}}}}}},"S63":{"type":"structure","members":{"scanType":{},"rules":{"shape":"S65"}}},"S65":{"type":"list","member":{"type":"structure","required":["scanFrequency","repositoryFilters"],"members":{"scanFrequency":{},"repositoryFilters":{"shape":"S15"}}}}}}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeImageScanFindings":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["registryId","repositoryName","imageId","imageScanStatus","imageScanFindings"],"output_token":"nextToken","result_key":["imageScanFindings.findings","imageScanFindings.enhancedFindings"]},"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribePullThroughCacheRules":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"pullThroughCacheRules"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"},"GetLifecyclePolicyPreview":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["registryId","repositoryName","lifecyclePolicyText","status","summary"],"output_token":"nextToken","result_key":"previewResults"},"ListImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageIds"}}}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ImageScanComplete":{"description":"Wait until an image scan is complete and findings can be accessed","operation":"DescribeImageScanFindings","delay":5,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"imageScanStatus.status","expected":"COMPLETE"},{"state":"failure","matcher":"path","argument":"imageScanStatus.status","expected":"FAILED"}]},"LifecyclePolicyPreviewComplete":{"description":"Wait until a lifecycle policy preview request is complete and results can be accessed","operation":"GetLifecyclePolicyPreview","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"status","expected":"COMPLETE"},{"state":"failure","matcher":"path","argument":"status","expected":"FAILED"}]}}}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ecs'] = {};
	AWS.ECS = Service.defineService('ecs', ['2014-11-13']);
	Object.defineProperty(apiLoader.services['ecs'], '2014-11-13', {
	  get: function get() {
	    var model = __webpack_require__(202);
	    model.paginators = __webpack_require__(203).pagination;
	    model.waiters = __webpack_require__(204).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ECS;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-13","endpointPrefix":"ecs","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECS","serviceFullName":"Amazon EC2 Container Service","serviceId":"ECS","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerServiceV20141113","uid":"ecs-2014-11-13"},"operations":{"CreateCapacityProvider":{"input":{"type":"structure","required":["name","autoScalingGroupProvider"],"members":{"name":{},"autoScalingGroupProvider":{"shape":"S3"},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Sf"}}}},"CreateCluster":{"input":{"type":"structure","members":{"clusterName":{},"tags":{"shape":"Sa"},"settings":{"shape":"Sj"},"configuration":{"shape":"Sm"},"capacityProviders":{"shape":"Sr"},"defaultCapacityProviderStrategy":{"shape":"Ss"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sx"}}}},"CreateService":{"input":{"type":"structure","required":["serviceName"],"members":{"cluster":{},"serviceName":{},"taskDefinition":{},"loadBalancers":{"shape":"S15"},"serviceRegistries":{"shape":"S18"},"desiredCount":{"type":"integer"},"clientToken":{},"launchType":{},"capacityProviderStrategy":{"shape":"Ss"},"platformVersion":{},"role":{},"deploymentConfiguration":{"shape":"S1b"},"placementConstraints":{"shape":"S1d"},"placementStrategy":{"shape":"S1g"},"networkConfiguration":{"shape":"S1j"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"S1n"},"tags":{"shape":"Sa"},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{},"enableExecuteCommand":{"type":"boolean"}}},"output":{"type":"structure","members":{"service":{"shape":"S1r"}}}},"CreateTaskSet":{"input":{"type":"structure","required":["service","cluster","taskDefinition"],"members":{"service":{},"cluster":{},"externalId":{},"taskDefinition":{},"networkConfiguration":{"shape":"S1j"},"loadBalancers":{"shape":"S15"},"serviceRegistries":{"shape":"S18"},"launchType":{},"capacityProviderStrategy":{"shape":"Ss"},"platformVersion":{},"scale":{"shape":"S1v"},"clientToken":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1t"}}}},"DeleteAccountSetting":{"input":{"type":"structure","required":["name"],"members":{"name":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S29"}}}},"DeleteAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S2b"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S2b"}}}},"DeleteCapacityProvider":{"input":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Sf"}}}},"DeleteCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sx"}}}},"DeleteService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"service":{"shape":"S1r"}}}},"DeleteTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet"],"members":{"cluster":{},"service":{},"taskSet":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1t"}}}},"DeregisterContainerInstance":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S2q"}}}},"DeregisterTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S33"}}}},"DescribeCapacityProviders":{"input":{"type":"structure","members":{"capacityProviders":{"shape":"Sr"},"include":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"capacityProviders":{"type":"list","member":{"shape":"Sf"}},"failures":{"shape":"S5d"},"nextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"clusters":{"shape":"Sr"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"clusters":{"type":"list","member":{"shape":"Sx"}},"failures":{"shape":"S5d"}}}},"DescribeContainerInstances":{"input":{"type":"structure","required":["containerInstances"],"members":{"cluster":{},"containerInstances":{"shape":"Sr"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S5o"},"failures":{"shape":"S5d"}}}},"DescribeServices":{"input":{"type":"structure","required":["services"],"members":{"cluster":{},"services":{"shape":"Sr"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"shape":"S1r"}},"failures":{"shape":"S5d"}}}},"DescribeTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S33"},"tags":{"shape":"Sa"}}}},"DescribeTaskSets":{"input":{"type":"structure","required":["cluster","service"],"members":{"cluster":{},"service":{},"taskSets":{"shape":"Sr"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskSets":{"shape":"S1s"},"failures":{"shape":"S5d"}}}},"DescribeTasks":{"input":{"type":"structure","required":["tasks"],"members":{"cluster":{},"tasks":{"shape":"Sr"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"tasks":{"shape":"S66"},"failures":{"shape":"S5d"}}}},"DiscoverPollEndpoint":{"input":{"type":"structure","members":{"containerInstance":{},"cluster":{}}},"output":{"type":"structure","members":{"endpoint":{},"telemetryEndpoint":{}}}},"ExecuteCommand":{"input":{"type":"structure","required":["command","interactive","task"],"members":{"cluster":{},"container":{},"command":{},"interactive":{"type":"boolean"},"task":{}}},"output":{"type":"structure","members":{"clusterArn":{},"containerArn":{},"containerName":{},"interactive":{"type":"boolean"},"session":{"type":"structure","members":{"sessionId":{},"streamUrl":{},"tokenValue":{"type":"string","sensitive":true}}},"taskArn":{}}}},"ListAccountSettings":{"input":{"type":"structure","members":{"name":{},"value":{},"principalArn":{},"effectiveSettings":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"settings":{"type":"list","member":{"shape":"S29"}},"nextToken":{}}}},"ListAttributes":{"input":{"type":"structure","required":["targetType"],"members":{"cluster":{},"targetType":{},"attributeName":{},"attributeValue":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S2b"},"nextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"clusterArns":{"shape":"Sr"},"nextToken":{}}}},"ListContainerInstances":{"input":{"type":"structure","members":{"cluster":{},"filter":{},"nextToken":{},"maxResults":{"type":"integer"},"status":{}}},"output":{"type":"structure","members":{"containerInstanceArns":{"shape":"Sr"},"nextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"cluster":{},"nextToken":{},"maxResults":{"type":"integer"},"launchType":{},"schedulingStrategy":{}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"Sr"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sa"}}}},"ListTaskDefinitionFamilies":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"families":{"shape":"Sr"},"nextToken":{}}}},"ListTaskDefinitions":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"sort":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"taskDefinitionArns":{"shape":"Sr"},"nextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"cluster":{},"containerInstance":{},"family":{},"nextToken":{},"maxResults":{"type":"integer"},"startedBy":{},"serviceName":{},"desiredStatus":{},"launchType":{}}},"output":{"type":"structure","members":{"taskArns":{"shape":"Sr"},"nextToken":{}}}},"PutAccountSetting":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S29"}}}},"PutAccountSettingDefault":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S29"}}}},"PutAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S2b"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S2b"}}}},"PutClusterCapacityProviders":{"input":{"type":"structure","required":["cluster","capacityProviders","defaultCapacityProviderStrategy"],"members":{"cluster":{},"capacityProviders":{"shape":"Sr"},"defaultCapacityProviderStrategy":{"shape":"Ss"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sx"}}}},"RegisterContainerInstance":{"input":{"type":"structure","members":{"cluster":{},"instanceIdentityDocument":{},"instanceIdentityDocumentSignature":{},"totalResources":{"shape":"S2t"},"versionInfo":{"shape":"S2s"},"containerInstanceArn":{},"attributes":{"shape":"S2b"},"platformDevices":{"type":"list","member":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}}},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S2q"}}}},"RegisterTaskDefinition":{"input":{"type":"structure","required":["family","containerDefinitions"],"members":{"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"containerDefinitions":{"shape":"S34"},"volumes":{"shape":"S4e"},"placementConstraints":{"shape":"S4s"},"requiresCompatibilities":{"shape":"S4v"},"cpu":{},"memory":{},"tags":{"shape":"Sa"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S54"},"inferenceAccelerators":{"shape":"S50"},"ephemeralStorage":{"shape":"S57"},"runtimePlatform":{"shape":"S4x"}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S33"},"tags":{"shape":"Sa"}}}},"RunTask":{"input":{"type":"structure","required":["taskDefinition"],"members":{"capacityProviderStrategy":{"shape":"Ss"},"cluster":{},"count":{"type":"integer"},"enableECSManagedTags":{"type":"boolean"},"enableExecuteCommand":{"type":"boolean"},"group":{},"launchType":{},"networkConfiguration":{"shape":"S1j"},"overrides":{"shape":"S6k"},"placementConstraints":{"shape":"S1d"},"placementStrategy":{"shape":"S1g"},"platformVersion":{},"propagateTags":{},"referenceId":{},"startedBy":{},"tags":{"shape":"Sa"},"taskDefinition":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S66"},"failures":{"shape":"S5d"}}}},"StartTask":{"input":{"type":"structure","required":["containerInstances","taskDefinition"],"members":{"cluster":{},"containerInstances":{"shape":"Sr"},"enableECSManagedTags":{"type":"boolean"},"enableExecuteCommand":{"type":"boolean"},"group":{},"networkConfiguration":{"shape":"S1j"},"overrides":{"shape":"S6k"},"propagateTags":{},"referenceId":{},"startedBy":{},"tags":{"shape":"Sa"},"taskDefinition":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S66"},"failures":{"shape":"S5d"}}}},"StopTask":{"input":{"type":"structure","required":["task"],"members":{"cluster":{},"task":{},"reason":{}}},"output":{"type":"structure","members":{"task":{"shape":"S67"}}}},"SubmitAttachmentStateChanges":{"input":{"type":"structure","required":["attachments"],"members":{"cluster":{},"attachments":{"shape":"S85"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitContainerStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"containerName":{},"runtimeId":{},"status":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S6b"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitTaskStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"status":{},"reason":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerName":{},"imageDigest":{},"runtimeId":{},"exitCode":{"type":"integer"},"networkBindings":{"shape":"S6b"},"reason":{},"status":{}}}},"attachments":{"shape":"S85"},"managedAgents":{"type":"list","member":{"type":"structure","required":["containerName","managedAgentName","status"],"members":{"containerName":{},"managedAgentName":{},"status":{},"reason":{}}}},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCapacityProvider":{"input":{"type":"structure","required":["name","autoScalingGroupProvider"],"members":{"name":{},"autoScalingGroupProvider":{"type":"structure","members":{"managedScaling":{"shape":"S4"},"managedTerminationProtection":{}}}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Sf"}}}},"UpdateCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{},"settings":{"shape":"Sj"},"configuration":{"shape":"Sm"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sx"}}}},"UpdateClusterSettings":{"input":{"type":"structure","required":["cluster","settings"],"members":{"cluster":{},"settings":{"shape":"Sj"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sx"}}}},"UpdateContainerAgent":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S2q"}}}},"UpdateContainerInstancesState":{"input":{"type":"structure","required":["containerInstances","status"],"members":{"cluster":{},"containerInstances":{"shape":"Sr"},"status":{}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S5o"},"failures":{"shape":"S5d"}}}},"UpdateService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"desiredCount":{"type":"integer"},"taskDefinition":{},"capacityProviderStrategy":{"shape":"Ss"},"deploymentConfiguration":{"shape":"S1b"},"networkConfiguration":{"shape":"S1j"},"placementConstraints":{"shape":"S1d"},"placementStrategy":{"shape":"S1g"},"platformVersion":{},"forceNewDeployment":{"type":"boolean"},"healthCheckGracePeriodSeconds":{"type":"integer"},"enableExecuteCommand":{"type":"boolean"},"enableECSManagedTags":{"type":"boolean"},"loadBalancers":{"shape":"S15"},"propagateTags":{},"serviceRegistries":{"shape":"S18"}}},"output":{"type":"structure","members":{"service":{"shape":"S1r"}}}},"UpdateServicePrimaryTaskSet":{"input":{"type":"structure","required":["cluster","service","primaryTaskSet"],"members":{"cluster":{},"service":{},"primaryTaskSet":{}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1t"}}}},"UpdateTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet","scale"],"members":{"cluster":{},"service":{},"taskSet":{},"scale":{"shape":"S1v"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S1t"}}}}},"shapes":{"S3":{"type":"structure","required":["autoScalingGroupArn"],"members":{"autoScalingGroupArn":{},"managedScaling":{"shape":"S4"},"managedTerminationProtection":{}}},"S4":{"type":"structure","members":{"status":{},"targetCapacity":{"type":"integer"},"minimumScalingStepSize":{"type":"integer"},"maximumScalingStepSize":{"type":"integer"},"instanceWarmupPeriod":{"type":"integer"}}},"Sa":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Sf":{"type":"structure","members":{"capacityProviderArn":{},"name":{},"status":{},"autoScalingGroupProvider":{"shape":"S3"},"updateStatus":{},"updateStatusReason":{},"tags":{"shape":"Sa"}}},"Sj":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"Sm":{"type":"structure","members":{"executeCommandConfiguration":{"type":"structure","members":{"kmsKeyId":{},"logging":{},"logConfiguration":{"type":"structure","members":{"cloudWatchLogGroupName":{},"cloudWatchEncryptionEnabled":{"type":"boolean"},"s3BucketName":{},"s3EncryptionEnabled":{"type":"boolean"},"s3KeyPrefix":{}}}}}}},"Sr":{"type":"list","member":{}},"Ss":{"type":"list","member":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{},"weight":{"type":"integer"},"base":{"type":"integer"}}}},"Sx":{"type":"structure","members":{"clusterArn":{},"clusterName":{},"configuration":{"shape":"Sm"},"status":{},"registeredContainerInstancesCount":{"type":"integer"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"activeServicesCount":{"type":"integer"},"statistics":{"type":"list","member":{"shape":"S10"}},"tags":{"shape":"Sa"},"settings":{"shape":"Sj"},"capacityProviders":{"shape":"Sr"},"defaultCapacityProviderStrategy":{"shape":"Ss"},"attachments":{"shape":"S11"},"attachmentsStatus":{}}},"S10":{"type":"structure","members":{"name":{},"value":{}}},"S11":{"type":"list","member":{"type":"structure","members":{"id":{},"type":{},"status":{},"details":{"type":"list","member":{"shape":"S10"}}}}},"S15":{"type":"list","member":{"type":"structure","members":{"targetGroupArn":{},"loadBalancerName":{},"containerName":{},"containerPort":{"type":"integer"}}}},"S18":{"type":"list","member":{"type":"structure","members":{"registryArn":{},"port":{"type":"integer"},"containerName":{},"containerPort":{"type":"integer"}}}},"S1b":{"type":"structure","members":{"deploymentCircuitBreaker":{"type":"structure","required":["enable","rollback"],"members":{"enable":{"type":"boolean"},"rollback":{"type":"boolean"}}},"maximumPercent":{"type":"integer"},"minimumHealthyPercent":{"type":"integer"}}},"S1d":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S1g":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"S1j":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"Sr"},"securityGroups":{"shape":"Sr"},"assignPublicIp":{}}}}},"S1n":{"type":"structure","required":["type"],"members":{"type":{}}},"S1r":{"type":"structure","members":{"serviceArn":{},"serviceName":{},"clusterArn":{},"loadBalancers":{"shape":"S15"},"serviceRegistries":{"shape":"S18"},"status":{},"desiredCount":{"type":"integer"},"runningCount":{"type":"integer"},"pendingCount":{"type":"integer"},"launchType":{},"capacityProviderStrategy":{"shape":"Ss"},"platformVersion":{},"platformFamily":{},"taskDefinition":{},"deploymentConfiguration":{"shape":"S1b"},"taskSets":{"shape":"S1s"},"deployments":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"taskDefinition":{},"desiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"failedTasks":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"capacityProviderStrategy":{"shape":"Ss"},"launchType":{},"platformVersion":{},"platformFamily":{},"networkConfiguration":{"shape":"S1j"},"rolloutState":{},"rolloutStateReason":{}}}},"roleArn":{},"events":{"type":"list","member":{"type":"structure","members":{"id":{},"createdAt":{"type":"timestamp"},"message":{}}}},"createdAt":{"type":"timestamp"},"placementConstraints":{"shape":"S1d"},"placementStrategy":{"shape":"S1g"},"networkConfiguration":{"shape":"S1j"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"S1n"},"tags":{"shape":"Sa"},"createdBy":{},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{},"enableExecuteCommand":{"type":"boolean"}}},"S1s":{"type":"list","member":{"shape":"S1t"}},"S1t":{"type":"structure","members":{"id":{},"taskSetArn":{},"serviceArn":{},"clusterArn":{},"startedBy":{},"externalId":{},"status":{},"taskDefinition":{},"computedDesiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"launchType":{},"capacityProviderStrategy":{"shape":"Ss"},"platformVersion":{},"platformFamily":{},"networkConfiguration":{"shape":"S1j"},"loadBalancers":{"shape":"S15"},"serviceRegistries":{"shape":"S18"},"scale":{"shape":"S1v"},"stabilityStatus":{},"stabilityStatusAt":{"type":"timestamp"},"tags":{"shape":"Sa"}}},"S1v":{"type":"structure","members":{"value":{"type":"double"},"unit":{}}},"S29":{"type":"structure","members":{"name":{},"value":{},"principalArn":{}}},"S2b":{"type":"list","member":{"shape":"S2c"}},"S2c":{"type":"structure","required":["name"],"members":{"name":{},"value":{},"targetType":{},"targetId":{}}},"S2q":{"type":"structure","members":{"containerInstanceArn":{},"ec2InstanceId":{},"capacityProviderName":{},"version":{"type":"long"},"versionInfo":{"shape":"S2s"},"remainingResources":{"shape":"S2t"},"registeredResources":{"shape":"S2t"},"status":{},"statusReason":{},"agentConnected":{"type":"boolean"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"agentUpdateStatus":{},"attributes":{"shape":"S2b"},"registeredAt":{"type":"timestamp"},"attachments":{"shape":"S11"},"tags":{"shape":"Sa"},"healthStatus":{"type":"structure","members":{"overallStatus":{},"details":{"type":"list","member":{"type":"structure","members":{"type":{},"status":{},"lastUpdated":{"type":"timestamp"},"lastStatusChange":{"type":"timestamp"}}}}}}}},"S2s":{"type":"structure","members":{"agentVersion":{},"agentHash":{},"dockerVersion":{}}},"S2t":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"integerValue":{"type":"integer"},"stringSetValue":{"shape":"Sr"}}}},"S33":{"type":"structure","members":{"taskDefinitionArn":{},"containerDefinitions":{"shape":"S34"},"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"revision":{"type":"integer"},"volumes":{"shape":"S4e"},"status":{},"requiresAttributes":{"type":"list","member":{"shape":"S2c"}},"placementConstraints":{"shape":"S4s"},"compatibilities":{"shape":"S4v"},"runtimePlatform":{"shape":"S4x"},"requiresCompatibilities":{"shape":"S4v"},"cpu":{},"memory":{},"inferenceAccelerators":{"shape":"S50"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S54"},"registeredAt":{"type":"timestamp"},"deregisteredAt":{"type":"timestamp"},"registeredBy":{},"ephemeralStorage":{"shape":"S57"}}},"S34":{"type":"list","member":{"type":"structure","members":{"name":{},"image":{},"repositoryCredentials":{"type":"structure","required":["credentialsParameter"],"members":{"credentialsParameter":{}}},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"links":{"shape":"Sr"},"portMappings":{"type":"list","member":{"type":"structure","members":{"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"essential":{"type":"boolean"},"entryPoint":{"shape":"Sr"},"command":{"shape":"Sr"},"environment":{"shape":"S3a"},"environmentFiles":{"shape":"S3b"},"mountPoints":{"type":"list","member":{"type":"structure","members":{"sourceVolume":{},"containerPath":{},"readOnly":{"type":"boolean"}}}},"volumesFrom":{"type":"list","member":{"type":"structure","members":{"sourceContainer":{},"readOnly":{"type":"boolean"}}}},"linuxParameters":{"type":"structure","members":{"capabilities":{"type":"structure","members":{"add":{"shape":"Sr"},"drop":{"shape":"Sr"}}},"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}},"initProcessEnabled":{"type":"boolean"},"sharedMemorySize":{"type":"integer"},"tmpfs":{"type":"list","member":{"type":"structure","required":["containerPath","size"],"members":{"containerPath":{},"size":{"type":"integer"},"mountOptions":{"shape":"Sr"}}}},"maxSwap":{"type":"integer"},"swappiness":{"type":"integer"}}},"secrets":{"shape":"S3q"},"dependsOn":{"type":"list","member":{"type":"structure","required":["containerName","condition"],"members":{"containerName":{},"condition":{}}}},"startTimeout":{"type":"integer"},"stopTimeout":{"type":"integer"},"hostname":{},"user":{},"workingDirectory":{},"disableNetworking":{"type":"boolean"},"privileged":{"type":"boolean"},"readonlyRootFilesystem":{"type":"boolean"},"dnsServers":{"shape":"Sr"},"dnsSearchDomains":{"shape":"Sr"},"extraHosts":{"type":"list","member":{"type":"structure","required":["hostname","ipAddress"],"members":{"hostname":{},"ipAddress":{}}}},"dockerSecurityOptions":{"shape":"Sr"},"interactive":{"type":"boolean"},"pseudoTerminal":{"type":"boolean"},"dockerLabels":{"type":"map","key":{},"value":{}},"ulimits":{"type":"list","member":{"type":"structure","required":["name","softLimit","hardLimit"],"members":{"name":{},"softLimit":{"type":"integer"},"hardLimit":{"type":"integer"}}}},"logConfiguration":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}},"secretOptions":{"shape":"S3q"}}},"healthCheck":{"type":"structure","required":["command"],"members":{"command":{"shape":"Sr"},"interval":{"type":"integer"},"timeout":{"type":"integer"},"retries":{"type":"integer"},"startPeriod":{"type":"integer"}}},"systemControls":{"type":"list","member":{"type":"structure","members":{"namespace":{},"value":{}}}},"resourceRequirements":{"shape":"S47"},"firelensConfiguration":{"type":"structure","required":["type"],"members":{"type":{},"options":{"type":"map","key":{},"value":{}}}}}}},"S3a":{"type":"list","member":{"shape":"S10"}},"S3b":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S3q":{"type":"list","member":{"type":"structure","required":["name","valueFrom"],"members":{"name":{},"valueFrom":{}}}},"S47":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S4e":{"type":"list","member":{"type":"structure","members":{"name":{},"host":{"type":"structure","members":{"sourcePath":{}}},"dockerVolumeConfiguration":{"type":"structure","members":{"scope":{},"autoprovision":{"type":"boolean"},"driver":{},"driverOpts":{"shape":"S4j"},"labels":{"shape":"S4j"}}},"efsVolumeConfiguration":{"type":"structure","required":["fileSystemId"],"members":{"fileSystemId":{},"rootDirectory":{},"transitEncryption":{},"transitEncryptionPort":{"type":"integer"},"authorizationConfig":{"type":"structure","members":{"accessPointId":{},"iam":{}}}}},"fsxWindowsFileServerVolumeConfiguration":{"type":"structure","required":["fileSystemId","rootDirectory","authorizationConfig"],"members":{"fileSystemId":{},"rootDirectory":{},"authorizationConfig":{"type":"structure","required":["credentialsParameter","domain"],"members":{"credentialsParameter":{},"domain":{}}}}}}}},"S4j":{"type":"map","key":{},"value":{}},"S4s":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S4v":{"type":"list","member":{}},"S4x":{"type":"structure","members":{"cpuArchitecture":{},"operatingSystemFamily":{}}},"S50":{"type":"list","member":{"type":"structure","required":["deviceName","deviceType"],"members":{"deviceName":{},"deviceType":{}}}},"S54":{"type":"structure","required":["containerName"],"members":{"type":{},"containerName":{},"properties":{"type":"list","member":{"shape":"S10"}}}},"S57":{"type":"structure","required":["sizeInGiB"],"members":{"sizeInGiB":{"type":"integer"}}},"S5d":{"type":"list","member":{"type":"structure","members":{"arn":{},"reason":{},"detail":{}}}},"S5o":{"type":"list","member":{"shape":"S2q"}},"S66":{"type":"list","member":{"shape":"S67"}},"S67":{"type":"structure","members":{"attachments":{"shape":"S11"},"attributes":{"shape":"S2b"},"availabilityZone":{},"capacityProviderName":{},"clusterArn":{},"connectivity":{},"connectivityAt":{"type":"timestamp"},"containerInstanceArn":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerArn":{},"taskArn":{},"name":{},"image":{},"imageDigest":{},"runtimeId":{},"lastStatus":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S6b"},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"privateIpv4Address":{},"ipv6Address":{}}}},"healthStatus":{},"managedAgents":{"type":"list","member":{"type":"structure","members":{"lastStartedAt":{"type":"timestamp"},"name":{},"reason":{},"lastStatus":{}}}},"cpu":{},"memory":{},"memoryReservation":{},"gpuIds":{"type":"list","member":{}}}}},"cpu":{},"createdAt":{"type":"timestamp"},"desiredStatus":{},"enableExecuteCommand":{"type":"boolean"},"executionStoppedAt":{"type":"timestamp"},"group":{},"healthStatus":{},"inferenceAccelerators":{"shape":"S50"},"lastStatus":{},"launchType":{},"memory":{},"overrides":{"shape":"S6k"},"platformVersion":{},"platformFamily":{},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"startedBy":{},"stopCode":{},"stoppedAt":{"type":"timestamp"},"stoppedReason":{},"stoppingAt":{"type":"timestamp"},"tags":{"shape":"Sa"},"taskArn":{},"taskDefinitionArn":{},"version":{"type":"long"},"ephemeralStorage":{"shape":"S57"}}},"S6b":{"type":"list","member":{"type":"structure","members":{"bindIP":{},"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"S6k":{"type":"structure","members":{"containerOverrides":{"type":"list","member":{"type":"structure","members":{"name":{},"command":{"shape":"Sr"},"environment":{"shape":"S3a"},"environmentFiles":{"shape":"S3b"},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"resourceRequirements":{"shape":"S47"}}}},"cpu":{},"inferenceAcceleratorOverrides":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"deviceType":{}}}},"executionRoleArn":{},"memory":{},"taskRoleArn":{},"ephemeralStorage":{"shape":"S57"}}},"S85":{"type":"list","member":{"type":"structure","required":["attachmentArn","status"],"members":{"attachmentArn":{},"status":{}}}}}}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccountSettings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"settings"},"ListAttributes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"attributes"},"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusterArns"},"ListContainerInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"containerInstanceArns"},"ListServices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListTaskDefinitionFamilies":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"families"},"ListTaskDefinitions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskDefinitionArns"},"ListTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskArns"}}}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"TasksRunning":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAny","state":"failure","argument":"tasks[].lastStatus"},{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"RUNNING","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"TasksStopped":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"ServicesStable":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"DRAINING","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":"INACTIVE","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":true,"matcher":"path","state":"success","argument":"length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"}]},"ServicesInactive":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"INACTIVE","matcher":"pathAny","state":"success","argument":"services[].status"}]}}}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['efs'] = {};
	AWS.EFS = Service.defineService('efs', ['2015-02-01']);
	Object.defineProperty(apiLoader.services['efs'], '2015-02-01', {
	  get: function get() {
	    var model = __webpack_require__(206);
	    model.paginators = __webpack_require__(207).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EFS;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-01","endpointPrefix":"elasticfilesystem","protocol":"rest-json","serviceAbbreviation":"EFS","serviceFullName":"Amazon Elastic File System","serviceId":"EFS","signatureVersion":"v4","uid":"elasticfilesystem-2015-02-01"},"operations":{"CreateAccessPoint":{"http":{"requestUri":"/2015-02-01/access-points","responseCode":200},"input":{"type":"structure","required":["ClientToken","FileSystemId"],"members":{"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S3"},"FileSystemId":{},"PosixUser":{"shape":"S8"},"RootDirectory":{"shape":"Sc"}}},"output":{"shape":"Si"}},"CreateFileSystem":{"http":{"requestUri":"/2015-02-01/file-systems","responseCode":201},"input":{"type":"structure","required":["CreationToken"],"members":{"CreationToken":{"idempotencyToken":true},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"AvailabilityZoneName":{},"Backup":{"type":"boolean"},"Tags":{"shape":"S3"}}},"output":{"shape":"Sx"}},"CreateMountTarget":{"http":{"requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","required":["FileSystemId","SubnetId"],"members":{"FileSystemId":{},"SubnetId":{},"IpAddress":{},"SecurityGroups":{"shape":"S18"}}},"output":{"shape":"S1a"}},"CreateReplicationConfiguration":{"http":{"requestUri":"/2015-02-01/file-systems/{SourceFileSystemId}/replication-configuration","responseCode":200},"input":{"type":"structure","required":["SourceFileSystemId","Destinations"],"members":{"SourceFileSystemId":{"location":"uri","locationName":"SourceFileSystemId"},"Destinations":{"type":"list","member":{"type":"structure","members":{"Region":{},"AvailabilityZoneName":{},"KmsKeyId":{}}}}}},"output":{"shape":"S1i"}},"CreateTags":{"http":{"requestUri":"/2015-02-01/create-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","Tags"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Tags":{"shape":"S3"}}},"deprecated":true,"deprecatedMessage":"Use TagResource."},"DeleteAccessPoint":{"http":{"method":"DELETE","requestUri":"/2015-02-01/access-points/{AccessPointId}","responseCode":204},"input":{"type":"structure","required":["AccessPointId"],"members":{"AccessPointId":{"location":"uri","locationName":"AccessPointId"}}}},"DeleteFileSystem":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteFileSystemPolicy":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteMountTarget":{"http":{"method":"DELETE","requestUri":"/2015-02-01/mount-targets/{MountTargetId}","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}}},"DeleteReplicationConfiguration":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{SourceFileSystemId}/replication-configuration","responseCode":204},"input":{"type":"structure","required":["SourceFileSystemId"],"members":{"SourceFileSystemId":{"location":"uri","locationName":"SourceFileSystemId"}}}},"DeleteTags":{"http":{"requestUri":"/2015-02-01/delete-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","TagKeys"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"TagKeys":{"shape":"S1t"}}},"deprecated":true,"deprecatedMessage":"Use UntagResource."},"DescribeAccessPoints":{"http":{"method":"GET","requestUri":"/2015-02-01/access-points","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"AccessPointId":{"location":"querystring","locationName":"AccessPointId"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"AccessPoints":{"type":"list","member":{"shape":"Si"}},"NextToken":{}}}},"DescribeAccountPreferences":{"http":{"method":"GET","requestUri":"/2015-02-01/account-preferences","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceIdPreference":{"shape":"S21"},"NextToken":{}}}},"DescribeBackupPolicy":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/backup-policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S26"}},"DescribeFileSystemPolicy":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S2a"}},"DescribeFileSystems":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"CreationToken":{"location":"querystring","locationName":"CreationToken"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"Marker":{},"FileSystems":{"type":"list","member":{"shape":"Sx"}},"NextMarker":{}}}},"DescribeLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S2i"}},"DescribeMountTargetSecurityGroups":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":200},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}},"output":{"type":"structure","required":["SecurityGroups"],"members":{"SecurityGroups":{"shape":"S18"}}}},"DescribeMountTargets":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"MountTargetId":{"location":"querystring","locationName":"MountTargetId"},"AccessPointId":{"location":"querystring","locationName":"AccessPointId"}}},"output":{"type":"structure","members":{"Marker":{},"MountTargets":{"type":"list","member":{"shape":"S1a"}},"NextMarker":{}}}},"DescribeReplicationConfigurations":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/replication-configurations","responseCode":200},"input":{"type":"structure","members":{"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"Replications":{"type":"list","member":{"shape":"S1i"}},"NextToken":{}}}},"DescribeTags":{"http":{"method":"GET","requestUri":"/2015-02-01/tags/{FileSystemId}/","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"type":"structure","required":["Tags"],"members":{"Marker":{},"Tags":{"shape":"S3"},"NextMarker":{}}},"deprecated":true,"deprecatedMessage":"Use ListTagsForResource."},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"},"NextToken":{}}}},"ModifyMountTargetSecurityGroups":{"http":{"method":"PUT","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"},"SecurityGroups":{"shape":"S18"}}}},"PutAccountPreferences":{"http":{"method":"PUT","requestUri":"/2015-02-01/account-preferences","responseCode":200},"input":{"type":"structure","required":["ResourceIdType"],"members":{"ResourceIdType":{}}},"output":{"type":"structure","members":{"ResourceIdPreference":{"shape":"S21"}}}},"PutBackupPolicy":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/backup-policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId","BackupPolicy"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"BackupPolicy":{"shape":"S27"}}},"output":{"shape":"S26"}},"PutFileSystemPolicy":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId","Policy"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}},"output":{"shape":"S2a"}},"PutLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId","LifecyclePolicies"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"LifecyclePolicies":{"shape":"S2j"}}},"output":{"shape":"S2i"}},"TagResource":{"http":{"requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Tags":{"shape":"S3"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"TagKeys":{"shape":"S1t","location":"querystring","locationName":"tagKeys"}}}},"UpdateFileSystem":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":202},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"}}},"output":{"shape":"Sx"}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S8":{"type":"structure","required":["Uid","Gid"],"members":{"Uid":{"type":"long"},"Gid":{"type":"long"},"SecondaryGids":{"type":"list","member":{"type":"long"}}}},"Sc":{"type":"structure","members":{"Path":{},"CreationInfo":{"type":"structure","required":["OwnerUid","OwnerGid","Permissions"],"members":{"OwnerUid":{"type":"long"},"OwnerGid":{"type":"long"},"Permissions":{}}}}},"Si":{"type":"structure","members":{"ClientToken":{},"Name":{},"Tags":{"shape":"S3"},"AccessPointId":{},"AccessPointArn":{},"FileSystemId":{},"PosixUser":{"shape":"S8"},"RootDirectory":{"shape":"Sc"},"OwnerId":{},"LifeCycleState":{}}},"Sx":{"type":"structure","required":["OwnerId","CreationToken","FileSystemId","CreationTime","LifeCycleState","NumberOfMountTargets","SizeInBytes","PerformanceMode","Tags"],"members":{"OwnerId":{},"CreationToken":{},"FileSystemId":{},"FileSystemArn":{},"CreationTime":{"type":"timestamp"},"LifeCycleState":{},"Name":{},"NumberOfMountTargets":{"type":"integer"},"SizeInBytes":{"type":"structure","required":["Value"],"members":{"Value":{"type":"long"},"Timestamp":{"type":"timestamp"},"ValueInIA":{"type":"long"},"ValueInStandard":{"type":"long"}}},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"AvailabilityZoneName":{},"AvailabilityZoneId":{},"Tags":{"shape":"S3"}}},"S18":{"type":"list","member":{}},"S1a":{"type":"structure","required":["MountTargetId","FileSystemId","SubnetId","LifeCycleState"],"members":{"OwnerId":{},"MountTargetId":{},"FileSystemId":{},"SubnetId":{},"LifeCycleState":{},"IpAddress":{},"NetworkInterfaceId":{},"AvailabilityZoneId":{},"AvailabilityZoneName":{},"VpcId":{}}},"S1i":{"type":"structure","required":["SourceFileSystemId","SourceFileSystemRegion","SourceFileSystemArn","OriginalSourceFileSystemArn","CreationTime","Destinations"],"members":{"SourceFileSystemId":{},"SourceFileSystemRegion":{},"SourceFileSystemArn":{},"OriginalSourceFileSystemArn":{},"CreationTime":{"type":"timestamp"},"Destinations":{"type":"list","member":{"type":"structure","required":["Status","FileSystemId","Region"],"members":{"Status":{},"FileSystemId":{},"Region":{},"LastReplicatedTimestamp":{"type":"timestamp"}}}}}},"S1t":{"type":"list","member":{}},"S21":{"type":"structure","members":{"ResourceIdType":{},"Resources":{"type":"list","member":{}}}},"S26":{"type":"structure","members":{"BackupPolicy":{"shape":"S27"}}},"S27":{"type":"structure","required":["Status"],"members":{"Status":{}}},"S2a":{"type":"structure","members":{"FileSystemId":{},"Policy":{}}},"S2i":{"type":"structure","members":{"LifecyclePolicies":{"shape":"S2j"}}},"S2j":{"type":"list","member":{"type":"structure","members":{"TransitionToIA":{},"TransitionToPrimaryStorageClass":{}}}}}}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAccessPoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeFileSystems":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems"},"DescribeTags":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['elasticache'] = {};
	AWS.ElastiCache = Service.defineService('elasticache', ['2012-11-15*', '2014-03-24*', '2014-07-15*', '2014-09-30*', '2015-02-02']);
	Object.defineProperty(apiLoader.services['elasticache'], '2015-02-02', {
	  get: function get() {
	    var model = __webpack_require__(209);
	    model.paginators = __webpack_require__(210).pagination;
	    model.waiters = __webpack_require__(211).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ElastiCache;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-02","endpointPrefix":"elasticache","protocol":"query","serviceFullName":"Amazon ElastiCache","serviceId":"ElastiCache","signatureVersion":"v4","uid":"elasticache-2015-02-02","xmlNamespace":"http://elasticache.amazonaws.com/doc/2015-02-02/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}},"output":{"shape":"S5","resultWrapper":"AddTagsToResourceResult"}},"AuthorizeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"BatchApplyUpdateAction":{"input":{"type":"structure","required":["ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"ServiceUpdateName":{}}},"output":{"shape":"Se","resultWrapper":"BatchApplyUpdateActionResult"}},"BatchStopUpdateAction":{"input":{"type":"structure","required":["ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"ServiceUpdateName":{}}},"output":{"shape":"Se","resultWrapper":"BatchStopUpdateActionResult"}},"CompleteMigration":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"CompleteMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{},"KmsKeyId":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CopySnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1q"}}}},"CreateCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"ReplicationGroupId":{},"AZMode":{},"PreferredAvailabilityZone":{},"PreferredAvailabilityZones":{"shape":"S1z"},"NumCacheNodes":{"type":"integer"},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"S20"},"SecurityGroupIds":{"shape":"S21"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S22"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"OutpostMode":{},"PreferredOutpostArn":{},"PreferredOutpostArns":{"shape":"S24"},"LogDeliveryConfigurations":{"shape":"S25"}}},"output":{"resultWrapper":"CreateCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S28"}}}},"CreateCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","CacheParameterGroupFamily","Description"],"members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateCacheParameterGroupResult","type":"structure","members":{"CacheParameterGroup":{"shape":"S2l"}}}},"CreateCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName","Description"],"members":{"CacheSecurityGroupName":{},"Description":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateCacheSecurityGroupResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CreateCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName","CacheSubnetGroupDescription","SubnetIds"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S2p"},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S2r"}}}},"CreateGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupIdSuffix","PrimaryReplicationGroupId"],"members":{"GlobalReplicationGroupIdSuffix":{},"GlobalReplicationGroupDescription":{},"PrimaryReplicationGroupId":{}}},"output":{"resultWrapper":"CreateGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"CreateReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId","ReplicationGroupDescription"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"GlobalReplicationGroupId":{},"PrimaryClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"MultiAZEnabled":{"type":"boolean"},"NumCacheClusters":{"type":"integer"},"PreferredCacheClusterAZs":{"shape":"S1v"},"NumNodeGroups":{"type":"integer"},"ReplicasPerNodeGroup":{"type":"integer"},"NodeGroupConfiguration":{"type":"list","member":{"shape":"S1t","locationName":"NodeGroupConfiguration"}},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"S20"},"SecurityGroupIds":{"shape":"S21"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S22"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"KmsKeyId":{},"UserGroupIds":{"type":"list","member":{}},"LogDeliveryConfigurations":{"shape":"S25"},"DataTieringEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"KmsKeyId":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1q"}}}},"CreateUser":{"input":{"type":"structure","required":["UserId","UserName","Engine","AccessString"],"members":{"UserId":{},"UserName":{},"Engine":{},"Passwords":{"shape":"S3d"},"AccessString":{},"NoPasswordRequired":{"type":"boolean"},"Tags":{"shape":"S3"}}},"output":{"shape":"S3f","resultWrapper":"CreateUserResult"}},"CreateUserGroup":{"input":{"type":"structure","required":["UserGroupId","Engine"],"members":{"UserGroupId":{},"Engine":{},"UserIds":{"shape":"S3j"},"Tags":{"shape":"S3"}}},"output":{"shape":"S3k","resultWrapper":"CreateUserGroupResult"}},"DecreaseNodeGroupsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"GlobalNodeGroupsToRemove":{"shape":"S3p"},"GlobalNodeGroupsToRetain":{"shape":"S3p"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseNodeGroupsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"DecreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S3s"},"ReplicasToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"DeleteCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S28"}}}},"DeleteCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{}}}},"DeleteCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName"],"members":{"CacheSecurityGroupName":{}}}},"DeleteCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{}}}},"DeleteGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","RetainPrimaryReplicationGroup"],"members":{"GlobalReplicationGroupId":{},"RetainPrimaryReplicationGroup":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"DeleteReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"RetainPrimaryCluster":{"type":"boolean"},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"resultWrapper":"DeleteSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1q"}}}},"DeleteUser":{"input":{"type":"structure","required":["UserId"],"members":{"UserId":{}}},"output":{"shape":"S3f","resultWrapper":"DeleteUserResult"}},"DeleteUserGroup":{"input":{"type":"structure","required":["UserGroupId"],"members":{"UserGroupId":{}}},"output":{"shape":"S3k","resultWrapper":"DeleteUserGroupResult"}},"DescribeCacheClusters":{"input":{"type":"structure","members":{"CacheClusterId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowCacheNodeInfo":{"type":"boolean"},"ShowCacheClustersNotInReplicationGroups":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheClustersResult","type":"structure","members":{"Marker":{},"CacheClusters":{"type":"list","member":{"shape":"S28","locationName":"CacheCluster"}}}}},"DescribeCacheEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheEngineVersionsResult","type":"structure","members":{"Marker":{},"CacheEngineVersions":{"type":"list","member":{"locationName":"CacheEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"CacheEngineDescription":{},"CacheEngineVersionDescription":{}}}}}}},"DescribeCacheParameterGroups":{"input":{"type":"structure","members":{"CacheParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParameterGroupsResult","type":"structure","members":{"Marker":{},"CacheParameterGroups":{"type":"list","member":{"shape":"S2l","locationName":"CacheParameterGroup"}}}}},"DescribeCacheParameters":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParametersResult","type":"structure","members":{"Marker":{},"Parameters":{"shape":"S4l"},"CacheNodeTypeSpecificParameters":{"shape":"S4o"}}}},"DescribeCacheSecurityGroups":{"input":{"type":"structure","members":{"CacheSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSecurityGroupsResult","type":"structure","members":{"Marker":{},"CacheSecurityGroups":{"type":"list","member":{"shape":"S8","locationName":"CacheSecurityGroup"}}}}},"DescribeCacheSubnetGroups":{"input":{"type":"structure","members":{"CacheSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSubnetGroupsResult","type":"structure","members":{"Marker":{},"CacheSubnetGroups":{"type":"list","member":{"shape":"S2r","locationName":"CacheSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["CacheParameterGroupFamily"],"members":{"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"CacheParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S4l"},"CacheNodeTypeSpecificParameters":{"shape":"S4o"}},"wrapper":true}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeGlobalReplicationGroups":{"input":{"type":"structure","members":{"GlobalReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowMemberInfo":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeGlobalReplicationGroupsResult","type":"structure","members":{"Marker":{},"GlobalReplicationGroups":{"type":"list","member":{"shape":"S2y","locationName":"GlobalReplicationGroup"}}}}},"DescribeReplicationGroups":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReplicationGroupsResult","type":"structure","members":{"Marker":{},"ReplicationGroups":{"type":"list","member":{"shape":"So","locationName":"ReplicationGroup"}}}}},"DescribeReservedCacheNodes":{"input":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesResult","type":"structure","members":{"Marker":{},"ReservedCacheNodes":{"type":"list","member":{"shape":"S5f","locationName":"ReservedCacheNode"}}}}},"DescribeReservedCacheNodesOfferings":{"input":{"type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedCacheNodesOfferings":{"type":"list","member":{"locationName":"ReservedCacheNodesOffering","type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"ProductDescription":{},"OfferingType":{},"RecurringCharges":{"shape":"S5g"}},"wrapper":true}}}}},"DescribeServiceUpdates":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateStatus":{"shape":"S5n"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeServiceUpdatesResult","type":"structure","members":{"Marker":{},"ServiceUpdates":{"type":"list","member":{"locationName":"ServiceUpdate","type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateEndDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateStatus":{},"ServiceUpdateDescription":{},"ServiceUpdateType":{},"Engine":{},"EngineVersion":{},"AutoUpdateAfterRecommendedApplyByDate":{"type":"boolean"},"EstimatedUpdateTime":{}}}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"SnapshotSource":{},"Marker":{},"MaxRecords":{"type":"integer"},"ShowNodeGroupConfig":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"S1q","locationName":"Snapshot"}}}}},"DescribeUpdateActions":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"Engine":{},"ServiceUpdateStatus":{"shape":"S5n"},"ServiceUpdateTimeRange":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"UpdateActionStatus":{"type":"list","member":{}},"ShowNodeLevelUpdateStatus":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUpdateActionsResult","type":"structure","members":{"Marker":{},"UpdateActions":{"type":"list","member":{"locationName":"UpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateStatus":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateType":{},"UpdateActionAvailableDate":{"type":"timestamp"},"UpdateActionStatus":{},"NodesUpdated":{},"UpdateActionStatusModifiedDate":{"type":"timestamp"},"SlaMet":{},"NodeGroupUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupUpdateStatus","type":"structure","members":{"NodeGroupId":{},"NodeGroupMemberUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupMemberUpdateStatus","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}}}}},"CacheNodeUpdateStatus":{"type":"list","member":{"locationName":"CacheNodeUpdateStatus","type":"structure","members":{"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}},"EstimatedUpdateTime":{},"Engine":{}}}}}}},"DescribeUserGroups":{"input":{"type":"structure","members":{"UserGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUserGroupsResult","type":"structure","members":{"UserGroups":{"type":"list","member":{"shape":"S3k"}},"Marker":{}}}},"DescribeUsers":{"input":{"type":"structure","members":{"Engine":{},"UserId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUsersResult","type":"structure","members":{"Users":{"type":"list","member":{"shape":"S3f"}},"Marker":{}}}},"DisassociateGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ReplicationGroupId","ReplicationGroupRegion"],"members":{"GlobalReplicationGroupId":{},"ReplicationGroupId":{},"ReplicationGroupRegion":{}}},"output":{"resultWrapper":"DisassociateGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"FailoverGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","PrimaryRegion","PrimaryReplicationGroupId"],"members":{"GlobalReplicationGroupId":{},"PrimaryRegion":{},"PrimaryReplicationGroupId":{}}},"output":{"resultWrapper":"FailoverGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"IncreaseNodeGroupsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"RegionalConfigurations":{"type":"list","member":{"locationName":"RegionalConfiguration","type":"structure","required":["ReplicationGroupId","ReplicationGroupRegion","ReshardingConfiguration"],"members":{"ReplicationGroupId":{},"ReplicationGroupRegion":{},"ReshardingConfiguration":{"shape":"S6u"}}}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseNodeGroupsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"IncreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S3s"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ListAllowedNodeTypeModifications":{"input":{"type":"structure","members":{"CacheClusterId":{},"ReplicationGroupId":{}}},"output":{"resultWrapper":"ListAllowedNodeTypeModificationsResult","type":"structure","members":{"ScaleUpModifications":{"shape":"S71"},"ScaleDownModifications":{"shape":"S71"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"shape":"S5","resultWrapper":"ListTagsForResourceResult"}},"ModifyCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S2a"},"AZMode":{},"NewAvailabilityZones":{"shape":"S1z"},"CacheSecurityGroupNames":{"shape":"S20"},"SecurityGroupIds":{"shape":"S21"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"AuthToken":{},"AuthTokenUpdateStrategy":{},"LogDeliveryConfigurations":{"shape":"S25"}}},"output":{"resultWrapper":"ModifyCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S28"}}}},"ModifyCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","ParameterNameValues"],"members":{"CacheParameterGroupName":{},"ParameterNameValues":{"shape":"S77"}}},"output":{"shape":"S79","resultWrapper":"ModifyCacheParameterGroupResult"}},"ModifyCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S2p"}}},"output":{"resultWrapper":"ModifyCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S2r"}}}},"ModifyGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"ApplyImmediately":{"type":"boolean"},"CacheNodeType":{},"EngineVersion":{},"CacheParameterGroupName":{},"GlobalReplicationGroupDescription":{},"AutomaticFailoverEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"ModifyReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"SnapshottingClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"MultiAZEnabled":{"type":"boolean"},"NodeGroupId":{"deprecated":true},"CacheSecurityGroupNames":{"shape":"S20"},"SecurityGroupIds":{"shape":"S21"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"AuthToken":{},"AuthTokenUpdateStrategy":{},"UserGroupIdsToAdd":{"shape":"Sx"},"UserGroupIdsToRemove":{"shape":"Sx"},"RemoveUserGroups":{"type":"boolean"},"LogDeliveryConfigurations":{"shape":"S25"}}},"output":{"resultWrapper":"ModifyReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ModifyReplicationGroupShardConfiguration":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReshardingConfiguration":{"shape":"S6u"},"NodeGroupsToRemove":{"type":"list","member":{"locationName":"NodeGroupToRemove"}},"NodeGroupsToRetain":{"type":"list","member":{"locationName":"NodeGroupToRetain"}}}},"output":{"resultWrapper":"ModifyReplicationGroupShardConfigurationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ModifyUser":{"input":{"type":"structure","required":["UserId"],"members":{"UserId":{},"AccessString":{},"AppendAccessString":{},"Passwords":{"shape":"S3d"},"NoPasswordRequired":{"type":"boolean"}}},"output":{"shape":"S3f","resultWrapper":"ModifyUserResult"}},"ModifyUserGroup":{"input":{"type":"structure","required":["UserGroupId"],"members":{"UserGroupId":{},"UserIdsToAdd":{"shape":"S3j"},"UserIdsToRemove":{"shape":"S3j"}}},"output":{"shape":"S3k","resultWrapper":"ModifyUserGroupResult"}},"PurchaseReservedCacheNodesOffering":{"input":{"type":"structure","required":["ReservedCacheNodesOfferingId"],"members":{"ReservedCacheNodesOfferingId":{},"ReservedCacheNodeId":{},"CacheNodeCount":{"type":"integer"},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"PurchaseReservedCacheNodesOfferingResult","type":"structure","members":{"ReservedCacheNode":{"shape":"S5f"}}}},"RebalanceSlotsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"RebalanceSlotsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S2y"}}}},"RebootCacheCluster":{"input":{"type":"structure","required":["CacheClusterId","CacheNodeIdsToReboot"],"members":{"CacheClusterId":{},"CacheNodeIdsToReboot":{"shape":"S2a"}}},"output":{"resultWrapper":"RebootCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S28"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"shape":"S5","resultWrapper":"RemoveTagsFromResourceResult"}},"ResetCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"ParameterNameValues":{"shape":"S77"}}},"output":{"shape":"S79","resultWrapper":"ResetCacheParameterGroupResult"}},"RevokeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"StartMigration":{"input":{"type":"structure","required":["ReplicationGroupId","CustomerNodeEndpointList"],"members":{"ReplicationGroupId":{},"CustomerNodeEndpointList":{"type":"list","member":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}}}}},"output":{"resultWrapper":"StartMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"TestFailover":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupId"],"members":{"ReplicationGroupId":{},"NodeGroupId":{}}},"output":{"resultWrapper":"TestFailoverResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S5":{"type":"structure","members":{"TagList":{"shape":"S3"}}},"S8":{"type":"structure","members":{"OwnerId":{},"CacheSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}}},"ARN":{}},"wrapper":true},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Se":{"type":"structure","members":{"ProcessedUpdateActions":{"type":"list","member":{"locationName":"ProcessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"UpdateActionStatus":{}}}},"UnprocessedUpdateActions":{"type":"list","member":{"locationName":"UnprocessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"ErrorType":{},"ErrorMessage":{}}}}}},"So":{"type":"structure","members":{"ReplicationGroupId":{},"Description":{},"GlobalReplicationGroupInfo":{"type":"structure","members":{"GlobalReplicationGroupId":{},"GlobalReplicationGroupMemberRole":{}}},"Status":{},"PendingModifiedValues":{"type":"structure","members":{"PrimaryClusterId":{},"AutomaticFailoverStatus":{},"Resharding":{"type":"structure","members":{"SlotMigration":{"type":"structure","members":{"ProgressPercentage":{"type":"double"}}}}},"AuthTokenStatus":{},"UserGroups":{"type":"structure","members":{"UserGroupIdsToAdd":{"shape":"Sx"},"UserGroupIdsToRemove":{"shape":"Sx"}}},"LogDeliveryConfigurations":{"shape":"Sz"}}},"MemberClusters":{"type":"list","member":{"locationName":"ClusterId"}},"NodeGroups":{"type":"list","member":{"locationName":"NodeGroup","type":"structure","members":{"NodeGroupId":{},"Status":{},"PrimaryEndpoint":{"shape":"S1a"},"ReaderEndpoint":{"shape":"S1a"},"Slots":{},"NodeGroupMembers":{"type":"list","member":{"locationName":"NodeGroupMember","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"ReadEndpoint":{"shape":"S1a"},"PreferredAvailabilityZone":{},"PreferredOutpostArn":{},"CurrentRole":{}}}}}}},"SnapshottingClusterId":{},"AutomaticFailover":{},"MultiAZ":{},"ConfigurationEndpoint":{"shape":"S1a"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"ClusterEnabled":{"type":"boolean"},"CacheNodeType":{},"AuthTokenEnabled":{"type":"boolean"},"AuthTokenLastModifiedDate":{"type":"timestamp"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"MemberClustersOutpostArns":{"type":"list","member":{"locationName":"ReplicationGroupOutpostArn"}},"KmsKeyId":{},"ARN":{},"UserGroupIds":{"shape":"Sx"},"LogDeliveryConfigurations":{"shape":"S1k"},"ReplicationGroupCreateTime":{"type":"timestamp"},"DataTiering":{}},"wrapper":true},"Sx":{"type":"list","member":{}},"Sz":{"type":"list","member":{"type":"structure","members":{"LogType":{},"DestinationType":{},"DestinationDetails":{"shape":"S13"},"LogFormat":{}}},"locationName":"PendingLogDeliveryConfiguration"},"S13":{"type":"structure","members":{"CloudWatchLogsDetails":{"type":"structure","members":{"LogGroup":{}}},"KinesisFirehoseDetails":{"type":"structure","members":{"DeliveryStream":{}}}}},"S1a":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"S1k":{"type":"list","member":{"locationName":"LogDeliveryConfiguration","type":"structure","members":{"LogType":{},"DestinationType":{},"DestinationDetails":{"shape":"S13"},"LogFormat":{},"Status":{},"Message":{}}}},"S1q":{"type":"structure","members":{"SnapshotName":{},"ReplicationGroupId":{},"ReplicationGroupDescription":{},"CacheClusterId":{},"SnapshotStatus":{},"SnapshotSource":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"PreferredOutpostArn":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"VpcId":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumNodeGroups":{"type":"integer"},"AutomaticFailover":{},"NodeSnapshots":{"type":"list","member":{"locationName":"NodeSnapshot","type":"structure","members":{"CacheClusterId":{},"NodeGroupId":{},"CacheNodeId":{},"NodeGroupConfiguration":{"shape":"S1t"},"CacheSize":{},"CacheNodeCreateTime":{"type":"timestamp"},"SnapshotCreateTime":{"type":"timestamp"}},"wrapper":true}},"KmsKeyId":{},"ARN":{},"DataTiering":{}},"wrapper":true},"S1t":{"type":"structure","members":{"NodeGroupId":{},"Slots":{},"ReplicaCount":{"type":"integer"},"PrimaryAvailabilityZone":{},"ReplicaAvailabilityZones":{"shape":"S1v"},"PrimaryOutpostArn":{},"ReplicaOutpostArns":{"type":"list","member":{"locationName":"OutpostArn"}}}},"S1v":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S1z":{"type":"list","member":{"locationName":"PreferredAvailabilityZone"}},"S20":{"type":"list","member":{"locationName":"CacheSecurityGroupName"}},"S21":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S22":{"type":"list","member":{"locationName":"SnapshotArn"}},"S24":{"type":"list","member":{"locationName":"PreferredOutpostArn"}},"S25":{"type":"list","member":{"locationName":"LogDeliveryConfigurationRequest","type":"structure","members":{"LogType":{},"DestinationType":{},"DestinationDetails":{"shape":"S13"},"LogFormat":{},"Enabled":{"type":"boolean"}}}},"S28":{"type":"structure","members":{"CacheClusterId":{},"ConfigurationEndpoint":{"shape":"S1a"},"ClientDownloadLandingPage":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheClusterStatus":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"PreferredOutpostArn":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S2a"},"EngineVersion":{},"CacheNodeType":{},"AuthTokenStatus":{},"LogDeliveryConfigurations":{"shape":"Sz"}}},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"CacheSecurityGroups":{"type":"list","member":{"locationName":"CacheSecurityGroup","type":"structure","members":{"CacheSecurityGroupName":{},"Status":{}}}},"CacheParameterGroup":{"type":"structure","members":{"CacheParameterGroupName":{},"ParameterApplyStatus":{},"CacheNodeIdsToReboot":{"shape":"S2a"}}},"CacheSubnetGroupName":{},"CacheNodes":{"type":"list","member":{"locationName":"CacheNode","type":"structure","members":{"CacheNodeId":{},"CacheNodeStatus":{},"CacheNodeCreateTime":{"type":"timestamp"},"Endpoint":{"shape":"S1a"},"ParameterGroupStatus":{},"SourceCacheNodeId":{},"CustomerAvailabilityZone":{},"CustomerOutpostArn":{}}}},"AutoMinorVersionUpgrade":{"type":"boolean"},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"ReplicationGroupId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthTokenEnabled":{"type":"boolean"},"AuthTokenLastModifiedDate":{"type":"timestamp"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"ARN":{},"ReplicationGroupLogDeliveryEnabled":{"type":"boolean"},"LogDeliveryConfigurations":{"shape":"S1k"}},"wrapper":true},"S2a":{"type":"list","member":{"locationName":"CacheNodeId"}},"S2l":{"type":"structure","members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{},"IsGlobal":{"type":"boolean"},"ARN":{}},"wrapper":true},"S2p":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2r":{"type":"structure","members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"VpcId":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}},"wrapper":true},"SubnetOutpost":{"type":"structure","members":{"SubnetOutpostArn":{}}}}}},"ARN":{}},"wrapper":true},"S2y":{"type":"structure","members":{"GlobalReplicationGroupId":{},"GlobalReplicationGroupDescription":{},"Status":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"Members":{"type":"list","member":{"locationName":"GlobalReplicationGroupMember","type":"structure","members":{"ReplicationGroupId":{},"ReplicationGroupRegion":{},"Role":{},"AutomaticFailover":{},"Status":{}},"wrapper":true}},"ClusterEnabled":{"type":"boolean"},"GlobalNodeGroups":{"type":"list","member":{"locationName":"GlobalNodeGroup","type":"structure","members":{"GlobalNodeGroupId":{},"Slots":{}}}},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"ARN":{}},"wrapper":true},"S3d":{"type":"list","member":{}},"S3f":{"type":"structure","members":{"UserId":{},"UserName":{},"Status":{},"Engine":{},"MinimumEngineVersion":{},"AccessString":{},"UserGroupIds":{"shape":"Sx"},"Authentication":{"type":"structure","members":{"Type":{},"PasswordCount":{"type":"integer"}}},"ARN":{}}},"S3j":{"type":"list","member":{}},"S3k":{"type":"structure","members":{"UserGroupId":{},"Status":{},"Engine":{},"UserIds":{"shape":"S3l"},"MinimumEngineVersion":{},"PendingChanges":{"type":"structure","members":{"UserIdsToRemove":{"shape":"S3l"},"UserIdsToAdd":{"shape":"S3l"}}},"ReplicationGroups":{"type":"list","member":{}},"ARN":{}}},"S3l":{"type":"list","member":{}},"S3p":{"type":"list","member":{"locationName":"GlobalNodeGroupId"}},"S3s":{"type":"list","member":{"locationName":"ConfigureShard","type":"structure","required":["NodeGroupId","NewReplicaCount"],"members":{"NodeGroupId":{},"NewReplicaCount":{"type":"integer"},"PreferredAvailabilityZones":{"shape":"S1z"},"PreferredOutpostArns":{"shape":"S24"}}}},"S4l":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ChangeType":{}}}},"S4o":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificParameter","type":"structure","members":{"ParameterName":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"CacheNodeTypeSpecificValues":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificValue","type":"structure","members":{"CacheNodeType":{},"Value":{}}}},"ChangeType":{}}}},"S5f":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CacheNodeCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"State":{},"RecurringCharges":{"shape":"S5g"},"ReservationARN":{}},"wrapper":true},"S5g":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S5n":{"type":"list","member":{}},"S6u":{"type":"list","member":{"locationName":"ReshardingConfiguration","type":"structure","members":{"NodeGroupId":{},"PreferredAvailabilityZones":{"shape":"S1v"}}}},"S71":{"type":"list","member":{}},"S77":{"type":"list","member":{"locationName":"ParameterNameValue","type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"S79":{"type":"structure","members":{"CacheParameterGroupName":{}}}}}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCacheClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheClusters"},"DescribeCacheEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheEngineVersions"},"DescribeCacheParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheParameterGroups"},"DescribeCacheParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeCacheSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSecurityGroups"},"DescribeCacheSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeGlobalReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalReplicationGroups"},"DescribeReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReplicationGroups"},"DescribeReservedCacheNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodes"},"DescribeReservedCacheNodesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodesOfferings"},"DescribeServiceUpdates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ServiceUpdates"},"DescribeSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeUpdateActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UpdateActions"},"DescribeUserGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UserGroups"},"DescribeUsers":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Users"}}}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"CacheClusterAvailable":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is available.","maxAttempts":40,"operation":"DescribeCacheClusters"},"CacheClusterDeleted":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAll","state":"success"},{"expected":"CacheClusterNotFound","matcher":"error","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"snapshotting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is deleted.","maxAttempts":40,"operation":"DescribeCacheClusters"},"ReplicationGroupAvailable":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache replication group is available.","maxAttempts":40,"operation":"DescribeReplicationGroups"},"ReplicationGroupDeleted":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ReplicationGroupNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until ElastiCache replication group is deleted.","maxAttempts":40,"operation":"DescribeReplicationGroups"}}}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['elasticbeanstalk'] = {};
	AWS.ElasticBeanstalk = Service.defineService('elasticbeanstalk', ['2010-12-01']);
	Object.defineProperty(apiLoader.services['elasticbeanstalk'], '2010-12-01', {
	  get: function get() {
	    var model = __webpack_require__(213);
	    model.paginators = __webpack_require__(214).pagination;
	    model.waiters = __webpack_require__(215).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ElasticBeanstalk;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"elasticbeanstalk","protocol":"query","serviceAbbreviation":"Elastic Beanstalk","serviceFullName":"AWS Elastic Beanstalk","serviceId":"Elastic Beanstalk","signatureVersion":"v4","uid":"elasticbeanstalk-2010-12-01","xmlNamespace":"http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"},"operations":{"AbortEnvironmentUpdate":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"ApplyEnvironmentManagedAction":{"input":{"type":"structure","required":["ActionId"],"members":{"EnvironmentName":{},"EnvironmentId":{},"ActionId":{}}},"output":{"resultWrapper":"ApplyEnvironmentManagedActionResult","type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{}}}},"AssociateEnvironmentOperationsRole":{"input":{"type":"structure","required":["EnvironmentName","OperationsRole"],"members":{"EnvironmentName":{},"OperationsRole":{}}}},"CheckDNSAvailability":{"input":{"type":"structure","required":["CNAMEPrefix"],"members":{"CNAMEPrefix":{}}},"output":{"resultWrapper":"CheckDNSAvailabilityResult","type":"structure","members":{"Available":{"type":"boolean"},"FullyQualifiedCNAME":{}}}},"ComposeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"GroupName":{},"VersionLabels":{"type":"list","member":{}}}},"output":{"shape":"Sk","resultWrapper":"ComposeEnvironmentsResult"}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{},"ResourceLifecycleConfig":{"shape":"S19"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S1j","resultWrapper":"CreateApplicationResult"}},"CreateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{},"SourceBuildInformation":{"shape":"S1p"},"SourceBundle":{"shape":"S1t"},"BuildConfiguration":{"type":"structure","required":["CodeBuildServiceRole","Image"],"members":{"ArtifactName":{},"CodeBuildServiceRole":{},"ComputeType":{},"Image":{},"TimeoutInMinutes":{"type":"integer"}}},"AutoCreateApplication":{"type":"boolean"},"Process":{"type":"boolean"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S21","resultWrapper":"CreateApplicationVersionResult"}},"CreateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"SourceConfiguration":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{}}},"EnvironmentId":{},"Description":{},"OptionSettings":{"shape":"S27"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S2d","resultWrapper":"CreateConfigurationTemplateResult"}},"CreateEnvironment":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"EnvironmentName":{},"GroupName":{},"Description":{},"CNAMEPrefix":{},"Tier":{"shape":"S13"},"Tags":{"shape":"S1f"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"},"OperationsRole":{}}},"output":{"shape":"Sm","resultWrapper":"CreateEnvironmentResult"}},"CreatePlatformVersion":{"input":{"type":"structure","required":["PlatformName","PlatformVersion","PlatformDefinitionBundle"],"members":{"PlatformName":{},"PlatformVersion":{},"PlatformDefinitionBundle":{"shape":"S1t"},"EnvironmentName":{},"OptionSettings":{"shape":"S27"},"Tags":{"shape":"S1f"}}},"output":{"resultWrapper":"CreatePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2m"},"Builder":{"type":"structure","members":{"ARN":{}}}}}},"CreateStorageLocation":{"output":{"resultWrapper":"CreateStorageLocationResult","type":"structure","members":{"S3Bucket":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TerminateEnvByForce":{"type":"boolean"}}}},"DeleteApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"DeleteSourceBundle":{"type":"boolean"}}}},"DeleteConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{}}}},"DeleteEnvironmentConfiguration":{"input":{"type":"structure","required":["ApplicationName","EnvironmentName"],"members":{"ApplicationName":{},"EnvironmentName":{}}}},"DeletePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DeletePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2m"}}}},"DescribeAccountAttributes":{"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"ResourceQuotas":{"type":"structure","members":{"ApplicationQuota":{"shape":"S3c"},"ApplicationVersionQuota":{"shape":"S3c"},"EnvironmentQuota":{"shape":"S3c"},"ConfigurationTemplateQuota":{"shape":"S3c"},"CustomPlatformQuota":{"shape":"S3c"}}}}}},"DescribeApplicationVersions":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabels":{"shape":"S1m"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeApplicationVersionsResult","type":"structure","members":{"ApplicationVersions":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"ApplicationNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeApplicationsResult","type":"structure","members":{"Applications":{"type":"list","member":{"shape":"S1k"}}}}},"DescribeConfigurationOptions":{"input":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"SolutionStackName":{},"PlatformArn":{},"Options":{"shape":"S2g"}}},"output":{"resultWrapper":"DescribeConfigurationOptionsResult","type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"Options":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Name":{},"DefaultValue":{},"ChangeSeverity":{},"UserDefined":{"type":"boolean"},"ValueType":{},"ValueOptions":{"type":"list","member":{}},"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"MaxLength":{"type":"integer"},"Regex":{"type":"structure","members":{"Pattern":{},"Label":{}}}}}}}}},"DescribeConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeConfigurationSettingsResult","type":"structure","members":{"ConfigurationSettings":{"type":"list","member":{"shape":"S2d"}}}}},"DescribeEnvironmentHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeEnvironmentHealthResult","type":"structure","members":{"EnvironmentName":{},"HealthStatus":{},"Status":{},"Color":{},"Causes":{"shape":"S48"},"ApplicationMetrics":{"shape":"S4a"},"InstancesHealth":{"type":"structure","members":{"NoData":{"type":"integer"},"Unknown":{"type":"integer"},"Pending":{"type":"integer"},"Ok":{"type":"integer"},"Info":{"type":"integer"},"Warning":{"type":"integer"},"Degraded":{"type":"integer"},"Severe":{"type":"integer"}}},"RefreshedAt":{"type":"timestamp"}}}},"DescribeEnvironmentManagedActionHistory":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionHistoryResult","type":"structure","members":{"ManagedActionHistoryItems":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionType":{},"ActionDescription":{},"FailureType":{},"Status":{},"FailureDescription":{},"ExecutedTime":{"type":"timestamp"},"FinishedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEnvironmentManagedActions":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"Status":{}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionsResult","type":"structure","members":{"ManagedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{},"WindowStartTime":{"type":"timestamp"}}}}}}},"DescribeEnvironmentResources":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeEnvironmentResourcesResult","type":"structure","members":{"EnvironmentResources":{"type":"structure","members":{"EnvironmentName":{},"AutoScalingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"LaunchTemplates":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Triggers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Queues":{"type":"list","member":{"type":"structure","members":{"Name":{},"URL":{}}}}}}}}},"DescribeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"EnvironmentIds":{"type":"list","member":{}},"EnvironmentNames":{"type":"list","member":{}},"IncludeDeleted":{"type":"boolean"},"IncludedDeletedBackTo":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"shape":"Sk","resultWrapper":"DescribeEnvironmentsResult"}},"DescribeEvents":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentId":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventDate":{"type":"timestamp"},"Message":{},"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{}}}},"NextToken":{}}}},"DescribeInstancesHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"resultWrapper":"DescribeInstancesHealthResult","type":"structure","members":{"InstanceHealthList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"HealthStatus":{},"Color":{},"Causes":{"shape":"S48"},"LaunchedAt":{"type":"timestamp"},"ApplicationMetrics":{"shape":"S4a"},"System":{"type":"structure","members":{"CPUUtilization":{"type":"structure","members":{"User":{"type":"double"},"Nice":{"type":"double"},"System":{"type":"double"},"Idle":{"type":"double"},"IOWait":{"type":"double"},"IRQ":{"type":"double"},"SoftIRQ":{"type":"double"},"Privileged":{"type":"double"}}},"LoadAverage":{"type":"list","member":{"type":"double"}}}},"Deployment":{"type":"structure","members":{"VersionLabel":{},"DeploymentId":{"type":"long"},"Status":{},"DeploymentTime":{"type":"timestamp"}}},"AvailabilityZone":{},"InstanceType":{}}}},"RefreshedAt":{"type":"timestamp"},"NextToken":{}}}},"DescribePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DescribePlatformVersionResult","type":"structure","members":{"PlatformDescription":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformName":{},"PlatformVersion":{},"SolutionStackName":{},"PlatformStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"PlatformCategory":{},"Description":{},"Maintainer":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"ProgrammingLanguages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"Frameworks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"CustomAmiList":{"type":"list","member":{"type":"structure","members":{"VirtualizationType":{},"ImageId":{}}}},"SupportedTierList":{"shape":"S2s"},"SupportedAddonList":{"shape":"S2u"},"PlatformLifecycleState":{},"PlatformBranchName":{},"PlatformBranchLifecycleState":{}}}}}},"DisassociateEnvironmentOperationsRole":{"input":{"type":"structure","required":["EnvironmentName"],"members":{"EnvironmentName":{}}}},"ListAvailableSolutionStacks":{"output":{"resultWrapper":"ListAvailableSolutionStacksResult","type":"structure","members":{"SolutionStacks":{"type":"list","member":{}},"SolutionStackDetails":{"type":"list","member":{"type":"structure","members":{"SolutionStackName":{},"PermittedFileTypes":{"type":"list","member":{}}}}}}}},"ListPlatformBranches":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Attribute":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformBranchesResult","type":"structure","members":{"PlatformBranchSummaryList":{"type":"list","member":{"type":"structure","members":{"PlatformName":{},"BranchName":{},"LifecycleState":{},"BranchOrder":{"type":"integer"},"SupportedTierList":{"shape":"S2s"}}}},"NextToken":{}}}},"ListPlatformVersions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Type":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformVersionsResult","type":"structure","members":{"PlatformSummaryList":{"type":"list","member":{"shape":"S2m"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"ResourceArn":{},"ResourceTags":{"shape":"S7g"}}}},"RebuildEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RequestEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}}},"RestartAppServer":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RetrieveEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}},"output":{"resultWrapper":"RetrieveEnvironmentInfoResult","type":"structure","members":{"EnvironmentInfo":{"type":"list","member":{"type":"structure","members":{"InfoType":{},"Ec2InstanceId":{},"SampleTimestamp":{"type":"timestamp"},"Message":{}}}}}}},"SwapEnvironmentCNAMEs":{"input":{"type":"structure","members":{"SourceEnvironmentId":{},"SourceEnvironmentName":{},"DestinationEnvironmentId":{},"DestinationEnvironmentName":{}}}},"TerminateEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"TerminateResources":{"type":"boolean"},"ForceTerminate":{"type":"boolean"}}},"output":{"shape":"Sm","resultWrapper":"TerminateEnvironmentResult"}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{}}},"output":{"shape":"S1j","resultWrapper":"UpdateApplicationResult"}},"UpdateApplicationResourceLifecycle":{"input":{"type":"structure","required":["ApplicationName","ResourceLifecycleConfig"],"members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S19"}}},"output":{"resultWrapper":"UpdateApplicationResourceLifecycleResult","type":"structure","members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S19"}}}},"UpdateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{}}},"output":{"shape":"S21","resultWrapper":"UpdateApplicationVersionResult"}},"UpdateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"Description":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"}}},"output":{"shape":"S2d","resultWrapper":"UpdateConfigurationTemplateResult"}},"UpdateEnvironment":{"input":{"type":"structure","members":{"ApplicationName":{},"EnvironmentId":{},"EnvironmentName":{},"GroupName":{},"Description":{},"Tier":{"shape":"S13"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"}}},"output":{"shape":"Sm","resultWrapper":"UpdateEnvironmentResult"}},"UpdateTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S7g"},"TagsToRemove":{"type":"list","member":{}}}}},"ValidateConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName","OptionSettings"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"OptionSettings":{"shape":"S27"}}},"output":{"resultWrapper":"ValidateConfigurationSettingsResult","type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"Message":{},"Severity":{},"Namespace":{},"OptionName":{}}}}}}}},"shapes":{"Sk":{"type":"structure","members":{"Environments":{"type":"list","member":{"shape":"Sm"}},"NextToken":{}}},"Sm":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"ApplicationName":{},"VersionLabel":{},"SolutionStackName":{},"PlatformArn":{},"TemplateName":{},"Description":{},"EndpointURL":{},"CNAME":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{},"AbortableOperationInProgress":{"type":"boolean"},"Health":{},"HealthStatus":{},"Resources":{"type":"structure","members":{"LoadBalancer":{"type":"structure","members":{"LoadBalancerName":{},"Domain":{},"Listeners":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}}}}}}},"Tier":{"shape":"S13"},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"LinkName":{},"EnvironmentName":{}}}},"EnvironmentArn":{},"OperationsRole":{}}},"S13":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"S19":{"type":"structure","members":{"ServiceRole":{},"VersionLifecycleConfig":{"type":"structure","members":{"MaxCountRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxCount":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}},"MaxAgeRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInDays":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}}}}}},"S1f":{"type":"list","member":{"shape":"S1g"}},"S1g":{"type":"structure","members":{"Key":{},"Value":{}}},"S1j":{"type":"structure","members":{"Application":{"shape":"S1k"}}},"S1k":{"type":"structure","members":{"ApplicationArn":{},"ApplicationName":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Versions":{"shape":"S1m"},"ConfigurationTemplates":{"type":"list","member":{}},"ResourceLifecycleConfig":{"shape":"S19"}}},"S1m":{"type":"list","member":{}},"S1p":{"type":"structure","required":["SourceType","SourceRepository","SourceLocation"],"members":{"SourceType":{},"SourceRepository":{},"SourceLocation":{}}},"S1t":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S21":{"type":"structure","members":{"ApplicationVersion":{"shape":"S22"}}},"S22":{"type":"structure","members":{"ApplicationVersionArn":{},"ApplicationName":{},"Description":{},"VersionLabel":{},"SourceBuildInformation":{"shape":"S1p"},"BuildArn":{},"SourceBundle":{"shape":"S1t"},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{},"Value":{}}}},"S2d":{"type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"ApplicationName":{},"TemplateName":{},"Description":{},"EnvironmentName":{},"DeploymentStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"OptionSettings":{"shape":"S27"}}},"S2g":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{}}}},"S2m":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformStatus":{},"PlatformCategory":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"SupportedTierList":{"shape":"S2s"},"SupportedAddonList":{"shape":"S2u"},"PlatformLifecycleState":{},"PlatformVersion":{},"PlatformBranchName":{},"PlatformBranchLifecycleState":{}}},"S2s":{"type":"list","member":{}},"S2u":{"type":"list","member":{}},"S3c":{"type":"structure","members":{"Maximum":{"type":"integer"}}},"S48":{"type":"list","member":{}},"S4a":{"type":"structure","members":{"Duration":{"type":"integer"},"RequestCount":{"type":"integer"},"StatusCodes":{"type":"structure","members":{"Status2xx":{"type":"integer"},"Status3xx":{"type":"integer"},"Status4xx":{"type":"integer"},"Status5xx":{"type":"integer"}}},"Latency":{"type":"structure","members":{"P999":{"type":"double"},"P99":{"type":"double"},"P95":{"type":"double"},"P90":{"type":"double"},"P85":{"type":"double"},"P75":{"type":"double"},"P50":{"type":"double"},"P10":{"type":"double"}}}}},"S7g":{"type":"list","member":{"shape":"S1g"}}}}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeApplicationVersions":{"result_key":"ApplicationVersions"},"DescribeApplications":{"result_key":"Applications"},"DescribeConfigurationOptions":{"result_key":"Options"},"DescribeEnvironmentManagedActionHistory":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"ManagedActionHistoryItems"},"DescribeEnvironments":{"result_key":"Environments"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Events"},"ListAvailableSolutionStacks":{"result_key":"SolutionStacks"},"ListPlatformBranches":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"},"ListPlatformVersions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"PlatformSummaryList"}}}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"EnvironmentExists":{"delay":20,"maxAttempts":20,"operation":"DescribeEnvironments","acceptors":[{"state":"success","matcher":"pathAll","argument":"Environments[].Status","expected":"Ready"},{"state":"retry","matcher":"pathAll","argument":"Environments[].Status","expected":"Launching"}]},"EnvironmentUpdated":{"delay":20,"maxAttempts":20,"operation":"DescribeEnvironments","acceptors":[{"state":"success","matcher":"pathAll","argument":"Environments[].Status","expected":"Ready"},{"state":"retry","matcher":"pathAll","argument":"Environments[].Status","expected":"Updating"}]},"EnvironmentTerminated":{"delay":20,"maxAttempts":20,"operation":"DescribeEnvironments","acceptors":[{"state":"success","matcher":"pathAll","argument":"Environments[].Status","expected":"Terminated"},{"state":"retry","matcher":"pathAll","argument":"Environments[].Status","expected":"Terminating"}]}}}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['elb'] = {};
	AWS.ELB = Service.defineService('elb', ['2012-06-01']);
	Object.defineProperty(apiLoader.services['elb'], '2012-06-01', {
	  get: function get() {
	    var model = __webpack_require__(217);
	    model.paginators = __webpack_require__(218).pagination;
	    model.waiters = __webpack_require__(219).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ELB;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-06-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancing-2012-06-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"},"operations":{"AddTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"ApplySecurityGroupsToLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","SecurityGroups"],"members":{"LoadBalancerName":{},"SecurityGroups":{"shape":"Sa"}}},"output":{"resultWrapper":"ApplySecurityGroupsToLoadBalancerResult","type":"structure","members":{"SecurityGroups":{"shape":"Sa"}}}},"AttachLoadBalancerToSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"AttachLoadBalancerToSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"ConfigureHealthCheck":{"input":{"type":"structure","required":["LoadBalancerName","HealthCheck"],"members":{"LoadBalancerName":{},"HealthCheck":{"shape":"Si"}}},"output":{"resultWrapper":"ConfigureHealthCheckResult","type":"structure","members":{"HealthCheck":{"shape":"Si"}}}},"CreateAppCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","CookieName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieName":{}}},"output":{"resultWrapper":"CreateAppCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLBCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}},"output":{"resultWrapper":"CreateLBCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"SecurityGroups":{"shape":"Sa"},"Scheme":{},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"DNSName":{}}}},"CreateLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateLoadBalancerListenersResult","type":"structure","members":{}}},"CreateLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","PolicyTypeName"],"members":{"LoadBalancerName":{},"PolicyName":{},"PolicyTypeName":{},"PolicyAttributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}},"output":{"resultWrapper":"CreateLoadBalancerPolicyResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPorts"],"members":{"LoadBalancerName":{},"LoadBalancerPorts":{"type":"list","member":{"type":"integer"}}}},"output":{"resultWrapper":"DeleteLoadBalancerListenersResult","type":"structure","members":{}}},"DeleteLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerPolicyResult","type":"structure","members":{}}},"DeregisterInstancesFromLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DeregisterInstancesFromLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeInstanceHealth":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeInstanceHealthResult","type":"structure","members":{"InstanceStates":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"State":{},"ReasonCode":{},"Description":{}}}}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerAttributes":{"shape":"S2a"}}}},"DescribeLoadBalancerPolicies":{"input":{"type":"structure","members":{"LoadBalancerName":{},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"DescribeLoadBalancerPoliciesResult","type":"structure","members":{"PolicyDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyTypeName":{},"PolicyAttributeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}}}}}},"DescribeLoadBalancerPolicyTypes":{"input":{"type":"structure","members":{"PolicyTypeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLoadBalancerPolicyTypesResult","type":"structure","members":{"PolicyTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyTypeName":{},"Description":{},"PolicyAttributeTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{},"Description":{},"DefaultValue":{},"Cardinality":{}}}}}}}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerNames":{"shape":"S2"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancerDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"DNSName":{},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"shape":"Sy"},"PolicyNames":{"shape":"S2s"}}}},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieName":{}}}},"LBCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}}},"OtherPolicies":{"shape":"S2s"}}},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}}},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"VPCId":{},"Instances":{"shape":"S1p"},"HealthCheck":{"shape":"Si"},"SourceSecurityGroup":{"type":"structure","members":{"OwnerAlias":{},"GroupName":{}}},"SecurityGroups":{"shape":"Sa"},"CreatedTime":{"type":"timestamp"},"Scheme":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["LoadBalancerNames"],"members":{"LoadBalancerNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"Tags":{"shape":"S4"}}}}}}},"DetachLoadBalancerFromSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"DetachLoadBalancerFromSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"DisableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"DisableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"EnableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"EnableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerAttributes"],"members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}}},"RegisterInstancesWithLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"RegisterInstancesWithLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"RemoveTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"type":"list","member":{"type":"structure","members":{"Key":{}}}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetLoadBalancerListenerSSLCertificate":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","SSLCertificateId"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"SSLCertificateId":{}}},"output":{"resultWrapper":"SetLoadBalancerListenerSSLCertificateResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesForBackendServer":{"input":{"type":"structure","required":["LoadBalancerName","InstancePort","PolicyNames"],"members":{"LoadBalancerName":{},"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesForBackendServerResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesOfListener":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","PolicyNames"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesOfListenerResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Si":{"type":"structure","required":["Target","Interval","Timeout","UnhealthyThreshold","HealthyThreshold"],"members":{"Target":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"},"HealthyThreshold":{"type":"integer"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Protocol","LoadBalancerPort","InstancePort"],"members":{"Protocol":{},"LoadBalancerPort":{"type":"integer"},"InstanceProtocol":{},"InstancePort":{"type":"integer"},"SSLCertificateId":{}}},"S13":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"S2a":{"type":"structure","members":{"CrossZoneLoadBalancing":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"AccessLog":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"S3BucketName":{},"EmitInterval":{"type":"integer"},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","required":["IdleTimeout"],"members":{"IdleTimeout":{"type":"integer"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S2s":{"type":"list","member":{}}}}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeInstanceHealth":{"result_key":"InstanceStates"},"DescribeLoadBalancerPolicies":{"result_key":"PolicyDescriptions"},"DescribeLoadBalancerPolicyTypes":{"result_key":"PolicyTypeDescriptions"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancerDescriptions"}}}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"InstanceDeregistered":{"delay":15,"operation":"DescribeInstanceHealth","maxAttempts":40,"acceptors":[{"expected":"OutOfService","matcher":"pathAll","state":"success","argument":"InstanceStates[].State"},{"matcher":"error","expected":"InvalidInstance","state":"success"}]},"AnyInstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAny","state":"success"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"},"InstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"}}}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['elbv2'] = {};
	AWS.ELBv2 = Service.defineService('elbv2', ['2015-12-01']);
	Object.defineProperty(apiLoader.services['elbv2'], '2015-12-01', {
	  get: function get() {
	    var model = __webpack_require__(221);
	    model.paginators = __webpack_require__(222).pagination;
	    model.waiters = __webpack_require__(223).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ELBv2;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceAbbreviation":"Elastic Load Balancing v2","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing v2","signatureVersion":"v4","uid":"elasticloadbalancingv2-2015-12-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"},"operations":{"AddListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"AddListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArns","Tags"],"members":{"ResourceArns":{"shape":"S9"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"CreateListener":{"input":{"type":"structure","required":["LoadBalancerArn","DefaultActions"],"members":{"LoadBalancerArn":{},"Protocol":{},"Port":{"type":"integer"},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"},"AlpnPolicy":{"shape":"S1y"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateListenerResult","type":"structure","members":{"Listeners":{"shape":"S21"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Subnets":{"shape":"S25"},"SubnetMappings":{"shape":"S27"},"SecurityGroups":{"shape":"S2c"},"Scheme":{},"Tags":{"shape":"Sb"},"Type":{},"IpAddressType":{},"CustomerOwnedIpv4Pool":{}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"LoadBalancers":{"shape":"S2j"}}}},"CreateRule":{"input":{"type":"structure","required":["ListenerArn","Conditions","Priority","Actions"],"members":{"ListenerArn":{},"Conditions":{"shape":"S30"},"Priority":{"type":"integer"},"Actions":{"shape":"Sl"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateRuleResult","type":"structure","members":{"Rules":{"shape":"S3g"}}}},"CreateTargetGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Protocol":{},"ProtocolVersion":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S3u"},"TargetType":{},"Tags":{"shape":"Sb"},"IpAddressType":{}}},"output":{"resultWrapper":"CreateTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S40"}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"resultWrapper":"DeleteListenerResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{}}},"output":{"resultWrapper":"DeleteRuleResult","type":"structure","members":{}}},"DeleteTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DeleteTargetGroupResult","type":"structure","members":{}}},"DeregisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S4c"}}},"output":{"resultWrapper":"DeregisterTargetsResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeListenerCertificates":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"},"NextMarker":{}}}},"DescribeListeners":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"ListenerArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenersResult","type":"structure","members":{"Listeners":{"shape":"S21"},"NextMarker":{}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S4v"}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerArns":{"shape":"S42"},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"shape":"S2j"},"NextMarker":{}}}},"DescribeRules":{"input":{"type":"structure","members":{"ListenerArn":{},"RuleArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeRulesResult","type":"structure","members":{"Rules":{"shape":"S3g"},"NextMarker":{}}}},"DescribeSSLPolicies":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"},"LoadBalancerType":{}}},"output":{"resultWrapper":"DescribeSSLPoliciesResult","type":"structure","members":{"SslPolicies":{"type":"list","member":{"type":"structure","members":{"SslProtocols":{"type":"list","member":{}},"Ciphers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Priority":{"type":"integer"}}}},"Name":{},"SupportedLoadBalancerTypes":{"shape":"S33"}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"shape":"S9"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}}}}}},"DescribeTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DescribeTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S5m"}}}},"DescribeTargetGroups":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"TargetGroupArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTargetGroupsResult","type":"structure","members":{"TargetGroups":{"shape":"S40"},"NextMarker":{}}}},"DescribeTargetHealth":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S4c"}}},"output":{"resultWrapper":"DescribeTargetHealthResult","type":"structure","members":{"TargetHealthDescriptions":{"type":"list","member":{"type":"structure","members":{"Target":{"shape":"S4d"},"HealthCheckPort":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}}}}},"ModifyListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Port":{"type":"integer"},"Protocol":{},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"},"AlpnPolicy":{"shape":"S1y"}}},"output":{"resultWrapper":"ModifyListenerResult","type":"structure","members":{"Listeners":{"shape":"S21"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn","Attributes"],"members":{"LoadBalancerArn":{},"Attributes":{"shape":"S4v"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S4v"}}}},"ModifyRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{},"Conditions":{"shape":"S30"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyRuleResult","type":"structure","members":{"Rules":{"shape":"S3g"}}}},"ModifyTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S3u"}}},"output":{"resultWrapper":"ModifyTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S40"}}}},"ModifyTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn","Attributes"],"members":{"TargetGroupArn":{},"Attributes":{"shape":"S5m"}}},"output":{"resultWrapper":"ModifyTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S5m"}}}},"RegisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S4c"}}},"output":{"resultWrapper":"RegisterTargetsResult","type":"structure","members":{}}},"RemoveListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"RemoveListenerCertificatesResult","type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceArns","TagKeys"],"members":{"ResourceArns":{"shape":"S9"},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetIpAddressType":{"input":{"type":"structure","required":["LoadBalancerArn","IpAddressType"],"members":{"LoadBalancerArn":{},"IpAddressType":{}}},"output":{"resultWrapper":"SetIpAddressTypeResult","type":"structure","members":{"IpAddressType":{}}}},"SetRulePriorities":{"input":{"type":"structure","required":["RulePriorities"],"members":{"RulePriorities":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{"type":"integer"}}}}}},"output":{"resultWrapper":"SetRulePrioritiesResult","type":"structure","members":{"Rules":{"shape":"S3g"}}}},"SetSecurityGroups":{"input":{"type":"structure","required":["LoadBalancerArn","SecurityGroups"],"members":{"LoadBalancerArn":{},"SecurityGroups":{"shape":"S2c"}}},"output":{"resultWrapper":"SetSecurityGroupsResult","type":"structure","members":{"SecurityGroupIds":{"shape":"S2c"}}}},"SetSubnets":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{},"Subnets":{"shape":"S25"},"SubnetMappings":{"shape":"S27"},"IpAddressType":{}}},"output":{"resultWrapper":"SetSubnetsResult","type":"structure","members":{"AvailabilityZones":{"shape":"S2s"},"IpAddressType":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"IsDefault":{"type":"boolean"}}}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"TargetGroupArn":{},"AuthenticateOidcConfig":{"type":"structure","required":["Issuer","AuthorizationEndpoint","TokenEndpoint","UserInfoEndpoint","ClientId"],"members":{"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"ClientId":{},"ClientSecret":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{},"UseExistingClientSecret":{"type":"boolean"}}},"AuthenticateCognitoConfig":{"type":"structure","required":["UserPoolArn","UserPoolClientId","UserPoolDomain"],"members":{"UserPoolArn":{},"UserPoolClientId":{},"UserPoolDomain":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{}}},"Order":{"type":"integer"},"RedirectConfig":{"type":"structure","required":["StatusCode"],"members":{"Protocol":{},"Port":{},"Host":{},"Path":{},"Query":{},"StatusCode":{}}},"FixedResponseConfig":{"type":"structure","required":["StatusCode"],"members":{"MessageBody":{},"StatusCode":{},"ContentType":{}}},"ForwardConfig":{"type":"structure","members":{"TargetGroups":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"Weight":{"type":"integer"}}}},"TargetGroupStickinessConfig":{"type":"structure","members":{"Enabled":{"type":"boolean"},"DurationSeconds":{"type":"integer"}}}}}}}},"S1y":{"type":"list","member":{}},"S21":{"type":"list","member":{"type":"structure","members":{"ListenerArn":{},"LoadBalancerArn":{},"Port":{"type":"integer"},"Protocol":{},"Certificates":{"shape":"S3"},"SslPolicy":{},"DefaultActions":{"shape":"Sl"},"AlpnPolicy":{"shape":"S1y"}}}},"S25":{"type":"list","member":{}},"S27":{"type":"list","member":{"type":"structure","members":{"SubnetId":{},"AllocationId":{},"PrivateIPv4Address":{},"IPv6Address":{}}}},"S2c":{"type":"list","member":{}},"S2j":{"type":"list","member":{"type":"structure","members":{"LoadBalancerArn":{},"DNSName":{},"CanonicalHostedZoneId":{},"CreatedTime":{"type":"timestamp"},"LoadBalancerName":{},"Scheme":{},"VpcId":{},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"AvailabilityZones":{"shape":"S2s"},"SecurityGroups":{"shape":"S2c"},"IpAddressType":{},"CustomerOwnedIpv4Pool":{}}}},"S2s":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{},"OutpostId":{},"LoadBalancerAddresses":{"type":"list","member":{"type":"structure","members":{"IpAddress":{},"AllocationId":{},"PrivateIPv4Address":{},"IPv6Address":{}}}}}}},"S30":{"type":"list","member":{"type":"structure","members":{"Field":{},"Values":{"shape":"S33"},"HostHeaderConfig":{"type":"structure","members":{"Values":{"shape":"S33"}}},"PathPatternConfig":{"type":"structure","members":{"Values":{"shape":"S33"}}},"HttpHeaderConfig":{"type":"structure","members":{"HttpHeaderName":{},"Values":{"shape":"S33"}}},"QueryStringConfig":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"HttpRequestMethodConfig":{"type":"structure","members":{"Values":{"shape":"S33"}}},"SourceIpConfig":{"type":"structure","members":{"Values":{"shape":"S33"}}}}}},"S33":{"type":"list","member":{}},"S3g":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{},"Conditions":{"shape":"S30"},"Actions":{"shape":"Sl"},"IsDefault":{"type":"boolean"}}}},"S3u":{"type":"structure","members":{"HttpCode":{},"GrpcCode":{}}},"S40":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"TargetGroupName":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"HealthCheckPath":{},"Matcher":{"shape":"S3u"},"LoadBalancerArns":{"shape":"S42"},"TargetType":{},"ProtocolVersion":{},"IpAddressType":{}}}},"S42":{"type":"list","member":{}},"S4c":{"type":"list","member":{"shape":"S4d"}},"S4d":{"type":"structure","required":["Id"],"members":{"Id":{},"Port":{"type":"integer"},"AvailabilityZone":{}}},"S4v":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S5m":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"}}}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"LoadBalancerExists":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"retry"}]},"LoadBalancerAvailable":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"state":"retry","matcher":"pathAny","argument":"LoadBalancers[].State.Code","expected":"provisioning"},{"state":"retry","matcher":"error","expected":"LoadBalancerNotFound"}]},"LoadBalancersDeleted":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"retry","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"success"}]},"TargetInService":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"healthy","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}]},"TargetDeregistered":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"matcher":"error","expected":"InvalidTarget","state":"success"},{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"unused","matcher":"pathAll","state":"success"}]}}}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['emr'] = {};
	AWS.EMR = Service.defineService('emr', ['2009-03-31']);
	Object.defineProperty(apiLoader.services['emr'], '2009-03-31', {
	  get: function get() {
	    var model = __webpack_require__(225);
	    model.paginators = __webpack_require__(226).pagination;
	    model.waiters = __webpack_require__(227).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EMR;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2009-03-31","endpointPrefix":"elasticmapreduce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon EMR","serviceFullName":"Amazon EMR","serviceId":"EMR","signatureVersion":"v4","targetPrefix":"ElasticMapReduce","uid":"elasticmapreduce-2009-03-31"},"operations":{"AddInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"shape":"S3"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceFleetId":{},"ClusterArn":{}}}},"AddInstanceGroups":{"input":{"type":"structure","required":["InstanceGroups","JobFlowId"],"members":{"InstanceGroups":{"shape":"Sx"},"JobFlowId":{}}},"output":{"type":"structure","members":{"JobFlowId":{},"InstanceGroupIds":{"type":"list","member":{}},"ClusterArn":{}}}},"AddJobFlowSteps":{"input":{"type":"structure","required":["JobFlowId","Steps"],"members":{"JobFlowId":{},"Steps":{"shape":"S1i"}}},"output":{"type":"structure","members":{"StepIds":{"shape":"S1r"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S1u"}}},"output":{"type":"structure","members":{}}},"CancelSteps":{"input":{"type":"structure","required":["ClusterId","StepIds"],"members":{"ClusterId":{},"StepIds":{"shape":"S1r"},"StepCancellationOption":{}}},"output":{"type":"structure","members":{"CancelStepsInfoList":{"type":"list","member":{"type":"structure","members":{"StepId":{},"Status":{},"Reason":{}}}}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","SecurityConfiguration"],"members":{"Name":{},"SecurityConfiguration":{}}},"output":{"type":"structure","required":["Name","CreationDateTime"],"members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"CreateStudio":{"input":{"type":"structure","required":["Name","AuthMode","VpcId","SubnetIds","ServiceRole","WorkspaceSecurityGroupId","EngineSecurityGroupId","DefaultS3Location"],"members":{"Name":{},"Description":{},"AuthMode":{},"VpcId":{},"SubnetIds":{"shape":"S29"},"ServiceRole":{},"UserRole":{},"WorkspaceSecurityGroupId":{},"EngineSecurityGroupId":{},"DefaultS3Location":{},"IdpAuthUrl":{},"IdpRelayStateParameterName":{},"Tags":{"shape":"S1u"}}},"output":{"type":"structure","members":{"StudioId":{},"Url":{}}}},"CreateStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType","SessionPolicyArn"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteStudio":{"input":{"type":"structure","required":["StudioId"],"members":{"StudioId":{}}}},"DeleteStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{}}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S2l"},"Ec2InstanceAttributes":{"type":"structure","members":{"Ec2KeyName":{},"Ec2SubnetId":{},"RequestedEc2SubnetIds":{"shape":"S2r"},"Ec2AvailabilityZone":{},"RequestedEc2AvailabilityZones":{"shape":"S2r"},"IamInstanceProfile":{},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S2s"},"AdditionalSlaveSecurityGroups":{"shape":"S2s"}}},"InstanceCollectionType":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"RequestedAmiVersion":{},"RunningAmiVersion":{},"ReleaseLabel":{},"AutoTerminate":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"VisibleToAllUsers":{"type":"boolean"},"Applications":{"shape":"S2v"},"Tags":{"shape":"S1u"},"ServiceRole":{},"NormalizedInstanceHours":{"type":"integer"},"MasterPublicDnsName":{},"Configurations":{"shape":"Sh"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2z"},"ClusterArn":{},"OutpostArn":{},"StepConcurrencyLevel":{"type":"integer"},"PlacementGroups":{"shape":"S31"}}}}}},"DescribeJobFlows":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"JobFlowIds":{"shape":"S1p"},"JobFlowStates":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobFlows":{"type":"list","member":{"type":"structure","required":["JobFlowId","Name","ExecutionStatusDetail","Instances"],"members":{"JobFlowId":{},"Name":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"AmiVersion":{},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}},"Instances":{"type":"structure","required":["MasterInstanceType","SlaveInstanceType","InstanceCount"],"members":{"MasterInstanceType":{},"MasterPublicDnsName":{},"MasterInstanceId":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["Market","InstanceRole","InstanceType","InstanceRequestCount","InstanceRunningCount","State","CreationDateTime"],"members":{"InstanceGroupId":{},"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceRequestCount":{"type":"integer"},"InstanceRunningCount":{"type":"integer"},"State":{},"LastStateChangeReason":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"CustomAmiId":{}}}},"NormalizedInstanceHours":{"type":"integer"},"Ec2KeyName":{},"Ec2SubnetId":{},"Placement":{"shape":"S3f"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{}}},"Steps":{"type":"list","member":{"type":"structure","required":["StepConfig","ExecutionStatusDetail"],"members":{"StepConfig":{"shape":"S1j"},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}}}}},"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"BootstrapActionConfig":{"shape":"S3m"}}}},"SupportedProducts":{"shape":"S3o"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"AutoScalingRole":{},"ScaleDownBehavior":{}}}}}},"deprecated":true},"DescribeNotebookExecution":{"input":{"type":"structure","required":["NotebookExecutionId"],"members":{"NotebookExecutionId":{}}},"output":{"type":"structure","members":{"NotebookExecution":{"type":"structure","members":{"NotebookExecutionId":{},"EditorId":{},"ExecutionEngine":{"shape":"S3s"},"NotebookExecutionName":{},"NotebookParams":{},"Status":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Arn":{},"OutputNotebookURI":{},"LastStateChangeReason":{},"NotebookInstanceSecurityGroupId":{},"Tags":{"shape":"S1u"}}}}}},"DescribeReleaseLabel":{"input":{"type":"structure","members":{"ReleaseLabel":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ReleaseLabel":{},"Applications":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"NextToken":{}}}},"DescribeSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"SecurityConfiguration":{},"CreationDateTime":{"type":"timestamp"}}}},"DescribeStep":{"input":{"type":"structure","required":["ClusterId","StepId"],"members":{"ClusterId":{},"StepId":{}}},"output":{"type":"structure","members":{"Step":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S45"},"ActionOnFailure":{},"Status":{"shape":"S46"}}}}}},"DescribeStudio":{"input":{"type":"structure","required":["StudioId"],"members":{"StudioId":{}}},"output":{"type":"structure","members":{"Studio":{"type":"structure","members":{"StudioId":{},"StudioArn":{},"Name":{},"Description":{},"AuthMode":{},"VpcId":{},"SubnetIds":{"shape":"S29"},"ServiceRole":{},"UserRole":{},"WorkspaceSecurityGroupId":{},"EngineSecurityGroupId":{},"Url":{},"CreationTime":{"type":"timestamp"},"DefaultS3Location":{},"IdpAuthUrl":{},"IdpRelayStateParameterName":{},"Tags":{"shape":"S1u"}}}}}},"GetAutoTerminationPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"AutoTerminationPolicy":{"shape":"S4h"}}}},"GetBlockPublicAccessConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["BlockPublicAccessConfiguration","BlockPublicAccessConfigurationMetadata"],"members":{"BlockPublicAccessConfiguration":{"shape":"S4l"},"BlockPublicAccessConfigurationMetadata":{"type":"structure","required":["CreationDateTime","CreatedByArn"],"members":{"CreationDateTime":{"type":"timestamp"},"CreatedByArn":{}}}}}},"GetManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"ManagedScalingPolicy":{"shape":"S4s"}}}},"GetStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{}}},"output":{"type":"structure","members":{"SessionMapping":{"type":"structure","members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}}}},"ListBootstrapActions":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ScriptPath":{},"Args":{"shape":"S2s"}}}},"Marker":{}}}},"ListClusters":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ClusterStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S2l"},"NormalizedInstanceHours":{"type":"integer"},"ClusterArn":{},"OutpostArn":{}}}},"Marker":{}}}},"ListInstanceFleets":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceFleets":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ProvisionedOnDemandCapacity":{"type":"integer"},"ProvisionedSpotCapacity":{"type":"integer"},"InstanceTypeSpecifications":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S5j"},"EbsOptimized":{"type":"boolean"},"CustomAmiId":{}}}},"LaunchSpecifications":{"shape":"Sk"}}}},"Marker":{}}}},"ListInstanceGroups":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Market":{},"InstanceGroupType":{},"BidPrice":{},"InstanceType":{},"RequestedInstanceCount":{"type":"integer"},"RunningInstanceCount":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"Configurations":{"shape":"Sh"},"ConfigurationsVersion":{"type":"long"},"LastSuccessfullyAppliedConfigurations":{"shape":"Sh"},"LastSuccessfullyAppliedConfigurationsVersion":{"type":"long"},"EbsBlockDevices":{"shape":"S5j"},"EbsOptimized":{"type":"boolean"},"ShrinkPolicy":{"shape":"S5v"},"AutoScalingPolicy":{"shape":"S5z"},"CustomAmiId":{}}}},"Marker":{}}}},"ListInstances":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"InstanceGroupId":{},"InstanceGroupTypes":{"type":"list","member":{}},"InstanceFleetId":{},"InstanceFleetType":{},"InstanceStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Ec2InstanceId":{},"PublicDnsName":{},"PublicIpAddress":{},"PrivateDnsName":{},"PrivateIpAddress":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceGroupId":{},"InstanceFleetId":{},"Market":{},"InstanceType":{},"EbsVolumes":{"type":"list","member":{"type":"structure","members":{"Device":{},"VolumeId":{}}}}}}},"Marker":{}}}},"ListNotebookExecutions":{"input":{"type":"structure","members":{"EditorId":{},"Status":{},"From":{"type":"timestamp"},"To":{"type":"timestamp"},"Marker":{}}},"output":{"type":"structure","members":{"NotebookExecutions":{"type":"list","member":{"type":"structure","members":{"NotebookExecutionId":{},"EditorId":{},"NotebookExecutionName":{},"Status":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListReleaseLabels":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Prefix":{},"Application":{}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ReleaseLabels":{"shape":"S2s"},"NextToken":{}}}},"ListSecurityConfigurations":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSteps":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepStates":{"type":"list","member":{}},"StepIds":{"shape":"S1p"},"Marker":{}}},"output":{"type":"structure","members":{"Steps":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S45"},"ActionOnFailure":{},"Status":{"shape":"S46"}}}},"Marker":{}}}},"ListStudioSessionMappings":{"input":{"type":"structure","members":{"StudioId":{},"IdentityType":{},"Marker":{}}},"output":{"type":"structure","members":{"SessionMappings":{"type":"list","member":{"type":"structure","members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{},"CreationTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListStudios":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"Studios":{"type":"list","member":{"type":"structure","members":{"StudioId":{},"Name":{},"VpcId":{},"Description":{},"Url":{},"AuthMode":{},"CreationTime":{"type":"timestamp"}}}},"Marker":{}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepConcurrencyLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"StepConcurrencyLevel":{"type":"integer"}}}},"ModifyInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"type":"structure","required":["InstanceFleetId"],"members":{"InstanceFleetId":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"}}}}}},"ModifyInstanceGroups":{"input":{"type":"structure","members":{"ClusterId":{},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["InstanceGroupId"],"members":{"InstanceGroupId":{},"InstanceCount":{"type":"integer"},"EC2InstanceIdsToTerminate":{"type":"list","member":{}},"ShrinkPolicy":{"shape":"S5v"},"Configurations":{"shape":"Sh"}}}}}}},"PutAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId","AutoScalingPolicy"],"members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S11"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S5z"},"ClusterArn":{}}}},"PutAutoTerminationPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"AutoTerminationPolicy":{"shape":"S4h"}}},"output":{"type":"structure","members":{}}},"PutBlockPublicAccessConfiguration":{"input":{"type":"structure","required":["BlockPublicAccessConfiguration"],"members":{"BlockPublicAccessConfiguration":{"shape":"S4l"}}},"output":{"type":"structure","members":{}}},"PutManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId","ManagedScalingPolicy"],"members":{"ClusterId":{},"ManagedScalingPolicy":{"shape":"S4s"}}},"output":{"type":"structure","members":{}}},"RemoveAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId"],"members":{"ClusterId":{},"InstanceGroupId":{}}},"output":{"type":"structure","members":{}}},"RemoveAutoTerminationPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"RemoveManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"shape":"S2s"}}},"output":{"type":"structure","members":{}}},"RunJobFlow":{"input":{"type":"structure","required":["Name","Instances"],"members":{"Name":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"AdditionalInfo":{},"AmiVersion":{},"ReleaseLabel":{},"Instances":{"type":"structure","members":{"MasterInstanceType":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"shape":"Sx"},"InstanceFleets":{"type":"list","member":{"shape":"S3"}},"Ec2KeyName":{},"Placement":{"shape":"S3f"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{},"Ec2SubnetId":{},"Ec2SubnetIds":{"shape":"S2r"},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S7w"},"AdditionalSlaveSecurityGroups":{"shape":"S7w"}}},"Steps":{"shape":"S1i"},"BootstrapActions":{"type":"list","member":{"shape":"S3m"}},"SupportedProducts":{"shape":"S3o"},"NewSupportedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Args":{"shape":"S1p"}}}},"Applications":{"shape":"S2v"},"Configurations":{"shape":"Sh"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"Tags":{"shape":"S1u"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2z"},"StepConcurrencyLevel":{"type":"integer"},"ManagedScalingPolicy":{"shape":"S4s"},"PlacementGroupConfigs":{"shape":"S31"},"AutoTerminationPolicy":{"shape":"S4h"}}},"output":{"type":"structure","members":{"JobFlowId":{},"ClusterArn":{}}}},"SetTerminationProtection":{"input":{"type":"structure","required":["JobFlowIds","TerminationProtected"],"members":{"JobFlowIds":{"shape":"S1p"},"TerminationProtected":{"type":"boolean"}}}},"SetVisibleToAllUsers":{"input":{"type":"structure","required":["JobFlowIds","VisibleToAllUsers"],"members":{"JobFlowIds":{"shape":"S1p"},"VisibleToAllUsers":{"type":"boolean"}}}},"StartNotebookExecution":{"input":{"type":"structure","required":["EditorId","RelativePath","ExecutionEngine","ServiceRole"],"members":{"EditorId":{},"RelativePath":{},"NotebookExecutionName":{},"NotebookParams":{},"ExecutionEngine":{"shape":"S3s"},"ServiceRole":{},"NotebookInstanceSecurityGroupId":{},"Tags":{"shape":"S1u"}}},"output":{"type":"structure","members":{"NotebookExecutionId":{}}}},"StopNotebookExecution":{"input":{"type":"structure","required":["NotebookExecutionId"],"members":{"NotebookExecutionId":{}}}},"TerminateJobFlows":{"input":{"type":"structure","required":["JobFlowIds"],"members":{"JobFlowIds":{"shape":"S1p"}}}},"UpdateStudio":{"input":{"type":"structure","required":["StudioId"],"members":{"StudioId":{},"Name":{},"Description":{},"SubnetIds":{"shape":"S29"},"DefaultS3Location":{}}}},"UpdateStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType","SessionPolicyArn"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{}}}}},"shapes":{"S3":{"type":"structure","required":["InstanceFleetType"],"members":{"Name":{},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"InstanceTypeConfigs":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"EbsConfiguration":{"shape":"Sa"},"Configurations":{"shape":"Sh"},"CustomAmiId":{}}}},"LaunchSpecifications":{"shape":"Sk"}}},"Sa":{"type":"structure","members":{"EbsBlockDeviceConfigs":{"type":"list","member":{"type":"structure","required":["VolumeSpecification"],"members":{"VolumeSpecification":{"shape":"Sd"},"VolumesPerInstance":{"type":"integer"}}}},"EbsOptimized":{"type":"boolean"}}},"Sd":{"type":"structure","required":["VolumeType","SizeInGB"],"members":{"VolumeType":{},"Iops":{"type":"integer"},"SizeInGB":{"type":"integer"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Classification":{},"Configurations":{"shape":"Sh"},"Properties":{"shape":"Sj"}}}},"Sj":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","members":{"SpotSpecification":{"type":"structure","required":["TimeoutDurationMinutes","TimeoutAction"],"members":{"TimeoutDurationMinutes":{"type":"integer"},"TimeoutAction":{},"BlockDurationMinutes":{"type":"integer"},"AllocationStrategy":{}}},"OnDemandSpecification":{"type":"structure","required":["AllocationStrategy"],"members":{"AllocationStrategy":{},"CapacityReservationOptions":{"type":"structure","members":{"UsageStrategy":{},"CapacityReservationPreference":{},"CapacityReservationResourceGroupArn":{}}}}}}},"Sx":{"type":"list","member":{"type":"structure","required":["InstanceRole","InstanceType","InstanceCount"],"members":{"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceCount":{"type":"integer"},"Configurations":{"shape":"Sh"},"EbsConfiguration":{"shape":"Sa"},"AutoScalingPolicy":{"shape":"S11"},"CustomAmiId":{}}}},"S11":{"type":"structure","required":["Constraints","Rules"],"members":{"Constraints":{"shape":"S12"},"Rules":{"shape":"S13"}}},"S12":{"type":"structure","required":["MinCapacity","MaxCapacity"],"members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"S13":{"type":"list","member":{"type":"structure","required":["Name","Action","Trigger"],"members":{"Name":{},"Description":{},"Action":{"type":"structure","required":["SimpleScalingPolicyConfiguration"],"members":{"Market":{},"SimpleScalingPolicyConfiguration":{"type":"structure","required":["ScalingAdjustment"],"members":{"AdjustmentType":{},"ScalingAdjustment":{"type":"integer"},"CoolDown":{"type":"integer"}}}}},"Trigger":{"type":"structure","required":["CloudWatchAlarmDefinition"],"members":{"CloudWatchAlarmDefinition":{"type":"structure","required":["ComparisonOperator","MetricName","Period","Threshold"],"members":{"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"Namespace":{},"Period":{"type":"integer"},"Statistic":{},"Threshold":{"type":"double"},"Unit":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}}}}}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","required":["Name","HadoopJarStep"],"members":{"Name":{},"ActionOnFailure":{},"HadoopJarStep":{"type":"structure","required":["Jar"],"members":{"Properties":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Jar":{},"MainClass":{},"Args":{"shape":"S1p"}}}}},"S1p":{"type":"list","member":{}},"S1r":{"type":"list","member":{}},"S1u":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S29":{"type":"list","member":{}},"S2l":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S2r":{"type":"list","member":{}},"S2s":{"type":"list","member":{}},"S2v":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Args":{"shape":"S2s"},"AdditionalInfo":{"shape":"Sj"}}}},"S2z":{"type":"structure","required":["Realm","KdcAdminPassword"],"members":{"Realm":{},"KdcAdminPassword":{},"CrossRealmTrustPrincipalPassword":{},"ADDomainJoinUser":{},"ADDomainJoinPassword":{}}},"S31":{"type":"list","member":{"type":"structure","required":["InstanceRole"],"members":{"InstanceRole":{},"PlacementStrategy":{}}}},"S3f":{"type":"structure","members":{"AvailabilityZone":{},"AvailabilityZones":{"shape":"S2r"}}},"S3m":{"type":"structure","required":["Name","ScriptBootstrapAction"],"members":{"Name":{},"ScriptBootstrapAction":{"type":"structure","required":["Path"],"members":{"Path":{},"Args":{"shape":"S1p"}}}}},"S3o":{"type":"list","member":{}},"S3s":{"type":"structure","required":["Id"],"members":{"Id":{},"Type":{},"MasterInstanceSecurityGroupId":{}}},"S45":{"type":"structure","members":{"Jar":{},"Properties":{"shape":"Sj"},"MainClass":{},"Args":{"shape":"S2s"}}},"S46":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"FailureDetails":{"type":"structure","members":{"Reason":{},"Message":{},"LogFile":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S4h":{"type":"structure","members":{"IdleTimeout":{"type":"long"}}},"S4l":{"type":"structure","required":["BlockPublicSecurityGroupRules"],"members":{"BlockPublicSecurityGroupRules":{"type":"boolean"},"PermittedPublicSecurityGroupRuleRanges":{"type":"list","member":{"type":"structure","required":["MinRange"],"members":{"MinRange":{"type":"integer"},"MaxRange":{"type":"integer"}}}}}},"S4s":{"type":"structure","members":{"ComputeLimits":{"type":"structure","required":["UnitType","MinimumCapacityUnits","MaximumCapacityUnits"],"members":{"UnitType":{},"MinimumCapacityUnits":{"type":"integer"},"MaximumCapacityUnits":{"type":"integer"},"MaximumOnDemandCapacityUnits":{"type":"integer"},"MaximumCoreCapacityUnits":{"type":"integer"}}}}},"S5j":{"type":"list","member":{"type":"structure","members":{"VolumeSpecification":{"shape":"Sd"},"Device":{}}}},"S5v":{"type":"structure","members":{"DecommissionTimeout":{"type":"integer"},"InstanceResizePolicy":{"type":"structure","members":{"InstancesToTerminate":{"shape":"S5x"},"InstancesToProtect":{"shape":"S5x"},"InstanceTerminationTimeout":{"type":"integer"}}}}},"S5x":{"type":"list","member":{}},"S5z":{"type":"structure","members":{"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}}}},"Constraints":{"shape":"S12"},"Rules":{"shape":"S13"}}},"S7w":{"type":"list","member":{}}}}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeJobFlows":{"result_key":"JobFlows"},"ListBootstrapActions":{"input_token":"Marker","output_token":"Marker","result_key":"BootstrapActions"},"ListClusters":{"input_token":"Marker","output_token":"Marker","result_key":"Clusters"},"ListInstanceFleets":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceFleets"},"ListInstanceGroups":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceGroups"},"ListInstances":{"input_token":"Marker","output_token":"Marker","result_key":"Instances"},"ListNotebookExecutions":{"input_token":"Marker","output_token":"Marker","result_key":"NotebookExecutions"},"ListReleaseLabels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListSecurityConfigurations":{"input_token":"Marker","output_token":"Marker","result_key":"SecurityConfigurations"},"ListSteps":{"input_token":"Marker","output_token":"Marker","result_key":"Steps"},"ListStudioSessionMappings":{"input_token":"Marker","output_token":"Marker","result_key":"SessionMappings"},"ListStudios":{"input_token":"Marker","output_token":"Marker","result_key":"Studios"}}}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ClusterRunning":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"RUNNING"},{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"WAITING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]},"StepComplete":{"delay":30,"operation":"DescribeStep","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Step.Status.State","expected":"COMPLETED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"CANCELLED"}]},"ClusterTerminated":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]}}}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['es'] = {};
	AWS.ES = Service.defineService('es', ['2015-01-01']);
	Object.defineProperty(apiLoader.services['es'], '2015-01-01', {
	  get: function get() {
	    var model = __webpack_require__(229);
	    model.paginators = __webpack_require__(230).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ES;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-01-01","endpointPrefix":"es","protocol":"rest-json","serviceFullName":"Amazon Elasticsearch Service","serviceId":"Elasticsearch Service","signatureVersion":"v4","uid":"es-2015-01-01"},"operations":{"AcceptInboundCrossClusterSearchConnection":{"http":{"method":"PUT","requestUri":"/2015-01-01/es/ccs/inboundConnection/{ConnectionId}/accept"},"input":{"type":"structure","required":["CrossClusterSearchConnectionId"],"members":{"CrossClusterSearchConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"CrossClusterSearchConnection":{"shape":"S4"}}}},"AddTags":{"http":{"requestUri":"/2015-01-01/tags"},"input":{"type":"structure","required":["ARN","TagList"],"members":{"ARN":{},"TagList":{"shape":"Se"}}}},"AssociatePackage":{"http":{"requestUri":"/2015-01-01/packages/associate/{PackageID}/{DomainName}"},"input":{"type":"structure","required":["PackageID","DomainName"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainPackageDetails":{"shape":"Sl"}}}},"CancelElasticsearchServiceSoftwareUpdate":{"http":{"requestUri":"/2015-01-01/es/serviceSoftwareUpdate/cancel"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"ServiceSoftwareOptions":{"shape":"Sx"}}}},"CreateElasticsearchDomain":{"http":{"requestUri":"/2015-01-01/es/domain"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ElasticsearchVersion":{},"ElasticsearchClusterConfig":{"shape":"S14"},"EBSOptions":{"shape":"S1a"},"AccessPolicies":{},"SnapshotOptions":{"shape":"S1d"},"VPCOptions":{"shape":"S1e"},"CognitoOptions":{"shape":"S1g"},"EncryptionAtRestOptions":{"shape":"S1k"},"NodeToNodeEncryptionOptions":{"shape":"S1m"},"AdvancedOptions":{"shape":"S1n"},"LogPublishingOptions":{"shape":"S1o"},"DomainEndpointOptions":{"shape":"S1s"},"AdvancedSecurityOptions":{"shape":"S1v"},"AutoTuneOptions":{"type":"structure","members":{"DesiredState":{},"MaintenanceSchedules":{"shape":"S26"}}},"TagList":{"shape":"Se"}}},"output":{"type":"structure","members":{"DomainStatus":{"shape":"S2d"}}}},"CreateOutboundCrossClusterSearchConnection":{"http":{"requestUri":"/2015-01-01/es/ccs/outboundConnection"},"input":{"type":"structure","required":["SourceDomainInfo","DestinationDomainInfo","ConnectionAlias"],"members":{"SourceDomainInfo":{"shape":"S5"},"DestinationDomainInfo":{"shape":"S5"},"ConnectionAlias":{}}},"output":{"type":"structure","members":{"SourceDomainInfo":{"shape":"S5"},"DestinationDomainInfo":{"shape":"S5"},"ConnectionAlias":{},"ConnectionStatus":{"shape":"S2t"},"CrossClusterSearchConnectionId":{}}}},"CreatePackage":{"http":{"requestUri":"/2015-01-01/packages"},"input":{"type":"structure","required":["PackageName","PackageType","PackageSource"],"members":{"PackageName":{},"PackageType":{},"PackageDescription":{},"PackageSource":{"shape":"S2x"}}},"output":{"type":"structure","members":{"PackageDetails":{"shape":"S31"}}}},"DeleteElasticsearchDomain":{"http":{"method":"DELETE","requestUri":"/2015-01-01/es/domain/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainStatus":{"shape":"S2d"}}}},"DeleteElasticsearchServiceRole":{"http":{"method":"DELETE","requestUri":"/2015-01-01/es/role"}},"DeleteInboundCrossClusterSearchConnection":{"http":{"method":"DELETE","requestUri":"/2015-01-01/es/ccs/inboundConnection/{ConnectionId}"},"input":{"type":"structure","required":["CrossClusterSearchConnectionId"],"members":{"CrossClusterSearchConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"CrossClusterSearchConnection":{"shape":"S4"}}}},"DeleteOutboundCrossClusterSearchConnection":{"http":{"method":"DELETE","requestUri":"/2015-01-01/es/ccs/outboundConnection/{ConnectionId}"},"input":{"type":"structure","required":["CrossClusterSearchConnectionId"],"members":{"CrossClusterSearchConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"CrossClusterSearchConnection":{"shape":"S3a"}}}},"DeletePackage":{"http":{"method":"DELETE","requestUri":"/2015-01-01/packages/{PackageID}"},"input":{"type":"structure","required":["PackageID"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"}}},"output":{"type":"structure","members":{"PackageDetails":{"shape":"S31"}}}},"DescribeDomainAutoTunes":{"http":{"method":"GET","requestUri":"/2015-01-01/es/domain/{DomainName}/autoTunes"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutoTunes":{"type":"list","member":{"type":"structure","members":{"AutoTuneType":{},"AutoTuneDetails":{"type":"structure","members":{"ScheduledAutoTuneDetails":{"type":"structure","members":{"Date":{"type":"timestamp"},"ActionType":{},"Action":{},"Severity":{}}}}}}}},"NextToken":{}}}},"DescribeDomainChangeProgress":{"http":{"method":"GET","requestUri":"/2015-01-01/es/domain/{DomainName}/progress"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ChangeId":{"location":"querystring","locationName":"changeid"}}},"output":{"type":"structure","members":{"ChangeProgressStatus":{"type":"structure","members":{"ChangeId":{},"StartTime":{"type":"timestamp"},"Status":{},"PendingProperties":{"shape":"S1f"},"CompletedProperties":{"shape":"S1f"},"TotalNumberOfStages":{"type":"integer"},"ChangeProgressStages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"Description":{},"LastUpdated":{"type":"timestamp"}}}}}}}}},"DescribeElasticsearchDomain":{"http":{"method":"GET","requestUri":"/2015-01-01/es/domain/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainStatus"],"members":{"DomainStatus":{"shape":"S2d"}}}},"DescribeElasticsearchDomainConfig":{"http":{"method":"GET","requestUri":"/2015-01-01/es/domain/{DomainName}/config"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainConfig"],"members":{"DomainConfig":{"shape":"S45"}}}},"DescribeElasticsearchDomains":{"http":{"requestUri":"/2015-01-01/es/domain-info"},"input":{"type":"structure","required":["DomainNames"],"members":{"DomainNames":{"type":"list","member":{}}}},"output":{"type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S2d"}}}}},"DescribeElasticsearchInstanceTypeLimits":{"http":{"method":"GET","requestUri":"/2015-01-01/es/instanceTypeLimits/{ElasticsearchVersion}/{InstanceType}"},"input":{"type":"structure","required":["InstanceType","ElasticsearchVersion"],"members":{"DomainName":{"location":"querystring","locationName":"domainName"},"InstanceType":{"location":"uri","locationName":"InstanceType"},"ElasticsearchVersion":{"location":"uri","locationName":"ElasticsearchVersion"}}},"output":{"type":"structure","members":{"LimitsByRole":{"type":"map","key":{},"value":{"type":"structure","members":{"StorageTypes":{"type":"list","member":{"type":"structure","members":{"StorageTypeName":{},"StorageSubTypeName":{},"StorageTypeLimits":{"type":"list","member":{"type":"structure","members":{"LimitName":{},"LimitValues":{"shape":"S56"}}}}}}},"InstanceLimits":{"type":"structure","members":{"InstanceCountLimits":{"type":"structure","members":{"MinimumInstanceCount":{"type":"integer"},"MaximumInstanceCount":{"type":"integer"}}}}},"AdditionalLimits":{"type":"list","member":{"type":"structure","members":{"LimitName":{},"LimitValues":{"shape":"S56"}}}}}}}}}},"DescribeInboundCrossClusterSearchConnections":{"http":{"requestUri":"/2015-01-01/es/ccs/inboundConnection/search"},"input":{"type":"structure","members":{"Filters":{"shape":"S5f"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"CrossClusterSearchConnections":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"DescribeOutboundCrossClusterSearchConnections":{"http":{"requestUri":"/2015-01-01/es/ccs/outboundConnection/search"},"input":{"type":"structure","members":{"Filters":{"shape":"S5f"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"CrossClusterSearchConnections":{"type":"list","member":{"shape":"S3a"}},"NextToken":{}}}},"DescribePackages":{"http":{"requestUri":"/2015-01-01/packages/describe"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PackageDetailsList":{"type":"list","member":{"shape":"S31"}},"NextToken":{}}}},"DescribeReservedElasticsearchInstanceOfferings":{"http":{"method":"GET","requestUri":"/2015-01-01/es/reservedInstanceOfferings"},"input":{"type":"structure","members":{"ReservedElasticsearchInstanceOfferingId":{"location":"querystring","locationName":"offeringId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ReservedElasticsearchInstanceOfferings":{"type":"list","member":{"type":"structure","members":{"ReservedElasticsearchInstanceOfferingId":{},"ElasticsearchInstanceType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"PaymentOption":{},"RecurringCharges":{"shape":"S63"}}}}}}},"DescribeReservedElasticsearchInstances":{"http":{"method":"GET","requestUri":"/2015-01-01/es/reservedInstances"},"input":{"type":"structure","members":{"ReservedElasticsearchInstanceId":{"location":"querystring","locationName":"reservationId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ReservedElasticsearchInstances":{"type":"list","member":{"type":"structure","members":{"ReservationName":{},"ReservedElasticsearchInstanceId":{},"ReservedElasticsearchInstanceOfferingId":{},"ElasticsearchInstanceType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ElasticsearchInstanceCount":{"type":"integer"},"State":{},"PaymentOption":{},"RecurringCharges":{"shape":"S63"}}}}}}},"DissociatePackage":{"http":{"requestUri":"/2015-01-01/packages/dissociate/{PackageID}/{DomainName}"},"input":{"type":"structure","required":["PackageID","DomainName"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainPackageDetails":{"shape":"Sl"}}}},"GetCompatibleElasticsearchVersions":{"http":{"method":"GET","requestUri":"/2015-01-01/es/compatibleVersions"},"input":{"type":"structure","members":{"DomainName":{"location":"querystring","locationName":"domainName"}}},"output":{"type":"structure","members":{"CompatibleElasticsearchVersions":{"type":"list","member":{"type":"structure","members":{"SourceVersion":{},"TargetVersions":{"shape":"S6g"}}}}}}},"GetPackageVersionHistory":{"http":{"method":"GET","requestUri":"/2015-01-01/packages/{PackageID}/history"},"input":{"type":"structure","required":["PackageID"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"PackageID":{},"PackageVersionHistoryList":{"type":"list","member":{"type":"structure","members":{"PackageVersion":{},"CommitMessage":{},"CreatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"GetUpgradeHistory":{"http":{"method":"GET","requestUri":"/2015-01-01/es/upgradeDomain/{DomainName}/history"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"UpgradeHistories":{"type":"list","member":{"type":"structure","members":{"UpgradeName":{},"StartTimestamp":{"type":"timestamp"},"UpgradeStatus":{},"StepsList":{"type":"list","member":{"type":"structure","members":{"UpgradeStep":{},"UpgradeStepStatus":{},"Issues":{"type":"list","member":{}},"ProgressPercent":{"type":"double"}}}}}}},"NextToken":{}}}},"GetUpgradeStatus":{"http":{"method":"GET","requestUri":"/2015-01-01/es/upgradeDomain/{DomainName}/status"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"UpgradeStep":{},"StepStatus":{},"UpgradeName":{}}}},"ListDomainNames":{"http":{"method":"GET","requestUri":"/2015-01-01/domain"},"input":{"type":"structure","members":{"EngineType":{"location":"querystring","locationName":"engineType"}}},"output":{"type":"structure","members":{"DomainNames":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"EngineType":{}}}}}}},"ListDomainsForPackage":{"http":{"method":"GET","requestUri":"/2015-01-01/packages/{PackageID}/domains"},"input":{"type":"structure","required":["PackageID"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"DomainPackageDetailsList":{"shape":"S77"},"NextToken":{}}}},"ListElasticsearchInstanceTypes":{"http":{"method":"GET","requestUri":"/2015-01-01/es/instanceTypes/{ElasticsearchVersion}"},"input":{"type":"structure","required":["ElasticsearchVersion"],"members":{"ElasticsearchVersion":{"location":"uri","locationName":"ElasticsearchVersion"},"DomainName":{"location":"querystring","locationName":"domainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ElasticsearchInstanceTypes":{"type":"list","member":{}},"NextToken":{}}}},"ListElasticsearchVersions":{"http":{"method":"GET","requestUri":"/2015-01-01/es/versions"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ElasticsearchVersions":{"shape":"S6g"},"NextToken":{}}}},"ListPackagesForDomain":{"http":{"method":"GET","requestUri":"/2015-01-01/domain/{DomainName}/packages"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"DomainPackageDetailsList":{"shape":"S77"},"NextToken":{}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2015-01-01/tags/"},"input":{"type":"structure","required":["ARN"],"members":{"ARN":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"TagList":{"shape":"Se"}}}},"PurchaseReservedElasticsearchInstanceOffering":{"http":{"requestUri":"/2015-01-01/es/purchaseReservedInstanceOffering"},"input":{"type":"structure","required":["ReservedElasticsearchInstanceOfferingId","ReservationName"],"members":{"ReservedElasticsearchInstanceOfferingId":{},"ReservationName":{},"InstanceCount":{"type":"integer"}}},"output":{"type":"structure","members":{"ReservedElasticsearchInstanceId":{},"ReservationName":{}}}},"RejectInboundCrossClusterSearchConnection":{"http":{"method":"PUT","requestUri":"/2015-01-01/es/ccs/inboundConnection/{ConnectionId}/reject"},"input":{"type":"structure","required":["CrossClusterSearchConnectionId"],"members":{"CrossClusterSearchConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"CrossClusterSearchConnection":{"shape":"S4"}}}},"RemoveTags":{"http":{"requestUri":"/2015-01-01/tags-removal"},"input":{"type":"structure","required":["ARN","TagKeys"],"members":{"ARN":{},"TagKeys":{"shape":"S1f"}}}},"StartElasticsearchServiceSoftwareUpdate":{"http":{"requestUri":"/2015-01-01/es/serviceSoftwareUpdate/start"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"ServiceSoftwareOptions":{"shape":"Sx"}}}},"UpdateElasticsearchDomainConfig":{"http":{"requestUri":"/2015-01-01/es/domain/{DomainName}/config"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ElasticsearchClusterConfig":{"shape":"S14"},"EBSOptions":{"shape":"S1a"},"SnapshotOptions":{"shape":"S1d"},"VPCOptions":{"shape":"S1e"},"CognitoOptions":{"shape":"S1g"},"AdvancedOptions":{"shape":"S1n"},"AccessPolicies":{},"LogPublishingOptions":{"shape":"S1o"},"DomainEndpointOptions":{"shape":"S1s"},"AdvancedSecurityOptions":{"shape":"S1v"},"NodeToNodeEncryptionOptions":{"shape":"S1m"},"EncryptionAtRestOptions":{"shape":"S1k"},"AutoTuneOptions":{"shape":"S4n"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","required":["DomainConfig"],"members":{"DomainConfig":{"shape":"S45"},"DryRunResults":{"type":"structure","members":{"DeploymentType":{},"Message":{}}}}}},"UpdatePackage":{"http":{"requestUri":"/2015-01-01/packages/update"},"input":{"type":"structure","required":["PackageID","PackageSource"],"members":{"PackageID":{},"PackageSource":{"shape":"S2x"},"PackageDescription":{},"CommitMessage":{}}},"output":{"type":"structure","members":{"PackageDetails":{"shape":"S31"}}}},"UpgradeElasticsearchDomain":{"http":{"requestUri":"/2015-01-01/es/upgradeDomain"},"input":{"type":"structure","required":["DomainName","TargetVersion"],"members":{"DomainName":{},"TargetVersion":{},"PerformCheckOnly":{"type":"boolean"}}},"output":{"type":"structure","members":{"DomainName":{},"TargetVersion":{},"PerformCheckOnly":{"type":"boolean"},"ChangeProgressDetails":{"shape":"S2n"}}}}},"shapes":{"S4":{"type":"structure","members":{"SourceDomainInfo":{"shape":"S5"},"DestinationDomainInfo":{"shape":"S5"},"CrossClusterSearchConnectionId":{},"ConnectionStatus":{"type":"structure","members":{"StatusCode":{},"Message":{}}}}},"S5":{"type":"structure","required":["DomainName"],"members":{"OwnerId":{},"DomainName":{},"Region":{}}},"Se":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"structure","members":{"PackageID":{},"PackageName":{},"PackageType":{},"LastUpdated":{"type":"timestamp"},"DomainName":{},"DomainPackageStatus":{},"PackageVersion":{},"ReferencePath":{},"ErrorDetails":{"shape":"Ss"}}},"Ss":{"type":"structure","members":{"ErrorType":{},"ErrorMessage":{}}},"Sx":{"type":"structure","members":{"CurrentVersion":{},"NewVersion":{},"UpdateAvailable":{"type":"boolean"},"Cancellable":{"type":"boolean"},"UpdateStatus":{},"Description":{},"AutomatedUpdateDate":{"type":"timestamp"},"OptionalDeployment":{"type":"boolean"}}},"S14":{"type":"structure","members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"DedicatedMasterEnabled":{"type":"boolean"},"ZoneAwarenessEnabled":{"type":"boolean"},"ZoneAwarenessConfig":{"type":"structure","members":{"AvailabilityZoneCount":{"type":"integer"}}},"DedicatedMasterType":{},"DedicatedMasterCount":{"type":"integer"},"WarmEnabled":{"type":"boolean"},"WarmType":{},"WarmCount":{"type":"integer"},"ColdStorageOptions":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}}}},"S1a":{"type":"structure","members":{"EBSEnabled":{"type":"boolean"},"VolumeType":{},"VolumeSize":{"type":"integer"},"Iops":{"type":"integer"}}},"S1d":{"type":"structure","members":{"AutomatedSnapshotStartHour":{"type":"integer"}}},"S1e":{"type":"structure","members":{"SubnetIds":{"shape":"S1f"},"SecurityGroupIds":{"shape":"S1f"}}},"S1f":{"type":"list","member":{}},"S1g":{"type":"structure","members":{"Enabled":{"type":"boolean"},"UserPoolId":{},"IdentityPoolId":{},"RoleArn":{}}},"S1k":{"type":"structure","members":{"Enabled":{"type":"boolean"},"KmsKeyId":{}}},"S1m":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S1n":{"type":"map","key":{},"value":{}},"S1o":{"type":"map","key":{},"value":{"type":"structure","members":{"CloudWatchLogsLogGroupArn":{},"Enabled":{"type":"boolean"}}}},"S1s":{"type":"structure","members":{"EnforceHTTPS":{"type":"boolean"},"TLSSecurityPolicy":{},"CustomEndpointEnabled":{"type":"boolean"},"CustomEndpoint":{},"CustomEndpointCertificateArn":{}}},"S1v":{"type":"structure","members":{"Enabled":{"type":"boolean"},"InternalUserDatabaseEnabled":{"type":"boolean"},"MasterUserOptions":{"type":"structure","members":{"MasterUserARN":{},"MasterUserName":{"shape":"S1x"},"MasterUserPassword":{"type":"string","sensitive":true}}},"SAMLOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Idp":{"shape":"S20"},"MasterUserName":{"shape":"S1x"},"MasterBackendRole":{},"SubjectKey":{},"RolesKey":{},"SessionTimeoutMinutes":{"type":"integer"}}},"AnonymousAuthEnabled":{"type":"boolean"}}},"S1x":{"type":"string","sensitive":true},"S20":{"type":"structure","required":["MetadataContent","EntityId"],"members":{"MetadataContent":{},"EntityId":{}}},"S26":{"type":"list","member":{"type":"structure","members":{"StartAt":{"type":"timestamp"},"Duration":{"type":"structure","members":{"Value":{"type":"long"},"Unit":{}}},"CronExpressionForRecurrence":{}}}},"S2d":{"type":"structure","required":["DomainId","DomainName","ARN","ElasticsearchClusterConfig"],"members":{"DomainId":{},"DomainName":{},"ARN":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"Endpoint":{},"Endpoints":{"type":"map","key":{},"value":{}},"Processing":{"type":"boolean"},"UpgradeProcessing":{"type":"boolean"},"ElasticsearchVersion":{},"ElasticsearchClusterConfig":{"shape":"S14"},"EBSOptions":{"shape":"S1a"},"AccessPolicies":{},"SnapshotOptions":{"shape":"S1d"},"VPCOptions":{"shape":"S2h"},"CognitoOptions":{"shape":"S1g"},"EncryptionAtRestOptions":{"shape":"S1k"},"NodeToNodeEncryptionOptions":{"shape":"S1m"},"AdvancedOptions":{"shape":"S1n"},"LogPublishingOptions":{"shape":"S1o"},"ServiceSoftwareOptions":{"shape":"Sx"},"DomainEndpointOptions":{"shape":"S1s"},"AdvancedSecurityOptions":{"shape":"S2i"},"AutoTuneOptions":{"type":"structure","members":{"State":{},"ErrorMessage":{}}},"ChangeProgressDetails":{"shape":"S2n"}}},"S2h":{"type":"structure","members":{"VPCId":{},"SubnetIds":{"shape":"S1f"},"AvailabilityZones":{"shape":"S1f"},"SecurityGroupIds":{"shape":"S1f"}}},"S2i":{"type":"structure","members":{"Enabled":{"type":"boolean"},"InternalUserDatabaseEnabled":{"type":"boolean"},"SAMLOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Idp":{"shape":"S20"},"SubjectKey":{},"RolesKey":{},"SessionTimeoutMinutes":{"type":"integer"}}},"AnonymousAuthDisableDate":{"type":"timestamp"},"AnonymousAuthEnabled":{"type":"boolean"}}},"S2n":{"type":"structure","members":{"ChangeId":{},"Message":{}}},"S2t":{"type":"structure","members":{"StatusCode":{},"Message":{}}},"S2x":{"type":"structure","members":{"S3BucketName":{},"S3Key":{}}},"S31":{"type":"structure","members":{"PackageID":{},"PackageName":{},"PackageType":{},"PackageDescription":{},"PackageStatus":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"AvailablePackageVersion":{},"ErrorDetails":{"shape":"Ss"}}},"S3a":{"type":"structure","members":{"SourceDomainInfo":{"shape":"S5"},"DestinationDomainInfo":{"shape":"S5"},"CrossClusterSearchConnectionId":{},"ConnectionAlias":{},"ConnectionStatus":{"shape":"S2t"}}},"S45":{"type":"structure","members":{"ElasticsearchVersion":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"S47"}}},"ElasticsearchClusterConfig":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S14"},"Status":{"shape":"S47"}}},"EBSOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1a"},"Status":{"shape":"S47"}}},"AccessPolicies":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"S47"}}},"SnapshotOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1d"},"Status":{"shape":"S47"}}},"VPCOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2h"},"Status":{"shape":"S47"}}},"CognitoOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1g"},"Status":{"shape":"S47"}}},"EncryptionAtRestOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1k"},"Status":{"shape":"S47"}}},"NodeToNodeEncryptionOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1m"},"Status":{"shape":"S47"}}},"AdvancedOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1n"},"Status":{"shape":"S47"}}},"LogPublishingOptions":{"type":"structure","members":{"Options":{"shape":"S1o"},"Status":{"shape":"S47"}}},"DomainEndpointOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1s"},"Status":{"shape":"S47"}}},"AdvancedSecurityOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2i"},"Status":{"shape":"S47"}}},"AutoTuneOptions":{"type":"structure","members":{"Options":{"shape":"S4n"},"Status":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"ErrorMessage":{},"PendingDeletion":{"type":"boolean"}}}}},"ChangeProgressDetails":{"shape":"S2n"}}},"S47":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"S4n":{"type":"structure","members":{"DesiredState":{},"RollbackOnDisable":{},"MaintenanceSchedules":{"shape":"S26"}}},"S56":{"type":"list","member":{}},"S5f":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S63":{"type":"list","member":{"type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}}}},"S6g":{"type":"list","member":{}},"S77":{"type":"list","member":{"shape":"Sl"}}}}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDomainAutoTunes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeInboundCrossClusterSearchConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeOutboundCrossClusterSearchConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribePackages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeReservedElasticsearchInstanceOfferings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeReservedElasticsearchInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetPackageVersionHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetUpgradeHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDomainsForPackage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListElasticsearchInstanceTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListElasticsearchVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPackagesForDomain":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['elastictranscoder'] = {};
	AWS.ElasticTranscoder = Service.defineService('elastictranscoder', ['2012-09-25']);
	Object.defineProperty(apiLoader.services['elastictranscoder'], '2012-09-25', {
	  get: function get() {
	    var model = __webpack_require__(232);
	    model.paginators = __webpack_require__(233).pagination;
	    model.waiters = __webpack_require__(234).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ElasticTranscoder;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-09-25","endpointPrefix":"elastictranscoder","protocol":"rest-json","serviceFullName":"Amazon Elastic Transcoder","serviceId":"Elastic Transcoder","signatureVersion":"v4","uid":"elastictranscoder-2012-09-25"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/2012-09-25/jobs/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2012-09-25/jobs","responseCode":201},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"Su"},"Outputs":{"type":"list","member":{"shape":"Su"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"}}}},"UserMetadata":{"shape":"S1v"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"CreatePipeline":{"http":{"requestUri":"/2012-09-25/pipelines","responseCode":201},"input":{"type":"structure","required":["Name","InputBucket","Role"],"members":{"Name":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"CreatePreset":{"http":{"requestUri":"/2012-09-25/presets","responseCode":201},"input":{"type":"structure","required":["Name","Container"],"members":{"Name":{},"Description":{},"Container":{},"Video":{"shape":"S2r"},"Audio":{"shape":"S37"},"Thumbnails":{"shape":"S3i"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"},"Warning":{}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2012-09-25/presets/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"ListJobsByPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByPipeline/{PipelineId}"},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{"location":"uri","locationName":"PipelineId"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListJobsByStatus":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByStatus/{Status}"},"input":{"type":"structure","required":["Status"],"members":{"Status":{"location":"uri","locationName":"Status"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Pipelines":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2012-09-25/presets"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Presets":{"type":"list","member":{"shape":"S3m"}},"NextPageToken":{}}}},"ReadJob":{"http":{"method":"GET","requestUri":"/2012-09-25/jobs/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"ReadPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"ReadPreset":{"http":{"method":"GET","requestUri":"/2012-09-25/presets/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"}}}},"TestRole":{"http":{"requestUri":"/2012-09-25/roleTests","responseCode":200},"input":{"type":"structure","required":["Role","InputBucket","OutputBucket","Topics"],"members":{"Role":{},"InputBucket":{},"OutputBucket":{},"Topics":{"type":"list","member":{}}},"deprecated":true},"output":{"type":"structure","members":{"Success":{},"Messages":{"type":"list","member":{}}},"deprecated":true},"deprecated":true},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"InputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"UpdatePipelineNotifications":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/notifications"},"input":{"type":"structure","required":["Id","Notifications"],"members":{"Id":{"location":"uri","locationName":"Id"},"Notifications":{"shape":"S2a"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}},"UpdatePipelineStatus":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/status"},"input":{"type":"structure","required":["Id","Status"],"members":{"Id":{"location":"uri","locationName":"Id"},"Status":{}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}}},"shapes":{"S5":{"type":"structure","members":{"Key":{},"FrameRate":{},"Resolution":{},"AspectRatio":{},"Interlaced":{},"Container":{},"Encryption":{"shape":"Sc"},"TimeSpan":{"shape":"Sg"},"InputCaptions":{"type":"structure","members":{"MergePolicy":{},"CaptionSources":{"shape":"Sk"}}},"DetectedProperties":{"type":"structure","members":{"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"}}}}},"Sc":{"type":"structure","members":{"Mode":{},"Key":{},"KeyMd5":{},"InitializationVector":{}}},"Sg":{"type":"structure","members":{"StartTime":{},"Duration":{}}},"Sk":{"type":"list","member":{"type":"structure","members":{"Key":{},"Language":{},"TimeOffset":{},"Label":{},"Encryption":{"shape":"Sc"}}}},"St":{"type":"list","member":{"shape":"S5"}},"Su":{"type":"structure","members":{"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"}}},"Sx":{"type":"list","member":{"type":"structure","members":{"PresetWatermarkId":{},"InputKey":{},"Encryption":{"shape":"Sc"}}}},"S11":{"type":"structure","members":{"MergePolicy":{},"Artwork":{"type":"list","member":{"type":"structure","members":{"InputKey":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{},"AlbumArtFormat":{},"Encryption":{"shape":"Sc"}}}}}},"S19":{"type":"list","member":{"type":"structure","members":{"TimeSpan":{"shape":"Sg"}},"deprecated":true},"deprecated":true},"S1b":{"type":"structure","members":{"MergePolicy":{"deprecated":true},"CaptionSources":{"shape":"Sk","deprecated":true},"CaptionFormats":{"type":"list","member":{"type":"structure","members":{"Format":{},"Pattern":{},"Encryption":{"shape":"Sc"}}}}}},"S1l":{"type":"list","member":{}},"S1m":{"type":"structure","members":{"Method":{},"Key":{},"KeyMd5":{},"InitializationVector":{},"LicenseAcquisitionUrl":{},"KeyStoragePolicy":{}}},"S1q":{"type":"structure","members":{"Format":{},"Key":{},"KeyMd5":{},"KeyId":{},"InitializationVector":{},"LicenseAcquisitionUrl":{}}},"S1v":{"type":"map","key":{},"value":{}},"S1y":{"type":"structure","members":{"Id":{},"Arn":{},"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"S1z"},"Outputs":{"type":"list","member":{"shape":"S1z"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"},"Status":{},"StatusDetail":{}}}},"Status":{},"UserMetadata":{"shape":"S1v"},"Timing":{"type":"structure","members":{"SubmitTimeMillis":{"type":"long"},"StartTimeMillis":{"type":"long"},"FinishTimeMillis":{"type":"long"}}}}},"S1z":{"type":"structure","members":{"Id":{},"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Status":{},"StatusDetail":{},"Duration":{"type":"long"},"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"},"AppliedColorSpaceConversion":{}}},"S2a":{"type":"structure","members":{"Progressing":{},"Completed":{},"Warning":{},"Error":{}}},"S2c":{"type":"structure","members":{"Bucket":{},"StorageClass":{},"Permissions":{"type":"list","member":{"type":"structure","members":{"GranteeType":{},"Grantee":{},"Access":{"type":"list","member":{}}}}}}},"S2l":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Status":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Code":{},"Message":{}}}},"S2r":{"type":"structure","members":{"Codec":{},"CodecOptions":{"type":"map","key":{},"value":{}},"KeyframesMaxDist":{},"FixedGOP":{},"BitRate":{},"FrameRate":{},"MaxFrameRate":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"DisplayAspectRatio":{},"SizingPolicy":{},"PaddingPolicy":{},"Watermarks":{"type":"list","member":{"type":"structure","members":{"Id":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"HorizontalAlign":{},"HorizontalOffset":{},"VerticalAlign":{},"VerticalOffset":{},"Opacity":{},"Target":{}}}}}},"S37":{"type":"structure","members":{"Codec":{},"SampleRate":{},"BitRate":{},"Channels":{},"AudioPackingMode":{},"CodecOptions":{"type":"structure","members":{"Profile":{},"BitDepth":{},"BitOrder":{},"Signed":{}}}}},"S3i":{"type":"structure","members":{"Format":{},"Interval":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{}}},"S3m":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Container":{},"Audio":{"shape":"S37"},"Video":{"shape":"S2r"},"Thumbnails":{"shape":"S3i"},"Type":{}}},"S3v":{"type":"list","member":{"shape":"S1y"}}}}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListJobsByPipeline":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListJobsByStatus":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListPipelines":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Pipelines"},"ListPresets":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Presets"}}}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"JobComplete":{"delay":30,"operation":"ReadJob","maxAttempts":120,"acceptors":[{"expected":"Complete","matcher":"path","state":"success","argument":"Job.Status"},{"expected":"Canceled","matcher":"path","state":"failure","argument":"Job.Status"},{"expected":"Error","matcher":"path","state":"failure","argument":"Job.Status"}]}}}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['firehose'] = {};
	AWS.Firehose = Service.defineService('firehose', ['2015-08-04']);
	Object.defineProperty(apiLoader.services['firehose'], '2015-08-04', {
	  get: function get() {
	    var model = __webpack_require__(236);
	    model.paginators = __webpack_require__(237).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Firehose;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-04","endpointPrefix":"firehose","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Firehose","serviceFullName":"Amazon Kinesis Firehose","serviceId":"Firehose","signatureVersion":"v4","targetPrefix":"Firehose_20150804","uid":"firehose-2015-08-04"},"operations":{"CreateDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamType":{},"KinesisStreamSourceConfiguration":{"type":"structure","required":["KinesisStreamARN","RoleARN"],"members":{"KinesisStreamARN":{},"RoleARN":{}}},"DeliveryStreamEncryptionConfigurationInput":{"shape":"S7"},"S3DestinationConfiguration":{"shape":"Sa","deprecated":true},"ExtendedS3DestinationConfiguration":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"Sa"},"DataFormatConversionConfiguration":{"shape":"Sz"},"DynamicPartitioningConfiguration":{"shape":"S1o"}}},"RedshiftDestinationConfiguration":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","Password","S3Configuration"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1t"},"Username":{"shape":"S1x"},"Password":{"shape":"S1y"},"RetryOptions":{"shape":"S1z"},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"Sa"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationConfiguration":{"type":"structure","required":["RoleARN","IndexName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S28"},"RetryOptions":{"shape":"S2b"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfiguration":{"shape":"S2e"}}},"AmazonopensearchserviceDestinationConfiguration":{"type":"structure","required":["RoleARN","IndexName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2n"},"RetryOptions":{"shape":"S2q"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfiguration":{"shape":"S2e"}}},"SplunkDestinationConfiguration":{"type":"structure","required":["HECEndpoint","HECEndpointType","HECToken","S3Configuration"],"members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2y"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"HttpEndpointDestinationConfiguration":{"type":"structure","required":["EndpointConfiguration","S3Configuration"],"members":{"EndpointConfiguration":{"shape":"S32"},"BufferingHints":{"shape":"S36"},"CloudWatchLoggingOptions":{"shape":"Sl"},"RequestConfiguration":{"shape":"S39"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S3f"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"}}},"Tags":{"shape":"S3i"}}},"output":{"type":"structure","members":{"DeliveryStreamARN":{}}}},"DeleteDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"AllowForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"Limit":{"type":"integer"},"ExclusiveStartDestinationId":{}}},"output":{"type":"structure","required":["DeliveryStreamDescription"],"members":{"DeliveryStreamDescription":{"type":"structure","required":["DeliveryStreamName","DeliveryStreamARN","DeliveryStreamStatus","DeliveryStreamType","VersionId","Destinations","HasMoreDestinations"],"members":{"DeliveryStreamName":{},"DeliveryStreamARN":{},"DeliveryStreamStatus":{},"FailureDescription":{"shape":"S3w"},"DeliveryStreamEncryptionConfiguration":{"type":"structure","members":{"KeyARN":{},"KeyType":{},"Status":{},"FailureDescription":{"shape":"S3w"}}},"DeliveryStreamType":{},"VersionId":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Source":{"type":"structure","members":{"KinesisStreamSourceDescription":{"type":"structure","members":{"KinesisStreamARN":{},"RoleARN":{},"DeliveryStartTimestamp":{"type":"timestamp"}}}}},"Destinations":{"type":"list","member":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{},"S3DestinationDescription":{"shape":"S47"},"ExtendedS3DestinationDescription":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S47"},"DataFormatConversionConfiguration":{"shape":"Sz"},"DynamicPartitioningConfiguration":{"shape":"S1o"}}},"RedshiftDestinationDescription":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","S3DestinationDescription"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1t"},"Username":{"shape":"S1x"},"RetryOptions":{"shape":"S1z"},"S3DestinationDescription":{"shape":"S47"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S47"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S28"},"RetryOptions":{"shape":"S2b"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S47"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfigurationDescription":{"shape":"S4b"}}},"AmazonopensearchserviceDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2n"},"RetryOptions":{"shape":"S2q"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S47"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfigurationDescription":{"shape":"S4b"}}},"SplunkDestinationDescription":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2y"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S47"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"HttpEndpointDestinationDescription":{"type":"structure","members":{"EndpointConfiguration":{"type":"structure","members":{"Url":{"shape":"S33"},"Name":{}}},"BufferingHints":{"shape":"S36"},"CloudWatchLoggingOptions":{"shape":"Sl"},"RequestConfiguration":{"shape":"S39"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S3f"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S47"}}}}}},"HasMoreDestinations":{"type":"boolean"}}}}}},"ListDeliveryStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"DeliveryStreamType":{},"ExclusiveStartDeliveryStreamName":{}}},"output":{"type":"structure","required":["DeliveryStreamNames","HasMoreDeliveryStreams"],"members":{"DeliveryStreamNames":{"type":"list","member":{}},"HasMoreDeliveryStreams":{"type":"boolean"}}}},"ListTagsForDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"shape":"S3j"}},"HasMoreTags":{"type":"boolean"}}}},"PutRecord":{"input":{"type":"structure","required":["DeliveryStreamName","Record"],"members":{"DeliveryStreamName":{},"Record":{"shape":"S4p"}}},"output":{"type":"structure","required":["RecordId"],"members":{"RecordId":{},"Encrypted":{"type":"boolean"}}}},"PutRecordBatch":{"input":{"type":"structure","required":["DeliveryStreamName","Records"],"members":{"DeliveryStreamName":{},"Records":{"type":"list","member":{"shape":"S4p"}}}},"output":{"type":"structure","required":["FailedPutCount","RequestResponses"],"members":{"FailedPutCount":{"type":"integer"},"Encrypted":{"type":"boolean"},"RequestResponses":{"type":"list","member":{"type":"structure","members":{"RecordId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamEncryptionConfigurationInput":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"StopDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"TagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","Tags"],"members":{"DeliveryStreamName":{},"Tags":{"shape":"S3i"}}},"output":{"type":"structure","members":{}}},"UntagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","TagKeys"],"members":{"DeliveryStreamName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDestination":{"input":{"type":"structure","required":["DeliveryStreamName","CurrentDeliveryStreamVersionId","DestinationId"],"members":{"DeliveryStreamName":{},"CurrentDeliveryStreamVersionId":{},"DestinationId":{},"S3DestinationUpdate":{"shape":"S5a","deprecated":true},"ExtendedS3DestinationUpdate":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S5a"},"DataFormatConversionConfiguration":{"shape":"Sz"},"DynamicPartitioningConfiguration":{"shape":"S1o"}}},"RedshiftDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1t"},"Username":{"shape":"S1x"},"Password":{"shape":"S1y"},"RetryOptions":{"shape":"S1z"},"S3Update":{"shape":"S5a"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S5a"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S28"},"RetryOptions":{"shape":"S2b"},"S3Update":{"shape":"S5a"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"AmazonopensearchserviceDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2n"},"RetryOptions":{"shape":"S2q"},"S3Update":{"shape":"S5a"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"SplunkDestinationUpdate":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2y"},"S3BackupMode":{},"S3Update":{"shape":"S5a"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"HttpEndpointDestinationUpdate":{"type":"structure","members":{"EndpointConfiguration":{"shape":"S32"},"BufferingHints":{"shape":"S36"},"CloudWatchLoggingOptions":{"shape":"Sl"},"RequestConfiguration":{"shape":"S39"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S3f"},"S3BackupMode":{},"S3Update":{"shape":"S5a"}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","required":["KeyType"],"members":{"KeyARN":{},"KeyType":{}}},"Sa":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"Se":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"Si":{"type":"structure","members":{"NoEncryptionConfig":{},"KMSEncryptionConfig":{"type":"structure","required":["AWSKMSKeyARN"],"members":{"AWSKMSKeyARN":{}}}}},"Sl":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogGroupName":{},"LogStreamName":{}}},"Sq":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Processors":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}}}}}}},"Sz":{"type":"structure","members":{"SchemaConfiguration":{"type":"structure","members":{"RoleARN":{},"CatalogId":{},"DatabaseName":{},"TableName":{},"Region":{},"VersionId":{}}},"InputFormatConfiguration":{"type":"structure","members":{"Deserializer":{"type":"structure","members":{"OpenXJsonSerDe":{"type":"structure","members":{"ConvertDotsInJsonKeysToUnderscores":{"type":"boolean"},"CaseInsensitive":{"type":"boolean"},"ColumnToJsonKeyMappings":{"type":"map","key":{},"value":{}}}},"HiveJsonSerDe":{"type":"structure","members":{"TimestampFormats":{"type":"list","member":{}}}}}}}},"OutputFormatConfiguration":{"type":"structure","members":{"Serializer":{"type":"structure","members":{"ParquetSerDe":{"type":"structure","members":{"BlockSizeBytes":{"type":"integer"},"PageSizeBytes":{"type":"integer"},"Compression":{},"EnableDictionaryCompression":{"type":"boolean"},"MaxPaddingBytes":{"type":"integer"},"WriterVersion":{}}},"OrcSerDe":{"type":"structure","members":{"StripeSizeBytes":{"type":"integer"},"BlockSizeBytes":{"type":"integer"},"RowIndexStride":{"type":"integer"},"EnablePadding":{"type":"boolean"},"PaddingTolerance":{"type":"double"},"Compression":{},"BloomFilterColumns":{"type":"list","member":{}},"BloomFilterFalsePositiveProbability":{"type":"double"},"DictionaryKeyThreshold":{"type":"double"},"FormatVersion":{}}}}}}},"Enabled":{"type":"boolean"}}},"S1o":{"type":"structure","members":{"RetryOptions":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"Enabled":{"type":"boolean"}}},"S1t":{"type":"structure","required":["DataTableName"],"members":{"DataTableName":{},"DataTableColumns":{},"CopyOptions":{}}},"S1x":{"type":"string","sensitive":true},"S1y":{"type":"string","sensitive":true},"S1z":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S28":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S2b":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2e":{"type":"structure","required":["SubnetIds","RoleARN","SecurityGroupIds"],"members":{"SubnetIds":{"shape":"S2f"},"RoleARN":{},"SecurityGroupIds":{"shape":"S2g"}}},"S2f":{"type":"list","member":{}},"S2g":{"type":"list","member":{}},"S2n":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S2q":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2y":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S32":{"type":"structure","required":["Url"],"members":{"Url":{"shape":"S33"},"Name":{},"AccessKey":{"type":"string","sensitive":true}}},"S33":{"type":"string","sensitive":true},"S36":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"S39":{"type":"structure","members":{"ContentEncoding":{},"CommonAttributes":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeValue"],"members":{"AttributeName":{"type":"string","sensitive":true},"AttributeValue":{"type":"string","sensitive":true}}}}}},"S3f":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S3i":{"type":"list","member":{"shape":"S3j"}},"S3j":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}},"S3w":{"type":"structure","required":["Type","Details"],"members":{"Type":{},"Details":{}}},"S47":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"S4b":{"type":"structure","required":["SubnetIds","RoleARN","SecurityGroupIds","VpcId"],"members":{"SubnetIds":{"shape":"S2f"},"RoleARN":{},"SecurityGroupIds":{"shape":"S2g"},"VpcId":{}}},"S4p":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"S5a":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}}}}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['gamelift'] = {};
	AWS.GameLift = Service.defineService('gamelift', ['2015-10-01']);
	Object.defineProperty(apiLoader.services['gamelift'], '2015-10-01', {
	  get: function get() {
	    var model = __webpack_require__(239);
	    model.paginators = __webpack_require__(240).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.GameLift;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-01","endpointPrefix":"gamelift","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon GameLift","serviceId":"GameLift","signatureVersion":"v4","targetPrefix":"GameLift","uid":"gamelift-2015-10-01"},"operations":{"AcceptMatch":{"input":{"type":"structure","required":["TicketId","PlayerIds","AcceptanceType"],"members":{"TicketId":{},"PlayerIds":{"shape":"S3"},"AcceptanceType":{}}},"output":{"type":"structure","members":{}}},"ClaimGameServer":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"GameServerId":{},"GameServerData":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"CreateAlias":{"input":{"type":"structure","required":["Name","RoutingStrategy"],"members":{"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sm"},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sv"}}}},"CreateBuild":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"Sz"},"OperatingSystem":{},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"Build":{"shape":"S13"},"UploadCredentials":{"shape":"S18"},"StorageLocation":{"shape":"Sz"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","EC2InstanceType"],"members":{"Name":{},"Description":{},"BuildId":{},"ScriptId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"EC2InstanceType":{},"EC2InboundPermissions":{"shape":"S1f"},"NewGameSessionProtectionPolicy":{},"RuntimeConfiguration":{"shape":"S1l"},"ResourceCreationLimitPolicy":{"shape":"S1r"},"MetricGroups":{"shape":"S1t"},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"FleetType":{},"InstanceRoleArn":{},"CertificateConfiguration":{"shape":"S1w"},"Locations":{"shape":"S1y"},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"FleetAttributes":{"shape":"S22"},"LocationStates":{"shape":"S29"}}}},"CreateFleetLocations":{"input":{"type":"structure","required":["FleetId","Locations"],"members":{"FleetId":{},"Locations":{"shape":"S1y"}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"LocationStates":{"shape":"S29"}}}},"CreateGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","RoleArn","MinSize","MaxSize","LaunchTemplate","InstanceDefinitions"],"members":{"GameServerGroupName":{},"RoleArn":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceDefinitions":{"shape":"S2k"},"AutoScalingPolicy":{"type":"structure","required":["TargetTrackingConfiguration"],"members":{"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}},"BalancingStrategy":{},"GameServerProtectionPolicy":{},"VpcSubnets":{"type":"list","member":{}},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2w"}}}},"CreateGameSession":{"input":{"type":"structure","required":["MaximumPlayerSessionCount"],"members":{"FleetId":{},"AliasId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"GameProperties":{"shape":"S33"},"CreatorId":{},"GameSessionId":{},"IdempotencyToken":{},"GameSessionData":{},"Location":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S3a"}}}},"CreateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S3j"},"Destinations":{"shape":"S3l"},"FilterConfiguration":{"shape":"S3o"},"PriorityConfiguration":{"shape":"S3q"},"CustomEventData":{},"NotificationTarget":{},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S3w"}}}},"CreateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name","RequestTimeoutSeconds","AcceptanceRequired","RuleSetName"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S3z"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S33"},"GameSessionData":{},"BackfillMode":{},"FlexMatchMode":{},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S4a"}}}},"CreateMatchmakingRuleSet":{"input":{"type":"structure","required":["Name","RuleSetBody"],"members":{"Name":{},"RuleSetBody":{},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["RuleSet"],"members":{"RuleSet":{"shape":"S4g"}}}},"CreatePlayerSession":{"input":{"type":"structure","required":["GameSessionId","PlayerId"],"members":{"GameSessionId":{},"PlayerId":{},"PlayerData":{}}},"output":{"type":"structure","members":{"PlayerSession":{"shape":"S4k"}}}},"CreatePlayerSessions":{"input":{"type":"structure","required":["GameSessionId","PlayerIds"],"members":{"GameSessionId":{},"PlayerIds":{"type":"list","member":{}},"PlayerDataMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S4r"}}}},"CreateScript":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"Sz"},"ZipFile":{"type":"blob"},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"Script":{"shape":"S4v"}}}},"CreateVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"VpcPeeringAuthorization":{"shape":"S4y"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","PeerVpcAwsAccountId","PeerVpcId"],"members":{"FleetId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}}},"DeleteBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}}},"DeleteFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}}},"DeleteFleetLocations":{"input":{"type":"structure","required":["FleetId","Locations"],"members":{"FleetId":{},"Locations":{"shape":"S3p"}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"LocationStates":{"shape":"S29"}}}},"DeleteGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"DeleteOption":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2w"}}}},"DeleteGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingRuleSet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId"],"members":{"Name":{},"FleetId":{}}}},"DeleteScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}}},"DeleteVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","VpcPeeringConnectionId"],"members":{"FleetId":{},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{}}},"DeregisterGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{}}}},"DescribeAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sv"}}}},"DescribeBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S13"}}}},"DescribeEC2InstanceLimits":{"input":{"type":"structure","members":{"EC2InstanceType":{},"Location":{}}},"output":{"type":"structure","members":{"EC2InstanceLimits":{"type":"list","member":{"type":"structure","members":{"EC2InstanceType":{},"CurrentInstances":{"type":"integer"},"InstanceLimit":{"type":"integer"},"Location":{}}}}}}},"DescribeFleetAttributes":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S5x"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"DescribeFleetCapacity":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S5x"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"type":"list","member":{"shape":"S63"}},"NextToken":{}}}},"DescribeFleetEvents":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ResourceId":{},"EventCode":{},"Message":{},"EventTime":{"type":"timestamp"},"PreSignedLogUrl":{}}}},"NextToken":{}}}},"DescribeFleetLocationAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Locations":{"shape":"S3p"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"LocationAttributes":{"type":"list","member":{"type":"structure","members":{"LocationState":{"shape":"S2a"},"StoppedActions":{"shape":"S27"},"UpdateStatus":{}}}},"NextToken":{}}}},"DescribeFleetLocationCapacity":{"input":{"type":"structure","required":["FleetId","Location"],"members":{"FleetId":{},"Location":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"shape":"S63"}}}},"DescribeFleetLocationUtilization":{"input":{"type":"structure","required":["FleetId","Location"],"members":{"FleetId":{},"Location":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"shape":"S6j"}}}},"DescribeFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"InboundPermissions":{"shape":"S1f"},"UpdateStatus":{},"Location":{}}}},"DescribeFleetUtilization":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S5x"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"type":"list","member":{"shape":"S6j"}},"NextToken":{}}}},"DescribeGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"DescribeGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2w"}}}},"DescribeGameServerInstances":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"InstanceIds":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServerInstances":{"type":"list","member":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"InstanceId":{},"InstanceStatus":{}}}},"NextToken":{}}}},"DescribeGameSessionDetails":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"Location":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionDetails":{"type":"list","member":{"type":"structure","members":{"GameSession":{"shape":"S3a"},"ProtectionPolicy":{}}}},"NextToken":{}}}},"DescribeGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S75"}}}},"DescribeGameSessionQueues":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionQueues":{"type":"list","member":{"shape":"S3w"}},"NextToken":{}}}},"DescribeGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"Location":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S7i"},"NextToken":{}}}},"DescribeInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InstanceId":{},"Limit":{"type":"integer"},"NextToken":{},"Location":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"InstanceId":{},"IpAddress":{},"DnsName":{},"OperatingSystem":{},"Type":{},"Status":{},"CreationTime":{"type":"timestamp"},"Location":{}}}},"NextToken":{}}}},"DescribeMatchmaking":{"input":{"type":"structure","required":["TicketIds"],"members":{"TicketIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"TicketList":{"type":"list","member":{"shape":"S7t"}}}}},"DescribeMatchmakingConfigurations":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"RuleSetName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Configurations":{"type":"list","member":{"shape":"S4a"}},"NextToken":{}}}},"DescribeMatchmakingRuleSets":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["RuleSets"],"members":{"RuleSets":{"type":"list","member":{"shape":"S4g"}},"NextToken":{}}}},"DescribePlayerSessions":{"input":{"type":"structure","members":{"GameSessionId":{},"PlayerId":{},"PlayerSessionId":{},"PlayerSessionStatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S4r"},"NextToken":{}}}},"DescribeRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S1l"}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{},"Location":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"Name":{},"Status":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"S8u"},"UpdateStatus":{},"Location":{}}}},"NextToken":{}}}},"DescribeScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}},"output":{"type":"structure","members":{"Script":{"shape":"S4v"}}}},"DescribeVpcPeeringAuthorizations":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"VpcPeeringAuthorizations":{"type":"list","member":{"shape":"S4y"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"FleetId":{}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"IpV4CidrBlock":{},"VpcPeeringConnectionId":{},"Status":{"type":"structure","members":{"Code":{},"Message":{}}},"PeerVpcId":{},"GameLiftVpcId":{}}}}}}},"GetGameSessionLogUrl":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{}}},"output":{"type":"structure","members":{"PreSignedUrl":{}}}},"GetInstanceAccess":{"input":{"type":"structure","required":["FleetId","InstanceId"],"members":{"FleetId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"InstanceAccess":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Credentials":{"type":"structure","members":{"UserName":{},"Secret":{}},"sensitive":true}}}}}},"ListAliases":{"input":{"type":"structure","members":{"RoutingStrategyType":{},"Name":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"Status":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Builds":{"type":"list","member":{"shape":"S13"}},"NextToken":{}}}},"ListFleets":{"input":{"type":"structure","members":{"BuildId":{},"ScriptId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetIds":{"type":"list","member":{}},"NextToken":{}}}},"ListGameServerGroups":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServerGroups":{"type":"list","member":{"shape":"S2w"}},"NextToken":{}}}},"ListGameServers":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"SortOrder":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServers":{"type":"list","member":{"shape":"Sc"}},"NextToken":{}}}},"ListScripts":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Scripts":{"type":"list","member":{"shape":"S4v"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sq"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId","MetricName"],"members":{"Name":{},"FleetId":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"Threshold":{"type":"double"},"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"S8u"}}},"output":{"type":"structure","members":{"Name":{}}}},"RegisterGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId","InstanceId"],"members":{"GameServerGroupName":{},"GameServerId":{},"InstanceId":{},"ConnectionInfo":{},"GameServerData":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"RequestUploadCredentials":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"UploadCredentials":{"shape":"S18"},"StorageLocation":{"shape":"Sz"}}}},"ResolveAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"ResumeGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","ResumeActions"],"members":{"GameServerGroupName":{},"ResumeActions":{"shape":"S2z"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2w"}}}},"SearchGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"AliasId":{},"Location":{},"FilterExpression":{},"SortExpression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S7i"},"NextToken":{}}}},"StartFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S27"},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"StartGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId","GameSessionQueueName","MaximumPlayerSessionCount"],"members":{"PlacementId":{},"GameSessionQueueName":{},"GameProperties":{"shape":"S33"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"PlayerLatencies":{"shape":"S77"},"DesiredPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerData":{}}}},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S75"}}}},"StartMatchBackfill":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"GameSessionArn":{},"Players":{"shape":"S7w"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S7t"}}}},"StartMatchmaking":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"Players":{"shape":"S7w"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S7t"}}}},"StopFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S27"},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"StopGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S75"}}}},"StopMatchmaking":{"input":{"type":"structure","required":["TicketId"],"members":{"TicketId":{}}},"output":{"type":"structure","members":{}}},"SuspendGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","SuspendActions"],"members":{"GameServerGroupName":{},"SuspendActions":{"shape":"S2z"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2w"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sm"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sv"}}}},"UpdateBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{},"Name":{},"Version":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S13"}}}},"UpdateFleetAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Name":{},"Description":{},"NewGameSessionProtectionPolicy":{},"ResourceCreationLimitPolicy":{"shape":"S1r"},"MetricGroups":{"shape":"S1t"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetCapacity":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"DesiredInstances":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"Location":{}}}},"UpdateFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InboundPermissionAuthorizations":{"shape":"S1f"},"InboundPermissionRevocations":{"shape":"S1f"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{},"GameServerData":{},"UtilizationStatus":{},"HealthCheck":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sc"}}}},"UpdateGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"RoleArn":{},"InstanceDefinitions":{"shape":"S2k"},"GameServerProtectionPolicy":{},"BalancingStrategy":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S2w"}}}},"UpdateGameSession":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"PlayerSessionCreationPolicy":{},"ProtectionPolicy":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S3a"}}}},"UpdateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S3j"},"Destinations":{"shape":"S3l"},"FilterConfiguration":{"shape":"S3o"},"PriorityConfiguration":{"shape":"S3q"},"CustomEventData":{},"NotificationTarget":{}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S3w"}}}},"UpdateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S3z"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S33"},"GameSessionData":{},"BackfillMode":{},"FlexMatchMode":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S4a"}}}},"UpdateRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId","RuntimeConfiguration"],"members":{"FleetId":{},"RuntimeConfiguration":{"shape":"S1l"}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S1l"}}}},"UpdateScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{},"Name":{},"Version":{},"StorageLocation":{"shape":"Sz"},"ZipFile":{"type":"blob"}}},"output":{"type":"structure","members":{"Script":{"shape":"S4v"}}}},"ValidateMatchmakingRuleSet":{"input":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetBody":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{}},"Sc":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"GameServerId":{},"InstanceId":{},"ConnectionInfo":{},"GameServerData":{},"ClaimStatus":{},"UtilizationStatus":{},"RegistrationTime":{"type":"timestamp"},"LastClaimTime":{"type":"timestamp"},"LastHealthCheckTime":{"type":"timestamp"}}},"Sm":{"type":"structure","members":{"Type":{},"FleetId":{},"Message":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sv":{"type":"structure","members":{"AliasId":{},"Name":{},"AliasArn":{},"Description":{},"RoutingStrategy":{"shape":"Sm"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"Sz":{"type":"structure","members":{"Bucket":{},"Key":{},"RoleArn":{},"ObjectVersion":{}}},"S13":{"type":"structure","members":{"BuildId":{},"BuildArn":{},"Name":{},"Version":{},"Status":{},"SizeOnDisk":{"type":"long"},"OperatingSystem":{},"CreationTime":{"type":"timestamp"}}},"S18":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{}},"sensitive":true},"S1f":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","IpRange","Protocol"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"IpRange":{},"Protocol":{}}}},"S1l":{"type":"structure","members":{"ServerProcesses":{"type":"list","member":{"type":"structure","required":["LaunchPath","ConcurrentExecutions"],"members":{"LaunchPath":{},"Parameters":{},"ConcurrentExecutions":{"type":"integer"}}}},"MaxConcurrentGameSessionActivations":{"type":"integer"},"GameSessionActivationTimeoutSeconds":{"type":"integer"}}},"S1r":{"type":"structure","members":{"NewGameSessionsPerCreator":{"type":"integer"},"PolicyPeriodInMinutes":{"type":"integer"}}},"S1t":{"type":"list","member":{}},"S1w":{"type":"structure","required":["CertificateType"],"members":{"CertificateType":{}}},"S1y":{"type":"list","member":{"type":"structure","members":{"Location":{}}}},"S22":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"FleetType":{},"InstanceType":{},"Description":{},"Name":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"BuildId":{},"BuildArn":{},"ScriptId":{},"ScriptArn":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"NewGameSessionProtectionPolicy":{},"OperatingSystem":{},"ResourceCreationLimitPolicy":{"shape":"S1r"},"MetricGroups":{"shape":"S1t"},"StoppedActions":{"shape":"S27"},"InstanceRoleArn":{},"CertificateConfiguration":{"shape":"S1w"}}},"S27":{"type":"list","member":{}},"S29":{"type":"list","member":{"shape":"S2a"}},"S2a":{"type":"structure","members":{"Location":{},"Status":{}}},"S2k":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{}}}},"S2w":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"RoleArn":{},"InstanceDefinitions":{"shape":"S2k"},"BalancingStrategy":{},"GameServerProtectionPolicy":{},"AutoScalingGroupArn":{},"Status":{},"StatusReason":{},"SuspendedActions":{"shape":"S2z"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S2z":{"type":"list","member":{}},"S33":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S3a":{"type":"structure","members":{"GameSessionId":{},"Name":{},"FleetId":{},"FleetArn":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Status":{},"StatusReason":{},"GameProperties":{"shape":"S33"},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"PlayerSessionCreationPolicy":{},"CreatorId":{},"GameSessionData":{},"MatchmakerData":{},"Location":{}}},"S3j":{"type":"list","member":{"type":"structure","members":{"MaximumIndividualPlayerLatencyMilliseconds":{"type":"integer"},"PolicyDurationSeconds":{"type":"integer"}}}},"S3l":{"type":"list","member":{"type":"structure","members":{"DestinationArn":{}}}},"S3o":{"type":"structure","members":{"AllowedLocations":{"shape":"S3p"}}},"S3p":{"type":"list","member":{}},"S3q":{"type":"structure","members":{"PriorityOrder":{"type":"list","member":{}},"LocationOrder":{"shape":"S3p"}}},"S3w":{"type":"structure","members":{"Name":{},"GameSessionQueueArn":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S3j"},"Destinations":{"shape":"S3l"},"FilterConfiguration":{"shape":"S3o"},"PriorityConfiguration":{"shape":"S3q"},"CustomEventData":{},"NotificationTarget":{}}},"S3z":{"type":"list","member":{}},"S4a":{"type":"structure","members":{"Name":{},"ConfigurationArn":{},"Description":{},"GameSessionQueueArns":{"shape":"S3z"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"RuleSetArn":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"CreationTime":{"type":"timestamp"},"GameProperties":{"shape":"S33"},"GameSessionData":{},"BackfillMode":{},"FlexMatchMode":{}}},"S4g":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetName":{},"RuleSetArn":{},"RuleSetBody":{},"CreationTime":{"type":"timestamp"}}},"S4k":{"type":"structure","members":{"PlayerSessionId":{},"PlayerId":{},"GameSessionId":{},"FleetId":{},"FleetArn":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"PlayerData":{}}},"S4r":{"type":"list","member":{"shape":"S4k"}},"S4v":{"type":"structure","members":{"ScriptId":{},"ScriptArn":{},"Name":{},"Version":{},"SizeOnDisk":{"type":"long"},"CreationTime":{"type":"timestamp"},"StorageLocation":{"shape":"Sz"}}},"S4y":{"type":"structure","members":{"GameLiftAwsAccountId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"}}},"S5x":{"type":"list","member":{}},"S63":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"InstanceType":{},"InstanceCounts":{"type":"structure","members":{"DESIRED":{"type":"integer"},"MINIMUM":{"type":"integer"},"MAXIMUM":{"type":"integer"},"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}},"Location":{}}},"S6j":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"ActiveServerProcessCount":{"type":"integer"},"ActiveGameSessionCount":{"type":"integer"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Location":{}}},"S75":{"type":"structure","members":{"PlacementId":{},"GameSessionQueueName":{},"Status":{},"GameProperties":{"shape":"S33"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"GameSessionId":{},"GameSessionArn":{},"GameSessionRegion":{},"PlayerLatencies":{"shape":"S77"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"PlacedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}},"GameSessionData":{},"MatchmakerData":{}}},"S77":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"RegionIdentifier":{},"LatencyInMilliseconds":{"type":"float"}}}},"S7i":{"type":"list","member":{"shape":"S3a"}},"S7t":{"type":"structure","members":{"TicketId":{},"ConfigurationName":{},"ConfigurationArn":{},"Status":{},"StatusReason":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Players":{"shape":"S7w"},"GameSessionConnectionInfo":{"type":"structure","members":{"GameSessionArn":{},"IpAddress":{},"DnsName":{},"Port":{"type":"integer"},"MatchedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}}}},"EstimatedWaitTime":{"type":"integer"}}},"S7w":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"S":{},"N":{"type":"double"},"SL":{"shape":"S3"},"SDM":{"type":"map","key":{},"value":{"type":"double"}}}}},"Team":{},"LatencyInMs":{"type":"map","key":{},"value":{"type":"integer"}}}}},"S8u":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeFleetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetAttributes"},"DescribeFleetCapacity":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetCapacity"},"DescribeFleetEvents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Events"},"DescribeFleetLocationAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit"},"DescribeFleetUtilization":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetUtilization"},"DescribeGameServerInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameServerInstances"},"DescribeGameSessionDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessionDetails"},"DescribeGameSessionQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessionQueues"},"DescribeGameSessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessions"},"DescribeInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Instances"},"DescribeMatchmakingConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Configurations"},"DescribeMatchmakingRuleSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"RuleSets"},"DescribePlayerSessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"PlayerSessions"},"DescribeScalingPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"ScalingPolicies"},"ListAliases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Aliases"},"ListBuilds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Builds"},"ListFleets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetIds"},"ListGameServerGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameServerGroups"},"ListGameServers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameServers"},"ListScripts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Scripts"},"SearchGameSessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessions"}}}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['glacier'] = {};
	AWS.Glacier = Service.defineService('glacier', ['2012-06-01']);
	__webpack_require__(242);
	Object.defineProperty(apiLoader.services['glacier'], '2012-06-01', {
	  get: function get() {
	    var model = __webpack_require__(243);
	    model.paginators = __webpack_require__(244).pagination;
	    model.waiters = __webpack_require__(245).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Glacier;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.Glacier.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (Array.isArray(request._events.validate)) {
	      request._events.validate.unshift(this.validateAccountId);
	    } else {
	      request.on('validate', this.validateAccountId);
	    }
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.COMPUTE_SHA256);
	    request.on('build', this.addGlacierApiVersion);
	    request.on('build', this.addTreeHashHeaders);
	  },

	  /**
	   * @api private
	   */
	  validateAccountId: function validateAccountId(request) {
	    if (request.params.accountId !== undefined) return;
	    request.params = AWS.util.copy(request.params);
	    request.params.accountId = '-';
	  },

	  /**
	   * @api private
	   */
	  addGlacierApiVersion: function addGlacierApiVersion(request) {
	    var version = request.service.api.apiVersion;
	    request.httpRequest.headers['x-amz-glacier-version'] = version;
	  },

	  /**
	   * @api private
	   */
	  addTreeHashHeaders: function addTreeHashHeaders(request) {
	    if (request.params.body === undefined) return;

	    var hashes = request.service.computeChecksums(request.params.body);
	    request.httpRequest.headers['X-Amz-Content-Sha256'] = hashes.linearHash;

	    if (!request.httpRequest.headers['x-amz-sha256-tree-hash']) {
	      request.httpRequest.headers['x-amz-sha256-tree-hash'] = hashes.treeHash;
	    }
	  },

	  /**
	   * @!group Computing Checksums
	   */

	  /**
	   * Computes the SHA-256 linear and tree hash checksums for a given
	   * block of Buffer data. Pass the tree hash of the computed checksums
	   * as the checksum input to the {completeMultipartUpload} when performing
	   * a multi-part upload.
	   *
	   * @example Calculate checksum of 5.5MB data chunk
	   *   var glacier = new AWS.Glacier();
	   *   var data = Buffer.alloc(5.5 * 1024 * 1024);
	   *   data.fill('0'); // fill with zeros
	   *   var results = glacier.computeChecksums(data);
	   *   // Result: { linearHash: '68aff0c5a9...', treeHash: '154e26c78f...' }
	   * @param data [Buffer, String] data to calculate the checksum for
	   * @return [map<linearHash:String,treeHash:String>] a map containing
	   *   the linearHash and treeHash properties representing hex based digests
	   *   of the respective checksums.
	   * @see completeMultipartUpload
	   */
	  computeChecksums: function computeChecksums(data) {
	    if (!AWS.util.Buffer.isBuffer(data)) data = AWS.util.buffer.toBuffer(data);

	    var mb = 1024 * 1024;
	    var hashes = [];
	    var hash = AWS.util.crypto.createHash('sha256');

	    // build leaf nodes in 1mb chunks
	    for (var i = 0; i < data.length; i += mb) {
	      var chunk = data.slice(i, Math.min(i + mb, data.length));
	      hash.update(chunk);
	      hashes.push(AWS.util.crypto.sha256(chunk));
	    }

	    return {
	      linearHash: hash.digest('hex'),
	      treeHash: this.buildHashTree(hashes)
	    };
	  },

	  /**
	   * @api private
	   */
	  buildHashTree: function buildHashTree(hashes) {
	    // merge leaf nodes
	    while (hashes.length > 1) {
	      var tmpHashes = [];
	      for (var i = 0; i < hashes.length; i += 2) {
	        if (hashes[i + 1]) {
	          var tmpHash = AWS.util.buffer.alloc(64);
	          tmpHash.write(hashes[i], 0, 32, 'binary');
	          tmpHash.write(hashes[i + 1], 32, 32, 'binary');
	          tmpHashes.push(AWS.util.crypto.sha256(tmpHash));
	        } else {
	          tmpHashes.push(hashes[i]);
	        }
	      }
	      hashes = tmpHashes;
	    }

	    return AWS.util.crypto.toHex(hashes[0]);
	  }
	});


/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-06-01","checksumFormat":"sha256","endpointPrefix":"glacier","protocol":"rest-json","serviceFullName":"Amazon Glacier","serviceId":"Glacier","signatureVersion":"v4","uid":"glacier-2012-06-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"}}}},"AbortVaultLock":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/lock-policy","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"AddTagsToVault":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/tags?operation=add","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"Tags":{"shape":"S5"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"},"archiveSize":{"location":"header","locationName":"x-amz-archive-size"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"}}},"output":{"shape":"S9"}},"CompleteVaultLock":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/lock-policy/{lockId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","lockId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"lockId":{"location":"uri","locationName":"lockId"}}}},"CreateVault":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"}}}},"DeleteArchive":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/archives/{archiveId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","archiveId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"archiveId":{"location":"uri","locationName":"archiveId"}}}},"DeleteVault":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"DeleteVaultAccessPolicy":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/access-policy","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"DeleteVaultNotifications":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/notification-configuration","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/jobs/{jobId}"},"input":{"type":"structure","required":["accountId","vaultName","jobId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"shape":"Si"}},"DescribeVault":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"shape":"S1a"}},"GetDataRetrievalPolicy":{"http":{"method":"GET","requestUri":"/{accountId}/policies/data-retrieval"},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1e"}}}},"GetJobOutput":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/jobs/{jobId}/output"},"input":{"type":"structure","required":["accountId","vaultName","jobId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"jobId":{"location":"uri","locationName":"jobId"},"range":{"location":"header","locationName":"Range"}}},"output":{"type":"structure","members":{"body":{"shape":"S1k"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"status":{"location":"statusCode","type":"integer"},"contentRange":{"location":"header","locationName":"Content-Range"},"acceptRanges":{"location":"header","locationName":"Accept-Ranges"},"contentType":{"location":"header","locationName":"Content-Type"},"archiveDescription":{"location":"header","locationName":"x-amz-archive-description"}},"payload":"body"}},"GetVaultAccessPolicy":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/access-policy"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"policy":{"shape":"S1o"}},"payload":"policy"}},"GetVaultLock":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/lock-policy"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"Policy":{},"State":{},"ExpirationDate":{},"CreationDate":{}}}},"GetVaultNotifications":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/notification-configuration"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"vaultNotificationConfig":{"shape":"S1t"}},"payload":"vaultNotificationConfig"}},"InitiateJob":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/jobs","responseCode":202},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"jobParameters":{"type":"structure","members":{"Format":{},"Type":{},"ArchiveId":{},"Description":{},"SNSTopic":{},"RetrievalByteRange":{},"Tier":{},"InventoryRetrievalParameters":{"type":"structure","members":{"StartDate":{},"EndDate":{},"Limit":{},"Marker":{}}},"SelectParameters":{"shape":"Sp"},"OutputLocation":{"shape":"Sx"}}}},"payload":"jobParameters"},"output":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"},"jobId":{"location":"header","locationName":"x-amz-job-id"},"jobOutputPath":{"location":"header","locationName":"x-amz-job-output-path"}}}},"InitiateMultipartUpload":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"archiveDescription":{"location":"header","locationName":"x-amz-archive-description"},"partSize":{"location":"header","locationName":"x-amz-part-size"}}},"output":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"},"uploadId":{"location":"header","locationName":"x-amz-multipart-upload-id"}}}},"InitiateVaultLock":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/lock-policy","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"policy":{"type":"structure","members":{"Policy":{}}}},"payload":"policy"},"output":{"type":"structure","members":{"lockId":{"location":"header","locationName":"x-amz-lock-id"}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/jobs"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"limit":{"location":"querystring","locationName":"limit"},"marker":{"location":"querystring","locationName":"marker"},"statuscode":{"location":"querystring","locationName":"statuscode"},"completed":{"location":"querystring","locationName":"completed"}}},"output":{"type":"structure","members":{"JobList":{"type":"list","member":{"shape":"Si"}},"Marker":{}}}},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"marker":{"location":"querystring","locationName":"marker"},"limit":{"location":"querystring","locationName":"limit"}}},"output":{"type":"structure","members":{"UploadsList":{"type":"list","member":{"type":"structure","members":{"MultipartUploadId":{},"VaultARN":{},"ArchiveDescription":{},"PartSizeInBytes":{"type":"long"},"CreationDate":{}}}},"Marker":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}"},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"},"marker":{"location":"querystring","locationName":"marker"},"limit":{"location":"querystring","locationName":"limit"}}},"output":{"type":"structure","members":{"MultipartUploadId":{},"VaultARN":{},"ArchiveDescription":{},"PartSizeInBytes":{"type":"long"},"CreationDate":{},"Parts":{"type":"list","member":{"type":"structure","members":{"RangeInBytes":{},"SHA256TreeHash":{}}}},"Marker":{}}}},"ListProvisionedCapacity":{"http":{"method":"GET","requestUri":"/{accountId}/provisioned-capacity"},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"ProvisionedCapacityList":{"type":"list","member":{"type":"structure","members":{"CapacityId":{},"StartDate":{},"ExpirationDate":{}}}}}}},"ListTagsForVault":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/tags"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5"}}}},"ListVaults":{"http":{"method":"GET","requestUri":"/{accountId}/vaults"},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"marker":{"location":"querystring","locationName":"marker"},"limit":{"location":"querystring","locationName":"limit"}}},"output":{"type":"structure","members":{"VaultList":{"type":"list","member":{"shape":"S1a"}},"Marker":{}}}},"PurchaseProvisionedCapacity":{"http":{"requestUri":"/{accountId}/provisioned-capacity","responseCode":201},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"capacityId":{"location":"header","locationName":"x-amz-capacity-id"}}}},"RemoveTagsFromVault":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/tags?operation=remove","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"TagKeys":{"type":"list","member":{}}}}},"SetDataRetrievalPolicy":{"http":{"method":"PUT","requestUri":"/{accountId}/policies/data-retrieval","responseCode":204},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"Policy":{"shape":"S1e"}}}},"SetVaultAccessPolicy":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}/access-policy","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"policy":{"shape":"S1o"}},"payload":"policy"}},"SetVaultNotifications":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}/notification-configuration","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"vaultNotificationConfig":{"shape":"S1t"}},"payload":"vaultNotificationConfig"}},"UploadArchive":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/archives","responseCode":201},"input":{"type":"structure","required":["vaultName","accountId"],"members":{"vaultName":{"location":"uri","locationName":"vaultName"},"accountId":{"location":"uri","locationName":"accountId"},"archiveDescription":{"location":"header","locationName":"x-amz-archive-description"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"body":{"shape":"S1k"}},"payload":"body"},"output":{"shape":"S9"}},"UploadMultipartPart":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"range":{"location":"header","locationName":"Content-Range"},"body":{"shape":"S1k"}},"payload":"body"},"output":{"type":"structure","members":{"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"}}}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"archiveId":{"location":"header","locationName":"x-amz-archive-id"}}},"Si":{"type":"structure","members":{"JobId":{},"JobDescription":{},"Action":{},"ArchiveId":{},"VaultARN":{},"CreationDate":{},"Completed":{"type":"boolean"},"StatusCode":{},"StatusMessage":{},"ArchiveSizeInBytes":{"type":"long"},"InventorySizeInBytes":{"type":"long"},"SNSTopic":{},"CompletionDate":{},"SHA256TreeHash":{},"ArchiveSHA256TreeHash":{},"RetrievalByteRange":{},"Tier":{},"InventoryRetrievalParameters":{"type":"structure","members":{"Format":{},"StartDate":{},"EndDate":{},"Limit":{},"Marker":{}}},"JobOutputPath":{},"SelectParameters":{"shape":"Sp"},"OutputLocation":{"shape":"Sx"}}},"Sp":{"type":"structure","members":{"InputSerialization":{"type":"structure","members":{"csv":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}}}},"ExpressionType":{},"Expression":{},"OutputSerialization":{"type":"structure","members":{"csv":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}}}}}},"Sx":{"type":"structure","members":{"S3":{"type":"structure","members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","members":{"EncryptionType":{},"KMSKeyId":{},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"type":"list","member":{"type":"structure","members":{"Grantee":{"type":"structure","required":["Type"],"members":{"Type":{},"DisplayName":{},"URI":{},"ID":{},"EmailAddress":{}}},"Permission":{}}}},"Tagging":{"shape":"S17"},"UserMetadata":{"shape":"S17"},"StorageClass":{}}}}},"S17":{"type":"map","key":{},"value":{}},"S1a":{"type":"structure","members":{"VaultARN":{},"VaultName":{},"CreationDate":{},"LastInventoryDate":{},"NumberOfArchives":{"type":"long"},"SizeInBytes":{"type":"long"}}},"S1e":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Strategy":{},"BytesPerHour":{"type":"long"}}}}}},"S1k":{"type":"blob","streaming":true},"S1o":{"type":"structure","members":{"Policy":{}}},"S1t":{"type":"structure","members":{"SNSTopic":{},"Events":{"type":"list","member":{}}}}}}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListJobs":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"JobList"},"ListMultipartUploads":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"UploadsList"},"ListParts":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"Parts"},"ListVaults":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"VaultList"}}}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"VaultExists":{"operation":"DescribeVault","delay":3,"maxAttempts":15,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]},"VaultNotExists":{"operation":"DescribeVault","delay":3,"maxAttempts":15,"acceptors":[{"state":"retry","matcher":"status","expected":200},{"state":"success","matcher":"error","expected":"ResourceNotFoundException"}]}}}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['health'] = {};
	AWS.Health = Service.defineService('health', ['2016-08-04']);
	Object.defineProperty(apiLoader.services['health'], '2016-08-04', {
	  get: function get() {
	    var model = __webpack_require__(247);
	    model.paginators = __webpack_require__(248).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Health;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-08-04","endpointPrefix":"health","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWSHealth","serviceFullName":"AWS Health APIs and Notifications","serviceId":"Health","signatureVersion":"v4","targetPrefix":"AWSHealth_20160804","uid":"health-2016-08-04"},"operations":{"DescribeAffectedAccountsForOrganization":{"input":{"type":"structure","required":["eventArn"],"members":{"eventArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"affectedAccounts":{"type":"list","member":{}},"eventScopeCode":{},"nextToken":{}}},"idempotent":true},"DescribeAffectedEntities":{"input":{"type":"structure","required":["filter"],"members":{"filter":{"type":"structure","required":["eventArns"],"members":{"eventArns":{"shape":"Sb"},"entityArns":{"shape":"Sc"},"entityValues":{"shape":"Se"},"lastUpdatedTimes":{"shape":"Sg"},"tags":{"shape":"Sj"},"statusCodes":{"type":"list","member":{}}}},"locale":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"entities":{"shape":"Sr"},"nextToken":{}}},"idempotent":true},"DescribeAffectedEntitiesForOrganization":{"input":{"type":"structure","required":["organizationEntityFilters"],"members":{"organizationEntityFilters":{"type":"list","member":{"shape":"Sw"}},"locale":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"entities":{"shape":"Sr"},"failedSet":{"type":"list","member":{"type":"structure","members":{"awsAccountId":{},"eventArn":{},"errorName":{},"errorMessage":{}}}},"nextToken":{}}},"idempotent":true},"DescribeEntityAggregates":{"input":{"type":"structure","members":{"eventArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"entityAggregates":{"type":"list","member":{"type":"structure","members":{"eventArn":{},"count":{"type":"integer"}}}}}},"idempotent":true},"DescribeEventAggregates":{"input":{"type":"structure","required":["aggregateField"],"members":{"filter":{"shape":"S19"},"aggregateField":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"eventAggregates":{"type":"list","member":{"type":"structure","members":{"aggregateValue":{},"count":{"type":"integer"}}}},"nextToken":{}}},"idempotent":true},"DescribeEventDetails":{"input":{"type":"structure","required":["eventArns"],"members":{"eventArns":{"shape":"Sb"},"locale":{}}},"output":{"type":"structure","members":{"successfulSet":{"type":"list","member":{"type":"structure","members":{"event":{"shape":"S1v"},"eventDescription":{"shape":"S1x"},"eventMetadata":{"shape":"S1z"}}}},"failedSet":{"type":"list","member":{"type":"structure","members":{"eventArn":{},"errorName":{},"errorMessage":{}}}}}},"idempotent":true},"DescribeEventDetailsForOrganization":{"input":{"type":"structure","required":["organizationEventDetailFilters"],"members":{"organizationEventDetailFilters":{"type":"list","member":{"shape":"Sw"}},"locale":{}}},"output":{"type":"structure","members":{"successfulSet":{"type":"list","member":{"type":"structure","members":{"awsAccountId":{},"event":{"shape":"S1v"},"eventDescription":{"shape":"S1x"},"eventMetadata":{"shape":"S1z"}}}},"failedSet":{"type":"list","member":{"type":"structure","members":{"awsAccountId":{},"eventArn":{},"errorName":{},"errorMessage":{}}}}}},"idempotent":true},"DescribeEventTypes":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"eventTypeCodes":{"type":"list","member":{}},"services":{"shape":"S1c"},"eventTypeCategories":{"type":"list","member":{}}}},"locale":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTypes":{"type":"list","member":{"type":"structure","members":{"service":{},"code":{},"category":{}}}},"nextToken":{}}},"idempotent":true},"DescribeEvents":{"input":{"type":"structure","members":{"filter":{"shape":"S19"},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"shape":"S1v"}},"nextToken":{}}},"idempotent":true},"DescribeEventsForOrganization":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"eventTypeCodes":{"shape":"S1a"},"awsAccountIds":{"type":"list","member":{}},"services":{"shape":"S1c"},"regions":{"shape":"S1e"},"startTime":{"shape":"Sh"},"endTime":{"shape":"Sh"},"lastUpdatedTime":{"shape":"Sh"},"entityArns":{"shape":"Sc"},"entityValues":{"shape":"Se"},"eventTypeCategories":{"shape":"S1i"},"eventStatusCodes":{"shape":"S1k"}}},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"arn":{},"service":{},"eventTypeCode":{},"eventTypeCategory":{},"eventScopeCode":{},"region":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"statusCode":{}}}},"nextToken":{}}},"idempotent":true},"DescribeHealthServiceStatusForOrganization":{"output":{"type":"structure","members":{"healthServiceAccessStatusForOrganization":{}}},"idempotent":true},"DisableHealthServiceAccessForOrganization":{"idempotent":true},"EnableHealthServiceAccessForOrganization":{"idempotent":true}},"shapes":{"Sb":{"type":"list","member":{}},"Sc":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sg":{"type":"list","member":{"shape":"Sh"}},"Sh":{"type":"structure","members":{"from":{"type":"timestamp"},"to":{"type":"timestamp"}}},"Sj":{"type":"list","member":{"shape":"Sk"}},"Sk":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{"type":"structure","members":{"entityArn":{},"eventArn":{},"entityValue":{},"entityUrl":{},"awsAccountId":{},"lastUpdatedTime":{"type":"timestamp"},"statusCode":{},"tags":{"shape":"Sk"}}}},"Sw":{"type":"structure","required":["eventArn"],"members":{"eventArn":{},"awsAccountId":{}}},"S19":{"type":"structure","members":{"eventArns":{"shape":"Sb"},"eventTypeCodes":{"shape":"S1a"},"services":{"shape":"S1c"},"regions":{"shape":"S1e"},"availabilityZones":{"type":"list","member":{}},"startTimes":{"shape":"Sg"},"endTimes":{"shape":"Sg"},"lastUpdatedTimes":{"shape":"Sg"},"entityArns":{"shape":"Sc"},"entityValues":{"shape":"Se"},"eventTypeCategories":{"shape":"S1i"},"tags":{"shape":"Sj"},"eventStatusCodes":{"shape":"S1k"}}},"S1a":{"type":"list","member":{}},"S1c":{"type":"list","member":{}},"S1e":{"type":"list","member":{}},"S1i":{"type":"list","member":{}},"S1k":{"type":"list","member":{}},"S1v":{"type":"structure","members":{"arn":{},"service":{},"eventTypeCode":{},"eventTypeCategory":{},"region":{},"availabilityZone":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"statusCode":{},"eventScopeCode":{}}},"S1x":{"type":"structure","members":{"latestDescription":{}}},"S1z":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAffectedAccountsForOrganization":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["eventScopeCode"],"output_token":"nextToken","result_key":"affectedAccounts"},"DescribeAffectedEntities":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"entities"},"DescribeAffectedEntitiesForOrganization":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["failedSet"],"output_token":"nextToken","result_key":"entities"},"DescribeEntityAggregates":{"result_key":"entityAggregates"},"DescribeEventAggregates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventAggregates"},"DescribeEventTypes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventTypes"},"DescribeEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"events"},"DescribeEventsForOrganization":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"events"}}}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iam'] = {};
	AWS.IAM = Service.defineService('iam', ['2010-05-08']);
	Object.defineProperty(apiLoader.services['iam'], '2010-05-08', {
	  get: function get() {
	    var model = __webpack_require__(250);
	    model.paginators = __webpack_require__(251).pagination;
	    model.waiters = __webpack_require__(252).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IAM;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-08","endpointPrefix":"iam","globalEndpoint":"iam.amazonaws.com","protocol":"query","serviceAbbreviation":"IAM","serviceFullName":"AWS Identity and Access Management","serviceId":"IAM","signatureVersion":"v4","uid":"iam-2010-05-08","xmlNamespace":"https://iam.amazonaws.com/doc/2010-05-08/"},"operations":{"AddClientIDToOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"AddRoleToInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"AddUserToGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"AttachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"AttachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"AttachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"ChangePassword":{"input":{"type":"structure","required":["OldPassword","NewPassword"],"members":{"OldPassword":{"shape":"Sf"},"NewPassword":{"shape":"Sf"}}}},"CreateAccessKey":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"CreateAccessKeyResult","type":"structure","required":["AccessKey"],"members":{"AccessKey":{"type":"structure","required":["UserName","AccessKeyId","Status","SecretAccessKey"],"members":{"UserName":{},"AccessKeyId":{},"Status":{},"SecretAccessKey":{"type":"string","sensitive":true},"CreateDate":{"type":"timestamp"}}}}}},"CreateAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"CreateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"Path":{},"GroupName":{}}},"output":{"resultWrapper":"CreateGroupResult","type":"structure","required":["Group"],"members":{"Group":{"shape":"Ss"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{},"Path":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"S10"}}}},"CreateLoginProfile":{"input":{"type":"structure","required":["UserName","Password"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}},"output":{"resultWrapper":"CreateLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1d"}}}},"CreateOpenIDConnectProvider":{"input":{"type":"structure","required":["Url","ThumbprintList"],"members":{"Url":{},"ClientIDList":{"shape":"S1g"},"ThumbprintList":{"shape":"S1h"},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateOpenIDConnectProviderResult","type":"structure","members":{"OpenIDConnectProviderArn":{},"Tags":{"shape":"Sv"}}}},"CreatePolicy":{"input":{"type":"structure","required":["PolicyName","PolicyDocument"],"members":{"PolicyName":{},"Path":{},"PolicyDocument":{},"Description":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreatePolicyResult","type":"structure","members":{"Policy":{"shape":"S1p"}}}},"CreatePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","PolicyDocument"],"members":{"PolicyArn":{},"PolicyDocument":{},"SetAsDefault":{"type":"boolean"}}},"output":{"resultWrapper":"CreatePolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1u"}}}},"CreateRole":{"input":{"type":"structure","required":["RoleName","AssumeRolePolicyDocument"],"members":{"Path":{},"RoleName":{},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"S12"}}}},"CreateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","Name"],"members":{"SAMLMetadataDocument":{},"Name":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{},"Tags":{"shape":"Sv"}}}},"CreateServiceLinkedRole":{"input":{"type":"structure","required":["AWSServiceName"],"members":{"AWSServiceName":{},"Description":{},"CustomSuffix":{}}},"output":{"resultWrapper":"CreateServiceLinkedRoleResult","type":"structure","members":{"Role":{"shape":"S12"}}}},"CreateServiceSpecificCredential":{"input":{"type":"structure","required":["UserName","ServiceName"],"members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"CreateServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S27"}}}},"CreateUser":{"input":{"type":"structure","required":["UserName"],"members":{"Path":{},"UserName":{},"PermissionsBoundary":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateUserResult","type":"structure","members":{"User":{"shape":"S2d"}}}},"CreateVirtualMFADevice":{"input":{"type":"structure","required":["VirtualMFADeviceName"],"members":{"Path":{},"VirtualMFADeviceName":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateVirtualMFADeviceResult","type":"structure","required":["VirtualMFADevice"],"members":{"VirtualMFADevice":{"shape":"S2h"}}}},"DeactivateMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber"],"members":{"UserName":{},"SerialNumber":{}}}},"DeleteAccessKey":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"UserName":{},"AccessKeyId":{}}}},"DeleteAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"DeleteAccountPasswordPolicy":{},"DeleteGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{}}}},"DeleteGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}}},"DeleteLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}}},"DeletePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"DeleteRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}}},"DeleteSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}}},"DeleteSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId"],"members":{"UserName":{},"SSHPublicKeyId":{}}}},"DeleteServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}}},"DeleteServiceLinkedRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"DeleteServiceLinkedRoleResult","type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}}},"DeleteServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}}},"DeleteSigningCertificate":{"input":{"type":"structure","required":["CertificateId"],"members":{"UserName":{},"CertificateId":{}}}},"DeleteUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}}},"DeleteVirtualMFADevice":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{}}}},"DetachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"DetachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"DetachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"EnableMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"GenerateCredentialReport":{"output":{"resultWrapper":"GenerateCredentialReportResult","type":"structure","members":{"State":{},"Description":{}}}},"GenerateOrganizationsAccessReport":{"input":{"type":"structure","required":["EntityPath"],"members":{"EntityPath":{},"OrganizationsPolicyId":{}}},"output":{"resultWrapper":"GenerateOrganizationsAccessReportResult","type":"structure","members":{"JobId":{}}}},"GenerateServiceLastAccessedDetails":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Granularity":{}}},"output":{"resultWrapper":"GenerateServiceLastAccessedDetailsResult","type":"structure","members":{"JobId":{}}}},"GetAccessKeyLastUsed":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyLastUsedResult","type":"structure","members":{"UserName":{},"AccessKeyLastUsed":{"type":"structure","required":["LastUsedDate","ServiceName","Region"],"members":{"LastUsedDate":{"type":"timestamp"},"ServiceName":{},"Region":{}}}}}},"GetAccountAuthorizationDetails":{"input":{"type":"structure","members":{"Filter":{"type":"list","member":{}},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetAccountAuthorizationDetailsResult","type":"structure","members":{"UserDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"UserPolicyList":{"shape":"S43"},"GroupList":{"type":"list","member":{}},"AttachedManagedPolicies":{"shape":"S46"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"}}}},"GroupDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"GroupPolicyList":{"shape":"S43"},"AttachedManagedPolicies":{"shape":"S46"}}}},"RoleDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"InstanceProfileList":{"shape":"S4c"},"RolePolicyList":{"shape":"S43"},"AttachedManagedPolicies":{"shape":"S46"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"},"RoleLastUsed":{"shape":"S18"}}}},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"PolicyVersionList":{"shape":"S4f"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetAccountPasswordPolicy":{"output":{"resultWrapper":"GetAccountPasswordPolicyResult","type":"structure","required":["PasswordPolicy"],"members":{"PasswordPolicy":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"ExpirePasswords":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}}}},"GetAccountSummary":{"output":{"resultWrapper":"GetAccountSummaryResult","type":"structure","members":{"SummaryMap":{"type":"map","key":{},"value":{"type":"integer"}}}}},"GetContextKeysForCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList"],"members":{"PolicyInputList":{"shape":"S4s"}}},"output":{"shape":"S4t","resultWrapper":"GetContextKeysForCustomPolicyResult"}},"GetContextKeysForPrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4s"}}},"output":{"shape":"S4t","resultWrapper":"GetContextKeysForPrincipalPolicyResult"}},"GetCredentialReport":{"output":{"resultWrapper":"GetCredentialReportResult","type":"structure","members":{"Content":{"type":"blob"},"ReportFormat":{},"GeneratedTime":{"type":"timestamp"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"GetGroupResult","type":"structure","required":["Group","Users"],"members":{"Group":{"shape":"Ss"},"Users":{"shape":"S52"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetGroupPolicyResult","type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}},"output":{"resultWrapper":"GetInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"S10"}}}},"GetLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}},"output":{"resultWrapper":"GetLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1d"}}}},"GetOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}},"output":{"resultWrapper":"GetOpenIDConnectProviderResult","type":"structure","members":{"Url":{},"ClientIDList":{"shape":"S1g"},"ThumbprintList":{"shape":"S1h"},"CreateDate":{"type":"timestamp"},"Tags":{"shape":"Sv"}}}},"GetOrganizationsAccessReport":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{},"SortKey":{}}},"output":{"resultWrapper":"GetOrganizationsAccessReportResult","type":"structure","required":["JobStatus","JobCreationDate"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"NumberOfServicesAccessible":{"type":"integer"},"NumberOfServicesNotAccessed":{"type":"integer"},"AccessDetails":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"ServiceNamespace":{},"Region":{},"EntityPath":{},"LastAuthenticatedTime":{"type":"timestamp"},"TotalAuthenticatedEntities":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"ErrorDetails":{"shape":"S5k"}}}},"GetPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}},"output":{"resultWrapper":"GetPolicyResult","type":"structure","members":{"Policy":{"shape":"S1p"}}}},"GetPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}},"output":{"resultWrapper":"GetPolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1u"}}}},"GetRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"GetRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"S12"}}}},"GetRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetRolePolicyResult","type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}},"output":{"resultWrapper":"GetSAMLProviderResult","type":"structure","members":{"SAMLMetadataDocument":{},"CreateDate":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"},"Tags":{"shape":"Sv"}}}},"GetSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Encoding"],"members":{"UserName":{},"SSHPublicKeyId":{},"Encoding":{}}},"output":{"resultWrapper":"GetSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S5y"}}}},"GetServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}},"output":{"resultWrapper":"GetServerCertificateResult","type":"structure","required":["ServerCertificate"],"members":{"ServerCertificate":{"type":"structure","required":["ServerCertificateMetadata","CertificateBody"],"members":{"ServerCertificateMetadata":{"shape":"S64"},"CertificateBody":{},"CertificateChain":{},"Tags":{"shape":"Sv"}}}}}},"GetServiceLastAccessedDetails":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsResult","type":"structure","required":["JobStatus","JobCreationDate","ServicesLastAccessed","JobCompletionDate"],"members":{"JobStatus":{},"JobType":{},"JobCreationDate":{"type":"timestamp"},"ServicesLastAccessed":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"LastAuthenticated":{"type":"timestamp"},"ServiceNamespace":{},"LastAuthenticatedEntity":{},"LastAuthenticatedRegion":{},"TotalAuthenticatedEntities":{"type":"integer"},"TrackedActionsLastAccessed":{"type":"list","member":{"type":"structure","members":{"ActionName":{},"LastAccessedEntity":{},"LastAccessedTime":{"type":"timestamp"},"LastAccessedRegion":{}}}}}}},"JobCompletionDate":{"type":"timestamp"},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5k"}}}},"GetServiceLastAccessedDetailsWithEntities":{"input":{"type":"structure","required":["JobId","ServiceNamespace"],"members":{"JobId":{},"ServiceNamespace":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsWithEntitiesResult","type":"structure","required":["JobStatus","JobCreationDate","JobCompletionDate","EntityDetailsList"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"EntityDetailsList":{"type":"list","member":{"type":"structure","required":["EntityInfo"],"members":{"EntityInfo":{"type":"structure","required":["Arn","Name","Type","Id"],"members":{"Arn":{},"Name":{},"Type":{},"Id":{},"Path":{}}},"LastAuthenticated":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5k"}}}},"GetServiceLinkedRoleDeletionStatus":{"input":{"type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}},"output":{"resultWrapper":"GetServiceLinkedRoleDeletionStatusResult","type":"structure","required":["Status"],"members":{"Status":{},"Reason":{"type":"structure","members":{"Reason":{},"RoleUsageList":{"type":"list","member":{"type":"structure","members":{"Region":{},"Resources":{"type":"list","member":{}}}}}}}}}},"GetUser":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"GetUserResult","type":"structure","required":["User"],"members":{"User":{"shape":"S2d"}}}},"GetUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetUserPolicyResult","type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"ListAccessKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccessKeysResult","type":"structure","required":["AccessKeyMetadata"],"members":{"AccessKeyMetadata":{"type":"list","member":{"type":"structure","members":{"UserName":{},"AccessKeyId":{},"Status":{},"CreateDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAccountAliases":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccountAliasesResult","type":"structure","required":["AccountAliases"],"members":{"AccountAliases":{"type":"list","member":{}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedGroupPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedRolePoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedUserPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListEntitiesForPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"EntityFilter":{},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListEntitiesForPolicyResult","type":"structure","members":{"PolicyGroups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupId":{}}}},"PolicyUsers":{"type":"list","member":{"type":"structure","members":{"UserName":{},"UserId":{}}}},"PolicyRoles":{"type":"list","member":{"type":"structure","members":{"RoleName":{},"RoleId":{}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroups":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7o"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupsForUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsForUserResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7o"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfileTags":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfileTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4c"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfilesForRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesForRoleResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4c"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListMFADeviceTags":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListMFADeviceTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListMFADevices":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListMFADevicesResult","type":"structure","required":["MFADevices"],"members":{"MFADevices":{"type":"list","member":{"type":"structure","required":["UserName","SerialNumber","EnableDate"],"members":{"UserName":{},"SerialNumber":{},"EnableDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListOpenIDConnectProviderTags":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListOpenIDConnectProviderTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListOpenIDConnectProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListOpenIDConnectProvidersResult","type":"structure","members":{"OpenIDConnectProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}}}}},"ListPolicies":{"input":{"type":"structure","members":{"Scope":{},"OnlyAttached":{"type":"boolean"},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPoliciesResult","type":"structure","members":{"Policies":{"type":"list","member":{"shape":"S1p"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPoliciesGrantingServiceAccess":{"input":{"type":"structure","required":["Arn","ServiceNamespaces"],"members":{"Marker":{},"Arn":{},"ServiceNamespaces":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListPoliciesGrantingServiceAccessResult","type":"structure","required":["PoliciesGrantingServiceAccess"],"members":{"PoliciesGrantingServiceAccess":{"type":"list","member":{"type":"structure","members":{"ServiceNamespace":{},"Policies":{"type":"list","member":{"type":"structure","required":["PolicyName","PolicyType"],"members":{"PolicyName":{},"PolicyType":{},"PolicyArn":{},"EntityType":{},"EntityName":{}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPolicyTags":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPolicyTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPolicyVersions":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPolicyVersionsResult","type":"structure","members":{"Versions":{"shape":"S4f"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolePoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoleTags":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRoleTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolesResult","type":"structure","required":["Roles"],"members":{"Roles":{"shape":"S11"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListSAMLProviderTags":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSAMLProviderTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListSAMLProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListSAMLProvidersResult","type":"structure","members":{"SAMLProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"ValidUntil":{"type":"timestamp"},"CreateDate":{"type":"timestamp"}}}}}}},"ListSSHPublicKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSSHPublicKeysResult","type":"structure","members":{"SSHPublicKeys":{"type":"list","member":{"type":"structure","required":["UserName","SSHPublicKeyId","Status","UploadDate"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{},"UploadDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServerCertificateTags":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListServerCertificateTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServerCertificates":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListServerCertificatesResult","type":"structure","required":["ServerCertificateMetadataList"],"members":{"ServerCertificateMetadataList":{"type":"list","member":{"shape":"S64"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServiceSpecificCredentials":{"input":{"type":"structure","members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"ListServiceSpecificCredentialsResult","type":"structure","members":{"ServiceSpecificCredentials":{"type":"list","member":{"type":"structure","required":["UserName","Status","ServiceUserName","CreateDate","ServiceSpecificCredentialId","ServiceName"],"members":{"UserName":{},"Status":{},"ServiceUserName":{},"CreateDate":{"type":"timestamp"},"ServiceSpecificCredentialId":{},"ServiceName":{}}}}}}},"ListSigningCertificates":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSigningCertificatesResult","type":"structure","required":["Certificates"],"members":{"Certificates":{"type":"list","member":{"shape":"S9i"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserTags":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUsers":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUsersResult","type":"structure","required":["Users"],"members":{"Users":{"shape":"S52"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListVirtualMFADevices":{"input":{"type":"structure","members":{"AssignmentStatus":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListVirtualMFADevicesResult","type":"structure","required":["VirtualMFADevices"],"members":{"VirtualMFADevices":{"type":"list","member":{"shape":"S2h"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"PutGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName","PermissionsBoundary"],"members":{"RoleName":{},"PermissionsBoundary":{}}}},"PutRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName","PermissionsBoundary"],"members":{"UserName":{},"PermissionsBoundary":{}}}},"PutUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"RemoveClientIDFromOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"RemoveRoleFromInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"RemoveUserFromGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"ResetServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}},"output":{"resultWrapper":"ResetServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S27"}}}},"ResyncMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"SetDefaultPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"SetSecurityTokenServicePreferences":{"input":{"type":"structure","required":["GlobalEndpointTokenVersion"],"members":{"GlobalEndpointTokenVersion":{}}}},"SimulateCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList","ActionNames"],"members":{"PolicyInputList":{"shape":"S4s"},"PermissionsBoundaryPolicyInputList":{"shape":"S4s"},"ActionNames":{"shape":"Sa8"},"ResourceArns":{"shape":"Saa"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"Sac"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"Sai","resultWrapper":"SimulateCustomPolicyResult"}},"SimulatePrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn","ActionNames"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4s"},"PermissionsBoundaryPolicyInputList":{"shape":"S4s"},"ActionNames":{"shape":"Sa8"},"ResourceArns":{"shape":"Saa"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"Sac"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"Sai","resultWrapper":"SimulatePrincipalPolicyResult"}},"TagInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","Tags"],"members":{"InstanceProfileName":{},"Tags":{"shape":"Sv"}}}},"TagMFADevice":{"input":{"type":"structure","required":["SerialNumber","Tags"],"members":{"SerialNumber":{},"Tags":{"shape":"Sv"}}}},"TagOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","Tags"],"members":{"OpenIDConnectProviderArn":{},"Tags":{"shape":"Sv"}}}},"TagPolicy":{"input":{"type":"structure","required":["PolicyArn","Tags"],"members":{"PolicyArn":{},"Tags":{"shape":"Sv"}}}},"TagRole":{"input":{"type":"structure","required":["RoleName","Tags"],"members":{"RoleName":{},"Tags":{"shape":"Sv"}}}},"TagSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn","Tags"],"members":{"SAMLProviderArn":{},"Tags":{"shape":"Sv"}}}},"TagServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","Tags"],"members":{"ServerCertificateName":{},"Tags":{"shape":"Sv"}}}},"TagUser":{"input":{"type":"structure","required":["UserName","Tags"],"members":{"UserName":{},"Tags":{"shape":"Sv"}}}},"UntagInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","TagKeys"],"members":{"InstanceProfileName":{},"TagKeys":{"shape":"Sb9"}}}},"UntagMFADevice":{"input":{"type":"structure","required":["SerialNumber","TagKeys"],"members":{"SerialNumber":{},"TagKeys":{"shape":"Sb9"}}}},"UntagOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","TagKeys"],"members":{"OpenIDConnectProviderArn":{},"TagKeys":{"shape":"Sb9"}}}},"UntagPolicy":{"input":{"type":"structure","required":["PolicyArn","TagKeys"],"members":{"PolicyArn":{},"TagKeys":{"shape":"Sb9"}}}},"UntagRole":{"input":{"type":"structure","required":["RoleName","TagKeys"],"members":{"RoleName":{},"TagKeys":{"shape":"Sb9"}}}},"UntagSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn","TagKeys"],"members":{"SAMLProviderArn":{},"TagKeys":{"shape":"Sb9"}}}},"UntagServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","TagKeys"],"members":{"ServerCertificateName":{},"TagKeys":{"shape":"Sb9"}}}},"UntagUser":{"input":{"type":"structure","required":["UserName","TagKeys"],"members":{"UserName":{},"TagKeys":{"shape":"Sb9"}}}},"UpdateAccessKey":{"input":{"type":"structure","required":["AccessKeyId","Status"],"members":{"UserName":{},"AccessKeyId":{},"Status":{}}}},"UpdateAccountPasswordPolicy":{"input":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}},"UpdateAssumeRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyDocument"],"members":{"RoleName":{},"PolicyDocument":{}}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"NewPath":{},"NewGroupName":{}}}},"UpdateLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}}},"UpdateOpenIDConnectProviderThumbprint":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ThumbprintList"],"members":{"OpenIDConnectProviderArn":{},"ThumbprintList":{"shape":"S1h"}}}},"UpdateRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Description":{},"MaxSessionDuration":{"type":"integer"}}},"output":{"resultWrapper":"UpdateRoleResult","type":"structure","members":{}}},"UpdateRoleDescription":{"input":{"type":"structure","required":["RoleName","Description"],"members":{"RoleName":{},"Description":{}}},"output":{"resultWrapper":"UpdateRoleDescriptionResult","type":"structure","members":{"Role":{"shape":"S12"}}}},"UpdateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","SAMLProviderArn"],"members":{"SAMLMetadataDocument":{},"SAMLProviderArn":{}}},"output":{"resultWrapper":"UpdateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{}}}},"UpdateSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{}}}},"UpdateServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{},"NewPath":{},"NewServerCertificateName":{}}}},"UpdateServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId","Status"],"members":{"UserName":{},"ServiceSpecificCredentialId":{},"Status":{}}}},"UpdateSigningCertificate":{"input":{"type":"structure","required":["CertificateId","Status"],"members":{"UserName":{},"CertificateId":{},"Status":{}}}},"UpdateUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"NewPath":{},"NewUserName":{}}}},"UploadSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyBody"],"members":{"UserName":{},"SSHPublicKeyBody":{}}},"output":{"resultWrapper":"UploadSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S5y"}}}},"UploadServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","CertificateBody","PrivateKey"],"members":{"Path":{},"ServerCertificateName":{},"CertificateBody":{},"PrivateKey":{"type":"string","sensitive":true},"CertificateChain":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"UploadServerCertificateResult","type":"structure","members":{"ServerCertificateMetadata":{"shape":"S64"},"Tags":{"shape":"Sv"}}}},"UploadSigningCertificate":{"input":{"type":"structure","required":["CertificateBody"],"members":{"UserName":{},"CertificateBody":{}}},"output":{"resultWrapper":"UploadSigningCertificateResult","type":"structure","required":["Certificate"],"members":{"Certificate":{"shape":"S9i"}}}}},"shapes":{"Sf":{"type":"string","sensitive":true},"Ss":{"type":"structure","required":["Path","GroupName","GroupId","Arn","CreateDate"],"members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"}}},"Sv":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S10":{"type":"structure","required":["Path","InstanceProfileName","InstanceProfileId","Arn","CreateDate","Roles"],"members":{"Path":{},"InstanceProfileName":{},"InstanceProfileId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"Roles":{"shape":"S11"},"Tags":{"shape":"Sv"}}},"S11":{"type":"list","member":{"shape":"S12"}},"S12":{"type":"structure","required":["Path","RoleName","RoleId","Arn","CreateDate"],"members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"},"RoleLastUsed":{"shape":"S18"}}},"S16":{"type":"structure","members":{"PermissionsBoundaryType":{},"PermissionsBoundaryArn":{}}},"S18":{"type":"structure","members":{"LastUsedDate":{"type":"timestamp"},"Region":{}}},"S1d":{"type":"structure","required":["UserName","CreateDate"],"members":{"UserName":{},"CreateDate":{"type":"timestamp"},"PasswordResetRequired":{"type":"boolean"}}},"S1g":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"Tags":{"shape":"Sv"}}},"S1u":{"type":"structure","members":{"Document":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"CreateDate":{"type":"timestamp"}}},"S27":{"type":"structure","required":["CreateDate","ServiceName","ServiceUserName","ServicePassword","ServiceSpecificCredentialId","UserName","Status"],"members":{"CreateDate":{"type":"timestamp"},"ServiceName":{},"ServiceUserName":{},"ServicePassword":{"type":"string","sensitive":true},"ServiceSpecificCredentialId":{},"UserName":{},"Status":{}}},"S2d":{"type":"structure","required":["Path","UserName","UserId","Arn","CreateDate"],"members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"PasswordLastUsed":{"type":"timestamp"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"}}},"S2h":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"Base32StringSeed":{"shape":"S2j"},"QRCodePNG":{"shape":"S2j"},"User":{"shape":"S2d"},"EnableDate":{"type":"timestamp"},"Tags":{"shape":"Sv"}}},"S2j":{"type":"blob","sensitive":true},"S43":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyDocument":{}}}},"S46":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyArn":{}}}},"S4c":{"type":"list","member":{"shape":"S10"}},"S4f":{"type":"list","member":{"shape":"S1u"}},"S4s":{"type":"list","member":{}},"S4t":{"type":"structure","members":{"ContextKeyNames":{"shape":"S4u"}}},"S4u":{"type":"list","member":{}},"S52":{"type":"list","member":{"shape":"S2d"}},"S5k":{"type":"structure","required":["Message","Code"],"members":{"Message":{},"Code":{}}},"S5y":{"type":"structure","required":["UserName","SSHPublicKeyId","Fingerprint","SSHPublicKeyBody","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Fingerprint":{},"SSHPublicKeyBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"S64":{"type":"structure","required":["Path","ServerCertificateName","ServerCertificateId","Arn"],"members":{"Path":{},"ServerCertificateName":{},"ServerCertificateId":{},"Arn":{},"UploadDate":{"type":"timestamp"},"Expiration":{"type":"timestamp"}}},"S7k":{"type":"list","member":{}},"S7o":{"type":"list","member":{"shape":"Ss"}},"S9i":{"type":"structure","required":["UserName","CertificateId","CertificateBody","Status"],"members":{"UserName":{},"CertificateId":{},"CertificateBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"Sa8":{"type":"list","member":{}},"Saa":{"type":"list","member":{}},"Sac":{"type":"list","member":{"type":"structure","members":{"ContextKeyName":{},"ContextKeyValues":{"type":"list","member":{}},"ContextKeyType":{}}}},"Sai":{"type":"structure","members":{"EvaluationResults":{"type":"list","member":{"type":"structure","required":["EvalActionName","EvalDecision"],"members":{"EvalActionName":{},"EvalResourceName":{},"EvalDecision":{},"MatchedStatements":{"shape":"Sam"},"MissingContextValues":{"shape":"S4u"},"OrganizationsDecisionDetail":{"type":"structure","members":{"AllowedByOrganizations":{"type":"boolean"}}},"PermissionsBoundaryDecisionDetail":{"shape":"Sau"},"EvalDecisionDetails":{"shape":"Sav"},"ResourceSpecificResults":{"type":"list","member":{"type":"structure","required":["EvalResourceName","EvalResourceDecision"],"members":{"EvalResourceName":{},"EvalResourceDecision":{},"MatchedStatements":{"shape":"Sam"},"MissingContextValues":{"shape":"S4u"},"EvalDecisionDetails":{"shape":"Sav"},"PermissionsBoundaryDecisionDetail":{"shape":"Sau"}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}},"Sam":{"type":"list","member":{"type":"structure","members":{"SourcePolicyId":{},"SourcePolicyType":{},"StartPosition":{"shape":"Saq"},"EndPosition":{"shape":"Saq"}}}},"Saq":{"type":"structure","members":{"Line":{"type":"integer"},"Column":{"type":"integer"}}},"Sau":{"type":"structure","members":{"AllowedByPermissionsBoundary":{"type":"boolean"}}},"Sav":{"type":"map","key":{},"value":{}},"Sb9":{"type":"list","member":{}}}}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetAccountAuthorizationDetails":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["UserDetailList","GroupDetailList","RoleDetailList","Policies"]},"GetGroup":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListAccessKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccessKeyMetadata"},"ListAccountAliases":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccountAliases"},"ListAttachedGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListEntitiesForPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["PolicyGroups","PolicyUsers","PolicyRoles"]},"ListGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListGroups":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListGroupsForUser":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListInstanceProfiles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListInstanceProfilesForRole":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"MFADevices"},"ListPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Policies"},"ListPolicyVersions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Versions"},"ListRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListRoles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Roles"},"ListSAMLProviders":{"result_key":"SAMLProviderList"},"ListSSHPublicKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"SSHPublicKeys"},"ListServerCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"ServerCertificateMetadataList"},"ListSigningCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Certificates"},"ListUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListUserTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListUsers":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListVirtualMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"VirtualMFADevices"},"SimulateCustomPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"},"SimulatePrincipalPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"}}}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"InstanceProfileExists":{"delay":1,"operation":"GetInstanceProfile","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"state":"retry","matcher":"status","expected":404}]},"UserExists":{"delay":1,"operation":"GetUser","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"RoleExists":{"delay":1,"operation":"GetRole","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"PolicyExists":{"delay":1,"operation":"GetPolicy","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]}}}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['importexport'] = {};
	AWS.ImportExport = Service.defineService('importexport', ['2010-06-01']);
	Object.defineProperty(apiLoader.services['importexport'], '2010-06-01', {
	  get: function get() {
	    var model = __webpack_require__(254);
	    model.paginators = __webpack_require__(255).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ImportExport;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"uid":"importexport-2010-06-01","apiVersion":"2010-06-01","endpointPrefix":"importexport","globalEndpoint":"importexport.amazonaws.com","serviceFullName":"AWS Import/Export","serviceId":"ImportExport","signatureVersion":"v2","xmlNamespace":"http://importexport.amazonaws.com/doc/2010-06-01/","protocol":"query"},"operations":{"CancelJob":{"http":{"requestUri":"/?Operation=CancelJob"},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"APIVersion":{}}},"output":{"resultWrapper":"CancelJobResult","type":"structure","members":{"Success":{"type":"boolean"}}}},"CreateJob":{"http":{"requestUri":"/?Operation=CreateJob"},"input":{"type":"structure","required":["JobType","Manifest","ValidateOnly"],"members":{"JobType":{},"Manifest":{},"ManifestAddendum":{},"ValidateOnly":{"type":"boolean"},"APIVersion":{}}},"output":{"resultWrapper":"CreateJobResult","type":"structure","members":{"JobId":{},"JobType":{},"Signature":{},"SignatureFileContents":{},"WarningMessage":{},"ArtifactList":{"shape":"Sf"}}}},"GetShippingLabel":{"http":{"requestUri":"/?Operation=GetShippingLabel"},"input":{"type":"structure","required":["jobIds"],"members":{"jobIds":{"type":"list","member":{}},"name":{},"company":{},"phoneNumber":{},"country":{},"stateOrProvince":{},"city":{},"postalCode":{},"street1":{},"street2":{},"street3":{},"APIVersion":{}}},"output":{"resultWrapper":"GetShippingLabelResult","type":"structure","members":{"ShippingLabelURL":{},"Warning":{}}}},"GetStatus":{"http":{"requestUri":"/?Operation=GetStatus"},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"APIVersion":{}}},"output":{"resultWrapper":"GetStatusResult","type":"structure","members":{"JobId":{},"JobType":{},"LocationCode":{},"LocationMessage":{},"ProgressCode":{},"ProgressMessage":{},"Carrier":{},"TrackingNumber":{},"LogBucket":{},"LogKey":{},"ErrorCount":{"type":"integer"},"Signature":{},"SignatureFileContents":{},"CurrentManifest":{},"CreationDate":{"type":"timestamp"},"ArtifactList":{"shape":"Sf"}}}},"ListJobs":{"http":{"requestUri":"/?Operation=ListJobs"},"input":{"type":"structure","members":{"MaxJobs":{"type":"integer"},"Marker":{},"APIVersion":{}}},"output":{"resultWrapper":"ListJobsResult","type":"structure","members":{"Jobs":{"type":"list","member":{"type":"structure","members":{"JobId":{},"CreationDate":{"type":"timestamp"},"IsCanceled":{"type":"boolean"},"JobType":{}}}},"IsTruncated":{"type":"boolean"}}}},"UpdateJob":{"http":{"requestUri":"/?Operation=UpdateJob"},"input":{"type":"structure","required":["JobId","Manifest","JobType","ValidateOnly"],"members":{"JobId":{},"Manifest":{},"JobType":{},"ValidateOnly":{"type":"boolean"},"APIVersion":{}}},"output":{"resultWrapper":"UpdateJobResult","type":"structure","members":{"Success":{"type":"boolean"},"WarningMessage":{},"ArtifactList":{"shape":"Sf"}}}}},"shapes":{"Sf":{"type":"list","member":{"type":"structure","members":{"Description":{},"URL":{}}}}},"examples":{}}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListJobs":{"input_token":"Marker","output_token":"Jobs[-1].JobId","more_results":"IsTruncated","limit_key":"MaxJobs","result_key":"Jobs"}}}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['inspector'] = {};
	AWS.Inspector = Service.defineService('inspector', ['2015-08-18*', '2016-02-16']);
	Object.defineProperty(apiLoader.services['inspector'], '2016-02-16', {
	  get: function get() {
	    var model = __webpack_require__(257);
	    model.paginators = __webpack_require__(258).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Inspector;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-16","endpointPrefix":"inspector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Inspector","serviceId":"Inspector","signatureVersion":"v4","targetPrefix":"InspectorService","uid":"inspector-2016-02-16"},"operations":{"AddAttributesToFindings":{"input":{"type":"structure","required":["findingArns","attributes"],"members":{"findingArns":{"shape":"S2"},"attributes":{"shape":"S4"}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"CreateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetName"],"members":{"assessmentTargetName":{},"resourceGroupArn":{}}},"output":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"CreateAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTemplateName","durationInSeconds","rulesPackageArns"],"members":{"assessmentTargetArn":{},"assessmentTemplateName":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"}}},"output":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"CreateExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}},"output":{"type":"structure","required":["previewToken"],"members":{"previewToken":{}}}},"CreateResourceGroup":{"input":{"type":"structure","required":["resourceGroupTags"],"members":{"resourceGroupTags":{"shape":"Sp"}}},"output":{"type":"structure","required":["resourceGroupArn"],"members":{"resourceGroupArn":{}}}},"DeleteAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"DeleteAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"DeleteAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"DescribeAssessmentRuns":{"input":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentRuns","failedItems"],"members":{"assessmentRuns":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTemplateArn","state","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt","stateChangedAt","dataCollected","stateChanges","notifications","findingCounts"],"members":{"arn":{},"name":{},"assessmentTemplateArn":{},"state":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"type":"list","member":{}},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"stateChangedAt":{"type":"timestamp"},"dataCollected":{"type":"boolean"},"stateChanges":{"type":"list","member":{"type":"structure","required":["stateChangedAt","state"],"members":{"stateChangedAt":{"type":"timestamp"},"state":{}}}},"notifications":{"type":"list","member":{"type":"structure","required":["date","event","error"],"members":{"date":{"type":"timestamp"},"event":{},"message":{},"error":{"type":"boolean"},"snsTopicArn":{},"snsPublishStatusCode":{}}}},"findingCounts":{"type":"map","key":{},"value":{"type":"integer"}}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTargets":{"input":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTargets","failedItems"],"members":{"assessmentTargets":{"type":"list","member":{"type":"structure","required":["arn","name","createdAt","updatedAt"],"members":{"arn":{},"name":{},"resourceGroupArn":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTemplates":{"input":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTemplates","failedItems"],"members":{"assessmentTemplates":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTargetArn","durationInSeconds","rulesPackageArns","userAttributesForFindings","assessmentRunCount","createdAt"],"members":{"arn":{},"name":{},"assessmentTargetArn":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"},"lastAssessmentRunArn":{},"assessmentRunCount":{"type":"integer"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeCrossAccountAccessRole":{"output":{"type":"structure","required":["roleArn","valid","registeredAt"],"members":{"roleArn":{},"valid":{"type":"boolean"},"registeredAt":{"type":"timestamp"}}}},"DescribeExclusions":{"input":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"type":"list","member":{}},"locale":{}}},"output":{"type":"structure","required":["exclusions","failedItems"],"members":{"exclusions":{"type":"map","key":{},"value":{"type":"structure","required":["arn","title","description","recommendation","scopes"],"members":{"arn":{},"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"failedItems":{"shape":"S9"}}}},"DescribeFindings":{"input":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["findings","failedItems"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["arn","attributes","userAttributes","createdAt","updatedAt"],"members":{"arn":{},"schemaVersion":{"type":"integer"},"service":{},"serviceAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"assessmentRunArn":{},"rulesPackageArn":{}}},"assetType":{},"assetAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"agentId":{},"autoScalingGroup":{},"amiId":{},"hostname":{},"ipv4Addresses":{"type":"list","member":{}},"tags":{"type":"list","member":{"shape":"S2i"}},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"networkInterfaceId":{},"subnetId":{},"vpcId":{},"privateDnsName":{},"privateIpAddress":{},"privateIpAddresses":{"type":"list","member":{"type":"structure","members":{"privateDnsName":{},"privateIpAddress":{}}}},"publicDnsName":{},"publicIp":{},"ipv6Addresses":{"type":"list","member":{}},"securityGroups":{"type":"list","member":{"type":"structure","members":{"groupName":{},"groupId":{}}}}}}}}},"id":{},"title":{},"description":{},"recommendation":{},"severity":{},"numericSeverity":{"type":"double"},"confidence":{"type":"integer"},"indicatorOfCompromise":{"type":"boolean"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S4"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeResourceGroups":{"input":{"type":"structure","required":["resourceGroupArns"],"members":{"resourceGroupArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["resourceGroups","failedItems"],"members":{"resourceGroups":{"type":"list","member":{"type":"structure","required":["arn","tags","createdAt"],"members":{"arn":{},"tags":{"shape":"Sp"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeRulesPackages":{"input":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["rulesPackages","failedItems"],"members":{"rulesPackages":{"type":"list","member":{"type":"structure","required":["arn","name","version","provider"],"members":{"arn":{},"name":{},"version":{},"provider":{},"description":{}}}},"failedItems":{"shape":"S9"}}}},"GetAssessmentReport":{"input":{"type":"structure","required":["assessmentRunArn","reportFileFormat","reportType"],"members":{"assessmentRunArn":{},"reportFileFormat":{},"reportType":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{},"url":{}}}},"GetExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn","previewToken"],"members":{"assessmentTemplateArn":{},"previewToken":{},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","required":["previewStatus"],"members":{"previewStatus":{},"exclusionPreviews":{"type":"list","member":{"type":"structure","required":["title","description","recommendation","scopes"],"members":{"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"nextToken":{}}}},"GetTelemetryMetadata":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}},"output":{"type":"structure","required":["telemetryMetadata"],"members":{"telemetryMetadata":{"shape":"S3j"}}}},"ListAssessmentRunAgents":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"filter":{"type":"structure","required":["agentHealths","agentHealthCodes"],"members":{"agentHealths":{"type":"list","member":{}},"agentHealthCodes":{"type":"list","member":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunAgents"],"members":{"assessmentRunAgents":{"type":"list","member":{"type":"structure","required":["agentId","assessmentRunArn","agentHealth","agentHealthCode","telemetryMetadata"],"members":{"agentId":{},"assessmentRunArn":{},"agentHealth":{},"agentHealthCode":{},"agentHealthDetails":{},"autoScalingGroup":{},"telemetryMetadata":{"shape":"S3j"}}}},"nextToken":{}}}},"ListAssessmentRuns":{"input":{"type":"structure","members":{"assessmentTemplateArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"states":{"type":"list","member":{}},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"},"startTimeRange":{"shape":"S43"},"completionTimeRange":{"shape":"S43"},"stateChangeTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTargets":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"assessmentTargetNamePattern":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTemplates":{"input":{"type":"structure","members":{"assessmentTargetArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"S45"},"nextToken":{}}}},"ListEventSubscriptions":{"input":{"type":"structure","members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["subscriptions"],"members":{"subscriptions":{"type":"list","member":{"type":"structure","required":["resourceArn","topicArn","eventSubscriptions"],"members":{"resourceArn":{},"topicArn":{},"eventSubscriptions":{"type":"list","member":{"type":"structure","required":["event","subscribedAt"],"members":{"event":{},"subscribedAt":{"type":"timestamp"}}}}}}},"nextToken":{}}}},"ListExclusions":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"shape":"S45"},"nextToken":{}}}},"ListFindings":{"input":{"type":"structure","members":{"assessmentRunArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"agentIds":{"type":"list","member":{}},"autoScalingGroups":{"type":"list","member":{}},"ruleNames":{"type":"list","member":{}},"severities":{"type":"list","member":{}},"rulesPackageArns":{"shape":"S42"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S21"},"creationTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"S45"},"nextToken":{}}}},"ListRulesPackages":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"S45"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S4x"}}}},"PreviewAgents":{"input":{"type":"structure","required":["previewAgentsArn"],"members":{"previewAgentsArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["agentPreviews"],"members":{"agentPreviews":{"type":"list","member":{"type":"structure","required":["agentId"],"members":{"hostname":{},"agentId":{},"autoScalingGroup":{},"agentHealth":{},"agentVersion":{},"operatingSystem":{},"kernelVersion":{},"ipv4Address":{}}}},"nextToken":{}}}},"RegisterCrossAccountAccessRole":{"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{}}}},"RemoveAttributesFromFindings":{"input":{"type":"structure","required":["findingArns","attributeKeys"],"members":{"findingArns":{"shape":"S2"},"attributeKeys":{"type":"list","member":{}}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"SetTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"tags":{"shape":"S4x"}}}},"StartAssessmentRun":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{},"assessmentRunName":{}}},"output":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"StopAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"stopAction":{}}}},"SubscribeToEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UnsubscribeFromEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UpdateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTargetName"],"members":{"assessmentTargetArn":{},"assessmentTargetName":{},"resourceGroupArn":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S9":{"type":"map","key":{},"value":{"type":"structure","required":["failureCode","retryable"],"members":{"failureCode":{},"retryable":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{}},"S1x":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S21":{"type":"list","member":{"shape":"S5"}},"S2i":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["messageType","count"],"members":{"messageType":{},"count":{"type":"long"},"dataSize":{"type":"long"}}}},"S3x":{"type":"list","member":{}},"S41":{"type":"structure","members":{"minSeconds":{"type":"integer"},"maxSeconds":{"type":"integer"}}},"S42":{"type":"list","member":{}},"S43":{"type":"structure","members":{"beginDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}},"S45":{"type":"list","member":{}},"S4x":{"type":"list","member":{"shape":"S2i"}}}}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetExclusionsPreview":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRunAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTargets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventSubscriptions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExclusions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRulesPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"PreviewAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iot'] = {};
	AWS.Iot = Service.defineService('iot', ['2015-05-28']);
	Object.defineProperty(apiLoader.services['iot'], '2015-05-28', {
	  get: function get() {
	    var model = __webpack_require__(260);
	    model.paginators = __webpack_require__(261).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Iot;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"iot","protocol":"rest-json","serviceFullName":"AWS IoT","serviceId":"IoT","signatureVersion":"v4","signingName":"execute-api","uid":"iot-2015-05-28"},"operations":{"AcceptCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/accept-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}}},"AddThingToBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/addThingToBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"AddThingToThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/addThingToThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AssociateTargetsWithJob":{"http":{"requestUri":"/jobs/{jobId}/targets"},"input":{"type":"structure","required":["targets","jobId"],"members":{"targets":{"shape":"Sg"},"jobId":{"location":"uri","locationName":"jobId"},"comment":{},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"AttachPrincipalPolicy":{"http":{"method":"PUT","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"AttachSecurityProfile":{"http":{"method":"PUT","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"AttachThingPrincipal":{"http":{"method":"PUT","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"CancelAuditMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/audit/mitigationactions/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelAuditTask":{"http":{"method":"PUT","requestUri":"/audit/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/cancel-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"CancelDetectMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/detect/mitigationactions/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"reasonCode":{},"comment":{},"force":{"location":"querystring","locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CancelJobExecution":{"http":{"method":"PUT","requestUri":"/things/{thingName}/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"expectedVersion":{"type":"long"},"statusDetails":{"shape":"S1e"}}}},"ClearDefaultAuthorizer":{"http":{"method":"DELETE","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ConfirmTopicRuleDestination":{"http":{"method":"GET","requestUri":"/confirmdestination/{confirmationToken+}"},"input":{"type":"structure","required":["confirmationToken"],"members":{"confirmationToken":{"location":"uri","locationName":"confirmationToken"}}},"output":{"type":"structure","members":{}}},"CreateAuditSuppression":{"http":{"requestUri":"/audit/suppressions/create"},"input":{"type":"structure","required":["checkName","resourceIdentifier","clientRequestToken"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"CreateAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName","authorizerFunctionArn"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S25"},"status":{},"tags":{"shape":"S29"},"signingDisabled":{"type":"boolean"},"enableCachingForHttp":{"type":"boolean"}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"CreateBillingGroup":{"http":{"requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S2i"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"billingGroupId":{}}}},"CreateCertificateFromCsr":{"http":{"requestUri":"/certificates"},"input":{"type":"structure","required":["certificateSigningRequest"],"members":{"certificateSigningRequest":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{}}}},"CreateCustomMetric":{"http":{"requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName","metricType","clientRequestToken"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"displayName":{},"metricType":{},"tags":{"shape":"S29"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{}}}},"CreateDimension":{"http":{"requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name","type","stringValues","clientRequestToken"],"members":{"name":{"location":"uri","locationName":"name"},"type":{},"stringValues":{"shape":"S30"},"tags":{"shape":"S29"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"name":{},"arn":{}}}},"CreateDomainConfiguration":{"http":{"requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"},"domainName":{},"serverCertificateArns":{"type":"list","member":{}},"validationCertificateArn":{},"authorizerConfig":{"shape":"S39"},"serviceType":{},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{}}}},"CreateDynamicThingGroup":{"http":{"requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","queryString"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3f"},"indexName":{},"queryString":{},"queryVersion":{},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{},"indexName":{},"queryString":{},"queryVersion":{}}}},"CreateFleetMetric":{"http":{"method":"PUT","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName","queryString","aggregationType","period","aggregationField"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"queryString":{},"aggregationType":{"shape":"S3t"},"period":{"type":"integer"},"aggregationField":{},"description":{},"queryVersion":{},"indexName":{},"unit":{},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{}}}},"CreateJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","targets"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"targets":{"shape":"Sg"},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S46"},"targetSelection":{},"jobExecutionsRolloutConfig":{"shape":"S49"},"abortConfig":{"shape":"S4g"},"timeoutConfig":{"shape":"S4n"},"tags":{"shape":"S29"},"namespaceId":{},"jobTemplateArn":{},"jobExecutionsRetryConfig":{"shape":"S4q"},"documentParameters":{"shape":"S4v"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CreateJobTemplate":{"http":{"method":"PUT","requestUri":"/job-templates/{jobTemplateId}"},"input":{"type":"structure","required":["jobTemplateId","description"],"members":{"jobTemplateId":{"location":"uri","locationName":"jobTemplateId"},"jobArn":{},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S46"},"jobExecutionsRolloutConfig":{"shape":"S49"},"abortConfig":{"shape":"S4g"},"timeoutConfig":{"shape":"S4n"},"tags":{"shape":"S29"},"jobExecutionsRetryConfig":{"shape":"S4q"}}},"output":{"type":"structure","members":{"jobTemplateArn":{},"jobTemplateId":{}}}},"CreateKeysAndCertificate":{"http":{"requestUri":"/keys-and-certificate"},"input":{"type":"structure","members":{"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{},"keyPair":{"shape":"S54"}}}},"CreateMitigationAction":{"http":{"requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName","roleArn","actionParams"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S59"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"CreateOTAUpdate":{"http":{"requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId","targets","files","roleArn"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"description":{},"targets":{"shape":"S5t"},"protocols":{"shape":"S5v"},"targetSelection":{},"awsJobExecutionsRolloutConfig":{"shape":"S5x"},"awsJobPresignedUrlConfig":{"shape":"S64"},"awsJobAbortConfig":{"type":"structure","required":["abortCriteriaList"],"members":{"abortCriteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"awsJobTimeoutConfig":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"files":{"shape":"S6f"},"roleArn":{},"additionalParameters":{"shape":"S7d"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"otaUpdateId":{},"awsIotJobId":{},"otaUpdateArn":{},"awsIotJobArn":{},"otaUpdateStatus":{}}}},"CreatePolicy":{"http":{"requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"policyVersionId":{}}}},"CreatePolicyVersion":{"http":{"requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"policyArn":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"CreateProvisioningClaim":{"http":{"requestUri":"/provisioning-templates/{templateName}/provisioning-claim"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{"certificateId":{},"certificatePem":{},"keyPair":{"shape":"S54"},"expiration":{"type":"timestamp"}}}},"CreateProvisioningTemplate":{"http":{"requestUri":"/provisioning-templates"},"input":{"type":"structure","required":["templateName","templateBody","provisioningRoleArn"],"members":{"templateName":{},"description":{},"templateBody":{},"enabled":{"type":"boolean"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S7z"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"defaultVersionId":{"type":"integer"}}}},"CreateProvisioningTemplateVersion":{"http":{"requestUri":"/provisioning-templates/{templateName}/versions"},"input":{"type":"structure","required":["templateName","templateBody"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"templateBody":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"versionId":{"type":"integer"},"isDefaultVersion":{"type":"boolean"}}}},"CreateRoleAlias":{"http":{"requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias","roleArn"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"CreateScheduledAudit":{"http":{"requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["frequency","targetCheckNames","scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S8e"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"CreateSecurityProfile":{"http":{"requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S8k"},"alertTargets":{"shape":"S9a"},"additionalMetricsToRetain":{"shape":"S9e","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S9f"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{}}}},"CreateStream":{"http":{"requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId","files","roleArn"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S9l"},"roleArn":{},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"CreateThing":{"http":{"requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S3h"},"billingGroupName":{}}},"output":{"type":"structure","members":{"thingName":{},"thingArn":{},"thingId":{}}}},"CreateThingGroup":{"http":{"requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"parentGroupName":{},"thingGroupProperties":{"shape":"S3f"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{}}}},"CreateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"thingTypeProperties":{"shape":"S9x"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeId":{}}}},"CreateTopicRule":{"http":{"requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"Sa5"},"tags":{"location":"header","locationName":"x-amz-tagging"}},"payload":"topicRulePayload"}},"CreateTopicRuleDestination":{"http":{"requestUri":"/destinations"},"input":{"type":"structure","required":["destinationConfiguration"],"members":{"destinationConfiguration":{"type":"structure","members":{"httpUrlConfiguration":{"type":"structure","required":["confirmationUrl"],"members":{"confirmationUrl":{}}},"vpcConfiguration":{"type":"structure","required":["subnetIds","vpcId","roleArn"],"members":{"subnetIds":{"shape":"Sd6"},"securityGroups":{"shape":"Sd8"},"vpcId":{},"roleArn":{}}}}}}},"output":{"type":"structure","members":{"topicRuleDestination":{"shape":"Sdc"}}}},"DeleteAccountAuditConfiguration":{"http":{"method":"DELETE","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"deleteScheduledAudits":{"location":"querystring","locationName":"deleteScheduledAudits","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteAuditSuppression":{"http":{"requestUri":"/audit/suppressions/delete"},"input":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"}}},"output":{"type":"structure","members":{}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{}}},"DeleteBillingGroup":{"http":{"method":"DELETE","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteCACertificate":{"http":{"method":"DELETE","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{}}},"DeleteCertificate":{"http":{"method":"DELETE","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"forceDelete":{"location":"querystring","locationName":"forceDelete","type":"boolean"}}}},"DeleteCustomMetric":{"http":{"method":"DELETE","requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"}}},"output":{"type":"structure","members":{}}},"DeleteDimension":{"http":{"method":"DELETE","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"DeleteDomainConfiguration":{"http":{"method":"DELETE","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"}}},"output":{"type":"structure","members":{}}},"DeleteDynamicThingGroup":{"http":{"method":"DELETE","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteFleetMetric":{"http":{"method":"DELETE","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}}},"DeleteJobExecution":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}"},"input":{"type":"structure","required":["jobId","thingName","executionNumber"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"uri","locationName":"executionNumber","type":"long"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}}},"DeleteJobTemplate":{"http":{"method":"DELETE","requestUri":"/job-templates/{jobTemplateId}"},"input":{"type":"structure","required":["jobTemplateId"],"members":{"jobTemplateId":{"location":"uri","locationName":"jobTemplateId"}}}},"DeleteMitigationAction":{"http":{"method":"DELETE","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{}}},"DeleteOTAUpdate":{"http":{"method":"DELETE","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"deleteStream":{"location":"querystring","locationName":"deleteStream","type":"boolean"},"forceDeleteAWSJob":{"location":"querystring","locationName":"forceDeleteAWSJob","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}}},"DeletePolicyVersion":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"DeleteProvisioningTemplate":{"http":{"method":"DELETE","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningTemplateVersion":{"http":{"method":"DELETE","requestUri":"/provisioning-templates/{templateName}/versions/{versionId}"},"input":{"type":"structure","required":["templateName","versionId"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"versionId":{"location":"uri","locationName":"versionId","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteRegistrationCode":{"http":{"method":"DELETE","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteRoleAlias":{"http":{"method":"DELETE","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAudit":{"http":{"method":"DELETE","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{}}},"DeleteSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"method":"DELETE","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{}}},"DeleteThing":{"http":{"method":"DELETE","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingGroup":{"http":{"method":"DELETE","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingType":{"http":{"method":"DELETE","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{}}},"DeleteTopicRule":{"http":{"method":"DELETE","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"DeleteTopicRuleDestination":{"http":{"method":"DELETE","requestUri":"/destinations/{arn+}"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{}}},"DeleteV2LoggingLevel":{"http":{"method":"DELETE","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["targetType","targetName"],"members":{"targetType":{"location":"querystring","locationName":"targetType"},"targetName":{"location":"querystring","locationName":"targetName"}}}},"DeprecateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}/deprecate"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"undoDeprecate":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeAccountAuditConfiguration":{"http":{"method":"GET","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sfc"},"auditCheckConfigurations":{"shape":"Sff"}}}},"DescribeAuditFinding":{"http":{"method":"GET","requestUri":"/audit/findings/{findingId}"},"input":{"type":"structure","required":["findingId"],"members":{"findingId":{"location":"uri","locationName":"findingId"}}},"output":{"type":"structure","members":{"finding":{"shape":"Sfk"}}}},"DescribeAuditMitigationActionsTask":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"taskStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"totalFindingsCount":{"type":"long"},"failedFindingsCount":{"type":"long"},"succeededFindingsCount":{"type":"long"},"skippedFindingsCount":{"type":"long"},"canceledFindingsCount":{"type":"long"}}}},"target":{"shape":"Sg4"},"auditCheckToActionsMapping":{"shape":"Sg8"},"actionsDefinition":{"shape":"Sga"}}}},"DescribeAuditSuppression":{"http":{"requestUri":"/audit/suppressions/describe"},"input":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"}}},"output":{"type":"structure","members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{}}}},"DescribeAuditTask":{"http":{"method":"GET","requestUri":"/audit/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"taskType":{},"taskStartTime":{"type":"timestamp"},"taskStatistics":{"type":"structure","members":{"totalChecks":{"type":"integer"},"inProgressChecks":{"type":"integer"},"waitingForDataCollectionChecks":{"type":"integer"},"compliantChecks":{"type":"integer"},"nonCompliantChecks":{"type":"integer"},"failedChecks":{"type":"integer"},"canceledChecks":{"type":"integer"}}},"scheduledAuditName":{},"auditDetails":{"type":"map","key":{},"value":{"type":"structure","members":{"checkRunStatus":{},"checkCompliant":{"type":"boolean"},"totalResourcesCount":{"type":"long"},"nonCompliantResourcesCount":{"type":"long"},"suppressedNonCompliantResourcesCount":{"type":"long"},"errorCode":{},"message":{}}}}}}},"DescribeAuthorizer":{"http":{"method":"GET","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Sh1"}}}},"DescribeBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupId":{},"billingGroupArn":{},"version":{"type":"long"},"billingGroupProperties":{"shape":"S2i"},"billingGroupMetadata":{"type":"structure","members":{"creationDate":{"type":"timestamp"}}}}}},"DescribeCACertificate":{"http":{"method":"GET","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"creationDate":{"type":"timestamp"},"autoRegistrationStatus":{},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"generationId":{},"validity":{"shape":"She"}}},"registrationConfig":{"shape":"Shf"}}}},"DescribeCertificate":{"http":{"method":"GET","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"caCertificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"previousOwnedBy":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"transferData":{"type":"structure","members":{"transferMessage":{},"rejectReason":{},"transferDate":{"type":"timestamp"},"acceptDate":{"type":"timestamp"},"rejectDate":{"type":"timestamp"}}},"generationId":{},"validity":{"shape":"She"},"certificateMode":{}}}}}},"DescribeCustomMetric":{"http":{"method":"GET","requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{},"metricType":{},"displayName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeDefaultAuthorizer":{"http":{"method":"GET","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Sh1"}}}},"DescribeDetectMitigationActionsTask":{"http":{"method":"GET","requestUri":"/detect/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskSummary":{"shape":"Sht"}}}},"DescribeDimension":{"http":{"method":"GET","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"name":{},"arn":{},"type":{},"stringValues":{"shape":"S30"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeDomainConfiguration":{"http":{"method":"GET","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{},"domainName":{},"serverCertificates":{"type":"list","member":{"type":"structure","members":{"serverCertificateArn":{},"serverCertificateStatus":{},"serverCertificateStatusDetail":{}}}},"authorizerConfig":{"shape":"S39"},"domainConfigurationStatus":{},"serviceType":{},"domainType":{},"lastStatusChangeDate":{"type":"timestamp"}}}},"DescribeEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{"endpointType":{"location":"querystring","locationName":"endpointType"}}},"output":{"type":"structure","members":{"endpointAddress":{}}}},"DescribeEventConfigurations":{"http":{"method":"GET","requestUri":"/event-configurations"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"eventConfigurations":{"shape":"Sij"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeFleetMetric":{"http":{"method":"GET","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"}}},"output":{"type":"structure","members":{"metricName":{},"queryString":{},"aggregationType":{"shape":"S3t"},"period":{"type":"integer"},"aggregationField":{},"description":{},"queryVersion":{},"indexName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"unit":{},"version":{"type":"long"},"metricArn":{}}}},"DescribeIndex":{"http":{"method":"GET","requestUri":"/indices/{indexName}"},"input":{"type":"structure","required":["indexName"],"members":{"indexName":{"location":"uri","locationName":"indexName"}}},"output":{"type":"structure","members":{"indexName":{},"indexStatus":{},"schema":{}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"documentSource":{},"job":{"type":"structure","members":{"jobArn":{},"jobId":{},"targetSelection":{},"status":{},"forceCanceled":{"type":"boolean"},"reasonCode":{},"comment":{},"targets":{"shape":"Sg"},"description":{},"presignedUrlConfig":{"shape":"S46"},"jobExecutionsRolloutConfig":{"shape":"S49"},"abortConfig":{"shape":"S4g"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"jobProcessDetails":{"type":"structure","members":{"processingTargets":{"type":"list","member":{}},"numberOfCanceledThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"},"numberOfFailedThings":{"type":"integer"},"numberOfRejectedThings":{"type":"integer"},"numberOfQueuedThings":{"type":"integer"},"numberOfInProgressThings":{"type":"integer"},"numberOfRemovedThings":{"type":"integer"},"numberOfTimedOutThings":{"type":"integer"}}},"timeoutConfig":{"shape":"S4n"},"namespaceId":{},"jobTemplateArn":{},"jobExecutionsRetryConfig":{"shape":"S4q"},"documentParameters":{"shape":"S4v"}}}}}},"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"type":"structure","members":{"jobId":{},"status":{},"forceCanceled":{"type":"boolean"},"statusDetails":{"type":"structure","members":{"detailsMap":{"shape":"S1e"}}},"thingArn":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"},"versionNumber":{"type":"long"},"approximateSecondsBeforeTimedOut":{"type":"long"}}}}}},"DescribeJobTemplate":{"http":{"method":"GET","requestUri":"/job-templates/{jobTemplateId}"},"input":{"type":"structure","required":["jobTemplateId"],"members":{"jobTemplateId":{"location":"uri","locationName":"jobTemplateId"}}},"output":{"type":"structure","members":{"jobTemplateArn":{},"jobTemplateId":{},"description":{},"documentSource":{},"document":{},"createdAt":{"type":"timestamp"},"presignedUrlConfig":{"shape":"S46"},"jobExecutionsRolloutConfig":{"shape":"S49"},"abortConfig":{"shape":"S4g"},"timeoutConfig":{"shape":"S4n"},"jobExecutionsRetryConfig":{"shape":"S4q"}}}},"DescribeManagedJobTemplate":{"http":{"method":"GET","requestUri":"/managed-job-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"templateVersion":{"location":"querystring","locationName":"templateVersion"}}},"output":{"type":"structure","members":{"templateName":{},"templateArn":{},"description":{},"templateVersion":{},"environments":{"shape":"Sjm"},"documentParameters":{"type":"list","member":{"type":"structure","members":{"key":{},"description":{},"regex":{},"example":{},"optional":{"type":"boolean"}}}},"document":{}}}},"DescribeMitigationAction":{"http":{"method":"GET","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{"actionName":{},"actionType":{},"actionArn":{},"actionId":{},"roleArn":{},"actionParams":{"shape":"S59"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeProvisioningTemplate":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"defaultVersionId":{"type":"integer"},"templateBody":{},"enabled":{"type":"boolean"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S7z"}}}},"DescribeProvisioningTemplateVersion":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}/versions/{versionId}"},"input":{"type":"structure","required":["templateName","versionId"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"versionId":{"location":"uri","locationName":"versionId","type":"integer"}}},"output":{"type":"structure","members":{"versionId":{"type":"integer"},"creationDate":{"type":"timestamp"},"templateBody":{},"isDefaultVersion":{"type":"boolean"}}}},"DescribeRoleAlias":{"http":{"method":"GET","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{"roleAliasDescription":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{},"roleArn":{},"owner":{},"credentialDurationSeconds":{"type":"integer"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}}}},"DescribeScheduledAudit":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S8e"},"scheduledAuditName":{},"scheduledAuditArn":{}}}},"DescribeSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S8k"},"alertTargets":{"shape":"S9a"},"additionalMetricsToRetain":{"shape":"S9e","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S9f"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeStream":{"http":{"method":"GET","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"streamInfo":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{},"files":{"shape":"S9l"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"roleArn":{}}}}}},"DescribeThing":{"http":{"method":"GET","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"defaultClientId":{},"thingName":{},"thingId":{},"thingArn":{},"thingTypeName":{},"attributes":{"shape":"S3i"},"version":{"type":"long"},"billingGroupName":{}}}},"DescribeThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupArn":{},"version":{"type":"long"},"thingGroupProperties":{"shape":"S3f"},"thingGroupMetadata":{"type":"structure","members":{"parentGroupName":{},"rootToParentThingGroups":{"shape":"Skf"},"creationDate":{"type":"timestamp"}}},"indexName":{},"queryString":{},"queryVersion":{},"status":{}}}},"DescribeThingRegistrationTask":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{},"status":{},"message":{},"successCount":{"type":"integer"},"failureCount":{"type":"integer"},"percentageProgress":{"type":"integer"}}}},"DescribeThingType":{"http":{"method":"GET","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeId":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S9x"},"thingTypeMetadata":{"shape":"Sks"}}}},"DetachPolicy":{"http":{"requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"DetachPrincipalPolicy":{"http":{"method":"DELETE","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"DetachSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"DetachThingPrincipal":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"DisableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/disable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"EnableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/enable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"GetBehaviorModelTrainingSummaries":{"http":{"method":"GET","requestUri":"/behavior-model-training/summaries"},"input":{"type":"structure","members":{"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"summaries":{"type":"list","member":{"type":"structure","members":{"securityProfileName":{},"behaviorName":{},"trainingDataCollectionStartDate":{"type":"timestamp"},"modelStatus":{},"datapointsCollectionPercentage":{"type":"double"},"lastModelRefreshDate":{"type":"timestamp"}}}},"nextToken":{}}}},"GetBucketsAggregation":{"http":{"requestUri":"/indices/buckets"},"input":{"type":"structure","required":["queryString","aggregationField","bucketsAggregationType"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{},"bucketsAggregationType":{"type":"structure","members":{"termsAggregation":{"type":"structure","members":{"maxBuckets":{"type":"integer"}}}}}}},"output":{"type":"structure","members":{"totalCount":{"type":"integer"},"buckets":{"type":"list","member":{"type":"structure","members":{"keyValue":{},"count":{"type":"integer"}}}}}}},"GetCardinality":{"http":{"requestUri":"/indices/cardinality"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"cardinality":{"type":"integer"}}}},"GetEffectivePolicies":{"http":{"requestUri":"/effective-policies"},"input":{"type":"structure","members":{"principal":{},"cognitoIdentityPoolId":{},"thingName":{"location":"querystring","locationName":"thingName"}}},"output":{"type":"structure","members":{"effectivePolicies":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{}}}}}}},"GetIndexingConfiguration":{"http":{"method":"GET","requestUri":"/indexing/config"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Slr"},"thingGroupIndexingConfiguration":{"shape":"Sm0"}}}},"GetJobDocument":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/job-document"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"document":{}}}},"GetLoggingOptions":{"http":{"method":"GET","requestUri":"/loggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"logLevel":{}}}},"GetOTAUpdate":{"http":{"method":"GET","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"}}},"output":{"type":"structure","members":{"otaUpdateInfo":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"description":{},"targets":{"shape":"S5t"},"protocols":{"shape":"S5v"},"awsJobExecutionsRolloutConfig":{"shape":"S5x"},"awsJobPresignedUrlConfig":{"shape":"S64"},"targetSelection":{},"otaUpdateFiles":{"shape":"S6f"},"otaUpdateStatus":{},"awsIotJobId":{},"awsIotJobArn":{},"errorInfo":{"type":"structure","members":{"code":{},"message":{}}},"additionalParameters":{"shape":"S7d"}}}}}},"GetPercentiles":{"http":{"requestUri":"/indices/percentiles"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{},"percents":{"type":"list","member":{"type":"double"}}}},"output":{"type":"structure","members":{"percentiles":{"type":"list","member":{"type":"structure","members":{"percent":{"type":"double"},"value":{"type":"double"}}}}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"defaultVersionId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetPolicyVersion":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}},"output":{"type":"structure","members":{"policyArn":{},"policyName":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetRegistrationCode":{"http":{"method":"GET","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registrationCode":{}}}},"GetStatistics":{"http":{"requestUri":"/indices/statistics"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"statistics":{"type":"structure","members":{"count":{"type":"integer"},"average":{"type":"double"},"sum":{"type":"double"},"minimum":{"type":"double"},"maximum":{"type":"double"},"sumOfSquares":{"type":"double"},"variance":{"type":"double"},"stdDeviation":{"type":"double"}}}}}},"GetTopicRule":{"http":{"method":"GET","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","members":{"ruleArn":{},"rule":{"type":"structure","members":{"ruleName":{},"sql":{},"description":{},"createdAt":{"type":"timestamp"},"actions":{"shape":"Sa8"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"Sa9"}}}}}},"GetTopicRuleDestination":{"http":{"method":"GET","requestUri":"/destinations/{arn+}"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{"topicRuleDestination":{"shape":"Sdc"}}}},"GetV2LoggingOptions":{"http":{"method":"GET","requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"ListActiveViolations":{"http":{"method":"GET","requestUri":"/active-violations"},"input":{"type":"structure","members":{"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"behaviorCriteriaType":{"location":"querystring","locationName":"behaviorCriteriaType"},"listSuppressedAlerts":{"location":"querystring","locationName":"listSuppressedAlerts","type":"boolean"},"verificationState":{"location":"querystring","locationName":"verificationState"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"activeViolations":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S8l"},"lastViolationValue":{"shape":"S8s"},"violationEventAdditionalInfo":{"shape":"Sni"},"verificationState":{},"verificationStateDescription":{},"lastViolationTime":{"type":"timestamp"},"violationStartTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAttachedPolicies":{"http":{"requestUri":"/attached-policies/{target}"},"input":{"type":"structure","required":["target"],"members":{"target":{"location":"uri","locationName":"target"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"policies":{"shape":"Snp"},"nextMarker":{}}}},"ListAuditFindings":{"http":{"requestUri":"/audit/findings"},"input":{"type":"structure","members":{"taskId":{},"checkName":{},"resourceIdentifier":{"shape":"S1o"},"maxResults":{"type":"integer"},"nextToken":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"listSuppressedFindings":{"type":"boolean"}}},"output":{"type":"structure","members":{"findings":{"type":"list","member":{"shape":"Sfk"}},"nextToken":{}}}},"ListAuditMitigationActionsExecutions":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/executions"},"input":{"type":"structure","required":["taskId","findingId"],"members":{"taskId":{"location":"querystring","locationName":"taskId"},"actionStatus":{"location":"querystring","locationName":"actionStatus"},"findingId":{"location":"querystring","locationName":"findingId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionsExecutions":{"type":"list","member":{"type":"structure","members":{"taskId":{},"findingId":{},"actionName":{},"actionId":{},"status":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"errorCode":{},"message":{}}}},"nextToken":{}}}},"ListAuditMitigationActionsTasks":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"auditTaskId":{"location":"querystring","locationName":"auditTaskId"},"findingId":{"location":"querystring","locationName":"findingId"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"startTime":{"type":"timestamp"},"taskStatus":{}}}},"nextToken":{}}}},"ListAuditSuppressions":{"http":{"requestUri":"/audit/suppressions/list"},"input":{"type":"structure","members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"ascendingOrder":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"suppressions":{"type":"list","member":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{}}}},"nextToken":{}}}},"ListAuditTasks":{"http":{"method":"GET","requestUri":"/audit/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"taskType":{"location":"querystring","locationName":"taskType"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskStatus":{},"taskType":{}}}},"nextToken":{}}}},"ListAuthorizers":{"http":{"method":"GET","requestUri":"/authorizers/"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"authorizers":{"type":"list","member":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"nextMarker":{}}}},"ListBillingGroups":{"http":{"method":"GET","requestUri":"/billing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"}}},"output":{"type":"structure","members":{"billingGroups":{"type":"list","member":{"shape":"Skg"}},"nextToken":{}}}},"ListCACertificates":{"http":{"method":"GET","requestUri":"/cacertificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListCertificates":{"http":{"method":"GET","requestUri":"/certificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sor"},"nextMarker":{}}}},"ListCertificatesByCA":{"http":{"method":"GET","requestUri":"/certificates-by-ca/{caCertificateId}"},"input":{"type":"structure","required":["caCertificateId"],"members":{"caCertificateId":{"location":"uri","locationName":"caCertificateId"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sor"},"nextMarker":{}}}},"ListCustomMetrics":{"http":{"method":"GET","requestUri":"/custom-metrics"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"metricNames":{"type":"list","member":{}},"nextToken":{}}}},"ListDetectMitigationActionsExecutions":{"http":{"method":"GET","requestUri":"/detect/mitigationactions/executions"},"input":{"type":"structure","members":{"taskId":{"location":"querystring","locationName":"taskId"},"violationId":{"location":"querystring","locationName":"violationId"},"thingName":{"location":"querystring","locationName":"thingName"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionsExecutions":{"type":"list","member":{"type":"structure","members":{"taskId":{},"violationId":{},"actionName":{},"thingName":{},"executionStartDate":{"type":"timestamp"},"executionEndDate":{"type":"timestamp"},"status":{},"errorCode":{},"message":{}}}},"nextToken":{}}}},"ListDetectMitigationActionsTasks":{"http":{"method":"GET","requestUri":"/detect/mitigationactions/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"shape":"Sht"}},"nextToken":{}}}},"ListDimensions":{"http":{"method":"GET","requestUri":"/dimensions"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"dimensionNames":{"type":"list","member":{}},"nextToken":{}}}},"ListDomainConfigurations":{"http":{"method":"GET","requestUri":"/domainConfigurations"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"serviceType":{"location":"querystring","locationName":"serviceType"}}},"output":{"type":"structure","members":{"domainConfigurations":{"type":"list","member":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{},"serviceType":{}}}},"nextMarker":{}}}},"ListFleetMetrics":{"http":{"method":"GET","requestUri":"/fleet-metrics"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"fleetMetrics":{"type":"list","member":{"type":"structure","members":{"metricName":{},"metricArn":{}}}},"nextToken":{}}}},"ListIndices":{"http":{"method":"GET","requestUri":"/indices"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"indexNames":{"type":"list","member":{}},"nextToken":{}}}},"ListJobExecutionsForJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/things"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"jobExecutionSummary":{"shape":"Spr"}}}},"nextToken":{}}}},"ListJobExecutionsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"status":{"location":"querystring","locationName":"status"},"namespaceId":{"location":"querystring","locationName":"namespaceId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"jobId":{"location":"querystring","locationName":"jobId"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"jobId":{},"jobExecutionSummary":{"shape":"Spr"}}}},"nextToken":{}}}},"ListJobTemplates":{"http":{"method":"GET","requestUri":"/job-templates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"jobTemplates":{"type":"list","member":{"type":"structure","members":{"jobTemplateArn":{},"jobTemplateId":{},"description":{},"createdAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"targetSelection":{"location":"querystring","locationName":"targetSelection"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"thingGroupName":{"location":"querystring","locationName":"thingGroupName"},"thingGroupId":{"location":"querystring","locationName":"thingGroupId"},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobArn":{},"jobId":{},"thingGroupId":{},"targetSelection":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListManagedJobTemplates":{"http":{"method":"GET","requestUri":"/managed-job-templates"},"input":{"type":"structure","members":{"templateName":{"location":"querystring","locationName":"templateName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"managedJobTemplates":{"type":"list","member":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"environments":{"shape":"Sjm"},"templateVersion":{}}}},"nextToken":{}}}},"ListMetricValues":{"http":{"method":"GET","requestUri":"/metric-values"},"input":{"type":"structure","required":["thingName","metricName","startTime","endTime"],"members":{"thingName":{"location":"querystring","locationName":"thingName"},"metricName":{"location":"querystring","locationName":"metricName"},"dimensionName":{"location":"querystring","locationName":"dimensionName"},"dimensionValueOperator":{"location":"querystring","locationName":"dimensionValueOperator"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"metricDatumList":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"timestamp"},"value":{"shape":"S8s"}}}},"nextToken":{}}}},"ListMitigationActions":{"http":{"method":"GET","requestUri":"/mitigationactions/actions"},"input":{"type":"structure","members":{"actionType":{"location":"querystring","locationName":"actionType"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionIdentifiers":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOTAUpdates":{"http":{"method":"GET","requestUri":"/otaUpdates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"otaUpdateStatus":{"location":"querystring","locationName":"otaUpdateStatus"}}},"output":{"type":"structure","members":{"otaUpdates":{"type":"list","member":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOutgoingCertificates":{"http":{"method":"GET","requestUri":"/certificates-out-going"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"outgoingCertificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"transferredTo":{},"transferDate":{"type":"timestamp"},"transferMessage":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListPolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Snp"},"nextMarker":{}}}},"ListPolicyPrincipals":{"http":{"method":"GET","requestUri":"/policy-principals"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"header","locationName":"x-amzn-iot-policy"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"principals":{"shape":"Sqt"},"nextMarker":{}}},"deprecated":true},"ListPolicyVersions":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyVersions":{"type":"list","member":{"type":"structure","members":{"versionId":{},"isDefaultVersion":{"type":"boolean"},"createDate":{"type":"timestamp"}}}}}}},"ListPrincipalPolicies":{"http":{"method":"GET","requestUri":"/principal-policies"},"input":{"type":"structure","required":["principal"],"members":{"principal":{"location":"header","locationName":"x-amzn-iot-principal"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Snp"},"nextMarker":{}}},"deprecated":true},"ListPrincipalThings":{"http":{"method":"GET","requestUri":"/principals/things"},"input":{"type":"structure","required":["principal"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{"things":{"shape":"Sr3"},"nextToken":{}}}},"ListProvisioningTemplateVersions":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}/versions"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"versions":{"type":"list","member":{"type":"structure","members":{"versionId":{"type":"integer"},"creationDate":{"type":"timestamp"},"isDefaultVersion":{"type":"boolean"}}}},"nextToken":{}}}},"ListProvisioningTemplates":{"http":{"method":"GET","requestUri":"/provisioning-templates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"templates":{"type":"list","member":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"enabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListRoleAliases":{"http":{"method":"GET","requestUri":"/role-aliases"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"roleAliases":{"type":"list","member":{}},"nextMarker":{}}}},"ListScheduledAudits":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"scheduledAudits":{"type":"list","member":{"type":"structure","members":{"scheduledAuditName":{},"scheduledAuditArn":{},"frequency":{},"dayOfMonth":{},"dayOfWeek":{}}}},"nextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"dimensionName":{"location":"querystring","locationName":"dimensionName"},"metricName":{"location":"querystring","locationName":"metricName"}}},"output":{"type":"structure","members":{"securityProfileIdentifiers":{"type":"list","member":{"shape":"Srm"}},"nextToken":{}}}},"ListSecurityProfilesForTarget":{"http":{"method":"GET","requestUri":"/security-profiles-for-target"},"input":{"type":"structure","required":["securityProfileTargetArn"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{"securityProfileTargetMappings":{"type":"list","member":{"type":"structure","members":{"securityProfileIdentifier":{"shape":"Srm"},"target":{"shape":"Srr"}}}},"nextToken":{}}}},"ListStreams":{"http":{"method":"GET","requestUri":"/streams"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"streams":{"type":"list","member":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"tags":{"shape":"S29"},"nextToken":{}}}},"ListTargetsForPolicy":{"http":{"requestUri":"/policy-targets/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"targets":{"type":"list","member":{}},"nextMarker":{}}}},"ListTargetsForSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"securityProfileTargets":{"type":"list","member":{"shape":"Srr"}},"nextToken":{}}}},"ListThingGroups":{"http":{"method":"GET","requestUri":"/thing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"parentGroup":{"location":"querystring","locationName":"parentGroup"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Skf"},"nextToken":{}}}},"ListThingGroupsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/thing-groups"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Skf"},"nextToken":{}}}},"ListThingPrincipals":{"http":{"method":"GET","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"principals":{"shape":"Sqt"},"nextToken":{}}}},"ListThingRegistrationTaskReports":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}/reports"},"input":{"type":"structure","required":["taskId","reportType"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"reportType":{"location":"querystring","locationName":"reportType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resourceLinks":{"type":"list","member":{}},"reportType":{},"nextToken":{}}}},"ListThingRegistrationTasks":{"http":{"method":"GET","requestUri":"/thing-registration-tasks"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"taskIds":{"type":"list","member":{}},"nextToken":{}}}},"ListThingTypes":{"http":{"method":"GET","requestUri":"/thing-types"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypes":{"type":"list","member":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S9x"},"thingTypeMetadata":{"shape":"Sks"}}}},"nextToken":{}}}},"ListThings":{"http":{"method":"GET","requestUri":"/things"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"attributeName":{"location":"querystring","locationName":"attributeName"},"attributeValue":{"location":"querystring","locationName":"attributeValue"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"},"usePrefixAttributeValue":{"location":"querystring","locationName":"usePrefixAttributeValue","type":"boolean"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingTypeName":{},"thingArn":{},"attributes":{"shape":"S3i"},"version":{"type":"long"}}}},"nextToken":{}}}},"ListThingsInBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}/things"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Sr3"},"nextToken":{}}}},"ListThingsInThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}/things"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Sr3"},"nextToken":{}}}},"ListTopicRuleDestinations":{"http":{"method":"GET","requestUri":"/destinations"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"destinationSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"statusReason":{},"httpUrlSummary":{"type":"structure","members":{"confirmationUrl":{}}},"vpcDestinationSummary":{"type":"structure","members":{"subnetIds":{"shape":"Sd6"},"securityGroups":{"shape":"Sd8"},"vpcId":{},"roleArn":{}}}}}},"nextToken":{}}}},"ListTopicRules":{"http":{"method":"GET","requestUri":"/rules"},"input":{"type":"structure","members":{"topic":{"location":"querystring","locationName":"topic"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ruleDisabled":{"location":"querystring","locationName":"ruleDisabled","type":"boolean"}}},"output":{"type":"structure","members":{"rules":{"type":"list","member":{"type":"structure","members":{"ruleArn":{},"ruleName":{},"topicPattern":{},"createdAt":{"type":"timestamp"},"ruleDisabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListV2LoggingLevels":{"http":{"method":"GET","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","members":{"targetType":{"location":"querystring","locationName":"targetType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"logTargetConfigurations":{"type":"list","member":{"type":"structure","members":{"logTarget":{"shape":"Stf"},"logLevel":{}}}},"nextToken":{}}}},"ListViolationEvents":{"http":{"method":"GET","requestUri":"/violation-events"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"behaviorCriteriaType":{"location":"querystring","locationName":"behaviorCriteriaType"},"listSuppressedAlerts":{"location":"querystring","locationName":"listSuppressedAlerts","type":"boolean"},"verificationState":{"location":"querystring","locationName":"verificationState"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"violationEvents":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S8l"},"metricValue":{"shape":"S8s"},"violationEventAdditionalInfo":{"shape":"Sni"},"violationEventType":{},"verificationState":{},"verificationStateDescription":{},"violationEventTime":{"type":"timestamp"}}}},"nextToken":{}}}},"PutVerificationStateOnViolation":{"http":{"requestUri":"/violations/verification-state/{violationId}"},"input":{"type":"structure","required":["violationId","verificationState"],"members":{"violationId":{"location":"uri","locationName":"violationId"},"verificationState":{},"verificationStateDescription":{}}},"output":{"type":"structure","members":{}}},"RegisterCACertificate":{"http":{"requestUri":"/cacertificate"},"input":{"type":"structure","required":["caCertificate","verificationCertificate"],"members":{"caCertificate":{},"verificationCertificate":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"},"allowAutoRegistration":{"location":"querystring","locationName":"allowAutoRegistration","type":"boolean"},"registrationConfig":{"shape":"Shf"},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificate":{"http":{"requestUri":"/certificate/register"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"caCertificatePem":{},"setAsActive":{"deprecated":true,"location":"querystring","locationName":"setAsActive","type":"boolean"},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificateWithoutCA":{"http":{"requestUri":"/certificate/register-no-ca"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterThing":{"http":{"requestUri":"/things"},"input":{"type":"structure","required":["templateBody"],"members":{"templateBody":{},"parameters":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"certificatePem":{},"resourceArns":{"type":"map","key":{},"value":{}}}}},"RejectCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/reject-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"rejectReason":{}}}},"RemoveThingFromBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/removeThingFromBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"RemoveThingFromThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/removeThingFromThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"ReplaceTopicRule":{"http":{"method":"PATCH","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"Sa5"}},"payload":"topicRulePayload"}},"SearchIndex":{"http":{"requestUri":"/indices/search"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"nextToken":{},"maxResults":{"type":"integer"},"queryVersion":{}}},"output":{"type":"structure","members":{"nextToken":{},"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingId":{},"thingTypeName":{},"thingGroupNames":{"shape":"Sub"},"attributes":{"shape":"S3i"},"shadow":{},"deviceDefender":{},"connectivity":{"type":"structure","members":{"connected":{"type":"boolean"},"timestamp":{"type":"long"},"disconnectReason":{}}}}}},"thingGroups":{"type":"list","member":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupDescription":{},"attributes":{"shape":"S3i"},"parentGroupNames":{"shape":"Sub"}}}}}}},"SetDefaultAuthorizer":{"http":{"requestUri":"/default-authorizer"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"SetDefaultPolicyVersion":{"http":{"method":"PATCH","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"SetLoggingOptions":{"http":{"requestUri":"/loggingOptions"},"input":{"type":"structure","required":["loggingOptionsPayload"],"members":{"loggingOptionsPayload":{"type":"structure","required":["roleArn"],"members":{"roleArn":{},"logLevel":{}}}},"payload":"loggingOptionsPayload"}},"SetV2LoggingLevel":{"http":{"requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["logTarget","logLevel"],"members":{"logTarget":{"shape":"Stf"},"logLevel":{}}}},"SetV2LoggingOptions":{"http":{"requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"StartAuditMitigationActionsTask":{"http":{"requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId","target","auditCheckToActionsMapping","clientRequestToken"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"target":{"shape":"Sg4"},"auditCheckToActionsMapping":{"shape":"Sg8"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartDetectMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/detect/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId","target","actions","clientRequestToken"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"target":{"shape":"Shv"},"actions":{"type":"list","member":{}},"violationEventOccurrenceRange":{"shape":"Shy"},"includeOnlyActiveViolations":{"type":"boolean"},"includeSuppressedAlerts":{"type":"boolean"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartOnDemandAuditTask":{"http":{"requestUri":"/audit/tasks"},"input":{"type":"structure","required":["targetCheckNames"],"members":{"targetCheckNames":{"shape":"S8e"}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartThingRegistrationTask":{"http":{"requestUri":"/thing-registration-tasks"},"input":{"type":"structure","required":["templateBody","inputFileBucket","inputFileKey","roleArn"],"members":{"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"StopThingRegistrationTask":{"http":{"method":"PUT","requestUri":"/thing-registration-tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S29"}}},"output":{"type":"structure","members":{}}},"TestAuthorization":{"http":{"requestUri":"/test-authorization"},"input":{"type":"structure","required":["authInfos"],"members":{"principal":{},"cognitoIdentityPoolId":{},"authInfos":{"type":"list","member":{"shape":"Sv4"}},"clientId":{"location":"querystring","locationName":"clientId"},"policyNamesToAdd":{"shape":"Sv8"},"policyNamesToSkip":{"shape":"Sv8"}}},"output":{"type":"structure","members":{"authResults":{"type":"list","member":{"type":"structure","members":{"authInfo":{"shape":"Sv4"},"allowed":{"type":"structure","members":{"policies":{"shape":"Snp"}}},"denied":{"type":"structure","members":{"implicitDeny":{"type":"structure","members":{"policies":{"shape":"Snp"}}},"explicitDeny":{"type":"structure","members":{"policies":{"shape":"Snp"}}}}},"authDecision":{},"missingContextValues":{"type":"list","member":{}}}}}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}/test"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"token":{},"tokenSignature":{},"httpContext":{"type":"structure","members":{"headers":{"type":"map","key":{},"value":{}},"queryString":{}}},"mqttContext":{"type":"structure","members":{"username":{},"password":{"type":"blob"},"clientId":{}}},"tlsContext":{"type":"structure","members":{"serverName":{}}}}},"output":{"type":"structure","members":{"isAuthenticated":{"type":"boolean"},"principalId":{},"policyDocuments":{"type":"list","member":{}},"refreshAfterInSeconds":{"type":"integer"},"disconnectAfterInSeconds":{"type":"integer"}}}},"TransferCertificate":{"http":{"method":"PATCH","requestUri":"/transfer-certificate/{certificateId}"},"input":{"type":"structure","required":["certificateId","targetAwsAccount"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"targetAwsAccount":{"location":"querystring","locationName":"targetAwsAccount"},"transferMessage":{}}},"output":{"type":"structure","members":{"transferredCertificateArn":{}}}},"UntagResource":{"http":{"requestUri":"/untag"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAccountAuditConfiguration":{"http":{"method":"PATCH","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sfc"},"auditCheckConfigurations":{"shape":"Sff"}}},"output":{"type":"structure","members":{}}},"UpdateAuditSuppression":{"http":{"method":"PATCH","requestUri":"/audit/suppressions/update"},"input":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{}}},"output":{"type":"structure","members":{}}},"UpdateAuthorizer":{"http":{"method":"PUT","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S25"},"status":{},"enableCachingForHttp":{"type":"boolean"}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"UpdateBillingGroup":{"http":{"method":"PATCH","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName","billingGroupProperties"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S2i"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateCACertificate":{"http":{"method":"PUT","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"},"newAutoRegistrationStatus":{"location":"querystring","locationName":"newAutoRegistrationStatus"},"registrationConfig":{"shape":"Shf"},"removeAutoRegistration":{"type":"boolean"}}}},"UpdateCertificate":{"http":{"method":"PUT","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId","newStatus"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"}}}},"UpdateCustomMetric":{"http":{"method":"PATCH","requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName","displayName"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"displayName":{}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{},"metricType":{},"displayName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateDimension":{"http":{"method":"PATCH","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name","stringValues"],"members":{"name":{"location":"uri","locationName":"name"},"stringValues":{"shape":"S30"}}},"output":{"type":"structure","members":{"name":{},"arn":{},"type":{},"stringValues":{"shape":"S30"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateDomainConfiguration":{"http":{"method":"PUT","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"},"authorizerConfig":{"shape":"S39"},"domainConfigurationStatus":{},"removeAuthorizerConfig":{"type":"boolean"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{}}}},"UpdateDynamicThingGroup":{"http":{"method":"PATCH","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3f"},"expectedVersion":{"type":"long"},"indexName":{},"queryString":{},"queryVersion":{}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateEventConfigurations":{"http":{"method":"PATCH","requestUri":"/event-configurations"},"input":{"type":"structure","members":{"eventConfigurations":{"shape":"Sij"}}},"output":{"type":"structure","members":{}}},"UpdateFleetMetric":{"http":{"method":"PATCH","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName","indexName"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"queryString":{},"aggregationType":{"shape":"S3t"},"period":{"type":"integer"},"aggregationField":{},"description":{},"queryVersion":{},"indexName":{},"unit":{},"expectedVersion":{"type":"long"}}}},"UpdateIndexingConfiguration":{"http":{"requestUri":"/indexing/config"},"input":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Slr"},"thingGroupIndexingConfiguration":{"shape":"Sm0"}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"http":{"method":"PATCH","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"description":{},"presignedUrlConfig":{"shape":"S46"},"jobExecutionsRolloutConfig":{"shape":"S49"},"abortConfig":{"shape":"S4g"},"timeoutConfig":{"shape":"S4n"},"namespaceId":{"location":"querystring","locationName":"namespaceId"},"jobExecutionsRetryConfig":{"shape":"S4q"}}}},"UpdateMitigationAction":{"http":{"method":"PATCH","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S59"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"UpdateProvisioningTemplate":{"http":{"method":"PATCH","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"description":{},"enabled":{"type":"boolean"},"defaultVersionId":{"type":"integer"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S7z"},"removePreProvisioningHook":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateRoleAlias":{"http":{"method":"PUT","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"UpdateScheduledAudit":{"http":{"method":"PATCH","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S8e"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"UpdateSecurityProfile":{"http":{"method":"PATCH","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S8k"},"alertTargets":{"shape":"S9a"},"additionalMetricsToRetain":{"shape":"S9e","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S9f"},"deleteBehaviors":{"type":"boolean"},"deleteAlertTargets":{"type":"boolean"},"deleteAdditionalMetricsToRetain":{"type":"boolean"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S8k"},"alertTargets":{"shape":"S9a"},"additionalMetricsToRetain":{"shape":"S9e","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"S9f"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateStream":{"http":{"method":"PUT","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S9l"},"roleArn":{}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"UpdateThing":{"http":{"method":"PATCH","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S3h"},"expectedVersion":{"type":"long"},"removeThingType":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateThingGroup":{"http":{"method":"PATCH","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3f"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateThingGroupsForThing":{"http":{"method":"PUT","requestUri":"/thing-groups/updateThingGroupsForThing"},"input":{"type":"structure","members":{"thingName":{},"thingGroupsToAdd":{"shape":"Sxj"},"thingGroupsToRemove":{"shape":"Sxj"},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateTopicRuleDestination":{"http":{"method":"PATCH","requestUri":"/destinations"},"input":{"type":"structure","required":["arn","status"],"members":{"arn":{},"status":{}}},"output":{"type":"structure","members":{}}},"ValidateSecurityProfileBehaviors":{"http":{"requestUri":"/security-profile-behaviors/validate"},"input":{"type":"structure","required":["behaviors"],"members":{"behaviors":{"shape":"S8k"}}},"output":{"type":"structure","members":{"valid":{"type":"boolean"},"validationErrors":{"type":"list","member":{"type":"structure","members":{"errorMessage":{}}}}}}}},"shapes":{"Sg":{"type":"list","member":{}},"S1e":{"type":"map","key":{},"value":{}},"S1o":{"type":"structure","members":{"deviceCertificateId":{},"caCertificateId":{},"cognitoIdentityPoolId":{},"clientId":{},"policyVersionIdentifier":{"type":"structure","members":{"policyName":{},"policyVersionId":{}}},"account":{},"iamRoleArn":{},"roleAliasArn":{}}},"S25":{"type":"map","key":{},"value":{}},"S29":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S2i":{"type":"structure","members":{"billingGroupDescription":{}}},"S30":{"type":"list","member":{}},"S39":{"type":"structure","members":{"defaultAuthorizerName":{},"allowAuthorizerOverride":{"type":"boolean"}}},"S3f":{"type":"structure","members":{"thingGroupDescription":{},"attributePayload":{"shape":"S3h"}}},"S3h":{"type":"structure","members":{"attributes":{"shape":"S3i"},"merge":{"type":"boolean"}}},"S3i":{"type":"map","key":{},"value":{}},"S3t":{"type":"structure","required":["name"],"members":{"name":{},"values":{"type":"list","member":{}}}},"S46":{"type":"structure","members":{"roleArn":{},"expiresInSec":{"type":"long"}}},"S49":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S4g":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"S4n":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"S4q":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","numberOfRetries"],"members":{"failureType":{},"numberOfRetries":{"type":"integer"}}}}}},"S4v":{"type":"map","key":{},"value":{}},"S54":{"type":"structure","members":{"PublicKey":{},"PrivateKey":{"type":"string","sensitive":true}}},"S59":{"type":"structure","members":{"updateDeviceCertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"updateCACertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"addThingsToThingGroupParams":{"type":"structure","required":["thingGroupNames"],"members":{"thingGroupNames":{"type":"list","member":{}},"overrideDynamicGroups":{"type":"boolean"}}},"replaceDefaultPolicyVersionParams":{"type":"structure","required":["templateName"],"members":{"templateName":{}}},"enableIoTLoggingParams":{"type":"structure","required":["roleArnForLogging","logLevel"],"members":{"roleArnForLogging":{},"logLevel":{}}},"publishFindingToSnsParams":{"type":"structure","required":["topicArn"],"members":{"topicArn":{}}}}},"S5t":{"type":"list","member":{}},"S5v":{"type":"list","member":{}},"S5x":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S64":{"type":"structure","members":{"expiresInSec":{"type":"long"}}},"S6f":{"type":"list","member":{"type":"structure","members":{"fileName":{},"fileType":{"type":"integer"},"fileVersion":{},"fileLocation":{"type":"structure","members":{"stream":{"type":"structure","members":{"streamId":{},"fileId":{"type":"integer"}}},"s3Location":{"shape":"S6o"}}},"codeSigning":{"type":"structure","members":{"awsSignerJobId":{},"startSigningJobParameter":{"type":"structure","members":{"signingProfileParameter":{"type":"structure","members":{"certificateArn":{},"platform":{},"certificatePathOnDevice":{}}},"signingProfileName":{},"destination":{"type":"structure","members":{"s3Destination":{"type":"structure","members":{"bucket":{},"prefix":{}}}}}}},"customCodeSigning":{"type":"structure","members":{"signature":{"type":"structure","members":{"inlineDocument":{"type":"blob"}}},"certificateChain":{"type":"structure","members":{"certificateName":{},"inlineDocument":{}}},"hashAlgorithm":{},"signatureAlgorithm":{}}}}},"attributes":{"type":"map","key":{},"value":{}}}}},"S6o":{"type":"structure","members":{"bucket":{},"key":{},"version":{}}},"S7d":{"type":"map","key":{},"value":{}},"S7z":{"type":"structure","required":["targetArn"],"members":{"payloadVersion":{},"targetArn":{}}},"S8e":{"type":"list","member":{}},"S8k":{"type":"list","member":{"shape":"S8l"}},"S8l":{"type":"structure","required":["name"],"members":{"name":{},"metric":{},"metricDimension":{"shape":"S8o"},"criteria":{"type":"structure","members":{"comparisonOperator":{},"value":{"shape":"S8s"},"durationSeconds":{"type":"integer"},"consecutiveDatapointsToAlarm":{"type":"integer"},"consecutiveDatapointsToClear":{"type":"integer"},"statisticalThreshold":{"type":"structure","members":{"statistic":{}}},"mlDetectionConfig":{"type":"structure","required":["confidenceLevel"],"members":{"confidenceLevel":{}}}}},"suppressAlerts":{"type":"boolean"}}},"S8o":{"type":"structure","required":["dimensionName"],"members":{"dimensionName":{},"operator":{}}},"S8s":{"type":"structure","members":{"count":{"type":"long"},"cidrs":{"type":"list","member":{}},"ports":{"type":"list","member":{"type":"integer"}},"number":{"type":"double"},"numbers":{"type":"list","member":{"type":"double"}},"strings":{"type":"list","member":{}}}},"S9a":{"type":"map","key":{},"value":{"type":"structure","required":["alertTargetArn","roleArn"],"members":{"alertTargetArn":{},"roleArn":{}}}},"S9e":{"type":"list","member":{}},"S9f":{"type":"list","member":{"type":"structure","required":["metric"],"members":{"metric":{},"metricDimension":{"shape":"S8o"}}}},"S9l":{"type":"list","member":{"type":"structure","members":{"fileId":{"type":"integer"},"s3Location":{"shape":"S6o"}}}},"S9x":{"type":"structure","members":{"thingTypeDescription":{},"searchableAttributes":{"type":"list","member":{}}}},"Sa5":{"type":"structure","required":["sql","actions"],"members":{"sql":{},"description":{},"actions":{"shape":"Sa8"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"Sa9"}}},"Sa8":{"type":"list","member":{"shape":"Sa9"}},"Sa9":{"type":"structure","members":{"dynamoDB":{"type":"structure","required":["tableName","roleArn","hashKeyField","hashKeyValue"],"members":{"tableName":{},"roleArn":{},"operation":{},"hashKeyField":{},"hashKeyValue":{},"hashKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"rangeKeyType":{},"payloadField":{}}},"dynamoDBv2":{"type":"structure","required":["roleArn","putItem"],"members":{"roleArn":{},"putItem":{"type":"structure","required":["tableName"],"members":{"tableName":{}}}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"sns":{"type":"structure","required":["targetArn","roleArn"],"members":{"targetArn":{},"roleArn":{},"messageFormat":{}}},"sqs":{"type":"structure","required":["roleArn","queueUrl"],"members":{"roleArn":{},"queueUrl":{},"useBase64":{"type":"boolean"}}},"kinesis":{"type":"structure","required":["roleArn","streamName"],"members":{"roleArn":{},"streamName":{},"partitionKey":{}}},"republish":{"type":"structure","required":["roleArn","topic"],"members":{"roleArn":{},"topic":{},"qos":{"type":"integer"}}},"s3":{"type":"structure","required":["roleArn","bucketName","key"],"members":{"roleArn":{},"bucketName":{},"key":{},"cannedAcl":{}}},"firehose":{"type":"structure","required":["roleArn","deliveryStreamName"],"members":{"roleArn":{},"deliveryStreamName":{},"separator":{},"batchMode":{"type":"boolean"}}},"cloudwatchMetric":{"type":"structure","required":["roleArn","metricNamespace","metricName","metricValue","metricUnit"],"members":{"roleArn":{},"metricNamespace":{},"metricName":{},"metricValue":{},"metricUnit":{},"metricTimestamp":{}}},"cloudwatchAlarm":{"type":"structure","required":["roleArn","alarmName","stateReason","stateValue"],"members":{"roleArn":{},"alarmName":{},"stateReason":{},"stateValue":{}}},"cloudwatchLogs":{"type":"structure","required":["roleArn","logGroupName"],"members":{"roleArn":{},"logGroupName":{}}},"elasticsearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"salesforce":{"type":"structure","required":["token","url"],"members":{"token":{},"url":{}}},"iotAnalytics":{"type":"structure","members":{"channelArn":{},"channelName":{},"batchMode":{"type":"boolean"},"roleArn":{}}},"iotEvents":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"messageId":{},"batchMode":{"type":"boolean"},"roleArn":{}}},"iotSiteWise":{"type":"structure","required":["putAssetPropertyValueEntries","roleArn"],"members":{"putAssetPropertyValueEntries":{"type":"list","member":{"type":"structure","required":["propertyValues"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"propertyValues":{"type":"list","member":{"type":"structure","required":["value","timestamp"],"members":{"value":{"type":"structure","members":{"stringValue":{},"integerValue":{},"doubleValue":{},"booleanValue":{}}},"timestamp":{"type":"structure","required":["timeInSeconds"],"members":{"timeInSeconds":{},"offsetInNanos":{}}},"quality":{}}}}}}},"roleArn":{}}},"stepFunctions":{"type":"structure","required":["stateMachineName","roleArn"],"members":{"executionNamePrefix":{},"stateMachineName":{},"roleArn":{}}},"timestream":{"type":"structure","required":["roleArn","databaseName","tableName","dimensions"],"members":{"roleArn":{},"databaseName":{},"tableName":{},"dimensions":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"timestamp":{"type":"structure","required":["value","unit"],"members":{"value":{},"unit":{}}}}},"http":{"type":"structure","required":["url"],"members":{"url":{},"confirmationUrl":{},"headers":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"auth":{"type":"structure","members":{"sigv4":{"type":"structure","required":["signingRegion","serviceName","roleArn"],"members":{"signingRegion":{},"serviceName":{},"roleArn":{}}}}}}},"kafka":{"type":"structure","required":["destinationArn","topic","clientProperties"],"members":{"destinationArn":{},"topic":{},"key":{},"partition":{},"clientProperties":{"type":"map","key":{},"value":{}}}},"openSearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}}}},"Sd6":{"type":"list","member":{}},"Sd8":{"type":"list","member":{}},"Sdc":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"statusReason":{},"httpUrlProperties":{"type":"structure","members":{"confirmationUrl":{}}},"vpcProperties":{"type":"structure","members":{"subnetIds":{"shape":"Sd6"},"securityGroups":{"shape":"Sd8"},"vpcId":{},"roleArn":{}}}}},"Sfc":{"type":"map","key":{},"value":{"type":"structure","members":{"targetArn":{},"roleArn":{},"enabled":{"type":"boolean"}}}},"Sff":{"type":"map","key":{},"value":{"type":"structure","members":{"enabled":{"type":"boolean"}}}},"Sfk":{"type":"structure","members":{"findingId":{},"taskId":{},"checkName":{},"taskStartTime":{"type":"timestamp"},"findingTime":{"type":"timestamp"},"severity":{},"nonCompliantResource":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"S1o"},"additionalInfo":{"shape":"Sfo"}}},"relatedResources":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"S1o"},"additionalInfo":{"shape":"Sfo"}}}},"reasonForNonCompliance":{},"reasonForNonComplianceCode":{},"isSuppressed":{"type":"boolean"}}},"Sfo":{"type":"map","key":{},"value":{}},"Sg4":{"type":"structure","members":{"auditTaskId":{},"findingIds":{"type":"list","member":{}},"auditCheckToReasonCodeFilter":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"Sg8":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sga":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"roleArn":{},"actionParams":{"shape":"S59"}}}},"Sh1":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S25"},"status":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"signingDisabled":{"type":"boolean"},"enableCachingForHttp":{"type":"boolean"}}},"She":{"type":"structure","members":{"notBefore":{"type":"timestamp"},"notAfter":{"type":"timestamp"}}},"Shf":{"type":"structure","members":{"templateBody":{},"roleArn":{}}},"Sht":{"type":"structure","members":{"taskId":{},"taskStatus":{},"taskStartTime":{"type":"timestamp"},"taskEndTime":{"type":"timestamp"},"target":{"shape":"Shv"},"violationEventOccurrenceRange":{"shape":"Shy"},"onlyActiveViolationsIncluded":{"type":"boolean"},"suppressedAlertsIncluded":{"type":"boolean"},"actionsDefinition":{"shape":"Sga"},"taskStatistics":{"type":"structure","members":{"actionsExecuted":{"type":"long"},"actionsSkipped":{"type":"long"},"actionsFailed":{"type":"long"}}}}},"Shv":{"type":"structure","members":{"violationIds":{"type":"list","member":{}},"securityProfileName":{},"behaviorName":{}}},"Shy":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"Sij":{"type":"map","key":{},"value":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"Sjm":{"type":"list","member":{}},"Skf":{"type":"list","member":{"shape":"Skg"}},"Skg":{"type":"structure","members":{"groupName":{},"groupArn":{}}},"Sks":{"type":"structure","members":{"deprecated":{"type":"boolean"},"deprecationDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"}}},"Slr":{"type":"structure","required":["thingIndexingMode"],"members":{"thingIndexingMode":{},"thingConnectivityIndexingMode":{},"deviceDefenderIndexingMode":{},"namedShadowIndexingMode":{},"managedFields":{"shape":"Slw"},"customFields":{"shape":"Slw"}}},"Slw":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{}}}},"Sm0":{"type":"structure","required":["thingGroupIndexingMode"],"members":{"thingGroupIndexingMode":{},"managedFields":{"shape":"Slw"},"customFields":{"shape":"Slw"}}},"Sni":{"type":"structure","members":{"confidenceLevel":{}}},"Snp":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{}}}},"Sor":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificateMode":{},"creationDate":{"type":"timestamp"}}}},"Spr":{"type":"structure","members":{"status":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"},"retryAttempt":{"type":"integer"}}},"Sqt":{"type":"list","member":{}},"Sr3":{"type":"list","member":{}},"Srm":{"type":"structure","required":["name","arn"],"members":{"name":{},"arn":{}}},"Srr":{"type":"structure","required":["arn"],"members":{"arn":{}}},"Stf":{"type":"structure","required":["targetType"],"members":{"targetType":{},"targetName":{}}},"Sub":{"type":"list","member":{}},"Sv4":{"type":"structure","required":["resources"],"members":{"actionType":{},"resources":{"type":"list","member":{}}}},"Sv8":{"type":"list","member":{}},"Sxj":{"type":"list","member":{}}}}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetBehaviorModelTrainingSummaries":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"ListActiveViolations":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"activeViolations"},"ListAttachedPolicies":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"policies"},"ListAuditFindings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"findings"},"ListAuditMitigationActionsExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"actionsExecutions"},"ListAuditMitigationActionsTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tasks"},"ListAuditSuppressions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"suppressions"},"ListAuditTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tasks"},"ListAuthorizers":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"authorizers"},"ListBillingGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"billingGroups"},"ListCACertificates":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"certificates"},"ListCertificates":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"certificates"},"ListCertificatesByCA":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"certificates"},"ListCustomMetrics":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"metricNames"},"ListDetectMitigationActionsExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"actionsExecutions"},"ListDetectMitigationActionsTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tasks"},"ListDimensions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"dimensionNames"},"ListDomainConfigurations":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"domainConfigurations"},"ListFleetMetrics":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"fleetMetrics"},"ListIndices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"indexNames"},"ListJobExecutionsForJob":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"executionSummaries"},"ListJobExecutionsForThing":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"executionSummaries"},"ListJobTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"jobTemplates"},"ListJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"jobs"},"ListMetricValues":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"metricDatumList"},"ListMitigationActions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"actionIdentifiers"},"ListOTAUpdates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"otaUpdates"},"ListOutgoingCertificates":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"outgoingCertificates"},"ListPolicies":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"policies"},"ListPolicyPrincipals":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"principals"},"ListPrincipalPolicies":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"policies"},"ListPrincipalThings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListProvisioningTemplateVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"versions"},"ListProvisioningTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"templates"},"ListRoleAliases":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"roleAliases"},"ListScheduledAudits":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"scheduledAudits"},"ListSecurityProfiles":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"securityProfileIdentifiers"},"ListSecurityProfilesForTarget":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"securityProfileTargetMappings"},"ListStreams":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"streams"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","result_key":"tags"},"ListTargetsForPolicy":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"targets"},"ListTargetsForSecurityProfile":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"securityProfileTargets"},"ListThingGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"thingGroups"},"ListThingGroupsForThing":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"thingGroups"},"ListThingPrincipals":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"principals"},"ListThingRegistrationTaskReports":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["reportType"],"output_token":"nextToken","result_key":"resourceLinks"},"ListThingRegistrationTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskIds"},"ListThingTypes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"thingTypes"},"ListThings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListThingsInBillingGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListThingsInThingGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListTopicRuleDestinations":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"destinationSummaries"},"ListTopicRules":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"rules"},"ListV2LoggingLevels":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"logTargetConfigurations"},"ListViolationEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"violationEvents"}}}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotdata'] = {};
	AWS.IotData = Service.defineService('iotdata', ['2015-05-28']);
	__webpack_require__(263);
	Object.defineProperty(apiLoader.services['iotdata'], '2015-05-28', {
	  get: function get() {
	    var model = __webpack_require__(264);
	    model.paginators = __webpack_require__(265).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IotData;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	/**
	 * @api private
	 */
	var blobPayloadOutputOps = [
	  'deleteThingShadow',
	  'getThingShadow',
	  'updateThingShadow'
	];

	/**
	 * Constructs a service interface object. Each API operation is exposed as a
	 * function on service.
	 *
	 * ### Sending a Request Using IotData
	 *
	 * ```javascript
	 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 * iotdata.getThingShadow(params, function (err, data) {
	 *   if (err) console.log(err, err.stack); // an error occurred
	 *   else     console.log(data);           // successful response
	 * });
	 * ```
	 *
	 * ### Locking the API Version
	 *
	 * In order to ensure that the IotData object uses this specific API,
	 * you can construct the object by passing the `apiVersion` option to the
	 * constructor:
	 *
	 * ```javascript
	 * var iotdata = new AWS.IotData({
	 *   endpoint: 'my.host.tld',
	 *   apiVersion: '2015-05-28'
	 * });
	 * ```
	 *
	 * You can also set the API version globally in `AWS.config.apiVersions` using
	 * the **iotdata** service identifier:
	 *
	 * ```javascript
	 * AWS.config.apiVersions = {
	 *   iotdata: '2015-05-28',
	 *   // other service API versions
	 * };
	 *
	 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 * ```
	 *
	 * @note You *must* provide an `endpoint` configuration parameter when
	 *   constructing this service. See {constructor} for more information.
	 *
	 * @!method constructor(options = {})
	 *   Constructs a service object. This object has one method for each
	 *   API operation.
	 *
	 *   @example Constructing a IotData object
	 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 *   @note You *must* provide an `endpoint` when constructing this service.
	 *   @option (see AWS.Config.constructor)
	 *
	 * @service iotdata
	 * @version 2015-05-28
	 */
	AWS.util.update(AWS.IotData.prototype, {
	    /**
	     * @api private
	     */
	    validateService: function validateService() {
	        if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
	            var msg = 'AWS.IotData requires an explicit ' +
	                '`endpoint\' configuration option.';
	            throw AWS.util.error(new Error(),
	                {name: 'InvalidEndpoint', message: msg});
	        }
	    },

	    /**
	     * @api private
	     */
	    setupRequestListeners: function setupRequestListeners(request) {
	        request.addListener('validateResponse', this.validateResponseBody);
	        if (blobPayloadOutputOps.indexOf(request.operation) > -1) {
	            request.addListener('extractData', AWS.util.convertPayloadToString);
	        }
	    },

	    /**
	     * @api private
	     */
	    validateResponseBody: function validateResponseBody(resp) {
	        var body = resp.httpResponse.body.toString() || '{}';
	        var bodyCheck = body.trim();
	        if (!bodyCheck || bodyCheck.charAt(0) !== '{') {
	            resp.httpResponse.body = '';
	        }
	    }

	});


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"data-ats.iot","protocol":"rest-json","serviceFullName":"AWS IoT Data Plane","serviceId":"IoT Data Plane","signatureVersion":"v4","signingName":"iotdata","uid":"iot-data-2015-05-28"},"operations":{"DeleteThingShadow":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","required":["payload"],"members":{"payload":{"type":"blob"}},"payload":"payload"}},"GetRetainedMessage":{"http":{"method":"GET","requestUri":"/retainedMessage/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"}}},"output":{"type":"structure","members":{"topic":{},"payload":{"type":"blob"},"qos":{"type":"integer"},"lastModifiedTime":{"type":"long"}}}},"GetThingShadow":{"http":{"method":"GET","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}},"ListNamedShadowsForThing":{"http":{"method":"GET","requestUri":"/api/things/shadow/ListNamedShadowsForThing/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{}},"nextToken":{},"timestamp":{"type":"long"}}}},"ListRetainedMessages":{"http":{"method":"GET","requestUri":"/retainedMessage"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"retainedTopics":{"type":"list","member":{"type":"structure","members":{"topic":{},"payloadSize":{"type":"long"},"qos":{"type":"integer"},"lastModifiedTime":{"type":"long"}}}},"nextToken":{}}}},"Publish":{"http":{"requestUri":"/topics/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"},"qos":{"location":"querystring","locationName":"qos","type":"integer"},"retain":{"location":"querystring","locationName":"retain","type":"boolean"},"payload":{"type":"blob"}},"payload":"payload"}},"UpdateThingShadow":{"http":{"requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName","payload"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"},"payload":{"type":"blob"}},"payload":"payload"},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}}},"shapes":{}}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListRetainedMessages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"retainedTopics"}}}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesis'] = {};
	AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
	Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
	  get: function get() {
	    var model = __webpack_require__(267);
	    model.paginators = __webpack_require__(268).pagination;
	    model.waiters = __webpack_require__(269).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Kinesis;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-12-02","endpointPrefix":"kinesis","jsonVersion":"1.1","protocol":"json","protocolSettings":{"h2":"eventstream"},"serviceAbbreviation":"Kinesis","serviceFullName":"Amazon Kinesis","serviceId":"Kinesis","signatureVersion":"v4","targetPrefix":"Kinesis_20131202","uid":"kinesis-2013-12-02"},"operations":{"AddTagsToStream":{"input":{"type":"structure","required":["StreamName","Tags"],"members":{"StreamName":{},"Tags":{"type":"map","key":{},"value":{}}}}},"CreateStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ShardCount":{"type":"integer"},"StreamModeDetails":{"shape":"S8"}}}},"DecreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"DeleteStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"EnforceConsumerDeletion":{"type":"boolean"}}}},"DeregisterStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{},"ConsumerName":{},"ConsumerARN":{}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["ShardLimit","OpenShardCount","OnDemandStreamCount","OnDemandStreamCountLimit"],"members":{"ShardLimit":{"type":"integer"},"OpenShardCount":{"type":"integer"},"OnDemandStreamCount":{"type":"integer"},"OnDemandStreamCountLimit":{"type":"integer"}}}},"DescribeStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","required":["StreamDescription"],"members":{"StreamDescription":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","Shards","HasMoreShards","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"StreamModeDetails":{"shape":"S8"},"Shards":{"shape":"St"},"HasMoreShards":{"type":"boolean"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"S10"},"EncryptionType":{},"KeyId":{}}}}}},"DescribeStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{},"ConsumerName":{},"ConsumerARN":{}}},"output":{"type":"structure","required":["ConsumerDescription"],"members":{"ConsumerDescription":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp","StreamARN"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"},"StreamARN":{}}}}}},"DescribeStreamSummary":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{}}},"output":{"type":"structure","required":["StreamDescriptionSummary"],"members":{"StreamDescriptionSummary":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring","OpenShardCount"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"StreamModeDetails":{"shape":"S8"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"S10"},"EncryptionType":{},"KeyId":{},"OpenShardCount":{"type":"integer"},"ConsumerCount":{"type":"integer"}}}}}},"DisableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"S12"}}},"output":{"shape":"S1f"}},"EnableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"S12"}}},"output":{"shape":"S1f"}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["SequenceNumber","Data","PartitionKey"],"members":{"SequenceNumber":{},"ApproximateArrivalTimestamp":{"type":"timestamp"},"Data":{"type":"blob"},"PartitionKey":{},"EncryptionType":{}}}},"NextShardIterator":{},"MillisBehindLatest":{"type":"long"},"ChildShards":{"type":"list","member":{"type":"structure","required":["ShardId","ParentShards","HashKeyRange"],"members":{"ShardId":{},"ParentShards":{"type":"list","member":{}},"HashKeyRange":{"shape":"Sv"}}}}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamName","ShardId","ShardIteratorType"],"members":{"StreamName":{},"ShardId":{},"ShardIteratorType":{},"StartingSequenceNumber":{},"Timestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"IncreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"ListShards":{"input":{"type":"structure","members":{"StreamName":{},"NextToken":{},"ExclusiveStartShardId":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"ShardFilter":{"type":"structure","required":["Type"],"members":{"Type":{},"ShardId":{},"Timestamp":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"Shards":{"shape":"St"},"NextToken":{}}}},"ListStreamConsumers":{"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"NextToken":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Consumers":{"type":"list","member":{"shape":"S27"}},"NextToken":{}}}},"ListStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartStreamName":{}}},"output":{"type":"structure","required":["StreamNames","HasMoreStreams"],"members":{"StreamNames":{"type":"list","member":{}},"HasMoreStreams":{"type":"boolean"}}}},"ListTagsForStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"HasMoreTags":{"type":"boolean"}}}},"MergeShards":{"input":{"type":"structure","required":["StreamName","ShardToMerge","AdjacentShardToMerge"],"members":{"StreamName":{},"ShardToMerge":{},"AdjacentShardToMerge":{}}}},"PutRecord":{"input":{"type":"structure","required":["StreamName","Data","PartitionKey"],"members":{"StreamName":{},"Data":{"type":"blob"},"PartitionKey":{},"ExplicitHashKey":{},"SequenceNumberForOrdering":{}}},"output":{"type":"structure","required":["ShardId","SequenceNumber"],"members":{"ShardId":{},"SequenceNumber":{},"EncryptionType":{}}}},"PutRecords":{"input":{"type":"structure","required":["Records","StreamName"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["Data","PartitionKey"],"members":{"Data":{"type":"blob"},"ExplicitHashKey":{},"PartitionKey":{}}}},"StreamName":{}}},"output":{"type":"structure","required":["Records"],"members":{"FailedRecordCount":{"type":"integer"},"Records":{"type":"list","member":{"type":"structure","members":{"SequenceNumber":{},"ShardId":{},"ErrorCode":{},"ErrorMessage":{}}}},"EncryptionType":{}}}},"RegisterStreamConsumer":{"input":{"type":"structure","required":["StreamARN","ConsumerName"],"members":{"StreamARN":{},"ConsumerName":{}}},"output":{"type":"structure","required":["Consumer"],"members":{"Consumer":{"shape":"S27"}}}},"RemoveTagsFromStream":{"input":{"type":"structure","required":["StreamName","TagKeys"],"members":{"StreamName":{},"TagKeys":{"type":"list","member":{}}}}},"SplitShard":{"input":{"type":"structure","required":["StreamName","ShardToSplit","NewStartingHashKey"],"members":{"StreamName":{},"ShardToSplit":{},"NewStartingHashKey":{}}}},"StartStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"StopStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"UpdateShardCount":{"input":{"type":"structure","required":["StreamName","TargetShardCount","ScalingType"],"members":{"StreamName":{},"TargetShardCount":{"type":"integer"},"ScalingType":{}}},"output":{"type":"structure","members":{"StreamName":{},"CurrentShardCount":{"type":"integer"},"TargetShardCount":{"type":"integer"}}}},"UpdateStreamMode":{"input":{"type":"structure","required":["StreamARN","StreamModeDetails"],"members":{"StreamARN":{},"StreamModeDetails":{"shape":"S8"}}}}},"shapes":{"S8":{"type":"structure","required":["StreamMode"],"members":{"StreamMode":{}}},"St":{"type":"list","member":{"type":"structure","required":["ShardId","HashKeyRange","SequenceNumberRange"],"members":{"ShardId":{},"ParentShardId":{},"AdjacentParentShardId":{},"HashKeyRange":{"shape":"Sv"},"SequenceNumberRange":{"type":"structure","required":["StartingSequenceNumber"],"members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}}}}},"Sv":{"type":"structure","required":["StartingHashKey","EndingHashKey"],"members":{"StartingHashKey":{},"EndingHashKey":{}}},"S10":{"type":"list","member":{"type":"structure","members":{"ShardLevelMetrics":{"shape":"S12"}}}},"S12":{"type":"list","member":{}},"S1f":{"type":"structure","members":{"StreamName":{},"CurrentShardLevelMetrics":{"shape":"S12"},"DesiredShardLevelMetrics":{"shape":"S12"}}},"S27":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"}}}}}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeStream":{"input_token":"ExclusiveStartShardId","limit_key":"Limit","more_results":"StreamDescription.HasMoreShards","output_token":"StreamDescription.Shards[-1].ShardId","result_key":"StreamDescription.Shards"},"ListStreamConsumers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListStreams":{"input_token":"ExclusiveStartStreamName","limit_key":"Limit","more_results":"HasMoreStreams","output_token":"StreamNames[-1]","result_key":"StreamNames"}}}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"StreamExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"StreamDescription.StreamStatus"}]},"StreamNotExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesisanalytics'] = {};
	AWS.KinesisAnalytics = Service.defineService('kinesisanalytics', ['2015-08-14']);
	Object.defineProperty(apiLoader.services['kinesisanalytics'], '2015-08-14', {
	  get: function get() {
	    var model = __webpack_require__(271);
	    model.paginators = __webpack_require__(272).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KinesisAnalytics;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-14","endpointPrefix":"kinesisanalytics","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Kinesis Analytics","serviceFullName":"Amazon Kinesis Analytics","serviceId":"Kinesis Analytics","signatureVersion":"v4","targetPrefix":"KinesisAnalytics_20150814","uid":"kinesisanalytics-2015-08-14"},"operations":{"AddApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","CloudWatchLoggingOption"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOption":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"AddApplicationInput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Input"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Input":{"shape":"S9"}}},"output":{"type":"structure","members":{}}},"AddApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId","InputProcessingConfiguration"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{},"InputProcessingConfiguration":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"AddApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Output"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Output":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AddApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceDataSource"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceDataSource":{"type":"structure","required":["TableName","ReferenceSchema"],"members":{"TableName":{},"S3ReferenceDataSource":{"type":"structure","required":["BucketARN","FileKey","ReferenceRoleARN"],"members":{"BucketARN":{},"FileKey":{},"ReferenceRoleARN":{}}},"ReferenceSchema":{"shape":"Si"}}}}},"output":{"type":"structure","members":{}}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"ApplicationDescription":{},"Inputs":{"type":"list","member":{"shape":"S9"}},"Outputs":{"type":"list","member":{"shape":"S12"}},"CloudWatchLoggingOptions":{"type":"list","member":{"shape":"S4"}},"ApplicationCode":{},"Tags":{"shape":"S1l"}}},"output":{"type":"structure","required":["ApplicationSummary"],"members":{"ApplicationSummary":{"shape":"S1q"}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName","CreateTimestamp"],"members":{"ApplicationName":{},"CreateTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"DeleteApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","CloudWatchLoggingOptionId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionId":{}}},"output":{"type":"structure","members":{}}},"DeleteApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{}}},"output":{"type":"structure","members":{}}},"DeleteApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","OutputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"OutputId":{}}},"output":{"type":"structure","members":{}}},"DeleteApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceId":{}}},"output":{"type":"structure","members":{}}},"DescribeApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"type":"structure","required":["ApplicationName","ApplicationARN","ApplicationStatus","ApplicationVersionId"],"members":{"ApplicationName":{},"ApplicationDescription":{},"ApplicationARN":{},"ApplicationStatus":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"InputDescriptions":{"type":"list","member":{"type":"structure","members":{"InputId":{},"NamePrefix":{},"InAppStreamNames":{"type":"list","member":{}},"InputProcessingConfigurationDescription":{"type":"structure","members":{"InputLambdaProcessorDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}}}},"KinesisStreamsInputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseInputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"InputSchema":{"shape":"Si"},"InputParallelism":{"shape":"Sg"},"InputStartingPositionConfiguration":{"shape":"S2d"}}}},"OutputDescriptions":{"type":"list","member":{"type":"structure","members":{"OutputId":{},"Name":{},"KinesisStreamsOutputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseOutputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"LambdaOutputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"DestinationSchema":{"shape":"S16"}}}},"ReferenceDataSourceDescriptions":{"type":"list","member":{"type":"structure","required":["ReferenceId","TableName","S3ReferenceDataSourceDescription"],"members":{"ReferenceId":{},"TableName":{},"S3ReferenceDataSourceDescription":{"type":"structure","required":["BucketARN","FileKey","ReferenceRoleARN"],"members":{"BucketARN":{},"FileKey":{},"ReferenceRoleARN":{}}},"ReferenceSchema":{"shape":"Si"}}}},"CloudWatchLoggingOptionDescriptions":{"type":"list","member":{"type":"structure","required":["LogStreamARN","RoleARN"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARN":{},"RoleARN":{}}}},"ApplicationCode":{},"ApplicationVersionId":{"type":"long"}}}}}},"DiscoverInputSchema":{"input":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{},"InputStartingPositionConfiguration":{"shape":"S2d"},"S3Configuration":{"type":"structure","required":["RoleARN","BucketARN","FileKey"],"members":{"RoleARN":{},"BucketARN":{},"FileKey":{}}},"InputProcessingConfiguration":{"shape":"Sb"}}},"output":{"type":"structure","members":{"InputSchema":{"shape":"Si"},"ParsedInputRecords":{"type":"list","member":{"type":"list","member":{}}},"ProcessedInputRecords":{"type":"list","member":{}},"RawInputRecords":{"type":"list","member":{}}}}},"ListApplications":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartApplicationName":{}}},"output":{"type":"structure","required":["ApplicationSummaries","HasMoreApplications"],"members":{"ApplicationSummaries":{"type":"list","member":{"shape":"S1q"}},"HasMoreApplications":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1l"}}}},"StartApplication":{"input":{"type":"structure","required":["ApplicationName","InputConfigurations"],"members":{"ApplicationName":{},"InputConfigurations":{"type":"list","member":{"type":"structure","required":["Id","InputStartingPositionConfiguration"],"members":{"Id":{},"InputStartingPositionConfiguration":{"shape":"S2d"}}}}}},"output":{"type":"structure","members":{}}},"StopApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1l"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ApplicationUpdate"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ApplicationUpdate":{"type":"structure","members":{"InputUpdates":{"type":"list","member":{"type":"structure","required":["InputId"],"members":{"InputId":{},"NamePrefixUpdate":{},"InputProcessingConfigurationUpdate":{"type":"structure","required":["InputLambdaProcessorUpdate"],"members":{"InputLambdaProcessorUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}}}},"KinesisStreamsInputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"KinesisFirehoseInputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"InputSchemaUpdate":{"type":"structure","members":{"RecordFormatUpdate":{"shape":"Sj"},"RecordEncodingUpdate":{},"RecordColumnUpdates":{"shape":"Ss"}}},"InputParallelismUpdate":{"type":"structure","members":{"CountUpdate":{"type":"integer"}}}}}},"ApplicationCodeUpdate":{},"OutputUpdates":{"type":"list","member":{"type":"structure","required":["OutputId"],"members":{"OutputId":{},"NameUpdate":{},"KinesisStreamsOutputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"KinesisFirehoseOutputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"LambdaOutputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"DestinationSchemaUpdate":{"shape":"S16"}}}},"ReferenceDataSourceUpdates":{"type":"list","member":{"type":"structure","required":["ReferenceId"],"members":{"ReferenceId":{},"TableNameUpdate":{},"S3ReferenceDataSourceUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"FileKeyUpdate":{},"ReferenceRoleARNUpdate":{}}},"ReferenceSchemaUpdate":{"shape":"Si"}}}},"CloudWatchLoggingOptionUpdates":{"type":"list","member":{"type":"structure","required":["CloudWatchLoggingOptionId"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARNUpdate":{},"RoleARNUpdate":{}}}}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["LogStreamARN","RoleARN"],"members":{"LogStreamARN":{},"RoleARN":{}}},"S9":{"type":"structure","required":["NamePrefix","InputSchema"],"members":{"NamePrefix":{},"InputProcessingConfiguration":{"shape":"Sb"},"KinesisStreamsInput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseInput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"InputParallelism":{"shape":"Sg"},"InputSchema":{"shape":"Si"}}},"Sb":{"type":"structure","required":["InputLambdaProcessor"],"members":{"InputLambdaProcessor":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}}}},"Sg":{"type":"structure","members":{"Count":{"type":"integer"}}},"Si":{"type":"structure","required":["RecordFormat","RecordColumns"],"members":{"RecordFormat":{"shape":"Sj"},"RecordEncoding":{},"RecordColumns":{"shape":"Ss"}}},"Sj":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{},"MappingParameters":{"type":"structure","members":{"JSONMappingParameters":{"type":"structure","required":["RecordRowPath"],"members":{"RecordRowPath":{}}},"CSVMappingParameters":{"type":"structure","required":["RecordRowDelimiter","RecordColumnDelimiter"],"members":{"RecordRowDelimiter":{},"RecordColumnDelimiter":{}}}}}}},"Ss":{"type":"list","member":{"type":"structure","required":["Name","SqlType"],"members":{"Name":{},"Mapping":{},"SqlType":{}}}},"S12":{"type":"structure","required":["Name","DestinationSchema"],"members":{"Name":{},"KinesisStreamsOutput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseOutput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"LambdaOutput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"DestinationSchema":{"shape":"S16"}}},"S16":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{}}},"S1l":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1q":{"type":"structure","required":["ApplicationName","ApplicationARN","ApplicationStatus"],"members":{"ApplicationName":{},"ApplicationARN":{},"ApplicationStatus":{}}},"S2d":{"type":"structure","members":{"InputStartingPosition":{}}}}}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kms'] = {};
	AWS.KMS = Service.defineService('kms', ['2014-11-01']);
	Object.defineProperty(apiLoader.services['kms'], '2014-11-01', {
	  get: function get() {
	    var model = __webpack_require__(274);
	    model.paginators = __webpack_require__(275).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KMS;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-01","endpointPrefix":"kms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"KMS","serviceFullName":"AWS Key Management Service","serviceId":"KMS","signatureVersion":"v4","targetPrefix":"TrentService","uid":"kms-2014-11-01"},"operations":{"CancelKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"ConnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"CreateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreName","CloudHsmClusterId","TrustAnchorCertificate","KeyStorePassword"],"members":{"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"KeyStorePassword":{"shape":"Sd"}}},"output":{"type":"structure","members":{"CustomKeyStoreId":{}}}},"CreateGrant":{"input":{"type":"structure","required":["KeyId","GranteePrincipal","Operations"],"members":{"KeyId":{},"GranteePrincipal":{},"RetiringPrincipal":{},"Operations":{"shape":"Sh"},"Constraints":{"shape":"Sj"},"GrantTokens":{"shape":"Sn"},"Name":{}}},"output":{"type":"structure","members":{"GrantToken":{},"GrantId":{}}}},"CreateKey":{"input":{"type":"structure","members":{"Policy":{},"Description":{},"KeyUsage":{},"CustomerMasterKeySpec":{"shape":"Sw","deprecated":true,"deprecatedMessage":"This parameter has been deprecated. Instead, use the KeySpec parameter."},"KeySpec":{},"Origin":{},"CustomKeyStoreId":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Tags":{"shape":"S10"},"MultiRegion":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S16"}}}},"Decrypt":{"input":{"type":"structure","required":["CiphertextBlob"],"members":{"CiphertextBlob":{"type":"blob"},"EncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"},"KeyId":{},"EncryptionAlgorithm":{}}},"output":{"type":"structure","members":{"KeyId":{},"Plaintext":{"shape":"S1s"},"EncryptionAlgorithm":{}}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasName"],"members":{"AliasName":{}}}},"DeleteCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"DeleteImportedKeyMaterial":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DescribeCustomKeyStores":{"input":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"CustomKeyStores":{"type":"list","member":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"ConnectionState":{},"ConnectionErrorCode":{},"CreationDate":{"type":"timestamp"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"DescribeKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S16"}}}},"DisableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisconnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"EnableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"Encrypt":{"input":{"type":"structure","required":["KeyId","Plaintext"],"members":{"KeyId":{},"Plaintext":{"shape":"S1s"},"EncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"},"EncryptionAlgorithm":{}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{},"EncryptionAlgorithm":{}}}},"GenerateDataKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sk"},"NumberOfBytes":{"type":"integer"},"KeySpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"Plaintext":{"shape":"S1s"},"KeyId":{}}}},"GenerateDataKeyPair":{"input":{"type":"structure","required":["KeyId","KeyPairSpec"],"members":{"EncryptionContext":{"shape":"Sk"},"KeyId":{},"KeyPairSpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"PrivateKeyCiphertextBlob":{"type":"blob"},"PrivateKeyPlaintext":{"shape":"S1s"},"PublicKey":{"type":"blob"},"KeyId":{},"KeyPairSpec":{}}}},"GenerateDataKeyPairWithoutPlaintext":{"input":{"type":"structure","required":["KeyId","KeyPairSpec"],"members":{"EncryptionContext":{"shape":"Sk"},"KeyId":{},"KeyPairSpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"PrivateKeyCiphertextBlob":{"type":"blob"},"PublicKey":{"type":"blob"},"KeyId":{},"KeyPairSpec":{}}}},"GenerateDataKeyWithoutPlaintext":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sk"},"KeySpec":{},"NumberOfBytes":{"type":"integer"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateMac":{"input":{"type":"structure","required":["Message","KeyId","MacAlgorithm"],"members":{"Message":{"shape":"S1s"},"KeyId":{},"MacAlgorithm":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"Mac":{"type":"blob"},"MacAlgorithm":{},"KeyId":{}}}},"GenerateRandom":{"input":{"type":"structure","members":{"NumberOfBytes":{"type":"integer"},"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{"Plaintext":{"shape":"S1s"}}}},"GetKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName"],"members":{"KeyId":{},"PolicyName":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetKeyRotationStatus":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyRotationEnabled":{"type":"boolean"}}}},"GetParametersForImport":{"input":{"type":"structure","required":["KeyId","WrappingAlgorithm","WrappingKeySpec"],"members":{"KeyId":{},"WrappingAlgorithm":{},"WrappingKeySpec":{}}},"output":{"type":"structure","members":{"KeyId":{},"ImportToken":{"type":"blob"},"PublicKey":{"shape":"S1s"},"ParametersValidTo":{"type":"timestamp"}}}},"GetPublicKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyId":{},"PublicKey":{"type":"blob"},"CustomerMasterKeySpec":{"shape":"Sw","deprecated":true,"deprecatedMessage":"This field has been deprecated. Instead, use the KeySpec field."},"KeySpec":{},"KeyUsage":{},"EncryptionAlgorithms":{"shape":"S1d"},"SigningAlgorithms":{"shape":"S1f"}}}},"ImportKeyMaterial":{"input":{"type":"structure","required":["KeyId","ImportToken","EncryptedKeyMaterial"],"members":{"KeyId":{},"ImportToken":{"type":"blob"},"EncryptedKeyMaterial":{"type":"blob"},"ValidTo":{"type":"timestamp"},"ExpirationModel":{}}},"output":{"type":"structure","members":{}}},"ListAliases":{"input":{"type":"structure","members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"type":"structure","members":{"AliasName":{},"AliasArn":{},"TargetKeyId":{},"CreationDate":{"type":"timestamp"},"LastUpdatedDate":{"type":"timestamp"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListGrants":{"input":{"type":"structure","required":["KeyId"],"members":{"Limit":{"type":"integer"},"Marker":{},"KeyId":{},"GrantId":{},"GranteePrincipal":{}}},"output":{"shape":"S3d"}},"ListKeyPolicies":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"PolicyNames":{"type":"list","member":{}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeys":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Keys":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"KeyArn":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListResourceTags":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S10"},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListRetirableGrants":{"input":{"type":"structure","required":["RetiringPrincipal"],"members":{"Limit":{"type":"integer"},"Marker":{},"RetiringPrincipal":{}}},"output":{"shape":"S3d"}},"PutKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName","Policy"],"members":{"KeyId":{},"PolicyName":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}}},"ReEncrypt":{"input":{"type":"structure","required":["CiphertextBlob","DestinationKeyId"],"members":{"CiphertextBlob":{"type":"blob"},"SourceEncryptionContext":{"shape":"Sk"},"SourceKeyId":{},"DestinationKeyId":{},"DestinationEncryptionContext":{"shape":"Sk"},"SourceEncryptionAlgorithm":{},"DestinationEncryptionAlgorithm":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"SourceKeyId":{},"KeyId":{},"SourceEncryptionAlgorithm":{},"DestinationEncryptionAlgorithm":{}}}},"ReplicateKey":{"input":{"type":"structure","required":["KeyId","ReplicaRegion"],"members":{"KeyId":{},"ReplicaRegion":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Description":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"ReplicaKeyMetadata":{"shape":"S16"},"ReplicaPolicy":{},"ReplicaTags":{"shape":"S10"}}}},"RetireGrant":{"input":{"type":"structure","members":{"GrantToken":{},"KeyId":{},"GrantId":{}}}},"RevokeGrant":{"input":{"type":"structure","required":["KeyId","GrantId"],"members":{"KeyId":{},"GrantId":{}}}},"ScheduleKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PendingWindowInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyId":{},"DeletionDate":{"type":"timestamp"},"KeyState":{},"PendingWindowInDays":{"type":"integer"}}}},"Sign":{"input":{"type":"structure","required":["KeyId","Message","SigningAlgorithm"],"members":{"KeyId":{},"Message":{"shape":"S1s"},"MessageType":{},"GrantTokens":{"shape":"Sn"},"SigningAlgorithm":{}}},"output":{"type":"structure","members":{"KeyId":{},"Signature":{"type":"blob"},"SigningAlgorithm":{}}}},"TagResource":{"input":{"type":"structure","required":["KeyId","Tags"],"members":{"KeyId":{},"Tags":{"shape":"S10"}}}},"UntagResource":{"input":{"type":"structure","required":["KeyId","TagKeys"],"members":{"KeyId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"UpdateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{},"NewCustomKeyStoreName":{},"KeyStorePassword":{"shape":"Sd"},"CloudHsmClusterId":{}}},"output":{"type":"structure","members":{}}},"UpdateKeyDescription":{"input":{"type":"structure","required":["KeyId","Description"],"members":{"KeyId":{},"Description":{}}}},"UpdatePrimaryRegion":{"input":{"type":"structure","required":["KeyId","PrimaryRegion"],"members":{"KeyId":{},"PrimaryRegion":{}}}},"Verify":{"input":{"type":"structure","required":["KeyId","Message","Signature","SigningAlgorithm"],"members":{"KeyId":{},"Message":{"shape":"S1s"},"MessageType":{},"Signature":{"type":"blob"},"SigningAlgorithm":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyId":{},"SignatureValid":{"type":"boolean"},"SigningAlgorithm":{}}}},"VerifyMac":{"input":{"type":"structure","required":["Message","KeyId","MacAlgorithm","Mac"],"members":{"Message":{"shape":"S1s"},"KeyId":{},"MacAlgorithm":{},"Mac":{"type":"blob"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyId":{},"MacValid":{"type":"boolean"},"MacAlgorithm":{}}}}},"shapes":{"Sd":{"type":"string","sensitive":true},"Sh":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"EncryptionContextSubset":{"shape":"Sk"},"EncryptionContextEquals":{"shape":"Sk"}}},"Sk":{"type":"map","key":{},"value":{}},"Sn":{"type":"list","member":{}},"Sw":{"type":"string","deprecated":true,"deprecatedMessage":"This enum has been deprecated. Instead, use the KeySpec enum."},"S10":{"type":"list","member":{"type":"structure","required":["TagKey","TagValue"],"members":{"TagKey":{},"TagValue":{}}}},"S16":{"type":"structure","required":["KeyId"],"members":{"AWSAccountId":{},"KeyId":{},"Arn":{},"CreationDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"Description":{},"KeyUsage":{},"KeyState":{},"DeletionDate":{"type":"timestamp"},"ValidTo":{"type":"timestamp"},"Origin":{},"CustomKeyStoreId":{},"CloudHsmClusterId":{},"ExpirationModel":{},"KeyManager":{},"CustomerMasterKeySpec":{"shape":"Sw","deprecated":true,"deprecatedMessage":"This field has been deprecated. Instead, use the KeySpec field."},"KeySpec":{},"EncryptionAlgorithms":{"shape":"S1d"},"SigningAlgorithms":{"shape":"S1f"},"MultiRegion":{"type":"boolean"},"MultiRegionConfiguration":{"type":"structure","members":{"MultiRegionKeyType":{},"PrimaryKey":{"shape":"S1j"},"ReplicaKeys":{"type":"list","member":{"shape":"S1j"}}}},"PendingDeletionWindowInDays":{"type":"integer"},"MacAlgorithms":{"type":"list","member":{}}}},"S1d":{"type":"list","member":{}},"S1f":{"type":"list","member":{}},"S1j":{"type":"structure","members":{"Arn":{},"Region":{}}},"S1s":{"type":"blob","sensitive":true},"S3d":{"type":"structure","members":{"Grants":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"GrantId":{},"Name":{},"CreationDate":{"type":"timestamp"},"GranteePrincipal":{},"RetiringPrincipal":{},"IssuingAccount":{},"Operations":{"shape":"Sh"},"Constraints":{"shape":"Sj"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}}}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Aliases"},"ListGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"},"ListKeyPolicies":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"PolicyNames"},"ListKeys":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Keys"}}}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lambda'] = {};
	AWS.Lambda = Service.defineService('lambda', ['2014-11-11', '2015-03-31']);
	__webpack_require__(277);
	Object.defineProperty(apiLoader.services['lambda'], '2014-11-11', {
	  get: function get() {
	    var model = __webpack_require__(278);
	    model.paginators = __webpack_require__(279).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['lambda'], '2015-03-31', {
	  get: function get() {
	    var model = __webpack_require__(280);
	    model.paginators = __webpack_require__(281).pagination;
	    model.waiters = __webpack_require__(282).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Lambda;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.Lambda.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'invoke') {
	      request.addListener('extractData', AWS.util.convertPayloadToString);
	    }
	  }
	});



/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2014-11-11","endpointPrefix":"lambda","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","protocol":"rest-json"},"operations":{"AddEventSource":{"http":{"requestUri":"/2014-11-13/event-source-mappings/"},"input":{"type":"structure","required":["EventSource","FunctionName","Role"],"members":{"EventSource":{},"FunctionName":{},"Role":{},"BatchSize":{"type":"integer"},"Parameters":{"shape":"S6"}}},"output":{"shape":"S7"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetEventSource":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S7"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"shape":"Se"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"shape":"Sq"}},"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}}}},"ListEventSources":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSource"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSources":{"type":"list","member":{"shape":"S7"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"type":"list","member":{"shape":"Se"}}}}},"RemoveEventSource":{"http":{"method":"DELETE","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":204},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}}},"output":{"shape":"Se"}},"UploadFunction":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":201},"input":{"type":"structure","required":["FunctionName","FunctionZip","Runtime","Role","Handler","Mode"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionZip":{"shape":"Sq"},"Runtime":{"location":"querystring","locationName":"Runtime"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Mode":{"location":"querystring","locationName":"Mode"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}},"payload":"FunctionZip"},"output":{"shape":"Se"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSource":{},"FunctionName":{},"Parameters":{"shape":"S6"},"Role":{},"LastModified":{"type":"timestamp"},"IsActive":{"type":"boolean"},"Status":{}}},"Se":{"type":"structure","members":{"FunctionName":{},"FunctionARN":{},"ConfigurationId":{},"Runtime":{},"Role":{},"Handler":{},"Mode":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{"type":"timestamp"}}},"Sq":{"type":"blob","streaming":true}}}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-03-31","endpointPrefix":"lambda","protocol":"rest-json","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","uid":"lambda-2015-03-31"},"operations":{"AddLayerVersionPermission":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":201},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId","Action","Principal"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{},"Action":{},"Principal":{},"OrganizationId":{},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}},"output":{"type":"structure","members":{"Statement":{},"RevisionId":{}}}},"AddPermission":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":201},"input":{"type":"structure","required":["FunctionName","StatementId","Action","Principal"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{},"Action":{},"Principal":{},"SourceArn":{},"SourceAccount":{},"EventSourceToken":{},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{},"PrincipalOrgID":{},"FunctionUrlAuthType":{}}},"output":{"type":"structure","members":{"Statement":{}}}},"CreateAlias":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":201},"input":{"type":"structure","required":["FunctionName","Name","FunctionVersion"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sp"}}},"output":{"shape":"St"}},"CreateCodeSigningConfig":{"http":{"requestUri":"/2020-04-22/code-signing-configs/","responseCode":201},"input":{"type":"structure","required":["AllowedPublishers"],"members":{"Description":{},"AllowedPublishers":{"shape":"Sw"},"CodeSigningPolicies":{"shape":"Sy"}}},"output":{"type":"structure","required":["CodeSigningConfig"],"members":{"CodeSigningConfig":{"shape":"S11"}}}},"CreateEventSourceMapping":{"http":{"requestUri":"/2015-03-31/event-source-mappings/","responseCode":202},"input":{"type":"structure","required":["FunctionName"],"members":{"EventSourceArn":{},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"FilterCriteria":{"shape":"S18"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"},"DestinationConfig":{"shape":"S1g"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"TumblingWindowInSeconds":{"type":"integer"},"Topics":{"shape":"S1o"},"Queues":{"shape":"S1q"},"SourceAccessConfigurations":{"shape":"S1s"},"SelfManagedEventSource":{"shape":"S1w"},"FunctionResponseTypes":{"shape":"S21"}}},"output":{"shape":"S23"}},"CreateFunction":{"http":{"requestUri":"/2015-03-31/functions","responseCode":201},"input":{"type":"structure","required":["FunctionName","Role","Code"],"members":{"FunctionName":{},"Runtime":{},"Role":{},"Handler":{},"Code":{"type":"structure","members":{"ZipFile":{"shape":"S29"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ImageUri":{}}},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"Publish":{"type":"boolean"},"VpcConfig":{"shape":"S2g"},"PackageType":{},"DeadLetterConfig":{"shape":"S2m"},"Environment":{"shape":"S2o"},"KMSKeyArn":{},"TracingConfig":{"shape":"S2t"},"Tags":{"shape":"S2v"},"Layers":{"shape":"S2y"},"FileSystemConfigs":{"shape":"S30"},"ImageConfig":{"shape":"S34"},"CodeSigningConfigArn":{},"Architectures":{"shape":"S37"},"EphemeralStorage":{"shape":"S39"}}},"output":{"shape":"S3b"}},"CreateFunctionUrlConfig":{"http":{"requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":201},"input":{"type":"structure","required":["FunctionName","AuthType"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"AuthType":{},"Cors":{"shape":"S3x"}}},"output":{"type":"structure","required":["FunctionUrl","FunctionArn","AuthType","CreationTime"],"members":{"FunctionUrl":{},"FunctionArn":{},"AuthType":{},"Cors":{"shape":"S3x"},"CreationTime":{}}}},"DeleteAlias":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":204},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}}},"DeleteCodeSigningConfig":{"http":{"method":"DELETE","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}","responseCode":204},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"}}},"output":{"type":"structure","members":{}}},"DeleteEventSourceMapping":{"http":{"method":"DELETE","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S23"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionCodeSigningConfig":{"http":{"method":"DELETE","requestUri":"/2020-06-30/functions/{FunctionName}/code-signing-config","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"DeleteFunctionConcurrency":{"http":{"method":"DELETE","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"DeleteFunctionEventInvokeConfig":{"http":{"method":"DELETE","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionUrlConfig":{"http":{"method":"DELETE","requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteLayerVersion":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}}},"DeleteProvisionedConcurrencyConfig":{"http":{"method":"DELETE","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName","Qualifier"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/2016-08-19/account-settings/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountLimit":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"CodeSizeUnzipped":{"type":"long"},"CodeSizeZipped":{"type":"long"},"ConcurrentExecutions":{"type":"integer"},"UnreservedConcurrentExecutions":{"type":"integer"}}},"AccountUsage":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"FunctionCount":{"type":"long"}}}}}},"GetAlias":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"shape":"St"}},"GetCodeSigningConfig":{"http":{"method":"GET","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"}}},"output":{"type":"structure","required":["CodeSigningConfig"],"members":{"CodeSigningConfig":{"shape":"S11"}}}},"GetEventSourceMapping":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S23"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S3b"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{},"ImageUri":{},"ResolvedImageUri":{}}},"Tags":{"shape":"S2v"},"Concurrency":{"shape":"S4w"}}}},"GetFunctionCodeSigningConfig":{"http":{"method":"GET","requestUri":"/2020-06-30/functions/{FunctionName}/code-signing-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","required":["CodeSigningConfigArn","FunctionName"],"members":{"CodeSigningConfigArn":{},"FunctionName":{}}}},"GetFunctionConcurrency":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S3b"}},"GetFunctionEventInvokeConfig":{"http":{"method":"GET","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S54"}},"GetFunctionUrlConfig":{"http":{"method":"GET","requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","required":["FunctionUrl","FunctionArn","AuthType","CreationTime","LastModifiedTime"],"members":{"FunctionUrl":{},"FunctionArn":{},"AuthType":{},"Cors":{"shape":"S3x"},"CreationTime":{},"LastModifiedTime":{}}}},"GetLayerVersion":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"shape":"S5a"}},"GetLayerVersionByArn":{"http":{"method":"GET","requestUri":"/2018-10-31/layers?find=LayerVersion","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"querystring","locationName":"Arn"}}},"output":{"shape":"S5a"}},"GetLayerVersionPolicy":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetProvisionedConcurrencyConfig":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","Qualifier"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"Invoke":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Payload":{"shape":"S29"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"FunctionError":{"location":"header","locationName":"X-Amz-Function-Error"},"LogResult":{"location":"header","locationName":"X-Amz-Log-Result"},"Payload":{"shape":"S29"},"ExecutedVersion":{"location":"header","locationName":"X-Amz-Executed-Version"}},"payload":"Payload"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"type":"blob","streaming":true}},"deprecated":true,"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}},"deprecated":true},"deprecated":true},"ListAliases":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Aliases":{"type":"list","member":{"shape":"St"}}}}},"ListCodeSigningConfigs":{"http":{"method":"GET","requestUri":"/2020-04-22/code-signing-configs/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"CodeSigningConfigs":{"type":"list","member":{"shape":"S11"}}}}},"ListEventSourceMappings":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSourceArn"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSourceMappings":{"type":"list","member":{"shape":"S23"}}}}},"ListFunctionEventInvokeConfigs":{"http":{"method":"GET","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config/list","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"FunctionEventInvokeConfigs":{"type":"list","member":{"shape":"S54"}},"NextMarker":{}}}},"ListFunctionUrlConfigs":{"http":{"method":"GET","requestUri":"/2021-10-31/functions/{FunctionName}/urls","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","required":["FunctionUrlConfigs"],"members":{"FunctionUrlConfigs":{"type":"list","member":{"type":"structure","required":["FunctionUrl","FunctionArn","CreationTime","LastModifiedTime","AuthType"],"members":{"FunctionUrl":{},"FunctionArn":{},"CreationTime":{},"LastModifiedTime":{},"Cors":{"shape":"S3x"},"AuthType":{}}}},"NextMarker":{}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/","responseCode":200},"input":{"type":"structure","members":{"MasterRegion":{"location":"querystring","locationName":"MasterRegion"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"shape":"S6l"}}}},"ListFunctionsByCodeSigningConfig":{"http":{"method":"GET","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}/functions","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"FunctionArns":{"type":"list","member":{}}}}},"ListLayerVersions":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":200},"input":{"type":"structure","required":["LayerName"],"members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"LayerName":{"location":"uri","locationName":"LayerName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"CompatibleArchitecture":{"location":"querystring","locationName":"CompatibleArchitecture"}}},"output":{"type":"structure","members":{"NextMarker":{},"LayerVersions":{"type":"list","member":{"shape":"S6t"}}}}},"ListLayers":{"http":{"method":"GET","requestUri":"/2018-10-31/layers","responseCode":200},"input":{"type":"structure","members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"CompatibleArchitecture":{"location":"querystring","locationName":"CompatibleArchitecture"}}},"output":{"type":"structure","members":{"NextMarker":{},"Layers":{"type":"list","member":{"type":"structure","members":{"LayerName":{},"LayerArn":{},"LatestMatchingVersion":{"shape":"S6t"}}}}}}},"ListProvisionedConcurrencyConfigs":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency?List=ALL","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"ProvisionedConcurrencyConfigs":{"type":"list","member":{"type":"structure","members":{"FunctionArn":{},"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"NextMarker":{}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2017-03-31/tags/{ARN}"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"uri","locationName":"ARN"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2v"}}}},"ListVersionsByFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"shape":"S6l"}}}},"PublishLayerVersion":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":201},"input":{"type":"structure","required":["LayerName","Content"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"Description":{},"Content":{"type":"structure","members":{"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ZipFile":{"shape":"S29"}}},"CompatibleRuntimes":{"shape":"S5d"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S5f"}}},"output":{"type":"structure","members":{"Content":{"shape":"S5b"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S5d"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S5f"}}}},"PublishVersion":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":201},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"CodeSha256":{},"Description":{},"RevisionId":{}}},"output":{"shape":"S3b"}},"PutFunctionCodeSigningConfig":{"http":{"method":"PUT","requestUri":"/2020-06-30/functions/{FunctionName}/code-signing-config","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn","FunctionName"],"members":{"CodeSigningConfigArn":{},"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","required":["CodeSigningConfigArn","FunctionName"],"members":{"CodeSigningConfigArn":{},"FunctionName":{}}}},"PutFunctionConcurrency":{"http":{"method":"PUT","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","ReservedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ReservedConcurrentExecutions":{"type":"integer"}}},"output":{"shape":"S4w"}},"PutFunctionEventInvokeConfig":{"http":{"method":"PUT","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"}}},"output":{"shape":"S54"}},"PutProvisionedConcurrencyConfig":{"http":{"method":"PUT","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":202},"input":{"type":"structure","required":["FunctionName","Qualifier","ProvisionedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"ProvisionedConcurrentExecutions":{"type":"integer"}}},"output":{"type":"structure","members":{"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"RemoveLayerVersionPermission":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{"location":"uri","locationName":"StatementId"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["FunctionName","StatementId"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{"location":"uri","locationName":"StatementId"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"TagResource":{"http":{"requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"Tags":{"shape":"S2v"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAlias":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sp"},"RevisionId":{}}},"output":{"shape":"St"}},"UpdateCodeSigningConfig":{"http":{"method":"PUT","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"},"Description":{},"AllowedPublishers":{"shape":"Sw"},"CodeSigningPolicies":{"shape":"Sy"}}},"output":{"type":"structure","required":["CodeSigningConfig"],"members":{"CodeSigningConfig":{"shape":"S11"}}}},"UpdateEventSourceMapping":{"http":{"method":"PUT","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"FilterCriteria":{"shape":"S18"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"SourceAccessConfigurations":{"shape":"S1s"},"TumblingWindowInSeconds":{"type":"integer"},"FunctionResponseTypes":{"shape":"S21"}}},"output":{"shape":"S23"}},"UpdateFunctionCode":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/code","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ZipFile":{"shape":"S29"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ImageUri":{},"Publish":{"type":"boolean"},"DryRun":{"type":"boolean"},"RevisionId":{},"Architectures":{"shape":"S37"}}},"output":{"shape":"S3b"}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{},"Handler":{},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"VpcConfig":{"shape":"S2g"},"Environment":{"shape":"S2o"},"Runtime":{},"DeadLetterConfig":{"shape":"S2m"},"KMSKeyArn":{},"TracingConfig":{"shape":"S2t"},"RevisionId":{},"Layers":{"shape":"S2y"},"FileSystemConfigs":{"shape":"S30"},"ImageConfig":{"shape":"S34"},"EphemeralStorage":{"shape":"S39"}}},"output":{"shape":"S3b"}},"UpdateFunctionEventInvokeConfig":{"http":{"requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"}}},"output":{"shape":"S54"}},"UpdateFunctionUrlConfig":{"http":{"method":"PUT","requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"AuthType":{},"Cors":{"shape":"S3x"}}},"output":{"type":"structure","required":["FunctionUrl","FunctionArn","AuthType","CreationTime","LastModifiedTime"],"members":{"FunctionUrl":{},"FunctionArn":{},"AuthType":{},"Cors":{"shape":"S3x"},"CreationTime":{},"LastModifiedTime":{}}}}},"shapes":{"Sp":{"type":"structure","members":{"AdditionalVersionWeights":{"type":"map","key":{},"value":{"type":"double"}}}},"St":{"type":"structure","members":{"AliasArn":{},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sp"},"RevisionId":{}}},"Sw":{"type":"structure","required":["SigningProfileVersionArns"],"members":{"SigningProfileVersionArns":{"type":"list","member":{}}}},"Sy":{"type":"structure","members":{"UntrustedArtifactOnDeployment":{}}},"S11":{"type":"structure","required":["CodeSigningConfigId","CodeSigningConfigArn","AllowedPublishers","CodeSigningPolicies","LastModified"],"members":{"CodeSigningConfigId":{},"CodeSigningConfigArn":{},"Description":{},"AllowedPublishers":{"shape":"Sw"},"CodeSigningPolicies":{"shape":"Sy"},"LastModified":{}}},"S18":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Pattern":{}}}}}},"S1g":{"type":"structure","members":{"OnSuccess":{"type":"structure","members":{"Destination":{}}},"OnFailure":{"type":"structure","members":{"Destination":{}}}}},"S1o":{"type":"list","member":{}},"S1q":{"type":"list","member":{}},"S1s":{"type":"list","member":{"type":"structure","members":{"Type":{},"URI":{}}}},"S1w":{"type":"structure","members":{"Endpoints":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"S21":{"type":"list","member":{}},"S23":{"type":"structure","members":{"UUID":{},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"},"BatchSize":{"type":"integer"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"EventSourceArn":{},"FilterCriteria":{"shape":"S18"},"FunctionArn":{},"LastModified":{"type":"timestamp"},"LastProcessingResult":{},"State":{},"StateTransitionReason":{},"DestinationConfig":{"shape":"S1g"},"Topics":{"shape":"S1o"},"Queues":{"shape":"S1q"},"SourceAccessConfigurations":{"shape":"S1s"},"SelfManagedEventSource":{"shape":"S1w"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"TumblingWindowInSeconds":{"type":"integer"},"FunctionResponseTypes":{"shape":"S21"}}},"S29":{"type":"blob","sensitive":true},"S2g":{"type":"structure","members":{"SubnetIds":{"shape":"S2h"},"SecurityGroupIds":{"shape":"S2j"}}},"S2h":{"type":"list","member":{}},"S2j":{"type":"list","member":{}},"S2m":{"type":"structure","members":{"TargetArn":{}}},"S2o":{"type":"structure","members":{"Variables":{"shape":"S2p"}}},"S2p":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true},"sensitive":true},"S2t":{"type":"structure","members":{"Mode":{}}},"S2v":{"type":"map","key":{},"value":{}},"S2y":{"type":"list","member":{}},"S30":{"type":"list","member":{"type":"structure","required":["Arn","LocalMountPath"],"members":{"Arn":{},"LocalMountPath":{}}}},"S34":{"type":"structure","members":{"EntryPoint":{"shape":"S35"},"Command":{"shape":"S35"},"WorkingDirectory":{}}},"S35":{"type":"list","member":{}},"S37":{"type":"list","member":{}},"S39":{"type":"structure","required":["Size"],"members":{"Size":{"type":"integer"}}},"S3b":{"type":"structure","members":{"FunctionName":{},"FunctionArn":{},"Runtime":{},"Role":{},"Handler":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{},"CodeSha256":{},"Version":{},"VpcConfig":{"type":"structure","members":{"SubnetIds":{"shape":"S2h"},"SecurityGroupIds":{"shape":"S2j"},"VpcId":{}}},"DeadLetterConfig":{"shape":"S2m"},"Environment":{"type":"structure","members":{"Variables":{"shape":"S2p"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"shape":"S3j"}}}}},"KMSKeyArn":{},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"MasterArn":{},"RevisionId":{},"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CodeSize":{"type":"long"},"SigningProfileVersionArn":{},"SigningJobArn":{}}}},"State":{},"StateReason":{},"StateReasonCode":{},"LastUpdateStatus":{},"LastUpdateStatusReason":{},"LastUpdateStatusReasonCode":{},"FileSystemConfigs":{"shape":"S30"},"PackageType":{},"ImageConfigResponse":{"type":"structure","members":{"ImageConfig":{"shape":"S34"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"shape":"S3j"}}}}},"SigningProfileVersionArn":{},"SigningJobArn":{},"Architectures":{"shape":"S37"},"EphemeralStorage":{"shape":"S39"}}},"S3j":{"type":"string","sensitive":true},"S3x":{"type":"structure","members":{"AllowCredentials":{"type":"boolean"},"AllowHeaders":{"shape":"S3z"},"AllowMethods":{"type":"list","member":{}},"AllowOrigins":{"type":"list","member":{}},"ExposeHeaders":{"shape":"S3z"},"MaxAge":{"type":"integer"}}},"S3z":{"type":"list","member":{}},"S4w":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}},"S54":{"type":"structure","members":{"LastModified":{"type":"timestamp"},"FunctionArn":{},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"}}},"S5a":{"type":"structure","members":{"Content":{"shape":"S5b"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S5d"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S5f"}}},"S5b":{"type":"structure","members":{"Location":{},"CodeSha256":{},"CodeSize":{"type":"long"},"SigningProfileVersionArn":{},"SigningJobArn":{}}},"S5d":{"type":"list","member":{}},"S5f":{"type":"list","member":{}},"S6l":{"type":"list","member":{"shape":"S3b"}},"S6t":{"type":"structure","members":{"LayerVersionArn":{},"Version":{"type":"long"},"Description":{},"CreatedDate":{},"CompatibleRuntimes":{"shape":"S5d"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S5f"}}}}}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Aliases"},"ListCodeSigningConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"CodeSigningConfigs"},"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctionEventInvokeConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionEventInvokeConfigs"},"ListFunctionUrlConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionUrlConfigs"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"},"ListFunctionsByCodeSigningConfig":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionArns"},"ListLayerVersions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"LayerVersions"},"ListLayers":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Layers"},"ListProvisionedConcurrencyConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"ProvisionedConcurrencyConfigs"},"ListVersionsByFunction":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Versions"}}}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"FunctionExists":{"delay":1,"operation":"GetFunction","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]},"FunctionActive":{"delay":5,"maxAttempts":60,"operation":"GetFunctionConfiguration","description":"Waits for the function's State to be Active. This waiter uses GetFunctionConfiguration API. This should be used after new function creation.","acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"Active"},{"state":"failure","matcher":"path","argument":"State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"State","expected":"Pending"}]},"FunctionUpdated":{"delay":5,"maxAttempts":60,"operation":"GetFunctionConfiguration","description":"Waits for the function's LastUpdateStatus to be Successful. This waiter uses GetFunctionConfiguration API. This should be used after function updates.","acceptors":[{"state":"success","matcher":"path","argument":"LastUpdateStatus","expected":"Successful"},{"state":"failure","matcher":"path","argument":"LastUpdateStatus","expected":"Failed"},{"state":"retry","matcher":"path","argument":"LastUpdateStatus","expected":"InProgress"}]},"FunctionActiveV2":{"delay":1,"maxAttempts":300,"operation":"GetFunction","description":"Waits for the function's State to be Active. This waiter uses GetFunction API. This should be used after new function creation.","acceptors":[{"state":"success","matcher":"path","argument":"Configuration.State","expected":"Active"},{"state":"failure","matcher":"path","argument":"Configuration.State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"Configuration.State","expected":"Pending"}]},"FunctionUpdatedV2":{"delay":1,"maxAttempts":300,"operation":"GetFunction","description":"Waits for the function's LastUpdateStatus to be Successful. This waiter uses GetFunction API. This should be used after function updates.","acceptors":[{"state":"success","matcher":"path","argument":"Configuration.LastUpdateStatus","expected":"Successful"},{"state":"failure","matcher":"path","argument":"Configuration.LastUpdateStatus","expected":"Failed"},{"state":"retry","matcher":"path","argument":"Configuration.LastUpdateStatus","expected":"InProgress"}]}}}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lexruntime'] = {};
	AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
	  get: function get() {
	    var model = __webpack_require__(284);
	    model.paginators = __webpack_require__(285).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LexRuntime;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"runtime.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Runtime Service","serviceId":"Lex Runtime Service","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex-2016-11-28"},"operations":{"DeleteSession":{"http":{"method":"DELETE","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"botName":{},"botAlias":{},"userId":{},"sessionId":{}}}},"GetSession":{"http":{"method":"GET","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session/"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"checkpointLabelFilter":{"location":"querystring","locationName":"checkpointLabelFilter"}}},"output":{"type":"structure","members":{"recentIntentSummaryView":{"shape":"Sa"},"sessionAttributes":{"shape":"Sd"},"sessionId":{},"dialogAction":{"shape":"Sh"},"activeContexts":{"shape":"Sk"}}}},"PostContent":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/content"},"input":{"type":"structure","required":["botName","botAlias","userId","contentType","inputStream"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"St","jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"requestAttributes":{"shape":"St","jsonvalue":true,"location":"header","locationName":"x-amz-lex-request-attributes"},"contentType":{"location":"header","locationName":"Content-Type"},"accept":{"location":"header","locationName":"Accept"},"inputStream":{"shape":"Sw"},"activeContexts":{"shape":"Sx","jsonvalue":true,"location":"header","locationName":"x-amz-lex-active-contexts"}},"payload":"inputStream"},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"nluIntentConfidence":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-nlu-intent-confidence"},"alternativeIntents":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-alternative-intents"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"sentimentResponse":{"location":"header","locationName":"x-amz-lex-sentiment"},"message":{"shape":"Si","deprecated":true,"deprecatedMessage":"The message field is deprecated, use the encodedMessage field instead. The message field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.","location":"header","locationName":"x-amz-lex-message"},"encodedMessage":{"shape":"Sz","location":"header","locationName":"x-amz-lex-encoded-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"inputTranscript":{"deprecated":true,"deprecatedMessage":"The inputTranscript field is deprecated, use the encodedInputTranscript field instead. The inputTranscript field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.","location":"header","locationName":"x-amz-lex-input-transcript"},"encodedInputTranscript":{"location":"header","locationName":"x-amz-lex-encoded-input-transcript","type":"string","sensitive":true},"audioStream":{"shape":"Sw"},"botVersion":{"location":"header","locationName":"x-amz-lex-bot-version"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"activeContexts":{"shape":"Sx","jsonvalue":true,"location":"header","locationName":"x-amz-lex-active-contexts"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"},"PostText":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/text"},"input":{"type":"structure","required":["botName","botAlias","userId","inputText"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sd"},"requestAttributes":{"shape":"Sd"},"inputText":{"shape":"Si"},"activeContexts":{"shape":"Sk"}}},"output":{"type":"structure","members":{"intentName":{},"nluIntentConfidence":{"shape":"S15"},"alternativeIntents":{"type":"list","member":{"type":"structure","members":{"intentName":{},"nluIntentConfidence":{"shape":"S15"},"slots":{"shape":"Sd"}}}},"slots":{"shape":"Sd"},"sessionAttributes":{"shape":"Sd"},"message":{"shape":"Si"},"sentimentResponse":{"type":"structure","members":{"sentimentLabel":{},"sentimentScore":{}}},"messageFormat":{},"dialogState":{},"slotToElicit":{},"responseCard":{"type":"structure","members":{"version":{},"contentType":{},"genericAttachments":{"type":"list","member":{"type":"structure","members":{"title":{},"subTitle":{},"attachmentLinkUrl":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}},"sessionId":{},"botVersion":{},"activeContexts":{"shape":"Sk"}}}},"PutSession":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sd"},"dialogAction":{"shape":"Sh"},"recentIntentSummaryView":{"shape":"Sa"},"accept":{"location":"header","locationName":"Accept"},"activeContexts":{"shape":"Sk"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Si","deprecated":true,"deprecatedMessage":"The message field is deprecated, use the encodedMessage field instead. The message field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.","location":"header","locationName":"x-amz-lex-message"},"encodedMessage":{"shape":"Sz","location":"header","locationName":"x-amz-lex-encoded-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"audioStream":{"shape":"Sw"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"activeContexts":{"shape":"Sx","jsonvalue":true,"location":"header","locationName":"x-amz-lex-active-contexts"}},"payload":"audioStream"}}},"shapes":{"Sa":{"type":"list","member":{"type":"structure","required":["dialogActionType"],"members":{"intentName":{},"checkpointLabel":{},"slots":{"shape":"Sd"},"confirmationStatus":{},"dialogActionType":{},"fulfillmentState":{},"slotToElicit":{}}}},"Sd":{"type":"map","key":{},"value":{},"sensitive":true},"Sh":{"type":"structure","required":["type"],"members":{"type":{},"intentName":{},"slots":{"shape":"Sd"},"slotToElicit":{},"fulfillmentState":{},"message":{"shape":"Si"},"messageFormat":{}}},"Si":{"type":"string","sensitive":true},"Sk":{"type":"list","member":{"type":"structure","required":["name","timeToLive","parameters"],"members":{"name":{},"timeToLive":{"type":"structure","members":{"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}},"parameters":{"type":"map","key":{},"value":{"shape":"Si"}}}},"sensitive":true},"St":{"type":"string","sensitive":true},"Sw":{"type":"blob","streaming":true},"Sx":{"type":"string","sensitive":true},"Sz":{"type":"string","sensitive":true},"S15":{"type":"structure","members":{"score":{"type":"double"}}}}}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lightsail'] = {};
	AWS.Lightsail = Service.defineService('lightsail', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['lightsail'], '2016-11-28', {
	  get: function get() {
	    var model = __webpack_require__(287);
	    model.paginators = __webpack_require__(288).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Lightsail;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"lightsail","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Lightsail","serviceId":"Lightsail","signatureVersion":"v4","targetPrefix":"Lightsail_20161128","uid":"lightsail-2016-11-28"},"operations":{"AllocateStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachCertificateToDistribution":{"input":{"type":"structure","required":["distributionName","certificateName"],"members":{"distributionName":{},"certificateName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"AttachDisk":{"input":{"type":"structure","required":["diskName","instanceName","diskPath"],"members":{"diskName":{},"instanceName":{},"diskPath":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachInstancesToLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName","instanceNames"],"members":{"loadBalancerName":{},"instanceNames":{"shape":"Sk"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachLoadBalancerTlsCertificate":{"input":{"type":"structure","required":["loadBalancerName","certificateName"],"members":{"loadBalancerName":{},"certificateName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachStaticIp":{"input":{"type":"structure","required":["staticIpName","instanceName"],"members":{"staticIpName":{},"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CloseInstancePublicPorts":{"input":{"type":"structure","required":["portInfo","instanceName"],"members":{"portInfo":{"shape":"Sr"},"instanceName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"CopySnapshot":{"input":{"type":"structure","required":["targetSnapshotName","sourceRegion"],"members":{"sourceSnapshotName":{},"sourceResourceName":{},"restoreDate":{},"useLatestRestorableAutoSnapshot":{"type":"boolean"},"targetSnapshotName":{},"sourceRegion":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateBucket":{"input":{"type":"structure","required":["bucketName","bundleId"],"members":{"bucketName":{},"bundleId":{},"tags":{"shape":"S10"},"enableObjectVersioning":{"type":"boolean"}}},"output":{"type":"structure","members":{"bucket":{"shape":"S15"},"operations":{"shape":"S4"}}}},"CreateBucketAccessKey":{"input":{"type":"structure","required":["bucketName"],"members":{"bucketName":{}}},"output":{"type":"structure","members":{"accessKey":{"shape":"S1g"},"operations":{"shape":"S4"}}}},"CreateCertificate":{"input":{"type":"structure","required":["certificateName","domainName"],"members":{"certificateName":{},"domainName":{},"subjectAlternativeNames":{"shape":"S1n"},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"certificate":{"shape":"S1p"},"operations":{"shape":"S4"}}}},"CreateCloudFormationStack":{"input":{"type":"structure","required":["instances"],"members":{"instances":{"type":"list","member":{"type":"structure","required":["sourceName","instanceType","portInfoSource","availabilityZone"],"members":{"sourceName":{},"instanceType":{},"portInfoSource":{},"userData":{},"availabilityZone":{}}}}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateContactMethod":{"input":{"type":"structure","required":["protocol","contactEndpoint"],"members":{"protocol":{},"contactEndpoint":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateContainerService":{"input":{"type":"structure","required":["serviceName","power","scale"],"members":{"serviceName":{},"power":{},"scale":{"type":"integer"},"tags":{"shape":"S10"},"publicDomainNames":{"shape":"S2i"},"deployment":{"type":"structure","members":{"containers":{"shape":"S2l"},"publicEndpoint":{"shape":"S2r"}}}}},"output":{"type":"structure","members":{"containerService":{"shape":"S2v"}}}},"CreateContainerServiceDeployment":{"input":{"type":"structure","required":["serviceName"],"members":{"serviceName":{},"containers":{"shape":"S2l"},"publicEndpoint":{"shape":"S2r"}}},"output":{"type":"structure","members":{"containerService":{"shape":"S2v"}}}},"CreateContainerServiceRegistryLogin":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryLogin":{"type":"structure","members":{"username":{},"password":{},"expiresAt":{"type":"timestamp"},"registry":{}}}}}},"CreateDisk":{"input":{"type":"structure","required":["diskName","availabilityZone","sizeInGb"],"members":{"diskName":{},"availabilityZone":{},"sizeInGb":{"type":"integer"},"tags":{"shape":"S10"},"addOns":{"shape":"S38"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDiskFromSnapshot":{"input":{"type":"structure","required":["diskName","availabilityZone","sizeInGb"],"members":{"diskName":{},"diskSnapshotName":{},"availabilityZone":{},"sizeInGb":{"type":"integer"},"tags":{"shape":"S10"},"addOns":{"shape":"S38"},"sourceDiskName":{},"restoreDate":{},"useLatestRestorableAutoSnapshot":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDiskSnapshot":{"input":{"type":"structure","required":["diskSnapshotName"],"members":{"diskName":{},"diskSnapshotName":{},"instanceName":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDistribution":{"input":{"type":"structure","required":["distributionName","origin","defaultCacheBehavior","bundleId"],"members":{"distributionName":{},"origin":{"shape":"S3j"},"defaultCacheBehavior":{"shape":"S3l"},"cacheBehaviorSettings":{"shape":"S3n"},"cacheBehaviors":{"shape":"S3v"},"bundleId":{},"ipAddressType":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"distribution":{"shape":"S3z"},"operation":{"shape":"S5"}}}},"CreateDomain":{"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"CreateDomainEntry":{"input":{"type":"structure","required":["domainName","domainEntry"],"members":{"domainName":{},"domainEntry":{"shape":"S44"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"CreateInstanceSnapshot":{"input":{"type":"structure","required":["instanceSnapshotName","instanceName"],"members":{"instanceSnapshotName":{},"instanceName":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateInstances":{"input":{"type":"structure","required":["instanceNames","availabilityZone","blueprintId","bundleId"],"members":{"instanceNames":{"shape":"Su"},"availabilityZone":{},"customImageName":{"deprecated":true},"blueprintId":{},"bundleId":{},"userData":{},"keyPairName":{},"tags":{"shape":"S10"},"addOns":{"shape":"S38"},"ipAddressType":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateInstancesFromSnapshot":{"input":{"type":"structure","required":["instanceNames","availabilityZone","bundleId"],"members":{"instanceNames":{"shape":"Su"},"attachedDiskMapping":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"originalDiskPath":{},"newDiskName":{}}}}},"availabilityZone":{},"instanceSnapshotName":{},"bundleId":{},"userData":{},"keyPairName":{},"tags":{"shape":"S10"},"addOns":{"shape":"S38"},"ipAddressType":{},"sourceInstanceName":{},"restoreDate":{},"useLatestRestorableAutoSnapshot":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["keyPairName"],"members":{"keyPairName":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"keyPair":{"shape":"S4k"},"publicKeyBase64":{},"privateKeyBase64":{},"operation":{"shape":"S5"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName","instancePort"],"members":{"loadBalancerName":{},"instancePort":{"type":"integer"},"healthCheckPath":{},"certificateName":{},"certificateDomainName":{},"certificateAlternativeNames":{"shape":"S4n"},"tags":{"shape":"S10"},"ipAddressType":{},"tlsPolicyName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateLoadBalancerTlsCertificate":{"input":{"type":"structure","required":["loadBalancerName","certificateName","certificateDomainName"],"members":{"loadBalancerName":{},"certificateName":{},"certificateDomainName":{},"certificateAlternativeNames":{"shape":"S4n"},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName","relationalDatabaseBlueprintId","relationalDatabaseBundleId","masterDatabaseName","masterUsername"],"members":{"relationalDatabaseName":{},"availabilityZone":{},"relationalDatabaseBlueprintId":{},"relationalDatabaseBundleId":{},"masterDatabaseName":{},"masterUsername":{},"masterUserPassword":{"shape":"S4s"},"preferredBackupWindow":{},"preferredMaintenanceWindow":{},"publiclyAccessible":{"type":"boolean"},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateRelationalDatabaseFromSnapshot":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"availabilityZone":{},"publiclyAccessible":{"type":"boolean"},"relationalDatabaseSnapshotName":{},"relationalDatabaseBundleId":{},"sourceRelationalDatabaseName":{},"restoreTime":{"type":"timestamp"},"useLatestRestorableTime":{"type":"boolean"},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateRelationalDatabaseSnapshot":{"input":{"type":"structure","required":["relationalDatabaseName","relationalDatabaseSnapshotName"],"members":{"relationalDatabaseName":{},"relationalDatabaseSnapshotName":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteAlarm":{"input":{"type":"structure","required":["alarmName"],"members":{"alarmName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteAutoSnapshot":{"input":{"type":"structure","required":["resourceName","date"],"members":{"resourceName":{},"date":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteBucket":{"input":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"forceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteBucketAccessKey":{"input":{"type":"structure","required":["bucketName","accessKeyId"],"members":{"bucketName":{},"accessKeyId":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["certificateName"],"members":{"certificateName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteContactMethod":{"input":{"type":"structure","required":["protocol"],"members":{"protocol":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteContainerImage":{"input":{"type":"structure","required":["serviceName","image"],"members":{"serviceName":{},"image":{}}},"output":{"type":"structure","members":{}}},"DeleteContainerService":{"input":{"type":"structure","required":["serviceName"],"members":{"serviceName":{}}},"output":{"type":"structure","members":{}}},"DeleteDisk":{"input":{"type":"structure","required":["diskName"],"members":{"diskName":{},"forceDeleteAddOns":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteDiskSnapshot":{"input":{"type":"structure","required":["diskSnapshotName"],"members":{"diskSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteDistribution":{"input":{"type":"structure","members":{"distributionName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteDomain":{"input":{"type":"structure","required":["domainName"],"members":{"domainName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteDomainEntry":{"input":{"type":"structure","required":["domainName","domainEntry"],"members":{"domainName":{},"domainEntry":{"shape":"S44"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"forceDeleteAddOns":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteInstanceSnapshot":{"input":{"type":"structure","required":["instanceSnapshotName"],"members":{"instanceSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteKeyPair":{"input":{"type":"structure","required":["keyPairName"],"members":{"keyPairName":{},"expectedFingerprint":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteKnownHostKeys":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName"],"members":{"loadBalancerName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteLoadBalancerTlsCertificate":{"input":{"type":"structure","required":["loadBalancerName","certificateName"],"members":{"loadBalancerName":{},"certificateName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"skipFinalSnapshot":{"type":"boolean"},"finalRelationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteRelationalDatabaseSnapshot":{"input":{"type":"structure","required":["relationalDatabaseSnapshotName"],"members":{"relationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DetachCertificateFromDistribution":{"input":{"type":"structure","required":["distributionName"],"members":{"distributionName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DetachDisk":{"input":{"type":"structure","required":["diskName"],"members":{"diskName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DetachInstancesFromLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName","instanceNames"],"members":{"loadBalancerName":{},"instanceNames":{"shape":"Sk"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DetachStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DisableAddOn":{"input":{"type":"structure","required":["addOnType","resourceName"],"members":{"addOnType":{},"resourceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DownloadDefaultKeyPair":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"publicKeyBase64":{},"privateKeyBase64":{},"createdAt":{"type":"timestamp"}}}},"EnableAddOn":{"input":{"type":"structure","required":["resourceName","addOnRequest"],"members":{"resourceName":{},"addOnRequest":{"shape":"S39"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"ExportSnapshot":{"input":{"type":"structure","required":["sourceSnapshotName"],"members":{"sourceSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"GetActiveNames":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"activeNames":{"shape":"Su"},"nextPageToken":{}}}},"GetAlarms":{"input":{"type":"structure","members":{"alarmName":{},"pageToken":{},"monitoredResourceName":{}}},"output":{"type":"structure","members":{"alarms":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"supportCode":{},"monitoredResourceInfo":{"type":"structure","members":{"arn":{},"name":{},"resourceType":{}}},"comparisonOperator":{},"evaluationPeriods":{"type":"integer"},"period":{"type":"integer"},"threshold":{"type":"double"},"datapointsToAlarm":{"type":"integer"},"treatMissingData":{},"statistic":{},"metricName":{},"state":{},"unit":{},"contactProtocols":{"shape":"S71"},"notificationTriggers":{"shape":"S72"},"notificationEnabled":{"type":"boolean"}}}},"nextPageToken":{}}}},"GetAutoSnapshots":{"input":{"type":"structure","required":["resourceName"],"members":{"resourceName":{}}},"output":{"type":"structure","members":{"resourceName":{},"resourceType":{},"autoSnapshots":{"type":"list","member":{"type":"structure","members":{"date":{},"createdAt":{"type":"timestamp"},"status":{},"fromAttachedDisks":{"type":"list","member":{"type":"structure","members":{"path":{},"sizeInGb":{"type":"integer"}}}}}}}}}},"GetBlueprints":{"input":{"type":"structure","members":{"includeInactive":{"type":"boolean"},"pageToken":{}}},"output":{"type":"structure","members":{"blueprints":{"type":"list","member":{"type":"structure","members":{"blueprintId":{},"name":{},"group":{},"type":{},"description":{},"isActive":{"type":"boolean"},"minPower":{"type":"integer"},"version":{},"versionCode":{},"productUrl":{},"licenseUrl":{},"platform":{}}}},"nextPageToken":{}}}},"GetBucketAccessKeys":{"input":{"type":"structure","required":["bucketName"],"members":{"bucketName":{}}},"output":{"type":"structure","members":{"accessKeys":{"type":"list","member":{"shape":"S1g"}}}}},"GetBucketBundles":{"input":{"type":"structure","members":{"includeInactive":{"type":"boolean"}}},"output":{"type":"structure","members":{"bundles":{"type":"list","member":{"type":"structure","members":{"bundleId":{},"name":{},"price":{"type":"float"},"storagePerMonthInGb":{"type":"integer"},"transferPerMonthInGb":{"type":"integer"},"isActive":{"type":"boolean"}}}}}}},"GetBucketMetricData":{"input":{"type":"structure","required":["bucketName","metricName","startTime","endTime","period","statistics","unit"],"members":{"bucketName":{},"metricName":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"period":{"type":"integer"},"statistics":{"shape":"S7q"},"unit":{}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S7s"}}}},"GetBuckets":{"input":{"type":"structure","members":{"bucketName":{},"pageToken":{},"includeConnectedResources":{"type":"boolean"}}},"output":{"type":"structure","members":{"buckets":{"type":"list","member":{"shape":"S15"}},"nextPageToken":{},"accountLevelBpaSync":{"type":"structure","members":{"status":{},"lastSyncedAt":{"type":"timestamp"},"message":{},"bpaImpactsLightsail":{"type":"boolean"}}}}}},"GetBundles":{"input":{"type":"structure","members":{"includeInactive":{"type":"boolean"},"pageToken":{}}},"output":{"type":"structure","members":{"bundles":{"type":"list","member":{"type":"structure","members":{"price":{"type":"float"},"cpuCount":{"type":"integer"},"diskSizeInGb":{"type":"integer"},"bundleId":{},"instanceType":{},"isActive":{"type":"boolean"},"name":{},"power":{"type":"integer"},"ramSizeInGb":{"type":"float"},"transferPerMonthInGb":{"type":"integer"},"supportedPlatforms":{"type":"list","member":{}}}}},"nextPageToken":{}}}},"GetCertificates":{"input":{"type":"structure","members":{"certificateStatuses":{"type":"list","member":{}},"includeCertificateDetails":{"type":"boolean"},"certificateName":{}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"shape":"S1p"}}}}},"GetCloudFormationStackRecords":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"cloudFormationStackRecords":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"state":{},"sourceInfo":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"name":{},"arn":{}}}},"destinationInfo":{"shape":"S8j"}}}},"nextPageToken":{}}}},"GetContactMethods":{"input":{"type":"structure","members":{"protocols":{"shape":"S71"}}},"output":{"type":"structure","members":{"contactMethods":{"type":"list","member":{"type":"structure","members":{"contactEndpoint":{},"status":{},"protocol":{},"name":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"supportCode":{}}}}}}},"GetContainerAPIMetadata":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"metadata":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}},"GetContainerImages":{"input":{"type":"structure","required":["serviceName"],"members":{"serviceName":{}}},"output":{"type":"structure","members":{"containerImages":{"type":"list","member":{"shape":"S8w"}}}}},"GetContainerLog":{"input":{"type":"structure","required":["serviceName","containerName"],"members":{"serviceName":{},"containerName":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"filterPattern":{},"pageToken":{}}},"output":{"type":"structure","members":{"logEvents":{"type":"list","member":{"type":"structure","members":{"createdAt":{"type":"timestamp"},"message":{}}}},"nextPageToken":{}}}},"GetContainerServiceDeployments":{"input":{"type":"structure","required":["serviceName"],"members":{"serviceName":{}}},"output":{"type":"structure","members":{"deployments":{"type":"list","member":{"shape":"S2z"}}}}},"GetContainerServiceMetricData":{"input":{"type":"structure","required":["serviceName","metricName","startTime","endTime","period","statistics"],"members":{"serviceName":{},"metricName":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"period":{"type":"integer"},"statistics":{"shape":"S7q"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S7s"}}}},"GetContainerServicePowers":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"powers":{"type":"list","member":{"type":"structure","members":{"powerId":{},"price":{"type":"float"},"cpuCount":{"type":"float"},"ramSizeInGb":{"type":"float"},"name":{},"isActive":{"type":"boolean"}}}}}}},"GetContainerServices":{"input":{"type":"structure","members":{"serviceName":{}}},"output":{"type":"structure","members":{"containerServices":{"type":"list","member":{"shape":"S2v"}}}}},"GetDisk":{"input":{"type":"structure","required":["diskName"],"members":{"diskName":{}}},"output":{"type":"structure","members":{"disk":{"shape":"S9g"}}}},"GetDiskSnapshot":{"input":{"type":"structure","required":["diskSnapshotName"],"members":{"diskSnapshotName":{}}},"output":{"type":"structure","members":{"diskSnapshot":{"shape":"S9m"}}}},"GetDiskSnapshots":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"diskSnapshots":{"type":"list","member":{"shape":"S9m"}},"nextPageToken":{}}}},"GetDisks":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"disks":{"shape":"S9t"},"nextPageToken":{}}}},"GetDistributionBundles":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"bundles":{"type":"list","member":{"type":"structure","members":{"bundleId":{},"name":{},"price":{"type":"float"},"transferPerMonthInGb":{"type":"integer"},"isActive":{"type":"boolean"}}}}}}},"GetDistributionLatestCacheReset":{"input":{"type":"structure","members":{"distributionName":{}}},"output":{"type":"structure","members":{"status":{},"createTime":{"type":"timestamp"}}}},"GetDistributionMetricData":{"input":{"type":"structure","required":["distributionName","metricName","startTime","endTime","period","unit","statistics"],"members":{"distributionName":{},"metricName":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"period":{"type":"integer"},"unit":{},"statistics":{"shape":"S7q"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S7s"}}}},"GetDistributions":{"input":{"type":"structure","members":{"distributionName":{},"pageToken":{}}},"output":{"type":"structure","members":{"distributions":{"type":"list","member":{"shape":"S3z"}},"nextPageToken":{}}}},"GetDomain":{"input":{"type":"structure","required":["domainName"],"members":{"domainName":{}}},"output":{"type":"structure","members":{"domain":{"shape":"Sa8"}}}},"GetDomains":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"domains":{"type":"list","member":{"shape":"Sa8"}},"nextPageToken":{}}}},"GetExportSnapshotRecords":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"exportSnapshotRecords":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"state":{},"sourceInfo":{"type":"structure","members":{"resourceType":{},"createdAt":{"type":"timestamp"},"name":{},"arn":{},"fromResourceName":{},"fromResourceArn":{},"instanceSnapshotInfo":{"type":"structure","members":{"fromBundleId":{},"fromBlueprintId":{},"fromDiskInfo":{"type":"list","member":{"type":"structure","members":{"name":{},"path":{},"sizeInGb":{"type":"integer"},"isSystemDisk":{"type":"boolean"}}}}}},"diskSnapshotInfo":{"type":"structure","members":{"sizeInGb":{"type":"integer"}}}}},"destinationInfo":{"shape":"S8j"}}}},"nextPageToken":{}}}},"GetInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instance":{"shape":"Sap"}}}},"GetInstanceAccessDetails":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"protocol":{}}},"output":{"type":"structure","members":{"accessDetails":{"type":"structure","members":{"certKey":{},"expiresAt":{"type":"timestamp"},"ipAddress":{},"password":{},"passwordData":{"type":"structure","members":{"ciphertext":{},"keyPairName":{}}},"privateKey":{},"protocol":{},"instanceName":{},"username":{},"hostKeys":{"type":"list","member":{"type":"structure","members":{"algorithm":{},"publicKey":{},"witnessedAt":{"type":"timestamp"},"fingerprintSHA1":{},"fingerprintSHA256":{},"notValidBefore":{"type":"timestamp"},"notValidAfter":{"type":"timestamp"}}}}}}}}},"GetInstanceMetricData":{"input":{"type":"structure","required":["instanceName","metricName","period","startTime","endTime","unit","statistics"],"members":{"instanceName":{},"metricName":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"unit":{},"statistics":{"shape":"S7q"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S7s"}}}},"GetInstancePortStates":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"portStates":{"type":"list","member":{"type":"structure","members":{"fromPort":{"type":"integer"},"toPort":{"type":"integer"},"protocol":{},"state":{},"cidrs":{"shape":"Su"},"ipv6Cidrs":{"shape":"Su"},"cidrListAliases":{"shape":"Su"}}}}}}},"GetInstanceSnapshot":{"input":{"type":"structure","required":["instanceSnapshotName"],"members":{"instanceSnapshotName":{}}},"output":{"type":"structure","members":{"instanceSnapshot":{"shape":"Sbi"}}}},"GetInstanceSnapshots":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"instanceSnapshots":{"type":"list","member":{"shape":"Sbi"}},"nextPageToken":{}}}},"GetInstanceState":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"state":{"shape":"Sb0"}}}},"GetInstances":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"instances":{"type":"list","member":{"shape":"Sap"}},"nextPageToken":{}}}},"GetKeyPair":{"input":{"type":"structure","required":["keyPairName"],"members":{"keyPairName":{}}},"output":{"type":"structure","members":{"keyPair":{"shape":"S4k"}}}},"GetKeyPairs":{"input":{"type":"structure","members":{"pageToken":{},"includeDefaultKeyPair":{"type":"boolean"}}},"output":{"type":"structure","members":{"keyPairs":{"type":"list","member":{"shape":"S4k"}},"nextPageToken":{}}}},"GetLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName"],"members":{"loadBalancerName":{}}},"output":{"type":"structure","members":{"loadBalancer":{"shape":"Sbz"}}}},"GetLoadBalancerMetricData":{"input":{"type":"structure","required":["loadBalancerName","metricName","period","startTime","endTime","unit","statistics"],"members":{"loadBalancerName":{},"metricName":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"unit":{},"statistics":{"shape":"S7q"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S7s"}}}},"GetLoadBalancerTlsCertificates":{"input":{"type":"structure","required":["loadBalancerName"],"members":{"loadBalancerName":{}}},"output":{"type":"structure","members":{"tlsCertificates":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"loadBalancerName":{},"isAttached":{"type":"boolean"},"status":{},"domainName":{},"domainValidationRecords":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"value":{},"validationStatus":{},"domainName":{}}}},"failureReason":{},"issuedAt":{"type":"timestamp"},"issuer":{},"keyAlgorithm":{},"notAfter":{"type":"timestamp"},"notBefore":{"type":"timestamp"},"renewalSummary":{"type":"structure","members":{"renewalStatus":{},"domainValidationOptions":{"type":"list","member":{"type":"structure","members":{"domainName":{},"validationStatus":{}}}}}},"revocationReason":{},"revokedAt":{"type":"timestamp"},"serial":{},"signatureAlgorithm":{},"subject":{},"subjectAlternativeNames":{"shape":"Su"}}}}}}},"GetLoadBalancerTlsPolicies":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"tlsPolicies":{"type":"list","member":{"type":"structure","members":{"name":{},"isDefault":{"type":"boolean"},"description":{},"protocols":{"shape":"Su"},"ciphers":{"shape":"Su"}}}},"nextPageToken":{}}}},"GetLoadBalancers":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"loadBalancers":{"type":"list","member":{"shape":"Sbz"}},"nextPageToken":{}}}},"GetOperation":{"input":{"type":"structure","required":["operationId"],"members":{"operationId":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"GetOperations":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"},"nextPageToken":{}}}},"GetOperationsForResource":{"input":{"type":"structure","required":["resourceName"],"members":{"resourceName":{},"pageToken":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"},"nextPageCount":{"deprecated":true},"nextPageToken":{}}}},"GetRegions":{"input":{"type":"structure","members":{"includeAvailabilityZones":{"type":"boolean"},"includeRelationalDatabaseAvailabilityZones":{"type":"boolean"}}},"output":{"type":"structure","members":{"regions":{"type":"list","member":{"type":"structure","members":{"continentCode":{},"description":{},"displayName":{},"name":{},"availabilityZones":{"shape":"Sd9"},"relationalDatabaseAvailabilityZones":{"shape":"Sd9"}}}}}}},"GetRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"relationalDatabase":{"shape":"Sdd"}}}},"GetRelationalDatabaseBlueprints":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"blueprints":{"type":"list","member":{"type":"structure","members":{"blueprintId":{},"engine":{},"engineVersion":{},"engineDescription":{},"engineVersionDescription":{},"isEngineDefault":{"type":"boolean"}}}},"nextPageToken":{}}}},"GetRelationalDatabaseBundles":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"bundles":{"type":"list","member":{"type":"structure","members":{"bundleId":{},"name":{},"price":{"type":"float"},"ramSizeInGb":{"type":"float"},"diskSizeInGb":{"type":"integer"},"transferPerMonthInGb":{"type":"integer"},"cpuCount":{"type":"integer"},"isEncrypted":{"type":"boolean"},"isActive":{"type":"boolean"}}}},"nextPageToken":{}}}},"GetRelationalDatabaseEvents":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"durationInMinutes":{"type":"integer"},"pageToken":{}}},"output":{"type":"structure","members":{"relationalDatabaseEvents":{"type":"list","member":{"type":"structure","members":{"resource":{},"createdAt":{"type":"timestamp"},"message":{},"eventCategories":{"shape":"Su"}}}},"nextPageToken":{}}}},"GetRelationalDatabaseLogEvents":{"input":{"type":"structure","required":["relationalDatabaseName","logStreamName"],"members":{"relationalDatabaseName":{},"logStreamName":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"startFromHead":{"type":"boolean"},"pageToken":{}}},"output":{"type":"structure","members":{"resourceLogEvents":{"type":"list","member":{"type":"structure","members":{"createdAt":{"type":"timestamp"},"message":{}}}},"nextBackwardToken":{},"nextForwardToken":{}}}},"GetRelationalDatabaseLogStreams":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"logStreams":{"shape":"Su"}}}},"GetRelationalDatabaseMasterUserPassword":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"passwordVersion":{}}},"output":{"type":"structure","members":{"masterUserPassword":{"shape":"S4s"},"createdAt":{"type":"timestamp"}}}},"GetRelationalDatabaseMetricData":{"input":{"type":"structure","required":["relationalDatabaseName","metricName","period","startTime","endTime","unit","statistics"],"members":{"relationalDatabaseName":{},"metricName":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"unit":{},"statistics":{"shape":"S7q"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S7s"}}}},"GetRelationalDatabaseParameters":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"pageToken":{}}},"output":{"type":"structure","members":{"parameters":{"shape":"Sea"},"nextPageToken":{}}}},"GetRelationalDatabaseSnapshot":{"input":{"type":"structure","required":["relationalDatabaseSnapshotName"],"members":{"relationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"relationalDatabaseSnapshot":{"shape":"See"}}}},"GetRelationalDatabaseSnapshots":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"relationalDatabaseSnapshots":{"type":"list","member":{"shape":"See"}},"nextPageToken":{}}}},"GetRelationalDatabases":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"relationalDatabases":{"type":"list","member":{"shape":"Sdd"}},"nextPageToken":{}}}},"GetStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"staticIp":{"shape":"Sen"}}}},"GetStaticIps":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"staticIps":{"type":"list","member":{"shape":"Sen"}},"nextPageToken":{}}}},"ImportKeyPair":{"input":{"type":"structure","required":["keyPairName","publicKeyBase64"],"members":{"keyPairName":{},"publicKeyBase64":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"IsVpcPeered":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"isPeered":{"type":"boolean"}}}},"OpenInstancePublicPorts":{"input":{"type":"structure","required":["portInfo","instanceName"],"members":{"portInfo":{"shape":"Sr"},"instanceName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"PeerVpc":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"PutAlarm":{"input":{"type":"structure","required":["alarmName","metricName","monitoredResourceName","comparisonOperator","threshold","evaluationPeriods"],"members":{"alarmName":{},"metricName":{},"monitoredResourceName":{},"comparisonOperator":{},"threshold":{"type":"double"},"evaluationPeriods":{"type":"integer"},"datapointsToAlarm":{"type":"integer"},"treatMissingData":{},"contactProtocols":{"shape":"S71"},"notificationTriggers":{"shape":"S72"},"notificationEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"PutInstancePublicPorts":{"input":{"type":"structure","required":["portInfos","instanceName"],"members":{"portInfos":{"type":"list","member":{"shape":"Sr"}},"instanceName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"RebootInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"RebootRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"RegisterContainerImage":{"input":{"type":"structure","required":["serviceName","label","digest"],"members":{"serviceName":{},"label":{},"digest":{}}},"output":{"type":"structure","members":{"containerImage":{"shape":"S8w"}}}},"ReleaseStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"ResetDistributionCache":{"input":{"type":"structure","members":{"distributionName":{}}},"output":{"type":"structure","members":{"status":{},"createTime":{"type":"timestamp"},"operation":{"shape":"S5"}}}},"SendContactMethodVerification":{"input":{"type":"structure","required":["protocol"],"members":{"protocol":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"SetIpAddressType":{"input":{"type":"structure","required":["resourceType","resourceName","ipAddressType"],"members":{"resourceType":{},"resourceName":{},"ipAddressType":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"SetResourceAccessForBucket":{"input":{"type":"structure","required":["resourceName","bucketName","access"],"members":{"resourceName":{},"bucketName":{},"access":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StartInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StartRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StopInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StopRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"relationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"TagResource":{"input":{"type":"structure","required":["resourceName","tags"],"members":{"resourceName":{},"resourceArn":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"TestAlarm":{"input":{"type":"structure","required":["alarmName","state"],"members":{"alarmName":{},"state":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UnpeerVpc":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"UntagResource":{"input":{"type":"structure","required":["resourceName","tagKeys"],"members":{"resourceName":{},"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateBucket":{"input":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"accessRules":{"shape":"S16"},"versioning":{},"readonlyAccessAccounts":{"shape":"S18"},"accessLogConfig":{"shape":"S1c"}}},"output":{"type":"structure","members":{"bucket":{"shape":"S15"},"operations":{"shape":"S4"}}}},"UpdateBucketBundle":{"input":{"type":"structure","required":["bucketName","bundleId"],"members":{"bucketName":{},"bundleId":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateContainerService":{"input":{"type":"structure","required":["serviceName"],"members":{"serviceName":{},"power":{},"scale":{"type":"integer"},"isDisabled":{"type":"boolean"},"publicDomainNames":{"shape":"S2i"}}},"output":{"type":"structure","members":{"containerService":{"shape":"S2v"}}}},"UpdateDistribution":{"input":{"type":"structure","required":["distributionName"],"members":{"distributionName":{},"origin":{"shape":"S3j"},"defaultCacheBehavior":{"shape":"S3l"},"cacheBehaviorSettings":{"shape":"S3n"},"cacheBehaviors":{"shape":"S3v"},"isEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"UpdateDistributionBundle":{"input":{"type":"structure","members":{"distributionName":{},"bundleId":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"UpdateDomainEntry":{"input":{"type":"structure","required":["domainName","domainEntry"],"members":{"domainName":{},"domainEntry":{"shape":"S44"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateLoadBalancerAttribute":{"input":{"type":"structure","required":["loadBalancerName","attributeName","attributeValue"],"members":{"loadBalancerName":{},"attributeName":{},"attributeValue":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"masterUserPassword":{"shape":"S4s"},"rotateMasterUserPassword":{"type":"boolean"},"preferredBackupWindow":{},"preferredMaintenanceWindow":{},"enableBackupRetention":{"type":"boolean"},"disableBackupRetention":{"type":"boolean"},"publiclyAccessible":{"type":"boolean"},"applyImmediately":{"type":"boolean"},"caCertificateIdentifier":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateRelationalDatabaseParameters":{"input":{"type":"structure","required":["relationalDatabaseName","parameters"],"members":{"relationalDatabaseName":{},"parameters":{"shape":"Sea"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}}},"shapes":{"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","members":{"id":{},"resourceName":{},"resourceType":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"isTerminal":{"type":"boolean"},"operationDetails":{},"operationType":{},"status":{},"statusChangedAt":{"type":"timestamp"},"errorCode":{},"errorDetails":{}}},"S9":{"type":"structure","members":{"availabilityZone":{},"regionName":{}}},"Sk":{"type":"list","member":{}},"Sr":{"type":"structure","members":{"fromPort":{"type":"integer"},"toPort":{"type":"integer"},"protocol":{},"cidrs":{"shape":"Su"},"ipv6Cidrs":{"shape":"Su"},"cidrListAliases":{"shape":"Su"}}},"Su":{"type":"list","member":{}},"S10":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S15":{"type":"structure","members":{"resourceType":{},"accessRules":{"shape":"S16"},"arn":{},"bundleId":{},"createdAt":{"type":"timestamp"},"url":{},"location":{"shape":"S9"},"name":{},"supportCode":{},"tags":{"shape":"S10"},"objectVersioning":{},"ableToUpdateBundle":{"type":"boolean"},"readonlyAccessAccounts":{"shape":"S18"},"resourcesReceivingAccess":{"type":"list","member":{"type":"structure","members":{"name":{},"resourceType":{}}}},"state":{"type":"structure","members":{"code":{},"message":{}}},"accessLogConfig":{"shape":"S1c"}}},"S16":{"type":"structure","members":{"getObject":{},"allowPublicOverrides":{"type":"boolean"}}},"S18":{"type":"list","member":{}},"S1c":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"},"destination":{},"prefix":{}}},"S1g":{"type":"structure","members":{"accessKeyId":{"type":"string","sensitive":true},"secretAccessKey":{},"status":{},"createdAt":{"type":"timestamp"},"lastUsed":{"type":"structure","members":{"lastUsedDate":{"type":"timestamp"},"region":{},"serviceName":{}}}}},"S1n":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"certificateArn":{},"certificateName":{},"domainName":{},"certificateDetail":{"type":"structure","members":{"arn":{},"name":{},"domainName":{},"status":{},"serialNumber":{},"subjectAlternativeNames":{"shape":"S1n"},"domainValidationRecords":{"shape":"S1t"},"requestFailureReason":{},"inUseResourceCount":{"type":"integer"},"keyAlgorithm":{},"createdAt":{"type":"timestamp"},"issuedAt":{"type":"timestamp"},"issuerCA":{},"notBefore":{"type":"timestamp"},"notAfter":{"type":"timestamp"},"eligibleToRenew":{},"renewalSummary":{"type":"structure","members":{"domainValidationRecords":{"shape":"S1t"},"renewalStatus":{},"renewalStatusReason":{},"updatedAt":{"type":"timestamp"}}},"revokedAt":{"type":"timestamp"},"revocationReason":{},"tags":{"shape":"S10"},"supportCode":{}}},"tags":{"shape":"S10"}}},"S1t":{"type":"list","member":{"type":"structure","members":{"domainName":{},"resourceRecord":{"type":"structure","members":{"name":{},"type":{},"value":{}}}}}},"S2i":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S2l":{"type":"map","key":{},"value":{"type":"structure","members":{"image":{},"command":{"shape":"Su"},"environment":{"type":"map","key":{},"value":{}},"ports":{"type":"map","key":{},"value":{}}}}},"S2r":{"type":"structure","required":["containerName","containerPort"],"members":{"containerName":{},"containerPort":{"type":"integer"},"healthCheck":{"shape":"S2t"}}},"S2t":{"type":"structure","members":{"healthyThreshold":{"type":"integer"},"unhealthyThreshold":{"type":"integer"},"timeoutSeconds":{"type":"integer"},"intervalSeconds":{"type":"integer"},"path":{},"successCodes":{}}},"S2v":{"type":"structure","members":{"containerServiceName":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"power":{},"powerId":{},"state":{},"stateDetail":{"type":"structure","members":{"code":{},"message":{}}},"scale":{"type":"integer"},"currentDeployment":{"shape":"S2z"},"nextDeployment":{"shape":"S2z"},"isDisabled":{"type":"boolean"},"principalArn":{},"privateDomainName":{},"publicDomainNames":{"shape":"S2i"},"url":{}}},"S2z":{"type":"structure","members":{"version":{"type":"integer"},"state":{},"containers":{"shape":"S2l"},"publicEndpoint":{"type":"structure","members":{"containerName":{},"containerPort":{"type":"integer"},"healthCheck":{"shape":"S2t"}}},"createdAt":{"type":"timestamp"}}},"S38":{"type":"list","member":{"shape":"S39"}},"S39":{"type":"structure","required":["addOnType"],"members":{"addOnType":{},"autoSnapshotAddOnRequest":{"type":"structure","members":{"snapshotTimeOfDay":{}}}}},"S3j":{"type":"structure","members":{"name":{},"regionName":{},"protocolPolicy":{}}},"S3l":{"type":"structure","members":{"behavior":{}}},"S3n":{"type":"structure","members":{"defaultTTL":{"type":"long"},"minimumTTL":{"type":"long"},"maximumTTL":{"type":"long"},"allowedHTTPMethods":{},"cachedHTTPMethods":{},"forwardedCookies":{"type":"structure","members":{"option":{},"cookiesAllowList":{"shape":"Su"}}},"forwardedHeaders":{"type":"structure","members":{"option":{},"headersAllowList":{"type":"list","member":{}}}},"forwardedQueryStrings":{"type":"structure","members":{"option":{"type":"boolean"},"queryStringsAllowList":{"shape":"Su"}}}}},"S3v":{"type":"list","member":{"type":"structure","members":{"path":{},"behavior":{}}}},"S3z":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"alternativeDomainNames":{"shape":"Su"},"status":{},"isEnabled":{"type":"boolean"},"domainName":{},"bundleId":{},"certificateName":{},"origin":{"type":"structure","members":{"name":{},"resourceType":{},"regionName":{},"protocolPolicy":{}}},"originPublicDNS":{},"defaultCacheBehavior":{"shape":"S3l"},"cacheBehaviorSettings":{"shape":"S3n"},"cacheBehaviors":{"shape":"S3v"},"ableToUpdateBundle":{"type":"boolean"},"ipAddressType":{},"tags":{"shape":"S10"}}},"S44":{"type":"structure","members":{"id":{},"name":{},"target":{},"isAlias":{"type":"boolean"},"type":{},"options":{"deprecated":true,"type":"map","key":{},"value":{}}}},"S4k":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"fingerprint":{}}},"S4n":{"type":"list","member":{}},"S4s":{"type":"string","sensitive":true},"S71":{"type":"list","member":{}},"S72":{"type":"list","member":{}},"S7q":{"type":"list","member":{}},"S7s":{"type":"list","member":{"type":"structure","members":{"average":{"type":"double"},"maximum":{"type":"double"},"minimum":{"type":"double"},"sampleCount":{"type":"double"},"sum":{"type":"double"},"timestamp":{"type":"timestamp"},"unit":{}}}},"S8j":{"type":"structure","members":{"id":{},"service":{}}},"S8w":{"type":"structure","members":{"image":{},"digest":{},"createdAt":{"type":"timestamp"}}},"S9g":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"addOns":{"shape":"S9h"},"sizeInGb":{"type":"integer"},"isSystemDisk":{"type":"boolean"},"iops":{"type":"integer"},"path":{},"state":{},"attachedTo":{},"isAttached":{"type":"boolean"},"attachmentState":{"deprecated":true},"gbInUse":{"deprecated":true,"type":"integer"}}},"S9h":{"type":"list","member":{"type":"structure","members":{"name":{},"status":{},"snapshotTimeOfDay":{},"nextSnapshotTimeOfDay":{}}}},"S9m":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"sizeInGb":{"type":"integer"},"state":{},"progress":{},"fromDiskName":{},"fromDiskArn":{},"fromInstanceName":{},"fromInstanceArn":{},"isFromAutoSnapshot":{"type":"boolean"}}},"S9t":{"type":"list","member":{"shape":"S9g"}},"Sa8":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"domainEntries":{"type":"list","member":{"shape":"S44"}}}},"Sap":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"blueprintId":{},"blueprintName":{},"bundleId":{},"addOns":{"shape":"S9h"},"isStaticIp":{"type":"boolean"},"privateIpAddress":{},"publicIpAddress":{},"ipv6Addresses":{"type":"list","member":{}},"ipAddressType":{},"hardware":{"type":"structure","members":{"cpuCount":{"type":"integer"},"disks":{"shape":"S9t"},"ramSizeInGb":{"type":"float"}}},"networking":{"type":"structure","members":{"monthlyTransfer":{"type":"structure","members":{"gbPerMonthAllocated":{"type":"integer"}}},"ports":{"type":"list","member":{"type":"structure","members":{"fromPort":{"type":"integer"},"toPort":{"type":"integer"},"protocol":{},"accessFrom":{},"accessType":{},"commonName":{},"accessDirection":{},"cidrs":{"shape":"Su"},"ipv6Cidrs":{"shape":"Su"},"cidrListAliases":{"shape":"Su"}}}}}},"state":{"shape":"Sb0"},"username":{},"sshKeyName":{}}},"Sb0":{"type":"structure","members":{"code":{"type":"integer"},"name":{}}},"Sbi":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"state":{},"progress":{},"fromAttachedDisks":{"shape":"S9t"},"fromInstanceName":{},"fromInstanceArn":{},"fromBlueprintId":{},"fromBundleId":{},"isFromAutoSnapshot":{"type":"boolean"},"sizeInGb":{"type":"integer"}}},"Sbz":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"dnsName":{},"state":{},"protocol":{},"publicPorts":{"type":"list","member":{"type":"integer"}},"healthCheckPath":{},"instancePort":{"type":"integer"},"instanceHealthSummary":{"type":"list","member":{"type":"structure","members":{"instanceName":{},"instanceHealth":{},"instanceHealthReason":{}}}},"tlsCertificateSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"isAttached":{"type":"boolean"}}}},"configurationOptions":{"type":"map","key":{},"value":{}},"ipAddressType":{},"httpsRedirectionEnabled":{"type":"boolean"},"tlsPolicyName":{}}},"Sd9":{"type":"list","member":{"type":"structure","members":{"zoneName":{},"state":{}}}},"Sdd":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"relationalDatabaseBlueprintId":{},"relationalDatabaseBundleId":{},"masterDatabaseName":{},"hardware":{"type":"structure","members":{"cpuCount":{"type":"integer"},"diskSizeInGb":{"type":"integer"},"ramSizeInGb":{"type":"float"}}},"state":{},"secondaryAvailabilityZone":{},"backupRetentionEnabled":{"type":"boolean"},"pendingModifiedValues":{"type":"structure","members":{"masterUserPassword":{},"engineVersion":{},"backupRetentionEnabled":{"type":"boolean"}}},"engine":{},"engineVersion":{},"latestRestorableTime":{"type":"timestamp"},"masterUsername":{},"parameterApplyStatus":{},"preferredBackupWindow":{},"preferredMaintenanceWindow":{},"publiclyAccessible":{"type":"boolean"},"masterEndpoint":{"type":"structure","members":{"port":{"type":"integer"},"address":{}}},"pendingMaintenanceActions":{"type":"list","member":{"type":"structure","members":{"action":{},"description":{},"currentApplyDate":{"type":"timestamp"}}}},"caCertificateIdentifier":{}}},"Sea":{"type":"list","member":{"type":"structure","members":{"allowedValues":{},"applyMethod":{},"applyType":{},"dataType":{},"description":{},"isModifiable":{"type":"boolean"},"parameterName":{},"parameterValue":{}}}},"See":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S10"},"engine":{},"engineVersion":{},"sizeInGb":{"type":"integer"},"state":{},"fromRelationalDatabaseName":{},"fromRelationalDatabaseArn":{},"fromRelationalDatabaseBundleId":{},"fromRelationalDatabaseBlueprintId":{}}},"Sen":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"ipAddress":{},"attachedTo":{},"isAttached":{"type":"boolean"}}}}}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['machinelearning'] = {};
	AWS.MachineLearning = Service.defineService('machinelearning', ['2014-12-12']);
	__webpack_require__(290);
	Object.defineProperty(apiLoader.services['machinelearning'], '2014-12-12', {
	  get: function get() {
	    var model = __webpack_require__(291);
	    model.paginators = __webpack_require__(292).pagination;
	    model.waiters = __webpack_require__(293).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MachineLearning;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.MachineLearning.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'predict') {
	      request.addListener('build', this.buildEndpoint);
	    }
	  },

	  /**
	   * Updates request endpoint from PredictEndpoint
	   * @api private
	   */
	  buildEndpoint: function buildEndpoint(request) {
	    var url = request.params.PredictEndpoint;
	    if (url) {
	      request.httpRequest.endpoint = new AWS.Endpoint(url);
	    }
	  }

	});


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-12-12","endpointPrefix":"machinelearning","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Machine Learning","serviceId":"Machine Learning","signatureVersion":"v4","targetPrefix":"AmazonML_20141212","uid":"machinelearning-2014-12-12"},"operations":{"AddTags":{"input":{"type":"structure","required":["Tags","ResourceId","ResourceType"],"members":{"Tags":{"shape":"S2"},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"CreateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","MLModelId","BatchPredictionDataSourceId","OutputUri"],"members":{"BatchPredictionId":{},"BatchPredictionName":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"OutputUri":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"CreateDataSourceFromRDS":{"input":{"type":"structure","required":["DataSourceId","RDSData","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"RDSData":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation","ResourceRole","ServiceRole","SubnetId","SecurityGroupIds"],"members":{"DatabaseInformation":{"shape":"Sf"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{},"ResourceRole":{},"ServiceRole":{},"SubnetId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromRedshift":{"input":{"type":"structure","required":["DataSourceId","DataSpec","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation"],"members":{"DatabaseInformation":{"shape":"Sy"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromS3":{"input":{"type":"structure","required":["DataSourceId","DataSpec"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DataLocationS3"],"members":{"DataLocationS3":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaLocationS3":{}}},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateEvaluation":{"input":{"type":"structure","required":["EvaluationId","MLModelId","EvaluationDataSourceId"],"members":{"EvaluationId":{},"EvaluationName":{},"MLModelId":{},"EvaluationDataSourceId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"CreateMLModel":{"input":{"type":"structure","required":["MLModelId","MLModelType","TrainingDataSourceId"],"members":{"MLModelId":{},"MLModelName":{},"MLModelType":{},"Parameters":{"shape":"S1d"},"TrainingDataSourceId":{},"Recipe":{},"RecipeUri":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"CreateRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"DeleteEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"DeleteMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"DeleteRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteTags":{"input":{"type":"structure","required":["TagKeys","ResourceId","ResourceType"],"members":{"TagKeys":{"type":"list","member":{}},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"DescribeBatchPredictions":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"NextToken":{}}}},"DescribeDataSources":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEvaluations":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMLModels":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"Algorithm":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId","ResourceType"],"members":{"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Tags":{"shape":"S2"}}}},"GetBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"GetDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"LogUri":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"DataSourceSchema":{}}}},"GetEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"GetMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"Recipe":{},"Schema":{}}}},"Predict":{"input":{"type":"structure","required":["MLModelId","Record","PredictEndpoint"],"members":{"MLModelId":{},"Record":{"type":"map","key":{},"value":{}},"PredictEndpoint":{}}},"output":{"type":"structure","members":{"Prediction":{"type":"structure","members":{"predictedLabel":{},"predictedValue":{"type":"float"},"predictedScores":{"type":"map","key":{},"value":{"type":"float"}},"details":{"type":"map","key":{},"value":{}}}}}}},"UpdateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","BatchPredictionName"],"members":{"BatchPredictionId":{},"BatchPredictionName":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"UpdateDataSource":{"input":{"type":"structure","required":["DataSourceId","DataSourceName"],"members":{"DataSourceId":{},"DataSourceName":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"UpdateEvaluation":{"input":{"type":"structure","required":["EvaluationId","EvaluationName"],"members":{"EvaluationId":{},"EvaluationName":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"UpdateMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"MLModelName":{},"ScoreThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"MLModelId":{}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["InstanceIdentifier","DatabaseName"],"members":{"InstanceIdentifier":{},"DatabaseName":{}}},"Sy":{"type":"structure","required":["DatabaseName","ClusterIdentifier"],"members":{"DatabaseName":{},"ClusterIdentifier":{}}},"S1d":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"PeakRequestsPerSecond":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"EndpointUrl":{},"EndpointStatus":{}}},"S2i":{"type":"structure","members":{"RedshiftDatabase":{"shape":"Sy"},"DatabaseUserName":{},"SelectSqlQuery":{}}},"S2j":{"type":"structure","members":{"Database":{"shape":"Sf"},"DatabaseUserName":{},"SelectSqlQuery":{},"ResourceRole":{},"ServiceRole":{},"DataPipelineId":{}}},"S2q":{"type":"structure","members":{"Properties":{"type":"map","key":{},"value":{}}}}}}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeBatchPredictions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DataSourceAvailable":{"delay":30,"operation":"DescribeDataSources","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"MLModelAvailable":{"delay":30,"operation":"DescribeMLModels","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"EvaluationAvailable":{"delay":30,"operation":"DescribeEvaluations","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"BatchPredictionAvailable":{"delay":30,"operation":"DescribeBatchPredictions","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]}}}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['marketplacecommerceanalytics'] = {};
	AWS.MarketplaceCommerceAnalytics = Service.defineService('marketplacecommerceanalytics', ['2015-07-01']);
	Object.defineProperty(apiLoader.services['marketplacecommerceanalytics'], '2015-07-01', {
	  get: function get() {
	    var model = __webpack_require__(295);
	    model.paginators = __webpack_require__(296).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MarketplaceCommerceAnalytics;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-01","endpointPrefix":"marketplacecommerceanalytics","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Commerce Analytics","serviceId":"Marketplace Commerce Analytics","signatureVersion":"v4","signingName":"marketplacecommerceanalytics","targetPrefix":"MarketplaceCommerceAnalytics20150701","uid":"marketplacecommerceanalytics-2015-07-01"},"operations":{"GenerateDataSet":{"input":{"type":"structure","required":["dataSetType","dataSetPublicationDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"dataSetPublicationDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}},"StartSupportDataExport":{"input":{"type":"structure","required":["dataSetType","fromDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"fromDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['marketplacemetering'] = {};
	AWS.MarketplaceMetering = Service.defineService('marketplacemetering', ['2016-01-14']);
	Object.defineProperty(apiLoader.services['marketplacemetering'], '2016-01-14', {
	  get: function get() {
	    var model = __webpack_require__(298);
	    model.paginators = __webpack_require__(299).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MarketplaceMetering;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-01-14","endpointPrefix":"metering.marketplace","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWSMarketplace Metering","serviceId":"Marketplace Metering","signatureVersion":"v4","signingName":"aws-marketplace","targetPrefix":"AWSMPMeteringService","uid":"meteringmarketplace-2016-01-14"},"operations":{"BatchMeterUsage":{"input":{"type":"structure","required":["UsageRecords","ProductCode"],"members":{"UsageRecords":{"shape":"S2"},"ProductCode":{}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"UsageRecord":{"shape":"S3"},"MeteringRecordId":{},"Status":{}}}},"UnprocessedRecords":{"shape":"S2"}}}},"MeterUsage":{"input":{"type":"structure","required":["ProductCode","Timestamp","UsageDimension"],"members":{"ProductCode":{},"Timestamp":{"type":"timestamp"},"UsageDimension":{},"UsageQuantity":{"type":"integer"},"DryRun":{"type":"boolean"},"UsageAllocations":{"shape":"S8"}}},"output":{"type":"structure","members":{"MeteringRecordId":{}}}},"RegisterUsage":{"input":{"type":"structure","required":["ProductCode","PublicKeyVersion"],"members":{"ProductCode":{},"PublicKeyVersion":{"type":"integer"},"Nonce":{}}},"output":{"type":"structure","members":{"PublicKeyRotationTimestamp":{"type":"timestamp"},"Signature":{}}}},"ResolveCustomer":{"input":{"type":"structure","required":["RegistrationToken"],"members":{"RegistrationToken":{}}},"output":{"type":"structure","members":{"CustomerIdentifier":{},"ProductCode":{},"CustomerAWSAccountId":{}}}}},"shapes":{"S2":{"type":"list","member":{"shape":"S3"}},"S3":{"type":"structure","required":["Timestamp","CustomerIdentifier","Dimension"],"members":{"Timestamp":{"type":"timestamp"},"CustomerIdentifier":{},"Dimension":{},"Quantity":{"type":"integer"},"UsageAllocations":{"shape":"S8"}}},"S8":{"type":"list","member":{"type":"structure","required":["AllocatedUsageQuantity"],"members":{"AllocatedUsageQuantity":{"type":"integer"},"Tags":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}}}}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mturk'] = {};
	AWS.MTurk = Service.defineService('mturk', ['2017-01-17']);
	Object.defineProperty(apiLoader.services['mturk'], '2017-01-17', {
	  get: function get() {
	    var model = __webpack_require__(301);
	    model.paginators = __webpack_require__(302).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MTurk;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-17","endpointPrefix":"mturk-requester","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MTurk","serviceFullName":"Amazon Mechanical Turk","serviceId":"MTurk","signatureVersion":"v4","targetPrefix":"MTurkRequesterServiceV20170117","uid":"mturk-requester-2017-01-17"},"operations":{"AcceptQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"IntegerValue":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"ApproveAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{},"RequesterFeedback":{},"OverrideRejection":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateQualificationWithWorker":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{},"IntegerValue":{"type":"integer"},"SendNotification":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateAdditionalAssignmentsForHIT":{"input":{"type":"structure","required":["HITId","NumberOfAdditionalAssignments"],"members":{"HITId":{},"NumberOfAdditionalAssignments":{"type":"integer"},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"CreateHIT":{"input":{"type":"structure","required":["LifetimeInSeconds","AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"MaxAssignments":{"type":"integer"},"AutoApprovalDelayInSeconds":{"type":"long"},"LifetimeInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"Question":{},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateHITType":{"input":{"type":"structure","required":["AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"AutoApprovalDelayInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"QualificationRequirements":{"shape":"Si"}}},"output":{"type":"structure","members":{"HITTypeId":{}}},"idempotent":true},"CreateHITWithHITType":{"input":{"type":"structure","required":["HITTypeId","LifetimeInSeconds"],"members":{"HITTypeId":{},"MaxAssignments":{"type":"integer"},"LifetimeInSeconds":{"type":"long"},"Question":{},"RequesterAnnotation":{},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateQualificationType":{"input":{"type":"structure","required":["Name","Description","QualificationTypeStatus"],"members":{"Name":{},"Keywords":{},"Description":{},"QualificationTypeStatus":{},"RetryDelayInSeconds":{"type":"long"},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}},"CreateWorkerBlock":{"input":{"type":"structure","required":["WorkerId","Reason"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"DeleteHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkerBlock":{"input":{"type":"structure","required":["WorkerId"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateQualificationFromWorker":{"input":{"type":"structure","required":["WorkerId","QualificationTypeId"],"members":{"WorkerId":{},"QualificationTypeId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"GetAccountBalance":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AvailableBalance":{},"OnHoldBalance":{}}},"idempotent":true},"GetAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{}}},"output":{"type":"structure","members":{"Assignment":{"shape":"S1p"},"HIT":{"shape":"Sz"}}},"idempotent":true},"GetFileUploadURL":{"input":{"type":"structure","required":["AssignmentId","QuestionIdentifier"],"members":{"AssignmentId":{},"QuestionIdentifier":{}}},"output":{"type":"structure","members":{"FileUploadURL":{}}},"idempotent":true},"GetHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}},"idempotent":true},"GetQualificationScore":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{}}},"output":{"type":"structure","members":{"Qualification":{"shape":"S1x"}}},"idempotent":true},"GetQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}},"idempotent":true},"ListAssignmentsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"NextToken":{},"MaxResults":{"type":"integer"},"AssignmentStatuses":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Assignments":{"type":"list","member":{"shape":"S1p"}}}},"idempotent":true},"ListBonusPayments":{"input":{"type":"structure","members":{"HITId":{},"AssignmentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"BonusPayments":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"GrantTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListHITs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListHITsForQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListQualificationRequests":{"input":{"type":"structure","members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationRequests":{"type":"list","member":{"type":"structure","members":{"QualificationRequestId":{},"QualificationTypeId":{},"WorkerId":{},"Test":{},"Answer":{},"SubmitTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListQualificationTypes":{"input":{"type":"structure","required":["MustBeRequestable"],"members":{"Query":{},"MustBeRequestable":{"type":"boolean"},"MustBeOwnedByCaller":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationTypes":{"type":"list","member":{"shape":"S1a"}}}},"idempotent":true},"ListReviewPolicyResultsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"PolicyLevels":{"type":"list","member":{}},"RetrieveActions":{"type":"boolean"},"RetrieveResults":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"HITId":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"AssignmentReviewReport":{"shape":"S2r"},"HITReviewReport":{"shape":"S2r"},"NextToken":{}}},"idempotent":true},"ListReviewableHITs":{"input":{"type":"structure","members":{"HITTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListWorkerBlocks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"WorkerBlocks":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"Reason":{}}}}}},"idempotent":true},"ListWorkersWithQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Qualifications":{"type":"list","member":{"shape":"S1x"}}}},"idempotent":true},"NotifyWorkers":{"input":{"type":"structure","required":["Subject","MessageText","WorkerIds"],"members":{"Subject":{},"MessageText":{},"WorkerIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NotifyWorkersFailureStatuses":{"type":"list","member":{"type":"structure","members":{"NotifyWorkersFailureCode":{},"NotifyWorkersFailureMessage":{},"WorkerId":{}}}}}}},"RejectAssignment":{"input":{"type":"structure","required":["AssignmentId","RequesterFeedback"],"members":{"AssignmentId":{},"RequesterFeedback":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RejectQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBonus":{"input":{"type":"structure","required":["WorkerId","BonusAmount","AssignmentId","Reason"],"members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"SendTestEventNotification":{"input":{"type":"structure","required":["Notification","TestEventType"],"members":{"Notification":{"shape":"S3k"},"TestEventType":{}}},"output":{"type":"structure","members":{}}},"UpdateExpirationForHIT":{"input":{"type":"structure","required":["HITId","ExpireAt"],"members":{"HITId":{},"ExpireAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITReviewStatus":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"Revert":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITTypeOfHIT":{"input":{"type":"structure","required":["HITId","HITTypeId"],"members":{"HITId":{},"HITTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotificationSettings":{"input":{"type":"structure","required":["HITTypeId"],"members":{"HITTypeId":{},"Notification":{"shape":"S3k"},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Description":{},"QualificationTypeStatus":{},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"RetryDelayInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}}},"shapes":{"Si":{"type":"list","member":{"type":"structure","required":["QualificationTypeId","Comparator"],"members":{"QualificationTypeId":{},"Comparator":{},"IntegerValues":{"type":"list","member":{"type":"integer"}},"LocaleValues":{"type":"list","member":{"shape":"Sn"}},"RequiredToPreview":{"deprecated":true,"type":"boolean"},"ActionsGuarded":{}}}},"Sn":{"type":"structure","required":["Country"],"members":{"Country":{},"Subdivision":{}}},"Sq":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"},"MapEntries":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"}}}}}}}}},"St":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Sz":{"type":"structure","members":{"HITId":{},"HITTypeId":{},"HITGroupId":{},"HITLayoutId":{},"CreationTime":{"type":"timestamp"},"Title":{},"Description":{},"Question":{},"Keywords":{},"HITStatus":{},"MaxAssignments":{"type":"integer"},"Reward":{},"AutoApprovalDelayInSeconds":{"type":"long"},"Expiration":{"type":"timestamp"},"AssignmentDurationInSeconds":{"type":"long"},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"HITReviewStatus":{},"NumberOfAssignmentsPending":{"type":"integer"},"NumberOfAssignmentsAvailable":{"type":"integer"},"NumberOfAssignmentsCompleted":{"type":"integer"}}},"S1a":{"type":"structure","members":{"QualificationTypeId":{},"CreationTime":{"type":"timestamp"},"Name":{},"Description":{},"Keywords":{},"QualificationTypeStatus":{},"Test":{},"TestDurationInSeconds":{"type":"long"},"AnswerKey":{},"RetryDelayInSeconds":{"type":"long"},"IsRequestable":{"type":"boolean"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"S1p":{"type":"structure","members":{"AssignmentId":{},"WorkerId":{},"HITId":{},"AssignmentStatus":{},"AutoApprovalTime":{"type":"timestamp"},"AcceptTime":{"type":"timestamp"},"SubmitTime":{"type":"timestamp"},"ApprovalTime":{"type":"timestamp"},"RejectionTime":{"type":"timestamp"},"Deadline":{"type":"timestamp"},"Answer":{},"RequesterFeedback":{}}},"S1x":{"type":"structure","members":{"QualificationTypeId":{},"WorkerId":{},"GrantTime":{"type":"timestamp"},"IntegerValue":{"type":"integer"},"LocaleValue":{"shape":"Sn"},"Status":{}}},"S2d":{"type":"list","member":{"shape":"Sz"}},"S2r":{"type":"structure","members":{"ReviewResults":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"SubjectId":{},"SubjectType":{},"QuestionId":{},"Key":{},"Value":{}}}},"ReviewActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionName":{},"TargetId":{},"TargetType":{},"Status":{},"CompleteTime":{"type":"timestamp"},"Result":{},"ErrorCode":{}}}}}},"S3k":{"type":"structure","required":["Destination","Transport","Version","EventTypes"],"members":{"Destination":{},"Transport":{},"Version":{},"EventTypes":{"type":"list","member":{}}}}}}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAssignmentsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBonusPayments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITsForQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewPolicyResultsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewableHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkerBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkersWithQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mobileanalytics'] = {};
	AWS.MobileAnalytics = Service.defineService('mobileanalytics', ['2014-06-05']);
	Object.defineProperty(apiLoader.services['mobileanalytics'], '2014-06-05', {
	  get: function get() {
	    var model = __webpack_require__(304);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MobileAnalytics;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","serviceId":"Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['opsworks'] = {};
	AWS.OpsWorks = Service.defineService('opsworks', ['2013-02-18']);
	Object.defineProperty(apiLoader.services['opsworks'], '2013-02-18', {
	  get: function get() {
	    var model = __webpack_require__(306);
	    model.paginators = __webpack_require__(307).pagination;
	    model.waiters = __webpack_require__(308).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.OpsWorks;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-18","endpointPrefix":"opsworks","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS OpsWorks","serviceId":"OpsWorks","signatureVersion":"v4","targetPrefix":"OpsWorks_20130218","uid":"opsworks-2013-02-18"},"operations":{"AssignInstance":{"input":{"type":"structure","required":["InstanceId","LayerIds"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"}}}},"AssignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"InstanceId":{}}}},"AssociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"InstanceId":{}}}},"AttachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"CloneStack":{"input":{"type":"structure","required":["SourceStackId","ServiceRoleArn"],"members":{"SourceStackId":{},"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"ClonePermissions":{"type":"boolean"},"CloneAppIds":{"shape":"S3"},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateApp":{"input":{"type":"structure","required":["StackId","Name","Type"],"members":{"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}},"output":{"type":"structure","members":{"AppId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["StackId","Command"],"members":{"StackId":{},"AppId":{},"InstanceIds":{"shape":"S3"},"LayerIds":{"shape":"S3"},"Command":{"shape":"Ss"},"Comment":{},"CustomJson":{}}},"output":{"type":"structure","members":{"DeploymentId":{}}}},"CreateInstance":{"input":{"type":"structure","required":["StackId","LayerIds","InstanceType"],"members":{"StackId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"AvailabilityZone":{},"VirtualizationType":{},"SubnetId":{},"Architecture":{},"RootDeviceType":{},"BlockDeviceMappings":{"shape":"Sz"},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{},"Tenancy":{}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"CreateLayer":{"input":{"type":"structure","required":["StackId","Type","Name","Shortname"],"members":{"StackId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}},"output":{"type":"structure","members":{"LayerId":{}}}},"CreateStack":{"input":{"type":"structure","required":["Name","Region","ServiceRoleArn","DefaultInstanceProfileArn"],"members":{"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}},"output":{"type":"structure","members":{"IamUserArn":{}}}},"DeleteApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{}}}},"DeleteInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DeleteElasticIp":{"type":"boolean"},"DeleteVolumes":{"type":"boolean"}}}},"DeleteLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{}}}},"DeregisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn"],"members":{"EcsClusterArn":{}}}},"DeregisterElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"DeregisterInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"DeregisterRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{}}}},"DeregisterVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"DescribeAgentVersions":{"input":{"type":"structure","members":{"StackId":{},"ConfigurationManager":{"shape":"Sa"}}},"output":{"type":"structure","members":{"AgentVersions":{"type":"list","member":{"type":"structure","members":{"Version":{},"ConfigurationManager":{"shape":"Sa"}}}}}}},"DescribeApps":{"input":{"type":"structure","members":{"StackId":{},"AppIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"AppId":{},"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"CreatedAt":{},"Environment":{"shape":"So"}}}}}}},"DescribeCommands":{"input":{"type":"structure","members":{"DeploymentId":{},"InstanceId":{},"CommandIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"DeploymentId":{},"CreatedAt":{},"AcknowledgedAt":{},"CompletedAt":{},"Status":{},"ExitCode":{"type":"integer"},"LogUrl":{},"Type":{}}}}}}},"DescribeDeployments":{"input":{"type":"structure","members":{"StackId":{},"AppId":{},"DeploymentIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"DeploymentId":{},"StackId":{},"AppId":{},"CreatedAt":{},"CompletedAt":{},"Duration":{"type":"integer"},"IamUserArn":{},"Comment":{},"Command":{"shape":"Ss"},"Status":{},"CustomJson":{},"InstanceIds":{"shape":"S3"}}}}}}},"DescribeEcsClusters":{"input":{"type":"structure","members":{"EcsClusterArns":{"shape":"S3"},"StackId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EcsClusters":{"type":"list","member":{"type":"structure","members":{"EcsClusterArn":{},"EcsClusterName":{},"StackId":{},"RegisteredAt":{}}}},"NextToken":{}}}},"DescribeElasticIps":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"Ips":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticIps":{"type":"list","member":{"type":"structure","members":{"Ip":{},"Name":{},"Domain":{},"Region":{},"InstanceId":{}}}}}}},"DescribeElasticLoadBalancers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticLoadBalancers":{"type":"list","member":{"type":"structure","members":{"ElasticLoadBalancerName":{},"Region":{},"DnsName":{},"StackId":{},"LayerId":{},"VpcId":{},"AvailabilityZones":{"shape":"S3"},"SubnetIds":{"shape":"S3"},"Ec2InstanceIds":{"shape":"S3"}}}}}}},"DescribeInstances":{"input":{"type":"structure","members":{"StackId":{},"LayerId":{},"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"AgentVersion":{},"AmiId":{},"Architecture":{},"Arn":{},"AutoScalingType":{},"AvailabilityZone":{},"BlockDeviceMappings":{"shape":"Sz"},"CreatedAt":{},"EbsOptimized":{"type":"boolean"},"Ec2InstanceId":{},"EcsClusterArn":{},"EcsContainerInstanceArn":{},"ElasticIp":{},"Hostname":{},"InfrastructureClass":{},"InstallUpdatesOnBoot":{"type":"boolean"},"InstanceId":{},"InstanceProfileArn":{},"InstanceType":{},"LastServiceErrorId":{},"LayerIds":{"shape":"S3"},"Os":{},"Platform":{},"PrivateDns":{},"PrivateIp":{},"PublicDns":{},"PublicIp":{},"RegisteredBy":{},"ReportedAgentVersion":{},"ReportedOs":{"type":"structure","members":{"Family":{},"Name":{},"Version":{}}},"RootDeviceType":{},"RootDeviceVolumeId":{},"SecurityGroupIds":{"shape":"S3"},"SshHostDsaKeyFingerprint":{},"SshHostRsaKeyFingerprint":{},"SshKeyName":{},"StackId":{},"Status":{},"SubnetId":{},"Tenancy":{},"VirtualizationType":{}}}}}}},"DescribeLayers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"StackId":{},"LayerId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"DefaultSecurityGroupNames":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"DefaultRecipes":{"shape":"S1h"},"CustomRecipes":{"shape":"S1h"},"CreatedAt":{},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}}}}},"DescribeLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerIds"],"members":{"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"LoadBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}}}}},"DescribeMyUserProfile":{"output":{"type":"structure","members":{"UserProfile":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{}}}}}},"DescribeOperatingSystems":{"output":{"type":"structure","members":{"OperatingSystems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Type":{},"ConfigurationManagers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"ReportedName":{},"ReportedVersion":{},"Supported":{"type":"boolean"}}}}}}},"DescribePermissions":{"input":{"type":"structure","members":{"IamUserArn":{},"StackId":{}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}}}}},"DescribeRaidArrays":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"RaidArrays":{"type":"list","member":{"type":"structure","members":{"RaidArrayId":{},"InstanceId":{},"Name":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"AvailabilityZone":{},"CreatedAt":{},"StackId":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DescribeRdsDbInstances":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"RdsDbInstanceArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"RdsDbInstances":{"type":"list","member":{"type":"structure","members":{"RdsDbInstanceArn":{},"DbInstanceIdentifier":{},"DbUser":{},"DbPassword":{},"Region":{},"Address":{},"Engine":{},"StackId":{},"MissingOnRds":{"type":"boolean"}}}}}}},"DescribeServiceErrors":{"input":{"type":"structure","members":{"StackId":{},"InstanceId":{},"ServiceErrorIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ServiceErrors":{"type":"list","member":{"type":"structure","members":{"ServiceErrorId":{},"StackId":{},"InstanceId":{},"Type":{},"Message":{},"CreatedAt":{}}}}}}},"DescribeStackProvisioningParameters":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"AgentInstallerUrl":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"DescribeStackSummary":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"StackSummary":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"LayersCount":{"type":"integer"},"AppsCount":{"type":"integer"},"InstancesCount":{"type":"structure","members":{"Assigning":{"type":"integer"},"Booting":{"type":"integer"},"ConnectionLost":{"type":"integer"},"Deregistering":{"type":"integer"},"Online":{"type":"integer"},"Pending":{"type":"integer"},"Rebooting":{"type":"integer"},"Registered":{"type":"integer"},"Registering":{"type":"integer"},"Requested":{"type":"integer"},"RunningSetup":{"type":"integer"},"SetupFailed":{"type":"integer"},"ShuttingDown":{"type":"integer"},"StartFailed":{"type":"integer"},"StopFailed":{"type":"integer"},"Stopped":{"type":"integer"},"Stopping":{"type":"integer"},"Terminated":{"type":"integer"},"Terminating":{"type":"integer"},"Unassigning":{"type":"integer"}}}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"CreatedAt":{},"DefaultRootDeviceType":{},"AgentVersion":{}}}}}}},"DescribeTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"TimeBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}}}}},"DescribeUserProfiles":{"input":{"type":"structure","members":{"IamUserArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayId":{},"VolumeIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"type":"structure","members":{"VolumeId":{},"Ec2VolumeId":{},"Name":{},"RaidArrayId":{},"InstanceId":{},"Status":{},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"Region":{},"AvailabilityZone":{},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}}}}},"DetachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"DisassociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"GetHostnameSuggestion":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}},"output":{"type":"structure","members":{"LayerId":{},"Hostname":{}}}},"GrantAccess":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ValidForInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"TemporaryCredential":{"type":"structure","members":{"Username":{},"Password":{},"ValidForInMinutes":{"type":"integer"},"InstanceId":{}}}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S50"},"NextToken":{}}}},"RebootInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"RegisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn","StackId"],"members":{"EcsClusterArn":{},"StackId":{}}},"output":{"type":"structure","members":{"EcsClusterArn":{}}}},"RegisterElasticIp":{"input":{"type":"structure","required":["ElasticIp","StackId"],"members":{"ElasticIp":{},"StackId":{}}},"output":{"type":"structure","members":{"ElasticIp":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Hostname":{},"PublicIp":{},"PrivateIp":{},"RsaPublicKey":{},"RsaPublicKeyFingerprint":{},"InstanceIdentity":{"type":"structure","members":{"Document":{},"Signature":{}}}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"RegisterRdsDbInstance":{"input":{"type":"structure","required":["StackId","RdsDbInstanceArn","DbUser","DbPassword"],"members":{"StackId":{},"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"RegisterVolume":{"input":{"type":"structure","required":["StackId"],"members":{"Ec2VolumeId":{},"StackId":{}}},"output":{"type":"structure","members":{"VolumeId":{}}}},"SetLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}},"SetPermission":{"input":{"type":"structure","required":["StackId","IamUserArn"],"members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}},"SetTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}},"StartInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StartStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"StopInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Force":{"type":"boolean"}}}},"StopStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S50"}}}},"UnassignInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"UnassignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}}},"UpdateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"Name":{}}}},"UpdateInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"Architecture":{},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{}}}},"UpdateLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}},"UpdateMyUserProfile":{"input":{"type":"structure","members":{"SshPublicKey":{}}}},"UpdateRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Name":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"UseOpsworksSecurityGroups":{"type":"boolean"},"AgentVersion":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"Name":{},"MountPoint":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"map","key":{},"value":{}},"Sa":{"type":"structure","members":{"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"ManageBerkshelf":{"type":"boolean"},"BerkshelfVersion":{}}},"Sd":{"type":"structure","members":{"Type":{},"Url":{},"Username":{},"Password":{},"SshKey":{},"Revision":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Type":{},"Arn":{},"DatabaseName":{}}}},"Sl":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"Certificate":{},"PrivateKey":{},"Chain":{}}},"Sm":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{},"Secure":{"type":"boolean"}}}},"Ss":{"type":"structure","required":["Name"],"members":{"Name":{},"Args":{"type":"map","key":{},"value":{"shape":"S3"}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"NoDevice":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"Iops":{"type":"integer"},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"}}}}}},"S17":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogStreams":{"type":"list","member":{"type":"structure","members":{"LogGroupName":{},"DatetimeFormat":{},"TimeZone":{},"File":{},"FileFingerprintLines":{},"MultiLineStartPattern":{},"InitialPosition":{},"Encoding":{},"BufferDuration":{"type":"integer"},"BatchCount":{"type":"integer"},"BatchSize":{"type":"integer"}}}}}},"S1f":{"type":"list","member":{"type":"structure","required":["MountPoint","NumberOfDisks","Size"],"members":{"MountPoint":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}},"S1h":{"type":"structure","members":{"Setup":{"shape":"S3"},"Configure":{"shape":"S3"},"Deploy":{"shape":"S3"},"Undeploy":{"shape":"S3"},"Shutdown":{"shape":"S3"}}},"S1i":{"type":"structure","members":{"Shutdown":{"type":"structure","members":{"ExecutionTimeout":{"type":"integer"},"DelayUntilElbConnectionsDrained":{"type":"boolean"}}}}},"S36":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"ThresholdsWaitTime":{"type":"integer"},"IgnoreMetricsTime":{"type":"integer"},"CpuThreshold":{"type":"double"},"MemoryThreshold":{"type":"double"},"LoadThreshold":{"type":"double"},"Alarms":{"shape":"S3"}}},"S4b":{"type":"structure","members":{"Monday":{"shape":"S4c"},"Tuesday":{"shape":"S4c"},"Wednesday":{"shape":"S4c"},"Thursday":{"shape":"S4c"},"Friday":{"shape":"S4c"},"Saturday":{"shape":"S4c"},"Sunday":{"shape":"S4c"}}},"S4c":{"type":"map","key":{},"value":{}},"S50":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeApps":{"result_key":"Apps"},"DescribeCommands":{"result_key":"Commands"},"DescribeDeployments":{"result_key":"Deployments"},"DescribeEcsClusters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EcsClusters"},"DescribeElasticIps":{"result_key":"ElasticIps"},"DescribeElasticLoadBalancers":{"result_key":"ElasticLoadBalancers"},"DescribeInstances":{"result_key":"Instances"},"DescribeLayers":{"result_key":"Layers"},"DescribeLoadBasedAutoScaling":{"result_key":"LoadBasedAutoScalingConfigurations"},"DescribePermissions":{"result_key":"Permissions"},"DescribeRaidArrays":{"result_key":"RaidArrays"},"DescribeServiceErrors":{"result_key":"ServiceErrors"},"DescribeStacks":{"result_key":"Stacks"},"DescribeTimeBasedAutoScaling":{"result_key":"TimeBasedAutoScalingConfigurations"},"DescribeUserProfiles":{"result_key":"UserProfiles"},"DescribeVolumes":{"result_key":"Volumes"}}}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"AppExists":{"delay":1,"operation":"DescribeApps","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"matcher":"status","expected":400,"state":"failure"}]},"DeploymentSuccessful":{"delay":15,"operation":"DescribeDeployments","maxAttempts":40,"description":"Wait until a deployment has completed successfully.","acceptors":[{"expected":"successful","matcher":"pathAll","state":"success","argument":"Deployments[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Deployments[].Status"}]},"InstanceOnline":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is online.","acceptors":[{"expected":"online","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceRegistered":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is registered.","acceptors":[{"expected":"registered","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is stopped.","acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is terminated.","acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]}}}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['opsworkscm'] = {};
	AWS.OpsWorksCM = Service.defineService('opsworkscm', ['2016-11-01']);
	Object.defineProperty(apiLoader.services['opsworkscm'], '2016-11-01', {
	  get: function get() {
	    var model = __webpack_require__(310);
	    model.paginators = __webpack_require__(311).pagination;
	    model.waiters = __webpack_require__(312).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.OpsWorksCM;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-01","endpointPrefix":"opsworks-cm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"OpsWorksCM","serviceFullName":"AWS OpsWorks CM","serviceId":"OpsWorksCM","signatureVersion":"v4","signingName":"opsworks-cm","targetPrefix":"OpsWorksCM_V2016_11_01","uid":"opsworkscm-2016-11-01"},"operations":{"AssociateNode":{"input":{"type":"structure","required":["ServerName","NodeName","EngineAttributes"],"members":{"ServerName":{},"NodeName":{},"EngineAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"NodeAssociationStatusToken":{}}}},"CreateBackup":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{},"Description":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{"Backup":{"shape":"Sh"}}}},"CreateServer":{"input":{"type":"structure","required":["Engine","ServerName","InstanceProfileArn","InstanceType","ServiceRoleArn"],"members":{"AssociatePublicIpAddress":{"type":"boolean"},"CustomDomain":{},"CustomCertificate":{},"CustomPrivateKey":{"type":"string","sensitive":true},"DisableAutomatedBackup":{"type":"boolean"},"Engine":{},"EngineModel":{},"EngineVersion":{},"EngineAttributes":{"shape":"S4"},"BackupRetentionCount":{"type":"integer"},"ServerName":{},"InstanceProfileArn":{},"InstanceType":{},"KeyPair":{},"PreferredMaintenanceWindow":{},"PreferredBackupWindow":{},"SecurityGroupIds":{"shape":"Sn"},"ServiceRoleArn":{},"SubnetIds":{"shape":"Sn"},"Tags":{"shape":"Sc"},"BackupId":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Sz"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{}}},"DeleteServer":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{}}},"output":{"type":"structure","members":{}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Attributes":{"type":"list","member":{"type":"structure","members":{"Name":{},"Maximum":{"type":"integer"},"Used":{"type":"integer"}}}}}}},"DescribeBackups":{"input":{"type":"structure","members":{"BackupId":{},"ServerName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"Sh"}},"NextToken":{}}}},"DescribeEvents":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ServerEvents":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"ServerName":{},"Message":{},"LogUrl":{}}}},"NextToken":{}}}},"DescribeNodeAssociationStatus":{"input":{"type":"structure","required":["NodeAssociationStatusToken","ServerName"],"members":{"NodeAssociationStatusToken":{},"ServerName":{}}},"output":{"type":"structure","members":{"NodeAssociationStatus":{},"EngineAttributes":{"shape":"S4"}}}},"DescribeServers":{"input":{"type":"structure","members":{"ServerName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Servers":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"DisassociateNode":{"input":{"type":"structure","required":["ServerName","NodeName"],"members":{"ServerName":{},"NodeName":{},"EngineAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"NodeAssociationStatusToken":{}}}},"ExportServerEngineAttribute":{"input":{"type":"structure","required":["ExportAttributeName","ServerName"],"members":{"ExportAttributeName":{},"ServerName":{},"InputAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"EngineAttribute":{"shape":"S5"},"ServerName":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sc"},"NextToken":{}}}},"RestoreServer":{"input":{"type":"structure","required":["BackupId","ServerName"],"members":{"BackupId":{},"ServerName":{},"InstanceType":{},"KeyPair":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Sz"}}}},"StartMaintenance":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{},"EngineAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"Server":{"shape":"Sz"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateServer":{"input":{"type":"structure","required":["ServerName"],"members":{"DisableAutomatedBackup":{"type":"boolean"},"BackupRetentionCount":{"type":"integer"},"ServerName":{},"PreferredMaintenanceWindow":{},"PreferredBackupWindow":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Sz"}}}},"UpdateServerEngineAttributes":{"input":{"type":"structure","required":["ServerName","AttributeName"],"members":{"ServerName":{},"AttributeName":{},"AttributeValue":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Sz"}}}}},"shapes":{"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","members":{"Name":{},"Value":{"type":"string","sensitive":true}}},"Sc":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sh":{"type":"structure","members":{"BackupArn":{},"BackupId":{},"BackupType":{},"CreatedAt":{"type":"timestamp"},"Description":{},"Engine":{},"EngineModel":{},"EngineVersion":{},"InstanceProfileArn":{},"InstanceType":{},"KeyPair":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"S3DataSize":{"deprecated":true,"type":"integer"},"S3DataUrl":{"deprecated":true},"S3LogUrl":{},"SecurityGroupIds":{"shape":"Sn"},"ServerName":{},"ServiceRoleArn":{},"Status":{},"StatusDescription":{},"SubnetIds":{"shape":"Sn"},"ToolsVersion":{},"UserArn":{}}},"Sn":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"BackupRetentionCount":{"type":"integer"},"ServerName":{},"CreatedAt":{"type":"timestamp"},"CloudFormationStackArn":{},"CustomDomain":{},"DisableAutomatedBackup":{"type":"boolean"},"Endpoint":{},"Engine":{},"EngineModel":{},"EngineAttributes":{"shape":"S4"},"EngineVersion":{},"InstanceProfileArn":{},"InstanceType":{},"KeyPair":{},"MaintenanceStatus":{},"PreferredMaintenanceWindow":{},"PreferredBackupWindow":{},"SecurityGroupIds":{"shape":"Sn"},"ServiceRoleArn":{},"Status":{},"StatusReason":{},"SubnetIds":{"shape":"Sn"},"ServerArn":{}}}}}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeBackups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Backups"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServerEvents"},"DescribeServers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Servers"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"NodeAssociated":{"delay":15,"maxAttempts":15,"operation":"DescribeNodeAssociationStatus","description":"Wait until node is associated or disassociated.","acceptors":[{"expected":"SUCCESS","state":"success","matcher":"path","argument":"NodeAssociationStatus"},{"expected":"FAILED","state":"failure","matcher":"path","argument":"NodeAssociationStatus"}]}}}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['organizations'] = {};
	AWS.Organizations = Service.defineService('organizations', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['organizations'], '2016-11-28', {
	  get: function get() {
	    var model = __webpack_require__(314);
	    model.paginators = __webpack_require__(315).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Organizations;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"organizations","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Organizations","serviceFullName":"AWS Organizations","serviceId":"Organizations","signatureVersion":"v4","targetPrefix":"AWSOrganizationsV20161128","uid":"organizations-2016-11-28"},"operations":{"AcceptHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"AttachPolicy":{"input":{"type":"structure","required":["PolicyId","TargetId"],"members":{"PolicyId":{},"TargetId":{}}}},"CancelHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"CloseAccount":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{}}}},"CreateAccount":{"input":{"type":"structure","required":["Email","AccountName"],"members":{"Email":{"shape":"Sp"},"AccountName":{"shape":"Sq"},"RoleName":{},"IamUserAccessToBilling":{},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{"CreateAccountStatus":{"shape":"Sy"}}}},"CreateGovCloudAccount":{"input":{"type":"structure","required":["Email","AccountName"],"members":{"Email":{"shape":"Sp"},"AccountName":{"shape":"Sq"},"RoleName":{},"IamUserAccessToBilling":{},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{"CreateAccountStatus":{"shape":"Sy"}}}},"CreateOrganization":{"input":{"type":"structure","members":{"FeatureSet":{}}},"output":{"type":"structure","members":{"Organization":{"shape":"S17"}}}},"CreateOrganizationalUnit":{"input":{"type":"structure","required":["ParentId","Name"],"members":{"ParentId":{},"Name":{},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{"OrganizationalUnit":{"shape":"S1j"}}}},"CreatePolicy":{"input":{"type":"structure","required":["Content","Description","Name","Type"],"members":{"Content":{},"Description":{},"Name":{},"Type":{},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1r"}}}},"DeclineHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"DeleteOrganization":{},"DeleteOrganizationalUnit":{"input":{"type":"structure","required":["OrganizationalUnitId"],"members":{"OrganizationalUnitId":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{}}}},"DeregisterDelegatedAdministrator":{"input":{"type":"structure","required":["AccountId","ServicePrincipal"],"members":{"AccountId":{},"ServicePrincipal":{}}}},"DescribeAccount":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{}}},"output":{"type":"structure","members":{"Account":{"shape":"S23"}}}},"DescribeCreateAccountStatus":{"input":{"type":"structure","required":["CreateAccountRequestId"],"members":{"CreateAccountRequestId":{}}},"output":{"type":"structure","members":{"CreateAccountStatus":{"shape":"Sy"}}}},"DescribeEffectivePolicy":{"input":{"type":"structure","required":["PolicyType"],"members":{"PolicyType":{},"TargetId":{}}},"output":{"type":"structure","members":{"EffectivePolicy":{"type":"structure","members":{"PolicyContent":{},"LastUpdatedTimestamp":{"type":"timestamp"},"TargetId":{},"PolicyType":{}}}}}},"DescribeHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"DescribeOrganization":{"output":{"type":"structure","members":{"Organization":{"shape":"S17"}}}},"DescribeOrganizationalUnit":{"input":{"type":"structure","required":["OrganizationalUnitId"],"members":{"OrganizationalUnitId":{}}},"output":{"type":"structure","members":{"OrganizationalUnit":{"shape":"S1j"}}}},"DescribePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1r"}}}},"DetachPolicy":{"input":{"type":"structure","required":["PolicyId","TargetId"],"members":{"PolicyId":{},"TargetId":{}}}},"DisableAWSServiceAccess":{"input":{"type":"structure","required":["ServicePrincipal"],"members":{"ServicePrincipal":{}}}},"DisablePolicyType":{"input":{"type":"structure","required":["RootId","PolicyType"],"members":{"RootId":{},"PolicyType":{}}},"output":{"type":"structure","members":{"Root":{"shape":"S2p"}}}},"EnableAWSServiceAccess":{"input":{"type":"structure","required":["ServicePrincipal"],"members":{"ServicePrincipal":{}}}},"EnableAllFeatures":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"EnablePolicyType":{"input":{"type":"structure","required":["RootId","PolicyType"],"members":{"RootId":{},"PolicyType":{}}},"output":{"type":"structure","members":{"Root":{"shape":"S2p"}}}},"InviteAccountToOrganization":{"input":{"type":"structure","required":["Target"],"members":{"Target":{"shape":"S7"},"Notes":{"type":"string","sensitive":true},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"LeaveOrganization":{},"ListAWSServiceAccessForOrganization":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EnabledServicePrincipals":{"type":"list","member":{"type":"structure","members":{"ServicePrincipal":{},"DateEnabled":{"type":"timestamp"}}}},"NextToken":{}}}},"ListAccounts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Accounts":{"shape":"S38"},"NextToken":{}}}},"ListAccountsForParent":{"input":{"type":"structure","required":["ParentId"],"members":{"ParentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Accounts":{"shape":"S38"},"NextToken":{}}}},"ListChildren":{"input":{"type":"structure","required":["ParentId","ChildType"],"members":{"ParentId":{},"ChildType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Children":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{}}}},"NextToken":{}}}},"ListCreateAccountStatus":{"input":{"type":"structure","members":{"States":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CreateAccountStatuses":{"type":"list","member":{"shape":"Sy"}},"NextToken":{}}}},"ListDelegatedAdministrators":{"input":{"type":"structure","members":{"ServicePrincipal":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DelegatedAdministrators":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Email":{"shape":"Sp"},"Name":{"shape":"S24"},"Status":{},"JoinedMethod":{},"JoinedTimestamp":{"type":"timestamp"},"DelegationEnabledDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListDelegatedServicesForAccount":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DelegatedServices":{"type":"list","member":{"type":"structure","members":{"ServicePrincipal":{},"DelegationEnabledDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListHandshakesForAccount":{"input":{"type":"structure","members":{"Filter":{"shape":"S3u"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Handshakes":{"shape":"S3w"},"NextToken":{}}}},"ListHandshakesForOrganization":{"input":{"type":"structure","members":{"Filter":{"shape":"S3u"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Handshakes":{"shape":"S3w"},"NextToken":{}}}},"ListOrganizationalUnitsForParent":{"input":{"type":"structure","required":["ParentId"],"members":{"ParentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationalUnits":{"type":"list","member":{"shape":"S1j"}},"NextToken":{}}}},"ListParents":{"input":{"type":"structure","required":["ChildId"],"members":{"ChildId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Parents":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{}}}},"NextToken":{}}}},"ListPolicies":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Policies":{"shape":"S49"},"NextToken":{}}}},"ListPoliciesForTarget":{"input":{"type":"structure","required":["TargetId","Filter"],"members":{"TargetId":{},"Filter":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Policies":{"shape":"S49"},"NextToken":{}}}},"ListRoots":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Roots":{"type":"list","member":{"shape":"S2p"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"St"},"NextToken":{}}}},"ListTargetsForPolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"Arn":{},"Name":{},"Type":{}}}},"NextToken":{}}}},"MoveAccount":{"input":{"type":"structure","required":["AccountId","SourceParentId","DestinationParentId"],"members":{"AccountId":{},"SourceParentId":{},"DestinationParentId":{}}}},"RegisterDelegatedAdministrator":{"input":{"type":"structure","required":["AccountId","ServicePrincipal"],"members":{"AccountId":{},"ServicePrincipal":{}}}},"RemoveAccountFromOrganization":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"St"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateOrganizationalUnit":{"input":{"type":"structure","required":["OrganizationalUnitId"],"members":{"OrganizationalUnitId":{},"Name":{}}},"output":{"type":"structure","members":{"OrganizationalUnit":{"shape":"S1j"}}}},"UpdatePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"Name":{},"Description":{},"Content":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1r"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"Arn":{},"Parties":{"type":"list","member":{"shape":"S7"}},"State":{},"RequestedTimestamp":{"type":"timestamp"},"ExpirationTimestamp":{"type":"timestamp"},"Action":{},"Resources":{"shape":"Sd"}}},"S7":{"type":"structure","required":["Id","Type"],"members":{"Id":{"type":"string","sensitive":true},"Type":{}}},"Sd":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"string","sensitive":true},"Type":{},"Resources":{"shape":"Sd"}}}},"Sp":{"type":"string","sensitive":true},"Sq":{"type":"string","sensitive":true},"St":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sy":{"type":"structure","members":{"Id":{},"AccountName":{"shape":"Sq"},"State":{},"RequestedTimestamp":{"type":"timestamp"},"CompletedTimestamp":{"type":"timestamp"},"AccountId":{},"GovCloudAccountId":{},"FailureReason":{}}},"S17":{"type":"structure","members":{"Id":{},"Arn":{},"FeatureSet":{},"MasterAccountArn":{},"MasterAccountId":{},"MasterAccountEmail":{"shape":"Sp"},"AvailablePolicyTypes":{"shape":"S1b"}}},"S1b":{"type":"list","member":{"type":"structure","members":{"Type":{},"Status":{}}}},"S1j":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S1r":{"type":"structure","members":{"PolicySummary":{"shape":"S1s"},"Content":{}}},"S1s":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Type":{},"AwsManaged":{"type":"boolean"}}},"S23":{"type":"structure","members":{"Id":{},"Arn":{},"Email":{"shape":"Sp"},"Name":{"shape":"S24"},"Status":{},"JoinedMethod":{},"JoinedTimestamp":{"type":"timestamp"}}},"S24":{"type":"string","sensitive":true},"S2p":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"PolicyTypes":{"shape":"S1b"}}},"S38":{"type":"list","member":{"shape":"S23"}},"S3u":{"type":"structure","members":{"ActionType":{},"ParentHandshakeId":{}}},"S3w":{"type":"list","member":{"shape":"S4"}},"S49":{"type":"list","member":{"shape":"S1s"}}}}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAWSServiceAccessForOrganization":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAccounts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAccountsForParent":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListChildren":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCreateAccountStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDelegatedAdministrators":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DelegatedAdministrators"},"ListDelegatedServicesForAccount":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DelegatedServices"},"ListHandshakesForAccount":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListHandshakesForOrganization":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListOrganizationalUnitsForParent":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListParents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPoliciesForTarget":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListRoots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","result_key":"Tags"},"ListTargetsForPolicy":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['pinpoint'] = {};
	AWS.Pinpoint = Service.defineService('pinpoint', ['2016-12-01']);
	Object.defineProperty(apiLoader.services['pinpoint'], '2016-12-01', {
	  get: function get() {
	    var model = __webpack_require__(317);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Pinpoint;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2016-12-01","endpointPrefix":"pinpoint","signingName":"mobiletargeting","serviceFullName":"Amazon Pinpoint","serviceId":"Pinpoint","protocol":"rest-json","jsonVersion":"1.1","uid":"pinpoint-2016-12-01","signatureVersion":"v4"},"operations":{"CreateApp":{"http":{"requestUri":"/v1/apps","responseCode":201},"input":{"type":"structure","members":{"CreateApplicationRequest":{"type":"structure","members":{"Name":{},"tags":{"shape":"S4","locationName":"tags"}},"required":["Name"]}},"required":["CreateApplicationRequest"],"payload":"CreateApplicationRequest"},"output":{"type":"structure","members":{"ApplicationResponse":{"shape":"S6"}},"required":["ApplicationResponse"],"payload":"ApplicationResponse"}},"CreateCampaign":{"http":{"requestUri":"/v1/apps/{application-id}/campaigns","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteCampaignRequest":{"shape":"S8"}},"required":["ApplicationId","WriteCampaignRequest"],"payload":"WriteCampaignRequest"},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S1j"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"CreateEmailTemplate":{"http":{"requestUri":"/v1/templates/{template-name}/email","responseCode":201},"input":{"type":"structure","members":{"EmailTemplateRequest":{"shape":"S1p"},"TemplateName":{"location":"uri","locationName":"template-name"}},"required":["TemplateName","EmailTemplateRequest"],"payload":"EmailTemplateRequest"},"output":{"type":"structure","members":{"CreateTemplateMessageBody":{"shape":"S1r"}},"required":["CreateTemplateMessageBody"],"payload":"CreateTemplateMessageBody"}},"CreateExportJob":{"http":{"requestUri":"/v1/apps/{application-id}/jobs/export","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"ExportJobRequest":{"type":"structure","members":{"RoleArn":{},"S3UrlPrefix":{},"SegmentId":{},"SegmentVersion":{"type":"integer"}},"required":["S3UrlPrefix","RoleArn"]}},"required":["ApplicationId","ExportJobRequest"],"payload":"ExportJobRequest"},"output":{"type":"structure","members":{"ExportJobResponse":{"shape":"S1v"}},"required":["ExportJobResponse"],"payload":"ExportJobResponse"}},"CreateImportJob":{"http":{"requestUri":"/v1/apps/{application-id}/jobs/import","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"ImportJobRequest":{"type":"structure","members":{"DefineSegment":{"type":"boolean"},"ExternalId":{},"Format":{},"RegisterEndpoints":{"type":"boolean"},"RoleArn":{},"S3Url":{},"SegmentId":{},"SegmentName":{}},"required":["Format","S3Url","RoleArn"]}},"required":["ApplicationId","ImportJobRequest"],"payload":"ImportJobRequest"},"output":{"type":"structure","members":{"ImportJobResponse":{"shape":"S22"}},"required":["ImportJobResponse"],"payload":"ImportJobResponse"}},"CreateInAppTemplate":{"http":{"requestUri":"/v1/templates/{template-name}/inapp","responseCode":201},"input":{"type":"structure","members":{"InAppTemplateRequest":{"shape":"S25"},"TemplateName":{"location":"uri","locationName":"template-name"}},"required":["TemplateName","InAppTemplateRequest"],"payload":"InAppTemplateRequest"},"output":{"type":"structure","members":{"TemplateCreateMessageBody":{"type":"structure","members":{"Arn":{},"Message":{},"RequestID":{}}}},"required":["TemplateCreateMessageBody"],"payload":"TemplateCreateMessageBody"}},"CreateJourney":{"http":{"requestUri":"/v1/apps/{application-id}/journeys","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteJourneyRequest":{"shape":"S29"}},"required":["ApplicationId","WriteJourneyRequest"],"payload":"WriteJourneyRequest"},"output":{"type":"structure","members":{"JourneyResponse":{"shape":"S3j"}},"required":["JourneyResponse"],"payload":"JourneyResponse"}},"CreatePushTemplate":{"http":{"requestUri":"/v1/templates/{template-name}/push","responseCode":201},"input":{"type":"structure","members":{"PushNotificationTemplateRequest":{"shape":"S3l"},"TemplateName":{"location":"uri","locationName":"template-name"}},"required":["TemplateName","PushNotificationTemplateRequest"],"payload":"PushNotificationTemplateRequest"},"output":{"type":"structure","members":{"CreateTemplateMessageBody":{"shape":"S1r"}},"required":["CreateTemplateMessageBody"],"payload":"CreateTemplateMessageBody"}},"CreateRecommenderConfiguration":{"http":{"requestUri":"/v1/recommenders","responseCode":201},"input":{"type":"structure","members":{"CreateRecommenderConfiguration":{"type":"structure","members":{"Attributes":{"shape":"S4"},"Description":{},"Name":{},"RecommendationProviderIdType":{},"RecommendationProviderRoleArn":{},"RecommendationProviderUri":{},"RecommendationTransformerUri":{},"RecommendationsDisplayName":{},"RecommendationsPerMessage":{"type":"integer"}},"required":["RecommendationProviderUri","RecommendationProviderRoleArn"]}},"required":["CreateRecommenderConfiguration"],"payload":"CreateRecommenderConfiguration"},"output":{"type":"structure","members":{"RecommenderConfigurationResponse":{"shape":"S3t"}},"required":["RecommenderConfigurationResponse"],"payload":"RecommenderConfigurationResponse"}},"CreateSegment":{"http":{"requestUri":"/v1/apps/{application-id}/segments","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteSegmentRequest":{"shape":"S3v"}},"required":["ApplicationId","WriteSegmentRequest"],"payload":"WriteSegmentRequest"},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S46"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"CreateSmsTemplate":{"http":{"requestUri":"/v1/templates/{template-name}/sms","responseCode":201},"input":{"type":"structure","members":{"SMSTemplateRequest":{"shape":"S4b"},"TemplateName":{"location":"uri","locationName":"template-name"}},"required":["TemplateName","SMSTemplateRequest"],"payload":"SMSTemplateRequest"},"output":{"type":"structure","members":{"CreateTemplateMessageBody":{"shape":"S1r"}},"required":["CreateTemplateMessageBody"],"payload":"CreateTemplateMessageBody"}},"CreateVoiceTemplate":{"http":{"requestUri":"/v1/templates/{template-name}/voice","responseCode":201},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"VoiceTemplateRequest":{"shape":"S4e"}},"required":["TemplateName","VoiceTemplateRequest"],"payload":"VoiceTemplateRequest"},"output":{"type":"structure","members":{"CreateTemplateMessageBody":{"shape":"S1r"}},"required":["CreateTemplateMessageBody"],"payload":"CreateTemplateMessageBody"}},"DeleteAdmChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/adm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ADMChannelResponse":{"shape":"S4i"}},"required":["ADMChannelResponse"],"payload":"ADMChannelResponse"}},"DeleteApnsChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSChannelResponse":{"shape":"S4l"}},"required":["APNSChannelResponse"],"payload":"APNSChannelResponse"}},"DeleteApnsSandboxChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSSandboxChannelResponse":{"shape":"S4o"}},"required":["APNSSandboxChannelResponse"],"payload":"APNSSandboxChannelResponse"}},"DeleteApnsVoipChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns_voip","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipChannelResponse":{"shape":"S4r"}},"required":["APNSVoipChannelResponse"],"payload":"APNSVoipChannelResponse"}},"DeleteApnsVoipSandboxChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns_voip_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipSandboxChannelResponse":{"shape":"S4u"}},"required":["APNSVoipSandboxChannelResponse"],"payload":"APNSVoipSandboxChannelResponse"}},"DeleteApp":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationResponse":{"shape":"S6"}},"required":["ApplicationResponse"],"payload":"ApplicationResponse"}},"DeleteBaiduChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/baidu","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"BaiduChannelResponse":{"shape":"S4z"}},"required":["BaiduChannelResponse"],"payload":"BaiduChannelResponse"}},"DeleteCampaign":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"}},"required":["CampaignId","ApplicationId"]},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S1j"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"DeleteEmailChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/email","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EmailChannelResponse":{"shape":"S54"}},"required":["EmailChannelResponse"],"payload":"EmailChannelResponse"}},"DeleteEmailTemplate":{"http":{"method":"DELETE","requestUri":"/v1/templates/{template-name}/email","responseCode":202},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"DeleteEndpoint":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"}},"required":["ApplicationId","EndpointId"]},"output":{"type":"structure","members":{"EndpointResponse":{"shape":"S5a"}},"required":["EndpointResponse"],"payload":"EndpointResponse"}},"DeleteEventStream":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/eventstream","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EventStream":{"shape":"S5j"}},"required":["EventStream"],"payload":"EventStream"}},"DeleteGcmChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/gcm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"GCMChannelResponse":{"shape":"S5m"}},"required":["GCMChannelResponse"],"payload":"GCMChannelResponse"}},"DeleteInAppTemplate":{"http":{"method":"DELETE","requestUri":"/v1/templates/{template-name}/inapp","responseCode":202},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"DeleteJourney":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JourneyId":{"location":"uri","locationName":"journey-id"}},"required":["JourneyId","ApplicationId"]},"output":{"type":"structure","members":{"JourneyResponse":{"shape":"S3j"}},"required":["JourneyResponse"],"payload":"JourneyResponse"}},"DeletePushTemplate":{"http":{"method":"DELETE","requestUri":"/v1/templates/{template-name}/push","responseCode":202},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"DeleteRecommenderConfiguration":{"http":{"method":"DELETE","requestUri":"/v1/recommenders/{recommender-id}","responseCode":200},"input":{"type":"structure","members":{"RecommenderId":{"location":"uri","locationName":"recommender-id"}},"required":["RecommenderId"]},"output":{"type":"structure","members":{"RecommenderConfigurationResponse":{"shape":"S3t"}},"required":["RecommenderConfigurationResponse"],"payload":"RecommenderConfigurationResponse"}},"DeleteSegment":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/segments/{segment-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S46"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"DeleteSmsChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/sms","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"SMSChannelResponse":{"shape":"S5z"}},"required":["SMSChannelResponse"],"payload":"SMSChannelResponse"}},"DeleteSmsTemplate":{"http":{"method":"DELETE","requestUri":"/v1/templates/{template-name}/sms","responseCode":202},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"DeleteUserEndpoints":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/users/{user-id}","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"UserId":{"location":"uri","locationName":"user-id"}},"required":["ApplicationId","UserId"]},"output":{"type":"structure","members":{"EndpointsResponse":{"shape":"S64"}},"required":["EndpointsResponse"],"payload":"EndpointsResponse"}},"DeleteVoiceChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/voice","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"VoiceChannelResponse":{"shape":"S68"}},"required":["VoiceChannelResponse"],"payload":"VoiceChannelResponse"}},"DeleteVoiceTemplate":{"http":{"method":"DELETE","requestUri":"/v1/templates/{template-name}/voice","responseCode":202},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"GetAdmChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/adm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ADMChannelResponse":{"shape":"S4i"}},"required":["ADMChannelResponse"],"payload":"ADMChannelResponse"}},"GetApnsChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSChannelResponse":{"shape":"S4l"}},"required":["APNSChannelResponse"],"payload":"APNSChannelResponse"}},"GetApnsSandboxChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSSandboxChannelResponse":{"shape":"S4o"}},"required":["APNSSandboxChannelResponse"],"payload":"APNSSandboxChannelResponse"}},"GetApnsVoipChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns_voip","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipChannelResponse":{"shape":"S4r"}},"required":["APNSVoipChannelResponse"],"payload":"APNSVoipChannelResponse"}},"GetApnsVoipSandboxChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns_voip_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipSandboxChannelResponse":{"shape":"S4u"}},"required":["APNSVoipSandboxChannelResponse"],"payload":"APNSVoipSandboxChannelResponse"}},"GetApp":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationResponse":{"shape":"S6"}},"required":["ApplicationResponse"],"payload":"ApplicationResponse"}},"GetApplicationDateRangeKpi":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/kpis/daterange/{kpi-name}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndTime":{"shape":"S3c","location":"querystring","locationName":"end-time"},"KpiName":{"location":"uri","locationName":"kpi-name"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"StartTime":{"shape":"S3c","location":"querystring","locationName":"start-time"}},"required":["ApplicationId","KpiName"]},"output":{"type":"structure","members":{"ApplicationDateRangeKpiResponse":{"type":"structure","members":{"ApplicationId":{},"EndTime":{"shape":"S3c"},"KpiName":{},"KpiResult":{"shape":"S6q"},"NextToken":{},"StartTime":{"shape":"S3c"}},"required":["KpiResult","KpiName","EndTime","StartTime","ApplicationId"]}},"required":["ApplicationDateRangeKpiResponse"],"payload":"ApplicationDateRangeKpiResponse"}},"GetApplicationSettings":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/settings","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationSettingsResource":{"shape":"S6x"}},"required":["ApplicationSettingsResource"],"payload":"ApplicationSettingsResource"}},"GetApps":{"http":{"method":"GET","requestUri":"/v1/apps","responseCode":200},"input":{"type":"structure","members":{"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}}},"output":{"type":"structure","members":{"ApplicationsResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S6"}},"NextToken":{}}}},"required":["ApplicationsResponse"],"payload":"ApplicationsResponse"}},"GetBaiduChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/baidu","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"BaiduChannelResponse":{"shape":"S4z"}},"required":["BaiduChannelResponse"],"payload":"BaiduChannelResponse"}},"GetCampaign":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"}},"required":["CampaignId","ApplicationId"]},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S1j"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"GetCampaignActivities":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/activities","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId","CampaignId"]},"output":{"type":"structure","members":{"ActivitiesResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"CampaignId":{},"End":{},"Id":{},"Result":{},"ScheduledStart":{},"Start":{},"State":{},"SuccessfulEndpointCount":{"type":"integer"},"TimezonesCompletedCount":{"type":"integer"},"TimezonesTotalCount":{"type":"integer"},"TotalEndpointCount":{"type":"integer"},"TreatmentId":{}},"required":["CampaignId","Id","ApplicationId"]}},"NextToken":{}},"required":["Item"]}},"required":["ActivitiesResponse"],"payload":"ActivitiesResponse"}},"GetCampaignDateRangeKpi":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/kpis/daterange/{kpi-name}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"EndTime":{"shape":"S3c","location":"querystring","locationName":"end-time"},"KpiName":{"location":"uri","locationName":"kpi-name"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"StartTime":{"shape":"S3c","location":"querystring","locationName":"start-time"}},"required":["ApplicationId","KpiName","CampaignId"]},"output":{"type":"structure","members":{"CampaignDateRangeKpiResponse":{"type":"structure","members":{"ApplicationId":{},"CampaignId":{},"EndTime":{"shape":"S3c"},"KpiName":{},"KpiResult":{"shape":"S6q"},"NextToken":{},"StartTime":{"shape":"S3c"}},"required":["KpiResult","KpiName","EndTime","CampaignId","StartTime","ApplicationId"]}},"required":["CampaignDateRangeKpiResponse"],"payload":"CampaignDateRangeKpiResponse"}},"GetCampaignVersion":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/versions/{version}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"Version":{"location":"uri","locationName":"version"}},"required":["Version","ApplicationId","CampaignId"]},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S1j"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"GetCampaignVersions":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/versions","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId","CampaignId"]},"output":{"type":"structure","members":{"CampaignsResponse":{"shape":"S7i"}},"required":["CampaignsResponse"],"payload":"CampaignsResponse"}},"GetCampaigns":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"CampaignsResponse":{"shape":"S7i"}},"required":["CampaignsResponse"],"payload":"CampaignsResponse"}},"GetChannels":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ChannelsResponse":{"type":"structure","members":{"Channels":{"type":"map","key":{},"value":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Version":{"type":"integer"}}}}},"required":["Channels"]}},"required":["ChannelsResponse"],"payload":"ChannelsResponse"}},"GetEmailChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/email","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EmailChannelResponse":{"shape":"S54"}},"required":["EmailChannelResponse"],"payload":"EmailChannelResponse"}},"GetEmailTemplate":{"http":{"method":"GET","requestUri":"/v1/templates/{template-name}/email","responseCode":200},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"EmailTemplateResponse":{"type":"structure","members":{"Arn":{},"CreationDate":{},"DefaultSubstitutions":{},"HtmlPart":{},"LastModifiedDate":{},"RecommenderId":{},"Subject":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"TextPart":{},"Version":{}},"required":["LastModifiedDate","CreationDate","TemplateName","TemplateType"]}},"required":["EmailTemplateResponse"],"payload":"EmailTemplateResponse"}},"GetEndpoint":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"}},"required":["ApplicationId","EndpointId"]},"output":{"type":"structure","members":{"EndpointResponse":{"shape":"S5a"}},"required":["EndpointResponse"],"payload":"EndpointResponse"}},"GetEventStream":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/eventstream","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EventStream":{"shape":"S5j"}},"required":["EventStream"],"payload":"EventStream"}},"GetExportJob":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/export/{job-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JobId":{"location":"uri","locationName":"job-id"}},"required":["ApplicationId","JobId"]},"output":{"type":"structure","members":{"ExportJobResponse":{"shape":"S1v"}},"required":["ExportJobResponse"],"payload":"ExportJobResponse"}},"GetExportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/export","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ExportJobsResponse":{"shape":"S85"}},"required":["ExportJobsResponse"],"payload":"ExportJobsResponse"}},"GetGcmChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/gcm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"GCMChannelResponse":{"shape":"S5m"}},"required":["GCMChannelResponse"],"payload":"GCMChannelResponse"}},"GetImportJob":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/import/{job-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JobId":{"location":"uri","locationName":"job-id"}},"required":["ApplicationId","JobId"]},"output":{"type":"structure","members":{"ImportJobResponse":{"shape":"S22"}},"required":["ImportJobResponse"],"payload":"ImportJobResponse"}},"GetImportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/import","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ImportJobsResponse":{"shape":"S8d"}},"required":["ImportJobsResponse"],"payload":"ImportJobsResponse"}},"GetInAppMessages":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}/inappmessages","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"}},"required":["ApplicationId","EndpointId"]},"output":{"type":"structure","members":{"InAppMessagesResponse":{"type":"structure","members":{"InAppMessageCampaigns":{"type":"list","member":{"type":"structure","members":{"CampaignId":{},"DailyCap":{"type":"integer"},"InAppMessage":{"type":"structure","members":{"Content":{"shape":"So"},"CustomConfig":{"shape":"S4"},"Layout":{}}},"Priority":{"type":"integer"},"Schedule":{"type":"structure","members":{"EndDate":{},"EventFilter":{"shape":"Sz"},"QuietTime":{"shape":"S1c"}}},"SessionCap":{"type":"integer"},"TotalCap":{"type":"integer"},"TreatmentId":{}}}}}}},"required":["InAppMessagesResponse"],"payload":"InAppMessagesResponse"}},"GetInAppTemplate":{"http":{"method":"GET","requestUri":"/v1/templates/{template-name}/inapp","responseCode":200},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"InAppTemplateResponse":{"type":"structure","members":{"Arn":{},"Content":{"shape":"So"},"CreationDate":{},"CustomConfig":{"shape":"S4"},"LastModifiedDate":{},"Layout":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"Version":{}},"required":["LastModifiedDate","CreationDate","TemplateName","TemplateType"]}},"required":["InAppTemplateResponse"],"payload":"InAppTemplateResponse"}},"GetJourney":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JourneyId":{"location":"uri","locationName":"journey-id"}},"required":["JourneyId","ApplicationId"]},"output":{"type":"structure","members":{"JourneyResponse":{"shape":"S3j"}},"required":["JourneyResponse"],"payload":"JourneyResponse"}},"GetJourneyDateRangeKpi":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}/kpis/daterange/{kpi-name}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndTime":{"shape":"S3c","location":"querystring","locationName":"end-time"},"JourneyId":{"location":"uri","locationName":"journey-id"},"KpiName":{"location":"uri","locationName":"kpi-name"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"StartTime":{"shape":"S3c","location":"querystring","locationName":"start-time"}},"required":["JourneyId","ApplicationId","KpiName"]},"output":{"type":"structure","members":{"JourneyDateRangeKpiResponse":{"type":"structure","members":{"ApplicationId":{},"EndTime":{"shape":"S3c"},"JourneyId":{},"KpiName":{},"KpiResult":{"shape":"S6q"},"NextToken":{},"StartTime":{"shape":"S3c"}},"required":["KpiResult","KpiName","JourneyId","EndTime","StartTime","ApplicationId"]}},"required":["JourneyDateRangeKpiResponse"],"payload":"JourneyDateRangeKpiResponse"}},"GetJourneyExecutionActivityMetrics":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}/activities/{journey-activity-id}/execution-metrics","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JourneyActivityId":{"location":"uri","locationName":"journey-activity-id"},"JourneyId":{"location":"uri","locationName":"journey-id"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"}},"required":["JourneyActivityId","ApplicationId","JourneyId"]},"output":{"type":"structure","members":{"JourneyExecutionActivityMetricsResponse":{"type":"structure","members":{"ActivityType":{},"ApplicationId":{},"JourneyActivityId":{},"JourneyId":{},"LastEvaluatedTime":{},"Metrics":{"shape":"S4"}},"required":["Metrics","JourneyId","LastEvaluatedTime","JourneyActivityId","ActivityType","ApplicationId"]}},"required":["JourneyExecutionActivityMetricsResponse"],"payload":"JourneyExecutionActivityMetricsResponse"}},"GetJourneyExecutionMetrics":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}/execution-metrics","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JourneyId":{"location":"uri","locationName":"journey-id"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"}},"required":["ApplicationId","JourneyId"]},"output":{"type":"structure","members":{"JourneyExecutionMetricsResponse":{"type":"structure","members":{"ApplicationId":{},"JourneyId":{},"LastEvaluatedTime":{},"Metrics":{"shape":"S4"}},"required":["Metrics","JourneyId","LastEvaluatedTime","ApplicationId"]}},"required":["JourneyExecutionMetricsResponse"],"payload":"JourneyExecutionMetricsResponse"}},"GetPushTemplate":{"http":{"method":"GET","requestUri":"/v1/templates/{template-name}/push","responseCode":200},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"PushNotificationTemplateResponse":{"type":"structure","members":{"ADM":{"shape":"S3m"},"APNS":{"shape":"S3n"},"Arn":{},"Baidu":{"shape":"S3m"},"CreationDate":{},"Default":{"shape":"S3o"},"DefaultSubstitutions":{},"GCM":{"shape":"S3m"},"LastModifiedDate":{},"RecommenderId":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"Version":{}},"required":["LastModifiedDate","CreationDate","TemplateType","TemplateName"]}},"required":["PushNotificationTemplateResponse"],"payload":"PushNotificationTemplateResponse"}},"GetRecommenderConfiguration":{"http":{"method":"GET","requestUri":"/v1/recommenders/{recommender-id}","responseCode":200},"input":{"type":"structure","members":{"RecommenderId":{"location":"uri","locationName":"recommender-id"}},"required":["RecommenderId"]},"output":{"type":"structure","members":{"RecommenderConfigurationResponse":{"shape":"S3t"}},"required":["RecommenderConfigurationResponse"],"payload":"RecommenderConfigurationResponse"}},"GetRecommenderConfigurations":{"http":{"method":"GET","requestUri":"/v1/recommenders","responseCode":200},"input":{"type":"structure","members":{"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}}},"output":{"type":"structure","members":{"ListRecommenderConfigurationsResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S3t"}},"NextToken":{}},"required":["Item"]}},"required":["ListRecommenderConfigurationsResponse"],"payload":"ListRecommenderConfigurationsResponse"}},"GetSegment":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S46"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"GetSegmentExportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/jobs/export","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Token":{"location":"querystring","locationName":"token"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"ExportJobsResponse":{"shape":"S85"}},"required":["ExportJobsResponse"],"payload":"ExportJobsResponse"}},"GetSegmentImportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/jobs/import","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Token":{"location":"querystring","locationName":"token"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"ImportJobsResponse":{"shape":"S8d"}},"required":["ImportJobsResponse"],"payload":"ImportJobsResponse"}},"GetSegmentVersion":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/versions/{version}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Version":{"location":"uri","locationName":"version"}},"required":["SegmentId","Version","ApplicationId"]},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S46"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"GetSegmentVersions":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/versions","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Token":{"location":"querystring","locationName":"token"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"SegmentsResponse":{"shape":"S9j"}},"required":["SegmentsResponse"],"payload":"SegmentsResponse"}},"GetSegments":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"SegmentsResponse":{"shape":"S9j"}},"required":["SegmentsResponse"],"payload":"SegmentsResponse"}},"GetSmsChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/sms","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"SMSChannelResponse":{"shape":"S5z"}},"required":["SMSChannelResponse"],"payload":"SMSChannelResponse"}},"GetSmsTemplate":{"http":{"method":"GET","requestUri":"/v1/templates/{template-name}/sms","responseCode":200},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"SMSTemplateResponse":{"type":"structure","members":{"Arn":{},"Body":{},"CreationDate":{},"DefaultSubstitutions":{},"LastModifiedDate":{},"RecommenderId":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"Version":{}},"required":["LastModifiedDate","CreationDate","TemplateName","TemplateType"]}},"required":["SMSTemplateResponse"],"payload":"SMSTemplateResponse"}},"GetUserEndpoints":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/users/{user-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"UserId":{"location":"uri","locationName":"user-id"}},"required":["ApplicationId","UserId"]},"output":{"type":"structure","members":{"EndpointsResponse":{"shape":"S64"}},"required":["EndpointsResponse"],"payload":"EndpointsResponse"}},"GetVoiceChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/voice","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"VoiceChannelResponse":{"shape":"S68"}},"required":["VoiceChannelResponse"],"payload":"VoiceChannelResponse"}},"GetVoiceTemplate":{"http":{"method":"GET","requestUri":"/v1/templates/{template-name}/voice","responseCode":200},"input":{"type":"structure","members":{"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName"]},"output":{"type":"structure","members":{"VoiceTemplateResponse":{"type":"structure","members":{"Arn":{},"Body":{},"CreationDate":{},"DefaultSubstitutions":{},"LanguageCode":{},"LastModifiedDate":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"Version":{},"VoiceId":{}},"required":["LastModifiedDate","CreationDate","TemplateName","TemplateType"]}},"required":["VoiceTemplateResponse"],"payload":"VoiceTemplateResponse"}},"ListJourneys":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/journeys","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"JourneysResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S3j"}},"NextToken":{}},"required":["Item"]}},"required":["JourneysResponse"],"payload":"JourneysResponse"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"TagsModel":{"shape":"Sa5"}},"required":["TagsModel"],"payload":"TagsModel"}},"ListTemplateVersions":{"http":{"method":"GET","requestUri":"/v1/templates/{template-name}/{template-type}/versions","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"TemplateName":{"location":"uri","locationName":"template-name"},"TemplateType":{"location":"uri","locationName":"template-type"}},"required":["TemplateName","TemplateType"]},"output":{"type":"structure","members":{"TemplateVersionsResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"type":"structure","members":{"CreationDate":{},"DefaultSubstitutions":{},"LastModifiedDate":{},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"Version":{}},"required":["LastModifiedDate","CreationDate","TemplateName","TemplateType"]}},"Message":{},"NextToken":{},"RequestID":{}},"required":["Item"]}},"required":["TemplateVersionsResponse"],"payload":"TemplateVersionsResponse"}},"ListTemplates":{"http":{"method":"GET","requestUri":"/v1/templates","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"Prefix":{"location":"querystring","locationName":"prefix"},"TemplateType":{"location":"querystring","locationName":"template-type"}}},"output":{"type":"structure","members":{"TemplatesResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationDate":{},"DefaultSubstitutions":{},"LastModifiedDate":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TemplateName":{},"TemplateType":{},"Version":{}},"required":["LastModifiedDate","CreationDate","TemplateName","TemplateType"]}},"NextToken":{}},"required":["Item"]}},"required":["TemplatesResponse"],"payload":"TemplatesResponse"}},"PhoneNumberValidate":{"http":{"requestUri":"/v1/phone/number/validate","responseCode":200},"input":{"type":"structure","members":{"NumberValidateRequest":{"type":"structure","members":{"IsoCountryCode":{},"PhoneNumber":{}}}},"required":["NumberValidateRequest"],"payload":"NumberValidateRequest"},"output":{"type":"structure","members":{"NumberValidateResponse":{"type":"structure","members":{"Carrier":{},"City":{},"CleansedPhoneNumberE164":{},"CleansedPhoneNumberNational":{},"Country":{},"CountryCodeIso2":{},"CountryCodeNumeric":{},"County":{},"OriginalCountryCodeIso2":{},"OriginalPhoneNumber":{},"PhoneType":{},"PhoneTypeCode":{"type":"integer"},"Timezone":{},"ZipCode":{}}}},"required":["NumberValidateResponse"],"payload":"NumberValidateResponse"}},"PutEventStream":{"http":{"requestUri":"/v1/apps/{application-id}/eventstream","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteEventStream":{"type":"structure","members":{"DestinationStreamArn":{},"RoleArn":{}},"required":["RoleArn","DestinationStreamArn"]}},"required":["ApplicationId","WriteEventStream"],"payload":"WriteEventStream"},"output":{"type":"structure","members":{"EventStream":{"shape":"S5j"}},"required":["EventStream"],"payload":"EventStream"}},"PutEvents":{"http":{"requestUri":"/v1/apps/{application-id}/events","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EventsRequest":{"type":"structure","members":{"BatchItem":{"type":"map","key":{},"value":{"type":"structure","members":{"Endpoint":{"type":"structure","members":{"Address":{},"Attributes":{"shape":"S5b"},"ChannelType":{},"Demographic":{"shape":"S5d"},"EffectiveDate":{},"EndpointStatus":{},"Location":{"shape":"S5e"},"Metrics":{"shape":"S5f"},"OptOut":{},"RequestId":{},"User":{"shape":"S5g"}}},"Events":{"type":"map","key":{},"value":{"type":"structure","members":{"AppPackageName":{},"AppTitle":{},"AppVersionCode":{},"Attributes":{"shape":"S4"},"ClientSdkVersion":{},"EventType":{},"Metrics":{"shape":"S5f"},"SdkName":{},"Session":{"type":"structure","members":{"Duration":{"type":"integer"},"Id":{},"StartTimestamp":{},"StopTimestamp":{}},"required":["StartTimestamp","Id"]},"Timestamp":{}},"required":["EventType","Timestamp"]}}},"required":["Endpoint","Events"]}}},"required":["BatchItem"]}},"required":["ApplicationId","EventsRequest"],"payload":"EventsRequest"},"output":{"type":"structure","members":{"EventsResponse":{"type":"structure","members":{"Results":{"type":"map","key":{},"value":{"type":"structure","members":{"EndpointItemResponse":{"type":"structure","members":{"Message":{},"StatusCode":{"type":"integer"}}},"EventsItemResponse":{"type":"map","key":{},"value":{"type":"structure","members":{"Message":{},"StatusCode":{"type":"integer"}}}}}}}}}},"required":["EventsResponse"],"payload":"EventsResponse"}},"RemoveAttributes":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/attributes/{attribute-type}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"AttributeType":{"location":"uri","locationName":"attribute-type"},"UpdateAttributesRequest":{"type":"structure","members":{"Blacklist":{"shape":"S14"}}}},"required":["AttributeType","ApplicationId","UpdateAttributesRequest"],"payload":"UpdateAttributesRequest"},"output":{"type":"structure","members":{"AttributesResource":{"type":"structure","members":{"ApplicationId":{},"AttributeType":{},"Attributes":{"shape":"S14"}},"required":["AttributeType","ApplicationId"]}},"required":["AttributesResource"],"payload":"AttributesResource"}},"SendMessages":{"http":{"requestUri":"/v1/apps/{application-id}/messages","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"MessageRequest":{"type":"structure","members":{"Addresses":{"type":"map","key":{},"value":{"type":"structure","members":{"BodyOverride":{},"ChannelType":{},"Context":{"shape":"S4"},"RawContent":{},"Substitutions":{"shape":"S5b"},"TitleOverride":{}}}},"Context":{"shape":"S4"},"Endpoints":{"shape":"Sba"},"MessageConfiguration":{"shape":"Sbc"},"TemplateConfiguration":{"shape":"S1d"},"TraceId":{}},"required":["MessageConfiguration"]}},"required":["ApplicationId","MessageRequest"],"payload":"MessageRequest"},"output":{"type":"structure","members":{"MessageResponse":{"shape":"Sbr"}},"required":["MessageResponse"],"payload":"MessageResponse"}},"SendOTPMessage":{"http":{"requestUri":"/v1/apps/{application-id}/otp","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SendOTPMessageRequestParameters":{"type":"structure","members":{"AllowedAttempts":{"type":"integer"},"BrandName":{},"Channel":{},"CodeLength":{"type":"integer"},"DestinationIdentity":{},"EntityId":{},"Language":{},"OriginationIdentity":{},"ReferenceId":{},"TemplateId":{},"ValidityPeriod":{"type":"integer"}},"required":["BrandName","ReferenceId","Channel","DestinationIdentity","OriginationIdentity"]}},"required":["ApplicationId","SendOTPMessageRequestParameters"],"payload":"SendOTPMessageRequestParameters"},"output":{"type":"structure","members":{"MessageResponse":{"shape":"Sbr"}},"required":["MessageResponse"],"payload":"MessageResponse"}},"SendUsersMessages":{"http":{"requestUri":"/v1/apps/{application-id}/users-messages","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SendUsersMessageRequest":{"type":"structure","members":{"Context":{"shape":"S4"},"MessageConfiguration":{"shape":"Sbc"},"TemplateConfiguration":{"shape":"S1d"},"TraceId":{},"Users":{"shape":"Sba"}},"required":["MessageConfiguration","Users"]}},"required":["ApplicationId","SendUsersMessageRequest"],"payload":"SendUsersMessageRequest"},"output":{"type":"structure","members":{"SendUsersMessageResponse":{"type":"structure","members":{"ApplicationId":{},"RequestId":{},"Result":{"type":"map","key":{},"value":{"shape":"Sbs"}}},"required":["ApplicationId"]}},"required":["SendUsersMessageResponse"],"payload":"SendUsersMessageResponse"}},"TagResource":{"http":{"requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagsModel":{"shape":"Sa5"}},"required":["ResourceArn","TagsModel"],"payload":"TagsModel"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"S14","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateAdmChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/adm","responseCode":200},"input":{"type":"structure","members":{"ADMChannelRequest":{"type":"structure","members":{"ClientId":{},"ClientSecret":{},"Enabled":{"type":"boolean"}},"required":["ClientSecret","ClientId"]},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","ADMChannelRequest"],"payload":"ADMChannelRequest"},"output":{"type":"structure","members":{"ADMChannelResponse":{"shape":"S4i"}},"required":["ADMChannelResponse"],"payload":"ADMChannelResponse"}},"UpdateApnsChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns","responseCode":200},"input":{"type":"structure","members":{"APNSChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSChannelRequest"],"payload":"APNSChannelRequest"},"output":{"type":"structure","members":{"APNSChannelResponse":{"shape":"S4l"}},"required":["APNSChannelResponse"],"payload":"APNSChannelResponse"}},"UpdateApnsSandboxChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns_sandbox","responseCode":200},"input":{"type":"structure","members":{"APNSSandboxChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSSandboxChannelRequest"],"payload":"APNSSandboxChannelRequest"},"output":{"type":"structure","members":{"APNSSandboxChannelResponse":{"shape":"S4o"}},"required":["APNSSandboxChannelResponse"],"payload":"APNSSandboxChannelResponse"}},"UpdateApnsVoipChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns_voip","responseCode":200},"input":{"type":"structure","members":{"APNSVoipChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSVoipChannelRequest"],"payload":"APNSVoipChannelRequest"},"output":{"type":"structure","members":{"APNSVoipChannelResponse":{"shape":"S4r"}},"required":["APNSVoipChannelResponse"],"payload":"APNSVoipChannelResponse"}},"UpdateApnsVoipSandboxChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns_voip_sandbox","responseCode":200},"input":{"type":"structure","members":{"APNSVoipSandboxChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSVoipSandboxChannelRequest"],"payload":"APNSVoipSandboxChannelRequest"},"output":{"type":"structure","members":{"APNSVoipSandboxChannelResponse":{"shape":"S4u"}},"required":["APNSVoipSandboxChannelResponse"],"payload":"APNSVoipSandboxChannelResponse"}},"UpdateApplicationSettings":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/settings","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteApplicationSettingsRequest":{"type":"structure","members":{"CampaignHook":{"shape":"S1f"},"CloudWatchMetricsEnabled":{"type":"boolean"},"EventTaggingEnabled":{"type":"boolean"},"Limits":{"shape":"S1h"},"QuietTime":{"shape":"S1c"}}}},"required":["ApplicationId","WriteApplicationSettingsRequest"],"payload":"WriteApplicationSettingsRequest"},"output":{"type":"structure","members":{"ApplicationSettingsResource":{"shape":"S6x"}},"required":["ApplicationSettingsResource"],"payload":"ApplicationSettingsResource"}},"UpdateBaiduChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/baidu","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"BaiduChannelRequest":{"type":"structure","members":{"ApiKey":{},"Enabled":{"type":"boolean"},"SecretKey":{}},"required":["SecretKey","ApiKey"]}},"required":["ApplicationId","BaiduChannelRequest"],"payload":"BaiduChannelRequest"},"output":{"type":"structure","members":{"BaiduChannelResponse":{"shape":"S4z"}},"required":["BaiduChannelResponse"],"payload":"BaiduChannelResponse"}},"UpdateCampaign":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"WriteCampaignRequest":{"shape":"S8"}},"required":["CampaignId","ApplicationId","WriteCampaignRequest"],"payload":"WriteCampaignRequest"},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S1j"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"UpdateEmailChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/email","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EmailChannelRequest":{"type":"structure","members":{"ConfigurationSet":{},"Enabled":{"type":"boolean"},"FromAddress":{},"Identity":{},"RoleArn":{}},"required":["FromAddress","Identity"]}},"required":["ApplicationId","EmailChannelRequest"],"payload":"EmailChannelRequest"},"output":{"type":"structure","members":{"EmailChannelResponse":{"shape":"S54"}},"required":["EmailChannelResponse"],"payload":"EmailChannelResponse"}},"UpdateEmailTemplate":{"http":{"method":"PUT","requestUri":"/v1/templates/{template-name}/email","responseCode":202},"input":{"type":"structure","members":{"CreateNewVersion":{"location":"querystring","locationName":"create-new-version","type":"boolean"},"EmailTemplateRequest":{"shape":"S1p"},"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName","EmailTemplateRequest"],"payload":"EmailTemplateRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateEndpoint":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"},"EndpointRequest":{"type":"structure","members":{"Address":{},"Attributes":{"shape":"S5b"},"ChannelType":{},"Demographic":{"shape":"S5d"},"EffectiveDate":{},"EndpointStatus":{},"Location":{"shape":"S5e"},"Metrics":{"shape":"S5f"},"OptOut":{},"RequestId":{},"User":{"shape":"S5g"}}}},"required":["ApplicationId","EndpointId","EndpointRequest"],"payload":"EndpointRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateEndpointsBatch":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/endpoints","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointBatchRequest":{"type":"structure","members":{"Item":{"type":"list","member":{"type":"structure","members":{"Address":{},"Attributes":{"shape":"S5b"},"ChannelType":{},"Demographic":{"shape":"S5d"},"EffectiveDate":{},"EndpointStatus":{},"Id":{},"Location":{"shape":"S5e"},"Metrics":{"shape":"S5f"},"OptOut":{},"RequestId":{},"User":{"shape":"S5g"}}}}},"required":["Item"]}},"required":["ApplicationId","EndpointBatchRequest"],"payload":"EndpointBatchRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateGcmChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/gcm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"GCMChannelRequest":{"type":"structure","members":{"ApiKey":{},"Enabled":{"type":"boolean"}},"required":["ApiKey"]}},"required":["ApplicationId","GCMChannelRequest"],"payload":"GCMChannelRequest"},"output":{"type":"structure","members":{"GCMChannelResponse":{"shape":"S5m"}},"required":["GCMChannelResponse"],"payload":"GCMChannelResponse"}},"UpdateInAppTemplate":{"http":{"method":"PUT","requestUri":"/v1/templates/{template-name}/inapp","responseCode":202},"input":{"type":"structure","members":{"CreateNewVersion":{"location":"querystring","locationName":"create-new-version","type":"boolean"},"InAppTemplateRequest":{"shape":"S25"},"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName","InAppTemplateRequest"],"payload":"InAppTemplateRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateJourney":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JourneyId":{"location":"uri","locationName":"journey-id"},"WriteJourneyRequest":{"shape":"S29"}},"required":["JourneyId","ApplicationId","WriteJourneyRequest"],"payload":"WriteJourneyRequest"},"output":{"type":"structure","members":{"JourneyResponse":{"shape":"S3j"}},"required":["JourneyResponse"],"payload":"JourneyResponse"}},"UpdateJourneyState":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/journeys/{journey-id}/state","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JourneyId":{"location":"uri","locationName":"journey-id"},"JourneyStateRequest":{"type":"structure","members":{"State":{}}}},"required":["JourneyId","ApplicationId","JourneyStateRequest"],"payload":"JourneyStateRequest"},"output":{"type":"structure","members":{"JourneyResponse":{"shape":"S3j"}},"required":["JourneyResponse"],"payload":"JourneyResponse"}},"UpdatePushTemplate":{"http":{"method":"PUT","requestUri":"/v1/templates/{template-name}/push","responseCode":202},"input":{"type":"structure","members":{"CreateNewVersion":{"location":"querystring","locationName":"create-new-version","type":"boolean"},"PushNotificationTemplateRequest":{"shape":"S3l"},"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName","PushNotificationTemplateRequest"],"payload":"PushNotificationTemplateRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateRecommenderConfiguration":{"http":{"method":"PUT","requestUri":"/v1/recommenders/{recommender-id}","responseCode":200},"input":{"type":"structure","members":{"RecommenderId":{"location":"uri","locationName":"recommender-id"},"UpdateRecommenderConfiguration":{"type":"structure","members":{"Attributes":{"shape":"S4"},"Description":{},"Name":{},"RecommendationProviderIdType":{},"RecommendationProviderRoleArn":{},"RecommendationProviderUri":{},"RecommendationTransformerUri":{},"RecommendationsDisplayName":{},"RecommendationsPerMessage":{"type":"integer"}},"required":["RecommendationProviderUri","RecommendationProviderRoleArn"]}},"required":["RecommenderId","UpdateRecommenderConfiguration"],"payload":"UpdateRecommenderConfiguration"},"output":{"type":"structure","members":{"RecommenderConfigurationResponse":{"shape":"S3t"}},"required":["RecommenderConfigurationResponse"],"payload":"RecommenderConfigurationResponse"}},"UpdateSegment":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/segments/{segment-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"},"WriteSegmentRequest":{"shape":"S3v"}},"required":["SegmentId","ApplicationId","WriteSegmentRequest"],"payload":"WriteSegmentRequest"},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S46"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"UpdateSmsChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/sms","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SMSChannelRequest":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SenderId":{},"ShortCode":{}}}},"required":["ApplicationId","SMSChannelRequest"],"payload":"SMSChannelRequest"},"output":{"type":"structure","members":{"SMSChannelResponse":{"shape":"S5z"}},"required":["SMSChannelResponse"],"payload":"SMSChannelResponse"}},"UpdateSmsTemplate":{"http":{"method":"PUT","requestUri":"/v1/templates/{template-name}/sms","responseCode":202},"input":{"type":"structure","members":{"CreateNewVersion":{"location":"querystring","locationName":"create-new-version","type":"boolean"},"SMSTemplateRequest":{"shape":"S4b"},"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"}},"required":["TemplateName","SMSTemplateRequest"],"payload":"SMSTemplateRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateTemplateActiveVersion":{"http":{"method":"PUT","requestUri":"/v1/templates/{template-name}/{template-type}/active-version","responseCode":200},"input":{"type":"structure","members":{"TemplateActiveVersionRequest":{"type":"structure","members":{"Version":{}}},"TemplateName":{"location":"uri","locationName":"template-name"},"TemplateType":{"location":"uri","locationName":"template-type"}},"required":["TemplateName","TemplateType","TemplateActiveVersionRequest"],"payload":"TemplateActiveVersionRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateVoiceChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/voice","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"VoiceChannelRequest":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"required":["ApplicationId","VoiceChannelRequest"],"payload":"VoiceChannelRequest"},"output":{"type":"structure","members":{"VoiceChannelResponse":{"shape":"S68"}},"required":["VoiceChannelResponse"],"payload":"VoiceChannelResponse"}},"UpdateVoiceTemplate":{"http":{"method":"PUT","requestUri":"/v1/templates/{template-name}/voice","responseCode":202},"input":{"type":"structure","members":{"CreateNewVersion":{"location":"querystring","locationName":"create-new-version","type":"boolean"},"TemplateName":{"location":"uri","locationName":"template-name"},"Version":{"location":"querystring","locationName":"version"},"VoiceTemplateRequest":{"shape":"S4e"}},"required":["TemplateName","VoiceTemplateRequest"],"payload":"VoiceTemplateRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S57"}},"required":["MessageBody"],"payload":"MessageBody"}},"VerifyOTPMessage":{"http":{"requestUri":"/v1/apps/{application-id}/verify-otp","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"VerifyOTPMessageRequestParameters":{"type":"structure","members":{"DestinationIdentity":{},"Otp":{},"ReferenceId":{}},"required":["ReferenceId","Otp","DestinationIdentity"]}},"required":["ApplicationId","VerifyOTPMessageRequestParameters"],"payload":"VerifyOTPMessageRequestParameters"},"output":{"type":"structure","members":{"VerificationResponse":{"type":"structure","members":{"Valid":{"type":"boolean"}}}},"required":["VerificationResponse"],"payload":"VerificationResponse"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S6":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"tags":{"shape":"S4","locationName":"tags"},"CreationDate":{}},"required":["Id","Arn","Name"]},"S8":{"type":"structure","members":{"AdditionalTreatments":{"type":"list","member":{"type":"structure","members":{"CustomDeliveryConfiguration":{"shape":"Sb"},"MessageConfiguration":{"shape":"Se"},"Schedule":{"shape":"Sy"},"SizePercent":{"type":"integer"},"TemplateConfiguration":{"shape":"S1d"},"TreatmentDescription":{},"TreatmentName":{}},"required":["SizePercent"]}},"CustomDeliveryConfiguration":{"shape":"Sb"},"Description":{},"HoldoutPercent":{"type":"integer"},"Hook":{"shape":"S1f"},"IsPaused":{"type":"boolean"},"Limits":{"shape":"S1h"},"MessageConfiguration":{"shape":"Se"},"Name":{},"Schedule":{"shape":"Sy"},"SegmentId":{},"SegmentVersion":{"type":"integer"},"tags":{"shape":"S4","locationName":"tags"},"TemplateConfiguration":{"shape":"S1d"},"TreatmentDescription":{},"TreatmentName":{},"Priority":{"type":"integer"}}},"Sb":{"type":"structure","members":{"DeliveryUri":{},"EndpointTypes":{"shape":"Sc"}},"required":["DeliveryUri"]},"Sc":{"type":"list","member":{}},"Se":{"type":"structure","members":{"ADMMessage":{"shape":"Sf"},"APNSMessage":{"shape":"Sf"},"BaiduMessage":{"shape":"Sf"},"CustomMessage":{"type":"structure","members":{"Data":{}}},"DefaultMessage":{"shape":"Sf"},"EmailMessage":{"type":"structure","members":{"Body":{},"FromAddress":{},"HtmlBody":{},"Title":{}}},"GCMMessage":{"shape":"Sf"},"SMSMessage":{"type":"structure","members":{"Body":{},"MessageType":{},"OriginationNumber":{},"SenderId":{},"EntityId":{},"TemplateId":{}}},"InAppMessage":{"type":"structure","members":{"Body":{},"Content":{"shape":"So"},"CustomConfig":{"shape":"S4"},"Layout":{}}}}},"Sf":{"type":"structure","members":{"Action":{},"Body":{},"ImageIconUrl":{},"ImageSmallIconUrl":{},"ImageUrl":{},"JsonBody":{},"MediaUrl":{},"RawContent":{},"SilentPush":{"type":"boolean"},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"So":{"type":"list","member":{"type":"structure","members":{"BackgroundColor":{},"BodyConfig":{"type":"structure","members":{"Alignment":{},"Body":{},"TextColor":{}},"required":["Alignment","TextColor","Body"]},"HeaderConfig":{"type":"structure","members":{"Alignment":{},"Header":{},"TextColor":{}},"required":["Alignment","Header","TextColor"]},"ImageUrl":{},"PrimaryBtn":{"shape":"St"},"SecondaryBtn":{"shape":"St"}}}},"St":{"type":"structure","members":{"Android":{"shape":"Su"},"DefaultConfig":{"type":"structure","members":{"BackgroundColor":{},"BorderRadius":{"type":"integer"},"ButtonAction":{},"Link":{},"Text":{},"TextColor":{}},"required":["ButtonAction","Text"]},"IOS":{"shape":"Su"},"Web":{"shape":"Su"}}},"Su":{"type":"structure","members":{"ButtonAction":{},"Link":{}},"required":["ButtonAction"]},"Sy":{"type":"structure","members":{"EndTime":{},"EventFilter":{"shape":"Sz"},"Frequency":{},"IsLocalTime":{"type":"boolean"},"QuietTime":{"shape":"S1c"},"StartTime":{},"Timezone":{}},"required":["StartTime"]},"Sz":{"type":"structure","members":{"Dimensions":{"shape":"S10"},"FilterType":{}},"required":["FilterType","Dimensions"]},"S10":{"type":"structure","members":{"Attributes":{"shape":"S11"},"EventType":{"shape":"S15"},"Metrics":{"shape":"S17"}}},"S11":{"type":"map","key":{},"value":{"type":"structure","members":{"AttributeType":{},"Values":{"shape":"S14"}},"required":["Values"]}},"S14":{"type":"list","member":{}},"S15":{"type":"structure","members":{"DimensionType":{},"Values":{"shape":"S14"}},"required":["Values"]},"S17":{"type":"map","key":{},"value":{"type":"structure","members":{"ComparisonOperator":{},"Value":{"type":"double"}},"required":["ComparisonOperator","Value"]}},"S1c":{"type":"structure","members":{"End":{},"Start":{}}},"S1d":{"type":"structure","members":{"EmailTemplate":{"shape":"S1e"},"PushTemplate":{"shape":"S1e"},"SMSTemplate":{"shape":"S1e"},"VoiceTemplate":{"shape":"S1e"}}},"S1e":{"type":"structure","members":{"Name":{},"Version":{}}},"S1f":{"type":"structure","members":{"LambdaFunctionName":{},"Mode":{},"WebUrl":{}}},"S1h":{"type":"structure","members":{"Daily":{"type":"integer"},"MaximumDuration":{"type":"integer"},"MessagesPerSecond":{"type":"integer"},"Total":{"type":"integer"},"Session":{"type":"integer"}}},"S1j":{"type":"structure","members":{"AdditionalTreatments":{"type":"list","member":{"type":"structure","members":{"CustomDeliveryConfiguration":{"shape":"Sb"},"Id":{},"MessageConfiguration":{"shape":"Se"},"Schedule":{"shape":"Sy"},"SizePercent":{"type":"integer"},"State":{"shape":"S1m"},"TemplateConfiguration":{"shape":"S1d"},"TreatmentDescription":{},"TreatmentName":{}},"required":["Id","SizePercent"]}},"ApplicationId":{},"Arn":{},"CreationDate":{},"CustomDeliveryConfiguration":{"shape":"Sb"},"DefaultState":{"shape":"S1m"},"Description":{},"HoldoutPercent":{"type":"integer"},"Hook":{"shape":"S1f"},"Id":{},"IsPaused":{"type":"boolean"},"LastModifiedDate":{},"Limits":{"shape":"S1h"},"MessageConfiguration":{"shape":"Se"},"Name":{},"Schedule":{"shape":"Sy"},"SegmentId":{},"SegmentVersion":{"type":"integer"},"State":{"shape":"S1m"},"tags":{"shape":"S4","locationName":"tags"},"TemplateConfiguration":{"shape":"S1d"},"TreatmentDescription":{},"TreatmentName":{},"Version":{"type":"integer"},"Priority":{"type":"integer"}},"required":["LastModifiedDate","CreationDate","SegmentId","SegmentVersion","Id","Arn","ApplicationId"]},"S1m":{"type":"structure","members":{"CampaignStatus":{}}},"S1p":{"type":"structure","members":{"DefaultSubstitutions":{},"HtmlPart":{},"RecommenderId":{},"Subject":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"TextPart":{}}},"S1r":{"type":"structure","members":{"Arn":{},"Message":{},"RequestID":{}}},"S1v":{"type":"structure","members":{"ApplicationId":{},"CompletedPieces":{"type":"integer"},"CompletionDate":{},"CreationDate":{},"Definition":{"type":"structure","members":{"RoleArn":{},"S3UrlPrefix":{},"SegmentId":{},"SegmentVersion":{"type":"integer"}},"required":["S3UrlPrefix","RoleArn"]},"FailedPieces":{"type":"integer"},"Failures":{"shape":"S14"},"Id":{},"JobStatus":{},"TotalFailures":{"type":"integer"},"TotalPieces":{"type":"integer"},"TotalProcessed":{"type":"integer"},"Type":{}},"required":["JobStatus","CreationDate","Type","Definition","Id","ApplicationId"]},"S22":{"type":"structure","members":{"ApplicationId":{},"CompletedPieces":{"type":"integer"},"CompletionDate":{},"CreationDate":{},"Definition":{"type":"structure","members":{"DefineSegment":{"type":"boolean"},"ExternalId":{},"Format":{},"RegisterEndpoints":{"type":"boolean"},"RoleArn":{},"S3Url":{},"SegmentId":{},"SegmentName":{}},"required":["Format","S3Url","RoleArn"]},"FailedPieces":{"type":"integer"},"Failures":{"shape":"S14"},"Id":{},"JobStatus":{},"TotalFailures":{"type":"integer"},"TotalPieces":{"type":"integer"},"TotalProcessed":{"type":"integer"},"Type":{}},"required":["JobStatus","CreationDate","Type","Definition","Id","ApplicationId"]},"S25":{"type":"structure","members":{"Content":{"shape":"So"},"CustomConfig":{"shape":"S4"},"Layout":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{}}},"S29":{"type":"structure","members":{"Activities":{"shape":"S2a"},"CreationDate":{},"LastModifiedDate":{},"Limits":{"shape":"S3a"},"LocalTime":{"type":"boolean"},"Name":{},"QuietTime":{"shape":"S1c"},"RefreshFrequency":{},"Schedule":{"shape":"S3b"},"StartActivity":{},"StartCondition":{"shape":"S3d"},"State":{},"WaitForQuietTime":{"type":"boolean"},"RefreshOnSegmentUpdate":{"type":"boolean"},"JourneyChannelSettings":{"shape":"S3h"}},"required":["Name"]},"S2a":{"type":"map","key":{},"value":{"type":"structure","members":{"CUSTOM":{"type":"structure","members":{"DeliveryUri":{},"EndpointTypes":{"shape":"Sc"},"MessageConfig":{"type":"structure","members":{"Data":{}}},"NextActivity":{},"TemplateName":{},"TemplateVersion":{}}},"ConditionalSplit":{"type":"structure","members":{"Condition":{"type":"structure","members":{"Conditions":{"type":"list","member":{"shape":"S2h"}},"Operator":{}}},"EvaluationWaitTime":{"shape":"S2u"},"FalseActivity":{},"TrueActivity":{}}},"Description":{},"EMAIL":{"type":"structure","members":{"MessageConfig":{"type":"structure","members":{"FromAddress":{}}},"NextActivity":{},"TemplateName":{},"TemplateVersion":{}}},"Holdout":{"type":"structure","members":{"NextActivity":{},"Percentage":{"type":"integer"}},"required":["Percentage"]},"MultiCondition":{"type":"structure","members":{"Branches":{"type":"list","member":{"type":"structure","members":{"Condition":{"shape":"S2h"},"NextActivity":{}}}},"DefaultActivity":{},"EvaluationWaitTime":{"shape":"S2u"}}},"PUSH":{"type":"structure","members":{"MessageConfig":{"type":"structure","members":{"TimeToLive":{}}},"NextActivity":{},"TemplateName":{},"TemplateVersion":{}}},"RandomSplit":{"type":"structure","members":{"Branches":{"type":"list","member":{"type":"structure","members":{"NextActivity":{},"Percentage":{"type":"integer"}}}}}},"SMS":{"type":"structure","members":{"MessageConfig":{"type":"structure","members":{"MessageType":{},"OriginationNumber":{},"SenderId":{},"EntityId":{},"TemplateId":{}}},"NextActivity":{},"TemplateName":{},"TemplateVersion":{}}},"Wait":{"type":"structure","members":{"NextActivity":{},"WaitTime":{"shape":"S2u"}}},"ContactCenter":{"type":"structure","members":{"NextActivity":{}}}}}},"S2h":{"type":"structure","members":{"EventCondition":{"type":"structure","members":{"Dimensions":{"shape":"S10"},"MessageActivity":{}}},"SegmentCondition":{"shape":"S2j"},"SegmentDimensions":{"shape":"S2k","locationName":"segmentDimensions"}}},"S2j":{"type":"structure","members":{"SegmentId":{}},"required":["SegmentId"]},"S2k":{"type":"structure","members":{"Attributes":{"shape":"S11"},"Behavior":{"type":"structure","members":{"Recency":{"type":"structure","members":{"Duration":{},"RecencyType":{}},"required":["Duration","RecencyType"]}}},"Demographic":{"type":"structure","members":{"AppVersion":{"shape":"S15"},"Channel":{"shape":"S15"},"DeviceType":{"shape":"S15"},"Make":{"shape":"S15"},"Model":{"shape":"S15"},"Platform":{"shape":"S15"}}},"Location":{"type":"structure","members":{"Country":{"shape":"S15"},"GPSPoint":{"type":"structure","members":{"Coordinates":{"type":"structure","members":{"Latitude":{"type":"double"},"Longitude":{"type":"double"}},"required":["Latitude","Longitude"]},"RangeInKilometers":{"type":"double"}},"required":["Coordinates"]}}},"Metrics":{"shape":"S17"},"UserAttributes":{"shape":"S11"}}},"S2u":{"type":"structure","members":{"WaitFor":{},"WaitUntil":{}}},"S3a":{"type":"structure","members":{"DailyCap":{"type":"integer"},"EndpointReentryCap":{"type":"integer"},"MessagesPerSecond":{"type":"integer"},"EndpointReentryInterval":{}}},"S3b":{"type":"structure","members":{"EndTime":{"shape":"S3c"},"StartTime":{"shape":"S3c"},"Timezone":{}}},"S3c":{"type":"timestamp","timestampFormat":"iso8601"},"S3d":{"type":"structure","members":{"Description":{},"EventStartCondition":{"type":"structure","members":{"EventFilter":{"type":"structure","members":{"Dimensions":{"shape":"S10"},"FilterType":{}},"required":["FilterType","Dimensions"]},"SegmentId":{}}},"SegmentStartCondition":{"shape":"S2j"}}},"S3h":{"type":"structure","members":{"ConnectCampaignArn":{},"ConnectCampaignExecutionRoleArn":{}}},"S3j":{"type":"structure","members":{"Activities":{"shape":"S2a"},"ApplicationId":{},"CreationDate":{},"Id":{},"LastModifiedDate":{},"Limits":{"shape":"S3a"},"LocalTime":{"type":"boolean"},"Name":{},"QuietTime":{"shape":"S1c"},"RefreshFrequency":{},"Schedule":{"shape":"S3b"},"StartActivity":{},"StartCondition":{"shape":"S3d"},"State":{},"tags":{"shape":"S4","locationName":"tags"},"WaitForQuietTime":{"type":"boolean"},"RefreshOnSegmentUpdate":{"type":"boolean"},"JourneyChannelSettings":{"shape":"S3h"}},"required":["Name","Id","ApplicationId"]},"S3l":{"type":"structure","members":{"ADM":{"shape":"S3m"},"APNS":{"shape":"S3n"},"Baidu":{"shape":"S3m"},"Default":{"shape":"S3o"},"DefaultSubstitutions":{},"GCM":{"shape":"S3m"},"RecommenderId":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{}}},"S3m":{"type":"structure","members":{"Action":{},"Body":{},"ImageIconUrl":{},"ImageUrl":{},"RawContent":{},"SmallImageIconUrl":{},"Sound":{},"Title":{},"Url":{}}},"S3n":{"type":"structure","members":{"Action":{},"Body":{},"MediaUrl":{},"RawContent":{},"Sound":{},"Title":{},"Url":{}}},"S3o":{"type":"structure","members":{"Action":{},"Body":{},"Sound":{},"Title":{},"Url":{}}},"S3t":{"type":"structure","members":{"Attributes":{"shape":"S4"},"CreationDate":{},"Description":{},"Id":{},"LastModifiedDate":{},"Name":{},"RecommendationProviderIdType":{},"RecommendationProviderRoleArn":{},"RecommendationProviderUri":{},"RecommendationTransformerUri":{},"RecommendationsDisplayName":{},"RecommendationsPerMessage":{"type":"integer"}},"required":["RecommendationProviderUri","LastModifiedDate","CreationDate","RecommendationProviderRoleArn","Id"]},"S3v":{"type":"structure","members":{"Dimensions":{"shape":"S2k"},"Name":{},"SegmentGroups":{"shape":"S3w"},"tags":{"shape":"S4","locationName":"tags"}}},"S3w":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"type":"list","member":{"shape":"S2k"}},"SourceSegments":{"type":"list","member":{"type":"structure","members":{"Id":{},"Version":{"type":"integer"}},"required":["Id"]}},"SourceType":{},"Type":{}}}},"Include":{}}},"S46":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreationDate":{},"Dimensions":{"shape":"S2k"},"Id":{},"ImportDefinition":{"type":"structure","members":{"ChannelCounts":{"type":"map","key":{},"value":{"type":"integer"}},"ExternalId":{},"Format":{},"RoleArn":{},"S3Url":{},"Size":{"type":"integer"}},"required":["Format","S3Url","Size","ExternalId","RoleArn"]},"LastModifiedDate":{},"Name":{},"SegmentGroups":{"shape":"S3w"},"SegmentType":{},"tags":{"shape":"S4","locationName":"tags"},"Version":{"type":"integer"}},"required":["SegmentType","CreationDate","Id","Arn","ApplicationId"]},"S4b":{"type":"structure","members":{"Body":{},"DefaultSubstitutions":{},"RecommenderId":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{}}},"S4e":{"type":"structure","members":{"Body":{},"DefaultSubstitutions":{},"LanguageCode":{},"tags":{"shape":"S4","locationName":"tags"},"TemplateDescription":{},"VoiceId":{}}},"S4i":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S4l":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S4o":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S4r":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S4u":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S4z":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Credential":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Credential","Platform"]},"S54":{"type":"structure","members":{"ApplicationId":{},"ConfigurationSet":{},"CreationDate":{},"Enabled":{"type":"boolean"},"FromAddress":{},"HasCredential":{"type":"boolean"},"Id":{},"Identity":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"MessagesPerSecond":{"type":"integer"},"Platform":{},"RoleArn":{},"Version":{"type":"integer"}},"required":["Platform"]},"S57":{"type":"structure","members":{"Message":{},"RequestID":{}}},"S5a":{"type":"structure","members":{"Address":{},"ApplicationId":{},"Attributes":{"shape":"S5b"},"ChannelType":{},"CohortId":{},"CreationDate":{},"Demographic":{"shape":"S5d"},"EffectiveDate":{},"EndpointStatus":{},"Id":{},"Location":{"shape":"S5e"},"Metrics":{"shape":"S5f"},"OptOut":{},"RequestId":{},"User":{"shape":"S5g"}}},"S5b":{"type":"map","key":{},"value":{"shape":"S14"}},"S5d":{"type":"structure","members":{"AppVersion":{},"Locale":{},"Make":{},"Model":{},"ModelVersion":{},"Platform":{},"PlatformVersion":{},"Timezone":{}}},"S5e":{"type":"structure","members":{"City":{},"Country":{},"Latitude":{"type":"double"},"Longitude":{"type":"double"},"PostalCode":{},"Region":{}}},"S5f":{"type":"map","key":{},"value":{"type":"double"}},"S5g":{"type":"structure","members":{"UserAttributes":{"shape":"S5b"},"UserId":{}}},"S5j":{"type":"structure","members":{"ApplicationId":{},"DestinationStreamArn":{},"ExternalId":{},"LastModifiedDate":{},"LastUpdatedBy":{},"RoleArn":{}},"required":["ApplicationId","RoleArn","DestinationStreamArn"]},"S5m":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Credential":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Credential","Platform"]},"S5z":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"PromotionalMessagesPerSecond":{"type":"integer"},"SenderId":{},"ShortCode":{},"TransactionalMessagesPerSecond":{"type":"integer"},"Version":{"type":"integer"}},"required":["Platform"]},"S64":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S5a"}}},"required":["Item"]},"S68":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S6q":{"type":"structure","members":{"Rows":{"type":"list","member":{"type":"structure","members":{"GroupedBys":{"shape":"S6t"},"Values":{"shape":"S6t"}},"required":["GroupedBys","Values"]}}},"required":["Rows"]},"S6t":{"type":"list","member":{"type":"structure","members":{"Key":{},"Type":{},"Value":{}},"required":["Type","Value","Key"]}},"S6x":{"type":"structure","members":{"ApplicationId":{},"CampaignHook":{"shape":"S1f"},"LastModifiedDate":{},"Limits":{"shape":"S1h"},"QuietTime":{"shape":"S1c"}},"required":["ApplicationId"]},"S7i":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S1j"}},"NextToken":{}},"required":["Item"]},"S85":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S1v"}},"NextToken":{}},"required":["Item"]},"S8d":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S22"}},"NextToken":{}},"required":["Item"]},"S9j":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S46"}},"NextToken":{}},"required":["Item"]},"Sa5":{"type":"structure","members":{"tags":{"shape":"S4","locationName":"tags"}},"required":["tags"]},"Sba":{"type":"map","key":{},"value":{"type":"structure","members":{"BodyOverride":{},"Context":{"shape":"S4"},"RawContent":{},"Substitutions":{"shape":"S5b"},"TitleOverride":{}}}},"Sbc":{"type":"structure","members":{"ADMMessage":{"type":"structure","members":{"Action":{},"Body":{},"ConsolidationKey":{},"Data":{"shape":"S4"},"ExpiresAfter":{},"IconReference":{},"ImageIconUrl":{},"ImageUrl":{},"MD5":{},"RawContent":{},"SilentPush":{"type":"boolean"},"SmallImageIconUrl":{},"Sound":{},"Substitutions":{"shape":"S5b"},"Title":{},"Url":{}}},"APNSMessage":{"type":"structure","members":{"APNSPushType":{},"Action":{},"Badge":{"type":"integer"},"Body":{},"Category":{},"CollapseId":{},"Data":{"shape":"S4"},"MediaUrl":{},"PreferredAuthenticationMethod":{},"Priority":{},"RawContent":{},"SilentPush":{"type":"boolean"},"Sound":{},"Substitutions":{"shape":"S5b"},"ThreadId":{},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"BaiduMessage":{"type":"structure","members":{"Action":{},"Body":{},"Data":{"shape":"S4"},"IconReference":{},"ImageIconUrl":{},"ImageUrl":{},"RawContent":{},"SilentPush":{"type":"boolean"},"SmallImageIconUrl":{},"Sound":{},"Substitutions":{"shape":"S5b"},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"DefaultMessage":{"type":"structure","members":{"Body":{},"Substitutions":{"shape":"S5b"}}},"DefaultPushNotificationMessage":{"type":"structure","members":{"Action":{},"Body":{},"Data":{"shape":"S4"},"SilentPush":{"type":"boolean"},"Substitutions":{"shape":"S5b"},"Title":{},"Url":{}}},"EmailMessage":{"type":"structure","members":{"Body":{},"FeedbackForwardingAddress":{},"FromAddress":{},"RawEmail":{"type":"structure","members":{"Data":{"type":"blob"}}},"ReplyToAddresses":{"shape":"S14"},"SimpleEmail":{"type":"structure","members":{"HtmlPart":{"shape":"Sbm"},"Subject":{"shape":"Sbm"},"TextPart":{"shape":"Sbm"}}},"Substitutions":{"shape":"S5b"}}},"GCMMessage":{"type":"structure","members":{"Action":{},"Body":{},"CollapseKey":{},"Data":{"shape":"S4"},"IconReference":{},"ImageIconUrl":{},"ImageUrl":{},"Priority":{},"RawContent":{},"RestrictedPackageName":{},"SilentPush":{"type":"boolean"},"SmallImageIconUrl":{},"Sound":{},"Substitutions":{"shape":"S5b"},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"SMSMessage":{"type":"structure","members":{"Body":{},"Keyword":{},"MediaUrl":{},"MessageType":{},"OriginationNumber":{},"SenderId":{},"Substitutions":{"shape":"S5b"},"EntityId":{},"TemplateId":{}}},"VoiceMessage":{"type":"structure","members":{"Body":{},"LanguageCode":{},"OriginationNumber":{},"Substitutions":{"shape":"S5b"},"VoiceId":{}}}}},"Sbm":{"type":"structure","members":{"Charset":{},"Data":{}}},"Sbr":{"type":"structure","members":{"ApplicationId":{},"EndpointResult":{"shape":"Sbs"},"RequestId":{},"Result":{"type":"map","key":{},"value":{"type":"structure","members":{"DeliveryStatus":{},"MessageId":{},"StatusCode":{"type":"integer"},"StatusMessage":{},"UpdatedToken":{}},"required":["DeliveryStatus","StatusCode"]}}},"required":["ApplicationId"]},"Sbs":{"type":"map","key":{},"value":{"type":"structure","members":{"Address":{},"DeliveryStatus":{},"MessageId":{},"StatusCode":{"type":"integer"},"StatusMessage":{},"UpdatedToken":{}},"required":["DeliveryStatus","StatusCode"]}}}}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['polly'] = {};
	AWS.Polly = Service.defineService('polly', ['2016-06-10']);
	__webpack_require__(319);
	Object.defineProperty(apiLoader.services['polly'], '2016-06-10', {
	  get: function get() {
	    var model = __webpack_require__(321);
	    model.paginators = __webpack_require__(322).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Polly;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(320);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var rest = AWS.Protocol.Rest;

	/**
	 * A presigner object can be used to generate presigned urls for the Polly service.
	 */
	AWS.Polly.Presigner = AWS.util.inherit({
	    /**
	     * Creates a presigner object with a set of configuration options.
	     *
	     * @option options params [map] An optional map of parameters to bind to every
	     *   request sent by this service object.
	     * @option options service [AWS.Polly] An optional pre-configured instance
	     *  of the AWS.Polly service object to use for requests. The object may
	     *  bound parameters used by the presigner.
	     * @see AWS.Polly.constructor
	     */
	    constructor: function Signer(options) {
	        options = options || {};
	        this.options = options;
	        this.service = options.service;
	        this.bindServiceObject(options);
	        this._operations = {};
	    },

	    /**
	     * @api private
	     */
	    bindServiceObject: function bindServiceObject(options) {
	        options = options || {};
	        if (!this.service) {
	            this.service = new AWS.Polly(options);
	        } else {
	            var config = AWS.util.copy(this.service.config);
	            this.service = new this.service.constructor.__super__(config);
	            this.service.config.params = AWS.util.merge(this.service.config.params || {}, options.params);
	        }
	    },

	    /**
	     * @api private
	     */
	    modifyInputMembers: function modifyInputMembers(input) {
	        // make copies of the input so we don't overwrite the api
	        // need to be careful to copy anything we access/modify
	        var modifiedInput = AWS.util.copy(input);
	        modifiedInput.members = AWS.util.copy(input.members);
	        AWS.util.each(input.members, function(name, member) {
	            modifiedInput.members[name] = AWS.util.copy(member);
	            // update location and locationName
	            if (!member.location || member.location === 'body') {
	                modifiedInput.members[name].location = 'querystring';
	                modifiedInput.members[name].locationName = name;
	            }
	        });
	        return modifiedInput;
	    },

	    /**
	     * @api private
	     */
	    convertPostToGet: function convertPostToGet(req) {
	        // convert method
	        req.httpRequest.method = 'GET';

	        var operation = req.service.api.operations[req.operation];
	        // get cached operation input first
	        var input = this._operations[req.operation];
	        if (!input) {
	            // modify the original input
	            this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
	        }

	        var uri = rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);

	        req.httpRequest.path = uri;
	        req.httpRequest.body = '';

	        // don't need these headers on a GET request
	        delete req.httpRequest.headers['Content-Length'];
	        delete req.httpRequest.headers['Content-Type'];
	    },

	    /**
	     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
	     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
	     *   @note You must ensure that you have static or previously resolved
	     *     credentials if you call this method synchronously (with no callback),
	     *     otherwise it may not properly sign the request. If you cannot guarantee
	     *     this (you are using an asynchronous credential provider, i.e., EC2
	     *     IAM roles), you should always call this method with an asynchronous
	     *     callback.
	     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
	     *     operation for the expected operation parameters.
	     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
	     *     Defaults to 1 hour.
	     *   @return [string] if called synchronously (with no callback), returns the signed URL.
	     *   @return [null] nothing is returned if a callback is provided.
	     *   @callback callback function (err, url)
	     *     If a callback is supplied, it is called when a signed URL has been generated.
	     *     @param err [Error] the error object returned from the presigner.
	     *     @param url [String] the signed URL.
	     *   @see AWS.Polly.synthesizeSpeech
	     */
	    getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
	        var self = this;
	        var request = this.service.makeRequest('synthesizeSpeech', params);
	        // remove existing build listeners
	        request.removeAllListeners('build');
	        request.on('build', function(req) {
	            self.convertPostToGet(req);
	        });
	        return request.presign(expires, callback);
	    }
	});


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-10","endpointPrefix":"polly","protocol":"rest-json","serviceFullName":"Amazon Polly","serviceId":"Polly","signatureVersion":"v4","uid":"polly-2016-06-10"},"operations":{"DeleteLexicon":{"http":{"method":"DELETE","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{}}},"DescribeVoices":{"http":{"method":"GET","requestUri":"/v1/voices","responseCode":200},"input":{"type":"structure","members":{"Engine":{"location":"querystring","locationName":"Engine"},"LanguageCode":{"location":"querystring","locationName":"LanguageCode"},"IncludeAdditionalLanguageCodes":{"location":"querystring","locationName":"IncludeAdditionalLanguageCodes","type":"boolean"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Voices":{"type":"list","member":{"type":"structure","members":{"Gender":{},"Id":{},"LanguageCode":{},"LanguageName":{},"Name":{},"AdditionalLanguageCodes":{"type":"list","member":{}},"SupportedEngines":{"type":"list","member":{}}}}},"NextToken":{}}}},"GetLexicon":{"http":{"method":"GET","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{"Lexicon":{"type":"structure","members":{"Content":{"shape":"Sl"},"Name":{}}},"LexiconAttributes":{"shape":"Sm"}}}},"GetSpeechSynthesisTask":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks/{TaskId}","responseCode":200},"input":{"type":"structure","required":["TaskId"],"members":{"TaskId":{"location":"uri","locationName":"TaskId"}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"ListLexicons":{"http":{"method":"GET","requestUri":"/v1/lexicons","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Lexicons":{"type":"list","member":{"type":"structure","members":{"Name":{},"Attributes":{"shape":"Sm"}}}},"NextToken":{}}}},"ListSpeechSynthesisTasks":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"Status":{"location":"querystring","locationName":"Status"}}},"output":{"type":"structure","members":{"NextToken":{},"SynthesisTasks":{"type":"list","member":{"shape":"Sv"}}}}},"PutLexicon":{"http":{"method":"PUT","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name","Content"],"members":{"Name":{"location":"uri","locationName":"LexiconName"},"Content":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"StartSpeechSynthesisTask":{"http":{"requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","required":["OutputFormat","OutputS3BucketName","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"SampleRate":{},"SnsTopicArn":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"SynthesizeSpeech":{"http":{"requestUri":"/v1/speech","responseCode":200},"input":{"type":"structure","required":["OutputFormat","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"AudioStream":{"type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"RequestCharacters":{"location":"header","locationName":"x-amzn-RequestCharacters","type":"integer"}},"payload":"AudioStream"}}},"shapes":{"Sl":{"type":"string","sensitive":true},"Sm":{"type":"structure","members":{"Alphabet":{},"LanguageCode":{},"LastModified":{"type":"timestamp"},"LexiconArn":{},"LexemesCount":{"type":"integer"},"Size":{"type":"integer"}}},"Sv":{"type":"structure","members":{"Engine":{},"TaskId":{},"TaskStatus":{},"TaskStatusReason":{},"OutputUri":{},"CreationTime":{"type":"timestamp"},"RequestCharacters":{"type":"integer"},"SnsTopicArn":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"TextType":{},"VoiceId":{},"LanguageCode":{}}},"S12":{"type":"list","member":{}},"S15":{"type":"list","member":{}}}}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListSpeechSynthesisTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['rds'] = {};
	AWS.RDS = Service.defineService('rds', ['2013-01-10', '2013-02-12', '2013-09-09', '2014-09-01', '2014-09-01*', '2014-10-31']);
	__webpack_require__(324);
	Object.defineProperty(apiLoader.services['rds'], '2013-01-10', {
	  get: function get() {
	    var model = __webpack_require__(327);
	    model.paginators = __webpack_require__(328).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2013-02-12', {
	  get: function get() {
	    var model = __webpack_require__(329);
	    model.paginators = __webpack_require__(330).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2013-09-09', {
	  get: function get() {
	    var model = __webpack_require__(331);
	    model.paginators = __webpack_require__(332).pagination;
	    model.waiters = __webpack_require__(333).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2014-09-01', {
	  get: function get() {
	    var model = __webpack_require__(334);
	    model.paginators = __webpack_require__(335).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2014-10-31', {
	  get: function get() {
	    var model = __webpack_require__(336);
	    model.paginators = __webpack_require__(337).pagination;
	    model.waiters = __webpack_require__(338).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.RDS;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var rdsutil = __webpack_require__(325);
	__webpack_require__(326);
	 /**
	  * @api private
	  */
	 var crossRegionOperations = ['copyDBSnapshot', 'createDBInstanceReadReplica', 'createDBCluster', 'copyDBClusterSnapshot', 'startDBInstanceAutomatedBackupsReplication'];

	 AWS.util.update(AWS.RDS.prototype, {
	   /**
	    * @api private
	    */
	   setupRequestListeners: function setupRequestListeners(request) {
	    rdsutil.setupRequestListeners(this, request, crossRegionOperations);
	   },
	 });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	var rdsutil = {
	  /**
	    * @api private
	    */
	   setupRequestListeners: function setupRequestListeners(service, request, crossRegionOperations) {
	    if (crossRegionOperations.indexOf(request.operation) !== -1 &&
	        request.params.SourceRegion) {
	      request.params = AWS.util.copy(request.params);
	      if (request.params.PreSignedUrl ||
	          request.params.SourceRegion === service.config.region) {
	        delete request.params.SourceRegion;
	      } else {
	        var doesParamValidation = !!service.config.paramValidation;
	        // remove the validate parameters listener so we can re-add it after we build the URL
	        if (doesParamValidation) {
	          request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	        }
	        request.onAsync('validate', rdsutil.buildCrossRegionPresignedUrl);
	        if (doesParamValidation) {
	          request.addListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	        }
	      }
	    }
	  },

	  /**
	   * @api private
	   */
	  buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
	    var config = AWS.util.copy(req.service.config);
	    config.region = req.params.SourceRegion;
	    delete req.params.SourceRegion;
	    delete config.endpoint;
	    // relevant params for the operation will already be in req.params
	    delete config.params;
	    config.signatureVersion = 'v4';
	    var destinationRegion = req.service.config.region;

	    var svc = new req.service.constructor(config);
	    var newReq = svc[req.operation](AWS.util.copy(req.params));
	    newReq.on('build', function addDestinationRegionParam(request) {
	      var httpRequest = request.httpRequest;
	      httpRequest.params.DestinationRegion = destinationRegion;
	      httpRequest.body = AWS.util.queryParamsToString(httpRequest.params);
	    });
	    newReq.presign(function(err, url) {
	      if (err) done(err);
	      else {
	        req.params.PreSignedUrl = url;
	        done();
	      }
	    });
	  }
	};

	/**
	 * @api private
	 */
	module.exports = rdsutil;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	/**
	 * @api private
	 */
	var service = null;

	/**
	 * @api private
	 */
	var api = {
	    signatureVersion: 'v4',
	    signingName: 'rds-db',
	    operations: {}
	};

	/**
	 * @api private
	 */
	var requiredAuthTokenOptions = {
	    region: 'string',
	    hostname: 'string',
	    port: 'number',
	    username: 'string'
	};

	/**
	 * A signer object can be used to generate an auth token to a database.
	 */
	AWS.RDS.Signer = AWS.util.inherit({
	    /**
	     * Creates a signer object can be used to generate an auth token.
	     *
	     * @option options credentials [AWS.Credentials] the AWS credentials
	     *   to sign requests with. Uses the default credential provider chain
	     *   if not specified.
	     * @option options hostname [String] the hostname of the database to connect to.
	     * @option options port [Number] the port number the database is listening on.
	     * @option options region [String] the region the database is located in.
	     * @option options username [String] the username to login as.
	     * @example Passing in options to constructor
	     *   var signer = new AWS.RDS.Signer({
	     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
	     *     region: 'us-east-1',
	     *     hostname: 'db.us-east-1.rds.amazonaws.com',
	     *     port: 8000,
	     *     username: 'name'
	     *   });
	     */
	    constructor: function Signer(options) {
	        this.options = options || {};
	    },

	    /**
	     * @api private
	     * Strips the protocol from a url.
	     */
	    convertUrlToAuthToken: function convertUrlToAuthToken(url) {
	        // we are always using https as the protocol
	        var protocol = 'https://';
	        if (url.indexOf(protocol) === 0) {
	            return url.substring(protocol.length);
	        }
	    },

	    /**
	     * @overload getAuthToken(options = {}, [callback])
	     *   Generate an auth token to a database.
	     *   @note You must ensure that you have static or previously resolved
	     *     credentials if you call this method synchronously (with no callback),
	     *     otherwise it may not properly sign the request. If you cannot guarantee
	     *     this (you are using an asynchronous credential provider, i.e., EC2
	     *     IAM roles), you should always call this method with an asynchronous
	     *     callback.
	     *
	     *   @param options [map] The fields to use when generating an auth token.
	     *     Any options specified here will be merged on top of any options passed
	     *     to AWS.RDS.Signer:
	     *
	     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
	     *         to sign requests with. Uses the default credential provider chain
	     *         if not specified.
	     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
	     *     * **port** (Number) &mdash; the port number the database is listening on.
	     *     * **region** (String) &mdash; the region the database is located in.
	     *     * **username** (String) &mdash; the username to login as.
	     *   @return [String] if called synchronously (with no callback), returns the
	     *     auth token.
	     *   @return [null] nothing is returned if a callback is provided.
	     *   @callback callback function (err, token)
	     *     If a callback is supplied, it is called when an auth token has been generated.
	     *     @param err [Error] the error object returned from the signer.
	     *     @param token [String] the auth token.
	     *
	     *   @example Generating an auth token synchronously
	     *     var signer = new AWS.RDS.Signer({
	     *       // configure options
	     *       region: 'us-east-1',
	     *       username: 'default',
	     *       hostname: 'db.us-east-1.amazonaws.com',
	     *       port: 8000
	     *     });
	     *     var token = signer.getAuthToken({
	     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
	     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
	     *       username: 'test' // overriding username
	     *     });
	     *   @example Generating an auth token asynchronously
	     *     var signer = new AWS.RDS.Signer({
	     *       // configure options
	     *       region: 'us-east-1',
	     *       username: 'default',
	     *       hostname: 'db.us-east-1.amazonaws.com',
	     *       port: 8000
	     *     });
	     *     signer.getAuthToken({
	     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
	     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
	     *       username: 'test' // overriding username
	     *     }, function(err, token) {
	     *       if (err) {
	     *         // handle error
	     *       } else {
	     *         // use token
	     *       }
	     *     });
	     *
	     */
	    getAuthToken: function getAuthToken(options, callback) {
	        if (typeof options === 'function' && callback === undefined) {
	            callback = options;
	            options = {};
	        }
	        var self = this;
	        var hasCallback = typeof callback === 'function';
	        // merge options with existing options
	        options = AWS.util.merge(this.options, options);
	        // validate options
	        var optionsValidation = this.validateAuthTokenOptions(options);
	        if (optionsValidation !== true) {
	            if (hasCallback) {
	                return callback(optionsValidation, null);
	            }
	            throw optionsValidation;
	        }

	        // 15 minutes
	        var expires = 900;
	        // create service to generate a request from
	        var serviceOptions = {
	            region: options.region,
	            endpoint: new AWS.Endpoint(options.hostname + ':' + options.port),
	            paramValidation: false,
	            signatureVersion: 'v4'
	        };
	        if (options.credentials) {
	            serviceOptions.credentials = options.credentials;
	        }
	        service = new AWS.Service(serviceOptions);
	        // ensure the SDK is using sigv4 signing (config is not enough)
	        service.api = api;

	        var request = service.makeRequest();
	        // add listeners to request to properly build auth token
	        this.modifyRequestForAuthToken(request, options);

	        if (hasCallback) {
	            request.presign(expires, function(err, url) {
	                if (url) {
	                    url = self.convertUrlToAuthToken(url);
	                }
	                callback(err, url);
	            });
	        } else {
	            var url = request.presign(expires);
	            return this.convertUrlToAuthToken(url);
	        }
	    },

	    /**
	     * @api private
	     * Modifies a request to allow the presigner to generate an auth token.
	     */
	    modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
	        request.on('build', request.buildAsGet);
	        var httpRequest = request.httpRequest;
	        httpRequest.body = AWS.util.queryParamsToString({
	            Action: 'connect',
	            DBUser: options.username
	        });
	    },

	    /**
	     * @api private
	     * Validates that the options passed in contain all the keys with values of the correct type that
	     *   are needed to generate an auth token.
	     */
	    validateAuthTokenOptions: function validateAuthTokenOptions(options) {
	        // iterate over all keys in options
	        var message = '';
	        options = options || {};
	        for (var key in requiredAuthTokenOptions) {
	            if (!Object.prototype.hasOwnProperty.call(requiredAuthTokenOptions, key)) {
	                continue;
	            }
	            if (typeof options[key] !== requiredAuthTokenOptions[key]) {
	                message += 'option \'' + key + '\' should have been type \'' + requiredAuthTokenOptions[key] + '\', was \'' + typeof options[key] + '\'.\n';
	            }
	        }
	        if (message.length) {
	            return AWS.util.error(new Error(), {
	                code: 'InvalidParameter',
	                message: message
	            });
	        }
	        return true;
	    }
	});


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-10","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-01-10","xmlNamespace":"http://rds.amazonaws.com/doc/2013-01-10/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1c"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S25"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S25","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2f"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2f"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1o","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3o"}},"wrapper":true}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3m"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMembership":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1i":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S25":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2f":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3o"}},"wrapper":true},"S3o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3z":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-12","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-02-12","xmlNamespace":"http://rds.amazonaws.com/doc/2013-02-12/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1d"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S28"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S28","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1d","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2n"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1p","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3w","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3y"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3w"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1d":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1j":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1t":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S28":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2n":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3w":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3y"}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4b":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-09-09","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-09-09","xmlNamespace":"http://rds.amazonaws.com/doc/2013-09-09/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2d"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2d","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1f","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2s"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S27"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1r","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S41","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S43"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S41"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1f":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1v":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S27":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2d":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S41":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S43"}},"wrapper":true},"S43":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4g":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-09-01","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-09-01","xmlNamespace":"http://rds.amazonaws.com/doc/2014-09-01/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{},"StorageType":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S17","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2w"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1b","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S2b"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"St","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1e","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S45","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"S13"},"VpcSecurityGroupMemberships":{"shape":"S14"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S45"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"Sn":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"St":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sy"},"VpcSecurityGroupMemberships":{"shape":"S10"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"Sx":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"Sy":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S14":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S17":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sy"},"VpcSecurityGroups":{"shape":"S10"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1b"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1e"},"SubnetStatus":{}}}}},"wrapper":true},"S1e":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2b":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S45":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4k":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddRoleToDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sb"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Sf"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"BacktrackDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","BacktrackTo"],"members":{"DBClusterIdentifier":{},"BacktrackTo":{"type":"timestamp"},"Force":{"type":"boolean"},"UseEarliestTimeOnPointInTimeUnavailable":{"type":"boolean"}}},"output":{"shape":"Ss","resultWrapper":"BacktrackDBClusterResult"}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskIdentifier"],"members":{"ExportTaskIdentifier":{}}},"output":{"shape":"Su","resultWrapper":"CancelExportTaskResult"}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sz"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sb"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S12"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S16"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"KmsKeyId":{},"Tags":{"shape":"Sb"},"CopyTags":{"type":"boolean"},"PreSignedUrl":{},"OptionGroupName":{},"TargetCustomAvailabilityZone":{},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1f"}}}},"CreateCustomDBEngineVersion":{"input":{"type":"structure","required":["Engine","EngineVersion","DatabaseInstallationFilesS3BucketName","KMSKeyId","Manifest"],"members":{"Engine":{},"EngineVersion":{},"DatabaseInstallationFilesS3BucketName":{},"DatabaseInstallationFilesS3Prefix":{},"KMSKeyId":{},"Description":{},"Manifest":{},"Tags":{"shape":"Sb"}}},"output":{"shape":"S1w","resultWrapper":"CreateCustomDBEngineVersionResult"}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"S13"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S27"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S24"},"EngineMode":{},"ScalingConfiguration":{"shape":"S29"},"DeletionProtection":{"type":"boolean"},"GlobalClusterIdentifier":{},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"EnableGlobalWriteForwarding":{"type":"boolean"},"DBClusterInstanceClass":{},"AllocatedStorage":{"type":"integer"},"StorageType":{},"Iops":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"shape":"S2a"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"CreateDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterIdentifier","DBClusterEndpointIdentifier","EndpointType"],"members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"},"Tags":{"shape":"Sb"}}},"output":{"shape":"S2v","resultWrapper":"CreateDBClusterEndpointResult"}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sz"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S12"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S31"},"VpcSecurityGroupIds":{"shape":"S27"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"NcharCharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S24"},"ProcessorFeatures":{"shape":"S1b"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"EnableCustomerOwnedIp":{"type":"boolean"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"DBParameterGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"S27"},"StorageType":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S24"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"ReplicaMode":{},"MaxAllocatedStorage":{"type":"integer"},"CustomIamInstanceProfile":{},"NetworkType":{},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S16"}}}},"CreateDBProxy":{"input":{"type":"structure","required":["DBProxyName","EngineFamily","Auth","RoleArn","VpcSubnetIds"],"members":{"DBProxyName":{},"EngineFamily":{},"Auth":{"shape":"S3v"},"RoleArn":{},"VpcSubnetIds":{"shape":"Sv"},"VpcSecurityGroupIds":{"shape":"Sv"},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S40"}}}},"CreateDBProxyEndpoint":{"input":{"type":"structure","required":["DBProxyName","DBProxyEndpointName","VpcSubnetIds"],"members":{"DBProxyName":{},"DBProxyEndpointName":{},"VpcSubnetIds":{"shape":"Sv"},"VpcSecurityGroupIds":{"shape":"Sv"},"TargetRole":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBProxyEndpointResult","type":"structure","members":{"DBProxyEndpoint":{"shape":"S49"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S4g"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S37"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"SourceIds":{"shape":"S7"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"CreateGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"SourceDBClusterIdentifier":{},"Engine":{},"EngineVersion":{},"DeletionProtection":{"type":"boolean"},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"}}},"output":{"resultWrapper":"CreateGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S4m"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1f"}}}},"DeleteCustomDBEngineVersion":{"input":{"type":"structure","required":["Engine","EngineVersion"],"members":{"Engine":{},"EngineVersion":{}}},"output":{"shape":"S1w","resultWrapper":"DeleteCustomDBEngineVersionResult"}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"DeleteDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{}}},"output":{"shape":"S2v","resultWrapper":"DeleteDBClusterEndpointResult"}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S12"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{},"DeleteAutomatedBackups":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"DeleteDBInstanceAutomatedBackup":{"input":{"type":"structure","members":{"DbiResourceId":{},"DBInstanceAutomatedBackupsArn":{}}},"output":{"resultWrapper":"DeleteDBInstanceAutomatedBackupResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S55"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBProxy":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{}}},"output":{"resultWrapper":"DeleteDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S40"}}}},"DeleteDBProxyEndpoint":{"input":{"type":"structure","required":["DBProxyEndpointName"],"members":{"DBProxyEndpointName":{}}},"output":{"resultWrapper":"DeleteDBProxyEndpointResult","type":"structure","members":{"DBProxyEndpoint":{"shape":"S49"}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"DeleteGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S4m"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DeregisterDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"DBInstanceIdentifiers":{"shape":"Sv"},"DBClusterIdentifiers":{"shape":"Sv"}}},"output":{"resultWrapper":"DeregisterDBProxyTargetsResult","type":"structure","members":{}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountQuotas":{"type":"list","member":{"locationName":"AccountQuota","type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}},"wrapper":true}}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"Certificates":{"type":"list","member":{"shape":"S5y","locationName":"Certificate"}},"Marker":{}}}},"DescribeDBClusterBacktracks":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterBacktracksResult","type":"structure","members":{"Marker":{},"DBClusterBacktracks":{"type":"list","member":{"shape":"Ss","locationName":"DBClusterBacktrack"}}}}},"DescribeDBClusterEndpoints":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterEndpointsResult","type":"structure","members":{"Marker":{},"DBClusterEndpoints":{"type":"list","member":{"shape":"S2v","locationName":"DBClusterEndpointList"}}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sz","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S6a"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S6f"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"S12","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"S2d","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"},"IncludeAll":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"shape":"S1w","locationName":"DBEngineVersion"}}}}},"DescribeDBInstanceAutomatedBackups":{"input":{"type":"structure","members":{"DbiResourceId":{},"DBInstanceIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{},"DBInstanceAutomatedBackupsArn":{}}},"output":{"resultWrapper":"DescribeDBInstanceAutomatedBackupsResult","type":"structure","members":{"Marker":{},"DBInstanceAutomatedBackups":{"type":"list","member":{"shape":"S55","locationName":"DBInstanceAutomatedBackup"}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S33","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S16","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S6a"},"Marker":{}}}},"DescribeDBProxies":{"input":{"type":"structure","members":{"DBProxyName":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxiesResult","type":"structure","members":{"DBProxies":{"type":"list","member":{"shape":"S40"}},"Marker":{}}}},"DescribeDBProxyEndpoints":{"input":{"type":"structure","members":{"DBProxyName":{},"DBProxyEndpointName":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyEndpointsResult","type":"structure","members":{"DBProxyEndpoints":{"type":"list","member":{"shape":"S49"}},"Marker":{}}}},"DescribeDBProxyTargetGroups":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyTargetGroupsResult","type":"structure","members":{"TargetGroups":{"type":"list","member":{"shape":"S7h"}},"Marker":{}}}},"DescribeDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyTargetsResult","type":"structure","members":{"Targets":{"shape":"S7l"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sl","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshotAttributes":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBSnapshotAttributesResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S7x"}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"},"DbiResourceId":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"S19","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S37","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S88"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S88"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S5t"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S8"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S6","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S8"},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S8"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIdentifier":{},"SourceArn":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeExportTasksResult","type":"structure","members":{"Marker":{},"ExportTasks":{"type":"list","member":{"shape":"Su","locationName":"ExportTask"}}}}},"DescribeGlobalClusters":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeGlobalClustersResult","type":"structure","members":{"Marker":{},"GlobalClusters":{"type":"list","member":{"shape":"S4m","locationName":"GlobalClusterMember"}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"OptionsConflictsWith":{"type":"list","member":{"locationName":"OptionConflictName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"RequiresAutoMinorEngineVersionUpgrade":{"type":"boolean"},"VpcOnly":{"type":"boolean"},"SupportsOptionVersionDowngrade":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsRequired":{"type":"boolean"},"MinimumEngineVersionPerAllowedValue":{"type":"list","member":{"locationName":"MinimumEngineVersionPerAllowedValue","type":"structure","members":{"AllowedValue":{},"MinimumEngineVersion":{}}}}}}},"OptionGroupOptionVersions":{"type":"list","member":{"locationName":"OptionVersion","type":"structure","members":{"Version":{},"IsDefault":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1f","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZoneGroup":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZoneGroup":{},"AvailabilityZones":{"type":"list","member":{"shape":"S3a","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"},"AvailableProcessorFeatures":{"shape":"S9d"},"SupportedEngineModes":{"shape":"S21"},"SupportsStorageAutoscaling":{"type":"boolean"},"SupportsKerberosAuthentication":{"type":"boolean"},"OutpostCapable":{"type":"boolean"},"SupportedActivityStreamModes":{"type":"list","member":{}},"SupportsGlobalDatabases":{"type":"boolean"},"SupportsClusters":{"type":"boolean"},"SupportedNetworkTypes":{"shape":"Sv"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S5t"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Sf","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"LeaseId":{},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S9m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S5t"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S9o"}},"wrapper":true}}}}},"DescribeSourceRegions":{"input":{"type":"structure","members":{"RegionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S5t"}}},"output":{"resultWrapper":"DescribeSourceRegionsResult","type":"structure","members":{"Marker":{},"SourceRegions":{"type":"list","member":{"locationName":"SourceRegion","type":"structure","members":{"RegionName":{},"Endpoint":{},"Status":{},"SupportsDBInstanceAutomatedBackupsReplication":{"type":"boolean"}}}}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"Sa3"},"ProvisionedIops":{"shape":"Sa3"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}},"SupportsStorageAutoscaling":{"type":"boolean"}}}},"ValidProcessorFeatures":{"shape":"S9d"}},"wrapper":true}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"FailoverDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"FailoverGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier","TargetDbClusterIdentifier"],"members":{"GlobalClusterIdentifier":{},"TargetDbClusterIdentifier":{}}},"output":{"resultWrapper":"FailoverGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S4m"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S5t"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sb"}}}},"ModifyCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"RemoveCustomerOverride":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyCertificatesResult","type":"structure","members":{"Certificate":{"shape":"S5y"}}}},"ModifyCurrentDBClusterCapacity":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"Capacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}},"output":{"resultWrapper":"ModifyCurrentDBClusterCapacityResult","type":"structure","members":{"DBClusterIdentifier":{},"PendingCapacity":{"type":"integer"},"CurrentCapacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}}},"ModifyCustomDBEngineVersion":{"input":{"type":"structure","required":["Engine","EngineVersion"],"members":{"Engine":{},"EngineVersion":{},"Description":{},"Status":{}}},"output":{"shape":"S1w","resultWrapper":"ModifyCustomDBEngineVersionResult"}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S27"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"CloudwatchLogsExportConfiguration":{"shape":"Sao"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"DBInstanceParameterGroupName":{},"Domain":{},"DomainIAMRoleName":{},"ScalingConfiguration":{"shape":"S29"},"DeletionProtection":{"type":"boolean"},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"EnableGlobalWriteForwarding":{"type":"boolean"},"DBClusterInstanceClass":{},"AllocatedStorage":{"type":"integer"},"StorageType":{},"Iops":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"ModifyDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"}}},"output":{"shape":"S2v","resultWrapper":"ModifyDBClusterEndpointResult"}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S6a"}}},"output":{"shape":"Sas","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S6i"},"ValuesToRemove":{"shape":"S6i"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S6f"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S31"},"VpcSecurityGroupIds":{"shape":"S27"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"CloudwatchLogsExportConfiguration":{"shape":"Sao"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"CertificateRotationRestart":{"type":"boolean"},"ReplicaMode":{},"EnableCustomerOwnedIp":{"type":"boolean"},"AwsBackupRecoveryPointArn":{},"AutomationMode":{},"ResumeFullAutomationModeMinutes":{"type":"integer"},"NetworkType":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S6a"}}},"output":{"shape":"Saz","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBProxy":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"NewDBProxyName":{},"Auth":{"shape":"S3v"},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"RoleArn":{},"SecurityGroups":{"shape":"Sv"}}},"output":{"resultWrapper":"ModifyDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S40"}}}},"ModifyDBProxyEndpoint":{"input":{"type":"structure","required":["DBProxyEndpointName"],"members":{"DBProxyEndpointName":{},"NewDBProxyEndpointName":{},"VpcSecurityGroupIds":{"shape":"Sv"}}},"output":{"resultWrapper":"ModifyDBProxyEndpointResult","type":"structure","members":{"DBProxyEndpoint":{"shape":"S49"}}}},"ModifyDBProxyTargetGroup":{"input":{"type":"structure","required":["TargetGroupName","DBProxyName"],"members":{"TargetGroupName":{},"DBProxyName":{},"ConnectionPoolConfig":{"type":"structure","members":{"MaxConnectionsPercent":{"type":"integer"},"MaxIdleConnectionsPercent":{"type":"integer"},"ConnectionBorrowTimeout":{"type":"integer"},"SessionPinningFilters":{"shape":"Sv"},"InitQuery":{}}},"NewName":{}}},"output":{"resultWrapper":"ModifyDBProxyTargetGroupResult","type":"structure","members":{"DBProxyTargetGroup":{"shape":"S7h"}}}},"ModifyDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{},"EngineVersion":{},"OptionGroupName":{}}},"output":{"resultWrapper":"ModifyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S19"}}}},"ModifyDBSnapshotAttribute":{"input":{"type":"structure","required":["DBSnapshotIdentifier","AttributeName"],"members":{"DBSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S6i"},"ValuesToRemove":{"shape":"S6i"}}},"output":{"resultWrapper":"ModifyDBSnapshotAttributeResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S7x"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S4g"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S37"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"ModifyGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"NewGlobalClusterIdentifier":{},"DeletionProtection":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S4m"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"OptionVersion":{},"DBSecurityGroupMemberships":{"shape":"S31"},"VpcSecurityGroupMemberships":{"shape":"S27"},"OptionSettings":{"type":"list","member":{"shape":"S1j","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1f"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S9m"}}}},"RebootDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"RebootDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"RegisterDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"DBInstanceIdentifiers":{"shape":"Sv"},"DBClusterIdentifiers":{"shape":"Sv"}}},"output":{"resultWrapper":"RegisterDBProxyTargetsResult","type":"structure","members":{"DBProxyTargets":{"shape":"S7l"}}}},"RemoveFromGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"DbClusterIdentifier":{}}},"output":{"resultWrapper":"RemoveFromGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S4m"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveRoleFromDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S6a"}}},"output":{"shape":"Sas","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S6a"}}},"output":{"shape":"Saz","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromS3":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","MasterUserPassword","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"AvailabilityZones":{"shape":"S13"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S27"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S24"},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"ServerlessV2ScalingConfiguration":{"shape":"S2a"}}},"output":{"resultWrapper":"RestoreDBClusterFromS3Result","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"S13"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S27"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S24"},"EngineMode":{},"ScalingConfiguration":{"shape":"S29"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"DBClusterInstanceClass":{},"StorageType":{},"Iops":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"ServerlessV2ScalingConfiguration":{"shape":"S2a"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S27"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S24"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"ScalingConfiguration":{"shape":"S29"},"EngineMode":{},"DBClusterInstanceClass":{},"StorageType":{},"PubliclyAccessible":{"type":"boolean"},"Iops":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"shape":"S2a"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S27"},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S24"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"EnableCustomerOwnedIp":{"type":"boolean"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"RestoreDBInstanceFromS3":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S31"},"VpcSecurityGroupIds":{"shape":"S27"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S24"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"NetworkType":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromS3Result","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CopyTagsToSnapshot":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S27"},"Domain":{},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S24"},"ProcessorFeatures":{"shape":"S1b"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"SourceDbiResourceId":{},"MaxAllocatedStorage":{"type":"integer"},"SourceDBInstanceAutomatedBackupsArn":{},"EnableCustomerOwnedIp":{"type":"boolean"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"StartActivityStream":{"input":{"type":"structure","required":["ResourceArn","Mode","KmsKeyId"],"members":{"ResourceArn":{},"Mode":{},"KmsKeyId":{},"ApplyImmediately":{"type":"boolean"},"EngineNativeAuditFieldsIncluded":{"type":"boolean"}}},"output":{"resultWrapper":"StartActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{},"Mode":{},"ApplyImmediately":{"type":"boolean"},"EngineNativeAuditFieldsIncluded":{"type":"boolean"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"StartDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"StartDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"StartDBInstanceAutomatedBackupsReplication":{"input":{"type":"structure","required":["SourceDBInstanceArn"],"members":{"SourceDBInstanceArn":{},"BackupRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"PreSignedUrl":{}}},"output":{"resultWrapper":"StartDBInstanceAutomatedBackupsReplicationResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S55"}}}},"StartExportTask":{"input":{"type":"structure","required":["ExportTaskIdentifier","SourceArn","S3BucketName","IamRoleArn","KmsKeyId"],"members":{"ExportTaskIdentifier":{},"SourceArn":{},"S3BucketName":{},"IamRoleArn":{},"KmsKeyId":{},"S3Prefix":{},"ExportOnly":{"shape":"Sv"}}},"output":{"shape":"Su","resultWrapper":"StartExportTaskResult"}},"StopActivityStream":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"StopActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S2d"}}}},"StopDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"StopDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S33"}}}},"StopDBInstanceAutomatedBackupsReplication":{"input":{"type":"structure","required":["SourceDBInstanceArn"],"members":{"SourceDBInstanceArn":{}}},"output":{"resultWrapper":"StopDBInstanceAutomatedBackupsReplicationResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S55"}}}}},"shapes":{"S6":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S7"},"EventCategoriesList":{"shape":"S8"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S7":{"type":"list","member":{"locationName":"SourceId"}},"S8":{"type":"list","member":{"locationName":"EventCategory"}},"Sb":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sl":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}},"DBSecurityGroupArn":{}},"wrapper":true},"Ss":{"type":"structure","members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"BacktrackTo":{"type":"timestamp"},"BacktrackedFrom":{"type":"timestamp"},"BacktrackRequestCreationTime":{"type":"timestamp"},"Status":{}}},"Su":{"type":"structure","members":{"ExportTaskIdentifier":{},"SourceArn":{},"ExportOnly":{"shape":"Sv"},"SnapshotTime":{"type":"timestamp"},"TaskStartTime":{"type":"timestamp"},"TaskEndTime":{"type":"timestamp"},"S3Bucket":{},"S3Prefix":{},"IamRoleArn":{},"KmsKeyId":{},"Status":{},"PercentProgress":{"type":"integer"},"TotalExtractedDataInGB":{"type":"integer"},"FailureCause":{},"WarningMessage":{}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"S12":{"type":"structure","members":{"AvailabilityZones":{"shape":"S13"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"EngineMode":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"TagList":{"shape":"Sb"}},"wrapper":true},"S13":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S16":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"S19":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDBSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"DBSnapshotArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"ProcessorFeatures":{"shape":"S1b"},"DbiResourceId":{},"TagList":{"shape":"Sb"},"OriginalSnapshotCreateTime":{"type":"timestamp"},"SnapshotTarget":{}},"wrapper":true},"S1b":{"type":"list","member":{"locationName":"ProcessorFeature","type":"structure","members":{"Name":{},"Value":{}}}},"S1f":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionVersion":{},"OptionSettings":{"type":"list","member":{"shape":"S1j","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"S1k"},"VpcSecurityGroupMemberships":{"shape":"S1m"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{},"OptionGroupArn":{}},"wrapper":true},"S1j":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S1k":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S1m":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1w":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S1x"},"SupportedCharacterSets":{"shape":"S1y"},"SupportedNcharCharacterSets":{"shape":"S1y"},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"},"SupportedEngineModes":{"shape":"S21"},"SupportsParallelQuery":{"type":"boolean"},"SupportsGlobalDatabases":{"type":"boolean"},"SupportsBabelfish":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"S24"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"},"SupportedEngineModes":{"shape":"S21"},"SupportedFeatureNames":{"type":"list","member":{}},"Status":{},"SupportsParallelQuery":{"type":"boolean"},"SupportsGlobalDatabases":{"type":"boolean"},"MajorEngineVersion":{},"DatabaseInstallationFilesS3BucketName":{},"DatabaseInstallationFilesS3Prefix":{},"DBEngineVersionArn":{},"KMSKeyId":{},"CreateTime":{"type":"timestamp"},"TagList":{"shape":"Sb"},"SupportsBabelfish":{"type":"boolean"}}},"S1x":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S1y":{"type":"list","member":{"shape":"S1x","locationName":"CharacterSet"}},"S21":{"type":"list","member":{}},"S24":{"type":"list","member":{}},"S27":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S29":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{},"SecondsBeforeTimeout":{"type":"integer"}}},"S2a":{"type":"structure","members":{"MinCapacity":{"type":"double"},"MaxCapacity":{"type":"double"}}},"S2d":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"S13"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"AutomaticRestartTime":{"type":"timestamp"},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"CustomEndpoints":{"shape":"Sv"},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S1m"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{},"FeatureName":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"},"EarliestBacktrackTime":{"type":"timestamp"},"BacktrackWindow":{"type":"long"},"BacktrackConsumedChangeRecords":{"type":"long"},"EnabledCloudwatchLogsExports":{"shape":"S24"},"Capacity":{"type":"integer"},"EngineMode":{},"ScalingConfigurationInfo":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{},"SecondsBeforeTimeout":{"type":"integer"}}},"DeletionProtection":{"type":"boolean"},"HttpEndpointEnabled":{"type":"boolean"},"ActivityStreamMode":{},"ActivityStreamStatus":{},"ActivityStreamKmsKeyId":{},"ActivityStreamKinesisStreamName":{},"CopyTagsToSnapshot":{"type":"boolean"},"CrossAccountClone":{"type":"boolean"},"DomainMemberships":{"shape":"S2o"},"TagList":{"shape":"Sb"},"GlobalWriteForwardingStatus":{},"GlobalWriteForwardingRequested":{"type":"boolean"},"PendingModifiedValues":{"type":"structure","members":{"PendingCloudwatchLogsExports":{"shape":"S2s"},"DBClusterIdentifier":{},"MasterUserPassword":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"EngineVersion":{}}},"DBClusterInstanceClass":{},"StorageType":{},"Iops":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"type":"structure","members":{"MinCapacity":{"type":"double"},"MaxCapacity":{"type":"double"}}}},"wrapper":true},"S2o":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"S2s":{"type":"structure","members":{"LogTypesToEnable":{"shape":"S24"},"LogTypesToDisable":{"shape":"S24"}}},"S2v":{"type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"},"DBClusterEndpointArn":{}}},"S31":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S33":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"AutomaticRestartTime":{"type":"timestamp"},"MasterUsername":{},"DBName":{},"Endpoint":{"shape":"S34"},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"S1k"},"VpcSecurityGroups":{"shape":"S1m"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S37"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"shape":"S2s"},"ProcessorFeatures":{"shape":"S1b"},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"AutomationMode":{},"ResumeFullAutomationModeTime":{"type":"timestamp"}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"ReplicaMode":{},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"NcharCharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"shape":"S2o"},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnabledCloudwatchLogsExports":{"shape":"S24"},"ProcessorFeatures":{"shape":"S1b"},"DeletionProtection":{"type":"boolean"},"AssociatedRoles":{"type":"list","member":{"locationName":"DBInstanceRole","type":"structure","members":{"RoleArn":{},"FeatureName":{},"Status":{}}}},"ListenerEndpoint":{"shape":"S34"},"MaxAllocatedStorage":{"type":"integer"},"TagList":{"shape":"Sb"},"DBInstanceAutomatedBackupsReplications":{"shape":"S3n"},"CustomerOwnedIpEnabled":{"type":"boolean"},"AwsBackupRecoveryPointArn":{},"ActivityStreamStatus":{},"ActivityStreamKmsKeyId":{},"ActivityStreamKinesisStreamName":{},"ActivityStreamMode":{},"ActivityStreamEngineNativeAuditFieldsIncluded":{"type":"boolean"},"AutomationMode":{},"ResumeFullAutomationModeTime":{"type":"timestamp"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{}},"wrapper":true},"S34":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"S37":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S3a"},"SubnetOutpost":{"type":"structure","members":{"Arn":{}}},"SubnetStatus":{}}}},"DBSubnetGroupArn":{},"SupportedNetworkTypes":{"shape":"Sv"}},"wrapper":true},"S3a":{"type":"structure","members":{"Name":{}},"wrapper":true},"S3n":{"type":"list","member":{"locationName":"DBInstanceAutomatedBackupsReplication","type":"structure","members":{"DBInstanceAutomatedBackupsArn":{}}}},"S3v":{"type":"list","member":{"type":"structure","members":{"Description":{},"UserName":{},"AuthScheme":{},"SecretArn":{},"IAMAuth":{}}}},"S40":{"type":"structure","members":{"DBProxyName":{},"DBProxyArn":{},"Status":{},"EngineFamily":{},"VpcId":{},"VpcSecurityGroupIds":{"shape":"Sv"},"VpcSubnetIds":{"shape":"Sv"},"Auth":{"type":"list","member":{"type":"structure","members":{"Description":{},"UserName":{},"AuthScheme":{},"SecretArn":{},"IAMAuth":{}}}},"RoleArn":{},"Endpoint":{},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"}}},"S49":{"type":"structure","members":{"DBProxyEndpointName":{},"DBProxyEndpointArn":{},"DBProxyName":{},"Status":{},"VpcId":{},"VpcSecurityGroupIds":{"shape":"Sv"},"VpcSubnetIds":{"shape":"Sv"},"Endpoint":{},"CreatedDate":{"type":"timestamp"},"TargetRole":{},"IsDefault":{"type":"boolean"}}},"S4g":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S4m":{"type":"structure","members":{"GlobalClusterIdentifier":{},"GlobalClusterResourceId":{},"GlobalClusterArn":{},"Status":{},"Engine":{},"EngineVersion":{},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"GlobalClusterMembers":{"type":"list","member":{"locationName":"GlobalClusterMember","type":"structure","members":{"DBClusterArn":{},"Readers":{"type":"list","member":{}},"IsWriter":{"type":"boolean"},"GlobalWriteForwardingStatus":{}},"wrapper":true}},"FailoverState":{"type":"structure","members":{"Status":{},"FromDbClusterArn":{},"ToDbClusterArn":{}},"wrapper":true}},"wrapper":true},"S55":{"type":"structure","members":{"DBInstanceArn":{},"DbiResourceId":{},"Region":{},"DBInstanceIdentifier":{},"RestoreWindow":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"Engine":{},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"StorageType":{},"KmsKeyId":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBInstanceAutomatedBackupsArn":{},"DBInstanceAutomatedBackupsReplications":{"shape":"S3n"},"BackupTarget":{}},"wrapper":true},"S5t":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S5y":{"type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{},"CustomerOverride":{"type":"boolean"},"CustomerOverrideValidTill":{"type":"timestamp"}},"wrapper":true},"S6a":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{},"SupportedEngineModes":{"shape":"S21"}}}},"S6f":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S6i"}}}}},"wrapper":true},"S6i":{"type":"list","member":{"locationName":"AttributeValue"}},"S7h":{"type":"structure","members":{"DBProxyName":{},"TargetGroupName":{},"TargetGroupArn":{},"IsDefault":{"type":"boolean"},"Status":{},"ConnectionPoolConfig":{"type":"structure","members":{"MaxConnectionsPercent":{"type":"integer"},"MaxIdleConnectionsPercent":{"type":"integer"},"ConnectionBorrowTimeout":{"type":"integer"},"SessionPinningFilters":{"shape":"Sv"},"InitQuery":{}}},"CreatedDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"}}},"S7l":{"type":"list","member":{"type":"structure","members":{"TargetArn":{},"Endpoint":{},"TrackedClusterId":{},"RdsResourceId":{},"Port":{"type":"integer"},"Type":{},"Role":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}},"S7x":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBSnapshotAttributes":{"type":"list","member":{"locationName":"DBSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S6i"}},"wrapper":true}}},"wrapper":true},"S88":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S6a"}},"wrapper":true},"S9d":{"type":"list","member":{"locationName":"AvailableProcessorFeature","type":"structure","members":{"Name":{},"DefaultValue":{},"AllowedValues":{}}}},"S9m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S9o"},"ReservedDBInstanceArn":{},"LeaseId":{}},"wrapper":true},"S9o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"Sa3":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"Sao":{"type":"structure","members":{"EnableLogTypes":{"shape":"S24"},"DisableLogTypes":{"shape":"S24"}}},"Sas":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"Saz":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Certificates"},"DescribeDBClusterBacktracks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterBacktracks"},"DescribeDBClusterEndpoints":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterEndpoints"},"DescribeDBClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterParameterGroups"},"DescribeDBClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterSnapshots"},"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstanceAutomatedBackups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstanceAutomatedBackups"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBProxies":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBProxies"},"DescribeDBProxyEndpoints":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBProxyEndpoints"},"DescribeDBProxyTargetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TargetGroups"},"DescribeDBProxyTargets":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Targets"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeExportTasks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ExportTasks"},"DescribeGlobalClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalClusters"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribePendingMaintenanceActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"PendingMaintenanceActions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DescribeSourceRegions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SourceRegions"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBInstances) == `0`"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBSnapshotAvailable":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBSnapshotDeleted":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBSnapshots) == `0`"},{"expected":"DBSnapshotNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBClusterSnapshotAvailable":{"delay":30,"operation":"DescribeDBClusterSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBClusterSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"}]},"DBClusterSnapshotDeleted":{"delay":30,"operation":"DescribeDBClusterSnapshots","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBClusterSnapshots) == `0`"},{"expected":"DBClusterSnapshotNotFoundFault","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"}]}}}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['redshift'] = {};
	AWS.Redshift = Service.defineService('redshift', ['2012-12-01']);
	Object.defineProperty(apiLoader.services['redshift'], '2012-12-01', {
	  get: function get() {
	    var model = __webpack_require__(340);
	    model.paginators = __webpack_require__(341).pagination;
	    model.waiters = __webpack_require__(342).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Redshift;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-12-01","endpointPrefix":"redshift","protocol":"query","serviceFullName":"Amazon Redshift","serviceId":"Redshift","signatureVersion":"v4","uid":"redshift-2012-12-01","xmlNamespace":"http://redshift.amazonaws.com/doc/2012-12-01/"},"operations":{"AcceptReservedNodeExchange":{"input":{"type":"structure","required":["ReservedNodeId","TargetReservedNodeOfferingId"],"members":{"ReservedNodeId":{},"TargetReservedNodeOfferingId":{}}},"output":{"resultWrapper":"AcceptReservedNodeExchangeResult","type":"structure","members":{"ExchangedReservedNode":{"shape":"S4"}}}},"AddPartner":{"input":{"shape":"Sb"},"output":{"shape":"Sg","resultWrapper":"AddPartnerResult"}},"AssociateDataShareConsumer":{"input":{"type":"structure","required":["DataShareArn"],"members":{"DataShareArn":{},"AssociateEntireAccount":{"type":"boolean"},"ConsumerArn":{},"ConsumerRegion":{}}},"output":{"shape":"Sj","resultWrapper":"AssociateDataShareConsumerResult"}},"AuthorizeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sq"}}}},"AuthorizeDataShare":{"input":{"type":"structure","required":["DataShareArn","ConsumerIdentifier"],"members":{"DataShareArn":{},"ConsumerIdentifier":{}}},"output":{"shape":"Sj","resultWrapper":"AuthorizeDataShareResult"}},"AuthorizeEndpointAccess":{"input":{"type":"structure","required":["Account"],"members":{"ClusterIdentifier":{},"Account":{},"VpcIds":{"shape":"Sz"}}},"output":{"shape":"S10","resultWrapper":"AuthorizeEndpointAccessResult"}},"AuthorizeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"AuthorizeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"BatchDeleteClusterSnapshots":{"input":{"type":"structure","required":["Identifiers"],"members":{"Identifiers":{"type":"list","member":{"shape":"S1c","locationName":"DeleteClusterSnapshotMessage"}}}},"output":{"resultWrapper":"BatchDeleteClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"S1e"},"Errors":{"type":"list","member":{"shape":"S1g","locationName":"SnapshotErrorMessage"}}}}},"BatchModifyClusterSnapshots":{"input":{"type":"structure","required":["SnapshotIdentifierList"],"members":{"SnapshotIdentifierList":{"shape":"S1e"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"BatchModifyClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"S1e"},"Errors":{"type":"list","member":{"shape":"S1g","locationName":"SnapshotErrorMessage"}}}}},"CancelResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S1l","resultWrapper":"CancelResizeResult"}},"CopyClusterSnapshot":{"input":{"type":"structure","required":["SourceSnapshotIdentifier","TargetSnapshotIdentifier"],"members":{"SourceSnapshotIdentifier":{},"SourceSnapshotClusterIdentifier":{},"TargetSnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"CopyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"CreateAuthenticationProfile":{"input":{"type":"structure","required":["AuthenticationProfileName","AuthenticationProfileContent"],"members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}},"output":{"resultWrapper":"CreateAuthenticationProfileResult","type":"structure","members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NodeType","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"MasterUsername":{},"MasterUserPassword":{},"ClusterSecurityGroups":{"shape":"S1x"},"VpcSecurityGroupIds":{"shape":"S1y"},"ClusterSubnetGroupName":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Port":{"type":"integer"},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"Tags":{"shape":"St"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S1z"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{},"AvailabilityZoneRelocation":{"type":"boolean"},"AquaConfigurationStatus":{},"DefaultIamRoleArn":{}}},"output":{"resultWrapper":"CreateClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"CreateClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterGroupFamily","Description"],"members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterParameterGroupResult","type":"structure","members":{"ClusterParameterGroup":{"shape":"S31"}}}},"CreateClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName","Description"],"members":{"ClusterSecurityGroupName":{},"Description":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterSecurityGroupResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sq"}}}},"CreateClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier","ClusterIdentifier"],"members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"CreateClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","Description","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S37"},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S39"}}}},"CreateEndpointAccess":{"input":{"type":"structure","required":["EndpointName","SubnetGroupName"],"members":{"ClusterIdentifier":{},"ResourceOwner":{},"EndpointName":{},"SubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"S1y"}}},"output":{"shape":"S3g","resultWrapper":"CreateEndpointAccessResult"}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S3i"},"EventCategories":{"shape":"S3j"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S3l"}}}},"CreateHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateHsmClientCertificateResult","type":"structure","members":{"HsmClientCertificate":{"shape":"S3o"}}}},"CreateHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier","Description","HsmIpAddress","HsmPartitionName","HsmPartitionPassword","HsmServerPublicCertificate"],"members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"HsmPartitionPassword":{},"HsmServerPublicCertificate":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateHsmConfigurationResult","type":"structure","members":{"HsmConfiguration":{"shape":"S3r"}}}},"CreateScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName","TargetAction","Schedule","IamRole"],"members":{"ScheduledActionName":{},"TargetAction":{"shape":"S3t"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Enable":{"type":"boolean"}}},"output":{"shape":"S3x","resultWrapper":"CreateScheduledActionResult"}},"CreateSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateSnapshotCopyGrantResult","type":"structure","members":{"SnapshotCopyGrant":{"shape":"S42"}}}},"CreateSnapshotSchedule":{"input":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S44"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"St"},"DryRun":{"type":"boolean"},"NextInvocations":{"type":"integer"}}},"output":{"shape":"S45","resultWrapper":"CreateSnapshotScheduleResult"}},"CreateTags":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"St"}}}},"CreateUsageLimit":{"input":{"type":"structure","required":["ClusterIdentifier","FeatureType","LimitType","Amount"],"members":{"ClusterIdentifier":{},"FeatureType":{},"LimitType":{},"Amount":{"type":"long"},"Period":{},"BreachAction":{},"Tags":{"shape":"St"}}},"output":{"shape":"S4f","resultWrapper":"CreateUsageLimitResult"}},"DeauthorizeDataShare":{"input":{"type":"structure","required":["DataShareArn","ConsumerIdentifier"],"members":{"DataShareArn":{},"ConsumerIdentifier":{}}},"output":{"shape":"Sj","resultWrapper":"DeauthorizeDataShareResult"}},"DeleteAuthenticationProfile":{"input":{"type":"structure","required":["AuthenticationProfileName"],"members":{"AuthenticationProfileName":{}}},"output":{"resultWrapper":"DeleteAuthenticationProfileResult","type":"structure","members":{"AuthenticationProfileName":{}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SkipFinalClusterSnapshot":{"type":"boolean"},"FinalClusterSnapshotIdentifier":{},"FinalClusterSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"DeleteClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"DeleteClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}}},"DeleteClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{}}}},"DeleteClusterSnapshot":{"input":{"shape":"S1c"},"output":{"resultWrapper":"DeleteClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"DeleteClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName"],"members":{"ClusterSubnetGroupName":{}}}},"DeleteEndpointAccess":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"shape":"S3g","resultWrapper":"DeleteEndpointAccessResult"}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}}},"DeleteHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{}}}},"DeleteHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier"],"members":{"HsmConfigurationIdentifier":{}}}},"DeletePartner":{"input":{"shape":"Sb"},"output":{"shape":"Sg","resultWrapper":"DeletePartnerResult"}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{}}}},"DeleteSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier"],"members":{"ScheduleIdentifier":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"shape":"S4x"}}}},"DeleteUsageLimit":{"input":{"type":"structure","required":["UsageLimitId"],"members":{"UsageLimitId":{}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"type":"list","member":{"locationName":"AttributeName"}}}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountAttributes":{"type":"list","member":{"locationName":"AccountAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"type":"list","member":{"locationName":"AttributeValueTarget","type":"structure","members":{"AttributeValue":{}}}}}}}}}},"DescribeAuthenticationProfiles":{"input":{"type":"structure","members":{"AuthenticationProfileName":{}}},"output":{"resultWrapper":"DescribeAuthenticationProfilesResult","type":"structure","members":{"AuthenticationProfiles":{"type":"list","member":{"type":"structure","members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}}}}}},"DescribeClusterDbRevisions":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterDbRevisionsResult","type":"structure","members":{"Marker":{},"ClusterDbRevisions":{"type":"list","member":{"locationName":"ClusterDbRevision","type":"structure","members":{"ClusterIdentifier":{},"CurrentDatabaseRevision":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"},"RevisionTargets":{"type":"list","member":{"locationName":"RevisionTarget","type":"structure","members":{"DatabaseRevision":{},"Description":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"}}}}}}}}}},"DescribeClusterParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"ParameterGroups":{"type":"list","member":{"shape":"S31","locationName":"ClusterParameterGroup"}}}}},"DescribeClusterParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S5m"},"Marker":{}}}},"DescribeClusterSecurityGroups":{"input":{"type":"structure","members":{"ClusterSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeClusterSecurityGroupsResult","type":"structure","members":{"Marker":{},"ClusterSecurityGroups":{"type":"list","member":{"shape":"Sq","locationName":"ClusterSecurityGroup"}}}}},"DescribeClusterSnapshots":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"Marker":{},"OwnerAccount":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"},"ClusterExists":{"type":"boolean"},"SortingEntities":{"type":"list","member":{"locationName":"SnapshotSortingEntity","type":"structure","required":["Attribute"],"members":{"Attribute":{},"SortOrder":{}}}}}},"output":{"resultWrapper":"DescribeClusterSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"S14","locationName":"Snapshot"}}}}},"DescribeClusterSubnetGroups":{"input":{"type":"structure","members":{"ClusterSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeClusterSubnetGroupsResult","type":"structure","members":{"Marker":{},"ClusterSubnetGroups":{"type":"list","member":{"shape":"S39","locationName":"ClusterSubnetGroup"}}}}},"DescribeClusterTracks":{"input":{"type":"structure","members":{"MaintenanceTrackName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterTracksResult","type":"structure","members":{"MaintenanceTracks":{"type":"list","member":{"locationName":"MaintenanceTrack","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"UpdateTargets":{"type":"list","member":{"locationName":"UpdateTarget","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"SupportedOperations":{"type":"list","member":{"locationName":"SupportedOperation","type":"structure","members":{"OperationName":{}}}}}}}}}},"Marker":{}}}},"DescribeClusterVersions":{"input":{"type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterVersionsResult","type":"structure","members":{"Marker":{},"ClusterVersions":{"type":"list","member":{"locationName":"ClusterVersion","type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"Description":{}}}}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeClustersResult","type":"structure","members":{"Marker":{},"Clusters":{"type":"list","member":{"shape":"S22","locationName":"Cluster"}}}}},"DescribeDataShares":{"input":{"type":"structure","members":{"DataShareArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDataSharesResult","type":"structure","members":{"DataShares":{"shape":"S6j"},"Marker":{}}}},"DescribeDataSharesForConsumer":{"input":{"type":"structure","members":{"ConsumerArn":{},"Status":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDataSharesForConsumerResult","type":"structure","members":{"DataShares":{"shape":"S6j"},"Marker":{}}}},"DescribeDataSharesForProducer":{"input":{"type":"structure","members":{"ProducerArn":{},"Status":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDataSharesForProducerResult","type":"structure","members":{"DataShares":{"shape":"S6j"},"Marker":{}}}},"DescribeDefaultClusterParameters":{"input":{"type":"structure","required":["ParameterGroupFamily"],"members":{"ParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDefaultClusterParametersResult","type":"structure","members":{"DefaultClusterParameters":{"type":"structure","members":{"ParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S5m"}},"wrapper":true}}}},"DescribeEndpointAccess":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"ResourceOwner":{},"EndpointName":{},"VpcId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEndpointAccessResult","type":"structure","members":{"EndpointAccessList":{"type":"list","member":{"shape":"S3g"}},"Marker":{}}}},"DescribeEndpointAuthorization":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"Account":{},"Grantee":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEndpointAuthorizationResult","type":"structure","members":{"EndpointAuthorizationList":{"type":"list","member":{"shape":"S10"}},"Marker":{}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"Events":{"type":"list","member":{"locationName":"EventInfoMap","type":"structure","members":{"EventId":{},"EventCategories":{"shape":"S3j"},"EventDescription":{},"Severity":{}},"wrapper":true}}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S3l","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S3j"},"Severity":{},"Date":{"type":"timestamp"},"EventId":{}}}}}}},"DescribeHsmClientCertificates":{"input":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeHsmClientCertificatesResult","type":"structure","members":{"Marker":{},"HsmClientCertificates":{"type":"list","member":{"shape":"S3o","locationName":"HsmClientCertificate"}}}}},"DescribeHsmConfigurations":{"input":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeHsmConfigurationsResult","type":"structure","members":{"Marker":{},"HsmConfigurations":{"type":"list","member":{"shape":"S3r","locationName":"HsmConfiguration"}}}}},"DescribeLoggingStatus":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S7k","resultWrapper":"DescribeLoggingStatusResult"}},"DescribeNodeConfigurationOptions":{"input":{"type":"structure","required":["ActionType"],"members":{"ActionType":{},"ClusterIdentifier":{},"SnapshotIdentifier":{},"OwnerAccount":{},"Filters":{"locationName":"Filter","type":"list","member":{"locationName":"NodeConfigurationOptionsFilter","type":"structure","members":{"Name":{},"Operator":{},"Values":{"shape":"S7t","locationName":"Value"}}}},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNodeConfigurationOptionsResult","type":"structure","members":{"NodeConfigurationOptionList":{"type":"list","member":{"locationName":"NodeConfigurationOption","type":"structure","members":{"NodeType":{},"NumberOfNodes":{"type":"integer"},"EstimatedDiskUtilizationPercent":{"type":"double"},"Mode":{}}}},"Marker":{}}}},"DescribeOrderableClusterOptions":{"input":{"type":"structure","members":{"ClusterVersion":{},"NodeType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableClusterOptionsResult","type":"structure","members":{"OrderableClusterOptions":{"type":"list","member":{"locationName":"OrderableClusterOption","type":"structure","members":{"ClusterVersion":{},"ClusterType":{},"NodeType":{},"AvailabilityZones":{"type":"list","member":{"shape":"S3c","locationName":"AvailabilityZone"}}},"wrapper":true}},"Marker":{}}}},"DescribePartners":{"input":{"type":"structure","required":["AccountId","ClusterIdentifier"],"members":{"AccountId":{},"ClusterIdentifier":{},"DatabaseName":{},"PartnerName":{}}},"output":{"resultWrapper":"DescribePartnersResult","type":"structure","members":{"PartnerIntegrationInfoList":{"type":"list","member":{"locationName":"PartnerIntegrationInfo","type":"structure","members":{"DatabaseName":{},"PartnerName":{},"Status":{},"StatusMessage":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"}}}}}}},"DescribeReservedNodeExchangeStatus":{"input":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeExchangeRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeExchangeStatusResult","type":"structure","members":{"ReservedNodeExchangeStatusDetails":{"type":"list","member":{"shape":"S2x","locationName":"ReservedNodeExchangeStatus"}},"Marker":{}}}},"DescribeReservedNodeOfferings":{"input":{"type":"structure","members":{"ReservedNodeOfferingId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S8e"}}}},"DescribeReservedNodes":{"input":{"type":"structure","members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodesResult","type":"structure","members":{"Marker":{},"ReservedNodes":{"type":"list","member":{"shape":"S4","locationName":"ReservedNode"}}}}},"DescribeResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S1l","resultWrapper":"DescribeResizeResult"}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"ScheduledActionName":{},"TargetActionType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Filters":{"type":"list","member":{"locationName":"ScheduledActionFilter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S7t"}}}},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"Marker":{},"ScheduledActions":{"type":"list","member":{"shape":"S3x","locationName":"ScheduledAction"}}}}},"DescribeSnapshotCopyGrants":{"input":{"type":"structure","members":{"SnapshotCopyGrantName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeSnapshotCopyGrantsResult","type":"structure","members":{"Marker":{},"SnapshotCopyGrants":{"type":"list","member":{"shape":"S42","locationName":"SnapshotCopyGrant"}}}}},"DescribeSnapshotSchedules":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSnapshotSchedulesResult","type":"structure","members":{"SnapshotSchedules":{"type":"list","member":{"shape":"S45","locationName":"SnapshotSchedule"}},"Marker":{}}}},"DescribeStorage":{"output":{"resultWrapper":"DescribeStorageResult","type":"structure","members":{"TotalBackupSizeInMegaBytes":{"type":"double"},"TotalProvisionedStorageInMegaBytes":{"type":"double"}}}},"DescribeTableRestoreStatus":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"TableRestoreRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeTableRestoreStatusResult","type":"structure","members":{"TableRestoreStatusDetails":{"type":"list","member":{"shape":"S91","locationName":"TableRestoreStatus"}},"Marker":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"ResourceName":{},"ResourceType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TaggedResources":{"type":"list","member":{"locationName":"TaggedResource","type":"structure","members":{"Tag":{"shape":"Su"},"ResourceName":{},"ResourceType":{}}}},"Marker":{}}}},"DescribeUsageLimits":{"input":{"type":"structure","members":{"UsageLimitId":{},"ClusterIdentifier":{},"FeatureType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S4x"},"TagValues":{"shape":"S5h"}}},"output":{"resultWrapper":"DescribeUsageLimitsResult","type":"structure","members":{"UsageLimits":{"type":"list","member":{"shape":"S4f"}},"Marker":{}}}},"DisableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S7k","resultWrapper":"DisableLoggingResult"}},"DisableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DisableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"DisassociateDataShareConsumer":{"input":{"type":"structure","required":["DataShareArn"],"members":{"DataShareArn":{},"DisassociateEntireAccount":{"type":"boolean"},"ConsumerArn":{},"ConsumerRegion":{}}},"output":{"shape":"Sj","resultWrapper":"DisassociateDataShareConsumerResult"}},"EnableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"BucketName":{},"S3KeyPrefix":{},"LogDestinationType":{},"LogExports":{"shape":"S7m"}}},"output":{"shape":"S7k","resultWrapper":"EnableLoggingResult"}},"EnableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier","DestinationRegion"],"members":{"ClusterIdentifier":{},"DestinationRegion":{},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"EnableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"GetClusterCredentials":{"input":{"type":"structure","required":["DbUser","ClusterIdentifier"],"members":{"DbUser":{},"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"AutoCreate":{"type":"boolean"},"DbGroups":{"type":"list","member":{"locationName":"DbGroup"}}}},"output":{"resultWrapper":"GetClusterCredentialsResult","type":"structure","members":{"DbUser":{},"DbPassword":{"type":"string","sensitive":true},"Expiration":{"type":"timestamp"}}}},"GetReservedNodeExchangeConfigurationOptions":{"input":{"type":"structure","required":["ActionType"],"members":{"ActionType":{},"ClusterIdentifier":{},"SnapshotIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetReservedNodeExchangeConfigurationOptionsResult","type":"structure","members":{"Marker":{},"ReservedNodeConfigurationOptionList":{"type":"list","member":{"locationName":"ReservedNodeConfigurationOption","type":"structure","members":{"SourceReservedNode":{"shape":"S4"},"TargetReservedNodeCount":{"type":"integer"},"TargetReservedNodeOffering":{"shape":"S8f"}},"wrapper":true}}}}},"GetReservedNodeExchangeOfferings":{"input":{"type":"structure","required":["ReservedNodeId"],"members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetReservedNodeExchangeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S8e"}}}},"ModifyAquaConfiguration":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AquaConfigurationStatus":{}}},"output":{"resultWrapper":"ModifyAquaConfigurationResult","type":"structure","members":{"AquaConfiguration":{"shape":"S2v"}}}},"ModifyAuthenticationProfile":{"input":{"type":"structure","required":["AuthenticationProfileName","AuthenticationProfileContent"],"members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}},"output":{"resultWrapper":"ModifyAuthenticationProfileResult","type":"structure","members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterSecurityGroups":{"shape":"S1x"},"VpcSecurityGroupIds":{"shape":"S1y"},"MasterUserPassword":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"PreferredMaintenanceWindow":{},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"NewClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"ElasticIp":{},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"AvailabilityZoneRelocation":{"type":"boolean"},"AvailabilityZone":{},"Port":{"type":"integer"}}},"output":{"resultWrapper":"ModifyClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"ModifyClusterDbRevision":{"input":{"type":"structure","required":["ClusterIdentifier","RevisionTarget"],"members":{"ClusterIdentifier":{},"RevisionTarget":{}}},"output":{"resultWrapper":"ModifyClusterDbRevisionResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"ModifyClusterIamRoles":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AddIamRoles":{"shape":"S1z"},"RemoveIamRoles":{"shape":"S1z"},"DefaultIamRoleArn":{}}},"output":{"resultWrapper":"ModifyClusterIamRolesResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"ModifyClusterMaintenance":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"DeferMaintenance":{"type":"boolean"},"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"},"DeferMaintenanceDuration":{"type":"integer"}}},"output":{"resultWrapper":"ModifyClusterMaintenanceResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"ModifyClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Parameters"],"members":{"ParameterGroupName":{},"Parameters":{"shape":"S5m"}}},"output":{"shape":"Sa5","resultWrapper":"ModifyClusterParameterGroupResult"}},"ModifyClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"ModifyClusterSnapshotSchedule":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"DisassociateSchedule":{"type":"boolean"}}}},"ModifyClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S37"}}},"output":{"resultWrapper":"ModifyClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S39"}}}},"ModifyEndpointAccess":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{},"VpcSecurityGroupIds":{"shape":"S1y"}}},"output":{"shape":"S3g","resultWrapper":"ModifyEndpointAccessResult"}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S3i"},"EventCategories":{"shape":"S3j"},"Severity":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S3l"}}}},"ModifyScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"TargetAction":{"shape":"S3t"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Enable":{"type":"boolean"}}},"output":{"shape":"S3x","resultWrapper":"ModifyScheduledActionResult"}},"ModifySnapshotCopyRetentionPeriod":{"input":{"type":"structure","required":["ClusterIdentifier","RetentionPeriod"],"members":{"ClusterIdentifier":{},"RetentionPeriod":{"type":"integer"},"Manual":{"type":"boolean"}}},"output":{"resultWrapper":"ModifySnapshotCopyRetentionPeriodResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"ModifySnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier","ScheduleDefinitions"],"members":{"ScheduleIdentifier":{},"ScheduleDefinitions":{"shape":"S44"}}},"output":{"shape":"S45","resultWrapper":"ModifySnapshotScheduleResult"}},"ModifyUsageLimit":{"input":{"type":"structure","required":["UsageLimitId"],"members":{"UsageLimitId":{},"Amount":{"type":"long"},"BreachAction":{}}},"output":{"shape":"S4f","resultWrapper":"ModifyUsageLimitResult"}},"PauseCluster":{"input":{"shape":"S3v"},"output":{"resultWrapper":"PauseClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"PurchaseReservedNodeOffering":{"input":{"type":"structure","required":["ReservedNodeOfferingId"],"members":{"ReservedNodeOfferingId":{},"NodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedNodeOfferingResult","type":"structure","members":{"ReservedNode":{"shape":"S4"}}}},"RebootCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RebootClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"RejectDataShare":{"input":{"type":"structure","required":["DataShareArn"],"members":{"DataShareArn":{}}},"output":{"shape":"Sj","resultWrapper":"RejectDataShareResult"}},"ResetClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S5m"}}},"output":{"shape":"Sa5","resultWrapper":"ResetClusterParameterGroupResult"}},"ResizeCluster":{"input":{"shape":"S3u"},"output":{"resultWrapper":"ResizeClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"RestoreFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"Port":{"type":"integer"},"AvailabilityZone":{},"AllowVersionUpgrade":{"type":"boolean"},"ClusterSubnetGroupName":{},"PubliclyAccessible":{"type":"boolean"},"OwnerAccount":{},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"ClusterParameterGroupName":{},"ClusterSecurityGroups":{"shape":"S1x"},"VpcSecurityGroupIds":{"shape":"S1y"},"PreferredMaintenanceWindow":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"NodeType":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S1z"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{},"NumberOfNodes":{"type":"integer"},"AvailabilityZoneRelocation":{"type":"boolean"},"AquaConfigurationStatus":{},"DefaultIamRoleArn":{},"ReservedNodeId":{},"TargetReservedNodeOfferingId":{},"Encrypted":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreFromClusterSnapshotResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"RestoreTableFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier","SourceDatabaseName","SourceTableName","NewTableName"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{},"EnableCaseSensitiveIdentifier":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreTableFromClusterSnapshotResult","type":"structure","members":{"TableRestoreStatus":{"shape":"S91"}}}},"ResumeCluster":{"input":{"shape":"S3w"},"output":{"resultWrapper":"ResumeClusterResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"RevokeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sq"}}}},"RevokeEndpointAccess":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"Account":{},"VpcIds":{"shape":"Sz"},"Force":{"type":"boolean"}}},"output":{"shape":"S10","resultWrapper":"RevokeEndpointAccessResult"}},"RevokeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"RevokeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"RotateEncryptionKey":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RotateEncryptionKeyResult","type":"structure","members":{"Cluster":{"shape":"S22"}}}},"UpdatePartnerStatus":{"input":{"type":"structure","required":["AccountId","ClusterIdentifier","DatabaseName","PartnerName","Status"],"members":{"AccountId":{},"ClusterIdentifier":{},"DatabaseName":{},"PartnerName":{},"Status":{},"StatusMessage":{}}},"output":{"shape":"Sg","resultWrapper":"UpdatePartnerStatusResult"}}},"shapes":{"S4":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeOfferingId":{},"NodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"NodeCount":{"type":"integer"},"State":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true},"S8":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"Sb":{"type":"structure","required":["AccountId","ClusterIdentifier","DatabaseName","PartnerName"],"members":{"AccountId":{},"ClusterIdentifier":{},"DatabaseName":{},"PartnerName":{}}},"Sg":{"type":"structure","members":{"DatabaseName":{},"PartnerName":{}}},"Sj":{"type":"structure","members":{"DataShareArn":{},"ProducerArn":{},"AllowPubliclyAccessibleConsumers":{"type":"boolean"},"DataShareAssociations":{"type":"list","member":{"type":"structure","members":{"ConsumerIdentifier":{},"Status":{},"ConsumerRegion":{},"CreatedDate":{"type":"timestamp"},"StatusChangeDate":{"type":"timestamp"}}}},"ManagedBy":{}}},"Sq":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{},"Tags":{"shape":"St"}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{},"Tags":{"shape":"St"}}}},"Tags":{"shape":"St"}},"wrapper":true},"St":{"type":"list","member":{"shape":"Su","locationName":"Tag"}},"Su":{"type":"structure","members":{"Key":{},"Value":{}}},"Sz":{"type":"list","member":{"locationName":"VpcIdentifier"}},"S10":{"type":"structure","members":{"Grantor":{},"Grantee":{},"ClusterIdentifier":{},"AuthorizeTime":{"type":"timestamp"},"ClusterStatus":{},"Status":{},"AllowedAllVPCs":{"type":"boolean"},"AllowedVPCs":{"shape":"Sz"},"EndpointCount":{"type":"integer"}}},"S14":{"type":"structure","members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"ClusterVersion":{},"EngineFullVersion":{},"SnapshotType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"DBName":{},"VpcId":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"EncryptedWithHSM":{"type":"boolean"},"AccountsWithRestoreAccess":{"type":"list","member":{"locationName":"AccountWithRestoreAccess","type":"structure","members":{"AccountId":{},"AccountAlias":{}}}},"OwnerAccount":{},"TotalBackupSizeInMegaBytes":{"type":"double"},"ActualIncrementalBackupSizeInMegaBytes":{"type":"double"},"BackupProgressInMegaBytes":{"type":"double"},"CurrentBackupRateInMegaBytesPerSecond":{"type":"double"},"EstimatedSecondsToCompletion":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"SourceRegion":{},"Tags":{"shape":"St"},"RestorableNodeTypes":{"type":"list","member":{"locationName":"NodeType"}},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRemainingDays":{"type":"integer"},"SnapshotRetentionStartTime":{"type":"timestamp"}},"wrapper":true},"S1c":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{}}},"S1e":{"type":"list","member":{"locationName":"String"}},"S1g":{"type":"structure","members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"FailureCode":{},"FailureReason":{}}},"S1l":{"type":"structure","members":{"TargetNodeType":{},"TargetNumberOfNodes":{"type":"integer"},"TargetClusterType":{},"Status":{},"ImportTablesCompleted":{"type":"list","member":{}},"ImportTablesInProgress":{"type":"list","member":{}},"ImportTablesNotStarted":{"type":"list","member":{}},"AvgResizeRateInMegaBytesPerSecond":{"type":"double"},"TotalResizeDataInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ResizeType":{},"Message":{},"TargetEncryptionType":{},"DataTransferProgressPercent":{"type":"double"}}},"S1x":{"type":"list","member":{"locationName":"ClusterSecurityGroupName"}},"S1y":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1z":{"type":"list","member":{"locationName":"IamRoleArn"}},"S22":{"type":"structure","members":{"ClusterIdentifier":{},"NodeType":{},"ClusterStatus":{},"ClusterAvailabilityStatus":{},"ModifyStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"VpcEndpoints":{"type":"list","member":{"shape":"S25","locationName":"VpcEndpoint"}}}},"ClusterCreateTime":{"type":"timestamp"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ClusterSecurityGroups":{"type":"list","member":{"locationName":"ClusterSecurityGroup","type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"shape":"S2a"},"ClusterParameterGroups":{"type":"list","member":{"locationName":"ClusterParameterGroup","type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}}}}},"ClusterSubnetGroupName":{},"VpcId":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterType":{},"ClusterVersion":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"EncryptionType":{}}},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"RestoreStatus":{"type":"structure","members":{"Status":{},"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"SnapshotSizeInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}},"DataTransferProgress":{"type":"structure","members":{"Status":{},"CurrentRateInMegaBytesPerSecond":{"type":"double"},"TotalDataInMegaBytes":{"type":"long"},"DataTransferredInMegaBytes":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"}}},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"RetentionPeriod":{"type":"long"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"ClusterPublicKey":{},"ClusterNodes":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIPAddress":{},"PublicIPAddress":{}}}},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ClusterRevisionNumber":{},"Tags":{"shape":"St"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"IamRoles":{"type":"list","member":{"locationName":"ClusterIamRole","type":"structure","members":{"IamRoleArn":{},"ApplyStatus":{}}}},"PendingActions":{"type":"list","member":{}},"MaintenanceTrackName":{},"ElasticResizeNumberOfNodeOptions":{},"DeferredMaintenanceWindows":{"type":"list","member":{"locationName":"DeferredMaintenanceWindow","type":"structure","members":{"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"}}}},"SnapshotScheduleIdentifier":{},"SnapshotScheduleState":{},"ExpectedNextSnapshotScheduleTime":{"type":"timestamp"},"ExpectedNextSnapshotScheduleTimeStatus":{},"NextMaintenanceWindowStartTime":{"type":"timestamp"},"ResizeInfo":{"type":"structure","members":{"ResizeType":{},"AllowCancelResize":{"type":"boolean"}}},"AvailabilityZoneRelocationStatus":{},"ClusterNamespaceArn":{},"TotalStorageCapacityInMegaBytes":{"type":"long"},"AquaConfiguration":{"shape":"S2v"},"DefaultIamRoleArn":{},"ReservedNodeExchangeStatus":{"shape":"S2x"}},"wrapper":true},"S25":{"type":"structure","members":{"VpcEndpointId":{},"VpcId":{},"NetworkInterfaces":{"type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"NetworkInterfaceId":{},"SubnetId":{},"PrivateIpAddress":{},"AvailabilityZone":{}}}}}},"S2a":{"type":"list","member":{"locationName":"VpcSecurityGroup","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S2v":{"type":"structure","members":{"AquaStatus":{},"AquaConfigurationStatus":{}}},"S2x":{"type":"structure","members":{"ReservedNodeExchangeRequestId":{},"Status":{},"RequestTime":{"type":"timestamp"},"SourceReservedNodeId":{},"SourceReservedNodeType":{},"SourceReservedNodeCount":{"type":"integer"},"TargetReservedNodeOfferingId":{},"TargetReservedNodeType":{},"TargetReservedNodeCount":{"type":"integer"}},"wrapper":true},"S31":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"St"}},"wrapper":true},"S37":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S39":{"type":"structure","members":{"ClusterSubnetGroupName":{},"Description":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S3c"},"SubnetStatus":{}}}},"Tags":{"shape":"St"}},"wrapper":true},"S3c":{"type":"structure","members":{"Name":{},"SupportedPlatforms":{"type":"list","member":{"locationName":"SupportedPlatform","type":"structure","members":{"Name":{}},"wrapper":true}}},"wrapper":true},"S3g":{"type":"structure","members":{"ClusterIdentifier":{},"ResourceOwner":{},"SubnetGroupName":{},"EndpointStatus":{},"EndpointName":{},"EndpointCreateTime":{"type":"timestamp"},"Port":{"type":"integer"},"Address":{},"VpcSecurityGroups":{"shape":"S2a"},"VpcEndpoint":{"shape":"S25"}}},"S3i":{"type":"list","member":{"locationName":"SourceId"}},"S3j":{"type":"list","member":{"locationName":"EventCategory"}},"S3l":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{"type":"timestamp"},"SourceType":{},"SourceIdsList":{"shape":"S3i"},"EventCategoriesList":{"shape":"S3j"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"St"}},"wrapper":true},"S3o":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmClientCertificatePublicKey":{},"Tags":{"shape":"St"}},"wrapper":true},"S3r":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"Tags":{"shape":"St"}},"wrapper":true},"S3t":{"type":"structure","members":{"ResizeCluster":{"shape":"S3u"},"PauseCluster":{"shape":"S3v"},"ResumeCluster":{"shape":"S3w"}}},"S3u":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"Classic":{"type":"boolean"},"ReservedNodeId":{},"TargetReservedNodeOfferingId":{}}},"S3v":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"S3w":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"S3x":{"type":"structure","members":{"ScheduledActionName":{},"TargetAction":{"shape":"S3t"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"State":{},"NextInvocations":{"type":"list","member":{"locationName":"ScheduledActionTime","type":"timestamp"}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S42":{"type":"structure","members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"St"}},"wrapper":true},"S44":{"type":"list","member":{"locationName":"ScheduleDefinition"}},"S45":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S44"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"St"},"NextInvocations":{"type":"list","member":{"locationName":"SnapshotTime","type":"timestamp"}},"AssociatedClusterCount":{"type":"integer"},"AssociatedClusters":{"type":"list","member":{"locationName":"ClusterAssociatedToSchedule","type":"structure","members":{"ClusterIdentifier":{},"ScheduleAssociationState":{}}}}}},"S4f":{"type":"structure","members":{"UsageLimitId":{},"ClusterIdentifier":{},"FeatureType":{},"LimitType":{},"Amount":{"type":"long"},"Period":{},"BreachAction":{},"Tags":{"shape":"St"}}},"S4x":{"type":"list","member":{"locationName":"TagKey"}},"S5h":{"type":"list","member":{"locationName":"TagValue"}},"S5m":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"ApplyType":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{}}}},"S6j":{"type":"list","member":{"shape":"Sj"}},"S7k":{"type":"structure","members":{"LoggingEnabled":{"type":"boolean"},"BucketName":{},"S3KeyPrefix":{},"LastSuccessfulDeliveryTime":{"type":"timestamp"},"LastFailureTime":{"type":"timestamp"},"LastFailureMessage":{},"LogDestinationType":{},"LogExports":{"shape":"S7m"}}},"S7m":{"type":"list","member":{}},"S7t":{"type":"list","member":{"locationName":"item"}},"S8e":{"type":"list","member":{"shape":"S8f","locationName":"ReservedNodeOffering"}},"S8f":{"type":"structure","members":{"ReservedNodeOfferingId":{},"NodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true},"S91":{"type":"structure","members":{"TableRestoreRequestId":{},"Status":{},"Message":{},"RequestTime":{"type":"timestamp"},"ProgressInMegaBytes":{"type":"long"},"TotalDataInMegaBytes":{"type":"long"},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}},"wrapper":true},"Sa5":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupStatus":{}}}}}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeClusterDbRevisions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterDbRevisions"},"DescribeClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ParameterGroups"},"DescribeClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeClusterSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSecurityGroups"},"DescribeClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeClusterSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSubnetGroups"},"DescribeClusterTracks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"MaintenanceTracks"},"DescribeClusterVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterVersions"},"DescribeClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Clusters"},"DescribeDataShares":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DataShares"},"DescribeDataSharesForConsumer":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DataShares"},"DescribeDataSharesForProducer":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DataShares"},"DescribeDefaultClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"DefaultClusterParameters.Marker","result_key":"DefaultClusterParameters.Parameters"},"DescribeEndpointAccess":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EndpointAccessList"},"DescribeEndpointAuthorization":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EndpointAuthorizationList"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeHsmClientCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmClientCertificates"},"DescribeHsmConfigurations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmConfigurations"},"DescribeNodeConfigurationOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"NodeConfigurationOptionList"},"DescribeOrderableClusterOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableClusterOptions"},"DescribeReservedNodeExchangeStatus":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeExchangeStatusDetails"},"DescribeReservedNodeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"DescribeReservedNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodes"},"DescribeScheduledActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ScheduledActions"},"DescribeSnapshotCopyGrants":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SnapshotCopyGrants"},"DescribeSnapshotSchedules":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SnapshotSchedules"},"DescribeTableRestoreStatus":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TableRestoreStatusDetails"},"DescribeTags":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TaggedResources"},"DescribeUsageLimits":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UsageLimits"},"GetReservedNodeExchangeConfigurationOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeConfigurationOptionList"},"GetReservedNodeExchangeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"}}}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ClusterAvailable":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Clusters[].ClusterStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"ClusterNotFound","matcher":"error","state":"retry"}]},"ClusterDeleted":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"ClusterNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"}]},"ClusterRestored":{"operation":"DescribeClusters","maxAttempts":30,"delay":60,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Clusters[].RestoreStatus.Status","expected":"completed"},{"state":"failure","matcher":"pathAny","argument":"Clusters[].ClusterStatus","expected":"deleting"}]},"SnapshotAvailable":{"delay":15,"operation":"DescribeClusterSnapshots","maxAttempts":20,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Snapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"}]}}}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['rekognition'] = {};
	AWS.Rekognition = Service.defineService('rekognition', ['2016-06-27']);
	Object.defineProperty(apiLoader.services['rekognition'], '2016-06-27', {
	  get: function get() {
	    var model = __webpack_require__(344);
	    model.paginators = __webpack_require__(345).pagination;
	    model.waiters = __webpack_require__(346).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Rekognition;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-27","endpointPrefix":"rekognition","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Rekognition","serviceId":"Rekognition","signatureVersion":"v4","targetPrefix":"RekognitionService","uid":"rekognition-2016-06-27"},"operations":{"CompareFaces":{"input":{"type":"structure","required":["SourceImage","TargetImage"],"members":{"SourceImage":{"shape":"S2"},"TargetImage":{"shape":"S2"},"SimilarityThreshold":{"type":"float"},"QualityFilter":{}}},"output":{"type":"structure","members":{"SourceImageFace":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"}}},"FaceMatches":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"Sg"}}}},"UnmatchedFaces":{"type":"list","member":{"shape":"Sg"}},"SourceImageOrientationCorrection":{},"TargetImageOrientationCorrection":{}}}},"CreateCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"Tags":{"shape":"Sw"}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"},"CollectionArn":{},"FaceModelVersion":{}}}},"CreateDataset":{"input":{"type":"structure","required":["DatasetType","ProjectArn"],"members":{"DatasetSource":{"type":"structure","members":{"GroundTruthManifest":{"shape":"S14"},"DatasetArn":{}}},"DatasetType":{},"ProjectArn":{}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateProject":{"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{}}},"output":{"type":"structure","members":{"ProjectArn":{}}}},"CreateProjectVersion":{"input":{"type":"structure","required":["ProjectArn","VersionName","OutputConfig"],"members":{"ProjectArn":{},"VersionName":{},"OutputConfig":{"shape":"S1e"},"TrainingData":{"shape":"S1g"},"TestingData":{"shape":"S1j"},"Tags":{"shape":"Sw"},"KmsKeyId":{}}},"output":{"type":"structure","members":{"ProjectVersionArn":{}}}},"CreateStreamProcessor":{"input":{"type":"structure","required":["Input","Output","Name","Settings","RoleArn"],"members":{"Input":{"shape":"S1o"},"Output":{"shape":"S1r"},"Name":{},"Settings":{"shape":"S1w"},"RoleArn":{},"Tags":{"shape":"Sw"},"NotificationChannel":{"shape":"S22"},"KmsKeyId":{},"RegionsOfInterest":{"shape":"S24"},"DataSharingPreference":{"shape":"S28"}}},"output":{"type":"structure","members":{"StreamProcessorArn":{}}}},"DeleteCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{}}},"DeleteFaces":{"input":{"type":"structure","required":["CollectionId","FaceIds"],"members":{"CollectionId":{},"FaceIds":{"shape":"S2g"}}},"output":{"type":"structure","members":{"DeletedFaces":{"shape":"S2g"}}}},"DeleteProject":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DeleteProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn"],"members":{"ProjectVersionArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DeleteStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"FaceCount":{"type":"long"},"FaceModelVersion":{},"CollectionARN":{},"CreationTimestamp":{"type":"timestamp"}}}},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetDescription":{"type":"structure","members":{"CreationTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Status":{},"StatusMessage":{},"StatusMessageCode":{},"DatasetStats":{"type":"structure","members":{"LabeledEntries":{"type":"integer"},"TotalEntries":{"type":"integer"},"TotalLabels":{"type":"integer"},"ErrorEntries":{"type":"integer"}}}}}}}},"DescribeProjectVersions":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{},"VersionNames":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProjectVersionDescriptions":{"type":"list","member":{"type":"structure","members":{"ProjectVersionArn":{},"CreationTimestamp":{"type":"timestamp"},"MinInferenceUnits":{"type":"integer"},"Status":{},"StatusMessage":{},"BillableTrainingTimeInSeconds":{"type":"long"},"TrainingEndTimestamp":{"type":"timestamp"},"OutputConfig":{"shape":"S1e"},"TrainingDataResult":{"type":"structure","members":{"Input":{"shape":"S1g"},"Output":{"shape":"S1g"},"Validation":{"shape":"S3b"}}},"TestingDataResult":{"type":"structure","members":{"Input":{"shape":"S1j"},"Output":{"shape":"S1j"},"Validation":{"shape":"S3b"}}},"EvaluationResult":{"type":"structure","members":{"F1Score":{"type":"float"},"Summary":{"type":"structure","members":{"S3Object":{"shape":"S4"}}}}},"ManifestSummary":{"shape":"S14"},"KmsKeyId":{}}}},"NextToken":{}}}},"DescribeProjects":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ProjectNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ProjectDescriptions":{"type":"list","member":{"type":"structure","members":{"ProjectArn":{},"CreationTimestamp":{"type":"timestamp"},"Status":{},"Datasets":{"type":"list","member":{"type":"structure","members":{"CreationTimestamp":{"type":"timestamp"},"DatasetType":{},"DatasetArn":{},"Status":{},"StatusMessage":{},"StatusMessageCode":{}}}}}}},"NextToken":{}}}},"DescribeStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"StreamProcessorArn":{},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Input":{"shape":"S1o"},"Output":{"shape":"S1r"},"RoleArn":{},"Settings":{"shape":"S1w"},"NotificationChannel":{"shape":"S22"},"KmsKeyId":{},"RegionsOfInterest":{"shape":"S24"},"DataSharingPreference":{"shape":"S28"}}}},"DetectCustomLabels":{"input":{"type":"structure","required":["ProjectVersionArn","Image"],"members":{"ProjectVersionArn":{},"Image":{"shape":"S2"},"MaxResults":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"CustomLabels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Geometry":{"shape":"S3u"}}}}}}},"DetectFaces":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Attributes":{"shape":"S3w"}}},"output":{"type":"structure","members":{"FaceDetails":{"type":"list","member":{"shape":"S40"}},"OrientationCorrection":{}}}},"DetectLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MaxLabels":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"shape":"S4d"}},"OrientationCorrection":{},"LabelModelVersion":{}}}},"DetectModerationLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MinConfidence":{"type":"float"},"HumanLoopConfig":{"type":"structure","required":["HumanLoopName","FlowDefinitionArn"],"members":{"HumanLoopName":{},"FlowDefinitionArn":{},"DataAttributes":{"type":"structure","members":{"ContentClassifiers":{"type":"list","member":{}}}}}}}},"output":{"type":"structure","members":{"ModerationLabels":{"type":"list","member":{"shape":"S4r"}},"ModerationModelVersion":{},"HumanLoopActivationOutput":{"type":"structure","members":{"HumanLoopArn":{},"HumanLoopActivationReasons":{"type":"list","member":{}},"HumanLoopActivationConditionsEvaluationResults":{"jsonvalue":true}}}}}},"DetectProtectiveEquipment":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"SummarizationAttributes":{"type":"structure","required":["MinConfidence","RequiredEquipmentTypes"],"members":{"MinConfidence":{"type":"float"},"RequiredEquipmentTypes":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"ProtectiveEquipmentModelVersion":{},"Persons":{"type":"list","member":{"type":"structure","members":{"BodyParts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"EquipmentDetections":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"},"Type":{},"CoversBodyPart":{"type":"structure","members":{"Confidence":{"type":"float"},"Value":{"type":"boolean"}}}}}}}}},"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"},"Id":{"type":"integer"}}}},"Summary":{"type":"structure","members":{"PersonsWithRequiredEquipment":{"shape":"S5b"},"PersonsWithoutRequiredEquipment":{"shape":"S5b"},"PersonsIndeterminate":{"shape":"S5b"}}}}}},"DetectText":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Filters":{"type":"structure","members":{"WordFilter":{"shape":"S5e"},"RegionsOfInterest":{"shape":"S24"}}}}},"output":{"type":"structure","members":{"TextDetections":{"type":"list","member":{"shape":"S5j"}},"TextModelVersion":{}}}},"DistributeDatasetEntries":{"input":{"type":"structure","required":["Datasets"],"members":{"Datasets":{"type":"list","member":{"type":"structure","required":["Arn"],"members":{"Arn":{}}}}}},"output":{"type":"structure","members":{}}},"GetCelebrityInfo":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Urls":{"shape":"S5s"},"Name":{},"KnownGender":{"shape":"S5u"}}}},"GetCelebrityRecognition":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S63"},"NextToken":{},"Celebrities":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Celebrity":{"type":"structure","members":{"Urls":{"shape":"S5s"},"Name":{},"Id":{},"Confidence":{"type":"float"},"BoundingBox":{"shape":"Sc"},"Face":{"shape":"S40"},"KnownGender":{"shape":"S5u"}}}}}}}}},"GetContentModeration":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S63"},"ModerationLabels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"ModerationLabel":{"shape":"S4r"}}}},"NextToken":{},"ModerationModelVersion":{}}}},"GetFaceDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S63"},"NextToken":{},"Faces":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Face":{"shape":"S40"}}}}}}},"GetFaceSearch":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"NextToken":{},"VideoMetadata":{"shape":"S63"},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S6n"},"FaceMatches":{"shape":"S6p"}}}}}}},"GetLabelDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S63"},"NextToken":{},"Labels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Label":{"shape":"S4d"}}}},"LabelModelVersion":{}}}},"GetPersonTracking":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S63"},"NextToken":{},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S6n"}}}}}}},"GetSegmentDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"type":"list","member":{"shape":"S63"}},"AudioMetadata":{"type":"list","member":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"SampleRate":{"type":"long"},"NumberOfChannels":{"type":"long"}}}},"NextToken":{},"Segments":{"type":"list","member":{"type":"structure","members":{"Type":{},"StartTimestampMillis":{"type":"long"},"EndTimestampMillis":{"type":"long"},"DurationMillis":{"type":"long"},"StartTimecodeSMPTE":{},"EndTimecodeSMPTE":{},"DurationSMPTE":{},"TechnicalCueSegment":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}},"ShotSegment":{"type":"structure","members":{"Index":{"type":"long"},"Confidence":{"type":"float"}}},"StartFrameNumber":{"type":"long"},"EndFrameNumber":{"type":"long"},"DurationFrames":{"type":"long"}}}},"SelectedSegmentTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ModelVersion":{}}}}}}},"GetTextDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S63"},"TextDetections":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"TextDetection":{"shape":"S5j"}}}},"NextToken":{},"TextModelVersion":{}}}},"IndexFaces":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"ExternalImageId":{},"DetectionAttributes":{"shape":"S3w"},"MaxFaces":{"type":"integer"},"QualityFilter":{}}},"output":{"type":"structure","members":{"FaceRecords":{"type":"list","member":{"type":"structure","members":{"Face":{"shape":"S6r"},"FaceDetail":{"shape":"S40"}}}},"OrientationCorrection":{},"FaceModelVersion":{},"UnindexedFaces":{"type":"list","member":{"type":"structure","members":{"Reasons":{"type":"list","member":{}},"FaceDetail":{"shape":"S40"}}}}}}},"ListCollections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CollectionIds":{"type":"list","member":{}},"NextToken":{},"FaceModelVersions":{"type":"list","member":{}}}}},"ListDatasetEntries":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{},"ContainsLabels":{"type":"list","member":{}},"Labeled":{"type":"boolean"},"SourceRefContains":{},"HasErrors":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetEntries":{"type":"list","member":{}},"NextToken":{}}}},"ListDatasetLabels":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetLabelDescriptions":{"type":"list","member":{"type":"structure","members":{"LabelName":{},"LabelStats":{"type":"structure","members":{"EntryCount":{"type":"integer"},"BoundingBoxCount":{"type":"integer"}}}}}},"NextToken":{}}}},"ListFaces":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Faces":{"type":"list","member":{"shape":"S6r"}},"NextToken":{},"FaceModelVersion":{}}}},"ListStreamProcessors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"StreamProcessors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sw"}}}},"RecognizeCelebrities":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"CelebrityFaces":{"type":"list","member":{"type":"structure","members":{"Urls":{"shape":"S5s"},"Name":{},"Id":{},"Face":{"shape":"Sg"},"MatchConfidence":{"type":"float"},"KnownGender":{"shape":"S5u"}}}},"UnrecognizedFaces":{"type":"list","member":{"shape":"Sg"}},"OrientationCorrection":{}}}},"SearchFaces":{"input":{"type":"structure","required":["CollectionId","FaceId"],"members":{"CollectionId":{},"FaceId":{},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceId":{},"FaceMatches":{"shape":"S6p"},"FaceModelVersion":{}}}},"SearchFacesByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"},"QualityFilter":{}}},"output":{"type":"structure","members":{"SearchedFaceBoundingBox":{"shape":"Sc"},"SearchedFaceConfidence":{"type":"float"},"FaceMatches":{"shape":"S6p"},"FaceModelVersion":{}}}},"StartCelebrityRecognition":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S95"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartContentModeration":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S93"},"MinConfidence":{"type":"float"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S95"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S95"},"FaceAttributes":{},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceSearch":{"input":{"type":"structure","required":["Video","CollectionId"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"FaceMatchThreshold":{"type":"float"},"CollectionId":{},"NotificationChannel":{"shape":"S95"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartLabelDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"MinConfidence":{"type":"float"},"NotificationChannel":{"shape":"S95"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartPersonTracking":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S95"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn","MinInferenceUnits"],"members":{"ProjectVersionArn":{},"MinInferenceUnits":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{}}}},"StartSegmentDetection":{"input":{"type":"structure","required":["Video","SegmentTypes"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S95"},"JobTag":{},"Filters":{"type":"structure","members":{"TechnicalCueFilter":{"type":"structure","members":{"MinSegmentConfidence":{"type":"float"},"BlackFrame":{"type":"structure","members":{"MaxPixelThreshold":{"type":"float"},"MinCoveragePercentage":{"type":"float"}}}}},"ShotFilter":{"type":"structure","members":{"MinSegmentConfidence":{"type":"float"}}}}},"SegmentTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"StartSelector":{"type":"structure","members":{"KVSStreamStartSelector":{"type":"structure","members":{"ProducerTimestamp":{"type":"long"},"FragmentNumber":{}}}}},"StopSelector":{"type":"structure","members":{"MaxDurationInSeconds":{"type":"long"}}}}},"output":{"type":"structure","members":{"SessionId":{}}}},"StartTextDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S93"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S95"},"JobTag":{},"Filters":{"type":"structure","members":{"WordFilter":{"shape":"S5e"},"RegionsOfInterest":{"shape":"S24"}}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StopProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn"],"members":{"ProjectVersionArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"StopStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDatasetEntries":{"input":{"type":"structure","required":["DatasetArn","Changes"],"members":{"DatasetArn":{},"Changes":{"type":"structure","required":["GroundTruth"],"members":{"GroundTruth":{"type":"blob"}}}}},"output":{"type":"structure","members":{}}},"UpdateStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"SettingsForUpdate":{"type":"structure","members":{"ConnectedHomeForUpdate":{"type":"structure","members":{"Labels":{"shape":"S1z"},"MinConfidence":{"type":"float"}}}}},"RegionsOfInterestForUpdate":{"shape":"S24"},"DataSharingPreferenceForUpdate":{"shape":"S28"},"ParametersToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"S4"}}},"S4":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"Sc":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Sg":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"},"Landmarks":{"shape":"Sh"},"Pose":{"shape":"Sk"},"Quality":{"shape":"Sm"},"Emotions":{"shape":"Sn"},"Smile":{"shape":"Sq"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Type":{},"X":{"type":"float"},"Y":{"type":"float"}}}},"Sk":{"type":"structure","members":{"Roll":{"type":"float"},"Yaw":{"type":"float"},"Pitch":{"type":"float"}}},"Sm":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"}}},"Sn":{"type":"list","member":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}}},"Sq":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sw":{"type":"map","key":{},"value":{}},"S14":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S1e":{"type":"structure","members":{"S3Bucket":{},"S3KeyPrefix":{}}},"S1g":{"type":"structure","members":{"Assets":{"shape":"S1h"}}},"S1h":{"type":"list","member":{"type":"structure","members":{"GroundTruthManifest":{"shape":"S14"}}}},"S1j":{"type":"structure","members":{"Assets":{"shape":"S1h"},"AutoCreate":{"type":"boolean"}}},"S1o":{"type":"structure","members":{"KinesisVideoStream":{"type":"structure","members":{"Arn":{}}}}},"S1r":{"type":"structure","members":{"KinesisDataStream":{"type":"structure","members":{"Arn":{}}},"S3Destination":{"type":"structure","members":{"Bucket":{},"KeyPrefix":{}}}}},"S1w":{"type":"structure","members":{"FaceSearch":{"type":"structure","members":{"CollectionId":{},"FaceMatchThreshold":{"type":"float"}}},"ConnectedHome":{"type":"structure","required":["Labels"],"members":{"Labels":{"shape":"S1z"},"MinConfidence":{"type":"float"}}}}},"S1z":{"type":"list","member":{}},"S22":{"type":"structure","required":["SNSTopicArn"],"members":{"SNSTopicArn":{}}},"S24":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Polygon":{"shape":"S26"}}}},"S26":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}},"S28":{"type":"structure","required":["OptIn"],"members":{"OptIn":{"type":"boolean"}}},"S2g":{"type":"list","member":{}},"S3b":{"type":"structure","members":{"Assets":{"shape":"S1h"}}},"S3u":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Polygon":{"shape":"S26"}}},"S3w":{"type":"list","member":{}},"S40":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"AgeRange":{"type":"structure","members":{"Low":{"type":"integer"},"High":{"type":"integer"}}},"Smile":{"shape":"Sq"},"Eyeglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sunglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Gender":{"type":"structure","members":{"Value":{},"Confidence":{"type":"float"}}},"Beard":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Mustache":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyesOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"MouthOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Emotions":{"shape":"Sn"},"Landmarks":{"shape":"Sh"},"Pose":{"shape":"Sk"},"Quality":{"shape":"Sm"},"Confidence":{"type":"float"}}},"S4d":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Instances":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sc"},"Confidence":{"type":"float"}}}},"Parents":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}},"S4r":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{},"ParentName":{}}},"S5b":{"type":"list","member":{"type":"integer"}},"S5e":{"type":"structure","members":{"MinConfidence":{"type":"float"},"MinBoundingBoxHeight":{"type":"float"},"MinBoundingBoxWidth":{"type":"float"}}},"S5j":{"type":"structure","members":{"DetectedText":{},"Type":{},"Id":{"type":"integer"},"ParentId":{"type":"integer"},"Confidence":{"type":"float"},"Geometry":{"shape":"S3u"}}},"S5s":{"type":"list","member":{}},"S5u":{"type":"structure","members":{"Type":{}}},"S63":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"Format":{},"FrameRate":{"type":"float"},"FrameHeight":{"type":"long"},"FrameWidth":{"type":"long"},"ColorRange":{}}},"S6n":{"type":"structure","members":{"Index":{"type":"long"},"BoundingBox":{"shape":"Sc"},"Face":{"shape":"S40"}}},"S6p":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"S6r"}}}},"S6r":{"type":"structure","members":{"FaceId":{},"BoundingBox":{"shape":"Sc"},"ImageId":{},"ExternalImageId":{},"Confidence":{"type":"float"},"IndexFacesModelVersion":{}}},"S93":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S95":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}}}}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeProjectVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectVersionDescriptions"},"DescribeProjects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectDescriptions"},"GetCelebrityRecognition":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetContentModeration":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceSearch":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetLabelDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPersonTracking":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetSegmentDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTextDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CollectionIds"},"ListDatasetEntries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetEntries"},"ListDatasetLabels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetLabelDescriptions"},"ListFaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Faces"},"ListStreamProcessors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ProjectVersionTrainingCompleted":{"description":"Wait until the ProjectVersion training completes.","operation":"DescribeProjectVersions","delay":120,"maxAttempts":360,"acceptors":[{"state":"success","matcher":"pathAll","argument":"ProjectVersionDescriptions[].Status","expected":"TRAINING_COMPLETED"},{"state":"failure","matcher":"pathAny","argument":"ProjectVersionDescriptions[].Status","expected":"TRAINING_FAILED"}]},"ProjectVersionRunning":{"description":"Wait until the ProjectVersion is running.","delay":30,"maxAttempts":40,"operation":"DescribeProjectVersions","acceptors":[{"state":"success","matcher":"pathAll","argument":"ProjectVersionDescriptions[].Status","expected":"RUNNING"},{"state":"failure","matcher":"pathAny","argument":"ProjectVersionDescriptions[].Status","expected":"FAILED"}]}}}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['resourcegroupstaggingapi'] = {};
	AWS.ResourceGroupsTaggingAPI = Service.defineService('resourcegroupstaggingapi', ['2017-01-26']);
	Object.defineProperty(apiLoader.services['resourcegroupstaggingapi'], '2017-01-26', {
	  get: function get() {
	    var model = __webpack_require__(348);
	    model.paginators = __webpack_require__(349).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ResourceGroupsTaggingAPI;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-26","endpointPrefix":"tagging","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Resource Groups Tagging API","serviceId":"Resource Groups Tagging API","signatureVersion":"v4","targetPrefix":"ResourceGroupsTaggingAPI_20170126","uid":"resourcegroupstaggingapi-2017-01-26"},"operations":{"DescribeReportCreation":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Status":{},"S3Location":{},"ErrorMessage":{}}}},"GetComplianceSummary":{"input":{"type":"structure","members":{"TargetIdFilters":{"type":"list","member":{}},"RegionFilters":{"type":"list","member":{}},"ResourceTypeFilters":{"shape":"Sb"},"TagKeyFilters":{"type":"list","member":{}},"GroupBy":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"SummaryList":{"type":"list","member":{"type":"structure","members":{"LastUpdated":{},"TargetId":{},"TargetIdType":{},"Region":{},"ResourceType":{},"NonCompliantResources":{"type":"long"}}}},"PaginationToken":{}}}},"GetResources":{"input":{"type":"structure","members":{"PaginationToken":{},"TagFilters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ResourcesPerPage":{"type":"integer"},"TagsPerPage":{"type":"integer"},"ResourceTypeFilters":{"shape":"Sb"},"IncludeComplianceDetails":{"type":"boolean"},"ExcludeCompliantResources":{"type":"boolean"},"ResourceARNList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"PaginationToken":{},"ResourceTagMappingList":{"type":"list","member":{"type":"structure","members":{"ResourceARN":{},"Tags":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"ComplianceDetails":{"type":"structure","members":{"NoncompliantKeys":{"shape":"S16"},"KeysWithNoncompliantValues":{"shape":"S16"},"ComplianceStatus":{"type":"boolean"}}}}}}}}},"GetTagKeys":{"input":{"type":"structure","members":{"PaginationToken":{}}},"output":{"type":"structure","members":{"PaginationToken":{},"TagKeys":{"shape":"S16"}}}},"GetTagValues":{"input":{"type":"structure","required":["Key"],"members":{"PaginationToken":{},"Key":{}}},"output":{"type":"structure","members":{"PaginationToken":{},"TagValues":{"type":"list","member":{}}}}},"StartReportCreation":{"input":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{}}},"output":{"type":"structure","members":{}}},"TagResources":{"input":{"type":"structure","required":["ResourceARNList","Tags"],"members":{"ResourceARNList":{"shape":"S1h"},"Tags":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"FailedResourcesMap":{"shape":"S1k"}}}},"UntagResources":{"input":{"type":"structure","required":["ResourceARNList","TagKeys"],"members":{"ResourceARNList":{"shape":"S1h"},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FailedResourcesMap":{"shape":"S1k"}}}}},"shapes":{"Sb":{"type":"list","member":{}},"S16":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1k":{"type":"map","key":{},"value":{"type":"structure","members":{"StatusCode":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}}}}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetComplianceSummary":{"input_token":"PaginationToken","limit_key":"MaxResults","output_token":"PaginationToken","result_key":"SummaryList"},"GetResources":{"input_token":"PaginationToken","limit_key":"ResourcesPerPage","output_token":"PaginationToken","result_key":"ResourceTagMappingList"},"GetTagKeys":{"input_token":"PaginationToken","output_token":"PaginationToken","result_key":"TagKeys"},"GetTagValues":{"input_token":"PaginationToken","output_token":"PaginationToken","result_key":"TagValues"}}}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['route53'] = {};
	AWS.Route53 = Service.defineService('route53', ['2013-04-01']);
	__webpack_require__(351);
	Object.defineProperty(apiLoader.services['route53'], '2013-04-01', {
	  get: function get() {
	    var model = __webpack_require__(352);
	    model.paginators = __webpack_require__(353).pagination;
	    model.waiters = __webpack_require__(354).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Route53;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.Route53.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.on('build', this.sanitizeUrl);
	  },

	  /**
	   * @api private
	   */
	  sanitizeUrl: function sanitizeUrl(request) {
	    var path = request.httpRequest.path;
	    request.httpRequest.path = path.replace(/\/%2F\w+%2F/, '/');
	  },

	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (error.code === 'PriorRequestNotComplete' &&
	        error.statusCode === 400) {
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error);
	    }
	  }
	});


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-04-01","endpointPrefix":"route53","globalEndpoint":"route53.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Route 53","serviceFullName":"Amazon Route 53","serviceId":"Route 53","signatureVersion":"v4","uid":"route53-2013-04-01"},"operations":{"ActivateKeySigningKey":{"http":{"requestUri":"/2013-04-01/keysigningkey/{HostedZoneId}/{Name}/activate"},"input":{"type":"structure","required":["HostedZoneId","Name"],"members":{"HostedZoneId":{"location":"uri","locationName":"HostedZoneId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"AssociateVPCWithHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/associatevpc"},"input":{"locationName":"AssociateVPCWithHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"ChangeResourceRecordSets":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/rrset/"},"input":{"locationName":"ChangeResourceRecordSetsRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","ChangeBatch"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"ChangeBatch":{"type":"structure","required":["Changes"],"members":{"Comment":{},"Changes":{"type":"list","member":{"locationName":"Change","type":"structure","required":["Action","ResourceRecordSet"],"members":{"Action":{},"ResourceRecordSet":{"shape":"Sk"}}}}}}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"ChangeTagsForResource":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"locationName":"ChangeTagsForResourceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"AddTags":{"shape":"S18"},"RemoveTagKeys":{"type":"list","member":{"locationName":"Key"}}}},"output":{"type":"structure","members":{}}},"CreateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck","responseCode":201},"input":{"locationName":"CreateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HealthCheckConfig"],"members":{"CallerReference":{},"HealthCheckConfig":{"shape":"S1g"}}},"output":{"type":"structure","required":["HealthCheck","Location"],"members":{"HealthCheck":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"}}}},"CreateHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone","responseCode":201},"input":{"locationName":"CreateHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"VPC":{"shape":"Sa"},"CallerReference":{},"HostedZoneConfig":{"shape":"S2l"},"DelegationSetId":{}}},"output":{"type":"structure","required":["HostedZone","ChangeInfo","DelegationSet","Location"],"members":{"HostedZone":{"shape":"S2o"},"ChangeInfo":{"shape":"S5"},"DelegationSet":{"shape":"S2q"},"VPC":{"shape":"Sa"},"Location":{"location":"header","locationName":"Location"}}}},"CreateKeySigningKey":{"http":{"requestUri":"/2013-04-01/keysigningkey","responseCode":201},"input":{"locationName":"CreateKeySigningKeyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HostedZoneId","KeyManagementServiceArn","Name","Status"],"members":{"CallerReference":{},"HostedZoneId":{},"KeyManagementServiceArn":{},"Name":{},"Status":{}}},"output":{"type":"structure","required":["ChangeInfo","KeySigningKey","Location"],"members":{"ChangeInfo":{"shape":"S5"},"KeySigningKey":{"shape":"S2w"},"Location":{"location":"header","locationName":"Location"}}}},"CreateQueryLoggingConfig":{"http":{"requestUri":"/2013-04-01/queryloggingconfig","responseCode":201},"input":{"locationName":"CreateQueryLoggingConfigRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"output":{"type":"structure","required":["QueryLoggingConfig","Location"],"members":{"QueryLoggingConfig":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"}}}},"CreateReusableDelegationSet":{"http":{"requestUri":"/2013-04-01/delegationset","responseCode":201},"input":{"locationName":"CreateReusableDelegationSetRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"HostedZoneId":{}}},"output":{"type":"structure","required":["DelegationSet","Location"],"members":{"DelegationSet":{"shape":"S2q"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicy":{"http":{"requestUri":"/2013-04-01/trafficpolicy","responseCode":201},"input":{"locationName":"CreateTrafficPolicyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","Document"],"members":{"Name":{},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S3c"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance","responseCode":201},"input":{"locationName":"CreateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","Name","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance","Location"],"members":{"TrafficPolicyInstance":{"shape":"S3h"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyVersion":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}","responseCode":201},"input":{"locationName":"CreateTrafficPolicyVersionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Document"],"members":{"Id":{"location":"uri","locationName":"Id"},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S3c"},"Location":{"location":"header","locationName":"Location"}}}},"CreateVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"locationName":"CreateVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"}}},"output":{"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{},"VPC":{"shape":"Sa"}}}},"DeactivateKeySigningKey":{"http":{"requestUri":"/2013-04-01/keysigningkey/{HostedZoneId}/{Name}/deactivate"},"input":{"type":"structure","required":["HostedZoneId","Name"],"members":{"HostedZoneId":{"location":"uri","locationName":"HostedZoneId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DeleteHealthCheck":{"http":{"method":"DELETE","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","members":{}}},"DeleteHostedZone":{"http":{"method":"DELETE","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DeleteKeySigningKey":{"http":{"method":"DELETE","requestUri":"/2013-04-01/keysigningkey/{HostedZoneId}/{Name}"},"input":{"type":"structure","required":["HostedZoneId","Name"],"members":{"HostedZoneId":{"location":"uri","locationName":"HostedZoneId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DeleteQueryLoggingConfig":{"http":{"method":"DELETE","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteReusableDelegationSet":{"http":{"method":"DELETE","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicy":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicyInstance":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"},"input":{"locationName":"DeleteVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"DisableHostedZoneDNSSEC":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disable-dnssec"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DisassociateVPCFromHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disassociatevpc"},"input":{"locationName":"DisassociateVPCFromHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"EnableHostedZoneDNSSEC":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/enable-dnssec"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"GetAccountLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/accountlimit/{Type}"},"input":{"type":"structure","required":["Type"],"members":{"Type":{"location":"uri","locationName":"Type"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetChange":{"http":{"method":"GET","requestUri":"/2013-04-01/change/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"GetCheckerIpRanges":{"http":{"method":"GET","requestUri":"/2013-04-01/checkeripranges"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["CheckerIpRanges"],"members":{"CheckerIpRanges":{"type":"list","member":{}}}}},"GetDNSSEC":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/dnssec"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Status","KeySigningKeys"],"members":{"Status":{"type":"structure","members":{"ServeSignature":{},"StatusMessage":{}}},"KeySigningKeys":{"type":"list","member":{"shape":"S2w"}}}}},"GetGeoLocation":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocation"},"input":{"type":"structure","members":{"ContinentCode":{"location":"querystring","locationName":"continentcode"},"CountryCode":{"location":"querystring","locationName":"countrycode"},"SubdivisionCode":{"location":"querystring","locationName":"subdivisioncode"}}},"output":{"type":"structure","required":["GeoLocationDetails"],"members":{"GeoLocationDetails":{"shape":"S4w"}}}},"GetHealthCheck":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S23"}}}},"GetHealthCheckCount":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheckcount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HealthCheckCount"],"members":{"HealthCheckCount":{"type":"long"}}}},"GetHealthCheckLastFailureReason":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S57"}}}},"GetHealthCheckStatus":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/status"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S57"}}}},"GetHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2o"},"DelegationSet":{"shape":"S2q"},"VPCs":{"shape":"S5f"}}}},"GetHostedZoneCount":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HostedZoneCount"],"members":{"HostedZoneCount":{"type":"long"}}}},"GetHostedZoneLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonelimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","HostedZoneId"],"members":{"Type":{"location":"uri","locationName":"Type"},"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetQueryLoggingConfig":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["QueryLoggingConfig"],"members":{"QueryLoggingConfig":{"shape":"S33"}}}},"GetReusableDelegationSet":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["DelegationSet"],"members":{"DelegationSet":{"shape":"S2q"}}}},"GetReusableDelegationSetLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","DelegationSetId"],"members":{"Type":{"location":"uri","locationName":"Type"},"DelegationSetId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetTrafficPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S3c"}}}},"GetTrafficPolicyInstance":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S3h"}}}},"GetTrafficPolicyInstanceCount":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstancecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TrafficPolicyInstanceCount"],"members":{"TrafficPolicyInstanceCount":{"type":"integer"}}}},"ListGeoLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocations"},"input":{"type":"structure","members":{"StartContinentCode":{"location":"querystring","locationName":"startcontinentcode"},"StartCountryCode":{"location":"querystring","locationName":"startcountrycode"},"StartSubdivisionCode":{"location":"querystring","locationName":"startsubdivisioncode"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["GeoLocationDetailsList","IsTruncated","MaxItems"],"members":{"GeoLocationDetailsList":{"type":"list","member":{"shape":"S4w","locationName":"GeoLocationDetails"}},"IsTruncated":{"type":"boolean"},"NextContinentCode":{},"NextCountryCode":{},"NextSubdivisionCode":{},"MaxItems":{}}}},"ListHealthChecks":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HealthChecks","Marker","IsTruncated","MaxItems"],"members":{"HealthChecks":{"type":"list","member":{"shape":"S23","locationName":"HealthCheck"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZones":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"DelegationSetId":{"location":"querystring","locationName":"delegationsetid"}}},"output":{"type":"structure","required":["HostedZones","Marker","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S6d"},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZonesByName":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyname"},"input":{"type":"structure","members":{"DNSName":{"location":"querystring","locationName":"dnsname"},"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HostedZones","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S6d"},"DNSName":{},"HostedZoneId":{},"IsTruncated":{"type":"boolean"},"NextDNSName":{},"NextHostedZoneId":{},"MaxItems":{}}}},"ListHostedZonesByVPC":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyvpc"},"input":{"type":"structure","required":["VPCId","VPCRegion"],"members":{"VPCId":{"location":"querystring","locationName":"vpcid"},"VPCRegion":{"location":"querystring","locationName":"vpcregion"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"NextToken":{"location":"querystring","locationName":"nexttoken"}}},"output":{"type":"structure","required":["HostedZoneSummaries","MaxItems"],"members":{"HostedZoneSummaries":{"type":"list","member":{"locationName":"HostedZoneSummary","type":"structure","required":["HostedZoneId","Name","Owner"],"members":{"HostedZoneId":{},"Name":{},"Owner":{"type":"structure","members":{"OwningAccount":{},"OwningService":{}}}}}},"MaxItems":{},"NextToken":{}}}},"ListQueryLoggingConfigs":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig"},"input":{"type":"structure","members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["QueryLoggingConfigs"],"members":{"QueryLoggingConfigs":{"type":"list","member":{"shape":"S33","locationName":"QueryLoggingConfig"}},"NextToken":{}}}},"ListResourceRecordSets":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/rrset"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"StartRecordName":{"location":"querystring","locationName":"name"},"StartRecordType":{"location":"querystring","locationName":"type"},"StartRecordIdentifier":{"location":"querystring","locationName":"identifier"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["ResourceRecordSets","IsTruncated","MaxItems"],"members":{"ResourceRecordSets":{"type":"list","member":{"shape":"Sk","locationName":"ResourceRecordSet"}},"IsTruncated":{"type":"boolean"},"NextRecordName":{},"NextRecordType":{},"NextRecordIdentifier":{},"MaxItems":{}}}},"ListReusableDelegationSets":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["DelegationSets","Marker","IsTruncated","MaxItems"],"members":{"DelegationSets":{"type":"list","member":{"shape":"S2q","locationName":"DelegationSet"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}},"output":{"type":"structure","required":["ResourceTagSet"],"members":{"ResourceTagSet":{"shape":"S70"}}}},"ListTagsForResources":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}"},"input":{"locationName":"ListTagsForResourcesRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceIds"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceIds":{"type":"list","member":{"locationName":"ResourceId"}}}},"output":{"type":"structure","required":["ResourceTagSets"],"members":{"ResourceTagSets":{"type":"list","member":{"shape":"S70","locationName":"ResourceTagSet"}}}}},"ListTrafficPolicies":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies"},"input":{"type":"structure","members":{"TrafficPolicyIdMarker":{"location":"querystring","locationName":"trafficpolicyid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicySummaries","IsTruncated","TrafficPolicyIdMarker","MaxItems"],"members":{"TrafficPolicySummaries":{"type":"list","member":{"locationName":"TrafficPolicySummary","type":"structure","required":["Id","Name","Type","LatestVersion","TrafficPolicyCount"],"members":{"Id":{},"Name":{},"Type":{},"LatestVersion":{"type":"integer"},"TrafficPolicyCount":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"TrafficPolicyIdMarker":{},"MaxItems":{}}}},"ListTrafficPolicyInstances":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances"},"input":{"type":"structure","members":{"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S7b"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/hostedzone"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"querystring","locationName":"id"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S7b"},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/trafficpolicy"},"input":{"type":"structure","required":["TrafficPolicyId","TrafficPolicyVersion"],"members":{"TrafficPolicyId":{"location":"querystring","locationName":"id"},"TrafficPolicyVersion":{"location":"querystring","locationName":"version","type":"integer"},"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S7b"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyVersions":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies/{Id}/versions"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TrafficPolicyVersionMarker":{"location":"querystring","locationName":"trafficpolicyversion"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicies","IsTruncated","TrafficPolicyVersionMarker","MaxItems"],"members":{"TrafficPolicies":{"type":"list","member":{"shape":"S3c","locationName":"TrafficPolicy"}},"IsTruncated":{"type":"boolean"},"TrafficPolicyVersionMarker":{},"MaxItems":{}}}},"ListVPCAssociationAuthorizations":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["HostedZoneId","VPCs"],"members":{"HostedZoneId":{},"NextToken":{},"VPCs":{"shape":"S5f"}}}},"TestDNSAnswer":{"http":{"method":"GET","requestUri":"/2013-04-01/testdnsanswer"},"input":{"type":"structure","required":["HostedZoneId","RecordName","RecordType"],"members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"RecordName":{"location":"querystring","locationName":"recordname"},"RecordType":{"location":"querystring","locationName":"recordtype"},"ResolverIP":{"location":"querystring","locationName":"resolverip"},"EDNS0ClientSubnetIP":{"location":"querystring","locationName":"edns0clientsubnetip"},"EDNS0ClientSubnetMask":{"location":"querystring","locationName":"edns0clientsubnetmask"}}},"output":{"type":"structure","required":["Nameserver","RecordName","RecordType","RecordData","ResponseCode","Protocol"],"members":{"Nameserver":{},"RecordName":{},"RecordType":{},"RecordData":{"type":"list","member":{"locationName":"RecordDataEntry"}},"ResponseCode":{},"Protocol":{}}}},"UpdateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"locationName":"UpdateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"},"HealthCheckVersion":{"type":"long"},"IPAddress":{},"Port":{"type":"integer"},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"FailureThreshold":{"type":"integer"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1t"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1v"},"AlarmIdentifier":{"shape":"S1x"},"InsufficientDataHealthStatus":{},"ResetElements":{"type":"list","member":{"locationName":"ResettableElementName"}}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S23"}}}},"UpdateHostedZoneComment":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"locationName":"UpdateHostedZoneCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Comment":{}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2o"}}}},"UpdateTrafficPolicyComment":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"locationName":"UpdateTrafficPolicyCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Version","Comment"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S3c"}}}},"UpdateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"locationName":"UpdateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"Id":{"location":"uri","locationName":"Id"},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S3h"}}}}},"shapes":{"S5":{"type":"structure","required":["Id","Status","SubmittedAt"],"members":{"Id":{},"Status":{},"SubmittedAt":{"type":"timestamp"},"Comment":{}}},"Sa":{"type":"structure","members":{"VPCRegion":{},"VPCId":{}}},"Sk":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"SetIdentifier":{},"Weight":{"type":"long"},"Region":{},"GeoLocation":{"type":"structure","members":{"ContinentCode":{},"CountryCode":{},"SubdivisionCode":{}}},"Failover":{},"MultiValueAnswer":{"type":"boolean"},"TTL":{"type":"long"},"ResourceRecords":{"type":"list","member":{"locationName":"ResourceRecord","type":"structure","required":["Value"],"members":{"Value":{}}}},"AliasTarget":{"type":"structure","required":["HostedZoneId","DNSName","EvaluateTargetHealth"],"members":{"HostedZoneId":{},"DNSName":{},"EvaluateTargetHealth":{"type":"boolean"}}},"HealthCheckId":{},"TrafficPolicyInstanceId":{}}},"S18":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S1g":{"type":"structure","required":["Type"],"members":{"IPAddress":{},"Port":{"type":"integer"},"Type":{},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"RequestInterval":{"type":"integer"},"FailureThreshold":{"type":"integer"},"MeasureLatency":{"type":"boolean"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1t"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1v"},"AlarmIdentifier":{"shape":"S1x"},"InsufficientDataHealthStatus":{},"RoutingControlArn":{}}},"S1t":{"type":"list","member":{"locationName":"ChildHealthCheck"}},"S1v":{"type":"list","member":{"locationName":"Region"}},"S1x":{"type":"structure","required":["Region","Name"],"members":{"Region":{},"Name":{}}},"S23":{"type":"structure","required":["Id","CallerReference","HealthCheckConfig","HealthCheckVersion"],"members":{"Id":{},"CallerReference":{},"LinkedService":{"shape":"S24"},"HealthCheckConfig":{"shape":"S1g"},"HealthCheckVersion":{"type":"long"},"CloudWatchAlarmConfiguration":{"type":"structure","required":["EvaluationPeriods","Threshold","ComparisonOperator","Period","MetricName","Namespace","Statistic"],"members":{"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"Period":{"type":"integer"},"MetricName":{},"Namespace":{},"Statistic":{},"Dimensions":{"type":"list","member":{"locationName":"Dimension","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}}},"S24":{"type":"structure","members":{"ServicePrincipal":{},"Description":{}}},"S2l":{"type":"structure","members":{"Comment":{},"PrivateZone":{"type":"boolean"}}},"S2o":{"type":"structure","required":["Id","Name","CallerReference"],"members":{"Id":{},"Name":{},"CallerReference":{},"Config":{"shape":"S2l"},"ResourceRecordSetCount":{"type":"long"},"LinkedService":{"shape":"S24"}}},"S2q":{"type":"structure","required":["NameServers"],"members":{"Id":{},"CallerReference":{},"NameServers":{"type":"list","member":{"locationName":"NameServer"}}}},"S2w":{"type":"structure","members":{"Name":{},"KmsArn":{},"Flag":{"type":"integer"},"SigningAlgorithmMnemonic":{},"SigningAlgorithmType":{"type":"integer"},"DigestAlgorithmMnemonic":{},"DigestAlgorithmType":{"type":"integer"},"KeyTag":{"type":"integer"},"DigestValue":{},"PublicKey":{},"DSRecord":{},"DNSKEYRecord":{},"Status":{},"StatusMessage":{},"CreatedDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"S33":{"type":"structure","required":["Id","HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"Id":{},"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"S3c":{"type":"structure","required":["Id","Version","Name","Type","Document"],"members":{"Id":{},"Version":{"type":"integer"},"Name":{},"Type":{},"Document":{},"Comment":{}}},"S3h":{"type":"structure","required":["Id","HostedZoneId","Name","TTL","State","Message","TrafficPolicyId","TrafficPolicyVersion","TrafficPolicyType"],"members":{"Id":{},"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"State":{},"Message":{},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"},"TrafficPolicyType":{}}},"S4w":{"type":"structure","members":{"ContinentCode":{},"ContinentName":{},"CountryCode":{},"CountryName":{},"SubdivisionCode":{},"SubdivisionName":{}}},"S57":{"type":"list","member":{"locationName":"HealthCheckObservation","type":"structure","members":{"Region":{},"IPAddress":{},"StatusReport":{"type":"structure","members":{"Status":{},"CheckedTime":{"type":"timestamp"}}}}}},"S5f":{"type":"list","member":{"shape":"Sa","locationName":"VPC"}},"S6d":{"type":"list","member":{"shape":"S2o","locationName":"HostedZone"}},"S70":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S18"}}},"S7b":{"type":"list","member":{"shape":"S3h","locationName":"TrafficPolicyInstance"}}}}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListHealthChecks":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HealthChecks"},"ListHostedZones":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HostedZones"},"ListQueryLoggingConfigs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueryLoggingConfigs"},"ListResourceRecordSets":{"input_token":["StartRecordName","StartRecordType","StartRecordIdentifier"],"limit_key":"MaxItems","more_results":"IsTruncated","output_token":["NextRecordName","NextRecordType","NextRecordIdentifier"],"result_key":"ResourceRecordSets"}}}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['route53domains'] = {};
	AWS.Route53Domains = Service.defineService('route53domains', ['2014-05-15']);
	Object.defineProperty(apiLoader.services['route53domains'], '2014-05-15', {
	  get: function get() {
	    var model = __webpack_require__(356);
	    model.paginators = __webpack_require__(357).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Route53Domains;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-15","endpointPrefix":"route53domains","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Route 53 Domains","serviceId":"Route 53 Domains","signatureVersion":"v4","targetPrefix":"Route53Domains_v20140515","uid":"route53domains-2014-05-15"},"operations":{"AcceptDomainTransferFromAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName","Password"],"members":{"DomainName":{},"Password":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CancelDomainTransferToAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CheckDomainAvailability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"IdnLangCode":{}}},"output":{"type":"structure","required":["Availability"],"members":{"Availability":{}}}},"CheckDomainTransferability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AuthCode":{"shape":"Sd"}}},"output":{"type":"structure","required":["Transferability"],"members":{"Transferability":{"type":"structure","members":{"Transferable":{}}}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DeleteTagsForDomain":{"input":{"type":"structure","required":["DomainName","TagsToDelete"],"members":{"DomainName":{},"TagsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DisableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"EnableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"EnableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"GetContactReachabilityStatus":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"status":{}}}},"GetDomainDetail":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["DomainName","Nameservers","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"Nameservers":{"shape":"S10"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S16"},"RegistrantContact":{"shape":"S16"},"TechContact":{"shape":"S16"},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"RegistrarName":{},"WhoIsServer":{},"RegistrarUrl":{},"AbuseContactEmail":{},"AbuseContactPhone":{},"RegistryDomainId":{},"CreationDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"},"ExpirationDate":{"type":"timestamp"},"Reseller":{},"DnsSec":{},"StatusList":{"type":"list","member":{}}}}},"GetDomainSuggestions":{"input":{"type":"structure","required":["DomainName","SuggestionCount","OnlyAvailable"],"members":{"DomainName":{},"SuggestionCount":{"type":"integer"},"OnlyAvailable":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuggestionsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Availability":{}}}}}}},"GetOperationDetail":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Status":{},"Message":{},"DomainName":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"ListDomains":{"input":{"type":"structure","members":{"FilterConditions":{"type":"list","member":{"type":"structure","required":["Name","Operator","Values"],"members":{"Name":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"SortCondition":{"type":"structure","required":["Name","SortOrder"],"members":{"Name":{},"SortOrder":{}}},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Domains"],"members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AutoRenew":{"type":"boolean"},"TransferLock":{"type":"boolean"},"Expiry":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListOperations":{"input":{"type":"structure","members":{"SubmittedSince":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Operations"],"members":{"Operations":{"type":"list","member":{"type":"structure","required":["OperationId","Status","Type","SubmittedDate"],"members":{"OperationId":{},"Status":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListPrices":{"input":{"type":"structure","members":{"Tld":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Prices"],"members":{"Prices":{"type":"list","member":{"type":"structure","members":{"Name":{},"RegistrationPrice":{"shape":"S2r"},"TransferPrice":{"shape":"S2r"},"RenewalPrice":{"shape":"S2r"},"ChangeOwnershipPrice":{"shape":"S2r"},"RestorationPrice":{"shape":"S2r"}}}},"NextPageMarker":{}}}},"ListTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S2w"}}}},"RegisterDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S16"},"RegistrantContact":{"shape":"S16"},"TechContact":{"shape":"S16"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"RejectDomainTransferFromAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"RenewDomain":{"input":{"type":"structure","required":["DomainName","CurrentExpiryYear"],"members":{"DomainName":{},"DurationInYears":{"type":"integer"},"CurrentExpiryYear":{"type":"integer"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"ResendContactReachabilityEmail":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"emailAddress":{},"isAlreadyVerified":{"type":"boolean"}}}},"RetrieveDomainAuthCode":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["AuthCode"],"members":{"AuthCode":{"shape":"Sd"}}}},"TransferDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"Nameservers":{"shape":"S10"},"AuthCode":{"shape":"Sd"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S16"},"RegistrantContact":{"shape":"S16"},"TechContact":{"shape":"S16"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"TransferDomainToAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName","AccountId"],"members":{"DomainName":{},"AccountId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Password":{}}}},"UpdateDomainContact":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminContact":{"shape":"S16"},"RegistrantContact":{"shape":"S16"},"TechContact":{"shape":"S16"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContactPrivacy":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainNameservers":{"input":{"type":"structure","required":["DomainName","Nameservers"],"members":{"DomainName":{},"FIAuthKey":{"deprecated":true,"type":"string","sensitive":true},"Nameservers":{"shape":"S10"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"TagsToUpdate":{"shape":"S2w"}}},"output":{"type":"structure","members":{}}},"ViewBilling":{"input":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageMarker":{},"BillingRecords":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Operation":{},"InvoiceId":{},"BillDate":{"type":"timestamp"},"Price":{"type":"double"}}}}}}}},"shapes":{"Sd":{"type":"string","sensitive":true},"S10":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"GlueIps":{"type":"list","member":{}}}}},"S16":{"type":"structure","members":{"FirstName":{},"LastName":{},"ContactType":{},"OrganizationName":{},"AddressLine1":{},"AddressLine2":{},"City":{},"State":{},"CountryCode":{},"ZipCode":{},"PhoneNumber":{},"Email":{},"Fax":{},"ExtraParams":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}}},"sensitive":true},"S2r":{"type":"structure","required":["Price","Currency"],"members":{"Price":{"type":"double"},"Currency":{}}},"S2w":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDomains":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Domains"},"ListOperations":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Operations"},"ListPrices":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Prices"},"ViewBilling":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"BillingRecords"}}}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['s3'] = {};
	AWS.S3 = Service.defineService('s3', ['2006-03-01']);
	__webpack_require__(359);
	Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
	  get: function get() {
	    var model = __webpack_require__(426);
	    model.paginators = __webpack_require__(427).pagination;
	    model.waiters = __webpack_require__(428).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.S3;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var v4Credentials = __webpack_require__(360);
	var resolveRegionalEndpointsFlag = __webpack_require__(33);
	var s3util = __webpack_require__(361);
	var regionUtil = __webpack_require__(362);

	// Pull in managed upload extension
	__webpack_require__(425);

	/**
	 * @api private
	 */
	var operationsWith200StatusCodeError = {
	  'completeMultipartUpload': true,
	  'copyObject': true,
	  'uploadPartCopy': true
	};

	/**
	 * @api private
	 */
	 var regionRedirectErrorCodes = [
	  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
	  'BadRequest', // head operations on virtual-hosted global bucket endpoints
	  'PermanentRedirect', // non-head operations on path-style or regional endpoints
	  301 // head operations on path-style or regional endpoints
	 ];

	var OBJECT_LAMBDA_SERVICE = 's3-object-lambda';

	AWS.util.update(AWS.S3.prototype, {
	  /**
	   * @api private
	   */
	  getSignatureVersion: function getSignatureVersion(request) {
	    var defaultApiVersion = this.api.signatureVersion;
	    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
	    var regionDefinedVersion = this.config.signatureVersion;
	    var isPresigned = request ? request.isPresigned() : false;
	    /*
	      1) User defined version specified:
	        a) always return user defined version
	      2) No user defined version specified:
	        a) If not using presigned urls, default to V4
	        b) If using presigned urls, default to lowest version the region supports
	    */
	    if (userDefinedVersion) {
	      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
	      return userDefinedVersion;
	    }
	    if (isPresigned !== true) {
	      defaultApiVersion = 'v4';
	    } else if (regionDefinedVersion) {
	      defaultApiVersion = regionDefinedVersion;
	    }
	    return defaultApiVersion;
	  },

	  /**
	   * @api private
	   */
	  getSigningName: function getSigningName(req) {
	    if (req && req.operation === 'writeGetObjectResponse') {
	      return OBJECT_LAMBDA_SERVICE;
	    }

	    var _super = AWS.Service.prototype.getSigningName;
	    return (req && req._parsedArn && req._parsedArn.service)
	      ? req._parsedArn.service
	      : _super.call(this);
	  },

	  /**
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var signatureVersion = this.getSignatureVersion(request);
	    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
	  },

	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	    var msg;
	    var messages = [];

	    // default to us-east-1 when no region is provided
	    if (!this.config.region) this.config.region = 'us-east-1';

	    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
	      messages.push('An endpoint must be provided when configuring ' +
	                    '`s3BucketEndpoint` to true.');
	    }
	    if (messages.length === 1) {
	      msg = messages[0];
	    } else if (messages.length > 1) {
	      msg = 'Multiple configuration errors:\n' + messages.join('\n');
	    }
	    if (msg) {
	      throw AWS.util.error(new Error(),
	        {name: 'InvalidEndpoint', message: msg});
	    }
	  },

	  /**
	   * @api private
	   */
	  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
	    var signerClass = this.getSignerClass();
	    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
	        && request.httpRequest.endpoint.protocol === 'https:') {
	      return true;
	    }
	    return false;
	  },

	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    var prependListener = true;
	    request.addListener('validate', this.validateScheme);
	    request.addListener('validate', this.validateBucketName, prependListener);
	    request.addListener('validate', this.optInUsEast1RegionalEndpoint, prependListener);

	    request.removeListener('validate',
	      AWS.EventListeners.Core.VALIDATE_REGION);
	    request.addListener('build', this.addContentType);
	    request.addListener('build', this.computeContentMd5);
	    request.addListener('build', this.computeSseCustomerKeyMd5);
	    request.addListener('build', this.populateURI);
	    request.addListener('afterBuild', this.addExpect100Continue);
	    request.addListener('extractError', this.extractError);
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	    request.addListener('extractData', this.extractData);
	    request.addListener('extractData', this.extractErrorFrom200Response);
	    request.addListener('beforePresign', this.prepareSignedUrl);
	    if (this.shouldDisableBodySigning(request))  {
	      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	      request.addListener('afterBuild', this.disableBodySigning);
	    }
	    //deal with ARNs supplied to Bucket
	    if (request.operation !== 'createBucket' && s3util.isArnInParam(request, 'Bucket')) {
	      // avoid duplicate parsing in the future
	      request._parsedArn = AWS.util.ARN.parse(request.params.Bucket);

	      request.removeListener('validate', this.validateBucketName);
	      request.removeListener('build', this.populateURI);
	      if (request._parsedArn.service === 's3') {
	        request.addListener('validate', s3util.validateS3AccessPointArn);
	        request.addListener('validate', this.validateArnResourceType);
	        request.addListener('validate', this.validateArnRegion);
	      } else if (request._parsedArn.service === 's3-outposts') {
	        request.addListener('validate', s3util.validateOutpostsAccessPointArn);
	        request.addListener('validate', s3util.validateOutpostsArn);
	        request.addListener('validate', s3util.validateArnRegion);
	      }
	      request.addListener('validate', s3util.validateArnAccount);
	      request.addListener('validate', s3util.validateArnService);
	      request.addListener('build', this.populateUriFromAccessPointArn);
	      request.addListener('build', s3util.validatePopulateUriFromArn);
	      return;
	    }
	    //listeners regarding region inference
	    request.addListener('validate', this.validateBucketEndpoint);
	    request.addListener('validate', this.correctBucketRegionFromCache);
	    request.onAsync('extractError', this.requestBucketRegion);
	    if (AWS.util.isBrowser()) {
	      request.onAsync('retry', this.reqRegionForNetworkingError);
	    }
	  },

	  /**
	   * @api private
	   */
	  validateScheme: function(req) {
	    var params = req.params,
	        scheme = req.httpRequest.endpoint.protocol,
	        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
	    if (sensitive && scheme !== 'https:') {
	      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
	        'to \'true\' in your configuration';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },

	  /**
	   * @api private
	   */
	  validateBucketEndpoint: function(req) {
	    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
	      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },

	  /**
	   * @api private
	   */
	   validateArnRegion: function validateArnRegion(req) {
	    s3util.validateArnRegion(req, { allowFipsEndpoint: true });
	  },

	  /**
	   * Validate resource-type supplied in S3 ARN
	   */
	  validateArnResourceType: function validateArnResourceType(req) {
	    var resource = req._parsedArn.resource;

	    if (
	      resource.indexOf('accesspoint:') !== 0 &&
	      resource.indexOf('accesspoint/') !== 0
	    ) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'ARN resource should begin with \'accesspoint/\''
	      });
	    }
	  },

	  /**
	   * @api private
	   */
	  validateBucketName: function validateBucketName(req) {
	    var service = req.service;
	    var signatureVersion = service.getSignatureVersion(req);
	    var bucket = req.params && req.params.Bucket;
	    var key = req.params && req.params.Key;
	    var slashIndex = bucket && bucket.indexOf('/');
	    if (bucket && slashIndex >= 0) {
	      if (typeof key === 'string' && slashIndex > 0) {
	        req.params = AWS.util.copy(req.params);
	        // Need to include trailing slash to match sigv2 behavior
	        var prefix = bucket.substr(slashIndex + 1) || '';
	        req.params.Key = prefix + '/' + key;
	        req.params.Bucket = bucket.substr(0, slashIndex);
	      } else if (signatureVersion === 'v4') {
	        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
	        throw AWS.util.error(new Error(),
	          { code: 'InvalidBucket', message: msg });
	      }
	    }
	  },

	  /**
	   * @api private
	   */
	  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
	    var invalidOperations = [
	      'createBucket',
	      'deleteBucket',
	      'listBuckets'
	    ];
	    return invalidOperations.indexOf(operation) === -1;
	  },

	  /**
	   * When us-east-1 region endpoint configuration is set, in stead of sending request to
	   * global endpoint(e.g. 's3.amazonaws.com'), we will send request to
	   * 's3.us-east-1.amazonaws.com'.
	   * @api private
	   */
	  optInUsEast1RegionalEndpoint: function optInUsEast1RegionalEndpoint(req) {
	    var service = req.service;
	    var config = service.config;
	    config.s3UsEast1RegionalEndpoint = resolveRegionalEndpointsFlag(service._originalConfig, {
	      env: 'AWS_S3_US_EAST_1_REGIONAL_ENDPOINT',
	      sharedConfig: 's3_us_east_1_regional_endpoint',
	      clientConfig: 's3UsEast1RegionalEndpoint'
	    });
	    if (
	      !(service._originalConfig || {}).endpoint &&
	      req.httpRequest.region === 'us-east-1' &&
	      config.s3UsEast1RegionalEndpoint === 'regional' &&
	      req.httpRequest.endpoint.hostname.indexOf('s3.amazonaws.com') >= 0
	    ) {
	      var insertPoint = config.endpoint.indexOf('.amazonaws.com');
	      regionalEndpoint = config.endpoint.substring(0, insertPoint) +
	        '.us-east-1' + config.endpoint.substring(insertPoint);
	      req.httpRequest.updateEndpoint(regionalEndpoint);
	    }
	  },

	  /**
	   * S3 prefers dns-compatible bucket names to be moved from the uri path
	   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
	   * buckets when using SSL and the bucket name contains a dot ('.').  The
	   * ssl wildcard certificate is only 1-level deep.
	   *
	   * @api private
	   */
	  populateURI: function populateURI(req) {
	    var httpRequest = req.httpRequest;
	    var b = req.params.Bucket;
	    var service = req.service;
	    var endpoint = httpRequest.endpoint;
	    if (b) {
	      if (!service.pathStyleBucketName(b)) {
	        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
	          if (service.config.useDualstackEndpoint) {
	            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
	          } else {
	            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
	          }
	        } else if (!service.config.s3BucketEndpoint) {
	          endpoint.hostname =
	            b + '.' + endpoint.hostname;
	        }

	        var port = endpoint.port;
	        if (port !== 80 && port !== 443) {
	          endpoint.host = endpoint.hostname + ':' +
	            endpoint.port;
	        } else {
	          endpoint.host = endpoint.hostname;
	        }

	        httpRequest.virtualHostedBucket = b; // needed for signing the request
	        service.removeVirtualHostedBucketFromPath(req);
	      }
	    }
	  },

	  /**
	   * Takes the bucket name out of the path if bucket is virtual-hosted
	   *
	   * @api private
	   */
	  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
	    var httpRequest = req.httpRequest;
	    var bucket = httpRequest.virtualHostedBucket;
	    if (bucket && httpRequest.path) {
	      if (req.params && req.params.Key) {
	        var encodedS3Key = '/' + AWS.util.uriEscapePath(req.params.Key);
	        if (httpRequest.path.indexOf(encodedS3Key) === 0 && (httpRequest.path.length === encodedS3Key.length || httpRequest.path[encodedS3Key.length] === '?')) {
	          //path only contains key or path contains only key and querystring
	          return;
	        }
	      }
	      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
	      if (httpRequest.path[0] !== '/') {
	        httpRequest.path = '/' + httpRequest.path;
	      }
	    }
	  },

	  /**
	   * When user supply an access point ARN in the Bucket parameter, we need to
	   * populate the URI according to the ARN.
	   */
	  populateUriFromAccessPointArn: function populateUriFromAccessPointArn(req) {
	    var accessPointArn = req._parsedArn;

	    var isOutpostArn = accessPointArn.service === 's3-outposts';
	    var isObjectLambdaArn = accessPointArn.service === 's3-object-lambda';

	    var outpostsSuffix = isOutpostArn ? '.' + accessPointArn.outpostId: '';
	    var serviceName = isOutpostArn ? 's3-outposts': 's3-accesspoint';
	    var fipsSuffix = !isOutpostArn && req.service.config.useFipsEndpoint ? '-fips': '';
	    var dualStackSuffix = !isOutpostArn &&
	      req.service.config.useDualstackEndpoint ? '.dualstack' : '';

	    var endpoint = req.httpRequest.endpoint;
	    var dnsSuffix = regionUtil.getEndpointSuffix(accessPointArn.region);
	    var useArnRegion = req.service.config.s3UseArnRegion;

	    endpoint.hostname = [
	      accessPointArn.accessPoint + '-' + accessPointArn.accountId + outpostsSuffix,
	      serviceName + fipsSuffix + dualStackSuffix,
	      useArnRegion ? accessPointArn.region : req.service.config.region,
	      dnsSuffix
	    ].join('.');

	    if (isObjectLambdaArn) {
	      // should be in the format: "accesspoint/${accesspointName}"
	      var serviceName = 's3-object-lambda';
	      var accesspointName = accessPointArn.resource.split('/')[1];
	      var fipsSuffix = req.service.config.useFipsEndpoint ? '-fips': '';
	      endpoint.hostname = [
	        accesspointName + '-' + accessPointArn.accountId,
	        serviceName + fipsSuffix,
	        useArnRegion ? accessPointArn.region : req.service.config.region,
	        dnsSuffix
	      ].join('.');
	    }
	    endpoint.host = endpoint.hostname;
	    var encodedArn = AWS.util.uriEscape(req.params.Bucket);
	    var path = req.httpRequest.path;
	    //remove the Bucket value from path
	    req.httpRequest.path = path.replace(new RegExp('/' + encodedArn), '');
	    if (req.httpRequest.path[0] !== '/') {
	      req.httpRequest.path = '/' + req.httpRequest.path;
	    }
	    req.httpRequest.region = accessPointArn.region; //region used to sign
	  },

	  /**
	   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
	   * @api private
	   */
	  addExpect100Continue: function addExpect100Continue(req) {
	    var len = req.httpRequest.headers['Content-Length'];
	    if (AWS.util.isNode() && (len >= 1024 * 1024 || req.params.Body instanceof AWS.util.stream.Stream)) {
	      req.httpRequest.headers['Expect'] = '100-continue';
	    }
	  },

	  /**
	   * Adds a default content type if none is supplied.
	   *
	   * @api private
	   */
	  addContentType: function addContentType(req) {
	    var httpRequest = req.httpRequest;
	    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
	      // Content-Type is not set in GET/HEAD requests
	      delete httpRequest.headers['Content-Type'];
	      return;
	    }

	    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
	      httpRequest.headers['Content-Type'] = 'application/octet-stream';
	    }

	    var contentType = httpRequest.headers['Content-Type'];
	    if (AWS.util.isBrowser()) {
	      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
	        var charset = '; charset=UTF-8';
	        httpRequest.headers['Content-Type'] += charset;
	      } else {
	        var replaceFn = function(_, prefix, charsetName) {
	          return prefix + charsetName.toUpperCase();
	        };

	        httpRequest.headers['Content-Type'] =
	          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
	      }
	    }
	  },

	  /**
	   * Checks whether checksums should be computed for the request if it's not
	   * already set by {AWS.EventListeners.Core.COMPUTE_CHECKSUM}. It depends on
	   * whether {AWS.Config.computeChecksums} is set.
	   *
	   * @param req [AWS.Request] the request to check against
	   * @return [Boolean] whether to compute checksums for a request.
	   * @api private
	   */
	  willComputeChecksums: function willComputeChecksums(req) {
	    var rules = req.service.api.operations[req.operation].input.members;
	    var body = req.httpRequest.body;
	    var needsContentMD5 = req.service.config.computeChecksums &&
	      rules.ContentMD5 &&
	      !req.params.ContentMD5 &&
	      body &&
	      (AWS.util.Buffer.isBuffer(req.httpRequest.body) || typeof req.httpRequest.body === 'string');

	    // Sha256 signing disabled, and not a presigned url
	    if (needsContentMD5 && req.service.shouldDisableBodySigning(req) && !req.isPresigned()) {
	      return true;
	    }

	    // SigV2 and presign, for backwards compatibility purpose.
	    if (needsContentMD5 && this.getSignatureVersion(req) === 's3' && req.isPresigned()) {
	      return true;
	    }

	    return false;
	  },

	  /**
	   * A listener that computes the Content-MD5 and sets it in the header.
	   * This listener is to support S3-specific features like
	   * s3DisableBodySigning and SigV2 presign. Content MD5 logic for SigV4 is
	   * handled in AWS.EventListeners.Core.COMPUTE_CHECKSUM
	   *
	   * @api private
	   */
	  computeContentMd5: function computeContentMd5(req) {
	    if (req.service.willComputeChecksums(req)) {
	      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
	      req.httpRequest.headers['Content-MD5'] = md5;
	    }
	  },

	  /**
	   * @api private
	   */
	  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
	    var keys = {
	      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
	      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
	    };
	    AWS.util.each(keys, function(key, header) {
	      if (req.params[key]) {
	        var value = AWS.util.crypto.md5(req.params[key], 'base64');
	        req.httpRequest.headers[header] = value;
	      }
	    });
	  },

	  /**
	   * Returns true if the bucket name should be left in the URI path for
	   * a request to S3.  This function takes into account the current
	   * endpoint protocol (e.g. http or https).
	   *
	   * @api private
	   */
	  pathStyleBucketName: function pathStyleBucketName(bucketName) {
	    // user can force path style requests via the configuration
	    if (this.config.s3ForcePathStyle) return true;
	    if (this.config.s3BucketEndpoint) return false;

	    if (s3util.dnsCompatibleBucketName(bucketName)) {
	      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
	    } else {
	      return true; // not dns compatible names must always use path style
	    }
	  },

	  /**
	   * For COPY operations, some can be error even with status code 200.
	   * SDK treats the response as exception when response body indicates
	   * an exception or body is empty.
	   *
	   * @api private
	   */
	  extractErrorFrom200Response: function extractErrorFrom200Response(resp) {
	    if (!operationsWith200StatusCodeError[resp.request.operation]) return;
	    var httpResponse = resp.httpResponse;
	    if (httpResponse.body && httpResponse.body.toString().match('<Error>')) {
	      // Response body with '<Error>...</Error>' indicates an exception.
	      // Get S3 client object. In ManagedUpload, this.service refers to
	      // S3 client object.
	      resp.data = null;
	      var service = this.service ? this.service : this;
	      service.extractError(resp);
	      throw resp.error;
	    } else if (!httpResponse.body || !httpResponse.body.toString().match(/<[\w_]/)) {
	      // When body is empty or incomplete, S3 might stop the request on detecting client
	      // side aborting the request.
	      resp.data = null;
	      throw AWS.util.error(new Error(), {
	        code: 'InternalError',
	        message: 'S3 aborted request'
	      });
	    }
	  },

	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error, request) {
	    if (operationsWith200StatusCodeError[request.operation] &&
	        error.statusCode === 200) {
	      return true;
	    } else if (request._requestRegionForBucket &&
	        request.service.bucketRegionCache[request._requestRegionForBucket]) {
	      return false;
	    } else if (error && error.code === 'RequestTimeout') {
	      return true;
	    } else if (error &&
	        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
	        error.region && error.region != request.httpRequest.region) {
	      request.httpRequest.region = error.region;
	      if (error.statusCode === 301) {
	        request.service.updateReqBucketRegion(request);
	      }
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error, request);
	    }
	  },

	  /**
	   * Updates httpRequest with region. If region is not provided, then
	   * the httpRequest will be updated based on httpRequest.region
	   *
	   * @api private
	   */
	  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
	    var httpRequest = request.httpRequest;
	    if (typeof region === 'string' && region.length) {
	      httpRequest.region = region;
	    }
	    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
	      return;
	    }
	    var service = request.service;
	    var s3Config = service.config;
	    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
	    if (s3BucketEndpoint) {
	      delete s3Config.s3BucketEndpoint;
	    }
	    var newConfig = AWS.util.copy(s3Config);
	    delete newConfig.endpoint;
	    newConfig.region = httpRequest.region;

	    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
	    service.populateURI(request);
	    s3Config.s3BucketEndpoint = s3BucketEndpoint;
	    httpRequest.headers.Host = httpRequest.endpoint.host;

	    if (request._asm.currentState === 'validate') {
	      request.removeListener('build', service.populateURI);
	      request.addListener('build', service.removeVirtualHostedBucketFromPath);
	    }
	  },

	  /**
	   * Provides a specialized parser for getBucketLocation -- all other
	   * operations are parsed by the super class.
	   *
	   * @api private
	   */
	  extractData: function extractData(resp) {
	    var req = resp.request;
	    if (req.operation === 'getBucketLocation') {
	      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
	      delete resp.data['_'];
	      if (match) {
	        resp.data.LocationConstraint = match[1];
	      } else {
	        resp.data.LocationConstraint = '';
	      }
	    }
	    var bucket = req.params.Bucket || null;
	    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
	      req.service.clearBucketRegionCache(bucket);
	    } else {
	      var headers = resp.httpResponse.headers || {};
	      var region = headers['x-amz-bucket-region'] || null;
	      if (!region && req.operation === 'createBucket' && !resp.error) {
	        var createBucketConfiguration = req.params.CreateBucketConfiguration;
	        if (!createBucketConfiguration) {
	          region = 'us-east-1';
	        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
	          region = 'eu-west-1';
	        } else {
	          region = createBucketConfiguration.LocationConstraint;
	        }
	      }
	      if (region) {
	          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
	            req.service.bucketRegionCache[bucket] = region;
	          }
	      }
	    }
	    req.service.extractRequestIds(resp);
	  },

	  /**
	   * Extracts an error object from the http response.
	   *
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    var codes = {
	      304: 'NotModified',
	      403: 'Forbidden',
	      400: 'BadRequest',
	      404: 'NotFound'
	    };

	    var req = resp.request;
	    var code = resp.httpResponse.statusCode;
	    var body = resp.httpResponse.body || '';

	    var headers = resp.httpResponse.headers || {};
	    var region = headers['x-amz-bucket-region'] || null;
	    var bucket = req.params.Bucket || null;
	    var bucketRegionCache = req.service.bucketRegionCache;
	    if (region && bucket && region !== bucketRegionCache[bucket]) {
	      bucketRegionCache[bucket] = region;
	    }

	    var cachedRegion;
	    if (codes[code] && body.length === 0) {
	      if (bucket && !region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	      resp.error = AWS.util.error(new Error(), {
	        code: codes[code],
	        message: null,
	        region: region
	      });
	    } else {
	      var data = new AWS.XML.Parser().parse(body.toString());

	      if (data.Region && !region) {
	        region = data.Region;
	        if (bucket && region !== bucketRegionCache[bucket]) {
	          bucketRegionCache[bucket] = region;
	        }
	      } else if (bucket && !region && !data.Region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }

	      resp.error = AWS.util.error(new Error(), {
	        code: data.Code || code,
	        message: data.Message || null,
	        region: region
	      });
	    }
	    req.service.extractRequestIds(resp);
	  },

	  /**
	   * If region was not obtained synchronously, then send async request
	   * to get bucket region for errors resulting from wrong region.
	   *
	   * @api private
	   */
	  requestBucketRegion: function requestBucketRegion(resp, done) {
	    var error = resp.error;
	    var req = resp.request;
	    var bucket = req.params.Bucket || null;

	    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
	        (AWS.util.isNode() && req.operation === 'headBucket') ||
	        (error.statusCode === 400 && req.operation !== 'headObject') ||
	        regionRedirectErrorCodes.indexOf(error.code) === -1) {
	      return done();
	    }
	    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
	    var reqParams = {Bucket: bucket};
	    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
	    var regionReq = req.service[reqOperation](reqParams);
	    regionReq._requestRegionForBucket = bucket;
	    regionReq.send(function() {
	      var region = req.service.bucketRegionCache[bucket] || null;
	      error.region = region;
	      done();
	    });
	  },

	   /**
	   * For browser only. If NetworkingError received, will attempt to obtain
	   * the bucket region.
	   *
	   * @api private
	   */
	   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
	    if (!AWS.util.isBrowser()) {
	      return done();
	    }
	    var error = resp.error;
	    var request = resp.request;
	    var bucket = request.params.Bucket;
	    if (!error || error.code !== 'NetworkingError' || !bucket ||
	        request.httpRequest.region === 'us-east-1') {
	      return done();
	    }
	    var service = request.service;
	    var bucketRegionCache = service.bucketRegionCache;
	    var cachedRegion = bucketRegionCache[bucket] || null;

	    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
	      service.updateReqBucketRegion(request, cachedRegion);
	      done();
	    } else if (!s3util.dnsCompatibleBucketName(bucket)) {
	      service.updateReqBucketRegion(request, 'us-east-1');
	      if (bucketRegionCache[bucket] !== 'us-east-1') {
	        bucketRegionCache[bucket] = 'us-east-1';
	      }
	      done();
	    } else if (request.httpRequest.virtualHostedBucket) {
	      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
	      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
	      getRegionReq._requestRegionForBucket = bucket;

	      getRegionReq.send(function() {
	        var region = service.bucketRegionCache[bucket] || null;
	        if (region && region !== request.httpRequest.region) {
	          service.updateReqBucketRegion(request, region);
	        }
	        done();
	      });
	    } else {
	      // DNS-compatible path-style
	      // (s3ForcePathStyle or bucket name with dot over https)
	      // Cannot obtain region information for this case
	      done();
	    }
	   },

	  /**
	   * Cache for bucket region.
	   *
	   * @api private
	   */
	   bucketRegionCache: {},

	  /**
	   * Clears bucket region cache.
	   *
	   * @api private
	   */
	   clearBucketRegionCache: function(buckets) {
	    var bucketRegionCache = this.bucketRegionCache;
	    if (!buckets) {
	      buckets = Object.keys(bucketRegionCache);
	    } else if (typeof buckets === 'string') {
	      buckets = [buckets];
	    }
	    for (var i = 0; i < buckets.length; i++) {
	      delete bucketRegionCache[buckets[i]];
	    }
	    return bucketRegionCache;
	   },

	   /**
	    * Corrects request region if bucket's cached region is different
	    *
	    * @api private
	    */
	  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
	    var bucket = req.params.Bucket || null;
	    if (bucket) {
	      var service = req.service;
	      var requestRegion = req.httpRequest.region;
	      var cachedRegion = service.bucketRegionCache[bucket];
	      if (cachedRegion && cachedRegion !== requestRegion) {
	        service.updateReqBucketRegion(req, cachedRegion);
	      }
	    }
	  },

	  /**
	   * Extracts S3 specific request ids from the http response.
	   *
	   * @api private
	   */
	  extractRequestIds: function extractRequestIds(resp) {
	    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
	    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
	    resp.extendedRequestId = extendedRequestId;
	    resp.cfId = cfId;

	    if (resp.error) {
	      resp.error.requestId = resp.requestId || null;
	      resp.error.extendedRequestId = extendedRequestId;
	      resp.error.cfId = cfId;
	    }
	  },

	  /**
	   * Get a pre-signed URL for a given operation name.
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   * @note Not all operation parameters are supported when using pre-signed
	   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
	   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
	   *   request. If you are using pre-signed URLs to upload from a browser and
	   *   need to use these fields, see {createPresignedPost}.
	   * @note The default signer allows altering the request by adding corresponding
	   *   headers to set some parameters (e.g. Range) and these added parameters
	   *   won't be signed. You must use signatureVersion v4 to to include these
	   *   parameters in the signed portion of the URL and enforce exact matching
	   *   between headers and signed params in the URL.
	   * @note This operation cannot be used with a promise. See note above regarding
	   *   asynchronous credentials and use with a callback.
	   * @param operation [String] the name of the operation to call
	   * @param params [map] parameters to pass to the operation. See the given
	   *   operation for the expected operation parameters. In addition, you can
	   *   also pass the "Expires" parameter to inform S3 how long the URL should
	   *   work for.
	   * @option params Expires [Integer] (900) the number of seconds to expire
	   *   the pre-signed URL operation in. Defaults to 15 minutes.
	   * @param callback [Function] if a callback is provided, this function will
	   *   pass the URL as the second parameter (after the error parameter) to
	   *   the callback function.
	   * @return [String] if called synchronously (with no callback), returns the
	   *   signed URL.
	   * @return [null] nothing is returned if a callback is provided.
	   * @example Pre-signing a getObject operation (synchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url);
	   * @example Pre-signing a putObject (asynchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   s3.getSignedUrl('putObject', params, function (err, url) {
	   *     console.log('The URL is', url);
	   *   });
	   * @example Pre-signing a putObject operation with a specific payload
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
	   *   var url = s3.getSignedUrl('putObject', params);
	   *   console.log('The URL is', url);
	   * @example Passing in a 1-minute expiry time for a pre-signed URL
	   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url); // expires in 60 seconds
	   */
	  getSignedUrl: function getSignedUrl(operation, params, callback) {
	    params = AWS.util.copy(params || {});
	    var expires = params.Expires || 900;

	    if (typeof expires !== 'number') {
	      throw AWS.util.error(new Error(),
	        { code: 'InvalidParameterException', message: 'The expiration must be a number, received ' + typeof expires });
	    }

	    delete params.Expires; // we can't validate this
	    var request = this.makeRequest(operation, params);

	    if (callback) {
	      AWS.util.defer(function() {
	        request.presign(expires, callback);
	      });
	    } else {
	      return request.presign(expires, callback);
	    }
	  },

	  /**
	   * @!method  getSignedUrlPromise()
	   *   Returns a 'thenable' promise that will be resolved with a pre-signed URL
	   *   for a given operation name.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @note Not all operation parameters are supported when using pre-signed
	   *      URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
	   *      `ContentLength`, or `Tagging` must be provided as headers when sending a
	   *      request. If you are using pre-signed URLs to upload from a browser and
	   *      need to use these fields, see {createPresignedPost}.
	   *   @param operation [String] the name of the operation to call
	   *   @param params [map] parameters to pass to the operation. See the given
	   *      operation for the expected operation parameters. In addition, you can
	   *      also pass the "Expires" parameter to inform S3 how long the URL should
	   *      work for.
	   *   @option params Expires [Integer] (900) the number of seconds to expire
	   *      the pre-signed URL operation in. Defaults to 15 minutes.
	   *   @callback fulfilledCallback function(url)
	   *     Called if the promise is fulfilled.
	   *     @param url [String] the signed url
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Pre-signing a getObject operation
	   *      var params = {Bucket: 'bucket', Key: 'key'};
	   *      var promise = s3.getSignedUrlPromise('getObject', params);
	   *      promise.then(function(url) {
	   *        console.log('The URL is', url);
	   *      }, function(err) { ... });
	   *   @example Pre-signing a putObject operation with a specific payload
	   *      var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
	   *      var promise = s3.getSignedUrlPromise('putObject', params);
	   *      promise.then(function(url) {
	   *        console.log('The URL is', url);
	   *      }, function(err) { ... });
	   *   @example Passing in a 1-minute expiry time for a pre-signed URL
	   *      var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
	   *      var promise = s3.getSignedUrlPromise('getObject', params);
	   *      promise.then(function(url) {
	   *        console.log('The URL is', url);
	   *      }, function(err) { ... });
	   */

	  /**
	   * Get a pre-signed POST policy to support uploading to S3 directly from an
	   * HTML form.
	   *
	   * @param params [map]
	   * @option params Bucket [String]     The bucket to which the post should be
	   *                                    uploaded
	   * @option params Expires [Integer]   (3600) The number of seconds for which
	   *                                    the presigned policy should be valid.
	   * @option params Conditions [Array]  An array of conditions that must be met
	   *                                    for the presigned policy to allow the
	   *                                    upload. This can include required tags,
	   *                                    the accepted range for content lengths,
	   *                                    etc.
	   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
	   * @option params Fields [map]        Fields to include in the form. All
	   *                                    values passed in as fields will be
	   *                                    signed as exact match conditions.
	   * @param callback [Function]
	   *
	   * @note All fields passed in when creating presigned post data will be signed
	   *   as exact match conditions. Any fields that will be interpolated by S3
	   *   must be added to the fields hash after signing, and an appropriate
	   *   condition for such fields must be explicitly added to the Conditions
	   *   array passed to this function before signing.
	   *
	   * @example Presiging post data with a known key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Fields: {
	   *       key: 'key'
	   *     }
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @example Presigning post data with an interpolated key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Conditions: [
	   *       ['starts-with', '$key', 'path/to/uploads/']
	   *     ]
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       data.Fields.key = 'path/to/uploads/${filename}';
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   *
	   * @return [map]  If called synchronously (with no callback), returns a hash
	   *                with the url to set as the form action and a hash of fields
	   *                to include in the form.
	   * @return [null] Nothing is returned if a callback is provided.
	   *
	   * @callback callback function (err, data)
	   *  @param err [Error] the error object returned from the policy signer
	   *  @param data [map] The data necessary to construct an HTML form
	   *  @param data.url [String] The URL to use as the action of the form
	   *  @param data.fields [map] A hash of fields that must be included in the
	   *                           form for the upload to succeed. This hash will
	   *                           include the signed POST policy, your access key
	   *                           ID and security token (if present), etc. These
	   *                           may be safely included as input elements of type
	   *                           'hidden.'
	   */
	  createPresignedPost: function createPresignedPost(params, callback) {
	    if (typeof params === 'function' && callback === undefined) {
	      callback = params;
	      params = null;
	    }

	    params = AWS.util.copy(params || {});
	    var boundParams = this.config.params || {};
	    var bucket = params.Bucket || boundParams.Bucket,
	      self = this,
	      config = this.config,
	      endpoint = AWS.util.copy(this.endpoint);
	    if (!config.s3BucketEndpoint) {
	      endpoint.pathname = '/' + bucket;
	    }

	    function finalizePost() {
	      return {
	        url: AWS.util.urlFormat(endpoint),
	        fields: self.preparePostFields(
	          config.credentials,
	          config.region,
	          bucket,
	          params.Fields,
	          params.Conditions,
	          params.Expires
	        )
	      };
	    }

	    if (callback) {
	      config.getCredentials(function (err) {
	        if (err) {
	          callback(err);
	        } else {
	          try {
	            callback(null, finalizePost());
	          } catch (err) {
	            callback(err);
	          }
	        }
	      });
	    } else {
	      return finalizePost();
	    }
	  },

	  /**
	   * @api private
	   */
	  preparePostFields: function preparePostFields(
	    credentials,
	    region,
	    bucket,
	    fields,
	    conditions,
	    expiresInSeconds
	  ) {
	    var now = this.getSkewCorrectedDate();
	    if (!credentials || !region || !bucket) {
	      throw new Error('Unable to create a POST object policy without a bucket,'
	        + ' region, and credentials');
	    }
	    fields = AWS.util.copy(fields || {});
	    conditions = (conditions || []).slice(0);
	    expiresInSeconds = expiresInSeconds || 3600;

	    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
	    var shortDate = signingDate.substr(0, 8);
	    var scope = v4Credentials.createScope(shortDate, region, 's3');
	    var credential = credentials.accessKeyId + '/' + scope;

	    fields['bucket'] = bucket;
	    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
	    fields['X-Amz-Credential'] = credential;
	    fields['X-Amz-Date'] = signingDate;
	    if (credentials.sessionToken) {
	      fields['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	    for (var field in fields) {
	      if (fields.hasOwnProperty(field)) {
	        var condition = {};
	        condition[field] = fields[field];
	        conditions.push(condition);
	      }
	    }

	    fields.Policy = this.preparePostPolicy(
	      new Date(now.valueOf() + expiresInSeconds * 1000),
	      conditions
	    );
	    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
	      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
	      fields.Policy,
	      'hex'
	    );

	    return fields;
	  },

	  /**
	   * @api private
	   */
	  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
	    return AWS.util.base64.encode(JSON.stringify({
	      expiration: AWS.util.date.iso8601(expiration),
	      conditions: conditions
	    }));
	  },

	  /**
	   * @api private
	   */
	  prepareSignedUrl: function prepareSignedUrl(request) {
	    request.addListener('validate', request.service.noPresignedContentLength);
	    request.removeListener('build', request.service.addContentType);
	    if (!request.params.Body) {
	      // no Content-MD5/SHA-256 if body is not provided
	      request.removeListener('build', request.service.computeContentMd5);
	    } else {
	      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	    }
	  },

	  /**
	   * @api private
	   * @param request
	   */
	  disableBodySigning: function disableBodySigning(request) {
	    var headers = request.httpRequest.headers;
	    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
	    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
	      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	    }
	  },

	  /**
	   * @api private
	   */
	  noPresignedContentLength: function noPresignedContentLength(request) {
	    if (request.params.ContentLength !== undefined) {
	      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
	        message: 'ContentLength is not supported in pre-signed URLs.'});
	    }
	  },

	  createBucket: function createBucket(params, callback) {
	    // When creating a bucket *outside* the classic region, the location
	    // constraint must be set for the bucket and it must match the endpoint.
	    // This chunk of code will set the location constraint param based
	    // on the region (when possible), but it will not override a passed-in
	    // location constraint.
	    if (typeof params === 'function' || !params) {
	      callback = callback || params;
	      params = {};
	    }
	    var hostname = this.endpoint.hostname;
	    // copy params so that appending keys does not unintentioinallly
	    // mutate params object argument passed in by user
	    var copiedParams = AWS.util.copy(params);

	    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
	      copiedParams.CreateBucketConfiguration = { LocationConstraint: this.config.region };
	    }
	    return this.makeRequest('createBucket', copiedParams, callback);
	  },

	  writeGetObjectResponse: function writeGetObjectResponse(params, callback) {

	    var request = this.makeRequest('writeGetObjectResponse', AWS.util.copy(params), callback);
	    var hostname = this.endpoint.hostname;
	    if (hostname.indexOf(this.config.region) !== -1) {
	      // hostname specifies a region already
	      hostname = hostname.replace('s3.', OBJECT_LAMBDA_SERVICE + '.');
	    } else {
	      // Hostname doesn't have a region.
	      // Object Lambda requires an explicit region.
	      hostname = hostname.replace('s3.', OBJECT_LAMBDA_SERVICE + '.' + this.config.region + '.');
	    }

	    request.httpRequest.endpoint = new AWS.Endpoint(hostname, this.config);
	    return request;
	  },

	  /**
	   * @see AWS.S3.ManagedUpload
	   * @overload upload(params = {}, [options], [callback])
	   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
	   *   concurrent handling of parts if the payload is large enough. You can
	   *   configure the concurrent queue size by setting `options`. Note that this
	   *   is the only operation for which the SDK can retry requests with stream
	   *   bodies.
	   *
	   *   @param (see AWS.S3.putObject)
	   *   @option (see AWS.S3.ManagedUpload.constructor)
	   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
	   *     `send()` or track progress.
	   *   @example Uploading a stream object
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     s3.upload(params, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
	   *     s3.upload(params, options, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *   @param data.Location [String] the URL of the uploaded object
	   *   @param data.ETag [String] the ETag of the uploaded object
	   *   @param data.Bucket [String]  the bucket to which the object was uploaded
	   *   @param data.Key [String] the key to which the object was uploaded
	   */
	  upload: function upload(params, options, callback) {
	    if (typeof options === 'function' && callback === undefined) {
	      callback = options;
	      options = null;
	    }

	    options = options || {};
	    options = AWS.util.merge(options || {}, {service: this, params: params});

	    var uploader = new AWS.S3.ManagedUpload(options);
	    if (typeof callback === 'function') uploader.send(callback);
	    return uploader;
	  }
	});

	/**
	 * @api private
	 */
	AWS.S3.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getSignedUrlPromise = AWS.util.promisifyMethod('getSignedUrl', PromiseDependency);
	};

	/**
	 * @api private
	 */
	AWS.S3.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getSignedUrlPromise;
	};

	AWS.util.addPromises(AWS.S3);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	/**
	 * @api private
	 */
	var cachedSecret = {};

	/**
	 * @api private
	 */
	var cacheQueue = [];

	/**
	 * @api private
	 */
	var maxCacheEntries = 50;

	/**
	 * @api private
	 */
	var v4Identifier = 'aws4_request';

	/**
	 * @api private
	 */
	module.exports = {
	  /**
	   * @api private
	   *
	   * @param date [String]
	   * @param region [String]
	   * @param serviceName [String]
	   * @return [String]
	   */
	  createScope: function createScope(date, region, serviceName) {
	    return [
	      date.substr(0, 8),
	      region,
	      serviceName,
	      v4Identifier
	    ].join('/');
	  },

	  /**
	   * @api private
	   *
	   * @param credentials [Credentials]
	   * @param date [String]
	   * @param region [String]
	   * @param service [String]
	   * @param shouldCache [Boolean]
	   * @return [String]
	   */
	  getSigningKey: function getSigningKey(
	    credentials,
	    date,
	    region,
	    service,
	    shouldCache
	  ) {
	    var credsIdentifier = AWS.util.crypto
	      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
	    var cacheKey = [credsIdentifier, date, region, service].join('_');
	    shouldCache = shouldCache !== false;
	    if (shouldCache && (cacheKey in cachedSecret)) {
	      return cachedSecret[cacheKey];
	    }

	    var kDate = AWS.util.crypto.hmac(
	      'AWS4' + credentials.secretAccessKey,
	      date,
	      'buffer'
	    );
	    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
	    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

	    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
	    if (shouldCache) {
	      cachedSecret[cacheKey] = signingKey;
	      cacheQueue.push(cacheKey);
	      if (cacheQueue.length > maxCacheEntries) {
	        // remove the oldest entry (not the least recently used)
	        delete cachedSecret[cacheQueue.shift()];
	      }
	    }

	    return signingKey;
	  },

	  /**
	   * @api private
	   *
	   * Empties the derived signing key cache. Made available for testing purposes
	   * only.
	   */
	  emptyCache: function emptyCache() {
	    cachedSecret = {};
	    cacheQueue = [];
	  }
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(4);
	var regionUtil = __webpack_require__(362);

	var s3util = {
	  /**
	   * @api private
	   */
	  isArnInParam: function isArnInParam(req, paramName) {
	    var inputShape = (req.service.api.operations[req.operation] || {}).input || {};
	    var inputMembers = inputShape.members || {};
	    if (!req.params[paramName] || !inputMembers[paramName]) return false;
	    return AWS.util.ARN.validate(req.params[paramName]);
	  },

	  /**
	   * Validate service component from ARN supplied in Bucket parameter
	   */
	  validateArnService: function validateArnService(req) {
	    var parsedArn = req._parsedArn;

	    if (parsedArn.service !== 's3'
	      && parsedArn.service !== 's3-outposts'
	      && parsedArn.service !== 's3-object-lambda') {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'expect \'s3\' or \'s3-outposts\' or \'s3-object-lambda\' in ARN service component'
	      });
	    }
	  },

	  /**
	   * Validate account ID from ARN supplied in Bucket parameter is a valid account
	   */
	  validateArnAccount: function validateArnAccount(req) {
	    var parsedArn = req._parsedArn;

	    if (!/[0-9]{12}/.exec(parsedArn.accountId)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'ARN accountID does not match regex "[0-9]{12}"'
	      });
	    }
	  },

	  /**
	   * Validate ARN supplied in Bucket parameter is a valid access point ARN
	   */
	  validateS3AccessPointArn: function validateS3AccessPointArn(req) {
	    var parsedArn = req._parsedArn;

	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['accesspoint'.length];

	    if (parsedArn.resource.split(delimiter).length !== 2) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Access Point ARN should have one resource accesspoint/{accesspointName}'
	      });
	    }

	    var accessPoint = parsedArn.resource.split(delimiter)[1];
	    var accessPointPrefix = accessPoint + '-' + parsedArn.accountId;
	    if (!s3util.dnsCompatibleBucketName(accessPointPrefix) || accessPointPrefix.match(/\./)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Access point resource in ARN is not DNS compatible. Got ' + accessPoint
	      });
	    }

	    //set parsed valid access point
	    req._parsedArn.accessPoint = accessPoint;
	  },

	  /**
	   * Validate Outposts ARN supplied in Bucket parameter is a valid outposts ARN
	   */
	  validateOutpostsArn: function validateOutpostsArn(req) {
	    var parsedArn = req._parsedArn;

	    if (
	      parsedArn.resource.indexOf('outpost:') !== 0 &&
	      parsedArn.resource.indexOf('outpost/') !== 0
	    ) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'ARN resource should begin with \'outpost/\''
	      });
	    }

	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['outpost'.length];
	    var outpostId = parsedArn.resource.split(delimiter)[1];
	    var dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
	    if (!dnsHostRegex.test(outpostId)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Outpost resource in ARN is not DNS compatible. Got ' + outpostId
	      });
	    }
	    req._parsedArn.outpostId = outpostId;
	  },

	  /**
	   * Validate Outposts ARN supplied in Bucket parameter is a valid outposts ARN
	   */
	  validateOutpostsAccessPointArn: function validateOutpostsAccessPointArn(req) {
	    var parsedArn = req._parsedArn;

	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['outpost'.length];

	    if (parsedArn.resource.split(delimiter).length !== 4) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Outposts ARN should have two resources outpost/{outpostId}/accesspoint/{accesspointName}'
	      });
	    }

	    var accessPoint = parsedArn.resource.split(delimiter)[3];
	    var accessPointPrefix = accessPoint + '-' + parsedArn.accountId;
	    if (!s3util.dnsCompatibleBucketName(accessPointPrefix) || accessPointPrefix.match(/\./)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Access point resource in ARN is not DNS compatible. Got ' + accessPoint
	      });
	    }

	    //set parsed valid access point
	    req._parsedArn.accessPoint = accessPoint;
	  },

	  /**
	   * Validate region field in ARN supplied in Bucket parameter is a valid region
	   */
	  validateArnRegion: function validateArnRegion(req, options) {
	    if (options === undefined) {
	      options = {};
	    }

	    var useArnRegion = s3util.loadUseArnRegionConfig(req);
	    var regionFromArn = req._parsedArn.region;
	    var clientRegion = req.service.config.region;
	    var useFipsEndpoint = req.service.config.useFipsEndpoint;
	    var allowFipsEndpoint = options.allowFipsEndpoint || false;

	    if (!regionFromArn) {
	      var message = 'ARN region is empty';
	      if (req._parsedArn.service === 's3') {
	        message = message + '\nYou may want to use multi-regional ARN. The feature is not supported in current SDK. ' +
	        'You should consider switching to V3(https://github.com/aws/aws-sdk-js-v3).';
	      }
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: message
	      });
	    }

	    if (useFipsEndpoint && !allowFipsEndpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'ARN endpoint is not compatible with FIPS region'
	      });
	    }

	    if (regionFromArn.indexOf('fips') >= 0) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'FIPS region not allowed in ARN'
	      });
	    }

	    if (!useArnRegion && regionFromArn !== clientRegion) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Configured region conflicts with access point region'
	      });
	    } else if (
	      useArnRegion &&
	      regionUtil.getEndpointSuffix(regionFromArn) !== regionUtil.getEndpointSuffix(clientRegion)
	    ) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Configured region and access point region not in same partition'
	      });
	    }

	    if (req.service.config.useAccelerateEndpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'useAccelerateEndpoint config is not supported with access point ARN'
	      });
	    }

	    if (req._parsedArn.service === 's3-outposts' && req.service.config.useDualstackEndpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Dualstack is not supported with outposts access point ARN'
	      });
	    }
	  },

	  loadUseArnRegionConfig: function loadUseArnRegionConfig(req) {
	    var envName = 'AWS_S3_USE_ARN_REGION';
	    var configName = 's3_use_arn_region';
	    var useArnRegion = true;
	    var originalConfig = req.service._originalConfig || {};
	    if (req.service.config.s3UseArnRegion !== undefined) {
	      return req.service.config.s3UseArnRegion;
	    } else if (originalConfig.s3UseArnRegion !== undefined) {
	      useArnRegion = originalConfig.s3UseArnRegion === true;
	    } else if (AWS.util.isNode()) {
	      //load from environmental variable AWS_USE_ARN_REGION
	      if (process.env[envName]) {
	        var value = process.env[envName].trim().toLowerCase();
	        if (['false', 'true'].indexOf(value) < 0) {
	          throw AWS.util.error(new Error(), {
	            code: 'InvalidConfiguration',
	            message: envName + ' only accepts true or false. Got ' + process.env[envName],
	            retryable: false
	          });
	        }
	        useArnRegion = value === 'true';
	      } else {  //load from shared config property use_arn_region
	        var profiles = {};
	        var profile = {};
	        try {
	          profiles = AWS.util.getProfilesFromSharedConfig(AWS.util.iniLoader);
	          profile = profiles[process.env.AWS_PROFILE || AWS.util.defaultProfile];
	        } catch (e) {}
	        if (profile[configName]) {
	          if (['false', 'true'].indexOf(profile[configName].trim().toLowerCase()) < 0) {
	            throw AWS.util.error(new Error(), {
	              code: 'InvalidConfiguration',
	              message: configName + ' only accepts true or false. Got ' + profile[configName],
	              retryable: false
	            });
	          }
	          useArnRegion = profile[configName].trim().toLowerCase() === 'true';
	        }
	      }
	    }
	    req.service.config.s3UseArnRegion = useArnRegion;
	    return useArnRegion;
	  },

	  /**
	   * Validations before URI can be populated
	   */
	  validatePopulateUriFromArn: function validatePopulateUriFromArn(req) {
	    if (req.service._originalConfig && req.service._originalConfig.endpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Custom endpoint is not compatible with access point ARN'
	      });
	    }

	    if (req.service.config.s3ForcePathStyle) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Cannot construct path-style endpoint with access point'
	      });
	    }
	  },

	  /**
	   * Returns true if the bucket name is DNS compatible.  Buckets created
	   * outside of the classic region MUST be DNS compatible.
	   *
	   * @api private
	   */
	  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
	    var b = bucketName;
	    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
	    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
	    var dots = new RegExp(/\.\./);
	    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
	  },
	};

	/**
	 * @api private
	 */
	module.exports = s3util;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(363);
	var regionConfig = __webpack_require__(424);

	function generateRegionPrefix(region) {
	  if (!region) return null;
	  var parts = region.split('-');
	  if (parts.length < 3) return null;
	  return parts.slice(0, parts.length - 2).join('-') + '-*';
	}

	function derivedKeys(service) {
	  var region = service.config.region;
	  var regionPrefix = generateRegionPrefix(region);
	  var endpointPrefix = service.api.endpointPrefix;

	  return [
	    [region, endpointPrefix],
	    [regionPrefix, endpointPrefix],
	    [region, '*'],
	    [regionPrefix, '*'],
	    ['*', endpointPrefix],
	    ['*', '*']
	  ].map(function(item) {
	    return item[0] && item[1] ? item.join('/') : null;
	  });
	}

	function applyConfig(service, config) {
	  util.each(config, function(key, value) {
	    if (key === 'globalEndpoint') return;
	    if (service.config[key] === undefined || service.config[key] === null) {
	      service.config[key] = value;
	    }
	  });
	}

	function configureEndpoint(service) {
	  var keys = derivedKeys(service);
	  var useFipsEndpoint = service.config.useFipsEndpoint;
	  var useDualstackEndpoint = service.config.useDualstackEndpoint;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!key) continue;

	    var rules = useFipsEndpoint
	      ? useDualstackEndpoint
	        ? regionConfig.dualstackFipsRules
	        : regionConfig.fipsRules
	      : useDualstackEndpoint
	      ? regionConfig.dualstackRules
	      : regionConfig.rules;

	    if (Object.prototype.hasOwnProperty.call(rules, key)) {
	      var config = rules[key];
	      if (typeof config === 'string') {
	        config = regionConfig.patterns[config];
	      }

	      // set global endpoint
	      service.isGlobalEndpoint = !!config.globalEndpoint;
	      if (config.signingRegion) {
	        service.signingRegion = config.signingRegion;
	      }

	      // signature version
	      if (!config.signatureVersion) config.signatureVersion = 'v4';

	      // merge config
	      applyConfig(service, config);
	      return;
	    }
	  }
	}

	function getEndpointSuffix(region) {
	  var regionRegexes = {
	    '^(us|eu|ap|sa|ca|me)\\-\\w+\\-\\d+$': 'amazonaws.com',
	    '^cn\\-\\w+\\-\\d+$': 'amazonaws.com.cn',
	    '^us\\-gov\\-\\w+\\-\\d+$': 'amazonaws.com',
	    '^us\\-iso\\-\\w+\\-\\d+$': 'c2s.ic.gov',
	    '^us\\-isob\\-\\w+\\-\\d+$': 'sc2s.sgov.gov'
	  };
	  var defaultSuffix = 'amazonaws.com';
	  var regexes = Object.keys(regionRegexes);
	  for (var i = 0; i < regexes.length; i++) {
	    var regionPattern = RegExp(regexes[i]);
	    var dnsSuffix = regionRegexes[regexes[i]];
	    if (regionPattern.test(region)) return dnsSuffix;
	  }
	  return defaultSuffix;
	}

	/**
	 * @api private
	 */
	module.exports = {
	  configureEndpoint: configureEndpoint,
	  getEndpointSuffix: getEndpointSuffix,
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
	var AWS;

	/**
	 * A set of utility methods for use with the AWS SDK.
	 *
	 * @!attribute abort
	 *   Return this value from an iterator function {each} or {arrayEach}
	 *   to break out of the iteration.
	 *   @example Breaking out of an iterator function
	 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
	 *       if (key == 'b') return AWS.util.abort;
	 *     });
	 *   @see each
	 *   @see arrayEach
	 * @api private
	 */
	var util = {
	  environment: 'nodejs',
	  engine: function engine() {
	    if (util.isBrowser() && typeof navigator !== 'undefined') {
	      return navigator.userAgent;
	    } else {
	      var engine = process.platform + '/' + process.version;
	      if (process.env.AWS_EXECUTION_ENV) {
	        engine += ' exec-env/' + process.env.AWS_EXECUTION_ENV;
	      }
	      return engine;
	    }
	  },

	  userAgent: function userAgent() {
	    var name = util.environment;
	    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(4).VERSION;
	    if (name === 'nodejs') agent += ' ' + util.engine();
	    return agent;
	  },

	  uriEscape: function uriEscape(string) {
	    var output = encodeURIComponent(string);
	    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

	    // AWS percent-encodes some extra non-standard characters in a URI
	    output = output.replace(/[*]/g, function(ch) {
	      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
	    });

	    return output;
	  },

	  uriEscapePath: function uriEscapePath(string) {
	    var parts = [];
	    util.arrayEach(string.split('/'), function (part) {
	      parts.push(util.uriEscape(part));
	    });
	    return parts.join('/');
	  },

	  urlParse: function urlParse(url) {
	    return util.url.parse(url);
	  },

	  urlFormat: function urlFormat(url) {
	    return util.url.format(url);
	  },

	  queryStringParse: function queryStringParse(qs) {
	    return util.querystring.parse(qs);
	  },

	  queryParamsToString: function queryParamsToString(params) {
	    var items = [];
	    var escape = util.uriEscape;
	    var sortedKeys = Object.keys(params).sort();

	    util.arrayEach(sortedKeys, function(name) {
	      var value = params[name];
	      var ename = escape(name);
	      var result = ename + '=';
	      if (Array.isArray(value)) {
	        var vals = [];
	        util.arrayEach(value, function(item) { vals.push(escape(item)); });
	        result = ename + '=' + vals.sort().join('&' + ename + '=');
	      } else if (value !== undefined && value !== null) {
	        result = ename + '=' + escape(value);
	      }
	      items.push(result);
	    });

	    return items.join('&');
	  },

	  readFileSync: function readFileSync(path) {
	    if (util.isBrowser()) return null;
	    return __webpack_require__(366).readFileSync(path, 'utf-8');
	  },

	  base64: {
	    encode: function encode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 encode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      var buf = util.buffer.toBuffer(string);
	      return buf.toString('base64');
	    },

	    decode: function decode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 decode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      return util.buffer.toBuffer(string, 'base64');
	    }

	  },

	  buffer: {
	    /**
	     * Buffer constructor for Node buffer and buffer pollyfill
	     */
	    toBuffer: function(data, encoding) {
	      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ?
	        util.Buffer.from(data, encoding) : new util.Buffer(data, encoding);
	    },

	    alloc: function(size, fill, encoding) {
	      if (typeof size !== 'number') {
	        throw new Error('size passed to alloc must be a number.');
	      }
	      if (typeof util.Buffer.alloc === 'function') {
	        return util.Buffer.alloc(size, fill, encoding);
	      } else {
	        var buf = new util.Buffer(size);
	        if (fill !== undefined && typeof buf.fill === 'function') {
	          buf.fill(fill, undefined, undefined, encoding);
	        }
	        return buf;
	      }
	    },

	    toStream: function toStream(buffer) {
	      if (!util.Buffer.isBuffer(buffer)) buffer =  util.buffer.toBuffer(buffer);

	      var readable = new (util.stream.Readable)();
	      var pos = 0;
	      readable._read = function(size) {
	        if (pos >= buffer.length) return readable.push(null);

	        var end = pos + size;
	        if (end > buffer.length) end = buffer.length;
	        readable.push(buffer.slice(pos, end));
	        pos = end;
	      };

	      return readable;
	    },

	    /**
	     * Concatenates a list of Buffer objects.
	     */
	    concat: function(buffers) {
	      var length = 0,
	          offset = 0,
	          buffer = null, i;

	      for (i = 0; i < buffers.length; i++) {
	        length += buffers[i].length;
	      }

	      buffer = util.buffer.alloc(length);

	      for (i = 0; i < buffers.length; i++) {
	        buffers[i].copy(buffer, offset);
	        offset += buffers[i].length;
	      }

	      return buffer;
	    }
	  },

	  string: {
	    byteLength: function byteLength(string) {
	      if (string === null || string === undefined) return 0;
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);

	      if (typeof string.byteLength === 'number') {
	        return string.byteLength;
	      } else if (typeof string.length === 'number') {
	        return string.length;
	      } else if (typeof string.size === 'number') {
	        return string.size;
	      } else if (typeof string.path === 'string') {
	        return __webpack_require__(366).lstatSync(string.path).size;
	      } else {
	        throw util.error(new Error('Cannot determine length of ' + string),
	          { object: string });
	      }
	    },

	    upperFirst: function upperFirst(string) {
	      return string[0].toUpperCase() + string.substr(1);
	    },

	    lowerFirst: function lowerFirst(string) {
	      return string[0].toLowerCase() + string.substr(1);
	    }
	  },

	  ini: {
	    parse: function string(ini) {
	      var currentSection, map = {};
	      util.arrayEach(ini.split(/\r?\n/), function(line) {
	        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
	        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
	        if (section) {
	          currentSection = section[1];
	          if (currentSection === '__proto__' || currentSection.split(/\s/)[1] === '__proto__') {
	            throw util.error(
	              new Error('Cannot load profile name \'' + currentSection + '\' from shared ini file.')
	            );
	          }
	        } else if (currentSection) {
	          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
	          if (item) {
	            map[currentSection] = map[currentSection] || {};
	            map[currentSection][item[1]] = item[2];
	          }
	        }
	      });

	      return map;
	    }
	  },

	  fn: {
	    noop: function() {},
	    callback: function (err) { if (err) throw err; },

	    /**
	     * Turn a synchronous function into as "async" function by making it call
	     * a callback. The underlying function is called with all but the last argument,
	     * which is treated as the callback. The callback is passed passed a first argument
	     * of null on success to mimick standard node callbacks.
	     */
	    makeAsync: function makeAsync(fn, expectedArgs) {
	      if (expectedArgs && expectedArgs <= fn.length) {
	        return fn;
	      }

	      return function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        var callback = args.pop();
	        var result = fn.apply(null, args);
	        callback(result);
	      };
	    }
	  },

	  /**
	   * Date and time utility functions.
	   */
	  date: {

	    /**
	     * @return [Date] the current JavaScript date object. Since all
	     *   AWS services rely on this date object, you can override
	     *   this function to provide a special time value to AWS service
	     *   requests.
	     */
	    getDate: function getDate() {
	      if (!AWS) AWS = __webpack_require__(4);
	      if (AWS.config.systemClockOffset) { // use offset when non-zero
	        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
	      } else {
	        return new Date();
	      }
	    },

	    /**
	     * @return [String] the date in ISO-8601 format
	     */
	    iso8601: function iso8601(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
	    },

	    /**
	     * @return [String] the date in RFC 822 format
	     */
	    rfc822: function rfc822(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toUTCString();
	    },

	    /**
	     * @return [Integer] the UNIX timestamp value for the current time
	     */
	    unixTimestamp: function unixTimestamp(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.getTime() / 1000;
	    },

	    /**
	     * @param [String,number,Date] date
	     * @return [Date]
	     */
	    from: function format(date) {
	      if (typeof date === 'number') {
	        return new Date(date * 1000); // unix timestamp
	      } else {
	        return new Date(date);
	      }
	    },

	    /**
	     * Given a Date or date-like value, this function formats the
	     * date into a string of the requested value.
	     * @param [String,number,Date] date
	     * @param [String] formatter Valid formats are:
	     #   * 'iso8601'
	     #   * 'rfc822'
	     #   * 'unixTimestamp'
	     * @return [String]
	     */
	    format: function format(date, formatter) {
	      if (!formatter) formatter = 'iso8601';
	      return util.date[formatter](util.date.from(date));
	    },

	    parseTimestamp: function parseTimestamp(value) {
	      if (typeof value === 'number') { // unix timestamp (number)
	        return new Date(value * 1000);
	      } else if (value.match(/^\d+$/)) { // unix timestamp
	        return new Date(value * 1000);
	      } else if (value.match(/^\d{4}/)) { // iso8601
	        return new Date(value);
	      } else if (value.match(/^\w{3},/)) { // rfc822
	        return new Date(value);
	      } else {
	        throw util.error(
	          new Error('unhandled timestamp format: ' + value),
	          {code: 'TimestampParserError'});
	      }
	    }

	  },

	  crypto: {
	    crc32Table: [
	     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
	     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
	     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
	     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
	     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
	     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
	     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
	     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
	     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
	     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
	     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
	     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
	     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
	     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
	     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
	     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
	     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
	     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
	     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
	     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
	     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
	     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
	     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
	     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
	     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
	     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
	     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
	     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
	     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
	     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
	     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
	     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
	     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
	     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
	     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
	     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
	     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
	     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
	     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
	     0x2D02EF8D],

	    crc32: function crc32(data) {
	      var tbl = util.crypto.crc32Table;
	      var crc = 0 ^ -1;

	      if (typeof data === 'string') {
	        data = util.buffer.toBuffer(data);
	      }

	      for (var i = 0; i < data.length; i++) {
	        var code = data.readUInt8(i);
	        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
	      }
	      return (crc ^ -1) >>> 0;
	    },

	    hmac: function hmac(key, string, digest, fn) {
	      if (!digest) digest = 'binary';
	      if (digest === 'buffer') { digest = undefined; }
	      if (!fn) fn = 'sha256';
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
	    },

	    md5: function md5(data, digest, callback) {
	      return util.crypto.hash('md5', data, digest, callback);
	    },

	    sha256: function sha256(data, digest, callback) {
	      return util.crypto.hash('sha256', data, digest, callback);
	    },

	    hash: function(algorithm, data, digest, callback) {
	      var hash = util.crypto.createHash(algorithm);
	      if (!digest) { digest = 'binary'; }
	      if (digest === 'buffer') { digest = undefined; }
	      if (typeof data === 'string') data = util.buffer.toBuffer(data);
	      var sliceFn = util.arraySliceFn(data);
	      var isBuffer = util.Buffer.isBuffer(data);
	      //Identifying objects with an ArrayBuffer as buffers
	      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

	      if (callback && typeof data === 'object' &&
	          typeof data.on === 'function' && !isBuffer) {
	        data.on('data', function(chunk) { hash.update(chunk); });
	        data.on('error', function(err) { callback(err); });
	        data.on('end', function() { callback(null, hash.digest(digest)); });
	      } else if (callback && sliceFn && !isBuffer &&
	                 typeof FileReader !== 'undefined') {
	        // this might be a File/Blob
	        var index = 0, size = 1024 * 512;
	        var reader = new FileReader();
	        reader.onerror = function() {
	          callback(new Error('Failed to read data.'));
	        };
	        reader.onload = function() {
	          var buf = new util.Buffer(new Uint8Array(reader.result));
	          hash.update(buf);
	          index += buf.length;
	          reader._continueReading();
	        };
	        reader._continueReading = function() {
	          if (index >= data.size) {
	            callback(null, hash.digest(digest));
	            return;
	          }

	          var back = index + size;
	          if (back > data.size) back = data.size;
	          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
	        };

	        reader._continueReading();
	      } else {
	        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
	          data = new util.Buffer(new Uint8Array(data));
	        }
	        var out = hash.update(data).digest(digest);
	        if (callback) callback(null, out);
	        return out;
	      }
	    },

	    toHex: function toHex(data) {
	      var out = [];
	      for (var i = 0; i < data.length; i++) {
	        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
	      }
	      return out.join('');
	    },

	    createHash: function createHash(algorithm) {
	      return util.crypto.lib.createHash(algorithm);
	    }

	  },

	  /** @!ignore */

	  /* Abort constant */
	  abort: {},

	  each: function each(object, iterFunction) {
	    for (var key in object) {
	      if (Object.prototype.hasOwnProperty.call(object, key)) {
	        var ret = iterFunction.call(this, key, object[key]);
	        if (ret === util.abort) break;
	      }
	    }
	  },

	  arrayEach: function arrayEach(array, iterFunction) {
	    for (var idx in array) {
	      if (Object.prototype.hasOwnProperty.call(array, idx)) {
	        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
	        if (ret === util.abort) break;
	      }
	    }
	  },

	  update: function update(obj1, obj2) {
	    util.each(obj2, function iterator(key, item) {
	      obj1[key] = item;
	    });
	    return obj1;
	  },

	  merge: function merge(obj1, obj2) {
	    return util.update(util.copy(obj1), obj2);
	  },

	  copy: function copy(object) {
	    if (object === null || object === undefined) return object;
	    var dupe = {};
	    // jshint forin:false
	    for (var key in object) {
	      dupe[key] = object[key];
	    }
	    return dupe;
	  },

	  isEmpty: function isEmpty(obj) {
	    for (var prop in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
	        return false;
	      }
	    }
	    return true;
	  },

	  arraySliceFn: function arraySliceFn(obj) {
	    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
	    return typeof fn === 'function' ? fn : null;
	  },

	  isType: function isType(obj, type) {
	    // handle cross-"frame" objects
	    if (typeof type === 'function') type = util.typeName(type);
	    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
	  },

	  typeName: function typeName(type) {
	    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
	    var str = type.toString();
	    var match = str.match(/^\s*function (.+)\(/);
	    return match ? match[1] : str;
	  },

	  error: function error(err, options) {
	    var originalError = null;
	    if (typeof err.message === 'string' && err.message !== '') {
	      if (typeof options === 'string' || (options && options.message)) {
	        originalError = util.copy(err);
	        originalError.message = err.message;
	      }
	    }
	    err.message = err.message || null;

	    if (typeof options === 'string') {
	      err.message = options;
	    } else if (typeof options === 'object' && options !== null) {
	      util.update(err, options);
	      if (options.message)
	        err.message = options.message;
	      if (options.code || options.name)
	        err.code = options.code || options.name;
	      if (options.stack)
	        err.stack = options.stack;
	    }

	    if (typeof Object.defineProperty === 'function') {
	      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
	      Object.defineProperty(err, 'message', {enumerable: true});
	    }

	    err.name = String(options && options.name || err.name || err.code || 'Error');
	    err.time = new Date();

	    if (originalError) err.originalError = originalError;

	    return err;
	  },

	  /**
	   * @api private
	   */
	  inherit: function inherit(klass, features) {
	    var newObject = null;
	    if (features === undefined) {
	      features = klass;
	      klass = Object;
	      newObject = {};
	    } else {
	      var ctor = function ConstructorWrapper() {};
	      ctor.prototype = klass.prototype;
	      newObject = new ctor();
	    }

	    // constructor not supplied, create pass-through ctor
	    if (features.constructor === Object) {
	      features.constructor = function() {
	        if (klass !== Object) {
	          return klass.apply(this, arguments);
	        }
	      };
	    }

	    features.constructor.prototype = newObject;
	    util.update(features.constructor.prototype, features);
	    features.constructor.__super__ = klass;
	    return features.constructor;
	  },

	  /**
	   * @api private
	   */
	  mixin: function mixin() {
	    var klass = arguments[0];
	    for (var i = 1; i < arguments.length; i++) {
	      // jshint forin:false
	      for (var prop in arguments[i].prototype) {
	        var fn = arguments[i].prototype[prop];
	        if (prop !== 'constructor') {
	          klass.prototype[prop] = fn;
	        }
	      }
	    }
	    return klass;
	  },

	  /**
	   * @api private
	   */
	  hideProperties: function hideProperties(obj, props) {
	    if (typeof Object.defineProperty !== 'function') return;

	    util.arrayEach(props, function (key) {
	      Object.defineProperty(obj, key, {
	        enumerable: false, writable: true, configurable: true });
	    });
	  },

	  /**
	   * @api private
	   */
	  property: function property(obj, name, value, enumerable, isValue) {
	    var opts = {
	      configurable: true,
	      enumerable: enumerable !== undefined ? enumerable : true
	    };
	    if (typeof value === 'function' && !isValue) {
	      opts.get = value;
	    }
	    else {
	      opts.value = value; opts.writable = true;
	    }

	    Object.defineProperty(obj, name, opts);
	  },

	  /**
	   * @api private
	   */
	  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
	    var cachedValue = null;

	    // build enumerable attribute for each value with lazy accessor.
	    util.property(obj, name, function() {
	      if (cachedValue === null) {
	        cachedValue = get();
	      }
	      return cachedValue;
	    }, enumerable);
	  },

	  /**
	   * TODO Remove in major version revision
	   * This backfill populates response data without the
	   * top-level payload name.
	   *
	   * @api private
	   */
	  hoistPayloadMember: function hoistPayloadMember(resp) {
	    var req = resp.request;
	    var operationName = req.operation;
	    var operation = req.service.api.operations[operationName];
	    var output = operation.output;
	    if (output.payload && !operation.hasEventOutput) {
	      var payloadMember = output.members[output.payload];
	      var responsePayload = resp.data[output.payload];
	      if (payloadMember.type === 'structure') {
	        util.each(responsePayload, function(key, value) {
	          util.property(resp.data, key, value, false);
	        });
	      }
	    }
	  },

	  /**
	   * Compute SHA-256 checksums of streams
	   *
	   * @api private
	   */
	  computeSha256: function computeSha256(body, done) {
	    if (util.isNode()) {
	      var Stream = util.stream.Stream;
	      var fs = __webpack_require__(366);
	      if (typeof Stream === 'function' && body instanceof Stream) {
	        if (typeof body.path === 'string') { // assume file object
	          var settings = {};
	          if (typeof body.start === 'number') {
	            settings.start = body.start;
	          }
	          if (typeof body.end === 'number') {
	            settings.end = body.end;
	          }
	          body = fs.createReadStream(body.path, settings);
	        } else { // TODO support other stream types
	          return done(new Error('Non-file stream objects are ' +
	                                'not supported with SigV4'));
	        }
	      }
	    }

	    util.crypto.sha256(body, 'hex', function(err, sha) {
	      if (err) done(err);
	      else done(null, sha);
	    });
	  },

	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(serverTime) {
	    if (serverTime) {
	      util.property(AWS.config, 'isClockSkewed',
	        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
	      return AWS.config.isClockSkewed;
	    }
	  },

	  applyClockOffset: function applyClockOffset(serverTime) {
	    if (serverTime)
	      AWS.config.systemClockOffset = serverTime - new Date().getTime();
	  },

	  /**
	   * @api private
	   */
	  extractRequestId: function extractRequestId(resp) {
	    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
	                     resp.httpResponse.headers['x-amzn-requestid'];

	    if (!requestId && resp.data && resp.data.ResponseMetadata) {
	      requestId = resp.data.ResponseMetadata.RequestId;
	    }

	    if (requestId) {
	      resp.requestId = requestId;
	    }

	    if (resp.error) {
	      resp.error.requestId = requestId;
	    }
	  },

	  /**
	   * @api private
	   */
	  addPromises: function addPromises(constructors, PromiseDependency) {
	    var deletePromises = false;
	    if (PromiseDependency === undefined && AWS && AWS.config) {
	      PromiseDependency = AWS.config.getPromisesDependency();
	    }
	    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
	      PromiseDependency = Promise;
	    }
	    if (typeof PromiseDependency !== 'function') deletePromises = true;
	    if (!Array.isArray(constructors)) constructors = [constructors];

	    for (var ind = 0; ind < constructors.length; ind++) {
	      var constructor = constructors[ind];
	      if (deletePromises) {
	        if (constructor.deletePromisesFromClass) {
	          constructor.deletePromisesFromClass();
	        }
	      } else if (constructor.addPromisesToClass) {
	        constructor.addPromisesToClass(PromiseDependency);
	      }
	    }
	  },

	  /**
	   * @api private
	   * Return a function that will return a promise whose fate is decided by the
	   * callback behavior of the given method with `methodName`. The method to be
	   * promisified should conform to node.js convention of accepting a callback as
	   * last argument and calling that callback with error as the first argument
	   * and success value on the second argument.
	   */
	  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
	    return function promise() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      return new PromiseDependency(function(resolve, reject) {
	        args.push(function(err, data) {
	          if (err) {
	            reject(err);
	          } else {
	            resolve(data);
	          }
	        });
	        self[methodName].apply(self, args);
	      });
	    };
	  },

	  /**
	   * @api private
	   */
	  isDualstackAvailable: function isDualstackAvailable(service) {
	    if (!service) return false;
	    var metadata = __webpack_require__(367);
	    if (typeof service !== 'string') service = service.serviceIdentifier;
	    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
	    return !!metadata[service].dualstackAvailable;
	  },

	  /**
	   * @api private
	   */
	  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions, err) {
	    if (!retryDelayOptions) retryDelayOptions = {};
	    var customBackoff = retryDelayOptions.customBackoff || null;
	    if (typeof customBackoff === 'function') {
	      return customBackoff(retryCount, err);
	    }
	    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
	    var delay = Math.random() * (Math.pow(2, retryCount) * base);
	    return delay;
	  },

	  /**
	   * @api private
	   */
	  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
	    if (!options) options = {};
	    var http = AWS.HttpClient.getInstance();
	    var httpOptions = options.httpOptions || {};
	    var retryCount = 0;

	    var errCallback = function(err) {
	      var maxRetries = options.maxRetries || 0;
	      if (err && err.code === 'TimeoutError') err.retryable = true;

	      // Call `calculateRetryDelay()` only when relevant, see #3401
	      if (err && err.retryable && retryCount < maxRetries) {
	        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions, err);
	        if (delay >= 0) {
	          retryCount++;
	          setTimeout(sendRequest, delay + (err.retryAfter || 0));
	          return;
	        }
	      }
	      cb(err);
	    };

	    var sendRequest = function() {
	      var data = '';
	      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
	        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
	        httpResponse.on('end', function() {
	          var statusCode = httpResponse.statusCode;
	          if (statusCode < 300) {
	            cb(null, data);
	          } else {
	            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
	            var err = util.error(new Error(),
	              {
	                statusCode: statusCode,
	                retryable: statusCode >= 500 || statusCode === 429
	              }
	            );
	            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
	            errCallback(err);
	          }
	        });
	      }, errCallback);
	    };

	    AWS.util.defer(sendRequest);
	  },

	  /**
	   * @api private
	   */
	  uuid: {
	    v4: function uuidV4() {
	      return __webpack_require__(368).v4();
	    }
	  },

	  /**
	   * @api private
	   */
	  convertPayloadToString: function convertPayloadToString(resp) {
	    var req = resp.request;
	    var operation = req.operation;
	    var rules = req.service.api.operations[operation].output || {};
	    if (rules.payload && resp.data[rules.payload]) {
	      resp.data[rules.payload] = resp.data[rules.payload].toString();
	    }
	  },

	  /**
	   * @api private
	   */
	  defer: function defer(callback) {
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	      process.nextTick(callback);
	    } else if (typeof setImmediate === 'function') {
	      setImmediate(callback);
	    } else {
	      setTimeout(callback, 0);
	    }
	  },

	  /**
	   * @api private
	   */
	  getRequestPayloadShape: function getRequestPayloadShape(req) {
	    var operations = req.service.api.operations;
	    if (!operations) return undefined;
	    var operation = (operations || {})[req.operation];
	    if (!operation || !operation.input || !operation.input.payload) return undefined;
	    return operation.input.members[operation.input.payload];
	  },

	  getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
	    var profiles = {};
	    var profilesFromConfig = {};
	    if (process.env[util.configOptInEnv]) {
	      var profilesFromConfig = iniLoader.loadFrom({
	        isConfig: true,
	        filename: process.env[util.sharedConfigFileEnv]
	      });
	    }
	    var profilesFromCreds= {};
	    try {
	      var profilesFromCreds = iniLoader.loadFrom({
	        filename: filename ||
	          (process.env[util.configOptInEnv] && process.env[util.sharedCredentialsFileEnv])
	      });
	    } catch (error) {
	      // if using config, assume it is fully descriptive without a credentials file:
	      if (!process.env[util.configOptInEnv]) throw error;
	    }
	    for (var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++) {
	      profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromConfig[profileNames[i]]);
	    }
	    for (var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++) {
	      profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromCreds[profileNames[i]]);
	    }
	    return profiles;

	    /**
	     * Roughly the semantics of `Object.assign(target, source)`
	     */
	    function objectAssign(target, source) {
	      for (var i = 0, keys = Object.keys(source); i < keys.length; i++) {
	        target[keys[i]] = source[keys[i]];
	      }
	      return target;
	    }
	  },

	  /**
	   * @api private
	   */
	  ARN: {
	    validate: function validateARN(str) {
	      return str && str.indexOf('arn:') === 0 && str.split(':').length >= 6;
	    },
	    parse: function parseARN(arn) {
	      var matched = arn.split(':');
	      return {
	        partition: matched[1],
	        service: matched[2],
	        region: matched[3],
	        accountId: matched[4],
	        resource: matched.slice(5).join(':')
	      };
	    },
	    build: function buildARN(arnObject) {
	      if (
	        arnObject.service === undefined ||
	        arnObject.region === undefined ||
	        arnObject.accountId === undefined ||
	        arnObject.resource === undefined
	      ) throw util.error(new Error('Input ARN object is invalid'));
	      return 'arn:'+ (arnObject.partition || 'aws') + ':' + arnObject.service +
	        ':' + arnObject.region + ':' + arnObject.accountId + ':' + arnObject.resource;
	    }
	  },

	  /**
	   * @api private
	   */
	  defaultProfile: 'default',

	  /**
	   * @api private
	   */
	  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

	  /**
	   * @api private
	   */
	  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

	  /**
	   * @api private
	   */
	  sharedConfigFileEnv: 'AWS_CONFIG_FILE',

	  /**
	   * @api private
	   */
	  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
	};

	/**
	 * @api private
	 */
	module.exports = util;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(364).setImmediate))

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(365);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3)))

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	// use this when replacing modules with an empty replacement (needed for react-native)

	/**
	 * @api private
	 */
	module.exports = {};


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*","2019-03-26*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true,"xmlNoDefaultLists":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay","cors":true},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena","cors":true},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2","cors":true},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect","cors":true},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics","cors":true},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService","cors":true},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService","cors":true},"qldb":{"name":"QLDB"},"qldbsession":{"prefix":"qldb-session","name":"QLDBSession"},"workmailmessageflow":{"name":"WorkMailMessageFlow"},"codestarnotifications":{"prefix":"codestar-notifications","name":"CodeStarNotifications"},"savingsplans":{"name":"SavingsPlans"},"sso":{"name":"SSO"},"ssooidc":{"prefix":"sso-oidc","name":"SSOOIDC"},"marketplacecatalog":{"prefix":"marketplace-catalog","name":"MarketplaceCatalog"},"dataexchange":{"name":"DataExchange"},"sesv2":{"name":"SESV2"},"migrationhubconfig":{"prefix":"migrationhub-config","name":"MigrationHubConfig"},"connectparticipant":{"name":"ConnectParticipant"},"appconfig":{"name":"AppConfig"},"iotsecuretunneling":{"name":"IoTSecureTunneling"},"wafv2":{"name":"WAFV2"},"elasticinference":{"prefix":"elastic-inference","name":"ElasticInference"},"imagebuilder":{"name":"Imagebuilder"},"schemas":{"name":"Schemas"},"accessanalyzer":{"name":"AccessAnalyzer"},"codegurureviewer":{"prefix":"codeguru-reviewer","name":"CodeGuruReviewer"},"codeguruprofiler":{"name":"CodeGuruProfiler"},"computeoptimizer":{"prefix":"compute-optimizer","name":"ComputeOptimizer"},"frauddetector":{"name":"FraudDetector"},"kendra":{"name":"Kendra"},"networkmanager":{"name":"NetworkManager"},"outposts":{"name":"Outposts"},"augmentedairuntime":{"prefix":"sagemaker-a2i-runtime","name":"AugmentedAIRuntime"},"ebs":{"name":"EBS"},"kinesisvideosignalingchannels":{"prefix":"kinesis-video-signaling","name":"KinesisVideoSignalingChannels","cors":true},"detective":{"name":"Detective"},"codestarconnections":{"prefix":"codestar-connections","name":"CodeStarconnections"},"synthetics":{"name":"Synthetics"},"iotsitewise":{"name":"IoTSiteWise"},"macie2":{"name":"Macie2"},"codeartifact":{"name":"CodeArtifact"},"honeycode":{"name":"Honeycode"},"ivs":{"name":"IVS"},"braket":{"name":"Braket"},"identitystore":{"name":"IdentityStore"},"appflow":{"name":"Appflow"},"redshiftdata":{"prefix":"redshift-data","name":"RedshiftData"},"ssoadmin":{"prefix":"sso-admin","name":"SSOAdmin"},"timestreamquery":{"prefix":"timestream-query","name":"TimestreamQuery"},"timestreamwrite":{"prefix":"timestream-write","name":"TimestreamWrite"},"s3outposts":{"name":"S3Outposts"},"databrew":{"name":"DataBrew"},"servicecatalogappregistry":{"prefix":"servicecatalog-appregistry","name":"ServiceCatalogAppRegistry"},"networkfirewall":{"prefix":"network-firewall","name":"NetworkFirewall"},"mwaa":{"name":"MWAA"},"amplifybackend":{"name":"AmplifyBackend"},"appintegrations":{"name":"AppIntegrations"},"connectcontactlens":{"prefix":"connect-contact-lens","name":"ConnectContactLens"},"devopsguru":{"prefix":"devops-guru","name":"DevOpsGuru"},"ecrpublic":{"prefix":"ecr-public","name":"ECRPUBLIC"},"lookoutvision":{"name":"LookoutVision"},"sagemakerfeaturestoreruntime":{"prefix":"sagemaker-featurestore-runtime","name":"SageMakerFeatureStoreRuntime"},"customerprofiles":{"prefix":"customer-profiles","name":"CustomerProfiles"},"auditmanager":{"name":"AuditManager"},"emrcontainers":{"prefix":"emr-containers","name":"EMRcontainers"},"healthlake":{"name":"HealthLake"},"sagemakeredge":{"prefix":"sagemaker-edge","name":"SagemakerEdge"},"amp":{"name":"Amp"},"greengrassv2":{"name":"GreengrassV2"},"iotdeviceadvisor":{"name":"IotDeviceAdvisor"},"iotfleethub":{"name":"IoTFleetHub"},"iotwireless":{"name":"IoTWireless"},"location":{"name":"Location","cors":true},"wellarchitected":{"name":"WellArchitected"},"lexmodelsv2":{"prefix":"models.lex.v2","name":"LexModelsV2"},"lexruntimev2":{"prefix":"runtime.lex.v2","name":"LexRuntimeV2","cors":true},"fis":{"name":"Fis"},"lookoutmetrics":{"name":"LookoutMetrics"},"mgn":{"name":"Mgn"},"lookoutequipment":{"name":"LookoutEquipment"},"nimble":{"name":"Nimble"},"finspace":{"name":"Finspace"},"finspacedata":{"prefix":"finspace-data","name":"Finspacedata"},"ssmcontacts":{"prefix":"ssm-contacts","name":"SSMContacts"},"ssmincidents":{"prefix":"ssm-incidents","name":"SSMIncidents"},"applicationcostprofiler":{"name":"ApplicationCostProfiler"},"apprunner":{"name":"AppRunner"},"proton":{"name":"Proton"},"route53recoverycluster":{"prefix":"route53-recovery-cluster","name":"Route53RecoveryCluster"},"route53recoverycontrolconfig":{"prefix":"route53-recovery-control-config","name":"Route53RecoveryControlConfig"},"route53recoveryreadiness":{"prefix":"route53-recovery-readiness","name":"Route53RecoveryReadiness"},"chimesdkidentity":{"prefix":"chime-sdk-identity","name":"ChimeSDKIdentity"},"chimesdkmessaging":{"prefix":"chime-sdk-messaging","name":"ChimeSDKMessaging"},"snowdevicemanagement":{"prefix":"snow-device-management","name":"SnowDeviceManagement"},"memorydb":{"name":"MemoryDB"},"opensearch":{"name":"OpenSearch"},"kafkaconnect":{"name":"KafkaConnect"},"voiceid":{"prefix":"voice-id","name":"VoiceID"},"wisdom":{"name":"Wisdom"},"account":{"name":"Account"},"cloudcontrol":{"name":"CloudControl"},"grafana":{"name":"Grafana"},"panorama":{"name":"Panorama"},"chimesdkmeetings":{"prefix":"chime-sdk-meetings","name":"ChimeSDKMeetings"},"resiliencehub":{"name":"Resiliencehub"},"migrationhubstrategy":{"name":"MigrationHubStrategy"},"appconfigdata":{"name":"AppConfigData"},"drs":{"name":"Drs"},"migrationhubrefactorspaces":{"prefix":"migration-hub-refactor-spaces","name":"MigrationHubRefactorSpaces"},"evidently":{"name":"Evidently"},"inspector2":{"name":"Inspector2"},"rbin":{"name":"Rbin"},"rum":{"name":"RUM"},"backupgateway":{"prefix":"backup-gateway","name":"BackupGateway"},"iottwinmaker":{"name":"IoTTwinMaker"},"workspacesweb":{"prefix":"workspaces-web","name":"WorkSpacesWeb"},"amplifyuibuilder":{"name":"AmplifyUIBuilder"},"keyspaces":{"name":"Keyspaces"},"billingconductor":{"name":"Billingconductor"},"gamesparks":{"name":"GameSparks"},"pinpointsmsvoicev2":{"prefix":"pinpoint-sms-voice-v2","name":"PinpointSMSVoiceV2"},"ivschat":{"name":"Ivschat"},"chimesdkmediapipelines":{"prefix":"chime-sdk-media-pipelines","name":"ChimeSDKMediaPipelines"}}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(369);
	var v4 = __webpack_require__(423);

	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;

	module.exports = uuid;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(370);
	var bytesToUuid = __webpack_require__(422);

	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html

	var _nodeId;
	var _clockseq;

	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;

	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];

	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }

	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }

	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }

	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }

	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;

	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;

	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;

	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;

	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;

	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;

	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;

	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }

	  return buf ? buf : bytesToUuid(b);
	}

	module.exports = v1;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// Unique ID creation requires a high quality random # generator.  In node.js
	// this is pretty straight-forward - we use the crypto API.

	var crypto = __webpack_require__(371);

	module.exports = function nodeRNG() {
	  return crypto.randomBytes(16);
	};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(372)

	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}

	exports.createHash = __webpack_require__(373)

	exports.createHmac = __webpack_require__(385)

	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}

	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}

	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}

	var p = __webpack_require__(386)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(388)(exports, module.exports);

	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(371)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(8).Buffer))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(374)

	var md5 = toConstructor(__webpack_require__(382))
	var rmd160 = toConstructor(__webpack_require__(384))

	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}

	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}

	var Buffer = __webpack_require__(8).Buffer
	var Hash   = __webpack_require__(375)(Buffer)

	exports.sha1 = __webpack_require__(376)(Buffer, Hash)
	exports.sha256 = __webpack_require__(380)(Buffer, Hash)
	exports.sha512 = __webpack_require__(381)(Buffer, Hash)


/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {

	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }

	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }

	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }

	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block

	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)

	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }

	      s += ch
	      f += ch

	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s

	    return this
	  }

	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8

	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80

	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)

	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }

	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)

	    var hash = this._update(this._block) || this._hash()

	    return enc ? hash.toString(enc) : hash
	  }

	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }

	  return Hash
	}


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */

	var inherits = __webpack_require__(377).inherits

	module.exports = function (Buffer, Hash) {

	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0

	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)

	  var POOL = []

	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()

	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)

	    this._h = null
	    this.init()
	  }

	  inherits(Sha1, Hash)

	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0

	    Hash.prototype.init.call(this)
	    return this
	  }

	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {

	    var a, b, c, d, e, _a, _b, _c, _d, _e

	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e

	    var w = this._w

	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)

	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )

	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }

	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }

	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }

	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }

	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }

	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }

	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }

	  return Sha1
	}


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }

	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};


	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }

	  if (process.noDeprecation === true) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	};


	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};


	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;


	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};

	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};


	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];

	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}


	function stylizeNoColor(str, styleType) {
	  return str;
	}


	function arrayToHash(array) {
	  var hash = {};

	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });

	  return hash;
	}


	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }

	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }

	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);

	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }

	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }

	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }

	  var base = '', array = false, braces = ['{', '}'];

	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }

	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }

	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }

	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }

	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }

	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }

	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }

	  ctx.seen.push(value);

	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }

	  ctx.seen.pop();

	  return reduceToSingleString(output, base, braces);
	}


	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}


	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}


	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}


	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }

	  return name + ': ' + str;
	}


	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);

	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }

	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}


	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = __webpack_require__(378);

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}


	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];

	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}


	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};


	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(379);

	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;

	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};

	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3)))

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function isBuffer(arg) {
	  return arg instanceof Buffer;
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */

	var inherits = __webpack_require__(377).inherits

	module.exports = function (Buffer, Hash) {

	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]

	  var W = new Array(64)

	  function Sha256() {
	    this.init()

	    this._w = W //new Array(64)

	    Hash.call(this, 16*4, 14*4)
	  }

	  inherits(Sha256, Hash)

	  Sha256.prototype.init = function () {

	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0

	    this._len = this._s = 0

	    return this
	  }

	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }

	  function R (X, n) {
	    return (X >>> n);
	  }

	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }

	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }

	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }

	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }

	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }

	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }

	  Sha256.prototype._update = function(M) {

	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2

	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0

	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]

	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w

	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }

	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0

	  };

	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)

	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)

	    return H
	  }

	  return Sha256

	}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(377).inherits

	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]

	  var W = new Array(160)

	  function Sha512() {
	    this.init()
	    this._w = W

	    Hash.call(this, 128, 112)
	  }

	  inherits(Sha512, Hash)

	  Sha512.prototype.init = function () {

	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0

	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0

	    this._len = this._s = 0

	    return this
	  }

	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }

	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }

	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }

	  Sha512.prototype._update = function(M) {

	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl

	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0

	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0

	    for (var i = 0; i < 80; i++) {
	      var j = i * 2

	      var Wi, Wil

	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)

	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)

	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)

	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]

	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]

	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)

	        W[j] = Wi
	        W[j + 1] = Wil
	      }

	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)

	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)

	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]

	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)

	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)

	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)

	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }

	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0

	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }

	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)

	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }

	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)

	    return H
	  }

	  return Sha512

	}


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */

	var helpers = __webpack_require__(383);

	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;

	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;

	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;

	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);

	}

	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}

	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}

	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}

	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;

	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }

	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}

	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}

	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}

	module.exports = { hash: hash };

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160



	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];

	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];

	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};

	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};

	var processBlock = function (H, M, offset) {

	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];

	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }

	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;

	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;

	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};

	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}

	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}

	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}

	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}

	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}

	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}

	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];

	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');

	  var m = bytesToWords(message);

	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;

	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );

	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }

	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];

	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }

	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}



	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(373)

	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)

	module.exports = Hmac

	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg

	  var blocksize = (alg === 'sha512') ? 128 : 64

	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key

	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }

	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)

	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }

	  this._hash = createHash(alg).update(ipad)
	}

	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}

	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}


	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(387)

	module.exports = function (crypto, exports) {
	  exports = exports || {}

	  var exported = pbkdf2Export(crypto)

	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync

	  return exports
	}


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }

	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')

	    setTimeout(function() {
	      var result

	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }

	      callback(undefined, result)
	    })
	  }

	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')

	    if (iterations < 0)
	      throw new TypeError('Bad iterations')

	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')

	    if (keylen < 0)
	      throw new TypeError('Bad key length')

	    digest = digest || 'sha1'

	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)

	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)

	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)

	      var U = crypto.createHmac(digest, password).update(block1).digest()

	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen

	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }

	      U.copy(T, 0, 0, hLen)

	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()

	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }

	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }

	    return DK
	  }

	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(389)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(421)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(412);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};



/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(390);
	var Transform = __webpack_require__(391);
	var inherits = __webpack_require__(393);
	var modes = __webpack_require__(412);
	var ebtk = __webpack_require__(413);
	var StreamCipher = __webpack_require__(414);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};


	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};

	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);

	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(415),
	  CBC: __webpack_require__(416),
	  CFB: __webpack_require__(418),
	  OFB: __webpack_require__(419),
	  CTR: __webpack_require__(420)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}

	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}

	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};

	var G = new Global();


	AES.blockSize = 4 * 4;

	AES.prototype.blockSize = AES.blockSize;

	AES.keySize = 256 / 8;

	AES.prototype.keySize = AES.keySize;

	AES.ivSize = AES.blockSize;

	AES.prototype.ivSize = AES.ivSize;

	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}

	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};

	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};

	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};

	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};

	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;

	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];

	};




	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(392).Transform;
	var inherits = __webpack_require__(393);

	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	module.exports = Stream;

	var EE = __webpack_require__(46).EventEmitter;
	var inherits = __webpack_require__(393);

	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(394);
	Stream.Writable = __webpack_require__(408);
	Stream.Duplex = __webpack_require__(409);
	Stream.Transform = __webpack_require__(410);
	Stream.PassThrough = __webpack_require__(411);

	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;



	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.

	function Stream() {
	  EE.call(this);
	}

	Stream.prototype.pipe = function(dest, options) {
	  var source = this;

	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }

	  source.on('data', ondata);

	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }

	  dest.on('drain', ondrain);

	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }

	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    dest.end();
	  }


	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    if (typeof dest.destroy === 'function') dest.destroy();
	  }

	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }

	  source.on('error', onerror);
	  dest.on('error', onerror);

	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);

	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);

	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);

	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);

	    dest.removeListener('close', cleanup);
	  }

	  source.on('end', cleanup);
	  source.on('close', cleanup);

	  dest.on('close', cleanup);

	  dest.emit('pipe', source);

	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var Stream = __webpack_require__(392);
	if (process.env.READABLE_STREAM === 'disable' && Stream) {
	  module.exports = Stream;
	  exports = module.exports = Stream.Readable;
	  exports.Readable = Stream.Readable;
	  exports.Writable = Stream.Writable;
	  exports.Duplex = Stream.Duplex;
	  exports.Transform = Stream.Transform;
	  exports.PassThrough = Stream.PassThrough;
	  exports.Stream = Stream;
	} else {
	  exports = module.exports = __webpack_require__(395);
	  exports.Stream = Stream || exports;
	  exports.Readable = exports;
	  exports.Writable = __webpack_require__(403);
	  exports.Duplex = __webpack_require__(402);
	  exports.Transform = __webpack_require__(406);
	  exports.PassThrough = __webpack_require__(407);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(396);
	/*</replacement>*/

	module.exports = Readable;

	/*<replacement>*/
	var isArray = __webpack_require__(11);
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Readable.ReadableState = ReadableState;

	/*<replacement>*/
	var EE = __webpack_require__(46).EventEmitter;

	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = __webpack_require__(397);
	/*</replacement>*/

	/*<replacement>*/

	var Buffer = __webpack_require__(398).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*</replacement>*/

	/*<replacement>*/
	var util = Object.create(__webpack_require__(399));
	util.inherits = __webpack_require__(393);
	/*</replacement>*/

	/*<replacement>*/
	var debugUtil = __webpack_require__(377);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/

	var BufferList = __webpack_require__(400);
	var destroyImpl = __webpack_require__(401);
	var StringDecoder;

	util.inherits(Readable, Stream);

	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}

	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(402);

	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;

	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;

	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;

	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;

	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;

	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;

	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(405).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}

	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(402);

	  if (!(this instanceof Readable)) return new Readable(options);

	  this._readableState = new ReadableState(options, this);

	  // legacy
	  this.readable = true;

	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }

	  Stream.call(this);
	}

	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});

	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};

	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;

	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }

	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};

	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};

	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }

	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }

	  return needMoreData(state);
	}

	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}

	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}

	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}

	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};

	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(405).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};

	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}

	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}

	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;

	  if (n !== 0) state.emittedReadable = false;

	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }

	  n = howMuchToRead(n, state);

	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }

	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.

	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);

	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }

	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }

	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;

	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }

	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;

	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }

	  if (ret !== null) this.emit('data', ret);

	  return ret;
	};

	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;

	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}

	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}

	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}

	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}

	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}

	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};

	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;

	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }

	  function onend() {
	    debug('onend');
	    dest.end();
	  }

	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);

	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);

	    cleanedUp = true;

	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }

	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }

	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }

	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);

	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);

	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }

	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);

	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }

	  return dest;
	};

	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}

	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };

	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;

	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;

	    if (!dest) dest = state.pipes;

	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }

	  // slow case. multiple pipe destinations.

	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;

	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }

	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;

	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];

	  dest.emit('unpipe', this, unpipeInfo);

	  return this;
	};

	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);

	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }

	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;

	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}

	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};

	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}

	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }

	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}

	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};

	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}

	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;

	  var state = this._readableState;
	  var paused = false;

	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }

	    _this.push(null);
	  });

	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);

	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });

	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }

	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }

	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };

	  return this;
	};

	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});

	// exposed for testing purposes only.
	Readable._fromList = fromList;

	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;

	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }

	  return ret;
	}

	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}

	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	function endReadable(stream) {
	  var state = stream._readableState;

	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}

	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}

	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3)))

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';

	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}

	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}


	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(392);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(8)
	var Buffer = buffer.Buffer

	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}

	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}

	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)

	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}

	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}

	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}

	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.

	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = __webpack_require__(8).Buffer.isBuffer;

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Buffer = __webpack_require__(398).Buffer;
	var util = __webpack_require__(377);

	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}

	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);

	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }

	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };

	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };

	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };

	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };

	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };

	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };

	  return BufferList;
	}();

	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(396);
	/*</replacement>*/

	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;

	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;

	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }

	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks

	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }

	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }

	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });

	  return this;
	}

	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }

	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}

	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}

	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(396);
	/*</replacement>*/

	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/

	module.exports = Duplex;

	/*<replacement>*/
	var util = Object.create(__webpack_require__(399));
	util.inherits = __webpack_require__(393);
	/*</replacement>*/

	var Readable = __webpack_require__(395);
	var Writable = __webpack_require__(403);

	util.inherits(Duplex, Readable);

	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}

	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);

	  Readable.call(this, options);
	  Writable.call(this, options);

	  if (options && options.readable === false) this.readable = false;

	  if (options && options.writable === false) this.writable = false;

	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

	  this.once('end', onend);
	}

	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});

	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;

	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}

	function onEndNT(self) {
	  self.end();
	}

	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});

	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();

	  pna.nextTick(cb, err);
	};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(396);
	/*</replacement>*/

	module.exports = Writable;

	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}

	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;

	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */

	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Writable.WritableState = WritableState;

	/*<replacement>*/
	var util = Object.create(__webpack_require__(399));
	util.inherits = __webpack_require__(393);
	/*</replacement>*/

	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(404)
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = __webpack_require__(397);
	/*</replacement>*/

	/*<replacement>*/

	var Buffer = __webpack_require__(398).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*</replacement>*/

	var destroyImpl = __webpack_require__(401);

	util.inherits(Writable, Stream);

	function nop() {}

	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(402);

	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;

	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;

	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // if _final has been called
	  this.finalCalled = false;

	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;

	  // a flag to see when we're in the middle of a write.
	  this.writing = false;

	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;

	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };

	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;

	  // the amount that is being written when _write is called.
	  this.writelen = 0;

	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;

	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;

	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;

	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;

	  // count buffered requests
	  this.bufferedRequestCount = 0;

	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}

	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};

	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();

	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;

	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}

	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(402);

	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.

	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }

	  this._writableState = new WritableState(options, this);

	  // legacy.
	  this.writable = true;

	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;

	    if (typeof options.writev === 'function') this._writev = options.writev;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;

	    if (typeof options.final === 'function') this._final = options.final;
	  }

	  Stream.call(this);
	}

	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};

	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}

	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;

	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}

	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);

	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }

	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

	  if (typeof cb !== 'function') cb = nop;

	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }

	  return ret;
	};

	Writable.prototype.cork = function () {
	  var state = this._writableState;

	  state.corked++;
	};

	Writable.prototype.uncork = function () {
	  var state = this._writableState;

	  if (state.corked) {
	    state.corked--;

	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};

	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};

	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}

	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});

	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;

	  state.length += len;

	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;

	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }

	  return ret;
	}

	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}

	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;

	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}

	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}

	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;

	  onwriteStateUpdate(state);

	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);

	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }

	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}

	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}

	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}

	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;

	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;

	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;

	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;

	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }

	    if (entry === null) state.lastBufferedRequest = null;
	  }

	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}

	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};

	Writable.prototype._writev = null;

	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;

	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }

	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};

	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}

	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}

	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}

	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}

	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});

	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(364).setImmediate, (function() { return this; }())))

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */

	module.exports = deprecate;

	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */

	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	}

	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */

	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	/*<replacement>*/

	var Buffer = __webpack_require__(398).Buffer;
	/*</replacement>*/

	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};

	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};

	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}

	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}

	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};

	StringDecoder.prototype.end = utf8End;

	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;

	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};

	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}

	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}

	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}

	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}

	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}

	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}

	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}

	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}

	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}

	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}

	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}

	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.

	'use strict';

	module.exports = Transform;

	var Duplex = __webpack_require__(402);

	/*<replacement>*/
	var util = Object.create(__webpack_require__(399));
	util.inherits = __webpack_require__(393);
	/*</replacement>*/

	util.inherits(Transform, Duplex);

	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;

	  var cb = ts.writecb;

	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }

	  ts.writechunk = null;
	  ts.writecb = null;

	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);

	  cb(er);

	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}

	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);

	  Duplex.call(this, options);

	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };

	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;

	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;

	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;

	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }

	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}

	function prefinish() {
	  var _this = this;

	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}

	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};

	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};

	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};

	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;

	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};

	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;

	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};

	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);

	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);

	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

	  return stream.push(null);
	}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.

	'use strict';

	module.exports = PassThrough;

	var Transform = __webpack_require__(406);

	/*<replacement>*/
	var util = Object.create(__webpack_require__(399));
	util.inherits = __webpack_require__(393);
	/*</replacement>*/

	util.inherits(PassThrough, Transform);

	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);

	  Transform.call(this, options);
	}

	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var Stream = __webpack_require__(392)
	var Writable = __webpack_require__(403)

	if (process.env.READABLE_STREAM === 'disable') {
	  module.exports = Stream && Stream.Writable || Writable
	} else {
	  module.exports = Writable
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(394).Duplex


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(394).Transform


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(394).PassThrough


/***/ }),
/* 412 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(390);
	var Transform = __webpack_require__(391);
	var inherits = __webpack_require__(393);

	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(417);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(417);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(417);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(417);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(390);
	var Transform = __webpack_require__(391);
	var inherits = __webpack_require__(393);
	var modes = __webpack_require__(412);
	var StreamCipher = __webpack_require__(414);
	var ebtk = __webpack_require__(413);

	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }

	  this.push(unpad(this._mode.decrypt(this, chunk)));

	  next();
	};

	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};

	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}

	var modelist = {
	  ECB: __webpack_require__(415),
	  CBC: __webpack_require__(416),
	  CFB: __webpack_require__(418),
	  OFB: __webpack_require__(419),
	  CTR: __webpack_require__(420)
	};

	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }

	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8).Buffer))

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}

	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([bth[buf[i++]], bth[buf[i++]], 
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]]]).join('');
	}

	module.exports = bytesToUuid;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(370);
	var bytesToUuid = __webpack_require__(422);

	function v4(options, buf, offset) {
	  var i = buf && offset || 0;

	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};

	  var rnds = options.random || (options.rng || rng)();

	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;

	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }

	  return buf || bytesToUuid(rnds);
	}

	module.exports = v4;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

	module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"us-iso-*/*":"usIso","us-isob-*/*":"usIsob","*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":"globalSSL","cn-*/route53":{"endpoint":"{service}.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-northwest-1"},"us-gov-*/route53":"globalGovCloud","us-iso-*/route53":{"endpoint":"{service}.c2s.ic.gov","globalEndpoint":true,"signingRegion":"us-iso-east-1"},"us-isob-*/route53":{"endpoint":"{service}.sc2s.sgov.gov","globalEndpoint":true,"signingRegion":"us-isob-east-1"},"*/waf":"globalSSL","*/iam":"globalSSL","cn-*/iam":{"endpoint":"{service}.cn-north-1.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-north-1"},"us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"fipsRules":{"*/*":"fipsStandard","us-gov-*/*":"fipsStandard","us-iso-*/*":{"endpoint":"{service}-fips.{region}.c2s.ic.gov"},"us-iso-*/dms":"usIso","us-isob-*/*":{"endpoint":"{service}-fips.{region}.sc2s.sgov.gov"},"us-isob-*/dms":"usIsob","cn-*/*":{"endpoint":"{service}-fips.{region}.amazonaws.com.cn"},"*/api.ecr":"fips.api.ecr","*/api.sagemaker":"fips.api.sagemaker","*/batch":"fipsDotPrefix","*/eks":"fipsDotPrefix","*/models.lex":"fips.models.lex","*/runtime.lex":"fips.runtime.lex","*/runtime.sagemaker":{"endpoint":"runtime-fips.sagemaker.{region}.amazonaws.com"},"*/iam":"fipsWithoutRegion","*/route53":"fipsWithoutRegion","*/transcribe":"fipsDotPrefix","*/waf":"fipsWithoutRegion","us-gov-*/transcribe":"fipsDotPrefix","us-gov-*/api.ecr":"fips.api.ecr","us-gov-*/api.sagemaker":"fips.api.sagemaker","us-gov-*/models.lex":"fips.models.lex","us-gov-*/runtime.lex":"fips.runtime.lex","us-gov-*/acm-pca":"fipsWithServiceOnly","us-gov-*/batch":"fipsWithServiceOnly","us-gov-*/config":"fipsWithServiceOnly","us-gov-*/eks":"fipsWithServiceOnly","us-gov-*/elasticmapreduce":"fipsWithServiceOnly","us-gov-*/identitystore":"fipsWithServiceOnly","us-gov-*/dynamodb":"fipsWithServiceOnly","us-gov-*/elasticloadbalancing":"fipsWithServiceOnly","us-gov-*/guardduty":"fipsWithServiceOnly","us-gov-*/monitoring":"fipsWithServiceOnly","us-gov-*/resource-groups":"fipsWithServiceOnly","us-gov-*/runtime.sagemaker":"fipsWithServiceOnly","us-gov-*/servicecatalog-appregistry":"fipsWithServiceOnly","us-gov-*/servicequotas":"fipsWithServiceOnly","us-gov-*/ssm":"fipsWithServiceOnly","us-gov-*/sts":"fipsWithServiceOnly","us-gov-*/support":"fipsWithServiceOnly","us-gov-west-1/states":"fipsWithServiceOnly","us-iso-east-1/elasticfilesystem":{"endpoint":"elasticfilesystem-fips.{region}.c2s.ic.gov"},"us-gov-west-1/organizations":"fipsWithServiceOnly","us-gov-west-1/route53":{"endpoint":"route53.us-gov.amazonaws.com"}},"dualstackRules":{"*/*":{"endpoint":"{service}.{region}.api.aws"},"cn-*/*":{"endpoint":"{service}.{region}.api.amazonwebservices.com.cn"},"*/s3":"dualstackLegacy","cn-*/s3":"dualstackLegacyCn","*/s3-control":"dualstackLegacy","cn-*/s3-control":"dualstackLegacyCn","ap-south-1/ec2":"dualstackLegacyEc2","eu-west-1/ec2":"dualstackLegacyEc2","sa-east-1/ec2":"dualstackLegacyEc2","us-east-1/ec2":"dualstackLegacyEc2","us-east-2/ec2":"dualstackLegacyEc2","us-west-2/ec2":"dualstackLegacyEc2"},"dualstackFipsRules":{"*/*":{"endpoint":"{service}-fips.{region}.api.aws"},"cn-*/*":{"endpoint":"{service}-fips.{region}.api.amazonwebservices.com.cn"},"*/s3":"dualstackFipsLegacy","cn-*/s3":"dualstackFipsLegacyCn","*/s3-control":"dualstackFipsLegacy","cn-*/s3-control":"dualstackFipsLegacyCn"},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true,"signingRegion":"us-east-1"},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com","globalEndpoint":true,"signingRegion":"us-gov-west-1"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"},"usIso":{"endpoint":"{service}.{region}.c2s.ic.gov"},"usIsob":{"endpoint":"{service}.{region}.sc2s.sgov.gov"},"fipsStandard":{"endpoint":"{service}-fips.{region}.amazonaws.com"},"fipsDotPrefix":{"endpoint":"fips.{service}.{region}.amazonaws.com"},"fipsWithoutRegion":{"endpoint":"{service}-fips.amazonaws.com"},"fips.api.ecr":{"endpoint":"ecr-fips.{region}.amazonaws.com"},"fips.api.sagemaker":{"endpoint":"api-fips.sagemaker.{region}.amazonaws.com"},"fips.models.lex":{"endpoint":"models-fips.lex.{region}.amazonaws.com"},"fips.runtime.lex":{"endpoint":"runtime-fips.lex.{region}.amazonaws.com"},"fipsWithServiceOnly":{"endpoint":"{service}.{region}.amazonaws.com"},"dualstackLegacy":{"endpoint":"{service}.dualstack.{region}.amazonaws.com"},"dualstackLegacyCn":{"endpoint":"{service}.dualstack.{region}.amazonaws.com.cn"},"dualstackFipsLegacy":{"endpoint":"{service}-fips.dualstack.{region}.amazonaws.com"},"dualstackFipsLegacyCn":{"endpoint":"{service}-fips.dualstack.{region}.amazonaws.com.cn"},"dualstackLegacyEc2":{"endpoint":"api.ec2.{region}.aws"}}}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var byteLength = AWS.util.string.byteLength;
	var Buffer = AWS.util.Buffer;

	/**
	 * The managed uploader allows for easy and efficient uploading of buffers,
	 * blobs, or streams, using a configurable amount of concurrency to perform
	 * multipart uploads where possible. This abstraction also enables uploading
	 * streams of unknown size due to the use of multipart uploads.
	 *
	 * To construct a managed upload object, see the {constructor} function.
	 *
	 * ## Tracking upload progress
	 *
	 * The managed upload object can also track progress by attaching an
	 * 'httpUploadProgress' listener to the upload manager. This event is similar
	 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
	 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
	 * information.
	 *
	 * ## Handling Multipart Cleanup
	 *
	 * By default, this class will automatically clean up any multipart uploads
	 * when an individual part upload fails. This behavior can be disabled in order
	 * to manually handle failures by setting the `leavePartsOnError` configuration
	 * option to `true` when initializing the upload object.
	 *
	 * @!event httpUploadProgress(progress)
	 *   Triggered when the uploader has uploaded more data.
	 *   @note The `total` property may not be set if the stream being uploaded has
	 *     not yet finished chunking. In this case the `total` will be undefined
	 *     until the total stream size is known.
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
	 *     size is known.
	 *   @context (see AWS.Request~send)
	 */
	AWS.S3.ManagedUpload = AWS.util.inherit({
	  /**
	   * Creates a managed upload object with a set of configuration options.
	   *
	   * @note A "Body" parameter is required to be set prior to calling {send}.
	   * @note In Node.js, sending "Body" as {https://nodejs.org/dist/latest/docs/api/stream.html#stream_object_mode object-mode stream}
	   *   may result in upload hangs. Using buffer stream is preferable.
	   * @option options params [map] a map of parameters to pass to the upload
	   *   requests. The "Body" parameter is required to be specified either on
	   *   the service or in the params option.
	   * @note ContentMD5 should not be provided when using the managed upload object.
	   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
	   *   by the managed upload object.
	   * @option options queueSize [Number] (4) the size of the concurrent queue
	   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
	   *   of parts. Note that the uploader will buffer at most queueSize * partSize
	   *   bytes into memory at any given time.
	   * @option options partSize [Number] (5mb) the size in bytes for each
	   *   individual part to be uploaded. Adjust the part size to ensure the number
	   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
	   *   minimum allowed part size.
	   * @option options leavePartsOnError [Boolean] (false) whether to abort the
	   *   multipart upload if an error occurs. Set to true if you want to handle
	   *   failures manually.
	   * @option options service [AWS.S3] an optional S3 service object to use for
	   *   requests. This object might have bound parameters used by the uploader.
	   * @option options tags [Array<map>] The tags to apply to the uploaded object.
	   *   Each tag should have a `Key` and `Value` keys.
	   * @example Creating a default uploader for a stream object
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     partSize: 10 * 1024 * 1024, queueSize: 1,
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with tags
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
	   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
	   *   });
	   * @see send
	   */
	  constructor: function ManagedUpload(options) {
	    var self = this;
	    AWS.SequentialExecutor.call(self);
	    self.body = null;
	    self.sliceFn = null;
	    self.callback = null;
	    self.parts = {};
	    self.completeInfo = [];
	    self.fillQueue = function() {
	      self.callback(new Error('Unsupported body payload ' + typeof self.body));
	    };

	    self.configure(options);
	  },

	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    options = options || {};
	    this.partSize = this.minPartSize;

	    if (options.queueSize) this.queueSize = options.queueSize;
	    if (options.partSize) this.partSize = options.partSize;
	    if (options.leavePartsOnError) this.leavePartsOnError = true;
	    if (options.tags) {
	      if (!Array.isArray(options.tags)) {
	        throw new Error('Tags must be specified as an array; ' +
	          typeof options.tags + ' provided.');
	      }
	      this.tags = options.tags;
	    }

	    if (this.partSize < this.minPartSize) {
	      throw new Error('partSize must be greater than ' +
	                      this.minPartSize);
	    }

	    this.service = options.service;
	    this.bindServiceObject(options.params);
	    this.validateBody();
	    this.adjustTotalBytes();
	  },

	  /**
	   * @api private
	   */
	  leavePartsOnError: false,

	  /**
	   * @api private
	   */
	  queueSize: 4,

	  /**
	   * @api private
	   */
	  partSize: null,

	  /**
	   * @readonly
	   * @return [Number] the minimum number of bytes for an individual part
	   *   upload.
	   */
	  minPartSize: 1024 * 1024 * 5,

	  /**
	   * @readonly
	   * @return [Number] the maximum allowed number of parts in a multipart upload.
	   */
	  maxTotalParts: 10000,

	  /**
	   * Initiates the managed upload for the payload.
	   *
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *     * `Location` (String) the URL of the uploaded object
	   *     * `ETag` (String) the ETag of the uploaded object
	   *     * `Bucket` (String) the bucket to which the object was uploaded
	   *     * `Key` (String) the key to which the object was uploaded
	   * @example Sending a managed upload object
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *   var upload = new AWS.S3.ManagedUpload({params: params});
	   *   upload.send(function(err, data) {
	   *     console.log(err, data);
	   *   });
	   */
	  send: function(callback) {
	    var self = this;
	    self.failed = false;
	    self.callback = callback || function(err) { if (err) throw err; };

	    var runFill = true;
	    if (self.sliceFn) {
	      self.fillQueue = self.fillBuffer;
	    } else if (AWS.util.isNode()) {
	      var Stream = AWS.util.stream.Stream;
	      if (self.body instanceof Stream) {
	        runFill = false;
	        self.fillQueue = self.fillStream;
	        self.partBuffers = [];
	        self.body.
	          on('error', function(err) { self.cleanup(err); }).
	          on('readable', function() { self.fillQueue(); }).
	          on('end', function() {
	            self.isDoneChunking = true;
	            self.numParts = self.totalPartNumbers;
	            self.fillQueue.call(self);

	            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
	              self.finishMultiPart();
	            }
	          });
	      }
	    }

	    if (runFill) self.fillQueue.call(self);
	  },

	  /**
	   * @!method  promise()
	   *   Returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [map] The response data from the successful upload:
	   *       `Location` (String) the URL of the uploaded object
	   *       `ETag` (String) the ETag of the uploaded object
	   *       `Bucket` (String) the bucket to which the object was uploaded
	   *       `Key` (String) the key to which the object was uploaded
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] an error or null if no error occurred.
	   *   @return [Promise] A promise that represents the state of the upload request.
	   *   @example Sending an upload request using promises.
	   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
	   *     var promise = upload.promise();
	   *     promise.then(function(data) { ... }, function(err) { ... });
	   */

	  /**
	   * Aborts a managed upload, including all concurrent upload requests.
	   * @note By default, calling this function will cleanup a multipart upload
	   *   if one was created. To leave the multipart upload around after aborting
	   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
	   * @note Calling {abort} in the browser environment will not abort any requests
	   *   that are already in flight. If a multipart upload was created, any parts
	   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
	   * @example Aborting an upload
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 25) // 25MB payload
	   *   };
	   *   var upload = s3.upload(params);
	   *   upload.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(upload.abort.bind(upload), 1000);
	   */
	  abort: function() {
	    var self = this;
	    //abort putObject request
	    if (self.isDoneChunking === true && self.totalPartNumbers === 1 && self.singlePart) {
	      self.singlePart.abort();
	    } else {
	      self.cleanup(AWS.util.error(new Error('Request aborted by user'), {
	        code: 'RequestAbortedError', retryable: false
	      }));
	    }
	  },

	  /**
	   * @api private
	   */
	  validateBody: function validateBody() {
	    var self = this;
	    self.body = self.service.config.params.Body;
	    if (typeof self.body === 'string') {
	      self.body = AWS.util.buffer.toBuffer(self.body);
	    } else if (!self.body) {
	      throw new Error('params.Body is required');
	    }
	    self.sliceFn = AWS.util.arraySliceFn(self.body);
	  },

	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(params) {
	    params = params || {};
	    var self = this;
	    // bind parameters to new service object
	    if (!self.service) {
	      self.service = new AWS.S3({params: params});
	    } else {
	      // Create a new S3 client from the supplied client's constructor.
	      var service = self.service;
	      var config = AWS.util.copy(service.config);
	      config.signatureVersion = service.getSignatureVersion();
	      self.service = new service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, params);
	      Object.defineProperty(self.service, '_originalConfig', {
	        get: function() { return service._originalConfig; },
	        enumerable: false,
	        configurable: true
	      });
	    }
	  },

	  /**
	   * @api private
	   */
	  adjustTotalBytes: function adjustTotalBytes() {
	    var self = this;
	    try { // try to get totalBytes
	      self.totalBytes = byteLength(self.body);
	    } catch (e) { }

	    // try to adjust partSize if we know payload length
	    if (self.totalBytes) {
	      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
	      if (newPartSize > self.partSize) self.partSize = newPartSize;
	    } else {
	      self.totalBytes = undefined;
	    }
	  },

	  /**
	   * @api private
	   */
	  isDoneChunking: false,

	  /**
	   * @api private
	   */
	  partPos: 0,

	  /**
	   * @api private
	   */
	  totalChunkedBytes: 0,

	  /**
	   * @api private
	   */
	  totalUploadedBytes: 0,

	  /**
	   * @api private
	   */
	  totalBytes: undefined,

	  /**
	   * @api private
	   */
	  numParts: 0,

	  /**
	   * @api private
	   */
	  totalPartNumbers: 0,

	  /**
	   * @api private
	   */
	  activeParts: 0,

	  /**
	   * @api private
	   */
	  doneParts: 0,

	  /**
	   * @api private
	   */
	  parts: null,

	  /**
	   * @api private
	   */
	  completeInfo: null,

	  /**
	   * @api private
	   */
	  failed: false,

	  /**
	   * @api private
	   */
	  multipartReq: null,

	  /**
	   * @api private
	   */
	  partBuffers: null,

	  /**
	   * @api private
	   */
	  partBufferLength: 0,

	  /**
	   * @api private
	   */
	  fillBuffer: function fillBuffer() {
	    var self = this;
	    var bodyLen = byteLength(self.body);

	    if (bodyLen === 0) {
	      self.isDoneChunking = true;
	      self.numParts = 1;
	      self.nextChunk(self.body);
	      return;
	    }

	    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
	      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
	      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
	      self.partPos += self.partSize;

	      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
	        self.isDoneChunking = true;
	        self.numParts = self.totalPartNumbers + 1;
	      }
	      self.nextChunk(buf);
	    }
	  },

	  /**
	   * @api private
	   */
	  fillStream: function fillStream() {
	    var self = this;
	    if (self.activeParts >= self.queueSize) return;

	    var buf = self.body.read(self.partSize - self.partBufferLength) ||
	              self.body.read();
	    if (buf) {
	      self.partBuffers.push(buf);
	      self.partBufferLength += buf.length;
	      self.totalChunkedBytes += buf.length;
	    }

	    if (self.partBufferLength >= self.partSize) {
	      // if we have single buffer we avoid copyfull concat
	      var pbuf = self.partBuffers.length === 1 ?
	        self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;

	      // if we have more than partSize, push the rest back on the queue
	      if (pbuf.length > self.partSize) {
	        var rest = pbuf.slice(self.partSize);
	        self.partBuffers.push(rest);
	        self.partBufferLength += rest.length;
	        pbuf = pbuf.slice(0, self.partSize);
	      }

	      self.nextChunk(pbuf);
	    }

	    if (self.isDoneChunking && !self.isDoneSending) {
	      // if we have single buffer we avoid copyfull concat
	      pbuf = self.partBuffers.length === 1 ?
	          self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	      self.totalBytes = self.totalChunkedBytes;
	      self.isDoneSending = true;

	      if (self.numParts === 0 || pbuf.length > 0) {
	        self.numParts++;
	        self.nextChunk(pbuf);
	      }
	    }

	    self.body.read(0);
	  },

	  /**
	   * @api private
	   */
	  nextChunk: function nextChunk(chunk) {
	    var self = this;
	    if (self.failed) return null;

	    var partNumber = ++self.totalPartNumbers;
	    if (self.isDoneChunking && partNumber === 1) {
	      var params = {Body: chunk};
	      if (this.tags) {
	        params.Tagging = this.getTaggingHeader();
	      }
	      var req = self.service.putObject(params);
	      req._managedUpload = self;
	      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
	      self.singlePart = req; //save the single part request
	      return null;
	    } else if (self.service.config.params.ContentMD5) {
	      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
	        code: 'InvalidDigest', retryable: false
	      });

	      self.cleanup(err);
	      return null;
	    }

	    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
	      return null; // Already uploaded this part.
	    }

	    self.activeParts++;
	    if (!self.service.config.params.UploadId) {

	      if (!self.multipartReq) { // create multipart
	        self.multipartReq = self.service.createMultipartUpload();
	        self.multipartReq.on('success', function(resp) {
	          self.service.config.params.UploadId = resp.data.UploadId;
	          self.multipartReq = null;
	        });
	        self.queueChunks(chunk, partNumber);
	        self.multipartReq.on('error', function(err) {
	          self.cleanup(err);
	        });
	        self.multipartReq.send();
	      } else {
	        self.queueChunks(chunk, partNumber);
	      }
	    } else { // multipart is created, just send
	      self.uploadPart(chunk, partNumber);
	    }
	  },

	  /**
	   * @api private
	   */
	  getTaggingHeader: function getTaggingHeader() {
	    var kvPairStrings = [];
	    for (var i = 0; i < this.tags.length; i++) {
	      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
	        AWS.util.uriEscape(this.tags[i].Value));
	    }

	    return kvPairStrings.join('&');
	  },

	  /**
	   * @api private
	   */
	  uploadPart: function uploadPart(chunk, partNumber) {
	    var self = this;

	    var partParams = {
	      Body: chunk,
	      ContentLength: AWS.util.string.byteLength(chunk),
	      PartNumber: partNumber
	    };

	    var partInfo = {ETag: null, PartNumber: partNumber};
	    self.completeInfo[partNumber] = partInfo;

	    var req = self.service.uploadPart(partParams);
	    self.parts[partNumber] = req;
	    req._lastUploadedBytes = 0;
	    req._managedUpload = self;
	    req.on('httpUploadProgress', self.progress);
	    req.send(function(err, data) {
	      delete self.parts[partParams.PartNumber];
	      self.activeParts--;

	      if (!err && (!data || !data.ETag)) {
	        var message = 'No access to ETag property on response.';
	        if (AWS.util.isBrowser()) {
	          message += ' Check CORS configuration to expose ETag header.';
	        }

	        err = AWS.util.error(new Error(message), {
	          code: 'ETagMissing', retryable: false
	        });
	      }
	      if (err) return self.cleanup(err);
	      //prevent sending part being returned twice (https://github.com/aws/aws-sdk-js/issues/2304)
	      if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) return null;
	      partInfo.ETag = data.ETag;
	      self.doneParts++;
	      if (self.isDoneChunking && self.doneParts === self.numParts) {
	        self.finishMultiPart();
	      } else {
	        self.fillQueue.call(self);
	      }
	    });
	  },

	  /**
	   * @api private
	   */
	  queueChunks: function queueChunks(chunk, partNumber) {
	    var self = this;
	    self.multipartReq.on('success', function() {
	      self.uploadPart(chunk, partNumber);
	    });
	  },

	  /**
	   * @api private
	   */
	  cleanup: function cleanup(err) {
	    var self = this;
	    if (self.failed) return;

	    // clean up stream
	    if (typeof self.body.removeAllListeners === 'function' &&
	        typeof self.body.resume === 'function') {
	      self.body.removeAllListeners('readable');
	      self.body.removeAllListeners('end');
	      self.body.resume();
	    }

	    // cleanup multipartReq listeners
	    if (self.multipartReq) {
	      self.multipartReq.removeAllListeners('success');
	      self.multipartReq.removeAllListeners('error');
	      self.multipartReq.removeAllListeners('complete');
	      delete self.multipartReq;
	    }

	    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
	      self.service.abortMultipartUpload().send();
	    } else if (self.leavePartsOnError) {
	      self.isDoneChunking = false;
	    }

	    AWS.util.each(self.parts, function(partNumber, part) {
	      part.removeAllListeners('complete');
	      part.abort();
	    });

	    self.activeParts = 0;
	    self.partPos = 0;
	    self.numParts = 0;
	    self.totalPartNumbers = 0;
	    self.parts = {};
	    self.failed = true;
	    self.callback(err);
	  },

	  /**
	   * @api private
	   */
	  finishMultiPart: function finishMultiPart() {
	    var self = this;
	    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
	    self.service.completeMultipartUpload(completeParams, function(err, data) {
	      if (err) {
	        return self.cleanup(err);
	      }

	      if (data && typeof data.Location === 'string') {
	        data.Location = data.Location.replace(/%2F/g, '/');
	      }

	      if (Array.isArray(self.tags)) {
	        for (var i = 0; i < self.tags.length; i++) {
	          self.tags[i].Value = String(self.tags[i].Value);
	        }
	        self.service.putObjectTagging(
	          {Tagging: {TagSet: self.tags}},
	          function(e, d) {
	            if (e) {
	              self.callback(e);
	            } else {
	              self.callback(e, data);
	            }
	          }
	        );
	      } else {
	        self.callback(err, data);
	      }
	    });
	  },

	  /**
	   * @api private
	   */
	  finishSinglePart: function finishSinglePart(err, data) {
	    var upload = this.request._managedUpload;
	    var httpReq = this.request.httpRequest;
	    var endpoint = httpReq.endpoint;
	    if (err) return upload.callback(err);
	    data.Location =
	      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
	    data.key = this.request.params.Key; // will stay undocumented
	    data.Key = this.request.params.Key;
	    data.Bucket = this.request.params.Bucket;
	    upload.callback(err, data);
	  },

	  /**
	   * @api private
	   */
	  progress: function progress(info) {
	    var upload = this._managedUpload;
	    if (this.operation === 'putObject') {
	      info.part = 1;
	      info.key = this.params.Key;
	    } else {
	      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
	      this._lastUploadedBytes = info.loaded;
	      info = {
	        loaded: upload.totalUploadedBytes,
	        total: upload.totalBytes,
	        part: this.params.PartNumber,
	        key: this.params.Key
	      };
	    }
	    upload.emit('httpUploadProgress', [info]);
	  }
	});

	AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);

	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
	};

	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};

	AWS.util.addPromises(AWS.S3.ManagedUpload);

	/**
	 * @api private
	 */
	module.exports = AWS.S3.ManagedUpload;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2006-03-01","checksumFormat":"md5","endpointPrefix":"s3","globalEndpoint":"s3.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Amazon S3","serviceFullName":"Amazon Simple Storage Service","serviceId":"S3","signatureVersion":"s3","uid":"s3-2006-03-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MultipartUpload":{"locationName":"CompleteMultipartUpload","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"ETag":{},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{},"PartNumber":{"type":"integer"}}},"flattened":true}}},"UploadId":{"location":"querystring","locationName":"uploadId"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"}},"payload":"MultipartUpload"},"output":{"type":"structure","members":{"Location":{},"Bucket":{},"Key":{},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CopyObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-checksum-algorithm"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"MetadataDirective":{"location":"header","locationName":"x-amz-metadata-directive"},"TaggingDirective":{"location":"header","locationName":"x-amz-tagging-directive"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1k","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ExpectedSourceBucketOwner":{"location":"header","locationName":"x-amz-source-expected-bucket-owner"}}},"output":{"type":"structure","members":{"CopyObjectResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyObjectResult"},"alias":"PutObjectCopy"},"CreateBucket":{"http":{"method":"PUT","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LocationConstraint":{}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ObjectLockEnabledForBucket":{"location":"header","locationName":"x-amz-bucket-object-lock-enabled","type":"boolean"},"ObjectOwnership":{"location":"header","locationName":"x-amz-object-ownership"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"}}},"alias":"PutBucket"},"CreateMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}?uploads"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-checksum-algorithm"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{"locationName":"Bucket"},"Key":{},"UploadId":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-checksum-algorithm"}}},"alias":"InitiateMultipartUpload"},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/{Bucket}","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketAnalyticsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?analytics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketCors":{"http":{"method":"DELETE","requestUri":"/{Bucket}?cors","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketEncryption":{"http":{"method":"DELETE","requestUri":"/{Bucket}?encryption","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketIntelligentTieringConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?intelligent-tiering","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketInventoryConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?inventory","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketLifecycle":{"http":{"method":"DELETE","requestUri":"/{Bucket}?lifecycle","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketMetricsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?metrics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketOwnershipControls":{"http":{"method":"DELETE","requestUri":"/{Bucket}?ownershipControls","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/{Bucket}?policy","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketReplication":{"http":{"method":"DELETE","requestUri":"/{Bucket}?replication","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteBucketWebsite":{"http":{"method":"DELETE","requestUri":"/{Bucket}?website","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"DeleteObjectTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"DeleteObjects":{"http":{"requestUri":"/{Bucket}?delete"},"input":{"type":"structure","required":["Bucket","Delete"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delete":{"locationName":"Delete","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Objects"],"members":{"Objects":{"locationName":"Object","type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"VersionId":{}}},"flattened":true},"Quiet":{"type":"boolean"}}},"MFA":{"location":"header","locationName":"x-amz-mfa"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"}},"payload":"Delete"},"output":{"type":"structure","members":{"Deleted":{"type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"DeleteMarker":{"type":"boolean"},"DeleteMarkerVersionId":{}}},"flattened":true},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"Errors":{"locationName":"Error","type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"Code":{},"Message":{}}},"flattened":true}}},"alias":"DeleteMultipleObjects","httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"DeletePublicAccessBlock":{"http":{"method":"DELETE","requestUri":"/{Bucket}?publicAccessBlock","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"GetBucketAccelerateConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Status":{}}}},"GetBucketAcl":{"http":{"method":"GET","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S3d"},"Grants":{"shape":"S3g","locationName":"AccessControlList"}}}},"GetBucketAnalyticsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"AnalyticsConfiguration":{"shape":"S3p"}},"payload":"AnalyticsConfiguration"}},"GetBucketCors":{"http":{"method":"GET","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"CORSRules":{"shape":"S44","locationName":"CORSRule"}}}},"GetBucketEncryption":{"http":{"method":"GET","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ServerSideEncryptionConfiguration":{"shape":"S4h"}},"payload":"ServerSideEncryptionConfiguration"}},"GetBucketIntelligentTieringConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?intelligent-tiering"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"IntelligentTieringConfiguration":{"shape":"S4n"}},"payload":"IntelligentTieringConfiguration"}},"GetBucketInventoryConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"InventoryConfiguration":{"shape":"S4x"}},"payload":"InventoryConfiguration"}},"GetBucketLifecycle":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S5d","locationName":"Rule"}}},"deprecated":true},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S5t","locationName":"Rule"}}}},"GetBucketLocation":{"http":{"method":"GET","requestUri":"/{Bucket}?location"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"LocationConstraint":{}}}},"GetBucketLogging":{"http":{"method":"GET","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"LoggingEnabled":{"shape":"S65"}}}},"GetBucketMetricsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"MetricsConfiguration":{"shape":"S6d"}},"payload":"MetricsConfiguration"}},"GetBucketNotification":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S6h"},"output":{"shape":"S6i"},"deprecated":true},"GetBucketNotificationConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S6h"},"output":{"shape":"S6t"}},"GetBucketOwnershipControls":{"http":{"method":"GET","requestUri":"/{Bucket}?ownershipControls"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"OwnershipControls":{"shape":"S7a"}},"payload":"OwnershipControls"}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Policy":{}},"payload":"Policy"}},"GetBucketPolicyStatus":{"http":{"method":"GET","requestUri":"/{Bucket}?policyStatus"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"PolicyStatus":{"type":"structure","members":{"IsPublic":{"locationName":"IsPublic","type":"boolean"}}}},"payload":"PolicyStatus"}},"GetBucketReplication":{"http":{"method":"GET","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ReplicationConfiguration":{"shape":"S7m"}},"payload":"ReplicationConfiguration"}},"GetBucketRequestPayment":{"http":{"method":"GET","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Payer":{}}}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3v"}}}},"GetBucketVersioning":{"http":{"method":"GET","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Status":{},"MFADelete":{"locationName":"MfaDelete"}}}},"GetBucketWebsite":{"http":{"method":"GET","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"RedirectAllRequestsTo":{"shape":"S8p"},"IndexDocument":{"shape":"S8s"},"ErrorDocument":{"shape":"S8u"},"RoutingRules":{"shape":"S8v"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"ResponseCacheControl":{"location":"querystring","locationName":"response-cache-control"},"ResponseContentDisposition":{"location":"querystring","locationName":"response-content-disposition"},"ResponseContentEncoding":{"location":"querystring","locationName":"response-content-encoding"},"ResponseContentLanguage":{"location":"querystring","locationName":"response-content-language"},"ResponseContentType":{"location":"querystring","locationName":"response-content-type"},"ResponseExpires":{"location":"querystring","locationName":"response-expires","type":"timestamp","timestampFormat":"rfc822"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumMode":{"location":"header","locationName":"x-amz-checksum-mode"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"TagCount":{"location":"header","locationName":"x-amz-tagging-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}},"payload":"Body"},"httpChecksum":{"requestValidationModeMember":"ChecksumMode","responseAlgorithms":["CRC32","CRC32C","SHA256","SHA1"]}},"GetObjectAcl":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S3d"},"Grants":{"shape":"S3g","locationName":"AccessControlList"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"GetObjectAttributes":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?attributes"},"input":{"type":"structure","required":["Bucket","Key","ObjectAttributes"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"MaxParts":{"location":"header","locationName":"x-amz-max-parts","type":"integer"},"PartNumberMarker":{"location":"header","locationName":"x-amz-part-number-marker","type":"integer"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ObjectAttributes":{"location":"header","locationName":"x-amz-object-attributes","type":"list","member":{}}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ETag":{},"Checksum":{"type":"structure","members":{"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"ObjectParts":{"type":"structure","members":{"TotalPartsCount":{"locationName":"PartsCount","type":"integer"},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"Size":{"type":"integer"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"flattened":true}}},"StorageClass":{},"ObjectSize":{"type":"long"}}}},"GetObjectLegalHold":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"LegalHold":{"shape":"Sa9"}},"payload":"LegalHold"}},"GetObjectLockConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ObjectLockConfiguration":{"shape":"Sac"}},"payload":"ObjectLockConfiguration"}},"GetObjectRetention":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Retention":{"shape":"Sak"}},"payload":"Retention"}},"GetObjectTagging":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","required":["TagSet"],"members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"},"TagSet":{"shape":"S3v"}}}},"GetObjectTorrent":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?torrent"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"Body"}},"GetPublicAccessBlock":{"http":{"method":"GET","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"PublicAccessBlockConfiguration":{"shape":"Sar"}},"payload":"PublicAccessBlockConfiguration"}},"HeadBucket":{"http":{"method":"HEAD","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}}},"HeadObject":{"http":{"method":"HEAD","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumMode":{"location":"header","locationName":"x-amz-checksum-mode"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"ArchiveStatus":{"location":"header","locationName":"x-amz-archive-status"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}}},"ListBucketAnalyticsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"AnalyticsConfigurationList":{"locationName":"AnalyticsConfiguration","type":"list","member":{"shape":"S3p"},"flattened":true}}}},"ListBucketIntelligentTieringConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?intelligent-tiering"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"IntelligentTieringConfigurationList":{"locationName":"IntelligentTieringConfiguration","type":"list","member":{"shape":"S4n"},"flattened":true}}}},"ListBucketInventoryConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ContinuationToken":{},"InventoryConfigurationList":{"locationName":"InventoryConfiguration","type":"list","member":{"shape":"S4x"},"flattened":true},"IsTruncated":{"type":"boolean"},"NextContinuationToken":{}}}},"ListBucketMetricsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"MetricsConfigurationList":{"locationName":"MetricsConfiguration","type":"list","member":{"shape":"S6d"},"flattened":true}}}},"ListBuckets":{"http":{"method":"GET"},"output":{"type":"structure","members":{"Buckets":{"type":"list","member":{"locationName":"Bucket","type":"structure","members":{"Name":{},"CreationDate":{"type":"timestamp"}}}},"Owner":{"shape":"S3d"}}},"alias":"GetService"},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{Bucket}?uploads"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxUploads":{"location":"querystring","locationName":"max-uploads","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"UploadIdMarker":{"location":"querystring","locationName":"upload-id-marker"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Bucket":{},"KeyMarker":{},"UploadIdMarker":{},"NextKeyMarker":{},"Prefix":{},"Delimiter":{},"NextUploadIdMarker":{},"MaxUploads":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Uploads":{"locationName":"Upload","type":"list","member":{"type":"structure","members":{"UploadId":{},"Key":{},"Initiated":{"type":"timestamp"},"StorageClass":{},"Owner":{"shape":"S3d"},"Initiator":{"shape":"Sbr"},"ChecksumAlgorithm":{}}},"flattened":true},"CommonPrefixes":{"shape":"Sbs"},"EncodingType":{}}}},"ListObjectVersions":{"http":{"method":"GET","requestUri":"/{Bucket}?versions"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"VersionIdMarker":{"location":"querystring","locationName":"version-id-marker"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"KeyMarker":{},"VersionIdMarker":{},"NextKeyMarker":{},"NextVersionIdMarker":{},"Versions":{"locationName":"Version","type":"list","member":{"type":"structure","members":{"ETag":{},"ChecksumAlgorithm":{"shape":"Sc1"},"Size":{"type":"integer"},"StorageClass":{},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"},"Owner":{"shape":"S3d"}}},"flattened":true},"DeleteMarkers":{"locationName":"DeleteMarker","type":"list","member":{"type":"structure","members":{"Owner":{"shape":"S3d"},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"}}},"flattened":true},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sbs"},"EncodingType":{}}},"alias":"GetBucketObjectVersions"},"ListObjects":{"http":{"method":"GET","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"Marker":{"location":"querystring","locationName":"marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{},"Contents":{"shape":"Sca"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sbs"},"EncodingType":{}}},"alias":"GetBucket"},"ListObjectsV2":{"http":{"method":"GET","requestUri":"/{Bucket}?list-type=2"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"FetchOwner":{"location":"querystring","locationName":"fetch-owner","type":"boolean"},"StartAfter":{"location":"querystring","locationName":"start-after"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Contents":{"shape":"Sca"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sbs"},"EncodingType":{},"KeyCount":{"type":"integer"},"ContinuationToken":{},"NextContinuationToken":{},"StartAfter":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MaxParts":{"location":"querystring","locationName":"max-parts","type":"integer"},"PartNumberMarker":{"location":"querystring","locationName":"part-number-marker","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{},"Key":{},"UploadId":{},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"flattened":true},"Initiator":{"shape":"Sbr"},"Owner":{"shape":"S3d"},"StorageClass":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ChecksumAlgorithm":{}}}},"PutBucketAccelerateConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket","AccelerateConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"AccelerateConfiguration":{"locationName":"AccelerateConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Status":{}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"}},"payload":"AccelerateConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"PutBucketAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Scp","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"AccessControlPolicy"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketAnalyticsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id","AnalyticsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"AnalyticsConfiguration":{"shape":"S3p","locationName":"AnalyticsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"AnalyticsConfiguration"}},"PutBucketCors":{"http":{"method":"PUT","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket","CORSConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CORSConfiguration":{"locationName":"CORSConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["CORSRules"],"members":{"CORSRules":{"shape":"S44","locationName":"CORSRule"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"CORSConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketEncryption":{"http":{"method":"PUT","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket","ServerSideEncryptionConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ServerSideEncryptionConfiguration":{"shape":"S4h","locationName":"ServerSideEncryptionConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"ServerSideEncryptionConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketIntelligentTieringConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?intelligent-tiering"},"input":{"type":"structure","required":["Bucket","Id","IntelligentTieringConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"IntelligentTieringConfiguration":{"shape":"S4n","locationName":"IntelligentTieringConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"IntelligentTieringConfiguration"}},"PutBucketInventoryConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id","InventoryConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"InventoryConfiguration":{"shape":"S4x","locationName":"InventoryConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"InventoryConfiguration"}},"PutBucketLifecycle":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S5d","locationName":"Rule"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"LifecycleConfiguration"},"deprecated":true,"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S5t","locationName":"Rule"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"LifecycleConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketLogging":{"http":{"method":"PUT","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket","BucketLoggingStatus"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"BucketLoggingStatus":{"locationName":"BucketLoggingStatus","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LoggingEnabled":{"shape":"S65"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"BucketLoggingStatus"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketMetricsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id","MetricsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"MetricsConfiguration":{"shape":"S6d","locationName":"MetricsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"MetricsConfiguration"}},"PutBucketNotification":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"NotificationConfiguration":{"shape":"S6i","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"NotificationConfiguration"},"deprecated":true,"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketNotificationConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"NotificationConfiguration":{"shape":"S6t","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"SkipDestinationValidation":{"location":"header","locationName":"x-amz-skip-destination-validation","type":"boolean"}},"payload":"NotificationConfiguration"}},"PutBucketOwnershipControls":{"http":{"method":"PUT","requestUri":"/{Bucket}?ownershipControls"},"input":{"type":"structure","required":["Bucket","OwnershipControls"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"OwnershipControls":{"shape":"S7a","locationName":"OwnershipControls","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"OwnershipControls"},"httpChecksum":{"requestChecksumRequired":true}},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket","Policy"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ConfirmRemoveSelfBucketAccess":{"location":"header","locationName":"x-amz-confirm-remove-self-bucket-access","type":"boolean"},"Policy":{},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Policy"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketReplication":{"http":{"method":"PUT","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket","ReplicationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ReplicationConfiguration":{"shape":"S7m","locationName":"ReplicationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"ReplicationConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketRequestPayment":{"http":{"method":"PUT","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket","RequestPaymentConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"RequestPaymentConfiguration":{"locationName":"RequestPaymentConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Payer"],"members":{"Payer":{}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"RequestPaymentConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"Tagging":{"shape":"Sdf","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Tagging"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketVersioning":{"http":{"method":"PUT","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket","VersioningConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersioningConfiguration":{"locationName":"VersioningConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"MFADelete":{"locationName":"MfaDelete"},"Status":{}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"VersioningConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutBucketWebsite":{"http":{"method":"PUT","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket","WebsiteConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"WebsiteConfiguration":{"locationName":"WebsiteConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"ErrorDocument":{"shape":"S8u"},"IndexDocument":{"shape":"S8s"},"RedirectAllRequestsTo":{"shape":"S8p"},"RoutingRules":{"shape":"S8v"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"WebsiteConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ContentType":{"location":"header","locationName":"Content-Type"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Body"},"output":{"type":"structure","members":{"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{"location":"header","locationName":"ETag"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"PutObjectAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Scp","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"AccessControlPolicy"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectLegalHold":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"LegalHold":{"shape":"Sa9","locationName":"LegalHold","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"LegalHold"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectLockConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ObjectLockConfiguration":{"shape":"Sac","locationName":"ObjectLockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"ObjectLockConfiguration"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectRetention":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"Retention":{"shape":"Sak","locationName":"Retention","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Retention"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"Tagging":{"shape":"Sdf","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Tagging"},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutPublicAccessBlock":{"http":{"method":"PUT","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket","PublicAccessBlockConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"PublicAccessBlockConfiguration":{"shape":"Sar","locationName":"PublicAccessBlockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"PublicAccessBlockConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"RestoreObject":{"http":{"requestUri":"/{Bucket}/{Key+}?restore"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RestoreRequest":{"locationName":"RestoreRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Days":{"type":"integer"},"GlacierJobParameters":{"type":"structure","required":["Tier"],"members":{"Tier":{}}},"Type":{},"Tier":{},"Description":{},"SelectParameters":{"type":"structure","required":["InputSerialization","ExpressionType","Expression","OutputSerialization"],"members":{"InputSerialization":{"shape":"Se5"},"ExpressionType":{},"Expression":{},"OutputSerialization":{"shape":"Sek"}}},"OutputLocation":{"type":"structure","members":{"S3":{"type":"structure","required":["BucketName","Prefix"],"members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","required":["EncryptionType"],"members":{"EncryptionType":{},"KMSKeyId":{"shape":"Sr"},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"shape":"S3g"},"Tagging":{"shape":"Sdf"},"UserMetadata":{"type":"list","member":{"locationName":"MetadataEntry","type":"structure","members":{"Name":{},"Value":{}}}},"StorageClass":{}}}}}}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"RestoreRequest"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"RestoreOutputPath":{"location":"header","locationName":"x-amz-restore-output-path"}}},"alias":"PostObjectRestore","httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"SelectObjectContent":{"http":{"requestUri":"/{Bucket}/{Key+}?select&select-type=2"},"input":{"locationName":"SelectObjectContentRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Bucket","Key","Expression","ExpressionType","InputSerialization","OutputSerialization"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"Expression":{},"ExpressionType":{},"RequestProgress":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InputSerialization":{"shape":"Se5"},"OutputSerialization":{"shape":"Sek"},"ScanRange":{"type":"structure","members":{"Start":{"type":"long"},"End":{"type":"long"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Payload":{"type":"structure","members":{"Records":{"type":"structure","members":{"Payload":{"eventpayload":true,"type":"blob"}},"event":true},"Stats":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Progress":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Cont":{"type":"structure","members":{},"event":true},"End":{"type":"structure","members":{},"event":true}},"eventstream":true}},"payload":"Payload"}},"UploadPart":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","PartNumber","UploadId"],"members":{"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Body"},"output":{"type":"structure","members":{"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"ETag":{"location":"header","locationName":"ETag"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"UploadPartCopy":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key","PartNumber","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"CopySourceRange":{"location":"header","locationName":"x-amz-copy-source-range"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1k","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ExpectedSourceBucketOwner":{"location":"header","locationName":"x-amz-source-expected-bucket-owner"}}},"output":{"type":"structure","members":{"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"CopyPartResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyPartResult"}},"WriteGetObjectResponse":{"http":{"requestUri":"/WriteGetObjectResponse"},"input":{"type":"structure","required":["RequestRoute","RequestToken"],"members":{"RequestRoute":{"hostLabel":true,"location":"header","locationName":"x-amz-request-route"},"RequestToken":{"location":"header","locationName":"x-amz-request-token"},"Body":{"streaming":true,"type":"blob"},"StatusCode":{"location":"header","locationName":"x-amz-fwd-status","type":"integer"},"ErrorCode":{"location":"header","locationName":"x-amz-fwd-error-code"},"ErrorMessage":{"location":"header","locationName":"x-amz-fwd-error-message"},"AcceptRanges":{"location":"header","locationName":"x-amz-fwd-header-accept-ranges"},"CacheControl":{"location":"header","locationName":"x-amz-fwd-header-Cache-Control"},"ContentDisposition":{"location":"header","locationName":"x-amz-fwd-header-Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"x-amz-fwd-header-Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"x-amz-fwd-header-Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentRange":{"location":"header","locationName":"x-amz-fwd-header-Content-Range"},"ContentType":{"location":"header","locationName":"x-amz-fwd-header-Content-Type"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-sha256"},"DeleteMarker":{"location":"header","locationName":"x-amz-fwd-header-x-amz-delete-marker","type":"boolean"},"ETag":{"location":"header","locationName":"x-amz-fwd-header-ETag"},"Expires":{"location":"header","locationName":"x-amz-fwd-header-Expires","type":"timestamp"},"Expiration":{"location":"header","locationName":"x-amz-fwd-header-x-amz-expiration"},"LastModified":{"location":"header","locationName":"x-amz-fwd-header-Last-Modified","type":"timestamp"},"MissingMeta":{"location":"header","locationName":"x-amz-fwd-header-x-amz-missing-meta","type":"integer"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"ObjectLockMode":{"location":"header","locationName":"x-amz-fwd-header-x-amz-object-lock-mode"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-fwd-header-x-amz-object-lock-legal-hold"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-fwd-header-x-amz-object-lock-retain-until-date"},"PartsCount":{"location":"header","locationName":"x-amz-fwd-header-x-amz-mp-parts-count","type":"integer"},"ReplicationStatus":{"location":"header","locationName":"x-amz-fwd-header-x-amz-replication-status"},"RequestCharged":{"location":"header","locationName":"x-amz-fwd-header-x-amz-request-charged"},"Restore":{"location":"header","locationName":"x-amz-fwd-header-x-amz-restore"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-customer-algorithm"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-aws-kms-key-id"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-customer-key-MD5"},"StorageClass":{"location":"header","locationName":"x-amz-fwd-header-x-amz-storage-class"},"TagCount":{"location":"header","locationName":"x-amz-fwd-header-x-amz-tagging-count","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-fwd-header-x-amz-version-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"}},"payload":"Body"},"authtype":"v4-unsigned-body","endpoint":{"hostPrefix":"{RequestRoute}."}}},"shapes":{"Sk":{"type":"blob","sensitive":true},"Sr":{"type":"string","sensitive":true},"S1b":{"type":"map","key":{},"value":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"blob","sensitive":true},"S1o":{"type":"timestamp","timestampFormat":"iso8601"},"S3d":{"type":"structure","members":{"DisplayName":{},"ID":{}}},"S3g":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S3i"},"Permission":{}}}},"S3i":{"type":"structure","required":["Type"],"members":{"DisplayName":{},"EmailAddress":{},"ID":{},"Type":{"locationName":"xsi:type","xmlAttribute":true},"URI":{}},"xmlNamespace":{"prefix":"xsi","uri":"http://www.w3.org/2001/XMLSchema-instance"}},"S3p":{"type":"structure","required":["Id","StorageClassAnalysis"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3s"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3v","flattened":true,"locationName":"Tag"}}}}},"StorageClassAnalysis":{"type":"structure","members":{"DataExport":{"type":"structure","required":["OutputSchemaVersion","Destination"],"members":{"OutputSchemaVersion":{},"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Format","Bucket"],"members":{"Format":{},"BucketAccountId":{},"Bucket":{},"Prefix":{}}}}}}}}}}},"S3s":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S3v":{"type":"list","member":{"shape":"S3s","locationName":"Tag"}},"S44":{"type":"list","member":{"type":"structure","required":["AllowedMethods","AllowedOrigins"],"members":{"ID":{},"AllowedHeaders":{"locationName":"AllowedHeader","type":"list","member":{},"flattened":true},"AllowedMethods":{"locationName":"AllowedMethod","type":"list","member":{},"flattened":true},"AllowedOrigins":{"locationName":"AllowedOrigin","type":"list","member":{},"flattened":true},"ExposeHeaders":{"locationName":"ExposeHeader","type":"list","member":{},"flattened":true},"MaxAgeSeconds":{"type":"integer"}}},"flattened":true},"S4h":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","members":{"ApplyServerSideEncryptionByDefault":{"type":"structure","required":["SSEAlgorithm"],"members":{"SSEAlgorithm":{},"KMSMasterKeyID":{"shape":"Sr"}}},"BucketKeyEnabled":{"type":"boolean"}}},"flattened":true}}},"S4n":{"type":"structure","required":["Id","Status","Tierings"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3s"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3v","flattened":true,"locationName":"Tag"}}}}},"Status":{},"Tierings":{"locationName":"Tiering","type":"list","member":{"type":"structure","required":["Days","AccessTier"],"members":{"Days":{"type":"integer"},"AccessTier":{}}},"flattened":true}}},"S4x":{"type":"structure","required":["Destination","IsEnabled","Id","IncludedObjectVersions","Schedule"],"members":{"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Bucket","Format"],"members":{"AccountId":{},"Bucket":{},"Format":{},"Prefix":{},"Encryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{"shape":"Sr"}}}}}}}}},"IsEnabled":{"type":"boolean"},"Filter":{"type":"structure","required":["Prefix"],"members":{"Prefix":{}}},"Id":{},"IncludedObjectVersions":{},"OptionalFields":{"type":"list","member":{"locationName":"Field"}},"Schedule":{"type":"structure","required":["Frequency"],"members":{"Frequency":{}}}}},"S5d":{"type":"list","member":{"type":"structure","required":["Prefix","Status"],"members":{"Expiration":{"shape":"S5f"},"ID":{},"Prefix":{},"Status":{},"Transition":{"shape":"S5k"},"NoncurrentVersionTransition":{"shape":"S5m"},"NoncurrentVersionExpiration":{"shape":"S5o"},"AbortIncompleteMultipartUpload":{"shape":"S5p"}}},"flattened":true},"S5f":{"type":"structure","members":{"Date":{"shape":"S5g"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"S5g":{"type":"timestamp","timestampFormat":"iso8601"},"S5k":{"type":"structure","members":{"Date":{"shape":"S5g"},"Days":{"type":"integer"},"StorageClass":{}}},"S5m":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{},"NewerNoncurrentVersions":{"type":"integer"}}},"S5o":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"NewerNoncurrentVersions":{"type":"integer"}}},"S5p":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"S5t":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Expiration":{"shape":"S5f"},"ID":{},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3s"},"ObjectSizeGreaterThan":{"type":"long"},"ObjectSizeLessThan":{"type":"long"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3v","flattened":true,"locationName":"Tag"},"ObjectSizeGreaterThan":{"type":"long"},"ObjectSizeLessThan":{"type":"long"}}}}},"Status":{},"Transitions":{"locationName":"Transition","type":"list","member":{"shape":"S5k"},"flattened":true},"NoncurrentVersionTransitions":{"locationName":"NoncurrentVersionTransition","type":"list","member":{"shape":"S5m"},"flattened":true},"NoncurrentVersionExpiration":{"shape":"S5o"},"AbortIncompleteMultipartUpload":{"shape":"S5p"}}},"flattened":true},"S65":{"type":"structure","required":["TargetBucket","TargetPrefix"],"members":{"TargetBucket":{},"TargetGrants":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S3i"},"Permission":{}}}},"TargetPrefix":{}}},"S6d":{"type":"structure","required":["Id"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3s"},"AccessPointArn":{},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3v","flattened":true,"locationName":"Tag"},"AccessPointArn":{}}}}}}},"S6h":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"S6i":{"type":"structure","members":{"TopicConfiguration":{"type":"structure","members":{"Id":{},"Events":{"shape":"S6l","locationName":"Event"},"Event":{"deprecated":true},"Topic":{}}},"QueueConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S6l","locationName":"Event"},"Queue":{}}},"CloudFunctionConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S6l","locationName":"Event"},"CloudFunction":{},"InvocationRole":{}}}}},"S6l":{"type":"list","member":{},"flattened":true},"S6t":{"type":"structure","members":{"TopicConfigurations":{"locationName":"TopicConfiguration","type":"list","member":{"type":"structure","required":["TopicArn","Events"],"members":{"Id":{},"TopicArn":{"locationName":"Topic"},"Events":{"shape":"S6l","locationName":"Event"},"Filter":{"shape":"S6w"}}},"flattened":true},"QueueConfigurations":{"locationName":"QueueConfiguration","type":"list","member":{"type":"structure","required":["QueueArn","Events"],"members":{"Id":{},"QueueArn":{"locationName":"Queue"},"Events":{"shape":"S6l","locationName":"Event"},"Filter":{"shape":"S6w"}}},"flattened":true},"LambdaFunctionConfigurations":{"locationName":"CloudFunctionConfiguration","type":"list","member":{"type":"structure","required":["LambdaFunctionArn","Events"],"members":{"Id":{},"LambdaFunctionArn":{"locationName":"CloudFunction"},"Events":{"shape":"S6l","locationName":"Event"},"Filter":{"shape":"S6w"}}},"flattened":true},"EventBridgeConfiguration":{"type":"structure","members":{}}}},"S6w":{"type":"structure","members":{"Key":{"locationName":"S3Key","type":"structure","members":{"FilterRules":{"locationName":"FilterRule","type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}},"flattened":true}}}}},"S7a":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["ObjectOwnership"],"members":{"ObjectOwnership":{}}},"flattened":true}}},"S7m":{"type":"structure","required":["Role","Rules"],"members":{"Role":{},"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["Status","Destination"],"members":{"ID":{},"Priority":{"type":"integer"},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3s"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3v","flattened":true,"locationName":"Tag"}}}}},"Status":{},"SourceSelectionCriteria":{"type":"structure","members":{"SseKmsEncryptedObjects":{"type":"structure","required":["Status"],"members":{"Status":{}}},"ReplicaModifications":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"ExistingObjectReplication":{"type":"structure","required":["Status"],"members":{"Status":{}}},"Destination":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Account":{},"StorageClass":{},"AccessControlTranslation":{"type":"structure","required":["Owner"],"members":{"Owner":{}}},"EncryptionConfiguration":{"type":"structure","members":{"ReplicaKmsKeyID":{}}},"ReplicationTime":{"type":"structure","required":["Status","Time"],"members":{"Status":{},"Time":{"shape":"S88"}}},"Metrics":{"type":"structure","required":["Status"],"members":{"Status":{},"EventThreshold":{"shape":"S88"}}}}},"DeleteMarkerReplication":{"type":"structure","members":{"Status":{}}}}},"flattened":true}}},"S88":{"type":"structure","members":{"Minutes":{"type":"integer"}}},"S8p":{"type":"structure","required":["HostName"],"members":{"HostName":{},"Protocol":{}}},"S8s":{"type":"structure","required":["Suffix"],"members":{"Suffix":{}}},"S8u":{"type":"structure","required":["Key"],"members":{"Key":{}}},"S8v":{"type":"list","member":{"locationName":"RoutingRule","type":"structure","required":["Redirect"],"members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"HostName":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}},"Sa9":{"type":"structure","members":{"Status":{}}},"Sac":{"type":"structure","members":{"ObjectLockEnabled":{},"Rule":{"type":"structure","members":{"DefaultRetention":{"type":"structure","members":{"Mode":{},"Days":{"type":"integer"},"Years":{"type":"integer"}}}}}}},"Sak":{"type":"structure","members":{"Mode":{},"RetainUntilDate":{"shape":"S5g"}}},"Sar":{"type":"structure","members":{"BlockPublicAcls":{"locationName":"BlockPublicAcls","type":"boolean"},"IgnorePublicAcls":{"locationName":"IgnorePublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"BlockPublicPolicy","type":"boolean"},"RestrictPublicBuckets":{"locationName":"RestrictPublicBuckets","type":"boolean"}}},"Sbr":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"Sbs":{"type":"list","member":{"type":"structure","members":{"Prefix":{}}},"flattened":true},"Sc1":{"type":"list","member":{},"flattened":true},"Sca":{"type":"list","member":{"type":"structure","members":{"Key":{},"LastModified":{"type":"timestamp"},"ETag":{},"ChecksumAlgorithm":{"shape":"Sc1"},"Size":{"type":"integer"},"StorageClass":{},"Owner":{"shape":"S3d"}}},"flattened":true},"Scp":{"type":"structure","members":{"Grants":{"shape":"S3g","locationName":"AccessControlList"},"Owner":{"shape":"S3d"}}},"Sdf":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3v"}}},"Se5":{"type":"structure","members":{"CSV":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{},"AllowQuotedRecordDelimiter":{"type":"boolean"}}},"CompressionType":{},"JSON":{"type":"structure","members":{"Type":{}}},"Parquet":{"type":"structure","members":{}}}},"Sek":{"type":"structure","members":{"CSV":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}},"JSON":{"type":"structure","members":{"RecordDelimiter":{}}}}}}}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBuckets":{"result_key":"Buckets"},"ListMultipartUploads":{"input_token":["KeyMarker","UploadIdMarker"],"limit_key":"MaxUploads","more_results":"IsTruncated","output_token":["NextKeyMarker","NextUploadIdMarker"],"result_key":["Uploads","CommonPrefixes"]},"ListObjectVersions":{"input_token":["KeyMarker","VersionIdMarker"],"limit_key":"MaxKeys","more_results":"IsTruncated","output_token":["NextKeyMarker","NextVersionIdMarker"],"result_key":["Versions","DeleteMarkers","CommonPrefixes"]},"ListObjects":{"input_token":"Marker","limit_key":"MaxKeys","more_results":"IsTruncated","output_token":"NextMarker || Contents[-1].Key","result_key":["Contents","CommonPrefixes"]},"ListObjectsV2":{"input_token":"ContinuationToken","limit_key":"MaxKeys","output_token":"NextContinuationToken","result_key":["Contents","CommonPrefixes"]},"ListParts":{"input_token":"PartNumberMarker","limit_key":"MaxParts","more_results":"IsTruncated","output_token":"NextPartNumberMarker","result_key":"Parts"}}}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"BucketExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":301,"matcher":"status","state":"success"},{"expected":403,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"BucketNotExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]},"ObjectExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"ObjectNotExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]}}}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['s3control'] = {};
	AWS.S3Control = Service.defineService('s3control', ['2018-08-20']);
	__webpack_require__(430);
	Object.defineProperty(apiLoader.services['s3control'], '2018-08-20', {
	  get: function get() {
	    var model = __webpack_require__(431);
	    model.paginators = __webpack_require__(432).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.S3Control;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var s3util = __webpack_require__(361);
	var regionUtil = __webpack_require__(362);

	AWS.util.update(AWS.S3Control.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('extractError', this.extractHostId);
	    request.addListener('extractData', this.extractHostId);
	    request.addListener('validate', this.validateAccountId);

	    var isArnInBucket = s3util.isArnInParam(request, 'Bucket');
	    var isArnInName = s3util.isArnInParam(request, 'Name');

	    if (isArnInBucket) {
	      request._parsedArn = AWS.util.ARN.parse(request.params['Bucket']);
	      request.addListener('validate', this.validateOutpostsBucketArn);
	      request.addListener('validate', s3util.validateOutpostsArn);
	      request.addListener('afterBuild', this.addOutpostIdHeader);
	    } else if (isArnInName) {
	      request._parsedArn = AWS.util.ARN.parse(request.params['Name']);
	      request.addListener('validate', s3util.validateOutpostsAccessPointArn);
	      request.addListener('validate', s3util.validateOutpostsArn);
	      request.addListener('afterBuild', this.addOutpostIdHeader);
	    }

	    if (isArnInBucket || isArnInName) {
	      request.addListener('validate', this.validateArnRegion);
	      request.addListener('validate', this.validateArnAccountWithParams, true);
	      request.addListener('validate', s3util.validateArnAccount);
	      request.addListener('validate', s3util.validateArnService);
	      request.addListener('build', this.populateParamFromArn, true);
	      request.addListener('build', this.populateUriFromArn);
	      request.addListener('build', s3util.validatePopulateUriFromArn);
	    }

	    if (request.params.OutpostId &&
	        (request.operation === 'createBucket' ||
	          request.operation === 'listRegionalBuckets')) {
	      request.addListener('build', this.populateEndpointForOutpostId);
	    }
	  },

	  /**
	   * Adds outpostId header
	   */
	  addOutpostIdHeader: function addOutpostIdHeader(req) {
	    req.httpRequest.headers['x-amz-outpost-id'] = req._parsedArn.outpostId;
	  },

	  /**
	   * Validate Outposts ARN supplied in Bucket parameter is a valid bucket name
	   */
	  validateOutpostsBucketArn: function validateOutpostsBucketArn(req) {
	    var parsedArn = req._parsedArn;

	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['outpost'.length];

	    if (parsedArn.resource.split(delimiter).length !== 4) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Bucket ARN should have two resources outpost/{outpostId}/bucket/{accesspointName}'
	      });
	    }

	    var bucket = parsedArn.resource.split(delimiter)[3];
	    if (!s3util.dnsCompatibleBucketName(bucket) || bucket.match(/\./)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Bucket ARN is not DNS compatible. Got ' + bucket
	      });
	    }

	    //set parsed valid bucket
	    req._parsedArn.bucket = bucket;
	  },

	  /**
	   * @api private
	   */
	  populateParamFromArn: function populateParamFromArn(req) {
	    var parsedArn = req._parsedArn;
	    if (s3util.isArnInParam(req, 'Bucket')) {
	      req.params.Bucket = parsedArn.bucket;
	    } else if (s3util.isArnInParam(req, 'Name')) {
	      req.params.Name = parsedArn.accessPoint;
	    }
	  },

	  /**
	   * Populate URI according to the ARN
	   */
	  populateUriFromArn: function populateUriFromArn(req) {
	    var parsedArn = req._parsedArn;

	    var endpoint = req.httpRequest.endpoint;
	    var useArnRegion = req.service.config.s3UseArnRegion;
	    var useFipsEndpoint = req.service.config.useFipsEndpoint;

	    endpoint.hostname = [
	      's3-outposts' + (useFipsEndpoint ? '-fips': ''),
	      useArnRegion ? parsedArn.region : req.service.config.region,
	      'amazonaws.com'
	    ].join('.');
	    endpoint.host = endpoint.hostname;
	  },

	  /**
	   * @api private
	   */
	  populateEndpointForOutpostId: function populateEndpointForOutpostId(req) {
	    var endpoint = req.httpRequest.endpoint;
	    var useFipsEndpoint = req.service.config.useFipsEndpoint;
	    endpoint.hostname = [
	      's3-outposts' + (useFipsEndpoint ? '-fips': ''),
	      req.service.config.region,
	      'amazonaws.com'
	    ].join('.');
	    endpoint.host = endpoint.hostname;
	  },

	  /**
	   * @api private
	   */
	  extractHostId: function(response) {
	    var hostId = response.httpResponse.headers ? response.httpResponse.headers['x-amz-id-2'] : null;
	    response.extendedRequestId = hostId;
	    if (response.error) {
	      response.error.extendedRequestId = hostId;
	    }
	  },

	  /**
	   * @api private
	   */
	  validateArnRegion: function validateArnRegion(req) {
	    s3util.validateArnRegion(req, { allowFipsEndpoint: true });
	  },

	  /**
	   * @api private
	   */
	  validateArnAccountWithParams: function validateArnAccountWithParams(req) {
	    var params = req.params;
	    var inputModel = req.service.api.operations[req.operation].input;
	    if (inputModel.members.AccountId) {
	      var parsedArn = req._parsedArn;
	      if (parsedArn.accountId) {
	        if (params.AccountId) {
	          if (params.AccountId !== parsedArn.accountId) {
	            throw AWS.util.error(
	              new Error(),
	              {code: 'ValidationError', message: 'AccountId in ARN and request params should be same.'}
	            );
	          }
	        } else {
	          // Store accountId from ARN in params
	          params.AccountId = parsedArn.accountId;
	        }
	      }
	    }
	  },

	  /**
	   * @api private
	   */
	  validateAccountId: function(request) {
	    var params = request.params;
	    if (!Object.prototype.hasOwnProperty.call(params, 'AccountId')) return;
	    var accountId = params.AccountId;
	    //validate type
	    if (typeof accountId !== 'string') {
	      throw AWS.util.error(
	        new Error(),
	        {code: 'ValidationError', message: 'AccountId must be a string.'}
	      );
	    }
	    //validate length
	    if (accountId.length < 1 || accountId.length > 63) {
	      throw AWS.util.error(
	        new Error(),
	        {code: 'ValidationError', message: 'AccountId length should be between 1 to 63 characters, inclusive.'}
	      );
	    }
	    //validate pattern
	    var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
	    if (!hostPattern.test(accountId)) {
	      throw AWS.util.error(new Error(),
	        {code: 'ValidationError', message: 'AccountId should be hostname compatible. AccountId: ' + accountId});
	    }
	  },

	  /**
	   * @api private
	   */
	  getSigningName: function getSigningName(req) {
	    var _super = AWS.Service.prototype.getSigningName;
	    if (req && req._parsedArn && req._parsedArn.service) {
	      return req._parsedArn.service;
	    } else if (req.params.OutpostId &&
	      (req.operation === 'createBucket' ||
	        req.operation === 'listRegionalBuckets')) {
	      return 's3-outposts';
	    } else {
	      return _super.call(this, req);
	    }
	  },
	});


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-08-20","endpointPrefix":"s3-control","protocol":"rest-xml","serviceFullName":"AWS S3 Control","serviceId":"S3 Control","signatureVersion":"s3v4","signingName":"s3","uid":"s3control-2018-08-20"},"operations":{"CreateAccessPoint":{"http":{"method":"PUT","requestUri":"/v20180820/accesspoint/{name}"},"input":{"locationName":"CreateAccessPointRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Name","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"},"Bucket":{},"VpcConfiguration":{"shape":"S5"},"PublicAccessBlockConfiguration":{"shape":"S7"}}},"output":{"type":"structure","members":{"AccessPointArn":{},"Alias":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"CreateAccessPointForObjectLambda":{"http":{"method":"PUT","requestUri":"/v20180820/accesspointforobjectlambda/{name}"},"input":{"locationName":"CreateAccessPointForObjectLambdaRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Name","Configuration"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"},"Configuration":{"shape":"Se"}}},"output":{"type":"structure","members":{"ObjectLambdaAccessPointArn":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"CreateBucket":{"http":{"method":"PUT","requestUri":"/v20180820/bucket/{name}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"name"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","members":{"LocationConstraint":{}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ObjectLockEnabledForBucket":{"location":"header","locationName":"x-amz-bucket-object-lock-enabled","type":"boolean"},"OutpostId":{"location":"header","locationName":"x-amz-outpost-id"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"BucketArn":{}}},"httpChecksumRequired":true},"CreateJob":{"http":{"requestUri":"/v20180820/jobs"},"input":{"locationName":"CreateJobRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Operation","Report","ClientRequestToken","Priority","RoleArn"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"ConfirmationRequired":{"type":"boolean"},"Operation":{"shape":"S19"},"Report":{"shape":"S2g"},"ClientRequestToken":{"idempotencyToken":true},"Manifest":{"shape":"S2k"},"Description":{},"Priority":{"type":"integer"},"RoleArn":{},"Tags":{"shape":"S1r"},"ManifestGenerator":{"shape":"S2v"}}},"output":{"type":"structure","members":{"JobId":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"CreateMultiRegionAccessPoint":{"http":{"requestUri":"/v20180820/async-requests/mrap/create"},"input":{"locationName":"CreateMultiRegionAccessPointRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","ClientToken","Details"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"ClientToken":{"idempotencyToken":true},"Details":{"shape":"S3b"}}},"output":{"type":"structure","members":{"RequestTokenARN":{}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"DeleteAccessPoint":{"http":{"method":"DELETE","requestUri":"/v20180820/accesspoint/{name}"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteAccessPointForObjectLambda":{"http":{"method":"DELETE","requestUri":"/v20180820/accesspointforobjectlambda/{name}"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteAccessPointPolicy":{"http":{"method":"DELETE","requestUri":"/v20180820/accesspoint/{name}/policy"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteAccessPointPolicyForObjectLambda":{"http":{"method":"DELETE","requestUri":"/v20180820/accesspointforobjectlambda/{name}/policy"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/v20180820/bucket/{name}"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteBucketLifecycleConfiguration":{"http":{"method":"DELETE","requestUri":"/v20180820/bucket/{name}/lifecycleconfiguration"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/v20180820/bucket/{name}/policy"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/v20180820/bucket/{name}/tagging","responseCode":204},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteJobTagging":{"http":{"method":"DELETE","requestUri":"/v20180820/jobs/{id}/tagging"},"input":{"type":"structure","required":["AccountId","JobId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteMultiRegionAccessPoint":{"http":{"requestUri":"/v20180820/async-requests/mrap/delete"},"input":{"locationName":"DeleteMultiRegionAccessPointRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","ClientToken","Details"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"ClientToken":{"idempotencyToken":true},"Details":{"shape":"S3s"}}},"output":{"type":"structure","members":{"RequestTokenARN":{}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"DeletePublicAccessBlock":{"http":{"method":"DELETE","requestUri":"/v20180820/configuration/publicAccessBlock"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteStorageLensConfiguration":{"http":{"method":"DELETE","requestUri":"/v20180820/storagelens/{storagelensid}"},"input":{"type":"structure","required":["ConfigId","AccountId"],"members":{"ConfigId":{"location":"uri","locationName":"storagelensid"},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DeleteStorageLensConfigurationTagging":{"http":{"method":"DELETE","requestUri":"/v20180820/storagelens/{storagelensid}/tagging"},"input":{"type":"structure","required":["ConfigId","AccountId"],"members":{"ConfigId":{"location":"uri","locationName":"storagelensid"},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"{AccountId}."}},"DescribeJob":{"http":{"method":"GET","requestUri":"/v20180820/jobs/{id}"},"input":{"type":"structure","required":["AccountId","JobId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"Job":{"type":"structure","members":{"JobId":{},"ConfirmationRequired":{"type":"boolean"},"Description":{},"JobArn":{},"Status":{},"Manifest":{"shape":"S2k"},"Operation":{"shape":"S19"},"Priority":{"type":"integer"},"ProgressSummary":{"shape":"S44"},"StatusUpdateReason":{},"FailureReasons":{"type":"list","member":{"type":"structure","members":{"FailureCode":{},"FailureReason":{}}}},"Report":{"shape":"S2g"},"CreationTime":{"type":"timestamp"},"TerminationDate":{"type":"timestamp"},"RoleArn":{},"SuspendedDate":{"type":"timestamp"},"SuspendedCause":{},"ManifestGenerator":{"shape":"S2v"},"GeneratedManifestDescriptor":{"type":"structure","members":{"Format":{},"Location":{"shape":"S2p"}}}}}}},"endpoint":{"hostPrefix":"{AccountId}."}},"DescribeMultiRegionAccessPointOperation":{"http":{"method":"GET","requestUri":"/v20180820/async-requests/mrap/{request_token+}"},"input":{"type":"structure","required":["AccountId","RequestTokenARN"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"RequestTokenARN":{"location":"uri","locationName":"request_token"}}},"output":{"type":"structure","members":{"AsyncOperation":{"type":"structure","members":{"CreationTime":{"type":"timestamp"},"Operation":{},"RequestTokenARN":{},"RequestParameters":{"type":"structure","members":{"CreateMultiRegionAccessPointRequest":{"shape":"S3b"},"DeleteMultiRegionAccessPointRequest":{"shape":"S3s"},"PutMultiRegionAccessPointPolicyRequest":{"shape":"S4q"}}},"RequestStatus":{},"ResponseDetails":{"type":"structure","members":{"MultiRegionAccessPointDetails":{"type":"structure","members":{"Regions":{"type":"list","member":{"locationName":"Region","type":"structure","members":{"Name":{},"RequestStatus":{}}}}}},"ErrorDetails":{"type":"structure","members":{"Code":{},"Message":{},"Resource":{},"RequestId":{}}}}}}}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"GetAccessPoint":{"http":{"method":"GET","requestUri":"/v20180820/accesspoint/{name}"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Name":{},"Bucket":{},"NetworkOrigin":{},"VpcConfiguration":{"shape":"S5"},"PublicAccessBlockConfiguration":{"shape":"S7"},"CreationDate":{"type":"timestamp"},"Alias":{},"AccessPointArn":{},"Endpoints":{"type":"map","key":{},"value":{}}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetAccessPointConfigurationForObjectLambda":{"http":{"method":"GET","requestUri":"/v20180820/accesspointforobjectlambda/{name}/configuration"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetAccessPointForObjectLambda":{"http":{"method":"GET","requestUri":"/v20180820/accesspointforobjectlambda/{name}"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Name":{},"PublicAccessBlockConfiguration":{"shape":"S7"},"CreationDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetAccessPointPolicy":{"http":{"method":"GET","requestUri":"/v20180820/accesspoint/{name}/policy"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Policy":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetAccessPointPolicyForObjectLambda":{"http":{"method":"GET","requestUri":"/v20180820/accesspointforobjectlambda/{name}/policy"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Policy":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetAccessPointPolicyStatus":{"http":{"method":"GET","requestUri":"/v20180820/accesspoint/{name}/policyStatus"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"PolicyStatus":{"shape":"S5f"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetAccessPointPolicyStatusForObjectLambda":{"http":{"method":"GET","requestUri":"/v20180820/accesspointforobjectlambda/{name}/policyStatus"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"PolicyStatus":{"shape":"S5f"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetBucket":{"http":{"method":"GET","requestUri":"/v20180820/bucket/{name}"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Bucket":{},"PublicAccessBlockEnabled":{"type":"boolean"},"CreationDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/v20180820/bucket/{name}/lifecycleconfiguration"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S5o"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/v20180820/bucket/{name}/policy"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Policy":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/v20180820/bucket/{name}/tagging"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S1r"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetJobTagging":{"http":{"method":"GET","requestUri":"/v20180820/jobs/{id}/tagging"},"input":{"type":"structure","required":["AccountId","JobId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1r"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"GetMultiRegionAccessPoint":{"http":{"method":"GET","requestUri":"/v20180820/mrap/instances/{name}"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"AccessPoint":{"shape":"S6f"}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"GetMultiRegionAccessPointPolicy":{"http":{"method":"GET","requestUri":"/v20180820/mrap/instances/{name}/policy"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Policy":{"type":"structure","members":{"Established":{"type":"structure","members":{"Policy":{}}},"Proposed":{"type":"structure","members":{"Policy":{}}}}}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"GetMultiRegionAccessPointPolicyStatus":{"http":{"method":"GET","requestUri":"/v20180820/mrap/instances/{name}/policystatus"},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Established":{"shape":"S5f"}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"GetPublicAccessBlock":{"http":{"method":"GET","requestUri":"/v20180820/configuration/publicAccessBlock"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}}},"output":{"type":"structure","members":{"PublicAccessBlockConfiguration":{"shape":"S7"}},"payload":"PublicAccessBlockConfiguration"},"endpoint":{"hostPrefix":"{AccountId}."}},"GetStorageLensConfiguration":{"http":{"method":"GET","requestUri":"/v20180820/storagelens/{storagelensid}"},"input":{"type":"structure","required":["ConfigId","AccountId"],"members":{"ConfigId":{"location":"uri","locationName":"storagelensid"},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}}},"output":{"type":"structure","members":{"StorageLensConfiguration":{"shape":"S6w"}},"payload":"StorageLensConfiguration"},"endpoint":{"hostPrefix":"{AccountId}."}},"GetStorageLensConfigurationTagging":{"http":{"method":"GET","requestUri":"/v20180820/storagelens/{storagelensid}/tagging"},"input":{"type":"structure","required":["ConfigId","AccountId"],"members":{"ConfigId":{"location":"uri","locationName":"storagelensid"},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7q"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"ListAccessPoints":{"http":{"method":"GET","requestUri":"/v20180820/accesspoint"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"querystring","locationName":"bucket"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"AccessPointList":{"type":"list","member":{"locationName":"AccessPoint","type":"structure","required":["Name","NetworkOrigin","Bucket"],"members":{"Name":{},"NetworkOrigin":{},"VpcConfiguration":{"shape":"S5"},"Bucket":{},"AccessPointArn":{},"Alias":{}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"ListAccessPointsForObjectLambda":{"http":{"method":"GET","requestUri":"/v20180820/accesspointforobjectlambda"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ObjectLambdaAccessPointList":{"type":"list","member":{"locationName":"ObjectLambdaAccessPoint","type":"structure","required":["Name"],"members":{"Name":{},"ObjectLambdaAccessPointArn":{}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"ListJobs":{"http":{"method":"GET","requestUri":"/v20180820/jobs"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobStatuses":{"location":"querystring","locationName":"jobStatuses","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Jobs":{"type":"list","member":{"type":"structure","members":{"JobId":{},"Description":{},"Operation":{},"Priority":{"type":"integer"},"Status":{},"CreationTime":{"type":"timestamp"},"TerminationDate":{"type":"timestamp"},"ProgressSummary":{"shape":"S44"}}}}}},"endpoint":{"hostPrefix":"{AccountId}."}},"ListMultiRegionAccessPoints":{"http":{"method":"GET","requestUri":"/v20180820/mrap/instances"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"AccessPoints":{"type":"list","member":{"shape":"S6f","locationName":"AccessPoint"}},"NextToken":{}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"ListRegionalBuckets":{"http":{"method":"GET","requestUri":"/v20180820/bucket"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"OutpostId":{"location":"header","locationName":"x-amz-outpost-id"}}},"output":{"type":"structure","members":{"RegionalBucketList":{"type":"list","member":{"locationName":"RegionalBucket","type":"structure","required":["Bucket","PublicAccessBlockEnabled","CreationDate"],"members":{"Bucket":{},"BucketArn":{},"PublicAccessBlockEnabled":{"type":"boolean"},"CreationDate":{"type":"timestamp"},"OutpostId":{}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"ListStorageLensConfigurations":{"http":{"method":"GET","requestUri":"/v20180820/storagelens"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"StorageLensConfigurationList":{"type":"list","member":{"locationName":"StorageLensConfiguration","type":"structure","required":["Id","StorageLensArn","HomeRegion"],"members":{"Id":{},"StorageLensArn":{},"HomeRegion":{},"IsEnabled":{"type":"boolean"}}},"flattened":true}}},"endpoint":{"hostPrefix":"{AccountId}."}},"PutAccessPointConfigurationForObjectLambda":{"http":{"method":"PUT","requestUri":"/v20180820/accesspointforobjectlambda/{name}/configuration"},"input":{"locationName":"PutAccessPointConfigurationForObjectLambdaRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Name","Configuration"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"},"Configuration":{"shape":"Se"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"PutAccessPointPolicy":{"http":{"method":"PUT","requestUri":"/v20180820/accesspoint/{name}/policy"},"input":{"locationName":"PutAccessPointPolicyRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Name","Policy"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"},"Policy":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"PutAccessPointPolicyForObjectLambda":{"http":{"method":"PUT","requestUri":"/v20180820/accesspointforobjectlambda/{name}/policy"},"input":{"locationName":"PutAccessPointPolicyForObjectLambdaRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Name","Policy"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Name":{"location":"uri","locationName":"name"},"Policy":{}}},"endpoint":{"hostPrefix":"{AccountId}."}},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/v20180820/bucket/{name}/lifecycleconfiguration"},"input":{"type":"structure","required":["AccountId","Bucket"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","members":{"Rules":{"shape":"S5o"}}}},"payload":"LifecycleConfiguration"},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/v20180820/bucket/{name}/policy"},"input":{"locationName":"PutBucketPolicyRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Bucket","Policy"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"},"ConfirmRemoveSelfBucketAccess":{"location":"header","locationName":"x-amz-confirm-remove-self-bucket-access","type":"boolean"},"Policy":{}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/v20180820/bucket/{name}/tagging"},"input":{"type":"structure","required":["AccountId","Bucket","Tagging"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Bucket":{"location":"uri","locationName":"name"},"Tagging":{"locationName":"Tagging","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S1r"}}}},"payload":"Tagging"},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"PutJobTagging":{"http":{"method":"PUT","requestUri":"/v20180820/jobs/{id}/tagging"},"input":{"locationName":"PutJobTaggingRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","JobId","Tags"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"},"Tags":{"shape":"S1r"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"{AccountId}."}},"PutMultiRegionAccessPointPolicy":{"http":{"requestUri":"/v20180820/async-requests/mrap/put-policy"},"input":{"locationName":"PutMultiRegionAccessPointPolicyRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","ClientToken","Details"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"ClientToken":{"idempotencyToken":true},"Details":{"shape":"S4q"}}},"output":{"type":"structure","members":{"RequestTokenARN":{}}},"endpoint":{"hostPrefix":"{AccountId}."},"httpChecksumRequired":true},"PutPublicAccessBlock":{"http":{"method":"PUT","requestUri":"/v20180820/configuration/publicAccessBlock"},"input":{"type":"structure","required":["PublicAccessBlockConfiguration","AccountId"],"members":{"PublicAccessBlockConfiguration":{"shape":"S7","locationName":"PublicAccessBlockConfiguration","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"}},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"}},"payload":"PublicAccessBlockConfiguration"},"endpoint":{"hostPrefix":"{AccountId}."}},"PutStorageLensConfiguration":{"http":{"method":"PUT","requestUri":"/v20180820/storagelens/{storagelensid}"},"input":{"locationName":"PutStorageLensConfigurationRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["ConfigId","AccountId","StorageLensConfiguration"],"members":{"ConfigId":{"location":"uri","locationName":"storagelensid"},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"StorageLensConfiguration":{"shape":"S6w"},"Tags":{"shape":"S7q"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"PutStorageLensConfigurationTagging":{"http":{"method":"PUT","requestUri":"/v20180820/storagelens/{storagelensid}/tagging"},"input":{"locationName":"PutStorageLensConfigurationTaggingRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["ConfigId","AccountId","Tags"],"members":{"ConfigId":{"location":"uri","locationName":"storagelensid"},"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"Tags":{"shape":"S7q"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"{AccountId}."}},"UpdateJobPriority":{"http":{"requestUri":"/v20180820/jobs/{id}/priority"},"input":{"type":"structure","required":["AccountId","JobId","Priority"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"},"Priority":{"location":"querystring","locationName":"priority","type":"integer"}}},"output":{"type":"structure","required":["JobId","Priority"],"members":{"JobId":{},"Priority":{"type":"integer"}}},"endpoint":{"hostPrefix":"{AccountId}."}},"UpdateJobStatus":{"http":{"requestUri":"/v20180820/jobs/{id}/status"},"input":{"type":"structure","required":["AccountId","JobId","RequestedJobStatus"],"members":{"AccountId":{"hostLabel":true,"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"},"RequestedJobStatus":{"location":"querystring","locationName":"requestedJobStatus"},"StatusUpdateReason":{"location":"querystring","locationName":"statusUpdateReason"}}},"output":{"type":"structure","members":{"JobId":{},"Status":{},"StatusUpdateReason":{}}},"endpoint":{"hostPrefix":"{AccountId}."}}},"shapes":{"S5":{"type":"structure","required":["VpcId"],"members":{"VpcId":{}}},"S7":{"type":"structure","members":{"BlockPublicAcls":{"locationName":"BlockPublicAcls","type":"boolean"},"IgnorePublicAcls":{"locationName":"IgnorePublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"BlockPublicPolicy","type":"boolean"},"RestrictPublicBuckets":{"locationName":"RestrictPublicBuckets","type":"boolean"}}},"Se":{"type":"structure","required":["SupportingAccessPoint","TransformationConfigurations"],"members":{"SupportingAccessPoint":{},"CloudWatchMetricsEnabled":{"type":"boolean"},"AllowedFeatures":{"type":"list","member":{"locationName":"AllowedFeature"}},"TransformationConfigurations":{"type":"list","member":{"locationName":"TransformationConfiguration","type":"structure","required":["Actions","ContentTransformation"],"members":{"Actions":{"type":"list","member":{"locationName":"Action"}},"ContentTransformation":{"type":"structure","members":{"AwsLambda":{"type":"structure","required":["FunctionArn"],"members":{"FunctionArn":{},"FunctionPayload":{}}}},"union":true}}}}}},"S19":{"type":"structure","members":{"LambdaInvoke":{"type":"structure","members":{"FunctionArn":{}}},"S3PutObjectCopy":{"type":"structure","members":{"TargetResource":{},"CannedAccessControlList":{},"AccessControlGrants":{"shape":"S1e"},"MetadataDirective":{},"ModifiedSinceConstraint":{"type":"timestamp"},"NewObjectMetadata":{"type":"structure","members":{"CacheControl":{},"ContentDisposition":{},"ContentEncoding":{},"ContentLanguage":{},"UserMetadata":{"type":"map","key":{},"value":{}},"ContentLength":{"type":"long"},"ContentMD5":{},"ContentType":{},"HttpExpiresDate":{"type":"timestamp"},"RequesterCharged":{"type":"boolean"},"SSEAlgorithm":{}}},"NewObjectTagging":{"shape":"S1r"},"RedirectLocation":{},"RequesterPays":{"type":"boolean"},"StorageClass":{},"UnModifiedSinceConstraint":{"type":"timestamp"},"SSEAwsKmsKeyId":{},"TargetKeyPrefix":{},"ObjectLockLegalHoldStatus":{},"ObjectLockMode":{},"ObjectLockRetainUntilDate":{"type":"timestamp"},"BucketKeyEnabled":{"type":"boolean"},"ChecksumAlgorithm":{}}},"S3PutObjectAcl":{"type":"structure","members":{"AccessControlPolicy":{"type":"structure","members":{"AccessControlList":{"type":"structure","required":["Owner"],"members":{"Owner":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"Grants":{"shape":"S1e"}}},"CannedAccessControlList":{}}}}},"S3PutObjectTagging":{"type":"structure","members":{"TagSet":{"shape":"S1r"}}},"S3DeleteObjectTagging":{"type":"structure","members":{}},"S3InitiateRestoreObject":{"type":"structure","members":{"ExpirationInDays":{"type":"integer"},"GlacierJobTier":{}}},"S3PutObjectLegalHold":{"type":"structure","required":["LegalHold"],"members":{"LegalHold":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"S3PutObjectRetention":{"type":"structure","required":["Retention"],"members":{"BypassGovernanceRetention":{"type":"boolean"},"Retention":{"type":"structure","members":{"RetainUntilDate":{"type":"timestamp"},"Mode":{}}}}},"S3ReplicateObject":{"type":"structure","members":{}}}},"S1e":{"type":"list","member":{"type":"structure","members":{"Grantee":{"type":"structure","members":{"TypeIdentifier":{},"Identifier":{},"DisplayName":{}}},"Permission":{}}}},"S1r":{"type":"list","member":{"shape":"S1s"}},"S1s":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S2g":{"type":"structure","required":["Enabled"],"members":{"Bucket":{},"Format":{},"Enabled":{"type":"boolean"},"Prefix":{},"ReportScope":{}}},"S2k":{"type":"structure","required":["Spec","Location"],"members":{"Spec":{"type":"structure","required":["Format"],"members":{"Format":{},"Fields":{"type":"list","member":{}}}},"Location":{"shape":"S2p"}}},"S2p":{"type":"structure","required":["ObjectArn","ETag"],"members":{"ObjectArn":{},"ObjectVersionId":{},"ETag":{}}},"S2v":{"type":"structure","members":{"S3JobManifestGenerator":{"type":"structure","required":["SourceBucket","EnableManifestOutput"],"members":{"ExpectedBucketOwner":{},"SourceBucket":{},"ManifestOutputLocation":{"type":"structure","required":["Bucket","ManifestFormat"],"members":{"ExpectedManifestBucketOwner":{},"Bucket":{},"ManifestPrefix":{},"ManifestEncryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{}}}}},"ManifestFormat":{}}},"Filter":{"type":"structure","members":{"EligibleForReplication":{"type":"boolean"},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ObjectReplicationStatuses":{"type":"list","member":{}}}},"EnableManifestOutput":{"type":"boolean"}}}},"union":true},"S3b":{"type":"structure","required":["Name","Regions"],"members":{"Name":{},"PublicAccessBlock":{"shape":"S7"},"Regions":{"type":"list","member":{"locationName":"Region","type":"structure","required":["Bucket"],"members":{"Bucket":{}}}}}},"S3s":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S44":{"type":"structure","members":{"TotalNumberOfTasks":{"type":"long"},"NumberOfTasksSucceeded":{"type":"long"},"NumberOfTasksFailed":{"type":"long"},"Timers":{"type":"structure","members":{"ElapsedTimeInActiveSeconds":{"type":"long"}}}}},"S4q":{"type":"structure","required":["Name","Policy"],"members":{"Name":{},"Policy":{}}},"S5f":{"type":"structure","members":{"IsPublic":{"locationName":"IsPublic","type":"boolean"}}},"S5o":{"type":"list","member":{"locationName":"Rule","type":"structure","required":["Status"],"members":{"Expiration":{"type":"structure","members":{"Date":{"type":"timestamp"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"ID":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S1s"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S1r"}}}}},"Status":{},"Transitions":{"type":"list","member":{"locationName":"Transition","type":"structure","members":{"Date":{"type":"timestamp"},"Days":{"type":"integer"},"StorageClass":{}}}},"NoncurrentVersionTransitions":{"type":"list","member":{"locationName":"NoncurrentVersionTransition","type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{}}}},"NoncurrentVersionExpiration":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"}}},"AbortIncompleteMultipartUpload":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}}}}},"S6f":{"type":"structure","members":{"Name":{},"Alias":{},"CreatedAt":{"type":"timestamp"},"PublicAccessBlock":{"shape":"S7"},"Status":{},"Regions":{"type":"list","member":{"locationName":"Region","type":"structure","members":{"Bucket":{},"Region":{}}}}}},"S6w":{"type":"structure","required":["Id","AccountLevel","IsEnabled"],"members":{"Id":{},"AccountLevel":{"type":"structure","required":["BucketLevel"],"members":{"ActivityMetrics":{"shape":"S6y"},"BucketLevel":{"type":"structure","members":{"ActivityMetrics":{"shape":"S6y"},"PrefixLevel":{"type":"structure","required":["StorageMetrics"],"members":{"StorageMetrics":{"type":"structure","members":{"IsEnabled":{"type":"boolean"},"SelectionCriteria":{"type":"structure","members":{"Delimiter":{},"MaxDepth":{"type":"integer"},"MinStorageBytesPercentage":{"type":"double"}}}}}}}}}}},"Include":{"type":"structure","members":{"Buckets":{"shape":"S78"},"Regions":{"shape":"S79"}}},"Exclude":{"type":"structure","members":{"Buckets":{"shape":"S78"},"Regions":{"shape":"S79"}}},"DataExport":{"type":"structure","members":{"S3BucketDestination":{"type":"structure","required":["Format","OutputSchemaVersion","AccountId","Arn"],"members":{"Format":{},"OutputSchemaVersion":{},"AccountId":{},"Arn":{},"Prefix":{},"Encryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{}}}}}}},"CloudWatchMetrics":{"type":"structure","required":["IsEnabled"],"members":{"IsEnabled":{"type":"boolean"}}}}},"IsEnabled":{"type":"boolean"},"AwsOrg":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"StorageLensArn":{}}},"S6y":{"type":"structure","members":{"IsEnabled":{"type":"boolean"}}},"S78":{"type":"list","member":{"locationName":"Arn"}},"S79":{"type":"list","member":{"locationName":"Region"}},"S7q":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccessPoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAccessPointsForObjectLambda":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ObjectLambdaAccessPointList"},"ListJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMultiRegionAccessPoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRegionalBuckets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListStorageLensConfigurations":{"input_token":"NextToken","output_token":"NextToken"}}}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['servicecatalog'] = {};
	AWS.ServiceCatalog = Service.defineService('servicecatalog', ['2015-12-10']);
	Object.defineProperty(apiLoader.services['servicecatalog'], '2015-12-10', {
	  get: function get() {
	    var model = __webpack_require__(434);
	    model.paginators = __webpack_require__(435).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ServiceCatalog;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-10","endpointPrefix":"servicecatalog","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Service Catalog","serviceId":"Service Catalog","signatureVersion":"v4","targetPrefix":"AWS242ServiceCatalogService","uid":"servicecatalog-2015-12-10"},"operations":{"AcceptPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"AssociateBudgetWithResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"AssociatePrincipalWithPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN","PrincipalType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"AssociateProductWithPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"AssociateTagOptionWithResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sm"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sp"}}}},"BatchDisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sm"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sp"}}}},"CopyProduct":{"input":{"type":"structure","required":["SourceProductArn","IdempotencyToken"],"members":{"AcceptLanguage":{},"SourceProductArn":{},"TargetProductId":{},"TargetProductName":{},"SourceProvisioningArtifactIdentifiers":{"type":"list","member":{"type":"map","key":{},"value":{}}},"CopyOptions":{"type":"list","member":{}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CopyProductToken":{}}}},"CreateConstraint":{"input":{"type":"structure","required":["PortfolioId","ProductId","Parameters","Type","IdempotencyToken"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"Parameters":{},"Type":{},"Description":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"CreatePortfolio":{"input":{"type":"structure","required":["DisplayName","ProviderName","IdempotencyToken"],"members":{"AcceptLanguage":{},"DisplayName":{},"Description":{},"ProviderName":{},"Tags":{"shape":"S1i"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"CreatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"},"ShareTagOptions":{"type":"boolean"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"CreateProduct":{"input":{"type":"structure","required":["Name","Owner","ProductType","ProvisioningArtifactParameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"ProductType":{},"Tags":{"shape":"S1i"},"ProvisioningArtifactParameters":{"shape":"S24"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2d"},"ProvisioningArtifactDetail":{"shape":"S2i"},"Tags":{"shape":"S1q"}}}},"CreateProvisionedProductPlan":{"input":{"type":"structure","required":["PlanName","PlanType","ProductId","ProvisionedProductName","ProvisioningArtifactId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanName":{},"PlanType":{},"NotificationArns":{"shape":"S2o"},"PathId":{},"ProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{},"ProvisioningParameters":{"shape":"S2r"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"S1q"}}},"output":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{}}}},"CreateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","Parameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"Parameters":{"shape":"S24"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2i"},"Info":{"shape":"S27"},"Status":{}}}},"CreateServiceAction":{"input":{"type":"structure","required":["Name","DefinitionType","Definition","IdempotencyToken"],"members":{"Name":{},"DefinitionType":{},"Definition":{"shape":"S32"},"Description":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S37"}}}},"CreateTagOption":{"input":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3d"}}}},"DeleteConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"DeleteProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeleteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"IgnoreErrors":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{}}},"output":{"type":"structure","members":{}}},"DeleteServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"DeleteTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DescribeConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"DescribeCopyProductStatus":{"input":{"type":"structure","required":["CopyProductToken"],"members":{"AcceptLanguage":{},"CopyProductToken":{}}},"output":{"type":"structure","members":{"CopyProductStatus":{},"TargetProductId":{},"StatusDetail":{}}}},"DescribePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S45"},"Budgets":{"shape":"S46"}}}},"DescribePortfolioShareStatus":{"input":{"type":"structure","required":["PortfolioShareToken"],"members":{"PortfolioShareToken":{}}},"output":{"type":"structure","members":{"PortfolioShareToken":{},"PortfolioId":{},"OrganizationNodeValue":{},"Status":{},"ShareDetails":{"type":"structure","members":{"SuccessfulShares":{"type":"list","member":{}},"ShareErrors":{"type":"list","member":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Message":{},"Error":{}}}}}}}}},"DescribePortfolioShares":{"input":{"type":"structure","required":["PortfolioId","Type"],"members":{"PortfolioId":{},"Type":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageToken":{},"PortfolioShareDetails":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"Type":{},"Accepted":{"type":"boolean"},"ShareTagOptions":{"type":"boolean"}}}}}}},"DescribeProduct":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2e"},"ProvisioningArtifacts":{"shape":"S4r"},"Budgets":{"shape":"S46"},"LaunchPaths":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}},"DescribeProductAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2d"},"ProvisioningArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProvisioningArtifactMetadata":{"shape":"S27"}}}},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S45"},"Budgets":{"shape":"S46"}}}},"DescribeProductView":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2e"},"ProvisioningArtifacts":{"shape":"S4r"}}}},"DescribeProvisionedProduct":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{}}},"output":{"type":"structure","members":{"ProvisionedProductDetail":{"shape":"S55"},"CloudWatchDashboards":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}},"DescribeProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProductPlanDetails":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"PathId":{},"ProductId":{},"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{},"Status":{},"UpdatedTime":{"type":"timestamp"},"NotificationArns":{"shape":"S2o"},"ProvisioningParameters":{"shape":"S2r"},"Tags":{"shape":"S1q"},"StatusMessage":{}}},"ResourceChanges":{"type":"list","member":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"CausingEntity":{}}}}}}},"NextPageToken":{}}}},"DescribeProvisioningArtifact":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisioningArtifactId":{},"ProductId":{},"ProvisioningArtifactName":{},"ProductName":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2i"},"Info":{"shape":"S27"},"Status":{}}}},"DescribeProvisioningParameters":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"PathId":{},"PathName":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactParameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"IsNoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}},"AllowedPattern":{},"ConstraintDescription":{},"MaxLength":{},"MinLength":{},"MaxValue":{},"MinValue":{}}}}}},"ConstraintSummaries":{"shape":"S6h"},"UsageInstructions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"TagOptions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ProvisioningArtifactPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6r"},"StackSetRegions":{"shape":"S6s"}}},"ProvisioningArtifactOutputs":{"shape":"S6u","deprecated":true,"deprecatedMessage":"This property is deprecated and returns the Id and Description of the Provisioning Artifact. Use ProvisioningArtifactOutputKeys instead to get the Keys and Descriptions of the outputs."},"ProvisioningArtifactOutputKeys":{"shape":"S6u"}}}},"DescribeRecord":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"},"RecordOutputs":{"shape":"S7b"},"NextPageToken":{}}}},"DescribeServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S37"}}}},"DescribeServiceActionExecutionParameters":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionParameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"DefaultValues":{"shape":"S7n"}}}}}}},"DescribeTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3d"}}}},"DisableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateBudgetFromResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"DisassociatePrincipalFromPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{}}},"output":{"type":"structure","members":{}}},"DisassociateProductFromPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"DisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"DisassociateTagOptionFromResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"EnableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ExecuteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"}}}},"ExecuteProvisionedProductServiceAction":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId","ExecuteToken"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"ExecuteToken":{"idempotencyToken":true},"AcceptLanguage":{},"Parameters":{"type":"map","key":{},"value":{"shape":"S7n"}}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"}}}},"GetAWSOrganizationsAccessStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccessStatus":{}}}},"GetProvisionedProductOutputs":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionedProductId":{},"ProvisionedProductName":{},"OutputKeys":{"type":"list","member":{}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Outputs":{"shape":"S7b"},"NextPageToken":{}}}},"ImportAsProvisionedProduct":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ProvisionedProductName","PhysicalId","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"ProvisionedProductName":{},"PhysicalId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"}}}},"ListAcceptedPortfolioShares":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"},"PortfolioShareType":{}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S8l"},"NextPageToken":{}}}},"ListBudgetsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"AcceptLanguage":{},"ResourceId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Budgets":{"shape":"S46"},"NextPageToken":{}}}},"ListConstraintsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ConstraintDetails":{"type":"list","member":{"shape":"S1b"}},"NextPageToken":{}}}},"ListLaunchPaths":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"LaunchPathSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"ConstraintSummaries":{"shape":"S6h"},"Tags":{"shape":"S1q"},"Name":{}}}},"NextPageToken":{}}}},"ListOrganizationPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId","OrganizationNodeType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationNodeType":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationNodes":{"type":"list","member":{"shape":"S1s"}},"NextPageToken":{}}}},"ListPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationParentId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextPageToken":{}}}},"ListPortfolios":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S8l"},"NextPageToken":{}}}},"ListPortfoliosForProduct":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S8l"},"NextPageToken":{}}}},"ListPrincipalsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"PrincipalARN":{},"PrincipalType":{}}}},"NextPageToken":{}}}},"ListProvisionedProductPlans":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionProductId":{},"PageSize":{"type":"integer"},"PageToken":{},"AccessLevelFilter":{"shape":"S9a"}}},"output":{"type":"structure","members":{"ProvisionedProductPlans":{"type":"list","member":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{}}}},"NextPageToken":{}}}},"ListProvisioningArtifacts":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetails":{"type":"list","member":{"shape":"S2i"}},"NextPageToken":{}}}},"ListProvisioningArtifactsForServiceAction":{"input":{"type":"structure","required":["ServiceActionId"],"members":{"ServiceActionId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactViews":{"type":"list","member":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2e"},"ProvisioningArtifact":{"shape":"S4s"}}}},"NextPageToken":{}}}},"ListRecordHistory":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S9a"},"SearchFilter":{"type":"structure","members":{"Key":{},"Value":{}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"RecordDetails":{"type":"list","member":{"shape":"S70"}},"NextPageToken":{}}}},"ListResourcesForTagOption":{"input":{"type":"structure","required":["TagOptionId"],"members":{"TagOptionId":{},"ResourceType":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ResourceDetails":{"type":"list","member":{"type":"structure","members":{"Id":{},"ARN":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"PageToken":{}}}},"ListServiceActions":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"Sa5"},"NextPageToken":{}}}},"ListServiceActionsForProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"Sa5"},"NextPageToken":{}}}},"ListStackInstancesForProvisionedProduct":{"input":{"type":"structure","required":["ProvisionedProductId"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"StackInstances":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"StackInstanceStatus":{}}}},"NextPageToken":{}}}},"ListTagOptions":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"TagOptionDetails":{"shape":"S45"},"PageToken":{}}}},"ProvisionProduct":{"input":{"type":"structure","required":["ProvisionedProductName","ProvisionToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"PathId":{},"PathName":{},"ProvisionedProductName":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6r"},"StackSetRegions":{"shape":"S6s"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"}}},"Tags":{"shape":"S1q"},"NotificationArns":{"shape":"S2o"},"ProvisionToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"}}}},"RejectPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"ScanProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S9a"},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"shape":"S55"}},"NextPageToken":{}}}},"SearchProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Filters":{"shape":"Sav"},"PageSize":{"type":"integer"},"SortBy":{},"SortOrder":{},"PageToken":{}}},"output":{"type":"structure","members":{"ProductViewSummaries":{"type":"list","member":{"shape":"S2e"}},"ProductViewAggregations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Value":{},"ApproximateCount":{"type":"integer"}}}}},"NextPageToken":{}}}},"SearchProductsAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PortfolioId":{},"Filters":{"shape":"Sav"},"SortBy":{},"SortOrder":{},"PageToken":{},"PageSize":{"type":"integer"},"ProductSource":{}}},"output":{"type":"structure","members":{"ProductViewDetails":{"type":"list","member":{"shape":"S2d"}},"NextPageToken":{}}}},"SearchProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S9a"},"Filters":{"type":"map","key":{},"value":{"type":"list","member":{}}},"SortBy":{},"SortOrder":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"LastProvisioningRecordId":{},"LastSuccessfulProvisioningRecordId":{},"Tags":{"shape":"S1q"},"PhysicalId":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"UserArn":{},"UserArnSession":{}}}},"TotalResultsCount":{"type":"integer"},"NextPageToken":{}}}},"TerminateProvisionedProduct":{"input":{"type":"structure","required":["TerminateToken"],"members":{"ProvisionedProductName":{},"ProvisionedProductId":{},"TerminateToken":{"idempotencyToken":true},"IgnoreErrors":{"type":"boolean"},"AcceptLanguage":{},"RetainPhysicalResources":{"type":"boolean"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"}}}},"UpdateConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Description":{},"Parameters":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"UpdatePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"DisplayName":{},"Description":{},"ProviderName":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sbw"}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"UpdatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"},"ShareTagOptions":{"type":"boolean"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{},"Status":{}}}},"UpdateProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sbw"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2d"},"Tags":{"shape":"S1q"}}}},"UpdateProvisionedProduct":{"input":{"type":"structure","required":["UpdateToken"],"members":{"AcceptLanguage":{},"ProvisionedProductName":{},"ProvisionedProductId":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"PathId":{},"PathName":{},"ProvisioningParameters":{"shape":"S2r"},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6r"},"StackSetRegions":{"shape":"S6s"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"},"StackSetOperationType":{}}},"Tags":{"shape":"S1q"},"UpdateToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S70"}}}},"UpdateProvisionedProductProperties":{"input":{"type":"structure","required":["ProvisionedProductId","ProvisionedProductProperties","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sc8"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sc8"},"RecordId":{},"Status":{}}}},"UpdateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"Name":{},"Description":{},"Active":{"type":"boolean"},"Guidance":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2i"},"Info":{"shape":"S27"},"Status":{}}}},"UpdateServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Name":{},"Definition":{"shape":"S32"},"Description":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S37"}}}},"UpdateTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Value":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3d"}}}}},"shapes":{"Sm":{"type":"list","member":{"type":"structure","required":["ServiceActionId","ProductId","ProvisioningArtifactId"],"members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{}}}},"Sp":{"type":"list","member":{"type":"structure","members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{},"ErrorCode":{},"ErrorMessage":{}}}},"S1b":{"type":"structure","members":{"ConstraintId":{},"Type":{},"Description":{},"Owner":{},"ProductId":{},"PortfolioId":{}}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S1n":{"type":"structure","members":{"Id":{},"ARN":{},"DisplayName":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProviderName":{}}},"S1q":{"type":"list","member":{"shape":"S1j"}},"S1s":{"type":"structure","members":{"Type":{},"Value":{}}},"S24":{"type":"structure","required":["Info"],"members":{"Name":{},"Description":{},"Info":{"shape":"S27"},"Type":{},"DisableTemplateValidation":{"type":"boolean"}}},"S27":{"type":"map","key":{},"value":{}},"S2d":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2e"},"Status":{},"ProductARN":{},"CreatedTime":{"type":"timestamp"}}},"S2e":{"type":"structure","members":{"Id":{},"ProductId":{},"Name":{},"Owner":{},"ShortDescription":{},"Type":{},"Distributor":{},"HasDefaultPath":{"type":"boolean"},"SupportEmail":{},"SupportDescription":{},"SupportUrl":{}}},"S2i":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Type":{},"CreatedTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Guidance":{}}},"S2o":{"type":"list","member":{}},"S2r":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"UsePreviousValue":{"type":"boolean"}}}},"S32":{"type":"map","key":{},"value":{}},"S37":{"type":"structure","members":{"ServiceActionSummary":{"shape":"S38"},"Definition":{"shape":"S32"}}},"S38":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"DefinitionType":{}}},"S3d":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"},"Id":{},"Owner":{}}},"S45":{"type":"list","member":{"shape":"S3d"}},"S46":{"type":"list","member":{"type":"structure","members":{"BudgetName":{}}}},"S4r":{"type":"list","member":{"shape":"S4s"}},"S4s":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"Guidance":{}}},"S55":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"LastProvisioningRecordId":{},"LastSuccessfulProvisioningRecordId":{},"ProductId":{},"ProvisioningArtifactId":{},"LaunchRoleArn":{}}},"S6h":{"type":"list","member":{"type":"structure","members":{"Type":{},"Description":{}}}},"S6r":{"type":"list","member":{}},"S6s":{"type":"list","member":{}},"S6u":{"type":"list","member":{"type":"structure","members":{"Key":{},"Description":{}}}},"S70":{"type":"structure","members":{"RecordId":{},"ProvisionedProductName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ProvisionedProductType":{},"RecordType":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"RecordErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Description":{}}}},"RecordTags":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"LaunchRoleArn":{}}},"S7b":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{}}}},"S7n":{"type":"list","member":{}},"S8l":{"type":"list","member":{"shape":"S1n"}},"S9a":{"type":"structure","members":{"Key":{},"Value":{}}},"Sa5":{"type":"list","member":{"shape":"S38"}},"Sav":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sbw":{"type":"list","member":{}},"Sc8":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribePortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"GetProvisionedProductOutputs":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListAcceptedPortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListBudgetsForResource":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListConstraintsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListLaunchPaths":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListOrganizationPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolios":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfoliosForProduct":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPrincipalsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListProvisioningArtifactsForServiceAction":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListResourcesForTagOption":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"ListServiceActions":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListServiceActionsForProvisioningArtifact":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListTagOptions":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"SearchProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProductsAsAdmin":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProvisionedProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"}}}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ses'] = {};
	AWS.SES = Service.defineService('ses', ['2010-12-01']);
	Object.defineProperty(apiLoader.services['ses'], '2010-12-01', {
	  get: function get() {
	    var model = __webpack_require__(437);
	    model.paginators = __webpack_require__(438).pagination;
	    model.waiters = __webpack_require__(439).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SES;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"email","protocol":"query","serviceAbbreviation":"Amazon SES","serviceFullName":"Amazon Simple Email Service","serviceId":"SES","signatureVersion":"v4","signingName":"ses","uid":"email-2010-12-01","xmlNamespace":"http://ses.amazonaws.com/doc/2010-12-01/"},"operations":{"CloneReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","OriginalRuleSetName"],"members":{"RuleSetName":{},"OriginalRuleSetName":{}}},"output":{"resultWrapper":"CloneReceiptRuleSetResult","type":"structure","members":{}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSet"],"members":{"ConfigurationSet":{"shape":"S5"}}},"output":{"resultWrapper":"CreateConfigurationSetResult","type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"CreateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"CreateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"CreateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"CreateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"CreateReceiptFilter":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{"shape":"S10"}}},"output":{"resultWrapper":"CreateReceiptFilterResult","type":"structure","members":{}}},"CreateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"After":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"CreateReceiptRuleResult","type":"structure","members":{}}},"CreateReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"CreateReceiptRuleSetResult","type":"structure","members":{}}},"CreateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"CreateTemplateResult","type":"structure","members":{}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetResult","type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetEventDestinationResult","type":"structure","members":{}}},"DeleteConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"DeleteCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}}},"DeleteIdentity":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"DeleteIdentityResult","type":"structure","members":{}}},"DeleteIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName"],"members":{"Identity":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteIdentityPolicyResult","type":"structure","members":{}}},"DeleteReceiptFilter":{"input":{"type":"structure","required":["FilterName"],"members":{"FilterName":{}}},"output":{"resultWrapper":"DeleteReceiptFilterResult","type":"structure","members":{}}},"DeleteReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleResult","type":"structure","members":{}}},"DeleteReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleSetResult","type":"structure","members":{}}},"DeleteTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"DeleteTemplateResult","type":"structure","members":{}}},"DeleteVerifiedEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"DescribeActiveReceiptRuleSet":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeActiveReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"DescribeConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"ConfigurationSetAttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeConfigurationSetResult","type":"structure","members":{"ConfigurationSet":{"shape":"S5"},"EventDestinations":{"type":"list","member":{"shape":"S9"}},"TrackingOptions":{"shape":"Sp"},"DeliveryOptions":{"shape":"S31"},"ReputationOptions":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"},"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}}}}},"DescribeReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleResult","type":"structure","members":{"Rule":{"shape":"S18"}}}},"DescribeReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"GetAccountSendingEnabled":{"output":{"resultWrapper":"GetAccountSendingEnabledResult","type":"structure","members":{"Enabled":{"type":"boolean"}}}},"GetCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetCustomVerificationEmailTemplateResult","type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"GetIdentityDkimAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityDkimAttributesResult","type":"structure","required":["DkimAttributes"],"members":{"DkimAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["DkimEnabled","DkimVerificationStatus"],"members":{"DkimEnabled":{"type":"boolean"},"DkimVerificationStatus":{},"DkimTokens":{"shape":"S3h"}}}}}}},"GetIdentityMailFromDomainAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityMailFromDomainAttributesResult","type":"structure","required":["MailFromDomainAttributes"],"members":{"MailFromDomainAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMXFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMXFailure":{}}}}}}},"GetIdentityNotificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityNotificationAttributesResult","type":"structure","required":["NotificationAttributes"],"members":{"NotificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["BounceTopic","ComplaintTopic","DeliveryTopic","ForwardingEnabled"],"members":{"BounceTopic":{},"ComplaintTopic":{},"DeliveryTopic":{},"ForwardingEnabled":{"type":"boolean"},"HeadersInBounceNotificationsEnabled":{"type":"boolean"},"HeadersInComplaintNotificationsEnabled":{"type":"boolean"},"HeadersInDeliveryNotificationsEnabled":{"type":"boolean"}}}}}}},"GetIdentityPolicies":{"input":{"type":"structure","required":["Identity","PolicyNames"],"members":{"Identity":{},"PolicyNames":{"shape":"S3w"}}},"output":{"resultWrapper":"GetIdentityPoliciesResult","type":"structure","required":["Policies"],"members":{"Policies":{"type":"map","key":{},"value":{}}}}},"GetIdentityVerificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityVerificationAttributesResult","type":"structure","required":["VerificationAttributes"],"members":{"VerificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["VerificationStatus"],"members":{"VerificationStatus":{},"VerificationToken":{}}}}}}},"GetSendQuota":{"output":{"resultWrapper":"GetSendQuotaResult","type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}}},"GetSendStatistics":{"output":{"resultWrapper":"GetSendStatisticsResult","type":"structure","members":{"SendDataPoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"DeliveryAttempts":{"type":"long"},"Bounces":{"type":"long"},"Complaints":{"type":"long"},"Rejects":{"type":"long"}}}}}}},"GetTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"Template":{"shape":"S20"}}}},"ListConfigurationSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListConfigurationSetsResult","type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListCustomVerificationEmailTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListCustomVerificationEmailTemplatesResult","type":"structure","members":{"CustomVerificationEmailTemplates":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"NextToken":{}}}},"ListIdentities":{"input":{"type":"structure","members":{"IdentityType":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListIdentitiesResult","type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"},"NextToken":{}}}},"ListIdentityPolicies":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"ListIdentityPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S3w"}}}},"ListReceiptFilters":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListReceiptFiltersResult","type":"structure","members":{"Filters":{"type":"list","member":{"shape":"S10"}}}}},"ListReceiptRuleSets":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListReceiptRuleSetsResult","type":"structure","members":{"RuleSets":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListTemplatesResult","type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListVerifiedEmailAddresses":{"output":{"resultWrapper":"ListVerifiedEmailAddressesResult","type":"structure","members":{"VerifiedEmailAddresses":{"shape":"S54"}}}},"PutConfigurationSetDeliveryOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"DeliveryOptions":{"shape":"S31"}}},"output":{"resultWrapper":"PutConfigurationSetDeliveryOptionsResult","type":"structure","members":{}}},"PutIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName","Policy"],"members":{"Identity":{},"PolicyName":{},"Policy":{}}},"output":{"resultWrapper":"PutIdentityPolicyResult","type":"structure","members":{}}},"ReorderReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","RuleNames"],"members":{"RuleSetName":{},"RuleNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"ReorderReceiptRuleSetResult","type":"structure","members":{}}},"SendBounce":{"input":{"type":"structure","required":["OriginalMessageId","BounceSender","BouncedRecipientInfoList"],"members":{"OriginalMessageId":{},"BounceSender":{},"Explanation":{},"MessageDsn":{"type":"structure","required":["ReportingMta"],"members":{"ReportingMta":{},"ArrivalDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}},"BouncedRecipientInfoList":{"type":"list","member":{"type":"structure","required":["Recipient"],"members":{"Recipient":{},"RecipientArn":{},"BounceType":{},"RecipientDsnFields":{"type":"structure","required":["Action","Status"],"members":{"FinalRecipient":{},"Action":{},"RemoteMta":{},"Status":{},"DiagnosticCode":{},"LastAttemptDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}}}}},"BounceSenderArn":{}}},"output":{"resultWrapper":"SendBounceResult","type":"structure","members":{"MessageId":{}}}},"SendBulkTemplatedEmail":{"input":{"type":"structure","required":["Source","Template","Destinations"],"members":{"Source":{},"SourceArn":{},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"ReturnPathArn":{},"ConfigurationSetName":{},"DefaultTags":{"shape":"S5x"},"Template":{},"TemplateArn":{},"DefaultTemplateData":{},"Destinations":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S64"},"ReplacementTags":{"shape":"S5x"},"ReplacementTemplateData":{}}}}}},"output":{"resultWrapper":"SendBulkTemplatedEmailResult","type":"structure","required":["Status"],"members":{"Status":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendCustomVerificationEmail":{"input":{"type":"structure","required":["EmailAddress","TemplateName"],"members":{"EmailAddress":{},"TemplateName":{},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendCustomVerificationEmailResult","type":"structure","members":{"MessageId":{}}}},"SendEmail":{"input":{"type":"structure","required":["Source","Destination","Message"],"members":{"Source":{},"Destination":{"shape":"S64"},"Message":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S6e"},"Body":{"type":"structure","members":{"Text":{"shape":"S6e"},"Html":{"shape":"S6e"}}}}},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendRawEmail":{"input":{"type":"structure","required":["RawMessage"],"members":{"Source":{},"Destinations":{"shape":"S54"},"RawMessage":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"FromArn":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendRawEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendTemplatedEmail":{"input":{"type":"structure","required":["Source","Destination","Template","TemplateData"],"members":{"Source":{},"Destination":{"shape":"S64"},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{},"Template":{},"TemplateArn":{},"TemplateData":{}}},"output":{"resultWrapper":"SendTemplatedEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SetActiveReceiptRuleSet":{"input":{"type":"structure","members":{"RuleSetName":{}}},"output":{"resultWrapper":"SetActiveReceiptRuleSetResult","type":"structure","members":{}}},"SetIdentityDkimEnabled":{"input":{"type":"structure","required":["Identity","DkimEnabled"],"members":{"Identity":{},"DkimEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityDkimEnabledResult","type":"structure","members":{}}},"SetIdentityFeedbackForwardingEnabled":{"input":{"type":"structure","required":["Identity","ForwardingEnabled"],"members":{"Identity":{},"ForwardingEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityFeedbackForwardingEnabledResult","type":"structure","members":{}}},"SetIdentityHeadersInNotificationsEnabled":{"input":{"type":"structure","required":["Identity","NotificationType","Enabled"],"members":{"Identity":{},"NotificationType":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityHeadersInNotificationsEnabledResult","type":"structure","members":{}}},"SetIdentityMailFromDomain":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{},"MailFromDomain":{},"BehaviorOnMXFailure":{}}},"output":{"resultWrapper":"SetIdentityMailFromDomainResult","type":"structure","members":{}}},"SetIdentityNotificationTopic":{"input":{"type":"structure","required":["Identity","NotificationType"],"members":{"Identity":{},"NotificationType":{},"SnsTopic":{}}},"output":{"resultWrapper":"SetIdentityNotificationTopicResult","type":"structure","members":{}}},"SetReceiptRulePosition":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{},"After":{}}},"output":{"resultWrapper":"SetReceiptRulePositionResult","type":"structure","members":{}}},"TestRenderTemplate":{"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{},"TemplateData":{}}},"output":{"resultWrapper":"TestRenderTemplateResult","type":"structure","members":{"RenderedTemplate":{}}}},"UpdateAccountSendingEnabled":{"input":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"UpdateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"UpdateConfigurationSetReputationMetricsEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetSendingEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"UpdateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"UpdateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"UpdateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"UpdateReceiptRuleResult","type":"structure","members":{}}},"UpdateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"UpdateTemplateResult","type":"structure","members":{}}},"VerifyDomainDkim":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainDkimResult","type":"structure","required":["DkimTokens"],"members":{"DkimTokens":{"shape":"S3h"}}}},"VerifyDomainIdentity":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainIdentityResult","type":"structure","required":["VerificationToken"],"members":{"VerificationToken":{}}}},"VerifyEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"VerifyEmailIdentity":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}},"output":{"resultWrapper":"VerifyEmailIdentityResult","type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S9":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"type":"list","member":{}},"KinesisFirehoseDestination":{"type":"structure","required":["IAMRoleARN","DeliveryStreamARN"],"members":{"IAMRoleARN":{},"DeliveryStreamARN":{}}},"CloudWatchDestination":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"SNSDestination":{"type":"structure","required":["TopicARN"],"members":{"TopicARN":{}}}}},"Sp":{"type":"structure","members":{"CustomRedirectDomain":{}}},"S10":{"type":"structure","required":["Name","IpFilter"],"members":{"Name":{},"IpFilter":{"type":"structure","required":["Policy","Cidr"],"members":{"Policy":{},"Cidr":{}}}}},"S18":{"type":"structure","required":["Name"],"members":{"Name":{},"Enabled":{"type":"boolean"},"TlsPolicy":{},"Recipients":{"type":"list","member":{}},"Actions":{"type":"list","member":{"type":"structure","members":{"S3Action":{"type":"structure","required":["BucketName"],"members":{"TopicArn":{},"BucketName":{},"ObjectKeyPrefix":{},"KmsKeyArn":{}}},"BounceAction":{"type":"structure","required":["SmtpReplyCode","Message","Sender"],"members":{"TopicArn":{},"SmtpReplyCode":{},"StatusCode":{},"Message":{},"Sender":{}}},"WorkmailAction":{"type":"structure","required":["OrganizationArn"],"members":{"TopicArn":{},"OrganizationArn":{}}},"LambdaAction":{"type":"structure","required":["FunctionArn"],"members":{"TopicArn":{},"FunctionArn":{},"InvocationType":{}}},"StopAction":{"type":"structure","required":["Scope"],"members":{"Scope":{},"TopicArn":{}}},"AddHeaderAction":{"type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}},"SNSAction":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"Encoding":{}}}}}},"ScanEnabled":{"type":"boolean"}}},"S20":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"SubjectPart":{},"TextPart":{},"HtmlPart":{}}},"S2t":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}},"S2v":{"type":"list","member":{"shape":"S18"}},"S31":{"type":"structure","members":{"TlsPolicy":{}}},"S3c":{"type":"list","member":{}},"S3h":{"type":"list","member":{}},"S3w":{"type":"list","member":{}},"S54":{"type":"list","member":{}},"S5i":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5x":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S64":{"type":"structure","members":{"ToAddresses":{"shape":"S54"},"CcAddresses":{"shape":"S54"},"BccAddresses":{"shape":"S54"}}},"S6e":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}}}}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCustomVerificationEmailTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListIdentities":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"Identities"},"ListVerifiedEmailAddresses":{"result_key":"VerifiedEmailAddresses"}}}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['shield'] = {};
	AWS.Shield = Service.defineService('shield', ['2016-06-02']);
	Object.defineProperty(apiLoader.services['shield'], '2016-06-02', {
	  get: function get() {
	    var model = __webpack_require__(441);
	    model.paginators = __webpack_require__(442).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Shield;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-02","endpointPrefix":"shield","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Shield","serviceFullName":"AWS Shield","serviceId":"Shield","signatureVersion":"v4","targetPrefix":"AWSShield_20160616","uid":"shield-2016-06-02"},"operations":{"AssociateDRTLogBucket":{"input":{"type":"structure","required":["LogBucket"],"members":{"LogBucket":{}}},"output":{"type":"structure","members":{}}},"AssociateDRTRole":{"input":{"type":"structure","required":["RoleArn"],"members":{"RoleArn":{}}},"output":{"type":"structure","members":{}}},"AssociateHealthCheck":{"input":{"type":"structure","required":["ProtectionId","HealthCheckArn"],"members":{"ProtectionId":{},"HealthCheckArn":{}}},"output":{"type":"structure","members":{}}},"AssociateProactiveEngagementDetails":{"input":{"type":"structure","required":["EmergencyContactList"],"members":{"EmergencyContactList":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateProtection":{"input":{"type":"structure","required":["Name","ResourceArn"],"members":{"Name":{},"ResourceArn":{},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"ProtectionId":{}}}},"CreateProtectionGroup":{"input":{"type":"structure","required":["ProtectionGroupId","Aggregation","Pattern"],"members":{"ProtectionGroupId":{},"Aggregation":{},"Pattern":{},"ResourceType":{},"Members":{"shape":"Sv"},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"CreateSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteProtection":{"input":{"type":"structure","required":["ProtectionId"],"members":{"ProtectionId":{}}},"output":{"type":"structure","members":{}}},"DeleteProtectionGroup":{"input":{"type":"structure","required":["ProtectionGroupId"],"members":{"ProtectionGroupId":{}}},"output":{"type":"structure","members":{}}},"DeleteSubscription":{"input":{"type":"structure","members":{},"deprecated":true},"output":{"type":"structure","members":{},"deprecated":true},"deprecated":true},"DescribeAttack":{"input":{"type":"structure","required":["AttackId"],"members":{"AttackId":{}}},"output":{"type":"structure","members":{"Attack":{"type":"structure","members":{"AttackId":{},"ResourceArn":{},"SubResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Id":{},"AttackVectors":{"type":"list","member":{"type":"structure","required":["VectorType"],"members":{"VectorType":{},"VectorCounters":{"shape":"S1f"}}}},"Counters":{"shape":"S1f"}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"AttackCounters":{"shape":"S1f"},"AttackProperties":{"type":"list","member":{"type":"structure","members":{"AttackLayer":{},"AttackPropertyIdentifier":{},"TopContributors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"long"}}}},"Unit":{},"Total":{"type":"long"}}}},"Mitigations":{"type":"list","member":{"type":"structure","members":{"MitigationName":{}}}}}}}}},"DescribeAttackStatistics":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TimeRange","DataItems"],"members":{"TimeRange":{"shape":"S1w"},"DataItems":{"type":"list","member":{"type":"structure","required":["AttackCount"],"members":{"AttackVolume":{"type":"structure","members":{"BitsPerSecond":{"shape":"S21"},"PacketsPerSecond":{"shape":"S21"},"RequestsPerSecond":{"shape":"S21"}}},"AttackCount":{"type":"long"}}}}}}},"DescribeDRTAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"RoleArn":{},"LogBucketList":{"type":"list","member":{}}}}},"DescribeEmergencyContactSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EmergencyContactList":{"shape":"Sc"}}}},"DescribeProtection":{"input":{"type":"structure","members":{"ProtectionId":{},"ResourceArn":{}}},"output":{"type":"structure","members":{"Protection":{"shape":"S29"}}}},"DescribeProtectionGroup":{"input":{"type":"structure","required":["ProtectionGroupId"],"members":{"ProtectionGroupId":{}}},"output":{"type":"structure","required":["ProtectionGroup"],"members":{"ProtectionGroup":{"shape":"S2j"}}}},"DescribeSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Subscription":{"type":"structure","required":["SubscriptionLimits"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TimeCommitmentInSeconds":{"type":"long"},"AutoRenew":{},"Limits":{"shape":"S2p"},"ProactiveEngagementStatus":{},"SubscriptionLimits":{"type":"structure","required":["ProtectionLimits","ProtectionGroupLimits"],"members":{"ProtectionLimits":{"type":"structure","required":["ProtectedResourceTypeLimits"],"members":{"ProtectedResourceTypeLimits":{"shape":"S2p"}}},"ProtectionGroupLimits":{"type":"structure","required":["MaxProtectionGroups","PatternTypeLimits"],"members":{"MaxProtectionGroups":{"type":"long"},"PatternTypeLimits":{"type":"structure","required":["ArbitraryPatternLimits"],"members":{"ArbitraryPatternLimits":{"type":"structure","required":["MaxMembers"],"members":{"MaxMembers":{"type":"long"}}}}}}}}},"SubscriptionArn":{}}}}}},"DisableApplicationLayerAutomaticResponse":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DisableProactiveEngagement":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateDRTLogBucket":{"input":{"type":"structure","required":["LogBucket"],"members":{"LogBucket":{}}},"output":{"type":"structure","members":{}}},"DisassociateDRTRole":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateHealthCheck":{"input":{"type":"structure","required":["ProtectionId","HealthCheckArn"],"members":{"ProtectionId":{},"HealthCheckArn":{}}},"output":{"type":"structure","members":{}}},"EnableApplicationLayerAutomaticResponse":{"input":{"type":"structure","required":["ResourceArn","Action"],"members":{"ResourceArn":{},"Action":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"EnableProactiveEngagement":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"GetSubscriptionState":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["SubscriptionState"],"members":{"SubscriptionState":{}}}},"ListAttacks":{"input":{"type":"structure","members":{"ResourceArns":{"type":"list","member":{}},"StartTime":{"shape":"S1w"},"EndTime":{"shape":"S1w"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AttackSummaries":{"type":"list","member":{"type":"structure","members":{"AttackId":{},"ResourceArn":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"AttackVectors":{"type":"list","member":{"type":"structure","required":["VectorType"],"members":{"VectorType":{}}}}}}},"NextToken":{}}}},"ListProtectionGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ProtectionGroups"],"members":{"ProtectionGroups":{"type":"list","member":{"shape":"S2j"}},"NextToken":{}}}},"ListProtections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Protections":{"type":"list","member":{"shape":"S29"}},"NextToken":{}}}},"ListResourcesInProtectionGroup":{"input":{"type":"structure","required":["ProtectionGroupId"],"members":{"ProtectionGroupId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"type":"list","member":{}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sl"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplicationLayerAutomaticResponse":{"input":{"type":"structure","required":["ResourceArn","Action"],"members":{"ResourceArn":{},"Action":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"UpdateEmergencyContactSettings":{"input":{"type":"structure","members":{"EmergencyContactList":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"UpdateProtectionGroup":{"input":{"type":"structure","required":["ProtectionGroupId","Aggregation","Pattern"],"members":{"ProtectionGroupId":{},"Aggregation":{},"Pattern":{},"ResourceType":{},"Members":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"UpdateSubscription":{"input":{"type":"structure","members":{"AutoRenew":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sc":{"type":"list","member":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{},"PhoneNumber":{},"ContactNotes":{}}}},"Sl":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sv":{"type":"list","member":{}},"S1f":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"N":{"type":"integer"},"Unit":{}}}},"S1w":{"type":"structure","members":{"FromInclusive":{"type":"timestamp"},"ToExclusive":{"type":"timestamp"}}},"S21":{"type":"structure","required":["Max"],"members":{"Max":{"type":"double"}}},"S29":{"type":"structure","members":{"Id":{},"Name":{},"ResourceArn":{},"HealthCheckIds":{"type":"list","member":{}},"ProtectionArn":{},"ApplicationLayerAutomaticResponseConfiguration":{"type":"structure","required":["Status","Action"],"members":{"Status":{},"Action":{"shape":"S2e"}}}}},"S2e":{"type":"structure","members":{"Block":{"type":"structure","members":{}},"Count":{"type":"structure","members":{}}}},"S2j":{"type":"structure","required":["ProtectionGroupId","Aggregation","Pattern","Members"],"members":{"ProtectionGroupId":{},"Aggregation":{},"Pattern":{},"ResourceType":{},"Members":{"shape":"Sv"},"ProtectionGroupArn":{}}},"S2p":{"type":"list","member":{"type":"structure","members":{"Type":{},"Max":{"type":"long"}}}}}}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAttacks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AttackSummaries"},"ListProtectionGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListProtections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Protections"},"ListResourcesInProtectionGroup":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['simpledb'] = {};
	AWS.SimpleDB = Service.defineService('simpledb', ['2009-04-15']);
	Object.defineProperty(apiLoader.services['simpledb'], '2009-04-15', {
	  get: function get() {
	    var model = __webpack_require__(444);
	    model.paginators = __webpack_require__(445).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SimpleDB;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2009-04-15","endpointPrefix":"sdb","serviceFullName":"Amazon SimpleDB","serviceId":"SimpleDB","signatureVersion":"v2","xmlNamespace":"http://sdb.amazonaws.com/doc/2009-04-15/","protocol":"query"},"operations":{"BatchDeleteAttributes":{"input":{"type":"structure","required":["DomainName","Items"],"members":{"DomainName":{},"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["Name"],"members":{"Name":{"locationName":"ItemName"},"Attributes":{"shape":"S5"}}},"flattened":true}}}},"BatchPutAttributes":{"input":{"type":"structure","required":["DomainName","Items"],"members":{"DomainName":{},"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["Name","Attributes"],"members":{"Name":{"locationName":"ItemName"},"Attributes":{"shape":"Sa"}}},"flattened":true}}}},"CreateDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}}},"DeleteAttributes":{"input":{"type":"structure","required":["DomainName","ItemName"],"members":{"DomainName":{},"ItemName":{},"Attributes":{"shape":"S5"},"Expected":{"shape":"Sf"}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}}},"DomainMetadata":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DomainMetadataResult","type":"structure","members":{"ItemCount":{"type":"integer"},"ItemNamesSizeBytes":{"type":"long"},"AttributeNameCount":{"type":"integer"},"AttributeNamesSizeBytes":{"type":"long"},"AttributeValueCount":{"type":"integer"},"AttributeValuesSizeBytes":{"type":"long"},"Timestamp":{"type":"integer"}}}},"GetAttributes":{"input":{"type":"structure","required":["DomainName","ItemName"],"members":{"DomainName":{},"ItemName":{},"AttributeNames":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"ConsistentRead":{"type":"boolean"}}},"output":{"resultWrapper":"GetAttributesResult","type":"structure","members":{"Attributes":{"shape":"So"}}}},"ListDomains":{"input":{"type":"structure","members":{"MaxNumberOfDomains":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListDomainsResult","type":"structure","members":{"DomainNames":{"type":"list","member":{"locationName":"DomainName"},"flattened":true},"NextToken":{}}}},"PutAttributes":{"input":{"type":"structure","required":["DomainName","ItemName","Attributes"],"members":{"DomainName":{},"ItemName":{},"Attributes":{"shape":"Sa"},"Expected":{"shape":"Sf"}}}},"Select":{"input":{"type":"structure","required":["SelectExpression"],"members":{"SelectExpression":{},"NextToken":{},"ConsistentRead":{"type":"boolean"}}},"output":{"resultWrapper":"SelectResult","type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["Name","Attributes"],"members":{"Name":{},"AlternateNameEncoding":{},"Attributes":{"shape":"So"}}},"flattened":true},"NextToken":{}}}}},"shapes":{"S5":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}},"flattened":true},"Sa":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{},"Replace":{"type":"boolean"}}},"flattened":true},"Sf":{"type":"structure","members":{"Name":{},"Value":{},"Exists":{"type":"boolean"}}},"So":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name","Value"],"members":{"Name":{},"AlternateNameEncoding":{},"Value":{},"AlternateValueEncoding":{}}},"flattened":true}}}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxNumberOfDomains","result_key":"DomainNames"},"Select":{"input_token":"NextToken","output_token":"NextToken","result_key":"Items"}}}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sms'] = {};
	AWS.SMS = Service.defineService('sms', ['2016-10-24']);
	Object.defineProperty(apiLoader.services['sms'], '2016-10-24', {
	  get: function get() {
	    var model = __webpack_require__(447);
	    model.paginators = __webpack_require__(448).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SMS;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-10-24","endpointPrefix":"sms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"SMS","serviceFullName":"AWS Server Migration Service","serviceId":"SMS","signatureVersion":"v4","targetPrefix":"AWSServerMigrationService_V2016_10_24","uid":"sms-2016-10-24"},"operations":{"CreateApp":{"input":{"type":"structure","members":{"name":{},"description":{},"roleName":{},"clientToken":{},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}},"output":{"type":"structure","members":{"appSummary":{"shape":"St"},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}}},"CreateReplicationJob":{"input":{"type":"structure","required":["serverId","seedReplicationTime"],"members":{"serverId":{},"seedReplicationTime":{"type":"timestamp"},"frequency":{"type":"integer"},"runOnce":{"type":"boolean"},"licenseType":{},"roleName":{},"description":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{}}},"output":{"type":"structure","members":{"replicationJobId":{}}}},"DeleteApp":{"input":{"type":"structure","members":{"appId":{},"forceStopAppReplication":{"type":"boolean"},"forceTerminateApp":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteAppLaunchConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"DeleteAppReplicationConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"DeleteAppValidationConfiguration":{"input":{"type":"structure","required":["appId"],"members":{"appId":{}}},"output":{"type":"structure","members":{}}},"DeleteReplicationJob":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{}}},"output":{"type":"structure","members":{}}},"DeleteServerCatalog":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateConnector":{"input":{"type":"structure","required":["connectorId"],"members":{"connectorId":{}}},"output":{"type":"structure","members":{}}},"GenerateChangeSet":{"input":{"type":"structure","members":{"appId":{},"changesetFormat":{}}},"output":{"type":"structure","members":{"s3Location":{"shape":"S24"}}}},"GenerateTemplate":{"input":{"type":"structure","members":{"appId":{},"templateFormat":{}}},"output":{"type":"structure","members":{"s3Location":{"shape":"S24"}}}},"GetApp":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{"appSummary":{"shape":"St"},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}}},"GetAppLaunchConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{"appId":{},"roleName":{},"autoLaunch":{"type":"boolean"},"serverGroupLaunchConfigurations":{"shape":"S2e"}}}},"GetAppReplicationConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{"serverGroupReplicationConfigurations":{"shape":"S2u"}}}},"GetAppValidationConfiguration":{"input":{"type":"structure","required":["appId"],"members":{"appId":{}}},"output":{"type":"structure","members":{"appValidationConfigurations":{"shape":"S31"},"serverGroupValidationConfigurations":{"shape":"S3c"}}}},"GetAppValidationOutput":{"input":{"type":"structure","required":["appId"],"members":{"appId":{}}},"output":{"type":"structure","members":{"validationOutputList":{"type":"list","member":{"type":"structure","members":{"validationId":{},"name":{},"status":{},"statusMessage":{},"latestValidationTime":{"type":"timestamp"},"appValidationOutput":{"type":"structure","members":{"ssmOutput":{"type":"structure","members":{"s3Location":{"shape":"S24"}}}}},"serverValidationOutput":{"type":"structure","members":{"server":{"shape":"Sb"}}}}}}}}},"GetConnectors":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"connectorList":{"type":"list","member":{"type":"structure","members":{"connectorId":{},"version":{},"status":{},"capabilityList":{"type":"list","member":{}},"vmManagerName":{},"vmManagerType":{},"vmManagerId":{},"ipAddress":{},"macAddress":{},"associatedOn":{"type":"timestamp"}}}},"nextToken":{}}}},"GetReplicationJobs":{"input":{"type":"structure","members":{"replicationJobId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"replicationJobList":{"type":"list","member":{"shape":"S46"}},"nextToken":{}}}},"GetReplicationRuns":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"replicationJob":{"shape":"S46"},"replicationRunList":{"shape":"S4a"},"nextToken":{}}}},"GetServers":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"vmServerAddressList":{"type":"list","member":{"shape":"Sf"}}}},"output":{"type":"structure","members":{"lastModifiedOn":{"type":"timestamp"},"serverCatalogStatus":{},"serverList":{"shape":"Sa"},"nextToken":{}}}},"ImportAppCatalog":{"input":{"type":"structure","members":{"roleName":{}}},"output":{"type":"structure","members":{}}},"ImportServerCatalog":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"LaunchApp":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"ListApps":{"input":{"type":"structure","members":{"appIds":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"apps":{"type":"list","member":{"shape":"St"}},"nextToken":{}}}},"NotifyAppValidationOutput":{"input":{"type":"structure","required":["appId"],"members":{"appId":{},"notificationContext":{"type":"structure","members":{"validationId":{},"status":{},"statusMessage":{}}}}},"output":{"type":"structure","members":{}}},"PutAppLaunchConfiguration":{"input":{"type":"structure","members":{"appId":{},"roleName":{},"autoLaunch":{"type":"boolean"},"serverGroupLaunchConfigurations":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"PutAppReplicationConfiguration":{"input":{"type":"structure","members":{"appId":{},"serverGroupReplicationConfigurations":{"shape":"S2u"}}},"output":{"type":"structure","members":{}}},"PutAppValidationConfiguration":{"input":{"type":"structure","required":["appId"],"members":{"appId":{},"appValidationConfigurations":{"shape":"S31"},"serverGroupValidationConfigurations":{"shape":"S3c"}}},"output":{"type":"structure","members":{}}},"StartAppReplication":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"StartOnDemandAppReplication":{"input":{"type":"structure","required":["appId"],"members":{"appId":{},"description":{}}},"output":{"type":"structure","members":{}}},"StartOnDemandReplicationRun":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{},"description":{}}},"output":{"type":"structure","members":{"replicationRunId":{}}}},"StopAppReplication":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"TerminateApp":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"UpdateApp":{"input":{"type":"structure","members":{"appId":{},"name":{},"description":{},"roleName":{},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}},"output":{"type":"structure","members":{"appSummary":{"shape":"St"},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}}},"UpdateReplicationJob":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{},"frequency":{"type":"integer"},"nextReplicationRunStartTime":{"type":"timestamp"},"licenseType":{},"roleName":{},"description":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"name":{},"serverList":{"shape":"Sa"}}}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"serverId":{},"serverType":{},"vmServer":{"shape":"Se"},"replicationJobId":{},"replicationJobTerminated":{"type":"boolean"}}},"Se":{"type":"structure","members":{"vmServerAddress":{"shape":"Sf"},"vmName":{},"vmManagerName":{},"vmManagerType":{},"vmPath":{}}},"Sf":{"type":"structure","members":{"vmManagerId":{},"vmId":{}}},"So":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"St":{"type":"structure","members":{"appId":{},"importedAppId":{},"name":{},"description":{},"status":{},"statusMessage":{},"replicationConfigurationStatus":{},"replicationStatus":{},"replicationStatusMessage":{},"latestReplicationTime":{"type":"timestamp"},"launchConfigurationStatus":{},"launchStatus":{},"launchStatusMessage":{},"launchDetails":{"type":"structure","members":{"latestLaunchTime":{"type":"timestamp"},"stackName":{},"stackId":{}}},"creationTime":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"roleName":{},"totalServerGroups":{"type":"integer"},"totalServers":{"type":"integer"}}},"S24":{"type":"structure","members":{"bucket":{},"key":{}}},"S2e":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"launchOrder":{"type":"integer"},"serverLaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"server":{"shape":"Sb"},"logicalId":{},"vpc":{},"subnet":{},"securityGroup":{},"ec2KeyName":{},"userData":{"type":"structure","members":{"s3Location":{"shape":"S24"}}},"instanceType":{},"associatePublicIpAddress":{"type":"boolean"},"iamInstanceProfileName":{},"configureScript":{"shape":"S24"},"configureScriptType":{}}}}}}},"S2u":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"serverReplicationConfigurations":{"type":"list","member":{"type":"structure","members":{"server":{"shape":"Sb"},"serverReplicationParameters":{"type":"structure","members":{"seedTime":{"type":"timestamp"},"frequency":{"type":"integer"},"runOnce":{"type":"boolean"},"licenseType":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{}}}}}}}}},"S31":{"type":"list","member":{"type":"structure","members":{"validationId":{},"name":{},"appValidationStrategy":{},"ssmValidationParameters":{"type":"structure","members":{"source":{"shape":"S37"},"instanceId":{},"scriptType":{},"command":{},"executionTimeoutSeconds":{"type":"integer"},"outputS3BucketName":{}}}}}},"S37":{"type":"structure","members":{"s3Location":{"shape":"S24"}}},"S3c":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"serverValidationConfigurations":{"type":"list","member":{"type":"structure","members":{"server":{"shape":"Sb"},"validationId":{},"name":{},"serverValidationStrategy":{},"userDataValidationParameters":{"type":"structure","members":{"source":{"shape":"S37"},"scriptType":{}}}}}}}}},"S46":{"type":"structure","members":{"replicationJobId":{},"serverId":{},"serverType":{},"vmServer":{"shape":"Se"},"seedReplicationTime":{"type":"timestamp"},"frequency":{"type":"integer"},"runOnce":{"type":"boolean"},"nextReplicationRunStartTime":{"type":"timestamp"},"licenseType":{},"roleName":{},"latestAmiId":{},"state":{},"statusMessage":{},"description":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{},"replicationRunList":{"shape":"S4a"}}},"S4a":{"type":"list","member":{"type":"structure","members":{"replicationRunId":{},"state":{},"type":{},"stageDetails":{"type":"structure","members":{"stage":{},"stageProgress":{}}},"statusMessage":{},"amiId":{},"scheduledStartTime":{"type":"timestamp"},"completedTime":{"type":"timestamp"},"description":{},"encrypted":{"type":"boolean"},"kmsKeyId":{}}}}}}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetConnectors":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"connectorList"},"GetReplicationJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"replicationJobList"},"GetReplicationRuns":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"replicationRunList"},"GetServers":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serverList"}}}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['snowball'] = {};
	AWS.Snowball = Service.defineService('snowball', ['2016-06-30']);
	Object.defineProperty(apiLoader.services['snowball'], '2016-06-30', {
	  get: function get() {
	    var model = __webpack_require__(450);
	    model.paginators = __webpack_require__(451).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Snowball;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-30","endpointPrefix":"snowball","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon Snowball","serviceFullName":"Amazon Import/Export Snowball","serviceId":"Snowball","signatureVersion":"v4","targetPrefix":"AWSIESnowballJobManagementService","uid":"snowball-2016-06-30"},"operations":{"CancelCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"CancelJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{}}},"CreateAddress":{"input":{"type":"structure","required":["Address"],"members":{"Address":{"shape":"S8"}}},"output":{"type":"structure","members":{"AddressId":{}}}},"CreateCluster":{"input":{"type":"structure","required":["JobType","Resources","AddressId","RoleARN","SnowballType","ShippingOption"],"members":{"JobType":{},"Resources":{"shape":"Sf"},"OnDeviceServiceConfiguration":{"shape":"Sv"},"Description":{},"AddressId":{},"KmsKeyARN":{},"RoleARN":{},"SnowballType":{},"ShippingOption":{},"Notification":{"shape":"S14"},"ForwardingAddressId":{},"TaxDocuments":{"shape":"S18"},"RemoteManagement":{}}},"output":{"type":"structure","members":{"ClusterId":{}}}},"CreateJob":{"input":{"type":"structure","members":{"JobType":{},"Resources":{"shape":"Sf"},"OnDeviceServiceConfiguration":{"shape":"Sv"},"Description":{},"AddressId":{},"KmsKeyARN":{},"RoleARN":{},"SnowballCapacityPreference":{},"ShippingOption":{},"Notification":{"shape":"S14"},"ClusterId":{},"SnowballType":{},"ForwardingAddressId":{},"TaxDocuments":{"shape":"S18"},"DeviceConfiguration":{"shape":"S1f"},"RemoteManagement":{},"LongTermPricingId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"CreateLongTermPricing":{"input":{"type":"structure","required":["LongTermPricingType"],"members":{"LongTermPricingType":{},"IsLongTermPricingAutoRenew":{"type":"boolean"},"SnowballType":{}}},"output":{"type":"structure","members":{"LongTermPricingId":{}}}},"CreateReturnShippingLabel":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"ShippingOption":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DescribeAddress":{"input":{"type":"structure","required":["AddressId"],"members":{"AddressId":{}}},"output":{"type":"structure","members":{"Address":{"shape":"S8"}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Addresses":{"type":"list","member":{"shape":"S8"}},"NextToken":{}}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"ClusterMetadata":{"type":"structure","members":{"ClusterId":{},"Description":{},"KmsKeyARN":{},"RoleARN":{},"ClusterState":{},"JobType":{},"SnowballType":{},"CreationDate":{"type":"timestamp"},"Resources":{"shape":"Sf"},"AddressId":{},"ShippingOption":{},"Notification":{"shape":"S14"},"ForwardingAddressId":{},"TaxDocuments":{"shape":"S18"},"OnDeviceServiceConfiguration":{"shape":"Sv"}}}}}},"DescribeJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobMetadata":{"shape":"S24"},"SubJobMetadata":{"type":"list","member":{"shape":"S24"}}}}},"DescribeReturnShippingLabel":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"Status":{},"ExpirationDate":{"type":"timestamp"},"ReturnShippingLabelURI":{}}}},"GetJobManifest":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ManifestURI":{}}}},"GetJobUnlockCode":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"UnlockCode":{}}}},"GetSnowballUsage":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"SnowballLimit":{"type":"integer"},"SnowballsInUse":{"type":"integer"}}}},"GetSoftwareUpdates":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"UpdatesURI":{}}}},"ListClusterJobs":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobListEntries":{"shape":"S2o"},"NextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ClusterListEntries":{"type":"list","member":{"type":"structure","members":{"ClusterId":{},"ClusterState":{},"CreationDate":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}}},"ListCompatibleImages":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"CompatibleImages":{"type":"list","member":{"type":"structure","members":{"AmiId":{},"Name":{}}}},"NextToken":{}}}},"ListJobs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobListEntries":{"shape":"S2o"},"NextToken":{}}}},"ListLongTermPricing":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LongTermPricingEntries":{"type":"list","member":{"type":"structure","members":{"LongTermPricingId":{},"LongTermPricingEndDate":{"type":"timestamp"},"LongTermPricingStartDate":{"type":"timestamp"},"LongTermPricingType":{},"CurrentActiveJob":{},"ReplacementJob":{},"IsLongTermPricingAutoRenew":{"type":"boolean"},"LongTermPricingStatus":{},"SnowballType":{},"JobIds":{"type":"list","member":{}}}}},"NextToken":{}}}},"UpdateCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"RoleARN":{},"Description":{},"Resources":{"shape":"Sf"},"OnDeviceServiceConfiguration":{"shape":"Sv"},"AddressId":{},"ShippingOption":{},"Notification":{"shape":"S14"},"ForwardingAddressId":{}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"RoleARN":{},"Notification":{"shape":"S14"},"Resources":{"shape":"Sf"},"OnDeviceServiceConfiguration":{"shape":"Sv"},"AddressId":{},"ShippingOption":{},"Description":{},"SnowballCapacityPreference":{},"ForwardingAddressId":{}}},"output":{"type":"structure","members":{}}},"UpdateJobShipmentState":{"input":{"type":"structure","required":["JobId","ShipmentState"],"members":{"JobId":{},"ShipmentState":{}}},"output":{"type":"structure","members":{}}},"UpdateLongTermPricing":{"input":{"type":"structure","required":["LongTermPricingId"],"members":{"LongTermPricingId":{},"ReplacementJob":{},"IsLongTermPricingAutoRenew":{"type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"structure","members":{"AddressId":{},"Name":{},"Company":{},"Street1":{},"Street2":{},"Street3":{},"City":{},"StateOrProvince":{},"PrefectureOrDistrict":{},"Landmark":{},"Country":{},"PostalCode":{},"PhoneNumber":{},"IsRestricted":{"type":"boolean"}}},"Sf":{"type":"structure","members":{"S3Resources":{"type":"list","member":{"type":"structure","members":{"BucketArn":{},"KeyRange":{"type":"structure","members":{"BeginMarker":{},"EndMarker":{}}},"TargetOnDeviceServices":{"type":"list","member":{"type":"structure","members":{"ServiceName":{},"TransferOption":{}}}}}}},"LambdaResources":{"type":"list","member":{"type":"structure","members":{"LambdaArn":{},"EventTriggers":{"type":"list","member":{"type":"structure","members":{"EventResourceARN":{}}}}}}},"Ec2AmiResources":{"type":"list","member":{"type":"structure","required":["AmiId"],"members":{"AmiId":{},"SnowballAmiId":{}}}}}},"Sv":{"type":"structure","members":{"NFSOnDeviceService":{"type":"structure","members":{"StorageLimit":{"type":"integer"},"StorageUnit":{}}},"TGWOnDeviceService":{"type":"structure","members":{"StorageLimit":{"type":"integer"},"StorageUnit":{}}}}},"S14":{"type":"structure","members":{"SnsTopicARN":{},"JobStatesToNotify":{"type":"list","member":{}},"NotifyAll":{"type":"boolean"}}},"S18":{"type":"structure","members":{"IND":{"type":"structure","members":{"GSTIN":{}}}}},"S1f":{"type":"structure","members":{"SnowconeDeviceConfiguration":{"type":"structure","members":{"WirelessConnection":{"type":"structure","members":{"IsWifiEnabled":{"type":"boolean"}}}}}}},"S24":{"type":"structure","members":{"JobId":{},"JobState":{},"JobType":{},"SnowballType":{},"CreationDate":{"type":"timestamp"},"Resources":{"shape":"Sf"},"Description":{},"KmsKeyARN":{},"RoleARN":{},"AddressId":{},"ShippingDetails":{"type":"structure","members":{"ShippingOption":{},"InboundShipment":{"shape":"S26"},"OutboundShipment":{"shape":"S26"}}},"SnowballCapacityPreference":{},"Notification":{"shape":"S14"},"DataTransferProgress":{"type":"structure","members":{"BytesTransferred":{"type":"long"},"ObjectsTransferred":{"type":"long"},"TotalBytes":{"type":"long"},"TotalObjects":{"type":"long"}}},"JobLogInfo":{"type":"structure","members":{"JobCompletionReportURI":{},"JobSuccessLogURI":{},"JobFailureLogURI":{}}},"ClusterId":{},"ForwardingAddressId":{},"TaxDocuments":{"shape":"S18"},"DeviceConfiguration":{"shape":"S1f"},"RemoteManagement":{},"LongTermPricingId":{},"OnDeviceServiceConfiguration":{"shape":"Sv"}}},"S26":{"type":"structure","members":{"Status":{},"TrackingNumber":{}}},"S2o":{"type":"list","member":{"type":"structure","members":{"JobId":{},"JobState":{},"IsMaster":{"type":"boolean"},"JobType":{},"SnowballType":{},"CreationDate":{"type":"timestamp"},"Description":{}}}}}}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAddresses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Addresses"},"ListJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"JobListEntries"}}}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sns'] = {};
	AWS.SNS = Service.defineService('sns', ['2010-03-31']);
	Object.defineProperty(apiLoader.services['sns'], '2010-03-31', {
	  get: function get() {
	    var model = __webpack_require__(453);
	    model.paginators = __webpack_require__(454).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SNS;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-03-31","endpointPrefix":"sns","protocol":"query","serviceAbbreviation":"Amazon SNS","serviceFullName":"Amazon Simple Notification Service","serviceId":"SNS","signatureVersion":"v4","uid":"sns-2010-03-31","xmlNamespace":"http://sns.amazonaws.com/doc/2010-03-31/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["TopicArn","Label","AWSAccountId","ActionName"],"members":{"TopicArn":{},"Label":{},"AWSAccountId":{"type":"list","member":{}},"ActionName":{"type":"list","member":{}}}}},"CheckIfPhoneNumberIsOptedOut":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"CheckIfPhoneNumberIsOptedOutResult","type":"structure","members":{"isOptedOut":{"type":"boolean"}}}},"ConfirmSubscription":{"input":{"type":"structure","required":["TopicArn","Token"],"members":{"TopicArn":{},"Token":{},"AuthenticateOnUnsubscribe":{}}},"output":{"resultWrapper":"ConfirmSubscriptionResult","type":"structure","members":{"SubscriptionArn":{}}}},"CreatePlatformApplication":{"input":{"type":"structure","required":["Name","Platform","Attributes"],"members":{"Name":{},"Platform":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformApplicationResult","type":"structure","members":{"PlatformApplicationArn":{}}}},"CreatePlatformEndpoint":{"input":{"type":"structure","required":["PlatformApplicationArn","Token"],"members":{"PlatformApplicationArn":{},"Token":{},"CustomUserData":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformEndpointResult","type":"structure","members":{"EndpointArn":{}}}},"CreateSMSSandboxPhoneNumber":{"input":{"type":"structure","required":["PhoneNumber"],"members":{"PhoneNumber":{},"LanguageCode":{}}},"output":{"resultWrapper":"CreateSMSSandboxPhoneNumberResult","type":"structure","members":{}}},"CreateTopic":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Attributes":{"shape":"St"},"Tags":{"shape":"Sw"}}},"output":{"resultWrapper":"CreateTopicResult","type":"structure","members":{"TopicArn":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"DeletePlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}}},"DeleteSMSSandboxPhoneNumber":{"input":{"type":"structure","required":["PhoneNumber"],"members":{"PhoneNumber":{}}},"output":{"resultWrapper":"DeleteSMSSandboxPhoneNumberResult","type":"structure","members":{}}},"DeleteTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}},"GetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"resultWrapper":"GetEndpointAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}},"output":{"resultWrapper":"GetPlatformApplicationAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetSMSAttributes":{"input":{"type":"structure","members":{"attributes":{"type":"list","member":{}}}},"output":{"resultWrapper":"GetSMSAttributesResult","type":"structure","members":{"attributes":{"shape":"Sj"}}}},"GetSMSSandboxAccountStatus":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetSMSSandboxAccountStatusResult","type":"structure","required":["IsInSandbox"],"members":{"IsInSandbox":{"type":"boolean"}}}},"GetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"resultWrapper":"GetSubscriptionAttributesResult","type":"structure","members":{"Attributes":{"shape":"S1h"}}}},"GetTopicAttributes":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"output":{"resultWrapper":"GetTopicAttributesResult","type":"structure","members":{"Attributes":{"shape":"St"}}}},"ListEndpointsByPlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListEndpointsByPlatformApplicationResult","type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListOriginationNumbers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListOriginationNumbersResult","type":"structure","members":{"NextToken":{},"PhoneNumbers":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"PhoneNumber":{},"Status":{},"Iso2CountryCode":{},"RouteType":{},"NumberCapabilities":{"type":"list","member":{}}}}}}}},"ListPhoneNumbersOptedOut":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"resultWrapper":"ListPhoneNumbersOptedOutResult","type":"structure","members":{"phoneNumbers":{"type":"list","member":{}},"nextToken":{}}}},"ListPlatformApplications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListPlatformApplicationsResult","type":"structure","members":{"PlatformApplications":{"type":"list","member":{"type":"structure","members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListSMSSandboxPhoneNumbers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListSMSSandboxPhoneNumbersResult","type":"structure","required":["PhoneNumbers"],"members":{"PhoneNumbers":{"type":"list","member":{"type":"structure","members":{"PhoneNumber":{},"Status":{}}}},"NextToken":{}}}},"ListSubscriptions":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsResult","type":"structure","members":{"Subscriptions":{"shape":"S2f"},"NextToken":{}}}},"ListSubscriptionsByTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsByTopicResult","type":"structure","members":{"Subscriptions":{"shape":"S2f"},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"Sw"}}}},"ListTopics":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListTopicsResult","type":"structure","members":{"Topics":{"type":"list","member":{"type":"structure","members":{"TopicArn":{}}}},"NextToken":{}}}},"OptInPhoneNumber":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"OptInPhoneNumberResult","type":"structure","members":{}}},"Publish":{"input":{"type":"structure","required":["Message"],"members":{"TopicArn":{},"TargetArn":{},"PhoneNumber":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"shape":"S2z"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"PublishResult","type":"structure","members":{"MessageId":{},"SequenceNumber":{}}}},"PublishBatch":{"input":{"type":"structure","required":["TopicArn","PublishBatchRequestEntries"],"members":{"TopicArn":{},"PublishBatchRequestEntries":{"type":"list","member":{"type":"structure","required":["Id","Message"],"members":{"Id":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"shape":"S2z"},"MessageDeduplicationId":{},"MessageGroupId":{}}}}}},"output":{"resultWrapper":"PublishBatchResult","type":"structure","members":{"Successful":{"type":"list","member":{"type":"structure","members":{"Id":{},"MessageId":{},"SequenceNumber":{}}}},"Failed":{"type":"list","member":{"type":"structure","required":["Id","Code","SenderFault"],"members":{"Id":{},"Code":{},"Message":{},"SenderFault":{"type":"boolean"}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["TopicArn","Label"],"members":{"TopicArn":{},"Label":{}}}},"SetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn","Attributes"],"members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"SetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn","Attributes"],"members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"SetSMSAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"SetSMSAttributesResult","type":"structure","members":{}}},"SetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn","AttributeName"],"members":{"SubscriptionArn":{},"AttributeName":{},"AttributeValue":{}}}},"SetTopicAttributes":{"input":{"type":"structure","required":["TopicArn","AttributeName"],"members":{"TopicArn":{},"AttributeName":{},"AttributeValue":{}}}},"Subscribe":{"input":{"type":"structure","required":["TopicArn","Protocol"],"members":{"TopicArn":{},"Protocol":{},"Endpoint":{},"Attributes":{"shape":"S1h"},"ReturnSubscriptionArn":{"type":"boolean"}}},"output":{"resultWrapper":"SubscribeResult","type":"structure","members":{"SubscriptionArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sw"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"Unsubscribe":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}},"VerifySMSSandboxPhoneNumber":{"input":{"type":"structure","required":["PhoneNumber","OneTimePassword"],"members":{"PhoneNumber":{},"OneTimePassword":{}}},"output":{"resultWrapper":"VerifySMSSandboxPhoneNumberResult","type":"structure","members":{}}}},"shapes":{"Sj":{"type":"map","key":{},"value":{}},"St":{"type":"map","key":{},"value":{}},"Sw":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1h":{"type":"map","key":{},"value":{}},"S2f":{"type":"list","member":{"type":"structure","members":{"SubscriptionArn":{},"Owner":{},"Protocol":{},"Endpoint":{},"TopicArn":{}}}},"S2z":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"DataType":{},"StringValue":{},"BinaryValue":{"type":"blob"}}}}}}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEndpointsByPlatformApplication":{"input_token":"NextToken","output_token":"NextToken","result_key":"Endpoints"},"ListOriginationNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumbers"},"ListPhoneNumbersOptedOut":{"input_token":"nextToken","output_token":"nextToken","result_key":"phoneNumbers"},"ListPlatformApplications":{"input_token":"NextToken","output_token":"NextToken","result_key":"PlatformApplications"},"ListSMSSandboxPhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumbers"},"ListSubscriptions":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListSubscriptionsByTopic":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListTopics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Topics"}}}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sqs'] = {};
	AWS.SQS = Service.defineService('sqs', ['2012-11-05']);
	__webpack_require__(456);
	Object.defineProperty(apiLoader.services['sqs'], '2012-11-05', {
	  get: function get() {
	    var model = __webpack_require__(457);
	    model.paginators = __webpack_require__(458).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SQS;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.SQS.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('build', this.buildEndpoint);

	    if (request.service.config.computeChecksums) {
	      if (request.operation === 'sendMessage') {
	        request.addListener('extractData', this.verifySendMessageChecksum);
	      } else if (request.operation === 'sendMessageBatch') {
	        request.addListener('extractData', this.verifySendMessageBatchChecksum);
	      } else if (request.operation === 'receiveMessage') {
	        request.addListener('extractData', this.verifyReceiveMessageChecksum);
	      }
	    }
	  },

	  /**
	   * @api private
	   */
	  verifySendMessageChecksum: function verifySendMessageChecksum(response) {
	    if (!response.data) return;

	    var md5 = response.data.MD5OfMessageBody;
	    var body = this.params.MessageBody;
	    var calculatedMd5 = this.service.calculateChecksum(body);
	    if (calculatedMd5 !== md5) {
	      var msg = 'Got "' + response.data.MD5OfMessageBody +
	        '", expecting "' + calculatedMd5 + '".';
	      this.service.throwInvalidChecksumError(response,
	        [response.data.MessageId], msg);
	    }
	  },

	  /**
	   * @api private
	   */
	  verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
	    if (!response.data) return;

	    var service = this.service;
	    var entries = {};
	    var errors = [];
	    var messageIds = [];
	    AWS.util.arrayEach(response.data.Successful, function (entry) {
	      entries[entry.Id] = entry;
	    });
	    AWS.util.arrayEach(this.params.Entries, function (entry) {
	      if (entries[entry.Id]) {
	        var md5 = entries[entry.Id].MD5OfMessageBody;
	        var body = entry.MessageBody;
	        if (!service.isChecksumValid(md5, body)) {
	          errors.push(entry.Id);
	          messageIds.push(entries[entry.Id].MessageId);
	        }
	      }
	    });

	    if (errors.length > 0) {
	      service.throwInvalidChecksumError(response, messageIds,
	        'Invalid messages: ' + errors.join(', '));
	    }
	  },

	  /**
	   * @api private
	   */
	  verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
	    if (!response.data) return;

	    var service = this.service;
	    var messageIds = [];
	    AWS.util.arrayEach(response.data.Messages, function(message) {
	      var md5 = message.MD5OfBody;
	      var body = message.Body;
	      if (!service.isChecksumValid(md5, body)) {
	        messageIds.push(message.MessageId);
	      }
	    });

	    if (messageIds.length > 0) {
	      service.throwInvalidChecksumError(response, messageIds,
	        'Invalid messages: ' + messageIds.join(', '));
	    }
	  },

	  /**
	   * @api private
	   */
	  throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
	    response.error = AWS.util.error(new Error(), {
	      retryable: true,
	      code: 'InvalidChecksum',
	      messageIds: ids,
	      message: response.request.operation +
	               ' returned an invalid MD5 response. ' + message
	    });
	  },

	  /**
	   * @api private
	   */
	  isChecksumValid: function isChecksumValid(checksum, data) {
	    return this.calculateChecksum(data) === checksum;
	  },

	  /**
	   * @api private
	   */
	  calculateChecksum: function calculateChecksum(data) {
	    return AWS.util.crypto.md5(data, 'hex');
	  },

	  /**
	   * @api private
	   */
	  buildEndpoint: function buildEndpoint(request) {
	    var url = request.httpRequest.params.QueueUrl;
	    if (url) {
	      request.httpRequest.endpoint = new AWS.Endpoint(url);

	      // signature version 4 requires the region name to be set,
	      // sqs queue urls contain the region name
	      var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
	      if (matches) request.httpRequest.region = matches[1];
	    }
	  }
	});


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-11-05","endpointPrefix":"sqs","protocol":"query","serviceAbbreviation":"Amazon SQS","serviceFullName":"Amazon Simple Queue Service","serviceId":"SQS","signatureVersion":"v4","uid":"sqs-2012-11-05","xmlNamespace":"http://queue.amazonaws.com/doc/2012-11-05/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["QueueUrl","Label","AWSAccountIds","Actions"],"members":{"QueueUrl":{},"Label":{},"AWSAccountIds":{"type":"list","member":{"locationName":"AWSAccountId"},"flattened":true},"Actions":{"type":"list","member":{"locationName":"ActionName"},"flattened":true}}}},"ChangeMessageVisibility":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle","VisibilityTimeout"],"members":{"QueueUrl":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}}},"ChangeMessageVisibilityBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}},"flattened":true}}},"output":{"resultWrapper":"ChangeMessageVisibilityBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"CreateQueue":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"Attributes":{"shape":"Sh","locationName":"Attribute"},"tags":{"shape":"Sj","locationName":"Tag"}}},"output":{"resultWrapper":"CreateQueueResult","type":"structure","members":{"QueueUrl":{}}}},"DeleteMessage":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle"],"members":{"QueueUrl":{},"ReceiptHandle":{}}}},"DeleteMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"DeleteMessageBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{}}},"flattened":true}}},"output":{"resultWrapper":"DeleteMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"DeleteMessageBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"DeleteQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"GetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sw"}}},"output":{"resultWrapper":"GetQueueAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"GetQueueUrl":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"QueueOwnerAWSAccountId":{}}},"output":{"resultWrapper":"GetQueueUrlResult","type":"structure","members":{"QueueUrl":{}}}},"ListDeadLetterSourceQueues":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListDeadLetterSourceQueuesResult","type":"structure","required":["queueUrls"],"members":{"queueUrls":{"shape":"S14"},"NextToken":{}}}},"ListQueueTags":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListQueueTagsResult","type":"structure","members":{"Tags":{"shape":"Sj","locationName":"Tag"}}}},"ListQueues":{"input":{"type":"structure","members":{"QueueNamePrefix":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListQueuesResult","type":"structure","members":{"QueueUrls":{"shape":"S14"},"NextToken":{}}}},"PurgeQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"ReceiveMessage":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sw"},"MessageAttributeNames":{"type":"list","member":{"locationName":"MessageAttributeName"},"flattened":true},"MaxNumberOfMessages":{"type":"integer"},"VisibilityTimeout":{"type":"integer"},"WaitTimeSeconds":{"type":"integer"},"ReceiveRequestAttemptId":{}}},"output":{"resultWrapper":"ReceiveMessageResult","type":"structure","members":{"Messages":{"type":"list","member":{"locationName":"Message","type":"structure","members":{"MessageId":{},"ReceiptHandle":{},"MD5OfBody":{},"Body":{},"Attributes":{"locationName":"Attribute","type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true},"MD5OfMessageAttributes":{},"MessageAttributes":{"shape":"S1i","locationName":"MessageAttribute"}}},"flattened":true}}}},"RemovePermission":{"input":{"type":"structure","required":["QueueUrl","Label"],"members":{"QueueUrl":{},"Label":{}}}},"SendMessage":{"input":{"type":"structure","required":["QueueUrl","MessageBody"],"members":{"QueueUrl":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1i","locationName":"MessageAttribute"},"MessageSystemAttributes":{"shape":"S1p","locationName":"MessageSystemAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"SendMessageResult","type":"structure","members":{"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MD5OfMessageSystemAttributes":{},"MessageId":{},"SequenceNumber":{}}}},"SendMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"SendMessageBatchRequestEntry","type":"structure","required":["Id","MessageBody"],"members":{"Id":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1i","locationName":"MessageAttribute"},"MessageSystemAttributes":{"shape":"S1p","locationName":"MessageSystemAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"flattened":true}}},"output":{"resultWrapper":"SendMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"SendMessageBatchResultEntry","type":"structure","required":["Id","MessageId","MD5OfMessageBody"],"members":{"Id":{},"MessageId":{},"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MD5OfMessageSystemAttributes":{},"SequenceNumber":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"SetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl","Attributes"],"members":{"QueueUrl":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"TagQueue":{"input":{"type":"structure","required":["QueueUrl","Tags"],"members":{"QueueUrl":{},"Tags":{"shape":"Sj"}}}},"UntagQueue":{"input":{"type":"structure","required":["QueueUrl","TagKeys"],"members":{"QueueUrl":{},"TagKeys":{"type":"list","member":{"locationName":"TagKey"},"flattened":true}}}}},"shapes":{"Sd":{"type":"list","member":{"locationName":"BatchResultErrorEntry","type":"structure","required":["Id","SenderFault","Code"],"members":{"Id":{},"SenderFault":{"type":"boolean"},"Code":{},"Message":{}}},"flattened":true},"Sh":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Attribute"},"Sj":{"type":"map","key":{"locationName":"Key"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Tag"},"Sw":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"S14":{"type":"list","member":{"locationName":"QueueUrl"},"flattened":true},"S1i":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"shape":"S1l","flattened":true,"locationName":"StringListValue"},"BinaryListValues":{"shape":"S1m","flattened":true,"locationName":"BinaryListValue"},"DataType":{}}},"flattened":true},"S1l":{"type":"list","member":{"locationName":"StringListValue"}},"S1m":{"type":"list","member":{"locationName":"BinaryListValue","type":"blob"}},"S1p":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"shape":"S1l","flattened":true,"locationName":"StringListValue"},"BinaryListValues":{"shape":"S1m","flattened":true,"locationName":"BinaryListValue"},"DataType":{}}},"flattened":true}}}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDeadLetterSourceQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"queueUrls"},"ListQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueueUrls"}}}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ssm'] = {};
	AWS.SSM = Service.defineService('ssm', ['2014-11-06']);
	Object.defineProperty(apiLoader.services['ssm'], '2014-11-06', {
	  get: function get() {
	    var model = __webpack_require__(460);
	    model.paginators = __webpack_require__(461).pagination;
	    model.waiters = __webpack_require__(462).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SSM;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-06","endpointPrefix":"ssm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon SSM","serviceFullName":"Amazon Simple Systems Manager (SSM)","serviceId":"SSM","signatureVersion":"v4","targetPrefix":"AmazonSSM","uid":"ssm-2014-11-06"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","Tags"],"members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"AssociateOpsItemRelatedItem":{"input":{"type":"structure","required":["OpsItemId","AssociationType","ResourceType","ResourceUri"],"members":{"OpsItemId":{},"AssociationType":{},"ResourceType":{},"ResourceUri":{}}},"output":{"type":"structure","members":{"AssociationId":{}}}},"CancelCommand":{"input":{"type":"structure","required":["CommandId"],"members":{"CommandId":{},"InstanceIds":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"CancelMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{}}}},"CreateActivation":{"input":{"type":"structure","required":["IamRole"],"members":{"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Tags":{"shape":"S4"},"RegistrationMetadata":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}},"output":{"type":"structure","members":{"ActivationId":{},"ActivationCode":{}}}},"CreateAssociation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"InstanceId":{},"Parameters":{"shape":"S14"},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"AssociationName":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S21"}}}},"CreateAssociationBatch":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"shape":"S2f"}}}},"output":{"type":"structure","members":{"Successful":{"type":"list","member":{"shape":"S21"}},"Failed":{"type":"list","member":{"type":"structure","members":{"Entry":{"shape":"S2f"},"Message":{},"Fault":{}}}}}}},"CreateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Requires":{"shape":"S2o"},"Attachments":{"shape":"S2q"},"Name":{},"DisplayName":{},"VersionName":{},"DocumentType":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S33"}}}},"CreateMaintenanceWindow":{"input":{"type":"structure","required":["Name","Schedule","Duration","Cutoff","AllowUnassociatedTargets"],"members":{"Name":{},"Description":{"shape":"S3x"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"WindowId":{}}}},"CreateOpsItem":{"input":{"type":"structure","required":["Description","Source","Title"],"members":{"Description":{},"OpsItemType":{},"OperationalData":{"shape":"S4b"},"Notifications":{"shape":"S4g"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S4k"},"Source":{},"Title":{},"Tags":{"shape":"S4"},"Category":{},"Severity":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"OpsItemId":{}}}},"CreateOpsMetadata":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"Metadata":{"shape":"S4t"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"OpsMetadataArn":{}}}},"CreatePatchBaseline":{"input":{"type":"structure","required":["Name"],"members":{"OperatingSystem":{},"Name":{},"GlobalFilters":{"shape":"S52"},"ApprovalRules":{"shape":"S58"},"ApprovedPatches":{"shape":"S5f"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5f"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S5j"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"CreateResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{},"S3Destination":{"shape":"S5t"},"SyncType":{},"SyncSource":{"shape":"S62"}}},"output":{"type":"structure","members":{}}},"DeleteActivation":{"input":{"type":"structure","required":["ActivationId"],"members":{"ActivationId":{}}},"output":{"type":"structure","members":{}}},"DeleteAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteInventory":{"input":{"type":"structure","required":["TypeName"],"members":{"TypeName":{},"SchemaDeleteOption":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionSummary":{"shape":"S6q"}}}},"DeleteMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{}}}},"DeleteOpsMetadata":{"input":{"type":"structure","required":["OpsMetadataArn"],"members":{"OpsMetadataArn":{}}},"output":{"type":"structure","members":{}}},"DeleteParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S75"}}},"output":{"type":"structure","members":{"DeletedParameters":{"shape":"S75"},"InvalidParameters":{"shape":"S75"}}}},"DeletePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"DeleteResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{},"SyncType":{}}},"output":{"type":"structure","members":{}}},"DeregisterManagedInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}},"output":{"type":"structure","members":{}}},"DeregisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"DeregisterTargetFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Safe":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{}}}},"DeregisterTaskFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{}}}},"DescribeActivations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ActivationList":{"type":"list","member":{"type":"structure","members":{"ActivationId":{},"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"RegistrationsCount":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Expired":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"DescribeAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S21"}}}},"DescribeAssociationExecutionTargets":{"input":{"type":"structure","required":["AssociationId","ExecutionId"],"members":{"AssociationId":{},"ExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutionTargets":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"ResourceId":{},"ResourceType":{},"Status":{},"DetailedStatus":{},"LastExecutionDate":{"type":"timestamp"},"OutputSource":{"type":"structure","members":{"OutputSourceId":{},"OutputSourceType":{}}}}}},"NextToken":{}}}},"DescribeAssociationExecutions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value","Type"],"members":{"Key":{},"Value":{},"Type":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"Status":{},"DetailedStatus":{},"CreatedTime":{"type":"timestamp"},"LastExecutionDate":{"type":"timestamp"},"ResourceCountByStatus":{}}}},"NextToken":{}}}},"DescribeAutomationExecutions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionMetadataList":{"type":"list","member":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"AutomationExecutionStatus":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"ExecutedBy":{},"LogFile":{},"Outputs":{"shape":"S90"},"Mode":{},"ParentAutomationExecutionId":{},"CurrentStepName":{},"CurrentAction":{},"FailureMessage":{},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S95"},"ResolvedTargets":{"shape":"S9a"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"AutomationType":{},"AutomationSubtype":{},"ScheduledTime":{"type":"timestamp"},"Runbooks":{"shape":"S9e"},"OpsItemId":{},"AssociationId":{},"ChangeRequestName":{}}}},"NextToken":{}}}},"DescribeAutomationStepExecutions":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxResults":{"type":"integer"},"ReverseOrder":{"type":"boolean"}}},"output":{"type":"structure","members":{"StepExecutions":{"shape":"S9o"},"NextToken":{}}}},"DescribeAvailablePatches":{"input":{"type":"structure","members":{"Filters":{"shape":"S9y"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"shape":"Sa6"}},"NextToken":{}}}},"DescribeDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{}}},"output":{"type":"structure","members":{"Document":{"shape":"S33"}}}},"DescribeDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"Sb1"},"AccountSharingInfoList":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"SharedDocumentVersion":{}}}},"NextToken":{}}}},"DescribeEffectiveInstanceAssociations":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"InstanceId":{},"Content":{},"AssociationVersion":{}}}},"NextToken":{}}}},"DescribeEffectivePatchesForPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EffectivePatches":{"type":"list","member":{"type":"structure","members":{"Patch":{"shape":"Sa6"},"PatchStatus":{"type":"structure","members":{"DeploymentStatus":{},"ComplianceLevel":{},"ApprovalDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeInstanceAssociationsStatus":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceAssociationStatusInfos":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Name":{},"DocumentVersion":{},"AssociationVersion":{},"InstanceId":{},"ExecutionDate":{"type":"timestamp"},"Status":{},"DetailedStatus":{},"ExecutionSummary":{},"ErrorCode":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{"type":"structure","members":{"OutputUrl":{}}}}},"AssociationName":{}}}},"NextToken":{}}}},"DescribeInstanceInformation":{"input":{"type":"structure","members":{"InstanceInformationFilterList":{"type":"list","member":{"type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"Sbu"}}}},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"Sbu"}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceInformationList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"IsLatestVersion":{"type":"boolean"},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"Name":{},"IPAddress":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"type":"structure","members":{"DetailedStatus":{},"InstanceAssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"SourceId":{},"SourceType":{}}}},"NextToken":{}}}},"DescribeInstancePatchStates":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Scg"}},"NextToken":{}}}},"DescribeInstancePatchStatesForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Type"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Scg"}},"NextToken":{}}}},"DescribeInstancePatches":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Filters":{"shape":"S9y"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"type":"structure","required":["Title","KBId","Classification","Severity","State","InstalledTime"],"members":{"Title":{},"KBId":{},"Classification":{},"Severity":{},"State":{},"InstalledTime":{"type":"timestamp"},"CVEIds":{}}}},"NextToken":{}}}},"DescribeInventoryDeletions":{"input":{"type":"structure","members":{"DeletionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InventoryDeletions":{"type":"list","member":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionStartTime":{"type":"timestamp"},"LastStatus":{},"LastStatusMessage":{},"DeletionSummary":{"shape":"S6q"},"LastStatusUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{},"Filters":{"shape":"Sdm"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskInvocationIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Sdy"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Scj"},"WindowTargetId":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTasks":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{},"Filters":{"shape":"Sdm"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TaskArn":{},"TaskType":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutions":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sdm"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowSchedule":{"input":{"type":"structure","members":{"WindowId":{},"Targets":{"shape":"S18"},"ResourceType":{},"Filters":{"shape":"S9y"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledWindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"ExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTargets":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sdm"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"ResourceType":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Scj"},"Name":{},"Description":{"shape":"S3x"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTasks":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sdm"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"TaskArn":{},"Type":{},"Targets":{"shape":"S18"},"TaskParameters":{"shape":"Sep"},"Priority":{"type":"integer"},"LoggingInfo":{"shape":"Sev"},"ServiceRoleArn":{},"MaxConcurrency":{},"MaxErrors":{},"Name":{},"Description":{"shape":"S3x"},"CutoffBehavior":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindows":{"input":{"type":"structure","members":{"Filters":{"shape":"Sdm"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S3x"},"Enabled":{"type":"boolean"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"EndDate":{},"StartDate":{},"NextExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowsForTarget":{"input":{"type":"structure","required":["Targets","ResourceType"],"members":{"Targets":{"shape":"S18"},"ResourceType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{}}}},"NextToken":{}}}},"DescribeOpsItems":{"input":{"type":"structure","members":{"OpsItemFilters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"OpsItemSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedBy":{},"CreatedTime":{"type":"timestamp"},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Priority":{"type":"integer"},"Source":{},"Status":{},"OpsItemId":{},"Title":{},"OperationalData":{"shape":"S4b"},"Category":{},"Severity":{},"OpsItemType":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"}}}}}}},"DescribeParameters":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ParameterFilters":{"shape":"Sfp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"AllowedPattern":{},"Version":{"type":"long"},"Tier":{},"Policies":{"shape":"Sg4"},"DataType":{}}}},"NextToken":{}}}},"DescribePatchBaselines":{"input":{"type":"structure","members":{"Filters":{"shape":"S9y"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BaselineIdentities":{"type":"list","member":{"shape":"Sga"}},"NextToken":{}}}},"DescribePatchGroupState":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{}}},"output":{"type":"structure","members":{"Instances":{"type":"integer"},"InstancesWithInstalledPatches":{"type":"integer"},"InstancesWithInstalledOtherPatches":{"type":"integer"},"InstancesWithInstalledPendingRebootPatches":{"type":"integer"},"InstancesWithInstalledRejectedPatches":{"type":"integer"},"InstancesWithMissingPatches":{"type":"integer"},"InstancesWithFailedPatches":{"type":"integer"},"InstancesWithNotApplicablePatches":{"type":"integer"},"InstancesWithUnreportedNotApplicablePatches":{"type":"integer"},"InstancesWithCriticalNonCompliantPatches":{"type":"integer"},"InstancesWithSecurityNonCompliantPatches":{"type":"integer"},"InstancesWithOtherNonCompliantPatches":{"type":"integer"}}}},"DescribePatchGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Filters":{"shape":"S9y"},"NextToken":{}}},"output":{"type":"structure","members":{"Mappings":{"type":"list","member":{"type":"structure","members":{"PatchGroup":{},"BaselineIdentity":{"shape":"Sga"}}}},"NextToken":{}}}},"DescribePatchProperties":{"input":{"type":"structure","required":["OperatingSystem","Property"],"members":{"OperatingSystem":{},"Property":{},"PatchSet":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Properties":{"type":"list","member":{"type":"map","key":{},"value":{}}},"NextToken":{}}}},"DescribeSessions":{"input":{"type":"structure","required":["State"],"members":{"State":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}},"output":{"type":"structure","members":{"Sessions":{"type":"list","member":{"type":"structure","members":{"SessionId":{},"Target":{},"Status":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"DocumentName":{},"Owner":{},"Reason":{},"Details":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{},"CloudWatchOutputUrl":{}}},"MaxSessionDuration":{}}}},"NextToken":{}}}},"DisassociateOpsItemRelatedItem":{"input":{"type":"structure","required":["OpsItemId","AssociationId"],"members":{"OpsItemId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"GetAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{"AutomationExecution":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"AutomationExecutionStatus":{},"StepExecutions":{"shape":"S9o"},"StepExecutionsTruncated":{"type":"boolean"},"Parameters":{"shape":"S90"},"Outputs":{"shape":"S90"},"FailureMessage":{},"Mode":{},"ParentAutomationExecutionId":{},"ExecutedBy":{},"CurrentStepName":{},"CurrentAction":{},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S95"},"ResolvedTargets":{"shape":"S9a"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"TargetLocations":{"shape":"S1s"},"ProgressCounters":{"type":"structure","members":{"TotalSteps":{"type":"integer"},"SuccessSteps":{"type":"integer"},"FailedSteps":{"type":"integer"},"CancelledSteps":{"type":"integer"},"TimedOutSteps":{"type":"integer"}}},"AutomationSubtype":{},"ScheduledTime":{"type":"timestamp"},"Runbooks":{"shape":"S9e"},"OpsItemId":{},"AssociationId":{},"ChangeRequestName":{}}}}}},"GetCalendarState":{"input":{"type":"structure","required":["CalendarNames"],"members":{"CalendarNames":{"shape":"S1q"},"AtTime":{}}},"output":{"type":"structure","members":{"State":{},"AtTime":{},"NextTransitionTime":{}}}},"GetCommandInvocation":{"input":{"type":"structure","required":["CommandId","InstanceId"],"members":{"CommandId":{},"InstanceId":{},"PluginName":{}}},"output":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"PluginName":{},"ResponseCode":{"type":"integer"},"ExecutionStartDateTime":{},"ExecutionElapsedTime":{},"ExecutionEndDateTime":{},"Status":{},"StatusDetails":{},"StandardOutputContent":{},"StandardOutputUrl":{},"StandardErrorContent":{},"StandardErrorUrl":{},"CloudWatchOutputConfig":{"shape":"Shv"}}}},"GetConnectionStatus":{"input":{"type":"structure","required":["Target"],"members":{"Target":{}}},"output":{"type":"structure","members":{"Target":{},"Status":{}}}},"GetDefaultPatchBaseline":{"input":{"type":"structure","members":{"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"OperatingSystem":{}}}},"GetDeployablePatchSnapshotForInstance":{"input":{"type":"structure","required":["InstanceId","SnapshotId"],"members":{"InstanceId":{},"SnapshotId":{},"BaselineOverride":{"type":"structure","members":{"OperatingSystem":{},"GlobalFilters":{"shape":"S52"},"ApprovalRules":{"shape":"S58"},"ApprovedPatches":{"shape":"S5f"},"ApprovedPatchesComplianceLevel":{},"RejectedPatches":{"shape":"S5f"},"RejectedPatchesAction":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"Sources":{"shape":"S5j"}}}}},"output":{"type":"structure","members":{"InstanceId":{},"SnapshotId":{},"SnapshotDownloadUrl":{},"Product":{}}}},"GetDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{}}},"output":{"type":"structure","members":{"Name":{},"CreatedDate":{"type":"timestamp"},"DisplayName":{},"VersionName":{},"DocumentVersion":{},"Status":{},"StatusInformation":{},"Content":{},"DocumentType":{},"DocumentFormat":{},"Requires":{"shape":"S2o"},"AttachmentsContent":{"type":"list","member":{"type":"structure","members":{"Name":{},"Size":{"type":"long"},"Hash":{},"HashType":{},"Url":{}}}},"ReviewStatus":{}}}},"GetInventory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sih"},"Aggregators":{"shape":"Sin"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","required":["TypeName","SchemaVersion","Content"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sj4"}}}}}}},"NextToken":{}}}},"GetInventorySchema":{"input":{"type":"structure","members":{"TypeName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Aggregator":{"type":"boolean"},"SubType":{"type":"boolean"}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","required":["TypeName","Attributes"],"members":{"TypeName":{},"Version":{},"Attributes":{"type":"list","member":{"type":"structure","required":["Name","DataType"],"members":{"Name":{},"DataType":{}}}},"DisplayName":{}}}},"NextToken":{}}}},"GetMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S3x"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"NextExecutionTime":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"}}}},"GetMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskIds":{"type":"list","member":{}},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTask":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"TaskArn":{},"ServiceRole":{},"Type":{},"TaskParameters":{"type":"list","member":{"shape":"Sep"},"sensitive":true},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTaskInvocation":{"input":{"type":"structure","required":["WindowExecutionId","TaskId","InvocationId"],"members":{"WindowExecutionId":{},"TaskId":{},"InvocationId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Sdy"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Scj"},"WindowTargetId":{}}}},"GetMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Sep"},"TaskInvocationParameters":{"shape":"Sjv"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sev"},"Name":{},"Description":{"shape":"S3x"},"CutoffBehavior":{}}}},"GetOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}},"output":{"type":"structure","members":{"OpsItem":{"type":"structure","members":{"CreatedBy":{},"OpsItemType":{},"CreatedTime":{"type":"timestamp"},"Description":{},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Notifications":{"shape":"S4g"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S4k"},"Status":{},"OpsItemId":{},"Version":{},"Title":{},"Source":{},"OperationalData":{"shape":"S4b"},"Category":{},"Severity":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"}}}}}},"GetOpsMetadata":{"input":{"type":"structure","required":["OpsMetadataArn"],"members":{"OpsMetadataArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceId":{},"Metadata":{"shape":"S4t"},"NextToken":{}}}},"GetOpsSummary":{"input":{"type":"structure","members":{"SyncName":{},"Filters":{"shape":"Ski"},"Aggregators":{"shape":"Sko"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","members":{"CaptureTime":{},"Content":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}}}}},"NextToken":{}}}},"GetParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameter":{"shape":"Sla"}}}},"GetParameterHistory":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"Value":{"shape":"Slb"},"AllowedPattern":{},"Version":{"type":"long"},"Labels":{"shape":"Slh"},"Tier":{},"Policies":{"shape":"Sg4"},"DataType":{}}}},"NextToken":{}}}},"GetParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S75"},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sll"},"InvalidParameters":{"shape":"S75"}}}},"GetParametersByPath":{"input":{"type":"structure","required":["Path"],"members":{"Path":{},"Recursive":{"type":"boolean"},"ParameterFilters":{"shape":"Sfp"},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sll"},"NextToken":{}}}},"GetPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S52"},"ApprovalRules":{"shape":"S58"},"ApprovedPatches":{"shape":"S5f"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5f"},"RejectedPatchesAction":{},"PatchGroups":{"type":"list","member":{}},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S5j"}}}},"GetPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{},"OperatingSystem":{}}}},"GetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Slx"}}}},"LabelParameterVersion":{"input":{"type":"structure","required":["Name","Labels"],"members":{"Name":{},"ParameterVersion":{"type":"long"},"Labels":{"shape":"Slh"}}},"output":{"type":"structure","members":{"InvalidLabels":{"shape":"Slh"},"ParameterVersion":{"type":"long"}}}},"ListAssociationVersions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationVersions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"CreatedDate":{"type":"timestamp"},"Name":{},"DocumentVersion":{},"Parameters":{"shape":"S14"},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"AssociationFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{},"DocumentVersion":{},"Targets":{"shape":"S18"},"LastExecutionDate":{"type":"timestamp"},"Overview":{"shape":"S28"},"ScheduleExpression":{},"AssociationName":{},"ScheduleOffset":{"type":"integer"}}}},"NextToken":{}}}},"ListCommandInvocations":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Smf"},"Details":{"type":"boolean"}}},"output":{"type":"structure","members":{"CommandInvocations":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"InstanceName":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"TraceOutput":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"CommandPlugins":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"StatusDetails":{},"ResponseCode":{"type":"integer"},"ResponseStartDateTime":{"type":"timestamp"},"ResponseFinishDateTime":{"type":"timestamp"},"Output":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}},"ServiceRole":{},"NotificationConfig":{"shape":"Sjx"},"CloudWatchOutputConfig":{"shape":"Shv"}}}},"NextToken":{}}}},"ListCommands":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Smf"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"shape":"Smv"}},"NextToken":{}}}},"ListComplianceItems":{"input":{"type":"structure","members":{"Filters":{"shape":"Sn2"},"ResourceIds":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Id":{},"Title":{},"Status":{},"Severity":{},"ExecutionSummary":{"shape":"Snk"},"Details":{"shape":"Snn"}}}},"NextToken":{}}}},"ListComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sn2"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"CompliantSummary":{"shape":"Sns"},"NonCompliantSummary":{"shape":"Snv"}}}},"NextToken":{}}}},"ListDocumentMetadataHistory":{"input":{"type":"structure","required":["Name","Metadata"],"members":{"Name":{},"DocumentVersion":{},"Metadata":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"Author":{},"Metadata":{"type":"structure","members":{"ReviewerResponse":{"type":"list","member":{"type":"structure","members":{"CreateTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ReviewStatus":{},"Comment":{"shape":"So2"},"Reviewer":{}}}}}},"NextToken":{}}}},"ListDocumentVersions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"type":"structure","members":{"Name":{},"DisplayName":{},"DocumentVersion":{},"VersionName":{},"CreatedDate":{"type":"timestamp"},"IsDefaultVersion":{"type":"boolean"},"DocumentFormat":{},"Status":{},"StatusInformation":{},"ReviewStatus":{}}}},"NextToken":{}}}},"ListDocuments":{"input":{"type":"structure","members":{"DocumentFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentIdentifiers":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedDate":{"type":"timestamp"},"DisplayName":{},"Owner":{},"VersionName":{},"PlatformTypes":{"shape":"S3h"},"DocumentVersion":{},"DocumentType":{},"SchemaVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"Requires":{"shape":"S2o"},"ReviewStatus":{},"Author":{}}}},"NextToken":{}}}},"ListInventoryEntries":{"input":{"type":"structure","required":["InstanceId","TypeName"],"members":{"InstanceId":{},"TypeName":{},"Filters":{"shape":"Sih"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TypeName":{},"InstanceId":{},"SchemaVersion":{},"CaptureTime":{},"Entries":{"shape":"Sj4"},"NextToken":{}}}},"ListOpsItemEvents":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Summaries":{"type":"list","member":{"type":"structure","members":{"OpsItemId":{},"EventId":{},"Source":{},"DetailType":{},"Detail":{},"CreatedBy":{"shape":"Sp0"},"CreatedTime":{"type":"timestamp"}}}}}}},"ListOpsItemRelatedItems":{"input":{"type":"structure","members":{"OpsItemId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Summaries":{"type":"list","member":{"type":"structure","members":{"OpsItemId":{},"AssociationId":{},"ResourceType":{},"AssociationType":{},"ResourceUri":{},"CreatedBy":{"shape":"Sp0"},"CreatedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sp0"},"LastModifiedTime":{"type":"timestamp"}}}}}}},"ListOpsMetadata":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OpsMetadataList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"OpsMetadataArn":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sn2"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Status":{},"OverallSeverity":{},"ExecutionSummary":{"shape":"Snk"},"CompliantSummary":{"shape":"Sns"},"NonCompliantSummary":{"shape":"Snv"}}}},"NextToken":{}}}},"ListResourceDataSync":{"input":{"type":"structure","members":{"SyncType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceDataSyncItems":{"type":"list","member":{"type":"structure","members":{"SyncName":{},"SyncType":{},"SyncSource":{"type":"structure","members":{"SourceType":{},"AwsOrganizationsSource":{"shape":"S64"},"SourceRegions":{"shape":"S69"},"IncludeFutureRegions":{"type":"boolean"},"State":{},"EnableAllOpsDataSources":{"type":"boolean"}}},"S3Destination":{"shape":"S5t"},"LastSyncTime":{"type":"timestamp"},"LastSuccessfulSyncTime":{"type":"timestamp"},"SyncLastModifiedTime":{"type":"timestamp"},"LastStatus":{},"SyncCreatedTime":{"type":"timestamp"},"LastSyncStatusMessage":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4"}}}},"ModifyDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"AccountIdsToAdd":{"shape":"Sb1"},"AccountIdsToRemove":{"shape":"Sb1"},"SharedDocumentVersion":{}}},"output":{"type":"structure","members":{}}},"PutComplianceItems":{"input":{"type":"structure","required":["ResourceId","ResourceType","ComplianceType","ExecutionSummary","Items"],"members":{"ResourceId":{},"ResourceType":{},"ComplianceType":{},"ExecutionSummary":{"shape":"Snk"},"Items":{"type":"list","member":{"type":"structure","required":["Severity","Status"],"members":{"Id":{},"Title":{},"Severity":{},"Status":{},"Details":{"shape":"Snn"}}}},"ItemContentHash":{},"UploadType":{}}},"output":{"type":"structure","members":{}}},"PutInventory":{"input":{"type":"structure","required":["InstanceId","Items"],"members":{"InstanceId":{},"Items":{"type":"list","member":{"type":"structure","required":["TypeName","SchemaVersion","CaptureTime"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sj4"},"Context":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{"Message":{}}}},"PutParameter":{"input":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Description":{},"Value":{"shape":"Slb"},"Type":{},"KeyId":{},"Overwrite":{"type":"boolean"},"AllowedPattern":{},"Tags":{"shape":"S4"},"Tier":{},"Policies":{},"DataType":{}}},"output":{"type":"structure","members":{"Version":{"type":"long"},"Tier":{}}}},"RegisterDefaultPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"RegisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"RegisterTargetWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","ResourceType","Targets"],"members":{"WindowId":{},"ResourceType":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Scj"},"Name":{},"Description":{"shape":"S3x"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTargetId":{}}}},"RegisterTaskWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","TaskArn","TaskType"],"members":{"WindowId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Sep"},"TaskInvocationParameters":{"shape":"Sjv"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sev"},"Name":{},"Description":{"shape":"S3x"},"ClientToken":{"idempotencyToken":true},"CutoffBehavior":{}}},"output":{"type":"structure","members":{"WindowTaskId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","TagKeys"],"members":{"ResourceType":{},"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"ResetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Slx"}}}},"ResumeSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"SendAutomationSignal":{"input":{"type":"structure","required":["AutomationExecutionId","SignalType"],"members":{"AutomationExecutionId":{},"SignalType":{},"Payload":{"shape":"S90"}}},"output":{"type":"structure","members":{}}},"SendCommand":{"input":{"type":"structure","required":["DocumentName"],"members":{"InstanceIds":{"shape":"Si"},"Targets":{"shape":"S18"},"DocumentName":{},"DocumentVersion":{},"DocumentHash":{},"DocumentHashType":{},"TimeoutSeconds":{"type":"integer"},"Comment":{},"Parameters":{"shape":"S14"},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"ServiceRoleArn":{},"NotificationConfig":{"shape":"Sjx"},"CloudWatchOutputConfig":{"shape":"Shv"}}},"output":{"type":"structure","members":{"Command":{"shape":"Smv"}}}},"StartAssociationsOnce":{"input":{"type":"structure","required":["AssociationIds"],"members":{"AssociationIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartAutomationExecution":{"input":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S90"},"ClientToken":{},"Mode":{},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S95"},"MaxConcurrency":{},"MaxErrors":{},"TargetLocations":{"shape":"S1s"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StartChangeRequestExecution":{"input":{"type":"structure","required":["DocumentName","Runbooks"],"members":{"ScheduledTime":{"type":"timestamp"},"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S90"},"ChangeRequestName":{},"ClientToken":{},"AutoApprove":{"type":"boolean"},"Runbooks":{"shape":"S9e"},"Tags":{"shape":"S4"},"ScheduledEndTime":{"type":"timestamp"},"ChangeDetails":{}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StartSession":{"input":{"type":"structure","required":["Target"],"members":{"Target":{},"DocumentName":{},"Reason":{},"Parameters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"StopAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"TerminateSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{}}}},"UnlabelParameterVersion":{"input":{"type":"structure","required":["Name","ParameterVersion","Labels"],"members":{"Name":{},"ParameterVersion":{"type":"long"},"Labels":{"shape":"Slh"}}},"output":{"type":"structure","members":{"RemovedLabels":{"shape":"Slh"},"InvalidLabels":{"shape":"Slh"}}}},"UpdateAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Parameters":{"shape":"S14"},"DocumentVersion":{},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"Name":{},"Targets":{"shape":"S18"},"AssociationName":{},"AssociationVersion":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S21"}}}},"UpdateAssociationStatus":{"input":{"type":"structure","required":["Name","InstanceId","AssociationStatus"],"members":{"Name":{},"InstanceId":{},"AssociationStatus":{"shape":"S24"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S21"}}}},"UpdateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Attachments":{"shape":"S2q"},"Name":{},"DisplayName":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{},"TargetType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S33"}}}},"UpdateDocumentDefaultVersion":{"input":{"type":"structure","required":["Name","DocumentVersion"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Description":{"type":"structure","members":{"Name":{},"DefaultVersion":{},"DefaultVersionName":{}}}}}},"UpdateDocumentMetadata":{"input":{"type":"structure","required":["Name","DocumentReviews"],"members":{"Name":{},"DocumentVersion":{},"DocumentReviews":{"type":"structure","required":["Action"],"members":{"Action":{},"Comment":{"shape":"So2"}}}}},"output":{"type":"structure","members":{}}},"UpdateMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Name":{},"Description":{"shape":"S3x"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S3x"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"}}}},"UpdateMaintenanceWindowTarget":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Scj"},"Name":{},"Description":{"shape":"S3x"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Scj"},"Name":{},"Description":{"shape":"S3x"}}}},"UpdateMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Sep"},"TaskInvocationParameters":{"shape":"Sjv"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sev"},"Name":{},"Description":{"shape":"S3x"},"Replace":{"type":"boolean"},"CutoffBehavior":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Sep"},"TaskInvocationParameters":{"shape":"Sjv"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sev"},"Name":{},"Description":{"shape":"S3x"},"CutoffBehavior":{}}}},"UpdateManagedInstanceRole":{"input":{"type":"structure","required":["InstanceId","IamRole"],"members":{"InstanceId":{},"IamRole":{}}},"output":{"type":"structure","members":{}}},"UpdateOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"Description":{},"OperationalData":{"shape":"S4b"},"OperationalDataToDelete":{"type":"list","member":{}},"Notifications":{"shape":"S4g"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S4k"},"Status":{},"OpsItemId":{},"Title":{},"Category":{},"Severity":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"UpdateOpsMetadata":{"input":{"type":"structure","required":["OpsMetadataArn"],"members":{"OpsMetadataArn":{},"MetadataToUpdate":{"shape":"S4t"},"KeysToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"OpsMetadataArn":{}}}},"UpdatePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"Name":{},"GlobalFilters":{"shape":"S52"},"ApprovalRules":{"shape":"S58"},"ApprovedPatches":{"shape":"S5f"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5f"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S5j"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S52"},"ApprovalRules":{"shape":"S58"},"ApprovedPatches":{"shape":"S5f"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5f"},"RejectedPatchesAction":{},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S5j"}}}},"UpdateResourceDataSync":{"input":{"type":"structure","required":["SyncName","SyncType","SyncSource"],"members":{"SyncName":{},"SyncType":{},"SyncSource":{"shape":"S62"}}},"output":{"type":"structure","members":{}}},"UpdateServiceSetting":{"input":{"type":"structure","required":["SettingId","SettingValue"],"members":{"SettingId":{},"SettingValue":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Si":{"type":"list","member":{}},"S14":{"type":"map","key":{},"value":{"type":"list","member":{}},"sensitive":true},"S18":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S1e":{"type":"structure","members":{"S3Location":{"type":"structure","members":{"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}}},"S1q":{"type":"list","member":{}},"S1s":{"type":"list","member":{"shape":"S1t"}},"S1t":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Regions":{"type":"list","member":{}},"TargetLocationMaxConcurrency":{},"TargetLocationMaxErrors":{},"ExecutionRoleName":{}}},"S21":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationVersion":{},"Date":{"type":"timestamp"},"LastUpdateAssociationDate":{"type":"timestamp"},"Status":{"shape":"S24"},"Overview":{"shape":"S28"},"DocumentVersion":{},"AutomationTargetParameterName":{},"Parameters":{"shape":"S14"},"AssociationId":{},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"LastExecutionDate":{"type":"timestamp"},"LastSuccessfulExecutionDate":{"type":"timestamp"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"}}},"S24":{"type":"structure","required":["Date","Name","Message"],"members":{"Date":{"type":"timestamp"},"Name":{},"Message":{},"AdditionalInfo":{}}},"S28":{"type":"structure","members":{"Status":{},"DetailedStatus":{},"AssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"S2f":{"type":"structure","required":["Name"],"members":{"Name":{},"InstanceId":{},"Parameters":{"shape":"S14"},"AutomationTargetParameterName":{},"DocumentVersion":{},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"}}},"S2o":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Version":{}}}},"S2q":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Name":{}}}},"S33":{"type":"structure","members":{"Sha1":{},"Hash":{},"HashType":{},"Name":{},"DisplayName":{},"VersionName":{},"Owner":{},"CreatedDate":{"type":"timestamp"},"Status":{},"StatusInformation":{},"DocumentVersion":{},"Description":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Description":{},"DefaultValue":{}}}},"PlatformTypes":{"shape":"S3h"},"DocumentType":{},"SchemaVersion":{},"LatestVersion":{},"DefaultVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"AttachmentsInformation":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Requires":{"shape":"S2o"},"Author":{},"ReviewInformation":{"type":"list","member":{"type":"structure","members":{"ReviewedTime":{"type":"timestamp"},"Status":{},"Reviewer":{}}}},"ApprovedVersion":{},"PendingReviewVersion":{},"ReviewStatus":{},"Category":{"type":"list","member":{}},"CategoryEnum":{"type":"list","member":{}}}},"S3h":{"type":"list","member":{}},"S3x":{"type":"string","sensitive":true},"S4b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{},"Type":{}}}},"S4g":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}},"S4k":{"type":"list","member":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}}},"S4t":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{}}}},"S52":{"type":"structure","required":["PatchFilters"],"members":{"PatchFilters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"S58":{"type":"structure","required":["PatchRules"],"members":{"PatchRules":{"type":"list","member":{"type":"structure","required":["PatchFilterGroup"],"members":{"PatchFilterGroup":{"shape":"S52"},"ComplianceLevel":{},"ApproveAfterDays":{"type":"integer"},"ApproveUntilDate":{},"EnableNonSecurity":{"type":"boolean"}}}}}},"S5f":{"type":"list","member":{}},"S5j":{"type":"list","member":{"type":"structure","required":["Name","Products","Configuration"],"members":{"Name":{},"Products":{"type":"list","member":{}},"Configuration":{"type":"string","sensitive":true}}}},"S5t":{"type":"structure","required":["BucketName","SyncFormat","Region"],"members":{"BucketName":{},"Prefix":{},"SyncFormat":{},"Region":{},"AWSKMSKeyARN":{},"DestinationDataSharing":{"type":"structure","members":{"DestinationDataSharingType":{}}}}},"S62":{"type":"structure","required":["SourceType","SourceRegions"],"members":{"SourceType":{},"AwsOrganizationsSource":{"shape":"S64"},"SourceRegions":{"shape":"S69"},"IncludeFutureRegions":{"type":"boolean"},"EnableAllOpsDataSources":{"type":"boolean"}}},"S64":{"type":"structure","required":["OrganizationSourceType"],"members":{"OrganizationSourceType":{},"OrganizationalUnits":{"type":"list","member":{"type":"structure","members":{"OrganizationalUnitId":{}}}}}},"S69":{"type":"list","member":{}},"S6q":{"type":"structure","members":{"TotalCount":{"type":"integer"},"RemainingCount":{"type":"integer"},"SummaryItems":{"type":"list","member":{"type":"structure","members":{"Version":{},"Count":{"type":"integer"},"RemainingCount":{"type":"integer"}}}}}},"S75":{"type":"list","member":{}},"S90":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S95":{"type":"list","member":{"type":"map","key":{},"value":{"type":"list","member":{}}}},"S9a":{"type":"structure","members":{"ParameterValues":{"type":"list","member":{}},"Truncated":{"type":"boolean"}}},"S9e":{"type":"list","member":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S90"},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S95"},"MaxConcurrency":{},"MaxErrors":{},"TargetLocations":{"shape":"S1s"}}}},"S9o":{"type":"list","member":{"type":"structure","members":{"StepName":{},"Action":{},"TimeoutSeconds":{"type":"long"},"OnFailure":{},"MaxAttempts":{"type":"integer"},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"StepStatus":{},"ResponseCode":{},"Inputs":{"type":"map","key":{},"value":{}},"Outputs":{"shape":"S90"},"Response":{},"FailureMessage":{},"FailureDetails":{"type":"structure","members":{"FailureStage":{},"FailureType":{},"Details":{"shape":"S90"}}},"StepExecutionId":{},"OverriddenParameters":{"shape":"S90"},"IsEnd":{"type":"boolean"},"NextStep":{},"IsCritical":{"type":"boolean"},"ValidNextSteps":{"type":"list","member":{}},"Targets":{"shape":"S18"},"TargetLocation":{"shape":"S1t"}}}},"S9y":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Sa6":{"type":"structure","members":{"Id":{},"ReleaseDate":{"type":"timestamp"},"Title":{},"Description":{},"ContentUrl":{},"Vendor":{},"ProductFamily":{},"Product":{},"Classification":{},"MsrcSeverity":{},"KbNumber":{},"MsrcNumber":{},"Language":{},"AdvisoryIds":{"type":"list","member":{}},"BugzillaIds":{"type":"list","member":{}},"CVEIds":{"type":"list","member":{}},"Name":{},"Epoch":{"type":"integer"},"Version":{},"Release":{},"Arch":{},"Severity":{},"Repository":{}}},"Sb1":{"type":"list","member":{}},"Sbu":{"type":"list","member":{}},"Scg":{"type":"structure","required":["InstanceId","PatchGroup","BaselineId","OperationStartTime","OperationEndTime","Operation"],"members":{"InstanceId":{},"PatchGroup":{},"BaselineId":{},"SnapshotId":{},"InstallOverrideList":{},"OwnerInformation":{"shape":"Scj"},"InstalledCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"InstalledPendingRebootCount":{"type":"integer"},"InstalledRejectedCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"UnreportedNotApplicableCount":{"type":"integer"},"NotApplicableCount":{"type":"integer"},"OperationStartTime":{"type":"timestamp"},"OperationEndTime":{"type":"timestamp"},"Operation":{},"LastNoRebootInstallOperationTime":{"type":"timestamp"},"RebootOption":{},"CriticalNonCompliantCount":{"type":"integer"},"SecurityNonCompliantCount":{"type":"integer"},"OtherNonCompliantCount":{"type":"integer"}}},"Scj":{"type":"string","sensitive":true},"Sdm":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Sdy":{"type":"string","sensitive":true},"Sep":{"type":"map","key":{},"value":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true}},"sensitive":true},"sensitive":true},"Sev":{"type":"structure","required":["S3BucketName","S3Region"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"S3Region":{}}},"Sfp":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Option":{},"Values":{"type":"list","member":{}}}}},"Sg4":{"type":"list","member":{"type":"structure","members":{"PolicyText":{},"PolicyType":{},"PolicyStatus":{}}}},"Sga":{"type":"structure","members":{"BaselineId":{},"BaselineName":{},"OperatingSystem":{},"BaselineDescription":{},"DefaultBaseline":{"type":"boolean"}}},"Shv":{"type":"structure","members":{"CloudWatchLogGroupName":{},"CloudWatchOutputEnabled":{"type":"boolean"}}},"Sih":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sin":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Aggregators":{"shape":"Sin"},"Groups":{"type":"list","member":{"type":"structure","required":["Name","Filters"],"members":{"Name":{},"Filters":{"shape":"Sih"}}}}}}},"Sj4":{"type":"list","member":{"type":"map","key":{},"value":{}}},"Sjv":{"type":"structure","members":{"RunCommand":{"type":"structure","members":{"Comment":{},"CloudWatchOutputConfig":{"shape":"Shv"},"DocumentHash":{},"DocumentHashType":{},"DocumentVersion":{},"NotificationConfig":{"shape":"Sjx"},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"Parameters":{"shape":"S14"},"ServiceRoleArn":{},"TimeoutSeconds":{"type":"integer"}}},"Automation":{"type":"structure","members":{"DocumentVersion":{},"Parameters":{"shape":"S90"}}},"StepFunctions":{"type":"structure","members":{"Input":{"type":"string","sensitive":true},"Name":{}}},"Lambda":{"type":"structure","members":{"ClientContext":{},"Qualifier":{},"Payload":{"type":"blob","sensitive":true}}}}},"Sjx":{"type":"structure","members":{"NotificationArn":{},"NotificationEvents":{"type":"list","member":{}},"NotificationType":{}}},"Ski":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sko":{"type":"list","member":{"type":"structure","members":{"AggregatorType":{},"TypeName":{},"AttributeName":{},"Values":{"type":"map","key":{},"value":{}},"Filters":{"shape":"Ski"},"Aggregators":{"shape":"Sko"}}}},"Sla":{"type":"structure","members":{"Name":{},"Type":{},"Value":{"shape":"Slb"},"Version":{"type":"long"},"Selector":{},"SourceResult":{},"LastModifiedDate":{"type":"timestamp"},"ARN":{},"DataType":{}}},"Slb":{"type":"string","sensitive":true},"Slh":{"type":"list","member":{}},"Sll":{"type":"list","member":{"shape":"Sla"}},"Slx":{"type":"structure","members":{"SettingId":{},"SettingValue":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"ARN":{},"Status":{}}},"Smf":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Smv":{"type":"structure","members":{"CommandId":{},"DocumentName":{},"DocumentVersion":{},"Comment":{},"ExpiresAfter":{"type":"timestamp"},"Parameters":{"shape":"S14"},"InstanceIds":{"shape":"Si"},"Targets":{"shape":"S18"},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"TargetCount":{"type":"integer"},"CompletedCount":{"type":"integer"},"ErrorCount":{"type":"integer"},"DeliveryTimedOutCount":{"type":"integer"},"ServiceRole":{},"NotificationConfig":{"shape":"Sjx"},"CloudWatchOutputConfig":{"shape":"Shv"},"TimeoutSeconds":{"type":"integer"}}},"Sn2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Snk":{"type":"structure","required":["ExecutionTime"],"members":{"ExecutionTime":{"type":"timestamp"},"ExecutionId":{},"ExecutionType":{}}},"Snn":{"type":"map","key":{},"value":{}},"Sns":{"type":"structure","members":{"CompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Snu"}}},"Snu":{"type":"structure","members":{"CriticalCount":{"type":"integer"},"HighCount":{"type":"integer"},"MediumCount":{"type":"integer"},"LowCount":{"type":"integer"},"InformationalCount":{"type":"integer"},"UnspecifiedCount":{"type":"integer"}}},"Snv":{"type":"structure","members":{"NonCompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Snu"}}},"So2":{"type":"list","member":{"type":"structure","members":{"Type":{},"Content":{}}}},"Sp0":{"type":"structure","members":{"Arn":{}}}}}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeActivations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActivationList"},"DescribeAssociationExecutionTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AssociationExecutionTargets"},"DescribeAssociationExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AssociationExecutions"},"DescribeAutomationExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AutomationExecutionMetadataList"},"DescribeAutomationStepExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StepExecutions"},"DescribeAvailablePatches":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Patches"},"DescribeEffectiveInstanceAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"DescribeEffectivePatchesForPatchBaseline":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EffectivePatches"},"DescribeInstanceAssociationsStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceAssociationStatusInfos"},"DescribeInstanceInformation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceInformationList"},"DescribeInstancePatchStates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstancePatchStates"},"DescribeInstancePatchStatesForPatchGroup":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstancePatchStates"},"DescribeInstancePatches":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Patches"},"DescribeInventoryDeletions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InventoryDeletions"},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowExecutionTaskInvocationIdentities"},"DescribeMaintenanceWindowExecutionTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowExecutionTaskIdentities"},"DescribeMaintenanceWindowExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowExecutions"},"DescribeMaintenanceWindowSchedule":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledWindowExecutions"},"DescribeMaintenanceWindowTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Targets"},"DescribeMaintenanceWindowTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tasks"},"DescribeMaintenanceWindows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowIdentities"},"DescribeMaintenanceWindowsForTarget":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowIdentities"},"DescribeOpsItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OpsItemSummaries"},"DescribeParameters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribePatchBaselines":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"BaselineIdentities"},"DescribePatchGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Mappings"},"DescribePatchProperties":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Properties"},"DescribeSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Sessions"},"GetInventory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Entities"},"GetInventorySchema":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Schemas"},"GetOpsSummary":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Entities"},"GetParameterHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParametersByPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAssociationVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AssociationVersions"},"ListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"ListCommandInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CommandInvocations"},"ListCommands":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Commands"},"ListComplianceItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ComplianceItems"},"ListComplianceSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ComplianceSummaryItems"},"ListDocumentVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentVersions"},"ListDocuments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentIdentifiers"},"ListOpsItemEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListOpsItemRelatedItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListOpsMetadata":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OpsMetadataList"},"ListResourceComplianceSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceComplianceSummaryItems"},"ListResourceDataSync":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceDataSyncItems"}}}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"CommandExecuted":{"delay":5,"operation":"GetCommandInvocation","maxAttempts":20,"acceptors":[{"expected":"Pending","matcher":"path","state":"retry","argument":"Status"},{"expected":"InProgress","matcher":"path","state":"retry","argument":"Status"},{"expected":"Delayed","matcher":"path","state":"retry","argument":"Status"},{"expected":"Success","matcher":"path","state":"success","argument":"Status"},{"expected":"Cancelled","matcher":"path","state":"failure","argument":"Status"},{"expected":"TimedOut","matcher":"path","state":"failure","argument":"Status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"Status"},{"expected":"Cancelling","matcher":"path","state":"failure","argument":"Status"},{"state":"retry","matcher":"error","expected":"InvocationDoesNotExist"}]}}}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['storagegateway'] = {};
	AWS.StorageGateway = Service.defineService('storagegateway', ['2013-06-30']);
	Object.defineProperty(apiLoader.services['storagegateway'], '2013-06-30', {
	  get: function get() {
	    var model = __webpack_require__(464);
	    model.paginators = __webpack_require__(465).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.StorageGateway;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-06-30","endpointPrefix":"storagegateway","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Storage Gateway","serviceId":"Storage Gateway","signatureVersion":"v4","targetPrefix":"StorageGateway_20130630","uid":"storagegateway-2013-06-30"},"operations":{"ActivateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayName","GatewayTimezone","GatewayRegion"],"members":{"ActivationKey":{},"GatewayName":{},"GatewayTimezone":{},"GatewayRegion":{},"GatewayType":{},"TapeDriveType":{},"MediumChangerType":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddCache":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"AddUploadBuffer":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddWorkingStorage":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AssignTapePool":{"input":{"type":"structure","required":["TapeARN","PoolId"],"members":{"TapeARN":{},"PoolId":{},"BypassGovernanceRetention":{"type":"boolean"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"AssociateFileSystem":{"input":{"type":"structure","required":["UserName","Password","ClientToken","GatewayARN","LocationARN"],"members":{"UserName":{},"Password":{"shape":"Sx"},"ClientToken":{},"GatewayARN":{},"LocationARN":{},"Tags":{"shape":"S9"},"AuditDestinationARN":{},"CacheAttributes":{"shape":"S11"},"EndpointNetworkConfiguration":{"shape":"S13"}}},"output":{"type":"structure","members":{"FileSystemAssociationARN":{}}}},"AttachVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeARN","NetworkInterfaceId"],"members":{"GatewayARN":{},"TargetName":{},"VolumeARN":{},"NetworkInterfaceId":{},"DiskId":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CancelArchival":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CancelRetrieval":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateCachediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeSizeInBytes","TargetName","NetworkInterfaceId","ClientToken"],"members":{"GatewayARN":{},"VolumeSizeInBytes":{"type":"long"},"SnapshotId":{},"TargetName":{},"SourceVolumeARN":{},"NetworkInterfaceId":{},"ClientToken":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CreateNFSFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"NFSFileShareDefaults":{"shape":"S1p"},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1w"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"AuditDestinationARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSMBFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AccessBasedEnumeration":{"type":"boolean"},"AdminUserList":{"shape":"S25"},"ValidUserList":{"shape":"S25"},"InvalidUserList":{"shape":"S25"},"AuditDestinationARN":{},"Authentication":{},"CaseSensitivity":{},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"OplocksEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"SnapshotId":{}}}},"CreateSnapshotFromVolumeRecoveryPoint":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"SnapshotId":{},"VolumeARN":{},"VolumeRecoveryPointTime":{}}}},"CreateStorediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","DiskId","PreserveExistingData","TargetName","NetworkInterfaceId"],"members":{"GatewayARN":{},"DiskId":{},"SnapshotId":{},"PreserveExistingData":{"type":"boolean"},"TargetName":{},"NetworkInterfaceId":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"TargetARN":{}}}},"CreateTapePool":{"input":{"type":"structure","required":["PoolName","StorageClass"],"members":{"PoolName":{},"StorageClass":{},"RetentionLockType":{},"RetentionLockTimeInDays":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"PoolARN":{}}}},"CreateTapeWithBarcode":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","TapeBarcode"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"TapeBarcode":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateTapes":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","ClientToken","NumTapesToCreate","TapeBarcodePrefix"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"ClientToken":{},"NumTapesToCreate":{"type":"integer"},"TapeBarcodePrefix":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARNs":{"shape":"S2x"}}}},"DeleteAutomaticTapeCreationPolicy":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN","BandwidthType"],"members":{"GatewayARN":{},"BandwidthType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteChapCredentials":{"input":{"type":"structure","required":["TargetARN","InitiatorName"],"members":{"TargetARN":{},"InitiatorName":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"DeleteFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DeleteTape":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{},"BypassGovernanceRetention":{"type":"boolean"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapeArchive":{"input":{"type":"structure","required":["TapeARN"],"members":{"TapeARN":{},"BypassGovernanceRetention":{"type":"boolean"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapePool":{"input":{"type":"structure","required":["PoolARN"],"members":{"PoolARN":{}}},"output":{"type":"structure","members":{"PoolARN":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DescribeAvailabilityMonitorTest":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Status":{},"StartTime":{"type":"timestamp"}}}},"DescribeBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"DescribeBandwidthRateLimitSchedule":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"BandwidthRateLimitIntervals":{"shape":"S3u"}}}},"DescribeCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"CacheAllocatedInBytes":{"type":"long"},"CacheUsedPercentage":{"type":"double"},"CacheDirtyPercentage":{"type":"double"},"CacheHitPercentage":{"type":"double"},"CacheMissPercentage":{"type":"double"}}}},"DescribeCachediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S44"}}},"output":{"type":"structure","members":{"CachediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"SourceSnapshotId":{},"VolumeiSCSIAttributes":{"shape":"S4d"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeChapCredentials":{"input":{"type":"structure","required":["TargetARN"],"members":{"TargetARN":{}}},"output":{"type":"structure","members":{"ChapCredentials":{"type":"list","member":{"type":"structure","members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S4m"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S4m"}}}}}}},"DescribeFileSystemAssociations":{"input":{"type":"structure","required":["FileSystemAssociationARNList"],"members":{"FileSystemAssociationARNList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FileSystemAssociationInfoList":{"type":"list","member":{"type":"structure","members":{"FileSystemAssociationARN":{},"LocationARN":{},"FileSystemAssociationStatus":{},"AuditDestinationARN":{},"GatewayARN":{},"Tags":{"shape":"S9"},"CacheAttributes":{"shape":"S11"},"EndpointNetworkConfiguration":{"shape":"S13"},"FileSystemAssociationStatusDetails":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{}}}}}}}}}},"DescribeGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayId":{},"GatewayName":{},"GatewayTimezone":{},"GatewayState":{},"GatewayNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"Ipv4Address":{},"MacAddress":{},"Ipv6Address":{}}}},"GatewayType":{},"NextUpdateAvailabilityDate":{},"LastSoftwareUpdate":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{},"Tags":{"shape":"S9"},"VPCEndpoint":{},"CloudWatchLogGroupARN":{},"HostEnvironment":{},"EndpointType":{},"SoftwareUpdatesEndDate":{},"DeprecationDate":{},"GatewayCapacity":{},"SupportedGatewayCapacities":{"type":"list","member":{}},"HostEnvironmentId":{}}}},"DescribeMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"},"Timezone":{}}}},"DescribeNFSFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S5i"}}},"output":{"type":"structure","members":{"NFSFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"NFSFileShareDefaults":{"shape":"S1p"},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1w"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"AuditDestinationARN":{}}}}}}},"DescribeSMBFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S5i"}}},"output":{"type":"structure","members":{"SMBFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AccessBasedEnumeration":{"type":"boolean"},"AdminUserList":{"shape":"S25"},"ValidUserList":{"shape":"S25"},"InvalidUserList":{"shape":"S25"},"AuditDestinationARN":{},"Authentication":{},"CaseSensitivity":{},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"OplocksEnabled":{"type":"boolean"}}}}}}},"DescribeSMBSettings":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DomainName":{},"ActiveDirectoryStatus":{},"SMBGuestPasswordSet":{"type":"boolean"},"SMBSecurityStrategy":{},"FileSharesVisible":{"type":"boolean"},"SMBLocalGroups":{"shape":"S5y"}}}},"DescribeSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Timezone":{},"Tags":{"shape":"S9"}}}},"DescribeStorediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S44"}}},"output":{"type":"structure","members":{"StorediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"VolumeDiskId":{},"SourceSnapshotId":{},"PreservedExistingData":{"type":"boolean"},"VolumeiSCSIAttributes":{"shape":"S4d"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeTapeArchives":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2x"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeArchives":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"CompletionTime":{"type":"timestamp"},"RetrievedTo":{},"TapeStatus":{},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"RetentionStartDate":{"type":"timestamp"},"PoolEntryDate":{"type":"timestamp"}}}},"Marker":{}}}},"DescribeTapeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"TapeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeRecoveryPointTime":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{}}}},"Marker":{}}}},"DescribeTapes":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"TapeARNs":{"shape":"S2x"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tapes":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"VTLDevice":{},"Progress":{"type":"double"},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"RetentionStartDate":{"type":"timestamp"},"PoolEntryDate":{"type":"timestamp"}}}},"Marker":{}}}},"DescribeUploadBuffer":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"UploadBufferUsedInBytes":{"type":"long"},"UploadBufferAllocatedInBytes":{"type":"long"}}}},"DescribeVTLDevices":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"VTLDeviceARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"VTLDevices":{"type":"list","member":{"type":"structure","members":{"VTLDeviceARN":{},"VTLDeviceType":{},"VTLDeviceVendor":{},"VTLDeviceProductIdentifier":{},"DeviceiSCSIAttributes":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}},"Marker":{}}}},"DescribeWorkingStorage":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"WorkingStorageUsedInBytes":{"type":"long"},"WorkingStorageAllocatedInBytes":{"type":"long"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{},"ForceDetach":{"type":"boolean"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DisableGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DisassociateFileSystem":{"input":{"type":"structure","required":["FileSystemAssociationARN"],"members":{"FileSystemAssociationARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileSystemAssociationARN":{}}}},"JoinDomain":{"input":{"type":"structure","required":["GatewayARN","DomainName","UserName","Password"],"members":{"GatewayARN":{},"DomainName":{},"OrganizationalUnit":{},"DomainControllers":{"type":"list","member":{}},"TimeoutInSeconds":{"type":"integer"},"UserName":{},"Password":{"shape":"Sx"}}},"output":{"type":"structure","members":{"GatewayARN":{},"ActiveDirectoryStatus":{}}}},"ListAutomaticTapeCreationPolicies":{"input":{"type":"structure","members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"AutomaticTapeCreationPolicyInfos":{"type":"list","member":{"type":"structure","members":{"AutomaticTapeCreationRules":{"shape":"S7i"},"GatewayARN":{}}}}}}},"ListFileShares":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareType":{},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{}}}}}}},"ListFileSystemAssociations":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileSystemAssociationSummaryList":{"type":"list","member":{"type":"structure","members":{"FileSystemAssociationId":{},"FileSystemAssociationARN":{},"FileSystemAssociationStatus":{},"GatewayARN":{}}}}}}},"ListGateways":{"input":{"type":"structure","members":{"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayId":{},"GatewayARN":{},"GatewayType":{},"GatewayOperationalState":{},"GatewayName":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{},"HostEnvironment":{},"HostEnvironmentId":{}}}},"Marker":{}}}},"ListLocalDisks":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Disks":{"type":"list","member":{"type":"structure","members":{"DiskId":{},"DiskPath":{},"DiskNode":{},"DiskStatus":{},"DiskSizeInBytes":{"type":"long"},"DiskAllocationType":{},"DiskAllocationResource":{},"DiskAttributeList":{"type":"list","member":{}}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceARN":{},"Marker":{},"Tags":{"shape":"S9"}}}},"ListTapePools":{"input":{"type":"structure","members":{"PoolARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PoolInfos":{"type":"list","member":{"type":"structure","members":{"PoolARN":{},"PoolName":{},"StorageClass":{},"RetentionLockType":{},"RetentionLockTimeInDays":{"type":"integer"},"PoolStatus":{}}}},"Marker":{}}}},"ListTapes":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2x"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"GatewayARN":{},"PoolId":{},"RetentionStartDate":{"type":"timestamp"},"PoolEntryDate":{"type":"timestamp"}}}},"Marker":{}}}},"ListVolumeInitiators":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"Initiators":{"type":"list","member":{}}}}},"ListVolumeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"VolumeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"VolumeUsageInBytes":{"type":"long"},"VolumeRecoveryPointTime":{}}}}}}},"ListVolumes":{"input":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"VolumeInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"GatewayARN":{},"GatewayId":{},"VolumeType":{},"VolumeSizeInBytes":{"type":"long"},"VolumeAttachmentStatus":{}}}}}}},"NotifyWhenUploaded":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RefreshCache":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"FolderList":{"type":"list","member":{}},"Recursive":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"ResetCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"RetrieveTapeArchive":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"RetrieveTapeRecoveryPoint":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"SetLocalConsolePassword":{"input":{"type":"structure","required":["GatewayARN","LocalConsolePassword"],"members":{"GatewayARN":{},"LocalConsolePassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"SetSMBGuestPassword":{"input":{"type":"structure","required":["GatewayARN","Password"],"members":{"GatewayARN":{},"Password":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ShutdownGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartAvailabilityMonitorTest":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateAutomaticTapeCreationPolicy":{"input":{"type":"structure","required":["AutomaticTapeCreationRules","GatewayARN"],"members":{"AutomaticTapeCreationRules":{"shape":"S7i"},"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimitSchedule":{"input":{"type":"structure","required":["GatewayARN","BandwidthRateLimitIntervals"],"members":{"GatewayARN":{},"BandwidthRateLimitIntervals":{"shape":"S3u"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateChapCredentials":{"input":{"type":"structure","required":["TargetARN","SecretToAuthenticateInitiator","InitiatorName"],"members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S4m"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S4m"}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"UpdateFileSystemAssociation":{"input":{"type":"structure","required":["FileSystemAssociationARN"],"members":{"FileSystemAssociationARN":{},"UserName":{},"Password":{"shape":"Sx"},"AuditDestinationARN":{},"CacheAttributes":{"shape":"S11"}}},"output":{"type":"structure","members":{"FileSystemAssociationARN":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"GatewayName":{},"GatewayTimezone":{},"CloudWatchLogGroupARN":{},"GatewayCapacity":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayName":{}}}},"UpdateGatewaySoftwareNow":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN","HourOfDay","MinuteOfHour"],"members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateNFSFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"NFSFileShareDefaults":{"shape":"S1p"},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1w"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"AuditDestinationARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AccessBasedEnumeration":{"type":"boolean"},"AdminUserList":{"shape":"S25"},"ValidUserList":{"shape":"S25"},"InvalidUserList":{"shape":"S25"},"AuditDestinationARN":{},"CaseSensitivity":{},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"OplocksEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBFileShareVisibility":{"input":{"type":"structure","required":["GatewayARN","FileSharesVisible"],"members":{"GatewayARN":{},"FileSharesVisible":{"type":"boolean"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSMBLocalGroups":{"input":{"type":"structure","required":["GatewayARN","SMBLocalGroups"],"members":{"GatewayARN":{},"SMBLocalGroups":{"shape":"S5y"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSMBSecurityStrategy":{"input":{"type":"structure","required":["GatewayARN","SMBSecurityStrategy"],"members":{"GatewayARN":{},"SMBSecurityStrategy":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN","StartAt","RecurrenceInHours"],"members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"UpdateVTLDeviceType":{"input":{"type":"structure","required":["VTLDeviceARN","DeviceType"],"members":{"VTLDeviceARN":{},"DeviceType":{}}},"output":{"type":"structure","members":{"VTLDeviceARN":{}}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sg":{"type":"list","member":{}},"Sx":{"type":"string","sensitive":true},"S11":{"type":"structure","members":{"CacheStaleTimeoutInSeconds":{"type":"integer"}}},"S13":{"type":"structure","members":{"IpAddresses":{"type":"list","member":{}}}},"S1p":{"type":"structure","members":{"FileMode":{},"DirectoryMode":{},"GroupId":{"type":"long"},"OwnerId":{"type":"long"}}},"S1w":{"type":"list","member":{}},"S25":{"type":"list","member":{}},"S2x":{"type":"list","member":{}},"S3u":{"type":"list","member":{"type":"structure","required":["StartHourOfDay","StartMinuteOfHour","EndHourOfDay","EndMinuteOfHour","DaysOfWeek"],"members":{"StartHourOfDay":{"type":"integer"},"StartMinuteOfHour":{"type":"integer"},"EndHourOfDay":{"type":"integer"},"EndMinuteOfHour":{"type":"integer"},"DaysOfWeek":{"type":"list","member":{"type":"integer"}},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"S44":{"type":"list","member":{}},"S4d":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"LunNumber":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}},"S4m":{"type":"string","sensitive":true},"S5i":{"type":"list","member":{}},"S5y":{"type":"structure","members":{"GatewayAdmins":{"shape":"S25"}}},"S7i":{"type":"list","member":{"type":"structure","required":["TapeBarcodePrefix","PoolId","TapeSizeInBytes","MinimumNumTapes"],"members":{"TapeBarcodePrefix":{},"PoolId":{},"TapeSizeInBytes":{"type":"long"},"MinimumNumTapes":{"type":"integer"},"Worm":{"type":"boolean"}}}}}}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCachediSCSIVolumes":{"result_key":"CachediSCSIVolumes"},"DescribeStorediSCSIVolumes":{"result_key":"StorediSCSIVolumes"},"DescribeTapeArchives":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeArchives"},"DescribeTapeRecoveryPoints":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeRecoveryPointInfos"},"DescribeTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Tapes"},"DescribeVTLDevices":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VTLDevices"},"ListFileShares":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["Marker"],"output_token":"NextMarker","result_key":"FileShareInfoList"},"ListFileSystemAssociations":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["Marker"],"output_token":"NextMarker","result_key":"FileSystemAssociationSummaryList"},"ListGateways":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Gateways"},"ListLocalDisks":{"result_key":"Disks"},"ListTagsForResource":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["ResourceARN"],"output_token":"Marker","result_key":"Tags"},"ListTapePools":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"PoolInfos"},"ListTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeInfos"},"ListVolumeRecoveryPoints":{"result_key":"VolumeRecoveryPointInfos"},"ListVolumes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VolumeInfos"}}}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['stepfunctions'] = {};
	AWS.StepFunctions = Service.defineService('stepfunctions', ['2016-11-23']);
	Object.defineProperty(apiLoader.services['stepfunctions'], '2016-11-23', {
	  get: function get() {
	    var model = __webpack_require__(467);
	    model.paginators = __webpack_require__(468).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.StepFunctions;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-23","endpointPrefix":"states","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"AWS SFN","serviceFullName":"AWS Step Functions","serviceId":"SFN","signatureVersion":"v4","targetPrefix":"AWSStepFunctions","uid":"states-2016-11-23"},"operations":{"CreateActivity":{"input":{"type":"structure","required":["name"],"members":{"name":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","required":["activityArn","creationDate"],"members":{"activityArn":{},"creationDate":{"type":"timestamp"}}},"idempotent":true},"CreateStateMachine":{"input":{"type":"structure","required":["name","definition","roleArn"],"members":{"name":{},"definition":{"shape":"Sb"},"roleArn":{},"type":{},"loggingConfiguration":{"shape":"Sd"},"tags":{"shape":"S3"},"tracingConfiguration":{"shape":"Sj"}}},"output":{"type":"structure","required":["stateMachineArn","creationDate"],"members":{"stateMachineArn":{},"creationDate":{"type":"timestamp"}}},"idempotent":true},"DeleteActivity":{"input":{"type":"structure","required":["activityArn"],"members":{"activityArn":{}}},"output":{"type":"structure","members":{}}},"DeleteStateMachine":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{}}},"output":{"type":"structure","members":{}}},"DescribeActivity":{"input":{"type":"structure","required":["activityArn"],"members":{"activityArn":{}}},"output":{"type":"structure","required":["activityArn","name","creationDate"],"members":{"activityArn":{},"name":{},"creationDate":{"type":"timestamp"}}}},"DescribeExecution":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{}}},"output":{"type":"structure","required":["executionArn","stateMachineArn","status","startDate"],"members":{"executionArn":{},"stateMachineArn":{},"name":{},"status":{},"startDate":{"type":"timestamp"},"stopDate":{"type":"timestamp"},"input":{"shape":"Sv"},"inputDetails":{"shape":"Sw"},"output":{"shape":"Sv"},"outputDetails":{"shape":"Sw"},"traceHeader":{}}}},"DescribeStateMachine":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{}}},"output":{"type":"structure","required":["stateMachineArn","name","definition","roleArn","type","creationDate"],"members":{"stateMachineArn":{},"name":{},"status":{},"definition":{"shape":"Sb"},"roleArn":{},"type":{},"creationDate":{"type":"timestamp"},"loggingConfiguration":{"shape":"Sd"},"tracingConfiguration":{"shape":"Sj"}}}},"DescribeStateMachineForExecution":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{}}},"output":{"type":"structure","required":["stateMachineArn","name","definition","roleArn","updateDate"],"members":{"stateMachineArn":{},"name":{},"definition":{"shape":"Sb"},"roleArn":{},"updateDate":{"type":"timestamp"},"loggingConfiguration":{"shape":"Sd"},"tracingConfiguration":{"shape":"Sj"}}}},"GetActivityTask":{"input":{"type":"structure","required":["activityArn"],"members":{"activityArn":{},"workerName":{}}},"output":{"type":"structure","members":{"taskToken":{},"input":{"type":"string","sensitive":true}}}},"GetExecutionHistory":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{},"maxResults":{"type":"integer"},"reverseOrder":{"type":"boolean"},"nextToken":{},"includeExecutionData":{"type":"boolean"}}},"output":{"type":"structure","required":["events"],"members":{"events":{"type":"list","member":{"type":"structure","required":["timestamp","type","id"],"members":{"timestamp":{"type":"timestamp"},"type":{},"id":{"type":"long"},"previousEventId":{"type":"long"},"activityFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"activityScheduleFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"activityScheduledEventDetails":{"type":"structure","required":["resource"],"members":{"resource":{},"input":{"shape":"Sv"},"inputDetails":{"shape":"S1n"},"timeoutInSeconds":{"type":"long"},"heartbeatInSeconds":{"type":"long"}}},"activityStartedEventDetails":{"type":"structure","members":{"workerName":{}}},"activitySucceededEventDetails":{"type":"structure","members":{"output":{"shape":"Sv"},"outputDetails":{"shape":"S1n"}}},"activityTimedOutEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"taskFailedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"taskScheduledEventDetails":{"type":"structure","required":["resourceType","resource","region","parameters"],"members":{"resourceType":{},"resource":{},"region":{},"parameters":{"type":"string","sensitive":true},"timeoutInSeconds":{"type":"long"},"heartbeatInSeconds":{"type":"long"}}},"taskStartFailedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"taskStartedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{}}},"taskSubmitFailedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"taskSubmittedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"output":{"shape":"Sv"},"outputDetails":{"shape":"S1n"}}},"taskSucceededEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"output":{"shape":"Sv"},"outputDetails":{"shape":"S1n"}}},"taskTimedOutEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"executionFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"executionStartedEventDetails":{"type":"structure","members":{"input":{"shape":"Sv"},"inputDetails":{"shape":"S1n"},"roleArn":{}}},"executionSucceededEventDetails":{"type":"structure","members":{"output":{"shape":"Sv"},"outputDetails":{"shape":"S1n"}}},"executionAbortedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"executionTimedOutEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"mapStateStartedEventDetails":{"type":"structure","members":{"length":{"type":"integer"}}},"mapIterationStartedEventDetails":{"shape":"S2a"},"mapIterationSucceededEventDetails":{"shape":"S2a"},"mapIterationFailedEventDetails":{"shape":"S2a"},"mapIterationAbortedEventDetails":{"shape":"S2a"},"lambdaFunctionFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"lambdaFunctionScheduleFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"lambdaFunctionScheduledEventDetails":{"type":"structure","required":["resource"],"members":{"resource":{},"input":{"shape":"Sv"},"inputDetails":{"shape":"S1n"},"timeoutInSeconds":{"type":"long"}}},"lambdaFunctionStartFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"lambdaFunctionSucceededEventDetails":{"type":"structure","members":{"output":{"shape":"Sv"},"outputDetails":{"shape":"S1n"}}},"lambdaFunctionTimedOutEventDetails":{"type":"structure","members":{"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"stateEnteredEventDetails":{"type":"structure","required":["name"],"members":{"name":{},"input":{"shape":"Sv"},"inputDetails":{"shape":"S1n"}}},"stateExitedEventDetails":{"type":"structure","required":["name"],"members":{"name":{},"output":{"shape":"Sv"},"outputDetails":{"shape":"S1n"}}}}}},"nextToken":{}}}},"ListActivities":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["activities"],"members":{"activities":{"type":"list","member":{"type":"structure","required":["activityArn","name","creationDate"],"members":{"activityArn":{},"name":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListExecutions":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"statusFilter":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["executions"],"members":{"executions":{"type":"list","member":{"type":"structure","required":["executionArn","stateMachineArn","name","status","startDate"],"members":{"executionArn":{},"stateMachineArn":{},"name":{},"status":{},"startDate":{"type":"timestamp"},"stopDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListStateMachines":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["stateMachines"],"members":{"stateMachines":{"type":"list","member":{"type":"structure","required":["stateMachineArn","name","type","creationDate"],"members":{"stateMachineArn":{},"name":{},"type":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S3"}}}},"SendTaskFailure":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"output":{"type":"structure","members":{}}},"SendTaskHeartbeat":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{}}},"output":{"type":"structure","members":{}}},"SendTaskSuccess":{"input":{"type":"structure","required":["taskToken","output"],"members":{"taskToken":{},"output":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"StartExecution":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"name":{},"input":{"shape":"Sv"},"traceHeader":{}}},"output":{"type":"structure","required":["executionArn","startDate"],"members":{"executionArn":{},"startDate":{"type":"timestamp"}}},"idempotent":true},"StartSyncExecution":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"name":{},"input":{"shape":"Sv"},"traceHeader":{}}},"output":{"type":"structure","required":["executionArn","startDate","stopDate","status"],"members":{"executionArn":{},"stateMachineArn":{},"name":{},"startDate":{"type":"timestamp"},"stopDate":{"type":"timestamp"},"status":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"},"input":{"shape":"Sv"},"inputDetails":{"shape":"Sw"},"output":{"shape":"Sv"},"outputDetails":{"shape":"Sw"},"traceHeader":{},"billingDetails":{"type":"structure","members":{"billedMemoryUsedInMB":{"type":"long"},"billedDurationInMilliseconds":{"type":"long"}}}}},"endpoint":{"hostPrefix":"sync-"}},"StopExecution":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{},"error":{"shape":"S1j"},"cause":{"shape":"S1k"}}},"output":{"type":"structure","required":["stopDate"],"members":{"stopDate":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateStateMachine":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"definition":{"shape":"Sb"},"roleArn":{},"loggingConfiguration":{"shape":"Sd"},"tracingConfiguration":{"shape":"Sj"}}},"output":{"type":"structure","required":["updateDate"],"members":{"updateDate":{"type":"timestamp"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Sb":{"type":"string","sensitive":true},"Sd":{"type":"structure","members":{"level":{},"includeExecutionData":{"type":"boolean"},"destinations":{"type":"list","member":{"type":"structure","members":{"cloudWatchLogsLogGroup":{"type":"structure","members":{"logGroupArn":{}}}}}}}},"Sj":{"type":"structure","members":{"enabled":{"type":"boolean"}}},"Sv":{"type":"string","sensitive":true},"Sw":{"type":"structure","members":{"included":{"type":"boolean"}}},"S1j":{"type":"string","sensitive":true},"S1k":{"type":"string","sensitive":true},"S1n":{"type":"structure","members":{"truncated":{"type":"boolean"}}},"S2a":{"type":"structure","members":{"name":{},"index":{"type":"integer"}}}}}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetExecutionHistory":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"events"},"ListActivities":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"activities"},"ListExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"executions"},"ListStateMachines":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"stateMachines"}}}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['support'] = {};
	AWS.Support = Service.defineService('support', ['2013-04-15']);
	Object.defineProperty(apiLoader.services['support'], '2013-04-15', {
	  get: function get() {
	    var model = __webpack_require__(470);
	    model.paginators = __webpack_require__(471).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Support;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-04-15","endpointPrefix":"support","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Support","serviceId":"Support","signatureVersion":"v4","targetPrefix":"AWSSupport_20130415","uid":"support-2013-04-15"},"operations":{"AddAttachmentsToSet":{"input":{"type":"structure","required":["attachments"],"members":{"attachmentSetId":{},"attachments":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"attachmentSetId":{},"expiryTime":{}}}},"AddCommunicationToCase":{"input":{"type":"structure","required":["communicationBody"],"members":{"caseId":{},"communicationBody":{},"ccEmailAddresses":{"shape":"Sc"},"attachmentSetId":{}}},"output":{"type":"structure","members":{"result":{"type":"boolean"}}}},"CreateCase":{"input":{"type":"structure","required":["subject","communicationBody"],"members":{"subject":{},"serviceCode":{},"severityCode":{},"categoryCode":{},"communicationBody":{},"ccEmailAddresses":{"shape":"Sc"},"language":{},"issueType":{},"attachmentSetId":{}}},"output":{"type":"structure","members":{"caseId":{}}}},"DescribeAttachment":{"input":{"type":"structure","required":["attachmentId"],"members":{"attachmentId":{}}},"output":{"type":"structure","members":{"attachment":{"shape":"S4"}}}},"DescribeCases":{"input":{"type":"structure","members":{"caseIdList":{"type":"list","member":{}},"displayId":{},"afterTime":{},"beforeTime":{},"includeResolvedCases":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"},"language":{},"includeCommunications":{"type":"boolean"}}},"output":{"type":"structure","members":{"cases":{"type":"list","member":{"type":"structure","members":{"caseId":{},"displayId":{},"subject":{},"status":{},"serviceCode":{},"categoryCode":{},"severityCode":{},"submittedBy":{},"timeCreated":{},"recentCommunications":{"type":"structure","members":{"communications":{"shape":"S17"},"nextToken":{}}},"ccEmailAddresses":{"shape":"Sc"},"language":{}}}},"nextToken":{}}}},"DescribeCommunications":{"input":{"type":"structure","required":["caseId"],"members":{"caseId":{},"beforeTime":{},"afterTime":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"communications":{"shape":"S17"},"nextToken":{}}}},"DescribeServices":{"input":{"type":"structure","members":{"serviceCodeList":{"type":"list","member":{}},"language":{}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"type":"structure","members":{"code":{},"name":{},"categories":{"type":"list","member":{"type":"structure","members":{"code":{},"name":{}}}}}}}}}},"DescribeSeverityLevels":{"input":{"type":"structure","members":{"language":{}}},"output":{"type":"structure","members":{"severityLevels":{"type":"list","member":{"type":"structure","members":{"code":{},"name":{}}}}}}},"DescribeTrustedAdvisorCheckRefreshStatuses":{"input":{"type":"structure","required":["checkIds"],"members":{"checkIds":{"shape":"S1t"}}},"output":{"type":"structure","required":["statuses"],"members":{"statuses":{"type":"list","member":{"shape":"S1x"}}}}},"DescribeTrustedAdvisorCheckResult":{"input":{"type":"structure","required":["checkId"],"members":{"checkId":{},"language":{}}},"output":{"type":"structure","members":{"result":{"type":"structure","required":["checkId","timestamp","status","resourcesSummary","categorySpecificSummary","flaggedResources"],"members":{"checkId":{},"timestamp":{},"status":{},"resourcesSummary":{"shape":"S22"},"categorySpecificSummary":{"shape":"S23"},"flaggedResources":{"type":"list","member":{"type":"structure","required":["status","resourceId","metadata"],"members":{"status":{},"region":{},"resourceId":{},"isSuppressed":{"type":"boolean"},"metadata":{"shape":"S1t"}}}}}}}}},"DescribeTrustedAdvisorCheckSummaries":{"input":{"type":"structure","required":["checkIds"],"members":{"checkIds":{"shape":"S1t"}}},"output":{"type":"structure","required":["summaries"],"members":{"summaries":{"type":"list","member":{"type":"structure","required":["checkId","timestamp","status","resourcesSummary","categorySpecificSummary"],"members":{"checkId":{},"timestamp":{},"status":{},"hasFlaggedResources":{"type":"boolean"},"resourcesSummary":{"shape":"S22"},"categorySpecificSummary":{"shape":"S23"}}}}}}},"DescribeTrustedAdvisorChecks":{"input":{"type":"structure","required":["language"],"members":{"language":{}}},"output":{"type":"structure","required":["checks"],"members":{"checks":{"type":"list","member":{"type":"structure","required":["id","name","description","category","metadata"],"members":{"id":{},"name":{},"description":{},"category":{},"metadata":{"shape":"S1t"}}}}}}},"RefreshTrustedAdvisorCheck":{"input":{"type":"structure","required":["checkId"],"members":{"checkId":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"S1x"}}}},"ResolveCase":{"input":{"type":"structure","members":{"caseId":{}}},"output":{"type":"structure","members":{"initialCaseStatus":{},"finalCaseStatus":{}}}}},"shapes":{"S4":{"type":"structure","members":{"fileName":{},"data":{"type":"blob"}}},"Sc":{"type":"list","member":{}},"S17":{"type":"list","member":{"type":"structure","members":{"caseId":{},"body":{},"submittedBy":{},"timeCreated":{},"attachmentSet":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"fileName":{}}}}}}},"S1t":{"type":"list","member":{}},"S1x":{"type":"structure","required":["checkId","status","millisUntilNextRefreshable"],"members":{"checkId":{},"status":{},"millisUntilNextRefreshable":{"type":"long"}}},"S22":{"type":"structure","required":["resourcesProcessed","resourcesFlagged","resourcesIgnored","resourcesSuppressed"],"members":{"resourcesProcessed":{"type":"long"},"resourcesFlagged":{"type":"long"},"resourcesIgnored":{"type":"long"},"resourcesSuppressed":{"type":"long"}}},"S23":{"type":"structure","members":{"costOptimizing":{"type":"structure","required":["estimatedMonthlySavings","estimatedPercentMonthlySavings"],"members":{"estimatedMonthlySavings":{"type":"double"},"estimatedPercentMonthlySavings":{"type":"double"}}}}}}}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCases":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"cases"},"DescribeCommunications":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"communications"},"DescribeServices":{"result_key":"services"},"DescribeTrustedAdvisorCheckRefreshStatuses":{"result_key":"statuses"},"DescribeTrustedAdvisorCheckSummaries":{"result_key":"summaries"}}}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['swf'] = {};
	AWS.SWF = Service.defineService('swf', ['2012-01-25']);
	__webpack_require__(473);
	Object.defineProperty(apiLoader.services['swf'], '2012-01-25', {
	  get: function get() {
	    var model = __webpack_require__(474);
	    model.paginators = __webpack_require__(475).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SWF;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.hideProperties(AWS, ['SimpleWorkflow']);

	/**
	 * @constant
	 * @readonly
	 * Backwards compatibility for access to the {AWS.SWF} service class.
	 */
	AWS.SimpleWorkflow = AWS.SWF;


/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-01-25","endpointPrefix":"swf","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"Amazon SWF","serviceFullName":"Amazon Simple Workflow Service","serviceId":"SWF","signatureVersion":"v4","targetPrefix":"SimpleWorkflowService","uid":"swf-2012-01-25"},"operations":{"CountClosedWorkflowExecutions":{"input":{"type":"structure","required":["domain"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"closeTimeFilter":{"shape":"S3"},"executionFilter":{"shape":"S5"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"closeStatusFilter":{"shape":"Sc"}}},"output":{"shape":"Se"}},"CountOpenWorkflowExecutions":{"input":{"type":"structure","required":["domain","startTimeFilter"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"executionFilter":{"shape":"S5"}}},"output":{"shape":"Se"}},"CountPendingActivityTasks":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"}}},"output":{"shape":"Sk"}},"CountPendingDecisionTasks":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"}}},"output":{"shape":"Sk"}},"DeprecateActivityType":{"input":{"type":"structure","required":["domain","activityType"],"members":{"domain":{},"activityType":{"shape":"Sn"}}}},"DeprecateDomain":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeprecateWorkflowType":{"input":{"type":"structure","required":["domain","workflowType"],"members":{"domain":{},"workflowType":{"shape":"Sr"}}}},"DescribeActivityType":{"input":{"type":"structure","required":["domain","activityType"],"members":{"domain":{},"activityType":{"shape":"Sn"}}},"output":{"type":"structure","required":["typeInfo","configuration"],"members":{"typeInfo":{"shape":"Su"},"configuration":{"type":"structure","members":{"defaultTaskStartToCloseTimeout":{},"defaultTaskHeartbeatTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultTaskScheduleToStartTimeout":{},"defaultTaskScheduleToCloseTimeout":{}}}}}},"DescribeDomain":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","required":["domainInfo","configuration"],"members":{"domainInfo":{"shape":"S12"},"configuration":{"type":"structure","required":["workflowExecutionRetentionPeriodInDays"],"members":{"workflowExecutionRetentionPeriodInDays":{}}}}}},"DescribeWorkflowExecution":{"input":{"type":"structure","required":["domain","execution"],"members":{"domain":{},"execution":{"shape":"S17"}}},"output":{"type":"structure","required":["executionInfo","executionConfiguration","openCounts"],"members":{"executionInfo":{"shape":"S1a"},"executionConfiguration":{"type":"structure","required":["taskStartToCloseTimeout","executionStartToCloseTimeout","taskList","childPolicy"],"members":{"taskStartToCloseTimeout":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"childPolicy":{},"lambdaRole":{}}},"openCounts":{"type":"structure","required":["openActivityTasks","openDecisionTasks","openTimers","openChildWorkflowExecutions"],"members":{"openActivityTasks":{"type":"integer"},"openDecisionTasks":{"type":"integer"},"openTimers":{"type":"integer"},"openChildWorkflowExecutions":{"type":"integer"},"openLambdaFunctions":{"type":"integer"}}},"latestActivityTaskTimestamp":{"type":"timestamp"},"latestExecutionContext":{}}}},"DescribeWorkflowType":{"input":{"type":"structure","required":["domain","workflowType"],"members":{"domain":{},"workflowType":{"shape":"Sr"}}},"output":{"type":"structure","required":["typeInfo","configuration"],"members":{"typeInfo":{"shape":"S1m"},"configuration":{"type":"structure","members":{"defaultTaskStartToCloseTimeout":{},"defaultExecutionStartToCloseTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultChildPolicy":{},"defaultLambdaRole":{}}}}}},"GetWorkflowExecutionHistory":{"input":{"type":"structure","required":["domain","execution"],"members":{"domain":{},"execution":{"shape":"S17"},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["events"],"members":{"events":{"shape":"S1t"},"nextPageToken":{}}}},"ListActivityTypes":{"input":{"type":"structure","required":["domain","registrationStatus"],"members":{"domain":{},"name":{},"registrationStatus":{},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["typeInfos"],"members":{"typeInfos":{"type":"list","member":{"shape":"Su"}},"nextPageToken":{}}}},"ListClosedWorkflowExecutions":{"input":{"type":"structure","required":["domain"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"closeTimeFilter":{"shape":"S3"},"executionFilter":{"shape":"S5"},"closeStatusFilter":{"shape":"Sc"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"shape":"S4g"}},"ListDomains":{"input":{"type":"structure","required":["registrationStatus"],"members":{"nextPageToken":{},"registrationStatus":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["domainInfos"],"members":{"domainInfos":{"type":"list","member":{"shape":"S12"}},"nextPageToken":{}}}},"ListOpenWorkflowExecutions":{"input":{"type":"structure","required":["domain","startTimeFilter"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"},"executionFilter":{"shape":"S5"}}},"output":{"shape":"S4g"}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S4o"}}}},"ListWorkflowTypes":{"input":{"type":"structure","required":["domain","registrationStatus"],"members":{"domain":{},"name":{},"registrationStatus":{},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["typeInfos"],"members":{"typeInfos":{"type":"list","member":{"shape":"S1m"}},"nextPageToken":{}}}},"PollForActivityTask":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"},"identity":{}}},"output":{"type":"structure","required":["taskToken","activityId","startedEventId","workflowExecution","activityType"],"members":{"taskToken":{},"activityId":{},"startedEventId":{"type":"long"},"workflowExecution":{"shape":"S17"},"activityType":{"shape":"Sn"},"input":{}}}},"PollForDecisionTask":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"},"identity":{},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["taskToken","startedEventId","workflowExecution","workflowType","events"],"members":{"taskToken":{},"startedEventId":{"type":"long"},"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"events":{"shape":"S1t"},"nextPageToken":{},"previousStartedEventId":{"type":"long"}}}},"RecordActivityTaskHeartbeat":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"details":{}}},"output":{"type":"structure","required":["cancelRequested"],"members":{"cancelRequested":{"type":"boolean"}}}},"RegisterActivityType":{"input":{"type":"structure","required":["domain","name","version"],"members":{"domain":{},"name":{},"version":{},"description":{},"defaultTaskStartToCloseTimeout":{},"defaultTaskHeartbeatTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultTaskScheduleToStartTimeout":{},"defaultTaskScheduleToCloseTimeout":{}}}},"RegisterDomain":{"input":{"type":"structure","required":["name","workflowExecutionRetentionPeriodInDays"],"members":{"name":{},"description":{},"workflowExecutionRetentionPeriodInDays":{},"tags":{"shape":"S4o"}}}},"RegisterWorkflowType":{"input":{"type":"structure","required":["domain","name","version"],"members":{"domain":{},"name":{},"version":{},"description":{},"defaultTaskStartToCloseTimeout":{},"defaultExecutionStartToCloseTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultChildPolicy":{},"defaultLambdaRole":{}}}},"RequestCancelWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId"],"members":{"domain":{},"workflowId":{},"runId":{}}}},"RespondActivityTaskCanceled":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"details":{}}}},"RespondActivityTaskCompleted":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"result":{}}}},"RespondActivityTaskFailed":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"reason":{},"details":{}}}},"RespondDecisionTaskCompleted":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"decisions":{"type":"list","member":{"type":"structure","required":["decisionType"],"members":{"decisionType":{},"scheduleActivityTaskDecisionAttributes":{"type":"structure","required":["activityType","activityId"],"members":{"activityType":{"shape":"Sn"},"activityId":{},"control":{},"input":{},"scheduleToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"scheduleToStartTimeout":{},"startToCloseTimeout":{},"heartbeatTimeout":{}}},"requestCancelActivityTaskDecisionAttributes":{"type":"structure","required":["activityId"],"members":{"activityId":{}}},"completeWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"result":{}}},"failWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"reason":{},"details":{}}},"cancelWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"details":{}}},"continueAsNewWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"input":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"taskStartToCloseTimeout":{},"childPolicy":{},"tagList":{"shape":"S1c"},"workflowTypeVersion":{},"lambdaRole":{}}},"recordMarkerDecisionAttributes":{"type":"structure","required":["markerName"],"members":{"markerName":{},"details":{}}},"startTimerDecisionAttributes":{"type":"structure","required":["timerId","startToFireTimeout"],"members":{"timerId":{},"control":{},"startToFireTimeout":{}}},"cancelTimerDecisionAttributes":{"type":"structure","required":["timerId"],"members":{"timerId":{}}},"signalExternalWorkflowExecutionDecisionAttributes":{"type":"structure","required":["workflowId","signalName"],"members":{"workflowId":{},"runId":{},"signalName":{},"input":{},"control":{}}},"requestCancelExternalWorkflowExecutionDecisionAttributes":{"type":"structure","required":["workflowId"],"members":{"workflowId":{},"runId":{},"control":{}}},"startChildWorkflowExecutionDecisionAttributes":{"type":"structure","required":["workflowType","workflowId"],"members":{"workflowType":{"shape":"Sr"},"workflowId":{},"control":{},"input":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"taskStartToCloseTimeout":{},"childPolicy":{},"tagList":{"shape":"S1c"},"lambdaRole":{}}},"scheduleLambdaFunctionDecisionAttributes":{"type":"structure","required":["id","name"],"members":{"id":{},"name":{},"control":{},"input":{},"startToCloseTimeout":{}}}}}},"executionContext":{}}}},"SignalWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId","signalName"],"members":{"domain":{},"workflowId":{},"runId":{},"signalName":{},"input":{}}}},"StartWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId","workflowType"],"members":{"domain":{},"workflowId":{},"workflowType":{"shape":"Sr"},"taskList":{"shape":"Sj"},"taskPriority":{},"input":{},"executionStartToCloseTimeout":{},"tagList":{"shape":"S1c"},"taskStartToCloseTimeout":{},"childPolicy":{},"lambdaRole":{}}},"output":{"type":"structure","members":{"runId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S4o"}}}},"TerminateWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId"],"members":{"domain":{},"workflowId":{},"runId":{},"reason":{},"details":{},"childPolicy":{}}}},"UndeprecateActivityType":{"input":{"type":"structure","required":["domain","activityType"],"members":{"domain":{},"activityType":{"shape":"Sn"}}}},"UndeprecateDomain":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"UndeprecateWorkflowType":{"input":{"type":"structure","required":["domain","workflowType"],"members":{"domain":{},"workflowType":{"shape":"Sr"}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}}},"shapes":{"S3":{"type":"structure","required":["oldestDate"],"members":{"oldestDate":{"type":"timestamp"},"latestDate":{"type":"timestamp"}}},"S5":{"type":"structure","required":["workflowId"],"members":{"workflowId":{}}},"S7":{"type":"structure","required":["name"],"members":{"name":{},"version":{}}},"Sa":{"type":"structure","required":["tag"],"members":{"tag":{}}},"Sc":{"type":"structure","required":["status"],"members":{"status":{}}},"Se":{"type":"structure","required":["count"],"members":{"count":{"type":"integer"},"truncated":{"type":"boolean"}}},"Sj":{"type":"structure","required":["name"],"members":{"name":{}}},"Sk":{"type":"structure","required":["count"],"members":{"count":{"type":"integer"},"truncated":{"type":"boolean"}}},"Sn":{"type":"structure","required":["name","version"],"members":{"name":{},"version":{}}},"Sr":{"type":"structure","required":["name","version"],"members":{"name":{},"version":{}}},"Su":{"type":"structure","required":["activityType","status","creationDate"],"members":{"activityType":{"shape":"Sn"},"status":{},"description":{},"creationDate":{"type":"timestamp"},"deprecationDate":{"type":"timestamp"}}},"S12":{"type":"structure","required":["name","status"],"members":{"name":{},"status":{},"description":{},"arn":{}}},"S17":{"type":"structure","required":["workflowId","runId"],"members":{"workflowId":{},"runId":{}}},"S1a":{"type":"structure","required":["execution","workflowType","startTimestamp","executionStatus"],"members":{"execution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"startTimestamp":{"type":"timestamp"},"closeTimestamp":{"type":"timestamp"},"executionStatus":{},"closeStatus":{},"parent":{"shape":"S17"},"tagList":{"shape":"S1c"},"cancelRequested":{"type":"boolean"}}},"S1c":{"type":"list","member":{}},"S1m":{"type":"structure","required":["workflowType","status","creationDate"],"members":{"workflowType":{"shape":"Sr"},"status":{},"description":{},"creationDate":{"type":"timestamp"},"deprecationDate":{"type":"timestamp"}}},"S1t":{"type":"list","member":{"type":"structure","required":["eventTimestamp","eventType","eventId"],"members":{"eventTimestamp":{"type":"timestamp"},"eventType":{},"eventId":{"type":"long"},"workflowExecutionStartedEventAttributes":{"type":"structure","required":["childPolicy","taskList","workflowType"],"members":{"input":{},"executionStartToCloseTimeout":{},"taskStartToCloseTimeout":{},"childPolicy":{},"taskList":{"shape":"Sj"},"taskPriority":{},"workflowType":{"shape":"Sr"},"tagList":{"shape":"S1c"},"continuedExecutionRunId":{},"parentWorkflowExecution":{"shape":"S17"},"parentInitiatedEventId":{"type":"long"},"lambdaRole":{}}},"workflowExecutionCompletedEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId"],"members":{"result":{},"decisionTaskCompletedEventId":{"type":"long"}}},"completeWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionFailedEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId"],"members":{"reason":{},"details":{},"decisionTaskCompletedEventId":{"type":"long"}}},"failWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionTimedOutEventAttributes":{"type":"structure","required":["timeoutType","childPolicy"],"members":{"timeoutType":{},"childPolicy":{}}},"workflowExecutionCanceledEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId"],"members":{"details":{},"decisionTaskCompletedEventId":{"type":"long"}}},"cancelWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionContinuedAsNewEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId","newExecutionRunId","taskList","childPolicy","workflowType"],"members":{"input":{},"decisionTaskCompletedEventId":{"type":"long"},"newExecutionRunId":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"taskStartToCloseTimeout":{},"childPolicy":{},"tagList":{"shape":"S1c"},"workflowType":{"shape":"Sr"},"lambdaRole":{}}},"continueAsNewWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionTerminatedEventAttributes":{"type":"structure","required":["childPolicy"],"members":{"reason":{},"details":{},"childPolicy":{},"cause":{}}},"workflowExecutionCancelRequestedEventAttributes":{"type":"structure","members":{"externalWorkflowExecution":{"shape":"S17"},"externalInitiatedEventId":{"type":"long"},"cause":{}}},"decisionTaskScheduledEventAttributes":{"type":"structure","required":["taskList"],"members":{"taskList":{"shape":"Sj"},"taskPriority":{},"startToCloseTimeout":{}}},"decisionTaskStartedEventAttributes":{"type":"structure","required":["scheduledEventId"],"members":{"identity":{},"scheduledEventId":{"type":"long"}}},"decisionTaskCompletedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"executionContext":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"decisionTaskTimedOutEventAttributes":{"type":"structure","required":["timeoutType","scheduledEventId","startedEventId"],"members":{"timeoutType":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"activityTaskScheduledEventAttributes":{"type":"structure","required":["activityType","activityId","taskList","decisionTaskCompletedEventId"],"members":{"activityType":{"shape":"Sn"},"activityId":{},"input":{},"control":{},"scheduleToStartTimeout":{},"scheduleToCloseTimeout":{},"startToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"decisionTaskCompletedEventId":{"type":"long"},"heartbeatTimeout":{}}},"activityTaskStartedEventAttributes":{"type":"structure","required":["scheduledEventId"],"members":{"identity":{},"scheduledEventId":{"type":"long"}}},"activityTaskCompletedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"result":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"activityTaskFailedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"reason":{},"details":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"activityTaskTimedOutEventAttributes":{"type":"structure","required":["timeoutType","scheduledEventId","startedEventId"],"members":{"timeoutType":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"details":{}}},"activityTaskCanceledEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"details":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"latestCancelRequestedEventId":{"type":"long"}}},"activityTaskCancelRequestedEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId","activityId"],"members":{"decisionTaskCompletedEventId":{"type":"long"},"activityId":{}}},"workflowExecutionSignaledEventAttributes":{"type":"structure","required":["signalName"],"members":{"signalName":{},"input":{},"externalWorkflowExecution":{"shape":"S17"},"externalInitiatedEventId":{"type":"long"}}},"markerRecordedEventAttributes":{"type":"structure","required":["markerName","decisionTaskCompletedEventId"],"members":{"markerName":{},"details":{},"decisionTaskCompletedEventId":{"type":"long"}}},"recordMarkerFailedEventAttributes":{"type":"structure","required":["markerName","cause","decisionTaskCompletedEventId"],"members":{"markerName":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"timerStartedEventAttributes":{"type":"structure","required":["timerId","startToFireTimeout","decisionTaskCompletedEventId"],"members":{"timerId":{},"control":{},"startToFireTimeout":{},"decisionTaskCompletedEventId":{"type":"long"}}},"timerFiredEventAttributes":{"type":"structure","required":["timerId","startedEventId"],"members":{"timerId":{},"startedEventId":{"type":"long"}}},"timerCanceledEventAttributes":{"type":"structure","required":["timerId","startedEventId","decisionTaskCompletedEventId"],"members":{"timerId":{},"startedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"}}},"startChildWorkflowExecutionInitiatedEventAttributes":{"type":"structure","required":["workflowId","workflowType","taskList","decisionTaskCompletedEventId","childPolicy"],"members":{"workflowId":{},"workflowType":{"shape":"Sr"},"control":{},"input":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"decisionTaskCompletedEventId":{"type":"long"},"childPolicy":{},"taskStartToCloseTimeout":{},"tagList":{"shape":"S1c"},"lambdaRole":{}}},"childWorkflowExecutionStartedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"initiatedEventId":{"type":"long"}}},"childWorkflowExecutionCompletedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"result":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"reason":{},"details":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionTimedOutEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","timeoutType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"timeoutType":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionCanceledEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"details":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionTerminatedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"signalExternalWorkflowExecutionInitiatedEventAttributes":{"type":"structure","required":["workflowId","signalName","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"signalName":{},"input":{},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"externalWorkflowExecutionSignaledEventAttributes":{"type":"structure","required":["workflowExecution","initiatedEventId"],"members":{"workflowExecution":{"shape":"S17"},"initiatedEventId":{"type":"long"}}},"signalExternalWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowId","cause","initiatedEventId","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"cause":{},"initiatedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"externalWorkflowExecutionCancelRequestedEventAttributes":{"type":"structure","required":["workflowExecution","initiatedEventId"],"members":{"workflowExecution":{"shape":"S17"},"initiatedEventId":{"type":"long"}}},"requestCancelExternalWorkflowExecutionInitiatedEventAttributes":{"type":"structure","required":["workflowId","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"requestCancelExternalWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowId","cause","initiatedEventId","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"cause":{},"initiatedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"scheduleActivityTaskFailedEventAttributes":{"type":"structure","required":["activityType","activityId","cause","decisionTaskCompletedEventId"],"members":{"activityType":{"shape":"Sn"},"activityId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"requestCancelActivityTaskFailedEventAttributes":{"type":"structure","required":["activityId","cause","decisionTaskCompletedEventId"],"members":{"activityId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"startTimerFailedEventAttributes":{"type":"structure","required":["timerId","cause","decisionTaskCompletedEventId"],"members":{"timerId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"cancelTimerFailedEventAttributes":{"type":"structure","required":["timerId","cause","decisionTaskCompletedEventId"],"members":{"timerId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"startChildWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowType","cause","workflowId","initiatedEventId","decisionTaskCompletedEventId"],"members":{"workflowType":{"shape":"Sr"},"cause":{},"workflowId":{},"initiatedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"lambdaFunctionScheduledEventAttributes":{"type":"structure","required":["id","name","decisionTaskCompletedEventId"],"members":{"id":{},"name":{},"control":{},"input":{},"startToCloseTimeout":{},"decisionTaskCompletedEventId":{"type":"long"}}},"lambdaFunctionStartedEventAttributes":{"type":"structure","required":["scheduledEventId"],"members":{"scheduledEventId":{"type":"long"}}},"lambdaFunctionCompletedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"result":{}}},"lambdaFunctionFailedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"reason":{},"details":{}}},"lambdaFunctionTimedOutEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"timeoutType":{}}},"scheduleLambdaFunctionFailedEventAttributes":{"type":"structure","required":["id","name","cause","decisionTaskCompletedEventId"],"members":{"id":{},"name":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"startLambdaFunctionFailedEventAttributes":{"type":"structure","members":{"scheduledEventId":{"type":"long"},"cause":{},"message":{}}}}}},"S4g":{"type":"structure","required":["executionInfos"],"members":{"executionInfos":{"type":"list","member":{"shape":"S1a"}},"nextPageToken":{}}},"S4o":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetWorkflowExecutionHistory":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"events"},"ListActivityTypes":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"typeInfos"},"ListClosedWorkflowExecutions":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"executionInfos"},"ListDomains":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"domainInfos"},"ListOpenWorkflowExecutions":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"executionInfos"},"ListWorkflowTypes":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"typeInfos"},"PollForDecisionTask":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"events"}}}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['xray'] = {};
	AWS.XRay = Service.defineService('xray', ['2016-04-12']);
	Object.defineProperty(apiLoader.services['xray'], '2016-04-12', {
	  get: function get() {
	    var model = __webpack_require__(477);
	    model.paginators = __webpack_require__(478).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.XRay;


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-12","endpointPrefix":"xray","protocol":"rest-json","serviceFullName":"AWS X-Ray","serviceId":"XRay","signatureVersion":"v4","uid":"xray-2016-04-12"},"operations":{"BatchGetTraces":{"http":{"requestUri":"/Traces"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Traces":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"LimitExceeded":{"type":"boolean"},"Segments":{"type":"list","member":{"type":"structure","members":{"Id":{},"Document":{}}}}}}},"UnprocessedTraceIds":{"type":"list","member":{}},"NextToken":{}}}},"CreateGroup":{"http":{"requestUri":"/CreateGroup"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Group":{"shape":"So"}}}},"CreateSamplingRule":{"http":{"requestUri":"/CreateSamplingRule"},"input":{"type":"structure","required":["SamplingRule"],"members":{"SamplingRule":{"shape":"Sq"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S16"}}}},"DeleteGroup":{"http":{"requestUri":"/DeleteGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{}}},"DeleteSamplingRule":{"http":{"requestUri":"/DeleteSamplingRule"},"input":{"type":"structure","members":{"RuleName":{},"RuleARN":{}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S16"}}}},"GetEncryptionConfig":{"http":{"requestUri":"/EncryptionConfig"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S1f"}}}},"GetGroup":{"http":{"requestUri":"/GetGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{"Group":{"shape":"So"}}}},"GetGroups":{"http":{"requestUri":"/Groups"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"}}}},"NextToken":{}}}},"GetInsight":{"http":{"requestUri":"/Insight"},"input":{"type":"structure","required":["InsightId"],"members":{"InsightId":{}}},"output":{"type":"structure","members":{"Insight":{"type":"structure","members":{"InsightId":{},"GroupARN":{},"GroupName":{},"RootCauseServiceId":{"shape":"S1t"},"Categories":{"shape":"S1v"},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Summary":{},"ClientRequestImpactStatistics":{"shape":"S1z"},"RootCauseServiceRequestImpactStatistics":{"shape":"S1z"},"TopAnomalousServices":{"shape":"S21"}}}}}},"GetInsightEvents":{"http":{"requestUri":"/InsightEvents"},"input":{"type":"structure","required":["InsightId"],"members":{"InsightId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InsightEvents":{"type":"list","member":{"type":"structure","members":{"Summary":{},"EventTime":{"type":"timestamp"},"ClientRequestImpactStatistics":{"shape":"S1z"},"RootCauseServiceRequestImpactStatistics":{"shape":"S1z"},"TopAnomalousServices":{"shape":"S21"}}}},"NextToken":{}}}},"GetInsightImpactGraph":{"http":{"requestUri":"/InsightImpactGraph"},"input":{"type":"structure","required":["InsightId","StartTime","EndTime"],"members":{"InsightId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"InsightId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ServiceGraphStartTime":{"type":"timestamp"},"ServiceGraphEndTime":{"type":"timestamp"},"Services":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"Type":{},"Name":{},"Names":{"shape":"S1u"},"AccountId":{},"Edges":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"}}}}}}},"NextToken":{}}}},"GetInsightSummaries":{"http":{"requestUri":"/InsightSummaries"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"States":{"type":"list","member":{}},"GroupARN":{},"GroupName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InsightSummaries":{"type":"list","member":{"type":"structure","members":{"InsightId":{},"GroupARN":{},"GroupName":{},"RootCauseServiceId":{"shape":"S1t"},"Categories":{"shape":"S1v"},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Summary":{},"ClientRequestImpactStatistics":{"shape":"S1z"},"RootCauseServiceRequestImpactStatistics":{"shape":"S1z"},"TopAnomalousServices":{"shape":"S21"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetSamplingRules":{"http":{"requestUri":"/GetSamplingRules"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingRuleRecords":{"type":"list","member":{"shape":"S16"}},"NextToken":{}}}},"GetSamplingStatisticSummaries":{"http":{"requestUri":"/SamplingStatisticSummaries"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingStatisticSummaries":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"BorrowCount":{"type":"integer"},"SampledCount":{"type":"integer"}}}},"NextToken":{}}}},"GetSamplingTargets":{"http":{"requestUri":"/SamplingTargets"},"input":{"type":"structure","required":["SamplingStatisticsDocuments"],"members":{"SamplingStatisticsDocuments":{"type":"list","member":{"type":"structure","required":["RuleName","ClientID","Timestamp","RequestCount","SampledCount"],"members":{"RuleName":{},"ClientID":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"SampledCount":{"type":"integer"},"BorrowCount":{"type":"integer"}}}}}},"output":{"type":"structure","members":{"SamplingTargetDocuments":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"FixedRate":{"type":"double"},"ReservoirQuota":{"type":"integer"},"ReservoirQuotaTTL":{"type":"timestamp"},"Interval":{"type":"integer"}}}},"LastRuleModification":{"type":"timestamp"},"UnprocessedStatistics":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"ErrorCode":{},"Message":{}}}}}}},"GetServiceGraph":{"http":{"requestUri":"/ServiceGraph"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"NextToken":{}}},"output":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Services":{"shape":"S3a"},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTimeSeriesServiceStatistics":{"http":{"requestUri":"/TimeSeriesServiceStatistics"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"EntitySelectorExpression":{},"Period":{"type":"integer"},"ForecastStatistics":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"TimeSeriesServiceStatistics":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"EdgeSummaryStatistics":{"shape":"S3e"},"ServiceSummaryStatistics":{"shape":"S3m"},"ServiceForecastStatistics":{"type":"structure","members":{"FaultCountHigh":{"type":"long"},"FaultCountLow":{"type":"long"}}},"ResponseTimeHistogram":{"shape":"S3h"}}}},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTraceGraph":{"http":{"requestUri":"/TraceGraph"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Services":{"shape":"S3a"},"NextToken":{}}}},"GetTraceSummaries":{"http":{"requestUri":"/TraceSummaries"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TimeRangeType":{},"Sampling":{"type":"boolean"},"SamplingStrategy":{"type":"structure","members":{"Name":{},"Value":{"type":"double"}}},"FilterExpression":{},"NextToken":{}}},"output":{"type":"structure","members":{"TraceSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"ResponseTime":{"type":"double"},"HasFault":{"type":"boolean"},"HasError":{"type":"boolean"},"HasThrottle":{"type":"boolean"},"IsPartial":{"type":"boolean"},"Http":{"type":"structure","members":{"HttpURL":{},"HttpStatus":{"type":"integer"},"HttpMethod":{},"UserAgent":{},"ClientIp":{}}},"Annotations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"AnnotationValue":{"type":"structure","members":{"NumberValue":{"type":"double"},"BooleanValue":{"type":"boolean"},"StringValue":{}}},"ServiceIds":{"shape":"S49"}}}}},"Users":{"type":"list","member":{"type":"structure","members":{"UserName":{},"ServiceIds":{"shape":"S49"}}}},"ServiceIds":{"shape":"S49"},"ResourceARNs":{"type":"list","member":{"type":"structure","members":{"ARN":{}}}},"InstanceIds":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"AvailabilityZones":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"EntryPoint":{"shape":"S1t"},"FaultRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1u"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S4o"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"ErrorRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1u"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S4o"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"ResponseTimeRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1u"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Coverage":{"type":"double"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"Revision":{"type":"integer"},"MatchedEventTime":{"type":"timestamp"}}}},"ApproximateTime":{"type":"timestamp"},"TracesProcessedCount":{"type":"long"},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sj"},"NextToken":{}}}},"PutEncryptionConfig":{"http":{"requestUri":"/PutEncryptionConfig"},"input":{"type":"structure","required":["Type"],"members":{"KeyId":{},"Type":{}}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S1f"}}}},"PutTelemetryRecords":{"http":{"requestUri":"/TelemetryRecords"},"input":{"type":"structure","required":["TelemetryRecords"],"members":{"TelemetryRecords":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"SegmentsReceivedCount":{"type":"integer"},"SegmentsSentCount":{"type":"integer"},"SegmentsSpilloverCount":{"type":"integer"},"SegmentsRejectedCount":{"type":"integer"},"BackendConnectionErrors":{"type":"structure","members":{"TimeoutCount":{"type":"integer"},"ConnectionRefusedCount":{"type":"integer"},"HTTPCode4XXCount":{"type":"integer"},"HTTPCode5XXCount":{"type":"integer"},"UnknownHostCount":{"type":"integer"},"OtherCount":{"type":"integer"}}}}}},"EC2InstanceId":{},"Hostname":{},"ResourceARN":{}}},"output":{"type":"structure","members":{}}},"PutTraceSegments":{"http":{"requestUri":"/TraceSegments"},"input":{"type":"structure","required":["TraceSegmentDocuments"],"members":{"TraceSegmentDocuments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedTraceSegments":{"type":"list","member":{"type":"structure","members":{"Id":{},"ErrorCode":{},"Message":{}}}}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"http":{"requestUri":"/UpdateGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"}}},"output":{"type":"structure","members":{"Group":{"shape":"So"}}}},"UpdateSamplingRule":{"http":{"requestUri":"/UpdateSamplingRule"},"input":{"type":"structure","required":["SamplingRuleUpdate"],"members":{"SamplingRuleUpdate":{"type":"structure","members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"Host":{},"ServiceName":{},"ServiceType":{},"HTTPMethod":{},"URLPath":{},"Attributes":{"shape":"S12"}}}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S16"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Si":{"type":"structure","members":{"InsightsEnabled":{"type":"boolean"},"NotificationsEnabled":{"type":"boolean"}}},"Sj":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"So":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"}}},"Sq":{"type":"structure","required":["ResourceARN","Priority","FixedRate","ReservoirSize","ServiceName","ServiceType","Host","HTTPMethod","URLPath","Version"],"members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"ServiceName":{},"ServiceType":{},"Host":{},"HTTPMethod":{},"URLPath":{},"Version":{"type":"integer"},"Attributes":{"shape":"S12"}}},"S12":{"type":"map","key":{},"value":{}},"S16":{"type":"structure","members":{"SamplingRule":{"shape":"Sq"},"CreatedAt":{"type":"timestamp"},"ModifiedAt":{"type":"timestamp"}}},"S1f":{"type":"structure","members":{"KeyId":{},"Status":{},"Type":{}}},"S1t":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1u"},"AccountId":{},"Type":{}}},"S1u":{"type":"list","member":{}},"S1v":{"type":"list","member":{}},"S1z":{"type":"structure","members":{"FaultCount":{"type":"long"},"OkCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S21":{"type":"list","member":{"type":"structure","members":{"ServiceId":{"shape":"S1t"}}}},"S3a":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"Name":{},"Names":{"shape":"S1u"},"Root":{"type":"boolean"},"AccountId":{},"Type":{},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Edges":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SummaryStatistics":{"shape":"S3e"},"ResponseTimeHistogram":{"shape":"S3h"},"Aliases":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"type":"list","member":{}},"Type":{}}}}}}},"SummaryStatistics":{"shape":"S3m"},"DurationHistogram":{"shape":"S3h"},"ResponseTimeHistogram":{"shape":"S3h"}}}},"S3e":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S3f"},"FaultStatistics":{"shape":"S3g"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S3f":{"type":"structure","members":{"ThrottleCount":{"type":"long"},"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S3g":{"type":"structure","members":{"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S3h":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"double"},"Count":{"type":"integer"}}}},"S3m":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S3f"},"FaultStatistics":{"shape":"S3g"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S49":{"type":"list","member":{"shape":"S1t"}},"S4o":{"type":"list","member":{"type":"structure","members":{"Name":{},"Message":{}}}}}}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"BatchGetTraces":{"input_token":"NextToken","output_token":"NextToken","result_key":"Traces"},"GetGroups":{"input_token":"NextToken","output_token":"NextToken","result_key":"Groups"},"GetInsightEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetInsightSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetSamplingRules":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingRuleRecords"},"GetSamplingStatisticSummaries":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingStatisticSummaries"},"GetServiceGraph":{"input_token":"NextToken","output_token":"NextToken","result_key":"Services"},"GetTimeSeriesServiceStatistics":{"input_token":"NextToken","output_token":"NextToken","result_key":"TimeSeriesServiceStatistics"},"GetTraceGraph":{"input_token":"NextToken","output_token":"NextToken","result_key":"Services"},"GetTraceSummaries":{"input_token":"NextToken","output_token":"NextToken","result_key":"TraceSummaries"}}}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['waf'] = {};
	AWS.WAF = Service.defineService('waf', ['2015-08-24']);
	Object.defineProperty(apiLoader.services['waf'], '2015-08-24', {
	  get: function get() {
	    var model = __webpack_require__(480);
	    model.paginators = __webpack_require__(481).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WAF;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-24","endpointPrefix":"waf","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF","serviceFullName":"AWS WAF","serviceId":"WAF","signatureVersion":"v4","targetPrefix":"AWSWAF_20150824","uid":"waf-2015-08-24"},"operations":{"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"},"ChangeToken":{}}}},"CreateWebACLMigrationStack":{"input":{"type":"structure","required":["WebACLId","S3BucketName","IgnoreUnsupportedType"],"members":{"WebACLId":{},"S3BucketName":{},"IgnoreUnsupportedType":{"type":"boolean"}}},"output":{"type":"structure","required":["S3ObjectUrl"],"members":{"S3ObjectUrl":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2k"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3s"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S4e"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S4e"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2k"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S24"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S3s"}},"NextMarker":{}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5p"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5p"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"Sx"}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S3s"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3s"}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"S8"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sj"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"Sq"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7f"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S1b"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7f"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1r"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S1y"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"DefaultAction":{"shape":"S20"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2m"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S5":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"S8"}}}},"S8":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"S9"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"S9":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sh":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sj"}}}},"Sj":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"So":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sx":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S12":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"S13"},"RateKey":{},"RateLimit":{"type":"long"}}},"S13":{"type":"list","member":{"shape":"S14"}},"S14":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S19":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S1b"}}}},"S1b":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1e":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1j":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"S13"}}},"S1m":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1p":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1r"}}}},"S1r":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1w":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S1y"}}}},"S1y":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S20":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S23":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"Rules":{"shape":"S24"},"WebACLArn":{}}},"S24":{"type":"list","member":{"shape":"S25"}},"S25":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S20"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{},"ExcludedRules":{"type":"list","member":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}}}}},"S2k":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2m"}}}},"S2m":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S3s":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"S9"}}}},"S4e":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S5p":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S7f":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S14"}}}}}}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['wafregional'] = {};
	AWS.WAFRegional = Service.defineService('wafregional', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['wafregional'], '2016-11-28', {
	  get: function get() {
	    var model = __webpack_require__(483);
	    model.paginators = __webpack_require__(484).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WAFRegional;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"waf-regional","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF Regional","serviceFullName":"AWS WAF Regional","serviceId":"WAF Regional","signatureVersion":"v4","targetPrefix":"AWSWAF_Regional_20161128","uid":"waf-regional-2016-11-28"},"operations":{"AssociateWebACL":{"input":{"type":"structure","required":["WebACLId","ResourceArn"],"members":{"WebACLId":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S9"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sk"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"Sr"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S15"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S1c"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1h"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1m"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1p"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1s"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1z"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S23"},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S26"},"ChangeToken":{}}}},"CreateWebACLMigrationStack":{"input":{"type":"structure","required":["WebACLId","S3BucketName","IgnoreUnsupportedType"],"members":{"WebACLId":{},"S3BucketName":{},"IgnoreUnsupportedType":{"type":"boolean"}}},"output":{"type":"structure","required":["S3ObjectUrl"],"members":{"S3ObjectUrl":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2m"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DisassociateWebACL":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S9"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sk"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"Sr"}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3w"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S15"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S1c"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1h"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1m"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1p"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S4i"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S4i"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1s"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1z"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S26"}}}},"GetWebACLForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"WebACLSummary":{"shape":"S59"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2m"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S27"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S3w"}},"NextMarker":{}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5w"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListResourcesForWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceArns":{"type":"list","member":{}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5w"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"S10"}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"shape":"S59"}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S3w"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3w"}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"Sb"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sm"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"St"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7p"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S1e"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7p"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S28"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1u"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S21"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S28"}}}},"DefaultAction":{"shape":"S23"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2o"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S9":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"Sb"}}}},"Sb":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"Sc"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"Sc":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sk":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sm"}}}},"Sm":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sr":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"St"}}}},"St":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"S10":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S15":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"S16"},"RateKey":{},"RateLimit":{"type":"long"}}},"S16":{"type":"list","member":{"shape":"S17"}},"S17":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S1c":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S1e"}}}},"S1e":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1h":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1m":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"S16"}}},"S1p":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1s":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1u"}}}},"S1u":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1z":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S21"}}}},"S21":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{}}},"S23":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S26":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S23"},"Rules":{"shape":"S27"},"WebACLArn":{}}},"S27":{"type":"list","member":{"shape":"S28"}},"S28":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S23"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{},"ExcludedRules":{"type":"list","member":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}}}}},"S2m":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2o"}}}},"S2o":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{}}},"S3w":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"Sc"}}}},"S4i":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S59":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}},"S5w":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S7p":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S17"}}}}}}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['workdocs'] = {};
	AWS.WorkDocs = Service.defineService('workdocs', ['2016-05-01']);
	Object.defineProperty(apiLoader.services['workdocs'], '2016-05-01', {
	  get: function get() {
	    var model = __webpack_require__(486);
	    model.paginators = __webpack_require__(487).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WorkDocs;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-05-01","endpointPrefix":"workdocs","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkDocs","serviceId":"WorkDocs","signatureVersion":"v4","uid":"workdocs-2016-05-01"},"operations":{"AbortDocumentVersionUpload":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"}}}},"ActivateUser":{"http":{"requestUri":"/api/v1/users/{UserId}/activation","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"AddResourcePermissions":{"http":{"requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":201},"input":{"type":"structure","required":["ResourceId","Principals"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Principals":{"type":"list","member":{"type":"structure","required":["Id","Type","Role"],"members":{"Id":{},"Type":{},"Role":{}}}},"NotificationOptions":{"type":"structure","members":{"SendEmail":{"type":"boolean"},"EmailMessage":{"shape":"St"}}}}},"output":{"type":"structure","members":{"ShareResults":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"InviteePrincipalId":{},"Role":{},"Status":{},"ShareId":{},"StatusMessage":{"shape":"St"}}}}}}},"CreateComment":{"http":{"requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment","responseCode":201},"input":{"type":"structure","required":["DocumentId","VersionId","Text"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Visibility":{},"NotifyCollaborators":{"type":"boolean"}}},"output":{"type":"structure","members":{"Comment":{"shape":"S13"}}}},"CreateCustomMetadata":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId","CustomMetadata"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionid"},"CustomMetadata":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"CreateFolder":{"http":{"requestUri":"/api/v1/folders","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Name":{},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"}}}},"CreateLabels":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId","Labels"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Labels":{"shape":"S1g"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{}}},"CreateNotificationSubscription":{"http":{"requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId","Endpoint","Protocol","SubscriptionType"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Endpoint":{},"Protocol":{},"SubscriptionType":{}}},"output":{"type":"structure","members":{"Subscription":{"shape":"S1p"}}}},"CreateUser":{"http":{"requestUri":"/api/v1/users","responseCode":201},"input":{"type":"structure","required":["Username","GivenName","Surname","Password"],"members":{"OrganizationId":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"Password":{"type":"string","sensitive":true},"TimeZoneId":{},"StorageRule":{"shape":"Sj"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"DeactivateUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}/activation","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}}},"DeleteComment":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","CommentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"CommentId":{"location":"uri","locationName":"CommentId"}}}},"DeleteCustomMetadata":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionId"},"Keys":{"location":"querystring","locationName":"keys","type":"list","member":{}},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteFolderContents":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteLabels":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Labels":{"shape":"S1g","location":"querystring","locationName":"labels"},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteNotificationSubscription":{"http":{"method":"DELETE","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}","responseCode":200},"input":{"type":"structure","required":["SubscriptionId","OrganizationId"],"members":{"SubscriptionId":{"location":"uri","locationName":"SubscriptionId"},"OrganizationId":{"location":"uri","locationName":"OrganizationId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeActivities":{"http":{"method":"GET","requestUri":"/api/v1/activities","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"StartTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"EndTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"ActivityTypes":{"location":"querystring","locationName":"activityTypes"},"ResourceId":{"location":"querystring","locationName":"resourceId"},"UserId":{"location":"querystring","locationName":"userId"},"IncludeIndirectActivities":{"location":"querystring","locationName":"includeIndirectActivities","type":"boolean"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"UserActivities":{"type":"list","member":{"type":"structure","members":{"Type":{},"TimeStamp":{"type":"timestamp"},"IsIndirectActivity":{"type":"boolean"},"OrganizationId":{},"Initiator":{"shape":"S2d"},"Participants":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2d"}},"Groups":{"shape":"S2g"}}},"ResourceMetadata":{"shape":"S2j"},"OriginalParent":{"shape":"S2j"},"CommentMetadata":{"type":"structure","members":{"CommentId":{},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"CommentStatus":{},"RecipientId":{}}}}}},"Marker":{}}}},"DescribeComments":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comments","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Comments":{"type":"list","member":{"shape":"S13"}},"Marker":{}}}},"DescribeDocumentVersions":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Include":{"location":"querystring","locationName":"include"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"shape":"S2u"}},"Marker":{}}}},"DescribeFolderContents":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Sort":{"location":"querystring","locationName":"sort"},"Order":{"location":"querystring","locationName":"order"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"},"Type":{"location":"querystring","locationName":"type"},"Include":{"location":"querystring","locationName":"include"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Documents":{"shape":"S38"},"Marker":{}}}},"DescribeGroups":{"http":{"method":"GET","requestUri":"/api/v1/groups","responseCode":200},"input":{"type":"structure","required":["SearchQuery"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"SearchQuery":{"shape":"S3b","location":"querystring","locationName":"searchQuery"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S2g"},"Marker":{}}}},"DescribeNotificationSubscriptions":{"http":{"method":"GET","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Subscriptions":{"type":"list","member":{"shape":"S1p"}},"Marker":{}}}},"DescribeResourcePermissions":{"http":{"method":"GET","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"querystring","locationName":"principalId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Role":{},"Type":{}}}}}}},"Marker":{}}}},"DescribeRootFolders":{"http":{"method":"GET","requestUri":"/api/v1/me/root","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Marker":{}}}},"DescribeUsers":{"http":{"method":"GET","requestUri":"/api/v1/users","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserIds":{"location":"querystring","locationName":"userIds"},"Query":{"shape":"S3b","location":"querystring","locationName":"query"},"Include":{"location":"querystring","locationName":"include"},"Order":{"location":"querystring","locationName":"order"},"Sort":{"location":"querystring","locationName":"sort"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S8"}},"TotalNumberOfUsers":{"deprecated":true,"type":"long"},"Marker":{}}}},"GetCurrentUser":{"http":{"method":"GET","requestUri":"/api/v1/me","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"GetDocument":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S39"},"CustomMetadata":{"shape":"S16"}}}},"GetDocumentPath":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/path","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S42"}}}},"GetDocumentVersion":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Fields":{"location":"querystring","locationName":"fields"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S2u"},"CustomMetadata":{"shape":"S16"}}}},"GetFolder":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"},"CustomMetadata":{"shape":"S16"}}}},"GetFolderPath":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/path","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S42"}}}},"GetResources":{"http":{"method":"GET","requestUri":"/api/v1/resources","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"querystring","locationName":"userId"},"CollectionType":{"location":"querystring","locationName":"collectionType"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Documents":{"shape":"S38"},"Marker":{}}}},"InitiateDocumentVersionUpload":{"http":{"requestUri":"/api/v1/documents","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Id":{},"Name":{},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"ContentType":{},"DocumentSizeInBytes":{"type":"long"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S39"},"UploadMetadata":{"type":"structure","members":{"UploadUrl":{"shape":"S2z"},"SignedHeaders":{"type":"map","key":{},"value":{}}}}}}},"RemoveAllResourcePermissions":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":204},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}}},"RemoveResourcePermission":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions/{PrincipalId}","responseCode":204},"input":{"type":"structure","required":["ResourceId","PrincipalId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"PrincipalType":{"location":"querystring","locationName":"type"}}}},"UpdateDocument":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateDocumentVersion":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"VersionStatus":{}}}},"UpdateFolder":{"http":{"method":"PATCH","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateUser":{"http":{"method":"PATCH","requestUri":"/api/v1/users/{UserId}","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"},"GivenName":{},"Surname":{},"Type":{},"StorageRule":{"shape":"Sj"},"TimeZoneId":{},"Locale":{},"GrantPoweruserPrivileges":{}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S8":{"type":"structure","members":{"Id":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"OrganizationId":{},"RootFolderId":{},"RecycleBinFolderId":{},"Status":{},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"TimeZoneId":{},"Locale":{},"Storage":{"type":"structure","members":{"StorageUtilizedInBytes":{"type":"long"},"StorageRule":{"shape":"Sj"}}}}},"Sj":{"type":"structure","members":{"StorageAllocatedInBytes":{"type":"long"},"StorageType":{}}},"St":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S13":{"type":"structure","required":["CommentId"],"members":{"CommentId":{},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"Status":{},"Visibility":{},"RecipientId":{}}},"S16":{"type":"map","key":{},"value":{}},"S1d":{"type":"structure","members":{"Id":{},"Name":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ResourceState":{},"Signature":{},"Labels":{"shape":"S1g"},"Size":{"type":"long"},"LatestVersionSize":{"type":"long"}}},"S1g":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"SubscriptionId":{},"EndPoint":{},"Protocol":{}}},"S2d":{"type":"structure","members":{"Id":{},"Username":{},"GivenName":{},"Surname":{},"EmailAddress":{}}},"S2g":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}},"S2j":{"type":"structure","members":{"Type":{},"Name":{},"OriginalName":{},"Id":{},"VersionId":{},"Owner":{"shape":"S2d"},"ParentId":{}}},"S2u":{"type":"structure","members":{"Id":{},"Name":{},"ContentType":{},"Size":{"type":"long"},"Signature":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"CreatorId":{},"Thumbnail":{"type":"map","key":{},"value":{"shape":"S2z"}},"Source":{"type":"map","key":{},"value":{"shape":"S2z"}}}},"S2z":{"type":"string","sensitive":true},"S37":{"type":"list","member":{"shape":"S1d"}},"S38":{"type":"list","member":{"shape":"S39"}},"S39":{"type":"structure","members":{"Id":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"LatestVersionMetadata":{"shape":"S2u"},"ResourceState":{},"Labels":{"shape":"S1g"}}},"S3b":{"type":"string","sensitive":true},"S42":{"type":"structure","members":{"Components":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}}}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDocumentVersions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"DocumentVersions"},"DescribeFolderContents":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":["Folders","Documents"]},"DescribeUsers":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Users"}}}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['workspaces'] = {};
	AWS.WorkSpaces = Service.defineService('workspaces', ['2015-04-08']);
	Object.defineProperty(apiLoader.services['workspaces'], '2015-04-08', {
	  get: function get() {
	    var model = __webpack_require__(489);
	    model.paginators = __webpack_require__(490).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WorkSpaces;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-08","endpointPrefix":"workspaces","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon WorkSpaces","serviceId":"WorkSpaces","signatureVersion":"v4","targetPrefix":"WorkspacesService","uid":"workspaces-2015-04-08"},"operations":{"AssociateConnectionAlias":{"input":{"type":"structure","required":["AliasId","ResourceId"],"members":{"AliasId":{},"ResourceId":{}}},"output":{"type":"structure","members":{"ConnectionIdentifier":{}}}},"AssociateIpGroups":{"input":{"type":"structure","required":["DirectoryId","GroupIds"],"members":{"DirectoryId":{},"GroupIds":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"AuthorizeIpRules":{"input":{"type":"structure","required":["GroupId","UserRules"],"members":{"GroupId":{},"UserRules":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CopyWorkspaceImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"Name":{},"Description":{},"SourceImageId":{},"SourceRegion":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ImageId":{}}}},"CreateConnectClientAddIn":{"input":{"type":"structure","required":["ResourceId","Name","URL"],"members":{"ResourceId":{},"Name":{},"URL":{}}},"output":{"type":"structure","members":{"AddInId":{}}}},"CreateConnectionAlias":{"input":{"type":"structure","required":["ConnectionString"],"members":{"ConnectionString":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"AliasId":{}}}},"CreateIpGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"GroupDesc":{},"UserRules":{"shape":"Sc"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"GroupId":{}}}},"CreateTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"CreateUpdatedWorkspaceImage":{"input":{"type":"structure","required":["Name","Description","SourceImageId"],"members":{"Name":{},"Description":{},"SourceImageId":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ImageId":{}}}},"CreateWorkspaceBundle":{"input":{"type":"structure","required":["BundleName","BundleDescription","ImageId","ComputeType","UserStorage"],"members":{"BundleName":{},"BundleDescription":{},"ImageId":{},"ComputeType":{"shape":"S1a"},"UserStorage":{"shape":"S1c"},"RootStorage":{"shape":"S1d"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"WorkspaceBundle":{"shape":"S1f"}}}},"CreateWorkspaces":{"input":{"type":"structure","required":["Workspaces"],"members":{"Workspaces":{"type":"list","member":{"shape":"S1m"}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"type":"structure","members":{"WorkspaceRequest":{"shape":"S1m"},"ErrorCode":{},"ErrorMessage":{}}}},"PendingRequests":{"shape":"S1z"}}}},"DeleteClientBranding":{"input":{"type":"structure","required":["ResourceId","Platforms"],"members":{"ResourceId":{},"Platforms":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteConnectClientAddIn":{"input":{"type":"structure","required":["AddInId","ResourceId"],"members":{"AddInId":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"DeleteConnectionAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{}}},"DeleteIpGroup":{"input":{"type":"structure","required":["GroupId"],"members":{"GroupId":{}}},"output":{"type":"structure","members":{}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteWorkspaceBundle":{"input":{"type":"structure","members":{"BundleId":{}}},"output":{"type":"structure","members":{}}},"DeleteWorkspaceImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{}}},"output":{"type":"structure","members":{}}},"DeregisterWorkspaceDirectory":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{}}},"DescribeAccount":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DedicatedTenancySupport":{},"DedicatedTenancyManagementCidrRange":{}}}},"DescribeAccountModifications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"AccountModifications":{"type":"list","member":{"type":"structure","members":{"ModificationState":{},"DedicatedTenancySupport":{},"DedicatedTenancyManagementCidrRange":{},"StartTime":{"type":"timestamp"},"ErrorCode":{},"ErrorMessage":{}}}},"NextToken":{}}}},"DescribeClientBranding":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{}}},"output":{"type":"structure","members":{"DeviceTypeWindows":{"shape":"S36"},"DeviceTypeOsx":{"shape":"S36"},"DeviceTypeAndroid":{"shape":"S36"},"DeviceTypeIos":{"shape":"S3c"},"DeviceTypeLinux":{"shape":"S36"},"DeviceTypeWeb":{"shape":"S36"}}}},"DescribeClientProperties":{"input":{"type":"structure","required":["ResourceIds"],"members":{"ResourceIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ClientPropertiesList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ClientProperties":{"shape":"S3i"}}}}}}},"DescribeConnectClientAddIns":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AddIns":{"type":"list","member":{"type":"structure","members":{"AddInId":{},"ResourceId":{},"Name":{},"URL":{}}}},"NextToken":{}}}},"DescribeConnectionAliasPermissions":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AliasId":{},"ConnectionAliasPermissions":{"type":"list","member":{"shape":"S3s"}},"NextToken":{}}}},"DescribeConnectionAliases":{"input":{"type":"structure","members":{"AliasIds":{"type":"list","member":{}},"ResourceId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConnectionAliases":{"type":"list","member":{"type":"structure","members":{"ConnectionString":{},"AliasId":{},"State":{},"OwnerAccountId":{},"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationStatus":{},"AssociatedAccountId":{},"ResourceId":{},"ConnectionIdentifier":{}}}}}}},"NextToken":{}}}},"DescribeIpGroups":{"input":{"type":"structure","members":{"GroupIds":{"shape":"S8"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Result":{"type":"list","member":{"type":"structure","members":{"groupId":{},"groupName":{},"groupDesc":{},"userRules":{"shape":"Sc"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"Sm"}}}},"DescribeWorkspaceBundles":{"input":{"type":"structure","members":{"BundleIds":{"type":"list","member":{}},"Owner":{},"NextToken":{}}},"output":{"type":"structure","members":{"Bundles":{"type":"list","member":{"shape":"S1f"}},"NextToken":{}}}},"DescribeWorkspaceDirectories":{"input":{"type":"structure","members":{"DirectoryIds":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Directories":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"Alias":{},"DirectoryName":{},"RegistrationCode":{},"SubnetIds":{"shape":"S4l"},"DnsIpAddresses":{"type":"list","member":{}},"CustomerUserName":{},"IamRoleId":{},"DirectoryType":{},"WorkspaceSecurityGroupId":{},"State":{},"WorkspaceCreationProperties":{"type":"structure","members":{"EnableWorkDocs":{"type":"boolean"},"EnableInternetAccess":{"type":"boolean"},"DefaultOu":{},"CustomSecurityGroupId":{},"UserEnabledAsLocalAdministrator":{"type":"boolean"},"EnableMaintenanceMode":{"type":"boolean"}}},"ipGroupIds":{"shape":"S8"},"WorkspaceAccessProperties":{"shape":"S4t"},"Tenancy":{},"SelfservicePermissions":{"shape":"S4w"}}}},"NextToken":{}}}},"DescribeWorkspaceImagePermissions":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ImageId":{},"ImagePermissions":{"type":"list","member":{"type":"structure","members":{"SharedAccountId":{}}}},"NextToken":{}}}},"DescribeWorkspaceImages":{"input":{"type":"structure","members":{"ImageIds":{"type":"list","member":{}},"ImageType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"type":"structure","members":{"ImageId":{},"Name":{},"Description":{},"OperatingSystem":{"type":"structure","members":{"Type":{}}},"State":{},"RequiredTenancy":{},"ErrorCode":{},"ErrorMessage":{},"Created":{"type":"timestamp"},"OwnerAccountId":{},"Updates":{"type":"structure","members":{"UpdateAvailable":{"type":"boolean"},"Description":{}}}}}},"NextToken":{}}}},"DescribeWorkspaceSnapshots":{"input":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}},"output":{"type":"structure","members":{"RebuildSnapshots":{"shape":"S5g"},"RestoreSnapshots":{"shape":"S5g"}}}},"DescribeWorkspaces":{"input":{"type":"structure","members":{"WorkspaceIds":{"shape":"S5j"},"DirectoryId":{},"UserName":{},"BundleId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Workspaces":{"shape":"S1z"},"NextToken":{}}}},"DescribeWorkspacesConnectionStatus":{"input":{"type":"structure","members":{"WorkspaceIds":{"shape":"S5j"},"NextToken":{}}},"output":{"type":"structure","members":{"WorkspacesConnectionStatus":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{},"ConnectionState":{},"ConnectionStateCheckTimestamp":{"type":"timestamp"},"LastKnownUserConnectionTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"DisassociateConnectionAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{}}},"DisassociateIpGroups":{"input":{"type":"structure","required":["DirectoryId","GroupIds"],"members":{"DirectoryId":{},"GroupIds":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"ImportClientBranding":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"DeviceTypeWindows":{"shape":"S5v"},"DeviceTypeOsx":{"shape":"S5v"},"DeviceTypeAndroid":{"shape":"S5v"},"DeviceTypeIos":{"type":"structure","members":{"Logo":{"type":"blob"},"Logo2x":{"type":"blob"},"Logo3x":{"type":"blob"},"SupportEmail":{},"SupportLink":{},"ForgotPasswordLink":{},"LoginMessage":{"shape":"S39"}}},"DeviceTypeLinux":{"shape":"S5v"},"DeviceTypeWeb":{"shape":"S5v"}}},"output":{"type":"structure","members":{"DeviceTypeWindows":{"shape":"S36"},"DeviceTypeOsx":{"shape":"S36"},"DeviceTypeAndroid":{"shape":"S36"},"DeviceTypeIos":{"shape":"S3c"},"DeviceTypeLinux":{"shape":"S36"},"DeviceTypeWeb":{"shape":"S36"}}}},"ImportWorkspaceImage":{"input":{"type":"structure","required":["Ec2ImageId","IngestionProcess","ImageName","ImageDescription"],"members":{"Ec2ImageId":{},"IngestionProcess":{},"ImageName":{},"ImageDescription":{},"Tags":{"shape":"Sm"},"Applications":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ImageId":{}}}},"ListAvailableManagementCidrRanges":{"input":{"type":"structure","required":["ManagementCidrRangeConstraint"],"members":{"ManagementCidrRangeConstraint":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ManagementCidrRanges":{"type":"list","member":{}},"NextToken":{}}}},"MigrateWorkspace":{"input":{"type":"structure","required":["SourceWorkspaceId","BundleId"],"members":{"SourceWorkspaceId":{},"BundleId":{}}},"output":{"type":"structure","members":{"SourceWorkspaceId":{},"TargetWorkspaceId":{}}}},"ModifyAccount":{"input":{"type":"structure","members":{"DedicatedTenancySupport":{},"DedicatedTenancyManagementCidrRange":{}}},"output":{"type":"structure","members":{}}},"ModifyClientProperties":{"input":{"type":"structure","required":["ResourceId","ClientProperties"],"members":{"ResourceId":{},"ClientProperties":{"shape":"S3i"}}},"output":{"type":"structure","members":{}}},"ModifySelfservicePermissions":{"input":{"type":"structure","required":["ResourceId","SelfservicePermissions"],"members":{"ResourceId":{},"SelfservicePermissions":{"shape":"S4w"}}},"output":{"type":"structure","members":{}}},"ModifyWorkspaceAccessProperties":{"input":{"type":"structure","required":["ResourceId","WorkspaceAccessProperties"],"members":{"ResourceId":{},"WorkspaceAccessProperties":{"shape":"S4t"}}},"output":{"type":"structure","members":{}}},"ModifyWorkspaceCreationProperties":{"input":{"type":"structure","required":["ResourceId","WorkspaceCreationProperties"],"members":{"ResourceId":{},"WorkspaceCreationProperties":{"type":"structure","members":{"EnableWorkDocs":{"type":"boolean"},"EnableInternetAccess":{"type":"boolean"},"DefaultOu":{},"CustomSecurityGroupId":{},"UserEnabledAsLocalAdministrator":{"type":"boolean"},"EnableMaintenanceMode":{"type":"boolean"}}}}},"output":{"type":"structure","members":{}}},"ModifyWorkspaceProperties":{"input":{"type":"structure","required":["WorkspaceId","WorkspaceProperties"],"members":{"WorkspaceId":{},"WorkspaceProperties":{"shape":"S1q"}}},"output":{"type":"structure","members":{}}},"ModifyWorkspaceState":{"input":{"type":"structure","required":["WorkspaceId","WorkspaceState"],"members":{"WorkspaceId":{},"WorkspaceState":{}}},"output":{"type":"structure","members":{}}},"RebootWorkspaces":{"input":{"type":"structure","required":["RebootWorkspaceRequests"],"members":{"RebootWorkspaceRequests":{"type":"list","member":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S71"}}}}},"RebuildWorkspaces":{"input":{"type":"structure","required":["RebuildWorkspaceRequests"],"members":{"RebuildWorkspaceRequests":{"type":"list","member":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S71"}}}}},"RegisterWorkspaceDirectory":{"input":{"type":"structure","required":["DirectoryId","EnableWorkDocs"],"members":{"DirectoryId":{},"SubnetIds":{"shape":"S4l"},"EnableWorkDocs":{"type":"boolean"},"EnableSelfService":{"type":"boolean"},"Tenancy":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"RestoreWorkspace":{"input":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}},"output":{"type":"structure","members":{}}},"RevokeIpRules":{"input":{"type":"structure","required":["GroupId","UserRules"],"members":{"GroupId":{},"UserRules":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartWorkspaces":{"input":{"type":"structure","required":["StartWorkspaceRequests"],"members":{"StartWorkspaceRequests":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S71"}}}}},"StopWorkspaces":{"input":{"type":"structure","required":["StopWorkspaceRequests"],"members":{"StopWorkspaceRequests":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S71"}}}}},"TerminateWorkspaces":{"input":{"type":"structure","required":["TerminateWorkspaceRequests"],"members":{"TerminateWorkspaceRequests":{"type":"list","member":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S71"}}}}},"UpdateConnectClientAddIn":{"input":{"type":"structure","required":["AddInId","ResourceId"],"members":{"AddInId":{},"ResourceId":{},"Name":{},"URL":{}}},"output":{"type":"structure","members":{}}},"UpdateConnectionAliasPermission":{"input":{"type":"structure","required":["AliasId","ConnectionAliasPermission"],"members":{"AliasId":{},"ConnectionAliasPermission":{"shape":"S3s"}}},"output":{"type":"structure","members":{}}},"UpdateRulesOfIpGroup":{"input":{"type":"structure","required":["GroupId","UserRules"],"members":{"GroupId":{},"UserRules":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"UpdateWorkspaceBundle":{"input":{"type":"structure","members":{"BundleId":{},"ImageId":{}}},"output":{"type":"structure","members":{}}},"UpdateWorkspaceImagePermission":{"input":{"type":"structure","required":["ImageId","AllowCopyImage","SharedAccountId"],"members":{"ImageId":{},"AllowCopyImage":{"type":"boolean"},"SharedAccountId":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"list","member":{}},"Sc":{"type":"list","member":{"type":"structure","members":{"ipRule":{},"ruleDesc":{}}}},"Sm":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1a":{"type":"structure","members":{"Name":{}}},"S1c":{"type":"structure","members":{"Capacity":{}}},"S1d":{"type":"structure","members":{"Capacity":{}}},"S1f":{"type":"structure","members":{"BundleId":{},"Name":{},"Owner":{},"Description":{},"ImageId":{},"RootStorage":{"shape":"S1d"},"UserStorage":{"shape":"S1c"},"ComputeType":{"shape":"S1a"},"LastUpdatedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}},"S1m":{"type":"structure","required":["DirectoryId","UserName","BundleId"],"members":{"DirectoryId":{},"UserName":{},"BundleId":{},"VolumeEncryptionKey":{},"UserVolumeEncryptionEnabled":{"type":"boolean"},"RootVolumeEncryptionEnabled":{"type":"boolean"},"WorkspaceProperties":{"shape":"S1q"},"Tags":{"shape":"Sm"}}},"S1q":{"type":"structure","members":{"RunningMode":{},"RunningModeAutoStopTimeoutInMinutes":{"type":"integer"},"RootVolumeSizeGib":{"type":"integer"},"UserVolumeSizeGib":{"type":"integer"},"ComputeTypeName":{}}},"S1z":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{},"DirectoryId":{},"UserName":{},"IpAddress":{},"State":{},"BundleId":{},"SubnetId":{},"ErrorMessage":{},"ErrorCode":{},"ComputerName":{},"VolumeEncryptionKey":{},"UserVolumeEncryptionEnabled":{"type":"boolean"},"RootVolumeEncryptionEnabled":{"type":"boolean"},"WorkspaceProperties":{"shape":"S1q"},"ModificationStates":{"type":"list","member":{"type":"structure","members":{"Resource":{},"State":{}}}}}}},"S36":{"type":"structure","members":{"LogoUrl":{},"SupportEmail":{},"SupportLink":{},"ForgotPasswordLink":{},"LoginMessage":{"shape":"S39"}}},"S39":{"type":"map","key":{},"value":{}},"S3c":{"type":"structure","members":{"LogoUrl":{},"Logo2xUrl":{},"Logo3xUrl":{},"SupportEmail":{},"SupportLink":{},"ForgotPasswordLink":{},"LoginMessage":{"shape":"S39"}}},"S3i":{"type":"structure","members":{"ReconnectEnabled":{}}},"S3s":{"type":"structure","required":["SharedAccountId","AllowAssociation"],"members":{"SharedAccountId":{},"AllowAssociation":{"type":"boolean"}}},"S4l":{"type":"list","member":{}},"S4t":{"type":"structure","members":{"DeviceTypeWindows":{},"DeviceTypeOsx":{},"DeviceTypeWeb":{},"DeviceTypeIos":{},"DeviceTypeAndroid":{},"DeviceTypeChromeOs":{},"DeviceTypeZeroClient":{},"DeviceTypeLinux":{}}},"S4w":{"type":"structure","members":{"RestartWorkspace":{},"IncreaseVolumeSize":{},"ChangeComputeType":{},"SwitchRunningMode":{},"RebuildWorkspace":{}}},"S5g":{"type":"list","member":{"type":"structure","members":{"SnapshotTime":{"type":"timestamp"}}}},"S5j":{"type":"list","member":{}},"S5v":{"type":"structure","members":{"Logo":{"type":"blob"},"SupportEmail":{},"SupportLink":{},"ForgotPasswordLink":{},"LoginMessage":{"shape":"S39"}}},"S71":{"type":"structure","members":{"WorkspaceId":{},"ErrorCode":{},"ErrorMessage":{}}}}}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeWorkspaceBundles":{"input_token":"NextToken","output_token":"NextToken","result_key":"Bundles"},"DescribeWorkspaceDirectories":{"input_token":"NextToken","output_token":"NextToken","result_key":"Directories"},"DescribeWorkspaces":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Workspaces"}}}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codestar'] = {};
	AWS.CodeStar = Service.defineService('codestar', ['2017-04-19']);
	Object.defineProperty(apiLoader.services['codestar'], '2017-04-19', {
	  get: function get() {
	    var model = __webpack_require__(492);
	    model.paginators = __webpack_require__(493).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeStar;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"codestar","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeStar","serviceFullName":"AWS CodeStar","serviceId":"CodeStar","signatureVersion":"v4","targetPrefix":"CodeStar_20170419","uid":"codestar-2017-04-19"},"operations":{"AssociateTeamMember":{"input":{"type":"structure","required":["projectId","userArn","projectRole"],"members":{"projectId":{},"clientRequestToken":{},"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}},"output":{"type":"structure","members":{"clientRequestToken":{}}}},"CreateProject":{"input":{"type":"structure","required":["name","id"],"members":{"name":{"shape":"S9"},"id":{},"description":{"shape":"Sa"},"clientRequestToken":{},"sourceCode":{"type":"list","member":{"type":"structure","required":["source","destination"],"members":{"source":{"type":"structure","required":["s3"],"members":{"s3":{"shape":"Se"}}},"destination":{"type":"structure","members":{"codeCommit":{"type":"structure","required":["name"],"members":{"name":{}}},"gitHub":{"type":"structure","required":["name","type","owner","privateRepository","issuesEnabled","token"],"members":{"name":{},"description":{},"type":{},"owner":{},"privateRepository":{"type":"boolean"},"issuesEnabled":{"type":"boolean"},"token":{"type":"string","sensitive":true}}}}}}}},"toolchain":{"type":"structure","required":["source"],"members":{"source":{"type":"structure","required":["s3"],"members":{"s3":{"shape":"Se"}}},"roleArn":{},"stackParameters":{"type":"map","key":{},"value":{"type":"string","sensitive":true}}}},"tags":{"shape":"Sx"}}},"output":{"type":"structure","required":["id","arn"],"members":{"id":{},"arn":{},"clientRequestToken":{},"projectTemplateId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["userArn","displayName","emailAddress"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{}}},"output":{"type":"structure","required":["userArn"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{},"createdTimestamp":{"type":"timestamp"},"lastModifiedTimestamp":{"type":"timestamp"}}}},"DeleteProject":{"input":{"type":"structure","required":["id"],"members":{"id":{},"clientRequestToken":{},"deleteStack":{"type":"boolean"}}},"output":{"type":"structure","members":{"stackId":{},"projectArn":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["userArn"],"members":{"userArn":{}}},"output":{"type":"structure","required":["userArn"],"members":{"userArn":{}}}},"DescribeProject":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"name":{"shape":"S9"},"id":{},"arn":{},"description":{"shape":"Sa"},"clientRequestToken":{},"createdTimeStamp":{"type":"timestamp"},"stackId":{},"projectTemplateId":{},"status":{"type":"structure","required":["state"],"members":{"state":{},"reason":{}}}}}},"DescribeUserProfile":{"input":{"type":"structure","required":["userArn"],"members":{"userArn":{}}},"output":{"type":"structure","required":["userArn","createdTimestamp","lastModifiedTimestamp"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{},"createdTimestamp":{"type":"timestamp"},"lastModifiedTimestamp":{"type":"timestamp"}}}},"DisassociateTeamMember":{"input":{"type":"structure","required":["projectId","userArn"],"members":{"projectId":{},"userArn":{}}},"output":{"type":"structure","members":{}}},"ListProjects":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["projects"],"members":{"projects":{"type":"list","member":{"type":"structure","members":{"projectId":{},"projectArn":{}}}},"nextToken":{}}}},"ListResources":{"input":{"type":"structure","required":["projectId"],"members":{"projectId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resources":{"type":"list","member":{"type":"structure","required":["id"],"members":{"id":{}}}},"nextToken":{}}}},"ListTagsForProject":{"input":{"type":"structure","required":["id"],"members":{"id":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"},"nextToken":{}}}},"ListTeamMembers":{"input":{"type":"structure","required":["projectId"],"members":{"projectId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["teamMembers"],"members":{"teamMembers":{"type":"list","member":{"type":"structure","required":["userArn","projectRole"],"members":{"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}}},"nextToken":{}}}},"ListUserProfiles":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["userProfiles"],"members":{"userProfiles":{"type":"list","member":{"type":"structure","members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{}}}},"nextToken":{}}}},"TagProject":{"input":{"type":"structure","required":["id","tags"],"members":{"id":{},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"}}}},"UntagProject":{"input":{"type":"structure","required":["id","tags"],"members":{"id":{},"tags":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateProject":{"input":{"type":"structure","required":["id"],"members":{"id":{},"name":{"shape":"S9"},"description":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"UpdateTeamMember":{"input":{"type":"structure","required":["projectId","userArn"],"members":{"projectId":{},"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}},"output":{"type":"structure","members":{"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["userArn"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{}}},"output":{"type":"structure","required":["userArn"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{},"createdTimestamp":{"type":"timestamp"},"lastModifiedTimestamp":{"type":"timestamp"}}}}},"shapes":{"S9":{"type":"string","sensitive":true},"Sa":{"type":"string","sensitive":true},"Se":{"type":"structure","members":{"bucketName":{},"bucketKey":{}}},"Sx":{"type":"map","key":{},"value":{}},"S14":{"type":"string","sensitive":true},"S15":{"type":"string","sensitive":true}}}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lexmodelbuildingservice'] = {};
	AWS.LexModelBuildingService = Service.defineService('lexmodelbuildingservice', ['2017-04-19']);
	Object.defineProperty(apiLoader.services['lexmodelbuildingservice'], '2017-04-19', {
	  get: function get() {
	    var model = __webpack_require__(495);
	    model.paginators = __webpack_require__(496).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LexModelBuildingService;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"models.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Model Building Service","serviceId":"Lex Model Building Service","signatureVersion":"v4","signingName":"lex","uid":"lex-models-2017-04-19"},"operations":{"CreateBotVersion":{"http":{"requestUri":"/bots/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"enableModelImprovements":{"type":"boolean"},"detectSentiment":{"type":"boolean"}}}},"CreateIntentVersion":{"http":{"requestUri":"/intents/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}}},"CreateSlotTypeVersion":{"http":{"requestUri":"/slottypes/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1q"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}}},"DeleteBotChannelAssociation":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/intents/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteIntentVersion":{"http":{"method":"DELETE","requestUri":"/intents/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteSlotTypeVersion":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}/version/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/utterances/{userId}","responseCode":204},"input":{"type":"structure","required":["botName","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"userId":{"location":"uri","locationName":"userId"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/{versionoralias}","responseCode":200},"input":{"type":"structure","required":["name","versionOrAlias"],"members":{"name":{"location":"uri","locationName":"name"},"versionOrAlias":{"location":"uri","locationName":"versionoralias"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"enableModelImprovements":{"type":"boolean"},"nluIntentConfidenceThreshold":{"type":"double"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"}}}},"GetBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S2h"}}}},"GetBotAliases":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/","responseCode":200},"input":{"type":"structure","required":["botName"],"members":{"botName":{"location":"uri","locationName":"botName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"BotAliases":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S2h"}}}},"nextToken":{}}}},"GetBotChannelAssociation":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S2z"},"status":{},"failureReason":{}}}},"GetBotChannelAssociations":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/","responseCode":200},"input":{"type":"structure","required":["botName","botAlias"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"botChannelAssociations":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S2z"},"status":{},"failureReason":{}}}},"nextToken":{}}}},"GetBotVersions":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"bots":{"shape":"S38"},"nextToken":{}}}},"GetBots":{"http":{"method":"GET","requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"bots":{"shape":"S38"},"nextToken":{}}}},"GetBuiltinIntent":{"http":{"method":"GET","requestUri":"/builtins/intents/{signature}","responseCode":200},"input":{"type":"structure","required":["signature"],"members":{"signature":{"location":"uri","locationName":"signature"}}},"output":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S3e"},"slots":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}}},"GetBuiltinIntents":{"http":{"method":"GET","requestUri":"/builtins/intents/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S3e"}}}},"nextToken":{}}}},"GetBuiltinSlotTypes":{"http":{"method":"GET","requestUri":"/builtins/slottypes/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S3e"}}}},"nextToken":{}}}},"GetExport":{"http":{"method":"GET","requestUri":"/exports/","responseCode":200},"input":{"type":"structure","required":["name","version","resourceType","exportType"],"members":{"name":{"location":"querystring","locationName":"name"},"version":{"location":"querystring","locationName":"version"},"resourceType":{"location":"querystring","locationName":"resourceType"},"exportType":{"location":"querystring","locationName":"exportType"}}},"output":{"type":"structure","members":{"name":{},"version":{},"resourceType":{},"exportType":{},"exportStatus":{},"failureReason":{},"url":{}}}},"GetImport":{"http":{"method":"GET","requestUri":"/imports/{importId}","responseCode":200},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"GetIntent":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}}},"GetIntentVersions":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"shape":"S45"},"nextToken":{}}}},"GetIntents":{"http":{"method":"GET","requestUri":"/intents/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"intents":{"shape":"S45"},"nextToken":{}}}},"GetMigration":{"http":{"method":"GET","requestUri":"/migrations/{migrationId}","responseCode":200},"input":{"type":"structure","required":["migrationId"],"members":{"migrationId":{"location":"uri","locationName":"migrationId"}}},"output":{"type":"structure","members":{"migrationId":{},"v1BotName":{},"v1BotVersion":{},"v1BotLocale":{},"v2BotId":{},"v2BotRole":{},"migrationStatus":{},"migrationStrategy":{},"migrationTimestamp":{"type":"timestamp"},"alerts":{"type":"list","member":{"type":"structure","members":{"type":{},"message":{},"details":{"type":"list","member":{}},"referenceURLs":{"type":"list","member":{}}}}}}}},"GetMigrations":{"http":{"method":"GET","requestUri":"/migrations","responseCode":200},"input":{"type":"structure","members":{"sortByAttribute":{"location":"querystring","locationName":"sortByAttribute"},"sortByOrder":{"location":"querystring","locationName":"sortByOrder"},"v1BotNameContains":{"location":"querystring","locationName":"v1BotNameContains"},"migrationStatusEquals":{"location":"querystring","locationName":"migrationStatusEquals"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"migrationSummaries":{"type":"list","member":{"type":"structure","members":{"migrationId":{},"v1BotName":{},"v1BotVersion":{},"v1BotLocale":{},"v2BotId":{},"v2BotRole":{},"migrationStatus":{},"migrationStrategy":{},"migrationTimestamp":{"type":"timestamp"}}}},"nextToken":{}}}},"GetSlotType":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1q"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}}},"GetSlotTypeVersions":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S4x"},"nextToken":{}}}},"GetSlotTypes":{"http":{"method":"GET","requestUri":"/slottypes/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S4x"},"nextToken":{}}}},"GetUtterancesView":{"http":{"method":"GET","requestUri":"/bots/{botname}/utterances?view=aggregation","responseCode":200},"input":{"type":"structure","required":["botName","botVersions","statusType"],"members":{"botName":{"location":"uri","locationName":"botname"},"botVersions":{"location":"querystring","locationName":"bot_versions","type":"list","member":{}},"statusType":{"location":"querystring","locationName":"status_type"}}},"output":{"type":"structure","members":{"botName":{},"utterances":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"utterances":{"type":"list","member":{"type":"structure","members":{"utteranceString":{},"count":{"type":"integer"},"distinctUsers":{"type":"integer"},"firstUtteredDate":{"type":"timestamp"},"lastUtteredDate":{"type":"timestamp"}}}}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5e"}}}},"PutBot":{"http":{"method":"PUT","requestUri":"/bots/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name","locale","childDirected"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"intents":{"shape":"S6"},"enableModelImprovements":{"type":"boolean"},"nluIntentConfidenceThreshold":{"type":"double"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"processBehavior":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"},"createVersion":{"type":"boolean"},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"enableModelImprovements":{"type":"boolean"},"nluIntentConfidenceThreshold":{"type":"double"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"},"detectSentiment":{"type":"boolean"},"tags":{"shape":"S5e"}}}},"PutBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botVersion","botName"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"botVersion":{},"botName":{"location":"uri","locationName":"botName"},"checksum":{},"conversationLogs":{"type":"structure","required":["logSettings","iamRoleArn"],"members":{"logSettings":{"type":"list","member":{"type":"structure","required":["logType","destination","resourceArn"],"members":{"logType":{},"destination":{},"kmsKeyArn":{},"resourceArn":{}}}},"iamRoleArn":{}}},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S2h"},"tags":{"shape":"S5e"}}}},"PutIntent":{"http":{"method":"PUT","requestUri":"/intents/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"checksum":{},"createVersion":{"type":"boolean"},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"createVersion":{"type":"boolean"},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}}},"PutSlotType":{"http":{"method":"PUT","requestUri":"/slottypes/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"enumerationValues":{"shape":"S1q"},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1q"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}}},"StartImport":{"http":{"requestUri":"/imports/","responseCode":201},"input":{"type":"structure","required":["payload","resourceType","mergeStrategy"],"members":{"payload":{"type":"blob"},"resourceType":{},"mergeStrategy":{},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"tags":{"shape":"S5e"},"createdDate":{"type":"timestamp"}}}},"StartMigration":{"http":{"requestUri":"/migrations","responseCode":202},"input":{"type":"structure","required":["v1BotName","v1BotVersion","v2BotName","v2BotRole","migrationStrategy"],"members":{"v1BotName":{},"v1BotVersion":{},"v2BotName":{},"v2BotRole":{},"migrationStrategy":{}}},"output":{"type":"structure","members":{"v1BotName":{},"v1BotVersion":{},"v1BotLocale":{},"v2BotId":{},"v2BotRole":{},"migrationId":{},"migrationStrategy":{},"migrationTimestamp":{"type":"timestamp"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["intentName","intentVersion"],"members":{"intentName":{},"intentVersion":{}}}},"Sa":{"type":"structure","required":["messages","maxAttempts"],"members":{"messages":{"shape":"Sb"},"maxAttempts":{"type":"integer"},"responseCard":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["contentType","content"],"members":{"contentType":{},"content":{},"groupNumber":{"type":"integer"}}}},"Si":{"type":"structure","required":["messages"],"members":{"messages":{"shape":"Sb"},"responseCard":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["name","slotConstraint"],"members":{"name":{},"description":{},"slotConstraint":{},"slotType":{},"slotTypeVersion":{},"valueElicitationPrompt":{"shape":"Sa"},"priority":{"type":"integer"},"sampleUtterances":{"type":"list","member":{}},"responseCard":{},"obfuscationSetting":{},"defaultValueSpec":{"type":"structure","required":["defaultValueList"],"members":{"defaultValueList":{"type":"list","member":{"type":"structure","required":["defaultValue"],"members":{"defaultValue":{}}}}}}}}},"S13":{"type":"list","member":{}},"S14":{"type":"structure","required":["prompt","rejectionStatement"],"members":{"prompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"}}},"S15":{"type":"structure","required":["uri","messageVersion"],"members":{"uri":{},"messageVersion":{}}},"S18":{"type":"structure","required":["type"],"members":{"type":{},"codeHook":{"shape":"S15"}}},"S1b":{"type":"structure","required":["kendraIndex","role"],"members":{"kendraIndex":{},"queryFilterString":{},"role":{}}},"S1f":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"S1i":{"type":"list","member":{"type":"structure","required":["name","timeToLiveInSeconds","turnsToLive"],"members":{"name":{},"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}}},"S1q":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{},"synonyms":{"type":"list","member":{}}}}},"S1v":{"type":"list","member":{"type":"structure","members":{"regexConfiguration":{"type":"structure","required":["pattern"],"members":{"pattern":{}}}}}},"S2h":{"type":"structure","members":{"logSettings":{"type":"list","member":{"type":"structure","members":{"logType":{},"destination":{},"kmsKeyArn":{},"resourceArn":{},"resourcePrefix":{}}}},"iamRoleArn":{}}},"S2z":{"type":"map","key":{},"value":{},"sensitive":true},"S38":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"status":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S3e":{"type":"list","member":{}},"S45":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S4x":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S5e":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotChannelAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetMigrations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypeVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['marketplaceentitlementservice'] = {};
	AWS.MarketplaceEntitlementService = Service.defineService('marketplaceentitlementservice', ['2017-01-11']);
	Object.defineProperty(apiLoader.services['marketplaceentitlementservice'], '2017-01-11', {
	  get: function get() {
	    var model = __webpack_require__(498);
	    model.paginators = __webpack_require__(499).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MarketplaceEntitlementService;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-11","endpointPrefix":"entitlement.marketplace","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Entitlement Service","serviceId":"Marketplace Entitlement Service","signatureVersion":"v4","signingName":"aws-marketplace","targetPrefix":"AWSMPEntitlementService","uid":"entitlement.marketplace-2017-01-11"},"operations":{"GetEntitlements":{"input":{"type":"structure","required":["ProductCode"],"members":{"ProductCode":{},"Filter":{"type":"map","key":{},"value":{"type":"list","member":{}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entitlements":{"type":"list","member":{"type":"structure","members":{"ProductCode":{},"Dimension":{},"CustomerIdentifier":{},"Value":{"type":"structure","members":{"IntegerValue":{"type":"integer"},"DoubleValue":{"type":"double"},"BooleanValue":{"type":"boolean"},"StringValue":{}}},"ExpirationDate":{"type":"timestamp"}}}},"NextToken":{}}}}},"shapes":{}}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['athena'] = {};
	AWS.Athena = Service.defineService('athena', ['2017-05-18']);
	Object.defineProperty(apiLoader.services['athena'], '2017-05-18', {
	  get: function get() {
	    var model = __webpack_require__(501);
	    model.paginators = __webpack_require__(502).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Athena;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-05-18","endpointPrefix":"athena","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Athena","serviceId":"Athena","signatureVersion":"v4","targetPrefix":"AmazonAthena","uid":"athena-2017-05-18"},"operations":{"BatchGetNamedQuery":{"input":{"type":"structure","required":["NamedQueryIds"],"members":{"NamedQueryIds":{"shape":"S2"}}},"output":{"type":"structure","members":{"NamedQueries":{"type":"list","member":{"shape":"S6"}},"UnprocessedNamedQueryIds":{"type":"list","member":{"type":"structure","members":{"NamedQueryId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchGetQueryExecution":{"input":{"type":"structure","required":["QueryExecutionIds"],"members":{"QueryExecutionIds":{"shape":"Sh"}}},"output":{"type":"structure","members":{"QueryExecutions":{"type":"list","member":{"shape":"Sl"}},"UnprocessedQueryExecutionIds":{"type":"list","member":{"type":"structure","members":{"QueryExecutionId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"CreateDataCatalog":{"input":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"Description":{},"Parameters":{"shape":"S19"},"Tags":{"shape":"S1c"}}},"output":{"type":"structure","members":{}}},"CreateNamedQuery":{"input":{"type":"structure","required":["Name","Database","QueryString"],"members":{"Name":{},"Description":{},"Database":{},"QueryString":{},"ClientRequestToken":{"idempotencyToken":true},"WorkGroup":{}}},"output":{"type":"structure","members":{"NamedQueryId":{}}},"idempotent":true},"CreatePreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup","QueryStatement"],"members":{"StatementName":{},"WorkGroup":{},"QueryStatement":{},"Description":{}}},"output":{"type":"structure","members":{}}},"CreateWorkGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Configuration":{"shape":"S1o"},"Description":{},"Tags":{"shape":"S1c"}}},"output":{"type":"structure","members":{}}},"DeleteDataCatalog":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteNamedQuery":{"input":{"type":"structure","required":["NamedQueryId"],"members":{"NamedQueryId":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeletePreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup"],"members":{"StatementName":{},"WorkGroup":{}}},"output":{"type":"structure","members":{}}},"DeleteWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"RecursiveDeleteOption":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetDataCatalog":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"DataCatalog":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Description":{},"Type":{},"Parameters":{"shape":"S19"}}}}}},"GetDatabase":{"input":{"type":"structure","required":["CatalogName","DatabaseName"],"members":{"CatalogName":{},"DatabaseName":{}}},"output":{"type":"structure","members":{"Database":{"shape":"S26"}}}},"GetNamedQuery":{"input":{"type":"structure","required":["NamedQueryId"],"members":{"NamedQueryId":{}}},"output":{"type":"structure","members":{"NamedQuery":{"shape":"S6"}}}},"GetPreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup"],"members":{"StatementName":{},"WorkGroup":{}}},"output":{"type":"structure","members":{"PreparedStatement":{"type":"structure","members":{"StatementName":{},"QueryStatement":{},"WorkGroupName":{},"Description":{},"LastModifiedTime":{"type":"timestamp"}}}}}},"GetQueryExecution":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{}}},"output":{"type":"structure","members":{"QueryExecution":{"shape":"Sl"}}}},"GetQueryResults":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UpdateCount":{"type":"long"},"ResultSet":{"type":"structure","members":{"Rows":{"type":"list","member":{"type":"structure","members":{"Data":{"type":"list","member":{"type":"structure","members":{"VarCharValue":{}}}}}}},"ResultSetMetadata":{"type":"structure","members":{"ColumnInfo":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"CatalogName":{},"SchemaName":{},"TableName":{},"Name":{},"Label":{},"Type":{},"Precision":{"type":"integer"},"Scale":{"type":"integer"},"Nullable":{},"CaseSensitive":{"type":"boolean"}}}}}}}},"NextToken":{}}}},"GetTableMetadata":{"input":{"type":"structure","required":["CatalogName","DatabaseName","TableName"],"members":{"CatalogName":{},"DatabaseName":{},"TableName":{}}},"output":{"type":"structure","members":{"TableMetadata":{"shape":"S2v"}}}},"GetWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{}}},"output":{"type":"structure","members":{"WorkGroup":{"type":"structure","required":["Name"],"members":{"Name":{},"State":{},"Configuration":{"shape":"S1o"},"Description":{},"CreationTime":{"type":"timestamp"}}}}}},"ListDataCatalogs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DataCatalogsSummary":{"type":"list","member":{"type":"structure","members":{"CatalogName":{},"Type":{}}}},"NextToken":{}}}},"ListDatabases":{"input":{"type":"structure","required":["CatalogName"],"members":{"CatalogName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatabaseList":{"type":"list","member":{"shape":"S26"}},"NextToken":{}}}},"ListEngineVersions":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EngineVersions":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"ListNamedQueries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"NamedQueryIds":{"shape":"S2"},"NextToken":{}}}},"ListPreparedStatements":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PreparedStatements":{"type":"list","member":{"type":"structure","members":{"StatementName":{},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListQueryExecutions":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"QueryExecutionIds":{"shape":"Sh"},"NextToken":{}}}},"ListTableMetadata":{"input":{"type":"structure","required":["CatalogName","DatabaseName"],"members":{"CatalogName":{},"DatabaseName":{},"Expression":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TableMetadataList":{"type":"list","member":{"shape":"S2v"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1c"},"NextToken":{}}}},"ListWorkGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WorkGroups":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"Description":{},"CreationTime":{"type":"timestamp"},"EngineVersion":{"shape":"S14"}}}},"NextToken":{}}}},"StartQueryExecution":{"input":{"type":"structure","required":["QueryString"],"members":{"QueryString":{},"ClientRequestToken":{"idempotencyToken":true},"QueryExecutionContext":{"shape":"St"},"ResultConfiguration":{"shape":"Sn"},"WorkGroup":{}}},"output":{"type":"structure","members":{"QueryExecutionId":{}}},"idempotent":true},"StopQueryExecution":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1c"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDataCatalog":{"input":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"Description":{},"Parameters":{"shape":"S19"}}},"output":{"type":"structure","members":{}}},"UpdateNamedQuery":{"input":{"type":"structure","required":["NamedQueryId","Name","QueryString"],"members":{"NamedQueryId":{},"Name":{},"Description":{},"QueryString":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdatePreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup","QueryStatement"],"members":{"StatementName":{},"WorkGroup":{},"QueryStatement":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"Description":{},"ConfigurationUpdates":{"type":"structure","members":{"EnforceWorkGroupConfiguration":{"type":"boolean"},"ResultConfigurationUpdates":{"type":"structure","members":{"OutputLocation":{},"RemoveOutputLocation":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sp"},"RemoveEncryptionConfiguration":{"type":"boolean"},"ExpectedBucketOwner":{},"RemoveExpectedBucketOwner":{"type":"boolean"},"AclConfiguration":{"shape":"Sr"},"RemoveAclConfiguration":{"type":"boolean"}}},"PublishCloudWatchMetricsEnabled":{"type":"boolean"},"BytesScannedCutoffPerQuery":{"type":"long"},"RemoveBytesScannedCutoffPerQuery":{"type":"boolean"},"RequesterPaysEnabled":{"type":"boolean"},"EngineVersion":{"shape":"S14"}}},"State":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"structure","required":["Name","Database","QueryString"],"members":{"Name":{},"Description":{},"Database":{},"QueryString":{},"NamedQueryId":{},"WorkGroup":{}}},"Sh":{"type":"list","member":{}},"Sl":{"type":"structure","members":{"QueryExecutionId":{},"Query":{},"StatementType":{},"ResultConfiguration":{"shape":"Sn"},"QueryExecutionContext":{"shape":"St"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{},"SubmissionDateTime":{"type":"timestamp"},"CompletionDateTime":{"type":"timestamp"},"AthenaError":{"type":"structure","members":{"ErrorCategory":{"type":"integer"},"ErrorType":{"type":"integer"},"Retryable":{"type":"boolean"},"ErrorMessage":{}}}}},"Statistics":{"type":"structure","members":{"EngineExecutionTimeInMillis":{"type":"long"},"DataScannedInBytes":{"type":"long"},"DataManifestLocation":{},"TotalExecutionTimeInMillis":{"type":"long"},"QueryQueueTimeInMillis":{"type":"long"},"QueryPlanningTimeInMillis":{"type":"long"},"ServiceProcessingTimeInMillis":{"type":"long"}}},"WorkGroup":{},"EngineVersion":{"shape":"S14"}}},"Sn":{"type":"structure","members":{"OutputLocation":{},"EncryptionConfiguration":{"shape":"Sp"},"ExpectedBucketOwner":{},"AclConfiguration":{"shape":"Sr"}}},"Sp":{"type":"structure","required":["EncryptionOption"],"members":{"EncryptionOption":{},"KmsKey":{}}},"Sr":{"type":"structure","required":["S3AclOption"],"members":{"S3AclOption":{}}},"St":{"type":"structure","members":{"Database":{},"Catalog":{}}},"S14":{"type":"structure","members":{"SelectedEngineVersion":{},"EffectiveEngineVersion":{}}},"S19":{"type":"map","key":{},"value":{}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S1o":{"type":"structure","members":{"ResultConfiguration":{"shape":"Sn"},"EnforceWorkGroupConfiguration":{"type":"boolean"},"PublishCloudWatchMetricsEnabled":{"type":"boolean"},"BytesScannedCutoffPerQuery":{"type":"long"},"RequesterPaysEnabled":{"type":"boolean"},"EngineVersion":{"shape":"S14"}}},"S26":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"Parameters":{"shape":"S19"}}},"S2v":{"type":"structure","required":["Name"],"members":{"Name":{},"CreateTime":{"type":"timestamp"},"LastAccessTime":{"type":"timestamp"},"TableType":{},"Columns":{"shape":"S2y"},"PartitionKeys":{"shape":"S2y"},"Parameters":{"shape":"S19"}}},"S2y":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Type":{},"Comment":{}}}}}}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetQueryResults":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDataCatalogs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DataCatalogsSummary"},"ListDatabases":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatabaseList"},"ListNamedQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPreparedStatements":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListQueryExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTableMetadata":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TableMetadataList"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"ListWorkGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['greengrass'] = {};
	AWS.Greengrass = Service.defineService('greengrass', ['2017-06-07']);
	Object.defineProperty(apiLoader.services['greengrass'], '2017-06-07', {
	  get: function get() {
	    var model = __webpack_require__(504);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Greengrass;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-06-07","endpointPrefix":"greengrass","signingName":"greengrass","serviceFullName":"AWS Greengrass","serviceId":"Greengrass","protocol":"rest-json","jsonVersion":"1.1","uid":"greengrass-2017-06-07","signatureVersion":"v4"},"operations":{"AssociateRoleToGroup":{"http":{"method":"PUT","requestUri":"/greengrass/groups/{GroupId}/role","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"RoleArn":{}},"required":["GroupId","RoleArn"]},"output":{"type":"structure","members":{"AssociatedAt":{}}}},"AssociateServiceRoleToAccount":{"http":{"method":"PUT","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{"RoleArn":{}},"required":["RoleArn"]},"output":{"type":"structure","members":{"AssociatedAt":{}}}},"CreateConnectorDefinition":{"http":{"requestUri":"/greengrass/definition/connectors","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S7"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateConnectorDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"Connectors":{"shape":"S8"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateCoreDefinition":{"http":{"requestUri":"/greengrass/definition/cores","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"Sg"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateCoreDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/cores/{CoreDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"Cores":{"shape":"Sh"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateDeployment":{"http":{"requestUri":"/greengrass/groups/{GroupId}/deployments","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"DeploymentId":{},"DeploymentType":{},"GroupId":{"location":"uri","locationName":"GroupId"},"GroupVersionId":{}},"required":["GroupId","DeploymentType"]},"output":{"type":"structure","members":{"DeploymentArn":{},"DeploymentId":{}}}},"CreateDeviceDefinition":{"http":{"requestUri":"/greengrass/definition/devices","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"Sr"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateDeviceDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"Devices":{"shape":"Ss"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateFunctionDefinition":{"http":{"requestUri":"/greengrass/definition/functions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"Sy"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateFunctionDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"DefaultConfig":{"shape":"Sz"},"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"Functions":{"shape":"S14"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateGroup":{"http":{"requestUri":"/greengrass/groups","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S1h"},"Name":{},"tags":{"shape":"Sb"}},"required":["Name"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateGroupCertificateAuthority":{"http":{"requestUri":"/greengrass/groups/{GroupId}/certificateauthorities","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"GroupCertificateAuthorityArn":{}}}},"CreateGroupVersion":{"http":{"requestUri":"/greengrass/groups/{GroupId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ConnectorDefinitionVersionArn":{},"CoreDefinitionVersionArn":{},"DeviceDefinitionVersionArn":{},"FunctionDefinitionVersionArn":{},"GroupId":{"location":"uri","locationName":"GroupId"},"LoggerDefinitionVersionArn":{},"ResourceDefinitionVersionArn":{},"SubscriptionDefinitionVersionArn":{}},"required":["GroupId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateLoggerDefinition":{"http":{"requestUri":"/greengrass/definition/loggers","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S1o"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateLoggerDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"Loggers":{"shape":"S1p"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateResourceDefinition":{"http":{"requestUri":"/greengrass/definition/resources","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S1y"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateResourceDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"},"Resources":{"shape":"S1z"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateSoftwareUpdateJob":{"http":{"requestUri":"/greengrass/updates","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"S3UrlSignerRole":{},"SoftwareToUpdate":{},"UpdateAgentLogLevel":{},"UpdateTargets":{"type":"list","member":{}},"UpdateTargetsArchitecture":{},"UpdateTargetsOperatingSystem":{}},"required":["S3UrlSignerRole","UpdateTargetsArchitecture","SoftwareToUpdate","UpdateTargets","UpdateTargetsOperatingSystem"]},"output":{"type":"structure","members":{"IotJobArn":{},"IotJobId":{},"PlatformSoftwareVersion":{}}}},"CreateSubscriptionDefinition":{"http":{"requestUri":"/greengrass/definition/subscriptions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S2m"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateSubscriptionDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"},"Subscriptions":{"shape":"S2n"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"DeleteConnectorDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteCoreDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteDeviceDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteFunctionDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteGroup":{"http":{"method":"DELETE","requestUri":"/greengrass/groups/{GroupId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{}}},"DeleteLoggerDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteResourceDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteSubscriptionDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{}}},"DisassociateRoleFromGroup":{"http":{"method":"DELETE","requestUri":"/greengrass/groups/{GroupId}/role","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"DisassociatedAt":{}}}},"DisassociateServiceRoleFromAccount":{"http":{"method":"DELETE","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DisassociatedAt":{}}}},"GetAssociatedRole":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/role","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"AssociatedAt":{},"RoleArn":{}}}},"GetBulkDeploymentStatus":{"http":{"method":"GET","requestUri":"/greengrass/bulk/deployments/{BulkDeploymentId}/status","responseCode":200},"input":{"type":"structure","members":{"BulkDeploymentId":{"location":"uri","locationName":"BulkDeploymentId"}},"required":["BulkDeploymentId"]},"output":{"type":"structure","members":{"BulkDeploymentMetrics":{"type":"structure","members":{"InvalidInputRecords":{"type":"integer"},"RecordsProcessed":{"type":"integer"},"RetryAttempts":{"type":"integer"}}},"BulkDeploymentStatus":{},"CreatedAt":{},"ErrorDetails":{"shape":"S3i"},"ErrorMessage":{},"tags":{"shape":"Sb"}}}},"GetConnectivityInfo":{"http":{"method":"GET","requestUri":"/greengrass/things/{ThingName}/connectivityInfo","responseCode":200},"input":{"type":"structure","members":{"ThingName":{"location":"uri","locationName":"ThingName"}},"required":["ThingName"]},"output":{"type":"structure","members":{"ConnectivityInfo":{"shape":"S3m"},"Message":{"locationName":"message"}}}},"GetConnectorDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetConnectorDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}/versions/{ConnectorDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"ConnectorDefinitionVersionId":{"location":"uri","locationName":"ConnectorDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["ConnectorDefinitionId","ConnectorDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S7"},"Id":{},"NextToken":{},"Version":{}}}},"GetCoreDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetCoreDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}/versions/{CoreDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"CoreDefinitionVersionId":{"location":"uri","locationName":"CoreDefinitionVersionId"}},"required":["CoreDefinitionId","CoreDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"Sg"},"Id":{},"NextToken":{},"Version":{}}}},"GetDeploymentStatus":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/deployments/{DeploymentId}/status","responseCode":200},"input":{"type":"structure","members":{"DeploymentId":{"location":"uri","locationName":"DeploymentId"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId","DeploymentId"]},"output":{"type":"structure","members":{"DeploymentStatus":{},"DeploymentType":{},"ErrorDetails":{"shape":"S3i"},"ErrorMessage":{},"UpdatedAt":{}}}},"GetDeviceDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetDeviceDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}/versions/{DeviceDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"DeviceDefinitionVersionId":{"location":"uri","locationName":"DeviceDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["DeviceDefinitionVersionId","DeviceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"Sr"},"Id":{},"NextToken":{},"Version":{}}}},"GetFunctionDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetFunctionDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}/versions/{FunctionDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"FunctionDefinitionVersionId":{"location":"uri","locationName":"FunctionDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["FunctionDefinitionId","FunctionDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"Sy"},"Id":{},"NextToken":{},"Version":{}}}},"GetGroup":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetGroupCertificateAuthority":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities/{CertificateAuthorityId}","responseCode":200},"input":{"type":"structure","members":{"CertificateAuthorityId":{"location":"uri","locationName":"CertificateAuthorityId"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["CertificateAuthorityId","GroupId"]},"output":{"type":"structure","members":{"GroupCertificateAuthorityArn":{},"GroupCertificateAuthorityId":{},"PemEncodedCertificate":{}}}},"GetGroupCertificateConfiguration":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities/configuration/expiry","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"CertificateAuthorityExpiryInMilliseconds":{},"CertificateExpiryInMilliseconds":{},"GroupId":{}}}},"GetGroupVersion":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/versions/{GroupVersionId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"GroupVersionId":{"location":"uri","locationName":"GroupVersionId"}},"required":["GroupVersionId","GroupId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S1h"},"Id":{},"Version":{}}}},"GetLoggerDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetLoggerDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}/versions/{LoggerDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"LoggerDefinitionVersionId":{"location":"uri","locationName":"LoggerDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["LoggerDefinitionVersionId","LoggerDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S1o"},"Id":{},"Version":{}}}},"GetResourceDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetResourceDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}/versions/{ResourceDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"},"ResourceDefinitionVersionId":{"location":"uri","locationName":"ResourceDefinitionVersionId"}},"required":["ResourceDefinitionVersionId","ResourceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S1y"},"Id":{},"Version":{}}}},"GetServiceRoleForAccount":{"http":{"method":"GET","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AssociatedAt":{},"RoleArn":{}}}},"GetSubscriptionDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetSubscriptionDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}/versions/{SubscriptionDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"},"SubscriptionDefinitionVersionId":{"location":"uri","locationName":"SubscriptionDefinitionVersionId"}},"required":["SubscriptionDefinitionId","SubscriptionDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S2m"},"Id":{},"NextToken":{},"Version":{}}}},"GetThingRuntimeConfiguration":{"http":{"method":"GET","requestUri":"/greengrass/things/{ThingName}/runtimeconfig","responseCode":200},"input":{"type":"structure","members":{"ThingName":{"location":"uri","locationName":"ThingName"}},"required":["ThingName"]},"output":{"type":"structure","members":{"RuntimeConfiguration":{"type":"structure","members":{"TelemetryConfiguration":{"type":"structure","members":{"ConfigurationSyncStatus":{},"Telemetry":{}},"required":["Telemetry"]}}}}}},"ListBulkDeploymentDetailedReports":{"http":{"method":"GET","requestUri":"/greengrass/bulk/deployments/{BulkDeploymentId}/detailed-reports","responseCode":200},"input":{"type":"structure","members":{"BulkDeploymentId":{"location":"uri","locationName":"BulkDeploymentId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["BulkDeploymentId"]},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{},"DeploymentArn":{},"DeploymentId":{},"DeploymentStatus":{},"DeploymentType":{},"ErrorDetails":{"shape":"S3i"},"ErrorMessage":{},"GroupArn":{}}}},"NextToken":{}}}},"ListBulkDeployments":{"http":{"method":"GET","requestUri":"/greengrass/bulk/deployments","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"BulkDeployments":{"type":"list","member":{"type":"structure","members":{"BulkDeploymentArn":{},"BulkDeploymentId":{},"CreatedAt":{}}}},"NextToken":{}}}},"ListConnectorDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListConnectorDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListCoreDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListCoreDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListDeployments":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/deployments","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["GroupId"]},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{},"DeploymentArn":{},"DeploymentId":{},"DeploymentType":{},"GroupArn":{}}}},"NextToken":{}}}},"ListDeviceDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListDeviceDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListFunctionDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListFunctionDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListGroupCertificateAuthorities":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"GroupCertificateAuthorities":{"type":"list","member":{"type":"structure","members":{"GroupCertificateAuthorityArn":{},"GroupCertificateAuthorityId":{}}}}}}},"ListGroupVersions":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/versions","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["GroupId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListGroups":{"http":{"method":"GET","requestUri":"/greengrass/groups","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"NextToken":{}}}},"ListLoggerDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListLoggerDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListResourceDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"},"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListResourceDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListSubscriptionDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S58"}}}},"ListSubscriptionDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S5c"},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"tags":{"shape":"Sb"}}}},"ResetDeployments":{"http":{"requestUri":"/greengrass/groups/{GroupId}/deployments/$reset","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"Force":{"type":"boolean"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"DeploymentArn":{},"DeploymentId":{}}}},"StartBulkDeployment":{"http":{"requestUri":"/greengrass/bulk/deployments","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ExecutionRoleArn":{},"InputFileUri":{},"tags":{"shape":"Sb"}},"required":["ExecutionRoleArn","InputFileUri"]},"output":{"type":"structure","members":{"BulkDeploymentArn":{},"BulkDeploymentId":{}}}},"StopBulkDeployment":{"http":{"method":"PUT","requestUri":"/greengrass/bulk/deployments/{BulkDeploymentId}/$stop","responseCode":200},"input":{"type":"structure","members":{"BulkDeploymentId":{"location":"uri","locationName":"BulkDeploymentId"}},"required":["BulkDeploymentId"]},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"tags":{"shape":"Sb"}},"required":["ResourceArn"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"S29","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateConnectivityInfo":{"http":{"method":"PUT","requestUri":"/greengrass/things/{ThingName}/connectivityInfo","responseCode":200},"input":{"type":"structure","members":{"ConnectivityInfo":{"shape":"S3m"},"ThingName":{"location":"uri","locationName":"ThingName"}},"required":["ThingName"]},"output":{"type":"structure","members":{"Message":{"locationName":"message"},"Version":{}}}},"UpdateConnectorDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"Name":{}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateCoreDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"Name":{}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateDeviceDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"Name":{}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateFunctionDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"Name":{}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateGroup":{"http":{"method":"PUT","requestUri":"/greengrass/groups/{GroupId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"Name":{}},"required":["GroupId"]},"output":{"type":"structure","members":{}}},"UpdateGroupCertificateConfiguration":{"http":{"method":"PUT","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities/configuration/expiry","responseCode":200},"input":{"type":"structure","members":{"CertificateExpiryInMilliseconds":{},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"CertificateAuthorityExpiryInMilliseconds":{},"CertificateExpiryInMilliseconds":{},"GroupId":{}}}},"UpdateLoggerDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"Name":{}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateResourceDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"Name":{},"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateSubscriptionDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"Name":{},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateThingRuntimeConfiguration":{"http":{"method":"PUT","requestUri":"/greengrass/things/{ThingName}/runtimeconfig","responseCode":200},"input":{"type":"structure","members":{"TelemetryConfiguration":{"type":"structure","members":{"Telemetry":{}},"required":["Telemetry"]},"ThingName":{"location":"uri","locationName":"ThingName"}},"required":["ThingName"]},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","members":{"Connectors":{"shape":"S8"}}},"S8":{"type":"list","member":{"type":"structure","members":{"ConnectorArn":{},"Id":{},"Parameters":{"shape":"Sa"}},"required":["ConnectorArn","Id"]}},"Sa":{"type":"map","key":{},"value":{}},"Sb":{"type":"map","key":{},"value":{}},"Sg":{"type":"structure","members":{"Cores":{"shape":"Sh"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"Id":{},"SyncShadow":{"type":"boolean"},"ThingArn":{}},"required":["ThingArn","Id","CertificateArn"]}},"Sr":{"type":"structure","members":{"Devices":{"shape":"Ss"}}},"Ss":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"Id":{},"SyncShadow":{"type":"boolean"},"ThingArn":{}},"required":["ThingArn","Id","CertificateArn"]}},"Sy":{"type":"structure","members":{"DefaultConfig":{"shape":"Sz"},"Functions":{"shape":"S14"}}},"Sz":{"type":"structure","members":{"Execution":{"type":"structure","members":{"IsolationMode":{},"RunAs":{"shape":"S12"}}}}},"S12":{"type":"structure","members":{"Gid":{"type":"integer"},"Uid":{"type":"integer"}}},"S14":{"type":"list","member":{"type":"structure","members":{"FunctionArn":{},"FunctionConfiguration":{"type":"structure","members":{"EncodingType":{},"Environment":{"type":"structure","members":{"AccessSysfs":{"type":"boolean"},"Execution":{"type":"structure","members":{"IsolationMode":{},"RunAs":{"shape":"S12"}}},"ResourceAccessPolicies":{"type":"list","member":{"type":"structure","members":{"Permission":{},"ResourceId":{}},"required":["ResourceId"]}},"Variables":{"shape":"Sa"}}},"ExecArgs":{},"Executable":{},"MemorySize":{"type":"integer"},"Pinned":{"type":"boolean"},"Timeout":{"type":"integer"}}},"Id":{}},"required":["Id"]}},"S1h":{"type":"structure","members":{"ConnectorDefinitionVersionArn":{},"CoreDefinitionVersionArn":{},"DeviceDefinitionVersionArn":{},"FunctionDefinitionVersionArn":{},"LoggerDefinitionVersionArn":{},"ResourceDefinitionVersionArn":{},"SubscriptionDefinitionVersionArn":{}}},"S1o":{"type":"structure","members":{"Loggers":{"shape":"S1p"}}},"S1p":{"type":"list","member":{"type":"structure","members":{"Component":{},"Id":{},"Level":{},"Space":{"type":"integer"},"Type":{}},"required":["Type","Level","Id","Component"]}},"S1y":{"type":"structure","members":{"Resources":{"shape":"S1z"}}},"S1z":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"ResourceDataContainer":{"type":"structure","members":{"LocalDeviceResourceData":{"type":"structure","members":{"GroupOwnerSetting":{"shape":"S23"},"SourcePath":{}}},"LocalVolumeResourceData":{"type":"structure","members":{"DestinationPath":{},"GroupOwnerSetting":{"shape":"S23"},"SourcePath":{}}},"S3MachineLearningModelResourceData":{"type":"structure","members":{"DestinationPath":{},"OwnerSetting":{"shape":"S26"},"S3Uri":{}}},"SageMakerMachineLearningModelResourceData":{"type":"structure","members":{"DestinationPath":{},"OwnerSetting":{"shape":"S26"},"SageMakerJobArn":{}}},"SecretsManagerSecretResourceData":{"type":"structure","members":{"ARN":{},"AdditionalStagingLabelsToDownload":{"shape":"S29"}}}}}},"required":["ResourceDataContainer","Id","Name"]}},"S23":{"type":"structure","members":{"AutoAddGroupOwner":{"type":"boolean"},"GroupOwner":{}}},"S26":{"type":"structure","members":{"GroupOwner":{},"GroupPermission":{}},"required":["GroupOwner","GroupPermission"]},"S29":{"type":"list","member":{}},"S2m":{"type":"structure","members":{"Subscriptions":{"shape":"S2n"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Id":{},"Source":{},"Subject":{},"Target":{}},"required":["Target","Id","Subject","Source"]}},"S3i":{"type":"list","member":{"type":"structure","members":{"DetailedErrorCode":{},"DetailedErrorMessage":{}}}},"S3m":{"type":"list","member":{"type":"structure","members":{"HostAddress":{},"Id":{},"Metadata":{},"PortNumber":{"type":"integer"}}}},"S58":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"S5c":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"Tags":{"shape":"Sb","locationName":"tags"}}}}}}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['dax'] = {};
	AWS.DAX = Service.defineService('dax', ['2017-04-19']);
	Object.defineProperty(apiLoader.services['dax'], '2017-04-19', {
	  get: function get() {
	    var model = __webpack_require__(506);
	    model.paginators = __webpack_require__(507).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DAX;


/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"dax","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon DAX","serviceFullName":"Amazon DynamoDB Accelerator (DAX)","serviceId":"DAX","signatureVersion":"v4","targetPrefix":"AmazonDAXV3","uid":"dax-2017-04-19"},"operations":{"CreateCluster":{"input":{"type":"structure","required":["ClusterName","NodeType","ReplicationFactor","IamRoleArn"],"members":{"ClusterName":{},"NodeType":{},"Description":{},"ReplicationFactor":{"type":"integer"},"AvailabilityZones":{"shape":"S4"},"SubnetGroupName":{},"SecurityGroupIds":{"shape":"S5"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"IamRoleArn":{},"ParameterGroupName":{},"Tags":{"shape":"S6"},"SSESpecification":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"ClusterEndpointEncryptionType":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sc"}}}},"CreateParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Description":{}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"Sr"}}}},"CreateSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName","SubnetIds"],"members":{"SubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"St"}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"Sv"}}}},"DecreaseReplicationFactor":{"input":{"type":"structure","required":["ClusterName","NewReplicationFactor"],"members":{"ClusterName":{},"NewReplicationFactor":{"type":"integer"},"AvailabilityZones":{"shape":"S4"},"NodeIdsToRemove":{"shape":"Sf"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sc"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sc"}}}},"DeleteParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}},"output":{"type":"structure","members":{"DeletionMessage":{}}}},"DeleteSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName"],"members":{"SubnetGroupName":{}}},"output":{"type":"structure","members":{"DeletionMessage":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Clusters":{"type":"list","member":{"shape":"Sc"}}}}},"DescribeDefaultParameters":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Parameters":{"shape":"S1c"}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceName":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Events":{"type":"list","member":{"type":"structure","members":{"SourceName":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"ParameterGroups":{"type":"list","member":{"shape":"Sr"}}}}},"DescribeParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Parameters":{"shape":"S1c"}}}},"DescribeSubnetGroups":{"input":{"type":"structure","members":{"SubnetGroupNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"SubnetGroups":{"type":"list","member":{"shape":"Sv"}}}}},"IncreaseReplicationFactor":{"input":{"type":"structure","required":["ClusterName","NewReplicationFactor"],"members":{"ClusterName":{},"NewReplicationFactor":{"type":"integer"},"AvailabilityZones":{"shape":"S4"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sc"}}}},"ListTags":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"},"NextToken":{}}}},"RebootNode":{"input":{"type":"structure","required":["ClusterName","NodeId"],"members":{"ClusterName":{},"NodeId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sc"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"UpdateCluster":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{},"Description":{},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"NotificationTopicStatus":{},"ParameterGroupName":{},"SecurityGroupIds":{"shape":"S5"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sc"}}}},"UpdateParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterNameValues"],"members":{"ParameterGroupName":{},"ParameterNameValues":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"Sr"}}}},"UpdateSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName"],"members":{"SubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"St"}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"Sv"}}}}},"shapes":{"S4":{"type":"list","member":{}},"S5":{"type":"list","member":{}},"S6":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sc":{"type":"structure","members":{"ClusterName":{},"Description":{},"ClusterArn":{},"TotalNodes":{"type":"integer"},"ActiveNodes":{"type":"integer"},"NodeType":{},"Status":{},"ClusterDiscoveryEndpoint":{"shape":"Se"},"NodeIdsToRemove":{"shape":"Sf"},"Nodes":{"type":"list","member":{"type":"structure","members":{"NodeId":{},"Endpoint":{"shape":"Se"},"NodeCreateTime":{"type":"timestamp"},"AvailabilityZone":{},"NodeStatus":{},"ParameterGroupStatus":{}}}},"PreferredMaintenanceWindow":{},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"SubnetGroup":{},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupIdentifier":{},"Status":{}}}},"IamRoleArn":{},"ParameterGroup":{"type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"NodeIdsToReboot":{"shape":"Sf"}}},"SSEDescription":{"type":"structure","members":{"Status":{}}},"ClusterEndpointEncryptionType":{}}},"Se":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"URL":{}}},"Sf":{"type":"list","member":{}},"Sr":{"type":"structure","members":{"ParameterGroupName":{},"Description":{}}},"St":{"type":"list","member":{}},"Sv":{"type":"structure","members":{"SubnetGroupName":{},"Description":{},"VpcId":{},"Subnets":{"type":"list","member":{"type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{}}}}}},"S1c":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterType":{},"ParameterValue":{},"NodeTypeSpecificValues":{"type":"list","member":{"type":"structure","members":{"NodeType":{},"Value":{}}}},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{},"ChangeType":{}}}}}}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['migrationhub'] = {};
	AWS.MigrationHub = Service.defineService('migrationhub', ['2017-05-31']);
	Object.defineProperty(apiLoader.services['migrationhub'], '2017-05-31', {
	  get: function get() {
	    var model = __webpack_require__(509);
	    model.paginators = __webpack_require__(510).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MigrationHub;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-05-31","endpointPrefix":"mgh","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Migration Hub","serviceId":"Migration Hub","signatureVersion":"v4","targetPrefix":"AWSMigrationHub","uid":"AWSMigrationHub-2017-05-31"},"operations":{"AssociateCreatedArtifact":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","CreatedArtifact"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"CreatedArtifact":{"shape":"S4"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AssociateDiscoveredResource":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","DiscoveredResource"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"DiscoveredResource":{"shape":"Sa"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateProgressUpdateStream":{"input":{"type":"structure","required":["ProgressUpdateStreamName"],"members":{"ProgressUpdateStreamName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProgressUpdateStream":{"input":{"type":"structure","required":["ProgressUpdateStreamName"],"members":{"ProgressUpdateStreamName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeApplicationState":{"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{}}},"output":{"type":"structure","members":{"ApplicationStatus":{},"LastUpdatedTime":{"type":"timestamp"}}}},"DescribeMigrationTask":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{}}},"output":{"type":"structure","members":{"MigrationTask":{"type":"structure","members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"Task":{"shape":"Sq"},"UpdateDateTime":{"type":"timestamp"},"ResourceAttributeList":{"type":"list","member":{"shape":"Sv"}}}}}}},"DisassociateCreatedArtifact":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","CreatedArtifactName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"CreatedArtifactName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DisassociateDiscoveredResource":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","ConfigurationId"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"ConfigurationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"ImportMigrationTask":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"ListApplicationStates":{"input":{"type":"structure","members":{"ApplicationIds":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ApplicationStateList":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"ApplicationStatus":{},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListCreatedArtifacts":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CreatedArtifactList":{"type":"list","member":{"shape":"S4"}}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"DiscoveredResourceList":{"type":"list","member":{"shape":"Sa"}}}}},"ListMigrationTasks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResourceName":{}}},"output":{"type":"structure","members":{"NextToken":{},"MigrationTaskSummaryList":{"type":"list","member":{"type":"structure","members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"Status":{},"ProgressPercent":{"type":"integer"},"StatusDetail":{},"UpdateDateTime":{"type":"timestamp"}}}}}}},"ListProgressUpdateStreams":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProgressUpdateStreamSummaryList":{"type":"list","member":{"type":"structure","members":{"ProgressUpdateStreamName":{}}}},"NextToken":{}}}},"NotifyApplicationState":{"input":{"type":"structure","required":["ApplicationId","Status"],"members":{"ApplicationId":{},"Status":{},"UpdateDateTime":{"type":"timestamp"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"NotifyMigrationTaskState":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","Task","UpdateDateTime","NextUpdateSeconds"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"Task":{"shape":"Sq"},"UpdateDateTime":{"type":"timestamp"},"NextUpdateSeconds":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutResourceAttributes":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","ResourceAttributeList"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"ResourceAttributeList":{"type":"list","member":{"shape":"Sv"}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{}}},"Sa":{"type":"structure","required":["ConfigurationId"],"members":{"ConfigurationId":{},"Description":{}}},"Sq":{"type":"structure","required":["Status"],"members":{"Status":{},"StatusDetail":{},"ProgressPercent":{"type":"integer"}}},"Sv":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}}}}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplicationStates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ApplicationStateList"},"ListCreatedArtifacts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CreatedArtifactList"},"ListDiscoveredResources":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DiscoveredResourceList"},"ListMigrationTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MigrationTaskSummaryList"},"ListProgressUpdateStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProgressUpdateStreamSummaryList"}}}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudhsmv2'] = {};
	AWS.CloudHSMV2 = Service.defineService('cloudhsmv2', ['2017-04-28']);
	Object.defineProperty(apiLoader.services['cloudhsmv2'], '2017-04-28', {
	  get: function get() {
	    var model = __webpack_require__(512);
	    model.paginators = __webpack_require__(513).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudHSMV2;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-28","endpointPrefix":"cloudhsmv2","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM V2","serviceFullName":"AWS CloudHSM V2","serviceId":"CloudHSM V2","signatureVersion":"v4","signingName":"cloudhsm","targetPrefix":"BaldrApiService","uid":"cloudhsmv2-2017-04-28"},"operations":{"CopyBackupToRegion":{"input":{"type":"structure","required":["DestinationRegion","BackupId"],"members":{"DestinationRegion":{},"BackupId":{},"TagList":{"shape":"S4"}}},"output":{"type":"structure","members":{"DestinationBackup":{"type":"structure","members":{"CreateTimestamp":{"type":"timestamp"},"SourceRegion":{},"SourceBackup":{},"SourceCluster":{}}}}}},"CreateCluster":{"input":{"type":"structure","required":["HsmType","SubnetIds"],"members":{"BackupRetentionPolicy":{"shape":"Sd"},"HsmType":{},"SourceBackupId":{},"SubnetIds":{"type":"list","member":{}},"TagList":{"shape":"S4"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sk"}}}},"CreateHsm":{"input":{"type":"structure","required":["ClusterId","AvailabilityZone"],"members":{"ClusterId":{},"AvailabilityZone":{},"IpAddress":{}}},"output":{"type":"structure","members":{"Hsm":{"shape":"Sn"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"S16"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sk"}}}},"DeleteHsm":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"HsmId":{},"EniId":{},"EniIp":{}}},"output":{"type":"structure","members":{"HsmId":{}}}},"DescribeBackups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S1g"},"SortAscending":{"type":"boolean"}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"S16"}},"NextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"Filters":{"shape":"S1g"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"shape":"Sk"}},"NextToken":{}}}},"InitializeCluster":{"input":{"type":"structure","required":["ClusterId","SignedCert","TrustAnchor"],"members":{"ClusterId":{},"SignedCert":{},"TrustAnchor":{}}},"output":{"type":"structure","members":{"State":{},"StateMessage":{}}}},"ListTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S4"},"NextToken":{}}}},"ModifyBackupAttributes":{"input":{"type":"structure","required":["BackupId","NeverExpires"],"members":{"BackupId":{},"NeverExpires":{"type":"boolean"}}},"output":{"type":"structure","members":{"Backup":{"shape":"S16"}}}},"ModifyCluster":{"input":{"type":"structure","required":["BackupRetentionPolicy","ClusterId"],"members":{"BackupRetentionPolicy":{"shape":"Sd"},"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sk"}}}},"RestoreBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"S16"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceId","TagList"],"members":{"ResourceId":{},"TagList":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceId","TagKeyList"],"members":{"ResourceId":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"Type":{},"Value":{}}},"Sk":{"type":"structure","members":{"BackupPolicy":{},"BackupRetentionPolicy":{"shape":"Sd"},"ClusterId":{},"CreateTimestamp":{"type":"timestamp"},"Hsms":{"type":"list","member":{"shape":"Sn"}},"HsmType":{},"PreCoPassword":{},"SecurityGroup":{},"SourceBackupId":{},"State":{},"StateMessage":{},"SubnetMapping":{"type":"map","key":{},"value":{}},"VpcId":{},"Certificates":{"type":"structure","members":{"ClusterCsr":{},"HsmCertificate":{},"AwsHardwareCertificate":{},"ManufacturerHardwareCertificate":{},"ClusterCertificate":{}}},"TagList":{"shape":"S4"}}},"Sn":{"type":"structure","required":["HsmId"],"members":{"AvailabilityZone":{},"ClusterId":{},"SubnetId":{},"EniId":{},"EniIp":{},"HsmId":{},"State":{},"StateMessage":{}}},"S16":{"type":"structure","required":["BackupId"],"members":{"BackupId":{},"BackupState":{},"ClusterId":{},"CreateTimestamp":{"type":"timestamp"},"CopyTimestamp":{"type":"timestamp"},"NeverExpires":{"type":"boolean"},"SourceRegion":{},"SourceBackup":{},"SourceCluster":{},"DeleteTimestamp":{"type":"timestamp"},"TagList":{"shape":"S4"}}},"S1g":{"type":"map","key":{},"value":{"type":"list","member":{}}}}}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeBackups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['glue'] = {};
	AWS.Glue = Service.defineService('glue', ['2017-03-31']);
	Object.defineProperty(apiLoader.services['glue'], '2017-03-31', {
	  get: function get() {
	    var model = __webpack_require__(515);
	    model.paginators = __webpack_require__(516).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Glue;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-31","endpointPrefix":"glue","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Glue","serviceId":"Glue","signatureVersion":"v4","targetPrefix":"AWSGlue","uid":"glue-2017-03-31"},"operations":{"BatchCreatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionInputList"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionInputList":{"type":"list","member":{"shape":"S5"}}}},"output":{"type":"structure","members":{"Errors":{"shape":"S12"}}}},"BatchDeleteConnection":{"input":{"type":"structure","required":["ConnectionNameList"],"members":{"CatalogId":{},"ConnectionNameList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Succeeded":{"shape":"Sn"},"Errors":{"type":"map","key":{},"value":{"shape":"S14"}}}}},"BatchDeletePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionsToDelete"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionsToDelete":{"type":"list","member":{"shape":"S1c"}}}},"output":{"type":"structure","members":{"Errors":{"shape":"S12"}}}},"BatchDeleteTable":{"input":{"type":"structure","required":["DatabaseName","TablesToDelete"],"members":{"CatalogId":{},"DatabaseName":{},"TablesToDelete":{"type":"list","member":{}},"TransactionId":{}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"TableName":{},"ErrorDetail":{"shape":"S14"}}}}}}},"BatchDeleteTableVersion":{"input":{"type":"structure","required":["DatabaseName","TableName","VersionIds"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"VersionIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"TableName":{},"VersionId":{},"ErrorDetail":{"shape":"S14"}}}}}}},"BatchGetBlueprints":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"type":"list","member":{}},"IncludeBlueprint":{"type":"boolean"},"IncludeParameterSpec":{"type":"boolean"}}},"output":{"type":"structure","members":{"Blueprints":{"type":"list","member":{"shape":"S1w"}},"MissingBlueprints":{"shape":"S24"}}}},"BatchGetCrawlers":{"input":{"type":"structure","required":["CrawlerNames"],"members":{"CrawlerNames":{"shape":"S26"}}},"output":{"type":"structure","members":{"Crawlers":{"shape":"S28"},"CrawlersNotFound":{"shape":"S26"}}}},"BatchGetCustomEntityTypes":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S3l"}}},"output":{"type":"structure","members":{"CustomEntityTypes":{"shape":"S3n"},"CustomEntityTypesNotFound":{"shape":"S3l"}}}},"BatchGetDevEndpoints":{"input":{"type":"structure","required":["DevEndpointNames"],"members":{"DevEndpointNames":{"shape":"S3r"}}},"output":{"type":"structure","members":{"DevEndpoints":{"shape":"S3t"},"DevEndpointsNotFound":{"shape":"S3r"}}}},"BatchGetJobs":{"input":{"type":"structure","required":["JobNames"],"members":{"JobNames":{"shape":"S43"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S45"},"JobsNotFound":{"shape":"S43"}}}},"BatchGetPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionsToGet"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionsToGet":{"shape":"S4m"}}},"output":{"type":"structure","members":{"Partitions":{"shape":"S4o"},"UnprocessedKeys":{"shape":"S4m"}}}},"BatchGetTriggers":{"input":{"type":"structure","required":["TriggerNames"],"members":{"TriggerNames":{"shape":"S4r"}}},"output":{"type":"structure","members":{"Triggers":{"shape":"S4t"},"TriggersNotFound":{"shape":"S4r"}}}},"BatchGetWorkflows":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S5b"},"IncludeGraph":{"type":"boolean"}}},"output":{"type":"structure","members":{"Workflows":{"type":"list","member":{"shape":"S5e"}},"MissingWorkflows":{"shape":"S5b"}}}},"BatchStopJobRun":{"input":{"type":"structure","required":["JobName","JobRunIds"],"members":{"JobName":{},"JobRunIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"SuccessfulSubmissions":{"type":"list","member":{"type":"structure","members":{"JobName":{},"JobRunId":{}}}},"Errors":{"type":"list","member":{"type":"structure","members":{"JobName":{},"JobRunId":{},"ErrorDetail":{"shape":"S14"}}}}}}},"BatchUpdatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","Entries"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"Entries":{"type":"list","member":{"type":"structure","required":["PartitionValueList","PartitionInput"],"members":{"PartitionValueList":{"shape":"S6c"},"PartitionInput":{"shape":"S5"}}}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"PartitionValueList":{"shape":"S6c"},"ErrorDetail":{"shape":"S14"}}}}}}},"CancelMLTaskRun":{"input":{"type":"structure","required":["TransformId","TaskRunId"],"members":{"TransformId":{},"TaskRunId":{}}},"output":{"type":"structure","members":{"TransformId":{},"TaskRunId":{},"Status":{}}}},"CancelStatement":{"input":{"type":"structure","required":["SessionId","Id"],"members":{"SessionId":{},"Id":{"type":"integer"},"RequestOrigin":{}}},"output":{"type":"structure","members":{}}},"CheckSchemaVersionValidity":{"input":{"type":"structure","required":["DataFormat","SchemaDefinition"],"members":{"DataFormat":{},"SchemaDefinition":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"},"Error":{}}}},"CreateBlueprint":{"input":{"type":"structure","required":["Name","BlueprintLocation"],"members":{"Name":{},"Description":{},"BlueprintLocation":{},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"Name":{}}}},"CreateClassifier":{"input":{"type":"structure","members":{"GrokClassifier":{"type":"structure","required":["Classification","Name","GrokPattern"],"members":{"Classification":{},"Name":{},"GrokPattern":{},"CustomPatterns":{}}},"XMLClassifier":{"type":"structure","required":["Classification","Name"],"members":{"Classification":{},"Name":{},"RowTag":{}}},"JsonClassifier":{"type":"structure","required":["Name","JsonPath"],"members":{"Name":{},"JsonPath":{}}},"CsvClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Delimiter":{},"QuoteSymbol":{},"ContainsHeader":{},"Header":{"shape":"S7b"},"DisableValueTrimming":{"type":"boolean"},"AllowSingleColumn":{"type":"boolean"}}}}},"output":{"type":"structure","members":{}}},"CreateConnection":{"input":{"type":"structure","required":["ConnectionInput"],"members":{"CatalogId":{},"ConnectionInput":{"shape":"S7e"},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{}}},"CreateCrawler":{"input":{"type":"structure","required":["Name","Role","Targets"],"members":{"Name":{},"Role":{},"DatabaseName":{},"Description":{},"Targets":{"shape":"S2b"},"Schedule":{},"Classifiers":{"shape":"S2w"},"TablePrefix":{},"SchemaChangePolicy":{"shape":"S2z"},"RecrawlPolicy":{"shape":"S2x"},"LineageConfiguration":{"shape":"S32"},"LakeFormationConfiguration":{"shape":"S3i"},"Configuration":{},"CrawlerSecurityConfiguration":{},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{}}},"CreateCustomEntityType":{"input":{"type":"structure","required":["Name","RegexString"],"members":{"Name":{},"RegexString":{},"ContextWords":{"shape":"S3p"}}},"output":{"type":"structure","members":{"Name":{}}}},"CreateDatabase":{"input":{"type":"structure","required":["DatabaseInput"],"members":{"CatalogId":{},"DatabaseInput":{"shape":"S7r"}}},"output":{"type":"structure","members":{}}},"CreateDevEndpoint":{"input":{"type":"structure","required":["EndpointName","RoleArn"],"members":{"EndpointName":{},"RoleArn":{},"SecurityGroupIds":{"shape":"S3w"},"SubnetId":{},"PublicKey":{},"PublicKeys":{"shape":"S40"},"NumberOfNodes":{"type":"integer"},"WorkerType":{},"GlueVersion":{},"NumberOfWorkers":{"type":"integer"},"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{},"SecurityConfiguration":{},"Tags":{"shape":"S6u"},"Arguments":{"shape":"S41"}}},"output":{"type":"structure","members":{"EndpointName":{},"Status":{},"SecurityGroupIds":{"shape":"S3w"},"SubnetId":{},"RoleArn":{},"YarnEndpointAddress":{},"ZeppelinRemoteSparkInterpreterPort":{"type":"integer"},"NumberOfNodes":{"type":"integer"},"WorkerType":{},"GlueVersion":{},"NumberOfWorkers":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{},"FailureReason":{},"SecurityConfiguration":{},"CreatedTimestamp":{"type":"timestamp"},"Arguments":{"shape":"S41"}}}},"CreateJob":{"input":{"type":"structure","required":["Name","Role","Command"],"members":{"Name":{},"Description":{},"LogUri":{},"Role":{},"ExecutionProperty":{"shape":"S49"},"Command":{"shape":"S4b"},"DefaultArguments":{"shape":"S4e"},"NonOverridableArguments":{"shape":"S4e"},"Connections":{"shape":"S4f"},"MaxRetries":{"type":"integer"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"SecurityConfiguration":{},"Tags":{"shape":"S6u"},"NotificationProperty":{"shape":"S4j"},"GlueVersion":{},"NumberOfWorkers":{"type":"integer"},"WorkerType":{}}},"output":{"type":"structure","members":{"Name":{}}}},"CreateMLTransform":{"input":{"type":"structure","required":["Name","InputRecordTables","Parameters","Role"],"members":{"Name":{},"Description":{},"InputRecordTables":{"shape":"S86"},"Parameters":{"shape":"S88"},"Role":{},"GlueVersion":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"},"Tags":{"shape":"S6u"},"TransformEncryption":{"shape":"S8d"}}},"output":{"type":"structure","members":{"TransformId":{}}}},"CreatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionInput":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"CreatePartitionIndex":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionIndex"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionIndex":{"shape":"S8k"}}},"output":{"type":"structure","members":{}}},"CreateRegistry":{"input":{"type":"structure","required":["RegistryName"],"members":{"RegistryName":{},"Description":{},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"RegistryArn":{},"RegistryName":{},"Description":{},"Tags":{"shape":"S6u"}}}},"CreateSchema":{"input":{"type":"structure","required":["SchemaName","DataFormat"],"members":{"RegistryId":{"shape":"S8q"},"SchemaName":{},"DataFormat":{},"Compatibility":{},"Description":{},"Tags":{"shape":"S6u"},"SchemaDefinition":{}}},"output":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{},"SchemaName":{},"SchemaArn":{},"Description":{},"DataFormat":{},"Compatibility":{},"SchemaCheckpoint":{"type":"long"},"LatestSchemaVersion":{"type":"long"},"NextSchemaVersion":{"type":"long"},"SchemaStatus":{},"Tags":{"shape":"S6u"},"SchemaVersionId":{},"SchemaVersionStatus":{}}}},"CreateScript":{"input":{"type":"structure","members":{"DagNodes":{"shape":"S8x"},"DagEdges":{"shape":"S95"},"Language":{}}},"output":{"type":"structure","members":{"PythonScript":{},"ScalaCode":{}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","EncryptionConfiguration"],"members":{"Name":{},"EncryptionConfiguration":{"shape":"S9c"}}},"output":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"CreateSession":{"input":{"type":"structure","required":["Id","Role","Command"],"members":{"Id":{},"Description":{},"Role":{},"Command":{"shape":"S9o"},"Timeout":{"type":"integer"},"IdleTimeout":{"type":"integer"},"DefaultArguments":{"shape":"S9p"},"Connections":{"shape":"S4f"},"MaxCapacity":{"type":"double"},"NumberOfWorkers":{"type":"integer"},"WorkerType":{},"SecurityConfiguration":{},"GlueVersion":{},"Tags":{"shape":"S6u"},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Session":{"shape":"S9s"}}}},"CreateTable":{"input":{"type":"structure","required":["DatabaseName","TableInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableInput":{"shape":"S9w"},"PartitionIndexes":{"type":"list","member":{"shape":"S8k"}},"TransactionId":{}}},"output":{"type":"structure","members":{}}},"CreateTrigger":{"input":{"type":"structure","required":["Name","Type","Actions"],"members":{"Name":{},"WorkflowName":{},"Type":{},"Schedule":{},"Predicate":{"shape":"S50"},"Actions":{"shape":"S4y"},"Description":{},"StartOnCreation":{"type":"boolean"},"Tags":{"shape":"S6u"},"EventBatchingCondition":{"shape":"S57"}}},"output":{"type":"structure","members":{"Name":{}}}},"CreateUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionInput"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionInput":{"shape":"Sa7"}}},"output":{"type":"structure","members":{}}},"CreateWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"DefaultRunProperties":{"shape":"S5f"},"Tags":{"shape":"S6u"},"MaxConcurrentRuns":{"type":"integer"}}},"output":{"type":"structure","members":{"Name":{}}}},"DeleteBlueprint":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"DeleteClassifier":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteColumnStatisticsForPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues","ColumnName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"},"ColumnName":{}}},"output":{"type":"structure","members":{}}},"DeleteColumnStatisticsForTable":{"input":{"type":"structure","required":["DatabaseName","TableName","ColumnName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"ColumnName":{}}},"output":{"type":"structure","members":{}}},"DeleteConnection":{"input":{"type":"structure","required":["ConnectionName"],"members":{"CatalogId":{},"ConnectionName":{}}},"output":{"type":"structure","members":{}}},"DeleteCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteCustomEntityType":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"DeleteDatabase":{"input":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteDevEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"type":"structure","members":{}}},"DeleteJob":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{}}},"output":{"type":"structure","members":{"JobName":{}}}},"DeleteMLTransform":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{}}},"output":{"type":"structure","members":{"TransformId":{}}}},"DeletePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"DeletePartitionIndex":{"input":{"type":"structure","required":["DatabaseName","TableName","IndexName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"IndexName":{}}},"output":{"type":"structure","members":{}}},"DeleteRegistry":{"input":{"type":"structure","required":["RegistryId"],"members":{"RegistryId":{"shape":"S8q"}}},"output":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{},"Status":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"PolicyHashCondition":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteSchema":{"input":{"type":"structure","required":["SchemaId"],"members":{"SchemaId":{"shape":"Sw"}}},"output":{"type":"structure","members":{"SchemaArn":{},"SchemaName":{},"Status":{}}}},"DeleteSchemaVersions":{"input":{"type":"structure","required":["SchemaId","Versions"],"members":{"SchemaId":{"shape":"Sw"},"Versions":{}}},"output":{"type":"structure","members":{"SchemaVersionErrors":{"type":"list","member":{"type":"structure","members":{"VersionNumber":{"type":"long"},"ErrorDetails":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}}}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteSession":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Id":{}}}},"DeleteTable":{"input":{"type":"structure","required":["DatabaseName","Name"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{},"TransactionId":{}}},"output":{"type":"structure","members":{}}},"DeleteTableVersion":{"input":{"type":"structure","required":["DatabaseName","TableName","VersionId"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"VersionId":{}}},"output":{"type":"structure","members":{}}},"DeleteTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"DeleteUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionName"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionName":{}}},"output":{"type":"structure","members":{}}},"DeleteWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"GetBlueprint":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"IncludeBlueprint":{"type":"boolean"},"IncludeParameterSpec":{"type":"boolean"}}},"output":{"type":"structure","members":{"Blueprint":{"shape":"S1w"}}}},"GetBlueprintRun":{"input":{"type":"structure","required":["BlueprintName","RunId"],"members":{"BlueprintName":{},"RunId":{}}},"output":{"type":"structure","members":{"BlueprintRun":{"shape":"Sc2"}}}},"GetBlueprintRuns":{"input":{"type":"structure","required":["BlueprintName"],"members":{"BlueprintName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"BlueprintRuns":{"type":"list","member":{"shape":"Sc2"}},"NextToken":{}}}},"GetCatalogImportStatus":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{"ImportStatus":{"type":"structure","members":{"ImportCompleted":{"type":"boolean"},"ImportTime":{"type":"timestamp"},"ImportedBy":{}}}}}},"GetClassifier":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Classifier":{"shape":"Scg"}}}},"GetClassifiers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Classifiers":{"type":"list","member":{"shape":"Scg"}},"NextToken":{}}}},"GetColumnStatisticsForPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues","ColumnNames"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"},"ColumnNames":{"shape":"Scq"}}},"output":{"type":"structure","members":{"ColumnStatisticsList":{"shape":"Scs"},"Errors":{"shape":"Sda"}}}},"GetColumnStatisticsForTable":{"input":{"type":"structure","required":["DatabaseName","TableName","ColumnNames"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"ColumnNames":{"shape":"Scq"}}},"output":{"type":"structure","members":{"ColumnStatisticsList":{"shape":"Scs"},"Errors":{"shape":"Sda"}}}},"GetConnection":{"input":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{},"HidePassword":{"type":"boolean"}}},"output":{"type":"structure","members":{"Connection":{"shape":"Sdg"}}}},"GetConnections":{"input":{"type":"structure","members":{"CatalogId":{},"Filter":{"type":"structure","members":{"MatchCriteria":{"shape":"S7g"},"ConnectionType":{}}},"HidePassword":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ConnectionList":{"type":"list","member":{"shape":"Sdg"}},"NextToken":{}}}},"GetCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Crawler":{"shape":"S29"}}}},"GetCrawlerMetrics":{"input":{"type":"structure","members":{"CrawlerNameList":{"shape":"S26"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"CrawlerMetricsList":{"type":"list","member":{"type":"structure","members":{"CrawlerName":{},"TimeLeftSeconds":{"type":"double"},"StillEstimating":{"type":"boolean"},"LastRuntimeSeconds":{"type":"double"},"MedianRuntimeSeconds":{"type":"double"},"TablesCreated":{"type":"integer"},"TablesUpdated":{"type":"integer"},"TablesDeleted":{"type":"integer"}}}},"NextToken":{}}}},"GetCrawlers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Crawlers":{"shape":"S28"},"NextToken":{}}}},"GetCustomEntityType":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"RegexString":{},"ContextWords":{"shape":"S3p"}}}},"GetDataCatalogEncryptionSettings":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{"DataCatalogEncryptionSettings":{"shape":"Sdx"}}}},"GetDatabase":{"input":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{}}},"output":{"type":"structure","members":{"Database":{"shape":"Se3"}}}},"GetDatabases":{"input":{"type":"structure","members":{"CatalogId":{},"NextToken":{},"MaxResults":{"type":"integer"},"ResourceShareType":{}}},"output":{"type":"structure","required":["DatabaseList"],"members":{"DatabaseList":{"type":"list","member":{"shape":"Se3"}},"NextToken":{}}}},"GetDataflowGraph":{"input":{"type":"structure","members":{"PythonScript":{}}},"output":{"type":"structure","members":{"DagNodes":{"shape":"S8x"},"DagEdges":{"shape":"S95"}}}},"GetDevEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"type":"structure","members":{"DevEndpoint":{"shape":"S3u"}}}},"GetDevEndpoints":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DevEndpoints":{"shape":"S3t"},"NextToken":{}}}},"GetJob":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{}}},"output":{"type":"structure","members":{"Job":{"shape":"S46"}}}},"GetJobBookmark":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"RunId":{}}},"output":{"type":"structure","members":{"JobBookmarkEntry":{"shape":"Sel"}}}},"GetJobRun":{"input":{"type":"structure","required":["JobName","RunId"],"members":{"JobName":{},"RunId":{},"PredecessorsIncluded":{"type":"boolean"}}},"output":{"type":"structure","members":{"JobRun":{"shape":"S5q"}}}},"GetJobRuns":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"JobRuns":{"shape":"S5p"},"NextToken":{}}}},"GetJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S45"},"NextToken":{}}}},"GetMLTaskRun":{"input":{"type":"structure","required":["TransformId","TaskRunId"],"members":{"TransformId":{},"TaskRunId":{}}},"output":{"type":"structure","members":{"TransformId":{},"TaskRunId":{},"Status":{},"LogGroupName":{},"Properties":{"shape":"Sev"},"ErrorString":{},"StartedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ExecutionTime":{"type":"integer"}}}},"GetMLTaskRuns":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filter":{"type":"structure","members":{"TaskRunType":{},"Status":{},"StartedBefore":{"type":"timestamp"},"StartedAfter":{"type":"timestamp"}}},"Sort":{"type":"structure","required":["Column","SortDirection"],"members":{"Column":{},"SortDirection":{}}}}},"output":{"type":"structure","members":{"TaskRuns":{"type":"list","member":{"type":"structure","members":{"TransformId":{},"TaskRunId":{},"Status":{},"LogGroupName":{},"Properties":{"shape":"Sev"},"ErrorString":{},"StartedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ExecutionTime":{"type":"integer"}}}},"NextToken":{}}}},"GetMLTransform":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{}}},"output":{"type":"structure","members":{"TransformId":{},"Name":{},"Description":{},"Status":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"InputRecordTables":{"shape":"S86"},"Parameters":{"shape":"S88"},"EvaluationMetrics":{"shape":"Sfe"},"LabelCount":{"type":"integer"},"Schema":{"shape":"Sfl"},"Role":{},"GlueVersion":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"},"TransformEncryption":{"shape":"S8d"}}}},"GetMLTransforms":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filter":{"shape":"Sfo"},"Sort":{"shape":"Sfp"}}},"output":{"type":"structure","required":["Transforms"],"members":{"Transforms":{"type":"list","member":{"type":"structure","members":{"TransformId":{},"Name":{},"Description":{},"Status":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"InputRecordTables":{"shape":"S86"},"Parameters":{"shape":"S88"},"EvaluationMetrics":{"shape":"Sfe"},"LabelCount":{"type":"integer"},"Schema":{"shape":"Sfl"},"Role":{},"GlueVersion":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"},"TransformEncryption":{"shape":"S8d"}}}},"NextToken":{}}}},"GetMapping":{"input":{"type":"structure","required":["Source"],"members":{"Source":{"shape":"Sfv"},"Sinks":{"shape":"Sfw"},"Location":{"shape":"Sfx"}}},"output":{"type":"structure","required":["Mapping"],"members":{"Mapping":{"shape":"Sfz"}}}},"GetPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"}}},"output":{"type":"structure","members":{"Partition":{"shape":"S4p"}}}},"GetPartitionIndexes":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"NextToken":{}}},"output":{"type":"structure","members":{"PartitionIndexDescriptorList":{"type":"list","member":{"type":"structure","required":["IndexName","Keys","IndexStatus"],"members":{"IndexName":{},"Keys":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{}}}},"IndexStatus":{},"BackfillErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Partitions":{"type":"list","member":{"shape":"S1c"}}}}}}}},"NextToken":{}}}},"GetPartitions":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"Expression":{},"NextToken":{},"Segment":{"shape":"Sgj"},"MaxResults":{"type":"integer"},"ExcludeColumnSchema":{"type":"boolean"},"TransactionId":{},"QueryAsOfTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Partitions":{"shape":"S4o"},"NextToken":{}}}},"GetPlan":{"input":{"type":"structure","required":["Mapping","Source"],"members":{"Mapping":{"shape":"Sfz"},"Source":{"shape":"Sfv"},"Sinks":{"shape":"Sfw"},"Location":{"shape":"Sfx"},"Language":{},"AdditionalPlanOptionsMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PythonScript":{},"ScalaCode":{}}}},"GetRegistry":{"input":{"type":"structure","required":["RegistryId"],"members":{"RegistryId":{"shape":"S8q"}}},"output":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{},"Description":{},"Status":{},"CreatedTime":{},"UpdatedTime":{}}}},"GetResourcePolicies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"GetResourcePoliciesResponseList":{"type":"list","member":{"type":"structure","members":{"PolicyInJson":{},"PolicyHash":{},"CreateTime":{"type":"timestamp"},"UpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetResourcePolicy":{"input":{"type":"structure","members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"PolicyInJson":{},"PolicyHash":{},"CreateTime":{"type":"timestamp"},"UpdateTime":{"type":"timestamp"}}}},"GetSchema":{"input":{"type":"structure","required":["SchemaId"],"members":{"SchemaId":{"shape":"Sw"}}},"output":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{},"SchemaName":{},"SchemaArn":{},"Description":{},"DataFormat":{},"Compatibility":{},"SchemaCheckpoint":{"type":"long"},"LatestSchemaVersion":{"type":"long"},"NextSchemaVersion":{"type":"long"},"SchemaStatus":{},"CreatedTime":{},"UpdatedTime":{}}}},"GetSchemaByDefinition":{"input":{"type":"structure","required":["SchemaId","SchemaDefinition"],"members":{"SchemaId":{"shape":"Sw"},"SchemaDefinition":{}}},"output":{"type":"structure","members":{"SchemaVersionId":{},"SchemaArn":{},"DataFormat":{},"Status":{},"CreatedTime":{}}}},"GetSchemaVersion":{"input":{"type":"structure","members":{"SchemaId":{"shape":"Sw"},"SchemaVersionId":{},"SchemaVersionNumber":{"shape":"Sh6"}}},"output":{"type":"structure","members":{"SchemaVersionId":{},"SchemaDefinition":{},"DataFormat":{},"SchemaArn":{},"VersionNumber":{"type":"long"},"Status":{},"CreatedTime":{}}}},"GetSchemaVersionsDiff":{"input":{"type":"structure","required":["SchemaId","FirstSchemaVersionNumber","SecondSchemaVersionNumber","SchemaDiffType"],"members":{"SchemaId":{"shape":"Sw"},"FirstSchemaVersionNumber":{"shape":"Sh6"},"SecondSchemaVersionNumber":{"shape":"Sh6"},"SchemaDiffType":{}}},"output":{"type":"structure","members":{"Diff":{}}}},"GetSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"SecurityConfiguration":{"shape":"Shf"}}}},"GetSecurityConfigurations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"shape":"Shf"}},"NextToken":{}}}},"GetSession":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Session":{"shape":"S9s"}}}},"GetStatement":{"input":{"type":"structure","required":["SessionId","Id"],"members":{"SessionId":{},"Id":{"type":"integer"},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Statement":{"shape":"Shn"}}}},"GetTable":{"input":{"type":"structure","required":["DatabaseName","Name"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{},"TransactionId":{},"QueryAsOfTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Table":{"shape":"Shu"}}}},"GetTableVersion":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"VersionId":{}}},"output":{"type":"structure","members":{"TableVersion":{"shape":"Shx"}}}},"GetTableVersions":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TableVersions":{"type":"list","member":{"shape":"Shx"}},"NextToken":{}}}},"GetTables":{"input":{"type":"structure","required":["DatabaseName"],"members":{"CatalogId":{},"DatabaseName":{},"Expression":{},"NextToken":{},"MaxResults":{"type":"integer"},"TransactionId":{},"QueryAsOfTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"TableList":{"shape":"Si4"},"NextToken":{}}}},"GetTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6u"}}}},"GetTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Trigger":{"shape":"S4u"}}}},"GetTriggers":{"input":{"type":"structure","members":{"NextToken":{},"DependentJobName":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Triggers":{"shape":"S4t"},"NextToken":{}}}},"GetUnfilteredPartitionMetadata":{"input":{"type":"structure","required":["CatalogId","DatabaseName","TableName","PartitionValues","SupportedPermissionTypes"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"},"AuditContext":{"shape":"Sic"},"SupportedPermissionTypes":{"shape":"Sif"}}},"output":{"type":"structure","members":{"Partition":{"shape":"S4p"},"AuthorizedColumns":{"shape":"Sn"},"IsRegisteredWithLakeFormation":{"type":"boolean"}}}},"GetUnfilteredPartitionsMetadata":{"input":{"type":"structure","required":["CatalogId","DatabaseName","TableName","SupportedPermissionTypes"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"Expression":{},"AuditContext":{"shape":"Sic"},"SupportedPermissionTypes":{"shape":"Sif"},"NextToken":{},"Segment":{"shape":"Sgj"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UnfilteredPartitions":{"type":"list","member":{"type":"structure","members":{"Partition":{"shape":"S4p"},"AuthorizedColumns":{"shape":"Sn"},"IsRegisteredWithLakeFormation":{"type":"boolean"}}}},"NextToken":{}}}},"GetUnfilteredTableMetadata":{"input":{"type":"structure","required":["CatalogId","DatabaseName","Name","SupportedPermissionTypes"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{},"AuditContext":{"shape":"Sic"},"SupportedPermissionTypes":{"shape":"Sif"}}},"output":{"type":"structure","members":{"Table":{"shape":"Shu"},"AuthorizedColumns":{"shape":"Sn"},"IsRegisteredWithLakeFormation":{"type":"boolean"},"CellFilters":{"type":"list","member":{"type":"structure","members":{"ColumnName":{},"RowFilterExpression":{}}}}}}},"GetUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionName"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionName":{}}},"output":{"type":"structure","members":{"UserDefinedFunction":{"shape":"Sis"}}}},"GetUserDefinedFunctions":{"input":{"type":"structure","required":["Pattern"],"members":{"CatalogId":{},"DatabaseName":{},"Pattern":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserDefinedFunctions":{"type":"list","member":{"shape":"Sis"}},"NextToken":{}}}},"GetWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"IncludeGraph":{"type":"boolean"}}},"output":{"type":"structure","members":{"Workflow":{"shape":"S5e"}}}},"GetWorkflowRun":{"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{},"RunId":{},"IncludeGraph":{"type":"boolean"}}},"output":{"type":"structure","members":{"Run":{"shape":"S5g"}}}},"GetWorkflowRunProperties":{"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{},"RunId":{}}},"output":{"type":"structure","members":{"RunProperties":{"shape":"S5f"}}}},"GetWorkflowRuns":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"IncludeGraph":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Runs":{"type":"list","member":{"shape":"S5g"}},"NextToken":{}}}},"ImportCatalogToGlue":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{}}},"ListBlueprints":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"Blueprints":{"shape":"S24"},"NextToken":{}}}},"ListCrawlers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"CrawlerNames":{"shape":"S26"},"NextToken":{}}}},"ListCustomEntityTypes":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CustomEntityTypes":{"shape":"S3n"},"NextToken":{}}}},"ListDevEndpoints":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"DevEndpointNames":{"type":"list","member":{}},"NextToken":{}}}},"ListJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"JobNames":{"shape":"S43"},"NextToken":{}}}},"ListMLTransforms":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filter":{"shape":"Sfo"},"Sort":{"shape":"Sfp"},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","required":["TransformIds"],"members":{"TransformIds":{"type":"list","member":{}},"NextToken":{}}}},"ListRegistries":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Registries":{"type":"list","member":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{},"Description":{},"Status":{},"CreatedTime":{},"UpdatedTime":{}}}},"NextToken":{}}}},"ListSchemaVersions":{"input":{"type":"structure","required":["SchemaId"],"members":{"SchemaId":{"shape":"Sw"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","members":{"SchemaArn":{},"SchemaVersionId":{},"VersionNumber":{"type":"long"},"Status":{},"CreatedTime":{}}}},"NextToken":{}}}},"ListSchemas":{"input":{"type":"structure","members":{"RegistryId":{"shape":"S8q"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","members":{"RegistryName":{},"SchemaName":{},"SchemaArn":{},"Description":{},"SchemaStatus":{},"CreatedTime":{},"UpdatedTime":{}}}},"NextToken":{}}}},"ListSessions":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S6u"},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Ids":{"type":"list","member":{}},"Sessions":{"type":"list","member":{"shape":"S9s"}},"NextToken":{}}}},"ListStatements":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{},"RequestOrigin":{},"NextToken":{}}},"output":{"type":"structure","members":{"Statements":{"type":"list","member":{"shape":"Shn"}},"NextToken":{}}}},"ListTriggers":{"input":{"type":"structure","members":{"NextToken":{},"DependentJobName":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S6u"}}},"output":{"type":"structure","members":{"TriggerNames":{"shape":"S4r"},"NextToken":{}}}},"ListWorkflows":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Workflows":{"shape":"S5b"},"NextToken":{}}}},"PutDataCatalogEncryptionSettings":{"input":{"type":"structure","required":["DataCatalogEncryptionSettings"],"members":{"CatalogId":{},"DataCatalogEncryptionSettings":{"shape":"Sdx"}}},"output":{"type":"structure","members":{}}},"PutResourcePolicy":{"input":{"type":"structure","required":["PolicyInJson"],"members":{"PolicyInJson":{},"ResourceArn":{},"PolicyHashCondition":{},"PolicyExistsCondition":{},"EnableHybrid":{}}},"output":{"type":"structure","members":{"PolicyHash":{}}}},"PutSchemaVersionMetadata":{"input":{"type":"structure","required":["MetadataKeyValue"],"members":{"SchemaId":{"shape":"Sw"},"SchemaVersionNumber":{"shape":"Sh6"},"SchemaVersionId":{},"MetadataKeyValue":{"shape":"Ski"}}},"output":{"type":"structure","members":{"SchemaArn":{},"SchemaName":{},"RegistryName":{},"LatestVersion":{"type":"boolean"},"VersionNumber":{"type":"long"},"SchemaVersionId":{},"MetadataKey":{},"MetadataValue":{}}}},"PutWorkflowRunProperties":{"input":{"type":"structure","required":["Name","RunId","RunProperties"],"members":{"Name":{},"RunId":{},"RunProperties":{"shape":"S5f"}}},"output":{"type":"structure","members":{}}},"QuerySchemaVersionMetadata":{"input":{"type":"structure","members":{"SchemaId":{"shape":"Sw"},"SchemaVersionNumber":{"shape":"Sh6"},"SchemaVersionId":{},"MetadataList":{"type":"list","member":{"shape":"Ski"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"MetadataInfoMap":{"type":"map","key":{},"value":{"type":"structure","members":{"MetadataValue":{},"CreatedTime":{},"OtherMetadataValueList":{"type":"list","member":{"type":"structure","members":{"MetadataValue":{},"CreatedTime":{}}}}}}},"SchemaVersionId":{},"NextToken":{}}}},"RegisterSchemaVersion":{"input":{"type":"structure","required":["SchemaId","SchemaDefinition"],"members":{"SchemaId":{"shape":"Sw"},"SchemaDefinition":{}}},"output":{"type":"structure","members":{"SchemaVersionId":{},"VersionNumber":{"type":"long"},"Status":{}}}},"RemoveSchemaVersionMetadata":{"input":{"type":"structure","required":["MetadataKeyValue"],"members":{"SchemaId":{"shape":"Sw"},"SchemaVersionNumber":{"shape":"Sh6"},"SchemaVersionId":{},"MetadataKeyValue":{"shape":"Ski"}}},"output":{"type":"structure","members":{"SchemaArn":{},"SchemaName":{},"RegistryName":{},"LatestVersion":{"type":"boolean"},"VersionNumber":{"type":"long"},"SchemaVersionId":{},"MetadataKey":{},"MetadataValue":{}}}},"ResetJobBookmark":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"RunId":{}}},"output":{"type":"structure","members":{"JobBookmarkEntry":{"shape":"Sel"}}}},"ResumeWorkflowRun":{"input":{"type":"structure","required":["Name","RunId","NodeIds"],"members":{"Name":{},"RunId":{},"NodeIds":{"shape":"Sl3"}}},"output":{"type":"structure","members":{"RunId":{},"NodeIds":{"shape":"Sl3"}}}},"RunStatement":{"input":{"type":"structure","required":["SessionId","Code"],"members":{"SessionId":{},"Code":{},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Id":{"type":"integer"}}}},"SearchTables":{"input":{"type":"structure","members":{"CatalogId":{},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Comparator":{}}}},"SearchText":{},"SortCriteria":{"type":"list","member":{"type":"structure","members":{"FieldName":{},"Sort":{}}}},"MaxResults":{"type":"integer"},"ResourceShareType":{}}},"output":{"type":"structure","members":{"NextToken":{},"TableList":{"shape":"Si4"}}}},"StartBlueprintRun":{"input":{"type":"structure","required":["BlueprintName","RoleArn"],"members":{"BlueprintName":{},"Parameters":{},"RoleArn":{}}},"output":{"type":"structure","members":{"RunId":{}}}},"StartCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StartCrawlerSchedule":{"input":{"type":"structure","required":["CrawlerName"],"members":{"CrawlerName":{}}},"output":{"type":"structure","members":{}}},"StartExportLabelsTaskRun":{"input":{"type":"structure","required":["TransformId","OutputS3Path"],"members":{"TransformId":{},"OutputS3Path":{}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartImportLabelsTaskRun":{"input":{"type":"structure","required":["TransformId","InputS3Path"],"members":{"TransformId":{},"InputS3Path":{},"ReplaceAllLabels":{"type":"boolean"}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartJobRun":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"JobRunId":{},"Arguments":{"shape":"S4e"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S4j"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"}}},"output":{"type":"structure","members":{"JobRunId":{}}}},"StartMLEvaluationTaskRun":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartMLLabelingSetGenerationTaskRun":{"input":{"type":"structure","required":["TransformId","OutputS3Path"],"members":{"TransformId":{},"OutputS3Path":{}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"StartWorkflowRun":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"RunProperties":{"shape":"S5f"}}},"output":{"type":"structure","members":{"RunId":{}}}},"StopCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StopCrawlerSchedule":{"input":{"type":"structure","required":["CrawlerName"],"members":{"CrawlerName":{}}},"output":{"type":"structure","members":{}}},"StopSession":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"RequestOrigin":{}}},"output":{"type":"structure","members":{"Id":{}}}},"StopTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"StopWorkflowRun":{"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{},"RunId":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","TagsToAdd"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S6u"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagsToRemove"],"members":{"ResourceArn":{},"TagsToRemove":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateBlueprint":{"input":{"type":"structure","required":["Name","BlueprintLocation"],"members":{"Name":{},"Description":{},"BlueprintLocation":{}}},"output":{"type":"structure","members":{"Name":{}}}},"UpdateClassifier":{"input":{"type":"structure","members":{"GrokClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Classification":{},"GrokPattern":{},"CustomPatterns":{}}},"XMLClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Classification":{},"RowTag":{}}},"JsonClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"JsonPath":{}}},"CsvClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Delimiter":{},"QuoteSymbol":{},"ContainsHeader":{},"Header":{"shape":"S7b"},"DisableValueTrimming":{"type":"boolean"},"AllowSingleColumn":{"type":"boolean"}}}}},"output":{"type":"structure","members":{}}},"UpdateColumnStatisticsForPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues","ColumnStatisticsList"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"},"ColumnStatisticsList":{"shape":"Smo"}}},"output":{"type":"structure","members":{"Errors":{"shape":"Smq"}}}},"UpdateColumnStatisticsForTable":{"input":{"type":"structure","required":["DatabaseName","TableName","ColumnStatisticsList"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"ColumnStatisticsList":{"shape":"Smo"}}},"output":{"type":"structure","members":{"Errors":{"shape":"Smq"}}}},"UpdateConnection":{"input":{"type":"structure","required":["Name","ConnectionInput"],"members":{"CatalogId":{},"Name":{},"ConnectionInput":{"shape":"S7e"}}},"output":{"type":"structure","members":{}}},"UpdateCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Role":{},"DatabaseName":{},"Description":{},"Targets":{"shape":"S2b"},"Schedule":{},"Classifiers":{"shape":"S2w"},"TablePrefix":{},"SchemaChangePolicy":{"shape":"S2z"},"RecrawlPolicy":{"shape":"S2x"},"LineageConfiguration":{"shape":"S32"},"LakeFormationConfiguration":{"shape":"S3i"},"Configuration":{},"CrawlerSecurityConfiguration":{}}},"output":{"type":"structure","members":{}}},"UpdateCrawlerSchedule":{"input":{"type":"structure","required":["CrawlerName"],"members":{"CrawlerName":{},"Schedule":{}}},"output":{"type":"structure","members":{}}},"UpdateDatabase":{"input":{"type":"structure","required":["Name","DatabaseInput"],"members":{"CatalogId":{},"Name":{},"DatabaseInput":{"shape":"S7r"}}},"output":{"type":"structure","members":{}}},"UpdateDevEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{},"PublicKey":{},"AddPublicKeys":{"shape":"S40"},"DeletePublicKeys":{"shape":"S40"},"CustomLibraries":{"type":"structure","members":{"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{}}},"UpdateEtlLibraries":{"type":"boolean"},"DeleteArguments":{"shape":"S3w"},"AddArguments":{"shape":"S41"}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"input":{"type":"structure","required":["JobName","JobUpdate"],"members":{"JobName":{},"JobUpdate":{"type":"structure","members":{"Description":{},"LogUri":{},"Role":{},"ExecutionProperty":{"shape":"S49"},"Command":{"shape":"S4b"},"DefaultArguments":{"shape":"S4e"},"NonOverridableArguments":{"shape":"S4e"},"Connections":{"shape":"S4f"},"MaxRetries":{"type":"integer"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S4j"},"GlueVersion":{}}}}},"output":{"type":"structure","members":{"JobName":{}}}},"UpdateMLTransform":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{},"Name":{},"Description":{},"Parameters":{"shape":"S88"},"Role":{},"GlueVersion":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"}}},"output":{"type":"structure","members":{"TransformId":{}}}},"UpdatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValueList","PartitionInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValueList":{"shape":"S6c"},"PartitionInput":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UpdateRegistry":{"input":{"type":"structure","required":["RegistryId","Description"],"members":{"RegistryId":{"shape":"S8q"},"Description":{}}},"output":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{}}}},"UpdateSchema":{"input":{"type":"structure","required":["SchemaId"],"members":{"SchemaId":{"shape":"Sw"},"SchemaVersionNumber":{"shape":"Sh6"},"Compatibility":{},"Description":{}}},"output":{"type":"structure","members":{"SchemaArn":{},"SchemaName":{},"RegistryName":{}}}},"UpdateTable":{"input":{"type":"structure","required":["DatabaseName","TableInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableInput":{"shape":"S9w"},"SkipArchive":{"type":"boolean"},"TransactionId":{},"VersionId":{}}},"output":{"type":"structure","members":{}}},"UpdateTrigger":{"input":{"type":"structure","required":["Name","TriggerUpdate"],"members":{"Name":{},"TriggerUpdate":{"type":"structure","members":{"Name":{},"Description":{},"Schedule":{},"Actions":{"shape":"S4y"},"Predicate":{"shape":"S50"},"EventBatchingCondition":{"shape":"S57"}}}}},"output":{"type":"structure","members":{"Trigger":{"shape":"S4u"}}}},"UpdateUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionName","FunctionInput"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionName":{},"FunctionInput":{"shape":"Sa7"}}},"output":{"type":"structure","members":{}}},"UpdateWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"DefaultRunProperties":{"shape":"S5f"},"MaxConcurrentRuns":{"type":"integer"}}},"output":{"type":"structure","members":{"Name":{}}}}},"shapes":{"S5":{"type":"structure","members":{"Values":{"shape":"S6"},"LastAccessTime":{"type":"timestamp"},"StorageDescriptor":{"shape":"S9"},"Parameters":{"shape":"Se"},"LastAnalyzedTime":{"type":"timestamp"}}},"S6":{"type":"list","member":{}},"S9":{"type":"structure","members":{"Columns":{"shape":"Sa"},"Location":{},"AdditionalLocations":{"type":"list","member":{}},"InputFormat":{},"OutputFormat":{},"Compressed":{"type":"boolean"},"NumberOfBuckets":{"type":"integer"},"SerdeInfo":{"type":"structure","members":{"Name":{},"SerializationLibrary":{},"Parameters":{"shape":"Se"}}},"BucketColumns":{"shape":"Sn"},"SortColumns":{"type":"list","member":{"type":"structure","required":["Column","SortOrder"],"members":{"Column":{},"SortOrder":{"type":"integer"}}}},"Parameters":{"shape":"Se"},"SkewedInfo":{"type":"structure","members":{"SkewedColumnNames":{"shape":"Sn"},"SkewedColumnValues":{"type":"list","member":{}},"SkewedColumnValueLocationMaps":{"type":"map","key":{},"value":{}}}},"StoredAsSubDirectories":{"type":"boolean"},"SchemaReference":{"type":"structure","members":{"SchemaId":{"shape":"Sw"},"SchemaVersionId":{},"SchemaVersionNumber":{"type":"long"}}}}},"Sa":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Type":{},"Comment":{},"Parameters":{"shape":"Se"}}}},"Se":{"type":"map","key":{},"value":{}},"Sn":{"type":"list","member":{}},"Sw":{"type":"structure","members":{"SchemaArn":{},"SchemaName":{},"RegistryName":{}}},"S12":{"type":"list","member":{"type":"structure","members":{"PartitionValues":{"shape":"S6"},"ErrorDetail":{"shape":"S14"}}}},"S14":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}},"S1c":{"type":"structure","required":["Values"],"members":{"Values":{"shape":"S6"}}},"S1w":{"type":"structure","members":{"Name":{},"Description":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"ParameterSpec":{},"BlueprintLocation":{},"BlueprintServiceLocation":{},"Status":{},"ErrorMessage":{},"LastActiveDefinition":{"type":"structure","members":{"Description":{},"LastModifiedOn":{"type":"timestamp"},"ParameterSpec":{},"BlueprintLocation":{},"BlueprintServiceLocation":{}}}}},"S24":{"type":"list","member":{}},"S26":{"type":"list","member":{}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"Name":{},"Role":{},"Targets":{"shape":"S2b"},"DatabaseName":{},"Description":{},"Classifiers":{"shape":"S2w"},"RecrawlPolicy":{"shape":"S2x"},"SchemaChangePolicy":{"shape":"S2z"},"LineageConfiguration":{"shape":"S32"},"State":{},"TablePrefix":{},"Schedule":{"type":"structure","members":{"ScheduleExpression":{},"State":{}}},"CrawlElapsedTime":{"type":"long"},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"LastCrawl":{"type":"structure","members":{"Status":{},"ErrorMessage":{},"LogGroup":{},"LogStream":{},"MessagePrefix":{},"StartTime":{"type":"timestamp"}}},"Version":{"type":"long"},"Configuration":{},"CrawlerSecurityConfiguration":{},"LakeFormationConfiguration":{"shape":"S3i"}}},"S2b":{"type":"structure","members":{"S3Targets":{"type":"list","member":{"type":"structure","members":{"Path":{},"Exclusions":{"shape":"S2f"},"ConnectionName":{},"SampleSize":{"type":"integer"},"EventQueueArn":{},"DlqEventQueueArn":{}}}},"JdbcTargets":{"type":"list","member":{"type":"structure","members":{"ConnectionName":{},"Path":{},"Exclusions":{"shape":"S2f"}}}},"MongoDBTargets":{"type":"list","member":{"type":"structure","members":{"ConnectionName":{},"Path":{},"ScanAll":{"type":"boolean"}}}},"DynamoDBTargets":{"type":"list","member":{"type":"structure","members":{"Path":{},"scanAll":{"type":"boolean"},"scanRate":{"type":"double"}}}},"CatalogTargets":{"type":"list","member":{"type":"structure","required":["DatabaseName","Tables"],"members":{"DatabaseName":{},"Tables":{"type":"list","member":{}},"ConnectionName":{}}}},"DeltaTargets":{"type":"list","member":{"type":"structure","members":{"DeltaTables":{"shape":"S2f"},"ConnectionName":{},"WriteManifest":{"type":"boolean"}}}}}},"S2f":{"type":"list","member":{}},"S2w":{"type":"list","member":{}},"S2x":{"type":"structure","members":{"RecrawlBehavior":{}}},"S2z":{"type":"structure","members":{"UpdateBehavior":{},"DeleteBehavior":{}}},"S32":{"type":"structure","members":{"CrawlerLineageSettings":{}}},"S3i":{"type":"structure","members":{"UseLakeFormationCredentials":{"type":"boolean"},"AccountId":{}}},"S3l":{"type":"list","member":{}},"S3n":{"type":"list","member":{"type":"structure","required":["Name","RegexString"],"members":{"Name":{},"RegexString":{},"ContextWords":{"shape":"S3p"}}}},"S3p":{"type":"list","member":{}},"S3r":{"type":"list","member":{}},"S3t":{"type":"list","member":{"shape":"S3u"}},"S3u":{"type":"structure","members":{"EndpointName":{},"RoleArn":{},"SecurityGroupIds":{"shape":"S3w"},"SubnetId":{},"YarnEndpointAddress":{},"PrivateAddress":{},"ZeppelinRemoteSparkInterpreterPort":{"type":"integer"},"PublicAddress":{},"Status":{},"WorkerType":{},"GlueVersion":{},"NumberOfWorkers":{"type":"integer"},"NumberOfNodes":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{},"FailureReason":{},"LastUpdateStatus":{},"CreatedTimestamp":{"type":"timestamp"},"LastModifiedTimestamp":{"type":"timestamp"},"PublicKey":{},"PublicKeys":{"shape":"S40"},"SecurityConfiguration":{},"Arguments":{"shape":"S41"}}},"S3w":{"type":"list","member":{}},"S40":{"type":"list","member":{}},"S41":{"type":"map","key":{},"value":{}},"S43":{"type":"list","member":{}},"S45":{"type":"list","member":{"shape":"S46"}},"S46":{"type":"structure","members":{"Name":{},"Description":{},"LogUri":{},"Role":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"ExecutionProperty":{"shape":"S49"},"Command":{"shape":"S4b"},"DefaultArguments":{"shape":"S4e"},"NonOverridableArguments":{"shape":"S4e"},"Connections":{"shape":"S4f"},"MaxRetries":{"type":"integer"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S4j"},"GlueVersion":{}}},"S49":{"type":"structure","members":{"MaxConcurrentRuns":{"type":"integer"}}},"S4b":{"type":"structure","members":{"Name":{},"ScriptLocation":{},"PythonVersion":{}}},"S4e":{"type":"map","key":{},"value":{}},"S4f":{"type":"structure","members":{"Connections":{"shape":"S4g"}}},"S4g":{"type":"list","member":{}},"S4j":{"type":"structure","members":{"NotifyDelayAfter":{"type":"integer"}}},"S4m":{"type":"list","member":{"shape":"S1c"}},"S4o":{"type":"list","member":{"shape":"S4p"}},"S4p":{"type":"structure","members":{"Values":{"shape":"S6"},"DatabaseName":{},"TableName":{},"CreationTime":{"type":"timestamp"},"LastAccessTime":{"type":"timestamp"},"StorageDescriptor":{"shape":"S9"},"Parameters":{"shape":"Se"},"LastAnalyzedTime":{"type":"timestamp"},"CatalogId":{}}},"S4r":{"type":"list","member":{}},"S4t":{"type":"list","member":{"shape":"S4u"}},"S4u":{"type":"structure","members":{"Name":{},"WorkflowName":{},"Id":{},"Type":{},"State":{},"Description":{},"Schedule":{},"Actions":{"shape":"S4y"},"Predicate":{"shape":"S50"},"EventBatchingCondition":{"shape":"S57"}}},"S4y":{"type":"list","member":{"type":"structure","members":{"JobName":{},"Arguments":{"shape":"S4e"},"Timeout":{"type":"integer"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S4j"},"CrawlerName":{}}}},"S50":{"type":"structure","members":{"Logical":{},"Conditions":{"type":"list","member":{"type":"structure","members":{"LogicalOperator":{},"JobName":{},"State":{},"CrawlerName":{},"CrawlState":{}}}}}},"S57":{"type":"structure","required":["BatchSize"],"members":{"BatchSize":{"type":"integer"},"BatchWindow":{"type":"integer"}}},"S5b":{"type":"list","member":{}},"S5e":{"type":"structure","members":{"Name":{},"Description":{},"DefaultRunProperties":{"shape":"S5f"},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"LastRun":{"shape":"S5g"},"Graph":{"shape":"S5j"},"MaxConcurrentRuns":{"type":"integer"},"BlueprintDetails":{"type":"structure","members":{"BlueprintName":{},"RunId":{}}}}},"S5f":{"type":"map","key":{},"value":{}},"S5g":{"type":"structure","members":{"Name":{},"WorkflowRunId":{},"PreviousRunId":{},"WorkflowRunProperties":{"shape":"S5f"},"StartedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"Status":{},"ErrorMessage":{},"Statistics":{"type":"structure","members":{"TotalActions":{"type":"integer"},"TimeoutActions":{"type":"integer"},"FailedActions":{"type":"integer"},"StoppedActions":{"type":"integer"},"SucceededActions":{"type":"integer"},"RunningActions":{"type":"integer"}}},"Graph":{"shape":"S5j"},"StartingEventBatchCondition":{"type":"structure","members":{"BatchSize":{"type":"integer"},"BatchWindow":{"type":"integer"}}}}},"S5j":{"type":"structure","members":{"Nodes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Name":{},"UniqueId":{},"TriggerDetails":{"type":"structure","members":{"Trigger":{"shape":"S4u"}}},"JobDetails":{"type":"structure","members":{"JobRuns":{"shape":"S5p"}}},"CrawlerDetails":{"type":"structure","members":{"Crawls":{"type":"list","member":{"type":"structure","members":{"State":{},"StartedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ErrorMessage":{},"LogGroup":{},"LogStream":{}}}}}}}}},"Edges":{"type":"list","member":{"type":"structure","members":{"SourceId":{},"DestinationId":{}}}}}},"S5p":{"type":"list","member":{"shape":"S5q"}},"S5q":{"type":"structure","members":{"Id":{},"Attempt":{"type":"integer"},"PreviousRunId":{},"TriggerName":{},"JobName":{},"StartedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"JobRunState":{},"Arguments":{"shape":"S4e"},"ErrorMessage":{},"PredecessorRuns":{"type":"list","member":{"type":"structure","members":{"JobName":{},"RunId":{}}}},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"ExecutionTime":{"type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"SecurityConfiguration":{},"LogGroupName":{},"NotificationProperty":{"shape":"S4j"},"GlueVersion":{},"DPUSeconds":{"type":"double"}}},"S6c":{"type":"list","member":{}},"S6u":{"type":"map","key":{},"value":{}},"S7b":{"type":"list","member":{}},"S7e":{"type":"structure","required":["Name","ConnectionType","ConnectionProperties"],"members":{"Name":{},"Description":{},"ConnectionType":{},"MatchCriteria":{"shape":"S7g"},"ConnectionProperties":{"shape":"S7h"},"PhysicalConnectionRequirements":{"shape":"S7j"}}},"S7g":{"type":"list","member":{}},"S7h":{"type":"map","key":{},"value":{}},"S7j":{"type":"structure","members":{"SubnetId":{},"SecurityGroupIdList":{"type":"list","member":{}},"AvailabilityZone":{}}},"S7r":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"LocationUri":{},"Parameters":{"shape":"Se"},"CreateTableDefaultPermissions":{"shape":"S7t"},"TargetDatabase":{"shape":"S7z"}}},"S7t":{"type":"list","member":{"type":"structure","members":{"Principal":{"type":"structure","members":{"DataLakePrincipalIdentifier":{}}},"Permissions":{"type":"list","member":{}}}}},"S7z":{"type":"structure","members":{"CatalogId":{},"DatabaseName":{}}},"S86":{"type":"list","member":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{},"CatalogId":{},"ConnectionName":{}}}},"S88":{"type":"structure","required":["TransformType"],"members":{"TransformType":{},"FindMatchesParameters":{"type":"structure","members":{"PrimaryKeyColumnName":{},"PrecisionRecallTradeoff":{"type":"double"},"AccuracyCostTradeoff":{"type":"double"},"EnforceProvidedLabels":{"type":"boolean"}}}}},"S8d":{"type":"structure","members":{"MlUserDataEncryption":{"type":"structure","required":["MlUserDataEncryptionMode"],"members":{"MlUserDataEncryptionMode":{},"KmsKeyId":{}}},"TaskRunSecurityConfigurationName":{}}},"S8k":{"type":"structure","required":["Keys","IndexName"],"members":{"Keys":{"type":"list","member":{}},"IndexName":{}}},"S8q":{"type":"structure","members":{"RegistryName":{},"RegistryArn":{}}},"S8x":{"type":"list","member":{"type":"structure","required":["Id","NodeType","Args"],"members":{"Id":{},"NodeType":{},"Args":{"shape":"S91"},"LineNumber":{"type":"integer"}}}},"S91":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{},"Param":{"type":"boolean"}}}},"S95":{"type":"list","member":{"type":"structure","required":["Source","Target"],"members":{"Source":{},"Target":{},"TargetParameter":{}}}},"S9c":{"type":"structure","members":{"S3Encryption":{"type":"list","member":{"type":"structure","members":{"S3EncryptionMode":{},"KmsKeyArn":{}}}},"CloudWatchEncryption":{"type":"structure","members":{"CloudWatchEncryptionMode":{},"KmsKeyArn":{}}},"JobBookmarksEncryption":{"type":"structure","members":{"JobBookmarksEncryptionMode":{},"KmsKeyArn":{}}}}},"S9o":{"type":"structure","members":{"Name":{},"PythonVersion":{}}},"S9p":{"type":"map","key":{},"value":{}},"S9s":{"type":"structure","members":{"Id":{},"CreatedOn":{"type":"timestamp"},"Status":{},"ErrorMessage":{},"Description":{},"Role":{},"Command":{"shape":"S9o"},"DefaultArguments":{"shape":"S9p"},"Connections":{"shape":"S4f"},"Progress":{"type":"double"},"MaxCapacity":{"type":"double"},"SecurityConfiguration":{},"GlueVersion":{}}},"S9w":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"Owner":{},"LastAccessTime":{"type":"timestamp"},"LastAnalyzedTime":{"type":"timestamp"},"Retention":{"type":"integer"},"StorageDescriptor":{"shape":"S9"},"PartitionKeys":{"shape":"Sa"},"ViewOriginalText":{},"ViewExpandedText":{},"TableType":{},"Parameters":{"shape":"Se"},"TargetTable":{"shape":"Sa0"}}},"Sa0":{"type":"structure","members":{"CatalogId":{},"DatabaseName":{},"Name":{}}},"Sa7":{"type":"structure","members":{"FunctionName":{},"ClassName":{},"OwnerName":{},"OwnerType":{},"ResourceUris":{"shape":"Sa9"}}},"Sa9":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"Uri":{}}}},"Sc2":{"type":"structure","members":{"BlueprintName":{},"RunId":{},"WorkflowName":{},"State":{},"StartedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ErrorMessage":{},"RollbackErrorMessage":{},"Parameters":{},"RoleArn":{}}},"Scg":{"type":"structure","members":{"GrokClassifier":{"type":"structure","required":["Name","Classification","GrokPattern"],"members":{"Name":{},"Classification":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"GrokPattern":{},"CustomPatterns":{}}},"XMLClassifier":{"type":"structure","required":["Name","Classification"],"members":{"Name":{},"Classification":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"RowTag":{}}},"JsonClassifier":{"type":"structure","required":["Name","JsonPath"],"members":{"Name":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"JsonPath":{}}},"CsvClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"Delimiter":{},"QuoteSymbol":{},"ContainsHeader":{},"Header":{"shape":"S7b"},"DisableValueTrimming":{"type":"boolean"},"AllowSingleColumn":{"type":"boolean"}}}}},"Scq":{"type":"list","member":{}},"Scs":{"type":"list","member":{"shape":"Sct"}},"Sct":{"type":"structure","required":["ColumnName","ColumnType","AnalyzedTime","StatisticsData"],"members":{"ColumnName":{},"ColumnType":{},"AnalyzedTime":{"type":"timestamp"},"StatisticsData":{"type":"structure","required":["Type"],"members":{"Type":{},"BooleanColumnStatisticsData":{"type":"structure","required":["NumberOfTrues","NumberOfFalses","NumberOfNulls"],"members":{"NumberOfTrues":{"type":"long"},"NumberOfFalses":{"type":"long"},"NumberOfNulls":{"type":"long"}}},"DateColumnStatisticsData":{"type":"structure","required":["NumberOfNulls","NumberOfDistinctValues"],"members":{"MinimumValue":{"type":"timestamp"},"MaximumValue":{"type":"timestamp"},"NumberOfNulls":{"type":"long"},"NumberOfDistinctValues":{"type":"long"}}},"DecimalColumnStatisticsData":{"type":"structure","required":["NumberOfNulls","NumberOfDistinctValues"],"members":{"MinimumValue":{"shape":"Sd1"},"MaximumValue":{"shape":"Sd1"},"NumberOfNulls":{"type":"long"},"NumberOfDistinctValues":{"type":"long"}}},"DoubleColumnStatisticsData":{"type":"structure","required":["NumberOfNulls","NumberOfDistinctValues"],"members":{"MinimumValue":{"type":"double"},"MaximumValue":{"type":"double"},"NumberOfNulls":{"type":"long"},"NumberOfDistinctValues":{"type":"long"}}},"LongColumnStatisticsData":{"type":"structure","required":["NumberOfNulls","NumberOfDistinctValues"],"members":{"MinimumValue":{"type":"long"},"MaximumValue":{"type":"long"},"NumberOfNulls":{"type":"long"},"NumberOfDistinctValues":{"type":"long"}}},"StringColumnStatisticsData":{"type":"structure","required":["MaximumLength","AverageLength","NumberOfNulls","NumberOfDistinctValues"],"members":{"MaximumLength":{"type":"long"},"AverageLength":{"type":"double"},"NumberOfNulls":{"type":"long"},"NumberOfDistinctValues":{"type":"long"}}},"BinaryColumnStatisticsData":{"type":"structure","required":["MaximumLength","AverageLength","NumberOfNulls"],"members":{"MaximumLength":{"type":"long"},"AverageLength":{"type":"double"},"NumberOfNulls":{"type":"long"}}}}}}},"Sd1":{"type":"structure","required":["UnscaledValue","Scale"],"members":{"UnscaledValue":{"type":"blob"},"Scale":{"type":"integer"}}},"Sda":{"type":"list","member":{"type":"structure","members":{"ColumnName":{},"Error":{"shape":"S14"}}}},"Sdg":{"type":"structure","members":{"Name":{},"Description":{},"ConnectionType":{},"MatchCriteria":{"shape":"S7g"},"ConnectionProperties":{"shape":"S7h"},"PhysicalConnectionRequirements":{"shape":"S7j"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"LastUpdatedBy":{}}},"Sdx":{"type":"structure","members":{"EncryptionAtRest":{"type":"structure","required":["CatalogEncryptionMode"],"members":{"CatalogEncryptionMode":{},"SseAwsKmsKeyId":{}}},"ConnectionPasswordEncryption":{"type":"structure","required":["ReturnConnectionPasswordEncrypted"],"members":{"ReturnConnectionPasswordEncrypted":{"type":"boolean"},"AwsKmsKeyId":{}}}}},"Se3":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"LocationUri":{},"Parameters":{"shape":"Se"},"CreateTime":{"type":"timestamp"},"CreateTableDefaultPermissions":{"shape":"S7t"},"TargetDatabase":{"shape":"S7z"},"CatalogId":{}}},"Sel":{"type":"structure","members":{"JobName":{},"Version":{"type":"integer"},"Run":{"type":"integer"},"Attempt":{"type":"integer"},"PreviousRunId":{},"RunId":{},"JobBookmark":{}}},"Sev":{"type":"structure","members":{"TaskType":{},"ImportLabelsTaskRunProperties":{"type":"structure","members":{"InputS3Path":{},"Replace":{"type":"boolean"}}},"ExportLabelsTaskRunProperties":{"type":"structure","members":{"OutputS3Path":{}}},"LabelingSetGenerationTaskRunProperties":{"type":"structure","members":{"OutputS3Path":{}}},"FindMatchesTaskRunProperties":{"type":"structure","members":{"JobId":{},"JobName":{},"JobRunId":{}}}}},"Sfe":{"type":"structure","required":["TransformType"],"members":{"TransformType":{},"FindMatchesMetrics":{"type":"structure","members":{"AreaUnderPRCurve":{"type":"double"},"Precision":{"type":"double"},"Recall":{"type":"double"},"F1":{"type":"double"},"ConfusionMatrix":{"type":"structure","members":{"NumTruePositives":{"type":"long"},"NumFalsePositives":{"type":"long"},"NumTrueNegatives":{"type":"long"},"NumFalseNegatives":{"type":"long"}}},"ColumnImportances":{"type":"list","member":{"type":"structure","members":{"ColumnName":{},"Importance":{"type":"double"}}}}}}}},"Sfl":{"type":"list","member":{"type":"structure","members":{"Name":{},"DataType":{}}}},"Sfo":{"type":"structure","members":{"Name":{},"TransformType":{},"Status":{},"GlueVersion":{},"CreatedBefore":{"type":"timestamp"},"CreatedAfter":{"type":"timestamp"},"LastModifiedBefore":{"type":"timestamp"},"LastModifiedAfter":{"type":"timestamp"},"Schema":{"shape":"Sfl"}}},"Sfp":{"type":"structure","required":["Column","SortDirection"],"members":{"Column":{},"SortDirection":{}}},"Sfv":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{}}},"Sfw":{"type":"list","member":{"shape":"Sfv"}},"Sfx":{"type":"structure","members":{"Jdbc":{"shape":"S91"},"S3":{"shape":"S91"},"DynamoDB":{"shape":"S91"}}},"Sfz":{"type":"list","member":{"type":"structure","members":{"SourceTable":{},"SourcePath":{},"SourceType":{},"TargetTable":{},"TargetPath":{},"TargetType":{}}}},"Sgj":{"type":"structure","required":["SegmentNumber","TotalSegments"],"members":{"SegmentNumber":{"type":"integer"},"TotalSegments":{"type":"integer"}}},"Sh6":{"type":"structure","members":{"LatestVersion":{"type":"boolean"},"VersionNumber":{"type":"long"}}},"Shf":{"type":"structure","members":{"Name":{},"CreatedTimeStamp":{"type":"timestamp"},"EncryptionConfiguration":{"shape":"S9c"}}},"Shn":{"type":"structure","members":{"Id":{"type":"integer"},"Code":{},"State":{},"Output":{"type":"structure","members":{"Data":{"type":"structure","members":{"TextPlain":{}}},"ExecutionCount":{"type":"integer"},"Status":{},"ErrorName":{},"ErrorValue":{},"Traceback":{"shape":"S4g"}}},"Progress":{"type":"double"},"StartedOn":{"type":"long"},"CompletedOn":{"type":"long"}}},"Shu":{"type":"structure","required":["Name"],"members":{"Name":{},"DatabaseName":{},"Description":{},"Owner":{},"CreateTime":{"type":"timestamp"},"UpdateTime":{"type":"timestamp"},"LastAccessTime":{"type":"timestamp"},"LastAnalyzedTime":{"type":"timestamp"},"Retention":{"type":"integer"},"StorageDescriptor":{"shape":"S9"},"PartitionKeys":{"shape":"Sa"},"ViewOriginalText":{},"ViewExpandedText":{},"TableType":{},"Parameters":{"shape":"Se"},"CreatedBy":{},"IsRegisteredWithLakeFormation":{"type":"boolean"},"TargetTable":{"shape":"Sa0"},"CatalogId":{},"VersionId":{}}},"Shx":{"type":"structure","members":{"Table":{"shape":"Shu"},"VersionId":{}}},"Si4":{"type":"list","member":{"shape":"Shu"}},"Sic":{"type":"structure","members":{"AdditionalAuditContext":{},"RequestedColumns":{"type":"list","member":{}},"AllColumnsRequested":{"type":"boolean"}}},"Sif":{"type":"list","member":{}},"Sis":{"type":"structure","members":{"FunctionName":{},"DatabaseName":{},"ClassName":{},"OwnerName":{},"OwnerType":{},"CreateTime":{"type":"timestamp"},"ResourceUris":{"shape":"Sa9"},"CatalogId":{}}},"Ski":{"type":"structure","members":{"MetadataKey":{},"MetadataValue":{}}},"Sl3":{"type":"list","member":{}},"Smo":{"type":"list","member":{"shape":"Sct"}},"Smq":{"type":"list","member":{"type":"structure","members":{"ColumnStatistics":{"shape":"Sct"},"Error":{"shape":"S14"}}}}}}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetBlueprintRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetClassifiers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetCrawlerMetrics":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetCrawlers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetDatabases":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetDevEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetJobRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMLTaskRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMLTransforms":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPartitionIndexes":{"input_token":"NextToken","output_token":"NextToken","result_key":"PartitionIndexDescriptorList"},"GetPartitions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetResourcePolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"GetResourcePoliciesResponseList"},"GetSecurityConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityConfigurations"},"GetTableVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTriggers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetUnfilteredPartitionsMetadata":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetUserDefinedFunctions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetWorkflowRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListBlueprints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCrawlers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCustomEntityTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDevEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListMLTransforms":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListRegistries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Registries"},"ListSchemaVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Schemas"},"ListSchemas":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Schemas"},"ListSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTriggers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListWorkflows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"SearchTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mobile'] = {};
	AWS.Mobile = Service.defineService('mobile', ['2017-07-01']);
	Object.defineProperty(apiLoader.services['mobile'], '2017-07-01', {
	  get: function get() {
	    var model = __webpack_require__(518);
	    model.paginators = __webpack_require__(519).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Mobile;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"mobile","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Mobile","serviceId":"Mobile","signatureVersion":"v4","signingName":"AWSMobileHubService","uid":"mobile-2017-07-01"},"operations":{"CreateProject":{"http":{"requestUri":"/projects"},"input":{"type":"structure","members":{"name":{"location":"querystring","locationName":"name"},"region":{"location":"querystring","locationName":"region"},"contents":{"type":"blob"},"snapshotId":{"location":"querystring","locationName":"snapshotId"}},"payload":"contents"},"output":{"type":"structure","members":{"details":{"shape":"S7"}}}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{projectId}"},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"}}},"output":{"type":"structure","members":{"deletedResources":{"shape":"Sc"},"orphanedResources":{"shape":"Sc"}}}},"DescribeBundle":{"http":{"method":"GET","requestUri":"/bundles/{bundleId}"},"input":{"type":"structure","required":["bundleId"],"members":{"bundleId":{"location":"uri","locationName":"bundleId"}}},"output":{"type":"structure","members":{"details":{"shape":"Sq"}}}},"DescribeProject":{"http":{"method":"GET","requestUri":"/project"},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"querystring","locationName":"projectId"},"syncFromResources":{"location":"querystring","locationName":"syncFromResources","type":"boolean"}}},"output":{"type":"structure","members":{"details":{"shape":"S7"}}}},"ExportBundle":{"http":{"requestUri":"/bundles/{bundleId}"},"input":{"type":"structure","required":["bundleId"],"members":{"bundleId":{"location":"uri","locationName":"bundleId"},"projectId":{"location":"querystring","locationName":"projectId"},"platform":{"location":"querystring","locationName":"platform"}}},"output":{"type":"structure","members":{"downloadUrl":{}}}},"ExportProject":{"http":{"requestUri":"/exports/{projectId}"},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"}}},"output":{"type":"structure","members":{"downloadUrl":{},"shareUrl":{},"snapshotId":{}}}},"ListBundles":{"http":{"method":"GET","requestUri":"/bundles"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"bundleList":{"type":"list","member":{"shape":"Sq"}},"nextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"type":"structure","members":{"name":{},"projectId":{}}}},"nextToken":{}}}},"UpdateProject":{"http":{"requestUri":"/update"},"input":{"type":"structure","required":["projectId"],"members":{"contents":{"type":"blob"},"projectId":{"location":"querystring","locationName":"projectId"}},"payload":"contents"},"output":{"type":"structure","members":{"details":{"shape":"S7"}}}}},"shapes":{"S7":{"type":"structure","members":{"name":{},"projectId":{},"region":{},"state":{},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"consoleUrl":{},"resources":{"shape":"Sc"}}},"Sc":{"type":"list","member":{"type":"structure","members":{"type":{},"name":{},"arn":{},"feature":{},"attributes":{"type":"map","key":{},"value":{}}}}},"Sq":{"type":"structure","members":{"bundleId":{},"title":{},"version":{},"description":{},"iconUrl":{},"availablePlatforms":{"type":"list","member":{}}}}}}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBundles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['pricing'] = {};
	AWS.Pricing = Service.defineService('pricing', ['2017-10-15']);
	Object.defineProperty(apiLoader.services['pricing'], '2017-10-15', {
	  get: function get() {
	    var model = __webpack_require__(521);
	    model.paginators = __webpack_require__(522).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Pricing;


/***/ }),
/* 521 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-15","endpointPrefix":"api.pricing","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Pricing","serviceFullName":"AWS Price List Service","serviceId":"Pricing","signatureVersion":"v4","signingName":"pricing","targetPrefix":"AWSPriceListService","uid":"pricing-2017-10-15"},"operations":{"DescribeServices":{"input":{"type":"structure","members":{"ServiceCode":{},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"ServiceCode":{},"AttributeNames":{"type":"list","member":{}}}}},"FormatVersion":{},"NextToken":{}}}},"GetAttributeValues":{"input":{"type":"structure","required":["ServiceCode","AttributeName"],"members":{"ServiceCode":{},"AttributeName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AttributeValues":{"type":"list","member":{"type":"structure","members":{"Value":{}}}},"NextToken":{}}}},"GetProducts":{"input":{"type":"structure","members":{"ServiceCode":{},"Filters":{"type":"list","member":{"type":"structure","required":["Type","Field","Value"],"members":{"Type":{},"Field":{},"Value":{}}}},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FormatVersion":{},"PriceList":{"type":"list","member":{"jsonvalue":true}},"NextToken":{}}}}},"shapes":{}}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetAttributeValues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['costexplorer'] = {};
	AWS.CostExplorer = Service.defineService('costexplorer', ['2017-10-25']);
	Object.defineProperty(apiLoader.services['costexplorer'], '2017-10-25', {
	  get: function get() {
	    var model = __webpack_require__(524);
	    model.paginators = __webpack_require__(525).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CostExplorer;


/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-25","endpointPrefix":"ce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Cost Explorer","serviceFullName":"AWS Cost Explorer Service","serviceId":"Cost Explorer","signatureVersion":"v4","signingName":"ce","targetPrefix":"AWSInsightsIndexService","uid":"ce-2017-10-25"},"operations":{"CreateAnomalyMonitor":{"input":{"type":"structure","required":["AnomalyMonitor"],"members":{"AnomalyMonitor":{"shape":"S2"},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}}},"CreateAnomalySubscription":{"input":{"type":"structure","required":["AnomalySubscription"],"members":{"AnomalySubscription":{"shape":"Sq"},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"CreateCostCategoryDefinition":{"input":{"type":"structure","required":["Name","RuleVersion","Rules"],"members":{"Name":{},"RuleVersion":{},"Rules":{"shape":"S13"},"DefaultValue":{},"SplitChargeRules":{"shape":"S19"},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveStart":{}}}},"DeleteAnomalyMonitor":{"input":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}},"output":{"type":"structure","members":{}}},"DeleteAnomalySubscription":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"type":"structure","members":{}}},"DeleteCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn"],"members":{"CostCategoryArn":{}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveEnd":{}}}},"DescribeCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn"],"members":{"CostCategoryArn":{},"EffectiveOn":{}}},"output":{"type":"structure","members":{"CostCategory":{"type":"structure","required":["CostCategoryArn","EffectiveStart","Name","RuleVersion","Rules"],"members":{"CostCategoryArn":{},"EffectiveStart":{},"EffectiveEnd":{},"Name":{},"RuleVersion":{},"Rules":{"shape":"S13"},"SplitChargeRules":{"shape":"S19"},"ProcessingStatus":{"shape":"S1s"},"DefaultValue":{}}}}}},"GetAnomalies":{"input":{"type":"structure","required":["DateInterval"],"members":{"MonitorArn":{},"DateInterval":{"type":"structure","required":["StartDate"],"members":{"StartDate":{},"EndDate":{}}},"Feedback":{},"TotalImpact":{"type":"structure","required":["NumericOperator","StartValue"],"members":{"NumericOperator":{},"StartValue":{"type":"double"},"EndValue":{"type":"double"}}},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Anomalies"],"members":{"Anomalies":{"type":"list","member":{"type":"structure","required":["AnomalyId","AnomalyScore","Impact","MonitorArn"],"members":{"AnomalyId":{},"AnomalyStartDate":{},"AnomalyEndDate":{},"DimensionValue":{},"RootCauses":{"type":"list","member":{"type":"structure","members":{"Service":{},"Region":{},"LinkedAccount":{},"UsageType":{}}}},"AnomalyScore":{"type":"structure","required":["MaxScore","CurrentScore"],"members":{"MaxScore":{"type":"double"},"CurrentScore":{"type":"double"}}},"Impact":{"type":"structure","required":["MaxImpact"],"members":{"MaxImpact":{"type":"double"},"TotalImpact":{"type":"double"}}},"MonitorArn":{},"Feedback":{}}}},"NextPageToken":{}}}},"GetAnomalyMonitors":{"input":{"type":"structure","members":{"MonitorArnList":{"shape":"Sb"},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["AnomalyMonitors"],"members":{"AnomalyMonitors":{"type":"list","member":{"shape":"S2"}},"NextPageToken":{}}}},"GetAnomalySubscriptions":{"input":{"type":"structure","members":{"SubscriptionArnList":{"shape":"Sb"},"MonitorArn":{},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["AnomalySubscriptions"],"members":{"AnomalySubscriptions":{"type":"list","member":{"shape":"Sq"}},"NextPageToken":{}}}},"GetCostAndUsage":{"input":{"type":"structure","required":["TimePeriod","Granularity","Metrics"],"members":{"TimePeriod":{"shape":"S2i"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2k"},"GroupBy":{"shape":"S2m"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"S2m"},"ResultsByTime":{"shape":"S2r"},"DimensionValueAttributes":{"shape":"S32"}}}},"GetCostAndUsageWithResources":{"input":{"type":"structure","required":["TimePeriod","Granularity","Filter"],"members":{"TimePeriod":{"shape":"S2i"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2k"},"GroupBy":{"shape":"S2m"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"S2m"},"ResultsByTime":{"shape":"S2r"},"DimensionValueAttributes":{"shape":"S32"}}}},"GetCostCategories":{"input":{"type":"structure","required":["TimePeriod"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2i"},"CostCategoryName":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3b"},"MaxResults":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","required":["ReturnSize","TotalSize"],"members":{"NextPageToken":{},"CostCategoryNames":{"type":"list","member":{}},"CostCategoryValues":{"shape":"S3i"},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"}}}},"GetCostForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"S2i"},"Metric":{},"Granularity":{},"Filter":{"shape":"S7"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"S2u"},"ForecastResultsByTime":{"shape":"S3n"}}}},"GetDimensionValues":{"input":{"type":"structure","required":["TimePeriod","Dimension"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2i"},"Dimension":{},"Context":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3b"},"MaxResults":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","required":["DimensionValues","ReturnSize","TotalSize"],"members":{"DimensionValues":{"shape":"S32"},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"},"NextPageToken":{}}}},"GetReservationCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2i"},"GroupBy":{"shape":"S2m"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2k"},"NextPageToken":{},"SortBy":{"shape":"S3c"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["CoveragesByTime"],"members":{"CoveragesByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2i"},"Groups":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S34"},"Coverage":{"shape":"S3y"}}}},"Total":{"shape":"S3y"}}}},"Total":{"shape":"S3y"},"NextPageToken":{}}}},"GetReservationPurchaseRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"AccountId":{},"Service":{},"Filter":{"shape":"S7"},"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S4g"},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{}}},"Recommendations":{"type":"list","member":{"type":"structure","members":{"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S4g"},"RecommendationDetails":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"InstanceDetails":{"type":"structure","members":{"EC2InstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"AvailabilityZone":{},"Platform":{},"Tenancy":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RDSInstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"DatabaseEngine":{},"DatabaseEdition":{},"DeploymentOption":{},"LicenseModel":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RedshiftInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ElastiCacheInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"ProductDescription":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ESInstanceDetails":{"type":"structure","members":{"InstanceClass":{},"InstanceSize":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}}}},"RecommendedNumberOfInstancesToPurchase":{},"RecommendedNormalizedUnitsToPurchase":{},"MinimumNumberOfInstancesUsedPerHour":{},"MinimumNormalizedUnitsUsedPerHour":{},"MaximumNumberOfInstancesUsedPerHour":{},"MaximumNormalizedUnitsUsedPerHour":{},"AverageNumberOfInstancesUsedPerHour":{},"AverageNormalizedUnitsUsedPerHour":{},"AverageUtilization":{},"EstimatedBreakEvenInMonths":{},"CurrencyCode":{},"EstimatedMonthlySavingsAmount":{},"EstimatedMonthlySavingsPercentage":{},"EstimatedMonthlyOnDemandCost":{},"EstimatedReservationCostForLookbackPeriod":{},"UpfrontCost":{},"RecurringStandardMonthlyCost":{}}}},"RecommendationSummary":{"type":"structure","members":{"TotalEstimatedMonthlySavingsAmount":{},"TotalEstimatedMonthlySavingsPercentage":{},"CurrencyCode":{}}}}}},"NextPageToken":{}}}},"GetReservationUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2i"},"GroupBy":{"shape":"S2m"},"Granularity":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3c"},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["UtilizationsByTime"],"members":{"UtilizationsByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2i"},"Groups":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Attributes":{"shape":"S34"},"Utilization":{"shape":"S55"}}}},"Total":{"shape":"S55"}}}},"Total":{"shape":"S55"},"NextPageToken":{}}}},"GetRightsizingRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"Filter":{"shape":"S7"},"Configuration":{"shape":"S5o"},"Service":{},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"LookbackPeriodInDays":{},"AdditionalMetadata":{}}},"Summary":{"type":"structure","members":{"TotalRecommendationCount":{},"EstimatedTotalMonthlySavingsAmount":{},"SavingsCurrencyCode":{},"SavingsPercentage":{}}},"RightsizingRecommendations":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"CurrentInstance":{"type":"structure","members":{"ResourceId":{},"InstanceName":{},"Tags":{"type":"list","member":{"shape":"Sf"}},"ResourceDetails":{"shape":"S5x"},"ResourceUtilization":{"shape":"S5z"},"ReservationCoveredHoursInLookbackPeriod":{},"SavingsPlansCoveredHoursInLookbackPeriod":{},"OnDemandHoursInLookbackPeriod":{},"TotalRunningHoursInLookbackPeriod":{},"MonthlyCost":{},"CurrencyCode":{}}},"RightsizingType":{},"ModifyRecommendationDetail":{"type":"structure","members":{"TargetInstances":{"type":"list","member":{"type":"structure","members":{"EstimatedMonthlyCost":{},"EstimatedMonthlySavings":{},"CurrencyCode":{},"DefaultTargetInstance":{"type":"boolean"},"ResourceDetails":{"shape":"S5x"},"ExpectedResourceUtilization":{"shape":"S5z"},"PlatformDifferences":{"type":"list","member":{}}}}}}},"TerminateRecommendationDetail":{"type":"structure","members":{"EstimatedMonthlySavings":{},"CurrencyCode":{}}},"FindingReasonCodes":{"type":"list","member":{}}}}},"NextPageToken":{},"Configuration":{"shape":"S5o"}}}},"GetSavingsPlansCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2i"},"GroupBy":{"shape":"S2m"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2k"},"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{"shape":"S3c"}}},"output":{"type":"structure","required":["SavingsPlansCoverages"],"members":{"SavingsPlansCoverages":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S34"},"Coverage":{"type":"structure","members":{"SpendCoveredBySavingsPlans":{},"OnDemandCost":{},"TotalCost":{},"CoveragePercentage":{}}},"TimePeriod":{"shape":"S2i"}}}},"NextToken":{}}}},"GetSavingsPlansPurchaseRecommendation":{"input":{"type":"structure","required":["SavingsPlansType","TermInYears","PaymentOption","LookbackPeriodInDays"],"members":{"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"AccountScope":{},"NextPageToken":{},"PageSize":{"type":"integer"},"LookbackPeriodInDays":{},"Filter":{"shape":"S7"}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"AdditionalMetadata":{}}},"SavingsPlansPurchaseRecommendation":{"type":"structure","members":{"AccountScope":{},"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"LookbackPeriodInDays":{},"SavingsPlansPurchaseRecommendationDetails":{"type":"list","member":{"type":"structure","members":{"SavingsPlansDetails":{"type":"structure","members":{"Region":{},"InstanceFamily":{},"OfferingId":{}}},"AccountId":{},"UpfrontCost":{},"EstimatedROI":{},"CurrencyCode":{},"EstimatedSPCost":{},"EstimatedOnDemandCost":{},"EstimatedOnDemandCostWithCurrentCommitment":{},"EstimatedSavingsAmount":{},"EstimatedSavingsPercentage":{},"HourlyCommitmentToPurchase":{},"EstimatedAverageUtilization":{},"EstimatedMonthlySavingsAmount":{},"CurrentMinimumHourlyOnDemandSpend":{},"CurrentMaximumHourlyOnDemandSpend":{},"CurrentAverageHourlyOnDemandSpend":{}}}},"SavingsPlansPurchaseRecommendationSummary":{"type":"structure","members":{"EstimatedROI":{},"CurrencyCode":{},"EstimatedTotalCost":{},"CurrentOnDemandSpend":{},"EstimatedSavingsAmount":{},"TotalRecommendationCount":{},"DailyCommitmentToPurchase":{},"HourlyCommitmentToPurchase":{},"EstimatedSavingsPercentage":{},"EstimatedMonthlySavingsAmount":{},"EstimatedOnDemandCostWithCurrentCommitment":{}}}}},"NextPageToken":{}}}},"GetSavingsPlansUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2i"},"Granularity":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3c"}}},"output":{"type":"structure","required":["Total"],"members":{"SavingsPlansUtilizationsByTime":{"type":"list","member":{"type":"structure","required":["TimePeriod","Utilization"],"members":{"TimePeriod":{"shape":"S2i"},"Utilization":{"shape":"S6v"},"Savings":{"shape":"S6w"},"AmortizedCommitment":{"shape":"S6x"}}}},"Total":{"shape":"S6y"}}}},"GetSavingsPlansUtilizationDetails":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2i"},"Filter":{"shape":"S7"},"DataType":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{"shape":"S3c"}}},"output":{"type":"structure","required":["SavingsPlansUtilizationDetails","TimePeriod"],"members":{"SavingsPlansUtilizationDetails":{"type":"list","member":{"type":"structure","members":{"SavingsPlanArn":{},"Attributes":{"shape":"S34"},"Utilization":{"shape":"S6v"},"Savings":{"shape":"S6w"},"AmortizedCommitment":{"shape":"S6x"}}}},"Total":{"shape":"S6y"},"TimePeriod":{"shape":"S2i"},"NextToken":{}}}},"GetTags":{"input":{"type":"structure","required":["TimePeriod"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2i"},"TagKey":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3b"},"MaxResults":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","required":["Tags","ReturnSize","TotalSize"],"members":{"NextPageToken":{},"Tags":{"type":"list","member":{}},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"}}}},"GetUsageForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"S2i"},"Metric":{},"Granularity":{},"Filter":{"shape":"S7"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"S2u"},"ForecastResultsByTime":{"shape":"S3n"}}}},"ListCostCategoryDefinitions":{"input":{"type":"structure","members":{"EffectiveOn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CostCategoryReferences":{"type":"list","member":{"type":"structure","members":{"CostCategoryArn":{},"Name":{},"EffectiveStart":{},"EffectiveEnd":{},"NumberOfRules":{"type":"integer"},"ProcessingStatus":{"shape":"S1s"},"Values":{"shape":"S3i"},"DefaultValue":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceTags":{"shape":"Sk"}}}},"ProvideAnomalyFeedback":{"input":{"type":"structure","required":["AnomalyId","Feedback"],"members":{"AnomalyId":{},"Feedback":{}}},"output":{"type":"structure","required":["AnomalyId"],"members":{"AnomalyId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","ResourceTags"],"members":{"ResourceArn":{},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","ResourceTagKeys"],"members":{"ResourceArn":{},"ResourceTagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAnomalyMonitor":{"input":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{},"MonitorName":{}}},"output":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}}},"UpdateAnomalySubscription":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{},"Threshold":{"type":"double"},"Frequency":{},"MonitorArnList":{"shape":"Sr"},"Subscribers":{"shape":"St"},"SubscriptionName":{}}},"output":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"UpdateCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn","RuleVersion","Rules"],"members":{"CostCategoryArn":{},"RuleVersion":{},"Rules":{"shape":"S13"},"DefaultValue":{},"SplitChargeRules":{"shape":"S19"}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveStart":{}}}}},"shapes":{"S2":{"type":"structure","required":["MonitorName","MonitorType"],"members":{"MonitorArn":{},"MonitorName":{},"CreationDate":{},"LastUpdatedDate":{},"LastEvaluatedDate":{},"MonitorType":{},"MonitorDimension":{},"MonitorSpecification":{"shape":"S7"},"DimensionalValueCount":{"type":"integer"}}},"S7":{"type":"structure","members":{"Or":{"shape":"S8"},"And":{"shape":"S8"},"Not":{"shape":"S7"},"Dimensions":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}},"Tags":{"shape":"Sf"},"CostCategories":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}}}},"S8":{"type":"list","member":{"shape":"S7"}},"Sb":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}},"Sk":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sq":{"type":"structure","required":["MonitorArnList","Subscribers","Threshold","Frequency","SubscriptionName"],"members":{"SubscriptionArn":{},"AccountId":{},"MonitorArnList":{"shape":"Sr"},"Subscribers":{"shape":"St"},"Threshold":{"type":"double"},"Frequency":{},"SubscriptionName":{}}},"Sr":{"type":"list","member":{}},"St":{"type":"list","member":{"type":"structure","members":{"Address":{},"Type":{},"Status":{}}}},"S13":{"type":"list","member":{"type":"structure","members":{"Value":{},"Rule":{"shape":"S7"},"InheritedValue":{"type":"structure","members":{"DimensionName":{},"DimensionKey":{}}},"Type":{}}}},"S19":{"type":"list","member":{"type":"structure","required":["Source","Targets","Method"],"members":{"Source":{},"Targets":{"type":"list","member":{}},"Method":{},"Parameters":{"type":"list","member":{"type":"structure","required":["Type","Values"],"members":{"Type":{},"Values":{"type":"list","member":{}}}}}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"Component":{},"Status":{}}}},"S2i":{"type":"structure","required":["Start","End"],"members":{"Start":{},"End":{}}},"S2k":{"type":"list","member":{}},"S2m":{"type":"list","member":{"type":"structure","members":{"Type":{},"Key":{}}}},"S2r":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2i"},"Total":{"shape":"S2t"},"Groups":{"type":"list","member":{"type":"structure","members":{"Keys":{"type":"list","member":{}},"Metrics":{"shape":"S2t"}}}},"Estimated":{"type":"boolean"}}}},"S2t":{"type":"map","key":{},"value":{"shape":"S2u"}},"S2u":{"type":"structure","members":{"Amount":{},"Unit":{}}},"S32":{"type":"list","member":{"type":"structure","members":{"Value":{},"Attributes":{"shape":"S34"}}}},"S34":{"type":"map","key":{},"value":{}},"S3b":{"type":"list","member":{"shape":"S3c"}},"S3c":{"type":"structure","required":["Key"],"members":{"Key":{},"SortOrder":{}}},"S3i":{"type":"list","member":{}},"S3n":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2i"},"MeanValue":{},"PredictionIntervalLowerBound":{},"PredictionIntervalUpperBound":{}}}},"S3y":{"type":"structure","members":{"CoverageHours":{"type":"structure","members":{"OnDemandHours":{},"ReservedHours":{},"TotalRunningHours":{},"CoverageHoursPercentage":{}}},"CoverageNormalizedUnits":{"type":"structure","members":{"OnDemandNormalizedUnits":{},"ReservedNormalizedUnits":{},"TotalRunningNormalizedUnits":{},"CoverageNormalizedUnitsPercentage":{}}},"CoverageCost":{"type":"structure","members":{"OnDemandCost":{}}}}},"S4g":{"type":"structure","members":{"EC2Specification":{"type":"structure","members":{"OfferingClass":{}}}}},"S55":{"type":"structure","members":{"UtilizationPercentage":{},"UtilizationPercentageInUnits":{},"PurchasedHours":{},"PurchasedUnits":{},"TotalActualHours":{},"TotalActualUnits":{},"UnusedHours":{},"UnusedUnits":{},"OnDemandCostOfRIHoursUsed":{},"NetRISavings":{},"TotalPotentialRISavings":{},"AmortizedUpfrontFee":{},"AmortizedRecurringFee":{},"TotalAmortizedFee":{},"RICostForUnusedHours":{},"RealizedSavings":{},"UnrealizedSavings":{}}},"S5o":{"type":"structure","required":["RecommendationTarget","BenefitsConsidered"],"members":{"RecommendationTarget":{},"BenefitsConsidered":{"type":"boolean"}}},"S5x":{"type":"structure","members":{"EC2ResourceDetails":{"type":"structure","members":{"HourlyOnDemandRate":{},"InstanceType":{},"Platform":{},"Region":{},"Sku":{},"Memory":{},"NetworkPerformance":{},"Storage":{},"Vcpu":{}}}}},"S5z":{"type":"structure","members":{"EC2ResourceUtilization":{"type":"structure","members":{"MaxCpuUtilizationPercentage":{},"MaxMemoryUtilizationPercentage":{},"MaxStorageUtilizationPercentage":{},"EBSResourceUtilization":{"type":"structure","members":{"EbsReadOpsPerSecond":{},"EbsWriteOpsPerSecond":{},"EbsReadBytesPerSecond":{},"EbsWriteBytesPerSecond":{}}},"DiskResourceUtilization":{"type":"structure","members":{"DiskReadOpsPerSecond":{},"DiskWriteOpsPerSecond":{},"DiskReadBytesPerSecond":{},"DiskWriteBytesPerSecond":{}}},"NetworkResourceUtilization":{"type":"structure","members":{"NetworkInBytesPerSecond":{},"NetworkOutBytesPerSecond":{},"NetworkPacketsInPerSecond":{},"NetworkPacketsOutPerSecond":{}}}}}}},"S6v":{"type":"structure","members":{"TotalCommitment":{},"UsedCommitment":{},"UnusedCommitment":{},"UtilizationPercentage":{}}},"S6w":{"type":"structure","members":{"NetSavings":{},"OnDemandCostEquivalent":{}}},"S6x":{"type":"structure","members":{"AmortizedRecurringCommitment":{},"AmortizedUpfrontCommitment":{},"TotalAmortizedCommitment":{}}},"S6y":{"type":"structure","required":["Utilization"],"members":{"Utilization":{"shape":"S6v"},"Savings":{"shape":"S6w"},"AmortizedCommitment":{"shape":"S6x"}}}}}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetSavingsPlansCoverage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetSavingsPlansUtilizationDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCostCategoryDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediaconvert'] = {};
	AWS.MediaConvert = Service.defineService('mediaconvert', ['2017-08-29']);
	Object.defineProperty(apiLoader.services['mediaconvert'], '2017-08-29', {
	  get: function get() {
	    var model = __webpack_require__(527);
	    model.paginators = __webpack_require__(528).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaConvert;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-08-29","endpointPrefix":"mediaconvert","signingName":"mediaconvert","serviceFullName":"AWS Elemental MediaConvert","serviceId":"MediaConvert","protocol":"rest-json","jsonVersion":"1.1","uid":"mediaconvert-2017-08-29","signatureVersion":"v4","serviceAbbreviation":"MediaConvert"},"operations":{"AssociateCertificate":{"http":{"requestUri":"/2017-08-29/certificates","responseCode":201},"input":{"type":"structure","members":{"Arn":{"locationName":"arn"}},"required":["Arn"]},"output":{"type":"structure","members":{}}},"CancelJob":{"http":{"method":"DELETE","requestUri":"/2017-08-29/jobs/{id}","responseCode":202},"input":{"type":"structure","members":{"Id":{"locationName":"id","location":"uri"}},"required":["Id"]},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2017-08-29/jobs","responseCode":201},"input":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"BillingTagsSource":{"locationName":"billingTagsSource"},"ClientRequestToken":{"locationName":"clientRequestToken","idempotencyToken":true},"HopDestinations":{"shape":"Sa","locationName":"hopDestinations"},"JobTemplate":{"locationName":"jobTemplate"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Role":{"locationName":"role"},"Settings":{"shape":"Se","locationName":"settings"},"SimulateReservedQueue":{"locationName":"simulateReservedQueue"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Tags":{"shape":"Sjh","locationName":"tags"},"UserMetadata":{"shape":"Sjh","locationName":"userMetadata"}},"required":["Role","Settings"]},"output":{"type":"structure","members":{"Job":{"shape":"Sjj","locationName":"job"}}}},"CreateJobTemplate":{"http":{"requestUri":"/2017-08-29/jobTemplates","responseCode":201},"input":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Category":{"locationName":"category"},"Description":{"locationName":"description"},"HopDestinations":{"shape":"Sa","locationName":"hopDestinations"},"Name":{"locationName":"name"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Settings":{"shape":"Sjz","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Tags":{"shape":"Sjh","locationName":"tags"}},"required":["Settings","Name"]},"output":{"type":"structure","members":{"JobTemplate":{"shape":"Sk3","locationName":"jobTemplate"}}}},"CreatePreset":{"http":{"requestUri":"/2017-08-29/presets","responseCode":201},"input":{"type":"structure","members":{"Category":{"locationName":"category"},"Description":{"locationName":"description"},"Name":{"locationName":"name"},"Settings":{"shape":"Sk6","locationName":"settings"},"Tags":{"shape":"Sjh","locationName":"tags"}},"required":["Settings","Name"]},"output":{"type":"structure","members":{"Preset":{"shape":"Ska","locationName":"preset"}}}},"CreateQueue":{"http":{"requestUri":"/2017-08-29/queues","responseCode":201},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"Name":{"locationName":"name"},"PricingPlan":{"locationName":"pricingPlan"},"ReservationPlanSettings":{"shape":"Skd","locationName":"reservationPlanSettings"},"Status":{"locationName":"status"},"Tags":{"shape":"Sjh","locationName":"tags"}},"required":["Name"]},"output":{"type":"structure","members":{"Queue":{"shape":"Ski","locationName":"queue"}}}},"DeleteJobTemplate":{"http":{"method":"DELETE","requestUri":"/2017-08-29/jobTemplates/{name}","responseCode":202},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{}}},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/2017-08-29/policy","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2017-08-29/presets/{name}","responseCode":202},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{}}},"DeleteQueue":{"http":{"method":"DELETE","requestUri":"/2017-08-29/queues/{name}","responseCode":202},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{}}},"DescribeEndpoints":{"http":{"requestUri":"/2017-08-29/endpoints","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"Mode":{"locationName":"mode"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Endpoints":{"locationName":"endpoints","type":"list","member":{"type":"structure","members":{"Url":{"locationName":"url"}}}},"NextToken":{"locationName":"nextToken"}}}},"DisassociateCertificate":{"http":{"method":"DELETE","requestUri":"/2017-08-29/certificates/{arn}","responseCode":202},"input":{"type":"structure","members":{"Arn":{"locationName":"arn","location":"uri"}},"required":["Arn"]},"output":{"type":"structure","members":{}}},"GetJob":{"http":{"method":"GET","requestUri":"/2017-08-29/jobs/{id}","responseCode":200},"input":{"type":"structure","members":{"Id":{"locationName":"id","location":"uri"}},"required":["Id"]},"output":{"type":"structure","members":{"Job":{"shape":"Sjj","locationName":"job"}}}},"GetJobTemplate":{"http":{"method":"GET","requestUri":"/2017-08-29/jobTemplates/{name}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{"JobTemplate":{"shape":"Sk3","locationName":"jobTemplate"}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2017-08-29/policy","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Policy":{"shape":"Sl6","locationName":"policy"}}}},"GetPreset":{"http":{"method":"GET","requestUri":"/2017-08-29/presets/{name}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{"Preset":{"shape":"Ska","locationName":"preset"}}}},"GetQueue":{"http":{"method":"GET","requestUri":"/2017-08-29/queues/{name}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{"Queue":{"shape":"Ski","locationName":"queue"}}}},"ListJobTemplates":{"http":{"method":"GET","requestUri":"/2017-08-29/jobTemplates","responseCode":200},"input":{"type":"structure","members":{"Category":{"locationName":"category","location":"querystring"},"ListBy":{"locationName":"listBy","location":"querystring"},"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"}}},"output":{"type":"structure","members":{"JobTemplates":{"locationName":"jobTemplates","type":"list","member":{"shape":"Sk3"}},"NextToken":{"locationName":"nextToken"}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/2017-08-29/jobs","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"},"Queue":{"locationName":"queue","location":"querystring"},"Status":{"locationName":"status","location":"querystring"}}},"output":{"type":"structure","members":{"Jobs":{"locationName":"jobs","type":"list","member":{"shape":"Sjj"}},"NextToken":{"locationName":"nextToken"}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2017-08-29/presets","responseCode":200},"input":{"type":"structure","members":{"Category":{"locationName":"category","location":"querystring"},"ListBy":{"locationName":"listBy","location":"querystring"},"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Presets":{"locationName":"presets","type":"list","member":{"shape":"Ska"}}}}},"ListQueues":{"http":{"method":"GET","requestUri":"/2017-08-29/queues","responseCode":200},"input":{"type":"structure","members":{"ListBy":{"locationName":"listBy","location":"querystring"},"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Queues":{"locationName":"queues","type":"list","member":{"shape":"Ski"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-08-29/tags/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"locationName":"arn","location":"uri"}},"required":["Arn"]},"output":{"type":"structure","members":{"ResourceTags":{"locationName":"resourceTags","type":"structure","members":{"Arn":{"locationName":"arn"},"Tags":{"shape":"Sjh","locationName":"tags"}}}}}},"PutPolicy":{"http":{"method":"PUT","requestUri":"/2017-08-29/policy","responseCode":200},"input":{"type":"structure","members":{"Policy":{"shape":"Sl6","locationName":"policy"}},"required":["Policy"]},"output":{"type":"structure","members":{"Policy":{"shape":"Sl6","locationName":"policy"}}}},"TagResource":{"http":{"requestUri":"/2017-08-29/tags","responseCode":200},"input":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Tags":{"shape":"Sjh","locationName":"tags"}},"required":["Arn","Tags"]},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"PUT","requestUri":"/2017-08-29/tags/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"locationName":"arn","location":"uri"},"TagKeys":{"shape":"Sjo","locationName":"tagKeys"}},"required":["Arn"]},"output":{"type":"structure","members":{}}},"UpdateJobTemplate":{"http":{"method":"PUT","requestUri":"/2017-08-29/jobTemplates/{name}","responseCode":200},"input":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Category":{"locationName":"category"},"Description":{"locationName":"description"},"HopDestinations":{"shape":"Sa","locationName":"hopDestinations"},"Name":{"locationName":"name","location":"uri"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Settings":{"shape":"Sjz","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"}},"required":["Name"]},"output":{"type":"structure","members":{"JobTemplate":{"shape":"Sk3","locationName":"jobTemplate"}}}},"UpdatePreset":{"http":{"method":"PUT","requestUri":"/2017-08-29/presets/{name}","responseCode":200},"input":{"type":"structure","members":{"Category":{"locationName":"category"},"Description":{"locationName":"description"},"Name":{"locationName":"name","location":"uri"},"Settings":{"shape":"Sk6","locationName":"settings"}},"required":["Name"]},"output":{"type":"structure","members":{"Preset":{"shape":"Ska","locationName":"preset"}}}},"UpdateQueue":{"http":{"method":"PUT","requestUri":"/2017-08-29/queues/{name}","responseCode":200},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"Name":{"locationName":"name","location":"uri"},"ReservationPlanSettings":{"shape":"Skd","locationName":"reservationPlanSettings"},"Status":{"locationName":"status"}},"required":["Name"]},"output":{"type":"structure","members":{"Queue":{"shape":"Ski","locationName":"queue"}}}}},"shapes":{"S7":{"type":"structure","members":{"Mode":{"locationName":"mode"}},"required":["Mode"]},"Sa":{"type":"list","member":{"type":"structure","members":{"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"WaitMinutes":{"locationName":"waitMinutes","type":"integer"}}}},"Se":{"type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"AvailBlanking":{"shape":"Sg","locationName":"availBlanking"},"Esam":{"shape":"Si","locationName":"esam"},"ExtendedDataServices":{"shape":"So","locationName":"extendedDataServices"},"Inputs":{"locationName":"inputs","type":"list","member":{"type":"structure","members":{"AudioSelectorGroups":{"shape":"St","locationName":"audioSelectorGroups"},"AudioSelectors":{"shape":"Sx","locationName":"audioSelectors"},"CaptionSelectors":{"shape":"S1i","locationName":"captionSelectors"},"Crop":{"shape":"S26","locationName":"crop"},"DeblockFilter":{"locationName":"deblockFilter"},"DecryptionSettings":{"locationName":"decryptionSettings","type":"structure","members":{"DecryptionMode":{"locationName":"decryptionMode"},"EncryptedDecryptionKey":{"locationName":"encryptedDecryptionKey"},"InitializationVector":{"locationName":"initializationVector"},"KmsKeyRegion":{"locationName":"kmsKeyRegion"}}},"DenoiseFilter":{"locationName":"denoiseFilter"},"DolbyVisionMetadataXml":{"locationName":"dolbyVisionMetadataXml"},"FileInput":{"locationName":"fileInput"},"FilterEnable":{"locationName":"filterEnable"},"FilterStrength":{"locationName":"filterStrength","type":"integer"},"ImageInserter":{"shape":"S2k","locationName":"imageInserter"},"InputClippings":{"shape":"S2r","locationName":"inputClippings"},"InputScanType":{"locationName":"inputScanType"},"Position":{"shape":"S26","locationName":"position"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"PsiControl":{"locationName":"psiControl"},"SupplementalImps":{"locationName":"supplementalImps","type":"list","member":{}},"TimecodeSource":{"locationName":"timecodeSource"},"TimecodeStart":{"locationName":"timecodeStart"},"VideoGenerator":{"locationName":"videoGenerator","type":"structure","members":{"Duration":{"locationName":"duration","type":"integer"}}},"VideoSelector":{"shape":"S32","locationName":"videoSelector"}}}},"KantarWatermark":{"shape":"S3d","locationName":"kantarWatermark"},"MotionImageInserter":{"shape":"S3l","locationName":"motionImageInserter"},"NielsenConfiguration":{"shape":"S3t","locationName":"nielsenConfiguration"},"NielsenNonLinearWatermark":{"shape":"S3v","locationName":"nielsenNonLinearWatermark"},"OutputGroups":{"shape":"S42","locationName":"outputGroups"},"TimecodeConfig":{"shape":"Sj9","locationName":"timecodeConfig"},"TimedMetadataInsertion":{"shape":"Sjc","locationName":"timedMetadataInsertion"}}},"Sg":{"type":"structure","members":{"AvailBlankingImage":{"locationName":"availBlankingImage"}}},"Si":{"type":"structure","members":{"ManifestConfirmConditionNotification":{"locationName":"manifestConfirmConditionNotification","type":"structure","members":{"MccXml":{"locationName":"mccXml"}}},"ResponseSignalPreroll":{"locationName":"responseSignalPreroll","type":"integer"},"SignalProcessingNotification":{"locationName":"signalProcessingNotification","type":"structure","members":{"SccXml":{"locationName":"sccXml"}}}}},"So":{"type":"structure","members":{"CopyProtectionAction":{"locationName":"copyProtectionAction"},"VchipAction":{"locationName":"vchipAction"}}},"St":{"type":"map","key":{},"value":{"type":"structure","members":{"AudioSelectorNames":{"shape":"Sv","locationName":"audioSelectorNames"}}}},"Sv":{"type":"list","member":{}},"Sx":{"type":"map","key":{},"value":{"type":"structure","members":{"CustomLanguageCode":{"locationName":"customLanguageCode"},"DefaultSelection":{"locationName":"defaultSelection"},"ExternalAudioFileInput":{"locationName":"externalAudioFileInput"},"HlsRenditionGroupSettings":{"locationName":"hlsRenditionGroupSettings","type":"structure","members":{"RenditionGroupId":{"locationName":"renditionGroupId"},"RenditionLanguageCode":{"locationName":"renditionLanguageCode"},"RenditionName":{"locationName":"renditionName"}}},"LanguageCode":{"locationName":"languageCode"},"Offset":{"locationName":"offset","type":"integer"},"Pids":{"shape":"S15","locationName":"pids"},"ProgramSelection":{"locationName":"programSelection","type":"integer"},"RemixSettings":{"shape":"S18","locationName":"remixSettings"},"SelectorType":{"locationName":"selectorType"},"Tracks":{"shape":"S15","locationName":"tracks"}}}},"S15":{"type":"list","member":{"type":"integer"}},"S18":{"type":"structure","members":{"ChannelMapping":{"locationName":"channelMapping","type":"structure","members":{"OutputChannels":{"locationName":"outputChannels","type":"list","member":{"type":"structure","members":{"InputChannels":{"locationName":"inputChannels","type":"list","member":{"type":"integer"}},"InputChannelsFineTune":{"locationName":"inputChannelsFineTune","type":"list","member":{"type":"double"}}}}}}},"ChannelsIn":{"locationName":"channelsIn","type":"integer"},"ChannelsOut":{"locationName":"channelsOut","type":"integer"}}},"S1i":{"type":"map","key":{},"value":{"type":"structure","members":{"CustomLanguageCode":{"locationName":"customLanguageCode"},"LanguageCode":{"locationName":"languageCode"},"SourceSettings":{"locationName":"sourceSettings","type":"structure","members":{"AncillarySourceSettings":{"locationName":"ancillarySourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"SourceAncillaryChannelNumber":{"locationName":"sourceAncillaryChannelNumber","type":"integer"},"TerminateCaptions":{"locationName":"terminateCaptions"}}},"DvbSubSourceSettings":{"locationName":"dvbSubSourceSettings","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}}},"EmbeddedSourceSettings":{"locationName":"embeddedSourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Source608ChannelNumber":{"locationName":"source608ChannelNumber","type":"integer"},"Source608TrackNumber":{"locationName":"source608TrackNumber","type":"integer"},"TerminateCaptions":{"locationName":"terminateCaptions"}}},"FileSourceSettings":{"locationName":"fileSourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Framerate":{"locationName":"framerate","type":"structure","members":{"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"}}},"SourceFile":{"locationName":"sourceFile"},"TimeDelta":{"locationName":"timeDelta","type":"integer"},"TimeDeltaUnits":{"locationName":"timeDeltaUnits"}}},"SourceType":{"locationName":"sourceType"},"TeletextSourceSettings":{"locationName":"teletextSourceSettings","type":"structure","members":{"PageNumber":{"locationName":"pageNumber"}}},"TrackSourceSettings":{"locationName":"trackSourceSettings","type":"structure","members":{"TrackNumber":{"locationName":"trackNumber","type":"integer"}}},"WebvttHlsSourceSettings":{"locationName":"webvttHlsSourceSettings","type":"structure","members":{"RenditionGroupId":{"locationName":"renditionGroupId"},"RenditionLanguageCode":{"locationName":"renditionLanguageCode"},"RenditionName":{"locationName":"renditionName"}}}}}}}},"S26":{"type":"structure","members":{"Height":{"locationName":"height","type":"integer"},"Width":{"locationName":"width","type":"integer"},"X":{"locationName":"x","type":"integer"},"Y":{"locationName":"y","type":"integer"}}},"S2k":{"type":"structure","members":{"InsertableImages":{"locationName":"insertableImages","type":"list","member":{"type":"structure","members":{"Duration":{"locationName":"duration","type":"integer"},"FadeIn":{"locationName":"fadeIn","type":"integer"},"FadeOut":{"locationName":"fadeOut","type":"integer"},"Height":{"locationName":"height","type":"integer"},"ImageInserterInput":{"locationName":"imageInserterInput"},"ImageX":{"locationName":"imageX","type":"integer"},"ImageY":{"locationName":"imageY","type":"integer"},"Layer":{"locationName":"layer","type":"integer"},"Opacity":{"locationName":"opacity","type":"integer"},"StartTime":{"locationName":"startTime"},"Width":{"locationName":"width","type":"integer"}}}}}},"S2r":{"type":"list","member":{"type":"structure","members":{"EndTimecode":{"locationName":"endTimecode"},"StartTimecode":{"locationName":"startTimecode"}}}},"S32":{"type":"structure","members":{"AlphaBehavior":{"locationName":"alphaBehavior"},"ColorSpace":{"locationName":"colorSpace"},"ColorSpaceUsage":{"locationName":"colorSpaceUsage"},"EmbeddedTimecodeOverride":{"locationName":"embeddedTimecodeOverride"},"Hdr10Metadata":{"shape":"S37","locationName":"hdr10Metadata"},"PadVideo":{"locationName":"padVideo"},"Pid":{"locationName":"pid","type":"integer"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"Rotate":{"locationName":"rotate"},"SampleRange":{"locationName":"sampleRange"}}},"S37":{"type":"structure","members":{"BluePrimaryX":{"locationName":"bluePrimaryX","type":"integer"},"BluePrimaryY":{"locationName":"bluePrimaryY","type":"integer"},"GreenPrimaryX":{"locationName":"greenPrimaryX","type":"integer"},"GreenPrimaryY":{"locationName":"greenPrimaryY","type":"integer"},"MaxContentLightLevel":{"locationName":"maxContentLightLevel","type":"integer"},"MaxFrameAverageLightLevel":{"locationName":"maxFrameAverageLightLevel","type":"integer"},"MaxLuminance":{"locationName":"maxLuminance","type":"integer"},"MinLuminance":{"locationName":"minLuminance","type":"integer"},"RedPrimaryX":{"locationName":"redPrimaryX","type":"integer"},"RedPrimaryY":{"locationName":"redPrimaryY","type":"integer"},"WhitePointX":{"locationName":"whitePointX","type":"integer"},"WhitePointY":{"locationName":"whitePointY","type":"integer"}}},"S3d":{"type":"structure","members":{"ChannelName":{"locationName":"channelName"},"ContentReference":{"locationName":"contentReference"},"CredentialsSecretName":{"locationName":"credentialsSecretName"},"FileOffset":{"locationName":"fileOffset","type":"double"},"KantarLicenseId":{"locationName":"kantarLicenseId","type":"integer"},"KantarServerUrl":{"locationName":"kantarServerUrl"},"LogDestination":{"locationName":"logDestination"},"Metadata3":{"locationName":"metadata3"},"Metadata4":{"locationName":"metadata4"},"Metadata5":{"locationName":"metadata5"},"Metadata6":{"locationName":"metadata6"},"Metadata7":{"locationName":"metadata7"},"Metadata8":{"locationName":"metadata8"}}},"S3l":{"type":"structure","members":{"Framerate":{"locationName":"framerate","type":"structure","members":{"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"}}},"Input":{"locationName":"input"},"InsertionMode":{"locationName":"insertionMode"},"Offset":{"locationName":"offset","type":"structure","members":{"ImageX":{"locationName":"imageX","type":"integer"},"ImageY":{"locationName":"imageY","type":"integer"}}},"Playback":{"locationName":"playback"},"StartTime":{"locationName":"startTime"}}},"S3t":{"type":"structure","members":{"BreakoutCode":{"locationName":"breakoutCode","type":"integer"},"DistributorId":{"locationName":"distributorId"}}},"S3v":{"type":"structure","members":{"ActiveWatermarkProcess":{"locationName":"activeWatermarkProcess"},"AdiFilename":{"locationName":"adiFilename"},"AssetId":{"locationName":"assetId"},"AssetName":{"locationName":"assetName"},"CbetSourceId":{"locationName":"cbetSourceId"},"EpisodeId":{"locationName":"episodeId"},"MetadataDestination":{"locationName":"metadataDestination"},"SourceId":{"locationName":"sourceId","type":"integer"},"SourceWatermarkStatus":{"locationName":"sourceWatermarkStatus"},"TicServerUrl":{"locationName":"ticServerUrl"},"UniqueTicPerAudioTrack":{"locationName":"uniqueTicPerAudioTrack"}}},"S42":{"type":"list","member":{"type":"structure","members":{"AutomatedEncodingSettings":{"locationName":"automatedEncodingSettings","type":"structure","members":{"AbrSettings":{"locationName":"abrSettings","type":"structure","members":{"MaxAbrBitrate":{"locationName":"maxAbrBitrate","type":"integer"},"MaxRenditions":{"locationName":"maxRenditions","type":"integer"},"MinAbrBitrate":{"locationName":"minAbrBitrate","type":"integer"}}}}},"CustomName":{"locationName":"customName"},"Name":{"locationName":"name"},"OutputGroupSettings":{"locationName":"outputGroupSettings","type":"structure","members":{"CmafGroupSettings":{"locationName":"cmafGroupSettings","type":"structure","members":{"AdditionalManifests":{"locationName":"additionalManifests","type":"list","member":{"type":"structure","members":{"ManifestNameModifier":{"locationName":"manifestNameModifier"},"SelectedOutputs":{"shape":"Sv","locationName":"selectedOutputs"}}}},"BaseUrl":{"locationName":"baseUrl"},"ClientCache":{"locationName":"clientCache"},"CodecSpecification":{"locationName":"codecSpecification"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S4e","locationName":"destinationSettings"},"Encryption":{"locationName":"encryption","type":"structure","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"InitializationVectorInManifest":{"locationName":"initializationVectorInManifest"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","type":"structure","members":{"CertificateArn":{"locationName":"certificateArn"},"DashSignaledSystemIds":{"shape":"S4s","locationName":"dashSignaledSystemIds"},"HlsSignaledSystemIds":{"shape":"S4s","locationName":"hlsSignaledSystemIds"},"ResourceId":{"locationName":"resourceId"},"Url":{"locationName":"url"}}},"StaticKeyProvider":{"shape":"S4v","locationName":"staticKeyProvider"},"Type":{"locationName":"type"}}},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"ImageBasedTrickPlay":{"locationName":"imageBasedTrickPlay"},"ImageBasedTrickPlaySettings":{"locationName":"imageBasedTrickPlaySettings","type":"structure","members":{"IntervalCadence":{"locationName":"intervalCadence"},"ThumbnailHeight":{"locationName":"thumbnailHeight","type":"integer"},"ThumbnailInterval":{"locationName":"thumbnailInterval","type":"double"},"ThumbnailWidth":{"locationName":"thumbnailWidth","type":"integer"},"TileHeight":{"locationName":"tileHeight","type":"integer"},"TileWidth":{"locationName":"tileWidth","type":"integer"}}},"ManifestCompression":{"locationName":"manifestCompression"},"ManifestDurationFormat":{"locationName":"manifestDurationFormat"},"MinBufferTime":{"locationName":"minBufferTime","type":"integer"},"MinFinalSegmentLength":{"locationName":"minFinalSegmentLength","type":"double"},"MpdProfile":{"locationName":"mpdProfile"},"PtsOffsetHandlingForBFrames":{"locationName":"ptsOffsetHandlingForBFrames"},"SegmentControl":{"locationName":"segmentControl"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"SegmentLengthControl":{"locationName":"segmentLengthControl"},"StreamInfResolution":{"locationName":"streamInfResolution"},"TargetDurationCompatibilityMode":{"locationName":"targetDurationCompatibilityMode"},"WriteDashManifest":{"locationName":"writeDashManifest"},"WriteHlsManifest":{"locationName":"writeHlsManifest"},"WriteSegmentTimelineInRepresentation":{"locationName":"writeSegmentTimelineInRepresentation"}}},"DashIsoGroupSettings":{"locationName":"dashIsoGroupSettings","type":"structure","members":{"AdditionalManifests":{"locationName":"additionalManifests","type":"list","member":{"type":"structure","members":{"ManifestNameModifier":{"locationName":"manifestNameModifier"},"SelectedOutputs":{"shape":"Sv","locationName":"selectedOutputs"}}}},"AudioChannelConfigSchemeIdUri":{"locationName":"audioChannelConfigSchemeIdUri"},"BaseUrl":{"locationName":"baseUrl"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S4e","locationName":"destinationSettings"},"Encryption":{"locationName":"encryption","type":"structure","members":{"PlaybackDeviceCompatibility":{"locationName":"playbackDeviceCompatibility"},"SpekeKeyProvider":{"shape":"S5p","locationName":"spekeKeyProvider"}}},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"HbbtvCompliance":{"locationName":"hbbtvCompliance"},"ImageBasedTrickPlay":{"locationName":"imageBasedTrickPlay"},"ImageBasedTrickPlaySettings":{"locationName":"imageBasedTrickPlaySettings","type":"structure","members":{"IntervalCadence":{"locationName":"intervalCadence"},"ThumbnailHeight":{"locationName":"thumbnailHeight","type":"integer"},"ThumbnailInterval":{"locationName":"thumbnailInterval","type":"double"},"ThumbnailWidth":{"locationName":"thumbnailWidth","type":"integer"},"TileHeight":{"locationName":"tileHeight","type":"integer"},"TileWidth":{"locationName":"tileWidth","type":"integer"}}},"MinBufferTime":{"locationName":"minBufferTime","type":"integer"},"MinFinalSegmentLength":{"locationName":"minFinalSegmentLength","type":"double"},"MpdProfile":{"locationName":"mpdProfile"},"PtsOffsetHandlingForBFrames":{"locationName":"ptsOffsetHandlingForBFrames"},"SegmentControl":{"locationName":"segmentControl"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"SegmentLengthControl":{"locationName":"segmentLengthControl"},"WriteSegmentTimelineInRepresentation":{"locationName":"writeSegmentTimelineInRepresentation"}}},"FileGroupSettings":{"locationName":"fileGroupSettings","type":"structure","members":{"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S4e","locationName":"destinationSettings"}}},"HlsGroupSettings":{"locationName":"hlsGroupSettings","type":"structure","members":{"AdMarkers":{"locationName":"adMarkers","type":"list","member":{}},"AdditionalManifests":{"locationName":"additionalManifests","type":"list","member":{"type":"structure","members":{"ManifestNameModifier":{"locationName":"manifestNameModifier"},"SelectedOutputs":{"shape":"Sv","locationName":"selectedOutputs"}}}},"AudioOnlyHeader":{"locationName":"audioOnlyHeader"},"BaseUrl":{"locationName":"baseUrl"},"CaptionLanguageMappings":{"locationName":"captionLanguageMappings","type":"list","member":{"type":"structure","members":{"CaptionChannel":{"locationName":"captionChannel","type":"integer"},"CustomLanguageCode":{"locationName":"customLanguageCode"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}}}},"CaptionLanguageSetting":{"locationName":"captionLanguageSetting"},"CaptionSegmentLengthControl":{"locationName":"captionSegmentLengthControl"},"ClientCache":{"locationName":"clientCache"},"CodecSpecification":{"locationName":"codecSpecification"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S4e","locationName":"destinationSettings"},"DirectoryStructure":{"locationName":"directoryStructure"},"Encryption":{"locationName":"encryption","type":"structure","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"InitializationVectorInManifest":{"locationName":"initializationVectorInManifest"},"OfflineEncrypted":{"locationName":"offlineEncrypted"},"SpekeKeyProvider":{"shape":"S5p","locationName":"spekeKeyProvider"},"StaticKeyProvider":{"shape":"S4v","locationName":"staticKeyProvider"},"Type":{"locationName":"type"}}},"ImageBasedTrickPlay":{"locationName":"imageBasedTrickPlay"},"ImageBasedTrickPlaySettings":{"locationName":"imageBasedTrickPlaySettings","type":"structure","members":{"IntervalCadence":{"locationName":"intervalCadence"},"ThumbnailHeight":{"locationName":"thumbnailHeight","type":"integer"},"ThumbnailInterval":{"locationName":"thumbnailInterval","type":"double"},"ThumbnailWidth":{"locationName":"thumbnailWidth","type":"integer"},"TileHeight":{"locationName":"tileHeight","type":"integer"},"TileWidth":{"locationName":"tileWidth","type":"integer"}}},"ManifestCompression":{"locationName":"manifestCompression"},"ManifestDurationFormat":{"locationName":"manifestDurationFormat"},"MinFinalSegmentLength":{"locationName":"minFinalSegmentLength","type":"double"},"MinSegmentLength":{"locationName":"minSegmentLength","type":"integer"},"OutputSelection":{"locationName":"outputSelection"},"ProgramDateTime":{"locationName":"programDateTime"},"ProgramDateTimePeriod":{"locationName":"programDateTimePeriod","type":"integer"},"SegmentControl":{"locationName":"segmentControl"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"SegmentLengthControl":{"locationName":"segmentLengthControl"},"SegmentsPerSubdirectory":{"locationName":"segmentsPerSubdirectory","type":"integer"},"StreamInfResolution":{"locationName":"streamInfResolution"},"TargetDurationCompatibilityMode":{"locationName":"targetDurationCompatibilityMode"},"TimedMetadataId3Frame":{"locationName":"timedMetadataId3Frame"},"TimedMetadataId3Period":{"locationName":"timedMetadataId3Period","type":"integer"},"TimestampDeltaMilliseconds":{"locationName":"timestampDeltaMilliseconds","type":"integer"}}},"MsSmoothGroupSettings":{"locationName":"msSmoothGroupSettings","type":"structure","members":{"AdditionalManifests":{"locationName":"additionalManifests","type":"list","member":{"type":"structure","members":{"ManifestNameModifier":{"locationName":"manifestNameModifier"},"SelectedOutputs":{"shape":"Sv","locationName":"selectedOutputs"}}}},"AudioDeduplication":{"locationName":"audioDeduplication"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S4e","locationName":"destinationSettings"},"Encryption":{"locationName":"encryption","type":"structure","members":{"SpekeKeyProvider":{"shape":"S5p","locationName":"spekeKeyProvider"}}},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"FragmentLengthControl":{"locationName":"fragmentLengthControl"},"ManifestEncoding":{"locationName":"manifestEncoding"}}},"Type":{"locationName":"type"}}},"Outputs":{"locationName":"outputs","type":"list","member":{"type":"structure","members":{"AudioDescriptions":{"shape":"S78","locationName":"audioDescriptions"},"CaptionDescriptions":{"locationName":"captionDescriptions","type":"list","member":{"type":"structure","members":{"CaptionSelectorName":{"locationName":"captionSelectorName"},"CustomLanguageCode":{"locationName":"customLanguageCode"},"DestinationSettings":{"shape":"S9q","locationName":"destinationSettings"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}}}},"ContainerSettings":{"shape":"Sb0","locationName":"containerSettings"},"Extension":{"locationName":"extension"},"NameModifier":{"locationName":"nameModifier"},"OutputSettings":{"locationName":"outputSettings","type":"structure","members":{"HlsSettings":{"locationName":"hlsSettings","type":"structure","members":{"AudioGroupId":{"locationName":"audioGroupId"},"AudioOnlyContainer":{"locationName":"audioOnlyContainer"},"AudioRenditionSets":{"locationName":"audioRenditionSets"},"AudioTrackType":{"locationName":"audioTrackType"},"DescriptiveVideoServiceFlag":{"locationName":"descriptiveVideoServiceFlag"},"IFrameOnlyManifest":{"locationName":"iFrameOnlyManifest"},"SegmentModifier":{"locationName":"segmentModifier"}}}}},"Preset":{"locationName":"preset"},"VideoDescription":{"shape":"Sd9","locationName":"videoDescription"}}}}}}},"S4e":{"type":"structure","members":{"S3Settings":{"locationName":"s3Settings","type":"structure","members":{"AccessControl":{"locationName":"accessControl","type":"structure","members":{"CannedAcl":{"locationName":"cannedAcl"}}},"Encryption":{"locationName":"encryption","type":"structure","members":{"EncryptionType":{"locationName":"encryptionType"},"KmsEncryptionContext":{"locationName":"kmsEncryptionContext"},"KmsKeyArn":{"locationName":"kmsKeyArn"}}}}}}},"S4s":{"type":"list","member":{}},"S4v":{"type":"structure","members":{"KeyFormat":{"locationName":"keyFormat"},"KeyFormatVersions":{"locationName":"keyFormatVersions"},"StaticKeyValue":{"locationName":"staticKeyValue"},"Url":{"locationName":"url"}}},"S5p":{"type":"structure","members":{"CertificateArn":{"locationName":"certificateArn"},"ResourceId":{"locationName":"resourceId"},"SystemIds":{"locationName":"systemIds","type":"list","member":{}},"Url":{"locationName":"url"}}},"S78":{"type":"list","member":{"type":"structure","members":{"AudioChannelTaggingSettings":{"locationName":"audioChannelTaggingSettings","type":"structure","members":{"ChannelTag":{"locationName":"channelTag"}}},"AudioNormalizationSettings":{"locationName":"audioNormalizationSettings","type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"AlgorithmControl":{"locationName":"algorithmControl"},"CorrectionGateLevel":{"locationName":"correctionGateLevel","type":"integer"},"LoudnessLogging":{"locationName":"loudnessLogging"},"PeakCalculation":{"locationName":"peakCalculation"},"TargetLkfs":{"locationName":"targetLkfs","type":"double"}}},"AudioSourceName":{"locationName":"audioSourceName"},"AudioType":{"locationName":"audioType","type":"integer"},"AudioTypeControl":{"locationName":"audioTypeControl"},"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"AacSettings":{"locationName":"aacSettings","type":"structure","members":{"AudioDescriptionBroadcasterMix":{"locationName":"audioDescriptionBroadcasterMix"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecProfile":{"locationName":"codecProfile"},"CodingMode":{"locationName":"codingMode"},"RateControlMode":{"locationName":"rateControlMode"},"RawFormat":{"locationName":"rawFormat"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"Specification":{"locationName":"specification"},"VbrQuality":{"locationName":"vbrQuality"}}},"Ac3Settings":{"locationName":"ac3Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DynamicRangeCompressionLine":{"locationName":"dynamicRangeCompressionLine"},"DynamicRangeCompressionProfile":{"locationName":"dynamicRangeCompressionProfile"},"DynamicRangeCompressionRf":{"locationName":"dynamicRangeCompressionRf"},"LfeFilter":{"locationName":"lfeFilter"},"MetadataControl":{"locationName":"metadataControl"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"AiffSettings":{"locationName":"aiffSettings","type":"structure","members":{"BitDepth":{"locationName":"bitDepth","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"Codec":{"locationName":"codec"},"Eac3AtmosSettings":{"locationName":"eac3AtmosSettings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"DialogueIntelligence":{"locationName":"dialogueIntelligence"},"DownmixControl":{"locationName":"downmixControl"},"DynamicRangeCompressionLine":{"locationName":"dynamicRangeCompressionLine"},"DynamicRangeCompressionRf":{"locationName":"dynamicRangeCompressionRf"},"DynamicRangeControl":{"locationName":"dynamicRangeControl"},"LoRoCenterMixLevel":{"locationName":"loRoCenterMixLevel","type":"double"},"LoRoSurroundMixLevel":{"locationName":"loRoSurroundMixLevel","type":"double"},"LtRtCenterMixLevel":{"locationName":"ltRtCenterMixLevel","type":"double"},"LtRtSurroundMixLevel":{"locationName":"ltRtSurroundMixLevel","type":"double"},"MeteringMode":{"locationName":"meteringMode"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"SpeechThreshold":{"locationName":"speechThreshold","type":"integer"},"StereoDownmix":{"locationName":"stereoDownmix"},"SurroundExMode":{"locationName":"surroundExMode"}}},"Eac3Settings":{"locationName":"eac3Settings","type":"structure","members":{"AttenuationControl":{"locationName":"attenuationControl"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"DcFilter":{"locationName":"dcFilter"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DynamicRangeCompressionLine":{"locationName":"dynamicRangeCompressionLine"},"DynamicRangeCompressionRf":{"locationName":"dynamicRangeCompressionRf"},"LfeControl":{"locationName":"lfeControl"},"LfeFilter":{"locationName":"lfeFilter"},"LoRoCenterMixLevel":{"locationName":"loRoCenterMixLevel","type":"double"},"LoRoSurroundMixLevel":{"locationName":"loRoSurroundMixLevel","type":"double"},"LtRtCenterMixLevel":{"locationName":"ltRtCenterMixLevel","type":"double"},"LtRtSurroundMixLevel":{"locationName":"ltRtSurroundMixLevel","type":"double"},"MetadataControl":{"locationName":"metadataControl"},"PassthroughControl":{"locationName":"passthroughControl"},"PhaseControl":{"locationName":"phaseControl"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"StereoDownmix":{"locationName":"stereoDownmix"},"SurroundExMode":{"locationName":"surroundExMode"},"SurroundMode":{"locationName":"surroundMode"}}},"Mp2Settings":{"locationName":"mp2Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"Mp3Settings":{"locationName":"mp3Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"RateControlMode":{"locationName":"rateControlMode"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"VbrQuality":{"locationName":"vbrQuality","type":"integer"}}},"OpusSettings":{"locationName":"opusSettings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"VorbisSettings":{"locationName":"vorbisSettings","type":"structure","members":{"Channels":{"locationName":"channels","type":"integer"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"VbrQuality":{"locationName":"vbrQuality","type":"integer"}}},"WavSettings":{"locationName":"wavSettings","type":"structure","members":{"BitDepth":{"locationName":"bitDepth","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"Format":{"locationName":"format"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}}}},"CustomLanguageCode":{"locationName":"customLanguageCode"},"LanguageCode":{"locationName":"languageCode"},"LanguageCodeControl":{"locationName":"languageCodeControl"},"RemixSettings":{"shape":"S18","locationName":"remixSettings"},"StreamName":{"locationName":"streamName"}}}},"S9q":{"type":"structure","members":{"BurninDestinationSettings":{"locationName":"burninDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"ApplyFontColor":{"locationName":"applyFontColor"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"FallbackFont":{"locationName":"fallbackFont"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontScript":{"locationName":"fontScript"},"FontSize":{"locationName":"fontSize","type":"integer"},"HexFontColor":{"locationName":"hexFontColor"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"StylePassthrough":{"locationName":"stylePassthrough"},"TeletextSpacing":{"locationName":"teletextSpacing"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"DestinationType":{"locationName":"destinationType"},"DvbSubDestinationSettings":{"locationName":"dvbSubDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"ApplyFontColor":{"locationName":"applyFontColor"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"DdsHandling":{"locationName":"ddsHandling"},"DdsXCoordinate":{"locationName":"ddsXCoordinate","type":"integer"},"DdsYCoordinate":{"locationName":"ddsYCoordinate","type":"integer"},"FallbackFont":{"locationName":"fallbackFont"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontScript":{"locationName":"fontScript"},"FontSize":{"locationName":"fontSize","type":"integer"},"Height":{"locationName":"height","type":"integer"},"HexFontColor":{"locationName":"hexFontColor"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"StylePassthrough":{"locationName":"stylePassthrough"},"SubtitlingType":{"locationName":"subtitlingType"},"TeletextSpacing":{"locationName":"teletextSpacing"},"Width":{"locationName":"width","type":"integer"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"EmbeddedDestinationSettings":{"locationName":"embeddedDestinationSettings","type":"structure","members":{"Destination608ChannelNumber":{"locationName":"destination608ChannelNumber","type":"integer"},"Destination708ServiceNumber":{"locationName":"destination708ServiceNumber","type":"integer"}}},"ImscDestinationSettings":{"locationName":"imscDestinationSettings","type":"structure","members":{"Accessibility":{"locationName":"accessibility"},"StylePassthrough":{"locationName":"stylePassthrough"}}},"SccDestinationSettings":{"locationName":"sccDestinationSettings","type":"structure","members":{"Framerate":{"locationName":"framerate"}}},"SrtDestinationSettings":{"locationName":"srtDestinationSettings","type":"structure","members":{"StylePassthrough":{"locationName":"stylePassthrough"}}},"TeletextDestinationSettings":{"locationName":"teletextDestinationSettings","type":"structure","members":{"PageNumber":{"locationName":"pageNumber"},"PageTypes":{"locationName":"pageTypes","type":"list","member":{}}}},"TtmlDestinationSettings":{"locationName":"ttmlDestinationSettings","type":"structure","members":{"StylePassthrough":{"locationName":"stylePassthrough"}}},"WebvttDestinationSettings":{"locationName":"webvttDestinationSettings","type":"structure","members":{"Accessibility":{"locationName":"accessibility"},"StylePassthrough":{"locationName":"stylePassthrough"}}}}},"Sb0":{"type":"structure","members":{"CmfcSettings":{"locationName":"cmfcSettings","type":"structure","members":{"AudioDuration":{"locationName":"audioDuration"},"AudioGroupId":{"locationName":"audioGroupId"},"AudioRenditionSets":{"locationName":"audioRenditionSets"},"AudioTrackType":{"locationName":"audioTrackType"},"DescriptiveVideoServiceFlag":{"locationName":"descriptiveVideoServiceFlag"},"IFrameOnlyManifest":{"locationName":"iFrameOnlyManifest"},"KlvMetadata":{"locationName":"klvMetadata"},"Scte35Esam":{"locationName":"scte35Esam"},"Scte35Source":{"locationName":"scte35Source"},"TimedMetadata":{"locationName":"timedMetadata"}}},"Container":{"locationName":"container"},"F4vSettings":{"locationName":"f4vSettings","type":"structure","members":{"MoovPlacement":{"locationName":"moovPlacement"}}},"M2tsSettings":{"locationName":"m2tsSettings","type":"structure","members":{"AudioBufferModel":{"locationName":"audioBufferModel"},"AudioDuration":{"locationName":"audioDuration"},"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"shape":"Sbg","locationName":"audioPids"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufferModel":{"locationName":"bufferModel"},"DataPTSControl":{"locationName":"dataPTSControl"},"DvbNitSettings":{"locationName":"dvbNitSettings","type":"structure","members":{"NetworkId":{"locationName":"networkId","type":"integer"},"NetworkName":{"locationName":"networkName"},"NitInterval":{"locationName":"nitInterval","type":"integer"}}},"DvbSdtSettings":{"locationName":"dvbSdtSettings","type":"structure","members":{"OutputSdt":{"locationName":"outputSdt"},"SdtInterval":{"locationName":"sdtInterval","type":"integer"},"ServiceName":{"locationName":"serviceName"},"ServiceProviderName":{"locationName":"serviceProviderName"}}},"DvbSubPids":{"shape":"Sbg","locationName":"dvbSubPids"},"DvbTdtSettings":{"locationName":"dvbTdtSettings","type":"structure","members":{"TdtInterval":{"locationName":"tdtInterval","type":"integer"}}},"DvbTeletextPid":{"locationName":"dvbTeletextPid","type":"integer"},"EbpAudioInterval":{"locationName":"ebpAudioInterval"},"EbpPlacement":{"locationName":"ebpPlacement"},"EsRateInPes":{"locationName":"esRateInPes"},"ForceTsVideoEbpOrder":{"locationName":"forceTsVideoEbpOrder"},"FragmentTime":{"locationName":"fragmentTime","type":"double"},"KlvMetadata":{"locationName":"klvMetadata"},"MaxPcrInterval":{"locationName":"maxPcrInterval","type":"integer"},"MinEbpInterval":{"locationName":"minEbpInterval","type":"integer"},"NielsenId3":{"locationName":"nielsenId3"},"NullPacketBitrate":{"locationName":"nullPacketBitrate","type":"double"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPid":{"locationName":"pcrPid","type":"integer"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid","type":"integer"},"PrivateMetadataPid":{"locationName":"privateMetadataPid","type":"integer"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"RateMode":{"locationName":"rateMode"},"Scte35Esam":{"locationName":"scte35Esam","type":"structure","members":{"Scte35EsamPid":{"locationName":"scte35EsamPid","type":"integer"}}},"Scte35Pid":{"locationName":"scte35Pid","type":"integer"},"Scte35Source":{"locationName":"scte35Source"},"SegmentationMarkers":{"locationName":"segmentationMarkers"},"SegmentationStyle":{"locationName":"segmentationStyle"},"SegmentationTime":{"locationName":"segmentationTime","type":"double"},"TimedMetadataPid":{"locationName":"timedMetadataPid","type":"integer"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid","type":"integer"}}},"M3u8Settings":{"locationName":"m3u8Settings","type":"structure","members":{"AudioDuration":{"locationName":"audioDuration"},"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"shape":"Sbg","locationName":"audioPids"},"DataPTSControl":{"locationName":"dataPTSControl"},"MaxPcrInterval":{"locationName":"maxPcrInterval","type":"integer"},"NielsenId3":{"locationName":"nielsenId3"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPid":{"locationName":"pcrPid","type":"integer"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid","type":"integer"},"PrivateMetadataPid":{"locationName":"privateMetadataPid","type":"integer"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"Scte35Pid":{"locationName":"scte35Pid","type":"integer"},"Scte35Source":{"locationName":"scte35Source"},"TimedMetadata":{"locationName":"timedMetadata"},"TimedMetadataPid":{"locationName":"timedMetadataPid","type":"integer"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid","type":"integer"}}},"MovSettings":{"locationName":"movSettings","type":"structure","members":{"ClapAtom":{"locationName":"clapAtom"},"CslgAtom":{"locationName":"cslgAtom"},"Mpeg2FourCCControl":{"locationName":"mpeg2FourCCControl"},"PaddingControl":{"locationName":"paddingControl"},"Reference":{"locationName":"reference"}}},"Mp4Settings":{"locationName":"mp4Settings","type":"structure","members":{"AudioDuration":{"locationName":"audioDuration"},"CslgAtom":{"locationName":"cslgAtom"},"CttsVersion":{"locationName":"cttsVersion","type":"integer"},"FreeSpaceBox":{"locationName":"freeSpaceBox"},"MoovPlacement":{"locationName":"moovPlacement"},"Mp4MajorBrand":{"locationName":"mp4MajorBrand"}}},"MpdSettings":{"locationName":"mpdSettings","type":"structure","members":{"AccessibilityCaptionHints":{"locationName":"accessibilityCaptionHints"},"AudioDuration":{"locationName":"audioDuration"},"CaptionContainerType":{"locationName":"captionContainerType"},"KlvMetadata":{"locationName":"klvMetadata"},"Scte35Esam":{"locationName":"scte35Esam"},"Scte35Source":{"locationName":"scte35Source"},"TimedMetadata":{"locationName":"timedMetadata"}}},"MxfSettings":{"locationName":"mxfSettings","type":"structure","members":{"AfdSignaling":{"locationName":"afdSignaling"},"Profile":{"locationName":"profile"},"XavcProfileSettings":{"locationName":"xavcProfileSettings","type":"structure","members":{"DurationMode":{"locationName":"durationMode"},"MaxAncDataSize":{"locationName":"maxAncDataSize","type":"integer"}}}}}}},"Sbg":{"type":"list","member":{"type":"integer"}},"Sd9":{"type":"structure","members":{"AfdSignaling":{"locationName":"afdSignaling"},"AntiAlias":{"locationName":"antiAlias"},"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"Av1Settings":{"locationName":"av1Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"BitDepth":{"locationName":"bitDepth"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"QvbrSettings":{"locationName":"qvbrSettings","type":"structure","members":{"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"},"QvbrQualityLevelFineTune":{"locationName":"qvbrQualityLevelFineTune","type":"double"}}},"RateControlMode":{"locationName":"rateControlMode"},"Slices":{"locationName":"slices","type":"integer"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"}}},"AvcIntraSettings":{"locationName":"avcIntraSettings","type":"structure","members":{"AvcIntraClass":{"locationName":"avcIntraClass"},"AvcIntraUhdSettings":{"locationName":"avcIntraUhdSettings","type":"structure","members":{"QualityTuningLevel":{"locationName":"qualityTuningLevel"}}},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"ScanTypeConversionMode":{"locationName":"scanTypeConversionMode"},"SlowPal":{"locationName":"slowPal"},"Telecine":{"locationName":"telecine"}}},"Codec":{"locationName":"codec"},"FrameCaptureSettings":{"locationName":"frameCaptureSettings","type":"structure","members":{"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"MaxCaptures":{"locationName":"maxCaptures","type":"integer"},"Quality":{"locationName":"quality","type":"integer"}}},"H264Settings":{"locationName":"h264Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecLevel":{"locationName":"codecLevel"},"CodecProfile":{"locationName":"codecProfile"},"DynamicSubGop":{"locationName":"dynamicSubGop"},"EntropyEncoding":{"locationName":"entropyEncoding"},"FieldEncoding":{"locationName":"fieldEncoding"},"FlickerAdaptiveQuantization":{"locationName":"flickerAdaptiveQuantization"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"HrdBufferInitialFillPercentage":{"locationName":"hrdBufferInitialFillPercentage","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"NumberReferenceFrames":{"locationName":"numberReferenceFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"QvbrSettings":{"locationName":"qvbrSettings","type":"structure","members":{"MaxAverageBitrate":{"locationName":"maxAverageBitrate","type":"integer"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"},"QvbrQualityLevelFineTune":{"locationName":"qvbrQualityLevelFineTune","type":"double"}}},"RateControlMode":{"locationName":"rateControlMode"},"RepeatPps":{"locationName":"repeatPps"},"ScanTypeConversionMode":{"locationName":"scanTypeConversionMode"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"SlowPal":{"locationName":"slowPal"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"Syntax":{"locationName":"syntax"},"Telecine":{"locationName":"telecine"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"},"UnregisteredSeiTimecode":{"locationName":"unregisteredSeiTimecode"}}},"H265Settings":{"locationName":"h265Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"AlternateTransferFunctionSei":{"locationName":"alternateTransferFunctionSei"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecLevel":{"locationName":"codecLevel"},"CodecProfile":{"locationName":"codecProfile"},"DynamicSubGop":{"locationName":"dynamicSubGop"},"FlickerAdaptiveQuantization":{"locationName":"flickerAdaptiveQuantization"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"HrdBufferInitialFillPercentage":{"locationName":"hrdBufferInitialFillPercentage","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"NumberReferenceFrames":{"locationName":"numberReferenceFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"QvbrSettings":{"locationName":"qvbrSettings","type":"structure","members":{"MaxAverageBitrate":{"locationName":"maxAverageBitrate","type":"integer"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"},"QvbrQualityLevelFineTune":{"locationName":"qvbrQualityLevelFineTune","type":"double"}}},"RateControlMode":{"locationName":"rateControlMode"},"SampleAdaptiveOffsetFilterMode":{"locationName":"sampleAdaptiveOffsetFilterMode"},"ScanTypeConversionMode":{"locationName":"scanTypeConversionMode"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"SlowPal":{"locationName":"slowPal"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"Telecine":{"locationName":"telecine"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"},"TemporalIds":{"locationName":"temporalIds"},"Tiles":{"locationName":"tiles"},"UnregisteredSeiTimecode":{"locationName":"unregisteredSeiTimecode"},"WriteMp4PackagingType":{"locationName":"writeMp4PackagingType"}}},"Mpeg2Settings":{"locationName":"mpeg2Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecLevel":{"locationName":"codecLevel"},"CodecProfile":{"locationName":"codecProfile"},"DynamicSubGop":{"locationName":"dynamicSubGop"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"HrdBufferInitialFillPercentage":{"locationName":"hrdBufferInitialFillPercentage","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"IntraDcPrecision":{"locationName":"intraDcPrecision"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"RateControlMode":{"locationName":"rateControlMode"},"ScanTypeConversionMode":{"locationName":"scanTypeConversionMode"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"SlowPal":{"locationName":"slowPal"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"Syntax":{"locationName":"syntax"},"Telecine":{"locationName":"telecine"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"}}},"ProresSettings":{"locationName":"proresSettings","type":"structure","members":{"ChromaSampling":{"locationName":"chromaSampling"},"CodecProfile":{"locationName":"codecProfile"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"ScanTypeConversionMode":{"locationName":"scanTypeConversionMode"},"SlowPal":{"locationName":"slowPal"},"Telecine":{"locationName":"telecine"}}},"Vc3Settings":{"locationName":"vc3Settings","type":"structure","members":{"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"ScanTypeConversionMode":{"locationName":"scanTypeConversionMode"},"SlowPal":{"locationName":"slowPal"},"Telecine":{"locationName":"telecine"},"Vc3Class":{"locationName":"vc3Class"}}},"Vp8Settings":{"locationName":"vp8Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"RateControlMode":{"locationName":"rateControlMode"}}},"Vp9Settings":{"locationName":"vp9Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"RateControlMode":{"locationName":"rateControlMode"}}},"XavcSettings":{"locationName":"xavcSettings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"EntropyEncoding":{"locationName":"entropyEncoding"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"Profile":{"locationName":"profile"},"SlowPal":{"locationName":"slowPal"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"},"Xavc4kIntraCbgProfileSettings":{"locationName":"xavc4kIntraCbgProfileSettings","type":"structure","members":{"XavcClass":{"locationName":"xavcClass"}}},"Xavc4kIntraVbrProfileSettings":{"locationName":"xavc4kIntraVbrProfileSettings","type":"structure","members":{"XavcClass":{"locationName":"xavcClass"}}},"Xavc4kProfileSettings":{"locationName":"xavc4kProfileSettings","type":"structure","members":{"BitrateClass":{"locationName":"bitrateClass"},"CodecProfile":{"locationName":"codecProfile"},"FlickerAdaptiveQuantization":{"locationName":"flickerAdaptiveQuantization"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"Slices":{"locationName":"slices","type":"integer"}}},"XavcHdIntraCbgProfileSettings":{"locationName":"xavcHdIntraCbgProfileSettings","type":"structure","members":{"XavcClass":{"locationName":"xavcClass"}}},"XavcHdProfileSettings":{"locationName":"xavcHdProfileSettings","type":"structure","members":{"BitrateClass":{"locationName":"bitrateClass"},"FlickerAdaptiveQuantization":{"locationName":"flickerAdaptiveQuantization"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"Slices":{"locationName":"slices","type":"integer"},"Telecine":{"locationName":"telecine"}}}}}}},"ColorMetadata":{"locationName":"colorMetadata"},"Crop":{"shape":"S26","locationName":"crop"},"DropFrameTimecode":{"locationName":"dropFrameTimecode"},"FixedAfd":{"locationName":"fixedAfd","type":"integer"},"Height":{"locationName":"height","type":"integer"},"Position":{"shape":"S26","locationName":"position"},"RespondToAfd":{"locationName":"respondToAfd"},"ScalingBehavior":{"locationName":"scalingBehavior"},"Sharpness":{"locationName":"sharpness","type":"integer"},"TimecodeInsertion":{"locationName":"timecodeInsertion"},"VideoPreprocessors":{"locationName":"videoPreprocessors","type":"structure","members":{"ColorCorrector":{"locationName":"colorCorrector","type":"structure","members":{"Brightness":{"locationName":"brightness","type":"integer"},"ColorSpaceConversion":{"locationName":"colorSpaceConversion"},"Contrast":{"locationName":"contrast","type":"integer"},"Hdr10Metadata":{"shape":"S37","locationName":"hdr10Metadata"},"Hue":{"locationName":"hue","type":"integer"},"SampleRangeConversion":{"locationName":"sampleRangeConversion"},"Saturation":{"locationName":"saturation","type":"integer"}}},"Deinterlacer":{"locationName":"deinterlacer","type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"Control":{"locationName":"control"},"Mode":{"locationName":"mode"}}},"DolbyVision":{"locationName":"dolbyVision","type":"structure","members":{"L6Metadata":{"locationName":"l6Metadata","type":"structure","members":{"MaxCll":{"locationName":"maxCll","type":"integer"},"MaxFall":{"locationName":"maxFall","type":"integer"}}},"L6Mode":{"locationName":"l6Mode"},"Mapping":{"locationName":"mapping"},"Profile":{"locationName":"profile"}}},"Hdr10Plus":{"locationName":"hdr10Plus","type":"structure","members":{"MasteringMonitorNits":{"locationName":"masteringMonitorNits","type":"integer"},"TargetMonitorNits":{"locationName":"targetMonitorNits","type":"integer"}}},"ImageInserter":{"shape":"S2k","locationName":"imageInserter"},"NoiseReducer":{"locationName":"noiseReducer","type":"structure","members":{"Filter":{"locationName":"filter"},"FilterSettings":{"locationName":"filterSettings","type":"structure","members":{"Strength":{"locationName":"strength","type":"integer"}}},"SpatialFilterSettings":{"locationName":"spatialFilterSettings","type":"structure","members":{"PostFilterSharpenStrength":{"locationName":"postFilterSharpenStrength","type":"integer"},"Speed":{"locationName":"speed","type":"integer"},"Strength":{"locationName":"strength","type":"integer"}}},"TemporalFilterSettings":{"locationName":"temporalFilterSettings","type":"structure","members":{"AggressiveMode":{"locationName":"aggressiveMode","type":"integer"},"PostTemporalSharpening":{"locationName":"postTemporalSharpening"},"PostTemporalSharpeningStrength":{"locationName":"postTemporalSharpeningStrength"},"Speed":{"locationName":"speed","type":"integer"},"Strength":{"locationName":"strength","type":"integer"}}}}},"PartnerWatermarking":{"locationName":"partnerWatermarking","type":"structure","members":{"NexguardFileMarkerSettings":{"locationName":"nexguardFileMarkerSettings","type":"structure","members":{"License":{"locationName":"license"},"Payload":{"locationName":"payload","type":"integer"},"Preset":{"locationName":"preset"},"Strength":{"locationName":"strength"}}}}},"TimecodeBurnin":{"locationName":"timecodeBurnin","type":"structure","members":{"FontSize":{"locationName":"fontSize","type":"integer"},"Position":{"locationName":"position"},"Prefix":{"locationName":"prefix"}}}}},"Width":{"locationName":"width","type":"integer"}}},"Sj9":{"type":"structure","members":{"Anchor":{"locationName":"anchor"},"Source":{"locationName":"source"},"Start":{"locationName":"start"},"TimestampOffset":{"locationName":"timestampOffset"}}},"Sjc":{"type":"structure","members":{"Id3Insertions":{"locationName":"id3Insertions","type":"list","member":{"type":"structure","members":{"Id3":{"locationName":"id3"},"Timecode":{"locationName":"timecode"}}}}}},"Sjh":{"type":"map","key":{},"value":{}},"Sjj":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"AccelerationStatus":{"locationName":"accelerationStatus"},"Arn":{"locationName":"arn"},"BillingTagsSource":{"locationName":"billingTagsSource"},"CreatedAt":{"shape":"Sjl","locationName":"createdAt"},"CurrentPhase":{"locationName":"currentPhase"},"ErrorCode":{"locationName":"errorCode","type":"integer"},"ErrorMessage":{"locationName":"errorMessage"},"HopDestinations":{"shape":"Sa","locationName":"hopDestinations"},"Id":{"locationName":"id"},"JobPercentComplete":{"locationName":"jobPercentComplete","type":"integer"},"JobTemplate":{"locationName":"jobTemplate"},"Messages":{"locationName":"messages","type":"structure","members":{"Info":{"shape":"Sjo","locationName":"info"},"Warning":{"shape":"Sjo","locationName":"warning"}}},"OutputGroupDetails":{"locationName":"outputGroupDetails","type":"list","member":{"type":"structure","members":{"OutputDetails":{"locationName":"outputDetails","type":"list","member":{"type":"structure","members":{"DurationInMs":{"locationName":"durationInMs","type":"integer"},"VideoDetails":{"locationName":"videoDetails","type":"structure","members":{"HeightInPx":{"locationName":"heightInPx","type":"integer"},"WidthInPx":{"locationName":"widthInPx","type":"integer"}}}}}}}}},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"QueueTransitions":{"locationName":"queueTransitions","type":"list","member":{"type":"structure","members":{"DestinationQueue":{"locationName":"destinationQueue"},"SourceQueue":{"locationName":"sourceQueue"},"Timestamp":{"shape":"Sjl","locationName":"timestamp"}}}},"RetryCount":{"locationName":"retryCount","type":"integer"},"Role":{"locationName":"role"},"Settings":{"shape":"Se","locationName":"settings"},"SimulateReservedQueue":{"locationName":"simulateReservedQueue"},"Status":{"locationName":"status"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Timing":{"locationName":"timing","type":"structure","members":{"FinishTime":{"shape":"Sjl","locationName":"finishTime"},"StartTime":{"shape":"Sjl","locationName":"startTime"},"SubmitTime":{"shape":"Sjl","locationName":"submitTime"}}},"UserMetadata":{"shape":"Sjh","locationName":"userMetadata"}},"required":["Role","Settings"]},"Sjl":{"type":"timestamp","timestampFormat":"unixTimestamp"},"Sjo":{"type":"list","member":{}},"Sjz":{"type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"AvailBlanking":{"shape":"Sg","locationName":"availBlanking"},"Esam":{"shape":"Si","locationName":"esam"},"ExtendedDataServices":{"shape":"So","locationName":"extendedDataServices"},"Inputs":{"locationName":"inputs","type":"list","member":{"type":"structure","members":{"AudioSelectorGroups":{"shape":"St","locationName":"audioSelectorGroups"},"AudioSelectors":{"shape":"Sx","locationName":"audioSelectors"},"CaptionSelectors":{"shape":"S1i","locationName":"captionSelectors"},"Crop":{"shape":"S26","locationName":"crop"},"DeblockFilter":{"locationName":"deblockFilter"},"DenoiseFilter":{"locationName":"denoiseFilter"},"DolbyVisionMetadataXml":{"locationName":"dolbyVisionMetadataXml"},"FilterEnable":{"locationName":"filterEnable"},"FilterStrength":{"locationName":"filterStrength","type":"integer"},"ImageInserter":{"shape":"S2k","locationName":"imageInserter"},"InputClippings":{"shape":"S2r","locationName":"inputClippings"},"InputScanType":{"locationName":"inputScanType"},"Position":{"shape":"S26","locationName":"position"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"PsiControl":{"locationName":"psiControl"},"TimecodeSource":{"locationName":"timecodeSource"},"TimecodeStart":{"locationName":"timecodeStart"},"VideoSelector":{"shape":"S32","locationName":"videoSelector"}}}},"KantarWatermark":{"shape":"S3d","locationName":"kantarWatermark"},"MotionImageInserter":{"shape":"S3l","locationName":"motionImageInserter"},"NielsenConfiguration":{"shape":"S3t","locationName":"nielsenConfiguration"},"NielsenNonLinearWatermark":{"shape":"S3v","locationName":"nielsenNonLinearWatermark"},"OutputGroups":{"shape":"S42","locationName":"outputGroups"},"TimecodeConfig":{"shape":"Sj9","locationName":"timecodeConfig"},"TimedMetadataInsertion":{"shape":"Sjc","locationName":"timedMetadataInsertion"}}},"Sk3":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Arn":{"locationName":"arn"},"Category":{"locationName":"category"},"CreatedAt":{"shape":"Sjl","locationName":"createdAt"},"Description":{"locationName":"description"},"HopDestinations":{"shape":"Sa","locationName":"hopDestinations"},"LastUpdated":{"shape":"Sjl","locationName":"lastUpdated"},"Name":{"locationName":"name"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Settings":{"shape":"Sjz","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Type":{"locationName":"type"}},"required":["Settings","Name"]},"Sk6":{"type":"structure","members":{"AudioDescriptions":{"shape":"S78","locationName":"audioDescriptions"},"CaptionDescriptions":{"locationName":"captionDescriptions","type":"list","member":{"type":"structure","members":{"CustomLanguageCode":{"locationName":"customLanguageCode"},"DestinationSettings":{"shape":"S9q","locationName":"destinationSettings"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}}}},"ContainerSettings":{"shape":"Sb0","locationName":"containerSettings"},"VideoDescription":{"shape":"Sd9","locationName":"videoDescription"}}},"Ska":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Category":{"locationName":"category"},"CreatedAt":{"shape":"Sjl","locationName":"createdAt"},"Description":{"locationName":"description"},"LastUpdated":{"shape":"Sjl","locationName":"lastUpdated"},"Name":{"locationName":"name"},"Settings":{"shape":"Sk6","locationName":"settings"},"Type":{"locationName":"type"}},"required":["Settings","Name"]},"Skd":{"type":"structure","members":{"Commitment":{"locationName":"commitment"},"RenewalType":{"locationName":"renewalType"},"ReservedSlots":{"locationName":"reservedSlots","type":"integer"}},"required":["Commitment","ReservedSlots","RenewalType"]},"Ski":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreatedAt":{"shape":"Sjl","locationName":"createdAt"},"Description":{"locationName":"description"},"LastUpdated":{"shape":"Sjl","locationName":"lastUpdated"},"Name":{"locationName":"name"},"PricingPlan":{"locationName":"pricingPlan"},"ProgressingJobsCount":{"locationName":"progressingJobsCount","type":"integer"},"ReservationPlan":{"locationName":"reservationPlan","type":"structure","members":{"Commitment":{"locationName":"commitment"},"ExpiresAt":{"shape":"Sjl","locationName":"expiresAt"},"PurchasedAt":{"shape":"Sjl","locationName":"purchasedAt"},"RenewalType":{"locationName":"renewalType"},"ReservedSlots":{"locationName":"reservedSlots","type":"integer"},"Status":{"locationName":"status"}}},"Status":{"locationName":"status"},"SubmittedJobsCount":{"locationName":"submittedJobsCount","type":"integer"},"Type":{"locationName":"type"}},"required":["Name"]},"Sl6":{"type":"structure","members":{"HttpInputs":{"locationName":"httpInputs"},"HttpsInputs":{"locationName":"httpsInputs"},"S3Inputs":{"locationName":"s3Inputs"}}}}}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Endpoints"},"ListJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Jobs"},"ListPresets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Presets"},"ListJobTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"JobTemplates"},"ListQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Queues"}}}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['medialive'] = {};
	AWS.MediaLive = Service.defineService('medialive', ['2017-10-14']);
	Object.defineProperty(apiLoader.services['medialive'], '2017-10-14', {
	  get: function get() {
	    var model = __webpack_require__(530);
	    model.paginators = __webpack_require__(531).pagination;
	    model.waiters = __webpack_require__(532).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaLive;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-10-14","endpointPrefix":"medialive","signingName":"medialive","serviceFullName":"AWS Elemental MediaLive","serviceId":"MediaLive","protocol":"rest-json","uid":"medialive-2017-10-14","signatureVersion":"v4","serviceAbbreviation":"MediaLive","jsonVersion":"1.1"},"operations":{"AcceptInputDeviceTransfer":{"http":{"requestUri":"/prod/inputDevices/{inputDeviceId}/accept","responseCode":200},"input":{"type":"structure","members":{"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"}},"required":["InputDeviceId"]},"output":{"type":"structure","members":{}}},"BatchDelete":{"http":{"requestUri":"/prod/batch/delete","responseCode":200},"input":{"type":"structure","members":{"ChannelIds":{"shape":"S5","locationName":"channelIds"},"InputIds":{"shape":"S5","locationName":"inputIds"},"InputSecurityGroupIds":{"shape":"S5","locationName":"inputSecurityGroupIds"},"MultiplexIds":{"shape":"S5","locationName":"multiplexIds"}}},"output":{"type":"structure","members":{"Failed":{"shape":"S7","locationName":"failed"},"Successful":{"shape":"S9","locationName":"successful"}}}},"BatchStart":{"http":{"requestUri":"/prod/batch/start","responseCode":200},"input":{"type":"structure","members":{"ChannelIds":{"shape":"S5","locationName":"channelIds"},"MultiplexIds":{"shape":"S5","locationName":"multiplexIds"}}},"output":{"type":"structure","members":{"Failed":{"shape":"S7","locationName":"failed"},"Successful":{"shape":"S9","locationName":"successful"}}}},"BatchStop":{"http":{"requestUri":"/prod/batch/stop","responseCode":200},"input":{"type":"structure","members":{"ChannelIds":{"shape":"S5","locationName":"channelIds"},"MultiplexIds":{"shape":"S5","locationName":"multiplexIds"}}},"output":{"type":"structure","members":{"Failed":{"shape":"S7","locationName":"failed"},"Successful":{"shape":"S9","locationName":"successful"}}}},"BatchUpdateSchedule":{"http":{"method":"PUT","requestUri":"/prod/channels/{channelId}/schedule","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"},"Creates":{"locationName":"creates","type":"structure","members":{"ScheduleActions":{"shape":"Sh","locationName":"scheduleActions"}},"required":["ScheduleActions"]},"Deletes":{"locationName":"deletes","type":"structure","members":{"ActionNames":{"shape":"S5","locationName":"actionNames"}},"required":["ActionNames"]}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Creates":{"locationName":"creates","type":"structure","members":{"ScheduleActions":{"shape":"Sh","locationName":"scheduleActions"}},"required":["ScheduleActions"]},"Deletes":{"locationName":"deletes","type":"structure","members":{"ScheduleActions":{"shape":"Sh","locationName":"scheduleActions"}},"required":["ScheduleActions"]}}}},"CancelInputDeviceTransfer":{"http":{"requestUri":"/prod/inputDevices/{inputDeviceId}/cancel","responseCode":200},"input":{"type":"structure","members":{"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"}},"required":["InputDeviceId"]},"output":{"type":"structure","members":{}}},"ClaimDevice":{"http":{"requestUri":"/prod/claimDevice","responseCode":200},"input":{"type":"structure","members":{"Id":{"locationName":"id"}}},"output":{"type":"structure","members":{}}},"CreateChannel":{"http":{"requestUri":"/prod/channels","responseCode":201},"input":{"type":"structure","members":{"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"locationName":"maintenance","type":"structure","members":{"MaintenanceDay":{"locationName":"maintenanceDay"},"MaintenanceStartTime":{"locationName":"maintenanceStartTime"}}},"Name":{"locationName":"name"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"Reserved":{"locationName":"reserved","deprecated":true},"RoleArn":{"locationName":"roleArn"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"locationName":"vpc","type":"structure","members":{"PublicAddressAllocationIds":{"shape":"S5","locationName":"publicAddressAllocationIds"},"SecurityGroupIds":{"shape":"S5","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S5","locationName":"subnetIds"}},"required":["SubnetIds"]}}},"output":{"type":"structure","members":{"Channel":{"shape":"Seh","locationName":"channel"}}}},"CreateInput":{"http":{"requestUri":"/prod/inputs","responseCode":201},"input":{"type":"structure","members":{"Destinations":{"shape":"Seq","locationName":"destinations"},"InputDevices":{"shape":"Ses","locationName":"inputDevices"},"InputSecurityGroups":{"shape":"S5","locationName":"inputSecurityGroups"},"MediaConnectFlows":{"shape":"Seu","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"RoleArn":{"locationName":"roleArn"},"Sources":{"shape":"Sew","locationName":"sources"},"Tags":{"shape":"See","locationName":"tags"},"Type":{"locationName":"type"},"Vpc":{"locationName":"vpc","type":"structure","members":{"SecurityGroupIds":{"shape":"S5","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S5","locationName":"subnetIds"}},"required":["SubnetIds"]}}},"output":{"type":"structure","members":{"Input":{"shape":"Sf1","locationName":"input"}}}},"CreateInputSecurityGroup":{"http":{"requestUri":"/prod/inputSecurityGroups","responseCode":200},"input":{"type":"structure","members":{"Tags":{"shape":"See","locationName":"tags"},"WhitelistRules":{"shape":"Sfd","locationName":"whitelistRules"}}},"output":{"type":"structure","members":{"SecurityGroup":{"shape":"Sfg","locationName":"securityGroup"}}}},"CreateMultiplex":{"http":{"requestUri":"/prod/multiplexes","responseCode":201},"input":{"type":"structure","members":{"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"Tags":{"shape":"See","locationName":"tags"}},"required":["RequestId","MultiplexSettings","AvailabilityZones","Name"]},"output":{"type":"structure","members":{"Multiplex":{"shape":"Sfq","locationName":"multiplex"}}}},"CreateMultiplexProgram":{"http":{"requestUri":"/prod/multiplexes/{multiplexId}/programs","responseCode":201},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"},"MultiplexProgramSettings":{"shape":"Sfw","locationName":"multiplexProgramSettings"},"ProgramName":{"locationName":"programName"},"RequestId":{"locationName":"requestId","idempotencyToken":true}},"required":["MultiplexId","RequestId","MultiplexProgramSettings","ProgramName"]},"output":{"type":"structure","members":{"MultiplexProgram":{"shape":"Sg5","locationName":"multiplexProgram"}}}},"CreatePartnerInput":{"http":{"requestUri":"/prod/inputs/{inputId}/partners","responseCode":201},"input":{"type":"structure","members":{"InputId":{"location":"uri","locationName":"inputId"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"Tags":{"shape":"See","locationName":"tags"}},"required":["InputId"]},"output":{"type":"structure","members":{"Input":{"shape":"Sf1","locationName":"input"}}}},"CreateTags":{"http":{"requestUri":"/prod/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"See","locationName":"tags"}},"required":["ResourceArn"]}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/prod/channels/{channelId}","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EgressEndpoints":{"shape":"Sei","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"shape":"Sek","locationName":"maintenance"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sel","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"shape":"Seo","locationName":"vpc"}}}},"DeleteInput":{"http":{"method":"DELETE","requestUri":"/prod/inputs/{inputId}","responseCode":200},"input":{"type":"structure","members":{"InputId":{"location":"uri","locationName":"inputId"}},"required":["InputId"]},"output":{"type":"structure","members":{}}},"DeleteInputSecurityGroup":{"http":{"method":"DELETE","requestUri":"/prod/inputSecurityGroups/{inputSecurityGroupId}","responseCode":200},"input":{"type":"structure","members":{"InputSecurityGroupId":{"location":"uri","locationName":"inputSecurityGroupId"}},"required":["InputSecurityGroupId"]},"output":{"type":"structure","members":{}}},"DeleteMultiplex":{"http":{"method":"DELETE","requestUri":"/prod/multiplexes/{multiplexId}","responseCode":202},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"}},"required":["MultiplexId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"Destinations":{"shape":"Sfr","locationName":"destinations"},"Id":{"locationName":"id"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"ProgramCount":{"locationName":"programCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"}}}},"DeleteMultiplexProgram":{"http":{"method":"DELETE","requestUri":"/prod/multiplexes/{multiplexId}/programs/{programName}","responseCode":200},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"},"ProgramName":{"location":"uri","locationName":"programName"}},"required":["MultiplexId","ProgramName"]},"output":{"type":"structure","members":{"ChannelId":{"locationName":"channelId"},"MultiplexProgramSettings":{"shape":"Sfw","locationName":"multiplexProgramSettings"},"PacketIdentifiersMap":{"shape":"Sg6","locationName":"packetIdentifiersMap"},"PipelineDetails":{"shape":"Sg8","locationName":"pipelineDetails"},"ProgramName":{"locationName":"programName"}}}},"DeleteReservation":{"http":{"method":"DELETE","requestUri":"/prod/reservations/{reservationId}","responseCode":200},"input":{"type":"structure","members":{"ReservationId":{"location":"uri","locationName":"reservationId"}},"required":["ReservationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"Name":{"locationName":"name"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ReservationId":{"locationName":"reservationId"},"ResourceSpecification":{"shape":"Sgr","locationName":"resourceSpecification"},"Start":{"locationName":"start"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}},"DeleteSchedule":{"http":{"method":"DELETE","requestUri":"/prod/channels/{channelId}/schedule","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{}}},"DeleteTags":{"http":{"method":"DELETE","requestUri":"/prod/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"S5","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/prod/channels/{channelId}","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EgressEndpoints":{"shape":"Sei","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"shape":"Sek","locationName":"maintenance"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sel","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"shape":"Seo","locationName":"vpc"}}}},"DescribeInput":{"http":{"method":"GET","requestUri":"/prod/inputs/{inputId}","responseCode":200},"input":{"type":"structure","members":{"InputId":{"location":"uri","locationName":"inputId"}},"required":["InputId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AttachedChannels":{"shape":"S5","locationName":"attachedChannels"},"Destinations":{"shape":"Sf2","locationName":"destinations"},"Id":{"locationName":"id"},"InputClass":{"locationName":"inputClass"},"InputDevices":{"shape":"Ses","locationName":"inputDevices"},"InputPartnerIds":{"shape":"S5","locationName":"inputPartnerIds"},"InputSourceType":{"locationName":"inputSourceType"},"MediaConnectFlows":{"shape":"Sf7","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"},"SecurityGroups":{"shape":"S5","locationName":"securityGroups"},"Sources":{"shape":"Sf9","locationName":"sources"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Type":{"locationName":"type"}}}},"DescribeInputDevice":{"http":{"method":"GET","requestUri":"/prod/inputDevices/{inputDeviceId}","responseCode":200},"input":{"type":"structure","members":{"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"}},"required":["InputDeviceId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ConnectionState":{"locationName":"connectionState"},"DeviceSettingsSyncState":{"locationName":"deviceSettingsSyncState"},"DeviceUpdateStatus":{"locationName":"deviceUpdateStatus"},"HdDeviceSettings":{"shape":"Shc","locationName":"hdDeviceSettings"},"Id":{"locationName":"id"},"MacAddress":{"locationName":"macAddress"},"Name":{"locationName":"name"},"NetworkSettings":{"shape":"Shh","locationName":"networkSettings"},"SerialNumber":{"locationName":"serialNumber"},"Type":{"locationName":"type"},"UhdDeviceSettings":{"shape":"Shk","locationName":"uhdDeviceSettings"}}}},"DescribeInputDeviceThumbnail":{"http":{"method":"GET","requestUri":"/prod/inputDevices/{inputDeviceId}/thumbnailData","responseCode":200},"input":{"type":"structure","members":{"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"},"Accept":{"location":"header","locationName":"accept"}},"required":["InputDeviceId","Accept"]},"output":{"type":"structure","members":{"Body":{"locationName":"body","type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"}},"payload":"Body"}},"DescribeInputSecurityGroup":{"http":{"method":"GET","requestUri":"/prod/inputSecurityGroups/{inputSecurityGroupId}","responseCode":200},"input":{"type":"structure","members":{"InputSecurityGroupId":{"location":"uri","locationName":"inputSecurityGroupId"}},"required":["InputSecurityGroupId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"},"Inputs":{"shape":"S5","locationName":"inputs"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"WhitelistRules":{"shape":"Sfi","locationName":"whitelistRules"}}}},"DescribeMultiplex":{"http":{"method":"GET","requestUri":"/prod/multiplexes/{multiplexId}","responseCode":200},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"}},"required":["MultiplexId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"Destinations":{"shape":"Sfr","locationName":"destinations"},"Id":{"locationName":"id"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"ProgramCount":{"locationName":"programCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"}}}},"DescribeMultiplexProgram":{"http":{"method":"GET","requestUri":"/prod/multiplexes/{multiplexId}/programs/{programName}","responseCode":200},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"},"ProgramName":{"location":"uri","locationName":"programName"}},"required":["MultiplexId","ProgramName"]},"output":{"type":"structure","members":{"ChannelId":{"locationName":"channelId"},"MultiplexProgramSettings":{"shape":"Sfw","locationName":"multiplexProgramSettings"},"PacketIdentifiersMap":{"shape":"Sg6","locationName":"packetIdentifiersMap"},"PipelineDetails":{"shape":"Sg8","locationName":"pipelineDetails"},"ProgramName":{"locationName":"programName"}}}},"DescribeOffering":{"http":{"method":"GET","requestUri":"/prod/offerings/{offeringId}","responseCode":200},"input":{"type":"structure","members":{"OfferingId":{"location":"uri","locationName":"offeringId"}},"required":["OfferingId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ResourceSpecification":{"shape":"Sgr","locationName":"resourceSpecification"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}},"DescribeReservation":{"http":{"method":"GET","requestUri":"/prod/reservations/{reservationId}","responseCode":200},"input":{"type":"structure","members":{"ReservationId":{"location":"uri","locationName":"reservationId"}},"required":["ReservationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"Name":{"locationName":"name"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ReservationId":{"locationName":"reservationId"},"ResourceSpecification":{"shape":"Sgr","locationName":"resourceSpecification"},"Start":{"locationName":"start"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}},"DescribeSchedule":{"http":{"method":"GET","requestUri":"/prod/channels/{channelId}/schedule","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduleActions":{"shape":"Sh","locationName":"scheduleActions"}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/prod/channels","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Channels":{"locationName":"channels","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EgressEndpoints":{"shape":"Sei","locationName":"egressEndpoints"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"shape":"Sek","locationName":"maintenance"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"shape":"Seo","locationName":"vpc"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListInputDeviceTransfers":{"http":{"method":"GET","requestUri":"/prod/inputDeviceTransfers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"TransferType":{"location":"querystring","locationName":"transferType"}},"required":["TransferType"]},"output":{"type":"structure","members":{"InputDeviceTransfers":{"locationName":"inputDeviceTransfers","type":"list","member":{"type":"structure","members":{"Id":{"locationName":"id"},"Message":{"locationName":"message"},"TargetCustomerId":{"locationName":"targetCustomerId"},"TransferType":{"locationName":"transferType"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListInputDevices":{"http":{"method":"GET","requestUri":"/prod/inputDevices","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"InputDevices":{"locationName":"inputDevices","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ConnectionState":{"locationName":"connectionState"},"DeviceSettingsSyncState":{"locationName":"deviceSettingsSyncState"},"DeviceUpdateStatus":{"locationName":"deviceUpdateStatus"},"HdDeviceSettings":{"shape":"Shc","locationName":"hdDeviceSettings"},"Id":{"locationName":"id"},"MacAddress":{"locationName":"macAddress"},"Name":{"locationName":"name"},"NetworkSettings":{"shape":"Shh","locationName":"networkSettings"},"SerialNumber":{"locationName":"serialNumber"},"Type":{"locationName":"type"},"UhdDeviceSettings":{"shape":"Shk","locationName":"uhdDeviceSettings"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListInputSecurityGroups":{"http":{"method":"GET","requestUri":"/prod/inputSecurityGroups","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"InputSecurityGroups":{"locationName":"inputSecurityGroups","type":"list","member":{"shape":"Sfg"}},"NextToken":{"locationName":"nextToken"}}}},"ListInputs":{"http":{"method":"GET","requestUri":"/prod/inputs","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Inputs":{"locationName":"inputs","type":"list","member":{"shape":"Sf1"}},"NextToken":{"locationName":"nextToken"}}}},"ListMultiplexPrograms":{"http":{"method":"GET","requestUri":"/prod/multiplexes/{multiplexId}/programs","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"MultiplexId":{"location":"uri","locationName":"multiplexId"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["MultiplexId"]},"output":{"type":"structure","members":{"MultiplexPrograms":{"locationName":"multiplexPrograms","type":"list","member":{"type":"structure","members":{"ChannelId":{"locationName":"channelId"},"ProgramName":{"locationName":"programName"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListMultiplexes":{"http":{"method":"GET","requestUri":"/prod/multiplexes","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Multiplexes":{"locationName":"multiplexes","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"Id":{"locationName":"id"},"MultiplexSettings":{"locationName":"multiplexSettings","type":"structure","members":{"TransportStreamBitrate":{"locationName":"transportStreamBitrate","type":"integer"}}},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"ProgramCount":{"locationName":"programCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListOfferings":{"http":{"method":"GET","requestUri":"/prod/offerings","responseCode":200},"input":{"type":"structure","members":{"ChannelClass":{"location":"querystring","locationName":"channelClass"},"ChannelConfiguration":{"location":"querystring","locationName":"channelConfiguration"},"Codec":{"location":"querystring","locationName":"codec"},"Duration":{"location":"querystring","locationName":"duration"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"MaximumBitrate":{"location":"querystring","locationName":"maximumBitrate"},"MaximumFramerate":{"location":"querystring","locationName":"maximumFramerate"},"NextToken":{"location":"querystring","locationName":"nextToken"},"Resolution":{"location":"querystring","locationName":"resolution"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"SpecialFeature":{"location":"querystring","locationName":"specialFeature"},"VideoQuality":{"location":"querystring","locationName":"videoQuality"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Offerings":{"locationName":"offerings","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ResourceSpecification":{"shape":"Sgr","locationName":"resourceSpecification"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}}}}},"ListReservations":{"http":{"method":"GET","requestUri":"/prod/reservations","responseCode":200},"input":{"type":"structure","members":{"ChannelClass":{"location":"querystring","locationName":"channelClass"},"Codec":{"location":"querystring","locationName":"codec"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"MaximumBitrate":{"location":"querystring","locationName":"maximumBitrate"},"MaximumFramerate":{"location":"querystring","locationName":"maximumFramerate"},"NextToken":{"location":"querystring","locationName":"nextToken"},"Resolution":{"location":"querystring","locationName":"resolution"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"SpecialFeature":{"location":"querystring","locationName":"specialFeature"},"VideoQuality":{"location":"querystring","locationName":"videoQuality"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Reservations":{"locationName":"reservations","type":"list","member":{"shape":"Sj4"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/prod/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"See","locationName":"tags"}}}},"PurchaseOffering":{"http":{"requestUri":"/prod/offerings/{offeringId}/purchase","responseCode":201},"input":{"type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"OfferingId":{"location":"uri","locationName":"offeringId"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"Start":{"locationName":"start"},"Tags":{"shape":"See","locationName":"tags"}},"required":["OfferingId","Count"]},"output":{"type":"structure","members":{"Reservation":{"shape":"Sj4","locationName":"reservation"}}}},"RejectInputDeviceTransfer":{"http":{"requestUri":"/prod/inputDevices/{inputDeviceId}/reject","responseCode":200},"input":{"type":"structure","members":{"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"}},"required":["InputDeviceId"]},"output":{"type":"structure","members":{}}},"StartChannel":{"http":{"requestUri":"/prod/channels/{channelId}/start","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EgressEndpoints":{"shape":"Sei","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"shape":"Sek","locationName":"maintenance"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sel","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"shape":"Seo","locationName":"vpc"}}}},"StartMultiplex":{"http":{"requestUri":"/prod/multiplexes/{multiplexId}/start","responseCode":202},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"}},"required":["MultiplexId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"Destinations":{"shape":"Sfr","locationName":"destinations"},"Id":{"locationName":"id"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"ProgramCount":{"locationName":"programCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"}}}},"StopChannel":{"http":{"requestUri":"/prod/channels/{channelId}/stop","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EgressEndpoints":{"shape":"Sei","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"shape":"Sek","locationName":"maintenance"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sel","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"shape":"Seo","locationName":"vpc"}}}},"StopMultiplex":{"http":{"requestUri":"/prod/multiplexes/{multiplexId}/stop","responseCode":202},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"}},"required":["MultiplexId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"Destinations":{"shape":"Sfr","locationName":"destinations"},"Id":{"locationName":"id"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"ProgramCount":{"locationName":"programCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"}}}},"TransferInputDevice":{"http":{"requestUri":"/prod/inputDevices/{inputDeviceId}/transfer","responseCode":200},"input":{"type":"structure","members":{"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"},"TargetCustomerId":{"locationName":"targetCustomerId"},"TargetRegion":{"locationName":"targetRegion"},"TransferMessage":{"locationName":"transferMessage"}},"required":["InputDeviceId"]},"output":{"type":"structure","members":{}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/prod/channels/{channelId}","responseCode":200},"input":{"type":"structure","members":{"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelId":{"location":"uri","locationName":"channelId"},"Destinations":{"shape":"S25","locationName":"destinations"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"locationName":"maintenance","type":"structure","members":{"MaintenanceDay":{"locationName":"maintenanceDay"},"MaintenanceScheduledDate":{"locationName":"maintenanceScheduledDate"},"MaintenanceStartTime":{"locationName":"maintenanceStartTime"}}},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Channel":{"shape":"Seh","locationName":"channel"}}}},"UpdateChannelClass":{"http":{"method":"PUT","requestUri":"/prod/channels/{channelId}/channelClass","responseCode":200},"input":{"type":"structure","members":{"ChannelClass":{"locationName":"channelClass"},"ChannelId":{"location":"uri","locationName":"channelId"},"Destinations":{"shape":"S25","locationName":"destinations"}},"required":["ChannelId","ChannelClass"]},"output":{"type":"structure","members":{"Channel":{"shape":"Seh","locationName":"channel"}}}},"UpdateInput":{"http":{"method":"PUT","requestUri":"/prod/inputs/{inputId}","responseCode":200},"input":{"type":"structure","members":{"Destinations":{"shape":"Seq","locationName":"destinations"},"InputDevices":{"locationName":"inputDevices","type":"list","member":{"type":"structure","members":{"Id":{"locationName":"id"}}}},"InputId":{"location":"uri","locationName":"inputId"},"InputSecurityGroups":{"shape":"S5","locationName":"inputSecurityGroups"},"MediaConnectFlows":{"shape":"Seu","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"},"Sources":{"shape":"Sew","locationName":"sources"}},"required":["InputId"]},"output":{"type":"structure","members":{"Input":{"shape":"Sf1","locationName":"input"}}}},"UpdateInputDevice":{"http":{"method":"PUT","requestUri":"/prod/inputDevices/{inputDeviceId}","responseCode":200},"input":{"type":"structure","members":{"HdDeviceSettings":{"shape":"Sjv","locationName":"hdDeviceSettings"},"InputDeviceId":{"location":"uri","locationName":"inputDeviceId"},"Name":{"locationName":"name"},"UhdDeviceSettings":{"shape":"Sjv","locationName":"uhdDeviceSettings"}},"required":["InputDeviceId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ConnectionState":{"locationName":"connectionState"},"DeviceSettingsSyncState":{"locationName":"deviceSettingsSyncState"},"DeviceUpdateStatus":{"locationName":"deviceUpdateStatus"},"HdDeviceSettings":{"shape":"Shc","locationName":"hdDeviceSettings"},"Id":{"locationName":"id"},"MacAddress":{"locationName":"macAddress"},"Name":{"locationName":"name"},"NetworkSettings":{"shape":"Shh","locationName":"networkSettings"},"SerialNumber":{"locationName":"serialNumber"},"Type":{"locationName":"type"},"UhdDeviceSettings":{"shape":"Shk","locationName":"uhdDeviceSettings"}}}},"UpdateInputSecurityGroup":{"http":{"method":"PUT","requestUri":"/prod/inputSecurityGroups/{inputSecurityGroupId}","responseCode":200},"input":{"type":"structure","members":{"InputSecurityGroupId":{"location":"uri","locationName":"inputSecurityGroupId"},"Tags":{"shape":"See","locationName":"tags"},"WhitelistRules":{"shape":"Sfd","locationName":"whitelistRules"}},"required":["InputSecurityGroupId"]},"output":{"type":"structure","members":{"SecurityGroup":{"shape":"Sfg","locationName":"securityGroup"}}}},"UpdateMultiplex":{"http":{"method":"PUT","requestUri":"/prod/multiplexes/{multiplexId}","responseCode":200},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"}},"required":["MultiplexId"]},"output":{"type":"structure","members":{"Multiplex":{"shape":"Sfq","locationName":"multiplex"}}}},"UpdateMultiplexProgram":{"http":{"method":"PUT","requestUri":"/prod/multiplexes/{multiplexId}/programs/{programName}","responseCode":200},"input":{"type":"structure","members":{"MultiplexId":{"location":"uri","locationName":"multiplexId"},"MultiplexProgramSettings":{"shape":"Sfw","locationName":"multiplexProgramSettings"},"ProgramName":{"location":"uri","locationName":"programName"}},"required":["MultiplexId","ProgramName"]},"output":{"type":"structure","members":{"MultiplexProgram":{"shape":"Sg5","locationName":"multiplexProgram"}}}},"UpdateReservation":{"http":{"method":"PUT","requestUri":"/prod/reservations/{reservationId}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name"},"ReservationId":{"location":"uri","locationName":"reservationId"}},"required":["ReservationId"]},"output":{"type":"structure","members":{"Reservation":{"shape":"Sj4","locationName":"reservation"}}}}},"shapes":{"S5":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Code":{"locationName":"code"},"Id":{"locationName":"id"},"Message":{"locationName":"message"}}}},"S9":{"type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"},"State":{"locationName":"state"}}}},"Sh":{"type":"list","member":{"type":"structure","members":{"ActionName":{"locationName":"actionName"},"ScheduleActionSettings":{"locationName":"scheduleActionSettings","type":"structure","members":{"HlsId3SegmentTaggingSettings":{"locationName":"hlsId3SegmentTaggingSettings","type":"structure","members":{"Tag":{"locationName":"tag"}},"required":["Tag"]},"HlsTimedMetadataSettings":{"locationName":"hlsTimedMetadataSettings","type":"structure","members":{"Id3":{"locationName":"id3"}},"required":["Id3"]},"InputPrepareSettings":{"locationName":"inputPrepareSettings","type":"structure","members":{"InputAttachmentNameReference":{"locationName":"inputAttachmentNameReference"},"InputClippingSettings":{"shape":"Sn","locationName":"inputClippingSettings"},"UrlPath":{"shape":"S5","locationName":"urlPath"}}},"InputSwitchSettings":{"locationName":"inputSwitchSettings","type":"structure","members":{"InputAttachmentNameReference":{"locationName":"inputAttachmentNameReference"},"InputClippingSettings":{"shape":"Sn","locationName":"inputClippingSettings"},"UrlPath":{"shape":"S5","locationName":"urlPath"}},"required":["InputAttachmentNameReference"]},"MotionGraphicsImageActivateSettings":{"locationName":"motionGraphicsImageActivateSettings","type":"structure","members":{"Duration":{"locationName":"duration","type":"long"},"PasswordParam":{"locationName":"passwordParam"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}},"MotionGraphicsImageDeactivateSettings":{"locationName":"motionGraphicsImageDeactivateSettings","type":"structure","members":{}},"PauseStateSettings":{"locationName":"pauseStateSettings","type":"structure","members":{"Pipelines":{"locationName":"pipelines","type":"list","member":{"type":"structure","members":{"PipelineId":{"locationName":"pipelineId"}},"required":["PipelineId"]}}}},"Scte35ReturnToNetworkSettings":{"locationName":"scte35ReturnToNetworkSettings","type":"structure","members":{"SpliceEventId":{"locationName":"spliceEventId","type":"long"}},"required":["SpliceEventId"]},"Scte35SpliceInsertSettings":{"locationName":"scte35SpliceInsertSettings","type":"structure","members":{"Duration":{"locationName":"duration","type":"long"},"SpliceEventId":{"locationName":"spliceEventId","type":"long"}},"required":["SpliceEventId"]},"Scte35TimeSignalSettings":{"locationName":"scte35TimeSignalSettings","type":"structure","members":{"Scte35Descriptors":{"locationName":"scte35Descriptors","type":"list","member":{"type":"structure","members":{"Scte35DescriptorSettings":{"locationName":"scte35DescriptorSettings","type":"structure","members":{"SegmentationDescriptorScte35DescriptorSettings":{"locationName":"segmentationDescriptorScte35DescriptorSettings","type":"structure","members":{"DeliveryRestrictions":{"locationName":"deliveryRestrictions","type":"structure","members":{"ArchiveAllowedFlag":{"locationName":"archiveAllowedFlag"},"DeviceRestrictions":{"locationName":"deviceRestrictions"},"NoRegionalBlackoutFlag":{"locationName":"noRegionalBlackoutFlag"},"WebDeliveryAllowedFlag":{"locationName":"webDeliveryAllowedFlag"}},"required":["DeviceRestrictions","ArchiveAllowedFlag","WebDeliveryAllowedFlag","NoRegionalBlackoutFlag"]},"SegmentNum":{"locationName":"segmentNum","type":"integer"},"SegmentationCancelIndicator":{"locationName":"segmentationCancelIndicator"},"SegmentationDuration":{"locationName":"segmentationDuration","type":"long"},"SegmentationEventId":{"locationName":"segmentationEventId","type":"long"},"SegmentationTypeId":{"locationName":"segmentationTypeId","type":"integer"},"SegmentationUpid":{"locationName":"segmentationUpid"},"SegmentationUpidType":{"locationName":"segmentationUpidType","type":"integer"},"SegmentsExpected":{"locationName":"segmentsExpected","type":"integer"},"SubSegmentNum":{"locationName":"subSegmentNum","type":"integer"},"SubSegmentsExpected":{"locationName":"subSegmentsExpected","type":"integer"}},"required":["SegmentationEventId","SegmentationCancelIndicator"]}},"required":["SegmentationDescriptorScte35DescriptorSettings"]}},"required":["Scte35DescriptorSettings"]}}},"required":["Scte35Descriptors"]},"StaticImageActivateSettings":{"locationName":"staticImageActivateSettings","type":"structure","members":{"Duration":{"locationName":"duration","type":"integer"},"FadeIn":{"locationName":"fadeIn","type":"integer"},"FadeOut":{"locationName":"fadeOut","type":"integer"},"Height":{"locationName":"height","type":"integer"},"Image":{"shape":"S1k","locationName":"image"},"ImageX":{"locationName":"imageX","type":"integer"},"ImageY":{"locationName":"imageY","type":"integer"},"Layer":{"locationName":"layer","type":"integer"},"Opacity":{"locationName":"opacity","type":"integer"},"Width":{"locationName":"width","type":"integer"}},"required":["Image"]},"StaticImageDeactivateSettings":{"locationName":"staticImageDeactivateSettings","type":"structure","members":{"FadeOut":{"locationName":"fadeOut","type":"integer"},"Layer":{"locationName":"layer","type":"integer"}}}}},"ScheduleActionStartSettings":{"locationName":"scheduleActionStartSettings","type":"structure","members":{"FixedModeScheduleActionStartSettings":{"locationName":"fixedModeScheduleActionStartSettings","type":"structure","members":{"Time":{"locationName":"time"}},"required":["Time"]},"FollowModeScheduleActionStartSettings":{"locationName":"followModeScheduleActionStartSettings","type":"structure","members":{"FollowPoint":{"locationName":"followPoint"},"ReferenceActionName":{"locationName":"referenceActionName"}},"required":["ReferenceActionName","FollowPoint"]},"ImmediateModeScheduleActionStartSettings":{"locationName":"immediateModeScheduleActionStartSettings","type":"structure","members":{}}}}},"required":["ActionName","ScheduleActionStartSettings","ScheduleActionSettings"]}},"Sn":{"type":"structure","members":{"InputTimecodeSource":{"locationName":"inputTimecodeSource"},"StartTimecode":{"locationName":"startTimecode","type":"structure","members":{"Timecode":{"locationName":"timecode"}}},"StopTimecode":{"locationName":"stopTimecode","type":"structure","members":{"LastFrameClippingBehavior":{"locationName":"lastFrameClippingBehavior"},"Timecode":{"locationName":"timecode"}}}},"required":["InputTimecodeSource"]},"S1k":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"Uri":{"locationName":"uri"},"Username":{"locationName":"username"}},"required":["Uri"]},"S22":{"type":"structure","members":{"Resolution":{"locationName":"resolution"}}},"S25":{"type":"list","member":{"type":"structure","members":{"Id":{"locationName":"id"},"MediaPackageSettings":{"locationName":"mediaPackageSettings","type":"list","member":{"type":"structure","members":{"ChannelId":{"locationName":"channelId"}}}},"MultiplexSettings":{"locationName":"multiplexSettings","type":"structure","members":{"MultiplexId":{"locationName":"multiplexId"},"ProgramName":{"locationName":"programName"}}},"Settings":{"locationName":"settings","type":"list","member":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"StreamName":{"locationName":"streamName"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}}}}}},"S2d":{"type":"structure","members":{"AudioDescriptions":{"locationName":"audioDescriptions","type":"list","member":{"type":"structure","members":{"AudioNormalizationSettings":{"locationName":"audioNormalizationSettings","type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"AlgorithmControl":{"locationName":"algorithmControl"},"TargetLkfs":{"locationName":"targetLkfs","type":"double"}}},"AudioSelectorName":{"locationName":"audioSelectorName"},"AudioType":{"locationName":"audioType"},"AudioTypeControl":{"locationName":"audioTypeControl"},"AudioWatermarkingSettings":{"locationName":"audioWatermarkingSettings","type":"structure","members":{"NielsenWatermarksSettings":{"locationName":"nielsenWatermarksSettings","type":"structure","members":{"NielsenCbetSettings":{"locationName":"nielsenCbetSettings","type":"structure","members":{"CbetCheckDigitString":{"locationName":"cbetCheckDigitString"},"CbetStepaside":{"locationName":"cbetStepaside"},"Csid":{"locationName":"csid"}},"required":["CbetCheckDigitString","CbetStepaside","Csid"]},"NielsenDistributionType":{"locationName":"nielsenDistributionType"},"NielsenNaesIiNwSettings":{"locationName":"nielsenNaesIiNwSettings","type":"structure","members":{"CheckDigitString":{"locationName":"checkDigitString"},"Sid":{"locationName":"sid","type":"double"}},"required":["CheckDigitString","Sid"]}}}}},"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"AacSettings":{"locationName":"aacSettings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"double"},"CodingMode":{"locationName":"codingMode"},"InputType":{"locationName":"inputType"},"Profile":{"locationName":"profile"},"RateControlMode":{"locationName":"rateControlMode"},"RawFormat":{"locationName":"rawFormat"},"SampleRate":{"locationName":"sampleRate","type":"double"},"Spec":{"locationName":"spec"},"VbrQuality":{"locationName":"vbrQuality"}}},"Ac3Settings":{"locationName":"ac3Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"double"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DrcProfile":{"locationName":"drcProfile"},"LfeFilter":{"locationName":"lfeFilter"},"MetadataControl":{"locationName":"metadataControl"}}},"Eac3Settings":{"locationName":"eac3Settings","type":"structure","members":{"AttenuationControl":{"locationName":"attenuationControl"},"Bitrate":{"locationName":"bitrate","type":"double"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"DcFilter":{"locationName":"dcFilter"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DrcLine":{"locationName":"drcLine"},"DrcRf":{"locationName":"drcRf"},"LfeControl":{"locationName":"lfeControl"},"LfeFilter":{"locationName":"lfeFilter"},"LoRoCenterMixLevel":{"locationName":"loRoCenterMixLevel","type":"double"},"LoRoSurroundMixLevel":{"locationName":"loRoSurroundMixLevel","type":"double"},"LtRtCenterMixLevel":{"locationName":"ltRtCenterMixLevel","type":"double"},"LtRtSurroundMixLevel":{"locationName":"ltRtSurroundMixLevel","type":"double"},"MetadataControl":{"locationName":"metadataControl"},"PassthroughControl":{"locationName":"passthroughControl"},"PhaseControl":{"locationName":"phaseControl"},"StereoDownmix":{"locationName":"stereoDownmix"},"SurroundExMode":{"locationName":"surroundExMode"},"SurroundMode":{"locationName":"surroundMode"}}},"Mp2Settings":{"locationName":"mp2Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"double"},"CodingMode":{"locationName":"codingMode"},"SampleRate":{"locationName":"sampleRate","type":"double"}}},"PassThroughSettings":{"locationName":"passThroughSettings","type":"structure","members":{}},"WavSettings":{"locationName":"wavSettings","type":"structure","members":{"BitDepth":{"locationName":"bitDepth","type":"double"},"CodingMode":{"locationName":"codingMode"},"SampleRate":{"locationName":"sampleRate","type":"double"}}}}},"LanguageCode":{"locationName":"languageCode"},"LanguageCodeControl":{"locationName":"languageCodeControl"},"Name":{"locationName":"name"},"RemixSettings":{"locationName":"remixSettings","type":"structure","members":{"ChannelMappings":{"locationName":"channelMappings","type":"list","member":{"type":"structure","members":{"InputChannelLevels":{"locationName":"inputChannelLevels","type":"list","member":{"type":"structure","members":{"Gain":{"locationName":"gain","type":"integer"},"InputChannel":{"locationName":"inputChannel","type":"integer"}},"required":["InputChannel","Gain"]}},"OutputChannel":{"locationName":"outputChannel","type":"integer"}},"required":["OutputChannel","InputChannelLevels"]}},"ChannelsIn":{"locationName":"channelsIn","type":"integer"},"ChannelsOut":{"locationName":"channelsOut","type":"integer"}},"required":["ChannelMappings"]},"StreamName":{"locationName":"streamName"}},"required":["AudioSelectorName","Name"]}},"AvailBlanking":{"locationName":"availBlanking","type":"structure","members":{"AvailBlankingImage":{"shape":"S1k","locationName":"availBlankingImage"},"State":{"locationName":"state"}}},"AvailConfiguration":{"locationName":"availConfiguration","type":"structure","members":{"AvailSettings":{"locationName":"availSettings","type":"structure","members":{"Scte35SpliceInsert":{"locationName":"scte35SpliceInsert","type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"NoRegionalBlackoutFlag":{"locationName":"noRegionalBlackoutFlag"},"WebDeliveryAllowedFlag":{"locationName":"webDeliveryAllowedFlag"}}},"Scte35TimeSignalApos":{"locationName":"scte35TimeSignalApos","type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"NoRegionalBlackoutFlag":{"locationName":"noRegionalBlackoutFlag"},"WebDeliveryAllowedFlag":{"locationName":"webDeliveryAllowedFlag"}}}}}}},"BlackoutSlate":{"locationName":"blackoutSlate","type":"structure","members":{"BlackoutSlateImage":{"shape":"S1k","locationName":"blackoutSlateImage"},"NetworkEndBlackout":{"locationName":"networkEndBlackout"},"NetworkEndBlackoutImage":{"shape":"S1k","locationName":"networkEndBlackoutImage"},"NetworkId":{"locationName":"networkId"},"State":{"locationName":"state"}}},"CaptionDescriptions":{"locationName":"captionDescriptions","type":"list","member":{"type":"structure","members":{"CaptionSelectorName":{"locationName":"captionSelectorName"},"DestinationSettings":{"locationName":"destinationSettings","type":"structure","members":{"AribDestinationSettings":{"locationName":"aribDestinationSettings","type":"structure","members":{}},"BurnInDestinationSettings":{"locationName":"burnInDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"Font":{"shape":"S1k","locationName":"font"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontSize":{"locationName":"fontSize"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"TeletextGridControl":{"locationName":"teletextGridControl"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"DvbSubDestinationSettings":{"locationName":"dvbSubDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"Font":{"shape":"S1k","locationName":"font"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontSize":{"locationName":"fontSize"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"TeletextGridControl":{"locationName":"teletextGridControl"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"EbuTtDDestinationSettings":{"locationName":"ebuTtDDestinationSettings","type":"structure","members":{"CopyrightHolder":{"locationName":"copyrightHolder"},"FillLineGap":{"locationName":"fillLineGap"},"FontFamily":{"locationName":"fontFamily"},"StyleControl":{"locationName":"styleControl"}}},"EmbeddedDestinationSettings":{"locationName":"embeddedDestinationSettings","type":"structure","members":{}},"EmbeddedPlusScte20DestinationSettings":{"locationName":"embeddedPlusScte20DestinationSettings","type":"structure","members":{}},"RtmpCaptionInfoDestinationSettings":{"locationName":"rtmpCaptionInfoDestinationSettings","type":"structure","members":{}},"Scte20PlusEmbeddedDestinationSettings":{"locationName":"scte20PlusEmbeddedDestinationSettings","type":"structure","members":{}},"Scte27DestinationSettings":{"locationName":"scte27DestinationSettings","type":"structure","members":{}},"SmpteTtDestinationSettings":{"locationName":"smpteTtDestinationSettings","type":"structure","members":{}},"TeletextDestinationSettings":{"locationName":"teletextDestinationSettings","type":"structure","members":{}},"TtmlDestinationSettings":{"locationName":"ttmlDestinationSettings","type":"structure","members":{"StyleControl":{"locationName":"styleControl"}}},"WebvttDestinationSettings":{"locationName":"webvttDestinationSettings","type":"structure","members":{"StyleControl":{"locationName":"styleControl"}}}}},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"},"Name":{"locationName":"name"}},"required":["CaptionSelectorName","Name"]}},"FeatureActivations":{"locationName":"featureActivations","type":"structure","members":{"InputPrepareScheduleActions":{"locationName":"inputPrepareScheduleActions"}}},"GlobalConfiguration":{"locationName":"globalConfiguration","type":"structure","members":{"InitialAudioGain":{"locationName":"initialAudioGain","type":"integer"},"InputEndAction":{"locationName":"inputEndAction"},"InputLossBehavior":{"locationName":"inputLossBehavior","type":"structure","members":{"BlackFrameMsec":{"locationName":"blackFrameMsec","type":"integer"},"InputLossImageColor":{"locationName":"inputLossImageColor"},"InputLossImageSlate":{"shape":"S1k","locationName":"inputLossImageSlate"},"InputLossImageType":{"locationName":"inputLossImageType"},"RepeatFrameMsec":{"locationName":"repeatFrameMsec","type":"integer"}}},"OutputLockingMode":{"locationName":"outputLockingMode"},"OutputTimingSource":{"locationName":"outputTimingSource"},"SupportLowFramerateInputs":{"locationName":"supportLowFramerateInputs"}}},"MotionGraphicsConfiguration":{"locationName":"motionGraphicsConfiguration","type":"structure","members":{"MotionGraphicsInsertion":{"locationName":"motionGraphicsInsertion"},"MotionGraphicsSettings":{"locationName":"motionGraphicsSettings","type":"structure","members":{"HtmlMotionGraphicsSettings":{"locationName":"htmlMotionGraphicsSettings","type":"structure","members":{}}}}},"required":["MotionGraphicsSettings"]},"NielsenConfiguration":{"locationName":"nielsenConfiguration","type":"structure","members":{"DistributorId":{"locationName":"distributorId"},"NielsenPcmToId3Tagging":{"locationName":"nielsenPcmToId3Tagging"}}},"OutputGroups":{"locationName":"outputGroups","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"OutputGroupSettings":{"locationName":"outputGroupSettings","type":"structure","members":{"ArchiveGroupSettings":{"locationName":"archiveGroupSettings","type":"structure","members":{"ArchiveCdnSettings":{"locationName":"archiveCdnSettings","type":"structure","members":{"ArchiveS3Settings":{"locationName":"archiveS3Settings","type":"structure","members":{"CannedAcl":{"locationName":"cannedAcl"}}}}},"Destination":{"shape":"S6c","locationName":"destination"},"RolloverInterval":{"locationName":"rolloverInterval","type":"integer"}},"required":["Destination"]},"FrameCaptureGroupSettings":{"locationName":"frameCaptureGroupSettings","type":"structure","members":{"Destination":{"shape":"S6c","locationName":"destination"},"FrameCaptureCdnSettings":{"locationName":"frameCaptureCdnSettings","type":"structure","members":{"FrameCaptureS3Settings":{"locationName":"frameCaptureS3Settings","type":"structure","members":{"CannedAcl":{"locationName":"cannedAcl"}}}}}},"required":["Destination"]},"HlsGroupSettings":{"locationName":"hlsGroupSettings","type":"structure","members":{"AdMarkers":{"locationName":"adMarkers","type":"list","member":{}},"BaseUrlContent":{"locationName":"baseUrlContent"},"BaseUrlContent1":{"locationName":"baseUrlContent1"},"BaseUrlManifest":{"locationName":"baseUrlManifest"},"BaseUrlManifest1":{"locationName":"baseUrlManifest1"},"CaptionLanguageMappings":{"locationName":"captionLanguageMappings","type":"list","member":{"type":"structure","members":{"CaptionChannel":{"locationName":"captionChannel","type":"integer"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}},"required":["LanguageCode","LanguageDescription","CaptionChannel"]}},"CaptionLanguageSetting":{"locationName":"captionLanguageSetting"},"ClientCache":{"locationName":"clientCache"},"CodecSpecification":{"locationName":"codecSpecification"},"ConstantIv":{"locationName":"constantIv"},"Destination":{"shape":"S6c","locationName":"destination"},"DirectoryStructure":{"locationName":"directoryStructure"},"DiscontinuityTags":{"locationName":"discontinuityTags"},"EncryptionType":{"locationName":"encryptionType"},"HlsCdnSettings":{"locationName":"hlsCdnSettings","type":"structure","members":{"HlsAkamaiSettings":{"locationName":"hlsAkamaiSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"HttpTransferMode":{"locationName":"httpTransferMode"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"},"Salt":{"locationName":"salt"},"Token":{"locationName":"token"}}},"HlsBasicPutSettings":{"locationName":"hlsBasicPutSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}},"HlsMediaStoreSettings":{"locationName":"hlsMediaStoreSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"MediaStoreStorageClass":{"locationName":"mediaStoreStorageClass"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}},"HlsS3Settings":{"locationName":"hlsS3Settings","type":"structure","members":{"CannedAcl":{"locationName":"cannedAcl"}}},"HlsWebdavSettings":{"locationName":"hlsWebdavSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"HttpTransferMode":{"locationName":"httpTransferMode"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}}}},"HlsId3SegmentTagging":{"locationName":"hlsId3SegmentTagging"},"IFrameOnlyPlaylists":{"locationName":"iFrameOnlyPlaylists"},"IncompleteSegmentBehavior":{"locationName":"incompleteSegmentBehavior"},"IndexNSegments":{"locationName":"indexNSegments","type":"integer"},"InputLossAction":{"locationName":"inputLossAction"},"IvInManifest":{"locationName":"ivInManifest"},"IvSource":{"locationName":"ivSource"},"KeepSegments":{"locationName":"keepSegments","type":"integer"},"KeyFormat":{"locationName":"keyFormat"},"KeyFormatVersions":{"locationName":"keyFormatVersions"},"KeyProviderSettings":{"locationName":"keyProviderSettings","type":"structure","members":{"StaticKeySettings":{"locationName":"staticKeySettings","type":"structure","members":{"KeyProviderServer":{"shape":"S1k","locationName":"keyProviderServer"},"StaticKeyValue":{"locationName":"staticKeyValue"}},"required":["StaticKeyValue"]}}},"ManifestCompression":{"locationName":"manifestCompression"},"ManifestDurationFormat":{"locationName":"manifestDurationFormat"},"MinSegmentLength":{"locationName":"minSegmentLength","type":"integer"},"Mode":{"locationName":"mode"},"OutputSelection":{"locationName":"outputSelection"},"ProgramDateTime":{"locationName":"programDateTime"},"ProgramDateTimeClock":{"locationName":"programDateTimeClock"},"ProgramDateTimePeriod":{"locationName":"programDateTimePeriod","type":"integer"},"RedundantManifest":{"locationName":"redundantManifest"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"SegmentationMode":{"locationName":"segmentationMode"},"SegmentsPerSubdirectory":{"locationName":"segmentsPerSubdirectory","type":"integer"},"StreamInfResolution":{"locationName":"streamInfResolution"},"TimedMetadataId3Frame":{"locationName":"timedMetadataId3Frame"},"TimedMetadataId3Period":{"locationName":"timedMetadataId3Period","type":"integer"},"TimestampDeltaMilliseconds":{"locationName":"timestampDeltaMilliseconds","type":"integer"},"TsFileMode":{"locationName":"tsFileMode"}},"required":["Destination"]},"MediaPackageGroupSettings":{"locationName":"mediaPackageGroupSettings","type":"structure","members":{"Destination":{"shape":"S6c","locationName":"destination"}},"required":["Destination"]},"MsSmoothGroupSettings":{"locationName":"msSmoothGroupSettings","type":"structure","members":{"AcquisitionPointId":{"locationName":"acquisitionPointId"},"AudioOnlyTimecodeControl":{"locationName":"audioOnlyTimecodeControl"},"CertificateMode":{"locationName":"certificateMode"},"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"Destination":{"shape":"S6c","locationName":"destination"},"EventId":{"locationName":"eventId"},"EventIdMode":{"locationName":"eventIdMode"},"EventStopBehavior":{"locationName":"eventStopBehavior"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"InputLossAction":{"locationName":"inputLossAction"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"},"SegmentationMode":{"locationName":"segmentationMode"},"SendDelayMs":{"locationName":"sendDelayMs","type":"integer"},"SparseTrackType":{"locationName":"sparseTrackType"},"StreamManifestBehavior":{"locationName":"streamManifestBehavior"},"TimestampOffset":{"locationName":"timestampOffset"},"TimestampOffsetMode":{"locationName":"timestampOffsetMode"}},"required":["Destination"]},"MultiplexGroupSettings":{"locationName":"multiplexGroupSettings","type":"structure","members":{}},"RtmpGroupSettings":{"locationName":"rtmpGroupSettings","type":"structure","members":{"AdMarkers":{"locationName":"adMarkers","type":"list","member":{}},"AuthenticationScheme":{"locationName":"authenticationScheme"},"CacheFullBehavior":{"locationName":"cacheFullBehavior"},"CacheLength":{"locationName":"cacheLength","type":"integer"},"CaptionData":{"locationName":"captionData"},"InputLossAction":{"locationName":"inputLossAction"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}},"UdpGroupSettings":{"locationName":"udpGroupSettings","type":"structure","members":{"InputLossAction":{"locationName":"inputLossAction"},"TimedMetadataId3Frame":{"locationName":"timedMetadataId3Frame"},"TimedMetadataId3Period":{"locationName":"timedMetadataId3Period","type":"integer"}}}}},"Outputs":{"locationName":"outputs","type":"list","member":{"type":"structure","members":{"AudioDescriptionNames":{"shape":"S5","locationName":"audioDescriptionNames"},"CaptionDescriptionNames":{"shape":"S5","locationName":"captionDescriptionNames"},"OutputName":{"locationName":"outputName"},"OutputSettings":{"locationName":"outputSettings","type":"structure","members":{"ArchiveOutputSettings":{"locationName":"archiveOutputSettings","type":"structure","members":{"ContainerSettings":{"locationName":"containerSettings","type":"structure","members":{"M2tsSettings":{"shape":"S8j","locationName":"m2tsSettings"},"RawSettings":{"locationName":"rawSettings","type":"structure","members":{}}}},"Extension":{"locationName":"extension"},"NameModifier":{"locationName":"nameModifier"}},"required":["ContainerSettings"]},"FrameCaptureOutputSettings":{"locationName":"frameCaptureOutputSettings","type":"structure","members":{"NameModifier":{"locationName":"nameModifier"}}},"HlsOutputSettings":{"locationName":"hlsOutputSettings","type":"structure","members":{"H265PackagingType":{"locationName":"h265PackagingType"},"HlsSettings":{"locationName":"hlsSettings","type":"structure","members":{"AudioOnlyHlsSettings":{"locationName":"audioOnlyHlsSettings","type":"structure","members":{"AudioGroupId":{"locationName":"audioGroupId"},"AudioOnlyImage":{"shape":"S1k","locationName":"audioOnlyImage"},"AudioTrackType":{"locationName":"audioTrackType"},"SegmentType":{"locationName":"segmentType"}}},"Fmp4HlsSettings":{"locationName":"fmp4HlsSettings","type":"structure","members":{"AudioRenditionSets":{"locationName":"audioRenditionSets"},"NielsenId3Behavior":{"locationName":"nielsenId3Behavior"},"TimedMetadataBehavior":{"locationName":"timedMetadataBehavior"}}},"FrameCaptureHlsSettings":{"locationName":"frameCaptureHlsSettings","type":"structure","members":{}},"StandardHlsSettings":{"locationName":"standardHlsSettings","type":"structure","members":{"AudioRenditionSets":{"locationName":"audioRenditionSets"},"M3u8Settings":{"locationName":"m3u8Settings","type":"structure","members":{"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"locationName":"audioPids"},"EcmPid":{"locationName":"ecmPid"},"NielsenId3Behavior":{"locationName":"nielsenId3Behavior"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPeriod":{"locationName":"pcrPeriod","type":"integer"},"PcrPid":{"locationName":"pcrPid"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid"},"ProgramNum":{"locationName":"programNum","type":"integer"},"Scte35Behavior":{"locationName":"scte35Behavior"},"Scte35Pid":{"locationName":"scte35Pid"},"TimedMetadataBehavior":{"locationName":"timedMetadataBehavior"},"TimedMetadataPid":{"locationName":"timedMetadataPid"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid"}}}},"required":["M3u8Settings"]}}},"NameModifier":{"locationName":"nameModifier"},"SegmentModifier":{"locationName":"segmentModifier"}},"required":["HlsSettings"]},"MediaPackageOutputSettings":{"locationName":"mediaPackageOutputSettings","type":"structure","members":{}},"MsSmoothOutputSettings":{"locationName":"msSmoothOutputSettings","type":"structure","members":{"H265PackagingType":{"locationName":"h265PackagingType"},"NameModifier":{"locationName":"nameModifier"}}},"MultiplexOutputSettings":{"locationName":"multiplexOutputSettings","type":"structure","members":{"Destination":{"shape":"S6c","locationName":"destination"}},"required":["Destination"]},"RtmpOutputSettings":{"locationName":"rtmpOutputSettings","type":"structure","members":{"CertificateMode":{"locationName":"certificateMode"},"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"Destination":{"shape":"S6c","locationName":"destination"},"NumRetries":{"locationName":"numRetries","type":"integer"}},"required":["Destination"]},"UdpOutputSettings":{"locationName":"udpOutputSettings","type":"structure","members":{"BufferMsec":{"locationName":"bufferMsec","type":"integer"},"ContainerSettings":{"locationName":"containerSettings","type":"structure","members":{"M2tsSettings":{"shape":"S8j","locationName":"m2tsSettings"}}},"Destination":{"shape":"S6c","locationName":"destination"},"FecOutputSettings":{"locationName":"fecOutputSettings","type":"structure","members":{"ColumnDepth":{"locationName":"columnDepth","type":"integer"},"IncludeFec":{"locationName":"includeFec"},"RowLength":{"locationName":"rowLength","type":"integer"}}}},"required":["Destination","ContainerSettings"]}}},"VideoDescriptionName":{"locationName":"videoDescriptionName"}},"required":["OutputSettings"]}}},"required":["Outputs","OutputGroupSettings"]}},"TimecodeConfig":{"locationName":"timecodeConfig","type":"structure","members":{"Source":{"locationName":"source"},"SyncThreshold":{"locationName":"syncThreshold","type":"integer"}},"required":["Source"]},"VideoDescriptions":{"locationName":"videoDescriptions","type":"list","member":{"type":"structure","members":{"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"FrameCaptureSettings":{"locationName":"frameCaptureSettings","type":"structure","members":{"CaptureInterval":{"locationName":"captureInterval","type":"integer"},"CaptureIntervalUnits":{"locationName":"captureIntervalUnits"}}},"H264Settings":{"locationName":"h264Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"AfdSignaling":{"locationName":"afdSignaling"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufFillPct":{"locationName":"bufFillPct","type":"integer"},"BufSize":{"locationName":"bufSize","type":"integer"},"ColorMetadata":{"locationName":"colorMetadata"},"ColorSpaceSettings":{"locationName":"colorSpaceSettings","type":"structure","members":{"ColorSpacePassthroughSettings":{"shape":"Saq","locationName":"colorSpacePassthroughSettings"},"Rec601Settings":{"shape":"Sar","locationName":"rec601Settings"},"Rec709Settings":{"shape":"Sas","locationName":"rec709Settings"}}},"EntropyEncoding":{"locationName":"entropyEncoding"},"FilterSettings":{"locationName":"filterSettings","type":"structure","members":{"TemporalFilterSettings":{"shape":"Sav","locationName":"temporalFilterSettings"}}},"FixedAfd":{"locationName":"fixedAfd"},"FlickerAq":{"locationName":"flickerAq"},"ForceFieldPictures":{"locationName":"forceFieldPictures"},"FramerateControl":{"locationName":"framerateControl"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopNumBFrames":{"locationName":"gopNumBFrames","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"Level":{"locationName":"level"},"LookAheadRateControl":{"locationName":"lookAheadRateControl"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumRefFrames":{"locationName":"numRefFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"Profile":{"locationName":"profile"},"QualityLevel":{"locationName":"qualityLevel"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"},"RateControlMode":{"locationName":"rateControlMode"},"ScanType":{"locationName":"scanType"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAq":{"locationName":"spatialAq"},"SubgopLength":{"locationName":"subgopLength"},"Syntax":{"locationName":"syntax"},"TemporalAq":{"locationName":"temporalAq"},"TimecodeInsertion":{"locationName":"timecodeInsertion"}}},"H265Settings":{"locationName":"h265Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"AfdSignaling":{"locationName":"afdSignaling"},"AlternativeTransferFunction":{"locationName":"alternativeTransferFunction"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufSize":{"locationName":"bufSize","type":"integer"},"ColorMetadata":{"locationName":"colorMetadata"},"ColorSpaceSettings":{"locationName":"colorSpaceSettings","type":"structure","members":{"ColorSpacePassthroughSettings":{"shape":"Saq","locationName":"colorSpacePassthroughSettings"},"Hdr10Settings":{"shape":"Sbt","locationName":"hdr10Settings"},"Rec601Settings":{"shape":"Sar","locationName":"rec601Settings"},"Rec709Settings":{"shape":"Sas","locationName":"rec709Settings"}}},"FilterSettings":{"locationName":"filterSettings","type":"structure","members":{"TemporalFilterSettings":{"shape":"Sav","locationName":"temporalFilterSettings"}}},"FixedAfd":{"locationName":"fixedAfd"},"FlickerAq":{"locationName":"flickerAq"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"Level":{"locationName":"level"},"LookAheadRateControl":{"locationName":"lookAheadRateControl"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"Profile":{"locationName":"profile"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"},"RateControlMode":{"locationName":"rateControlMode"},"ScanType":{"locationName":"scanType"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"Tier":{"locationName":"tier"},"TimecodeInsertion":{"locationName":"timecodeInsertion"}},"required":["FramerateNumerator","FramerateDenominator"]},"Mpeg2Settings":{"locationName":"mpeg2Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"AfdSignaling":{"locationName":"afdSignaling"},"ColorMetadata":{"locationName":"colorMetadata"},"ColorSpace":{"locationName":"colorSpace"},"DisplayAspectRatio":{"locationName":"displayAspectRatio"},"FilterSettings":{"locationName":"filterSettings","type":"structure","members":{"TemporalFilterSettings":{"shape":"Sav","locationName":"temporalFilterSettings"}}},"FixedAfd":{"locationName":"fixedAfd"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopNumBFrames":{"locationName":"gopNumBFrames","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"ScanType":{"locationName":"scanType"},"SubgopLength":{"locationName":"subgopLength"},"TimecodeInsertion":{"locationName":"timecodeInsertion"}},"required":["FramerateNumerator","FramerateDenominator"]}}},"Height":{"locationName":"height","type":"integer"},"Name":{"locationName":"name"},"RespondToAfd":{"locationName":"respondToAfd"},"ScalingBehavior":{"locationName":"scalingBehavior"},"Sharpness":{"locationName":"sharpness","type":"integer"},"Width":{"locationName":"width","type":"integer"}},"required":["Name"]}}},"required":["VideoDescriptions","AudioDescriptions","OutputGroups","TimecodeConfig"]},"S6c":{"type":"structure","members":{"DestinationRefId":{"locationName":"destinationRefId"}}},"S8j":{"type":"structure","members":{"AbsentInputAudioBehavior":{"locationName":"absentInputAudioBehavior"},"Arib":{"locationName":"arib"},"AribCaptionsPid":{"locationName":"aribCaptionsPid"},"AribCaptionsPidControl":{"locationName":"aribCaptionsPidControl"},"AudioBufferModel":{"locationName":"audioBufferModel"},"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"locationName":"audioPids"},"AudioStreamType":{"locationName":"audioStreamType"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufferModel":{"locationName":"bufferModel"},"CcDescriptor":{"locationName":"ccDescriptor"},"DvbNitSettings":{"locationName":"dvbNitSettings","type":"structure","members":{"NetworkId":{"locationName":"networkId","type":"integer"},"NetworkName":{"locationName":"networkName"},"RepInterval":{"locationName":"repInterval","type":"integer"}},"required":["NetworkName","NetworkId"]},"DvbSdtSettings":{"locationName":"dvbSdtSettings","type":"structure","members":{"OutputSdt":{"locationName":"outputSdt"},"RepInterval":{"locationName":"repInterval","type":"integer"},"ServiceName":{"locationName":"serviceName"},"ServiceProviderName":{"locationName":"serviceProviderName"}}},"DvbSubPids":{"locationName":"dvbSubPids"},"DvbTdtSettings":{"locationName":"dvbTdtSettings","type":"structure","members":{"RepInterval":{"locationName":"repInterval","type":"integer"}}},"DvbTeletextPid":{"locationName":"dvbTeletextPid"},"Ebif":{"locationName":"ebif"},"EbpAudioInterval":{"locationName":"ebpAudioInterval"},"EbpLookaheadMs":{"locationName":"ebpLookaheadMs","type":"integer"},"EbpPlacement":{"locationName":"ebpPlacement"},"EcmPid":{"locationName":"ecmPid"},"EsRateInPes":{"locationName":"esRateInPes"},"EtvPlatformPid":{"locationName":"etvPlatformPid"},"EtvSignalPid":{"locationName":"etvSignalPid"},"FragmentTime":{"locationName":"fragmentTime","type":"double"},"Klv":{"locationName":"klv"},"KlvDataPids":{"locationName":"klvDataPids"},"NielsenId3Behavior":{"locationName":"nielsenId3Behavior"},"NullPacketBitrate":{"locationName":"nullPacketBitrate","type":"double"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPeriod":{"locationName":"pcrPeriod","type":"integer"},"PcrPid":{"locationName":"pcrPid"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid"},"ProgramNum":{"locationName":"programNum","type":"integer"},"RateMode":{"locationName":"rateMode"},"Scte27Pids":{"locationName":"scte27Pids"},"Scte35Control":{"locationName":"scte35Control"},"Scte35Pid":{"locationName":"scte35Pid"},"SegmentationMarkers":{"locationName":"segmentationMarkers"},"SegmentationStyle":{"locationName":"segmentationStyle"},"SegmentationTime":{"locationName":"segmentationTime","type":"double"},"TimedMetadataBehavior":{"locationName":"timedMetadataBehavior"},"TimedMetadataPid":{"locationName":"timedMetadataPid"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid"}}},"Saq":{"type":"structure","members":{}},"Sar":{"type":"structure","members":{}},"Sas":{"type":"structure","members":{}},"Sav":{"type":"structure","members":{"PostFilterSharpening":{"locationName":"postFilterSharpening"},"Strength":{"locationName":"strength"}}},"Sbt":{"type":"structure","members":{"MaxCll":{"locationName":"maxCll","type":"integer"},"MaxFall":{"locationName":"maxFall","type":"integer"}}},"Scj":{"type":"list","member":{"type":"structure","members":{"AutomaticInputFailoverSettings":{"locationName":"automaticInputFailoverSettings","type":"structure","members":{"ErrorClearTimeMsec":{"locationName":"errorClearTimeMsec","type":"integer"},"FailoverConditions":{"locationName":"failoverConditions","type":"list","member":{"type":"structure","members":{"FailoverConditionSettings":{"locationName":"failoverConditionSettings","type":"structure","members":{"AudioSilenceSettings":{"locationName":"audioSilenceSettings","type":"structure","members":{"AudioSelectorName":{"locationName":"audioSelectorName"},"AudioSilenceThresholdMsec":{"locationName":"audioSilenceThresholdMsec","type":"integer"}},"required":["AudioSelectorName"]},"InputLossSettings":{"locationName":"inputLossSettings","type":"structure","members":{"InputLossThresholdMsec":{"locationName":"inputLossThresholdMsec","type":"integer"}}},"VideoBlackSettings":{"locationName":"videoBlackSettings","type":"structure","members":{"BlackDetectThreshold":{"locationName":"blackDetectThreshold","type":"double"},"VideoBlackThresholdMsec":{"locationName":"videoBlackThresholdMsec","type":"integer"}}}}}}}},"InputPreference":{"locationName":"inputPreference"},"SecondaryInputId":{"locationName":"secondaryInputId"}},"required":["SecondaryInputId"]},"InputAttachmentName":{"locationName":"inputAttachmentName"},"InputId":{"locationName":"inputId"},"InputSettings":{"locationName":"inputSettings","type":"structure","members":{"AudioSelectors":{"locationName":"audioSelectors","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"SelectorSettings":{"locationName":"selectorSettings","type":"structure","members":{"AudioHlsRenditionSelection":{"locationName":"audioHlsRenditionSelection","type":"structure","members":{"GroupId":{"locationName":"groupId"},"Name":{"locationName":"name"}},"required":["Name","GroupId"]},"AudioLanguageSelection":{"locationName":"audioLanguageSelection","type":"structure","members":{"LanguageCode":{"locationName":"languageCode"},"LanguageSelectionPolicy":{"locationName":"languageSelectionPolicy"}},"required":["LanguageCode"]},"AudioPidSelection":{"locationName":"audioPidSelection","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}},"required":["Pid"]},"AudioTrackSelection":{"locationName":"audioTrackSelection","type":"structure","members":{"Tracks":{"locationName":"tracks","type":"list","member":{"type":"structure","members":{"Track":{"locationName":"track","type":"integer"}},"required":["Track"]}}},"required":["Tracks"]}}}},"required":["Name"]}},"CaptionSelectors":{"locationName":"captionSelectors","type":"list","member":{"type":"structure","members":{"LanguageCode":{"locationName":"languageCode"},"Name":{"locationName":"name"},"SelectorSettings":{"locationName":"selectorSettings","type":"structure","members":{"AncillarySourceSettings":{"locationName":"ancillarySourceSettings","type":"structure","members":{"SourceAncillaryChannelNumber":{"locationName":"sourceAncillaryChannelNumber","type":"integer"}}},"AribSourceSettings":{"locationName":"aribSourceSettings","type":"structure","members":{}},"DvbSubSourceSettings":{"locationName":"dvbSubSourceSettings","type":"structure","members":{"OcrLanguage":{"locationName":"ocrLanguage"},"Pid":{"locationName":"pid","type":"integer"}}},"EmbeddedSourceSettings":{"locationName":"embeddedSourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Scte20Detection":{"locationName":"scte20Detection"},"Source608ChannelNumber":{"locationName":"source608ChannelNumber","type":"integer"},"Source608TrackNumber":{"locationName":"source608TrackNumber","type":"integer"}}},"Scte20SourceSettings":{"locationName":"scte20SourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Source608ChannelNumber":{"locationName":"source608ChannelNumber","type":"integer"}}},"Scte27SourceSettings":{"locationName":"scte27SourceSettings","type":"structure","members":{"OcrLanguage":{"locationName":"ocrLanguage"},"Pid":{"locationName":"pid","type":"integer"}}},"TeletextSourceSettings":{"locationName":"teletextSourceSettings","type":"structure","members":{"OutputRectangle":{"locationName":"outputRectangle","type":"structure","members":{"Height":{"locationName":"height","type":"double"},"LeftOffset":{"locationName":"leftOffset","type":"double"},"TopOffset":{"locationName":"topOffset","type":"double"},"Width":{"locationName":"width","type":"double"}},"required":["TopOffset","Height","Width","LeftOffset"]},"PageNumber":{"locationName":"pageNumber"}}}}}},"required":["Name"]}},"DeblockFilter":{"locationName":"deblockFilter"},"DenoiseFilter":{"locationName":"denoiseFilter"},"FilterStrength":{"locationName":"filterStrength","type":"integer"},"InputFilter":{"locationName":"inputFilter"},"NetworkInputSettings":{"locationName":"networkInputSettings","type":"structure","members":{"HlsInputSettings":{"locationName":"hlsInputSettings","type":"structure","members":{"Bandwidth":{"locationName":"bandwidth","type":"integer"},"BufferSegments":{"locationName":"bufferSegments","type":"integer"},"Retries":{"locationName":"retries","type":"integer"},"RetryInterval":{"locationName":"retryInterval","type":"integer"},"Scte35Source":{"locationName":"scte35Source"}}},"ServerValidation":{"locationName":"serverValidation"}}},"Scte35Pid":{"locationName":"scte35Pid","type":"integer"},"Smpte2038DataPreference":{"locationName":"smpte2038DataPreference"},"SourceEndBehavior":{"locationName":"sourceEndBehavior"},"VideoSelector":{"locationName":"videoSelector","type":"structure","members":{"ColorSpace":{"locationName":"colorSpace"},"ColorSpaceSettings":{"locationName":"colorSpaceSettings","type":"structure","members":{"Hdr10Settings":{"shape":"Sbt","locationName":"hdr10Settings"}}},"ColorSpaceUsage":{"locationName":"colorSpaceUsage"},"SelectorSettings":{"locationName":"selectorSettings","type":"structure","members":{"VideoSelectorPid":{"locationName":"videoSelectorPid","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}}},"VideoSelectorProgramId":{"locationName":"videoSelectorProgramId","type":"structure","members":{"ProgramId":{"locationName":"programId","type":"integer"}}}}}}}}}}}},"Se6":{"type":"structure","members":{"Codec":{"locationName":"codec"},"MaximumBitrate":{"locationName":"maximumBitrate"},"Resolution":{"locationName":"resolution"}}},"See":{"type":"map","key":{},"value":{}},"Seh":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CdiInputSpecification":{"shape":"S22","locationName":"cdiInputSpecification"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S25","locationName":"destinations"},"EgressEndpoints":{"shape":"Sei","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S2d","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"Scj","locationName":"inputAttachments"},"InputSpecification":{"shape":"Se6","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Maintenance":{"shape":"Sek","locationName":"maintenance"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sel","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Vpc":{"shape":"Seo","locationName":"vpc"}}},"Sei":{"type":"list","member":{"type":"structure","members":{"SourceIp":{"locationName":"sourceIp"}}}},"Sek":{"type":"structure","members":{"MaintenanceDay":{"locationName":"maintenanceDay"},"MaintenanceDeadline":{"locationName":"maintenanceDeadline"},"MaintenanceScheduledDate":{"locationName":"maintenanceScheduledDate"},"MaintenanceStartTime":{"locationName":"maintenanceStartTime"}}},"Sel":{"type":"list","member":{"type":"structure","members":{"ActiveInputAttachmentName":{"locationName":"activeInputAttachmentName"},"ActiveInputSwitchActionName":{"locationName":"activeInputSwitchActionName"},"ActiveMotionGraphicsActionName":{"locationName":"activeMotionGraphicsActionName"},"ActiveMotionGraphicsUri":{"locationName":"activeMotionGraphicsUri"},"PipelineId":{"locationName":"pipelineId"}}}},"Seo":{"type":"structure","members":{"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"NetworkInterfaceIds":{"shape":"S5","locationName":"networkInterfaceIds"},"SecurityGroupIds":{"shape":"S5","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S5","locationName":"subnetIds"}}},"Seq":{"type":"list","member":{"type":"structure","members":{"StreamName":{"locationName":"streamName"}}}},"Ses":{"type":"list","member":{"type":"structure","members":{"Id":{"locationName":"id"}}}},"Seu":{"type":"list","member":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"}}}},"Sew":{"type":"list","member":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}}},"Sf1":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AttachedChannels":{"shape":"S5","locationName":"attachedChannels"},"Destinations":{"shape":"Sf2","locationName":"destinations"},"Id":{"locationName":"id"},"InputClass":{"locationName":"inputClass"},"InputDevices":{"shape":"Ses","locationName":"inputDevices"},"InputPartnerIds":{"shape":"S5","locationName":"inputPartnerIds"},"InputSourceType":{"locationName":"inputSourceType"},"MediaConnectFlows":{"shape":"Sf7","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"},"SecurityGroups":{"shape":"S5","locationName":"securityGroups"},"Sources":{"shape":"Sf9","locationName":"sources"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"Type":{"locationName":"type"}}},"Sf2":{"type":"list","member":{"type":"structure","members":{"Ip":{"locationName":"ip"},"Port":{"locationName":"port"},"Url":{"locationName":"url"},"Vpc":{"locationName":"vpc","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}}}},"Sf7":{"type":"list","member":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"}}}},"Sf9":{"type":"list","member":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}}},"Sfd":{"type":"list","member":{"type":"structure","members":{"Cidr":{"locationName":"cidr"}}}},"Sfg":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"},"Inputs":{"shape":"S5","locationName":"inputs"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"WhitelistRules":{"shape":"Sfi","locationName":"whitelistRules"}}},"Sfi":{"type":"list","member":{"type":"structure","members":{"Cidr":{"locationName":"cidr"}}}},"Sfl":{"type":"structure","members":{"MaximumVideoBufferDelayMilliseconds":{"locationName":"maximumVideoBufferDelayMilliseconds","type":"integer"},"TransportStreamBitrate":{"locationName":"transportStreamBitrate","type":"integer"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"TransportStreamReservedBitrate":{"locationName":"transportStreamReservedBitrate","type":"integer"}},"required":["TransportStreamBitrate","TransportStreamId"]},"Sfq":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AvailabilityZones":{"shape":"S5","locationName":"availabilityZones"},"Destinations":{"shape":"Sfr","locationName":"destinations"},"Id":{"locationName":"id"},"MultiplexSettings":{"shape":"Sfl","locationName":"multiplexSettings"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"ProgramCount":{"locationName":"programCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"}}},"Sfr":{"type":"list","member":{"type":"structure","members":{"MediaConnectSettings":{"locationName":"mediaConnectSettings","type":"structure","members":{"EntitlementArn":{"locationName":"entitlementArn"}}}}}},"Sfw":{"type":"structure","members":{"PreferredChannelPipeline":{"locationName":"preferredChannelPipeline"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"ServiceDescriptor":{"locationName":"serviceDescriptor","type":"structure","members":{"ProviderName":{"locationName":"providerName"},"ServiceName":{"locationName":"serviceName"}},"required":["ProviderName","ServiceName"]},"VideoSettings":{"locationName":"videoSettings","type":"structure","members":{"ConstantBitrate":{"locationName":"constantBitrate","type":"integer"},"StatmuxSettings":{"locationName":"statmuxSettings","type":"structure","members":{"MaximumBitrate":{"locationName":"maximumBitrate","type":"integer"},"MinimumBitrate":{"locationName":"minimumBitrate","type":"integer"},"Priority":{"locationName":"priority","type":"integer"}}}}}},"required":["ProgramNumber"]},"Sg5":{"type":"structure","members":{"ChannelId":{"locationName":"channelId"},"MultiplexProgramSettings":{"shape":"Sfw","locationName":"multiplexProgramSettings"},"PacketIdentifiersMap":{"shape":"Sg6","locationName":"packetIdentifiersMap"},"PipelineDetails":{"shape":"Sg8","locationName":"pipelineDetails"},"ProgramName":{"locationName":"programName"}}},"Sg6":{"type":"structure","members":{"AudioPids":{"shape":"Sg7","locationName":"audioPids"},"DvbSubPids":{"shape":"Sg7","locationName":"dvbSubPids"},"DvbTeletextPid":{"locationName":"dvbTeletextPid","type":"integer"},"EtvPlatformPid":{"locationName":"etvPlatformPid","type":"integer"},"EtvSignalPid":{"locationName":"etvSignalPid","type":"integer"},"KlvDataPids":{"shape":"Sg7","locationName":"klvDataPids"},"PcrPid":{"locationName":"pcrPid","type":"integer"},"PmtPid":{"locationName":"pmtPid","type":"integer"},"PrivateMetadataPid":{"locationName":"privateMetadataPid","type":"integer"},"Scte27Pids":{"shape":"Sg7","locationName":"scte27Pids"},"Scte35Pid":{"locationName":"scte35Pid","type":"integer"},"TimedMetadataPid":{"locationName":"timedMetadataPid","type":"integer"},"VideoPid":{"locationName":"videoPid","type":"integer"}}},"Sg7":{"type":"list","member":{"type":"integer"}},"Sg8":{"type":"list","member":{"type":"structure","members":{"ActiveChannelPipeline":{"locationName":"activeChannelPipeline"},"PipelineId":{"locationName":"pipelineId"}}}},"Sgr":{"type":"structure","members":{"ChannelClass":{"locationName":"channelClass"},"Codec":{"locationName":"codec"},"MaximumBitrate":{"locationName":"maximumBitrate"},"MaximumFramerate":{"locationName":"maximumFramerate"},"Resolution":{"locationName":"resolution"},"ResourceType":{"locationName":"resourceType"},"SpecialFeature":{"locationName":"specialFeature"},"VideoQuality":{"locationName":"videoQuality"}}},"Shc":{"type":"structure","members":{"ActiveInput":{"locationName":"activeInput"},"ConfiguredInput":{"locationName":"configuredInput"},"DeviceState":{"locationName":"deviceState"},"Framerate":{"locationName":"framerate","type":"double"},"Height":{"locationName":"height","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"ScanType":{"locationName":"scanType"},"Width":{"locationName":"width","type":"integer"}}},"Shh":{"type":"structure","members":{"DnsAddresses":{"shape":"S5","locationName":"dnsAddresses"},"Gateway":{"locationName":"gateway"},"IpAddress":{"locationName":"ipAddress"},"IpScheme":{"locationName":"ipScheme"},"SubnetMask":{"locationName":"subnetMask"}}},"Shk":{"type":"structure","members":{"ActiveInput":{"locationName":"activeInput"},"ConfiguredInput":{"locationName":"configuredInput"},"DeviceState":{"locationName":"deviceState"},"Framerate":{"locationName":"framerate","type":"double"},"Height":{"locationName":"height","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"ScanType":{"locationName":"scanType"},"Width":{"locationName":"width","type":"integer"}}},"Sj4":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"Name":{"locationName":"name"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ReservationId":{"locationName":"reservationId"},"ResourceSpecification":{"shape":"Sgr","locationName":"resourceSpecification"},"Start":{"locationName":"start"},"State":{"locationName":"state"},"Tags":{"shape":"See","locationName":"tags"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}},"Sjv":{"type":"structure","members":{"ConfiguredInput":{"locationName":"configuredInput"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"}}}}}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeSchedule":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ScheduleActions"},"ListChannels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Channels"},"ListInputSecurityGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"InputSecurityGroups"},"ListInputs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Inputs"},"ListOfferings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Offerings"},"ListReservations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Reservations"},"ListMultiplexPrograms":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"MultiplexPrograms"},"ListMultiplexes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Multiplexes"},"ListInputDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"InputDevices"},"ListInputDeviceTransfers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"InputDeviceTransfers"}}}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ChannelCreated":{"description":"Wait until a channel has been created","operation":"DescribeChannel","delay":3,"maxAttempts":5,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"IDLE"},{"state":"retry","matcher":"path","argument":"State","expected":"CREATING"},{"state":"retry","matcher":"status","expected":500},{"state":"failure","matcher":"path","argument":"State","expected":"CREATE_FAILED"}]},"ChannelRunning":{"description":"Wait until a channel is running","operation":"DescribeChannel","delay":5,"maxAttempts":120,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"RUNNING"},{"state":"retry","matcher":"path","argument":"State","expected":"STARTING"},{"state":"retry","matcher":"status","expected":500}]},"ChannelStopped":{"description":"Wait until a channel has is stopped","operation":"DescribeChannel","delay":5,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"IDLE"},{"state":"retry","matcher":"path","argument":"State","expected":"STOPPING"},{"state":"retry","matcher":"status","expected":500}]},"ChannelDeleted":{"description":"Wait until a channel has been deleted","operation":"DescribeChannel","delay":5,"maxAttempts":84,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"DELETED"},{"state":"retry","matcher":"path","argument":"State","expected":"DELETING"},{"state":"retry","matcher":"status","expected":500}]},"InputAttached":{"description":"Wait until an input has been attached","operation":"DescribeInput","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"ATTACHED"},{"state":"retry","matcher":"path","argument":"State","expected":"DETACHED"},{"state":"retry","matcher":"status","expected":500}]},"InputDetached":{"description":"Wait until an input has been detached","operation":"DescribeInput","delay":5,"maxAttempts":84,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"DETACHED"},{"state":"retry","matcher":"path","argument":"State","expected":"CREATING"},{"state":"retry","matcher":"path","argument":"State","expected":"ATTACHED"},{"state":"retry","matcher":"status","expected":500}]},"InputDeleted":{"description":"Wait until an input has been deleted","operation":"DescribeInput","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"DELETED"},{"state":"retry","matcher":"path","argument":"State","expected":"DELETING"},{"state":"retry","matcher":"status","expected":500}]},"MultiplexCreated":{"description":"Wait until a multiplex has been created","operation":"DescribeMultiplex","delay":3,"maxAttempts":5,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"IDLE"},{"state":"retry","matcher":"path","argument":"State","expected":"CREATING"},{"state":"retry","matcher":"status","expected":500},{"state":"failure","matcher":"path","argument":"State","expected":"CREATE_FAILED"}]},"MultiplexRunning":{"description":"Wait until a multiplex is running","operation":"DescribeMultiplex","delay":5,"maxAttempts":120,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"RUNNING"},{"state":"retry","matcher":"path","argument":"State","expected":"STARTING"},{"state":"retry","matcher":"status","expected":500}]},"MultiplexStopped":{"description":"Wait until a multiplex has is stopped","operation":"DescribeMultiplex","delay":5,"maxAttempts":28,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"IDLE"},{"state":"retry","matcher":"path","argument":"State","expected":"STOPPING"},{"state":"retry","matcher":"status","expected":500}]},"MultiplexDeleted":{"description":"Wait until a multiplex has been deleted","operation":"DescribeMultiplex","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"DELETED"},{"state":"retry","matcher":"path","argument":"State","expected":"DELETING"},{"state":"retry","matcher":"status","expected":500}]}}}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediapackage'] = {};
	AWS.MediaPackage = Service.defineService('mediapackage', ['2017-10-12']);
	Object.defineProperty(apiLoader.services['mediapackage'], '2017-10-12', {
	  get: function get() {
	    var model = __webpack_require__(534);
	    model.paginators = __webpack_require__(535).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaPackage;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-10-12","endpointPrefix":"mediapackage","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"MediaPackage","serviceFullName":"AWS Elemental MediaPackage","serviceId":"MediaPackage","signatureVersion":"v4","signingName":"mediapackage","uid":"mediapackage-2017-10-12"},"operations":{"ConfigureLogs":{"http":{"method":"PUT","requestUri":"/channels/{id}/configure_logs","responseCode":200},"input":{"members":{"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"location":"uri","locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":200},"input":{"members":{"Description":{"locationName":"description"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S9"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"}},"CreateHarvestJob":{"http":{"requestUri":"/harvest_jobs","responseCode":200},"input":{"members":{"EndTime":{"locationName":"endTime"},"Id":{"locationName":"id"},"OriginEndpointId":{"locationName":"originEndpointId"},"S3Destination":{"locationName":"s3Destination","shape":"Sd"},"StartTime":{"locationName":"startTime"}},"required":["S3Destination","EndTime","OriginEndpointId","StartTime","Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CreatedAt":{"locationName":"createdAt"},"EndTime":{"locationName":"endTime"},"Id":{"locationName":"id"},"OriginEndpointId":{"locationName":"originEndpointId"},"S3Destination":{"locationName":"s3Destination","shape":"Sd"},"StartTime":{"locationName":"startTime"},"Status":{"locationName":"status"}},"type":"structure"}},"CreateOriginEndpoint":{"http":{"requestUri":"/origin_endpoints","responseCode":200},"input":{"members":{"Authorization":{"locationName":"authorization","shape":"Sh"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"Si"},"DashPackage":{"locationName":"dashPackage","shape":"S10"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"S18"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"S1b"},"Origination":{"locationName":"origination"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S9"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Whitelist":{"locationName":"whitelist","shape":"Sp"}},"required":["ChannelId","Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"Sh"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S1f"},"DashPackage":{"locationName":"dashPackage","shape":"S10"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"S18"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"S1b"},"Origination":{"locationName":"origination"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S9"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sp"}},"type":"structure"}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteOriginEndpoint":{"http":{"method":"DELETE","requestUri":"/origin_endpoints/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"}},"DescribeHarvestJob":{"http":{"method":"GET","requestUri":"/harvest_jobs/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CreatedAt":{"locationName":"createdAt"},"EndTime":{"locationName":"endTime"},"Id":{"locationName":"id"},"OriginEndpointId":{"locationName":"originEndpointId"},"S3Destination":{"locationName":"s3Destination","shape":"Sd"},"StartTime":{"locationName":"startTime"},"Status":{"locationName":"status"}},"type":"structure"}},"DescribeOriginEndpoint":{"http":{"method":"GET","requestUri":"/origin_endpoints/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"Sh"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S1f"},"DashPackage":{"locationName":"dashPackage","shape":"S10"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"S18"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"S1b"},"Origination":{"locationName":"origination"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S9"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sp"}},"type":"structure"}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"Channels":{"locationName":"channels","member":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"},"type":"list"},"NextToken":{"locationName":"nextToken"}},"type":"structure"}},"ListHarvestJobs":{"http":{"method":"GET","requestUri":"/harvest_jobs","responseCode":200},"input":{"members":{"IncludeChannelId":{"location":"querystring","locationName":"includeChannelId"},"IncludeStatus":{"location":"querystring","locationName":"includeStatus"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"HarvestJobs":{"locationName":"harvestJobs","member":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CreatedAt":{"locationName":"createdAt"},"EndTime":{"locationName":"endTime"},"Id":{"locationName":"id"},"OriginEndpointId":{"locationName":"originEndpointId"},"S3Destination":{"locationName":"s3Destination","shape":"Sd"},"StartTime":{"locationName":"startTime"},"Status":{"locationName":"status"}},"type":"structure"},"type":"list"},"NextToken":{"locationName":"nextToken"}},"type":"structure"}},"ListOriginEndpoints":{"http":{"method":"GET","requestUri":"/origin_endpoints","responseCode":200},"input":{"members":{"ChannelId":{"location":"querystring","locationName":"channelId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"NextToken":{"locationName":"nextToken"},"OriginEndpoints":{"locationName":"originEndpoints","member":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"Sh"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S1f"},"DashPackage":{"locationName":"dashPackage","shape":"S10"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"S18"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"S1b"},"Origination":{"locationName":"origination"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S9"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sp"}},"type":"structure"},"type":"list"}},"type":"structure"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"],"type":"structure"},"output":{"members":{"Tags":{"locationName":"tags","shape":"S27"}},"type":"structure"}},"RotateChannelCredentials":{"deprecated":true,"deprecatedMessage":"This API is deprecated. Please use RotateIngestEndpointCredentials instead","http":{"method":"PUT","requestUri":"/channels/{id}/credentials","responseCode":200},"input":{"deprecated":true,"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"deprecated":true,"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"}},"RotateIngestEndpointCredentials":{"http":{"method":"PUT","requestUri":"/channels/{id}/ingest_endpoints/{ingest_endpoint_id}/credentials","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"},"IngestEndpointId":{"location":"uri","locationName":"ingest_endpoint_id"}},"required":["IngestEndpointId","Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"locationName":"tags","shape":"S27"}},"required":["ResourceArn","Tags"],"type":"structure"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","shape":"Sp"}},"required":["TagKeys","ResourceArn"],"type":"structure"}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{id}","responseCode":200},"input":{"members":{"Description":{"locationName":"description"},"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"HlsIngest":{"locationName":"hlsIngest","shape":"S6"},"Id":{"locationName":"id"},"IngressAccessLogs":{"locationName":"ingressAccessLogs","shape":"S4"},"Tags":{"locationName":"tags","shape":"S9"}},"type":"structure"}},"UpdateOriginEndpoint":{"http":{"method":"PUT","requestUri":"/origin_endpoints/{id}","responseCode":200},"input":{"members":{"Authorization":{"locationName":"authorization","shape":"Sh"},"CmafPackage":{"locationName":"cmafPackage","shape":"Si"},"DashPackage":{"locationName":"dashPackage","shape":"S10"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"S18"},"Id":{"location":"uri","locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"S1b"},"Origination":{"locationName":"origination"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Whitelist":{"locationName":"whitelist","shape":"Sp"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"Sh"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S1f"},"DashPackage":{"locationName":"dashPackage","shape":"S10"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"S18"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"S1b"},"Origination":{"locationName":"origination"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S9"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sp"}},"type":"structure"}}},"shapes":{"S2":{"members":{"LogGroupName":{"locationName":"logGroupName"}},"type":"structure"},"S4":{"members":{"LogGroupName":{"locationName":"logGroupName"}},"type":"structure"},"S6":{"members":{"IngestEndpoints":{"locationName":"ingestEndpoints","member":{"members":{"Id":{"locationName":"id"},"Password":{"locationName":"password"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}},"type":"structure"},"type":"list"}},"type":"structure"},"S9":{"key":{},"type":"map","value":{}},"Sd":{"members":{"BucketName":{"locationName":"bucketName"},"ManifestKey":{"locationName":"manifestKey"},"RoleArn":{"locationName":"roleArn"}},"required":["ManifestKey","BucketName","RoleArn"],"type":"structure"},"Sh":{"members":{"CdnIdentifierSecret":{"locationName":"cdnIdentifierSecret"},"SecretsRoleArn":{"locationName":"secretsRoleArn"}},"required":["SecretsRoleArn","CdnIdentifierSecret"],"type":"structure"},"Si":{"members":{"Encryption":{"locationName":"encryption","shape":"Sj"},"HlsManifests":{"locationName":"hlsManifests","member":{"members":{"AdMarkers":{"locationName":"adMarkers"},"AdTriggers":{"locationName":"adTriggers","shape":"St"},"AdsOnDeliveryRestrictions":{"locationName":"adsOnDeliveryRestrictions"},"Id":{"locationName":"id"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"ManifestName":{"locationName":"manifestName"},"PlaylistType":{"locationName":"playlistType"},"PlaylistWindowSeconds":{"locationName":"playlistWindowSeconds","type":"integer"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"}},"required":["Id"],"type":"structure"},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentPrefix":{"locationName":"segmentPrefix"},"StreamSelection":{"locationName":"streamSelection","shape":"Sy"}},"type":"structure"},"Sj":{"members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"KeyRotationIntervalSeconds":{"locationName":"keyRotationIntervalSeconds","type":"integer"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sl"}},"required":["SpekeKeyProvider"],"type":"structure"},"Sl":{"members":{"CertificateArn":{"locationName":"certificateArn"},"EncryptionContractConfiguration":{"locationName":"encryptionContractConfiguration","members":{"PresetSpeke20Audio":{"locationName":"presetSpeke20Audio"},"PresetSpeke20Video":{"locationName":"presetSpeke20Video"}},"required":["PresetSpeke20Audio","PresetSpeke20Video"],"type":"structure"},"ResourceId":{"locationName":"resourceId"},"RoleArn":{"locationName":"roleArn"},"SystemIds":{"locationName":"systemIds","shape":"Sp"},"Url":{"locationName":"url"}},"required":["ResourceId","SystemIds","Url","RoleArn"],"type":"structure"},"Sp":{"member":{},"type":"list"},"St":{"member":{},"type":"list"},"Sy":{"members":{"MaxVideoBitsPerSecond":{"locationName":"maxVideoBitsPerSecond","type":"integer"},"MinVideoBitsPerSecond":{"locationName":"minVideoBitsPerSecond","type":"integer"},"StreamOrder":{"locationName":"streamOrder"}},"type":"structure"},"S10":{"members":{"AdTriggers":{"locationName":"adTriggers","shape":"St"},"AdsOnDeliveryRestrictions":{"locationName":"adsOnDeliveryRestrictions"},"Encryption":{"locationName":"encryption","members":{"KeyRotationIntervalSeconds":{"locationName":"keyRotationIntervalSeconds","type":"integer"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sl"}},"required":["SpekeKeyProvider"],"type":"structure"},"ManifestLayout":{"locationName":"manifestLayout"},"ManifestWindowSeconds":{"locationName":"manifestWindowSeconds","type":"integer"},"MinBufferTimeSeconds":{"locationName":"minBufferTimeSeconds","type":"integer"},"MinUpdatePeriodSeconds":{"locationName":"minUpdatePeriodSeconds","type":"integer"},"PeriodTriggers":{"locationName":"periodTriggers","member":{},"type":"list"},"Profile":{"locationName":"profile"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentTemplateFormat":{"locationName":"segmentTemplateFormat"},"StreamSelection":{"locationName":"streamSelection","shape":"Sy"},"SuggestedPresentationDelaySeconds":{"locationName":"suggestedPresentationDelaySeconds","type":"integer"},"UtcTiming":{"locationName":"utcTiming"},"UtcTimingUri":{"locationName":"utcTimingUri"}},"type":"structure"},"S18":{"members":{"AdMarkers":{"locationName":"adMarkers"},"AdTriggers":{"locationName":"adTriggers","shape":"St"},"AdsOnDeliveryRestrictions":{"locationName":"adsOnDeliveryRestrictions"},"Encryption":{"locationName":"encryption","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"KeyRotationIntervalSeconds":{"locationName":"keyRotationIntervalSeconds","type":"integer"},"RepeatExtXKey":{"locationName":"repeatExtXKey","type":"boolean"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sl"}},"required":["SpekeKeyProvider"],"type":"structure"},"IncludeDvbSubtitles":{"locationName":"includeDvbSubtitles","type":"boolean"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"PlaylistType":{"locationName":"playlistType"},"PlaylistWindowSeconds":{"locationName":"playlistWindowSeconds","type":"integer"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"StreamSelection":{"locationName":"streamSelection","shape":"Sy"},"UseAudioRenditionGroup":{"locationName":"useAudioRenditionGroup","type":"boolean"}},"type":"structure"},"S1b":{"members":{"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sl"}},"required":["SpekeKeyProvider"],"type":"structure"},"ManifestWindowSeconds":{"locationName":"manifestWindowSeconds","type":"integer"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"StreamSelection":{"locationName":"streamSelection","shape":"Sy"}},"type":"structure"},"S1f":{"members":{"Encryption":{"locationName":"encryption","shape":"Sj"},"HlsManifests":{"locationName":"hlsManifests","member":{"members":{"AdMarkers":{"locationName":"adMarkers"},"Id":{"locationName":"id"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"ManifestName":{"locationName":"manifestName"},"PlaylistType":{"locationName":"playlistType"},"PlaylistWindowSeconds":{"locationName":"playlistWindowSeconds","type":"integer"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"},"Url":{"locationName":"url"}},"required":["Id"],"type":"structure"},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentPrefix":{"locationName":"segmentPrefix"},"StreamSelection":{"locationName":"streamSelection","shape":"Sy"}},"type":"structure"},"S27":{"key":{},"type":"map","value":{}}}}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChannels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Channels"},"ListOriginEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"OriginEndpoints"},"ListHarvestJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"HarvestJobs"}}}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediastore'] = {};
	AWS.MediaStore = Service.defineService('mediastore', ['2017-09-01']);
	Object.defineProperty(apiLoader.services['mediastore'], '2017-09-01', {
	  get: function get() {
	    var model = __webpack_require__(537);
	    model.paginators = __webpack_require__(538).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaStore;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-01","endpointPrefix":"mediastore","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"MediaStore","serviceFullName":"AWS Elemental MediaStore","serviceId":"MediaStore","signatureVersion":"v4","signingName":"mediastore","targetPrefix":"MediaStore_20170901","uid":"mediastore-2017-09-01"},"operations":{"CreateContainer":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","required":["Container"],"members":{"Container":{"shape":"S8"}}}},"DeleteContainer":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteContainerPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteCorsPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteMetricPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DescribeContainer":{"input":{"type":"structure","members":{"ContainerName":{}}},"output":{"type":"structure","members":{"Container":{"shape":"S8"}}}},"GetContainerPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["Policy"],"members":{"Policy":{}}}},"GetCorsPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["CorsPolicy"],"members":{"CorsPolicy":{"shape":"Sv"}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["LifecyclePolicy"],"members":{"LifecyclePolicy":{}}}},"GetMetricPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["MetricPolicy"],"members":{"MetricPolicy":{"shape":"S1a"}}}},"ListContainers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Containers"],"members":{"Containers":{"type":"list","member":{"shape":"S8"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["Resource"],"members":{"Resource":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"PutContainerPolicy":{"input":{"type":"structure","required":["ContainerName","Policy"],"members":{"ContainerName":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"PutCorsPolicy":{"input":{"type":"structure","required":["ContainerName","CorsPolicy"],"members":{"ContainerName":{},"CorsPolicy":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["ContainerName","LifecyclePolicy"],"members":{"ContainerName":{},"LifecyclePolicy":{}}},"output":{"type":"structure","members":{}}},"PutMetricPolicy":{"input":{"type":"structure","required":["ContainerName","MetricPolicy"],"members":{"ContainerName":{},"MetricPolicy":{"shape":"S1a"}}},"output":{"type":"structure","members":{}}},"StartAccessLogging":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"StopAccessLogging":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S8":{"type":"structure","members":{"Endpoint":{},"CreationTime":{"type":"timestamp"},"ARN":{},"Name":{},"Status":{},"AccessLoggingEnabled":{"type":"boolean"}}},"Sv":{"type":"list","member":{"type":"structure","required":["AllowedOrigins","AllowedHeaders"],"members":{"AllowedOrigins":{"type":"list","member":{}},"AllowedMethods":{"type":"list","member":{}},"AllowedHeaders":{"type":"list","member":{}},"MaxAgeSeconds":{"type":"integer"},"ExposeHeaders":{"type":"list","member":{}}}}},"S1a":{"type":"structure","required":["ContainerLevelMetrics"],"members":{"ContainerLevelMetrics":{},"MetricPolicyRules":{"type":"list","member":{"type":"structure","required":["ObjectGroup","ObjectGroupName"],"members":{"ObjectGroup":{},"ObjectGroupName":{}}}}}}}}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListContainers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediastoredata'] = {};
	AWS.MediaStoreData = Service.defineService('mediastoredata', ['2017-09-01']);
	Object.defineProperty(apiLoader.services['mediastoredata'], '2017-09-01', {
	  get: function get() {
	    var model = __webpack_require__(540);
	    model.paginators = __webpack_require__(541).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaStoreData;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-01","endpointPrefix":"data.mediastore","protocol":"rest-json","serviceAbbreviation":"MediaStore Data","serviceFullName":"AWS Elemental MediaStore Data Plane","serviceId":"MediaStore Data","signatureVersion":"v4","signingName":"mediastore","uid":"mediastore-data-2017-09-01"},"operations":{"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{}}},"DescribeObject":{"http":{"method":"HEAD","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{"ETag":{"location":"header","locationName":"ETag"},"ContentType":{"location":"header","locationName":"Content-Type"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"},"Range":{"location":"header","locationName":"Range"}}},"output":{"type":"structure","required":["StatusCode"],"members":{"Body":{"shape":"Se"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentType":{"location":"header","locationName":"Content-Type"},"ETag":{"location":"header","locationName":"ETag"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"StatusCode":{"location":"statusCode","type":"integer"}},"payload":"Body"}},"ListItems":{"http":{"method":"GET"},"input":{"type":"structure","members":{"Path":{"location":"querystring","locationName":"Path"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"ETag":{},"LastModified":{"type":"timestamp"},"ContentType":{},"ContentLength":{"type":"long"}}}},"NextToken":{}}}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Body","Path"],"members":{"Body":{"shape":"Se"},"Path":{"location":"uri","locationName":"Path"},"ContentType":{"location":"header","locationName":"Content-Type"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"UploadAvailability":{"location":"header","locationName":"x-amz-upload-availability"}},"payload":"Body"},"output":{"type":"structure","members":{"ContentSHA256":{},"ETag":{},"StorageClass":{}}},"authtype":"v4-unsigned-body"}},"shapes":{"Se":{"type":"blob","streaming":true}}}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appsync'] = {};
	AWS.AppSync = Service.defineService('appsync', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['appsync'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(543);
	    model.paginators = __webpack_require__(544).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppSync;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"appsync","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWSAppSync","serviceFullName":"AWS AppSync","serviceId":"AppSync","signatureVersion":"v4","signingName":"appsync","uid":"appsync-2017-07-25"},"operations":{"AssociateApi":{"http":{"requestUri":"/v1/domainnames/{domainName}/apiassociation"},"input":{"type":"structure","required":["domainName","apiId"],"members":{"domainName":{"location":"uri","locationName":"domainName"},"apiId":{}}},"output":{"type":"structure","members":{"apiAssociation":{"shape":"S5"}}}},"CreateApiCache":{"http":{"requestUri":"/v1/apis/{apiId}/ApiCaches"},"input":{"type":"structure","required":["apiId","ttl","apiCachingBehavior","type"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"ttl":{"type":"long"},"transitEncryptionEnabled":{"type":"boolean"},"atRestEncryptionEnabled":{"type":"boolean"},"apiCachingBehavior":{},"type":{}}},"output":{"type":"structure","members":{"apiCache":{"shape":"Sd"}}}},"CreateApiKey":{"http":{"requestUri":"/v1/apis/{apiId}/apikeys"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"description":{},"expires":{"type":"long"}}},"output":{"type":"structure","members":{"apiKey":{"shape":"Sh"}}}},"CreateDataSource":{"http":{"requestUri":"/v1/apis/{apiId}/datasources"},"input":{"type":"structure","required":["apiId","name","type"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"description":{},"type":{},"serviceRoleArn":{},"dynamodbConfig":{"shape":"Sl"},"lambdaConfig":{"shape":"Sn"},"elasticsearchConfig":{"shape":"So"},"openSearchServiceConfig":{"shape":"Sp"},"httpConfig":{"shape":"Sq"},"relationalDatabaseConfig":{"shape":"Su"}}},"output":{"type":"structure","members":{"dataSource":{"shape":"Sy"}}}},"CreateDomainName":{"http":{"requestUri":"/v1/domainnames"},"input":{"type":"structure","required":["domainName","certificateArn"],"members":{"domainName":{},"certificateArn":{},"description":{}}},"output":{"type":"structure","members":{"domainNameConfig":{"shape":"S13"}}}},"CreateFunction":{"http":{"requestUri":"/v1/apis/{apiId}/functions"},"input":{"type":"structure","required":["apiId","name","dataSourceName","functionVersion"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"description":{},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"functionVersion":{},"syncConfig":{"shape":"S16"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"functionConfiguration":{"shape":"S1c"}}}},"CreateGraphqlApi":{"http":{"requestUri":"/v1/apis"},"input":{"type":"structure","required":["name","authenticationType"],"members":{"name":{},"logConfig":{"shape":"S1e"},"authenticationType":{},"userPoolConfig":{"shape":"S1h"},"openIDConnectConfig":{"shape":"S1j"},"tags":{"shape":"S1k"},"additionalAuthenticationProviders":{"shape":"S1n"},"xrayEnabled":{"type":"boolean"},"lambdaAuthorizerConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"graphqlApi":{"shape":"S1t"}}}},"CreateResolver":{"http":{"requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers"},"input":{"type":"structure","required":["apiId","typeName","fieldName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"kind":{},"pipelineConfig":{"shape":"S1x"},"syncConfig":{"shape":"S16"},"cachingConfig":{"shape":"S1z"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"resolver":{"shape":"S22"}}}},"CreateType":{"http":{"requestUri":"/v1/apis/{apiId}/types"},"input":{"type":"structure","required":["apiId","definition","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"definition":{},"format":{}}},"output":{"type":"structure","members":{"type":{"shape":"S26"}}}},"DeleteApiCache":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/ApiCaches"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{}}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/apikeys/{id}"},"input":{"type":"structure","required":["apiId","id"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{}}},"DeleteDataSource":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/datasources/{name}"},"input":{"type":"structure","required":["apiId","name"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/v1/domainnames/{domainName}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","members":{}}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/functions/{functionId}"},"input":{"type":"structure","required":["apiId","functionId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"functionId":{"location":"uri","locationName":"functionId"}}},"output":{"type":"structure","members":{}}},"DeleteGraphqlApi":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{}}},"DeleteResolver":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers/{fieldName}"},"input":{"type":"structure","required":["apiId","typeName","fieldName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{"location":"uri","locationName":"fieldName"}}},"output":{"type":"structure","members":{}}},"DeleteType":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/types/{typeName}"},"input":{"type":"structure","required":["apiId","typeName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"}}},"output":{"type":"structure","members":{}}},"DisassociateApi":{"http":{"method":"DELETE","requestUri":"/v1/domainnames/{domainName}/apiassociation"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","members":{}}},"FlushApiCache":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/FlushCache"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{}}},"GetApiAssociation":{"http":{"method":"GET","requestUri":"/v1/domainnames/{domainName}/apiassociation"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","members":{"apiAssociation":{"shape":"S5"}}}},"GetApiCache":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/ApiCaches"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{"apiCache":{"shape":"Sd"}}}},"GetDataSource":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/datasources/{name}"},"input":{"type":"structure","required":["apiId","name"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"dataSource":{"shape":"Sy"}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/v1/domainnames/{domainName}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","members":{"domainNameConfig":{"shape":"S13"}}}},"GetFunction":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/functions/{functionId}"},"input":{"type":"structure","required":["apiId","functionId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"functionId":{"location":"uri","locationName":"functionId"}}},"output":{"type":"structure","members":{"functionConfiguration":{"shape":"S1c"}}}},"GetGraphqlApi":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{"graphqlApi":{"shape":"S1t"}}}},"GetIntrospectionSchema":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/schema"},"input":{"type":"structure","required":["apiId","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"format":{"location":"querystring","locationName":"format"},"includeDirectives":{"location":"querystring","locationName":"includeDirectives","type":"boolean"}}},"output":{"type":"structure","members":{"schema":{"type":"blob"}},"payload":"schema"}},"GetResolver":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers/{fieldName}"},"input":{"type":"structure","required":["apiId","typeName","fieldName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{"location":"uri","locationName":"fieldName"}}},"output":{"type":"structure","members":{"resolver":{"shape":"S22"}}}},"GetSchemaCreationStatus":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/schemacreation"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{"status":{},"details":{}}}},"GetType":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types/{typeName}"},"input":{"type":"structure","required":["apiId","typeName","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"format":{"location":"querystring","locationName":"format"}}},"output":{"type":"structure","members":{"type":{"shape":"S26"}}}},"ListApiKeys":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/apikeys"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"apiKeys":{"type":"list","member":{"shape":"Sh"}},"nextToken":{}}}},"ListDataSources":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/datasources"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"dataSources":{"type":"list","member":{"shape":"Sy"}},"nextToken":{}}}},"ListDomainNames":{"http":{"method":"GET","requestUri":"/v1/domainnames"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"domainNameConfigs":{"type":"list","member":{"shape":"S13"}},"nextToken":{}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/functions"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"functions":{"type":"list","member":{"shape":"S1c"}},"nextToken":{}}}},"ListGraphqlApis":{"http":{"method":"GET","requestUri":"/v1/apis"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"graphqlApis":{"type":"list","member":{"shape":"S1t"}},"nextToken":{}}}},"ListResolvers":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers"},"input":{"type":"structure","required":["apiId","typeName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resolvers":{"shape":"S3y"},"nextToken":{}}}},"ListResolversByFunction":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/functions/{functionId}/resolvers"},"input":{"type":"structure","required":["apiId","functionId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"functionId":{"location":"uri","locationName":"functionId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resolvers":{"shape":"S3y"},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1k"}}}},"ListTypes":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types"},"input":{"type":"structure","required":["apiId","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"format":{"location":"querystring","locationName":"format"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"types":{"type":"list","member":{"shape":"S26"}},"nextToken":{}}}},"StartSchemaCreation":{"http":{"requestUri":"/v1/apis/{apiId}/schemacreation"},"input":{"type":"structure","required":["apiId","definition"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"definition":{"type":"blob"}}},"output":{"type":"structure","members":{"status":{}}}},"TagResource":{"http":{"requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApiCache":{"http":{"requestUri":"/v1/apis/{apiId}/ApiCaches/update"},"input":{"type":"structure","required":["apiId","ttl","apiCachingBehavior","type"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"ttl":{"type":"long"},"apiCachingBehavior":{},"type":{}}},"output":{"type":"structure","members":{"apiCache":{"shape":"Sd"}}}},"UpdateApiKey":{"http":{"requestUri":"/v1/apis/{apiId}/apikeys/{id}"},"input":{"type":"structure","required":["apiId","id"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"id":{"location":"uri","locationName":"id"},"description":{},"expires":{"type":"long"}}},"output":{"type":"structure","members":{"apiKey":{"shape":"Sh"}}}},"UpdateDataSource":{"http":{"requestUri":"/v1/apis/{apiId}/datasources/{name}"},"input":{"type":"structure","required":["apiId","name","type"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{"location":"uri","locationName":"name"},"description":{},"type":{},"serviceRoleArn":{},"dynamodbConfig":{"shape":"Sl"},"lambdaConfig":{"shape":"Sn"},"elasticsearchConfig":{"shape":"So"},"openSearchServiceConfig":{"shape":"Sp"},"httpConfig":{"shape":"Sq"},"relationalDatabaseConfig":{"shape":"Su"}}},"output":{"type":"structure","members":{"dataSource":{"shape":"Sy"}}}},"UpdateDomainName":{"http":{"requestUri":"/v1/domainnames/{domainName}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domainName"},"description":{}}},"output":{"type":"structure","members":{"domainNameConfig":{"shape":"S13"}}}},"UpdateFunction":{"http":{"requestUri":"/v1/apis/{apiId}/functions/{functionId}"},"input":{"type":"structure","required":["apiId","name","functionId","dataSourceName","functionVersion"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"description":{},"functionId":{"location":"uri","locationName":"functionId"},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"functionVersion":{},"syncConfig":{"shape":"S16"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"functionConfiguration":{"shape":"S1c"}}}},"UpdateGraphqlApi":{"http":{"requestUri":"/v1/apis/{apiId}"},"input":{"type":"structure","required":["apiId","name"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"logConfig":{"shape":"S1e"},"authenticationType":{},"userPoolConfig":{"shape":"S1h"},"openIDConnectConfig":{"shape":"S1j"},"additionalAuthenticationProviders":{"shape":"S1n"},"xrayEnabled":{"type":"boolean"},"lambdaAuthorizerConfig":{"shape":"S1q"}}},"output":{"type":"structure","members":{"graphqlApi":{"shape":"S1t"}}}},"UpdateResolver":{"http":{"requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers/{fieldName}"},"input":{"type":"structure","required":["apiId","typeName","fieldName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{"location":"uri","locationName":"fieldName"},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"kind":{},"pipelineConfig":{"shape":"S1x"},"syncConfig":{"shape":"S16"},"cachingConfig":{"shape":"S1z"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"resolver":{"shape":"S22"}}}},"UpdateType":{"http":{"requestUri":"/v1/apis/{apiId}/types/{typeName}"},"input":{"type":"structure","required":["apiId","typeName","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"definition":{},"format":{}}},"output":{"type":"structure","members":{"type":{"shape":"S26"}}}}},"shapes":{"S5":{"type":"structure","members":{"domainName":{},"apiId":{},"associationStatus":{},"deploymentDetail":{}}},"Sd":{"type":"structure","members":{"ttl":{"type":"long"},"apiCachingBehavior":{},"transitEncryptionEnabled":{"type":"boolean"},"atRestEncryptionEnabled":{"type":"boolean"},"type":{},"status":{}}},"Sh":{"type":"structure","members":{"id":{},"description":{},"expires":{"type":"long"},"deletes":{"type":"long"}}},"Sl":{"type":"structure","required":["tableName","awsRegion"],"members":{"tableName":{},"awsRegion":{},"useCallerCredentials":{"type":"boolean"},"deltaSyncConfig":{"type":"structure","members":{"baseTableTTL":{"type":"long"},"deltaSyncTableName":{},"deltaSyncTableTTL":{"type":"long"}}},"versioned":{"type":"boolean"}}},"Sn":{"type":"structure","required":["lambdaFunctionArn"],"members":{"lambdaFunctionArn":{}}},"So":{"type":"structure","required":["endpoint","awsRegion"],"members":{"endpoint":{},"awsRegion":{}}},"Sp":{"type":"structure","required":["endpoint","awsRegion"],"members":{"endpoint":{},"awsRegion":{}}},"Sq":{"type":"structure","members":{"endpoint":{},"authorizationConfig":{"type":"structure","required":["authorizationType"],"members":{"authorizationType":{},"awsIamConfig":{"type":"structure","members":{"signingRegion":{},"signingServiceName":{}}}}}}},"Su":{"type":"structure","members":{"relationalDatabaseSourceType":{},"rdsHttpEndpointConfig":{"type":"structure","members":{"awsRegion":{},"dbClusterIdentifier":{},"databaseName":{},"schema":{},"awsSecretStoreArn":{}}}}},"Sy":{"type":"structure","members":{"dataSourceArn":{},"name":{},"description":{},"type":{},"serviceRoleArn":{},"dynamodbConfig":{"shape":"Sl"},"lambdaConfig":{"shape":"Sn"},"elasticsearchConfig":{"shape":"So"},"openSearchServiceConfig":{"shape":"Sp"},"httpConfig":{"shape":"Sq"},"relationalDatabaseConfig":{"shape":"Su"}}},"S13":{"type":"structure","members":{"domainName":{},"description":{},"certificateArn":{},"appsyncDomainName":{},"hostedZoneId":{}}},"S16":{"type":"structure","members":{"conflictHandler":{},"conflictDetection":{},"lambdaConflictHandlerConfig":{"type":"structure","members":{"lambdaConflictHandlerArn":{}}}}},"S1c":{"type":"structure","members":{"functionId":{},"functionArn":{},"name":{},"description":{},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"functionVersion":{},"syncConfig":{"shape":"S16"},"maxBatchSize":{"type":"integer"}}},"S1e":{"type":"structure","required":["fieldLogLevel","cloudWatchLogsRoleArn"],"members":{"fieldLogLevel":{},"cloudWatchLogsRoleArn":{},"excludeVerboseContent":{"type":"boolean"}}},"S1h":{"type":"structure","required":["userPoolId","awsRegion","defaultAction"],"members":{"userPoolId":{},"awsRegion":{},"defaultAction":{},"appIdClientRegex":{}}},"S1j":{"type":"structure","required":["issuer"],"members":{"issuer":{},"clientId":{},"iatTTL":{"type":"long"},"authTTL":{"type":"long"}}},"S1k":{"type":"map","key":{},"value":{}},"S1n":{"type":"list","member":{"type":"structure","members":{"authenticationType":{},"openIDConnectConfig":{"shape":"S1j"},"userPoolConfig":{"type":"structure","required":["userPoolId","awsRegion"],"members":{"userPoolId":{},"awsRegion":{},"appIdClientRegex":{}}},"lambdaAuthorizerConfig":{"shape":"S1q"}}}},"S1q":{"type":"structure","required":["authorizerUri"],"members":{"authorizerResultTtlInSeconds":{"type":"integer"},"authorizerUri":{},"identityValidationExpression":{}}},"S1t":{"type":"structure","members":{"name":{},"apiId":{},"authenticationType":{},"logConfig":{"shape":"S1e"},"userPoolConfig":{"shape":"S1h"},"openIDConnectConfig":{"shape":"S1j"},"arn":{},"uris":{"type":"map","key":{},"value":{}},"tags":{"shape":"S1k"},"additionalAuthenticationProviders":{"shape":"S1n"},"xrayEnabled":{"type":"boolean"},"wafWebAclArn":{},"lambdaAuthorizerConfig":{"shape":"S1q"}}},"S1x":{"type":"structure","members":{"functions":{"type":"list","member":{}}}},"S1z":{"type":"structure","members":{"ttl":{"type":"long"},"cachingKeys":{"type":"list","member":{}}}},"S22":{"type":"structure","members":{"typeName":{},"fieldName":{},"dataSourceName":{},"resolverArn":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"kind":{},"pipelineConfig":{"shape":"S1x"},"syncConfig":{"shape":"S16"},"cachingConfig":{"shape":"S1z"},"maxBatchSize":{"type":"integer"}}},"S26":{"type":"structure","members":{"name":{},"description":{},"arn":{},"definition":{},"format":{}}},"S3y":{"type":"list","member":{"shape":"S22"}}}}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['guardduty'] = {};
	AWS.GuardDuty = Service.defineService('guardduty', ['2017-11-28']);
	Object.defineProperty(apiLoader.services['guardduty'], '2017-11-28', {
	  get: function get() {
	    var model = __webpack_require__(546);
	    model.paginators = __webpack_require__(547).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.GuardDuty;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-28","endpointPrefix":"guardduty","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon GuardDuty","serviceId":"GuardDuty","signatureVersion":"v4","signingName":"guardduty","uid":"guardduty-2017-11-28"},"operations":{"AcceptInvitation":{"http":{"requestUri":"/detector/{detectorId}/master","responseCode":200},"input":{"type":"structure","required":["DetectorId","MasterId","InvitationId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MasterId":{"locationName":"masterId"},"InvitationId":{"locationName":"invitationId"}}},"output":{"type":"structure","members":{}}},"ArchiveFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/archive","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"}}},"output":{"type":"structure","members":{}}},"CreateDetector":{"http":{"requestUri":"/detector","responseCode":200},"input":{"type":"structure","required":["Enable"],"members":{"Enable":{"locationName":"enable","type":"boolean"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"FindingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"DataSources":{"shape":"Sd","locationName":"dataSources"},"Tags":{"shape":"Sh","locationName":"tags"}}},"output":{"type":"structure","members":{"DetectorId":{"locationName":"detectorId"}}}},"CreateFilter":{"http":{"requestUri":"/detector/{detectorId}/filter","responseCode":200},"input":{"type":"structure","required":["DetectorId","Name","FindingCriteria"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"Action":{"locationName":"action"},"Rank":{"locationName":"rank","type":"integer"},"FindingCriteria":{"shape":"Sq","locationName":"findingCriteria"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"Tags":{"shape":"Sh","locationName":"tags"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{"locationName":"name"}}}},"CreateIPSet":{"http":{"requestUri":"/detector/{detectorId}/ipset","responseCode":200},"input":{"type":"structure","required":["DetectorId","Name","Format","Location","Activate"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"Tags":{"shape":"Sh","locationName":"tags"}}},"output":{"type":"structure","required":["IpSetId"],"members":{"IpSetId":{"locationName":"ipSetId"}}}},"CreateMembers":{"http":{"requestUri":"/detector/{detectorId}/member","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountDetails"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountDetails":{"locationName":"accountDetails","type":"list","member":{"type":"structure","required":["AccountId","Email"],"members":{"AccountId":{"locationName":"accountId"},"Email":{"locationName":"email"}}}}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"CreatePublishingDestination":{"http":{"requestUri":"/detector/{detectorId}/publishingDestination","responseCode":200},"input":{"type":"structure","required":["DetectorId","DestinationType","DestinationProperties"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"DestinationType":{"locationName":"destinationType"},"DestinationProperties":{"shape":"S1f","locationName":"destinationProperties"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"}}},"output":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{"locationName":"destinationId"}}}},"CreateSampleFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/create","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingTypes":{"locationName":"findingTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"CreateThreatIntelSet":{"http":{"requestUri":"/detector/{detectorId}/threatintelset","responseCode":200},"input":{"type":"structure","required":["DetectorId","Name","Format","Location","Activate"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"Tags":{"shape":"Sh","locationName":"tags"}}},"output":{"type":"structure","required":["ThreatIntelSetId"],"members":{"ThreatIntelSetId":{"locationName":"threatIntelSetId"}}}},"DeclineInvitations":{"http":{"requestUri":"/invitation/decline","responseCode":200},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"DeleteDetector":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","members":{}}},"DeleteFilter":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/filter/{filterName}","responseCode":200},"input":{"type":"structure","required":["DetectorId","FilterName"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FilterName":{"location":"uri","locationName":"filterName"}}},"output":{"type":"structure","members":{}}},"DeleteIPSet":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/ipset/{ipSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","IpSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"IpSetId":{"location":"uri","locationName":"ipSetId"}}},"output":{"type":"structure","members":{}}},"DeleteInvitations":{"http":{"requestUri":"/invitation/delete","responseCode":200},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"DeleteMembers":{"http":{"requestUri":"/detector/{detectorId}/member/delete","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"DeletePublishingDestination":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/publishingDestination/{destinationId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","DestinationId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"DestinationId":{"location":"uri","locationName":"destinationId"}}},"output":{"type":"structure","members":{}}},"DeleteThreatIntelSet":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/threatintelset/{threatIntelSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","ThreatIntelSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"ThreatIntelSetId":{"location":"uri","locationName":"threatIntelSetId"}}},"output":{"type":"structure","members":{}}},"DescribeOrganizationConfiguration":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/admin","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","required":["AutoEnable","MemberAccountLimitReached"],"members":{"AutoEnable":{"locationName":"autoEnable","type":"boolean"},"MemberAccountLimitReached":{"locationName":"memberAccountLimitReached","type":"boolean"},"DataSources":{"locationName":"dataSources","type":"structure","required":["S3Logs"],"members":{"S3Logs":{"locationName":"s3Logs","type":"structure","required":["AutoEnable"],"members":{"AutoEnable":{"locationName":"autoEnable","type":"boolean"}}},"Kubernetes":{"locationName":"kubernetes","type":"structure","required":["AuditLogs"],"members":{"AuditLogs":{"locationName":"auditLogs","type":"structure","required":["AutoEnable"],"members":{"AutoEnable":{"locationName":"autoEnable","type":"boolean"}}}}}}}}}},"DescribePublishingDestination":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/publishingDestination/{destinationId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","DestinationId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"DestinationId":{"location":"uri","locationName":"destinationId"}}},"output":{"type":"structure","required":["DestinationId","DestinationType","Status","PublishingFailureStartTimestamp","DestinationProperties"],"members":{"DestinationId":{"locationName":"destinationId"},"DestinationType":{"locationName":"destinationType"},"Status":{"locationName":"status"},"PublishingFailureStartTimestamp":{"locationName":"publishingFailureStartTimestamp","type":"long"},"DestinationProperties":{"shape":"S1f","locationName":"destinationProperties"}}}},"DisableOrganizationAdminAccount":{"http":{"requestUri":"/admin/disable","responseCode":200},"input":{"type":"structure","required":["AdminAccountId"],"members":{"AdminAccountId":{"locationName":"adminAccountId"}}},"output":{"type":"structure","members":{}}},"DisassociateFromMasterAccount":{"http":{"requestUri":"/detector/{detectorId}/master/disassociate","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","members":{}}},"DisassociateMembers":{"http":{"requestUri":"/detector/{detectorId}/member/disassociate","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"EnableOrganizationAdminAccount":{"http":{"requestUri":"/admin/enable","responseCode":200},"input":{"type":"structure","required":["AdminAccountId"],"members":{"AdminAccountId":{"locationName":"adminAccountId"}}},"output":{"type":"structure","members":{}}},"GetDetector":{"http":{"method":"GET","requestUri":"/detector/{detectorId}","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","required":["ServiceRole","Status"],"members":{"CreatedAt":{"locationName":"createdAt"},"FindingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"ServiceRole":{"locationName":"serviceRole"},"Status":{"locationName":"status"},"UpdatedAt":{"locationName":"updatedAt"},"DataSources":{"shape":"S2p","locationName":"dataSources"},"Tags":{"shape":"Sh","locationName":"tags"}}}},"GetFilter":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/filter/{filterName}","responseCode":200},"input":{"type":"structure","required":["DetectorId","FilterName"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FilterName":{"location":"uri","locationName":"filterName"}}},"output":{"type":"structure","required":["Name","Action","FindingCriteria"],"members":{"Name":{"locationName":"name"},"Description":{"locationName":"description"},"Action":{"locationName":"action"},"Rank":{"locationName":"rank","type":"integer"},"FindingCriteria":{"shape":"Sq","locationName":"findingCriteria"},"Tags":{"shape":"Sh","locationName":"tags"}}}},"GetFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/get","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"},"SortCriteria":{"shape":"S30","locationName":"sortCriteria"}}},"output":{"type":"structure","required":["Findings"],"members":{"Findings":{"locationName":"findings","type":"list","member":{"type":"structure","required":["AccountId","Arn","CreatedAt","Id","Region","Resource","SchemaVersion","Severity","Type","UpdatedAt"],"members":{"AccountId":{"locationName":"accountId"},"Arn":{"locationName":"arn"},"Confidence":{"locationName":"confidence","type":"double"},"CreatedAt":{"locationName":"createdAt"},"Description":{"locationName":"description"},"Id":{"locationName":"id"},"Partition":{"locationName":"partition"},"Region":{"locationName":"region"},"Resource":{"locationName":"resource","type":"structure","members":{"AccessKeyDetails":{"locationName":"accessKeyDetails","type":"structure","members":{"AccessKeyId":{"locationName":"accessKeyId"},"PrincipalId":{"locationName":"principalId"},"UserName":{"locationName":"userName"},"UserType":{"locationName":"userType"}}},"S3BucketDetails":{"locationName":"s3BucketDetails","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"},"Type":{"locationName":"type"},"CreatedAt":{"locationName":"createdAt","type":"timestamp"},"Owner":{"locationName":"owner","type":"structure","members":{"Id":{"locationName":"id"}}},"Tags":{"shape":"S3c","locationName":"tags"},"DefaultServerSideEncryption":{"locationName":"defaultServerSideEncryption","type":"structure","members":{"EncryptionType":{"locationName":"encryptionType"},"KmsMasterKeyArn":{"locationName":"kmsMasterKeyArn"}}},"PublicAccess":{"locationName":"publicAccess","type":"structure","members":{"PermissionConfiguration":{"locationName":"permissionConfiguration","type":"structure","members":{"BucketLevelPermissions":{"locationName":"bucketLevelPermissions","type":"structure","members":{"AccessControlList":{"locationName":"accessControlList","type":"structure","members":{"AllowsPublicReadAccess":{"locationName":"allowsPublicReadAccess","type":"boolean"},"AllowsPublicWriteAccess":{"locationName":"allowsPublicWriteAccess","type":"boolean"}}},"BucketPolicy":{"locationName":"bucketPolicy","type":"structure","members":{"AllowsPublicReadAccess":{"locationName":"allowsPublicReadAccess","type":"boolean"},"AllowsPublicWriteAccess":{"locationName":"allowsPublicWriteAccess","type":"boolean"}}},"BlockPublicAccess":{"shape":"S3k","locationName":"blockPublicAccess"}}},"AccountLevelPermissions":{"locationName":"accountLevelPermissions","type":"structure","members":{"BlockPublicAccess":{"shape":"S3k","locationName":"blockPublicAccess"}}}}},"EffectivePermission":{"locationName":"effectivePermission"}}}}}},"InstanceDetails":{"locationName":"instanceDetails","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"ImageDescription":{"locationName":"imageDescription"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"locationName":"instanceState"},"InstanceType":{"locationName":"instanceType"},"OutpostArn":{"locationName":"outpostArn"},"LaunchTime":{"locationName":"launchTime"},"NetworkInterfaces":{"locationName":"networkInterfaces","type":"list","member":{"type":"structure","members":{"Ipv6Addresses":{"locationName":"ipv6Addresses","type":"list","member":{}},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddresses","type":"list","member":{"type":"structure","members":{"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"},"SecurityGroups":{"locationName":"securityGroups","type":"list","member":{"type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"}}}},"Platform":{"locationName":"platform"},"ProductCodes":{"locationName":"productCodes","type":"list","member":{"type":"structure","members":{"Code":{"locationName":"code"},"ProductType":{"locationName":"productType"}}}},"Tags":{"shape":"S3c","locationName":"tags"}}},"EksClusterDetails":{"locationName":"eksClusterDetails","type":"structure","members":{"Name":{"locationName":"name"},"Arn":{"locationName":"arn"},"VpcId":{"locationName":"vpcId"},"Status":{"locationName":"status"},"Tags":{"shape":"S3c","locationName":"tags"},"CreatedAt":{"locationName":"createdAt","type":"timestamp"}}},"KubernetesDetails":{"locationName":"kubernetesDetails","type":"structure","members":{"KubernetesUserDetails":{"locationName":"kubernetesUserDetails","type":"structure","members":{"Username":{"locationName":"username"},"Uid":{"locationName":"uid"},"Groups":{"locationName":"groups","type":"list","member":{}}}},"KubernetesWorkloadDetails":{"locationName":"kubernetesWorkloadDetails","type":"structure","members":{"Name":{"locationName":"name"},"Type":{"locationName":"type"},"Uid":{"locationName":"uid"},"Namespace":{"locationName":"namespace"},"HostNetwork":{"locationName":"hostNetwork","type":"boolean"},"Containers":{"locationName":"containers","type":"list","member":{"type":"structure","members":{"ContainerRuntime":{"locationName":"containerRuntime"},"Id":{"locationName":"id"},"Name":{"locationName":"name"},"Image":{"locationName":"image"},"ImagePrefix":{"locationName":"imagePrefix"},"VolumeMounts":{"locationName":"volumeMounts","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"MountPath":{"locationName":"mountPath"}}}},"SecurityContext":{"locationName":"securityContext","type":"structure","members":{"Privileged":{"locationName":"privileged","type":"boolean"}}}}}},"Volumes":{"locationName":"volumes","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"HostPath":{"locationName":"hostPath","type":"structure","members":{"Path":{"locationName":"path"}}}}}}}}}},"ResourceType":{"locationName":"resourceType"}}},"SchemaVersion":{"locationName":"schemaVersion"},"Service":{"locationName":"service","type":"structure","members":{"Action":{"locationName":"action","type":"structure","members":{"ActionType":{"locationName":"actionType"},"AwsApiCallAction":{"locationName":"awsApiCallAction","type":"structure","members":{"Api":{"locationName":"api"},"CallerType":{"locationName":"callerType"},"DomainDetails":{"locationName":"domainDetails","type":"structure","members":{"Domain":{"locationName":"domain"}}},"ErrorCode":{"locationName":"errorCode"},"UserAgent":{"locationName":"userAgent"},"RemoteIpDetails":{"shape":"S4e","locationName":"remoteIpDetails"},"ServiceName":{"locationName":"serviceName"},"RemoteAccountDetails":{"locationName":"remoteAccountDetails","type":"structure","members":{"AccountId":{"locationName":"accountId"},"Affiliated":{"locationName":"affiliated","type":"boolean"}}}}},"DnsRequestAction":{"locationName":"dnsRequestAction","type":"structure","members":{"Domain":{"locationName":"domain"}}},"NetworkConnectionAction":{"locationName":"networkConnectionAction","type":"structure","members":{"Blocked":{"locationName":"blocked","type":"boolean"},"ConnectionDirection":{"locationName":"connectionDirection"},"LocalPortDetails":{"shape":"S4m","locationName":"localPortDetails"},"Protocol":{"locationName":"protocol"},"LocalIpDetails":{"shape":"S4n","locationName":"localIpDetails"},"RemoteIpDetails":{"shape":"S4e","locationName":"remoteIpDetails"},"RemotePortDetails":{"locationName":"remotePortDetails","type":"structure","members":{"Port":{"locationName":"port","type":"integer"},"PortName":{"locationName":"portName"}}}}},"PortProbeAction":{"locationName":"portProbeAction","type":"structure","members":{"Blocked":{"locationName":"blocked","type":"boolean"},"PortProbeDetails":{"locationName":"portProbeDetails","type":"list","member":{"type":"structure","members":{"LocalPortDetails":{"shape":"S4m","locationName":"localPortDetails"},"LocalIpDetails":{"shape":"S4n","locationName":"localIpDetails"},"RemoteIpDetails":{"shape":"S4e","locationName":"remoteIpDetails"}}}}}},"KubernetesApiCallAction":{"locationName":"kubernetesApiCallAction","type":"structure","members":{"RequestUri":{"locationName":"requestUri"},"Verb":{"locationName":"verb"},"SourceIps":{"locationName":"sourceIps","type":"list","member":{}},"UserAgent":{"locationName":"userAgent"},"RemoteIpDetails":{"shape":"S4e","locationName":"remoteIpDetails"},"StatusCode":{"locationName":"statusCode","type":"integer"},"Parameters":{"locationName":"parameters"}}}}},"Evidence":{"locationName":"evidence","type":"structure","members":{"ThreatIntelligenceDetails":{"locationName":"threatIntelligenceDetails","type":"list","member":{"type":"structure","members":{"ThreatListName":{"locationName":"threatListName"},"ThreatNames":{"locationName":"threatNames","type":"list","member":{}}}}}}},"Archived":{"locationName":"archived","type":"boolean"},"Count":{"locationName":"count","type":"integer"},"DetectorId":{"locationName":"detectorId"},"EventFirstSeen":{"locationName":"eventFirstSeen"},"EventLastSeen":{"locationName":"eventLastSeen"},"ResourceRole":{"locationName":"resourceRole"},"ServiceName":{"locationName":"serviceName"},"UserFeedback":{"locationName":"userFeedback"}}},"Severity":{"locationName":"severity","type":"double"},"Title":{"locationName":"title"},"Type":{"locationName":"type"},"UpdatedAt":{"locationName":"updatedAt"}}}}}}},"GetFindingsStatistics":{"http":{"requestUri":"/detector/{detectorId}/findings/statistics","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingStatisticTypes"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingStatisticTypes":{"locationName":"findingStatisticTypes","type":"list","member":{}},"FindingCriteria":{"shape":"Sq","locationName":"findingCriteria"}}},"output":{"type":"structure","required":["FindingStatistics"],"members":{"FindingStatistics":{"locationName":"findingStatistics","type":"structure","members":{"CountBySeverity":{"locationName":"countBySeverity","type":"map","key":{},"value":{"type":"integer"}}}}}}},"GetIPSet":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/ipset/{ipSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","IpSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"IpSetId":{"location":"uri","locationName":"ipSetId"}}},"output":{"type":"structure","required":["Name","Format","Location","Status"],"members":{"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Status":{"locationName":"status"},"Tags":{"shape":"Sh","locationName":"tags"}}}},"GetInvitationsCount":{"http":{"method":"GET","requestUri":"/invitation/count","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"InvitationsCount":{"locationName":"invitationsCount","type":"integer"}}}},"GetMasterAccount":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/master","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","required":["Master"],"members":{"Master":{"locationName":"master","type":"structure","members":{"AccountId":{"locationName":"accountId"},"InvitationId":{"locationName":"invitationId"},"RelationshipStatus":{"locationName":"relationshipStatus"},"InvitedAt":{"locationName":"invitedAt"}}}}}},"GetMemberDetectors":{"http":{"requestUri":"/detector/{detectorId}/member/detector/get","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["MemberDataSourceConfigurations","UnprocessedAccounts"],"members":{"MemberDataSourceConfigurations":{"locationName":"members","type":"list","member":{"type":"structure","required":["AccountId","DataSources"],"members":{"AccountId":{"locationName":"accountId"},"DataSources":{"shape":"S2p","locationName":"dataSources"}}}},"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"GetMembers":{"http":{"requestUri":"/detector/{detectorId}/member/get","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["Members","UnprocessedAccounts"],"members":{"Members":{"shape":"S5i","locationName":"members"},"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"GetThreatIntelSet":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/threatintelset/{threatIntelSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","ThreatIntelSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"ThreatIntelSetId":{"location":"uri","locationName":"threatIntelSetId"}}},"output":{"type":"structure","required":["Name","Format","Location","Status"],"members":{"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Status":{"locationName":"status"},"Tags":{"shape":"Sh","locationName":"tags"}}}},"GetUsageStatistics":{"http":{"requestUri":"/detector/{detectorId}/usage/statistics","responseCode":200},"input":{"type":"structure","required":["DetectorId","UsageStatisticType","UsageCriteria"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"UsageStatisticType":{"locationName":"usageStatisticsType"},"UsageCriteria":{"locationName":"usageCriteria","type":"structure","required":["DataSources"],"members":{"AccountIds":{"shape":"S1p","locationName":"accountIds"},"DataSources":{"locationName":"dataSources","type":"list","member":{}},"Resources":{"locationName":"resources","type":"list","member":{}}}},"Unit":{"locationName":"unit"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"UsageStatistics":{"locationName":"usageStatistics","type":"structure","members":{"SumByAccount":{"locationName":"sumByAccount","type":"list","member":{"type":"structure","members":{"AccountId":{"locationName":"accountId"},"Total":{"shape":"S5y","locationName":"total"}}}},"SumByDataSource":{"locationName":"sumByDataSource","type":"list","member":{"type":"structure","members":{"DataSource":{"locationName":"dataSource"},"Total":{"shape":"S5y","locationName":"total"}}}},"SumByResource":{"shape":"S61","locationName":"sumByResource"},"TopResources":{"shape":"S61","locationName":"topResources"}}},"NextToken":{"locationName":"nextToken"}}}},"InviteMembers":{"http":{"requestUri":"/detector/{detectorId}/member/invite","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"},"DisableEmailNotification":{"locationName":"disableEmailNotification","type":"boolean"},"Message":{"locationName":"message"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"ListDetectors":{"http":{"method":"GET","requestUri":"/detector","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["DetectorIds"],"members":{"DetectorIds":{"locationName":"detectorIds","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListFilters":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/filter","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["FilterNames"],"members":{"FilterNames":{"locationName":"filterNames","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListFindings":{"http":{"requestUri":"/detector/{detectorId}/findings","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingCriteria":{"shape":"Sq","locationName":"findingCriteria"},"SortCriteria":{"shape":"S30","locationName":"sortCriteria"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","required":["FindingIds"],"members":{"FindingIds":{"shape":"S6","locationName":"findingIds"},"NextToken":{"locationName":"nextToken"}}}},"ListIPSets":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/ipset","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["IpSetIds"],"members":{"IpSetIds":{"locationName":"ipSetIds","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitation","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Invitations":{"locationName":"invitations","type":"list","member":{"type":"structure","members":{"AccountId":{"locationName":"accountId"},"InvitationId":{"locationName":"invitationId"},"RelationshipStatus":{"locationName":"relationshipStatus"},"InvitedAt":{"locationName":"invitedAt"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/member","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"OnlyAssociated":{"location":"querystring","locationName":"onlyAssociated"}}},"output":{"type":"structure","members":{"Members":{"shape":"S5i","locationName":"members"},"NextToken":{"locationName":"nextToken"}}}},"ListOrganizationAdminAccounts":{"http":{"method":"GET","requestUri":"/admin","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"AdminAccounts":{"locationName":"adminAccounts","type":"list","member":{"type":"structure","members":{"AdminAccountId":{"locationName":"adminAccountId"},"AdminStatus":{"locationName":"adminStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListPublishingDestinations":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/publishingDestination","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["Destinations"],"members":{"Destinations":{"locationName":"destinations","type":"list","member":{"type":"structure","required":["DestinationId","DestinationType","Status"],"members":{"DestinationId":{"locationName":"destinationId"},"DestinationType":{"locationName":"destinationType"},"Status":{"locationName":"status"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh","locationName":"tags"}}}},"ListThreatIntelSets":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/threatintelset","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["ThreatIntelSetIds"],"members":{"ThreatIntelSetIds":{"locationName":"threatIntelSetIds","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"StartMonitoringMembers":{"http":{"requestUri":"/detector/{detectorId}/member/start","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"StopMonitoringMembers":{"http":{"requestUri":"/detector/{detectorId}/member/stop","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sh","locationName":"tags"}}},"output":{"type":"structure","members":{}}},"UnarchiveFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/unarchive","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDetector":{"http":{"requestUri":"/detector/{detectorId}","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Enable":{"locationName":"enable","type":"boolean"},"FindingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"DataSources":{"shape":"Sd","locationName":"dataSources"}}},"output":{"type":"structure","members":{}}},"UpdateFilter":{"http":{"requestUri":"/detector/{detectorId}/filter/{filterName}","responseCode":200},"input":{"type":"structure","required":["DetectorId","FilterName"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FilterName":{"location":"uri","locationName":"filterName"},"Description":{"locationName":"description"},"Action":{"locationName":"action"},"Rank":{"locationName":"rank","type":"integer"},"FindingCriteria":{"shape":"Sq","locationName":"findingCriteria"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{"locationName":"name"}}}},"UpdateFindingsFeedback":{"http":{"requestUri":"/detector/{detectorId}/findings/feedback","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds","Feedback"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"},"Feedback":{"locationName":"feedback"},"Comments":{"locationName":"comments"}}},"output":{"type":"structure","members":{}}},"UpdateIPSet":{"http":{"requestUri":"/detector/{detectorId}/ipset/{ipSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","IpSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"IpSetId":{"location":"uri","locationName":"ipSetId"},"Name":{"locationName":"name"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateMemberDetectors":{"http":{"requestUri":"/detector/{detectorId}/member/detector/update","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1p","locationName":"accountIds"},"DataSources":{"shape":"Sd","locationName":"dataSources"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S1b","locationName":"unprocessedAccounts"}}}},"UpdateOrganizationConfiguration":{"http":{"requestUri":"/detector/{detectorId}/admin","responseCode":200},"input":{"type":"structure","required":["DetectorId","AutoEnable"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AutoEnable":{"locationName":"autoEnable","type":"boolean"},"DataSources":{"locationName":"dataSources","type":"structure","members":{"S3Logs":{"locationName":"s3Logs","type":"structure","required":["AutoEnable"],"members":{"AutoEnable":{"locationName":"autoEnable","type":"boolean"}}},"Kubernetes":{"locationName":"kubernetes","type":"structure","required":["AuditLogs"],"members":{"AuditLogs":{"locationName":"auditLogs","type":"structure","required":["AutoEnable"],"members":{"AutoEnable":{"locationName":"autoEnable","type":"boolean"}}}}}}}}},"output":{"type":"structure","members":{}}},"UpdatePublishingDestination":{"http":{"requestUri":"/detector/{detectorId}/publishingDestination/{destinationId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","DestinationId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"DestinationId":{"location":"uri","locationName":"destinationId"},"DestinationProperties":{"shape":"S1f","locationName":"destinationProperties"}}},"output":{"type":"structure","members":{}}},"UpdateThreatIntelSet":{"http":{"requestUri":"/detector/{detectorId}/threatintelset/{threatIntelSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","ThreatIntelSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"ThreatIntelSetId":{"location":"uri","locationName":"threatIntelSetId"},"Name":{"locationName":"name"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{}},"Sd":{"type":"structure","members":{"S3Logs":{"locationName":"s3Logs","type":"structure","required":["Enable"],"members":{"Enable":{"locationName":"enable","type":"boolean"}}},"Kubernetes":{"locationName":"kubernetes","type":"structure","required":["AuditLogs"],"members":{"AuditLogs":{"locationName":"auditLogs","type":"structure","required":["Enable"],"members":{"Enable":{"locationName":"enable","type":"boolean"}}}}}}},"Sh":{"type":"map","key":{},"value":{}},"Sq":{"type":"structure","members":{"Criterion":{"locationName":"criterion","type":"map","key":{},"value":{"type":"structure","members":{"Eq":{"deprecated":true,"locationName":"eq","type":"list","member":{}},"Neq":{"deprecated":true,"locationName":"neq","type":"list","member":{}},"Gt":{"deprecated":true,"locationName":"gt","type":"integer"},"Gte":{"deprecated":true,"locationName":"gte","type":"integer"},"Lt":{"deprecated":true,"locationName":"lt","type":"integer"},"Lte":{"deprecated":true,"locationName":"lte","type":"integer"},"Equals":{"locationName":"equals","type":"list","member":{}},"NotEquals":{"locationName":"notEquals","type":"list","member":{}},"GreaterThan":{"locationName":"greaterThan","type":"long"},"GreaterThanOrEqual":{"locationName":"greaterThanOrEqual","type":"long"},"LessThan":{"locationName":"lessThan","type":"long"},"LessThanOrEqual":{"locationName":"lessThanOrEqual","type":"long"}}}}}},"S1b":{"type":"list","member":{"type":"structure","required":["AccountId","Result"],"members":{"AccountId":{"locationName":"accountId"},"Result":{"locationName":"result"}}}},"S1f":{"type":"structure","members":{"DestinationArn":{"locationName":"destinationArn"},"KmsKeyArn":{"locationName":"kmsKeyArn"}}},"S1p":{"type":"list","member":{}},"S2p":{"type":"structure","required":["CloudTrail","DNSLogs","FlowLogs","S3Logs"],"members":{"CloudTrail":{"locationName":"cloudTrail","type":"structure","required":["Status"],"members":{"Status":{"locationName":"status"}}},"DNSLogs":{"locationName":"dnsLogs","type":"structure","required":["Status"],"members":{"Status":{"locationName":"status"}}},"FlowLogs":{"locationName":"flowLogs","type":"structure","required":["Status"],"members":{"Status":{"locationName":"status"}}},"S3Logs":{"locationName":"s3Logs","type":"structure","required":["Status"],"members":{"Status":{"locationName":"status"}}},"Kubernetes":{"locationName":"kubernetes","type":"structure","required":["AuditLogs"],"members":{"AuditLogs":{"locationName":"auditLogs","type":"structure","required":["Status"],"members":{"Status":{"locationName":"status"}}}}}}},"S30":{"type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"OrderBy":{"locationName":"orderBy"}}},"S3c":{"type":"list","member":{"type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"S3k":{"type":"structure","members":{"IgnorePublicAcls":{"locationName":"ignorePublicAcls","type":"boolean"},"RestrictPublicBuckets":{"locationName":"restrictPublicBuckets","type":"boolean"},"BlockPublicAcls":{"locationName":"blockPublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"blockPublicPolicy","type":"boolean"}}},"S4e":{"type":"structure","members":{"City":{"locationName":"city","type":"structure","members":{"CityName":{"locationName":"cityName"}}},"Country":{"locationName":"country","type":"structure","members":{"CountryCode":{"locationName":"countryCode"},"CountryName":{"locationName":"countryName"}}},"GeoLocation":{"locationName":"geoLocation","type":"structure","members":{"Lat":{"locationName":"lat","type":"double"},"Lon":{"locationName":"lon","type":"double"}}},"IpAddressV4":{"locationName":"ipAddressV4"},"Organization":{"locationName":"organization","type":"structure","members":{"Asn":{"locationName":"asn"},"AsnOrg":{"locationName":"asnOrg"},"Isp":{"locationName":"isp"},"Org":{"locationName":"org"}}}}},"S4m":{"type":"structure","members":{"Port":{"locationName":"port","type":"integer"},"PortName":{"locationName":"portName"}}},"S4n":{"type":"structure","members":{"IpAddressV4":{"locationName":"ipAddressV4"}}},"S5i":{"type":"list","member":{"type":"structure","required":["AccountId","MasterId","Email","RelationshipStatus","UpdatedAt"],"members":{"AccountId":{"locationName":"accountId"},"DetectorId":{"locationName":"detectorId"},"MasterId":{"locationName":"masterId"},"Email":{"locationName":"email"},"RelationshipStatus":{"locationName":"relationshipStatus"},"InvitedAt":{"locationName":"invitedAt"},"UpdatedAt":{"locationName":"updatedAt"}}}},"S5y":{"type":"structure","members":{"Amount":{"locationName":"amount"},"Unit":{"locationName":"unit"}}},"S61":{"type":"list","member":{"type":"structure","members":{"Resource":{"locationName":"resource"},"Total":{"shape":"S5y","locationName":"total"}}}}}}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetUsageStatistics":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDetectors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DetectorIds"},"ListFilters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FilterNames"},"ListFindings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FindingIds"},"ListIPSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"IpSetIds"},"ListInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Invitations"},"ListMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Members"},"ListOrganizationAdminAccounts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AdminAccounts"},"ListPublishingDestinations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListThreatIntelSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ThreatIntelSetIds"}}}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mq'] = {};
	AWS.MQ = Service.defineService('mq', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['mq'], '2017-11-27', {
	  get: function get() {
	    var model = __webpack_require__(549);
	    model.paginators = __webpack_require__(550).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MQ;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-11-27","endpointPrefix":"mq","signingName":"mq","serviceFullName":"AmazonMQ","serviceId":"mq","protocol":"rest-json","jsonVersion":"1.1","uid":"mq-2017-11-27","signatureVersion":"v4"},"operations":{"CreateBroker":{"http":{"requestUri":"/v1/brokers","responseCode":200},"input":{"type":"structure","members":{"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerName":{"locationName":"brokerName"},"Configuration":{"shape":"S5","locationName":"configuration"},"CreatorRequestId":{"locationName":"creatorRequestId","idempotencyToken":true},"DeploymentMode":{"locationName":"deploymentMode"},"EncryptionOptions":{"shape":"S8","locationName":"encryptionOptions"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"HostInstanceType":{"locationName":"hostInstanceType"},"LdapServerMetadata":{"shape":"Sa","locationName":"ldapServerMetadata"},"Logs":{"shape":"Sc","locationName":"logs"},"MaintenanceWindowStartTime":{"shape":"Sd","locationName":"maintenanceWindowStartTime"},"PubliclyAccessible":{"locationName":"publiclyAccessible","type":"boolean"},"SecurityGroups":{"shape":"Sb","locationName":"securityGroups"},"StorageType":{"locationName":"storageType"},"SubnetIds":{"shape":"Sb","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"},"Users":{"locationName":"users","type":"list","member":{"type":"structure","members":{"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sb","locationName":"groups"},"Password":{"locationName":"password"},"Username":{"locationName":"username"}},"required":["Username","Password"]}}},"required":["EngineVersion","HostInstanceType","AutoMinorVersionUpgrade","Users","BrokerName","DeploymentMode","EngineType","PubliclyAccessible"]},"output":{"type":"structure","members":{"BrokerArn":{"locationName":"brokerArn"},"BrokerId":{"locationName":"brokerId"}}}},"CreateConfiguration":{"http":{"requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"Name":{"locationName":"name"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["EngineVersion","EngineType","Name"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"Created":{"shape":"Sm","locationName":"created"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sn","locationName":"latestRevision"},"Name":{"locationName":"name"}}}},"CreateTags":{"http":{"requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["ResourceArn"]}},"CreateUser":{"http":{"requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sb","locationName":"groups"},"Password":{"locationName":"password"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId","Password"]},"output":{"type":"structure","members":{}}},"DeleteBroker":{"http":{"method":"DELETE","requestUri":"/v1/brokers/{broker-id}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"BrokerId":{"locationName":"brokerId"}}}},"DeleteTags":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"Sb","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{}}},"DescribeBroker":{"http":{"method":"GET","requestUri":"/v1/brokers/{broker-id}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"ActionsRequired":{"locationName":"actionsRequired","type":"list","member":{"type":"structure","members":{"ActionRequiredCode":{"locationName":"actionRequiredCode"},"ActionRequiredInfo":{"locationName":"actionRequiredInfo"}}}},"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerArn":{"locationName":"brokerArn"},"BrokerId":{"locationName":"brokerId"},"BrokerInstances":{"locationName":"brokerInstances","type":"list","member":{"type":"structure","members":{"ConsoleURL":{"locationName":"consoleURL"},"Endpoints":{"shape":"Sb","locationName":"endpoints"},"IpAddress":{"locationName":"ipAddress"}}}},"BrokerName":{"locationName":"brokerName"},"BrokerState":{"locationName":"brokerState"},"Configurations":{"locationName":"configurations","type":"structure","members":{"Current":{"shape":"S5","locationName":"current"},"History":{"locationName":"history","type":"list","member":{"shape":"S5"}},"Pending":{"shape":"S5","locationName":"pending"}}},"Created":{"shape":"Sm","locationName":"created"},"DeploymentMode":{"locationName":"deploymentMode"},"EncryptionOptions":{"shape":"S8","locationName":"encryptionOptions"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"HostInstanceType":{"locationName":"hostInstanceType"},"LdapServerMetadata":{"shape":"S15","locationName":"ldapServerMetadata"},"Logs":{"locationName":"logs","type":"structure","members":{"Audit":{"locationName":"audit","type":"boolean"},"AuditLogGroup":{"locationName":"auditLogGroup"},"General":{"locationName":"general","type":"boolean"},"GeneralLogGroup":{"locationName":"generalLogGroup"},"Pending":{"locationName":"pending","type":"structure","members":{"Audit":{"locationName":"audit","type":"boolean"},"General":{"locationName":"general","type":"boolean"}}}},"required":["GeneralLogGroup","General"]},"MaintenanceWindowStartTime":{"shape":"Sd","locationName":"maintenanceWindowStartTime"},"PendingAuthenticationStrategy":{"locationName":"pendingAuthenticationStrategy"},"PendingEngineVersion":{"locationName":"pendingEngineVersion"},"PendingHostInstanceType":{"locationName":"pendingHostInstanceType"},"PendingLdapServerMetadata":{"shape":"S15","locationName":"pendingLdapServerMetadata"},"PendingSecurityGroups":{"shape":"Sb","locationName":"pendingSecurityGroups"},"PubliclyAccessible":{"locationName":"publiclyAccessible","type":"boolean"},"SecurityGroups":{"shape":"Sb","locationName":"securityGroups"},"StorageType":{"locationName":"storageType"},"SubnetIds":{"shape":"Sb","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"},"Users":{"shape":"S18","locationName":"users"}}}},"DescribeBrokerEngineTypes":{"http":{"method":"GET","requestUri":"/v1/broker-engine-types","responseCode":200},"input":{"type":"structure","members":{"EngineType":{"location":"querystring","locationName":"engineType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"BrokerEngineTypes":{"locationName":"brokerEngineTypes","type":"list","member":{"type":"structure","members":{"EngineType":{"locationName":"engineType"},"EngineVersions":{"locationName":"engineVersions","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"}}}}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeBrokerInstanceOptions":{"http":{"method":"GET","requestUri":"/v1/broker-instance-options","responseCode":200},"input":{"type":"structure","members":{"EngineType":{"location":"querystring","locationName":"engineType"},"HostInstanceType":{"location":"querystring","locationName":"hostInstanceType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"StorageType":{"location":"querystring","locationName":"storageType"}}},"output":{"type":"structure","members":{"BrokerInstanceOptions":{"locationName":"brokerInstanceOptions","type":"list","member":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZones","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"}}}},"EngineType":{"locationName":"engineType"},"HostInstanceType":{"locationName":"hostInstanceType"},"StorageType":{"locationName":"storageType"},"SupportedDeploymentModes":{"locationName":"supportedDeploymentModes","type":"list","member":{}},"SupportedEngineVersions":{"shape":"Sb","locationName":"supportedEngineVersions"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeConfiguration":{"http":{"method":"GET","requestUri":"/v1/configurations/{configuration-id}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"}},"required":["ConfigurationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"Created":{"shape":"Sm","locationName":"created"},"Description":{"locationName":"description"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sn","locationName":"latestRevision"},"Name":{"locationName":"name"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"DescribeConfigurationRevision":{"http":{"method":"GET","requestUri":"/v1/configurations/{configuration-id}/revisions/{configuration-revision}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"},"ConfigurationRevision":{"location":"uri","locationName":"configuration-revision"}},"required":["ConfigurationRevision","ConfigurationId"]},"output":{"type":"structure","members":{"ConfigurationId":{"locationName":"configurationId"},"Created":{"shape":"Sm","locationName":"created"},"Data":{"locationName":"data"},"Description":{"locationName":"description"}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{"BrokerId":{"locationName":"brokerId"},"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sb","locationName":"groups"},"Pending":{"locationName":"pending","type":"structure","members":{"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sb","locationName":"groups"},"PendingChange":{"locationName":"pendingChange"}},"required":["PendingChange"]},"Username":{"locationName":"username"}}}},"ListBrokers":{"http":{"method":"GET","requestUri":"/v1/brokers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"BrokerSummaries":{"locationName":"brokerSummaries","type":"list","member":{"type":"structure","members":{"BrokerArn":{"locationName":"brokerArn"},"BrokerId":{"locationName":"brokerId"},"BrokerName":{"locationName":"brokerName"},"BrokerState":{"locationName":"brokerState"},"Created":{"shape":"Sm","locationName":"created"},"DeploymentMode":{"locationName":"deploymentMode"},"EngineType":{"locationName":"engineType"},"HostInstanceType":{"locationName":"hostInstanceType"}},"required":["DeploymentMode","EngineType"]}},"NextToken":{"locationName":"nextToken"}}}},"ListConfigurationRevisions":{"http":{"method":"GET","requestUri":"/v1/configurations/{configuration-id}/revisions","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ConfigurationId"]},"output":{"type":"structure","members":{"ConfigurationId":{"locationName":"configurationId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"Revisions":{"locationName":"revisions","type":"list","member":{"shape":"Sn"}}}}},"ListConfigurations":{"http":{"method":"GET","requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Configurations":{"locationName":"configurations","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"Created":{"shape":"Sm","locationName":"created"},"Description":{"locationName":"description"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sn","locationName":"latestRevision"},"Name":{"locationName":"name"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["Description","EngineVersion","LatestRevision","AuthenticationStrategy","EngineType","Id","Arn","Name","Created"]}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"ListTags":{"http":{"method":"GET","requestUri":"/v1/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sg","locationName":"tags"}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/v1/brokers/{broker-id}/users","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"BrokerId":{"locationName":"brokerId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"Users":{"shape":"S18","locationName":"users"}}}},"RebootBroker":{"http":{"requestUri":"/v1/brokers/{broker-id}/reboot","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"}},"required":["BrokerId"]},"output":{"type":"structure","members":{}}},"UpdateBroker":{"http":{"method":"PUT","requestUri":"/v1/brokers/{broker-id}","responseCode":200},"input":{"type":"structure","members":{"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerId":{"location":"uri","locationName":"broker-id"},"Configuration":{"shape":"S5","locationName":"configuration"},"EngineVersion":{"locationName":"engineVersion"},"HostInstanceType":{"locationName":"hostInstanceType"},"LdapServerMetadata":{"shape":"Sa","locationName":"ldapServerMetadata"},"Logs":{"shape":"Sc","locationName":"logs"},"MaintenanceWindowStartTime":{"shape":"Sd","locationName":"maintenanceWindowStartTime"},"SecurityGroups":{"shape":"Sb","locationName":"securityGroups"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"AuthenticationStrategy":{"locationName":"authenticationStrategy"},"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerId":{"locationName":"brokerId"},"Configuration":{"shape":"S5","locationName":"configuration"},"EngineVersion":{"locationName":"engineVersion"},"HostInstanceType":{"locationName":"hostInstanceType"},"LdapServerMetadata":{"shape":"S15","locationName":"ldapServerMetadata"},"Logs":{"shape":"Sc","locationName":"logs"},"MaintenanceWindowStartTime":{"shape":"Sd","locationName":"maintenanceWindowStartTime"},"SecurityGroups":{"shape":"Sb","locationName":"securityGroups"}}}},"UpdateConfiguration":{"http":{"method":"PUT","requestUri":"/v1/configurations/{configuration-id}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"},"Data":{"locationName":"data"},"Description":{"locationName":"description"}},"required":["ConfigurationId","Data"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Created":{"shape":"Sm","locationName":"created"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sn","locationName":"latestRevision"},"Name":{"locationName":"name"},"Warnings":{"locationName":"warnings","type":"list","member":{"type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"ElementName":{"locationName":"elementName"},"Reason":{"locationName":"reason"}},"required":["Reason"]}}}}},"UpdateUser":{"http":{"method":"PUT","requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sb","locationName":"groups"},"Password":{"locationName":"password"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","members":{"Id":{"locationName":"id"},"Revision":{"locationName":"revision","type":"integer"}},"required":["Id"]},"S8":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"},"UseAwsOwnedKey":{"locationName":"useAwsOwnedKey","type":"boolean"}},"required":["UseAwsOwnedKey"]},"Sa":{"type":"structure","members":{"Hosts":{"shape":"Sb","locationName":"hosts"},"RoleBase":{"locationName":"roleBase"},"RoleName":{"locationName":"roleName"},"RoleSearchMatching":{"locationName":"roleSearchMatching"},"RoleSearchSubtree":{"locationName":"roleSearchSubtree","type":"boolean"},"ServiceAccountPassword":{"locationName":"serviceAccountPassword"},"ServiceAccountUsername":{"locationName":"serviceAccountUsername"},"UserBase":{"locationName":"userBase"},"UserRoleName":{"locationName":"userRoleName"},"UserSearchMatching":{"locationName":"userSearchMatching"},"UserSearchSubtree":{"locationName":"userSearchSubtree","type":"boolean"}},"required":["Hosts","UserSearchMatching","UserBase","RoleSearchMatching","ServiceAccountUsername","RoleBase","ServiceAccountPassword"]},"Sb":{"type":"list","member":{}},"Sc":{"type":"structure","members":{"Audit":{"locationName":"audit","type":"boolean"},"General":{"locationName":"general","type":"boolean"}}},"Sd":{"type":"structure","members":{"DayOfWeek":{"locationName":"dayOfWeek"},"TimeOfDay":{"locationName":"timeOfDay"},"TimeZone":{"locationName":"timeZone"}},"required":["TimeOfDay","DayOfWeek"]},"Sg":{"type":"map","key":{},"value":{}},"Sm":{"type":"timestamp","timestampFormat":"iso8601"},"Sn":{"type":"structure","members":{"Created":{"shape":"Sm","locationName":"created"},"Description":{"locationName":"description"},"Revision":{"locationName":"revision","type":"integer"}},"required":["Revision","Created"]},"S15":{"type":"structure","members":{"Hosts":{"shape":"Sb","locationName":"hosts"},"RoleBase":{"locationName":"roleBase"},"RoleName":{"locationName":"roleName"},"RoleSearchMatching":{"locationName":"roleSearchMatching"},"RoleSearchSubtree":{"locationName":"roleSearchSubtree","type":"boolean"},"ServiceAccountUsername":{"locationName":"serviceAccountUsername"},"UserBase":{"locationName":"userBase"},"UserRoleName":{"locationName":"userRoleName"},"UserSearchMatching":{"locationName":"userSearchMatching"},"UserSearchSubtree":{"locationName":"userSearchSubtree","type":"boolean"}},"required":["Hosts","UserSearchMatching","UserBase","RoleSearchMatching","ServiceAccountUsername","RoleBase"]},"S18":{"type":"list","member":{"type":"structure","members":{"PendingChange":{"locationName":"pendingChange"},"Username":{"locationName":"username"}},"required":["Username"]}}},"authorizers":{"authorization_strategy":{"name":"authorization_strategy","type":"provided","placement":{"location":"header","name":"Authorization"}}}}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBrokers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"BrokerSummaries"}}}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['comprehend'] = {};
	AWS.Comprehend = Service.defineService('comprehend', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['comprehend'], '2017-11-27', {
	  get: function get() {
	    var model = __webpack_require__(552);
	    model.paginators = __webpack_require__(553).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Comprehend;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"comprehend","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Comprehend","serviceId":"Comprehend","signatureVersion":"v4","signingName":"comprehend","targetPrefix":"Comprehend_20171127","uid":"comprehend-2017-11-27"},"operations":{"BatchDetectDominantLanguage":{"input":{"type":"structure","required":["TextList"],"members":{"TextList":{"shape":"S2"}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Languages":{"shape":"S8"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectEntities":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Entities":{"shape":"Sj"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectKeyPhrases":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"KeyPhrases":{"shape":"Sq"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectSentiment":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Sentiment":{},"SentimentScore":{"shape":"Sx"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectSyntax":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"SyntaxTokens":{"shape":"S13"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"ClassifyDocument":{"input":{"type":"structure","required":["Text","EndpointArn"],"members":{"Text":{"shape":"S3"},"EndpointArn":{}}},"output":{"type":"structure","members":{"Classes":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}}},"sensitive":true}},"ContainsPiiEntities":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}}}}},"CreateDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"DocumentClassifierName":{},"VersionName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S1n"},"InputDataConfig":{"shape":"S1r"},"OutputDataConfig":{"shape":"S21"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Mode":{},"ModelKmsKeyId":{},"ModelPolicy":{}}},"output":{"type":"structure","members":{"DocumentClassifierArn":{}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointName","ModelArn","DesiredInferenceUnits"],"members":{"EndpointName":{},"ModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S1n"},"DataAccessRoleArn":{}}},"output":{"type":"structure","members":{"EndpointArn":{}}}},"CreateEntityRecognizer":{"input":{"type":"structure","required":["RecognizerName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"RecognizerName":{},"VersionName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S1n"},"InputDataConfig":{"shape":"S2k"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"ModelKmsKeyId":{},"ModelPolicy":{}}},"output":{"type":"structure","members":{"EntityRecognizerArn":{}}}},"DeleteDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"PolicyRevisionId":{}}},"output":{"type":"structure","members":{}}},"DescribeDocumentClassificationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DocumentClassificationJobProperties":{"shape":"S38"}}}},"DescribeDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{"DocumentClassifierProperties":{"shape":"S3n"}}}},"DescribeDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobProperties":{"shape":"S3u"}}}},"DescribeEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"EndpointProperties":{"shape":"S3x"}}}},"DescribeEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"EntitiesDetectionJobProperties":{"shape":"S41"}}}},"DescribeEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{"EntityRecognizerProperties":{"shape":"S44"}}}},"DescribeEventsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"EventsDetectionJobProperties":{"shape":"S4c"}}}},"DescribeKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobProperties":{"shape":"S4h"}}}},"DescribePiiEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"PiiEntitiesDetectionJobProperties":{"shape":"S4k"}}}},"DescribeResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourcePolicy":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"PolicyRevisionId":{}}}},"DescribeSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"SentimentDetectionJobProperties":{"shape":"S4v"}}}},"DescribeTargetedSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TargetedSentimentDetectionJobProperties":{"shape":"S4y"}}}},"DescribeTopicsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TopicsDetectionJobProperties":{"shape":"S51"}}}},"DetectDominantLanguage":{"input":{"type":"structure","required":["Text"],"members":{"Text":{"shape":"S3"}}},"output":{"type":"structure","members":{"Languages":{"shape":"S8"}},"sensitive":true}},"DetectEntities":{"input":{"type":"structure","required":["Text"],"members":{"Text":{"shape":"S3"},"LanguageCode":{},"EndpointArn":{}}},"output":{"type":"structure","members":{"Entities":{"shape":"Sj"}},"sensitive":true}},"DetectKeyPhrases":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"KeyPhrases":{"shape":"Sq"}},"sensitive":true}},"DetectPiiEntities":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Type":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}}}}},"DetectSentiment":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"Sentiment":{},"SentimentScore":{"shape":"Sx"}},"sensitive":true}},"DetectSyntax":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"SyntaxTokens":{"shape":"S13"}},"sensitive":true}},"ImportModel":{"input":{"type":"structure","required":["SourceModelArn"],"members":{"SourceModelArn":{},"ModelName":{},"VersionName":{},"ModelKmsKeyId":{},"DataAccessRoleArn":{},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ModelArn":{}}}},"ListDocumentClassificationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassificationJobPropertiesList":{"type":"list","member":{"shape":"S38"}},"NextToken":{}}}},"ListDocumentClassifierSummaries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassifierSummariesList":{"type":"list","member":{"type":"structure","members":{"DocumentClassifierName":{},"NumberOfVersions":{"type":"integer"},"LatestVersionCreatedAt":{"type":"timestamp"},"LatestVersionName":{},"LatestVersionStatus":{}}}},"NextToken":{}}}},"ListDocumentClassifiers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"DocumentClassifierName":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassifierPropertiesList":{"type":"list","member":{"shape":"S3n"}},"NextToken":{}}}},"ListDominantLanguageDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobPropertiesList":{"type":"list","member":{"shape":"S3u"}},"NextToken":{}}}},"ListEndpoints":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"ModelArn":{},"Status":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EndpointPropertiesList":{"type":"list","member":{"shape":"S3x"}},"NextToken":{}}}},"ListEntitiesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntitiesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S41"}},"NextToken":{}}}},"ListEntityRecognizerSummaries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntityRecognizerSummariesList":{"type":"list","member":{"type":"structure","members":{"RecognizerName":{},"NumberOfVersions":{"type":"integer"},"LatestVersionCreatedAt":{"type":"timestamp"},"LatestVersionName":{},"LatestVersionStatus":{}}}},"NextToken":{}}}},"ListEntityRecognizers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"RecognizerName":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntityRecognizerPropertiesList":{"type":"list","member":{"shape":"S44"}},"NextToken":{}}}},"ListEventsDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EventsDetectionJobPropertiesList":{"type":"list","member":{"shape":"S4c"}},"NextToken":{}}}},"ListKeyPhrasesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S4h"}},"NextToken":{}}}},"ListPiiEntitiesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PiiEntitiesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S4k"}},"NextToken":{}}}},"ListSentimentDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SentimentDetectionJobPropertiesList":{"type":"list","member":{"shape":"S4v"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"S1n"}}}},"ListTargetedSentimentDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TargetedSentimentDetectionJobPropertiesList":{"type":"list","member":{"shape":"S4y"}},"NextToken":{}}}},"ListTopicsDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TopicsDetectionJobPropertiesList":{"type":"list","member":{"shape":"S51"}},"NextToken":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","ResourcePolicy"],"members":{"ResourceArn":{},"ResourcePolicy":{},"PolicyRevisionId":{}}},"output":{"type":"structure","members":{"PolicyRevisionId":{}}}},"StartDocumentClassificationJob":{"input":{"type":"structure","required":["DocumentClassifierArn","InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"JobName":{},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartDominantLanguageDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartEntitiesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"EntityRecognizerArn":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartEventsDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode","TargetEventTypes"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"TargetEventTypes":{"shape":"S4d"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartPiiEntitiesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","Mode","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"Mode":{},"RedactionConfig":{"shape":"S4m"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartSentimentDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartTargetedSentimentDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartTopicsDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"JobName":{},"NumberOfTopics":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StopDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopEventsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopPiiEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTargetedSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTrainingDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"StopTrainingEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{},"DesiredModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"DesiredDataAccessRoleArn":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{"shape":"S3"},"sensitive":true},"S3":{"type":"string","sensitive":true},"S8":{"type":"list","member":{"type":"structure","members":{"LanguageCode":{},"Score":{"type":"float"}}}},"Sc":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}},"Sj":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Type":{},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"Sq":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"Sx":{"type":"structure","members":{"Positive":{"type":"float"},"Negative":{"type":"float"},"Neutral":{"type":"float"},"Mixed":{"type":"float"}}},"S13":{"type":"list","member":{"type":"structure","members":{"TokenId":{"type":"integer"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"PartOfSpeech":{"type":"structure","members":{"Tag":{},"Score":{"type":"float"}}}}}},"S1n":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1r":{"type":"structure","members":{"DataFormat":{},"S3Uri":{},"TestS3Uri":{},"LabelDelimiter":{},"AugmentedManifests":{"type":"list","member":{"shape":"S1w"}}}},"S1w":{"type":"structure","required":["S3Uri","AttributeNames"],"members":{"S3Uri":{},"Split":{},"AttributeNames":{"type":"list","member":{}},"AnnotationDataS3Uri":{},"SourceDocumentsS3Uri":{},"DocumentType":{}}},"S21":{"type":"structure","members":{"S3Uri":{},"KmsKeyId":{}}},"S24":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"type":"list","member":{}}}},"S2k":{"type":"structure","required":["EntityTypes"],"members":{"DataFormat":{},"EntityTypes":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{}}}},"Documents":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"TestS3Uri":{},"InputFormat":{}}},"Annotations":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"TestS3Uri":{}}},"EntityList":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"AugmentedManifests":{"type":"list","member":{"shape":"S1w"}}}},"S38":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}},"S3e":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"InputFormat":{},"DocumentReaderConfig":{"type":"structure","required":["DocumentReadAction"],"members":{"DocumentReadAction":{},"DocumentReadMode":{},"FeatureTypes":{"type":"list","member":{}}}}}},"S3k":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{}}},"S3n":{"type":"structure","members":{"DocumentClassifierArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S1r"},"OutputDataConfig":{"shape":"S21"},"ClassifierMetadata":{"type":"structure","members":{"NumberOfLabels":{"type":"integer"},"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Accuracy":{"type":"double"},"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"},"MicroPrecision":{"type":"double"},"MicroRecall":{"type":"double"},"MicroF1Score":{"type":"double"},"HammingLoss":{"type":"double"}}}},"sensitive":true},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"Mode":{},"ModelKmsKeyId":{},"VersionName":{},"SourceModelArn":{}}},"S3u":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}},"S3x":{"type":"structure","members":{"EndpointArn":{},"Status":{},"Message":{},"ModelArn":{},"DesiredModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"CurrentInferenceUnits":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"DataAccessRoleArn":{},"DesiredDataAccessRoleArn":{}}},"S41":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EntityRecognizerArn":{},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}},"S44":{"type":"structure","members":{"EntityRecognizerArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2k"},"RecognizerMetadata":{"type":"structure","members":{"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"EntityTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"NumberOfTrainMentions":{"type":"integer"}}}}},"sensitive":true},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"},"ModelKmsKeyId":{},"VersionName":{},"SourceModelArn":{}}},"S4c":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"LanguageCode":{},"DataAccessRoleArn":{},"TargetEventTypes":{"shape":"S4d"}}},"S4d":{"type":"list","member":{}},"S4h":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}},"S4k":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{}}},"RedactionConfig":{"shape":"S4m"},"LanguageCode":{},"DataAccessRoleArn":{},"Mode":{}}},"S4m":{"type":"structure","members":{"PiiEntityTypes":{"type":"list","member":{}},"MaskMode":{},"MaskCharacter":{}}},"S4v":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}},"S4y":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}},"S51":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3e"},"OutputDataConfig":{"shape":"S3k"},"NumberOfTopics":{"type":"integer"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S24"}}}}}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDocumentClassificationJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDocumentClassifierSummaries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDocumentClassifiers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDominantLanguageDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntitiesDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntityRecognizerSummaries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntityRecognizers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEventsDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListKeyPhrasesDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSentimentDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTargetedSentimentDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTopicsDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotjobsdataplane'] = {};
	AWS.IoTJobsDataPlane = Service.defineService('iotjobsdataplane', ['2017-09-29']);
	Object.defineProperty(apiLoader.services['iotjobsdataplane'], '2017-09-29', {
	  get: function get() {
	    var model = __webpack_require__(555);
	    model.paginators = __webpack_require__(556).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTJobsDataPlane;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-29","endpointPrefix":"data.jobs.iot","protocol":"rest-json","serviceFullName":"AWS IoT Jobs Data Plane","serviceId":"IoT Jobs Data Plane","signatureVersion":"v4","signingName":"iot-jobs-data","uid":"iot-jobs-data-2017-09-29"},"operations":{"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"includeJobDocument":{"location":"querystring","locationName":"includeJobDocument","type":"boolean"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"shape":"S7"}}}},"GetPendingJobExecutions":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"inProgressJobs":{"shape":"Sl"},"queuedJobs":{"shape":"Sl"}}}},"StartNextPendingJobExecution":{"http":{"method":"PUT","requestUri":"/things/{thingName}/jobs/$next"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"statusDetails":{"shape":"Sa"},"stepTimeoutInMinutes":{"type":"long"}}},"output":{"type":"structure","members":{"execution":{"shape":"S7"}}}},"UpdateJobExecution":{"http":{"requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName","status"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"status":{},"statusDetails":{"shape":"Sa"},"stepTimeoutInMinutes":{"type":"long"},"expectedVersion":{"type":"long"},"includeJobExecutionState":{"type":"boolean"},"includeJobDocument":{"type":"boolean"},"executionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"executionState":{"type":"structure","members":{"status":{},"statusDetails":{"shape":"Sa"},"versionNumber":{"type":"long"}}},"jobDocument":{}}}}},"shapes":{"S7":{"type":"structure","members":{"jobId":{},"thingName":{},"status":{},"statusDetails":{"shape":"Sa"},"queuedAt":{"type":"long"},"startedAt":{"type":"long"},"lastUpdatedAt":{"type":"long"},"approximateSecondsBeforeTimedOut":{"type":"long"},"versionNumber":{"type":"long"},"executionNumber":{"type":"long"},"jobDocument":{}}},"Sa":{"type":"map","key":{},"value":{}},"Sl":{"type":"list","member":{"type":"structure","members":{"jobId":{},"queuedAt":{"type":"long"},"startedAt":{"type":"long"},"lastUpdatedAt":{"type":"long"},"versionNumber":{"type":"long"},"executionNumber":{"type":"long"}}}}}}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesisvideoarchivedmedia'] = {};
	AWS.KinesisVideoArchivedMedia = Service.defineService('kinesisvideoarchivedmedia', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideoarchivedmedia'], '2017-09-30', {
	  get: function get() {
	    var model = __webpack_require__(558);
	    model.paginators = __webpack_require__(559).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KinesisVideoArchivedMedia;


/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Archived Media","serviceFullName":"Amazon Kinesis Video Streams Archived Media","serviceId":"Kinesis Video Archived Media","signatureVersion":"v4","uid":"kinesis-video-archived-media-2017-09-30"},"operations":{"GetClip":{"http":{"requestUri":"/getClip"},"input":{"type":"structure","required":["ClipFragmentSelector"],"members":{"StreamName":{},"StreamARN":{},"ClipFragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"shape":"Sa"}},"payload":"Payload"}},"GetDASHStreamingSessionURL":{"http":{"requestUri":"/getDASHStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"DisplayFragmentTimestamp":{},"DisplayFragmentNumber":{},"DASHFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"Expires":{"type":"integer"},"MaxManifestFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"DASHStreamingSessionURL":{}}}},"GetHLSStreamingSessionURL":{"http":{"requestUri":"/getHLSStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"HLSFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"ContainerFormat":{},"DiscontinuityMode":{},"DisplayFragmentTimestamp":{},"Expires":{"type":"integer"},"MaxMediaPlaylistFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"HLSStreamingSessionURL":{}}}},"GetImages":{"http":{"requestUri":"/getImages"},"input":{"type":"structure","required":["ImageSelectorType","StartTimestamp","EndTimestamp","SamplingInterval","Format"],"members":{"StreamName":{},"StreamARN":{},"ImageSelectorType":{},"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"},"SamplingInterval":{"type":"integer"},"Format":{},"FormatConfig":{"type":"map","key":{},"value":{}},"WidthPixels":{"type":"integer"},"HeightPixels":{"type":"integer"},"MaxResults":{"type":"long"},"NextToken":{}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"type":"structure","members":{"TimeStamp":{"type":"timestamp"},"Error":{},"ImageContent":{}}}},"NextToken":{}}}},"GetMediaForFragmentList":{"http":{"requestUri":"/getMediaForFragmentList"},"input":{"type":"structure","required":["Fragments"],"members":{"StreamName":{},"StreamARN":{},"Fragments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"shape":"Sa"}},"payload":"Payload"}},"ListFragments":{"http":{"requestUri":"/listFragments"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"MaxResults":{"type":"long"},"NextToken":{},"FragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"Fragments":{"type":"list","member":{"type":"structure","members":{"FragmentNumber":{},"FragmentSizeInBytes":{"type":"long"},"ProducerTimestamp":{"type":"timestamp"},"ServerTimestamp":{"type":"timestamp"},"FragmentLengthInMilliseconds":{"type":"long"}}}},"NextToken":{}}}}},"shapes":{"Sa":{"type":"blob","streaming":true}}}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Images"},"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesisvideomedia'] = {};
	AWS.KinesisVideoMedia = Service.defineService('kinesisvideomedia', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideomedia'], '2017-09-30', {
	  get: function get() {
	    var model = __webpack_require__(561);
	    model.paginators = __webpack_require__(562).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KinesisVideoMedia;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Media","serviceFullName":"Amazon Kinesis Video Streams Media","serviceId":"Kinesis Video Media","signatureVersion":"v4","uid":"kinesis-video-media-2017-09-30"},"operations":{"GetMedia":{"http":{"requestUri":"/getMedia"},"input":{"type":"structure","required":["StartSelector"],"members":{"StreamName":{},"StreamARN":{},"StartSelector":{"type":"structure","required":["StartSelectorType"],"members":{"StartSelectorType":{},"AfterFragmentNumber":{},"StartTimestamp":{"type":"timestamp"},"ContinuationToken":{}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"type":"blob","streaming":true}},"payload":"Payload"}}},"shapes":{}}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesisvideo'] = {};
	AWS.KinesisVideo = Service.defineService('kinesisvideo', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideo'], '2017-09-30', {
	  get: function get() {
	    var model = __webpack_require__(564);
	    model.paginators = __webpack_require__(565).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KinesisVideo;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video","serviceFullName":"Amazon Kinesis Video Streams","serviceId":"Kinesis Video","signatureVersion":"v4","uid":"kinesisvideo-2017-09-30"},"operations":{"CreateSignalingChannel":{"http":{"requestUri":"/createSignalingChannel"},"input":{"type":"structure","required":["ChannelName"],"members":{"ChannelName":{},"ChannelType":{},"SingleMasterConfiguration":{"shape":"S4"},"Tags":{"type":"list","member":{"shape":"S7"}}}},"output":{"type":"structure","members":{"ChannelARN":{}}}},"CreateStream":{"http":{"requestUri":"/createStream"},"input":{"type":"structure","required":["StreamName"],"members":{"DeviceName":{},"StreamName":{},"MediaType":{},"KmsKeyId":{},"DataRetentionInHours":{"type":"integer"},"Tags":{"shape":"Si"}}},"output":{"type":"structure","members":{"StreamARN":{}}}},"DeleteSignalingChannel":{"http":{"requestUri":"/deleteSignalingChannel"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"requestUri":"/deleteStream"},"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DescribeImageGenerationConfiguration":{"http":{"requestUri":"/describeImageGenerationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"ImageGenerationConfiguration":{"shape":"Sr"}}}},"DescribeNotificationConfiguration":{"http":{"requestUri":"/describeNotificationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"NotificationConfiguration":{"shape":"S16"}}}},"DescribeSignalingChannel":{"http":{"requestUri":"/describeSignalingChannel"},"input":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{}}},"output":{"type":"structure","members":{"ChannelInfo":{"shape":"S1a"}}}},"DescribeStream":{"http":{"requestUri":"/describeStream"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"StreamInfo":{"shape":"S1f"}}}},"GetDataEndpoint":{"http":{"requestUri":"/getDataEndpoint"},"input":{"type":"structure","required":["APIName"],"members":{"StreamName":{},"StreamARN":{},"APIName":{}}},"output":{"type":"structure","members":{"DataEndpoint":{}}}},"GetSignalingChannelEndpoint":{"http":{"requestUri":"/getSignalingChannelEndpoint"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"SingleMasterChannelEndpointConfiguration":{"type":"structure","members":{"Protocols":{"type":"list","member":{}},"Role":{}}}}},"output":{"type":"structure","members":{"ResourceEndpointList":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"ResourceEndpoint":{}}}}}}},"ListSignalingChannels":{"http":{"requestUri":"/listSignalingChannels"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"ChannelNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"ChannelInfoList":{"type":"list","member":{"shape":"S1a"}},"NextToken":{}}}},"ListStreams":{"http":{"requestUri":"/listStreams"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"StreamNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"StreamInfoList":{"type":"list","member":{"shape":"S1f"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["ResourceARN"],"members":{"NextToken":{},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Si"}}}},"ListTagsForStream":{"http":{"requestUri":"/listTagsForStream"},"input":{"type":"structure","members":{"NextToken":{},"StreamARN":{},"StreamName":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Si"}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"type":"list","member":{"shape":"S7"}}}},"output":{"type":"structure","members":{}}},"TagStream":{"http":{"requestUri":"/tagStream"},"input":{"type":"structure","required":["Tags"],"members":{"StreamARN":{},"StreamName":{},"Tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["ResourceARN","TagKeyList"],"members":{"ResourceARN":{},"TagKeyList":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"UntagStream":{"http":{"requestUri":"/untagStream"},"input":{"type":"structure","required":["TagKeyList"],"members":{"StreamARN":{},"StreamName":{},"TagKeyList":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"UpdateDataRetention":{"http":{"requestUri":"/updateDataRetention"},"input":{"type":"structure","required":["CurrentVersion","Operation","DataRetentionChangeInHours"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"Operation":{},"DataRetentionChangeInHours":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"UpdateImageGenerationConfiguration":{"http":{"requestUri":"/updateImageGenerationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"ImageGenerationConfiguration":{"shape":"Sr"}}},"output":{"type":"structure","members":{}}},"UpdateNotificationConfiguration":{"http":{"requestUri":"/updateNotificationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"NotificationConfiguration":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"UpdateSignalingChannel":{"http":{"requestUri":"/updateSignalingChannel"},"input":{"type":"structure","required":["ChannelARN","CurrentVersion"],"members":{"ChannelARN":{},"CurrentVersion":{},"SingleMasterConfiguration":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UpdateStream":{"http":{"requestUri":"/updateStream"},"input":{"type":"structure","required":["CurrentVersion"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"DeviceName":{},"MediaType":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","members":{"MessageTtlSeconds":{"type":"integer"}}},"S7":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"Si":{"type":"map","key":{},"value":{}},"Sr":{"type":"structure","required":["Status","ImageSelectorType","DestinationConfig","SamplingInterval","Format"],"members":{"Status":{},"ImageSelectorType":{},"DestinationConfig":{"type":"structure","required":["Uri","DestinationRegion"],"members":{"Uri":{},"DestinationRegion":{}}},"SamplingInterval":{"type":"integer"},"Format":{},"FormatConfig":{"type":"map","key":{},"value":{}},"WidthPixels":{"type":"integer"},"HeightPixels":{"type":"integer"}}},"S16":{"type":"structure","required":["Status","DestinationConfig"],"members":{"Status":{},"DestinationConfig":{"type":"structure","required":["Uri"],"members":{"Uri":{}}}}},"S1a":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{},"ChannelType":{},"ChannelStatus":{},"CreationTime":{"type":"timestamp"},"SingleMasterConfiguration":{"shape":"S4"},"Version":{}}},"S1f":{"type":"structure","members":{"DeviceName":{},"StreamName":{},"StreamARN":{},"MediaType":{},"KmsKeyId":{},"Version":{},"Status":{},"CreationTime":{"type":"timestamp"},"DataRetentionInHours":{"type":"integer"}}},"S2e":{"type":"list","member":{}}}}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListSignalingChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ChannelInfoList"},"ListStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StreamInfoList"}}}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sagemakerruntime'] = {};
	AWS.SageMakerRuntime = Service.defineService('sagemakerruntime', ['2017-05-13']);
	Object.defineProperty(apiLoader.services['sagemakerruntime'], '2017-05-13', {
	  get: function get() {
	    var model = __webpack_require__(567);
	    model.paginators = __webpack_require__(568).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SageMakerRuntime;


/***/ }),
/* 567 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-05-13","endpointPrefix":"runtime.sagemaker","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon SageMaker Runtime","serviceId":"SageMaker Runtime","signatureVersion":"v4","signingName":"sagemaker","uid":"runtime.sagemaker-2017-05-13"},"operations":{"InvokeEndpoint":{"http":{"requestUri":"/endpoints/{EndpointName}/invocations"},"input":{"type":"structure","required":["EndpointName","Body"],"members":{"EndpointName":{"location":"uri","locationName":"EndpointName"},"Body":{"shape":"S3"},"ContentType":{"location":"header","locationName":"Content-Type"},"Accept":{"location":"header","locationName":"Accept"},"CustomAttributes":{"shape":"S5","location":"header","locationName":"X-Amzn-SageMaker-Custom-Attributes"},"TargetModel":{"location":"header","locationName":"X-Amzn-SageMaker-Target-Model"},"TargetVariant":{"location":"header","locationName":"X-Amzn-SageMaker-Target-Variant"},"TargetContainerHostname":{"location":"header","locationName":"X-Amzn-SageMaker-Target-Container-Hostname"},"InferenceId":{"location":"header","locationName":"X-Amzn-SageMaker-Inference-Id"}},"payload":"Body"},"output":{"type":"structure","required":["Body"],"members":{"Body":{"shape":"S3"},"ContentType":{"location":"header","locationName":"Content-Type"},"InvokedProductionVariant":{"location":"header","locationName":"x-Amzn-Invoked-Production-Variant"},"CustomAttributes":{"shape":"S5","location":"header","locationName":"X-Amzn-SageMaker-Custom-Attributes"}},"payload":"Body"}},"InvokeEndpointAsync":{"http":{"requestUri":"/endpoints/{EndpointName}/async-invocations","responseCode":202},"input":{"type":"structure","required":["EndpointName","InputLocation"],"members":{"EndpointName":{"location":"uri","locationName":"EndpointName"},"ContentType":{"location":"header","locationName":"X-Amzn-SageMaker-Content-Type"},"Accept":{"location":"header","locationName":"X-Amzn-SageMaker-Accept"},"CustomAttributes":{"shape":"S5","location":"header","locationName":"X-Amzn-SageMaker-Custom-Attributes"},"InferenceId":{"location":"header","locationName":"X-Amzn-SageMaker-Inference-Id"},"InputLocation":{"location":"header","locationName":"X-Amzn-SageMaker-InputLocation"},"RequestTTLSeconds":{"location":"header","locationName":"X-Amzn-SageMaker-RequestTTLSeconds","type":"integer"}}},"output":{"type":"structure","members":{"InferenceId":{},"OutputLocation":{"location":"header","locationName":"X-Amzn-SageMaker-OutputLocation"}}}}},"shapes":{"S3":{"type":"blob","sensitive":true},"S5":{"type":"string","sensitive":true}}}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sagemaker'] = {};
	AWS.SageMaker = Service.defineService('sagemaker', ['2017-07-24']);
	Object.defineProperty(apiLoader.services['sagemaker'], '2017-07-24', {
	  get: function get() {
	    var model = __webpack_require__(570);
	    model.paginators = __webpack_require__(571).pagination;
	    model.waiters = __webpack_require__(572).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SageMaker;


/***/ }),
/* 570 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-24","endpointPrefix":"api.sagemaker","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"SageMaker","serviceFullName":"Amazon SageMaker Service","serviceId":"SageMaker","signatureVersion":"v4","signingName":"sagemaker","targetPrefix":"SageMaker","uid":"sagemaker-2017-07-24"},"operations":{"AddAssociation":{"input":{"type":"structure","required":["SourceArn","DestinationArn"],"members":{"SourceArn":{},"DestinationArn":{},"AssociationType":{}}},"output":{"type":"structure","members":{"SourceArn":{},"DestinationArn":{}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"}}}},"AssociateTrialComponent":{"input":{"type":"structure","required":["TrialComponentName","TrialName"],"members":{"TrialComponentName":{},"TrialName":{}}},"output":{"type":"structure","members":{"TrialComponentArn":{},"TrialArn":{}}}},"BatchDescribeModelPackage":{"input":{"type":"structure","required":["ModelPackageArnList"],"members":{"ModelPackageArnList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ModelPackageSummaries":{"type":"map","key":{},"value":{"type":"structure","required":["ModelPackageGroupName","ModelPackageArn","CreationTime","InferenceSpecification","ModelPackageStatus"],"members":{"ModelPackageGroupName":{},"ModelPackageVersion":{"type":"integer"},"ModelPackageArn":{},"ModelPackageDescription":{},"CreationTime":{"type":"timestamp"},"InferenceSpecification":{"shape":"Sr"},"ModelPackageStatus":{},"ModelApprovalStatus":{}}}},"BatchDescribeModelPackageErrorMap":{"type":"map","key":{},"value":{"type":"structure","required":["ErrorCode","ErrorResponse"],"members":{"ErrorCode":{},"ErrorResponse":{}}}}}}},"CreateAction":{"input":{"type":"structure","required":["ActionName","Source","ActionType"],"members":{"ActionName":{},"Source":{"shape":"S1j"},"ActionType":{},"Description":{},"Status":{},"Properties":{"shape":"S1o"},"MetadataProperties":{"shape":"S1q"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ActionArn":{}}}},"CreateAlgorithm":{"input":{"type":"structure","required":["AlgorithmName","TrainingSpecification"],"members":{"AlgorithmName":{},"AlgorithmDescription":{},"TrainingSpecification":{"shape":"S1v"},"InferenceSpecification":{"shape":"Sr"},"ValidationSpecification":{"shape":"S2o"},"CertifyForMarketplace":{"type":"boolean"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["AlgorithmArn"],"members":{"AlgorithmArn":{}}}},"CreateApp":{"input":{"type":"structure","required":["DomainId","UserProfileName","AppType","AppName"],"members":{"DomainId":{},"UserProfileName":{},"AppType":{},"AppName":{},"Tags":{"shape":"S7"},"ResourceSpec":{"shape":"S48"}}},"output":{"type":"structure","members":{"AppArn":{}}}},"CreateAppImageConfig":{"input":{"type":"structure","required":["AppImageConfigName"],"members":{"AppImageConfigName":{},"Tags":{"shape":"S7"},"KernelGatewayImageConfig":{"shape":"S4h"}}},"output":{"type":"structure","members":{"AppImageConfigArn":{}}}},"CreateArtifact":{"input":{"type":"structure","required":["Source","ArtifactType"],"members":{"ArtifactName":{},"Source":{"shape":"S4t"},"ArtifactType":{},"Properties":{"shape":"S1o"},"MetadataProperties":{"shape":"S1q"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ArtifactArn":{}}}},"CreateAutoMLJob":{"input":{"type":"structure","required":["AutoMLJobName","InputDataConfig","OutputDataConfig","RoleArn"],"members":{"AutoMLJobName":{},"InputDataConfig":{"shape":"S51"},"OutputDataConfig":{"shape":"S58"},"ProblemType":{},"AutoMLJobObjective":{"shape":"S5a"},"AutoMLJobConfig":{"shape":"S5c"},"RoleArn":{},"GenerateCandidateDefinitionsOnly":{"type":"boolean"},"Tags":{"shape":"S7"},"ModelDeployConfig":{"shape":"S5q"}}},"output":{"type":"structure","required":["AutoMLJobArn"],"members":{"AutoMLJobArn":{}}}},"CreateCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName","GitConfig"],"members":{"CodeRepositoryName":{},"GitConfig":{"shape":"S5w"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["CodeRepositoryArn"],"members":{"CodeRepositoryArn":{}}}},"CreateCompilationJob":{"input":{"type":"structure","required":["CompilationJobName","RoleArn","OutputConfig","StoppingCondition"],"members":{"CompilationJobName":{},"RoleArn":{},"ModelPackageVersionArn":{},"InputConfig":{"shape":"S63"},"OutputConfig":{"shape":"S65"},"VpcConfig":{"shape":"S6c"},"StoppingCondition":{"shape":"S3h"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["CompilationJobArn"],"members":{"CompilationJobArn":{}}}},"CreateContext":{"input":{"type":"structure","required":["ContextName","Source","ContextType"],"members":{"ContextName":{},"Source":{"shape":"S6k"},"ContextType":{},"Description":{},"Properties":{"shape":"S1o"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ContextArn":{}}}},"CreateDataQualityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName","DataQualityAppSpecification","DataQualityJobInput","DataQualityJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionName":{},"DataQualityBaselineConfig":{"shape":"S6p"},"DataQualityAppSpecification":{"shape":"S6t"},"DataQualityJobInput":{"shape":"S72"},"DataQualityJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["JobDefinitionArn"],"members":{"JobDefinitionArn":{}}}},"CreateDeviceFleet":{"input":{"type":"structure","required":["DeviceFleetName","OutputConfig"],"members":{"DeviceFleetName":{},"RoleArn":{},"Description":{},"OutputConfig":{"shape":"S7r"},"Tags":{"shape":"S7"},"EnableIotRoleAlias":{"type":"boolean"}}}},"CreateDomain":{"input":{"type":"structure","required":["DomainName","AuthMode","DefaultUserSettings","SubnetIds","VpcId"],"members":{"DomainName":{},"AuthMode":{},"DefaultUserSettings":{"shape":"S7x"},"SubnetIds":{"shape":"S5l"},"VpcId":{},"Tags":{"shape":"S7"},"AppNetworkAccessType":{},"HomeEfsFileSystemKmsKeyId":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use KmsKeyId instead."},"KmsKeyId":{},"AppSecurityGroupManagement":{},"DomainSettings":{"shape":"S8g"}}},"output":{"type":"structure","members":{"DomainArn":{},"Url":{}}}},"CreateEdgePackagingJob":{"input":{"type":"structure","required":["EdgePackagingJobName","CompilationJobName","ModelName","ModelVersion","RoleArn","OutputConfig"],"members":{"EdgePackagingJobName":{},"CompilationJobName":{},"ModelName":{},"ModelVersion":{},"RoleArn":{},"OutputConfig":{"shape":"S7r"},"ResourceKey":{},"Tags":{"shape":"S7"}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointName","EndpointConfigName"],"members":{"EndpointName":{},"EndpointConfigName":{},"DeploymentConfig":{"shape":"S8q"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"CreateEndpointConfig":{"input":{"type":"structure","required":["EndpointConfigName","ProductionVariants"],"members":{"EndpointConfigName":{},"ProductionVariants":{"shape":"S97"},"DataCaptureConfig":{"shape":"S9j"},"Tags":{"shape":"S7"},"KmsKeyId":{},"AsyncInferenceConfig":{"shape":"S9u"}}},"output":{"type":"structure","required":["EndpointConfigArn"],"members":{"EndpointConfigArn":{}}}},"CreateExperiment":{"input":{"type":"structure","required":["ExperimentName"],"members":{"ExperimentName":{},"DisplayName":{},"Description":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ExperimentArn":{}}}},"CreateFeatureGroup":{"input":{"type":"structure","required":["FeatureGroupName","RecordIdentifierFeatureName","EventTimeFeatureName","FeatureDefinitions"],"members":{"FeatureGroupName":{},"RecordIdentifierFeatureName":{},"EventTimeFeatureName":{},"FeatureDefinitions":{"shape":"Sa8"},"OnlineStoreConfig":{"shape":"Sab"},"OfflineStoreConfig":{"shape":"Sad"},"RoleArn":{},"Description":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["FeatureGroupArn"],"members":{"FeatureGroupArn":{}}}},"CreateFlowDefinition":{"input":{"type":"structure","required":["FlowDefinitionName","HumanLoopConfig","OutputConfig","RoleArn"],"members":{"FlowDefinitionName":{},"HumanLoopRequestSource":{"shape":"Sao"},"HumanLoopActivationConfig":{"shape":"Saq"},"HumanLoopConfig":{"shape":"Sat"},"OutputConfig":{"shape":"Sb8"},"RoleArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["FlowDefinitionArn"],"members":{"FlowDefinitionArn":{}}}},"CreateHumanTaskUi":{"input":{"type":"structure","required":["HumanTaskUiName","UiTemplate"],"members":{"HumanTaskUiName":{},"UiTemplate":{"shape":"Sbd"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["HumanTaskUiArn"],"members":{"HumanTaskUiArn":{}}}},"CreateHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName","HyperParameterTuningJobConfig"],"members":{"HyperParameterTuningJobName":{},"HyperParameterTuningJobConfig":{"shape":"Sbi"},"TrainingJobDefinition":{"shape":"Sbz"},"TrainingJobDefinitions":{"shape":"Sc7"},"WarmStartConfig":{"shape":"Sc8"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["HyperParameterTuningJobArn"],"members":{"HyperParameterTuningJobArn":{}}}},"CreateImage":{"input":{"type":"structure","required":["ImageName","RoleArn"],"members":{"Description":{},"DisplayName":{},"ImageName":{},"RoleArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ImageArn":{}}}},"CreateImageVersion":{"input":{"type":"structure","required":["BaseImage","ClientToken","ImageName"],"members":{"BaseImage":{},"ClientToken":{"idempotencyToken":true},"ImageName":{}}},"output":{"type":"structure","members":{"ImageVersionArn":{}}}},"CreateInferenceRecommendationsJob":{"input":{"type":"structure","required":["JobName","JobType","RoleArn","InputConfig"],"members":{"JobName":{},"JobType":{},"RoleArn":{},"InputConfig":{"shape":"Scp"},"JobDescription":{},"StoppingConditions":{"shape":"Sdb"},"OutputConfig":{"type":"structure","members":{"KmsKeyId":{},"CompiledOutputConfig":{"type":"structure","members":{"S3OutputUri":{}}}}},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["JobArn"],"members":{"JobArn":{}}}},"CreateLabelingJob":{"input":{"type":"structure","required":["LabelingJobName","LabelAttributeName","InputConfig","OutputConfig","RoleArn","HumanTaskConfig"],"members":{"LabelingJobName":{},"LabelAttributeName":{},"InputConfig":{"shape":"Sdm"},"OutputConfig":{"shape":"Sdt"},"RoleArn":{},"LabelCategoryConfigS3Uri":{},"StoppingConditions":{"shape":"Sdu"},"LabelingJobAlgorithmsConfig":{"shape":"Sdx"},"HumanTaskConfig":{"shape":"Se1"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["LabelingJobArn"],"members":{"LabelingJobArn":{}}}},"CreateModel":{"input":{"type":"structure","required":["ModelName","ExecutionRoleArn"],"members":{"ModelName":{},"PrimaryContainer":{"shape":"Seg"},"Containers":{"shape":"Sep"},"InferenceExecutionConfig":{"shape":"Seq"},"ExecutionRoleArn":{},"Tags":{"shape":"S7"},"VpcConfig":{"shape":"S5i"},"EnableNetworkIsolation":{"type":"boolean"}}},"output":{"type":"structure","required":["ModelArn"],"members":{"ModelArn":{}}}},"CreateModelBiasJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName","ModelBiasAppSpecification","ModelBiasJobInput","ModelBiasJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionName":{},"ModelBiasBaselineConfig":{"shape":"Seu"},"ModelBiasAppSpecification":{"shape":"Sev"},"ModelBiasJobInput":{"shape":"Sew"},"ModelBiasJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["JobDefinitionArn"],"members":{"JobDefinitionArn":{}}}},"CreateModelExplainabilityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName","ModelExplainabilityAppSpecification","ModelExplainabilityJobInput","ModelExplainabilityJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionName":{},"ModelExplainabilityBaselineConfig":{"shape":"Sf0"},"ModelExplainabilityAppSpecification":{"shape":"Sf1"},"ModelExplainabilityJobInput":{"shape":"Sf2"},"ModelExplainabilityJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["JobDefinitionArn"],"members":{"JobDefinitionArn":{}}}},"CreateModelPackage":{"input":{"type":"structure","members":{"ModelPackageName":{},"ModelPackageGroupName":{},"ModelPackageDescription":{},"InferenceSpecification":{"shape":"Sr"},"ValidationSpecification":{"shape":"Sf5"},"SourceAlgorithmSpecification":{"shape":"Sf8"},"CertifyForMarketplace":{"type":"boolean"},"Tags":{"shape":"S7"},"ModelApprovalStatus":{},"MetadataProperties":{"shape":"S1q"},"ModelMetrics":{"shape":"Sfb"},"ClientToken":{"idempotencyToken":true},"CustomerMetadataProperties":{"shape":"Sfi"},"DriftCheckBaselines":{"shape":"Sfl"},"Domain":{},"Task":{},"SamplePayloadUrl":{},"AdditionalInferenceSpecifications":{"shape":"Sfr"}}},"output":{"type":"structure","required":["ModelPackageArn"],"members":{"ModelPackageArn":{}}}},"CreateModelPackageGroup":{"input":{"type":"structure","required":["ModelPackageGroupName"],"members":{"ModelPackageGroupName":{},"ModelPackageGroupDescription":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["ModelPackageGroupArn"],"members":{"ModelPackageGroupArn":{}}}},"CreateModelQualityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName","ModelQualityAppSpecification","ModelQualityJobInput","ModelQualityJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionName":{},"ModelQualityBaselineConfig":{"shape":"Sfy"},"ModelQualityAppSpecification":{"shape":"Sfz"},"ModelQualityJobInput":{"shape":"Sg1"},"ModelQualityJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["JobDefinitionArn"],"members":{"JobDefinitionArn":{}}}},"CreateMonitoringSchedule":{"input":{"type":"structure","required":["MonitoringScheduleName","MonitoringScheduleConfig"],"members":{"MonitoringScheduleName":{},"MonitoringScheduleConfig":{"shape":"Sg5"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["MonitoringScheduleArn"],"members":{"MonitoringScheduleArn":{}}}},"CreateNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName","InstanceType","RoleArn"],"members":{"NotebookInstanceName":{},"InstanceType":{},"SubnetId":{},"SecurityGroupIds":{"shape":"S7y"},"RoleArn":{},"KmsKeyId":{},"Tags":{"shape":"S7"},"LifecycleConfigName":{},"DirectInternetAccess":{},"VolumeSizeInGB":{"type":"integer"},"AcceleratorTypes":{"shape":"Sgn"},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"Sgq"},"RootAccess":{},"PlatformIdentifier":{}}},"output":{"type":"structure","members":{"NotebookInstanceArn":{}}}},"CreateNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{},"OnCreate":{"shape":"Sgw"},"OnStart":{"shape":"Sgw"}}},"output":{"type":"structure","members":{"NotebookInstanceLifecycleConfigArn":{}}}},"CreatePipeline":{"input":{"type":"structure","required":["PipelineName","ClientRequestToken","RoleArn"],"members":{"PipelineName":{},"PipelineDisplayName":{},"PipelineDefinition":{},"PipelineDefinitionS3Location":{"shape":"Sh4"},"PipelineDescription":{},"ClientRequestToken":{"idempotencyToken":true},"RoleArn":{},"Tags":{"shape":"S7"},"ParallelismConfiguration":{"shape":"Sha"}}},"output":{"type":"structure","members":{"PipelineArn":{}}}},"CreatePresignedDomainUrl":{"input":{"type":"structure","required":["DomainId","UserProfileName"],"members":{"DomainId":{},"UserProfileName":{},"SessionExpirationDurationInSeconds":{"type":"integer"},"ExpiresInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizedUrl":{}}}},"CreatePresignedNotebookInstanceUrl":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{},"SessionExpirationDurationInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizedUrl":{}}}},"CreateProcessingJob":{"input":{"type":"structure","required":["ProcessingJobName","ProcessingResources","AppSpecification","RoleArn"],"members":{"ProcessingInputs":{"shape":"Shn"},"ProcessingOutputConfig":{"shape":"Sia"},"ProcessingJobName":{},"ProcessingResources":{"shape":"Sif"},"StoppingCondition":{"shape":"Sih"},"AppSpecification":{"shape":"Sij"},"Environment":{"shape":"Sil"},"NetworkConfig":{"shape":"Sgd"},"RoleArn":{},"Tags":{"shape":"S7"},"ExperimentConfig":{"shape":"Sim"}}},"output":{"type":"structure","required":["ProcessingJobArn"],"members":{"ProcessingJobArn":{}}}},"CreateProject":{"input":{"type":"structure","required":["ProjectName","ServiceCatalogProvisioningDetails"],"members":{"ProjectName":{},"ProjectDescription":{},"ServiceCatalogProvisioningDetails":{"shape":"Sir"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["ProjectArn","ProjectId"],"members":{"ProjectArn":{},"ProjectId":{}}}},"CreateStudioLifecycleConfig":{"input":{"type":"structure","required":["StudioLifecycleConfigName","StudioLifecycleConfigContent","StudioLifecycleConfigAppType"],"members":{"StudioLifecycleConfigName":{},"StudioLifecycleConfigContent":{},"StudioLifecycleConfigAppType":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"StudioLifecycleConfigArn":{}}}},"CreateTrainingJob":{"input":{"type":"structure","required":["TrainingJobName","AlgorithmSpecification","RoleArn","OutputDataConfig","ResourceConfig","StoppingCondition"],"members":{"TrainingJobName":{},"HyperParameters":{"shape":"S2t"},"AlgorithmSpecification":{"shape":"Sj7"},"RoleArn":{},"InputDataConfig":{"shape":"S2v"},"OutputDataConfig":{"shape":"S3c"},"ResourceConfig":{"shape":"S3e"},"VpcConfig":{"shape":"S5i"},"StoppingCondition":{"shape":"S3h"},"Tags":{"shape":"S7"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"Sc4"},"DebugHookConfig":{"shape":"Sj8"},"DebugRuleConfigurations":{"shape":"Sjg"},"TensorBoardOutputConfig":{"shape":"Sjl"},"ExperimentConfig":{"shape":"Sim"},"ProfilerConfig":{"shape":"Sjm"},"ProfilerRuleConfigurations":{"shape":"Sjp"},"Environment":{"shape":"Sjr"},"RetryStrategy":{"shape":"Sc5"}}},"output":{"type":"structure","required":["TrainingJobArn"],"members":{"TrainingJobArn":{}}}},"CreateTransformJob":{"input":{"type":"structure","required":["TransformJobName","ModelName","TransformInput","TransformOutput","TransformResources"],"members":{"TransformJobName":{},"ModelName":{},"MaxConcurrentTransforms":{"type":"integer"},"ModelClientConfig":{"shape":"Sjy"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S3o"},"TransformInput":{"shape":"S3r"},"TransformOutput":{"shape":"S3v"},"TransformResources":{"shape":"S3y"},"DataProcessing":{"shape":"Sk1"},"Tags":{"shape":"S7"},"ExperimentConfig":{"shape":"Sim"}}},"output":{"type":"structure","required":["TransformJobArn"],"members":{"TransformJobArn":{}}}},"CreateTrial":{"input":{"type":"structure","required":["TrialName","ExperimentName"],"members":{"TrialName":{},"DisplayName":{},"ExperimentName":{},"MetadataProperties":{"shape":"S1q"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"TrialArn":{}}}},"CreateTrialComponent":{"input":{"type":"structure","required":["TrialComponentName"],"members":{"TrialComponentName":{},"DisplayName":{},"Status":{"shape":"Sk9"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Parameters":{"shape":"Skd"},"InputArtifacts":{"shape":"Skh"},"OutputArtifacts":{"shape":"Skh"},"MetadataProperties":{"shape":"S1q"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"TrialComponentArn":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["DomainId","UserProfileName"],"members":{"DomainId":{},"UserProfileName":{},"SingleSignOnUserIdentifier":{},"SingleSignOnUserValue":{},"Tags":{"shape":"S7"},"UserSettings":{"shape":"S7x"}}},"output":{"type":"structure","members":{"UserProfileArn":{}}}},"CreateWorkforce":{"input":{"type":"structure","required":["WorkforceName"],"members":{"CognitoConfig":{"shape":"Sks"},"OidcConfig":{"shape":"Skv"},"SourceIpConfig":{"shape":"Sky"},"WorkforceName":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["WorkforceArn"],"members":{"WorkforceArn":{}}}},"CreateWorkteam":{"input":{"type":"structure","required":["WorkteamName","MemberDefinitions","Description"],"members":{"WorkteamName":{},"WorkforceName":{},"MemberDefinitions":{"shape":"Sl6"},"Description":{},"NotificationConfiguration":{"shape":"Sle"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"WorkteamArn":{}}}},"DeleteAction":{"input":{"type":"structure","required":["ActionName"],"members":{"ActionName":{}}},"output":{"type":"structure","members":{"ActionArn":{}}}},"DeleteAlgorithm":{"input":{"type":"structure","required":["AlgorithmName"],"members":{"AlgorithmName":{}}}},"DeleteApp":{"input":{"type":"structure","required":["DomainId","UserProfileName","AppType","AppName"],"members":{"DomainId":{},"UserProfileName":{},"AppType":{},"AppName":{}}}},"DeleteAppImageConfig":{"input":{"type":"structure","required":["AppImageConfigName"],"members":{"AppImageConfigName":{}}}},"DeleteArtifact":{"input":{"type":"structure","members":{"ArtifactArn":{},"Source":{"shape":"S4t"}}},"output":{"type":"structure","members":{"ArtifactArn":{}}}},"DeleteAssociation":{"input":{"type":"structure","required":["SourceArn","DestinationArn"],"members":{"SourceArn":{},"DestinationArn":{}}},"output":{"type":"structure","members":{"SourceArn":{},"DestinationArn":{}}}},"DeleteCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName"],"members":{"CodeRepositoryName":{}}}},"DeleteContext":{"input":{"type":"structure","required":["ContextName"],"members":{"ContextName":{}}},"output":{"type":"structure","members":{"ContextArn":{}}}},"DeleteDataQualityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}}},"DeleteDeviceFleet":{"input":{"type":"structure","required":["DeviceFleetName"],"members":{"DeviceFleetName":{}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{},"RetentionPolicy":{"type":"structure","members":{"HomeEfsFileSystem":{}}}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}}},"DeleteEndpointConfig":{"input":{"type":"structure","required":["EndpointConfigName"],"members":{"EndpointConfigName":{}}}},"DeleteExperiment":{"input":{"type":"structure","required":["ExperimentName"],"members":{"ExperimentName":{}}},"output":{"type":"structure","members":{"ExperimentArn":{}}}},"DeleteFeatureGroup":{"input":{"type":"structure","required":["FeatureGroupName"],"members":{"FeatureGroupName":{}}}},"DeleteFlowDefinition":{"input":{"type":"structure","required":["FlowDefinitionName"],"members":{"FlowDefinitionName":{}}},"output":{"type":"structure","members":{}}},"DeleteHumanTaskUi":{"input":{"type":"structure","required":["HumanTaskUiName"],"members":{"HumanTaskUiName":{}}},"output":{"type":"structure","members":{}}},"DeleteImage":{"input":{"type":"structure","required":["ImageName"],"members":{"ImageName":{}}},"output":{"type":"structure","members":{}}},"DeleteImageVersion":{"input":{"type":"structure","required":["ImageName","Version"],"members":{"ImageName":{},"Version":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}}},"DeleteModelBiasJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}}},"DeleteModelExplainabilityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}}},"DeleteModelPackage":{"input":{"type":"structure","required":["ModelPackageName"],"members":{"ModelPackageName":{}}}},"DeleteModelPackageGroup":{"input":{"type":"structure","required":["ModelPackageGroupName"],"members":{"ModelPackageGroupName":{}}}},"DeleteModelPackageGroupPolicy":{"input":{"type":"structure","required":["ModelPackageGroupName"],"members":{"ModelPackageGroupName":{}}}},"DeleteModelQualityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}}},"DeleteMonitoringSchedule":{"input":{"type":"structure","required":["MonitoringScheduleName"],"members":{"MonitoringScheduleName":{}}}},"DeleteNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}}},"DeleteNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["PipelineName","ClientRequestToken"],"members":{"PipelineName":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PipelineArn":{}}}},"DeleteProject":{"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{}}}},"DeleteStudioLifecycleConfig":{"input":{"type":"structure","required":["StudioLifecycleConfigName"],"members":{"StudioLifecycleConfigName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteTrial":{"input":{"type":"structure","required":["TrialName"],"members":{"TrialName":{}}},"output":{"type":"structure","members":{"TrialArn":{}}}},"DeleteTrialComponent":{"input":{"type":"structure","required":["TrialComponentName"],"members":{"TrialComponentName":{}}},"output":{"type":"structure","members":{"TrialComponentArn":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["DomainId","UserProfileName"],"members":{"DomainId":{},"UserProfileName":{}}}},"DeleteWorkforce":{"input":{"type":"structure","required":["WorkforceName"],"members":{"WorkforceName":{}}},"output":{"type":"structure","members":{}}},"DeleteWorkteam":{"input":{"type":"structure","required":["WorkteamName"],"members":{"WorkteamName":{}}},"output":{"type":"structure","required":["Success"],"members":{"Success":{"type":"boolean"}}}},"DeregisterDevices":{"input":{"type":"structure","required":["DeviceFleetName","DeviceNames"],"members":{"DeviceFleetName":{},"DeviceNames":{"type":"list","member":{}}}}},"DescribeAction":{"input":{"type":"structure","required":["ActionName"],"members":{"ActionName":{}}},"output":{"type":"structure","members":{"ActionName":{},"ActionArn":{},"Source":{"shape":"S1j"},"ActionType":{},"Description":{},"Status":{},"Properties":{"shape":"S1o"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"MetadataProperties":{"shape":"S1q"},"LineageGroupArn":{}}}},"DescribeAlgorithm":{"input":{"type":"structure","required":["AlgorithmName"],"members":{"AlgorithmName":{}}},"output":{"type":"structure","required":["AlgorithmName","AlgorithmArn","CreationTime","TrainingSpecification","AlgorithmStatus","AlgorithmStatusDetails"],"members":{"AlgorithmName":{},"AlgorithmArn":{},"AlgorithmDescription":{},"CreationTime":{"type":"timestamp"},"TrainingSpecification":{"shape":"S1v"},"InferenceSpecification":{"shape":"Sr"},"ValidationSpecification":{"shape":"S2o"},"AlgorithmStatus":{},"AlgorithmStatusDetails":{"type":"structure","members":{"ValidationStatuses":{"shape":"Sne"},"ImageScanStatuses":{"shape":"Sne"}}},"ProductId":{},"CertifyForMarketplace":{"type":"boolean"}}}},"DescribeApp":{"input":{"type":"structure","required":["DomainId","UserProfileName","AppType","AppName"],"members":{"DomainId":{},"UserProfileName":{},"AppType":{},"AppName":{}}},"output":{"type":"structure","members":{"AppArn":{},"AppType":{},"AppName":{},"DomainId":{},"UserProfileName":{},"Status":{},"LastHealthCheckTimestamp":{"type":"timestamp"},"LastUserActivityTimestamp":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"FailureReason":{},"ResourceSpec":{"shape":"S48"}}}},"DescribeAppImageConfig":{"input":{"type":"structure","required":["AppImageConfigName"],"members":{"AppImageConfigName":{}}},"output":{"type":"structure","members":{"AppImageConfigArn":{},"AppImageConfigName":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"KernelGatewayImageConfig":{"shape":"S4h"}}}},"DescribeArtifact":{"input":{"type":"structure","required":["ArtifactArn"],"members":{"ArtifactArn":{}}},"output":{"type":"structure","members":{"ArtifactName":{},"ArtifactArn":{},"Source":{"shape":"S4t"},"ArtifactType":{},"Properties":{"shape":"S1o"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"MetadataProperties":{"shape":"S1q"},"LineageGroupArn":{}}}},"DescribeAutoMLJob":{"input":{"type":"structure","required":["AutoMLJobName"],"members":{"AutoMLJobName":{}}},"output":{"type":"structure","required":["AutoMLJobName","AutoMLJobArn","InputDataConfig","OutputDataConfig","RoleArn","CreationTime","LastModifiedTime","AutoMLJobStatus","AutoMLJobSecondaryStatus"],"members":{"AutoMLJobName":{},"AutoMLJobArn":{},"InputDataConfig":{"shape":"S51"},"OutputDataConfig":{"shape":"S58"},"RoleArn":{},"AutoMLJobObjective":{"shape":"S5a"},"ProblemType":{},"AutoMLJobConfig":{"shape":"S5c"},"CreationTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"PartialFailureReasons":{"shape":"Sns"},"BestCandidate":{"shape":"Snu"},"AutoMLJobStatus":{},"AutoMLJobSecondaryStatus":{},"GenerateCandidateDefinitionsOnly":{"type":"boolean"},"AutoMLJobArtifacts":{"type":"structure","members":{"CandidateDefinitionNotebookLocation":{},"DataExplorationNotebookLocation":{}}},"ResolvedAttributes":{"type":"structure","members":{"AutoMLJobObjective":{"shape":"S5a"},"ProblemType":{},"CompletionCriteria":{"shape":"S5d"}}},"ModelDeployConfig":{"shape":"S5q"},"ModelDeployResult":{"type":"structure","members":{"EndpointName":{}}}}}},"DescribeCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName"],"members":{"CodeRepositoryName":{}}},"output":{"type":"structure","required":["CodeRepositoryName","CodeRepositoryArn","CreationTime","LastModifiedTime"],"members":{"CodeRepositoryName":{},"CodeRepositoryArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"GitConfig":{"shape":"S5w"}}}},"DescribeCompilationJob":{"input":{"type":"structure","required":["CompilationJobName"],"members":{"CompilationJobName":{}}},"output":{"type":"structure","required":["CompilationJobName","CompilationJobArn","CompilationJobStatus","StoppingCondition","CreationTime","LastModifiedTime","FailureReason","ModelArtifacts","RoleArn","InputConfig","OutputConfig"],"members":{"CompilationJobName":{},"CompilationJobArn":{},"CompilationJobStatus":{},"CompilationStartTime":{"type":"timestamp"},"CompilationEndTime":{"type":"timestamp"},"StoppingCondition":{"shape":"S3h"},"InferenceImage":{},"ModelPackageVersionArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"ModelArtifacts":{"shape":"Sov"},"ModelDigests":{"type":"structure","members":{"ArtifactDigest":{}}},"RoleArn":{},"InputConfig":{"shape":"S63"},"OutputConfig":{"shape":"S65"},"VpcConfig":{"shape":"S6c"}}}},"DescribeContext":{"input":{"type":"structure","required":["ContextName"],"members":{"ContextName":{}}},"output":{"type":"structure","members":{"ContextName":{},"ContextArn":{},"Source":{"shape":"S6k"},"ContextType":{},"Description":{},"Properties":{"shape":"S1o"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"LineageGroupArn":{}}}},"DescribeDataQualityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}},"output":{"type":"structure","required":["JobDefinitionArn","JobDefinitionName","CreationTime","DataQualityAppSpecification","DataQualityJobInput","DataQualityJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionArn":{},"JobDefinitionName":{},"CreationTime":{"type":"timestamp"},"DataQualityBaselineConfig":{"shape":"S6p"},"DataQualityAppSpecification":{"shape":"S6t"},"DataQualityJobInput":{"shape":"S72"},"DataQualityJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"}}}},"DescribeDevice":{"input":{"type":"structure","required":["DeviceName","DeviceFleetName"],"members":{"NextToken":{},"DeviceName":{},"DeviceFleetName":{}}},"output":{"type":"structure","required":["DeviceName","DeviceFleetName","RegistrationTime"],"members":{"DeviceArn":{},"DeviceName":{},"Description":{},"DeviceFleetName":{},"IotThingName":{},"RegistrationTime":{"type":"timestamp"},"LatestHeartbeat":{"type":"timestamp"},"Models":{"type":"list","member":{"type":"structure","required":["ModelName","ModelVersion"],"members":{"ModelName":{},"ModelVersion":{},"LatestSampleTime":{"type":"timestamp"},"LatestInference":{"type":"timestamp"}}}},"MaxModels":{"type":"integer"},"NextToken":{},"AgentVersion":{}}}},"DescribeDeviceFleet":{"input":{"type":"structure","required":["DeviceFleetName"],"members":{"DeviceFleetName":{}}},"output":{"type":"structure","required":["DeviceFleetName","DeviceFleetArn","OutputConfig","CreationTime","LastModifiedTime"],"members":{"DeviceFleetName":{},"DeviceFleetArn":{},"OutputConfig":{"shape":"S7r"},"Description":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"RoleArn":{},"IotRoleAlias":{}}}},"DescribeDomain":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{}}},"output":{"type":"structure","members":{"DomainArn":{},"DomainId":{},"DomainName":{},"HomeEfsFileSystemId":{},"SingleSignOnManagedApplicationInstanceId":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"AuthMode":{},"DefaultUserSettings":{"shape":"S7x"},"AppNetworkAccessType":{},"HomeEfsFileSystemKmsKeyId":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use KmsKeyId instead."},"SubnetIds":{"shape":"S5l"},"Url":{},"VpcId":{},"KmsKeyId":{},"DomainSettings":{"shape":"S8g"},"AppSecurityGroupManagement":{},"SecurityGroupIdForDomainBoundary":{}}}},"DescribeEdgePackagingJob":{"input":{"type":"structure","required":["EdgePackagingJobName"],"members":{"EdgePackagingJobName":{}}},"output":{"type":"structure","required":["EdgePackagingJobArn","EdgePackagingJobName","EdgePackagingJobStatus"],"members":{"EdgePackagingJobArn":{},"EdgePackagingJobName":{},"CompilationJobName":{},"ModelName":{},"ModelVersion":{},"RoleArn":{},"OutputConfig":{"shape":"S7r"},"ResourceKey":{},"EdgePackagingJobStatus":{},"EdgePackagingJobStatusMessage":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"ModelArtifact":{},"ModelSignature":{},"PresetDeploymentOutput":{"type":"structure","required":["Type"],"members":{"Type":{},"Artifact":{},"Status":{},"StatusMessage":{}}}}}},"DescribeEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"type":"structure","required":["EndpointName","EndpointArn","EndpointConfigName","EndpointStatus","CreationTime","LastModifiedTime"],"members":{"EndpointName":{},"EndpointArn":{},"EndpointConfigName":{},"ProductionVariants":{"shape":"Spr"},"DataCaptureConfig":{"shape":"Sq0"},"EndpointStatus":{},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastDeploymentConfig":{"shape":"S8q"},"AsyncInferenceConfig":{"shape":"S9u"},"PendingDeploymentSummary":{"type":"structure","required":["EndpointConfigName"],"members":{"EndpointConfigName":{},"ProductionVariants":{"type":"list","member":{"type":"structure","required":["VariantName"],"members":{"VariantName":{},"DeployedImages":{"shape":"Spt"},"CurrentWeight":{"type":"float"},"DesiredWeight":{"type":"float"},"CurrentInstanceCount":{"type":"integer"},"DesiredInstanceCount":{"type":"integer"},"InstanceType":{},"AcceleratorType":{},"VariantStatus":{"shape":"Spw"},"CurrentServerlessConfig":{"shape":"S9g"},"DesiredServerlessConfig":{"shape":"S9g"}}}},"StartTime":{"type":"timestamp"}}}}}},"DescribeEndpointConfig":{"input":{"type":"structure","required":["EndpointConfigName"],"members":{"EndpointConfigName":{}}},"output":{"type":"structure","required":["EndpointConfigName","EndpointConfigArn","ProductionVariants","CreationTime"],"members":{"EndpointConfigName":{},"EndpointConfigArn":{},"ProductionVariants":{"shape":"S97"},"DataCaptureConfig":{"shape":"S9j"},"KmsKeyId":{},"CreationTime":{"type":"timestamp"},"AsyncInferenceConfig":{"shape":"S9u"}}}},"DescribeExperiment":{"input":{"type":"structure","required":["ExperimentName"],"members":{"ExperimentName":{}}},"output":{"type":"structure","members":{"ExperimentName":{},"ExperimentArn":{},"DisplayName":{},"Source":{"shape":"Sqa"},"Description":{},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"}}}},"DescribeFeatureGroup":{"input":{"type":"structure","required":["FeatureGroupName"],"members":{"FeatureGroupName":{},"NextToken":{}}},"output":{"type":"structure","required":["FeatureGroupArn","FeatureGroupName","RecordIdentifierFeatureName","EventTimeFeatureName","FeatureDefinitions","CreationTime","NextToken"],"members":{"FeatureGroupArn":{},"FeatureGroupName":{},"RecordIdentifierFeatureName":{},"EventTimeFeatureName":{},"FeatureDefinitions":{"shape":"Sa8"},"CreationTime":{"type":"timestamp"},"OnlineStoreConfig":{"shape":"Sab"},"OfflineStoreConfig":{"shape":"Sad"},"RoleArn":{},"FeatureGroupStatus":{},"OfflineStoreStatus":{"shape":"Sqg"},"FailureReason":{},"Description":{},"NextToken":{}}}},"DescribeFlowDefinition":{"input":{"type":"structure","required":["FlowDefinitionName"],"members":{"FlowDefinitionName":{}}},"output":{"type":"structure","required":["FlowDefinitionArn","FlowDefinitionName","FlowDefinitionStatus","CreationTime","HumanLoopConfig","OutputConfig","RoleArn"],"members":{"FlowDefinitionArn":{},"FlowDefinitionName":{},"FlowDefinitionStatus":{},"CreationTime":{"type":"timestamp"},"HumanLoopRequestSource":{"shape":"Sao"},"HumanLoopActivationConfig":{"shape":"Saq"},"HumanLoopConfig":{"shape":"Sat"},"OutputConfig":{"shape":"Sb8"},"RoleArn":{},"FailureReason":{}}}},"DescribeHumanTaskUi":{"input":{"type":"structure","required":["HumanTaskUiName"],"members":{"HumanTaskUiName":{}}},"output":{"type":"structure","required":["HumanTaskUiArn","HumanTaskUiName","CreationTime","UiTemplate"],"members":{"HumanTaskUiArn":{},"HumanTaskUiName":{},"HumanTaskUiStatus":{},"CreationTime":{"type":"timestamp"},"UiTemplate":{"type":"structure","members":{"Url":{},"ContentSha256":{}}}}}},"DescribeHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName"],"members":{"HyperParameterTuningJobName":{}}},"output":{"type":"structure","required":["HyperParameterTuningJobName","HyperParameterTuningJobArn","HyperParameterTuningJobConfig","HyperParameterTuningJobStatus","CreationTime","TrainingJobStatusCounters","ObjectiveStatusCounters"],"members":{"HyperParameterTuningJobName":{},"HyperParameterTuningJobArn":{},"HyperParameterTuningJobConfig":{"shape":"Sbi"},"TrainingJobDefinition":{"shape":"Sbz"},"TrainingJobDefinitions":{"shape":"Sc7"},"HyperParameterTuningJobStatus":{},"CreationTime":{"type":"timestamp"},"HyperParameterTuningEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TrainingJobStatusCounters":{"shape":"Sqv"},"ObjectiveStatusCounters":{"shape":"Sqx"},"BestTrainingJob":{"shape":"Sqz"},"OverallBestTrainingJob":{"shape":"Sqz"},"WarmStartConfig":{"shape":"Sc8"},"FailureReason":{}}}},"DescribeImage":{"input":{"type":"structure","required":["ImageName"],"members":{"ImageName":{}}},"output":{"type":"structure","members":{"CreationTime":{"type":"timestamp"},"Description":{},"DisplayName":{},"FailureReason":{},"ImageArn":{},"ImageName":{},"ImageStatus":{},"LastModifiedTime":{"type":"timestamp"},"RoleArn":{}}}},"DescribeImageVersion":{"input":{"type":"structure","required":["ImageName"],"members":{"ImageName":{},"Version":{"type":"integer"}}},"output":{"type":"structure","members":{"BaseImage":{},"ContainerImage":{},"CreationTime":{"type":"timestamp"},"FailureReason":{},"ImageArn":{},"ImageVersionArn":{},"ImageVersionStatus":{},"LastModifiedTime":{"type":"timestamp"},"Version":{"type":"integer"}}}},"DescribeInferenceRecommendationsJob":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{}}},"output":{"type":"structure","required":["JobName","JobType","JobArn","RoleArn","Status","CreationTime","LastModifiedTime","InputConfig"],"members":{"JobName":{},"JobDescription":{},"JobType":{},"JobArn":{},"RoleArn":{},"Status":{},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"InputConfig":{"shape":"Scp"},"StoppingConditions":{"shape":"Sdb"},"InferenceRecommendations":{"type":"list","member":{"type":"structure","required":["Metrics","EndpointConfiguration","ModelConfiguration"],"members":{"Metrics":{"type":"structure","required":["CostPerHour","CostPerInference","MaxInvocations","ModelLatency"],"members":{"CostPerHour":{"type":"float"},"CostPerInference":{"type":"float"},"MaxInvocations":{"type":"integer"},"ModelLatency":{"type":"integer"}}},"EndpointConfiguration":{"type":"structure","required":["EndpointName","VariantName","InstanceType","InitialInstanceCount"],"members":{"EndpointName":{},"VariantName":{},"InstanceType":{},"InitialInstanceCount":{"type":"integer"}}},"ModelConfiguration":{"type":"structure","members":{"InferenceSpecificationName":{},"EnvironmentParameters":{"type":"list","member":{"type":"structure","required":["Key","ValueType","Value"],"members":{"Key":{},"ValueType":{},"Value":{}}}}}}}}}}}},"DescribeLabelingJob":{"input":{"type":"structure","required":["LabelingJobName"],"members":{"LabelingJobName":{}}},"output":{"type":"structure","required":["LabelingJobStatus","LabelCounters","CreationTime","LastModifiedTime","JobReferenceCode","LabelingJobName","LabelingJobArn","InputConfig","OutputConfig","RoleArn","HumanTaskConfig"],"members":{"LabelingJobStatus":{},"LabelCounters":{"shape":"Srm"},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"JobReferenceCode":{},"LabelingJobName":{},"LabelingJobArn":{},"LabelAttributeName":{},"InputConfig":{"shape":"Sdm"},"OutputConfig":{"shape":"Sdt"},"RoleArn":{},"LabelCategoryConfigS3Uri":{},"StoppingConditions":{"shape":"Sdu"},"LabelingJobAlgorithmsConfig":{"shape":"Sdx"},"HumanTaskConfig":{"shape":"Se1"},"Tags":{"shape":"S7"},"LabelingJobOutput":{"shape":"Srp"}}}},"DescribeLineageGroup":{"input":{"type":"structure","required":["LineageGroupName"],"members":{"LineageGroupName":{}}},"output":{"type":"structure","members":{"LineageGroupName":{},"LineageGroupArn":{},"DisplayName":{},"Description":{},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"}}}},"DescribeModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}},"output":{"type":"structure","required":["ModelName","ExecutionRoleArn","CreationTime","ModelArn"],"members":{"ModelName":{},"PrimaryContainer":{"shape":"Seg"},"Containers":{"shape":"Sep"},"InferenceExecutionConfig":{"shape":"Seq"},"ExecutionRoleArn":{},"VpcConfig":{"shape":"S5i"},"CreationTime":{"type":"timestamp"},"ModelArn":{},"EnableNetworkIsolation":{"type":"boolean"}}}},"DescribeModelBiasJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}},"output":{"type":"structure","required":["JobDefinitionArn","JobDefinitionName","CreationTime","ModelBiasAppSpecification","ModelBiasJobInput","ModelBiasJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionArn":{},"JobDefinitionName":{},"CreationTime":{"type":"timestamp"},"ModelBiasBaselineConfig":{"shape":"Seu"},"ModelBiasAppSpecification":{"shape":"Sev"},"ModelBiasJobInput":{"shape":"Sew"},"ModelBiasJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"}}}},"DescribeModelExplainabilityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}},"output":{"type":"structure","required":["JobDefinitionArn","JobDefinitionName","CreationTime","ModelExplainabilityAppSpecification","ModelExplainabilityJobInput","ModelExplainabilityJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionArn":{},"JobDefinitionName":{},"CreationTime":{"type":"timestamp"},"ModelExplainabilityBaselineConfig":{"shape":"Sf0"},"ModelExplainabilityAppSpecification":{"shape":"Sf1"},"ModelExplainabilityJobInput":{"shape":"Sf2"},"ModelExplainabilityJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"}}}},"DescribeModelPackage":{"input":{"type":"structure","required":["ModelPackageName"],"members":{"ModelPackageName":{}}},"output":{"type":"structure","required":["ModelPackageName","ModelPackageArn","CreationTime","ModelPackageStatus","ModelPackageStatusDetails"],"members":{"ModelPackageName":{},"ModelPackageGroupName":{},"ModelPackageVersion":{"type":"integer"},"ModelPackageArn":{},"ModelPackageDescription":{},"CreationTime":{"type":"timestamp"},"InferenceSpecification":{"shape":"Sr"},"SourceAlgorithmSpecification":{"shape":"Sf8"},"ValidationSpecification":{"shape":"Sf5"},"ModelPackageStatus":{},"ModelPackageStatusDetails":{"shape":"Ss0"},"CertifyForMarketplace":{"type":"boolean"},"ModelApprovalStatus":{},"CreatedBy":{"shape":"Sn8"},"MetadataProperties":{"shape":"S1q"},"ModelMetrics":{"shape":"Sfb"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"ApprovalDescription":{},"CustomerMetadataProperties":{"shape":"Sfi"},"DriftCheckBaselines":{"shape":"Sfl"},"Domain":{},"Task":{},"SamplePayloadUrl":{},"AdditionalInferenceSpecifications":{"shape":"Sfr"}}}},"DescribeModelPackageGroup":{"input":{"type":"structure","required":["ModelPackageGroupName"],"members":{"ModelPackageGroupName":{}}},"output":{"type":"structure","required":["ModelPackageGroupName","ModelPackageGroupArn","CreationTime","CreatedBy","ModelPackageGroupStatus"],"members":{"ModelPackageGroupName":{},"ModelPackageGroupArn":{},"ModelPackageGroupDescription":{},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"ModelPackageGroupStatus":{}}}},"DescribeModelQualityJobDefinition":{"input":{"type":"structure","required":["JobDefinitionName"],"members":{"JobDefinitionName":{}}},"output":{"type":"structure","required":["JobDefinitionArn","JobDefinitionName","CreationTime","ModelQualityAppSpecification","ModelQualityJobInput","ModelQualityJobOutputConfig","JobResources","RoleArn"],"members":{"JobDefinitionArn":{},"JobDefinitionName":{},"CreationTime":{"type":"timestamp"},"ModelQualityBaselineConfig":{"shape":"Sfy"},"ModelQualityAppSpecification":{"shape":"Sfz"},"ModelQualityJobInput":{"shape":"Sg1"},"ModelQualityJobOutputConfig":{"shape":"S79"},"JobResources":{"shape":"S7f"},"NetworkConfig":{"shape":"S7k"},"RoleArn":{},"StoppingCondition":{"shape":"S7l"}}}},"DescribeMonitoringSchedule":{"input":{"type":"structure","required":["MonitoringScheduleName"],"members":{"MonitoringScheduleName":{}}},"output":{"type":"structure","required":["MonitoringScheduleArn","MonitoringScheduleName","MonitoringScheduleStatus","CreationTime","LastModifiedTime","MonitoringScheduleConfig"],"members":{"MonitoringScheduleArn":{},"MonitoringScheduleName":{},"MonitoringScheduleStatus":{},"MonitoringType":{},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"MonitoringScheduleConfig":{"shape":"Sg5"},"EndpointName":{},"LastMonitoringExecutionSummary":{"shape":"Ssd"}}}},"DescribeNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}},"output":{"type":"structure","members":{"NotebookInstanceArn":{},"NotebookInstanceName":{},"NotebookInstanceStatus":{},"FailureReason":{},"Url":{},"InstanceType":{},"SubnetId":{},"SecurityGroups":{"shape":"S7y"},"RoleArn":{},"KmsKeyId":{},"NetworkInterfaceId":{},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"NotebookInstanceLifecycleConfigName":{},"DirectInternetAccess":{},"VolumeSizeInGB":{"type":"integer"},"AcceleratorTypes":{"shape":"Sgn"},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"Sgq"},"RootAccess":{},"PlatformIdentifier":{}}}},"DescribeNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{}}},"output":{"type":"structure","members":{"NotebookInstanceLifecycleConfigArn":{},"NotebookInstanceLifecycleConfigName":{},"OnCreate":{"shape":"Sgw"},"OnStart":{"shape":"Sgw"},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}}},"DescribePipeline":{"input":{"type":"structure","required":["PipelineName"],"members":{"PipelineName":{}}},"output":{"type":"structure","members":{"PipelineArn":{},"PipelineName":{},"PipelineDisplayName":{},"PipelineDefinition":{},"PipelineDescription":{},"RoleArn":{},"PipelineStatus":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastRunTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedBy":{"shape":"Sn8"},"ParallelismConfiguration":{"shape":"Sha"}}}},"DescribePipelineDefinitionForExecution":{"input":{"type":"structure","required":["PipelineExecutionArn"],"members":{"PipelineExecutionArn":{}}},"output":{"type":"structure","members":{"PipelineDefinition":{},"CreationTime":{"type":"timestamp"}}}},"DescribePipelineExecution":{"input":{"type":"structure","required":["PipelineExecutionArn"],"members":{"PipelineExecutionArn":{}}},"output":{"type":"structure","members":{"PipelineArn":{},"PipelineExecutionArn":{},"PipelineExecutionDisplayName":{},"PipelineExecutionStatus":{},"PipelineExecutionDescription":{},"PipelineExperimentConfig":{"shape":"Ssw"},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedBy":{"shape":"Sn8"},"ParallelismConfiguration":{"shape":"Sha"}}}},"DescribeProcessingJob":{"input":{"type":"structure","required":["ProcessingJobName"],"members":{"ProcessingJobName":{}}},"output":{"type":"structure","required":["ProcessingJobName","ProcessingResources","AppSpecification","ProcessingJobArn","ProcessingJobStatus","CreationTime"],"members":{"ProcessingInputs":{"shape":"Shn"},"ProcessingOutputConfig":{"shape":"Sia"},"ProcessingJobName":{},"ProcessingResources":{"shape":"Sif"},"StoppingCondition":{"shape":"Sih"},"AppSpecification":{"shape":"Sij"},"Environment":{"shape":"Sil"},"NetworkConfig":{"shape":"Sgd"},"RoleArn":{},"ExperimentConfig":{"shape":"Sim"},"ProcessingJobArn":{},"ProcessingJobStatus":{},"ExitMessage":{},"FailureReason":{},"ProcessingEndTime":{"type":"timestamp"},"ProcessingStartTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"MonitoringScheduleArn":{},"AutoMLJobArn":{},"TrainingJobArn":{}}}},"DescribeProject":{"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{}}},"output":{"type":"structure","required":["ProjectArn","ProjectName","ProjectId","ServiceCatalogProvisioningDetails","ProjectStatus","CreationTime"],"members":{"ProjectArn":{},"ProjectName":{},"ProjectId":{},"ProjectDescription":{},"ServiceCatalogProvisioningDetails":{"shape":"Sir"},"ServiceCatalogProvisionedProductDetails":{"shape":"St4"},"ProjectStatus":{},"CreatedBy":{"shape":"Sn8"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"}}}},"DescribeStudioLifecycleConfig":{"input":{"type":"structure","required":["StudioLifecycleConfigName"],"members":{"StudioLifecycleConfigName":{}}},"output":{"type":"structure","members":{"StudioLifecycleConfigArn":{},"StudioLifecycleConfigName":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"StudioLifecycleConfigContent":{},"StudioLifecycleConfigAppType":{}}}},"DescribeSubscribedWorkteam":{"input":{"type":"structure","required":["WorkteamArn"],"members":{"WorkteamArn":{}}},"output":{"type":"structure","required":["SubscribedWorkteam"],"members":{"SubscribedWorkteam":{"shape":"Stb"}}}},"DescribeTrainingJob":{"input":{"type":"structure","required":["TrainingJobName"],"members":{"TrainingJobName":{}}},"output":{"type":"structure","required":["TrainingJobName","TrainingJobArn","ModelArtifacts","TrainingJobStatus","SecondaryStatus","AlgorithmSpecification","ResourceConfig","StoppingCondition","CreationTime"],"members":{"TrainingJobName":{},"TrainingJobArn":{},"TuningJobArn":{},"LabelingJobArn":{},"AutoMLJobArn":{},"ModelArtifacts":{"shape":"Sov"},"TrainingJobStatus":{},"SecondaryStatus":{},"FailureReason":{},"HyperParameters":{"shape":"S2t"},"AlgorithmSpecification":{"shape":"Sj7"},"RoleArn":{},"InputDataConfig":{"shape":"S2v"},"OutputDataConfig":{"shape":"S3c"},"ResourceConfig":{"shape":"S3e"},"VpcConfig":{"shape":"S5i"},"StoppingCondition":{"shape":"S3h"},"CreationTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"SecondaryStatusTransitions":{"shape":"Stf"},"FinalMetricDataList":{"shape":"Sti"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"Sc4"},"TrainingTimeInSeconds":{"type":"integer"},"BillableTimeInSeconds":{"type":"integer"},"DebugHookConfig":{"shape":"Sj8"},"ExperimentConfig":{"shape":"Sim"},"DebugRuleConfigurations":{"shape":"Sjg"},"TensorBoardOutputConfig":{"shape":"Sjl"},"DebugRuleEvaluationStatuses":{"shape":"Stm"},"ProfilerConfig":{"shape":"Sjm"},"ProfilerRuleConfigurations":{"shape":"Sjp"},"ProfilerRuleEvaluationStatuses":{"type":"list","member":{"type":"structure","members":{"RuleConfigurationName":{},"RuleEvaluationJobArn":{},"RuleEvaluationStatus":{},"StatusDetails":{},"LastModifiedTime":{"type":"timestamp"}}}},"ProfilingStatus":{},"RetryStrategy":{"shape":"Sc5"},"Environment":{"shape":"Sjr"}}}},"DescribeTransformJob":{"input":{"type":"structure","required":["TransformJobName"],"members":{"TransformJobName":{}}},"output":{"type":"structure","required":["TransformJobName","TransformJobArn","TransformJobStatus","ModelName","TransformInput","TransformResources","CreationTime"],"members":{"TransformJobName":{},"TransformJobArn":{},"TransformJobStatus":{},"FailureReason":{},"ModelName":{},"MaxConcurrentTransforms":{"type":"integer"},"ModelClientConfig":{"shape":"Sjy"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S3o"},"TransformInput":{"shape":"S3r"},"TransformOutput":{"shape":"S3v"},"TransformResources":{"shape":"S3y"},"CreationTime":{"type":"timestamp"},"TransformStartTime":{"type":"timestamp"},"TransformEndTime":{"type":"timestamp"},"LabelingJobArn":{},"AutoMLJobArn":{},"DataProcessing":{"shape":"Sk1"},"ExperimentConfig":{"shape":"Sim"}}}},"DescribeTrial":{"input":{"type":"structure","required":["TrialName"],"members":{"TrialName":{}}},"output":{"type":"structure","members":{"TrialName":{},"TrialArn":{},"DisplayName":{},"ExperimentName":{},"Source":{"shape":"Sty"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"MetadataProperties":{"shape":"S1q"}}}},"DescribeTrialComponent":{"input":{"type":"structure","required":["TrialComponentName"],"members":{"TrialComponentName":{}}},"output":{"type":"structure","members":{"TrialComponentName":{},"TrialComponentArn":{},"DisplayName":{},"Source":{"shape":"Su2"},"Status":{"shape":"Sk9"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"Parameters":{"shape":"Skd"},"InputArtifacts":{"shape":"Skh"},"OutputArtifacts":{"shape":"Skh"},"MetadataProperties":{"shape":"S1q"},"Metrics":{"shape":"Su4"},"LineageGroupArn":{}}}},"DescribeUserProfile":{"input":{"type":"structure","required":["DomainId","UserProfileName"],"members":{"DomainId":{},"UserProfileName":{}}},"output":{"type":"structure","members":{"DomainId":{},"UserProfileArn":{},"UserProfileName":{},"HomeEfsFileSystemUid":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"FailureReason":{},"SingleSignOnUserIdentifier":{},"SingleSignOnUserValue":{},"UserSettings":{"shape":"S7x"}}}},"DescribeWorkforce":{"input":{"type":"structure","required":["WorkforceName"],"members":{"WorkforceName":{}}},"output":{"type":"structure","required":["Workforce"],"members":{"Workforce":{"shape":"Sue"}}}},"DescribeWorkteam":{"input":{"type":"structure","required":["WorkteamName"],"members":{"WorkteamName":{}}},"output":{"type":"structure","required":["Workteam"],"members":{"Workteam":{"shape":"Sui"}}}},"DisableSagemakerServicecatalogPortfolio":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateTrialComponent":{"input":{"type":"structure","required":["TrialComponentName","TrialName"],"members":{"TrialComponentName":{},"TrialName":{}}},"output":{"type":"structure","members":{"TrialComponentArn":{},"TrialArn":{}}}},"EnableSagemakerServicecatalogPortfolio":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"GetDeviceFleetReport":{"input":{"type":"structure","required":["DeviceFleetName"],"members":{"DeviceFleetName":{}}},"output":{"type":"structure","required":["DeviceFleetArn","DeviceFleetName"],"members":{"DeviceFleetArn":{},"DeviceFleetName":{},"OutputConfig":{"shape":"S7r"},"Description":{},"ReportGenerated":{"type":"timestamp"},"DeviceStats":{"type":"structure","required":["ConnectedDeviceCount","RegisteredDeviceCount"],"members":{"ConnectedDeviceCount":{"type":"long"},"RegisteredDeviceCount":{"type":"long"}}},"AgentVersions":{"type":"list","member":{"type":"structure","required":["Version","AgentCount"],"members":{"Version":{},"AgentCount":{"type":"long"}}}},"ModelStats":{"type":"list","member":{"type":"structure","required":["ModelName","ModelVersion","OfflineDeviceCount","ConnectedDeviceCount","ActiveDeviceCount","SamplingDeviceCount"],"members":{"ModelName":{},"ModelVersion":{},"OfflineDeviceCount":{"type":"long"},"ConnectedDeviceCount":{"type":"long"},"ActiveDeviceCount":{"type":"long"},"SamplingDeviceCount":{"type":"long"}}}}}}},"GetLineageGroupPolicy":{"input":{"type":"structure","required":["LineageGroupName"],"members":{"LineageGroupName":{}}},"output":{"type":"structure","members":{"LineageGroupArn":{},"ResourcePolicy":{}}}},"GetModelPackageGroupPolicy":{"input":{"type":"structure","required":["ModelPackageGroupName"],"members":{"ModelPackageGroupName":{}}},"output":{"type":"structure","required":["ResourcePolicy"],"members":{"ResourcePolicy":{}}}},"GetSagemakerServicecatalogPortfolioStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Status":{}}}},"GetSearchSuggestions":{"input":{"type":"structure","required":["Resource"],"members":{"Resource":{},"SuggestionQuery":{"type":"structure","members":{"PropertyNameQuery":{"type":"structure","required":["PropertyNameHint"],"members":{"PropertyNameHint":{}}}}}}},"output":{"type":"structure","members":{"PropertyNameSuggestions":{"type":"list","member":{"type":"structure","members":{"PropertyName":{}}}}}}},"ListActions":{"input":{"type":"structure","members":{"SourceUri":{},"ActionType":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ActionSummaries":{"type":"list","member":{"type":"structure","members":{"ActionArn":{},"ActionName":{},"Source":{"shape":"S1j"},"ActionType":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListAlgorithms":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["AlgorithmSummaryList"],"members":{"AlgorithmSummaryList":{"type":"list","member":{"type":"structure","required":["AlgorithmName","AlgorithmArn","CreationTime","AlgorithmStatus"],"members":{"AlgorithmName":{},"AlgorithmArn":{},"AlgorithmDescription":{},"CreationTime":{"type":"timestamp"},"AlgorithmStatus":{}}}},"NextToken":{}}}},"ListAppImageConfigs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"ModifiedTimeBefore":{"type":"timestamp"},"ModifiedTimeAfter":{"type":"timestamp"},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"NextToken":{},"AppImageConfigs":{"type":"list","member":{"type":"structure","members":{"AppImageConfigArn":{},"AppImageConfigName":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"KernelGatewayImageConfig":{"shape":"S4h"}}}}}}},"ListApps":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortOrder":{},"SortBy":{},"DomainIdEquals":{},"UserProfileNameEquals":{}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"DomainId":{},"UserProfileName":{},"AppType":{},"AppName":{},"Status":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListArtifacts":{"input":{"type":"structure","members":{"SourceUri":{},"ArtifactType":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"ArtifactArn":{},"ArtifactName":{},"Source":{"shape":"S4t"},"ArtifactType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"SourceArn":{},"DestinationArn":{},"SourceType":{},"DestinationType":{},"AssociationType":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AssociationSummaries":{"type":"list","member":{"type":"structure","members":{"SourceArn":{},"DestinationArn":{},"SourceType":{},"DestinationType":{},"AssociationType":{},"SourceName":{},"DestinationName":{},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"}}}},"NextToken":{}}}},"ListAutoMLJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortOrder":{},"SortBy":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["AutoMLJobSummaries"],"members":{"AutoMLJobSummaries":{"type":"list","member":{"type":"structure","required":["AutoMLJobName","AutoMLJobArn","AutoMLJobStatus","AutoMLJobSecondaryStatus","CreationTime","LastModifiedTime"],"members":{"AutoMLJobName":{},"AutoMLJobArn":{},"AutoMLJobStatus":{},"AutoMLJobSecondaryStatus":{},"CreationTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"PartialFailureReasons":{"shape":"Sns"}}}},"NextToken":{}}}},"ListCandidatesForAutoMLJob":{"input":{"type":"structure","required":["AutoMLJobName"],"members":{"AutoMLJobName":{},"StatusEquals":{},"CandidateNameEquals":{},"SortOrder":{},"SortBy":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Candidates"],"members":{"Candidates":{"type":"list","member":{"shape":"Snu"}},"NextToken":{}}}},"ListCodeRepositories":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["CodeRepositorySummaryList"],"members":{"CodeRepositorySummaryList":{"type":"list","member":{"type":"structure","required":["CodeRepositoryName","CodeRepositoryArn","CreationTime","LastModifiedTime"],"members":{"CodeRepositoryName":{},"CodeRepositoryArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"GitConfig":{"shape":"S5w"}}}},"NextToken":{}}}},"ListCompilationJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["CompilationJobSummaries"],"members":{"CompilationJobSummaries":{"type":"list","member":{"type":"structure","required":["CompilationJobName","CompilationJobArn","CreationTime","CompilationJobStatus"],"members":{"CompilationJobName":{},"CompilationJobArn":{},"CreationTime":{"type":"timestamp"},"CompilationStartTime":{"type":"timestamp"},"CompilationEndTime":{"type":"timestamp"},"CompilationTargetDevice":{},"CompilationTargetPlatformOs":{},"CompilationTargetPlatformArch":{},"CompilationTargetPlatformAccelerator":{},"LastModifiedTime":{"type":"timestamp"},"CompilationJobStatus":{}}}},"NextToken":{}}}},"ListContexts":{"input":{"type":"structure","members":{"SourceUri":{},"ContextType":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ContextSummaries":{"type":"list","member":{"type":"structure","members":{"ContextArn":{},"ContextName":{},"Source":{"shape":"S6k"},"ContextType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListDataQualityJobDefinitions":{"input":{"type":"structure","members":{"EndpointName":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["JobDefinitionSummaries"],"members":{"JobDefinitionSummaries":{"shape":"Sxb"},"NextToken":{}}}},"ListDeviceFleets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["DeviceFleetSummaries"],"members":{"DeviceFleetSummaries":{"type":"list","member":{"type":"structure","required":["DeviceFleetArn","DeviceFleetName"],"members":{"DeviceFleetArn":{},"DeviceFleetName":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"LatestHeartbeatAfter":{"type":"timestamp"},"ModelName":{},"DeviceFleetName":{}}},"output":{"type":"structure","required":["DeviceSummaries"],"members":{"DeviceSummaries":{"type":"list","member":{"type":"structure","required":["DeviceName","DeviceArn"],"members":{"DeviceName":{},"DeviceArn":{},"Description":{},"DeviceFleetName":{},"IotThingName":{},"RegistrationTime":{"type":"timestamp"},"LatestHeartbeat":{"type":"timestamp"},"Models":{"type":"list","member":{"type":"structure","required":["ModelName","ModelVersion"],"members":{"ModelName":{},"ModelVersion":{}}}},"AgentVersion":{}}}},"NextToken":{}}}},"ListDomains":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Domains":{"type":"list","member":{"type":"structure","members":{"DomainArn":{},"DomainId":{},"DomainName":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"Url":{}}}},"NextToken":{}}}},"ListEdgePackagingJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"ModelNameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["EdgePackagingJobSummaries"],"members":{"EdgePackagingJobSummaries":{"type":"list","member":{"type":"structure","required":["EdgePackagingJobArn","EdgePackagingJobName","EdgePackagingJobStatus"],"members":{"EdgePackagingJobArn":{},"EdgePackagingJobName":{},"EdgePackagingJobStatus":{},"CompilationJobName":{},"ModelName":{},"ModelVersion":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEndpointConfigs":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["EndpointConfigs"],"members":{"EndpointConfigs":{"type":"list","member":{"type":"structure","required":["EndpointConfigName","EndpointConfigArn","CreationTime"],"members":{"EndpointConfigName":{},"EndpointConfigArn":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEndpoints":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"StatusEquals":{}}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["EndpointName","EndpointArn","CreationTime","LastModifiedTime","EndpointStatus"],"members":{"EndpointName":{},"EndpointArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"EndpointStatus":{}}}},"NextToken":{}}}},"ListExperiments":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ExperimentSummaries":{"type":"list","member":{"type":"structure","members":{"ExperimentArn":{},"ExperimentName":{},"DisplayName":{},"ExperimentSource":{"shape":"Sqa"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListFeatureGroups":{"input":{"type":"structure","members":{"NameContains":{},"FeatureGroupStatusEquals":{},"OfflineStoreStatusEquals":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"SortOrder":{},"SortBy":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["FeatureGroupSummaries","NextToken"],"members":{"FeatureGroupSummaries":{"type":"list","member":{"type":"structure","required":["FeatureGroupName","FeatureGroupArn","CreationTime"],"members":{"FeatureGroupName":{},"FeatureGroupArn":{},"CreationTime":{"type":"timestamp"},"FeatureGroupStatus":{},"OfflineStoreStatus":{"shape":"Sqg"}}}},"NextToken":{}}}},"ListFlowDefinitions":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["FlowDefinitionSummaries"],"members":{"FlowDefinitionSummaries":{"type":"list","member":{"type":"structure","required":["FlowDefinitionName","FlowDefinitionArn","FlowDefinitionStatus","CreationTime"],"members":{"FlowDefinitionName":{},"FlowDefinitionArn":{},"FlowDefinitionStatus":{},"CreationTime":{"type":"timestamp"},"FailureReason":{}}}},"NextToken":{}}}},"ListHumanTaskUis":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["HumanTaskUiSummaries"],"members":{"HumanTaskUiSummaries":{"type":"list","member":{"type":"structure","required":["HumanTaskUiName","HumanTaskUiArn","CreationTime"],"members":{"HumanTaskUiName":{},"HumanTaskUiArn":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListHyperParameterTuningJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{},"SortOrder":{},"NameContains":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"StatusEquals":{}}},"output":{"type":"structure","required":["HyperParameterTuningJobSummaries"],"members":{"HyperParameterTuningJobSummaries":{"type":"list","member":{"type":"structure","required":["HyperParameterTuningJobName","HyperParameterTuningJobArn","HyperParameterTuningJobStatus","Strategy","CreationTime","TrainingJobStatusCounters","ObjectiveStatusCounters"],"members":{"HyperParameterTuningJobName":{},"HyperParameterTuningJobArn":{},"HyperParameterTuningJobStatus":{},"Strategy":{},"CreationTime":{"type":"timestamp"},"HyperParameterTuningEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TrainingJobStatusCounters":{"shape":"Sqv"},"ObjectiveStatusCounters":{"shape":"Sqx"},"ResourceLimits":{"shape":"Sbk"}}}},"NextToken":{}}}},"ListImageVersions":{"input":{"type":"structure","required":["ImageName"],"members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"ImageName":{},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"ImageVersions":{"type":"list","member":{"type":"structure","required":["CreationTime","ImageArn","ImageVersionArn","ImageVersionStatus","LastModifiedTime","Version"],"members":{"CreationTime":{"type":"timestamp"},"FailureReason":{},"ImageArn":{},"ImageVersionArn":{},"ImageVersionStatus":{},"LastModifiedTime":{"type":"timestamp"},"Version":{"type":"integer"}}}},"NextToken":{}}}},"ListImages":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"type":"structure","required":["CreationTime","ImageArn","ImageName","ImageStatus","LastModifiedTime"],"members":{"CreationTime":{"type":"timestamp"},"Description":{},"DisplayName":{},"FailureReason":{},"ImageArn":{},"ImageName":{},"ImageStatus":{},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListInferenceRecommendationsJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["InferenceRecommendationsJobs"],"members":{"InferenceRecommendationsJobs":{"type":"list","member":{"type":"structure","required":["JobName","JobDescription","JobType","JobArn","Status","CreationTime","RoleArn","LastModifiedTime"],"members":{"JobName":{},"JobDescription":{},"JobType":{},"JobArn":{},"Status":{},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"RoleArn":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{}}}},"NextToken":{}}}},"ListLabelingJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{},"NameContains":{},"SortBy":{},"SortOrder":{},"StatusEquals":{}}},"output":{"type":"structure","members":{"LabelingJobSummaryList":{"type":"list","member":{"type":"structure","required":["LabelingJobName","LabelingJobArn","CreationTime","LastModifiedTime","LabelingJobStatus","LabelCounters","WorkteamArn","PreHumanTaskLambdaArn"],"members":{"LabelingJobName":{},"LabelingJobArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LabelingJobStatus":{},"LabelCounters":{"shape":"Srm"},"WorkteamArn":{},"PreHumanTaskLambdaArn":{},"AnnotationConsolidationLambdaArn":{},"FailureReason":{},"LabelingJobOutput":{"shape":"Srp"},"InputConfig":{"shape":"Sdm"}}}},"NextToken":{}}}},"ListLabelingJobsForWorkteam":{"input":{"type":"structure","required":["WorkteamArn"],"members":{"WorkteamArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"JobReferenceCodeContains":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["LabelingJobSummaryList"],"members":{"LabelingJobSummaryList":{"type":"list","member":{"type":"structure","required":["JobReferenceCode","WorkRequesterAccountId","CreationTime"],"members":{"LabelingJobName":{},"JobReferenceCode":{},"WorkRequesterAccountId":{},"CreationTime":{"type":"timestamp"},"LabelCounters":{"type":"structure","members":{"HumanLabeled":{"type":"integer"},"PendingHuman":{"type":"integer"},"Total":{"type":"integer"}}},"NumberOfHumanWorkersPerDataObject":{"type":"integer"}}}},"NextToken":{}}}},"ListLineageGroups":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"LineageGroupSummaries":{"type":"list","member":{"type":"structure","members":{"LineageGroupArn":{},"LineageGroupName":{},"DisplayName":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListModelBiasJobDefinitions":{"input":{"type":"structure","members":{"EndpointName":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["JobDefinitionSummaries"],"members":{"JobDefinitionSummaries":{"shape":"Sxb"},"NextToken":{}}}},"ListModelExplainabilityJobDefinitions":{"input":{"type":"structure","members":{"EndpointName":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["JobDefinitionSummaries"],"members":{"JobDefinitionSummaries":{"shape":"Sxb"},"NextToken":{}}}},"ListModelMetadata":{"input":{"type":"structure","members":{"SearchExpression":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ModelMetadataSummaries"],"members":{"ModelMetadataSummaries":{"type":"list","member":{"type":"structure","required":["Domain","Framework","Task","Model","FrameworkVersion"],"members":{"Domain":{},"Framework":{},"Task":{},"Model":{},"FrameworkVersion":{}}}},"NextToken":{}}}},"ListModelPackageGroups":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["ModelPackageGroupSummaryList"],"members":{"ModelPackageGroupSummaryList":{"type":"list","member":{"type":"structure","required":["ModelPackageGroupName","ModelPackageGroupArn","CreationTime","ModelPackageGroupStatus"],"members":{"ModelPackageGroupName":{},"ModelPackageGroupArn":{},"ModelPackageGroupDescription":{},"CreationTime":{"type":"timestamp"},"ModelPackageGroupStatus":{}}}},"NextToken":{}}}},"ListModelPackages":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"ModelApprovalStatus":{},"ModelPackageGroupName":{},"ModelPackageType":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["ModelPackageSummaryList"],"members":{"ModelPackageSummaryList":{"type":"list","member":{"type":"structure","required":["ModelPackageName","ModelPackageArn","CreationTime","ModelPackageStatus"],"members":{"ModelPackageName":{},"ModelPackageGroupName":{},"ModelPackageVersion":{"type":"integer"},"ModelPackageArn":{},"ModelPackageDescription":{},"CreationTime":{"type":"timestamp"},"ModelPackageStatus":{},"ModelApprovalStatus":{}}}},"NextToken":{}}}},"ListModelQualityJobDefinitions":{"input":{"type":"structure","members":{"EndpointName":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["JobDefinitionSummaries"],"members":{"JobDefinitionSummaries":{"shape":"Sxb"},"NextToken":{}}}},"ListModels":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["Models"],"members":{"Models":{"type":"list","member":{"type":"structure","required":["ModelName","ModelArn","CreationTime"],"members":{"ModelName":{},"ModelArn":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListMonitoringExecutions":{"input":{"type":"structure","members":{"MonitoringScheduleName":{},"EndpointName":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"ScheduledTimeBefore":{"type":"timestamp"},"ScheduledTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"StatusEquals":{},"MonitoringJobDefinitionName":{},"MonitoringTypeEquals":{}}},"output":{"type":"structure","required":["MonitoringExecutionSummaries"],"members":{"MonitoringExecutionSummaries":{"type":"list","member":{"shape":"Ssd"}},"NextToken":{}}}},"ListMonitoringSchedules":{"input":{"type":"structure","members":{"EndpointName":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"StatusEquals":{},"MonitoringJobDefinitionName":{},"MonitoringTypeEquals":{}}},"output":{"type":"structure","required":["MonitoringScheduleSummaries"],"members":{"MonitoringScheduleSummaries":{"type":"list","member":{"type":"structure","required":["MonitoringScheduleName","MonitoringScheduleArn","CreationTime","LastModifiedTime","MonitoringScheduleStatus"],"members":{"MonitoringScheduleName":{},"MonitoringScheduleArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"MonitoringScheduleStatus":{},"EndpointName":{},"MonitoringJobDefinitionName":{},"MonitoringType":{}}}},"NextToken":{}}}},"ListNotebookInstanceLifecycleConfigs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{},"SortOrder":{},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{},"NotebookInstanceLifecycleConfigs":{"type":"list","member":{"type":"structure","required":["NotebookInstanceLifecycleConfigName","NotebookInstanceLifecycleConfigArn"],"members":{"NotebookInstanceLifecycleConfigName":{},"NotebookInstanceLifecycleConfigArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}}}}},"ListNotebookInstances":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{},"SortOrder":{},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"StatusEquals":{},"NotebookInstanceLifecycleConfigNameContains":{},"DefaultCodeRepositoryContains":{},"AdditionalCodeRepositoryEquals":{}}},"output":{"type":"structure","members":{"NextToken":{},"NotebookInstances":{"type":"list","member":{"type":"structure","required":["NotebookInstanceName","NotebookInstanceArn"],"members":{"NotebookInstanceName":{},"NotebookInstanceArn":{},"NotebookInstanceStatus":{},"Url":{},"InstanceType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"NotebookInstanceLifecycleConfigName":{},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"Sgq"}}}}}}},"ListPipelineExecutionSteps":{"input":{"type":"structure","members":{"PipelineExecutionArn":{},"NextToken":{},"MaxResults":{"type":"integer"},"SortOrder":{}}},"output":{"type":"structure","members":{"PipelineExecutionSteps":{"type":"list","member":{"type":"structure","members":{"StepName":{},"StepDisplayName":{},"StepDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StepStatus":{},"CacheHitResult":{"type":"structure","members":{"SourcePipelineExecutionArn":{}}},"AttemptCount":{"type":"integer"},"FailureReason":{},"Metadata":{"type":"structure","members":{"TrainingJob":{"type":"structure","members":{"Arn":{}}},"ProcessingJob":{"type":"structure","members":{"Arn":{}}},"TransformJob":{"type":"structure","members":{"Arn":{}}},"TuningJob":{"type":"structure","members":{"Arn":{}}},"Model":{"type":"structure","members":{"Arn":{}}},"RegisterModel":{"type":"structure","members":{"Arn":{}}},"Condition":{"type":"structure","members":{"Outcome":{}}},"Callback":{"type":"structure","members":{"CallbackToken":{},"SqsQueueUrl":{},"OutputParameters":{"shape":"S126"}}},"Lambda":{"type":"structure","members":{"Arn":{},"OutputParameters":{"shape":"S126"}}},"QualityCheck":{"type":"structure","members":{"CheckType":{},"BaselineUsedForDriftCheckStatistics":{},"BaselineUsedForDriftCheckConstraints":{},"CalculatedBaselineStatistics":{},"CalculatedBaselineConstraints":{},"ModelPackageGroupName":{},"ViolationReport":{},"CheckJobArn":{},"SkipCheck":{"type":"boolean"},"RegisterNewBaseline":{"type":"boolean"}}},"ClarifyCheck":{"type":"structure","members":{"CheckType":{},"BaselineUsedForDriftCheckConstraints":{},"CalculatedBaselineConstraints":{},"ModelPackageGroupName":{},"ViolationReport":{},"CheckJobArn":{},"SkipCheck":{"type":"boolean"},"RegisterNewBaseline":{"type":"boolean"}}},"EMR":{"type":"structure","members":{"ClusterId":{},"StepId":{},"StepName":{},"LogFilePath":{}}},"Fail":{"type":"structure","members":{"ErrorMessage":{}}}}}}}},"NextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["PipelineName"],"members":{"PipelineName":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"PipelineExecutionArn":{},"StartTime":{"type":"timestamp"},"PipelineExecutionStatus":{},"PipelineExecutionDescription":{},"PipelineExecutionDisplayName":{},"PipelineExecutionFailureReason":{}}}},"NextToken":{}}}},"ListPipelineParametersForExecution":{"input":{"type":"structure","required":["PipelineExecutionArn"],"members":{"PipelineExecutionArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PipelineParameters":{"shape":"S12l"},"NextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"PipelineNamePrefix":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PipelineSummaries":{"type":"list","member":{"type":"structure","members":{"PipelineArn":{},"PipelineName":{},"PipelineDisplayName":{},"PipelineDescription":{},"RoleArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastExecutionTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListProcessingJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ProcessingJobSummaries"],"members":{"ProcessingJobSummaries":{"type":"list","member":{"type":"structure","required":["ProcessingJobName","ProcessingJobArn","CreationTime","ProcessingJobStatus"],"members":{"ProcessingJobName":{},"ProcessingJobArn":{},"CreationTime":{"type":"timestamp"},"ProcessingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"ProcessingJobStatus":{},"FailureReason":{},"ExitMessage":{}}}},"NextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["ProjectSummaryList"],"members":{"ProjectSummaryList":{"type":"list","member":{"type":"structure","required":["ProjectName","ProjectArn","ProjectId","CreationTime","ProjectStatus"],"members":{"ProjectName":{},"ProjectDescription":{},"ProjectArn":{},"ProjectId":{},"CreationTime":{"type":"timestamp"},"ProjectStatus":{}}}},"NextToken":{}}}},"ListStudioLifecycleConfigs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"NameContains":{},"AppTypeEquals":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"ModifiedTimeBefore":{"type":"timestamp"},"ModifiedTimeAfter":{"type":"timestamp"},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"NextToken":{},"StudioLifecycleConfigs":{"type":"list","member":{"type":"structure","members":{"StudioLifecycleConfigArn":{},"StudioLifecycleConfigName":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"StudioLifecycleConfigAppType":{}}}}}}},"ListSubscribedWorkteams":{"input":{"type":"structure","members":{"NameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["SubscribedWorkteams"],"members":{"SubscribedWorkteams":{"type":"list","member":{"shape":"Stb"}},"NextToken":{}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"},"NextToken":{}}}},"ListTrainingJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["TrainingJobSummaries"],"members":{"TrainingJobSummaries":{"type":"list","member":{"type":"structure","required":["TrainingJobName","TrainingJobArn","CreationTime","TrainingJobStatus"],"members":{"TrainingJobName":{},"TrainingJobArn":{},"CreationTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TrainingJobStatus":{}}}},"NextToken":{}}}},"ListTrainingJobsForHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName"],"members":{"HyperParameterTuningJobName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["TrainingJobSummaries"],"members":{"TrainingJobSummaries":{"type":"list","member":{"shape":"Sqz"}},"NextToken":{}}}},"ListTransformJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["TransformJobSummaries"],"members":{"TransformJobSummaries":{"type":"list","member":{"type":"structure","required":["TransformJobName","TransformJobArn","CreationTime","TransformJobStatus"],"members":{"TransformJobName":{},"TransformJobArn":{},"CreationTime":{"type":"timestamp"},"TransformEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TransformJobStatus":{},"FailureReason":{}}}},"NextToken":{}}}},"ListTrialComponents":{"input":{"type":"structure","members":{"ExperimentName":{},"TrialName":{},"SourceArn":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrialComponentSummaries":{"type":"list","member":{"type":"structure","members":{"TrialComponentName":{},"TrialComponentArn":{},"DisplayName":{},"TrialComponentSource":{"shape":"Su2"},"Status":{"shape":"Sk9"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"}}}},"NextToken":{}}}},"ListTrials":{"input":{"type":"structure","members":{"ExperimentName":{},"TrialComponentName":{},"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"SortBy":{},"SortOrder":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrialSummaries":{"type":"list","member":{"type":"structure","members":{"TrialArn":{},"TrialName":{},"DisplayName":{},"TrialSource":{"shape":"Sty"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUserProfiles":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortOrder":{},"SortBy":{},"DomainIdEquals":{},"UserProfileNameContains":{}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"DomainId":{},"UserProfileName":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListWorkforces":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Workforces"],"members":{"Workforces":{"type":"list","member":{"shape":"Sue"}},"NextToken":{}}}},"ListWorkteams":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Workteams"],"members":{"Workteams":{"type":"list","member":{"shape":"Sui"}},"NextToken":{}}}},"PutModelPackageGroupPolicy":{"input":{"type":"structure","required":["ModelPackageGroupName","ResourcePolicy"],"members":{"ModelPackageGroupName":{},"ResourcePolicy":{}}},"output":{"type":"structure","required":["ModelPackageGroupArn"],"members":{"ModelPackageGroupArn":{}}}},"QueryLineage":{"input":{"type":"structure","required":["StartArns"],"members":{"StartArns":{"type":"list","member":{}},"Direction":{},"IncludeEdges":{"type":"boolean"},"Filters":{"type":"structure","members":{"Types":{"type":"list","member":{}},"LineageTypes":{"type":"list","member":{}},"CreatedBefore":{"type":"timestamp"},"CreatedAfter":{"type":"timestamp"},"ModifiedBefore":{"type":"timestamp"},"ModifiedAfter":{"type":"timestamp"},"Properties":{"type":"map","key":{},"value":{}}}},"MaxDepth":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Vertices":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Type":{},"LineageType":{}}}},"Edges":{"type":"list","member":{"type":"structure","members":{"SourceArn":{},"DestinationArn":{},"AssociationType":{}}}},"NextToken":{}}}},"RegisterDevices":{"input":{"type":"structure","required":["DeviceFleetName","Devices"],"members":{"DeviceFleetName":{},"Devices":{"shape":"S14x"},"Tags":{"shape":"S7"}}}},"RenderUiTemplate":{"input":{"type":"structure","required":["Task","RoleArn"],"members":{"UiTemplate":{"shape":"Sbd"},"Task":{"type":"structure","required":["Input"],"members":{"Input":{}}},"RoleArn":{},"HumanTaskUiArn":{}}},"output":{"type":"structure","required":["RenderedContent","Errors"],"members":{"RenderedContent":{},"Errors":{"type":"list","member":{"type":"structure","required":["Code","Message"],"members":{"Code":{},"Message":{}}}}}}},"RetryPipelineExecution":{"input":{"type":"structure","required":["PipelineExecutionArn","ClientRequestToken"],"members":{"PipelineExecutionArn":{},"ClientRequestToken":{"idempotencyToken":true},"ParallelismConfiguration":{"shape":"Sha"}}},"output":{"type":"structure","members":{"PipelineExecutionArn":{}}}},"Search":{"input":{"type":"structure","required":["Resource"],"members":{"Resource":{},"SearchExpression":{"shape":"S158"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"TrainingJob":{"shape":"S15l"},"Experiment":{"type":"structure","members":{"ExperimentName":{},"ExperimentArn":{},"DisplayName":{},"Source":{"shape":"Sqa"},"Description":{},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"Tags":{"shape":"S7"}}},"Trial":{"type":"structure","members":{"TrialName":{},"TrialArn":{},"DisplayName":{},"ExperimentName":{},"Source":{"shape":"Sty"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"MetadataProperties":{"shape":"S1q"},"Tags":{"shape":"S7"},"TrialComponentSummaries":{"type":"list","member":{"type":"structure","members":{"TrialComponentName":{},"TrialComponentArn":{},"TrialComponentSource":{"shape":"Su2"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"}}}}}},"TrialComponent":{"type":"structure","members":{"TrialComponentName":{},"DisplayName":{},"TrialComponentArn":{},"Source":{"shape":"Su2"},"Status":{"shape":"Sk9"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"Parameters":{"shape":"Skd"},"InputArtifacts":{"shape":"Skh"},"OutputArtifacts":{"shape":"Skh"},"Metrics":{"shape":"Su4"},"MetadataProperties":{"shape":"S1q"},"SourceDetail":{"type":"structure","members":{"SourceArn":{},"TrainingJob":{"shape":"S15l"},"ProcessingJob":{"type":"structure","members":{"ProcessingInputs":{"shape":"Shn"},"ProcessingOutputConfig":{"shape":"Sia"},"ProcessingJobName":{},"ProcessingResources":{"shape":"Sif"},"StoppingCondition":{"shape":"Sih"},"AppSpecification":{"shape":"Sij"},"Environment":{"shape":"Sil"},"NetworkConfig":{"shape":"Sgd"},"RoleArn":{},"ExperimentConfig":{"shape":"Sim"},"ProcessingJobArn":{},"ProcessingJobStatus":{},"ExitMessage":{},"FailureReason":{},"ProcessingEndTime":{"type":"timestamp"},"ProcessingStartTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"MonitoringScheduleArn":{},"AutoMLJobArn":{},"TrainingJobArn":{},"Tags":{"shape":"S7"}}},"TransformJob":{"type":"structure","members":{"TransformJobName":{},"TransformJobArn":{},"TransformJobStatus":{},"FailureReason":{},"ModelName":{},"MaxConcurrentTransforms":{"type":"integer"},"ModelClientConfig":{"shape":"Sjy"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S3o"},"TransformInput":{"shape":"S3r"},"TransformOutput":{"shape":"S3v"},"TransformResources":{"shape":"S3y"},"CreationTime":{"type":"timestamp"},"TransformStartTime":{"type":"timestamp"},"TransformEndTime":{"type":"timestamp"},"LabelingJobArn":{},"AutoMLJobArn":{},"DataProcessing":{"shape":"Sk1"},"ExperimentConfig":{"shape":"Sim"},"Tags":{"shape":"S7"}}}}},"LineageGroupArn":{},"Tags":{"shape":"S7"},"Parents":{"type":"list","member":{"type":"structure","members":{"TrialName":{},"ExperimentName":{}}}}}},"Endpoint":{"type":"structure","required":["EndpointName","EndpointArn","EndpointConfigName","EndpointStatus","CreationTime","LastModifiedTime"],"members":{"EndpointName":{},"EndpointArn":{},"EndpointConfigName":{},"ProductionVariants":{"shape":"Spr"},"DataCaptureConfig":{"shape":"Sq0"},"EndpointStatus":{},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"MonitoringSchedules":{"type":"list","member":{"type":"structure","members":{"MonitoringScheduleArn":{},"MonitoringScheduleName":{},"MonitoringScheduleStatus":{},"MonitoringType":{},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"MonitoringScheduleConfig":{"shape":"Sg5"},"EndpointName":{},"LastMonitoringExecutionSummary":{"shape":"Ssd"},"Tags":{"shape":"S7"}}}},"Tags":{"shape":"S7"}}},"ModelPackage":{"type":"structure","members":{"ModelPackageName":{},"ModelPackageGroupName":{},"ModelPackageVersion":{"type":"integer"},"ModelPackageArn":{},"ModelPackageDescription":{},"CreationTime":{"type":"timestamp"},"InferenceSpecification":{"shape":"Sr"},"SourceAlgorithmSpecification":{"shape":"Sf8"},"ValidationSpecification":{"shape":"Sf5"},"ModelPackageStatus":{},"ModelPackageStatusDetails":{"shape":"Ss0"},"CertifyForMarketplace":{"type":"boolean"},"ModelApprovalStatus":{},"CreatedBy":{"shape":"Sn8"},"MetadataProperties":{"shape":"S1q"},"ModelMetrics":{"shape":"Sfb"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"},"ApprovalDescription":{},"Domain":{},"Task":{},"SamplePayloadUrl":{},"AdditionalInferenceSpecifications":{"shape":"Sfr"},"Tags":{"shape":"S7"},"CustomerMetadataProperties":{"shape":"Sfi"},"DriftCheckBaselines":{"shape":"Sfl"}}},"ModelPackageGroup":{"type":"structure","members":{"ModelPackageGroupName":{},"ModelPackageGroupArn":{},"ModelPackageGroupDescription":{},"CreationTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"ModelPackageGroupStatus":{},"Tags":{"shape":"S7"}}},"Pipeline":{"type":"structure","members":{"PipelineArn":{},"PipelineName":{},"PipelineDisplayName":{},"PipelineDescription":{},"RoleArn":{},"PipelineStatus":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastRunTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedBy":{"shape":"Sn8"},"ParallelismConfiguration":{"shape":"Sha"},"Tags":{"shape":"S7"}}},"PipelineExecution":{"type":"structure","members":{"PipelineArn":{},"PipelineExecutionArn":{},"PipelineExecutionDisplayName":{},"PipelineExecutionStatus":{},"PipelineExecutionDescription":{},"PipelineExperimentConfig":{"shape":"Ssw"},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"CreatedBy":{"shape":"Sn8"},"LastModifiedBy":{"shape":"Sn8"},"ParallelismConfiguration":{"shape":"Sha"},"PipelineParameters":{"shape":"S12l"}}},"FeatureGroup":{"type":"structure","members":{"FeatureGroupArn":{},"FeatureGroupName":{},"RecordIdentifierFeatureName":{},"EventTimeFeatureName":{},"FeatureDefinitions":{"shape":"Sa8"},"CreationTime":{"type":"timestamp"},"OnlineStoreConfig":{"shape":"Sab"},"OfflineStoreConfig":{"shape":"Sad"},"RoleArn":{},"FeatureGroupStatus":{},"OfflineStoreStatus":{"shape":"Sqg"},"FailureReason":{},"Description":{},"Tags":{"shape":"S7"}}},"Project":{"type":"structure","members":{"ProjectArn":{},"ProjectName":{},"ProjectId":{},"ProjectDescription":{},"ServiceCatalogProvisioningDetails":{"shape":"Sir"},"ServiceCatalogProvisionedProductDetails":{"shape":"St4"},"ProjectStatus":{},"CreatedBy":{"shape":"Sn8"},"CreationTime":{"type":"timestamp"},"Tags":{"shape":"S7"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sn8"}}}}}},"NextToken":{}}}},"SendPipelineExecutionStepFailure":{"input":{"type":"structure","required":["CallbackToken"],"members":{"CallbackToken":{},"FailureReason":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PipelineExecutionArn":{}}}},"SendPipelineExecutionStepSuccess":{"input":{"type":"structure","required":["CallbackToken"],"members":{"CallbackToken":{},"OutputParameters":{"shape":"S126"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PipelineExecutionArn":{}}}},"StartMonitoringSchedule":{"input":{"type":"structure","required":["MonitoringScheduleName"],"members":{"MonitoringScheduleName":{}}}},"StartNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["PipelineName","ClientRequestToken"],"members":{"PipelineName":{},"PipelineExecutionDisplayName":{},"PipelineParameters":{"shape":"S12l"},"PipelineExecutionDescription":{},"ClientRequestToken":{"idempotencyToken":true},"ParallelismConfiguration":{"shape":"Sha"}}},"output":{"type":"structure","members":{"PipelineExecutionArn":{}}}},"StopAutoMLJob":{"input":{"type":"structure","required":["AutoMLJobName"],"members":{"AutoMLJobName":{}}}},"StopCompilationJob":{"input":{"type":"structure","required":["CompilationJobName"],"members":{"CompilationJobName":{}}}},"StopEdgePackagingJob":{"input":{"type":"structure","required":["EdgePackagingJobName"],"members":{"EdgePackagingJobName":{}}}},"StopHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName"],"members":{"HyperParameterTuningJobName":{}}}},"StopInferenceRecommendationsJob":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{}}}},"StopLabelingJob":{"input":{"type":"structure","required":["LabelingJobName"],"members":{"LabelingJobName":{}}}},"StopMonitoringSchedule":{"input":{"type":"structure","required":["MonitoringScheduleName"],"members":{"MonitoringScheduleName":{}}}},"StopNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}}},"StopPipelineExecution":{"input":{"type":"structure","required":["PipelineExecutionArn","ClientRequestToken"],"members":{"PipelineExecutionArn":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PipelineExecutionArn":{}}}},"StopProcessingJob":{"input":{"type":"structure","required":["ProcessingJobName"],"members":{"ProcessingJobName":{}}}},"StopTrainingJob":{"input":{"type":"structure","required":["TrainingJobName"],"members":{"TrainingJobName":{}}}},"StopTransformJob":{"input":{"type":"structure","required":["TransformJobName"],"members":{"TransformJobName":{}}}},"UpdateAction":{"input":{"type":"structure","required":["ActionName"],"members":{"ActionName":{},"Description":{},"Status":{},"Properties":{"shape":"S1o"},"PropertiesToRemove":{"shape":"S16r"}}},"output":{"type":"structure","members":{"ActionArn":{}}}},"UpdateAppImageConfig":{"input":{"type":"structure","required":["AppImageConfigName"],"members":{"AppImageConfigName":{},"KernelGatewayImageConfig":{"shape":"S4h"}}},"output":{"type":"structure","members":{"AppImageConfigArn":{}}}},"UpdateArtifact":{"input":{"type":"structure","required":["ArtifactArn"],"members":{"ArtifactArn":{},"ArtifactName":{},"Properties":{"shape":"S1o"},"PropertiesToRemove":{"shape":"S16r"}}},"output":{"type":"structure","members":{"ArtifactArn":{}}}},"UpdateCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName"],"members":{"CodeRepositoryName":{},"GitConfig":{"type":"structure","members":{"SecretArn":{}}}}},"output":{"type":"structure","required":["CodeRepositoryArn"],"members":{"CodeRepositoryArn":{}}}},"UpdateContext":{"input":{"type":"structure","required":["ContextName"],"members":{"ContextName":{},"Description":{},"Properties":{"shape":"S1o"},"PropertiesToRemove":{"shape":"S16r"}}},"output":{"type":"structure","members":{"ContextArn":{}}}},"UpdateDeviceFleet":{"input":{"type":"structure","required":["DeviceFleetName","OutputConfig"],"members":{"DeviceFleetName":{},"RoleArn":{},"Description":{},"OutputConfig":{"shape":"S7r"},"EnableIotRoleAlias":{"type":"boolean"}}}},"UpdateDevices":{"input":{"type":"structure","required":["DeviceFleetName","Devices"],"members":{"DeviceFleetName":{},"Devices":{"shape":"S14x"}}}},"UpdateDomain":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{},"DefaultUserSettings":{"shape":"S7x"},"DomainSettingsForUpdate":{"type":"structure","members":{"RStudioServerProDomainSettingsForUpdate":{"type":"structure","required":["DomainExecutionRoleArn"],"members":{"DomainExecutionRoleArn":{},"DefaultResourceSpec":{"shape":"S48"}}}}}}},"output":{"type":"structure","members":{"DomainArn":{}}}},"UpdateEndpoint":{"input":{"type":"structure","required":["EndpointName","EndpointConfigName"],"members":{"EndpointName":{},"EndpointConfigName":{},"RetainAllVariantProperties":{"type":"boolean"},"ExcludeRetainedVariantProperties":{"type":"list","member":{"type":"structure","required":["VariantPropertyType"],"members":{"VariantPropertyType":{}}}},"DeploymentConfig":{"shape":"S8q"},"RetainDeploymentConfig":{"type":"boolean"}}},"output":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"UpdateEndpointWeightsAndCapacities":{"input":{"type":"structure","required":["EndpointName","DesiredWeightsAndCapacities"],"members":{"EndpointName":{},"DesiredWeightsAndCapacities":{"type":"list","member":{"type":"structure","required":["VariantName"],"members":{"VariantName":{},"DesiredWeight":{"type":"float"},"DesiredInstanceCount":{"type":"integer"}}}}}},"output":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"UpdateExperiment":{"input":{"type":"structure","required":["ExperimentName"],"members":{"ExperimentName":{},"DisplayName":{},"Description":{}}},"output":{"type":"structure","members":{"ExperimentArn":{}}}},"UpdateImage":{"input":{"type":"structure","required":["ImageName"],"members":{"DeleteProperties":{"type":"list","member":{}},"Description":{},"DisplayName":{},"ImageName":{},"RoleArn":{}}},"output":{"type":"structure","members":{"ImageArn":{}}}},"UpdateModelPackage":{"input":{"type":"structure","required":["ModelPackageArn"],"members":{"ModelPackageArn":{},"ModelApprovalStatus":{},"ApprovalDescription":{},"CustomerMetadataProperties":{"shape":"Sfi"},"CustomerMetadataPropertiesToRemove":{"type":"list","member":{}},"AdditionalInferenceSpecificationsToAdd":{"shape":"Sfr"}}},"output":{"type":"structure","required":["ModelPackageArn"],"members":{"ModelPackageArn":{}}}},"UpdateMonitoringSchedule":{"input":{"type":"structure","required":["MonitoringScheduleName","MonitoringScheduleConfig"],"members":{"MonitoringScheduleName":{},"MonitoringScheduleConfig":{"shape":"Sg5"}}},"output":{"type":"structure","required":["MonitoringScheduleArn"],"members":{"MonitoringScheduleArn":{}}}},"UpdateNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{},"InstanceType":{},"RoleArn":{},"LifecycleConfigName":{},"DisassociateLifecycleConfig":{"type":"boolean"},"VolumeSizeInGB":{"type":"integer"},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"Sgq"},"AcceleratorTypes":{"shape":"Sgn"},"DisassociateAcceleratorTypes":{"type":"boolean"},"DisassociateDefaultCodeRepository":{"type":"boolean"},"DisassociateAdditionalCodeRepositories":{"type":"boolean"},"RootAccess":{}}},"output":{"type":"structure","members":{}}},"UpdateNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{},"OnCreate":{"shape":"Sgw"},"OnStart":{"shape":"Sgw"}}},"output":{"type":"structure","members":{}}},"UpdatePipeline":{"input":{"type":"structure","required":["PipelineName"],"members":{"PipelineName":{},"PipelineDisplayName":{},"PipelineDefinition":{},"PipelineDefinitionS3Location":{"shape":"Sh4"},"PipelineDescription":{},"RoleArn":{},"ParallelismConfiguration":{"shape":"Sha"}}},"output":{"type":"structure","members":{"PipelineArn":{}}}},"UpdatePipelineExecution":{"input":{"type":"structure","required":["PipelineExecutionArn"],"members":{"PipelineExecutionArn":{},"PipelineExecutionDescription":{},"PipelineExecutionDisplayName":{},"ParallelismConfiguration":{"shape":"Sha"}}},"output":{"type":"structure","members":{"PipelineExecutionArn":{}}}},"UpdateProject":{"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{},"ProjectDescription":{},"ServiceCatalogProvisioningUpdateDetails":{"type":"structure","members":{"ProvisioningArtifactId":{},"ProvisioningParameters":{"shape":"Sit"}}},"Tags":{"shape":"S7"}}},"output":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{}}}},"UpdateTrainingJob":{"input":{"type":"structure","required":["TrainingJobName"],"members":{"TrainingJobName":{},"ProfilerConfig":{"type":"structure","members":{"S3OutputPath":{},"ProfilingIntervalInMilliseconds":{"type":"long"},"ProfilingParameters":{"shape":"Sjo"},"DisableProfiler":{"type":"boolean"}}},"ProfilerRuleConfigurations":{"shape":"Sjp"}}},"output":{"type":"structure","required":["TrainingJobArn"],"members":{"TrainingJobArn":{}}}},"UpdateTrial":{"input":{"type":"structure","required":["TrialName"],"members":{"TrialName":{},"DisplayName":{}}},"output":{"type":"structure","members":{"TrialArn":{}}}},"UpdateTrialComponent":{"input":{"type":"structure","required":["TrialComponentName"],"members":{"TrialComponentName":{},"DisplayName":{},"Status":{"shape":"Sk9"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Parameters":{"shape":"Skd"},"ParametersToRemove":{"shape":"S18e"},"InputArtifacts":{"shape":"Skh"},"InputArtifactsToRemove":{"shape":"S18e"},"OutputArtifacts":{"shape":"Skh"},"OutputArtifactsToRemove":{"shape":"S18e"}}},"output":{"type":"structure","members":{"TrialComponentArn":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["DomainId","UserProfileName"],"members":{"DomainId":{},"UserProfileName":{},"UserSettings":{"shape":"S7x"}}},"output":{"type":"structure","members":{"UserProfileArn":{}}}},"UpdateWorkforce":{"input":{"type":"structure","required":["WorkforceName"],"members":{"WorkforceName":{},"SourceIpConfig":{"shape":"Sky"},"OidcConfig":{"shape":"Skv"}}},"output":{"type":"structure","required":["Workforce"],"members":{"Workforce":{"shape":"Sue"}}}},"UpdateWorkteam":{"input":{"type":"structure","required":["WorkteamName"],"members":{"WorkteamName":{},"MemberDefinitions":{"shape":"Sl6"},"Description":{},"NotificationConfiguration":{"shape":"Sle"}}},"output":{"type":"structure","required":["Workteam"],"members":{"Workteam":{"shape":"Sui"}}}}},"shapes":{"S7":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sr":{"type":"structure","required":["Containers","SupportedContentTypes","SupportedResponseMIMETypes"],"members":{"Containers":{"shape":"Ss"},"SupportedTransformInstanceTypes":{"shape":"S16"},"SupportedRealtimeInferenceInstanceTypes":{"shape":"S18"},"SupportedContentTypes":{"shape":"S1a"},"SupportedResponseMIMETypes":{"shape":"S1c"}}},"Ss":{"type":"list","member":{"type":"structure","required":["Image"],"members":{"ContainerHostname":{},"Image":{},"ImageDigest":{},"ModelDataUrl":{},"ProductId":{},"Environment":{"shape":"Sz"},"ModelInput":{"type":"structure","required":["DataInputConfig"],"members":{"DataInputConfig":{}}},"Framework":{},"FrameworkVersion":{},"NearestModelName":{}}}},"Sz":{"type":"map","key":{},"value":{}},"S16":{"type":"list","member":{}},"S18":{"type":"list","member":{}},"S1a":{"type":"list","member":{}},"S1c":{"type":"list","member":{}},"S1j":{"type":"structure","required":["SourceUri"],"members":{"SourceUri":{},"SourceType":{},"SourceId":{}}},"S1o":{"type":"map","key":{},"value":{}},"S1q":{"type":"structure","members":{"CommitId":{},"Repository":{},"GeneratedBy":{},"ProjectId":{}}},"S1v":{"type":"structure","required":["TrainingImage","SupportedTrainingInstanceTypes","TrainingChannels"],"members":{"TrainingImage":{},"TrainingImageDigest":{},"SupportedHyperParameters":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Description":{},"Type":{},"Range":{"type":"structure","members":{"IntegerParameterRangeSpecification":{"type":"structure","required":["MinValue","MaxValue"],"members":{"MinValue":{},"MaxValue":{}}},"ContinuousParameterRangeSpecification":{"type":"structure","required":["MinValue","MaxValue"],"members":{"MinValue":{},"MaxValue":{}}},"CategoricalParameterRangeSpecification":{"type":"structure","required":["Values"],"members":{"Values":{"shape":"S25"}}}}},"IsTunable":{"type":"boolean"},"IsRequired":{"type":"boolean"},"DefaultValue":{}}}},"SupportedTrainingInstanceTypes":{"type":"list","member":{}},"SupportsDistributedTraining":{"type":"boolean"},"MetricDefinitions":{"shape":"S2a"},"TrainingChannels":{"type":"list","member":{"type":"structure","required":["Name","SupportedContentTypes","SupportedInputModes"],"members":{"Name":{},"Description":{},"IsRequired":{"type":"boolean"},"SupportedContentTypes":{"shape":"S1a"},"SupportedCompressionTypes":{"type":"list","member":{}},"SupportedInputModes":{"type":"list","member":{}}}}},"SupportedTuningJobObjectiveMetrics":{"type":"list","member":{"shape":"S2m"}}}},"S25":{"type":"list","member":{}},"S2a":{"type":"list","member":{"type":"structure","required":["Name","Regex"],"members":{"Name":{},"Regex":{}}}},"S2m":{"type":"structure","required":["Type","MetricName"],"members":{"Type":{},"MetricName":{}}},"S2o":{"type":"structure","required":["ValidationRole","ValidationProfiles"],"members":{"ValidationRole":{},"ValidationProfiles":{"type":"list","member":{"type":"structure","required":["ProfileName","TrainingJobDefinition"],"members":{"ProfileName":{},"TrainingJobDefinition":{"type":"structure","required":["TrainingInputMode","InputDataConfig","OutputDataConfig","ResourceConfig","StoppingCondition"],"members":{"TrainingInputMode":{},"HyperParameters":{"shape":"S2t"},"InputDataConfig":{"shape":"S2v"},"OutputDataConfig":{"shape":"S3c"},"ResourceConfig":{"shape":"S3e"},"StoppingCondition":{"shape":"S3h"}}},"TransformJobDefinition":{"shape":"S3k"}}}}}},"S2t":{"type":"map","key":{},"value":{}},"S2v":{"type":"list","member":{"type":"structure","required":["ChannelName","DataSource"],"members":{"ChannelName":{},"DataSource":{"type":"structure","members":{"S3DataSource":{"type":"structure","required":["S3DataType","S3Uri"],"members":{"S3DataType":{},"S3Uri":{},"S3DataDistributionType":{},"AttributeNames":{"type":"list","member":{}}}},"FileSystemDataSource":{"type":"structure","required":["FileSystemId","FileSystemAccessMode","FileSystemType","DirectoryPath"],"members":{"FileSystemId":{},"FileSystemAccessMode":{},"FileSystemType":{},"DirectoryPath":{}}}}},"ContentType":{},"CompressionType":{},"RecordWrapperType":{},"InputMode":{},"ShuffleConfig":{"type":"structure","required":["Seed"],"members":{"Seed":{"type":"long"}}}}}},"S3c":{"type":"structure","required":["S3OutputPath"],"members":{"KmsKeyId":{},"S3OutputPath":{}}},"S3e":{"type":"structure","required":["InstanceType","InstanceCount","VolumeSizeInGB"],"members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"VolumeSizeInGB":{"type":"integer"},"VolumeKmsKeyId":{}}},"S3h":{"type":"structure","members":{"MaxRuntimeInSeconds":{"type":"integer"},"MaxWaitTimeInSeconds":{"type":"integer"}}},"S3k":{"type":"structure","required":["TransformInput","TransformOutput","TransformResources"],"members":{"MaxConcurrentTransforms":{"type":"integer"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S3o"},"TransformInput":{"shape":"S3r"},"TransformOutput":{"shape":"S3v"},"TransformResources":{"shape":"S3y"}}},"S3o":{"type":"map","key":{},"value":{}},"S3r":{"type":"structure","required":["DataSource"],"members":{"DataSource":{"type":"structure","required":["S3DataSource"],"members":{"S3DataSource":{"type":"structure","required":["S3DataType","S3Uri"],"members":{"S3DataType":{},"S3Uri":{}}}}},"ContentType":{},"CompressionType":{},"SplitType":{}}},"S3v":{"type":"structure","required":["S3OutputPath"],"members":{"S3OutputPath":{},"Accept":{},"AssembleWith":{},"KmsKeyId":{}}},"S3y":{"type":"structure","required":["InstanceType","InstanceCount"],"members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"VolumeKmsKeyId":{}}},"S48":{"type":"structure","members":{"SageMakerImageArn":{},"SageMakerImageVersionArn":{},"InstanceType":{},"LifecycleConfigArn":{}}},"S4h":{"type":"structure","required":["KernelSpecs"],"members":{"KernelSpecs":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"DisplayName":{}}}},"FileSystemConfig":{"type":"structure","members":{"MountPath":{},"DefaultUid":{"type":"integer"},"DefaultGid":{"type":"integer"}}}}},"S4t":{"type":"structure","required":["SourceUri"],"members":{"SourceUri":{},"SourceTypes":{"type":"list","member":{"type":"structure","required":["SourceIdType","Value"],"members":{"SourceIdType":{},"Value":{}}}}}},"S51":{"type":"list","member":{"type":"structure","required":["DataSource","TargetAttributeName"],"members":{"DataSource":{"type":"structure","required":["S3DataSource"],"members":{"S3DataSource":{"type":"structure","required":["S3DataType","S3Uri"],"members":{"S3DataType":{},"S3Uri":{}}}}},"CompressionType":{},"TargetAttributeName":{},"ContentType":{},"ChannelType":{}}}},"S58":{"type":"structure","required":["S3OutputPath"],"members":{"KmsKeyId":{},"S3OutputPath":{}}},"S5a":{"type":"structure","required":["MetricName"],"members":{"MetricName":{}}},"S5c":{"type":"structure","members":{"CompletionCriteria":{"shape":"S5d"},"SecurityConfig":{"type":"structure","members":{"VolumeKmsKeyId":{},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"VpcConfig":{"shape":"S5i"}}},"DataSplitConfig":{"type":"structure","members":{"ValidationFraction":{"type":"float"}}}}},"S5d":{"type":"structure","members":{"MaxCandidates":{"type":"integer"},"MaxRuntimePerTrainingJobInSeconds":{"type":"integer"},"MaxAutoMLJobRuntimeInSeconds":{"type":"integer"}}},"S5i":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"shape":"S5l"}}},"S5l":{"type":"list","member":{}},"S5q":{"type":"structure","members":{"AutoGenerateEndpointName":{"type":"boolean"},"EndpointName":{}}},"S5w":{"type":"structure","required":["RepositoryUrl"],"members":{"RepositoryUrl":{},"Branch":{},"SecretArn":{}}},"S63":{"type":"structure","required":["S3Uri","DataInputConfig","Framework"],"members":{"S3Uri":{},"DataInputConfig":{},"Framework":{},"FrameworkVersion":{}}},"S65":{"type":"structure","required":["S3OutputLocation"],"members":{"S3OutputLocation":{},"TargetDevice":{},"TargetPlatform":{"type":"structure","required":["Os","Arch"],"members":{"Os":{},"Arch":{},"Accelerator":{}}},"CompilerOptions":{},"KmsKeyId":{}}},"S6c":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"type":"list","member":{}}}},"S6k":{"type":"structure","required":["SourceUri"],"members":{"SourceUri":{},"SourceType":{},"SourceId":{}}},"S6p":{"type":"structure","members":{"BaseliningJobName":{},"ConstraintsResource":{"shape":"S6r"},"StatisticsResource":{"shape":"S6s"}}},"S6r":{"type":"structure","members":{"S3Uri":{}}},"S6s":{"type":"structure","members":{"S3Uri":{}}},"S6t":{"type":"structure","required":["ImageUri"],"members":{"ImageUri":{},"ContainerEntrypoint":{"shape":"S6v"},"ContainerArguments":{"shape":"S6x"},"RecordPreprocessorSourceUri":{},"PostAnalyticsProcessorSourceUri":{},"Environment":{"shape":"S6z"}}},"S6v":{"type":"list","member":{}},"S6x":{"type":"list","member":{}},"S6z":{"type":"map","key":{},"value":{}},"S72":{"type":"structure","required":["EndpointInput"],"members":{"EndpointInput":{"shape":"S73"}}},"S73":{"type":"structure","required":["EndpointName","LocalPath"],"members":{"EndpointName":{},"LocalPath":{},"S3InputMode":{},"S3DataDistributionType":{},"FeaturesAttribute":{},"InferenceAttribute":{},"ProbabilityAttribute":{},"ProbabilityThresholdAttribute":{"type":"double"},"StartTimeOffset":{},"EndTimeOffset":{}}},"S79":{"type":"structure","required":["MonitoringOutputs"],"members":{"MonitoringOutputs":{"type":"list","member":{"type":"structure","required":["S3Output"],"members":{"S3Output":{"type":"structure","required":["S3Uri","LocalPath"],"members":{"S3Uri":{},"LocalPath":{},"S3UploadMode":{}}}}}},"KmsKeyId":{}}},"S7f":{"type":"structure","required":["ClusterConfig"],"members":{"ClusterConfig":{"type":"structure","required":["InstanceCount","InstanceType","VolumeSizeInGB"],"members":{"InstanceCount":{"type":"integer"},"InstanceType":{},"VolumeSizeInGB":{"type":"integer"},"VolumeKmsKeyId":{}}}}},"S7k":{"type":"structure","members":{"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableNetworkIsolation":{"type":"boolean"},"VpcConfig":{"shape":"S5i"}}},"S7l":{"type":"structure","required":["MaxRuntimeInSeconds"],"members":{"MaxRuntimeInSeconds":{"type":"integer"}}},"S7r":{"type":"structure","required":["S3OutputLocation"],"members":{"S3OutputLocation":{},"KmsKeyId":{},"PresetDeploymentType":{},"PresetDeploymentConfig":{}}},"S7x":{"type":"structure","members":{"ExecutionRole":{},"SecurityGroups":{"shape":"S7y"},"SharingSettings":{"type":"structure","members":{"NotebookOutputOption":{},"S3OutputPath":{},"S3KmsKeyId":{}}},"JupyterServerAppSettings":{"type":"structure","members":{"DefaultResourceSpec":{"shape":"S48"},"LifecycleConfigArns":{"shape":"S82"}}},"KernelGatewayAppSettings":{"type":"structure","members":{"DefaultResourceSpec":{"shape":"S48"},"CustomImages":{"shape":"S84"},"LifecycleConfigArns":{"shape":"S82"}}},"TensorBoardAppSettings":{"type":"structure","members":{"DefaultResourceSpec":{"shape":"S48"}}},"RStudioServerProAppSettings":{"type":"structure","members":{"AccessStatus":{},"UserGroup":{}}},"RSessionAppSettings":{"type":"structure","members":{"DefaultResourceSpec":{"shape":"S48"},"CustomImages":{"shape":"S84"}}}}},"S7y":{"type":"list","member":{}},"S82":{"type":"list","member":{}},"S84":{"type":"list","member":{"type":"structure","required":["ImageName","AppImageConfigName"],"members":{"ImageName":{},"ImageVersionNumber":{"type":"integer"},"AppImageConfigName":{}}}},"S8g":{"type":"structure","members":{"SecurityGroupIds":{"type":"list","member":{}},"RStudioServerProDomainSettings":{"type":"structure","required":["DomainExecutionRoleArn"],"members":{"DomainExecutionRoleArn":{},"RStudioConnectUrl":{},"RStudioPackageManagerUrl":{},"DefaultResourceSpec":{"shape":"S48"}}}}},"S8q":{"type":"structure","required":["BlueGreenUpdatePolicy"],"members":{"BlueGreenUpdatePolicy":{"type":"structure","required":["TrafficRoutingConfiguration"],"members":{"TrafficRoutingConfiguration":{"type":"structure","required":["Type","WaitIntervalInSeconds"],"members":{"Type":{},"WaitIntervalInSeconds":{"type":"integer"},"CanarySize":{"shape":"S8v"},"LinearStepSize":{"shape":"S8v"}}},"TerminationWaitInSeconds":{"type":"integer"},"MaximumExecutionTimeoutInSeconds":{"type":"integer"}}},"AutoRollbackConfiguration":{"type":"structure","members":{"Alarms":{"type":"list","member":{"type":"structure","members":{"AlarmName":{}}}}}}}},"S8v":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"integer"}}},"S97":{"type":"list","member":{"type":"structure","required":["VariantName","ModelName"],"members":{"VariantName":{},"ModelName":{},"InitialInstanceCount":{"type":"integer"},"InstanceType":{},"InitialVariantWeight":{"type":"float"},"AcceleratorType":{},"CoreDumpConfig":{"type":"structure","required":["DestinationS3Uri"],"members":{"DestinationS3Uri":{},"KmsKeyId":{}}},"ServerlessConfig":{"shape":"S9g"}}}},"S9g":{"type":"structure","required":["MemorySizeInMB","MaxConcurrency"],"members":{"MemorySizeInMB":{"type":"integer"},"MaxConcurrency":{"type":"integer"}}},"S9j":{"type":"structure","required":["InitialSamplingPercentage","DestinationS3Uri","CaptureOptions"],"members":{"EnableCapture":{"type":"boolean"},"InitialSamplingPercentage":{"type":"integer"},"DestinationS3Uri":{},"KmsKeyId":{},"CaptureOptions":{"type":"list","member":{"type":"structure","required":["CaptureMode"],"members":{"CaptureMode":{}}}},"CaptureContentTypeHeader":{"type":"structure","members":{"CsvContentTypes":{"type":"list","member":{}},"JsonContentTypes":{"type":"list","member":{}}}}}},"S9u":{"type":"structure","required":["OutputConfig"],"members":{"ClientConfig":{"type":"structure","members":{"MaxConcurrentInvocationsPerInstance":{"type":"integer"}}},"OutputConfig":{"type":"structure","required":["S3OutputPath"],"members":{"KmsKeyId":{},"S3OutputPath":{},"NotificationConfig":{"type":"structure","members":{"SuccessTopic":{},"ErrorTopic":{}}}}}}},"Sa8":{"type":"list","member":{"type":"structure","members":{"FeatureName":{},"FeatureType":{}}}},"Sab":{"type":"structure","members":{"SecurityConfig":{"type":"structure","members":{"KmsKeyId":{}}},"EnableOnlineStore":{"type":"boolean"}}},"Sad":{"type":"structure","required":["S3StorageConfig"],"members":{"S3StorageConfig":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{},"ResolvedOutputS3Uri":{}}},"DisableGlueTableCreation":{"type":"boolean"},"DataCatalogConfig":{"type":"structure","required":["TableName","Catalog","Database"],"members":{"TableName":{},"Catalog":{},"Database":{}}}}},"Sao":{"type":"structure","required":["AwsManagedHumanLoopRequestSource"],"members":{"AwsManagedHumanLoopRequestSource":{}}},"Saq":{"type":"structure","required":["HumanLoopActivationConditionsConfig"],"members":{"HumanLoopActivationConditionsConfig":{"type":"structure","required":["HumanLoopActivationConditions"],"members":{"HumanLoopActivationConditions":{"jsonvalue":true}}}}},"Sat":{"type":"structure","required":["WorkteamArn","HumanTaskUiArn","TaskTitle","TaskDescription","TaskCount"],"members":{"WorkteamArn":{},"HumanTaskUiArn":{},"TaskTitle":{},"TaskDescription":{},"TaskCount":{"type":"integer"},"TaskAvailabilityLifetimeInSeconds":{"type":"integer"},"TaskTimeLimitInSeconds":{"type":"integer"},"TaskKeywords":{"type":"list","member":{}},"PublicWorkforceTaskPrice":{"shape":"Sb3"}}},"Sb3":{"type":"structure","members":{"AmountInUsd":{"type":"structure","members":{"Dollars":{"type":"integer"},"Cents":{"type":"integer"},"TenthFractionsOfACent":{"type":"integer"}}}}},"Sb8":{"type":"structure","required":["S3OutputPath"],"members":{"S3OutputPath":{},"KmsKeyId":{}}},"Sbd":{"type":"structure","required":["Content"],"members":{"Content":{}}},"Sbi":{"type":"structure","required":["Strategy","ResourceLimits"],"members":{"Strategy":{},"HyperParameterTuningJobObjective":{"shape":"S2m"},"ResourceLimits":{"shape":"Sbk"},"ParameterRanges":{"shape":"Sbn"},"TrainingJobEarlyStoppingType":{},"TuningJobCompletionCriteria":{"type":"structure","required":["TargetObjectiveMetricValue"],"members":{"TargetObjectiveMetricValue":{"type":"float"}}}}},"Sbk":{"type":"structure","required":["MaxNumberOfTrainingJobs","MaxParallelTrainingJobs"],"members":{"MaxNumberOfTrainingJobs":{"type":"integer"},"MaxParallelTrainingJobs":{"type":"integer"}}},"Sbn":{"type":"structure","members":{"IntegerParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MinValue","MaxValue"],"members":{"Name":{},"MinValue":{},"MaxValue":{},"ScalingType":{}}}},"ContinuousParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MinValue","MaxValue"],"members":{"Name":{},"MinValue":{},"MaxValue":{},"ScalingType":{}}}},"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S25"}}}}}},"Sbz":{"type":"structure","required":["AlgorithmSpecification","RoleArn","OutputDataConfig","ResourceConfig","StoppingCondition"],"members":{"DefinitionName":{},"TuningObjective":{"shape":"S2m"},"HyperParameterRanges":{"shape":"Sbn"},"StaticHyperParameters":{"shape":"S2t"},"AlgorithmSpecification":{"type":"structure","required":["TrainingInputMode"],"members":{"TrainingImage":{},"TrainingInputMode":{},"AlgorithmName":{},"MetricDefinitions":{"shape":"S2a"}}},"RoleArn":{},"InputDataConfig":{"shape":"S2v"},"VpcConfig":{"shape":"S5i"},"OutputDataConfig":{"shape":"S3c"},"ResourceConfig":{"shape":"S3e"},"StoppingCondition":{"shape":"S3h"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"Sc4"},"RetryStrategy":{"shape":"Sc5"}}},"Sc4":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"LocalPath":{}}},"Sc5":{"type":"structure","required":["MaximumRetryAttempts"],"members":{"MaximumRetryAttempts":{"type":"integer"}}},"Sc7":{"type":"list","member":{"shape":"Sbz"}},"Sc8":{"type":"structure","required":["ParentHyperParameterTuningJobs","WarmStartType"],"members":{"ParentHyperParameterTuningJobs":{"type":"list","member":{"type":"structure","members":{"HyperParameterTuningJobName":{}}}},"WarmStartType":{}}},"Scp":{"type":"structure","required":["ModelPackageVersionArn"],"members":{"ModelPackageVersionArn":{},"JobDurationInSeconds":{"type":"integer"},"TrafficPattern":{"type":"structure","members":{"TrafficType":{},"Phases":{"type":"list","member":{"type":"structure","members":{"InitialNumberOfUsers":{"type":"integer"},"SpawnRate":{"type":"integer"},"DurationInSeconds":{"type":"integer"}}}}}},"ResourceLimit":{"type":"structure","members":{"MaxNumberOfTests":{"type":"integer"},"MaxParallelOfTests":{"type":"integer"}}},"EndpointConfigurations":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"InferenceSpecificationName":{},"EnvironmentParameterRanges":{"type":"structure","members":{"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{"type":"list","member":{}}}}}}}}}},"VolumeKmsKeyId":{}}},"Sdb":{"type":"structure","members":{"MaxInvocations":{"type":"integer"},"ModelLatencyThresholds":{"type":"list","member":{"type":"structure","members":{"Percentile":{},"ValueInMilliseconds":{"type":"integer"}}}}}},"Sdm":{"type":"structure","required":["DataSource"],"members":{"DataSource":{"type":"structure","members":{"S3DataSource":{"type":"structure","required":["ManifestS3Uri"],"members":{"ManifestS3Uri":{}}},"SnsDataSource":{"type":"structure","required":["SnsTopicArn"],"members":{"SnsTopicArn":{}}}}},"DataAttributes":{"type":"structure","members":{"ContentClassifiers":{"type":"list","member":{}}}}}},"Sdt":{"type":"structure","required":["S3OutputPath"],"members":{"S3OutputPath":{},"KmsKeyId":{},"SnsTopicArn":{}}},"Sdu":{"type":"structure","members":{"MaxHumanLabeledObjectCount":{"type":"integer"},"MaxPercentageOfInputDatasetLabeled":{"type":"integer"}}},"Sdx":{"type":"structure","required":["LabelingJobAlgorithmSpecificationArn"],"members":{"LabelingJobAlgorithmSpecificationArn":{},"InitialActiveLearningModelArn":{},"LabelingJobResourceConfig":{"type":"structure","members":{"VolumeKmsKeyId":{}}}}},"Se1":{"type":"structure","required":["WorkteamArn","UiConfig","PreHumanTaskLambdaArn","TaskTitle","TaskDescription","NumberOfHumanWorkersPerDataObject","TaskTimeLimitInSeconds","AnnotationConsolidationConfig"],"members":{"WorkteamArn":{},"UiConfig":{"type":"structure","members":{"UiTemplateS3Uri":{},"HumanTaskUiArn":{}}},"PreHumanTaskLambdaArn":{},"TaskKeywords":{"type":"list","member":{}},"TaskTitle":{},"TaskDescription":{},"NumberOfHumanWorkersPerDataObject":{"type":"integer"},"TaskTimeLimitInSeconds":{"type":"integer"},"TaskAvailabilityLifetimeInSeconds":{"type":"integer"},"MaxConcurrentTaskCount":{"type":"integer"},"AnnotationConsolidationConfig":{"type":"structure","required":["AnnotationConsolidationLambdaArn"],"members":{"AnnotationConsolidationLambdaArn":{}}},"PublicWorkforceTaskPrice":{"shape":"Sb3"}}},"Seg":{"type":"structure","members":{"ContainerHostname":{},"Image":{},"ImageConfig":{"type":"structure","required":["RepositoryAccessMode"],"members":{"RepositoryAccessMode":{},"RepositoryAuthConfig":{"type":"structure","required":["RepositoryCredentialsProviderArn"],"members":{"RepositoryCredentialsProviderArn":{}}}}},"Mode":{},"ModelDataUrl":{},"Environment":{"shape":"Sz"},"ModelPackageName":{},"InferenceSpecificationName":{},"MultiModelConfig":{"type":"structure","members":{"ModelCacheSetting":{}}}}},"Sep":{"type":"list","member":{"shape":"Seg"}},"Seq":{"type":"structure","required":["Mode"],"members":{"Mode":{}}},"Seu":{"type":"structure","members":{"BaseliningJobName":{},"ConstraintsResource":{"shape":"S6r"}}},"Sev":{"type":"structure","required":["ImageUri","ConfigUri"],"members":{"ImageUri":{},"ConfigUri":{},"Environment":{"shape":"S6z"}}},"Sew":{"type":"structure","required":["EndpointInput","GroundTruthS3Input"],"members":{"EndpointInput":{"shape":"S73"},"GroundTruthS3Input":{"shape":"Sex"}}},"Sex":{"type":"structure","members":{"S3Uri":{}}},"Sf0":{"type":"structure","members":{"BaseliningJobName":{},"ConstraintsResource":{"shape":"S6r"}}},"Sf1":{"type":"structure","required":["ImageUri","ConfigUri"],"members":{"ImageUri":{},"ConfigUri":{},"Environment":{"shape":"S6z"}}},"Sf2":{"type":"structure","required":["EndpointInput"],"members":{"EndpointInput":{"shape":"S73"}}},"Sf5":{"type":"structure","required":["ValidationRole","ValidationProfiles"],"members":{"ValidationRole":{},"ValidationProfiles":{"type":"list","member":{"type":"structure","required":["ProfileName","TransformJobDefinition"],"members":{"ProfileName":{},"TransformJobDefinition":{"shape":"S3k"}}}}}},"Sf8":{"type":"structure","required":["SourceAlgorithms"],"members":{"SourceAlgorithms":{"type":"list","member":{"type":"structure","required":["AlgorithmName"],"members":{"ModelDataUrl":{},"AlgorithmName":{}}}}}},"Sfb":{"type":"structure","members":{"ModelQuality":{"type":"structure","members":{"Statistics":{"shape":"Sfd"},"Constraints":{"shape":"Sfd"}}},"ModelDataQuality":{"type":"structure","members":{"Statistics":{"shape":"Sfd"},"Constraints":{"shape":"Sfd"}}},"Bias":{"type":"structure","members":{"Report":{"shape":"Sfd"},"PreTrainingReport":{"shape":"Sfd"},"PostTrainingReport":{"shape":"Sfd"}}},"Explainability":{"type":"structure","members":{"Report":{"shape":"Sfd"}}}}},"Sfd":{"type":"structure","required":["ContentType","S3Uri"],"members":{"ContentType":{},"ContentDigest":{},"S3Uri":{}}},"Sfi":{"type":"map","key":{},"value":{}},"Sfl":{"type":"structure","members":{"Bias":{"type":"structure","members":{"ConfigFile":{"shape":"Sfn"},"PreTrainingConstraints":{"shape":"Sfd"},"PostTrainingConstraints":{"shape":"Sfd"}}},"Explainability":{"type":"structure","members":{"Constraints":{"shape":"Sfd"},"ConfigFile":{"shape":"Sfn"}}},"ModelQuality":{"type":"structure","members":{"Statistics":{"shape":"Sfd"},"Constraints":{"shape":"Sfd"}}},"ModelDataQuality":{"type":"structure","members":{"Statistics":{"shape":"Sfd"},"Constraints":{"shape":"Sfd"}}}}},"Sfn":{"type":"structure","required":["S3Uri"],"members":{"ContentType":{},"ContentDigest":{},"S3Uri":{}}},"Sfr":{"type":"list","member":{"type":"structure","required":["Name","Containers"],"members":{"Name":{},"Description":{},"Containers":{"shape":"Ss"},"SupportedTransformInstanceTypes":{"shape":"S16"},"SupportedRealtimeInferenceInstanceTypes":{"shape":"S18"},"SupportedContentTypes":{"shape":"S1a"},"SupportedResponseMIMETypes":{"shape":"S1c"}}}},"Sfy":{"type":"structure","members":{"BaseliningJobName":{},"ConstraintsResource":{"shape":"S6r"}}},"Sfz":{"type":"structure","required":["ImageUri"],"members":{"ImageUri":{},"ContainerEntrypoint":{"shape":"S6v"},"ContainerArguments":{"shape":"S6x"},"RecordPreprocessorSourceUri":{},"PostAnalyticsProcessorSourceUri":{},"ProblemType":{},"Environment":{"shape":"S6z"}}},"Sg1":{"type":"structure","required":["EndpointInput","GroundTruthS3Input"],"members":{"EndpointInput":{"shape":"S73"},"GroundTruthS3Input":{"shape":"Sex"}}},"Sg5":{"type":"structure","members":{"ScheduleConfig":{"type":"structure","required":["ScheduleExpression"],"members":{"ScheduleExpression":{}}},"MonitoringJobDefinition":{"type":"structure","required":["MonitoringInputs","MonitoringOutputConfig","MonitoringResources","MonitoringAppSpecification","RoleArn"],"members":{"BaselineConfig":{"type":"structure","members":{"BaseliningJobName":{},"ConstraintsResource":{"shape":"S6r"},"StatisticsResource":{"shape":"S6s"}}},"MonitoringInputs":{"type":"list","member":{"type":"structure","required":["EndpointInput"],"members":{"EndpointInput":{"shape":"S73"}}}},"MonitoringOutputConfig":{"shape":"S79"},"MonitoringResources":{"shape":"S7f"},"MonitoringAppSpecification":{"type":"structure","required":["ImageUri"],"members":{"ImageUri":{},"ContainerEntrypoint":{"shape":"S6v"},"ContainerArguments":{"shape":"S6x"},"RecordPreprocessorSourceUri":{},"PostAnalyticsProcessorSourceUri":{}}},"StoppingCondition":{"shape":"S7l"},"Environment":{"shape":"S6z"},"NetworkConfig":{"shape":"Sgd"},"RoleArn":{}}},"MonitoringJobDefinitionName":{},"MonitoringType":{}}},"Sgd":{"type":"structure","members":{"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableNetworkIsolation":{"type":"boolean"},"VpcConfig":{"shape":"S5i"}}},"Sgn":{"type":"list","member":{}},"Sgq":{"type":"list","member":{}},"Sgw":{"type":"list","member":{"type":"structure","members":{"Content":{}}}},"Sh4":{"type":"structure","required":["Bucket","ObjectKey"],"members":{"Bucket":{},"ObjectKey":{},"VersionId":{}}},"Sha":{"type":"structure","required":["MaxParallelExecutionSteps"],"members":{"MaxParallelExecutionSteps":{"type":"integer"}}},"Shn":{"type":"list","member":{"type":"structure","required":["InputName"],"members":{"InputName":{},"AppManaged":{"type":"boolean"},"S3Input":{"type":"structure","required":["S3Uri","S3DataType"],"members":{"S3Uri":{},"LocalPath":{},"S3DataType":{},"S3InputMode":{},"S3DataDistributionType":{},"S3CompressionType":{}}},"DatasetDefinition":{"type":"structure","members":{"AthenaDatasetDefinition":{"type":"structure","required":["Catalog","Database","QueryString","OutputS3Uri","OutputFormat"],"members":{"Catalog":{},"Database":{},"QueryString":{},"WorkGroup":{},"OutputS3Uri":{},"KmsKeyId":{},"OutputFormat":{},"OutputCompression":{}}},"RedshiftDatasetDefinition":{"type":"structure","required":["ClusterId","Database","DbUser","QueryString","ClusterRoleArn","OutputS3Uri","OutputFormat"],"members":{"ClusterId":{},"Database":{},"DbUser":{},"QueryString":{},"ClusterRoleArn":{},"OutputS3Uri":{},"KmsKeyId":{},"OutputFormat":{},"OutputCompression":{}}},"LocalPath":{},"DataDistributionType":{},"InputMode":{}}}}}},"Sia":{"type":"structure","required":["Outputs"],"members":{"Outputs":{"type":"list","member":{"type":"structure","required":["OutputName"],"members":{"OutputName":{},"S3Output":{"type":"structure","required":["S3Uri","LocalPath","S3UploadMode"],"members":{"S3Uri":{},"LocalPath":{},"S3UploadMode":{}}},"FeatureStoreOutput":{"type":"structure","required":["FeatureGroupName"],"members":{"FeatureGroupName":{}}},"AppManaged":{"type":"boolean"}}}},"KmsKeyId":{}}},"Sif":{"type":"structure","required":["ClusterConfig"],"members":{"ClusterConfig":{"type":"structure","required":["InstanceCount","InstanceType","VolumeSizeInGB"],"members":{"InstanceCount":{"type":"integer"},"InstanceType":{},"VolumeSizeInGB":{"type":"integer"},"VolumeKmsKeyId":{}}}}},"Sih":{"type":"structure","required":["MaxRuntimeInSeconds"],"members":{"MaxRuntimeInSeconds":{"type":"integer"}}},"Sij":{"type":"structure","required":["ImageUri"],"members":{"ImageUri":{},"ContainerEntrypoint":{"shape":"S6v"},"ContainerArguments":{"type":"list","member":{}}}},"Sil":{"type":"map","key":{},"value":{}},"Sim":{"type":"structure","members":{"ExperimentName":{},"TrialName":{},"TrialComponentDisplayName":{}}},"Sir":{"type":"structure","required":["ProductId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisioningParameters":{"shape":"Sit"}}},"Sit":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sj7":{"type":"structure","required":["TrainingInputMode"],"members":{"TrainingImage":{},"AlgorithmName":{},"TrainingInputMode":{},"MetricDefinitions":{"shape":"S2a"},"EnableSageMakerMetricsTimeSeries":{"type":"boolean"}}},"Sj8":{"type":"structure","required":["S3OutputPath"],"members":{"LocalPath":{},"S3OutputPath":{},"HookParameters":{"type":"map","key":{},"value":{}},"CollectionConfigurations":{"type":"list","member":{"type":"structure","members":{"CollectionName":{},"CollectionParameters":{"type":"map","key":{},"value":{}}}}}}},"Sjg":{"type":"list","member":{"type":"structure","required":["RuleConfigurationName","RuleEvaluatorImage"],"members":{"RuleConfigurationName":{},"LocalPath":{},"S3OutputPath":{},"RuleEvaluatorImage":{},"InstanceType":{},"VolumeSizeInGB":{"type":"integer"},"RuleParameters":{"shape":"Sjk"}}}},"Sjk":{"type":"map","key":{},"value":{}},"Sjl":{"type":"structure","required":["S3OutputPath"],"members":{"LocalPath":{},"S3OutputPath":{}}},"Sjm":{"type":"structure","required":["S3OutputPath"],"members":{"S3OutputPath":{},"ProfilingIntervalInMilliseconds":{"type":"long"},"ProfilingParameters":{"shape":"Sjo"}}},"Sjo":{"type":"map","key":{},"value":{}},"Sjp":{"type":"list","member":{"type":"structure","required":["RuleConfigurationName","RuleEvaluatorImage"],"members":{"RuleConfigurationName":{},"LocalPath":{},"S3OutputPath":{},"RuleEvaluatorImage":{},"InstanceType":{},"VolumeSizeInGB":{"type":"integer"},"RuleParameters":{"shape":"Sjk"}}}},"Sjr":{"type":"map","key":{},"value":{}},"Sjy":{"type":"structure","members":{"InvocationsTimeoutInSeconds":{"type":"integer"},"InvocationsMaxRetries":{"type":"integer"}}},"Sk1":{"type":"structure","members":{"InputFilter":{},"OutputFilter":{},"JoinSource":{}}},"Sk9":{"type":"structure","members":{"PrimaryStatus":{},"Message":{}}},"Skd":{"type":"map","key":{},"value":{"type":"structure","members":{"StringValue":{},"NumberValue":{"type":"double"}}}},"Skh":{"type":"map","key":{},"value":{"type":"structure","required":["Value"],"members":{"MediaType":{},"Value":{}}}},"Sks":{"type":"structure","required":["UserPool","ClientId"],"members":{"UserPool":{},"ClientId":{}}},"Skv":{"type":"structure","required":["ClientId","ClientSecret","Issuer","AuthorizationEndpoint","TokenEndpoint","UserInfoEndpoint","LogoutEndpoint","JwksUri"],"members":{"ClientId":{},"ClientSecret":{"type":"string","sensitive":true},"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"LogoutEndpoint":{},"JwksUri":{}}},"Sky":{"type":"structure","required":["Cidrs"],"members":{"Cidrs":{"type":"list","member":{}}}},"Sl6":{"type":"list","member":{"type":"structure","members":{"CognitoMemberDefinition":{"type":"structure","required":["UserPool","UserGroup","ClientId"],"members":{"UserPool":{},"UserGroup":{},"ClientId":{}}},"OidcMemberDefinition":{"type":"structure","required":["Groups"],"members":{"Groups":{"type":"list","member":{}}}}}}},"Sle":{"type":"structure","members":{"NotificationTopicArn":{}}},"Sn8":{"type":"structure","members":{"UserProfileArn":{},"UserProfileName":{},"DomainId":{}}},"Sne":{"type":"list","member":{"type":"structure","required":["Name","Status"],"members":{"Name":{},"Status":{},"FailureReason":{}}}},"Sns":{"type":"list","member":{"type":"structure","members":{"PartialFailureMessage":{}}}},"Snu":{"type":"structure","required":["CandidateName","ObjectiveStatus","CandidateSteps","CandidateStatus","CreationTime","LastModifiedTime"],"members":{"CandidateName":{},"FinalAutoMLJobObjectiveMetric":{"type":"structure","required":["MetricName","Value"],"members":{"Type":{},"MetricName":{},"Value":{"type":"float"}}},"ObjectiveStatus":{},"CandidateSteps":{"type":"list","member":{"type":"structure","required":["CandidateStepType","CandidateStepArn","CandidateStepName"],"members":{"CandidateStepType":{},"CandidateStepArn":{},"CandidateStepName":{}}}},"CandidateStatus":{},"InferenceContainers":{"type":"list","member":{"type":"structure","required":["Image","ModelDataUrl"],"members":{"Image":{},"ModelDataUrl":{},"Environment":{"shape":"Sz"}}}},"CreationTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"CandidateProperties":{"type":"structure","members":{"CandidateArtifactLocations":{"type":"structure","required":["Explainability"],"members":{"Explainability":{},"ModelInsights":{}}},"CandidateMetrics":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"Value":{"type":"float"},"Set":{},"StandardMetricName":{}}}}}}}},"Sov":{"type":"structure","required":["S3ModelArtifacts"],"members":{"S3ModelArtifacts":{}}},"Spr":{"type":"list","member":{"type":"structure","required":["VariantName"],"members":{"VariantName":{},"DeployedImages":{"shape":"Spt"},"CurrentWeight":{"type":"float"},"DesiredWeight":{"type":"float"},"CurrentInstanceCount":{"type":"integer"},"DesiredInstanceCount":{"type":"integer"},"VariantStatus":{"shape":"Spw"},"CurrentServerlessConfig":{"shape":"S9g"},"DesiredServerlessConfig":{"shape":"S9g"}}}},"Spt":{"type":"list","member":{"type":"structure","members":{"SpecifiedImage":{},"ResolvedImage":{},"ResolutionTime":{"type":"timestamp"}}}},"Spw":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Status":{},"StatusMessage":{},"StartTime":{"type":"timestamp"}}}},"Sq0":{"type":"structure","required":["EnableCapture","CaptureStatus","CurrentSamplingPercentage","DestinationS3Uri","KmsKeyId"],"members":{"EnableCapture":{"type":"boolean"},"CaptureStatus":{},"CurrentSamplingPercentage":{"type":"integer"},"DestinationS3Uri":{},"KmsKeyId":{}}},"Sqa":{"type":"structure","required":["SourceArn"],"members":{"SourceArn":{},"SourceType":{}}},"Sqg":{"type":"structure","required":["Status"],"members":{"Status":{},"BlockedReason":{}}},"Sqv":{"type":"structure","members":{"Completed":{"type":"integer"},"InProgress":{"type":"integer"},"RetryableError":{"type":"integer"},"NonRetryableError":{"type":"integer"},"Stopped":{"type":"integer"}}},"Sqx":{"type":"structure","members":{"Succeeded":{"type":"integer"},"Pending":{"type":"integer"},"Failed":{"type":"integer"}}},"Sqz":{"type":"structure","required":["TrainingJobName","TrainingJobArn","CreationTime","TrainingJobStatus","TunedHyperParameters"],"members":{"TrainingJobDefinitionName":{},"TrainingJobName":{},"TrainingJobArn":{},"TuningJobName":{},"CreationTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"TrainingJobStatus":{},"TunedHyperParameters":{"shape":"S2t"},"FailureReason":{},"FinalHyperParameterTuningJobObjectiveMetric":{"type":"structure","required":["MetricName","Value"],"members":{"Type":{},"MetricName":{},"Value":{"type":"float"}}},"ObjectiveStatus":{}}},"Srm":{"type":"structure","members":{"TotalLabeled":{"type":"integer"},"HumanLabeled":{"type":"integer"},"MachineLabeled":{"type":"integer"},"FailedNonRetryableError":{"type":"integer"},"Unlabeled":{"type":"integer"}}},"Srp":{"type":"structure","required":["OutputDatasetS3Uri"],"members":{"OutputDatasetS3Uri":{},"FinalActiveLearningModelArn":{}}},"Ss0":{"type":"structure","required":["ValidationStatuses"],"members":{"ValidationStatuses":{"shape":"Ss1"},"ImageScanStatuses":{"shape":"Ss1"}}},"Ss1":{"type":"list","member":{"type":"structure","required":["Name","Status"],"members":{"Name":{},"Status":{},"FailureReason":{}}}},"Ssd":{"type":"structure","required":["MonitoringScheduleName","ScheduledTime","CreationTime","LastModifiedTime","MonitoringExecutionStatus"],"members":{"MonitoringScheduleName":{},"ScheduledTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"MonitoringExecutionStatus":{},"ProcessingJobArn":{},"EndpointName":{},"FailureReason":{},"MonitoringJobDefinitionName":{},"MonitoringType":{}}},"Ssw":{"type":"structure","members":{"ExperimentName":{},"TrialName":{}}},"St4":{"type":"structure","members":{"ProvisionedProductId":{},"ProvisionedProductStatusMessage":{}}},"Stb":{"type":"structure","required":["WorkteamArn"],"members":{"WorkteamArn":{},"MarketplaceTitle":{},"SellerName":{},"MarketplaceDescription":{},"ListingId":{}}},"Stf":{"type":"list","member":{"type":"structure","required":["Status","StartTime"],"members":{"Status":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusMessage":{}}}},"Sti":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"Value":{"type":"float"},"Timestamp":{"type":"timestamp"}}}},"Stm":{"type":"list","member":{"type":"structure","members":{"RuleConfigurationName":{},"RuleEvaluationJobArn":{},"RuleEvaluationStatus":{},"StatusDetails":{},"LastModifiedTime":{"type":"timestamp"}}}},"Sty":{"type":"structure","required":["SourceArn"],"members":{"SourceArn":{},"SourceType":{}}},"Su2":{"type":"structure","required":["SourceArn"],"members":{"SourceArn":{},"SourceType":{}}},"Su4":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"SourceArn":{},"TimeStamp":{"type":"timestamp"},"Max":{"type":"double"},"Min":{"type":"double"},"Last":{"type":"double"},"Count":{"type":"integer"},"Avg":{"type":"double"},"StdDev":{"type":"double"}}}},"Sue":{"type":"structure","required":["WorkforceName","WorkforceArn"],"members":{"WorkforceName":{},"WorkforceArn":{},"LastUpdatedDate":{"type":"timestamp"},"SourceIpConfig":{"shape":"Sky"},"SubDomain":{},"CognitoConfig":{"shape":"Sks"},"OidcConfig":{"type":"structure","members":{"ClientId":{},"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"LogoutEndpoint":{},"JwksUri":{}}},"CreateDate":{"type":"timestamp"}}},"Sui":{"type":"structure","required":["WorkteamName","MemberDefinitions","WorkteamArn","Description"],"members":{"WorkteamName":{},"MemberDefinitions":{"shape":"Sl6"},"WorkteamArn":{},"WorkforceArn":{},"ProductListingIds":{"type":"list","member":{}},"Description":{},"SubDomain":{},"CreateDate":{"type":"timestamp"},"LastUpdatedDate":{"type":"timestamp"},"NotificationConfiguration":{"shape":"Sle"}}},"Sxb":{"type":"list","member":{"type":"structure","required":["MonitoringJobDefinitionName","MonitoringJobDefinitionArn","CreationTime","EndpointName"],"members":{"MonitoringJobDefinitionName":{},"MonitoringJobDefinitionArn":{},"CreationTime":{"type":"timestamp"},"EndpointName":{}}}},"S126":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S12l":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S14x":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"DeviceName":{},"Description":{},"IotThingName":{}}}},"S158":{"type":"structure","members":{"Filters":{"shape":"S159"},"NestedFilters":{"type":"list","member":{"type":"structure","required":["NestedPropertyName","Filters"],"members":{"NestedPropertyName":{},"Filters":{"shape":"S159"}}}},"SubExpressions":{"type":"list","member":{"shape":"S158"}},"Operator":{}}},"S159":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Operator":{},"Value":{}}}},"S15l":{"type":"structure","members":{"TrainingJobName":{},"TrainingJobArn":{},"TuningJobArn":{},"LabelingJobArn":{},"AutoMLJobArn":{},"ModelArtifacts":{"shape":"Sov"},"TrainingJobStatus":{},"SecondaryStatus":{},"FailureReason":{},"HyperParameters":{"shape":"S2t"},"AlgorithmSpecification":{"shape":"Sj7"},"RoleArn":{},"InputDataConfig":{"shape":"S2v"},"OutputDataConfig":{"shape":"S3c"},"ResourceConfig":{"shape":"S3e"},"VpcConfig":{"shape":"S5i"},"StoppingCondition":{"shape":"S3h"},"CreationTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"SecondaryStatusTransitions":{"shape":"Stf"},"FinalMetricDataList":{"shape":"Sti"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"Sc4"},"TrainingTimeInSeconds":{"type":"integer"},"BillableTimeInSeconds":{"type":"integer"},"DebugHookConfig":{"shape":"Sj8"},"ExperimentConfig":{"shape":"Sim"},"DebugRuleConfigurations":{"shape":"Sjg"},"TensorBoardOutputConfig":{"shape":"Sjl"},"DebugRuleEvaluationStatuses":{"shape":"Stm"},"Environment":{"shape":"Sjr"},"RetryStrategy":{"shape":"Sc5"},"Tags":{"shape":"S7"}}},"S16r":{"type":"list","member":{}},"S18e":{"type":"list","member":{}}}}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListActions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ActionSummaries"},"ListAlgorithms":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AlgorithmSummaryList"},"ListAppImageConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AppImageConfigs"},"ListApps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Apps"},"ListArtifacts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ArtifactSummaries"},"ListAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AssociationSummaries"},"ListAutoMLJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AutoMLJobSummaries"},"ListCandidatesForAutoMLJob":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Candidates"},"ListCodeRepositories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CodeRepositorySummaryList"},"ListCompilationJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CompilationJobSummaries"},"ListContexts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ContextSummaries"},"ListDataQualityJobDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"JobDefinitionSummaries"},"ListDeviceFleets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DeviceFleetSummaries"},"ListDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DeviceSummaries"},"ListDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Domains"},"ListEdgePackagingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EdgePackagingJobSummaries"},"ListEndpointConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EndpointConfigs"},"ListEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Endpoints"},"ListExperiments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ExperimentSummaries"},"ListFeatureGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FeatureGroupSummaries"},"ListFlowDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FlowDefinitionSummaries"},"ListHumanTaskUis":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"HumanTaskUiSummaries"},"ListHyperParameterTuningJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"HyperParameterTuningJobSummaries"},"ListImageVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ImageVersions"},"ListImages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Images"},"ListInferenceRecommendationsJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"InferenceRecommendationsJobs"},"ListLabelingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"LabelingJobSummaryList"},"ListLabelingJobsForWorkteam":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"LabelingJobSummaryList"},"ListLineageGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"LineageGroupSummaries"},"ListModelBiasJobDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"JobDefinitionSummaries"},"ListModelExplainabilityJobDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"JobDefinitionSummaries"},"ListModelMetadata":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ModelMetadataSummaries"},"ListModelPackageGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ModelPackageGroupSummaryList"},"ListModelPackages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ModelPackageSummaryList"},"ListModelQualityJobDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"JobDefinitionSummaries"},"ListModels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Models"},"ListMonitoringExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"MonitoringExecutionSummaries"},"ListMonitoringSchedules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"MonitoringScheduleSummaries"},"ListNotebookInstanceLifecycleConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NotebookInstanceLifecycleConfigs"},"ListNotebookInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NotebookInstances"},"ListPipelineExecutionSteps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PipelineExecutionSteps"},"ListPipelineExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PipelineExecutionSummaries"},"ListPipelineParametersForExecution":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PipelineParameters"},"ListPipelines":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PipelineSummaries"},"ListProcessingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ProcessingJobSummaries"},"ListProjects":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListStudioLifecycleConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"StudioLifecycleConfigs"},"ListSubscribedWorkteams":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"SubscribedWorkteams"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Tags"},"ListTrainingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TrainingJobSummaries"},"ListTrainingJobsForHyperParameterTuningJob":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TrainingJobSummaries"},"ListTransformJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TransformJobSummaries"},"ListTrialComponents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TrialComponentSummaries"},"ListTrials":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TrialSummaries"},"ListUserProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"UserProfiles"},"ListWorkforces":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Workforces"},"ListWorkteams":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Workteams"},"QueryLineage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"Search":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Results"}}}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"NotebookInstanceInService":{"delay":30,"maxAttempts":60,"operation":"DescribeNotebookInstance","acceptors":[{"expected":"InService","matcher":"path","state":"success","argument":"NotebookInstanceStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"NotebookInstanceStatus"}]},"NotebookInstanceStopped":{"delay":30,"operation":"DescribeNotebookInstance","maxAttempts":60,"acceptors":[{"expected":"Stopped","matcher":"path","state":"success","argument":"NotebookInstanceStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"NotebookInstanceStatus"}]},"NotebookInstanceDeleted":{"delay":30,"maxAttempts":60,"operation":"DescribeNotebookInstance","acceptors":[{"expected":"ValidationException","matcher":"error","state":"success"},{"expected":"Failed","matcher":"path","state":"failure","argument":"NotebookInstanceStatus"}]},"TrainingJobCompletedOrStopped":{"delay":120,"maxAttempts":180,"operation":"DescribeTrainingJob","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"TrainingJobStatus"},{"expected":"Stopped","matcher":"path","state":"success","argument":"TrainingJobStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"TrainingJobStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"EndpointInService":{"delay":30,"maxAttempts":120,"operation":"DescribeEndpoint","acceptors":[{"expected":"InService","matcher":"path","state":"success","argument":"EndpointStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"EndpointStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"EndpointDeleted":{"delay":30,"maxAttempts":60,"operation":"DescribeEndpoint","acceptors":[{"expected":"ValidationException","matcher":"error","state":"success"},{"expected":"Failed","matcher":"path","state":"failure","argument":"EndpointStatus"}]},"TransformJobCompletedOrStopped":{"delay":60,"maxAttempts":60,"operation":"DescribeTransformJob","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"TransformJobStatus"},{"expected":"Stopped","matcher":"path","state":"success","argument":"TransformJobStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"TransformJobStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"ProcessingJobCompletedOrStopped":{"delay":60,"maxAttempts":60,"operation":"DescribeProcessingJob","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"ProcessingJobStatus"},{"expected":"Stopped","matcher":"path","state":"success","argument":"ProcessingJobStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"ProcessingJobStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"ImageCreated":{"delay":60,"maxAttempts":60,"operation":"DescribeImage","acceptors":[{"expected":"CREATED","matcher":"path","state":"success","argument":"ImageStatus"},{"expected":"CREATE_FAILED","matcher":"path","state":"failure","argument":"ImageStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"ImageUpdated":{"delay":60,"maxAttempts":60,"operation":"DescribeImage","acceptors":[{"expected":"CREATED","matcher":"path","state":"success","argument":"ImageStatus"},{"expected":"UPDATE_FAILED","matcher":"path","state":"failure","argument":"ImageStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"ImageDeleted":{"delay":60,"maxAttempts":60,"operation":"DescribeImage","acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"DELETE_FAILED","matcher":"path","state":"failure","argument":"ImageStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"ImageVersionCreated":{"delay":60,"maxAttempts":60,"operation":"DescribeImageVersion","acceptors":[{"expected":"CREATED","matcher":"path","state":"success","argument":"ImageVersionStatus"},{"expected":"CREATE_FAILED","matcher":"path","state":"failure","argument":"ImageVersionStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"ImageVersionDeleted":{"delay":60,"maxAttempts":60,"operation":"DescribeImageVersion","acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"DELETE_FAILED","matcher":"path","state":"failure","argument":"ImageVersionStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]}}}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['translate'] = {};
	AWS.Translate = Service.defineService('translate', ['2017-07-01']);
	Object.defineProperty(apiLoader.services['translate'], '2017-07-01', {
	  get: function get() {
	    var model = __webpack_require__(574);
	    model.paginators = __webpack_require__(575).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Translate;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"translate","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Translate","serviceId":"Translate","signatureVersion":"v4","signingName":"translate","targetPrefix":"AWSShineFrontendService_20170701","uid":"translate-2017-07-01"},"operations":{"CreateParallelData":{"input":{"type":"structure","required":["Name","ParallelDataConfig","ClientToken"],"members":{"Name":{},"Description":{},"ParallelDataConfig":{"shape":"S4"},"EncryptionKey":{"shape":"S7"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Name":{},"Status":{}}}},"DeleteParallelData":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Status":{}}}},"DeleteTerminology":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DescribeTextTranslationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TextTranslationJobProperties":{"shape":"Sj"}}}},"GetParallelData":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ParallelDataProperties":{"shape":"S12"},"DataLocation":{"shape":"S16"},"AuxiliaryDataLocation":{"shape":"S16"},"LatestUpdateAttemptAuxiliaryDataLocation":{"shape":"S16"}}}},"GetTerminology":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TerminologyDataFormat":{}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"S1b"},"TerminologyDataLocation":{"shape":"S1e"},"AuxiliaryDataLocation":{"shape":"S1e"}}}},"ImportTerminology":{"input":{"type":"structure","required":["Name","MergeStrategy","TerminologyData"],"members":{"Name":{},"MergeStrategy":{},"Description":{},"TerminologyData":{"type":"structure","required":["File","Format"],"members":{"File":{"type":"blob","sensitive":true},"Format":{},"Directionality":{}}},"EncryptionKey":{"shape":"S7"}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"S1b"},"AuxiliaryDataLocation":{"shape":"S1e"}}}},"ListParallelData":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ParallelDataPropertiesList":{"type":"list","member":{"shape":"S12"}},"NextToken":{}}}},"ListTerminologies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TerminologyPropertiesList":{"type":"list","member":{"shape":"S1b"}},"NextToken":{}}}},"ListTextTranslationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmittedBeforeTime":{"type":"timestamp"},"SubmittedAfterTime":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TextTranslationJobPropertiesList":{"type":"list","member":{"shape":"Sj"}},"NextToken":{}}}},"StartTextTranslationJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","SourceLanguageCode","TargetLanguageCodes","ClientToken"],"members":{"JobName":{},"InputDataConfig":{"shape":"St"},"OutputDataConfig":{"shape":"Sv"},"DataAccessRoleArn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"Sp"},"TerminologyNames":{"shape":"Sq"},"ParallelDataNames":{"shape":"Sq"},"ClientToken":{"idempotencyToken":true},"Settings":{"shape":"Sx"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTextTranslationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"TranslateText":{"input":{"type":"structure","required":["Text","SourceLanguageCode","TargetLanguageCode"],"members":{"Text":{},"TerminologyNames":{"shape":"Sq"},"SourceLanguageCode":{},"TargetLanguageCode":{},"Settings":{"shape":"Sx"}}},"output":{"type":"structure","required":["TranslatedText","SourceLanguageCode","TargetLanguageCode"],"members":{"TranslatedText":{},"SourceLanguageCode":{},"TargetLanguageCode":{},"AppliedTerminologies":{"type":"list","member":{"type":"structure","members":{"Name":{},"Terms":{"type":"list","member":{"type":"structure","members":{"SourceText":{},"TargetText":{}}}}}}},"AppliedSettings":{"shape":"Sx"}}}},"UpdateParallelData":{"input":{"type":"structure","required":["Name","ParallelDataConfig","ClientToken"],"members":{"Name":{},"Description":{},"ParallelDataConfig":{"shape":"S4"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Name":{},"Status":{},"LatestUpdateAttemptStatus":{},"LatestUpdateAttemptAt":{"type":"timestamp"}}}}},"shapes":{"S4":{"type":"structure","required":["S3Uri","Format"],"members":{"S3Uri":{},"Format":{}}},"S7":{"type":"structure","required":["Type","Id"],"members":{"Type":{},"Id":{}}},"Sj":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"JobDetails":{"type":"structure","members":{"TranslatedDocumentsCount":{"type":"integer"},"DocumentsWithErrorsCount":{"type":"integer"},"InputDocumentsCount":{"type":"integer"}}},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"Sp"},"TerminologyNames":{"shape":"Sq"},"ParallelDataNames":{"shape":"Sq"},"Message":{},"SubmittedTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"St"},"OutputDataConfig":{"shape":"Sv"},"DataAccessRoleArn":{},"Settings":{"shape":"Sx"}}},"Sp":{"type":"list","member":{}},"Sq":{"type":"list","member":{}},"St":{"type":"structure","required":["S3Uri","ContentType"],"members":{"S3Uri":{},"ContentType":{}}},"Sv":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"EncryptionKey":{"shape":"S7"}}},"Sx":{"type":"structure","members":{"Formality":{},"Profanity":{}}},"S12":{"type":"structure","members":{"Name":{},"Arn":{},"Description":{},"Status":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"S14"},"ParallelDataConfig":{"shape":"S4"},"Message":{},"ImportedDataSize":{"type":"long"},"ImportedRecordCount":{"type":"long"},"FailedRecordCount":{"type":"long"},"SkippedRecordCount":{"type":"long"},"EncryptionKey":{"shape":"S7"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"LatestUpdateAttemptStatus":{},"LatestUpdateAttemptAt":{"type":"timestamp"}}},"S14":{"type":"list","member":{}},"S16":{"type":"structure","required":["RepositoryType","Location"],"members":{"RepositoryType":{},"Location":{}}},"S1b":{"type":"structure","members":{"Name":{},"Description":{},"Arn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"S14"},"EncryptionKey":{"shape":"S7"},"SizeBytes":{"type":"integer"},"TermCount":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Directionality":{},"Message":{},"SkippedTermCount":{"type":"integer"},"Format":{}}},"S1e":{"type":"structure","required":["RepositoryType","Location"],"members":{"RepositoryType":{},"Location":{}}}}}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListParallelData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTerminologies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTextTranslationJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['resourcegroups'] = {};
	AWS.ResourceGroups = Service.defineService('resourcegroups', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['resourcegroups'], '2017-11-27', {
	  get: function get() {
	    var model = __webpack_require__(577);
	    model.paginators = __webpack_require__(578).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ResourceGroups;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"resource-groups","protocol":"rest-json","serviceAbbreviation":"Resource Groups","serviceFullName":"AWS Resource Groups","serviceId":"Resource Groups","signatureVersion":"v4","signingName":"resource-groups","uid":"resource-groups-2017-11-27"},"operations":{"CreateGroup":{"http":{"requestUri":"/groups"},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"},"Configuration":{"shape":"Sa"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"},"GroupConfiguration":{"shape":"Sl"}}}},"DeleteGroup":{"http":{"requestUri":"/delete-group"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"}}}},"GetGroup":{"http":{"requestUri":"/get-group"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"}}}},"GetGroupConfiguration":{"http":{"requestUri":"/get-group-configuration"},"input":{"type":"structure","members":{"Group":{}}},"output":{"type":"structure","members":{"GroupConfiguration":{"shape":"Sl"}}}},"GetGroupQuery":{"http":{"requestUri":"/get-group-query"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"Sx"}}}},"GetTags":{"http":{"method":"GET","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"uri","locationName":"Arn"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"GroupResources":{"http":{"requestUri":"/group-resources"},"input":{"type":"structure","required":["Group","ResourceArns"],"members":{"Group":{},"ResourceArns":{"shape":"S11"}}},"output":{"type":"structure","members":{"Succeeded":{"shape":"S11"},"Failed":{"shape":"S14"},"Pending":{"shape":"S18"}}}},"ListGroupResources":{"http":{"requestUri":"/list-group-resources"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Resources":{"type":"list","member":{"type":"structure","members":{"Identifier":{"shape":"S1l"},"Status":{"type":"structure","members":{"Name":{}}}}}},"ResourceIdentifiers":{"shape":"S1p","deprecated":true,"deprecatedMessage":"This field is deprecated, use Resources instead."},"NextToken":{},"QueryErrors":{"shape":"S1q"}}}},"ListGroups":{"http":{"requestUri":"/groups-list"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"GroupIdentifiers":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupArn":{}}}},"Groups":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use GroupIdentifiers instead.","type":"list","member":{"shape":"Sj"}},"NextToken":{}}}},"PutGroupConfiguration":{"http":{"requestUri":"/put-group-configuration","responseCode":202},"input":{"type":"structure","members":{"Group":{},"Configuration":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"SearchResources":{"http":{"requestUri":"/resources/search"},"input":{"type":"structure","required":["ResourceQuery"],"members":{"ResourceQuery":{"shape":"S4"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"shape":"S1p"},"NextToken":{},"QueryErrors":{"shape":"S1q"}}}},"Tag":{"http":{"method":"PUT","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"UngroupResources":{"http":{"requestUri":"/ungroup-resources"},"input":{"type":"structure","required":["Group","ResourceArns"],"members":{"Group":{},"ResourceArns":{"shape":"S11"}}},"output":{"type":"structure","members":{"Succeeded":{"shape":"S11"},"Failed":{"shape":"S14"},"Pending":{"shape":"S18"}}}},"Untag":{"http":{"method":"PATCH","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Keys"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Keys":{"shape":"S2d"}}},"output":{"type":"structure","members":{"Arn":{},"Keys":{"shape":"S2d"}}}},"UpdateGroup":{"http":{"requestUri":"/update-group"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{},"Description":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"}}}},"UpdateGroupQuery":{"http":{"requestUri":"/update-group-query"},"input":{"type":"structure","required":["ResourceQuery"],"members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{},"ResourceQuery":{"shape":"S4"}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"Sx"}}}}},"shapes":{"S4":{"type":"structure","required":["Type","Query"],"members":{"Type":{},"Query":{}}},"S7":{"type":"map","key":{},"value":{}},"Sa":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}}}}},"Sj":{"type":"structure","required":["GroupArn","Name"],"members":{"GroupArn":{},"Name":{},"Description":{}}},"Sl":{"type":"structure","members":{"Configuration":{"shape":"Sa"},"ProposedConfiguration":{"shape":"Sa"},"Status":{},"FailureReason":{}}},"Sx":{"type":"structure","required":["GroupName","ResourceQuery"],"members":{"GroupName":{},"ResourceQuery":{"shape":"S4"}}},"S11":{"type":"list","member":{}},"S14":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ErrorMessage":{},"ErrorCode":{}}}},"S18":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{}}}},"S1l":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{}}},"S1p":{"type":"list","member":{"shape":"S1l"}},"S1q":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"Message":{}}}},"S2d":{"type":"list","member":{}}}}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListGroupResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":["ResourceIdentifiers","Resources"]},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"GroupIdentifiers"},"SearchResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResourceIdentifiers"}}}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['alexaforbusiness'] = {};
	AWS.AlexaForBusiness = Service.defineService('alexaforbusiness', ['2017-11-09']);
	Object.defineProperty(apiLoader.services['alexaforbusiness'], '2017-11-09', {
	  get: function get() {
	    var model = __webpack_require__(580);
	    model.paginators = __webpack_require__(581).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AlexaForBusiness;


/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-09","endpointPrefix":"a4b","jsonVersion":"1.1","protocol":"json","serviceFullName":"Alexa For Business","serviceId":"Alexa For Business","signatureVersion":"v4","targetPrefix":"AlexaForBusiness","uid":"alexaforbusiness-2017-11-09"},"operations":{"ApproveSkill":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"AssociateContactWithAddressBook":{"input":{"type":"structure","required":["ContactArn","AddressBookArn"],"members":{"ContactArn":{},"AddressBookArn":{}}},"output":{"type":"structure","members":{}}},"AssociateDeviceWithNetworkProfile":{"input":{"type":"structure","required":["DeviceArn","NetworkProfileArn"],"members":{"DeviceArn":{},"NetworkProfileArn":{}}},"output":{"type":"structure","members":{}}},"AssociateDeviceWithRoom":{"input":{"type":"structure","members":{"DeviceArn":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"AssociateSkillGroupWithRoom":{"input":{"type":"structure","members":{"SkillGroupArn":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"AssociateSkillWithSkillGroup":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillGroupArn":{},"SkillId":{}}},"output":{"type":"structure","members":{}}},"AssociateSkillWithUsers":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"CreateAddressBook":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"AddressBookArn":{}}}},"CreateBusinessReportSchedule":{"input":{"type":"structure","required":["Format","ContentRange"],"members":{"ScheduleName":{},"S3BucketName":{},"S3KeyPrefix":{},"Format":{},"ContentRange":{"shape":"Sv"},"Recurrence":{"shape":"Sx"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"ScheduleArn":{}}}},"CreateConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderName","ConferenceProviderType","MeetingSetting"],"members":{"ConferenceProviderName":{},"ConferenceProviderType":{},"IPDialIn":{"shape":"S13"},"PSTNDialIn":{"shape":"S16"},"MeetingSetting":{"shape":"S1b"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"ConferenceProviderArn":{}}}},"CreateContact":{"input":{"type":"structure","required":["FirstName"],"members":{"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1g"},"PhoneNumbers":{"shape":"S1h"},"SipAddresses":{"shape":"S1k"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"ContactArn":{}}}},"CreateGatewayGroup":{"input":{"type":"structure","required":["Name","ClientRequestToken"],"members":{"Name":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"GatewayGroupArn":{}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileName","Ssid","SecurityType","ClientRequestToken"],"members":{"NetworkProfileName":{},"Description":{},"Ssid":{},"SecurityType":{},"EapMethod":{},"CurrentPassword":{"shape":"S1z"},"NextPassword":{"shape":"S20"},"CertificateAuthorityArn":{},"TrustAnchors":{"shape":"S21"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"NetworkProfileArn":{}}}},"CreateProfile":{"input":{"type":"structure","required":["ProfileName","Timezone","Address","DistanceUnit","TemperatureUnit","WakeWord"],"members":{"ProfileName":{},"Timezone":{},"Address":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{},"ClientRequestToken":{"idempotencyToken":true},"SetupModeDisabled":{"type":"boolean"},"MaxVolumeLimit":{"type":"integer"},"PSTNEnabled":{"type":"boolean"},"DataRetentionOptIn":{"type":"boolean"},"MeetingRoomConfiguration":{"type":"structure","members":{"RoomUtilizationMetricsEnabled":{"type":"boolean"},"EndOfMeetingReminder":{"type":"structure","required":["ReminderAtMinutes","ReminderType","Enabled"],"members":{"ReminderAtMinutes":{"shape":"S2g"},"ReminderType":{},"Enabled":{"type":"boolean"}}},"InstantBooking":{"type":"structure","required":["DurationInMinutes","Enabled"],"members":{"DurationInMinutes":{"type":"integer"},"Enabled":{"type":"boolean"}}},"RequireCheckIn":{"type":"structure","required":["ReleaseAfterMinutes","Enabled"],"members":{"ReleaseAfterMinutes":{"type":"integer"},"Enabled":{"type":"boolean"}}}}},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"ProfileArn":{}}}},"CreateRoom":{"input":{"type":"structure","required":["RoomName"],"members":{"RoomName":{},"Description":{},"ProfileArn":{},"ProviderCalendarId":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"RoomArn":{}}}},"CreateSkillGroup":{"input":{"type":"structure","required":["SkillGroupName"],"members":{"SkillGroupName":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"SkillGroupArn":{}}}},"CreateUser":{"input":{"type":"structure","required":["UserId"],"members":{"UserId":{},"FirstName":{},"LastName":{},"Email":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"UserArn":{}}}},"DeleteAddressBook":{"input":{"type":"structure","required":["AddressBookArn"],"members":{"AddressBookArn":{}}},"output":{"type":"structure","members":{}}},"DeleteBusinessReportSchedule":{"input":{"type":"structure","required":["ScheduleArn"],"members":{"ScheduleArn":{}}},"output":{"type":"structure","members":{}}},"DeleteConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderArn"],"members":{"ConferenceProviderArn":{}}},"output":{"type":"structure","members":{}}},"DeleteContact":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{}}},"output":{"type":"structure","members":{}}},"DeleteDevice":{"input":{"type":"structure","required":["DeviceArn"],"members":{"DeviceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteDeviceUsageData":{"input":{"type":"structure","required":["DeviceArn","DeviceUsageType"],"members":{"DeviceArn":{},"DeviceUsageType":{}}},"output":{"type":"structure","members":{}}},"DeleteGatewayGroup":{"input":{"type":"structure","required":["GatewayGroupArn"],"members":{"GatewayGroupArn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileArn"],"members":{"NetworkProfileArn":{}}},"output":{"type":"structure","members":{}}},"DeleteProfile":{"input":{"type":"structure","members":{"ProfileArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRoom":{"input":{"type":"structure","members":{"RoomArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRoomSkillParameter":{"input":{"type":"structure","required":["SkillId","ParameterKey"],"members":{"RoomArn":{},"SkillId":{},"ParameterKey":{}}},"output":{"type":"structure","members":{}}},"DeleteSkillAuthorization":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"DeleteSkillGroup":{"input":{"type":"structure","members":{"SkillGroupArn":{}}},"output":{"type":"structure","members":{}}},"DeleteUser":{"input":{"type":"structure","required":["EnrollmentId"],"members":{"UserArn":{},"EnrollmentId":{}}},"output":{"type":"structure","members":{}}},"DisassociateContactFromAddressBook":{"input":{"type":"structure","required":["ContactArn","AddressBookArn"],"members":{"ContactArn":{},"AddressBookArn":{}}},"output":{"type":"structure","members":{}}},"DisassociateDeviceFromRoom":{"input":{"type":"structure","members":{"DeviceArn":{}}},"output":{"type":"structure","members":{}}},"DisassociateSkillFromSkillGroup":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillGroupArn":{},"SkillId":{}}},"output":{"type":"structure","members":{}}},"DisassociateSkillFromUsers":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"DisassociateSkillGroupFromRoom":{"input":{"type":"structure","members":{"SkillGroupArn":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"ForgetSmartHomeAppliances":{"input":{"type":"structure","required":["RoomArn"],"members":{"RoomArn":{}}},"output":{"type":"structure","members":{}}},"GetAddressBook":{"input":{"type":"structure","required":["AddressBookArn"],"members":{"AddressBookArn":{}}},"output":{"type":"structure","members":{"AddressBook":{"type":"structure","members":{"AddressBookArn":{},"Name":{},"Description":{}}}}}},"GetConferencePreference":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Preference":{"shape":"S4d"}}}},"GetConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderArn"],"members":{"ConferenceProviderArn":{}}},"output":{"type":"structure","members":{"ConferenceProvider":{"shape":"S4g"}}}},"GetContact":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{}}},"output":{"type":"structure","members":{"Contact":{"type":"structure","members":{"ContactArn":{},"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1g"},"PhoneNumbers":{"shape":"S1h"},"SipAddresses":{"shape":"S1k"}}}}}},"GetDevice":{"input":{"type":"structure","members":{"DeviceArn":{}}},"output":{"type":"structure","members":{"Device":{"type":"structure","members":{"DeviceArn":{},"DeviceSerialNumber":{},"DeviceType":{},"DeviceName":{},"SoftwareVersion":{},"MacAddress":{},"RoomArn":{},"DeviceStatus":{},"DeviceStatusInfo":{"shape":"S4t"},"NetworkProfileInfo":{"type":"structure","members":{"NetworkProfileArn":{},"CertificateArn":{},"CertificateExpirationTime":{"type":"timestamp"}}}}}}}},"GetGateway":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{}}},"output":{"type":"structure","members":{"Gateway":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{},"GatewayGroupArn":{},"SoftwareVersion":{}}}}}},"GetGatewayGroup":{"input":{"type":"structure","required":["GatewayGroupArn"],"members":{"GatewayGroupArn":{}}},"output":{"type":"structure","members":{"GatewayGroup":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{}}}}}},"GetInvitationConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"OrganizationName":{},"ContactEmail":{},"PrivateSkillIds":{"shape":"S5e"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileArn"],"members":{"NetworkProfileArn":{}}},"output":{"type":"structure","members":{"NetworkProfile":{"type":"structure","members":{"NetworkProfileArn":{},"NetworkProfileName":{},"Description":{},"Ssid":{},"SecurityType":{},"EapMethod":{},"CurrentPassword":{"shape":"S1z"},"NextPassword":{"shape":"S20"},"CertificateAuthorityArn":{},"TrustAnchors":{"shape":"S21"}}}}}},"GetProfile":{"input":{"type":"structure","members":{"ProfileArn":{}}},"output":{"type":"structure","members":{"Profile":{"type":"structure","members":{"ProfileArn":{},"ProfileName":{},"IsDefault":{"type":"boolean"},"Address":{},"Timezone":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{},"SetupModeDisabled":{"type":"boolean"},"MaxVolumeLimit":{"type":"integer"},"PSTNEnabled":{"type":"boolean"},"DataRetentionOptIn":{"type":"boolean"},"AddressBookArn":{},"MeetingRoomConfiguration":{"type":"structure","members":{"RoomUtilizationMetricsEnabled":{"type":"boolean"},"EndOfMeetingReminder":{"type":"structure","members":{"ReminderAtMinutes":{"shape":"S2g"},"ReminderType":{},"Enabled":{"type":"boolean"}}},"InstantBooking":{"type":"structure","members":{"DurationInMinutes":{"type":"integer"},"Enabled":{"type":"boolean"}}},"RequireCheckIn":{"type":"structure","members":{"ReleaseAfterMinutes":{"type":"integer"},"Enabled":{"type":"boolean"}}}}}}}}}},"GetRoom":{"input":{"type":"structure","members":{"RoomArn":{}}},"output":{"type":"structure","members":{"Room":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"Description":{},"ProviderCalendarId":{},"ProfileArn":{}}}}}},"GetRoomSkillParameter":{"input":{"type":"structure","required":["SkillId","ParameterKey"],"members":{"RoomArn":{},"SkillId":{},"ParameterKey":{}}},"output":{"type":"structure","members":{"RoomSkillParameter":{"shape":"S5u"}}}},"GetSkillGroup":{"input":{"type":"structure","members":{"SkillGroupArn":{}}},"output":{"type":"structure","members":{"SkillGroup":{"type":"structure","members":{"SkillGroupArn":{},"SkillGroupName":{},"Description":{}}}}}},"ListBusinessReportSchedules":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"BusinessReportSchedules":{"type":"list","member":{"type":"structure","members":{"ScheduleArn":{},"ScheduleName":{},"S3BucketName":{},"S3KeyPrefix":{},"Format":{},"ContentRange":{"shape":"Sv"},"Recurrence":{"shape":"Sx"},"LastBusinessReport":{"type":"structure","members":{"Status":{},"FailureCode":{},"S3Location":{"type":"structure","members":{"Path":{},"BucketName":{}}},"DeliveryTime":{"type":"timestamp"},"DownloadUrl":{}}}}}},"NextToken":{}}}},"ListConferenceProviders":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ConferenceProviders":{"type":"list","member":{"shape":"S4g"}},"NextToken":{}}}},"ListDeviceEvents":{"input":{"type":"structure","required":["DeviceArn"],"members":{"DeviceArn":{},"EventType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DeviceEvents":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{},"Timestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListGatewayGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayGroups":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{}}}},"NextToken":{}}}},"ListGateways":{"input":{"type":"structure","members":{"GatewayGroupArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{},"GatewayGroupArn":{},"SoftwareVersion":{}}}},"NextToken":{}}}},"ListSkills":{"input":{"type":"structure","members":{"SkillGroupArn":{},"EnablementType":{},"SkillType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SkillSummaries":{"type":"list","member":{"type":"structure","members":{"SkillId":{},"SkillName":{},"SupportsLinking":{"type":"boolean"},"EnablementType":{},"SkillType":{}}}},"NextToken":{}}}},"ListSkillsStoreCategories":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CategoryList":{"type":"list","member":{"type":"structure","members":{"CategoryId":{"type":"long"},"CategoryName":{}}}},"NextToken":{}}}},"ListSkillsStoreSkillsByCategory":{"input":{"type":"structure","required":["CategoryId"],"members":{"CategoryId":{"type":"long"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SkillsStoreSkills":{"type":"list","member":{"type":"structure","members":{"SkillId":{},"SkillName":{},"ShortDescription":{},"IconUrl":{},"SampleUtterances":{"type":"list","member":{}},"SkillDetails":{"type":"structure","members":{"ProductDescription":{},"InvocationPhrase":{},"ReleaseDate":{},"EndUserLicenseAgreement":{},"GenericKeywords":{"type":"list","member":{}},"BulletPoints":{"type":"list","member":{}},"NewInThisVersionBulletPoints":{"type":"list","member":{}},"SkillTypes":{"type":"list","member":{}},"Reviews":{"type":"map","key":{},"value":{}},"DeveloperInfo":{"type":"structure","members":{"DeveloperName":{},"PrivacyPolicy":{},"Email":{},"Url":{}}}}},"SupportsLinking":{"type":"boolean"}}}},"NextToken":{}}}},"ListSmartHomeAppliances":{"input":{"type":"structure","required":["RoomArn"],"members":{"RoomArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SmartHomeAppliances":{"type":"list","member":{"type":"structure","members":{"FriendlyName":{},"Description":{},"ManufacturerName":{}}}},"NextToken":{}}}},"ListTags":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sl"},"NextToken":{}}}},"PutConferencePreference":{"input":{"type":"structure","required":["ConferencePreference"],"members":{"ConferencePreference":{"shape":"S4d"}}},"output":{"type":"structure","members":{}}},"PutInvitationConfiguration":{"input":{"type":"structure","required":["OrganizationName"],"members":{"OrganizationName":{},"ContactEmail":{},"PrivateSkillIds":{"shape":"S5e"}}},"output":{"type":"structure","members":{}}},"PutRoomSkillParameter":{"input":{"type":"structure","required":["SkillId","RoomSkillParameter"],"members":{"RoomArn":{},"SkillId":{},"RoomSkillParameter":{"shape":"S5u"}}},"output":{"type":"structure","members":{}}},"PutSkillAuthorization":{"input":{"type":"structure","required":["AuthorizationResult","SkillId"],"members":{"AuthorizationResult":{"type":"map","key":{},"value":{},"sensitive":true},"SkillId":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"RegisterAVSDevice":{"input":{"type":"structure","required":["ClientId","UserCode","ProductId","AmazonId"],"members":{"ClientId":{},"UserCode":{},"ProductId":{},"DeviceSerialNumber":{},"AmazonId":{},"RoomArn":{},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"DeviceArn":{}}}},"RejectSkill":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"ResolveRoom":{"input":{"type":"structure","required":["UserId","SkillId"],"members":{"UserId":{},"SkillId":{}}},"output":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"RoomSkillParameters":{"type":"list","member":{"shape":"S5u"}}}}},"RevokeInvitation":{"input":{"type":"structure","members":{"UserArn":{},"EnrollmentId":{}}},"output":{"type":"structure","members":{}}},"SearchAddressBooks":{"input":{"type":"structure","members":{"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AddressBooks":{"type":"list","member":{"type":"structure","members":{"AddressBookArn":{},"Name":{},"Description":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchContacts":{"input":{"type":"structure","members":{"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Contacts":{"type":"list","member":{"type":"structure","members":{"ContactArn":{},"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1g"},"PhoneNumbers":{"shape":"S1h"},"SipAddresses":{"shape":"S1k"}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchDevices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"}}},"output":{"type":"structure","members":{"Devices":{"type":"list","member":{"type":"structure","members":{"DeviceArn":{},"DeviceSerialNumber":{},"DeviceType":{},"DeviceName":{},"SoftwareVersion":{},"MacAddress":{},"DeviceStatus":{},"NetworkProfileArn":{},"NetworkProfileName":{},"RoomArn":{},"RoomName":{},"DeviceStatusInfo":{"shape":"S4t"},"CreatedTime":{"type":"timestamp"}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchNetworkProfiles":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"}}},"output":{"type":"structure","members":{"NetworkProfiles":{"type":"list","member":{"type":"structure","members":{"NetworkProfileArn":{},"NetworkProfileName":{},"Description":{},"Ssid":{},"SecurityType":{},"EapMethod":{},"CertificateAuthorityArn":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchProfiles":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"}}},"output":{"type":"structure","members":{"Profiles":{"type":"list","member":{"type":"structure","members":{"ProfileArn":{},"ProfileName":{},"IsDefault":{"type":"boolean"},"Address":{},"Timezone":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchRooms":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"}}},"output":{"type":"structure","members":{"Rooms":{"type":"list","member":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"Description":{},"ProviderCalendarId":{},"ProfileArn":{},"ProfileName":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchSkillGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"}}},"output":{"type":"structure","members":{"SkillGroups":{"type":"list","member":{"type":"structure","members":{"SkillGroupArn":{},"SkillGroupName":{},"Description":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchUsers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S92"},"SortCriteria":{"shape":"S97"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"UserArn":{},"FirstName":{},"LastName":{},"Email":{},"EnrollmentStatus":{},"EnrollmentId":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SendAnnouncement":{"input":{"type":"structure","required":["RoomFilters","Content","ClientRequestToken"],"members":{"RoomFilters":{"shape":"S92"},"Content":{"type":"structure","members":{"TextList":{"type":"list","member":{"type":"structure","required":["Locale","Value"],"members":{"Locale":{},"Value":{}}}},"SsmlList":{"type":"list","member":{"type":"structure","required":["Locale","Value"],"members":{"Locale":{},"Value":{}}}},"AudioList":{"type":"list","member":{"type":"structure","required":["Locale","Location"],"members":{"Locale":{},"Location":{}}}}}},"TimeToLiveInSeconds":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"AnnouncementArn":{}}}},"SendInvitation":{"input":{"type":"structure","members":{"UserArn":{}}},"output":{"type":"structure","members":{}}},"StartDeviceSync":{"input":{"type":"structure","required":["Features"],"members":{"RoomArn":{},"DeviceArn":{},"Features":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartSmartHomeApplianceDiscovery":{"input":{"type":"structure","required":["RoomArn"],"members":{"RoomArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["Arn","TagKeys"],"members":{"Arn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAddressBook":{"input":{"type":"structure","required":["AddressBookArn"],"members":{"AddressBookArn":{},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateBusinessReportSchedule":{"input":{"type":"structure","required":["ScheduleArn"],"members":{"ScheduleArn":{},"S3BucketName":{},"S3KeyPrefix":{},"Format":{},"ScheduleName":{},"Recurrence":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UpdateConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderArn","ConferenceProviderType","MeetingSetting"],"members":{"ConferenceProviderArn":{},"ConferenceProviderType":{},"IPDialIn":{"shape":"S13"},"PSTNDialIn":{"shape":"S16"},"MeetingSetting":{"shape":"S1b"}}},"output":{"type":"structure","members":{}}},"UpdateContact":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{},"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1g"},"PhoneNumbers":{"shape":"S1h"},"SipAddresses":{"shape":"S1k"}}},"output":{"type":"structure","members":{}}},"UpdateDevice":{"input":{"type":"structure","members":{"DeviceArn":{},"DeviceName":{}}},"output":{"type":"structure","members":{}}},"UpdateGateway":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{},"Name":{},"Description":{},"SoftwareVersion":{}}},"output":{"type":"structure","members":{}}},"UpdateGatewayGroup":{"input":{"type":"structure","required":["GatewayGroupArn"],"members":{"GatewayGroupArn":{},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileArn"],"members":{"NetworkProfileArn":{},"NetworkProfileName":{},"Description":{},"CurrentPassword":{"shape":"S1z"},"NextPassword":{"shape":"S20"},"CertificateAuthorityArn":{},"TrustAnchors":{"shape":"S21"}}},"output":{"type":"structure","members":{}}},"UpdateProfile":{"input":{"type":"structure","members":{"ProfileArn":{},"ProfileName":{},"IsDefault":{"type":"boolean"},"Timezone":{},"Address":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{},"SetupModeDisabled":{"type":"boolean"},"MaxVolumeLimit":{"type":"integer"},"PSTNEnabled":{"type":"boolean"},"DataRetentionOptIn":{"type":"boolean"},"MeetingRoomConfiguration":{"type":"structure","members":{"RoomUtilizationMetricsEnabled":{"type":"boolean"},"EndOfMeetingReminder":{"type":"structure","members":{"ReminderAtMinutes":{"shape":"S2g"},"ReminderType":{},"Enabled":{"type":"boolean"}}},"InstantBooking":{"type":"structure","members":{"DurationInMinutes":{"type":"integer"},"Enabled":{"type":"boolean"}}},"RequireCheckIn":{"type":"structure","members":{"ReleaseAfterMinutes":{"type":"integer"},"Enabled":{"type":"boolean"}}}}}}},"output":{"type":"structure","members":{}}},"UpdateRoom":{"input":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"Description":{},"ProviderCalendarId":{},"ProfileArn":{}}},"output":{"type":"structure","members":{}}},"UpdateSkillGroup":{"input":{"type":"structure","members":{"SkillGroupArn":{},"SkillGroupName":{},"Description":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sl":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sv":{"type":"structure","required":["Interval"],"members":{"Interval":{}}},"Sx":{"type":"structure","members":{"StartDate":{}}},"S13":{"type":"structure","required":["Endpoint","CommsProtocol"],"members":{"Endpoint":{},"CommsProtocol":{}}},"S16":{"type":"structure","required":["CountryCode","PhoneNumber","OneClickIdDelay","OneClickPinDelay"],"members":{"CountryCode":{},"PhoneNumber":{},"OneClickIdDelay":{},"OneClickPinDelay":{}}},"S1b":{"type":"structure","required":["RequirePin"],"members":{"RequirePin":{}}},"S1g":{"type":"string","sensitive":true},"S1h":{"type":"list","member":{"type":"structure","required":["Number","Type"],"members":{"Number":{"shape":"S1g"},"Type":{"type":"string","sensitive":true}}}},"S1k":{"type":"list","member":{"type":"structure","required":["Uri","Type"],"members":{"Uri":{"type":"string","sensitive":true},"Type":{"type":"string","sensitive":true}}}},"S1z":{"type":"string","sensitive":true},"S20":{"type":"string","sensitive":true},"S21":{"type":"list","member":{}},"S2g":{"type":"list","member":{"type":"integer"}},"S4d":{"type":"structure","members":{"DefaultConferenceProviderArn":{}}},"S4g":{"type":"structure","members":{"Arn":{},"Name":{},"Type":{},"IPDialIn":{"shape":"S13"},"PSTNDialIn":{"shape":"S16"},"MeetingSetting":{"shape":"S1b"}}},"S4t":{"type":"structure","members":{"DeviceStatusDetails":{"type":"list","member":{"type":"structure","members":{"Feature":{},"Code":{}}}},"ConnectionStatus":{},"ConnectionStatusUpdatedTime":{"type":"timestamp"}}},"S5e":{"type":"list","member":{}},"S5u":{"type":"structure","required":["ParameterKey","ParameterValue"],"members":{"ParameterKey":{},"ParameterValue":{}}},"S92":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S97":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBusinessReportSchedules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListConferenceProviders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDeviceEvents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGatewayGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGateways":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSkills":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSkillsStoreCategories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSkillsStoreSkillsByCategory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSmartHomeAppliances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchAddressBooks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchContacts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchNetworkProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchRooms":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchSkillGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloud9'] = {};
	AWS.Cloud9 = Service.defineService('cloud9', ['2017-09-23']);
	Object.defineProperty(apiLoader.services['cloud9'], '2017-09-23', {
	  get: function get() {
	    var model = __webpack_require__(583);
	    model.paginators = __webpack_require__(584).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Cloud9;


/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-23","endpointPrefix":"cloud9","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cloud9","serviceId":"Cloud9","signatureVersion":"v4","targetPrefix":"AWSCloud9WorkspaceManagementService","uid":"cloud9-2017-09-23"},"operations":{"CreateEnvironmentEC2":{"input":{"type":"structure","required":["name","instanceType"],"members":{"name":{},"description":{"shape":"S3"},"clientRequestToken":{},"instanceType":{},"subnetId":{},"imageId":{},"automaticStopTimeMinutes":{"type":"integer"},"ownerArn":{},"tags":{"shape":"Sa"},"connectionType":{},"dryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"environmentId":{}}},"idempotent":true},"CreateEnvironmentMembership":{"input":{"type":"structure","required":["environmentId","userArn","permissions"],"members":{"environmentId":{},"userArn":{},"permissions":{}}},"output":{"type":"structure","required":["membership"],"members":{"membership":{"shape":"Sl"}}},"idempotent":true},"DeleteEnvironment":{"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteEnvironmentMembership":{"input":{"type":"structure","required":["environmentId","userArn"],"members":{"environmentId":{},"userArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeEnvironmentMemberships":{"input":{"type":"structure","members":{"userArn":{},"environmentId":{},"permissions":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"memberships":{"type":"list","member":{"shape":"Sl"}},"nextToken":{}}}},"DescribeEnvironmentStatus":{"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{}}},"output":{"type":"structure","required":["status","message"],"members":{"status":{},"message":{}}}},"DescribeEnvironments":{"input":{"type":"structure","required":["environmentIds"],"members":{"environmentIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"environments":{"type":"list","member":{"type":"structure","required":["type","arn","ownerArn"],"members":{"id":{},"name":{},"description":{"shape":"S3"},"type":{},"connectionType":{},"arn":{},"ownerArn":{},"lifecycle":{"type":"structure","members":{"status":{},"reason":{},"failureResource":{}}},"managedCredentialsStatus":{}}}}}}},"ListEnvironments":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"environmentIds":{"type":"list","member":{}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sa"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{"shape":"Sc"},"sensitive":true}}},"output":{"type":"structure","members":{}}},"UpdateEnvironment":{"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{},"name":{},"description":{"shape":"S3"},"managedCredentialsAction":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateEnvironmentMembership":{"input":{"type":"structure","required":["environmentId","userArn","permissions"],"members":{"environmentId":{},"userArn":{},"permissions":{}}},"output":{"type":"structure","members":{"membership":{"shape":"Sl"}}},"idempotent":true}},"shapes":{"S3":{"type":"string","sensitive":true},"Sa":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"Sc"},"Value":{"type":"string","sensitive":true}},"sensitive":true},"sensitive":true},"Sc":{"type":"string","sensitive":true},"Sl":{"type":"structure","required":["permissions","userId","userArn","environmentId"],"members":{"permissions":{},"userId":{},"userArn":{},"environmentId":{},"lastAccess":{"type":"timestamp"}}}}}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeEnvironmentMemberships":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEnvironments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['serverlessapplicationrepository'] = {};
	AWS.ServerlessApplicationRepository = Service.defineService('serverlessapplicationrepository', ['2017-09-08']);
	Object.defineProperty(apiLoader.services['serverlessapplicationrepository'], '2017-09-08', {
	  get: function get() {
	    var model = __webpack_require__(586);
	    model.paginators = __webpack_require__(587).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ServerlessApplicationRepository;


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-09-08","endpointPrefix":"serverlessrepo","signingName":"serverlessrepo","serviceFullName":"AWSServerlessApplicationRepository","serviceId":"ServerlessApplicationRepository","protocol":"rest-json","jsonVersion":"1.1","uid":"serverlessrepo-2017-09-08","signatureVersion":"v4"},"operations":{"CreateApplication":{"http":{"requestUri":"/applications","responseCode":201},"input":{"type":"structure","members":{"Author":{"locationName":"author"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseBody":{"locationName":"licenseBody"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeBody":{"locationName":"readmeBody"},"ReadmeUrl":{"locationName":"readmeUrl"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"TemplateBody":{"locationName":"templateBody"},"TemplateUrl":{"locationName":"templateUrl"}},"required":["Description","Name","Author"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"IsVerifiedAuthor":{"locationName":"isVerifiedAuthor","type":"boolean"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeUrl":{"locationName":"readmeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"VerifiedAuthorUrl":{"locationName":"verifiedAuthorUrl"},"Version":{"shape":"S6","locationName":"version"}}}},"CreateApplicationVersion":{"http":{"method":"PUT","requestUri":"/applications/{applicationId}/versions/{semanticVersion}","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"SemanticVersion":{"location":"uri","locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"TemplateBody":{"locationName":"templateBody"},"TemplateUrl":{"locationName":"templateUrl"}},"required":["ApplicationId","SemanticVersion"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ParameterDefinitions":{"shape":"S7","locationName":"parameterDefinitions"},"RequiredCapabilities":{"shape":"Sa","locationName":"requiredCapabilities"},"ResourcesSupported":{"locationName":"resourcesSupported","type":"boolean"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"TemplateUrl":{"locationName":"templateUrl"}}}},"CreateCloudFormationChangeSet":{"http":{"requestUri":"/applications/{applicationId}/changesets","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"Capabilities":{"shape":"S3","locationName":"capabilities"},"ChangeSetName":{"locationName":"changeSetName"},"ClientToken":{"locationName":"clientToken"},"Description":{"locationName":"description"},"NotificationArns":{"shape":"S3","locationName":"notificationArns"},"ParameterOverrides":{"locationName":"parameterOverrides","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"Value":{"locationName":"value"}},"required":["Value","Name"]}},"ResourceTypes":{"shape":"S3","locationName":"resourceTypes"},"RollbackConfiguration":{"locationName":"rollbackConfiguration","type":"structure","members":{"MonitoringTimeInMinutes":{"locationName":"monitoringTimeInMinutes","type":"integer"},"RollbackTriggers":{"locationName":"rollbackTriggers","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Type":{"locationName":"type"}},"required":["Type","Arn"]}}}},"SemanticVersion":{"locationName":"semanticVersion"},"StackName":{"locationName":"stackName"},"Tags":{"locationName":"tags","type":"list","member":{"type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}},"required":["Value","Key"]}},"TemplateId":{"locationName":"templateId"}},"required":["ApplicationId","StackName"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"ChangeSetId":{"locationName":"changeSetId"},"SemanticVersion":{"locationName":"semanticVersion"},"StackId":{"locationName":"stackId"}}}},"CreateCloudFormationTemplate":{"http":{"requestUri":"/applications/{applicationId}/templates","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"SemanticVersion":{"locationName":"semanticVersion"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ExpirationTime":{"locationName":"expirationTime"},"SemanticVersion":{"locationName":"semanticVersion"},"Status":{"locationName":"status"},"TemplateId":{"locationName":"templateId"},"TemplateUrl":{"locationName":"templateUrl"}}}},"DeleteApplication":{"http":{"method":"DELETE","requestUri":"/applications/{applicationId}","responseCode":204},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"}},"required":["ApplicationId"]}},"GetApplication":{"http":{"method":"GET","requestUri":"/applications/{applicationId}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"SemanticVersion":{"location":"querystring","locationName":"semanticVersion"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"IsVerifiedAuthor":{"locationName":"isVerifiedAuthor","type":"boolean"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeUrl":{"locationName":"readmeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"VerifiedAuthorUrl":{"locationName":"verifiedAuthorUrl"},"Version":{"shape":"S6","locationName":"version"}}}},"GetApplicationPolicy":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/policy","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"Statements":{"shape":"Sv","locationName":"statements"}}}},"GetCloudFormationTemplate":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/templates/{templateId}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"TemplateId":{"location":"uri","locationName":"templateId"}},"required":["ApplicationId","TemplateId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ExpirationTime":{"locationName":"expirationTime"},"SemanticVersion":{"locationName":"semanticVersion"},"Status":{"locationName":"status"},"TemplateId":{"locationName":"templateId"},"TemplateUrl":{"locationName":"templateUrl"}}}},"ListApplicationDependencies":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/dependencies","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"MaxItems":{"location":"querystring","locationName":"maxItems","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"SemanticVersion":{"location":"querystring","locationName":"semanticVersion"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"Dependencies":{"locationName":"dependencies","type":"list","member":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"SemanticVersion":{"locationName":"semanticVersion"}},"required":["ApplicationId","SemanticVersion"]}},"NextToken":{"locationName":"nextToken"}}}},"ListApplicationVersions":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/versions","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"MaxItems":{"location":"querystring","locationName":"maxItems","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Versions":{"locationName":"versions","type":"list","member":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"}},"required":["CreationTime","ApplicationId","SemanticVersion"]}}}}},"ListApplications":{"http":{"method":"GET","requestUri":"/applications","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"maxItems","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Applications":{"locationName":"applications","type":"list","member":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"Name":{"locationName":"name"},"SpdxLicenseId":{"locationName":"spdxLicenseId"}},"required":["Description","Author","ApplicationId","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"PutApplicationPolicy":{"http":{"method":"PUT","requestUri":"/applications/{applicationId}/policy","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"Statements":{"shape":"Sv","locationName":"statements"}},"required":["ApplicationId","Statements"]},"output":{"type":"structure","members":{"Statements":{"shape":"Sv","locationName":"statements"}}}},"UnshareApplication":{"http":{"requestUri":"/applications/{applicationId}/unshare","responseCode":204},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"OrganizationId":{"locationName":"organizationId"}},"required":["ApplicationId","OrganizationId"]}},"UpdateApplication":{"http":{"method":"PATCH","requestUri":"/applications/{applicationId}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"Author":{"locationName":"author"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"ReadmeBody":{"locationName":"readmeBody"},"ReadmeUrl":{"locationName":"readmeUrl"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"IsVerifiedAuthor":{"locationName":"isVerifiedAuthor","type":"boolean"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeUrl":{"locationName":"readmeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"VerifiedAuthorUrl":{"locationName":"verifiedAuthorUrl"},"Version":{"shape":"S6","locationName":"version"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S6":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ParameterDefinitions":{"shape":"S7","locationName":"parameterDefinitions"},"RequiredCapabilities":{"shape":"Sa","locationName":"requiredCapabilities"},"ResourcesSupported":{"locationName":"resourcesSupported","type":"boolean"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"TemplateUrl":{"locationName":"templateUrl"}},"required":["TemplateUrl","ParameterDefinitions","ResourcesSupported","CreationTime","RequiredCapabilities","ApplicationId","SemanticVersion"]},"S7":{"type":"list","member":{"type":"structure","members":{"AllowedPattern":{"locationName":"allowedPattern"},"AllowedValues":{"shape":"S3","locationName":"allowedValues"},"ConstraintDescription":{"locationName":"constraintDescription"},"DefaultValue":{"locationName":"defaultValue"},"Description":{"locationName":"description"},"MaxLength":{"locationName":"maxLength","type":"integer"},"MaxValue":{"locationName":"maxValue","type":"integer"},"MinLength":{"locationName":"minLength","type":"integer"},"MinValue":{"locationName":"minValue","type":"integer"},"Name":{"locationName":"name"},"NoEcho":{"locationName":"noEcho","type":"boolean"},"ReferencedByResources":{"shape":"S3","locationName":"referencedByResources"},"Type":{"locationName":"type"}},"required":["ReferencedByResources","Name"]}},"Sa":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","members":{"Actions":{"shape":"S3","locationName":"actions"},"PrincipalOrgIDs":{"shape":"S3","locationName":"principalOrgIDs"},"Principals":{"shape":"S3","locationName":"principals"},"StatementId":{"locationName":"statementId"}},"required":["Principals","Actions"]}}}}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplicationVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxItems"},"ListApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxItems"},"ListApplicationDependencies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxItems"}}}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['servicediscovery'] = {};
	AWS.ServiceDiscovery = Service.defineService('servicediscovery', ['2017-03-14']);
	Object.defineProperty(apiLoader.services['servicediscovery'], '2017-03-14', {
	  get: function get() {
	    var model = __webpack_require__(589);
	    model.paginators = __webpack_require__(590).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ServiceDiscovery;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-14","endpointPrefix":"servicediscovery","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ServiceDiscovery","serviceFullName":"AWS Cloud Map","serviceId":"ServiceDiscovery","signatureVersion":"v4","targetPrefix":"Route53AutoNaming_v20170314","uid":"servicediscovery-2017-03-14"},"operations":{"CreateHttpNamespace":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CreatePrivateDnsNamespace":{"input":{"type":"structure","required":["Name","Vpc"],"members":{"Name":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{},"Vpc":{},"Tags":{"shape":"S5"},"Properties":{"type":"structure","required":["DnsProperties"],"members":{"DnsProperties":{"type":"structure","required":["SOA"],"members":{"SOA":{"shape":"Sf"}}}}}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CreatePublicDnsNamespace":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{},"Tags":{"shape":"S5"},"Properties":{"type":"structure","required":["DnsProperties"],"members":{"DnsProperties":{"type":"structure","required":["SOA"],"members":{"SOA":{"shape":"Sf"}}}}}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CreateService":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"NamespaceId":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{},"DnsConfig":{"shape":"Sp"},"HealthCheckConfig":{"shape":"Su"},"HealthCheckCustomConfig":{"shape":"Sy"},"Tags":{"shape":"S5"},"Type":{}}},"output":{"type":"structure","members":{"Service":{"shape":"S11"}}}},"DeleteNamespace":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DeleteService":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DeregisterInstance":{"input":{"type":"structure","required":["ServiceId","InstanceId"],"members":{"ServiceId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DiscoverInstances":{"input":{"type":"structure","required":["NamespaceName","ServiceName"],"members":{"NamespaceName":{},"ServiceName":{},"MaxResults":{"type":"integer"},"QueryParameters":{"shape":"S1f"},"OptionalParameters":{"shape":"S1f"},"HealthStatus":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"NamespaceName":{},"ServiceName":{},"HealthStatus":{},"Attributes":{"shape":"S1f"}}}}}},"endpoint":{"hostPrefix":"data-"}},"GetInstance":{"input":{"type":"structure","required":["ServiceId","InstanceId"],"members":{"ServiceId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"Instance":{"type":"structure","required":["Id"],"members":{"Id":{},"CreatorRequestId":{},"Attributes":{"shape":"S1f"}}}}}},"GetInstancesHealthStatus":{"input":{"type":"structure","required":["ServiceId"],"members":{"ServiceId":{},"Instances":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Status":{"type":"map","key":{},"value":{}},"NextToken":{}}}},"GetNamespace":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Namespace":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{},"Description":{},"ServiceCount":{"type":"integer"},"Properties":{"shape":"S20"},"CreateDate":{"type":"timestamp"},"CreatorRequestId":{}}}}}},"GetOperation":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"Operation":{"type":"structure","members":{"Id":{},"Type":{},"Status":{},"ErrorMessage":{},"ErrorCode":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"Targets":{"type":"map","key":{},"value":{}}}}}}},"GetService":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Service":{"shape":"S11"}}}},"ListInstances":{"input":{"type":"structure","required":["ServiceId"],"members":{"ServiceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Attributes":{"shape":"S1f"}}}},"NextToken":{}}}},"ListNamespaces":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2m"},"Condition":{}}}}}},"output":{"type":"structure","members":{"Namespaces":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{},"Description":{},"ServiceCount":{"type":"integer"},"Properties":{"shape":"S20"},"CreateDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListOperations":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2m"},"Condition":{}}}}}},"output":{"type":"structure","members":{"Operations":{"type":"list","member":{"type":"structure","members":{"Id":{},"Status":{}}}},"NextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2m"},"Condition":{}}}}}},"output":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{},"Description":{},"InstanceCount":{"type":"integer"},"DnsConfig":{"shape":"Sp"},"HealthCheckConfig":{"shape":"Su"},"HealthCheckCustomConfig":{"shape":"Sy"},"CreateDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5"}}}},"RegisterInstance":{"input":{"type":"structure","required":["ServiceId","InstanceId","Attributes"],"members":{"ServiceId":{},"InstanceId":{},"CreatorRequestId":{"idempotencyToken":true},"Attributes":{"shape":"S1f"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateHttpNamespace":{"input":{"type":"structure","required":["Id","Namespace"],"members":{"Id":{},"UpdaterRequestId":{"idempotencyToken":true},"Namespace":{"type":"structure","required":["Description"],"members":{"Description":{}}}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdateInstanceCustomHealthStatus":{"input":{"type":"structure","required":["ServiceId","InstanceId","Status"],"members":{"ServiceId":{},"InstanceId":{},"Status":{}}}},"UpdatePrivateDnsNamespace":{"input":{"type":"structure","required":["Id","Namespace"],"members":{"Id":{},"UpdaterRequestId":{"idempotencyToken":true},"Namespace":{"type":"structure","members":{"Description":{},"Properties":{"type":"structure","required":["DnsProperties"],"members":{"DnsProperties":{"type":"structure","required":["SOA"],"members":{"SOA":{"shape":"S3q"}}}}}}}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdatePublicDnsNamespace":{"input":{"type":"structure","required":["Id","Namespace"],"members":{"Id":{},"UpdaterRequestId":{"idempotencyToken":true},"Namespace":{"type":"structure","members":{"Description":{},"Properties":{"type":"structure","required":["DnsProperties"],"members":{"DnsProperties":{"type":"structure","required":["SOA"],"members":{"SOA":{"shape":"S3q"}}}}}}}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdateService":{"input":{"type":"structure","required":["Id","Service"],"members":{"Id":{},"Service":{"type":"structure","members":{"Description":{},"DnsConfig":{"type":"structure","required":["DnsRecords"],"members":{"DnsRecords":{"shape":"Sr"}}},"HealthCheckConfig":{"shape":"Su"}}}}},"output":{"type":"structure","members":{"OperationId":{}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["TTL"],"members":{"TTL":{"type":"long"}}},"Sp":{"type":"structure","required":["DnsRecords"],"members":{"NamespaceId":{"deprecated":true,"deprecatedMessage":"Top level attribute in request should be used to reference namespace-id"},"RoutingPolicy":{},"DnsRecords":{"shape":"Sr"}}},"Sr":{"type":"list","member":{"type":"structure","required":["Type","TTL"],"members":{"Type":{},"TTL":{"type":"long"}}}},"Su":{"type":"structure","required":["Type"],"members":{"Type":{},"ResourcePath":{},"FailureThreshold":{"type":"integer"}}},"Sy":{"type":"structure","members":{"FailureThreshold":{"deprecated":true,"deprecatedMessage":"Configurable FailureThreshold of HealthCheckCustomConfig is deprecated.  It will always have value 1.","type":"integer"}}},"S11":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"NamespaceId":{},"Description":{},"InstanceCount":{"type":"integer"},"DnsConfig":{"shape":"Sp"},"Type":{},"HealthCheckConfig":{"shape":"Su"},"HealthCheckCustomConfig":{"shape":"Sy"},"CreateDate":{"type":"timestamp"},"CreatorRequestId":{}}},"S1f":{"type":"map","key":{},"value":{}},"S20":{"type":"structure","members":{"DnsProperties":{"type":"structure","members":{"HostedZoneId":{},"SOA":{"shape":"Sf"}}},"HttpProperties":{"type":"structure","members":{"HttpName":{}}}}},"S2m":{"type":"list","member":{}},"S3q":{"type":"structure","required":["TTL"],"members":{"TTL":{"type":"long"}}}}}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetInstancesHealthStatus":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNamespaces":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOperations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['workmail'] = {};
	AWS.WorkMail = Service.defineService('workmail', ['2017-10-01']);
	Object.defineProperty(apiLoader.services['workmail'], '2017-10-01', {
	  get: function get() {
	    var model = __webpack_require__(592);
	    model.paginators = __webpack_require__(593).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WorkMail;


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-01","endpointPrefix":"workmail","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon WorkMail","serviceId":"WorkMail","signatureVersion":"v4","targetPrefix":"WorkMailService","uid":"workmail-2017-10-01"},"operations":{"AssociateDelegateToResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId","EntityId"],"members":{"OrganizationId":{},"ResourceId":{},"EntityId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateMemberToGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId","MemberId"],"members":{"OrganizationId":{},"GroupId":{},"MemberId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"CancelMailboxExportJob":{"input":{"type":"structure","required":["ClientToken","JobId","OrganizationId"],"members":{"ClientToken":{"idempotencyToken":true},"JobId":{},"OrganizationId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateAlias":{"input":{"type":"structure","required":["OrganizationId","EntityId","Alias"],"members":{"OrganizationId":{},"EntityId":{},"Alias":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateGroup":{"input":{"type":"structure","required":["OrganizationId","Name"],"members":{"OrganizationId":{},"Name":{}}},"output":{"type":"structure","members":{"GroupId":{}}},"idempotent":true},"CreateMobileDeviceAccessRule":{"input":{"type":"structure","required":["OrganizationId","Name","Effect"],"members":{"OrganizationId":{},"ClientToken":{"idempotencyToken":true},"Name":{},"Description":{},"Effect":{},"DeviceTypes":{"shape":"Sm"},"NotDeviceTypes":{"shape":"Sm"},"DeviceModels":{"shape":"So"},"NotDeviceModels":{"shape":"So"},"DeviceOperatingSystems":{"shape":"Sq"},"NotDeviceOperatingSystems":{"shape":"Sq"},"DeviceUserAgents":{"shape":"Ss"},"NotDeviceUserAgents":{"shape":"Ss"}}},"output":{"type":"structure","members":{"MobileDeviceAccessRuleId":{}}}},"CreateOrganization":{"input":{"type":"structure","required":["Alias"],"members":{"DirectoryId":{},"Alias":{},"ClientToken":{"idempotencyToken":true},"Domains":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"HostedZoneId":{}}}},"KmsKeyArn":{},"EnableInteroperability":{"type":"boolean"}}},"output":{"type":"structure","members":{"OrganizationId":{}}},"idempotent":true},"CreateResource":{"input":{"type":"structure","required":["OrganizationId","Name","Type"],"members":{"OrganizationId":{},"Name":{},"Type":{}}},"output":{"type":"structure","members":{"ResourceId":{}}},"idempotent":true},"CreateUser":{"input":{"type":"structure","required":["OrganizationId","Name","DisplayName","Password"],"members":{"OrganizationId":{},"Name":{},"DisplayName":{},"Password":{"shape":"S1d"}}},"output":{"type":"structure","members":{"UserId":{}}},"idempotent":true},"DeleteAccessControlRule":{"input":{"type":"structure","required":["OrganizationId","Name"],"members":{"OrganizationId":{},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["OrganizationId","EntityId","Alias"],"members":{"OrganizationId":{},"EntityId":{},"Alias":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteEmailMonitoringConfiguration":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId"],"members":{"OrganizationId":{},"GroupId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteMailboxPermissions":{"input":{"type":"structure","required":["OrganizationId","EntityId","GranteeId"],"members":{"OrganizationId":{},"EntityId":{},"GranteeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteMobileDeviceAccessOverride":{"input":{"type":"structure","required":["OrganizationId","UserId","DeviceId"],"members":{"OrganizationId":{},"UserId":{},"DeviceId":{}}},"output":{"type":"structure","members":{}}},"DeleteMobileDeviceAccessRule":{"input":{"type":"structure","required":["OrganizationId","MobileDeviceAccessRuleId"],"members":{"OrganizationId":{},"MobileDeviceAccessRuleId":{}}},"output":{"type":"structure","members":{}}},"DeleteOrganization":{"input":{"type":"structure","required":["OrganizationId","DeleteDirectory"],"members":{"ClientToken":{"idempotencyToken":true},"OrganizationId":{},"DeleteDirectory":{"type":"boolean"}}},"output":{"type":"structure","members":{"OrganizationId":{},"State":{}}},"idempotent":true},"DeleteResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["OrganizationId","Id"],"members":{"OrganizationId":{},"Id":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteUser":{"input":{"type":"structure","required":["OrganizationId","UserId"],"members":{"OrganizationId":{},"UserId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeregisterFromWorkMail":{"input":{"type":"structure","required":["OrganizationId","EntityId"],"members":{"OrganizationId":{},"EntityId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeregisterMailDomain":{"input":{"type":"structure","required":["OrganizationId","DomainName"],"members":{"OrganizationId":{},"DomainName":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeEmailMonitoringConfiguration":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"RoleArn":{},"LogGroupArn":{}}},"idempotent":true},"DescribeGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId"],"members":{"OrganizationId":{},"GroupId":{}}},"output":{"type":"structure","members":{"GroupId":{},"Name":{},"Email":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}},"idempotent":true},"DescribeInboundDmarcSettings":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"Enforced":{"type":"boolean"}}},"idempotent":true},"DescribeMailboxExportJob":{"input":{"type":"structure","required":["JobId","OrganizationId"],"members":{"JobId":{},"OrganizationId":{}}},"output":{"type":"structure","members":{"EntityId":{},"Description":{},"RoleArn":{},"KmsKeyArn":{},"S3BucketName":{},"S3Prefix":{},"S3Path":{},"EstimatedProgress":{"type":"integer"},"State":{},"ErrorInfo":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"idempotent":true},"DescribeOrganization":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"OrganizationId":{},"Alias":{},"State":{},"DirectoryId":{},"DirectoryType":{},"DefaultMailDomain":{},"CompletedDate":{"type":"timestamp"},"ErrorMessage":{},"ARN":{}}},"idempotent":true},"DescribeResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{}}},"output":{"type":"structure","members":{"ResourceId":{},"Email":{},"Name":{},"Type":{},"BookingOptions":{"shape":"S2x"},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}},"idempotent":true},"DescribeUser":{"input":{"type":"structure","required":["OrganizationId","UserId"],"members":{"OrganizationId":{},"UserId":{}}},"output":{"type":"structure","members":{"UserId":{},"Name":{},"Email":{},"DisplayName":{},"State":{},"UserRole":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}},"idempotent":true},"DisassociateDelegateFromResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId","EntityId"],"members":{"OrganizationId":{},"ResourceId":{},"EntityId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateMemberFromGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId","MemberId"],"members":{"OrganizationId":{},"GroupId":{},"MemberId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetAccessControlEffect":{"input":{"type":"structure","required":["OrganizationId","IpAddress","Action","UserId"],"members":{"OrganizationId":{},"IpAddress":{},"Action":{},"UserId":{}}},"output":{"type":"structure","members":{"Effect":{},"MatchedRules":{"type":"list","member":{}}}}},"GetDefaultRetentionPolicy":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"FolderConfigurations":{"shape":"S3d"}}},"idempotent":true},"GetMailDomain":{"input":{"type":"structure","required":["OrganizationId","DomainName"],"members":{"OrganizationId":{},"DomainName":{}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"Type":{},"Hostname":{},"Value":{}}}},"IsTestDomain":{"type":"boolean"},"IsDefault":{"type":"boolean"},"OwnershipVerificationStatus":{},"DkimVerificationStatus":{}}},"idempotent":true},"GetMailboxDetails":{"input":{"type":"structure","required":["OrganizationId","UserId"],"members":{"OrganizationId":{},"UserId":{}}},"output":{"type":"structure","members":{"MailboxQuota":{"type":"integer"},"MailboxSize":{"type":"double"}}},"idempotent":true},"GetMobileDeviceAccessEffect":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"DeviceType":{},"DeviceModel":{},"DeviceOperatingSystem":{},"DeviceUserAgent":{}}},"output":{"type":"structure","members":{"Effect":{},"MatchedRules":{"type":"list","member":{"type":"structure","members":{"MobileDeviceAccessRuleId":{},"Name":{}}}}}}},"GetMobileDeviceAccessOverride":{"input":{"type":"structure","required":["OrganizationId","UserId","DeviceId"],"members":{"OrganizationId":{},"UserId":{},"DeviceId":{}}},"output":{"type":"structure","members":{"UserId":{},"DeviceId":{},"Effect":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateModified":{"type":"timestamp"}}}},"ListAccessControlRules":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Effect":{},"Description":{},"IpRanges":{"shape":"S42"},"NotIpRanges":{"shape":"S42"},"Actions":{"shape":"S44"},"NotActions":{"shape":"S44"},"UserIds":{"shape":"S45"},"NotUserIds":{"shape":"S45"},"DateCreated":{"type":"timestamp"},"DateModified":{"type":"timestamp"}}}}}}},"ListAliases":{"input":{"type":"structure","required":["OrganizationId","EntityId"],"members":{"OrganizationId":{},"EntityId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{}},"NextToken":{}}},"idempotent":true},"ListGroupMembers":{"input":{"type":"structure","required":["OrganizationId","GroupId"],"members":{"OrganizationId":{},"GroupId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Members":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Type":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListGroups":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Email":{},"Name":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListMailDomains":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"MailDomains":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"DefaultDomain":{"type":"boolean"}}}},"NextToken":{}}},"idempotent":true},"ListMailboxExportJobs":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Jobs":{"type":"list","member":{"type":"structure","members":{"JobId":{},"EntityId":{},"Description":{},"S3BucketName":{},"S3Path":{},"EstimatedProgress":{"type":"integer"},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListMailboxPermissions":{"input":{"type":"structure","required":["OrganizationId","EntityId"],"members":{"OrganizationId":{},"EntityId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","required":["GranteeId","GranteeType","PermissionValues"],"members":{"GranteeId":{},"GranteeType":{},"PermissionValues":{"shape":"S4w"}}}},"NextToken":{}}},"idempotent":true},"ListMobileDeviceAccessOverrides":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"UserId":{},"DeviceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Overrides":{"type":"list","member":{"type":"structure","members":{"UserId":{},"DeviceId":{},"Effect":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateModified":{"type":"timestamp"}}}},"NextToken":{}}}},"ListMobileDeviceAccessRules":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"MobileDeviceAccessRuleId":{},"Name":{},"Description":{},"Effect":{},"DeviceTypes":{"shape":"Sm"},"NotDeviceTypes":{"shape":"Sm"},"DeviceModels":{"shape":"So"},"NotDeviceModels":{"shape":"So"},"DeviceOperatingSystems":{"shape":"Sq"},"NotDeviceOperatingSystems":{"shape":"Sq"},"DeviceUserAgents":{"shape":"Ss"},"NotDeviceUserAgents":{"shape":"Ss"},"DateCreated":{"type":"timestamp"},"DateModified":{"type":"timestamp"}}}}}}},"ListOrganizations":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationSummaries":{"type":"list","member":{"type":"structure","members":{"OrganizationId":{},"Alias":{},"DefaultMailDomain":{},"ErrorMessage":{},"State":{}}}},"NextToken":{}}},"idempotent":true},"ListResourceDelegates":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Delegates":{"type":"list","member":{"type":"structure","required":["Id","Type"],"members":{"Id":{},"Type":{}}}},"NextToken":{}}},"idempotent":true},"ListResources":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Resources":{"type":"list","member":{"type":"structure","members":{"Id":{},"Email":{},"Name":{},"Type":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5k"}}}},"ListUsers":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"Id":{},"Email":{},"Name":{},"DisplayName":{},"State":{},"UserRole":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"PutAccessControlRule":{"input":{"type":"structure","required":["Name","Effect","Description","OrganizationId"],"members":{"Name":{},"Effect":{},"Description":{},"IpRanges":{"shape":"S42"},"NotIpRanges":{"shape":"S42"},"Actions":{"shape":"S44"},"NotActions":{"shape":"S44"},"UserIds":{"shape":"S45"},"NotUserIds":{"shape":"S45"},"OrganizationId":{}}},"output":{"type":"structure","members":{}}},"PutEmailMonitoringConfiguration":{"input":{"type":"structure","required":["OrganizationId","RoleArn","LogGroupArn"],"members":{"OrganizationId":{},"RoleArn":{},"LogGroupArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"PutInboundDmarcSettings":{"input":{"type":"structure","required":["OrganizationId","Enforced"],"members":{"OrganizationId":{},"Enforced":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"PutMailboxPermissions":{"input":{"type":"structure","required":["OrganizationId","EntityId","GranteeId","PermissionValues"],"members":{"OrganizationId":{},"EntityId":{},"GranteeId":{},"PermissionValues":{"shape":"S4w"}}},"output":{"type":"structure","members":{}},"idempotent":true},"PutMobileDeviceAccessOverride":{"input":{"type":"structure","required":["OrganizationId","UserId","DeviceId","Effect"],"members":{"OrganizationId":{},"UserId":{},"DeviceId":{},"Effect":{},"Description":{}}},"output":{"type":"structure","members":{}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["OrganizationId","Name","FolderConfigurations"],"members":{"OrganizationId":{},"Id":{},"Name":{},"Description":{"type":"string","sensitive":true},"FolderConfigurations":{"shape":"S3d"}}},"output":{"type":"structure","members":{}},"idempotent":true},"RegisterMailDomain":{"input":{"type":"structure","required":["OrganizationId","DomainName"],"members":{"ClientToken":{"idempotencyToken":true},"OrganizationId":{},"DomainName":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RegisterToWorkMail":{"input":{"type":"structure","required":["OrganizationId","EntityId","Email"],"members":{"OrganizationId":{},"EntityId":{},"Email":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"ResetPassword":{"input":{"type":"structure","required":["OrganizationId","UserId","Password"],"members":{"OrganizationId":{},"UserId":{},"Password":{"shape":"S1d"}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartMailboxExportJob":{"input":{"type":"structure","required":["ClientToken","OrganizationId","EntityId","RoleArn","KmsKeyArn","S3BucketName","S3Prefix"],"members":{"ClientToken":{"idempotencyToken":true},"OrganizationId":{},"EntityId":{},"Description":{},"RoleArn":{},"KmsKeyArn":{},"S3BucketName":{},"S3Prefix":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5k"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDefaultMailDomain":{"input":{"type":"structure","required":["OrganizationId","DomainName"],"members":{"OrganizationId":{},"DomainName":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateMailboxQuota":{"input":{"type":"structure","required":["OrganizationId","UserId","MailboxQuota"],"members":{"OrganizationId":{},"UserId":{},"MailboxQuota":{"type":"integer"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateMobileDeviceAccessRule":{"input":{"type":"structure","required":["OrganizationId","MobileDeviceAccessRuleId","Name","Effect"],"members":{"OrganizationId":{},"MobileDeviceAccessRuleId":{},"Name":{},"Description":{},"Effect":{},"DeviceTypes":{"shape":"Sm"},"NotDeviceTypes":{"shape":"Sm"},"DeviceModels":{"shape":"So"},"NotDeviceModels":{"shape":"So"},"DeviceOperatingSystems":{"shape":"Sq"},"NotDeviceOperatingSystems":{"shape":"Sq"},"DeviceUserAgents":{"shape":"Ss"},"NotDeviceUserAgents":{"shape":"Ss"}}},"output":{"type":"structure","members":{}}},"UpdatePrimaryEmailAddress":{"input":{"type":"structure","required":["OrganizationId","EntityId","Email"],"members":{"OrganizationId":{},"EntityId":{},"Email":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{},"Name":{},"BookingOptions":{"shape":"S2x"}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"Sm":{"type":"list","member":{}},"So":{"type":"list","member":{}},"Sq":{"type":"list","member":{}},"Ss":{"type":"list","member":{}},"S1d":{"type":"string","sensitive":true},"S2x":{"type":"structure","members":{"AutoAcceptRequests":{"type":"boolean"},"AutoDeclineRecurringRequests":{"type":"boolean"},"AutoDeclineConflictingRequests":{"type":"boolean"}}},"S3d":{"type":"list","member":{"type":"structure","required":["Name","Action"],"members":{"Name":{},"Action":{},"Period":{"type":"integer"}}}},"S42":{"type":"list","member":{}},"S44":{"type":"list","member":{}},"S45":{"type":"list","member":{}},"S4w":{"type":"list","member":{}},"S5k":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAliases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGroupMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMailDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMailboxExportJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMailboxPermissions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMobileDeviceAccessOverrides":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOrganizations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResourceDelegates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['autoscalingplans'] = {};
	AWS.AutoScalingPlans = Service.defineService('autoscalingplans', ['2018-01-06']);
	Object.defineProperty(apiLoader.services['autoscalingplans'], '2018-01-06', {
	  get: function get() {
	    var model = __webpack_require__(595);
	    model.paginators = __webpack_require__(596).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AutoScalingPlans;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-01-06","endpointPrefix":"autoscaling-plans","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Auto Scaling Plans","serviceId":"Auto Scaling Plans","signatureVersion":"v4","signingName":"autoscaling-plans","targetPrefix":"AnyScaleScalingPlannerFrontendService","uid":"autoscaling-plans-2018-01-06"},"operations":{"CreateScalingPlan":{"input":{"type":"structure","required":["ScalingPlanName","ApplicationSource","ScalingInstructions"],"members":{"ScalingPlanName":{},"ApplicationSource":{"shape":"S3"},"ScalingInstructions":{"shape":"Sa"}}},"output":{"type":"structure","required":["ScalingPlanVersion"],"members":{"ScalingPlanVersion":{"type":"long"}}}},"DeleteScalingPlan":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"}}},"output":{"type":"structure","members":{}}},"DescribeScalingPlanResources":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPlanResources":{"type":"list","member":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion","ServiceNamespace","ResourceId","ScalableDimension","ScalingStatusCode"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyName","PolicyType"],"members":{"PolicyName":{},"PolicyType":{},"TargetTrackingConfiguration":{"shape":"Sh"}}}},"ScalingStatusCode":{},"ScalingStatusMessage":{}}}},"NextToken":{}}}},"DescribeScalingPlans":{"input":{"type":"structure","members":{"ScalingPlanNames":{"type":"list","member":{}},"ScalingPlanVersion":{"type":"long"},"ApplicationSources":{"type":"list","member":{"shape":"S3"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPlans":{"type":"list","member":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion","ApplicationSource","ScalingInstructions","StatusCode"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ApplicationSource":{"shape":"S3"},"ScalingInstructions":{"shape":"Sa"},"StatusCode":{},"StatusMessage":{},"StatusStartTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetScalingPlanResourceForecastData":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion","ServiceNamespace","ResourceId","ScalableDimension","ForecastDataType","StartTime","EndTime"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"ForecastDataType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"output":{"type":"structure","required":["Datapoints"],"members":{"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"Value":{"type":"double"}}}}}}},"UpdateScalingPlan":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ApplicationSource":{"shape":"S3"},"ScalingInstructions":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","members":{"CloudFormationStackARN":{},"TagFilters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"Sa":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","TargetTrackingConfigurations"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"TargetTrackingConfigurations":{"type":"list","member":{"shape":"Sh"}},"PredefinedLoadMetricSpecification":{"type":"structure","required":["PredefinedLoadMetricType"],"members":{"PredefinedLoadMetricType":{},"ResourceLabel":{}}},"CustomizedLoadMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"shape":"So"},"Statistic":{},"Unit":{}}},"ScheduledActionBufferTime":{"type":"integer"},"PredictiveScalingMaxCapacityBehavior":{},"PredictiveScalingMaxCapacityBuffer":{"type":"integer"},"PredictiveScalingMode":{},"ScalingPolicyUpdateBehavior":{},"DisableDynamicScaling":{"type":"boolean"}}}},"Sh":{"type":"structure","required":["TargetValue"],"members":{"PredefinedScalingMetricSpecification":{"type":"structure","required":["PredefinedScalingMetricType"],"members":{"PredefinedScalingMetricType":{},"ResourceLabel":{}}},"CustomizedScalingMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"shape":"So"},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"EstimatedInstanceWarmup":{"type":"integer"}}},"So":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['transcribeservice'] = {};
	AWS.TranscribeService = Service.defineService('transcribeservice', ['2017-10-26']);
	Object.defineProperty(apiLoader.services['transcribeservice'], '2017-10-26', {
	  get: function get() {
	    var model = __webpack_require__(598);
	    model.paginators = __webpack_require__(599).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.TranscribeService;


/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-26","endpointPrefix":"transcribe","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Transcribe Service","serviceId":"Transcribe","signatureVersion":"v4","signingName":"transcribe","targetPrefix":"Transcribe","uid":"transcribe-2017-10-26"},"operations":{"CreateCallAnalyticsCategory":{"input":{"type":"structure","required":["CategoryName","Rules"],"members":{"CategoryName":{},"Rules":{"shape":"S3"}}},"output":{"type":"structure","members":{"CategoryProperties":{"shape":"Sl"}}}},"CreateLanguageModel":{"input":{"type":"structure","required":["LanguageCode","BaseModelName","ModelName","InputDataConfig"],"members":{"LanguageCode":{},"BaseModelName":{},"ModelName":{},"InputDataConfig":{"shape":"Sr"},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"LanguageCode":{},"BaseModelName":{},"ModelName":{},"InputDataConfig":{"shape":"Sr"},"ModelStatus":{}}}},"CreateMedicalVocabulary":{"input":{"type":"structure","required":["VocabularyName","LanguageCode","VocabularyFileUri"],"members":{"VocabularyName":{},"LanguageCode":{},"VocabularyFileUri":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"VocabularyState":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{}}}},"CreateVocabulary":{"input":{"type":"structure","required":["VocabularyName","LanguageCode"],"members":{"VocabularyName":{},"LanguageCode":{},"Phrases":{"shape":"S17"},"VocabularyFileUri":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"VocabularyState":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{}}}},"CreateVocabularyFilter":{"input":{"type":"structure","required":["VocabularyFilterName","LanguageCode"],"members":{"VocabularyFilterName":{},"LanguageCode":{},"Words":{"shape":"S1c"},"VocabularyFilterFileUri":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"VocabularyFilterName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"}}}},"DeleteCallAnalyticsCategory":{"input":{"type":"structure","required":["CategoryName"],"members":{"CategoryName":{}}},"output":{"type":"structure","members":{}}},"DeleteCallAnalyticsJob":{"input":{"type":"structure","required":["CallAnalyticsJobName"],"members":{"CallAnalyticsJobName":{}}},"output":{"type":"structure","members":{}}},"DeleteLanguageModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}}},"DeleteMedicalTranscriptionJob":{"input":{"type":"structure","required":["MedicalTranscriptionJobName"],"members":{"MedicalTranscriptionJobName":{}}}},"DeleteMedicalVocabulary":{"input":{"type":"structure","required":["VocabularyName"],"members":{"VocabularyName":{}}}},"DeleteTranscriptionJob":{"input":{"type":"structure","required":["TranscriptionJobName"],"members":{"TranscriptionJobName":{}}}},"DeleteVocabulary":{"input":{"type":"structure","required":["VocabularyName"],"members":{"VocabularyName":{}}}},"DeleteVocabularyFilter":{"input":{"type":"structure","required":["VocabularyFilterName"],"members":{"VocabularyFilterName":{}}}},"DescribeLanguageModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}},"output":{"type":"structure","members":{"LanguageModel":{"shape":"S1t"}}}},"GetCallAnalyticsCategory":{"input":{"type":"structure","required":["CategoryName"],"members":{"CategoryName":{}}},"output":{"type":"structure","members":{"CategoryProperties":{"shape":"Sl"}}}},"GetCallAnalyticsJob":{"input":{"type":"structure","required":["CallAnalyticsJobName"],"members":{"CallAnalyticsJobName":{}}},"output":{"type":"structure","members":{"CallAnalyticsJob":{"shape":"S1y"}}}},"GetMedicalTranscriptionJob":{"input":{"type":"structure","required":["MedicalTranscriptionJobName"],"members":{"MedicalTranscriptionJobName":{}}},"output":{"type":"structure","members":{"MedicalTranscriptionJob":{"shape":"S2k"}}}},"GetMedicalVocabulary":{"input":{"type":"structure","required":["VocabularyName"],"members":{"VocabularyName":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"VocabularyState":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"DownloadUri":{}}}},"GetTranscriptionJob":{"input":{"type":"structure","required":["TranscriptionJobName"],"members":{"TranscriptionJobName":{}}},"output":{"type":"structure","members":{"TranscriptionJob":{"shape":"S2y"}}}},"GetVocabulary":{"input":{"type":"structure","required":["VocabularyName"],"members":{"VocabularyName":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"VocabularyState":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"DownloadUri":{}}}},"GetVocabularyFilter":{"input":{"type":"structure","required":["VocabularyFilterName"],"members":{"VocabularyFilterName":{}}},"output":{"type":"structure","members":{"VocabularyFilterName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"},"DownloadUri":{}}}},"ListCallAnalyticsCategories":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Categories":{"type":"list","member":{"shape":"Sl"}}}}},"ListCallAnalyticsJobs":{"input":{"type":"structure","members":{"Status":{},"JobNameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"CallAnalyticsJobSummaries":{"type":"list","member":{"type":"structure","members":{"CallAnalyticsJobName":{},"CreationTime":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"LanguageCode":{},"CallAnalyticsJobStatus":{},"FailureReason":{}}}}}}},"ListLanguageModels":{"input":{"type":"structure","members":{"StatusEquals":{},"NameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Models":{"type":"list","member":{"shape":"S1t"}}}}},"ListMedicalTranscriptionJobs":{"input":{"type":"structure","members":{"Status":{},"JobNameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"MedicalTranscriptionJobSummaries":{"type":"list","member":{"type":"structure","members":{"MedicalTranscriptionJobName":{},"CreationTime":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"LanguageCode":{},"TranscriptionJobStatus":{},"FailureReason":{},"OutputLocationType":{},"Specialty":{},"ContentIdentificationType":{},"Type":{}}}}}}},"ListMedicalVocabularies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"StateEquals":{},"NameContains":{}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"Vocabularies":{"shape":"S3u"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Su"}}}},"ListTranscriptionJobs":{"input":{"type":"structure","members":{"Status":{},"JobNameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"TranscriptionJobSummaries":{"type":"list","member":{"type":"structure","members":{"TranscriptionJobName":{},"CreationTime":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"LanguageCode":{},"TranscriptionJobStatus":{},"FailureReason":{},"OutputLocationType":{},"ContentRedaction":{"shape":"S27"},"ModelSettings":{"shape":"S30"},"IdentifyLanguage":{"type":"boolean"},"IdentifiedLanguageScore":{"type":"float"}}}}}}},"ListVocabularies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"StateEquals":{},"NameContains":{}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"Vocabularies":{"shape":"S3u"}}}},"ListVocabularyFilters":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{}}},"output":{"type":"structure","members":{"NextToken":{},"VocabularyFilters":{"type":"list","member":{"type":"structure","members":{"VocabularyFilterName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"}}}}}}},"StartCallAnalyticsJob":{"input":{"type":"structure","required":["CallAnalyticsJobName","Media","DataAccessRoleArn"],"members":{"CallAnalyticsJobName":{},"Media":{"shape":"S22"},"OutputLocation":{},"OutputEncryptionKMSKeyId":{},"DataAccessRoleArn":{},"Settings":{"shape":"S25"},"ChannelDefinitions":{"shape":"S2f"}}},"output":{"type":"structure","members":{"CallAnalyticsJob":{"shape":"S1y"}}}},"StartMedicalTranscriptionJob":{"input":{"type":"structure","required":["MedicalTranscriptionJobName","LanguageCode","Media","OutputBucketName","Specialty","Type"],"members":{"MedicalTranscriptionJobName":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"S22"},"OutputBucketName":{},"OutputKey":{},"OutputEncryptionKMSKeyId":{},"KMSEncryptionContext":{"shape":"S4f"},"Settings":{"shape":"S2o"},"ContentIdentificationType":{},"Specialty":{},"Type":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"MedicalTranscriptionJob":{"shape":"S2k"}}}},"StartTranscriptionJob":{"input":{"type":"structure","required":["TranscriptionJobName","Media"],"members":{"TranscriptionJobName":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"S22"},"OutputBucketName":{},"OutputKey":{},"OutputEncryptionKMSKeyId":{},"KMSEncryptionContext":{"shape":"S4f"},"Settings":{"shape":"S2z"},"ModelSettings":{"shape":"S30"},"JobExecutionSettings":{"shape":"S31"},"ContentRedaction":{"shape":"S27"},"IdentifyLanguage":{"type":"boolean"},"LanguageOptions":{"shape":"S2c"},"Subtitles":{"type":"structure","members":{"Formats":{"shape":"S33"},"OutputStartIndex":{"type":"integer"}}},"Tags":{"shape":"Su"},"LanguageIdSettings":{"shape":"S2d"}}},"output":{"type":"structure","members":{"TranscriptionJob":{"shape":"S2y"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCallAnalyticsCategory":{"input":{"type":"structure","required":["CategoryName","Rules"],"members":{"CategoryName":{},"Rules":{"shape":"S3"}}},"output":{"type":"structure","members":{"CategoryProperties":{"shape":"Sl"}}}},"UpdateMedicalVocabulary":{"input":{"type":"structure","required":["VocabularyName","LanguageCode"],"members":{"VocabularyName":{},"LanguageCode":{},"VocabularyFileUri":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"},"VocabularyState":{}}}},"UpdateVocabulary":{"input":{"type":"structure","required":["VocabularyName","LanguageCode"],"members":{"VocabularyName":{},"LanguageCode":{},"Phrases":{"shape":"S17"},"VocabularyFileUri":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"},"VocabularyState":{}}}},"UpdateVocabularyFilter":{"input":{"type":"structure","required":["VocabularyFilterName"],"members":{"VocabularyFilterName":{},"Words":{"shape":"S1c"},"VocabularyFilterFileUri":{}}},"output":{"type":"structure","members":{"VocabularyFilterName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"NonTalkTimeFilter":{"type":"structure","members":{"Threshold":{"type":"long"},"AbsoluteTimeRange":{"shape":"S7"},"RelativeTimeRange":{"shape":"S8"},"Negate":{"type":"boolean"}}},"InterruptionFilter":{"type":"structure","members":{"Threshold":{"type":"long"},"ParticipantRole":{},"AbsoluteTimeRange":{"shape":"S7"},"RelativeTimeRange":{"shape":"S8"},"Negate":{"type":"boolean"}}},"TranscriptFilter":{"type":"structure","required":["TranscriptFilterType","Targets"],"members":{"TranscriptFilterType":{},"AbsoluteTimeRange":{"shape":"S7"},"RelativeTimeRange":{"shape":"S8"},"ParticipantRole":{},"Negate":{"type":"boolean"},"Targets":{"type":"list","member":{}}}},"SentimentFilter":{"type":"structure","required":["Sentiments"],"members":{"Sentiments":{"type":"list","member":{}},"AbsoluteTimeRange":{"shape":"S7"},"RelativeTimeRange":{"shape":"S8"},"ParticipantRole":{},"Negate":{"type":"boolean"}}}},"union":true}},"S7":{"type":"structure","members":{"StartTime":{"type":"long"},"EndTime":{"type":"long"},"First":{"type":"long"},"Last":{"type":"long"}}},"S8":{"type":"structure","members":{"StartPercentage":{"type":"integer"},"EndPercentage":{"type":"integer"},"First":{"type":"integer"},"Last":{"type":"integer"}}},"Sl":{"type":"structure","members":{"CategoryName":{},"Rules":{"shape":"S3"},"CreateTime":{"type":"timestamp"},"LastUpdateTime":{"type":"timestamp"}}},"Sr":{"type":"structure","required":["S3Uri","DataAccessRoleArn"],"members":{"S3Uri":{},"TuningDataS3Uri":{},"DataAccessRoleArn":{}}},"Su":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S17":{"type":"list","member":{}},"S1c":{"type":"list","member":{}},"S1t":{"type":"structure","members":{"ModelName":{},"CreateTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LanguageCode":{},"BaseModelName":{},"ModelStatus":{},"UpgradeAvailability":{"type":"boolean"},"FailureReason":{},"InputDataConfig":{"shape":"Sr"}}},"S1y":{"type":"structure","members":{"CallAnalyticsJobName":{},"CallAnalyticsJobStatus":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"S22"},"Transcript":{"shape":"S23"},"StartTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"FailureReason":{},"DataAccessRoleArn":{},"IdentifiedLanguageScore":{"type":"float"},"Settings":{"shape":"S25"},"ChannelDefinitions":{"shape":"S2f"}}},"S22":{"type":"structure","members":{"MediaFileUri":{},"RedactedMediaFileUri":{}}},"S23":{"type":"structure","members":{"TranscriptFileUri":{},"RedactedTranscriptFileUri":{}}},"S25":{"type":"structure","members":{"VocabularyName":{},"VocabularyFilterName":{},"VocabularyFilterMethod":{},"LanguageModelName":{},"ContentRedaction":{"shape":"S27"},"LanguageOptions":{"shape":"S2c"},"LanguageIdSettings":{"shape":"S2d"}}},"S27":{"type":"structure","required":["RedactionType","RedactionOutput"],"members":{"RedactionType":{},"RedactionOutput":{},"PiiEntityTypes":{"type":"list","member":{}}}},"S2c":{"type":"list","member":{}},"S2d":{"type":"map","key":{},"value":{"type":"structure","members":{"VocabularyName":{},"VocabularyFilterName":{},"LanguageModelName":{}}}},"S2f":{"type":"list","member":{"type":"structure","members":{"ChannelId":{"type":"integer"},"ParticipantRole":{}}}},"S2k":{"type":"structure","members":{"MedicalTranscriptionJobName":{},"TranscriptionJobStatus":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"S22"},"Transcript":{"type":"structure","members":{"TranscriptFileUri":{}}},"StartTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"FailureReason":{},"Settings":{"shape":"S2o"},"ContentIdentificationType":{},"Specialty":{},"Type":{},"Tags":{"shape":"Su"}}},"S2o":{"type":"structure","members":{"ShowSpeakerLabels":{"type":"boolean"},"MaxSpeakerLabels":{"type":"integer"},"ChannelIdentification":{"type":"boolean"},"ShowAlternatives":{"type":"boolean"},"MaxAlternatives":{"type":"integer"},"VocabularyName":{}}},"S2y":{"type":"structure","members":{"TranscriptionJobName":{},"TranscriptionJobStatus":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"S22"},"Transcript":{"shape":"S23"},"StartTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"FailureReason":{},"Settings":{"shape":"S2z"},"ModelSettings":{"shape":"S30"},"JobExecutionSettings":{"shape":"S31"},"ContentRedaction":{"shape":"S27"},"IdentifyLanguage":{"type":"boolean"},"LanguageOptions":{"shape":"S2c"},"IdentifiedLanguageScore":{"type":"float"},"Tags":{"shape":"Su"},"Subtitles":{"type":"structure","members":{"Formats":{"shape":"S33"},"SubtitleFileUris":{"type":"list","member":{}},"OutputStartIndex":{"type":"integer"}}},"LanguageIdSettings":{"shape":"S2d"}}},"S2z":{"type":"structure","members":{"VocabularyName":{},"ShowSpeakerLabels":{"type":"boolean"},"MaxSpeakerLabels":{"type":"integer"},"ChannelIdentification":{"type":"boolean"},"ShowAlternatives":{"type":"boolean"},"MaxAlternatives":{"type":"integer"},"VocabularyFilterName":{},"VocabularyFilterMethod":{}}},"S30":{"type":"structure","members":{"LanguageModelName":{}}},"S31":{"type":"structure","members":{"AllowDeferredExecution":{"type":"boolean"},"DataAccessRoleArn":{}}},"S33":{"type":"list","member":{}},"S3u":{"type":"list","member":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"},"VocabularyState":{}}}},"S4f":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCallAnalyticsCategories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCallAnalyticsJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLanguageModels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMedicalTranscriptionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMedicalVocabularies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTranscriptionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVocabularies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVocabularyFilters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['connect'] = {};
	AWS.Connect = Service.defineService('connect', ['2017-08-08']);
	Object.defineProperty(apiLoader.services['connect'], '2017-08-08', {
	  get: function get() {
	    var model = __webpack_require__(601);
	    model.paginators = __webpack_require__(602).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Connect;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-08-08","endpointPrefix":"connect","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon Connect","serviceFullName":"Amazon Connect Service","serviceId":"Connect","signatureVersion":"v4","signingName":"connect","uid":"connect-2017-08-08"},"operations":{"AssociateApprovedOrigin":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/approved-origin"},"input":{"type":"structure","required":["InstanceId","Origin"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Origin":{}}}},"AssociateBot":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/bot"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LexBot":{"shape":"S5"},"LexV2Bot":{"shape":"S8"}}}},"AssociateDefaultVocabulary":{"http":{"method":"PUT","requestUri":"/default-vocabulary/{InstanceId}/{LanguageCode}"},"input":{"type":"structure","required":["InstanceId","LanguageCode"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LanguageCode":{"location":"uri","locationName":"LanguageCode"},"VocabularyId":{}}},"output":{"type":"structure","members":{}}},"AssociateInstanceStorageConfig":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/storage-config"},"input":{"type":"structure","required":["InstanceId","ResourceType","StorageConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceType":{},"StorageConfig":{"shape":"Sg"}}},"output":{"type":"structure","members":{"AssociationId":{}}}},"AssociateLambdaFunction":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/lambda-function"},"input":{"type":"structure","required":["InstanceId","FunctionArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FunctionArn":{}}}},"AssociateLexBot":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/lex-bot"},"input":{"type":"structure","required":["InstanceId","LexBot"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LexBot":{"shape":"S5"}}}},"AssociatePhoneNumberContactFlow":{"http":{"method":"PUT","requestUri":"/phone-number/{PhoneNumberId}/contact-flow"},"input":{"type":"structure","required":["PhoneNumberId","InstanceId","ContactFlowId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"InstanceId":{},"ContactFlowId":{}}}},"AssociateQueueQuickConnects":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/associate-quick-connects"},"input":{"type":"structure","required":["InstanceId","QueueId","QuickConnectIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"QuickConnectIds":{"shape":"S13"}}}},"AssociateRoutingProfileQueues":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/associate-queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","QueueConfigs"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"QueueConfigs":{"shape":"S17"}}}},"AssociateSecurityKey":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/security-key"},"input":{"type":"structure","required":["InstanceId","Key"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Key":{}}},"output":{"type":"structure","members":{"AssociationId":{}}}},"ClaimPhoneNumber":{"http":{"requestUri":"/phone-number/claim"},"input":{"type":"structure","required":["TargetArn","PhoneNumber"],"members":{"TargetArn":{},"PhoneNumber":{},"PhoneNumberDescription":{},"Tags":{"shape":"S1j"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{}}}},"CreateAgentStatus":{"http":{"method":"PUT","requestUri":"/agent-status/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","State"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"State":{},"DisplayOrder":{"type":"integer"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"AgentStatusARN":{},"AgentStatusId":{}}}},"CreateContactFlow":{"http":{"method":"PUT","requestUri":"/contact-flows/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Type","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Type":{},"Description":{},"Content":{},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"ContactFlowId":{},"ContactFlowArn":{}}}},"CreateContactFlowModule":{"http":{"method":"PUT","requestUri":"/contact-flow-modules/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"Content":{},"Tags":{"shape":"S1j"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"CreateHoursOfOperation":{"http":{"method":"PUT","requestUri":"/hours-of-operations/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","TimeZone","Config"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"TimeZone":{},"Config":{"shape":"S2b"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"HoursOfOperationId":{},"HoursOfOperationArn":{}}}},"CreateInstance":{"http":{"method":"PUT","requestUri":"/instance"},"input":{"type":"structure","required":["IdentityManagementType","InboundCallsEnabled","OutboundCallsEnabled"],"members":{"ClientToken":{},"IdentityManagementType":{},"InstanceAlias":{"shape":"S2l"},"DirectoryId":{},"InboundCallsEnabled":{"type":"boolean"},"OutboundCallsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"CreateIntegrationAssociation":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/integration-associations"},"input":{"type":"structure","required":["InstanceId","IntegrationType","IntegrationArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationType":{},"IntegrationArn":{},"SourceApplicationUrl":{},"SourceApplicationName":{},"SourceType":{},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"IntegrationAssociationId":{},"IntegrationAssociationArn":{}}}},"CreateQueue":{"http":{"method":"PUT","requestUri":"/queues/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"OutboundCallerConfig":{"shape":"S2z"},"HoursOfOperationId":{},"MaxContacts":{"type":"integer"},"QuickConnectIds":{"shape":"S13"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"QueueArn":{},"QueueId":{}}}},"CreateQuickConnect":{"http":{"method":"PUT","requestUri":"/quick-connects/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","QuickConnectConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"QuickConnectConfig":{"shape":"S36"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"QuickConnectARN":{},"QuickConnectId":{}}}},"CreateRoutingProfile":{"http":{"method":"PUT","requestUri":"/routing-profiles/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Description","DefaultOutboundQueueId","MediaConcurrencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"DefaultOutboundQueueId":{},"QueueConfigs":{"shape":"S17"},"MediaConcurrencies":{"shape":"S3g"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"RoutingProfileArn":{},"RoutingProfileId":{}}}},"CreateSecurityProfile":{"http":{"method":"PUT","requestUri":"/security-profiles/{InstanceId}"},"input":{"type":"structure","required":["SecurityProfileName","InstanceId"],"members":{"SecurityProfileName":{},"Description":{},"Permissions":{"shape":"S3n"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"SecurityProfileId":{},"SecurityProfileArn":{}}}},"CreateUseCase":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId","UseCaseType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"},"UseCaseType":{},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"UseCaseId":{},"UseCaseArn":{}}}},"CreateUser":{"http":{"method":"PUT","requestUri":"/users/{InstanceId}"},"input":{"type":"structure","required":["Username","PhoneConfig","SecurityProfileIds","RoutingProfileId","InstanceId"],"members":{"Username":{},"Password":{},"IdentityInfo":{"shape":"S3y"},"PhoneConfig":{"shape":"S42"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"S47"},"RoutingProfileId":{},"HierarchyGroupId":{},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"UserId":{},"UserArn":{}}}},"CreateUserHierarchyGroup":{"http":{"method":"PUT","requestUri":"/user-hierarchy-groups/{InstanceId}"},"input":{"type":"structure","required":["Name","InstanceId"],"members":{"Name":{},"ParentGroupId":{},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","members":{"HierarchyGroupId":{},"HierarchyGroupArn":{}}}},"CreateVocabulary":{"http":{"requestUri":"/vocabulary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","VocabularyName","LanguageCode","Content"],"members":{"ClientToken":{"idempotencyToken":true},"InstanceId":{"location":"uri","locationName":"InstanceId"},"VocabularyName":{},"LanguageCode":{},"Content":{},"Tags":{"shape":"S1j"}}},"output":{"type":"structure","required":["VocabularyArn","VocabularyId","State"],"members":{"VocabularyArn":{},"VocabularyId":{},"State":{}}}},"DeleteContactFlow":{"http":{"method":"DELETE","requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"}}}},"DeleteContactFlowModule":{"http":{"method":"DELETE","requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"}}},"output":{"type":"structure","members":{}}},"DeleteHoursOfOperation":{"http":{"method":"DELETE","requestUri":"/hours-of-operations/{InstanceId}/{HoursOfOperationId}"},"input":{"type":"structure","required":["InstanceId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"HoursOfOperationId":{"location":"uri","locationName":"HoursOfOperationId"}}}},"DeleteInstance":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"DeleteIntegrationAssociation":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"}}}},"DeleteQuickConnect":{"http":{"method":"DELETE","requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}"},"input":{"type":"structure","required":["InstanceId","QuickConnectId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"}}}},"DeleteSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["InstanceId","SecurityProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"}}}},"DeleteUseCase":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases/{UseCaseId}"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId","UseCaseId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"},"UseCaseId":{"location":"uri","locationName":"UseCaseId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["InstanceId","UserId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DeleteUserHierarchyGroup":{"http":{"method":"DELETE","requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"},"input":{"type":"structure","required":["HierarchyGroupId","InstanceId"],"members":{"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"DeleteVocabulary":{"http":{"requestUri":"/vocabulary-remove/{InstanceId}/{VocabularyId}"},"input":{"type":"structure","required":["InstanceId","VocabularyId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"VocabularyId":{"location":"uri","locationName":"VocabularyId"}}},"output":{"type":"structure","required":["VocabularyArn","VocabularyId","State"],"members":{"VocabularyArn":{},"VocabularyId":{},"State":{}}}},"DescribeAgentStatus":{"http":{"method":"GET","requestUri":"/agent-status/{InstanceId}/{AgentStatusId}"},"input":{"type":"structure","required":["InstanceId","AgentStatusId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AgentStatusId":{"location":"uri","locationName":"AgentStatusId"}}},"output":{"type":"structure","members":{"AgentStatus":{"type":"structure","members":{"AgentStatusARN":{},"AgentStatusId":{},"Name":{},"Description":{},"Type":{},"DisplayOrder":{"type":"integer"},"State":{},"Tags":{"shape":"S1j"}}}}}},"DescribeContact":{"http":{"method":"GET","requestUri":"/contacts/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"}}},"output":{"type":"structure","members":{"Contact":{"type":"structure","members":{"Arn":{},"Id":{},"InitialContactId":{},"PreviousContactId":{},"InitiationMethod":{},"Name":{},"Description":{},"Channel":{},"QueueInfo":{"type":"structure","members":{"Id":{},"EnqueueTimestamp":{"type":"timestamp"}}},"AgentInfo":{"type":"structure","members":{"Id":{},"ConnectedToAgentTimestamp":{"type":"timestamp"}}},"InitiationTimestamp":{"type":"timestamp"},"DisconnectTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"ScheduledTimestamp":{"type":"timestamp"}}}}}},"DescribeContactFlow":{"http":{"method":"GET","requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"}}},"output":{"type":"structure","members":{"ContactFlow":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Type":{},"State":{},"Description":{},"Content":{},"Tags":{"shape":"S1j"}}}}}},"DescribeContactFlowModule":{"http":{"method":"GET","requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"}}},"output":{"type":"structure","members":{"ContactFlowModule":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Content":{},"Description":{},"State":{},"Status":{},"Tags":{"shape":"S1j"}}}}}},"DescribeHoursOfOperation":{"http":{"method":"GET","requestUri":"/hours-of-operations/{InstanceId}/{HoursOfOperationId}"},"input":{"type":"structure","required":["InstanceId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"HoursOfOperationId":{"location":"uri","locationName":"HoursOfOperationId"}}},"output":{"type":"structure","members":{"HoursOfOperation":{"type":"structure","members":{"HoursOfOperationId":{},"HoursOfOperationArn":{},"Name":{},"Description":{},"TimeZone":{},"Config":{"shape":"S2b"},"Tags":{"shape":"S1j"}}}}}},"DescribeInstance":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"Instance":{"type":"structure","members":{"Id":{},"Arn":{},"IdentityManagementType":{},"InstanceAlias":{"shape":"S2l"},"CreatedTime":{"type":"timestamp"},"ServiceRole":{},"InstanceStatus":{},"StatusReason":{"type":"structure","members":{"Message":{}}},"InboundCallsEnabled":{"type":"boolean"},"OutboundCallsEnabled":{"type":"boolean"}}}}}},"DescribeInstanceAttribute":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/attribute/{AttributeType}"},"input":{"type":"structure","required":["InstanceId","AttributeType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AttributeType":{"location":"uri","locationName":"AttributeType"}}},"output":{"type":"structure","members":{"Attribute":{"shape":"S5w"}}}},"DescribeInstanceStorageConfig":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/storage-config/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}},"output":{"type":"structure","members":{"StorageConfig":{"shape":"Sg"}}}},"DescribePhoneNumber":{"http":{"method":"GET","requestUri":"/phone-number/{PhoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"}}},"output":{"type":"structure","members":{"ClaimedPhoneNumberSummary":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{},"PhoneNumber":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{},"PhoneNumberDescription":{},"TargetArn":{},"Tags":{"shape":"S1j"},"PhoneNumberStatus":{"type":"structure","members":{"Status":{},"Message":{}}}}}}}},"DescribeQueue":{"http":{"method":"GET","requestUri":"/queues/{InstanceId}/{QueueId}"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"}}},"output":{"type":"structure","members":{"Queue":{"type":"structure","members":{"Name":{},"QueueArn":{},"QueueId":{},"Description":{},"OutboundCallerConfig":{"shape":"S2z"},"HoursOfOperationId":{},"MaxContacts":{"type":"integer"},"Status":{},"Tags":{"shape":"S1j"}}}}}},"DescribeQuickConnect":{"http":{"method":"GET","requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}"},"input":{"type":"structure","required":["InstanceId","QuickConnectId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"}}},"output":{"type":"structure","members":{"QuickConnect":{"type":"structure","members":{"QuickConnectARN":{},"QuickConnectId":{},"Name":{},"Description":{},"QuickConnectConfig":{"shape":"S36"},"Tags":{"shape":"S1j"}}}}}},"DescribeRoutingProfile":{"http":{"method":"GET","requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"}}},"output":{"type":"structure","members":{"RoutingProfile":{"type":"structure","members":{"InstanceId":{},"Name":{},"RoutingProfileArn":{},"RoutingProfileId":{},"Description":{},"MediaConcurrencies":{"shape":"S3g"},"DefaultOutboundQueueId":{},"Tags":{"shape":"S1j"}}}}}},"DescribeSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"SecurityProfile":{"type":"structure","members":{"Id":{},"OrganizationResourceId":{},"Arn":{},"SecurityProfileName":{},"Description":{},"Tags":{"shape":"S1j"}}}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"User":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{},"IdentityInfo":{"shape":"S3y"},"PhoneConfig":{"shape":"S42"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"S47"},"RoutingProfileId":{},"HierarchyGroupId":{},"Tags":{"shape":"S1j"}}}}}},"DescribeUserHierarchyGroup":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"},"input":{"type":"structure","required":["HierarchyGroupId","InstanceId"],"members":{"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyGroup":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LevelId":{},"HierarchyPath":{"type":"structure","members":{"LevelOne":{"shape":"S6t"},"LevelTwo":{"shape":"S6t"},"LevelThree":{"shape":"S6t"},"LevelFour":{"shape":"S6t"},"LevelFive":{"shape":"S6t"}}},"Tags":{"shape":"S1j"}}}}}},"DescribeUserHierarchyStructure":{"http":{"method":"GET","requestUri":"/user-hierarchy-structure/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyStructure":{"type":"structure","members":{"LevelOne":{"shape":"S6x"},"LevelTwo":{"shape":"S6x"},"LevelThree":{"shape":"S6x"},"LevelFour":{"shape":"S6x"},"LevelFive":{"shape":"S6x"}}}}}},"DescribeVocabulary":{"http":{"method":"GET","requestUri":"/vocabulary/{InstanceId}/{VocabularyId}"},"input":{"type":"structure","required":["InstanceId","VocabularyId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"VocabularyId":{"location":"uri","locationName":"VocabularyId"}}},"output":{"type":"structure","required":["Vocabulary"],"members":{"Vocabulary":{"type":"structure","required":["Name","Id","Arn","LanguageCode","State","LastModifiedTime"],"members":{"Name":{},"Id":{},"Arn":{},"LanguageCode":{},"State":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"Content":{},"Tags":{"shape":"S1j"}}}}}},"DisassociateApprovedOrigin":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/approved-origin"},"input":{"type":"structure","required":["InstanceId","Origin"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Origin":{"location":"querystring","locationName":"origin"}}}},"DisassociateBot":{"http":{"requestUri":"/instance/{InstanceId}/bot"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LexBot":{"shape":"S5"},"LexV2Bot":{"shape":"S8"}}}},"DisassociateInstanceStorageConfig":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/storage-config/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}}},"DisassociateLambdaFunction":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/lambda-function"},"input":{"type":"structure","required":["InstanceId","FunctionArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FunctionArn":{"location":"querystring","locationName":"functionArn"}}}},"DisassociateLexBot":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/lex-bot"},"input":{"type":"structure","required":["InstanceId","BotName","LexRegion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"BotName":{"location":"querystring","locationName":"botName"},"LexRegion":{"location":"querystring","locationName":"lexRegion"}}}},"DisassociatePhoneNumberContactFlow":{"http":{"method":"DELETE","requestUri":"/phone-number/{PhoneNumberId}/contact-flow"},"input":{"type":"structure","required":["PhoneNumberId","InstanceId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"InstanceId":{"location":"querystring","locationName":"instanceId"}}}},"DisassociateQueueQuickConnects":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/disassociate-quick-connects"},"input":{"type":"structure","required":["InstanceId","QueueId","QuickConnectIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"QuickConnectIds":{"shape":"S13"}}}},"DisassociateRoutingProfileQueues":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/disassociate-queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","QueueReferences"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"QueueReferences":{"type":"list","member":{"shape":"S19"}}}}},"DisassociateSecurityKey":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/security-key/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"}}}},"GetContactAttributes":{"http":{"method":"GET","requestUri":"/contact/attributes/{InstanceId}/{InitialContactId}"},"input":{"type":"structure","required":["InstanceId","InitialContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"InitialContactId":{"location":"uri","locationName":"InitialContactId"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S7g"}}}},"GetCurrentMetricData":{"http":{"requestUri":"/metrics/current/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Filters","CurrentMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Filters":{"shape":"S7k"},"Groupings":{"shape":"S7n"},"CurrentMetrics":{"type":"list","member":{"shape":"S7q"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"S7y"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"S7q"},"Value":{"type":"double"}}}}}}},"DataSnapshotTime":{"type":"timestamp"}}}},"GetFederationToken":{"http":{"method":"GET","requestUri":"/user/federate/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"Credentials":{"type":"structure","members":{"AccessToken":{"shape":"S86"},"AccessTokenExpiration":{"type":"timestamp"},"RefreshToken":{"shape":"S86"},"RefreshTokenExpiration":{"type":"timestamp"}}}}}},"GetMetricData":{"http":{"requestUri":"/metrics/historical/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","StartTime","EndTime","Filters","HistoricalMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Filters":{"shape":"S7k"},"Groupings":{"shape":"S7n"},"HistoricalMetrics":{"type":"list","member":{"shape":"S89"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"S7y"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"S89"},"Value":{"type":"double"}}}}}}}}}},"ListAgentStatuses":{"http":{"method":"GET","requestUri":"/agent-status/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"AgentStatusTypes":{"location":"querystring","locationName":"AgentStatusTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"AgentStatusSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{}}}}}}},"ListApprovedOrigins":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/approved-origins"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Origins":{"type":"list","member":{}},"NextToken":{}}}},"ListBots":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/bots"},"input":{"type":"structure","required":["InstanceId","LexVersion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"LexVersion":{"location":"querystring","locationName":"lexVersion"}}},"output":{"type":"structure","members":{"LexBots":{"type":"list","member":{"type":"structure","members":{"LexBot":{"shape":"S5"},"LexV2Bot":{"shape":"S8"}}}},"NextToken":{}}}},"ListContactFlowModules":{"http":{"method":"GET","requestUri":"/contact-flow-modules-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ContactFlowModuleState":{"location":"querystring","locationName":"state"}}},"output":{"type":"structure","members":{"ContactFlowModulesSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"State":{}}}},"NextToken":{}}}},"ListContactFlows":{"http":{"method":"GET","requestUri":"/contact-flows-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowTypes":{"location":"querystring","locationName":"contactFlowTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ContactFlowSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"ContactFlowType":{},"ContactFlowState":{}}}},"NextToken":{}}}},"ListContactReferences":{"http":{"method":"GET","requestUri":"/contact/references/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId","ReferenceTypes"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"ReferenceTypes":{"location":"querystring","locationName":"referenceTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ReferenceSummaryList":{"type":"list","member":{"type":"structure","members":{"Url":{"type":"structure","members":{"Name":{},"Value":{}}},"Attachment":{"type":"structure","members":{"Name":{},"Value":{},"Status":{}}}},"union":true}},"NextToken":{}}}},"ListDefaultVocabularies":{"http":{"requestUri":"/default-vocabulary-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LanguageCode":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["DefaultVocabularyList"],"members":{"DefaultVocabularyList":{"type":"list","member":{"type":"structure","required":["InstanceId","LanguageCode","VocabularyId","VocabularyName"],"members":{"InstanceId":{},"LanguageCode":{},"VocabularyId":{},"VocabularyName":{}}}},"NextToken":{}}}},"ListHoursOfOperations":{"http":{"method":"GET","requestUri":"/hours-of-operations-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"HoursOfOperationSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListInstanceAttributes":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/attributes"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"type":"list","member":{"shape":"S5w"}},"NextToken":{}}}},"ListInstanceStorageConfigs":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/storage-configs"},"input":{"type":"structure","required":["InstanceId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"StorageConfigs":{"type":"list","member":{"shape":"Sg"}},"NextToken":{}}}},"ListInstances":{"http":{"method":"GET","requestUri":"/instance"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"InstanceSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"IdentityManagementType":{},"InstanceAlias":{"shape":"S2l"},"CreatedTime":{"type":"timestamp"},"ServiceRole":{},"InstanceStatus":{},"InboundCallsEnabled":{"type":"boolean"},"OutboundCallsEnabled":{"type":"boolean"}}}},"NextToken":{}}}},"ListIntegrationAssociations":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/integration-associations"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationType":{"location":"querystring","locationName":"integrationType"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IntegrationAssociationSummaryList":{"type":"list","member":{"type":"structure","members":{"IntegrationAssociationId":{},"IntegrationAssociationArn":{},"InstanceId":{},"IntegrationType":{},"IntegrationArn":{},"SourceApplicationUrl":{},"SourceApplicationName":{},"SourceType":{}}}},"NextToken":{}}}},"ListLambdaFunctions":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/lambda-functions"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"LambdaFunctions":{"type":"list","member":{}},"NextToken":{}}}},"ListLexBots":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/lex-bots"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"LexBots":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListPhoneNumbers":{"http":{"method":"GET","requestUri":"/phone-numbers-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PhoneNumberTypes":{"shape":"Sag","location":"querystring","locationName":"phoneNumberTypes"},"PhoneNumberCountryCodes":{"shape":"Sah","location":"querystring","locationName":"phoneNumberCountryCodes"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"PhoneNumberSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"PhoneNumber":{},"PhoneNumberType":{},"PhoneNumberCountryCode":{}}}},"NextToken":{}}}},"ListPhoneNumbersV2":{"http":{"requestUri":"/phone-number/list"},"input":{"type":"structure","members":{"TargetArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"PhoneNumberCountryCodes":{"shape":"Sah"},"PhoneNumberTypes":{"shape":"Sag"},"PhoneNumberPrefix":{}}},"output":{"type":"structure","members":{"NextToken":{},"ListPhoneNumbersSummaryList":{"type":"list","member":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{},"PhoneNumber":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{},"TargetArn":{}}}}}}},"ListPrompts":{"http":{"method":"GET","requestUri":"/prompts-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"PromptSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListQueueQuickConnects":{"http":{"method":"GET","requestUri":"/queues/{InstanceId}/{QueueId}/quick-connects"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"QuickConnectSummaryList":{"shape":"Saz"}}}},"ListQueues":{"http":{"method":"GET","requestUri":"/queues-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueTypes":{"location":"querystring","locationName":"queueTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"QueueSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"QueueType":{}}}},"NextToken":{}}}},"ListQuickConnects":{"http":{"method":"GET","requestUri":"/quick-connects/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"QuickConnectTypes":{"location":"querystring","locationName":"QuickConnectTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{"QuickConnectSummaryList":{"shape":"Saz"},"NextToken":{}}}},"ListRoutingProfileQueues":{"http":{"method":"GET","requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RoutingProfileQueueConfigSummaryList":{"type":"list","member":{"type":"structure","required":["QueueId","QueueArn","QueueName","Priority","Delay","Channel"],"members":{"QueueId":{},"QueueArn":{},"QueueName":{},"Priority":{"type":"integer"},"Delay":{"type":"integer"},"Channel":{}}}}}}},"ListRoutingProfiles":{"http":{"method":"GET","requestUri":"/routing-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"RoutingProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListSecurityKeys":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/security-keys"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"SecurityKeys":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Key":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListSecurityProfilePermissions":{"http":{"method":"GET","requestUri":"/security-profiles-permissions/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"shape":"S3n"},"NextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"SecurityProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1j"}}}},"ListUseCases":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UseCaseSummaryList":{"type":"list","member":{"type":"structure","members":{"UseCaseId":{},"UseCaseArn":{},"UseCaseType":{}}}},"NextToken":{}}}},"ListUserHierarchyGroups":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserHierarchyGroupSummaryList":{"type":"list","member":{"shape":"S6t"}},"NextToken":{}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/users-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{}}}},"NextToken":{}}}},"PutUserStatus":{"http":{"method":"PUT","requestUri":"/users/{InstanceId}/{UserId}/status"},"input":{"type":"structure","required":["UserId","InstanceId","AgentStatusId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"AgentStatusId":{}}},"output":{"type":"structure","members":{}}},"ReleasePhoneNumber":{"http":{"method":"DELETE","requestUri":"/phone-number/{PhoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"ClientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}}},"ResumeContactRecording":{"http":{"requestUri":"/contact/resume-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{}}},"output":{"type":"structure","members":{}}},"SearchAvailablePhoneNumbers":{"http":{"requestUri":"/phone-number/search-available"},"input":{"type":"structure","required":["TargetArn","PhoneNumberCountryCode","PhoneNumberType"],"members":{"TargetArn":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{},"PhoneNumberPrefix":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"AvailableNumbersList":{"type":"list","member":{"type":"structure","members":{"PhoneNumber":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{}}}}}}},"SearchUsers":{"http":{"requestUri":"/search-users"},"input":{"type":"structure","members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"type":"structure","members":{"OrConditions":{"type":"list","member":{"shape":"Scl"}},"AndConditions":{"shape":"Scl"},"TagCondition":{"shape":"Scm"}}}}},"SearchCriteria":{"shape":"Scn"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"Arn":{},"DirectoryUserId":{},"HierarchyGroupId":{},"Id":{},"IdentityInfo":{"type":"structure","members":{"FirstName":{},"LastName":{}}},"PhoneConfig":{"shape":"S42"},"RoutingProfileId":{},"SecurityProfileIds":{"shape":"S47"},"Tags":{"shape":"S1j"},"Username":{}}}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchVocabularies":{"http":{"requestUri":"/vocabulary-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"State":{},"NameStartsWith":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"VocabularySummaryList":{"type":"list","member":{"type":"structure","required":["Name","Id","Arn","LanguageCode","State","LastModifiedTime"],"members":{"Name":{},"Id":{},"Arn":{},"LanguageCode":{},"State":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{}}}},"NextToken":{}}}},"StartChatContact":{"http":{"method":"PUT","requestUri":"/contact/chat"},"input":{"type":"structure","required":["InstanceId","ContactFlowId","ParticipantDetails"],"members":{"InstanceId":{},"ContactFlowId":{},"Attributes":{"shape":"S7g"},"ParticipantDetails":{"type":"structure","required":["DisplayName"],"members":{"DisplayName":{}}},"InitialMessage":{"type":"structure","required":["ContentType","Content"],"members":{"ContentType":{},"Content":{}}},"ClientToken":{"idempotencyToken":true},"ChatDurationInMinutes":{"type":"integer"},"SupportedMessagingContentTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ContactId":{},"ParticipantId":{},"ParticipantToken":{}}}},"StartContactRecording":{"http":{"requestUri":"/contact/start-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId","VoiceRecordingConfiguration"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{},"VoiceRecordingConfiguration":{"type":"structure","members":{"VoiceRecordingTrack":{}}}}},"output":{"type":"structure","members":{}}},"StartContactStreaming":{"http":{"requestUri":"/contact/start-streaming"},"input":{"type":"structure","required":["InstanceId","ContactId","ChatStreamingConfiguration","ClientToken"],"members":{"InstanceId":{},"ContactId":{},"ChatStreamingConfiguration":{"type":"structure","required":["StreamingEndpointArn"],"members":{"StreamingEndpointArn":{}}},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["StreamingId"],"members":{"StreamingId":{}}}},"StartOutboundVoiceContact":{"http":{"method":"PUT","requestUri":"/contact/outbound-voice"},"input":{"type":"structure","required":["DestinationPhoneNumber","ContactFlowId","InstanceId"],"members":{"DestinationPhoneNumber":{},"ContactFlowId":{},"InstanceId":{},"ClientToken":{"idempotencyToken":true},"SourcePhoneNumber":{},"QueueId":{},"Attributes":{"shape":"S7g"},"AnswerMachineDetectionConfig":{"type":"structure","members":{"EnableAnswerMachineDetection":{"type":"boolean"},"AwaitAnswerMachinePrompt":{"type":"boolean"}}},"CampaignId":{},"TrafficType":{}}},"output":{"type":"structure","members":{"ContactId":{}}}},"StartTaskContact":{"http":{"method":"PUT","requestUri":"/contact/task"},"input":{"type":"structure","required":["InstanceId","ContactFlowId","Name"],"members":{"InstanceId":{},"PreviousContactId":{},"ContactFlowId":{},"Attributes":{"shape":"S7g"},"Name":{},"References":{"shape":"Sdu"},"Description":{},"ClientToken":{"idempotencyToken":true},"ScheduledTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ContactId":{}}}},"StopContact":{"http":{"requestUri":"/contact/stop"},"input":{"type":"structure","required":["ContactId","InstanceId"],"members":{"ContactId":{},"InstanceId":{}}},"output":{"type":"structure","members":{}}},"StopContactRecording":{"http":{"requestUri":"/contact/stop-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{}}},"output":{"type":"structure","members":{}}},"StopContactStreaming":{"http":{"requestUri":"/contact/stop-streaming"},"input":{"type":"structure","required":["InstanceId","ContactId","StreamingId"],"members":{"InstanceId":{},"ContactId":{},"StreamingId":{}}},"output":{"type":"structure","members":{}}},"SuspendContactRecording":{"http":{"requestUri":"/contact/suspend-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1j"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAgentStatus":{"http":{"requestUri":"/agent-status/{InstanceId}/{AgentStatusId}"},"input":{"type":"structure","required":["InstanceId","AgentStatusId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AgentStatusId":{"location":"uri","locationName":"AgentStatusId"},"Name":{},"Description":{},"State":{},"DisplayOrder":{"type":"integer"},"ResetOrderNumber":{"type":"boolean"}}}},"UpdateContact":{"http":{"requestUri":"/contacts/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"Name":{},"Description":{},"References":{"shape":"Sdu"}}},"output":{"type":"structure","members":{}}},"UpdateContactAttributes":{"http":{"requestUri":"/contact/attributes"},"input":{"type":"structure","required":["InitialContactId","InstanceId","Attributes"],"members":{"InitialContactId":{},"InstanceId":{},"Attributes":{"shape":"S7g"}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowContent":{"http":{"requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}/content"},"input":{"type":"structure","required":["InstanceId","ContactFlowId","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"},"Content":{}}}},"UpdateContactFlowMetadata":{"http":{"requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}/metadata"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"},"Name":{},"Description":{},"ContactFlowState":{}}}},"UpdateContactFlowModuleContent":{"http":{"requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}/content"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"},"Content":{}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowModuleMetadata":{"http":{"requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}/metadata"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"},"Name":{},"Description":{},"State":{}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowName":{"http":{"requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}/name"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"},"Name":{},"Description":{}}}},"UpdateContactSchedule":{"http":{"requestUri":"/contact/schedule"},"input":{"type":"structure","required":["InstanceId","ContactId","ScheduledTime"],"members":{"InstanceId":{},"ContactId":{},"ScheduledTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"UpdateHoursOfOperation":{"http":{"requestUri":"/hours-of-operations/{InstanceId}/{HoursOfOperationId}"},"input":{"type":"structure","required":["InstanceId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"HoursOfOperationId":{"location":"uri","locationName":"HoursOfOperationId"},"Name":{},"Description":{},"TimeZone":{},"Config":{"shape":"S2b"}}}},"UpdateInstanceAttribute":{"http":{"requestUri":"/instance/{InstanceId}/attribute/{AttributeType}"},"input":{"type":"structure","required":["InstanceId","AttributeType","Value"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AttributeType":{"location":"uri","locationName":"AttributeType"},"Value":{}}}},"UpdateInstanceStorageConfig":{"http":{"requestUri":"/instance/{InstanceId}/storage-config/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId","ResourceType","StorageConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"StorageConfig":{"shape":"Sg"}}}},"UpdatePhoneNumber":{"http":{"method":"PUT","requestUri":"/phone-number/{PhoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId","TargetArn"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"TargetArn":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{}}}},"UpdateQueueHoursOfOperation":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/hours-of-operation"},"input":{"type":"structure","required":["InstanceId","QueueId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"HoursOfOperationId":{}}}},"UpdateQueueMaxContacts":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/max-contacts"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"MaxContacts":{"type":"integer"}}}},"UpdateQueueName":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/name"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"Name":{},"Description":{}}}},"UpdateQueueOutboundCallerConfig":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/outbound-caller-config"},"input":{"type":"structure","required":["InstanceId","QueueId","OutboundCallerConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"OutboundCallerConfig":{"shape":"S2z"}}}},"UpdateQueueStatus":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/status"},"input":{"type":"structure","required":["InstanceId","QueueId","Status"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"Status":{}}}},"UpdateQuickConnectConfig":{"http":{"requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}/config"},"input":{"type":"structure","required":["InstanceId","QuickConnectId","QuickConnectConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"},"QuickConnectConfig":{"shape":"S36"}}}},"UpdateQuickConnectName":{"http":{"requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}/name"},"input":{"type":"structure","required":["InstanceId","QuickConnectId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"},"Name":{},"Description":{}}}},"UpdateRoutingProfileConcurrency":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/concurrency"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","MediaConcurrencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"MediaConcurrencies":{"shape":"S3g"}}}},"UpdateRoutingProfileDefaultOutboundQueue":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/default-outbound-queue"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","DefaultOutboundQueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"DefaultOutboundQueueId":{}}}},"UpdateRoutingProfileName":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/name"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"Name":{},"Description":{}}}},"UpdateRoutingProfileQueues":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","QueueConfigs"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"QueueConfigs":{"shape":"S17"}}}},"UpdateSecurityProfile":{"http":{"requestUri":"/security-profiles/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"Description":{},"Permissions":{"shape":"S3n"},"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserHierarchy":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/hierarchy"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"HierarchyGroupId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserHierarchyGroupName":{"http":{"requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}/name"},"input":{"type":"structure","required":["Name","HierarchyGroupId","InstanceId"],"members":{"Name":{},"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserHierarchyStructure":{"http":{"requestUri":"/user-hierarchy-structure/{InstanceId}"},"input":{"type":"structure","required":["HierarchyStructure","InstanceId"],"members":{"HierarchyStructure":{"type":"structure","members":{"LevelOne":{"shape":"Sfa"},"LevelTwo":{"shape":"Sfa"},"LevelThree":{"shape":"Sfa"},"LevelFour":{"shape":"Sfa"},"LevelFive":{"shape":"Sfa"}}},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserIdentityInfo":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/identity-info"},"input":{"type":"structure","required":["IdentityInfo","UserId","InstanceId"],"members":{"IdentityInfo":{"shape":"S3y"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserPhoneConfig":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/phone-config"},"input":{"type":"structure","required":["PhoneConfig","UserId","InstanceId"],"members":{"PhoneConfig":{"shape":"S42"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserRoutingProfile":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/routing-profile"},"input":{"type":"structure","required":["RoutingProfileId","UserId","InstanceId"],"members":{"RoutingProfileId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserSecurityProfiles":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/security-profiles"},"input":{"type":"structure","required":["SecurityProfileIds","UserId","InstanceId"],"members":{"SecurityProfileIds":{"shape":"S47"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}}},"shapes":{"S5":{"type":"structure","members":{"Name":{},"LexRegion":{}}},"S8":{"type":"structure","members":{"AliasArn":{}}},"Sg":{"type":"structure","required":["StorageType"],"members":{"AssociationId":{},"StorageType":{},"S3Config":{"type":"structure","required":["BucketName","BucketPrefix"],"members":{"BucketName":{},"BucketPrefix":{},"EncryptionConfig":{"shape":"Sm"}}},"KinesisVideoStreamConfig":{"type":"structure","required":["Prefix","RetentionPeriodHours","EncryptionConfig"],"members":{"Prefix":{},"RetentionPeriodHours":{"type":"integer"},"EncryptionConfig":{"shape":"Sm"}}},"KinesisStreamConfig":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{}}},"KinesisFirehoseConfig":{"type":"structure","required":["FirehoseArn"],"members":{"FirehoseArn":{}}}}},"Sm":{"type":"structure","required":["EncryptionType","KeyId"],"members":{"EncryptionType":{},"KeyId":{}}},"S13":{"type":"list","member":{}},"S17":{"type":"list","member":{"type":"structure","required":["QueueReference","Priority","Delay"],"members":{"QueueReference":{"shape":"S19"},"Priority":{"type":"integer"},"Delay":{"type":"integer"}}}},"S19":{"type":"structure","required":["QueueId","Channel"],"members":{"QueueId":{},"Channel":{}}},"S1j":{"type":"map","key":{},"value":{}},"S2b":{"type":"list","member":{"type":"structure","required":["Day","StartTime","EndTime"],"members":{"Day":{},"StartTime":{"shape":"S2e"},"EndTime":{"shape":"S2e"}}}},"S2e":{"type":"structure","required":["Hours","Minutes"],"members":{"Hours":{"type":"integer"},"Minutes":{"type":"integer"}}},"S2l":{"type":"string","sensitive":true},"S2z":{"type":"structure","members":{"OutboundCallerIdName":{},"OutboundCallerIdNumberId":{},"OutboundFlowId":{}}},"S36":{"type":"structure","required":["QuickConnectType"],"members":{"QuickConnectType":{},"UserConfig":{"type":"structure","required":["UserId","ContactFlowId"],"members":{"UserId":{},"ContactFlowId":{}}},"QueueConfig":{"type":"structure","required":["QueueId","ContactFlowId"],"members":{"QueueId":{},"ContactFlowId":{}}},"PhoneConfig":{"type":"structure","required":["PhoneNumber"],"members":{"PhoneNumber":{}}}}},"S3g":{"type":"list","member":{"type":"structure","required":["Channel","Concurrency"],"members":{"Channel":{},"Concurrency":{"type":"integer"}}}},"S3n":{"type":"list","member":{}},"S3y":{"type":"structure","members":{"FirstName":{},"LastName":{},"Email":{}}},"S42":{"type":"structure","required":["PhoneType"],"members":{"PhoneType":{},"AutoAccept":{"type":"boolean"},"AfterContactWorkTimeLimit":{"type":"integer"},"DeskPhoneNumber":{}}},"S47":{"type":"list","member":{}},"S5w":{"type":"structure","members":{"AttributeType":{},"Value":{}}},"S6t":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S6x":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S7g":{"type":"map","key":{},"value":{}},"S7k":{"type":"structure","members":{"Queues":{"type":"list","member":{}},"Channels":{"type":"list","member":{}}}},"S7n":{"type":"list","member":{}},"S7q":{"type":"structure","members":{"Name":{},"Unit":{}}},"S7y":{"type":"structure","members":{"Queue":{"type":"structure","members":{"Id":{},"Arn":{}}},"Channel":{}}},"S86":{"type":"string","sensitive":true},"S89":{"type":"structure","members":{"Name":{},"Threshold":{"type":"structure","members":{"Comparison":{},"ThresholdValue":{"type":"double"}}},"Statistic":{},"Unit":{}}},"Sag":{"type":"list","member":{}},"Sah":{"type":"list","member":{}},"Saz":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"QuickConnectType":{}}}},"Scl":{"type":"list","member":{"shape":"Scm"}},"Scm":{"type":"structure","members":{"TagKey":{},"TagValue":{}}},"Scn":{"type":"structure","members":{"OrConditions":{"shape":"Sco"},"AndConditions":{"shape":"Sco"},"StringCondition":{"type":"structure","members":{"FieldName":{},"Value":{},"ComparisonType":{}}},"HierarchyGroupCondition":{"type":"structure","members":{"Value":{},"HierarchyGroupMatchType":{}}}}},"Sco":{"type":"list","member":{"shape":"Scn"}},"Sdu":{"type":"map","key":{},"value":{"type":"structure","required":["Value","Type"],"members":{"Value":{},"Type":{}}}},"Sfa":{"type":"structure","required":["Name"],"members":{"Name":{}}}}}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetCurrentMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAgentStatuses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AgentStatusSummaryList"},"ListApprovedOrigins":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Origins"},"ListBots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LexBots"},"ListContactFlowModules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ContactFlowModulesSummaryList"},"ListContactFlows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ContactFlowSummaryList"},"ListContactReferences":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReferenceSummaryList"},"ListDefaultVocabularies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DefaultVocabularyList"},"ListHoursOfOperations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HoursOfOperationSummaryList"},"ListInstanceAttributes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Attributes"},"ListInstanceStorageConfigs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StorageConfigs"},"ListInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceSummaryList"},"ListIntegrationAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IntegrationAssociationSummaryList"},"ListLambdaFunctions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LambdaFunctions"},"ListLexBots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LexBots"},"ListPhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumberSummaryList"},"ListPhoneNumbersV2":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ListPhoneNumbersSummaryList"},"ListPrompts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PromptSummaryList"},"ListQueueQuickConnects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QuickConnectSummaryList"},"ListQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueueSummaryList"},"ListQuickConnects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QuickConnectSummaryList"},"ListRoutingProfileQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RoutingProfileQueueConfigSummaryList"},"ListRoutingProfiles":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RoutingProfileSummaryList"},"ListSecurityKeys":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityKeys"},"ListSecurityProfilePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Permissions"},"ListSecurityProfiles":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityProfileSummaryList"},"ListUseCases":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UseCaseSummaryList"},"ListUserHierarchyGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserHierarchyGroupSummaryList"},"ListUsers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserSummaryList"},"SearchAvailablePhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AvailableNumbersList"},"SearchUsers":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"Users"},"SearchVocabularies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VocabularySummaryList"}}}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['acmpca'] = {};
	AWS.ACMPCA = Service.defineService('acmpca', ['2017-08-22']);
	Object.defineProperty(apiLoader.services['acmpca'], '2017-08-22', {
	  get: function get() {
	    var model = __webpack_require__(604);
	    model.paginators = __webpack_require__(605).pagination;
	    model.waiters = __webpack_require__(606).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ACMPCA;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-08-22","endpointPrefix":"acm-pca","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM-PCA","serviceFullName":"AWS Certificate Manager Private Certificate Authority","serviceId":"ACM PCA","signatureVersion":"v4","targetPrefix":"ACMPrivateCA","uid":"acm-pca-2017-08-22"},"operations":{"CreateCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityConfiguration","CertificateAuthorityType"],"members":{"CertificateAuthorityConfiguration":{"shape":"S2"},"RevocationConfiguration":{"shape":"Sv"},"CertificateAuthorityType":{},"IdempotencyToken":{},"KeyStorageSecurityStandard":{},"Tags":{"shape":"S14"}}},"output":{"type":"structure","members":{"CertificateAuthorityArn":{}}},"idempotent":true},"CreateCertificateAuthorityAuditReport":{"input":{"type":"structure","required":["CertificateAuthorityArn","S3BucketName","AuditReportResponseFormat"],"members":{"CertificateAuthorityArn":{},"S3BucketName":{},"AuditReportResponseFormat":{}}},"output":{"type":"structure","members":{"AuditReportId":{},"S3Key":{}}},"idempotent":true},"CreatePermission":{"input":{"type":"structure","required":["CertificateAuthorityArn","Principal","Actions"],"members":{"CertificateAuthorityArn":{},"Principal":{},"SourceAccount":{},"Actions":{"shape":"S1j"}}}},"DeleteCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"PermanentDeletionTimeInDays":{"type":"integer"}}}},"DeletePermission":{"input":{"type":"structure","required":["CertificateAuthorityArn","Principal"],"members":{"CertificateAuthorityArn":{},"Principal":{},"SourceAccount":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}}},"DescribeCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"CertificateAuthority":{"shape":"S1r"}}}},"DescribeCertificateAuthorityAuditReport":{"input":{"type":"structure","required":["CertificateAuthorityArn","AuditReportId"],"members":{"CertificateAuthorityArn":{},"AuditReportId":{}}},"output":{"type":"structure","members":{"AuditReportStatus":{},"S3BucketName":{},"S3Key":{},"CreatedAt":{"type":"timestamp"}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","CertificateArn"],"members":{"CertificateAuthorityArn":{},"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"GetCertificateAuthorityCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"GetCertificateAuthorityCsr":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"Csr":{}}}},"GetPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"ImportCertificateAuthorityCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","Certificate"],"members":{"CertificateAuthorityArn":{},"Certificate":{"type":"blob"},"CertificateChain":{"type":"blob"}}}},"IssueCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","Csr","SigningAlgorithm","Validity"],"members":{"ApiPassthrough":{"type":"structure","members":{"Extensions":{"type":"structure","members":{"CertificatePolicies":{"type":"list","member":{"type":"structure","required":["CertPolicyId"],"members":{"CertPolicyId":{},"PolicyQualifiers":{"type":"list","member":{"type":"structure","required":["PolicyQualifierId","Qualifier"],"members":{"PolicyQualifierId":{},"Qualifier":{"type":"structure","required":["CpsUri"],"members":{"CpsUri":{}}}}}}}}},"ExtendedKeyUsage":{"type":"list","member":{"type":"structure","members":{"ExtendedKeyUsageType":{},"ExtendedKeyUsageObjectIdentifier":{}}}},"KeyUsage":{"shape":"Sj"},"SubjectAlternativeNames":{"type":"list","member":{"shape":"Sp"}},"CustomExtensions":{"type":"list","member":{"type":"structure","required":["ObjectIdentifier","Value"],"members":{"ObjectIdentifier":{},"Value":{},"Critical":{"type":"boolean"}}}}}},"Subject":{"shape":"S5"}}},"CertificateAuthorityArn":{},"Csr":{"type":"blob"},"SigningAlgorithm":{},"TemplateArn":{},"Validity":{"shape":"S2v"},"ValidityNotBefore":{"shape":"S2v"},"IdempotencyToken":{}}},"output":{"type":"structure","members":{"CertificateArn":{}}},"idempotent":true},"ListCertificateAuthorities":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResourceOwner":{}}},"output":{"type":"structure","members":{"CertificateAuthorities":{"type":"list","member":{"shape":"S1r"}},"NextToken":{}}}},"ListPermissions":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"CertificateAuthorityArn":{},"CreatedAt":{"type":"timestamp"},"Principal":{},"SourceAccount":{},"Actions":{"shape":"S1j"},"Policy":{}}}},"NextToken":{}}}},"ListTags":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S14"},"NextToken":{}}}},"PutPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}}},"RestoreCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}}},"RevokeCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","CertificateSerial","RevocationReason"],"members":{"CertificateAuthorityArn":{},"CertificateSerial":{},"RevocationReason":{}}}},"TagCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn","Tags"],"members":{"CertificateAuthorityArn":{},"Tags":{"shape":"S14"}}}},"UntagCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn","Tags"],"members":{"CertificateAuthorityArn":{},"Tags":{"shape":"S14"}}}},"UpdateCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"RevocationConfiguration":{"shape":"Sv"},"Status":{}}}}},"shapes":{"S2":{"type":"structure","required":["KeyAlgorithm","SigningAlgorithm","Subject"],"members":{"KeyAlgorithm":{},"SigningAlgorithm":{},"Subject":{"shape":"S5"},"CsrExtensions":{"type":"structure","members":{"KeyUsage":{"shape":"Sj"},"SubjectInformationAccess":{"type":"list","member":{"type":"structure","required":["AccessMethod","AccessLocation"],"members":{"AccessMethod":{"type":"structure","members":{"CustomObjectIdentifier":{},"AccessMethodType":{}}},"AccessLocation":{"shape":"Sp"}}}}}}}},"S5":{"type":"structure","members":{"Country":{},"Organization":{},"OrganizationalUnit":{},"DistinguishedNameQualifier":{},"State":{},"CommonName":{},"SerialNumber":{},"Locality":{},"Title":{},"Surname":{},"GivenName":{},"Initials":{},"Pseudonym":{},"GenerationQualifier":{},"CustomAttributes":{"type":"list","member":{"type":"structure","required":["ObjectIdentifier","Value"],"members":{"ObjectIdentifier":{},"Value":{}}}}}},"Sj":{"type":"structure","members":{"DigitalSignature":{"type":"boolean"},"NonRepudiation":{"type":"boolean"},"KeyEncipherment":{"type":"boolean"},"DataEncipherment":{"type":"boolean"},"KeyAgreement":{"type":"boolean"},"KeyCertSign":{"type":"boolean"},"CRLSign":{"type":"boolean"},"EncipherOnly":{"type":"boolean"},"DecipherOnly":{"type":"boolean"}}},"Sp":{"type":"structure","members":{"OtherName":{"type":"structure","required":["TypeId","Value"],"members":{"TypeId":{},"Value":{}}},"Rfc822Name":{},"DnsName":{},"DirectoryName":{"shape":"S5"},"EdiPartyName":{"type":"structure","required":["PartyName"],"members":{"PartyName":{},"NameAssigner":{}}},"UniformResourceIdentifier":{},"IpAddress":{},"RegisteredId":{}}},"Sv":{"type":"structure","members":{"CrlConfiguration":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"ExpirationInDays":{"type":"integer"},"CustomCname":{},"S3BucketName":{},"S3ObjectAcl":{}}},"OcspConfiguration":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"OcspCustomCname":{}}}}},"S14":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1j":{"type":"list","member":{}},"S1r":{"type":"structure","members":{"Arn":{},"OwnerAccount":{},"CreatedAt":{"type":"timestamp"},"LastStateChangeAt":{"type":"timestamp"},"Type":{},"Serial":{},"Status":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"FailureReason":{},"CertificateAuthorityConfiguration":{"shape":"S2"},"RevocationConfiguration":{"shape":"Sv"},"RestorableUntil":{"type":"timestamp"},"KeyStorageSecurityStandard":{}}},"S2v":{"type":"structure","required":["Value","Type"],"members":{"Value":{"type":"long"},"Type":{}}}}}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCertificateAuthorities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CertificateAuthorities"},"ListPermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Permissions"},"ListTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"CertificateAuthorityCSRCreated":{"description":"Wait until a Certificate Authority CSR is created","operation":"GetCertificateAuthorityCsr","delay":3,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"RequestInProgressException"}]},"CertificateIssued":{"description":"Wait until a certificate is issued","operation":"GetCertificate","delay":3,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"RequestInProgressException"}]},"AuditReportCreated":{"description":"Wait until a Audit Report is created","operation":"DescribeCertificateAuthorityAuditReport","delay":3,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"AuditReportStatus","expected":"SUCCESS"},{"state":"failure","matcher":"path","argument":"AuditReportStatus","expected":"FAILED"}]}}}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['fms'] = {};
	AWS.FMS = Service.defineService('fms', ['2018-01-01']);
	Object.defineProperty(apiLoader.services['fms'], '2018-01-01', {
	  get: function get() {
	    var model = __webpack_require__(608);
	    model.paginators = __webpack_require__(609).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.FMS;


/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-01-01","endpointPrefix":"fms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"FMS","serviceFullName":"Firewall Management Service","serviceId":"FMS","signatureVersion":"v4","targetPrefix":"AWSFMS_20180101","uid":"fms-2018-01-01"},"operations":{"AssociateAdminAccount":{"input":{"type":"structure","required":["AdminAccount"],"members":{"AdminAccount":{}}}},"AssociateThirdPartyFirewall":{"input":{"type":"structure","required":["ThirdPartyFirewall"],"members":{"ThirdPartyFirewall":{}}},"output":{"type":"structure","members":{"ThirdPartyFirewallStatus":{}}}},"DeleteAppsList":{"input":{"type":"structure","required":["ListId"],"members":{"ListId":{}}}},"DeleteNotificationChannel":{"input":{"type":"structure","members":{}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"DeleteAllPolicyResources":{"type":"boolean"}}}},"DeleteProtocolsList":{"input":{"type":"structure","required":["ListId"],"members":{"ListId":{}}}},"DisassociateAdminAccount":{"input":{"type":"structure","members":{}}},"DisassociateThirdPartyFirewall":{"input":{"type":"structure","required":["ThirdPartyFirewall"],"members":{"ThirdPartyFirewall":{}}},"output":{"type":"structure","members":{"ThirdPartyFirewallStatus":{}}}},"GetAdminAccount":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AdminAccount":{},"RoleStatus":{}}}},"GetAppsList":{"input":{"type":"structure","required":["ListId"],"members":{"ListId":{},"DefaultList":{"type":"boolean"}}},"output":{"type":"structure","members":{"AppsList":{"shape":"Sm"},"AppsListArn":{}}}},"GetComplianceDetail":{"input":{"type":"structure","required":["PolicyId","MemberAccount"],"members":{"PolicyId":{},"MemberAccount":{}}},"output":{"type":"structure","members":{"PolicyComplianceDetail":{"type":"structure","members":{"PolicyOwner":{},"PolicyId":{},"MemberAccount":{},"Violators":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ViolationReason":{},"ResourceType":{},"Metadata":{"type":"map","key":{},"value":{}}}}},"EvaluationLimitExceeded":{"type":"boolean"},"ExpiredAt":{"type":"timestamp"},"IssueInfoMap":{"shape":"S17"}}}}}},"GetNotificationChannel":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"SnsTopicArn":{},"SnsRoleName":{}}}},"GetPolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1e"},"PolicyArn":{}}}},"GetProtectionStatus":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"MemberAccountId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AdminAccountId":{},"ServiceType":{},"Data":{},"NextToken":{}}}},"GetProtocolsList":{"input":{"type":"structure","required":["ListId"],"members":{"ListId":{},"DefaultList":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProtocolsList":{"shape":"S23"},"ProtocolsListArn":{}}}},"GetThirdPartyFirewallAssociationStatus":{"input":{"type":"structure","required":["ThirdPartyFirewall"],"members":{"ThirdPartyFirewall":{}}},"output":{"type":"structure","members":{"ThirdPartyFirewallStatus":{},"MarketplaceOnboardingStatus":{}}}},"GetViolationDetails":{"input":{"type":"structure","required":["PolicyId","MemberAccount","ResourceId","ResourceType"],"members":{"PolicyId":{},"MemberAccount":{},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ViolationDetail":{"type":"structure","required":["PolicyId","MemberAccount","ResourceId","ResourceType","ResourceViolations"],"members":{"PolicyId":{},"MemberAccount":{},"ResourceId":{},"ResourceType":{},"ResourceViolations":{"type":"list","member":{"type":"structure","members":{"AwsVPCSecurityGroupViolation":{"type":"structure","members":{"ViolationTarget":{},"ViolationTargetDescription":{},"PartialMatches":{"type":"list","member":{"type":"structure","members":{"Reference":{},"TargetViolationReasons":{"type":"list","member":{}}}}},"PossibleSecurityGroupRemediationActions":{"type":"list","member":{"type":"structure","members":{"RemediationActionType":{},"Description":{},"RemediationResult":{"type":"structure","members":{"IPV4Range":{},"IPV6Range":{},"PrefixListId":{},"Protocol":{},"FromPort":{"type":"long"},"ToPort":{"type":"long"}}},"IsDefaultAction":{"type":"boolean"}}}}}},"AwsEc2NetworkInterfaceViolation":{"shape":"S2r"},"AwsEc2InstanceViolation":{"type":"structure","members":{"ViolationTarget":{},"AwsEc2NetworkInterfaceViolations":{"type":"list","member":{"shape":"S2r"}}}},"NetworkFirewallMissingFirewallViolation":{"type":"structure","members":{"ViolationTarget":{},"VPC":{},"AvailabilityZone":{},"TargetViolationReason":{}}},"NetworkFirewallMissingSubnetViolation":{"type":"structure","members":{"ViolationTarget":{},"VPC":{},"AvailabilityZone":{},"TargetViolationReason":{}}},"NetworkFirewallMissingExpectedRTViolation":{"type":"structure","members":{"ViolationTarget":{},"VPC":{},"AvailabilityZone":{},"CurrentRouteTable":{},"ExpectedRouteTable":{}}},"NetworkFirewallPolicyModifiedViolation":{"type":"structure","members":{"ViolationTarget":{},"CurrentPolicyDescription":{"shape":"S2z"},"ExpectedPolicyDescription":{"shape":"S2z"}}},"NetworkFirewallInternetTrafficNotInspectedViolation":{"type":"structure","members":{"SubnetId":{},"SubnetAvailabilityZone":{},"RouteTableId":{},"ViolatingRoutes":{"shape":"S39"},"IsRouteTableUsedInDifferentAZ":{"type":"boolean"},"CurrentFirewallSubnetRouteTable":{},"ExpectedFirewallEndpoint":{},"FirewallSubnetId":{},"ExpectedFirewallSubnetRoutes":{"shape":"S3d"},"ActualFirewallSubnetRoutes":{"shape":"S39"},"InternetGatewayId":{},"CurrentInternetGatewayRouteTable":{},"ExpectedInternetGatewayRoutes":{"shape":"S3d"},"ActualInternetGatewayRoutes":{"shape":"S39"},"VpcId":{}}},"NetworkFirewallInvalidRouteConfigurationViolation":{"type":"structure","members":{"AffectedSubnets":{"shape":"S2s"},"RouteTableId":{},"IsRouteTableUsedInDifferentAZ":{"type":"boolean"},"ViolatingRoute":{"shape":"S3a"},"CurrentFirewallSubnetRouteTable":{},"ExpectedFirewallEndpoint":{},"ActualFirewallEndpoint":{},"ExpectedFirewallSubnetId":{},"ActualFirewallSubnetId":{},"ExpectedFirewallSubnetRoutes":{"shape":"S3d"},"ActualFirewallSubnetRoutes":{"shape":"S39"},"InternetGatewayId":{},"CurrentInternetGatewayRouteTable":{},"ExpectedInternetGatewayRoutes":{"shape":"S3d"},"ActualInternetGatewayRoutes":{"shape":"S39"},"VpcId":{}}},"NetworkFirewallBlackHoleRouteDetectedViolation":{"type":"structure","members":{"ViolationTarget":{},"RouteTableId":{},"VpcId":{},"ViolatingRoutes":{"shape":"S39"}}},"NetworkFirewallUnexpectedFirewallRoutesViolation":{"type":"structure","members":{"FirewallSubnetId":{},"ViolatingRoutes":{"shape":"S39"},"RouteTableId":{},"FirewallEndpoint":{},"VpcId":{}}},"NetworkFirewallUnexpectedGatewayRoutesViolation":{"type":"structure","members":{"GatewayId":{},"ViolatingRoutes":{"shape":"S39"},"RouteTableId":{},"VpcId":{}}},"NetworkFirewallMissingExpectedRoutesViolation":{"type":"structure","members":{"ViolationTarget":{},"ExpectedRoutes":{"shape":"S3d"},"VpcId":{}}},"DnsRuleGroupPriorityConflictViolation":{"type":"structure","members":{"ViolationTarget":{},"ViolationTargetDescription":{},"ConflictingPriority":{"type":"integer"},"ConflictingPolicyId":{},"UnavailablePriorities":{"type":"list","member":{"type":"integer"}}}},"DnsDuplicateRuleGroupViolation":{"type":"structure","members":{"ViolationTarget":{},"ViolationTargetDescription":{}}},"DnsRuleGroupLimitExceededViolation":{"type":"structure","members":{"ViolationTarget":{},"ViolationTargetDescription":{},"NumberOfRuleGroupsAlreadyAssociated":{"type":"integer"}}},"PossibleRemediationActions":{"type":"structure","members":{"Description":{},"Actions":{"type":"list","member":{"type":"structure","required":["OrderedRemediationActions"],"members":{"Description":{},"OrderedRemediationActions":{"type":"list","member":{"type":"structure","members":{"RemediationAction":{"type":"structure","members":{"Description":{},"EC2CreateRouteAction":{"type":"structure","required":["RouteTableId"],"members":{"Description":{},"DestinationCidrBlock":{},"DestinationPrefixListId":{},"DestinationIpv6CidrBlock":{},"VpcEndpointId":{"shape":"S3y"},"GatewayId":{"shape":"S3y"},"RouteTableId":{"shape":"S3y"}}},"EC2ReplaceRouteAction":{"type":"structure","required":["RouteTableId"],"members":{"Description":{},"DestinationCidrBlock":{},"DestinationPrefixListId":{},"DestinationIpv6CidrBlock":{},"GatewayId":{"shape":"S3y"},"RouteTableId":{"shape":"S3y"}}},"EC2DeleteRouteAction":{"type":"structure","required":["RouteTableId"],"members":{"Description":{},"DestinationCidrBlock":{},"DestinationPrefixListId":{},"DestinationIpv6CidrBlock":{},"RouteTableId":{"shape":"S3y"}}},"EC2CopyRouteTableAction":{"type":"structure","required":["VpcId","RouteTableId"],"members":{"Description":{},"VpcId":{"shape":"S3y"},"RouteTableId":{"shape":"S3y"}}},"EC2ReplaceRouteTableAssociationAction":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"Description":{},"AssociationId":{"shape":"S3y"},"RouteTableId":{"shape":"S3y"}}},"EC2AssociateRouteTableAction":{"type":"structure","required":["RouteTableId"],"members":{"Description":{},"RouteTableId":{"shape":"S3y"},"SubnetId":{"shape":"S3y"},"GatewayId":{"shape":"S3y"}}},"EC2CreateRouteTableAction":{"type":"structure","required":["VpcId"],"members":{"Description":{},"VpcId":{"shape":"S3y"}}},"FMSPolicyUpdateFirewallCreationConfigAction":{"type":"structure","members":{"Description":{},"FirewallCreationConfig":{}}}}},"Order":{"type":"integer"}}}},"IsDefaultAction":{"type":"boolean"}}}}}},"FirewallSubnetIsOutOfScopeViolation":{"type":"structure","members":{"FirewallSubnetId":{},"VpcId":{},"SubnetAvailabilityZone":{},"SubnetAvailabilityZoneId":{},"VpcEndpointId":{}}},"RouteHasOutOfScopeEndpointViolation":{"type":"structure","members":{"SubnetId":{},"VpcId":{},"RouteTableId":{},"ViolatingRoutes":{"shape":"S39"},"SubnetAvailabilityZone":{},"SubnetAvailabilityZoneId":{},"CurrentFirewallSubnetRouteTable":{},"FirewallSubnetId":{},"FirewallSubnetRoutes":{"shape":"S39"},"InternetGatewayId":{},"CurrentInternetGatewayRouteTable":{},"InternetGatewayRoutes":{"shape":"S39"}}},"ThirdPartyFirewallMissingFirewallViolation":{"type":"structure","members":{"ViolationTarget":{},"VPC":{},"AvailabilityZone":{},"TargetViolationReason":{}}},"ThirdPartyFirewallMissingSubnetViolation":{"type":"structure","members":{"ViolationTarget":{},"VPC":{},"AvailabilityZone":{},"TargetViolationReason":{}}},"ThirdPartyFirewallMissingExpectedRouteTableViolation":{"type":"structure","members":{"ViolationTarget":{},"VPC":{},"AvailabilityZone":{},"CurrentRouteTable":{},"ExpectedRouteTable":{}}},"FirewallSubnetMissingVPCEndpointViolation":{"type":"structure","members":{"FirewallSubnetId":{},"VpcId":{},"SubnetAvailabilityZone":{},"SubnetAvailabilityZoneId":{}}}}}},"ResourceTags":{"shape":"S4c"},"ResourceDescription":{}}}}}},"ListAppsLists":{"input":{"type":"structure","required":["MaxResults"],"members":{"DefaultLists":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AppsLists":{"type":"list","member":{"type":"structure","members":{"ListArn":{},"ListId":{},"ListName":{},"AppsList":{"shape":"Sq"}}}},"NextToken":{}}}},"ListComplianceStatus":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyComplianceStatusList":{"type":"list","member":{"type":"structure","members":{"PolicyOwner":{},"PolicyId":{},"PolicyName":{},"MemberAccount":{},"EvaluationResults":{"type":"list","member":{"type":"structure","members":{"ComplianceStatus":{},"ViolatorCount":{"type":"long"},"EvaluationLimitExceeded":{"type":"boolean"}}}},"LastUpdated":{"type":"timestamp"},"IssueInfoMap":{"shape":"S17"}}}},"NextToken":{}}}},"ListMemberAccounts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"MemberAccounts":{"type":"list","member":{}},"NextToken":{}}}},"ListPolicies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyList":{"type":"list","member":{"type":"structure","members":{"PolicyArn":{},"PolicyId":{},"PolicyName":{},"ResourceType":{},"SecurityServiceType":{},"RemediationEnabled":{"type":"boolean"},"DeleteUnusedFMManagedResources":{"type":"boolean"}}}},"NextToken":{}}}},"ListProtocolsLists":{"input":{"type":"structure","required":["MaxResults"],"members":{"DefaultLists":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProtocolsLists":{"type":"list","member":{"type":"structure","members":{"ListArn":{},"ListId":{},"ListName":{},"ProtocolsList":{"shape":"S24"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4c"}}}},"ListThirdPartyFirewallFirewallPolicies":{"input":{"type":"structure","required":["ThirdPartyFirewall","MaxResults"],"members":{"ThirdPartyFirewall":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ThirdPartyFirewallFirewallPolicies":{"type":"list","member":{"type":"structure","members":{"FirewallPolicyId":{},"FirewallPolicyName":{}}}},"NextToken":{}}}},"PutAppsList":{"input":{"type":"structure","required":["AppsList"],"members":{"AppsList":{"shape":"Sm"},"TagList":{"shape":"S4c"}}},"output":{"type":"structure","members":{"AppsList":{"shape":"Sm"},"AppsListArn":{}}}},"PutNotificationChannel":{"input":{"type":"structure","required":["SnsTopicArn","SnsRoleName"],"members":{"SnsTopicArn":{},"SnsRoleName":{}}}},"PutPolicy":{"input":{"type":"structure","required":["Policy"],"members":{"Policy":{"shape":"S1e"},"TagList":{"shape":"S4c"}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1e"},"PolicyArn":{}}}},"PutProtocolsList":{"input":{"type":"structure","required":["ProtocolsList"],"members":{"ProtocolsList":{"shape":"S23"},"TagList":{"shape":"S4c"}}},"output":{"type":"structure","members":{"ProtocolsList":{"shape":"S23"},"ProtocolsListArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S4c"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sm":{"type":"structure","required":["ListName","AppsList"],"members":{"ListId":{},"ListName":{},"ListUpdateToken":{},"CreateTime":{"type":"timestamp"},"LastUpdateTime":{"type":"timestamp"},"AppsList":{"shape":"Sq"},"PreviousAppsList":{"type":"map","key":{},"value":{"shape":"Sq"}}}},"Sq":{"type":"list","member":{"type":"structure","required":["AppName","Protocol","Port"],"members":{"AppName":{},"Protocol":{},"Port":{"type":"long"}}}},"S17":{"type":"map","key":{},"value":{}},"S1e":{"type":"structure","required":["PolicyName","SecurityServicePolicyData","ResourceType","ExcludeResourceTags","RemediationEnabled"],"members":{"PolicyId":{},"PolicyName":{},"PolicyUpdateToken":{},"SecurityServicePolicyData":{"type":"structure","required":["Type"],"members":{"Type":{},"ManagedServiceData":{},"PolicyOption":{"type":"structure","members":{"NetworkFirewallPolicy":{"type":"structure","members":{"FirewallDeploymentModel":{}}},"ThirdPartyFirewallPolicy":{"type":"structure","members":{"FirewallDeploymentModel":{}}}}}}},"ResourceType":{},"ResourceTypeList":{"type":"list","member":{}},"ResourceTags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"ExcludeResourceTags":{"type":"boolean"},"RemediationEnabled":{"type":"boolean"},"DeleteUnusedFMManagedResources":{"type":"boolean"},"IncludeMap":{"shape":"S1s"},"ExcludeMap":{"shape":"S1s"}}},"S1s":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S23":{"type":"structure","required":["ListName","ProtocolsList"],"members":{"ListId":{},"ListName":{},"ListUpdateToken":{},"CreateTime":{"type":"timestamp"},"LastUpdateTime":{"type":"timestamp"},"ProtocolsList":{"shape":"S24"},"PreviousProtocolsList":{"type":"map","key":{},"value":{"shape":"S24"}}}},"S24":{"type":"list","member":{}},"S2r":{"type":"structure","members":{"ViolationTarget":{},"ViolatingSecurityGroups":{"shape":"S2s"}}},"S2s":{"type":"list","member":{}},"S2z":{"type":"structure","members":{"StatelessRuleGroups":{"type":"list","member":{"type":"structure","members":{"RuleGroupName":{},"ResourceId":{},"Priority":{"type":"integer"}}}},"StatelessDefaultActions":{"shape":"S34"},"StatelessFragmentDefaultActions":{"shape":"S34"},"StatelessCustomActions":{"shape":"S34"},"StatefulRuleGroups":{"type":"list","member":{"type":"structure","members":{"RuleGroupName":{},"ResourceId":{}}}}}},"S34":{"type":"list","member":{}},"S39":{"type":"list","member":{"shape":"S3a"}},"S3a":{"type":"structure","members":{"DestinationType":{},"TargetType":{},"Destination":{},"Target":{}}},"S3d":{"type":"list","member":{"type":"structure","members":{"IpV4Cidr":{},"PrefixListId":{},"IpV6Cidr":{},"ContributingSubnets":{"shape":"S2s"},"AllowedTargets":{"type":"list","member":{}},"RouteTableId":{}}}},"S3y":{"type":"structure","members":{"ResourceId":{},"Description":{}}},"S4c":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAppsLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AppsLists"},"ListComplianceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PolicyComplianceStatusList"},"ListMemberAccounts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MemberAccounts"},"ListPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PolicyList"},"ListProtocolsLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProtocolsLists"},"ListThirdPartyFirewallFirewallPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ThirdPartyFirewallFirewallPolicies"}}}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['secretsmanager'] = {};
	AWS.SecretsManager = Service.defineService('secretsmanager', ['2017-10-17']);
	Object.defineProperty(apiLoader.services['secretsmanager'], '2017-10-17', {
	  get: function get() {
	    var model = __webpack_require__(611);
	    model.paginators = __webpack_require__(612).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SecretsManager;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-17","endpointPrefix":"secretsmanager","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Secrets Manager","serviceId":"Secrets Manager","signatureVersion":"v4","signingName":"secretsmanager","targetPrefix":"secretsmanager","uid":"secretsmanager-2017-10-17"},"operations":{"CancelRotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"CreateSecret":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"Tags":{"shape":"Se"},"AddReplicaRegions":{"shape":"Si"},"ForceOverwriteReplicaSecret":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"ReplicationStatus":{"shape":"Sn"}}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"DeleteSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"RecoveryWindowInDays":{"type":"long"},"ForceDeleteWithoutRecovery":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"DeletionDate":{"type":"timestamp"}}}},"DescribeSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"S12"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"Tags":{"shape":"Se"},"VersionIdsToStages":{"shape":"S19"},"OwningService":{},"CreatedDate":{"type":"timestamp"},"PrimaryRegion":{},"ReplicationStatus":{"shape":"Sn"}}}},"GetRandomPassword":{"input":{"type":"structure","members":{"PasswordLength":{"type":"long"},"ExcludeCharacters":{},"ExcludeNumbers":{"type":"boolean"},"ExcludePunctuation":{"type":"boolean"},"ExcludeUppercase":{"type":"boolean"},"ExcludeLowercase":{"type":"boolean"},"IncludeSpace":{"type":"boolean"},"RequireEachIncludedType":{"type":"boolean"}}},"output":{"type":"structure","members":{"RandomPassword":{"type":"string","sensitive":true}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"ResourcePolicy":{}}}},"GetSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"VersionId":{},"VersionStage":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"VersionStages":{"shape":"S1a"},"CreatedDate":{"type":"timestamp"}}}},"ListSecretVersionIds":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"MaxResults":{"type":"integer"},"NextToken":{},"IncludeDeprecated":{"type":"boolean"}}},"output":{"type":"structure","members":{"Versions":{"type":"list","member":{"type":"structure","members":{"VersionId":{},"VersionStages":{"shape":"S1a"},"LastAccessedDate":{"type":"timestamp"},"CreatedDate":{"type":"timestamp"},"KmsKeyIds":{"type":"list","member":{}}}}},"NextToken":{},"ARN":{},"Name":{}}}},"ListSecrets":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"SortOrder":{}}},"output":{"type":"structure","members":{"SecretList":{"type":"list","member":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"S12"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"Tags":{"shape":"Se"},"SecretVersionsToStages":{"shape":"S19"},"OwningService":{},"CreatedDate":{"type":"timestamp"},"PrimaryRegion":{}}}},"NextToken":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["SecretId","ResourcePolicy"],"members":{"SecretId":{},"ResourcePolicy":{},"BlockPublicPolicy":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"PutSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"VersionStages":{"shape":"S1a"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"VersionStages":{"shape":"S1a"}}}},"RemoveRegionsFromReplication":{"input":{"type":"structure","required":["SecretId","RemoveReplicaRegions"],"members":{"SecretId":{},"RemoveReplicaRegions":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ARN":{},"ReplicationStatus":{"shape":"Sn"}}}},"ReplicateSecretToRegions":{"input":{"type":"structure","required":["SecretId","AddReplicaRegions"],"members":{"SecretId":{},"AddReplicaRegions":{"shape":"Si"},"ForceOverwriteReplicaSecret":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"ReplicationStatus":{"shape":"Sn"}}}},"RestoreSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"RotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"RotationLambdaARN":{},"RotationRules":{"shape":"S12"},"RotateImmediately":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"StopReplicationToReplica":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{}}}},"TagResource":{"input":{"type":"structure","required":["SecretId","Tags"],"members":{"SecretId":{},"Tags":{"shape":"Se"}}}},"UntagResource":{"input":{"type":"structure","required":["SecretId","TagKeys"],"members":{"SecretId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"UpdateSecretVersionStage":{"input":{"type":"structure","required":["SecretId","VersionStage"],"members":{"SecretId":{},"VersionStage":{},"RemoveFromVersionId":{},"MoveToVersionId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"ValidateResourcePolicy":{"input":{"type":"structure","required":["ResourcePolicy"],"members":{"SecretId":{},"ResourcePolicy":{}}},"output":{"type":"structure","members":{"PolicyValidationPassed":{"type":"boolean"},"ValidationErrors":{"type":"list","member":{"type":"structure","members":{"CheckName":{},"ErrorMessage":{}}}}}}}},"shapes":{"Sc":{"type":"blob","sensitive":true},"Sd":{"type":"string","sensitive":true},"Se":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Si":{"type":"list","member":{"type":"structure","members":{"Region":{},"KmsKeyId":{}}}},"Sn":{"type":"list","member":{"type":"structure","members":{"Region":{},"KmsKeyId":{},"Status":{},"StatusMessage":{},"LastAccessedDate":{"type":"timestamp"}}}},"S12":{"type":"structure","members":{"AutomaticallyAfterDays":{"type":"long"},"Duration":{},"ScheduleExpression":{}}},"S19":{"type":"map","key":{},"value":{"shape":"S1a"}},"S1a":{"type":"list","member":{}}}}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListSecretVersionIds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecrets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotanalytics'] = {};
	AWS.IoTAnalytics = Service.defineService('iotanalytics', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['iotanalytics'], '2017-11-27', {
	  get: function get() {
	    var model = __webpack_require__(614);
	    model.paginators = __webpack_require__(615).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTAnalytics;


/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"iotanalytics","protocol":"rest-json","serviceFullName":"AWS IoT Analytics","serviceId":"IoTAnalytics","signatureVersion":"v4","signingName":"iotanalytics","uid":"iotanalytics-2017-11-27"},"operations":{"BatchPutMessage":{"http":{"requestUri":"/messages/batch","responseCode":200},"input":{"type":"structure","required":["channelName","messages"],"members":{"channelName":{},"messages":{"type":"list","member":{"type":"structure","required":["messageId","payload"],"members":{"messageId":{},"payload":{"type":"blob"}}}}}},"output":{"type":"structure","members":{"batchPutMessageErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"CancelPipelineReprocessing":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}/reprocessing/{reprocessingId}"},"input":{"type":"structure","required":["pipelineName","reprocessingId"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"reprocessingId":{"location":"uri","locationName":"reprocessingId"}}},"output":{"type":"structure","members":{}}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":201},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"channelName":{},"channelArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDataset":{"http":{"requestUri":"/datasets","responseCode":201},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"tags":{"shape":"Sq"},"lateDataRules":{"shape":"S24"}}},"output":{"type":"structure","members":{"datasetName":{},"datasetArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDatasetContent":{"http":{"requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{}}},"output":{"type":"structure","members":{"versionId":{}}}},"CreateDatastore":{"http":{"requestUri":"/datastores","responseCode":201},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{},"datastoreStorage":{"shape":"S2h"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"},"fileFormatConfiguration":{"shape":"S2m"},"datastorePartitions":{"shape":"S2u"}}},"output":{"type":"structure","members":{"datastoreName":{},"datastoreArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreatePipeline":{"http":{"requestUri":"/pipelines","responseCode":201},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{},"pipelineActivities":{"shape":"S34"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineArn":{}}}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{channelName}","responseCode":204},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}}},"DeleteDatasetContent":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}/content","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}}},"DeleteDatastore":{"http":{"method":"DELETE","requestUri":"/datastores/{datastoreName}","responseCode":204},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}","responseCode":204},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"channel":{"type":"structure","members":{"name":{},"storage":{"shape":"Sh"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S42"}}}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"arn":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"lateDataRules":{"shape":"S24"}}}}}},"DescribeDatastore":{"http":{"method":"GET","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"datastore":{"type":"structure","members":{"name":{},"storage":{"shape":"S2h"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"},"fileFormatConfiguration":{"shape":"S2m"},"datastorePartitions":{"shape":"S2u"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S42"}}}}}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"loggingOptions":{"shape":"S4f"}}}},"DescribePipeline":{"http":{"method":"GET","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}},"output":{"type":"structure","members":{"pipeline":{"type":"structure","members":{"name":{},"arn":{},"activities":{"shape":"S34"},"reprocessingSummaries":{"shape":"S4l"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"GetDatasetContent":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"entries":{"type":"list","member":{"type":"structure","members":{"entryName":{},"dataURI":{}}}},"timestamp":{"type":"timestamp"},"status":{"shape":"S4t"}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"channelSummaries":{"type":"list","member":{"type":"structure","members":{"channelName":{},"channelStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasetContents":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/contents"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"scheduledOnOrAfter":{"location":"querystring","locationName":"scheduledOnOrAfter","type":"timestamp"},"scheduledBefore":{"location":"querystring","locationName":"scheduledBefore","type":"timestamp"}}},"output":{"type":"structure","members":{"datasetContentSummaries":{"type":"list","member":{"type":"structure","members":{"version":{},"status":{"shape":"S4t"},"creationTime":{"type":"timestamp"},"scheduleTime":{"type":"timestamp"},"completionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/datasets"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datasetSummaries":{"type":"list","member":{"type":"structure","members":{"datasetName":{},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"triggers":{"shape":"S1l"},"actions":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionType":{}}}}}}},"nextToken":{}}}},"ListDatastores":{"http":{"method":"GET","requestUri":"/datastores"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datastoreSummaries":{"type":"list","member":{"type":"structure","members":{"datastoreName":{},"datastoreStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}},"iotSiteWiseMultiLayerStorage":{"type":"structure","members":{"customerManagedS3Storage":{"type":"structure","members":{"bucket":{},"keyPrefix":{}}}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"},"fileFormatType":{},"datastorePartitions":{"shape":"S2u"}}}},"nextToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/pipelines"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"pipelineSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineName":{},"reprocessingSummaries":{"shape":"S4l"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"}}}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S4f"}}}},"RunPipelineActivity":{"http":{"requestUri":"/pipelineactivities/run"},"input":{"type":"structure","required":["pipelineActivity","payloads"],"members":{"pipelineActivity":{"shape":"S35"},"payloads":{"shape":"S5z"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S5z"},"logResult":{}}}},"SampleChannelData":{"http":{"method":"GET","requestUri":"/channels/{channelName}/sample"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"maxMessages":{"location":"querystring","locationName":"maxMessages","type":"integer"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S5z"}}}},"StartPipelineReprocessing":{"http":{"requestUri":"/pipelines/{pipelineName}/reprocessing"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"channelMessages":{"type":"structure","members":{"s3Paths":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"reprocessingId":{}}}},"TagResource":{"http":{"requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"}}}},"UpdateDataset":{"http":{"method":"PUT","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"lateDataRules":{"shape":"S24"}}}},"UpdateDatastore":{"http":{"method":"PUT","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"retentionPeriod":{"shape":"Sn"},"datastoreStorage":{"shape":"S2h"},"fileFormatConfiguration":{"shape":"S2m"}}}},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"pipelineActivities":{"shape":"S34"}}}}},"shapes":{"Sh":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"Sn":{"type":"structure","members":{"unlimited":{"type":"boolean"},"numberOfDays":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{"type":"structure","members":{"actionName":{},"queryAction":{"type":"structure","required":["sqlQuery"],"members":{"sqlQuery":{},"filters":{"type":"list","member":{"type":"structure","members":{"deltaTime":{"type":"structure","required":["offsetSeconds","timeExpression"],"members":{"offsetSeconds":{"type":"integer"},"timeExpression":{}}}}}}}},"containerAction":{"type":"structure","required":["image","executionRoleArn","resourceConfiguration"],"members":{"image":{},"executionRoleArn":{},"resourceConfiguration":{"type":"structure","required":["computeType","volumeSizeInGB"],"members":{"computeType":{},"volumeSizeInGB":{"type":"integer"}}},"variables":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"stringValue":{},"doubleValue":{"type":"double"},"datasetContentVersionValue":{"type":"structure","required":["datasetName"],"members":{"datasetName":{}}},"outputFileUriValue":{"type":"structure","required":["fileName"],"members":{"fileName":{}}}}}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"schedule":{"type":"structure","members":{"expression":{}}},"dataset":{"type":"structure","required":["name"],"members":{"name":{}}}}}},"S1q":{"type":"list","member":{"type":"structure","required":["destination"],"members":{"entryName":{},"destination":{"type":"structure","members":{"iotEventsDestinationConfiguration":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"roleArn":{}}},"s3DestinationConfiguration":{"type":"structure","required":["bucket","key","roleArn"],"members":{"bucket":{},"key":{},"glueConfiguration":{"type":"structure","required":["tableName","databaseName"],"members":{"tableName":{},"databaseName":{}}},"roleArn":{}}}}}}}},"S21":{"type":"structure","members":{"unlimited":{"type":"boolean"},"maxVersions":{"type":"integer"}}},"S24":{"type":"list","member":{"type":"structure","required":["ruleConfiguration"],"members":{"ruleName":{},"ruleConfiguration":{"type":"structure","members":{"deltaTimeSessionWindowConfiguration":{"type":"structure","required":["timeoutInMinutes"],"members":{"timeoutInMinutes":{"type":"integer"}}}}}}}},"S2h":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}},"iotSiteWiseMultiLayerStorage":{"type":"structure","required":["customerManagedS3Storage"],"members":{"customerManagedS3Storage":{"type":"structure","required":["bucket"],"members":{"bucket":{},"keyPrefix":{}}}}}}},"S2m":{"type":"structure","members":{"jsonConfiguration":{"type":"structure","members":{}},"parquetConfiguration":{"type":"structure","members":{"schemaDefinition":{"type":"structure","members":{"columns":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}}}}}}}},"S2u":{"type":"structure","members":{"partitions":{"type":"list","member":{"type":"structure","members":{"attributePartition":{"type":"structure","required":["attributeName"],"members":{"attributeName":{}}},"timestampPartition":{"type":"structure","required":["attributeName"],"members":{"attributeName":{},"timestampFormat":{}}}}}}}},"S34":{"type":"list","member":{"shape":"S35"}},"S35":{"type":"structure","members":{"channel":{"type":"structure","required":["name","channelName"],"members":{"name":{},"channelName":{},"next":{}}},"lambda":{"type":"structure","required":["name","lambdaName","batchSize"],"members":{"name":{},"lambdaName":{},"batchSize":{"type":"integer"},"next":{}}},"datastore":{"type":"structure","required":["name","datastoreName"],"members":{"name":{},"datastoreName":{}}},"addAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"type":"map","key":{},"value":{}},"next":{}}},"removeAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S3g"},"next":{}}},"selectAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S3g"},"next":{}}},"filter":{"type":"structure","required":["name","filter"],"members":{"name":{},"filter":{},"next":{}}},"math":{"type":"structure","required":["name","attribute","math"],"members":{"name":{},"attribute":{},"math":{},"next":{}}},"deviceRegistryEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}},"deviceShadowEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}}}},"S3g":{"type":"list","member":{}},"S42":{"type":"structure","members":{"estimatedSizeInBytes":{"type":"double"},"estimatedOn":{"type":"timestamp"}}},"S4f":{"type":"structure","required":["roleArn","level","enabled"],"members":{"roleArn":{},"level":{},"enabled":{"type":"boolean"}}},"S4l":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"creationTime":{"type":"timestamp"}}}},"S4t":{"type":"structure","members":{"state":{},"reason":{}}},"S5z":{"type":"list","member":{"type":"blob"}}}}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChannels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasetContents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatastores":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iot1clickdevicesservice'] = {};
	AWS.IoT1ClickDevicesService = Service.defineService('iot1clickdevicesservice', ['2018-05-14']);
	Object.defineProperty(apiLoader.services['iot1clickdevicesservice'], '2018-05-14', {
	  get: function get() {
	    var model = __webpack_require__(617);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoT1ClickDevicesService;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-05-14","endpointPrefix":"devices.iot1click","signingName":"iot1click","serviceFullName":"AWS IoT 1-Click Devices Service","serviceId":"IoT 1Click Devices Service","protocol":"rest-json","jsonVersion":"1.1","uid":"devices-2018-05-14","signatureVersion":"v4"},"operations":{"ClaimDevicesByClaimCode":{"http":{"method":"PUT","requestUri":"/claims/{claimCode}","responseCode":200},"input":{"type":"structure","members":{"ClaimCode":{"location":"uri","locationName":"claimCode"}},"required":["ClaimCode"]},"output":{"type":"structure","members":{"ClaimCode":{"locationName":"claimCode"},"Total":{"locationName":"total","type":"integer"}}}},"DescribeDevice":{"http":{"method":"GET","requestUri":"/devices/{deviceId}","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"DeviceDescription":{"shape":"S8","locationName":"deviceDescription"}}}},"FinalizeDeviceClaim":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/finalize-claim","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"Tags":{"shape":"Sc","locationName":"tags"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"GetDeviceMethods":{"http":{"method":"GET","requestUri":"/devices/{deviceId}/methods","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"DeviceMethods":{"locationName":"deviceMethods","type":"list","member":{"shape":"Si"}}}}},"InitiateDeviceClaim":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/initiate-claim","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"InvokeDeviceMethod":{"http":{"requestUri":"/devices/{deviceId}/methods","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"DeviceMethod":{"shape":"Si","locationName":"deviceMethod"},"DeviceMethodParameters":{"locationName":"deviceMethodParameters"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"DeviceMethodResponse":{"locationName":"deviceMethodResponse"}}}},"ListDeviceEvents":{"http":{"method":"GET","requestUri":"/devices/{deviceId}/events","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"FromTimeStamp":{"shape":"So","location":"querystring","locationName":"fromTimeStamp"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ToTimeStamp":{"shape":"So","location":"querystring","locationName":"toTimeStamp"}},"required":["DeviceId","FromTimeStamp","ToTimeStamp"]},"output":{"type":"structure","members":{"Events":{"locationName":"events","type":"list","member":{"type":"structure","members":{"Device":{"locationName":"device","type":"structure","members":{"Attributes":{"locationName":"attributes","type":"structure","members":{}},"DeviceId":{"locationName":"deviceId"},"Type":{"locationName":"type"}}},"StdEvent":{"locationName":"stdEvent"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListDevices":{"http":{"method":"GET","requestUri":"/devices","responseCode":200},"input":{"type":"structure","members":{"DeviceType":{"location":"querystring","locationName":"deviceType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Devices":{"locationName":"devices","type":"list","member":{"shape":"S8"}},"NextToken":{"locationName":"nextToken"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sc","locationName":"tags"}}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"Sc","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UnclaimDevice":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/unclaim","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}},"required":["TagKeys","ResourceArn"]}},"UpdateDeviceState":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/state","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"Enabled":{"locationName":"enabled","type":"boolean"}},"required":["DeviceId"]},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Attributes":{"locationName":"attributes","type":"map","key":{},"value":{}},"DeviceId":{"locationName":"deviceId"},"Enabled":{"locationName":"enabled","type":"boolean"},"RemainingLife":{"locationName":"remainingLife","type":"double"},"Type":{"locationName":"type"},"Tags":{"shape":"Sc","locationName":"tags"}}},"Sc":{"type":"map","key":{},"value":{}},"Si":{"type":"structure","members":{"DeviceType":{"locationName":"deviceType"},"MethodName":{"locationName":"methodName"}}},"So":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iot1clickprojects'] = {};
	AWS.IoT1ClickProjects = Service.defineService('iot1clickprojects', ['2018-05-14']);
	Object.defineProperty(apiLoader.services['iot1clickprojects'], '2018-05-14', {
	  get: function get() {
	    var model = __webpack_require__(619);
	    model.paginators = __webpack_require__(620).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoT1ClickProjects;


/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-14","endpointPrefix":"projects.iot1click","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWS IoT 1-Click Projects","serviceFullName":"AWS IoT 1-Click Projects Service","serviceId":"IoT 1Click Projects","signatureVersion":"v4","signingName":"iot1click","uid":"iot1click-projects-2018-05-14"},"operations":{"AssociateDeviceWithPlacement":{"http":{"method":"PUT","requestUri":"/projects/{projectName}/placements/{placementName}/devices/{deviceTemplateName}"},"input":{"type":"structure","required":["projectName","placementName","deviceId","deviceTemplateName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"placementName":{"location":"uri","locationName":"placementName"},"deviceId":{},"deviceTemplateName":{"location":"uri","locationName":"deviceTemplateName"}}},"output":{"type":"structure","members":{}}},"CreatePlacement":{"http":{"requestUri":"/projects/{projectName}/placements"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{},"projectName":{"location":"uri","locationName":"projectName"},"attributes":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"CreateProject":{"http":{"requestUri":"/projects"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"description":{},"placementTemplate":{"shape":"Se"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"DeletePlacement":{"http":{"method":"DELETE","requestUri":"/projects/{projectName}/placements/{placementName}"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{"location":"uri","locationName":"placementName"},"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{projectName}"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","members":{}}},"DescribePlacement":{"http":{"method":"GET","requestUri":"/projects/{projectName}/placements/{placementName}"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{"location":"uri","locationName":"placementName"},"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","required":["placement"],"members":{"placement":{"type":"structure","required":["projectName","placementName","attributes","createdDate","updatedDate"],"members":{"projectName":{},"placementName":{},"attributes":{"shape":"S8"},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"}}}}}},"DescribeProject":{"http":{"method":"GET","requestUri":"/projects/{projectName}"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","required":["project"],"members":{"project":{"type":"structure","required":["projectName","createdDate","updatedDate"],"members":{"arn":{},"projectName":{},"description":{},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"},"placementTemplate":{"shape":"Se"},"tags":{"shape":"Sn"}}}}}},"DisassociateDeviceFromPlacement":{"http":{"method":"DELETE","requestUri":"/projects/{projectName}/placements/{placementName}/devices/{deviceTemplateName}"},"input":{"type":"structure","required":["projectName","placementName","deviceTemplateName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"placementName":{"location":"uri","locationName":"placementName"},"deviceTemplateName":{"location":"uri","locationName":"deviceTemplateName"}}},"output":{"type":"structure","members":{}}},"GetDevicesInPlacement":{"http":{"method":"GET","requestUri":"/projects/{projectName}/placements/{placementName}/devices"},"input":{"type":"structure","required":["projectName","placementName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"placementName":{"location":"uri","locationName":"placementName"}}},"output":{"type":"structure","required":["devices"],"members":{"devices":{"type":"map","key":{},"value":{}}}}},"ListPlacements":{"http":{"method":"GET","requestUri":"/projects/{projectName}/placements"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["placements"],"members":{"placements":{"type":"list","member":{"type":"structure","required":["projectName","placementName","createdDate","updatedDate"],"members":{"projectName":{},"placementName":{},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["projects"],"members":{"projects":{"type":"list","member":{"type":"structure","required":["projectName","createdDate","updatedDate"],"members":{"arn":{},"projectName":{},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"},"tags":{"shape":"Sn"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sn"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdatePlacement":{"http":{"method":"PUT","requestUri":"/projects/{projectName}/placements/{placementName}"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{"location":"uri","locationName":"placementName"},"projectName":{"location":"uri","locationName":"projectName"},"attributes":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"UpdateProject":{"http":{"method":"PUT","requestUri":"/projects/{projectName}"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"description":{},"placementTemplate":{"shape":"Se"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}},"Se":{"type":"structure","members":{"defaultAttributes":{"type":"map","key":{},"value":{}},"deviceTemplates":{"type":"map","key":{},"value":{"type":"structure","members":{"deviceType":{},"callbackOverrides":{"type":"map","key":{},"value":{}}}}}}},"Sn":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListPlacements":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"placements"},"ListProjects":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"projects"}}}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['pi'] = {};
	AWS.PI = Service.defineService('pi', ['2018-02-27']);
	Object.defineProperty(apiLoader.services['pi'], '2018-02-27', {
	  get: function get() {
	    var model = __webpack_require__(622);
	    model.paginators = __webpack_require__(623).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.PI;


/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-02-27","endpointPrefix":"pi","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS PI","serviceFullName":"AWS Performance Insights","serviceId":"PI","signatureVersion":"v4","signingName":"pi","targetPrefix":"PerformanceInsightsv20180227","uid":"pi-2018-02-27"},"operations":{"DescribeDimensionKeys":{"input":{"type":"structure","required":["ServiceType","Identifier","StartTime","EndTime","Metric","GroupBy"],"members":{"ServiceType":{},"Identifier":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Metric":{},"PeriodInSeconds":{"type":"integer"},"GroupBy":{"shape":"S6"},"AdditionalMetrics":{"type":"list","member":{}},"PartitionBy":{"shape":"S6"},"Filter":{"shape":"Sa"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AlignedStartTime":{"type":"timestamp"},"AlignedEndTime":{"type":"timestamp"},"PartitionKeys":{"type":"list","member":{"type":"structure","required":["Dimensions"],"members":{"Dimensions":{"shape":"Sg"}}}},"Keys":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"Sg"},"Total":{"type":"double"},"AdditionalMetrics":{"type":"map","key":{},"value":{"type":"double"}},"Partitions":{"type":"list","member":{"type":"double"}}}}},"NextToken":{}}}},"GetDimensionKeyDetails":{"input":{"type":"structure","required":["ServiceType","Identifier","Group","GroupIdentifier"],"members":{"ServiceType":{},"Identifier":{},"Group":{},"GroupIdentifier":{},"RequestedDimensions":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Dimensions":{"type":"list","member":{"type":"structure","members":{"Value":{},"Dimension":{},"Status":{}}}}}}},"GetResourceMetadata":{"input":{"type":"structure","required":["ServiceType","Identifier"],"members":{"ServiceType":{},"Identifier":{}}},"output":{"type":"structure","members":{"Identifier":{},"Features":{"type":"map","key":{},"value":{"type":"structure","members":{"Status":{}}}}}}},"GetResourceMetrics":{"input":{"type":"structure","required":["ServiceType","Identifier","MetricQueries","StartTime","EndTime"],"members":{"ServiceType":{},"Identifier":{},"MetricQueries":{"type":"list","member":{"type":"structure","required":["Metric"],"members":{"Metric":{},"GroupBy":{"shape":"S6"},"Filter":{"shape":"Sa"}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PeriodInSeconds":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AlignedStartTime":{"type":"timestamp"},"AlignedEndTime":{"type":"timestamp"},"Identifier":{},"MetricList":{"type":"list","member":{"type":"structure","members":{"Key":{"type":"structure","required":["Metric"],"members":{"Metric":{},"Dimensions":{"shape":"Sg"}}},"DataPoints":{"type":"list","member":{"type":"structure","required":["Timestamp","Value"],"members":{"Timestamp":{"type":"timestamp"},"Value":{"type":"double"}}}}}}},"NextToken":{}}}},"ListAvailableResourceDimensions":{"input":{"type":"structure","required":["ServiceType","Identifier","Metrics"],"members":{"ServiceType":{},"Identifier":{},"Metrics":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"MetricDimensions":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Groups":{"type":"list","member":{"type":"structure","members":{"Group":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Identifier":{}}}}}}}}}},"NextToken":{}}}},"ListAvailableResourceMetrics":{"input":{"type":"structure","required":["ServiceType","Identifier","MetricTypes"],"members":{"ServiceType":{},"Identifier":{},"MetricTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Description":{},"Unit":{}}}},"NextToken":{}}}}},"shapes":{"S6":{"type":"structure","required":["Group"],"members":{"Group":{},"Dimensions":{"type":"list","member":{}},"Limit":{"type":"integer"}}},"Sa":{"type":"map","key":{},"value":{}},"Sg":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDimensionKeys":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetResourceMetrics":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAvailableResourceDimensions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAvailableResourceMetrics":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['neptune'] = {};
	AWS.Neptune = Service.defineService('neptune', ['2014-10-31']);
	__webpack_require__(625);
	Object.defineProperty(apiLoader.services['neptune'], '2014-10-31', {
	  get: function get() {
	    var model = __webpack_require__(626);
	    model.paginators = __webpack_require__(627).pagination;
	    model.waiters = __webpack_require__(628).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Neptune;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var rdsutil = __webpack_require__(325);

	/**
	* @api private
	*/
	var crossRegionOperations = ['createDBCluster', 'copyDBClusterSnapshot'];

	AWS.util.update(AWS.Neptune.prototype, {
	  /**
	  * @api private
	  */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (
	      crossRegionOperations.indexOf(request.operation) !== -1 &&
	      this.config.params &&
	      this.config.params.SourceRegion &&
	      request.params &&
	      !request.params.SourceRegion
	    ) {
	      request.params.SourceRegion = this.config.params.SourceRegion;
	    }
	    rdsutil.setupRequestListeners(this, request, crossRegionOperations);
	  },
	});


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon Neptune","serviceFullName":"Amazon Neptune","serviceId":"Neptune","signatureVersion":"v4","signingName":"rds","uid":"neptune-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sa"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Se"}}}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sk"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"So"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"St"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sp"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"CopyTagsToSnapshot":{"type":"boolean"},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sa"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"Sx"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"CreateDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterIdentifier","DBClusterEndpointIdentifier","EndpointType"],"members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"S1a"},"ExcludedMembers":{"shape":"S1a"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterEndpointResult","type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"S1a"},"ExcludedMembers":{"shape":"S1a"},"DBClusterEndpointArn":{}}}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sk"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"So"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S1h"},"VpcSecurityGroupIds":{"shape":"Sw"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"deprecated":true,"type":"boolean"},"Tags":{"shape":"Sa"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnableCloudwatchLogsExports":{"shape":"Sx"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1j"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"St"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S26"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1p"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"SourceIds":{"shape":"S6"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"DeleteDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterEndpointResult","type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"S1a"},"ExcludedMembers":{"shape":"S1a"},"DBClusterEndpointArn":{}}}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"So"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1j"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"DescribeDBClusterEndpoints":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterEndpointsResult","type":"structure","members":{"Marker":{},"DBClusterEndpoints":{"type":"list","member":{"locationName":"DBClusterEndpointList","type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"S1a"},"ExcludedMembers":{"shape":"S1a"},"DBClusterEndpointArn":{}}}}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S2z"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S34"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"So","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"Sz","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S3i"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S3i","locationName":"CharacterSet"}},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"Sx"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S1j","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"St","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2z"},"Marker":{}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1p","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S41"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S41"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2o"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S7"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S5","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S7"},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S7"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2o"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1s","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S2o"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Se","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"S4u"},"ProvisionedIops":{"shape":"S4u"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}}}}}},"wrapper":true}}}},"FailoverDBCluster":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2o"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sa"}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"CloudwatchLogsExportConfiguration":{"shape":"S54"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"DBInstanceParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"ModifyDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"S1a"},"ExcludedMembers":{"shape":"S1a"}}},"output":{"resultWrapper":"ModifyDBClusterEndpointResult","type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"S1a"},"ExcludedMembers":{"shape":"S1a"},"DBClusterEndpointArn":{}}}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S2z"}}},"output":{"shape":"S59","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S37"},"ValuesToRemove":{"shape":"S37"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S34"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S1h"},"VpcSecurityGroupIds":{"shape":"Sw"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"deprecated":true,"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"CloudwatchLogsExportConfiguration":{"shape":"S54"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1j"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2z"}}},"output":{"shape":"S5f","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S26"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1p"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1j"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2z"}}},"output":{"shape":"S59","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2z"}}},"output":{"shape":"S5f","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sp"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"Sx"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"Sx"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}}},"shapes":{"S5":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S6"},"EventCategoriesList":{"shape":"S7"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S6":{"type":"list","member":{"locationName":"SourceId"}},"S7":{"type":"list","member":{"locationName":"EventCategory"}},"Sa":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Se":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"So":{"type":"structure","members":{"AvailabilityZones":{"shape":"Sp"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"AvailabilityZone"}},"St":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"Sw":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"Sx":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"Sp"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S15"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{},"FeatureName":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"},"CopyTagsToSnapshot":{"type":"boolean"},"EnabledCloudwatchLogsExports":{"shape":"Sx"},"DeletionProtection":{"type":"boolean"},"CrossAccountClone":{"type":"boolean"},"AutomaticRestartTime":{"type":"timestamp"}},"wrapper":true},"S15":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1a":{"type":"list","member":{}},"S1h":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S1j":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"shape":"S15"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1p"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"Sx"},"LogTypesToDisable":{"shape":"Sx"}}}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"deprecated":true,"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnabledCloudwatchLogsExports":{"shape":"Sx"},"DeletionProtection":{"type":"boolean"}},"wrapper":true},"S1p":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1s"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S1s":{"type":"structure","members":{"Name":{}},"wrapper":true},"S26":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2o":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2z":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S34":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S37"}}}}},"wrapper":true},"S37":{"type":"list","member":{"locationName":"AttributeValue"}},"S3i":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S41":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2z"}},"wrapper":true},"S4u":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"S54":{"type":"structure","members":{"EnableLogTypes":{"shape":"Sx"},"DisableLogTypes":{"shape":"Sx"}}},"S59":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"S5f":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDBClusterEndpoints":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterEndpoints"},"DescribeDBClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterParameterGroups"},"DescribeDBClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterSnapshots"},"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribePendingMaintenanceActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"PendingMaintenanceActions"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediatailor'] = {};
	AWS.MediaTailor = Service.defineService('mediatailor', ['2018-04-23']);
	Object.defineProperty(apiLoader.services['mediatailor'], '2018-04-23', {
	  get: function get() {
	    var model = __webpack_require__(630);
	    model.paginators = __webpack_require__(631).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaTailor;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-04-23","endpointPrefix":"api.mediatailor","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"MediaTailor","serviceFullName":"AWS MediaTailor","serviceId":"MediaTailor","signatureVersion":"v4","signingName":"mediatailor","uid":"mediatailor-2018-04-23"},"operations":{"ConfigureLogsForPlaybackConfiguration":{"http":{"method":"PUT","requestUri":"/configureLogs/playbackConfiguration","responseCode":200},"input":{"members":{"PercentEnabled":{"type":"integer"},"PlaybackConfigurationName":{}},"required":["PercentEnabled","PlaybackConfigurationName"],"type":"structure"},"output":{"members":{"PercentEnabled":{"type":"integer"},"PlaybackConfigurationName":{}},"type":"structure"}},"CreateChannel":{"http":{"requestUri":"/channel/{channelName}","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"},"FillerSlate":{"shape":"S6"},"Outputs":{"shape":"S7"},"PlaybackMode":{},"Tags":{"locationName":"tags","shape":"Sc"},"Tier":{}},"required":["ChannelName","Outputs","PlaybackMode"],"type":"structure"},"output":{"members":{"Arn":{},"ChannelName":{},"ChannelState":{},"CreationTime":{"shape":"Sg"},"FillerSlate":{"shape":"S6"},"LastModifiedTime":{"shape":"Sg"},"Outputs":{"shape":"Sh"},"PlaybackMode":{},"Tags":{"locationName":"tags","shape":"Sc"},"Tier":{}},"type":"structure"}},"CreateLiveSource":{"http":{"requestUri":"/sourceLocation/{sourceLocationName}/liveSource/{liveSourceName}","responseCode":200},"input":{"members":{"HttpPackageConfigurations":{"shape":"Sk"},"LiveSourceName":{"location":"uri","locationName":"liveSourceName"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"},"Tags":{"locationName":"tags","shape":"Sc"}},"required":["SourceLocationName","LiveSourceName","HttpPackageConfigurations"],"type":"structure"},"output":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"LiveSourceName":{},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"CreatePrefetchSchedule":{"http":{"requestUri":"/prefetchSchedule/{PlaybackConfigurationName}/{Name}","responseCode":200},"input":{"members":{"Consumption":{"shape":"Sp"},"Name":{"location":"uri","locationName":"Name"},"PlaybackConfigurationName":{"location":"uri","locationName":"PlaybackConfigurationName"},"Retrieval":{"shape":"St"},"StreamId":{}},"required":["Name","PlaybackConfigurationName","Retrieval","Consumption"],"type":"structure"},"output":{"members":{"Arn":{},"Consumption":{"shape":"Sp"},"Name":{},"PlaybackConfigurationName":{},"Retrieval":{"shape":"St"},"StreamId":{}},"type":"structure"}},"CreateProgram":{"http":{"requestUri":"/channel/{channelName}/program/{programName}","responseCode":200},"input":{"members":{"AdBreaks":{"shape":"Sw"},"ChannelName":{"location":"uri","locationName":"channelName"},"LiveSourceName":{},"ProgramName":{"location":"uri","locationName":"programName"},"ScheduleConfiguration":{"members":{"Transition":{"members":{"DurationMillis":{"type":"long"},"RelativePosition":{},"RelativeProgram":{},"ScheduledStartTimeMillis":{"type":"long"},"Type":{}},"required":["Type","RelativePosition"],"type":"structure"}},"required":["Transition"],"type":"structure"},"SourceLocationName":{},"VodSourceName":{}},"required":["ChannelName","ProgramName","SourceLocationName","ScheduleConfiguration"],"type":"structure"},"output":{"members":{"AdBreaks":{"shape":"Sw"},"Arn":{},"ChannelName":{},"CreationTime":{"shape":"Sg"},"LiveSourceName":{},"ProgramName":{},"ScheduledStartTime":{"shape":"Sg"},"SourceLocationName":{},"VodSourceName":{}},"type":"structure"}},"CreateSourceLocation":{"http":{"requestUri":"/sourceLocation/{sourceLocationName}","responseCode":200},"input":{"members":{"AccessConfiguration":{"shape":"S16"},"DefaultSegmentDeliveryConfiguration":{"shape":"S19"},"HttpConfiguration":{"shape":"S1a"},"SegmentDeliveryConfigurations":{"shape":"S1b"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"},"Tags":{"locationName":"tags","shape":"Sc"}},"required":["SourceLocationName","HttpConfiguration"],"type":"structure"},"output":{"members":{"AccessConfiguration":{"shape":"S16"},"Arn":{},"CreationTime":{"shape":"Sg"},"DefaultSegmentDeliveryConfiguration":{"shape":"S19"},"HttpConfiguration":{"shape":"S1a"},"LastModifiedTime":{"shape":"Sg"},"SegmentDeliveryConfigurations":{"shape":"S1b"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"CreateVodSource":{"http":{"requestUri":"/sourceLocation/{sourceLocationName}/vodSource/{vodSourceName}","responseCode":200},"input":{"members":{"HttpPackageConfigurations":{"shape":"Sk"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"},"Tags":{"locationName":"tags","shape":"Sc"},"VodSourceName":{"location":"uri","locationName":"vodSourceName"}},"required":["SourceLocationName","VodSourceName","HttpPackageConfigurations"],"type":"structure"},"output":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"},"VodSourceName":{}},"type":"structure"}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channel/{channelName}","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteChannelPolicy":{"http":{"method":"DELETE","requestUri":"/channel/{channelName}/policy","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteLiveSource":{"http":{"method":"DELETE","requestUri":"/sourceLocation/{sourceLocationName}/liveSource/{liveSourceName}","responseCode":200},"input":{"members":{"LiveSourceName":{"location":"uri","locationName":"liveSourceName"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName","LiveSourceName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeletePlaybackConfiguration":{"http":{"method":"DELETE","requestUri":"/playbackConfiguration/{Name}","responseCode":204},"input":{"members":{"Name":{"location":"uri","locationName":"Name"}},"required":["Name"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeletePrefetchSchedule":{"http":{"method":"DELETE","requestUri":"/prefetchSchedule/{PlaybackConfigurationName}/{Name}","responseCode":204},"input":{"members":{"Name":{"location":"uri","locationName":"Name"},"PlaybackConfigurationName":{"location":"uri","locationName":"PlaybackConfigurationName"}},"required":["Name","PlaybackConfigurationName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteProgram":{"http":{"method":"DELETE","requestUri":"/channel/{channelName}/program/{programName}","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"},"ProgramName":{"location":"uri","locationName":"programName"}},"required":["ChannelName","ProgramName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteSourceLocation":{"http":{"method":"DELETE","requestUri":"/sourceLocation/{sourceLocationName}","responseCode":200},"input":{"members":{"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteVodSource":{"http":{"method":"DELETE","requestUri":"/sourceLocation/{sourceLocationName}/vodSource/{vodSourceName}","responseCode":200},"input":{"members":{"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"},"VodSourceName":{"location":"uri","locationName":"vodSourceName"}},"required":["SourceLocationName","VodSourceName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channel/{channelName}","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{"Arn":{},"ChannelName":{},"ChannelState":{},"CreationTime":{"shape":"Sg"},"FillerSlate":{"shape":"S6"},"LastModifiedTime":{"shape":"Sg"},"Outputs":{"shape":"Sh"},"PlaybackMode":{},"Tags":{"locationName":"tags","shape":"Sc"},"Tier":{}},"type":"structure"}},"DescribeLiveSource":{"http":{"method":"GET","requestUri":"/sourceLocation/{sourceLocationName}/liveSource/{liveSourceName}","responseCode":200},"input":{"members":{"LiveSourceName":{"location":"uri","locationName":"liveSourceName"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName","LiveSourceName"],"type":"structure"},"output":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"LiveSourceName":{},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"DescribeProgram":{"http":{"method":"GET","requestUri":"/channel/{channelName}/program/{programName}","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"},"ProgramName":{"location":"uri","locationName":"programName"}},"required":["ChannelName","ProgramName"],"type":"structure"},"output":{"members":{"AdBreaks":{"shape":"Sw"},"Arn":{},"ChannelName":{},"CreationTime":{"shape":"Sg"},"LiveSourceName":{},"ProgramName":{},"ScheduledStartTime":{"shape":"Sg"},"SourceLocationName":{},"VodSourceName":{}},"type":"structure"}},"DescribeSourceLocation":{"http":{"method":"GET","requestUri":"/sourceLocation/{sourceLocationName}","responseCode":200},"input":{"members":{"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName"],"type":"structure"},"output":{"members":{"AccessConfiguration":{"shape":"S16"},"Arn":{},"CreationTime":{"shape":"Sg"},"DefaultSegmentDeliveryConfiguration":{"shape":"S19"},"HttpConfiguration":{"shape":"S1a"},"LastModifiedTime":{"shape":"Sg"},"SegmentDeliveryConfigurations":{"shape":"S1b"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"DescribeVodSource":{"http":{"method":"GET","requestUri":"/sourceLocation/{sourceLocationName}/vodSource/{vodSourceName}","responseCode":200},"input":{"members":{"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"},"VodSourceName":{"location":"uri","locationName":"vodSourceName"}},"required":["SourceLocationName","VodSourceName"],"type":"structure"},"output":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"},"VodSourceName":{}},"type":"structure"}},"GetChannelPolicy":{"http":{"method":"GET","requestUri":"/channel/{channelName}/policy","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{"Policy":{}},"type":"structure"}},"GetChannelSchedule":{"http":{"method":"GET","requestUri":"/channel/{channelName}/schedule","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"},"DurationMinutes":{"location":"querystring","locationName":"durationMinutes"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"ApproximateDurationSeconds":{"type":"long"},"ApproximateStartTime":{"shape":"Sg"},"Arn":{},"ChannelName":{},"LiveSourceName":{},"ProgramName":{},"ScheduleAdBreaks":{"member":{"members":{"ApproximateDurationSeconds":{"type":"long"},"ApproximateStartTime":{"shape":"Sg"},"SourceLocationName":{},"VodSourceName":{}},"type":"structure"},"type":"list"},"ScheduleEntryType":{},"SourceLocationName":{},"VodSourceName":{}},"required":["SourceLocationName","ChannelName","Arn","ProgramName"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"GetPlaybackConfiguration":{"http":{"method":"GET","requestUri":"/playbackConfiguration/{Name}","responseCode":200},"input":{"members":{"Name":{"location":"uri","locationName":"Name"}},"required":["Name"],"type":"structure"},"output":{"members":{"AdDecisionServerUrl":{},"AvailSuppression":{"shape":"S2i"},"Bumper":{"shape":"S2k"},"CdnConfiguration":{"shape":"S2l"},"ConfigurationAliases":{"shape":"S2m"},"DashConfiguration":{"shape":"S2n"},"HlsConfiguration":{"shape":"S2p"},"LivePreRollConfiguration":{"shape":"S2q"},"LogConfiguration":{"shape":"S2r"},"ManifestProcessingRules":{"shape":"S2s"},"Name":{},"PersonalizationThresholdSeconds":{"type":"integer"},"PlaybackConfigurationArn":{},"PlaybackEndpointPrefix":{},"SessionInitializationEndpointPrefix":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sc"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"}},"GetPrefetchSchedule":{"http":{"method":"GET","requestUri":"/prefetchSchedule/{PlaybackConfigurationName}/{Name}","responseCode":200},"input":{"members":{"Name":{"location":"uri","locationName":"Name"},"PlaybackConfigurationName":{"location":"uri","locationName":"PlaybackConfigurationName"}},"required":["Name","PlaybackConfigurationName"],"type":"structure"},"output":{"members":{"Arn":{},"Consumption":{"shape":"Sp"},"Name":{},"PlaybackConfigurationName":{},"Retrieval":{"shape":"St"},"StreamId":{}},"type":"structure"}},"ListAlerts":{"http":{"method":"GET","requestUri":"/alerts","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ResourceArn":{"location":"querystring","locationName":"resourceArn"}},"required":["ResourceArn"],"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"AlertCode":{},"AlertMessage":{},"LastModifiedTime":{"shape":"Sg"},"RelatedResourceArns":{"shape":"S32"},"ResourceArn":{}},"required":["ResourceArn","AlertCode","LastModifiedTime","RelatedResourceArns","AlertMessage"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"Arn":{},"ChannelName":{},"ChannelState":{},"CreationTime":{"shape":"Sg"},"FillerSlate":{"shape":"S6"},"LastModifiedTime":{"shape":"Sg"},"Outputs":{"shape":"Sh"},"PlaybackMode":{},"Tags":{"locationName":"tags","shape":"Sc"},"Tier":{}},"required":["ChannelState","ChannelName","Tier","Outputs","Arn","PlaybackMode"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListLiveSources":{"http":{"method":"GET","requestUri":"/sourceLocation/{sourceLocationName}/liveSources","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName"],"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"LiveSourceName":{},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"required":["SourceLocationName","LiveSourceName","HttpPackageConfigurations","Arn"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListPlaybackConfigurations":{"http":{"method":"GET","requestUri":"/playbackConfigurations","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"AdDecisionServerUrl":{},"AvailSuppression":{"shape":"S2i"},"Bumper":{"shape":"S2k"},"CdnConfiguration":{"shape":"S2l"},"ConfigurationAliases":{"shape":"S2m"},"DashConfiguration":{"shape":"S2n"},"HlsConfiguration":{"shape":"S2p"},"LivePreRollConfiguration":{"shape":"S2q"},"LogConfiguration":{"shape":"S2r"},"ManifestProcessingRules":{"shape":"S2s"},"Name":{},"PersonalizationThresholdSeconds":{"type":"integer"},"PlaybackConfigurationArn":{},"PlaybackEndpointPrefix":{},"SessionInitializationEndpointPrefix":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sc"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListPrefetchSchedules":{"http":{"requestUri":"/prefetchSchedule/{PlaybackConfigurationName}","responseCode":200},"input":{"members":{"MaxResults":{"type":"integer"},"NextToken":{},"PlaybackConfigurationName":{"location":"uri","locationName":"PlaybackConfigurationName"},"StreamId":{}},"required":["PlaybackConfigurationName"],"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"Arn":{},"Consumption":{"shape":"Sp"},"Name":{},"PlaybackConfigurationName":{},"Retrieval":{"shape":"St"},"StreamId":{}},"required":["Retrieval","Consumption","Arn","PlaybackConfigurationName","Name"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListSourceLocations":{"http":{"method":"GET","requestUri":"/sourceLocations","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"AccessConfiguration":{"shape":"S16"},"Arn":{},"CreationTime":{"shape":"Sg"},"DefaultSegmentDeliveryConfiguration":{"shape":"S19"},"HttpConfiguration":{"shape":"S1a"},"LastModifiedTime":{"shape":"Sg"},"SegmentDeliveryConfigurations":{"shape":"S1b"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"required":["SourceLocationName","HttpConfiguration","Arn"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}},"required":["ResourceArn"],"type":"structure"},"output":{"members":{"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"ListVodSources":{"http":{"method":"GET","requestUri":"/sourceLocation/{sourceLocationName}/vodSources","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName"],"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"},"VodSourceName":{}},"required":["VodSourceName","SourceLocationName","HttpPackageConfigurations","Arn"],"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"PutChannelPolicy":{"http":{"method":"PUT","requestUri":"/channel/{channelName}/policy","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"},"Policy":{}},"required":["ChannelName","Policy"],"type":"structure"},"output":{"members":{},"type":"structure"}},"PutPlaybackConfiguration":{"http":{"method":"PUT","requestUri":"/playbackConfiguration","responseCode":200},"input":{"members":{"AdDecisionServerUrl":{},"AvailSuppression":{"shape":"S2i"},"Bumper":{"shape":"S2k"},"CdnConfiguration":{"shape":"S2l"},"ConfigurationAliases":{"key":{},"type":"map","value":{"shape":"Sc"}},"DashConfiguration":{"members":{"MpdLocation":{},"OriginManifestType":{}},"type":"structure"},"LivePreRollConfiguration":{"shape":"S2q"},"ManifestProcessingRules":{"shape":"S2s"},"Name":{},"PersonalizationThresholdSeconds":{"type":"integer"},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sc"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"},"output":{"members":{"AdDecisionServerUrl":{},"AvailSuppression":{"shape":"S2i"},"Bumper":{"shape":"S2k"},"CdnConfiguration":{"shape":"S2l"},"ConfigurationAliases":{"shape":"S2m"},"DashConfiguration":{"shape":"S2n"},"HlsConfiguration":{"shape":"S2p"},"LivePreRollConfiguration":{"shape":"S2q"},"LogConfiguration":{"shape":"S2r"},"ManifestProcessingRules":{"shape":"S2s"},"Name":{},"PersonalizationThresholdSeconds":{"type":"integer"},"PlaybackConfigurationArn":{},"PlaybackEndpointPrefix":{},"SessionInitializationEndpointPrefix":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sc"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"}},"StartChannel":{"http":{"method":"PUT","requestUri":"/channel/{channelName}/start","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"StopChannel":{"http":{"method":"PUT","requestUri":"/channel/{channelName}/stop","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"}},"required":["ChannelName"],"type":"structure"},"output":{"members":{},"type":"structure"}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"locationName":"tags","shape":"Sc"}},"required":["ResourceArn","Tags"],"type":"structure"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","shape":"S32"}},"required":["ResourceArn","TagKeys"],"type":"structure"}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channel/{channelName}","responseCode":200},"input":{"members":{"ChannelName":{"location":"uri","locationName":"channelName"},"FillerSlate":{"shape":"S6"},"Outputs":{"shape":"S7"}},"required":["ChannelName","Outputs"],"type":"structure"},"output":{"members":{"Arn":{},"ChannelName":{},"ChannelState":{},"CreationTime":{"shape":"Sg"},"FillerSlate":{"shape":"S6"},"LastModifiedTime":{"shape":"Sg"},"Outputs":{"shape":"Sh"},"PlaybackMode":{},"Tags":{"locationName":"tags","shape":"Sc"},"Tier":{}},"type":"structure"}},"UpdateLiveSource":{"http":{"method":"PUT","requestUri":"/sourceLocation/{sourceLocationName}/liveSource/{liveSourceName}","responseCode":200},"input":{"members":{"HttpPackageConfigurations":{"shape":"Sk"},"LiveSourceName":{"location":"uri","locationName":"liveSourceName"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName","LiveSourceName","HttpPackageConfigurations"],"type":"structure"},"output":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"LiveSourceName":{},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"UpdateSourceLocation":{"http":{"method":"PUT","requestUri":"/sourceLocation/{sourceLocationName}","responseCode":200},"input":{"members":{"AccessConfiguration":{"shape":"S16"},"DefaultSegmentDeliveryConfiguration":{"shape":"S19"},"HttpConfiguration":{"shape":"S1a"},"SegmentDeliveryConfigurations":{"shape":"S1b"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"}},"required":["SourceLocationName","HttpConfiguration"],"type":"structure"},"output":{"members":{"AccessConfiguration":{"shape":"S16"},"Arn":{},"CreationTime":{"shape":"Sg"},"DefaultSegmentDeliveryConfiguration":{"shape":"S19"},"HttpConfiguration":{"shape":"S1a"},"LastModifiedTime":{"shape":"Sg"},"SegmentDeliveryConfigurations":{"shape":"S1b"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"}},"type":"structure"}},"UpdateVodSource":{"http":{"method":"PUT","requestUri":"/sourceLocation/{sourceLocationName}/vodSource/{vodSourceName}","responseCode":200},"input":{"members":{"HttpPackageConfigurations":{"shape":"Sk"},"SourceLocationName":{"location":"uri","locationName":"sourceLocationName"},"VodSourceName":{"location":"uri","locationName":"vodSourceName"}},"required":["SourceLocationName","VodSourceName","HttpPackageConfigurations"],"type":"structure"},"output":{"members":{"Arn":{},"CreationTime":{"shape":"Sg"},"HttpPackageConfigurations":{"shape":"Sk"},"LastModifiedTime":{"shape":"Sg"},"SourceLocationName":{},"Tags":{"locationName":"tags","shape":"Sc"},"VodSourceName":{}},"type":"structure"}}},"shapes":{"S6":{"members":{"SourceLocationName":{},"VodSourceName":{}},"type":"structure"},"S7":{"member":{"members":{"DashPlaylistSettings":{"shape":"S9"},"HlsPlaylistSettings":{"shape":"Sa"},"ManifestName":{},"SourceGroup":{}},"required":["ManifestName","SourceGroup"],"type":"structure"},"type":"list"},"S9":{"members":{"ManifestWindowSeconds":{"type":"integer"},"MinBufferTimeSeconds":{"type":"integer"},"MinUpdatePeriodSeconds":{"type":"integer"},"SuggestedPresentationDelaySeconds":{"type":"integer"}},"type":"structure"},"Sa":{"members":{"ManifestWindowSeconds":{"type":"integer"}},"type":"structure"},"Sc":{"key":{},"type":"map","value":{}},"Sg":{"timestampFormat":"unixTimestamp","type":"timestamp"},"Sh":{"member":{"members":{"DashPlaylistSettings":{"shape":"S9"},"HlsPlaylistSettings":{"shape":"Sa"},"ManifestName":{},"PlaybackUrl":{},"SourceGroup":{}},"required":["ManifestName","PlaybackUrl","SourceGroup"],"type":"structure"},"type":"list"},"Sk":{"member":{"members":{"Path":{},"SourceGroup":{},"Type":{}},"required":["Path","Type","SourceGroup"],"type":"structure"},"type":"list"},"Sp":{"members":{"AvailMatchingCriteria":{"member":{"members":{"DynamicVariable":{},"Operator":{}},"required":["Operator","DynamicVariable"],"type":"structure"},"type":"list"},"EndTime":{"shape":"Sg"},"StartTime":{"shape":"Sg"}},"required":["EndTime"],"type":"structure"},"St":{"members":{"DynamicVariables":{"shape":"Sc"},"EndTime":{"shape":"Sg"},"StartTime":{"shape":"Sg"}},"required":["EndTime"],"type":"structure"},"Sw":{"member":{"members":{"MessageType":{},"OffsetMillis":{"type":"long"},"Slate":{"shape":"S6"},"SpliceInsertMessage":{"members":{"AvailNum":{"type":"integer"},"AvailsExpected":{"type":"integer"},"SpliceEventId":{"type":"integer"},"UniqueProgramId":{"type":"integer"}},"type":"structure"}},"type":"structure"},"type":"list"},"S16":{"members":{"AccessType":{},"SecretsManagerAccessTokenConfiguration":{"members":{"HeaderName":{},"SecretArn":{},"SecretStringKey":{}},"type":"structure"}},"type":"structure"},"S19":{"members":{"BaseUrl":{}},"type":"structure"},"S1a":{"members":{"BaseUrl":{}},"required":["BaseUrl"],"type":"structure"},"S1b":{"member":{"members":{"BaseUrl":{},"Name":{}},"type":"structure"},"type":"list"},"S2i":{"members":{"Mode":{},"Value":{}},"type":"structure"},"S2k":{"members":{"EndUrl":{},"StartUrl":{}},"type":"structure"},"S2l":{"members":{"AdSegmentUrlPrefix":{},"ContentSegmentUrlPrefix":{}},"type":"structure"},"S2m":{"key":{},"type":"map","value":{"shape":"Sc"}},"S2n":{"members":{"ManifestEndpointPrefix":{},"MpdLocation":{},"OriginManifestType":{}},"type":"structure"},"S2p":{"members":{"ManifestEndpointPrefix":{}},"type":"structure"},"S2q":{"members":{"AdDecisionServerUrl":{},"MaxDurationSeconds":{"type":"integer"}},"type":"structure"},"S2r":{"members":{"PercentEnabled":{"type":"integer"}},"required":["PercentEnabled"],"type":"structure"},"S2s":{"members":{"AdMarkerPassthrough":{"members":{"Enabled":{"type":"boolean"}},"type":"structure"}},"type":"structure"},"S32":{"member":{},"type":"list"}}}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetChannelSchedule":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListAlerts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListLiveSources":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListPlaybackConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListPrefetchSchedules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListSourceLocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"},"ListVodSources":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Items"}}}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['eks'] = {};
	AWS.EKS = Service.defineService('eks', ['2017-11-01']);
	Object.defineProperty(apiLoader.services['eks'], '2017-11-01', {
	  get: function get() {
	    var model = __webpack_require__(633);
	    model.paginators = __webpack_require__(634).pagination;
	    model.waiters = __webpack_require__(635).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EKS;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-01","endpointPrefix":"eks","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon EKS","serviceFullName":"Amazon Elastic Kubernetes Service","serviceId":"EKS","signatureVersion":"v4","signingName":"eks","uid":"eks-2017-11-01"},"operations":{"AssociateEncryptionConfig":{"http":{"requestUri":"/clusters/{name}/encryption-config/associate"},"input":{"type":"structure","required":["clusterName","encryptionConfig"],"members":{"clusterName":{"location":"uri","locationName":"name"},"encryptionConfig":{"shape":"S3"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"AssociateIdentityProviderConfig":{"http":{"requestUri":"/clusters/{name}/identity-provider-configs/associate"},"input":{"type":"structure","required":["clusterName","oidc"],"members":{"clusterName":{"location":"uri","locationName":"name"},"oidc":{"type":"structure","required":["identityProviderConfigName","issuerUrl","clientId"],"members":{"identityProviderConfigName":{},"issuerUrl":{},"clientId":{},"usernameClaim":{},"usernamePrefix":{},"groupsClaim":{},"groupsPrefix":{},"requiredClaims":{"shape":"Sk"}}},"tags":{"shape":"Sn"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"},"tags":{"shape":"Sn"}}}},"CreateAddon":{"http":{"requestUri":"/clusters/{name}/addons"},"input":{"type":"structure","required":["clusterName","addonName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"addonName":{},"addonVersion":{},"serviceAccountRoleArn":{},"resolveConflicts":{},"clientRequestToken":{"idempotencyToken":true},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"addon":{"shape":"Sw"}}}},"CreateCluster":{"http":{"requestUri":"/clusters"},"input":{"type":"structure","required":["name","roleArn","resourcesVpcConfig"],"members":{"name":{},"version":{},"roleArn":{},"resourcesVpcConfig":{"shape":"S13"},"kubernetesNetworkConfig":{"type":"structure","members":{"serviceIpv4Cidr":{},"ipFamily":{}}},"logging":{"shape":"S17"},"clientRequestToken":{"idempotencyToken":true},"tags":{"shape":"Sn"},"encryptionConfig":{"shape":"S3"}}},"output":{"type":"structure","members":{"cluster":{"shape":"S1d"}}}},"CreateFargateProfile":{"http":{"requestUri":"/clusters/{name}/fargate-profiles"},"input":{"type":"structure","required":["fargateProfileName","clusterName","podExecutionRoleArn"],"members":{"fargateProfileName":{},"clusterName":{"location":"uri","locationName":"name"},"podExecutionRoleArn":{},"subnets":{"shape":"S5"},"selectors":{"shape":"S1n"},"clientRequestToken":{"idempotencyToken":true},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"fargateProfile":{"shape":"S1r"}}}},"CreateNodegroup":{"http":{"requestUri":"/clusters/{name}/node-groups"},"input":{"type":"structure","required":["clusterName","nodegroupName","subnets","nodeRole"],"members":{"clusterName":{"location":"uri","locationName":"name"},"nodegroupName":{},"scalingConfig":{"shape":"S1u"},"diskSize":{"type":"integer"},"subnets":{"shape":"S5"},"instanceTypes":{"shape":"S5"},"amiType":{},"remoteAccess":{"shape":"S1z"},"nodeRole":{},"labels":{"shape":"S20"},"taints":{"shape":"S23"},"tags":{"shape":"Sn"},"clientRequestToken":{"idempotencyToken":true},"launchTemplate":{"shape":"S28"},"updateConfig":{"shape":"S29"},"capacityType":{},"version":{},"releaseVersion":{}}},"output":{"type":"structure","members":{"nodegroup":{"shape":"S2e"}}}},"DeleteAddon":{"http":{"method":"DELETE","requestUri":"/clusters/{name}/addons/{addonName}"},"input":{"type":"structure","required":["clusterName","addonName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"addonName":{"location":"uri","locationName":"addonName"},"preserve":{"location":"querystring","locationName":"preserve","type":"boolean"}}},"output":{"type":"structure","members":{"addon":{"shape":"Sw"}}}},"DeleteCluster":{"http":{"method":"DELETE","requestUri":"/clusters/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"cluster":{"shape":"S1d"}}}},"DeleteFargateProfile":{"http":{"method":"DELETE","requestUri":"/clusters/{name}/fargate-profiles/{fargateProfileName}"},"input":{"type":"structure","required":["clusterName","fargateProfileName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"fargateProfileName":{"location":"uri","locationName":"fargateProfileName"}}},"output":{"type":"structure","members":{"fargateProfile":{"shape":"S1r"}}}},"DeleteNodegroup":{"http":{"method":"DELETE","requestUri":"/clusters/{name}/node-groups/{nodegroupName}"},"input":{"type":"structure","required":["clusterName","nodegroupName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"nodegroupName":{"location":"uri","locationName":"nodegroupName"}}},"output":{"type":"structure","members":{"nodegroup":{"shape":"S2e"}}}},"DeregisterCluster":{"http":{"method":"DELETE","requestUri":"/cluster-registrations/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"cluster":{"shape":"S1d"}}}},"DescribeAddon":{"http":{"method":"GET","requestUri":"/clusters/{name}/addons/{addonName}"},"input":{"type":"structure","required":["clusterName","addonName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"addonName":{"location":"uri","locationName":"addonName"}}},"output":{"type":"structure","members":{"addon":{"shape":"Sw"}}}},"DescribeAddonVersions":{"http":{"method":"GET","requestUri":"/addons/supported-versions"},"input":{"type":"structure","members":{"kubernetesVersion":{"location":"querystring","locationName":"kubernetesVersion"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"addonName":{"location":"querystring","locationName":"addonName"}}},"output":{"type":"structure","members":{"addons":{"type":"list","member":{"type":"structure","members":{"addonName":{},"type":{},"addonVersions":{"type":"list","member":{"type":"structure","members":{"addonVersion":{},"architecture":{"shape":"S5"},"compatibilities":{"type":"list","member":{"type":"structure","members":{"clusterVersion":{},"platformVersions":{"shape":"S5"},"defaultVersion":{"type":"boolean"}}}}}}}}}},"nextToken":{}}}},"DescribeCluster":{"http":{"method":"GET","requestUri":"/clusters/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"cluster":{"shape":"S1d"}}}},"DescribeFargateProfile":{"http":{"method":"GET","requestUri":"/clusters/{name}/fargate-profiles/{fargateProfileName}"},"input":{"type":"structure","required":["clusterName","fargateProfileName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"fargateProfileName":{"location":"uri","locationName":"fargateProfileName"}}},"output":{"type":"structure","members":{"fargateProfile":{"shape":"S1r"}}}},"DescribeIdentityProviderConfig":{"http":{"requestUri":"/clusters/{name}/identity-provider-configs/describe"},"input":{"type":"structure","required":["clusterName","identityProviderConfig"],"members":{"clusterName":{"location":"uri","locationName":"name"},"identityProviderConfig":{"shape":"S3d"}}},"output":{"type":"structure","members":{"identityProviderConfig":{"type":"structure","members":{"oidc":{"type":"structure","members":{"identityProviderConfigName":{},"identityProviderConfigArn":{},"clusterName":{},"issuerUrl":{},"clientId":{},"usernameClaim":{},"usernamePrefix":{},"groupsClaim":{},"groupsPrefix":{},"requiredClaims":{"shape":"Sk"},"tags":{"shape":"Sn"},"status":{}}}}}}}},"DescribeNodegroup":{"http":{"method":"GET","requestUri":"/clusters/{name}/node-groups/{nodegroupName}"},"input":{"type":"structure","required":["clusterName","nodegroupName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"nodegroupName":{"location":"uri","locationName":"nodegroupName"}}},"output":{"type":"structure","members":{"nodegroup":{"shape":"S2e"}}}},"DescribeUpdate":{"http":{"method":"GET","requestUri":"/clusters/{name}/updates/{updateId}"},"input":{"type":"structure","required":["name","updateId"],"members":{"name":{"location":"uri","locationName":"name"},"updateId":{"location":"uri","locationName":"updateId"},"nodegroupName":{"location":"querystring","locationName":"nodegroupName"},"addonName":{"location":"querystring","locationName":"addonName"}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"DisassociateIdentityProviderConfig":{"http":{"requestUri":"/clusters/{name}/identity-provider-configs/disassociate"},"input":{"type":"structure","required":["clusterName","identityProviderConfig"],"members":{"clusterName":{"location":"uri","locationName":"name"},"identityProviderConfig":{"shape":"S3d"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"ListAddons":{"http":{"method":"GET","requestUri":"/clusters/{name}/addons"},"input":{"type":"structure","required":["clusterName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"addons":{"shape":"S5"},"nextToken":{}}}},"ListClusters":{"http":{"method":"GET","requestUri":"/clusters"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"include":{"location":"querystring","locationName":"include","type":"list","member":{}}}},"output":{"type":"structure","members":{"clusters":{"shape":"S5"},"nextToken":{}}}},"ListFargateProfiles":{"http":{"method":"GET","requestUri":"/clusters/{name}/fargate-profiles"},"input":{"type":"structure","required":["clusterName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"fargateProfileNames":{"shape":"S5"},"nextToken":{}}}},"ListIdentityProviderConfigs":{"http":{"method":"GET","requestUri":"/clusters/{name}/identity-provider-configs"},"input":{"type":"structure","required":["clusterName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"identityProviderConfigs":{"type":"list","member":{"shape":"S3d"}},"nextToken":{}}}},"ListNodegroups":{"http":{"method":"GET","requestUri":"/clusters/{name}/node-groups"},"input":{"type":"structure","required":["clusterName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nodegroups":{"shape":"S5"},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sn"}}}},"ListUpdates":{"http":{"method":"GET","requestUri":"/clusters/{name}/updates"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nodegroupName":{"location":"querystring","locationName":"nodegroupName"},"addonName":{"location":"querystring","locationName":"addonName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"updateIds":{"shape":"S5"},"nextToken":{}}}},"RegisterCluster":{"http":{"requestUri":"/cluster-registrations"},"input":{"type":"structure","required":["name","connectorConfig"],"members":{"name":{},"connectorConfig":{"type":"structure","required":["roleArn","provider"],"members":{"roleArn":{},"provider":{}}},"clientRequestToken":{"idempotencyToken":true},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"cluster":{"shape":"S1d"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAddon":{"http":{"requestUri":"/clusters/{name}/addons/{addonName}/update"},"input":{"type":"structure","required":["clusterName","addonName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"addonName":{"location":"uri","locationName":"addonName"},"addonVersion":{},"serviceAccountRoleArn":{},"resolveConflicts":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"UpdateClusterConfig":{"http":{"requestUri":"/clusters/{name}/update-config"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"resourcesVpcConfig":{"shape":"S13"},"logging":{"shape":"S17"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"UpdateClusterVersion":{"http":{"requestUri":"/clusters/{name}/updates"},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"UpdateNodegroupConfig":{"http":{"requestUri":"/clusters/{name}/node-groups/{nodegroupName}/update-config"},"input":{"type":"structure","required":["clusterName","nodegroupName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"nodegroupName":{"location":"uri","locationName":"nodegroupName"},"labels":{"type":"structure","members":{"addOrUpdateLabels":{"shape":"S20"},"removeLabels":{"type":"list","member":{}}}},"taints":{"type":"structure","members":{"addOrUpdateTaints":{"shape":"S23"},"removeTaints":{"shape":"S23"}}},"scalingConfig":{"shape":"S1u"},"updateConfig":{"shape":"S29"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}},"UpdateNodegroupVersion":{"http":{"requestUri":"/clusters/{name}/node-groups/{nodegroupName}/update-version"},"input":{"type":"structure","required":["clusterName","nodegroupName"],"members":{"clusterName":{"location":"uri","locationName":"name"},"nodegroupName":{"location":"uri","locationName":"nodegroupName"},"version":{},"releaseVersion":{},"launchTemplate":{"shape":"S28"},"force":{"type":"boolean"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"S8"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"resources":{"shape":"S5"},"provider":{"type":"structure","members":{"keyArn":{}}}}}},"S5":{"type":"list","member":{}},"S8":{"type":"structure","members":{"id":{},"status":{},"type":{},"params":{"type":"list","member":{"type":"structure","members":{"type":{},"value":{}}}},"createdAt":{"type":"timestamp"},"errors":{"type":"list","member":{"type":"structure","members":{"errorCode":{},"errorMessage":{},"resourceIds":{"shape":"S5"}}}}}},"Sk":{"type":"map","key":{},"value":{}},"Sn":{"type":"map","key":{},"value":{}},"Sw":{"type":"structure","members":{"addonName":{},"clusterName":{},"status":{},"addonVersion":{},"health":{"type":"structure","members":{"issues":{"type":"list","member":{"type":"structure","members":{"code":{},"message":{},"resourceIds":{"shape":"S5"}}}}}},"addonArn":{},"createdAt":{"type":"timestamp"},"modifiedAt":{"type":"timestamp"},"serviceAccountRoleArn":{},"tags":{"shape":"Sn"}}},"S13":{"type":"structure","members":{"subnetIds":{"shape":"S5"},"securityGroupIds":{"shape":"S5"},"endpointPublicAccess":{"type":"boolean"},"endpointPrivateAccess":{"type":"boolean"},"publicAccessCidrs":{"shape":"S5"}}},"S17":{"type":"structure","members":{"clusterLogging":{"type":"list","member":{"type":"structure","members":{"types":{"type":"list","member":{}},"enabled":{"type":"boolean"}}}}}},"S1d":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"version":{},"endpoint":{},"roleArn":{},"resourcesVpcConfig":{"type":"structure","members":{"subnetIds":{"shape":"S5"},"securityGroupIds":{"shape":"S5"},"clusterSecurityGroupId":{},"vpcId":{},"endpointPublicAccess":{"type":"boolean"},"endpointPrivateAccess":{"type":"boolean"},"publicAccessCidrs":{"shape":"S5"}}},"kubernetesNetworkConfig":{"type":"structure","members":{"serviceIpv4Cidr":{},"serviceIpv6Cidr":{},"ipFamily":{}}},"logging":{"shape":"S17"},"identity":{"type":"structure","members":{"oidc":{"type":"structure","members":{"issuer":{}}}}},"status":{},"certificateAuthority":{"type":"structure","members":{"data":{}}},"clientRequestToken":{},"platformVersion":{},"tags":{"shape":"Sn"},"encryptionConfig":{"shape":"S3"},"connectorConfig":{"type":"structure","members":{"activationId":{},"activationCode":{},"activationExpiry":{"type":"timestamp"},"provider":{},"roleArn":{}}}}},"S1n":{"type":"list","member":{"type":"structure","members":{"namespace":{},"labels":{"type":"map","key":{},"value":{}}}}},"S1r":{"type":"structure","members":{"fargateProfileName":{},"fargateProfileArn":{},"clusterName":{},"createdAt":{"type":"timestamp"},"podExecutionRoleArn":{},"subnets":{"shape":"S5"},"selectors":{"shape":"S1n"},"status":{},"tags":{"shape":"Sn"}}},"S1u":{"type":"structure","members":{"minSize":{"type":"integer"},"maxSize":{"type":"integer"},"desiredSize":{"type":"integer"}}},"S1z":{"type":"structure","members":{"ec2SshKey":{},"sourceSecurityGroups":{"shape":"S5"}}},"S20":{"type":"map","key":{},"value":{}},"S23":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{},"effect":{}}}},"S28":{"type":"structure","members":{"name":{},"version":{},"id":{}}},"S29":{"type":"structure","members":{"maxUnavailable":{"type":"integer"},"maxUnavailablePercentage":{"type":"integer"}}},"S2e":{"type":"structure","members":{"nodegroupName":{},"nodegroupArn":{},"clusterName":{},"version":{},"releaseVersion":{},"createdAt":{"type":"timestamp"},"modifiedAt":{"type":"timestamp"},"status":{},"capacityType":{},"scalingConfig":{"shape":"S1u"},"instanceTypes":{"shape":"S5"},"subnets":{"shape":"S5"},"remoteAccess":{"shape":"S1z"},"amiType":{},"nodeRole":{},"labels":{"shape":"S20"},"taints":{"shape":"S23"},"resources":{"type":"structure","members":{"autoScalingGroups":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"remoteAccessSecurityGroup":{}}},"diskSize":{"type":"integer"},"health":{"type":"structure","members":{"issues":{"type":"list","member":{"type":"structure","members":{"code":{},"message":{},"resourceIds":{"shape":"S5"}}}}}},"updateConfig":{"shape":"S29"},"launchTemplate":{"shape":"S28"},"tags":{"shape":"Sn"}}},"S3d":{"type":"structure","required":["type","name"],"members":{"type":{},"name":{}}}}}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAddonVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"addons"},"ListAddons":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"addons"},"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusters"},"ListFargateProfiles":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"fargateProfileNames"},"ListIdentityProviderConfigs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"identityProviderConfigs"},"ListNodegroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"nodegroups"},"ListUpdates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"updateIds"}}}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ClusterActive":{"delay":30,"operation":"DescribeCluster","maxAttempts":40,"acceptors":[{"expected":"DELETING","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"FAILED","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"ACTIVE","matcher":"path","state":"success","argument":"cluster.status"}]},"ClusterDeleted":{"delay":30,"operation":"DescribeCluster","maxAttempts":40,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"CREATING","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"PENDING","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]},"NodegroupActive":{"delay":30,"operation":"DescribeNodegroup","maxAttempts":80,"acceptors":[{"expected":"CREATE_FAILED","matcher":"path","state":"failure","argument":"nodegroup.status"},{"expected":"ACTIVE","matcher":"path","state":"success","argument":"nodegroup.status"}]},"NodegroupDeleted":{"delay":30,"operation":"DescribeNodegroup","maxAttempts":40,"acceptors":[{"expected":"DELETE_FAILED","matcher":"path","state":"failure","argument":"nodegroup.status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]},"AddonActive":{"delay":10,"operation":"DescribeAddon","maxAttempts":60,"acceptors":[{"expected":"CREATE_FAILED","matcher":"path","state":"failure","argument":"addon.status"},{"expected":"DEGRADED","matcher":"path","state":"failure","argument":"addon.status"},{"expected":"ACTIVE","matcher":"path","state":"success","argument":"addon.status"}]},"AddonDeleted":{"delay":10,"operation":"DescribeAddon","maxAttempts":60,"acceptors":[{"expected":"DELETE_FAILED","matcher":"path","state":"failure","argument":"addon.status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]},"FargateProfileActive":{"delay":10,"operation":"DescribeFargateProfile","maxAttempts":60,"acceptors":[{"expected":"CREATE_FAILED","matcher":"path","state":"failure","argument":"fargateProfile.status"},{"expected":"ACTIVE","matcher":"path","state":"success","argument":"fargateProfile.status"}]},"FargateProfileDeleted":{"delay":30,"operation":"DescribeFargateProfile","maxAttempts":60,"acceptors":[{"expected":"DELETE_FAILED","matcher":"path","state":"failure","argument":"fargateProfile.status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['macie'] = {};
	AWS.Macie = Service.defineService('macie', ['2017-12-19']);
	Object.defineProperty(apiLoader.services['macie'], '2017-12-19', {
	  get: function get() {
	    var model = __webpack_require__(637);
	    model.paginators = __webpack_require__(638).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Macie;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-12-19","endpointPrefix":"macie","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Macie","serviceId":"Macie","signatureVersion":"v4","targetPrefix":"MacieService","uid":"macie-2017-12-19"},"operations":{"AssociateMemberAccount":{"input":{"type":"structure","required":["memberAccountId"],"members":{"memberAccountId":{}}}},"AssociateS3Resources":{"input":{"type":"structure","required":["s3Resources"],"members":{"memberAccountId":{},"s3Resources":{"shape":"S4"}}},"output":{"type":"structure","members":{"failedS3Resources":{"shape":"Sc"}}}},"DisassociateMemberAccount":{"input":{"type":"structure","required":["memberAccountId"],"members":{"memberAccountId":{}}}},"DisassociateS3Resources":{"input":{"type":"structure","required":["associatedS3Resources"],"members":{"memberAccountId":{},"associatedS3Resources":{"type":"list","member":{"shape":"Se"}}}},"output":{"type":"structure","members":{"failedS3Resources":{"shape":"Sc"}}}},"ListMemberAccounts":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"memberAccounts":{"type":"list","member":{"type":"structure","members":{"accountId":{}}}},"nextToken":{}}}},"ListS3Resources":{"input":{"type":"structure","members":{"memberAccountId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"s3Resources":{"shape":"S4"},"nextToken":{}}}},"UpdateS3Resources":{"input":{"type":"structure","required":["s3ResourcesUpdate"],"members":{"memberAccountId":{},"s3ResourcesUpdate":{"type":"list","member":{"type":"structure","required":["bucketName","classificationTypeUpdate"],"members":{"bucketName":{},"prefix":{},"classificationTypeUpdate":{"type":"structure","members":{"oneTime":{},"continuous":{}}}}}}}},"output":{"type":"structure","members":{"failedS3Resources":{"shape":"Sc"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["bucketName","classificationType"],"members":{"bucketName":{},"prefix":{},"classificationType":{"type":"structure","required":["oneTime","continuous"],"members":{"oneTime":{},"continuous":{}}}}}},"Sc":{"type":"list","member":{"type":"structure","members":{"failedItem":{"shape":"Se"},"errorCode":{},"errorMessage":{}}}},"Se":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"prefix":{}}}}}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListMemberAccounts":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListS3Resources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['dlm'] = {};
	AWS.DLM = Service.defineService('dlm', ['2018-01-12']);
	Object.defineProperty(apiLoader.services['dlm'], '2018-01-12', {
	  get: function get() {
	    var model = __webpack_require__(640);
	    model.paginators = __webpack_require__(641).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DLM;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-01-12","endpointPrefix":"dlm","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon DLM","serviceFullName":"Amazon Data Lifecycle Manager","serviceId":"DLM","signatureVersion":"v4","signingName":"dlm","uid":"dlm-2018-01-12"},"operations":{"CreateLifecyclePolicy":{"http":{"requestUri":"/policies"},"input":{"type":"structure","required":["ExecutionRoleArn","Description","State","PolicyDetails"],"members":{"ExecutionRoleArn":{},"Description":{},"State":{},"PolicyDetails":{"shape":"S5"},"Tags":{"shape":"S1q"}}},"output":{"type":"structure","members":{"PolicyId":{}}}},"DeleteLifecyclePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyId}/"},"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{"location":"uri","locationName":"policyId"}}},"output":{"type":"structure","members":{}}},"GetLifecyclePolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"PolicyIds":{"location":"querystring","locationName":"policyIds","type":"list","member":{}},"State":{"location":"querystring","locationName":"state"},"ResourceTypes":{"shape":"S7","location":"querystring","locationName":"resourceTypes"},"TargetTags":{"location":"querystring","locationName":"targetTags","type":"list","member":{}},"TagsToAdd":{"location":"querystring","locationName":"tagsToAdd","type":"list","member":{}}}},"output":{"type":"structure","members":{"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"Description":{},"State":{},"Tags":{"shape":"S1q"},"PolicyType":{}}}}}}},"GetLifecyclePolicy":{"http":{"method":"GET","requestUri":"/policies/{policyId}/"},"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{"location":"uri","locationName":"policyId"}}},"output":{"type":"structure","members":{"Policy":{"type":"structure","members":{"PolicyId":{},"Description":{},"State":{},"StatusMessage":{},"ExecutionRoleArn":{},"DateCreated":{"shape":"S2a"},"DateModified":{"shape":"S2a"},"PolicyDetails":{"shape":"S5"},"Tags":{"shape":"S1q"},"PolicyArn":{}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1q"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"S1q"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateLifecyclePolicy":{"http":{"method":"PATCH","requestUri":"/policies/{policyId}"},"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{"location":"uri","locationName":"policyId"},"ExecutionRoleArn":{},"State":{},"Description":{},"PolicyDetails":{"shape":"S5"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","members":{"PolicyType":{},"ResourceTypes":{"shape":"S7"},"ResourceLocations":{"type":"list","member":{}},"TargetTags":{"type":"list","member":{"shape":"Sc"}},"Schedules":{"type":"list","member":{"type":"structure","members":{"Name":{},"CopyTags":{"type":"boolean"},"TagsToAdd":{"type":"list","member":{"shape":"Sc"}},"VariableTags":{"type":"list","member":{"shape":"Sc"}},"CreateRule":{"type":"structure","members":{"Location":{},"Interval":{"type":"integer"},"IntervalUnit":{},"Times":{"type":"list","member":{}},"CronExpression":{}}},"RetainRule":{"type":"structure","members":{"Count":{"type":"integer"},"Interval":{"type":"integer"},"IntervalUnit":{}}},"FastRestoreRule":{"type":"structure","required":["AvailabilityZones"],"members":{"Count":{"type":"integer"},"Interval":{"type":"integer"},"IntervalUnit":{},"AvailabilityZones":{"type":"list","member":{}}}},"CrossRegionCopyRules":{"type":"list","member":{"type":"structure","required":["Encrypted"],"members":{"TargetRegion":{},"Target":{},"Encrypted":{"type":"boolean"},"CmkArn":{},"CopyTags":{"type":"boolean"},"RetainRule":{"shape":"S14"},"DeprecateRule":{"type":"structure","members":{"Interval":{"type":"integer"},"IntervalUnit":{}}}}}},"ShareRules":{"type":"list","member":{"type":"structure","required":["TargetAccounts"],"members":{"TargetAccounts":{"type":"list","member":{}},"UnshareInterval":{"type":"integer"},"UnshareIntervalUnit":{}}}},"DeprecateRule":{"type":"structure","members":{"Count":{"type":"integer"},"Interval":{"type":"integer"},"IntervalUnit":{}}}}}},"Parameters":{"type":"structure","members":{"ExcludeBootVolume":{"type":"boolean"},"NoReboot":{"type":"boolean"}}},"EventSource":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"structure","required":["EventType","SnapshotOwner","DescriptionRegex"],"members":{"EventType":{},"SnapshotOwner":{"type":"list","member":{}},"DescriptionRegex":{}}}}},"Actions":{"type":"list","member":{"type":"structure","required":["Name","CrossRegionCopy"],"members":{"Name":{},"CrossRegionCopy":{"type":"list","member":{"type":"structure","required":["Target","EncryptionConfiguration"],"members":{"Target":{},"EncryptionConfiguration":{"type":"structure","required":["Encrypted"],"members":{"Encrypted":{"type":"boolean"},"CmkArn":{}}},"RetainRule":{"shape":"S14"}}}}}}}}},"S7":{"type":"list","member":{}},"Sc":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S14":{"type":"structure","members":{"Interval":{"type":"integer"},"IntervalUnit":{}}},"S1q":{"type":"map","key":{},"value":{}},"S2a":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['signer'] = {};
	AWS.Signer = Service.defineService('signer', ['2017-08-25']);
	Object.defineProperty(apiLoader.services['signer'], '2017-08-25', {
	  get: function get() {
	    var model = __webpack_require__(643);
	    model.paginators = __webpack_require__(644).pagination;
	    model.waiters = __webpack_require__(645).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Signer;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-08-25","endpointPrefix":"signer","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"signer","serviceFullName":"AWS Signer","serviceId":"signer","signatureVersion":"v4","signingName":"signer","uid":"signer-2017-08-25"},"operations":{"AddProfilePermission":{"http":{"requestUri":"/signing-profiles/{profileName}/permissions"},"input":{"type":"structure","required":["action","principal","statementId","profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"profileVersion":{},"action":{},"principal":{},"revisionId":{},"statementId":{}}},"output":{"type":"structure","members":{"revisionId":{}}}},"CancelSigningProfile":{"http":{"method":"DELETE","requestUri":"/signing-profiles/{profileName}"},"input":{"type":"structure","required":["profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"}}}},"DescribeSigningJob":{"http":{"method":"GET","requestUri":"/signing-jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"jobId":{},"source":{"shape":"Sa"},"signingMaterial":{"shape":"Sf"},"platformId":{},"platformDisplayName":{},"profileName":{},"profileVersion":{},"overrides":{"shape":"Sj"},"signingParameters":{"shape":"So"},"createdAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"signatureExpiresAt":{"type":"timestamp"},"requestedBy":{},"status":{},"statusReason":{},"revocationRecord":{"type":"structure","members":{"reason":{},"revokedAt":{"type":"timestamp"},"revokedBy":{}}},"signedObject":{"shape":"Sw"},"jobOwner":{},"jobInvoker":{}}}},"GetSigningPlatform":{"http":{"method":"GET","requestUri":"/signing-platforms/{platformId}"},"input":{"type":"structure","required":["platformId"],"members":{"platformId":{"location":"uri","locationName":"platformId"}}},"output":{"type":"structure","members":{"platformId":{},"displayName":{},"partner":{},"target":{},"category":{},"signingConfiguration":{"shape":"S12"},"signingImageFormat":{"shape":"S17"},"maxSizeInMB":{"type":"integer"},"revocationSupported":{"type":"boolean"}}}},"GetSigningProfile":{"http":{"method":"GET","requestUri":"/signing-profiles/{profileName}"},"input":{"type":"structure","required":["profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"profileOwner":{"location":"querystring","locationName":"profileOwner"}}},"output":{"type":"structure","members":{"profileName":{},"profileVersion":{},"profileVersionArn":{},"revocationRecord":{"type":"structure","members":{"revocationEffectiveFrom":{"type":"timestamp"},"revokedAt":{"type":"timestamp"},"revokedBy":{}}},"signingMaterial":{"shape":"Sf"},"platformId":{},"platformDisplayName":{},"signatureValidityPeriod":{"shape":"S1f"},"overrides":{"shape":"Sj"},"signingParameters":{"shape":"So"},"status":{},"statusReason":{},"arn":{},"tags":{"shape":"S1k"}}}},"ListProfilePermissions":{"http":{"method":"GET","requestUri":"/signing-profiles/{profileName}/permissions"},"input":{"type":"structure","required":["profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"revisionId":{},"policySizeBytes":{"type":"integer"},"permissions":{"type":"list","member":{"type":"structure","members":{"action":{},"principal":{},"statementId":{},"profileVersion":{}}}},"nextToken":{}}}},"ListSigningJobs":{"http":{"method":"GET","requestUri":"/signing-jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"platformId":{"location":"querystring","locationName":"platformId"},"requestedBy":{"location":"querystring","locationName":"requestedBy"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"isRevoked":{"location":"querystring","locationName":"isRevoked","type":"boolean"},"signatureExpiresBefore":{"location":"querystring","locationName":"signatureExpiresBefore","type":"timestamp"},"signatureExpiresAfter":{"location":"querystring","locationName":"signatureExpiresAfter","type":"timestamp"},"jobInvoker":{"location":"querystring","locationName":"jobInvoker"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobId":{},"source":{"shape":"Sa"},"signedObject":{"shape":"Sw"},"signingMaterial":{"shape":"Sf"},"createdAt":{"type":"timestamp"},"status":{},"isRevoked":{"type":"boolean"},"profileName":{},"profileVersion":{},"platformId":{},"platformDisplayName":{},"signatureExpiresAt":{"type":"timestamp"},"jobOwner":{},"jobInvoker":{}}}},"nextToken":{}}}},"ListSigningPlatforms":{"http":{"method":"GET","requestUri":"/signing-platforms"},"input":{"type":"structure","members":{"category":{"location":"querystring","locationName":"category"},"partner":{"location":"querystring","locationName":"partner"},"target":{"location":"querystring","locationName":"target"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"platforms":{"type":"list","member":{"type":"structure","members":{"platformId":{},"displayName":{},"partner":{},"target":{},"category":{},"signingConfiguration":{"shape":"S12"},"signingImageFormat":{"shape":"S17"},"maxSizeInMB":{"type":"integer"},"revocationSupported":{"type":"boolean"}}}},"nextToken":{}}}},"ListSigningProfiles":{"http":{"method":"GET","requestUri":"/signing-profiles"},"input":{"type":"structure","members":{"includeCanceled":{"location":"querystring","locationName":"includeCanceled","type":"boolean"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"platformId":{"location":"querystring","locationName":"platformId"},"statuses":{"location":"querystring","locationName":"statuses","type":"list","member":{}}}},"output":{"type":"structure","members":{"profiles":{"type":"list","member":{"type":"structure","members":{"profileName":{},"profileVersion":{},"profileVersionArn":{},"signingMaterial":{"shape":"Sf"},"signatureValidityPeriod":{"shape":"S1f"},"platformId":{},"platformDisplayName":{},"signingParameters":{"shape":"So"},"status":{},"arn":{},"tags":{"shape":"S1k"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1k"}}}},"PutSigningProfile":{"http":{"method":"PUT","requestUri":"/signing-profiles/{profileName}"},"input":{"type":"structure","required":["profileName","platformId"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"signingMaterial":{"shape":"Sf"},"signatureValidityPeriod":{"shape":"S1f"},"platformId":{},"overrides":{"shape":"Sj"},"signingParameters":{"shape":"So"},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{"arn":{},"profileVersion":{},"profileVersionArn":{}}}},"RemoveProfilePermission":{"http":{"method":"DELETE","requestUri":"/signing-profiles/{profileName}/permissions/{statementId}"},"input":{"type":"structure","required":["revisionId","profileName","statementId"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"revisionId":{"location":"querystring","locationName":"revisionId"},"statementId":{"location":"uri","locationName":"statementId"}}},"output":{"type":"structure","members":{"revisionId":{}}}},"RevokeSignature":{"http":{"method":"PUT","requestUri":"/signing-jobs/{jobId}/revoke"},"input":{"type":"structure","required":["reason","jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"jobOwner":{},"reason":{}}}},"RevokeSigningProfile":{"http":{"method":"PUT","requestUri":"/signing-profiles/{profileName}/revoke"},"input":{"type":"structure","required":["profileVersion","reason","effectiveTime","profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"profileVersion":{},"reason":{},"effectiveTime":{"type":"timestamp"}}}},"StartSigningJob":{"http":{"requestUri":"/signing-jobs"},"input":{"type":"structure","required":["source","destination","profileName","clientRequestToken"],"members":{"source":{"shape":"Sa"},"destination":{"type":"structure","members":{"s3":{"type":"structure","members":{"bucketName":{},"prefix":{}}}}},"profileName":{},"clientRequestToken":{"idempotencyToken":true},"profileOwner":{}}},"output":{"type":"structure","members":{"jobId":{},"jobOwner":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","members":{"s3":{"type":"structure","required":["bucketName","key","version"],"members":{"bucketName":{},"key":{},"version":{}}}}},"Sf":{"type":"structure","required":["certificateArn"],"members":{"certificateArn":{}}},"Sj":{"type":"structure","members":{"signingConfiguration":{"type":"structure","members":{"encryptionAlgorithm":{},"hashAlgorithm":{}}},"signingImageFormat":{}}},"So":{"type":"map","key":{},"value":{}},"Sw":{"type":"structure","members":{"s3":{"type":"structure","members":{"bucketName":{},"key":{}}}}},"S12":{"type":"structure","required":["encryptionAlgorithmOptions","hashAlgorithmOptions"],"members":{"encryptionAlgorithmOptions":{"type":"structure","required":["allowedValues","defaultValue"],"members":{"allowedValues":{"type":"list","member":{}},"defaultValue":{}}},"hashAlgorithmOptions":{"type":"structure","required":["allowedValues","defaultValue"],"members":{"allowedValues":{"type":"list","member":{}},"defaultValue":{}}}}},"S17":{"type":"structure","required":["supportedFormats","defaultFormat"],"members":{"supportedFormats":{"type":"list","member":{}},"defaultFormat":{}}},"S1f":{"type":"structure","members":{"value":{"type":"integer"},"type":{}}},"S1k":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListSigningJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSigningPlatforms":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSigningProfiles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"SuccessfulSigningJob":{"delay":20,"operation":"DescribeSigningJob","maxAttempts":25,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"failure"}]}}}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['chime'] = {};
	AWS.Chime = Service.defineService('chime', ['2018-05-01']);
	Object.defineProperty(apiLoader.services['chime'], '2018-05-01', {
	  get: function get() {
	    var model = __webpack_require__(647);
	    model.paginators = __webpack_require__(648).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Chime;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-01","endpointPrefix":"chime","protocol":"rest-json","serviceFullName":"Amazon Chime","serviceId":"Chime","signatureVersion":"v4","uid":"chime-2018-05-01"},"operations":{"AssociatePhoneNumberWithUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=associate-phone-number","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId","E164PhoneNumber"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"},"E164PhoneNumber":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"AssociatePhoneNumbersWithVoiceConnector":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}?operation=associate-phone-numbers","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","E164PhoneNumbers"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"E164PhoneNumbers":{"shape":"S7"},"ForceAssociate":{"type":"boolean"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"Sa"}}}},"AssociatePhoneNumbersWithVoiceConnectorGroup":{"http":{"requestUri":"/voice-connector-groups/{voiceConnectorGroupId}?operation=associate-phone-numbers","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorGroupId","E164PhoneNumbers"],"members":{"VoiceConnectorGroupId":{"location":"uri","locationName":"voiceConnectorGroupId"},"E164PhoneNumbers":{"shape":"S7"},"ForceAssociate":{"type":"boolean"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"Sa"}}}},"AssociateSigninDelegateGroupsWithAccount":{"http":{"requestUri":"/accounts/{accountId}?operation=associate-signin-delegate-groups","responseCode":200},"input":{"type":"structure","required":["AccountId","SigninDelegateGroups"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"SigninDelegateGroups":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"BatchCreateAttendee":{"http":{"requestUri":"/meetings/{meetingId}/attendees?operation=batch-create","responseCode":201},"input":{"type":"structure","required":["MeetingId","Attendees"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"Attendees":{"type":"list","member":{"shape":"Sm"}}}},"output":{"type":"structure","members":{"Attendees":{"shape":"St"},"Errors":{"shape":"Sw"}}}},"BatchCreateChannelMembership":{"http":{"requestUri":"/channels/{channelArn}/memberships?operation=batch-create","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArns"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Type":{},"MemberArns":{"type":"list","member":{}},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"BatchChannelMemberships":{"type":"structure","members":{"InvitedBy":{"shape":"S14"},"Type":{},"Members":{"type":"list","member":{"shape":"S14"}},"ChannelArn":{}}},"Errors":{"type":"list","member":{"type":"structure","members":{"MemberArn":{},"ErrorCode":{},"ErrorMessage":{}}}}}},"endpoint":{"hostPrefix":"messaging-"}},"BatchCreateRoomMembership":{"http":{"requestUri":"/accounts/{accountId}/rooms/{roomId}/memberships?operation=batch-create","responseCode":201},"input":{"type":"structure","required":["AccountId","RoomId","MembershipItemList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"MembershipItemList":{"type":"list","member":{"type":"structure","members":{"MemberId":{},"Role":{}}}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"MemberId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchDeletePhoneNumber":{"http":{"requestUri":"/phone-numbers?operation=batch-delete","responseCode":200},"input":{"type":"structure","required":["PhoneNumberIds"],"members":{"PhoneNumberIds":{"shape":"S1h"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"Sa"}}}},"BatchSuspendUser":{"http":{"requestUri":"/accounts/{accountId}/users?operation=suspend","responseCode":200},"input":{"type":"structure","required":["AccountId","UserIdList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserIdList":{"shape":"S1k"}}},"output":{"type":"structure","members":{"UserErrors":{"shape":"S1m"}}}},"BatchUnsuspendUser":{"http":{"requestUri":"/accounts/{accountId}/users?operation=unsuspend","responseCode":200},"input":{"type":"structure","required":["AccountId","UserIdList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserIdList":{"shape":"S1k"}}},"output":{"type":"structure","members":{"UserErrors":{"shape":"S1m"}}}},"BatchUpdatePhoneNumber":{"http":{"requestUri":"/phone-numbers?operation=batch-update","responseCode":200},"input":{"type":"structure","required":["UpdatePhoneNumberRequestItems"],"members":{"UpdatePhoneNumberRequestItems":{"type":"list","member":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{},"ProductType":{},"CallingName":{"shape":"S1u"}}}}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"Sa"}}}},"BatchUpdateUser":{"http":{"requestUri":"/accounts/{accountId}/users","responseCode":200},"input":{"type":"structure","required":["AccountId","UpdateUserRequestItems"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UpdateUserRequestItems":{"type":"list","member":{"type":"structure","required":["UserId"],"members":{"UserId":{},"LicenseType":{},"UserType":{},"AlexaForBusinessMetadata":{"shape":"S21"}}}}}},"output":{"type":"structure","members":{"UserErrors":{"shape":"S1m"}}}},"CreateAccount":{"http":{"requestUri":"/accounts","responseCode":201},"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Account":{"shape":"S28"}}}},"CreateAppInstance":{"http":{"requestUri":"/app-instances","responseCode":201},"input":{"type":"structure","required":["Name","ClientRequestToken"],"members":{"Name":{"shape":"S2e"},"Metadata":{"shape":"S2f"},"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"Tags":{"shape":"S2h"}}},"output":{"type":"structure","members":{"AppInstanceArn":{}}},"endpoint":{"hostPrefix":"identity-"}},"CreateAppInstanceAdmin":{"http":{"requestUri":"/app-instances/{appInstanceArn}/admins","responseCode":201},"input":{"type":"structure","required":["AppInstanceAdminArn","AppInstanceArn"],"members":{"AppInstanceAdminArn":{},"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceAdmin":{"shape":"S14"},"AppInstanceArn":{}}},"endpoint":{"hostPrefix":"identity-"}},"CreateAppInstanceUser":{"http":{"requestUri":"/app-instance-users","responseCode":201},"input":{"type":"structure","required":["AppInstanceArn","AppInstanceUserId","Name","ClientRequestToken"],"members":{"AppInstanceArn":{},"AppInstanceUserId":{"type":"string","sensitive":true},"Name":{"shape":"S2n"},"Metadata":{"shape":"S2f"},"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"Tags":{"shape":"S2h"}}},"output":{"type":"structure","members":{"AppInstanceUserArn":{}}},"endpoint":{"hostPrefix":"identity-"}},"CreateAttendee":{"http":{"requestUri":"/meetings/{meetingId}/attendees","responseCode":201},"input":{"type":"structure","required":["MeetingId","ExternalUserId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"ExternalUserId":{"shape":"Sn"},"Tags":{"shape":"So"}}},"output":{"type":"structure","members":{"Attendee":{"shape":"Su"}}}},"CreateBot":{"http":{"requestUri":"/accounts/{accountId}/bots","responseCode":201},"input":{"type":"structure","required":["DisplayName","AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"DisplayName":{"shape":"S23"},"Domain":{}}},"output":{"type":"structure","members":{"Bot":{"shape":"S2t"}}}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":201},"input":{"type":"structure","required":["AppInstanceArn","Name","ClientRequestToken"],"members":{"AppInstanceArn":{},"Name":{"shape":"S2e"},"Mode":{},"Privacy":{},"Metadata":{"shape":"S2f"},"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"Tags":{"shape":"S2h"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{}}},"endpoint":{"hostPrefix":"messaging-"}},"CreateChannelBan":{"http":{"requestUri":"/channels/{channelArn}/bans","responseCode":201},"input":{"type":"structure","required":["ChannelArn","MemberArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Member":{"shape":"S14"}}},"endpoint":{"hostPrefix":"messaging-"}},"CreateChannelMembership":{"http":{"requestUri":"/channels/{channelArn}/memberships","responseCode":201},"input":{"type":"structure","required":["ChannelArn","MemberArn","Type"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{},"Type":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Member":{"shape":"S14"}}},"endpoint":{"hostPrefix":"messaging-"}},"CreateChannelModerator":{"http":{"requestUri":"/channels/{channelArn}/moderators","responseCode":201},"input":{"type":"structure","required":["ChannelArn","ChannelModeratorArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelModeratorArn":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"ChannelModerator":{"shape":"S14"}}},"endpoint":{"hostPrefix":"messaging-"}},"CreateMediaCapturePipeline":{"http":{"requestUri":"/media-capture-pipelines","responseCode":201},"input":{"type":"structure","required":["SourceType","SourceArn","SinkType","SinkArn"],"members":{"SourceType":{},"SourceArn":{"shape":"S37"},"SinkType":{},"SinkArn":{"shape":"S37"},"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"ChimeSdkMeetingConfiguration":{"shape":"S39"}}},"output":{"type":"structure","members":{"MediaCapturePipeline":{"shape":"S3n"}}}},"CreateMeeting":{"http":{"requestUri":"/meetings","responseCode":201},"input":{"type":"structure","required":["ClientRequestToken"],"members":{"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"ExternalMeetingId":{"shape":"S3q"},"MeetingHostId":{"shape":"Sn"},"MediaRegion":{},"Tags":{"shape":"S3r"},"NotificationsConfiguration":{"shape":"S3s"}}},"output":{"type":"structure","members":{"Meeting":{"shape":"S3u"}}}},"CreateMeetingDialOut":{"http":{"requestUri":"/meetings/{meetingId}/dial-outs","responseCode":201},"input":{"type":"structure","required":["MeetingId","FromPhoneNumber","ToPhoneNumber","JoinToken"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"FromPhoneNumber":{"shape":"S3"},"ToPhoneNumber":{"shape":"S3"},"JoinToken":{"shape":"Sv"}}},"output":{"type":"structure","members":{"TransactionId":{}}}},"CreateMeetingWithAttendees":{"http":{"requestUri":"/meetings?operation=create-attendees","responseCode":201},"input":{"type":"structure","required":["ClientRequestToken"],"members":{"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"ExternalMeetingId":{"shape":"S3q"},"MeetingHostId":{"shape":"Sn"},"MediaRegion":{},"Tags":{"shape":"S3r"},"NotificationsConfiguration":{"shape":"S3s"},"Attendees":{"type":"list","member":{"shape":"Sm"}}}},"output":{"type":"structure","members":{"Meeting":{"shape":"S3u"},"Attendees":{"shape":"St"},"Errors":{"shape":"Sw"}}}},"CreatePhoneNumberOrder":{"http":{"requestUri":"/phone-number-orders","responseCode":201},"input":{"type":"structure","required":["ProductType","E164PhoneNumbers"],"members":{"ProductType":{},"E164PhoneNumbers":{"shape":"S7"}}},"output":{"type":"structure","members":{"PhoneNumberOrder":{"shape":"S44"}}}},"CreateProxySession":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}/proxy-sessions","responseCode":201},"input":{"type":"structure","required":["ParticipantPhoneNumbers","Capabilities","VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"ParticipantPhoneNumbers":{"type":"list","member":{"shape":"S3"}},"Name":{"type":"string","sensitive":true},"ExpiryMinutes":{"type":"integer"},"Capabilities":{"shape":"S4e"},"NumberSelectionBehavior":{},"GeoMatchLevel":{},"GeoMatchParams":{"shape":"S4i"}}},"output":{"type":"structure","members":{"ProxySession":{"shape":"S4m"}}}},"CreateRoom":{"http":{"requestUri":"/accounts/{accountId}/rooms","responseCode":201},"input":{"type":"structure","required":["AccountId","Name"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"Name":{"shape":"S23"},"ClientRequestToken":{"shape":"S2g","idempotencyToken":true}}},"output":{"type":"structure","members":{"Room":{"shape":"S4t"}}}},"CreateRoomMembership":{"http":{"requestUri":"/accounts/{accountId}/rooms/{roomId}/memberships","responseCode":201},"input":{"type":"structure","required":["AccountId","RoomId","MemberId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"MemberId":{},"Role":{}}},"output":{"type":"structure","members":{"RoomMembership":{"shape":"S4w"}}}},"CreateSipMediaApplication":{"http":{"requestUri":"/sip-media-applications","responseCode":201},"input":{"type":"structure","required":["AwsRegion","Name","Endpoints"],"members":{"AwsRegion":{},"Name":{},"Endpoints":{"shape":"S51"}}},"output":{"type":"structure","members":{"SipMediaApplication":{"shape":"S55"}}}},"CreateSipMediaApplicationCall":{"http":{"requestUri":"/sip-media-applications/{sipMediaApplicationId}/calls","responseCode":201},"input":{"type":"structure","required":["FromPhoneNumber","ToPhoneNumber","SipMediaApplicationId"],"members":{"FromPhoneNumber":{"shape":"S3"},"ToPhoneNumber":{"shape":"S3"},"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"},"SipHeaders":{"type":"map","key":{"shape":"S23"},"value":{"shape":"S23"}}}},"output":{"type":"structure","members":{"SipMediaApplicationCall":{"shape":"S59"}}}},"CreateSipRule":{"http":{"requestUri":"/sip-rules","responseCode":201},"input":{"type":"structure","required":["Name","TriggerType","TriggerValue","TargetApplications"],"members":{"Name":{},"TriggerType":{},"TriggerValue":{},"Disabled":{"type":"boolean"},"TargetApplications":{"shape":"S5d"}}},"output":{"type":"structure","members":{"SipRule":{"shape":"S5h"}}}},"CreateUser":{"http":{"requestUri":"/accounts/{accountId}/users?operation=create","responseCode":201},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"Username":{},"Email":{"shape":"S5j"},"UserType":{}}},"output":{"type":"structure","members":{"User":{"shape":"S5l"}}}},"CreateVoiceConnector":{"http":{"requestUri":"/voice-connectors","responseCode":201},"input":{"type":"structure","required":["Name","RequireEncryption"],"members":{"Name":{},"AwsRegion":{},"RequireEncryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"VoiceConnector":{"shape":"S5s"}}}},"CreateVoiceConnectorGroup":{"http":{"requestUri":"/voice-connector-groups","responseCode":201},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"VoiceConnectorItems":{"shape":"S5v"}}},"output":{"type":"structure","members":{"VoiceConnectorGroup":{"shape":"S5z"}}}},"DeleteAccount":{"http":{"method":"DELETE","requestUri":"/accounts/{accountId}","responseCode":204},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{}}},"DeleteAppInstance":{"http":{"method":"DELETE","requestUri":"/app-instances/{appInstanceArn}","responseCode":204},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"endpoint":{"hostPrefix":"identity-"}},"DeleteAppInstanceAdmin":{"http":{"method":"DELETE","requestUri":"/app-instances/{appInstanceArn}/admins/{appInstanceAdminArn}","responseCode":204},"input":{"type":"structure","required":["AppInstanceAdminArn","AppInstanceArn"],"members":{"AppInstanceAdminArn":{"location":"uri","locationName":"appInstanceAdminArn"},"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"endpoint":{"hostPrefix":"identity-"}},"DeleteAppInstanceStreamingConfigurations":{"http":{"method":"DELETE","requestUri":"/app-instances/{appInstanceArn}/streaming-configurations","responseCode":204},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}}},"DeleteAppInstanceUser":{"http":{"method":"DELETE","requestUri":"/app-instance-users/{appInstanceUserArn}","responseCode":204},"input":{"type":"structure","required":["AppInstanceUserArn"],"members":{"AppInstanceUserArn":{"location":"uri","locationName":"appInstanceUserArn"}}},"endpoint":{"hostPrefix":"identity-"}},"DeleteAttendee":{"http":{"method":"DELETE","requestUri":"/meetings/{meetingId}/attendees/{attendeeId}","responseCode":204},"input":{"type":"structure","required":["MeetingId","AttendeeId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"AttendeeId":{"location":"uri","locationName":"attendeeId"}}}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"endpoint":{"hostPrefix":"messaging-"}},"DeleteChannelBan":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/bans/{memberArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","MemberArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"endpoint":{"hostPrefix":"messaging-"}},"DeleteChannelMembership":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/memberships/{memberArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","MemberArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"endpoint":{"hostPrefix":"messaging-"}},"DeleteChannelMessage":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/messages/{messageId}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","MessageId"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"endpoint":{"hostPrefix":"messaging-"}},"DeleteChannelModerator":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/moderators/{channelModeratorArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","ChannelModeratorArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelModeratorArn":{"location":"uri","locationName":"channelModeratorArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"endpoint":{"hostPrefix":"messaging-"}},"DeleteEventsConfiguration":{"http":{"method":"DELETE","requestUri":"/accounts/{accountId}/bots/{botId}/events-configuration","responseCode":204},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}}},"DeleteMediaCapturePipeline":{"http":{"method":"DELETE","requestUri":"/media-capture-pipelines/{mediaPipelineId}","responseCode":204},"input":{"type":"structure","required":["MediaPipelineId"],"members":{"MediaPipelineId":{"location":"uri","locationName":"mediaPipelineId"}}}},"DeleteMeeting":{"http":{"method":"DELETE","requestUri":"/meetings/{meetingId}","responseCode":204},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"}}}},"DeletePhoneNumber":{"http":{"method":"DELETE","requestUri":"/phone-numbers/{phoneNumberId}","responseCode":204},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"}}}},"DeleteProxySession":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/proxy-sessions/{proxySessionId}","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId","ProxySessionId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"ProxySessionId":{"location":"uri","locationName":"proxySessionId"}}}},"DeleteRoom":{"http":{"method":"DELETE","requestUri":"/accounts/{accountId}/rooms/{roomId}","responseCode":204},"input":{"type":"structure","required":["AccountId","RoomId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"}}}},"DeleteRoomMembership":{"http":{"method":"DELETE","requestUri":"/accounts/{accountId}/rooms/{roomId}/memberships/{memberId}","responseCode":204},"input":{"type":"structure","required":["AccountId","RoomId","MemberId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"MemberId":{"location":"uri","locationName":"memberId"}}}},"DeleteSipMediaApplication":{"http":{"method":"DELETE","requestUri":"/sip-media-applications/{sipMediaApplicationId}","responseCode":204},"input":{"type":"structure","required":["SipMediaApplicationId"],"members":{"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"}}}},"DeleteSipRule":{"http":{"method":"DELETE","requestUri":"/sip-rules/{sipRuleId}","responseCode":204},"input":{"type":"structure","required":["SipRuleId"],"members":{"SipRuleId":{"location":"uri","locationName":"sipRuleId"}}}},"DeleteVoiceConnector":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorEmergencyCallingConfiguration":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/emergency-calling-configuration","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorGroup":{"http":{"method":"DELETE","requestUri":"/voice-connector-groups/{voiceConnectorGroupId}","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorGroupId"],"members":{"VoiceConnectorGroupId":{"location":"uri","locationName":"voiceConnectorGroupId"}}}},"DeleteVoiceConnectorOrigination":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/origination","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorProxy":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/programmable-numbers/proxy","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorStreamingConfiguration":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/streaming-configuration","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorTermination":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/termination","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorTerminationCredentials":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}/termination/credentials?operation=delete","responseCode":204},"input":{"type":"structure","required":["Usernames","VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Usernames":{"shape":"S6u"}}}},"DescribeAppInstance":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstance":{"type":"structure","members":{"AppInstanceArn":{},"Name":{"shape":"S2e"},"Metadata":{"shape":"S2f"},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}},"endpoint":{"hostPrefix":"identity-"}},"DescribeAppInstanceAdmin":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/admins/{appInstanceAdminArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceAdminArn","AppInstanceArn"],"members":{"AppInstanceAdminArn":{"location":"uri","locationName":"appInstanceAdminArn"},"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceAdmin":{"type":"structure","members":{"Admin":{"shape":"S14"},"AppInstanceArn":{},"CreatedTimestamp":{"type":"timestamp"}}}}},"endpoint":{"hostPrefix":"identity-"}},"DescribeAppInstanceUser":{"http":{"method":"GET","requestUri":"/app-instance-users/{appInstanceUserArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceUserArn"],"members":{"AppInstanceUserArn":{"location":"uri","locationName":"appInstanceUserArn"}}},"output":{"type":"structure","members":{"AppInstanceUser":{"type":"structure","members":{"AppInstanceUserArn":{},"Name":{"shape":"S2n"},"CreatedTimestamp":{"type":"timestamp"},"Metadata":{"shape":"S2f"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}},"endpoint":{"hostPrefix":"identity-"}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{channelArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channel":{"type":"structure","members":{"Name":{"shape":"S2e"},"ChannelArn":{},"Mode":{},"Privacy":{},"Metadata":{"shape":"S2f"},"CreatedBy":{"shape":"S14"},"CreatedTimestamp":{"type":"timestamp"},"LastMessageTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}},"endpoint":{"hostPrefix":"messaging-"}},"DescribeChannelBan":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/bans/{memberArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelBan":{"type":"structure","members":{"Member":{"shape":"S14"},"ChannelArn":{},"CreatedTimestamp":{"type":"timestamp"},"CreatedBy":{"shape":"S14"}}}}},"endpoint":{"hostPrefix":"messaging-"}},"DescribeChannelMembership":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/memberships/{memberArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMembership":{"type":"structure","members":{"InvitedBy":{"shape":"S14"},"Type":{},"Member":{"shape":"S14"},"ChannelArn":{},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}},"endpoint":{"hostPrefix":"messaging-"}},"DescribeChannelMembershipForAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels/{channelArn}?scope=app-instance-user-membership","responseCode":200},"input":{"type":"structure","required":["ChannelArn","AppInstanceUserArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMembership":{"shape":"S7g"}}},"endpoint":{"hostPrefix":"messaging-"}},"DescribeChannelModeratedByAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels/{channelArn}?scope=app-instance-user-moderated-channel","responseCode":200},"input":{"type":"structure","required":["ChannelArn","AppInstanceUserArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channel":{"shape":"S7l"}}},"endpoint":{"hostPrefix":"messaging-"}},"DescribeChannelModerator":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/moderators/{channelModeratorArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChannelModeratorArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelModeratorArn":{"location":"uri","locationName":"channelModeratorArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelModerator":{"type":"structure","members":{"Moderator":{"shape":"S14"},"ChannelArn":{},"CreatedTimestamp":{"type":"timestamp"},"CreatedBy":{"shape":"S14"}}}}},"endpoint":{"hostPrefix":"messaging-"}},"DisassociatePhoneNumberFromUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=disassociate-phone-number","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{}}},"DisassociatePhoneNumbersFromVoiceConnector":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}?operation=disassociate-phone-numbers","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","E164PhoneNumbers"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"E164PhoneNumbers":{"shape":"S7"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"Sa"}}}},"DisassociatePhoneNumbersFromVoiceConnectorGroup":{"http":{"requestUri":"/voice-connector-groups/{voiceConnectorGroupId}?operation=disassociate-phone-numbers","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorGroupId","E164PhoneNumbers"],"members":{"VoiceConnectorGroupId":{"location":"uri","locationName":"voiceConnectorGroupId"},"E164PhoneNumbers":{"shape":"S7"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"Sa"}}}},"DisassociateSigninDelegateGroupsFromAccount":{"http":{"requestUri":"/accounts/{accountId}?operation=disassociate-signin-delegate-groups","responseCode":200},"input":{"type":"structure","required":["AccountId","GroupNames"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"GroupNames":{"shape":"S1h"}}},"output":{"type":"structure","members":{}}},"GetAccount":{"http":{"method":"GET","requestUri":"/accounts/{accountId}"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"Account":{"shape":"S28"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/settings"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"AccountSettings":{"shape":"S81"}}}},"GetAppInstanceRetentionSettings":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/retention-settings","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceRetentionSettings":{"shape":"S84"},"InitiateDeletionTimestamp":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"identity-"}},"GetAppInstanceStreamingConfigurations":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/streaming-configurations","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceStreamingConfigurations":{"shape":"S89"}}}},"GetAttendee":{"http":{"method":"GET","requestUri":"/meetings/{meetingId}/attendees/{attendeeId}","responseCode":200},"input":{"type":"structure","required":["MeetingId","AttendeeId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"AttendeeId":{"location":"uri","locationName":"attendeeId"}}},"output":{"type":"structure","members":{"Attendee":{"shape":"Su"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/bots/{botId}","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"Bot":{"shape":"S2t"}}}},"GetChannelMessage":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/messages/{messageId}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMessage":{"type":"structure","members":{"ChannelArn":{},"MessageId":{},"Content":{"shape":"S8j"},"Metadata":{"shape":"S2f"},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"LastEditedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Sender":{"shape":"S14"},"Redacted":{"type":"boolean"},"Persistence":{}}}}},"endpoint":{"hostPrefix":"messaging-"}},"GetEventsConfiguration":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/bots/{botId}/events-configuration","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"EventsConfiguration":{"shape":"S8p"}}}},"GetGlobalSettings":{"http":{"method":"GET","requestUri":"/settings","responseCode":200},"output":{"type":"structure","members":{"BusinessCalling":{"shape":"S8r"},"VoiceConnector":{"shape":"S8s"}}}},"GetMediaCapturePipeline":{"http":{"method":"GET","requestUri":"/media-capture-pipelines/{mediaPipelineId}","responseCode":200},"input":{"type":"structure","required":["MediaPipelineId"],"members":{"MediaPipelineId":{"location":"uri","locationName":"mediaPipelineId"}}},"output":{"type":"structure","members":{"MediaCapturePipeline":{"shape":"S3n"}}}},"GetMeeting":{"http":{"method":"GET","requestUri":"/meetings/{meetingId}","responseCode":200},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"}}},"output":{"type":"structure","members":{"Meeting":{"shape":"S3u"}}}},"GetMessagingSessionEndpoint":{"http":{"method":"GET","requestUri":"/endpoints/messaging-session","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Endpoint":{"type":"structure","members":{"Url":{}}}}},"endpoint":{"hostPrefix":"messaging-"}},"GetPhoneNumber":{"http":{"method":"GET","requestUri":"/phone-numbers/{phoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"}}},"output":{"type":"structure","members":{"PhoneNumber":{"shape":"S93"}}}},"GetPhoneNumberOrder":{"http":{"method":"GET","requestUri":"/phone-number-orders/{phoneNumberOrderId}","responseCode":200},"input":{"type":"structure","required":["PhoneNumberOrderId"],"members":{"PhoneNumberOrderId":{"location":"uri","locationName":"phoneNumberOrderId"}}},"output":{"type":"structure","members":{"PhoneNumberOrder":{"shape":"S44"}}}},"GetPhoneNumberSettings":{"http":{"method":"GET","requestUri":"/settings/phone-number","responseCode":200},"output":{"type":"structure","members":{"CallingName":{"shape":"S1u"},"CallingNameUpdatedTimestamp":{"shape":"S2a"}}}},"GetProxySession":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/proxy-sessions/{proxySessionId}","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","ProxySessionId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"ProxySessionId":{"location":"uri","locationName":"proxySessionId"}}},"output":{"type":"structure","members":{"ProxySession":{"shape":"S4m"}}}},"GetRetentionSettings":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/retention-settings"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"RetentionSettings":{"shape":"S9j"},"InitiateDeletionTimestamp":{"shape":"S2a"}}}},"GetRoom":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/rooms/{roomId}","responseCode":200},"input":{"type":"structure","required":["AccountId","RoomId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"}}},"output":{"type":"structure","members":{"Room":{"shape":"S4t"}}}},"GetSipMediaApplication":{"http":{"method":"GET","requestUri":"/sip-media-applications/{sipMediaApplicationId}","responseCode":200},"input":{"type":"structure","required":["SipMediaApplicationId"],"members":{"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"}}},"output":{"type":"structure","members":{"SipMediaApplication":{"shape":"S55"}}}},"GetSipMediaApplicationLoggingConfiguration":{"http":{"method":"GET","requestUri":"/sip-media-applications/{sipMediaApplicationId}/logging-configuration","responseCode":200},"input":{"type":"structure","required":["SipMediaApplicationId"],"members":{"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"}}},"output":{"type":"structure","members":{"SipMediaApplicationLoggingConfiguration":{"shape":"S9s"}}}},"GetSipRule":{"http":{"method":"GET","requestUri":"/sip-rules/{sipRuleId}","responseCode":200},"input":{"type":"structure","required":["SipRuleId"],"members":{"SipRuleId":{"location":"uri","locationName":"sipRuleId"}}},"output":{"type":"structure","members":{"SipRule":{"shape":"S5h"}}}},"GetUser":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/users/{userId}","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"User":{"shape":"S5l"}}}},"GetUserSettings":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/users/{userId}/settings","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"UserSettings":{"shape":"S9z"}}}},"GetVoiceConnector":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"VoiceConnector":{"shape":"S5s"}}}},"GetVoiceConnectorEmergencyCallingConfiguration":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/emergency-calling-configuration","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"EmergencyCallingConfiguration":{"shape":"Sa5"}}}},"GetVoiceConnectorGroup":{"http":{"method":"GET","requestUri":"/voice-connector-groups/{voiceConnectorGroupId}","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorGroupId"],"members":{"VoiceConnectorGroupId":{"location":"uri","locationName":"voiceConnectorGroupId"}}},"output":{"type":"structure","members":{"VoiceConnectorGroup":{"shape":"S5z"}}}},"GetVoiceConnectorLoggingConfiguration":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/logging-configuration","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"Sac"}}}},"GetVoiceConnectorOrigination":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/origination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Origination":{"shape":"Saf"}}}},"GetVoiceConnectorProxy":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/programmable-numbers/proxy","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Proxy":{"shape":"Sao"}}}},"GetVoiceConnectorStreamingConfiguration":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/streaming-configuration","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"StreamingConfiguration":{"shape":"Sat"}}}},"GetVoiceConnectorTermination":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/termination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Termination":{"shape":"Sb0"}}}},"GetVoiceConnectorTerminationHealth":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/termination/health","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"TerminationHealth":{"type":"structure","members":{"Timestamp":{"shape":"S2a"},"Source":{}}}}}},"InviteUsers":{"http":{"requestUri":"/accounts/{accountId}/users?operation=add","responseCode":201},"input":{"type":"structure","required":["AccountId","UserEmailList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserEmailList":{"type":"list","member":{"shape":"S5j"}},"UserType":{}}},"output":{"type":"structure","members":{"Invites":{"type":"list","member":{"type":"structure","members":{"InviteId":{},"Status":{},"EmailAddress":{"shape":"S5j"},"EmailStatus":{}}}}}}},"ListAccounts":{"http":{"method":"GET","requestUri":"/accounts"},"input":{"type":"structure","members":{"Name":{"location":"querystring","locationName":"name"},"UserEmail":{"shape":"S5j","location":"querystring","locationName":"user-email"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Accounts":{"type":"list","member":{"shape":"S28"}},"NextToken":{}}}},"ListAppInstanceAdmins":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/admins","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstanceArn":{},"AppInstanceAdmins":{"type":"list","member":{"type":"structure","members":{"Admin":{"shape":"S14"}}}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"identity-"}},"ListAppInstanceUsers":{"http":{"method":"GET","requestUri":"/app-instance-users","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"querystring","locationName":"app-instance-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstanceArn":{},"AppInstanceUsers":{"type":"list","member":{"type":"structure","members":{"AppInstanceUserArn":{},"Name":{"shape":"S2n"},"Metadata":{"shape":"S2f"}}}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"identity-"}},"ListAppInstances":{"http":{"method":"GET","requestUri":"/app-instances","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstances":{"type":"list","member":{"type":"structure","members":{"AppInstanceArn":{},"Name":{"shape":"S2e"},"Metadata":{"shape":"S2f"}}}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"identity-"}},"ListAttendeeTags":{"http":{"method":"GET","requestUri":"/meetings/{meetingId}/attendees/{attendeeId}/tags","responseCode":200},"input":{"type":"structure","required":["MeetingId","AttendeeId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"AttendeeId":{"location":"uri","locationName":"attendeeId"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2h"}}}},"ListAttendees":{"http":{"method":"GET","requestUri":"/meetings/{meetingId}/attendees","responseCode":200},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Attendees":{"shape":"St"},"NextToken":{}}}},"ListBots":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/bots","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"Bots":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListChannelBans":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/bans","responseCode":200},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"NextToken":{"shape":"Sbj"},"ChannelBans":{"type":"list","member":{"type":"structure","members":{"Member":{"shape":"S14"}}}}}},"endpoint":{"hostPrefix":"messaging-"}},"ListChannelMemberships":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/memberships","responseCode":200},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Type":{"location":"querystring","locationName":"type"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"ChannelMemberships":{"type":"list","member":{"type":"structure","members":{"Member":{"shape":"S14"}}}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"messaging-"}},"ListChannelMembershipsForAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels?scope=app-instance-user-memberships","responseCode":200},"input":{"type":"structure","members":{"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMemberships":{"type":"list","member":{"shape":"S7g"}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"messaging-"}},"ListChannelMessages":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/messages","responseCode":200},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"SortOrder":{"location":"querystring","locationName":"sort-order"},"NotBefore":{"location":"querystring","locationName":"not-before","type":"timestamp"},"NotAfter":{"location":"querystring","locationName":"not-after","type":"timestamp"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"NextToken":{"shape":"Sbj"},"ChannelMessages":{"type":"list","member":{"type":"structure","members":{"MessageId":{},"Content":{"shape":"S8j"},"Metadata":{"shape":"S2f"},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"LastEditedTimestamp":{"type":"timestamp"},"Sender":{"shape":"S14"},"Redacted":{"type":"boolean"}}}}}},"endpoint":{"hostPrefix":"messaging-"}},"ListChannelModerators":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/moderators","responseCode":200},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"NextToken":{"shape":"Sbj"},"ChannelModerators":{"type":"list","member":{"type":"structure","members":{"Moderator":{"shape":"S14"}}}}}},"endpoint":{"hostPrefix":"messaging-"}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"querystring","locationName":"app-instance-arn"},"Privacy":{"location":"querystring","locationName":"privacy"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"shape":"S7h"}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"messaging-"}},"ListChannelsModeratedByAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels?scope=app-instance-user-moderated-channels","responseCode":200},"input":{"type":"structure","members":{"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"Sbj","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"shape":"S7l"}},"NextToken":{"shape":"Sbj"}}},"endpoint":{"hostPrefix":"messaging-"}},"ListMediaCapturePipelines":{"http":{"method":"GET","requestUri":"/media-capture-pipelines","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"MediaCapturePipelines":{"type":"list","member":{"shape":"S3n"}},"NextToken":{}}}},"ListMeetingTags":{"http":{"method":"GET","requestUri":"/meetings/{meetingId}/tags","responseCode":200},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2h"}}}},"ListMeetings":{"http":{"method":"GET","requestUri":"/meetings","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Meetings":{"type":"list","member":{"shape":"S3u"}},"NextToken":{}}}},"ListPhoneNumberOrders":{"http":{"method":"GET","requestUri":"/phone-number-orders","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"PhoneNumberOrders":{"type":"list","member":{"shape":"S44"}},"NextToken":{}}}},"ListPhoneNumbers":{"http":{"method":"GET","requestUri":"/phone-numbers"},"input":{"type":"structure","members":{"Status":{"location":"querystring","locationName":"status"},"ProductType":{"location":"querystring","locationName":"product-type"},"FilterName":{"location":"querystring","locationName":"filter-name"},"FilterValue":{"location":"querystring","locationName":"filter-value"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"PhoneNumbers":{"type":"list","member":{"shape":"S93"}},"NextToken":{}}}},"ListProxySessions":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/proxy-sessions","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Status":{"location":"querystring","locationName":"status"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"ProxySessions":{"type":"list","member":{"shape":"S4m"}},"NextToken":{}}}},"ListRoomMemberships":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/rooms/{roomId}/memberships","responseCode":200},"input":{"type":"structure","required":["AccountId","RoomId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"RoomMemberships":{"type":"list","member":{"shape":"S4w"}},"NextToken":{}}}},"ListRooms":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/rooms","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"MemberId":{"location":"querystring","locationName":"member-id"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"Rooms":{"type":"list","member":{"shape":"S4t"}},"NextToken":{}}}},"ListSipMediaApplications":{"http":{"method":"GET","requestUri":"/sip-media-applications","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"SipMediaApplications":{"type":"list","member":{"shape":"S55"}},"NextToken":{}}}},"ListSipRules":{"http":{"method":"GET","requestUri":"/sip-rules","responseCode":200},"input":{"type":"structure","members":{"SipMediaApplicationId":{"location":"querystring","locationName":"sip-media-application"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"SipRules":{"type":"list","member":{"shape":"S5h"}},"NextToken":{}}}},"ListSupportedPhoneNumberCountries":{"http":{"method":"GET","requestUri":"/phone-number-countries","responseCode":200},"input":{"type":"structure","required":["ProductType"],"members":{"ProductType":{"location":"querystring","locationName":"product-type"}}},"output":{"type":"structure","members":{"PhoneNumberCountries":{"type":"list","member":{"type":"structure","members":{"CountryCode":{},"SupportedPhoneNumberTypes":{"type":"list","member":{}}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{"shape":"S37","location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2h"}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/users","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserEmail":{"shape":"S5j","location":"querystring","locationName":"user-email"},"UserType":{"location":"querystring","locationName":"user-type"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S5l"}},"NextToken":{}}}},"ListVoiceConnectorGroups":{"http":{"method":"GET","requestUri":"/voice-connector-groups","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"VoiceConnectorGroups":{"type":"list","member":{"shape":"S5z"}},"NextToken":{}}}},"ListVoiceConnectorTerminationCredentials":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/termination/credentials","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Usernames":{"shape":"S6u"}}}},"ListVoiceConnectors":{"http":{"method":"GET","requestUri":"/voice-connectors","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"VoiceConnectors":{"type":"list","member":{"shape":"S5s"}},"NextToken":{}}}},"LogoutUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=logout","responseCode":204},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{}}},"PutAppInstanceRetentionSettings":{"http":{"method":"PUT","requestUri":"/app-instances/{appInstanceArn}/retention-settings","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn","AppInstanceRetentionSettings"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"AppInstanceRetentionSettings":{"shape":"S84"}}},"output":{"type":"structure","members":{"AppInstanceRetentionSettings":{"shape":"S84"},"InitiateDeletionTimestamp":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"identity-"}},"PutAppInstanceStreamingConfigurations":{"http":{"method":"PUT","requestUri":"/app-instances/{appInstanceArn}/streaming-configurations","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn","AppInstanceStreamingConfigurations"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"AppInstanceStreamingConfigurations":{"shape":"S89"}}},"output":{"type":"structure","members":{"AppInstanceStreamingConfigurations":{"shape":"S89"}}}},"PutEventsConfiguration":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/bots/{botId}/events-configuration","responseCode":201},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"},"OutboundEventsHTTPSEndpoint":{"shape":"S23"},"LambdaFunctionArn":{"shape":"S23"}}},"output":{"type":"structure","members":{"EventsConfiguration":{"shape":"S8p"}}}},"PutRetentionSettings":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/retention-settings","responseCode":204},"input":{"type":"structure","required":["AccountId","RetentionSettings"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RetentionSettings":{"shape":"S9j"}}},"output":{"type":"structure","members":{"RetentionSettings":{"shape":"S9j"},"InitiateDeletionTimestamp":{"shape":"S2a"}}}},"PutSipMediaApplicationLoggingConfiguration":{"http":{"method":"PUT","requestUri":"/sip-media-applications/{sipMediaApplicationId}/logging-configuration","responseCode":200},"input":{"type":"structure","required":["SipMediaApplicationId"],"members":{"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"},"SipMediaApplicationLoggingConfiguration":{"shape":"S9s"}}},"output":{"type":"structure","members":{"SipMediaApplicationLoggingConfiguration":{"shape":"S9s"}}}},"PutVoiceConnectorEmergencyCallingConfiguration":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/emergency-calling-configuration","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","EmergencyCallingConfiguration"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"EmergencyCallingConfiguration":{"shape":"Sa5"}}},"output":{"type":"structure","members":{"EmergencyCallingConfiguration":{"shape":"Sa5"}}}},"PutVoiceConnectorLoggingConfiguration":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/logging-configuration","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","LoggingConfiguration"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"LoggingConfiguration":{"shape":"Sac"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"Sac"}}}},"PutVoiceConnectorOrigination":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/origination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","Origination"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Origination":{"shape":"Saf"}}},"output":{"type":"structure","members":{"Origination":{"shape":"Saf"}}}},"PutVoiceConnectorProxy":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/programmable-numbers/proxy"},"input":{"type":"structure","required":["DefaultSessionExpiryMinutes","PhoneNumberPoolCountries","VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"DefaultSessionExpiryMinutes":{"type":"integer"},"PhoneNumberPoolCountries":{"type":"list","member":{}},"FallBackPhoneNumber":{"shape":"S3"},"Disabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Proxy":{"shape":"Sao"}}}},"PutVoiceConnectorStreamingConfiguration":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/streaming-configuration","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","StreamingConfiguration"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"StreamingConfiguration":{"shape":"Sat"}}},"output":{"type":"structure","members":{"StreamingConfiguration":{"shape":"Sat"}}}},"PutVoiceConnectorTermination":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/termination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","Termination"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Termination":{"shape":"Sb0"}}},"output":{"type":"structure","members":{"Termination":{"shape":"Sb0"}}}},"PutVoiceConnectorTerminationCredentials":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}/termination/credentials?operation=put","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Credentials":{"type":"list","member":{"type":"structure","members":{"Username":{"shape":"S23"},"Password":{"shape":"S23"}}}}}}},"RedactChannelMessage":{"http":{"requestUri":"/channels/{channelArn}/messages/{messageId}?operation=redact","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"MessageId":{}}},"endpoint":{"hostPrefix":"messaging-"}},"RedactConversationMessage":{"http":{"requestUri":"/accounts/{accountId}/conversations/{conversationId}/messages/{messageId}?operation=redact","responseCode":200},"input":{"type":"structure","required":["AccountId","ConversationId","MessageId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"ConversationId":{"location":"uri","locationName":"conversationId"},"MessageId":{"location":"uri","locationName":"messageId"}}},"output":{"type":"structure","members":{}}},"RedactRoomMessage":{"http":{"requestUri":"/accounts/{accountId}/rooms/{roomId}/messages/{messageId}?operation=redact","responseCode":200},"input":{"type":"structure","required":["AccountId","RoomId","MessageId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"MessageId":{"location":"uri","locationName":"messageId"}}},"output":{"type":"structure","members":{}}},"RegenerateSecurityToken":{"http":{"requestUri":"/accounts/{accountId}/bots/{botId}?operation=regenerate-security-token","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"Bot":{"shape":"S2t"}}}},"ResetPersonalPIN":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=reset-personal-pin","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"User":{"shape":"S5l"}}}},"RestorePhoneNumber":{"http":{"requestUri":"/phone-numbers/{phoneNumberId}?operation=restore","responseCode":200},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"}}},"output":{"type":"structure","members":{"PhoneNumber":{"shape":"S93"}}}},"SearchAvailablePhoneNumbers":{"http":{"method":"GET","requestUri":"/search?type=phone-numbers"},"input":{"type":"structure","members":{"AreaCode":{"location":"querystring","locationName":"area-code"},"City":{"location":"querystring","locationName":"city"},"Country":{"location":"querystring","locationName":"country"},"State":{"location":"querystring","locationName":"state"},"TollFreePrefix":{"location":"querystring","locationName":"toll-free-prefix"},"PhoneNumberType":{"location":"querystring","locationName":"phone-number-type"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"E164PhoneNumbers":{"shape":"S7"},"NextToken":{}}}},"SendChannelMessage":{"http":{"requestUri":"/channels/{channelArn}/messages","responseCode":201},"input":{"type":"structure","required":["ChannelArn","Content","Type","Persistence","ClientRequestToken"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Content":{"type":"string","sensitive":true},"Type":{},"Persistence":{},"Metadata":{"shape":"S2f"},"ClientRequestToken":{"shape":"S2g","idempotencyToken":true},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"MessageId":{}}},"endpoint":{"hostPrefix":"messaging-"}},"StartMeetingTranscription":{"http":{"requestUri":"/meetings/{meetingId}/transcription?operation=start","responseCode":200},"input":{"type":"structure","required":["MeetingId","TranscriptionConfiguration"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"TranscriptionConfiguration":{"type":"structure","members":{"EngineTranscribeSettings":{"type":"structure","required":["LanguageCode"],"members":{"LanguageCode":{},"VocabularyFilterMethod":{},"VocabularyFilterName":{},"VocabularyName":{},"Region":{},"EnablePartialResultsStabilization":{"type":"boolean"},"PartialResultsStability":{},"ContentIdentificationType":{},"ContentRedactionType":{},"PiiEntityTypes":{},"LanguageModelName":{}}},"EngineTranscribeMedicalSettings":{"type":"structure","required":["LanguageCode","Specialty","Type"],"members":{"LanguageCode":{},"Specialty":{},"Type":{},"VocabularyName":{},"Region":{},"ContentIdentificationType":{}}}}}}},"output":{"type":"structure","members":{}}},"StopMeetingTranscription":{"http":{"requestUri":"/meetings/{meetingId}/transcription?operation=stop","responseCode":200},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"}}},"output":{"type":"structure","members":{}}},"TagAttendee":{"http":{"requestUri":"/meetings/{meetingId}/attendees/{attendeeId}/tags?operation=add","responseCode":204},"input":{"type":"structure","required":["MeetingId","AttendeeId","Tags"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"AttendeeId":{"location":"uri","locationName":"attendeeId"},"Tags":{"shape":"So"}}}},"TagMeeting":{"http":{"requestUri":"/meetings/{meetingId}/tags?operation=add","responseCode":204},"input":{"type":"structure","required":["MeetingId","Tags"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"Tags":{"shape":"S3r"}}}},"TagResource":{"http":{"requestUri":"/tags?operation=tag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{"shape":"S37"},"Tags":{"shape":"S2h"}}}},"UntagAttendee":{"http":{"requestUri":"/meetings/{meetingId}/attendees/{attendeeId}/tags?operation=delete","responseCode":204},"input":{"type":"structure","required":["MeetingId","TagKeys","AttendeeId"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"AttendeeId":{"location":"uri","locationName":"attendeeId"},"TagKeys":{"type":"list","member":{"shape":"Sq"}}}}},"UntagMeeting":{"http":{"requestUri":"/meetings/{meetingId}/tags?operation=delete","responseCode":204},"input":{"type":"structure","required":["MeetingId","TagKeys"],"members":{"MeetingId":{"location":"uri","locationName":"meetingId"},"TagKeys":{"type":"list","member":{"shape":"Sq"}}}}},"UntagResource":{"http":{"requestUri":"/tags?operation=untag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{"shape":"S37"},"TagKeys":{"type":"list","member":{"shape":"Sq"}}}}},"UpdateAccount":{"http":{"requestUri":"/accounts/{accountId}","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"Name":{},"DefaultLicense":{}}},"output":{"type":"structure","members":{"Account":{"shape":"S28"}}}},"UpdateAccountSettings":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/settings","responseCode":204},"input":{"type":"structure","required":["AccountId","AccountSettings"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"AccountSettings":{"shape":"S81"}}},"output":{"type":"structure","members":{}}},"UpdateAppInstance":{"http":{"method":"PUT","requestUri":"/app-instances/{appInstanceArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn","Name"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"Name":{"shape":"S2e"},"Metadata":{"shape":"S2f"}}},"output":{"type":"structure","members":{"AppInstanceArn":{}}},"endpoint":{"hostPrefix":"identity-"}},"UpdateAppInstanceUser":{"http":{"method":"PUT","requestUri":"/app-instance-users/{appInstanceUserArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceUserArn","Name"],"members":{"AppInstanceUserArn":{"location":"uri","locationName":"appInstanceUserArn"},"Name":{"shape":"S2n"},"Metadata":{"shape":"S2f"}}},"output":{"type":"structure","members":{"AppInstanceUserArn":{}}},"endpoint":{"hostPrefix":"identity-"}},"UpdateBot":{"http":{"requestUri":"/accounts/{accountId}/bots/{botId}","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"},"Disabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Bot":{"shape":"S2t"}}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","Name","Mode"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Name":{"shape":"S2e"},"Mode":{},"Metadata":{"shape":"S2f"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{}}},"endpoint":{"hostPrefix":"messaging-"}},"UpdateChannelMessage":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}/messages/{messageId}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"Content":{"shape":"S8j"},"Metadata":{"shape":"S2f"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"MessageId":{}}},"endpoint":{"hostPrefix":"messaging-"}},"UpdateChannelReadMarker":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}/readMarker","responseCode":200},"input":{"type":"structure","required":["ChannelArn"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{}}},"endpoint":{"hostPrefix":"messaging-"}},"UpdateGlobalSettings":{"http":{"method":"PUT","requestUri":"/settings","responseCode":204},"input":{"type":"structure","members":{"BusinessCalling":{"shape":"S8r"},"VoiceConnector":{"shape":"S8s"}}}},"UpdatePhoneNumber":{"http":{"requestUri":"/phone-numbers/{phoneNumberId}","responseCode":200},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"},"ProductType":{},"CallingName":{"shape":"S1u"}}},"output":{"type":"structure","members":{"PhoneNumber":{"shape":"S93"}}}},"UpdatePhoneNumberSettings":{"http":{"method":"PUT","requestUri":"/settings/phone-number","responseCode":204},"input":{"type":"structure","required":["CallingName"],"members":{"CallingName":{"shape":"S1u"}}}},"UpdateProxySession":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}/proxy-sessions/{proxySessionId}","responseCode":201},"input":{"type":"structure","required":["Capabilities","VoiceConnectorId","ProxySessionId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"ProxySessionId":{"location":"uri","locationName":"proxySessionId"},"Capabilities":{"shape":"S4e"},"ExpiryMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"ProxySession":{"shape":"S4m"}}}},"UpdateRoom":{"http":{"requestUri":"/accounts/{accountId}/rooms/{roomId}","responseCode":200},"input":{"type":"structure","required":["AccountId","RoomId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"Name":{"shape":"S23"}}},"output":{"type":"structure","members":{"Room":{"shape":"S4t"}}}},"UpdateRoomMembership":{"http":{"requestUri":"/accounts/{accountId}/rooms/{roomId}/memberships/{memberId}","responseCode":200},"input":{"type":"structure","required":["AccountId","RoomId","MemberId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"RoomId":{"location":"uri","locationName":"roomId"},"MemberId":{"location":"uri","locationName":"memberId"},"Role":{}}},"output":{"type":"structure","members":{"RoomMembership":{"shape":"S4w"}}}},"UpdateSipMediaApplication":{"http":{"method":"PUT","requestUri":"/sip-media-applications/{sipMediaApplicationId}","responseCode":200},"input":{"type":"structure","required":["SipMediaApplicationId"],"members":{"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"},"Name":{},"Endpoints":{"shape":"S51"}}},"output":{"type":"structure","members":{"SipMediaApplication":{"shape":"S55"}}}},"UpdateSipMediaApplicationCall":{"http":{"requestUri":"/sip-media-applications/{sipMediaApplicationId}/calls/{transactionId}","responseCode":202},"input":{"type":"structure","required":["SipMediaApplicationId","TransactionId","Arguments"],"members":{"SipMediaApplicationId":{"location":"uri","locationName":"sipMediaApplicationId"},"TransactionId":{"location":"uri","locationName":"transactionId"},"Arguments":{"type":"map","key":{"shape":"S23"},"value":{"shape":"S23"}}}},"output":{"type":"structure","members":{"SipMediaApplicationCall":{"shape":"S59"}}}},"UpdateSipRule":{"http":{"method":"PUT","requestUri":"/sip-rules/{sipRuleId}","responseCode":202},"input":{"type":"structure","required":["SipRuleId","Name"],"members":{"SipRuleId":{"location":"uri","locationName":"sipRuleId"},"Name":{},"Disabled":{"type":"boolean"},"TargetApplications":{"shape":"S5d"}}},"output":{"type":"structure","members":{"SipRule":{"shape":"S5h"}}}},"UpdateUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"},"LicenseType":{},"UserType":{},"AlexaForBusinessMetadata":{"shape":"S21"}}},"output":{"type":"structure","members":{"User":{"shape":"S5l"}}}},"UpdateUserSettings":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/users/{userId}/settings","responseCode":204},"input":{"type":"structure","required":["AccountId","UserId","UserSettings"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"},"UserSettings":{"shape":"S9z"}}}},"UpdateVoiceConnector":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","Name","RequireEncryption"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Name":{},"RequireEncryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"VoiceConnector":{"shape":"S5s"}}}},"UpdateVoiceConnectorGroup":{"http":{"method":"PUT","requestUri":"/voice-connector-groups/{voiceConnectorGroupId}","responseCode":202},"input":{"type":"structure","required":["VoiceConnectorGroupId","Name","VoiceConnectorItems"],"members":{"VoiceConnectorGroupId":{"location":"uri","locationName":"voiceConnectorGroupId"},"Name":{},"VoiceConnectorItems":{"shape":"S5v"}}},"output":{"type":"structure","members":{"VoiceConnectorGroup":{"shape":"S5z"}}}}},"shapes":{"S3":{"type":"string","sensitive":true},"S7":{"type":"list","member":{"shape":"S3"}},"Sa":{"type":"list","member":{"type":"structure","members":{"PhoneNumberId":{},"ErrorCode":{},"ErrorMessage":{}}}},"Sg":{"type":"list","member":{"type":"structure","members":{"GroupName":{}}}},"Sm":{"type":"structure","required":["ExternalUserId"],"members":{"ExternalUserId":{"shape":"Sn"},"Tags":{"shape":"So"}}},"Sn":{"type":"string","sensitive":true},"So":{"type":"list","member":{"shape":"Sp"}},"Sp":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"Sq"},"Value":{"type":"string","sensitive":true}}},"Sq":{"type":"string","sensitive":true},"St":{"type":"list","member":{"shape":"Su"}},"Su":{"type":"structure","members":{"ExternalUserId":{"shape":"Sn"},"AttendeeId":{},"JoinToken":{"shape":"Sv"}}},"Sv":{"type":"string","sensitive":true},"Sw":{"type":"list","member":{"type":"structure","members":{"ExternalUserId":{"shape":"Sn"},"ErrorCode":{},"ErrorMessage":{}}}},"S14":{"type":"structure","members":{"Arn":{},"Name":{"type":"string","sensitive":true}}},"S1h":{"type":"list","member":{}},"S1k":{"type":"list","member":{}},"S1m":{"type":"list","member":{"type":"structure","members":{"UserId":{},"ErrorCode":{},"ErrorMessage":{}}}},"S1u":{"type":"string","sensitive":true},"S21":{"type":"structure","members":{"IsAlexaForBusinessEnabled":{"type":"boolean"},"AlexaForBusinessRoomArn":{"shape":"S23"}}},"S23":{"type":"string","sensitive":true},"S28":{"type":"structure","required":["AwsAccountId","AccountId","Name"],"members":{"AwsAccountId":{},"AccountId":{},"Name":{},"AccountType":{},"CreatedTimestamp":{"shape":"S2a"},"DefaultLicense":{},"SupportedLicenses":{"type":"list","member":{}},"AccountStatus":{},"SigninDelegateGroups":{"shape":"Sg"}}},"S2a":{"type":"timestamp","timestampFormat":"iso8601"},"S2e":{"type":"string","sensitive":true},"S2f":{"type":"string","sensitive":true},"S2g":{"type":"string","sensitive":true},"S2h":{"type":"list","member":{"shape":"Sp"}},"S2n":{"type":"string","sensitive":true},"S2t":{"type":"structure","members":{"BotId":{},"UserId":{},"DisplayName":{"shape":"S23"},"BotType":{},"Disabled":{"type":"boolean"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"},"BotEmail":{"shape":"S23"},"SecurityToken":{"shape":"S23"}}},"S37":{"type":"string","sensitive":true},"S39":{"type":"structure","members":{"SourceConfiguration":{"type":"structure","members":{"SelectedVideoStreams":{"type":"structure","members":{"AttendeeIds":{"type":"list","member":{}},"ExternalUserIds":{"type":"list","member":{"shape":"Sn"}}}}}},"ArtifactsConfiguration":{"type":"structure","required":["Audio","Video","Content"],"members":{"Audio":{"type":"structure","required":["MuxType"],"members":{"MuxType":{}}},"Video":{"type":"structure","required":["State"],"members":{"State":{},"MuxType":{}}},"Content":{"type":"structure","required":["State"],"members":{"State":{},"MuxType":{}}}}}}},"S3n":{"type":"structure","members":{"MediaPipelineId":{},"SourceType":{},"SourceArn":{"shape":"S37"},"Status":{},"SinkType":{},"SinkArn":{"shape":"S37"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"},"ChimeSdkMeetingConfiguration":{"shape":"S39"}}},"S3q":{"type":"string","sensitive":true},"S3r":{"type":"list","member":{"shape":"Sp"}},"S3s":{"type":"structure","members":{"SnsTopicArn":{"shape":"S37"},"SqsQueueArn":{"shape":"S37"}}},"S3u":{"type":"structure","members":{"MeetingId":{},"ExternalMeetingId":{"shape":"S3q"},"MediaPlacement":{"type":"structure","members":{"AudioHostUrl":{},"AudioFallbackUrl":{},"ScreenDataUrl":{},"ScreenSharingUrl":{},"ScreenViewingUrl":{},"SignalingUrl":{},"TurnControlUrl":{},"EventIngestionUrl":{}}},"MediaRegion":{}}},"S44":{"type":"structure","members":{"PhoneNumberOrderId":{},"ProductType":{},"Status":{},"OrderedPhoneNumbers":{"type":"list","member":{"type":"structure","members":{"E164PhoneNumber":{"shape":"S3"},"Status":{}}}},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"}}},"S4e":{"type":"list","member":{}},"S4i":{"type":"structure","required":["Country","AreaCode"],"members":{"Country":{},"AreaCode":{}}},"S4m":{"type":"structure","members":{"VoiceConnectorId":{},"ProxySessionId":{},"Name":{},"Status":{},"ExpiryMinutes":{"type":"integer"},"Capabilities":{"shape":"S4e"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"},"EndedTimestamp":{"shape":"S2a"},"Participants":{"type":"list","member":{"type":"structure","members":{"PhoneNumber":{"shape":"S3"},"ProxyPhoneNumber":{"shape":"S3"}}}},"NumberSelectionBehavior":{},"GeoMatchLevel":{},"GeoMatchParams":{"shape":"S4i"}}},"S4t":{"type":"structure","members":{"RoomId":{},"Name":{"shape":"S23"},"AccountId":{},"CreatedBy":{},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"}}},"S4w":{"type":"structure","members":{"RoomId":{},"Member":{"type":"structure","members":{"MemberId":{},"MemberType":{},"Email":{"shape":"S23"},"FullName":{"shape":"S23"},"AccountId":{}}},"Role":{},"InvitedBy":{},"UpdatedTimestamp":{"shape":"S2a"}}},"S51":{"type":"list","member":{"type":"structure","members":{"LambdaArn":{"type":"string","sensitive":true}}}},"S55":{"type":"structure","members":{"SipMediaApplicationId":{},"AwsRegion":{},"Name":{},"Endpoints":{"shape":"S51"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"}}},"S59":{"type":"structure","members":{"TransactionId":{}}},"S5d":{"type":"list","member":{"type":"structure","members":{"SipMediaApplicationId":{},"Priority":{"type":"integer"},"AwsRegion":{}}}},"S5h":{"type":"structure","members":{"SipRuleId":{},"Name":{},"Disabled":{"type":"boolean"},"TriggerType":{},"TriggerValue":{},"TargetApplications":{"shape":"S5d"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"}}},"S5j":{"type":"string","sensitive":true},"S5l":{"type":"structure","required":["UserId"],"members":{"UserId":{},"AccountId":{},"PrimaryEmail":{"shape":"S5j"},"PrimaryProvisionedNumber":{"shape":"S23"},"DisplayName":{"shape":"S23"},"LicenseType":{},"UserType":{},"UserRegistrationStatus":{},"UserInvitationStatus":{},"RegisteredOn":{"shape":"S2a"},"InvitedOn":{"shape":"S2a"},"AlexaForBusinessMetadata":{"shape":"S21"},"PersonalPIN":{}}},"S5s":{"type":"structure","members":{"VoiceConnectorId":{},"AwsRegion":{},"Name":{},"OutboundHostName":{},"RequireEncryption":{"type":"boolean"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"},"VoiceConnectorArn":{}}},"S5v":{"type":"list","member":{"type":"structure","required":["VoiceConnectorId","Priority"],"members":{"VoiceConnectorId":{},"Priority":{"type":"integer"}}}},"S5z":{"type":"structure","members":{"VoiceConnectorGroupId":{},"Name":{},"VoiceConnectorItems":{"shape":"S5v"},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"},"VoiceConnectorGroupArn":{}}},"S6u":{"type":"list","member":{"shape":"S23"}},"S7g":{"type":"structure","members":{"ChannelSummary":{"shape":"S7h"},"AppInstanceUserMembershipSummary":{"type":"structure","members":{"Type":{},"ReadMarkerTimestamp":{"type":"timestamp"}}}}},"S7h":{"type":"structure","members":{"Name":{"shape":"S2e"},"ChannelArn":{},"Mode":{},"Privacy":{},"Metadata":{"shape":"S2f"},"LastMessageTimestamp":{"type":"timestamp"}}},"S7l":{"type":"structure","members":{"ChannelSummary":{"shape":"S7h"}}},"S81":{"type":"structure","members":{"DisableRemoteControl":{"type":"boolean"},"EnableDialOut":{"type":"boolean"}}},"S84":{"type":"structure","members":{"ChannelRetentionSettings":{"type":"structure","members":{"RetentionDays":{"type":"integer"}}}}},"S89":{"type":"list","member":{"type":"structure","required":["AppInstanceDataType","ResourceArn"],"members":{"AppInstanceDataType":{},"ResourceArn":{"shape":"S37"}}}},"S8j":{"type":"string","sensitive":true},"S8p":{"type":"structure","members":{"BotId":{},"OutboundEventsHTTPSEndpoint":{"shape":"S23"},"LambdaFunctionArn":{"shape":"S23"}}},"S8r":{"type":"structure","members":{"CdrBucket":{}}},"S8s":{"type":"structure","members":{"CdrBucket":{}}},"S93":{"type":"structure","members":{"PhoneNumberId":{},"E164PhoneNumber":{"shape":"S3"},"Country":{},"Type":{},"ProductType":{},"Status":{},"Capabilities":{"type":"structure","members":{"InboundCall":{"type":"boolean"},"OutboundCall":{"type":"boolean"},"InboundSMS":{"type":"boolean"},"OutboundSMS":{"type":"boolean"},"InboundMMS":{"type":"boolean"},"OutboundMMS":{"type":"boolean"}}},"Associations":{"type":"list","member":{"type":"structure","members":{"Value":{},"Name":{},"AssociatedTimestamp":{"shape":"S2a"}}}},"CallingName":{"shape":"S1u"},"CallingNameStatus":{},"CreatedTimestamp":{"shape":"S2a"},"UpdatedTimestamp":{"shape":"S2a"},"DeletionTimestamp":{"shape":"S2a"}}},"S9j":{"type":"structure","members":{"RoomRetentionSettings":{"type":"structure","members":{"RetentionDays":{"type":"integer"}}},"ConversationRetentionSettings":{"type":"structure","members":{"RetentionDays":{"type":"integer"}}}}},"S9s":{"type":"structure","members":{"EnableSipMediaApplicationMessageLogs":{"type":"boolean"}}},"S9z":{"type":"structure","required":["Telephony"],"members":{"Telephony":{"type":"structure","required":["InboundCalling","OutboundCalling","SMS"],"members":{"InboundCalling":{"type":"boolean"},"OutboundCalling":{"type":"boolean"},"SMS":{"type":"boolean"}}}}},"Sa5":{"type":"structure","members":{"DNIS":{"type":"list","member":{"type":"structure","required":["EmergencyPhoneNumber","CallingCountry"],"members":{"EmergencyPhoneNumber":{"shape":"S3"},"TestPhoneNumber":{"shape":"S3"},"CallingCountry":{}}}}}},"Sac":{"type":"structure","members":{"EnableSIPLogs":{"type":"boolean"},"EnableMediaMetricLogs":{"type":"boolean"}}},"Saf":{"type":"structure","members":{"Routes":{"type":"list","member":{"type":"structure","members":{"Host":{},"Port":{"type":"integer"},"Protocol":{},"Priority":{"type":"integer"},"Weight":{"type":"integer"}}}},"Disabled":{"type":"boolean"}}},"Sao":{"type":"structure","members":{"DefaultSessionExpiryMinutes":{"type":"integer"},"Disabled":{"type":"boolean"},"FallBackPhoneNumber":{"shape":"S3"},"PhoneNumberCountries":{"shape":"Saq"}}},"Saq":{"type":"list","member":{}},"Sat":{"type":"structure","required":["DataRetentionInHours"],"members":{"DataRetentionInHours":{"type":"integer"},"Disabled":{"type":"boolean"},"StreamingNotificationTargets":{"type":"list","member":{"type":"structure","required":["NotificationTarget"],"members":{"NotificationTarget":{}}}}}},"Sb0":{"type":"structure","members":{"CpsLimit":{"type":"integer"},"DefaultPhoneNumber":{"shape":"S3"},"CallingRegions":{"type":"list","member":{}},"CidrAllowedList":{"shape":"Saq"},"Disabled":{"type":"boolean"}}},"Sbj":{"type":"string","sensitive":true}}}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccounts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAppInstanceAdmins":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAppInstanceUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAppInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAttendees":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBots":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelBans":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelMemberships":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelMembershipsForAppInstanceUser":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelMessages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelModerators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelsModeratedByAppInstanceUser":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMediaCapturePipelines":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMeetings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPhoneNumberOrders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPhoneNumbers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProxySessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRoomMemberships":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRooms":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSipMediaApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSipRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVoiceConnectorGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVoiceConnectors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchAvailablePhoneNumbers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['pinpointemail'] = {};
	AWS.PinpointEmail = Service.defineService('pinpointemail', ['2018-07-26']);
	Object.defineProperty(apiLoader.services['pinpointemail'], '2018-07-26', {
	  get: function get() {
	    var model = __webpack_require__(650);
	    model.paginators = __webpack_require__(651).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.PinpointEmail;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-07-26","endpointPrefix":"email","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Pinpoint Email","serviceFullName":"Amazon Pinpoint Email Service","serviceId":"Pinpoint Email","signatureVersion":"v4","signingName":"ses","uid":"pinpoint-email-2018-07-26"},"operations":{"CreateConfigurationSet":{"http":{"requestUri":"/v1/email/configuration-sets"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"S3"},"DeliveryOptions":{"shape":"S5"},"ReputationOptions":{"shape":"S8"},"SendingOptions":{"shape":"Sb"},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"http":{"requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","EventDestination"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{},"EventDestination":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"CreateDedicatedIpPool":{"http":{"requestUri":"/v1/email/dedicated-ip-pools"},"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateDeliverabilityTestReport":{"http":{"requestUri":"/v1/email/deliverability-dashboard/test"},"input":{"type":"structure","required":["FromEmailAddress","Content"],"members":{"ReportName":{},"FromEmailAddress":{},"Content":{"shape":"S12"},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","required":["ReportId","DeliverabilityTestStatus"],"members":{"ReportId":{},"DeliverabilityTestStatus":{}}}},"CreateEmailIdentity":{"http":{"requestUri":"/v1/email/identities"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{"IdentityType":{},"VerifiedForSendingStatus":{"type":"boolean"},"DkimAttributes":{"shape":"S1k"}}}},"DeleteConfigurationSet":{"http":{"method":"DELETE","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"http":{"method":"DELETE","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}}},"output":{"type":"structure","members":{}}},"DeleteDedicatedIpPool":{"http":{"method":"DELETE","requestUri":"/v1/email/dedicated-ip-pools/{PoolName}"},"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{"location":"uri","locationName":"PoolName"}}},"output":{"type":"structure","members":{}}},"DeleteEmailIdentity":{"http":{"method":"DELETE","requestUri":"/v1/email/identities/{EmailIdentity}"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{}}},"GetAccount":{"http":{"method":"GET","requestUri":"/v1/email/account"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"SendQuota":{"type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}},"SendingEnabled":{"type":"boolean"},"DedicatedIpAutoWarmupEnabled":{"type":"boolean"},"EnforcementStatus":{},"ProductionAccessEnabled":{"type":"boolean"}}}},"GetBlacklistReports":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/blacklist-report"},"input":{"type":"structure","required":["BlacklistItemNames"],"members":{"BlacklistItemNames":{"location":"querystring","locationName":"BlacklistItemNames","type":"list","member":{}}}},"output":{"type":"structure","required":["BlacklistReport"],"members":{"BlacklistReport":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"RblName":{},"ListingTime":{"type":"timestamp"},"Description":{}}}}}}}},"GetConfigurationSet":{"http":{"method":"GET","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"S3"},"DeliveryOptions":{"shape":"S5"},"ReputationOptions":{"shape":"S8"},"SendingOptions":{"shape":"Sb"},"Tags":{"shape":"Sc"}}}},"GetConfigurationSetEventDestinations":{"http":{"method":"GET","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{"EventDestinations":{"type":"list","member":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sk"},"KinesisFirehoseDestination":{"shape":"Sm"},"CloudWatchDestination":{"shape":"So"},"SnsDestination":{"shape":"Su"},"PinpointDestination":{"shape":"Sv"}}}}}}},"GetDedicatedIp":{"http":{"method":"GET","requestUri":"/v1/email/dedicated-ips/{IP}"},"input":{"type":"structure","required":["Ip"],"members":{"Ip":{"location":"uri","locationName":"IP"}}},"output":{"type":"structure","members":{"DedicatedIp":{"shape":"S2m"}}}},"GetDedicatedIps":{"http":{"method":"GET","requestUri":"/v1/email/dedicated-ips"},"input":{"type":"structure","members":{"PoolName":{"location":"querystring","locationName":"PoolName"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"DedicatedIps":{"type":"list","member":{"shape":"S2m"}},"NextToken":{}}}},"GetDeliverabilityDashboardOptions":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["DashboardEnabled"],"members":{"DashboardEnabled":{"type":"boolean"},"SubscriptionExpiryDate":{"type":"timestamp"},"AccountStatus":{},"ActiveSubscribedDomains":{"shape":"S2x"},"PendingExpirationSubscribedDomains":{"shape":"S2x"}}}},"GetDeliverabilityTestReport":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/test-reports/{ReportId}"},"input":{"type":"structure","required":["ReportId"],"members":{"ReportId":{"location":"uri","locationName":"ReportId"}}},"output":{"type":"structure","required":["DeliverabilityTestReport","OverallPlacement","IspPlacements"],"members":{"DeliverabilityTestReport":{"shape":"S35"},"OverallPlacement":{"shape":"S37"},"IspPlacements":{"type":"list","member":{"type":"structure","members":{"IspName":{},"PlacementStatistics":{"shape":"S37"}}}},"Message":{},"Tags":{"shape":"Sc"}}}},"GetDomainDeliverabilityCampaign":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/campaigns/{CampaignId}"},"input":{"type":"structure","required":["CampaignId"],"members":{"CampaignId":{"location":"uri","locationName":"CampaignId"}}},"output":{"type":"structure","required":["DomainDeliverabilityCampaign"],"members":{"DomainDeliverabilityCampaign":{"shape":"S3f"}}}},"GetDomainStatisticsReport":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/statistics-report/{Domain}"},"input":{"type":"structure","required":["Domain","StartDate","EndDate"],"members":{"Domain":{"location":"uri","locationName":"Domain"},"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"}}},"output":{"type":"structure","required":["OverallVolume","DailyVolumes"],"members":{"OverallVolume":{"type":"structure","members":{"VolumeStatistics":{"shape":"S3p"},"ReadRatePercent":{"type":"double"},"DomainIspPlacements":{"shape":"S3q"}}},"DailyVolumes":{"type":"list","member":{"type":"structure","members":{"StartDate":{"type":"timestamp"},"VolumeStatistics":{"shape":"S3p"},"DomainIspPlacements":{"shape":"S3q"}}}}}}},"GetEmailIdentity":{"http":{"method":"GET","requestUri":"/v1/email/identities/{EmailIdentity}"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{"IdentityType":{},"FeedbackForwardingStatus":{"type":"boolean"},"VerifiedForSendingStatus":{"type":"boolean"},"DkimAttributes":{"shape":"S1k"},"MailFromAttributes":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMxFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMxFailure":{}}},"Tags":{"shape":"Sc"}}}},"ListConfigurationSets":{"http":{"method":"GET","requestUri":"/v1/email/configuration-sets"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationSets":{"type":"list","member":{}},"NextToken":{}}}},"ListDedicatedIpPools":{"http":{"method":"GET","requestUri":"/v1/email/dedicated-ip-pools"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"DedicatedIpPools":{"type":"list","member":{}},"NextToken":{}}}},"ListDeliverabilityTestReports":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/test-reports"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","required":["DeliverabilityTestReports"],"members":{"DeliverabilityTestReports":{"type":"list","member":{"shape":"S35"}},"NextToken":{}}}},"ListDomainDeliverabilityCampaigns":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/domains/{SubscribedDomain}/campaigns"},"input":{"type":"structure","required":["StartDate","EndDate","SubscribedDomain"],"members":{"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"},"SubscribedDomain":{"location":"uri","locationName":"SubscribedDomain"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","required":["DomainDeliverabilityCampaigns"],"members":{"DomainDeliverabilityCampaigns":{"type":"list","member":{"shape":"S3f"}},"NextToken":{}}}},"ListEmailIdentities":{"http":{"method":"GET","requestUri":"/v1/email/identities"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"EmailIdentities":{"type":"list","member":{"type":"structure","members":{"IdentityType":{},"IdentityName":{},"SendingEnabled":{"type":"boolean"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/email/tags"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"querystring","locationName":"ResourceArn"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sc"}}}},"PutAccountDedicatedIpWarmupAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/account/dedicated-ips/warmup"},"input":{"type":"structure","members":{"AutoWarmupEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutAccountSendingAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/account/sending"},"input":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetDeliveryOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/delivery-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"TlsPolicy":{},"SendingPoolName":{}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetReputationOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/reputation-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"ReputationMetricsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetSendingOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/sending"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"SendingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetTrackingOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/tracking-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"CustomRedirectDomain":{}}},"output":{"type":"structure","members":{}}},"PutDedicatedIpInPool":{"http":{"method":"PUT","requestUri":"/v1/email/dedicated-ips/{IP}/pool"},"input":{"type":"structure","required":["Ip","DestinationPoolName"],"members":{"Ip":{"location":"uri","locationName":"IP"},"DestinationPoolName":{}}},"output":{"type":"structure","members":{}}},"PutDedicatedIpWarmupAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/dedicated-ips/{IP}/warmup"},"input":{"type":"structure","required":["Ip","WarmupPercentage"],"members":{"Ip":{"location":"uri","locationName":"IP"},"WarmupPercentage":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"PutDeliverabilityDashboardOption":{"http":{"method":"PUT","requestUri":"/v1/email/deliverability-dashboard"},"input":{"type":"structure","required":["DashboardEnabled"],"members":{"DashboardEnabled":{"type":"boolean"},"SubscribedDomains":{"shape":"S2x"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityDkimAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/dkim"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"SigningEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityFeedbackAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/feedback"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"EmailForwardingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityMailFromAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/mail-from"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"MailFromDomain":{},"BehaviorOnMxFailure":{}}},"output":{"type":"structure","members":{}}},"SendEmail":{"http":{"requestUri":"/v1/email/outbound-emails"},"input":{"type":"structure","required":["Destination","Content"],"members":{"FromEmailAddress":{},"Destination":{"type":"structure","members":{"ToAddresses":{"shape":"S59"},"CcAddresses":{"shape":"S59"},"BccAddresses":{"shape":"S59"}}},"ReplyToAddresses":{"shape":"S59"},"FeedbackForwardingEmailAddress":{},"Content":{"shape":"S12"},"EmailTags":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"MessageId":{}}}},"TagResource":{"http":{"requestUri":"/v1/email/tags"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/email/tags"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"querystring","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"TagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConfigurationSetEventDestination":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","EventDestination"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"},"EventDestination":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","required":["CustomRedirectDomain"],"members":{"CustomRedirectDomain":{}}},"S5":{"type":"structure","members":{"TlsPolicy":{},"SendingPoolName":{}}},"S8":{"type":"structure","members":{"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}},"Sb":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"}}},"Sc":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sj":{"type":"structure","members":{"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sk"},"KinesisFirehoseDestination":{"shape":"Sm"},"CloudWatchDestination":{"shape":"So"},"SnsDestination":{"shape":"Su"},"PinpointDestination":{"shape":"Sv"}}},"Sk":{"type":"list","member":{}},"Sm":{"type":"structure","required":["IamRoleArn","DeliveryStreamArn"],"members":{"IamRoleArn":{},"DeliveryStreamArn":{}}},"So":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"Su":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"Sv":{"type":"structure","members":{"ApplicationArn":{}}},"S12":{"type":"structure","members":{"Simple":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S14"},"Body":{"type":"structure","members":{"Text":{"shape":"S14"},"Html":{"shape":"S14"}}}}},"Raw":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"Template":{"type":"structure","members":{"TemplateArn":{},"TemplateData":{}}}}},"S14":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}},"S1k":{"type":"structure","members":{"SigningEnabled":{"type":"boolean"},"Status":{},"Tokens":{"type":"list","member":{}}}},"S2m":{"type":"structure","required":["Ip","WarmupStatus","WarmupPercentage"],"members":{"Ip":{},"WarmupStatus":{},"WarmupPercentage":{"type":"integer"},"PoolName":{}}},"S2x":{"type":"list","member":{"type":"structure","members":{"Domain":{},"SubscriptionStartDate":{"type":"timestamp"},"InboxPlacementTrackingOption":{"type":"structure","members":{"Global":{"type":"boolean"},"TrackedIsps":{"type":"list","member":{}}}}}}},"S35":{"type":"structure","members":{"ReportId":{},"ReportName":{},"Subject":{},"FromEmailAddress":{},"CreateDate":{"type":"timestamp"},"DeliverabilityTestStatus":{}}},"S37":{"type":"structure","members":{"InboxPercentage":{"type":"double"},"SpamPercentage":{"type":"double"},"MissingPercentage":{"type":"double"},"SpfPercentage":{"type":"double"},"DkimPercentage":{"type":"double"}}},"S3f":{"type":"structure","members":{"CampaignId":{},"ImageUrl":{},"Subject":{},"FromAddress":{},"SendingIps":{"type":"list","member":{}},"FirstSeenDateTime":{"type":"timestamp"},"LastSeenDateTime":{"type":"timestamp"},"InboxCount":{"type":"long"},"SpamCount":{"type":"long"},"ReadRate":{"type":"double"},"DeleteRate":{"type":"double"},"ReadDeleteRate":{"type":"double"},"ProjectedVolume":{"type":"long"},"Esps":{"type":"list","member":{}}}},"S3p":{"type":"structure","members":{"InboxRawCount":{"type":"long"},"SpamRawCount":{"type":"long"},"ProjectedInbox":{"type":"long"},"ProjectedSpam":{"type":"long"}}},"S3q":{"type":"list","member":{"type":"structure","members":{"IspName":{},"InboxRawCount":{"type":"long"},"SpamRawCount":{"type":"long"},"InboxPercentage":{"type":"double"},"SpamPercentage":{"type":"double"}}}},"S59":{"type":"list","member":{}}}}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetDedicatedIps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListConfigurationSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDedicatedIpPools":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDeliverabilityTestReports":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDomainDeliverabilityCampaigns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListEmailIdentities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"}}}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ram'] = {};
	AWS.RAM = Service.defineService('ram', ['2018-01-04']);
	Object.defineProperty(apiLoader.services['ram'], '2018-01-04', {
	  get: function get() {
	    var model = __webpack_require__(653);
	    model.paginators = __webpack_require__(654).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.RAM;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-01-04","endpointPrefix":"ram","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"RAM","serviceFullName":"AWS Resource Access Manager","serviceId":"RAM","signatureVersion":"v4","uid":"ram-2018-01-04"},"operations":{"AcceptResourceShareInvitation":{"http":{"requestUri":"/acceptresourceshareinvitation"},"input":{"type":"structure","required":["resourceShareInvitationArn"],"members":{"resourceShareInvitationArn":{},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareInvitation":{"shape":"S4"},"clientToken":{}}}},"AssociateResourceShare":{"http":{"requestUri":"/associateresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"resourceArns":{"shape":"Sd"},"principals":{"shape":"Se"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareAssociations":{"shape":"S7"},"clientToken":{}}}},"AssociateResourceSharePermission":{"http":{"requestUri":"/associateresourcesharepermission"},"input":{"type":"structure","required":["resourceShareArn","permissionArn"],"members":{"resourceShareArn":{},"permissionArn":{},"replace":{"type":"boolean"},"clientToken":{},"permissionVersion":{"type":"integer"}}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"},"clientToken":{}}}},"CreateResourceShare":{"http":{"requestUri":"/createresourceshare"},"input":{"type":"structure","required":["name"],"members":{"name":{},"resourceArns":{"shape":"Sd"},"principals":{"shape":"Se"},"tags":{"shape":"Sk"},"allowExternalPrincipals":{"type":"boolean"},"clientToken":{},"permissionArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceShare":{"shape":"Sq"},"clientToken":{}}}},"DeleteResourceShare":{"http":{"method":"DELETE","requestUri":"/deleteresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{"location":"querystring","locationName":"resourceShareArn"},"clientToken":{"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"},"clientToken":{}}}},"DisassociateResourceShare":{"http":{"requestUri":"/disassociateresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"resourceArns":{"shape":"Sd"},"principals":{"shape":"Se"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareAssociations":{"shape":"S7"},"clientToken":{}}}},"DisassociateResourceSharePermission":{"http":{"requestUri":"/disassociateresourcesharepermission"},"input":{"type":"structure","required":["resourceShareArn","permissionArn"],"members":{"resourceShareArn":{},"permissionArn":{},"clientToken":{}}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"},"clientToken":{}}}},"EnableSharingWithAwsOrganization":{"http":{"requestUri":"/enablesharingwithawsorganization"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"}}}},"GetPermission":{"http":{"requestUri":"/getpermission"},"input":{"type":"structure","required":["permissionArn"],"members":{"permissionArn":{},"permissionVersion":{"type":"integer"}}},"output":{"type":"structure","members":{"permission":{"type":"structure","members":{"arn":{},"version":{},"defaultVersion":{"type":"boolean"},"name":{},"resourceType":{},"permission":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"isResourceTypeDefault":{"type":"boolean"}}}}}},"GetResourcePolicies":{"http":{"requestUri":"/getresourcepolicies"},"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"shape":"Sd"},"principal":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"policies":{"type":"list","member":{}},"nextToken":{}}}},"GetResourceShareAssociations":{"http":{"requestUri":"/getresourceshareassociations"},"input":{"type":"structure","required":["associationType"],"members":{"associationType":{},"resourceShareArns":{"shape":"S1a"},"resourceArn":{},"principal":{},"associationStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resourceShareAssociations":{"shape":"S7"},"nextToken":{}}}},"GetResourceShareInvitations":{"http":{"requestUri":"/getresourceshareinvitations"},"input":{"type":"structure","members":{"resourceShareInvitationArns":{"type":"list","member":{}},"resourceShareArns":{"shape":"S1a"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resourceShareInvitations":{"type":"list","member":{"shape":"S4"}},"nextToken":{}}}},"GetResourceShares":{"http":{"requestUri":"/getresourceshares"},"input":{"type":"structure","required":["resourceOwner"],"members":{"resourceShareArns":{"shape":"S1a"},"resourceShareStatus":{},"resourceOwner":{},"name":{},"tagFilters":{"type":"list","member":{"type":"structure","members":{"tagKey":{},"tagValues":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"},"permissionArn":{}}},"output":{"type":"structure","members":{"resourceShares":{"type":"list","member":{"shape":"Sq"}},"nextToken":{}}}},"ListPendingInvitationResources":{"http":{"requestUri":"/listpendinginvitationresources"},"input":{"type":"structure","required":["resourceShareInvitationArn"],"members":{"resourceShareInvitationArn":{},"nextToken":{},"maxResults":{"type":"integer"},"resourceRegionScope":{}}},"output":{"type":"structure","members":{"resources":{"shape":"S1q"},"nextToken":{}}}},"ListPermissionVersions":{"http":{"requestUri":"/listpermissionversions"},"input":{"type":"structure","required":["permissionArn"],"members":{"permissionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"permissions":{"shape":"S1w"},"nextToken":{}}}},"ListPermissions":{"http":{"requestUri":"/listpermissions"},"input":{"type":"structure","members":{"resourceType":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"permissions":{"shape":"S1w"},"nextToken":{}}}},"ListPrincipals":{"http":{"requestUri":"/listprincipals"},"input":{"type":"structure","required":["resourceOwner"],"members":{"resourceOwner":{},"resourceArn":{},"principals":{"shape":"Se"},"resourceType":{},"resourceShareArns":{"shape":"S1a"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"principals":{"type":"list","member":{"type":"structure","members":{"id":{},"resourceShareArn":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"external":{"type":"boolean"}}}},"nextToken":{}}}},"ListResourceSharePermissions":{"http":{"requestUri":"/listresourcesharepermissions"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"permissions":{"shape":"S1w"},"nextToken":{}}}},"ListResourceTypes":{"http":{"requestUri":"/listresourcetypes"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"resourceRegionScope":{}}},"output":{"type":"structure","members":{"resourceTypes":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"serviceName":{},"resourceRegionScope":{}}}},"nextToken":{}}}},"ListResources":{"http":{"requestUri":"/listresources"},"input":{"type":"structure","required":["resourceOwner"],"members":{"resourceOwner":{},"principal":{},"resourceType":{},"resourceArns":{"shape":"Sd"},"resourceShareArns":{"shape":"S1a"},"nextToken":{},"maxResults":{"type":"integer"},"resourceRegionScope":{}}},"output":{"type":"structure","members":{"resources":{"shape":"S1q"},"nextToken":{}}}},"PromoteResourceShareCreatedFromPolicy":{"http":{"requestUri":"/promoteresourcesharecreatedfrompolicy"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{"location":"querystring","locationName":"resourceShareArn"}}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"}}}},"RejectResourceShareInvitation":{"http":{"requestUri":"/rejectresourceshareinvitation"},"input":{"type":"structure","required":["resourceShareInvitationArn"],"members":{"resourceShareInvitationArn":{},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareInvitation":{"shape":"S4"},"clientToken":{}}}},"TagResource":{"http":{"requestUri":"/tagresource"},"input":{"type":"structure","required":["resourceShareArn","tags"],"members":{"resourceShareArn":{},"tags":{"shape":"Sk"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/untagresource"},"input":{"type":"structure","required":["resourceShareArn","tagKeys"],"members":{"resourceShareArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateResourceShare":{"http":{"requestUri":"/updateresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"name":{},"allowExternalPrincipals":{"type":"boolean"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShare":{"shape":"Sq"},"clientToken":{}}}}},"shapes":{"S4":{"type":"structure","members":{"resourceShareInvitationArn":{},"resourceShareName":{},"resourceShareArn":{},"senderAccountId":{},"receiverAccountId":{},"invitationTimestamp":{"type":"timestamp"},"status":{},"resourceShareAssociations":{"shape":"S7","deprecated":true,"deprecatedMessage":"This member has been deprecated. Use ListPendingInvitationResources."},"receiverArn":{}}},"S7":{"type":"list","member":{"type":"structure","members":{"resourceShareArn":{},"resourceShareName":{},"associatedEntity":{},"associationType":{},"status":{},"statusMessage":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"external":{"type":"boolean"}}}},"Sd":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Sq":{"type":"structure","members":{"resourceShareArn":{},"name":{},"owningAccountId":{},"allowExternalPrincipals":{"type":"boolean"},"status":{},"statusMessage":{},"tags":{"shape":"Sk"},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"featureSet":{}}},"S1a":{"type":"list","member":{}},"S1q":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"resourceShareArn":{},"resourceGroupArn":{},"status":{},"statusMessage":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"resourceRegionScope":{}}}},"S1w":{"type":"list","member":{"type":"structure","members":{"arn":{},"version":{},"defaultVersion":{"type":"boolean"},"name":{},"resourceType":{},"status":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"isResourceTypeDefault":{"type":"boolean"}}}}}}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetResourcePolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetResourceShareAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetResourceShareInvitations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetResourceShares":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPendingInvitationResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPermissionVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPermissions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPrincipals":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListResourceSharePermissions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListResourceTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['route53resolver'] = {};
	AWS.Route53Resolver = Service.defineService('route53resolver', ['2018-04-01']);
	Object.defineProperty(apiLoader.services['route53resolver'], '2018-04-01', {
	  get: function get() {
	    var model = __webpack_require__(656);
	    model.paginators = __webpack_require__(657).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Route53Resolver;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-04-01","endpointPrefix":"route53resolver","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Route53Resolver","serviceFullName":"Amazon Route 53 Resolver","serviceId":"Route53Resolver","signatureVersion":"v4","targetPrefix":"Route53Resolver","uid":"route53resolver-2018-04-01"},"operations":{"AssociateFirewallRuleGroup":{"input":{"type":"structure","required":["CreatorRequestId","FirewallRuleGroupId","VpcId","Priority","Name"],"members":{"CreatorRequestId":{"idempotencyToken":true},"FirewallRuleGroupId":{},"VpcId":{},"Priority":{"type":"integer"},"Name":{},"MutationProtection":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"FirewallRuleGroupAssociation":{"shape":"Sc"}}}},"AssociateResolverEndpointIpAddress":{"input":{"type":"structure","required":["ResolverEndpointId","IpAddress"],"members":{"ResolverEndpointId":{},"IpAddress":{"shape":"Sj"}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"Sn"}}}},"AssociateResolverQueryLogConfig":{"input":{"type":"structure","required":["ResolverQueryLogConfigId","ResourceId"],"members":{"ResolverQueryLogConfigId":{},"ResourceId":{}}},"output":{"type":"structure","members":{"ResolverQueryLogConfigAssociation":{"shape":"Su"}}}},"AssociateResolverRule":{"input":{"type":"structure","required":["ResolverRuleId","VPCId"],"members":{"ResolverRuleId":{},"Name":{},"VPCId":{}}},"output":{"type":"structure","members":{"ResolverRuleAssociation":{"shape":"S10"}}}},"CreateFirewallDomainList":{"input":{"type":"structure","required":["CreatorRequestId","Name"],"members":{"CreatorRequestId":{"idempotencyToken":true},"Name":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"FirewallDomainList":{"shape":"S14"}}}},"CreateFirewallRule":{"input":{"type":"structure","required":["CreatorRequestId","FirewallRuleGroupId","FirewallDomainListId","Priority","Action","Name"],"members":{"CreatorRequestId":{"idempotencyToken":true},"FirewallRuleGroupId":{},"FirewallDomainListId":{},"Priority":{"type":"integer"},"Action":{},"BlockResponse":{},"BlockOverrideDomain":{},"BlockOverrideDnsType":{},"BlockOverrideTtl":{"type":"integer"},"Name":{}}},"output":{"type":"structure","members":{"FirewallRule":{"shape":"S1e"}}}},"CreateFirewallRuleGroup":{"input":{"type":"structure","required":["CreatorRequestId","Name"],"members":{"CreatorRequestId":{"idempotencyToken":true},"Name":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"FirewallRuleGroup":{"shape":"S1h"}}}},"CreateResolverEndpoint":{"input":{"type":"structure","required":["CreatorRequestId","SecurityGroupIds","Direction","IpAddresses"],"members":{"CreatorRequestId":{},"Name":{},"SecurityGroupIds":{"shape":"So"},"Direction":{},"IpAddresses":{"type":"list","member":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"Ip":{}}}},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"Sn"}}}},"CreateResolverQueryLogConfig":{"input":{"type":"structure","required":["Name","DestinationArn","CreatorRequestId"],"members":{"Name":{},"DestinationArn":{},"CreatorRequestId":{"idempotencyToken":true},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ResolverQueryLogConfig":{"shape":"S1t"}}}},"CreateResolverRule":{"input":{"type":"structure","required":["CreatorRequestId","RuleType","DomainName"],"members":{"CreatorRequestId":{},"Name":{},"RuleType":{},"DomainName":{},"TargetIps":{"shape":"S1z"},"ResolverEndpointId":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S23"}}}},"DeleteFirewallDomainList":{"input":{"type":"structure","required":["FirewallDomainListId"],"members":{"FirewallDomainListId":{}}},"output":{"type":"structure","members":{"FirewallDomainList":{"shape":"S14"}}}},"DeleteFirewallRule":{"input":{"type":"structure","required":["FirewallRuleGroupId","FirewallDomainListId"],"members":{"FirewallRuleGroupId":{},"FirewallDomainListId":{}}},"output":{"type":"structure","members":{"FirewallRule":{"shape":"S1e"}}}},"DeleteFirewallRuleGroup":{"input":{"type":"structure","required":["FirewallRuleGroupId"],"members":{"FirewallRuleGroupId":{}}},"output":{"type":"structure","members":{"FirewallRuleGroup":{"shape":"S1h"}}}},"DeleteResolverEndpoint":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"Sn"}}}},"DeleteResolverQueryLogConfig":{"input":{"type":"structure","required":["ResolverQueryLogConfigId"],"members":{"ResolverQueryLogConfigId":{}}},"output":{"type":"structure","members":{"ResolverQueryLogConfig":{"shape":"S1t"}}}},"DeleteResolverRule":{"input":{"type":"structure","required":["ResolverRuleId"],"members":{"ResolverRuleId":{}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S23"}}}},"DisassociateFirewallRuleGroup":{"input":{"type":"structure","required":["FirewallRuleGroupAssociationId"],"members":{"FirewallRuleGroupAssociationId":{}}},"output":{"type":"structure","members":{"FirewallRuleGroupAssociation":{"shape":"Sc"}}}},"DisassociateResolverEndpointIpAddress":{"input":{"type":"structure","required":["ResolverEndpointId","IpAddress"],"members":{"ResolverEndpointId":{},"IpAddress":{"shape":"Sj"}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"Sn"}}}},"DisassociateResolverQueryLogConfig":{"input":{"type":"structure","required":["ResolverQueryLogConfigId","ResourceId"],"members":{"ResolverQueryLogConfigId":{},"ResourceId":{}}},"output":{"type":"structure","members":{"ResolverQueryLogConfigAssociation":{"shape":"Su"}}}},"DisassociateResolverRule":{"input":{"type":"structure","required":["VPCId","ResolverRuleId"],"members":{"VPCId":{},"ResolverRuleId":{}}},"output":{"type":"structure","members":{"ResolverRuleAssociation":{"shape":"S10"}}}},"GetFirewallConfig":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{}}},"output":{"type":"structure","members":{"FirewallConfig":{"shape":"S2r"}}}},"GetFirewallDomainList":{"input":{"type":"structure","required":["FirewallDomainListId"],"members":{"FirewallDomainListId":{}}},"output":{"type":"structure","members":{"FirewallDomainList":{"shape":"S14"}}}},"GetFirewallRuleGroup":{"input":{"type":"structure","required":["FirewallRuleGroupId"],"members":{"FirewallRuleGroupId":{}}},"output":{"type":"structure","members":{"FirewallRuleGroup":{"shape":"S1h"}}}},"GetFirewallRuleGroupAssociation":{"input":{"type":"structure","required":["FirewallRuleGroupAssociationId"],"members":{"FirewallRuleGroupAssociationId":{}}},"output":{"type":"structure","members":{"FirewallRuleGroupAssociation":{"shape":"Sc"}}}},"GetFirewallRuleGroupPolicy":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"FirewallRuleGroupPolicy":{}}}},"GetResolverConfig":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{}}},"output":{"type":"structure","members":{"ResolverConfig":{"shape":"S34"}}}},"GetResolverDnssecConfig":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{}}},"output":{"type":"structure","members":{"ResolverDNSSECConfig":{"shape":"S38"}}}},"GetResolverEndpoint":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"Sn"}}}},"GetResolverQueryLogConfig":{"input":{"type":"structure","required":["ResolverQueryLogConfigId"],"members":{"ResolverQueryLogConfigId":{}}},"output":{"type":"structure","members":{"ResolverQueryLogConfig":{"shape":"S1t"}}}},"GetResolverQueryLogConfigAssociation":{"input":{"type":"structure","required":["ResolverQueryLogConfigAssociationId"],"members":{"ResolverQueryLogConfigAssociationId":{}}},"output":{"type":"structure","members":{"ResolverQueryLogConfigAssociation":{"shape":"Su"}}}},"GetResolverQueryLogConfigPolicy":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"ResolverQueryLogConfigPolicy":{}}}},"GetResolverRule":{"input":{"type":"structure","required":["ResolverRuleId"],"members":{"ResolverRuleId":{}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S23"}}}},"GetResolverRuleAssociation":{"input":{"type":"structure","required":["ResolverRuleAssociationId"],"members":{"ResolverRuleAssociationId":{}}},"output":{"type":"structure","members":{"ResolverRuleAssociation":{"shape":"S10"}}}},"GetResolverRulePolicy":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"ResolverRulePolicy":{}}}},"ImportFirewallDomains":{"input":{"type":"structure","required":["FirewallDomainListId","Operation","DomainFileUrl"],"members":{"FirewallDomainListId":{},"Operation":{},"DomainFileUrl":{}}},"output":{"type":"structure","members":{"Id":{},"Name":{},"Status":{},"StatusMessage":{}}}},"ListFirewallConfigs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"FirewallConfigs":{"type":"list","member":{"shape":"S2r"}}}}},"ListFirewallDomainLists":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"FirewallDomainLists":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"CreatorRequestId":{},"ManagedOwnerName":{}}}}}}},"ListFirewallDomains":{"input":{"type":"structure","required":["FirewallDomainListId"],"members":{"FirewallDomainListId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Domains":{"shape":"S47"}}}},"ListFirewallRuleGroupAssociations":{"input":{"type":"structure","members":{"FirewallRuleGroupId":{},"VpcId":{},"Priority":{"type":"integer"},"Status":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"FirewallRuleGroupAssociations":{"type":"list","member":{"shape":"Sc"}}}}},"ListFirewallRuleGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"FirewallRuleGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"OwnerId":{},"CreatorRequestId":{},"ShareStatus":{}}}}}}},"ListFirewallRules":{"input":{"type":"structure","required":["FirewallRuleGroupId"],"members":{"FirewallRuleGroupId":{},"Priority":{"type":"integer"},"Action":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"FirewallRules":{"type":"list","member":{"shape":"S1e"}}}}},"ListResolverConfigs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"ResolverConfigs":{"type":"list","member":{"shape":"S34"}}}}},"ListResolverDnssecConfigs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4o"}}},"output":{"type":"structure","members":{"NextToken":{},"ResolverDnssecConfigs":{"type":"list","member":{"shape":"S38"}}}}},"ListResolverEndpointIpAddresses":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"IpAddresses":{"type":"list","member":{"type":"structure","members":{"IpId":{},"SubnetId":{},"Ip":{},"Status":{},"StatusMessage":{},"CreationTime":{},"ModificationTime":{}}}}}}},"ListResolverEndpoints":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4o"}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResolverEndpoints":{"type":"list","member":{"shape":"Sn"}}}}},"ListResolverQueryLogConfigAssociations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4o"},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"NextToken":{},"TotalCount":{"type":"integer"},"TotalFilteredCount":{"type":"integer"},"ResolverQueryLogConfigAssociations":{"type":"list","member":{"shape":"Su"}}}}},"ListResolverQueryLogConfigs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4o"},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"NextToken":{},"TotalCount":{"type":"integer"},"TotalFilteredCount":{"type":"integer"},"ResolverQueryLogConfigs":{"type":"list","member":{"shape":"S1t"}}}}},"ListResolverRuleAssociations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4o"}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResolverRuleAssociations":{"type":"list","member":{"shape":"S10"}}}}},"ListResolverRules":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4o"}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResolverRules":{"type":"list","member":{"shape":"S23"}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"},"NextToken":{}}}},"PutFirewallRuleGroupPolicy":{"input":{"type":"structure","required":["Arn","FirewallRuleGroupPolicy"],"members":{"Arn":{},"FirewallRuleGroupPolicy":{}}},"output":{"type":"structure","members":{"ReturnValue":{"type":"boolean"}}}},"PutResolverQueryLogConfigPolicy":{"input":{"type":"structure","required":["Arn","ResolverQueryLogConfigPolicy"],"members":{"Arn":{},"ResolverQueryLogConfigPolicy":{}}},"output":{"type":"structure","members":{"ReturnValue":{"type":"boolean"}}}},"PutResolverRulePolicy":{"input":{"type":"structure","required":["Arn","ResolverRulePolicy"],"members":{"Arn":{},"ResolverRulePolicy":{}}},"output":{"type":"structure","members":{"ReturnValue":{"type":"boolean"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFirewallConfig":{"input":{"type":"structure","required":["ResourceId","FirewallFailOpen"],"members":{"ResourceId":{},"FirewallFailOpen":{}}},"output":{"type":"structure","members":{"FirewallConfig":{"shape":"S2r"}}}},"UpdateFirewallDomains":{"input":{"type":"structure","required":["FirewallDomainListId","Operation","Domains"],"members":{"FirewallDomainListId":{},"Operation":{},"Domains":{"shape":"S47"}}},"output":{"type":"structure","members":{"Id":{},"Name":{},"Status":{},"StatusMessage":{}}}},"UpdateFirewallRule":{"input":{"type":"structure","required":["FirewallRuleGroupId","FirewallDomainListId"],"members":{"FirewallRuleGroupId":{},"FirewallDomainListId":{},"Priority":{"type":"integer"},"Action":{},"BlockResponse":{},"BlockOverrideDomain":{},"BlockOverrideDnsType":{},"BlockOverrideTtl":{"type":"integer"},"Name":{}}},"output":{"type":"structure","members":{"FirewallRule":{"shape":"S1e"}}}},"UpdateFirewallRuleGroupAssociation":{"input":{"type":"structure","required":["FirewallRuleGroupAssociationId"],"members":{"FirewallRuleGroupAssociationId":{},"Priority":{"type":"integer"},"MutationProtection":{},"Name":{}}},"output":{"type":"structure","members":{"FirewallRuleGroupAssociation":{"shape":"Sc"}}}},"UpdateResolverConfig":{"input":{"type":"structure","required":["ResourceId","AutodefinedReverseFlag"],"members":{"ResourceId":{},"AutodefinedReverseFlag":{}}},"output":{"type":"structure","members":{"ResolverConfig":{"shape":"S34"}}}},"UpdateResolverDnssecConfig":{"input":{"type":"structure","required":["ResourceId","Validation"],"members":{"ResourceId":{},"Validation":{}}},"output":{"type":"structure","members":{"ResolverDNSSECConfig":{"shape":"S38"}}}},"UpdateResolverEndpoint":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{},"Name":{}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"Sn"}}}},"UpdateResolverRule":{"input":{"type":"structure","required":["ResolverRuleId","Config"],"members":{"ResolverRuleId":{},"Config":{"type":"structure","members":{"Name":{},"TargetIps":{"shape":"S1z"},"ResolverEndpointId":{}}}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S23"}}}}},"shapes":{"S7":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"structure","members":{"Id":{},"Arn":{},"FirewallRuleGroupId":{},"VpcId":{},"Name":{},"Priority":{"type":"integer"},"MutationProtection":{},"ManagedOwnerName":{},"Status":{},"StatusMessage":{},"CreatorRequestId":{},"CreationTime":{},"ModificationTime":{}}},"Sj":{"type":"structure","members":{"IpId":{},"SubnetId":{},"Ip":{}}},"Sn":{"type":"structure","members":{"Id":{},"CreatorRequestId":{},"Arn":{},"Name":{},"SecurityGroupIds":{"shape":"So"},"Direction":{},"IpAddressCount":{"type":"integer"},"HostVPCId":{},"Status":{},"StatusMessage":{},"CreationTime":{},"ModificationTime":{}}},"So":{"type":"list","member":{}},"Su":{"type":"structure","members":{"Id":{},"ResolverQueryLogConfigId":{},"ResourceId":{},"Status":{},"Error":{},"ErrorMessage":{},"CreationTime":{}}},"S10":{"type":"structure","members":{"Id":{},"ResolverRuleId":{},"Name":{},"VPCId":{},"Status":{},"StatusMessage":{}}},"S14":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"DomainCount":{"type":"integer"},"Status":{},"StatusMessage":{},"ManagedOwnerName":{},"CreatorRequestId":{},"CreationTime":{},"ModificationTime":{}}},"S1e":{"type":"structure","members":{"FirewallRuleGroupId":{},"FirewallDomainListId":{},"Name":{},"Priority":{"type":"integer"},"Action":{},"BlockResponse":{},"BlockOverrideDomain":{},"BlockOverrideDnsType":{},"BlockOverrideTtl":{"type":"integer"},"CreatorRequestId":{},"CreationTime":{},"ModificationTime":{}}},"S1h":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"RuleCount":{"type":"integer"},"Status":{},"StatusMessage":{},"OwnerId":{},"CreatorRequestId":{},"ShareStatus":{},"CreationTime":{},"ModificationTime":{}}},"S1t":{"type":"structure","members":{"Id":{},"OwnerId":{},"Status":{},"ShareStatus":{},"AssociationCount":{"type":"integer"},"Arn":{},"Name":{},"DestinationArn":{},"CreatorRequestId":{},"CreationTime":{}}},"S1z":{"type":"list","member":{"type":"structure","required":["Ip"],"members":{"Ip":{},"Port":{"type":"integer"}}}},"S23":{"type":"structure","members":{"Id":{},"CreatorRequestId":{},"Arn":{},"DomainName":{},"Status":{},"StatusMessage":{},"RuleType":{},"Name":{},"TargetIps":{"shape":"S1z"},"ResolverEndpointId":{},"OwnerId":{},"ShareStatus":{},"CreationTime":{},"ModificationTime":{}}},"S2r":{"type":"structure","members":{"Id":{},"ResourceId":{},"OwnerId":{},"FirewallFailOpen":{}}},"S34":{"type":"structure","members":{"Id":{},"ResourceId":{},"OwnerId":{},"AutodefinedReverse":{}}},"S38":{"type":"structure","members":{"Id":{},"OwnerId":{},"ResourceId":{},"ValidationStatus":{}}},"S47":{"type":"list","member":{}},"S4o":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}}}}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListFirewallConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FirewallConfigs"},"ListFirewallDomainLists":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FirewallDomainLists"},"ListFirewallDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Domains"},"ListFirewallRuleGroupAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FirewallRuleGroupAssociations"},"ListFirewallRuleGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FirewallRuleGroups"},"ListFirewallRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FirewallRules"},"ListResolverConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverConfigs"},"ListResolverDnssecConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverDnssecConfigs"},"ListResolverEndpointIpAddresses":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"IpAddresses"},"ListResolverEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverEndpoints"},"ListResolverQueryLogConfigAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverQueryLogConfigAssociations"},"ListResolverQueryLogConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverQueryLogConfigs"},"ListResolverRuleAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverRuleAssociations"},"ListResolverRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResolverRules"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Tags"}}}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['pinpointsmsvoice'] = {};
	AWS.PinpointSMSVoice = Service.defineService('pinpointsmsvoice', ['2018-09-05']);
	Object.defineProperty(apiLoader.services['pinpointsmsvoice'], '2018-09-05', {
	  get: function get() {
	    var model = __webpack_require__(659);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.PinpointSMSVoice;


/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-09-05","endpointPrefix":"sms-voice.pinpoint","signingName":"sms-voice","serviceAbbreviation":"Pinpoint SMS Voice","serviceFullName":"Amazon Pinpoint SMS and Voice Service","serviceId":"Pinpoint SMS Voice","protocol":"rest-json","jsonVersion":"1.1","uid":"pinpoint-sms-voice-2018-09-05","signatureVersion":"v4"},"operations":{"CreateConfigurationSet":{"http":{"requestUri":"/v1/sms-voice/configuration-sets","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{}}},"output":{"type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"http":{"requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestination":{"shape":"S6"},"EventDestinationName":{}},"required":["ConfigurationSetName"]},"output":{"type":"structure","members":{}}},"DeleteConfigurationSet":{"http":{"method":"DELETE","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}},"required":["ConfigurationSetName"]},"output":{"type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"http":{"method":"DELETE","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}},"required":["EventDestinationName","ConfigurationSetName"]},"output":{"type":"structure","members":{}}},"GetConfigurationSetEventDestinations":{"http":{"method":"GET","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}},"required":["ConfigurationSetName"]},"output":{"type":"structure","members":{"EventDestinations":{"type":"list","member":{"type":"structure","members":{"CloudWatchLogsDestination":{"shape":"S7"},"Enabled":{"type":"boolean"},"KinesisFirehoseDestination":{"shape":"Sa"},"MatchingEventTypes":{"shape":"Sb"},"Name":{},"SnsDestination":{"shape":"Sd"}}}}}}},"ListConfigurationSets":{"http":{"method":"GET","requestUri":"/v1/sms-voice/configuration-sets","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize"}}},"output":{"type":"structure","members":{"ConfigurationSets":{"type":"list","member":{}},"NextToken":{}}}},"SendVoiceMessage":{"http":{"requestUri":"/v1/sms-voice/voice/message","responseCode":200},"input":{"type":"structure","members":{"CallerId":{},"ConfigurationSetName":{},"Content":{"type":"structure","members":{"CallInstructionsMessage":{"type":"structure","members":{"Text":{}},"required":[]},"PlainTextMessage":{"type":"structure","members":{"LanguageCode":{},"Text":{},"VoiceId":{}},"required":[]},"SSMLMessage":{"type":"structure","members":{"LanguageCode":{},"Text":{},"VoiceId":{}},"required":[]}}},"DestinationPhoneNumber":{},"OriginationPhoneNumber":{}}},"output":{"type":"structure","members":{"MessageId":{}}}},"UpdateConfigurationSetEventDestination":{"http":{"method":"PUT","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestination":{"shape":"S6"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}},"required":["EventDestinationName","ConfigurationSetName"]},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"structure","members":{"CloudWatchLogsDestination":{"shape":"S7"},"Enabled":{"type":"boolean"},"KinesisFirehoseDestination":{"shape":"Sa"},"MatchingEventTypes":{"shape":"Sb"},"SnsDestination":{"shape":"Sd"}},"required":[]},"S7":{"type":"structure","members":{"IamRoleArn":{},"LogGroupArn":{}},"required":[]},"Sa":{"type":"structure","members":{"DeliveryStreamArn":{},"IamRoleArn":{}},"required":[]},"Sb":{"type":"list","member":{}},"Sd":{"type":"structure","members":{"TopicArn":{}},"required":[]}}}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['quicksight'] = {};
	AWS.QuickSight = Service.defineService('quicksight', ['2018-04-01']);
	Object.defineProperty(apiLoader.services['quicksight'], '2018-04-01', {
	  get: function get() {
	    var model = __webpack_require__(661);
	    model.paginators = __webpack_require__(662).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.QuickSight;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-04-01","endpointPrefix":"quicksight","jsonVersion":"1.0","protocol":"rest-json","serviceFullName":"Amazon QuickSight","serviceId":"QuickSight","signatureVersion":"v4","uid":"quicksight-2018-04-01"},"operations":{"CancelIngestion":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}/ingestions/{IngestionId}"},"input":{"type":"structure","required":["AwsAccountId","DataSetId","IngestionId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"IngestionId":{"location":"uri","locationName":"IngestionId"}}},"output":{"type":"structure","members":{"Arn":{},"IngestionId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateAccountCustomization":{"http":{"requestUri":"/accounts/{AwsAccountId}/customizations"},"input":{"type":"structure","required":["AwsAccountId","AccountCustomization"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"querystring","locationName":"namespace"},"AccountCustomization":{"shape":"Sa"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"AwsAccountId":{},"Namespace":{},"AccountCustomization":{"shape":"Sa"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateAnalysis":{"http":{"requestUri":"/accounts/{AwsAccountId}/analyses/{AnalysisId}"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId","Name","SourceEntity"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"},"Name":{},"Parameters":{"shape":"Sj"},"Permissions":{"shape":"S10"},"SourceEntity":{"shape":"S14"},"ThemeArn":{},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"AnalysisId":{},"CreationStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"CreateDashboard":{"http":{"requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}"},"input":{"type":"structure","required":["AwsAccountId","DashboardId","Name","SourceEntity"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"Name":{},"Parameters":{"shape":"Sj"},"Permissions":{"shape":"S10"},"SourceEntity":{"shape":"S1c"},"Tags":{"shape":"Sb"},"VersionDescription":{},"DashboardPublishOptions":{"shape":"S1f"},"ThemeArn":{}}},"output":{"type":"structure","members":{"Arn":{},"VersionArn":{},"DashboardId":{},"CreationStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"CreateDataSet":{"http":{"requestUri":"/accounts/{AwsAccountId}/data-sets"},"input":{"type":"structure","required":["AwsAccountId","DataSetId","Name","PhysicalTableMap","ImportMode"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{},"Name":{},"PhysicalTableMap":{"shape":"S1p"},"LogicalTableMap":{"shape":"S2a"},"ImportMode":{},"ColumnGroups":{"shape":"S37"},"FieldFolders":{"shape":"S3d"},"Permissions":{"shape":"S10"},"RowLevelPermissionDataSet":{"shape":"S3i"},"RowLevelPermissionTagConfiguration":{"shape":"S3m"},"ColumnLevelPermissionRules":{"shape":"S3s"},"Tags":{"shape":"Sb"},"DataSetUsageConfiguration":{"shape":"S3w"}}},"output":{"type":"structure","members":{"Arn":{},"DataSetId":{},"IngestionArn":{},"IngestionId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateDataSource":{"http":{"requestUri":"/accounts/{AwsAccountId}/data-sources"},"input":{"type":"structure","required":["AwsAccountId","DataSourceId","Name","Type"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSourceId":{},"Name":{},"Type":{},"DataSourceParameters":{"shape":"S40"},"Credentials":{"shape":"S53"},"Permissions":{"shape":"S10"},"VpcConnectionProperties":{"shape":"S59"},"SslProperties":{"shape":"S5a"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"DataSourceId":{},"CreationStatus":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateFolder":{"http":{"requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{},"FolderType":{},"ParentFolderArn":{},"Permissions":{"shape":"S10"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Arn":{},"FolderId":{},"RequestId":{}}}},"CreateFolderMembership":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}/members/{MemberType}/{MemberId}"},"input":{"type":"structure","required":["AwsAccountId","FolderId","MemberId","MemberType"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"},"MemberId":{"location":"uri","locationName":"MemberId"},"MemberType":{"location":"uri","locationName":"MemberType"}}},"output":{"type":"structure","members":{"Status":{"type":"integer"},"FolderMember":{"type":"structure","members":{"MemberId":{},"MemberType":{}}},"RequestId":{}}}},"CreateGroup":{"http":{"requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{},"Description":{},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Group":{"shape":"S5o"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateGroupMembership":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members/{MemberName}"},"input":{"type":"structure","required":["MemberName","GroupName","AwsAccountId","Namespace"],"members":{"MemberName":{"location":"uri","locationName":"MemberName"},"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupMember":{"shape":"S5s"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateIAMPolicyAssignment":{"http":{"requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/iam-policy-assignments/"},"input":{"type":"structure","required":["AwsAccountId","AssignmentName","AssignmentStatus","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AssignmentName":{},"AssignmentStatus":{},"PolicyArn":{},"Identities":{"shape":"S5w"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"AssignmentName":{},"AssignmentId":{},"AssignmentStatus":{},"PolicyArn":{},"Identities":{"shape":"S5w"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateIngestion":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}/ingestions/{IngestionId}"},"input":{"type":"structure","required":["DataSetId","IngestionId","AwsAccountId"],"members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"IngestionId":{"location":"uri","locationName":"IngestionId"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"IngestionType":{}}},"output":{"type":"structure","members":{"Arn":{},"IngestionId":{},"IngestionStatus":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateNamespace":{"http":{"requestUri":"/accounts/{AwsAccountId}"},"input":{"type":"structure","required":["AwsAccountId","Namespace","IdentityStore"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{},"IdentityStore":{},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{},"CapacityRegion":{},"CreationStatus":{},"IdentityStore":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateTemplate":{"http":{"requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId","SourceEntity"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"Name":{},"Permissions":{"shape":"S10"},"SourceEntity":{"shape":"S6a"},"Tags":{"shape":"Sb"},"VersionDescription":{}}},"output":{"type":"structure","members":{"Arn":{},"VersionArn":{},"TemplateId":{},"CreationStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"CreateTemplateAlias":{"http":{"requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId","AliasName","TemplateVersionNumber"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"AliasName":{"location":"uri","locationName":"AliasName"},"TemplateVersionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"TemplateAlias":{"shape":"S6i"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"CreateTheme":{"http":{"requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId","Name","BaseThemeId","Configuration"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"Name":{},"BaseThemeId":{},"VersionDescription":{},"Configuration":{"shape":"S6l"},"Permissions":{"shape":"S10"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"VersionArn":{},"ThemeId":{},"CreationStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"CreateThemeAlias":{"http":{"requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId","AliasName","ThemeVersionNumber"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"AliasName":{"location":"uri","locationName":"AliasName"},"ThemeVersionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"ThemeAlias":{"shape":"S70"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DeleteAccountCustomization":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/customizations"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"querystring","locationName":"namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteAnalysis":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/analyses/{AnalysisId}"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"},"RecoveryWindowInDays":{"location":"querystring","locationName":"recovery-window-in-days","type":"long"},"ForceDeleteWithoutRecovery":{"location":"querystring","locationName":"force-delete-without-recovery","type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Arn":{},"AnalysisId":{},"DeletionTime":{"type":"timestamp"},"RequestId":{}}}},"DeleteDashboard":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}"},"input":{"type":"structure","required":["AwsAccountId","DashboardId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"VersionNumber":{"location":"querystring","locationName":"version-number","type":"long"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Arn":{},"DashboardId":{},"RequestId":{}}}},"DeleteDataSet":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}"},"input":{"type":"structure","required":["AwsAccountId","DataSetId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"}}},"output":{"type":"structure","members":{"Arn":{},"DataSetId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteDataSource":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/data-sources/{DataSourceId}"},"input":{"type":"structure","required":["AwsAccountId","DataSourceId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSourceId":{"location":"uri","locationName":"DataSourceId"}}},"output":{"type":"structure","members":{"Arn":{},"DataSourceId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Arn":{},"FolderId":{},"RequestId":{}}}},"DeleteFolderMembership":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}/members/{MemberType}/{MemberId}"},"input":{"type":"structure","required":["AwsAccountId","FolderId","MemberId","MemberType"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"},"MemberId":{"location":"uri","locationName":"MemberId"},"MemberType":{"location":"uri","locationName":"MemberType"}}},"output":{"type":"structure","members":{"Status":{"type":"integer"},"RequestId":{}}}},"DeleteGroup":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteGroupMembership":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members/{MemberName}"},"input":{"type":"structure","required":["MemberName","GroupName","AwsAccountId","Namespace"],"members":{"MemberName":{"location":"uri","locationName":"MemberName"},"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteIAMPolicyAssignment":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespace/{Namespace}/iam-policy-assignments/{AssignmentName}"},"input":{"type":"structure","required":["AwsAccountId","AssignmentName","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AssignmentName":{"location":"uri","locationName":"AssignmentName"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"AssignmentName":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteNamespace":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteTemplate":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"VersionNumber":{"location":"querystring","locationName":"version-number","type":"long"}}},"output":{"type":"structure","members":{"RequestId":{},"Arn":{},"TemplateId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteTemplateAlias":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId","AliasName"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"AliasName":{"location":"uri","locationName":"AliasName"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"TemplateId":{},"AliasName":{},"Arn":{},"RequestId":{}}}},"DeleteTheme":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"VersionNumber":{"location":"querystring","locationName":"version-number","type":"long"}}},"output":{"type":"structure","members":{"Arn":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"},"ThemeId":{}}}},"DeleteThemeAlias":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId","AliasName"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"AliasName":{"location":"uri","locationName":"AliasName"}}},"output":{"type":"structure","members":{"AliasName":{},"Arn":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"},"ThemeId":{}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteUserByPrincipalId":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/user-principals/{PrincipalId}"},"input":{"type":"structure","required":["PrincipalId","AwsAccountId","Namespace"],"members":{"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeAccountCustomization":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/customizations"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"querystring","locationName":"namespace"},"Resolved":{"location":"querystring","locationName":"resolved","type":"boolean"}}},"output":{"type":"structure","members":{"Arn":{},"AwsAccountId":{},"Namespace":{},"AccountCustomization":{"shape":"Sa"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeAccountSettings":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/settings"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"}}},"output":{"type":"structure","members":{"AccountSettings":{"type":"structure","members":{"AccountName":{},"Edition":{},"DefaultNamespace":{},"NotificationEmail":{}}},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeAnalysis":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/analyses/{AnalysisId}"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"}}},"output":{"type":"structure","members":{"Analysis":{"type":"structure","members":{"AnalysisId":{},"Arn":{},"Name":{},"Status":{},"Errors":{"type":"list","member":{"type":"structure","members":{"Type":{},"Message":{}}}},"DataSetArns":{"shape":"S8d"},"ThemeArn":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"Sheets":{"shape":"S8e"}}},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeAnalysisPermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/analyses/{AnalysisId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"}}},"output":{"type":"structure","members":{"AnalysisId":{},"AnalysisArn":{},"Permissions":{"shape":"S10"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeDashboard":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}"},"input":{"type":"structure","required":["AwsAccountId","DashboardId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"VersionNumber":{"location":"querystring","locationName":"version-number","type":"long"},"AliasName":{"location":"querystring","locationName":"alias-name"}}},"output":{"type":"structure","members":{"Dashboard":{"type":"structure","members":{"DashboardId":{},"Arn":{},"Name":{},"Version":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"Errors":{"type":"list","member":{"type":"structure","members":{"Type":{},"Message":{}}}},"VersionNumber":{"type":"long"},"Status":{},"Arn":{},"SourceEntityArn":{},"DataSetArns":{"shape":"S8d"},"Description":{},"ThemeArn":{},"Sheets":{"shape":"S8e"}}},"CreatedTime":{"type":"timestamp"},"LastPublishedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeDashboardPermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","DashboardId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"}}},"output":{"type":"structure","members":{"DashboardId":{},"DashboardArn":{},"Permissions":{"shape":"S10"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{},"LinkSharingConfiguration":{"shape":"S8r"}}}},"DescribeDataSet":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}"},"input":{"type":"structure","required":["AwsAccountId","DataSetId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"}}},"output":{"type":"structure","members":{"DataSet":{"type":"structure","members":{"Arn":{},"DataSetId":{},"Name":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"PhysicalTableMap":{"shape":"S1p"},"LogicalTableMap":{"shape":"S2a"},"OutputColumns":{"type":"list","member":{"type":"structure","members":{"Name":{},"Description":{},"Type":{}}}},"ImportMode":{},"ConsumedSpiceCapacityInBytes":{"type":"long"},"ColumnGroups":{"shape":"S37"},"FieldFolders":{"shape":"S3d"},"RowLevelPermissionDataSet":{"shape":"S3i"},"RowLevelPermissionTagConfiguration":{"shape":"S3m"},"ColumnLevelPermissionRules":{"shape":"S3s"},"DataSetUsageConfiguration":{"shape":"S3w"}}},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeDataSetPermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","DataSetId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"}}},"output":{"type":"structure","members":{"DataSetArn":{},"DataSetId":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeDataSource":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sources/{DataSourceId}"},"input":{"type":"structure","required":["AwsAccountId","DataSourceId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSourceId":{"location":"uri","locationName":"DataSourceId"}}},"output":{"type":"structure","members":{"DataSource":{"shape":"S91"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeDataSourcePermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sources/{DataSourceId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","DataSourceId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSourceId":{"location":"uri","locationName":"DataSourceId"}}},"output":{"type":"structure","members":{"DataSourceArn":{},"DataSourceId":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeFolder":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Folder":{"type":"structure","members":{"FolderId":{},"Arn":{},"Name":{},"FolderType":{},"FolderPath":{"type":"list","member":{}},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"RequestId":{}}}},"DescribeFolderPermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"FolderId":{},"Arn":{},"Permissions":{"shape":"S10"},"RequestId":{}}}},"DescribeFolderResolvedPermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}/resolved-permissions"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"FolderId":{},"Arn":{},"Permissions":{"shape":"S10"},"RequestId":{}}}},"DescribeGroup":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Group":{"shape":"S5o"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeGroupMembership":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members/{MemberName}"},"input":{"type":"structure","required":["MemberName","GroupName","AwsAccountId","Namespace"],"members":{"MemberName":{"location":"uri","locationName":"MemberName"},"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupMember":{"shape":"S5s"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeIAMPolicyAssignment":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/iam-policy-assignments/{AssignmentName}"},"input":{"type":"structure","required":["AwsAccountId","AssignmentName","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AssignmentName":{"location":"uri","locationName":"AssignmentName"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"IAMPolicyAssignment":{"type":"structure","members":{"AwsAccountId":{},"AssignmentId":{},"AssignmentName":{},"PolicyArn":{},"Identities":{"shape":"S5w"},"AssignmentStatus":{}}},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeIngestion":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}/ingestions/{IngestionId}"},"input":{"type":"structure","required":["AwsAccountId","DataSetId","IngestionId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"IngestionId":{"location":"uri","locationName":"IngestionId"}}},"output":{"type":"structure","members":{"Ingestion":{"shape":"S9n"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeIpRestriction":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/ip-restriction"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"}}},"output":{"type":"structure","members":{"AwsAccountId":{},"IpRestrictionRuleMap":{"shape":"S9w"},"Enabled":{"type":"boolean"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeNamespace":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Namespace":{"shape":"Sa2"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeTemplate":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"VersionNumber":{"location":"querystring","locationName":"version-number","type":"long"},"AliasName":{"location":"querystring","locationName":"alias-name"}}},"output":{"type":"structure","members":{"Template":{"type":"structure","members":{"Arn":{},"Name":{},"Version":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"Errors":{"type":"list","member":{"type":"structure","members":{"Type":{},"Message":{}}}},"VersionNumber":{"type":"long"},"Status":{},"DataSetConfigurations":{"type":"list","member":{"type":"structure","members":{"Placeholder":{},"DataSetSchema":{"type":"structure","members":{"ColumnSchemaList":{"type":"list","member":{"type":"structure","members":{"Name":{},"DataType":{},"GeographicRole":{}}}}}},"ColumnGroupSchemaList":{"type":"list","member":{"type":"structure","members":{"Name":{},"ColumnGroupColumnSchemaList":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}}}}},"Description":{},"SourceEntityArn":{},"ThemeArn":{},"Sheets":{"shape":"S8e"}}},"TemplateId":{},"LastUpdatedTime":{"type":"timestamp"},"CreatedTime":{"type":"timestamp"}}},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeTemplateAlias":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId","AliasName"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"AliasName":{"location":"uri","locationName":"AliasName"}}},"output":{"type":"structure","members":{"TemplateAlias":{"shape":"S6i"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeTemplatePermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","TemplateId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"}}},"output":{"type":"structure","members":{"TemplateId":{},"TemplateArn":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeTheme":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"VersionNumber":{"location":"querystring","locationName":"version-number","type":"long"},"AliasName":{"location":"querystring","locationName":"alias-name"}}},"output":{"type":"structure","members":{"Theme":{"type":"structure","members":{"Arn":{},"Name":{},"ThemeId":{},"Version":{"type":"structure","members":{"VersionNumber":{"type":"long"},"Arn":{},"Description":{},"BaseThemeId":{},"CreatedTime":{"type":"timestamp"},"Configuration":{"shape":"S6l"},"Errors":{"type":"list","member":{"type":"structure","members":{"Type":{},"Message":{}}}},"Status":{}}},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"Type":{}}},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeThemeAlias":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId","AliasName"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"AliasName":{"location":"uri","locationName":"AliasName"}}},"output":{"type":"structure","members":{"ThemeAlias":{"shape":"S70"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"DescribeThemePermissions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","ThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"}}},"output":{"type":"structure","members":{"ThemeId":{},"ThemeArn":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"User":{"shape":"Sb4"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"GenerateEmbedUrlForAnonymousUser":{"http":{"requestUri":"/accounts/{AwsAccountId}/embed-url/anonymous-user"},"input":{"type":"structure","required":["AwsAccountId","Namespace","AuthorizedResourceArns","ExperienceConfiguration"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"SessionLifetimeInMinutes":{"type":"long"},"Namespace":{},"SessionTags":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{"shape":"S3r"}}}},"AuthorizedResourceArns":{"type":"list","member":{}},"ExperienceConfiguration":{"type":"structure","members":{"Dashboard":{"type":"structure","required":["InitialDashboardId"],"members":{"InitialDashboardId":{}}}}}}},"output":{"type":"structure","required":["EmbedUrl","Status","RequestId"],"members":{"EmbedUrl":{"shape":"Sbg"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"GenerateEmbedUrlForRegisteredUser":{"http":{"requestUri":"/accounts/{AwsAccountId}/embed-url/registered-user"},"input":{"type":"structure","required":["AwsAccountId","UserArn","ExperienceConfiguration"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"SessionLifetimeInMinutes":{"type":"long"},"UserArn":{},"ExperienceConfiguration":{"type":"structure","members":{"Dashboard":{"type":"structure","required":["InitialDashboardId"],"members":{"InitialDashboardId":{}}},"QuickSightConsole":{"type":"structure","members":{"InitialPath":{}}},"QSearchBar":{"type":"structure","members":{"InitialTopicId":{}}}}}}},"output":{"type":"structure","required":["EmbedUrl","Status","RequestId"],"members":{"EmbedUrl":{"shape":"Sbg"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"GetDashboardEmbedUrl":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}/embed-url"},"input":{"type":"structure","required":["AwsAccountId","DashboardId","IdentityType"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"IdentityType":{"location":"querystring","locationName":"creds-type"},"SessionLifetimeInMinutes":{"location":"querystring","locationName":"session-lifetime","type":"long"},"UndoRedoDisabled":{"location":"querystring","locationName":"undo-redo-disabled","type":"boolean"},"ResetDisabled":{"location":"querystring","locationName":"reset-disabled","type":"boolean"},"StatePersistenceEnabled":{"location":"querystring","locationName":"state-persistence-enabled","type":"boolean"},"UserArn":{"location":"querystring","locationName":"user-arn"},"Namespace":{"location":"querystring","locationName":"namespace"},"AdditionalDashboardIds":{"location":"querystring","locationName":"additional-dashboard-ids","type":"list","member":{}}}},"output":{"type":"structure","members":{"EmbedUrl":{"shape":"Sbg"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"GetSessionEmbedUrl":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/session-embed-url"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"EntryPoint":{"location":"querystring","locationName":"entry-point"},"SessionLifetimeInMinutes":{"location":"querystring","locationName":"session-lifetime","type":"long"},"UserArn":{"location":"querystring","locationName":"user-arn"}}},"output":{"type":"structure","members":{"EmbedUrl":{"shape":"Sbg"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListAnalyses":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/analyses"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"AnalysisSummaryList":{"shape":"Sby"},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListDashboardVersions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}/versions"},"input":{"type":"structure","required":["AwsAccountId","DashboardId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"DashboardVersionSummaryList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedTime":{"type":"timestamp"},"VersionNumber":{"type":"long"},"Status":{},"SourceEntityArn":{},"Description":{}}}},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListDashboards":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/dashboards"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"DashboardSummaryList":{"shape":"Sc6"},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListDataSets":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sets"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"DataSetSummaries":{"type":"list","member":{"type":"structure","members":{"Arn":{},"DataSetId":{},"Name":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"ImportMode":{},"RowLevelPermissionDataSet":{"shape":"S3i"},"RowLevelPermissionTagConfigurationApplied":{"type":"boolean"},"ColumnLevelPermissionRulesApplied":{"type":"boolean"}}}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListDataSources":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sources"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"DataSources":{"type":"list","member":{"shape":"S91"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListFolderMembers":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}/members"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"FolderMemberList":{"type":"list","member":{"type":"structure","members":{"MemberId":{},"MemberArn":{}}}},"NextToken":{},"RequestId":{}}}},"ListFolders":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/folders"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"FolderSummaryList":{"shape":"Scl"},"NextToken":{},"RequestId":{}}}},"ListGroupMemberships":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupMemberList":{"type":"list","member":{"shape":"S5s"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListGroups":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupList":{"shape":"Scs"},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListIAMPolicyAssignments":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/iam-policy-assignments"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AssignmentStatus":{},"Namespace":{"location":"uri","locationName":"Namespace"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"IAMPolicyAssignments":{"type":"list","member":{"type":"structure","members":{"AssignmentName":{},"AssignmentStatus":{}}}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListIAMPolicyAssignmentsForUser":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}/iam-policy-assignments"},"input":{"type":"structure","required":["AwsAccountId","UserName","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"UserName":{"location":"uri","locationName":"UserName"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"ActiveAssignments":{"type":"list","member":{"type":"structure","members":{"AssignmentName":{},"PolicyArn":{}}}},"RequestId":{},"NextToken":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListIngestions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}/ingestions"},"input":{"type":"structure","required":["DataSetId","AwsAccountId"],"members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"NextToken":{"location":"querystring","locationName":"next-token"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Ingestions":{"type":"list","member":{"shape":"S9n"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListNamespaces":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Namespaces":{"type":"list","member":{"shape":"Sa2"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/resources/{ResourceArn}/tags"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sb"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListTemplateAliases":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/aliases"},"input":{"type":"structure","required":["AwsAccountId","TemplateId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-result","type":"integer"}}},"output":{"type":"structure","members":{"TemplateAliasList":{"type":"list","member":{"shape":"S6i"}},"Status":{"location":"statusCode","type":"integer"},"RequestId":{},"NextToken":{}}}},"ListTemplateVersions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/versions"},"input":{"type":"structure","required":["AwsAccountId","TemplateId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"TemplateVersionSummaryList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"VersionNumber":{"type":"long"},"CreatedTime":{"type":"timestamp"},"Status":{},"Description":{}}}},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListTemplates":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/templates"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-result","type":"integer"}}},"output":{"type":"structure","members":{"TemplateSummaryList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"TemplateId":{},"Name":{},"LatestVersionNumber":{"type":"long"},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListThemeAliases":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/aliases"},"input":{"type":"structure","required":["AwsAccountId","ThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-result","type":"integer"}}},"output":{"type":"structure","members":{"ThemeAliasList":{"type":"list","member":{"shape":"S70"}},"Status":{"location":"statusCode","type":"integer"},"RequestId":{},"NextToken":{}}}},"ListThemeVersions":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/versions"},"input":{"type":"structure","required":["AwsAccountId","ThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"ThemeVersionSummaryList":{"type":"list","member":{"type":"structure","members":{"VersionNumber":{"type":"long"},"Arn":{},"Description":{},"CreatedTime":{"type":"timestamp"},"Status":{}}}},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListThemes":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/themes"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Type":{"location":"querystring","locationName":"type"}}},"output":{"type":"structure","members":{"ThemeSummaryList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"ThemeId":{},"LatestVersionNumber":{"type":"long"},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListUserGroups":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}/groups"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"GroupList":{"shape":"Scs"},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"UserList":{"type":"list","member":{"shape":"Sb4"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"RegisterUser":{"http":{"requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users"},"input":{"type":"structure","required":["IdentityType","Email","UserRole","AwsAccountId","Namespace"],"members":{"IdentityType":{},"Email":{},"UserRole":{},"IamArn":{},"SessionName":{},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"},"UserName":{},"CustomPermissionsName":{},"ExternalLoginFederationProviderType":{},"CustomFederationProviderUrl":{},"ExternalLoginId":{}}},"output":{"type":"structure","members":{"User":{"shape":"Sb4"},"UserInvitationUrl":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"RestoreAnalysis":{"http":{"requestUri":"/accounts/{AwsAccountId}/restore/analyses/{AnalysisId}"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Arn":{},"AnalysisId":{},"RequestId":{}}}},"SearchAnalyses":{"http":{"requestUri":"/accounts/{AwsAccountId}/search/analyses"},"input":{"type":"structure","required":["AwsAccountId","Filters"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Filters":{"type":"list","member":{"type":"structure","members":{"Operator":{},"Name":{},"Value":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AnalysisSummaryList":{"shape":"Sby"},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"SearchDashboards":{"http":{"requestUri":"/accounts/{AwsAccountId}/search/dashboards"},"input":{"type":"structure","required":["AwsAccountId","Filters"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Filters":{"type":"list","member":{"type":"structure","required":["Operator"],"members":{"Operator":{},"Name":{},"Value":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DashboardSummaryList":{"shape":"Sc6"},"NextToken":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"SearchFolders":{"http":{"requestUri":"/accounts/{AwsAccountId}/search/folders"},"input":{"type":"structure","required":["AwsAccountId","Filters"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Filters":{"type":"list","member":{"type":"structure","members":{"Operator":{},"Name":{},"Value":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"FolderSummaryList":{"shape":"Scl"},"NextToken":{},"RequestId":{}}}},"SearchGroups":{"http":{"requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups-search"},"input":{"type":"structure","required":["AwsAccountId","Namespace","Filters"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Namespace":{"location":"uri","locationName":"Namespace"},"Filters":{"type":"list","member":{"type":"structure","required":["Operator","Name","Value"],"members":{"Operator":{},"Name":{},"Value":{}}}}}},"output":{"type":"structure","members":{"GroupList":{"shape":"Scs"},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"TagResource":{"http":{"requestUri":"/resources/{ResourceArn}/tags"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/resources/{ResourceArn}/tags"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"keys","type":"list","member":{}}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateAccountCustomization":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/customizations"},"input":{"type":"structure","required":["AwsAccountId","AccountCustomization"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"querystring","locationName":"namespace"},"AccountCustomization":{"shape":"Sa"}}},"output":{"type":"structure","members":{"Arn":{},"AwsAccountId":{},"Namespace":{},"AccountCustomization":{"shape":"Sa"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateAccountSettings":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/settings"},"input":{"type":"structure","required":["AwsAccountId","DefaultNamespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DefaultNamespace":{},"NotificationEmail":{}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateAnalysis":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/analyses/{AnalysisId}"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId","Name","SourceEntity"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"},"Name":{},"Parameters":{"shape":"Sj"},"SourceEntity":{"shape":"S14"},"ThemeArn":{}}},"output":{"type":"structure","members":{"Arn":{},"AnalysisId":{},"UpdateStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"UpdateAnalysisPermissions":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/analyses/{AnalysisId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","AnalysisId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AnalysisId":{"location":"uri","locationName":"AnalysisId"},"GrantPermissions":{"shape":"Sf4"},"RevokePermissions":{"shape":"Sf4"}}},"output":{"type":"structure","members":{"AnalysisArn":{},"AnalysisId":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateDashboard":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}"},"input":{"type":"structure","required":["AwsAccountId","DashboardId","Name","SourceEntity"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"Name":{},"SourceEntity":{"shape":"S1c"},"Parameters":{"shape":"Sj"},"VersionDescription":{},"DashboardPublishOptions":{"shape":"S1f"},"ThemeArn":{}}},"output":{"type":"structure","members":{"Arn":{},"VersionArn":{},"DashboardId":{},"CreationStatus":{},"Status":{"type":"integer"},"RequestId":{}}}},"UpdateDashboardPermissions":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","DashboardId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"GrantPermissions":{"shape":"Sf4"},"RevokePermissions":{"shape":"Sf4"},"GrantLinkPermissions":{"shape":"Sf9"},"RevokeLinkPermissions":{"shape":"Sf9"}}},"output":{"type":"structure","members":{"DashboardArn":{},"DashboardId":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"},"LinkSharingConfiguration":{"shape":"S8r"}}}},"UpdateDashboardPublishedVersion":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}/versions/{VersionNumber}"},"input":{"type":"structure","required":["AwsAccountId","DashboardId","VersionNumber"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"type":"structure","members":{"DashboardId":{},"DashboardArn":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"UpdateDataSet":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}"},"input":{"type":"structure","required":["AwsAccountId","DataSetId","Name","PhysicalTableMap","ImportMode"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"Name":{},"PhysicalTableMap":{"shape":"S1p"},"LogicalTableMap":{"shape":"S2a"},"ImportMode":{},"ColumnGroups":{"shape":"S37"},"FieldFolders":{"shape":"S3d"},"RowLevelPermissionDataSet":{"shape":"S3i"},"RowLevelPermissionTagConfiguration":{"shape":"S3m"},"ColumnLevelPermissionRules":{"shape":"S3s"},"DataSetUsageConfiguration":{"shape":"S3w"}}},"output":{"type":"structure","members":{"Arn":{},"DataSetId":{},"IngestionArn":{},"IngestionId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateDataSetPermissions":{"http":{"requestUri":"/accounts/{AwsAccountId}/data-sets/{DataSetId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","DataSetId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"GrantPermissions":{"shape":"S10"},"RevokePermissions":{"shape":"S10"}}},"output":{"type":"structure","members":{"DataSetArn":{},"DataSetId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateDataSource":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/data-sources/{DataSourceId}"},"input":{"type":"structure","required":["AwsAccountId","DataSourceId","Name"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSourceId":{"location":"uri","locationName":"DataSourceId"},"Name":{},"DataSourceParameters":{"shape":"S40"},"Credentials":{"shape":"S53"},"VpcConnectionProperties":{"shape":"S59"},"SslProperties":{"shape":"S5a"}}},"output":{"type":"structure","members":{"Arn":{},"DataSourceId":{},"UpdateStatus":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateDataSourcePermissions":{"http":{"requestUri":"/accounts/{AwsAccountId}/data-sources/{DataSourceId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","DataSourceId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DataSourceId":{"location":"uri","locationName":"DataSourceId"},"GrantPermissions":{"shape":"S10"},"RevokePermissions":{"shape":"S10"}}},"output":{"type":"structure","members":{"DataSourceArn":{},"DataSourceId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateFolder":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}"},"input":{"type":"structure","required":["AwsAccountId","FolderId","Name"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{}}},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"},"Arn":{},"FolderId":{},"RequestId":{}}}},"UpdateFolderPermissions":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/folders/{FolderId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","FolderId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"FolderId":{"location":"uri","locationName":"FolderId"},"GrantPermissions":{"shape":"S10"},"RevokePermissions":{"shape":"S10"}}},"output":{"type":"structure","members":{"Status":{"type":"integer"},"Arn":{},"FolderId":{},"Permissions":{"shape":"S10"},"RequestId":{}}}},"UpdateGroup":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"Description":{},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Group":{"shape":"S5o"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateIAMPolicyAssignment":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/iam-policy-assignments/{AssignmentName}"},"input":{"type":"structure","required":["AwsAccountId","AssignmentName","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"AssignmentName":{"location":"uri","locationName":"AssignmentName"},"Namespace":{"location":"uri","locationName":"Namespace"},"AssignmentStatus":{},"PolicyArn":{},"Identities":{"shape":"S5w"}}},"output":{"type":"structure","members":{"AssignmentName":{},"AssignmentId":{},"PolicyArn":{},"Identities":{"shape":"S5w"},"AssignmentStatus":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateIpRestriction":{"http":{"requestUri":"/accounts/{AwsAccountId}/ip-restriction"},"input":{"type":"structure","required":["AwsAccountId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"IpRestrictionRuleMap":{"shape":"S9w"},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"AwsAccountId":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateTemplate":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId","SourceEntity"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"SourceEntity":{"shape":"S6a"},"VersionDescription":{},"Name":{}}},"output":{"type":"structure","members":{"TemplateId":{},"Arn":{},"VersionArn":{},"CreationStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"UpdateTemplateAlias":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","TemplateId","AliasName","TemplateVersionNumber"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"AliasName":{"location":"uri","locationName":"AliasName"},"TemplateVersionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"TemplateAlias":{"shape":"S6i"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"UpdateTemplatePermissions":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/templates/{TemplateId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","TemplateId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"TemplateId":{"location":"uri","locationName":"TemplateId"},"GrantPermissions":{"shape":"Sf4"},"RevokePermissions":{"shape":"Sf4"}}},"output":{"type":"structure","members":{"TemplateId":{},"TemplateArn":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateTheme":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId","BaseThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"Name":{},"BaseThemeId":{},"VersionDescription":{},"Configuration":{"shape":"S6l"}}},"output":{"type":"structure","members":{"ThemeId":{},"Arn":{},"VersionArn":{},"CreationStatus":{},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"UpdateThemeAlias":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/aliases/{AliasName}"},"input":{"type":"structure","required":["AwsAccountId","ThemeId","AliasName","ThemeVersionNumber"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"AliasName":{"location":"uri","locationName":"AliasName"},"ThemeVersionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"ThemeAlias":{"shape":"S70"},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"UpdateThemePermissions":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/themes/{ThemeId}/permissions"},"input":{"type":"structure","required":["AwsAccountId","ThemeId"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"ThemeId":{"location":"uri","locationName":"ThemeId"},"GrantPermissions":{"shape":"Sf4"},"RevokePermissions":{"shape":"Sf4"}}},"output":{"type":"structure","members":{"ThemeId":{},"ThemeArn":{},"Permissions":{"shape":"S10"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateUser":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace","Email","Role"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"},"Email":{},"Role":{},"CustomPermissionsName":{},"UnapplyCustomPermissions":{"type":"boolean"},"ExternalLoginFederationProviderType":{},"CustomFederationProviderUrl":{},"ExternalLoginId":{}}},"output":{"type":"structure","members":{"User":{"shape":"Sb4"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}}},"shapes":{"Sa":{"type":"structure","members":{"DefaultTheme":{},"DefaultEmailCustomizationTemplate":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sj":{"type":"structure","members":{"StringParameters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"IntegerParameters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"type":"long"}}}}},"DecimalParameters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"type":"double"}}}}},"DateTimeParameters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"type":"timestamp"}}}}}}},"S10":{"type":"list","member":{"shape":"S11"}},"S11":{"type":"structure","required":["Principal","Actions"],"members":{"Principal":{},"Actions":{"type":"list","member":{}}}},"S14":{"type":"structure","members":{"SourceTemplate":{"type":"structure","required":["DataSetReferences","Arn"],"members":{"DataSetReferences":{"shape":"S16"},"Arn":{}}}}},"S16":{"type":"list","member":{"type":"structure","required":["DataSetPlaceholder","DataSetArn"],"members":{"DataSetPlaceholder":{},"DataSetArn":{}}}},"S1c":{"type":"structure","members":{"SourceTemplate":{"type":"structure","required":["DataSetReferences","Arn"],"members":{"DataSetReferences":{"shape":"S16"},"Arn":{}}}}},"S1f":{"type":"structure","members":{"AdHocFilteringOption":{"type":"structure","members":{"AvailabilityStatus":{}}},"ExportToCSVOption":{"type":"structure","members":{"AvailabilityStatus":{}}},"SheetControlsOption":{"type":"structure","members":{"VisibilityState":{}}}}},"S1p":{"type":"map","key":{},"value":{"type":"structure","members":{"RelationalTable":{"type":"structure","required":["DataSourceArn","Name","InputColumns"],"members":{"DataSourceArn":{},"Catalog":{},"Schema":{},"Name":{},"InputColumns":{"shape":"S1w"}}},"CustomSql":{"type":"structure","required":["DataSourceArn","Name","SqlQuery"],"members":{"DataSourceArn":{},"Name":{},"SqlQuery":{},"Columns":{"shape":"S1w"}}},"S3Source":{"type":"structure","required":["DataSourceArn","InputColumns"],"members":{"DataSourceArn":{},"UploadSettings":{"type":"structure","members":{"Format":{},"StartFromRow":{"type":"integer"},"ContainsHeader":{"type":"boolean"},"TextQualifier":{},"Delimiter":{}}},"InputColumns":{"shape":"S1w"}}}}}},"S1w":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{}}}},"S2a":{"type":"map","key":{},"value":{"type":"structure","required":["Alias","Source"],"members":{"Alias":{},"DataTransforms":{"type":"list","member":{"type":"structure","members":{"ProjectOperation":{"type":"structure","required":["ProjectedColumns"],"members":{"ProjectedColumns":{"type":"list","member":{}}}},"FilterOperation":{"type":"structure","required":["ConditionExpression"],"members":{"ConditionExpression":{}}},"CreateColumnsOperation":{"type":"structure","required":["Columns"],"members":{"Columns":{"type":"list","member":{"type":"structure","required":["ColumnName","ColumnId","Expression"],"members":{"ColumnName":{},"ColumnId":{},"Expression":{}}}}}},"RenameColumnOperation":{"type":"structure","required":["ColumnName","NewColumnName"],"members":{"ColumnName":{},"NewColumnName":{}}},"CastColumnTypeOperation":{"type":"structure","required":["ColumnName","NewColumnType"],"members":{"ColumnName":{},"NewColumnType":{},"Format":{}}},"TagColumnOperation":{"type":"structure","required":["ColumnName","Tags"],"members":{"ColumnName":{},"Tags":{"type":"list","member":{"type":"structure","members":{"ColumnGeographicRole":{},"ColumnDescription":{"type":"structure","members":{"Text":{}}}}}}}},"UntagColumnOperation":{"type":"structure","required":["ColumnName","TagNames"],"members":{"ColumnName":{},"TagNames":{"type":"list","member":{}}}}}}},"Source":{"type":"structure","members":{"JoinInstruction":{"type":"structure","required":["LeftOperand","RightOperand","Type","OnClause"],"members":{"LeftOperand":{},"RightOperand":{},"LeftJoinKeyProperties":{"shape":"S33"},"RightJoinKeyProperties":{"shape":"S33"},"Type":{},"OnClause":{}}},"PhysicalTableId":{},"DataSetArn":{}}}}}},"S33":{"type":"structure","members":{"UniqueKey":{"type":"boolean"}}},"S37":{"type":"list","member":{"type":"structure","members":{"GeoSpatialColumnGroup":{"type":"structure","required":["Name","CountryCode","Columns"],"members":{"Name":{},"CountryCode":{},"Columns":{"type":"list","member":{}}}}}}},"S3d":{"type":"map","key":{},"value":{"type":"structure","members":{"description":{},"columns":{"type":"list","member":{}}}}},"S3i":{"type":"structure","required":["Arn","PermissionPolicy"],"members":{"Namespace":{},"Arn":{},"PermissionPolicy":{},"FormatVersion":{},"Status":{}}},"S3m":{"type":"structure","required":["TagRules"],"members":{"Status":{},"TagRules":{"type":"list","member":{"type":"structure","required":["TagKey","ColumnName"],"members":{"TagKey":{},"ColumnName":{},"TagMultiValueDelimiter":{},"MatchAllValue":{"shape":"S3r"}}}}}},"S3r":{"type":"string","sensitive":true},"S3s":{"type":"list","member":{"type":"structure","members":{"Principals":{"type":"list","member":{}},"ColumnNames":{"type":"list","member":{}}}}},"S3w":{"type":"structure","members":{"DisableUseAsDirectQuerySource":{"type":"boolean"},"DisableUseAsImportedSource":{"type":"boolean"}}},"S40":{"type":"structure","members":{"AmazonElasticsearchParameters":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"AthenaParameters":{"type":"structure","members":{"WorkGroup":{}}},"AuroraParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"AuroraPostgreSqlParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"AwsIotAnalyticsParameters":{"type":"structure","required":["DataSetName"],"members":{"DataSetName":{}}},"JiraParameters":{"type":"structure","required":["SiteBaseUrl"],"members":{"SiteBaseUrl":{}}},"MariaDbParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"MySqlParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"OracleParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"PostgreSqlParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"PrestoParameters":{"type":"structure","required":["Host","Port","Catalog"],"members":{"Host":{},"Port":{"type":"integer"},"Catalog":{}}},"RdsParameters":{"type":"structure","required":["InstanceId","Database"],"members":{"InstanceId":{},"Database":{}}},"RedshiftParameters":{"type":"structure","required":["Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{},"ClusterId":{}}},"S3Parameters":{"type":"structure","required":["ManifestFileLocation"],"members":{"ManifestFileLocation":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{},"Key":{}}}}},"ServiceNowParameters":{"type":"structure","required":["SiteBaseUrl"],"members":{"SiteBaseUrl":{}}},"SnowflakeParameters":{"type":"structure","required":["Host","Database","Warehouse"],"members":{"Host":{},"Database":{},"Warehouse":{}}},"SparkParameters":{"type":"structure","required":["Host","Port"],"members":{"Host":{},"Port":{"type":"integer"}}},"SqlServerParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"TeradataParameters":{"type":"structure","required":["Host","Port","Database"],"members":{"Host":{},"Port":{"type":"integer"},"Database":{}}},"TwitterParameters":{"type":"structure","required":["Query","MaxRows"],"members":{"Query":{},"MaxRows":{"type":"integer"}}},"AmazonOpenSearchParameters":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"ExasolParameters":{"type":"structure","required":["Host","Port"],"members":{"Host":{},"Port":{"type":"integer"}}}}},"S53":{"type":"structure","members":{"CredentialPair":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{},"AlternateDataSourceParameters":{"shape":"S57"}}},"CopySourceArn":{}},"sensitive":true},"S57":{"type":"list","member":{"shape":"S40"}},"S59":{"type":"structure","required":["VpcConnectionArn"],"members":{"VpcConnectionArn":{}}},"S5a":{"type":"structure","members":{"DisableSsl":{"type":"boolean"}}},"S5o":{"type":"structure","members":{"Arn":{},"GroupName":{},"Description":{},"PrincipalId":{}}},"S5s":{"type":"structure","members":{"Arn":{},"MemberName":{}}},"S5w":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S6a":{"type":"structure","members":{"SourceAnalysis":{"type":"structure","required":["Arn","DataSetReferences"],"members":{"Arn":{},"DataSetReferences":{"shape":"S16"}}},"SourceTemplate":{"type":"structure","required":["Arn"],"members":{"Arn":{}}}}},"S6i":{"type":"structure","members":{"AliasName":{},"Arn":{},"TemplateVersionNumber":{"type":"long"}}},"S6l":{"type":"structure","members":{"DataColorPalette":{"type":"structure","members":{"Colors":{"shape":"S6n"},"MinMaxGradient":{"shape":"S6n"},"EmptyFillColor":{}}},"UIColorPalette":{"type":"structure","members":{"PrimaryForeground":{},"PrimaryBackground":{},"SecondaryForeground":{},"SecondaryBackground":{},"Accent":{},"AccentForeground":{},"Danger":{},"DangerForeground":{},"Warning":{},"WarningForeground":{},"Success":{},"SuccessForeground":{},"Dimension":{},"DimensionForeground":{},"Measure":{},"MeasureForeground":{}}},"Sheet":{"type":"structure","members":{"Tile":{"type":"structure","members":{"Border":{"type":"structure","members":{"Show":{"type":"boolean"}}}}},"TileLayout":{"type":"structure","members":{"Gutter":{"type":"structure","members":{"Show":{"type":"boolean"}}},"Margin":{"type":"structure","members":{"Show":{"type":"boolean"}}}}}}}}},"S6n":{"type":"list","member":{}},"S70":{"type":"structure","members":{"Arn":{},"AliasName":{},"ThemeVersionNumber":{"type":"long"}}},"S8d":{"type":"list","member":{}},"S8e":{"type":"list","member":{"type":"structure","members":{"SheetId":{},"Name":{}}}},"S8r":{"type":"structure","members":{"Permissions":{"shape":"S10"}}},"S91":{"type":"structure","members":{"Arn":{},"DataSourceId":{},"Name":{},"Type":{},"Status":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DataSourceParameters":{"shape":"S40"},"AlternateDataSourceParameters":{"shape":"S57"},"VpcConnectionProperties":{"shape":"S59"},"SslProperties":{"shape":"S5a"},"ErrorInfo":{"type":"structure","members":{"Type":{},"Message":{}}}}},"S9n":{"type":"structure","required":["Arn","IngestionStatus","CreatedTime"],"members":{"Arn":{},"IngestionId":{},"IngestionStatus":{},"ErrorInfo":{"type":"structure","members":{"Type":{},"Message":{}}},"RowInfo":{"type":"structure","members":{"RowsIngested":{"type":"long"},"RowsDropped":{"type":"long"},"TotalRowsInDataset":{"type":"long"}}},"QueueInfo":{"type":"structure","required":["WaitingOnIngestion","QueuedIngestion"],"members":{"WaitingOnIngestion":{},"QueuedIngestion":{}}},"CreatedTime":{"type":"timestamp"},"IngestionTimeInSeconds":{"type":"long"},"IngestionSizeInBytes":{"type":"long"},"RequestSource":{},"RequestType":{}}},"S9w":{"type":"map","key":{},"value":{}},"Sa2":{"type":"structure","members":{"Name":{},"Arn":{},"CapacityRegion":{},"CreationStatus":{},"IdentityStore":{},"NamespaceError":{"type":"structure","members":{"Type":{},"Message":{}}}}},"Sb4":{"type":"structure","members":{"Arn":{},"UserName":{},"Email":{},"Role":{},"IdentityType":{},"Active":{"type":"boolean"},"PrincipalId":{},"CustomPermissionsName":{},"ExternalLoginFederationProviderType":{},"ExternalLoginFederationProviderUrl":{},"ExternalLoginId":{}}},"Sbg":{"type":"string","sensitive":true},"Sby":{"type":"list","member":{"type":"structure","members":{"Arn":{},"AnalysisId":{},"Name":{},"Status":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"Sc6":{"type":"list","member":{"type":"structure","members":{"Arn":{},"DashboardId":{},"Name":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"PublishedVersionNumber":{"type":"long"},"LastPublishedTime":{"type":"timestamp"}}}},"Scl":{"type":"list","member":{"type":"structure","members":{"Arn":{},"FolderId":{},"Name":{},"FolderType":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"Scs":{"type":"list","member":{"shape":"S5o"}},"Sf4":{"type":"list","member":{"shape":"S11"}},"Sf9":{"type":"list","member":{"shape":"S11"}}}}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAnalyses":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AnalysisSummaryList"},"ListDashboardVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DashboardVersionSummaryList"},"ListDashboards":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DashboardSummaryList"},"ListDataSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DataSetSummaries"},"ListDataSources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DataSources"},"ListIngestions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Ingestions"},"ListNamespaces":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Namespaces"},"ListTemplateAliases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TemplateAliasList"},"ListTemplateVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TemplateVersionSummaryList"},"ListTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TemplateSummaryList"},"ListThemeVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ThemeVersionSummaryList"},"ListThemes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ThemeSummaryList"},"SearchAnalyses":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AnalysisSummaryList"},"SearchDashboards":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DashboardSummaryList"}}}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['rdsdataservice'] = {};
	AWS.RDSDataService = Service.defineService('rdsdataservice', ['2018-08-01']);
	__webpack_require__(664);
	Object.defineProperty(apiLoader.services['rdsdataservice'], '2018-08-01', {
	  get: function get() {
	    var model = __webpack_require__(665);
	    model.paginators = __webpack_require__(666).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.RDSDataService;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.RDSDataService.prototype, {
	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (error.code === 'BadRequestException' &&
	      error.message &&
	      error.message.match(/^Communications link failure/) &&
	      error.statusCode === 400) {
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error);
	    }
	  }
	});


/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-08-01","endpointPrefix":"rds-data","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS RDS DataService","serviceId":"RDS Data","signatureVersion":"v4","signingName":"rds-data","uid":"rds-data-2018-08-01"},"operations":{"BatchExecuteStatement":{"http":{"requestUri":"/BatchExecute","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","sql"],"members":{"database":{},"parameterSets":{"type":"list","member":{"shape":"S4"}},"resourceArn":{},"schema":{},"secretArn":{},"sql":{},"transactionId":{}}},"output":{"type":"structure","members":{"updateResults":{"type":"list","member":{"type":"structure","members":{"generatedFields":{"shape":"Sq"}}}}}}},"BeginTransaction":{"http":{"requestUri":"/BeginTransaction","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn"],"members":{"database":{},"resourceArn":{},"schema":{},"secretArn":{}}},"output":{"type":"structure","members":{"transactionId":{}}}},"CommitTransaction":{"http":{"requestUri":"/CommitTransaction","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","transactionId"],"members":{"resourceArn":{},"secretArn":{},"transactionId":{}}},"output":{"type":"structure","members":{"transactionStatus":{}}}},"ExecuteSql":{"http":{"requestUri":"/ExecuteSql","responseCode":200},"input":{"type":"structure","required":["awsSecretStoreArn","dbClusterOrInstanceArn","sqlStatements"],"members":{"awsSecretStoreArn":{},"database":{},"dbClusterOrInstanceArn":{},"schema":{},"sqlStatements":{}}},"output":{"type":"structure","members":{"sqlStatementResults":{"type":"list","member":{"type":"structure","members":{"numberOfRecordsUpdated":{"type":"long"},"resultFrame":{"type":"structure","members":{"records":{"type":"list","member":{"type":"structure","members":{"values":{"type":"list","member":{"shape":"S15"}}}}},"resultSetMetadata":{"type":"structure","members":{"columnCount":{"type":"long"},"columnMetadata":{"shape":"S1c"}}}}}}}}}},"deprecated":true,"deprecatedMessage":"The ExecuteSql API is deprecated, please use the ExecuteStatement API."},"ExecuteStatement":{"http":{"requestUri":"/Execute","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","sql"],"members":{"continueAfterTimeout":{"type":"boolean"},"database":{},"formatRecordsAs":{},"includeResultMetadata":{"type":"boolean"},"parameters":{"shape":"S4"},"resourceArn":{},"resultSetOptions":{"type":"structure","members":{"decimalReturnType":{},"longReturnType":{}}},"schema":{},"secretArn":{},"sql":{},"transactionId":{}}},"output":{"type":"structure","members":{"columnMetadata":{"shape":"S1c"},"formattedRecords":{},"generatedFields":{"shape":"Sq"},"numberOfRecordsUpdated":{"type":"long"},"records":{"type":"list","member":{"shape":"Sq"}}}}},"RollbackTransaction":{"http":{"requestUri":"/RollbackTransaction","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","transactionId"],"members":{"resourceArn":{},"secretArn":{},"transactionId":{}}},"output":{"type":"structure","members":{"transactionStatus":{}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"name":{},"typeHint":{},"value":{"shape":"S8"}}}},"S8":{"type":"structure","members":{"arrayValue":{"shape":"S9"},"blobValue":{"type":"blob"},"booleanValue":{"type":"boolean"},"doubleValue":{"type":"double"},"isNull":{"type":"boolean"},"longValue":{"type":"long"},"stringValue":{}},"union":true},"S9":{"type":"structure","members":{"arrayValues":{"type":"list","member":{"shape":"S9"}},"booleanValues":{"type":"list","member":{"type":"boolean"}},"doubleValues":{"type":"list","member":{"type":"double"}},"longValues":{"type":"list","member":{"type":"long"}},"stringValues":{"type":"list","member":{}}},"union":true},"Sq":{"type":"list","member":{"shape":"S8"}},"S15":{"type":"structure","members":{"arrayValues":{"shape":"S16"},"bigIntValue":{"type":"long"},"bitValue":{"type":"boolean"},"blobValue":{"type":"blob"},"doubleValue":{"type":"double"},"intValue":{"type":"integer"},"isNull":{"type":"boolean"},"realValue":{"type":"float"},"stringValue":{},"structValue":{"type":"structure","members":{"attributes":{"shape":"S16"}}}},"union":true},"S16":{"type":"list","member":{"shape":"S15"}},"S1c":{"type":"list","member":{"type":"structure","members":{"arrayBaseColumnType":{"type":"integer"},"isAutoIncrement":{"type":"boolean"},"isCaseSensitive":{"type":"boolean"},"isCurrency":{"type":"boolean"},"isSigned":{"type":"boolean"},"label":{},"name":{},"nullable":{"type":"integer"},"precision":{"type":"integer"},"scale":{"type":"integer"},"schemaName":{},"tableName":{},"type":{"type":"integer"},"typeName":{}}}}}}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['amplify'] = {};
	AWS.Amplify = Service.defineService('amplify', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['amplify'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(668);
	    model.paginators = __webpack_require__(669).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Amplify;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"amplify","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amplify","serviceFullName":"AWS Amplify","serviceId":"Amplify","signatureVersion":"v4","signingName":"amplify","uid":"amplify-2017-07-25"},"operations":{"CreateApp":{"http":{"requestUri":"/apps"},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"repository":{},"platform":{},"iamServiceRoleArn":{},"oauthToken":{"shape":"S7"},"accessToken":{"shape":"S8"},"environmentVariables":{"shape":"S9"},"enableBranchAutoBuild":{"type":"boolean"},"enableBranchAutoDeletion":{"type":"boolean"},"enableBasicAuth":{"type":"boolean"},"basicAuthCredentials":{"shape":"Sf"},"customRules":{"shape":"Sg"},"tags":{"shape":"Sm"},"buildSpec":{"shape":"Sp"},"customHeaders":{},"enableAutoBranchCreation":{"type":"boolean"},"autoBranchCreationPatterns":{"shape":"Ss"},"autoBranchCreationConfig":{"shape":"Su"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"S12"}}}},"CreateBackendEnvironment":{"http":{"requestUri":"/apps/{appId}/backendenvironments"},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{},"stackName":{},"deploymentArtifacts":{}}},"output":{"type":"structure","required":["backendEnvironment"],"members":{"backendEnvironment":{"shape":"S1i"}}}},"CreateBranch":{"http":{"requestUri":"/apps/{appId}/branches"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{},"description":{},"stage":{},"framework":{},"enableNotification":{"type":"boolean"},"enableAutoBuild":{"type":"boolean"},"environmentVariables":{"shape":"S9"},"basicAuthCredentials":{"shape":"Sf"},"enableBasicAuth":{"type":"boolean"},"enablePerformanceMode":{"type":"boolean"},"tags":{"shape":"Sm"},"buildSpec":{"shape":"Sp"},"ttl":{},"displayName":{},"enablePullRequestPreview":{"type":"boolean"},"pullRequestEnvironmentName":{},"backendEnvironmentArn":{}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1p"}}}},"CreateDeployment":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}/deployments"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"fileMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","required":["fileUploadUrls","zipUploadUrl"],"members":{"jobId":{},"fileUploadUrls":{"type":"map","key":{},"value":{}},"zipUploadUrl":{}}}},"CreateDomainAssociation":{"http":{"requestUri":"/apps/{appId}/domains"},"input":{"type":"structure","required":["appId","domainName","subDomainSettings"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{},"enableAutoSubDomain":{"type":"boolean"},"subDomainSettings":{"shape":"S28"},"autoSubDomainCreationPatterns":{"shape":"S2b"},"autoSubDomainIAMRole":{}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S2f"}}}},"CreateWebhook":{"http":{"requestUri":"/apps/{appId}/webhooks"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{},"description":{}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2q"}}}},"DeleteApp":{"http":{"method":"DELETE","requestUri":"/apps/{appId}"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"S12"}}}},"DeleteBackendEnvironment":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/backendenvironments/{environmentName}"},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"}}},"output":{"type":"structure","required":["backendEnvironment"],"members":{"backendEnvironment":{"shape":"S1i"}}}},"DeleteBranch":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/branches/{branchName}"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1p"}}}},"DeleteDomainAssociation":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/domains/{domainName}"},"input":{"type":"structure","required":["appId","domainName"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S2f"}}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S34"}}}},"DeleteWebhook":{"http":{"method":"DELETE","requestUri":"/webhooks/{webhookId}"},"input":{"type":"structure","required":["webhookId"],"members":{"webhookId":{"location":"uri","locationName":"webhookId"}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2q"}}}},"GenerateAccessLogs":{"http":{"requestUri":"/apps/{appId}/accesslogs"},"input":{"type":"structure","required":["domainName","appId"],"members":{"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"domainName":{},"appId":{"location":"uri","locationName":"appId"}}},"output":{"type":"structure","members":{"logUrl":{}}}},"GetApp":{"http":{"method":"GET","requestUri":"/apps/{appId}"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"S12"}}}},"GetArtifactUrl":{"http":{"method":"GET","requestUri":"/artifacts/{artifactId}"},"input":{"type":"structure","required":["artifactId"],"members":{"artifactId":{"location":"uri","locationName":"artifactId"}}},"output":{"type":"structure","required":["artifactId","artifactUrl"],"members":{"artifactId":{},"artifactUrl":{}}}},"GetBackendEnvironment":{"http":{"method":"GET","requestUri":"/apps/{appId}/backendenvironments/{environmentName}"},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"}}},"output":{"type":"structure","required":["backendEnvironment"],"members":{"backendEnvironment":{"shape":"S1i"}}}},"GetBranch":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1p"}}}},"GetDomainAssociation":{"http":{"method":"GET","requestUri":"/apps/{appId}/domains/{domainName}"},"input":{"type":"structure","required":["appId","domainName"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S2f"}}}},"GetJob":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["job"],"members":{"job":{"type":"structure","required":["summary","steps"],"members":{"summary":{"shape":"S34"},"steps":{"type":"list","member":{"type":"structure","required":["stepName","startTime","status","endTime"],"members":{"stepName":{},"startTime":{"type":"timestamp"},"status":{},"endTime":{"type":"timestamp"},"logUrl":{},"artifactsUrl":{},"testArtifactsUrl":{},"testConfigUrl":{},"screenshots":{"type":"map","key":{},"value":{}},"statusReason":{},"context":{}}}}}}}}},"GetWebhook":{"http":{"method":"GET","requestUri":"/webhooks/{webhookId}"},"input":{"type":"structure","required":["webhookId"],"members":{"webhookId":{"location":"uri","locationName":"webhookId"}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2q"}}}},"ListApps":{"http":{"method":"GET","requestUri":"/apps"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["apps"],"members":{"apps":{"type":"list","member":{"shape":"S12"}},"nextToken":{}}}},"ListArtifacts":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}/artifacts"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["artifacts"],"members":{"artifacts":{"type":"list","member":{"type":"structure","required":["artifactFileName","artifactId"],"members":{"artifactFileName":{},"artifactId":{}}}},"nextToken":{}}}},"ListBackendEnvironments":{"http":{"method":"GET","requestUri":"/apps/{appId}/backendenvironments"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"querystring","locationName":"environmentName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["backendEnvironments"],"members":{"backendEnvironments":{"type":"list","member":{"shape":"S1i"}},"nextToken":{}}}},"ListBranches":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["branches"],"members":{"branches":{"type":"list","member":{"shape":"S1p"}},"nextToken":{}}}},"ListDomainAssociations":{"http":{"method":"GET","requestUri":"/apps/{appId}/domains"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["domainAssociations"],"members":{"domainAssociations":{"type":"list","member":{"shape":"S2f"}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}/jobs"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["jobSummaries"],"members":{"jobSummaries":{"type":"list","member":{"shape":"S34"}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sm"}}}},"ListWebhooks":{"http":{"method":"GET","requestUri":"/apps/{appId}/webhooks"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["webhooks"],"members":{"webhooks":{"type":"list","member":{"shape":"S2q"}},"nextToken":{}}}},"StartDeployment":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}/deployments/start"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{},"sourceUrl":{}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S34"}}}},"StartJob":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}/jobs"},"input":{"type":"structure","required":["appId","branchName","jobType"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{},"jobType":{},"jobReason":{},"commitId":{},"commitMessage":{},"commitTime":{"type":"timestamp"}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S34"}}}},"StopJob":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}/stop"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S34"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApp":{"http":{"requestUri":"/apps/{appId}"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"name":{},"description":{},"platform":{},"iamServiceRoleArn":{},"environmentVariables":{"shape":"S9"},"enableBranchAutoBuild":{"type":"boolean"},"enableBranchAutoDeletion":{"type":"boolean"},"enableBasicAuth":{"type":"boolean"},"basicAuthCredentials":{"shape":"Sf"},"customRules":{"shape":"Sg"},"buildSpec":{"shape":"Sp"},"customHeaders":{},"enableAutoBranchCreation":{"type":"boolean"},"autoBranchCreationPatterns":{"shape":"Ss"},"autoBranchCreationConfig":{"shape":"Su"},"repository":{},"oauthToken":{"shape":"S7"},"accessToken":{"shape":"S8"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"S12"}}}},"UpdateBranch":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"description":{},"framework":{},"stage":{},"enableNotification":{"type":"boolean"},"enableAutoBuild":{"type":"boolean"},"environmentVariables":{"shape":"S9"},"basicAuthCredentials":{"shape":"Sf"},"enableBasicAuth":{"type":"boolean"},"enablePerformanceMode":{"type":"boolean"},"buildSpec":{"shape":"Sp"},"ttl":{},"displayName":{},"enablePullRequestPreview":{"type":"boolean"},"pullRequestEnvironmentName":{},"backendEnvironmentArn":{}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1p"}}}},"UpdateDomainAssociation":{"http":{"requestUri":"/apps/{appId}/domains/{domainName}"},"input":{"type":"structure","required":["appId","domainName"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{"location":"uri","locationName":"domainName"},"enableAutoSubDomain":{"type":"boolean"},"subDomainSettings":{"shape":"S28"},"autoSubDomainCreationPatterns":{"shape":"S2b"},"autoSubDomainIAMRole":{}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S2f"}}}},"UpdateWebhook":{"http":{"requestUri":"/webhooks/{webhookId}"},"input":{"type":"structure","required":["webhookId"],"members":{"webhookId":{"location":"uri","locationName":"webhookId"},"branchName":{},"description":{}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2q"}}}}},"shapes":{"S7":{"type":"string","sensitive":true},"S8":{"type":"string","sensitive":true},"S9":{"type":"map","key":{},"value":{}},"Sf":{"type":"string","sensitive":true},"Sg":{"type":"list","member":{"type":"structure","required":["source","target"],"members":{"source":{},"target":{},"status":{},"condition":{}}}},"Sm":{"type":"map","key":{},"value":{}},"Sp":{"type":"string","sensitive":true},"Ss":{"type":"list","member":{}},"Su":{"type":"structure","members":{"stage":{},"framework":{},"enableAutoBuild":{"type":"boolean"},"environmentVariables":{"shape":"S9"},"basicAuthCredentials":{"shape":"Sf"},"enableBasicAuth":{"type":"boolean"},"enablePerformanceMode":{"type":"boolean"},"buildSpec":{"shape":"Sp"},"enablePullRequestPreview":{"type":"boolean"},"pullRequestEnvironmentName":{}}},"S12":{"type":"structure","required":["appId","appArn","name","description","repository","platform","createTime","updateTime","environmentVariables","defaultDomain","enableBranchAutoBuild","enableBasicAuth"],"members":{"appId":{},"appArn":{},"name":{},"tags":{"shape":"Sm"},"description":{},"repository":{},"platform":{},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"},"iamServiceRoleArn":{},"environmentVariables":{"shape":"S9"},"defaultDomain":{},"enableBranchAutoBuild":{"type":"boolean"},"enableBranchAutoDeletion":{"type":"boolean"},"enableBasicAuth":{"type":"boolean"},"basicAuthCredentials":{"shape":"Sf"},"customRules":{"shape":"Sg"},"productionBranch":{"type":"structure","members":{"lastDeployTime":{"type":"timestamp"},"status":{},"thumbnailUrl":{},"branchName":{}}},"buildSpec":{"shape":"Sp"},"customHeaders":{},"enableAutoBranchCreation":{"type":"boolean"},"autoBranchCreationPatterns":{"shape":"Ss"},"autoBranchCreationConfig":{"shape":"Su"},"repositoryCloneMethod":{}}},"S1i":{"type":"structure","required":["backendEnvironmentArn","environmentName","createTime","updateTime"],"members":{"backendEnvironmentArn":{},"environmentName":{},"stackName":{},"deploymentArtifacts":{},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"}}},"S1p":{"type":"structure","required":["branchArn","branchName","description","stage","displayName","enableNotification","createTime","updateTime","environmentVariables","enableAutoBuild","customDomains","framework","activeJobId","totalNumberOfJobs","enableBasicAuth","ttl","enablePullRequestPreview"],"members":{"branchArn":{},"branchName":{},"description":{},"tags":{"shape":"Sm"},"stage":{},"displayName":{},"enableNotification":{"type":"boolean"},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"},"environmentVariables":{"shape":"S9"},"enableAutoBuild":{"type":"boolean"},"customDomains":{"type":"list","member":{}},"framework":{},"activeJobId":{},"totalNumberOfJobs":{},"enableBasicAuth":{"type":"boolean"},"enablePerformanceMode":{"type":"boolean"},"thumbnailUrl":{},"basicAuthCredentials":{"shape":"Sf"},"buildSpec":{"shape":"Sp"},"ttl":{},"associatedResources":{"type":"list","member":{}},"enablePullRequestPreview":{"type":"boolean"},"pullRequestEnvironmentName":{},"destinationBranch":{},"sourceBranch":{},"backendEnvironmentArn":{}}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","required":["prefix","branchName"],"members":{"prefix":{},"branchName":{}}},"S2b":{"type":"list","member":{}},"S2f":{"type":"structure","required":["domainAssociationArn","domainName","enableAutoSubDomain","domainStatus","statusReason","subDomains"],"members":{"domainAssociationArn":{},"domainName":{},"enableAutoSubDomain":{"type":"boolean"},"autoSubDomainCreationPatterns":{"shape":"S2b"},"autoSubDomainIAMRole":{},"domainStatus":{},"statusReason":{},"certificateVerificationDNSRecord":{},"subDomains":{"type":"list","member":{"type":"structure","required":["subDomainSetting","verified","dnsRecord"],"members":{"subDomainSetting":{"shape":"S29"},"verified":{"type":"boolean"},"dnsRecord":{}}}}}},"S2q":{"type":"structure","required":["webhookArn","webhookId","webhookUrl","branchName","description","createTime","updateTime"],"members":{"webhookArn":{},"webhookId":{},"webhookUrl":{},"branchName":{},"description":{},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"}}},"S34":{"type":"structure","required":["jobArn","jobId","commitId","commitMessage","commitTime","startTime","status","jobType"],"members":{"jobArn":{},"jobId":{},"commitId":{},"commitMessage":{},"commitTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"status":{},"endTime":{"type":"timestamp"},"jobType":{}}}}}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['datasync'] = {};
	AWS.DataSync = Service.defineService('datasync', ['2018-11-09']);
	Object.defineProperty(apiLoader.services['datasync'], '2018-11-09', {
	  get: function get() {
	    var model = __webpack_require__(671);
	    model.paginators = __webpack_require__(672).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DataSync;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-09","endpointPrefix":"datasync","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"DataSync","serviceFullName":"AWS DataSync","serviceId":"DataSync","signatureVersion":"v4","signingName":"datasync","targetPrefix":"FmrsService","uid":"datasync-2018-11-09"},"operations":{"CancelTaskExecution":{"input":{"type":"structure","required":["TaskExecutionArn"],"members":{"TaskExecutionArn":{}}},"output":{"type":"structure","members":{}}},"CreateAgent":{"input":{"type":"structure","required":["ActivationKey"],"members":{"ActivationKey":{},"AgentName":{},"Tags":{"shape":"S7"},"VpcEndpointId":{},"SubnetArns":{"shape":"Sb"},"SecurityGroupArns":{"shape":"Sd"}}},"output":{"type":"structure","members":{"AgentArn":{}}}},"CreateLocationEfs":{"input":{"type":"structure","required":["EfsFilesystemArn","Ec2Config"],"members":{"Subdirectory":{},"EfsFilesystemArn":{},"Ec2Config":{"shape":"Sk"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationFsxLustre":{"input":{"type":"structure","required":["FsxFilesystemArn","SecurityGroupArns"],"members":{"FsxFilesystemArn":{},"SecurityGroupArns":{"shape":"Sl"},"Subdirectory":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationFsxOpenZfs":{"input":{"type":"structure","required":["FsxFilesystemArn","Protocol","SecurityGroupArns"],"members":{"FsxFilesystemArn":{},"Protocol":{"shape":"St"},"SecurityGroupArns":{"shape":"Sl"},"Subdirectory":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationFsxWindows":{"input":{"type":"structure","required":["FsxFilesystemArn","SecurityGroupArns","User","Password"],"members":{"Subdirectory":{},"FsxFilesystemArn":{},"SecurityGroupArns":{"shape":"Sl"},"Tags":{"shape":"S7"},"User":{},"Domain":{},"Password":{"shape":"S13"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationHdfs":{"input":{"type":"structure","required":["NameNodes","AuthenticationType","AgentArns"],"members":{"Subdirectory":{},"NameNodes":{"shape":"S17"},"BlockSize":{"type":"integer"},"ReplicationFactor":{"type":"integer"},"KmsKeyProviderUri":{},"QopConfiguration":{"shape":"S1e"},"AuthenticationType":{},"SimpleUser":{},"KerberosPrincipal":{},"KerberosKeytab":{"type":"blob"},"KerberosKrb5Conf":{"type":"blob"},"AgentArns":{"shape":"S1m"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationNfs":{"input":{"type":"structure","required":["Subdirectory","ServerHostname","OnPremConfig"],"members":{"Subdirectory":{},"ServerHostname":{},"OnPremConfig":{"shape":"S1r"},"MountOptions":{"shape":"Sv"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationObjectStorage":{"input":{"type":"structure","required":["ServerHostname","BucketName","AgentArns"],"members":{"ServerHostname":{},"ServerPort":{"type":"integer"},"ServerProtocol":{},"Subdirectory":{},"BucketName":{},"AccessKey":{},"SecretKey":{"shape":"S1z"},"AgentArns":{"shape":"S1m"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationS3":{"input":{"type":"structure","required":["S3BucketArn","S3Config"],"members":{"Subdirectory":{},"S3BucketArn":{},"S3StorageClass":{},"S3Config":{"shape":"S24"},"AgentArns":{"shape":"S1m"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationSmb":{"input":{"type":"structure","required":["Subdirectory","ServerHostname","User","Password","AgentArns"],"members":{"Subdirectory":{},"ServerHostname":{},"User":{},"Domain":{},"Password":{"shape":"S13"},"AgentArns":{"shape":"S1m"},"MountOptions":{"shape":"S29"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateTask":{"input":{"type":"structure","required":["SourceLocationArn","DestinationLocationArn"],"members":{"SourceLocationArn":{},"DestinationLocationArn":{},"CloudWatchLogGroupArn":{},"Name":{},"Options":{"shape":"S2e"},"Excludes":{"shape":"S2t"},"Schedule":{"shape":"S2x"},"Tags":{"shape":"S7"},"Includes":{"shape":"S2t"}}},"output":{"type":"structure","members":{"TaskArn":{}}}},"DeleteAgent":{"input":{"type":"structure","required":["AgentArn"],"members":{"AgentArn":{}}},"output":{"type":"structure","members":{}}},"DeleteLocation":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{}}},"DeleteTask":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{}}},"output":{"type":"structure","members":{}}},"DescribeAgent":{"input":{"type":"structure","required":["AgentArn"],"members":{"AgentArn":{}}},"output":{"type":"structure","members":{"AgentArn":{},"Name":{},"Status":{},"LastConnectionTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"EndpointType":{},"PrivateLinkConfig":{"type":"structure","members":{"VpcEndpointId":{},"PrivateLinkEndpoint":{},"SubnetArns":{"shape":"Sb"},"SecurityGroupArns":{"shape":"Sd"}}}}}},"DescribeLocationEfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"Ec2Config":{"shape":"Sk"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationFsxLustre":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"SecurityGroupArns":{"shape":"Sl"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationFsxOpenZfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"SecurityGroupArns":{"shape":"Sl"},"Protocol":{"shape":"St"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationFsxWindows":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"SecurityGroupArns":{"shape":"Sl"},"CreationTime":{"type":"timestamp"},"User":{},"Domain":{}}}},"DescribeLocationHdfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"NameNodes":{"shape":"S17"},"BlockSize":{"type":"integer"},"ReplicationFactor":{"type":"integer"},"KmsKeyProviderUri":{},"QopConfiguration":{"shape":"S1e"},"AuthenticationType":{},"SimpleUser":{},"KerberosPrincipal":{},"AgentArns":{"shape":"S1m"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationNfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"OnPremConfig":{"shape":"S1r"},"MountOptions":{"shape":"Sv"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationObjectStorage":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"AccessKey":{},"ServerPort":{"type":"integer"},"ServerProtocol":{},"AgentArns":{"shape":"S1m"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationS3":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"S3StorageClass":{},"S3Config":{"shape":"S24"},"AgentArns":{"shape":"S1m"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationSmb":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"AgentArns":{"shape":"S1m"},"User":{},"Domain":{},"MountOptions":{"shape":"S29"},"CreationTime":{"type":"timestamp"}}}},"DescribeTask":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{}}},"output":{"type":"structure","members":{"TaskArn":{},"Status":{},"Name":{},"CurrentTaskExecutionArn":{},"SourceLocationArn":{},"DestinationLocationArn":{},"CloudWatchLogGroupArn":{},"SourceNetworkInterfaceArns":{"type":"list","member":{}},"DestinationNetworkInterfaceArns":{"type":"list","member":{}},"Options":{"shape":"S2e"},"Excludes":{"shape":"S2t"},"Schedule":{"shape":"S2x"},"ErrorCode":{},"ErrorDetail":{},"CreationTime":{"type":"timestamp"},"Includes":{"shape":"S2t"}}}},"DescribeTaskExecution":{"input":{"type":"structure","required":["TaskExecutionArn"],"members":{"TaskExecutionArn":{}}},"output":{"type":"structure","members":{"TaskExecutionArn":{},"Status":{},"Options":{"shape":"S2e"},"Excludes":{"shape":"S2t"},"Includes":{"shape":"S2t"},"StartTime":{"type":"timestamp"},"EstimatedFilesToTransfer":{"type":"long"},"EstimatedBytesToTransfer":{"type":"long"},"FilesTransferred":{"type":"long"},"BytesWritten":{"type":"long"},"BytesTransferred":{"type":"long"},"Result":{"type":"structure","members":{"PrepareDuration":{"type":"long"},"PrepareStatus":{},"TotalDuration":{"type":"long"},"TransferDuration":{"type":"long"},"TransferStatus":{},"VerifyDuration":{"type":"long"},"VerifyStatus":{},"ErrorCode":{},"ErrorDetail":{}}}}}},"ListAgents":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Agents":{"type":"list","member":{"type":"structure","members":{"AgentArn":{},"Name":{},"Status":{}}}},"NextToken":{}}}},"ListLocations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values","Operator"],"members":{"Name":{},"Values":{"shape":"S4l"},"Operator":{}}}}}},"output":{"type":"structure","members":{"Locations":{"type":"list","member":{"type":"structure","members":{"LocationArn":{},"LocationUri":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"type":"list","member":{"shape":"S8"}},"NextToken":{}}}},"ListTaskExecutions":{"input":{"type":"structure","members":{"TaskArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TaskExecutions":{"type":"list","member":{"type":"structure","members":{"TaskExecutionArn":{},"Status":{}}}},"NextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values","Operator"],"members":{"Name":{},"Values":{"shape":"S4l"},"Operator":{}}}}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"TaskArn":{},"Status":{},"Name":{}}}},"NextToken":{}}}},"StartTaskExecution":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{},"OverrideOptions":{"shape":"S2e"},"Includes":{"shape":"S2t"},"Excludes":{"shape":"S2t"}}},"output":{"type":"structure","members":{"TaskExecutionArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","Keys"],"members":{"ResourceArn":{},"Keys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAgent":{"input":{"type":"structure","required":["AgentArn"],"members":{"AgentArn":{},"Name":{}}},"output":{"type":"structure","members":{}}},"UpdateLocationHdfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{},"Subdirectory":{},"NameNodes":{"shape":"S17"},"BlockSize":{"type":"integer"},"ReplicationFactor":{"type":"integer"},"KmsKeyProviderUri":{},"QopConfiguration":{"shape":"S1e"},"AuthenticationType":{},"SimpleUser":{},"KerberosPrincipal":{},"KerberosKeytab":{"type":"blob"},"KerberosKrb5Conf":{"type":"blob"},"AgentArns":{"shape":"S1m"}}},"output":{"type":"structure","members":{}}},"UpdateLocationNfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{},"Subdirectory":{},"OnPremConfig":{"shape":"S1r"},"MountOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"UpdateLocationObjectStorage":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{},"ServerPort":{"type":"integer"},"ServerProtocol":{},"Subdirectory":{},"AccessKey":{},"SecretKey":{"shape":"S1z"},"AgentArns":{"shape":"S1m"}}},"output":{"type":"structure","members":{}}},"UpdateLocationSmb":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{},"Subdirectory":{},"User":{},"Domain":{},"Password":{"shape":"S13"},"AgentArns":{"shape":"S1m"},"MountOptions":{"shape":"S29"}}},"output":{"type":"structure","members":{}}},"UpdateTask":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{},"Options":{"shape":"S2e"},"Excludes":{"shape":"S2t"},"Schedule":{"shape":"S2x"},"Name":{},"CloudWatchLogGroupArn":{},"Includes":{"shape":"S2t"}}},"output":{"type":"structure","members":{}}},"UpdateTaskExecution":{"input":{"type":"structure","required":["TaskExecutionArn","Options"],"members":{"TaskExecutionArn":{},"Options":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"list","member":{"shape":"S8"}},"S8":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}},"Sb":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sk":{"type":"structure","required":["SubnetArn","SecurityGroupArns"],"members":{"SubnetArn":{},"SecurityGroupArns":{"shape":"Sl"}}},"Sl":{"type":"list","member":{}},"St":{"type":"structure","members":{"NFS":{"type":"structure","members":{"MountOptions":{"shape":"Sv"}}}}},"Sv":{"type":"structure","members":{"Version":{}}},"S13":{"type":"string","sensitive":true},"S17":{"type":"list","member":{"type":"structure","required":["Hostname","Port"],"members":{"Hostname":{},"Port":{"type":"integer"}}}},"S1e":{"type":"structure","members":{"RpcProtection":{},"DataTransferProtection":{}}},"S1m":{"type":"list","member":{}},"S1r":{"type":"structure","required":["AgentArns"],"members":{"AgentArns":{"shape":"S1m"}}},"S1z":{"type":"string","sensitive":true},"S24":{"type":"structure","required":["BucketAccessRoleArn"],"members":{"BucketAccessRoleArn":{}}},"S29":{"type":"structure","members":{"Version":{}}},"S2e":{"type":"structure","members":{"VerifyMode":{},"OverwriteMode":{},"Atime":{},"Mtime":{},"Uid":{},"Gid":{},"PreserveDeletedFiles":{},"PreserveDevices":{},"PosixPermissions":{},"BytesPerSecond":{"type":"long"},"TaskQueueing":{},"LogLevel":{},"TransferMode":{},"SecurityDescriptorCopyFlags":{}}},"S2t":{"type":"list","member":{"type":"structure","members":{"FilterType":{},"Value":{}}}},"S2x":{"type":"structure","required":["ScheduleExpression"],"members":{"ScheduleExpression":{}}},"S4l":{"type":"list","member":{}}}}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAgents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLocations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTaskExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['robomaker'] = {};
	AWS.RoboMaker = Service.defineService('robomaker', ['2018-06-29']);
	Object.defineProperty(apiLoader.services['robomaker'], '2018-06-29', {
	  get: function get() {
	    var model = __webpack_require__(674);
	    model.paginators = __webpack_require__(675).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.RoboMaker;


/***/ }),
/* 674 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-29","endpointPrefix":"robomaker","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"RoboMaker","serviceFullName":"AWS RoboMaker","serviceId":"RoboMaker","signatureVersion":"v4","signingName":"robomaker","uid":"robomaker-2018-06-29"},"operations":{"BatchDeleteWorlds":{"http":{"requestUri":"/batchDeleteWorlds"},"input":{"type":"structure","required":["worlds"],"members":{"worlds":{"shape":"S2"}}},"output":{"type":"structure","members":{"unprocessedWorlds":{"shape":"S2"}}}},"BatchDescribeSimulationJob":{"http":{"requestUri":"/batchDescribeSimulationJob"},"input":{"type":"structure","required":["jobs"],"members":{"jobs":{"shape":"S2"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"status":{},"lastStartedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"failureBehavior":{},"failureCode":{},"failureReason":{},"clientRequestToken":{},"outputLocation":{"shape":"Sh"},"loggingConfig":{"shape":"Sk"},"maxJobDurationInSeconds":{"type":"long"},"simulationTimeMillis":{"type":"long"},"iamRole":{},"robotApplications":{"shape":"Sp"},"simulationApplications":{"shape":"S1d"},"dataSources":{"shape":"S1h"},"tags":{"shape":"S1o"},"vpcConfig":{"shape":"S1r"},"networkInterface":{"shape":"S1u"},"compute":{"shape":"S1v"}}}},"unprocessedJobs":{"shape":"S2"}}}},"CancelDeploymentJob":{"http":{"requestUri":"/cancelDeploymentJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"CancelSimulationJob":{"http":{"requestUri":"/cancelSimulationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"CancelSimulationJobBatch":{"http":{"requestUri":"/cancelSimulationJobBatch"},"input":{"type":"structure","required":["batch"],"members":{"batch":{}}},"output":{"type":"structure","members":{}}},"CancelWorldExportJob":{"http":{"requestUri":"/cancelWorldExportJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"CancelWorldGenerationJob":{"http":{"requestUri":"/cancelWorldGenerationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"CreateDeploymentJob":{"http":{"requestUri":"/createDeploymentJob"},"input":{"type":"structure","required":["clientRequestToken","fleet","deploymentApplicationConfigs"],"members":{"deploymentConfig":{"shape":"S2a"},"clientRequestToken":{"idempotencyToken":true},"fleet":{},"deploymentApplicationConfigs":{"shape":"S2e"},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentApplicationConfigs":{"shape":"S2e"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"},"deploymentConfig":{"shape":"S2a"},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"CreateFleet":{"http":{"requestUri":"/createFleet"},"input":{"type":"structure","required":["name"],"members":{"name":{},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"arn":{},"name":{},"createdAt":{"type":"timestamp"},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"CreateRobot":{"http":{"requestUri":"/createRobot"},"input":{"type":"structure","required":["name","architecture","greengrassGroupId"],"members":{"name":{},"architecture":{},"greengrassGroupId":{},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"arn":{},"name":{},"createdAt":{"type":"timestamp"},"greengrassGroupId":{},"architecture":{},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"CreateRobotApplication":{"http":{"requestUri":"/createRobotApplication"},"input":{"type":"structure","required":["name","robotSoftwareSuite"],"members":{"name":{},"sources":{"shape":"S2t"},"robotSoftwareSuite":{"shape":"S2v"},"tags":{"shape":"S1o"},"environment":{"shape":"S2y"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"robotSoftwareSuite":{"shape":"S2v"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"tags":{"shape":"S1o"},"environment":{"shape":"S2y"}}}},"CreateRobotApplicationVersion":{"http":{"requestUri":"/createRobotApplicationVersion"},"input":{"type":"structure","required":["application"],"members":{"application":{},"currentRevisionId":{},"s3Etags":{"shape":"S35"},"imageDigest":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"robotSoftwareSuite":{"shape":"S2v"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"environment":{"shape":"S2y"}}}},"CreateSimulationApplication":{"http":{"requestUri":"/createSimulationApplication"},"input":{"type":"structure","required":["name","simulationSoftwareSuite","robotSoftwareSuite"],"members":{"name":{},"sources":{"shape":"S2t"},"simulationSoftwareSuite":{"shape":"S39"},"robotSoftwareSuite":{"shape":"S2v"},"renderingEngine":{"shape":"S3c"},"tags":{"shape":"S1o"},"environment":{"shape":"S2y"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"simulationSoftwareSuite":{"shape":"S39"},"robotSoftwareSuite":{"shape":"S2v"},"renderingEngine":{"shape":"S3c"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"tags":{"shape":"S1o"},"environment":{"shape":"S2y"}}}},"CreateSimulationApplicationVersion":{"http":{"requestUri":"/createSimulationApplicationVersion"},"input":{"type":"structure","required":["application"],"members":{"application":{},"currentRevisionId":{},"s3Etags":{"shape":"S35"},"imageDigest":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"simulationSoftwareSuite":{"shape":"S39"},"robotSoftwareSuite":{"shape":"S2v"},"renderingEngine":{"shape":"S3c"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"environment":{"shape":"S2y"}}}},"CreateSimulationJob":{"http":{"requestUri":"/createSimulationJob"},"input":{"type":"structure","required":["maxJobDurationInSeconds","iamRole"],"members":{"clientRequestToken":{"idempotencyToken":true},"outputLocation":{"shape":"Sh"},"loggingConfig":{"shape":"Sk"},"maxJobDurationInSeconds":{"type":"long"},"iamRole":{},"failureBehavior":{},"robotApplications":{"shape":"Sp"},"simulationApplications":{"shape":"S1d"},"dataSources":{"shape":"S3j"},"tags":{"shape":"S1o"},"vpcConfig":{"shape":"S3m"},"compute":{"shape":"S3n"}}},"output":{"type":"structure","members":{"arn":{},"status":{},"lastStartedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"failureBehavior":{},"failureCode":{},"clientRequestToken":{},"outputLocation":{"shape":"Sh"},"loggingConfig":{"shape":"Sk"},"maxJobDurationInSeconds":{"type":"long"},"simulationTimeMillis":{"type":"long"},"iamRole":{},"robotApplications":{"shape":"Sp"},"simulationApplications":{"shape":"S1d"},"dataSources":{"shape":"S1h"},"tags":{"shape":"S1o"},"vpcConfig":{"shape":"S1r"},"compute":{"shape":"S1v"}}}},"CreateWorldExportJob":{"http":{"requestUri":"/createWorldExportJob"},"input":{"type":"structure","required":["worlds","outputLocation","iamRole"],"members":{"clientRequestToken":{"idempotencyToken":true},"worlds":{"shape":"S2"},"outputLocation":{"shape":"Sh"},"iamRole":{},"tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"failureCode":{},"clientRequestToken":{},"outputLocation":{"shape":"Sh"},"iamRole":{},"tags":{"shape":"S1o"}}}},"CreateWorldGenerationJob":{"http":{"requestUri":"/createWorldGenerationJob"},"input":{"type":"structure","required":["template","worldCount"],"members":{"clientRequestToken":{"idempotencyToken":true},"template":{},"worldCount":{"shape":"S3u"},"tags":{"shape":"S1o"},"worldTags":{"shape":"S1o"}}},"output":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"failureCode":{},"clientRequestToken":{},"template":{},"worldCount":{"shape":"S3u"},"tags":{"shape":"S1o"},"worldTags":{"shape":"S1o"}}}},"CreateWorldTemplate":{"http":{"requestUri":"/createWorldTemplate"},"input":{"type":"structure","members":{"clientRequestToken":{},"name":{},"templateBody":{},"templateLocation":{"shape":"S43"},"tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{"arn":{},"clientRequestToken":{},"createdAt":{"type":"timestamp"},"name":{},"tags":{"shape":"S1o"}}}},"DeleteFleet":{"http":{"requestUri":"/deleteFleet"},"input":{"type":"structure","required":["fleet"],"members":{"fleet":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"DeleteRobot":{"http":{"requestUri":"/deleteRobot"},"input":{"type":"structure","required":["robot"],"members":{"robot":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"DeleteRobotApplication":{"http":{"requestUri":"/deleteRobotApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{}}},"DeleteSimulationApplication":{"http":{"requestUri":"/deleteSimulationApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{}}},"DeleteWorldTemplate":{"http":{"requestUri":"/deleteWorldTemplate"},"input":{"type":"structure","required":["template"],"members":{"template":{}}},"output":{"type":"structure","members":{}}},"DeregisterRobot":{"http":{"requestUri":"/deregisterRobot"},"input":{"type":"structure","required":["fleet","robot"],"members":{"fleet":{},"robot":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"fleet":{},"robot":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"DescribeDeploymentJob":{"http":{"requestUri":"/describeDeploymentJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentConfig":{"shape":"S2a"},"deploymentApplicationConfigs":{"shape":"S2e"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"},"robotDeploymentSummary":{"type":"list","member":{"type":"structure","members":{"arn":{},"deploymentStartTime":{"type":"timestamp"},"deploymentFinishTime":{"type":"timestamp"},"status":{},"progressDetail":{"type":"structure","members":{"currentProgress":{},"percentDone":{"type":"float"},"estimatedTimeRemainingSeconds":{"type":"integer"},"targetResource":{}}},"failureReason":{},"failureCode":{}}}},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"DescribeFleet":{"http":{"requestUri":"/describeFleet"},"input":{"type":"structure","required":["fleet"],"members":{"fleet":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"name":{},"arn":{},"robots":{"shape":"S4s"},"createdAt":{"type":"timestamp"},"lastDeploymentStatus":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"DescribeRobot":{"http":{"requestUri":"/describeRobot"},"input":{"type":"structure","required":["robot"],"members":{"robot":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"arn":{},"name":{},"fleetArn":{},"status":{},"greengrassGroupId":{},"createdAt":{"type":"timestamp"},"architecture":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"},"tags":{"shape":"S1o"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"DescribeRobotApplication":{"http":{"requestUri":"/describeRobotApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"robotSoftwareSuite":{"shape":"S2v"},"revisionId":{},"lastUpdatedAt":{"type":"timestamp"},"tags":{"shape":"S1o"},"environment":{"shape":"S2y"},"imageDigest":{}}}},"DescribeSimulationApplication":{"http":{"requestUri":"/describeSimulationApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"simulationSoftwareSuite":{"shape":"S39"},"robotSoftwareSuite":{"shape":"S2v"},"renderingEngine":{"shape":"S3c"},"revisionId":{},"lastUpdatedAt":{"type":"timestamp"},"tags":{"shape":"S1o"},"environment":{"shape":"S2y"},"imageDigest":{}}}},"DescribeSimulationJob":{"http":{"requestUri":"/describeSimulationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"status":{},"lastStartedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"failureBehavior":{},"failureCode":{},"failureReason":{},"clientRequestToken":{},"outputLocation":{"shape":"Sh"},"loggingConfig":{"shape":"Sk"},"maxJobDurationInSeconds":{"type":"long"},"simulationTimeMillis":{"type":"long"},"iamRole":{},"robotApplications":{"shape":"Sp"},"simulationApplications":{"shape":"S1d"},"dataSources":{"shape":"S1h"},"tags":{"shape":"S1o"},"vpcConfig":{"shape":"S1r"},"networkInterface":{"shape":"S1u"},"compute":{"shape":"S1v"}}}},"DescribeSimulationJobBatch":{"http":{"requestUri":"/describeSimulationJobBatch"},"input":{"type":"structure","required":["batch"],"members":{"batch":{}}},"output":{"type":"structure","members":{"arn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"createdAt":{"type":"timestamp"},"clientRequestToken":{},"batchPolicy":{"shape":"S55"},"failureCode":{},"failureReason":{},"failedRequests":{"shape":"S59"},"pendingRequests":{"shape":"S5d"},"createdRequests":{"shape":"S5e"},"tags":{"shape":"S1o"}}}},"DescribeWorld":{"http":{"requestUri":"/describeWorld"},"input":{"type":"structure","required":["world"],"members":{"world":{}}},"output":{"type":"structure","members":{"arn":{},"generationJob":{},"template":{},"createdAt":{"type":"timestamp"},"tags":{"shape":"S1o"},"worldDescriptionBody":{}}}},"DescribeWorldExportJob":{"http":{"requestUri":"/describeWorldExportJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"failureCode":{},"failureReason":{},"clientRequestToken":{},"worlds":{"shape":"S2"},"outputLocation":{"shape":"Sh"},"iamRole":{},"tags":{"shape":"S1o"}}}},"DescribeWorldGenerationJob":{"http":{"requestUri":"/describeWorldGenerationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"failureCode":{},"failureReason":{},"clientRequestToken":{},"template":{},"worldCount":{"shape":"S3u"},"finishedWorldsSummary":{"type":"structure","members":{"finishedCount":{"type":"integer"},"succeededWorlds":{"shape":"S2"},"failureSummary":{"type":"structure","members":{"totalFailureCount":{"type":"integer"},"failures":{"type":"list","member":{"type":"structure","members":{"failureCode":{},"sampleFailureReason":{},"failureCount":{"type":"integer"}}}}}}}},"tags":{"shape":"S1o"},"worldTags":{"shape":"S1o"}}}},"DescribeWorldTemplate":{"http":{"requestUri":"/describeWorldTemplate"},"input":{"type":"structure","required":["template"],"members":{"template":{}}},"output":{"type":"structure","members":{"arn":{},"clientRequestToken":{},"name":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"tags":{"shape":"S1o"},"version":{}}}},"GetWorldTemplateBody":{"http":{"requestUri":"/getWorldTemplateBody"},"input":{"type":"structure","members":{"template":{},"generationJob":{}}},"output":{"type":"structure","members":{"templateBody":{}}}},"ListDeploymentJobs":{"http":{"requestUri":"/listDeploymentJobs"},"input":{"type":"structure","members":{"filters":{"shape":"S5z"},"nextToken":{},"maxResults":{"type":"integer"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"deploymentJobs":{"type":"list","member":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentApplicationConfigs":{"shape":"S2e"},"deploymentConfig":{"shape":"S2a"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"}}}},"nextToken":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"ListFleets":{"http":{"requestUri":"/listFleets"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"fleetDetails":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"lastDeploymentStatus":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"}}}},"nextToken":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"ListRobotApplications":{"http":{"requestUri":"/listRobotApplications"},"input":{"type":"structure","members":{"versionQualifier":{},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","members":{"robotApplicationSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"version":{},"lastUpdatedAt":{"type":"timestamp"},"robotSoftwareSuite":{"shape":"S2v"}}}},"nextToken":{}}}},"ListRobots":{"http":{"requestUri":"/listRobots"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"robots":{"shape":"S4s"},"nextToken":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"ListSimulationApplications":{"http":{"requestUri":"/listSimulationApplications"},"input":{"type":"structure","members":{"versionQualifier":{},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","members":{"simulationApplicationSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"version":{},"lastUpdatedAt":{"type":"timestamp"},"robotSoftwareSuite":{"shape":"S2v"},"simulationSoftwareSuite":{"shape":"S39"}}}},"nextToken":{}}}},"ListSimulationJobBatches":{"http":{"requestUri":"/listSimulationJobBatches"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","members":{"simulationJobBatchSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"lastUpdatedAt":{"type":"timestamp"},"createdAt":{"type":"timestamp"},"status":{},"failedRequestCount":{"type":"integer"},"pendingRequestCount":{"type":"integer"},"createdRequestCount":{"type":"integer"}}}},"nextToken":{}}}},"ListSimulationJobs":{"http":{"requestUri":"/listSimulationJobs"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","required":["simulationJobSummaries"],"members":{"simulationJobSummaries":{"shape":"S5e"},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1o"}}}},"ListWorldExportJobs":{"http":{"requestUri":"/listWorldExportJobs"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","required":["worldExportJobSummaries"],"members":{"worldExportJobSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"worlds":{"shape":"S2"},"outputLocation":{"shape":"Sh"}}}},"nextToken":{}}}},"ListWorldGenerationJobs":{"http":{"requestUri":"/listWorldGenerationJobs"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","required":["worldGenerationJobSummaries"],"members":{"worldGenerationJobSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"template":{},"createdAt":{"type":"timestamp"},"status":{},"worldCount":{"shape":"S3u"},"succeededWorldCount":{"type":"integer"},"failedWorldCount":{"type":"integer"}}}},"nextToken":{}}}},"ListWorldTemplates":{"http":{"requestUri":"/listWorldTemplates"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"templateSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"name":{},"version":{}}}},"nextToken":{}}}},"ListWorlds":{"http":{"requestUri":"/listWorlds"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S5z"}}},"output":{"type":"structure","members":{"worldSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"createdAt":{"type":"timestamp"},"generationJob":{},"template":{}}}},"nextToken":{}}}},"RegisterRobot":{"http":{"requestUri":"/registerRobot"},"input":{"type":"structure","required":["fleet","robot"],"members":{"fleet":{},"robot":{}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"fleet":{},"robot":{}},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"AWS RoboMaker is unable to process this request as the support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"RestartSimulationJob":{"http":{"requestUri":"/restartSimulationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"StartSimulationJobBatch":{"http":{"requestUri":"/startSimulationJobBatch"},"input":{"type":"structure","required":["createSimulationJobRequests"],"members":{"clientRequestToken":{"idempotencyToken":true},"batchPolicy":{"shape":"S55"},"createSimulationJobRequests":{"shape":"S5d"},"tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"clientRequestToken":{},"batchPolicy":{"shape":"S55"},"failureCode":{},"failureReason":{},"failedRequests":{"shape":"S59"},"pendingRequests":{"shape":"S5d"},"createdRequests":{"shape":"S5e"},"tags":{"shape":"S1o"}}}},"SyncDeploymentJob":{"http":{"requestUri":"/syncDeploymentJob"},"input":{"type":"structure","required":["clientRequestToken","fleet"],"members":{"clientRequestToken":{"idempotencyToken":true},"fleet":{}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"output":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentConfig":{"shape":"S2a"},"deploymentApplicationConfigs":{"shape":"S2e"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"}},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"deprecated":true,"deprecatedMessage":"Support for the AWS RoboMaker application deployment feature has ended. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html."},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateRobotApplication":{"http":{"requestUri":"/updateRobotApplication"},"input":{"type":"structure","required":["application","robotSoftwareSuite"],"members":{"application":{},"sources":{"shape":"S2t"},"robotSoftwareSuite":{"shape":"S2v"},"currentRevisionId":{},"environment":{"shape":"S2y"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"robotSoftwareSuite":{"shape":"S2v"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"environment":{"shape":"S2y"}}}},"UpdateSimulationApplication":{"http":{"requestUri":"/updateSimulationApplication"},"input":{"type":"structure","required":["application","simulationSoftwareSuite","robotSoftwareSuite"],"members":{"application":{},"sources":{"shape":"S2t"},"simulationSoftwareSuite":{"shape":"S39"},"robotSoftwareSuite":{"shape":"S2v"},"renderingEngine":{"shape":"S3c"},"currentRevisionId":{},"environment":{"shape":"S2y"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S31"},"simulationSoftwareSuite":{"shape":"S39"},"robotSoftwareSuite":{"shape":"S2v"},"renderingEngine":{"shape":"S3c"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"environment":{"shape":"S2y"}}}},"UpdateWorldTemplate":{"http":{"requestUri":"/updateWorldTemplate"},"input":{"type":"structure","required":["template"],"members":{"template":{},"name":{},"templateBody":{},"templateLocation":{"shape":"S43"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Sh":{"type":"structure","members":{"s3Bucket":{},"s3Prefix":{}}},"Sk":{"type":"structure","members":{"recordAllRosTopics":{"deprecated":true,"deprecatedMessage":"AWS RoboMaker is ending support for ROS software suite. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/software-support-policy.html.","type":"boolean"}}},"Sp":{"type":"list","member":{"type":"structure","required":["application","launchConfig"],"members":{"application":{},"applicationVersion":{},"launchConfig":{"shape":"Ss"},"uploadConfigurations":{"shape":"S15"},"useDefaultUploadConfigurations":{"deprecated":true,"deprecatedMessage":"AWS RoboMaker is ending support for ROS software suite. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/software-support-policy.html.","type":"boolean"},"tools":{"shape":"S19"},"useDefaultTools":{"deprecated":true,"deprecatedMessage":"AWS RoboMaker is ending support for ROS software suite. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/software-support-policy.html.","type":"boolean"}}}},"Ss":{"type":"structure","members":{"packageName":{},"launchFile":{},"environmentVariables":{"shape":"Su"},"portForwardingConfig":{"type":"structure","members":{"portMappings":{"type":"list","member":{"type":"structure","required":["jobPort","applicationPort"],"members":{"jobPort":{"type":"integer"},"applicationPort":{"type":"integer"},"enableOnPublicIp":{"type":"boolean"}}}}}},"streamUI":{"type":"boolean"},"command":{"type":"list","member":{}}}},"Su":{"type":"map","key":{},"value":{}},"S15":{"type":"list","member":{"type":"structure","required":["name","path","uploadBehavior"],"members":{"name":{},"path":{},"uploadBehavior":{}}}},"S19":{"type":"list","member":{"type":"structure","required":["name","command"],"members":{"streamUI":{"type":"boolean"},"name":{},"command":{},"streamOutputToCloudWatch":{"type":"boolean"},"exitBehavior":{}}}},"S1d":{"type":"list","member":{"type":"structure","required":["application","launchConfig"],"members":{"application":{},"applicationVersion":{},"launchConfig":{"shape":"Ss"},"uploadConfigurations":{"shape":"S15"},"worldConfigs":{"type":"list","member":{"type":"structure","members":{"world":{}}}},"useDefaultUploadConfigurations":{"deprecated":true,"deprecatedMessage":"AWS RoboMaker is ending support for ROS software suite. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/software-support-policy.html.","type":"boolean"},"tools":{"shape":"S19"},"useDefaultTools":{"deprecated":true,"deprecatedMessage":"AWS RoboMaker is ending support for ROS software suite. For additional information, see https://docs.aws.amazon.com/robomaker/latest/dg/software-support-policy.html.","type":"boolean"}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"name":{},"s3Bucket":{},"s3Keys":{"type":"list","member":{"type":"structure","members":{"s3Key":{},"etag":{}}}},"type":{},"destination":{}}}},"S1o":{"type":"map","key":{},"value":{}},"S1r":{"type":"structure","members":{"subnets":{"shape":"S1s"},"securityGroups":{"shape":"S1t"},"vpcId":{},"assignPublicIp":{"type":"boolean"}}},"S1s":{"type":"list","member":{}},"S1t":{"type":"list","member":{}},"S1u":{"type":"structure","members":{"networkInterfaceId":{},"privateIpAddress":{},"publicIpAddress":{}}},"S1v":{"type":"structure","members":{"simulationUnitLimit":{"type":"integer"},"computeType":{},"gpuUnitLimit":{"type":"integer"}}},"S2a":{"type":"structure","members":{"concurrentDeploymentPercentage":{"type":"integer"},"failureThresholdPercentage":{"type":"integer"},"robotDeploymentTimeoutInSeconds":{"type":"long"},"downloadConditionFile":{"type":"structure","required":["bucket","key"],"members":{"bucket":{},"key":{},"etag":{}}}}},"S2e":{"type":"list","member":{"type":"structure","required":["application","applicationVersion","launchConfig"],"members":{"application":{},"applicationVersion":{},"launchConfig":{"type":"structure","required":["packageName","launchFile"],"members":{"packageName":{},"preLaunchFile":{},"launchFile":{},"postLaunchFile":{},"environmentVariables":{"shape":"Su"}}}}}},"S2t":{"type":"list","member":{"type":"structure","members":{"s3Bucket":{},"s3Key":{},"architecture":{}}}},"S2v":{"type":"structure","members":{"name":{},"version":{}}},"S2y":{"type":"structure","members":{"uri":{}}},"S31":{"type":"list","member":{"type":"structure","members":{"s3Bucket":{},"s3Key":{},"etag":{},"architecture":{}}}},"S35":{"type":"list","member":{}},"S39":{"type":"structure","members":{"name":{},"version":{}}},"S3c":{"type":"structure","members":{"name":{},"version":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["name","s3Bucket","s3Keys"],"members":{"name":{},"s3Bucket":{},"s3Keys":{"type":"list","member":{}},"type":{},"destination":{}}}},"S3m":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"S1s"},"securityGroups":{"shape":"S1t"},"assignPublicIp":{"type":"boolean"}}},"S3n":{"type":"structure","members":{"simulationUnitLimit":{"type":"integer"},"computeType":{},"gpuUnitLimit":{"type":"integer"}}},"S3u":{"type":"structure","members":{"floorplanCount":{"type":"integer"},"interiorCountPerFloorplan":{"type":"integer"}}},"S43":{"type":"structure","required":["s3Bucket","s3Key"],"members":{"s3Bucket":{},"s3Key":{}}},"S4s":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"fleetArn":{},"status":{},"greenGrassGroupId":{},"createdAt":{"type":"timestamp"},"architecture":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"}}}},"S55":{"type":"structure","members":{"timeoutInSeconds":{"type":"long"},"maxConcurrency":{"type":"integer"}}},"S59":{"type":"list","member":{"type":"structure","members":{"request":{"shape":"S5b"},"failureReason":{},"failureCode":{},"failedAt":{"type":"timestamp"}}}},"S5b":{"type":"structure","required":["maxJobDurationInSeconds"],"members":{"outputLocation":{"shape":"Sh"},"loggingConfig":{"shape":"Sk"},"maxJobDurationInSeconds":{"type":"long"},"iamRole":{},"failureBehavior":{},"useDefaultApplications":{"type":"boolean"},"robotApplications":{"shape":"Sp"},"simulationApplications":{"shape":"S1d"},"dataSources":{"shape":"S3j"},"vpcConfig":{"shape":"S3m"},"compute":{"shape":"S3n"},"tags":{"shape":"S1o"}}},"S5d":{"type":"list","member":{"shape":"S5b"}},"S5e":{"type":"list","member":{"type":"structure","members":{"arn":{},"lastUpdatedAt":{"type":"timestamp"},"name":{},"status":{},"simulationApplicationNames":{"type":"list","member":{}},"robotApplicationNames":{"type":"list","member":{}},"dataSourceNames":{"type":"list","member":{}},"computeType":{}}}},"S5z":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"type":"list","member":{}}}}}}}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDeploymentJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"deploymentJobs"},"ListFleets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"fleetDetails"},"ListRobotApplications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"robotApplicationSummaries"},"ListRobots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"robots"},"ListSimulationApplications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"simulationApplicationSummaries"},"ListSimulationJobBatches":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"simulationJobBatchSummaries"},"ListSimulationJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"simulationJobSummaries"},"ListWorldExportJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"worldExportJobSummaries"},"ListWorldGenerationJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"worldGenerationJobSummaries"},"ListWorldTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"templateSummaries"},"ListWorlds":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"worldSummaries"}}}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['transfer'] = {};
	AWS.Transfer = Service.defineService('transfer', ['2018-11-05']);
	Object.defineProperty(apiLoader.services['transfer'], '2018-11-05', {
	  get: function get() {
	    var model = __webpack_require__(677);
	    model.paginators = __webpack_require__(678).pagination;
	    model.waiters = __webpack_require__(679).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Transfer;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-05","endpointPrefix":"transfer","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Transfer","serviceFullName":"AWS Transfer Family","serviceId":"Transfer","signatureVersion":"v4","signingName":"transfer","targetPrefix":"TransferService","uid":"transfer-2018-11-05"},"operations":{"CreateAccess":{"input":{"type":"structure","required":["Role","ServerId","ExternalId"],"members":{"HomeDirectory":{},"HomeDirectoryType":{},"HomeDirectoryMappings":{"shape":"S4"},"Policy":{},"PosixProfile":{"shape":"S9"},"Role":{},"ServerId":{},"ExternalId":{}}},"output":{"type":"structure","required":["ServerId","ExternalId"],"members":{"ServerId":{},"ExternalId":{}}}},"CreateServer":{"input":{"type":"structure","members":{"Certificate":{},"Domain":{},"EndpointDetails":{"shape":"Sj"},"EndpointType":{},"HostKey":{"shape":"St"},"IdentityProviderDetails":{"shape":"Su"},"IdentityProviderType":{},"LoggingRole":{},"PostAuthenticationLoginBanner":{},"PreAuthenticationLoginBanner":{},"Protocols":{"shape":"S11"},"ProtocolDetails":{"shape":"S13"},"SecurityPolicyName":{},"Tags":{"shape":"S17"},"WorkflowDetails":{"shape":"S1b"}}},"output":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"CreateUser":{"input":{"type":"structure","required":["Role","ServerId","UserName"],"members":{"HomeDirectory":{},"HomeDirectoryType":{},"HomeDirectoryMappings":{"shape":"S4"},"Policy":{},"PosixProfile":{"shape":"S9"},"Role":{},"ServerId":{},"SshPublicKeyBody":{},"Tags":{"shape":"S17"},"UserName":{}}},"output":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}}},"CreateWorkflow":{"input":{"type":"structure","required":["Steps"],"members":{"Description":{},"Steps":{"shape":"S1m"},"OnExceptionSteps":{"shape":"S1m"},"Tags":{"shape":"S17"}}},"output":{"type":"structure","required":["WorkflowId"],"members":{"WorkflowId":{}}}},"DeleteAccess":{"input":{"type":"structure","required":["ServerId","ExternalId"],"members":{"ServerId":{},"ExternalId":{}}}},"DeleteServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"DeleteSshPublicKey":{"input":{"type":"structure","required":["ServerId","SshPublicKeyId","UserName"],"members":{"ServerId":{},"SshPublicKeyId":{},"UserName":{}}}},"DeleteUser":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}}},"DeleteWorkflow":{"input":{"type":"structure","required":["WorkflowId"],"members":{"WorkflowId":{}}}},"DescribeAccess":{"input":{"type":"structure","required":["ServerId","ExternalId"],"members":{"ServerId":{},"ExternalId":{}}},"output":{"type":"structure","required":["ServerId","Access"],"members":{"ServerId":{},"Access":{"type":"structure","members":{"HomeDirectory":{},"HomeDirectoryMappings":{"shape":"S4"},"HomeDirectoryType":{},"Policy":{},"PosixProfile":{"shape":"S9"},"Role":{},"ExternalId":{}}}}}},"DescribeExecution":{"input":{"type":"structure","required":["ExecutionId","WorkflowId"],"members":{"ExecutionId":{},"WorkflowId":{}}},"output":{"type":"structure","required":["WorkflowId","Execution"],"members":{"WorkflowId":{},"Execution":{"type":"structure","members":{"ExecutionId":{},"InitialFileLocation":{"shape":"S2n"},"ServiceMetadata":{"shape":"S2r"},"ExecutionRole":{},"LoggingConfiguration":{"type":"structure","members":{"LoggingRole":{},"LogGroupName":{}}},"PosixProfile":{"shape":"S9"},"Status":{},"Results":{"type":"structure","members":{"Steps":{"shape":"S2y"},"OnExceptionSteps":{"shape":"S2y"}}}}}}}},"DescribeSecurityPolicy":{"input":{"type":"structure","required":["SecurityPolicyName"],"members":{"SecurityPolicyName":{}}},"output":{"type":"structure","required":["SecurityPolicy"],"members":{"SecurityPolicy":{"type":"structure","required":["SecurityPolicyName"],"members":{"Fips":{"type":"boolean"},"SecurityPolicyName":{},"SshCiphers":{"shape":"S38"},"SshKexs":{"shape":"S38"},"SshMacs":{"shape":"S38"},"TlsCiphers":{"shape":"S38"}}}}}},"DescribeServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}},"output":{"type":"structure","required":["Server"],"members":{"Server":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Certificate":{},"ProtocolDetails":{"shape":"S13"},"Domain":{},"EndpointDetails":{"shape":"Sj"},"EndpointType":{},"HostKeyFingerprint":{},"IdentityProviderDetails":{"shape":"Su"},"IdentityProviderType":{},"LoggingRole":{},"PostAuthenticationLoginBanner":{},"PreAuthenticationLoginBanner":{},"Protocols":{"shape":"S11"},"SecurityPolicyName":{},"ServerId":{},"State":{},"Tags":{"shape":"S17"},"UserCount":{"type":"integer"},"WorkflowDetails":{"shape":"S1b"}}}}}},"DescribeUser":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}},"output":{"type":"structure","required":["ServerId","User"],"members":{"ServerId":{},"User":{"type":"structure","required":["Arn"],"members":{"Arn":{},"HomeDirectory":{},"HomeDirectoryMappings":{"shape":"S4"},"HomeDirectoryType":{},"Policy":{},"PosixProfile":{"shape":"S9"},"Role":{},"SshPublicKeys":{"type":"list","member":{"type":"structure","required":["DateImported","SshPublicKeyBody","SshPublicKeyId"],"members":{"DateImported":{"type":"timestamp"},"SshPublicKeyBody":{},"SshPublicKeyId":{}}}},"Tags":{"shape":"S17"},"UserName":{}}}}}},"DescribeWorkflow":{"input":{"type":"structure","required":["WorkflowId"],"members":{"WorkflowId":{}}},"output":{"type":"structure","required":["Workflow"],"members":{"Workflow":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Description":{},"Steps":{"shape":"S1m"},"OnExceptionSteps":{"shape":"S1m"},"WorkflowId":{},"Tags":{"shape":"S17"}}}}}},"ImportSshPublicKey":{"input":{"type":"structure","required":["ServerId","SshPublicKeyBody","UserName"],"members":{"ServerId":{},"SshPublicKeyBody":{},"UserName":{}}},"output":{"type":"structure","required":["ServerId","SshPublicKeyId","UserName"],"members":{"ServerId":{},"SshPublicKeyId":{},"UserName":{}}}},"ListAccesses":{"input":{"type":"structure","required":["ServerId"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"ServerId":{}}},"output":{"type":"structure","required":["ServerId","Accesses"],"members":{"NextToken":{},"ServerId":{},"Accesses":{"type":"list","member":{"type":"structure","members":{"HomeDirectory":{},"HomeDirectoryType":{},"Role":{},"ExternalId":{}}}}}}},"ListExecutions":{"input":{"type":"structure","required":["WorkflowId"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"WorkflowId":{}}},"output":{"type":"structure","required":["WorkflowId","Executions"],"members":{"NextToken":{},"WorkflowId":{},"Executions":{"type":"list","member":{"type":"structure","members":{"ExecutionId":{},"InitialFileLocation":{"shape":"S2n"},"ServiceMetadata":{"shape":"S2r"},"Status":{}}}}}}},"ListSecurityPolicies":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["SecurityPolicyNames"],"members":{"NextToken":{},"SecurityPolicyNames":{"type":"list","member":{}}}}},"ListServers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Servers"],"members":{"NextToken":{},"Servers":{"type":"list","member":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Domain":{},"IdentityProviderType":{},"EndpointType":{},"LoggingRole":{},"ServerId":{},"State":{},"UserCount":{"type":"integer"}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Arn":{},"NextToken":{},"Tags":{"shape":"S17"}}}},"ListUsers":{"input":{"type":"structure","required":["ServerId"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"ServerId":{}}},"output":{"type":"structure","required":["ServerId","Users"],"members":{"NextToken":{},"ServerId":{},"Users":{"type":"list","member":{"type":"structure","required":["Arn"],"members":{"Arn":{},"HomeDirectory":{},"HomeDirectoryType":{},"Role":{},"SshPublicKeyCount":{"type":"integer"},"UserName":{}}}}}}},"ListWorkflows":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Workflows"],"members":{"NextToken":{},"Workflows":{"type":"list","member":{"type":"structure","members":{"WorkflowId":{},"Description":{},"Arn":{}}}}}}},"SendWorkflowStepState":{"input":{"type":"structure","required":["WorkflowId","ExecutionId","Token","Status"],"members":{"WorkflowId":{},"ExecutionId":{},"Token":{},"Status":{}}},"output":{"type":"structure","members":{}}},"StartServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"StopServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"TagResource":{"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{},"Tags":{"shape":"S17"}}}},"TestIdentityProvider":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"ServerProtocol":{},"SourceIp":{},"UserName":{},"UserPassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["StatusCode","Url"],"members":{"Response":{},"StatusCode":{"type":"integer"},"Message":{},"Url":{}}}},"UntagResource":{"input":{"type":"structure","required":["Arn","TagKeys"],"members":{"Arn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAccess":{"input":{"type":"structure","required":["ServerId","ExternalId"],"members":{"HomeDirectory":{},"HomeDirectoryType":{},"HomeDirectoryMappings":{"shape":"S4"},"Policy":{},"PosixProfile":{"shape":"S9"},"Role":{},"ServerId":{},"ExternalId":{}}},"output":{"type":"structure","required":["ServerId","ExternalId"],"members":{"ServerId":{},"ExternalId":{}}}},"UpdateServer":{"input":{"type":"structure","required":["ServerId"],"members":{"Certificate":{},"ProtocolDetails":{"shape":"S13"},"EndpointDetails":{"shape":"Sj"},"EndpointType":{},"HostKey":{"shape":"St"},"IdentityProviderDetails":{"shape":"Su"},"LoggingRole":{},"PostAuthenticationLoginBanner":{},"PreAuthenticationLoginBanner":{},"Protocols":{"shape":"S11"},"SecurityPolicyName":{},"ServerId":{},"WorkflowDetails":{"shape":"S1b"}}},"output":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"UpdateUser":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"HomeDirectory":{},"HomeDirectoryType":{},"HomeDirectoryMappings":{"shape":"S4"},"Policy":{},"PosixProfile":{"shape":"S9"},"Role":{},"ServerId":{},"UserName":{}}},"output":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Entry","Target"],"members":{"Entry":{},"Target":{}}}},"S9":{"type":"structure","required":["Uid","Gid"],"members":{"Uid":{"type":"long"},"Gid":{"type":"long"},"SecondaryGids":{"type":"list","member":{"type":"long"}}}},"Sj":{"type":"structure","members":{"AddressAllocationIds":{"type":"list","member":{}},"SubnetIds":{"type":"list","member":{}},"VpcEndpointId":{},"VpcId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"St":{"type":"string","sensitive":true},"Su":{"type":"structure","members":{"Url":{},"InvocationRole":{},"DirectoryId":{},"Function":{}}},"S11":{"type":"list","member":{}},"S13":{"type":"structure","members":{"PassiveIp":{},"TlsSessionResumptionMode":{}}},"S17":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1b":{"type":"structure","required":["OnUpload"],"members":{"OnUpload":{"type":"list","member":{"type":"structure","required":["WorkflowId","ExecutionRole"],"members":{"WorkflowId":{},"ExecutionRole":{}}}}}},"S1m":{"type":"list","member":{"type":"structure","members":{"Type":{},"CopyStepDetails":{"type":"structure","members":{"Name":{},"DestinationFileLocation":{"type":"structure","members":{"S3FileLocation":{"type":"structure","members":{"Bucket":{},"Key":{}}},"EfsFileLocation":{"shape":"S1v"}}},"OverwriteExisting":{},"SourceFileLocation":{}}},"CustomStepDetails":{"type":"structure","members":{"Name":{},"Target":{},"TimeoutSeconds":{"type":"integer"},"SourceFileLocation":{}}},"DeleteStepDetails":{"type":"structure","members":{"Name":{},"SourceFileLocation":{}}},"TagStepDetails":{"type":"structure","members":{"Name":{},"Tags":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"SourceFileLocation":{}}}}}},"S1v":{"type":"structure","members":{"FileSystemId":{},"Path":{}}},"S2n":{"type":"structure","members":{"S3FileLocation":{"type":"structure","members":{"Bucket":{},"Key":{},"VersionId":{},"Etag":{}}},"EfsFileLocation":{"shape":"S1v"}}},"S2r":{"type":"structure","required":["UserDetails"],"members":{"UserDetails":{"type":"structure","required":["UserName","ServerId"],"members":{"UserName":{},"ServerId":{},"SessionId":{}}}}},"S2y":{"type":"list","member":{"type":"structure","members":{"StepType":{},"Outputs":{},"Error":{"type":"structure","required":["Type","Message"],"members":{"Type":{},"Message":{}}}}}},"S38":{"type":"list","member":{}}}}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccesses":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ServerId"],"output_token":"NextToken","result_key":"Accesses"},"ListExecutions":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["WorkflowId"],"output_token":"NextToken","result_key":"Executions"},"ListSecurityPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityPolicyNames"},"ListServers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Servers"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["Arn"],"output_token":"NextToken","result_key":"Tags"},"ListUsers":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ServerId"],"output_token":"NextToken","result_key":"Users"},"ListWorkflows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Workflows"}}}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ServerOffline":{"acceptors":[{"argument":"Server.State","expected":"OFFLINE","matcher":"path","state":"success"},{"argument":"Server.State","expected":"STOP_FAILED","matcher":"path","state":"failure"}],"delay":30,"maxAttempts":120,"operation":"DescribeServer","type":"api"},"ServerOnline":{"acceptors":[{"argument":"Server.State","expected":"ONLINE","matcher":"path","state":"success"},{"argument":"Server.State","expected":"START_FAILED","matcher":"path","state":"failure"}],"delay":30,"maxAttempts":120,"operation":"DescribeServer","type":"api"}}}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['globalaccelerator'] = {};
	AWS.GlobalAccelerator = Service.defineService('globalaccelerator', ['2018-08-08']);
	Object.defineProperty(apiLoader.services['globalaccelerator'], '2018-08-08', {
	  get: function get() {
	    var model = __webpack_require__(681);
	    model.paginators = __webpack_require__(682).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.GlobalAccelerator;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-08-08","endpointPrefix":"globalaccelerator","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Global Accelerator","serviceId":"Global Accelerator","signatureVersion":"v4","signingName":"globalaccelerator","targetPrefix":"GlobalAccelerator_V20180706","uid":"globalaccelerator-2018-08-08"},"operations":{"AddCustomRoutingEndpoints":{"input":{"type":"structure","required":["EndpointConfigurations","EndpointGroupArn"],"members":{"EndpointConfigurations":{"type":"list","member":{"type":"structure","members":{"EndpointId":{}}}},"EndpointGroupArn":{}}},"output":{"type":"structure","members":{"EndpointDescriptions":{"shape":"S6"},"EndpointGroupArn":{}}}},"AdvertiseByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"Sa"}}}},"AllowCustomRoutingTraffic":{"input":{"type":"structure","required":["EndpointGroupArn","EndpointId"],"members":{"EndpointGroupArn":{},"EndpointId":{},"DestinationAddresses":{"shape":"Sg"},"DestinationPorts":{"shape":"Si"},"AllowAllTrafficToEndpoint":{"type":"boolean"}}}},"CreateAccelerator":{"input":{"type":"structure","required":["Name","IdempotencyToken"],"members":{"Name":{},"IpAddressType":{},"IpAddresses":{"shape":"Sn"},"Enabled":{"type":"boolean"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"Sp"}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"Su"}}}},"CreateCustomRoutingAccelerator":{"input":{"type":"structure","required":["Name","IdempotencyToken"],"members":{"Name":{},"IpAddressType":{},"IpAddresses":{"shape":"Sn"},"Enabled":{"type":"boolean"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"Sp"}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"S10"}}}},"CreateCustomRoutingEndpointGroup":{"input":{"type":"structure","required":["ListenerArn","EndpointGroupRegion","DestinationConfigurations","IdempotencyToken"],"members":{"ListenerArn":{},"EndpointGroupRegion":{},"DestinationConfigurations":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","Protocols"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"Protocols":{"shape":"S15"}}}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"S18"}}}},"CreateCustomRoutingListener":{"input":{"type":"structure","required":["AcceleratorArn","PortRanges","IdempotencyToken"],"members":{"AcceleratorArn":{},"PortRanges":{"shape":"S1e"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Listener":{"shape":"S1h"}}}},"CreateEndpointGroup":{"input":{"type":"structure","required":["ListenerArn","EndpointGroupRegion","IdempotencyToken"],"members":{"ListenerArn":{},"EndpointGroupRegion":{},"EndpointConfigurations":{"shape":"S1j"},"TrafficDialPercentage":{"type":"float"},"HealthCheckPort":{"type":"integer"},"HealthCheckProtocol":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"ThresholdCount":{"type":"integer"},"IdempotencyToken":{"idempotencyToken":true},"PortOverrides":{"shape":"S1s"}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"S1v"}}}},"CreateListener":{"input":{"type":"structure","required":["AcceleratorArn","PortRanges","Protocol","IdempotencyToken"],"members":{"AcceleratorArn":{},"PortRanges":{"shape":"S1e"},"Protocol":{},"ClientAffinity":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Listener":{"shape":"S22"}}}},"DeleteAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}}},"DeleteCustomRoutingAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}}},"DeleteCustomRoutingEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{}}}},"DeleteCustomRoutingListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}}},"DeleteEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}}},"DenyCustomRoutingTraffic":{"input":{"type":"structure","required":["EndpointGroupArn","EndpointId"],"members":{"EndpointGroupArn":{},"EndpointId":{},"DestinationAddresses":{"shape":"Sg"},"DestinationPorts":{"shape":"Si"},"DenyAllTrafficToEndpoint":{"type":"boolean"}}}},"DeprovisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"Sa"}}}},"DescribeAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"Su"}}}},"DescribeAcceleratorAttributes":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}},"output":{"type":"structure","members":{"AcceleratorAttributes":{"shape":"S2g"}}}},"DescribeCustomRoutingAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"S10"}}}},"DescribeCustomRoutingAcceleratorAttributes":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}},"output":{"type":"structure","members":{"AcceleratorAttributes":{"shape":"S2l"}}}},"DescribeCustomRoutingEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"S18"}}}},"DescribeCustomRoutingListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"type":"structure","members":{"Listener":{"shape":"S1h"}}}},"DescribeEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"S1v"}}}},"DescribeListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"type":"structure","members":{"Listener":{"shape":"S22"}}}},"ListAccelerators":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Accelerators":{"type":"list","member":{"shape":"Su"}},"NextToken":{}}}},"ListByoipCidrs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ByoipCidrs":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"ListCustomRoutingAccelerators":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Accelerators":{"type":"list","member":{"shape":"S10"}},"NextToken":{}}}},"ListCustomRoutingEndpointGroups":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EndpointGroups":{"type":"list","member":{"shape":"S18"}},"NextToken":{}}}},"ListCustomRoutingListeners":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Listeners":{"type":"list","member":{"shape":"S1h"}},"NextToken":{}}}},"ListCustomRoutingPortMappings":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"EndpointGroupArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PortMappings":{"type":"list","member":{"type":"structure","members":{"AcceleratorPort":{"type":"integer"},"EndpointGroupArn":{},"EndpointId":{},"DestinationSocketAddress":{"shape":"S3f"},"Protocols":{"shape":"S15"},"DestinationTrafficState":{}}}},"NextToken":{}}}},"ListCustomRoutingPortMappingsByDestination":{"input":{"type":"structure","required":["EndpointId","DestinationAddress"],"members":{"EndpointId":{},"DestinationAddress":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DestinationPortMappings":{"type":"list","member":{"type":"structure","members":{"AcceleratorArn":{},"AcceleratorSocketAddresses":{"type":"list","member":{"shape":"S3f"}},"EndpointGroupArn":{},"EndpointId":{},"EndpointGroupRegion":{},"DestinationSocketAddress":{"shape":"S3f"},"IpAddressType":{},"DestinationTrafficState":{}}}},"NextToken":{}}}},"ListEndpointGroups":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EndpointGroups":{"type":"list","member":{"shape":"S1v"}},"NextToken":{}}}},"ListListeners":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Listeners":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sp"}}}},"ProvisionByoipCidr":{"input":{"type":"structure","required":["Cidr","CidrAuthorizationContext"],"members":{"Cidr":{},"CidrAuthorizationContext":{"type":"structure","required":["Message","Signature"],"members":{"Message":{},"Signature":{}}}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"Sa"}}}},"RemoveCustomRoutingEndpoints":{"input":{"type":"structure","required":["EndpointIds","EndpointGroupArn"],"members":{"EndpointIds":{"type":"list","member":{}},"EndpointGroupArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sp"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"Su"}}}},"UpdateAcceleratorAttributes":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"FlowLogsEnabled":{"type":"boolean"},"FlowLogsS3Bucket":{},"FlowLogsS3Prefix":{}}},"output":{"type":"structure","members":{"AcceleratorAttributes":{"shape":"S2g"}}}},"UpdateCustomRoutingAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"S10"}}}},"UpdateCustomRoutingAcceleratorAttributes":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"FlowLogsEnabled":{"type":"boolean"},"FlowLogsS3Bucket":{},"FlowLogsS3Prefix":{}}},"output":{"type":"structure","members":{"AcceleratorAttributes":{"shape":"S2l"}}}},"UpdateCustomRoutingListener":{"input":{"type":"structure","required":["ListenerArn","PortRanges"],"members":{"ListenerArn":{},"PortRanges":{"shape":"S1e"}}},"output":{"type":"structure","members":{"Listener":{"shape":"S1h"}}}},"UpdateEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{},"EndpointConfigurations":{"shape":"S1j"},"TrafficDialPercentage":{"type":"float"},"HealthCheckPort":{"type":"integer"},"HealthCheckProtocol":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"ThresholdCount":{"type":"integer"},"PortOverrides":{"shape":"S1s"}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"S1v"}}}},"UpdateListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"PortRanges":{"shape":"S1e"},"Protocol":{},"ClientAffinity":{}}},"output":{"type":"structure","members":{"Listener":{"shape":"S22"}}}},"WithdrawByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"Sa"}}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","members":{"EndpointId":{}}}},"Sa":{"type":"structure","members":{"Cidr":{},"State":{},"Events":{"type":"list","member":{"type":"structure","members":{"Message":{},"Timestamp":{"type":"timestamp"}}}}}},"Sg":{"type":"list","member":{}},"Si":{"type":"list","member":{"type":"integer"}},"Sn":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Su":{"type":"structure","members":{"AcceleratorArn":{},"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"},"IpSets":{"shape":"Sv"},"DnsName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"IpFamily":{},"IpAddresses":{"shape":"Sn"}}}},"S10":{"type":"structure","members":{"AcceleratorArn":{},"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"},"IpSets":{"shape":"Sv"},"DnsName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}},"S15":{"type":"list","member":{}},"S18":{"type":"structure","members":{"EndpointGroupArn":{},"EndpointGroupRegion":{},"DestinationDescriptions":{"type":"list","member":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"Protocols":{"type":"list","member":{}}}}},"EndpointDescriptions":{"shape":"S6"}}},"S1e":{"type":"list","member":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}}},"S1h":{"type":"structure","members":{"ListenerArn":{},"PortRanges":{"shape":"S1e"}}},"S1j":{"type":"list","member":{"type":"structure","members":{"EndpointId":{},"Weight":{"type":"integer"},"ClientIPPreservationEnabled":{"type":"boolean"}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"ListenerPort":{"type":"integer"},"EndpointPort":{"type":"integer"}}}},"S1v":{"type":"structure","members":{"EndpointGroupArn":{},"EndpointGroupRegion":{},"EndpointDescriptions":{"type":"list","member":{"type":"structure","members":{"EndpointId":{},"Weight":{"type":"integer"},"HealthState":{},"HealthReason":{},"ClientIPPreservationEnabled":{"type":"boolean"}}}},"TrafficDialPercentage":{"type":"float"},"HealthCheckPort":{"type":"integer"},"HealthCheckProtocol":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"ThresholdCount":{"type":"integer"},"PortOverrides":{"shape":"S1s"}}},"S22":{"type":"structure","members":{"ListenerArn":{},"PortRanges":{"shape":"S1e"},"Protocol":{},"ClientAffinity":{}}},"S2g":{"type":"structure","members":{"FlowLogsEnabled":{"type":"boolean"},"FlowLogsS3Bucket":{},"FlowLogsS3Prefix":{}}},"S2l":{"type":"structure","members":{"FlowLogsEnabled":{"type":"boolean"},"FlowLogsS3Bucket":{},"FlowLogsS3Prefix":{}}},"S3f":{"type":"structure","members":{"IpAddress":{},"Port":{"type":"integer"}}}}}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccelerators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Accelerators"},"ListByoipCidrs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ByoipCidrs"},"ListCustomRoutingAccelerators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Accelerators"},"ListCustomRoutingEndpointGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCustomRoutingListeners":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Listeners"},"ListCustomRoutingPortMappings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PortMappings"},"ListCustomRoutingPortMappingsByDestination":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DestinationPortMappings"},"ListEndpointGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EndpointGroups"},"ListListeners":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Listeners"}}}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['comprehendmedical'] = {};
	AWS.ComprehendMedical = Service.defineService('comprehendmedical', ['2018-10-30']);
	Object.defineProperty(apiLoader.services['comprehendmedical'], '2018-10-30', {
	  get: function get() {
	    var model = __webpack_require__(684);
	    model.paginators = __webpack_require__(685).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ComprehendMedical;


/***/ }),
/* 684 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-30","endpointPrefix":"comprehendmedical","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ComprehendMedical","serviceFullName":"AWS Comprehend Medical","serviceId":"ComprehendMedical","signatureVersion":"v4","signingName":"comprehendmedical","targetPrefix":"ComprehendMedical_20181030","uid":"comprehendmedical-2018-10-30"},"operations":{"DescribeEntitiesDetectionV2Job":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeICD10CMInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribePHIDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeRxNormInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeSNOMEDCTInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DetectEntities":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"St"},"UnmappedAttributes":{"shape":"S16"},"PaginationToken":{},"ModelVersion":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use DetectEntitiesV2 instead."},"DetectEntitiesV2":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"St"},"UnmappedAttributes":{"shape":"S16"},"PaginationToken":{},"ModelVersion":{}}}},"DetectPHI":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"St"},"PaginationToken":{},"ModelVersion":{}}}},"InferICD10CM":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S1m"},"Category":{},"RelationshipType":{}}}},"Traits":{"shape":"S1m"},"ICD10CMConcepts":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}}}}},"PaginationToken":{},"ModelVersion":{}}}},"InferRxNorm":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S21"}}}},"Traits":{"shape":"S21"},"RxNormConcepts":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}}}}},"PaginationToken":{},"ModelVersion":{}}}},"InferSNOMEDCT":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Category":{},"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"RelationshipType":{},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S2g"},"SNOMEDCTConcepts":{"shape":"S2j"}}}},"Traits":{"shape":"S2g"},"SNOMEDCTConcepts":{"shape":"S2j"}}}},"PaginationToken":{},"ModelVersion":{},"SNOMEDCTDetails":{"type":"structure","members":{"Edition":{},"Language":{},"VersionDate":{}}},"Characters":{"type":"structure","members":{"OriginalTextCharacters":{"type":"integer"}}}}}},"ListEntitiesDetectionV2Jobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListICD10CMInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListPHIDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListRxNormInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListSNOMEDCTInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"StartEntitiesDetectionV2Job":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartICD10CMInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartPHIDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartRxNormInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartSNOMEDCTInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopEntitiesDetectionV2Job":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopICD10CMInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopPHIDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopRxNormInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopSNOMEDCTInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}}},"shapes":{"S4":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"LanguageCode":{},"DataAccessRoleArn":{},"ManifestFilePath":{},"KMSKey":{},"ModelVersion":{}}},"S9":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Key":{}}},"Sc":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Key":{}}},"St":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Score":{"type":"float"},"Text":{},"Category":{},"Type":{},"Traits":{"shape":"S10"},"Attributes":{"type":"list","member":{"shape":"S14"}}}}},"S10":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S14":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"RelationshipType":{},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Category":{},"Traits":{"shape":"S10"}}},"S16":{"type":"list","member":{"type":"structure","members":{"Type":{},"Attribute":{"shape":"S14"}}}},"S1m":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S21":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S2g":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S2j":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}},"S2o":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"S2r":{"type":"list","member":{"shape":"S4"}}}}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesisanalyticsv2'] = {};
	AWS.KinesisAnalyticsV2 = Service.defineService('kinesisanalyticsv2', ['2018-05-23']);
	Object.defineProperty(apiLoader.services['kinesisanalyticsv2'], '2018-05-23', {
	  get: function get() {
	    var model = __webpack_require__(687);
	    model.paginators = __webpack_require__(688).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KinesisAnalyticsV2;


/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-23","endpointPrefix":"kinesisanalytics","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Kinesis Analytics V2","serviceFullName":"Amazon Kinesis Analytics","serviceId":"Kinesis Analytics V2","signatureVersion":"v4","signingName":"kinesisanalytics","targetPrefix":"KinesisAnalytics_20180523","uid":"kinesisanalyticsv2-2018-05-23"},"operations":{"AddApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CloudWatchLoggingOption"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOption":{"shape":"S4"},"ConditionalToken":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionDescriptions":{"shape":"S9"}}}},"AddApplicationInput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Input"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Input":{"shape":"Se"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"InputDescriptions":{"shape":"S12"}}}},"AddApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId","InputProcessingConfiguration"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{},"InputProcessingConfiguration":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"InputId":{},"InputProcessingConfigurationDescription":{"shape":"S15"}}}},"AddApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Output"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Output":{"shape":"S1e"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"OutputDescriptions":{"shape":"S1k"}}}},"AddApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceDataSource"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceDataSource":{"shape":"S1q"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"ReferenceDataSourceDescriptions":{"shape":"S1w"}}}},"AddApplicationVpcConfiguration":{"input":{"type":"structure","required":["ApplicationName","VpcConfiguration"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"VpcConfiguration":{"shape":"S20"},"ConditionalToken":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"VpcConfigurationDescription":{"shape":"S26"}}}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName","RuntimeEnvironment","ServiceExecutionRole"],"members":{"ApplicationName":{},"ApplicationDescription":{},"RuntimeEnvironment":{},"ServiceExecutionRole":{},"ApplicationConfiguration":{"type":"structure","members":{"SqlApplicationConfiguration":{"type":"structure","members":{"Inputs":{"type":"list","member":{"shape":"Se"}},"Outputs":{"type":"list","member":{"shape":"S1e"}},"ReferenceDataSources":{"type":"list","member":{"shape":"S1q"}}}},"FlinkApplicationConfiguration":{"type":"structure","members":{"CheckpointConfiguration":{"type":"structure","required":["ConfigurationType"],"members":{"ConfigurationType":{},"CheckpointingEnabled":{"type":"boolean"},"CheckpointInterval":{"type":"long"},"MinPauseBetweenCheckpoints":{"type":"long"}}},"MonitoringConfiguration":{"type":"structure","required":["ConfigurationType"],"members":{"ConfigurationType":{},"MetricsLevel":{},"LogLevel":{}}},"ParallelismConfiguration":{"type":"structure","required":["ConfigurationType"],"members":{"ConfigurationType":{},"Parallelism":{"type":"integer"},"ParallelismPerKPU":{"type":"integer"},"AutoScalingEnabled":{"type":"boolean"}}}}},"EnvironmentProperties":{"type":"structure","required":["PropertyGroups"],"members":{"PropertyGroups":{"shape":"S2t"}}},"ApplicationCodeConfiguration":{"type":"structure","required":["CodeContentType"],"members":{"CodeContent":{"type":"structure","members":{"TextContent":{},"ZipFileContent":{"type":"blob"},"S3ContentLocation":{"shape":"S32"}}},"CodeContentType":{}}},"ApplicationSnapshotConfiguration":{"type":"structure","required":["SnapshotsEnabled"],"members":{"SnapshotsEnabled":{"type":"boolean"}}},"VpcConfigurations":{"type":"list","member":{"shape":"S20"}},"ZeppelinApplicationConfiguration":{"type":"structure","members":{"MonitoringConfiguration":{"type":"structure","required":["LogLevel"],"members":{"LogLevel":{}}},"CatalogConfiguration":{"type":"structure","required":["GlueDataCatalogConfiguration"],"members":{"GlueDataCatalogConfiguration":{"type":"structure","required":["DatabaseARN"],"members":{"DatabaseARN":{}}}}},"DeployAsApplicationConfiguration":{"type":"structure","required":["S3ContentLocation"],"members":{"S3ContentLocation":{"type":"structure","required":["BucketARN"],"members":{"BucketARN":{},"BasePath":{}}}}},"CustomArtifactsConfiguration":{"shape":"S3f"}}}}},"CloudWatchLoggingOptions":{"type":"list","member":{"shape":"S4"}},"Tags":{"shape":"S3n"},"ApplicationMode":{}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S3t"}}}},"CreateApplicationPresignedUrl":{"input":{"type":"structure","required":["ApplicationName","UrlType"],"members":{"ApplicationName":{},"UrlType":{},"SessionExpirationDurationInSeconds":{"type":"long"}}},"output":{"type":"structure","members":{"AuthorizedUrl":{}}}},"CreateApplicationSnapshot":{"input":{"type":"structure","required":["ApplicationName","SnapshotName"],"members":{"ApplicationName":{},"SnapshotName":{}}},"output":{"type":"structure","members":{}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName","CreateTimestamp"],"members":{"ApplicationName":{},"CreateTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"DeleteApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CloudWatchLoggingOptionId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionId":{},"ConditionalToken":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionDescriptions":{"shape":"S9"}}}},"DeleteApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DeleteApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","OutputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"OutputId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DeleteApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DeleteApplicationSnapshot":{"input":{"type":"structure","required":["ApplicationName","SnapshotName","SnapshotCreationTimestamp"],"members":{"ApplicationName":{},"SnapshotName":{},"SnapshotCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"DeleteApplicationVpcConfiguration":{"input":{"type":"structure","required":["ApplicationName","VpcConfigurationId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"VpcConfigurationId":{},"ConditionalToken":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DescribeApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"IncludeAdditionalDetails":{"type":"boolean"}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S3t"}}}},"DescribeApplicationSnapshot":{"input":{"type":"structure","required":["ApplicationName","SnapshotName"],"members":{"ApplicationName":{},"SnapshotName":{}}},"output":{"type":"structure","required":["SnapshotDetails"],"members":{"SnapshotDetails":{"shape":"S5g"}}}},"DescribeApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","ApplicationVersionId"],"members":{"ApplicationName":{},"ApplicationVersionId":{"type":"long"}}},"output":{"type":"structure","members":{"ApplicationVersionDetail":{"shape":"S3t"}}}},"DiscoverInputSchema":{"input":{"type":"structure","required":["ServiceExecutionRole"],"members":{"ResourceARN":{},"ServiceExecutionRole":{},"InputStartingPositionConfiguration":{"shape":"S19"},"S3Configuration":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{}}},"InputProcessingConfiguration":{"shape":"Sg"}}},"output":{"type":"structure","members":{"InputSchema":{"shape":"Sm"},"ParsedInputRecords":{"type":"list","member":{"type":"list","member":{}}},"ProcessedInputRecords":{"type":"list","member":{}},"RawInputRecords":{"type":"list","member":{}}}}},"ListApplicationSnapshots":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SnapshotSummaries":{"type":"list","member":{"shape":"S5g"}},"NextToken":{}}}},"ListApplicationVersions":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationVersionSummaries":{"type":"list","member":{"type":"structure","required":["ApplicationVersionId","ApplicationStatus"],"members":{"ApplicationVersionId":{"type":"long"},"ApplicationStatus":{}}}},"NextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ApplicationSummaries"],"members":{"ApplicationSummaries":{"type":"list","member":{"type":"structure","required":["ApplicationName","ApplicationARN","ApplicationStatus","ApplicationVersionId","RuntimeEnvironment"],"members":{"ApplicationName":{},"ApplicationARN":{},"ApplicationStatus":{},"ApplicationVersionId":{"type":"long"},"RuntimeEnvironment":{},"ApplicationMode":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3n"}}}},"RollbackApplication":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S3t"}}}},"StartApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"RunConfiguration":{"type":"structure","members":{"FlinkRunConfiguration":{"shape":"S47"},"SqlRunConfigurations":{"type":"list","member":{"type":"structure","required":["InputId","InputStartingPositionConfiguration"],"members":{"InputId":{},"InputStartingPositionConfiguration":{"shape":"S19"}}}},"ApplicationRestoreConfiguration":{"shape":"S44"}}}}},"output":{"type":"structure","members":{}}},"StopApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S3n"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ApplicationConfigurationUpdate":{"type":"structure","members":{"SqlApplicationConfigurationUpdate":{"type":"structure","members":{"InputUpdates":{"type":"list","member":{"type":"structure","required":["InputId"],"members":{"InputId":{},"NamePrefixUpdate":{},"InputProcessingConfigurationUpdate":{"type":"structure","required":["InputLambdaProcessorUpdate"],"members":{"InputLambdaProcessorUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}}}},"KinesisStreamsInputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"KinesisFirehoseInputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"InputSchemaUpdate":{"type":"structure","members":{"RecordFormatUpdate":{"shape":"Sn"},"RecordEncodingUpdate":{},"RecordColumnUpdates":{"shape":"Sw"}}},"InputParallelismUpdate":{"type":"structure","required":["CountUpdate"],"members":{"CountUpdate":{"type":"integer"}}}}}},"OutputUpdates":{"type":"list","member":{"type":"structure","required":["OutputId"],"members":{"OutputId":{},"NameUpdate":{},"KinesisStreamsOutputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"KinesisFirehoseOutputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"LambdaOutputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"DestinationSchemaUpdate":{"shape":"S1i"}}}},"ReferenceDataSourceUpdates":{"type":"list","member":{"type":"structure","required":["ReferenceId"],"members":{"ReferenceId":{},"TableNameUpdate":{},"S3ReferenceDataSourceUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"FileKeyUpdate":{}}},"ReferenceSchemaUpdate":{"shape":"Sm"}}}}}},"ApplicationCodeConfigurationUpdate":{"type":"structure","members":{"CodeContentTypeUpdate":{},"CodeContentUpdate":{"type":"structure","members":{"TextContentUpdate":{},"ZipFileContentUpdate":{"type":"blob"},"S3ContentLocationUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"FileKeyUpdate":{},"ObjectVersionUpdate":{}}}}}}},"FlinkApplicationConfigurationUpdate":{"type":"structure","members":{"CheckpointConfigurationUpdate":{"type":"structure","members":{"ConfigurationTypeUpdate":{},"CheckpointingEnabledUpdate":{"type":"boolean"},"CheckpointIntervalUpdate":{"type":"long"},"MinPauseBetweenCheckpointsUpdate":{"type":"long"}}},"MonitoringConfigurationUpdate":{"type":"structure","members":{"ConfigurationTypeUpdate":{},"MetricsLevelUpdate":{},"LogLevelUpdate":{}}},"ParallelismConfigurationUpdate":{"type":"structure","members":{"ConfigurationTypeUpdate":{},"ParallelismUpdate":{"type":"integer"},"ParallelismPerKPUUpdate":{"type":"integer"},"AutoScalingEnabledUpdate":{"type":"boolean"}}}}},"EnvironmentPropertyUpdates":{"type":"structure","required":["PropertyGroups"],"members":{"PropertyGroups":{"shape":"S2t"}}},"ApplicationSnapshotConfigurationUpdate":{"type":"structure","required":["SnapshotsEnabledUpdate"],"members":{"SnapshotsEnabledUpdate":{"type":"boolean"}}},"VpcConfigurationUpdates":{"type":"list","member":{"type":"structure","required":["VpcConfigurationId"],"members":{"VpcConfigurationId":{},"SubnetIdUpdates":{"shape":"S21"},"SecurityGroupIdUpdates":{"shape":"S23"}}}},"ZeppelinApplicationConfigurationUpdate":{"type":"structure","members":{"MonitoringConfigurationUpdate":{"type":"structure","required":["LogLevelUpdate"],"members":{"LogLevelUpdate":{}}},"CatalogConfigurationUpdate":{"type":"structure","required":["GlueDataCatalogConfigurationUpdate"],"members":{"GlueDataCatalogConfigurationUpdate":{"type":"structure","required":["DatabaseARNUpdate"],"members":{"DatabaseARNUpdate":{}}}}},"DeployAsApplicationConfigurationUpdate":{"type":"structure","members":{"S3ContentLocationUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"BasePathUpdate":{}}}}},"CustomArtifactsConfigurationUpdate":{"shape":"S3f"}}}}},"ServiceExecutionRoleUpdate":{},"RunConfigurationUpdate":{"type":"structure","members":{"FlinkRunConfiguration":{"shape":"S47"},"ApplicationRestoreConfiguration":{"shape":"S44"}}},"CloudWatchLoggingOptionUpdates":{"type":"list","member":{"type":"structure","required":["CloudWatchLoggingOptionId"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARNUpdate":{}}}},"ConditionalToken":{}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S3t"}}}},"UpdateApplicationMaintenanceConfiguration":{"input":{"type":"structure","required":["ApplicationName","ApplicationMaintenanceConfigurationUpdate"],"members":{"ApplicationName":{},"ApplicationMaintenanceConfigurationUpdate":{"type":"structure","required":["ApplicationMaintenanceWindowStartTimeUpdate"],"members":{"ApplicationMaintenanceWindowStartTimeUpdate":{}}}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationMaintenanceConfigurationDescription":{"shape":"S4o"}}}}},"shapes":{"S4":{"type":"structure","required":["LogStreamARN"],"members":{"LogStreamARN":{}}},"S9":{"type":"list","member":{"type":"structure","required":["LogStreamARN"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARN":{},"RoleARN":{}}}},"Se":{"type":"structure","required":["NamePrefix","InputSchema"],"members":{"NamePrefix":{},"InputProcessingConfiguration":{"shape":"Sg"},"KinesisStreamsInput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"KinesisFirehoseInput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"InputParallelism":{"shape":"Sk"},"InputSchema":{"shape":"Sm"}}},"Sg":{"type":"structure","required":["InputLambdaProcessor"],"members":{"InputLambdaProcessor":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}}}},"Sk":{"type":"structure","members":{"Count":{"type":"integer"}}},"Sm":{"type":"structure","required":["RecordFormat","RecordColumns"],"members":{"RecordFormat":{"shape":"Sn"},"RecordEncoding":{},"RecordColumns":{"shape":"Sw"}}},"Sn":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{},"MappingParameters":{"type":"structure","members":{"JSONMappingParameters":{"type":"structure","required":["RecordRowPath"],"members":{"RecordRowPath":{}}},"CSVMappingParameters":{"type":"structure","required":["RecordRowDelimiter","RecordColumnDelimiter"],"members":{"RecordRowDelimiter":{},"RecordColumnDelimiter":{}}}}}}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","SqlType"],"members":{"Name":{},"Mapping":{},"SqlType":{}}}},"S12":{"type":"list","member":{"type":"structure","members":{"InputId":{},"NamePrefix":{},"InAppStreamNames":{"type":"list","member":{}},"InputProcessingConfigurationDescription":{"shape":"S15"},"KinesisStreamsInputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseInputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"InputSchema":{"shape":"Sm"},"InputParallelism":{"shape":"Sk"},"InputStartingPositionConfiguration":{"shape":"S19"}}}},"S15":{"type":"structure","members":{"InputLambdaProcessorDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}}}},"S19":{"type":"structure","members":{"InputStartingPosition":{}}},"S1e":{"type":"structure","required":["Name","DestinationSchema"],"members":{"Name":{},"KinesisStreamsOutput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"KinesisFirehoseOutput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"LambdaOutput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"DestinationSchema":{"shape":"S1i"}}},"S1i":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{}}},"S1k":{"type":"list","member":{"type":"structure","members":{"OutputId":{},"Name":{},"KinesisStreamsOutputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseOutputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"LambdaOutputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"DestinationSchema":{"shape":"S1i"}}}},"S1q":{"type":"structure","required":["TableName","ReferenceSchema"],"members":{"TableName":{},"S3ReferenceDataSource":{"type":"structure","members":{"BucketARN":{},"FileKey":{}}},"ReferenceSchema":{"shape":"Sm"}}},"S1w":{"type":"list","member":{"type":"structure","required":["ReferenceId","TableName","S3ReferenceDataSourceDescription"],"members":{"ReferenceId":{},"TableName":{},"S3ReferenceDataSourceDescription":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{},"ReferenceRoleARN":{}}},"ReferenceSchema":{"shape":"Sm"}}}},"S20":{"type":"structure","required":["SubnetIds","SecurityGroupIds"],"members":{"SubnetIds":{"shape":"S21"},"SecurityGroupIds":{"shape":"S23"}}},"S21":{"type":"list","member":{}},"S23":{"type":"list","member":{}},"S26":{"type":"structure","required":["VpcConfigurationId","VpcId","SubnetIds","SecurityGroupIds"],"members":{"VpcConfigurationId":{},"VpcId":{},"SubnetIds":{"shape":"S21"},"SecurityGroupIds":{"shape":"S23"}}},"S2t":{"type":"list","member":{"type":"structure","required":["PropertyGroupId","PropertyMap"],"members":{"PropertyGroupId":{},"PropertyMap":{"type":"map","key":{},"value":{}}}}},"S32":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{},"ObjectVersion":{}}},"S3f":{"type":"list","member":{"type":"structure","required":["ArtifactType"],"members":{"ArtifactType":{},"S3ContentLocation":{"shape":"S32"},"MavenReference":{"shape":"S3i"}}}},"S3i":{"type":"structure","required":["GroupId","ArtifactId","Version"],"members":{"GroupId":{},"ArtifactId":{},"Version":{}}},"S3n":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S3t":{"type":"structure","required":["ApplicationARN","ApplicationName","RuntimeEnvironment","ApplicationStatus","ApplicationVersionId"],"members":{"ApplicationARN":{},"ApplicationDescription":{},"ApplicationName":{},"RuntimeEnvironment":{},"ServiceExecutionRole":{},"ApplicationStatus":{},"ApplicationVersionId":{"type":"long"},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"ApplicationConfigurationDescription":{"type":"structure","members":{"SqlApplicationConfigurationDescription":{"type":"structure","members":{"InputDescriptions":{"shape":"S12"},"OutputDescriptions":{"shape":"S1k"},"ReferenceDataSourceDescriptions":{"shape":"S1w"}}},"ApplicationCodeConfigurationDescription":{"type":"structure","required":["CodeContentType"],"members":{"CodeContentType":{},"CodeContentDescription":{"type":"structure","members":{"TextContent":{},"CodeMD5":{},"CodeSize":{"type":"long"},"S3ApplicationCodeLocationDescription":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{},"ObjectVersion":{}}}}}}},"RunConfigurationDescription":{"type":"structure","members":{"ApplicationRestoreConfigurationDescription":{"shape":"S44"},"FlinkRunConfigurationDescription":{"shape":"S47"}}},"FlinkApplicationConfigurationDescription":{"type":"structure","members":{"CheckpointConfigurationDescription":{"type":"structure","members":{"ConfigurationType":{},"CheckpointingEnabled":{"type":"boolean"},"CheckpointInterval":{"type":"long"},"MinPauseBetweenCheckpoints":{"type":"long"}}},"MonitoringConfigurationDescription":{"type":"structure","members":{"ConfigurationType":{},"MetricsLevel":{},"LogLevel":{}}},"ParallelismConfigurationDescription":{"type":"structure","members":{"ConfigurationType":{},"Parallelism":{"type":"integer"},"ParallelismPerKPU":{"type":"integer"},"CurrentParallelism":{"type":"integer"},"AutoScalingEnabled":{"type":"boolean"}}},"JobPlanDescription":{}}},"EnvironmentPropertyDescriptions":{"type":"structure","members":{"PropertyGroupDescriptions":{"shape":"S2t"}}},"ApplicationSnapshotConfigurationDescription":{"type":"structure","required":["SnapshotsEnabled"],"members":{"SnapshotsEnabled":{"type":"boolean"}}},"VpcConfigurationDescriptions":{"type":"list","member":{"shape":"S26"}},"ZeppelinApplicationConfigurationDescription":{"type":"structure","required":["MonitoringConfigurationDescription"],"members":{"MonitoringConfigurationDescription":{"type":"structure","members":{"LogLevel":{}}},"CatalogConfigurationDescription":{"type":"structure","required":["GlueDataCatalogConfigurationDescription"],"members":{"GlueDataCatalogConfigurationDescription":{"type":"structure","required":["DatabaseARN"],"members":{"DatabaseARN":{}}}}},"DeployAsApplicationConfigurationDescription":{"type":"structure","required":["S3ContentLocationDescription"],"members":{"S3ContentLocationDescription":{"type":"structure","required":["BucketARN"],"members":{"BucketARN":{},"BasePath":{}}}}},"CustomArtifactsConfigurationDescription":{"type":"list","member":{"type":"structure","members":{"ArtifactType":{},"S3ContentLocationDescription":{"shape":"S32"},"MavenReferenceDescription":{"shape":"S3i"}}}}}}}},"CloudWatchLoggingOptionDescriptions":{"shape":"S9"},"ApplicationMaintenanceConfigurationDescription":{"shape":"S4o"},"ApplicationVersionUpdatedFrom":{"type":"long"},"ApplicationVersionRolledBackFrom":{"type":"long"},"ConditionalToken":{},"ApplicationVersionRolledBackTo":{"type":"long"},"ApplicationMode":{}}},"S44":{"type":"structure","required":["ApplicationRestoreType"],"members":{"ApplicationRestoreType":{},"SnapshotName":{}}},"S47":{"type":"structure","members":{"AllowNonRestoredState":{"type":"boolean"}}},"S4o":{"type":"structure","required":["ApplicationMaintenanceWindowStartTime","ApplicationMaintenanceWindowEndTime"],"members":{"ApplicationMaintenanceWindowStartTime":{},"ApplicationMaintenanceWindowEndTime":{}}},"S5g":{"type":"structure","required":["SnapshotName","SnapshotStatus","ApplicationVersionId"],"members":{"SnapshotName":{},"SnapshotStatus":{},"ApplicationVersionId":{"type":"long"},"SnapshotCreationTimestamp":{"type":"timestamp"}}}}}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediaconnect'] = {};
	AWS.MediaConnect = Service.defineService('mediaconnect', ['2018-11-14']);
	Object.defineProperty(apiLoader.services['mediaconnect'], '2018-11-14', {
	  get: function get() {
	    var model = __webpack_require__(690);
	    model.paginators = __webpack_require__(691).pagination;
	    model.waiters = __webpack_require__(692).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaConnect;


/***/ }),
/* 690 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-11-14","endpointPrefix":"mediaconnect","signingName":"mediaconnect","serviceFullName":"AWS MediaConnect","serviceId":"MediaConnect","protocol":"rest-json","jsonVersion":"1.1","uid":"mediaconnect-2018-11-14","signatureVersion":"v4"},"operations":{"AddFlowMediaStreams":{"http":{"requestUri":"/v1/flows/{flowArn}/mediaStreams","responseCode":201},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"MediaStreams":{"shape":"S3","locationName":"mediaStreams"}},"required":["FlowArn","MediaStreams"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"MediaStreams":{"shape":"Se","locationName":"mediaStreams"}}}},"AddFlowOutputs":{"http":{"requestUri":"/v1/flows/{flowArn}/outputs","responseCode":201},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"Outputs":{"shape":"Sj","locationName":"outputs"}},"required":["FlowArn","Outputs"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Outputs":{"shape":"S11","locationName":"outputs"}}}},"AddFlowSources":{"http":{"requestUri":"/v1/flows/{flowArn}/source","responseCode":201},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"Sources":{"shape":"S1b","locationName":"sources"}},"required":["FlowArn","Sources"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Sources":{"shape":"S1i","locationName":"sources"}}}},"AddFlowVpcInterfaces":{"http":{"requestUri":"/v1/flows/{flowArn}/vpcInterfaces","responseCode":201},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"VpcInterfaces":{"shape":"S1p","locationName":"vpcInterfaces"}},"required":["FlowArn","VpcInterfaces"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"VpcInterfaces":{"shape":"S1t","locationName":"vpcInterfaces"}}}},"CreateFlow":{"http":{"requestUri":"/v1/flows","responseCode":201},"input":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Entitlements":{"shape":"S1w","locationName":"entitlements"},"MediaStreams":{"shape":"S3","locationName":"mediaStreams"},"Name":{"locationName":"name"},"Outputs":{"shape":"Sj","locationName":"outputs"},"Source":{"shape":"S1c","locationName":"source"},"SourceFailoverConfig":{"shape":"S1z","locationName":"sourceFailoverConfig"},"Sources":{"shape":"S1b","locationName":"sources"},"VpcInterfaces":{"shape":"S1p","locationName":"vpcInterfaces"},"Maintenance":{"locationName":"maintenance","type":"structure","members":{"MaintenanceDay":{"locationName":"maintenanceDay"},"MaintenanceStartHour":{"locationName":"maintenanceStartHour"}},"required":["MaintenanceDay","MaintenanceStartHour"]}},"required":["Name"]},"output":{"type":"structure","members":{"Flow":{"shape":"S26","locationName":"flow"}}}},"DeleteFlow":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Status":{"locationName":"status"}}}},"DescribeFlow":{"http":{"method":"GET","requestUri":"/v1/flows/{flowArn}","responseCode":200},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"Flow":{"shape":"S26","locationName":"flow"},"Messages":{"locationName":"messages","type":"structure","members":{"Errors":{"shape":"Sl","locationName":"errors"}},"required":["Errors"]}}}},"DescribeOffering":{"http":{"method":"GET","requestUri":"/v1/offerings/{offeringArn}","responseCode":200},"input":{"type":"structure","members":{"OfferingArn":{"location":"uri","locationName":"offeringArn"}},"required":["OfferingArn"]},"output":{"type":"structure","members":{"Offering":{"shape":"S2i","locationName":"offering"}}}},"DescribeReservation":{"http":{"method":"GET","requestUri":"/v1/reservations/{reservationArn}","responseCode":200},"input":{"type":"structure","members":{"ReservationArn":{"location":"uri","locationName":"reservationArn"}},"required":["ReservationArn"]},"output":{"type":"structure","members":{"Reservation":{"shape":"S2p","locationName":"reservation"}}}},"GrantFlowEntitlements":{"http":{"requestUri":"/v1/flows/{flowArn}/entitlements","responseCode":200},"input":{"type":"structure","members":{"Entitlements":{"shape":"S1w","locationName":"entitlements"},"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn","Entitlements"]},"output":{"type":"structure","members":{"Entitlements":{"shape":"S27","locationName":"entitlements"},"FlowArn":{"locationName":"flowArn"}}}},"ListEntitlements":{"http":{"method":"GET","requestUri":"/v1/entitlements","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Entitlements":{"locationName":"entitlements","type":"list","member":{"type":"structure","members":{"DataTransferSubscriberFeePercent":{"locationName":"dataTransferSubscriberFeePercent","type":"integer"},"EntitlementArn":{"locationName":"entitlementArn"},"EntitlementName":{"locationName":"entitlementName"}},"required":["EntitlementArn","EntitlementName"]}},"NextToken":{"locationName":"nextToken"}}}},"ListFlows":{"http":{"method":"GET","requestUri":"/v1/flows","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Flows":{"locationName":"flows","type":"list","member":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"FlowArn":{"locationName":"flowArn"},"Name":{"locationName":"name"},"SourceType":{"locationName":"sourceType"},"Status":{"locationName":"status"},"Maintenance":{"shape":"S2a","locationName":"maintenance"}},"required":["Status","Description","SourceType","AvailabilityZone","FlowArn","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"ListOfferings":{"http":{"method":"GET","requestUri":"/v1/offerings","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Offerings":{"locationName":"offerings","type":"list","member":{"shape":"S2i"}}}}},"ListReservations":{"http":{"method":"GET","requestUri":"/v1/reservations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Reservations":{"locationName":"reservations","type":"list","member":{"shape":"S2p"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S3b","locationName":"tags"}}}},"PurchaseOffering":{"http":{"requestUri":"/v1/offerings/{offeringArn}","responseCode":201},"input":{"type":"structure","members":{"OfferingArn":{"location":"uri","locationName":"offeringArn"},"ReservationName":{"locationName":"reservationName"},"Start":{"locationName":"start"}},"required":["OfferingArn","Start","ReservationName"]},"output":{"type":"structure","members":{"Reservation":{"shape":"S2p","locationName":"reservation"}}}},"RemoveFlowMediaStream":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/mediaStreams/{mediaStreamName}","responseCode":200},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"MediaStreamName":{"location":"uri","locationName":"mediaStreamName"}},"required":["FlowArn","MediaStreamName"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"MediaStreamName":{"locationName":"mediaStreamName"}}}},"RemoveFlowOutput":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/outputs/{outputArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"OutputArn":{"location":"uri","locationName":"outputArn"}},"required":["FlowArn","OutputArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"OutputArn":{"locationName":"outputArn"}}}},"RemoveFlowSource":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/source/{sourceArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"SourceArn":{"location":"uri","locationName":"sourceArn"}},"required":["FlowArn","SourceArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"SourceArn":{"locationName":"sourceArn"}}}},"RemoveFlowVpcInterface":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/vpcInterfaces/{vpcInterfaceName}","responseCode":200},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"VpcInterfaceName":{"location":"uri","locationName":"vpcInterfaceName"}},"required":["FlowArn","VpcInterfaceName"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"NonDeletedNetworkInterfaceIds":{"shape":"Sl","locationName":"nonDeletedNetworkInterfaceIds"},"VpcInterfaceName":{"locationName":"vpcInterfaceName"}}}},"RevokeFlowEntitlement":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/entitlements/{entitlementArn}","responseCode":202},"input":{"type":"structure","members":{"EntitlementArn":{"location":"uri","locationName":"entitlementArn"},"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn","EntitlementArn"]},"output":{"type":"structure","members":{"EntitlementArn":{"locationName":"entitlementArn"},"FlowArn":{"locationName":"flowArn"}}}},"StartFlow":{"http":{"requestUri":"/v1/flows/start/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Status":{"locationName":"status"}}}},"StopFlow":{"http":{"requestUri":"/v1/flows/stop/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Status":{"locationName":"status"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"S3b","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"shape":"Sl","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateFlow":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"SourceFailoverConfig":{"locationName":"sourceFailoverConfig","type":"structure","members":{"FailoverMode":{"locationName":"failoverMode"},"RecoveryWindow":{"locationName":"recoveryWindow","type":"integer"},"SourcePriority":{"shape":"S21","locationName":"sourcePriority"},"State":{"locationName":"state"}}},"Maintenance":{"locationName":"maintenance","type":"structure","members":{"MaintenanceDay":{"locationName":"maintenanceDay"},"MaintenanceScheduledDate":{"locationName":"maintenanceScheduledDate"},"MaintenanceStartHour":{"locationName":"maintenanceStartHour"}}}},"required":["FlowArn"]},"output":{"type":"structure","members":{"Flow":{"shape":"S26","locationName":"flow"}}}},"UpdateFlowEntitlement":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/entitlements/{entitlementArn}","responseCode":202},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"Encryption":{"shape":"S3z","locationName":"encryption"},"EntitlementArn":{"location":"uri","locationName":"entitlementArn"},"EntitlementStatus":{"locationName":"entitlementStatus"},"FlowArn":{"location":"uri","locationName":"flowArn"},"Subscribers":{"shape":"Sl","locationName":"subscribers"}},"required":["FlowArn","EntitlementArn"]},"output":{"type":"structure","members":{"Entitlement":{"shape":"S28","locationName":"entitlement"},"FlowArn":{"locationName":"flowArn"}}}},"UpdateFlowMediaStream":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/mediaStreams/{mediaStreamName}","responseCode":202},"input":{"type":"structure","members":{"Attributes":{"shape":"S5","locationName":"attributes"},"ClockRate":{"locationName":"clockRate","type":"integer"},"Description":{"locationName":"description"},"FlowArn":{"location":"uri","locationName":"flowArn"},"MediaStreamName":{"location":"uri","locationName":"mediaStreamName"},"MediaStreamType":{"locationName":"mediaStreamType"},"VideoFormat":{"locationName":"videoFormat"}},"required":["FlowArn","MediaStreamName"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"MediaStream":{"shape":"Sf","locationName":"mediaStream"}}}},"UpdateFlowOutput":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/outputs/{outputArn}","responseCode":202},"input":{"type":"structure","members":{"CidrAllowList":{"shape":"Sl","locationName":"cidrAllowList"},"Description":{"locationName":"description"},"Destination":{"locationName":"destination"},"Encryption":{"shape":"S3z","locationName":"encryption"},"FlowArn":{"location":"uri","locationName":"flowArn"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"MediaStreamOutputConfigurations":{"shape":"Sp","locationName":"mediaStreamOutputConfigurations"},"MinLatency":{"locationName":"minLatency","type":"integer"},"OutputArn":{"location":"uri","locationName":"outputArn"},"Port":{"locationName":"port","type":"integer"},"Protocol":{"locationName":"protocol"},"RemoteId":{"locationName":"remoteId"},"SenderControlPort":{"locationName":"senderControlPort","type":"integer"},"SenderIpAddress":{"locationName":"senderIpAddress"},"SmoothingLatency":{"locationName":"smoothingLatency","type":"integer"},"StreamId":{"locationName":"streamId"},"VpcInterfaceAttachment":{"shape":"Sz","locationName":"vpcInterfaceAttachment"}},"required":["FlowArn","OutputArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Output":{"shape":"S12","locationName":"output"}}}},"UpdateFlowSource":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/source/{sourceArn}","responseCode":202},"input":{"type":"structure","members":{"Decryption":{"shape":"S3z","locationName":"decryption"},"Description":{"locationName":"description"},"EntitlementArn":{"locationName":"entitlementArn"},"FlowArn":{"location":"uri","locationName":"flowArn"},"IngestPort":{"locationName":"ingestPort","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"MaxSyncBuffer":{"locationName":"maxSyncBuffer","type":"integer"},"MediaStreamSourceConfigurations":{"shape":"S1d","locationName":"mediaStreamSourceConfigurations"},"MinLatency":{"locationName":"minLatency","type":"integer"},"Protocol":{"locationName":"protocol"},"SenderControlPort":{"locationName":"senderControlPort","type":"integer"},"SenderIpAddress":{"locationName":"senderIpAddress"},"SourceArn":{"location":"uri","locationName":"sourceArn"},"StreamId":{"locationName":"streamId"},"VpcInterfaceName":{"locationName":"vpcInterfaceName"},"WhitelistCidr":{"locationName":"whitelistCidr"}},"required":["FlowArn","SourceArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Source":{"shape":"S1j","locationName":"source"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S5","locationName":"attributes"},"ClockRate":{"locationName":"clockRate","type":"integer"},"Description":{"locationName":"description"},"MediaStreamId":{"locationName":"mediaStreamId","type":"integer"},"MediaStreamName":{"locationName":"mediaStreamName"},"MediaStreamType":{"locationName":"mediaStreamType"},"VideoFormat":{"locationName":"videoFormat"}},"required":["MediaStreamType","MediaStreamId","MediaStreamName"]}},"S5":{"type":"structure","members":{"Fmtp":{"locationName":"fmtp","type":"structure","members":{"ChannelOrder":{"locationName":"channelOrder"},"Colorimetry":{"locationName":"colorimetry"},"ExactFramerate":{"locationName":"exactFramerate"},"Par":{"locationName":"par"},"Range":{"locationName":"range"},"ScanMode":{"locationName":"scanMode"},"Tcs":{"locationName":"tcs"}}},"Lang":{"locationName":"lang"}}},"Se":{"type":"list","member":{"shape":"Sf"}},"Sf":{"type":"structure","members":{"Attributes":{"locationName":"attributes","type":"structure","members":{"Fmtp":{"locationName":"fmtp","type":"structure","members":{"ChannelOrder":{"locationName":"channelOrder"},"Colorimetry":{"locationName":"colorimetry"},"ExactFramerate":{"locationName":"exactFramerate"},"Par":{"locationName":"par"},"Range":{"locationName":"range"},"ScanMode":{"locationName":"scanMode"},"Tcs":{"locationName":"tcs"}}},"Lang":{"locationName":"lang"}},"required":["Fmtp"]},"ClockRate":{"locationName":"clockRate","type":"integer"},"Description":{"locationName":"description"},"Fmt":{"locationName":"fmt","type":"integer"},"MediaStreamId":{"locationName":"mediaStreamId","type":"integer"},"MediaStreamName":{"locationName":"mediaStreamName"},"MediaStreamType":{"locationName":"mediaStreamType"},"VideoFormat":{"locationName":"videoFormat"}},"required":["MediaStreamType","MediaStreamId","MediaStreamName","Fmt"]},"Sj":{"type":"list","member":{"type":"structure","members":{"CidrAllowList":{"shape":"Sl","locationName":"cidrAllowList"},"Description":{"locationName":"description"},"Destination":{"locationName":"destination"},"Encryption":{"shape":"Sm","locationName":"encryption"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"MediaStreamOutputConfigurations":{"shape":"Sp","locationName":"mediaStreamOutputConfigurations"},"MinLatency":{"locationName":"minLatency","type":"integer"},"Name":{"locationName":"name"},"Port":{"locationName":"port","type":"integer"},"Protocol":{"locationName":"protocol"},"RemoteId":{"locationName":"remoteId"},"SenderControlPort":{"locationName":"senderControlPort","type":"integer"},"SmoothingLatency":{"locationName":"smoothingLatency","type":"integer"},"StreamId":{"locationName":"streamId"},"VpcInterfaceAttachment":{"shape":"Sz","locationName":"vpcInterfaceAttachment"}},"required":["Protocol"]}},"Sl":{"type":"list","member":{}},"Sm":{"type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"DeviceId":{"locationName":"deviceId"},"KeyType":{"locationName":"keyType"},"Region":{"locationName":"region"},"ResourceId":{"locationName":"resourceId"},"RoleArn":{"locationName":"roleArn"},"SecretArn":{"locationName":"secretArn"},"Url":{"locationName":"url"}},"required":["RoleArn"]},"Sp":{"type":"list","member":{"type":"structure","members":{"DestinationConfigurations":{"locationName":"destinationConfigurations","type":"list","member":{"type":"structure","members":{"DestinationIp":{"locationName":"destinationIp"},"DestinationPort":{"locationName":"destinationPort","type":"integer"},"Interface":{"shape":"St","locationName":"interface"}},"required":["DestinationIp","DestinationPort","Interface"]}},"EncodingName":{"locationName":"encodingName"},"EncodingParameters":{"locationName":"encodingParameters","type":"structure","members":{"CompressionFactor":{"locationName":"compressionFactor","type":"double"},"EncoderProfile":{"locationName":"encoderProfile"}},"required":["EncoderProfile","CompressionFactor"]},"MediaStreamName":{"locationName":"mediaStreamName"}},"required":["MediaStreamName","EncodingName"]}},"St":{"type":"structure","members":{"Name":{"locationName":"name"}},"required":["Name"]},"Sz":{"type":"structure","members":{"VpcInterfaceName":{"locationName":"vpcInterfaceName"}}},"S11":{"type":"list","member":{"shape":"S12"}},"S12":{"type":"structure","members":{"DataTransferSubscriberFeePercent":{"locationName":"dataTransferSubscriberFeePercent","type":"integer"},"Description":{"locationName":"description"},"Destination":{"locationName":"destination"},"Encryption":{"shape":"Sm","locationName":"encryption"},"EntitlementArn":{"locationName":"entitlementArn"},"ListenerAddress":{"locationName":"listenerAddress"},"MediaLiveInputArn":{"locationName":"mediaLiveInputArn"},"MediaStreamOutputConfigurations":{"locationName":"mediaStreamOutputConfigurations","type":"list","member":{"type":"structure","members":{"DestinationConfigurations":{"locationName":"destinationConfigurations","type":"list","member":{"type":"structure","members":{"DestinationIp":{"locationName":"destinationIp"},"DestinationPort":{"locationName":"destinationPort","type":"integer"},"Interface":{"shape":"S17","locationName":"interface"},"OutboundIp":{"locationName":"outboundIp"}},"required":["DestinationIp","DestinationPort","Interface","OutboundIp"]}},"EncodingName":{"locationName":"encodingName"},"EncodingParameters":{"locationName":"encodingParameters","type":"structure","members":{"CompressionFactor":{"locationName":"compressionFactor","type":"double"},"EncoderProfile":{"locationName":"encoderProfile"}},"required":["EncoderProfile","CompressionFactor"]},"MediaStreamName":{"locationName":"mediaStreamName"}},"required":["MediaStreamName","EncodingName"]}},"Name":{"locationName":"name"},"OutputArn":{"locationName":"outputArn"},"Port":{"locationName":"port","type":"integer"},"Transport":{"shape":"S19","locationName":"transport"},"VpcInterfaceAttachment":{"shape":"Sz","locationName":"vpcInterfaceAttachment"}},"required":["OutputArn","Name"]},"S17":{"type":"structure","members":{"Name":{"locationName":"name"}},"required":["Name"]},"S19":{"type":"structure","members":{"CidrAllowList":{"shape":"Sl","locationName":"cidrAllowList"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"MaxSyncBuffer":{"locationName":"maxSyncBuffer","type":"integer"},"MinLatency":{"locationName":"minLatency","type":"integer"},"Protocol":{"locationName":"protocol"},"RemoteId":{"locationName":"remoteId"},"SenderControlPort":{"locationName":"senderControlPort","type":"integer"},"SenderIpAddress":{"locationName":"senderIpAddress"},"SmoothingLatency":{"locationName":"smoothingLatency","type":"integer"},"StreamId":{"locationName":"streamId"}},"required":["Protocol"]},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","members":{"Decryption":{"shape":"Sm","locationName":"decryption"},"Description":{"locationName":"description"},"EntitlementArn":{"locationName":"entitlementArn"},"IngestPort":{"locationName":"ingestPort","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"MaxSyncBuffer":{"locationName":"maxSyncBuffer","type":"integer"},"MediaStreamSourceConfigurations":{"shape":"S1d","locationName":"mediaStreamSourceConfigurations"},"MinLatency":{"locationName":"minLatency","type":"integer"},"Name":{"locationName":"name"},"Protocol":{"locationName":"protocol"},"SenderControlPort":{"locationName":"senderControlPort","type":"integer"},"SenderIpAddress":{"locationName":"senderIpAddress"},"StreamId":{"locationName":"streamId"},"VpcInterfaceName":{"locationName":"vpcInterfaceName"},"WhitelistCidr":{"locationName":"whitelistCidr"}}},"S1d":{"type":"list","member":{"type":"structure","members":{"EncodingName":{"locationName":"encodingName"},"InputConfigurations":{"locationName":"inputConfigurations","type":"list","member":{"type":"structure","members":{"InputPort":{"locationName":"inputPort","type":"integer"},"Interface":{"shape":"St","locationName":"interface"}},"required":["InputPort","Interface"]}},"MediaStreamName":{"locationName":"mediaStreamName"}},"required":["MediaStreamName","EncodingName"]}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","members":{"DataTransferSubscriberFeePercent":{"locationName":"dataTransferSubscriberFeePercent","type":"integer"},"Decryption":{"shape":"Sm","locationName":"decryption"},"Description":{"locationName":"description"},"EntitlementArn":{"locationName":"entitlementArn"},"IngestIp":{"locationName":"ingestIp"},"IngestPort":{"locationName":"ingestPort","type":"integer"},"MediaStreamSourceConfigurations":{"locationName":"mediaStreamSourceConfigurations","type":"list","member":{"type":"structure","members":{"EncodingName":{"locationName":"encodingName"},"InputConfigurations":{"locationName":"inputConfigurations","type":"list","member":{"type":"structure","members":{"InputIp":{"locationName":"inputIp"},"InputPort":{"locationName":"inputPort","type":"integer"},"Interface":{"shape":"S17","locationName":"interface"}},"required":["InputPort","InputIp","Interface"]}},"MediaStreamName":{"locationName":"mediaStreamName"}},"required":["MediaStreamName","EncodingName"]}},"Name":{"locationName":"name"},"SenderControlPort":{"locationName":"senderControlPort","type":"integer"},"SenderIpAddress":{"locationName":"senderIpAddress"},"SourceArn":{"locationName":"sourceArn"},"Transport":{"shape":"S19","locationName":"transport"},"VpcInterfaceName":{"locationName":"vpcInterfaceName"},"WhitelistCidr":{"locationName":"whitelistCidr"}},"required":["SourceArn","Name"]},"S1p":{"type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"NetworkInterfaceType":{"locationName":"networkInterfaceType"},"RoleArn":{"locationName":"roleArn"},"SecurityGroupIds":{"shape":"Sl","locationName":"securityGroupIds"},"SubnetId":{"locationName":"subnetId"}},"required":["SubnetId","SecurityGroupIds","RoleArn","Name"]}},"S1t":{"type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"NetworkInterfaceIds":{"shape":"Sl","locationName":"networkInterfaceIds"},"NetworkInterfaceType":{"locationName":"networkInterfaceType"},"RoleArn":{"locationName":"roleArn"},"SecurityGroupIds":{"shape":"Sl","locationName":"securityGroupIds"},"SubnetId":{"locationName":"subnetId"}},"required":["NetworkInterfaceType","NetworkInterfaceIds","SubnetId","SecurityGroupIds","RoleArn","Name"]}},"S1w":{"type":"list","member":{"type":"structure","members":{"DataTransferSubscriberFeePercent":{"locationName":"dataTransferSubscriberFeePercent","type":"integer"},"Description":{"locationName":"description"},"Encryption":{"shape":"Sm","locationName":"encryption"},"EntitlementStatus":{"locationName":"entitlementStatus"},"Name":{"locationName":"name"},"Subscribers":{"shape":"Sl","locationName":"subscribers"}},"required":["Subscribers"]}},"S1z":{"type":"structure","members":{"FailoverMode":{"locationName":"failoverMode"},"RecoveryWindow":{"locationName":"recoveryWindow","type":"integer"},"SourcePriority":{"shape":"S21","locationName":"sourcePriority"},"State":{"locationName":"state"}}},"S21":{"type":"structure","members":{"PrimarySource":{"locationName":"primarySource"}}},"S26":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"EgressIp":{"locationName":"egressIp"},"Entitlements":{"shape":"S27","locationName":"entitlements"},"FlowArn":{"locationName":"flowArn"},"MediaStreams":{"shape":"Se","locationName":"mediaStreams"},"Name":{"locationName":"name"},"Outputs":{"shape":"S11","locationName":"outputs"},"Source":{"shape":"S1j","locationName":"source"},"SourceFailoverConfig":{"shape":"S1z","locationName":"sourceFailoverConfig"},"Sources":{"shape":"S1i","locationName":"sources"},"Status":{"locationName":"status"},"VpcInterfaces":{"shape":"S1t","locationName":"vpcInterfaces"},"Maintenance":{"shape":"S2a","locationName":"maintenance"}},"required":["Status","Entitlements","Outputs","AvailabilityZone","FlowArn","Source","Name"]},"S27":{"type":"list","member":{"shape":"S28"}},"S28":{"type":"structure","members":{"DataTransferSubscriberFeePercent":{"locationName":"dataTransferSubscriberFeePercent","type":"integer"},"Description":{"locationName":"description"},"Encryption":{"shape":"Sm","locationName":"encryption"},"EntitlementArn":{"locationName":"entitlementArn"},"EntitlementStatus":{"locationName":"entitlementStatus"},"Name":{"locationName":"name"},"Subscribers":{"shape":"Sl","locationName":"subscribers"}},"required":["EntitlementArn","Subscribers","Name"]},"S2a":{"type":"structure","members":{"MaintenanceDay":{"locationName":"maintenanceDay"},"MaintenanceDeadline":{"locationName":"maintenanceDeadline"},"MaintenanceScheduledDate":{"locationName":"maintenanceScheduledDate"},"MaintenanceStartHour":{"locationName":"maintenanceStartHour"}}},"S2i":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"OfferingArn":{"locationName":"offeringArn"},"OfferingDescription":{"locationName":"offeringDescription"},"PricePerUnit":{"locationName":"pricePerUnit"},"PriceUnits":{"locationName":"priceUnits"},"ResourceSpecification":{"shape":"S2l","locationName":"resourceSpecification"}},"required":["CurrencyCode","OfferingArn","OfferingDescription","DurationUnits","Duration","PricePerUnit","ResourceSpecification","PriceUnits"]},"S2l":{"type":"structure","members":{"ReservedBitrate":{"locationName":"reservedBitrate","type":"integer"},"ResourceType":{"locationName":"resourceType"}},"required":["ResourceType"]},"S2p":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"OfferingArn":{"locationName":"offeringArn"},"OfferingDescription":{"locationName":"offeringDescription"},"PricePerUnit":{"locationName":"pricePerUnit"},"PriceUnits":{"locationName":"priceUnits"},"ReservationArn":{"locationName":"reservationArn"},"ReservationName":{"locationName":"reservationName"},"ReservationState":{"locationName":"reservationState"},"ResourceSpecification":{"shape":"S2l","locationName":"resourceSpecification"},"Start":{"locationName":"start"}},"required":["CurrencyCode","ReservationState","OfferingArn","ReservationArn","Start","OfferingDescription","ReservationName","End","Duration","DurationUnits","PricePerUnit","ResourceSpecification","PriceUnits"]},"S3b":{"type":"map","key":{},"value":{}},"S3z":{"type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"DeviceId":{"locationName":"deviceId"},"KeyType":{"locationName":"keyType"},"Region":{"locationName":"region"},"ResourceId":{"locationName":"resourceId"},"RoleArn":{"locationName":"roleArn"},"SecretArn":{"locationName":"secretArn"},"Url":{"locationName":"url"}}}}}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEntitlements":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entitlements"},"ListFlows":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Flows"},"ListOfferings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Offerings"},"ListReservations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Reservations"}}}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"FlowActive":{"description":"Wait until a flow is active","operation":"DescribeFlow","delay":3,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"path","argument":"Flow.Status","expected":"ACTIVE"},{"state":"retry","matcher":"path","argument":"Flow.Status","expected":"STARTING"},{"state":"retry","matcher":"path","argument":"Flow.Status","expected":"UPDATING"},{"state":"retry","matcher":"status","expected":500},{"state":"retry","matcher":"status","expected":503},{"state":"failure","matcher":"path","argument":"Flow.Status","expected":"ERROR"}]},"FlowStandby":{"description":"Wait until a flow is in standby mode","operation":"DescribeFlow","delay":3,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"path","argument":"Flow.Status","expected":"STANDBY"},{"state":"retry","matcher":"path","argument":"Flow.Status","expected":"STOPPING"},{"state":"retry","matcher":"status","expected":500},{"state":"retry","matcher":"status","expected":503},{"state":"failure","matcher":"path","argument":"Flow.Status","expected":"ERROR"}]},"FlowDeleted":{"description":"Wait until a flow is deleted","operation":"DescribeFlow","delay":3,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"status","expected":404},{"state":"retry","matcher":"path","argument":"Flow.Status","expected":"DELETING"},{"state":"retry","matcher":"status","expected":500},{"state":"retry","matcher":"status","expected":503},{"state":"failure","matcher":"path","argument":"Flow.Status","expected":"ERROR"}]}}}

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['fsx'] = {};
	AWS.FSx = Service.defineService('fsx', ['2018-03-01']);
	Object.defineProperty(apiLoader.services['fsx'], '2018-03-01', {
	  get: function get() {
	    var model = __webpack_require__(694);
	    model.paginators = __webpack_require__(695).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.FSx;


/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-03-01","endpointPrefix":"fsx","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon FSx","serviceId":"FSx","signatureVersion":"v4","signingName":"fsx","targetPrefix":"AWSSimbaAPIService_v20180301","uid":"fsx-2018-03-01"},"operations":{"AssociateFileSystemAliases":{"input":{"type":"structure","required":["FileSystemId","Aliases"],"members":{"ClientRequestToken":{"idempotencyToken":true},"FileSystemId":{},"Aliases":{"shape":"S4"}}},"output":{"type":"structure","members":{"Aliases":{"shape":"S7"}}}},"CancelDataRepositoryTask":{"input":{"type":"structure","required":["TaskId"],"members":{"TaskId":{}}},"output":{"type":"structure","members":{"Lifecycle":{},"TaskId":{}}},"idempotent":true},"CopyBackup":{"input":{"type":"structure","required":["SourceBackupId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"SourceBackupId":{},"SourceRegion":{},"KmsKeyId":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Backup":{"shape":"So"}}},"idempotent":true},"CreateBackup":{"input":{"type":"structure","members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sj"},"VolumeId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"So"}}},"idempotent":true},"CreateDataRepositoryAssociation":{"input":{"type":"structure","required":["FileSystemId","FileSystemPath","DataRepositoryPath"],"members":{"FileSystemId":{},"FileSystemPath":{},"DataRepositoryPath":{},"BatchImportMetaDataOnCreate":{"type":"boolean"},"ImportedFileChunkSize":{"type":"integer"},"S3":{"shape":"S41"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Association":{"shape":"S47"}}},"idempotent":true},"CreateDataRepositoryTask":{"input":{"type":"structure","required":["Type","FileSystemId","Report"],"members":{"Type":{},"Paths":{"shape":"S4b"},"FileSystemId":{},"Report":{"shape":"S4d"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"DataRepositoryTask":{"shape":"S4h"}}},"idempotent":true},"CreateFileSystem":{"input":{"type":"structure","required":["FileSystemType","StorageCapacity","SubnetIds"],"members":{"ClientRequestToken":{"idempotencyToken":true},"FileSystemType":{},"StorageCapacity":{"type":"integer"},"StorageType":{},"SubnetIds":{"shape":"S15"},"SecurityGroupIds":{"shape":"S4r"},"Tags":{"shape":"Sj"},"KmsKeyId":{},"WindowsConfiguration":{"shape":"S4t"},"LustreConfiguration":{"shape":"S4x"},"OntapConfiguration":{"type":"structure","required":["DeploymentType","ThroughputCapacity"],"members":{"AutomaticBackupRetentionDays":{"type":"integer"},"DailyAutomaticBackupStartTime":{},"DeploymentType":{},"EndpointIpAddressRange":{},"FsxAdminPassword":{"shape":"S50"},"DiskIopsConfiguration":{"shape":"S3m"},"PreferredSubnetId":{},"RouteTableIds":{"shape":"S3p"},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{}}},"FileSystemTypeVersion":{},"OpenZFSConfiguration":{"shape":"S51"}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sx"}}}},"CreateFileSystemFromBackup":{"input":{"type":"structure","required":["BackupId","SubnetIds"],"members":{"BackupId":{},"ClientRequestToken":{"idempotencyToken":true},"SubnetIds":{"shape":"S15"},"SecurityGroupIds":{"shape":"S4r"},"Tags":{"shape":"Sj"},"WindowsConfiguration":{"shape":"S4t"},"LustreConfiguration":{"shape":"S4x"},"StorageType":{},"KmsKeyId":{},"FileSystemTypeVersion":{},"OpenZFSConfiguration":{"shape":"S51"}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sx"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["Name","VolumeId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"Name":{},"VolumeId":{},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"S3c"}}},"idempotent":true},"CreateStorageVirtualMachine":{"input":{"type":"structure","required":["FileSystemId","Name"],"members":{"ActiveDirectoryConfiguration":{"type":"structure","required":["NetBiosName"],"members":{"NetBiosName":{},"SelfManagedActiveDirectoryConfiguration":{"shape":"S4u"}}},"ClientRequestToken":{"idempotencyToken":true},"FileSystemId":{},"Name":{},"SvmAdminPassword":{"shape":"S50"},"Tags":{"shape":"Sj"},"RootVolumeSecurityStyle":{}}},"output":{"type":"structure","members":{"StorageVirtualMachine":{"shape":"S5e"}}}},"CreateVolume":{"input":{"type":"structure","required":["VolumeType","Name"],"members":{"ClientRequestToken":{"idempotencyToken":true},"VolumeType":{},"Name":{},"OntapConfiguration":{"shape":"S5l"},"Tags":{"shape":"Sj"},"OpenZFSConfiguration":{"type":"structure","required":["ParentVolumeId"],"members":{"ParentVolumeId":{},"StorageCapacityReservationGiB":{"type":"integer"},"StorageCapacityQuotaGiB":{"type":"integer"},"RecordSizeKiB":{"type":"integer"},"DataCompressionType":{},"CopyTagsToSnapshots":{"type":"boolean"},"OriginSnapshot":{"type":"structure","required":["SnapshotARN","CopyStrategy"],"members":{"SnapshotARN":{},"CopyStrategy":{}}},"ReadOnly":{"type":"boolean"},"NfsExports":{"shape":"S32"},"UserAndGroupQuotas":{"shape":"S39"}}}}},"output":{"type":"structure","members":{"Volume":{"shape":"S2d"}}}},"CreateVolumeFromBackup":{"input":{"type":"structure","required":["BackupId","Name"],"members":{"BackupId":{},"ClientRequestToken":{"idempotencyToken":true},"Name":{},"OntapConfiguration":{"shape":"S5l"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Volume":{"shape":"S2d"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"BackupId":{},"Lifecycle":{}}},"idempotent":true},"DeleteDataRepositoryAssociation":{"input":{"type":"structure","required":["AssociationId","DeleteDataInFileSystem"],"members":{"AssociationId":{},"ClientRequestToken":{"idempotencyToken":true},"DeleteDataInFileSystem":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{},"Lifecycle":{},"DeleteDataInFileSystem":{"type":"boolean"}}},"idempotent":true},"DeleteFileSystem":{"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true},"WindowsConfiguration":{"type":"structure","members":{"SkipFinalBackup":{"type":"boolean"},"FinalBackupTags":{"shape":"Sj"}}},"LustreConfiguration":{"type":"structure","members":{"SkipFinalBackup":{"type":"boolean"},"FinalBackupTags":{"shape":"Sj"}}},"OpenZFSConfiguration":{"type":"structure","members":{"SkipFinalBackup":{"type":"boolean"},"FinalBackupTags":{"shape":"Sj"},"Options":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"FileSystemId":{},"Lifecycle":{},"WindowsResponse":{"type":"structure","members":{"FinalBackupId":{},"FinalBackupTags":{"shape":"Sj"}}},"LustreResponse":{"type":"structure","members":{"FinalBackupId":{},"FinalBackupTags":{"shape":"Sj"}}},"OpenZFSResponse":{"type":"structure","members":{"FinalBackupId":{},"FinalBackupTags":{"shape":"Sj"}}}}},"idempotent":true},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"SnapshotId":{}}},"output":{"type":"structure","members":{"SnapshotId":{},"Lifecycle":{}}},"idempotent":true},"DeleteStorageVirtualMachine":{"input":{"type":"structure","required":["StorageVirtualMachineId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"StorageVirtualMachineId":{}}},"output":{"type":"structure","members":{"StorageVirtualMachineId":{},"Lifecycle":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"VolumeId":{},"OntapConfiguration":{"type":"structure","members":{"SkipFinalBackup":{"type":"boolean"},"FinalBackupTags":{"shape":"Sj"}}},"OpenZFSConfiguration":{"type":"structure","members":{"Options":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"VolumeId":{},"Lifecycle":{},"OntapResponse":{"type":"structure","members":{"FinalBackupId":{},"FinalBackupTags":{"shape":"Sj"}}}}}},"DescribeBackups":{"input":{"type":"structure","members":{"BackupIds":{"type":"list","member":{}},"Filters":{"shape":"S6k"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"So"}},"NextToken":{}}}},"DescribeDataRepositoryAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"type":"list","member":{}},"Filters":{"shape":"S6k"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"shape":"S47"}},"NextToken":{}}},"idempotent":true},"DescribeDataRepositoryTasks":{"input":{"type":"structure","members":{"TaskIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DataRepositoryTasks":{"type":"list","member":{"shape":"S4h"}},"NextToken":{}}}},"DescribeFileSystemAliases":{"input":{"type":"structure","required":["FileSystemId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"FileSystemId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"shape":"S7"},"NextToken":{}}}},"DescribeFileSystems":{"input":{"type":"structure","members":{"FileSystemIds":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FileSystems":{"type":"list","member":{"shape":"Sx"}},"NextToken":{}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"SnapshotIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Snapshots":{"type":"list","member":{"shape":"S3c"}},"NextToken":{}}}},"DescribeStorageVirtualMachines":{"input":{"type":"structure","members":{"StorageVirtualMachineIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"StorageVirtualMachines":{"type":"list","member":{"shape":"S5e"}},"NextToken":{}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"VolumeIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"shape":"S2d"}},"NextToken":{}}}},"DisassociateFileSystemAliases":{"input":{"type":"structure","required":["FileSystemId","Aliases"],"members":{"ClientRequestToken":{"idempotencyToken":true},"FileSystemId":{},"Aliases":{"shape":"S4"}}},"output":{"type":"structure","members":{"Aliases":{"shape":"S7"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sj"},"NextToken":{}}}},"ReleaseFileSystemNfsV3Locks":{"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sx"}}},"idempotent":true},"RestoreVolumeFromSnapshot":{"input":{"type":"structure","required":["VolumeId","SnapshotId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"VolumeId":{},"SnapshotId":{},"Options":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"VolumeId":{},"Lifecycle":{}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateDataRepositoryAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"ClientRequestToken":{"idempotencyToken":true},"ImportedFileChunkSize":{"type":"integer"},"S3":{"shape":"S41"}}},"output":{"type":"structure","members":{"Association":{"shape":"S47"}}},"idempotent":true},"UpdateFileSystem":{"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true},"StorageCapacity":{"type":"integer"},"WindowsConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"ThroughputCapacity":{"type":"integer"},"SelfManagedActiveDirectoryConfiguration":{"shape":"S8n"},"AuditLogConfiguration":{"shape":"S4w"}}},"LustreConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"AutoImportPolicy":{},"DataCompressionType":{},"LogConfiguration":{"shape":"S4y"}}},"OntapConfiguration":{"type":"structure","members":{"AutomaticBackupRetentionDays":{"type":"integer"},"DailyAutomaticBackupStartTime":{},"FsxAdminPassword":{"shape":"S50"},"WeeklyMaintenanceStartTime":{},"DiskIopsConfiguration":{"shape":"S3m"},"ThroughputCapacity":{"type":"integer"}}},"OpenZFSConfiguration":{"type":"structure","members":{"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"CopyTagsToVolumes":{"type":"boolean"},"DailyAutomaticBackupStartTime":{},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{},"DiskIopsConfiguration":{"shape":"S3m"}}}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sx"}}}},"UpdateSnapshot":{"input":{"type":"structure","required":["Name","SnapshotId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"Name":{},"SnapshotId":{}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"S3c"}}},"idempotent":true},"UpdateStorageVirtualMachine":{"input":{"type":"structure","required":["StorageVirtualMachineId"],"members":{"ActiveDirectoryConfiguration":{"type":"structure","members":{"SelfManagedActiveDirectoryConfiguration":{"shape":"S8n"}}},"ClientRequestToken":{"idempotencyToken":true},"StorageVirtualMachineId":{},"SvmAdminPassword":{"shape":"S50"}}},"output":{"type":"structure","members":{"StorageVirtualMachine":{"shape":"S5e"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"ClientRequestToken":{"idempotencyToken":true},"VolumeId":{},"OntapConfiguration":{"type":"structure","members":{"JunctionPath":{},"SecurityStyle":{},"SizeInMegabytes":{"type":"integer"},"StorageEfficiencyEnabled":{"type":"boolean"},"TieringPolicy":{"shape":"S2m"}}},"Name":{},"OpenZFSConfiguration":{"type":"structure","members":{"StorageCapacityReservationGiB":{"type":"integer"},"StorageCapacityQuotaGiB":{"type":"integer"},"RecordSizeKiB":{"type":"integer"},"DataCompressionType":{},"NfsExports":{"shape":"S32"},"UserAndGroupQuotas":{"shape":"S39"},"ReadOnly":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"Volume":{"shape":"S2d"}}}}},"shapes":{"S4":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","members":{"Name":{},"Lifecycle":{}}}},"Sj":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"So":{"type":"structure","required":["BackupId","Lifecycle","Type","CreationTime","FileSystem"],"members":{"BackupId":{},"Lifecycle":{},"FailureDetails":{"type":"structure","members":{"Message":{}}},"Type":{},"ProgressPercent":{"type":"integer"},"CreationTime":{"type":"timestamp"},"KmsKeyId":{},"ResourceARN":{},"Tags":{"shape":"Sj"},"FileSystem":{"shape":"Sx"},"DirectoryInformation":{"type":"structure","members":{"DomainName":{},"ActiveDirectoryId":{},"ResourceARN":{}}},"OwnerId":{},"SourceBackupId":{},"SourceBackupRegion":{},"ResourceType":{},"Volume":{"shape":"S2d"}}},"Sx":{"type":"structure","members":{"OwnerId":{},"CreationTime":{"type":"timestamp"},"FileSystemId":{},"FileSystemType":{},"Lifecycle":{},"FailureDetails":{"type":"structure","members":{"Message":{}}},"StorageCapacity":{"type":"integer"},"StorageType":{},"VpcId":{},"SubnetIds":{"shape":"S15"},"NetworkInterfaceIds":{"type":"list","member":{}},"DNSName":{},"KmsKeyId":{},"ResourceARN":{},"Tags":{"shape":"Sj"},"WindowsConfiguration":{"type":"structure","members":{"ActiveDirectoryId":{},"SelfManagedActiveDirectoryConfiguration":{"shape":"S1c"},"DeploymentType":{},"RemoteAdministrationEndpoint":{},"PreferredSubnetId":{},"PreferredFileServerIp":{},"ThroughputCapacity":{"type":"integer"},"MaintenanceOperationsInProgress":{"type":"list","member":{}},"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"Aliases":{"shape":"S7"},"AuditLogConfiguration":{"type":"structure","required":["FileAccessAuditLogLevel","FileShareAccessAuditLogLevel"],"members":{"FileAccessAuditLogLevel":{},"FileShareAccessAuditLogLevel":{},"AuditLogDestination":{}}}}},"LustreConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"DataRepositoryConfiguration":{"type":"structure","members":{"Lifecycle":{},"ImportPath":{},"ExportPath":{},"ImportedFileChunkSize":{"type":"integer"},"AutoImportPolicy":{},"FailureDetails":{"shape":"S1z"}}},"DeploymentType":{},"PerUnitStorageThroughput":{"type":"integer"},"MountName":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"DriveCacheType":{},"DataCompressionType":{},"LogConfiguration":{"type":"structure","required":["Level"],"members":{"Level":{},"Destination":{}}}}},"AdministrativeActions":{"shape":"S27"},"OntapConfiguration":{"type":"structure","members":{"AutomaticBackupRetentionDays":{"type":"integer"},"DailyAutomaticBackupStartTime":{},"DeploymentType":{},"EndpointIpAddressRange":{},"Endpoints":{"type":"structure","members":{"Intercluster":{"shape":"S3k"},"Management":{"shape":"S3k"}}},"DiskIopsConfiguration":{"shape":"S3m"},"PreferredSubnetId":{},"RouteTableIds":{"shape":"S3p"},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{}}},"FileSystemTypeVersion":{},"OpenZFSConfiguration":{"type":"structure","members":{"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"CopyTagsToVolumes":{"type":"boolean"},"DailyAutomaticBackupStartTime":{},"DeploymentType":{},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{},"DiskIopsConfiguration":{"shape":"S3m"},"RootVolumeId":{}}}}},"S15":{"type":"list","member":{}},"S1c":{"type":"structure","members":{"DomainName":{},"OrganizationalUnitDistinguishedName":{},"FileSystemAdministratorsGroup":{},"UserName":{},"DnsIps":{"shape":"S1h"}}},"S1h":{"type":"list","member":{}},"S1z":{"type":"structure","members":{"Message":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"AdministrativeActionType":{},"ProgressPercent":{"type":"integer"},"RequestTime":{"type":"timestamp"},"Status":{},"TargetFileSystemValues":{"shape":"Sx"},"FailureDetails":{"type":"structure","members":{"Message":{}}},"TargetVolumeValues":{"shape":"S2d"},"TargetSnapshotValues":{"shape":"S3c"}}}},"S2d":{"type":"structure","members":{"CreationTime":{"type":"timestamp"},"FileSystemId":{},"Lifecycle":{},"Name":{},"OntapConfiguration":{"type":"structure","members":{"FlexCacheEndpointType":{},"JunctionPath":{},"SecurityStyle":{},"SizeInMegabytes":{"type":"integer"},"StorageEfficiencyEnabled":{"type":"boolean"},"StorageVirtualMachineId":{},"StorageVirtualMachineRoot":{"type":"boolean"},"TieringPolicy":{"shape":"S2m"},"UUID":{},"OntapVolumeType":{}}},"ResourceARN":{},"Tags":{"shape":"Sj"},"VolumeId":{},"VolumeType":{},"LifecycleTransitionReason":{"shape":"S2t"},"AdministrativeActions":{"shape":"S27"},"OpenZFSConfiguration":{"type":"structure","members":{"ParentVolumeId":{},"VolumePath":{},"StorageCapacityReservationGiB":{"type":"integer"},"StorageCapacityQuotaGiB":{"type":"integer"},"RecordSizeKiB":{"type":"integer"},"DataCompressionType":{},"CopyTagsToSnapshots":{"type":"boolean"},"OriginSnapshot":{"type":"structure","members":{"SnapshotARN":{},"CopyStrategy":{}}},"ReadOnly":{"type":"boolean"},"NfsExports":{"shape":"S32"},"UserAndGroupQuotas":{"shape":"S39"}}}}},"S2m":{"type":"structure","members":{"CoolingPeriod":{"type":"integer"},"Name":{}}},"S2t":{"type":"structure","members":{"Message":{}}},"S32":{"type":"list","member":{"type":"structure","required":["ClientConfigurations"],"members":{"ClientConfigurations":{"type":"list","member":{"type":"structure","required":["Clients","Options"],"members":{"Clients":{},"Options":{"type":"list","member":{}}}}}}}},"S39":{"type":"list","member":{"type":"structure","required":["Type","Id","StorageCapacityQuotaGiB"],"members":{"Type":{},"Id":{"type":"integer"},"StorageCapacityQuotaGiB":{"type":"integer"}}}},"S3c":{"type":"structure","members":{"ResourceARN":{},"SnapshotId":{},"Name":{},"VolumeId":{},"CreationTime":{"type":"timestamp"},"Lifecycle":{},"LifecycleTransitionReason":{"shape":"S2t"},"Tags":{"shape":"Sj"},"AdministrativeActions":{"shape":"S27"}}},"S3k":{"type":"structure","members":{"DNSName":{},"IpAddresses":{"shape":"S3l"}}},"S3l":{"type":"list","member":{}},"S3m":{"type":"structure","members":{"Mode":{},"Iops":{"type":"long"}}},"S3p":{"type":"list","member":{}},"S41":{"type":"structure","members":{"AutoImportPolicy":{"type":"structure","members":{"Events":{"shape":"S43"}}},"AutoExportPolicy":{"type":"structure","members":{"Events":{"shape":"S43"}}}}},"S43":{"type":"list","member":{}},"S47":{"type":"structure","members":{"AssociationId":{},"ResourceARN":{},"FileSystemId":{},"Lifecycle":{},"FailureDetails":{"shape":"S1z"},"FileSystemPath":{},"DataRepositoryPath":{},"BatchImportMetaDataOnCreate":{"type":"boolean"},"ImportedFileChunkSize":{"type":"integer"},"S3":{"shape":"S41"},"Tags":{"shape":"Sj"},"CreationTime":{"type":"timestamp"}}},"S4b":{"type":"list","member":{}},"S4d":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Path":{},"Format":{},"Scope":{}}},"S4h":{"type":"structure","required":["TaskId","Lifecycle","Type","CreationTime","FileSystemId"],"members":{"TaskId":{},"Lifecycle":{},"Type":{},"CreationTime":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ResourceARN":{},"Tags":{"shape":"Sj"},"FileSystemId":{},"Paths":{"shape":"S4b"},"FailureDetails":{"type":"structure","members":{"Message":{}}},"Status":{"type":"structure","members":{"TotalCount":{"type":"long"},"SucceededCount":{"type":"long"},"FailedCount":{"type":"long"},"LastUpdatedTime":{"type":"timestamp"}}},"Report":{"shape":"S4d"}}},"S4r":{"type":"list","member":{}},"S4t":{"type":"structure","required":["ThroughputCapacity"],"members":{"ActiveDirectoryId":{},"SelfManagedActiveDirectoryConfiguration":{"shape":"S4u"},"DeploymentType":{},"PreferredSubnetId":{},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"Aliases":{"shape":"S4"},"AuditLogConfiguration":{"shape":"S4w"}}},"S4u":{"type":"structure","required":["DomainName","UserName","Password","DnsIps"],"members":{"DomainName":{},"OrganizationalUnitDistinguishedName":{},"FileSystemAdministratorsGroup":{},"UserName":{},"Password":{"shape":"S4v"},"DnsIps":{"shape":"S1h"}}},"S4v":{"type":"string","sensitive":true},"S4w":{"type":"structure","required":["FileAccessAuditLogLevel","FileShareAccessAuditLogLevel"],"members":{"FileAccessAuditLogLevel":{},"FileShareAccessAuditLogLevel":{},"AuditLogDestination":{}}},"S4x":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"ImportPath":{},"ExportPath":{},"ImportedFileChunkSize":{"type":"integer"},"DeploymentType":{},"AutoImportPolicy":{},"PerUnitStorageThroughput":{"type":"integer"},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"DriveCacheType":{},"DataCompressionType":{},"LogConfiguration":{"shape":"S4y"}}},"S4y":{"type":"structure","required":["Level"],"members":{"Level":{},"Destination":{}}},"S50":{"type":"string","sensitive":true},"S51":{"type":"structure","required":["DeploymentType","ThroughputCapacity"],"members":{"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"},"CopyTagsToVolumes":{"type":"boolean"},"DailyAutomaticBackupStartTime":{},"DeploymentType":{},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{},"DiskIopsConfiguration":{"shape":"S3m"},"RootVolumeConfiguration":{"type":"structure","members":{"RecordSizeKiB":{"type":"integer"},"DataCompressionType":{},"NfsExports":{"shape":"S32"},"UserAndGroupQuotas":{"shape":"S39"},"CopyTagsToSnapshots":{"type":"boolean"},"ReadOnly":{"type":"boolean"}}}}},"S5e":{"type":"structure","members":{"ActiveDirectoryConfiguration":{"type":"structure","members":{"NetBiosName":{},"SelfManagedActiveDirectoryConfiguration":{"shape":"S1c"}}},"CreationTime":{"type":"timestamp"},"Endpoints":{"type":"structure","members":{"Iscsi":{"shape":"S5h"},"Management":{"shape":"S5h"},"Nfs":{"shape":"S5h"},"Smb":{"shape":"S5h"}}},"FileSystemId":{},"Lifecycle":{},"Name":{},"ResourceARN":{},"StorageVirtualMachineId":{},"Subtype":{},"UUID":{},"Tags":{"shape":"Sj"},"LifecycleTransitionReason":{"shape":"S2t"},"RootVolumeSecurityStyle":{}}},"S5h":{"type":"structure","members":{"DNSName":{},"IpAddresses":{"shape":"S3l"}}},"S5l":{"type":"structure","required":["JunctionPath","SizeInMegabytes","StorageEfficiencyEnabled","StorageVirtualMachineId"],"members":{"JunctionPath":{},"SecurityStyle":{},"SizeInMegabytes":{"type":"integer"},"StorageEfficiencyEnabled":{"type":"boolean"},"StorageVirtualMachineId":{},"TieringPolicy":{"shape":"S2m"}}},"S6k":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S8n":{"type":"structure","members":{"UserName":{},"Password":{"shape":"S4v"},"DnsIps":{"shape":"S1h"}}}}}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeBackups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeDataRepositoryAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeDataRepositoryTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeFileSystemAliases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeFileSystems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeSnapshots":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeStorageVirtualMachines":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"StorageVirtualMachines"},"DescribeVolumes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Volumes"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['securityhub'] = {};
	AWS.SecurityHub = Service.defineService('securityhub', ['2018-10-26']);
	Object.defineProperty(apiLoader.services['securityhub'], '2018-10-26', {
	  get: function get() {
	    var model = __webpack_require__(697);
	    model.paginators = __webpack_require__(698).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SecurityHub;


/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-26","endpointPrefix":"securityhub","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS SecurityHub","serviceId":"SecurityHub","signatureVersion":"v4","signingName":"securityhub","uid":"securityhub-2018-10-26"},"operations":{"AcceptAdministratorInvitation":{"http":{"requestUri":"/administrator"},"input":{"type":"structure","required":["AdministratorId","InvitationId"],"members":{"AdministratorId":{},"InvitationId":{}}},"output":{"type":"structure","members":{}}},"AcceptInvitation":{"http":{"requestUri":"/master"},"input":{"type":"structure","required":["MasterId","InvitationId"],"members":{"MasterId":{},"InvitationId":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"This API has been deprecated, use AcceptAdministratorInvitation API instead."},"BatchDisableStandards":{"http":{"requestUri":"/standards/deregister"},"input":{"type":"structure","required":["StandardsSubscriptionArns"],"members":{"StandardsSubscriptionArns":{"shape":"S7"}}},"output":{"type":"structure","members":{"StandardsSubscriptions":{"shape":"S9"}}}},"BatchEnableStandards":{"http":{"requestUri":"/standards/register"},"input":{"type":"structure","required":["StandardsSubscriptionRequests"],"members":{"StandardsSubscriptionRequests":{"type":"list","member":{"type":"structure","required":["StandardsArn"],"members":{"StandardsArn":{},"StandardsInput":{"shape":"Sb"}}}}}},"output":{"type":"structure","members":{"StandardsSubscriptions":{"shape":"S9"}}}},"BatchImportFindings":{"http":{"requestUri":"/findings/import"},"input":{"type":"structure","required":["Findings"],"members":{"Findings":{"type":"list","member":{"shape":"Sl"}}}},"output":{"type":"structure","required":["FailedCount","SuccessCount"],"members":{"FailedCount":{"type":"integer"},"SuccessCount":{"type":"integer"},"FailedFindings":{"type":"list","member":{"type":"structure","required":["Id","ErrorCode","ErrorMessage"],"members":{"Id":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchUpdateFindings":{"http":{"method":"PATCH","requestUri":"/findings/batchupdate"},"input":{"type":"structure","required":["FindingIdentifiers"],"members":{"FindingIdentifiers":{"shape":"Sgq"},"Note":{"shape":"Sgs"},"Severity":{"type":"structure","members":{"Normalized":{"type":"integer"},"Product":{"type":"double"},"Label":{}}},"VerificationState":{},"Confidence":{"type":"integer"},"Criticality":{"type":"integer"},"Types":{"shape":"Sm"},"UserDefinedFields":{"shape":"St"},"Workflow":{"type":"structure","members":{"Status":{}}},"RelatedFindings":{"shape":"Sfq"}}},"output":{"type":"structure","required":["ProcessedFindings","UnprocessedFindings"],"members":{"ProcessedFindings":{"shape":"Sgq"},"UnprocessedFindings":{"type":"list","member":{"type":"structure","required":["FindingIdentifier","ErrorCode","ErrorMessage"],"members":{"FindingIdentifier":{"shape":"Sgr"},"ErrorCode":{},"ErrorMessage":{}}}}}}},"CreateActionTarget":{"http":{"requestUri":"/actionTargets"},"input":{"type":"structure","required":["Name","Description","Id"],"members":{"Name":{},"Description":{},"Id":{}}},"output":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{}}}},"CreateFindingAggregator":{"http":{"requestUri":"/findingAggregator/create"},"input":{"type":"structure","required":["RegionLinkingMode"],"members":{"RegionLinkingMode":{},"Regions":{"shape":"S15"}}},"output":{"type":"structure","members":{"FindingAggregatorArn":{},"FindingAggregationRegion":{},"RegionLinkingMode":{},"Regions":{"shape":"S15"}}}},"CreateInsight":{"http":{"requestUri":"/insights"},"input":{"type":"structure","required":["Name","Filters","GroupByAttribute"],"members":{"Name":{},"Filters":{"shape":"Sh3"},"GroupByAttribute":{}}},"output":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{}}}},"CreateMembers":{"http":{"requestUri":"/members"},"input":{"type":"structure","required":["AccountDetails"],"members":{"AccountDetails":{"type":"list","member":{"type":"structure","required":["AccountId"],"members":{"AccountId":{},"Email":{}}}}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"Shs"}}}},"DeclineInvitations":{"http":{"requestUri":"/invitations/decline"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"Shv"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"Shs"}}}},"DeleteActionTarget":{"http":{"method":"DELETE","requestUri":"/actionTargets/{ActionTargetArn+}"},"input":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{"location":"uri","locationName":"ActionTargetArn"}}},"output":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{}}}},"DeleteFindingAggregator":{"http":{"method":"DELETE","requestUri":"/findingAggregator/delete/{FindingAggregatorArn+}"},"input":{"type":"structure","required":["FindingAggregatorArn"],"members":{"FindingAggregatorArn":{"location":"uri","locationName":"FindingAggregatorArn"}}},"output":{"type":"structure","members":{}}},"DeleteInsight":{"http":{"method":"DELETE","requestUri":"/insights/{InsightArn+}"},"input":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{"location":"uri","locationName":"InsightArn"}}},"output":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{}}}},"DeleteInvitations":{"http":{"requestUri":"/invitations/delete"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"Shv"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"Shs"}}}},"DeleteMembers":{"http":{"requestUri":"/members/delete"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"Shv"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"Shs"}}}},"DescribeActionTargets":{"http":{"requestUri":"/actionTargets/get"},"input":{"type":"structure","members":{"ActionTargetArns":{"shape":"Si8"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ActionTargets"],"members":{"ActionTargets":{"type":"list","member":{"type":"structure","required":["ActionTargetArn","Name","Description"],"members":{"ActionTargetArn":{},"Name":{},"Description":{}}}},"NextToken":{}}}},"DescribeHub":{"http":{"method":"GET","requestUri":"/accounts"},"input":{"type":"structure","members":{"HubArn":{"location":"querystring","locationName":"HubArn"}}},"output":{"type":"structure","members":{"HubArn":{},"SubscribedAt":{},"AutoEnableControls":{"type":"boolean"}}}},"DescribeOrganizationConfiguration":{"http":{"method":"GET","requestUri":"/organization/configuration"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AutoEnable":{"type":"boolean"},"MemberAccountLimitReached":{"type":"boolean"},"AutoEnableStandards":{}}}},"DescribeProducts":{"http":{"method":"GET","requestUri":"/products"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"ProductArn":{"location":"querystring","locationName":"ProductArn"}}},"output":{"type":"structure","required":["Products"],"members":{"Products":{"type":"list","member":{"type":"structure","required":["ProductArn"],"members":{"ProductArn":{},"ProductName":{},"CompanyName":{},"Description":{},"Categories":{"type":"list","member":{}},"IntegrationTypes":{"type":"list","member":{}},"MarketplaceUrl":{},"ActivationUrl":{},"ProductSubscriptionResourcePolicy":{}}}},"NextToken":{}}}},"DescribeStandards":{"http":{"method":"GET","requestUri":"/standards"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"Standards":{"type":"list","member":{"type":"structure","members":{"StandardsArn":{},"Name":{},"Description":{},"EnabledByDefault":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeStandardsControls":{"http":{"method":"GET","requestUri":"/standards/controls/{StandardsSubscriptionArn+}"},"input":{"type":"structure","required":["StandardsSubscriptionArn"],"members":{"StandardsSubscriptionArn":{"location":"uri","locationName":"StandardsSubscriptionArn"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"Controls":{"type":"list","member":{"type":"structure","members":{"StandardsControlArn":{},"ControlStatus":{},"DisabledReason":{},"ControlStatusUpdatedAt":{"shape":"Siz"},"ControlId":{},"Title":{},"Description":{},"RemediationUrl":{},"SeverityRating":{},"RelatedRequirements":{"shape":"Sfi"}}}},"NextToken":{}}}},"DisableImportFindingsForProduct":{"http":{"method":"DELETE","requestUri":"/productSubscriptions/{ProductSubscriptionArn+}"},"input":{"type":"structure","required":["ProductSubscriptionArn"],"members":{"ProductSubscriptionArn":{"location":"uri","locationName":"ProductSubscriptionArn"}}},"output":{"type":"structure","members":{}}},"DisableOrganizationAdminAccount":{"http":{"requestUri":"/organization/admin/disable"},"input":{"type":"structure","required":["AdminAccountId"],"members":{"AdminAccountId":{}}},"output":{"type":"structure","members":{}}},"DisableSecurityHub":{"http":{"method":"DELETE","requestUri":"/accounts"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateFromAdministratorAccount":{"http":{"requestUri":"/administrator/disassociate"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateFromMasterAccount":{"http":{"requestUri":"/master/disassociate"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"This API has been deprecated, use DisassociateFromAdministratorAccount API instead."},"DisassociateMembers":{"http":{"requestUri":"/members/disassociate"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"Shv"}}},"output":{"type":"structure","members":{}}},"EnableImportFindingsForProduct":{"http":{"requestUri":"/productSubscriptions"},"input":{"type":"structure","required":["ProductArn"],"members":{"ProductArn":{}}},"output":{"type":"structure","members":{"ProductSubscriptionArn":{}}}},"EnableOrganizationAdminAccount":{"http":{"requestUri":"/organization/admin/enable"},"input":{"type":"structure","required":["AdminAccountId"],"members":{"AdminAccountId":{}}},"output":{"type":"structure","members":{}}},"EnableSecurityHub":{"http":{"requestUri":"/accounts"},"input":{"type":"structure","members":{"Tags":{"shape":"Sji"},"EnableDefaultStandards":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"GetAdministratorAccount":{"http":{"method":"GET","requestUri":"/administrator"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Administrator":{"shape":"Sjo"}}}},"GetEnabledStandards":{"http":{"requestUri":"/standards/get"},"input":{"type":"structure","members":{"StandardsSubscriptionArns":{"shape":"S7"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"StandardsSubscriptions":{"shape":"S9"},"NextToken":{}}}},"GetFindingAggregator":{"http":{"method":"GET","requestUri":"/findingAggregator/get/{FindingAggregatorArn+}"},"input":{"type":"structure","required":["FindingAggregatorArn"],"members":{"FindingAggregatorArn":{"location":"uri","locationName":"FindingAggregatorArn"}}},"output":{"type":"structure","members":{"FindingAggregatorArn":{},"FindingAggregationRegion":{},"RegionLinkingMode":{},"Regions":{"shape":"S15"}}}},"GetFindings":{"http":{"requestUri":"/findings"},"input":{"type":"structure","members":{"Filters":{"shape":"Sh3"},"SortCriteria":{"type":"list","member":{"type":"structure","members":{"Field":{},"SortOrder":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Findings"],"members":{"Findings":{"type":"list","member":{"shape":"Sl"}},"NextToken":{}}}},"GetInsightResults":{"http":{"method":"GET","requestUri":"/insights/results/{InsightArn+}"},"input":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{"location":"uri","locationName":"InsightArn"}}},"output":{"type":"structure","required":["InsightResults"],"members":{"InsightResults":{"type":"structure","required":["InsightArn","GroupByAttribute","ResultValues"],"members":{"InsightArn":{},"GroupByAttribute":{},"ResultValues":{"type":"list","member":{"type":"structure","required":["GroupByAttributeValue","Count"],"members":{"GroupByAttributeValue":{},"Count":{"type":"integer"}}}}}}}}},"GetInsights":{"http":{"requestUri":"/insights/get"},"input":{"type":"structure","members":{"InsightArns":{"shape":"Si8"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Insights"],"members":{"Insights":{"type":"list","member":{"type":"structure","required":["InsightArn","Name","Filters","GroupByAttribute"],"members":{"InsightArn":{},"Name":{},"Filters":{"shape":"Sh3"},"GroupByAttribute":{}}}},"NextToken":{}}}},"GetInvitationsCount":{"http":{"method":"GET","requestUri":"/invitations/count"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"InvitationsCount":{"type":"integer"}}}},"GetMasterAccount":{"http":{"method":"GET","requestUri":"/master"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Master":{"shape":"Sjo"}}},"deprecated":true,"deprecatedMessage":"This API has been deprecated, use GetAdministratorAccount API instead."},"GetMembers":{"http":{"requestUri":"/members/get"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"Shv"}}},"output":{"type":"structure","members":{"Members":{"shape":"Ske"},"UnprocessedAccounts":{"shape":"Shs"}}}},"InviteMembers":{"http":{"requestUri":"/members/invite"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"Shv"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"Shs"}}}},"ListEnabledProductsForImport":{"http":{"method":"GET","requestUri":"/productSubscriptions"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"ProductSubscriptions":{"type":"list","member":{}},"NextToken":{}}}},"ListFindingAggregators":{"http":{"method":"GET","requestUri":"/findingAggregator/list"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"FindingAggregators":{"type":"list","member":{"type":"structure","members":{"FindingAggregatorArn":{}}}},"NextToken":{}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitations"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Invitations":{"type":"list","member":{"shape":"Sjo"}},"NextToken":{}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/members"},"input":{"type":"structure","members":{"OnlyAssociated":{"location":"querystring","locationName":"OnlyAssociated","type":"boolean"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Members":{"shape":"Ske"},"NextToken":{}}}},"ListOrganizationAdminAccounts":{"http":{"method":"GET","requestUri":"/organization/admin"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"AdminAccounts":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"Status":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sji"}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sji"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateActionTarget":{"http":{"method":"PATCH","requestUri":"/actionTargets/{ActionTargetArn+}"},"input":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{"location":"uri","locationName":"ActionTargetArn"},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateFindingAggregator":{"http":{"method":"PATCH","requestUri":"/findingAggregator/update"},"input":{"type":"structure","required":["FindingAggregatorArn","RegionLinkingMode"],"members":{"FindingAggregatorArn":{},"RegionLinkingMode":{},"Regions":{"shape":"S15"}}},"output":{"type":"structure","members":{"FindingAggregatorArn":{},"FindingAggregationRegion":{},"RegionLinkingMode":{},"Regions":{"shape":"S15"}}}},"UpdateFindings":{"http":{"method":"PATCH","requestUri":"/findings"},"input":{"type":"structure","required":["Filters"],"members":{"Filters":{"shape":"Sh3"},"Note":{"shape":"Sgs"},"RecordState":{}}},"output":{"type":"structure","members":{}}},"UpdateInsight":{"http":{"method":"PATCH","requestUri":"/insights/{InsightArn+}"},"input":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{"location":"uri","locationName":"InsightArn"},"Name":{},"Filters":{"shape":"Sh3"},"GroupByAttribute":{}}},"output":{"type":"structure","members":{}}},"UpdateOrganizationConfiguration":{"http":{"requestUri":"/organization/configuration"},"input":{"type":"structure","required":["AutoEnable"],"members":{"AutoEnable":{"type":"boolean"},"AutoEnableStandards":{}}},"output":{"type":"structure","members":{}}},"UpdateSecurityHubConfiguration":{"http":{"method":"PATCH","requestUri":"/accounts"},"input":{"type":"structure","members":{"AutoEnableControls":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateStandardsControl":{"http":{"method":"PATCH","requestUri":"/standards/control/{StandardsControlArn+}"},"input":{"type":"structure","required":["StandardsControlArn"],"members":{"StandardsControlArn":{"location":"uri","locationName":"StandardsControlArn"},"ControlStatus":{},"DisabledReason":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"list","member":{}},"S9":{"type":"list","member":{"type":"structure","required":["StandardsSubscriptionArn","StandardsArn","StandardsInput","StandardsStatus"],"members":{"StandardsSubscriptionArn":{},"StandardsArn":{},"StandardsInput":{"shape":"Sb"},"StandardsStatus":{},"StandardsStatusReason":{"type":"structure","required":["StatusReasonCode"],"members":{"StatusReasonCode":{}}}}}},"Sb":{"type":"map","key":{},"value":{}},"Sl":{"type":"structure","required":["SchemaVersion","Id","ProductArn","GeneratorId","AwsAccountId","CreatedAt","UpdatedAt","Title","Description","Resources"],"members":{"SchemaVersion":{},"Id":{},"ProductArn":{},"ProductName":{},"CompanyName":{},"Region":{},"GeneratorId":{},"AwsAccountId":{},"Types":{"shape":"Sm"},"FirstObservedAt":{},"LastObservedAt":{},"CreatedAt":{},"UpdatedAt":{},"Severity":{"type":"structure","members":{"Product":{"type":"double"},"Label":{},"Normalized":{"type":"integer"},"Original":{}}},"Confidence":{"type":"integer"},"Criticality":{"type":"integer"},"Title":{},"Description":{},"Remediation":{"type":"structure","members":{"Recommendation":{"type":"structure","members":{"Text":{},"Url":{}}}}},"SourceUrl":{},"ProductFields":{"shape":"St"},"UserDefinedFields":{"shape":"St"},"Malware":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Type":{},"Path":{},"State":{}}}},"Network":{"type":"structure","members":{"Direction":{},"Protocol":{},"OpenPortRange":{"shape":"S10"},"SourceIpV4":{},"SourceIpV6":{},"SourcePort":{"type":"integer"},"SourceDomain":{},"SourceMac":{},"DestinationIpV4":{},"DestinationIpV6":{},"DestinationPort":{"type":"integer"},"DestinationDomain":{}}},"NetworkPath":{"type":"list","member":{"type":"structure","members":{"ComponentId":{},"ComponentType":{},"Egress":{"shape":"S13"},"Ingress":{"shape":"S13"}}}},"Process":{"type":"structure","members":{"Name":{},"Path":{},"Pid":{"type":"integer"},"ParentPid":{"type":"integer"},"LaunchedAt":{},"TerminatedAt":{}}},"ThreatIntelIndicators":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{},"Category":{},"LastObservedAt":{},"Source":{},"SourceUrl":{}}}},"Resources":{"type":"list","member":{"type":"structure","required":["Type","Id"],"members":{"Type":{},"Id":{},"Partition":{},"Region":{},"ResourceRole":{},"Tags":{"shape":"St"},"DataClassification":{"type":"structure","members":{"DetailedResultsLocation":{},"Result":{"type":"structure","members":{"MimeType":{},"SizeClassified":{"type":"long"},"AdditionalOccurrences":{"type":"boolean"},"Status":{"type":"structure","members":{"Code":{},"Reason":{}}},"SensitiveData":{"type":"list","member":{"type":"structure","members":{"Category":{},"Detections":{"type":"list","member":{"type":"structure","members":{"Count":{"type":"long"},"Type":{},"Occurrences":{"shape":"S1o"}}}},"TotalCount":{"type":"long"}}}},"CustomDataIdentifiers":{"type":"structure","members":{"Detections":{"type":"list","member":{"type":"structure","members":{"Count":{"type":"long"},"Arn":{},"Name":{},"Occurrences":{"shape":"S1o"}}}},"TotalCount":{"type":"long"}}}}}}},"Details":{"type":"structure","members":{"AwsAutoScalingAutoScalingGroup":{"type":"structure","members":{"LaunchConfigurationName":{},"LoadBalancerNames":{"shape":"S15"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"CreatedTime":{},"MixedInstancesPolicy":{"type":"structure","members":{"InstancesDistribution":{"type":"structure","members":{"OnDemandAllocationStrategy":{},"OnDemandBaseCapacity":{"type":"integer"},"OnDemandPercentageAboveBaseCapacity":{"type":"integer"},"SpotAllocationStrategy":{},"SpotInstancePools":{"type":"integer"},"SpotMaxPrice":{}}},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateSpecification":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"Overrides":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{}}}}}}}},"AvailabilityZones":{"type":"list","member":{"type":"structure","members":{"Value":{}}}},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"CapacityRebalance":{"type":"boolean"}}},"AwsCodeBuildProject":{"type":"structure","members":{"EncryptionKey":{},"Artifacts":{"shape":"S2c"},"Environment":{"type":"structure","members":{"Certificate":{},"EnvironmentVariables":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Value":{}}}},"PrivilegedMode":{"type":"boolean"},"ImagePullCredentialsType":{},"RegistryCredential":{"type":"structure","members":{"Credential":{},"CredentialProvider":{}}},"Type":{}}},"Name":{},"Source":{"type":"structure","members":{"Type":{},"Location":{},"GitCloneDepth":{"type":"integer"},"InsecureSsl":{"type":"boolean"}}},"ServiceRole":{},"LogsConfig":{"type":"structure","members":{"CloudWatchLogs":{"type":"structure","members":{"GroupName":{},"Status":{},"StreamName":{}}},"S3Logs":{"type":"structure","members":{"EncryptionDisabled":{"type":"boolean"},"Location":{},"Status":{}}}}},"VpcConfig":{"type":"structure","members":{"VpcId":{},"Subnets":{"shape":"S2n"},"SecurityGroupIds":{"shape":"S2n"}}},"SecondaryArtifacts":{"shape":"S2c"}}},"AwsCloudFrontDistribution":{"type":"structure","members":{"CacheBehaviors":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"ViewerProtocolPolicy":{}}}}}},"DefaultCacheBehavior":{"type":"structure","members":{"ViewerProtocolPolicy":{}}},"DefaultRootObject":{},"DomainName":{},"ETag":{},"LastModifiedTime":{},"Logging":{"type":"structure","members":{"Bucket":{},"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Prefix":{}}},"Origins":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Id":{},"OriginPath":{},"S3OriginConfig":{"type":"structure","members":{"OriginAccessIdentity":{}}}}}}}},"OriginGroups":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"FailoverCriteria":{"type":"structure","members":{"StatusCodes":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"integer"}},"Quantity":{"type":"integer"}}}}}}}}}},"ViewerCertificate":{"type":"structure","members":{"AcmCertificateArn":{},"Certificate":{},"CertificateSource":{},"CloudFrontDefaultCertificate":{"type":"boolean"},"IamCertificateId":{},"MinimumProtocolVersion":{},"SslSupportMethod":{}}},"Status":{},"WebAclId":{}}},"AwsEc2Instance":{"type":"structure","members":{"Type":{},"ImageId":{},"IpV4Addresses":{"shape":"S15"},"IpV6Addresses":{"shape":"S15"},"KeyName":{},"IamInstanceProfileArn":{},"VpcId":{},"SubnetId":{},"LaunchedAt":{},"NetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"NetworkInterfaceId":{}}}}}},"AwsEc2NetworkInterface":{"type":"structure","members":{"Attachment":{"type":"structure","members":{"AttachTime":{},"AttachmentId":{},"DeleteOnTermination":{"type":"boolean"},"DeviceIndex":{"type":"integer"},"InstanceId":{},"InstanceOwnerId":{},"Status":{}}},"NetworkInterfaceId":{},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupId":{}}}},"SourceDestCheck":{"type":"boolean"},"IpV6Addresses":{"type":"list","member":{"type":"structure","members":{"IpV6Address":{}}}},"PrivateIpAddresses":{"type":"list","member":{"type":"structure","members":{"PrivateIpAddress":{},"PrivateDnsName":{}}}},"PublicDnsName":{},"PublicIp":{}}},"AwsEc2SecurityGroup":{"type":"structure","members":{"GroupName":{},"GroupId":{},"OwnerId":{},"VpcId":{},"IpPermissions":{"shape":"S3h"},"IpPermissionsEgress":{"shape":"S3h"}}},"AwsEc2Volume":{"type":"structure","members":{"CreateTime":{},"Encrypted":{"type":"boolean"},"Size":{"type":"integer"},"SnapshotId":{},"Status":{},"KmsKeyId":{},"Attachments":{"type":"list","member":{"type":"structure","members":{"AttachTime":{},"DeleteOnTermination":{"type":"boolean"},"InstanceId":{},"Status":{}}}}}},"AwsEc2Vpc":{"type":"structure","members":{"CidrBlockAssociationSet":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"CidrBlock":{},"CidrBlockState":{}}}},"Ipv6CidrBlockAssociationSet":{"shape":"S3x"},"DhcpOptionsId":{},"State":{}}},"AwsEc2Eip":{"type":"structure","members":{"InstanceId":{},"PublicIp":{},"AllocationId":{},"AssociationId":{},"Domain":{},"PublicIpv4Pool":{},"NetworkBorderGroup":{},"NetworkInterfaceId":{},"NetworkInterfaceOwnerId":{},"PrivateIpAddress":{}}},"AwsEc2Subnet":{"type":"structure","members":{"AssignIpv6AddressOnCreation":{"type":"boolean"},"AvailabilityZone":{},"AvailabilityZoneId":{},"AvailableIpAddressCount":{"type":"integer"},"CidrBlock":{},"DefaultForAz":{"type":"boolean"},"MapPublicIpOnLaunch":{"type":"boolean"},"OwnerId":{},"State":{},"SubnetArn":{},"SubnetId":{},"VpcId":{},"Ipv6CidrBlockAssociationSet":{"shape":"S3x"}}},"AwsEc2NetworkAcl":{"type":"structure","members":{"IsDefault":{"type":"boolean"},"NetworkAclId":{},"OwnerId":{},"VpcId":{},"Associations":{"type":"list","member":{"type":"structure","members":{"NetworkAclAssociationId":{},"NetworkAclId":{},"SubnetId":{}}}},"Entries":{"type":"list","member":{"type":"structure","members":{"CidrBlock":{},"Egress":{"type":"boolean"},"IcmpTypeCode":{"type":"structure","members":{"Code":{"type":"integer"},"Type":{"type":"integer"}}},"Ipv6CidrBlock":{},"PortRange":{"type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"}}},"Protocol":{},"RuleAction":{},"RuleNumber":{"type":"integer"}}}}}},"AwsElbv2LoadBalancer":{"type":"structure","members":{"AvailabilityZones":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{}}}},"CanonicalHostedZoneId":{},"CreatedTime":{},"DNSName":{},"IpAddressType":{},"Scheme":{},"SecurityGroups":{"type":"list","member":{}},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"VpcId":{},"LoadBalancerAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"AwsElasticBeanstalkEnvironment":{"type":"structure","members":{"ApplicationName":{},"Cname":{},"DateCreated":{},"DateUpdated":{},"Description":{},"EndpointUrl":{},"EnvironmentArn":{},"EnvironmentId":{},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"EnvironmentName":{},"LinkName":{}}}},"EnvironmentName":{},"OptionSettings":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"OptionName":{},"ResourceName":{},"Value":{}}}},"PlatformArn":{},"SolutionStackName":{},"Status":{},"Tier":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"VersionLabel":{}}},"AwsElasticsearchDomain":{"type":"structure","members":{"AccessPolicies":{},"DomainEndpointOptions":{"type":"structure","members":{"EnforceHTTPS":{"type":"boolean"},"TLSSecurityPolicy":{}}},"DomainId":{},"DomainName":{},"Endpoint":{},"Endpoints":{"shape":"St"},"ElasticsearchVersion":{},"ElasticsearchClusterConfig":{"type":"structure","members":{"DedicatedMasterCount":{"type":"integer"},"DedicatedMasterEnabled":{"type":"boolean"},"DedicatedMasterType":{},"InstanceCount":{"type":"integer"},"InstanceType":{},"ZoneAwarenessConfig":{"type":"structure","members":{"AvailabilityZoneCount":{"type":"integer"}}},"ZoneAwarenessEnabled":{"type":"boolean"}}},"EncryptionAtRestOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"},"KmsKeyId":{}}},"LogPublishingOptions":{"type":"structure","members":{"IndexSlowLogs":{"shape":"S4r"},"SearchSlowLogs":{"shape":"S4r"},"AuditLogs":{"shape":"S4r"}}},"NodeToNodeEncryptionOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"ServiceSoftwareOptions":{"type":"structure","members":{"AutomatedUpdateDate":{},"Cancellable":{"type":"boolean"},"CurrentVersion":{},"Description":{},"NewVersion":{},"UpdateAvailable":{"type":"boolean"},"UpdateStatus":{}}},"VPCOptions":{"type":"structure","members":{"AvailabilityZones":{"shape":"S2n"},"SecurityGroupIds":{"shape":"S2n"},"SubnetIds":{"shape":"S2n"},"VPCId":{}}}}},"AwsS3Bucket":{"type":"structure","members":{"OwnerId":{},"OwnerName":{},"OwnerAccountId":{},"CreatedAt":{},"ServerSideEncryptionConfiguration":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"ApplyServerSideEncryptionByDefault":{"type":"structure","members":{"SSEAlgorithm":{},"KMSMasterKeyID":{}}}}}}}},"BucketLifecycleConfiguration":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"AbortIncompleteMultipartUpload":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"ExpirationDate":{},"ExpirationInDays":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"},"Filter":{"type":"structure","members":{"Predicate":{"type":"structure","members":{"Operands":{"type":"list","member":{"type":"structure","members":{"Prefix":{},"Tag":{"type":"structure","members":{"Key":{},"Value":{}}},"Type":{}}}},"Prefix":{},"Tag":{"type":"structure","members":{"Key":{},"Value":{}}},"Type":{}}}}},"ID":{},"NoncurrentVersionExpirationInDays":{"type":"integer"},"NoncurrentVersionTransitions":{"type":"list","member":{"type":"structure","members":{"Days":{"type":"integer"},"StorageClass":{}}}},"Prefix":{},"Status":{},"Transitions":{"type":"list","member":{"type":"structure","members":{"Date":{},"Days":{"type":"integer"},"StorageClass":{}}}}}}}}},"PublicAccessBlockConfiguration":{"shape":"S5e"},"AccessControlList":{},"BucketLoggingConfiguration":{"type":"structure","members":{"DestinationBucketName":{},"LogFilePrefix":{}}},"BucketWebsiteConfiguration":{"type":"structure","members":{"ErrorDocument":{},"IndexDocumentSuffix":{},"RedirectAllRequestsTo":{"type":"structure","members":{"Hostname":{},"Protocol":{}}},"RoutingRules":{"type":"list","member":{"type":"structure","members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"Hostname":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}}}},"BucketNotificationConfiguration":{"type":"structure","members":{"Configurations":{"type":"list","member":{"type":"structure","members":{"Events":{"type":"list","member":{}},"Filter":{"type":"structure","members":{"S3KeyFilter":{"type":"structure","members":{"FilterRules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}}}},"Destination":{},"Type":{}}}}}},"BucketVersioningConfiguration":{"type":"structure","members":{"IsMfaDeleteEnabled":{"type":"boolean"},"Status":{}}}}},"AwsS3AccountPublicAccessBlock":{"shape":"S5e"},"AwsS3Object":{"type":"structure","members":{"LastModified":{},"ETag":{},"VersionId":{},"ContentType":{},"ServerSideEncryption":{},"SSEKMSKeyId":{}}},"AwsSecretsManagerSecret":{"type":"structure","members":{"RotationRules":{"type":"structure","members":{"AutomaticallyAfterDays":{"type":"integer"}}},"RotationOccurredWithinFrequency":{"type":"boolean"},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaArn":{},"Deleted":{"type":"boolean"},"Name":{},"Description":{}}},"AwsIamAccessKey":{"type":"structure","members":{"UserName":{"deprecated":true,"deprecatedMessage":"This filter is deprecated. Instead, use PrincipalName."},"Status":{},"CreatedAt":{},"PrincipalId":{},"PrincipalType":{},"PrincipalName":{},"AccountId":{},"AccessKeyId":{},"SessionContext":{"type":"structure","members":{"Attributes":{"type":"structure","members":{"MfaAuthenticated":{"type":"boolean"},"CreationDate":{}}},"SessionIssuer":{"type":"structure","members":{"Type":{},"PrincipalId":{},"Arn":{},"AccountId":{},"UserName":{}}}}}}},"AwsIamUser":{"type":"structure","members":{"AttachedManagedPolicies":{"shape":"S65"},"CreateDate":{},"GroupList":{"shape":"S15"},"Path":{},"PermissionsBoundary":{"shape":"S67"},"UserId":{},"UserName":{},"UserPolicyList":{"type":"list","member":{"type":"structure","members":{"PolicyName":{}}}}}},"AwsIamPolicy":{"type":"structure","members":{"AttachmentCount":{"type":"integer"},"CreateDate":{},"DefaultVersionId":{},"Description":{},"IsAttachable":{"type":"boolean"},"Path":{},"PermissionsBoundaryUsageCount":{"type":"integer"},"PolicyId":{},"PolicyName":{},"PolicyVersionList":{"type":"list","member":{"type":"structure","members":{"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"CreateDate":{}}}},"UpdateDate":{}}},"AwsApiGatewayV2Stage":{"type":"structure","members":{"ClientCertificateId":{},"CreatedDate":{},"Description":{},"DefaultRouteSettings":{"shape":"S6e"},"DeploymentId":{},"LastUpdatedDate":{},"RouteSettings":{"shape":"S6e"},"StageName":{},"StageVariables":{"shape":"St"},"AccessLogSettings":{"shape":"S6f"},"AutoDeploy":{"type":"boolean"},"LastDeploymentStatusMessage":{},"ApiGatewayManaged":{"type":"boolean"}}},"AwsApiGatewayV2Api":{"type":"structure","members":{"ApiEndpoint":{},"ApiId":{},"ApiKeySelectionExpression":{},"CreatedDate":{},"Description":{},"Version":{},"Name":{},"ProtocolType":{},"RouteSelectionExpression":{},"CorsConfiguration":{"type":"structure","members":{"AllowOrigins":{"shape":"S2n"},"AllowCredentials":{"type":"boolean"},"ExposeHeaders":{"shape":"S2n"},"MaxAge":{"type":"integer"},"AllowMethods":{"shape":"S2n"},"AllowHeaders":{"shape":"S2n"}}}}},"AwsDynamoDbTable":{"type":"structure","members":{"AttributeDefinitions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{}}}},"BillingModeSummary":{"type":"structure","members":{"BillingMode":{},"LastUpdateToPayPerRequestDateTime":{}}},"CreationDateTime":{},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"Backfilling":{"type":"boolean"},"IndexArn":{},"IndexName":{},"IndexSizeBytes":{"type":"long"},"IndexStatus":{},"ItemCount":{"type":"integer"},"KeySchema":{"shape":"S6p"},"Projection":{"shape":"S6r"},"ProvisionedThroughput":{"shape":"S6s"}}}},"GlobalTableVersion":{},"ItemCount":{"type":"integer"},"KeySchema":{"shape":"S6p"},"LatestStreamArn":{},"LatestStreamLabel":{},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexArn":{},"IndexName":{},"KeySchema":{"shape":"S6p"},"Projection":{"shape":"S6r"}}}},"ProvisionedThroughput":{"shape":"S6s"},"Replicas":{"type":"list","member":{"type":"structure","members":{"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S6z"}}}},"KmsMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S6z"},"RegionName":{},"ReplicaStatus":{},"ReplicaStatusDescription":{}}}},"RestoreSummary":{"type":"structure","members":{"SourceBackupArn":{},"SourceTableArn":{},"RestoreDateTime":{},"RestoreInProgress":{"type":"boolean"}}},"SseDescription":{"type":"structure","members":{"InaccessibleEncryptionDateTime":{},"Status":{},"SseType":{},"KmsMasterKeyArn":{}}},"StreamSpecification":{"type":"structure","members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"TableId":{},"TableName":{},"TableSizeBytes":{"type":"long"},"TableStatus":{}}},"AwsApiGatewayStage":{"type":"structure","members":{"DeploymentId":{},"ClientCertificateId":{},"StageName":{},"Description":{},"CacheClusterEnabled":{"type":"boolean"},"CacheClusterSize":{},"CacheClusterStatus":{},"MethodSettings":{"type":"list","member":{"type":"structure","members":{"MetricsEnabled":{"type":"boolean"},"LoggingLevel":{},"DataTraceEnabled":{"type":"boolean"},"ThrottlingBurstLimit":{"type":"integer"},"ThrottlingRateLimit":{"type":"double"},"CachingEnabled":{"type":"boolean"},"CacheTtlInSeconds":{"type":"integer"},"CacheDataEncrypted":{"type":"boolean"},"RequireAuthorizationForCacheControl":{"type":"boolean"},"UnauthorizedCacheControlHeaderStrategy":{},"HttpMethod":{},"ResourcePath":{}}}},"Variables":{"shape":"St"},"DocumentationVersion":{},"AccessLogSettings":{"shape":"S6f"},"CanarySettings":{"type":"structure","members":{"PercentTraffic":{"type":"double"},"DeploymentId":{},"StageVariableOverrides":{"shape":"St"},"UseStageCache":{"type":"boolean"}}},"TracingEnabled":{"type":"boolean"},"CreatedDate":{},"LastUpdatedDate":{},"WebAclArn":{}}},"AwsApiGatewayRestApi":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedDate":{},"Version":{},"BinaryMediaTypes":{"shape":"S2n"},"MinimumCompressionSize":{"type":"integer"},"ApiKeySource":{},"EndpointConfiguration":{"type":"structure","members":{"Types":{"shape":"S2n"}}}}},"AwsCloudTrailTrail":{"type":"structure","members":{"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"HasCustomEventSelectors":{"type":"boolean"},"HomeRegion":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"IsOrganizationTrail":{"type":"boolean"},"KmsKeyId":{},"LogFileValidationEnabled":{"type":"boolean"},"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicArn":{},"SnsTopicName":{},"TrailArn":{}}},"AwsSsmPatchCompliance":{"type":"structure","members":{"Patch":{"type":"structure","members":{"ComplianceSummary":{"type":"structure","members":{"Status":{},"CompliantCriticalCount":{"type":"integer"},"CompliantHighCount":{"type":"integer"},"CompliantMediumCount":{"type":"integer"},"ExecutionType":{},"NonCompliantCriticalCount":{"type":"integer"},"CompliantInformationalCount":{"type":"integer"},"NonCompliantInformationalCount":{"type":"integer"},"CompliantUnspecifiedCount":{"type":"integer"},"NonCompliantLowCount":{"type":"integer"},"NonCompliantHighCount":{"type":"integer"},"CompliantLowCount":{"type":"integer"},"ComplianceType":{},"PatchBaselineId":{},"OverallSeverity":{},"NonCompliantMediumCount":{"type":"integer"},"NonCompliantUnspecifiedCount":{"type":"integer"},"PatchGroup":{}}}}}}},"AwsCertificateManagerCertificate":{"type":"structure","members":{"CertificateAuthorityArn":{},"CreatedAt":{},"DomainName":{},"DomainValidationOptions":{"shape":"S7e"},"ExtendedKeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{},"OId":{}}}},"FailureReason":{},"ImportedAt":{},"InUseBy":{"shape":"S15"},"IssuedAt":{},"Issuer":{},"KeyAlgorithm":{},"KeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"NotAfter":{},"NotBefore":{},"Options":{"type":"structure","members":{"CertificateTransparencyLoggingPreference":{}}},"RenewalEligibility":{},"RenewalSummary":{"type":"structure","members":{"DomainValidationOptions":{"shape":"S7e"},"RenewalStatus":{},"RenewalStatusReason":{},"UpdatedAt":{}}},"Serial":{},"SignatureAlgorithm":{},"Status":{},"Subject":{},"SubjectAlternativeNames":{"shape":"S15"},"Type":{}}},"AwsRedshiftCluster":{"type":"structure","members":{"AllowVersionUpgrade":{"type":"boolean"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"AvailabilityZone":{},"ClusterAvailabilityStatus":{},"ClusterCreateTime":{},"ClusterIdentifier":{},"ClusterNodes":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIpAddress":{},"PublicIpAddress":{}}}},"ClusterParameterGroups":{"type":"list","member":{"type":"structure","members":{"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}},"ParameterApplyStatus":{},"ParameterGroupName":{}}}},"ClusterPublicKey":{},"ClusterRevisionNumber":{},"ClusterSecurityGroups":{"type":"list","member":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"ClusterStatus":{},"ClusterSubnetGroupName":{},"ClusterVersion":{},"DBName":{},"DeferredMaintenanceWindows":{"type":"list","member":{"type":"structure","members":{"DeferMaintenanceEndTime":{},"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{}}}},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ElasticResizeNumberOfNodeOptions":{},"Encrypted":{"type":"boolean"},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"EnhancedVpcRouting":{"type":"boolean"},"ExpectedNextSnapshotScheduleTime":{},"ExpectedNextSnapshotScheduleTimeStatus":{},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"IamRoles":{"type":"list","member":{"type":"structure","members":{"ApplyStatus":{},"IamRoleArn":{}}}},"KmsKeyId":{},"MaintenanceTrackName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"MasterUsername":{},"NextMaintenanceWindowStartTime":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"PendingActions":{"shape":"S15"},"PendingModifiedValues":{"type":"structure","members":{"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"ClusterType":{},"ClusterVersion":{},"EncryptionType":{},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"MasterUserPassword":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"}}},"PreferredMaintenanceWindow":{},"PubliclyAccessible":{"type":"boolean"},"ResizeInfo":{"type":"structure","members":{"AllowCancelResize":{"type":"boolean"},"ResizeType":{}}},"RestoreStatus":{"type":"structure","members":{"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"SnapshotSizeInMegaBytes":{"type":"long"},"Status":{}}},"SnapshotScheduleIdentifier":{},"SnapshotScheduleState":{},"VpcId":{},"VpcSecurityGroups":{"type":"list","member":{"type":"structure","members":{"Status":{},"VpcSecurityGroupId":{}}}},"LoggingStatus":{"type":"structure","members":{"BucketName":{},"LastFailureMessage":{},"LastFailureTime":{},"LastSuccessfulDeliveryTime":{},"LoggingEnabled":{"type":"boolean"},"S3KeyPrefix":{}}}}},"AwsElbLoadBalancer":{"type":"structure","members":{"AvailabilityZones":{"shape":"S15"},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S15"}}}},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"CreatedTime":{},"DnsName":{},"HealthCheck":{"type":"structure","members":{"HealthyThreshold":{"type":"integer"},"Interval":{"type":"integer"},"Target":{},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"}}},"Instances":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"type":"structure","members":{"InstancePort":{"type":"integer"},"InstanceProtocol":{},"LoadBalancerPort":{"type":"integer"},"Protocol":{},"SslCertificateId":{}}},"PolicyNames":{"shape":"S15"}}}},"LoadBalancerAttributes":{"type":"structure","members":{"AccessLog":{"type":"structure","members":{"EmitInterval":{"type":"integer"},"Enabled":{"type":"boolean"},"S3BucketName":{},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","members":{"IdleTimeout":{"type":"integer"}}},"CrossZoneLoadBalancing":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"LoadBalancerName":{},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"CookieName":{},"PolicyName":{}}}},"LbCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"CookieExpirationPeriod":{"type":"long"},"PolicyName":{}}}},"OtherPolicies":{"shape":"S15"}}},"Scheme":{},"SecurityGroups":{"shape":"S15"},"SourceSecurityGroup":{"type":"structure","members":{"GroupName":{},"OwnerAlias":{}}},"Subnets":{"shape":"S15"},"VpcId":{}}},"AwsIamGroup":{"type":"structure","members":{"AttachedManagedPolicies":{"shape":"S65"},"CreateDate":{},"GroupId":{},"GroupName":{},"GroupPolicyList":{"type":"list","member":{"type":"structure","members":{"PolicyName":{}}}},"Path":{}}},"AwsIamRole":{"type":"structure","members":{"AssumeRolePolicyDocument":{},"AttachedManagedPolicies":{"shape":"S65"},"CreateDate":{},"InstanceProfileList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreateDate":{},"InstanceProfileId":{},"InstanceProfileName":{},"Path":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Arn":{},"AssumeRolePolicyDocument":{},"CreateDate":{},"Path":{},"RoleId":{},"RoleName":{}}}}}}},"PermissionsBoundary":{"shape":"S67"},"RoleId":{},"RoleName":{},"RolePolicyList":{"type":"list","member":{"type":"structure","members":{"PolicyName":{}}}},"MaxSessionDuration":{"type":"integer"},"Path":{}}},"AwsKmsKey":{"type":"structure","members":{"AWSAccountId":{},"CreationDate":{"type":"double"},"KeyId":{},"KeyManager":{},"KeyState":{},"Origin":{},"Description":{},"KeyRotationStatus":{"type":"boolean"}}},"AwsLambdaFunction":{"type":"structure","members":{"Code":{"type":"structure","members":{"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ZipFile":{}}},"CodeSha256":{},"DeadLetterConfig":{"type":"structure","members":{"TargetArn":{}}},"Environment":{"type":"structure","members":{"Variables":{"shape":"St"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{}}}}},"FunctionName":{},"Handler":{},"KmsKeyArn":{},"LastModified":{},"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CodeSize":{"type":"integer"}}}},"MasterArn":{},"MemorySize":{"type":"integer"},"RevisionId":{},"Role":{},"Runtime":{},"Timeout":{"type":"integer"},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"VpcConfig":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S2n"},"SubnetIds":{"shape":"S2n"},"VpcId":{}}},"Version":{}}},"AwsLambdaLayerVersion":{"type":"structure","members":{"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S2n"},"CreatedDate":{}}},"AwsRdsDbInstance":{"type":"structure","members":{"AssociatedRoles":{"type":"list","member":{"type":"structure","members":{"RoleArn":{},"FeatureName":{},"Status":{}}}},"CACertificateIdentifier":{},"DBClusterIdentifier":{},"DBInstanceIdentifier":{},"DBInstanceClass":{},"DbInstancePort":{"type":"integer"},"DbiResourceId":{},"DBName":{},"DeletionProtection":{"type":"boolean"},"Endpoint":{"shape":"S9m"},"Engine":{},"EngineVersion":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"InstanceCreateTime":{},"KmsKeyId":{},"PubliclyAccessible":{"type":"boolean"},"StorageEncrypted":{"type":"boolean"},"TdeCredentialArn":{},"VpcSecurityGroups":{"shape":"S9n"},"MultiAz":{"type":"boolean"},"EnhancedMonitoringResourceArn":{},"DbInstanceStatus":{},"MasterUsername":{},"AllocatedStorage":{"type":"integer"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DbSecurityGroups":{"shape":"S15"},"DbParameterGroups":{"type":"list","member":{"type":"structure","members":{"DbParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DbSubnetGroup":{"type":"structure","members":{"DbSubnetGroupName":{},"DbSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}}},"SubnetStatus":{}}}},"DbSubnetGroupArn":{}}},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DbInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DbInstanceIdentifier":{},"StorageType":{},"CaCertificateIdentifier":{},"DbSubnetGroupName":{},"PendingCloudWatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"S15"},"LogTypesToDisable":{"shape":"S15"}}},"ProcessorFeatures":{"shape":"S9x"}}},"LatestRestorableTime":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"shape":"S15"},"ReadReplicaDBClusterIdentifiers":{"shape":"S15"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"StatusInfos":{"type":"list","member":{"type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"DomainMemberships":{"shape":"Sa3"},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"Timezone":{},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKmsKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnabledCloudWatchLogsExports":{"shape":"S15"},"ProcessorFeatures":{"shape":"S9x"},"ListenerEndpoint":{"shape":"S9m"},"MaxAllocatedStorage":{"type":"integer"}}},"AwsSnsTopic":{"type":"structure","members":{"KmsMasterKeyId":{},"Subscription":{"type":"list","member":{"type":"structure","members":{"Endpoint":{},"Protocol":{}}}},"TopicName":{},"Owner":{}}},"AwsSqsQueue":{"type":"structure","members":{"KmsDataKeyReusePeriodSeconds":{"type":"integer"},"KmsMasterKeyId":{},"QueueName":{},"DeadLetterTargetArn":{}}},"AwsWafWebAcl":{"type":"structure","members":{"Name":{},"DefaultAction":{},"Rules":{"type":"list","member":{"type":"structure","members":{"Action":{"type":"structure","members":{"Type":{}}},"ExcludedRules":{"type":"list","member":{"type":"structure","members":{"RuleId":{}}}},"OverrideAction":{"type":"structure","members":{"Type":{}}},"Priority":{"type":"integer"},"RuleId":{},"Type":{}}}},"WebAclId":{}}},"AwsRdsDbSnapshot":{"type":"structure","members":{"DbSnapshotIdentifier":{},"DbInstanceIdentifier":{},"SnapshotCreateTime":{},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDbSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"Timezone":{},"IamDatabaseAuthenticationEnabled":{"type":"boolean"},"ProcessorFeatures":{"shape":"S9x"},"DbiResourceId":{}}},"AwsRdsDbClusterSnapshot":{"type":"structure","members":{"AvailabilityZones":{"shape":"S15"},"SnapshotCreateTime":{},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterIdentifier":{},"DbClusterSnapshotIdentifier":{},"IamDatabaseAuthenticationEnabled":{"type":"boolean"}}},"AwsRdsDbCluster":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"S15"},"BackupRetentionPeriod":{"type":"integer"},"DatabaseName":{},"Status":{},"Endpoint":{},"ReaderEndpoint":{},"CustomEndpoints":{"shape":"S15"},"MultiAz":{"type":"boolean"},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReadReplicaIdentifiers":{"shape":"S15"},"VpcSecurityGroups":{"shape":"S9n"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"AssociatedRoles":{"type":"list","member":{"type":"structure","members":{"RoleArn":{},"Status":{}}}},"ClusterCreateTime":{},"EnabledCloudWatchLogsExports":{"shape":"S15"},"EngineMode":{},"DeletionProtection":{"type":"boolean"},"HttpEndpointEnabled":{"type":"boolean"},"ActivityStreamStatus":{},"CopyTagsToSnapshot":{"type":"boolean"},"CrossAccountClone":{"type":"boolean"},"DomainMemberships":{"shape":"Sa3"},"DbClusterParameterGroup":{},"DbSubnetGroup":{},"DbClusterOptionGroupMemberships":{"type":"list","member":{"type":"structure","members":{"DbClusterOptionGroupName":{},"Status":{}}}},"DbClusterIdentifier":{},"DbClusterMembers":{"type":"list","member":{"type":"structure","members":{"IsClusterWriter":{"type":"boolean"},"PromotionTier":{"type":"integer"},"DbInstanceIdentifier":{},"DbClusterParameterGroupStatus":{}}}},"IamDatabaseAuthenticationEnabled":{"type":"boolean"}}},"AwsEcsCluster":{"type":"structure","members":{"CapacityProviders":{"shape":"S2n"},"ClusterSettings":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"Configuration":{"type":"structure","members":{"ExecuteCommandConfiguration":{"type":"structure","members":{"KmsKeyId":{},"LogConfiguration":{"type":"structure","members":{"CloudWatchEncryptionEnabled":{"type":"boolean"},"CloudWatchLogGroupName":{},"S3BucketName":{},"S3EncryptionEnabled":{"type":"boolean"},"S3KeyPrefix":{}}},"Logging":{}}}}},"DefaultCapacityProviderStrategy":{"type":"list","member":{"type":"structure","members":{"Base":{"type":"integer"},"CapacityProvider":{},"Weight":{"type":"integer"}}}}}},"AwsEcsTaskDefinition":{"type":"structure","members":{"ContainerDefinitions":{"type":"list","member":{"type":"structure","members":{"Command":{"shape":"S2n"},"Cpu":{"type":"integer"},"DependsOn":{"type":"list","member":{"type":"structure","members":{"Condition":{},"ContainerName":{}}}},"DisableNetworking":{"type":"boolean"},"DnsSearchDomains":{"shape":"S2n"},"DnsServers":{"shape":"S2n"},"DockerLabels":{"shape":"St"},"DockerSecurityOptions":{"shape":"S2n"},"EntryPoint":{"shape":"S2n"},"Environment":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"EnvironmentFiles":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"Essential":{"type":"boolean"},"ExtraHosts":{"type":"list","member":{"type":"structure","members":{"Hostname":{},"IpAddress":{}}}},"FirelensConfiguration":{"type":"structure","members":{"Options":{"shape":"St"},"Type":{}}},"HealthCheck":{"type":"structure","members":{"Command":{"shape":"S2n"},"Interval":{"type":"integer"},"Retries":{"type":"integer"},"StartPeriod":{"type":"integer"},"Timeout":{"type":"integer"}}},"Hostname":{},"Image":{},"Interactive":{"type":"boolean"},"Links":{"shape":"S2n"},"LinuxParameters":{"type":"structure","members":{"Capabilities":{"type":"structure","members":{"Add":{"shape":"S2n"},"Drop":{"shape":"S2n"}}},"Devices":{"type":"list","member":{"type":"structure","members":{"ContainerPath":{},"HostPath":{},"Permissions":{"shape":"S2n"}}}},"InitProcessEnabled":{"type":"boolean"},"MaxSwap":{"type":"integer"},"SharedMemorySize":{"type":"integer"},"Swappiness":{"type":"integer"},"Tmpfs":{"type":"list","member":{"type":"structure","members":{"ContainerPath":{},"MountOptions":{"shape":"S2n"},"Size":{"type":"integer"}}}}}},"LogConfiguration":{"type":"structure","members":{"LogDriver":{},"Options":{"shape":"St"},"SecretOptions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ValueFrom":{}}}}}},"Memory":{"type":"integer"},"MemoryReservation":{"type":"integer"},"MountPoints":{"type":"list","member":{"type":"structure","members":{"ContainerPath":{},"ReadOnly":{"type":"boolean"},"SourceVolume":{}}}},"Name":{},"PortMappings":{"type":"list","member":{"type":"structure","members":{"ContainerPort":{"type":"integer"},"HostPort":{"type":"integer"},"Protocol":{}}}},"Privileged":{"type":"boolean"},"PseudoTerminal":{"type":"boolean"},"ReadonlyRootFilesystem":{"type":"boolean"},"RepositoryCredentials":{"type":"structure","members":{"CredentialsParameter":{}}},"ResourceRequirements":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"Secrets":{"type":"list","member":{"type":"structure","members":{"Name":{},"ValueFrom":{}}}},"StartTimeout":{"type":"integer"},"StopTimeout":{"type":"integer"},"SystemControls":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Value":{}}}},"Ulimits":{"type":"list","member":{"type":"structure","members":{"HardLimit":{"type":"integer"},"Name":{},"SoftLimit":{"type":"integer"}}}},"User":{},"VolumesFrom":{"type":"list","member":{"type":"structure","members":{"ReadOnly":{"type":"boolean"},"SourceContainer":{}}}},"WorkingDirectory":{}}}},"Cpu":{},"ExecutionRoleArn":{},"Family":{},"InferenceAccelerators":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"DeviceType":{}}}},"IpcMode":{},"Memory":{},"NetworkMode":{},"PidMode":{},"PlacementConstraints":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Type":{}}}},"ProxyConfiguration":{"type":"structure","members":{"ContainerName":{},"ProxyConfigurationProperties":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"Type":{}}},"RequiresCompatibilities":{"shape":"S2n"},"TaskRoleArn":{},"Volumes":{"type":"list","member":{"type":"structure","members":{"DockerVolumeConfiguration":{"type":"structure","members":{"Autoprovision":{"type":"boolean"},"Driver":{},"DriverOpts":{"shape":"St"},"Labels":{"shape":"St"},"Scope":{}}},"EfsVolumeConfiguration":{"type":"structure","members":{"AuthorizationConfig":{"type":"structure","members":{"AccessPointId":{},"Iam":{}}},"FilesystemId":{},"RootDirectory":{},"TransitEncryption":{},"TransitEncryptionPort":{"type":"integer"}}},"Host":{"type":"structure","members":{"SourcePath":{}}},"Name":{}}}}}},"Container":{"type":"structure","members":{"Name":{},"ImageId":{},"ImageName":{},"LaunchedAt":{}}},"Other":{"shape":"St"},"AwsRdsEventSubscription":{"type":"structure","members":{"CustSubscriptionId":{},"CustomerAwsId":{},"Enabled":{"type":"boolean"},"EventCategoriesList":{"shape":"S2n"},"EventSubscriptionArn":{},"SnsTopicArn":{},"SourceIdsList":{"shape":"S2n"},"SourceType":{},"Status":{},"SubscriptionCreationTime":{}}},"AwsEcsService":{"type":"structure","members":{"CapacityProviderStrategy":{"type":"list","member":{"type":"structure","members":{"Base":{"type":"integer"},"CapacityProvider":{},"Weight":{"type":"integer"}}}},"Cluster":{},"DeploymentConfiguration":{"type":"structure","members":{"DeploymentCircuitBreaker":{"type":"structure","members":{"Enable":{"type":"boolean"},"Rollback":{"type":"boolean"}}},"MaximumPercent":{"type":"integer"},"MinimumHealthyPercent":{"type":"integer"}}},"DeploymentController":{"type":"structure","members":{"Type":{}}},"DesiredCount":{"type":"integer"},"EnableEcsManagedTags":{"type":"boolean"},"EnableExecuteCommand":{"type":"boolean"},"HealthCheckGracePeriodSeconds":{"type":"integer"},"LaunchType":{},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"ContainerName":{},"ContainerPort":{"type":"integer"},"LoadBalancerName":{},"TargetGroupArn":{}}}},"Name":{},"NetworkConfiguration":{"type":"structure","members":{"AwsVpcConfiguration":{"type":"structure","members":{"AssignPublicIp":{},"SecurityGroups":{"shape":"S2n"},"Subnets":{"shape":"S2n"}}}}},"PlacementConstraints":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Type":{}}}},"PlacementStrategies":{"type":"list","member":{"type":"structure","members":{"Field":{},"Type":{}}}},"PlatformVersion":{},"PropagateTags":{},"Role":{},"SchedulingStrategy":{},"ServiceArn":{},"ServiceName":{},"ServiceRegistries":{"type":"list","member":{"type":"structure","members":{"ContainerName":{},"ContainerPort":{"type":"integer"},"Port":{"type":"integer"},"RegistryArn":{}}}},"TaskDefinition":{}}},"AwsAutoScalingLaunchConfiguration":{"type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"BlockDeviceMappings":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{"type":"boolean"},"VirtualName":{}}}},"ClassicLinkVpcId":{},"ClassicLinkVpcSecurityGroups":{"shape":"S2n"},"CreatedTime":{},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{},"ImageId":{},"InstanceMonitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InstanceType":{},"KernelId":{},"KeyName":{},"LaunchConfigurationName":{},"PlacementTenancy":{},"RamdiskId":{},"SecurityGroups":{"shape":"S2n"},"SpotPrice":{},"UserData":{},"MetadataOptions":{"type":"structure","members":{"HttpEndpoint":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpTokens":{}}}}},"AwsEc2VpnConnection":{"type":"structure","members":{"VpnConnectionId":{},"State":{},"CustomerGatewayId":{},"CustomerGatewayConfiguration":{},"Type":{},"VpnGatewayId":{},"Category":{},"VgwTelemetry":{"type":"list","member":{"type":"structure","members":{"AcceptedRouteCount":{"type":"integer"},"CertificateArn":{},"LastStatusChange":{},"OutsideIpAddress":{},"Status":{},"StatusMessage":{}}}},"Options":{"type":"structure","members":{"StaticRoutesOnly":{"type":"boolean"},"TunnelOptions":{"type":"list","member":{"type":"structure","members":{"DpdTimeoutSeconds":{"type":"integer"},"IkeVersions":{"shape":"S2n"},"OutsideIpAddress":{},"Phase1DhGroupNumbers":{"shape":"Sd5"},"Phase1EncryptionAlgorithms":{"shape":"S2n"},"Phase1IntegrityAlgorithms":{"shape":"S2n"},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2DhGroupNumbers":{"shape":"Sd5"},"Phase2EncryptionAlgorithms":{"shape":"S2n"},"Phase2IntegrityAlgorithms":{"shape":"S2n"},"Phase2LifetimeSeconds":{"type":"integer"},"PreSharedKey":{},"RekeyFuzzPercentage":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"TunnelInsideCidr":{}}}}}},"Routes":{"type":"list","member":{"type":"structure","members":{"DestinationCidrBlock":{},"State":{}}}},"TransitGatewayId":{}}},"AwsEcrContainerImage":{"type":"structure","members":{"RegistryId":{},"RepositoryName":{},"Architecture":{},"ImageDigest":{},"ImageTags":{"shape":"S2n"},"ImagePublishedAt":{}}},"AwsOpenSearchServiceDomain":{"type":"structure","members":{"Arn":{},"AccessPolicies":{},"DomainName":{},"Id":{},"DomainEndpoint":{},"EngineVersion":{},"EncryptionAtRestOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"},"KmsKeyId":{}}},"NodeToNodeEncryptionOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"ServiceSoftwareOptions":{"type":"structure","members":{"AutomatedUpdateDate":{},"Cancellable":{"type":"boolean"},"CurrentVersion":{},"Description":{},"NewVersion":{},"UpdateAvailable":{"type":"boolean"},"UpdateStatus":{},"OptionalDeployment":{"type":"boolean"}}},"ClusterConfig":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"WarmEnabled":{"type":"boolean"},"WarmCount":{"type":"integer"},"DedicatedMasterEnabled":{"type":"boolean"},"ZoneAwarenessConfig":{"type":"structure","members":{"AvailabilityZoneCount":{"type":"integer"}}},"DedicatedMasterCount":{"type":"integer"},"InstanceType":{},"WarmType":{},"ZoneAwarenessEnabled":{"type":"boolean"},"DedicatedMasterType":{}}},"DomainEndpointOptions":{"type":"structure","members":{"CustomEndpointCertificateArn":{},"CustomEndpointEnabled":{"type":"boolean"},"EnforceHTTPS":{"type":"boolean"},"CustomEndpoint":{},"TLSSecurityPolicy":{}}},"VpcOptions":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S2n"},"SubnetIds":{"shape":"S2n"}}},"LogPublishingOptions":{"type":"structure","members":{"IndexSlowLogs":{"shape":"Sdi"},"SearchSlowLogs":{"shape":"Sdi"},"AuditLogs":{"shape":"Sdi"}}},"DomainEndpoints":{"shape":"St"}}},"AwsEc2VpcEndpointService":{"type":"structure","members":{"AcceptanceRequired":{"type":"boolean"},"AvailabilityZones":{"shape":"S2n"},"BaseEndpointDnsNames":{"shape":"S2n"},"ManagesVpcEndpoints":{"type":"boolean"},"GatewayLoadBalancerArns":{"shape":"S2n"},"NetworkLoadBalancerArns":{"shape":"S2n"},"PrivateDnsName":{},"ServiceId":{},"ServiceName":{},"ServiceState":{},"ServiceType":{"type":"list","member":{"type":"structure","members":{"ServiceType":{}}}}}},"AwsXrayEncryptionConfig":{"type":"structure","members":{"KeyId":{},"Status":{},"Type":{}}},"AwsWafRateBasedRule":{"type":"structure","members":{"MetricName":{},"Name":{},"RateKey":{},"RateLimit":{"type":"long"},"RuleId":{},"MatchPredicates":{"type":"list","member":{"type":"structure","members":{"DataId":{},"Negated":{"type":"boolean"},"Type":{}}}}}},"AwsWafRegionalRateBasedRule":{"type":"structure","members":{"MetricName":{},"Name":{},"RateKey":{},"RateLimit":{"type":"long"},"RuleId":{},"MatchPredicates":{"type":"list","member":{"type":"structure","members":{"DataId":{},"Negated":{"type":"boolean"},"Type":{}}}}}},"AwsEcrRepository":{"type":"structure","members":{"Arn":{},"ImageScanningConfiguration":{"type":"structure","members":{"ScanOnPush":{"type":"boolean"}}},"ImageTagMutability":{},"LifecyclePolicy":{"type":"structure","members":{"LifecyclePolicyText":{},"RegistryId":{}}},"RepositoryName":{},"RepositoryPolicyText":{}}},"AwsEksCluster":{"type":"structure","members":{"Arn":{},"CertificateAuthorityData":{},"ClusterStatus":{},"Endpoint":{},"Name":{},"ResourcesVpcConfig":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S2n"},"SubnetIds":{"shape":"S2n"}}},"RoleArn":{},"Version":{},"Logging":{"type":"structure","members":{"ClusterLogging":{"type":"list","member":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Types":{"shape":"S2n"}}}}}}}},"AwsNetworkFirewallFirewallPolicy":{"type":"structure","members":{"FirewallPolicy":{"type":"structure","members":{"StatefulRuleGroupReferences":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{}}}},"StatelessCustomActions":{"type":"list","member":{"type":"structure","members":{"ActionDefinition":{"shape":"Se7"},"ActionName":{}}}},"StatelessDefaultActions":{"shape":"S2n"},"StatelessFragmentDefaultActions":{"shape":"S2n"},"StatelessRuleGroupReferences":{"type":"list","member":{"type":"structure","members":{"Priority":{"type":"integer"},"ResourceArn":{}}}}}},"FirewallPolicyArn":{},"FirewallPolicyId":{},"FirewallPolicyName":{},"Description":{}}},"AwsNetworkFirewallFirewall":{"type":"structure","members":{"DeleteProtection":{"type":"boolean"},"Description":{},"FirewallArn":{},"FirewallId":{},"FirewallName":{},"FirewallPolicyArn":{},"FirewallPolicyChangeProtection":{"type":"boolean"},"SubnetChangeProtection":{"type":"boolean"},"SubnetMappings":{"type":"list","member":{"type":"structure","members":{"SubnetId":{}}}},"VpcId":{}}},"AwsNetworkFirewallRuleGroup":{"type":"structure","members":{"Capacity":{"type":"integer"},"Description":{},"RuleGroup":{"type":"structure","members":{"RuleVariables":{"type":"structure","members":{"IpSets":{"type":"structure","members":{"Definition":{"shape":"S2n"}}},"PortSets":{"type":"structure","members":{"Definition":{"shape":"S2n"}}}}},"RulesSource":{"type":"structure","members":{"RulesSourceList":{"type":"structure","members":{"GeneratedRulesType":{},"TargetTypes":{"shape":"S2n"},"Targets":{"shape":"S2n"}}},"RulesString":{},"StatefulRules":{"type":"list","member":{"type":"structure","members":{"Action":{},"Header":{"type":"structure","members":{"Destination":{},"DestinationPort":{},"Direction":{},"Protocol":{},"Source":{},"SourcePort":{}}},"RuleOptions":{"type":"list","member":{"type":"structure","members":{"Keyword":{},"Settings":{"type":"list","member":{}}}}}}}},"StatelessRulesAndCustomActions":{"type":"structure","members":{"CustomActions":{"type":"list","member":{"type":"structure","members":{"ActionDefinition":{"shape":"Se7"},"ActionName":{}}}},"StatelessRules":{"type":"list","member":{"type":"structure","members":{"Priority":{"type":"integer"},"RuleDefinition":{"type":"structure","members":{"Actions":{"shape":"S2n"},"MatchAttributes":{"type":"structure","members":{"DestinationPorts":{"type":"list","member":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}}},"Destinations":{"type":"list","member":{"type":"structure","members":{"AddressDefinition":{}}}},"Protocols":{"type":"list","member":{"type":"integer"}},"SourcePorts":{"type":"list","member":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}}},"Sources":{"type":"list","member":{"type":"structure","members":{"AddressDefinition":{}}}},"TcpFlags":{"type":"list","member":{"type":"structure","members":{"Flags":{"shape":"S2n"},"Masks":{"shape":"S2n"}}}}}}}}}}}}}}}}},"RuleGroupArn":{},"RuleGroupId":{},"RuleGroupName":{},"Type":{}}},"AwsRdsDbSecurityGroup":{"type":"structure","members":{"DbSecurityGroupArn":{},"DbSecurityGroupDescription":{},"DbSecurityGroupName":{},"Ec2SecurityGroups":{"type":"list","member":{"type":"structure","members":{"Ec2SecurityGroupId":{},"Ec2SecurityGroupName":{},"Ec2SecurityGroupOwnerId":{},"Status":{}}}},"IpRanges":{"type":"list","member":{"type":"structure","members":{"CidrIp":{},"Status":{}}}},"OwnerId":{},"VpcId":{}}}}}}}},"Compliance":{"type":"structure","members":{"Status":{},"RelatedRequirements":{"shape":"Sfi"},"StatusReasons":{"type":"list","member":{"type":"structure","required":["ReasonCode"],"members":{"ReasonCode":{},"Description":{}}}}}},"VerificationState":{},"WorkflowState":{"type":"string","deprecated":true,"deprecatedMessage":"This filter is deprecated. Instead, use SeverityLabel or FindingProviderFieldsSeverityLabel."},"Workflow":{"type":"structure","members":{"Status":{}}},"RecordState":{},"RelatedFindings":{"shape":"Sfq"},"Note":{"type":"structure","required":["Text","UpdatedBy","UpdatedAt"],"members":{"Text":{},"UpdatedBy":{},"UpdatedAt":{}}},"Vulnerabilities":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"VulnerablePackages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Epoch":{},"Release":{},"Architecture":{},"PackageManager":{},"FilePath":{}}}},"Cvss":{"type":"list","member":{"type":"structure","members":{"Version":{},"BaseScore":{"type":"double"},"BaseVector":{},"Source":{},"Adjustments":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Reason":{}}}}}}},"RelatedVulnerabilities":{"shape":"S15"},"Vendor":{"type":"structure","required":["Name"],"members":{"Name":{},"Url":{},"VendorSeverity":{},"VendorCreatedAt":{},"VendorUpdatedAt":{}}},"ReferenceUrls":{"shape":"S15"}}}},"PatchSummary":{"type":"structure","required":["Id"],"members":{"Id":{},"InstalledCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"InstalledRejectedCount":{"type":"integer"},"InstalledPendingReboot":{"type":"integer"},"OperationStartTime":{},"OperationEndTime":{},"RebootOption":{},"Operation":{}}},"Action":{"type":"structure","members":{"ActionType":{},"NetworkConnectionAction":{"type":"structure","members":{"ConnectionDirection":{},"RemoteIpDetails":{"shape":"Sg5"},"RemotePortDetails":{"type":"structure","members":{"Port":{"type":"integer"},"PortName":{}}},"LocalPortDetails":{"shape":"Sgb"},"Protocol":{},"Blocked":{"type":"boolean"}}},"AwsApiCallAction":{"type":"structure","members":{"Api":{},"ServiceName":{},"CallerType":{},"RemoteIpDetails":{"shape":"Sg5"},"DomainDetails":{"type":"structure","members":{"Domain":{}}},"AffectedResources":{"shape":"St"},"FirstSeen":{},"LastSeen":{}}},"DnsRequestAction":{"type":"structure","members":{"Domain":{},"Protocol":{},"Blocked":{"type":"boolean"}}},"PortProbeAction":{"type":"structure","members":{"PortProbeDetails":{"type":"list","member":{"type":"structure","members":{"LocalPortDetails":{"shape":"Sgb"},"LocalIpDetails":{"type":"structure","members":{"IpAddressV4":{}}},"RemoteIpDetails":{"shape":"Sg5"}}}},"Blocked":{"type":"boolean"}}}}},"FindingProviderFields":{"type":"structure","members":{"Confidence":{"type":"integer"},"Criticality":{"type":"integer"},"RelatedFindings":{"shape":"Sfq"},"Severity":{"type":"structure","members":{"Label":{},"Original":{}}},"Types":{"shape":"Sm"}}},"Sample":{"type":"boolean"}}},"Sm":{"type":"list","member":{}},"St":{"type":"map","key":{},"value":{}},"S10":{"type":"structure","members":{"Begin":{"type":"integer"},"End":{"type":"integer"}}},"S13":{"type":"structure","members":{"Protocol":{},"Destination":{"shape":"S14"},"Source":{"shape":"S14"}}},"S14":{"type":"structure","members":{"Address":{"shape":"S15"},"PortRanges":{"type":"list","member":{"shape":"S10"}}}},"S15":{"type":"list","member":{}},"S1o":{"type":"structure","members":{"LineRanges":{"shape":"S1p"},"OffsetRanges":{"shape":"S1p"},"Pages":{"type":"list","member":{"type":"structure","members":{"PageNumber":{"type":"long"},"LineRange":{"shape":"S1q"},"OffsetRange":{"shape":"S1q"}}}},"Records":{"type":"list","member":{"type":"structure","members":{"JsonPath":{},"RecordIndex":{"type":"long"}}}},"Cells":{"type":"list","member":{"type":"structure","members":{"Column":{"type":"long"},"Row":{"type":"long"},"ColumnName":{},"CellReference":{}}}}}},"S1p":{"type":"list","member":{"shape":"S1q"}},"S1q":{"type":"structure","members":{"Start":{"type":"long"},"End":{"type":"long"},"StartColumn":{"type":"long"}}},"S2c":{"type":"list","member":{"type":"structure","members":{"ArtifactIdentifier":{},"EncryptionDisabled":{"type":"boolean"},"Location":{},"Name":{},"NamespaceType":{},"OverrideArtifactName":{"type":"boolean"},"Packaging":{},"Path":{},"Type":{}}}},"S2n":{"type":"list","member":{}},"S3h":{"type":"list","member":{"type":"structure","members":{"IpProtocol":{},"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"UserIdGroupPairs":{"type":"list","member":{"type":"structure","members":{"GroupId":{},"GroupName":{},"PeeringStatus":{},"UserId":{},"VpcId":{},"VpcPeeringConnectionId":{}}}},"IpRanges":{"type":"list","member":{"type":"structure","members":{"CidrIp":{}}}},"Ipv6Ranges":{"type":"list","member":{"type":"structure","members":{"CidrIpv6":{}}}},"PrefixListIds":{"type":"list","member":{"type":"structure","members":{"PrefixListId":{}}}}}}},"S3x":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Ipv6CidrBlock":{},"CidrBlockState":{}}}},"S4r":{"type":"structure","members":{"CloudWatchLogsLogGroupArn":{},"Enabled":{"type":"boolean"}}},"S5e":{"type":"structure","members":{"BlockPublicAcls":{"type":"boolean"},"BlockPublicPolicy":{"type":"boolean"},"IgnorePublicAcls":{"type":"boolean"},"RestrictPublicBuckets":{"type":"boolean"}}},"S65":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyArn":{}}}},"S67":{"type":"structure","members":{"PermissionsBoundaryArn":{},"PermissionsBoundaryType":{}}},"S6e":{"type":"structure","members":{"DetailedMetricsEnabled":{"type":"boolean"},"LoggingLevel":{},"DataTraceEnabled":{"type":"boolean"},"ThrottlingBurstLimit":{"type":"integer"},"ThrottlingRateLimit":{"type":"double"}}},"S6f":{"type":"structure","members":{"Format":{},"DestinationArn":{}}},"S6p":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"KeyType":{}}}},"S6r":{"type":"structure","members":{"NonKeyAttributes":{"shape":"S15"},"ProjectionType":{}}},"S6s":{"type":"structure","members":{"LastDecreaseDateTime":{},"LastIncreaseDateTime":{},"NumberOfDecreasesToday":{"type":"integer"},"ReadCapacityUnits":{"type":"integer"},"WriteCapacityUnits":{"type":"integer"}}},"S6z":{"type":"structure","members":{"ReadCapacityUnits":{"type":"integer"}}},"S7e":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"ResourceRecord":{"type":"structure","members":{"Name":{},"Type":{},"Value":{}}},"ValidationDomain":{},"ValidationEmails":{"shape":"S15"},"ValidationMethod":{},"ValidationStatus":{}}}},"S9m":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"S9n":{"type":"list","member":{"type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S9x":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"Sa3":{"type":"list","member":{"type":"structure","members":{"Domain":{},"Status":{},"Fqdn":{},"IamRoleName":{}}}},"Sd5":{"type":"list","member":{"type":"integer"}},"Sdi":{"type":"structure","members":{"CloudWatchLogsLogGroupArn":{},"Enabled":{"type":"boolean"}}},"Se7":{"type":"structure","members":{"PublishMetricAction":{"type":"structure","members":{"Dimensions":{"type":"list","member":{"type":"structure","members":{"Value":{}}}}}}}},"Sfi":{"type":"list","member":{}},"Sfq":{"type":"list","member":{"type":"structure","required":["ProductArn","Id"],"members":{"ProductArn":{},"Id":{}}}},"Sg5":{"type":"structure","members":{"IpAddressV4":{},"Organization":{"type":"structure","members":{"Asn":{"type":"integer"},"AsnOrg":{},"Isp":{},"Org":{}}},"Country":{"type":"structure","members":{"CountryCode":{},"CountryName":{}}},"City":{"type":"structure","members":{"CityName":{}}},"GeoLocation":{"type":"structure","members":{"Lon":{"type":"double"},"Lat":{"type":"double"}}}}},"Sgb":{"type":"structure","members":{"Port":{"type":"integer"},"PortName":{}}},"Sgq":{"type":"list","member":{"shape":"Sgr"}},"Sgr":{"type":"structure","required":["Id","ProductArn"],"members":{"Id":{},"ProductArn":{}}},"Sgs":{"type":"structure","required":["Text","UpdatedBy"],"members":{"Text":{},"UpdatedBy":{}}},"Sh3":{"type":"structure","members":{"ProductArn":{"shape":"Sh4"},"AwsAccountId":{"shape":"Sh4"},"Id":{"shape":"Sh4"},"GeneratorId":{"shape":"Sh4"},"Region":{"shape":"Sh4"},"Type":{"shape":"Sh4"},"FirstObservedAt":{"shape":"Sh7"},"LastObservedAt":{"shape":"Sh7"},"CreatedAt":{"shape":"Sh7"},"UpdatedAt":{"shape":"Sh7"},"SeverityProduct":{"shape":"Shb","deprecated":true,"deprecatedMessage":"This filter is deprecated. Instead, use FindingProviderSeverityOriginal."},"SeverityNormalized":{"shape":"Shb","deprecated":true,"deprecatedMessage":"This filter is deprecated. Instead, use SeverityLabel or FindingProviderFieldsSeverityLabel."},"SeverityLabel":{"shape":"Sh4"},"Confidence":{"shape":"Shb"},"Criticality":{"shape":"Shb"},"Title":{"shape":"Sh4"},"Description":{"shape":"Sh4"},"RecommendationText":{"shape":"Sh4"},"SourceUrl":{"shape":"Sh4"},"ProductFields":{"shape":"Shd"},"ProductName":{"shape":"Sh4"},"CompanyName":{"shape":"Sh4"},"UserDefinedFields":{"shape":"Shd"},"MalwareName":{"shape":"Sh4"},"MalwareType":{"shape":"Sh4"},"MalwarePath":{"shape":"Sh4"},"MalwareState":{"shape":"Sh4"},"NetworkDirection":{"shape":"Sh4"},"NetworkProtocol":{"shape":"Sh4"},"NetworkSourceIpV4":{"shape":"Shg"},"NetworkSourceIpV6":{"shape":"Shg"},"NetworkSourcePort":{"shape":"Shb"},"NetworkSourceDomain":{"shape":"Sh4"},"NetworkSourceMac":{"shape":"Sh4"},"NetworkDestinationIpV4":{"shape":"Shg"},"NetworkDestinationIpV6":{"shape":"Shg"},"NetworkDestinationPort":{"shape":"Shb"},"NetworkDestinationDomain":{"shape":"Sh4"},"ProcessName":{"shape":"Sh4"},"ProcessPath":{"shape":"Sh4"},"ProcessPid":{"shape":"Shb"},"ProcessParentPid":{"shape":"Shb"},"ProcessLaunchedAt":{"shape":"Sh7"},"ProcessTerminatedAt":{"shape":"Sh7"},"ThreatIntelIndicatorType":{"shape":"Sh4"},"ThreatIntelIndicatorValue":{"shape":"Sh4"},"ThreatIntelIndicatorCategory":{"shape":"Sh4"},"ThreatIntelIndicatorLastObservedAt":{"shape":"Sh7"},"ThreatIntelIndicatorSource":{"shape":"Sh4"},"ThreatIntelIndicatorSourceUrl":{"shape":"Sh4"},"ResourceType":{"shape":"Sh4"},"ResourceId":{"shape":"Sh4"},"ResourcePartition":{"shape":"Sh4"},"ResourceRegion":{"shape":"Sh4"},"ResourceTags":{"shape":"Shd"},"ResourceAwsEc2InstanceType":{"shape":"Sh4"},"ResourceAwsEc2InstanceImageId":{"shape":"Sh4"},"ResourceAwsEc2InstanceIpV4Addresses":{"shape":"Shg"},"ResourceAwsEc2InstanceIpV6Addresses":{"shape":"Shg"},"ResourceAwsEc2InstanceKeyName":{"shape":"Sh4"},"ResourceAwsEc2InstanceIamInstanceProfileArn":{"shape":"Sh4"},"ResourceAwsEc2InstanceVpcId":{"shape":"Sh4"},"ResourceAwsEc2InstanceSubnetId":{"shape":"Sh4"},"ResourceAwsEc2InstanceLaunchedAt":{"shape":"Sh7"},"ResourceAwsS3BucketOwnerId":{"shape":"Sh4"},"ResourceAwsS3BucketOwnerName":{"shape":"Sh4"},"ResourceAwsIamAccessKeyUserName":{"shape":"Sh4","deprecated":true,"deprecatedMessage":"This filter is deprecated. Instead, use ResourceAwsIamAccessKeyPrincipalName."},"ResourceAwsIamAccessKeyPrincipalName":{"shape":"Sh4"},"ResourceAwsIamAccessKeyStatus":{"shape":"Sh4"},"ResourceAwsIamAccessKeyCreatedAt":{"shape":"Sh7"},"ResourceAwsIamUserUserName":{"shape":"Sh4"},"ResourceContainerName":{"shape":"Sh4"},"ResourceContainerImageId":{"shape":"Sh4"},"ResourceContainerImageName":{"shape":"Sh4"},"ResourceContainerLaunchedAt":{"shape":"Sh7"},"ResourceDetailsOther":{"shape":"Shd"},"ComplianceStatus":{"shape":"Sh4"},"VerificationState":{"shape":"Sh4"},"WorkflowState":{"shape":"Sh4"},"WorkflowStatus":{"shape":"Sh4"},"RecordState":{"shape":"Sh4"},"RelatedFindingsProductArn":{"shape":"Sh4"},"RelatedFindingsId":{"shape":"Sh4"},"NoteText":{"shape":"Sh4"},"NoteUpdatedAt":{"shape":"Sh7"},"NoteUpdatedBy":{"shape":"Sh4"},"Keyword":{"deprecated":true,"deprecatedMessage":"The Keyword property is deprecated.","type":"list","member":{"type":"structure","members":{"Value":{}}}},"FindingProviderFieldsConfidence":{"shape":"Shb"},"FindingProviderFieldsCriticality":{"shape":"Shb"},"FindingProviderFieldsRelatedFindingsId":{"shape":"Sh4"},"FindingProviderFieldsRelatedFindingsProductArn":{"shape":"Sh4"},"FindingProviderFieldsSeverityLabel":{"shape":"Sh4"},"FindingProviderFieldsSeverityOriginal":{"shape":"Sh4"},"FindingProviderFieldsTypes":{"shape":"Sh4"},"Sample":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"boolean"}}}}}},"Sh4":{"type":"list","member":{"type":"structure","members":{"Value":{},"Comparison":{}}}},"Sh7":{"type":"list","member":{"type":"structure","members":{"Start":{},"End":{},"DateRange":{"type":"structure","members":{"Value":{"type":"integer"},"Unit":{}}}}}},"Shb":{"type":"list","member":{"type":"structure","members":{"Gte":{"type":"double"},"Lte":{"type":"double"},"Eq":{"type":"double"}}}},"Shd":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Comparison":{}}}},"Shg":{"type":"list","member":{"type":"structure","members":{"Cidr":{}}}},"Shs":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"ProcessingResult":{}}}},"Shv":{"type":"list","member":{}},"Si8":{"type":"list","member":{}},"Siz":{"type":"timestamp","timestampFormat":"iso8601"},"Sji":{"type":"map","key":{},"value":{}},"Sjo":{"type":"structure","members":{"AccountId":{},"InvitationId":{},"InvitedAt":{"shape":"Siz"},"MemberStatus":{}}},"Ske":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"Email":{},"MasterId":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use AdministratorId instead."},"AdministratorId":{},"MemberStatus":{},"InvitedAt":{"shape":"Siz"},"UpdatedAt":{"shape":"Siz"}}}}}}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeActionTargets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ActionTargets"},"DescribeProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Products"},"DescribeStandards":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Standards"},"DescribeStandardsControls":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Controls"},"GetEnabledStandards":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"StandardsSubscriptions"},"GetFindings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Findings"},"GetInsights":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Insights"},"ListEnabledProductsForImport":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ProductSubscriptions"},"ListFindingAggregators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FindingAggregators"},"ListInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Invitations"},"ListMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Members"},"ListOrganizationAdminAccounts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AdminAccounts"}}}

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appmesh'] = {};
	AWS.AppMesh = Service.defineService('appmesh', ['2018-10-01', '2018-10-01*', '2019-01-25']);
	Object.defineProperty(apiLoader.services['appmesh'], '2018-10-01', {
	  get: function get() {
	    var model = __webpack_require__(700);
	    model.paginators = __webpack_require__(701).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['appmesh'], '2019-01-25', {
	  get: function get() {
	    var model = __webpack_require__(702);
	    model.paginators = __webpack_require__(703).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppMesh;


/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-01","endpointPrefix":"appmesh","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS App Mesh","serviceId":"App Mesh","signatureVersion":"v4","signingName":"appmesh","uid":"appmesh-2018-10-01"},"operations":{"CreateMesh":{"http":{"method":"PUT","requestUri":"/meshes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{}}},"output":{"type":"structure","members":{"mesh":{"shape":"S5"}},"payload":"mesh"},"idempotent":true},"CreateRoute":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"routeName":{},"spec":{"shape":"Sd"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"},"idempotent":true},"CreateVirtualNode":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"Sp"},"virtualNodeName":{}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"},"idempotent":true},"CreateVirtualRouter":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S18"},"virtualRouterName":{}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"},"idempotent":true},"DeleteMesh":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","members":{"mesh":{"shape":"S5"}},"payload":"mesh"},"idempotent":true},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"},"idempotent":true},"DeleteVirtualNode":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"},"idempotent":true},"DeleteVirtualRouter":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"},"idempotent":true},"DescribeMesh":{"http":{"method":"GET","requestUri":"/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","members":{"mesh":{"shape":"S5"}},"payload":"mesh"}},"DescribeRoute":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"}},"DescribeVirtualNode":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"}},"DescribeVirtualRouter":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"}},"ListMeshes":{"http":{"method":"GET","requestUri":"/meshes","responseCode":200},"input":{"type":"structure","members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["meshes"],"members":{"meshes":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{}}}},"nextToken":{}}}},"ListRoutes":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["routes"],"members":{"nextToken":{},"routes":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{},"routeName":{},"virtualRouterName":{}}}}}}},"ListVirtualNodes":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualNodes"],"members":{"nextToken":{},"virtualNodes":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{},"virtualNodeName":{}}}}}}},"ListVirtualRouters":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualRouters"],"members":{"nextToken":{},"virtualRouters":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{},"virtualRouterName":{}}}}}}},"UpdateRoute":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"spec":{"shape":"Sd"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"},"idempotent":true},"UpdateVirtualNode":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"Sp"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"},"idempotent":true},"UpdateVirtualRouter":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S18"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"},"idempotent":true}},"shapes":{"S5":{"type":"structure","required":["meshName","metadata"],"members":{"meshName":{},"metadata":{"shape":"S6"},"status":{"type":"structure","members":{"status":{}}}}},"S6":{"type":"structure","members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"uid":{},"version":{"type":"long"}}},"Sd":{"type":"structure","members":{"httpRoute":{"type":"structure","members":{"action":{"type":"structure","members":{"weightedTargets":{"type":"list","member":{"type":"structure","members":{"virtualNode":{},"weight":{"type":"integer"}}}}}},"match":{"type":"structure","members":{"prefix":{}}}}}}},"Sl":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"S6"},"routeName":{},"spec":{"shape":"Sd"},"status":{"type":"structure","members":{"status":{}}},"virtualRouterName":{}}},"Sp":{"type":"structure","members":{"backends":{"type":"list","member":{}},"listeners":{"type":"list","member":{"type":"structure","members":{"healthCheck":{"type":"structure","required":["healthyThreshold","intervalMillis","protocol","timeoutMillis","unhealthyThreshold"],"members":{"healthyThreshold":{"type":"integer"},"intervalMillis":{"type":"long"},"path":{},"port":{"type":"integer"},"protocol":{},"timeoutMillis":{"type":"long"},"unhealthyThreshold":{"type":"integer"}}},"portMapping":{"type":"structure","members":{"port":{"type":"integer"},"protocol":{}}}}}},"serviceDiscovery":{"type":"structure","members":{"dns":{"type":"structure","members":{"serviceName":{}}}}}}},"S14":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{},"metadata":{"shape":"S6"},"spec":{"shape":"Sp"},"status":{"type":"structure","members":{"status":{}}},"virtualNodeName":{}}},"S18":{"type":"structure","members":{"serviceNames":{"type":"list","member":{}}}},"S1b":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"S6"},"spec":{"shape":"S18"},"status":{"type":"structure","members":{"status":{}}},"virtualRouterName":{}}}}}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListMeshes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"meshes"},"ListRoutes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"routes"},"ListVirtualNodes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualNodes"},"ListVirtualRouters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualRouters"}}}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-01-25","endpointPrefix":"appmesh","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS App Mesh","serviceId":"App Mesh","signatureVersion":"v4","signingName":"appmesh","uid":"appmesh-2019-01-25"},"operations":{"CreateGatewayRoute":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualGateway/{virtualGatewayName}/gatewayRoutes","responseCode":200},"input":{"type":"structure","required":["gatewayRouteName","meshName","spec","virtualGatewayName"],"members":{"clientToken":{"idempotencyToken":true},"gatewayRouteName":{},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S5"},"tags":{"shape":"S19"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["gatewayRoute"],"members":{"gatewayRoute":{"shape":"S1e"}},"payload":"gatewayRoute"},"idempotent":true},"CreateMesh":{"http":{"method":"PUT","requestUri":"/v20190125/meshes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{},"spec":{"shape":"S1l"},"tags":{"shape":"S19"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"S1p"}},"payload":"mesh"},"idempotent":true},"CreateRoute":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"routeName":{},"spec":{"shape":"S1t"},"tags":{"shape":"S19"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S2t"}},"payload":"route"},"idempotent":true},"CreateVirtualGateway":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualGateways","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualGatewayName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S2x"},"tags":{"shape":"S19"},"virtualGatewayName":{}}},"output":{"type":"structure","required":["virtualGateway"],"members":{"virtualGateway":{"shape":"S47"}},"payload":"virtualGateway"},"idempotent":true},"CreateVirtualNode":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S4b"},"tags":{"shape":"S19"},"virtualNodeName":{}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S5t"}},"payload":"virtualNode"},"idempotent":true},"CreateVirtualRouter":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S5x"},"tags":{"shape":"S19"},"virtualRouterName":{}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S61"}},"payload":"virtualRouter"},"idempotent":true},"CreateVirtualService":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualServices","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualServiceName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S65"},"tags":{"shape":"S19"},"virtualServiceName":{}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S6a"}},"payload":"virtualService"},"idempotent":true},"DeleteGatewayRoute":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualGateway/{virtualGatewayName}/gatewayRoutes/{gatewayRouteName}","responseCode":200},"input":{"type":"structure","required":["gatewayRouteName","meshName","virtualGatewayName"],"members":{"gatewayRouteName":{"location":"uri","locationName":"gatewayRouteName"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["gatewayRoute"],"members":{"gatewayRoute":{"shape":"S1e"}},"payload":"gatewayRoute"},"idempotent":true},"DeleteMesh":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"S1p"}},"payload":"mesh"},"idempotent":true},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S2t"}},"payload":"route"},"idempotent":true},"DeleteVirtualGateway":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualGateways/{virtualGatewayName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualGatewayName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["virtualGateway"],"members":{"virtualGateway":{"shape":"S47"}},"payload":"virtualGateway"},"idempotent":true},"DeleteVirtualNode":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S5t"}},"payload":"virtualNode"},"idempotent":true},"DeleteVirtualRouter":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S61"}},"payload":"virtualRouter"},"idempotent":true},"DeleteVirtualService":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualServices/{virtualServiceName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualServiceName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualServiceName":{"location":"uri","locationName":"virtualServiceName"}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S6a"}},"payload":"virtualService"},"idempotent":true},"DescribeGatewayRoute":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualGateway/{virtualGatewayName}/gatewayRoutes/{gatewayRouteName}","responseCode":200},"input":{"type":"structure","required":["gatewayRouteName","meshName","virtualGatewayName"],"members":{"gatewayRouteName":{"location":"uri","locationName":"gatewayRouteName"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["gatewayRoute"],"members":{"gatewayRoute":{"shape":"S1e"}},"payload":"gatewayRoute"}},"DescribeMesh":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"S1p"}},"payload":"mesh"}},"DescribeRoute":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S2t"}},"payload":"route"}},"DescribeVirtualGateway":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualGateways/{virtualGatewayName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualGatewayName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["virtualGateway"],"members":{"virtualGateway":{"shape":"S47"}},"payload":"virtualGateway"}},"DescribeVirtualNode":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S5t"}},"payload":"virtualNode"}},"DescribeVirtualRouter":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S61"}},"payload":"virtualRouter"}},"DescribeVirtualService":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualServices/{virtualServiceName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualServiceName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"virtualServiceName":{"location":"uri","locationName":"virtualServiceName"}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S6a"}},"payload":"virtualService"}},"ListGatewayRoutes":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualGateway/{virtualGatewayName}/gatewayRoutes","responseCode":200},"input":{"type":"structure","required":["meshName","virtualGatewayName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"nextToken":{"location":"querystring","locationName":"nextToken"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["gatewayRoutes"],"members":{"gatewayRoutes":{"type":"list","member":{"type":"structure","required":["arn","createdAt","gatewayRouteName","lastUpdatedAt","meshName","meshOwner","resourceOwner","version","virtualGatewayName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"gatewayRouteName":{},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"version":{"type":"long"},"virtualGatewayName":{}}}},"nextToken":{}}}},"ListMeshes":{"http":{"method":"GET","requestUri":"/v20190125/meshes","responseCode":200},"input":{"type":"structure","members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["meshes"],"members":{"meshes":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshName","meshOwner","resourceOwner","version"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"version":{"type":"long"}}}},"nextToken":{}}}},"ListRoutes":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"nextToken":{"location":"querystring","locationName":"nextToken"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["routes"],"members":{"nextToken":{},"routes":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshName","meshOwner","resourceOwner","routeName","version","virtualRouterName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"routeName":{},"version":{"type":"long"},"virtualRouterName":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v20190125/tags","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","required":["tags"],"members":{"nextToken":{},"tags":{"shape":"S19"}}}},"ListVirtualGateways":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualGateways","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualGateways"],"members":{"nextToken":{},"virtualGateways":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshName","meshOwner","resourceOwner","version","virtualGatewayName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"version":{"type":"long"},"virtualGatewayName":{}}}}}}},"ListVirtualNodes":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualNodes"],"members":{"nextToken":{},"virtualNodes":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshName","meshOwner","resourceOwner","version","virtualNodeName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"version":{"type":"long"},"virtualNodeName":{}}}}}}},"ListVirtualRouters":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualRouters"],"members":{"nextToken":{},"virtualRouters":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshName","meshOwner","resourceOwner","version","virtualRouterName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"version":{"type":"long"},"virtualRouterName":{}}}}}}},"ListVirtualServices":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualServices","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualServices"],"members":{"nextToken":{},"virtualServices":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshName","meshOwner","resourceOwner","version","virtualServiceName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshName":{},"meshOwner":{},"resourceOwner":{},"version":{"type":"long"},"virtualServiceName":{}}}}}}},"TagResource":{"http":{"method":"PUT","requestUri":"/v20190125/tag","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"S19"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"PUT","requestUri":"/v20190125/untag","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateGatewayRoute":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualGateway/{virtualGatewayName}/gatewayRoutes/{gatewayRouteName}","responseCode":200},"input":{"type":"structure","required":["gatewayRouteName","meshName","spec","virtualGatewayName"],"members":{"clientToken":{"idempotencyToken":true},"gatewayRouteName":{"location":"uri","locationName":"gatewayRouteName"},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S5"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["gatewayRoute"],"members":{"gatewayRoute":{"shape":"S1e"}},"payload":"gatewayRoute"},"idempotent":true},"UpdateMesh":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S1l"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"S1p"}},"payload":"mesh"},"idempotent":true},"UpdateRoute":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"routeName":{"location":"uri","locationName":"routeName"},"spec":{"shape":"S1t"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S2t"}},"payload":"route"},"idempotent":true},"UpdateVirtualGateway":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualGateways/{virtualGatewayName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualGatewayName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S2x"},"virtualGatewayName":{"location":"uri","locationName":"virtualGatewayName"}}},"output":{"type":"structure","required":["virtualGateway"],"members":{"virtualGateway":{"shape":"S47"}},"payload":"virtualGateway"},"idempotent":true},"UpdateVirtualNode":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S4b"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S5t"}},"payload":"virtualNode"},"idempotent":true},"UpdateVirtualRouter":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S5x"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S61"}},"payload":"virtualRouter"},"idempotent":true},"UpdateVirtualService":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualServices/{virtualServiceName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualServiceName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"meshOwner":{"location":"querystring","locationName":"meshOwner"},"spec":{"shape":"S65"},"virtualServiceName":{"location":"uri","locationName":"virtualServiceName"}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S6a"}},"payload":"virtualService"},"idempotent":true}},"shapes":{"S5":{"type":"structure","members":{"grpcRoute":{"type":"structure","required":["action","match"],"members":{"action":{"type":"structure","required":["target"],"members":{"rewrite":{"type":"structure","members":{"hostname":{"shape":"S9"}}},"target":{"shape":"Sb"}}},"match":{"type":"structure","members":{"hostname":{"shape":"Se"},"metadata":{"type":"list","member":{"type":"structure","required":["name"],"members":{"invert":{"type":"boolean"},"match":{"type":"structure","members":{"exact":{},"prefix":{},"range":{"shape":"Sm"},"regex":{},"suffix":{}},"union":true},"name":{}}}},"serviceName":{}}}}},"http2Route":{"shape":"Sq"},"httpRoute":{"shape":"Sq"},"priority":{"type":"integer"}}},"S9":{"type":"structure","members":{"defaultTargetHostname":{}}},"Sb":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"type":"structure","required":["virtualServiceName"],"members":{"virtualServiceName":{}}}}},"Se":{"type":"structure","members":{"exact":{},"suffix":{}}},"Sm":{"type":"structure","required":["end","start"],"members":{"end":{"type":"long"},"start":{"type":"long"}}},"Sq":{"type":"structure","required":["action","match"],"members":{"action":{"type":"structure","required":["target"],"members":{"rewrite":{"type":"structure","members":{"hostname":{"shape":"S9"},"path":{"type":"structure","members":{"exact":{}}},"prefix":{"type":"structure","members":{"defaultPrefix":{},"value":{}}}}},"target":{"shape":"Sb"}}},"match":{"type":"structure","members":{"headers":{"type":"list","member":{"type":"structure","required":["name"],"members":{"invert":{"type":"boolean"},"match":{"shape":"S10"},"name":{}}}},"hostname":{"shape":"Se"},"method":{},"path":{"shape":"S12"},"prefix":{},"queryParameters":{"shape":"S14"}}}}},"S10":{"type":"structure","members":{"exact":{},"prefix":{},"range":{"shape":"Sm"},"regex":{},"suffix":{}},"union":true},"S12":{"type":"structure","members":{"exact":{},"regex":{}}},"S14":{"type":"list","member":{"type":"structure","required":["name"],"members":{"match":{"type":"structure","members":{"exact":{}}},"name":{}}}},"S19":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"S1e":{"type":"structure","required":["gatewayRouteName","meshName","metadata","spec","status","virtualGatewayName"],"members":{"gatewayRouteName":{},"meshName":{},"metadata":{"shape":"S1f"},"spec":{"shape":"S5"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualGatewayName":{}}},"S1f":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","meshOwner","resourceOwner","uid","version"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"meshOwner":{},"resourceOwner":{},"uid":{},"version":{"type":"long"}}},"S1l":{"type":"structure","members":{"egressFilter":{"type":"structure","required":["type"],"members":{"type":{}}}}},"S1p":{"type":"structure","required":["meshName","metadata","spec","status"],"members":{"meshName":{},"metadata":{"shape":"S1f"},"spec":{"shape":"S1l"},"status":{"type":"structure","members":{"status":{}}}}},"S1t":{"type":"structure","members":{"grpcRoute":{"type":"structure","required":["action","match"],"members":{"action":{"type":"structure","required":["weightedTargets"],"members":{"weightedTargets":{"shape":"S1w"}}},"match":{"type":"structure","members":{"metadata":{"type":"list","member":{"type":"structure","required":["name"],"members":{"invert":{"type":"boolean"},"match":{"type":"structure","members":{"exact":{},"prefix":{},"range":{"shape":"Sm"},"regex":{},"suffix":{}},"union":true},"name":{}}}},"methodName":{},"serviceName":{}}},"retryPolicy":{"type":"structure","required":["maxRetries","perRetryTimeout"],"members":{"grpcRetryEvents":{"type":"list","member":{}},"httpRetryEvents":{"shape":"S27"},"maxRetries":{"type":"long"},"perRetryTimeout":{"shape":"S2a"},"tcpRetryEvents":{"shape":"S2d"}}},"timeout":{"shape":"S2f"}}},"http2Route":{"shape":"S2g"},"httpRoute":{"shape":"S2g"},"priority":{"type":"integer"},"tcpRoute":{"type":"structure","required":["action"],"members":{"action":{"type":"structure","required":["weightedTargets"],"members":{"weightedTargets":{"shape":"S1w"}}},"timeout":{"shape":"S2r"}}}}},"S1w":{"type":"list","member":{"type":"structure","required":["virtualNode","weight"],"members":{"virtualNode":{},"weight":{"type":"integer"}}}},"S27":{"type":"list","member":{}},"S2a":{"type":"structure","members":{"unit":{},"value":{"type":"long"}}},"S2d":{"type":"list","member":{}},"S2f":{"type":"structure","members":{"idle":{"shape":"S2a"},"perRequest":{"shape":"S2a"}}},"S2g":{"type":"structure","required":["action","match"],"members":{"action":{"type":"structure","required":["weightedTargets"],"members":{"weightedTargets":{"shape":"S1w"}}},"match":{"type":"structure","members":{"headers":{"type":"list","member":{"type":"structure","required":["name"],"members":{"invert":{"type":"boolean"},"match":{"shape":"S10"},"name":{}}}},"method":{},"path":{"shape":"S12"},"prefix":{},"queryParameters":{"shape":"S14"},"scheme":{}}},"retryPolicy":{"type":"structure","required":["maxRetries","perRetryTimeout"],"members":{"httpRetryEvents":{"shape":"S27"},"maxRetries":{"type":"long"},"perRetryTimeout":{"shape":"S2a"},"tcpRetryEvents":{"shape":"S2d"}}},"timeout":{"shape":"S2n"}}},"S2n":{"type":"structure","members":{"idle":{"shape":"S2a"},"perRequest":{"shape":"S2a"}}},"S2r":{"type":"structure","members":{"idle":{"shape":"S2a"}}},"S2t":{"type":"structure","required":["meshName","metadata","routeName","spec","status","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"S1f"},"routeName":{},"spec":{"shape":"S1t"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualRouterName":{}}},"S2x":{"type":"structure","required":["listeners"],"members":{"backendDefaults":{"type":"structure","members":{"clientPolicy":{"type":"structure","members":{"tls":{"type":"structure","required":["validation"],"members":{"certificate":{"type":"structure","members":{"file":{"shape":"S32"},"sds":{"shape":"S34"}},"union":true},"enforce":{"type":"boolean"},"ports":{"shape":"S36"},"validation":{"type":"structure","required":["trust"],"members":{"subjectAlternativeNames":{"shape":"S39"},"trust":{"type":"structure","members":{"acm":{"type":"structure","required":["certificateAuthorityArns"],"members":{"certificateAuthorityArns":{"type":"list","member":{}}}},"file":{"shape":"S3g"},"sds":{"shape":"S3h"}},"union":true}}}}}}}}},"listeners":{"type":"list","member":{"type":"structure","required":["portMapping"],"members":{"connectionPool":{"type":"structure","members":{"grpc":{"type":"structure","required":["maxRequests"],"members":{"maxRequests":{"type":"integer"}}},"http":{"type":"structure","required":["maxConnections"],"members":{"maxConnections":{"type":"integer"},"maxPendingRequests":{"type":"integer"}}},"http2":{"type":"structure","required":["maxRequests"],"members":{"maxRequests":{"type":"integer"}}}},"union":true},"healthCheck":{"type":"structure","required":["healthyThreshold","intervalMillis","protocol","timeoutMillis","unhealthyThreshold"],"members":{"healthyThreshold":{"type":"integer"},"intervalMillis":{"type":"long"},"path":{},"port":{"type":"integer"},"protocol":{},"timeoutMillis":{"type":"long"},"unhealthyThreshold":{"type":"integer"}}},"portMapping":{"type":"structure","required":["port","protocol"],"members":{"port":{"type":"integer"},"protocol":{}}},"tls":{"type":"structure","required":["certificate","mode"],"members":{"certificate":{"type":"structure","members":{"acm":{"type":"structure","required":["certificateArn"],"members":{"certificateArn":{}}},"file":{"shape":"S32"},"sds":{"shape":"S34"}},"union":true},"mode":{},"validation":{"type":"structure","required":["trust"],"members":{"subjectAlternativeNames":{"shape":"S39"},"trust":{"type":"structure","members":{"file":{"shape":"S3g"},"sds":{"shape":"S3h"}},"union":true}}}}}}}},"logging":{"type":"structure","members":{"accessLog":{"type":"structure","members":{"file":{"type":"structure","required":["path"],"members":{"path":{}}}},"union":true}}}}},"S32":{"type":"structure","required":["certificateChain","privateKey"],"members":{"certificateChain":{},"privateKey":{}}},"S34":{"type":"structure","required":["secretName"],"members":{"secretName":{}}},"S36":{"type":"list","member":{"type":"integer"}},"S39":{"type":"structure","required":["match"],"members":{"match":{"type":"structure","required":["exact"],"members":{"exact":{"type":"list","member":{}}}}}},"S3g":{"type":"structure","required":["certificateChain"],"members":{"certificateChain":{}}},"S3h":{"type":"structure","required":["secretName"],"members":{"secretName":{}}},"S47":{"type":"structure","required":["meshName","metadata","spec","status","virtualGatewayName"],"members":{"meshName":{},"metadata":{"shape":"S1f"},"spec":{"shape":"S2x"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualGatewayName":{}}},"S4b":{"type":"structure","members":{"backendDefaults":{"type":"structure","members":{"clientPolicy":{"shape":"S4d"}}},"backends":{"type":"list","member":{"type":"structure","members":{"virtualService":{"type":"structure","required":["virtualServiceName"],"members":{"clientPolicy":{"shape":"S4d"},"virtualServiceName":{}}}},"union":true}},"listeners":{"type":"list","member":{"type":"structure","required":["portMapping"],"members":{"connectionPool":{"type":"structure","members":{"grpc":{"type":"structure","required":["maxRequests"],"members":{"maxRequests":{"type":"integer"}}},"http":{"type":"structure","required":["maxConnections"],"members":{"maxConnections":{"type":"integer"},"maxPendingRequests":{"type":"integer"}}},"http2":{"type":"structure","required":["maxRequests"],"members":{"maxRequests":{"type":"integer"}}},"tcp":{"type":"structure","required":["maxConnections"],"members":{"maxConnections":{"type":"integer"}}}},"union":true},"healthCheck":{"type":"structure","required":["healthyThreshold","intervalMillis","protocol","timeoutMillis","unhealthyThreshold"],"members":{"healthyThreshold":{"type":"integer"},"intervalMillis":{"type":"long"},"path":{},"port":{"type":"integer"},"protocol":{},"timeoutMillis":{"type":"long"},"unhealthyThreshold":{"type":"integer"}}},"outlierDetection":{"type":"structure","required":["baseEjectionDuration","interval","maxEjectionPercent","maxServerErrors"],"members":{"baseEjectionDuration":{"shape":"S2a"},"interval":{"shape":"S2a"},"maxEjectionPercent":{"type":"integer"},"maxServerErrors":{"type":"long"}}},"portMapping":{"shape":"S57"},"timeout":{"type":"structure","members":{"grpc":{"shape":"S2f"},"http":{"shape":"S2n"},"http2":{"shape":"S2n"},"tcp":{"shape":"S2r"}},"union":true},"tls":{"type":"structure","required":["certificate","mode"],"members":{"certificate":{"type":"structure","members":{"acm":{"type":"structure","required":["certificateArn"],"members":{"certificateArn":{}}},"file":{"shape":"S4g"},"sds":{"shape":"S4h"}},"union":true},"mode":{},"validation":{"type":"structure","required":["trust"],"members":{"subjectAlternativeNames":{"shape":"S39"},"trust":{"type":"structure","members":{"file":{"shape":"S4n"},"sds":{"shape":"S4o"}},"union":true}}}}}}}},"logging":{"type":"structure","members":{"accessLog":{"type":"structure","members":{"file":{"type":"structure","required":["path"],"members":{"path":{}}}},"union":true}}},"serviceDiscovery":{"type":"structure","members":{"awsCloudMap":{"type":"structure","required":["namespaceName","serviceName"],"members":{"attributes":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"namespaceName":{},"serviceName":{}}},"dns":{"type":"structure","required":["hostname"],"members":{"hostname":{},"responseType":{}}}},"union":true}}},"S4d":{"type":"structure","members":{"tls":{"type":"structure","required":["validation"],"members":{"certificate":{"type":"structure","members":{"file":{"shape":"S4g"},"sds":{"shape":"S4h"}},"union":true},"enforce":{"type":"boolean"},"ports":{"shape":"S36"},"validation":{"type":"structure","required":["trust"],"members":{"subjectAlternativeNames":{"shape":"S39"},"trust":{"type":"structure","members":{"acm":{"type":"structure","required":["certificateAuthorityArns"],"members":{"certificateAuthorityArns":{"type":"list","member":{}}}},"file":{"shape":"S4n"},"sds":{"shape":"S4o"}},"union":true}}}}}}},"S4g":{"type":"structure","required":["certificateChain","privateKey"],"members":{"certificateChain":{},"privateKey":{}}},"S4h":{"type":"structure","required":["secretName"],"members":{"secretName":{}}},"S4n":{"type":"structure","required":["certificateChain"],"members":{"certificateChain":{}}},"S4o":{"type":"structure","required":["secretName"],"members":{"secretName":{}}},"S57":{"type":"structure","required":["port","protocol"],"members":{"port":{"type":"integer"},"protocol":{}}},"S5t":{"type":"structure","required":["meshName","metadata","spec","status","virtualNodeName"],"members":{"meshName":{},"metadata":{"shape":"S1f"},"spec":{"shape":"S4b"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualNodeName":{}}},"S5x":{"type":"structure","members":{"listeners":{"type":"list","member":{"type":"structure","required":["portMapping"],"members":{"portMapping":{"shape":"S57"}}}}}},"S61":{"type":"structure","required":["meshName","metadata","spec","status","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"S1f"},"spec":{"shape":"S5x"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualRouterName":{}}},"S65":{"type":"structure","members":{"provider":{"type":"structure","members":{"virtualNode":{"type":"structure","required":["virtualNodeName"],"members":{"virtualNodeName":{}}},"virtualRouter":{"type":"structure","required":["virtualRouterName"],"members":{"virtualRouterName":{}}}},"union":true}}},"S6a":{"type":"structure","required":["meshName","metadata","spec","status","virtualServiceName"],"members":{"meshName":{},"metadata":{"shape":"S1f"},"spec":{"shape":"S65"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualServiceName":{}}}}}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListGatewayRoutes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"gatewayRoutes"},"ListMeshes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"meshes"},"ListRoutes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"routes"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"tags"},"ListVirtualGateways":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"virtualGateways"},"ListVirtualNodes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"virtualNodes"},"ListVirtualRouters":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"virtualRouters"},"ListVirtualServices":{"input_token":"nextToken","output_token":"nextToken","limit_key":"limit","result_key":"virtualServices"}}}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['licensemanager'] = {};
	AWS.LicenseManager = Service.defineService('licensemanager', ['2018-08-01']);
	Object.defineProperty(apiLoader.services['licensemanager'], '2018-08-01', {
	  get: function get() {
	    var model = __webpack_require__(705);
	    model.paginators = __webpack_require__(706).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LicenseManager;


/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-08-01","endpointPrefix":"license-manager","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS License Manager","serviceId":"License Manager","signatureVersion":"v4","targetPrefix":"AWSLicenseManager","uid":"license-manager-2018-08-01"},"operations":{"AcceptGrant":{"input":{"type":"structure","required":["GrantArn"],"members":{"GrantArn":{}}},"output":{"type":"structure","members":{"GrantArn":{},"Status":{},"Version":{}}}},"CheckInLicense":{"input":{"type":"structure","required":["LicenseConsumptionToken"],"members":{"LicenseConsumptionToken":{},"Beneficiary":{}}},"output":{"type":"structure","members":{}}},"CheckoutBorrowLicense":{"input":{"type":"structure","required":["LicenseArn","Entitlements","DigitalSignatureMethod","ClientToken"],"members":{"LicenseArn":{},"Entitlements":{"shape":"S9"},"DigitalSignatureMethod":{},"NodeId":{},"CheckoutMetadata":{"shape":"Sd"},"ClientToken":{}}},"output":{"type":"structure","members":{"LicenseArn":{},"LicenseConsumptionToken":{},"EntitlementsAllowed":{"shape":"S9"},"NodeId":{},"SignedToken":{},"IssuedAt":{},"Expiration":{},"CheckoutMetadata":{"shape":"Sd"}}}},"CheckoutLicense":{"input":{"type":"structure","required":["ProductSKU","CheckoutType","KeyFingerprint","Entitlements","ClientToken"],"members":{"ProductSKU":{},"CheckoutType":{},"KeyFingerprint":{},"Entitlements":{"shape":"S9"},"ClientToken":{},"Beneficiary":{},"NodeId":{}}},"output":{"type":"structure","members":{"CheckoutType":{},"LicenseConsumptionToken":{},"EntitlementsAllowed":{"shape":"S9"},"SignedToken":{},"NodeId":{},"IssuedAt":{},"Expiration":{},"LicenseArn":{}}}},"CreateGrant":{"input":{"type":"structure","required":["ClientToken","GrantName","LicenseArn","Principals","HomeRegion","AllowedOperations"],"members":{"ClientToken":{},"GrantName":{},"LicenseArn":{},"Principals":{"type":"list","member":{}},"HomeRegion":{},"AllowedOperations":{"shape":"So"}}},"output":{"type":"structure","members":{"GrantArn":{},"Status":{},"Version":{}}}},"CreateGrantVersion":{"input":{"type":"structure","required":["ClientToken","GrantArn"],"members":{"ClientToken":{},"GrantArn":{},"GrantName":{},"AllowedOperations":{"shape":"So"},"Status":{},"StatusReason":{},"SourceVersion":{}}},"output":{"type":"structure","members":{"GrantArn":{},"Status":{},"Version":{}}}},"CreateLicense":{"input":{"type":"structure","required":["LicenseName","ProductName","ProductSKU","Issuer","HomeRegion","Validity","Entitlements","Beneficiary","ConsumptionConfiguration","ClientToken"],"members":{"LicenseName":{},"ProductName":{},"ProductSKU":{},"Issuer":{"shape":"Sv"},"HomeRegion":{},"Validity":{"shape":"Sw"},"Entitlements":{"shape":"Sx"},"Beneficiary":{},"ConsumptionConfiguration":{"shape":"S12"},"LicenseMetadata":{"shape":"Sd"},"ClientToken":{}}},"output":{"type":"structure","members":{"LicenseArn":{},"Status":{},"Version":{}}}},"CreateLicenseConfiguration":{"input":{"type":"structure","required":["Name","LicenseCountingType"],"members":{"Name":{},"Description":{},"LicenseCountingType":{},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"LicenseRules":{"shape":"S1c"},"Tags":{"shape":"S1d"},"DisassociateWhenNotFound":{"type":"boolean"},"ProductInformationList":{"shape":"S1f"}}},"output":{"type":"structure","members":{"LicenseConfigurationArn":{}}}},"CreateLicenseConversionTaskForResource":{"input":{"type":"structure","required":["ResourceArn","SourceLicenseContext","DestinationLicenseContext"],"members":{"ResourceArn":{},"SourceLicenseContext":{"shape":"S1l"},"DestinationLicenseContext":{"shape":"S1l"}}},"output":{"type":"structure","members":{"LicenseConversionTaskId":{}}}},"CreateLicenseManagerReportGenerator":{"input":{"type":"structure","required":["ReportGeneratorName","Type","ReportContext","ReportFrequency","ClientToken"],"members":{"ReportGeneratorName":{},"Type":{"shape":"S1r"},"ReportContext":{"shape":"S1t"},"ReportFrequency":{"shape":"S1v"},"ClientToken":{},"Description":{},"Tags":{"shape":"S1d"}}},"output":{"type":"structure","members":{"LicenseManagerReportGeneratorArn":{}}}},"CreateLicenseVersion":{"input":{"type":"structure","required":["LicenseArn","LicenseName","ProductName","Issuer","HomeRegion","Validity","Entitlements","ConsumptionConfiguration","Status","ClientToken"],"members":{"LicenseArn":{},"LicenseName":{},"ProductName":{},"Issuer":{"shape":"Sv"},"HomeRegion":{},"Validity":{"shape":"Sw"},"LicenseMetadata":{"shape":"Sd"},"Entitlements":{"shape":"Sx"},"ConsumptionConfiguration":{"shape":"S12"},"Status":{},"ClientToken":{},"SourceVersion":{}}},"output":{"type":"structure","members":{"LicenseArn":{},"Version":{},"Status":{}}}},"CreateToken":{"input":{"type":"structure","required":["LicenseArn","ClientToken"],"members":{"LicenseArn":{},"RoleArns":{"shape":"S1u"},"ExpirationInDays":{"type":"integer"},"TokenProperties":{"shape":"S23"},"ClientToken":{}}},"output":{"type":"structure","members":{"TokenId":{},"TokenType":{},"Token":{}}}},"DeleteGrant":{"input":{"type":"structure","required":["GrantArn","Version"],"members":{"GrantArn":{},"StatusReason":{},"Version":{}}},"output":{"type":"structure","members":{"GrantArn":{},"Status":{},"Version":{}}}},"DeleteLicense":{"input":{"type":"structure","required":["LicenseArn","SourceVersion"],"members":{"LicenseArn":{},"SourceVersion":{}}},"output":{"type":"structure","members":{"Status":{},"DeletionDate":{}}}},"DeleteLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{}}},"output":{"type":"structure","members":{}}},"DeleteLicenseManagerReportGenerator":{"input":{"type":"structure","required":["LicenseManagerReportGeneratorArn"],"members":{"LicenseManagerReportGeneratorArn":{}}},"output":{"type":"structure","members":{}}},"DeleteToken":{"input":{"type":"structure","required":["TokenId"],"members":{"TokenId":{}}},"output":{"type":"structure","members":{}}},"ExtendLicenseConsumption":{"input":{"type":"structure","required":["LicenseConsumptionToken"],"members":{"LicenseConsumptionToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LicenseConsumptionToken":{},"Expiration":{}}}},"GetAccessToken":{"input":{"type":"structure","required":["Token"],"members":{"Token":{},"TokenProperties":{"shape":"S23"}}},"output":{"type":"structure","members":{"AccessToken":{}}}},"GetGrant":{"input":{"type":"structure","required":["GrantArn"],"members":{"GrantArn":{},"Version":{}}},"output":{"type":"structure","members":{"Grant":{"shape":"S2p"}}}},"GetLicense":{"input":{"type":"structure","required":["LicenseArn"],"members":{"LicenseArn":{},"Version":{}}},"output":{"type":"structure","members":{"License":{"shape":"S2s"}}}},"GetLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{}}},"output":{"type":"structure","members":{"LicenseConfigurationId":{},"LicenseConfigurationArn":{},"Name":{},"Description":{},"LicenseCountingType":{},"LicenseRules":{"shape":"S1c"},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"ConsumedLicenses":{"type":"long"},"Status":{},"OwnerAccountId":{},"ConsumedLicenseSummaryList":{"shape":"S2w"},"ManagedResourceSummaryList":{"shape":"S2z"},"Tags":{"shape":"S1d"},"ProductInformationList":{"shape":"S1f"},"AutomatedDiscoveryInformation":{"shape":"S31"},"DisassociateWhenNotFound":{"type":"boolean"}}}},"GetLicenseConversionTask":{"input":{"type":"structure","required":["LicenseConversionTaskId"],"members":{"LicenseConversionTaskId":{}}},"output":{"type":"structure","members":{"LicenseConversionTaskId":{},"ResourceArn":{},"SourceLicenseContext":{"shape":"S1l"},"DestinationLicenseContext":{"shape":"S1l"},"StatusMessage":{},"Status":{},"StartTime":{"type":"timestamp"},"LicenseConversionTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetLicenseManagerReportGenerator":{"input":{"type":"structure","required":["LicenseManagerReportGeneratorArn"],"members":{"LicenseManagerReportGeneratorArn":{}}},"output":{"type":"structure","members":{"ReportGenerator":{"shape":"S38"}}}},"GetLicenseUsage":{"input":{"type":"structure","required":["LicenseArn"],"members":{"LicenseArn":{}}},"output":{"type":"structure","members":{"LicenseUsage":{"type":"structure","members":{"EntitlementUsages":{"type":"list","member":{"type":"structure","required":["Name","ConsumedValue","Unit"],"members":{"Name":{},"ConsumedValue":{},"MaxCount":{},"Unit":{}}}}}}}}},"GetServiceSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"S3BucketArn":{},"SnsTopicArn":{},"OrganizationConfiguration":{"shape":"S3h"},"EnableCrossAccountsDiscovery":{"type":"boolean"},"LicenseManagerResourceShareArn":{}}}},"ListAssociationsForLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LicenseConfigurationAssociations":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"ResourceOwnerId":{},"AssociationTime":{"type":"timestamp"},"AmiAssociationScope":{}}}},"NextToken":{}}}},"ListDistributedGrants":{"input":{"type":"structure","members":{"GrantArns":{"shape":"S1u"},"Filters":{"shape":"S3n"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Grants":{"shape":"S3u"},"NextToken":{}}}},"ListFailuresForLicenseConfigurationOperations":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LicenseOperationFailureList":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"ErrorMessage":{},"FailureTime":{"type":"timestamp"},"OperationName":{},"ResourceOwnerId":{},"OperationRequestedBy":{},"MetadataList":{"shape":"Sd"}}}},"NextToken":{}}}},"ListLicenseConfigurations":{"input":{"type":"structure","members":{"LicenseConfigurationArns":{"shape":"S1c"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S40"}}},"output":{"type":"structure","members":{"LicenseConfigurations":{"type":"list","member":{"type":"structure","members":{"LicenseConfigurationId":{},"LicenseConfigurationArn":{},"Name":{},"Description":{},"LicenseCountingType":{},"LicenseRules":{"shape":"S1c"},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"DisassociateWhenNotFound":{"type":"boolean"},"ConsumedLicenses":{"type":"long"},"Status":{},"OwnerAccountId":{},"ConsumedLicenseSummaryList":{"shape":"S2w"},"ManagedResourceSummaryList":{"shape":"S2z"},"ProductInformationList":{"shape":"S1f"},"AutomatedDiscoveryInformation":{"shape":"S31"}}}},"NextToken":{}}}},"ListLicenseConversionTasks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S40"}}},"output":{"type":"structure","members":{"LicenseConversionTasks":{"type":"list","member":{"type":"structure","members":{"LicenseConversionTaskId":{},"ResourceArn":{},"SourceLicenseContext":{"shape":"S1l"},"DestinationLicenseContext":{"shape":"S1l"},"Status":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"LicenseConversionTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListLicenseManagerReportGenerators":{"input":{"type":"structure","members":{"Filters":{"shape":"S3n"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ReportGenerators":{"type":"list","member":{"shape":"S38"}},"NextToken":{}}}},"ListLicenseSpecificationsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LicenseSpecifications":{"shape":"S4d"},"NextToken":{}}}},"ListLicenseVersions":{"input":{"type":"structure","required":["LicenseArn"],"members":{"LicenseArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Licenses":{"shape":"S4h"},"NextToken":{}}}},"ListLicenses":{"input":{"type":"structure","members":{"LicenseArns":{"shape":"S1u"},"Filters":{"shape":"S3n"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Licenses":{"shape":"S4h"},"NextToken":{}}}},"ListReceivedGrants":{"input":{"type":"structure","members":{"GrantArns":{"shape":"S1u"},"Filters":{"shape":"S3n"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Grants":{"shape":"S3u"},"NextToken":{}}}},"ListReceivedLicenses":{"input":{"type":"structure","members":{"LicenseArns":{"shape":"S1u"},"Filters":{"shape":"S3n"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Licenses":{"type":"list","member":{"type":"structure","members":{"LicenseArn":{},"LicenseName":{},"ProductName":{},"ProductSKU":{},"Issuer":{"shape":"S2t"},"HomeRegion":{},"Status":{},"Validity":{"shape":"Sw"},"Beneficiary":{},"Entitlements":{"shape":"Sx"},"ConsumptionConfiguration":{"shape":"S12"},"LicenseMetadata":{"shape":"Sd"},"CreateTime":{},"Version":{},"ReceivedMetadata":{"type":"structure","members":{"ReceivedStatus":{},"ReceivedStatusReason":{},"AllowedOperations":{"shape":"So"}}}}}},"NextToken":{}}}},"ListResourceInventory":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Condition"],"members":{"Name":{},"Condition":{},"Value":{}}}}}},"output":{"type":"structure","members":{"ResourceInventoryList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"ResourceArn":{},"Platform":{},"PlatformVersion":{},"ResourceOwningAccountId":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1d"}}}},"ListTokens":{"input":{"type":"structure","members":{"TokenIds":{"shape":"S1c"},"Filters":{"shape":"S3n"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tokens":{"type":"list","member":{"type":"structure","members":{"TokenId":{},"TokenType":{},"LicenseArn":{},"ExpirationTime":{},"TokenProperties":{"shape":"S23"},"RoleArns":{"shape":"S1u"},"Status":{}}}},"NextToken":{}}}},"ListUsageForLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S40"}}},"output":{"type":"structure","members":{"LicenseConfigurationUsageList":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"ResourceStatus":{},"ResourceOwnerId":{},"AssociationTime":{"type":"timestamp"},"ConsumedLicenses":{"type":"long"}}}},"NextToken":{}}}},"RejectGrant":{"input":{"type":"structure","required":["GrantArn"],"members":{"GrantArn":{}}},"output":{"type":"structure","members":{"GrantArn":{},"Status":{},"Version":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S1d"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"LicenseConfigurationStatus":{},"LicenseRules":{"shape":"S1c"},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"Name":{},"Description":{},"ProductInformationList":{"shape":"S1f"},"DisassociateWhenNotFound":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateLicenseManagerReportGenerator":{"input":{"type":"structure","required":["LicenseManagerReportGeneratorArn","ReportGeneratorName","Type","ReportContext","ReportFrequency","ClientToken"],"members":{"LicenseManagerReportGeneratorArn":{},"ReportGeneratorName":{},"Type":{"shape":"S1r"},"ReportContext":{"shape":"S1t"},"ReportFrequency":{"shape":"S1v"},"ClientToken":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateLicenseSpecificationsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"AddLicenseSpecifications":{"shape":"S4d"},"RemoveLicenseSpecifications":{"shape":"S4d"}}},"output":{"type":"structure","members":{}}},"UpdateServiceSettings":{"input":{"type":"structure","members":{"S3BucketArn":{},"SnsTopicArn":{},"OrganizationConfiguration":{"shape":"S3h"},"EnableCrossAccountsDiscovery":{"type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","required":["Name","Unit"],"members":{"Name":{},"Value":{},"Unit":{}}}},"Sd":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"So":{"type":"list","member":{}},"Sv":{"type":"structure","required":["Name"],"members":{"Name":{},"SignKey":{}}},"Sw":{"type":"structure","required":["Begin"],"members":{"Begin":{},"End":{}}},"Sx":{"type":"list","member":{"type":"structure","required":["Name","Unit"],"members":{"Name":{},"Value":{},"MaxCount":{"type":"long"},"Overage":{"type":"boolean"},"Unit":{},"AllowCheckIn":{"type":"boolean"}}}},"S12":{"type":"structure","members":{"RenewType":{},"ProvisionalConfiguration":{"type":"structure","required":["MaxTimeToLiveInMinutes"],"members":{"MaxTimeToLiveInMinutes":{"type":"integer"}}},"BorrowConfiguration":{"type":"structure","required":["AllowEarlyCheckIn","MaxTimeToLiveInMinutes"],"members":{"AllowEarlyCheckIn":{"type":"boolean"},"MaxTimeToLiveInMinutes":{"type":"integer"}}}}},"S1c":{"type":"list","member":{}},"S1d":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S1f":{"type":"list","member":{"type":"structure","required":["ResourceType","ProductInformationFilterList"],"members":{"ResourceType":{},"ProductInformationFilterList":{"type":"list","member":{"type":"structure","required":["ProductInformationFilterName","ProductInformationFilterComparator"],"members":{"ProductInformationFilterName":{},"ProductInformationFilterValue":{"shape":"S1c"},"ProductInformationFilterComparator":{}}}}}}},"S1l":{"type":"structure","members":{"UsageOperation":{}}},"S1r":{"type":"list","member":{}},"S1t":{"type":"structure","required":["licenseConfigurationArns"],"members":{"licenseConfigurationArns":{"shape":"S1u"}}},"S1u":{"type":"list","member":{}},"S1v":{"type":"structure","members":{"value":{"type":"integer"},"period":{}}},"S23":{"type":"list","member":{}},"S2p":{"type":"structure","required":["GrantArn","GrantName","ParentArn","LicenseArn","GranteePrincipalArn","HomeRegion","GrantStatus","Version","GrantedOperations"],"members":{"GrantArn":{},"GrantName":{},"ParentArn":{},"LicenseArn":{},"GranteePrincipalArn":{},"HomeRegion":{},"GrantStatus":{},"StatusReason":{},"Version":{},"GrantedOperations":{"shape":"So"}}},"S2s":{"type":"structure","members":{"LicenseArn":{},"LicenseName":{},"ProductName":{},"ProductSKU":{},"Issuer":{"shape":"S2t"},"HomeRegion":{},"Status":{},"Validity":{"shape":"Sw"},"Beneficiary":{},"Entitlements":{"shape":"Sx"},"ConsumptionConfiguration":{"shape":"S12"},"LicenseMetadata":{"shape":"Sd"},"CreateTime":{},"Version":{}}},"S2t":{"type":"structure","members":{"Name":{},"SignKey":{},"KeyFingerprint":{}}},"S2w":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ConsumedLicenses":{"type":"long"}}}},"S2z":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"AssociationCount":{"type":"long"}}}},"S31":{"type":"structure","members":{"LastRunTime":{"type":"timestamp"}}},"S38":{"type":"structure","members":{"ReportGeneratorName":{},"ReportType":{"shape":"S1r"},"ReportContext":{"shape":"S1t"},"ReportFrequency":{"shape":"S1v"},"LicenseManagerReportGeneratorArn":{},"LastRunStatus":{},"LastRunFailureReason":{},"LastReportGenerationTime":{},"ReportCreatorAccount":{},"Description":{},"S3Location":{"type":"structure","members":{"bucket":{},"keyPrefix":{}}},"CreateTime":{},"Tags":{"shape":"S1d"}}},"S3h":{"type":"structure","required":["EnableIntegration"],"members":{"EnableIntegration":{"type":"boolean"}}},"S3n":{"type":"list","member":{"shape":"S3o"}},"S3o":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}},"S3u":{"type":"list","member":{"shape":"S2p"}},"S40":{"type":"list","member":{"shape":"S3o"}},"S4d":{"type":"list","member":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"AmiAssociationScope":{}}}},"S4h":{"type":"list","member":{"shape":"S2s"}}}}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kafka'] = {};
	AWS.Kafka = Service.defineService('kafka', ['2018-11-14']);
	Object.defineProperty(apiLoader.services['kafka'], '2018-11-14', {
	  get: function get() {
	    var model = __webpack_require__(708);
	    model.paginators = __webpack_require__(709).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Kafka;


/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-11-14","endpointPrefix":"kafka","signingName":"kafka","serviceFullName":"Managed Streaming for Kafka","serviceAbbreviation":"Kafka","serviceId":"Kafka","protocol":"rest-json","jsonVersion":"1.1","uid":"kafka-2018-11-14","signatureVersion":"v4"},"operations":{"BatchAssociateScramSecret":{"http":{"requestUri":"/v1/clusters/{clusterArn}/scram-secrets","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"SecretArnList":{"shape":"S3","locationName":"secretArnList"}},"required":["ClusterArn","SecretArnList"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"UnprocessedScramSecrets":{"shape":"S5","locationName":"unprocessedScramSecrets"}}}},"CreateCluster":{"http":{"requestUri":"/v1/clusters","responseCode":200},"input":{"type":"structure","members":{"BrokerNodeGroupInfo":{"shape":"S8","locationName":"brokerNodeGroupInfo"},"ClientAuthentication":{"shape":"Sj","locationName":"clientAuthentication"},"ClusterName":{"locationName":"clusterName"},"ConfigurationInfo":{"shape":"Sq","locationName":"configurationInfo"},"EncryptionInfo":{"shape":"Ss","locationName":"encryptionInfo"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"OpenMonitoring":{"shape":"Sx","locationName":"openMonitoring"},"KafkaVersion":{"locationName":"kafkaVersion"},"LoggingInfo":{"shape":"S12","locationName":"loggingInfo"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"},"Tags":{"shape":"S18","locationName":"tags"}},"required":["BrokerNodeGroupInfo","KafkaVersion","NumberOfBrokerNodes","ClusterName"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterName":{"locationName":"clusterName"},"State":{"locationName":"state"}}}},"CreateClusterV2":{"http":{"requestUri":"/api/v2/clusters","responseCode":200},"input":{"type":"structure","members":{"ClusterName":{"locationName":"clusterName"},"Tags":{"shape":"S18","locationName":"tags"},"Provisioned":{"locationName":"provisioned","type":"structure","members":{"BrokerNodeGroupInfo":{"shape":"S8","locationName":"brokerNodeGroupInfo"},"ClientAuthentication":{"shape":"Sj","locationName":"clientAuthentication"},"ConfigurationInfo":{"shape":"Sq","locationName":"configurationInfo"},"EncryptionInfo":{"shape":"Ss","locationName":"encryptionInfo"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"OpenMonitoring":{"shape":"Sx","locationName":"openMonitoring"},"KafkaVersion":{"locationName":"kafkaVersion"},"LoggingInfo":{"shape":"S12","locationName":"loggingInfo"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"}},"required":["BrokerNodeGroupInfo","KafkaVersion","NumberOfBrokerNodes"]},"Serverless":{"locationName":"serverless","type":"structure","members":{"VpcConfigs":{"shape":"S1e","locationName":"vpcConfigs"},"ClientAuthentication":{"shape":"S1g","locationName":"clientAuthentication"}},"required":["VpcConfigs"]}},"required":["ClusterName"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterName":{"locationName":"clusterName"},"State":{"locationName":"state"},"ClusterType":{"locationName":"clusterType"}}}},"CreateConfiguration":{"http":{"requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"KafkaVersions":{"shape":"S3","locationName":"kafkaVersions"},"Name":{"locationName":"name"},"ServerProperties":{"locationName":"serverProperties","type":"blob"}},"required":["ServerProperties","Name"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"LatestRevision":{"shape":"S1o","locationName":"latestRevision"},"Name":{"locationName":"name"},"State":{"locationName":"state"}}}},"DeleteCluster":{"http":{"method":"DELETE","requestUri":"/v1/clusters/{clusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"location":"querystring","locationName":"currentVersion"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"State":{"locationName":"state"}}}},"DeleteConfiguration":{"http":{"method":"DELETE","requestUri":"/v1/configurations/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"}},"required":["Arn"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"State":{"locationName":"state"}}}},"DescribeCluster":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterInfo":{"shape":"S1w","locationName":"clusterInfo"}}}},"DescribeClusterV2":{"http":{"method":"GET","requestUri":"/api/v2/clusters/{clusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterInfo":{"shape":"S25","locationName":"clusterInfo"}}}},"DescribeClusterOperation":{"http":{"method":"GET","requestUri":"/v1/operations/{clusterOperationArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterOperationArn":{"location":"uri","locationName":"clusterOperationArn"}},"required":["ClusterOperationArn"]},"output":{"type":"structure","members":{"ClusterOperationInfo":{"shape":"S2a","locationName":"clusterOperationInfo"}}}},"DescribeConfiguration":{"http":{"method":"GET","requestUri":"/v1/configurations/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"}},"required":["Arn"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"Description":{"locationName":"description"},"KafkaVersions":{"shape":"S3","locationName":"kafkaVersions"},"LatestRevision":{"shape":"S1o","locationName":"latestRevision"},"Name":{"locationName":"name"},"State":{"locationName":"state"}}}},"DescribeConfigurationRevision":{"http":{"method":"GET","requestUri":"/v1/configurations/{arn}/revisions/{revision}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"},"Revision":{"location":"uri","locationName":"revision","type":"long"}},"required":["Revision","Arn"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"Description":{"locationName":"description"},"Revision":{"locationName":"revision","type":"long"},"ServerProperties":{"locationName":"serverProperties","type":"blob"}}}},"BatchDisassociateScramSecret":{"http":{"method":"PATCH","requestUri":"/v1/clusters/{clusterArn}/scram-secrets","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"SecretArnList":{"shape":"S3","locationName":"secretArnList"}},"required":["ClusterArn","SecretArnList"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"UnprocessedScramSecrets":{"shape":"S5","locationName":"unprocessedScramSecrets"}}}},"GetBootstrapBrokers":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/bootstrap-brokers","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"BootstrapBrokerString":{"locationName":"bootstrapBrokerString"},"BootstrapBrokerStringTls":{"locationName":"bootstrapBrokerStringTls"},"BootstrapBrokerStringSaslScram":{"locationName":"bootstrapBrokerStringSaslScram"},"BootstrapBrokerStringSaslIam":{"locationName":"bootstrapBrokerStringSaslIam"},"BootstrapBrokerStringPublicTls":{"locationName":"bootstrapBrokerStringPublicTls"},"BootstrapBrokerStringPublicSaslScram":{"locationName":"bootstrapBrokerStringPublicSaslScram"},"BootstrapBrokerStringPublicSaslIam":{"locationName":"bootstrapBrokerStringPublicSaslIam"}}}},"GetCompatibleKafkaVersions":{"http":{"method":"GET","requestUri":"/v1/compatible-kafka-versions","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"querystring","locationName":"clusterArn"}}},"output":{"type":"structure","members":{"CompatibleKafkaVersions":{"locationName":"compatibleKafkaVersions","type":"list","member":{"type":"structure","members":{"SourceVersion":{"locationName":"sourceVersion"},"TargetVersions":{"shape":"S3","locationName":"targetVersions"}}}}}}},"ListClusterOperations":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/operations","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterOperationInfoList":{"locationName":"clusterOperationInfoList","type":"list","member":{"shape":"S2a"}},"NextToken":{"locationName":"nextToken"}}}},"ListClusters":{"http":{"method":"GET","requestUri":"/v1/clusters","responseCode":200},"input":{"type":"structure","members":{"ClusterNameFilter":{"location":"querystring","locationName":"clusterNameFilter"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ClusterInfoList":{"locationName":"clusterInfoList","type":"list","member":{"shape":"S1w"}},"NextToken":{"locationName":"nextToken"}}}},"ListClustersV2":{"http":{"method":"GET","requestUri":"/api/v2/clusters","responseCode":200},"input":{"type":"structure","members":{"ClusterNameFilter":{"location":"querystring","locationName":"clusterNameFilter"},"ClusterTypeFilter":{"location":"querystring","locationName":"clusterTypeFilter"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ClusterInfoList":{"locationName":"clusterInfoList","type":"list","member":{"shape":"S25"}},"NextToken":{"locationName":"nextToken"}}}},"ListConfigurationRevisions":{"http":{"method":"GET","requestUri":"/v1/configurations/{arn}/revisions","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["Arn"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Revisions":{"locationName":"revisions","type":"list","member":{"shape":"S1o"}}}}},"ListConfigurations":{"http":{"method":"GET","requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Configurations":{"locationName":"configurations","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"Description":{"locationName":"description"},"KafkaVersions":{"shape":"S3","locationName":"kafkaVersions"},"LatestRevision":{"shape":"S1o","locationName":"latestRevision"},"Name":{"locationName":"name"},"State":{"locationName":"state"}},"required":["Description","LatestRevision","CreationTime","KafkaVersions","Arn","Name","State"]}},"NextToken":{"locationName":"nextToken"}}}},"ListKafkaVersions":{"http":{"method":"GET","requestUri":"/v1/kafka-versions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"KafkaVersions":{"locationName":"kafkaVersions","type":"list","member":{"type":"structure","members":{"Version":{"locationName":"version"},"Status":{"locationName":"status"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListNodes":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/nodes","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"NodeInfoList":{"locationName":"nodeInfoList","type":"list","member":{"type":"structure","members":{"AddedToClusterTime":{"locationName":"addedToClusterTime"},"BrokerNodeInfo":{"locationName":"brokerNodeInfo","type":"structure","members":{"AttachedENIId":{"locationName":"attachedENIId"},"BrokerId":{"locationName":"brokerId","type":"double"},"ClientSubnet":{"locationName":"clientSubnet"},"ClientVpcIpAddress":{"locationName":"clientVpcIpAddress"},"CurrentBrokerSoftwareInfo":{"shape":"S1x","locationName":"currentBrokerSoftwareInfo"},"Endpoints":{"shape":"S3","locationName":"endpoints"}}},"InstanceType":{"locationName":"instanceType"},"NodeARN":{"locationName":"nodeARN"},"NodeType":{"locationName":"nodeType"},"ZookeeperNodeInfo":{"locationName":"zookeeperNodeInfo","type":"structure","members":{"AttachedENIId":{"locationName":"attachedENIId"},"ClientVpcIpAddress":{"locationName":"clientVpcIpAddress"},"Endpoints":{"shape":"S3","locationName":"endpoints"},"ZookeeperId":{"locationName":"zookeeperId","type":"double"},"ZookeeperVersion":{"locationName":"zookeeperVersion"}}}}}}}}},"ListScramSecrets":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/scram-secrets","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SecretArnList":{"shape":"S3","locationName":"secretArnList"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S18","locationName":"tags"}}}},"RebootBroker":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/reboot-broker","responseCode":200},"input":{"type":"structure","members":{"BrokerIds":{"shape":"S3","locationName":"brokerIds"},"ClusterArn":{"location":"uri","locationName":"clusterArn"}},"required":["ClusterArn","BrokerIds"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"TagResource":{"http":{"requestUri":"/v1/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"S18","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"shape":"S3","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateBrokerCount":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/nodes/count","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"locationName":"currentVersion"},"TargetNumberOfBrokerNodes":{"locationName":"targetNumberOfBrokerNodes","type":"integer"}},"required":["ClusterArn","CurrentVersion","TargetNumberOfBrokerNodes"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateBrokerType":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/nodes/type","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"locationName":"currentVersion"},"TargetInstanceType":{"locationName":"targetInstanceType"}},"required":["ClusterArn","CurrentVersion","TargetInstanceType"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateBrokerStorage":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/nodes/storage","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"locationName":"currentVersion"},"TargetBrokerEBSVolumeInfo":{"shape":"S2g","locationName":"targetBrokerEBSVolumeInfo"}},"required":["ClusterArn","TargetBrokerEBSVolumeInfo","CurrentVersion"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateConfiguration":{"http":{"method":"PUT","requestUri":"/v1/configurations/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"},"Description":{"locationName":"description"},"ServerProperties":{"locationName":"serverProperties","type":"blob"}},"required":["Arn","ServerProperties"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"LatestRevision":{"shape":"S1o","locationName":"latestRevision"}}}},"UpdateConnectivity":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/connectivity","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"ConnectivityInfo":{"shape":"Sh","locationName":"connectivityInfo"},"CurrentVersion":{"locationName":"currentVersion"}},"required":["ClusterArn","ConnectivityInfo","CurrentVersion"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateClusterConfiguration":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/configuration","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"ConfigurationInfo":{"shape":"Sq","locationName":"configurationInfo"},"CurrentVersion":{"locationName":"currentVersion"}},"required":["ClusterArn","CurrentVersion","ConfigurationInfo"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateClusterKafkaVersion":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/version","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"ConfigurationInfo":{"shape":"Sq","locationName":"configurationInfo"},"CurrentVersion":{"locationName":"currentVersion"},"TargetKafkaVersion":{"locationName":"targetKafkaVersion"}},"required":["ClusterArn","TargetKafkaVersion","CurrentVersion"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateMonitoring":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/monitoring","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"locationName":"currentVersion"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"OpenMonitoring":{"shape":"Sx","locationName":"openMonitoring"},"LoggingInfo":{"shape":"S12","locationName":"loggingInfo"}},"required":["ClusterArn","CurrentVersion"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateSecurity":{"http":{"method":"PATCH","requestUri":"/v1/clusters/{clusterArn}/security","responseCode":200},"input":{"type":"structure","members":{"ClientAuthentication":{"shape":"Sj","locationName":"clientAuthentication"},"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"locationName":"currentVersion"},"EncryptionInfo":{"shape":"Ss","locationName":"encryptionInfo"}},"required":["ClusterArn","CurrentVersion"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S5":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"},"SecretArn":{"locationName":"secretArn"}}}},"S8":{"type":"structure","members":{"BrokerAZDistribution":{"locationName":"brokerAZDistribution"},"ClientSubnets":{"shape":"S3","locationName":"clientSubnets"},"InstanceType":{"locationName":"instanceType"},"SecurityGroups":{"shape":"S3","locationName":"securityGroups"},"StorageInfo":{"locationName":"storageInfo","type":"structure","members":{"EbsStorageInfo":{"locationName":"ebsStorageInfo","type":"structure","members":{"ProvisionedThroughput":{"shape":"Sd","locationName":"provisionedThroughput"},"VolumeSize":{"locationName":"volumeSize","type":"integer"}}}}},"ConnectivityInfo":{"shape":"Sh","locationName":"connectivityInfo"}},"required":["ClientSubnets","InstanceType"]},"Sd":{"type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"VolumeThroughput":{"locationName":"volumeThroughput","type":"integer"}}},"Sh":{"type":"structure","members":{"PublicAccess":{"locationName":"publicAccess","type":"structure","members":{"Type":{"locationName":"type"}}}}},"Sj":{"type":"structure","members":{"Sasl":{"locationName":"sasl","type":"structure","members":{"Scram":{"locationName":"scram","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Iam":{"shape":"Sm","locationName":"iam"}}},"Tls":{"locationName":"tls","type":"structure","members":{"CertificateAuthorityArnList":{"shape":"S3","locationName":"certificateAuthorityArnList"},"Enabled":{"locationName":"enabled","type":"boolean"}}},"Unauthenticated":{"locationName":"unauthenticated","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}}}},"Sm":{"type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Sq":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Revision":{"locationName":"revision","type":"long"}},"required":["Revision","Arn"]},"Ss":{"type":"structure","members":{"EncryptionAtRest":{"locationName":"encryptionAtRest","type":"structure","members":{"DataVolumeKMSKeyId":{"locationName":"dataVolumeKMSKeyId"}},"required":["DataVolumeKMSKeyId"]},"EncryptionInTransit":{"locationName":"encryptionInTransit","type":"structure","members":{"ClientBroker":{"locationName":"clientBroker"},"InCluster":{"locationName":"inCluster","type":"boolean"}}}}},"Sx":{"type":"structure","members":{"Prometheus":{"locationName":"prometheus","type":"structure","members":{"JmxExporter":{"locationName":"jmxExporter","type":"structure","members":{"EnabledInBroker":{"locationName":"enabledInBroker","type":"boolean"}},"required":["EnabledInBroker"]},"NodeExporter":{"locationName":"nodeExporter","type":"structure","members":{"EnabledInBroker":{"locationName":"enabledInBroker","type":"boolean"}},"required":["EnabledInBroker"]}}}},"required":["Prometheus"]},"S12":{"type":"structure","members":{"BrokerLogs":{"locationName":"brokerLogs","type":"structure","members":{"CloudWatchLogs":{"locationName":"cloudWatchLogs","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"LogGroup":{"locationName":"logGroup"}},"required":["Enabled"]},"Firehose":{"locationName":"firehose","type":"structure","members":{"DeliveryStream":{"locationName":"deliveryStream"},"Enabled":{"locationName":"enabled","type":"boolean"}},"required":["Enabled"]},"S3":{"locationName":"s3","type":"structure","members":{"Bucket":{"locationName":"bucket"},"Enabled":{"locationName":"enabled","type":"boolean"},"Prefix":{"locationName":"prefix"}},"required":["Enabled"]}}}},"required":["BrokerLogs"]},"S18":{"type":"map","key":{},"value":{}},"S1e":{"type":"list","member":{"type":"structure","members":{"SubnetIds":{"shape":"S3","locationName":"subnetIds"},"SecurityGroupIds":{"shape":"S3","locationName":"securityGroupIds"}},"required":["SubnetIds"]}},"S1g":{"type":"structure","members":{"Sasl":{"locationName":"sasl","type":"structure","members":{"Iam":{"shape":"Sm","locationName":"iam"}}}}},"S1n":{"type":"timestamp","timestampFormat":"iso8601"},"S1o":{"type":"structure","members":{"CreationTime":{"shape":"S1n","locationName":"creationTime"},"Description":{"locationName":"description"},"Revision":{"locationName":"revision","type":"long"}},"required":["Revision","CreationTime"]},"S1w":{"type":"structure","members":{"ActiveOperationArn":{"locationName":"activeOperationArn"},"BrokerNodeGroupInfo":{"shape":"S8","locationName":"brokerNodeGroupInfo"},"ClientAuthentication":{"shape":"Sj","locationName":"clientAuthentication"},"ClusterArn":{"locationName":"clusterArn"},"ClusterName":{"locationName":"clusterName"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"CurrentBrokerSoftwareInfo":{"shape":"S1x","locationName":"currentBrokerSoftwareInfo"},"CurrentVersion":{"locationName":"currentVersion"},"EncryptionInfo":{"shape":"Ss","locationName":"encryptionInfo"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"OpenMonitoring":{"shape":"S1y","locationName":"openMonitoring"},"LoggingInfo":{"shape":"S12","locationName":"loggingInfo"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"},"State":{"locationName":"state"},"StateInfo":{"shape":"S22","locationName":"stateInfo"},"Tags":{"shape":"S18","locationName":"tags"},"ZookeeperConnectString":{"locationName":"zookeeperConnectString"},"ZookeeperConnectStringTls":{"locationName":"zookeeperConnectStringTls"}}},"S1x":{"type":"structure","members":{"ConfigurationArn":{"locationName":"configurationArn"},"ConfigurationRevision":{"locationName":"configurationRevision","type":"long"},"KafkaVersion":{"locationName":"kafkaVersion"}}},"S1y":{"type":"structure","members":{"Prometheus":{"locationName":"prometheus","type":"structure","members":{"JmxExporter":{"locationName":"jmxExporter","type":"structure","members":{"EnabledInBroker":{"locationName":"enabledInBroker","type":"boolean"}},"required":["EnabledInBroker"]},"NodeExporter":{"locationName":"nodeExporter","type":"structure","members":{"EnabledInBroker":{"locationName":"enabledInBroker","type":"boolean"}},"required":["EnabledInBroker"]}}}},"required":["Prometheus"]},"S22":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S25":{"type":"structure","members":{"ActiveOperationArn":{"locationName":"activeOperationArn"},"ClusterType":{"locationName":"clusterType"},"ClusterArn":{"locationName":"clusterArn"},"ClusterName":{"locationName":"clusterName"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"CurrentVersion":{"locationName":"currentVersion"},"State":{"locationName":"state"},"StateInfo":{"shape":"S22","locationName":"stateInfo"},"Tags":{"shape":"S18","locationName":"tags"},"Provisioned":{"locationName":"provisioned","type":"structure","members":{"BrokerNodeGroupInfo":{"shape":"S8","locationName":"brokerNodeGroupInfo"},"CurrentBrokerSoftwareInfo":{"shape":"S1x","locationName":"currentBrokerSoftwareInfo"},"ClientAuthentication":{"shape":"Sj","locationName":"clientAuthentication"},"EncryptionInfo":{"shape":"Ss","locationName":"encryptionInfo"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"OpenMonitoring":{"shape":"Sx","locationName":"openMonitoring"},"LoggingInfo":{"shape":"S12","locationName":"loggingInfo"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"},"ZookeeperConnectString":{"locationName":"zookeeperConnectString"},"ZookeeperConnectStringTls":{"locationName":"zookeeperConnectStringTls"}},"required":["BrokerNodeGroupInfo","NumberOfBrokerNodes"]},"Serverless":{"locationName":"serverless","type":"structure","members":{"VpcConfigs":{"shape":"S1e","locationName":"vpcConfigs"},"ClientAuthentication":{"shape":"S1g","locationName":"clientAuthentication"}},"required":["VpcConfigs"]}}},"S2a":{"type":"structure","members":{"ClientRequestId":{"locationName":"clientRequestId"},"ClusterArn":{"locationName":"clusterArn"},"CreationTime":{"shape":"S1n","locationName":"creationTime"},"EndTime":{"shape":"S1n","locationName":"endTime"},"ErrorInfo":{"locationName":"errorInfo","type":"structure","members":{"ErrorCode":{"locationName":"errorCode"},"ErrorString":{"locationName":"errorString"}}},"OperationArn":{"locationName":"operationArn"},"OperationState":{"locationName":"operationState"},"OperationSteps":{"locationName":"operationSteps","type":"list","member":{"type":"structure","members":{"StepInfo":{"locationName":"stepInfo","type":"structure","members":{"StepStatus":{"locationName":"stepStatus"}}},"StepName":{"locationName":"stepName"}}}},"OperationType":{"locationName":"operationType"},"SourceClusterInfo":{"shape":"S2f","locationName":"sourceClusterInfo"},"TargetClusterInfo":{"shape":"S2f","locationName":"targetClusterInfo"}}},"S2f":{"type":"structure","members":{"BrokerEBSVolumeInfo":{"shape":"S2g","locationName":"brokerEBSVolumeInfo"},"ConfigurationInfo":{"shape":"Sq","locationName":"configurationInfo"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"OpenMonitoring":{"shape":"S1y","locationName":"openMonitoring"},"KafkaVersion":{"locationName":"kafkaVersion"},"LoggingInfo":{"shape":"S12","locationName":"loggingInfo"},"InstanceType":{"locationName":"instanceType"},"ClientAuthentication":{"shape":"Sj","locationName":"clientAuthentication"},"EncryptionInfo":{"shape":"Ss","locationName":"encryptionInfo"},"ConnectivityInfo":{"shape":"Sh","locationName":"connectivityInfo"}}},"S2g":{"type":"list","member":{"type":"structure","members":{"KafkaBrokerNodeId":{"locationName":"kafkaBrokerNodeId"},"ProvisionedThroughput":{"shape":"Sd","locationName":"provisionedThroughput"},"VolumeSizeGB":{"locationName":"volumeSizeGB","type":"integer"}},"required":["KafkaBrokerNodeId"]}}}}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ClusterInfoList"},"ListClustersV2":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ClusterInfoList"},"ListConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Configurations"},"ListKafkaVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"KafkaVersions"},"ListNodes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NodeInfoList"},"ListClusterOperations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ClusterOperationInfoList"},"ListConfigurationRevisions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Revisions"},"ListScramSecrets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"SecretArnList"}}}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['apigatewaymanagementapi'] = {};
	AWS.ApiGatewayManagementApi = Service.defineService('apigatewaymanagementapi', ['2018-11-29']);
	Object.defineProperty(apiLoader.services['apigatewaymanagementapi'], '2018-11-29', {
	  get: function get() {
	    var model = __webpack_require__(711);
	    model.paginators = __webpack_require__(712).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ApiGatewayManagementApi;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-11-29","endpointPrefix":"execute-api","signingName":"execute-api","serviceFullName":"AmazonApiGatewayManagementApi","serviceId":"ApiGatewayManagementApi","protocol":"rest-json","jsonVersion":"1.1","uid":"apigatewaymanagementapi-2018-11-29","signatureVersion":"v4"},"operations":{"DeleteConnection":{"http":{"method":"DELETE","requestUri":"/@connections/{connectionId}","responseCode":204},"input":{"type":"structure","members":{"ConnectionId":{"location":"uri","locationName":"connectionId"}},"required":["ConnectionId"]}},"GetConnection":{"http":{"method":"GET","requestUri":"/@connections/{connectionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectionId":{"location":"uri","locationName":"connectionId"}},"required":["ConnectionId"]},"output":{"type":"structure","members":{"ConnectedAt":{"shape":"S5","locationName":"connectedAt"},"Identity":{"locationName":"identity","type":"structure","members":{"SourceIp":{"locationName":"sourceIp"},"UserAgent":{"locationName":"userAgent"}},"required":["SourceIp","UserAgent"]},"LastActiveAt":{"shape":"S5","locationName":"lastActiveAt"}}}},"PostToConnection":{"http":{"requestUri":"/@connections/{connectionId}","responseCode":200},"input":{"type":"structure","members":{"Data":{"type":"blob"},"ConnectionId":{"location":"uri","locationName":"connectionId"}},"required":["ConnectionId","Data"],"payload":"Data"}}},"shapes":{"S5":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['apigatewayv2'] = {};
	AWS.ApiGatewayV2 = Service.defineService('apigatewayv2', ['2018-11-29']);
	Object.defineProperty(apiLoader.services['apigatewayv2'], '2018-11-29', {
	  get: function get() {
	    var model = __webpack_require__(714);
	    model.paginators = __webpack_require__(715).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ApiGatewayV2;


/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-11-29","endpointPrefix":"apigateway","signingName":"apigateway","serviceFullName":"AmazonApiGatewayV2","serviceId":"ApiGatewayV2","protocol":"rest-json","jsonVersion":"1.1","uid":"apigatewayv2-2018-11-29","signatureVersion":"v4"},"operations":{"CreateApi":{"http":{"requestUri":"/v2/apis","responseCode":201},"input":{"type":"structure","members":{"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteKey":{"locationName":"routeKey"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Target":{"locationName":"target"},"Version":{"locationName":"version"}},"required":["ProtocolType","Name"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"ImportInfo":{"shape":"Sm","locationName":"importInfo"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Version":{"locationName":"version"},"Warnings":{"shape":"Sm","locationName":"warnings"}}}},"CreateApiMapping":{"http":{"requestUri":"/v2/domainnames/{domainName}/apimappings","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"DomainName":{"location":"uri","locationName":"domainName"},"Stage":{"locationName":"stage"}},"required":["DomainName","Stage","ApiId"]},"output":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}}}},"CreateAuthorizer":{"http":{"requestUri":"/v2/apis/{apiId}/authorizers","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerPayloadFormatVersion":{"locationName":"authorizerPayloadFormatVersion"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"EnableSimpleResponses":{"locationName":"enableSimpleResponses","type":"boolean"},"IdentitySource":{"shape":"Ss","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"JwtConfiguration":{"shape":"St","locationName":"jwtConfiguration"},"Name":{"locationName":"name"}},"required":["ApiId","AuthorizerType","IdentitySource","Name"]},"output":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerPayloadFormatVersion":{"locationName":"authorizerPayloadFormatVersion"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"EnableSimpleResponses":{"locationName":"enableSimpleResponses","type":"boolean"},"IdentitySource":{"shape":"Ss","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"JwtConfiguration":{"shape":"St","locationName":"jwtConfiguration"},"Name":{"locationName":"name"}}}},"CreateDeployment":{"http":{"requestUri":"/v2/apis/{apiId}/deployments","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"Description":{"locationName":"description"},"StageName":{"locationName":"stageName"}},"required":["ApiId"]},"output":{"type":"structure","members":{"AutoDeployed":{"locationName":"autoDeployed","type":"boolean"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"CreateDomainName":{"http":{"requestUri":"/v2/domainnames","responseCode":201},"input":{"type":"structure","members":{"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"S10","locationName":"domainNameConfigurations"},"MutualTlsAuthentication":{"shape":"S15","locationName":"mutualTlsAuthentication"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["DomainName"]},"output":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"S10","locationName":"domainNameConfigurations"},"MutualTlsAuthentication":{"shape":"S17","locationName":"mutualTlsAuthentication"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"CreateIntegration":{"http":{"requestUri":"/v2/apis/{apiId}/integrations","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationSubtype":{"locationName":"integrationSubtype"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"PayloadFormatVersion":{"locationName":"payloadFormatVersion"},"RequestParameters":{"shape":"S1e","locationName":"requestParameters"},"RequestTemplates":{"shape":"S1f","locationName":"requestTemplates"},"ResponseParameters":{"shape":"S1h","locationName":"responseParameters"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"},"TlsConfig":{"shape":"S1j","locationName":"tlsConfig"}},"required":["ApiId","IntegrationType"]},"output":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationSubtype":{"locationName":"integrationSubtype"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"PayloadFormatVersion":{"locationName":"payloadFormatVersion"},"RequestParameters":{"shape":"S1e","locationName":"requestParameters"},"RequestTemplates":{"shape":"S1f","locationName":"requestTemplates"},"ResponseParameters":{"shape":"S1h","locationName":"responseParameters"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"},"TlsConfig":{"shape":"S1l","locationName":"tlsConfig"}}}},"CreateIntegrationResponse":{"http":{"requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S1e","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S1f","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}},"required":["ApiId","IntegrationId","IntegrationResponseKey"]},"output":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S1e","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S1f","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}}}},"CreateModel":{"http":{"requestUri":"/v2/apis/{apiId}/models","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}},"required":["ApiId","Schema","Name"]},"output":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}}}},"CreateRoute":{"http":{"requestUri":"/v2/apis/{apiId}/routes","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1s","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1u","locationName":"requestModels"},"RequestParameters":{"shape":"S1v","locationName":"requestParameters"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}},"required":["ApiId","RouteKey"]},"output":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1s","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1u","locationName":"requestModels"},"RequestParameters":{"shape":"S1v","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}}}},"CreateRouteResponse":{"http":{"requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1u","locationName":"responseModels"},"ResponseParameters":{"shape":"S1v","locationName":"responseParameters"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseKey":{"locationName":"routeResponseKey"}},"required":["ApiId","RouteId","RouteResponseKey"]},"output":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1u","locationName":"responseModels"},"ResponseParameters":{"shape":"S1v","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}}}},"CreateStage":{"http":{"requestUri":"/v2/apis/{apiId}/stages","responseCode":201},"input":{"type":"structure","members":{"AccessLogSettings":{"shape":"S21","locationName":"accessLogSettings"},"ApiId":{"location":"uri","locationName":"apiId"},"AutoDeploy":{"locationName":"autoDeploy","type":"boolean"},"ClientCertificateId":{"locationName":"clientCertificateId"},"DefaultRouteSettings":{"shape":"S22","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"RouteSettings":{"shape":"S26","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S27","locationName":"stageVariables"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["ApiId","StageName"]},"output":{"type":"structure","members":{"AccessLogSettings":{"shape":"S21","locationName":"accessLogSettings"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"AutoDeploy":{"locationName":"autoDeploy","type":"boolean"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S22","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastDeploymentStatusMessage":{"locationName":"lastDeploymentStatusMessage"},"LastUpdatedDate":{"shape":"Sl","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S26","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S27","locationName":"stageVariables"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"CreateVpcLink":{"http":{"requestUri":"/v2/vpclinks","responseCode":201},"input":{"type":"structure","members":{"Name":{"locationName":"name"},"SecurityGroupIds":{"shape":"S2b","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S2c","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["SubnetIds","Name"]},"output":{"type":"structure","members":{"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Name":{"locationName":"name"},"SecurityGroupIds":{"shape":"S2b","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S2c","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"},"VpcLinkId":{"locationName":"vpcLinkId"},"VpcLinkStatus":{"locationName":"vpcLinkStatus"},"VpcLinkStatusMessage":{"locationName":"vpcLinkStatusMessage"},"VpcLinkVersion":{"locationName":"vpcLinkVersion"}}}},"DeleteAccessLogSettings":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/stages/{stageName}/accesslogsettings","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","ApiId"]}},"DeleteApi":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"}},"required":["ApiId"]}},"DeleteApiMapping":{"http":{"method":"DELETE","requestUri":"/v2/domainnames/{domainName}/apimappings/{apiMappingId}","responseCode":204},"input":{"type":"structure","members":{"ApiMappingId":{"location":"uri","locationName":"apiMappingId"},"DomainName":{"location":"uri","locationName":"domainName"}},"required":["ApiMappingId","DomainName"]}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/authorizers/{authorizerId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerId":{"location":"uri","locationName":"authorizerId"}},"required":["AuthorizerId","ApiId"]}},"DeleteCorsConfiguration":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/cors","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"}},"required":["ApiId"]}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/deployments/{deploymentId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"DeploymentId":{"location":"uri","locationName":"deploymentId"}},"required":["ApiId","DeploymentId"]}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/v2/domainnames/{domainName}","responseCode":204},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"}},"required":["DomainName"]}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"}},"required":["ApiId","IntegrationId"]}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses/{integrationResponseId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseId":{"location":"uri","locationName":"integrationResponseId"}},"required":["ApiId","IntegrationResponseId","IntegrationId"]}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/models/{modelId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelId":{"location":"uri","locationName":"modelId"}},"required":["ModelId","ApiId"]}},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/routes/{routeId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["ApiId","RouteId"]}},"DeleteRouteRequestParameter":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/routes/{routeId}/requestparameters/{requestParameterKey}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RequestParameterKey":{"location":"uri","locationName":"requestParameterKey"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["RequestParameterKey","ApiId","RouteId"]}},"DeleteRouteResponse":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses/{routeResponseId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseId":{"location":"uri","locationName":"routeResponseId"}},"required":["RouteResponseId","ApiId","RouteId"]}},"DeleteRouteSettings":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/stages/{stageName}/routesettings/{routeKey}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteKey":{"location":"uri","locationName":"routeKey"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","RouteKey","ApiId"]}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/stages/{stageName}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","ApiId"]}},"DeleteVpcLink":{"http":{"method":"DELETE","requestUri":"/v2/vpclinks/{vpcLinkId}","responseCode":202},"input":{"type":"structure","members":{"VpcLinkId":{"location":"uri","locationName":"vpcLinkId"}},"required":["VpcLinkId"]},"output":{"type":"structure","members":{}}},"ExportApi":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/exports/{specification}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ExportVersion":{"location":"querystring","locationName":"exportVersion"},"IncludeExtensions":{"location":"querystring","locationName":"includeExtensions","type":"boolean"},"OutputType":{"location":"querystring","locationName":"outputType"},"Specification":{"location":"uri","locationName":"specification"},"StageName":{"location":"querystring","locationName":"stageName"}},"required":["Specification","OutputType","ApiId"]},"output":{"type":"structure","members":{"body":{"type":"blob"}},"payload":"body"}},"ResetAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/stages/{stageName}/cache/authorizers","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","ApiId"]}},"GetApi":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"}},"required":["ApiId"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"ImportInfo":{"shape":"Sm","locationName":"importInfo"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Version":{"locationName":"version"},"Warnings":{"shape":"Sm","locationName":"warnings"}}}},"GetApiMapping":{"http":{"method":"GET","requestUri":"/v2/domainnames/{domainName}/apimappings/{apiMappingId}","responseCode":200},"input":{"type":"structure","members":{"ApiMappingId":{"location":"uri","locationName":"apiMappingId"},"DomainName":{"location":"uri","locationName":"domainName"}},"required":["ApiMappingId","DomainName"]},"output":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}}}},"GetApiMappings":{"http":{"method":"GET","requestUri":"/v2/domainnames/{domainName}/apimappings","responseCode":200},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["DomainName"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}},"required":["Stage","ApiId"]}},"NextToken":{"locationName":"nextToken"}}}},"GetApis":{"http":{"method":"GET","requestUri":"/v2/apis","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"ImportInfo":{"shape":"Sm","locationName":"importInfo"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Version":{"locationName":"version"},"Warnings":{"shape":"Sm","locationName":"warnings"}},"required":["RouteSelectionExpression","Name","ProtocolType"]}},"NextToken":{"locationName":"nextToken"}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/authorizers/{authorizerId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerId":{"location":"uri","locationName":"authorizerId"}},"required":["AuthorizerId","ApiId"]},"output":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerPayloadFormatVersion":{"locationName":"authorizerPayloadFormatVersion"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"EnableSimpleResponses":{"locationName":"enableSimpleResponses","type":"boolean"},"IdentitySource":{"shape":"Ss","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"JwtConfiguration":{"shape":"St","locationName":"jwtConfiguration"},"Name":{"locationName":"name"}}}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/authorizers","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerPayloadFormatVersion":{"locationName":"authorizerPayloadFormatVersion"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"EnableSimpleResponses":{"locationName":"enableSimpleResponses","type":"boolean"},"IdentitySource":{"shape":"Ss","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"JwtConfiguration":{"shape":"St","locationName":"jwtConfiguration"},"Name":{"locationName":"name"}},"required":["Name"]}},"NextToken":{"locationName":"nextToken"}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/deployments/{deploymentId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"DeploymentId":{"location":"uri","locationName":"deploymentId"}},"required":["ApiId","DeploymentId"]},"output":{"type":"structure","members":{"AutoDeployed":{"locationName":"autoDeployed","type":"boolean"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"GetDeployments":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/deployments","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"AutoDeployed":{"locationName":"autoDeployed","type":"boolean"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/v2/domainnames/{domainName}","responseCode":200},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"}},"required":["DomainName"]},"output":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"S10","locationName":"domainNameConfigurations"},"MutualTlsAuthentication":{"shape":"S17","locationName":"mutualTlsAuthentication"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/v2/domainnames","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"S10","locationName":"domainNameConfigurations"},"MutualTlsAuthentication":{"shape":"S17","locationName":"mutualTlsAuthentication"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["DomainName"]}},"NextToken":{"locationName":"nextToken"}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"}},"required":["ApiId","IntegrationId"]},"output":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationSubtype":{"locationName":"integrationSubtype"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"PayloadFormatVersion":{"locationName":"payloadFormatVersion"},"RequestParameters":{"shape":"S1e","locationName":"requestParameters"},"RequestTemplates":{"shape":"S1f","locationName":"requestTemplates"},"ResponseParameters":{"shape":"S1h","locationName":"responseParameters"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"},"TlsConfig":{"shape":"S1l","locationName":"tlsConfig"}}}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses/{integrationResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseId":{"location":"uri","locationName":"integrationResponseId"}},"required":["ApiId","IntegrationResponseId","IntegrationId"]},"output":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S1e","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S1f","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}}}},"GetIntegrationResponses":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["IntegrationId","ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S1e","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S1f","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}},"required":["IntegrationResponseKey"]}},"NextToken":{"locationName":"nextToken"}}}},"GetIntegrations":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationSubtype":{"locationName":"integrationSubtype"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"PayloadFormatVersion":{"locationName":"payloadFormatVersion"},"RequestParameters":{"shape":"S1e","locationName":"requestParameters"},"RequestTemplates":{"shape":"S1f","locationName":"requestTemplates"},"ResponseParameters":{"shape":"S1h","locationName":"responseParameters"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"},"TlsConfig":{"shape":"S1l","locationName":"tlsConfig"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetModel":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/models/{modelId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelId":{"location":"uri","locationName":"modelId"}},"required":["ModelId","ApiId"]},"output":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}}}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/models/{modelId}/template","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelId":{"location":"uri","locationName":"modelId"}},"required":["ModelId","ApiId"]},"output":{"type":"structure","members":{"Value":{"locationName":"value"}}}},"GetModels":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/models","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}},"required":["Name"]}},"NextToken":{"locationName":"nextToken"}}}},"GetRoute":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes/{routeId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["ApiId","RouteId"]},"output":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1s","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1u","locationName":"requestModels"},"RequestParameters":{"shape":"S1v","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}}}},"GetRouteResponse":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses/{routeResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseId":{"location":"uri","locationName":"routeResponseId"}},"required":["RouteResponseId","ApiId","RouteId"]},"output":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1u","locationName":"responseModels"},"ResponseParameters":{"shape":"S1v","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}}}},"GetRouteResponses":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["RouteId","ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1u","locationName":"responseModels"},"ResponseParameters":{"shape":"S1v","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}},"required":["RouteResponseKey"]}},"NextToken":{"locationName":"nextToken"}}}},"GetRoutes":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1s","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1u","locationName":"requestModels"},"RequestParameters":{"shape":"S1v","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}},"required":["RouteKey"]}},"NextToken":{"locationName":"nextToken"}}}},"GetStage":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/stages/{stageName}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","ApiId"]},"output":{"type":"structure","members":{"AccessLogSettings":{"shape":"S21","locationName":"accessLogSettings"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"AutoDeploy":{"locationName":"autoDeploy","type":"boolean"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S22","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastDeploymentStatusMessage":{"locationName":"lastDeploymentStatusMessage"},"LastUpdatedDate":{"shape":"Sl","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S26","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S27","locationName":"stageVariables"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"GetStages":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/stages","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"AccessLogSettings":{"shape":"S21","locationName":"accessLogSettings"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"AutoDeploy":{"locationName":"autoDeploy","type":"boolean"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S22","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastDeploymentStatusMessage":{"locationName":"lastDeploymentStatusMessage"},"LastUpdatedDate":{"shape":"Sl","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S26","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S27","locationName":"stageVariables"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["StageName"]}},"NextToken":{"locationName":"nextToken"}}}},"GetTags":{"http":{"method":"GET","requestUri":"/v2/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sg","locationName":"tags"}}}},"GetVpcLink":{"http":{"method":"GET","requestUri":"/v2/vpclinks/{vpcLinkId}","responseCode":200},"input":{"type":"structure","members":{"VpcLinkId":{"location":"uri","locationName":"vpcLinkId"}},"required":["VpcLinkId"]},"output":{"type":"structure","members":{"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Name":{"locationName":"name"},"SecurityGroupIds":{"shape":"S2b","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S2c","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"},"VpcLinkId":{"locationName":"vpcLinkId"},"VpcLinkStatus":{"locationName":"vpcLinkStatus"},"VpcLinkStatusMessage":{"locationName":"vpcLinkStatusMessage"},"VpcLinkVersion":{"locationName":"vpcLinkVersion"}}}},"GetVpcLinks":{"http":{"method":"GET","requestUri":"/v2/vpclinks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Name":{"locationName":"name"},"SecurityGroupIds":{"shape":"S2b","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S2c","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"},"VpcLinkId":{"locationName":"vpcLinkId"},"VpcLinkStatus":{"locationName":"vpcLinkStatus"},"VpcLinkStatusMessage":{"locationName":"vpcLinkStatusMessage"},"VpcLinkVersion":{"locationName":"vpcLinkVersion"}},"required":["VpcLinkId","SecurityGroupIds","SubnetIds","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"ImportApi":{"http":{"method":"PUT","requestUri":"/v2/apis","responseCode":201},"input":{"type":"structure","members":{"Basepath":{"location":"querystring","locationName":"basepath"},"Body":{"locationName":"body"},"FailOnWarnings":{"location":"querystring","locationName":"failOnWarnings","type":"boolean"}},"required":["Body"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"ImportInfo":{"shape":"Sm","locationName":"importInfo"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Version":{"locationName":"version"},"Warnings":{"shape":"Sm","locationName":"warnings"}}}},"ReimportApi":{"http":{"method":"PUT","requestUri":"/v2/apis/{apiId}","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"Basepath":{"location":"querystring","locationName":"basepath"},"Body":{"locationName":"body"},"FailOnWarnings":{"location":"querystring","locationName":"failOnWarnings","type":"boolean"}},"required":["ApiId","Body"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"ImportInfo":{"shape":"Sm","locationName":"importInfo"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Version":{"locationName":"version"},"Warnings":{"shape":"Sm","locationName":"warnings"}}}},"TagResource":{"http":{"requestUri":"/v2/tags/{resource-arn}","responseCode":201},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"Sg","locationName":"tags"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v2/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"Sm","location":"querystring","locationName":"tagKeys"}},"required":["ResourceArn","TagKeys"]}},"UpdateApi":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"Name":{"locationName":"name"},"RouteKey":{"locationName":"routeKey"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Target":{"locationName":"target"},"Version":{"locationName":"version"}},"required":["ApiId"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CorsConfiguration":{"shape":"S3","locationName":"corsConfiguration"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"DisableExecuteApiEndpoint":{"locationName":"disableExecuteApiEndpoint","type":"boolean"},"ImportInfo":{"shape":"Sm","locationName":"importInfo"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Tags":{"shape":"Sg","locationName":"tags"},"Version":{"locationName":"version"},"Warnings":{"shape":"Sm","locationName":"warnings"}}}},"UpdateApiMapping":{"http":{"method":"PATCH","requestUri":"/v2/domainnames/{domainName}/apimappings/{apiMappingId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"location":"uri","locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"DomainName":{"location":"uri","locationName":"domainName"},"Stage":{"locationName":"stage"}},"required":["ApiMappingId","ApiId","DomainName"]},"output":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}}}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/authorizers/{authorizerId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"location":"uri","locationName":"authorizerId"},"AuthorizerPayloadFormatVersion":{"locationName":"authorizerPayloadFormatVersion"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"EnableSimpleResponses":{"locationName":"enableSimpleResponses","type":"boolean"},"IdentitySource":{"shape":"Ss","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"JwtConfiguration":{"shape":"St","locationName":"jwtConfiguration"},"Name":{"locationName":"name"}},"required":["AuthorizerId","ApiId"]},"output":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerPayloadFormatVersion":{"locationName":"authorizerPayloadFormatVersion"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"EnableSimpleResponses":{"locationName":"enableSimpleResponses","type":"boolean"},"IdentitySource":{"shape":"Ss","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"JwtConfiguration":{"shape":"St","locationName":"jwtConfiguration"},"Name":{"locationName":"name"}}}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/deployments/{deploymentId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"DeploymentId":{"location":"uri","locationName":"deploymentId"},"Description":{"locationName":"description"}},"required":["ApiId","DeploymentId"]},"output":{"type":"structure","members":{"AutoDeployed":{"locationName":"autoDeployed","type":"boolean"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/v2/domainnames/{domainName}","responseCode":200},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"},"DomainNameConfigurations":{"shape":"S10","locationName":"domainNameConfigurations"},"MutualTlsAuthentication":{"shape":"S15","locationName":"mutualTlsAuthentication"}},"required":["DomainName"]},"output":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"S10","locationName":"domainNameConfigurations"},"MutualTlsAuthentication":{"shape":"S17","locationName":"mutualTlsAuthentication"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationSubtype":{"locationName":"integrationSubtype"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"PayloadFormatVersion":{"locationName":"payloadFormatVersion"},"RequestParameters":{"shape":"S1e","locationName":"requestParameters"},"RequestTemplates":{"shape":"S1f","locationName":"requestTemplates"},"ResponseParameters":{"shape":"S1h","locationName":"responseParameters"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"},"TlsConfig":{"shape":"S1j","locationName":"tlsConfig"}},"required":["ApiId","IntegrationId"]},"output":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationSubtype":{"locationName":"integrationSubtype"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"PayloadFormatVersion":{"locationName":"payloadFormatVersion"},"RequestParameters":{"shape":"S1e","locationName":"requestParameters"},"RequestTemplates":{"shape":"S1f","locationName":"requestTemplates"},"ResponseParameters":{"shape":"S1h","locationName":"responseParameters"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"},"TlsConfig":{"shape":"S1l","locationName":"tlsConfig"}}}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses/{integrationResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseId":{"location":"uri","locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S1e","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S1f","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}},"required":["ApiId","IntegrationResponseId","IntegrationId"]},"output":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S1e","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S1f","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}}}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/models/{modelId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"location":"uri","locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}},"required":["ModelId","ApiId"]},"output":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}}}},"UpdateRoute":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/routes/{routeId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1s","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1u","locationName":"requestModels"},"RequestParameters":{"shape":"S1v","locationName":"requestParameters"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}},"required":["ApiId","RouteId"]},"output":{"type":"structure","members":{"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1s","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1u","locationName":"requestModels"},"RequestParameters":{"shape":"S1v","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}}}},"UpdateRouteResponse":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses/{routeResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1u","locationName":"responseModels"},"ResponseParameters":{"shape":"S1v","locationName":"responseParameters"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseId":{"location":"uri","locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}},"required":["RouteResponseId","ApiId","RouteId"]},"output":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1u","locationName":"responseModels"},"ResponseParameters":{"shape":"S1v","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}}}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/stages/{stageName}","responseCode":200},"input":{"type":"structure","members":{"AccessLogSettings":{"shape":"S21","locationName":"accessLogSettings"},"ApiId":{"location":"uri","locationName":"apiId"},"AutoDeploy":{"locationName":"autoDeploy","type":"boolean"},"ClientCertificateId":{"locationName":"clientCertificateId"},"DefaultRouteSettings":{"shape":"S22","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"RouteSettings":{"shape":"S26","locationName":"routeSettings"},"StageName":{"location":"uri","locationName":"stageName"},"StageVariables":{"shape":"S27","locationName":"stageVariables"}},"required":["StageName","ApiId"]},"output":{"type":"structure","members":{"AccessLogSettings":{"shape":"S21","locationName":"accessLogSettings"},"ApiGatewayManaged":{"locationName":"apiGatewayManaged","type":"boolean"},"AutoDeploy":{"locationName":"autoDeploy","type":"boolean"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S22","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastDeploymentStatusMessage":{"locationName":"lastDeploymentStatusMessage"},"LastUpdatedDate":{"shape":"Sl","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S26","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S27","locationName":"stageVariables"},"Tags":{"shape":"Sg","locationName":"tags"}}}},"UpdateVpcLink":{"http":{"method":"PATCH","requestUri":"/v2/vpclinks/{vpcLinkId}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name"},"VpcLinkId":{"location":"uri","locationName":"vpcLinkId"}},"required":["VpcLinkId"]},"output":{"type":"structure","members":{"CreatedDate":{"shape":"Sl","locationName":"createdDate"},"Name":{"locationName":"name"},"SecurityGroupIds":{"shape":"S2b","locationName":"securityGroupIds"},"SubnetIds":{"shape":"S2c","locationName":"subnetIds"},"Tags":{"shape":"Sg","locationName":"tags"},"VpcLinkId":{"locationName":"vpcLinkId"},"VpcLinkStatus":{"locationName":"vpcLinkStatus"},"VpcLinkStatusMessage":{"locationName":"vpcLinkStatusMessage"},"VpcLinkVersion":{"locationName":"vpcLinkVersion"}}}}},"shapes":{"S3":{"type":"structure","members":{"AllowCredentials":{"locationName":"allowCredentials","type":"boolean"},"AllowHeaders":{"shape":"S5","locationName":"allowHeaders"},"AllowMethods":{"locationName":"allowMethods","type":"list","member":{}},"AllowOrigins":{"locationName":"allowOrigins","type":"list","member":{}},"ExposeHeaders":{"shape":"S5","locationName":"exposeHeaders"},"MaxAge":{"locationName":"maxAge","type":"integer"}}},"S5":{"type":"list","member":{}},"Sg":{"type":"map","key":{},"value":{}},"Sl":{"type":"timestamp","timestampFormat":"iso8601"},"Sm":{"type":"list","member":{}},"Ss":{"type":"list","member":{}},"St":{"type":"structure","members":{"Audience":{"shape":"Sm","locationName":"audience"},"Issuer":{"locationName":"issuer"}}},"S10":{"type":"list","member":{"type":"structure","members":{"ApiGatewayDomainName":{"locationName":"apiGatewayDomainName"},"CertificateArn":{"locationName":"certificateArn"},"CertificateName":{"locationName":"certificateName"},"CertificateUploadDate":{"shape":"Sl","locationName":"certificateUploadDate"},"DomainNameStatus":{"locationName":"domainNameStatus"},"DomainNameStatusMessage":{"locationName":"domainNameStatusMessage"},"EndpointType":{"locationName":"endpointType"},"HostedZoneId":{"locationName":"hostedZoneId"},"SecurityPolicy":{"locationName":"securityPolicy"},"OwnershipVerificationCertificateArn":{"locationName":"ownershipVerificationCertificateArn"}}}},"S15":{"type":"structure","members":{"TruststoreUri":{"locationName":"truststoreUri"},"TruststoreVersion":{"locationName":"truststoreVersion"}}},"S17":{"type":"structure","members":{"TruststoreUri":{"locationName":"truststoreUri"},"TruststoreVersion":{"locationName":"truststoreVersion"},"TruststoreWarnings":{"shape":"Sm","locationName":"truststoreWarnings"}}},"S1e":{"type":"map","key":{},"value":{}},"S1f":{"type":"map","key":{},"value":{}},"S1h":{"type":"map","key":{},"value":{"shape":"S1e"}},"S1j":{"type":"structure","members":{"ServerNameToVerify":{"locationName":"serverNameToVerify"}}},"S1l":{"type":"structure","members":{"ServerNameToVerify":{"locationName":"serverNameToVerify"}}},"S1s":{"type":"list","member":{}},"S1u":{"type":"map","key":{},"value":{}},"S1v":{"type":"map","key":{},"value":{"type":"structure","members":{"Required":{"locationName":"required","type":"boolean"}}}},"S21":{"type":"structure","members":{"DestinationArn":{"locationName":"destinationArn"},"Format":{"locationName":"format"}}},"S22":{"type":"structure","members":{"DataTraceEnabled":{"locationName":"dataTraceEnabled","type":"boolean"},"DetailedMetricsEnabled":{"locationName":"detailedMetricsEnabled","type":"boolean"},"LoggingLevel":{"locationName":"loggingLevel"},"ThrottlingBurstLimit":{"locationName":"throttlingBurstLimit","type":"integer"},"ThrottlingRateLimit":{"locationName":"throttlingRateLimit","type":"double"}}},"S26":{"type":"map","key":{},"value":{"shape":"S22"}},"S27":{"type":"map","key":{},"value":{}},"S2b":{"type":"list","member":{}},"S2c":{"type":"list","member":{}}}}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['docdb'] = {};
	AWS.DocDB = Service.defineService('docdb', ['2014-10-31']);
	__webpack_require__(717);
	Object.defineProperty(apiLoader.services['docdb'], '2014-10-31', {
	  get: function get() {
	    var model = __webpack_require__(718);
	    model.paginators = __webpack_require__(719).pagination;
	    model.waiters = __webpack_require__(720).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DocDB;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var rdsutil = __webpack_require__(325);

	/**
	* @api private
	*/
	var crossRegionOperations = ['createDBCluster', 'copyDBClusterSnapshot'];

	AWS.util.update(AWS.DocDB.prototype, {
	  /**
	  * @api private
	  */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (
	      crossRegionOperations.indexOf(request.operation) !== -1 &&
	      this.config.params &&
	      this.config.params.SourceRegion &&
	      request.params &&
	      !request.params.SourceRegion
	    ) {
	      request.params.SourceRegion = this.config.params.SourceRegion;
	    }
	    rdsutil.setupRequestListeners(this, request, crossRegionOperations);
	  },
	});


/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon DocDB","serviceFullName":"Amazon DocumentDB with MongoDB compatibility","serviceId":"DocDB","signatureVersion":"v4","signingName":"rds","uid":"docdb-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Sd"}}}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sj"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sn"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"So"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Ss"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"S9"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableCloudwatchLogsExports":{"shape":"St"},"DeletionProtection":{"type":"boolean"},"GlobalClusterIdentifier":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sj"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sn"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","DBClusterIdentifier"],"members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"Tags":{"shape":"S9"},"DBClusterIdentifier":{},"PromotionTier":{"type":"integer"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1a"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1c"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{},"SourceDBClusterIdentifier":{},"Engine":{},"EngineVersion":{},"DeletionProtection":{"type":"boolean"},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"}}},"output":{"resultWrapper":"CreateGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S1r"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sn"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1a"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S1r"}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"Certificates":{"type":"list","member":{"locationName":"Certificate","type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{}},"wrapper":true}},"Marker":{}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sj","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S2j"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S2o"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"Sw","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"ExportableLogTypes":{"shape":"St"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S1a","locationName":"DBInstance"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2j"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S28"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeGlobalClusters":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeGlobalClustersResult","type":"structure","members":{"Marker":{},"GlobalClusters":{"type":"list","member":{"shape":"S1r","locationName":"GlobalClusterMember"}}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S28"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1f","locationName":"AvailabilityZone"}},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S28"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Sd","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"FailoverDBCluster":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S28"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Ss"},"Port":{"type":"integer"},"MasterUserPassword":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"CloudwatchLogsExportConfiguration":{"type":"structure","members":{"EnableLogTypes":{"shape":"St"},"DisableLogTypes":{"shape":"St"}}},"EngineVersion":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S2j"}}},"output":{"shape":"S48","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S2r"},"ValuesToRemove":{"shape":"S2r"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S2o"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"ApplyImmediately":{"type":"boolean"},"PreferredMaintenanceWindow":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"NewDBInstanceIdentifier":{},"CACertificateIdentifier":{},"PromotionTier":{"type":"integer"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1a"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1c"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{},"NewGlobalClusterIdentifier":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S1r"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1a"}}}},"RemoveFromGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier","DbClusterIdentifier"],"members":{"GlobalClusterIdentifier":{},"DbClusterIdentifier":{}}},"output":{"resultWrapper":"RemoveFromGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S1r"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2j"}}},"output":{"shape":"S48","resultWrapper":"ResetDBClusterParameterGroupResult"}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"So"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"Ss"},"Tags":{"shape":"S9"},"KmsKeyId":{},"EnableCloudwatchLogsExports":{"shape":"St"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"Ss"},"Tags":{"shape":"S9"},"KmsKeyId":{},"EnableCloudwatchLogsExports":{"shape":"St"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sw"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sj":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"Sn":{"type":"structure","members":{"AvailabilityZones":{"shape":"So"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{}},"wrapper":true},"So":{"type":"list","member":{"locationName":"AvailabilityZone"}},"Ss":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"list","member":{}},"Sw":{"type":"structure","members":{"AvailabilityZones":{"shape":"So"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S10"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{}}}},"ClusterCreateTime":{"type":"timestamp"},"EnabledCloudwatchLogsExports":{"shape":"St"},"DeletionProtection":{"type":"boolean"}},"wrapper":true},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1a":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"VpcSecurityGroups":{"shape":"S10"},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1c"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"St"},"LogTypesToDisable":{"shape":"St"}}}}},"LatestRestorableTime":{"type":"timestamp"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"EnabledCloudwatchLogsExports":{"shape":"St"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1f"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S1f":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"GlobalClusterIdentifier":{},"GlobalClusterResourceId":{},"GlobalClusterArn":{},"Status":{},"Engine":{},"EngineVersion":{},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"GlobalClusterMembers":{"type":"list","member":{"locationName":"GlobalClusterMember","type":"structure","members":{"DBClusterArn":{},"Readers":{"type":"list","member":{}},"IsWriter":{"type":"boolean"}},"wrapper":true}}},"wrapper":true},"S28":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2j":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S2o":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S2r"}}}}},"wrapper":true},"S2r":{"type":"list","member":{"locationName":"AttributeValue"}},"S48":{"type":"structure","members":{"DBClusterParameterGroupName":{}}}}}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Certificates"},"DescribeDBClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterParameterGroups"},"DescribeDBClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterSnapshots"},"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeGlobalClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalClusters"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribePendingMaintenanceActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"PendingMaintenanceActions"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['backup'] = {};
	AWS.Backup = Service.defineService('backup', ['2018-11-15']);
	Object.defineProperty(apiLoader.services['backup'], '2018-11-15', {
	  get: function get() {
	    var model = __webpack_require__(722);
	    model.paginators = __webpack_require__(723).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Backup;


/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-15","endpointPrefix":"backup","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Backup","serviceId":"Backup","signatureVersion":"v4","uid":"backup-2018-11-15"},"operations":{"CreateBackupPlan":{"http":{"method":"PUT","requestUri":"/backup/plans/"},"input":{"type":"structure","required":["BackupPlan"],"members":{"BackupPlan":{"shape":"S2"},"BackupPlanTags":{"shape":"Sc"},"CreatorRequestId":{}}},"output":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"CreationDate":{"type":"timestamp"},"VersionId":{},"AdvancedBackupSettings":{"shape":"Sj"}}},"idempotent":true},"CreateBackupSelection":{"http":{"method":"PUT","requestUri":"/backup/plans/{backupPlanId}/selections/"},"input":{"type":"structure","required":["BackupPlanId","BackupSelection"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"BackupSelection":{"shape":"St"},"CreatorRequestId":{}}},"output":{"type":"structure","members":{"SelectionId":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"CreateBackupVault":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"BackupVaultTags":{"shape":"Sc"},"EncryptionKeyArn":{},"CreatorRequestId":{}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"CreateFramework":{"http":{"requestUri":"/audit/frameworks"},"input":{"type":"structure","required":["FrameworkName","FrameworkControls"],"members":{"FrameworkName":{},"FrameworkDescription":{},"FrameworkControls":{"shape":"S1b"},"IdempotencyToken":{"idempotencyToken":true},"FrameworkTags":{"shape":"S1l"}}},"output":{"type":"structure","members":{"FrameworkName":{},"FrameworkArn":{}}},"idempotent":true},"CreateReportPlan":{"http":{"requestUri":"/audit/report-plans"},"input":{"type":"structure","required":["ReportPlanName","ReportDeliveryChannel","ReportSetting"],"members":{"ReportPlanName":{},"ReportPlanDescription":{},"ReportDeliveryChannel":{"shape":"S1q"},"ReportSetting":{"shape":"S1s"},"ReportPlanTags":{"shape":"S1l"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ReportPlanName":{},"ReportPlanArn":{},"CreationTime":{"type":"timestamp"}}},"idempotent":true},"DeleteBackupPlan":{"http":{"method":"DELETE","requestUri":"/backup/plans/{backupPlanId}"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"}}},"output":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"DeletionDate":{"type":"timestamp"},"VersionId":{}}}},"DeleteBackupSelection":{"http":{"method":"DELETE","requestUri":"/backup/plans/{backupPlanId}/selections/{selectionId}"},"input":{"type":"structure","required":["BackupPlanId","SelectionId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"SelectionId":{"location":"uri","locationName":"selectionId"}}}},"DeleteBackupVault":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}}},"DeleteBackupVaultAccessPolicy":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/access-policy"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"idempotent":true},"DeleteBackupVaultLockConfiguration":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/vault-lock"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"idempotent":true},"DeleteBackupVaultNotifications":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/notification-configuration"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"idempotent":true},"DeleteFramework":{"http":{"method":"DELETE","requestUri":"/audit/frameworks/{frameworkName}"},"input":{"type":"structure","required":["FrameworkName"],"members":{"FrameworkName":{"location":"uri","locationName":"frameworkName"}}}},"DeleteRecoveryPoint":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}},"idempotent":true},"DeleteReportPlan":{"http":{"method":"DELETE","requestUri":"/audit/report-plans/{reportPlanName}"},"input":{"type":"structure","required":["ReportPlanName"],"members":{"ReportPlanName":{"location":"uri","locationName":"reportPlanName"}}},"idempotent":true},"DescribeBackupJob":{"http":{"method":"GET","requestUri":"/backup-jobs/{backupJobId}"},"input":{"type":"structure","required":["BackupJobId"],"members":{"BackupJobId":{"location":"uri","locationName":"backupJobId"}}},"output":{"type":"structure","members":{"AccountId":{},"BackupJobId":{},"BackupVaultName":{},"BackupVaultArn":{},"RecoveryPointArn":{},"ResourceArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"State":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"CreatedBy":{"shape":"S2a"},"ResourceType":{},"BytesTransferred":{"type":"long"},"ExpectedCompletionDate":{"type":"timestamp"},"StartBy":{"type":"timestamp"},"BackupOptions":{"shape":"Sm"},"BackupType":{}}},"idempotent":true},"DescribeBackupVault":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"EncryptionKeyArn":{},"CreationDate":{"type":"timestamp"},"CreatorRequestId":{},"NumberOfRecoveryPoints":{"type":"long"},"Locked":{"type":"boolean"},"MinRetentionDays":{"type":"long"},"MaxRetentionDays":{"type":"long"},"LockDate":{"type":"timestamp"}}},"idempotent":true},"DescribeCopyJob":{"http":{"method":"GET","requestUri":"/copy-jobs/{copyJobId}"},"input":{"type":"structure","required":["CopyJobId"],"members":{"CopyJobId":{"location":"uri","locationName":"copyJobId"}}},"output":{"type":"structure","members":{"CopyJob":{"shape":"S2g"}}},"idempotent":true},"DescribeFramework":{"http":{"method":"GET","requestUri":"/audit/frameworks/{frameworkName}"},"input":{"type":"structure","required":["FrameworkName"],"members":{"FrameworkName":{"location":"uri","locationName":"frameworkName"}}},"output":{"type":"structure","members":{"FrameworkName":{},"FrameworkArn":{},"FrameworkDescription":{},"FrameworkControls":{"shape":"S1b"},"CreationTime":{"type":"timestamp"},"DeploymentStatus":{},"FrameworkStatus":{},"IdempotencyToken":{}}}},"DescribeGlobalSettings":{"http":{"method":"GET","requestUri":"/global-settings"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"GlobalSettings":{"shape":"S2m"},"LastUpdateTime":{"type":"timestamp"}}}},"DescribeProtectedResource":{"http":{"method":"GET","requestUri":"/resources/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"LastBackupTime":{"type":"timestamp"}}},"idempotent":true},"DescribeRecoveryPoint":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}},"output":{"type":"structure","members":{"RecoveryPointArn":{},"BackupVaultName":{},"BackupVaultArn":{},"SourceBackupVaultArn":{},"ResourceArn":{},"ResourceType":{},"CreatedBy":{"shape":"S2a"},"IamRoleArn":{},"Status":{},"StatusMessage":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"BackupSizeInBytes":{"type":"long"},"CalculatedLifecycle":{"shape":"S2u"},"Lifecycle":{"shape":"Sa"},"EncryptionKeyArn":{},"IsEncrypted":{"type":"boolean"},"StorageClass":{},"LastRestoreTime":{"type":"timestamp"}}},"idempotent":true},"DescribeRegionSettings":{"http":{"method":"GET","requestUri":"/account-settings"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ResourceTypeOptInPreference":{"shape":"S2z"},"ResourceTypeManagementPreference":{"shape":"S31"}}}},"DescribeReportJob":{"http":{"method":"GET","requestUri":"/audit/report-jobs/{reportJobId}"},"input":{"type":"structure","required":["ReportJobId"],"members":{"ReportJobId":{"location":"uri","locationName":"reportJobId"}}},"output":{"type":"structure","members":{"ReportJob":{"shape":"S35"}}}},"DescribeReportPlan":{"http":{"method":"GET","requestUri":"/audit/report-plans/{reportPlanName}"},"input":{"type":"structure","required":["ReportPlanName"],"members":{"ReportPlanName":{"location":"uri","locationName":"reportPlanName"}}},"output":{"type":"structure","members":{"ReportPlan":{"shape":"S39"}}}},"DescribeRestoreJob":{"http":{"method":"GET","requestUri":"/restore-jobs/{restoreJobId}"},"input":{"type":"structure","required":["RestoreJobId"],"members":{"RestoreJobId":{"location":"uri","locationName":"restoreJobId"}}},"output":{"type":"structure","members":{"AccountId":{},"RestoreJobId":{},"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"ExpectedCompletionTimeMinutes":{"type":"long"},"CreatedResourceArn":{},"ResourceType":{}}},"idempotent":true},"DisassociateRecoveryPoint":{"http":{"requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}/disassociate"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}}},"ExportBackupPlanTemplate":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/toTemplate/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"}}},"output":{"type":"structure","members":{"BackupPlanTemplateJson":{}}}},"GetBackupPlan":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"BackupPlan":{"shape":"S3j"},"BackupPlanId":{},"BackupPlanArn":{},"VersionId":{},"CreatorRequestId":{},"CreationDate":{"type":"timestamp"},"DeletionDate":{"type":"timestamp"},"LastExecutionDate":{"type":"timestamp"},"AdvancedBackupSettings":{"shape":"Sj"}}},"idempotent":true},"GetBackupPlanFromJSON":{"http":{"requestUri":"/backup/template/json/toPlan"},"input":{"type":"structure","required":["BackupPlanTemplateJson"],"members":{"BackupPlanTemplateJson":{}}},"output":{"type":"structure","members":{"BackupPlan":{"shape":"S3j"}}}},"GetBackupPlanFromTemplate":{"http":{"method":"GET","requestUri":"/backup/template/plans/{templateId}/toPlan"},"input":{"type":"structure","required":["BackupPlanTemplateId"],"members":{"BackupPlanTemplateId":{"location":"uri","locationName":"templateId"}}},"output":{"type":"structure","members":{"BackupPlanDocument":{"shape":"S3j"}}}},"GetBackupSelection":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/selections/{selectionId}"},"input":{"type":"structure","required":["BackupPlanId","SelectionId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"SelectionId":{"location":"uri","locationName":"selectionId"}}},"output":{"type":"structure","members":{"BackupSelection":{"shape":"St"},"SelectionId":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"},"CreatorRequestId":{}}},"idempotent":true},"GetBackupVaultAccessPolicy":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/access-policy"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"Policy":{}}},"idempotent":true},"GetBackupVaultNotifications":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/notification-configuration"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"SNSTopicArn":{},"BackupVaultEvents":{"shape":"S3x"}}},"idempotent":true},"GetRecoveryPointRestoreMetadata":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}/restore-metadata"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}},"output":{"type":"structure","members":{"BackupVaultArn":{},"RecoveryPointArn":{},"RestoreMetadata":{"shape":"S41"}}},"idempotent":true},"GetSupportedResourceTypes":{"http":{"method":"GET","requestUri":"/supported-resource-types"},"output":{"type":"structure","members":{"ResourceTypes":{"type":"list","member":{}}}}},"ListBackupJobs":{"http":{"method":"GET","requestUri":"/backup-jobs/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ByResourceArn":{"location":"querystring","locationName":"resourceArn"},"ByState":{"location":"querystring","locationName":"state"},"ByBackupVaultName":{"location":"querystring","locationName":"backupVaultName"},"ByCreatedBefore":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"ByCreatedAfter":{"location":"querystring","locationName":"createdAfter","type":"timestamp"},"ByResourceType":{"location":"querystring","locationName":"resourceType"},"ByAccountId":{"location":"querystring","locationName":"accountId"}}},"output":{"type":"structure","members":{"BackupJobs":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"BackupJobId":{},"BackupVaultName":{},"BackupVaultArn":{},"RecoveryPointArn":{},"ResourceArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"State":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"CreatedBy":{"shape":"S2a"},"ExpectedCompletionDate":{"type":"timestamp"},"StartBy":{"type":"timestamp"},"ResourceType":{},"BytesTransferred":{"type":"long"},"BackupOptions":{"shape":"Sm"},"BackupType":{}}}},"NextToken":{}}},"idempotent":true},"ListBackupPlanTemplates":{"http":{"method":"GET","requestUri":"/backup/template/plans"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupPlanTemplatesList":{"type":"list","member":{"type":"structure","members":{"BackupPlanTemplateId":{},"BackupPlanTemplateName":{}}}}}}},"ListBackupPlanVersions":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/versions/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupPlanVersionsList":{"type":"list","member":{"shape":"S4i"}}}},"idempotent":true},"ListBackupPlans":{"http":{"method":"GET","requestUri":"/backup/plans/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"IncludeDeleted":{"location":"querystring","locationName":"includeDeleted","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupPlansList":{"type":"list","member":{"shape":"S4i"}}}},"idempotent":true},"ListBackupSelections":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/selections/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupSelectionsList":{"type":"list","member":{"type":"structure","members":{"SelectionId":{},"SelectionName":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"},"CreatorRequestId":{},"IamRoleArn":{}}}}}},"idempotent":true},"ListBackupVaults":{"http":{"method":"GET","requestUri":"/backup-vaults/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"BackupVaultList":{"type":"list","member":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"CreationDate":{"type":"timestamp"},"EncryptionKeyArn":{},"CreatorRequestId":{},"NumberOfRecoveryPoints":{"type":"long"},"Locked":{"type":"boolean"},"MinRetentionDays":{"type":"long"},"MaxRetentionDays":{"type":"long"},"LockDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListCopyJobs":{"http":{"method":"GET","requestUri":"/copy-jobs/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ByResourceArn":{"location":"querystring","locationName":"resourceArn"},"ByState":{"location":"querystring","locationName":"state"},"ByCreatedBefore":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"ByCreatedAfter":{"location":"querystring","locationName":"createdAfter","type":"timestamp"},"ByResourceType":{"location":"querystring","locationName":"resourceType"},"ByDestinationVaultArn":{"location":"querystring","locationName":"destinationVaultArn"},"ByAccountId":{"location":"querystring","locationName":"accountId"}}},"output":{"type":"structure","members":{"CopyJobs":{"type":"list","member":{"shape":"S2g"}},"NextToken":{}}}},"ListFrameworks":{"http":{"method":"GET","requestUri":"/audit/frameworks"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Frameworks":{"type":"list","member":{"type":"structure","members":{"FrameworkName":{},"FrameworkArn":{},"FrameworkDescription":{},"NumberOfControls":{"type":"integer"},"CreationTime":{"type":"timestamp"},"DeploymentStatus":{}}}},"NextToken":{}}}},"ListProtectedResources":{"http":{"method":"GET","requestUri":"/resources/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"LastBackupTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListRecoveryPointsByBackupVault":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ByResourceArn":{"location":"querystring","locationName":"resourceArn"},"ByResourceType":{"location":"querystring","locationName":"resourceType"},"ByBackupPlanId":{"location":"querystring","locationName":"backupPlanId"},"ByCreatedBefore":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"ByCreatedAfter":{"location":"querystring","locationName":"createdAfter","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{},"RecoveryPoints":{"type":"list","member":{"type":"structure","members":{"RecoveryPointArn":{},"BackupVaultName":{},"BackupVaultArn":{},"SourceBackupVaultArn":{},"ResourceArn":{},"ResourceType":{},"CreatedBy":{"shape":"S2a"},"IamRoleArn":{},"Status":{},"StatusMessage":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"BackupSizeInBytes":{"type":"long"},"CalculatedLifecycle":{"shape":"S2u"},"Lifecycle":{"shape":"Sa"},"EncryptionKeyArn":{},"IsEncrypted":{"type":"boolean"},"LastRestoreTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListRecoveryPointsByResource":{"http":{"method":"GET","requestUri":"/resources/{resourceArn}/recovery-points/"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RecoveryPoints":{"type":"list","member":{"type":"structure","members":{"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"},"Status":{},"StatusMessage":{},"EncryptionKeyArn":{},"BackupSizeBytes":{"type":"long"},"BackupVaultName":{}}}}}},"idempotent":true},"ListReportJobs":{"http":{"method":"GET","requestUri":"/audit/report-jobs"},"input":{"type":"structure","members":{"ByReportPlanName":{"location":"querystring","locationName":"ReportPlanName"},"ByCreationBefore":{"location":"querystring","locationName":"CreationBefore","type":"timestamp"},"ByCreationAfter":{"location":"querystring","locationName":"CreationAfter","type":"timestamp"},"ByStatus":{"location":"querystring","locationName":"Status"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ReportJobs":{"type":"list","member":{"shape":"S35"}},"NextToken":{}}}},"ListReportPlans":{"http":{"method":"GET","requestUri":"/audit/report-plans"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ReportPlans":{"type":"list","member":{"shape":"S39"}},"NextToken":{}}}},"ListRestoreJobs":{"http":{"method":"GET","requestUri":"/restore-jobs/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ByAccountId":{"location":"querystring","locationName":"accountId"},"ByCreatedBefore":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"ByCreatedAfter":{"location":"querystring","locationName":"createdAfter","type":"timestamp"},"ByStatus":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"RestoreJobs":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"RestoreJobId":{},"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"ExpectedCompletionTimeMinutes":{"type":"long"},"CreatedResourceArn":{},"ResourceType":{}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}/"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Sc"}}},"idempotent":true},"PutBackupVaultAccessPolicy":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}/access-policy"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"Policy":{}}},"idempotent":true},"PutBackupVaultLockConfiguration":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}/vault-lock"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"MinRetentionDays":{"type":"long"},"MaxRetentionDays":{"type":"long"},"ChangeableForDays":{"type":"long"}}},"idempotent":true},"PutBackupVaultNotifications":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}/notification-configuration"},"input":{"type":"structure","required":["BackupVaultName","SNSTopicArn","BackupVaultEvents"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"SNSTopicArn":{},"BackupVaultEvents":{"shape":"S3x"}}},"idempotent":true},"StartBackupJob":{"http":{"method":"PUT","requestUri":"/backup-jobs"},"input":{"type":"structure","required":["BackupVaultName","ResourceArn","IamRoleArn"],"members":{"BackupVaultName":{},"ResourceArn":{},"IamRoleArn":{},"IdempotencyToken":{},"StartWindowMinutes":{"type":"long"},"CompleteWindowMinutes":{"type":"long"},"Lifecycle":{"shape":"Sa"},"RecoveryPointTags":{"shape":"Sc"},"BackupOptions":{"shape":"Sm"}}},"output":{"type":"structure","members":{"BackupJobId":{},"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"StartCopyJob":{"http":{"method":"PUT","requestUri":"/copy-jobs"},"input":{"type":"structure","required":["RecoveryPointArn","SourceBackupVaultName","DestinationBackupVaultArn","IamRoleArn"],"members":{"RecoveryPointArn":{},"SourceBackupVaultName":{},"DestinationBackupVaultArn":{},"IamRoleArn":{},"IdempotencyToken":{},"Lifecycle":{"shape":"Sa"}}},"output":{"type":"structure","members":{"CopyJobId":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"StartReportJob":{"http":{"requestUri":"/audit/report-jobs/{reportPlanName}"},"input":{"type":"structure","required":["ReportPlanName"],"members":{"ReportPlanName":{"location":"uri","locationName":"reportPlanName"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ReportJobId":{}}},"idempotent":true},"StartRestoreJob":{"http":{"method":"PUT","requestUri":"/restore-jobs"},"input":{"type":"structure","required":["RecoveryPointArn","Metadata","IamRoleArn"],"members":{"RecoveryPointArn":{},"Metadata":{"shape":"S41"},"IamRoleArn":{},"IdempotencyToken":{},"ResourceType":{}}},"output":{"type":"structure","members":{"RestoreJobId":{}}},"idempotent":true},"StopBackupJob":{"http":{"requestUri":"/backup-jobs/{backupJobId}"},"input":{"type":"structure","required":["BackupJobId"],"members":{"BackupJobId":{"location":"uri","locationName":"backupJobId"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sc"}}},"idempotent":true},"UntagResource":{"http":{"requestUri":"/untag/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeyList":{"type":"list","member":{},"sensitive":true}}},"idempotent":true},"UpdateBackupPlan":{"http":{"requestUri":"/backup/plans/{backupPlanId}"},"input":{"type":"structure","required":["BackupPlanId","BackupPlan"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"BackupPlan":{"shape":"S2"}}},"output":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"CreationDate":{"type":"timestamp"},"VersionId":{},"AdvancedBackupSettings":{"shape":"Sj"}}},"idempotent":true},"UpdateFramework":{"http":{"method":"PUT","requestUri":"/audit/frameworks/{frameworkName}"},"input":{"type":"structure","required":["FrameworkName"],"members":{"FrameworkName":{"location":"uri","locationName":"frameworkName"},"FrameworkDescription":{},"FrameworkControls":{"shape":"S1b"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"FrameworkName":{},"FrameworkArn":{},"CreationTime":{"type":"timestamp"}}},"idempotent":true},"UpdateGlobalSettings":{"http":{"method":"PUT","requestUri":"/global-settings"},"input":{"type":"structure","members":{"GlobalSettings":{"shape":"S2m"}}}},"UpdateRecoveryPointLifecycle":{"http":{"requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"},"Lifecycle":{"shape":"Sa"}}},"output":{"type":"structure","members":{"BackupVaultArn":{},"RecoveryPointArn":{},"Lifecycle":{"shape":"Sa"},"CalculatedLifecycle":{"shape":"S2u"}}},"idempotent":true},"UpdateRegionSettings":{"http":{"method":"PUT","requestUri":"/account-settings"},"input":{"type":"structure","members":{"ResourceTypeOptInPreference":{"shape":"S2z"},"ResourceTypeManagementPreference":{"shape":"S31"}}}},"UpdateReportPlan":{"http":{"method":"PUT","requestUri":"/audit/report-plans/{reportPlanName}"},"input":{"type":"structure","required":["ReportPlanName"],"members":{"ReportPlanName":{"location":"uri","locationName":"reportPlanName"},"ReportPlanDescription":{},"ReportDeliveryChannel":{"shape":"S1q"},"ReportSetting":{"shape":"S1s"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ReportPlanName":{},"ReportPlanArn":{},"CreationTime":{"type":"timestamp"}}},"idempotent":true}},"shapes":{"S2":{"type":"structure","required":["BackupPlanName","Rules"],"members":{"BackupPlanName":{},"Rules":{"type":"list","member":{"type":"structure","required":["RuleName","TargetBackupVaultName"],"members":{"RuleName":{},"TargetBackupVaultName":{},"ScheduleExpression":{},"StartWindowMinutes":{"type":"long"},"CompletionWindowMinutes":{"type":"long"},"Lifecycle":{"shape":"Sa"},"RecoveryPointTags":{"shape":"Sc"},"CopyActions":{"shape":"Sf"},"EnableContinuousBackup":{"type":"boolean"}}}},"AdvancedBackupSettings":{"shape":"Sj"}}},"Sa":{"type":"structure","members":{"MoveToColdStorageAfterDays":{"type":"long"},"DeleteAfterDays":{"type":"long"}}},"Sc":{"type":"map","key":{},"value":{},"sensitive":true},"Sf":{"type":"list","member":{"type":"structure","required":["DestinationBackupVaultArn"],"members":{"Lifecycle":{"shape":"Sa"},"DestinationBackupVaultArn":{}}}},"Sj":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"BackupOptions":{"shape":"Sm"}}}},"Sm":{"type":"map","key":{},"value":{}},"St":{"type":"structure","required":["SelectionName","IamRoleArn"],"members":{"SelectionName":{},"IamRoleArn":{},"Resources":{"shape":"Sw"},"ListOfTags":{"type":"list","member":{"type":"structure","required":["ConditionType","ConditionKey","ConditionValue"],"members":{"ConditionType":{},"ConditionKey":{},"ConditionValue":{}}}},"NotResources":{"shape":"Sw"},"Conditions":{"type":"structure","members":{"StringEquals":{"shape":"S13"},"StringNotEquals":{"shape":"S13"},"StringLike":{"shape":"S13"},"StringNotLike":{"shape":"S13"}}}}},"Sw":{"type":"list","member":{}},"S13":{"type":"list","member":{"type":"structure","members":{"ConditionKey":{},"ConditionValue":{}}}},"S1b":{"type":"list","member":{"type":"structure","required":["ControlName"],"members":{"ControlName":{},"ControlInputParameters":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"ControlScope":{"type":"structure","members":{"ComplianceResourceIds":{"type":"list","member":{}},"ComplianceResourceTypes":{"type":"list","member":{}},"Tags":{"shape":"S1l"}}}}}},"S1l":{"type":"map","key":{},"value":{}},"S1q":{"type":"structure","required":["S3BucketName"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"Formats":{"type":"list","member":{}}}},"S1s":{"type":"structure","required":["ReportTemplate"],"members":{"ReportTemplate":{},"FrameworkArns":{"shape":"S1t"},"NumberOfFrameworks":{"type":"integer"}}},"S1t":{"type":"list","member":{}},"S2a":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"BackupPlanVersion":{},"BackupRuleId":{}}},"S2g":{"type":"structure","members":{"AccountId":{},"CopyJobId":{},"SourceBackupVaultArn":{},"SourceRecoveryPointArn":{},"DestinationBackupVaultArn":{},"DestinationRecoveryPointArn":{},"ResourceArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"State":{},"StatusMessage":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"CreatedBy":{"shape":"S2a"},"ResourceType":{}}},"S2m":{"type":"map","key":{},"value":{}},"S2u":{"type":"structure","members":{"MoveToColdStorageAt":{"type":"timestamp"},"DeleteAt":{"type":"timestamp"}}},"S2z":{"type":"map","key":{},"value":{"type":"boolean"}},"S31":{"type":"map","key":{},"value":{"type":"boolean"}},"S35":{"type":"structure","members":{"ReportJobId":{},"ReportPlanArn":{},"ReportTemplate":{},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"Status":{},"StatusMessage":{},"ReportDestination":{"type":"structure","members":{"S3BucketName":{},"S3Keys":{"shape":"S1t"}}}}},"S39":{"type":"structure","members":{"ReportPlanArn":{},"ReportPlanName":{},"ReportPlanDescription":{},"ReportSetting":{"shape":"S1s"},"ReportDeliveryChannel":{"shape":"S1q"},"DeploymentStatus":{},"CreationTime":{"type":"timestamp"},"LastAttemptedExecutionTime":{"type":"timestamp"},"LastSuccessfulExecutionTime":{"type":"timestamp"}}},"S3j":{"type":"structure","required":["BackupPlanName","Rules"],"members":{"BackupPlanName":{},"Rules":{"type":"list","member":{"type":"structure","required":["RuleName","TargetBackupVaultName"],"members":{"RuleName":{},"TargetBackupVaultName":{},"ScheduleExpression":{},"StartWindowMinutes":{"type":"long"},"CompletionWindowMinutes":{"type":"long"},"Lifecycle":{"shape":"Sa"},"RecoveryPointTags":{"shape":"Sc"},"RuleId":{},"CopyActions":{"shape":"Sf"},"EnableContinuousBackup":{"type":"boolean"}}}},"AdvancedBackupSettings":{"shape":"Sj"}}},"S3x":{"type":"list","member":{}},"S41":{"type":"map","key":{},"value":{},"sensitive":true},"S4i":{"type":"structure","members":{"BackupPlanArn":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"},"DeletionDate":{"type":"timestamp"},"VersionId":{},"BackupPlanName":{},"CreatorRequestId":{},"LastExecutionDate":{"type":"timestamp"},"AdvancedBackupSettings":{"shape":"Sj"}}}}}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBackupJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupPlanTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupPlanVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupPlans":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupSelections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupVaults":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCopyJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFrameworks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProtectedResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRecoveryPointsByBackupVault":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRecoveryPointsByResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReportJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReportPlans":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRestoreJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['worklink'] = {};
	AWS.WorkLink = Service.defineService('worklink', ['2018-09-25']);
	Object.defineProperty(apiLoader.services['worklink'], '2018-09-25', {
	  get: function get() {
	    var model = __webpack_require__(725);
	    model.paginators = __webpack_require__(726).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WorkLink;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-25","endpointPrefix":"worklink","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"WorkLink","serviceFullName":"Amazon WorkLink","serviceId":"WorkLink","signatureVersion":"v4","signingName":"worklink","uid":"worklink-2018-09-25"},"operations":{"AssociateDomain":{"http":{"requestUri":"/associateDomain"},"input":{"type":"structure","required":["FleetArn","DomainName","AcmCertificateArn"],"members":{"FleetArn":{},"DomainName":{},"DisplayName":{},"AcmCertificateArn":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"AssociateWebsiteAuthorizationProvider":{"http":{"requestUri":"/associateWebsiteAuthorizationProvider"},"input":{"type":"structure","required":["FleetArn","AuthorizationProviderType"],"members":{"FleetArn":{},"AuthorizationProviderType":{},"DomainName":{}}},"output":{"type":"structure","members":{"AuthorizationProviderId":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"AssociateWebsiteCertificateAuthority":{"http":{"requestUri":"/associateWebsiteCertificateAuthority"},"input":{"type":"structure","required":["FleetArn","Certificate"],"members":{"FleetArn":{},"Certificate":{},"DisplayName":{}}},"output":{"type":"structure","members":{"WebsiteCaId":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"CreateFleet":{"http":{"requestUri":"/createFleet"},"input":{"type":"structure","required":["FleetName"],"members":{"FleetName":{},"DisplayName":{},"OptimizeForEndUserLocation":{"type":"boolean"},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"FleetArn":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DeleteFleet":{"http":{"requestUri":"/deleteFleet"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeAuditStreamConfiguration":{"http":{"requestUri":"/describeAuditStreamConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"AuditStreamArn":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeCompanyNetworkConfiguration":{"http":{"requestUri":"/describeCompanyNetworkConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"St"},"SecurityGroupIds":{"shape":"Sv"}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeDevice":{"http":{"requestUri":"/describeDevice"},"input":{"type":"structure","required":["FleetArn","DeviceId"],"members":{"FleetArn":{},"DeviceId":{}}},"output":{"type":"structure","members":{"Status":{},"Model":{},"Manufacturer":{},"OperatingSystem":{},"OperatingSystemVersion":{},"PatchLevel":{},"FirstAccessedTime":{"type":"timestamp"},"LastAccessedTime":{"type":"timestamp"},"Username":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeDevicePolicyConfiguration":{"http":{"requestUri":"/describeDevicePolicyConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"DeviceCaCertificate":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeDomain":{"http":{"requestUri":"/describeDomain"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{"DomainName":{},"DisplayName":{},"CreatedTime":{"type":"timestamp"},"DomainStatus":{},"AcmCertificateArn":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeFleetMetadata":{"http":{"requestUri":"/describeFleetMetadata"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"FleetName":{},"DisplayName":{},"OptimizeForEndUserLocation":{"type":"boolean"},"CompanyCode":{},"FleetStatus":{},"Tags":{"shape":"Sh"}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeIdentityProviderConfiguration":{"http":{"requestUri":"/describeIdentityProviderConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"IdentityProviderType":{},"ServiceProviderSamlMetadata":{},"IdentityProviderSamlMetadata":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DescribeWebsiteCertificateAuthority":{"http":{"requestUri":"/describeWebsiteCertificateAuthority"},"input":{"type":"structure","required":["FleetArn","WebsiteCaId"],"members":{"FleetArn":{},"WebsiteCaId":{}}},"output":{"type":"structure","members":{"Certificate":{},"CreatedTime":{"type":"timestamp"},"DisplayName":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DisassociateDomain":{"http":{"requestUri":"/disassociateDomain"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DisassociateWebsiteAuthorizationProvider":{"http":{"requestUri":"/disassociateWebsiteAuthorizationProvider"},"input":{"type":"structure","required":["FleetArn","AuthorizationProviderId"],"members":{"FleetArn":{},"AuthorizationProviderId":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"DisassociateWebsiteCertificateAuthority":{"http":{"requestUri":"/disassociateWebsiteCertificateAuthority"},"input":{"type":"structure","required":["FleetArn","WebsiteCaId"],"members":{"FleetArn":{},"WebsiteCaId":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"ListDevices":{"http":{"requestUri":"/listDevices"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Devices":{"type":"list","member":{"type":"structure","members":{"DeviceId":{},"DeviceStatus":{}}}},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"ListDomains":{"http":{"requestUri":"/listDomains"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName","CreatedTime","DomainStatus"],"members":{"DomainName":{},"DisplayName":{},"CreatedTime":{"type":"timestamp"},"DomainStatus":{}}}},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"ListFleets":{"http":{"requestUri":"/listFleets"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FleetSummaryList":{"type":"list","member":{"type":"structure","members":{"FleetArn":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"FleetName":{},"DisplayName":{},"CompanyCode":{},"FleetStatus":{},"Tags":{"shape":"Sh"}}}},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh"}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"ListWebsiteAuthorizationProviders":{"http":{"requestUri":"/listWebsiteAuthorizationProviders"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WebsiteAuthorizationProviders":{"type":"list","member":{"type":"structure","required":["AuthorizationProviderType"],"members":{"AuthorizationProviderId":{},"AuthorizationProviderType":{},"DomainName":{},"CreatedTime":{"type":"timestamp"}}}},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"ListWebsiteCertificateAuthorities":{"http":{"requestUri":"/listWebsiteCertificateAuthorities"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WebsiteCertificateAuthorities":{"type":"list","member":{"type":"structure","members":{"WebsiteCaId":{},"CreatedTime":{"type":"timestamp"},"DisplayName":{}}}},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"RestoreDomainAccess":{"http":{"requestUri":"/restoreDomainAccess"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"RevokeDomainAccess":{"http":{"requestUri":"/revokeDomainAccess"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"SignOutUser":{"http":{"requestUri":"/signOutUser"},"input":{"type":"structure","required":["FleetArn","Username"],"members":{"FleetArn":{},"Username":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UpdateAuditStreamConfiguration":{"http":{"requestUri":"/updateAuditStreamConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"AuditStreamArn":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UpdateCompanyNetworkConfiguration":{"http":{"requestUri":"/updateCompanyNetworkConfiguration"},"input":{"type":"structure","required":["FleetArn","VpcId","SubnetIds","SecurityGroupIds"],"members":{"FleetArn":{},"VpcId":{},"SubnetIds":{"shape":"St"},"SecurityGroupIds":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UpdateDevicePolicyConfiguration":{"http":{"requestUri":"/updateDevicePolicyConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"DeviceCaCertificate":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UpdateDomainMetadata":{"http":{"requestUri":"/updateDomainMetadata"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{},"DisplayName":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UpdateFleetMetadata":{"http":{"requestUri":"/UpdateFleetMetadata"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"DisplayName":{},"OptimizeForEndUserLocation":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."},"UpdateIdentityProviderConfiguration":{"http":{"requestUri":"/updateIdentityProviderConfiguration"},"input":{"type":"structure","required":["FleetArn","IdentityProviderType"],"members":{"FleetArn":{},"IdentityProviderType":{},"IdentityProviderSamlMetadata":{}}},"output":{"type":"structure","members":{}},"deprecated":true,"deprecatedMessage":"Amazon WorkLink is no longer supported. This will be removed in a future version of the SDK."}},"shapes":{"Sh":{"type":"map","key":{},"value":{}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{}}}}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFleets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWebsiteAuthorizationProviders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWebsiteCertificateAuthorities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['textract'] = {};
	AWS.Textract = Service.defineService('textract', ['2018-06-27']);
	Object.defineProperty(apiLoader.services['textract'], '2018-06-27', {
	  get: function get() {
	    var model = __webpack_require__(728);
	    model.paginators = __webpack_require__(729).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Textract;


/***/ }),
/* 728 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-27","endpointPrefix":"textract","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Textract","serviceId":"Textract","signatureVersion":"v4","targetPrefix":"Textract","uid":"textract-2018-06-27"},"operations":{"AnalyzeDocument":{"input":{"type":"structure","required":["Document","FeatureTypes"],"members":{"Document":{"shape":"S2"},"FeatureTypes":{"shape":"S8"},"HumanLoopConfig":{"type":"structure","required":["HumanLoopName","FlowDefinitionArn"],"members":{"HumanLoopName":{},"FlowDefinitionArn":{},"DataAttributes":{"type":"structure","members":{"ContentClassifiers":{"type":"list","member":{}}}}}},"QueriesConfig":{"shape":"Sg"}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sn"},"Blocks":{"shape":"Sp"},"HumanLoopActivationOutput":{"type":"structure","members":{"HumanLoopArn":{},"HumanLoopActivationReasons":{"type":"list","member":{}},"HumanLoopActivationConditionsEvaluationResults":{"jsonvalue":true}}},"AnalyzeDocumentModelVersion":{}}}},"AnalyzeExpense":{"input":{"type":"structure","required":["Document"],"members":{"Document":{"shape":"S2"}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sn"},"ExpenseDocuments":{"shape":"S1f"}}}},"AnalyzeID":{"input":{"type":"structure","required":["DocumentPages"],"members":{"DocumentPages":{"type":"list","member":{"shape":"S2"}}}},"output":{"type":"structure","members":{"IdentityDocuments":{"type":"list","member":{"type":"structure","members":{"DocumentIndex":{"type":"integer"},"IdentityDocumentFields":{"type":"list","member":{"type":"structure","members":{"Type":{"shape":"S1w"},"ValueDetection":{"shape":"S1w"}}}}}}},"DocumentMetadata":{"shape":"Sn"},"AnalyzeIDModelVersion":{}}}},"DetectDocumentText":{"input":{"type":"structure","required":["Document"],"members":{"Document":{"shape":"S2"}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sn"},"Blocks":{"shape":"Sp"},"DetectDocumentTextModelVersion":{}}}},"GetDocumentAnalysis":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sn"},"JobStatus":{},"NextToken":{},"Blocks":{"shape":"Sp"},"Warnings":{"shape":"S27"},"StatusMessage":{},"AnalyzeDocumentModelVersion":{}}}},"GetDocumentTextDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sn"},"JobStatus":{},"NextToken":{},"Blocks":{"shape":"Sp"},"Warnings":{"shape":"S27"},"StatusMessage":{},"DetectDocumentTextModelVersion":{}}}},"GetExpenseAnalysis":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sn"},"JobStatus":{},"NextToken":{},"ExpenseDocuments":{"shape":"S1f"},"Warnings":{"shape":"S27"},"StatusMessage":{},"AnalyzeExpenseModelVersion":{}}}},"StartDocumentAnalysis":{"input":{"type":"structure","required":["DocumentLocation","FeatureTypes"],"members":{"DocumentLocation":{"shape":"S2h"},"FeatureTypes":{"shape":"S8"},"ClientRequestToken":{},"JobTag":{},"NotificationChannel":{"shape":"S2k"},"OutputConfig":{"shape":"S2n"},"KMSKeyId":{},"QueriesConfig":{"shape":"Sg"}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartDocumentTextDetection":{"input":{"type":"structure","required":["DocumentLocation"],"members":{"DocumentLocation":{"shape":"S2h"},"ClientRequestToken":{},"JobTag":{},"NotificationChannel":{"shape":"S2k"},"OutputConfig":{"shape":"S2n"},"KMSKeyId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartExpenseAnalysis":{"input":{"type":"structure","required":["DocumentLocation"],"members":{"DocumentLocation":{"shape":"S2h"},"ClientRequestToken":{},"JobTag":{},"NotificationChannel":{"shape":"S2k"},"OutputConfig":{"shape":"S2n"},"KMSKeyId":{}}},"output":{"type":"structure","members":{"JobId":{}}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"S4"}}},"S4":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"S8":{"type":"list","member":{}},"Sg":{"type":"structure","required":["Queries"],"members":{"Queries":{"type":"list","member":{"shape":"Si"}}}},"Si":{"type":"structure","required":["Text"],"members":{"Text":{},"Alias":{},"Pages":{"type":"list","member":{}}}},"Sn":{"type":"structure","members":{"Pages":{"type":"integer"}}},"Sp":{"type":"list","member":{"type":"structure","members":{"BlockType":{},"Confidence":{"type":"float"},"Text":{},"TextType":{},"RowIndex":{"type":"integer"},"ColumnIndex":{"type":"integer"},"RowSpan":{"type":"integer"},"ColumnSpan":{"type":"integer"},"Geometry":{"shape":"Sv"},"Id":{},"Relationships":{"type":"list","member":{"type":"structure","members":{"Type":{},"Ids":{"type":"list","member":{}}}}},"EntityTypes":{"type":"list","member":{}},"SelectionStatus":{},"Page":{"type":"integer"},"Query":{"shape":"Si"}}}},"Sv":{"type":"structure","members":{"BoundingBox":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Polygon":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}}}},"S1f":{"type":"list","member":{"type":"structure","members":{"ExpenseIndex":{"type":"integer"},"SummaryFields":{"shape":"S1h"},"LineItemGroups":{"type":"list","member":{"type":"structure","members":{"LineItemGroupIndex":{"type":"integer"},"LineItems":{"type":"list","member":{"type":"structure","members":{"LineItemExpenseFields":{"shape":"S1h"}}}}}}}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"Type":{"type":"structure","members":{"Text":{},"Confidence":{"type":"float"}}},"LabelDetection":{"shape":"S1k"},"ValueDetection":{"shape":"S1k"},"PageNumber":{"type":"integer"}}}},"S1k":{"type":"structure","members":{"Text":{},"Geometry":{"shape":"Sv"},"Confidence":{"type":"float"}}},"S1w":{"type":"structure","required":["Text"],"members":{"Text":{},"NormalizedValue":{"type":"structure","members":{"Value":{},"ValueType":{}}},"Confidence":{"type":"float"}}},"S27":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"Pages":{"type":"list","member":{"type":"integer"}}}}},"S2h":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S2k":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}},"S2n":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Prefix":{}}}}}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['managedblockchain'] = {};
	AWS.ManagedBlockchain = Service.defineService('managedblockchain', ['2018-09-24']);
	Object.defineProperty(apiLoader.services['managedblockchain'], '2018-09-24', {
	  get: function get() {
	    var model = __webpack_require__(731);
	    model.paginators = __webpack_require__(732).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ManagedBlockchain;


/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-24","endpointPrefix":"managedblockchain","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"ManagedBlockchain","serviceFullName":"Amazon Managed Blockchain","serviceId":"ManagedBlockchain","signatureVersion":"v4","signingName":"managedblockchain","uid":"managedblockchain-2018-09-24"},"operations":{"CreateMember":{"http":{"requestUri":"/networks/{networkId}/members"},"input":{"type":"structure","required":["ClientRequestToken","InvitationId","NetworkId","MemberConfiguration"],"members":{"ClientRequestToken":{"idempotencyToken":true},"InvitationId":{},"NetworkId":{"location":"uri","locationName":"networkId"},"MemberConfiguration":{"shape":"S4"}}},"output":{"type":"structure","members":{"MemberId":{}}}},"CreateNetwork":{"http":{"requestUri":"/networks"},"input":{"type":"structure","required":["ClientRequestToken","Name","Framework","FrameworkVersion","VotingPolicy","MemberConfiguration"],"members":{"ClientRequestToken":{"idempotencyToken":true},"Name":{},"Description":{},"Framework":{},"FrameworkVersion":{},"FrameworkConfiguration":{"type":"structure","members":{"Fabric":{"type":"structure","required":["Edition"],"members":{"Edition":{}}}}},"VotingPolicy":{"shape":"Ss"},"MemberConfiguration":{"shape":"S4"},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{"NetworkId":{},"MemberId":{}}}},"CreateNode":{"http":{"requestUri":"/networks/{networkId}/nodes"},"input":{"type":"structure","required":["ClientRequestToken","NetworkId","NodeConfiguration"],"members":{"ClientRequestToken":{"idempotencyToken":true},"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{},"NodeConfiguration":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"AvailabilityZone":{},"LogPublishingConfiguration":{"shape":"S12"},"StateDB":{}}},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{"NodeId":{}}}},"CreateProposal":{"http":{"requestUri":"/networks/{networkId}/proposals"},"input":{"type":"structure","required":["ClientRequestToken","NetworkId","MemberId","Actions"],"members":{"ClientRequestToken":{"idempotencyToken":true},"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{},"Actions":{"shape":"S17"},"Description":{},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ProposalId":{}}}},"DeleteMember":{"http":{"method":"DELETE","requestUri":"/networks/{networkId}/members/{memberId}"},"input":{"type":"structure","required":["NetworkId","MemberId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"}}},"output":{"type":"structure","members":{}}},"DeleteNode":{"http":{"method":"DELETE","requestUri":"/networks/{networkId}/nodes/{nodeId}"},"input":{"type":"structure","required":["NetworkId","NodeId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"querystring","locationName":"memberId"},"NodeId":{"location":"uri","locationName":"nodeId"}}},"output":{"type":"structure","members":{}}},"GetMember":{"http":{"method":"GET","requestUri":"/networks/{networkId}/members/{memberId}"},"input":{"type":"structure","required":["NetworkId","MemberId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"}}},"output":{"type":"structure","members":{"Member":{"type":"structure","members":{"NetworkId":{},"Id":{},"Name":{},"Description":{},"FrameworkAttributes":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"AdminUsername":{},"CaEndpoint":{}}}}},"LogPublishingConfiguration":{"shape":"Sb"},"Status":{},"CreationDate":{"shape":"S1p"},"Tags":{"shape":"S1q"},"Arn":{},"KmsKeyArn":{}}}}}},"GetNetwork":{"http":{"method":"GET","requestUri":"/networks/{networkId}"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"}}},"output":{"type":"structure","members":{"Network":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Framework":{},"FrameworkVersion":{},"FrameworkAttributes":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"OrderingServiceEndpoint":{},"Edition":{}}},"Ethereum":{"type":"structure","members":{"ChainId":{}}}}},"VpcEndpointServiceName":{},"VotingPolicy":{"shape":"Ss"},"Status":{},"CreationDate":{"shape":"S1p"},"Tags":{"shape":"S1q"},"Arn":{}}}}}},"GetNode":{"http":{"method":"GET","requestUri":"/networks/{networkId}/nodes/{nodeId}"},"input":{"type":"structure","required":["NetworkId","NodeId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"querystring","locationName":"memberId"},"NodeId":{"location":"uri","locationName":"nodeId"}}},"output":{"type":"structure","members":{"Node":{"type":"structure","members":{"NetworkId":{},"MemberId":{},"Id":{},"InstanceType":{},"AvailabilityZone":{},"FrameworkAttributes":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"PeerEndpoint":{},"PeerEventEndpoint":{}}},"Ethereum":{"type":"structure","members":{"HttpEndpoint":{},"WebSocketEndpoint":{}}}}},"LogPublishingConfiguration":{"shape":"S12"},"StateDB":{},"Status":{},"CreationDate":{"shape":"S1p"},"Tags":{"shape":"S1q"},"Arn":{},"KmsKeyArn":{}}}}}},"GetProposal":{"http":{"method":"GET","requestUri":"/networks/{networkId}/proposals/{proposalId}"},"input":{"type":"structure","required":["NetworkId","ProposalId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"ProposalId":{"location":"uri","locationName":"proposalId"}}},"output":{"type":"structure","members":{"Proposal":{"type":"structure","members":{"ProposalId":{},"NetworkId":{},"Description":{},"Actions":{"shape":"S17"},"ProposedByMemberId":{},"ProposedByMemberName":{},"Status":{},"CreationDate":{"shape":"S1p"},"ExpirationDate":{"shape":"S1p"},"YesVoteCount":{"type":"integer"},"NoVoteCount":{"type":"integer"},"OutstandingVoteCount":{"type":"integer"},"Tags":{"shape":"S1q"},"Arn":{}}}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitations"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Invitations":{"type":"list","member":{"type":"structure","members":{"InvitationId":{},"CreationDate":{"shape":"S1p"},"ExpirationDate":{"shape":"S1p"},"Status":{},"NetworkSummary":{"shape":"S2h"},"Arn":{}}}},"NextToken":{}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/networks/{networkId}/members"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"Name":{"location":"querystring","locationName":"name"},"Status":{"location":"querystring","locationName":"status"},"IsOwned":{"location":"querystring","locationName":"isOwned","type":"boolean"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Members":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Status":{},"CreationDate":{"shape":"S1p"},"IsOwned":{"type":"boolean"},"Arn":{}}}},"NextToken":{}}}},"ListNetworks":{"http":{"method":"GET","requestUri":"/networks"},"input":{"type":"structure","members":{"Name":{"location":"querystring","locationName":"name"},"Framework":{"location":"querystring","locationName":"framework"},"Status":{"location":"querystring","locationName":"status"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Networks":{"type":"list","member":{"shape":"S2h"}},"NextToken":{}}}},"ListNodes":{"http":{"method":"GET","requestUri":"/networks/{networkId}/nodes"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"querystring","locationName":"memberId"},"Status":{"location":"querystring","locationName":"status"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Nodes":{"type":"list","member":{"type":"structure","members":{"Id":{},"Status":{},"CreationDate":{"shape":"S1p"},"AvailabilityZone":{},"InstanceType":{},"Arn":{}}}},"NextToken":{}}}},"ListProposalVotes":{"http":{"method":"GET","requestUri":"/networks/{networkId}/proposals/{proposalId}/votes"},"input":{"type":"structure","required":["NetworkId","ProposalId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"ProposalId":{"location":"uri","locationName":"proposalId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ProposalVotes":{"type":"list","member":{"type":"structure","members":{"Vote":{},"MemberName":{},"MemberId":{}}}},"NextToken":{}}}},"ListProposals":{"http":{"method":"GET","requestUri":"/networks/{networkId}/proposals"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Proposals":{"type":"list","member":{"type":"structure","members":{"ProposalId":{},"Description":{},"ProposedByMemberId":{},"ProposedByMemberName":{},"Status":{},"CreationDate":{"shape":"S1p"},"ExpirationDate":{"shape":"S1p"},"Arn":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1q"}}}},"RejectInvitation":{"http":{"method":"DELETE","requestUri":"/invitations/{invitationId}"},"input":{"type":"structure","required":["InvitationId"],"members":{"InvitationId":{"location":"uri","locationName":"invitationId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateMember":{"http":{"method":"PATCH","requestUri":"/networks/{networkId}/members/{memberId}"},"input":{"type":"structure","required":["NetworkId","MemberId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"},"LogPublishingConfiguration":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"UpdateNode":{"http":{"method":"PATCH","requestUri":"/networks/{networkId}/nodes/{nodeId}"},"input":{"type":"structure","required":["NetworkId","NodeId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{},"NodeId":{"location":"uri","locationName":"nodeId"},"LogPublishingConfiguration":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"VoteOnProposal":{"http":{"requestUri":"/networks/{networkId}/proposals/{proposalId}/votes"},"input":{"type":"structure","required":["NetworkId","ProposalId","VoterMemberId","Vote"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"ProposalId":{"location":"uri","locationName":"proposalId"},"VoterMemberId":{},"Vote":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["Name","FrameworkConfiguration"],"members":{"Name":{},"Description":{},"FrameworkConfiguration":{"type":"structure","members":{"Fabric":{"type":"structure","required":["AdminUsername","AdminPassword"],"members":{"AdminUsername":{},"AdminPassword":{"type":"string","sensitive":true}}}}},"LogPublishingConfiguration":{"shape":"Sb"},"Tags":{"shape":"Sg"},"KmsKeyArn":{}}},"Sb":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"CaLogs":{"shape":"Sd"}}}}},"Sd":{"type":"structure","members":{"Cloudwatch":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}}},"Sg":{"type":"map","key":{},"value":{}},"Ss":{"type":"structure","members":{"ApprovalThresholdPolicy":{"type":"structure","members":{"ThresholdPercentage":{"type":"integer"},"ProposalDurationInHours":{"type":"integer"},"ThresholdComparator":{}}}}},"S12":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"ChaincodeLogs":{"shape":"Sd"},"PeerLogs":{"shape":"Sd"}}}}},"S17":{"type":"structure","members":{"Invitations":{"type":"list","member":{"type":"structure","required":["Principal"],"members":{"Principal":{}}}},"Removals":{"type":"list","member":{"type":"structure","required":["MemberId"],"members":{"MemberId":{}}}}}},"S1p":{"type":"timestamp","timestampFormat":"iso8601"},"S1q":{"type":"map","key":{},"value":{}},"S2h":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Framework":{},"FrameworkVersion":{},"Status":{},"CreationDate":{"shape":"S1p"},"Arn":{}}}}}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNetworks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNodes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProposalVotes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProposals":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mediapackagevod'] = {};
	AWS.MediaPackageVod = Service.defineService('mediapackagevod', ['2018-11-07']);
	Object.defineProperty(apiLoader.services['mediapackagevod'], '2018-11-07', {
	  get: function get() {
	    var model = __webpack_require__(734);
	    model.paginators = __webpack_require__(735).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MediaPackageVod;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2018-11-07","endpointPrefix":"mediapackage-vod","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"MediaPackage Vod","serviceFullName":"AWS Elemental MediaPackage VOD","serviceId":"MediaPackage Vod","signatureVersion":"v4","signingName":"mediapackage-vod","uid":"mediapackage-vod-2018-11-07"},"operations":{"ConfigureLogs":{"http":{"method":"PUT","requestUri":"/packaging_groups/{id}/configure_logs","responseCode":200},"input":{"members":{"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"S5"},"DomainName":{"locationName":"domainName"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"CreateAsset":{"http":{"requestUri":"/assets","responseCode":200},"input":{"members":{"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"},"Tags":{"locationName":"tags","shape":"S6"}},"required":["SourceArn","Id","PackagingGroupId","SourceRoleArn"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"CreatedAt":{"locationName":"createdAt"},"EgressEndpoints":{"locationName":"egressEndpoints","shape":"S9"},"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"CreatePackagingConfiguration":{"http":{"requestUri":"/packaging_configurations","responseCode":200},"input":{"members":{"CmafPackage":{"locationName":"cmafPackage","shape":"Sc"},"DashPackage":{"locationName":"dashPackage","shape":"Sn"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sx"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"S10"},"PackagingGroupId":{"locationName":"packagingGroupId"},"Tags":{"locationName":"tags","shape":"S6"}},"required":["Id","PackagingGroupId"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"CmafPackage":{"locationName":"cmafPackage","shape":"Sc"},"DashPackage":{"locationName":"dashPackage","shape":"Sn"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sx"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"S10"},"PackagingGroupId":{"locationName":"packagingGroupId"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"CreatePackagingGroup":{"http":{"requestUri":"/packaging_groups","responseCode":200},"input":{"members":{"Authorization":{"locationName":"authorization","shape":"S5"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S6"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"S5"},"DomainName":{"locationName":"domainName"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"DeleteAsset":{"http":{"method":"DELETE","requestUri":"/assets/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeletePackagingConfiguration":{"http":{"method":"DELETE","requestUri":"/packaging_configurations/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeletePackagingGroup":{"http":{"method":"DELETE","requestUri":"/packaging_groups/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DescribeAsset":{"http":{"method":"GET","requestUri":"/assets/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"CreatedAt":{"locationName":"createdAt"},"EgressEndpoints":{"locationName":"egressEndpoints","shape":"S9"},"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"DescribePackagingConfiguration":{"http":{"method":"GET","requestUri":"/packaging_configurations/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"CmafPackage":{"locationName":"cmafPackage","shape":"Sc"},"DashPackage":{"locationName":"dashPackage","shape":"Sn"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sx"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"S10"},"PackagingGroupId":{"locationName":"packagingGroupId"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"DescribePackagingGroup":{"http":{"method":"GET","requestUri":"/packaging_groups/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"S5"},"DomainName":{"locationName":"domainName"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}},"ListAssets":{"http":{"method":"GET","requestUri":"/assets","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"PackagingGroupId":{"location":"querystring","locationName":"packagingGroupId"}},"type":"structure"},"output":{"members":{"Assets":{"locationName":"assets","member":{"members":{"Arn":{"locationName":"arn"},"CreatedAt":{"locationName":"createdAt"},"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"},"type":"list"},"NextToken":{"locationName":"nextToken"}},"type":"structure"}},"ListPackagingConfigurations":{"http":{"method":"GET","requestUri":"/packaging_configurations","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"PackagingGroupId":{"location":"querystring","locationName":"packagingGroupId"}},"type":"structure"},"output":{"members":{"NextToken":{"locationName":"nextToken"},"PackagingConfigurations":{"locationName":"packagingConfigurations","member":{"members":{"Arn":{"locationName":"arn"},"CmafPackage":{"locationName":"cmafPackage","shape":"Sc"},"DashPackage":{"locationName":"dashPackage","shape":"Sn"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sx"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"S10"},"PackagingGroupId":{"locationName":"packagingGroupId"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"},"type":"list"}},"type":"structure"}},"ListPackagingGroups":{"http":{"method":"GET","requestUri":"/packaging_groups","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"NextToken":{"locationName":"nextToken"},"PackagingGroups":{"locationName":"packagingGroups","member":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"S5"},"DomainName":{"locationName":"domainName"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"},"type":"list"}},"type":"structure"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"],"type":"structure"},"output":{"members":{"Tags":{"locationName":"tags","shape":"S1y"}},"type":"structure"}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"locationName":"tags","shape":"S1y"}},"required":["ResourceArn","Tags"],"type":"structure"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","shape":"Sf"}},"required":["TagKeys","ResourceArn"],"type":"structure"}},"UpdatePackagingGroup":{"http":{"method":"PUT","requestUri":"/packaging_groups/{id}","responseCode":200},"input":{"members":{"Authorization":{"locationName":"authorization","shape":"S5"},"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Authorization":{"locationName":"authorization","shape":"S5"},"DomainName":{"locationName":"domainName"},"EgressAccessLogs":{"locationName":"egressAccessLogs","shape":"S2"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S6"}},"type":"structure"}}},"shapes":{"S2":{"members":{"LogGroupName":{"locationName":"logGroupName"}},"type":"structure"},"S5":{"members":{"CdnIdentifierSecret":{"locationName":"cdnIdentifierSecret"},"SecretsRoleArn":{"locationName":"secretsRoleArn"}},"required":["SecretsRoleArn","CdnIdentifierSecret"],"type":"structure"},"S6":{"key":{},"type":"map","value":{}},"S9":{"member":{"members":{"PackagingConfigurationId":{"locationName":"packagingConfigurationId"},"Status":{"locationName":"status"},"Url":{"locationName":"url"}},"type":"structure"},"type":"list"},"Sc":{"members":{"Encryption":{"locationName":"encryption","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Se"}},"required":["SpekeKeyProvider"],"type":"structure"},"HlsManifests":{"locationName":"hlsManifests","shape":"Sg"},"IncludeEncoderConfigurationInSegments":{"locationName":"includeEncoderConfigurationInSegments","type":"boolean"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"}},"required":["HlsManifests"],"type":"structure"},"Se":{"members":{"RoleArn":{"locationName":"roleArn"},"SystemIds":{"locationName":"systemIds","shape":"Sf"},"Url":{"locationName":"url"}},"required":["SystemIds","Url","RoleArn"],"type":"structure"},"Sf":{"member":{},"type":"list"},"Sg":{"member":{"members":{"AdMarkers":{"locationName":"adMarkers"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"ManifestName":{"locationName":"manifestName"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"},"RepeatExtXKey":{"locationName":"repeatExtXKey","type":"boolean"},"StreamSelection":{"locationName":"streamSelection","shape":"Sl"}},"type":"structure"},"type":"list"},"Sl":{"members":{"MaxVideoBitsPerSecond":{"locationName":"maxVideoBitsPerSecond","type":"integer"},"MinVideoBitsPerSecond":{"locationName":"minVideoBitsPerSecond","type":"integer"},"StreamOrder":{"locationName":"streamOrder"}},"type":"structure"},"Sn":{"members":{"DashManifests":{"locationName":"dashManifests","member":{"members":{"ManifestLayout":{"locationName":"manifestLayout"},"ManifestName":{"locationName":"manifestName"},"MinBufferTimeSeconds":{"locationName":"minBufferTimeSeconds","type":"integer"},"Profile":{"locationName":"profile"},"ScteMarkersSource":{"locationName":"scteMarkersSource"},"StreamSelection":{"locationName":"streamSelection","shape":"Sl"}},"type":"structure"},"type":"list"},"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Se"}},"required":["SpekeKeyProvider"],"type":"structure"},"IncludeEncoderConfigurationInSegments":{"locationName":"includeEncoderConfigurationInSegments","type":"boolean"},"PeriodTriggers":{"locationName":"periodTriggers","member":{},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentTemplateFormat":{"locationName":"segmentTemplateFormat"}},"required":["DashManifests"],"type":"structure"},"Sx":{"members":{"Encryption":{"locationName":"encryption","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Se"}},"required":["SpekeKeyProvider"],"type":"structure"},"HlsManifests":{"locationName":"hlsManifests","shape":"Sg"},"IncludeDvbSubtitles":{"locationName":"includeDvbSubtitles","type":"boolean"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"UseAudioRenditionGroup":{"locationName":"useAudioRenditionGroup","type":"boolean"}},"required":["HlsManifests"],"type":"structure"},"S10":{"members":{"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Se"}},"required":["SpekeKeyProvider"],"type":"structure"},"MssManifests":{"locationName":"mssManifests","member":{"members":{"ManifestName":{"locationName":"manifestName"},"StreamSelection":{"locationName":"streamSelection","shape":"Sl"}},"type":"structure"},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"}},"required":["MssManifests"],"type":"structure"},"S1y":{"key":{},"type":"map","value":{}}}}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAssets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Assets"},"ListPackagingConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PackagingConfigurations"},"ListPackagingGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PackagingGroups"}}}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['groundstation'] = {};
	AWS.GroundStation = Service.defineService('groundstation', ['2019-05-23']);
	Object.defineProperty(apiLoader.services['groundstation'], '2019-05-23', {
	  get: function get() {
	    var model = __webpack_require__(737);
	    model.paginators = __webpack_require__(738).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.GroundStation;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-05-23","endpointPrefix":"groundstation","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Ground Station","serviceId":"GroundStation","signatureVersion":"v4","signingName":"groundstation","uid":"groundstation-2019-05-23"},"operations":{"CancelContact":{"http":{"method":"DELETE","requestUri":"/contact/{contactId}","responseCode":200},"input":{"type":"structure","required":["contactId"],"members":{"contactId":{"location":"uri","locationName":"contactId"}}},"output":{"shape":"S3"},"idempotent":true},"CreateConfig":{"http":{"requestUri":"/config","responseCode":200},"input":{"type":"structure","required":["configData","name"],"members":{"configData":{"shape":"S5"},"name":{},"tags":{"shape":"Sx"}}},"output":{"shape":"Sy"}},"CreateDataflowEndpointGroup":{"http":{"requestUri":"/dataflowEndpointGroup","responseCode":200},"input":{"type":"structure","required":["endpointDetails"],"members":{"endpointDetails":{"shape":"S11"},"tags":{"shape":"Sx"}}},"output":{"shape":"S1b"}},"CreateMissionProfile":{"http":{"requestUri":"/missionprofile","responseCode":200},"input":{"type":"structure","required":["dataflowEdges","minimumViableContactDurationSeconds","name","trackingConfigArn"],"members":{"contactPostPassDurationSeconds":{"type":"integer"},"contactPrePassDurationSeconds":{"type":"integer"},"dataflowEdges":{"shape":"S1e"},"minimumViableContactDurationSeconds":{"type":"integer"},"name":{},"tags":{"shape":"Sx"},"trackingConfigArn":{}}},"output":{"shape":"S1g"}},"DeleteConfig":{"http":{"method":"DELETE","requestUri":"/config/{configType}/{configId}","responseCode":200},"input":{"type":"structure","required":["configId","configType"],"members":{"configId":{"location":"uri","locationName":"configId"},"configType":{"location":"uri","locationName":"configType"}}},"output":{"shape":"Sy"},"idempotent":true},"DeleteDataflowEndpointGroup":{"http":{"method":"DELETE","requestUri":"/dataflowEndpointGroup/{dataflowEndpointGroupId}","responseCode":200},"input":{"type":"structure","required":["dataflowEndpointGroupId"],"members":{"dataflowEndpointGroupId":{"location":"uri","locationName":"dataflowEndpointGroupId"}}},"output":{"shape":"S1b"},"idempotent":true},"DeleteMissionProfile":{"http":{"method":"DELETE","requestUri":"/missionprofile/{missionProfileId}","responseCode":200},"input":{"type":"structure","required":["missionProfileId"],"members":{"missionProfileId":{"location":"uri","locationName":"missionProfileId"}}},"output":{"shape":"S1g"},"idempotent":true},"DescribeContact":{"http":{"method":"GET","requestUri":"/contact/{contactId}","responseCode":200},"input":{"type":"structure","required":["contactId"],"members":{"contactId":{"location":"uri","locationName":"contactId"}}},"output":{"type":"structure","members":{"contactId":{},"contactStatus":{},"dataflowList":{"type":"list","member":{"type":"structure","members":{"destination":{"type":"structure","members":{"configDetails":{"shape":"S1q"},"configId":{},"configType":{},"dataflowDestinationRegion":{}}},"errorMessage":{},"source":{"type":"structure","members":{"configDetails":{"shape":"S1q"},"configId":{},"configType":{},"dataflowSourceRegion":{}}}}}},"endTime":{"type":"timestamp"},"errorMessage":{},"groundStation":{},"maximumElevation":{"shape":"S1v"},"missionProfileArn":{},"postPassEndTime":{"type":"timestamp"},"prePassStartTime":{"type":"timestamp"},"region":{},"satelliteArn":{},"startTime":{"type":"timestamp"},"tags":{"shape":"Sx"}}}},"GetConfig":{"http":{"method":"GET","requestUri":"/config/{configType}/{configId}","responseCode":200},"input":{"type":"structure","required":["configId","configType"],"members":{"configId":{"location":"uri","locationName":"configId"},"configType":{"location":"uri","locationName":"configType"}}},"output":{"type":"structure","required":["configArn","configData","configId","name"],"members":{"configArn":{},"configData":{"shape":"S5"},"configId":{},"configType":{},"name":{},"tags":{"shape":"Sx"}}}},"GetDataflowEndpointGroup":{"http":{"method":"GET","requestUri":"/dataflowEndpointGroup/{dataflowEndpointGroupId}","responseCode":200},"input":{"type":"structure","required":["dataflowEndpointGroupId"],"members":{"dataflowEndpointGroupId":{"location":"uri","locationName":"dataflowEndpointGroupId"}}},"output":{"type":"structure","members":{"dataflowEndpointGroupArn":{},"dataflowEndpointGroupId":{},"endpointsDetails":{"shape":"S11"},"tags":{"shape":"Sx"}}}},"GetMinuteUsage":{"http":{"requestUri":"/minute-usage","responseCode":200},"input":{"type":"structure","required":["month","year"],"members":{"month":{"type":"integer"},"year":{"type":"integer"}}},"output":{"type":"structure","members":{"estimatedMinutesRemaining":{"type":"integer"},"isReservedMinutesCustomer":{"type":"boolean"},"totalReservedMinuteAllocation":{"type":"integer"},"totalScheduledMinutes":{"type":"integer"},"upcomingMinutesScheduled":{"type":"integer"}}}},"GetMissionProfile":{"http":{"method":"GET","requestUri":"/missionprofile/{missionProfileId}","responseCode":200},"input":{"type":"structure","required":["missionProfileId"],"members":{"missionProfileId":{"location":"uri","locationName":"missionProfileId"}}},"output":{"type":"structure","members":{"contactPostPassDurationSeconds":{"type":"integer"},"contactPrePassDurationSeconds":{"type":"integer"},"dataflowEdges":{"shape":"S1e"},"minimumViableContactDurationSeconds":{"type":"integer"},"missionProfileArn":{},"missionProfileId":{},"name":{},"region":{},"tags":{"shape":"Sx"},"trackingConfigArn":{}}}},"GetSatellite":{"http":{"method":"GET","requestUri":"/satellite/{satelliteId}","responseCode":200},"input":{"type":"structure","required":["satelliteId"],"members":{"satelliteId":{"location":"uri","locationName":"satelliteId"}}},"output":{"type":"structure","members":{"groundStations":{"shape":"S2a"},"noradSatelliteID":{"type":"integer"},"satelliteArn":{},"satelliteId":{}}}},"ListConfigs":{"http":{"method":"GET","requestUri":"/config","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"configList":{"type":"list","member":{"type":"structure","members":{"configArn":{},"configId":{},"configType":{},"name":{}}}},"nextToken":{}}}},"ListContacts":{"http":{"requestUri":"/contacts","responseCode":200},"input":{"type":"structure","required":["endTime","startTime","statusList"],"members":{"endTime":{"type":"timestamp"},"groundStation":{},"maxResults":{"type":"integer"},"missionProfileArn":{},"nextToken":{},"satelliteArn":{},"startTime":{"type":"timestamp"},"statusList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"contactList":{"type":"list","member":{"type":"structure","members":{"contactId":{},"contactStatus":{},"endTime":{"type":"timestamp"},"errorMessage":{},"groundStation":{},"maximumElevation":{"shape":"S1v"},"missionProfileArn":{},"postPassEndTime":{"type":"timestamp"},"prePassStartTime":{"type":"timestamp"},"region":{},"satelliteArn":{},"startTime":{"type":"timestamp"},"tags":{"shape":"Sx"}}}},"nextToken":{}}}},"ListDataflowEndpointGroups":{"http":{"method":"GET","requestUri":"/dataflowEndpointGroup","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"dataflowEndpointGroupList":{"type":"list","member":{"type":"structure","members":{"dataflowEndpointGroupArn":{},"dataflowEndpointGroupId":{}}}},"nextToken":{}}}},"ListGroundStations":{"http":{"method":"GET","requestUri":"/groundstation","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"satelliteId":{"location":"querystring","locationName":"satelliteId"}}},"output":{"type":"structure","members":{"groundStationList":{"type":"list","member":{"type":"structure","members":{"groundStationId":{},"groundStationName":{},"region":{}}}},"nextToken":{}}}},"ListMissionProfiles":{"http":{"method":"GET","requestUri":"/missionprofile","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"missionProfileList":{"type":"list","member":{"type":"structure","members":{"missionProfileArn":{},"missionProfileId":{},"name":{},"region":{}}}},"nextToken":{}}}},"ListSatellites":{"http":{"method":"GET","requestUri":"/satellite","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"satellites":{"type":"list","member":{"type":"structure","members":{"groundStations":{"shape":"S2a"},"noradSatelliteID":{"type":"integer"},"satelliteArn":{},"satelliteId":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"}}}},"ReserveContact":{"http":{"requestUri":"/contact","responseCode":200},"input":{"type":"structure","required":["endTime","groundStation","missionProfileArn","satelliteArn","startTime"],"members":{"endTime":{"type":"timestamp"},"groundStation":{},"missionProfileArn":{},"satelliteArn":{},"startTime":{"type":"timestamp"},"tags":{"shape":"Sx"}}},"output":{"shape":"S3"}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateConfig":{"http":{"method":"PUT","requestUri":"/config/{configType}/{configId}","responseCode":200},"input":{"type":"structure","required":["configData","configId","configType","name"],"members":{"configData":{"shape":"S5"},"configId":{"location":"uri","locationName":"configId"},"configType":{"location":"uri","locationName":"configType"},"name":{}}},"output":{"shape":"Sy"},"idempotent":true},"UpdateMissionProfile":{"http":{"method":"PUT","requestUri":"/missionprofile/{missionProfileId}","responseCode":200},"input":{"type":"structure","required":["missionProfileId"],"members":{"contactPostPassDurationSeconds":{"type":"integer"},"contactPrePassDurationSeconds":{"type":"integer"},"dataflowEdges":{"shape":"S1e"},"minimumViableContactDurationSeconds":{"type":"integer"},"missionProfileId":{"location":"uri","locationName":"missionProfileId"},"name":{},"trackingConfigArn":{}}},"output":{"shape":"S1g"},"idempotent":true}},"shapes":{"S3":{"type":"structure","members":{"contactId":{}}},"S5":{"type":"structure","members":{"antennaDownlinkConfig":{"type":"structure","required":["spectrumConfig"],"members":{"spectrumConfig":{"shape":"S7"}}},"antennaDownlinkDemodDecodeConfig":{"type":"structure","required":["decodeConfig","demodulationConfig","spectrumConfig"],"members":{"decodeConfig":{"type":"structure","required":["unvalidatedJSON"],"members":{"unvalidatedJSON":{}}},"demodulationConfig":{"type":"structure","required":["unvalidatedJSON"],"members":{"unvalidatedJSON":{}}},"spectrumConfig":{"shape":"S7"}}},"antennaUplinkConfig":{"type":"structure","required":["spectrumConfig","targetEirp"],"members":{"spectrumConfig":{"type":"structure","required":["centerFrequency"],"members":{"centerFrequency":{"shape":"Sb"},"polarization":{}}},"targetEirp":{"type":"structure","required":["units","value"],"members":{"units":{},"value":{"type":"double"}}},"transmitDisabled":{"type":"boolean"}}},"dataflowEndpointConfig":{"type":"structure","required":["dataflowEndpointName"],"members":{"dataflowEndpointName":{},"dataflowEndpointRegion":{}}},"s3RecordingConfig":{"type":"structure","required":["bucketArn","roleArn"],"members":{"bucketArn":{},"prefix":{},"roleArn":{}}},"trackingConfig":{"type":"structure","required":["autotrack"],"members":{"autotrack":{}}},"uplinkEchoConfig":{"type":"structure","required":["antennaUplinkConfigArn","enabled"],"members":{"antennaUplinkConfigArn":{},"enabled":{"type":"boolean"}}}},"union":true},"S7":{"type":"structure","required":["bandwidth","centerFrequency"],"members":{"bandwidth":{"type":"structure","required":["units","value"],"members":{"units":{},"value":{"type":"double"}}},"centerFrequency":{"shape":"Sb"},"polarization":{}}},"Sb":{"type":"structure","required":["units","value"],"members":{"units":{},"value":{"type":"double"}}},"Sx":{"type":"map","key":{},"value":{}},"Sy":{"type":"structure","members":{"configArn":{},"configId":{},"configType":{}}},"S11":{"type":"list","member":{"shape":"S12"}},"S12":{"type":"structure","members":{"endpoint":{"type":"structure","members":{"address":{"type":"structure","required":["name","port"],"members":{"name":{},"port":{"type":"integer"}}},"mtu":{"type":"integer"},"name":{},"status":{}}},"securityDetails":{"type":"structure","required":["roleArn","securityGroupIds","subnetIds"],"members":{"roleArn":{},"securityGroupIds":{"type":"list","member":{}},"subnetIds":{"type":"list","member":{}}}}}},"S1b":{"type":"structure","members":{"dataflowEndpointGroupId":{}}},"S1e":{"type":"list","member":{"type":"list","member":{}}},"S1g":{"type":"structure","members":{"missionProfileId":{}}},"S1q":{"type":"structure","members":{"antennaDemodDecodeDetails":{"type":"structure","members":{"outputNode":{}}},"endpointDetails":{"shape":"S12"},"s3RecordingDetails":{"type":"structure","members":{"bucketArn":{},"keyTemplate":{}}}},"union":true},"S1v":{"type":"structure","required":["unit","value"],"members":{"unit":{},"value":{"type":"double"}}},"S2a":{"type":"list","member":{}}}}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListConfigs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"configList"},"ListContacts":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"contactList"},"ListDataflowEndpointGroups":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"dataflowEndpointGroupList"},"ListGroundStations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"groundStationList"},"ListMissionProfiles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"missionProfileList"},"ListSatellites":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"satellites"}}}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotthingsgraph'] = {};
	AWS.IoTThingsGraph = Service.defineService('iotthingsgraph', ['2018-09-06']);
	Object.defineProperty(apiLoader.services['iotthingsgraph'], '2018-09-06', {
	  get: function get() {
	    var model = __webpack_require__(740);
	    model.paginators = __webpack_require__(741).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTThingsGraph;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-06","endpointPrefix":"iotthingsgraph","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS IoT Things Graph","serviceId":"IoTThingsGraph","signatureVersion":"v4","signingName":"iotthingsgraph","targetPrefix":"IotThingsGraphFrontEndService","uid":"iotthingsgraph-2018-09-06"},"operations":{"AssociateEntityToThing":{"input":{"type":"structure","required":["thingName","entityId"],"members":{"thingName":{},"entityId":{},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{}}},"CreateFlowTemplate":{"input":{"type":"structure","required":["definition"],"members":{"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sb"}}}},"CreateSystemInstance":{"input":{"type":"structure","required":["definition","target"],"members":{"tags":{"shape":"Sf"},"definition":{"shape":"S7"},"target":{},"greengrassGroupName":{},"s3BucketName":{},"metricsConfiguration":{"shape":"Sm"},"flowActionsRoleArn":{}}},"output":{"type":"structure","members":{"summary":{"shape":"Sq"}}}},"CreateSystemTemplate":{"input":{"type":"structure","required":["definition"],"members":{"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sw"}}}},"DeleteFlowTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeleteNamespace":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"namespaceArn":{},"namespaceName":{}}}},"DeleteSystemInstance":{"input":{"type":"structure","members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeleteSystemTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeploySystemInstance":{"input":{"type":"structure","members":{"id":{}}},"output":{"type":"structure","required":["summary"],"members":{"summary":{"shape":"Sq"},"greengrassDeploymentId":{}}}},"DeprecateFlowTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeprecateSystemTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DescribeNamespace":{"input":{"type":"structure","members":{"namespaceName":{}}},"output":{"type":"structure","members":{"namespaceArn":{},"namespaceName":{},"trackingNamespaceName":{},"trackingNamespaceVersion":{"type":"long"},"namespaceVersion":{"type":"long"}}}},"DissociateEntityFromThing":{"input":{"type":"structure","required":["thingName","entityType"],"members":{"thingName":{},"entityType":{}}},"output":{"type":"structure","members":{}}},"GetEntities":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"type":"list","member":{}},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"descriptions":{"shape":"S1l"}}}},"GetFlowTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{},"revisionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"description":{"type":"structure","members":{"summary":{"shape":"Sb"},"definition":{"shape":"S7"},"validatedNamespaceVersion":{"type":"long"}}}}}},"GetFlowTemplateRevisions":{"input":{"type":"structure","required":["id"],"members":{"id":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S1u"},"nextToken":{}}}},"GetNamespaceDeletionStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"namespaceArn":{},"namespaceName":{},"status":{},"errorCode":{},"errorMessage":{}}}},"GetSystemInstance":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"description":{"type":"structure","members":{"summary":{"shape":"Sq"},"definition":{"shape":"S7"},"s3BucketName":{},"metricsConfiguration":{"shape":"Sm"},"validatedNamespaceVersion":{"type":"long"},"validatedDependencyRevisions":{"type":"list","member":{"type":"structure","members":{"id":{},"revisionNumber":{"type":"long"}}}},"flowActionsRoleArn":{}}}}}},"GetSystemTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{},"revisionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"description":{"type":"structure","members":{"summary":{"shape":"Sw"},"definition":{"shape":"S7"},"validatedNamespaceVersion":{"type":"long"}}}}}},"GetSystemTemplateRevisions":{"input":{"type":"structure","required":["id"],"members":{"id":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S2a"},"nextToken":{}}}},"GetUploadStatus":{"input":{"type":"structure","required":["uploadId"],"members":{"uploadId":{}}},"output":{"type":"structure","required":["uploadId","uploadStatus","createdDate"],"members":{"uploadId":{},"uploadStatus":{},"namespaceArn":{},"namespaceName":{},"namespaceVersion":{"type":"long"},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"ListFlowExecutionMessages":{"input":{"type":"structure","required":["flowExecutionId"],"members":{"flowExecutionId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"messages":{"type":"list","member":{"type":"structure","members":{"messageId":{},"eventType":{},"timestamp":{"type":"timestamp"},"payload":{}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"maxResults":{"type":"integer"},"resourceArn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sf"},"nextToken":{}}}},"SearchEntities":{"input":{"type":"structure","required":["entityTypes"],"members":{"entityTypes":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"descriptions":{"shape":"S1l"},"nextToken":{}}}},"SearchFlowExecutions":{"input":{"type":"structure","required":["systemInstanceId"],"members":{"systemInstanceId":{},"flowExecutionId":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"type":"list","member":{"type":"structure","members":{"flowExecutionId":{},"status":{},"systemInstanceId":{},"flowTemplateId":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"SearchFlowTemplates":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S1u"},"nextToken":{}}}},"SearchSystemInstances":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"type":"list","member":{"shape":"Sq"}},"nextToken":{}}}},"SearchSystemTemplates":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S2a"},"nextToken":{}}}},"SearchThings":{"input":{"type":"structure","required":["entityId"],"members":{"entityId":{},"nextToken":{},"maxResults":{"type":"integer"},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"thingName":{}}}},"nextToken":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UndeploySystemInstance":{"input":{"type":"structure","members":{"id":{}}},"output":{"type":"structure","members":{"summary":{"shape":"Sq"}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFlowTemplate":{"input":{"type":"structure","required":["id","definition"],"members":{"id":{},"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sb"}}}},"UpdateSystemTemplate":{"input":{"type":"structure","required":["id","definition"],"members":{"id":{},"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sw"}}}},"UploadEntityDefinitions":{"input":{"type":"structure","members":{"document":{"shape":"S7"},"syncWithPublicNamespace":{"type":"boolean"},"deprecateExistingEntities":{"type":"boolean"}}},"output":{"type":"structure","required":["uploadId"],"members":{"uploadId":{}}}}},"shapes":{"S7":{"type":"structure","required":["language","text"],"members":{"language":{},"text":{}}},"Sb":{"type":"structure","members":{"id":{},"arn":{},"revisionNumber":{"type":"long"},"createdAt":{"type":"timestamp"}}},"Sf":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sm":{"type":"structure","members":{"cloudMetricEnabled":{"type":"boolean"},"metricRuleRoleArn":{}}},"Sq":{"type":"structure","members":{"id":{},"arn":{},"status":{},"target":{},"greengrassGroupName":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"greengrassGroupId":{},"greengrassGroupVersionId":{}}},"Sw":{"type":"structure","members":{"id":{},"arn":{},"revisionNumber":{"type":"long"},"createdAt":{"type":"timestamp"}}},"S1l":{"type":"list","member":{"type":"structure","members":{"id":{},"arn":{},"type":{},"createdAt":{"type":"timestamp"},"definition":{"shape":"S7"}}}},"S1u":{"type":"list","member":{"shape":"Sb"}},"S2a":{"type":"list","member":{"shape":"Sw"}}}}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetFlowTemplateRevisions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"GetSystemTemplateRevisions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"ListFlowExecutionMessages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"messages"},"ListTagsForResource":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tags"},"SearchEntities":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"descriptions"},"SearchFlowExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchFlowTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchSystemInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchSystemTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchThings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"}}}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotevents'] = {};
	AWS.IoTEvents = Service.defineService('iotevents', ['2018-07-27']);
	Object.defineProperty(apiLoader.services['iotevents'], '2018-07-27', {
	  get: function get() {
	    var model = __webpack_require__(743);
	    model.paginators = __webpack_require__(744).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTEvents;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-07-27","endpointPrefix":"iotevents","protocol":"rest-json","serviceFullName":"AWS IoT Events","serviceId":"IoT Events","signatureVersion":"v4","signingName":"iotevents","uid":"iotevents-2018-07-27"},"operations":{"CreateAlarmModel":{"http":{"requestUri":"/alarm-models"},"input":{"type":"structure","required":["alarmModelName","roleArn","alarmRule"],"members":{"alarmModelName":{},"alarmModelDescription":{},"roleArn":{},"tags":{"shape":"S5"},"key":{},"severity":{"type":"integer"},"alarmRule":{"shape":"Sb"},"alarmNotification":{"shape":"Sg"},"alarmEventActions":{"shape":"S13"},"alarmCapabilities":{"shape":"S23"}}},"output":{"type":"structure","members":{"creationTime":{"type":"timestamp"},"alarmModelArn":{},"alarmModelVersion":{},"lastUpdateTime":{"type":"timestamp"},"status":{}}}},"CreateDetectorModel":{"http":{"requestUri":"/detector-models"},"input":{"type":"structure","required":["detectorModelName","detectorModelDefinition","roleArn"],"members":{"detectorModelName":{},"detectorModelDefinition":{"shape":"S2f"},"detectorModelDescription":{},"key":{},"roleArn":{},"tags":{"shape":"S5"},"evaluationMethod":{}}},"output":{"type":"structure","members":{"detectorModelConfiguration":{"shape":"S35"}}}},"CreateInput":{"http":{"requestUri":"/inputs","responseCode":201},"input":{"type":"structure","required":["inputName","inputDefinition"],"members":{"inputName":{},"inputDescription":{},"inputDefinition":{"shape":"S3b"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"inputConfiguration":{"shape":"S3f"}}}},"DeleteAlarmModel":{"http":{"method":"DELETE","requestUri":"/alarm-models/{alarmModelName}","responseCode":204},"input":{"type":"structure","required":["alarmModelName"],"members":{"alarmModelName":{"location":"uri","locationName":"alarmModelName"}}},"output":{"type":"structure","members":{}}},"DeleteDetectorModel":{"http":{"method":"DELETE","requestUri":"/detector-models/{detectorModelName}","responseCode":204},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"}}},"output":{"type":"structure","members":{}}},"DeleteInput":{"http":{"method":"DELETE","requestUri":"/inputs/{inputName}"},"input":{"type":"structure","required":["inputName"],"members":{"inputName":{"location":"uri","locationName":"inputName"}}},"output":{"type":"structure","members":{}}},"DescribeAlarmModel":{"http":{"method":"GET","requestUri":"/alarm-models/{alarmModelName}"},"input":{"type":"structure","required":["alarmModelName"],"members":{"alarmModelName":{"location":"uri","locationName":"alarmModelName"},"alarmModelVersion":{"location":"querystring","locationName":"version"}}},"output":{"type":"structure","members":{"creationTime":{"type":"timestamp"},"alarmModelArn":{},"alarmModelVersion":{},"lastUpdateTime":{"type":"timestamp"},"status":{},"statusMessage":{},"alarmModelName":{},"alarmModelDescription":{},"roleArn":{},"key":{},"severity":{"type":"integer"},"alarmRule":{"shape":"Sb"},"alarmNotification":{"shape":"Sg"},"alarmEventActions":{"shape":"S13"},"alarmCapabilities":{"shape":"S23"}}}},"DescribeDetectorModel":{"http":{"method":"GET","requestUri":"/detector-models/{detectorModelName}"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"detectorModelVersion":{"location":"querystring","locationName":"version"}}},"output":{"type":"structure","members":{"detectorModel":{"type":"structure","members":{"detectorModelDefinition":{"shape":"S2f"},"detectorModelConfiguration":{"shape":"S35"}}}}}},"DescribeDetectorModelAnalysis":{"http":{"method":"GET","requestUri":"/analysis/detector-models/{analysisId}"},"input":{"type":"structure","required":["analysisId"],"members":{"analysisId":{"location":"uri","locationName":"analysisId"}}},"output":{"type":"structure","members":{"status":{}}}},"DescribeInput":{"http":{"method":"GET","requestUri":"/inputs/{inputName}"},"input":{"type":"structure","required":["inputName"],"members":{"inputName":{"location":"uri","locationName":"inputName"}}},"output":{"type":"structure","members":{"input":{"type":"structure","members":{"inputConfiguration":{"shape":"S3f"},"inputDefinition":{"shape":"S3b"}}}}}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"loggingOptions":{"shape":"S43"}}}},"GetDetectorModelAnalysisResults":{"http":{"method":"GET","requestUri":"/analysis/detector-models/{analysisId}/results"},"input":{"type":"structure","required":["analysisId"],"members":{"analysisId":{"location":"uri","locationName":"analysisId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"analysisResults":{"type":"list","member":{"type":"structure","members":{"type":{},"level":{},"message":{},"locations":{"type":"list","member":{"type":"structure","members":{"path":{}}}}}}},"nextToken":{}}}},"ListAlarmModelVersions":{"http":{"method":"GET","requestUri":"/alarm-models/{alarmModelName}/versions"},"input":{"type":"structure","required":["alarmModelName"],"members":{"alarmModelName":{"location":"uri","locationName":"alarmModelName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"alarmModelVersionSummaries":{"type":"list","member":{"type":"structure","members":{"alarmModelName":{},"alarmModelArn":{},"alarmModelVersion":{},"roleArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"statusMessage":{}}}},"nextToken":{}}}},"ListAlarmModels":{"http":{"method":"GET","requestUri":"/alarm-models"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"alarmModelSummaries":{"type":"list","member":{"type":"structure","members":{"creationTime":{"type":"timestamp"},"alarmModelDescription":{},"alarmModelName":{}}}},"nextToken":{}}}},"ListDetectorModelVersions":{"http":{"method":"GET","requestUri":"/detector-models/{detectorModelName}/versions"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"detectorModelVersionSummaries":{"type":"list","member":{"type":"structure","members":{"detectorModelName":{},"detectorModelVersion":{},"detectorModelArn":{},"roleArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"evaluationMethod":{}}}},"nextToken":{}}}},"ListDetectorModels":{"http":{"method":"GET","requestUri":"/detector-models"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"detectorModelSummaries":{"type":"list","member":{"type":"structure","members":{"detectorModelName":{},"detectorModelDescription":{},"creationTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListInputRoutings":{"http":{"requestUri":"/input-routings"},"input":{"type":"structure","required":["inputIdentifier"],"members":{"inputIdentifier":{"type":"structure","members":{"iotEventsInputIdentifier":{"type":"structure","required":["inputName"],"members":{"inputName":{}}},"iotSiteWiseInputIdentifier":{"type":"structure","members":{"iotSiteWiseAssetModelPropertyIdentifier":{"type":"structure","required":["assetModelId","propertyId"],"members":{"assetModelId":{},"propertyId":{}}}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"routedResources":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{}}}},"nextToken":{}}}},"ListInputs":{"http":{"method":"GET","requestUri":"/inputs"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"inputSummaries":{"type":"list","member":{"type":"structure","members":{"inputName":{},"inputDescription":{},"inputArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5"}}}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S43"}}}},"StartDetectorModelAnalysis":{"http":{"requestUri":"/analysis/detector-models/"},"input":{"type":"structure","required":["detectorModelDefinition"],"members":{"detectorModelDefinition":{"shape":"S2f"}}},"output":{"type":"structure","members":{"analysisId":{}}}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAlarmModel":{"http":{"requestUri":"/alarm-models/{alarmModelName}"},"input":{"type":"structure","required":["alarmModelName","roleArn","alarmRule"],"members":{"alarmModelName":{"location":"uri","locationName":"alarmModelName"},"alarmModelDescription":{},"roleArn":{},"severity":{"type":"integer"},"alarmRule":{"shape":"Sb"},"alarmNotification":{"shape":"Sg"},"alarmEventActions":{"shape":"S13"},"alarmCapabilities":{"shape":"S23"}}},"output":{"type":"structure","members":{"creationTime":{"type":"timestamp"},"alarmModelArn":{},"alarmModelVersion":{},"lastUpdateTime":{"type":"timestamp"},"status":{}}}},"UpdateDetectorModel":{"http":{"requestUri":"/detector-models/{detectorModelName}"},"input":{"type":"structure","required":["detectorModelName","detectorModelDefinition","roleArn"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"detectorModelDefinition":{"shape":"S2f"},"detectorModelDescription":{},"roleArn":{},"evaluationMethod":{}}},"output":{"type":"structure","members":{"detectorModelConfiguration":{"shape":"S35"}}}},"UpdateInput":{"http":{"method":"PUT","requestUri":"/inputs/{inputName}"},"input":{"type":"structure","required":["inputName","inputDefinition"],"members":{"inputName":{"location":"uri","locationName":"inputName"},"inputDescription":{},"inputDefinition":{"shape":"S3b"}}},"output":{"type":"structure","members":{"inputConfiguration":{"shape":"S3f"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sb":{"type":"structure","members":{"simpleRule":{"type":"structure","required":["inputProperty","comparisonOperator","threshold"],"members":{"inputProperty":{},"comparisonOperator":{},"threshold":{}}}}},"Sg":{"type":"structure","members":{"notificationActions":{"type":"list","member":{"type":"structure","required":["action"],"members":{"action":{"type":"structure","members":{"lambdaAction":{"shape":"Sk"}}},"smsConfigurations":{"type":"list","member":{"type":"structure","required":["recipients"],"members":{"senderId":{},"additionalMessage":{},"recipients":{"shape":"Ss"}}}},"emailConfigurations":{"type":"list","member":{"type":"structure","required":["from","recipients"],"members":{"from":{},"content":{"type":"structure","members":{"subject":{},"additionalMessage":{}}},"recipients":{"type":"structure","members":{"to":{"shape":"Ss"}}}}}}}}}}},"Sk":{"type":"structure","required":["functionArn"],"members":{"functionArn":{},"payload":{"shape":"Sl"}}},"Sl":{"type":"structure","required":["contentExpression","type"],"members":{"contentExpression":{},"type":{}}},"Ss":{"type":"list","member":{"type":"structure","members":{"ssoIdentity":{"type":"structure","required":["identityStoreId"],"members":{"identityStoreId":{},"userId":{}}}}}},"S13":{"type":"structure","members":{"alarmActions":{"type":"list","member":{"type":"structure","members":{"sns":{"shape":"S16"},"iotTopicPublish":{"shape":"S17"},"lambda":{"shape":"Sk"},"iotEvents":{"shape":"S19"},"sqs":{"shape":"S1b"},"firehose":{"shape":"S1e"},"dynamoDB":{"shape":"S1h"},"dynamoDBv2":{"shape":"S1n"},"iotSiteWise":{"shape":"S1o"}}}}}},"S16":{"type":"structure","required":["targetArn"],"members":{"targetArn":{},"payload":{"shape":"Sl"}}},"S17":{"type":"structure","required":["mqttTopic"],"members":{"mqttTopic":{},"payload":{"shape":"Sl"}}},"S19":{"type":"structure","required":["inputName"],"members":{"inputName":{},"payload":{"shape":"Sl"}}},"S1b":{"type":"structure","required":["queueUrl"],"members":{"queueUrl":{},"useBase64":{"type":"boolean"},"payload":{"shape":"Sl"}}},"S1e":{"type":"structure","required":["deliveryStreamName"],"members":{"deliveryStreamName":{},"separator":{},"payload":{"shape":"Sl"}}},"S1h":{"type":"structure","required":["hashKeyField","hashKeyValue","tableName"],"members":{"hashKeyType":{},"hashKeyField":{},"hashKeyValue":{},"rangeKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"operation":{},"payloadField":{},"tableName":{},"payload":{"shape":"Sl"}}},"S1n":{"type":"structure","required":["tableName"],"members":{"tableName":{},"payload":{"shape":"Sl"}}},"S1o":{"type":"structure","members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"propertyValue":{"type":"structure","members":{"value":{"type":"structure","members":{"stringValue":{},"integerValue":{},"doubleValue":{},"booleanValue":{}}},"timestamp":{"type":"structure","required":["timeInSeconds"],"members":{"timeInSeconds":{},"offsetInNanos":{}}},"quality":{}}}}},"S23":{"type":"structure","members":{"initializationConfiguration":{"type":"structure","required":["disabledOnInitialization"],"members":{"disabledOnInitialization":{"type":"boolean"}}},"acknowledgeFlow":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"}}}}},"S2f":{"type":"structure","required":["states","initialStateName"],"members":{"states":{"type":"list","member":{"type":"structure","required":["stateName"],"members":{"stateName":{},"onInput":{"type":"structure","members":{"events":{"shape":"S2k"},"transitionEvents":{"type":"list","member":{"type":"structure","required":["eventName","condition","nextState"],"members":{"eventName":{},"condition":{},"actions":{"shape":"S2o"},"nextState":{}}}}}},"onEnter":{"type":"structure","members":{"events":{"shape":"S2k"}}},"onExit":{"type":"structure","members":{"events":{"shape":"S2k"}}}}}},"initialStateName":{}}},"S2k":{"type":"list","member":{"type":"structure","required":["eventName"],"members":{"eventName":{},"condition":{},"actions":{"shape":"S2o"}}}},"S2o":{"type":"list","member":{"type":"structure","members":{"setVariable":{"type":"structure","required":["variableName","value"],"members":{"variableName":{},"value":{}}},"sns":{"shape":"S16"},"iotTopicPublish":{"shape":"S17"},"setTimer":{"type":"structure","required":["timerName"],"members":{"timerName":{},"seconds":{"deprecated":true,"deprecatedMessage":"seconds is deprecated. You can use durationExpression for SetTimerAction. The value of seconds can be used as a string expression for durationExpression.","type":"integer"},"durationExpression":{}}},"clearTimer":{"type":"structure","required":["timerName"],"members":{"timerName":{}}},"resetTimer":{"type":"structure","required":["timerName"],"members":{"timerName":{}}},"lambda":{"shape":"Sk"},"iotEvents":{"shape":"S19"},"sqs":{"shape":"S1b"},"firehose":{"shape":"S1e"},"dynamoDB":{"shape":"S1h"},"dynamoDBv2":{"shape":"S1n"},"iotSiteWise":{"shape":"S1o"}}}},"S35":{"type":"structure","members":{"detectorModelName":{},"detectorModelVersion":{},"detectorModelDescription":{},"detectorModelArn":{},"roleArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"key":{},"evaluationMethod":{}}},"S3b":{"type":"structure","required":["attributes"],"members":{"attributes":{"type":"list","member":{"type":"structure","required":["jsonPath"],"members":{"jsonPath":{}}}}}},"S3f":{"type":"structure","required":["inputName","inputArn","creationTime","lastUpdateTime","status"],"members":{"inputName":{},"inputDescription":{},"inputArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{}}},"S43":{"type":"structure","required":["roleArn","level","enabled"],"members":{"roleArn":{},"level":{},"enabled":{"type":"boolean"},"detectorDebugOptions":{"type":"list","member":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{},"keyValue":{}}}}}}}}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ioteventsdata'] = {};
	AWS.IoTEventsData = Service.defineService('ioteventsdata', ['2018-10-23']);
	Object.defineProperty(apiLoader.services['ioteventsdata'], '2018-10-23', {
	  get: function get() {
	    var model = __webpack_require__(746);
	    model.paginators = __webpack_require__(747).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTEventsData;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-23","endpointPrefix":"data.iotevents","protocol":"rest-json","serviceFullName":"AWS IoT Events Data","serviceId":"IoT Events Data","signatureVersion":"v4","signingName":"ioteventsdata","uid":"iotevents-data-2018-10-23"},"operations":{"BatchAcknowledgeAlarm":{"http":{"requestUri":"/alarms/acknowledge","responseCode":202},"input":{"type":"structure","required":["acknowledgeActionRequests"],"members":{"acknowledgeActionRequests":{"type":"list","member":{"type":"structure","required":["requestId","alarmModelName"],"members":{"requestId":{},"alarmModelName":{},"keyValue":{},"note":{}}}}}},"output":{"type":"structure","members":{"errorEntries":{"shape":"S9"}}}},"BatchDisableAlarm":{"http":{"requestUri":"/alarms/disable","responseCode":202},"input":{"type":"structure","required":["disableActionRequests"],"members":{"disableActionRequests":{"type":"list","member":{"type":"structure","required":["requestId","alarmModelName"],"members":{"requestId":{},"alarmModelName":{},"keyValue":{},"note":{}}}}}},"output":{"type":"structure","members":{"errorEntries":{"shape":"S9"}}}},"BatchEnableAlarm":{"http":{"requestUri":"/alarms/enable","responseCode":202},"input":{"type":"structure","required":["enableActionRequests"],"members":{"enableActionRequests":{"type":"list","member":{"type":"structure","required":["requestId","alarmModelName"],"members":{"requestId":{},"alarmModelName":{},"keyValue":{},"note":{}}}}}},"output":{"type":"structure","members":{"errorEntries":{"shape":"S9"}}}},"BatchPutMessage":{"http":{"requestUri":"/inputs/messages","responseCode":200},"input":{"type":"structure","required":["messages"],"members":{"messages":{"type":"list","member":{"type":"structure","required":["messageId","inputName","payload"],"members":{"messageId":{},"inputName":{},"payload":{"type":"blob"},"timestamp":{"type":"structure","members":{"timeInMillis":{"type":"long"}}}}}}}},"output":{"type":"structure","members":{"BatchPutMessageErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchResetAlarm":{"http":{"requestUri":"/alarms/reset","responseCode":202},"input":{"type":"structure","required":["resetActionRequests"],"members":{"resetActionRequests":{"type":"list","member":{"type":"structure","required":["requestId","alarmModelName"],"members":{"requestId":{},"alarmModelName":{},"keyValue":{},"note":{}}}}}},"output":{"type":"structure","members":{"errorEntries":{"shape":"S9"}}}},"BatchSnoozeAlarm":{"http":{"requestUri":"/alarms/snooze","responseCode":202},"input":{"type":"structure","required":["snoozeActionRequests"],"members":{"snoozeActionRequests":{"type":"list","member":{"type":"structure","required":["requestId","alarmModelName","snoozeDuration"],"members":{"requestId":{},"alarmModelName":{},"keyValue":{},"note":{},"snoozeDuration":{"type":"integer"}}}}}},"output":{"type":"structure","members":{"errorEntries":{"shape":"S9"}}}},"BatchUpdateDetector":{"http":{"requestUri":"/detectors","responseCode":200},"input":{"type":"structure","required":["detectors"],"members":{"detectors":{"type":"list","member":{"type":"structure","required":["messageId","detectorModelName","state"],"members":{"messageId":{},"detectorModelName":{},"keyValue":{},"state":{"type":"structure","required":["stateName","variables","timers"],"members":{"stateName":{},"variables":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"timers":{"type":"list","member":{"type":"structure","required":["name","seconds"],"members":{"name":{},"seconds":{"type":"integer"}}}}}}}}}}},"output":{"type":"structure","members":{"batchUpdateDetectorErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"DescribeAlarm":{"http":{"method":"GET","requestUri":"/alarms/{alarmModelName}/keyValues/"},"input":{"type":"structure","required":["alarmModelName"],"members":{"alarmModelName":{"location":"uri","locationName":"alarmModelName"},"keyValue":{"location":"querystring","locationName":"keyValue"}}},"output":{"type":"structure","members":{"alarm":{"type":"structure","members":{"alarmModelName":{},"alarmModelVersion":{},"keyValue":{},"alarmState":{"type":"structure","members":{"stateName":{},"ruleEvaluation":{"type":"structure","members":{"simpleRuleEvaluation":{"type":"structure","members":{"inputPropertyValue":{},"operator":{},"thresholdValue":{}}}}},"customerAction":{"type":"structure","members":{"actionName":{},"snoozeActionConfiguration":{"type":"structure","members":{"snoozeDuration":{"type":"integer"},"note":{}}},"enableActionConfiguration":{"type":"structure","members":{"note":{}}},"disableActionConfiguration":{"type":"structure","members":{"note":{}}},"acknowledgeActionConfiguration":{"type":"structure","members":{"note":{}}},"resetActionConfiguration":{"type":"structure","members":{"note":{}}}}},"systemEvent":{"type":"structure","members":{"eventType":{},"stateChangeConfiguration":{"type":"structure","members":{"triggerType":{}}}}}}},"severity":{"type":"integer"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"DescribeDetector":{"http":{"method":"GET","requestUri":"/detectors/{detectorModelName}/keyValues/"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"keyValue":{"location":"querystring","locationName":"keyValue"}}},"output":{"type":"structure","members":{"detector":{"type":"structure","members":{"detectorModelName":{},"keyValue":{},"detectorModelVersion":{},"state":{"type":"structure","required":["stateName","variables","timers"],"members":{"stateName":{},"variables":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"timers":{"type":"list","member":{"type":"structure","required":["name","timestamp"],"members":{"name":{},"timestamp":{"type":"timestamp"}}}}}},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"ListAlarms":{"http":{"method":"GET","requestUri":"/alarms/{alarmModelName}"},"input":{"type":"structure","required":["alarmModelName"],"members":{"alarmModelName":{"location":"uri","locationName":"alarmModelName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"alarmSummaries":{"type":"list","member":{"type":"structure","members":{"alarmModelName":{},"alarmModelVersion":{},"keyValue":{},"stateName":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDetectors":{"http":{"method":"GET","requestUri":"/detectors/{detectorModelName}"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"stateName":{"location":"querystring","locationName":"stateName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"detectorSummaries":{"type":"list","member":{"type":"structure","members":{"detectorModelName":{},"keyValue":{},"detectorModelVersion":{},"state":{"type":"structure","members":{"stateName":{}}},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","members":{"requestId":{},"errorCode":{},"errorMessage":{}}}}}}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['personalize'] = {};
	AWS.Personalize = Service.defineService('personalize', ['2018-05-22']);
	Object.defineProperty(apiLoader.services['personalize'], '2018-05-22', {
	  get: function get() {
	    var model = __webpack_require__(749);
	    model.paginators = __webpack_require__(750).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Personalize;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Personalize","serviceId":"Personalize","signatureVersion":"v4","signingName":"personalize","targetPrefix":"AmazonPersonalize","uid":"personalize-2018-05-22"},"operations":{"CreateBatchInferenceJob":{"input":{"type":"structure","required":["jobName","solutionVersionArn","jobInput","jobOutput","roleArn"],"members":{"jobName":{},"solutionVersionArn":{},"filterArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"S5"},"jobOutput":{"shape":"S9"},"roleArn":{},"batchInferenceJobConfig":{"shape":"Sb"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"batchInferenceJobArn":{}}}},"CreateBatchSegmentJob":{"input":{"type":"structure","required":["jobName","solutionVersionArn","jobInput","jobOutput","roleArn"],"members":{"jobName":{},"solutionVersionArn":{},"filterArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"Sl"},"jobOutput":{"shape":"Sm"},"roleArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"batchSegmentJobArn":{}}}},"CreateCampaign":{"input":{"type":"structure","required":["name","solutionVersionArn"],"members":{"name":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Sq"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true},"CreateDataset":{"input":{"type":"structure","required":["name","schemaArn","datasetGroupArn","datasetType"],"members":{"name":{},"schemaArn":{},"datasetGroupArn":{},"datasetType":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetArn":{}}},"idempotent":true},"CreateDatasetExportJob":{"input":{"type":"structure","required":["jobName","datasetArn","roleArn","jobOutput"],"members":{"jobName":{},"datasetArn":{},"ingestionMode":{},"roleArn":{},"jobOutput":{"shape":"Sx"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetExportJobArn":{}}},"idempotent":true},"CreateDatasetGroup":{"input":{"type":"structure","required":["name"],"members":{"name":{},"roleArn":{},"kmsKeyArn":{},"domain":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetGroupArn":{},"domain":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["jobName","datasetArn","dataSource","roleArn"],"members":{"jobName":{},"datasetArn":{},"dataSource":{"shape":"S13"},"roleArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetImportJobArn":{}}}},"CreateEventTracker":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"datasetGroupArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"eventTrackerArn":{},"trackingId":{}}},"idempotent":true},"CreateFilter":{"input":{"type":"structure","required":["name","datasetGroupArn","filterExpression"],"members":{"name":{},"datasetGroupArn":{},"filterExpression":{"shape":"S19"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"filterArn":{}}}},"CreateRecommender":{"input":{"type":"structure","required":["name","datasetGroupArn","recipeArn"],"members":{"name":{},"datasetGroupArn":{},"recipeArn":{},"recommenderConfig":{"shape":"S1c"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true},"CreateSchema":{"input":{"type":"structure","required":["name","schema"],"members":{"name":{},"schema":{},"domain":{}}},"output":{"type":"structure","members":{"schemaArn":{}}},"idempotent":true},"CreateSolution":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"S1l"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"solutionArn":{}}}},"CreateSolutionVersion":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{},"trainingMode":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"solutionVersionArn":{}}}},"DeleteCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"idempotent":true},"DeleteDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"idempotent":true},"DeleteEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"idempotent":true},"DeleteFilter":{"input":{"type":"structure","required":["filterArn"],"members":{"filterArn":{}}}},"DeleteRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"idempotent":true},"DeleteSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"idempotent":true},"DeleteSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"idempotent":true},"DescribeAlgorithm":{"input":{"type":"structure","required":["algorithmArn"],"members":{"algorithmArn":{}}},"output":{"type":"structure","members":{"algorithm":{"type":"structure","members":{"name":{},"algorithmArn":{},"algorithmImage":{"type":"structure","required":["dockerURI"],"members":{"name":{},"dockerURI":{}}},"defaultHyperParameters":{"shape":"Sc"},"defaultHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"},"isTunable":{"type":"boolean"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"},"isTunable":{"type":"boolean"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S25"},"isTunable":{"type":"boolean"}}}}}},"defaultResourceConfig":{"type":"map","key":{},"value":{}},"trainingInputMode":{},"roleArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeBatchInferenceJob":{"input":{"type":"structure","required":["batchInferenceJobArn"],"members":{"batchInferenceJobArn":{}}},"output":{"type":"structure","members":{"batchInferenceJob":{"type":"structure","members":{"jobName":{},"batchInferenceJobArn":{},"filterArn":{},"failureReason":{},"solutionVersionArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"S5"},"jobOutput":{"shape":"S9"},"batchInferenceJobConfig":{"shape":"Sb"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeBatchSegmentJob":{"input":{"type":"structure","required":["batchSegmentJobArn"],"members":{"batchSegmentJobArn":{}}},"output":{"type":"structure","members":{"batchSegmentJob":{"type":"structure","members":{"jobName":{},"batchSegmentJobArn":{},"filterArn":{},"failureReason":{},"solutionVersionArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"Sl"},"jobOutput":{"shape":"Sm"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"output":{"type":"structure","members":{"campaign":{"type":"structure","members":{"name":{},"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Sq"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestCampaignUpdate":{"type":"structure","members":{"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Sq"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetGroupArn":{},"datasetType":{},"schemaArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeDatasetExportJob":{"input":{"type":"structure","required":["datasetExportJobArn"],"members":{"datasetExportJobArn":{}}},"output":{"type":"structure","members":{"datasetExportJob":{"type":"structure","members":{"jobName":{},"datasetExportJobArn":{},"datasetArn":{},"ingestionMode":{},"roleArn":{},"status":{},"jobOutput":{"shape":"Sx"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"output":{"type":"structure","members":{"datasetGroup":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"roleArn":{},"kmsKeyArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"domain":{}}}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["datasetImportJobArn"],"members":{"datasetImportJobArn":{}}},"output":{"type":"structure","members":{"datasetImportJob":{"type":"structure","members":{"jobName":{},"datasetImportJobArn":{},"datasetArn":{},"dataSource":{"shape":"S13"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"output":{"type":"structure","members":{"eventTracker":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"accountId":{},"trackingId":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeFeatureTransformation":{"input":{"type":"structure","required":["featureTransformationArn"],"members":{"featureTransformationArn":{}}},"output":{"type":"structure","members":{"featureTransformation":{"type":"structure","members":{"name":{},"featureTransformationArn":{},"defaultParameters":{"type":"map","key":{},"value":{}},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{}}}}},"idempotent":true},"DescribeFilter":{"input":{"type":"structure","required":["filterArn"],"members":{"filterArn":{}}},"output":{"type":"structure","members":{"filter":{"type":"structure","members":{"name":{},"filterArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"datasetGroupArn":{},"failureReason":{},"filterExpression":{"shape":"S19"},"status":{}}}}},"idempotent":true},"DescribeRecipe":{"input":{"type":"structure","required":["recipeArn"],"members":{"recipeArn":{}}},"output":{"type":"structure","members":{"recipe":{"type":"structure","members":{"name":{},"recipeArn":{},"algorithmArn":{},"featureTransformationArn":{},"status":{},"description":{},"creationDateTime":{"type":"timestamp"},"recipeType":{},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"output":{"type":"structure","members":{"recommender":{"type":"structure","members":{"recommenderArn":{},"datasetGroupArn":{},"name":{},"recipeArn":{},"recommenderConfig":{"shape":"S1c"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{},"failureReason":{},"latestRecommenderUpdate":{"type":"structure","members":{"recommenderConfig":{"shape":"S1c"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{},"failureReason":{}}}}}}},"idempotent":true},"DescribeSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"output":{"type":"structure","members":{"schema":{"type":"structure","members":{"name":{},"schemaArn":{},"schema":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"domain":{}}}}},"idempotent":true},"DescribeSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"output":{"type":"structure","members":{"solution":{"type":"structure","members":{"name":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"S1l"},"autoMLResult":{"type":"structure","members":{"bestRecipeArn":{}}},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestSolutionVersion":{"shape":"S4l"}}}}},"idempotent":true},"DescribeSolutionVersion":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersion":{"type":"structure","members":{"solutionVersionArn":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"eventType":{},"datasetGroupArn":{},"solutionConfig":{"shape":"S1l"},"trainingHours":{"type":"double"},"trainingMode":{},"tunedHPOParams":{"type":"structure","members":{"algorithmHyperParameters":{"shape":"Sc"}}},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"GetSolutionMetrics":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersionArn":{},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"ListBatchInferenceJobs":{"input":{"type":"structure","members":{"solutionVersionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"batchInferenceJobs":{"type":"list","member":{"type":"structure","members":{"batchInferenceJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"solutionVersionArn":{}}}},"nextToken":{}}},"idempotent":true},"ListBatchSegmentJobs":{"input":{"type":"structure","members":{"solutionVersionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"batchSegmentJobs":{"type":"list","member":{"type":"structure","members":{"batchSegmentJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"solutionVersionArn":{}}}},"nextToken":{}}},"idempotent":true},"ListCampaigns":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"campaigns":{"type":"list","member":{"type":"structure","members":{"name":{},"campaignArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetExportJobs":{"input":{"type":"structure","members":{"datasetArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetExportJobs":{"type":"list","member":{"type":"structure","members":{"datasetExportJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetGroups":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"domain":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"datasetArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetImportJobs":{"type":"list","member":{"type":"structure","members":{"datasetImportJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasets":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetType":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListEventTrackers":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTrackers":{"type":"list","member":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListFilters":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"name":{},"filterArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"datasetGroupArn":{},"failureReason":{},"status":{}}}},"nextToken":{}}},"idempotent":true},"ListRecipes":{"input":{"type":"structure","members":{"recipeProvider":{},"nextToken":{},"maxResults":{"type":"integer"},"domain":{}}},"output":{"type":"structure","members":{"recipes":{"type":"list","member":{"type":"structure","members":{"name":{},"recipeArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"domain":{}}}},"nextToken":{}}},"idempotent":true},"ListRecommenders":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"recommenders":{"type":"list","member":{"type":"structure","members":{"name":{},"recommenderArn":{},"datasetGroupArn":{},"recipeArn":{},"recommenderConfig":{"shape":"S1c"},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListSchemas":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"schemas":{"type":"list","member":{"type":"structure","members":{"name":{},"schemaArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"domain":{}}}},"nextToken":{}}},"idempotent":true},"ListSolutionVersions":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutionVersions":{"type":"list","member":{"shape":"S4l"}},"nextToken":{}}},"idempotent":true},"ListSolutions":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutions":{"type":"list","member":{"type":"structure","members":{"name":{},"solutionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sf"}}}},"StartRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true},"StopRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true},"StopSolutionVersionCreation":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Sq"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true},"UpdateRecommender":{"input":{"type":"structure","required":["recommenderArn","recommenderConfig"],"members":{"recommenderArn":{},"recommenderConfig":{"shape":"S1c"}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true}},"shapes":{"S5":{"type":"structure","required":["s3DataSource"],"members":{"s3DataSource":{"shape":"S6"}}},"S6":{"type":"structure","required":["path"],"members":{"path":{},"kmsKeyArn":{}}},"S9":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"Sb":{"type":"structure","members":{"itemExplorationConfig":{"shape":"Sc"}}},"Sc":{"type":"map","key":{},"value":{}},"Sf":{"type":"list","member":{"type":"structure","required":["tagKey","tagValue"],"members":{"tagKey":{},"tagValue":{}}}},"Sl":{"type":"structure","required":["s3DataSource"],"members":{"s3DataSource":{"shape":"S6"}}},"Sm":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"Sq":{"type":"structure","members":{"itemExplorationConfig":{"shape":"Sc"}}},"Sx":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"S13":{"type":"structure","members":{"dataLocation":{}}},"S19":{"type":"string","sensitive":true},"S1c":{"type":"structure","members":{"itemExplorationConfig":{"shape":"Sc"},"minRecommendationRequestsPerSecond":{"type":"integer"}}},"S1l":{"type":"structure","members":{"eventValueThreshold":{},"hpoConfig":{"type":"structure","members":{"hpoObjective":{"type":"structure","members":{"type":{},"metricName":{},"metricRegex":{}}},"hpoResourceConfig":{"type":"structure","members":{"maxNumberOfTrainingJobs":{},"maxParallelTrainingJobs":{}}},"algorithmHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S25"}}}}}}}},"algorithmHyperParameters":{"shape":"Sc"},"featureTransformationParameters":{"type":"map","key":{},"value":{}},"autoMLConfig":{"type":"structure","members":{"metricName":{},"recipeList":{"type":"list","member":{}}}},"optimizationObjective":{"type":"structure","members":{"itemAttribute":{},"objectiveSensitivity":{}}}}},"S25":{"type":"list","member":{}},"S4l":{"type":"structure","members":{"solutionVersionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBatchInferenceJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"batchInferenceJobs"},"ListBatchSegmentJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"batchSegmentJobs"},"ListCampaigns":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"campaigns"},"ListDatasetExportJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetExportJobs"},"ListDatasetGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetGroups"},"ListDatasetImportJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetImportJobs"},"ListDatasets":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasets"},"ListEventTrackers":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventTrackers"},"ListFilters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"Filters"},"ListRecipes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"recipes"},"ListRecommenders":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"recommenders"},"ListSchemas":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"schemas"},"ListSolutionVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutionVersions"},"ListSolutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutions"}}}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['personalizeevents'] = {};
	AWS.PersonalizeEvents = Service.defineService('personalizeevents', ['2018-03-22']);
	Object.defineProperty(apiLoader.services['personalizeevents'], '2018-03-22', {
	  get: function get() {
	    var model = __webpack_require__(752);
	    model.paginators = __webpack_require__(753).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.PersonalizeEvents;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-03-22","endpointPrefix":"personalize-events","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Events","serviceId":"Personalize Events","signatureVersion":"v4","signingName":"personalize","uid":"personalize-events-2018-03-22"},"operations":{"PutEvents":{"http":{"requestUri":"/events"},"input":{"type":"structure","required":["trackingId","sessionId","eventList"],"members":{"trackingId":{},"userId":{},"sessionId":{},"eventList":{"type":"list","member":{"type":"structure","required":["eventType","sentAt"],"members":{"eventId":{},"eventType":{},"eventValue":{"type":"float"},"itemId":{},"properties":{"jsonvalue":true},"sentAt":{"type":"timestamp"},"recommendationId":{},"impression":{"type":"list","member":{}}}}}}}},"PutItems":{"http":{"requestUri":"/items"},"input":{"type":"structure","required":["datasetArn","items"],"members":{"datasetArn":{},"items":{"type":"list","member":{"type":"structure","required":["itemId"],"members":{"itemId":{},"properties":{"jsonvalue":true}}}}}}},"PutUsers":{"http":{"requestUri":"/users"},"input":{"type":"structure","required":["datasetArn","users"],"members":{"datasetArn":{},"users":{"type":"list","member":{"type":"structure","required":["userId"],"members":{"userId":{},"properties":{"jsonvalue":true}}}}}}}},"shapes":{}}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['personalizeruntime'] = {};
	AWS.PersonalizeRuntime = Service.defineService('personalizeruntime', ['2018-05-22']);
	Object.defineProperty(apiLoader.services['personalizeruntime'], '2018-05-22', {
	  get: function get() {
	    var model = __webpack_require__(755);
	    model.paginators = __webpack_require__(756).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.PersonalizeRuntime;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize-runtime","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Runtime","serviceId":"Personalize Runtime","signatureVersion":"v4","signingName":"personalize","uid":"personalize-runtime-2018-05-22"},"operations":{"GetPersonalizedRanking":{"http":{"requestUri":"/personalize-ranking"},"input":{"type":"structure","required":["campaignArn","inputList","userId"],"members":{"campaignArn":{},"inputList":{"type":"list","member":{}},"userId":{},"context":{"shape":"S6"},"filterArn":{},"filterValues":{"shape":"S9"}}},"output":{"type":"structure","members":{"personalizedRanking":{"shape":"Sd"},"recommendationId":{}}},"idempotent":true},"GetRecommendations":{"http":{"requestUri":"/recommendations"},"input":{"type":"structure","members":{"campaignArn":{},"itemId":{},"userId":{},"numResults":{"type":"integer"},"context":{"shape":"S6"},"filterArn":{},"filterValues":{"shape":"S9"},"recommenderArn":{}}},"output":{"type":"structure","members":{"itemList":{"shape":"Sd"},"recommendationId":{}}},"idempotent":true}},"shapes":{"S6":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"S9":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"Sd":{"type":"list","member":{"type":"structure","members":{"itemId":{},"score":{"type":"double"}}}}}}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['applicationinsights'] = {};
	AWS.ApplicationInsights = Service.defineService('applicationinsights', ['2018-11-25']);
	Object.defineProperty(apiLoader.services['applicationinsights'], '2018-11-25', {
	  get: function get() {
	    var model = __webpack_require__(758);
	    model.paginators = __webpack_require__(759).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ApplicationInsights;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-25","endpointPrefix":"applicationinsights","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Application Insights","serviceFullName":"Amazon CloudWatch Application Insights","serviceId":"Application Insights","signatureVersion":"v4","signingName":"applicationinsights","targetPrefix":"EC2WindowsBarleyService","uid":"application-insights-2018-11-25"},"operations":{"CreateApplication":{"input":{"type":"structure","members":{"ResourceGroupName":{},"OpsCenterEnabled":{"type":"boolean"},"CWEMonitorEnabled":{"type":"boolean"},"OpsItemSNSTopicArn":{},"Tags":{"shape":"S6"},"AutoConfigEnabled":{"type":"boolean"},"AutoCreate":{"type":"boolean"}}},"output":{"type":"structure","members":{"ApplicationInfo":{"shape":"Sd"}}}},"CreateComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName","ResourceList"],"members":{"ResourceGroupName":{},"ComponentName":{},"ResourceList":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"CreateLogPattern":{"input":{"type":"structure","required":["ResourceGroupName","PatternSetName","PatternName","Pattern","Rank"],"members":{"ResourceGroupName":{},"PatternSetName":{},"PatternName":{},"Pattern":{},"Rank":{"type":"integer"}}},"output":{"type":"structure","members":{"LogPattern":{"shape":"Ss"},"ResourceGroupName":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{}}},"output":{"type":"structure","members":{}}},"DeleteComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{}}},"output":{"type":"structure","members":{}}},"DeleteLogPattern":{"input":{"type":"structure","required":["ResourceGroupName","PatternSetName","PatternName"],"members":{"ResourceGroupName":{},"PatternSetName":{},"PatternName":{}}},"output":{"type":"structure","members":{}}},"DescribeApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{}}},"output":{"type":"structure","members":{"ApplicationInfo":{"shape":"Sd"}}}},"DescribeComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{}}},"output":{"type":"structure","members":{"ApplicationComponent":{"shape":"S14"},"ResourceList":{"shape":"Sj"}}}},"DescribeComponentConfiguration":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{}}},"output":{"type":"structure","members":{"Monitor":{"type":"boolean"},"Tier":{},"ComponentConfiguration":{}}}},"DescribeComponentConfigurationRecommendation":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName","Tier"],"members":{"ResourceGroupName":{},"ComponentName":{},"Tier":{}}},"output":{"type":"structure","members":{"ComponentConfiguration":{}}}},"DescribeLogPattern":{"input":{"type":"structure","required":["ResourceGroupName","PatternSetName","PatternName"],"members":{"ResourceGroupName":{},"PatternSetName":{},"PatternName":{}}},"output":{"type":"structure","members":{"ResourceGroupName":{},"LogPattern":{"shape":"Ss"}}}},"DescribeObservation":{"input":{"type":"structure","required":["ObservationId"],"members":{"ObservationId":{}}},"output":{"type":"structure","members":{"Observation":{"shape":"S1n"}}}},"DescribeProblem":{"input":{"type":"structure","required":["ProblemId"],"members":{"ProblemId":{}}},"output":{"type":"structure","members":{"Problem":{"shape":"S2z"}}}},"DescribeProblemObservations":{"input":{"type":"structure","required":["ProblemId"],"members":{"ProblemId":{}}},"output":{"type":"structure","members":{"RelatedObservations":{"type":"structure","members":{"ObservationList":{"type":"list","member":{"shape":"S1n"}}}}}}},"ListApplications":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationInfoList":{"type":"list","member":{"shape":"Sd"}},"NextToken":{}}}},"ListComponents":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationComponentList":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"ListConfigurationHistory":{"input":{"type":"structure","members":{"ResourceGroupName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EventStatus":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EventList":{"type":"list","member":{"type":"structure","members":{"MonitoredResourceARN":{},"EventStatus":{},"EventResourceType":{},"EventTime":{"type":"timestamp"},"EventDetail":{},"EventResourceName":{}}}},"NextToken":{}}}},"ListLogPatternSets":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceGroupName":{},"LogPatternSets":{"type":"list","member":{}},"NextToken":{}}}},"ListLogPatterns":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"PatternSetName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceGroupName":{},"LogPatterns":{"type":"list","member":{"shape":"Ss"}},"NextToken":{}}}},"ListProblems":{"input":{"type":"structure","members":{"ResourceGroupName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{},"ComponentName":{}}},"output":{"type":"structure","members":{"ProblemList":{"type":"list","member":{"shape":"S2z"}},"NextToken":{},"ResourceGroupName":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"OpsCenterEnabled":{"type":"boolean"},"CWEMonitorEnabled":{"type":"boolean"},"OpsItemSNSTopicArn":{},"RemoveSNSTopic":{"type":"boolean"},"AutoConfigEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"ApplicationInfo":{"shape":"Sd"}}}},"UpdateComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{},"NewComponentName":{},"ResourceList":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"UpdateComponentConfiguration":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{},"Monitor":{"type":"boolean"},"Tier":{},"ComponentConfiguration":{},"AutoConfigEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateLogPattern":{"input":{"type":"structure","required":["ResourceGroupName","PatternSetName","PatternName"],"members":{"ResourceGroupName":{},"PatternSetName":{},"PatternName":{},"Pattern":{},"Rank":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceGroupName":{},"LogPattern":{"shape":"Ss"}}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"ResourceGroupName":{},"LifeCycle":{},"OpsItemSNSTopicArn":{},"OpsCenterEnabled":{"type":"boolean"},"CWEMonitorEnabled":{"type":"boolean"},"Remarks":{},"AutoConfigEnabled":{"type":"boolean"},"DiscoveryType":{}}},"Sj":{"type":"list","member":{}},"Ss":{"type":"structure","members":{"PatternSetName":{},"PatternName":{},"Pattern":{},"Rank":{"type":"integer"}}},"S14":{"type":"structure","members":{"ComponentName":{},"ComponentRemarks":{},"ResourceType":{},"OsType":{},"Tier":{},"Monitor":{"type":"boolean"},"DetectedWorkload":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{}}}}},"S1n":{"type":"structure","members":{"Id":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SourceType":{},"SourceARN":{},"LogGroup":{},"LineTime":{"type":"timestamp"},"LogText":{},"LogFilter":{},"MetricNamespace":{},"MetricName":{},"Unit":{},"Value":{"type":"double"},"CloudWatchEventId":{},"CloudWatchEventSource":{},"CloudWatchEventDetailType":{},"HealthEventArn":{},"HealthService":{},"HealthEventTypeCode":{},"HealthEventTypeCategory":{},"HealthEventDescription":{},"CodeDeployDeploymentId":{},"CodeDeployDeploymentGroup":{},"CodeDeployState":{},"CodeDeployApplication":{},"CodeDeployInstanceGroupId":{},"Ec2State":{},"RdsEventCategories":{},"RdsEventMessage":{},"S3EventName":{},"StatesExecutionArn":{},"StatesArn":{},"StatesStatus":{},"StatesInput":{},"EbsEvent":{},"EbsResult":{},"EbsCause":{},"EbsRequestId":{},"XRayFaultPercent":{"type":"integer"},"XRayThrottlePercent":{"type":"integer"},"XRayErrorPercent":{"type":"integer"},"XRayRequestCount":{"type":"integer"},"XRayRequestAverageLatency":{"type":"long"},"XRayNodeName":{},"XRayNodeType":{}}},"S2z":{"type":"structure","members":{"Id":{},"Title":{},"Insights":{},"Status":{},"AffectedResource":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SeverityLevel":{},"ResourceGroupName":{},"Feedback":{"type":"map","key":{},"value":{}},"RecurringCount":{"type":"long"},"LastRecurrenceTime":{"type":"timestamp"}}}}}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListComponents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListConfigurationHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLogPatternSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLogPatterns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProblems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['servicequotas'] = {};
	AWS.ServiceQuotas = Service.defineService('servicequotas', ['2019-06-24']);
	Object.defineProperty(apiLoader.services['servicequotas'], '2019-06-24', {
	  get: function get() {
	    var model = __webpack_require__(761);
	    model.paginators = __webpack_require__(762).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ServiceQuotas;


/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-06-24","endpointPrefix":"servicequotas","jsonVersion":"1.1","protocol":"json","serviceFullName":"Service Quotas","serviceId":"Service Quotas","signatureVersion":"v4","targetPrefix":"ServiceQuotasV20190624","uid":"service-quotas-2019-06-24"},"operations":{"AssociateServiceQuotaTemplate":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteServiceQuotaIncreaseRequestFromTemplate":{"input":{"type":"structure","required":["ServiceCode","QuotaCode","AwsRegion"],"members":{"ServiceCode":{},"QuotaCode":{},"AwsRegion":{}}},"output":{"type":"structure","members":{}}},"DisassociateServiceQuotaTemplate":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"GetAWSDefaultServiceQuota":{"input":{"type":"structure","required":["ServiceCode","QuotaCode"],"members":{"ServiceCode":{},"QuotaCode":{}}},"output":{"type":"structure","members":{"Quota":{"shape":"Sc"}}}},"GetAssociationForServiceQuotaTemplate":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ServiceQuotaTemplateAssociationStatus":{}}}},"GetRequestedServiceQuotaChange":{"input":{"type":"structure","required":["RequestId"],"members":{"RequestId":{}}},"output":{"type":"structure","members":{"RequestedQuota":{"shape":"S13"}}}},"GetServiceQuota":{"input":{"type":"structure","required":["ServiceCode","QuotaCode"],"members":{"ServiceCode":{},"QuotaCode":{}}},"output":{"type":"structure","members":{"Quota":{"shape":"Sc"}}}},"GetServiceQuotaIncreaseRequestFromTemplate":{"input":{"type":"structure","required":["ServiceCode","QuotaCode","AwsRegion"],"members":{"ServiceCode":{},"QuotaCode":{},"AwsRegion":{}}},"output":{"type":"structure","members":{"ServiceQuotaIncreaseRequestInTemplate":{"shape":"S1c"}}}},"ListAWSDefaultServiceQuotas":{"input":{"type":"structure","required":["ServiceCode"],"members":{"ServiceCode":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Quotas":{"shape":"S1h"}}}},"ListRequestedServiceQuotaChangeHistory":{"input":{"type":"structure","members":{"ServiceCode":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RequestedQuotas":{"shape":"S1k"}}}},"ListRequestedServiceQuotaChangeHistoryByQuota":{"input":{"type":"structure","required":["ServiceCode","QuotaCode"],"members":{"ServiceCode":{},"QuotaCode":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RequestedQuotas":{"shape":"S1k"}}}},"ListServiceQuotaIncreaseRequestsInTemplate":{"input":{"type":"structure","members":{"ServiceCode":{},"AwsRegion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ServiceQuotaIncreaseRequestInTemplateList":{"type":"list","member":{"shape":"S1c"}},"NextToken":{}}}},"ListServiceQuotas":{"input":{"type":"structure","required":["ServiceCode"],"members":{"ServiceCode":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Quotas":{"shape":"S1h"}}}},"ListServices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Services":{"type":"list","member":{"type":"structure","members":{"ServiceCode":{},"ServiceName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"type":"list","member":{"shape":"S20"}}}}},"PutServiceQuotaIncreaseRequestIntoTemplate":{"input":{"type":"structure","required":["QuotaCode","ServiceCode","AwsRegion","DesiredValue"],"members":{"QuotaCode":{},"ServiceCode":{},"AwsRegion":{},"DesiredValue":{"type":"double"}}},"output":{"type":"structure","members":{"ServiceQuotaIncreaseRequestInTemplate":{"shape":"S1c"}}}},"RequestServiceQuotaIncrease":{"input":{"type":"structure","required":["ServiceCode","QuotaCode","DesiredValue"],"members":{"ServiceCode":{},"QuotaCode":{},"DesiredValue":{"type":"double"}}},"output":{"type":"structure","members":{"RequestedQuota":{"shape":"S13"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"type":"list","member":{"shape":"S20"}}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sc":{"type":"structure","members":{"ServiceCode":{},"ServiceName":{},"QuotaArn":{},"QuotaCode":{},"QuotaName":{},"Value":{"type":"double"},"Unit":{},"Adjustable":{"type":"boolean"},"GlobalQuota":{"type":"boolean"},"UsageMetric":{"type":"structure","members":{"MetricNamespace":{},"MetricName":{},"MetricDimensions":{"type":"map","key":{},"value":{}},"MetricStatisticRecommendation":{}}},"Period":{"type":"structure","members":{"PeriodValue":{"type":"integer"},"PeriodUnit":{}}},"ErrorReason":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}},"S13":{"type":"structure","members":{"Id":{},"CaseId":{},"ServiceCode":{},"ServiceName":{},"QuotaCode":{},"QuotaName":{},"DesiredValue":{"type":"double"},"Status":{},"Created":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Requester":{},"QuotaArn":{},"GlobalQuota":{"type":"boolean"},"Unit":{}}},"S1c":{"type":"structure","members":{"ServiceCode":{},"ServiceName":{},"QuotaCode":{},"QuotaName":{},"DesiredValue":{"type":"double"},"AwsRegion":{},"Unit":{},"GlobalQuota":{"type":"boolean"}}},"S1h":{"type":"list","member":{"shape":"Sc"}},"S1k":{"type":"list","member":{"shape":"S13"}},"S20":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAWSDefaultServiceQuotas":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Quotas"},"ListRequestedServiceQuotaChangeHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RequestedQuotas"},"ListRequestedServiceQuotaChangeHistoryByQuota":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RequestedQuotas"},"ListServiceQuotaIncreaseRequestsInTemplate":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServiceQuotaIncreaseRequestInTemplateList"},"ListServiceQuotas":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Quotas"},"ListServices":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Services"}}}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ec2instanceconnect'] = {};
	AWS.EC2InstanceConnect = Service.defineService('ec2instanceconnect', ['2018-04-02']);
	Object.defineProperty(apiLoader.services['ec2instanceconnect'], '2018-04-02', {
	  get: function get() {
	    var model = __webpack_require__(764);
	    model.paginators = __webpack_require__(765).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EC2InstanceConnect;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-04-02","endpointPrefix":"ec2-instance-connect","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"EC2 Instance Connect","serviceFullName":"AWS EC2 Instance Connect","serviceId":"EC2 Instance Connect","signatureVersion":"v4","targetPrefix":"AWSEC2InstanceConnectService","uid":"ec2-instance-connect-2018-04-02"},"operations":{"SendSSHPublicKey":{"input":{"type":"structure","required":["InstanceId","InstanceOSUser","SSHPublicKey"],"members":{"InstanceId":{},"InstanceOSUser":{},"SSHPublicKey":{},"AvailabilityZone":{}}},"output":{"type":"structure","members":{"RequestId":{},"Success":{"type":"boolean"}}}},"SendSerialConsoleSSHPublicKey":{"input":{"type":"structure","required":["InstanceId","SSHPublicKey"],"members":{"InstanceId":{},"SerialPort":{"type":"integer"},"SSHPublicKey":{}}},"output":{"type":"structure","members":{"RequestId":{},"Success":{"type":"boolean"}}}}},"shapes":{}}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['eventbridge'] = {};
	AWS.EventBridge = Service.defineService('eventbridge', ['2015-10-07']);
	__webpack_require__(767);
	Object.defineProperty(apiLoader.services['eventbridge'], '2015-10-07', {
	  get: function get() {
	    var model = __webpack_require__(768);
	    model.paginators = __webpack_require__(769).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EventBridge;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);

	AWS.util.update(AWS.EventBridge.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'putEvents') {
	      var params = request.params || {};
	      if (params.EndpointId !== undefined) {
	        throw new AWS.util.error(new Error(), {
	          code: 'InvalidParameter',
	          message: 'EndpointId is not supported in current SDK.\n' +
	            'You should consider switching to V3(https://github.com/aws/aws-sdk-js-v3).'
	        });
	      }
	    }
	  },
	});


/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon EventBridge","serviceId":"EventBridge","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"eventbridge-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CancelReplay":{"input":{"type":"structure","required":["ReplayName"],"members":{"ReplayName":{}}},"output":{"type":"structure","members":{"ReplayArn":{},"State":{},"StateReason":{}}}},"CreateApiDestination":{"input":{"type":"structure","required":["Name","ConnectionArn","InvocationEndpoint","HttpMethod"],"members":{"Name":{},"Description":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"ApiDestinationState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"CreateArchive":{"input":{"type":"structure","required":["ArchiveName","EventSourceArn"],"members":{"ArchiveName":{},"EventSourceArn":{},"Description":{},"EventPattern":{},"RetentionDays":{"type":"integer"}}},"output":{"type":"structure","members":{"ArchiveArn":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"}}}},"CreateConnection":{"input":{"type":"structure","required":["Name","AuthorizationType","AuthParameters"],"members":{"Name":{},"Description":{},"AuthorizationType":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"OAuthParameters":{"type":"structure","required":["ClientParameters","AuthorizationEndpoint","HttpMethod"],"members":{"ClientParameters":{"type":"structure","required":["ClientID","ClientSecret"],"members":{"ClientID":{},"ClientSecret":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S14"}}},"ApiKeyAuthParameters":{"type":"structure","required":["ApiKeyName","ApiKeyValue"],"members":{"ApiKeyName":{},"ApiKeyValue":{}}},"InvocationHttpParameters":{"shape":"S14"}}}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"CreateEndpoint":{"input":{"type":"structure","required":["Name","RoutingConfig","EventBuses"],"members":{"Name":{},"Description":{},"RoutingConfig":{"shape":"S1n"},"ReplicationConfig":{"shape":"S1t"},"EventBuses":{"shape":"S1v"},"RoleArn":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"RoutingConfig":{"shape":"S1n"},"ReplicationConfig":{"shape":"S1t"},"EventBuses":{"shape":"S1v"},"RoleArn":{},"State":{}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{},"Tags":{"shape":"S24"}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeauthorizeConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DeleteApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{}}},"output":{"type":"structure","members":{}}},"DeleteConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"Name":{},"Description":{},"ApiDestinationState":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"DescribeArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{}}},"output":{"type":"structure","members":{"ArchiveArn":{},"ArchiveName":{},"EventSourceArn":{},"Description":{},"EventPattern":{},"State":{},"StateReason":{},"RetentionDays":{"type":"integer"},"SizeBytes":{"type":"long"},"EventCount":{"type":"long"},"CreationTime":{"type":"timestamp"}}}},"DescribeConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"Name":{},"Description":{},"ConnectionState":{},"StateReason":{},"AuthorizationType":{},"SecretArn":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","members":{"Username":{}}},"OAuthParameters":{"type":"structure","members":{"ClientParameters":{"type":"structure","members":{"ClientID":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S14"}}},"ApiKeyAuthParameters":{"type":"structure","members":{"ApiKeyName":{}}},"InvocationHttpParameters":{"shape":"S14"}}},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DescribeEndpoint":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"HomeRegion":{}}},"output":{"type":"structure","members":{"Name":{},"Description":{},"Arn":{},"RoutingConfig":{"shape":"S1n"},"ReplicationConfig":{"shape":"S1t"},"EventBuses":{"shape":"S1v"},"RoleArn":{},"EndpointId":{},"EndpointUrl":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeReplay":{"input":{"type":"structure","required":["ReplayName"],"members":{"ReplayName":{}}},"output":{"type":"structure","members":{"ReplayName":{},"ReplayArn":{},"Description":{},"State":{},"StateReason":{},"EventSourceArn":{},"Destination":{"shape":"S3m"},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"EventLastReplayedTime":{"type":"timestamp"},"ReplayStartTime":{"type":"timestamp"},"ReplayEndTime":{"type":"timestamp"}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{},"CreatedBy":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListApiDestinations":{"input":{"type":"structure","members":{"NamePrefix":{},"ConnectionArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinations":{"type":"list","member":{"type":"structure","members":{"ApiDestinationArn":{},"Name":{},"ApiDestinationState":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListArchives":{"input":{"type":"structure","members":{"NamePrefix":{},"EventSourceArn":{},"State":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Archives":{"type":"list","member":{"type":"structure","members":{"ArchiveName":{},"EventSourceArn":{},"State":{},"StateReason":{},"RetentionDays":{"type":"integer"},"SizeBytes":{"type":"long"},"EventCount":{"type":"long"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListConnections":{"input":{"type":"structure","members":{"NamePrefix":{},"ConnectionState":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"type":"structure","members":{"ConnectionArn":{},"Name":{},"ConnectionState":{},"StateReason":{},"AuthorizationType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEndpoints":{"input":{"type":"structure","members":{"NamePrefix":{},"HomeRegion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"Name":{},"Description":{},"Arn":{},"RoutingConfig":{"shape":"S1n"},"ReplicationConfig":{"shape":"S1t"},"EventBuses":{"shape":"S1v"},"RoleArn":{},"EndpointId":{},"EndpointUrl":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListReplays":{"input":{"type":"structure","members":{"NamePrefix":{},"State":{},"EventSourceArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Replays":{"type":"list","member":{"type":"structure","members":{"ReplayName":{},"EventSourceArn":{},"State":{},"StateReason":{},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"EventLastReplayedTime":{"type":"timestamp"},"ReplayStartTime":{"type":"timestamp"},"ReplayEndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S24"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S5f"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S7d"},"DetailType":{},"Detail":{},"EventBusName":{},"TraceHeader":{}}}},"EndpointId":{}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S7d"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}},"Policy":{}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S24"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S5f"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","members":{"StatementId":{},"RemoveAllPermissions":{"type":"boolean"},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartReplay":{"input":{"type":"structure","required":["ReplayName","EventSourceArn","EventStartTime","EventEndTime","Destination"],"members":{"ReplayName":{},"Description":{},"EventSourceArn":{},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"Destination":{"shape":"S3m"}}},"output":{"type":"structure","members":{"ReplayArn":{},"State":{},"StateReason":{},"ReplayStartTime":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S24"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"ApiDestinationState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"UpdateArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{},"Description":{},"EventPattern":{},"RetentionDays":{"type":"integer"}}},"output":{"type":"structure","members":{"ArchiveArn":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"}}}},"UpdateConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"AuthorizationType":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","members":{"Username":{},"Password":{}}},"OAuthParameters":{"type":"structure","members":{"ClientParameters":{"type":"structure","members":{"ClientID":{},"ClientSecret":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S14"}}},"ApiKeyAuthParameters":{"type":"structure","members":{"ApiKeyName":{},"ApiKeyValue":{}}},"InvocationHttpParameters":{"shape":"S14"}}}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"UpdateEndpoint":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"RoutingConfig":{"shape":"S1n"},"ReplicationConfig":{"shape":"S1t"},"EventBuses":{"shape":"S1v"},"RoleArn":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"RoutingConfig":{"shape":"S1n"},"ReplicationConfig":{"shape":"S1t"},"EventBuses":{"shape":"S1v"},"RoleArn":{},"EndpointId":{},"EndpointUrl":{},"State":{}}}}},"shapes":{"S14":{"type":"structure","members":{"HeaderParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"IsValueSecret":{"type":"boolean"}}}},"QueryStringParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"IsValueSecret":{"type":"boolean"}}}},"BodyParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"IsValueSecret":{"type":"boolean"}}}}}},"S1n":{"type":"structure","required":["FailoverConfig"],"members":{"FailoverConfig":{"type":"structure","required":["Primary","Secondary"],"members":{"Primary":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{}}},"Secondary":{"type":"structure","required":["Route"],"members":{"Route":{}}}}}}},"S1t":{"type":"structure","members":{"State":{}}},"S1v":{"type":"list","member":{"type":"structure","required":["EventBusArn"],"members":{"EventBusArn":{}}}},"S24":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S3m":{"type":"structure","required":["Arn"],"members":{"Arn":{},"FilterArns":{"type":"list","member":{}}}},"S5f":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S61"},"SecurityGroups":{"shape":"S61"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{},"CapacityProviderStrategy":{"type":"list","member":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{},"weight":{"type":"integer"},"base":{"type":"integer"}}}},"EnableECSManagedTags":{"type":"boolean"},"EnableExecuteCommand":{"type":"boolean"},"PlacementConstraints":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"PlacementStrategy":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"PropagateTags":{},"ReferenceId":{},"Tags":{"shape":"S24"}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}},"HttpParameters":{"type":"structure","members":{"PathParameterValues":{"type":"list","member":{}},"HeaderParameters":{"type":"map","key":{},"value":{}},"QueryStringParameters":{"type":"map","key":{},"value":{}}}},"RedshiftDataParameters":{"type":"structure","required":["Database","Sql"],"members":{"SecretManagerArn":{},"Database":{},"DbUser":{},"Sql":{},"StatementName":{},"WithEvent":{"type":"boolean"}}},"SageMakerPipelineParameters":{"type":"structure","members":{"PipelineParameterList":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"DeadLetterConfig":{"type":"structure","members":{"Arn":{}}},"RetryPolicy":{"type":"structure","members":{"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"}}}}}},"S61":{"type":"list","member":{}},"S7d":{"type":"list","member":{}}}}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lakeformation'] = {};
	AWS.LakeFormation = Service.defineService('lakeformation', ['2017-03-31']);
	Object.defineProperty(apiLoader.services['lakeformation'], '2017-03-31', {
	  get: function get() {
	    var model = __webpack_require__(771);
	    model.paginators = __webpack_require__(772).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LakeFormation;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-31","endpointPrefix":"lakeformation","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Lake Formation","serviceId":"LakeFormation","signatureVersion":"v4","signingName":"lakeformation","uid":"lakeformation-2017-03-31"},"operations":{"AddLFTagsToResource":{"http":{"requestUri":"/AddLFTagsToResource"},"input":{"type":"structure","required":["Resource","LFTags"],"members":{"CatalogId":{},"Resource":{"shape":"S3"},"LFTags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"Failures":{"shape":"Sq"}}}},"BatchGrantPermissions":{"http":{"requestUri":"/BatchGrantPermissions"},"input":{"type":"structure","required":["Entries"],"members":{"CatalogId":{},"Entries":{"shape":"Sv"}}},"output":{"type":"structure","members":{"Failures":{"shape":"S13"}}}},"BatchRevokePermissions":{"http":{"requestUri":"/BatchRevokePermissions"},"input":{"type":"structure","required":["Entries"],"members":{"CatalogId":{},"Entries":{"shape":"Sv"}}},"output":{"type":"structure","members":{"Failures":{"shape":"S13"}}}},"CancelTransaction":{"http":{"requestUri":"/CancelTransaction"},"input":{"type":"structure","required":["TransactionId"],"members":{"TransactionId":{}}},"output":{"type":"structure","members":{}}},"CommitTransaction":{"http":{"requestUri":"/CommitTransaction"},"input":{"type":"structure","required":["TransactionId"],"members":{"TransactionId":{}}},"output":{"type":"structure","members":{"TransactionStatus":{}}}},"CreateDataCellsFilter":{"http":{"requestUri":"/CreateDataCellsFilter"},"input":{"type":"structure","required":["TableData"],"members":{"TableData":{"shape":"S1e"}}},"output":{"type":"structure","members":{}}},"CreateLFTag":{"http":{"requestUri":"/CreateLFTag"},"input":{"type":"structure","required":["TagKey","TagValues"],"members":{"CatalogId":{},"TagKey":{},"TagValues":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"DeleteDataCellsFilter":{"http":{"requestUri":"/DeleteDataCellsFilter"},"input":{"type":"structure","members":{"TableCatalogId":{},"DatabaseName":{},"TableName":{},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteLFTag":{"http":{"requestUri":"/DeleteLFTag"},"input":{"type":"structure","required":["TagKey"],"members":{"CatalogId":{},"TagKey":{}}},"output":{"type":"structure","members":{}}},"DeleteObjectsOnCancel":{"http":{"requestUri":"/DeleteObjectsOnCancel"},"input":{"type":"structure","required":["DatabaseName","TableName","TransactionId","Objects"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"TransactionId":{},"Objects":{"type":"list","member":{"type":"structure","required":["Uri"],"members":{"Uri":{},"ETag":{}}}}}},"output":{"type":"structure","members":{}}},"DeregisterResource":{"http":{"requestUri":"/DeregisterResource"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DescribeResource":{"http":{"requestUri":"/DescribeResource"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceInfo":{"shape":"S1z"}}}},"DescribeTransaction":{"http":{"requestUri":"/DescribeTransaction"},"input":{"type":"structure","required":["TransactionId"],"members":{"TransactionId":{}}},"output":{"type":"structure","members":{"TransactionDescription":{"shape":"S24"}}}},"ExtendTransaction":{"http":{"requestUri":"/ExtendTransaction"},"input":{"type":"structure","members":{"TransactionId":{}}},"output":{"type":"structure","members":{}}},"GetDataLakeSettings":{"http":{"requestUri":"/GetDataLakeSettings"},"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{"DataLakeSettings":{"shape":"S2a"}}}},"GetEffectivePermissionsForPath":{"http":{"requestUri":"/GetEffectivePermissionsForPath"},"input":{"type":"structure","required":["ResourceArn"],"members":{"CatalogId":{},"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"shape":"S2l"},"NextToken":{}}}},"GetLFTag":{"http":{"requestUri":"/GetLFTag"},"input":{"type":"structure","required":["TagKey"],"members":{"CatalogId":{},"TagKey":{}}},"output":{"type":"structure","members":{"CatalogId":{},"TagKey":{},"TagValues":{"shape":"Sg"}}}},"GetQueryState":{"http":{"requestUri":"/GetQueryState","responseCode":200},"input":{"type":"structure","required":["QueryId"],"members":{"QueryId":{}}},"output":{"type":"structure","required":["State"],"members":{"Error":{},"State":{}}},"endpoint":{"hostPrefix":"query-"}},"GetQueryStatistics":{"http":{"requestUri":"/GetQueryStatistics","responseCode":200},"input":{"type":"structure","required":["QueryId"],"members":{"QueryId":{}}},"output":{"type":"structure","members":{"ExecutionStatistics":{"type":"structure","members":{"AverageExecutionTimeMillis":{"type":"long"},"DataScannedBytes":{"type":"long"},"WorkUnitsExecutedCount":{"type":"long"}}},"PlanningStatistics":{"type":"structure","members":{"EstimatedDataToScanBytes":{"type":"long"},"PlanningTimeMillis":{"type":"long"},"QueueTimeMillis":{"type":"long"},"WorkUnitsGeneratedCount":{"type":"long"}}},"QuerySubmissionTime":{"type":"timestamp","timestampFormat":"iso8601"}}},"endpoint":{"hostPrefix":"query-"}},"GetResourceLFTags":{"http":{"requestUri":"/GetResourceLFTags"},"input":{"type":"structure","required":["Resource"],"members":{"CatalogId":{},"Resource":{"shape":"S3"},"ShowAssignedLFTags":{"type":"boolean"}}},"output":{"type":"structure","members":{"LFTagOnDatabase":{"shape":"Sn"},"LFTagsOnTable":{"shape":"Sn"},"LFTagsOnColumns":{"shape":"S39"}}}},"GetTableObjects":{"http":{"requestUri":"/GetTableObjects"},"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"TransactionId":{},"QueryAsOfTime":{"type":"timestamp"},"PartitionPredicate":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Objects":{"type":"list","member":{"type":"structure","members":{"PartitionValues":{"shape":"S3g"},"Objects":{"type":"list","member":{"type":"structure","members":{"Uri":{},"ETag":{},"Size":{"type":"long"}}}}}}},"NextToken":{}}}},"GetTemporaryGluePartitionCredentials":{"http":{"requestUri":"/GetTemporaryGluePartitionCredentials"},"input":{"type":"structure","required":["TableArn","Partition","SupportedPermissionTypes"],"members":{"TableArn":{},"Partition":{"type":"structure","required":["Values"],"members":{"Values":{"type":"list","member":{}}}},"Permissions":{"shape":"S10"},"DurationSeconds":{"type":"integer"},"AuditContext":{"shape":"S3q"},"SupportedPermissionTypes":{"shape":"S3s"}}},"output":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}},"GetTemporaryGlueTableCredentials":{"http":{"requestUri":"/GetTemporaryGlueTableCredentials"},"input":{"type":"structure","required":["TableArn","SupportedPermissionTypes"],"members":{"TableArn":{},"Permissions":{"shape":"S10"},"DurationSeconds":{"type":"integer"},"AuditContext":{"shape":"S3q"},"SupportedPermissionTypes":{"shape":"S3s"}}},"output":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}},"GetWorkUnitResults":{"http":{"requestUri":"/GetWorkUnitResults","responseCode":200},"input":{"type":"structure","required":["QueryId","WorkUnitId","WorkUnitToken"],"members":{"QueryId":{},"WorkUnitId":{"type":"long"},"WorkUnitToken":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"ResultStream":{"type":"blob","streaming":true}},"payload":"ResultStream"},"endpoint":{"hostPrefix":"data-"}},"GetWorkUnits":{"http":{"requestUri":"/GetWorkUnits","responseCode":200},"input":{"type":"structure","required":["QueryId"],"members":{"NextToken":{},"PageSize":{"type":"integer"},"QueryId":{}}},"output":{"type":"structure","required":["QueryId","WorkUnitRanges"],"members":{"NextToken":{},"QueryId":{},"WorkUnitRanges":{"type":"list","member":{"type":"structure","required":["WorkUnitIdMax","WorkUnitIdMin","WorkUnitToken"],"members":{"WorkUnitIdMax":{"type":"long"},"WorkUnitIdMin":{"type":"long"},"WorkUnitToken":{}}}}}},"endpoint":{"hostPrefix":"query-"}},"GrantPermissions":{"http":{"requestUri":"/GrantPermissions"},"input":{"type":"structure","required":["Principal","Resource","Permissions"],"members":{"CatalogId":{},"Principal":{"shape":"Sy"},"Resource":{"shape":"S3"},"Permissions":{"shape":"S10"},"PermissionsWithGrantOption":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"ListDataCellsFilter":{"http":{"requestUri":"/ListDataCellsFilter"},"input":{"type":"structure","members":{"Table":{"shape":"S7"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DataCellsFilters":{"type":"list","member":{"shape":"S1e"}},"NextToken":{}}}},"ListLFTags":{"http":{"requestUri":"/ListLFTags"},"input":{"type":"structure","members":{"CatalogId":{},"ResourceShareType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LFTags":{"shape":"Sn"},"NextToken":{}}}},"ListPermissions":{"http":{"requestUri":"/ListPermissions"},"input":{"type":"structure","members":{"CatalogId":{},"Principal":{"shape":"Sy"},"ResourceType":{},"Resource":{"shape":"S3"},"NextToken":{},"MaxResults":{"type":"integer"},"IncludeRelated":{}}},"output":{"type":"structure","members":{"PrincipalResourcePermissions":{"shape":"S2l"},"NextToken":{}}}},"ListResources":{"http":{"requestUri":"/ListResources"},"input":{"type":"structure","members":{"FilterConditionList":{"type":"list","member":{"type":"structure","members":{"Field":{},"ComparisonOperator":{},"StringValueList":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceInfoList":{"type":"list","member":{"shape":"S1z"}},"NextToken":{}}}},"ListTableStorageOptimizers":{"http":{"requestUri":"/ListTableStorageOptimizers"},"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"StorageOptimizerType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"StorageOptimizerList":{"type":"list","member":{"type":"structure","members":{"StorageOptimizerType":{},"Config":{"shape":"S56"},"ErrorMessage":{},"Warnings":{},"LastRunDetails":{}}}},"NextToken":{}}}},"ListTransactions":{"http":{"requestUri":"/ListTransactions"},"input":{"type":"structure","members":{"CatalogId":{},"StatusFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Transactions":{"type":"list","member":{"shape":"S24"}},"NextToken":{}}}},"PutDataLakeSettings":{"http":{"requestUri":"/PutDataLakeSettings"},"input":{"type":"structure","required":["DataLakeSettings"],"members":{"CatalogId":{},"DataLakeSettings":{"shape":"S2a"}}},"output":{"type":"structure","members":{}}},"RegisterResource":{"http":{"requestUri":"/RegisterResource"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"UseServiceLinkedRole":{"type":"boolean"},"RoleArn":{}}},"output":{"type":"structure","members":{}}},"RemoveLFTagsFromResource":{"http":{"requestUri":"/RemoveLFTagsFromResource"},"input":{"type":"structure","required":["Resource","LFTags"],"members":{"CatalogId":{},"Resource":{"shape":"S3"},"LFTags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"Failures":{"shape":"Sq"}}}},"RevokePermissions":{"http":{"requestUri":"/RevokePermissions"},"input":{"type":"structure","required":["Principal","Resource","Permissions"],"members":{"CatalogId":{},"Principal":{"shape":"Sy"},"Resource":{"shape":"S3"},"Permissions":{"shape":"S10"},"PermissionsWithGrantOption":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"SearchDatabasesByLFTags":{"http":{"requestUri":"/SearchDatabasesByLFTags"},"input":{"type":"structure","required":["Expression"],"members":{"NextToken":{},"MaxResults":{"type":"integer"},"CatalogId":{},"Expression":{"shape":"Sk"}}},"output":{"type":"structure","members":{"NextToken":{},"DatabaseList":{"type":"list","member":{"type":"structure","members":{"Database":{"shape":"S5"},"LFTags":{"shape":"Sn"}}}}}}},"SearchTablesByLFTags":{"http":{"requestUri":"/SearchTablesByLFTags"},"input":{"type":"structure","required":["Expression"],"members":{"NextToken":{},"MaxResults":{"type":"integer"},"CatalogId":{},"Expression":{"shape":"Sk"}}},"output":{"type":"structure","members":{"NextToken":{},"TableList":{"type":"list","member":{"type":"structure","members":{"Table":{"shape":"S7"},"LFTagOnDatabase":{"shape":"Sn"},"LFTagsOnTable":{"shape":"Sn"},"LFTagsOnColumns":{"shape":"S39"}}}}}}},"StartQueryPlanning":{"http":{"requestUri":"/StartQueryPlanning","responseCode":200},"input":{"type":"structure","required":["QueryPlanningContext","QueryString"],"members":{"QueryPlanningContext":{"type":"structure","required":["DatabaseName"],"members":{"CatalogId":{},"DatabaseName":{},"QueryAsOfTime":{"type":"timestamp"},"QueryParameters":{"type":"map","key":{},"value":{}},"TransactionId":{}}},"QueryString":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["QueryId"],"members":{"QueryId":{}}},"endpoint":{"hostPrefix":"query-"}},"StartTransaction":{"http":{"requestUri":"/StartTransaction"},"input":{"type":"structure","members":{"TransactionType":{}}},"output":{"type":"structure","members":{"TransactionId":{}}}},"UpdateLFTag":{"http":{"requestUri":"/UpdateLFTag"},"input":{"type":"structure","required":["TagKey"],"members":{"CatalogId":{},"TagKey":{},"TagValuesToDelete":{"shape":"Sg"},"TagValuesToAdd":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UpdateResource":{"http":{"requestUri":"/UpdateResource"},"input":{"type":"structure","required":["RoleArn","ResourceArn"],"members":{"RoleArn":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"UpdateTableObjects":{"http":{"requestUri":"/UpdateTableObjects"},"input":{"type":"structure","required":["DatabaseName","TableName","WriteOperations"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"TransactionId":{},"WriteOperations":{"type":"list","member":{"type":"structure","members":{"AddObject":{"type":"structure","required":["Uri","ETag","Size"],"members":{"Uri":{},"ETag":{},"Size":{"type":"long"},"PartitionValues":{"shape":"S3g"}}},"DeleteObject":{"type":"structure","required":["Uri"],"members":{"Uri":{},"ETag":{},"PartitionValues":{"shape":"S3g"}}}}}}}},"output":{"type":"structure","members":{}}},"UpdateTableStorageOptimizer":{"http":{"requestUri":"/UpdateTableStorageOptimizer"},"input":{"type":"structure","required":["DatabaseName","TableName","StorageOptimizerConfig"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"StorageOptimizerConfig":{"type":"map","key":{},"value":{"shape":"S56"}}}},"output":{"type":"structure","members":{"Result":{}}}}},"shapes":{"S3":{"type":"structure","members":{"Catalog":{"type":"structure","members":{}},"Database":{"shape":"S5"},"Table":{"shape":"S7"},"TableWithColumns":{"type":"structure","required":["DatabaseName","Name"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{},"ColumnNames":{"shape":"Sa"},"ColumnWildcard":{"shape":"Sb"}}},"DataLocation":{"type":"structure","required":["ResourceArn"],"members":{"CatalogId":{},"ResourceArn":{}}},"DataCellsFilter":{"type":"structure","members":{"TableCatalogId":{},"DatabaseName":{},"TableName":{},"Name":{}}},"LFTag":{"type":"structure","required":["TagKey","TagValues"],"members":{"CatalogId":{},"TagKey":{},"TagValues":{"shape":"Sg"}}},"LFTagPolicy":{"type":"structure","required":["ResourceType","Expression"],"members":{"CatalogId":{},"ResourceType":{},"Expression":{"shape":"Sk"}}}}},"S5":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{}}},"S7":{"type":"structure","required":["DatabaseName"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{},"TableWildcard":{"type":"structure","members":{}}}},"Sa":{"type":"list","member":{}},"Sb":{"type":"structure","members":{"ExcludedColumnNames":{"shape":"Sa"}}},"Sg":{"type":"list","member":{}},"Sk":{"type":"list","member":{"type":"structure","required":["TagKey","TagValues"],"members":{"TagKey":{},"TagValues":{"shape":"Sg"}}}},"Sn":{"type":"list","member":{"shape":"So"}},"So":{"type":"structure","required":["TagKey","TagValues"],"members":{"CatalogId":{},"TagKey":{},"TagValues":{"shape":"Sg"}}},"Sq":{"type":"list","member":{"type":"structure","members":{"LFTag":{"shape":"So"},"Error":{"shape":"Ss"}}}},"Ss":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}},"Sv":{"type":"list","member":{"shape":"Sw"}},"Sw":{"type":"structure","required":["Id"],"members":{"Id":{},"Principal":{"shape":"Sy"},"Resource":{"shape":"S3"},"Permissions":{"shape":"S10"},"PermissionsWithGrantOption":{"shape":"S10"}}},"Sy":{"type":"structure","members":{"DataLakePrincipalIdentifier":{}}},"S10":{"type":"list","member":{}},"S13":{"type":"list","member":{"type":"structure","members":{"RequestEntry":{"shape":"Sw"},"Error":{"shape":"Ss"}}}},"S1e":{"type":"structure","required":["TableCatalogId","DatabaseName","TableName","Name"],"members":{"TableCatalogId":{},"DatabaseName":{},"TableName":{},"Name":{},"RowFilter":{"type":"structure","members":{"FilterExpression":{},"AllRowsWildcard":{"type":"structure","members":{}}}},"ColumnNames":{"shape":"Sa"},"ColumnWildcard":{"shape":"Sb"}}},"S1z":{"type":"structure","members":{"ResourceArn":{},"RoleArn":{},"LastModified":{"type":"timestamp"}}},"S24":{"type":"structure","members":{"TransactionId":{},"TransactionStatus":{},"TransactionStartTime":{"type":"timestamp"},"TransactionEndTime":{"type":"timestamp"}}},"S2a":{"type":"structure","members":{"DataLakeAdmins":{"shape":"S2b"},"CreateDatabaseDefaultPermissions":{"shape":"S2c"},"CreateTableDefaultPermissions":{"shape":"S2c"},"TrustedResourceOwners":{"type":"list","member":{}},"AllowExternalDataFiltering":{"type":"boolean"},"ExternalDataFilteringAllowList":{"shape":"S2b"},"AuthorizedSessionTagValueList":{"type":"list","member":{}}}},"S2b":{"type":"list","member":{"shape":"Sy"}},"S2c":{"type":"list","member":{"type":"structure","members":{"Principal":{"shape":"Sy"},"Permissions":{"shape":"S10"}}}},"S2l":{"type":"list","member":{"type":"structure","members":{"Principal":{"shape":"Sy"},"Resource":{"shape":"S3"},"Permissions":{"shape":"S10"},"PermissionsWithGrantOption":{"shape":"S10"},"AdditionalDetails":{"type":"structure","members":{"ResourceShare":{"type":"list","member":{}}}}}}},"S39":{"type":"list","member":{"type":"structure","members":{"Name":{},"LFTags":{"shape":"Sn"}}}},"S3g":{"type":"list","member":{}},"S3q":{"type":"structure","members":{"AdditionalAuditContext":{}}},"S3s":{"type":"list","member":{}},"S56":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetEffectivePermissionsForPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTableObjects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetWorkUnits":{"input_token":"NextToken","limit_key":"PageSize","output_token":"NextToken","result_key":"WorkUnitRanges"},"ListDataCellsFilter":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DataCellsFilters"},"ListLFTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LFTags"},"ListPermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListResources":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTableStorageOptimizers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTransactions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"SearchDatabasesByLFTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatabaseList"},"SearchTablesByLFTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TableList"}}}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['forecastservice'] = {};
	AWS.ForecastService = Service.defineService('forecastservice', ['2018-06-26']);
	Object.defineProperty(apiLoader.services['forecastservice'], '2018-06-26', {
	  get: function get() {
	    var model = __webpack_require__(774);
	    model.paginators = __webpack_require__(775).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ForecastService;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecast","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Service","serviceId":"forecast","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecast","uid":"forecast-2018-06-26"},"operations":{"CreateAutoPredictor":{"input":{"type":"structure","required":["PredictorName"],"members":{"PredictorName":{},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"ForecastDimensions":{"shape":"S6"},"ForecastFrequency":{},"DataConfig":{"shape":"S8"},"EncryptionConfig":{"shape":"Si"},"ReferencePredictorArn":{},"OptimizationMetric":{},"ExplainPredictor":{"type":"boolean"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"PredictorArn":{}}}},"CreateDataset":{"input":{"type":"structure","required":["DatasetName","Domain","DatasetType","Schema"],"members":{"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"Su"},"EncryptionConfig":{"shape":"Si"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupName","Domain"],"members":{"DatasetGroupName":{},"Domain":{},"DatasetArns":{"shape":"S10"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"DatasetGroupArn":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobName","DatasetArn","DataSource"],"members":{"DatasetImportJobName":{},"DatasetArn":{},"DataSource":{"shape":"S13"},"TimestampFormat":{},"TimeZone":{},"UseGeolocationForTimeZone":{"type":"boolean"},"GeolocationFormat":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"DatasetImportJobArn":{}}}},"CreateExplainability":{"input":{"type":"structure","required":["ExplainabilityName","ResourceArn","ExplainabilityConfig"],"members":{"ExplainabilityName":{},"ResourceArn":{},"ExplainabilityConfig":{"shape":"S1c"},"DataSource":{"shape":"S13"},"Schema":{"shape":"Su"},"EnableVisualization":{"type":"boolean"},"StartDateTime":{},"EndDateTime":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ExplainabilityArn":{}}}},"CreateExplainabilityExport":{"input":{"type":"structure","required":["ExplainabilityExportName","ExplainabilityArn","Destination"],"members":{"ExplainabilityExportName":{},"ExplainabilityArn":{},"Destination":{"shape":"S1i"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ExplainabilityExportArn":{}}}},"CreateForecast":{"input":{"type":"structure","required":["ForecastName","PredictorArn"],"members":{"ForecastName":{},"PredictorArn":{},"ForecastTypes":{"shape":"S4"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ForecastArn":{}}}},"CreateForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobName","ForecastArn","Destination"],"members":{"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"S1i"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{}}}},"CreatePredictor":{"input":{"type":"structure","required":["PredictorName","ForecastHorizon","InputDataConfig","FeaturizationConfig"],"members":{"PredictorName":{},"AlgorithmArn":{},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"PerformAutoML":{"type":"boolean"},"AutoMLOverrideStrategy":{},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"S1q"},"EvaluationParameters":{"shape":"S1t"},"HPOConfig":{"shape":"S1u"},"InputDataConfig":{"shape":"S24"},"FeaturizationConfig":{"shape":"S27"},"EncryptionConfig":{"shape":"Si"},"Tags":{"shape":"Sm"},"OptimizationMetric":{}}},"output":{"type":"structure","members":{"PredictorArn":{}}}},"CreatePredictorBacktestExportJob":{"input":{"type":"structure","required":["PredictorBacktestExportJobName","PredictorArn","Destination"],"members":{"PredictorBacktestExportJobName":{},"PredictorArn":{},"Destination":{"shape":"S1i"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"PredictorBacktestExportJobArn":{}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"idempotent":true},"DeleteDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"idempotent":true},"DeleteExplainability":{"input":{"type":"structure","required":["ExplainabilityArn"],"members":{"ExplainabilityArn":{}}},"idempotent":true},"DeleteExplainabilityExport":{"input":{"type":"structure","required":["ExplainabilityExportArn"],"members":{"ExplainabilityExportArn":{}}},"idempotent":true},"DeleteForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"idempotent":true},"DeleteForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"idempotent":true},"DeletePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"idempotent":true},"DeletePredictorBacktestExportJob":{"input":{"type":"structure","required":["PredictorBacktestExportJobArn"],"members":{"PredictorBacktestExportJobArn":{}}},"idempotent":true},"DeleteResourceTree":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"idempotent":true},"DescribeAutoPredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"ForecastFrequency":{},"ForecastDimensions":{"shape":"S6"},"DatasetImportJobArns":{"shape":"S10"},"DataConfig":{"shape":"S8"},"EncryptionConfig":{"shape":"Si"},"ReferencePredictorSummary":{"shape":"S2t"},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"OptimizationMetric":{},"ExplainabilityInfo":{"type":"structure","members":{"ExplainabilityArn":{},"Status":{}}}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"Su"},"EncryptionConfig":{"shape":"Si"},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"output":{"type":"structure","members":{"DatasetGroupName":{},"DatasetGroupArn":{},"DatasetArns":{"shape":"S10"},"Domain":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"output":{"type":"structure","members":{"DatasetImportJobName":{},"DatasetImportJobArn":{},"DatasetArn":{},"TimestampFormat":{},"TimeZone":{},"UseGeolocationForTimeZone":{"type":"boolean"},"GeolocationFormat":{},"DataSource":{"shape":"S13"},"EstimatedTimeRemainingInMinutes":{"type":"long"},"FieldStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"Count":{"type":"integer"},"CountDistinct":{"type":"integer"},"CountNull":{"type":"integer"},"CountNan":{"type":"integer"},"Min":{},"Max":{},"Avg":{"type":"double"},"Stddev":{"type":"double"},"CountLong":{"type":"long"},"CountDistinctLong":{"type":"long"},"CountNullLong":{"type":"long"},"CountNanLong":{"type":"long"}}}},"DataSize":{"type":"double"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeExplainability":{"input":{"type":"structure","required":["ExplainabilityArn"],"members":{"ExplainabilityArn":{}}},"output":{"type":"structure","members":{"ExplainabilityArn":{},"ExplainabilityName":{},"ResourceArn":{},"ExplainabilityConfig":{"shape":"S1c"},"EnableVisualization":{"type":"boolean"},"DataSource":{"shape":"S13"},"Schema":{"shape":"Su"},"StartDateTime":{},"EndDateTime":{},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeExplainabilityExport":{"input":{"type":"structure","required":["ExplainabilityExportArn"],"members":{"ExplainabilityExportArn":{}}},"output":{"type":"structure","members":{"ExplainabilityExportArn":{},"ExplainabilityExportName":{},"ExplainabilityArn":{},"Destination":{"shape":"S1i"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"output":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"ForecastTypes":{"shape":"S4"},"PredictorArn":{},"DatasetGroupArn":{},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"S1i"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"AlgorithmArn":{},"AutoMLAlgorithmArns":{"shape":"S10"},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"PerformAutoML":{"type":"boolean"},"AutoMLOverrideStrategy":{},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"S1q"},"EvaluationParameters":{"shape":"S1t"},"HPOConfig":{"shape":"S1u"},"InputDataConfig":{"shape":"S24"},"FeaturizationConfig":{"shape":"S27"},"EncryptionConfig":{"shape":"Si"},"PredictorExecutionDetails":{"type":"structure","members":{"PredictorExecutions":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"Status":{},"Message":{}}}}}}}}},"EstimatedTimeRemainingInMinutes":{"type":"long"},"IsAutoPredictor":{"type":"boolean"},"DatasetImportJobArns":{"shape":"S10"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"OptimizationMetric":{}}},"idempotent":true},"DescribePredictorBacktestExportJob":{"input":{"type":"structure","required":["PredictorBacktestExportJobArn"],"members":{"PredictorBacktestExportJobArn":{}}},"output":{"type":"structure","members":{"PredictorBacktestExportJobArn":{},"PredictorBacktestExportJobName":{},"PredictorArn":{},"Destination":{"shape":"S1i"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"GetAccuracyMetrics":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorEvaluationResults":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"ItemCount":{"type":"integer"},"EvaluationType":{},"Metrics":{"type":"structure","members":{"RMSE":{"deprecated":true,"deprecatedMessage":"This property is deprecated, please refer to ErrorMetrics for both RMSE and WAPE","type":"double"},"WeightedQuantileLosses":{"type":"list","member":{"type":"structure","members":{"Quantile":{"type":"double"},"LossValue":{"type":"double"}}}},"ErrorMetrics":{"type":"list","member":{"type":"structure","members":{"ForecastType":{},"WAPE":{"type":"double"},"RMSE":{"type":"double"},"MASE":{"type":"double"},"MAPE":{"type":"double"}}}},"AverageWeightedQuantileLoss":{"type":"double"}}}}}}}}},"IsAutoPredictor":{"type":"boolean"},"AutoMLOverrideStrategy":{},"OptimizationMetric":{}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetGroups":{"type":"list","member":{"type":"structure","members":{"DatasetGroupArn":{},"DatasetGroupName":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"DatasetImportJobs":{"type":"list","member":{"type":"structure","members":{"DatasetImportJobArn":{},"DatasetImportJobName":{},"DataSource":{"shape":"S13"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"DatasetType":{},"Domain":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListExplainabilities":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"Explainabilities":{"type":"list","member":{"type":"structure","members":{"ExplainabilityArn":{},"ExplainabilityName":{},"ResourceArn":{},"ExplainabilityConfig":{"shape":"S1c"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListExplainabilityExports":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"ExplainabilityExports":{"type":"list","member":{"type":"structure","members":{"ExplainabilityExportArn":{},"ExplainabilityExportName":{},"Destination":{"shape":"S1i"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecastExportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"ForecastExportJobs":{"type":"list","member":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"Destination":{"shape":"S1i"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecasts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"Forecasts":{"type":"list","member":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"PredictorArn":{},"CreatedUsingAutoPredictor":{"type":"boolean"},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPredictorBacktestExportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"PredictorBacktestExportJobs":{"type":"list","member":{"type":"structure","members":{"PredictorBacktestExportJobArn":{},"PredictorBacktestExportJobName":{},"Destination":{"shape":"S1i"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPredictors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S4a"}}},"output":{"type":"structure","members":{"Predictors":{"type":"list","member":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"DatasetGroupArn":{},"IsAutoPredictor":{"type":"boolean"},"ReferencePredictorSummary":{"shape":"S2t"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sm"}}}},"StopResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{"shape":"So"}}}},"output":{"type":"structure","members":{}}},"UpdateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn","DatasetArns"],"members":{"DatasetGroupArn":{},"DatasetArns":{"shape":"S10"}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"S4":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"S8":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{},"AttributeConfigs":{"type":"list","member":{"type":"structure","required":["AttributeName","Transformations"],"members":{"AttributeName":{},"Transformations":{"type":"map","key":{},"value":{}}}}},"AdditionalDatasets":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Configuration":{"type":"map","key":{},"value":{"shape":"Sh"}}}}}}},"Sh":{"type":"list","member":{}},"Si":{"type":"structure","required":["RoleArn","KMSKeyArn"],"members":{"RoleArn":{},"KMSKeyArn":{}}},"Sm":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"So"},"Value":{"type":"string","sensitive":true}}}},"So":{"type":"string","sensitive":true},"Su":{"type":"structure","members":{"Attributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{}}}}}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"S14"}}},"S14":{"type":"structure","required":["Path","RoleArn"],"members":{"Path":{},"RoleArn":{},"KMSKeyArn":{}}},"S1c":{"type":"structure","required":["TimeSeriesGranularity","TimePointGranularity"],"members":{"TimeSeriesGranularity":{},"TimePointGranularity":{}}},"S1i":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"S14"}}},"S1q":{"type":"map","key":{},"value":{}},"S1t":{"type":"structure","members":{"NumberOfBacktestWindows":{"type":"integer"},"BackTestWindowOffset":{"type":"integer"}}},"S1u":{"type":"structure","members":{"ParameterRanges":{"type":"structure","members":{"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"Sh"}}}},"ContinuousParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"double"},"MinValue":{"type":"double"},"ScalingType":{}}}},"IntegerParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"integer"},"MinValue":{"type":"integer"},"ScalingType":{}}}}}}}},"S24":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{},"SupplementaryFeatures":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"S27":{"type":"structure","required":["ForecastFrequency"],"members":{"ForecastFrequency":{},"ForecastDimensions":{"shape":"S6"},"Featurizations":{"type":"list","member":{"type":"structure","required":["AttributeName"],"members":{"AttributeName":{},"FeaturizationPipeline":{"type":"list","member":{"type":"structure","required":["FeaturizationMethodName"],"members":{"FeaturizationMethodName":{},"FeaturizationMethodParameters":{"type":"map","key":{},"value":{}}}}}}}}}},"S2t":{"type":"structure","members":{"Arn":{},"State":{}}},"S4a":{"type":"list","member":{"type":"structure","required":["Key","Value","Condition"],"members":{"Key":{},"Value":{},"Condition":{}}}}}}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDatasetGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetGroups"},"ListDatasetImportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetImportJobs"},"ListDatasets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Datasets"},"ListForecastExportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ForecastExportJobs"},"ListForecasts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Forecasts"},"ListPredictorBacktestExportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PredictorBacktestExportJobs"},"ListPredictors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Predictors"}}}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['forecastqueryservice'] = {};
	AWS.ForecastQueryService = Service.defineService('forecastqueryservice', ['2018-06-26']);
	Object.defineProperty(apiLoader.services['forecastqueryservice'], '2018-06-26', {
	  get: function get() {
	    var model = __webpack_require__(777);
	    model.paginators = __webpack_require__(778).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ForecastQueryService;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecastquery","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Query Service","serviceId":"forecastquery","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecastRuntime","uid":"forecastquery-2018-06-26"},"operations":{"QueryForecast":{"input":{"type":"structure","required":["ForecastArn","Filters"],"members":{"ForecastArn":{},"StartDate":{},"EndDate":{},"Filters":{"type":"map","key":{},"value":{}},"NextToken":{}}},"output":{"type":"structure","members":{"Forecast":{"type":"structure","members":{"Predictions":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Timestamp":{},"Value":{"type":"double"}}}}}}}}}}},"shapes":{}}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['qldb'] = {};
	AWS.QLDB = Service.defineService('qldb', ['2019-01-02']);
	Object.defineProperty(apiLoader.services['qldb'], '2019-01-02', {
	  get: function get() {
	    var model = __webpack_require__(780);
	    model.paginators = __webpack_require__(781).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.QLDB;


/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-01-02","endpointPrefix":"qldb","jsonVersion":"1.0","protocol":"rest-json","serviceAbbreviation":"QLDB","serviceFullName":"Amazon QLDB","serviceId":"QLDB","signatureVersion":"v4","signingName":"qldb","uid":"qldb-2019-01-02"},"operations":{"CancelJournalKinesisStream":{"http":{"method":"DELETE","requestUri":"/ledgers/{name}/journal-kinesis-streams/{streamId}"},"input":{"type":"structure","required":["LedgerName","StreamId"],"members":{"LedgerName":{"location":"uri","locationName":"name"},"StreamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"StreamId":{}}}},"CreateLedger":{"http":{"requestUri":"/ledgers"},"input":{"type":"structure","required":["Name","PermissionsMode"],"members":{"Name":{},"Tags":{"shape":"S6"},"PermissionsMode":{},"DeletionProtection":{"type":"boolean"},"KmsKey":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"State":{},"CreationDateTime":{"type":"timestamp"},"PermissionsMode":{},"DeletionProtection":{"type":"boolean"},"KmsKeyArn":{}}}},"DeleteLedger":{"http":{"method":"DELETE","requestUri":"/ledgers/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}}},"DescribeJournalKinesisStream":{"http":{"method":"GET","requestUri":"/ledgers/{name}/journal-kinesis-streams/{streamId}"},"input":{"type":"structure","required":["LedgerName","StreamId"],"members":{"LedgerName":{"location":"uri","locationName":"name"},"StreamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"Stream":{"shape":"Sj"}}}},"DescribeJournalS3Export":{"http":{"method":"GET","requestUri":"/ledgers/{name}/journal-s3-exports/{exportId}"},"input":{"type":"structure","required":["Name","ExportId"],"members":{"Name":{"location":"uri","locationName":"name"},"ExportId":{"location":"uri","locationName":"exportId"}}},"output":{"type":"structure","required":["ExportDescription"],"members":{"ExportDescription":{"shape":"Sr"}}}},"DescribeLedger":{"http":{"method":"GET","requestUri":"/ledgers/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"State":{},"CreationDateTime":{"type":"timestamp"},"PermissionsMode":{},"DeletionProtection":{"type":"boolean"},"EncryptionDescription":{"shape":"S11"}}}},"ExportJournalToS3":{"http":{"requestUri":"/ledgers/{name}/journal-s3-exports"},"input":{"type":"structure","required":["Name","InclusiveStartTime","ExclusiveEndTime","S3ExportConfiguration","RoleArn"],"members":{"Name":{"location":"uri","locationName":"name"},"InclusiveStartTime":{"type":"timestamp"},"ExclusiveEndTime":{"type":"timestamp"},"S3ExportConfiguration":{"shape":"St"},"RoleArn":{},"OutputFormat":{}}},"output":{"type":"structure","required":["ExportId"],"members":{"ExportId":{}}}},"GetBlock":{"http":{"requestUri":"/ledgers/{name}/block"},"input":{"type":"structure","required":["Name","BlockAddress"],"members":{"Name":{"location":"uri","locationName":"name"},"BlockAddress":{"shape":"S16"},"DigestTipAddress":{"shape":"S16"}}},"output":{"type":"structure","required":["Block"],"members":{"Block":{"shape":"S16"},"Proof":{"shape":"S16"}}}},"GetDigest":{"http":{"requestUri":"/ledgers/{name}/digest"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Digest","DigestTipAddress"],"members":{"Digest":{"type":"blob"},"DigestTipAddress":{"shape":"S16"}}}},"GetRevision":{"http":{"requestUri":"/ledgers/{name}/revision"},"input":{"type":"structure","required":["Name","BlockAddress","DocumentId"],"members":{"Name":{"location":"uri","locationName":"name"},"BlockAddress":{"shape":"S16"},"DocumentId":{},"DigestTipAddress":{"shape":"S16"}}},"output":{"type":"structure","required":["Revision"],"members":{"Proof":{"shape":"S16"},"Revision":{"shape":"S16"}}}},"ListJournalKinesisStreamsForLedger":{"http":{"method":"GET","requestUri":"/ledgers/{name}/journal-kinesis-streams"},"input":{"type":"structure","required":["LedgerName"],"members":{"LedgerName":{"location":"uri","locationName":"name"},"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"shape":"Sj"}},"NextToken":{}}}},"ListJournalS3Exports":{"http":{"method":"GET","requestUri":"/journal-s3-exports"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"JournalS3Exports":{"shape":"S1l"},"NextToken":{}}}},"ListJournalS3ExportsForLedger":{"http":{"method":"GET","requestUri":"/ledgers/{name}/journal-s3-exports"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"JournalS3Exports":{"shape":"S1l"},"NextToken":{}}}},"ListLedgers":{"http":{"method":"GET","requestUri":"/ledgers"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Ledgers":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"CreationDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"StreamJournalToKinesis":{"http":{"requestUri":"/ledgers/{name}/journal-kinesis-streams"},"input":{"type":"structure","required":["LedgerName","RoleArn","InclusiveStartTime","KinesisConfiguration","StreamName"],"members":{"LedgerName":{"location":"uri","locationName":"name"},"RoleArn":{},"Tags":{"shape":"S6"},"InclusiveStartTime":{"type":"timestamp"},"ExclusiveEndTime":{"type":"timestamp"},"KinesisConfiguration":{"shape":"Sl"},"StreamName":{}}},"output":{"type":"structure","members":{"StreamId":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateLedger":{"http":{"method":"PATCH","requestUri":"/ledgers/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"DeletionProtection":{"type":"boolean"},"KmsKey":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"State":{},"CreationDateTime":{"type":"timestamp"},"DeletionProtection":{"type":"boolean"},"EncryptionDescription":{"shape":"S11"}}}},"UpdateLedgerPermissionsMode":{"http":{"method":"PATCH","requestUri":"/ledgers/{name}/permissions-mode"},"input":{"type":"structure","required":["Name","PermissionsMode"],"members":{"Name":{"location":"uri","locationName":"name"},"PermissionsMode":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"PermissionsMode":{}}}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"Sj":{"type":"structure","required":["LedgerName","RoleArn","StreamId","Status","KinesisConfiguration","StreamName"],"members":{"LedgerName":{},"CreationTime":{"type":"timestamp"},"InclusiveStartTime":{"type":"timestamp"},"ExclusiveEndTime":{"type":"timestamp"},"RoleArn":{},"StreamId":{},"Arn":{},"Status":{},"KinesisConfiguration":{"shape":"Sl"},"ErrorCause":{},"StreamName":{}}},"Sl":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"AggregationEnabled":{"type":"boolean"}}},"Sr":{"type":"structure","required":["LedgerName","ExportId","ExportCreationTime","Status","InclusiveStartTime","ExclusiveEndTime","S3ExportConfiguration","RoleArn"],"members":{"LedgerName":{},"ExportId":{},"ExportCreationTime":{"type":"timestamp"},"Status":{},"InclusiveStartTime":{"type":"timestamp"},"ExclusiveEndTime":{"type":"timestamp"},"S3ExportConfiguration":{"shape":"St"},"RoleArn":{},"OutputFormat":{}}},"St":{"type":"structure","required":["Bucket","Prefix","EncryptionConfiguration"],"members":{"Bucket":{},"Prefix":{},"EncryptionConfiguration":{"type":"structure","required":["ObjectEncryptionType"],"members":{"ObjectEncryptionType":{},"KmsKeyArn":{}}}}},"S11":{"type":"structure","required":["KmsKeyArn","EncryptionStatus"],"members":{"KmsKeyArn":{},"EncryptionStatus":{},"InaccessibleKmsKeyDateTime":{"type":"timestamp"}}},"S16":{"type":"structure","members":{"IonText":{"type":"string","sensitive":true}},"sensitive":true},"S1l":{"type":"list","member":{"shape":"Sr"}}}}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListJournalKinesisStreamsForLedger":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListJournalS3Exports":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListJournalS3ExportsForLedger":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLedgers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['qldbsession'] = {};
	AWS.QLDBSession = Service.defineService('qldbsession', ['2019-07-11']);
	Object.defineProperty(apiLoader.services['qldbsession'], '2019-07-11', {
	  get: function get() {
	    var model = __webpack_require__(783);
	    model.paginators = __webpack_require__(784).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.QLDBSession;


/***/ }),
/* 783 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-07-11","endpointPrefix":"session.qldb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"QLDB Session","serviceFullName":"Amazon QLDB Session","serviceId":"QLDB Session","signatureVersion":"v4","signingName":"qldb","targetPrefix":"QLDBSession","uid":"qldb-session-2019-07-11"},"operations":{"SendCommand":{"input":{"type":"structure","members":{"SessionToken":{},"StartSession":{"type":"structure","required":["LedgerName"],"members":{"LedgerName":{}}},"StartTransaction":{"type":"structure","members":{}},"EndSession":{"type":"structure","members":{}},"CommitTransaction":{"type":"structure","required":["TransactionId","CommitDigest"],"members":{"TransactionId":{},"CommitDigest":{"type":"blob"}}},"AbortTransaction":{"type":"structure","members":{}},"ExecuteStatement":{"type":"structure","required":["TransactionId","Statement"],"members":{"TransactionId":{},"Statement":{},"Parameters":{"type":"list","member":{"shape":"Se"}}}},"FetchPage":{"type":"structure","required":["TransactionId","NextPageToken"],"members":{"TransactionId":{},"NextPageToken":{}}}}},"output":{"type":"structure","members":{"StartSession":{"type":"structure","members":{"SessionToken":{},"TimingInformation":{"shape":"Sl"}}},"StartTransaction":{"type":"structure","members":{"TransactionId":{},"TimingInformation":{"shape":"Sl"}}},"EndSession":{"type":"structure","members":{"TimingInformation":{"shape":"Sl"}}},"CommitTransaction":{"type":"structure","members":{"TransactionId":{},"CommitDigest":{"type":"blob"},"TimingInformation":{"shape":"Sl"},"ConsumedIOs":{"shape":"Sq"}}},"AbortTransaction":{"type":"structure","members":{"TimingInformation":{"shape":"Sl"}}},"ExecuteStatement":{"type":"structure","members":{"FirstPage":{"shape":"Sv"},"TimingInformation":{"shape":"Sl"},"ConsumedIOs":{"shape":"Sq"}}},"FetchPage":{"type":"structure","members":{"Page":{"shape":"Sv"},"TimingInformation":{"shape":"Sl"},"ConsumedIOs":{"shape":"Sq"}}}}}}},"shapes":{"Se":{"type":"structure","members":{"IonBinary":{"type":"blob"},"IonText":{}}},"Sl":{"type":"structure","members":{"ProcessingTimeMilliseconds":{"type":"long"}}},"Sq":{"type":"structure","members":{"ReadIOs":{"type":"long"},"WriteIOs":{"type":"long"}}},"Sv":{"type":"structure","members":{"Values":{"type":"list","member":{"shape":"Se"}},"NextPageToken":{}}}}}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['workmailmessageflow'] = {};
	AWS.WorkMailMessageFlow = Service.defineService('workmailmessageflow', ['2019-05-01']);
	Object.defineProperty(apiLoader.services['workmailmessageflow'], '2019-05-01', {
	  get: function get() {
	    var model = __webpack_require__(786);
	    model.paginators = __webpack_require__(787).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WorkMailMessageFlow;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-05-01","endpointPrefix":"workmailmessageflow","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkMail Message Flow","serviceId":"WorkMailMessageFlow","signatureVersion":"v4","uid":"workmailmessageflow-2019-05-01"},"operations":{"GetRawMessageContent":{"http":{"method":"GET","requestUri":"/messages/{messageId}"},"input":{"type":"structure","required":["messageId"],"members":{"messageId":{"location":"uri","locationName":"messageId"}}},"output":{"type":"structure","required":["messageContent"],"members":{"messageContent":{"type":"blob","streaming":true}},"payload":"messageContent"}},"PutRawMessageContent":{"http":{"requestUri":"/messages/{messageId}"},"input":{"type":"structure","required":["messageId","content"],"members":{"messageId":{"location":"uri","locationName":"messageId"},"content":{"type":"structure","required":["s3Reference"],"members":{"s3Reference":{"type":"structure","required":["bucket","key"],"members":{"bucket":{},"key":{},"objectVersion":{}}}}}}},"output":{"type":"structure","members":{}}}},"shapes":{}}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codestarnotifications'] = {};
	AWS.CodeStarNotifications = Service.defineService('codestarnotifications', ['2019-10-15']);
	Object.defineProperty(apiLoader.services['codestarnotifications'], '2019-10-15', {
	  get: function get() {
	    var model = __webpack_require__(789);
	    model.paginators = __webpack_require__(790).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeStarNotifications;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-10-15","endpointPrefix":"codestar-notifications","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS CodeStar Notifications","serviceId":"codestar notifications","signatureVersion":"v4","signingName":"codestar-notifications","uid":"codestar-notifications-2019-10-15"},"operations":{"CreateNotificationRule":{"http":{"requestUri":"/createNotificationRule"},"input":{"type":"structure","required":["Name","EventTypeIds","Resource","Targets","DetailType"],"members":{"Name":{"shape":"S2"},"EventTypeIds":{"shape":"S3"},"Resource":{},"Targets":{"shape":"S6"},"DetailType":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sc"},"Status":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"DeleteNotificationRule":{"http":{"requestUri":"/deleteNotificationRule"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"DeleteTarget":{"http":{"requestUri":"/deleteTarget"},"input":{"type":"structure","required":["TargetAddress"],"members":{"TargetAddress":{"shape":"S9"},"ForceUnsubscribeAll":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeNotificationRule":{"http":{"requestUri":"/describeNotificationRule"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Name":{"shape":"S2"},"EventTypes":{"shape":"Sp"},"Resource":{},"Targets":{"shape":"Su"},"DetailType":{},"CreatedBy":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"LastModifiedTimestamp":{"type":"timestamp"},"Tags":{"shape":"Sc"}}}},"ListEventTypes":{"http":{"requestUri":"/listEventTypes"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EventTypes":{"shape":"Sp"},"NextToken":{}}}},"ListNotificationRules":{"http":{"requestUri":"/listNotificationRules"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NotificationRules":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{}}}}}}},"ListTagsForResource":{"http":{"requestUri":"/listTagsForResource"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sc"}}}},"ListTargets":{"http":{"requestUri":"/listTargets"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"Su"},"NextToken":{}}}},"Subscribe":{"http":{"requestUri":"/subscribe"},"input":{"type":"structure","required":["Arn","Target"],"members":{"Arn":{},"Target":{"shape":"S7"},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"TagResource":{"http":{"requestUri":"/tagResource"},"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sc"}}}},"Unsubscribe":{"http":{"requestUri":"/unsubscribe"},"input":{"type":"structure","required":["Arn","TargetAddress"],"members":{"Arn":{},"TargetAddress":{"shape":"S9"}}},"output":{"type":"structure","required":["Arn"],"members":{"Arn":{}}}},"UntagResource":{"http":{"requestUri":"/untagResource"},"input":{"type":"structure","required":["Arn","TagKeys"],"members":{"Arn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateNotificationRule":{"http":{"requestUri":"/updateNotificationRule"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Name":{"shape":"S2"},"Status":{},"EventTypeIds":{"shape":"S3"},"Targets":{"shape":"S6"},"DetailType":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S3":{"type":"list","member":{}},"S6":{"type":"list","member":{"shape":"S7"}},"S7":{"type":"structure","members":{"TargetType":{},"TargetAddress":{"shape":"S9"}}},"S9":{"type":"string","sensitive":true},"Sc":{"type":"map","key":{},"value":{}},"Sp":{"type":"list","member":{"type":"structure","members":{"EventTypeId":{},"ServiceName":{},"EventTypeName":{},"ResourceType":{}}}},"Su":{"type":"list","member":{"type":"structure","members":{"TargetAddress":{"shape":"S9"},"TargetType":{},"TargetStatus":{}}}}}}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEventTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EventTypes"},"ListNotificationRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NotificationRules"},"ListTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Targets"}}}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['savingsplans'] = {};
	AWS.SavingsPlans = Service.defineService('savingsplans', ['2019-06-28']);
	Object.defineProperty(apiLoader.services['savingsplans'], '2019-06-28', {
	  get: function get() {
	    var model = __webpack_require__(792);
	    model.paginators = __webpack_require__(793).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SavingsPlans;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-06-28","endpointPrefix":"savingsplans","globalEndpoint":"savingsplans.amazonaws.com","jsonVersion":"1.0","protocol":"rest-json","serviceAbbreviation":"AWSSavingsPlans","serviceFullName":"AWS Savings Plans","serviceId":"savingsplans","signatureVersion":"v4","uid":"savingsplans-2019-06-28"},"operations":{"CreateSavingsPlan":{"http":{"requestUri":"/CreateSavingsPlan"},"input":{"type":"structure","required":["savingsPlanOfferingId","commitment"],"members":{"savingsPlanOfferingId":{},"commitment":{},"upfrontPaymentAmount":{},"purchaseTime":{"type":"timestamp"},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"savingsPlanId":{}}}},"DeleteQueuedSavingsPlan":{"http":{"requestUri":"/DeleteQueuedSavingsPlan"},"input":{"type":"structure","required":["savingsPlanId"],"members":{"savingsPlanId":{}}},"output":{"type":"structure","members":{}}},"DescribeSavingsPlanRates":{"http":{"requestUri":"/DescribeSavingsPlanRates"},"input":{"type":"structure","required":["savingsPlanId"],"members":{"savingsPlanId":{},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sh"}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"savingsPlanId":{},"searchResults":{"type":"list","member":{"type":"structure","members":{"rate":{},"currency":{},"unit":{},"productType":{},"serviceCode":{},"usageType":{},"operation":{},"properties":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}}}}},"nextToken":{}}}},"DescribeSavingsPlans":{"http":{"requestUri":"/DescribeSavingsPlans"},"input":{"type":"structure","members":{"savingsPlanArns":{"type":"list","member":{}},"savingsPlanIds":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"},"states":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sh"}}}}}},"output":{"type":"structure","members":{"savingsPlans":{"type":"list","member":{"type":"structure","members":{"offeringId":{},"savingsPlanId":{},"savingsPlanArn":{},"description":{},"start":{},"end":{},"state":{},"region":{},"ec2InstanceFamily":{},"savingsPlanType":{},"paymentOption":{},"productTypes":{"shape":"S1e"},"currency":{},"commitment":{},"upfrontPaymentAmount":{},"recurringPaymentAmount":{},"termDurationInSeconds":{"type":"long"},"tags":{"shape":"S6"}}}},"nextToken":{}}}},"DescribeSavingsPlansOfferingRates":{"http":{"requestUri":"/DescribeSavingsPlansOfferingRates"},"input":{"type":"structure","members":{"savingsPlanOfferingIds":{"shape":"S1h"},"savingsPlanPaymentOptions":{"shape":"S1j"},"savingsPlanTypes":{"shape":"S1k"},"products":{"shape":"S1e"},"serviceCodes":{"type":"list","member":{}},"usageTypes":{"type":"list","member":{}},"operations":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S1r"}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"searchResults":{"type":"list","member":{"type":"structure","members":{"savingsPlanOffering":{"type":"structure","members":{"offeringId":{},"paymentOption":{},"planType":{},"durationSeconds":{"type":"long"},"currency":{},"planDescription":{}}},"rate":{},"unit":{},"productType":{},"serviceCode":{},"usageType":{},"operation":{},"properties":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}}}}},"nextToken":{}}}},"DescribeSavingsPlansOfferings":{"http":{"requestUri":"/DescribeSavingsPlansOfferings"},"input":{"type":"structure","members":{"offeringIds":{"shape":"S1h"},"paymentOptions":{"shape":"S1j"},"productType":{},"planTypes":{"shape":"S1k"},"durations":{"type":"list","member":{"type":"long"}},"currencies":{"type":"list","member":{}},"descriptions":{"type":"list","member":{}},"serviceCodes":{"type":"list","member":{}},"usageTypes":{"type":"list","member":{}},"operations":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S1r"}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"searchResults":{"type":"list","member":{"type":"structure","members":{"offeringId":{},"productTypes":{"shape":"S1e"},"planType":{},"description":{},"paymentOption":{},"durationSeconds":{"type":"long"},"currency":{},"serviceCode":{},"usageType":{},"operation":{},"properties":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S6"}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"Sh":{"type":"list","member":{}},"S1e":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1j":{"type":"list","member":{}},"S1k":{"type":"list","member":{}},"S1r":{"type":"list","member":{}}}}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sso'] = {};
	AWS.SSO = Service.defineService('sso', ['2019-06-10']);
	Object.defineProperty(apiLoader.services['sso'], '2019-06-10', {
	  get: function get() {
	    var model = __webpack_require__(795);
	    model.paginators = __webpack_require__(796).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SSO;


/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-06-10","endpointPrefix":"portal.sso","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"SSO","serviceFullName":"AWS Single Sign-On","serviceId":"SSO","signatureVersion":"v4","signingName":"awsssoportal","uid":"sso-2019-06-10"},"operations":{"GetRoleCredentials":{"http":{"method":"GET","requestUri":"/federation/credentials"},"input":{"type":"structure","required":["roleName","accountId","accessToken"],"members":{"roleName":{"location":"querystring","locationName":"role_name"},"accountId":{"location":"querystring","locationName":"account_id"},"accessToken":{"shape":"S4","location":"header","locationName":"x-amz-sso_bearer_token"}}},"output":{"type":"structure","members":{"roleCredentials":{"type":"structure","members":{"accessKeyId":{},"secretAccessKey":{"type":"string","sensitive":true},"sessionToken":{"type":"string","sensitive":true},"expiration":{"type":"long"}}}}},"authtype":"none"},"ListAccountRoles":{"http":{"method":"GET","requestUri":"/assignment/roles"},"input":{"type":"structure","required":["accessToken","accountId"],"members":{"nextToken":{"location":"querystring","locationName":"next_token"},"maxResults":{"location":"querystring","locationName":"max_result","type":"integer"},"accessToken":{"shape":"S4","location":"header","locationName":"x-amz-sso_bearer_token"},"accountId":{"location":"querystring","locationName":"account_id"}}},"output":{"type":"structure","members":{"nextToken":{},"roleList":{"type":"list","member":{"type":"structure","members":{"roleName":{},"accountId":{}}}}}},"authtype":"none"},"ListAccounts":{"http":{"method":"GET","requestUri":"/assignment/accounts"},"input":{"type":"structure","required":["accessToken"],"members":{"nextToken":{"location":"querystring","locationName":"next_token"},"maxResults":{"location":"querystring","locationName":"max_result","type":"integer"},"accessToken":{"shape":"S4","location":"header","locationName":"x-amz-sso_bearer_token"}}},"output":{"type":"structure","members":{"nextToken":{},"accountList":{"type":"list","member":{"type":"structure","members":{"accountId":{},"accountName":{},"emailAddress":{}}}}}},"authtype":"none"},"Logout":{"http":{"requestUri":"/logout"},"input":{"type":"structure","required":["accessToken"],"members":{"accessToken":{"shape":"S4","location":"header","locationName":"x-amz-sso_bearer_token"}}},"authtype":"none"}},"shapes":{"S4":{"type":"string","sensitive":true}}}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccountRoles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"roleList"},"ListAccounts":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"accountList"}}}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ssooidc'] = {};
	AWS.SSOOIDC = Service.defineService('ssooidc', ['2019-06-10']);
	Object.defineProperty(apiLoader.services['ssooidc'], '2019-06-10', {
	  get: function get() {
	    var model = __webpack_require__(798);
	    model.paginators = __webpack_require__(799).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SSOOIDC;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-06-10","endpointPrefix":"oidc","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"SSO OIDC","serviceFullName":"AWS SSO OIDC","serviceId":"SSO OIDC","signatureVersion":"v4","signingName":"awsssooidc","uid":"sso-oidc-2019-06-10"},"operations":{"CreateToken":{"http":{"requestUri":"/token"},"input":{"type":"structure","required":["clientId","clientSecret","grantType","deviceCode"],"members":{"clientId":{},"clientSecret":{},"grantType":{},"deviceCode":{},"code":{},"refreshToken":{},"scope":{"shape":"S8"},"redirectUri":{}}},"output":{"type":"structure","members":{"accessToken":{},"tokenType":{},"expiresIn":{"type":"integer"},"refreshToken":{},"idToken":{}}},"authtype":"none"},"RegisterClient":{"http":{"requestUri":"/client/register"},"input":{"type":"structure","required":["clientName","clientType"],"members":{"clientName":{},"clientType":{},"scopes":{"shape":"S8"}}},"output":{"type":"structure","members":{"clientId":{},"clientSecret":{},"clientIdIssuedAt":{"type":"long"},"clientSecretExpiresAt":{"type":"long"},"authorizationEndpoint":{},"tokenEndpoint":{}}},"authtype":"none"},"StartDeviceAuthorization":{"http":{"requestUri":"/device_authorization"},"input":{"type":"structure","required":["clientId","clientSecret","startUrl"],"members":{"clientId":{},"clientSecret":{},"startUrl":{}}},"output":{"type":"structure","members":{"deviceCode":{},"userCode":{},"verificationUri":{},"verificationUriComplete":{},"expiresIn":{"type":"integer"},"interval":{"type":"integer"}}},"authtype":"none"}},"shapes":{"S8":{"type":"list","member":{}}}}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['marketplacecatalog'] = {};
	AWS.MarketplaceCatalog = Service.defineService('marketplacecatalog', ['2018-09-17']);
	Object.defineProperty(apiLoader.services['marketplacecatalog'], '2018-09-17', {
	  get: function get() {
	    var model = __webpack_require__(801);
	    model.paginators = __webpack_require__(802).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MarketplaceCatalog;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-17","endpointPrefix":"catalog.marketplace","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWS Marketplace Catalog","serviceFullName":"AWS Marketplace Catalog Service","serviceId":"Marketplace Catalog","signatureVersion":"v4","signingName":"aws-marketplace","uid":"marketplace-catalog-2018-09-17"},"operations":{"CancelChangeSet":{"http":{"method":"PATCH","requestUri":"/CancelChangeSet"},"input":{"type":"structure","required":["Catalog","ChangeSetId"],"members":{"Catalog":{"location":"querystring","locationName":"catalog"},"ChangeSetId":{"location":"querystring","locationName":"changeSetId"}}},"output":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{}}}},"DescribeChangeSet":{"http":{"method":"GET","requestUri":"/DescribeChangeSet"},"input":{"type":"structure","required":["Catalog","ChangeSetId"],"members":{"Catalog":{"location":"querystring","locationName":"catalog"},"ChangeSetId":{"location":"querystring","locationName":"changeSetId"}}},"output":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{},"ChangeSetName":{},"StartTime":{},"EndTime":{},"Status":{},"FailureCode":{},"FailureDescription":{},"ChangeSet":{"type":"list","member":{"type":"structure","members":{"ChangeType":{},"Entity":{"shape":"Sg"},"Details":{},"ErrorDetailList":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"ChangeName":{}}}}}}},"DescribeEntity":{"http":{"method":"GET","requestUri":"/DescribeEntity"},"input":{"type":"structure","required":["Catalog","EntityId"],"members":{"Catalog":{"location":"querystring","locationName":"catalog"},"EntityId":{"location":"querystring","locationName":"entityId"}}},"output":{"type":"structure","members":{"EntityType":{},"EntityIdentifier":{},"EntityArn":{},"LastModifiedDate":{},"Details":{}}}},"ListChangeSets":{"http":{"requestUri":"/ListChangeSets"},"input":{"type":"structure","required":["Catalog"],"members":{"Catalog":{},"FilterList":{"shape":"Sr"},"Sort":{"shape":"Sw"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ChangeSetSummaryList":{"type":"list","member":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{},"ChangeSetName":{},"StartTime":{},"EndTime":{},"Status":{},"EntityIdList":{"type":"list","member":{}},"FailureCode":{}}}},"NextToken":{}}}},"ListEntities":{"http":{"requestUri":"/ListEntities"},"input":{"type":"structure","required":["Catalog","EntityType"],"members":{"Catalog":{},"EntityType":{},"FilterList":{"shape":"Sr"},"Sort":{"shape":"Sw"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntitySummaryList":{"type":"list","member":{"type":"structure","members":{"Name":{},"EntityType":{},"EntityId":{},"EntityArn":{},"LastModifiedDate":{},"Visibility":{}}}},"NextToken":{}}}},"StartChangeSet":{"http":{"requestUri":"/StartChangeSet"},"input":{"type":"structure","required":["Catalog","ChangeSet"],"members":{"Catalog":{},"ChangeSet":{"type":"list","member":{"type":"structure","required":["ChangeType","Entity","Details"],"members":{"ChangeType":{},"Entity":{"shape":"Sg"},"Details":{},"ChangeName":{}}}},"ChangeSetName":{},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{}}}}},"shapes":{"Sg":{"type":"structure","required":["Type"],"members":{"Type":{},"Identifier":{}}},"Sr":{"type":"list","member":{"type":"structure","members":{"Name":{},"ValueList":{"type":"list","member":{}}}}},"Sw":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}}}}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['dataexchange'] = {};
	AWS.DataExchange = Service.defineService('dataexchange', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['dataexchange'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(804);
	    model.paginators = __webpack_require__(805).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DataExchange;


/***/ }),
/* 804 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2017-07-25","endpointPrefix":"dataexchange","signingName":"dataexchange","serviceFullName":"AWS Data Exchange","serviceId":"DataExchange","protocol":"rest-json","jsonVersion":"1.1","uid":"dataexchange-2017-07-25","signatureVersion":"v4"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/v1/jobs/{JobId}","responseCode":204},"input":{"type":"structure","members":{"JobId":{"location":"uri","locationName":"JobId"}},"required":["JobId"]}},"CreateDataSet":{"http":{"requestUri":"/v1/data-sets","responseCode":201},"input":{"type":"structure","members":{"AssetType":{},"Description":{},"Name":{},"Tags":{"shape":"S7"}},"required":["AssetType","Description","Name"]},"output":{"type":"structure","members":{"Arn":{},"AssetType":{},"CreatedAt":{"shape":"Sa"},"Description":{},"Id":{},"Name":{},"Origin":{},"OriginDetails":{"shape":"Sd"},"SourceId":{},"Tags":{"shape":"S7"},"UpdatedAt":{"shape":"Sa"}}}},"CreateEventAction":{"http":{"requestUri":"/v1/event-actions","responseCode":201},"input":{"type":"structure","members":{"Action":{"shape":"Sf"},"Event":{"shape":"Sk"}},"required":["Action","Event"]},"output":{"type":"structure","members":{"Action":{"shape":"Sf"},"Arn":{},"CreatedAt":{"shape":"Sa"},"Event":{"shape":"Sk"},"Id":{},"UpdatedAt":{"shape":"Sa"}}}},"CreateJob":{"http":{"requestUri":"/v1/jobs","responseCode":201},"input":{"type":"structure","members":{"Details":{"type":"structure","members":{"ExportAssetToSignedUrl":{"type":"structure","members":{"AssetId":{},"DataSetId":{},"RevisionId":{}},"required":["DataSetId","AssetId","RevisionId"]},"ExportAssetsToS3":{"type":"structure","members":{"AssetDestinations":{"shape":"Sr"},"DataSetId":{},"Encryption":{"shape":"Sh"},"RevisionId":{}},"required":["AssetDestinations","DataSetId","RevisionId"]},"ExportRevisionsToS3":{"type":"structure","members":{"DataSetId":{},"Encryption":{"shape":"Sh"},"RevisionDestinations":{"shape":"Su"}},"required":["RevisionDestinations","DataSetId"]},"ImportAssetFromSignedUrl":{"type":"structure","members":{"AssetName":{},"DataSetId":{},"Md5Hash":{},"RevisionId":{}},"required":["DataSetId","Md5Hash","AssetName","RevisionId"]},"ImportAssetsFromS3":{"type":"structure","members":{"AssetSources":{"shape":"S10"},"DataSetId":{},"RevisionId":{}},"required":["DataSetId","AssetSources","RevisionId"]},"ImportAssetsFromRedshiftDataShares":{"type":"structure","members":{"AssetSources":{"shape":"S13"},"DataSetId":{},"RevisionId":{}},"required":["DataSetId","AssetSources","RevisionId"]},"ImportAssetFromApiGatewayApi":{"type":"structure","members":{"ApiDescription":{},"ApiId":{},"ApiKey":{},"ApiName":{},"ApiSpecificationMd5Hash":{},"DataSetId":{},"ProtocolType":{},"RevisionId":{},"Stage":{}},"required":["ApiName","ProtocolType","ApiSpecificationMd5Hash","Stage","DataSetId","ApiId","RevisionId"]}}},"Type":{}},"required":["Type","Details"]},"output":{"type":"structure","members":{"Arn":{},"CreatedAt":{"shape":"Sa"},"Details":{"shape":"S1a"},"Errors":{"shape":"S1i"},"Id":{},"State":{},"Type":{},"UpdatedAt":{"shape":"Sa"}}}},"CreateRevision":{"http":{"requestUri":"/v1/data-sets/{DataSetId}/revisions","responseCode":201},"input":{"type":"structure","members":{"Comment":{},"DataSetId":{"location":"uri","locationName":"DataSetId"},"Tags":{"shape":"S7"}},"required":["DataSetId"]},"output":{"type":"structure","members":{"Arn":{},"Comment":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Finalized":{"type":"boolean"},"Id":{},"SourceId":{},"Tags":{"shape":"S7"},"UpdatedAt":{"shape":"Sa"},"RevocationComment":{},"Revoked":{"type":"boolean"},"RevokedAt":{"shape":"Sa"}}}},"DeleteAsset":{"http":{"method":"DELETE","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}/assets/{AssetId}","responseCode":204},"input":{"type":"structure","members":{"AssetId":{"location":"uri","locationName":"AssetId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","AssetId","DataSetId"]}},"DeleteDataSet":{"http":{"method":"DELETE","requestUri":"/v1/data-sets/{DataSetId}","responseCode":204},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"}},"required":["DataSetId"]}},"DeleteEventAction":{"http":{"method":"DELETE","requestUri":"/v1/event-actions/{EventActionId}","responseCode":204},"input":{"type":"structure","members":{"EventActionId":{"location":"uri","locationName":"EventActionId"}},"required":["EventActionId"]}},"DeleteRevision":{"http":{"method":"DELETE","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}","responseCode":204},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","DataSetId"]}},"GetAsset":{"http":{"method":"GET","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}/assets/{AssetId}","responseCode":200},"input":{"type":"structure","members":{"AssetId":{"location":"uri","locationName":"AssetId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","AssetId","DataSetId"]},"output":{"type":"structure","members":{"Arn":{},"AssetDetails":{"shape":"S22"},"AssetType":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Id":{},"Name":{},"RevisionId":{},"SourceId":{},"UpdatedAt":{"shape":"Sa"}}}},"GetDataSet":{"http":{"method":"GET","requestUri":"/v1/data-sets/{DataSetId}","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"}},"required":["DataSetId"]},"output":{"type":"structure","members":{"Arn":{},"AssetType":{},"CreatedAt":{"shape":"Sa"},"Description":{},"Id":{},"Name":{},"Origin":{},"OriginDetails":{"shape":"Sd"},"SourceId":{},"Tags":{"shape":"S7"},"UpdatedAt":{"shape":"Sa"}}}},"GetEventAction":{"http":{"method":"GET","requestUri":"/v1/event-actions/{EventActionId}","responseCode":200},"input":{"type":"structure","members":{"EventActionId":{"location":"uri","locationName":"EventActionId"}},"required":["EventActionId"]},"output":{"type":"structure","members":{"Action":{"shape":"Sf"},"Arn":{},"CreatedAt":{"shape":"Sa"},"Event":{"shape":"Sk"},"Id":{},"UpdatedAt":{"shape":"Sa"}}}},"GetJob":{"http":{"method":"GET","requestUri":"/v1/jobs/{JobId}","responseCode":200},"input":{"type":"structure","members":{"JobId":{"location":"uri","locationName":"JobId"}},"required":["JobId"]},"output":{"type":"structure","members":{"Arn":{},"CreatedAt":{"shape":"Sa"},"Details":{"shape":"S1a"},"Errors":{"shape":"S1i"},"Id":{},"State":{},"Type":{},"UpdatedAt":{"shape":"Sa"}}}},"GetRevision":{"http":{"method":"GET","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","DataSetId"]},"output":{"type":"structure","members":{"Arn":{},"Comment":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Finalized":{"type":"boolean"},"Id":{},"SourceId":{},"Tags":{"shape":"S7"},"UpdatedAt":{"shape":"Sa"},"RevocationComment":{},"Revoked":{"type":"boolean"},"RevokedAt":{"shape":"Sa"}}}},"ListDataSetRevisions":{"http":{"method":"GET","requestUri":"/v1/data-sets/{DataSetId}/revisions","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["DataSetId"]},"output":{"type":"structure","members":{"NextToken":{},"Revisions":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Comment":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Finalized":{"type":"boolean"},"Id":{},"SourceId":{},"UpdatedAt":{"shape":"Sa"},"RevocationComment":{},"Revoked":{"type":"boolean"},"RevokedAt":{"shape":"Sa"}},"required":["CreatedAt","DataSetId","Id","Arn","UpdatedAt"]}}}}},"ListDataSets":{"http":{"method":"GET","requestUri":"/v1/data-sets","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"Origin":{"location":"querystring","locationName":"origin"}}},"output":{"type":"structure","members":{"DataSets":{"type":"list","member":{"type":"structure","members":{"Arn":{},"AssetType":{},"CreatedAt":{"shape":"Sa"},"Description":{},"Id":{},"Name":{},"Origin":{},"OriginDetails":{"shape":"Sd"},"SourceId":{},"UpdatedAt":{"shape":"Sa"}},"required":["Origin","AssetType","Description","CreatedAt","Id","Arn","UpdatedAt","Name"]}},"NextToken":{}}}},"ListEventActions":{"http":{"method":"GET","requestUri":"/v1/event-actions","responseCode":200},"input":{"type":"structure","members":{"EventSourceId":{"location":"querystring","locationName":"eventSourceId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"EventActions":{"type":"list","member":{"type":"structure","members":{"Action":{"shape":"Sf"},"Arn":{},"CreatedAt":{"shape":"Sa"},"Event":{"shape":"Sk"},"Id":{},"UpdatedAt":{"shape":"Sa"}},"required":["Action","CreatedAt","Event","Id","Arn","UpdatedAt"]}},"NextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/v1/jobs","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"querystring","locationName":"dataSetId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RevisionId":{"location":"querystring","locationName":"revisionId"}}},"output":{"type":"structure","members":{"Jobs":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedAt":{"shape":"Sa"},"Details":{"shape":"S1a"},"Errors":{"shape":"S1i"},"Id":{},"State":{},"Type":{},"UpdatedAt":{"shape":"Sa"}},"required":["Type","Details","State","CreatedAt","Id","Arn","UpdatedAt"]}},"NextToken":{}}}},"ListRevisionAssets":{"http":{"method":"GET","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}/assets","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","DataSetId"]},"output":{"type":"structure","members":{"Assets":{"type":"list","member":{"type":"structure","members":{"Arn":{},"AssetDetails":{"shape":"S22"},"AssetType":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Id":{},"Name":{},"RevisionId":{},"SourceId":{},"UpdatedAt":{"shape":"Sa"}},"required":["AssetType","CreatedAt","DataSetId","Id","Arn","AssetDetails","UpdatedAt","RevisionId","Name"]}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S7","locationName":"tags"}}}},"RevokeRevision":{"http":{"requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}/revoke","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"RevisionId":{"location":"uri","locationName":"RevisionId"},"RevocationComment":{}},"required":["RevisionId","DataSetId","RevocationComment"]},"output":{"type":"structure","members":{"Arn":{},"Comment":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Finalized":{"type":"boolean"},"Id":{},"SourceId":{},"UpdatedAt":{"shape":"Sa"},"RevocationComment":{},"Revoked":{"type":"boolean"},"RevokedAt":{"shape":"Sa"}}}},"SendApiAsset":{"http":{"requestUri":"/v1","responseCode":200},"input":{"type":"structure","members":{"Body":{},"QueryStringParameters":{"shape":"S7","location":"querystring"},"AssetId":{"location":"header","locationName":"x-amzn-dataexchange-asset-id"},"DataSetId":{"location":"header","locationName":"x-amzn-dataexchange-data-set-id"},"RequestHeaders":{"shape":"S7","location":"headers","locationName":"x-amzn-dataexchange-header-"},"Method":{"location":"header","locationName":"x-amzn-dataexchange-http-method"},"Path":{"location":"header","locationName":"x-amzn-dataexchange-path"},"RevisionId":{"location":"header","locationName":"x-amzn-dataexchange-revision-id"}},"required":["DataSetId","RevisionId","AssetId"],"payload":"Body"},"output":{"type":"structure","members":{"Body":{},"ResponseHeaders":{"shape":"S7","location":"headers","locationName":""}},"payload":"Body"},"endpoint":{"hostPrefix":"api-fulfill."}},"StartJob":{"http":{"method":"PATCH","requestUri":"/v1/jobs/{JobId}","responseCode":202},"input":{"type":"structure","members":{"JobId":{"location":"uri","locationName":"JobId"}},"required":["JobId"]},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"S7","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}},"required":["TagKeys","ResourceArn"]}},"UpdateAsset":{"http":{"method":"PATCH","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}/assets/{AssetId}","responseCode":200},"input":{"type":"structure","members":{"AssetId":{"location":"uri","locationName":"AssetId"},"DataSetId":{"location":"uri","locationName":"DataSetId"},"Name":{},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","AssetId","DataSetId","Name"]},"output":{"type":"structure","members":{"Arn":{},"AssetDetails":{"shape":"S22"},"AssetType":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Id":{},"Name":{},"RevisionId":{},"SourceId":{},"UpdatedAt":{"shape":"Sa"}}}},"UpdateDataSet":{"http":{"method":"PATCH","requestUri":"/v1/data-sets/{DataSetId}","responseCode":200},"input":{"type":"structure","members":{"DataSetId":{"location":"uri","locationName":"DataSetId"},"Description":{},"Name":{}},"required":["DataSetId"]},"output":{"type":"structure","members":{"Arn":{},"AssetType":{},"CreatedAt":{"shape":"Sa"},"Description":{},"Id":{},"Name":{},"Origin":{},"OriginDetails":{"shape":"Sd"},"SourceId":{},"UpdatedAt":{"shape":"Sa"}}}},"UpdateEventAction":{"http":{"method":"PATCH","requestUri":"/v1/event-actions/{EventActionId}","responseCode":200},"input":{"type":"structure","members":{"Action":{"shape":"Sf"},"EventActionId":{"location":"uri","locationName":"EventActionId"}},"required":["EventActionId"]},"output":{"type":"structure","members":{"Action":{"shape":"Sf"},"Arn":{},"CreatedAt":{"shape":"Sa"},"Event":{"shape":"Sk"},"Id":{},"UpdatedAt":{"shape":"Sa"}}}},"UpdateRevision":{"http":{"method":"PATCH","requestUri":"/v1/data-sets/{DataSetId}/revisions/{RevisionId}","responseCode":200},"input":{"type":"structure","members":{"Comment":{},"DataSetId":{"location":"uri","locationName":"DataSetId"},"Finalized":{"type":"boolean"},"RevisionId":{"location":"uri","locationName":"RevisionId"}},"required":["RevisionId","DataSetId"]},"output":{"type":"structure","members":{"Arn":{},"Comment":{},"CreatedAt":{"shape":"Sa"},"DataSetId":{},"Finalized":{"type":"boolean"},"Id":{},"SourceId":{},"UpdatedAt":{"shape":"Sa"},"RevocationComment":{},"Revoked":{"type":"boolean"},"RevokedAt":{"shape":"Sa"}}}}},"shapes":{"S7":{"type":"map","key":{},"value":{}},"Sa":{"type":"timestamp","timestampFormat":"iso8601"},"Sd":{"type":"structure","members":{"ProductId":{}},"required":["ProductId"]},"Sf":{"type":"structure","members":{"ExportRevisionToS3":{"type":"structure","members":{"Encryption":{"shape":"Sh"},"RevisionDestination":{"type":"structure","members":{"Bucket":{},"KeyPattern":{}},"required":["Bucket"]}},"required":["RevisionDestination"]}}},"Sh":{"type":"structure","members":{"KmsKeyArn":{},"Type":{}},"required":["Type"]},"Sk":{"type":"structure","members":{"RevisionPublished":{"type":"structure","members":{"DataSetId":{}},"required":["DataSetId"]}}},"Sr":{"type":"list","member":{"type":"structure","members":{"AssetId":{},"Bucket":{},"Key":{}},"required":["Bucket","AssetId"]}},"Su":{"type":"list","member":{"type":"structure","members":{"Bucket":{},"KeyPattern":{},"RevisionId":{}},"required":["Bucket","RevisionId"]}},"S10":{"type":"list","member":{"type":"structure","members":{"Bucket":{},"Key":{}},"required":["Bucket","Key"]}},"S13":{"type":"list","member":{"type":"structure","members":{"DataShareArn":{}},"required":["DataShareArn"]}},"S1a":{"type":"structure","members":{"ExportAssetToSignedUrl":{"type":"structure","members":{"AssetId":{},"DataSetId":{},"RevisionId":{},"SignedUrl":{},"SignedUrlExpiresAt":{"shape":"Sa"}},"required":["DataSetId","AssetId","RevisionId"]},"ExportAssetsToS3":{"type":"structure","members":{"AssetDestinations":{"shape":"Sr"},"DataSetId":{},"Encryption":{"shape":"Sh"},"RevisionId":{}},"required":["AssetDestinations","DataSetId","RevisionId"]},"ExportRevisionsToS3":{"type":"structure","members":{"DataSetId":{},"Encryption":{"shape":"Sh"},"RevisionDestinations":{"shape":"Su"},"EventActionArn":{}},"required":["RevisionDestinations","DataSetId"]},"ImportAssetFromSignedUrl":{"type":"structure","members":{"AssetName":{},"DataSetId":{},"Md5Hash":{},"RevisionId":{},"SignedUrl":{},"SignedUrlExpiresAt":{"shape":"Sa"}},"required":["DataSetId","AssetName","RevisionId"]},"ImportAssetsFromS3":{"type":"structure","members":{"AssetSources":{"shape":"S10"},"DataSetId":{},"RevisionId":{}},"required":["DataSetId","AssetSources","RevisionId"]},"ImportAssetsFromRedshiftDataShares":{"type":"structure","members":{"AssetSources":{"shape":"S13"},"DataSetId":{},"RevisionId":{}},"required":["DataSetId","AssetSources","RevisionId"]},"ImportAssetFromApiGatewayApi":{"type":"structure","members":{"ApiDescription":{},"ApiId":{},"ApiKey":{},"ApiName":{},"ApiSpecificationMd5Hash":{},"ApiSpecificationUploadUrl":{},"ApiSpecificationUploadUrlExpiresAt":{"shape":"Sa"},"DataSetId":{},"ProtocolType":{},"RevisionId":{},"Stage":{}},"required":["ApiSpecificationUploadUrlExpiresAt","ApiName","ProtocolType","ApiSpecificationMd5Hash","Stage","DataSetId","ApiId","RevisionId","ApiSpecificationUploadUrl"]}}},"S1i":{"type":"list","member":{"type":"structure","members":{"Code":{},"Details":{"type":"structure","members":{"ImportAssetFromSignedUrlJobErrorDetails":{"type":"structure","members":{"AssetName":{}},"required":["AssetName"]},"ImportAssetsFromS3JobErrorDetails":{"shape":"S10"}}},"LimitName":{},"LimitValue":{"type":"double"},"Message":{},"ResourceId":{},"ResourceType":{}},"required":["Message","Code"]}},"S22":{"type":"structure","members":{"S3SnapshotAsset":{"type":"structure","members":{"Size":{"type":"double"}},"required":["Size"]},"RedshiftDataShareAsset":{"type":"structure","members":{"Arn":{}},"required":["Arn"]},"ApiGatewayApiAsset":{"type":"structure","members":{"ApiDescription":{},"ApiEndpoint":{},"ApiId":{},"ApiKey":{},"ApiName":{},"ApiSpecificationDownloadUrl":{},"ApiSpecificationDownloadUrlExpiresAt":{"shape":"Sa"},"ProtocolType":{},"Stage":{}}}}}}}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDataSetRevisions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Revisions"},"ListDataSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DataSets"},"ListEventActions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EventActions"},"ListJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Jobs"},"ListRevisionAssets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Assets"}}}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sesv2'] = {};
	AWS.SESV2 = Service.defineService('sesv2', ['2019-09-27']);
	Object.defineProperty(apiLoader.services['sesv2'], '2019-09-27', {
	  get: function get() {
	    var model = __webpack_require__(807);
	    model.paginators = __webpack_require__(808).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SESV2;


/***/ }),
/* 807 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-09-27","endpointPrefix":"email","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon SES V2","serviceFullName":"Amazon Simple Email Service","serviceId":"SESv2","signatureVersion":"v4","signingName":"ses","uid":"sesv2-2019-09-27"},"operations":{"CreateConfigurationSet":{"http":{"requestUri":"/v2/email/configuration-sets"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"S3"},"DeliveryOptions":{"shape":"S5"},"ReputationOptions":{"shape":"S8"},"SendingOptions":{"shape":"Sb"},"Tags":{"shape":"Sc"},"SuppressionOptions":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"http":{"requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","EventDestination"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{},"EventDestination":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"CreateContact":{"http":{"requestUri":"/v2/email/contact-lists/{ContactListName}/contacts"},"input":{"type":"structure","required":["ContactListName","EmailAddress"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"},"EmailAddress":{},"TopicPreferences":{"shape":"S13"},"UnsubscribeAll":{"type":"boolean"},"AttributesData":{}}},"output":{"type":"structure","members":{}}},"CreateContactList":{"http":{"requestUri":"/v2/email/contact-lists"},"input":{"type":"structure","required":["ContactListName"],"members":{"ContactListName":{},"Topics":{"shape":"S1b"},"Description":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateCustomVerificationEmailTemplate":{"http":{"requestUri":"/v2/email/custom-verification-email-templates"},"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}},"output":{"type":"structure","members":{}}},"CreateDedicatedIpPool":{"http":{"requestUri":"/v2/email/dedicated-ip-pools"},"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateDeliverabilityTestReport":{"http":{"requestUri":"/v2/email/deliverability-dashboard/test"},"input":{"type":"structure","required":["FromEmailAddress","Content"],"members":{"ReportName":{},"FromEmailAddress":{},"Content":{"shape":"S1r"},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","required":["ReportId","DeliverabilityTestStatus"],"members":{"ReportId":{},"DeliverabilityTestStatus":{}}}},"CreateEmailIdentity":{"http":{"requestUri":"/v2/email/identities"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{},"Tags":{"shape":"Sc"},"DkimSigningAttributes":{"shape":"S26"},"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"IdentityType":{},"VerifiedForSendingStatus":{"type":"boolean"},"DkimAttributes":{"shape":"S2c"}}}},"CreateEmailIdentityPolicy":{"http":{"requestUri":"/v2/email/identities/{EmailIdentity}/policies/{PolicyName}"},"input":{"type":"structure","required":["EmailIdentity","PolicyName","Policy"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"PolicyName":{"location":"uri","locationName":"PolicyName"},"Policy":{}}},"output":{"type":"structure","members":{}}},"CreateEmailTemplate":{"http":{"requestUri":"/v2/email/templates"},"input":{"type":"structure","required":["TemplateName","TemplateContent"],"members":{"TemplateName":{},"TemplateContent":{"shape":"S2n"}}},"output":{"type":"structure","members":{}}},"CreateImportJob":{"http":{"requestUri":"/v2/email/import-jobs"},"input":{"type":"structure","required":["ImportDestination","ImportDataSource"],"members":{"ImportDestination":{"shape":"S2s"},"ImportDataSource":{"shape":"S2x"}}},"output":{"type":"structure","members":{"JobId":{}}}},"DeleteConfigurationSet":{"http":{"method":"DELETE","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"http":{"method":"DELETE","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}}},"output":{"type":"structure","members":{}}},"DeleteContact":{"http":{"method":"DELETE","requestUri":"/v2/email/contact-lists/{ContactListName}/contacts/{EmailAddress}"},"input":{"type":"structure","required":["ContactListName","EmailAddress"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"},"EmailAddress":{"location":"uri","locationName":"EmailAddress"}}},"output":{"type":"structure","members":{}}},"DeleteContactList":{"http":{"method":"DELETE","requestUri":"/v2/email/contact-lists/{ContactListName}"},"input":{"type":"structure","required":["ContactListName"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"}}},"output":{"type":"structure","members":{}}},"DeleteCustomVerificationEmailTemplate":{"http":{"method":"DELETE","requestUri":"/v2/email/custom-verification-email-templates/{TemplateName}"},"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"}}},"output":{"type":"structure","members":{}}},"DeleteDedicatedIpPool":{"http":{"method":"DELETE","requestUri":"/v2/email/dedicated-ip-pools/{PoolName}"},"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{"location":"uri","locationName":"PoolName"}}},"output":{"type":"structure","members":{}}},"DeleteEmailIdentity":{"http":{"method":"DELETE","requestUri":"/v2/email/identities/{EmailIdentity}"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{}}},"DeleteEmailIdentityPolicy":{"http":{"method":"DELETE","requestUri":"/v2/email/identities/{EmailIdentity}/policies/{PolicyName}"},"input":{"type":"structure","required":["EmailIdentity","PolicyName"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"PolicyName":{"location":"uri","locationName":"PolicyName"}}},"output":{"type":"structure","members":{}}},"DeleteEmailTemplate":{"http":{"method":"DELETE","requestUri":"/v2/email/templates/{TemplateName}"},"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"}}},"output":{"type":"structure","members":{}}},"DeleteSuppressedDestination":{"http":{"method":"DELETE","requestUri":"/v2/email/suppression/addresses/{EmailAddress}"},"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{"location":"uri","locationName":"EmailAddress"}}},"output":{"type":"structure","members":{}}},"GetAccount":{"http":{"method":"GET","requestUri":"/v2/email/account"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DedicatedIpAutoWarmupEnabled":{"type":"boolean"},"EnforcementStatus":{},"ProductionAccessEnabled":{"type":"boolean"},"SendQuota":{"type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}},"SendingEnabled":{"type":"boolean"},"SuppressionAttributes":{"type":"structure","members":{"SuppressedReasons":{"shape":"Sh"}}},"Details":{"type":"structure","members":{"MailType":{},"WebsiteURL":{"shape":"S3w"},"ContactLanguage":{},"UseCaseDescription":{"shape":"S3y"},"AdditionalContactEmailAddresses":{"shape":"S3z"},"ReviewDetails":{"type":"structure","members":{"Status":{},"CaseId":{}}}}}}}},"GetBlacklistReports":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard/blacklist-report"},"input":{"type":"structure","required":["BlacklistItemNames"],"members":{"BlacklistItemNames":{"location":"querystring","locationName":"BlacklistItemNames","type":"list","member":{}}}},"output":{"type":"structure","required":["BlacklistReport"],"members":{"BlacklistReport":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"RblName":{},"ListingTime":{"type":"timestamp"},"Description":{}}}}}}}},"GetConfigurationSet":{"http":{"method":"GET","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"S3"},"DeliveryOptions":{"shape":"S5"},"ReputationOptions":{"shape":"S8"},"SendingOptions":{"shape":"Sb"},"Tags":{"shape":"Sc"},"SuppressionOptions":{"shape":"Sg"}}}},"GetConfigurationSetEventDestinations":{"http":{"method":"GET","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{"EventDestinations":{"type":"list","member":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sn"},"KinesisFirehoseDestination":{"shape":"Sp"},"CloudWatchDestination":{"shape":"Sr"},"SnsDestination":{"shape":"Sx"},"PinpointDestination":{"shape":"Sy"}}}}}}},"GetContact":{"http":{"method":"GET","requestUri":"/v2/email/contact-lists/{ContactListName}/contacts/{EmailAddress}"},"input":{"type":"structure","required":["ContactListName","EmailAddress"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"},"EmailAddress":{"location":"uri","locationName":"EmailAddress"}}},"output":{"type":"structure","members":{"ContactListName":{},"EmailAddress":{},"TopicPreferences":{"shape":"S13"},"TopicDefaultPreferences":{"shape":"S13"},"UnsubscribeAll":{"type":"boolean"},"AttributesData":{},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}},"GetContactList":{"http":{"method":"GET","requestUri":"/v2/email/contact-lists/{ContactListName}"},"input":{"type":"structure","required":["ContactListName"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"}}},"output":{"type":"structure","members":{"ContactListName":{},"Topics":{"shape":"S1b"},"Description":{},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Tags":{"shape":"Sc"}}}},"GetCustomVerificationEmailTemplate":{"http":{"method":"GET","requestUri":"/v2/email/custom-verification-email-templates/{TemplateName}"},"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"}}},"output":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"GetDedicatedIp":{"http":{"method":"GET","requestUri":"/v2/email/dedicated-ips/{IP}"},"input":{"type":"structure","required":["Ip"],"members":{"Ip":{"location":"uri","locationName":"IP"}}},"output":{"type":"structure","members":{"DedicatedIp":{"shape":"S4s"}}}},"GetDedicatedIps":{"http":{"method":"GET","requestUri":"/v2/email/dedicated-ips"},"input":{"type":"structure","members":{"PoolName":{"location":"querystring","locationName":"PoolName"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"DedicatedIps":{"type":"list","member":{"shape":"S4s"}},"NextToken":{}}}},"GetDeliverabilityDashboardOptions":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["DashboardEnabled"],"members":{"DashboardEnabled":{"type":"boolean"},"SubscriptionExpiryDate":{"type":"timestamp"},"AccountStatus":{},"ActiveSubscribedDomains":{"shape":"S53"},"PendingExpirationSubscribedDomains":{"shape":"S53"}}}},"GetDeliverabilityTestReport":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard/test-reports/{ReportId}"},"input":{"type":"structure","required":["ReportId"],"members":{"ReportId":{"location":"uri","locationName":"ReportId"}}},"output":{"type":"structure","required":["DeliverabilityTestReport","OverallPlacement","IspPlacements"],"members":{"DeliverabilityTestReport":{"shape":"S5b"},"OverallPlacement":{"shape":"S5d"},"IspPlacements":{"type":"list","member":{"type":"structure","members":{"IspName":{},"PlacementStatistics":{"shape":"S5d"}}}},"Message":{},"Tags":{"shape":"Sc"}}}},"GetDomainDeliverabilityCampaign":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard/campaigns/{CampaignId}"},"input":{"type":"structure","required":["CampaignId"],"members":{"CampaignId":{"location":"uri","locationName":"CampaignId"}}},"output":{"type":"structure","required":["DomainDeliverabilityCampaign"],"members":{"DomainDeliverabilityCampaign":{"shape":"S5l"}}}},"GetDomainStatisticsReport":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard/statistics-report/{Domain}"},"input":{"type":"structure","required":["Domain","StartDate","EndDate"],"members":{"Domain":{"location":"uri","locationName":"Domain"},"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"}}},"output":{"type":"structure","required":["OverallVolume","DailyVolumes"],"members":{"OverallVolume":{"type":"structure","members":{"VolumeStatistics":{"shape":"S5v"},"ReadRatePercent":{"type":"double"},"DomainIspPlacements":{"shape":"S5w"}}},"DailyVolumes":{"type":"list","member":{"type":"structure","members":{"StartDate":{"type":"timestamp"},"VolumeStatistics":{"shape":"S5v"},"DomainIspPlacements":{"shape":"S5w"}}}}}}},"GetEmailIdentity":{"http":{"method":"GET","requestUri":"/v2/email/identities/{EmailIdentity}"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{"IdentityType":{},"FeedbackForwardingStatus":{"type":"boolean"},"VerifiedForSendingStatus":{"type":"boolean"},"DkimAttributes":{"shape":"S2c"},"MailFromAttributes":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMxFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMxFailure":{}}},"Policies":{"shape":"S66"},"Tags":{"shape":"Sc"},"ConfigurationSetName":{}}}},"GetEmailIdentityPolicies":{"http":{"method":"GET","requestUri":"/v2/email/identities/{EmailIdentity}/policies"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{"Policies":{"shape":"S66"}}}},"GetEmailTemplate":{"http":{"method":"GET","requestUri":"/v2/email/templates/{TemplateName}"},"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"}}},"output":{"type":"structure","required":["TemplateName","TemplateContent"],"members":{"TemplateName":{},"TemplateContent":{"shape":"S2n"}}}},"GetImportJob":{"http":{"method":"GET","requestUri":"/v2/email/import-jobs/{JobId}"},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{"location":"uri","locationName":"JobId"}}},"output":{"type":"structure","members":{"JobId":{},"ImportDestination":{"shape":"S2s"},"ImportDataSource":{"shape":"S2x"},"FailureInfo":{"type":"structure","members":{"FailedRecordsS3Url":{},"ErrorMessage":{}}},"JobStatus":{},"CreatedTimestamp":{"type":"timestamp"},"CompletedTimestamp":{"type":"timestamp"},"ProcessedRecordsCount":{"type":"integer"},"FailedRecordsCount":{"type":"integer"}}}},"GetSuppressedDestination":{"http":{"method":"GET","requestUri":"/v2/email/suppression/addresses/{EmailAddress}"},"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{"location":"uri","locationName":"EmailAddress"}}},"output":{"type":"structure","required":["SuppressedDestination"],"members":{"SuppressedDestination":{"type":"structure","required":["EmailAddress","Reason","LastUpdateTime"],"members":{"EmailAddress":{},"Reason":{},"LastUpdateTime":{"type":"timestamp"},"Attributes":{"type":"structure","members":{"MessageId":{},"FeedbackId":{}}}}}}}},"ListConfigurationSets":{"http":{"method":"GET","requestUri":"/v2/email/configuration-sets"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationSets":{"type":"list","member":{}},"NextToken":{}}}},"ListContactLists":{"http":{"method":"GET","requestUri":"/v2/email/contact-lists"},"input":{"type":"structure","members":{"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ContactLists":{"type":"list","member":{"type":"structure","members":{"ContactListName":{},"LastUpdatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListContacts":{"http":{"method":"GET","requestUri":"/v2/email/contact-lists/{ContactListName}/contacts"},"input":{"type":"structure","required":["ContactListName"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"},"Filter":{"type":"structure","members":{"FilteredStatus":{},"TopicFilter":{"type":"structure","members":{"TopicName":{},"UseDefaultIfPreferenceUnavailable":{"type":"boolean"}}}}},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Contacts":{"type":"list","member":{"type":"structure","members":{"EmailAddress":{},"TopicPreferences":{"shape":"S13"},"TopicDefaultPreferences":{"shape":"S13"},"UnsubscribeAll":{"type":"boolean"},"LastUpdatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListCustomVerificationEmailTemplates":{"http":{"method":"GET","requestUri":"/v2/email/custom-verification-email-templates"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"CustomVerificationEmailTemplates":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"NextToken":{}}}},"ListDedicatedIpPools":{"http":{"method":"GET","requestUri":"/v2/email/dedicated-ip-pools"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"DedicatedIpPools":{"type":"list","member":{}},"NextToken":{}}}},"ListDeliverabilityTestReports":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard/test-reports"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","required":["DeliverabilityTestReports"],"members":{"DeliverabilityTestReports":{"type":"list","member":{"shape":"S5b"}},"NextToken":{}}}},"ListDomainDeliverabilityCampaigns":{"http":{"method":"GET","requestUri":"/v2/email/deliverability-dashboard/domains/{SubscribedDomain}/campaigns"},"input":{"type":"structure","required":["StartDate","EndDate","SubscribedDomain"],"members":{"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"},"SubscribedDomain":{"location":"uri","locationName":"SubscribedDomain"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","required":["DomainDeliverabilityCampaigns"],"members":{"DomainDeliverabilityCampaigns":{"type":"list","member":{"shape":"S5l"}},"NextToken":{}}}},"ListEmailIdentities":{"http":{"method":"GET","requestUri":"/v2/email/identities"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"EmailIdentities":{"type":"list","member":{"type":"structure","members":{"IdentityType":{},"IdentityName":{},"SendingEnabled":{"type":"boolean"}}}},"NextToken":{}}}},"ListEmailTemplates":{"http":{"method":"GET","requestUri":"/v2/email/templates"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListImportJobs":{"http":{"method":"GET","requestUri":"/v2/email/import-jobs"},"input":{"type":"structure","members":{"ImportDestinationType":{},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"ImportJobs":{"type":"list","member":{"type":"structure","members":{"JobId":{},"ImportDestination":{"shape":"S2s"},"JobStatus":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListSuppressedDestinations":{"http":{"method":"GET","requestUri":"/v2/email/suppression/addresses"},"input":{"type":"structure","members":{"Reasons":{"shape":"Sh","location":"querystring","locationName":"Reason"},"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"SuppressedDestinationSummaries":{"type":"list","member":{"type":"structure","required":["EmailAddress","Reason","LastUpdateTime"],"members":{"EmailAddress":{},"Reason":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v2/email/tags"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"querystring","locationName":"ResourceArn"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sc"}}}},"PutAccountDedicatedIpWarmupAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/account/dedicated-ips/warmup"},"input":{"type":"structure","members":{"AutoWarmupEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutAccountDetails":{"http":{"requestUri":"/v2/email/account/details"},"input":{"type":"structure","required":["MailType","WebsiteURL","UseCaseDescription"],"members":{"MailType":{},"WebsiteURL":{"shape":"S3w"},"ContactLanguage":{},"UseCaseDescription":{"shape":"S3y"},"AdditionalContactEmailAddresses":{"shape":"S3z"},"ProductionAccessEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutAccountSendingAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/account/sending"},"input":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutAccountSuppressionAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/account/suppression"},"input":{"type":"structure","members":{"SuppressedReasons":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetDeliveryOptions":{"http":{"method":"PUT","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/delivery-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"TlsPolicy":{},"SendingPoolName":{}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetReputationOptions":{"http":{"method":"PUT","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/reputation-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"ReputationMetricsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetSendingOptions":{"http":{"method":"PUT","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/sending"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"SendingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetSuppressionOptions":{"http":{"method":"PUT","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/suppression-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"SuppressedReasons":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetTrackingOptions":{"http":{"method":"PUT","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/tracking-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"CustomRedirectDomain":{}}},"output":{"type":"structure","members":{}}},"PutDedicatedIpInPool":{"http":{"method":"PUT","requestUri":"/v2/email/dedicated-ips/{IP}/pool"},"input":{"type":"structure","required":["Ip","DestinationPoolName"],"members":{"Ip":{"location":"uri","locationName":"IP"},"DestinationPoolName":{}}},"output":{"type":"structure","members":{}}},"PutDedicatedIpWarmupAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/dedicated-ips/{IP}/warmup"},"input":{"type":"structure","required":["Ip","WarmupPercentage"],"members":{"Ip":{"location":"uri","locationName":"IP"},"WarmupPercentage":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"PutDeliverabilityDashboardOption":{"http":{"method":"PUT","requestUri":"/v2/email/deliverability-dashboard"},"input":{"type":"structure","required":["DashboardEnabled"],"members":{"DashboardEnabled":{"type":"boolean"},"SubscribedDomains":{"shape":"S53"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityConfigurationSetAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/identities/{EmailIdentity}/configuration-set"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"ConfigurationSetName":{}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityDkimAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/identities/{EmailIdentity}/dkim"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"SigningEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityDkimSigningAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/dkim/signing"},"input":{"type":"structure","required":["EmailIdentity","SigningAttributesOrigin"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"SigningAttributesOrigin":{},"SigningAttributes":{"shape":"S26"}}},"output":{"type":"structure","members":{"DkimStatus":{},"DkimTokens":{"shape":"S2e"}}}},"PutEmailIdentityFeedbackAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/identities/{EmailIdentity}/feedback"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"EmailForwardingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityMailFromAttributes":{"http":{"method":"PUT","requestUri":"/v2/email/identities/{EmailIdentity}/mail-from"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"MailFromDomain":{},"BehaviorOnMxFailure":{}}},"output":{"type":"structure","members":{}}},"PutSuppressedDestination":{"http":{"method":"PUT","requestUri":"/v2/email/suppression/addresses"},"input":{"type":"structure","required":["EmailAddress","Reason"],"members":{"EmailAddress":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBulkEmail":{"http":{"requestUri":"/v2/email/outbound-bulk-emails"},"input":{"type":"structure","required":["DefaultContent","BulkEmailEntries"],"members":{"FromEmailAddress":{},"FromEmailAddressIdentityArn":{},"ReplyToAddresses":{"shape":"S92"},"FeedbackForwardingEmailAddress":{},"FeedbackForwardingEmailAddressIdentityArn":{},"DefaultEmailTags":{"shape":"S93"},"DefaultContent":{"type":"structure","members":{"Template":{"shape":"S1z"}}},"BulkEmailEntries":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S9a"},"ReplacementTags":{"shape":"S93"},"ReplacementEmailContent":{"type":"structure","members":{"ReplacementTemplate":{"type":"structure","members":{"ReplacementTemplateData":{}}}}}}}},"ConfigurationSetName":{}}},"output":{"type":"structure","required":["BulkEmailEntryResults"],"members":{"BulkEmailEntryResults":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendCustomVerificationEmail":{"http":{"requestUri":"/v2/email/outbound-custom-verification-emails"},"input":{"type":"structure","required":["EmailAddress","TemplateName"],"members":{"EmailAddress":{},"TemplateName":{},"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"MessageId":{}}}},"SendEmail":{"http":{"requestUri":"/v2/email/outbound-emails"},"input":{"type":"structure","required":["Content"],"members":{"FromEmailAddress":{},"FromEmailAddressIdentityArn":{},"Destination":{"shape":"S9a"},"ReplyToAddresses":{"shape":"S92"},"FeedbackForwardingEmailAddress":{},"FeedbackForwardingEmailAddressIdentityArn":{},"Content":{"shape":"S1r"},"EmailTags":{"shape":"S93"},"ConfigurationSetName":{},"ListManagementOptions":{"type":"structure","required":["ContactListName"],"members":{"ContactListName":{},"TopicName":{}}}}},"output":{"type":"structure","members":{"MessageId":{}}}},"TagResource":{"http":{"requestUri":"/v2/email/tags"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"TestRenderEmailTemplate":{"http":{"requestUri":"/v2/email/templates/{TemplateName}/render"},"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"},"TemplateData":{}}},"output":{"type":"structure","required":["RenderedTemplate"],"members":{"RenderedTemplate":{}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v2/email/tags"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"querystring","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"TagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConfigurationSetEventDestination":{"http":{"method":"PUT","requestUri":"/v2/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","EventDestination"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"},"EventDestination":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"UpdateContact":{"http":{"method":"PUT","requestUri":"/v2/email/contact-lists/{ContactListName}/contacts/{EmailAddress}"},"input":{"type":"structure","required":["ContactListName","EmailAddress"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"},"EmailAddress":{"location":"uri","locationName":"EmailAddress"},"TopicPreferences":{"shape":"S13"},"UnsubscribeAll":{"type":"boolean"},"AttributesData":{}}},"output":{"type":"structure","members":{}}},"UpdateContactList":{"http":{"method":"PUT","requestUri":"/v2/email/contact-lists/{ContactListName}"},"input":{"type":"structure","required":["ContactListName"],"members":{"ContactListName":{"location":"uri","locationName":"ContactListName"},"Topics":{"shape":"S1b"},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateCustomVerificationEmailTemplate":{"http":{"method":"PUT","requestUri":"/v2/email/custom-verification-email-templates/{TemplateName}"},"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}},"output":{"type":"structure","members":{}}},"UpdateEmailIdentityPolicy":{"http":{"method":"PUT","requestUri":"/v2/email/identities/{EmailIdentity}/policies/{PolicyName}"},"input":{"type":"structure","required":["EmailIdentity","PolicyName","Policy"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"PolicyName":{"location":"uri","locationName":"PolicyName"},"Policy":{}}},"output":{"type":"structure","members":{}}},"UpdateEmailTemplate":{"http":{"method":"PUT","requestUri":"/v2/email/templates/{TemplateName}"},"input":{"type":"structure","required":["TemplateName","TemplateContent"],"members":{"TemplateName":{"location":"uri","locationName":"TemplateName"},"TemplateContent":{"shape":"S2n"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","required":["CustomRedirectDomain"],"members":{"CustomRedirectDomain":{}}},"S5":{"type":"structure","members":{"TlsPolicy":{},"SendingPoolName":{}}},"S8":{"type":"structure","members":{"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}},"Sb":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"}}},"Sc":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sg":{"type":"structure","members":{"SuppressedReasons":{"shape":"Sh"}}},"Sh":{"type":"list","member":{}},"Sm":{"type":"structure","members":{"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sn"},"KinesisFirehoseDestination":{"shape":"Sp"},"CloudWatchDestination":{"shape":"Sr"},"SnsDestination":{"shape":"Sx"},"PinpointDestination":{"shape":"Sy"}}},"Sn":{"type":"list","member":{}},"Sp":{"type":"structure","required":["IamRoleArn","DeliveryStreamArn"],"members":{"IamRoleArn":{},"DeliveryStreamArn":{}}},"Sr":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"Sx":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"Sy":{"type":"structure","members":{"ApplicationArn":{}}},"S13":{"type":"list","member":{"type":"structure","required":["TopicName","SubscriptionStatus"],"members":{"TopicName":{},"SubscriptionStatus":{}}}},"S1b":{"type":"list","member":{"type":"structure","required":["TopicName","DisplayName","DefaultSubscriptionStatus"],"members":{"TopicName":{},"DisplayName":{},"Description":{},"DefaultSubscriptionStatus":{}}}},"S1r":{"type":"structure","members":{"Simple":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S1t"},"Body":{"type":"structure","members":{"Text":{"shape":"S1t"},"Html":{"shape":"S1t"}}}}},"Raw":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"Template":{"shape":"S1z"}}},"S1t":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}},"S1z":{"type":"structure","members":{"TemplateName":{},"TemplateArn":{},"TemplateData":{}}},"S26":{"type":"structure","members":{"DomainSigningSelector":{},"DomainSigningPrivateKey":{"type":"string","sensitive":true},"NextSigningKeyLength":{}}},"S2c":{"type":"structure","members":{"SigningEnabled":{"type":"boolean"},"Status":{},"Tokens":{"shape":"S2e"},"SigningAttributesOrigin":{},"NextSigningKeyLength":{},"CurrentSigningKeyLength":{},"LastKeyGenerationTimestamp":{"type":"timestamp"}}},"S2e":{"type":"list","member":{}},"S2n":{"type":"structure","members":{"Subject":{},"Text":{},"Html":{}}},"S2s":{"type":"structure","members":{"SuppressionListDestination":{"type":"structure","required":["SuppressionListImportAction"],"members":{"SuppressionListImportAction":{}}},"ContactListDestination":{"type":"structure","required":["ContactListName","ContactListImportAction"],"members":{"ContactListName":{},"ContactListImportAction":{}}}}},"S2x":{"type":"structure","required":["S3Url","DataFormat"],"members":{"S3Url":{},"DataFormat":{}}},"S3w":{"type":"string","sensitive":true},"S3y":{"type":"string","sensitive":true},"S3z":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true},"S4s":{"type":"structure","required":["Ip","WarmupStatus","WarmupPercentage"],"members":{"Ip":{},"WarmupStatus":{},"WarmupPercentage":{"type":"integer"},"PoolName":{}}},"S53":{"type":"list","member":{"type":"structure","members":{"Domain":{},"SubscriptionStartDate":{"type":"timestamp"},"InboxPlacementTrackingOption":{"type":"structure","members":{"Global":{"type":"boolean"},"TrackedIsps":{"type":"list","member":{}}}}}}},"S5b":{"type":"structure","members":{"ReportId":{},"ReportName":{},"Subject":{},"FromEmailAddress":{},"CreateDate":{"type":"timestamp"},"DeliverabilityTestStatus":{}}},"S5d":{"type":"structure","members":{"InboxPercentage":{"type":"double"},"SpamPercentage":{"type":"double"},"MissingPercentage":{"type":"double"},"SpfPercentage":{"type":"double"},"DkimPercentage":{"type":"double"}}},"S5l":{"type":"structure","members":{"CampaignId":{},"ImageUrl":{},"Subject":{},"FromAddress":{},"SendingIps":{"type":"list","member":{}},"FirstSeenDateTime":{"type":"timestamp"},"LastSeenDateTime":{"type":"timestamp"},"InboxCount":{"type":"long"},"SpamCount":{"type":"long"},"ReadRate":{"type":"double"},"DeleteRate":{"type":"double"},"ReadDeleteRate":{"type":"double"},"ProjectedVolume":{"type":"long"},"Esps":{"type":"list","member":{}}}},"S5v":{"type":"structure","members":{"InboxRawCount":{"type":"long"},"SpamRawCount":{"type":"long"},"ProjectedInbox":{"type":"long"},"ProjectedSpam":{"type":"long"}}},"S5w":{"type":"list","member":{"type":"structure","members":{"IspName":{},"InboxRawCount":{"type":"long"},"SpamRawCount":{"type":"long"},"InboxPercentage":{"type":"double"},"SpamPercentage":{"type":"double"}}}},"S66":{"type":"map","key":{},"value":{}},"S92":{"type":"list","member":{}},"S93":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S9a":{"type":"structure","members":{"ToAddresses":{"shape":"S92"},"CcAddresses":{"shape":"S92"},"BccAddresses":{"shape":"S92"}}}}}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetDedicatedIps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListConfigurationSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListContactLists":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListContacts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListCustomVerificationEmailTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDedicatedIpPools":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDeliverabilityTestReports":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDomainDeliverabilityCampaigns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListEmailIdentities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListEmailTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListImportJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListSuppressedDestinations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"}}}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['migrationhubconfig'] = {};
	AWS.MigrationHubConfig = Service.defineService('migrationhubconfig', ['2019-06-30']);
	Object.defineProperty(apiLoader.services['migrationhubconfig'], '2019-06-30', {
	  get: function get() {
	    var model = __webpack_require__(810);
	    model.paginators = __webpack_require__(811).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MigrationHubConfig;


/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-06-30","endpointPrefix":"migrationhub-config","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Migration Hub Config","serviceId":"MigrationHub Config","signatureVersion":"v4","signingName":"mgh","targetPrefix":"AWSMigrationHubMultiAccountService","uid":"migrationhub-config-2019-06-30"},"operations":{"CreateHomeRegionControl":{"input":{"type":"structure","required":["HomeRegion","Target"],"members":{"HomeRegion":{},"Target":{"shape":"S3"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"HomeRegionControl":{"shape":"S8"}}}},"DescribeHomeRegionControls":{"input":{"type":"structure","members":{"ControlId":{},"HomeRegion":{},"Target":{"shape":"S3"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HomeRegionControls":{"type":"list","member":{"shape":"S8"}},"NextToken":{}}}},"GetHomeRegion":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"HomeRegion":{}}}}},"shapes":{"S3":{"type":"structure","required":["Type"],"members":{"Type":{},"Id":{}}},"S8":{"type":"structure","members":{"ControlId":{},"HomeRegion":{},"Target":{"shape":"S3"},"RequestedTime":{"type":"timestamp"}}}}}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeHomeRegionControls":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['connectparticipant'] = {};
	AWS.ConnectParticipant = Service.defineService('connectparticipant', ['2018-09-07']);
	Object.defineProperty(apiLoader.services['connectparticipant'], '2018-09-07', {
	  get: function get() {
	    var model = __webpack_require__(813);
	    model.paginators = __webpack_require__(814).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ConnectParticipant;


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-07","endpointPrefix":"participant.connect","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon Connect Participant","serviceFullName":"Amazon Connect Participant Service","serviceId":"ConnectParticipant","signatureVersion":"v4","signingName":"execute-api","uid":"connectparticipant-2018-09-07"},"operations":{"CompleteAttachmentUpload":{"http":{"requestUri":"/participant/complete-attachment-upload"},"input":{"type":"structure","required":["AttachmentIds","ClientToken","ConnectionToken"],"members":{"AttachmentIds":{"type":"list","member":{}},"ClientToken":{"idempotencyToken":true},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{}}},"CreateParticipantConnection":{"http":{"requestUri":"/participant/connection"},"input":{"type":"structure","required":["Type","ParticipantToken"],"members":{"Type":{"type":"list","member":{}},"ParticipantToken":{"location":"header","locationName":"X-Amz-Bearer"},"ConnectParticipant":{"type":"boolean"}}},"output":{"type":"structure","members":{"Websocket":{"type":"structure","members":{"Url":{},"ConnectionExpiry":{}}},"ConnectionCredentials":{"type":"structure","members":{"ConnectionToken":{},"Expiry":{}}}}}},"DisconnectParticipant":{"http":{"requestUri":"/participant/disconnect"},"input":{"type":"structure","required":["ConnectionToken"],"members":{"ClientToken":{"idempotencyToken":true},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{}}},"GetAttachment":{"http":{"requestUri":"/participant/attachment"},"input":{"type":"structure","required":["AttachmentId","ConnectionToken"],"members":{"AttachmentId":{},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{"Url":{},"UrlExpiry":{}}}},"GetTranscript":{"http":{"requestUri":"/participant/transcript"},"input":{"type":"structure","required":["ConnectionToken"],"members":{"ContactId":{},"MaxResults":{"type":"integer"},"NextToken":{},"ScanDirection":{},"SortOrder":{},"StartPosition":{"type":"structure","members":{"Id":{},"AbsoluteTime":{},"MostRecent":{"type":"integer"}}},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{"InitialContactId":{},"Transcript":{"type":"list","member":{"type":"structure","members":{"AbsoluteTime":{},"Content":{},"ContentType":{},"Id":{},"Type":{},"ParticipantId":{},"DisplayName":{},"ParticipantRole":{},"Attachments":{"type":"list","member":{"type":"structure","members":{"ContentType":{},"AttachmentId":{},"AttachmentName":{},"Status":{}}}}}}},"NextToken":{}}}},"SendEvent":{"http":{"requestUri":"/participant/event"},"input":{"type":"structure","required":["ContentType","ConnectionToken"],"members":{"ContentType":{},"Content":{},"ClientToken":{"idempotencyToken":true},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{"Id":{},"AbsoluteTime":{}}}},"SendMessage":{"http":{"requestUri":"/participant/message"},"input":{"type":"structure","required":["ContentType","Content","ConnectionToken"],"members":{"ContentType":{},"Content":{},"ClientToken":{"idempotencyToken":true},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{"Id":{},"AbsoluteTime":{}}}},"StartAttachmentUpload":{"http":{"requestUri":"/participant/start-attachment-upload"},"input":{"type":"structure","required":["ContentType","AttachmentSizeInBytes","AttachmentName","ClientToken","ConnectionToken"],"members":{"ContentType":{},"AttachmentSizeInBytes":{"type":"long"},"AttachmentName":{},"ClientToken":{"idempotencyToken":true},"ConnectionToken":{"location":"header","locationName":"X-Amz-Bearer"}}},"output":{"type":"structure","members":{"AttachmentId":{},"UploadMetadata":{"type":"structure","members":{"Url":{},"UrlExpiry":{},"HeadersToInclude":{"type":"map","key":{},"value":{}}}}}}}},"shapes":{}}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetTranscript":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appconfig'] = {};
	AWS.AppConfig = Service.defineService('appconfig', ['2019-10-09']);
	Object.defineProperty(apiLoader.services['appconfig'], '2019-10-09', {
	  get: function get() {
	    var model = __webpack_require__(816);
	    model.paginators = __webpack_require__(817).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppConfig;


/***/ }),
/* 816 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-10-09","endpointPrefix":"appconfig","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AppConfig","serviceFullName":"Amazon AppConfig","serviceId":"AppConfig","signatureVersion":"v4","signingName":"appconfig","uid":"appconfig-2019-10-09"},"operations":{"CreateApplication":{"http":{"requestUri":"/applications","responseCode":201},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"Tags":{"shape":"S4"}}},"output":{"shape":"S7"}},"CreateConfigurationProfile":{"http":{"requestUri":"/applications/{ApplicationId}/configurationprofiles","responseCode":201},"input":{"type":"structure","required":["ApplicationId","Name","LocationUri"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"Name":{},"Description":{},"LocationUri":{},"RetrievalRoleArn":{},"Validators":{"shape":"Sc"},"Tags":{"shape":"S4"},"Type":{}}},"output":{"shape":"Sh"}},"CreateDeploymentStrategy":{"http":{"requestUri":"/deploymentstrategies","responseCode":201},"input":{"type":"structure","required":["Name","DeploymentDurationInMinutes","GrowthFactor","ReplicateTo"],"members":{"Name":{},"Description":{},"DeploymentDurationInMinutes":{"type":"integer"},"FinalBakeTimeInMinutes":{"type":"integer"},"GrowthFactor":{"type":"float"},"GrowthType":{},"ReplicateTo":{},"Tags":{"shape":"S4"}}},"output":{"shape":"Sn"}},"CreateEnvironment":{"http":{"requestUri":"/applications/{ApplicationId}/environments","responseCode":201},"input":{"type":"structure","required":["ApplicationId","Name"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"Name":{},"Description":{},"Monitors":{"shape":"Sq"},"Tags":{"shape":"S4"}}},"output":{"shape":"St"}},"CreateHostedConfigurationVersion":{"http":{"requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}/hostedconfigurationversions","responseCode":201},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId","Content","ContentType"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"},"Description":{"location":"header","locationName":"Description"},"Content":{"shape":"Sw"},"ContentType":{"location":"header","locationName":"Content-Type"},"LatestVersionNumber":{"location":"header","locationName":"Latest-Version-Number","type":"integer"}},"payload":"Content"},"output":{"shape":"Sz"}},"DeleteApplication":{"http":{"method":"DELETE","requestUri":"/applications/{ApplicationId}","responseCode":204},"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"}}}},"DeleteConfigurationProfile":{"http":{"method":"DELETE","requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}","responseCode":204},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"}}}},"DeleteDeploymentStrategy":{"http":{"method":"DELETE","requestUri":"/deployementstrategies/{DeploymentStrategyId}","responseCode":204},"input":{"type":"structure","required":["DeploymentStrategyId"],"members":{"DeploymentStrategyId":{"location":"uri","locationName":"DeploymentStrategyId"}}}},"DeleteEnvironment":{"http":{"method":"DELETE","requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}","responseCode":204},"input":{"type":"structure","required":["ApplicationId","EnvironmentId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"}}}},"DeleteHostedConfigurationVersion":{"http":{"method":"DELETE","requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}/hostedconfigurationversions/{VersionNumber}","responseCode":204},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId","VersionNumber"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"integer"}}}},"GetApplication":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}","responseCode":200},"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"}}},"output":{"shape":"S7"}},"GetConfiguration":{"http":{"method":"GET","requestUri":"/applications/{Application}/environments/{Environment}/configurations/{Configuration}","responseCode":200},"input":{"type":"structure","required":["Application","Environment","Configuration","ClientId"],"members":{"Application":{"location":"uri","locationName":"Application"},"Environment":{"location":"uri","locationName":"Environment"},"Configuration":{"location":"uri","locationName":"Configuration"},"ClientId":{"location":"querystring","locationName":"client_id"},"ClientConfigurationVersion":{"location":"querystring","locationName":"client_configuration_version"}}},"output":{"type":"structure","members":{"Content":{"shape":"Sw"},"ConfigurationVersion":{"location":"header","locationName":"Configuration-Version"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Content"},"deprecated":true,"deprecatedMessage":"This API has been deprecated in favor of the GetLatestConfiguration API used in conjunction with StartConfigurationSession."},"GetConfigurationProfile":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}","responseCode":200},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"}}},"output":{"shape":"Sh"}},"GetDeployment":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}/deployments/{DeploymentNumber}","responseCode":200},"input":{"type":"structure","required":["ApplicationId","EnvironmentId","DeploymentNumber"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"},"DeploymentNumber":{"location":"uri","locationName":"DeploymentNumber","type":"integer"}}},"output":{"shape":"S1e"}},"GetDeploymentStrategy":{"http":{"method":"GET","requestUri":"/deploymentstrategies/{DeploymentStrategyId}","responseCode":200},"input":{"type":"structure","required":["DeploymentStrategyId"],"members":{"DeploymentStrategyId":{"location":"uri","locationName":"DeploymentStrategyId"}}},"output":{"shape":"Sn"}},"GetEnvironment":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}","responseCode":200},"input":{"type":"structure","required":["ApplicationId","EnvironmentId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"}}},"output":{"shape":"St"}},"GetHostedConfigurationVersion":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}/hostedconfigurationversions/{VersionNumber}","responseCode":200},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId","VersionNumber"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"integer"}}},"output":{"shape":"Sz"}},"ListApplications":{"http":{"method":"GET","requestUri":"/applications","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"shape":"S7"}},"NextToken":{}}}},"ListConfigurationProfiles":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/configurationprofiles","responseCode":200},"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"},"Type":{"location":"querystring","locationName":"type"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"Id":{},"Name":{},"LocationUri":{},"ValidatorTypes":{"type":"list","member":{}},"Type":{}}}},"NextToken":{}}}},"ListDeploymentStrategies":{"http":{"method":"GET","requestUri":"/deploymentstrategies","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"shape":"Sn"}},"NextToken":{}}}},"ListDeployments":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}/deployments","responseCode":200},"input":{"type":"structure","required":["ApplicationId","EnvironmentId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"},"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"DeploymentNumber":{"type":"integer"},"ConfigurationName":{},"ConfigurationVersion":{},"DeploymentDurationInMinutes":{"type":"integer"},"GrowthType":{},"GrowthFactor":{"type":"float"},"FinalBakeTimeInMinutes":{"type":"integer"},"State":{},"PercentageComplete":{"type":"float"},"StartedAt":{"shape":"S1k"},"CompletedAt":{"shape":"S1k"}}}},"NextToken":{}}}},"ListEnvironments":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/environments","responseCode":200},"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"shape":"St"}},"NextToken":{}}}},"ListHostedConfigurationVersions":{"http":{"method":"GET","requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}/hostedconfigurationversions","responseCode":200},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"},"MaxResults":{"location":"querystring","locationName":"max_results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next_token"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"ConfigurationProfileId":{},"VersionNumber":{"type":"integer"},"Description":{},"ContentType":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4"}}}},"StartDeployment":{"http":{"requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}/deployments","responseCode":201},"input":{"type":"structure","required":["ApplicationId","EnvironmentId","DeploymentStrategyId","ConfigurationProfileId","ConfigurationVersion"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"},"DeploymentStrategyId":{},"ConfigurationProfileId":{},"ConfigurationVersion":{},"Description":{},"Tags":{"shape":"S4"}}},"output":{"shape":"S1e"}},"StopDeployment":{"http":{"method":"DELETE","requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}/deployments/{DeploymentNumber}","responseCode":202},"input":{"type":"structure","required":["ApplicationId","EnvironmentId","DeploymentNumber"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"},"DeploymentNumber":{"location":"uri","locationName":"DeploymentNumber","type":"integer"}}},"output":{"shape":"S1e"}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S4"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateApplication":{"http":{"method":"PATCH","requestUri":"/applications/{ApplicationId}","responseCode":200},"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"Name":{},"Description":{}}},"output":{"shape":"S7"}},"UpdateConfigurationProfile":{"http":{"method":"PATCH","requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}","responseCode":200},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"},"Name":{},"Description":{},"RetrievalRoleArn":{},"Validators":{"shape":"Sc"}}},"output":{"shape":"Sh"}},"UpdateDeploymentStrategy":{"http":{"method":"PATCH","requestUri":"/deploymentstrategies/{DeploymentStrategyId}","responseCode":200},"input":{"type":"structure","required":["DeploymentStrategyId"],"members":{"DeploymentStrategyId":{"location":"uri","locationName":"DeploymentStrategyId"},"Description":{},"DeploymentDurationInMinutes":{"type":"integer"},"FinalBakeTimeInMinutes":{"type":"integer"},"GrowthFactor":{"type":"float"},"GrowthType":{}}},"output":{"shape":"Sn"}},"UpdateEnvironment":{"http":{"method":"PATCH","requestUri":"/applications/{ApplicationId}/environments/{EnvironmentId}","responseCode":200},"input":{"type":"structure","required":["ApplicationId","EnvironmentId"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"EnvironmentId":{"location":"uri","locationName":"EnvironmentId"},"Name":{},"Description":{},"Monitors":{"shape":"Sq"}}},"output":{"shape":"St"}},"ValidateConfiguration":{"http":{"requestUri":"/applications/{ApplicationId}/configurationprofiles/{ConfigurationProfileId}/validators","responseCode":204},"input":{"type":"structure","required":["ApplicationId","ConfigurationProfileId","ConfigurationVersion"],"members":{"ApplicationId":{"location":"uri","locationName":"ApplicationId"},"ConfigurationProfileId":{"location":"uri","locationName":"ConfigurationProfileId"},"ConfigurationVersion":{"location":"querystring","locationName":"configuration_version"}}}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"Id":{},"Name":{},"Description":{}}},"Sc":{"type":"list","member":{"type":"structure","required":["Type","Content"],"members":{"Type":{},"Content":{"type":"string","sensitive":true}}}},"Sh":{"type":"structure","members":{"ApplicationId":{},"Id":{},"Name":{},"Description":{},"LocationUri":{},"RetrievalRoleArn":{},"Validators":{"shape":"Sc"},"Type":{}}},"Sn":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"DeploymentDurationInMinutes":{"type":"integer"},"GrowthType":{},"GrowthFactor":{"type":"float"},"FinalBakeTimeInMinutes":{"type":"integer"},"ReplicateTo":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["AlarmArn"],"members":{"AlarmArn":{},"AlarmRoleArn":{}}}},"St":{"type":"structure","members":{"ApplicationId":{},"Id":{},"Name":{},"Description":{},"State":{},"Monitors":{"shape":"Sq"}}},"Sw":{"type":"blob","sensitive":true},"Sz":{"type":"structure","members":{"ApplicationId":{"location":"header","locationName":"Application-Id"},"ConfigurationProfileId":{"location":"header","locationName":"Configuration-Profile-Id"},"VersionNumber":{"location":"header","locationName":"Version-Number","type":"integer"},"Description":{"location":"header","locationName":"Description"},"Content":{"shape":"Sw"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Content"},"S1e":{"type":"structure","members":{"ApplicationId":{},"EnvironmentId":{},"DeploymentStrategyId":{},"ConfigurationProfileId":{},"DeploymentNumber":{"type":"integer"},"ConfigurationName":{},"ConfigurationLocationUri":{},"ConfigurationVersion":{},"Description":{},"DeploymentDurationInMinutes":{"type":"integer"},"GrowthType":{},"GrowthFactor":{"type":"float"},"FinalBakeTimeInMinutes":{"type":"integer"},"State":{},"EventLog":{"type":"list","member":{"type":"structure","members":{"EventType":{},"TriggeredBy":{},"Description":{},"OccurredAt":{"shape":"S1k"}}}},"PercentageComplete":{"type":"float"},"StartedAt":{"shape":"S1k"},"CompletedAt":{"shape":"S1k"}}},"S1k":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListConfigurationProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDeploymentStrategies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDeployments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEnvironments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHostedConfigurationVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotsecuretunneling'] = {};
	AWS.IoTSecureTunneling = Service.defineService('iotsecuretunneling', ['2018-10-05']);
	Object.defineProperty(apiLoader.services['iotsecuretunneling'], '2018-10-05', {
	  get: function get() {
	    var model = __webpack_require__(819);
	    model.paginators = __webpack_require__(820).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTSecureTunneling;


/***/ }),
/* 819 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-05","endpointPrefix":"api.tunneling.iot","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS IoT Secure Tunneling","serviceId":"IoTSecureTunneling","signatureVersion":"v4","signingName":"IoTSecuredTunneling","targetPrefix":"IoTSecuredTunneling","uid":"iotsecuretunneling-2018-10-05"},"operations":{"CloseTunnel":{"input":{"type":"structure","required":["tunnelId"],"members":{"tunnelId":{},"delete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeTunnel":{"input":{"type":"structure","required":["tunnelId"],"members":{"tunnelId":{}}},"output":{"type":"structure","members":{"tunnel":{"type":"structure","members":{"tunnelId":{},"tunnelArn":{},"status":{},"sourceConnectionState":{"shape":"Sa"},"destinationConnectionState":{"shape":"Sa"},"description":{},"destinationConfig":{"shape":"Se"},"timeoutConfig":{"shape":"Si"},"tags":{"shape":"Sk"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sk"}}}},"ListTunnels":{"input":{"type":"structure","members":{"thingName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"tunnelSummaries":{"type":"list","member":{"type":"structure","members":{"tunnelId":{},"tunnelArn":{},"status":{},"description":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"OpenTunnel":{"input":{"type":"structure","members":{"description":{},"tags":{"shape":"Sk"},"destinationConfig":{"shape":"Se"},"timeoutConfig":{"shape":"Si"}}},"output":{"type":"structure","members":{"tunnelId":{},"tunnelArn":{},"sourceAccessToken":{"shape":"Sz"},"destinationAccessToken":{"shape":"Sz"}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sk"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","members":{"status":{},"lastUpdatedAt":{"type":"timestamp"}}},"Se":{"type":"structure","required":["services"],"members":{"thingName":{},"services":{"type":"list","member":{}}}},"Si":{"type":"structure","members":{"maxLifetimeTimeoutMinutes":{"type":"integer"}}},"Sk":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sz":{"type":"string","sensitive":true}}}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListTunnels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['wafv2'] = {};
	AWS.WAFV2 = Service.defineService('wafv2', ['2019-07-29']);
	Object.defineProperty(apiLoader.services['wafv2'], '2019-07-29', {
	  get: function get() {
	    var model = __webpack_require__(822);
	    model.paginators = __webpack_require__(823).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WAFV2;


/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-07-29","endpointPrefix":"wafv2","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAFV2","serviceFullName":"AWS WAFV2","serviceId":"WAFV2","signatureVersion":"v4","targetPrefix":"AWSWAF_20190729","uid":"wafv2-2019-07-29"},"operations":{"AssociateWebACL":{"input":{"type":"structure","required":["WebACLArn","ResourceArn"],"members":{"WebACLArn":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"CheckCapacity":{"input":{"type":"structure","required":["Scope","Rules"],"members":{"Scope":{},"Rules":{"shape":"S6"}}},"output":{"type":"structure","members":{"Capacity":{"type":"long"}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","Scope","IPAddressVersion","Addresses"],"members":{"Name":{},"Scope":{},"Description":{},"IPAddressVersion":{},"Addresses":{"shape":"S33"},"Tags":{"shape":"S35"}}},"output":{"type":"structure","members":{"Summary":{"shape":"S3a"}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","Scope","RegularExpressionList"],"members":{"Name":{},"Scope":{},"Description":{},"RegularExpressionList":{"shape":"S3e"},"Tags":{"shape":"S35"}}},"output":{"type":"structure","members":{"Summary":{"shape":"S3h"}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","Scope","Capacity","VisibilityConfig"],"members":{"Name":{},"Scope":{},"Capacity":{"type":"long"},"Description":{},"Rules":{"shape":"S6"},"VisibilityConfig":{"shape":"S2s"},"Tags":{"shape":"S35"},"CustomResponseBodies":{"shape":"S3k"}}},"output":{"type":"structure","members":{"Summary":{"shape":"S3p"}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","Scope","DefaultAction","VisibilityConfig"],"members":{"Name":{},"Scope":{},"DefaultAction":{"shape":"S3r"},"Description":{},"Rules":{"shape":"S6"},"VisibilityConfig":{"shape":"S2s"},"Tags":{"shape":"S35"},"CustomResponseBodies":{"shape":"S3k"},"CaptchaConfig":{"shape":"S2v"}}},"output":{"type":"structure","members":{"Summary":{"shape":"S3t"}}}},"DeleteFirewallManagerRuleGroups":{"input":{"type":"structure","required":["WebACLArn","WebACLLockToken"],"members":{"WebACLArn":{},"WebACLLockToken":{}}},"output":{"type":"structure","members":{"NextWebACLLockToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["Name","Scope","Id","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"LockToken":{}}},"output":{"type":"structure","members":{}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["Name","Scope","Id","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"LockToken":{}}},"output":{"type":"structure","members":{}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["Name","Scope","Id","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"LockToken":{}}},"output":{"type":"structure","members":{}}},"DeleteWebACL":{"input":{"type":"structure","required":["Name","Scope","Id","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"LockToken":{}}},"output":{"type":"structure","members":{}}},"DescribeManagedRuleGroup":{"input":{"type":"structure","required":["VendorName","Name","Scope"],"members":{"VendorName":{},"Name":{},"Scope":{},"VersionName":{}}},"output":{"type":"structure","members":{"VersionName":{},"SnsTopicArn":{},"Capacity":{"type":"long"},"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Action":{"shape":"S2b"}}}},"LabelNamespace":{},"AvailableLabels":{"shape":"S4c"},"ConsumedLabels":{"shape":"S4c"}}}},"DisassociateWebACL":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"GenerateMobileSdkReleaseUrl":{"input":{"type":"structure","required":["Platform","ReleaseVersion"],"members":{"Platform":{},"ReleaseVersion":{}}},"output":{"type":"structure","members":{"Url":{}}}},"GetIPSet":{"input":{"type":"structure","required":["Name","Scope","Id"],"members":{"Name":{},"Scope":{},"Id":{}}},"output":{"type":"structure","members":{"IPSet":{"type":"structure","required":["Name","Id","ARN","IPAddressVersion","Addresses"],"members":{"Name":{},"Id":{},"ARN":{},"Description":{},"IPAddressVersion":{},"Addresses":{"shape":"S33"}}},"LockToken":{}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S4p"}}}},"GetManagedRuleSet":{"input":{"type":"structure","required":["Name","Scope","Id"],"members":{"Name":{},"Scope":{},"Id":{}}},"output":{"type":"structure","members":{"ManagedRuleSet":{"type":"structure","required":["Name","Id","ARN"],"members":{"Name":{},"Id":{},"ARN":{},"Description":{},"PublishedVersions":{"type":"map","key":{},"value":{"type":"structure","members":{"AssociatedRuleGroupArn":{},"Capacity":{"type":"long"},"ForecastedLifetime":{"type":"integer"},"PublishTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"ExpiryTimestamp":{"type":"timestamp"}}}},"RecommendedVersion":{},"LabelNamespace":{}}},"LockToken":{}}}},"GetMobileSdkRelease":{"input":{"type":"structure","required":["Platform","ReleaseVersion"],"members":{"Platform":{},"ReleaseVersion":{}}},"output":{"type":"structure","members":{"MobileSdkRelease":{"type":"structure","members":{"ReleaseVersion":{},"Timestamp":{"type":"timestamp"},"ReleaseNotes":{},"Tags":{"shape":"S35"}}}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedStatementManagedKeys":{"input":{"type":"structure","required":["Scope","WebACLName","WebACLId","RuleName"],"members":{"Scope":{},"WebACLName":{},"WebACLId":{},"RuleGroupRuleName":{},"RuleName":{}}},"output":{"type":"structure","members":{"ManagedKeysIPV4":{"shape":"S5i"},"ManagedKeysIPV6":{"shape":"S5i"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["Name","Scope","Id"],"members":{"Name":{},"Scope":{},"Id":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"type":"structure","members":{"Name":{},"Id":{},"ARN":{},"Description":{},"RegularExpressionList":{"shape":"S3e"}}},"LockToken":{}}}},"GetRuleGroup":{"input":{"type":"structure","members":{"Name":{},"Scope":{},"Id":{},"ARN":{}}},"output":{"type":"structure","members":{"RuleGroup":{"type":"structure","required":["Name","Id","Capacity","ARN","VisibilityConfig"],"members":{"Name":{},"Id":{},"Capacity":{"type":"long"},"ARN":{},"Description":{},"Rules":{"shape":"S6"},"VisibilityConfig":{"shape":"S2s"},"LabelNamespace":{},"CustomResponseBodies":{"shape":"S3k"},"AvailableLabels":{"shape":"S4c"},"ConsumedLabels":{"shape":"S4c"}}},"LockToken":{}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclArn","RuleMetricName","Scope","TimeWindow","MaxItems"],"members":{"WebAclArn":{},"RuleMetricName":{},"Scope":{},"TimeWindow":{"shape":"S5q"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"shape":"S61"}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleNameWithinRuleGroup":{},"RequestHeadersInserted":{"shape":"S61"},"ResponseCodeSent":{"type":"integer"},"Labels":{"shape":"S2p"},"CaptchaResponse":{"type":"structure","members":{"ResponseCode":{"type":"integer"},"SolveTimestamp":{"type":"long"},"FailureReason":{}}}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S5q"}}}},"GetWebACL":{"input":{"type":"structure","required":["Name","Scope","Id"],"members":{"Name":{},"Scope":{},"Id":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S6e"},"LockToken":{},"ApplicationIntegrationURL":{}}}},"GetWebACLForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S6e"}}}},"ListAvailableManagedRuleGroupVersions":{"input":{"type":"structure","required":["VendorName","Name","Scope"],"members":{"VendorName":{},"Name":{},"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"type":"list","member":{"type":"structure","members":{"Name":{},"LastUpdateTimestamp":{"type":"timestamp"}}}},"CurrentDefaultVersion":{}}}},"ListAvailableManagedRuleGroups":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ManagedRuleGroups":{"type":"list","member":{"type":"structure","members":{"VendorName":{},"Name":{},"VersioningSupported":{"type":"boolean"},"Description":{}}}}}}},"ListIPSets":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"shape":"S3a"}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S4p"}},"NextMarker":{}}}},"ListManagedRuleSets":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ManagedRuleSets":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Description":{},"LockToken":{},"ARN":{},"LabelNamespace":{}}}}}}},"ListMobileSdkReleases":{"input":{"type":"structure","required":["Platform"],"members":{"Platform":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ReleaseSummaries":{"type":"list","member":{"type":"structure","members":{"ReleaseVersion":{},"Timestamp":{"type":"timestamp"}}}},"NextMarker":{}}}},"ListRegexPatternSets":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"shape":"S3h"}}}}},"ListResourcesForWebACL":{"input":{"type":"structure","required":["WebACLArn"],"members":{"WebACLArn":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceArns":{"type":"list","member":{}}}}},"ListRuleGroups":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"shape":"S3p"}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"S35"}}}}}},"ListWebACLs":{"input":{"type":"structure","required":["Scope"],"members":{"Scope":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"shape":"S3t"}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S4p"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S4p"}}}},"PutManagedRuleSetVersions":{"input":{"type":"structure","required":["Name","Scope","Id","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"LockToken":{},"RecommendedVersion":{},"VersionsToPublish":{"type":"map","key":{},"value":{"type":"structure","members":{"AssociatedRuleGroupArn":{},"ForecastedLifetime":{"type":"integer"}}}}}},"output":{"type":"structure","members":{"NextLockToken":{}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S35"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIPSet":{"input":{"type":"structure","required":["Name","Scope","Id","Addresses","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"Description":{},"Addresses":{"shape":"S33"},"LockToken":{}}},"output":{"type":"structure","members":{"NextLockToken":{}}}},"UpdateManagedRuleSetVersionExpiryDate":{"input":{"type":"structure","required":["Name","Scope","Id","LockToken","VersionToExpire","ExpiryTimestamp"],"members":{"Name":{},"Scope":{},"Id":{},"LockToken":{},"VersionToExpire":{},"ExpiryTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ExpiringVersion":{},"ExpiryTimestamp":{"type":"timestamp"},"NextLockToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["Name","Scope","Id","RegularExpressionList","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"Description":{},"RegularExpressionList":{"shape":"S3e"},"LockToken":{}}},"output":{"type":"structure","members":{"NextLockToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["Name","Scope","Id","VisibilityConfig","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"Description":{},"Rules":{"shape":"S6"},"VisibilityConfig":{"shape":"S2s"},"LockToken":{},"CustomResponseBodies":{"shape":"S3k"}}},"output":{"type":"structure","members":{"NextLockToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["Name","Scope","Id","DefaultAction","VisibilityConfig","LockToken"],"members":{"Name":{},"Scope":{},"Id":{},"DefaultAction":{"shape":"S3r"},"Description":{},"Rules":{"shape":"S6"},"VisibilityConfig":{"shape":"S2s"},"LockToken":{},"CustomResponseBodies":{"shape":"S3k"},"CaptchaConfig":{"shape":"S2v"}}},"output":{"type":"structure","members":{"NextLockToken":{}}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["Name","Priority","Statement","VisibilityConfig"],"members":{"Name":{},"Priority":{"type":"integer"},"Statement":{"shape":"Sa"},"Action":{"shape":"S2b"},"OverrideAction":{"shape":"S2n"},"RuleLabels":{"shape":"S2p"},"VisibilityConfig":{"shape":"S2s"},"CaptchaConfig":{"shape":"S2v"}}}},"Sa":{"type":"structure","members":{"ByteMatchStatement":{"type":"structure","required":["SearchString","FieldToMatch","TextTransformations","PositionalConstraint"],"members":{"SearchString":{"type":"blob"},"FieldToMatch":{"shape":"Sd"},"TextTransformations":{"shape":"S12"},"PositionalConstraint":{}}},"SqliMatchStatement":{"type":"structure","required":["FieldToMatch","TextTransformations"],"members":{"FieldToMatch":{"shape":"Sd"},"TextTransformations":{"shape":"S12"}}},"XssMatchStatement":{"type":"structure","required":["FieldToMatch","TextTransformations"],"members":{"FieldToMatch":{"shape":"Sd"},"TextTransformations":{"shape":"S12"}}},"SizeConstraintStatement":{"type":"structure","required":["FieldToMatch","ComparisonOperator","Size","TextTransformations"],"members":{"FieldToMatch":{"shape":"Sd"},"ComparisonOperator":{},"Size":{"type":"long"},"TextTransformations":{"shape":"S12"}}},"GeoMatchStatement":{"type":"structure","members":{"CountryCodes":{"type":"list","member":{}},"ForwardedIPConfig":{"shape":"S1f"}}},"RuleGroupReferenceStatement":{"shape":"S1i"},"IPSetReferenceStatement":{"type":"structure","required":["ARN"],"members":{"ARN":{},"IPSetForwardedIPConfig":{"type":"structure","required":["HeaderName","FallbackBehavior","Position"],"members":{"HeaderName":{},"FallbackBehavior":{},"Position":{}}}}},"RegexPatternSetReferenceStatement":{"type":"structure","required":["ARN","FieldToMatch","TextTransformations"],"members":{"ARN":{},"FieldToMatch":{"shape":"Sd"},"TextTransformations":{"shape":"S12"}}},"RateBasedStatement":{"type":"structure","required":["Limit","AggregateKeyType"],"members":{"Limit":{"type":"long"},"AggregateKeyType":{},"ScopeDownStatement":{"shape":"Sa"},"ForwardedIPConfig":{"shape":"S1f"}}},"AndStatement":{"type":"structure","required":["Statements"],"members":{"Statements":{"shape":"S1t"}}},"OrStatement":{"type":"structure","required":["Statements"],"members":{"Statements":{"shape":"S1t"}}},"NotStatement":{"type":"structure","required":["Statement"],"members":{"Statement":{"shape":"Sa"}}},"ManagedRuleGroupStatement":{"shape":"S1w"},"LabelMatchStatement":{"type":"structure","required":["Scope","Key"],"members":{"Scope":{},"Key":{}}},"RegexMatchStatement":{"type":"structure","required":["RegexString","FieldToMatch","TextTransformations"],"members":{"RegexString":{},"FieldToMatch":{"shape":"Sd"},"TextTransformations":{"shape":"S12"}}}}},"Sd":{"type":"structure","members":{"SingleHeader":{"type":"structure","required":["Name"],"members":{"Name":{}}},"SingleQueryArgument":{"type":"structure","required":["Name"],"members":{"Name":{}}},"AllQueryArguments":{"type":"structure","members":{}},"UriPath":{"type":"structure","members":{}},"QueryString":{"type":"structure","members":{}},"Body":{"type":"structure","members":{"OversizeHandling":{}}},"Method":{"type":"structure","members":{}},"JsonBody":{"type":"structure","required":["MatchPattern","MatchScope"],"members":{"MatchPattern":{"type":"structure","members":{"All":{"shape":"Sp"},"IncludedPaths":{"type":"list","member":{}}}},"MatchScope":{},"InvalidFallbackBehavior":{},"OversizeHandling":{}}},"Headers":{"type":"structure","required":["MatchPattern","MatchScope","OversizeHandling"],"members":{"MatchPattern":{"type":"structure","members":{"All":{"shape":"Sp"},"IncludedHeaders":{"shape":"Sw"},"ExcludedHeaders":{"shape":"Sw"}}},"MatchScope":{},"OversizeHandling":{}}},"Cookies":{"type":"structure","required":["MatchPattern","MatchScope","OversizeHandling"],"members":{"MatchPattern":{"type":"structure","members":{"All":{"shape":"Sp"},"IncludedCookies":{"shape":"S10"},"ExcludedCookies":{"shape":"S10"}}},"MatchScope":{},"OversizeHandling":{}}}}},"Sp":{"type":"structure","members":{}},"Sw":{"type":"list","member":{}},"S10":{"type":"list","member":{}},"S12":{"type":"list","member":{"type":"structure","required":["Priority","Type"],"members":{"Priority":{"type":"integer"},"Type":{}}}},"S1f":{"type":"structure","required":["HeaderName","FallbackBehavior"],"members":{"HeaderName":{},"FallbackBehavior":{}}},"S1i":{"type":"structure","required":["ARN"],"members":{"ARN":{},"ExcludedRules":{"shape":"S1j"}}},"S1j":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"S1t":{"type":"list","member":{"shape":"Sa"}},"S1w":{"type":"structure","required":["VendorName","Name"],"members":{"VendorName":{},"Name":{},"Version":{},"ExcludedRules":{"shape":"S1j"},"ScopeDownStatement":{"shape":"Sa"},"ManagedRuleGroupConfigs":{"type":"list","member":{"type":"structure","members":{"LoginPath":{},"PayloadType":{},"UsernameField":{"type":"structure","required":["Identifier"],"members":{"Identifier":{}}},"PasswordField":{"type":"structure","required":["Identifier"],"members":{"Identifier":{}}}}}}}},"S2b":{"type":"structure","members":{"Block":{"shape":"S2c"},"Allow":{"shape":"S2j"},"Count":{"shape":"S2l"},"Captcha":{"type":"structure","members":{"CustomRequestHandling":{"shape":"S2k"}}}}},"S2c":{"type":"structure","members":{"CustomResponse":{"type":"structure","required":["ResponseCode"],"members":{"ResponseCode":{"type":"integer"},"CustomResponseBodyKey":{},"ResponseHeaders":{"shape":"S2f"}}}}},"S2f":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S2j":{"type":"structure","members":{"CustomRequestHandling":{"shape":"S2k"}}},"S2k":{"type":"structure","required":["InsertHeaders"],"members":{"InsertHeaders":{"shape":"S2f"}}},"S2l":{"type":"structure","members":{"CustomRequestHandling":{"shape":"S2k"}}},"S2n":{"type":"structure","members":{"Count":{"shape":"S2l"},"None":{"type":"structure","members":{}}}},"S2p":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"S2s":{"type":"structure","required":["SampledRequestsEnabled","CloudWatchMetricsEnabled","MetricName"],"members":{"SampledRequestsEnabled":{"type":"boolean"},"CloudWatchMetricsEnabled":{"type":"boolean"},"MetricName":{}}},"S2v":{"type":"structure","members":{"ImmunityTimeProperty":{"type":"structure","required":["ImmunityTime"],"members":{"ImmunityTime":{"type":"long"}}}}},"S33":{"type":"list","member":{}},"S35":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S3a":{"type":"structure","members":{"Name":{},"Id":{},"Description":{},"LockToken":{},"ARN":{}}},"S3e":{"type":"list","member":{"type":"structure","members":{"RegexString":{}}}},"S3h":{"type":"structure","members":{"Name":{},"Id":{},"Description":{},"LockToken":{},"ARN":{}}},"S3k":{"type":"map","key":{},"value":{"type":"structure","required":["ContentType","Content"],"members":{"ContentType":{},"Content":{}}}},"S3p":{"type":"structure","members":{"Name":{},"Id":{},"Description":{},"LockToken":{},"ARN":{}}},"S3r":{"type":"structure","members":{"Block":{"shape":"S2c"},"Allow":{"shape":"S2j"}}},"S3t":{"type":"structure","members":{"Name":{},"Id":{},"Description":{},"LockToken":{},"ARN":{}}},"S4c":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"S4p":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"Sd"}},"ManagedByFirewallManager":{"type":"boolean"},"LoggingFilter":{"type":"structure","required":["Filters","DefaultBehavior"],"members":{"Filters":{"type":"list","member":{"type":"structure","required":["Behavior","Requirement","Conditions"],"members":{"Behavior":{},"Requirement":{},"Conditions":{"type":"list","member":{"type":"structure","members":{"ActionCondition":{"type":"structure","required":["Action"],"members":{"Action":{}}},"LabelNameCondition":{"type":"structure","required":["LabelName"],"members":{"LabelName":{}}}}}}}}},"DefaultBehavior":{}}}}},"S5i":{"type":"structure","members":{"IPAddressVersion":{},"Addresses":{"shape":"S33"}}},"S5q":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S61":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"S6e":{"type":"structure","required":["Name","Id","ARN","DefaultAction","VisibilityConfig"],"members":{"Name":{},"Id":{},"ARN":{},"DefaultAction":{"shape":"S3r"},"Description":{},"Rules":{"shape":"S6"},"VisibilityConfig":{"shape":"S2s"},"Capacity":{"type":"long"},"PreProcessFirewallManagerRuleGroups":{"shape":"S6f"},"PostProcessFirewallManagerRuleGroups":{"shape":"S6f"},"ManagedByFirewallManager":{"type":"boolean"},"LabelNamespace":{},"CustomResponseBodies":{"shape":"S3k"},"CaptchaConfig":{"shape":"S2v"}}},"S6f":{"type":"list","member":{"type":"structure","required":["Name","Priority","FirewallManagerStatement","OverrideAction","VisibilityConfig"],"members":{"Name":{},"Priority":{"type":"integer"},"FirewallManagerStatement":{"type":"structure","members":{"ManagedRuleGroupStatement":{"shape":"S1w"},"RuleGroupReferenceStatement":{"shape":"S1i"}}},"OverrideAction":{"shape":"S2n"},"VisibilityConfig":{"shape":"S2s"}}}}}}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['elasticinference'] = {};
	AWS.ElasticInference = Service.defineService('elasticinference', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['elasticinference'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(825);
	    model.paginators = __webpack_require__(826).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ElasticInference;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"api.elastic-inference","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon Elastic Inference","serviceFullName":"Amazon Elastic  Inference","serviceId":"Elastic Inference","signatureVersion":"v4","signingName":"elastic-inference","uid":"elastic-inference-2017-07-25"},"operations":{"DescribeAcceleratorOfferings":{"http":{"requestUri":"/describe-accelerator-offerings"},"input":{"type":"structure","required":["locationType"],"members":{"locationType":{},"acceleratorTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"acceleratorTypeOfferings":{"type":"list","member":{"type":"structure","members":{"acceleratorType":{},"locationType":{},"location":{}}}}}}},"DescribeAcceleratorTypes":{"http":{"method":"GET","requestUri":"/describe-accelerator-types"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"acceleratorTypes":{"type":"list","member":{"type":"structure","members":{"acceleratorTypeName":{},"memoryInfo":{"type":"structure","members":{"sizeInMiB":{"type":"integer"}}},"throughputInfo":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{"type":"integer"}}}}}}}}}},"DescribeAccelerators":{"http":{"requestUri":"/describe-accelerators"},"input":{"type":"structure","members":{"acceleratorIds":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"type":"list","member":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"acceleratorSet":{"type":"list","member":{"type":"structure","members":{"acceleratorHealth":{"type":"structure","members":{"status":{}}},"acceleratorType":{},"acceleratorId":{},"availabilityZone":{},"attachedResource":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S13"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S13":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAccelerators":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"acceleratorSet"}}}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['imagebuilder'] = {};
	AWS.Imagebuilder = Service.defineService('imagebuilder', ['2019-12-02']);
	Object.defineProperty(apiLoader.services['imagebuilder'], '2019-12-02', {
	  get: function get() {
	    var model = __webpack_require__(828);
	    model.paginators = __webpack_require__(829).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Imagebuilder;


/***/ }),
/* 828 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-02","endpointPrefix":"imagebuilder","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"imagebuilder","serviceFullName":"EC2 Image Builder","serviceId":"imagebuilder","signatureVersion":"v4","signingName":"imagebuilder","uid":"imagebuilder-2019-12-02"},"operations":{"CancelImageCreation":{"http":{"method":"PUT","requestUri":"/CancelImageCreation"},"input":{"type":"structure","required":["imageBuildVersionArn","clientToken"],"members":{"imageBuildVersionArn":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"imageBuildVersionArn":{}}}},"CreateComponent":{"http":{"method":"PUT","requestUri":"/CreateComponent"},"input":{"type":"structure","required":["name","semanticVersion","platform","clientToken"],"members":{"name":{},"semanticVersion":{},"description":{},"changeDescription":{},"platform":{},"supportedOsVersions":{"shape":"Sa"},"data":{},"uri":{},"kmsKeyId":{},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"componentBuildVersionArn":{}}}},"CreateContainerRecipe":{"http":{"method":"PUT","requestUri":"/CreateContainerRecipe"},"input":{"type":"structure","required":["containerType","name","semanticVersion","components","parentImage","targetRepository","clientToken"],"members":{"containerType":{},"name":{},"description":{},"semanticVersion":{},"components":{"shape":"Sl"},"instanceConfiguration":{"shape":"St"},"dockerfileTemplateData":{},"dockerfileTemplateUri":{},"platformOverride":{},"imageOsVersionOverride":{},"parentImage":{},"tags":{"shape":"Se"},"workingDirectory":{},"targetRepository":{"shape":"S14"},"kmsKeyId":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"containerRecipeArn":{}}}},"CreateDistributionConfiguration":{"http":{"method":"PUT","requestUri":"/CreateDistributionConfiguration"},"input":{"type":"structure","required":["name","distributions","clientToken"],"members":{"name":{},"description":{},"distributions":{"shape":"S19"},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"distributionConfigurationArn":{}}}},"CreateImage":{"http":{"method":"PUT","requestUri":"/CreateImage"},"input":{"type":"structure","required":["infrastructureConfigurationArn","clientToken"],"members":{"imageRecipeArn":{},"containerRecipeArn":{},"distributionConfigurationArn":{},"infrastructureConfigurationArn":{},"imageTestsConfiguration":{"shape":"S25"},"enhancedImageMetadataEnabled":{"type":"boolean"},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"imageBuildVersionArn":{}}}},"CreateImagePipeline":{"http":{"method":"PUT","requestUri":"/CreateImagePipeline"},"input":{"type":"structure","required":["name","infrastructureConfigurationArn","clientToken"],"members":{"name":{},"description":{},"imageRecipeArn":{},"containerRecipeArn":{},"infrastructureConfigurationArn":{},"distributionConfigurationArn":{},"imageTestsConfiguration":{"shape":"S25"},"enhancedImageMetadataEnabled":{"type":"boolean"},"schedule":{"shape":"S29"},"status":{},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"imagePipelineArn":{}}}},"CreateImageRecipe":{"http":{"method":"PUT","requestUri":"/CreateImageRecipe"},"input":{"type":"structure","required":["name","semanticVersion","components","parentImage","clientToken"],"members":{"name":{},"description":{},"semanticVersion":{},"components":{"shape":"Sl"},"parentImage":{},"blockDeviceMappings":{"shape":"Su"},"tags":{"shape":"Se"},"workingDirectory":{},"additionalInstanceConfiguration":{"shape":"S2g"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"imageRecipeArn":{}}}},"CreateInfrastructureConfiguration":{"http":{"method":"PUT","requestUri":"/CreateInfrastructureConfiguration"},"input":{"type":"structure","required":["name","instanceProfileName","clientToken"],"members":{"name":{},"description":{},"instanceTypes":{"shape":"S2l"},"instanceProfileName":{},"securityGroupIds":{"shape":"S2o"},"subnetId":{},"logging":{"shape":"S2p"},"keyPair":{},"terminateInstanceOnFailure":{"type":"boolean"},"snsTopicArn":{},"resourceTags":{"shape":"S2s"},"instanceMetadataOptions":{"shape":"S2t"},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"infrastructureConfigurationArn":{}}}},"DeleteComponent":{"http":{"method":"DELETE","requestUri":"/DeleteComponent"},"input":{"type":"structure","required":["componentBuildVersionArn"],"members":{"componentBuildVersionArn":{"location":"querystring","locationName":"componentBuildVersionArn"}}},"output":{"type":"structure","members":{"requestId":{},"componentBuildVersionArn":{}}}},"DeleteContainerRecipe":{"http":{"method":"DELETE","requestUri":"/DeleteContainerRecipe"},"input":{"type":"structure","required":["containerRecipeArn"],"members":{"containerRecipeArn":{"location":"querystring","locationName":"containerRecipeArn"}}},"output":{"type":"structure","members":{"requestId":{},"containerRecipeArn":{}}}},"DeleteDistributionConfiguration":{"http":{"method":"DELETE","requestUri":"/DeleteDistributionConfiguration"},"input":{"type":"structure","required":["distributionConfigurationArn"],"members":{"distributionConfigurationArn":{"location":"querystring","locationName":"distributionConfigurationArn"}}},"output":{"type":"structure","members":{"requestId":{},"distributionConfigurationArn":{}}}},"DeleteImage":{"http":{"method":"DELETE","requestUri":"/DeleteImage"},"input":{"type":"structure","required":["imageBuildVersionArn"],"members":{"imageBuildVersionArn":{"location":"querystring","locationName":"imageBuildVersionArn"}}},"output":{"type":"structure","members":{"requestId":{},"imageBuildVersionArn":{}}}},"DeleteImagePipeline":{"http":{"method":"DELETE","requestUri":"/DeleteImagePipeline"},"input":{"type":"structure","required":["imagePipelineArn"],"members":{"imagePipelineArn":{"location":"querystring","locationName":"imagePipelineArn"}}},"output":{"type":"structure","members":{"requestId":{},"imagePipelineArn":{}}}},"DeleteImageRecipe":{"http":{"method":"DELETE","requestUri":"/DeleteImageRecipe"},"input":{"type":"structure","required":["imageRecipeArn"],"members":{"imageRecipeArn":{"location":"querystring","locationName":"imageRecipeArn"}}},"output":{"type":"structure","members":{"requestId":{},"imageRecipeArn":{}}}},"DeleteInfrastructureConfiguration":{"http":{"method":"DELETE","requestUri":"/DeleteInfrastructureConfiguration"},"input":{"type":"structure","required":["infrastructureConfigurationArn"],"members":{"infrastructureConfigurationArn":{"location":"querystring","locationName":"infrastructureConfigurationArn"}}},"output":{"type":"structure","members":{"requestId":{},"infrastructureConfigurationArn":{}}}},"GetComponent":{"http":{"method":"GET","requestUri":"/GetComponent"},"input":{"type":"structure","required":["componentBuildVersionArn"],"members":{"componentBuildVersionArn":{"location":"querystring","locationName":"componentBuildVersionArn"}}},"output":{"type":"structure","members":{"requestId":{},"component":{"type":"structure","members":{"arn":{},"name":{},"version":{},"description":{},"changeDescription":{},"type":{},"platform":{},"supportedOsVersions":{"shape":"Sa"},"state":{"shape":"S3g"},"parameters":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{},"defaultValue":{"shape":"Sr"},"description":{}}}},"owner":{},"data":{},"kmsKeyId":{},"encrypted":{"type":"boolean"},"dateCreated":{},"tags":{"shape":"Se"}}}}}},"GetComponentPolicy":{"http":{"method":"GET","requestUri":"/GetComponentPolicy"},"input":{"type":"structure","required":["componentArn"],"members":{"componentArn":{"location":"querystring","locationName":"componentArn"}}},"output":{"type":"structure","members":{"requestId":{},"policy":{}}}},"GetContainerRecipe":{"http":{"method":"GET","requestUri":"/GetContainerRecipe"},"input":{"type":"structure","required":["containerRecipeArn"],"members":{"containerRecipeArn":{"location":"querystring","locationName":"containerRecipeArn"}}},"output":{"type":"structure","members":{"requestId":{},"containerRecipe":{"shape":"S3t"}}}},"GetContainerRecipePolicy":{"http":{"method":"GET","requestUri":"/GetContainerRecipePolicy"},"input":{"type":"structure","required":["containerRecipeArn"],"members":{"containerRecipeArn":{"location":"querystring","locationName":"containerRecipeArn"}}},"output":{"type":"structure","members":{"requestId":{},"policy":{}}}},"GetDistributionConfiguration":{"http":{"method":"GET","requestUri":"/GetDistributionConfiguration"},"input":{"type":"structure","required":["distributionConfigurationArn"],"members":{"distributionConfigurationArn":{"location":"querystring","locationName":"distributionConfigurationArn"}}},"output":{"type":"structure","members":{"requestId":{},"distributionConfiguration":{"shape":"S3z"}}}},"GetImage":{"http":{"method":"GET","requestUri":"/GetImage"},"input":{"type":"structure","required":["imageBuildVersionArn"],"members":{"imageBuildVersionArn":{"location":"querystring","locationName":"imageBuildVersionArn"}}},"output":{"type":"structure","members":{"requestId":{},"image":{"type":"structure","members":{"arn":{},"type":{},"name":{},"version":{},"platform":{},"enhancedImageMetadataEnabled":{"type":"boolean"},"osVersion":{},"state":{"shape":"S46"},"imageRecipe":{"shape":"S48"},"containerRecipe":{"shape":"S3t"},"sourcePipelineName":{},"sourcePipelineArn":{},"infrastructureConfiguration":{"shape":"S4a"},"distributionConfiguration":{"shape":"S3z"},"imageTestsConfiguration":{"shape":"S25"},"dateCreated":{},"outputResources":{"shape":"S4b"},"tags":{"shape":"Se"},"buildType":{}}}}}},"GetImagePipeline":{"http":{"method":"GET","requestUri":"/GetImagePipeline"},"input":{"type":"structure","required":["imagePipelineArn"],"members":{"imagePipelineArn":{"location":"querystring","locationName":"imagePipelineArn"}}},"output":{"type":"structure","members":{"requestId":{},"imagePipeline":{"shape":"S4j"}}}},"GetImagePolicy":{"http":{"method":"GET","requestUri":"/GetImagePolicy"},"input":{"type":"structure","required":["imageArn"],"members":{"imageArn":{"location":"querystring","locationName":"imageArn"}}},"output":{"type":"structure","members":{"requestId":{},"policy":{}}}},"GetImageRecipe":{"http":{"method":"GET","requestUri":"/GetImageRecipe"},"input":{"type":"structure","required":["imageRecipeArn"],"members":{"imageRecipeArn":{"location":"querystring","locationName":"imageRecipeArn"}}},"output":{"type":"structure","members":{"requestId":{},"imageRecipe":{"shape":"S48"}}}},"GetImageRecipePolicy":{"http":{"method":"GET","requestUri":"/GetImageRecipePolicy"},"input":{"type":"structure","required":["imageRecipeArn"],"members":{"imageRecipeArn":{"location":"querystring","locationName":"imageRecipeArn"}}},"output":{"type":"structure","members":{"requestId":{},"policy":{}}}},"GetInfrastructureConfiguration":{"http":{"method":"GET","requestUri":"/GetInfrastructureConfiguration"},"input":{"type":"structure","required":["infrastructureConfigurationArn"],"members":{"infrastructureConfigurationArn":{"location":"querystring","locationName":"infrastructureConfigurationArn"}}},"output":{"type":"structure","members":{"requestId":{},"infrastructureConfiguration":{"shape":"S4a"}}}},"ImportComponent":{"http":{"method":"PUT","requestUri":"/ImportComponent"},"input":{"type":"structure","required":["name","semanticVersion","type","format","platform","clientToken"],"members":{"name":{},"semanticVersion":{},"description":{},"changeDescription":{},"type":{},"format":{},"platform":{},"data":{},"uri":{},"kmsKeyId":{},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"componentBuildVersionArn":{}}}},"ImportVmImage":{"http":{"method":"PUT","requestUri":"/ImportVmImage"},"input":{"type":"structure","required":["name","semanticVersion","platform","vmImportTaskId","clientToken"],"members":{"name":{},"semanticVersion":{},"description":{},"platform":{},"osVersion":{},"vmImportTaskId":{},"tags":{"shape":"Se"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"imageArn":{},"clientToken":{}}}},"ListComponentBuildVersions":{"http":{"requestUri":"/ListComponentBuildVersions"},"input":{"type":"structure","required":["componentVersionArn"],"members":{"componentVersionArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"componentSummaryList":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"version":{},"platform":{},"supportedOsVersions":{"shape":"Sa"},"state":{"shape":"S3g"},"type":{},"owner":{},"description":{},"changeDescription":{},"dateCreated":{},"tags":{"shape":"Se"}}}},"nextToken":{}}}},"ListComponents":{"http":{"requestUri":"/ListComponents"},"input":{"type":"structure","members":{"owner":{},"filters":{"shape":"S56"},"byName":{"type":"boolean"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"componentVersionList":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"version":{},"description":{},"platform":{},"supportedOsVersions":{"shape":"Sa"},"type":{},"owner":{},"dateCreated":{}}}},"nextToken":{}}}},"ListContainerRecipes":{"http":{"requestUri":"/ListContainerRecipes"},"input":{"type":"structure","members":{"owner":{},"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"containerRecipeSummaryList":{"type":"list","member":{"type":"structure","members":{"arn":{},"containerType":{},"name":{},"platform":{},"owner":{},"parentImage":{},"dateCreated":{},"tags":{"shape":"Se"}}}},"nextToken":{}}}},"ListDistributionConfigurations":{"http":{"requestUri":"/ListDistributionConfigurations"},"input":{"type":"structure","members":{"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"distributionConfigurationSummaryList":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"description":{},"dateCreated":{},"dateUpdated":{},"tags":{"shape":"Se"},"regions":{"type":"list","member":{}}}}},"nextToken":{}}}},"ListImageBuildVersions":{"http":{"requestUri":"/ListImageBuildVersions"},"input":{"type":"structure","required":["imageVersionArn"],"members":{"imageVersionArn":{},"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"imageSummaryList":{"shape":"S5q"},"nextToken":{}}}},"ListImagePackages":{"http":{"requestUri":"/ListImagePackages"},"input":{"type":"structure","required":["imageBuildVersionArn"],"members":{"imageBuildVersionArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"imagePackageList":{"type":"list","member":{"type":"structure","members":{"packageName":{},"packageVersion":{}}}},"nextToken":{}}}},"ListImagePipelineImages":{"http":{"requestUri":"/ListImagePipelineImages"},"input":{"type":"structure","required":["imagePipelineArn"],"members":{"imagePipelineArn":{},"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"imageSummaryList":{"shape":"S5q"},"nextToken":{}}}},"ListImagePipelines":{"http":{"requestUri":"/ListImagePipelines"},"input":{"type":"structure","members":{"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"imagePipelineList":{"type":"list","member":{"shape":"S4j"}},"nextToken":{}}}},"ListImageRecipes":{"http":{"requestUri":"/ListImageRecipes"},"input":{"type":"structure","members":{"owner":{},"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"imageRecipeSummaryList":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"platform":{},"owner":{},"parentImage":{},"dateCreated":{},"tags":{"shape":"Se"}}}},"nextToken":{}}}},"ListImages":{"http":{"requestUri":"/ListImages"},"input":{"type":"structure","members":{"owner":{},"filters":{"shape":"S56"},"byName":{"type":"boolean"},"maxResults":{"type":"integer"},"nextToken":{},"includeDeprecated":{"type":"boolean"}}},"output":{"type":"structure","members":{"requestId":{},"imageVersionList":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"version":{},"platform":{},"osVersion":{},"owner":{},"dateCreated":{},"buildType":{}}}},"nextToken":{}}}},"ListInfrastructureConfigurations":{"http":{"requestUri":"/ListInfrastructureConfigurations"},"input":{"type":"structure","members":{"filters":{"shape":"S56"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"requestId":{},"infrastructureConfigurationSummaryList":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"description":{},"dateCreated":{},"dateUpdated":{},"resourceTags":{"shape":"S2s"},"tags":{"shape":"Se"},"instanceTypes":{"shape":"S2l"},"instanceProfileName":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutComponentPolicy":{"http":{"method":"PUT","requestUri":"/PutComponentPolicy"},"input":{"type":"structure","required":["componentArn","policy"],"members":{"componentArn":{},"policy":{}}},"output":{"type":"structure","members":{"requestId":{},"componentArn":{}}}},"PutContainerRecipePolicy":{"http":{"method":"PUT","requestUri":"/PutContainerRecipePolicy"},"input":{"type":"structure","required":["containerRecipeArn","policy"],"members":{"containerRecipeArn":{},"policy":{}}},"output":{"type":"structure","members":{"requestId":{},"containerRecipeArn":{}}}},"PutImagePolicy":{"http":{"method":"PUT","requestUri":"/PutImagePolicy"},"input":{"type":"structure","required":["imageArn","policy"],"members":{"imageArn":{},"policy":{}}},"output":{"type":"structure","members":{"requestId":{},"imageArn":{}}}},"PutImageRecipePolicy":{"http":{"method":"PUT","requestUri":"/PutImageRecipePolicy"},"input":{"type":"structure","required":["imageRecipeArn","policy"],"members":{"imageRecipeArn":{},"policy":{}}},"output":{"type":"structure","members":{"requestId":{},"imageRecipeArn":{}}}},"StartImagePipelineExecution":{"http":{"method":"PUT","requestUri":"/StartImagePipelineExecution"},"input":{"type":"structure","required":["imagePipelineArn","clientToken"],"members":{"imagePipelineArn":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"imageBuildVersionArn":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Se"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDistributionConfiguration":{"http":{"method":"PUT","requestUri":"/UpdateDistributionConfiguration"},"input":{"type":"structure","required":["distributionConfigurationArn","distributions","clientToken"],"members":{"distributionConfigurationArn":{},"description":{},"distributions":{"shape":"S19"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"distributionConfigurationArn":{}}}},"UpdateImagePipeline":{"http":{"method":"PUT","requestUri":"/UpdateImagePipeline"},"input":{"type":"structure","required":["imagePipelineArn","infrastructureConfigurationArn","clientToken"],"members":{"imagePipelineArn":{},"description":{},"imageRecipeArn":{},"containerRecipeArn":{},"infrastructureConfigurationArn":{},"distributionConfigurationArn":{},"imageTestsConfiguration":{"shape":"S25"},"enhancedImageMetadataEnabled":{"type":"boolean"},"schedule":{"shape":"S29"},"status":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"imagePipelineArn":{}}}},"UpdateInfrastructureConfiguration":{"http":{"method":"PUT","requestUri":"/UpdateInfrastructureConfiguration"},"input":{"type":"structure","required":["infrastructureConfigurationArn","instanceProfileName","clientToken"],"members":{"infrastructureConfigurationArn":{},"description":{},"instanceTypes":{"shape":"S2l"},"instanceProfileName":{},"securityGroupIds":{"shape":"S2o"},"subnetId":{},"logging":{"shape":"S2p"},"keyPair":{},"terminateInstanceOnFailure":{"type":"boolean"},"snsTopicArn":{},"clientToken":{"idempotencyToken":true},"resourceTags":{"shape":"S2s"},"instanceMetadataOptions":{"shape":"S2t"}}},"output":{"type":"structure","members":{"requestId":{},"clientToken":{},"infrastructureConfigurationArn":{}}}}},"shapes":{"Sa":{"type":"list","member":{}},"Se":{"type":"map","key":{},"value":{}},"Sl":{"type":"list","member":{"type":"structure","required":["componentArn"],"members":{"componentArn":{},"parameters":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"shape":"Sr"}}}}}}},"Sr":{"type":"list","member":{}},"St":{"type":"structure","members":{"image":{},"blockDeviceMappings":{"shape":"Su"}}},"Su":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"ebs":{"type":"structure","members":{"encrypted":{"type":"boolean"},"deleteOnTermination":{"type":"boolean"},"iops":{"type":"integer"},"kmsKeyId":{},"snapshotId":{},"volumeSize":{"type":"integer"},"volumeType":{},"throughput":{"type":"integer"}}},"virtualName":{},"noDevice":{}}}},"S14":{"type":"structure","required":["service","repositoryName"],"members":{"service":{},"repositoryName":{}}},"S19":{"type":"list","member":{"type":"structure","required":["region"],"members":{"region":{},"amiDistributionConfiguration":{"type":"structure","members":{"name":{},"description":{},"targetAccountIds":{"shape":"S1d"},"amiTags":{"shape":"Se"},"kmsKeyId":{},"launchPermission":{"type":"structure","members":{"userIds":{"shape":"S1d"},"userGroups":{"shape":"S1g"},"organizationArns":{"type":"list","member":{}},"organizationalUnitArns":{"type":"list","member":{}}}}}},"containerDistributionConfiguration":{"type":"structure","required":["targetRepository"],"members":{"description":{},"containerTags":{"shape":"S1g"},"targetRepository":{"shape":"S14"}}},"licenseConfigurationArns":{"type":"list","member":{}},"launchTemplateConfigurations":{"type":"list","member":{"type":"structure","required":["launchTemplateId"],"members":{"launchTemplateId":{},"accountId":{},"setDefaultVersion":{"type":"boolean"}}}},"s3ExportConfiguration":{"type":"structure","required":["roleName","diskImageFormat","s3Bucket"],"members":{"roleName":{},"diskImageFormat":{},"s3Bucket":{},"s3Prefix":{}}},"fastLaunchConfigurations":{"type":"list","member":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"},"snapshotConfiguration":{"type":"structure","members":{"targetResourceCount":{"type":"integer"}}},"maxParallelLaunches":{"type":"integer"},"launchTemplate":{"type":"structure","members":{"launchTemplateId":{},"launchTemplateName":{},"launchTemplateVersion":{}}},"accountId":{}}}}}}},"S1d":{"type":"list","member":{}},"S1g":{"type":"list","member":{}},"S25":{"type":"structure","members":{"imageTestsEnabled":{"type":"boolean"},"timeoutMinutes":{"type":"integer"}}},"S29":{"type":"structure","members":{"scheduleExpression":{},"timezone":{},"pipelineExecutionStartCondition":{}}},"S2g":{"type":"structure","members":{"systemsManagerAgent":{"type":"structure","members":{"uninstallAfterBuild":{"type":"boolean"}}},"userDataOverride":{}}},"S2l":{"type":"list","member":{}},"S2o":{"type":"list","member":{}},"S2p":{"type":"structure","members":{"s3Logs":{"type":"structure","members":{"s3BucketName":{},"s3KeyPrefix":{}}}}},"S2s":{"type":"map","key":{},"value":{}},"S2t":{"type":"structure","members":{"httpTokens":{},"httpPutResponseHopLimit":{"type":"integer"}}},"S3g":{"type":"structure","members":{"status":{},"reason":{}}},"S3t":{"type":"structure","members":{"arn":{},"containerType":{},"name":{},"description":{},"platform":{},"owner":{},"version":{},"components":{"shape":"Sl"},"instanceConfiguration":{"shape":"St"},"dockerfileTemplateData":{},"kmsKeyId":{},"encrypted":{"type":"boolean"},"parentImage":{},"dateCreated":{},"tags":{"shape":"Se"},"workingDirectory":{},"targetRepository":{"shape":"S14"}}},"S3z":{"type":"structure","required":["timeoutMinutes"],"members":{"arn":{},"name":{},"description":{},"distributions":{"shape":"S19"},"timeoutMinutes":{"type":"integer"},"dateCreated":{},"dateUpdated":{},"tags":{"shape":"Se"}}},"S46":{"type":"structure","members":{"status":{},"reason":{}}},"S48":{"type":"structure","members":{"arn":{},"type":{},"name":{},"description":{},"platform":{},"owner":{},"version":{},"components":{"shape":"Sl"},"parentImage":{},"blockDeviceMappings":{"shape":"Su"},"dateCreated":{},"tags":{"shape":"Se"},"workingDirectory":{},"additionalInstanceConfiguration":{"shape":"S2g"}}},"S4a":{"type":"structure","members":{"arn":{},"name":{},"description":{},"instanceTypes":{"shape":"S2l"},"instanceProfileName":{},"securityGroupIds":{"shape":"S2o"},"subnetId":{},"logging":{"shape":"S2p"},"keyPair":{},"terminateInstanceOnFailure":{"type":"boolean"},"snsTopicArn":{},"dateCreated":{},"dateUpdated":{},"resourceTags":{"shape":"S2s"},"instanceMetadataOptions":{"shape":"S2t"},"tags":{"shape":"Se"}}},"S4b":{"type":"structure","members":{"amis":{"type":"list","member":{"type":"structure","members":{"region":{},"image":{},"name":{},"description":{},"state":{"shape":"S46"},"accountId":{}}}},"containers":{"type":"list","member":{"type":"structure","members":{"region":{},"imageUris":{"shape":"S1g"}}}}}},"S4j":{"type":"structure","members":{"arn":{},"name":{},"description":{},"platform":{},"enhancedImageMetadataEnabled":{"type":"boolean"},"imageRecipeArn":{},"containerRecipeArn":{},"infrastructureConfigurationArn":{},"distributionConfigurationArn":{},"imageTestsConfiguration":{"shape":"S25"},"schedule":{"shape":"S29"},"status":{},"dateCreated":{},"dateUpdated":{},"dateLastRun":{},"dateNextRun":{},"tags":{"shape":"Se"}}},"S56":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"type":"list","member":{}}}}},"S5q":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"version":{},"platform":{},"osVersion":{},"state":{"shape":"S46"},"owner":{},"dateCreated":{},"outputResources":{"shape":"S4b"},"tags":{"shape":"Se"},"buildType":{}}}}}}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListComponentBuildVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"componentSummaryList"},"ListComponents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"componentVersionList"},"ListContainerRecipes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"containerRecipeSummaryList"},"ListDistributionConfigurations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"distributionConfigurationSummaryList"},"ListImageBuildVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"imageSummaryList"},"ListImagePackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"imagePackageList"},"ListImagePipelineImages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"imageSummaryList"},"ListImagePipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"imagePipelineList"},"ListImageRecipes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"imageRecipeSummaryList"},"ListImages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"imageVersionList"},"ListInfrastructureConfigurations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"infrastructureConfigurationSummaryList"}}}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['schemas'] = {};
	AWS.Schemas = Service.defineService('schemas', ['2019-12-02']);
	Object.defineProperty(apiLoader.services['schemas'], '2019-12-02', {
	  get: function get() {
	    var model = __webpack_require__(831);
	    model.paginators = __webpack_require__(832).pagination;
	    model.waiters = __webpack_require__(833).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Schemas;


/***/ }),
/* 831 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2019-12-02","endpointPrefix":"schemas","signingName":"schemas","serviceFullName":"Schemas","serviceId":"schemas","protocol":"rest-json","jsonVersion":"1.1","uid":"schemas-2019-12-02","signatureVersion":"v4"},"operations":{"CreateDiscoverer":{"http":{"requestUri":"/v1/discoverers","responseCode":201},"input":{"type":"structure","members":{"Description":{},"SourceArn":{},"CrossAccount":{"type":"boolean"},"Tags":{"shape":"S5","locationName":"tags"}},"required":["SourceArn"]},"output":{"type":"structure","members":{"Description":{},"DiscovererArn":{},"DiscovererId":{},"SourceArn":{},"State":{},"CrossAccount":{"type":"boolean"},"Tags":{"shape":"S5","locationName":"tags"}}}},"CreateRegistry":{"http":{"requestUri":"/v1/registries/name/{registryName}","responseCode":201},"input":{"type":"structure","members":{"Description":{},"RegistryName":{"location":"uri","locationName":"registryName"},"Tags":{"shape":"S5","locationName":"tags"}},"required":["RegistryName"]},"output":{"type":"structure","members":{"Description":{},"RegistryArn":{},"RegistryName":{},"Tags":{"shape":"S5","locationName":"tags"}}}},"CreateSchema":{"http":{"requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}","responseCode":201},"input":{"type":"structure","members":{"Content":{},"Description":{},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"Tags":{"shape":"S5","locationName":"tags"},"Type":{}},"required":["RegistryName","SchemaName","Type","Content"]},"output":{"type":"structure","members":{"Description":{},"LastModified":{"shape":"Sf"},"SchemaArn":{},"SchemaName":{},"SchemaVersion":{},"Tags":{"shape":"S5","locationName":"tags"},"Type":{},"VersionCreatedDate":{"shape":"Sf"}}}},"DeleteDiscoverer":{"http":{"method":"DELETE","requestUri":"/v1/discoverers/id/{discovererId}","responseCode":204},"input":{"type":"structure","members":{"DiscovererId":{"location":"uri","locationName":"discovererId"}},"required":["DiscovererId"]}},"DeleteRegistry":{"http":{"method":"DELETE","requestUri":"/v1/registries/name/{registryName}","responseCode":204},"input":{"type":"structure","members":{"RegistryName":{"location":"uri","locationName":"registryName"}},"required":["RegistryName"]}},"DeleteResourcePolicy":{"http":{"method":"DELETE","requestUri":"/v1/policy","responseCode":204},"input":{"type":"structure","members":{"RegistryName":{"location":"querystring","locationName":"registryName"}}}},"DeleteSchema":{"http":{"method":"DELETE","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}","responseCode":204},"input":{"type":"structure","members":{"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"}},"required":["RegistryName","SchemaName"]}},"DeleteSchemaVersion":{"http":{"method":"DELETE","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}/version/{schemaVersion}","responseCode":204},"input":{"type":"structure","members":{"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"SchemaVersion":{"location":"uri","locationName":"schemaVersion"}},"required":["SchemaVersion","RegistryName","SchemaName"]}},"DescribeCodeBinding":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}/language/{language}","responseCode":200},"input":{"type":"structure","members":{"Language":{"location":"uri","locationName":"language"},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"SchemaVersion":{"location":"querystring","locationName":"schemaVersion"}},"required":["RegistryName","SchemaName","Language"]},"output":{"type":"structure","members":{"CreationDate":{"shape":"Sf"},"LastModified":{"shape":"Sf"},"SchemaVersion":{},"Status":{}}}},"DescribeDiscoverer":{"http":{"method":"GET","requestUri":"/v1/discoverers/id/{discovererId}","responseCode":200},"input":{"type":"structure","members":{"DiscovererId":{"location":"uri","locationName":"discovererId"}},"required":["DiscovererId"]},"output":{"type":"structure","members":{"Description":{},"DiscovererArn":{},"DiscovererId":{},"SourceArn":{},"State":{},"CrossAccount":{"type":"boolean"},"Tags":{"shape":"S5","locationName":"tags"}}}},"DescribeRegistry":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}","responseCode":200},"input":{"type":"structure","members":{"RegistryName":{"location":"uri","locationName":"registryName"}},"required":["RegistryName"]},"output":{"type":"structure","members":{"Description":{},"RegistryArn":{},"RegistryName":{},"Tags":{"shape":"S5","locationName":"tags"}}}},"DescribeSchema":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}","responseCode":200},"input":{"type":"structure","members":{"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"SchemaVersion":{"location":"querystring","locationName":"schemaVersion"}},"required":["RegistryName","SchemaName"]},"output":{"type":"structure","members":{"Content":{},"Description":{},"LastModified":{"shape":"Sf"},"SchemaArn":{},"SchemaName":{},"SchemaVersion":{},"Tags":{"shape":"S5","locationName":"tags"},"Type":{},"VersionCreatedDate":{"shape":"Sf"}}}},"ExportSchema":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}/export","responseCode":200},"input":{"type":"structure","members":{"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"SchemaVersion":{"location":"querystring","locationName":"schemaVersion"},"Type":{"location":"querystring","locationName":"type"}},"required":["RegistryName","SchemaName","Type"]},"output":{"type":"structure","members":{"Content":{},"SchemaArn":{},"SchemaName":{},"SchemaVersion":{},"Type":{}}}},"GetCodeBindingSource":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}/language/{language}/source","responseCode":200},"input":{"type":"structure","members":{"Language":{"location":"uri","locationName":"language"},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"SchemaVersion":{"location":"querystring","locationName":"schemaVersion"}},"required":["RegistryName","SchemaName","Language"]},"output":{"type":"structure","members":{"Body":{"type":"blob"}},"payload":"Body"}},"GetDiscoveredSchema":{"http":{"requestUri":"/v1/discover","responseCode":200},"input":{"type":"structure","members":{"Events":{"type":"list","member":{}},"Type":{}},"required":["Type","Events"]},"output":{"type":"structure","members":{"Content":{}}}},"GetResourcePolicy":{"http":{"method":"GET","requestUri":"/v1/policy","responseCode":200},"input":{"type":"structure","members":{"RegistryName":{"location":"querystring","locationName":"registryName"}}},"output":{"type":"structure","members":{"Policy":{"jsonvalue":true},"RevisionId":{}}}},"ListDiscoverers":{"http":{"method":"GET","requestUri":"/v1/discoverers","responseCode":200},"input":{"type":"structure","members":{"DiscovererIdPrefix":{"location":"querystring","locationName":"discovererIdPrefix"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"SourceArnPrefix":{"location":"querystring","locationName":"sourceArnPrefix"}}},"output":{"type":"structure","members":{"Discoverers":{"type":"list","member":{"type":"structure","members":{"DiscovererArn":{},"DiscovererId":{},"SourceArn":{},"State":{},"CrossAccount":{"type":"boolean"},"Tags":{"shape":"S5","locationName":"tags"}}}},"NextToken":{}}}},"ListRegistries":{"http":{"method":"GET","requestUri":"/v1/registries","responseCode":200},"input":{"type":"structure","members":{"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RegistryNamePrefix":{"location":"querystring","locationName":"registryNamePrefix"},"Scope":{"location":"querystring","locationName":"scope"}}},"output":{"type":"structure","members":{"NextToken":{},"Registries":{"type":"list","member":{"type":"structure","members":{"RegistryArn":{},"RegistryName":{},"Tags":{"shape":"S5","locationName":"tags"}}}}}}},"ListSchemaVersions":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}/versions","responseCode":200},"input":{"type":"structure","members":{"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"}},"required":["RegistryName","SchemaName"]},"output":{"type":"structure","members":{"NextToken":{},"SchemaVersions":{"type":"list","member":{"type":"structure","members":{"SchemaArn":{},"SchemaName":{},"SchemaVersion":{},"Type":{}}}}}}},"ListSchemas":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas","responseCode":200},"input":{"type":"structure","members":{"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaNamePrefix":{"location":"querystring","locationName":"schemaNamePrefix"}},"required":["RegistryName"]},"output":{"type":"structure","members":{"NextToken":{},"Schemas":{"type":"list","member":{"type":"structure","members":{"LastModified":{"shape":"Sf"},"SchemaArn":{},"SchemaName":{},"Tags":{"shape":"S5","locationName":"tags"},"VersionCount":{"type":"long"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S5","locationName":"tags"}}}},"PutCodeBinding":{"http":{"requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}/language/{language}","responseCode":202},"input":{"type":"structure","members":{"Language":{"location":"uri","locationName":"language"},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"SchemaVersion":{"location":"querystring","locationName":"schemaVersion"}},"required":["RegistryName","SchemaName","Language"]},"output":{"type":"structure","members":{"CreationDate":{"shape":"Sf"},"LastModified":{"shape":"Sf"},"SchemaVersion":{},"Status":{}}}},"PutResourcePolicy":{"http":{"method":"PUT","requestUri":"/v1/policy","responseCode":200},"input":{"type":"structure","members":{"Policy":{"jsonvalue":true},"RegistryName":{"location":"querystring","locationName":"registryName"},"RevisionId":{}},"required":["Policy"]},"output":{"type":"structure","members":{"Policy":{"jsonvalue":true},"RevisionId":{}}}},"SearchSchemas":{"http":{"method":"GET","requestUri":"/v1/registries/name/{registryName}/schemas/search","responseCode":200},"input":{"type":"structure","members":{"Keywords":{"location":"querystring","locationName":"keywords"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RegistryName":{"location":"uri","locationName":"registryName"}},"required":["RegistryName","Keywords"]},"output":{"type":"structure","members":{"NextToken":{},"Schemas":{"type":"list","member":{"type":"structure","members":{"RegistryName":{},"SchemaArn":{},"SchemaName":{},"SchemaVersions":{"type":"list","member":{"type":"structure","members":{"CreatedDate":{"shape":"Sf"},"SchemaVersion":{},"Type":{}}}}}}}}}},"StartDiscoverer":{"http":{"requestUri":"/v1/discoverers/id/{discovererId}/start","responseCode":200},"input":{"type":"structure","members":{"DiscovererId":{"location":"uri","locationName":"discovererId"}},"required":["DiscovererId"]},"output":{"type":"structure","members":{"DiscovererId":{},"State":{}}}},"StopDiscoverer":{"http":{"requestUri":"/v1/discoverers/id/{discovererId}/stop","responseCode":200},"input":{"type":"structure","members":{"DiscovererId":{"location":"uri","locationName":"discovererId"}},"required":["DiscovererId"]},"output":{"type":"structure","members":{"DiscovererId":{},"State":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"S5","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}},"required":["TagKeys","ResourceArn"]}},"UpdateDiscoverer":{"http":{"method":"PUT","requestUri":"/v1/discoverers/id/{discovererId}","responseCode":200},"input":{"type":"structure","members":{"Description":{},"DiscovererId":{"location":"uri","locationName":"discovererId"},"CrossAccount":{"type":"boolean"}},"required":["DiscovererId"]},"output":{"type":"structure","members":{"Description":{},"DiscovererArn":{},"DiscovererId":{},"SourceArn":{},"State":{},"CrossAccount":{"type":"boolean"},"Tags":{"shape":"S5","locationName":"tags"}}}},"UpdateRegistry":{"http":{"method":"PUT","requestUri":"/v1/registries/name/{registryName}","responseCode":200},"input":{"type":"structure","members":{"Description":{},"RegistryName":{"location":"uri","locationName":"registryName"}},"required":["RegistryName"]},"output":{"type":"structure","members":{"Description":{},"RegistryArn":{},"RegistryName":{},"Tags":{"shape":"S5","locationName":"tags"}}}},"UpdateSchema":{"http":{"method":"PUT","requestUri":"/v1/registries/name/{registryName}/schemas/name/{schemaName}","responseCode":200},"input":{"type":"structure","members":{"ClientTokenId":{"idempotencyToken":true},"Content":{},"Description":{},"RegistryName":{"location":"uri","locationName":"registryName"},"SchemaName":{"location":"uri","locationName":"schemaName"},"Type":{}},"required":["RegistryName","SchemaName"]},"output":{"type":"structure","members":{"Description":{},"LastModified":{"shape":"Sf"},"SchemaArn":{},"SchemaName":{},"SchemaVersion":{},"Tags":{"shape":"S5","locationName":"tags"},"Type":{},"VersionCreatedDate":{"shape":"Sf"}}}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"Sf":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDiscoverers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Discoverers"},"ListRegistries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Registries"},"ListSchemaVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"SchemaVersions"},"ListSchemas":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Schemas"},"SearchSchemas":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Schemas"}}}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"CodeBindingExists":{"description":"Wait until code binding is generated","delay":2,"operation":"DescribeCodeBinding","maxAttempts":30,"acceptors":[{"expected":"CREATE_COMPLETE","matcher":"path","state":"success","argument":"Status"},{"expected":"CREATE_IN_PROGRESS","matcher":"path","state":"retry","argument":"Status"},{"expected":"CREATE_FAILED","matcher":"path","state":"failure","argument":"Status"},{"matcher":"error","expected":"NotFoundException","state":"failure"}]}}}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['accessanalyzer'] = {};
	AWS.AccessAnalyzer = Service.defineService('accessanalyzer', ['2019-11-01']);
	Object.defineProperty(apiLoader.services['accessanalyzer'], '2019-11-01', {
	  get: function get() {
	    var model = __webpack_require__(835);
	    model.paginators = __webpack_require__(836).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AccessAnalyzer;


/***/ }),
/* 835 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-11-01","endpointPrefix":"access-analyzer","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Access Analyzer","serviceId":"AccessAnalyzer","signatureVersion":"v4","signingName":"access-analyzer","uid":"accessanalyzer-2019-11-01"},"operations":{"ApplyArchiveRule":{"http":{"method":"PUT","requestUri":"/archive-rule","responseCode":200},"input":{"type":"structure","required":["analyzerArn","ruleName"],"members":{"analyzerArn":{},"clientToken":{"idempotencyToken":true},"ruleName":{}}},"idempotent":true},"CancelPolicyGeneration":{"http":{"method":"PUT","requestUri":"/policy/generation/{jobId}","responseCode":200},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateAccessPreview":{"http":{"method":"PUT","requestUri":"/access-preview","responseCode":200},"input":{"type":"structure","required":["analyzerArn","configurations"],"members":{"analyzerArn":{},"clientToken":{"idempotencyToken":true},"configurations":{"shape":"S9"}}},"output":{"type":"structure","required":["id"],"members":{"id":{}}},"idempotent":true},"CreateAnalyzer":{"http":{"method":"PUT","requestUri":"/analyzer","responseCode":200},"input":{"type":"structure","required":["analyzerName","type"],"members":{"analyzerName":{},"archiveRules":{"type":"list","member":{"type":"structure","required":["filter","ruleName"],"members":{"filter":{"shape":"S1l"},"ruleName":{}}}},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S1o"},"type":{}}},"output":{"type":"structure","members":{"arn":{}}},"idempotent":true},"CreateArchiveRule":{"http":{"method":"PUT","requestUri":"/analyzer/{analyzerName}/archive-rule","responseCode":200},"input":{"type":"structure","required":["analyzerName","filter","ruleName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"},"clientToken":{"idempotencyToken":true},"filter":{"shape":"S1l"},"ruleName":{}}},"idempotent":true},"DeleteAnalyzer":{"http":{"method":"DELETE","requestUri":"/analyzer/{analyzerName}","responseCode":200},"input":{"type":"structure","required":["analyzerName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"idempotent":true},"DeleteArchiveRule":{"http":{"method":"DELETE","requestUri":"/analyzer/{analyzerName}/archive-rule/{ruleName}","responseCode":200},"input":{"type":"structure","required":["analyzerName","ruleName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"ruleName":{"location":"uri","locationName":"ruleName"}}},"idempotent":true},"GetAccessPreview":{"http":{"method":"GET","requestUri":"/access-preview/{accessPreviewId}","responseCode":200},"input":{"type":"structure","required":["accessPreviewId","analyzerArn"],"members":{"accessPreviewId":{"location":"uri","locationName":"accessPreviewId"},"analyzerArn":{"location":"querystring","locationName":"analyzerArn"}}},"output":{"type":"structure","required":["accessPreview"],"members":{"accessPreview":{"type":"structure","required":["analyzerArn","configurations","createdAt","id","status"],"members":{"analyzerArn":{},"configurations":{"shape":"S9"},"createdAt":{"shape":"S1x"},"id":{},"status":{},"statusReason":{"shape":"S1z"}}}}}},"GetAnalyzedResource":{"http":{"method":"GET","requestUri":"/analyzed-resource","responseCode":200},"input":{"type":"structure","required":["analyzerArn","resourceArn"],"members":{"analyzerArn":{"location":"querystring","locationName":"analyzerArn"},"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"resource":{"type":"structure","required":["analyzedAt","createdAt","isPublic","resourceArn","resourceOwnerAccount","resourceType","updatedAt"],"members":{"actions":{"shape":"S25"},"analyzedAt":{"shape":"S1x"},"createdAt":{"shape":"S1x"},"error":{},"isPublic":{"type":"boolean"},"resourceArn":{},"resourceOwnerAccount":{},"resourceType":{},"sharedVia":{"type":"list","member":{}},"status":{},"updatedAt":{"shape":"S1x"}}}}}},"GetAnalyzer":{"http":{"method":"GET","requestUri":"/analyzer/{analyzerName}","responseCode":200},"input":{"type":"structure","required":["analyzerName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"}}},"output":{"type":"structure","required":["analyzer"],"members":{"analyzer":{"shape":"S2b"}}}},"GetArchiveRule":{"http":{"method":"GET","requestUri":"/analyzer/{analyzerName}/archive-rule/{ruleName}","responseCode":200},"input":{"type":"structure","required":["analyzerName","ruleName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"},"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","required":["archiveRule"],"members":{"archiveRule":{"shape":"S2h"}}}},"GetFinding":{"http":{"method":"GET","requestUri":"/finding/{id}","responseCode":200},"input":{"type":"structure","required":["analyzerArn","id"],"members":{"analyzerArn":{"location":"querystring","locationName":"analyzerArn"},"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"finding":{"type":"structure","required":["analyzedAt","condition","createdAt","id","resourceOwnerAccount","resourceType","status","updatedAt"],"members":{"action":{"shape":"S25"},"analyzedAt":{"shape":"S1x"},"condition":{"shape":"S2m"},"createdAt":{"shape":"S1x"},"error":{},"id":{},"isPublic":{"type":"boolean"},"principal":{"shape":"S2n"},"resource":{},"resourceOwnerAccount":{},"resourceType":{},"sources":{"shape":"S2o"},"status":{},"updatedAt":{"shape":"S1x"}}}}}},"GetGeneratedPolicy":{"http":{"method":"GET","requestUri":"/policy/generation/{jobId}","responseCode":200},"input":{"type":"structure","required":["jobId"],"members":{"includeResourcePlaceholders":{"location":"querystring","locationName":"includeResourcePlaceholders","type":"boolean"},"includeServiceLevelTemplate":{"location":"querystring","locationName":"includeServiceLevelTemplate","type":"boolean"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["generatedPolicyResult","jobDetails"],"members":{"generatedPolicyResult":{"type":"structure","required":["properties"],"members":{"generatedPolicies":{"type":"list","member":{"type":"structure","required":["policy"],"members":{"policy":{}}}},"properties":{"type":"structure","required":["principalArn"],"members":{"cloudTrailProperties":{"type":"structure","required":["endTime","startTime","trailProperties"],"members":{"endTime":{"shape":"S1x"},"startTime":{"shape":"S1x"},"trailProperties":{"type":"list","member":{"type":"structure","required":["cloudTrailArn"],"members":{"allRegions":{"type":"boolean"},"cloudTrailArn":{},"regions":{"shape":"S32"}}}}}},"isComplete":{"type":"boolean"},"principalArn":{}}}}},"jobDetails":{"type":"structure","required":["jobId","startedOn","status"],"members":{"completedOn":{"shape":"S1x"},"jobError":{"type":"structure","required":["code","message"],"members":{"code":{},"message":{}}},"jobId":{},"startedOn":{"shape":"S1x"},"status":{}}}}}},"ListAccessPreviewFindings":{"http":{"requestUri":"/access-preview/{accessPreviewId}","responseCode":200},"input":{"type":"structure","required":["accessPreviewId","analyzerArn"],"members":{"accessPreviewId":{"location":"uri","locationName":"accessPreviewId"},"analyzerArn":{},"filter":{"shape":"S1l"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["findings"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["changeType","createdAt","id","resourceOwnerAccount","resourceType","status"],"members":{"action":{"shape":"S25"},"changeType":{},"condition":{"shape":"S2m"},"createdAt":{"shape":"S1x"},"error":{},"existingFindingId":{},"existingFindingStatus":{},"id":{},"isPublic":{"type":"boolean"},"principal":{"shape":"S2n"},"resource":{},"resourceOwnerAccount":{},"resourceType":{},"sources":{"shape":"S2o"},"status":{}}}},"nextToken":{}}}},"ListAccessPreviews":{"http":{"method":"GET","requestUri":"/access-preview","responseCode":200},"input":{"type":"structure","required":["analyzerArn"],"members":{"analyzerArn":{"location":"querystring","locationName":"analyzerArn"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["accessPreviews"],"members":{"accessPreviews":{"type":"list","member":{"type":"structure","required":["analyzerArn","createdAt","id","status"],"members":{"analyzerArn":{},"createdAt":{"shape":"S1x"},"id":{},"status":{},"statusReason":{"shape":"S1z"}}}},"nextToken":{}}}},"ListAnalyzedResources":{"http":{"requestUri":"/analyzed-resource","responseCode":200},"input":{"type":"structure","required":["analyzerArn"],"members":{"analyzerArn":{},"maxResults":{"type":"integer"},"nextToken":{},"resourceType":{}}},"output":{"type":"structure","required":["analyzedResources"],"members":{"analyzedResources":{"type":"list","member":{"type":"structure","required":["resourceArn","resourceOwnerAccount","resourceType"],"members":{"resourceArn":{},"resourceOwnerAccount":{},"resourceType":{}}}},"nextToken":{}}}},"ListAnalyzers":{"http":{"method":"GET","requestUri":"/analyzer","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"type":{"location":"querystring","locationName":"type"}}},"output":{"type":"structure","required":["analyzers"],"members":{"analyzers":{"type":"list","member":{"shape":"S2b"}},"nextToken":{}}}},"ListArchiveRules":{"http":{"method":"GET","requestUri":"/analyzer/{analyzerName}/archive-rule","responseCode":200},"input":{"type":"structure","required":["analyzerName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["archiveRules"],"members":{"archiveRules":{"type":"list","member":{"shape":"S2h"}},"nextToken":{}}}},"ListFindings":{"http":{"requestUri":"/finding","responseCode":200},"input":{"type":"structure","required":["analyzerArn"],"members":{"analyzerArn":{},"filter":{"shape":"S1l"},"maxResults":{"type":"integer"},"nextToken":{},"sort":{"type":"structure","members":{"attributeName":{},"orderBy":{}}}}},"output":{"type":"structure","required":["findings"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["analyzedAt","condition","createdAt","id","resourceOwnerAccount","resourceType","status","updatedAt"],"members":{"action":{"shape":"S25"},"analyzedAt":{"shape":"S1x"},"condition":{"shape":"S2m"},"createdAt":{"shape":"S1x"},"error":{},"id":{},"isPublic":{"type":"boolean"},"principal":{"shape":"S2n"},"resource":{},"resourceOwnerAccount":{},"resourceType":{},"sources":{"shape":"S2o"},"status":{},"updatedAt":{"shape":"S1x"}}}},"nextToken":{}}}},"ListPolicyGenerations":{"http":{"method":"GET","requestUri":"/policy/generation","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"principalArn":{"location":"querystring","locationName":"principalArn"}}},"output":{"type":"structure","required":["policyGenerations"],"members":{"nextToken":{},"policyGenerations":{"type":"list","member":{"type":"structure","required":["jobId","principalArn","startedOn","status"],"members":{"completedOn":{"shape":"S1x"},"jobId":{},"principalArn":{},"startedOn":{"shape":"S1x"},"status":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1o"}}}},"StartPolicyGeneration":{"http":{"method":"PUT","requestUri":"/policy/generation","responseCode":200},"input":{"type":"structure","required":["policyGenerationDetails"],"members":{"clientToken":{"idempotencyToken":true},"cloudTrailDetails":{"type":"structure","required":["accessRole","startTime","trails"],"members":{"accessRole":{},"endTime":{"shape":"S1x"},"startTime":{"shape":"S1x"},"trails":{"type":"list","member":{"type":"structure","required":["cloudTrailArn"],"members":{"allRegions":{"type":"boolean"},"cloudTrailArn":{},"regions":{"shape":"S32"}}}}}},"policyGenerationDetails":{"type":"structure","required":["principalArn"],"members":{"principalArn":{}}}}},"output":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"idempotent":true},"StartResourceScan":{"http":{"requestUri":"/resource/scan","responseCode":200},"input":{"type":"structure","required":["analyzerArn","resourceArn"],"members":{"analyzerArn":{},"resourceArn":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateArchiveRule":{"http":{"method":"PUT","requestUri":"/analyzer/{analyzerName}/archive-rule/{ruleName}","responseCode":200},"input":{"type":"structure","required":["analyzerName","filter","ruleName"],"members":{"analyzerName":{"location":"uri","locationName":"analyzerName"},"clientToken":{"idempotencyToken":true},"filter":{"shape":"S1l"},"ruleName":{"location":"uri","locationName":"ruleName"}}},"idempotent":true},"UpdateFindings":{"http":{"method":"PUT","requestUri":"/finding","responseCode":200},"input":{"type":"structure","required":["analyzerArn","status"],"members":{"analyzerArn":{},"clientToken":{"idempotencyToken":true},"ids":{"type":"list","member":{}},"resourceArn":{},"status":{}}},"idempotent":true},"ValidatePolicy":{"http":{"requestUri":"/policy/validation","responseCode":200},"input":{"type":"structure","required":["policyDocument","policyType"],"members":{"locale":{},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"policyDocument":{},"policyType":{},"validatePolicyResourceType":{}}},"output":{"type":"structure","required":["findings"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["findingDetails","findingType","issueCode","learnMoreLink","locations"],"members":{"findingDetails":{},"findingType":{},"issueCode":{},"learnMoreLink":{},"locations":{"type":"list","member":{"type":"structure","required":["path","span"],"members":{"path":{"type":"list","member":{"type":"structure","members":{"index":{"type":"integer"},"key":{},"substring":{"type":"structure","required":["length","start"],"members":{"length":{"type":"integer"},"start":{"type":"integer"}}},"value":{}},"union":true}},"span":{"type":"structure","required":["end","start"],"members":{"end":{"shape":"S55"},"start":{"shape":"S55"}}}}}}}}},"nextToken":{}}}}},"shapes":{"S9":{"type":"map","key":{},"value":{"type":"structure","members":{"iamRole":{"type":"structure","members":{"trustPolicy":{}}},"kmsKey":{"type":"structure","members":{"grants":{"type":"list","member":{"type":"structure","required":["granteePrincipal","issuingAccount","operations"],"members":{"constraints":{"type":"structure","members":{"encryptionContextEquals":{"shape":"Si"},"encryptionContextSubset":{"shape":"Si"}}},"granteePrincipal":{},"issuingAccount":{},"operations":{"type":"list","member":{}},"retiringPrincipal":{}}}},"keyPolicies":{"type":"map","key":{},"value":{}}}},"s3Bucket":{"type":"structure","members":{"accessPoints":{"type":"map","key":{},"value":{"type":"structure","members":{"accessPointPolicy":{},"networkOrigin":{"type":"structure","members":{"internetConfiguration":{"type":"structure","members":{}},"vpcConfiguration":{"type":"structure","required":["vpcId"],"members":{"vpcId":{}}}},"union":true},"publicAccessBlock":{"shape":"S12"}}}},"bucketAclGrants":{"type":"list","member":{"type":"structure","required":["grantee","permission"],"members":{"grantee":{"type":"structure","members":{"id":{},"uri":{}},"union":true},"permission":{}}}},"bucketPolicy":{},"bucketPublicAccessBlock":{"shape":"S12"}}},"secretsManagerSecret":{"type":"structure","members":{"kmsKeyId":{},"secretPolicy":{}}},"sqsQueue":{"type":"structure","members":{"queuePolicy":{}}}},"union":true}},"Si":{"type":"map","key":{},"value":{}},"S12":{"type":"structure","required":["ignorePublicAcls","restrictPublicBuckets"],"members":{"ignorePublicAcls":{"type":"boolean"},"restrictPublicBuckets":{"type":"boolean"}}},"S1l":{"type":"map","key":{},"value":{"type":"structure","members":{"contains":{"shape":"S1n"},"eq":{"shape":"S1n"},"exists":{"type":"boolean"},"neq":{"shape":"S1n"}}}},"S1n":{"type":"list","member":{}},"S1o":{"type":"map","key":{},"value":{}},"S1x":{"type":"timestamp","timestampFormat":"iso8601"},"S1z":{"type":"structure","required":["code"],"members":{"code":{}}},"S25":{"type":"list","member":{}},"S2b":{"type":"structure","required":["arn","createdAt","name","status","type"],"members":{"arn":{},"createdAt":{"shape":"S1x"},"lastResourceAnalyzed":{},"lastResourceAnalyzedAt":{"shape":"S1x"},"name":{},"status":{},"statusReason":{"type":"structure","required":["code"],"members":{"code":{}}},"tags":{"shape":"S1o"},"type":{}}},"S2h":{"type":"structure","required":["createdAt","filter","ruleName","updatedAt"],"members":{"createdAt":{"shape":"S1x"},"filter":{"shape":"S1l"},"ruleName":{},"updatedAt":{"shape":"S1x"}}},"S2m":{"type":"map","key":{},"value":{}},"S2n":{"type":"map","key":{},"value":{}},"S2o":{"type":"list","member":{"type":"structure","required":["type"],"members":{"detail":{"type":"structure","members":{"accessPointArn":{}}},"type":{}}}},"S32":{"type":"list","member":{}},"S55":{"type":"structure","required":["column","line","offset"],"members":{"column":{"type":"integer"},"line":{"type":"integer"},"offset":{"type":"integer"}}}}}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccessPreviewFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"findings"},"ListAccessPreviews":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"accessPreviews"},"ListAnalyzedResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"analyzedResources"},"ListAnalyzers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"analyzers"},"ListArchiveRules":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"archiveRules"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"findings"},"ListPolicyGenerations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"policyGenerations"},"ValidatePolicy":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"findings"}}}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codegurureviewer'] = {};
	AWS.CodeGuruReviewer = Service.defineService('codegurureviewer', ['2019-09-19']);
	Object.defineProperty(apiLoader.services['codegurureviewer'], '2019-09-19', {
	  get: function get() {
	    var model = __webpack_require__(838);
	    model.paginators = __webpack_require__(839).pagination;
	    model.waiters = __webpack_require__(840).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeGuruReviewer;


/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-09-19","endpointPrefix":"codeguru-reviewer","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"CodeGuruReviewer","serviceFullName":"Amazon CodeGuru Reviewer","serviceId":"CodeGuru Reviewer","signatureVersion":"v4","signingName":"codeguru-reviewer","uid":"codeguru-reviewer-2019-09-19"},"operations":{"AssociateRepository":{"http":{"requestUri":"/associations"},"input":{"type":"structure","required":["Repository"],"members":{"Repository":{"type":"structure","members":{"CodeCommit":{"type":"structure","required":["Name"],"members":{"Name":{}}},"Bitbucket":{"shape":"S5"},"GitHubEnterpriseServer":{"shape":"S5"},"S3Bucket":{"type":"structure","required":["Name","BucketName"],"members":{"Name":{},"BucketName":{}}}}},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"Sb"},"KMSKeyDetails":{"shape":"Se"}}},"output":{"type":"structure","members":{"RepositoryAssociation":{"shape":"Si"},"Tags":{"shape":"Sb"}}}},"CreateCodeReview":{"http":{"requestUri":"/codereviews"},"input":{"type":"structure","required":["Name","RepositoryAssociationArn","Type"],"members":{"Name":{},"RepositoryAssociationArn":{},"Type":{"type":"structure","required":["RepositoryAnalysis"],"members":{"RepositoryAnalysis":{"type":"structure","members":{"RepositoryHead":{"shape":"Sy"},"SourceCodeType":{"shape":"S10"}}},"AnalysisTypes":{"shape":"S1c"}}},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CodeReview":{"shape":"S1f"}}}},"DescribeCodeReview":{"http":{"method":"GET","requestUri":"/codereviews/{CodeReviewArn}"},"input":{"type":"structure","required":["CodeReviewArn"],"members":{"CodeReviewArn":{"location":"uri","locationName":"CodeReviewArn"}}},"output":{"type":"structure","members":{"CodeReview":{"shape":"S1f"}}}},"DescribeRecommendationFeedback":{"http":{"method":"GET","requestUri":"/feedback/{CodeReviewArn}"},"input":{"type":"structure","required":["CodeReviewArn","RecommendationId"],"members":{"CodeReviewArn":{"location":"uri","locationName":"CodeReviewArn"},"RecommendationId":{"location":"querystring","locationName":"RecommendationId"},"UserId":{"location":"querystring","locationName":"UserId"}}},"output":{"type":"structure","members":{"RecommendationFeedback":{"type":"structure","members":{"CodeReviewArn":{},"RecommendationId":{},"Reactions":{"shape":"S1u"},"UserId":{},"CreatedTimeStamp":{"type":"timestamp"},"LastUpdatedTimeStamp":{"type":"timestamp"}}}}}},"DescribeRepositoryAssociation":{"http":{"method":"GET","requestUri":"/associations/{AssociationArn}"},"input":{"type":"structure","required":["AssociationArn"],"members":{"AssociationArn":{"location":"uri","locationName":"AssociationArn"}}},"output":{"type":"structure","members":{"RepositoryAssociation":{"shape":"Si"},"Tags":{"shape":"Sb"}}}},"DisassociateRepository":{"http":{"method":"DELETE","requestUri":"/associations/{AssociationArn}"},"input":{"type":"structure","required":["AssociationArn"],"members":{"AssociationArn":{"location":"uri","locationName":"AssociationArn"}}},"output":{"type":"structure","members":{"RepositoryAssociation":{"shape":"Si"},"Tags":{"shape":"Sb"}}}},"ListCodeReviews":{"http":{"method":"GET","requestUri":"/codereviews"},"input":{"type":"structure","required":["Type"],"members":{"ProviderTypes":{"shape":"S21","location":"querystring","locationName":"ProviderTypes"},"States":{"location":"querystring","locationName":"States","type":"list","member":{}},"RepositoryNames":{"location":"querystring","locationName":"RepositoryNames","type":"list","member":{}},"Type":{"location":"querystring","locationName":"Type"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"CodeReviewSummaries":{"type":"list","member":{"type":"structure","members":{"Name":{},"CodeReviewArn":{},"RepositoryName":{},"Owner":{},"ProviderType":{},"State":{},"CreatedTimeStamp":{"type":"timestamp"},"LastUpdatedTimeStamp":{"type":"timestamp"},"Type":{},"PullRequestId":{},"MetricsSummary":{"type":"structure","members":{"MeteredLinesOfCodeCount":{"type":"long"},"SuppressedLinesOfCodeCount":{"type":"long"},"FindingsCount":{"type":"long"}}},"SourceCodeType":{"shape":"S10"}}}},"NextToken":{}}}},"ListRecommendationFeedback":{"http":{"method":"GET","requestUri":"/feedback/{CodeReviewArn}/RecommendationFeedback"},"input":{"type":"structure","required":["CodeReviewArn"],"members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"CodeReviewArn":{"location":"uri","locationName":"CodeReviewArn"},"UserIds":{"location":"querystring","locationName":"UserIds","type":"list","member":{}},"RecommendationIds":{"location":"querystring","locationName":"RecommendationIds","type":"list","member":{}}}},"output":{"type":"structure","members":{"RecommendationFeedbackSummaries":{"type":"list","member":{"type":"structure","members":{"RecommendationId":{},"Reactions":{"shape":"S1u"},"UserId":{}}}},"NextToken":{}}}},"ListRecommendations":{"http":{"method":"GET","requestUri":"/codereviews/{CodeReviewArn}/Recommendations"},"input":{"type":"structure","required":["CodeReviewArn"],"members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"CodeReviewArn":{"location":"uri","locationName":"CodeReviewArn"}}},"output":{"type":"structure","members":{"RecommendationSummaries":{"type":"list","member":{"type":"structure","members":{"FilePath":{},"RecommendationId":{},"StartLine":{"type":"integer"},"EndLine":{"type":"integer"},"Description":{},"RecommendationCategory":{},"RuleMetadata":{"type":"structure","members":{"RuleId":{},"RuleName":{},"ShortDescription":{},"LongDescription":{},"RuleTags":{"type":"list","member":{}}}},"Severity":{}}}},"NextToken":{}}}},"ListRepositoryAssociations":{"http":{"method":"GET","requestUri":"/associations"},"input":{"type":"structure","members":{"ProviderTypes":{"shape":"S21","location":"querystring","locationName":"ProviderType"},"States":{"location":"querystring","locationName":"State","type":"list","member":{}},"Names":{"location":"querystring","locationName":"Name","type":"list","member":{}},"Owners":{"location":"querystring","locationName":"Owner","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"RepositoryAssociationSummaries":{"type":"list","member":{"type":"structure","members":{"AssociationArn":{},"ConnectionArn":{},"LastUpdatedTimeStamp":{"type":"timestamp"},"AssociationId":{},"Name":{},"Owner":{},"ProviderType":{},"State":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sb"}}}},"PutRecommendationFeedback":{"http":{"method":"PUT","requestUri":"/feedback"},"input":{"type":"structure","required":["CodeReviewArn","RecommendationId","Reactions"],"members":{"CodeReviewArn":{},"RecommendationId":{},"Reactions":{"shape":"S1u"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","Tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","TagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name","ConnectionArn","Owner"],"members":{"Name":{},"ConnectionArn":{},"Owner":{}}},"Sb":{"type":"map","key":{},"value":{}},"Se":{"type":"structure","members":{"KMSKeyId":{},"EncryptionOption":{}}},"Si":{"type":"structure","members":{"AssociationId":{},"AssociationArn":{},"ConnectionArn":{},"Name":{},"Owner":{},"ProviderType":{},"State":{},"StateReason":{},"LastUpdatedTimeStamp":{"type":"timestamp"},"CreatedTimeStamp":{"type":"timestamp"},"KMSKeyDetails":{"shape":"Se"},"S3RepositoryDetails":{"shape":"Sp"}}},"Sp":{"type":"structure","members":{"BucketName":{},"CodeArtifacts":{"type":"structure","required":["SourceCodeArtifactsObjectKey"],"members":{"SourceCodeArtifactsObjectKey":{},"BuildArtifactsObjectKey":{}}}}},"Sy":{"type":"structure","required":["BranchName"],"members":{"BranchName":{}}},"S10":{"type":"structure","members":{"CommitDiff":{"type":"structure","members":{"SourceCommit":{},"DestinationCommit":{},"MergeBaseCommit":{}}},"RepositoryHead":{"shape":"Sy"},"BranchDiff":{"type":"structure","required":["SourceBranchName","DestinationBranchName"],"members":{"SourceBranchName":{},"DestinationBranchName":{}}},"S3BucketRepository":{"type":"structure","required":["Name"],"members":{"Name":{},"Details":{"shape":"Sp"}}},"RequestMetadata":{"type":"structure","members":{"RequestId":{},"Requester":{},"EventInfo":{"type":"structure","members":{"Name":{},"State":{}}},"VendorName":{}}}}},"S1c":{"type":"list","member":{}},"S1f":{"type":"structure","members":{"Name":{},"CodeReviewArn":{},"RepositoryName":{},"Owner":{},"ProviderType":{},"State":{},"StateReason":{},"CreatedTimeStamp":{"type":"timestamp"},"LastUpdatedTimeStamp":{"type":"timestamp"},"Type":{},"PullRequestId":{},"SourceCodeType":{"shape":"S10"},"AssociationArn":{},"Metrics":{"type":"structure","members":{"MeteredLinesOfCodeCount":{"type":"long"},"SuppressedLinesOfCodeCount":{"type":"long"},"FindingsCount":{"type":"long"}}},"AnalysisTypes":{"shape":"S1c"},"ConfigFileState":{}}},"S1u":{"type":"list","member":{}},"S21":{"type":"list","member":{}}}}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListCodeReviews":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRecommendationFeedback":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRecommendations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRepositoryAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"RepositoryAssociationSummaries"}}}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"RepositoryAssociationSucceeded":{"description":"Wait until a repository association is complete.","operation":"DescribeRepositoryAssociation","delay":10,"maxAttempts":30,"acceptors":[{"state":"success","matcher":"path","argument":"RepositoryAssociation.State","expected":"Associated"},{"state":"failure","matcher":"path","argument":"RepositoryAssociation.State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"RepositoryAssociation.State","expected":"Associating"}]},"CodeReviewCompleted":{"description":"Wait until a code review is complete.","operation":"DescribeCodeReview","delay":10,"maxAttempts":180,"acceptors":[{"state":"success","matcher":"path","argument":"CodeReview.State","expected":"Completed"},{"state":"failure","matcher":"path","argument":"CodeReview.State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"CodeReview.State","expected":"Pending"}]}}}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codeguruprofiler'] = {};
	AWS.CodeGuruProfiler = Service.defineService('codeguruprofiler', ['2019-07-18']);
	Object.defineProperty(apiLoader.services['codeguruprofiler'], '2019-07-18', {
	  get: function get() {
	    var model = __webpack_require__(842);
	    model.paginators = __webpack_require__(843).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeGuruProfiler;


/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-07-18","endpointPrefix":"codeguru-profiler","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon CodeGuru Profiler","serviceId":"CodeGuruProfiler","signatureVersion":"v4","signingName":"codeguru-profiler","uid":"codeguruprofiler-2019-07-18"},"operations":{"AddNotificationChannels":{"http":{"requestUri":"/profilingGroups/{profilingGroupName}/notificationConfiguration","responseCode":200},"input":{"type":"structure","required":["channels","profilingGroupName"],"members":{"channels":{"shape":"S2"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","members":{"notificationConfiguration":{"shape":"Sa"}}}},"BatchGetFrameMetricData":{"http":{"requestUri":"/profilingGroups/{profilingGroupName}/frames/-/metrics","responseCode":200},"input":{"type":"structure","required":["profilingGroupName"],"members":{"endTime":{"shape":"Sc","location":"querystring","locationName":"endTime"},"frameMetrics":{"type":"list","member":{"shape":"Se"}},"period":{"location":"querystring","locationName":"period"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"startTime":{"shape":"Sc","location":"querystring","locationName":"startTime"},"targetResolution":{"location":"querystring","locationName":"targetResolution"}}},"output":{"type":"structure","required":["endTime","endTimes","frameMetricData","resolution","startTime","unprocessedEndTimes"],"members":{"endTime":{"shape":"Sc"},"endTimes":{"shape":"Sl"},"frameMetricData":{"type":"list","member":{"type":"structure","required":["frameMetric","values"],"members":{"frameMetric":{"shape":"Se"},"values":{"type":"list","member":{"type":"double"}}}}},"resolution":{},"startTime":{"shape":"Sc"},"unprocessedEndTimes":{"type":"map","key":{},"value":{"shape":"Sl"}}}}},"ConfigureAgent":{"http":{"requestUri":"/profilingGroups/{profilingGroupName}/configureAgent","responseCode":200},"input":{"type":"structure","required":["profilingGroupName"],"members":{"fleetInstanceId":{},"metadata":{"type":"map","key":{},"value":{}},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","required":["configuration"],"members":{"configuration":{"type":"structure","required":["periodInSeconds","shouldProfile"],"members":{"agentParameters":{"type":"map","key":{},"value":{}},"periodInSeconds":{"type":"integer"},"shouldProfile":{"type":"boolean"}}}},"payload":"configuration"}},"CreateProfilingGroup":{"http":{"requestUri":"/profilingGroups","responseCode":201},"input":{"type":"structure","required":["clientToken","profilingGroupName"],"members":{"agentOrchestrationConfig":{"shape":"S13"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"computePlatform":{},"profilingGroupName":{},"tags":{"shape":"S16"}}},"output":{"type":"structure","required":["profilingGroup"],"members":{"profilingGroup":{"shape":"S18"}},"payload":"profilingGroup"},"idempotent":true},"DeleteProfilingGroup":{"http":{"method":"DELETE","requestUri":"/profilingGroups/{profilingGroupName}","responseCode":204},"input":{"type":"structure","required":["profilingGroupName"],"members":{"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeProfilingGroup":{"http":{"method":"GET","requestUri":"/profilingGroups/{profilingGroupName}","responseCode":200},"input":{"type":"structure","required":["profilingGroupName"],"members":{"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","required":["profilingGroup"],"members":{"profilingGroup":{"shape":"S18"}},"payload":"profilingGroup"}},"GetFindingsReportAccountSummary":{"http":{"method":"GET","requestUri":"/internal/findingsReports","responseCode":200},"input":{"type":"structure","members":{"dailyReportsOnly":{"location":"querystring","locationName":"dailyReportsOnly","type":"boolean"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["reportSummaries"],"members":{"nextToken":{},"reportSummaries":{"shape":"S1k"}}}},"GetNotificationConfiguration":{"http":{"method":"GET","requestUri":"/profilingGroups/{profilingGroupName}/notificationConfiguration","responseCode":200},"input":{"type":"structure","required":["profilingGroupName"],"members":{"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","required":["notificationConfiguration"],"members":{"notificationConfiguration":{"shape":"Sa"}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/profilingGroups/{profilingGroupName}/policy","responseCode":200},"input":{"type":"structure","required":["profilingGroupName"],"members":{"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","required":["policy","revisionId"],"members":{"policy":{},"revisionId":{}}}},"GetProfile":{"http":{"method":"GET","requestUri":"/profilingGroups/{profilingGroupName}/profile","responseCode":200},"input":{"type":"structure","required":["profilingGroupName"],"members":{"accept":{"location":"header","locationName":"Accept"},"endTime":{"shape":"Sc","location":"querystring","locationName":"endTime"},"maxDepth":{"location":"querystring","locationName":"maxDepth","type":"integer"},"period":{"location":"querystring","locationName":"period"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"startTime":{"shape":"Sc","location":"querystring","locationName":"startTime"}}},"output":{"type":"structure","required":["contentType","profile"],"members":{"contentEncoding":{"location":"header","locationName":"Content-Encoding"},"contentType":{"location":"header","locationName":"Content-Type"},"profile":{"type":"blob"}},"payload":"profile"}},"GetRecommendations":{"http":{"method":"GET","requestUri":"/internal/profilingGroups/{profilingGroupName}/recommendations","responseCode":200},"input":{"type":"structure","required":["endTime","profilingGroupName","startTime"],"members":{"endTime":{"shape":"Sc","location":"querystring","locationName":"endTime"},"locale":{"location":"querystring","locationName":"locale"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"startTime":{"shape":"Sc","location":"querystring","locationName":"startTime"}}},"output":{"type":"structure","required":["anomalies","profileEndTime","profileStartTime","profilingGroupName","recommendations"],"members":{"anomalies":{"type":"list","member":{"type":"structure","required":["instances","metric","reason"],"members":{"instances":{"type":"list","member":{"type":"structure","required":["id","startTime"],"members":{"endTime":{"shape":"Sc"},"id":{},"startTime":{"shape":"Sc"},"userFeedback":{"type":"structure","required":["type"],"members":{"type":{}}}}}},"metric":{"type":"structure","required":["frameName","threadStates","type"],"members":{"frameName":{},"threadStates":{"shape":"S26"},"type":{}}},"reason":{}}}},"profileEndTime":{"shape":"Sc"},"profileStartTime":{"shape":"Sc"},"profilingGroupName":{},"recommendations":{"type":"list","member":{"type":"structure","required":["allMatchesCount","allMatchesSum","endTime","pattern","startTime","topMatches"],"members":{"allMatchesCount":{"type":"integer"},"allMatchesSum":{"type":"double"},"endTime":{"shape":"Sc"},"pattern":{"type":"structure","members":{"countersToAggregate":{"shape":"S26"},"description":{},"id":{},"name":{},"resolutionSteps":{},"targetFrames":{"type":"list","member":{"type":"list","member":{}}},"thresholdPercent":{"type":"double"}}},"startTime":{"shape":"Sc"},"topMatches":{"type":"list","member":{"type":"structure","members":{"frameAddress":{},"targetFramesIndex":{"type":"integer"},"thresholdBreachValue":{"type":"double"}}}}}}}}}},"ListFindingsReports":{"http":{"method":"GET","requestUri":"/internal/profilingGroups/{profilingGroupName}/findingsReports","responseCode":200},"input":{"type":"structure","required":["endTime","profilingGroupName","startTime"],"members":{"dailyReportsOnly":{"location":"querystring","locationName":"dailyReportsOnly","type":"boolean"},"endTime":{"shape":"Sc","location":"querystring","locationName":"endTime"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"startTime":{"shape":"Sc","location":"querystring","locationName":"startTime"}}},"output":{"type":"structure","required":["findingsReportSummaries"],"members":{"findingsReportSummaries":{"shape":"S1k"},"nextToken":{}}}},"ListProfileTimes":{"http":{"method":"GET","requestUri":"/profilingGroups/{profilingGroupName}/profileTimes","responseCode":200},"input":{"type":"structure","required":["endTime","period","profilingGroupName","startTime"],"members":{"endTime":{"shape":"Sc","location":"querystring","locationName":"endTime"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"orderBy":{"location":"querystring","locationName":"orderBy"},"period":{"location":"querystring","locationName":"period"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"startTime":{"shape":"Sc","location":"querystring","locationName":"startTime"}}},"output":{"type":"structure","required":["profileTimes"],"members":{"nextToken":{},"profileTimes":{"type":"list","member":{"type":"structure","members":{"start":{"shape":"Sc"}}}}}}},"ListProfilingGroups":{"http":{"method":"GET","requestUri":"/profilingGroups","responseCode":200},"input":{"type":"structure","members":{"includeDescription":{"location":"querystring","locationName":"includeDescription","type":"boolean"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["profilingGroupNames"],"members":{"nextToken":{},"profilingGroupNames":{"type":"list","member":{}},"profilingGroups":{"type":"list","member":{"shape":"S18"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S16"}}}},"PostAgentProfile":{"http":{"requestUri":"/profilingGroups/{profilingGroupName}/agentProfile","responseCode":204},"input":{"type":"structure","required":["agentProfile","contentType","profilingGroupName"],"members":{"agentProfile":{"type":"blob"},"contentType":{"location":"header","locationName":"Content-Type"},"profileToken":{"idempotencyToken":true,"location":"querystring","locationName":"profileToken"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}},"payload":"agentProfile"},"output":{"type":"structure","members":{}}},"PutPermission":{"http":{"method":"PUT","requestUri":"/profilingGroups/{profilingGroupName}/policy/{actionGroup}","responseCode":200},"input":{"type":"structure","required":["actionGroup","principals","profilingGroupName"],"members":{"actionGroup":{"location":"uri","locationName":"actionGroup"},"principals":{"type":"list","member":{}},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"revisionId":{}}},"output":{"type":"structure","required":["policy","revisionId"],"members":{"policy":{},"revisionId":{}}},"idempotent":true},"RemoveNotificationChannel":{"http":{"method":"DELETE","requestUri":"/profilingGroups/{profilingGroupName}/notificationConfiguration/{channelId}","responseCode":200},"input":{"type":"structure","required":["channelId","profilingGroupName"],"members":{"channelId":{"location":"uri","locationName":"channelId"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","members":{"notificationConfiguration":{"shape":"Sa"}}},"idempotent":true},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/profilingGroups/{profilingGroupName}/policy/{actionGroup}","responseCode":200},"input":{"type":"structure","required":["actionGroup","profilingGroupName","revisionId"],"members":{"actionGroup":{"location":"uri","locationName":"actionGroup"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"revisionId":{"location":"querystring","locationName":"revisionId"}}},"output":{"type":"structure","required":["policy","revisionId"],"members":{"policy":{},"revisionId":{}}}},"SubmitFeedback":{"http":{"requestUri":"/internal/profilingGroups/{profilingGroupName}/anomalies/{anomalyInstanceId}/feedback","responseCode":204},"input":{"type":"structure","required":["anomalyInstanceId","profilingGroupName","type"],"members":{"anomalyInstanceId":{"location":"uri","locationName":"anomalyInstanceId"},"comment":{},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"},"type":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateProfilingGroup":{"http":{"method":"PUT","requestUri":"/profilingGroups/{profilingGroupName}","responseCode":200},"input":{"type":"structure","required":["agentOrchestrationConfig","profilingGroupName"],"members":{"agentOrchestrationConfig":{"shape":"S13"},"profilingGroupName":{"location":"uri","locationName":"profilingGroupName"}}},"output":{"type":"structure","required":["profilingGroup"],"members":{"profilingGroup":{"shape":"S18"}},"payload":"profilingGroup"},"idempotent":true}},"shapes":{"S2":{"type":"list","member":{"type":"structure","required":["eventPublishers","uri"],"members":{"eventPublishers":{"type":"list","member":{}},"id":{},"uri":{}}}},"Sa":{"type":"structure","members":{"channels":{"shape":"S2"}}},"Sc":{"type":"timestamp","timestampFormat":"iso8601"},"Se":{"type":"structure","required":["frameName","threadStates","type"],"members":{"frameName":{},"threadStates":{"type":"list","member":{}},"type":{}}},"Sl":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{"shape":"Sc"}}}},"S13":{"type":"structure","required":["profilingEnabled"],"members":{"profilingEnabled":{"type":"boolean"}}},"S16":{"type":"map","key":{},"value":{}},"S18":{"type":"structure","members":{"agentOrchestrationConfig":{"shape":"S13"},"arn":{},"computePlatform":{},"createdAt":{"shape":"Sc"},"name":{},"profilingStatus":{"type":"structure","members":{"latestAgentOrchestratedAt":{"shape":"Sc"},"latestAgentProfileReportedAt":{"shape":"Sc"},"latestAggregatedProfile":{"type":"structure","members":{"period":{},"start":{"shape":"Sc"}}}}},"tags":{"shape":"S16"},"updatedAt":{"shape":"Sc"}}},"S1k":{"type":"list","member":{"type":"structure","members":{"id":{},"profileEndTime":{"shape":"Sc"},"profileStartTime":{"shape":"Sc"},"profilingGroupName":{},"totalNumberOfFindings":{"type":"integer"}}}},"S26":{"type":"list","member":{}}}}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetFindingsReportAccountSummary":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindingsReports":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListProfileTimes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"profileTimes"},"ListProfilingGroups":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['computeoptimizer'] = {};
	AWS.ComputeOptimizer = Service.defineService('computeoptimizer', ['2019-11-01']);
	Object.defineProperty(apiLoader.services['computeoptimizer'], '2019-11-01', {
	  get: function get() {
	    var model = __webpack_require__(845);
	    model.paginators = __webpack_require__(846).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ComputeOptimizer;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-11-01","endpointPrefix":"compute-optimizer","jsonVersion":"1.0","protocol":"json","serviceFullName":"AWS Compute Optimizer","serviceId":"Compute Optimizer","signatureVersion":"v4","signingName":"compute-optimizer","targetPrefix":"ComputeOptimizerService","uid":"compute-optimizer-2019-11-01"},"operations":{"DeleteRecommendationPreferences":{"input":{"type":"structure","required":["resourceType","recommendationPreferenceNames"],"members":{"resourceType":{},"scope":{"shape":"S3"},"recommendationPreferenceNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DescribeRecommendationExportJobs":{"input":{"type":"structure","members":{"jobIds":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sf"}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"recommendationExportJobs":{"type":"list","member":{"type":"structure","members":{"jobId":{},"destination":{"type":"structure","members":{"s3":{"shape":"Sn"}}},"resourceType":{},"status":{},"creationTimestamp":{"type":"timestamp"},"lastUpdatedTimestamp":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}}},"ExportAutoScalingGroupRecommendations":{"input":{"type":"structure","required":["s3DestinationConfig"],"members":{"accountIds":{"shape":"Sw"},"filters":{"shape":"Sy"},"fieldsToExport":{"type":"list","member":{}},"s3DestinationConfig":{"shape":"S13"},"fileFormat":{},"includeMemberAccounts":{"type":"boolean"},"recommendationPreferences":{"shape":"S17"}}},"output":{"type":"structure","members":{"jobId":{},"s3Destination":{"shape":"Sn"}}}},"ExportEBSVolumeRecommendations":{"input":{"type":"structure","required":["s3DestinationConfig"],"members":{"accountIds":{"shape":"Sw"},"filters":{"shape":"S1c"},"fieldsToExport":{"type":"list","member":{}},"s3DestinationConfig":{"shape":"S13"},"fileFormat":{},"includeMemberAccounts":{"type":"boolean"}}},"output":{"type":"structure","members":{"jobId":{},"s3Destination":{"shape":"Sn"}}}},"ExportEC2InstanceRecommendations":{"input":{"type":"structure","required":["s3DestinationConfig"],"members":{"accountIds":{"shape":"Sw"},"filters":{"shape":"Sy"},"fieldsToExport":{"type":"list","member":{}},"s3DestinationConfig":{"shape":"S13"},"fileFormat":{},"includeMemberAccounts":{"type":"boolean"},"recommendationPreferences":{"shape":"S17"}}},"output":{"type":"structure","members":{"jobId":{},"s3Destination":{"shape":"Sn"}}}},"ExportLambdaFunctionRecommendations":{"input":{"type":"structure","required":["s3DestinationConfig"],"members":{"accountIds":{"shape":"Sw"},"filters":{"shape":"S1n"},"fieldsToExport":{"type":"list","member":{}},"s3DestinationConfig":{"shape":"S13"},"fileFormat":{},"includeMemberAccounts":{"type":"boolean"}}},"output":{"type":"structure","members":{"jobId":{},"s3Destination":{"shape":"Sn"}}}},"GetAutoScalingGroupRecommendations":{"input":{"type":"structure","members":{"accountIds":{"shape":"Sw"},"autoScalingGroupArns":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"Sy"},"recommendationPreferences":{"shape":"S17"}}},"output":{"type":"structure","members":{"nextToken":{},"autoScalingGroupRecommendations":{"type":"list","member":{"type":"structure","members":{"accountId":{},"autoScalingGroupArn":{},"autoScalingGroupName":{},"finding":{},"utilizationMetrics":{"shape":"S21"},"lookBackPeriodInDays":{"type":"double"},"currentConfiguration":{"shape":"S27"},"recommendationOptions":{"type":"list","member":{"type":"structure","members":{"configuration":{"shape":"S27"},"projectedUtilizationMetrics":{"shape":"S2e"},"performanceRisk":{"type":"double"},"rank":{"type":"integer"},"savingsOpportunity":{"shape":"S2h"},"migrationEffort":{}}}},"lastRefreshTimestamp":{"type":"timestamp"},"currentPerformanceRisk":{},"effectiveRecommendationPreferences":{"shape":"S2p"},"inferredWorkloadTypes":{"shape":"S2s"}}}},"errors":{"shape":"S2u"}}}},"GetEBSVolumeRecommendations":{"input":{"type":"structure","members":{"volumeArns":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S1c"},"accountIds":{"shape":"Sw"}}},"output":{"type":"structure","members":{"nextToken":{},"volumeRecommendations":{"type":"list","member":{"type":"structure","members":{"volumeArn":{},"accountId":{},"currentConfiguration":{"shape":"S35"},"finding":{},"utilizationMetrics":{"type":"list","member":{"type":"structure","members":{"name":{},"statistic":{},"value":{"type":"double"}}}},"lookBackPeriodInDays":{"type":"double"},"volumeRecommendationOptions":{"type":"list","member":{"type":"structure","members":{"configuration":{"shape":"S35"},"performanceRisk":{"type":"double"},"rank":{"type":"integer"},"savingsOpportunity":{"shape":"S2h"}}}},"lastRefreshTimestamp":{"type":"timestamp"},"currentPerformanceRisk":{}}}},"errors":{"shape":"S2u"}}}},"GetEC2InstanceRecommendations":{"input":{"type":"structure","members":{"instanceArns":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"Sy"},"accountIds":{"shape":"Sw"},"recommendationPreferences":{"shape":"S17"}}},"output":{"type":"structure","members":{"nextToken":{},"instanceRecommendations":{"type":"list","member":{"type":"structure","members":{"instanceArn":{},"accountId":{},"instanceName":{},"currentInstanceType":{},"finding":{},"findingReasonCodes":{"type":"list","member":{}},"utilizationMetrics":{"shape":"S21"},"lookBackPeriodInDays":{"type":"double"},"recommendationOptions":{"type":"list","member":{"type":"structure","members":{"instanceType":{},"projectedUtilizationMetrics":{"shape":"S2e"},"platformDifferences":{"type":"list","member":{}},"performanceRisk":{"type":"double"},"rank":{"type":"integer"},"savingsOpportunity":{"shape":"S2h"},"migrationEffort":{}}}},"recommendationSources":{"type":"list","member":{"type":"structure","members":{"recommendationSourceArn":{},"recommendationSourceType":{}}}},"lastRefreshTimestamp":{"type":"timestamp"},"currentPerformanceRisk":{},"effectiveRecommendationPreferences":{"shape":"S2p"},"inferredWorkloadTypes":{"shape":"S2s"}}}},"errors":{"shape":"S2u"}}}},"GetEC2RecommendationProjectedMetrics":{"input":{"type":"structure","required":["instanceArn","stat","period","startTime","endTime"],"members":{"instanceArn":{},"stat":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"recommendationPreferences":{"shape":"S17"}}},"output":{"type":"structure","members":{"recommendedOptionProjectedMetrics":{"type":"list","member":{"type":"structure","members":{"recommendedInstanceType":{},"rank":{"type":"integer"},"projectedMetrics":{"type":"list","member":{"type":"structure","members":{"name":{},"timestamps":{"type":"list","member":{"type":"timestamp"}},"values":{"type":"list","member":{"type":"double"}}}}}}}}}}},"GetEffectiveRecommendationPreferences":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"enhancedInfrastructureMetrics":{}}}},"GetEnrollmentStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"status":{},"statusReason":{},"memberAccountsEnrolled":{"type":"boolean"},"lastUpdatedTimestamp":{"type":"timestamp"},"numberOfMemberAccountsOptedIn":{"type":"integer"}}}},"GetEnrollmentStatusesForOrganization":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sf"}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"accountEnrollmentStatuses":{"type":"list","member":{"type":"structure","members":{"accountId":{},"status":{},"statusReason":{},"lastUpdatedTimestamp":{"type":"timestamp"}}}},"nextToken":{}}}},"GetLambdaFunctionRecommendations":{"input":{"type":"structure","members":{"functionArns":{"type":"list","member":{}},"accountIds":{"shape":"Sw"},"filters":{"shape":"S1n"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"lambdaFunctionRecommendations":{"type":"list","member":{"type":"structure","members":{"functionArn":{},"functionVersion":{},"accountId":{},"currentMemorySize":{"type":"integer"},"numberOfInvocations":{"type":"long"},"utilizationMetrics":{"type":"list","member":{"type":"structure","members":{"name":{},"statistic":{},"value":{"type":"double"}}}},"lookbackPeriodInDays":{"type":"double"},"lastRefreshTimestamp":{"type":"timestamp"},"finding":{},"findingReasonCodes":{"type":"list","member":{}},"memorySizeRecommendationOptions":{"type":"list","member":{"type":"structure","members":{"rank":{"type":"integer"},"memorySize":{"type":"integer"},"projectedUtilizationMetrics":{"type":"list","member":{"type":"structure","members":{"name":{},"statistic":{},"value":{"type":"double"}}}},"savingsOpportunity":{"shape":"S2h"}}}},"currentPerformanceRisk":{}}}}}}},"GetRecommendationPreferences":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"scope":{"shape":"S3"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"recommendationPreferencesDetails":{"type":"list","member":{"type":"structure","members":{"scope":{"shape":"S3"},"resourceType":{},"enhancedInfrastructureMetrics":{},"inferredWorkloadTypes":{}}}}}}},"GetRecommendationSummaries":{"input":{"type":"structure","members":{"accountIds":{"shape":"Sw"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"recommendationSummaries":{"type":"list","member":{"type":"structure","members":{"summaries":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"type":"double"},"reasonCodeSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"type":"double"}}}}}}},"recommendationResourceType":{},"accountId":{},"savingsOpportunity":{"shape":"S2h"},"currentPerformanceRiskRatings":{"type":"structure","members":{"high":{"type":"long"},"medium":{"type":"long"},"low":{"type":"long"},"veryLow":{"type":"long"}}}}}}}}},"PutRecommendationPreferences":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"scope":{"shape":"S3"},"enhancedInfrastructureMetrics":{},"inferredWorkloadTypes":{}}},"output":{"type":"structure","members":{}}},"UpdateEnrollmentStatus":{"input":{"type":"structure","required":["status"],"members":{"status":{},"includeMemberAccounts":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusReason":{}}}}},"shapes":{"S3":{"type":"structure","members":{"name":{},"value":{}}},"Sf":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"bucket":{},"key":{},"metadataKey":{}}},"Sw":{"type":"list","member":{}},"Sy":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sf"}}}},"S13":{"type":"structure","members":{"bucket":{},"keyPrefix":{}}},"S17":{"type":"structure","members":{"cpuVendorArchitectures":{"shape":"S18"}}},"S18":{"type":"list","member":{}},"S1c":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sf"}}}},"S1n":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"Sf"}}}},"S21":{"type":"list","member":{"shape":"S22"}},"S22":{"type":"structure","members":{"name":{},"statistic":{},"value":{"type":"double"}}},"S27":{"type":"structure","members":{"desiredCapacity":{"type":"integer"},"minSize":{"type":"integer"},"maxSize":{"type":"integer"},"instanceType":{}}},"S2e":{"type":"list","member":{"shape":"S22"}},"S2h":{"type":"structure","members":{"savingsOpportunityPercentage":{"type":"double"},"estimatedMonthlySavings":{"type":"structure","members":{"currency":{},"value":{"type":"double"}}}}},"S2p":{"type":"structure","members":{"cpuVendorArchitectures":{"shape":"S18"},"enhancedInfrastructureMetrics":{},"inferredWorkloadTypes":{}}},"S2s":{"type":"list","member":{}},"S2u":{"type":"list","member":{"type":"structure","members":{"identifier":{},"code":{},"message":{}}}},"S35":{"type":"structure","members":{"volumeType":{},"volumeSize":{"type":"integer"},"volumeBaselineIOPS":{"type":"integer"},"volumeBurstIOPS":{"type":"integer"},"volumeBaselineThroughput":{"type":"integer"},"volumeBurstThroughput":{"type":"integer"}}}}}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['frauddetector'] = {};
	AWS.FraudDetector = Service.defineService('frauddetector', ['2019-11-15']);
	Object.defineProperty(apiLoader.services['frauddetector'], '2019-11-15', {
	  get: function get() {
	    var model = __webpack_require__(848);
	    model.paginators = __webpack_require__(849).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.FraudDetector;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-11-15","endpointPrefix":"frauddetector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Fraud Detector","serviceId":"FraudDetector","signatureVersion":"v4","targetPrefix":"AWSHawksNestServiceFacade","uid":"frauddetector-2019-11-15"},"operations":{"BatchCreateVariable":{"input":{"type":"structure","required":["variableEntries"],"members":{"variableEntries":{"type":"list","member":{"type":"structure","members":{"name":{},"dataType":{},"dataSource":{},"defaultValue":{},"description":{},"variableType":{}}}},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"type":"structure","members":{"name":{},"code":{"type":"integer"},"message":{}}}}}}},"BatchGetVariable":{"input":{"type":"structure","required":["names"],"members":{"names":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"variables":{"shape":"Sg"},"errors":{"type":"list","member":{"type":"structure","members":{"name":{},"code":{"type":"integer"},"message":{}}}}}}},"CancelBatchImportJob":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{}}},"CancelBatchPredictionJob":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{}}},"CreateBatchImportJob":{"input":{"type":"structure","required":["jobId","inputPath","outputPath","eventTypeName","iamRoleArn"],"members":{"jobId":{},"inputPath":{},"outputPath":{},"eventTypeName":{},"iamRoleArn":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"CreateBatchPredictionJob":{"input":{"type":"structure","required":["jobId","inputPath","outputPath","eventTypeName","detectorName","iamRoleArn"],"members":{"jobId":{},"inputPath":{},"outputPath":{},"eventTypeName":{},"detectorName":{},"detectorVersion":{},"iamRoleArn":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"CreateDetectorVersion":{"input":{"type":"structure","required":["detectorId","rules"],"members":{"detectorId":{},"description":{},"externalModelEndpoints":{"shape":"S12"},"rules":{"shape":"S13"},"modelVersions":{"shape":"S15"},"ruleExecutionMode":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"detectorId":{},"detectorVersionId":{},"status":{}}}},"CreateModel":{"input":{"type":"structure","required":["modelId","modelType","eventTypeName"],"members":{"modelId":{},"modelType":{},"description":{},"eventTypeName":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"CreateModelVersion":{"input":{"type":"structure","required":["modelId","modelType","trainingDataSource","trainingDataSchema"],"members":{"modelId":{},"modelType":{},"trainingDataSource":{},"trainingDataSchema":{"shape":"S1h"},"externalEventsDetail":{"shape":"S1m"},"ingestedEventsDetail":{"shape":"S1n"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"modelId":{},"modelType":{},"modelVersionNumber":{},"status":{}}}},"CreateRule":{"input":{"type":"structure","required":["ruleId","detectorId","expression","language","outcomes"],"members":{"ruleId":{},"detectorId":{},"description":{},"expression":{"shape":"S1r"},"language":{},"outcomes":{"shape":"S1k"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"rule":{"shape":"S14"}}}},"CreateVariable":{"input":{"type":"structure","required":["name","dataType","dataSource","defaultValue"],"members":{"name":{},"dataType":{},"dataSource":{},"defaultValue":{},"description":{},"variableType":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"DeleteBatchImportJob":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{}}},"DeleteBatchPredictionJob":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{}}},"DeleteDetector":{"input":{"type":"structure","required":["detectorId"],"members":{"detectorId":{}}},"output":{"type":"structure","members":{}}},"DeleteDetectorVersion":{"input":{"type":"structure","required":["detectorId","detectorVersionId"],"members":{"detectorId":{},"detectorVersionId":{}}},"output":{"type":"structure","members":{}}},"DeleteEntityType":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteEvent":{"input":{"type":"structure","required":["eventId","eventTypeName"],"members":{"eventId":{},"eventTypeName":{},"deleteAuditHistory":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteEventType":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteEventsByEventType":{"input":{"type":"structure","required":["eventTypeName"],"members":{"eventTypeName":{}}},"output":{"type":"structure","members":{"eventTypeName":{},"eventsDeletionStatus":{}}}},"DeleteExternalModel":{"input":{"type":"structure","required":["modelEndpoint"],"members":{"modelEndpoint":{}}},"output":{"type":"structure","members":{}}},"DeleteLabel":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteModel":{"input":{"type":"structure","required":["modelId","modelType"],"members":{"modelId":{},"modelType":{}}},"output":{"type":"structure","members":{}}},"DeleteModelVersion":{"input":{"type":"structure","required":["modelId","modelType","modelVersionNumber"],"members":{"modelId":{},"modelType":{},"modelVersionNumber":{}}},"output":{"type":"structure","members":{}}},"DeleteOutcome":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["rule"],"members":{"rule":{"shape":"S14"}}},"output":{"type":"structure","members":{}}},"DeleteVariable":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DescribeDetector":{"input":{"type":"structure","required":["detectorId"],"members":{"detectorId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"detectorId":{},"detectorVersionSummaries":{"type":"list","member":{"type":"structure","members":{"detectorVersionId":{},"status":{},"description":{},"lastUpdatedTime":{}}}},"nextToken":{},"arn":{}}}},"DescribeModelVersions":{"input":{"type":"structure","members":{"modelId":{},"modelVersionNumber":{},"modelType":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"modelVersionDetails":{"type":"list","member":{"type":"structure","members":{"modelId":{},"modelType":{},"modelVersionNumber":{},"status":{},"trainingDataSource":{},"trainingDataSchema":{"shape":"S1h"},"externalEventsDetail":{"shape":"S1m"},"ingestedEventsDetail":{"shape":"S1n"},"trainingResult":{"type":"structure","members":{"dataValidationMetrics":{"type":"structure","members":{"fileLevelMessages":{"type":"list","member":{"type":"structure","members":{"title":{},"content":{},"type":{}}}},"fieldLevelMessages":{"type":"list","member":{"type":"structure","members":{"fieldName":{},"identifier":{},"title":{},"content":{},"type":{}}}}}},"trainingMetrics":{"type":"structure","members":{"auc":{"type":"float"},"metricDataPoints":{"type":"list","member":{"type":"structure","members":{"fpr":{"type":"float"},"precision":{"type":"float"},"tpr":{"type":"float"},"threshold":{"type":"float"}}}}}},"variableImportanceMetrics":{"type":"structure","members":{"logOddsMetrics":{"type":"list","member":{"type":"structure","required":["variableName","variableType","variableImportance"],"members":{"variableName":{},"variableType":{},"variableImportance":{"type":"float"}}}}}}}},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetBatchImportJobs":{"input":{"type":"structure","members":{"jobId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"batchImports":{"type":"list","member":{"type":"structure","members":{"jobId":{},"status":{},"failureReason":{},"startTime":{},"completionTime":{},"inputPath":{},"outputPath":{},"eventTypeName":{},"iamRoleArn":{},"arn":{},"processedRecordsCount":{"type":"integer"},"failedRecordsCount":{"type":"integer"},"totalRecordsCount":{"type":"integer"}}}},"nextToken":{}}}},"GetBatchPredictionJobs":{"input":{"type":"structure","members":{"jobId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"batchPredictions":{"type":"list","member":{"type":"structure","members":{"jobId":{},"status":{},"failureReason":{},"startTime":{},"completionTime":{},"lastHeartbeatTime":{},"inputPath":{},"outputPath":{},"eventTypeName":{},"detectorName":{},"detectorVersion":{},"iamRoleArn":{},"arn":{},"processedRecordsCount":{"type":"integer"},"totalRecordsCount":{"type":"integer"}}}},"nextToken":{}}}},"GetDeleteEventsByEventTypeStatus":{"input":{"type":"structure","required":["eventTypeName"],"members":{"eventTypeName":{}}},"output":{"type":"structure","members":{"eventTypeName":{},"eventsDeletionStatus":{}}}},"GetDetectorVersion":{"input":{"type":"structure","required":["detectorId","detectorVersionId"],"members":{"detectorId":{},"detectorVersionId":{}}},"output":{"type":"structure","members":{"detectorId":{},"detectorVersionId":{},"description":{},"externalModelEndpoints":{"shape":"S12"},"modelVersions":{"shape":"S15"},"rules":{"shape":"S13"},"status":{},"lastUpdatedTime":{},"createdTime":{},"ruleExecutionMode":{},"arn":{}}}},"GetDetectors":{"input":{"type":"structure","members":{"detectorId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"detectors":{"type":"list","member":{"type":"structure","members":{"detectorId":{},"description":{},"eventTypeName":{},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetEntityTypes":{"input":{"type":"structure","members":{"name":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"entityTypes":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetEvent":{"input":{"type":"structure","required":["eventId","eventTypeName"],"members":{"eventId":{},"eventTypeName":{}}},"output":{"type":"structure","members":{"event":{"type":"structure","members":{"eventId":{},"eventTypeName":{},"eventTimestamp":{},"eventVariables":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"currentLabel":{},"labelTimestamp":{},"entities":{"shape":"S4b"}}}}}},"GetEventPrediction":{"input":{"type":"structure","required":["detectorId","eventId","eventTypeName","entities","eventTimestamp","eventVariables"],"members":{"detectorId":{},"detectorVersionId":{},"eventId":{},"eventTypeName":{},"entities":{"shape":"S4b"},"eventTimestamp":{},"eventVariables":{"shape":"S4g"},"externalModelEndpointDataBlobs":{"type":"map","key":{},"value":{"type":"structure","members":{"byteBuffer":{"type":"blob"},"contentType":{}}},"sensitive":true}}},"output":{"type":"structure","members":{"modelScores":{"type":"list","member":{"type":"structure","members":{"modelVersion":{"shape":"S16"},"scores":{"type":"map","key":{},"value":{"type":"float"}}}}},"ruleResults":{"type":"list","member":{"type":"structure","members":{"ruleId":{},"outcomes":{"shape":"S12"}}}},"externalModelOutputs":{"type":"list","member":{"type":"structure","members":{"externalModel":{"type":"structure","members":{"modelEndpoint":{},"modelSource":{}}},"outputs":{"type":"map","key":{},"value":{}}}}}}}},"GetEventPredictionMetadata":{"input":{"type":"structure","required":["eventId","eventTypeName","detectorId","detectorVersionId","predictionTimestamp"],"members":{"eventId":{},"eventTypeName":{},"detectorId":{},"detectorVersionId":{},"predictionTimestamp":{}}},"output":{"type":"structure","members":{"eventId":{},"eventTypeName":{},"entityId":{},"entityType":{},"eventTimestamp":{},"detectorId":{},"detectorVersionId":{},"detectorVersionStatus":{},"eventVariables":{"type":"list","member":{"type":"structure","members":{"name":{"shape":"S52"},"value":{"shape":"S52"},"source":{"shape":"S52"}}}},"rules":{"type":"list","member":{"type":"structure","members":{"ruleId":{},"ruleVersion":{},"expression":{"shape":"S52"},"expressionWithValues":{"shape":"S52"},"outcomes":{"shape":"S12"},"evaluated":{"type":"boolean"},"matched":{"type":"boolean"}}}},"ruleExecutionMode":{},"outcomes":{"shape":"S12"},"evaluatedModelVersions":{"type":"list","member":{"type":"structure","members":{"modelId":{},"modelVersion":{},"modelType":{},"evaluations":{"type":"list","member":{"type":"structure","members":{"outputVariableName":{},"evaluationScore":{},"predictionExplanations":{"type":"structure","members":{"variableImpactExplanations":{"type":"list","member":{"type":"structure","members":{"eventVariableName":{},"relativeImpact":{},"logOddsImpact":{"type":"float"}}}}}}}}}}}},"evaluatedExternalModels":{"type":"list","member":{"type":"structure","members":{"modelEndpoint":{},"useEventVariables":{"type":"boolean"},"inputVariables":{"shape":"S5f"},"outputVariables":{"shape":"S5f"}}}},"predictionTimestamp":{}}}},"GetEventTypes":{"input":{"type":"structure","members":{"name":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTypes":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"eventVariables":{"shape":"S12"},"labels":{"shape":"S12"},"entityTypes":{"shape":"S1k"},"eventIngestion":{},"ingestedEventStatistics":{"type":"structure","members":{"numberOfEvents":{"type":"long"},"eventDataSizeInBytes":{"type":"long"},"leastRecentEvent":{},"mostRecentEvent":{},"lastUpdatedTime":{}}},"lastUpdatedTime":{},"createdTime":{},"arn":{}},"sensitive":true}},"nextToken":{}}}},"GetExternalModels":{"input":{"type":"structure","members":{"modelEndpoint":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"externalModels":{"type":"list","member":{"type":"structure","members":{"modelEndpoint":{},"modelSource":{},"invokeModelEndpointRoleArn":{},"inputConfiguration":{"shape":"S5t"},"outputConfiguration":{"shape":"S5x"},"modelEndpointStatus":{},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetKMSEncryptionKey":{"output":{"type":"structure","members":{"kmsKey":{"type":"structure","members":{"kmsEncryptionKeyArn":{}}}}}},"GetLabels":{"input":{"type":"structure","members":{"name":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"labels":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetModelVersion":{"input":{"type":"structure","required":["modelId","modelType","modelVersionNumber"],"members":{"modelId":{},"modelType":{},"modelVersionNumber":{}}},"output":{"type":"structure","members":{"modelId":{},"modelType":{},"modelVersionNumber":{},"trainingDataSource":{},"trainingDataSchema":{"shape":"S1h"},"externalEventsDetail":{"shape":"S1m"},"ingestedEventsDetail":{"shape":"S1n"},"status":{},"arn":{}}}},"GetModels":{"input":{"type":"structure","members":{"modelId":{},"modelType":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"models":{"type":"list","member":{"type":"structure","members":{"modelId":{},"modelType":{},"description":{},"eventTypeName":{},"createdTime":{},"lastUpdatedTime":{},"arn":{}}}}}}},"GetOutcomes":{"input":{"type":"structure","members":{"name":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"outcomes":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetRules":{"input":{"type":"structure","required":["detectorId"],"members":{"ruleId":{},"detectorId":{},"ruleVersion":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ruleDetails":{"type":"list","member":{"type":"structure","members":{"ruleId":{},"description":{},"detectorId":{},"ruleVersion":{},"expression":{"shape":"S1r"},"language":{},"outcomes":{"shape":"S1k"},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"nextToken":{}}}},"GetVariables":{"input":{"type":"structure","members":{"name":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"variables":{"shape":"Sg"},"nextToken":{}}}},"ListEventPredictions":{"input":{"type":"structure","members":{"eventId":{"shape":"S6u"},"eventType":{"shape":"S6u"},"detectorId":{"shape":"S6u"},"detectorVersionId":{"shape":"S6u"},"predictionTimeRange":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{},"endTime":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventPredictionSummaries":{"type":"list","member":{"type":"structure","members":{"eventId":{},"eventTypeName":{},"eventTimestamp":{},"predictionTimestamp":{},"detectorId":{},"detectorVersionId":{}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceARN"],"members":{"resourceARN":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5"},"nextToken":{}}}},"PutDetector":{"input":{"type":"structure","required":["detectorId","eventTypeName"],"members":{"detectorId":{},"description":{},"eventTypeName":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"PutEntityType":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"PutEventType":{"input":{"type":"structure","required":["name","eventVariables","entityTypes"],"members":{"name":{},"description":{},"eventVariables":{"shape":"S1k"},"labels":{"shape":"S12"},"entityTypes":{"shape":"S1k"},"eventIngestion":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"PutExternalModel":{"input":{"type":"structure","required":["modelEndpoint","modelSource","invokeModelEndpointRoleArn","inputConfiguration","outputConfiguration","modelEndpointStatus"],"members":{"modelEndpoint":{},"modelSource":{},"invokeModelEndpointRoleArn":{},"inputConfiguration":{"shape":"S5t"},"outputConfiguration":{"shape":"S5x"},"modelEndpointStatus":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"PutKMSEncryptionKey":{"input":{"type":"structure","required":["kmsEncryptionKeyArn"],"members":{"kmsEncryptionKeyArn":{}}},"output":{"type":"structure","members":{}}},"PutLabel":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"PutOutcome":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"SendEvent":{"input":{"type":"structure","required":["eventId","eventTypeName","eventTimestamp","eventVariables","entities"],"members":{"eventId":{},"eventTypeName":{},"eventTimestamp":{},"eventVariables":{"shape":"S4g"},"assignedLabel":{},"labelTimestamp":{},"entities":{"shape":"S4b"}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["resourceARN","tags"],"members":{"resourceARN":{},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceARN","tagKeys"],"members":{"resourceARN":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDetectorVersion":{"input":{"type":"structure","required":["detectorId","detectorVersionId","externalModelEndpoints","rules"],"members":{"detectorId":{},"detectorVersionId":{},"externalModelEndpoints":{"shape":"S12"},"rules":{"shape":"S13"},"description":{},"modelVersions":{"shape":"S15"},"ruleExecutionMode":{}}},"output":{"type":"structure","members":{}}},"UpdateDetectorVersionMetadata":{"input":{"type":"structure","required":["detectorId","detectorVersionId","description"],"members":{"detectorId":{},"detectorVersionId":{},"description":{}}},"output":{"type":"structure","members":{}}},"UpdateDetectorVersionStatus":{"input":{"type":"structure","required":["detectorId","detectorVersionId","status"],"members":{"detectorId":{},"detectorVersionId":{},"status":{}}},"output":{"type":"structure","members":{}}},"UpdateEventLabel":{"input":{"type":"structure","required":["eventId","eventTypeName","assignedLabel","labelTimestamp"],"members":{"eventId":{},"eventTypeName":{},"assignedLabel":{},"labelTimestamp":{}}},"output":{"type":"structure","members":{}}},"UpdateModel":{"input":{"type":"structure","required":["modelId","modelType"],"members":{"modelId":{},"modelType":{},"description":{}}},"output":{"type":"structure","members":{}}},"UpdateModelVersion":{"input":{"type":"structure","required":["modelId","modelType","majorVersionNumber"],"members":{"modelId":{},"modelType":{},"majorVersionNumber":{},"externalEventsDetail":{"shape":"S1m"},"ingestedEventsDetail":{"shape":"S1n"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"modelId":{},"modelType":{},"modelVersionNumber":{},"status":{}}}},"UpdateModelVersionStatus":{"input":{"type":"structure","required":["modelId","modelType","modelVersionNumber","status"],"members":{"modelId":{},"modelType":{},"modelVersionNumber":{},"status":{}}},"output":{"type":"structure","members":{}}},"UpdateRuleMetadata":{"input":{"type":"structure","required":["rule","description"],"members":{"rule":{"shape":"S14"},"description":{}}},"output":{"type":"structure","members":{}}},"UpdateRuleVersion":{"input":{"type":"structure","required":["rule","expression","language","outcomes"],"members":{"rule":{"shape":"S14"},"description":{},"expression":{"shape":"S1r"},"language":{},"outcomes":{"shape":"S1k"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"rule":{"shape":"S14"}}}},"UpdateVariable":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultValue":{},"description":{},"variableType":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sg":{"type":"list","member":{"type":"structure","members":{"name":{},"dataType":{},"dataSource":{},"defaultValue":{},"description":{},"variableType":{},"lastUpdatedTime":{},"createdTime":{},"arn":{}}}},"S12":{"type":"list","member":{}},"S13":{"type":"list","member":{"shape":"S14"}},"S14":{"type":"structure","required":["detectorId","ruleId","ruleVersion"],"members":{"detectorId":{},"ruleId":{},"ruleVersion":{}}},"S15":{"type":"list","member":{"shape":"S16"}},"S16":{"type":"structure","required":["modelId","modelType","modelVersionNumber"],"members":{"modelId":{},"modelType":{},"modelVersionNumber":{},"arn":{}}},"S1h":{"type":"structure","required":["modelVariables","labelSchema"],"members":{"modelVariables":{"shape":"S12"},"labelSchema":{"type":"structure","required":["labelMapper"],"members":{"labelMapper":{"type":"map","key":{},"value":{"shape":"S1k"}},"unlabeledEventsTreatment":{}}}}},"S1k":{"type":"list","member":{}},"S1m":{"type":"structure","required":["dataLocation","dataAccessRoleArn"],"members":{"dataLocation":{},"dataAccessRoleArn":{}}},"S1n":{"type":"structure","required":["ingestedEventsTimeWindow"],"members":{"ingestedEventsTimeWindow":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{},"endTime":{}}}}},"S1r":{"type":"string","sensitive":true},"S4b":{"type":"list","member":{"type":"structure","required":["entityType","entityId"],"members":{"entityType":{},"entityId":{}},"sensitive":true}},"S4g":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"S52":{"type":"string","sensitive":true},"S5f":{"type":"map","key":{},"value":{},"sensitive":true},"S5t":{"type":"structure","required":["useEventVariables"],"members":{"eventTypeName":{},"format":{},"useEventVariables":{"type":"boolean"},"jsonInputTemplate":{},"csvInputTemplate":{}}},"S5x":{"type":"structure","required":["format"],"members":{"format":{},"jsonKeyToVariableMap":{"type":"map","key":{},"value":{}},"csvIndexToVariableMap":{"type":"map","key":{},"value":{}}}},"S6u":{"type":"structure","members":{"value":{}}}}}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeModelVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBatchImportJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBatchPredictionJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetDetectors":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetEntityTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetEventTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetExternalModels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetLabels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetModels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetOutcomes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetRules":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetVariables":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventPredictions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kendra'] = {};
	AWS.Kendra = Service.defineService('kendra', ['2019-02-03']);
	Object.defineProperty(apiLoader.services['kendra'], '2019-02-03', {
	  get: function get() {
	    var model = __webpack_require__(851);
	    model.paginators = __webpack_require__(852).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Kendra;


/***/ }),
/* 851 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-02-03","endpointPrefix":"kendra","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"kendra","serviceFullName":"AWSKendraFrontendService","serviceId":"kendra","signatureVersion":"v4","signingName":"kendra","targetPrefix":"AWSKendraFrontendService","uid":"kendra-2019-02-03"},"operations":{"AssociateEntitiesToExperience":{"input":{"type":"structure","required":["Id","IndexId","EntityList"],"members":{"Id":{},"IndexId":{},"EntityList":{"type":"list","member":{"shape":"S5"}}}},"output":{"type":"structure","members":{"FailedEntityList":{"type":"list","member":{"shape":"Sa"}}}}},"AssociatePersonasToEntities":{"input":{"type":"structure","required":["Id","IndexId","Personas"],"members":{"Id":{},"IndexId":{},"Personas":{"type":"list","member":{"type":"structure","required":["EntityId","Persona"],"members":{"EntityId":{},"Persona":{}}}}}},"output":{"type":"structure","members":{"FailedEntityList":{"shape":"Sh"}}}},"BatchDeleteDocument":{"input":{"type":"structure","required":["IndexId","DocumentIdList"],"members":{"IndexId":{},"DocumentIdList":{"type":"list","member":{}},"DataSourceSyncJobMetricTarget":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"DataSourceSyncJobId":{}}}}},"output":{"type":"structure","members":{"FailedDocuments":{"type":"list","member":{"type":"structure","members":{"Id":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchGetDocumentStatus":{"input":{"type":"structure","required":["IndexId","DocumentInfoList"],"members":{"IndexId":{},"DocumentInfoList":{"type":"list","member":{"type":"structure","required":["DocumentId"],"members":{"DocumentId":{},"Attributes":{"shape":"Sv"}}}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"DocumentId":{},"ErrorCode":{},"ErrorMessage":{}}}},"DocumentStatusList":{"type":"list","member":{"type":"structure","members":{"DocumentId":{},"DocumentStatus":{},"FailureCode":{},"FailureReason":{}}}}}}},"BatchPutDocument":{"input":{"type":"structure","required":["IndexId","Documents"],"members":{"IndexId":{},"RoleArn":{},"Documents":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"Title":{},"Blob":{"type":"blob"},"S3Path":{"shape":"S1g"},"Attributes":{"shape":"Sv"},"AccessControlList":{"shape":"S1j"},"HierarchicalAccessControlList":{"type":"list","member":{"type":"structure","required":["PrincipalList"],"members":{"PrincipalList":{"shape":"S1j"}}}},"ContentType":{}}}},"CustomDocumentEnrichmentConfiguration":{"shape":"S1r"}}},"output":{"type":"structure","members":{"FailedDocuments":{"type":"list","member":{"type":"structure","members":{"Id":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"ClearQuerySuggestions":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{}}}},"CreateDataSource":{"input":{"type":"structure","required":["Name","IndexId","Type"],"members":{"Name":{},"IndexId":{},"Type":{},"Configuration":{"shape":"S27"},"Description":{},"Schedule":{},"RoleArn":{},"Tags":{"shape":"S5r"},"ClientToken":{"idempotencyToken":true},"LanguageCode":{},"CustomDocumentEnrichmentConfiguration":{"shape":"S1r"}}},"output":{"type":"structure","required":["Id"],"members":{"Id":{}}}},"CreateExperience":{"input":{"type":"structure","required":["Name","IndexId"],"members":{"Name":{},"IndexId":{},"RoleArn":{},"Configuration":{"shape":"S60"},"Description":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["Id"],"members":{"Id":{}}}},"CreateFaq":{"input":{"type":"structure","required":["IndexId","Name","S3Path","RoleArn"],"members":{"IndexId":{},"Name":{},"Description":{},"S3Path":{"shape":"S1g"},"RoleArn":{},"Tags":{"shape":"S5r"},"FileFormat":{},"ClientToken":{"idempotencyToken":true},"LanguageCode":{}}},"output":{"type":"structure","members":{"Id":{}}}},"CreateIndex":{"input":{"type":"structure","required":["Name","RoleArn"],"members":{"Name":{},"Edition":{},"RoleArn":{},"ServerSideEncryptionConfiguration":{"shape":"S6f"},"Description":{},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S5r"},"UserTokenConfigurations":{"shape":"S6h"},"UserContextPolicy":{},"UserGroupResolutionConfiguration":{"shape":"S6r"}}},"output":{"type":"structure","members":{"Id":{}}}},"CreateQuerySuggestionsBlockList":{"input":{"type":"structure","required":["IndexId","Name","SourceS3Path","RoleArn"],"members":{"IndexId":{},"Name":{},"Description":{},"SourceS3Path":{"shape":"S1g"},"ClientToken":{"idempotencyToken":true},"RoleArn":{},"Tags":{"shape":"S5r"}}},"output":{"type":"structure","members":{"Id":{}}}},"CreateThesaurus":{"input":{"type":"structure","required":["IndexId","Name","RoleArn","SourceS3Path"],"members":{"IndexId":{},"Name":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S5r"},"SourceS3Path":{"shape":"S1g"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Id":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}}},"DeleteExperience":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}},"output":{"type":"structure","members":{}}},"DeleteFaq":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}}},"DeleteIndex":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}}},"DeletePrincipalMapping":{"input":{"type":"structure","required":["IndexId","GroupId"],"members":{"IndexId":{},"DataSourceId":{},"GroupId":{},"OrderingId":{"type":"long"}}}},"DeleteQuerySuggestionsBlockList":{"input":{"type":"structure","required":["IndexId","Id"],"members":{"IndexId":{},"Id":{}}}},"DeleteThesaurus":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}}},"DescribeDataSource":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}},"output":{"type":"structure","members":{"Id":{},"IndexId":{},"Name":{},"Type":{},"Configuration":{"shape":"S27"},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"Description":{},"Status":{},"Schedule":{},"RoleArn":{},"ErrorMessage":{},"LanguageCode":{},"CustomDocumentEnrichmentConfiguration":{"shape":"S1r"}}}},"DescribeExperience":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}},"output":{"type":"structure","members":{"Id":{},"IndexId":{},"Name":{},"Endpoints":{"shape":"S7h"},"Configuration":{"shape":"S60"},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"Description":{},"Status":{},"RoleArn":{},"ErrorMessage":{}}}},"DescribeFaq":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}},"output":{"type":"structure","members":{"Id":{},"IndexId":{},"Name":{},"Description":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"S3Path":{"shape":"S1g"},"Status":{},"RoleArn":{},"ErrorMessage":{},"FileFormat":{},"LanguageCode":{}}}},"DescribeIndex":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Name":{},"Id":{},"Edition":{},"RoleArn":{},"ServerSideEncryptionConfiguration":{"shape":"S6f"},"Status":{},"Description":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"DocumentMetadataConfigurations":{"shape":"S7s"},"IndexStatistics":{"type":"structure","required":["FaqStatistics","TextDocumentStatistics"],"members":{"FaqStatistics":{"type":"structure","required":["IndexedQuestionAnswersCount"],"members":{"IndexedQuestionAnswersCount":{"type":"integer"}}},"TextDocumentStatistics":{"type":"structure","required":["IndexedTextDocumentsCount","IndexedTextBytes"],"members":{"IndexedTextDocumentsCount":{"type":"integer"},"IndexedTextBytes":{"type":"long"}}}}},"ErrorMessage":{},"CapacityUnits":{"shape":"S8a"},"UserTokenConfigurations":{"shape":"S6h"},"UserContextPolicy":{},"UserGroupResolutionConfiguration":{"shape":"S6r"}}}},"DescribePrincipalMapping":{"input":{"type":"structure","required":["IndexId","GroupId"],"members":{"IndexId":{},"DataSourceId":{},"GroupId":{}}},"output":{"type":"structure","members":{"IndexId":{},"DataSourceId":{},"GroupId":{},"GroupOrderingIdSummaries":{"type":"list","member":{"type":"structure","members":{"Status":{},"LastUpdatedAt":{"type":"timestamp"},"ReceivedAt":{"type":"timestamp"},"OrderingId":{"type":"long"},"FailureReason":{}}}}}}},"DescribeQuerySuggestionsBlockList":{"input":{"type":"structure","required":["IndexId","Id"],"members":{"IndexId":{},"Id":{}}},"output":{"type":"structure","members":{"IndexId":{},"Id":{},"Name":{},"Description":{},"Status":{},"ErrorMessage":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"SourceS3Path":{"shape":"S1g"},"ItemCount":{"type":"integer"},"FileSizeBytes":{"type":"long"},"RoleArn":{}}}},"DescribeQuerySuggestionsConfig":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{}}},"output":{"type":"structure","members":{"Mode":{},"Status":{},"QueryLogLookBackWindowInDays":{"type":"integer"},"IncludeQueriesWithoutUserInformation":{"type":"boolean"},"MinimumNumberOfQueryingUsers":{"type":"integer"},"MinimumQueryCount":{"type":"integer"},"LastSuggestionsBuildTime":{"type":"timestamp"},"LastClearTime":{"type":"timestamp"},"TotalSuggestionsCount":{"type":"integer"}}}},"DescribeThesaurus":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}},"output":{"type":"structure","members":{"Id":{},"IndexId":{},"Name":{},"Description":{},"Status":{},"ErrorMessage":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"RoleArn":{},"SourceS3Path":{"shape":"S1g"},"FileSizeBytes":{"type":"long"},"TermCount":{"type":"long"},"SynonymRuleCount":{"type":"long"}}}},"DisassociateEntitiesFromExperience":{"input":{"type":"structure","required":["Id","IndexId","EntityList"],"members":{"Id":{},"IndexId":{},"EntityList":{"type":"list","member":{"shape":"S5"}}}},"output":{"type":"structure","members":{"FailedEntityList":{"shape":"Sh"}}}},"DisassociatePersonasFromEntities":{"input":{"type":"structure","required":["Id","IndexId","EntityIds"],"members":{"Id":{},"IndexId":{},"EntityIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FailedEntityList":{"shape":"Sh"}}}},"GetQuerySuggestions":{"input":{"type":"structure","required":["IndexId","QueryText"],"members":{"IndexId":{},"QueryText":{},"MaxSuggestionsCount":{"type":"integer"}}},"output":{"type":"structure","members":{"QuerySuggestionsId":{},"Suggestions":{"type":"list","member":{"type":"structure","members":{"Id":{},"Value":{"type":"structure","members":{"Text":{"type":"structure","members":{"Text":{},"Highlights":{"type":"list","member":{"type":"structure","members":{"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}}}}}}}}}}}},"GetSnapshots":{"input":{"type":"structure","required":["IndexId","Interval","MetricType"],"members":{"IndexId":{},"Interval":{},"MetricType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SnapShotTimeFilter":{"shape":"S9j"},"SnapshotsDataHeader":{"type":"list","member":{}},"SnapshotsData":{"type":"list","member":{"type":"list","member":{}}},"NextToken":{}}}},"ListDataSourceSyncJobs":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"},"StartTimeFilter":{"shape":"S9j"},"StatusFilter":{}}},"output":{"type":"structure","members":{"History":{"type":"list","member":{"type":"structure","members":{"ExecutionId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Status":{},"ErrorMessage":{},"ErrorCode":{},"DataSourceErrorCode":{},"Metrics":{"type":"structure","members":{"DocumentsAdded":{},"DocumentsModified":{},"DocumentsDeleted":{},"DocumentsFailed":{},"DocumentsScanned":{}}}}}},"NextToken":{}}}},"ListDataSources":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SummaryItems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Type":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"Status":{},"LanguageCode":{}}}},"NextToken":{}}}},"ListEntityPersonas":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SummaryItems":{"type":"list","member":{"type":"structure","members":{"EntityId":{},"Persona":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"ListExperienceEntities":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{},"NextToken":{}}},"output":{"type":"structure","members":{"SummaryItems":{"type":"list","member":{"type":"structure","members":{"EntityId":{},"EntityType":{},"DisplayData":{"type":"structure","members":{"UserName":{"shape":"Saa"},"GroupName":{"shape":"Saa"},"IdentifiedUserName":{"shape":"Saa"},"FirstName":{"shape":"Saa"},"LastName":{"shape":"Saa"}}}}}},"NextToken":{}}}},"ListExperiences":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SummaryItems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"CreatedAt":{"type":"timestamp"},"Status":{},"Endpoints":{"shape":"S7h"}}}},"NextToken":{}}}},"ListFaqs":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"FaqSummaryItems":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"FileFormat":{},"LanguageCode":{}}}}}}},"ListGroupsOlderThanOrderingId":{"input":{"type":"structure","required":["IndexId","OrderingId"],"members":{"IndexId":{},"DataSourceId":{},"OrderingId":{"type":"long"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"GroupsSummaries":{"type":"list","member":{"type":"structure","members":{"GroupId":{},"OrderingId":{"type":"long"}}}},"NextToken":{}}}},"ListIndices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"IndexConfigurationSummaryItems":{"type":"list","member":{"type":"structure","required":["CreatedAt","UpdatedAt","Status"],"members":{"Name":{},"Id":{},"Edition":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"Status":{}}}},"NextToken":{}}}},"ListQuerySuggestionsBlockLists":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"BlockListSummaryItems":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"ItemCount":{"type":"integer"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5r"}}}},"ListThesauri":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"ThesaurusSummaryItems":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"}}}}}}},"PutPrincipalMapping":{"input":{"type":"structure","required":["IndexId","GroupId","GroupMembers"],"members":{"IndexId":{},"DataSourceId":{},"GroupId":{},"GroupMembers":{"type":"structure","members":{"MemberGroups":{"type":"list","member":{"type":"structure","required":["GroupId"],"members":{"GroupId":{},"DataSourceId":{}}}},"MemberUsers":{"type":"list","member":{"type":"structure","required":["UserId"],"members":{"UserId":{}}}},"S3PathforGroupMembers":{"shape":"S1g"}}},"OrderingId":{"type":"long"},"RoleArn":{}}}},"Query":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"QueryText":{},"AttributeFilter":{"shape":"Sbh"},"Facets":{"type":"list","member":{"type":"structure","members":{"DocumentAttributeKey":{}}}},"RequestedDocumentAttributes":{"type":"list","member":{}},"QueryResultTypeFilter":{},"DocumentRelevanceOverrideConfigurations":{"type":"list","member":{"type":"structure","required":["Name","Relevance"],"members":{"Name":{},"Relevance":{"shape":"S7w"}}}},"PageNumber":{"type":"integer"},"PageSize":{"type":"integer"},"SortingConfiguration":{"type":"structure","required":["DocumentAttributeKey","SortOrder"],"members":{"DocumentAttributeKey":{},"SortOrder":{}}},"UserContext":{"type":"structure","members":{"Token":{},"UserId":{},"Groups":{"type":"list","member":{}},"DataSourceGroups":{"type":"list","member":{"type":"structure","required":["GroupId","DataSourceId"],"members":{"GroupId":{},"DataSourceId":{}}}}}},"VisitorId":{},"SpellCorrectionConfiguration":{"type":"structure","required":["IncludeQuerySpellCheckSuggestions"],"members":{"IncludeQuerySpellCheckSuggestions":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"QueryId":{},"ResultItems":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"AdditionalAttributes":{"type":"list","member":{"type":"structure","required":["Key","ValueType","Value"],"members":{"Key":{},"ValueType":{},"Value":{"type":"structure","members":{"TextWithHighlightsValue":{"shape":"Sc6"}}}}}},"DocumentId":{},"DocumentTitle":{"shape":"Sc6"},"DocumentExcerpt":{"shape":"Sc6"},"DocumentURI":{},"DocumentAttributes":{"shape":"Sv"},"ScoreAttributes":{"type":"structure","members":{"ScoreConfidence":{}}},"FeedbackToken":{}}}},"FacetResults":{"type":"list","member":{"type":"structure","members":{"DocumentAttributeKey":{},"DocumentAttributeValueType":{},"DocumentAttributeValueCountPairs":{"type":"list","member":{"type":"structure","members":{"DocumentAttributeValue":{"shape":"Sy"},"Count":{"type":"integer"}}}}}}},"TotalNumberOfResults":{"type":"integer"},"Warnings":{"type":"list","member":{"type":"structure","members":{"Message":{},"Code":{}}}},"SpellCorrectedQueries":{"type":"list","member":{"type":"structure","members":{"SuggestedQueryText":{},"Corrections":{"type":"list","member":{"type":"structure","members":{"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Term":{},"CorrectedTerm":{}}}}}}}}}},"StartDataSourceSyncJob":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}},"output":{"type":"structure","members":{"ExecutionId":{}}}},"StopDataSourceSyncJob":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"IndexId":{}}}},"SubmitFeedback":{"input":{"type":"structure","required":["IndexId","QueryId"],"members":{"IndexId":{},"QueryId":{},"ClickFeedbackItems":{"type":"list","member":{"type":"structure","required":["ResultId","ClickTime"],"members":{"ResultId":{},"ClickTime":{"type":"timestamp"}}}},"RelevanceFeedbackItems":{"type":"list","member":{"type":"structure","required":["ResultId","RelevanceValue"],"members":{"ResultId":{},"RelevanceValue":{}}}}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5r"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDataSource":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"Name":{},"IndexId":{},"Configuration":{"shape":"S27"},"Description":{},"Schedule":{},"RoleArn":{},"LanguageCode":{},"CustomDocumentEnrichmentConfiguration":{"shape":"S1r"}}}},"UpdateExperience":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"Name":{},"IndexId":{},"RoleArn":{},"Configuration":{"shape":"S60"},"Description":{}}}},"UpdateIndex":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Name":{},"RoleArn":{},"Description":{},"DocumentMetadataConfigurationUpdates":{"shape":"S7s"},"CapacityUnits":{"shape":"S8a"},"UserTokenConfigurations":{"shape":"S6h"},"UserContextPolicy":{},"UserGroupResolutionConfiguration":{"shape":"S6r"}}}},"UpdateQuerySuggestionsBlockList":{"input":{"type":"structure","required":["IndexId","Id"],"members":{"IndexId":{},"Id":{},"Name":{},"Description":{},"SourceS3Path":{"shape":"S1g"},"RoleArn":{}}}},"UpdateQuerySuggestionsConfig":{"input":{"type":"structure","required":["IndexId"],"members":{"IndexId":{},"Mode":{},"QueryLogLookBackWindowInDays":{"type":"integer"},"IncludeQueriesWithoutUserInformation":{"type":"boolean"},"MinimumNumberOfQueryingUsers":{"type":"integer"},"MinimumQueryCount":{"type":"integer"}}}},"UpdateThesaurus":{"input":{"type":"structure","required":["Id","IndexId"],"members":{"Id":{},"Name":{},"IndexId":{},"Description":{},"RoleArn":{},"SourceS3Path":{"shape":"S1g"}}}}},"shapes":{"S5":{"type":"structure","required":["EntityId","EntityType"],"members":{"EntityId":{},"EntityType":{}}},"Sa":{"type":"structure","members":{"EntityId":{},"ErrorMessage":{}}},"Sh":{"type":"list","member":{"shape":"Sa"}},"Sv":{"type":"list","member":{"shape":"Sw"}},"Sw":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{"shape":"Sy"}}},"Sy":{"type":"structure","members":{"StringValue":{},"StringListValue":{"type":"list","member":{}},"LongValue":{"type":"long"},"DateValue":{"type":"timestamp"}}},"S1g":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{},"Key":{}}},"S1j":{"type":"list","member":{"type":"structure","required":["Name","Type","Access"],"members":{"Name":{},"Type":{},"Access":{},"DataSourceId":{}}}},"S1r":{"type":"structure","members":{"InlineConfigurations":{"type":"list","member":{"type":"structure","members":{"Condition":{"shape":"S1u"},"Target":{"type":"structure","members":{"TargetDocumentAttributeKey":{},"TargetDocumentAttributeValueDeletion":{"type":"boolean"},"TargetDocumentAttributeValue":{"shape":"Sy"}}},"DocumentContentDeletion":{"type":"boolean"}}}},"PreExtractionHookConfiguration":{"shape":"S1y"},"PostExtractionHookConfiguration":{"shape":"S1y"},"RoleArn":{}}},"S1u":{"type":"structure","required":["ConditionDocumentAttributeKey","Operator"],"members":{"ConditionDocumentAttributeKey":{},"Operator":{},"ConditionOnValue":{"shape":"Sy"}}},"S1y":{"type":"structure","required":["LambdaArn","S3Bucket"],"members":{"InvocationCondition":{"shape":"S1u"},"LambdaArn":{},"S3Bucket":{}}},"S27":{"type":"structure","members":{"S3Configuration":{"type":"structure","required":["BucketName"],"members":{"BucketName":{},"InclusionPrefixes":{"shape":"S29"},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"DocumentsMetadataConfiguration":{"type":"structure","members":{"S3Prefix":{}}},"AccessControlListConfiguration":{"type":"structure","members":{"KeyPath":{}}}}},"SharePointConfiguration":{"type":"structure","required":["SharePointVersion","Urls","SecretArn"],"members":{"SharePointVersion":{},"Urls":{"type":"list","member":{}},"SecretArn":{},"CrawlAttachments":{"type":"boolean"},"UseChangeLog":{"type":"boolean"},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"VpcConfiguration":{"shape":"S2i"},"FieldMappings":{"shape":"S2n"},"DocumentTitleFieldName":{},"DisableLocalGroups":{"type":"boolean"},"SslCertificateS3Path":{"shape":"S1g"}}},"DatabaseConfiguration":{"type":"structure","required":["DatabaseEngineType","ConnectionConfiguration","ColumnConfiguration"],"members":{"DatabaseEngineType":{},"ConnectionConfiguration":{"type":"structure","required":["DatabaseHost","DatabasePort","DatabaseName","TableName","SecretArn"],"members":{"DatabaseHost":{},"DatabasePort":{"type":"integer"},"DatabaseName":{},"TableName":{},"SecretArn":{}}},"VpcConfiguration":{"shape":"S2i"},"ColumnConfiguration":{"type":"structure","required":["DocumentIdColumnName","DocumentDataColumnName","ChangeDetectingColumns"],"members":{"DocumentIdColumnName":{},"DocumentDataColumnName":{},"DocumentTitleColumnName":{},"FieldMappings":{"shape":"S2n"},"ChangeDetectingColumns":{"type":"list","member":{}}}},"AclConfiguration":{"type":"structure","required":["AllowedGroupsColumnName"],"members":{"AllowedGroupsColumnName":{}}},"SqlConfiguration":{"type":"structure","members":{"QueryIdentifiersEnclosingOption":{}}}}},"SalesforceConfiguration":{"type":"structure","required":["ServerUrl","SecretArn"],"members":{"ServerUrl":{},"SecretArn":{},"StandardObjectConfigurations":{"type":"list","member":{"type":"structure","required":["Name","DocumentDataFieldName"],"members":{"Name":{},"DocumentDataFieldName":{},"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"}}}},"KnowledgeArticleConfiguration":{"type":"structure","required":["IncludedStates"],"members":{"IncludedStates":{"type":"list","member":{}},"StandardKnowledgeArticleTypeConfiguration":{"type":"structure","required":["DocumentDataFieldName"],"members":{"DocumentDataFieldName":{},"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"}}},"CustomKnowledgeArticleTypeConfigurations":{"type":"list","member":{"type":"structure","required":["Name","DocumentDataFieldName"],"members":{"Name":{},"DocumentDataFieldName":{},"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"}}}}}},"ChatterFeedConfiguration":{"type":"structure","required":["DocumentDataFieldName"],"members":{"DocumentDataFieldName":{},"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"},"IncludeFilterTypes":{"type":"list","member":{}}}},"CrawlAttachments":{"type":"boolean"},"StandardObjectAttachmentConfiguration":{"type":"structure","members":{"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"}}},"IncludeAttachmentFilePatterns":{"shape":"S29"},"ExcludeAttachmentFilePatterns":{"shape":"S29"}}},"OneDriveConfiguration":{"type":"structure","required":["TenantDomain","SecretArn","OneDriveUsers"],"members":{"TenantDomain":{},"SecretArn":{},"OneDriveUsers":{"type":"structure","members":{"OneDriveUserList":{"type":"list","member":{}},"OneDriveUserS3Path":{"shape":"S1g"}}},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"FieldMappings":{"shape":"S2n"},"DisableLocalGroups":{"type":"boolean"}}},"ServiceNowConfiguration":{"type":"structure","required":["HostUrl","SecretArn","ServiceNowBuildVersion"],"members":{"HostUrl":{},"SecretArn":{},"ServiceNowBuildVersion":{},"KnowledgeArticleConfiguration":{"type":"structure","required":["DocumentDataFieldName"],"members":{"CrawlAttachments":{"type":"boolean"},"IncludeAttachmentFilePatterns":{"shape":"S29"},"ExcludeAttachmentFilePatterns":{"shape":"S29"},"DocumentDataFieldName":{},"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"},"FilterQuery":{}}},"ServiceCatalogConfiguration":{"type":"structure","required":["DocumentDataFieldName"],"members":{"CrawlAttachments":{"type":"boolean"},"IncludeAttachmentFilePatterns":{"shape":"S29"},"ExcludeAttachmentFilePatterns":{"shape":"S29"},"DocumentDataFieldName":{},"DocumentTitleFieldName":{},"FieldMappings":{"shape":"S2n"}}},"AuthenticationType":{}}},"ConfluenceConfiguration":{"type":"structure","required":["ServerUrl","SecretArn","Version"],"members":{"ServerUrl":{},"SecretArn":{},"Version":{},"SpaceConfiguration":{"type":"structure","members":{"CrawlPersonalSpaces":{"type":"boolean"},"CrawlArchivedSpaces":{"type":"boolean"},"IncludeSpaces":{"shape":"S3z"},"ExcludeSpaces":{"shape":"S3z"},"SpaceFieldMappings":{"type":"list","member":{"type":"structure","members":{"DataSourceFieldName":{},"DateFieldFormat":{},"IndexFieldName":{}}}}}},"PageConfiguration":{"type":"structure","members":{"PageFieldMappings":{"type":"list","member":{"type":"structure","members":{"DataSourceFieldName":{},"DateFieldFormat":{},"IndexFieldName":{}}}}}},"BlogConfiguration":{"type":"structure","members":{"BlogFieldMappings":{"type":"list","member":{"type":"structure","members":{"DataSourceFieldName":{},"DateFieldFormat":{},"IndexFieldName":{}}}}}},"AttachmentConfiguration":{"type":"structure","members":{"CrawlAttachments":{"type":"boolean"},"AttachmentFieldMappings":{"type":"list","member":{"type":"structure","members":{"DataSourceFieldName":{},"DateFieldFormat":{},"IndexFieldName":{}}}}}},"VpcConfiguration":{"shape":"S2i"},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"}}},"GoogleDriveConfiguration":{"type":"structure","required":["SecretArn"],"members":{"SecretArn":{},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"FieldMappings":{"shape":"S2n"},"ExcludeMimeTypes":{"type":"list","member":{}},"ExcludeUserAccounts":{"type":"list","member":{}},"ExcludeSharedDrives":{"type":"list","member":{}}}},"WebCrawlerConfiguration":{"type":"structure","required":["Urls"],"members":{"Urls":{"type":"structure","members":{"SeedUrlConfiguration":{"type":"structure","required":["SeedUrls"],"members":{"SeedUrls":{"type":"list","member":{}},"WebCrawlerMode":{}}},"SiteMapsConfiguration":{"type":"structure","required":["SiteMaps"],"members":{"SiteMaps":{"type":"list","member":{}}}}}},"CrawlDepth":{"type":"integer"},"MaxLinksPerPage":{"type":"integer"},"MaxContentSizePerPageInMegaBytes":{"type":"float"},"MaxUrlsPerMinuteCrawlRate":{"type":"integer"},"UrlInclusionPatterns":{"shape":"S29"},"UrlExclusionPatterns":{"shape":"S29"},"ProxyConfiguration":{"type":"structure","required":["Host","Port"],"members":{"Host":{},"Port":{"type":"integer"},"Credentials":{}}},"AuthenticationConfiguration":{"type":"structure","members":{"BasicAuthentication":{"type":"list","member":{"type":"structure","required":["Host","Port","Credentials"],"members":{"Host":{},"Port":{"type":"integer"},"Credentials":{}}}}}}}},"WorkDocsConfiguration":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"CrawlComments":{"type":"boolean"},"UseChangeLog":{"type":"boolean"},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"FieldMappings":{"shape":"S2n"}}},"FsxConfiguration":{"type":"structure","required":["FileSystemId","FileSystemType","VpcConfiguration"],"members":{"FileSystemId":{},"FileSystemType":{},"VpcConfiguration":{"shape":"S2i"},"SecretArn":{},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"FieldMappings":{"shape":"S2n"}}},"SlackConfiguration":{"type":"structure","required":["TeamId","SecretArn","SlackEntityList","SinceCrawlDate"],"members":{"TeamId":{},"SecretArn":{},"VpcConfiguration":{"shape":"S2i"},"SlackEntityList":{"type":"list","member":{}},"UseChangeLog":{"type":"boolean"},"CrawlBotMessage":{"type":"boolean"},"ExcludeArchived":{"type":"boolean"},"SinceCrawlDate":{},"LookBackPeriod":{"type":"integer"},"PrivateChannelFilter":{"type":"list","member":{}},"PublicChannelFilter":{"type":"list","member":{}},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"FieldMappings":{"shape":"S2n"}}},"BoxConfiguration":{"type":"structure","required":["EnterpriseId","SecretArn"],"members":{"EnterpriseId":{},"SecretArn":{},"UseChangeLog":{"type":"boolean"},"CrawlComments":{"type":"boolean"},"CrawlTasks":{"type":"boolean"},"CrawlWebLinks":{"type":"boolean"},"FileFieldMappings":{"shape":"S2n"},"TaskFieldMappings":{"shape":"S2n"},"CommentFieldMappings":{"shape":"S2n"},"WebLinkFieldMappings":{"shape":"S2n"},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"VpcConfiguration":{"shape":"S2i"}}},"QuipConfiguration":{"type":"structure","required":["Domain","SecretArn"],"members":{"Domain":{},"SecretArn":{},"CrawlFileComments":{"type":"boolean"},"CrawlChatRooms":{"type":"boolean"},"CrawlAttachments":{"type":"boolean"},"FolderIds":{"type":"list","member":{}},"ThreadFieldMappings":{"shape":"S2n"},"MessageFieldMappings":{"shape":"S2n"},"AttachmentFieldMappings":{"shape":"S2n"},"InclusionPatterns":{"shape":"S29"},"ExclusionPatterns":{"shape":"S29"},"VpcConfiguration":{"shape":"S2i"}}}}},"S29":{"type":"list","member":{}},"S2i":{"type":"structure","required":["SubnetIds","SecurityGroupIds"],"members":{"SubnetIds":{"type":"list","member":{}},"SecurityGroupIds":{"type":"list","member":{}}}},"S2n":{"type":"list","member":{"type":"structure","required":["DataSourceFieldName","IndexFieldName"],"members":{"DataSourceFieldName":{},"DateFieldFormat":{},"IndexFieldName":{}}}},"S3z":{"type":"list","member":{}},"S5r":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S60":{"type":"structure","members":{"ContentSourceConfiguration":{"type":"structure","members":{"DataSourceIds":{"type":"list","member":{}},"FaqIds":{"type":"list","member":{}},"DirectPutContent":{"type":"boolean"}}},"UserIdentityConfiguration":{"type":"structure","members":{"IdentityAttributeName":{}}}}},"S6f":{"type":"structure","members":{"KmsKeyId":{"type":"string","sensitive":true}}},"S6h":{"type":"list","member":{"type":"structure","members":{"JwtTokenTypeConfiguration":{"type":"structure","required":["KeyLocation"],"members":{"KeyLocation":{},"URL":{},"SecretManagerArn":{},"UserNameAttributeField":{},"GroupAttributeField":{},"Issuer":{},"ClaimRegex":{}}},"JsonTokenTypeConfiguration":{"type":"structure","required":["UserNameAttributeField","GroupAttributeField"],"members":{"UserNameAttributeField":{},"GroupAttributeField":{}}}}}},"S6r":{"type":"structure","required":["UserGroupResolutionMode"],"members":{"UserGroupResolutionMode":{}}},"S7h":{"type":"list","member":{"type":"structure","members":{"EndpointType":{},"Endpoint":{}}}},"S7s":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"Relevance":{"shape":"S7w"},"Search":{"type":"structure","members":{"Facetable":{"type":"boolean"},"Searchable":{"type":"boolean"},"Displayable":{"type":"boolean"},"Sortable":{"type":"boolean"}}}}}},"S7w":{"type":"structure","members":{"Freshness":{"type":"boolean"},"Importance":{"type":"integer"},"Duration":{},"RankOrder":{},"ValueImportanceMap":{"type":"map","key":{},"value":{"type":"integer"}}}},"S8a":{"type":"structure","required":["StorageCapacityUnits","QueryCapacityUnits"],"members":{"StorageCapacityUnits":{"type":"integer"},"QueryCapacityUnits":{"type":"integer"}}},"S9j":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"Saa":{"type":"string","sensitive":true},"Sbh":{"type":"structure","members":{"AndAllFilters":{"shape":"Sbi"},"OrAllFilters":{"shape":"Sbi"},"NotFilter":{"shape":"Sbh"},"EqualsTo":{"shape":"Sw"},"ContainsAll":{"shape":"Sw"},"ContainsAny":{"shape":"Sw"},"GreaterThan":{"shape":"Sw"},"GreaterThanOrEquals":{"shape":"Sw"},"LessThan":{"shape":"Sw"},"LessThanOrEquals":{"shape":"Sw"}}},"Sbi":{"type":"list","member":{"shape":"Sbh"}},"Sc6":{"type":"structure","members":{"Text":{},"Highlights":{"type":"list","member":{"type":"structure","required":["BeginOffset","EndOffset"],"members":{"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"TopAnswer":{"type":"boolean"},"Type":{}}}}}}}}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetSnapshots":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDataSourceSyncJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDataSources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntityPersonas":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListExperienceEntities":{"input_token":"NextToken","output_token":"NextToken"},"ListExperiences":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListIndices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['networkmanager'] = {};
	AWS.NetworkManager = Service.defineService('networkmanager', ['2019-07-05']);
	Object.defineProperty(apiLoader.services['networkmanager'], '2019-07-05', {
	  get: function get() {
	    var model = __webpack_require__(854);
	    model.paginators = __webpack_require__(855).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.NetworkManager;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-07-05","endpointPrefix":"networkmanager","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"NetworkManager","serviceFullName":"AWS Network Manager","serviceId":"NetworkManager","signatureVersion":"v4","signingName":"networkmanager","uid":"networkmanager-2019-07-05"},"operations":{"AcceptAttachment":{"http":{"requestUri":"/attachments/{attachmentId}/accept"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"S4"}}}},"AssociateConnectPeer":{"http":{"requestUri":"/global-networks/{globalNetworkId}/connect-peer-associations"},"input":{"type":"structure","required":["GlobalNetworkId","ConnectPeerId","DeviceId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ConnectPeerId":{},"DeviceId":{},"LinkId":{}}},"output":{"type":"structure","members":{"ConnectPeerAssociation":{"shape":"Sq"}}}},"AssociateCustomerGateway":{"http":{"requestUri":"/global-networks/{globalNetworkId}/customer-gateway-associations"},"input":{"type":"structure","required":["CustomerGatewayArn","GlobalNetworkId","DeviceId"],"members":{"CustomerGatewayArn":{},"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{},"LinkId":{}}},"output":{"type":"structure","members":{"CustomerGatewayAssociation":{"shape":"Sv"}}}},"AssociateLink":{"http":{"requestUri":"/global-networks/{globalNetworkId}/link-associations"},"input":{"type":"structure","required":["GlobalNetworkId","DeviceId","LinkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{},"LinkId":{}}},"output":{"type":"structure","members":{"LinkAssociation":{"shape":"Sz"}}}},"AssociateTransitGatewayConnectPeer":{"http":{"requestUri":"/global-networks/{globalNetworkId}/transit-gateway-connect-peer-associations"},"input":{"type":"structure","required":["GlobalNetworkId","TransitGatewayConnectPeerArn","DeviceId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"TransitGatewayConnectPeerArn":{},"DeviceId":{},"LinkId":{}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeerAssociation":{"shape":"S14"}}}},"CreateConnectAttachment":{"http":{"requestUri":"/connect-attachments"},"input":{"type":"structure","required":["CoreNetworkId","EdgeLocation","TransportAttachmentId","Options"],"members":{"CoreNetworkId":{},"EdgeLocation":{},"TransportAttachmentId":{},"Options":{"shape":"S17"},"Tags":{"shape":"Se"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConnectAttachment":{"shape":"S1b"}}}},"CreateConnectPeer":{"http":{"requestUri":"/connect-peers"},"input":{"type":"structure","required":["ConnectAttachmentId","PeerAddress","InsideCidrBlocks"],"members":{"ConnectAttachmentId":{},"CoreNetworkAddress":{},"PeerAddress":{},"BgpOptions":{"type":"structure","members":{"PeerAsn":{"type":"long"}}},"InsideCidrBlocks":{"shape":"S1g"},"Tags":{"shape":"Se"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConnectPeer":{"shape":"S1i"}}}},"CreateConnection":{"http":{"requestUri":"/global-networks/{globalNetworkId}/connections"},"input":{"type":"structure","required":["GlobalNetworkId","DeviceId","ConnectedDeviceId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{},"ConnectedDeviceId":{},"LinkId":{},"ConnectedLinkId":{},"Description":{},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S1p"}}}},"CreateCoreNetwork":{"http":{"requestUri":"/core-networks"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{},"Description":{},"Tags":{"shape":"Se"},"PolicyDocument":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CoreNetwork":{"shape":"S1w"}}}},"CreateDevice":{"http":{"requestUri":"/global-networks/{globalNetworkId}/devices"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"AWSLocation":{"shape":"S24"},"Description":{},"Type":{},"Vendor":{},"Model":{},"SerialNumber":{},"Location":{"shape":"S26"},"SiteId":{},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"Device":{"shape":"S29"}}}},"CreateGlobalNetwork":{"http":{"requestUri":"/global-networks"},"input":{"type":"structure","members":{"Description":{},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"GlobalNetwork":{"shape":"S2e"}}}},"CreateLink":{"http":{"requestUri":"/global-networks/{globalNetworkId}/links"},"input":{"type":"structure","required":["GlobalNetworkId","Bandwidth","SiteId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"Description":{},"Type":{},"Bandwidth":{"shape":"S2i"},"Provider":{},"SiteId":{},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"Link":{"shape":"S2k"}}}},"CreateSite":{"http":{"requestUri":"/global-networks/{globalNetworkId}/sites"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"Description":{},"Location":{"shape":"S26"},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"Site":{"shape":"S2p"}}}},"CreateSiteToSiteVpnAttachment":{"http":{"requestUri":"/site-to-site-vpn-attachments"},"input":{"type":"structure","required":["CoreNetworkId","VpnConnectionArn"],"members":{"CoreNetworkId":{},"VpnConnectionArn":{},"Tags":{"shape":"Se"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"SiteToSiteVpnAttachment":{"shape":"S2v"}}}},"CreateVpcAttachment":{"http":{"requestUri":"/vpc-attachments"},"input":{"type":"structure","required":["CoreNetworkId","VpcArn","SubnetArns"],"members":{"CoreNetworkId":{},"VpcArn":{},"SubnetArns":{"shape":"S2y"},"Options":{"shape":"S2z"},"Tags":{"shape":"Se"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S32"}}}},"DeleteAttachment":{"http":{"method":"DELETE","requestUri":"/attachments/{attachmentId}"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"S4"}}}},"DeleteConnectPeer":{"http":{"method":"DELETE","requestUri":"/connect-peers/{connectPeerId}"},"input":{"type":"structure","required":["ConnectPeerId"],"members":{"ConnectPeerId":{"location":"uri","locationName":"connectPeerId"}}},"output":{"type":"structure","members":{"ConnectPeer":{"shape":"S1i"}}}},"DeleteConnection":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/connections/{connectionId}"},"input":{"type":"structure","required":["GlobalNetworkId","ConnectionId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ConnectionId":{"location":"uri","locationName":"connectionId"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S1p"}}}},"DeleteCoreNetwork":{"http":{"method":"DELETE","requestUri":"/core-networks/{coreNetworkId}"},"input":{"type":"structure","required":["CoreNetworkId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"}}},"output":{"type":"structure","members":{"CoreNetwork":{"shape":"S1w"}}}},"DeleteCoreNetworkPolicyVersion":{"http":{"method":"DELETE","requestUri":"/core-networks/{coreNetworkId}/core-network-policy-versions/{policyVersionId}"},"input":{"type":"structure","required":["CoreNetworkId","PolicyVersionId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"PolicyVersionId":{"location":"uri","locationName":"policyVersionId","type":"integer"}}},"output":{"type":"structure","members":{"CoreNetworkPolicy":{"shape":"S3d"}}}},"DeleteDevice":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/devices/{deviceId}"},"input":{"type":"structure","required":["GlobalNetworkId","DeviceId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{"location":"uri","locationName":"deviceId"}}},"output":{"type":"structure","members":{"Device":{"shape":"S29"}}}},"DeleteGlobalNetwork":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"}}},"output":{"type":"structure","members":{"GlobalNetwork":{"shape":"S2e"}}}},"DeleteLink":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/links/{linkId}"},"input":{"type":"structure","required":["GlobalNetworkId","LinkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"LinkId":{"location":"uri","locationName":"linkId"}}},"output":{"type":"structure","members":{"Link":{"shape":"S2k"}}}},"DeleteResourcePolicy":{"http":{"method":"DELETE","requestUri":"/resource-policy/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{}}},"DeleteSite":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/sites/{siteId}"},"input":{"type":"structure","required":["GlobalNetworkId","SiteId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"SiteId":{"location":"uri","locationName":"siteId"}}},"output":{"type":"structure","members":{"Site":{"shape":"S2p"}}}},"DeregisterTransitGateway":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/transit-gateway-registrations/{transitGatewayArn}"},"input":{"type":"structure","required":["GlobalNetworkId","TransitGatewayArn"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"TransitGatewayArn":{"location":"uri","locationName":"transitGatewayArn"}}},"output":{"type":"structure","members":{"TransitGatewayRegistration":{"shape":"S3w"}}}},"DescribeGlobalNetworks":{"http":{"method":"GET","requestUri":"/global-networks"},"input":{"type":"structure","members":{"GlobalNetworkIds":{"location":"querystring","locationName":"globalNetworkIds","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"GlobalNetworks":{"type":"list","member":{"shape":"S2e"}},"NextToken":{}}}},"DisassociateConnectPeer":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/connect-peer-associations/{connectPeerId}"},"input":{"type":"structure","required":["GlobalNetworkId","ConnectPeerId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ConnectPeerId":{"location":"uri","locationName":"connectPeerId"}}},"output":{"type":"structure","members":{"ConnectPeerAssociation":{"shape":"Sq"}}}},"DisassociateCustomerGateway":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/customer-gateway-associations/{customerGatewayArn}"},"input":{"type":"structure","required":["GlobalNetworkId","CustomerGatewayArn"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"CustomerGatewayArn":{"location":"uri","locationName":"customerGatewayArn"}}},"output":{"type":"structure","members":{"CustomerGatewayAssociation":{"shape":"Sv"}}}},"DisassociateLink":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/link-associations"},"input":{"type":"structure","required":["GlobalNetworkId","DeviceId","LinkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{"location":"querystring","locationName":"deviceId"},"LinkId":{"location":"querystring","locationName":"linkId"}}},"output":{"type":"structure","members":{"LinkAssociation":{"shape":"Sz"}}}},"DisassociateTransitGatewayConnectPeer":{"http":{"method":"DELETE","requestUri":"/global-networks/{globalNetworkId}/transit-gateway-connect-peer-associations/{transitGatewayConnectPeerArn}"},"input":{"type":"structure","required":["GlobalNetworkId","TransitGatewayConnectPeerArn"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"TransitGatewayConnectPeerArn":{"location":"uri","locationName":"transitGatewayConnectPeerArn"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeerAssociation":{"shape":"S14"}}}},"ExecuteCoreNetworkChangeSet":{"http":{"requestUri":"/core-networks/{coreNetworkId}/core-network-change-sets/{policyVersionId}/execute"},"input":{"type":"structure","required":["CoreNetworkId","PolicyVersionId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"PolicyVersionId":{"location":"uri","locationName":"policyVersionId","type":"integer"}}},"output":{"type":"structure","members":{}}},"GetConnectAttachment":{"http":{"method":"GET","requestUri":"/connect-attachments/{attachmentId}"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"}}},"output":{"type":"structure","members":{"ConnectAttachment":{"shape":"S1b"}}}},"GetConnectPeer":{"http":{"method":"GET","requestUri":"/connect-peers/{connectPeerId}"},"input":{"type":"structure","required":["ConnectPeerId"],"members":{"ConnectPeerId":{"location":"uri","locationName":"connectPeerId"}}},"output":{"type":"structure","members":{"ConnectPeer":{"shape":"S1i"}}}},"GetConnectPeerAssociations":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/connect-peer-associations"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ConnectPeerIds":{"location":"querystring","locationName":"connectPeerIds","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ConnectPeerAssociations":{"type":"list","member":{"shape":"Sq"}},"NextToken":{}}}},"GetConnections":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/connections"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ConnectionIds":{"location":"querystring","locationName":"connectionIds","type":"list","member":{}},"DeviceId":{"location":"querystring","locationName":"deviceId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"shape":"S1p"}},"NextToken":{}}}},"GetCoreNetwork":{"http":{"method":"GET","requestUri":"/core-networks/{coreNetworkId}"},"input":{"type":"structure","required":["CoreNetworkId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"}}},"output":{"type":"structure","members":{"CoreNetwork":{"shape":"S1w"}}}},"GetCoreNetworkChangeSet":{"http":{"method":"GET","requestUri":"/core-networks/{coreNetworkId}/core-network-change-sets/{policyVersionId}"},"input":{"type":"structure","required":["CoreNetworkId","PolicyVersionId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"PolicyVersionId":{"location":"uri","locationName":"policyVersionId","type":"integer"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"CoreNetworkChanges":{"type":"list","member":{"type":"structure","members":{"Type":{},"Action":{},"Identifier":{},"PreviousValues":{"shape":"S4z"},"NewValues":{"shape":"S4z"}}}},"NextToken":{}}}},"GetCoreNetworkPolicy":{"http":{"method":"GET","requestUri":"/core-networks/{coreNetworkId}/core-network-policy"},"input":{"type":"structure","required":["CoreNetworkId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"PolicyVersionId":{"location":"querystring","locationName":"policyVersionId","type":"integer"},"Alias":{"location":"querystring","locationName":"alias"}}},"output":{"type":"structure","members":{"CoreNetworkPolicy":{"shape":"S3d"}}}},"GetCustomerGatewayAssociations":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/customer-gateway-associations"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"CustomerGatewayArns":{"location":"querystring","locationName":"customerGatewayArns","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"CustomerGatewayAssociations":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"GetDevices":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/devices"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceIds":{"location":"querystring","locationName":"deviceIds","type":"list","member":{}},"SiteId":{"location":"querystring","locationName":"siteId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Devices":{"type":"list","member":{"shape":"S29"}},"NextToken":{}}}},"GetLinkAssociations":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/link-associations"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{"location":"querystring","locationName":"deviceId"},"LinkId":{"location":"querystring","locationName":"linkId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"LinkAssociations":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"GetLinks":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/links"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"LinkIds":{"location":"querystring","locationName":"linkIds","type":"list","member":{}},"SiteId":{"location":"querystring","locationName":"siteId"},"Type":{"location":"querystring","locationName":"type"},"Provider":{"location":"querystring","locationName":"provider"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Links":{"type":"list","member":{"shape":"S2k"}},"NextToken":{}}}},"GetNetworkResourceCounts":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/network-resource-count"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NetworkResourceCounts":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"Count":{"type":"integer"}}}},"NextToken":{}}}},"GetNetworkResourceRelationships":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/network-resource-relationships"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"CoreNetworkId":{"location":"querystring","locationName":"coreNetworkId"},"RegisteredGatewayArn":{"location":"querystring","locationName":"registeredGatewayArn"},"AwsRegion":{"location":"querystring","locationName":"awsRegion"},"AccountId":{"location":"querystring","locationName":"accountId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"ResourceArn":{"location":"querystring","locationName":"resourceArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Relationships":{"type":"list","member":{"type":"structure","members":{"From":{},"To":{}}}},"NextToken":{}}}},"GetNetworkResources":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/network-resources"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"CoreNetworkId":{"location":"querystring","locationName":"coreNetworkId"},"RegisteredGatewayArn":{"location":"querystring","locationName":"registeredGatewayArn"},"AwsRegion":{"location":"querystring","locationName":"awsRegion"},"AccountId":{"location":"querystring","locationName":"accountId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"ResourceArn":{"location":"querystring","locationName":"resourceArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NetworkResources":{"type":"list","member":{"type":"structure","members":{"RegisteredGatewayArn":{},"CoreNetworkId":{},"AwsRegion":{},"AccountId":{},"ResourceType":{},"ResourceId":{},"ResourceArn":{},"Definition":{},"DefinitionTimestamp":{"type":"timestamp"},"Tags":{"shape":"Se"},"Metadata":{"shape":"S5t"}}}},"NextToken":{}}}},"GetNetworkRoutes":{"http":{"requestUri":"/global-networks/{globalNetworkId}/network-routes"},"input":{"type":"structure","required":["GlobalNetworkId","RouteTableIdentifier"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"RouteTableIdentifier":{"type":"structure","members":{"TransitGatewayRouteTableArn":{},"CoreNetworkSegmentEdge":{"shape":"S5x"}}},"ExactCidrMatches":{"shape":"S1g"},"LongestPrefixMatches":{"shape":"S1g"},"SubnetOfMatches":{"shape":"S1g"},"SupernetOfMatches":{"shape":"S1g"},"PrefixListIds":{"shape":"S1g"},"States":{"type":"list","member":{}},"Types":{"type":"list","member":{}},"DestinationFilters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"RouteTableArn":{},"CoreNetworkSegmentEdge":{"shape":"S5x"},"RouteTableType":{},"RouteTableTimestamp":{"type":"timestamp"},"NetworkRoutes":{"type":"list","member":{"type":"structure","members":{"DestinationCidrBlock":{},"Destinations":{"type":"list","member":{"type":"structure","members":{"CoreNetworkAttachmentId":{},"TransitGatewayAttachmentId":{},"SegmentName":{},"EdgeLocation":{},"ResourceType":{},"ResourceId":{}}}},"PrefixListId":{},"State":{},"Type":{}}}}}}},"GetNetworkTelemetry":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/network-telemetry"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"CoreNetworkId":{"location":"querystring","locationName":"coreNetworkId"},"RegisteredGatewayArn":{"location":"querystring","locationName":"registeredGatewayArn"},"AwsRegion":{"location":"querystring","locationName":"awsRegion"},"AccountId":{"location":"querystring","locationName":"accountId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"ResourceArn":{"location":"querystring","locationName":"resourceArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NetworkTelemetry":{"type":"list","member":{"type":"structure","members":{"RegisteredGatewayArn":{},"CoreNetworkId":{},"AwsRegion":{},"AccountId":{},"ResourceType":{},"ResourceId":{},"ResourceArn":{},"Address":{},"Health":{"type":"structure","members":{"Type":{},"Status":{},"Timestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"GetResourcePolicy":{"http":{"method":"GET","requestUri":"/resource-policy/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"PolicyDocument":{"jsonvalue":true}}}},"GetRouteAnalysis":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/route-analyses/{routeAnalysisId}"},"input":{"type":"structure","required":["GlobalNetworkId","RouteAnalysisId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"RouteAnalysisId":{"location":"uri","locationName":"routeAnalysisId"}}},"output":{"type":"structure","members":{"RouteAnalysis":{"shape":"S6p"}}}},"GetSiteToSiteVpnAttachment":{"http":{"method":"GET","requestUri":"/site-to-site-vpn-attachments/{attachmentId}"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"}}},"output":{"type":"structure","members":{"SiteToSiteVpnAttachment":{"shape":"S2v"}}}},"GetSites":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/sites"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"SiteIds":{"location":"querystring","locationName":"siteIds","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Sites":{"type":"list","member":{"shape":"S2p"}},"NextToken":{}}}},"GetTransitGatewayConnectPeerAssociations":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/transit-gateway-connect-peer-associations"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"TransitGatewayConnectPeerArns":{"location":"querystring","locationName":"transitGatewayConnectPeerArns","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeerAssociations":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"GetTransitGatewayRegistrations":{"http":{"method":"GET","requestUri":"/global-networks/{globalNetworkId}/transit-gateway-registrations"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"TransitGatewayArns":{"location":"querystring","locationName":"transitGatewayArns","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"TransitGatewayRegistrations":{"type":"list","member":{"shape":"S3w"}},"NextToken":{}}}},"GetVpcAttachment":{"http":{"method":"GET","requestUri":"/vpc-attachments/{attachmentId}"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S32"}}}},"ListAttachments":{"http":{"method":"GET","requestUri":"/attachments"},"input":{"type":"structure","members":{"CoreNetworkId":{"location":"querystring","locationName":"coreNetworkId"},"AttachmentType":{"location":"querystring","locationName":"attachmentType"},"EdgeLocation":{"location":"querystring","locationName":"edgeLocation"},"State":{"location":"querystring","locationName":"state"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Attachments":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"ListConnectPeers":{"http":{"method":"GET","requestUri":"/connect-peers"},"input":{"type":"structure","members":{"CoreNetworkId":{"location":"querystring","locationName":"coreNetworkId"},"ConnectAttachmentId":{"location":"querystring","locationName":"connectAttachmentId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ConnectPeers":{"type":"list","member":{"type":"structure","members":{"CoreNetworkId":{},"ConnectAttachmentId":{},"ConnectPeerId":{},"EdgeLocation":{},"ConnectPeerState":{},"CreatedAt":{"type":"timestamp"},"Tags":{"shape":"Se"}}}},"NextToken":{}}}},"ListCoreNetworkPolicyVersions":{"http":{"method":"GET","requestUri":"/core-networks/{coreNetworkId}/core-network-policy-versions"},"input":{"type":"structure","required":["CoreNetworkId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"CoreNetworkPolicyVersions":{"type":"list","member":{"type":"structure","members":{"CoreNetworkId":{},"PolicyVersionId":{"type":"integer"},"Alias":{},"Description":{},"CreatedAt":{"type":"timestamp"},"ChangeSetState":{}}}},"NextToken":{}}}},"ListCoreNetworks":{"http":{"method":"GET","requestUri":"/core-networks"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"CoreNetworks":{"type":"list","member":{"type":"structure","members":{"CoreNetworkId":{},"CoreNetworkArn":{},"GlobalNetworkId":{},"OwnerAccountId":{},"State":{},"Description":{},"Tags":{"shape":"Se"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"TagList":{"shape":"Se"}}}},"PutCoreNetworkPolicy":{"http":{"requestUri":"/core-networks/{coreNetworkId}/core-network-policy"},"input":{"type":"structure","required":["CoreNetworkId","PolicyDocument"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"PolicyDocument":{"jsonvalue":true},"Description":{},"LatestVersionId":{"type":"integer"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CoreNetworkPolicy":{"shape":"S3d"}}}},"PutResourcePolicy":{"http":{"requestUri":"/resource-policy/{resourceArn}"},"input":{"type":"structure","required":["PolicyDocument","ResourceArn"],"members":{"PolicyDocument":{"jsonvalue":true},"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{}}},"RegisterTransitGateway":{"http":{"requestUri":"/global-networks/{globalNetworkId}/transit-gateway-registrations"},"input":{"type":"structure","required":["GlobalNetworkId","TransitGatewayArn"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"TransitGatewayArn":{}}},"output":{"type":"structure","members":{"TransitGatewayRegistration":{"shape":"S3w"}}}},"RejectAttachment":{"http":{"requestUri":"/attachments/{attachmentId}/reject"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"S4"}}}},"RestoreCoreNetworkPolicyVersion":{"http":{"requestUri":"/core-networks/{coreNetworkId}/core-network-policy-versions/{policyVersionId}/restore"},"input":{"type":"structure","required":["CoreNetworkId","PolicyVersionId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"PolicyVersionId":{"location":"uri","locationName":"policyVersionId","type":"integer"}}},"output":{"type":"structure","members":{"CoreNetworkPolicy":{"shape":"S3d"}}}},"StartRouteAnalysis":{"http":{"requestUri":"/global-networks/{globalNetworkId}/route-analyses"},"input":{"type":"structure","required":["GlobalNetworkId","Source","Destination"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"Source":{"shape":"S8b"},"Destination":{"shape":"S8b"},"IncludeReturnPath":{"type":"boolean"},"UseMiddleboxes":{"type":"boolean"}}},"output":{"type":"structure","members":{"RouteAnalysis":{"shape":"S6p"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConnection":{"http":{"method":"PATCH","requestUri":"/global-networks/{globalNetworkId}/connections/{connectionId}"},"input":{"type":"structure","required":["GlobalNetworkId","ConnectionId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ConnectionId":{"location":"uri","locationName":"connectionId"},"LinkId":{},"ConnectedLinkId":{},"Description":{}}},"output":{"type":"structure","members":{"Connection":{"shape":"S1p"}}}},"UpdateCoreNetwork":{"http":{"method":"PATCH","requestUri":"/core-networks/{coreNetworkId}"},"input":{"type":"structure","required":["CoreNetworkId"],"members":{"CoreNetworkId":{"location":"uri","locationName":"coreNetworkId"},"Description":{}}},"output":{"type":"structure","members":{"CoreNetwork":{"shape":"S1w"}}}},"UpdateDevice":{"http":{"method":"PATCH","requestUri":"/global-networks/{globalNetworkId}/devices/{deviceId}"},"input":{"type":"structure","required":["GlobalNetworkId","DeviceId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"DeviceId":{"location":"uri","locationName":"deviceId"},"AWSLocation":{"shape":"S24"},"Description":{},"Type":{},"Vendor":{},"Model":{},"SerialNumber":{},"Location":{"shape":"S26"},"SiteId":{}}},"output":{"type":"structure","members":{"Device":{"shape":"S29"}}}},"UpdateGlobalNetwork":{"http":{"method":"PATCH","requestUri":"/global-networks/{globalNetworkId}"},"input":{"type":"structure","required":["GlobalNetworkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"Description":{}}},"output":{"type":"structure","members":{"GlobalNetwork":{"shape":"S2e"}}}},"UpdateLink":{"http":{"method":"PATCH","requestUri":"/global-networks/{globalNetworkId}/links/{linkId}"},"input":{"type":"structure","required":["GlobalNetworkId","LinkId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"LinkId":{"location":"uri","locationName":"linkId"},"Description":{},"Type":{},"Bandwidth":{"shape":"S2i"},"Provider":{}}},"output":{"type":"structure","members":{"Link":{"shape":"S2k"}}}},"UpdateNetworkResourceMetadata":{"http":{"method":"PATCH","requestUri":"/global-networks/{globalNetworkId}/network-resources/{resourceArn}/metadata"},"input":{"type":"structure","required":["GlobalNetworkId","ResourceArn","Metadata"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Metadata":{"shape":"S5t"}}},"output":{"type":"structure","members":{"ResourceArn":{},"Metadata":{"shape":"S5t"}}}},"UpdateSite":{"http":{"method":"PATCH","requestUri":"/global-networks/{globalNetworkId}/sites/{siteId}"},"input":{"type":"structure","required":["GlobalNetworkId","SiteId"],"members":{"GlobalNetworkId":{"location":"uri","locationName":"globalNetworkId"},"SiteId":{"location":"uri","locationName":"siteId"},"Description":{},"Location":{"shape":"S26"}}},"output":{"type":"structure","members":{"Site":{"shape":"S2p"}}}},"UpdateVpcAttachment":{"http":{"method":"PATCH","requestUri":"/vpc-attachments/{attachmentId}"},"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"location":"uri","locationName":"attachmentId"},"AddSubnetArns":{"shape":"S2y"},"RemoveSubnetArns":{"shape":"S2y"},"Options":{"shape":"S2z"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S32"}}}}},"shapes":{"S4":{"type":"structure","members":{"CoreNetworkId":{},"CoreNetworkArn":{},"AttachmentId":{},"OwnerAccountId":{},"AttachmentType":{},"State":{},"EdgeLocation":{},"ResourceArn":{},"AttachmentPolicyRuleNumber":{"type":"integer"},"SegmentName":{},"Tags":{"shape":"Se"},"ProposedSegmentChange":{"type":"structure","members":{"Tags":{"shape":"Se"},"AttachmentPolicyRuleNumber":{"type":"integer"},"SegmentName":{}}},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"}}},"Se":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sq":{"type":"structure","members":{"ConnectPeerId":{},"GlobalNetworkId":{},"DeviceId":{},"LinkId":{},"State":{}}},"Sv":{"type":"structure","members":{"CustomerGatewayArn":{},"GlobalNetworkId":{},"DeviceId":{},"LinkId":{},"State":{}}},"Sz":{"type":"structure","members":{"GlobalNetworkId":{},"DeviceId":{},"LinkId":{},"LinkAssociationState":{}}},"S14":{"type":"structure","members":{"TransitGatewayConnectPeerArn":{},"GlobalNetworkId":{},"DeviceId":{},"LinkId":{},"State":{}}},"S17":{"type":"structure","members":{"Protocol":{}}},"S1b":{"type":"structure","members":{"Attachment":{"shape":"S4"},"TransportAttachmentId":{},"Options":{"shape":"S17"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"structure","members":{"CoreNetworkId":{},"ConnectAttachmentId":{},"ConnectPeerId":{},"EdgeLocation":{},"State":{},"CreatedAt":{"type":"timestamp"},"Configuration":{"type":"structure","members":{"CoreNetworkAddress":{},"PeerAddress":{},"InsideCidrBlocks":{"shape":"S1g"},"Protocol":{},"BgpConfigurations":{"type":"list","member":{"type":"structure","members":{"CoreNetworkAsn":{"type":"long"},"PeerAsn":{"type":"long"},"CoreNetworkAddress":{},"PeerAddress":{}}}}}},"Tags":{"shape":"Se"}}},"S1p":{"type":"structure","members":{"ConnectionId":{},"ConnectionArn":{},"GlobalNetworkId":{},"DeviceId":{},"ConnectedDeviceId":{},"LinkId":{},"ConnectedLinkId":{},"Description":{},"CreatedAt":{"type":"timestamp"},"State":{},"Tags":{"shape":"Se"}}},"S1w":{"type":"structure","members":{"GlobalNetworkId":{},"CoreNetworkId":{},"CoreNetworkArn":{},"Description":{},"CreatedAt":{"type":"timestamp"},"State":{},"Segments":{"type":"list","member":{"type":"structure","members":{"Name":{},"EdgeLocations":{"shape":"S20"},"SharedSegments":{"shape":"S1g"}}}},"Edges":{"type":"list","member":{"type":"structure","members":{"EdgeLocation":{},"Asn":{"type":"long"},"InsideCidrBlocks":{"shape":"S1g"}}}},"Tags":{"shape":"Se"}}},"S20":{"type":"list","member":{}},"S24":{"type":"structure","members":{"Zone":{},"SubnetArn":{}}},"S26":{"type":"structure","members":{"Address":{},"Latitude":{},"Longitude":{}},"sensitive":true},"S29":{"type":"structure","members":{"DeviceId":{},"DeviceArn":{},"GlobalNetworkId":{},"AWSLocation":{"shape":"S24"},"Description":{},"Type":{},"Vendor":{},"Model":{},"SerialNumber":{},"Location":{"shape":"S26"},"SiteId":{},"CreatedAt":{"type":"timestamp"},"State":{},"Tags":{"shape":"Se"}}},"S2e":{"type":"structure","members":{"GlobalNetworkId":{},"GlobalNetworkArn":{},"Description":{},"CreatedAt":{"type":"timestamp"},"State":{},"Tags":{"shape":"Se"}}},"S2i":{"type":"structure","members":{"UploadSpeed":{"type":"integer"},"DownloadSpeed":{"type":"integer"}}},"S2k":{"type":"structure","members":{"LinkId":{},"LinkArn":{},"GlobalNetworkId":{},"SiteId":{},"Description":{},"Type":{},"Bandwidth":{"shape":"S2i"},"Provider":{},"CreatedAt":{"type":"timestamp"},"State":{},"Tags":{"shape":"Se"}}},"S2p":{"type":"structure","members":{"SiteId":{},"SiteArn":{},"GlobalNetworkId":{},"Description":{},"Location":{"shape":"S26"},"CreatedAt":{"type":"timestamp"},"State":{},"Tags":{"shape":"Se"}}},"S2v":{"type":"structure","members":{"Attachment":{"shape":"S4"},"VpnConnectionArn":{}}},"S2y":{"type":"list","member":{}},"S2z":{"type":"structure","members":{"Ipv6Support":{"type":"boolean"}}},"S32":{"type":"structure","members":{"Attachment":{"shape":"S4"},"SubnetArns":{"shape":"S2y"},"Options":{"shape":"S2z"}}},"S3d":{"type":"structure","members":{"CoreNetworkId":{},"PolicyVersionId":{"type":"integer"},"Alias":{},"Description":{},"CreatedAt":{"type":"timestamp"},"ChangeSetState":{},"PolicyErrors":{"type":"list","member":{"type":"structure","required":["ErrorCode","Message"],"members":{"ErrorCode":{},"Message":{},"Path":{}}}},"PolicyDocument":{"jsonvalue":true}}},"S3w":{"type":"structure","members":{"GlobalNetworkId":{},"TransitGatewayArn":{},"State":{"type":"structure","members":{"Code":{},"Message":{}}}}},"S4z":{"type":"structure","members":{"SegmentName":{},"EdgeLocations":{"shape":"S20"},"Asn":{"type":"long"},"Cidr":{},"DestinationIdentifier":{},"InsideCidrBlocks":{"shape":"S1g"},"SharedSegments":{"shape":"S1g"}}},"S5t":{"type":"map","key":{},"value":{}},"S5x":{"type":"structure","members":{"CoreNetworkId":{},"SegmentName":{},"EdgeLocation":{}}},"S6p":{"type":"structure","members":{"GlobalNetworkId":{},"OwnerAccountId":{},"RouteAnalysisId":{},"StartTimestamp":{"type":"timestamp"},"Status":{},"Source":{"shape":"S6r"},"Destination":{"shape":"S6r"},"IncludeReturnPath":{"type":"boolean"},"UseMiddleboxes":{"type":"boolean"},"ForwardPath":{"shape":"S6t"},"ReturnPath":{"shape":"S6t"}}},"S6r":{"type":"structure","members":{"TransitGatewayAttachmentArn":{},"TransitGatewayArn":{},"IpAddress":{}}},"S6t":{"type":"structure","members":{"CompletionStatus":{"type":"structure","members":{"ResultCode":{},"ReasonCode":{},"ReasonContext":{"type":"map","key":{},"value":{}}}},"Path":{"type":"list","member":{"type":"structure","members":{"Sequence":{"type":"integer"},"Resource":{"type":"structure","members":{"RegisteredGatewayArn":{},"ResourceArn":{},"ResourceType":{},"Definition":{},"NameTag":{},"IsMiddlebox":{"type":"boolean"}}},"DestinationCidrBlock":{}}}}}},"S8b":{"type":"structure","members":{"TransitGatewayAttachmentArn":{},"IpAddress":{}}}}}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeGlobalNetworks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"GlobalNetworks"},"GetConnectPeerAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ConnectPeerAssociations"},"GetConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Connections"},"GetCoreNetworkChangeSet":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CoreNetworkChanges"},"GetCustomerGatewayAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CustomerGatewayAssociations"},"GetDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Devices"},"GetLinkAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"LinkAssociations"},"GetLinks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Links"},"GetNetworkResourceCounts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NetworkResourceCounts"},"GetNetworkResourceRelationships":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Relationships"},"GetNetworkResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NetworkResources"},"GetNetworkTelemetry":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NetworkTelemetry"},"GetSites":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Sites"},"GetTransitGatewayConnectPeerAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TransitGatewayConnectPeerAssociations"},"GetTransitGatewayRegistrations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"TransitGatewayRegistrations"},"ListAttachments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Attachments"},"ListConnectPeers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ConnectPeers"},"ListCoreNetworkPolicyVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CoreNetworkPolicyVersions"},"ListCoreNetworks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CoreNetworks"}}}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['outposts'] = {};
	AWS.Outposts = Service.defineService('outposts', ['2019-12-03']);
	Object.defineProperty(apiLoader.services['outposts'], '2019-12-03', {
	  get: function get() {
	    var model = __webpack_require__(857);
	    model.paginators = __webpack_require__(858).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Outposts;


/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-03","endpointPrefix":"outposts","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Outposts","serviceFullName":"AWS Outposts","serviceId":"Outposts","signatureVersion":"v4","signingName":"outposts","uid":"outposts-2019-12-03"},"operations":{"CancelOrder":{"http":{"requestUri":"/orders/{OrderId}/cancel"},"input":{"type":"structure","required":["OrderId"],"members":{"OrderId":{"location":"uri","locationName":"OrderId"}}},"output":{"type":"structure","members":{}}},"CreateOrder":{"http":{"requestUri":"/orders"},"input":{"type":"structure","required":["OutpostIdentifier","LineItems","PaymentOption"],"members":{"OutpostIdentifier":{},"LineItems":{"type":"list","member":{"type":"structure","members":{"CatalogItemId":{},"Quantity":{"type":"integer"}}}},"PaymentOption":{},"PaymentTerm":{}}},"output":{"type":"structure","members":{"Order":{"shape":"Sd"}}}},"CreateOutpost":{"http":{"requestUri":"/outposts"},"input":{"type":"structure","required":["Name","SiteId"],"members":{"Name":{},"Description":{},"SiteId":{},"AvailabilityZone":{},"AvailabilityZoneId":{},"Tags":{"shape":"Sr"},"SupportedHardwareType":{}}},"output":{"type":"structure","members":{"Outpost":{"shape":"Sw"}}}},"CreateSite":{"http":{"requestUri":"/sites"},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"Notes":{},"Tags":{"shape":"Sr"},"OperatingAddress":{"shape":"S16"},"ShippingAddress":{"shape":"S16"},"RackPhysicalProperties":{"shape":"S1i"}}},"output":{"type":"structure","members":{"Site":{"shape":"S1t"}}}},"DeleteOutpost":{"http":{"method":"DELETE","requestUri":"/outposts/{OutpostId}"},"input":{"type":"structure","required":["OutpostId"],"members":{"OutpostId":{"location":"uri","locationName":"OutpostId"}}},"output":{"type":"structure","members":{}}},"DeleteSite":{"http":{"method":"DELETE","requestUri":"/sites/{SiteId}"},"input":{"type":"structure","required":["SiteId"],"members":{"SiteId":{"location":"uri","locationName":"SiteId"}}},"output":{"type":"structure","members":{}}},"GetCatalogItem":{"http":{"method":"GET","requestUri":"/catalog/item/{CatalogItemId}"},"input":{"type":"structure","required":["CatalogItemId"],"members":{"CatalogItemId":{"location":"uri","locationName":"CatalogItemId"}}},"output":{"type":"structure","members":{"CatalogItem":{"shape":"S21"}}}},"GetOrder":{"http":{"method":"GET","requestUri":"/orders/{OrderId}"},"input":{"type":"structure","required":["OrderId"],"members":{"OrderId":{"location":"uri","locationName":"OrderId"}}},"output":{"type":"structure","members":{"Order":{"shape":"Sd"}}}},"GetOutpost":{"http":{"method":"GET","requestUri":"/outposts/{OutpostId}"},"input":{"type":"structure","required":["OutpostId"],"members":{"OutpostId":{"location":"uri","locationName":"OutpostId"}}},"output":{"type":"structure","members":{"Outpost":{"shape":"Sw"}}}},"GetOutpostInstanceTypes":{"http":{"method":"GET","requestUri":"/outposts/{OutpostId}/instanceTypes"},"input":{"type":"structure","required":["OutpostId"],"members":{"OutpostId":{"location":"uri","locationName":"OutpostId"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"InstanceTypes":{"type":"list","member":{"type":"structure","members":{"InstanceType":{}}}},"NextToken":{},"OutpostId":{},"OutpostArn":{}}}},"GetSite":{"http":{"method":"GET","requestUri":"/sites/{SiteId}"},"input":{"type":"structure","required":["SiteId"],"members":{"SiteId":{"location":"uri","locationName":"SiteId"}}},"output":{"type":"structure","members":{"Site":{"shape":"S1t"}}}},"GetSiteAddress":{"http":{"method":"GET","requestUri":"/sites/{SiteId}/address"},"input":{"type":"structure","required":["SiteId","AddressType"],"members":{"SiteId":{"location":"uri","locationName":"SiteId"},"AddressType":{"location":"querystring","locationName":"AddressType"}}},"output":{"type":"structure","members":{"SiteId":{},"AddressType":{},"Address":{"shape":"S16"}}}},"ListAssets":{"http":{"method":"GET","requestUri":"/outposts/{OutpostId}/assets"},"input":{"type":"structure","required":["OutpostIdentifier"],"members":{"OutpostIdentifier":{"location":"uri","locationName":"OutpostId"},"HostIdFilter":{"location":"querystring","locationName":"HostIdFilter","type":"list","member":{}},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Assets":{"type":"list","member":{"type":"structure","members":{"AssetId":{},"RackId":{},"AssetType":{},"ComputeAttributes":{"type":"structure","members":{"HostId":{}}}}}},"NextToken":{}}}},"ListCatalogItems":{"http":{"method":"GET","requestUri":"/catalog/items"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"ItemClassFilter":{"location":"querystring","locationName":"ItemClassFilter","type":"list","member":{}},"SupportedStorageFilter":{"shape":"S2c","location":"querystring","locationName":"SupportedStorageFilter"},"EC2FamilyFilter":{"location":"querystring","locationName":"EC2FamilyFilter","type":"list","member":{}}}},"output":{"type":"structure","members":{"CatalogItems":{"type":"list","member":{"shape":"S21"}},"NextToken":{}}}},"ListOrders":{"http":{"method":"GET","requestUri":"/list-orders"},"input":{"type":"structure","members":{"OutpostIdentifierFilter":{"location":"querystring","locationName":"OutpostIdentifierFilter"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"Orders":{"type":"list","member":{"type":"structure","members":{"OutpostId":{},"OrderId":{},"OrderType":{},"Status":{},"LineItemCountsByStatus":{"type":"map","key":{},"value":{"type":"integer"}},"OrderSubmissionDate":{"type":"timestamp"},"OrderFulfilledDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListOutposts":{"http":{"method":"GET","requestUri":"/outposts"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"LifeCycleStatusFilter":{"location":"querystring","locationName":"LifeCycleStatusFilter","type":"list","member":{}},"AvailabilityZoneFilter":{"location":"querystring","locationName":"AvailabilityZoneFilter","type":"list","member":{}},"AvailabilityZoneIdFilter":{"location":"querystring","locationName":"AvailabilityZoneIdFilter","type":"list","member":{}}}},"output":{"type":"structure","members":{"Outposts":{"type":"list","member":{"shape":"Sw"}},"NextToken":{}}}},"ListSites":{"http":{"method":"GET","requestUri":"/sites"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"OperatingAddressCountryCodeFilter":{"location":"querystring","locationName":"OperatingAddressCountryCodeFilter","type":"list","member":{}},"OperatingAddressStateOrRegionFilter":{"location":"querystring","locationName":"OperatingAddressStateOrRegionFilter","type":"list","member":{}},"OperatingAddressCityFilter":{"location":"querystring","locationName":"OperatingAddressCityFilter","type":"list","member":{}}}},"output":{"type":"structure","members":{"Sites":{"type":"list","member":{"shape":"S1t"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sr"}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateOutpost":{"http":{"method":"PATCH","requestUri":"/outposts/{OutpostId}"},"input":{"type":"structure","required":["OutpostId"],"members":{"OutpostId":{"location":"uri","locationName":"OutpostId"},"Name":{},"Description":{},"SupportedHardwareType":{}}},"output":{"type":"structure","members":{"Outpost":{"shape":"Sw"}}}},"UpdateSite":{"http":{"method":"PATCH","requestUri":"/sites/{SiteId}"},"input":{"type":"structure","required":["SiteId"],"members":{"SiteId":{"location":"uri","locationName":"SiteId"},"Name":{},"Description":{},"Notes":{}}},"output":{"type":"structure","members":{"Site":{"shape":"S1t"}}}},"UpdateSiteAddress":{"http":{"method":"PUT","requestUri":"/sites/{SiteId}/address"},"input":{"type":"structure","required":["SiteId","AddressType","Address"],"members":{"SiteId":{"location":"uri","locationName":"SiteId"},"AddressType":{},"Address":{"shape":"S16"}}},"output":{"type":"structure","members":{"AddressType":{},"Address":{"shape":"S16"}}}},"UpdateSiteRackPhysicalProperties":{"http":{"method":"PATCH","requestUri":"/sites/{SiteId}/rackPhysicalProperties"},"input":{"type":"structure","required":["SiteId"],"members":{"SiteId":{"location":"uri","locationName":"SiteId"},"PowerDrawKva":{},"PowerPhase":{},"PowerConnector":{},"PowerFeedDrop":{},"UplinkGbps":{},"UplinkCount":{},"FiberOpticCableType":{},"OpticalStandard":{},"MaximumSupportedWeightLbs":{}}},"output":{"type":"structure","members":{"Site":{"shape":"S1t"}}}}},"shapes":{"Sd":{"type":"structure","members":{"OutpostId":{},"OrderId":{},"Status":{},"LineItems":{"type":"list","member":{"type":"structure","members":{"CatalogItemId":{},"LineItemId":{},"Quantity":{"type":"integer"},"Status":{}}}},"PaymentOption":{},"OrderSubmissionDate":{"type":"timestamp"},"OrderFulfilledDate":{"type":"timestamp"}}},"Sr":{"type":"map","key":{},"value":{}},"Sw":{"type":"structure","members":{"OutpostId":{},"OwnerId":{},"OutpostArn":{},"SiteId":{},"Name":{},"Description":{},"LifeCycleStatus":{},"AvailabilityZone":{},"AvailabilityZoneId":{},"Tags":{"shape":"Sr"},"SiteArn":{},"SupportedHardwareType":{}}},"S16":{"type":"structure","required":["AddressLine1","City","StateOrRegion","PostalCode","CountryCode"],"members":{"ContactName":{},"ContactPhoneNumber":{},"AddressLine1":{},"AddressLine2":{},"AddressLine3":{},"City":{},"StateOrRegion":{},"DistrictOrCounty":{},"PostalCode":{},"CountryCode":{},"Municipality":{}}},"S1i":{"type":"structure","members":{"PowerDrawKva":{},"PowerPhase":{},"PowerConnector":{},"PowerFeedDrop":{},"UplinkGbps":{},"UplinkCount":{},"FiberOpticCableType":{},"OpticalStandard":{},"MaximumSupportedWeightLbs":{}}},"S1t":{"type":"structure","members":{"SiteId":{},"AccountId":{},"Name":{},"Description":{},"Tags":{"shape":"Sr"},"SiteArn":{},"Notes":{},"OperatingAddressCountryCode":{},"OperatingAddressStateOrRegion":{},"OperatingAddressCity":{},"RackPhysicalProperties":{"shape":"S1i"}}},"S21":{"type":"structure","members":{"CatalogItemId":{},"ItemStatus":{},"EC2Capacities":{"type":"list","member":{"type":"structure","members":{"Family":{},"MaxSize":{},"Quantity":{}}}},"PowerKva":{"type":"float"},"WeightLbs":{"type":"integer"},"SupportedUplinkGbps":{"type":"list","member":{"type":"integer"}},"SupportedStorage":{"shape":"S2c"}}},"S2c":{"type":"list","member":{}}}}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetOutpostInstanceTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAssets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCatalogItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOrders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOutposts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSites":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['augmentedairuntime'] = {};
	AWS.AugmentedAIRuntime = Service.defineService('augmentedairuntime', ['2019-11-07']);
	Object.defineProperty(apiLoader.services['augmentedairuntime'], '2019-11-07', {
	  get: function get() {
	    var model = __webpack_require__(860);
	    model.paginators = __webpack_require__(861).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AugmentedAIRuntime;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-11-07","endpointPrefix":"a2i-runtime.sagemaker","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Augmented AI Runtime","serviceId":"SageMaker A2I Runtime","signatureVersion":"v4","signingName":"sagemaker","uid":"sagemaker-a2i-runtime-2019-11-07"},"operations":{"DeleteHumanLoop":{"http":{"method":"DELETE","requestUri":"/human-loops/{HumanLoopName}"},"input":{"type":"structure","required":["HumanLoopName"],"members":{"HumanLoopName":{"location":"uri","locationName":"HumanLoopName"}}},"output":{"type":"structure","members":{}}},"DescribeHumanLoop":{"http":{"method":"GET","requestUri":"/human-loops/{HumanLoopName}"},"input":{"type":"structure","required":["HumanLoopName"],"members":{"HumanLoopName":{"location":"uri","locationName":"HumanLoopName"}}},"output":{"type":"structure","required":["CreationTime","HumanLoopStatus","HumanLoopName","HumanLoopArn","FlowDefinitionArn"],"members":{"CreationTime":{"type":"timestamp"},"FailureReason":{},"FailureCode":{},"HumanLoopStatus":{},"HumanLoopName":{},"HumanLoopArn":{},"FlowDefinitionArn":{},"HumanLoopOutput":{"type":"structure","required":["OutputS3Uri"],"members":{"OutputS3Uri":{}}}}}},"ListHumanLoops":{"http":{"method":"GET","requestUri":"/human-loops"},"input":{"type":"structure","required":["FlowDefinitionArn"],"members":{"CreationTimeAfter":{"location":"querystring","locationName":"CreationTimeAfter","type":"timestamp"},"CreationTimeBefore":{"location":"querystring","locationName":"CreationTimeBefore","type":"timestamp"},"FlowDefinitionArn":{"location":"querystring","locationName":"FlowDefinitionArn"},"SortOrder":{"location":"querystring","locationName":"SortOrder"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","required":["HumanLoopSummaries"],"members":{"HumanLoopSummaries":{"type":"list","member":{"type":"structure","members":{"HumanLoopName":{},"HumanLoopStatus":{},"CreationTime":{"type":"timestamp"},"FailureReason":{},"FlowDefinitionArn":{}}}},"NextToken":{}}}},"StartHumanLoop":{"http":{"requestUri":"/human-loops"},"input":{"type":"structure","required":["HumanLoopName","FlowDefinitionArn","HumanLoopInput"],"members":{"HumanLoopName":{},"FlowDefinitionArn":{},"HumanLoopInput":{"type":"structure","required":["InputContent"],"members":{"InputContent":{}}},"DataAttributes":{"type":"structure","required":["ContentClassifiers"],"members":{"ContentClassifiers":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"HumanLoopArn":{}}}},"StopHumanLoop":{"http":{"requestUri":"/human-loops/stop"},"input":{"type":"structure","required":["HumanLoopName"],"members":{"HumanLoopName":{}}},"output":{"type":"structure","members":{}}}},"shapes":{}}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListHumanLoops":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"HumanLoopSummaries"}}}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ebs'] = {};
	AWS.EBS = Service.defineService('ebs', ['2019-11-02']);
	Object.defineProperty(apiLoader.services['ebs'], '2019-11-02', {
	  get: function get() {
	    var model = __webpack_require__(863);
	    model.paginators = __webpack_require__(864).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EBS;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-11-02","endpointPrefix":"ebs","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon EBS","serviceFullName":"Amazon Elastic Block Store","serviceId":"EBS","signatureVersion":"v4","uid":"ebs-2019-11-02"},"operations":{"CompleteSnapshot":{"http":{"requestUri":"/snapshots/completion/{snapshotId}","responseCode":202},"input":{"type":"structure","required":["SnapshotId","ChangedBlocksCount"],"members":{"SnapshotId":{"location":"uri","locationName":"snapshotId"},"ChangedBlocksCount":{"location":"header","locationName":"x-amz-ChangedBlocksCount","type":"integer"},"Checksum":{"location":"header","locationName":"x-amz-Checksum"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-Checksum-Algorithm"},"ChecksumAggregationMethod":{"location":"header","locationName":"x-amz-Checksum-Aggregation-Method"}}},"output":{"type":"structure","members":{"Status":{}}}},"GetSnapshotBlock":{"http":{"method":"GET","requestUri":"/snapshots/{snapshotId}/blocks/{blockIndex}"},"input":{"type":"structure","required":["SnapshotId","BlockIndex","BlockToken"],"members":{"SnapshotId":{"location":"uri","locationName":"snapshotId"},"BlockIndex":{"location":"uri","locationName":"blockIndex","type":"integer"},"BlockToken":{"location":"querystring","locationName":"blockToken"}}},"output":{"type":"structure","members":{"DataLength":{"location":"header","locationName":"x-amz-Data-Length","type":"integer"},"BlockData":{"shape":"Se"},"Checksum":{"location":"header","locationName":"x-amz-Checksum"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-Checksum-Algorithm"}},"payload":"BlockData"}},"ListChangedBlocks":{"http":{"method":"GET","requestUri":"/snapshots/{secondSnapshotId}/changedblocks"},"input":{"type":"structure","required":["SecondSnapshotId"],"members":{"FirstSnapshotId":{"location":"querystring","locationName":"firstSnapshotId"},"SecondSnapshotId":{"location":"uri","locationName":"secondSnapshotId"},"NextToken":{"location":"querystring","locationName":"pageToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"StartingBlockIndex":{"location":"querystring","locationName":"startingBlockIndex","type":"integer"}}},"output":{"type":"structure","members":{"ChangedBlocks":{"type":"list","member":{"type":"structure","members":{"BlockIndex":{"type":"integer"},"FirstBlockToken":{},"SecondBlockToken":{}},"sensitive":true}},"ExpiryTime":{"type":"timestamp"},"VolumeSize":{"type":"long"},"BlockSize":{"type":"integer"},"NextToken":{}}}},"ListSnapshotBlocks":{"http":{"method":"GET","requestUri":"/snapshots/{snapshotId}/blocks"},"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{"location":"uri","locationName":"snapshotId"},"NextToken":{"location":"querystring","locationName":"pageToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"StartingBlockIndex":{"location":"querystring","locationName":"startingBlockIndex","type":"integer"}}},"output":{"type":"structure","members":{"Blocks":{"type":"list","member":{"type":"structure","members":{"BlockIndex":{"type":"integer"},"BlockToken":{}}},"sensitive":true},"ExpiryTime":{"type":"timestamp"},"VolumeSize":{"type":"long"},"BlockSize":{"type":"integer"},"NextToken":{}}}},"PutSnapshotBlock":{"http":{"method":"PUT","requestUri":"/snapshots/{snapshotId}/blocks/{blockIndex}","responseCode":201},"input":{"type":"structure","required":["SnapshotId","BlockIndex","BlockData","DataLength","Checksum","ChecksumAlgorithm"],"members":{"SnapshotId":{"location":"uri","locationName":"snapshotId"},"BlockIndex":{"location":"uri","locationName":"blockIndex","type":"integer"},"BlockData":{"shape":"Se"},"DataLength":{"location":"header","locationName":"x-amz-Data-Length","type":"integer"},"Progress":{"location":"header","locationName":"x-amz-Progress","type":"integer"},"Checksum":{"location":"header","locationName":"x-amz-Checksum"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-Checksum-Algorithm"}},"payload":"BlockData"},"output":{"type":"structure","members":{"Checksum":{"location":"header","locationName":"x-amz-Checksum"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-Checksum-Algorithm"}}},"authtype":"v4-unsigned-body"},"StartSnapshot":{"http":{"requestUri":"/snapshots","responseCode":201},"input":{"type":"structure","required":["VolumeSize"],"members":{"VolumeSize":{"type":"long"},"ParentSnapshotId":{},"Tags":{"shape":"Sw"},"Description":{},"ClientToken":{"idempotencyToken":true},"Encrypted":{"type":"boolean"},"KmsKeyArn":{"shape":"S13"},"Timeout":{"type":"integer"}}},"output":{"type":"structure","members":{"Description":{},"SnapshotId":{},"OwnerId":{},"Status":{},"StartTime":{"type":"timestamp"},"VolumeSize":{"type":"long"},"BlockSize":{"type":"integer"},"Tags":{"shape":"Sw"},"ParentSnapshotId":{},"KmsKeyArn":{"shape":"S13"}}}}},"shapes":{"Se":{"type":"blob","sensitive":true,"streaming":true},"Sw":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S13":{"type":"string","sensitive":true}}}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChangedBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSnapshotBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kinesisvideosignalingchannels'] = {};
	AWS.KinesisVideoSignalingChannels = Service.defineService('kinesisvideosignalingchannels', ['2019-12-04']);
	Object.defineProperty(apiLoader.services['kinesisvideosignalingchannels'], '2019-12-04', {
	  get: function get() {
	    var model = __webpack_require__(866);
	    model.paginators = __webpack_require__(867).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KinesisVideoSignalingChannels;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-04","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Amazon Kinesis Video Signaling Channels","serviceFullName":"Amazon Kinesis Video Signaling Channels","serviceId":"Kinesis Video Signaling","signatureVersion":"v4","uid":"kinesis-video-signaling-2019-12-04"},"operations":{"GetIceServerConfig":{"http":{"requestUri":"/v1/get-ice-server-config"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"ClientId":{},"Service":{},"Username":{}}},"output":{"type":"structure","members":{"IceServerList":{"type":"list","member":{"type":"structure","members":{"Uris":{"type":"list","member":{}},"Username":{},"Password":{},"Ttl":{"type":"integer"}}}}}}},"SendAlexaOfferToMaster":{"http":{"requestUri":"/v1/send-alexa-offer-to-master"},"input":{"type":"structure","required":["ChannelARN","SenderClientId","MessagePayload"],"members":{"ChannelARN":{},"SenderClientId":{},"MessagePayload":{}}},"output":{"type":"structure","members":{"Answer":{}}}}},"shapes":{}}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['detective'] = {};
	AWS.Detective = Service.defineService('detective', ['2018-10-26']);
	Object.defineProperty(apiLoader.services['detective'], '2018-10-26', {
	  get: function get() {
	    var model = __webpack_require__(869);
	    model.paginators = __webpack_require__(870).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Detective;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-26","endpointPrefix":"api.detective","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Detective","serviceId":"Detective","signatureVersion":"v4","signingName":"detective","uid":"detective-2018-10-26"},"operations":{"AcceptInvitation":{"http":{"method":"PUT","requestUri":"/invitation"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{}}}},"CreateGraph":{"http":{"requestUri":"/graph"},"input":{"type":"structure","members":{"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"GraphArn":{}}}},"CreateMembers":{"http":{"requestUri":"/graph/members"},"input":{"type":"structure","required":["GraphArn","Accounts"],"members":{"GraphArn":{},"Message":{},"DisableEmailNotification":{"type":"boolean"},"Accounts":{"type":"list","member":{"type":"structure","required":["AccountId","EmailAddress"],"members":{"AccountId":{},"EmailAddress":{}}}}}},"output":{"type":"structure","members":{"Members":{"shape":"Sg"},"UnprocessedAccounts":{"shape":"So"}}}},"DeleteGraph":{"http":{"requestUri":"/graph/removal"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{}}}},"DeleteMembers":{"http":{"requestUri":"/graph/members/removal"},"input":{"type":"structure","required":["GraphArn","AccountIds"],"members":{"GraphArn":{},"AccountIds":{"shape":"St"}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"St"},"UnprocessedAccounts":{"shape":"So"}}}},"DescribeOrganizationConfiguration":{"http":{"requestUri":"/orgs/describeOrganizationConfiguration"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{}}},"output":{"type":"structure","members":{"AutoEnable":{"type":"boolean"}}}},"DisableOrganizationAdminAccount":{"http":{"requestUri":"/orgs/disableAdminAccount"}},"DisassociateMembership":{"http":{"requestUri":"/membership/removal"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{}}}},"EnableOrganizationAdminAccount":{"http":{"requestUri":"/orgs/enableAdminAccount"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{}}}},"GetMembers":{"http":{"requestUri":"/graph/members/get"},"input":{"type":"structure","required":["GraphArn","AccountIds"],"members":{"GraphArn":{},"AccountIds":{"shape":"St"}}},"output":{"type":"structure","members":{"MemberDetails":{"shape":"Sg"},"UnprocessedAccounts":{"shape":"So"}}}},"ListGraphs":{"http":{"requestUri":"/graphs/list"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"GraphList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedTime":{"shape":"Sk"}}}},"NextToken":{}}}},"ListInvitations":{"http":{"requestUri":"/invitations/list"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Invitations":{"shape":"Sg"},"NextToken":{}}}},"ListMembers":{"http":{"requestUri":"/graph/members/list"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"MemberDetails":{"shape":"Sg"},"NextToken":{}}}},"ListOrganizationAdminAccounts":{"http":{"requestUri":"/orgs/adminAccountslist"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Administrators":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"GraphArn":{},"DelegationTime":{"shape":"Sk"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4"}}}},"RejectInvitation":{"http":{"requestUri":"/invitation/removal"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{}}}},"StartMonitoringMember":{"http":{"requestUri":"/graph/member/monitoringstate"},"input":{"type":"structure","required":["GraphArn","AccountId"],"members":{"GraphArn":{},"AccountId":{}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateOrganizationConfiguration":{"http":{"requestUri":"/orgs/updateOrganizationConfiguration"},"input":{"type":"structure","required":["GraphArn"],"members":{"GraphArn":{},"AutoEnable":{"type":"boolean"}}}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"Sg":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"EmailAddress":{},"GraphArn":{},"MasterId":{"deprecated":true,"deprecatedMessage":"This property is deprecated. Use AdministratorId instead."},"AdministratorId":{},"Status":{},"DisabledReason":{},"InvitedTime":{"shape":"Sk"},"UpdatedTime":{"shape":"Sk"},"VolumeUsageInBytes":{"type":"long"},"VolumeUsageUpdatedTime":{"shape":"Sk"},"PercentOfGraphUtilization":{"deprecated":true,"deprecatedMessage":"This property is deprecated. Use VolumeUsageInBytes instead.","type":"double"},"PercentOfGraphUtilizationUpdatedTime":{"shape":"Sk","deprecated":true,"deprecatedMessage":"This property is deprecated. Use VolumeUsageUpdatedTime instead."},"InvitationType":{}}}},"Sk":{"type":"timestamp","timestampFormat":"iso8601"},"So":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"Reason":{}}}},"St":{"type":"list","member":{}}}}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListGraphs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOrganizationAdminAccounts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codestarconnections'] = {};
	AWS.CodeStarconnections = Service.defineService('codestarconnections', ['2019-12-01']);
	Object.defineProperty(apiLoader.services['codestarconnections'], '2019-12-01', {
	  get: function get() {
	    var model = __webpack_require__(872);
	    model.paginators = __webpack_require__(873).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeStarconnections;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-01","endpointPrefix":"codestar-connections","jsonVersion":"1.0","protocol":"json","serviceFullName":"AWS CodeStar connections","serviceId":"CodeStar connections","signatureVersion":"v4","signingName":"codestar-connections","targetPrefix":"com.amazonaws.codestar.connections.CodeStar_connections_20191201","uid":"codestar-connections-2019-12-01"},"operations":{"CreateConnection":{"input":{"type":"structure","required":["ConnectionName"],"members":{"ProviderType":{},"ConnectionName":{},"Tags":{"shape":"S4"},"HostArn":{}}},"output":{"type":"structure","required":["ConnectionArn"],"members":{"ConnectionArn":{},"Tags":{"shape":"S4"}}}},"CreateHost":{"input":{"type":"structure","required":["Name","ProviderType","ProviderEndpoint"],"members":{"Name":{},"ProviderType":{},"ProviderEndpoint":{},"VpcConfiguration":{"shape":"Se"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"HostArn":{},"Tags":{"shape":"S4"}}}},"DeleteConnection":{"input":{"type":"structure","required":["ConnectionArn"],"members":{"ConnectionArn":{}}},"output":{"type":"structure","members":{}}},"DeleteHost":{"input":{"type":"structure","required":["HostArn"],"members":{"HostArn":{}}},"output":{"type":"structure","members":{}}},"GetConnection":{"input":{"type":"structure","required":["ConnectionArn"],"members":{"ConnectionArn":{}}},"output":{"type":"structure","members":{"Connection":{"shape":"Ss"}}}},"GetHost":{"input":{"type":"structure","required":["HostArn"],"members":{"HostArn":{}}},"output":{"type":"structure","members":{"Name":{},"Status":{},"ProviderType":{},"ProviderEndpoint":{},"VpcConfiguration":{"shape":"Se"}}}},"ListConnections":{"input":{"type":"structure","members":{"ProviderTypeFilter":{},"HostArnFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"shape":"Ss"}},"NextToken":{}}}},"ListHosts":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Hosts":{"type":"list","member":{"type":"structure","members":{"Name":{},"HostArn":{},"ProviderType":{},"ProviderEndpoint":{},"VpcConfiguration":{"shape":"Se"},"Status":{},"StatusMessage":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateHost":{"input":{"type":"structure","required":["HostArn"],"members":{"HostArn":{},"ProviderEndpoint":{},"VpcConfiguration":{"shape":"Se"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Se":{"type":"structure","required":["VpcId","SubnetIds","SecurityGroupIds"],"members":{"VpcId":{},"SubnetIds":{"type":"list","member":{}},"SecurityGroupIds":{"type":"list","member":{}},"TlsCertificate":{}}},"Ss":{"type":"structure","members":{"ConnectionName":{},"ConnectionArn":{},"ProviderType":{},"OwnerAccountId":{},"ConnectionStatus":{},"HostArn":{}}}}}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHosts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['synthetics'] = {};
	AWS.Synthetics = Service.defineService('synthetics', ['2017-10-11']);
	Object.defineProperty(apiLoader.services['synthetics'], '2017-10-11', {
	  get: function get() {
	    var model = __webpack_require__(875);
	    model.paginators = __webpack_require__(876).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Synthetics;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-11","endpointPrefix":"synthetics","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Synthetics","serviceFullName":"Synthetics","serviceId":"synthetics","signatureVersion":"v4","signingName":"synthetics","uid":"synthetics-2017-10-11"},"operations":{"CreateCanary":{"http":{"requestUri":"/canary"},"input":{"type":"structure","required":["Name","Code","ArtifactS3Location","ExecutionRoleArn","Schedule","RuntimeVersion"],"members":{"Name":{},"Code":{"shape":"S3"},"ArtifactS3Location":{},"ExecutionRoleArn":{},"Schedule":{"shape":"S8"},"RunConfig":{"shape":"Sa"},"SuccessRetentionPeriodInDays":{"type":"integer"},"FailureRetentionPeriodInDays":{"type":"integer"},"RuntimeVersion":{},"VpcConfig":{"shape":"Si"},"Tags":{"shape":"Sn"},"ArtifactConfig":{"shape":"Sq"}}},"output":{"type":"structure","members":{"Canary":{"shape":"Sv"}}}},"DeleteCanary":{"http":{"method":"DELETE","requestUri":"/canary/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"DeleteLambda":{"location":"querystring","locationName":"deleteLambda","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeCanaries":{"http":{"requestUri":"/canaries"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Names":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Canaries":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"DescribeCanariesLastRun":{"http":{"requestUri":"/canaries/last-run"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Names":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"CanariesLastRun":{"type":"list","member":{"type":"structure","members":{"CanaryName":{},"LastRun":{"shape":"S1t"}}}},"NextToken":{}}}},"DescribeRuntimeVersions":{"http":{"requestUri":"/runtime-versions"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"RuntimeVersions":{"type":"list","member":{"type":"structure","members":{"VersionName":{},"Description":{},"ReleaseDate":{"type":"timestamp"},"DeprecationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"GetCanary":{"http":{"method":"GET","requestUri":"/canary/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"Canary":{"shape":"Sv"}}}},"GetCanaryRuns":{"http":{"requestUri":"/canary/{name}/runs"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CanaryRuns":{"type":"list","member":{"shape":"S1t"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sn"}}}},"StartCanary":{"http":{"requestUri":"/canary/{name}/start"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"StopCanary":{"http":{"requestUri":"/canary/{name}/stop"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCanary":{"http":{"method":"PATCH","requestUri":"/canary/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"Code":{"shape":"S3"},"ExecutionRoleArn":{},"RuntimeVersion":{},"Schedule":{"shape":"S8"},"RunConfig":{"shape":"Sa"},"SuccessRetentionPeriodInDays":{"type":"integer"},"FailureRetentionPeriodInDays":{"type":"integer"},"VpcConfig":{"shape":"Si"},"VisualReference":{"type":"structure","required":["BaseCanaryRunId"],"members":{"BaseScreenshots":{"shape":"S19"},"BaseCanaryRunId":{}}},"ArtifactS3Location":{},"ArtifactConfig":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","required":["Handler"],"members":{"S3Bucket":{},"S3Key":{},"S3Version":{},"ZipFile":{"type":"blob"},"Handler":{}}},"S8":{"type":"structure","required":["Expression"],"members":{"Expression":{},"DurationInSeconds":{"type":"long"}}},"Sa":{"type":"structure","members":{"TimeoutInSeconds":{"type":"integer"},"MemoryInMB":{"type":"integer"},"ActiveTracing":{"type":"boolean"},"EnvironmentVariables":{"type":"map","key":{},"value":{}}}},"Si":{"type":"structure","members":{"SubnetIds":{"shape":"Sj"},"SecurityGroupIds":{"shape":"Sl"}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"list","member":{}},"Sn":{"type":"map","key":{},"value":{}},"Sq":{"type":"structure","members":{"S3Encryption":{"shape":"Sr"}}},"Sr":{"type":"structure","members":{"EncryptionMode":{},"KmsKeyArn":{}}},"Sv":{"type":"structure","members":{"Id":{},"Name":{},"Code":{"type":"structure","members":{"SourceLocationArn":{},"Handler":{}}},"ExecutionRoleArn":{},"Schedule":{"type":"structure","members":{"Expression":{},"DurationInSeconds":{"type":"long"}}},"RunConfig":{"type":"structure","members":{"TimeoutInSeconds":{"type":"integer"},"MemoryInMB":{"type":"integer"},"ActiveTracing":{"type":"boolean"}}},"SuccessRetentionPeriodInDays":{"type":"integer"},"FailureRetentionPeriodInDays":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateReason":{},"StateReasonCode":{}}},"Timeline":{"type":"structure","members":{"Created":{"type":"timestamp"},"LastModified":{"type":"timestamp"},"LastStarted":{"type":"timestamp"},"LastStopped":{"type":"timestamp"}}},"ArtifactS3Location":{},"EngineArn":{},"RuntimeVersion":{},"VpcConfig":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"Sj"},"SecurityGroupIds":{"shape":"Sl"}}},"VisualReference":{"type":"structure","members":{"BaseScreenshots":{"shape":"S19"},"BaseCanaryRunId":{}}},"Tags":{"shape":"Sn"},"ArtifactConfig":{"type":"structure","members":{"S3Encryption":{"shape":"Sr"}}}}},"S19":{"type":"list","member":{"type":"structure","required":["ScreenshotName"],"members":{"ScreenshotName":{},"IgnoreCoordinates":{"type":"list","member":{}}}}},"S1t":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateReason":{},"StateReasonCode":{}}},"Timeline":{"type":"structure","members":{"Started":{"type":"timestamp"},"Completed":{"type":"timestamp"}}},"ArtifactS3Location":{}}}}}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCanaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribeCanariesLastRun":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribeRuntimeVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetCanaryRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotsitewise'] = {};
	AWS.IoTSiteWise = Service.defineService('iotsitewise', ['2019-12-02']);
	Object.defineProperty(apiLoader.services['iotsitewise'], '2019-12-02', {
	  get: function get() {
	    var model = __webpack_require__(878);
	    model.paginators = __webpack_require__(879).pagination;
	    model.waiters = __webpack_require__(880).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTSiteWise;


/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-02","endpointPrefix":"iotsitewise","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS IoT SiteWise","serviceId":"IoTSiteWise","signatureVersion":"v4","signingName":"iotsitewise","uid":"iotsitewise-2019-12-02"},"operations":{"AssociateAssets":{"http":{"requestUri":"/assets/{assetId}/associate"},"input":{"type":"structure","required":["assetId","hierarchyId","childAssetId"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"hierarchyId":{},"childAssetId":{},"clientToken":{"idempotencyToken":true}}},"endpoint":{"hostPrefix":"api."}},"AssociateTimeSeriesToAssetProperty":{"http":{"requestUri":"/timeseries/associate/"},"input":{"type":"structure","required":["alias","assetId","propertyId"],"members":{"alias":{"location":"querystring","locationName":"alias"},"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"clientToken":{"idempotencyToken":true}}},"endpoint":{"hostPrefix":"api."}},"BatchAssociateProjectAssets":{"http":{"requestUri":"/projects/{projectId}/assets/associate","responseCode":200},"input":{"type":"structure","required":["projectId","assetIds"],"members":{"projectId":{"location":"uri","locationName":"projectId"},"assetIds":{"shape":"S7"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"shape":"Sa"}}}},"endpoint":{"hostPrefix":"monitor."}},"BatchDisassociateProjectAssets":{"http":{"requestUri":"/projects/{projectId}/assets/disassociate","responseCode":200},"input":{"type":"structure","required":["projectId","assetIds"],"members":{"projectId":{"location":"uri","locationName":"projectId"},"assetIds":{"shape":"S7"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"shape":"Sa"}}}},"endpoint":{"hostPrefix":"monitor."}},"BatchGetAssetPropertyAggregates":{"http":{"requestUri":"/properties/batch/aggregates"},"input":{"type":"structure","required":["entries"],"members":{"entries":{"type":"list","member":{"type":"structure","required":["entryId","aggregateTypes","resolution","startDate","endDate"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"aggregateTypes":{"shape":"Sl"},"resolution":{},"startDate":{"type":"timestamp"},"endDate":{"type":"timestamp"},"qualities":{"shape":"Sp"},"timeOrdering":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["errorEntries","successEntries","skippedEntries"],"members":{"errorEntries":{"type":"list","member":{"type":"structure","required":["errorCode","errorMessage","entryId"],"members":{"errorCode":{},"errorMessage":{},"entryId":{}}}},"successEntries":{"type":"list","member":{"type":"structure","required":["entryId","aggregatedValues"],"members":{"entryId":{},"aggregatedValues":{"shape":"S11"}}}},"skippedEntries":{"type":"list","member":{"type":"structure","required":["entryId","completionStatus"],"members":{"entryId":{},"completionStatus":{},"errorInfo":{"type":"structure","required":["errorCode","errorTimestamp"],"members":{"errorCode":{},"errorTimestamp":{"type":"timestamp"}}}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"data."}},"BatchGetAssetPropertyValue":{"http":{"requestUri":"/properties/batch/latest"},"input":{"type":"structure","required":["entries"],"members":{"entries":{"type":"list","member":{"type":"structure","required":["entryId"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{}}}},"nextToken":{}}},"output":{"type":"structure","required":["errorEntries","successEntries","skippedEntries"],"members":{"errorEntries":{"type":"list","member":{"type":"structure","required":["errorCode","errorMessage","entryId"],"members":{"errorCode":{},"errorMessage":{},"entryId":{}}}},"successEntries":{"type":"list","member":{"type":"structure","required":["entryId"],"members":{"entryId":{},"assetPropertyValue":{"shape":"S1i"}}}},"skippedEntries":{"type":"list","member":{"type":"structure","required":["entryId","completionStatus"],"members":{"entryId":{},"completionStatus":{},"errorInfo":{"type":"structure","required":["errorCode","errorTimestamp"],"members":{"errorCode":{},"errorTimestamp":{"type":"timestamp"}}}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"data."}},"BatchGetAssetPropertyValueHistory":{"http":{"requestUri":"/properties/batch/history"},"input":{"type":"structure","required":["entries"],"members":{"entries":{"type":"list","member":{"type":"structure","required":["entryId"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"startDate":{"type":"timestamp"},"endDate":{"type":"timestamp"},"qualities":{"shape":"Sp"},"timeOrdering":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["errorEntries","successEntries","skippedEntries"],"members":{"errorEntries":{"type":"list","member":{"type":"structure","required":["errorCode","errorMessage","entryId"],"members":{"errorCode":{},"errorMessage":{},"entryId":{}}}},"successEntries":{"type":"list","member":{"type":"structure","required":["entryId","assetPropertyValueHistory"],"members":{"entryId":{},"assetPropertyValueHistory":{"shape":"S24"}}}},"skippedEntries":{"type":"list","member":{"type":"structure","required":["entryId","completionStatus"],"members":{"entryId":{},"completionStatus":{},"errorInfo":{"type":"structure","required":["errorCode","errorTimestamp"],"members":{"errorCode":{},"errorTimestamp":{"type":"timestamp"}}}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"data."}},"BatchPutAssetPropertyValue":{"http":{"requestUri":"/properties"},"input":{"type":"structure","required":["entries"],"members":{"entries":{"type":"list","member":{"type":"structure","required":["entryId","propertyValues"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"propertyValues":{"type":"list","member":{"shape":"S1i"}}}}}}},"output":{"type":"structure","required":["errorEntries"],"members":{"errorEntries":{"type":"list","member":{"type":"structure","required":["entryId","errors"],"members":{"entryId":{},"errors":{"type":"list","member":{"type":"structure","required":["errorCode","errorMessage","timestamps"],"members":{"errorCode":{},"errorMessage":{},"timestamps":{"type":"list","member":{"shape":"S1o"}}}}}}}}}},"endpoint":{"hostPrefix":"data."}},"CreateAccessPolicy":{"http":{"requestUri":"/access-policies","responseCode":201},"input":{"type":"structure","required":["accessPolicyIdentity","accessPolicyResource","accessPolicyPermission"],"members":{"accessPolicyIdentity":{"shape":"S2k"},"accessPolicyResource":{"shape":"S2r"},"accessPolicyPermission":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S2v"}}},"output":{"type":"structure","required":["accessPolicyId","accessPolicyArn"],"members":{"accessPolicyId":{},"accessPolicyArn":{}}},"endpoint":{"hostPrefix":"monitor."}},"CreateAsset":{"http":{"requestUri":"/assets","responseCode":202},"input":{"type":"structure","required":["assetName","assetModelId"],"members":{"assetName":{},"assetModelId":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S2v"}}},"output":{"type":"structure","required":["assetId","assetArn","assetStatus"],"members":{"assetId":{},"assetArn":{},"assetStatus":{"shape":"S32"}}},"endpoint":{"hostPrefix":"api."}},"CreateAssetModel":{"http":{"requestUri":"/asset-models","responseCode":202},"input":{"type":"structure","required":["assetModelName"],"members":{"assetModelName":{},"assetModelDescription":{},"assetModelProperties":{"shape":"S3c"},"assetModelHierarchies":{"type":"list","member":{"type":"structure","required":["name","childAssetModelId"],"members":{"name":{},"childAssetModelId":{}}}},"assetModelCompositeModels":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"description":{},"type":{},"properties":{"shape":"S3c"}}}},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S2v"}}},"output":{"type":"structure","required":["assetModelId","assetModelArn","assetModelStatus"],"members":{"assetModelId":{},"assetModelArn":{},"assetModelStatus":{"shape":"S47"}}},"endpoint":{"hostPrefix":"api."}},"CreateDashboard":{"http":{"requestUri":"/dashboards","responseCode":201},"input":{"type":"structure","required":["projectId","dashboardName","dashboardDefinition"],"members":{"projectId":{},"dashboardName":{},"dashboardDescription":{},"dashboardDefinition":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S2v"}}},"output":{"type":"structure","required":["dashboardId","dashboardArn"],"members":{"dashboardId":{},"dashboardArn":{}}},"endpoint":{"hostPrefix":"monitor."}},"CreateGateway":{"http":{"requestUri":"/20200301/gateways","responseCode":201},"input":{"type":"structure","required":["gatewayName","gatewayPlatform"],"members":{"gatewayName":{},"gatewayPlatform":{"shape":"S4d"},"tags":{"shape":"S2v"}}},"output":{"type":"structure","required":["gatewayId","gatewayArn"],"members":{"gatewayId":{},"gatewayArn":{}}},"endpoint":{"hostPrefix":"api."}},"CreatePortal":{"http":{"requestUri":"/portals","responseCode":202},"input":{"type":"structure","required":["portalName","portalContactEmail","roleArn"],"members":{"portalName":{},"portalDescription":{},"portalContactEmail":{},"clientToken":{"idempotencyToken":true},"portalLogoImageFile":{"shape":"S4k"},"roleArn":{},"tags":{"shape":"S2v"},"portalAuthMode":{},"notificationSenderEmail":{},"alarms":{"shape":"S4o"}}},"output":{"type":"structure","required":["portalId","portalArn","portalStartUrl","portalStatus","ssoApplicationId"],"members":{"portalId":{},"portalArn":{},"portalStartUrl":{},"portalStatus":{"shape":"S4r"},"ssoApplicationId":{}}},"endpoint":{"hostPrefix":"monitor."}},"CreateProject":{"http":{"requestUri":"/projects","responseCode":201},"input":{"type":"structure","required":["portalId","projectName"],"members":{"portalId":{},"projectName":{},"projectDescription":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S2v"}}},"output":{"type":"structure","required":["projectId","projectArn"],"members":{"projectId":{},"projectArn":{}}},"endpoint":{"hostPrefix":"monitor."}},"DeleteAccessPolicy":{"http":{"method":"DELETE","requestUri":"/access-policies/{accessPolicyId}","responseCode":204},"input":{"type":"structure","required":["accessPolicyId"],"members":{"accessPolicyId":{"location":"uri","locationName":"accessPolicyId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"monitor."}},"DeleteAsset":{"http":{"method":"DELETE","requestUri":"/assets/{assetId}","responseCode":202},"input":{"type":"structure","required":["assetId"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","required":["assetStatus"],"members":{"assetStatus":{"shape":"S32"}}},"endpoint":{"hostPrefix":"api."}},"DeleteAssetModel":{"http":{"method":"DELETE","requestUri":"/asset-models/{assetModelId}","responseCode":202},"input":{"type":"structure","required":["assetModelId"],"members":{"assetModelId":{"location":"uri","locationName":"assetModelId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","required":["assetModelStatus"],"members":{"assetModelStatus":{"shape":"S47"}}},"endpoint":{"hostPrefix":"api."}},"DeleteDashboard":{"http":{"method":"DELETE","requestUri":"/dashboards/{dashboardId}","responseCode":204},"input":{"type":"structure","required":["dashboardId"],"members":{"dashboardId":{"location":"uri","locationName":"dashboardId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"monitor."}},"DeleteGateway":{"http":{"method":"DELETE","requestUri":"/20200301/gateways/{gatewayId}"},"input":{"type":"structure","required":["gatewayId"],"members":{"gatewayId":{"location":"uri","locationName":"gatewayId"}}},"endpoint":{"hostPrefix":"api."}},"DeletePortal":{"http":{"method":"DELETE","requestUri":"/portals/{portalId}","responseCode":202},"input":{"type":"structure","required":["portalId"],"members":{"portalId":{"location":"uri","locationName":"portalId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","required":["portalStatus"],"members":{"portalStatus":{"shape":"S4r"}}},"endpoint":{"hostPrefix":"monitor."}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{projectId}","responseCode":204},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"monitor."}},"DeleteTimeSeries":{"http":{"requestUri":"/timeseries/delete/"},"input":{"type":"structure","members":{"alias":{"location":"querystring","locationName":"alias"},"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"clientToken":{"idempotencyToken":true}}},"endpoint":{"hostPrefix":"api."}},"DescribeAccessPolicy":{"http":{"method":"GET","requestUri":"/access-policies/{accessPolicyId}","responseCode":200},"input":{"type":"structure","required":["accessPolicyId"],"members":{"accessPolicyId":{"location":"uri","locationName":"accessPolicyId"}}},"output":{"type":"structure","required":["accessPolicyId","accessPolicyArn","accessPolicyIdentity","accessPolicyResource","accessPolicyPermission","accessPolicyCreationDate","accessPolicyLastUpdateDate"],"members":{"accessPolicyId":{},"accessPolicyArn":{},"accessPolicyIdentity":{"shape":"S2k"},"accessPolicyResource":{"shape":"S2r"},"accessPolicyPermission":{},"accessPolicyCreationDate":{"type":"timestamp"},"accessPolicyLastUpdateDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"monitor."}},"DescribeAsset":{"http":{"method":"GET","requestUri":"/assets/{assetId}"},"input":{"type":"structure","required":["assetId"],"members":{"assetId":{"location":"uri","locationName":"assetId"}}},"output":{"type":"structure","required":["assetId","assetArn","assetName","assetModelId","assetProperties","assetHierarchies","assetCreationDate","assetLastUpdateDate","assetStatus"],"members":{"assetId":{},"assetArn":{},"assetName":{},"assetModelId":{},"assetProperties":{"shape":"S5h"},"assetHierarchies":{"shape":"S5m"},"assetCompositeModels":{"type":"list","member":{"type":"structure","required":["name","type","properties"],"members":{"name":{},"description":{},"type":{},"properties":{"shape":"S5h"}}}},"assetCreationDate":{"type":"timestamp"},"assetLastUpdateDate":{"type":"timestamp"},"assetStatus":{"shape":"S32"}}},"endpoint":{"hostPrefix":"api."}},"DescribeAssetModel":{"http":{"method":"GET","requestUri":"/asset-models/{assetModelId}"},"input":{"type":"structure","required":["assetModelId"],"members":{"assetModelId":{"location":"uri","locationName":"assetModelId"}}},"output":{"type":"structure","required":["assetModelId","assetModelArn","assetModelName","assetModelDescription","assetModelProperties","assetModelHierarchies","assetModelCreationDate","assetModelLastUpdateDate","assetModelStatus"],"members":{"assetModelId":{},"assetModelArn":{},"assetModelName":{},"assetModelDescription":{},"assetModelProperties":{"shape":"S5s"},"assetModelHierarchies":{"shape":"S5u"},"assetModelCompositeModels":{"shape":"S5w"},"assetModelCreationDate":{"type":"timestamp"},"assetModelLastUpdateDate":{"type":"timestamp"},"assetModelStatus":{"shape":"S47"}}},"endpoint":{"hostPrefix":"api."}},"DescribeAssetProperty":{"http":{"method":"GET","requestUri":"/assets/{assetId}/properties/{propertyId}"},"input":{"type":"structure","required":["assetId","propertyId"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"propertyId":{"location":"uri","locationName":"propertyId"}}},"output":{"type":"structure","required":["assetId","assetName","assetModelId"],"members":{"assetId":{},"assetName":{},"assetModelId":{},"assetProperty":{"shape":"S60"},"compositeModel":{"type":"structure","required":["name","type","assetProperty"],"members":{"name":{},"type":{},"assetProperty":{"shape":"S60"}}}}},"endpoint":{"hostPrefix":"api."}},"DescribeDashboard":{"http":{"method":"GET","requestUri":"/dashboards/{dashboardId}","responseCode":200},"input":{"type":"structure","required":["dashboardId"],"members":{"dashboardId":{"location":"uri","locationName":"dashboardId"}}},"output":{"type":"structure","required":["dashboardId","dashboardArn","dashboardName","projectId","dashboardDefinition","dashboardCreationDate","dashboardLastUpdateDate"],"members":{"dashboardId":{},"dashboardArn":{},"dashboardName":{},"projectId":{},"dashboardDescription":{},"dashboardDefinition":{},"dashboardCreationDate":{"type":"timestamp"},"dashboardLastUpdateDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"monitor."}},"DescribeDefaultEncryptionConfiguration":{"http":{"method":"GET","requestUri":"/configuration/account/encryption"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["encryptionType","configurationStatus"],"members":{"encryptionType":{},"kmsKeyArn":{},"configurationStatus":{"shape":"S67"}}},"endpoint":{"hostPrefix":"api."}},"DescribeGateway":{"http":{"method":"GET","requestUri":"/20200301/gateways/{gatewayId}"},"input":{"type":"structure","required":["gatewayId"],"members":{"gatewayId":{"location":"uri","locationName":"gatewayId"}}},"output":{"type":"structure","required":["gatewayId","gatewayName","gatewayArn","gatewayCapabilitySummaries","creationDate","lastUpdateDate"],"members":{"gatewayId":{},"gatewayName":{},"gatewayArn":{},"gatewayPlatform":{"shape":"S4d"},"gatewayCapabilitySummaries":{"shape":"S6c"},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"DescribeGatewayCapabilityConfiguration":{"http":{"method":"GET","requestUri":"/20200301/gateways/{gatewayId}/capability/{capabilityNamespace}"},"input":{"type":"structure","required":["gatewayId","capabilityNamespace"],"members":{"gatewayId":{"location":"uri","locationName":"gatewayId"},"capabilityNamespace":{"location":"uri","locationName":"capabilityNamespace"}}},"output":{"type":"structure","required":["gatewayId","capabilityNamespace","capabilityConfiguration","capabilitySyncStatus"],"members":{"gatewayId":{},"capabilityNamespace":{},"capabilityConfiguration":{},"capabilitySyncStatus":{}}},"endpoint":{"hostPrefix":"api."}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S6l"}}},"endpoint":{"hostPrefix":"api."}},"DescribePortal":{"http":{"method":"GET","requestUri":"/portals/{portalId}","responseCode":200},"input":{"type":"structure","required":["portalId"],"members":{"portalId":{"location":"uri","locationName":"portalId"}}},"output":{"type":"structure","required":["portalId","portalArn","portalName","portalClientId","portalStartUrl","portalContactEmail","portalStatus","portalCreationDate","portalLastUpdateDate"],"members":{"portalId":{},"portalArn":{},"portalName":{},"portalDescription":{},"portalClientId":{},"portalStartUrl":{},"portalContactEmail":{},"portalStatus":{"shape":"S4r"},"portalCreationDate":{"type":"timestamp"},"portalLastUpdateDate":{"type":"timestamp"},"portalLogoImageLocation":{"type":"structure","required":["id","url"],"members":{"id":{},"url":{}}},"roleArn":{},"portalAuthMode":{},"notificationSenderEmail":{},"alarms":{"shape":"S4o"}}},"endpoint":{"hostPrefix":"monitor."}},"DescribeProject":{"http":{"method":"GET","requestUri":"/projects/{projectId}","responseCode":200},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"}}},"output":{"type":"structure","required":["projectId","projectArn","projectName","portalId","projectCreationDate","projectLastUpdateDate"],"members":{"projectId":{},"projectArn":{},"projectName":{},"portalId":{},"projectDescription":{},"projectCreationDate":{"type":"timestamp"},"projectLastUpdateDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"monitor."}},"DescribeStorageConfiguration":{"http":{"method":"GET","requestUri":"/configuration/account/storage"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["storageType","configurationStatus"],"members":{"storageType":{},"multiLayerStorage":{"shape":"S6w"},"disassociatedDataStorage":{},"retentionPeriod":{"shape":"S6z"},"configurationStatus":{"shape":"S67"},"lastUpdateDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"DescribeTimeSeries":{"http":{"method":"GET","requestUri":"/timeseries/describe/"},"input":{"type":"structure","members":{"alias":{"location":"querystring","locationName":"alias"},"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"}}},"output":{"type":"structure","required":["timeSeriesId","dataType","timeSeriesCreationDate","timeSeriesLastUpdateDate"],"members":{"assetId":{},"propertyId":{},"alias":{},"timeSeriesId":{},"dataType":{},"dataTypeSpec":{},"timeSeriesCreationDate":{"type":"timestamp"},"timeSeriesLastUpdateDate":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"DisassociateAssets":{"http":{"requestUri":"/assets/{assetId}/disassociate"},"input":{"type":"structure","required":["assetId","hierarchyId","childAssetId"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"hierarchyId":{},"childAssetId":{},"clientToken":{"idempotencyToken":true}}},"endpoint":{"hostPrefix":"api."}},"DisassociateTimeSeriesFromAssetProperty":{"http":{"requestUri":"/timeseries/disassociate/"},"input":{"type":"structure","required":["alias","assetId","propertyId"],"members":{"alias":{"location":"querystring","locationName":"alias"},"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"clientToken":{"idempotencyToken":true}}},"endpoint":{"hostPrefix":"api."}},"GetAssetPropertyAggregates":{"http":{"method":"GET","requestUri":"/properties/aggregates"},"input":{"type":"structure","required":["aggregateTypes","resolution","startDate","endDate"],"members":{"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"propertyAlias":{"location":"querystring","locationName":"propertyAlias"},"aggregateTypes":{"shape":"Sl","location":"querystring","locationName":"aggregateTypes"},"resolution":{"location":"querystring","locationName":"resolution"},"qualities":{"shape":"Sp","location":"querystring","locationName":"qualities"},"startDate":{"location":"querystring","locationName":"startDate","type":"timestamp"},"endDate":{"location":"querystring","locationName":"endDate","type":"timestamp"},"timeOrdering":{"location":"querystring","locationName":"timeOrdering"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["aggregatedValues"],"members":{"aggregatedValues":{"shape":"S11"},"nextToken":{}}},"endpoint":{"hostPrefix":"data."}},"GetAssetPropertyValue":{"http":{"method":"GET","requestUri":"/properties/latest"},"input":{"type":"structure","members":{"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"propertyAlias":{"location":"querystring","locationName":"propertyAlias"}}},"output":{"type":"structure","members":{"propertyValue":{"shape":"S1i"}}},"endpoint":{"hostPrefix":"data."}},"GetAssetPropertyValueHistory":{"http":{"method":"GET","requestUri":"/properties/history"},"input":{"type":"structure","members":{"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"propertyAlias":{"location":"querystring","locationName":"propertyAlias"},"startDate":{"location":"querystring","locationName":"startDate","type":"timestamp"},"endDate":{"location":"querystring","locationName":"endDate","type":"timestamp"},"qualities":{"shape":"Sp","location":"querystring","locationName":"qualities"},"timeOrdering":{"location":"querystring","locationName":"timeOrdering"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["assetPropertyValueHistory"],"members":{"assetPropertyValueHistory":{"shape":"S24"},"nextToken":{}}},"endpoint":{"hostPrefix":"data."}},"GetInterpolatedAssetPropertyValues":{"http":{"method":"GET","requestUri":"/properties/interpolated"},"input":{"type":"structure","required":["startTimeInSeconds","endTimeInSeconds","quality","intervalInSeconds","type"],"members":{"assetId":{"location":"querystring","locationName":"assetId"},"propertyId":{"location":"querystring","locationName":"propertyId"},"propertyAlias":{"location":"querystring","locationName":"propertyAlias"},"startTimeInSeconds":{"location":"querystring","locationName":"startTimeInSeconds","type":"long"},"startTimeOffsetInNanos":{"location":"querystring","locationName":"startTimeOffsetInNanos","type":"integer"},"endTimeInSeconds":{"location":"querystring","locationName":"endTimeInSeconds","type":"long"},"endTimeOffsetInNanos":{"location":"querystring","locationName":"endTimeOffsetInNanos","type":"integer"},"quality":{"location":"querystring","locationName":"quality"},"intervalInSeconds":{"location":"querystring","locationName":"intervalInSeconds","type":"long"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"type":{"location":"querystring","locationName":"type"},"intervalWindowInSeconds":{"location":"querystring","locationName":"intervalWindowInSeconds","type":"long"}}},"output":{"type":"structure","required":["interpolatedAssetPropertyValues"],"members":{"interpolatedAssetPropertyValues":{"type":"list","member":{"type":"structure","required":["timestamp","value"],"members":{"timestamp":{"shape":"S1o"},"value":{"shape":"S1j"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"data."}},"ListAccessPolicies":{"http":{"method":"GET","requestUri":"/access-policies","responseCode":200},"input":{"type":"structure","members":{"identityType":{"location":"querystring","locationName":"identityType"},"identityId":{"location":"querystring","locationName":"identityId"},"resourceType":{"location":"querystring","locationName":"resourceType"},"resourceId":{"location":"querystring","locationName":"resourceId"},"iamArn":{"location":"querystring","locationName":"iamArn"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["accessPolicySummaries"],"members":{"accessPolicySummaries":{"type":"list","member":{"type":"structure","required":["id","identity","resource","permission"],"members":{"id":{},"identity":{"shape":"S2k"},"resource":{"shape":"S2r"},"permission":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"monitor."}},"ListAssetModels":{"http":{"method":"GET","requestUri":"/asset-models"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["assetModelSummaries"],"members":{"assetModelSummaries":{"type":"list","member":{"type":"structure","required":["id","arn","name","description","creationDate","lastUpdateDate","status"],"members":{"id":{},"arn":{},"name":{},"description":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"},"status":{"shape":"S47"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListAssetRelationships":{"http":{"method":"GET","requestUri":"/assets/{assetId}/assetRelationships"},"input":{"type":"structure","required":["assetId","traversalType"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"traversalType":{"location":"querystring","locationName":"traversalType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["assetRelationshipSummaries"],"members":{"assetRelationshipSummaries":{"type":"list","member":{"type":"structure","required":["relationshipType"],"members":{"hierarchyInfo":{"type":"structure","members":{"parentAssetId":{},"childAssetId":{}}},"relationshipType":{}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListAssets":{"http":{"method":"GET","requestUri":"/assets"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"assetModelId":{"location":"querystring","locationName":"assetModelId"},"filter":{"location":"querystring","locationName":"filter"}}},"output":{"type":"structure","required":["assetSummaries"],"members":{"assetSummaries":{"type":"list","member":{"type":"structure","required":["id","arn","name","assetModelId","creationDate","lastUpdateDate","status","hierarchies"],"members":{"id":{},"arn":{},"name":{},"assetModelId":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"},"status":{"shape":"S32"},"hierarchies":{"shape":"S5m"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListAssociatedAssets":{"http":{"method":"GET","requestUri":"/assets/{assetId}/hierarchies"},"input":{"type":"structure","required":["assetId"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"hierarchyId":{"location":"querystring","locationName":"hierarchyId"},"traversalDirection":{"location":"querystring","locationName":"traversalDirection"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["assetSummaries"],"members":{"assetSummaries":{"type":"list","member":{"type":"structure","required":["id","arn","name","assetModelId","creationDate","lastUpdateDate","status","hierarchies"],"members":{"id":{},"arn":{},"name":{},"assetModelId":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"},"status":{"shape":"S32"},"hierarchies":{"shape":"S5m"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListDashboards":{"http":{"method":"GET","requestUri":"/dashboards","responseCode":200},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"querystring","locationName":"projectId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["dashboardSummaries"],"members":{"dashboardSummaries":{"type":"list","member":{"type":"structure","required":["id","name"],"members":{"id":{},"name":{},"description":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"monitor."}},"ListGateways":{"http":{"method":"GET","requestUri":"/20200301/gateways"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["gatewaySummaries"],"members":{"gatewaySummaries":{"type":"list","member":{"type":"structure","required":["gatewayId","gatewayName","creationDate","lastUpdateDate"],"members":{"gatewayId":{},"gatewayName":{},"gatewayPlatform":{"shape":"S4d"},"gatewayCapabilitySummaries":{"shape":"S6c"},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListPortals":{"http":{"method":"GET","requestUri":"/portals","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"portalSummaries":{"type":"list","member":{"type":"structure","required":["id","name","startUrl","status"],"members":{"id":{},"name":{},"description":{},"startUrl":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"},"roleArn":{},"status":{"shape":"S4r"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"monitor."}},"ListProjectAssets":{"http":{"method":"GET","requestUri":"/projects/{projectId}/assets","responseCode":200},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["assetIds"],"members":{"assetIds":{"type":"list","member":{}},"nextToken":{}}},"endpoint":{"hostPrefix":"monitor."}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects","responseCode":200},"input":{"type":"structure","required":["portalId"],"members":{"portalId":{"location":"querystring","locationName":"portalId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["projectSummaries"],"members":{"projectSummaries":{"type":"list","member":{"type":"structure","required":["id","name"],"members":{"id":{},"name":{},"description":{},"creationDate":{"type":"timestamp"},"lastUpdateDate":{"type":"timestamp"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"monitor."}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S2v"}}},"endpoint":{"hostPrefix":"api."}},"ListTimeSeries":{"http":{"method":"GET","requestUri":"/timeseries/"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"assetId":{"location":"querystring","locationName":"assetId"},"aliasPrefix":{"location":"querystring","locationName":"aliasPrefix"},"timeSeriesType":{"location":"querystring","locationName":"timeSeriesType"}}},"output":{"type":"structure","required":["TimeSeriesSummaries"],"members":{"TimeSeriesSummaries":{"type":"list","member":{"type":"structure","required":["timeSeriesId","dataType","timeSeriesCreationDate","timeSeriesLastUpdateDate"],"members":{"assetId":{},"propertyId":{},"alias":{},"timeSeriesId":{},"dataType":{},"dataTypeSpec":{},"timeSeriesCreationDate":{"type":"timestamp"},"timeSeriesLastUpdateDate":{"type":"timestamp"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"PutDefaultEncryptionConfiguration":{"http":{"requestUri":"/configuration/account/encryption"},"input":{"type":"structure","required":["encryptionType"],"members":{"encryptionType":{},"kmsKeyId":{}}},"output":{"type":"structure","required":["encryptionType","configurationStatus"],"members":{"encryptionType":{},"kmsKeyArn":{},"configurationStatus":{"shape":"S67"}}},"endpoint":{"hostPrefix":"api."}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S6l"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"PutStorageConfiguration":{"http":{"requestUri":"/configuration/account/storage"},"input":{"type":"structure","required":["storageType"],"members":{"storageType":{},"multiLayerStorage":{"shape":"S6w"},"disassociatedDataStorage":{},"retentionPeriod":{"shape":"S6z"}}},"output":{"type":"structure","required":["storageType","configurationStatus"],"members":{"storageType":{},"multiLayerStorage":{"shape":"S6w"},"disassociatedDataStorage":{},"retentionPeriod":{"shape":"S6z"},"configurationStatus":{"shape":"S67"}}},"endpoint":{"hostPrefix":"api."}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"S2v"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"UpdateAccessPolicy":{"http":{"method":"PUT","requestUri":"/access-policies/{accessPolicyId}","responseCode":200},"input":{"type":"structure","required":["accessPolicyId","accessPolicyIdentity","accessPolicyResource","accessPolicyPermission"],"members":{"accessPolicyId":{"location":"uri","locationName":"accessPolicyId"},"accessPolicyIdentity":{"shape":"S2k"},"accessPolicyResource":{"shape":"S2r"},"accessPolicyPermission":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"monitor."}},"UpdateAsset":{"http":{"method":"PUT","requestUri":"/assets/{assetId}","responseCode":202},"input":{"type":"structure","required":["assetId","assetName"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"assetName":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["assetStatus"],"members":{"assetStatus":{"shape":"S32"}}},"endpoint":{"hostPrefix":"api."}},"UpdateAssetModel":{"http":{"method":"PUT","requestUri":"/asset-models/{assetModelId}","responseCode":202},"input":{"type":"structure","required":["assetModelId","assetModelName"],"members":{"assetModelId":{"location":"uri","locationName":"assetModelId"},"assetModelName":{},"assetModelDescription":{},"assetModelProperties":{"shape":"S5s"},"assetModelHierarchies":{"shape":"S5u"},"assetModelCompositeModels":{"shape":"S5w"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["assetModelStatus"],"members":{"assetModelStatus":{"shape":"S47"}}},"endpoint":{"hostPrefix":"api."}},"UpdateAssetProperty":{"http":{"method":"PUT","requestUri":"/assets/{assetId}/properties/{propertyId}"},"input":{"type":"structure","required":["assetId","propertyId"],"members":{"assetId":{"location":"uri","locationName":"assetId"},"propertyId":{"location":"uri","locationName":"propertyId"},"propertyAlias":{},"propertyNotificationState":{},"clientToken":{"idempotencyToken":true}}},"endpoint":{"hostPrefix":"api."}},"UpdateDashboard":{"http":{"method":"PUT","requestUri":"/dashboards/{dashboardId}","responseCode":200},"input":{"type":"structure","required":["dashboardId","dashboardName","dashboardDefinition"],"members":{"dashboardId":{"location":"uri","locationName":"dashboardId"},"dashboardName":{},"dashboardDescription":{},"dashboardDefinition":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"monitor."}},"UpdateGateway":{"http":{"method":"PUT","requestUri":"/20200301/gateways/{gatewayId}"},"input":{"type":"structure","required":["gatewayId","gatewayName"],"members":{"gatewayId":{"location":"uri","locationName":"gatewayId"},"gatewayName":{}}},"endpoint":{"hostPrefix":"api."}},"UpdateGatewayCapabilityConfiguration":{"http":{"requestUri":"/20200301/gateways/{gatewayId}/capability","responseCode":201},"input":{"type":"structure","required":["gatewayId","capabilityNamespace","capabilityConfiguration"],"members":{"gatewayId":{"location":"uri","locationName":"gatewayId"},"capabilityNamespace":{},"capabilityConfiguration":{}}},"output":{"type":"structure","required":["capabilityNamespace","capabilitySyncStatus"],"members":{"capabilityNamespace":{},"capabilitySyncStatus":{}}},"endpoint":{"hostPrefix":"api."}},"UpdatePortal":{"http":{"method":"PUT","requestUri":"/portals/{portalId}","responseCode":202},"input":{"type":"structure","required":["portalId","portalName","portalContactEmail","roleArn"],"members":{"portalId":{"location":"uri","locationName":"portalId"},"portalName":{},"portalDescription":{},"portalContactEmail":{},"portalLogoImage":{"type":"structure","members":{"id":{},"file":{"shape":"S4k"}}},"roleArn":{},"clientToken":{"idempotencyToken":true},"notificationSenderEmail":{},"alarms":{"shape":"S4o"}}},"output":{"type":"structure","required":["portalStatus"],"members":{"portalStatus":{"shape":"S4r"}}},"endpoint":{"hostPrefix":"monitor."}},"UpdateProject":{"http":{"method":"PUT","requestUri":"/projects/{projectId}","responseCode":200},"input":{"type":"structure","required":["projectId","projectName"],"members":{"projectId":{"location":"uri","locationName":"projectId"},"projectName":{},"projectDescription":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"monitor."}}},"shapes":{"S7":{"type":"list","member":{}},"Sa":{"type":"structure","required":["assetId","code","message"],"members":{"assetId":{},"code":{},"message":{}}},"Sl":{"type":"list","member":{}},"Sp":{"type":"list","member":{}},"S11":{"type":"list","member":{"type":"structure","required":["timestamp","value"],"members":{"timestamp":{"type":"timestamp"},"quality":{},"value":{"type":"structure","members":{"average":{"type":"double"},"count":{"type":"double"},"maximum":{"type":"double"},"minimum":{"type":"double"},"sum":{"type":"double"},"standardDeviation":{"type":"double"}}}}}},"S1i":{"type":"structure","required":["value","timestamp"],"members":{"value":{"shape":"S1j"},"timestamp":{"shape":"S1o"},"quality":{}}},"S1j":{"type":"structure","members":{"stringValue":{},"integerValue":{"type":"integer"},"doubleValue":{"type":"double"},"booleanValue":{"type":"boolean"}}},"S1o":{"type":"structure","required":["timeInSeconds"],"members":{"timeInSeconds":{"type":"long"},"offsetInNanos":{"type":"integer"}}},"S24":{"type":"list","member":{"shape":"S1i"}},"S2k":{"type":"structure","members":{"user":{"type":"structure","required":["id"],"members":{"id":{}}},"group":{"type":"structure","required":["id"],"members":{"id":{}}},"iamUser":{"type":"structure","required":["arn"],"members":{"arn":{}}},"iamRole":{"type":"structure","required":["arn"],"members":{"arn":{}}}}},"S2r":{"type":"structure","members":{"portal":{"type":"structure","required":["id"],"members":{"id":{}}},"project":{"type":"structure","required":["id"],"members":{"id":{}}}}},"S2v":{"type":"map","key":{},"value":{}},"S32":{"type":"structure","required":["state"],"members":{"state":{},"error":{"shape":"S34"}}},"S34":{"type":"structure","required":["code","message"],"members":{"code":{},"message":{},"details":{"type":"list","member":{"type":"structure","required":["code","message"],"members":{"code":{},"message":{}}}}}},"S3c":{"type":"list","member":{"type":"structure","required":["name","dataType","type"],"members":{"name":{},"dataType":{},"dataTypeSpec":{},"unit":{},"type":{"shape":"S3g"}}}},"S3g":{"type":"structure","members":{"attribute":{"type":"structure","members":{"defaultValue":{}}},"measurement":{"type":"structure","members":{"processingConfig":{"type":"structure","required":["forwardingConfig"],"members":{"forwardingConfig":{"shape":"S3l"}}}}},"transform":{"type":"structure","required":["expression","variables"],"members":{"expression":{},"variables":{"shape":"S3p"},"processingConfig":{"type":"structure","required":["computeLocation"],"members":{"computeLocation":{},"forwardingConfig":{"shape":"S3l"}}}}},"metric":{"type":"structure","required":["expression","variables","window"],"members":{"expression":{},"variables":{"shape":"S3p"},"window":{"type":"structure","members":{"tumbling":{"type":"structure","required":["interval"],"members":{"interval":{},"offset":{}}}}},"processingConfig":{"type":"structure","required":["computeLocation"],"members":{"computeLocation":{}}}}}}},"S3l":{"type":"structure","required":["state"],"members":{"state":{}}},"S3p":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"type":"structure","required":["propertyId"],"members":{"propertyId":{},"hierarchyId":{}}}}}},"S47":{"type":"structure","required":["state"],"members":{"state":{},"error":{"shape":"S34"}}},"S4d":{"type":"structure","members":{"greengrass":{"type":"structure","required":["groupArn"],"members":{"groupArn":{}}},"greengrassV2":{"type":"structure","required":["coreDeviceThingName"],"members":{"coreDeviceThingName":{}}}}},"S4k":{"type":"structure","required":["data","type"],"members":{"data":{"type":"blob"},"type":{}}},"S4o":{"type":"structure","required":["alarmRoleArn"],"members":{"alarmRoleArn":{},"notificationLambdaArn":{}}},"S4r":{"type":"structure","required":["state"],"members":{"state":{},"error":{"type":"structure","members":{"code":{},"message":{}}}}},"S5h":{"type":"list","member":{"type":"structure","required":["id","name","dataType"],"members":{"id":{},"name":{},"alias":{},"notification":{"shape":"S5j"},"dataType":{},"dataTypeSpec":{},"unit":{}}}},"S5j":{"type":"structure","required":["topic","state"],"members":{"topic":{},"state":{}}},"S5m":{"type":"list","member":{"type":"structure","required":["name"],"members":{"id":{},"name":{}}}},"S5s":{"type":"list","member":{"type":"structure","required":["name","dataType","type"],"members":{"id":{},"name":{},"dataType":{},"dataTypeSpec":{},"unit":{},"type":{"shape":"S3g"}}}},"S5u":{"type":"list","member":{"type":"structure","required":["name","childAssetModelId"],"members":{"id":{},"name":{},"childAssetModelId":{}}}},"S5w":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"description":{},"type":{},"properties":{"shape":"S5s"}}}},"S60":{"type":"structure","required":["id","name","dataType"],"members":{"id":{},"name":{},"alias":{},"notification":{"shape":"S5j"},"dataType":{},"unit":{},"type":{"shape":"S3g"}}},"S67":{"type":"structure","required":["state"],"members":{"state":{},"error":{"type":"structure","required":["code","message"],"members":{"code":{},"message":{}}}}},"S6c":{"type":"list","member":{"type":"structure","required":["capabilityNamespace","capabilitySyncStatus"],"members":{"capabilityNamespace":{},"capabilitySyncStatus":{}}}},"S6l":{"type":"structure","required":["level"],"members":{"level":{}}},"S6w":{"type":"structure","required":["customerManagedS3Storage"],"members":{"customerManagedS3Storage":{"type":"structure","required":["s3ResourceArn","roleArn"],"members":{"s3ResourceArn":{},"roleArn":{}}}}},"S6z":{"type":"structure","members":{"numberOfDays":{"type":"integer"},"unlimited":{"type":"boolean"}}}}}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"BatchGetAssetPropertyAggregates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"BatchGetAssetPropertyValue":{"input_token":"nextToken","output_token":"nextToken"},"BatchGetAssetPropertyValueHistory":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetAssetPropertyAggregates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"aggregatedValues"},"GetAssetPropertyValueHistory":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assetPropertyValueHistory"},"GetInterpolatedAssetPropertyValues":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"interpolatedAssetPropertyValues"},"ListAccessPolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"accessPolicySummaries"},"ListAssetModels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assetModelSummaries"},"ListAssetRelationships":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assetRelationshipSummaries"},"ListAssets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assetSummaries"},"ListAssociatedAssets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assetSummaries"},"ListDashboards":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"dashboardSummaries"},"ListGateways":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"gatewaySummaries"},"ListPortals":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"portalSummaries"},"ListProjectAssets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assetIds"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"projectSummaries"},"ListTimeSeries":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"TimeSeriesSummaries"}}}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"AssetModelNotExists":{"delay":3,"maxAttempts":20,"operation":"DescribeAssetModel","acceptors":[{"state":"success","matcher":"error","expected":"ResourceNotFoundException"}]},"AssetModelActive":{"delay":3,"maxAttempts":20,"operation":"DescribeAssetModel","acceptors":[{"state":"success","matcher":"path","argument":"assetModelStatus.state","expected":"ACTIVE"},{"state":"failure","matcher":"path","argument":"assetModelStatus.state","expected":"FAILED"}]},"AssetNotExists":{"delay":3,"maxAttempts":20,"operation":"DescribeAsset","acceptors":[{"state":"success","matcher":"error","expected":"ResourceNotFoundException"}]},"AssetActive":{"delay":3,"maxAttempts":20,"operation":"DescribeAsset","acceptors":[{"state":"success","matcher":"path","argument":"assetStatus.state","expected":"ACTIVE"},{"state":"failure","matcher":"path","argument":"assetStatus.state","expected":"FAILED"}]},"PortalNotExists":{"delay":3,"maxAttempts":20,"operation":"DescribePortal","acceptors":[{"state":"success","matcher":"error","expected":"ResourceNotFoundException"}]},"PortalActive":{"delay":3,"maxAttempts":20,"operation":"DescribePortal","acceptors":[{"state":"success","matcher":"path","argument":"portalStatus.state","expected":"ACTIVE"}]}}}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['macie2'] = {};
	AWS.Macie2 = Service.defineService('macie2', ['2020-01-01']);
	Object.defineProperty(apiLoader.services['macie2'], '2020-01-01', {
	  get: function get() {
	    var model = __webpack_require__(882);
	    model.paginators = __webpack_require__(883).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Macie2;


/***/ }),
/* 882 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2020-01-01","endpointPrefix":"macie2","signingName":"macie2","serviceFullName":"Amazon Macie 2","serviceId":"Macie2","protocol":"rest-json","jsonVersion":"1.1","uid":"macie2-2020-01-01","signatureVersion":"v4"},"operations":{"AcceptInvitation":{"http":{"requestUri":"/invitations/accept","responseCode":200},"input":{"type":"structure","members":{"administratorAccountId":{"locationName":"administratorAccountId"},"invitationId":{"locationName":"invitationId"},"masterAccount":{"locationName":"masterAccount"}},"required":["invitationId"]},"output":{"type":"structure","members":{}}},"BatchGetCustomDataIdentifiers":{"http":{"requestUri":"/custom-data-identifiers/get","responseCode":200},"input":{"type":"structure","members":{"ids":{"shape":"S5","locationName":"ids"}}},"output":{"type":"structure","members":{"customDataIdentifiers":{"locationName":"customDataIdentifiers","type":"list","member":{"type":"structure","members":{"arn":{"locationName":"arn"},"createdAt":{"shape":"S9","locationName":"createdAt"},"deleted":{"locationName":"deleted","type":"boolean"},"description":{"locationName":"description"},"id":{"locationName":"id"},"name":{"locationName":"name"}}}},"notFoundIdentifierIds":{"shape":"S5","locationName":"notFoundIdentifierIds"}}}},"CreateClassificationJob":{"http":{"requestUri":"/jobs","responseCode":200},"input":{"type":"structure","members":{"clientToken":{"locationName":"clientToken","idempotencyToken":true},"customDataIdentifierIds":{"shape":"S5","locationName":"customDataIdentifierIds"},"description":{"locationName":"description"},"initialRun":{"locationName":"initialRun","type":"boolean"},"jobType":{"locationName":"jobType"},"managedDataIdentifierIds":{"shape":"S5","locationName":"managedDataIdentifierIds"},"managedDataIdentifierSelector":{"locationName":"managedDataIdentifierSelector"},"name":{"locationName":"name"},"s3JobDefinition":{"shape":"Se","locationName":"s3JobDefinition"},"samplingPercentage":{"locationName":"samplingPercentage","type":"integer"},"scheduleFrequency":{"shape":"S12","locationName":"scheduleFrequency"},"tags":{"shape":"S17","locationName":"tags"}},"required":["s3JobDefinition","jobType","clientToken","name"]},"output":{"type":"structure","members":{"jobArn":{"locationName":"jobArn"},"jobId":{"locationName":"jobId"}}}},"CreateCustomDataIdentifier":{"http":{"requestUri":"/custom-data-identifiers","responseCode":200},"input":{"type":"structure","members":{"clientToken":{"locationName":"clientToken","idempotencyToken":true},"description":{"locationName":"description"},"ignoreWords":{"shape":"S5","locationName":"ignoreWords"},"keywords":{"shape":"S5","locationName":"keywords"},"maximumMatchDistance":{"locationName":"maximumMatchDistance","type":"integer"},"name":{"locationName":"name"},"regex":{"locationName":"regex"},"severityLevels":{"shape":"S1a","locationName":"severityLevels"},"tags":{"shape":"S17","locationName":"tags"}},"required":["name","regex"]},"output":{"type":"structure","members":{"customDataIdentifierId":{"locationName":"customDataIdentifierId"}}}},"CreateFindingsFilter":{"http":{"requestUri":"/findingsfilters","responseCode":200},"input":{"type":"structure","members":{"action":{"locationName":"action"},"clientToken":{"locationName":"clientToken","idempotencyToken":true},"description":{"locationName":"description"},"findingCriteria":{"shape":"S1h","locationName":"findingCriteria"},"name":{"locationName":"name"},"position":{"locationName":"position","type":"integer"},"tags":{"shape":"S17","locationName":"tags"}},"required":["action","findingCriteria","name"]},"output":{"type":"structure","members":{"arn":{"locationName":"arn"},"id":{"locationName":"id"}}}},"CreateInvitations":{"http":{"requestUri":"/invitations","responseCode":200},"input":{"type":"structure","members":{"accountIds":{"shape":"S5","locationName":"accountIds"},"disableEmailNotification":{"locationName":"disableEmailNotification","type":"boolean"},"message":{"locationName":"message"}},"required":["accountIds"]},"output":{"type":"structure","members":{"unprocessedAccounts":{"shape":"S1n","locationName":"unprocessedAccounts"}}}},"CreateMember":{"http":{"requestUri":"/members","responseCode":200},"input":{"type":"structure","members":{"account":{"locationName":"account","type":"structure","members":{"accountId":{"locationName":"accountId"},"email":{"locationName":"email"}},"required":["email","accountId"]},"tags":{"shape":"S17","locationName":"tags"}},"required":["account"]},"output":{"type":"structure","members":{"arn":{"locationName":"arn"}}}},"CreateSampleFindings":{"http":{"requestUri":"/findings/sample","responseCode":200},"input":{"type":"structure","members":{"findingTypes":{"locationName":"findingTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeclineInvitations":{"http":{"requestUri":"/invitations/decline","responseCode":200},"input":{"type":"structure","members":{"accountIds":{"shape":"S5","locationName":"accountIds"}},"required":["accountIds"]},"output":{"type":"structure","members":{"unprocessedAccounts":{"shape":"S1n","locationName":"unprocessedAccounts"}}}},"DeleteCustomDataIdentifier":{"http":{"method":"DELETE","requestUri":"/custom-data-identifiers/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{}}},"DeleteFindingsFilter":{"http":{"method":"DELETE","requestUri":"/findingsfilters/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{}}},"DeleteInvitations":{"http":{"requestUri":"/invitations/delete","responseCode":200},"input":{"type":"structure","members":{"accountIds":{"shape":"S5","locationName":"accountIds"}},"required":["accountIds"]},"output":{"type":"structure","members":{"unprocessedAccounts":{"shape":"S1n","locationName":"unprocessedAccounts"}}}},"DeleteMember":{"http":{"method":"DELETE","requestUri":"/members/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{}}},"DescribeBuckets":{"http":{"requestUri":"/datasources/s3","responseCode":200},"input":{"type":"structure","members":{"criteria":{"locationName":"criteria","type":"map","key":{},"value":{"type":"structure","members":{"eq":{"shape":"S5","locationName":"eq"},"gt":{"locationName":"gt","type":"long"},"gte":{"locationName":"gte","type":"long"},"lt":{"locationName":"lt","type":"long"},"lte":{"locationName":"lte","type":"long"},"neq":{"shape":"S5","locationName":"neq"},"prefix":{"locationName":"prefix"}}}},"maxResults":{"locationName":"maxResults","type":"integer"},"nextToken":{"locationName":"nextToken"},"sortCriteria":{"locationName":"sortCriteria","type":"structure","members":{"attributeName":{"locationName":"attributeName"},"orderBy":{"locationName":"orderBy"}}}}},"output":{"type":"structure","members":{"buckets":{"locationName":"buckets","type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"allowsUnencryptedObjectUploads":{"locationName":"allowsUnencryptedObjectUploads"},"bucketArn":{"locationName":"bucketArn"},"bucketCreatedAt":{"shape":"S9","locationName":"bucketCreatedAt"},"bucketName":{"locationName":"bucketName"},"classifiableObjectCount":{"locationName":"classifiableObjectCount","type":"long"},"classifiableSizeInBytes":{"locationName":"classifiableSizeInBytes","type":"long"},"errorCode":{"locationName":"errorCode"},"errorMessage":{"locationName":"errorMessage"},"jobDetails":{"shape":"S2h","locationName":"jobDetails"},"lastUpdated":{"shape":"S9","locationName":"lastUpdated"},"objectCount":{"locationName":"objectCount","type":"long"},"objectCountByEncryptionType":{"shape":"S2k","locationName":"objectCountByEncryptionType"},"publicAccess":{"shape":"S2l","locationName":"publicAccess"},"region":{"locationName":"region"},"replicationDetails":{"locationName":"replicationDetails","type":"structure","members":{"replicated":{"locationName":"replicated","type":"boolean"},"replicatedExternally":{"locationName":"replicatedExternally","type":"boolean"},"replicationAccounts":{"shape":"S5","locationName":"replicationAccounts"}}},"serverSideEncryption":{"locationName":"serverSideEncryption","type":"structure","members":{"kmsMasterKeyId":{"locationName":"kmsMasterKeyId"},"type":{"locationName":"type"}}},"sharedAccess":{"locationName":"sharedAccess"},"sizeInBytes":{"locationName":"sizeInBytes","type":"long"},"sizeInBytesCompressed":{"locationName":"sizeInBytesCompressed","type":"long"},"tags":{"locationName":"tags","type":"list","member":{"shape":"S2y"}},"unclassifiableObjectCount":{"shape":"S2z","locationName":"unclassifiableObjectCount"},"unclassifiableObjectSizeInBytes":{"shape":"S2z","locationName":"unclassifiableObjectSizeInBytes"},"versioning":{"locationName":"versioning","type":"boolean"}}}},"nextToken":{"locationName":"nextToken"}}}},"DescribeClassificationJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}","responseCode":200},"input":{"type":"structure","members":{"jobId":{"location":"uri","locationName":"jobId"}},"required":["jobId"]},"output":{"type":"structure","members":{"clientToken":{"locationName":"clientToken","idempotencyToken":true},"createdAt":{"shape":"S9","locationName":"createdAt"},"customDataIdentifierIds":{"shape":"S5","locationName":"customDataIdentifierIds"},"description":{"locationName":"description"},"initialRun":{"locationName":"initialRun","type":"boolean"},"jobArn":{"locationName":"jobArn"},"jobId":{"locationName":"jobId"},"jobStatus":{"locationName":"jobStatus"},"jobType":{"locationName":"jobType"},"lastRunErrorStatus":{"shape":"S33","locationName":"lastRunErrorStatus"},"lastRunTime":{"shape":"S9","locationName":"lastRunTime"},"managedDataIdentifierIds":{"shape":"S5","locationName":"managedDataIdentifierIds"},"managedDataIdentifierSelector":{"locationName":"managedDataIdentifierSelector"},"name":{"locationName":"name"},"s3JobDefinition":{"shape":"Se","locationName":"s3JobDefinition"},"samplingPercentage":{"locationName":"samplingPercentage","type":"integer"},"scheduleFrequency":{"shape":"S12","locationName":"scheduleFrequency"},"statistics":{"locationName":"statistics","type":"structure","members":{"approximateNumberOfObjectsToProcess":{"locationName":"approximateNumberOfObjectsToProcess","type":"double"},"numberOfRuns":{"locationName":"numberOfRuns","type":"double"}}},"tags":{"shape":"S17","locationName":"tags"},"userPausedDetails":{"shape":"S37","locationName":"userPausedDetails"}}}},"DescribeOrganizationConfiguration":{"http":{"method":"GET","requestUri":"/admin/configuration","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"autoEnable":{"locationName":"autoEnable","type":"boolean"},"maxAccountLimitReached":{"locationName":"maxAccountLimitReached","type":"boolean"}}}},"DisableMacie":{"http":{"method":"DELETE","requestUri":"/macie","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisableOrganizationAdminAccount":{"http":{"method":"DELETE","requestUri":"/admin","responseCode":200},"input":{"type":"structure","members":{"adminAccountId":{"location":"querystring","locationName":"adminAccountId"}},"required":["adminAccountId"]},"output":{"type":"structure","members":{}}},"DisassociateFromAdministratorAccount":{"http":{"requestUri":"/administrator/disassociate","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateFromMasterAccount":{"http":{"requestUri":"/master/disassociate","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateMember":{"http":{"requestUri":"/members/disassociate/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{}}},"EnableMacie":{"http":{"requestUri":"/macie","responseCode":200},"input":{"type":"structure","members":{"clientToken":{"locationName":"clientToken","idempotencyToken":true},"findingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"status":{"locationName":"status"}}},"output":{"type":"structure","members":{}}},"EnableOrganizationAdminAccount":{"http":{"requestUri":"/admin","responseCode":200},"input":{"type":"structure","members":{"adminAccountId":{"locationName":"adminAccountId"},"clientToken":{"locationName":"clientToken","idempotencyToken":true}},"required":["adminAccountId"]},"output":{"type":"structure","members":{}}},"GetAdministratorAccount":{"http":{"method":"GET","requestUri":"/administrator","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"administrator":{"shape":"S3s","locationName":"administrator"}}}},"GetBucketStatistics":{"http":{"requestUri":"/datasources/s3/statistics","responseCode":200},"input":{"type":"structure","members":{"accountId":{"locationName":"accountId"}}},"output":{"type":"structure","members":{"bucketCount":{"locationName":"bucketCount","type":"long"},"bucketCountByEffectivePermission":{"locationName":"bucketCountByEffectivePermission","type":"structure","members":{"publiclyAccessible":{"locationName":"publiclyAccessible","type":"long"},"publiclyReadable":{"locationName":"publiclyReadable","type":"long"},"publiclyWritable":{"locationName":"publiclyWritable","type":"long"},"unknown":{"locationName":"unknown","type":"long"}}},"bucketCountByEncryptionType":{"locationName":"bucketCountByEncryptionType","type":"structure","members":{"kmsManaged":{"locationName":"kmsManaged","type":"long"},"s3Managed":{"locationName":"s3Managed","type":"long"},"unencrypted":{"locationName":"unencrypted","type":"long"},"unknown":{"locationName":"unknown","type":"long"}}},"bucketCountByObjectEncryptionRequirement":{"locationName":"bucketCountByObjectEncryptionRequirement","type":"structure","members":{"allowsUnencryptedObjectUploads":{"locationName":"allowsUnencryptedObjectUploads","type":"long"},"deniesUnencryptedObjectUploads":{"locationName":"deniesUnencryptedObjectUploads","type":"long"},"unknown":{"locationName":"unknown","type":"long"}}},"bucketCountBySharedAccessType":{"locationName":"bucketCountBySharedAccessType","type":"structure","members":{"external":{"locationName":"external","type":"long"},"internal":{"locationName":"internal","type":"long"},"notShared":{"locationName":"notShared","type":"long"},"unknown":{"locationName":"unknown","type":"long"}}},"classifiableObjectCount":{"locationName":"classifiableObjectCount","type":"long"},"classifiableSizeInBytes":{"locationName":"classifiableSizeInBytes","type":"long"},"lastUpdated":{"shape":"S9","locationName":"lastUpdated"},"objectCount":{"locationName":"objectCount","type":"long"},"sizeInBytes":{"locationName":"sizeInBytes","type":"long"},"sizeInBytesCompressed":{"locationName":"sizeInBytesCompressed","type":"long"},"unclassifiableObjectCount":{"shape":"S2z","locationName":"unclassifiableObjectCount"},"unclassifiableObjectSizeInBytes":{"shape":"S2z","locationName":"unclassifiableObjectSizeInBytes"}}}},"GetClassificationExportConfiguration":{"http":{"method":"GET","requestUri":"/classification-export-configuration","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"configuration":{"shape":"S42","locationName":"configuration"}}}},"GetCustomDataIdentifier":{"http":{"method":"GET","requestUri":"/custom-data-identifiers/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{"arn":{"locationName":"arn"},"createdAt":{"shape":"S9","locationName":"createdAt"},"deleted":{"locationName":"deleted","type":"boolean"},"description":{"locationName":"description"},"id":{"locationName":"id"},"ignoreWords":{"shape":"S5","locationName":"ignoreWords"},"keywords":{"shape":"S5","locationName":"keywords"},"maximumMatchDistance":{"locationName":"maximumMatchDistance","type":"integer"},"name":{"locationName":"name"},"regex":{"locationName":"regex"},"severityLevels":{"shape":"S1a","locationName":"severityLevels"},"tags":{"shape":"S17","locationName":"tags"}}}},"GetFindingStatistics":{"http":{"requestUri":"/findings/statistics","responseCode":200},"input":{"type":"structure","members":{"findingCriteria":{"shape":"S1h","locationName":"findingCriteria"},"groupBy":{"locationName":"groupBy"},"size":{"locationName":"size","type":"integer"},"sortCriteria":{"locationName":"sortCriteria","type":"structure","members":{"attributeName":{"locationName":"attributeName"},"orderBy":{"locationName":"orderBy"}}}},"required":["groupBy"]},"output":{"type":"structure","members":{"countsByGroup":{"locationName":"countsByGroup","type":"list","member":{"type":"structure","members":{"count":{"locationName":"count","type":"long"},"groupKey":{"locationName":"groupKey"}}}}}}},"GetFindings":{"http":{"requestUri":"/findings/describe","responseCode":200},"input":{"type":"structure","members":{"findingIds":{"shape":"S5","locationName":"findingIds"},"sortCriteria":{"shape":"S4e","locationName":"sortCriteria"}},"required":["findingIds"]},"output":{"type":"structure","members":{"findings":{"locationName":"findings","type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"archived":{"locationName":"archived","type":"boolean"},"category":{"locationName":"category"},"classificationDetails":{"locationName":"classificationDetails","type":"structure","members":{"detailedResultsLocation":{"locationName":"detailedResultsLocation"},"jobArn":{"locationName":"jobArn"},"jobId":{"locationName":"jobId"},"originType":{"locationName":"originType"},"result":{"locationName":"result","type":"structure","members":{"additionalOccurrences":{"locationName":"additionalOccurrences","type":"boolean"},"customDataIdentifiers":{"locationName":"customDataIdentifiers","type":"structure","members":{"detections":{"locationName":"detections","type":"list","member":{"type":"structure","members":{"arn":{"locationName":"arn"},"count":{"locationName":"count","type":"long"},"name":{"locationName":"name"},"occurrences":{"shape":"S4p","locationName":"occurrences"}}}},"totalCount":{"locationName":"totalCount","type":"long"}}},"mimeType":{"locationName":"mimeType"},"sensitiveData":{"locationName":"sensitiveData","type":"list","member":{"type":"structure","members":{"category":{"locationName":"category"},"detections":{"locationName":"detections","type":"list","member":{"type":"structure","members":{"count":{"locationName":"count","type":"long"},"occurrences":{"shape":"S4p","locationName":"occurrences"},"type":{"locationName":"type"}}}},"totalCount":{"locationName":"totalCount","type":"long"}}}},"sizeClassified":{"locationName":"sizeClassified","type":"long"},"status":{"locationName":"status","type":"structure","members":{"code":{"locationName":"code"},"reason":{"locationName":"reason"}}}}}}},"count":{"locationName":"count","type":"long"},"createdAt":{"shape":"S9","locationName":"createdAt"},"description":{"locationName":"description"},"id":{"locationName":"id"},"partition":{"locationName":"partition"},"policyDetails":{"locationName":"policyDetails","type":"structure","members":{"action":{"locationName":"action","type":"structure","members":{"actionType":{"locationName":"actionType"},"apiCallDetails":{"locationName":"apiCallDetails","type":"structure","members":{"api":{"locationName":"api"},"apiServiceName":{"locationName":"apiServiceName"},"firstSeen":{"shape":"S9","locationName":"firstSeen"},"lastSeen":{"shape":"S9","locationName":"lastSeen"}}}}},"actor":{"locationName":"actor","type":"structure","members":{"domainDetails":{"locationName":"domainDetails","type":"structure","members":{"domainName":{"locationName":"domainName"}}},"ipAddressDetails":{"locationName":"ipAddressDetails","type":"structure","members":{"ipAddressV4":{"locationName":"ipAddressV4"},"ipCity":{"locationName":"ipCity","type":"structure","members":{"name":{"locationName":"name"}}},"ipCountry":{"locationName":"ipCountry","type":"structure","members":{"code":{"locationName":"code"},"name":{"locationName":"name"}}},"ipGeoLocation":{"locationName":"ipGeoLocation","type":"structure","members":{"lat":{"locationName":"lat","type":"double"},"lon":{"locationName":"lon","type":"double"}}},"ipOwner":{"locationName":"ipOwner","type":"structure","members":{"asn":{"locationName":"asn"},"asnOrg":{"locationName":"asnOrg"},"isp":{"locationName":"isp"},"org":{"locationName":"org"}}}}},"userIdentity":{"locationName":"userIdentity","type":"structure","members":{"assumedRole":{"locationName":"assumedRole","type":"structure","members":{"accessKeyId":{"locationName":"accessKeyId"},"accountId":{"locationName":"accountId"},"arn":{"locationName":"arn"},"principalId":{"locationName":"principalId"},"sessionContext":{"shape":"S5h","locationName":"sessionContext"}}},"awsAccount":{"locationName":"awsAccount","type":"structure","members":{"accountId":{"locationName":"accountId"},"principalId":{"locationName":"principalId"}}},"awsService":{"locationName":"awsService","type":"structure","members":{"invokedBy":{"locationName":"invokedBy"}}},"federatedUser":{"locationName":"federatedUser","type":"structure","members":{"accessKeyId":{"locationName":"accessKeyId"},"accountId":{"locationName":"accountId"},"arn":{"locationName":"arn"},"principalId":{"locationName":"principalId"},"sessionContext":{"shape":"S5h","locationName":"sessionContext"}}},"iamUser":{"locationName":"iamUser","type":"structure","members":{"accountId":{"locationName":"accountId"},"arn":{"locationName":"arn"},"principalId":{"locationName":"principalId"},"userName":{"locationName":"userName"}}},"root":{"locationName":"root","type":"structure","members":{"accountId":{"locationName":"accountId"},"arn":{"locationName":"arn"},"principalId":{"locationName":"principalId"}}},"type":{"locationName":"type"}}}}}}},"region":{"locationName":"region"},"resourcesAffected":{"locationName":"resourcesAffected","type":"structure","members":{"s3Bucket":{"locationName":"s3Bucket","type":"structure","members":{"allowsUnencryptedObjectUploads":{"locationName":"allowsUnencryptedObjectUploads"},"arn":{"locationName":"arn"},"createdAt":{"shape":"S9","locationName":"createdAt"},"defaultServerSideEncryption":{"shape":"S5s","locationName":"defaultServerSideEncryption"},"name":{"locationName":"name"},"owner":{"locationName":"owner","type":"structure","members":{"displayName":{"locationName":"displayName"},"id":{"locationName":"id"}}},"publicAccess":{"shape":"S2l","locationName":"publicAccess"},"tags":{"shape":"S5v","locationName":"tags"}}},"s3Object":{"locationName":"s3Object","type":"structure","members":{"bucketArn":{"locationName":"bucketArn"},"eTag":{"locationName":"eTag"},"extension":{"locationName":"extension"},"key":{"locationName":"key"},"lastModified":{"shape":"S9","locationName":"lastModified"},"path":{"locationName":"path"},"publicAccess":{"locationName":"publicAccess","type":"boolean"},"serverSideEncryption":{"shape":"S5s","locationName":"serverSideEncryption"},"size":{"locationName":"size","type":"long"},"storageClass":{"locationName":"storageClass"},"tags":{"shape":"S5v","locationName":"tags"},"versionId":{"locationName":"versionId"}}}}},"sample":{"locationName":"sample","type":"boolean"},"schemaVersion":{"locationName":"schemaVersion"},"severity":{"locationName":"severity","type":"structure","members":{"description":{"locationName":"description"},"score":{"locationName":"score","type":"long"}}},"title":{"locationName":"title"},"type":{"locationName":"type"},"updatedAt":{"shape":"S9","locationName":"updatedAt"}}}}}}},"GetFindingsFilter":{"http":{"method":"GET","requestUri":"/findingsfilters/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{"action":{"locationName":"action"},"arn":{"locationName":"arn"},"description":{"locationName":"description"},"findingCriteria":{"shape":"S1h","locationName":"findingCriteria"},"id":{"locationName":"id"},"name":{"locationName":"name"},"position":{"locationName":"position","type":"integer"},"tags":{"shape":"S17","locationName":"tags"}}}},"GetFindingsPublicationConfiguration":{"http":{"method":"GET","requestUri":"/findings-publication-configuration","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"securityHubConfiguration":{"shape":"S64","locationName":"securityHubConfiguration"}}}},"GetInvitationsCount":{"http":{"method":"GET","requestUri":"/invitations/count","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"invitationsCount":{"locationName":"invitationsCount","type":"long"}}}},"GetMacieSession":{"http":{"method":"GET","requestUri":"/macie","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"createdAt":{"shape":"S9","locationName":"createdAt"},"findingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"serviceRole":{"locationName":"serviceRole"},"status":{"locationName":"status"},"updatedAt":{"shape":"S9","locationName":"updatedAt"}}}},"GetMasterAccount":{"http":{"method":"GET","requestUri":"/master","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"master":{"shape":"S3s","locationName":"master"}}}},"GetMember":{"http":{"method":"GET","requestUri":"/members/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"}},"required":["id"]},"output":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"administratorAccountId":{"locationName":"administratorAccountId"},"arn":{"locationName":"arn"},"email":{"locationName":"email"},"invitedAt":{"shape":"S9","locationName":"invitedAt"},"masterAccountId":{"locationName":"masterAccountId"},"relationshipStatus":{"locationName":"relationshipStatus"},"tags":{"shape":"S17","locationName":"tags"},"updatedAt":{"shape":"S9","locationName":"updatedAt"}}}},"GetUsageStatistics":{"http":{"requestUri":"/usage/statistics","responseCode":200},"input":{"type":"structure","members":{"filterBy":{"locationName":"filterBy","type":"list","member":{"type":"structure","members":{"comparator":{"locationName":"comparator"},"key":{"locationName":"key"},"values":{"shape":"S5","locationName":"values"}}}},"maxResults":{"locationName":"maxResults","type":"integer"},"nextToken":{"locationName":"nextToken"},"sortBy":{"locationName":"sortBy","type":"structure","members":{"key":{"locationName":"key"},"orderBy":{"locationName":"orderBy"}}},"timeRange":{"locationName":"timeRange"}}},"output":{"type":"structure","members":{"nextToken":{"locationName":"nextToken"},"records":{"locationName":"records","type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"freeTrialStartDate":{"shape":"S9","locationName":"freeTrialStartDate"},"usage":{"locationName":"usage","type":"list","member":{"type":"structure","members":{"currency":{"locationName":"currency"},"estimatedCost":{"locationName":"estimatedCost"},"serviceLimit":{"locationName":"serviceLimit","type":"structure","members":{"isServiceLimited":{"locationName":"isServiceLimited","type":"boolean"},"unit":{"locationName":"unit"},"value":{"locationName":"value","type":"long"}}},"type":{"locationName":"type"}}}}}}},"timeRange":{"locationName":"timeRange"}}}},"GetUsageTotals":{"http":{"method":"GET","requestUri":"/usage","responseCode":200},"input":{"type":"structure","members":{"timeRange":{"location":"querystring","locationName":"timeRange"}}},"output":{"type":"structure","members":{"timeRange":{"locationName":"timeRange"},"usageTotals":{"locationName":"usageTotals","type":"list","member":{"type":"structure","members":{"currency":{"locationName":"currency"},"estimatedCost":{"locationName":"estimatedCost"},"type":{"locationName":"type"}}}}}}},"ListClassificationJobs":{"http":{"requestUri":"/jobs/list","responseCode":200},"input":{"type":"structure","members":{"filterCriteria":{"locationName":"filterCriteria","type":"structure","members":{"excludes":{"shape":"S70","locationName":"excludes"},"includes":{"shape":"S70","locationName":"includes"}}},"maxResults":{"locationName":"maxResults","type":"integer"},"nextToken":{"locationName":"nextToken"},"sortCriteria":{"locationName":"sortCriteria","type":"structure","members":{"attributeName":{"locationName":"attributeName"},"orderBy":{"locationName":"orderBy"}}}}},"output":{"type":"structure","members":{"items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"bucketDefinitions":{"shape":"Sf","locationName":"bucketDefinitions"},"createdAt":{"shape":"S9","locationName":"createdAt"},"jobId":{"locationName":"jobId"},"jobStatus":{"locationName":"jobStatus"},"jobType":{"locationName":"jobType"},"lastRunErrorStatus":{"shape":"S33","locationName":"lastRunErrorStatus"},"name":{"locationName":"name"},"userPausedDetails":{"shape":"S37","locationName":"userPausedDetails"},"bucketCriteria":{"shape":"Ss","locationName":"bucketCriteria"}}}},"nextToken":{"locationName":"nextToken"}}}},"ListCustomDataIdentifiers":{"http":{"requestUri":"/custom-data-identifiers/list","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"locationName":"maxResults","type":"integer"},"nextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"arn":{"locationName":"arn"},"createdAt":{"shape":"S9","locationName":"createdAt"},"description":{"locationName":"description"},"id":{"locationName":"id"},"name":{"locationName":"name"}}}},"nextToken":{"locationName":"nextToken"}}}},"ListFindings":{"http":{"requestUri":"/findings","responseCode":200},"input":{"type":"structure","members":{"findingCriteria":{"shape":"S1h","locationName":"findingCriteria"},"maxResults":{"locationName":"maxResults","type":"integer"},"nextToken":{"locationName":"nextToken"},"sortCriteria":{"shape":"S4e","locationName":"sortCriteria"}}},"output":{"type":"structure","members":{"findingIds":{"shape":"S5","locationName":"findingIds"},"nextToken":{"locationName":"nextToken"}}}},"ListFindingsFilters":{"http":{"method":"GET","requestUri":"/findingsfilters","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"findingsFilterListItems":{"locationName":"findingsFilterListItems","type":"list","member":{"type":"structure","members":{"action":{"locationName":"action"},"arn":{"locationName":"arn"},"id":{"locationName":"id"},"name":{"locationName":"name"},"tags":{"shape":"S17","locationName":"tags"}}}},"nextToken":{"locationName":"nextToken"}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitations","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"invitations":{"locationName":"invitations","type":"list","member":{"shape":"S3s"}},"nextToken":{"locationName":"nextToken"}}}},"ListManagedDataIdentifiers":{"http":{"requestUri":"/managed-data-identifiers/list","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"category":{"locationName":"category"},"id":{"locationName":"id"}}}},"nextToken":{"locationName":"nextToken"}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/members","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"onlyAssociated":{"location":"querystring","locationName":"onlyAssociated"}}},"output":{"type":"structure","members":{"members":{"locationName":"members","type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"administratorAccountId":{"locationName":"administratorAccountId"},"arn":{"locationName":"arn"},"email":{"locationName":"email"},"invitedAt":{"shape":"S9","locationName":"invitedAt"},"masterAccountId":{"locationName":"masterAccountId"},"relationshipStatus":{"locationName":"relationshipStatus"},"tags":{"shape":"S17","locationName":"tags"},"updatedAt":{"shape":"S9","locationName":"updatedAt"}}}},"nextToken":{"locationName":"nextToken"}}}},"ListOrganizationAdminAccounts":{"http":{"method":"GET","requestUri":"/admin","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"adminAccounts":{"locationName":"adminAccounts","type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"status":{"locationName":"status"}}}},"nextToken":{"locationName":"nextToken"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}},"required":["resourceArn"]},"output":{"type":"structure","members":{"tags":{"shape":"S17","locationName":"tags"}}}},"PutClassificationExportConfiguration":{"http":{"method":"PUT","requestUri":"/classification-export-configuration","responseCode":200},"input":{"type":"structure","members":{"configuration":{"shape":"S42","locationName":"configuration"}},"required":["configuration"]},"output":{"type":"structure","members":{"configuration":{"shape":"S42","locationName":"configuration"}}}},"PutFindingsPublicationConfiguration":{"http":{"method":"PUT","requestUri":"/findings-publication-configuration","responseCode":200},"input":{"type":"structure","members":{"clientToken":{"locationName":"clientToken","idempotencyToken":true},"securityHubConfiguration":{"shape":"S64","locationName":"securityHubConfiguration"}}},"output":{"type":"structure","members":{}}},"SearchResources":{"http":{"requestUri":"/datasources/search-resources","responseCode":200},"input":{"type":"structure","members":{"bucketCriteria":{"locationName":"bucketCriteria","type":"structure","members":{"excludes":{"shape":"S87","locationName":"excludes"},"includes":{"shape":"S87","locationName":"includes"}}},"maxResults":{"locationName":"maxResults","type":"integer"},"nextToken":{"locationName":"nextToken"},"sortCriteria":{"locationName":"sortCriteria","type":"structure","members":{"attributeName":{"locationName":"attributeName"},"orderBy":{"locationName":"orderBy"}}}}},"output":{"type":"structure","members":{"matchingResources":{"locationName":"matchingResources","type":"list","member":{"type":"structure","members":{"matchingBucket":{"locationName":"matchingBucket","type":"structure","members":{"accountId":{"locationName":"accountId"},"bucketName":{"locationName":"bucketName"},"classifiableObjectCount":{"locationName":"classifiableObjectCount","type":"long"},"classifiableSizeInBytes":{"locationName":"classifiableSizeInBytes","type":"long"},"errorCode":{"locationName":"errorCode"},"errorMessage":{"locationName":"errorMessage"},"jobDetails":{"shape":"S2h","locationName":"jobDetails"},"objectCount":{"locationName":"objectCount","type":"long"},"objectCountByEncryptionType":{"shape":"S2k","locationName":"objectCountByEncryptionType"},"sizeInBytes":{"locationName":"sizeInBytes","type":"long"},"sizeInBytesCompressed":{"locationName":"sizeInBytesCompressed","type":"long"},"unclassifiableObjectCount":{"shape":"S2z","locationName":"unclassifiableObjectCount"},"unclassifiableObjectSizeInBytes":{"shape":"S2z","locationName":"unclassifiableObjectSizeInBytes"}}}}}},"nextToken":{"locationName":"nextToken"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S17","locationName":"tags"}},"required":["resourceArn","tags"]},"output":{"type":"structure","members":{}}},"TestCustomDataIdentifier":{"http":{"requestUri":"/custom-data-identifiers/test","responseCode":200},"input":{"type":"structure","members":{"ignoreWords":{"shape":"S5","locationName":"ignoreWords"},"keywords":{"shape":"S5","locationName":"keywords"},"maximumMatchDistance":{"locationName":"maximumMatchDistance","type":"integer"},"regex":{"locationName":"regex"},"sampleText":{"locationName":"sampleText"}},"required":["regex","sampleText"]},"output":{"type":"structure","members":{"matchCount":{"locationName":"matchCount","type":"integer"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"shape":"S5","location":"querystring","locationName":"tagKeys"}},"required":["tagKeys","resourceArn"]},"output":{"type":"structure","members":{}}},"UpdateClassificationJob":{"http":{"method":"PATCH","requestUri":"/jobs/{jobId}","responseCode":200},"input":{"type":"structure","members":{"jobId":{"location":"uri","locationName":"jobId"},"jobStatus":{"locationName":"jobStatus"}},"required":["jobId","jobStatus"]},"output":{"type":"structure","members":{}}},"UpdateFindingsFilter":{"http":{"method":"PATCH","requestUri":"/findingsfilters/{id}","responseCode":200},"input":{"type":"structure","members":{"action":{"locationName":"action"},"description":{"locationName":"description"},"findingCriteria":{"shape":"S1h","locationName":"findingCriteria"},"id":{"location":"uri","locationName":"id"},"name":{"locationName":"name"},"position":{"locationName":"position","type":"integer"},"clientToken":{"locationName":"clientToken","idempotencyToken":true}},"required":["id"]},"output":{"type":"structure","members":{"arn":{"locationName":"arn"},"id":{"locationName":"id"}}}},"UpdateMacieSession":{"http":{"method":"PATCH","requestUri":"/macie","responseCode":200},"input":{"type":"structure","members":{"findingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"status":{"locationName":"status"}}},"output":{"type":"structure","members":{}}},"UpdateMemberSession":{"http":{"method":"PATCH","requestUri":"/macie/members/{id}","responseCode":200},"input":{"type":"structure","members":{"id":{"location":"uri","locationName":"id"},"status":{"locationName":"status"}},"required":["id","status"]},"output":{"type":"structure","members":{}}},"UpdateOrganizationConfiguration":{"http":{"method":"PATCH","requestUri":"/admin/configuration","responseCode":200},"input":{"type":"structure","members":{"autoEnable":{"locationName":"autoEnable","type":"boolean"}},"required":["autoEnable"]},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"list","member":{}},"S9":{"type":"timestamp","timestampFormat":"iso8601"},"Se":{"type":"structure","members":{"bucketDefinitions":{"shape":"Sf","locationName":"bucketDefinitions"},"scoping":{"locationName":"scoping","type":"structure","members":{"excludes":{"shape":"Si","locationName":"excludes"},"includes":{"shape":"Si","locationName":"includes"}}},"bucketCriteria":{"shape":"Ss","locationName":"bucketCriteria"}}},"Sf":{"type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"buckets":{"shape":"S5","locationName":"buckets"}},"required":["accountId","buckets"]}},"Si":{"type":"structure","members":{"and":{"locationName":"and","type":"list","member":{"type":"structure","members":{"simpleScopeTerm":{"locationName":"simpleScopeTerm","type":"structure","members":{"comparator":{"locationName":"comparator"},"key":{"locationName":"key"},"values":{"shape":"S5","locationName":"values"}}},"tagScopeTerm":{"locationName":"tagScopeTerm","type":"structure","members":{"comparator":{"locationName":"comparator"},"key":{"locationName":"key"},"tagValues":{"locationName":"tagValues","type":"list","member":{"type":"structure","members":{"key":{"locationName":"key"},"value":{"locationName":"value"}}}},"target":{"locationName":"target"}}}}}}}},"Ss":{"type":"structure","members":{"excludes":{"shape":"St","locationName":"excludes"},"includes":{"shape":"St","locationName":"includes"}}},"St":{"type":"structure","members":{"and":{"locationName":"and","type":"list","member":{"type":"structure","members":{"simpleCriterion":{"locationName":"simpleCriterion","type":"structure","members":{"comparator":{"locationName":"comparator"},"key":{"locationName":"key"},"values":{"shape":"S5","locationName":"values"}}},"tagCriterion":{"locationName":"tagCriterion","type":"structure","members":{"comparator":{"locationName":"comparator"},"tagValues":{"locationName":"tagValues","type":"list","member":{"type":"structure","members":{"key":{"locationName":"key"},"value":{"locationName":"value"}}}}}}}}}}},"S12":{"type":"structure","members":{"dailySchedule":{"locationName":"dailySchedule","type":"structure","members":{}},"monthlySchedule":{"locationName":"monthlySchedule","type":"structure","members":{"dayOfMonth":{"locationName":"dayOfMonth","type":"integer"}}},"weeklySchedule":{"locationName":"weeklySchedule","type":"structure","members":{"dayOfWeek":{"locationName":"dayOfWeek"}}}}},"S17":{"type":"map","key":{},"value":{}},"S1a":{"type":"list","member":{"type":"structure","members":{"occurrencesThreshold":{"locationName":"occurrencesThreshold","type":"long"},"severity":{"locationName":"severity"}},"required":["occurrencesThreshold","severity"]}},"S1h":{"type":"structure","members":{"criterion":{"locationName":"criterion","type":"map","key":{},"value":{"type":"structure","members":{"eq":{"shape":"S5","locationName":"eq"},"eqExactMatch":{"shape":"S5","locationName":"eqExactMatch"},"gt":{"locationName":"gt","type":"long"},"gte":{"locationName":"gte","type":"long"},"lt":{"locationName":"lt","type":"long"},"lte":{"locationName":"lte","type":"long"},"neq":{"shape":"S5","locationName":"neq"}}}}}},"S1n":{"type":"list","member":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"errorCode":{"locationName":"errorCode"},"errorMessage":{"locationName":"errorMessage"}}}},"S2h":{"type":"structure","members":{"isDefinedInJob":{"locationName":"isDefinedInJob"},"isMonitoredByJob":{"locationName":"isMonitoredByJob"},"lastJobId":{"locationName":"lastJobId"},"lastJobRunTime":{"shape":"S9","locationName":"lastJobRunTime"}}},"S2k":{"type":"structure","members":{"customerManaged":{"locationName":"customerManaged","type":"long"},"kmsManaged":{"locationName":"kmsManaged","type":"long"},"s3Managed":{"locationName":"s3Managed","type":"long"},"unencrypted":{"locationName":"unencrypted","type":"long"},"unknown":{"locationName":"unknown","type":"long"}}},"S2l":{"type":"structure","members":{"effectivePermission":{"locationName":"effectivePermission"},"permissionConfiguration":{"locationName":"permissionConfiguration","type":"structure","members":{"accountLevelPermissions":{"locationName":"accountLevelPermissions","type":"structure","members":{"blockPublicAccess":{"shape":"S2p","locationName":"blockPublicAccess"}}},"bucketLevelPermissions":{"locationName":"bucketLevelPermissions","type":"structure","members":{"accessControlList":{"locationName":"accessControlList","type":"structure","members":{"allowsPublicReadAccess":{"locationName":"allowsPublicReadAccess","type":"boolean"},"allowsPublicWriteAccess":{"locationName":"allowsPublicWriteAccess","type":"boolean"}}},"blockPublicAccess":{"shape":"S2p","locationName":"blockPublicAccess"},"bucketPolicy":{"locationName":"bucketPolicy","type":"structure","members":{"allowsPublicReadAccess":{"locationName":"allowsPublicReadAccess","type":"boolean"},"allowsPublicWriteAccess":{"locationName":"allowsPublicWriteAccess","type":"boolean"}}}}}}}}},"S2p":{"type":"structure","members":{"blockPublicAcls":{"locationName":"blockPublicAcls","type":"boolean"},"blockPublicPolicy":{"locationName":"blockPublicPolicy","type":"boolean"},"ignorePublicAcls":{"locationName":"ignorePublicAcls","type":"boolean"},"restrictPublicBuckets":{"locationName":"restrictPublicBuckets","type":"boolean"}}},"S2y":{"type":"structure","members":{"key":{"locationName":"key"},"value":{"locationName":"value"}}},"S2z":{"type":"structure","members":{"fileType":{"locationName":"fileType","type":"long"},"storageClass":{"locationName":"storageClass","type":"long"},"total":{"locationName":"total","type":"long"}}},"S33":{"type":"structure","members":{"code":{"locationName":"code"}}},"S37":{"type":"structure","members":{"jobExpiresAt":{"shape":"S9","locationName":"jobExpiresAt"},"jobImminentExpirationHealthEventArn":{"locationName":"jobImminentExpirationHealthEventArn"},"jobPausedAt":{"shape":"S9","locationName":"jobPausedAt"}}},"S3s":{"type":"structure","members":{"accountId":{"locationName":"accountId"},"invitationId":{"locationName":"invitationId"},"invitedAt":{"shape":"S9","locationName":"invitedAt"},"relationshipStatus":{"locationName":"relationshipStatus"}}},"S42":{"type":"structure","members":{"s3Destination":{"locationName":"s3Destination","type":"structure","members":{"bucketName":{"locationName":"bucketName"},"keyPrefix":{"locationName":"keyPrefix"},"kmsKeyArn":{"locationName":"kmsKeyArn"}},"required":["bucketName","kmsKeyArn"]}}},"S4e":{"type":"structure","members":{"attributeName":{"locationName":"attributeName"},"orderBy":{"locationName":"orderBy"}}},"S4p":{"type":"structure","members":{"cells":{"locationName":"cells","type":"list","member":{"type":"structure","members":{"cellReference":{"locationName":"cellReference"},"column":{"locationName":"column","type":"long"},"columnName":{"locationName":"columnName"},"row":{"locationName":"row","type":"long"}}}},"lineRanges":{"shape":"S4s","locationName":"lineRanges"},"offsetRanges":{"shape":"S4s","locationName":"offsetRanges"},"pages":{"locationName":"pages","type":"list","member":{"type":"structure","members":{"lineRange":{"shape":"S4t","locationName":"lineRange"},"offsetRange":{"shape":"S4t","locationName":"offsetRange"},"pageNumber":{"locationName":"pageNumber","type":"long"}}}},"records":{"locationName":"records","type":"list","member":{"type":"structure","members":{"jsonPath":{"locationName":"jsonPath"},"recordIndex":{"locationName":"recordIndex","type":"long"}}}}}},"S4s":{"type":"list","member":{"shape":"S4t"}},"S4t":{"type":"structure","members":{"end":{"locationName":"end","type":"long"},"start":{"locationName":"start","type":"long"},"startColumn":{"locationName":"startColumn","type":"long"}}},"S5h":{"type":"structure","members":{"attributes":{"locationName":"attributes","type":"structure","members":{"creationDate":{"shape":"S9","locationName":"creationDate"},"mfaAuthenticated":{"locationName":"mfaAuthenticated","type":"boolean"}}},"sessionIssuer":{"locationName":"sessionIssuer","type":"structure","members":{"accountId":{"locationName":"accountId"},"arn":{"locationName":"arn"},"principalId":{"locationName":"principalId"},"type":{"locationName":"type"},"userName":{"locationName":"userName"}}}}},"S5s":{"type":"structure","members":{"encryptionType":{"locationName":"encryptionType"},"kmsMasterKeyId":{"locationName":"kmsMasterKeyId"}}},"S5v":{"type":"list","member":{"shape":"S2y"}},"S64":{"type":"structure","members":{"publishClassificationFindings":{"locationName":"publishClassificationFindings","type":"boolean"},"publishPolicyFindings":{"locationName":"publishPolicyFindings","type":"boolean"}},"required":["publishPolicyFindings","publishClassificationFindings"]},"S70":{"type":"list","member":{"type":"structure","members":{"comparator":{"locationName":"comparator"},"key":{"locationName":"key"},"values":{"shape":"S5","locationName":"values"}}}},"S87":{"type":"structure","members":{"and":{"locationName":"and","type":"list","member":{"type":"structure","members":{"simpleCriterion":{"locationName":"simpleCriterion","type":"structure","members":{"comparator":{"locationName":"comparator"},"key":{"locationName":"key"},"values":{"shape":"S5","locationName":"values"}}},"tagCriterion":{"locationName":"tagCriterion","type":"structure","members":{"comparator":{"locationName":"comparator"},"tagValues":{"locationName":"tagValues","type":"list","member":{"type":"structure","members":{"key":{"locationName":"key"},"value":{"locationName":"value"}}}}}}}}}}}}}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeBuckets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"buckets"},"GetUsageStatistics":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"records"},"ListClassificationJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"ListCustomDataIdentifiers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"findingIds"},"ListFindingsFilters":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"findingsFilterListItems"},"ListInvitations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"invitations"},"ListMembers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"members"},"ListOrganizationAdminAccounts":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"adminAccounts"},"SearchResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"matchingResources"}}}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['codeartifact'] = {};
	AWS.CodeArtifact = Service.defineService('codeartifact', ['2018-09-22']);
	Object.defineProperty(apiLoader.services['codeartifact'], '2018-09-22', {
	  get: function get() {
	    var model = __webpack_require__(885);
	    model.paginators = __webpack_require__(886).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CodeArtifact;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-22","endpointPrefix":"codeartifact","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"CodeArtifact","serviceId":"codeartifact","signatureVersion":"v4","signingName":"codeartifact","uid":"codeartifact-2018-09-22"},"operations":{"AssociateExternalConnection":{"http":{"requestUri":"/v1/repository/external-connection"},"input":{"type":"structure","required":["domain","repository","externalConnection"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"externalConnection":{"location":"querystring","locationName":"external-connection"}}},"output":{"type":"structure","members":{"repository":{"shape":"S7"}}}},"CopyPackageVersions":{"http":{"requestUri":"/v1/package/versions/copy"},"input":{"type":"structure","required":["domain","sourceRepository","destinationRepository","format","package"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"sourceRepository":{"location":"querystring","locationName":"source-repository"},"destinationRepository":{"location":"querystring","locationName":"destination-repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"versions":{"shape":"Sj"},"versionRevisions":{"shape":"Sl"},"allowOverwrite":{"type":"boolean"},"includeFromUpstream":{"type":"boolean"}}},"output":{"type":"structure","members":{"successfulVersions":{"shape":"Sp"},"failedVersions":{"shape":"St"}}}},"CreateDomain":{"http":{"requestUri":"/v1/domain"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"encryptionKey":{},"tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"domain":{"shape":"S13"}}}},"CreateRepository":{"http":{"requestUri":"/v1/repository"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"description":{},"upstreams":{"shape":"S19"},"tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"repository":{"shape":"S7"}}}},"DeleteDomain":{"http":{"method":"DELETE","requestUri":"/v1/domain"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"}}},"output":{"type":"structure","members":{"domain":{"shape":"S13"}}}},"DeleteDomainPermissionsPolicy":{"http":{"method":"DELETE","requestUri":"/v1/domain/permissions/policy"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"policyRevision":{"location":"querystring","locationName":"policy-revision"}}},"output":{"type":"structure","members":{"policy":{"shape":"S1h"}}}},"DeletePackageVersions":{"http":{"requestUri":"/v1/package/versions/delete"},"input":{"type":"structure","required":["domain","repository","format","package","versions"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"versions":{"shape":"Sj"},"expectedStatus":{}}},"output":{"type":"structure","members":{"successfulVersions":{"shape":"Sp"},"failedVersions":{"shape":"St"}}}},"DeleteRepository":{"http":{"method":"DELETE","requestUri":"/v1/repository"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"}}},"output":{"type":"structure","members":{"repository":{"shape":"S7"}}}},"DeleteRepositoryPermissionsPolicy":{"http":{"method":"DELETE","requestUri":"/v1/repository/permissions/policies"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"policyRevision":{"location":"querystring","locationName":"policy-revision"}}},"output":{"type":"structure","members":{"policy":{"shape":"S1h"}}}},"DescribeDomain":{"http":{"method":"GET","requestUri":"/v1/domain"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"}}},"output":{"type":"structure","members":{"domain":{"shape":"S13"}}}},"DescribePackageVersion":{"http":{"method":"GET","requestUri":"/v1/package/version"},"input":{"type":"structure","required":["domain","repository","format","package","packageVersion"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"packageVersion":{"location":"querystring","locationName":"version"}}},"output":{"type":"structure","required":["packageVersion"],"members":{"packageVersion":{"type":"structure","members":{"format":{},"namespace":{},"packageName":{},"displayName":{},"version":{},"summary":{},"homePage":{},"sourceCodeRepository":{},"publishedTime":{"type":"timestamp"},"licenses":{"type":"list","member":{"type":"structure","members":{"name":{},"url":{}}}},"revision":{},"status":{}}}}}},"DescribeRepository":{"http":{"method":"GET","requestUri":"/v1/repository"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"}}},"output":{"type":"structure","members":{"repository":{"shape":"S7"}}}},"DisassociateExternalConnection":{"http":{"method":"DELETE","requestUri":"/v1/repository/external-connection"},"input":{"type":"structure","required":["domain","repository","externalConnection"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"externalConnection":{"location":"querystring","locationName":"external-connection"}}},"output":{"type":"structure","members":{"repository":{"shape":"S7"}}}},"DisposePackageVersions":{"http":{"requestUri":"/v1/package/versions/dispose"},"input":{"type":"structure","required":["domain","repository","format","package","versions"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"versions":{"shape":"Sj"},"versionRevisions":{"shape":"Sl"},"expectedStatus":{}}},"output":{"type":"structure","members":{"successfulVersions":{"shape":"Sp"},"failedVersions":{"shape":"St"}}}},"GetAuthorizationToken":{"http":{"requestUri":"/v1/authorization-token"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"durationSeconds":{"location":"querystring","locationName":"duration","type":"long"}}},"output":{"type":"structure","members":{"authorizationToken":{},"expiration":{"type":"timestamp"}}}},"GetDomainPermissionsPolicy":{"http":{"method":"GET","requestUri":"/v1/domain/permissions/policy"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"}}},"output":{"type":"structure","members":{"policy":{"shape":"S1h"}}}},"GetPackageVersionAsset":{"http":{"method":"GET","requestUri":"/v1/package/version/asset"},"input":{"type":"structure","required":["domain","repository","format","package","packageVersion","asset"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"packageVersion":{"location":"querystring","locationName":"version"},"asset":{"location":"querystring","locationName":"asset"},"packageVersionRevision":{"location":"querystring","locationName":"revision"}}},"output":{"type":"structure","members":{"asset":{"type":"blob","streaming":true},"assetName":{"location":"header","locationName":"X-AssetName"},"packageVersion":{"location":"header","locationName":"X-PackageVersion"},"packageVersionRevision":{"location":"header","locationName":"X-PackageVersionRevision"}},"payload":"asset"}},"GetPackageVersionReadme":{"http":{"method":"GET","requestUri":"/v1/package/version/readme"},"input":{"type":"structure","required":["domain","repository","format","package","packageVersion"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"packageVersion":{"location":"querystring","locationName":"version"}}},"output":{"type":"structure","members":{"format":{},"namespace":{},"package":{},"version":{},"versionRevision":{},"readme":{}}}},"GetRepositoryEndpoint":{"http":{"method":"GET","requestUri":"/v1/repository/endpoint"},"input":{"type":"structure","required":["domain","repository","format"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"}}},"output":{"type":"structure","members":{"repositoryEndpoint":{}}}},"GetRepositoryPermissionsPolicy":{"http":{"method":"GET","requestUri":"/v1/repository/permissions/policy"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"}}},"output":{"type":"structure","members":{"policy":{"shape":"S1h"}}}},"ListDomains":{"http":{"requestUri":"/v1/domains"},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"domains":{"type":"list","member":{"type":"structure","members":{"name":{},"owner":{},"arn":{},"status":{},"createdTime":{"type":"timestamp"},"encryptionKey":{}}}},"nextToken":{}}}},"ListPackageVersionAssets":{"http":{"requestUri":"/v1/package/version/assets"},"input":{"type":"structure","required":["domain","repository","format","package","packageVersion"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"packageVersion":{"location":"querystring","locationName":"version"},"maxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"nextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"format":{},"namespace":{},"package":{},"version":{},"versionRevision":{},"nextToken":{},"assets":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"size":{"type":"long"},"hashes":{"type":"map","key":{},"value":{}}}}}}}},"ListPackageVersionDependencies":{"http":{"requestUri":"/v1/package/version/dependencies"},"input":{"type":"structure","required":["domain","repository","format","package","packageVersion"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"packageVersion":{"location":"querystring","locationName":"version"},"nextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"format":{},"namespace":{},"package":{},"version":{},"versionRevision":{},"nextToken":{},"dependencies":{"type":"list","member":{"type":"structure","members":{"namespace":{},"package":{},"dependencyType":{},"versionRequirement":{}}}}}}},"ListPackageVersions":{"http":{"requestUri":"/v1/package/versions"},"input":{"type":"structure","required":["domain","repository","format","package"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"status":{"location":"querystring","locationName":"status"},"sortBy":{"location":"querystring","locationName":"sortBy"},"maxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"nextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"defaultDisplayVersion":{},"format":{},"namespace":{},"package":{},"versions":{"type":"list","member":{"type":"structure","required":["version","status"],"members":{"version":{},"revision":{},"status":{}}}},"nextToken":{}}}},"ListPackages":{"http":{"requestUri":"/v1/packages"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"packagePrefix":{"location":"querystring","locationName":"package-prefix"},"maxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"nextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"packages":{"type":"list","member":{"type":"structure","members":{"format":{},"namespace":{},"package":{}}}},"nextToken":{}}}},"ListRepositories":{"http":{"requestUri":"/v1/repositories"},"input":{"type":"structure","members":{"repositoryPrefix":{"location":"querystring","locationName":"repository-prefix"},"maxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"nextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"repositories":{"shape":"S3f"},"nextToken":{}}}},"ListRepositoriesInDomain":{"http":{"requestUri":"/v1/domain/repositories"},"input":{"type":"structure","required":["domain"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"administratorAccount":{"location":"querystring","locationName":"administrator-account"},"repositoryPrefix":{"location":"querystring","locationName":"repository-prefix"},"maxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"nextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"repositories":{"shape":"S3f"},"nextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/v1/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sy"}}}},"PutDomainPermissionsPolicy":{"http":{"method":"PUT","requestUri":"/v1/domain/permissions/policy"},"input":{"type":"structure","required":["domain","policyDocument"],"members":{"domain":{},"domainOwner":{},"policyRevision":{},"policyDocument":{}}},"output":{"type":"structure","members":{"policy":{"shape":"S1h"}}}},"PutRepositoryPermissionsPolicy":{"http":{"method":"PUT","requestUri":"/v1/repository/permissions/policy"},"input":{"type":"structure","required":["domain","repository","policyDocument"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"policyRevision":{},"policyDocument":{}}},"output":{"type":"structure","members":{"policy":{"shape":"S1h"}}}},"TagResource":{"http":{"requestUri":"/v1/tag"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/v1/untag"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdatePackageVersionsStatus":{"http":{"requestUri":"/v1/package/versions/update_status"},"input":{"type":"structure","required":["domain","repository","format","package","versions","targetStatus"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"format":{"location":"querystring","locationName":"format"},"namespace":{"location":"querystring","locationName":"namespace"},"package":{"location":"querystring","locationName":"package"},"versions":{"shape":"Sj"},"versionRevisions":{"shape":"Sl"},"expectedStatus":{},"targetStatus":{}}},"output":{"type":"structure","members":{"successfulVersions":{"shape":"Sp"},"failedVersions":{"shape":"St"}}}},"UpdateRepository":{"http":{"method":"PUT","requestUri":"/v1/repository"},"input":{"type":"structure","required":["domain","repository"],"members":{"domain":{"location":"querystring","locationName":"domain"},"domainOwner":{"location":"querystring","locationName":"domain-owner"},"repository":{"location":"querystring","locationName":"repository"},"description":{},"upstreams":{"shape":"S19"}}},"output":{"type":"structure","members":{"repository":{"shape":"S7"}}}}},"shapes":{"S7":{"type":"structure","members":{"name":{},"administratorAccount":{},"domainName":{},"domainOwner":{},"arn":{},"description":{},"upstreams":{"type":"list","member":{"type":"structure","members":{"repositoryName":{}}}},"externalConnections":{"type":"list","member":{"type":"structure","members":{"externalConnectionName":{},"packageFormat":{},"status":{}}}}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"map","key":{},"value":{}},"Sp":{"type":"map","key":{},"value":{"type":"structure","members":{"revision":{},"status":{}}}},"St":{"type":"map","key":{},"value":{"type":"structure","members":{"errorCode":{},"errorMessage":{}}}},"Sy":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"S13":{"type":"structure","members":{"name":{},"owner":{},"arn":{},"status":{},"createdTime":{"type":"timestamp"},"encryptionKey":{},"repositoryCount":{"type":"integer"},"assetSizeBytes":{"type":"long"},"s3BucketArn":{}}},"S19":{"type":"list","member":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}}},"S1h":{"type":"structure","members":{"resourceArn":{},"revision":{},"document":{}}},"S3f":{"type":"list","member":{"type":"structure","members":{"name":{},"administratorAccount":{},"domainName":{},"domainOwner":{},"arn":{},"description":{}}}}}}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDomains":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"domains"},"ListPackageVersionAssets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assets"},"ListPackageVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"versions"},"ListPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"packages"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"repositories"},"ListRepositoriesInDomain":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"repositories"}}}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['honeycode'] = {};
	AWS.Honeycode = Service.defineService('honeycode', ['2020-03-01']);
	Object.defineProperty(apiLoader.services['honeycode'], '2020-03-01', {
	  get: function get() {
	    var model = __webpack_require__(888);
	    model.paginators = __webpack_require__(889).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Honeycode;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-03-01","endpointPrefix":"honeycode","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Honeycode","serviceFullName":"Amazon Honeycode","serviceId":"Honeycode","signatureVersion":"v4","signingName":"honeycode","uid":"honeycode-2020-03-01"},"operations":{"BatchCreateTableRows":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/rows/batchcreate"},"input":{"type":"structure","required":["workbookId","tableId","rowsToCreate"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"rowsToCreate":{"type":"list","member":{"type":"structure","required":["batchItemId","cellsToCreate"],"members":{"batchItemId":{},"cellsToCreate":{"shape":"S6"}}}},"clientRequestToken":{}}},"output":{"type":"structure","required":["workbookCursor","createdRows"],"members":{"workbookCursor":{"type":"long"},"createdRows":{"type":"map","key":{},"value":{}},"failedBatchItems":{"shape":"Sf"}}}},"BatchDeleteTableRows":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/rows/batchdelete"},"input":{"type":"structure","required":["workbookId","tableId","rowIds"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"rowIds":{"shape":"Sj"},"clientRequestToken":{}}},"output":{"type":"structure","required":["workbookCursor"],"members":{"workbookCursor":{"type":"long"},"failedBatchItems":{"shape":"Sf"}}}},"BatchUpdateTableRows":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/rows/batchupdate"},"input":{"type":"structure","required":["workbookId","tableId","rowsToUpdate"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"rowsToUpdate":{"type":"list","member":{"type":"structure","required":["rowId","cellsToUpdate"],"members":{"rowId":{},"cellsToUpdate":{"shape":"S6"}}}},"clientRequestToken":{}}},"output":{"type":"structure","required":["workbookCursor"],"members":{"workbookCursor":{"type":"long"},"failedBatchItems":{"shape":"Sf"}}}},"BatchUpsertTableRows":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/rows/batchupsert"},"input":{"type":"structure","required":["workbookId","tableId","rowsToUpsert"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"rowsToUpsert":{"type":"list","member":{"type":"structure","required":["batchItemId","filter","cellsToUpdate"],"members":{"batchItemId":{},"filter":{"shape":"Ss"},"cellsToUpdate":{"shape":"S6"}}}},"clientRequestToken":{}}},"output":{"type":"structure","required":["rows","workbookCursor"],"members":{"rows":{"type":"map","key":{},"value":{"type":"structure","required":["rowIds","upsertAction"],"members":{"rowIds":{"shape":"Sj"},"upsertAction":{}}}},"workbookCursor":{"type":"long"},"failedBatchItems":{"shape":"Sf"}}}},"DescribeTableDataImportJob":{"http":{"method":"GET","requestUri":"/workbooks/{workbookId}/tables/{tableId}/import/{jobId}"},"input":{"type":"structure","required":["workbookId","tableId","jobId"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["jobStatus","message","jobMetadata"],"members":{"jobStatus":{},"message":{},"jobMetadata":{"type":"structure","required":["submitter","submitTime","importOptions","dataSource"],"members":{"submitter":{"type":"structure","members":{"email":{"type":"string","sensitive":true},"userArn":{}}},"submitTime":{"type":"timestamp"},"importOptions":{"shape":"S18"},"dataSource":{"shape":"S1i"}}},"errorCode":{}}}},"GetScreenData":{"http":{"requestUri":"/screendata"},"input":{"type":"structure","required":["workbookId","appId","screenId"],"members":{"workbookId":{},"appId":{},"screenId":{},"variables":{"shape":"S1n"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["results","workbookCursor"],"members":{"results":{"type":"map","key":{"shape":"S1v"},"value":{"type":"structure","required":["headers","rows"],"members":{"headers":{"type":"list","member":{"type":"structure","required":["name","format"],"members":{"name":{"shape":"S1v"},"format":{}}}},"rows":{"type":"list","member":{"type":"structure","required":["dataItems"],"members":{"rowId":{},"dataItems":{"type":"list","member":{"type":"structure","members":{"overrideFormat":{},"rawValue":{},"formattedValue":{}},"sensitive":true}}}}}}}},"workbookCursor":{"type":"long"},"nextToken":{}}}},"InvokeScreenAutomation":{"http":{"requestUri":"/workbooks/{workbookId}/apps/{appId}/screens/{screenId}/automations/{automationId}"},"input":{"type":"structure","required":["workbookId","appId","screenId","screenAutomationId"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"appId":{"location":"uri","locationName":"appId"},"screenId":{"location":"uri","locationName":"screenId"},"screenAutomationId":{"location":"uri","locationName":"automationId"},"variables":{"shape":"S1n"},"rowId":{},"clientRequestToken":{}}},"output":{"type":"structure","required":["workbookCursor"],"members":{"workbookCursor":{"type":"long"}}}},"ListTableColumns":{"http":{"method":"GET","requestUri":"/workbooks/{workbookId}/tables/{tableId}/columns"},"input":{"type":"structure","required":["workbookId","tableId"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["tableColumns"],"members":{"tableColumns":{"type":"list","member":{"type":"structure","members":{"tableColumnId":{},"tableColumnName":{},"format":{}}}},"nextToken":{},"workbookCursor":{"type":"long"}}}},"ListTableRows":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/rows/list"},"input":{"type":"structure","required":["workbookId","tableId"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"rowIds":{"shape":"Sj"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["columnIds","rows","workbookCursor"],"members":{"columnIds":{"shape":"S2e"},"rows":{"shape":"S2f"},"rowIdsNotFound":{"shape":"Sj"},"nextToken":{},"workbookCursor":{"type":"long"}}}},"ListTables":{"http":{"method":"GET","requestUri":"/workbooks/{workbookId}/tables"},"input":{"type":"structure","required":["workbookId"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["tables"],"members":{"tables":{"type":"list","member":{"type":"structure","members":{"tableId":{},"tableName":{}}}},"nextToken":{},"workbookCursor":{"type":"long"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S2s"}}}},"QueryTableRows":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/rows/query"},"input":{"type":"structure","required":["workbookId","tableId","filterFormula"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"tableId":{"location":"uri","locationName":"tableId"},"filterFormula":{"shape":"Ss"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["columnIds","rows","workbookCursor"],"members":{"columnIds":{"shape":"S2e"},"rows":{"shape":"S2f"},"nextToken":{},"workbookCursor":{"type":"long"}}}},"StartTableDataImportJob":{"http":{"requestUri":"/workbooks/{workbookId}/tables/{tableId}/import"},"input":{"type":"structure","required":["workbookId","dataSource","dataFormat","destinationTableId","importOptions","clientRequestToken"],"members":{"workbookId":{"location":"uri","locationName":"workbookId"},"dataSource":{"shape":"S1i"},"dataFormat":{},"destinationTableId":{"location":"uri","locationName":"tableId"},"importOptions":{"shape":"S18"},"clientRequestToken":{}}},"output":{"type":"structure","required":["jobId","jobStatus"],"members":{"jobId":{},"jobStatus":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S2s"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"map","key":{},"value":{"type":"structure","members":{"fact":{"shape":"S8"},"facts":{"type":"list","member":{"shape":"S8"}}}}},"S8":{"type":"string","sensitive":true},"Sf":{"type":"list","member":{"type":"structure","required":["id","errorMessage"],"members":{"id":{},"errorMessage":{}}}},"Sj":{"type":"list","member":{}},"Ss":{"type":"structure","required":["formula"],"members":{"formula":{"shape":"St"},"contextRowId":{}}},"St":{"type":"string","sensitive":true},"S18":{"type":"structure","members":{"destinationOptions":{"type":"structure","members":{"columnMap":{"type":"map","key":{},"value":{"type":"structure","members":{"columnIndex":{"type":"integer"}}}}}},"delimitedTextOptions":{"type":"structure","required":["delimiter"],"members":{"delimiter":{},"hasHeaderRow":{"type":"boolean"},"ignoreEmptyRows":{"type":"boolean"},"dataCharacterEncoding":{}}}}},"S1i":{"type":"structure","required":["dataSourceConfig"],"members":{"dataSourceConfig":{"type":"structure","members":{"dataSourceUrl":{"type":"string","sensitive":true}}}}},"S1n":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"structure","required":["rawValue"],"members":{"rawValue":{}},"sensitive":true},"sensitive":true},"S1v":{"type":"string","sensitive":true},"S2e":{"type":"list","member":{}},"S2f":{"type":"list","member":{"type":"structure","required":["rowId","cells"],"members":{"rowId":{},"cells":{"type":"list","member":{"type":"structure","members":{"formula":{"shape":"St"},"format":{},"rawValue":{},"formattedValue":{},"formattedValues":{"type":"list","member":{}}},"sensitive":true}}}}},"S2s":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListTableColumns":{"input_token":"nextToken","output_token":"nextToken","result_key":"tableColumns"},"ListTableRows":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"rows"},"ListTables":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tables"},"QueryTableRows":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"rows"}}}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ivs'] = {};
	AWS.IVS = Service.defineService('ivs', ['2020-07-14']);
	Object.defineProperty(apiLoader.services['ivs'], '2020-07-14', {
	  get: function get() {
	    var model = __webpack_require__(891);
	    model.paginators = __webpack_require__(892).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IVS;


/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-14","endpointPrefix":"ivs","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon IVS","serviceFullName":"Amazon Interactive Video Service","serviceId":"ivs","signatureVersion":"v4","signingName":"ivs","uid":"ivs-2020-07-14"},"operations":{"BatchGetChannel":{"http":{"requestUri":"/BatchGetChannel","responseCode":200},"input":{"type":"structure","required":["arns"],"members":{"arns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"channels":{"type":"list","member":{"shape":"S6"}},"errors":{"shape":"Sh"}}}},"BatchGetStreamKey":{"http":{"requestUri":"/BatchGetStreamKey","responseCode":200},"input":{"type":"structure","required":["arns"],"members":{"arns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"errors":{"shape":"Sh"},"streamKeys":{"type":"list","member":{"shape":"Sr"}}}}},"CreateChannel":{"http":{"requestUri":"/CreateChannel","responseCode":200},"input":{"type":"structure","members":{"authorized":{"type":"boolean"},"latencyMode":{},"name":{},"recordingConfigurationArn":{},"tags":{"shape":"Sd"},"type":{}}},"output":{"type":"structure","members":{"channel":{"shape":"S6"},"streamKey":{"shape":"Sr"}}}},"CreateRecordingConfiguration":{"http":{"requestUri":"/CreateRecordingConfiguration","responseCode":200},"input":{"type":"structure","required":["destinationConfiguration"],"members":{"destinationConfiguration":{"shape":"Sx"},"name":{},"tags":{"shape":"Sd"},"thumbnailConfiguration":{"shape":"S11"}}},"output":{"type":"structure","members":{"recordingConfiguration":{"shape":"S15"}}}},"CreateStreamKey":{"http":{"requestUri":"/CreateStreamKey","responseCode":200},"input":{"type":"structure","required":["channelArn"],"members":{"channelArn":{},"tags":{"shape":"Sd"}}},"output":{"type":"structure","members":{"streamKey":{"shape":"Sr"}}}},"DeleteChannel":{"http":{"requestUri":"/DeleteChannel","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"DeletePlaybackKeyPair":{"http":{"requestUri":"/DeletePlaybackKeyPair","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRecordingConfiguration":{"http":{"requestUri":"/DeleteRecordingConfiguration","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"DeleteStreamKey":{"http":{"requestUri":"/DeleteStreamKey","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"GetChannel":{"http":{"requestUri":"/GetChannel","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"channel":{"shape":"S6"}}}},"GetPlaybackKeyPair":{"http":{"requestUri":"/GetPlaybackKeyPair","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"keyPair":{"shape":"S1k"}}}},"GetRecordingConfiguration":{"http":{"requestUri":"/GetRecordingConfiguration","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"recordingConfiguration":{"shape":"S15"}}}},"GetStream":{"http":{"requestUri":"/GetStream","responseCode":200},"input":{"type":"structure","required":["channelArn"],"members":{"channelArn":{}}},"output":{"type":"structure","members":{"stream":{"type":"structure","members":{"channelArn":{},"health":{},"playbackUrl":{},"startTime":{"shape":"S1t"},"state":{},"streamId":{},"viewerCount":{"type":"long"}}}}}},"GetStreamKey":{"http":{"requestUri":"/GetStreamKey","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"streamKey":{"shape":"Sr"}}}},"GetStreamSession":{"http":{"requestUri":"/GetStreamSession","responseCode":200},"input":{"type":"structure","required":["channelArn"],"members":{"channelArn":{},"streamId":{}}},"output":{"type":"structure","members":{"streamSession":{"type":"structure","members":{"channel":{"shape":"S6"},"endTime":{"shape":"S22"},"ingestConfiguration":{"type":"structure","members":{"audio":{"type":"structure","members":{"channels":{"type":"long"},"codec":{},"sampleRate":{"type":"long"},"targetBitrate":{"type":"long"}}},"video":{"type":"structure","members":{"avcLevel":{},"avcProfile":{},"codec":{},"encoder":{},"targetBitrate":{"type":"long"},"targetFramerate":{"type":"long"},"videoHeight":{"type":"long"},"videoWidth":{"type":"long"}}}}},"recordingConfiguration":{"shape":"S15"},"startTime":{"shape":"S22"},"streamId":{},"truncatedEvents":{"type":"list","member":{"type":"structure","members":{"eventTime":{"shape":"S22"},"name":{},"type":{}}}}}}}}},"ImportPlaybackKeyPair":{"http":{"requestUri":"/ImportPlaybackKeyPair","responseCode":200},"input":{"type":"structure","required":["publicKeyMaterial"],"members":{"name":{},"publicKeyMaterial":{},"tags":{"shape":"Sd"}}},"output":{"type":"structure","members":{"keyPair":{"shape":"S1k"}}}},"ListChannels":{"http":{"requestUri":"/ListChannels","responseCode":200},"input":{"type":"structure","members":{"filterByName":{},"filterByRecordingConfigurationArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["channels"],"members":{"channels":{"type":"list","member":{"type":"structure","members":{"arn":{},"authorized":{"type":"boolean"},"latencyMode":{},"name":{},"recordingConfigurationArn":{},"tags":{"shape":"Sd"}}}},"nextToken":{}}}},"ListPlaybackKeyPairs":{"http":{"requestUri":"/ListPlaybackKeyPairs","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["keyPairs"],"members":{"keyPairs":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"tags":{"shape":"Sd"}}}},"nextToken":{}}}},"ListRecordingConfigurations":{"http":{"requestUri":"/ListRecordingConfigurations","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["recordingConfigurations"],"members":{"nextToken":{},"recordingConfigurations":{"type":"list","member":{"type":"structure","required":["arn","destinationConfiguration","state"],"members":{"arn":{},"destinationConfiguration":{"shape":"Sx"},"name":{},"state":{},"tags":{"shape":"Sd"}}}}}}},"ListStreamKeys":{"http":{"requestUri":"/ListStreamKeys","responseCode":200},"input":{"type":"structure","required":["channelArn"],"members":{"channelArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["streamKeys"],"members":{"nextToken":{},"streamKeys":{"type":"list","member":{"type":"structure","members":{"arn":{},"channelArn":{},"tags":{"shape":"Sd"}}}}}}},"ListStreamSessions":{"http":{"requestUri":"/ListStreamSessions","responseCode":200},"input":{"type":"structure","required":["channelArn"],"members":{"channelArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["streamSessions"],"members":{"nextToken":{},"streamSessions":{"type":"list","member":{"type":"structure","members":{"endTime":{"shape":"S22"},"hasErrorEvent":{"type":"boolean"},"startTime":{"shape":"S22"},"streamId":{}}}}}}},"ListStreams":{"http":{"requestUri":"/ListStreams","responseCode":200},"input":{"type":"structure","members":{"filterBy":{"type":"structure","members":{"health":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["streams"],"members":{"nextToken":{},"streams":{"type":"list","member":{"type":"structure","members":{"channelArn":{},"health":{},"startTime":{"shape":"S1t"},"state":{},"streamId":{},"viewerCount":{"type":"long"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"Sd"}}}},"PutMetadata":{"http":{"requestUri":"/PutMetadata","responseCode":200},"input":{"type":"structure","required":["channelArn","metadata"],"members":{"channelArn":{},"metadata":{"type":"string","sensitive":true}}}},"StopStream":{"http":{"requestUri":"/StopStream","responseCode":200},"input":{"type":"structure","required":["channelArn"],"members":{"channelArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateChannel":{"http":{"requestUri":"/UpdateChannel","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{},"authorized":{"type":"boolean"},"latencyMode":{},"name":{},"recordingConfigurationArn":{},"type":{}}},"output":{"type":"structure","members":{"channel":{"shape":"S6"}}}}},"shapes":{"S6":{"type":"structure","members":{"arn":{},"authorized":{"type":"boolean"},"ingestEndpoint":{},"latencyMode":{},"name":{},"playbackUrl":{},"recordingConfigurationArn":{},"tags":{"shape":"Sd"},"type":{}}},"Sd":{"type":"map","key":{},"value":{}},"Sh":{"type":"list","member":{"type":"structure","members":{"arn":{},"code":{},"message":{}}}},"Sr":{"type":"structure","members":{"arn":{},"channelArn":{},"tags":{"shape":"Sd"},"value":{"type":"string","sensitive":true}}},"Sx":{"type":"structure","members":{"s3":{"type":"structure","required":["bucketName"],"members":{"bucketName":{}}}}},"S11":{"type":"structure","members":{"recordingMode":{},"targetIntervalSeconds":{"type":"long"}}},"S15":{"type":"structure","required":["arn","destinationConfiguration","state"],"members":{"arn":{},"destinationConfiguration":{"shape":"Sx"},"name":{},"state":{},"tags":{"shape":"Sd"},"thumbnailConfiguration":{"shape":"S11"}}},"S1k":{"type":"structure","members":{"arn":{},"fingerprint":{},"name":{},"tags":{"shape":"Sd"}}},"S1t":{"type":"timestamp","timestampFormat":"iso8601"},"S22":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChannels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPlaybackKeyPairs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRecordingConfigurations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListStreamKeys":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListStreamSessions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListStreams":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['braket'] = {};
	AWS.Braket = Service.defineService('braket', ['2019-09-01']);
	Object.defineProperty(apiLoader.services['braket'], '2019-09-01', {
	  get: function get() {
	    var model = __webpack_require__(894);
	    model.paginators = __webpack_require__(895).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Braket;


/***/ }),
/* 894 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-09-01","endpointPrefix":"braket","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Braket","serviceId":"Braket","signatureVersion":"v4","signingName":"braket","uid":"braket-2019-09-01"},"operations":{"CancelJob":{"http":{"method":"PUT","requestUri":"/job/{jobArn}/cancel","responseCode":200},"input":{"type":"structure","required":["jobArn"],"members":{"jobArn":{"location":"uri","locationName":"jobArn"}}},"output":{"type":"structure","required":["cancellationStatus","jobArn"],"members":{"cancellationStatus":{},"jobArn":{}}},"idempotent":true},"CancelQuantumTask":{"http":{"method":"PUT","requestUri":"/quantum-task/{quantumTaskArn}/cancel","responseCode":200},"input":{"type":"structure","required":["clientToken","quantumTaskArn"],"members":{"clientToken":{"idempotencyToken":true},"quantumTaskArn":{"location":"uri","locationName":"quantumTaskArn"}}},"output":{"type":"structure","required":["cancellationStatus","quantumTaskArn"],"members":{"cancellationStatus":{},"quantumTaskArn":{}}},"idempotent":true},"CreateJob":{"http":{"requestUri":"/job","responseCode":201},"input":{"type":"structure","required":["algorithmSpecification","clientToken","deviceConfig","instanceConfig","jobName","outputDataConfig","roleArn"],"members":{"algorithmSpecification":{"shape":"Sa"},"checkpointConfig":{"shape":"Sh"},"clientToken":{"idempotencyToken":true},"deviceConfig":{"shape":"Sj"},"hyperParameters":{"shape":"Sl"},"inputDataConfig":{"type":"list","member":{"shape":"So"}},"instanceConfig":{"shape":"Ss"},"jobName":{},"outputDataConfig":{"shape":"Sx"},"roleArn":{},"stoppingCondition":{"shape":"S10"},"tags":{"shape":"S12"}}},"output":{"type":"structure","required":["jobArn"],"members":{"jobArn":{}}}},"CreateQuantumTask":{"http":{"requestUri":"/quantum-task","responseCode":201},"input":{"type":"structure","required":["action","clientToken","deviceArn","outputS3Bucket","outputS3KeyPrefix","shots"],"members":{"action":{"jsonvalue":true},"clientToken":{"idempotencyToken":true},"deviceArn":{},"deviceParameters":{"jsonvalue":true},"jobToken":{},"outputS3Bucket":{},"outputS3KeyPrefix":{},"shots":{"type":"long"},"tags":{"shape":"S12"}}},"output":{"type":"structure","required":["quantumTaskArn"],"members":{"quantumTaskArn":{}}}},"GetDevice":{"http":{"method":"GET","requestUri":"/device/{deviceArn}","responseCode":200},"input":{"type":"structure","required":["deviceArn"],"members":{"deviceArn":{"location":"uri","locationName":"deviceArn"}}},"output":{"type":"structure","required":["deviceArn","deviceCapabilities","deviceName","deviceStatus","deviceType","providerName"],"members":{"deviceArn":{},"deviceCapabilities":{"jsonvalue":true},"deviceName":{},"deviceStatus":{},"deviceType":{},"providerName":{}}}},"GetJob":{"http":{"method":"GET","requestUri":"/job/{jobArn}","responseCode":200},"input":{"type":"structure","required":["jobArn"],"members":{"jobArn":{"location":"uri","locationName":"jobArn"}}},"output":{"type":"structure","required":["algorithmSpecification","createdAt","instanceConfig","jobArn","jobName","outputDataConfig","roleArn","status"],"members":{"algorithmSpecification":{"shape":"Sa"},"billableDuration":{"type":"integer"},"checkpointConfig":{"shape":"Sh"},"createdAt":{"shape":"S1k"},"deviceConfig":{"shape":"Sj"},"endedAt":{"shape":"S1k"},"events":{"type":"list","member":{"type":"structure","members":{"eventType":{},"message":{},"timeOfEvent":{"shape":"S1k"}}}},"failureReason":{},"hyperParameters":{"shape":"Sl"},"inputDataConfig":{"type":"list","member":{"shape":"So"}},"instanceConfig":{"shape":"Ss"},"jobArn":{},"jobName":{},"outputDataConfig":{"shape":"Sx"},"roleArn":{},"startedAt":{"shape":"S1k"},"status":{},"stoppingCondition":{"shape":"S10"},"tags":{"shape":"S12"}}}},"GetQuantumTask":{"http":{"method":"GET","requestUri":"/quantum-task/{quantumTaskArn}","responseCode":200},"input":{"type":"structure","required":["quantumTaskArn"],"members":{"quantumTaskArn":{"location":"uri","locationName":"quantumTaskArn"}}},"output":{"type":"structure","required":["createdAt","deviceArn","deviceParameters","outputS3Bucket","outputS3Directory","quantumTaskArn","shots","status"],"members":{"createdAt":{"shape":"S1k"},"deviceArn":{},"deviceParameters":{"jsonvalue":true},"endedAt":{"shape":"S1k"},"failureReason":{},"jobArn":{},"outputS3Bucket":{},"outputS3Directory":{},"quantumTaskArn":{},"shots":{"type":"long"},"status":{},"tags":{"shape":"S12"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S12"}}}},"SearchDevices":{"http":{"requestUri":"/devices","responseCode":200},"input":{"type":"structure","required":["filters"],"members":{"filters":{"type":"list","member":{"type":"structure","required":["name","values"],"members":{"name":{},"values":{"type":"list","member":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["devices"],"members":{"devices":{"type":"list","member":{"type":"structure","required":["deviceArn","deviceName","deviceStatus","deviceType","providerName"],"members":{"deviceArn":{},"deviceName":{},"deviceStatus":{},"deviceType":{},"providerName":{}}}},"nextToken":{}}}},"SearchJobs":{"http":{"requestUri":"/jobs","responseCode":200},"input":{"type":"structure","required":["filters"],"members":{"filters":{"type":"list","member":{"type":"structure","required":["name","operator","values"],"members":{"name":{},"operator":{},"values":{"type":"list","member":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["jobs"],"members":{"jobs":{"type":"list","member":{"type":"structure","required":["createdAt","device","jobArn","jobName","status"],"members":{"createdAt":{"shape":"S1k"},"device":{},"endedAt":{"shape":"S1k"},"jobArn":{},"jobName":{},"startedAt":{"shape":"S1k"},"status":{},"tags":{"shape":"S12"}}}},"nextToken":{}}}},"SearchQuantumTasks":{"http":{"requestUri":"/quantum-tasks","responseCode":200},"input":{"type":"structure","required":["filters"],"members":{"filters":{"type":"list","member":{"type":"structure","required":["name","operator","values"],"members":{"name":{},"operator":{},"values":{"type":"list","member":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["quantumTasks"],"members":{"nextToken":{},"quantumTasks":{"type":"list","member":{"type":"structure","required":["createdAt","deviceArn","outputS3Bucket","outputS3Directory","quantumTaskArn","shots","status"],"members":{"createdAt":{"shape":"S1k"},"deviceArn":{},"endedAt":{"shape":"S1k"},"outputS3Bucket":{},"outputS3Directory":{},"quantumTaskArn":{},"shots":{"type":"long"},"status":{},"tags":{"shape":"S12"}}}}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"Sa":{"type":"structure","members":{"containerImage":{"type":"structure","required":["uri"],"members":{"uri":{}}},"scriptModeConfig":{"type":"structure","required":["entryPoint","s3Uri"],"members":{"compressionType":{},"entryPoint":{},"s3Uri":{}}}}},"Sh":{"type":"structure","required":["s3Uri"],"members":{"localPath":{},"s3Uri":{}}},"Sj":{"type":"structure","required":["device"],"members":{"device":{}}},"Sl":{"type":"map","key":{},"value":{}},"So":{"type":"structure","required":["channelName","dataSource"],"members":{"channelName":{},"contentType":{},"dataSource":{"type":"structure","required":["s3DataSource"],"members":{"s3DataSource":{"type":"structure","required":["s3Uri"],"members":{"s3Uri":{}}}}}}},"Ss":{"type":"structure","required":["instanceType","volumeSizeInGb"],"members":{"instanceCount":{"type":"integer"},"instanceType":{},"volumeSizeInGb":{"type":"integer"}}},"Sx":{"type":"structure","required":["s3Path"],"members":{"kmsKeyId":{},"s3Path":{}}},"S10":{"type":"structure","members":{"maxRuntimeInSeconds":{"type":"integer"}}},"S12":{"type":"map","key":{},"value":{}},"S1k":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"SearchDevices":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"devices"},"SearchJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobs"},"SearchQuantumTasks":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"quantumTasks"}}}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['identitystore'] = {};
	AWS.IdentityStore = Service.defineService('identitystore', ['2020-06-15']);
	Object.defineProperty(apiLoader.services['identitystore'], '2020-06-15', {
	  get: function get() {
	    var model = __webpack_require__(897);
	    model.paginators = __webpack_require__(898).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IdentityStore;


/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-06-15","endpointPrefix":"identitystore","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"IdentityStore","serviceFullName":"AWS SSO Identity Store","serviceId":"identitystore","signatureVersion":"v4","signingName":"identitystore","targetPrefix":"AWSIdentityStore","uid":"identitystore-2020-06-15"},"operations":{"DescribeGroup":{"input":{"type":"structure","required":["IdentityStoreId","GroupId"],"members":{"IdentityStoreId":{},"GroupId":{}}},"output":{"type":"structure","required":["GroupId","DisplayName"],"members":{"GroupId":{},"DisplayName":{}}}},"DescribeUser":{"input":{"type":"structure","required":["IdentityStoreId","UserId"],"members":{"IdentityStoreId":{},"UserId":{}}},"output":{"type":"structure","required":["UserName","UserId"],"members":{"UserName":{"shape":"S8"},"UserId":{}}}},"ListGroups":{"input":{"type":"structure","required":["IdentityStoreId"],"members":{"IdentityStoreId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sc"}}},"output":{"type":"structure","required":["Groups"],"members":{"Groups":{"type":"list","member":{"type":"structure","required":["GroupId","DisplayName"],"members":{"GroupId":{},"DisplayName":{}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["IdentityStoreId"],"members":{"IdentityStoreId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sc"}}},"output":{"type":"structure","required":["Users"],"members":{"Users":{"type":"list","member":{"type":"structure","required":["UserName","UserId"],"members":{"UserName":{"shape":"S8"},"UserId":{}}}},"NextToken":{}}}}},"shapes":{"S8":{"type":"string","sensitive":true},"Sc":{"type":"list","member":{"type":"structure","required":["AttributePath","AttributeValue"],"members":{"AttributePath":{},"AttributeValue":{"type":"string","sensitive":true}}}}}}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appflow'] = {};
	AWS.Appflow = Service.defineService('appflow', ['2020-08-23']);
	Object.defineProperty(apiLoader.services['appflow'], '2020-08-23', {
	  get: function get() {
	    var model = __webpack_require__(900);
	    model.paginators = __webpack_require__(901).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Appflow;


/***/ }),
/* 900 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-23","endpointPrefix":"appflow","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Appflow","serviceId":"Appflow","signatureVersion":"v4","signingName":"appflow","uid":"appflow-2020-08-23"},"operations":{"CreateConnectorProfile":{"http":{"requestUri":"/create-connector-profile"},"input":{"type":"structure","required":["connectorProfileName","connectorType","connectionMode","connectorProfileConfig"],"members":{"connectorProfileName":{},"kmsArn":{},"connectorType":{},"connectorLabel":{},"connectionMode":{},"connectorProfileConfig":{"shape":"S7"}}},"output":{"type":"structure","members":{"connectorProfileArn":{}}}},"CreateFlow":{"http":{"requestUri":"/create-flow"},"input":{"type":"structure","required":["flowName","triggerConfig","sourceFlowConfig","destinationFlowConfigList","tasks"],"members":{"flowName":{},"description":{},"kmsArn":{},"triggerConfig":{"shape":"S2z"},"sourceFlowConfig":{"shape":"S38"},"destinationFlowConfigList":{"shape":"S3z"},"tasks":{"shape":"S4v"},"tags":{"shape":"S5l"}}},"output":{"type":"structure","members":{"flowArn":{},"flowStatus":{}}}},"DeleteConnectorProfile":{"http":{"requestUri":"/delete-connector-profile"},"input":{"type":"structure","required":["connectorProfileName"],"members":{"connectorProfileName":{},"forceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteFlow":{"http":{"requestUri":"/delete-flow"},"input":{"type":"structure","required":["flowName"],"members":{"flowName":{},"forceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeConnector":{"http":{"requestUri":"/describe-connector"},"input":{"type":"structure","required":["connectorType"],"members":{"connectorType":{},"connectorLabel":{}}},"output":{"type":"structure","members":{"connectorConfiguration":{"shape":"S5x"}}}},"DescribeConnectorEntity":{"http":{"requestUri":"/describe-connector-entity"},"input":{"type":"structure","required":["connectorEntityName"],"members":{"connectorEntityName":{},"connectorType":{},"connectorProfileName":{},"apiVersion":{}}},"output":{"type":"structure","required":["connectorEntityFields"],"members":{"connectorEntityFields":{"type":"list","member":{"type":"structure","required":["identifier"],"members":{"identifier":{},"parentIdentifier":{},"label":{},"isPrimaryKey":{"type":"boolean"},"defaultValue":{},"isDeprecated":{"type":"boolean"},"supportedFieldTypeDetails":{"type":"structure","required":["v1"],"members":{"v1":{"type":"structure","required":["fieldType","filterOperators"],"members":{"fieldType":{},"filterOperators":{"type":"list","member":{}},"supportedValues":{"type":"list","member":{}},"valueRegexPattern":{},"supportedDateFormat":{},"fieldValueRange":{"shape":"S82"},"fieldLengthRange":{"shape":"S82"}}}}},"description":{},"sourceProperties":{"type":"structure","members":{"isRetrievable":{"type":"boolean"},"isQueryable":{"type":"boolean"},"isTimestampFieldForIncrementalQueries":{"type":"boolean"}}},"destinationProperties":{"type":"structure","members":{"isCreatable":{"type":"boolean"},"isNullable":{"type":"boolean"},"isUpsertable":{"type":"boolean"},"isUpdatable":{"type":"boolean"},"isDefaultedOnCreate":{"type":"boolean"},"supportedWriteOperations":{"shape":"S7l"}}},"customProperties":{"shape":"S3w"}}}}}}},"DescribeConnectorProfiles":{"http":{"requestUri":"/describe-connector-profiles"},"input":{"type":"structure","members":{"connectorProfileNames":{"type":"list","member":{}},"connectorType":{},"connectorLabel":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"connectorProfileDetails":{"type":"list","member":{"type":"structure","members":{"connectorProfileArn":{},"connectorProfileName":{},"connectorType":{},"connectorLabel":{},"connectionMode":{},"credentialsArn":{},"connectorProfileProperties":{"shape":"S8"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"privateConnectionProvisioningState":{"type":"structure","members":{"status":{},"failureMessage":{},"failureCause":{}}}}}},"nextToken":{}}}},"DescribeConnectors":{"http":{"requestUri":"/describe-connectors"},"input":{"type":"structure","members":{"connectorTypes":{"shape":"S5y"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"connectorConfigurations":{"type":"map","key":{},"value":{"shape":"S5x"}},"connectors":{"shape":"S8k"},"nextToken":{}}}},"DescribeFlow":{"http":{"requestUri":"/describe-flow"},"input":{"type":"structure","required":["flowName"],"members":{"flowName":{}}},"output":{"type":"structure","members":{"flowArn":{},"description":{},"flowName":{},"kmsArn":{},"flowStatus":{},"flowStatusMessage":{},"sourceFlowConfig":{"shape":"S38"},"destinationFlowConfigList":{"shape":"S3z"},"lastRunExecutionDetails":{"shape":"S8q"},"triggerConfig":{"shape":"S2z"},"tasks":{"shape":"S4v"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"createdBy":{},"lastUpdatedBy":{},"tags":{"shape":"S5l"}}}},"DescribeFlowExecutionRecords":{"http":{"requestUri":"/describe-flow-execution-records"},"input":{"type":"structure","required":["flowName"],"members":{"flowName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"flowExecutions":{"type":"list","member":{"type":"structure","members":{"executionId":{},"executionStatus":{},"executionResult":{"type":"structure","members":{"errorInfo":{"type":"structure","members":{"putFailuresCount":{"type":"long"},"executionMessage":{}}},"bytesProcessed":{"type":"long"},"bytesWritten":{"type":"long"},"recordsProcessed":{"type":"long"}}},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"dataPullStartTime":{"type":"timestamp"},"dataPullEndTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListConnectorEntities":{"http":{"requestUri":"/list-connector-entities"},"input":{"type":"structure","members":{"connectorProfileName":{},"connectorType":{},"entitiesPath":{},"apiVersion":{}}},"output":{"type":"structure","required":["connectorEntityMap"],"members":{"connectorEntityMap":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"label":{},"hasNestedEntities":{"type":"boolean"}}}}}}}},"ListConnectors":{"http":{"requestUri":"/list-connectors"},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"connectors":{"shape":"S8k"},"nextToken":{}}}},"ListFlows":{"http":{"requestUri":"/list-flows"},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"flows":{"type":"list","member":{"type":"structure","members":{"flowArn":{},"description":{},"flowName":{},"flowStatus":{},"sourceConnectorType":{},"sourceConnectorLabel":{},"destinationConnectorType":{},"destinationConnectorLabel":{},"triggerType":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"createdBy":{},"lastUpdatedBy":{},"tags":{"shape":"S5l"},"lastRunExecutionDetails":{"shape":"S8q"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5l"}}}},"RegisterConnector":{"http":{"requestUri":"/register-connector"},"input":{"type":"structure","members":{"connectorLabel":{},"description":{},"connectorProvisioningType":{},"connectorProvisioningConfig":{"shape":"S7n"}}},"output":{"type":"structure","members":{"connectorArn":{}}}},"StartFlow":{"http":{"requestUri":"/start-flow"},"input":{"type":"structure","required":["flowName"],"members":{"flowName":{}}},"output":{"type":"structure","members":{"flowArn":{},"flowStatus":{},"executionId":{}}}},"StopFlow":{"http":{"requestUri":"/stop-flow"},"input":{"type":"structure","required":["flowName"],"members":{"flowName":{}}},"output":{"type":"structure","members":{"flowArn":{},"flowStatus":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S5l"}}},"output":{"type":"structure","members":{}}},"UnregisterConnector":{"http":{"requestUri":"/unregister-connector"},"input":{"type":"structure","required":["connectorLabel"],"members":{"connectorLabel":{},"forceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConnectorProfile":{"http":{"requestUri":"/update-connector-profile"},"input":{"type":"structure","required":["connectorProfileName","connectionMode","connectorProfileConfig"],"members":{"connectorProfileName":{},"connectionMode":{},"connectorProfileConfig":{"shape":"S7"}}},"output":{"type":"structure","members":{"connectorProfileArn":{}}}},"UpdateFlow":{"http":{"requestUri":"/update-flow"},"input":{"type":"structure","required":["flowName","triggerConfig","sourceFlowConfig","destinationFlowConfigList","tasks"],"members":{"flowName":{},"description":{},"triggerConfig":{"shape":"S2z"},"sourceFlowConfig":{"shape":"S38"},"destinationFlowConfigList":{"shape":"S3z"},"tasks":{"shape":"S4v"}}},"output":{"type":"structure","members":{"flowStatus":{}}}}},"shapes":{"S7":{"type":"structure","required":["connectorProfileProperties","connectorProfileCredentials"],"members":{"connectorProfileProperties":{"shape":"S8"},"connectorProfileCredentials":{"type":"structure","members":{"Amplitude":{"type":"structure","required":["apiKey","secretKey"],"members":{"apiKey":{"shape":"S1m"},"secretKey":{"type":"string","sensitive":true}}},"Datadog":{"type":"structure","required":["apiKey","applicationKey"],"members":{"apiKey":{"shape":"S1m"},"applicationKey":{}}},"Dynatrace":{"type":"structure","required":["apiToken"],"members":{"apiToken":{}}},"GoogleAnalytics":{"type":"structure","required":["clientId","clientSecret"],"members":{"clientId":{},"clientSecret":{"shape":"S1u"},"accessToken":{"shape":"S1v"},"refreshToken":{},"oAuthRequest":{"shape":"S1x"}}},"Honeycode":{"type":"structure","members":{"accessToken":{"shape":"S1v"},"refreshToken":{},"oAuthRequest":{"shape":"S1x"}}},"InforNexus":{"type":"structure","required":["accessKeyId","userId","secretAccessKey","datakey"],"members":{"accessKeyId":{"type":"string","sensitive":true},"userId":{},"secretAccessKey":{},"datakey":{}}},"Marketo":{"type":"structure","required":["clientId","clientSecret"],"members":{"clientId":{},"clientSecret":{"shape":"S1u"},"accessToken":{"shape":"S1v"},"oAuthRequest":{"shape":"S1x"}}},"Redshift":{"type":"structure","required":["username","password"],"members":{"username":{},"password":{"shape":"S27"}}},"Salesforce":{"type":"structure","members":{"accessToken":{"shape":"S1v"},"refreshToken":{},"oAuthRequest":{"shape":"S1x"},"clientCredentialsArn":{"type":"string","sensitive":true}}},"ServiceNow":{"type":"structure","required":["username","password"],"members":{"username":{},"password":{"shape":"S27"}}},"Singular":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"shape":"S1m"}}},"Slack":{"type":"structure","required":["clientId","clientSecret"],"members":{"clientId":{},"clientSecret":{"shape":"S1u"},"accessToken":{"shape":"S1v"},"oAuthRequest":{"shape":"S1x"}}},"Snowflake":{"type":"structure","required":["username","password"],"members":{"username":{},"password":{"shape":"S27"}}},"Trendmicro":{"type":"structure","required":["apiSecretKey"],"members":{"apiSecretKey":{"shape":"S2f"}}},"Veeva":{"type":"structure","required":["username","password"],"members":{"username":{},"password":{"shape":"S27"}}},"Zendesk":{"type":"structure","required":["clientId","clientSecret"],"members":{"clientId":{},"clientSecret":{"shape":"S1u"},"accessToken":{"shape":"S1v"},"oAuthRequest":{"shape":"S1x"}}},"SAPOData":{"type":"structure","members":{"basicAuthCredentials":{"shape":"S2j"},"oAuthCredentials":{"type":"structure","required":["clientId","clientSecret"],"members":{"clientId":{},"clientSecret":{"shape":"S1u"},"accessToken":{"shape":"S1v"},"refreshToken":{},"oAuthRequest":{"shape":"S1x"}}}}},"CustomConnector":{"type":"structure","required":["authenticationType"],"members":{"authenticationType":{},"basic":{"shape":"S2j"},"oauth2":{"type":"structure","members":{"clientId":{},"clientSecret":{"shape":"S1u"},"accessToken":{"shape":"S1v"},"refreshToken":{},"oAuthRequest":{"shape":"S1x"}}},"apiKey":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"shape":"S1m"},"apiSecretKey":{"shape":"S2f"}}},"custom":{"type":"structure","required":["customAuthenticationType"],"members":{"customAuthenticationType":{},"credentialsMap":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true}}}}}}}}}},"S8":{"type":"structure","members":{"Amplitude":{"type":"structure","members":{}},"Datadog":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"Dynatrace":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"GoogleAnalytics":{"type":"structure","members":{}},"Honeycode":{"type":"structure","members":{}},"InforNexus":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"Marketo":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"Redshift":{"type":"structure","required":["databaseUrl","bucketName","roleArn"],"members":{"databaseUrl":{},"bucketName":{},"bucketPrefix":{},"roleArn":{}}},"Salesforce":{"type":"structure","members":{"instanceUrl":{},"isSandboxEnvironment":{"type":"boolean"}}},"ServiceNow":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"Singular":{"type":"structure","members":{}},"Slack":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"Snowflake":{"type":"structure","required":["warehouse","stage","bucketName"],"members":{"warehouse":{},"stage":{},"bucketName":{},"bucketPrefix":{},"privateLinkServiceName":{},"accountName":{},"region":{}}},"Trendmicro":{"type":"structure","members":{}},"Veeva":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"Zendesk":{"type":"structure","required":["instanceUrl"],"members":{"instanceUrl":{}}},"SAPOData":{"type":"structure","required":["applicationHostUrl","applicationServicePath","portNumber","clientNumber"],"members":{"applicationHostUrl":{},"applicationServicePath":{},"portNumber":{"type":"integer"},"clientNumber":{},"logonLanguage":{},"privateLinkServiceName":{},"oAuthProperties":{"type":"structure","required":["tokenUrl","authCodeUrl","oAuthScopes"],"members":{"tokenUrl":{},"authCodeUrl":{},"oAuthScopes":{"shape":"S19"}}}}},"CustomConnector":{"type":"structure","members":{"profileProperties":{"type":"map","key":{},"value":{}},"oAuth2Properties":{"type":"structure","required":["tokenUrl","oAuth2GrantType"],"members":{"tokenUrl":{},"oAuth2GrantType":{},"tokenUrlCustomProperties":{"type":"map","key":{},"value":{}}}}}}}},"S19":{"type":"list","member":{}},"S1m":{"type":"string","sensitive":true},"S1u":{"type":"string","sensitive":true},"S1v":{"type":"string","sensitive":true},"S1x":{"type":"structure","members":{"authCode":{},"redirectUri":{}}},"S27":{"type":"string","sensitive":true},"S2f":{"type":"string","sensitive":true},"S2j":{"type":"structure","required":["username","password"],"members":{"username":{},"password":{"shape":"S27"}}},"S2z":{"type":"structure","required":["triggerType"],"members":{"triggerType":{},"triggerProperties":{"type":"structure","members":{"Scheduled":{"type":"structure","required":["scheduleExpression"],"members":{"scheduleExpression":{},"dataPullMode":{},"scheduleStartTime":{"type":"timestamp"},"scheduleEndTime":{"type":"timestamp"},"timezone":{},"scheduleOffset":{"type":"long"},"firstExecutionFrom":{"type":"timestamp"}}}}}}},"S38":{"type":"structure","required":["connectorType","sourceConnectorProperties"],"members":{"connectorType":{},"apiVersion":{},"connectorProfileName":{},"sourceConnectorProperties":{"type":"structure","members":{"Amplitude":{"type":"structure","required":["object"],"members":{"object":{}}},"Datadog":{"type":"structure","required":["object"],"members":{"object":{}}},"Dynatrace":{"type":"structure","required":["object"],"members":{"object":{}}},"GoogleAnalytics":{"type":"structure","required":["object"],"members":{"object":{}}},"InforNexus":{"type":"structure","required":["object"],"members":{"object":{}}},"Marketo":{"type":"structure","required":["object"],"members":{"object":{}}},"S3":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"bucketPrefix":{},"s3InputFormatConfig":{"type":"structure","members":{"s3InputFileType":{}}}}},"Salesforce":{"type":"structure","required":["object"],"members":{"object":{},"enableDynamicFieldUpdate":{"type":"boolean"},"includeDeletedRecords":{"type":"boolean"}}},"ServiceNow":{"type":"structure","required":["object"],"members":{"object":{}}},"Singular":{"type":"structure","required":["object"],"members":{"object":{}}},"Slack":{"type":"structure","required":["object"],"members":{"object":{}}},"Trendmicro":{"type":"structure","required":["object"],"members":{"object":{}}},"Veeva":{"type":"structure","required":["object"],"members":{"object":{},"documentType":{},"includeSourceFiles":{"type":"boolean"},"includeRenditions":{"type":"boolean"},"includeAllVersions":{"type":"boolean"}}},"Zendesk":{"type":"structure","required":["object"],"members":{"object":{}}},"SAPOData":{"type":"structure","members":{"objectPath":{}}},"CustomConnector":{"type":"structure","required":["entityName"],"members":{"entityName":{},"customProperties":{"shape":"S3w"}}}}},"incrementalPullConfig":{"type":"structure","members":{"datetimeTypeFieldName":{}}}}},"S3w":{"type":"map","key":{},"value":{}},"S3z":{"type":"list","member":{"type":"structure","required":["connectorType","destinationConnectorProperties"],"members":{"connectorType":{},"apiVersion":{},"connectorProfileName":{},"destinationConnectorProperties":{"type":"structure","members":{"Redshift":{"type":"structure","required":["object","intermediateBucketName"],"members":{"object":{},"intermediateBucketName":{},"bucketPrefix":{},"errorHandlingConfig":{"shape":"S43"}}},"S3":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"bucketPrefix":{},"s3OutputFormatConfig":{"type":"structure","members":{"fileType":{},"prefixConfig":{"shape":"S47"},"aggregationConfig":{"shape":"S4a"}}}}},"Salesforce":{"type":"structure","required":["object"],"members":{"object":{},"idFieldNames":{"shape":"S4d"},"errorHandlingConfig":{"shape":"S43"},"writeOperationType":{}}},"Snowflake":{"type":"structure","required":["object","intermediateBucketName"],"members":{"object":{},"intermediateBucketName":{},"bucketPrefix":{},"errorHandlingConfig":{"shape":"S43"}}},"EventBridge":{"type":"structure","required":["object"],"members":{"object":{},"errorHandlingConfig":{"shape":"S43"}}},"LookoutMetrics":{"type":"structure","members":{}},"Upsolver":{"type":"structure","required":["bucketName","s3OutputFormatConfig"],"members":{"bucketName":{},"bucketPrefix":{},"s3OutputFormatConfig":{"type":"structure","required":["prefixConfig"],"members":{"fileType":{},"prefixConfig":{"shape":"S47"},"aggregationConfig":{"shape":"S4a"}}}}},"Honeycode":{"type":"structure","required":["object"],"members":{"object":{},"errorHandlingConfig":{"shape":"S43"}}},"CustomerProfiles":{"type":"structure","required":["domainName"],"members":{"domainName":{},"objectTypeName":{}}},"Zendesk":{"type":"structure","required":["object"],"members":{"object":{},"idFieldNames":{"shape":"S4d"},"errorHandlingConfig":{"shape":"S43"},"writeOperationType":{}}},"Marketo":{"type":"structure","required":["object"],"members":{"object":{},"errorHandlingConfig":{"shape":"S43"}}},"CustomConnector":{"type":"structure","required":["entityName"],"members":{"entityName":{},"errorHandlingConfig":{"shape":"S43"},"writeOperationType":{},"idFieldNames":{"shape":"S4d"},"customProperties":{"shape":"S3w"}}},"SAPOData":{"type":"structure","required":["objectPath"],"members":{"objectPath":{},"successResponseHandlingConfig":{"type":"structure","members":{"bucketPrefix":{},"bucketName":{}}},"idFieldNames":{"shape":"S4d"},"errorHandlingConfig":{"shape":"S43"},"writeOperationType":{}}}}}}}},"S43":{"type":"structure","members":{"failOnFirstDestinationError":{"type":"boolean"},"bucketPrefix":{},"bucketName":{}}},"S47":{"type":"structure","members":{"prefixType":{},"prefixFormat":{}}},"S4a":{"type":"structure","members":{"aggregationType":{}}},"S4d":{"type":"list","member":{}},"S4v":{"type":"list","member":{"type":"structure","required":["sourceFields","taskType"],"members":{"sourceFields":{"type":"list","member":{}},"connectorOperator":{"type":"structure","members":{"Amplitude":{},"Datadog":{},"Dynatrace":{},"GoogleAnalytics":{},"InforNexus":{},"Marketo":{},"S3":{},"Salesforce":{},"ServiceNow":{},"Singular":{},"Slack":{},"Trendmicro":{},"Veeva":{},"Zendesk":{},"SAPOData":{},"CustomConnector":{}}},"destinationField":{},"taskType":{},"taskProperties":{"type":"map","key":{},"value":{}}}}},"S5l":{"type":"map","key":{},"value":{}},"S5x":{"type":"structure","members":{"canUseAsSource":{"type":"boolean"},"canUseAsDestination":{"type":"boolean"},"supportedDestinationConnectors":{"shape":"S5y"},"supportedSchedulingFrequencies":{"type":"list","member":{}},"isPrivateLinkEnabled":{"type":"boolean"},"isPrivateLinkEndpointUrlRequired":{"type":"boolean"},"supportedTriggerTypes":{"type":"list","member":{}},"connectorMetadata":{"type":"structure","members":{"Amplitude":{"type":"structure","members":{}},"Datadog":{"type":"structure","members":{}},"Dynatrace":{"type":"structure","members":{}},"GoogleAnalytics":{"type":"structure","members":{"oAuthScopes":{"shape":"S19"}}},"InforNexus":{"type":"structure","members":{}},"Marketo":{"type":"structure","members":{}},"Redshift":{"type":"structure","members":{}},"S3":{"type":"structure","members":{}},"Salesforce":{"type":"structure","members":{"oAuthScopes":{"shape":"S19"}}},"ServiceNow":{"type":"structure","members":{}},"Singular":{"type":"structure","members":{}},"Slack":{"type":"structure","members":{"oAuthScopes":{"shape":"S19"}}},"Snowflake":{"type":"structure","members":{"supportedRegions":{"type":"list","member":{}}}},"Trendmicro":{"type":"structure","members":{}},"Veeva":{"type":"structure","members":{}},"Zendesk":{"type":"structure","members":{"oAuthScopes":{"shape":"S19"}}},"EventBridge":{"type":"structure","members":{}},"Upsolver":{"type":"structure","members":{}},"CustomerProfiles":{"type":"structure","members":{}},"Honeycode":{"type":"structure","members":{"oAuthScopes":{"shape":"S19"}}},"SAPOData":{"type":"structure","members":{}}}},"connectorType":{},"connectorLabel":{},"connectorDescription":{},"connectorOwner":{},"connectorName":{},"connectorVersion":{},"connectorArn":{},"connectorModes":{"shape":"S6u"},"authenticationConfig":{"type":"structure","members":{"isBasicAuthSupported":{"type":"boolean"},"isApiKeyAuthSupported":{"type":"boolean"},"isOAuth2Supported":{"type":"boolean"},"isCustomAuthSupported":{"type":"boolean"},"oAuth2Defaults":{"type":"structure","members":{"oauthScopes":{"shape":"S19"},"tokenUrls":{"type":"list","member":{}},"authCodeUrls":{"type":"list","member":{}},"oauth2GrantTypesSupported":{"type":"list","member":{}},"oauth2CustomProperties":{"type":"list","member":{"type":"structure","members":{"key":{},"isRequired":{"type":"boolean"},"label":{},"description":{},"isSensitiveField":{"type":"boolean"},"connectorSuppliedValues":{"shape":"S75"},"type":{}}}}}},"customAuthConfigs":{"type":"list","member":{"type":"structure","members":{"customAuthenticationType":{},"authParameters":{"type":"list","member":{"type":"structure","members":{"key":{},"isRequired":{"type":"boolean"},"label":{},"description":{},"isSensitiveField":{"type":"boolean"},"connectorSuppliedValues":{"shape":"S75"}}}}}}}}},"connectorRuntimeSettings":{"type":"list","member":{"type":"structure","members":{"key":{},"dataType":{},"isRequired":{"type":"boolean"},"label":{},"description":{},"scope":{},"connectorSuppliedValueOptions":{"type":"list","member":{}}}}},"supportedApiVersions":{"type":"list","member":{}},"supportedOperators":{"type":"list","member":{}},"supportedWriteOperations":{"shape":"S7l"},"connectorProvisioningType":{},"connectorProvisioningConfig":{"shape":"S7n"},"logoURL":{},"registeredAt":{"type":"timestamp"},"registeredBy":{}}},"S5y":{"type":"list","member":{}},"S6u":{"type":"list","member":{}},"S75":{"type":"list","member":{}},"S7l":{"type":"list","member":{}},"S7n":{"type":"structure","members":{"lambda":{"type":"structure","required":["lambdaArn"],"members":{"lambdaArn":{}}}}},"S82":{"type":"structure","members":{"maximum":{"type":"double"},"minimum":{"type":"double"}}},"S8k":{"type":"list","member":{"type":"structure","members":{"connectorDescription":{},"connectorName":{},"connectorOwner":{},"connectorVersion":{},"applicationType":{},"connectorType":{},"connectorLabel":{},"registeredAt":{"type":"timestamp"},"registeredBy":{},"connectorProvisioningType":{},"connectorModes":{"shape":"S6u"}}}},"S8q":{"type":"structure","members":{"mostRecentExecutionMessage":{},"mostRecentExecutionTime":{"type":"timestamp"},"mostRecentExecutionStatus":{}}}}}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeConnectorProfiles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"DescribeConnectors":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"DescribeFlowExecutionRecords":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListConnectors":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFlows":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['redshiftdata'] = {};
	AWS.RedshiftData = Service.defineService('redshiftdata', ['2019-12-20']);
	Object.defineProperty(apiLoader.services['redshiftdata'], '2019-12-20', {
	  get: function get() {
	    var model = __webpack_require__(903);
	    model.paginators = __webpack_require__(904).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.RedshiftData;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-20","endpointPrefix":"redshift-data","jsonVersion":"1.1","protocol":"json","serviceFullName":"Redshift Data API Service","serviceId":"Redshift Data","signatureVersion":"v4","signingName":"redshift-data","targetPrefix":"RedshiftData","uid":"redshift-data-2019-12-20"},"operations":{"BatchExecuteStatement":{"input":{"type":"structure","required":["Database","Sqls"],"members":{"ClusterIdentifier":{},"Database":{},"DbUser":{},"SecretArn":{},"Sqls":{"type":"list","member":{}},"StatementName":{},"WithEvent":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClusterIdentifier":{},"CreatedAt":{"type":"timestamp"},"Database":{},"DbUser":{},"Id":{},"SecretArn":{}}}},"CancelStatement":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Status":{"type":"boolean"}}}},"DescribeStatement":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","required":["Id"],"members":{"ClusterIdentifier":{},"CreatedAt":{"type":"timestamp"},"Database":{},"DbUser":{},"Duration":{"type":"long"},"Error":{},"HasResultSet":{"type":"boolean"},"Id":{},"QueryParameters":{"shape":"Sh"},"QueryString":{},"RedshiftPid":{"type":"long"},"RedshiftQueryId":{"type":"long"},"ResultRows":{"type":"long"},"ResultSize":{"type":"long"},"SecretArn":{},"Status":{},"SubStatements":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"CreatedAt":{"type":"timestamp"},"Duration":{"type":"long"},"Error":{},"HasResultSet":{"type":"boolean"},"Id":{},"QueryString":{},"RedshiftQueryId":{"type":"long"},"ResultRows":{"type":"long"},"ResultSize":{"type":"long"},"Status":{},"UpdatedAt":{"type":"timestamp"}}}},"UpdatedAt":{"type":"timestamp"}}}},"DescribeTable":{"input":{"type":"structure","required":["Database"],"members":{"ClusterIdentifier":{},"ConnectedDatabase":{},"Database":{},"DbUser":{},"MaxResults":{"type":"integer"},"NextToken":{},"Schema":{},"SecretArn":{},"Table":{}}},"output":{"type":"structure","members":{"ColumnList":{"type":"list","member":{"shape":"St"}},"NextToken":{},"TableName":{}}}},"ExecuteStatement":{"input":{"type":"structure","required":["Database","Sql"],"members":{"ClusterIdentifier":{},"Database":{},"DbUser":{},"Parameters":{"shape":"Sh"},"SecretArn":{},"Sql":{},"StatementName":{},"WithEvent":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClusterIdentifier":{},"CreatedAt":{"type":"timestamp"},"Database":{},"DbUser":{},"Id":{},"SecretArn":{}}}},"GetStatementResult":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"NextToken":{}}},"output":{"type":"structure","required":["Records"],"members":{"ColumnMetadata":{"type":"list","member":{"shape":"St"}},"NextToken":{},"Records":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"blobValue":{"type":"blob"},"booleanValue":{"type":"boolean"},"doubleValue":{"type":"double"},"isNull":{"type":"boolean"},"longValue":{"type":"long"},"stringValue":{}},"union":true}}},"TotalNumRows":{"type":"long"}}}},"ListDatabases":{"input":{"type":"structure","required":["Database"],"members":{"ClusterIdentifier":{},"Database":{},"DbUser":{},"MaxResults":{"type":"integer"},"NextToken":{},"SecretArn":{}}},"output":{"type":"structure","members":{"Databases":{"type":"list","member":{}},"NextToken":{}}}},"ListSchemas":{"input":{"type":"structure","required":["Database"],"members":{"ClusterIdentifier":{},"ConnectedDatabase":{},"Database":{},"DbUser":{},"MaxResults":{"type":"integer"},"NextToken":{},"SchemaPattern":{},"SecretArn":{}}},"output":{"type":"structure","members":{"NextToken":{},"Schemas":{"type":"list","member":{}}}}},"ListStatements":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"RoleLevel":{"type":"boolean"},"StatementName":{},"Status":{}}},"output":{"type":"structure","required":["Statements"],"members":{"NextToken":{},"Statements":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"CreatedAt":{"type":"timestamp"},"Id":{},"IsBatchStatement":{"type":"boolean"},"QueryParameters":{"shape":"Sh"},"QueryString":{},"QueryStrings":{"type":"list","member":{}},"SecretArn":{},"StatementName":{},"Status":{},"UpdatedAt":{"type":"timestamp"}}}}}}},"ListTables":{"input":{"type":"structure","required":["Database"],"members":{"ClusterIdentifier":{},"ConnectedDatabase":{},"Database":{},"DbUser":{},"MaxResults":{"type":"integer"},"NextToken":{},"SchemaPattern":{},"SecretArn":{},"TablePattern":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tables":{"type":"list","member":{"type":"structure","members":{"name":{},"schema":{},"type":{}}}}}}}},"shapes":{"Sh":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"St":{"type":"structure","members":{"columnDefault":{},"isCaseSensitive":{"type":"boolean"},"isCurrency":{"type":"boolean"},"isSigned":{"type":"boolean"},"label":{},"length":{"type":"integer"},"name":{},"nullable":{"type":"integer"},"precision":{"type":"integer"},"scale":{"type":"integer"},"schemaName":{},"tableName":{},"typeName":{}}}}}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeTable":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ColumnList"},"GetStatementResult":{"input_token":"NextToken","output_token":"NextToken","result_key":"Records"},"ListDatabases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Databases"},"ListSchemas":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Schemas"},"ListStatements":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Statements"},"ListTables":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Tables"}}}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ssoadmin'] = {};
	AWS.SSOAdmin = Service.defineService('ssoadmin', ['2020-07-20']);
	Object.defineProperty(apiLoader.services['ssoadmin'], '2020-07-20', {
	  get: function get() {
	    var model = __webpack_require__(906);
	    model.paginators = __webpack_require__(907).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SSOAdmin;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-20","endpointPrefix":"sso","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"SSO Admin","serviceFullName":"AWS Single Sign-On Admin","serviceId":"SSO Admin","signatureVersion":"v4","signingName":"sso","targetPrefix":"SWBExternalService","uid":"sso-admin-2020-07-20"},"operations":{"AttachManagedPolicyToPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn","ManagedPolicyArn"],"members":{"InstanceArn":{},"PermissionSetArn":{},"ManagedPolicyArn":{}}},"output":{"type":"structure","members":{}}},"CreateAccountAssignment":{"input":{"type":"structure","required":["InstanceArn","TargetId","TargetType","PermissionSetArn","PrincipalType","PrincipalId"],"members":{"InstanceArn":{},"TargetId":{},"TargetType":{},"PermissionSetArn":{},"PrincipalType":{},"PrincipalId":{}}},"output":{"type":"structure","members":{"AccountAssignmentCreationStatus":{"shape":"Sc"}}}},"CreateInstanceAccessControlAttributeConfiguration":{"input":{"type":"structure","required":["InstanceArn","InstanceAccessControlAttributeConfiguration"],"members":{"InstanceArn":{},"InstanceAccessControlAttributeConfiguration":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"CreatePermissionSet":{"input":{"type":"structure","required":["Name","InstanceArn"],"members":{"Name":{},"Description":{},"InstanceArn":{},"SessionDuration":{},"RelayState":{},"Tags":{"shape":"Sv"}}},"output":{"type":"structure","members":{"PermissionSet":{"shape":"S10"}}}},"DeleteAccountAssignment":{"input":{"type":"structure","required":["InstanceArn","TargetId","TargetType","PermissionSetArn","PrincipalType","PrincipalId"],"members":{"InstanceArn":{},"TargetId":{},"TargetType":{},"PermissionSetArn":{},"PrincipalType":{},"PrincipalId":{}}},"output":{"type":"structure","members":{"AccountAssignmentDeletionStatus":{"shape":"Sc"}}}},"DeleteInlinePolicyFromPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{}}},"output":{"type":"structure","members":{}}},"DeleteInstanceAccessControlAttributeConfiguration":{"input":{"type":"structure","required":["InstanceArn"],"members":{"InstanceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{}}},"output":{"type":"structure","members":{}}},"DescribeAccountAssignmentCreationStatus":{"input":{"type":"structure","required":["InstanceArn","AccountAssignmentCreationRequestId"],"members":{"InstanceArn":{},"AccountAssignmentCreationRequestId":{}}},"output":{"type":"structure","members":{"AccountAssignmentCreationStatus":{"shape":"Sc"}}}},"DescribeAccountAssignmentDeletionStatus":{"input":{"type":"structure","required":["InstanceArn","AccountAssignmentDeletionRequestId"],"members":{"InstanceArn":{},"AccountAssignmentDeletionRequestId":{}}},"output":{"type":"structure","members":{"AccountAssignmentDeletionStatus":{"shape":"Sc"}}}},"DescribeInstanceAccessControlAttributeConfiguration":{"input":{"type":"structure","required":["InstanceArn"],"members":{"InstanceArn":{}}},"output":{"type":"structure","members":{"Status":{},"StatusReason":{},"InstanceAccessControlAttributeConfiguration":{"shape":"Si"}}}},"DescribePermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{}}},"output":{"type":"structure","members":{"PermissionSet":{"shape":"S10"}}}},"DescribePermissionSetProvisioningStatus":{"input":{"type":"structure","required":["InstanceArn","ProvisionPermissionSetRequestId"],"members":{"InstanceArn":{},"ProvisionPermissionSetRequestId":{}}},"output":{"type":"structure","members":{"PermissionSetProvisioningStatus":{"shape":"S1l"}}}},"DetachManagedPolicyFromPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn","ManagedPolicyArn"],"members":{"InstanceArn":{},"PermissionSetArn":{},"ManagedPolicyArn":{}}},"output":{"type":"structure","members":{}}},"GetInlinePolicyForPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{}}},"output":{"type":"structure","members":{"InlinePolicy":{"shape":"S1r"}}}},"ListAccountAssignmentCreationStatus":{"input":{"type":"structure","required":["InstanceArn"],"members":{"InstanceArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filter":{"shape":"S1v"}}},"output":{"type":"structure","members":{"AccountAssignmentsCreationStatus":{"shape":"S1x"},"NextToken":{}}}},"ListAccountAssignmentDeletionStatus":{"input":{"type":"structure","required":["InstanceArn"],"members":{"InstanceArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filter":{"shape":"S1v"}}},"output":{"type":"structure","members":{"AccountAssignmentsDeletionStatus":{"shape":"S1x"},"NextToken":{}}}},"ListAccountAssignments":{"input":{"type":"structure","required":["InstanceArn","AccountId","PermissionSetArn"],"members":{"InstanceArn":{},"AccountId":{},"PermissionSetArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AccountAssignments":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"PermissionSetArn":{},"PrincipalType":{},"PrincipalId":{}}}},"NextToken":{}}}},"ListAccountsForProvisionedPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{},"ProvisioningStatus":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextToken":{}}}},"ListInstances":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"InstanceArn":{},"IdentityStoreId":{}}}},"NextToken":{}}}},"ListManagedPoliciesInPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AttachedManagedPolicies":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{}}}},"NextToken":{}}}},"ListPermissionSetProvisioningStatus":{"input":{"type":"structure","required":["InstanceArn"],"members":{"InstanceArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filter":{"shape":"S1v"}}},"output":{"type":"structure","members":{"PermissionSetsProvisioningStatus":{"type":"list","member":{"type":"structure","members":{"Status":{},"RequestId":{},"CreatedDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListPermissionSets":{"input":{"type":"structure","required":["InstanceArn"],"members":{"InstanceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PermissionSets":{"shape":"S2p"},"NextToken":{}}}},"ListPermissionSetsProvisionedToAccount":{"input":{"type":"structure","required":["InstanceArn","AccountId"],"members":{"InstanceArn":{},"AccountId":{},"ProvisioningStatus":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"PermissionSets":{"shape":"S2p"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["InstanceArn","ResourceArn"],"members":{"InstanceArn":{},"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sv"},"NextToken":{}}}},"ProvisionPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn","TargetType"],"members":{"InstanceArn":{},"PermissionSetArn":{},"TargetId":{},"TargetType":{}}},"output":{"type":"structure","members":{"PermissionSetProvisioningStatus":{"shape":"S1l"}}}},"PutInlinePolicyToPermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn","InlinePolicy"],"members":{"InstanceArn":{},"PermissionSetArn":{},"InlinePolicy":{"shape":"S1r"}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["InstanceArn","ResourceArn","Tags"],"members":{"InstanceArn":{},"ResourceArn":{},"Tags":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["InstanceArn","ResourceArn","TagKeys"],"members":{"InstanceArn":{},"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateInstanceAccessControlAttributeConfiguration":{"input":{"type":"structure","required":["InstanceArn","InstanceAccessControlAttributeConfiguration"],"members":{"InstanceArn":{},"InstanceAccessControlAttributeConfiguration":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"UpdatePermissionSet":{"input":{"type":"structure","required":["InstanceArn","PermissionSetArn"],"members":{"InstanceArn":{},"PermissionSetArn":{},"Description":{},"SessionDuration":{},"RelayState":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sc":{"type":"structure","members":{"Status":{},"RequestId":{},"FailureReason":{},"TargetId":{},"TargetType":{},"PermissionSetArn":{},"PrincipalType":{},"PrincipalId":{},"CreatedDate":{"type":"timestamp"}}},"Si":{"type":"structure","required":["AccessControlAttributes"],"members":{"AccessControlAttributes":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{"type":"structure","required":["Source"],"members":{"Source":{"type":"list","member":{}}}}}}}}},"Sv":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S10":{"type":"structure","members":{"Name":{},"PermissionSetArn":{},"Description":{},"CreatedDate":{"type":"timestamp"},"SessionDuration":{},"RelayState":{}}},"S1l":{"type":"structure","members":{"Status":{},"RequestId":{},"AccountId":{},"PermissionSetArn":{},"FailureReason":{},"CreatedDate":{"type":"timestamp"}}},"S1r":{"type":"string","sensitive":true},"S1v":{"type":"structure","members":{"Status":{}}},"S1x":{"type":"list","member":{"type":"structure","members":{"Status":{},"RequestId":{},"CreatedDate":{"type":"timestamp"}}}},"S2p":{"type":"list","member":{}}}}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccountAssignmentCreationStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AccountAssignmentsCreationStatus"},"ListAccountAssignmentDeletionStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AccountAssignmentsDeletionStatus"},"ListAccountAssignments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AccountAssignments"},"ListAccountsForProvisionedPermissionSet":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AccountIds"},"ListInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Instances"},"ListManagedPoliciesInPermissionSet":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AttachedManagedPolicies"},"ListPermissionSetProvisioningStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PermissionSetsProvisioningStatus"},"ListPermissionSets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PermissionSets"},"ListPermissionSetsProvisionedToAccount":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PermissionSets"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['timestreamquery'] = {};
	AWS.TimestreamQuery = Service.defineService('timestreamquery', ['2018-11-01']);
	Object.defineProperty(apiLoader.services['timestreamquery'], '2018-11-01', {
	  get: function get() {
	    var model = __webpack_require__(909);
	    model.paginators = __webpack_require__(910).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.TimestreamQuery;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-01","endpointPrefix":"query.timestream","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"Timestream Query","serviceFullName":"Amazon Timestream Query","serviceId":"Timestream Query","signatureVersion":"v4","signingName":"timestream","targetPrefix":"Timestream_20181101","uid":"timestream-query-2018-11-01"},"operations":{"CancelQuery":{"input":{"type":"structure","required":["QueryId"],"members":{"QueryId":{}}},"output":{"type":"structure","members":{"CancellationMessage":{}}},"endpointdiscovery":{"required":true},"idempotent":true},"CreateScheduledQuery":{"input":{"type":"structure","required":["Name","QueryString","ScheduleConfiguration","NotificationConfiguration","ScheduledQueryExecutionRoleArn","ErrorReportConfiguration"],"members":{"Name":{},"QueryString":{"shape":"S7"},"ScheduleConfiguration":{"shape":"S8"},"NotificationConfiguration":{"shape":"Sa"},"TargetConfiguration":{"shape":"Sd"},"ClientToken":{"shape":"Sr","idempotencyToken":true},"ScheduledQueryExecutionRoleArn":{},"Tags":{"shape":"Ss"},"KmsKeyId":{},"ErrorReportConfiguration":{"shape":"Sx"}}},"output":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"endpointdiscovery":{"required":true},"idempotent":true},"DeleteScheduledQuery":{"input":{"type":"structure","required":["ScheduledQueryArn"],"members":{"ScheduledQueryArn":{}}},"endpointdiscovery":{"required":true},"idempotent":true},"DescribeEndpoints":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["Address","CachePeriodInMinutes"],"members":{"Address":{},"CachePeriodInMinutes":{"type":"long"}}}}}},"endpointoperation":true},"DescribeScheduledQuery":{"input":{"type":"structure","required":["ScheduledQueryArn"],"members":{"ScheduledQueryArn":{}}},"output":{"type":"structure","required":["ScheduledQuery"],"members":{"ScheduledQuery":{"type":"structure","required":["Arn","Name","QueryString","State","ScheduleConfiguration","NotificationConfiguration"],"members":{"Arn":{},"Name":{},"QueryString":{"shape":"S7"},"CreationTime":{"type":"timestamp"},"State":{},"PreviousInvocationTime":{"type":"timestamp"},"NextInvocationTime":{"type":"timestamp"},"ScheduleConfiguration":{"shape":"S8"},"NotificationConfiguration":{"shape":"Sa"},"TargetConfiguration":{"shape":"Sd"},"ScheduledQueryExecutionRoleArn":{},"KmsKeyId":{},"ErrorReportConfiguration":{"shape":"Sx"},"LastRunSummary":{"shape":"S1e"},"RecentlyFailedRuns":{"type":"list","member":{"shape":"S1e"}}}}}},"endpointdiscovery":{"required":true}},"ExecuteScheduledQuery":{"input":{"type":"structure","required":["ScheduledQueryArn","InvocationTime"],"members":{"ScheduledQueryArn":{},"InvocationTime":{"type":"timestamp"},"ClientToken":{"shape":"Sr","idempotencyToken":true}}},"endpointdiscovery":{"required":true},"idempotent":true},"ListScheduledQueries":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ScheduledQueries"],"members":{"ScheduledQueries":{"type":"list","member":{"type":"structure","required":["Arn","Name","State"],"members":{"Arn":{},"Name":{},"CreationTime":{"type":"timestamp"},"State":{},"PreviousInvocationTime":{"type":"timestamp"},"NextInvocationTime":{"type":"timestamp"},"ErrorReportConfiguration":{"shape":"Sx"},"TargetDestination":{"type":"structure","members":{"TimestreamDestination":{"type":"structure","members":{"DatabaseName":{},"TableName":{}}}}},"LastRunStatus":{}}}},"NextToken":{}}},"endpointdiscovery":{"required":true}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Ss"},"NextToken":{}}},"endpointdiscovery":{"required":true}},"PrepareQuery":{"input":{"type":"structure","required":["QueryString"],"members":{"QueryString":{"shape":"S7"},"ValidateOnly":{"type":"boolean"}}},"output":{"type":"structure","required":["QueryString","Columns","Parameters"],"members":{"QueryString":{"shape":"S7"},"Columns":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{"shape":"S24"},"DatabaseName":{},"TableName":{},"Aliased":{"type":"boolean"}}}},"Parameters":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{"shape":"S24"}}}}}},"endpointdiscovery":{"required":true},"idempotent":true},"Query":{"input":{"type":"structure","required":["QueryString"],"members":{"QueryString":{"shape":"S7"},"ClientToken":{"idempotencyToken":true,"type":"string","sensitive":true},"NextToken":{},"MaxRows":{"type":"integer"}}},"output":{"type":"structure","required":["QueryId","Rows","ColumnInfo"],"members":{"QueryId":{},"NextToken":{},"Rows":{"type":"list","member":{"shape":"S2g"}},"ColumnInfo":{"shape":"S27"},"QueryStatus":{"type":"structure","members":{"ProgressPercentage":{"type":"double"},"CumulativeBytesScanned":{"type":"long"},"CumulativeBytesMetered":{"type":"long"}}}}},"endpointdiscovery":{"required":true},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Ss"}}},"output":{"type":"structure","members":{}},"endpointdiscovery":{"required":true}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpointdiscovery":{"required":true}},"UpdateScheduledQuery":{"input":{"type":"structure","required":["ScheduledQueryArn","State"],"members":{"ScheduledQueryArn":{},"State":{}}},"endpointdiscovery":{"required":true}}},"shapes":{"S7":{"type":"string","sensitive":true},"S8":{"type":"structure","required":["ScheduleExpression"],"members":{"ScheduleExpression":{}}},"Sa":{"type":"structure","required":["SnsConfiguration"],"members":{"SnsConfiguration":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}}},"Sd":{"type":"structure","required":["TimestreamConfiguration"],"members":{"TimestreamConfiguration":{"type":"structure","required":["DatabaseName","TableName","TimeColumn","DimensionMappings"],"members":{"DatabaseName":{},"TableName":{},"TimeColumn":{},"DimensionMappings":{"type":"list","member":{"type":"structure","required":["Name","DimensionValueType"],"members":{"Name":{},"DimensionValueType":{}}}},"MultiMeasureMappings":{"type":"structure","required":["MultiMeasureAttributeMappings"],"members":{"TargetMultiMeasureName":{},"MultiMeasureAttributeMappings":{"shape":"Sl"}}},"MixedMeasureMappings":{"type":"list","member":{"type":"structure","required":["MeasureValueType"],"members":{"MeasureName":{},"SourceColumn":{},"TargetMeasureName":{},"MeasureValueType":{},"MultiMeasureAttributeMappings":{"shape":"Sl"}}}},"MeasureNameColumn":{}}}}},"Sl":{"type":"list","member":{"type":"structure","required":["SourceColumn","MeasureValueType"],"members":{"SourceColumn":{},"TargetMultiMeasureAttributeName":{},"MeasureValueType":{}}}},"Sr":{"type":"string","sensitive":true},"Ss":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sx":{"type":"structure","required":["S3Configuration"],"members":{"S3Configuration":{"type":"structure","required":["BucketName"],"members":{"BucketName":{},"ObjectKeyPrefix":{},"EncryptionOption":{}}}}},"S1e":{"type":"structure","members":{"InvocationTime":{"type":"timestamp"},"TriggerTime":{"type":"timestamp"},"RunStatus":{},"ExecutionStats":{"type":"structure","members":{"ExecutionTimeInMillis":{"type":"long"},"DataWrites":{"type":"long"},"BytesMetered":{"type":"long"},"RecordsIngested":{"type":"long"},"QueryResultRows":{"type":"long"}}},"ErrorReportLocation":{"type":"structure","members":{"S3ReportLocation":{"type":"structure","members":{"BucketName":{},"ObjectKey":{}}}}},"FailureReason":{}}},"S24":{"type":"structure","members":{"ScalarType":{},"ArrayColumnInfo":{"shape":"S26"},"TimeSeriesMeasureValueColumnInfo":{"shape":"S26"},"RowColumnInfo":{"shape":"S27"}}},"S26":{"type":"structure","required":["Type"],"members":{"Name":{},"Type":{"shape":"S24"}}},"S27":{"type":"list","member":{"shape":"S26"}},"S2g":{"type":"structure","required":["Data"],"members":{"Data":{"shape":"S2h"}}},"S2h":{"type":"list","member":{"shape":"S2i"}},"S2i":{"type":"structure","members":{"ScalarValue":{},"TimeSeriesValue":{"type":"list","member":{"type":"structure","required":["Time","Value"],"members":{"Time":{},"Value":{"shape":"S2i"}}}},"ArrayValue":{"shape":"S2h"},"RowValue":{"shape":"S2g"},"NullValue":{"type":"boolean"}}}}}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListScheduledQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledQueries"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"Query":{"input_token":"NextToken","limit_key":"MaxRows","non_aggregate_keys":["ColumnInfo","QueryId","QueryStatus"],"output_token":"NextToken","result_key":"Rows"}}}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['timestreamwrite'] = {};
	AWS.TimestreamWrite = Service.defineService('timestreamwrite', ['2018-11-01']);
	Object.defineProperty(apiLoader.services['timestreamwrite'], '2018-11-01', {
	  get: function get() {
	    var model = __webpack_require__(912);
	    model.paginators = __webpack_require__(913).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.TimestreamWrite;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-01","endpointPrefix":"ingest.timestream","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"Timestream Write","serviceFullName":"Amazon Timestream Write","serviceId":"Timestream Write","signatureVersion":"v4","signingName":"timestream","targetPrefix":"Timestream_20181101","uid":"timestream-write-2018-11-01"},"operations":{"CreateDatabase":{"input":{"type":"structure","required":["DatabaseName"],"members":{"DatabaseName":{},"KmsKeyId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"Database":{"shape":"S9"}}},"endpointdiscovery":{"required":true}},"CreateTable":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{},"RetentionProperties":{"shape":"Sf"},"Tags":{"shape":"S4"},"MagneticStoreWriteProperties":{"shape":"Si"}}},"output":{"type":"structure","members":{"Table":{"shape":"Sq"}}},"endpointdiscovery":{"required":true}},"DeleteDatabase":{"input":{"type":"structure","required":["DatabaseName"],"members":{"DatabaseName":{}}},"endpointdiscovery":{"required":true}},"DeleteTable":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{}}},"endpointdiscovery":{"required":true}},"DescribeDatabase":{"input":{"type":"structure","required":["DatabaseName"],"members":{"DatabaseName":{}}},"output":{"type":"structure","members":{"Database":{"shape":"S9"}}},"endpointdiscovery":{"required":true}},"DescribeEndpoints":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["Address","CachePeriodInMinutes"],"members":{"Address":{},"CachePeriodInMinutes":{"type":"long"}}}}}},"endpointoperation":true},"DescribeTable":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"Sq"}}},"endpointdiscovery":{"required":true}},"ListDatabases":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Databases":{"type":"list","member":{"shape":"S9"}},"NextToken":{}}},"endpointdiscovery":{"required":true}},"ListTables":{"input":{"type":"structure","members":{"DatabaseName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tables":{"type":"list","member":{"shape":"Sq"}},"NextToken":{}}},"endpointdiscovery":{"required":true}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4"}}},"endpointdiscovery":{"required":true}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}},"endpointdiscovery":{"required":true}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpointdiscovery":{"required":true}},"UpdateDatabase":{"input":{"type":"structure","required":["DatabaseName","KmsKeyId"],"members":{"DatabaseName":{},"KmsKeyId":{}}},"output":{"type":"structure","members":{"Database":{"shape":"S9"}}},"endpointdiscovery":{"required":true}},"UpdateTable":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{},"RetentionProperties":{"shape":"Sf"},"MagneticStoreWriteProperties":{"shape":"Si"}}},"output":{"type":"structure","members":{"Table":{"shape":"Sq"}}},"endpointdiscovery":{"required":true}},"WriteRecords":{"input":{"type":"structure","required":["DatabaseName","TableName","Records"],"members":{"DatabaseName":{},"TableName":{},"CommonAttributes":{"shape":"S1m"},"Records":{"type":"list","member":{"shape":"S1m"}}}},"output":{"type":"structure","members":{"RecordsIngested":{"type":"structure","members":{"Total":{"type":"integer"},"MemoryStore":{"type":"integer"},"MagneticStore":{"type":"integer"}}}}},"endpointdiscovery":{"required":true}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S9":{"type":"structure","members":{"Arn":{},"DatabaseName":{},"TableCount":{"type":"long"},"KmsKeyId":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"Sf":{"type":"structure","required":["MemoryStoreRetentionPeriodInHours","MagneticStoreRetentionPeriodInDays"],"members":{"MemoryStoreRetentionPeriodInHours":{"type":"long"},"MagneticStoreRetentionPeriodInDays":{"type":"long"}}},"Si":{"type":"structure","required":["EnableMagneticStoreWrites"],"members":{"EnableMagneticStoreWrites":{"type":"boolean"},"MagneticStoreRejectedDataLocation":{"type":"structure","members":{"S3Configuration":{"type":"structure","members":{"BucketName":{},"ObjectKeyPrefix":{},"EncryptionOption":{},"KmsKeyId":{}}}}}}},"Sq":{"type":"structure","members":{"Arn":{},"TableName":{},"DatabaseName":{},"TableStatus":{},"RetentionProperties":{"shape":"Sf"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"MagneticStoreWriteProperties":{"shape":"Si"}}},"S1m":{"type":"structure","members":{"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{},"DimensionValueType":{}}}},"MeasureName":{},"MeasureValue":{},"MeasureValueType":{},"Time":{},"TimeUnit":{},"Version":{"type":"long"},"MeasureValues":{"type":"list","member":{"type":"structure","required":["Name","Value","Type"],"members":{"Name":{},"Value":{},"Type":{}}}}}}}}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDatabases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTables":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['s3outposts'] = {};
	AWS.S3Outposts = Service.defineService('s3outposts', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['s3outposts'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(915);
	    model.paginators = __webpack_require__(916).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.S3Outposts;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"s3-outposts","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon S3 Outposts","serviceFullName":"Amazon S3 on Outposts","serviceId":"S3Outposts","signatureVersion":"v4","signingName":"s3-outposts","uid":"s3outposts-2017-07-25"},"operations":{"CreateEndpoint":{"http":{"requestUri":"/S3Outposts/CreateEndpoint"},"input":{"type":"structure","required":["OutpostId","SubnetId","SecurityGroupId"],"members":{"OutpostId":{},"SubnetId":{},"SecurityGroupId":{},"AccessType":{},"CustomerOwnedIpv4Pool":{}}},"output":{"type":"structure","members":{"EndpointArn":{}}}},"DeleteEndpoint":{"http":{"method":"DELETE","requestUri":"/S3Outposts/DeleteEndpoint"},"input":{"type":"structure","required":["EndpointId","OutpostId"],"members":{"EndpointId":{"location":"querystring","locationName":"endpointId"},"OutpostId":{"location":"querystring","locationName":"outpostId"}}}},"ListEndpoints":{"http":{"method":"GET","requestUri":"/S3Outposts/ListEndpoints"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Endpoints":{"shape":"Sf"},"NextToken":{}}}},"ListSharedEndpoints":{"http":{"method":"GET","requestUri":"/S3Outposts/ListSharedEndpoints"},"input":{"type":"structure","required":["OutpostId"],"members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"OutpostId":{"location":"querystring","locationName":"outpostId"}}},"output":{"type":"structure","members":{"Endpoints":{"shape":"Sf"},"NextToken":{}}}}},"shapes":{"Sf":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"OutpostsId":{},"CidrBlock":{},"Status":{},"CreationTime":{"type":"timestamp"},"NetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"NetworkInterfaceId":{}}}},"VpcId":{},"SubnetId":{},"SecurityGroupId":{},"AccessType":{},"CustomerOwnedIpv4Pool":{}}}}}}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Endpoints"},"ListSharedEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Endpoints"}}}

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['databrew'] = {};
	AWS.DataBrew = Service.defineService('databrew', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['databrew'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(918);
	    model.paginators = __webpack_require__(919).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DataBrew;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"databrew","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Glue DataBrew","serviceId":"DataBrew","signatureVersion":"v4","signingName":"databrew","uid":"databrew-2017-07-25"},"operations":{"BatchDeleteRecipeVersion":{"http":{"requestUri":"/recipes/{name}/batchDeleteRecipeVersion"},"input":{"type":"structure","required":["Name","RecipeVersions"],"members":{"Name":{"location":"uri","locationName":"name"},"RecipeVersions":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{},"Errors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{},"RecipeVersion":{}}}}}}},"CreateDataset":{"http":{"requestUri":"/datasets"},"input":{"type":"structure","required":["Name","Input"],"members":{"Name":{},"Format":{},"FormatOptions":{"shape":"Sd"},"Input":{"shape":"So"},"PathOptions":{"shape":"S13"},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateProfileJob":{"http":{"requestUri":"/profileJobs"},"input":{"type":"structure","required":["DatasetName","Name","OutputLocation","RoleArn"],"members":{"DatasetName":{},"EncryptionKeyArn":{},"EncryptionMode":{},"Name":{},"LogSubscription":{},"MaxCapacity":{"type":"integer"},"MaxRetries":{"type":"integer"},"OutputLocation":{"shape":"Sp"},"Configuration":{"shape":"S1x"},"ValidationConfigurations":{"shape":"S2g"},"RoleArn":{},"Tags":{"shape":"S1m"},"Timeout":{"type":"integer"},"JobSample":{"shape":"S2k"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateProject":{"http":{"requestUri":"/projects"},"input":{"type":"structure","required":["DatasetName","Name","RecipeName","RoleArn"],"members":{"DatasetName":{},"Name":{},"RecipeName":{},"Sample":{"shape":"S2q"},"RoleArn":{},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateRecipe":{"http":{"requestUri":"/recipes"},"input":{"type":"structure","required":["Name","Steps"],"members":{"Description":{},"Name":{},"Steps":{"shape":"S2w"},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateRecipeJob":{"http":{"requestUri":"/recipeJobs"},"input":{"type":"structure","required":["Name","RoleArn"],"members":{"DatasetName":{},"EncryptionKeyArn":{},"EncryptionMode":{},"Name":{},"LogSubscription":{},"MaxCapacity":{"type":"integer"},"MaxRetries":{"type":"integer"},"Outputs":{"shape":"S36"},"DataCatalogOutputs":{"shape":"S3f"},"DatabaseOutputs":{"shape":"S3j"},"ProjectName":{},"RecipeReference":{"shape":"S3m"},"RoleArn":{},"Tags":{"shape":"S1m"},"Timeout":{"type":"integer"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateRuleset":{"http":{"requestUri":"/rulesets"},"input":{"type":"structure","required":["Name","TargetArn","Rules"],"members":{"Name":{},"Description":{},"TargetArn":{},"Rules":{"shape":"S3r"},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateSchedule":{"http":{"requestUri":"/schedules"},"input":{"type":"structure","required":["CronExpression","Name"],"members":{"JobNames":{"shape":"S41"},"CronExpression":{},"Tags":{"shape":"S1m"},"Name":{}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/datasets/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/jobs/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteRecipeVersion":{"http":{"method":"DELETE","requestUri":"/recipes/{name}/recipeVersion/{recipeVersion}"},"input":{"type":"structure","required":["Name","RecipeVersion"],"members":{"Name":{"location":"uri","locationName":"name"},"RecipeVersion":{"location":"uri","locationName":"recipeVersion"}}},"output":{"type":"structure","required":["Name","RecipeVersion"],"members":{"Name":{},"RecipeVersion":{}}}},"DeleteRuleset":{"http":{"method":"DELETE","requestUri":"/rulesets/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteSchedule":{"http":{"method":"DELETE","requestUri":"/schedules/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/datasets/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name","Input"],"members":{"CreatedBy":{},"CreateDate":{"type":"timestamp"},"Name":{},"Format":{},"FormatOptions":{"shape":"Sd"},"Input":{"shape":"So"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"Source":{},"PathOptions":{"shape":"S13"},"Tags":{"shape":"S1m"},"ResourceArn":{}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/jobs/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"CreateDate":{"type":"timestamp"},"CreatedBy":{},"DatasetName":{},"EncryptionKeyArn":{},"EncryptionMode":{},"Name":{},"Type":{},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"LogSubscription":{},"MaxCapacity":{"type":"integer"},"MaxRetries":{"type":"integer"},"Outputs":{"shape":"S36"},"DataCatalogOutputs":{"shape":"S3f"},"DatabaseOutputs":{"shape":"S3j"},"ProjectName":{},"ProfileConfiguration":{"shape":"S1x"},"ValidationConfigurations":{"shape":"S2g"},"RecipeReference":{"shape":"S3m"},"ResourceArn":{},"RoleArn":{},"Tags":{"shape":"S1m"},"Timeout":{"type":"integer"},"JobSample":{"shape":"S2k"}}}},"DescribeJobRun":{"http":{"method":"GET","requestUri":"/jobs/{name}/jobRun/{runId}"},"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{"location":"uri","locationName":"name"},"RunId":{"location":"uri","locationName":"runId"}}},"output":{"type":"structure","required":["JobName"],"members":{"Attempt":{"type":"integer"},"CompletedOn":{"type":"timestamp"},"DatasetName":{},"ErrorMessage":{},"ExecutionTime":{"type":"integer"},"JobName":{},"ProfileConfiguration":{"shape":"S1x"},"ValidationConfigurations":{"shape":"S2g"},"RunId":{},"State":{},"LogSubscription":{},"LogGroupName":{},"Outputs":{"shape":"S36"},"DataCatalogOutputs":{"shape":"S3f"},"DatabaseOutputs":{"shape":"S3j"},"RecipeReference":{"shape":"S3m"},"StartedBy":{},"StartedOn":{"type":"timestamp"},"JobSample":{"shape":"S2k"}}}},"DescribeProject":{"http":{"method":"GET","requestUri":"/projects/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"CreateDate":{"type":"timestamp"},"CreatedBy":{},"DatasetName":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"Name":{},"RecipeName":{},"ResourceArn":{},"Sample":{"shape":"S2q"},"RoleArn":{},"Tags":{"shape":"S1m"},"SessionStatus":{},"OpenedBy":{},"OpenDate":{"type":"timestamp"}}}},"DescribeRecipe":{"http":{"method":"GET","requestUri":"/recipes/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"RecipeVersion":{"location":"querystring","locationName":"recipeVersion"}}},"output":{"type":"structure","required":["Name"],"members":{"CreatedBy":{},"CreateDate":{"type":"timestamp"},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"ProjectName":{},"PublishedBy":{},"PublishedDate":{"type":"timestamp"},"Description":{},"Name":{},"Steps":{"shape":"S2w"},"Tags":{"shape":"S1m"},"ResourceArn":{},"RecipeVersion":{}}}},"DescribeRuleset":{"http":{"method":"GET","requestUri":"/rulesets/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"TargetArn":{},"Rules":{"shape":"S3r"},"CreateDate":{"type":"timestamp"},"CreatedBy":{},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"ResourceArn":{},"Tags":{"shape":"S1m"}}}},"DescribeSchedule":{"http":{"method":"GET","requestUri":"/schedules/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"CreateDate":{"type":"timestamp"},"CreatedBy":{},"JobNames":{"shape":"S41"},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"ResourceArn":{},"CronExpression":{},"Tags":{"shape":"S1m"},"Name":{}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/datasets"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["Datasets"],"members":{"Datasets":{"type":"list","member":{"type":"structure","required":["Name","Input"],"members":{"AccountId":{},"CreatedBy":{},"CreateDate":{"type":"timestamp"},"Name":{},"Format":{},"FormatOptions":{"shape":"Sd"},"Input":{"shape":"So"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"Source":{},"PathOptions":{"shape":"S13"},"Tags":{"shape":"S1m"},"ResourceArn":{}}}},"NextToken":{}}}},"ListJobRuns":{"http":{"method":"GET","requestUri":"/jobs/{name}/jobRuns"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["JobRuns"],"members":{"JobRuns":{"type":"list","member":{"type":"structure","members":{"Attempt":{"type":"integer"},"CompletedOn":{"type":"timestamp"},"DatasetName":{},"ErrorMessage":{},"ExecutionTime":{"type":"integer"},"JobName":{},"RunId":{},"State":{},"LogSubscription":{},"LogGroupName":{},"Outputs":{"shape":"S36"},"DataCatalogOutputs":{"shape":"S3f"},"DatabaseOutputs":{"shape":"S3j"},"RecipeReference":{"shape":"S3m"},"StartedBy":{},"StartedOn":{"type":"timestamp"},"JobSample":{"shape":"S2k"},"ValidationConfigurations":{"shape":"S2g"}}}},"NextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/jobs"},"input":{"type":"structure","members":{"DatasetName":{"location":"querystring","locationName":"datasetName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ProjectName":{"location":"querystring","locationName":"projectName"}}},"output":{"type":"structure","required":["Jobs"],"members":{"Jobs":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"AccountId":{},"CreatedBy":{},"CreateDate":{"type":"timestamp"},"DatasetName":{},"EncryptionKeyArn":{},"EncryptionMode":{},"Name":{},"Type":{},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"LogSubscription":{},"MaxCapacity":{"type":"integer"},"MaxRetries":{"type":"integer"},"Outputs":{"shape":"S36"},"DataCatalogOutputs":{"shape":"S3f"},"DatabaseOutputs":{"shape":"S3j"},"ProjectName":{},"RecipeReference":{"shape":"S3m"},"ResourceArn":{},"RoleArn":{},"Timeout":{"type":"integer"},"Tags":{"shape":"S1m"},"JobSample":{"shape":"S2k"},"ValidationConfigurations":{"shape":"S2g"}}}},"NextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["Projects"],"members":{"Projects":{"type":"list","member":{"type":"structure","required":["Name","RecipeName"],"members":{"AccountId":{},"CreateDate":{"type":"timestamp"},"CreatedBy":{},"DatasetName":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"Name":{},"RecipeName":{},"ResourceArn":{},"Sample":{"shape":"S2q"},"Tags":{"shape":"S1m"},"RoleArn":{},"OpenedBy":{},"OpenDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListRecipeVersions":{"http":{"method":"GET","requestUri":"/recipeVersions"},"input":{"type":"structure","required":["Name"],"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"Name":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","required":["Recipes"],"members":{"NextToken":{},"Recipes":{"shape":"S5v"}}}},"ListRecipes":{"http":{"method":"GET","requestUri":"/recipes"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RecipeVersion":{"location":"querystring","locationName":"recipeVersion"}}},"output":{"type":"structure","required":["Recipes"],"members":{"Recipes":{"shape":"S5v"},"NextToken":{}}}},"ListRulesets":{"http":{"method":"GET","requestUri":"/rulesets"},"input":{"type":"structure","members":{"TargetArn":{"location":"querystring","locationName":"targetArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["Rulesets"],"members":{"Rulesets":{"type":"list","member":{"type":"structure","required":["Name","TargetArn"],"members":{"AccountId":{},"CreatedBy":{},"CreateDate":{"type":"timestamp"},"Description":{},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"Name":{},"ResourceArn":{},"RuleCount":{"type":"integer"},"Tags":{"shape":"S1m"},"TargetArn":{}}}},"NextToken":{}}}},"ListSchedules":{"http":{"method":"GET","requestUri":"/schedules"},"input":{"type":"structure","members":{"JobName":{"location":"querystring","locationName":"jobName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["Schedules"],"members":{"Schedules":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"AccountId":{},"CreatedBy":{},"CreateDate":{"type":"timestamp"},"JobNames":{"shape":"S41"},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"ResourceArn":{},"CronExpression":{},"Tags":{"shape":"S1m"},"Name":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1m"}}}},"PublishRecipe":{"http":{"requestUri":"/recipes/{name}/publishRecipe"},"input":{"type":"structure","required":["Name"],"members":{"Description":{},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"SendProjectSessionAction":{"http":{"method":"PUT","requestUri":"/projects/{name}/sendProjectSessionAction"},"input":{"type":"structure","required":["Name"],"members":{"Preview":{"type":"boolean"},"Name":{"location":"uri","locationName":"name"},"RecipeStep":{"shape":"S2x"},"StepIndex":{"type":"integer"},"ClientSessionId":{"shape":"S6f"},"ViewFrame":{"type":"structure","required":["StartColumnIndex"],"members":{"StartColumnIndex":{"type":"integer"},"ColumnRange":{"type":"integer"},"HiddenColumns":{"type":"list","member":{}},"StartRowIndex":{"type":"integer"},"RowRange":{"type":"integer"},"Analytics":{}}}}},"output":{"type":"structure","required":["Name"],"members":{"Result":{},"Name":{},"ActionId":{"type":"integer"}}}},"StartJobRun":{"http":{"requestUri":"/jobs/{name}/startJobRun"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["RunId"],"members":{"RunId":{}}}},"StartProjectSession":{"http":{"method":"PUT","requestUri":"/projects/{name}/startProjectSession"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"name"},"AssumeControl":{"type":"boolean"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{},"ClientSessionId":{"shape":"S6f"}}}},"StopJobRun":{"http":{"requestUri":"/jobs/{name}/jobRun/{runId}/stopJobRun"},"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{"location":"uri","locationName":"name"},"RunId":{"location":"uri","locationName":"runId"}}},"output":{"type":"structure","required":["RunId"],"members":{"RunId":{}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S1m"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDataset":{"http":{"method":"PUT","requestUri":"/datasets/{name}"},"input":{"type":"structure","required":["Name","Input"],"members":{"Name":{"location":"uri","locationName":"name"},"Format":{},"FormatOptions":{"shape":"Sd"},"Input":{"shape":"So"},"PathOptions":{"shape":"S13"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"UpdateProfileJob":{"http":{"method":"PUT","requestUri":"/profileJobs/{name}"},"input":{"type":"structure","required":["Name","OutputLocation","RoleArn"],"members":{"Configuration":{"shape":"S1x"},"EncryptionKeyArn":{},"EncryptionMode":{},"Name":{"location":"uri","locationName":"name"},"LogSubscription":{},"MaxCapacity":{"type":"integer"},"MaxRetries":{"type":"integer"},"OutputLocation":{"shape":"Sp"},"ValidationConfigurations":{"shape":"S2g"},"RoleArn":{},"Timeout":{"type":"integer"},"JobSample":{"shape":"S2k"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"UpdateProject":{"http":{"method":"PUT","requestUri":"/projects/{name}"},"input":{"type":"structure","required":["RoleArn","Name"],"members":{"Sample":{"shape":"S2q"},"RoleArn":{},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"LastModifiedDate":{"type":"timestamp"},"Name":{}}}},"UpdateRecipe":{"http":{"method":"PUT","requestUri":"/recipes/{name}"},"input":{"type":"structure","required":["Name"],"members":{"Description":{},"Name":{"location":"uri","locationName":"name"},"Steps":{"shape":"S2w"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"UpdateRecipeJob":{"http":{"method":"PUT","requestUri":"/recipeJobs/{name}"},"input":{"type":"structure","required":["Name","RoleArn"],"members":{"EncryptionKeyArn":{},"EncryptionMode":{},"Name":{"location":"uri","locationName":"name"},"LogSubscription":{},"MaxCapacity":{"type":"integer"},"MaxRetries":{"type":"integer"},"Outputs":{"shape":"S36"},"DataCatalogOutputs":{"shape":"S3f"},"DatabaseOutputs":{"shape":"S3j"},"RoleArn":{},"Timeout":{"type":"integer"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"UpdateRuleset":{"http":{"method":"PUT","requestUri":"/rulesets/{name}"},"input":{"type":"structure","required":["Name","Rules"],"members":{"Name":{"location":"uri","locationName":"name"},"Description":{},"Rules":{"shape":"S3r"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"UpdateSchedule":{"http":{"method":"PUT","requestUri":"/schedules/{name}"},"input":{"type":"structure","required":["CronExpression","Name"],"members":{"JobNames":{"shape":"S41"},"CronExpression":{},"Name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{}}}}},"shapes":{"Sd":{"type":"structure","members":{"Json":{"type":"structure","members":{"MultiLine":{"type":"boolean"}}},"Excel":{"type":"structure","members":{"SheetNames":{"type":"list","member":{}},"SheetIndexes":{"type":"list","member":{"type":"integer"}},"HeaderRow":{"type":"boolean"}}},"Csv":{"type":"structure","members":{"Delimiter":{},"HeaderRow":{"type":"boolean"}}}}},"So":{"type":"structure","members":{"S3InputDefinition":{"shape":"Sp"},"DataCatalogInputDefinition":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"TempDirectory":{"shape":"Sp"}}},"DatabaseInputDefinition":{"type":"structure","required":["GlueConnectionName"],"members":{"GlueConnectionName":{},"DatabaseTableName":{},"TempDirectory":{"shape":"Sp"},"QueryString":{}}},"Metadata":{"type":"structure","members":{"SourceArn":{}}}}},"Sp":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Key":{},"BucketOwner":{}}},"S13":{"type":"structure","members":{"LastModifiedDateCondition":{"shape":"S14"},"FilesLimit":{"type":"structure","required":["MaxFiles"],"members":{"MaxFiles":{"type":"integer"},"OrderedBy":{},"Order":{}}},"Parameters":{"type":"map","key":{},"value":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"DatetimeOptions":{"type":"structure","required":["Format"],"members":{"Format":{},"TimezoneOffset":{},"LocaleCode":{}}},"CreateColumn":{"type":"boolean"},"Filter":{"shape":"S14"}}}}}},"S14":{"type":"structure","required":["Expression","ValuesMap"],"members":{"Expression":{},"ValuesMap":{"shape":"S16"}}},"S16":{"type":"map","key":{},"value":{}},"S1m":{"type":"map","key":{},"value":{}},"S1x":{"type":"structure","members":{"DatasetStatisticsConfiguration":{"shape":"S1y"},"ProfileColumns":{"shape":"S26"},"ColumnStatisticsConfigurations":{"type":"list","member":{"type":"structure","required":["Statistics"],"members":{"Selectors":{"shape":"S26"},"Statistics":{"shape":"S1y"}}}},"EntityDetectorConfiguration":{"type":"structure","required":["EntityTypes"],"members":{"EntityTypes":{"type":"list","member":{}},"AllowedStatistics":{"type":"list","member":{"type":"structure","required":["Statistics"],"members":{"Statistics":{"shape":"S1z"}}}}}}}},"S1y":{"type":"structure","members":{"IncludedStatistics":{"shape":"S1z"},"Overrides":{"type":"list","member":{"type":"structure","required":["Statistic","Parameters"],"members":{"Statistic":{},"Parameters":{"shape":"S23"}}}}}},"S1z":{"type":"list","member":{}},"S23":{"type":"map","key":{},"value":{}},"S26":{"type":"list","member":{"type":"structure","members":{"Regex":{},"Name":{}}}},"S2g":{"type":"list","member":{"type":"structure","required":["RulesetArn"],"members":{"RulesetArn":{},"ValidationMode":{}}}},"S2k":{"type":"structure","members":{"Mode":{},"Size":{"type":"long"}}},"S2q":{"type":"structure","required":["Type"],"members":{"Size":{"type":"integer"},"Type":{}}},"S2w":{"type":"list","member":{"shape":"S2x"}},"S2x":{"type":"structure","required":["Action"],"members":{"Action":{"type":"structure","required":["Operation"],"members":{"Operation":{},"Parameters":{"shape":"S23"}}},"ConditionExpressions":{"type":"list","member":{"type":"structure","required":["Condition","TargetColumn"],"members":{"Condition":{},"Value":{},"TargetColumn":{}}}}}},"S36":{"type":"list","member":{"type":"structure","required":["Location"],"members":{"CompressionFormat":{},"Format":{},"PartitionColumns":{"type":"list","member":{}},"Location":{"shape":"Sp"},"Overwrite":{"type":"boolean"},"FormatOptions":{"type":"structure","members":{"Csv":{"type":"structure","members":{"Delimiter":{}}}}},"MaxOutputFiles":{"type":"integer"}}}},"S3f":{"type":"list","member":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"S3Options":{"type":"structure","required":["Location"],"members":{"Location":{"shape":"Sp"}}},"DatabaseOptions":{"shape":"S3i"},"Overwrite":{"type":"boolean"}}}},"S3i":{"type":"structure","required":["TableName"],"members":{"TempDirectory":{"shape":"Sp"},"TableName":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["GlueConnectionName","DatabaseOptions"],"members":{"GlueConnectionName":{},"DatabaseOptions":{"shape":"S3i"},"DatabaseOutputMode":{}}}},"S3m":{"type":"structure","required":["Name"],"members":{"Name":{},"RecipeVersion":{}}},"S3r":{"type":"list","member":{"type":"structure","required":["Name","CheckExpression"],"members":{"Name":{},"Disabled":{"type":"boolean"},"CheckExpression":{},"SubstitutionMap":{"shape":"S16"},"Threshold":{"type":"structure","required":["Value"],"members":{"Value":{"type":"double"},"Type":{},"Unit":{}}},"ColumnSelectors":{"shape":"S26"}}}},"S41":{"type":"list","member":{}},"S5v":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"CreatedBy":{},"CreateDate":{"type":"timestamp"},"LastModifiedBy":{},"LastModifiedDate":{"type":"timestamp"},"ProjectName":{},"PublishedBy":{},"PublishedDate":{"type":"timestamp"},"Description":{},"Name":{},"ResourceArn":{},"Steps":{"shape":"S2w"},"Tags":{"shape":"S1m"},"RecipeVersion":{}}}},"S6f":{"type":"string","sensitive":true}}}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDatasets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Datasets"},"ListJobRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"JobRuns"},"ListJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Jobs"},"ListProjects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Projects"},"ListRecipeVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Recipes"},"ListRecipes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Recipes"},"ListRulesets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Rulesets"},"ListSchedules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Schedules"}}}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['servicecatalogappregistry'] = {};
	AWS.ServiceCatalogAppRegistry = Service.defineService('servicecatalogappregistry', ['2020-06-24']);
	Object.defineProperty(apiLoader.services['servicecatalogappregistry'], '2020-06-24', {
	  get: function get() {
	    var model = __webpack_require__(921);
	    model.paginators = __webpack_require__(922).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ServiceCatalogAppRegistry;


/***/ }),
/* 921 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-06-24","endpointPrefix":"servicecatalog-appregistry","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AppRegistry","serviceFullName":"AWS Service Catalog App Registry","serviceId":"Service Catalog AppRegistry","signatureVersion":"v4","signingName":"servicecatalog","uid":"AWS242AppRegistry-2020-06-24"},"operations":{"AssociateAttributeGroup":{"http":{"method":"PUT","requestUri":"/applications/{application}/attribute-groups/{attributeGroup}"},"input":{"type":"structure","required":["application","attributeGroup"],"members":{"application":{"location":"uri","locationName":"application"},"attributeGroup":{"location":"uri","locationName":"attributeGroup"}}},"output":{"type":"structure","members":{"applicationArn":{},"attributeGroupArn":{}}}},"AssociateResource":{"http":{"method":"PUT","requestUri":"/applications/{application}/resources/{resourceType}/{resource}"},"input":{"type":"structure","required":["application","resourceType","resource"],"members":{"application":{"location":"uri","locationName":"application"},"resourceType":{"location":"uri","locationName":"resourceType"},"resource":{"location":"uri","locationName":"resource"}}},"output":{"type":"structure","members":{"applicationArn":{},"resourceArn":{}}}},"CreateApplication":{"http":{"requestUri":"/applications","responseCode":201},"input":{"type":"structure","required":["name","clientToken"],"members":{"name":{},"description":{},"tags":{"shape":"Sf"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"application":{"shape":"Sk"}}}},"CreateAttributeGroup":{"http":{"requestUri":"/attribute-groups","responseCode":201},"input":{"type":"structure","required":["name","attributes","clientToken"],"members":{"name":{},"description":{},"attributes":{},"tags":{"shape":"Sf"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"attributeGroup":{"shape":"Sq"}}}},"DeleteApplication":{"http":{"method":"DELETE","requestUri":"/applications/{application}"},"input":{"type":"structure","required":["application"],"members":{"application":{"location":"uri","locationName":"application"}}},"output":{"type":"structure","members":{"application":{"shape":"Su"}}}},"DeleteAttributeGroup":{"http":{"method":"DELETE","requestUri":"/attribute-groups/{attributeGroup}"},"input":{"type":"structure","required":["attributeGroup"],"members":{"attributeGroup":{"location":"uri","locationName":"attributeGroup"}}},"output":{"type":"structure","members":{"attributeGroup":{"shape":"Sx"}}}},"DisassociateAttributeGroup":{"http":{"method":"DELETE","requestUri":"/applications/{application}/attribute-groups/{attributeGroup}"},"input":{"type":"structure","required":["application","attributeGroup"],"members":{"application":{"location":"uri","locationName":"application"},"attributeGroup":{"location":"uri","locationName":"attributeGroup"}}},"output":{"type":"structure","members":{"applicationArn":{},"attributeGroupArn":{}}}},"DisassociateResource":{"http":{"method":"DELETE","requestUri":"/applications/{application}/resources/{resourceType}/{resource}"},"input":{"type":"structure","required":["application","resourceType","resource"],"members":{"application":{"location":"uri","locationName":"application"},"resourceType":{"location":"uri","locationName":"resourceType"},"resource":{"location":"uri","locationName":"resource"}}},"output":{"type":"structure","members":{"applicationArn":{},"resourceArn":{}}}},"GetApplication":{"http":{"method":"GET","requestUri":"/applications/{application}"},"input":{"type":"structure","required":["application"],"members":{"application":{"location":"uri","locationName":"application"}}},"output":{"type":"structure","members":{"id":{},"arn":{},"name":{},"description":{},"creationTime":{"shape":"Sm"},"lastUpdateTime":{"shape":"Sm"},"associatedResourceCount":{"type":"integer"},"tags":{"shape":"Sf"},"integrations":{"type":"structure","members":{"resourceGroup":{"shape":"S16"}}}}}},"GetAssociatedResource":{"http":{"method":"GET","requestUri":"/applications/{application}/resources/{resourceType}/{resource}"},"input":{"type":"structure","required":["application","resourceType","resource"],"members":{"application":{"location":"uri","locationName":"application"},"resourceType":{"location":"uri","locationName":"resourceType"},"resource":{"location":"uri","locationName":"resource"}}},"output":{"type":"structure","members":{"resource":{"type":"structure","members":{"name":{},"arn":{},"associationTime":{"shape":"Sm"},"integrations":{"type":"structure","members":{"resourceGroup":{"shape":"S16"}}}}}}},"idempotent":true},"GetAttributeGroup":{"http":{"method":"GET","requestUri":"/attribute-groups/{attributeGroup}"},"input":{"type":"structure","required":["attributeGroup"],"members":{"attributeGroup":{"location":"uri","locationName":"attributeGroup"}}},"output":{"type":"structure","members":{"id":{},"arn":{},"name":{},"description":{},"attributes":{},"creationTime":{"shape":"Sm"},"lastUpdateTime":{"shape":"Sm"},"tags":{"shape":"Sf"}}}},"ListApplications":{"http":{"method":"GET","requestUri":"/applications"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"applications":{"type":"list","member":{"shape":"Su"}},"nextToken":{}}},"idempotent":true},"ListAssociatedAttributeGroups":{"http":{"method":"GET","requestUri":"/applications/{application}/attribute-groups"},"input":{"type":"structure","required":["application"],"members":{"application":{"location":"uri","locationName":"application"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"attributeGroups":{"type":"list","member":{}},"nextToken":{}}},"idempotent":true},"ListAssociatedResources":{"http":{"method":"GET","requestUri":"/applications/{application}/resources"},"input":{"type":"structure","required":["application"],"members":{"application":{"location":"uri","locationName":"application"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resources":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{}}}},"nextToken":{}}},"idempotent":true},"ListAttributeGroups":{"http":{"method":"GET","requestUri":"/attribute-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"attributeGroups":{"type":"list","member":{"shape":"Sx"}},"nextToken":{}}},"idempotent":true},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sf"}}}},"SyncResource":{"http":{"requestUri":"/sync/{resourceType}/{resource}"},"input":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{"location":"uri","locationName":"resourceType"},"resource":{"location":"uri","locationName":"resource"}}},"output":{"type":"structure","members":{"applicationArn":{},"resourceArn":{},"actionTaken":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"http":{"method":"PATCH","requestUri":"/applications/{application}"},"input":{"type":"structure","required":["application"],"members":{"application":{"location":"uri","locationName":"application"},"name":{"deprecated":true,"deprecatedMessage":"Name update for application is deprecated."},"description":{}}},"output":{"type":"structure","members":{"application":{"shape":"Sk"}}}},"UpdateAttributeGroup":{"http":{"method":"PATCH","requestUri":"/attribute-groups/{attributeGroup}"},"input":{"type":"structure","required":["attributeGroup"],"members":{"attributeGroup":{"location":"uri","locationName":"attributeGroup"},"name":{"deprecated":true,"deprecatedMessage":"Name update for attribute group is deprecated."},"description":{},"attributes":{}}},"output":{"type":"structure","members":{"attributeGroup":{"shape":"Sq"}}}}},"shapes":{"Sf":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","members":{"id":{},"arn":{},"name":{},"description":{},"creationTime":{"shape":"Sm"},"lastUpdateTime":{"shape":"Sm"},"tags":{"shape":"Sf"}}},"Sm":{"type":"timestamp","timestampFormat":"iso8601"},"Sq":{"type":"structure","members":{"id":{},"arn":{},"name":{},"description":{},"creationTime":{"shape":"Sm"},"lastUpdateTime":{"shape":"Sm"},"tags":{"shape":"Sf"}}},"Su":{"type":"structure","members":{"id":{},"arn":{},"name":{},"description":{},"creationTime":{"shape":"Sm"},"lastUpdateTime":{"shape":"Sm"}}},"Sx":{"type":"structure","members":{"id":{},"arn":{},"name":{},"description":{},"creationTime":{"shape":"Sm"},"lastUpdateTime":{"shape":"Sm"}}},"S16":{"type":"structure","members":{"state":{},"arn":{},"errorMessage":{}}}}}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"applications"},"ListAssociatedAttributeGroups":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"attributeGroups"},"ListAssociatedResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"resources"},"ListAttributeGroups":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"attributeGroups"}}}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['networkfirewall'] = {};
	AWS.NetworkFirewall = Service.defineService('networkfirewall', ['2020-11-12']);
	Object.defineProperty(apiLoader.services['networkfirewall'], '2020-11-12', {
	  get: function get() {
	    var model = __webpack_require__(924);
	    model.paginators = __webpack_require__(925).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.NetworkFirewall;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-12","endpointPrefix":"network-firewall","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"Network Firewall","serviceFullName":"AWS Network Firewall","serviceId":"Network Firewall","signatureVersion":"v4","signingName":"network-firewall","targetPrefix":"NetworkFirewall_20201112","uid":"network-firewall-2020-11-12"},"operations":{"AssociateFirewallPolicy":{"input":{"type":"structure","required":["FirewallPolicyArn"],"members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"FirewallPolicyArn":{}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"FirewallPolicyArn":{},"UpdateToken":{}}}},"AssociateSubnets":{"input":{"type":"structure","required":["SubnetMappings"],"members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"SubnetMappings":{"shape":"S7"}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"SubnetMappings":{"shape":"S7"},"UpdateToken":{}}}},"CreateFirewall":{"input":{"type":"structure","required":["FirewallName","FirewallPolicyArn","VpcId","SubnetMappings"],"members":{"FirewallName":{},"FirewallPolicyArn":{},"VpcId":{},"SubnetMappings":{"shape":"S7"},"DeleteProtection":{"type":"boolean"},"SubnetChangeProtection":{"type":"boolean"},"FirewallPolicyChangeProtection":{"type":"boolean"},"Description":{},"Tags":{"shape":"Sf"},"EncryptionConfiguration":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Firewall":{"shape":"Sn"},"FirewallStatus":{"shape":"Sp"}}}},"CreateFirewallPolicy":{"input":{"type":"structure","required":["FirewallPolicyName","FirewallPolicy"],"members":{"FirewallPolicyName":{},"FirewallPolicy":{"shape":"S13"},"Description":{},"Tags":{"shape":"Sf"},"DryRun":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sj"}}},"output":{"type":"structure","required":["UpdateToken","FirewallPolicyResponse"],"members":{"UpdateToken":{},"FirewallPolicyResponse":{"shape":"S1o"}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["RuleGroupName","Type","Capacity"],"members":{"RuleGroupName":{},"RuleGroup":{"shape":"S1u"},"Rules":{},"Type":{},"Description":{},"Capacity":{"type":"integer"},"Tags":{"shape":"Sf"},"DryRun":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sj"},"SourceMetadata":{"shape":"S37"}}},"output":{"type":"structure","required":["UpdateToken","RuleGroupResponse"],"members":{"UpdateToken":{},"RuleGroupResponse":{"shape":"S39"}}}},"DeleteFirewall":{"input":{"type":"structure","members":{"FirewallName":{},"FirewallArn":{}}},"output":{"type":"structure","members":{"Firewall":{"shape":"Sn"},"FirewallStatus":{"shape":"Sp"}}}},"DeleteFirewallPolicy":{"input":{"type":"structure","members":{"FirewallPolicyName":{},"FirewallPolicyArn":{}}},"output":{"type":"structure","required":["FirewallPolicyResponse"],"members":{"FirewallPolicyResponse":{"shape":"S1o"}}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRuleGroup":{"input":{"type":"structure","members":{"RuleGroupName":{},"RuleGroupArn":{},"Type":{}}},"output":{"type":"structure","required":["RuleGroupResponse"],"members":{"RuleGroupResponse":{"shape":"S39"}}}},"DescribeFirewall":{"input":{"type":"structure","members":{"FirewallName":{},"FirewallArn":{}}},"output":{"type":"structure","members":{"UpdateToken":{},"Firewall":{"shape":"Sn"},"FirewallStatus":{"shape":"Sp"}}}},"DescribeFirewallPolicy":{"input":{"type":"structure","members":{"FirewallPolicyName":{},"FirewallPolicyArn":{}}},"output":{"type":"structure","required":["UpdateToken","FirewallPolicyResponse"],"members":{"UpdateToken":{},"FirewallPolicyResponse":{"shape":"S1o"},"FirewallPolicy":{"shape":"S13"}}}},"DescribeLoggingConfiguration":{"input":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{}}},"output":{"type":"structure","members":{"FirewallArn":{},"LoggingConfiguration":{"shape":"S3o"}}}},"DescribeResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"DescribeRuleGroup":{"input":{"type":"structure","members":{"RuleGroupName":{},"RuleGroupArn":{},"Type":{}}},"output":{"type":"structure","required":["UpdateToken","RuleGroupResponse"],"members":{"UpdateToken":{},"RuleGroup":{"shape":"S1u"},"RuleGroupResponse":{"shape":"S39"}}}},"DescribeRuleGroupMetadata":{"input":{"type":"structure","members":{"RuleGroupName":{},"RuleGroupArn":{},"Type":{}}},"output":{"type":"structure","required":["RuleGroupArn","RuleGroupName"],"members":{"RuleGroupArn":{},"RuleGroupName":{},"Description":{},"Type":{},"Capacity":{"type":"integer"},"StatefulRuleOptions":{"shape":"S35"},"LastModifiedTime":{"type":"timestamp"}}}},"DisassociateSubnets":{"input":{"type":"structure","required":["SubnetIds"],"members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"SubnetIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"SubnetMappings":{"shape":"S7"},"UpdateToken":{}}}},"ListFirewallPolicies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"FirewallPolicies":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{}}}}}}},"ListFirewalls":{"input":{"type":"structure","members":{"NextToken":{},"VpcIds":{"type":"list","member":{}},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Firewalls":{"type":"list","member":{"type":"structure","members":{"FirewallName":{},"FirewallArn":{}}}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Scope":{},"ManagedType":{},"Type":{}}},"output":{"type":"structure","members":{"NextToken":{},"RuleGroups":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResourceArn":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Sf"}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFirewallDeleteProtection":{"input":{"type":"structure","required":["DeleteProtection"],"members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"DeleteProtection":{"type":"boolean"}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"DeleteProtection":{"type":"boolean"},"UpdateToken":{}}}},"UpdateFirewallDescription":{"input":{"type":"structure","members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"Description":{}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"Description":{},"UpdateToken":{}}}},"UpdateFirewallEncryptionConfiguration":{"input":{"type":"structure","members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"EncryptionConfiguration":{"shape":"Sj"}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"UpdateToken":{},"EncryptionConfiguration":{"shape":"Sj"}}}},"UpdateFirewallPolicy":{"input":{"type":"structure","required":["UpdateToken","FirewallPolicy"],"members":{"UpdateToken":{},"FirewallPolicyArn":{},"FirewallPolicyName":{},"FirewallPolicy":{"shape":"S13"},"Description":{},"DryRun":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sj"}}},"output":{"type":"structure","required":["UpdateToken","FirewallPolicyResponse"],"members":{"UpdateToken":{},"FirewallPolicyResponse":{"shape":"S1o"}}}},"UpdateFirewallPolicyChangeProtection":{"input":{"type":"structure","required":["FirewallPolicyChangeProtection"],"members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"FirewallPolicyChangeProtection":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"FirewallPolicyChangeProtection":{"type":"boolean"}}}},"UpdateLoggingConfiguration":{"input":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"LoggingConfiguration":{"shape":"S3o"}}},"output":{"type":"structure","members":{"FirewallArn":{},"FirewallName":{},"LoggingConfiguration":{"shape":"S3o"}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["UpdateToken"],"members":{"UpdateToken":{},"RuleGroupArn":{},"RuleGroupName":{},"RuleGroup":{"shape":"S1u"},"Rules":{},"Type":{},"Description":{},"DryRun":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sj"},"SourceMetadata":{"shape":"S37"}}},"output":{"type":"structure","required":["UpdateToken","RuleGroupResponse"],"members":{"UpdateToken":{},"RuleGroupResponse":{"shape":"S39"}}}},"UpdateSubnetChangeProtection":{"input":{"type":"structure","required":["SubnetChangeProtection"],"members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"SubnetChangeProtection":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpdateToken":{},"FirewallArn":{},"FirewallName":{},"SubnetChangeProtection":{"type":"boolean"}}}}},"shapes":{"S7":{"type":"list","member":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{}}}},"Sf":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sj":{"type":"structure","required":["Type"],"members":{"KeyId":{},"Type":{}}},"Sn":{"type":"structure","required":["FirewallPolicyArn","VpcId","SubnetMappings","FirewallId"],"members":{"FirewallName":{},"FirewallArn":{},"FirewallPolicyArn":{},"VpcId":{},"SubnetMappings":{"shape":"S7"},"DeleteProtection":{"type":"boolean"},"SubnetChangeProtection":{"type":"boolean"},"FirewallPolicyChangeProtection":{"type":"boolean"},"Description":{},"FirewallId":{},"Tags":{"shape":"Sf"},"EncryptionConfiguration":{"shape":"Sj"}}},"Sp":{"type":"structure","required":["Status","ConfigurationSyncStateSummary"],"members":{"Status":{},"ConfigurationSyncStateSummary":{},"SyncStates":{"type":"map","key":{},"value":{"type":"structure","members":{"Attachment":{"type":"structure","members":{"SubnetId":{},"EndpointId":{},"Status":{}}},"Config":{"type":"map","key":{},"value":{"type":"structure","members":{"SyncStatus":{},"UpdateToken":{}}}}}}}}},"S13":{"type":"structure","required":["StatelessDefaultActions","StatelessFragmentDefaultActions"],"members":{"StatelessRuleGroupReferences":{"type":"list","member":{"type":"structure","required":["ResourceArn","Priority"],"members":{"ResourceArn":{},"Priority":{"type":"integer"}}}},"StatelessDefaultActions":{"shape":"S17"},"StatelessFragmentDefaultActions":{"shape":"S17"},"StatelessCustomActions":{"shape":"S18"},"StatefulRuleGroupReferences":{"type":"list","member":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Priority":{"type":"integer"},"Override":{"type":"structure","members":{"Action":{}}}}}},"StatefulDefaultActions":{"type":"list","member":{}},"StatefulEngineOptions":{"type":"structure","members":{"RuleOrder":{}}}}},"S17":{"type":"list","member":{}},"S18":{"type":"list","member":{"type":"structure","required":["ActionName","ActionDefinition"],"members":{"ActionName":{},"ActionDefinition":{"type":"structure","members":{"PublishMetricAction":{"type":"structure","required":["Dimensions"],"members":{"Dimensions":{"type":"list","member":{"type":"structure","required":["Value"],"members":{"Value":{}}}}}}}}}}},"S1o":{"type":"structure","required":["FirewallPolicyName","FirewallPolicyArn","FirewallPolicyId"],"members":{"FirewallPolicyName":{},"FirewallPolicyArn":{},"FirewallPolicyId":{},"Description":{},"FirewallPolicyStatus":{},"Tags":{"shape":"Sf"},"ConsumedStatelessRuleCapacity":{"type":"integer"},"ConsumedStatefulRuleCapacity":{"type":"integer"},"NumberOfAssociations":{"type":"integer"},"EncryptionConfiguration":{"shape":"Sj"},"LastModifiedTime":{"type":"timestamp"}}},"S1u":{"type":"structure","required":["RulesSource"],"members":{"RuleVariables":{"type":"structure","members":{"IPSets":{"type":"map","key":{},"value":{"type":"structure","required":["Definition"],"members":{"Definition":{"shape":"S1z"}}}},"PortSets":{"type":"map","key":{},"value":{"type":"structure","members":{"Definition":{"shape":"S1z"}}}}}},"RulesSource":{"type":"structure","members":{"RulesString":{},"RulesSourceList":{"type":"structure","required":["Targets","TargetTypes","GeneratedRulesType"],"members":{"Targets":{"type":"list","member":{}},"TargetTypes":{"type":"list","member":{}},"GeneratedRulesType":{}}},"StatefulRules":{"type":"list","member":{"type":"structure","required":["Action","Header","RuleOptions"],"members":{"Action":{},"Header":{"type":"structure","required":["Protocol","Source","SourcePort","Direction","Destination","DestinationPort"],"members":{"Protocol":{},"Source":{},"SourcePort":{},"Direction":{},"Destination":{},"DestinationPort":{}}},"RuleOptions":{"type":"list","member":{"type":"structure","required":["Keyword"],"members":{"Keyword":{},"Settings":{"type":"list","member":{}}}}}}}},"StatelessRulesAndCustomActions":{"type":"structure","required":["StatelessRules"],"members":{"StatelessRules":{"type":"list","member":{"type":"structure","required":["RuleDefinition","Priority"],"members":{"RuleDefinition":{"type":"structure","required":["MatchAttributes","Actions"],"members":{"MatchAttributes":{"type":"structure","members":{"Sources":{"shape":"S2t"},"Destinations":{"shape":"S2t"},"SourcePorts":{"shape":"S2w"},"DestinationPorts":{"shape":"S2w"},"Protocols":{"type":"list","member":{"type":"integer"}},"TCPFlags":{"type":"list","member":{"type":"structure","required":["Flags"],"members":{"Flags":{"shape":"S33"},"Masks":{"shape":"S33"}}}}}},"Actions":{"shape":"S17"}}},"Priority":{"type":"integer"}}}},"CustomActions":{"shape":"S18"}}}}},"StatefulRuleOptions":{"shape":"S35"}}},"S1z":{"type":"list","member":{}},"S2t":{"type":"list","member":{"type":"structure","required":["AddressDefinition"],"members":{"AddressDefinition":{}}}},"S2w":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}}},"S33":{"type":"list","member":{}},"S35":{"type":"structure","members":{"RuleOrder":{}}},"S37":{"type":"structure","members":{"SourceArn":{},"SourceUpdateToken":{}}},"S39":{"type":"structure","required":["RuleGroupArn","RuleGroupName","RuleGroupId"],"members":{"RuleGroupArn":{},"RuleGroupName":{},"RuleGroupId":{},"Description":{},"Type":{},"Capacity":{"type":"integer"},"RuleGroupStatus":{},"Tags":{"shape":"Sf"},"ConsumedCapacity":{"type":"integer"},"NumberOfAssociations":{"type":"integer"},"EncryptionConfiguration":{"shape":"Sj"},"SourceMetadata":{"shape":"S37"},"SnsTopic":{},"LastModifiedTime":{"type":"timestamp"}}},"S3o":{"type":"structure","required":["LogDestinationConfigs"],"members":{"LogDestinationConfigs":{"type":"list","member":{"type":"structure","required":["LogType","LogDestinationType","LogDestination"],"members":{"LogType":{},"LogDestinationType":{},"LogDestination":{"type":"map","key":{},"value":{}}}}}}}}}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListFirewallPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FirewallPolicies"},"ListFirewalls":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Firewalls"},"ListRuleGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"RuleGroups"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Tags"}}}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mwaa'] = {};
	AWS.MWAA = Service.defineService('mwaa', ['2020-07-01']);
	Object.defineProperty(apiLoader.services['mwaa'], '2020-07-01', {
	  get: function get() {
	    var model = __webpack_require__(927);
	    model.paginators = __webpack_require__(928).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MWAA;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-01","endpointPrefix":"airflow","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AmazonMWAA","serviceId":"MWAA","signatureVersion":"v4","signingName":"airflow","uid":"mwaa-2020-07-01"},"operations":{"CreateCliToken":{"http":{"requestUri":"/clitoken/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"CliToken":{"type":"string","sensitive":true},"WebServerHostname":{}}},"endpoint":{"hostPrefix":"env."}},"CreateEnvironment":{"http":{"method":"PUT","requestUri":"/environments/{Name}","responseCode":200},"input":{"type":"structure","required":["DagS3Path","ExecutionRoleArn","Name","NetworkConfiguration","SourceBucketArn"],"members":{"AirflowConfigurationOptions":{"type":"map","key":{},"value":{},"sensitive":true},"AirflowVersion":{},"DagS3Path":{},"EnvironmentClass":{},"ExecutionRoleArn":{},"KmsKey":{},"LoggingConfiguration":{"shape":"Sf"},"MaxWorkers":{"type":"integer"},"MinWorkers":{"type":"integer"},"Name":{"location":"uri","locationName":"Name"},"NetworkConfiguration":{"shape":"Sl"},"PluginsS3ObjectVersion":{},"PluginsS3Path":{},"RequirementsS3ObjectVersion":{},"RequirementsS3Path":{},"Schedulers":{"type":"integer"},"SourceBucketArn":{},"Tags":{"shape":"St"},"WebserverAccessMode":{},"WeeklyMaintenanceWindowStart":{}}},"output":{"type":"structure","members":{"Arn":{}}},"endpoint":{"hostPrefix":"api."},"idempotent":true},"CreateWebLoginToken":{"http":{"requestUri":"/webtoken/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"WebServerHostname":{},"WebToken":{"type":"string","sensitive":true}}},"endpoint":{"hostPrefix":"env."},"idempotent":true},"DeleteEnvironment":{"http":{"method":"DELETE","requestUri":"/environments/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."},"idempotent":true},"GetEnvironment":{"http":{"method":"GET","requestUri":"/environments/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"Environment":{"type":"structure","members":{"AirflowConfigurationOptions":{"type":"map","key":{},"value":{}},"AirflowVersion":{},"Arn":{},"CreatedAt":{"type":"timestamp"},"DagS3Path":{},"EnvironmentClass":{},"ExecutionRoleArn":{},"KmsKey":{},"LastUpdate":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"Error":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}},"Source":{},"Status":{}}},"LoggingConfiguration":{"type":"structure","members":{"DagProcessingLogs":{"shape":"S1i"},"SchedulerLogs":{"shape":"S1i"},"TaskLogs":{"shape":"S1i"},"WebserverLogs":{"shape":"S1i"},"WorkerLogs":{"shape":"S1i"}}},"MaxWorkers":{"type":"integer"},"MinWorkers":{"type":"integer"},"Name":{},"NetworkConfiguration":{"shape":"Sl"},"PluginsS3ObjectVersion":{},"PluginsS3Path":{},"RequirementsS3ObjectVersion":{},"RequirementsS3Path":{},"Schedulers":{"type":"integer"},"ServiceRoleArn":{},"SourceBucketArn":{},"Status":{},"Tags":{"shape":"St"},"WebserverAccessMode":{},"WebserverUrl":{},"WeeklyMaintenanceWindowStart":{}}}}},"endpoint":{"hostPrefix":"api."}},"ListEnvironments":{"http":{"method":"GET","requestUri":"/environments","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","required":["Environments"],"members":{"Environments":{"type":"list","member":{}},"NextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"St"}}},"endpoint":{"hostPrefix":"api."}},"PublishMetrics":{"http":{"requestUri":"/metrics/environments/{EnvironmentName}","responseCode":200},"input":{"type":"structure","required":["EnvironmentName","MetricData"],"members":{"EnvironmentName":{"location":"uri","locationName":"EnvironmentName"},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName","Timestamp"],"members":{"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"MetricName":{},"StatisticValues":{"type":"structure","members":{"Maximum":{"type":"double"},"Minimum":{"type":"double"},"SampleCount":{"type":"integer"},"Sum":{"type":"double"}}},"Timestamp":{"type":"timestamp"},"Unit":{},"Value":{"type":"double"}}}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"ops."}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","tagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."},"idempotent":true},"UpdateEnvironment":{"http":{"method":"PATCH","requestUri":"/environments/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"AirflowConfigurationOptions":{"type":"map","key":{},"value":{},"sensitive":true},"AirflowVersion":{},"DagS3Path":{},"EnvironmentClass":{},"ExecutionRoleArn":{},"LoggingConfiguration":{"shape":"Sf"},"MaxWorkers":{"type":"integer"},"MinWorkers":{"type":"integer"},"Name":{"location":"uri","locationName":"Name"},"NetworkConfiguration":{"type":"structure","required":["SecurityGroupIds"],"members":{"SecurityGroupIds":{"shape":"Sm"}}},"PluginsS3ObjectVersion":{},"PluginsS3Path":{},"RequirementsS3ObjectVersion":{},"RequirementsS3Path":{},"Schedulers":{"type":"integer"},"SourceBucketArn":{},"WebserverAccessMode":{},"WeeklyMaintenanceWindowStart":{}}},"output":{"type":"structure","members":{"Arn":{}}},"endpoint":{"hostPrefix":"api."}}},"shapes":{"Sf":{"type":"structure","members":{"DagProcessingLogs":{"shape":"Sg"},"SchedulerLogs":{"shape":"Sg"},"TaskLogs":{"shape":"Sg"},"WebserverLogs":{"shape":"Sg"},"WorkerLogs":{"shape":"Sg"}}},"Sg":{"type":"structure","required":["Enabled","LogLevel"],"members":{"Enabled":{"type":"boolean"},"LogLevel":{}}},"Sl":{"type":"structure","members":{"SecurityGroupIds":{"shape":"Sm"},"SubnetIds":{"type":"list","member":{}}}},"Sm":{"type":"list","member":{}},"St":{"type":"map","key":{},"value":{}},"S1i":{"type":"structure","members":{"CloudWatchLogGroupArn":{},"Enabled":{"type":"boolean"},"LogLevel":{}}}}}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEnvironments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Environments"}}}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['amplifybackend'] = {};
	AWS.AmplifyBackend = Service.defineService('amplifybackend', ['2020-08-11']);
	Object.defineProperty(apiLoader.services['amplifybackend'], '2020-08-11', {
	  get: function get() {
	    var model = __webpack_require__(930);
	    model.paginators = __webpack_require__(931).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AmplifyBackend;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2020-08-11","endpointPrefix":"amplifybackend","signingName":"amplifybackend","serviceFullName":"AmplifyBackend","serviceId":"AmplifyBackend","protocol":"rest-json","jsonVersion":"1.1","uid":"amplifybackend-2020-08-11","signatureVersion":"v4"},"operations":{"CloneBackend":{"http":{"requestUri":"/backend/{appId}/environments/{backendEnvironmentName}/clone","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"TargetEnvironmentName":{"locationName":"targetEnvironmentName"}},"required":["AppId","BackendEnvironmentName","TargetEnvironmentName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"CreateBackend":{"http":{"requestUri":"/backend","responseCode":200},"input":{"type":"structure","members":{"AppId":{"locationName":"appId"},"AppName":{"locationName":"appName"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"ResourceConfig":{"locationName":"resourceConfig","type":"structure","members":{}},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","AppName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"CreateBackendAPI":{"http":{"requestUri":"/backend/{appId}/api","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"ResourceConfig":{"shape":"S8","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","ResourceName","BackendEnvironmentName","ResourceConfig"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"CreateBackendAuth":{"http":{"requestUri":"/backend/{appId}/auth","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"ResourceConfig":{"shape":"Si","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","ResourceName","BackendEnvironmentName","ResourceConfig"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"CreateBackendConfig":{"http":{"requestUri":"/backend/{appId}/config","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendManagerAppId":{"locationName":"backendManagerAppId"}},"required":["AppId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"JobId":{"locationName":"jobId"},"Status":{"locationName":"status"}}}},"CreateBackendStorage":{"http":{"requestUri":"/backend/{appId}/storage","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"ResourceConfig":{"locationName":"resourceConfig","type":"structure","members":{"BucketName":{"locationName":"bucketName"},"Permissions":{"shape":"S1h","locationName":"permissions"},"ServiceName":{"locationName":"serviceName"}},"required":["ServiceName","Permissions"]},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","ResourceName","BackendEnvironmentName","ResourceConfig"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"JobId":{"locationName":"jobId"},"Status":{"locationName":"status"}}}},"CreateToken":{"http":{"requestUri":"/backend/{appId}/challenge","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"}},"required":["AppId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"ChallengeCode":{"locationName":"challengeCode"},"SessionId":{"locationName":"sessionId"},"Ttl":{"locationName":"ttl"}}}},"DeleteBackend":{"http":{"requestUri":"/backend/{appId}/environments/{backendEnvironmentName}/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"}},"required":["AppId","BackendEnvironmentName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"DeleteBackendAPI":{"http":{"requestUri":"/backend/{appId}/api/{backendEnvironmentName}/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceConfig":{"shape":"S8","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"DeleteBackendAuth":{"http":{"requestUri":"/backend/{appId}/auth/{backendEnvironmentName}/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"DeleteBackendStorage":{"http":{"requestUri":"/backend/{appId}/storage/{backendEnvironmentName}/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceName":{"locationName":"resourceName"},"ServiceName":{"locationName":"serviceName"}},"required":["AppId","BackendEnvironmentName","ServiceName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"JobId":{"locationName":"jobId"},"Status":{"locationName":"status"}}}},"DeleteToken":{"http":{"requestUri":"/backend/{appId}/challenge/{sessionId}/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"SessionId":{"location":"uri","locationName":"sessionId"}},"required":["SessionId","AppId"]},"output":{"type":"structure","members":{"IsSuccess":{"locationName":"isSuccess","type":"boolean"}}}},"GenerateBackendAPIModels":{"http":{"requestUri":"/backend/{appId}/api/{backendEnvironmentName}/generateModels","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"GetBackend":{"http":{"requestUri":"/backend/{appId}/details","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"}},"required":["AppId"]},"output":{"type":"structure","members":{"AmplifyFeatureFlags":{"locationName":"amplifyFeatureFlags"},"AmplifyMetaConfig":{"locationName":"amplifyMetaConfig"},"AppId":{"locationName":"appId"},"AppName":{"locationName":"appName"},"BackendEnvironmentList":{"shape":"S11","locationName":"backendEnvironmentList"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"}}}},"GetBackendAPI":{"http":{"requestUri":"/backend/{appId}/api/{backendEnvironmentName}/details","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceConfig":{"shape":"S8","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"ResourceConfig":{"shape":"S8","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}}}},"GetBackendAPIModels":{"http":{"requestUri":"/backend/{appId}/api/{backendEnvironmentName}/getModels","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"Models":{"locationName":"models"},"Status":{"locationName":"status"}}}},"GetBackendAuth":{"http":{"requestUri":"/backend/{appId}/auth/{backendEnvironmentName}/details","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"ResourceConfig":{"shape":"Si","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}}}},"GetBackendJob":{"http":{"method":"GET","requestUri":"/backend/{appId}/job/{backendEnvironmentName}/{jobId}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"JobId":{"location":"uri","locationName":"jobId"}},"required":["AppId","BackendEnvironmentName","JobId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"CreateTime":{"locationName":"createTime"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"},"UpdateTime":{"locationName":"updateTime"}}}},"GetBackendStorage":{"http":{"requestUri":"/backend/{appId}/storage/{backendEnvironmentName}/details","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"ResourceConfig":{"locationName":"resourceConfig","type":"structure","members":{"BucketName":{"locationName":"bucketName"},"Imported":{"locationName":"imported","type":"boolean"},"Permissions":{"shape":"S1h","locationName":"permissions"},"ServiceName":{"locationName":"serviceName"}},"required":["ServiceName","Imported"]},"ResourceName":{"locationName":"resourceName"}}}},"GetToken":{"http":{"method":"GET","requestUri":"/backend/{appId}/challenge/{sessionId}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"SessionId":{"location":"uri","locationName":"sessionId"}},"required":["SessionId","AppId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"ChallengeCode":{"locationName":"challengeCode"},"SessionId":{"locationName":"sessionId"},"Ttl":{"locationName":"ttl"}}}},"ImportBackendAuth":{"http":{"requestUri":"/backend/{appId}/auth/{backendEnvironmentName}/import","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"IdentityPoolId":{"locationName":"identityPoolId"},"NativeClientId":{"locationName":"nativeClientId"},"UserPoolId":{"locationName":"userPoolId"},"WebClientId":{"locationName":"webClientId"}},"required":["AppId","BackendEnvironmentName","UserPoolId","NativeClientId","WebClientId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"ImportBackendStorage":{"http":{"requestUri":"/backend/{appId}/storage/{backendEnvironmentName}/import","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"BucketName":{"locationName":"bucketName"},"ServiceName":{"locationName":"serviceName"}},"required":["AppId","BackendEnvironmentName","ServiceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"JobId":{"locationName":"jobId"},"Status":{"locationName":"status"}}}},"ListBackendJobs":{"http":{"requestUri":"/backend/{appId}/job/{backendEnvironmentName}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"JobId":{"locationName":"jobId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}},"required":["AppId","BackendEnvironmentName"]},"output":{"type":"structure","members":{"Jobs":{"locationName":"jobs","type":"list","member":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"CreateTime":{"locationName":"createTime"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"},"UpdateTime":{"locationName":"updateTime"}},"required":["AppId","BackendEnvironmentName"]}},"NextToken":{"locationName":"nextToken"}}}},"ListS3Buckets":{"http":{"requestUri":"/s3Buckets","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Buckets":{"locationName":"buckets","type":"list","member":{"type":"structure","members":{"CreationDate":{"locationName":"creationDate"},"Name":{"locationName":"name"}}}},"NextToken":{"locationName":"nextToken"}}}},"RemoveAllBackends":{"http":{"requestUri":"/backend/{appId}/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"CleanAmplifyApp":{"locationName":"cleanAmplifyApp","type":"boolean"}},"required":["AppId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"RemoveBackendConfig":{"http":{"requestUri":"/backend/{appId}/config/remove","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"}},"required":["AppId"]},"output":{"type":"structure","members":{"Error":{"locationName":"error"}}}},"UpdateBackendAPI":{"http":{"requestUri":"/backend/{appId}/api/{backendEnvironmentName}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceConfig":{"shape":"S8","locationName":"resourceConfig"},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"UpdateBackendAuth":{"http":{"requestUri":"/backend/{appId}/auth/{backendEnvironmentName}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceConfig":{"locationName":"resourceConfig","type":"structure","members":{"AuthResources":{"locationName":"authResources"},"IdentityPoolConfigs":{"locationName":"identityPoolConfigs","type":"structure","members":{"UnauthenticatedLogin":{"locationName":"unauthenticatedLogin","type":"boolean"}}},"Service":{"locationName":"service"},"UserPoolConfigs":{"locationName":"userPoolConfigs","type":"structure","members":{"ForgotPassword":{"locationName":"forgotPassword","type":"structure","members":{"DeliveryMethod":{"locationName":"deliveryMethod"},"EmailSettings":{"shape":"Sq","locationName":"emailSettings"},"SmsSettings":{"shape":"Sr","locationName":"smsSettings"}}},"Mfa":{"locationName":"mfa","type":"structure","members":{"MFAMode":{},"Settings":{"shape":"Su","locationName":"settings"}}},"OAuth":{"locationName":"oAuth","type":"structure","members":{"DomainPrefix":{"locationName":"domainPrefix"},"OAuthGrantType":{"locationName":"oAuthGrantType"},"OAuthScopes":{"shape":"Sz","locationName":"oAuthScopes"},"RedirectSignInURIs":{"shape":"S11","locationName":"redirectSignInURIs"},"RedirectSignOutURIs":{"shape":"S11","locationName":"redirectSignOutURIs"},"SocialProviderSettings":{"shape":"S12","locationName":"socialProviderSettings"}}},"PasswordPolicy":{"locationName":"passwordPolicy","type":"structure","members":{"AdditionalConstraints":{"shape":"S16","locationName":"additionalConstraints"},"MinimumLength":{"locationName":"minimumLength","type":"double"}}},"VerificationMessage":{"locationName":"verificationMessage","type":"structure","members":{"DeliveryMethod":{"locationName":"deliveryMethod"},"EmailSettings":{"shape":"Sq","locationName":"emailSettings"},"SmsSettings":{"shape":"Sr","locationName":"smsSettings"}},"required":["DeliveryMethod"]}}}},"required":["AuthResources","UserPoolConfigs","Service"]},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName","ResourceConfig"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}}}},"UpdateBackendConfig":{"http":{"requestUri":"/backend/{appId}/config/update","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"LoginAuthConfig":{"shape":"S3c","locationName":"loginAuthConfig"}},"required":["AppId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendManagerAppId":{"locationName":"backendManagerAppId"},"Error":{"locationName":"error"},"LoginAuthConfig":{"shape":"S3c","locationName":"loginAuthConfig"}}}},"UpdateBackendJob":{"http":{"requestUri":"/backend/{appId}/job/{backendEnvironmentName}/{jobId}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"JobId":{"location":"uri","locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"}},"required":["AppId","BackendEnvironmentName","JobId"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"CreateTime":{"locationName":"createTime"},"Error":{"locationName":"error"},"JobId":{"locationName":"jobId"},"Operation":{"locationName":"operation"},"Status":{"locationName":"status"},"UpdateTime":{"locationName":"updateTime"}}}},"UpdateBackendStorage":{"http":{"requestUri":"/backend/{appId}/storage/{backendEnvironmentName}","responseCode":200},"input":{"type":"structure","members":{"AppId":{"location":"uri","locationName":"appId"},"BackendEnvironmentName":{"location":"uri","locationName":"backendEnvironmentName"},"ResourceConfig":{"locationName":"resourceConfig","type":"structure","members":{"Permissions":{"shape":"S1h","locationName":"permissions"},"ServiceName":{"locationName":"serviceName"}},"required":["ServiceName","Permissions"]},"ResourceName":{"locationName":"resourceName"}},"required":["AppId","BackendEnvironmentName","ResourceName","ResourceConfig"]},"output":{"type":"structure","members":{"AppId":{"locationName":"appId"},"BackendEnvironmentName":{"locationName":"backendEnvironmentName"},"JobId":{"locationName":"jobId"},"Status":{"locationName":"status"}}}}},"shapes":{"S8":{"type":"structure","members":{"AdditionalAuthTypes":{"locationName":"additionalAuthTypes","type":"list","member":{"shape":"Sa"}},"ApiName":{"locationName":"apiName"},"ConflictResolution":{"locationName":"conflictResolution","type":"structure","members":{"ResolutionStrategy":{"locationName":"resolutionStrategy"}}},"DefaultAuthType":{"shape":"Sa","locationName":"defaultAuthType"},"Service":{"locationName":"service"},"TransformSchema":{"locationName":"transformSchema"}}},"Sa":{"type":"structure","members":{"Mode":{"locationName":"mode"},"Settings":{"locationName":"settings","type":"structure","members":{"CognitoUserPoolId":{"locationName":"cognitoUserPoolId"},"Description":{"locationName":"description"},"ExpirationTime":{"locationName":"expirationTime","type":"double"},"OpenIDAuthTTL":{"locationName":"openIDAuthTTL"},"OpenIDClientId":{"locationName":"openIDClientId"},"OpenIDIatTTL":{"locationName":"openIDIatTTL"},"OpenIDIssueURL":{"locationName":"openIDIssueURL"},"OpenIDProviderName":{"locationName":"openIDProviderName"}}}}},"Si":{"type":"structure","members":{"AuthResources":{"locationName":"authResources"},"IdentityPoolConfigs":{"locationName":"identityPoolConfigs","type":"structure","members":{"IdentityPoolName":{"locationName":"identityPoolName"},"UnauthenticatedLogin":{"locationName":"unauthenticatedLogin","type":"boolean"}},"required":["UnauthenticatedLogin","IdentityPoolName"]},"Service":{"locationName":"service"},"UserPoolConfigs":{"locationName":"userPoolConfigs","type":"structure","members":{"ForgotPassword":{"locationName":"forgotPassword","type":"structure","members":{"DeliveryMethod":{"locationName":"deliveryMethod"},"EmailSettings":{"shape":"Sq","locationName":"emailSettings"},"SmsSettings":{"shape":"Sr","locationName":"smsSettings"}},"required":["DeliveryMethod"]},"Mfa":{"locationName":"mfa","type":"structure","members":{"MFAMode":{},"Settings":{"shape":"Su","locationName":"settings"}},"required":["MFAMode"]},"OAuth":{"locationName":"oAuth","type":"structure","members":{"DomainPrefix":{"locationName":"domainPrefix"},"OAuthGrantType":{"locationName":"oAuthGrantType"},"OAuthScopes":{"shape":"Sz","locationName":"oAuthScopes"},"RedirectSignInURIs":{"shape":"S11","locationName":"redirectSignInURIs"},"RedirectSignOutURIs":{"shape":"S11","locationName":"redirectSignOutURIs"},"SocialProviderSettings":{"shape":"S12","locationName":"socialProviderSettings"}},"required":["RedirectSignOutURIs","RedirectSignInURIs","OAuthGrantType","OAuthScopes"]},"PasswordPolicy":{"locationName":"passwordPolicy","type":"structure","members":{"AdditionalConstraints":{"shape":"S16","locationName":"additionalConstraints"},"MinimumLength":{"locationName":"minimumLength","type":"double"}},"required":["MinimumLength"]},"RequiredSignUpAttributes":{"locationName":"requiredSignUpAttributes","type":"list","member":{}},"SignInMethod":{"locationName":"signInMethod"},"UserPoolName":{"locationName":"userPoolName"},"VerificationMessage":{"locationName":"verificationMessage","type":"structure","members":{"DeliveryMethod":{"locationName":"deliveryMethod"},"EmailSettings":{"shape":"Sq","locationName":"emailSettings"},"SmsSettings":{"shape":"Sr","locationName":"smsSettings"}},"required":["DeliveryMethod"]}},"required":["RequiredSignUpAttributes","SignInMethod","UserPoolName"]}},"required":["AuthResources","UserPoolConfigs","Service"]},"Sq":{"type":"structure","members":{"EmailMessage":{"locationName":"emailMessage"},"EmailSubject":{"locationName":"emailSubject"}}},"Sr":{"type":"structure","members":{"SmsMessage":{"locationName":"smsMessage"}}},"Su":{"type":"structure","members":{"MfaTypes":{"locationName":"mfaTypes","type":"list","member":{}},"SmsMessage":{"locationName":"smsMessage"}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S12":{"type":"structure","members":{"Facebook":{"shape":"S13"},"Google":{"shape":"S13"},"LoginWithAmazon":{"shape":"S13"},"SignInWithApple":{"type":"structure","members":{"ClientId":{"locationName":"client_id"},"KeyId":{"locationName":"key_id"},"PrivateKey":{"locationName":"private_key"},"TeamId":{"locationName":"team_id"}}}}},"S13":{"type":"structure","members":{"ClientId":{"locationName":"client_id"},"ClientSecret":{"locationName":"client_secret"}}},"S16":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"Authenticated":{"locationName":"authenticated","type":"list","member":{}},"UnAuthenticated":{"locationName":"unAuthenticated","type":"list","member":{}}},"required":["Authenticated"]},"S3c":{"type":"structure","members":{"AwsCognitoIdentityPoolId":{"locationName":"aws_cognito_identity_pool_id"},"AwsCognitoRegion":{"locationName":"aws_cognito_region"},"AwsUserPoolsId":{"locationName":"aws_user_pools_id"},"AwsUserPoolsWebClientId":{"locationName":"aws_user_pools_web_client_id"}}}}}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBackendJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Jobs"}}}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appintegrations'] = {};
	AWS.AppIntegrations = Service.defineService('appintegrations', ['2020-07-29']);
	Object.defineProperty(apiLoader.services['appintegrations'], '2020-07-29', {
	  get: function get() {
	    var model = __webpack_require__(933);
	    model.paginators = __webpack_require__(934).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppIntegrations;


/***/ }),
/* 933 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-29","endpointPrefix":"app-integrations","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon AppIntegrations Service","serviceId":"AppIntegrations","signatureVersion":"v4","signingName":"app-integrations","uid":"appintegrations-2020-07-29"},"operations":{"CreateDataIntegration":{"http":{"requestUri":"/dataIntegrations"},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"KmsKey":{},"SourceURI":{},"ScheduleConfig":{"shape":"S5"},"Tags":{"shape":"S8"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Description":{},"KmsKey":{},"SourceURI":{},"ScheduleConfiguration":{"shape":"S5"},"Tags":{"shape":"S8"},"ClientToken":{}}}},"CreateEventIntegration":{"http":{"requestUri":"/eventIntegrations"},"input":{"type":"structure","required":["Name","EventFilter","EventBridgeBus"],"members":{"Name":{},"Description":{},"EventFilter":{"shape":"Sg"},"EventBridgeBus":{},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S8"}}},"output":{"type":"structure","members":{"EventIntegrationArn":{}}}},"DeleteDataIntegration":{"http":{"method":"DELETE","requestUri":"/dataIntegrations/{Identifier}"},"input":{"type":"structure","required":["DataIntegrationIdentifier"],"members":{"DataIntegrationIdentifier":{"location":"uri","locationName":"Identifier"}}},"output":{"type":"structure","members":{}}},"DeleteEventIntegration":{"http":{"method":"DELETE","requestUri":"/eventIntegrations/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{}}},"GetDataIntegration":{"http":{"method":"GET","requestUri":"/dataIntegrations/{Identifier}"},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"}}},"output":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Description":{},"KmsKey":{},"SourceURI":{},"ScheduleConfiguration":{"shape":"S5"},"Tags":{"shape":"S8"}}}},"GetEventIntegration":{"http":{"method":"GET","requestUri":"/eventIntegrations/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"Name":{},"Description":{},"EventIntegrationArn":{},"EventBridgeBus":{},"EventFilter":{"shape":"Sg"},"Tags":{"shape":"S8"}}}},"ListDataIntegrationAssociations":{"http":{"method":"GET","requestUri":"/dataIntegrations/{Identifier}/associations"},"input":{"type":"structure","required":["DataIntegrationIdentifier"],"members":{"DataIntegrationIdentifier":{"location":"uri","locationName":"Identifier"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"DataIntegrationAssociations":{"type":"list","member":{"type":"structure","members":{"DataIntegrationAssociationArn":{},"DataIntegrationArn":{},"ClientId":{}}}},"NextToken":{}}}},"ListDataIntegrations":{"http":{"method":"GET","requestUri":"/dataIntegrations"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"DataIntegrations":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"SourceURI":{}}}},"NextToken":{}}}},"ListEventIntegrationAssociations":{"http":{"method":"GET","requestUri":"/eventIntegrations/{Name}/associations"},"input":{"type":"structure","required":["EventIntegrationName"],"members":{"EventIntegrationName":{"location":"uri","locationName":"Name"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"EventIntegrationAssociations":{"type":"list","member":{"type":"structure","members":{"EventIntegrationAssociationArn":{},"EventIntegrationAssociationId":{},"EventIntegrationName":{},"ClientId":{},"EventBridgeRuleName":{},"ClientAssociationMetadata":{"type":"map","key":{},"value":{}}}}},"NextToken":{}}}},"ListEventIntegrations":{"http":{"method":"GET","requestUri":"/eventIntegrations"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"EventIntegrations":{"type":"list","member":{"type":"structure","members":{"EventIntegrationArn":{},"Name":{},"Description":{},"EventFilter":{"shape":"Sg"},"EventBridgeBus":{},"Tags":{"shape":"S8"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S8"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDataIntegration":{"http":{"method":"PATCH","requestUri":"/dataIntegrations/{Identifier}"},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateEventIntegration":{"http":{"method":"PATCH","requestUri":"/eventIntegrations/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"Description":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","members":{"FirstExecutionFrom":{},"Object":{},"ScheduleExpression":{}}},"S8":{"type":"map","key":{},"value":{}},"Sg":{"type":"structure","required":["Source"],"members":{"Source":{}}}}}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['connectcontactlens'] = {};
	AWS.ConnectContactLens = Service.defineService('connectcontactlens', ['2020-08-21']);
	Object.defineProperty(apiLoader.services['connectcontactlens'], '2020-08-21', {
	  get: function get() {
	    var model = __webpack_require__(936);
	    model.paginators = __webpack_require__(937).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ConnectContactLens;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-21","endpointPrefix":"contact-lens","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon Connect Contact Lens","serviceFullName":"Amazon Connect Contact Lens","serviceId":"Connect Contact Lens","signatureVersion":"v4","signingName":"connect","uid":"connect-contact-lens-2020-08-21"},"operations":{"ListRealtimeContactAnalysisSegments":{"http":{"requestUri":"/realtime-contact-analysis/analysis-segments"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{},"ContactId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Segments"],"members":{"Segments":{"type":"list","member":{"type":"structure","members":{"Transcript":{"type":"structure","required":["Id","ParticipantId","ParticipantRole","Content","BeginOffsetMillis","EndOffsetMillis","Sentiment"],"members":{"Id":{},"ParticipantId":{},"ParticipantRole":{},"Content":{},"BeginOffsetMillis":{"type":"integer"},"EndOffsetMillis":{"type":"integer"},"Sentiment":{},"IssuesDetected":{"type":"list","member":{"type":"structure","required":["CharacterOffsets"],"members":{"CharacterOffsets":{"type":"structure","required":["BeginOffsetChar","EndOffsetChar"],"members":{"BeginOffsetChar":{"type":"integer"},"EndOffsetChar":{"type":"integer"}}}}}}}},"Categories":{"type":"structure","required":["MatchedCategories","MatchedDetails"],"members":{"MatchedCategories":{"type":"list","member":{}},"MatchedDetails":{"type":"map","key":{},"value":{"type":"structure","required":["PointsOfInterest"],"members":{"PointsOfInterest":{"type":"list","member":{"type":"structure","required":["BeginOffsetMillis","EndOffsetMillis"],"members":{"BeginOffsetMillis":{"type":"integer"},"EndOffsetMillis":{"type":"integer"}}}}}}}}}}}},"NextToken":{}}}}},"shapes":{}}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListRealtimeContactAnalysisSegments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['devopsguru'] = {};
	AWS.DevOpsGuru = Service.defineService('devopsguru', ['2020-12-01']);
	Object.defineProperty(apiLoader.services['devopsguru'], '2020-12-01', {
	  get: function get() {
	    var model = __webpack_require__(939);
	    model.paginators = __webpack_require__(940).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.DevOpsGuru;


/***/ }),
/* 939 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-12-01","endpointPrefix":"devops-guru","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon DevOps Guru","serviceId":"DevOps Guru","signatureVersion":"v4","signingName":"devops-guru","uid":"devops-guru-2020-12-01"},"operations":{"AddNotificationChannel":{"http":{"method":"PUT","requestUri":"/channels","responseCode":200},"input":{"type":"structure","required":["Config"],"members":{"Config":{"shape":"S2"}}},"output":{"type":"structure","required":["Id"],"members":{"Id":{}}}},"DeleteInsight":{"http":{"method":"DELETE","requestUri":"/insights/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DescribeAccountHealth":{"http":{"method":"GET","requestUri":"/accounts/health","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["OpenReactiveInsights","OpenProactiveInsights","MetricsAnalyzed","ResourceHours"],"members":{"OpenReactiveInsights":{"type":"integer"},"OpenProactiveInsights":{"type":"integer"},"MetricsAnalyzed":{"type":"integer"},"ResourceHours":{"type":"long"}}}},"DescribeAccountOverview":{"http":{"requestUri":"/accounts/overview","responseCode":200},"input":{"type":"structure","required":["FromTime"],"members":{"FromTime":{"type":"timestamp"},"ToTime":{"type":"timestamp"}}},"output":{"type":"structure","required":["ReactiveInsights","ProactiveInsights","MeanTimeToRecoverInMilliseconds"],"members":{"ReactiveInsights":{"type":"integer"},"ProactiveInsights":{"type":"integer"},"MeanTimeToRecoverInMilliseconds":{"type":"long"}}}},"DescribeAnomaly":{"http":{"method":"GET","requestUri":"/anomalies/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"AccountId":{"location":"querystring","locationName":"AccountId"}}},"output":{"type":"structure","members":{"ProactiveAnomaly":{"type":"structure","members":{"Id":{},"Severity":{},"Status":{},"UpdateTime":{"type":"timestamp"},"AnomalyTimeRange":{"shape":"St"},"AnomalyReportedTimeRange":{"shape":"Su"},"PredictionTimeRange":{"shape":"Sv"},"SourceDetails":{"shape":"Sw"},"AssociatedInsightId":{},"ResourceCollection":{"shape":"S21"},"Limit":{"type":"double"},"SourceMetadata":{"shape":"S2b"},"AnomalyResources":{"shape":"S2f"}}},"ReactiveAnomaly":{"type":"structure","members":{"Id":{},"Severity":{},"Status":{},"AnomalyTimeRange":{"shape":"St"},"AnomalyReportedTimeRange":{"shape":"Su"},"SourceDetails":{"shape":"Sw"},"AssociatedInsightId":{},"ResourceCollection":{"shape":"S21"},"Type":{},"Name":{},"Description":{},"CausalAnomalyId":{},"AnomalyResources":{"shape":"S2f"}}}}}},"DescribeEventSourcesConfig":{"http":{"requestUri":"/event-sources","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EventSources":{"shape":"S2n"}}}},"DescribeFeedback":{"http":{"requestUri":"/feedback","responseCode":200},"input":{"type":"structure","members":{"InsightId":{}}},"output":{"type":"structure","members":{"InsightFeedback":{"shape":"S2s"}}}},"DescribeInsight":{"http":{"method":"GET","requestUri":"/insights/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"AccountId":{"location":"querystring","locationName":"AccountId"}}},"output":{"type":"structure","members":{"ProactiveInsight":{"type":"structure","members":{"Id":{},"Name":{},"Severity":{},"Status":{},"InsightTimeRange":{"shape":"S30"},"PredictionTimeRange":{"shape":"Sv"},"ResourceCollection":{"shape":"S21"},"SsmOpsItemId":{},"Description":{}}},"ReactiveInsight":{"type":"structure","members":{"Id":{},"Name":{},"Severity":{},"Status":{},"InsightTimeRange":{"shape":"S30"},"ResourceCollection":{"shape":"S21"},"SsmOpsItemId":{},"Description":{}}}}}},"DescribeOrganizationHealth":{"http":{"requestUri":"/organization/health","responseCode":200},"input":{"type":"structure","members":{"AccountIds":{"shape":"S35"},"OrganizationalUnitIds":{"shape":"S36"}}},"output":{"type":"structure","required":["OpenReactiveInsights","OpenProactiveInsights","MetricsAnalyzed","ResourceHours"],"members":{"OpenReactiveInsights":{"type":"integer"},"OpenProactiveInsights":{"type":"integer"},"MetricsAnalyzed":{"type":"integer"},"ResourceHours":{"type":"long"}}}},"DescribeOrganizationOverview":{"http":{"requestUri":"/organization/overview","responseCode":200},"input":{"type":"structure","required":["FromTime"],"members":{"FromTime":{"type":"timestamp"},"ToTime":{"type":"timestamp"},"AccountIds":{"shape":"S35"},"OrganizationalUnitIds":{"shape":"S36"}}},"output":{"type":"structure","required":["ReactiveInsights","ProactiveInsights"],"members":{"ReactiveInsights":{"type":"integer"},"ProactiveInsights":{"type":"integer"}}}},"DescribeOrganizationResourceCollectionHealth":{"http":{"requestUri":"/organization/health/resource-collection","responseCode":200},"input":{"type":"structure","required":["OrganizationResourceCollectionType"],"members":{"OrganizationResourceCollectionType":{},"AccountIds":{"shape":"S35"},"OrganizationalUnitIds":{"shape":"S36"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CloudFormation":{"shape":"S3g"},"Service":{"shape":"S3j"},"Account":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"Insight":{"type":"structure","members":{"OpenProactiveInsights":{"type":"integer"},"OpenReactiveInsights":{"type":"integer"}}}}}},"NextToken":{},"Tags":{"shape":"S3q"}}}},"DescribeResourceCollectionHealth":{"http":{"method":"GET","requestUri":"/accounts/health/resource-collection/{ResourceCollectionType}","responseCode":200},"input":{"type":"structure","required":["ResourceCollectionType"],"members":{"ResourceCollectionType":{"location":"uri","locationName":"ResourceCollectionType"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"CloudFormation":{"shape":"S3g"},"Service":{"shape":"S3j"},"NextToken":{},"Tags":{"shape":"S3q"}}}},"DescribeServiceIntegration":{"http":{"method":"GET","requestUri":"/service-integrations","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ServiceIntegration":{"type":"structure","members":{"OpsCenter":{"type":"structure","members":{"OptInStatus":{}}}}}}}},"GetCostEstimation":{"http":{"method":"GET","requestUri":"/cost-estimation","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ResourceCollection":{"shape":"S42"},"Status":{},"Costs":{"type":"list","member":{"type":"structure","members":{"Type":{},"State":{},"Count":{"type":"integer"},"UnitCost":{"type":"double"},"Cost":{"type":"double"}}}},"TimeRange":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"TotalCost":{"type":"double"},"NextToken":{}}}},"GetResourceCollection":{"http":{"method":"GET","requestUri":"/resource-collections/{ResourceCollectionType}","responseCode":200},"input":{"type":"structure","required":["ResourceCollectionType"],"members":{"ResourceCollectionType":{"location":"uri","locationName":"ResourceCollectionType"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ResourceCollection":{"type":"structure","members":{"CloudFormation":{"type":"structure","members":{"StackNames":{"shape":"S23"}}},"Tags":{"type":"list","member":{"type":"structure","required":["AppBoundaryKey","TagValues"],"members":{"AppBoundaryKey":{},"TagValues":{"shape":"S28"}}}}}},"NextToken":{}}}},"ListAnomaliesForInsight":{"http":{"requestUri":"/anomalies/insight/{InsightId}","responseCode":200},"input":{"type":"structure","required":["InsightId"],"members":{"InsightId":{"location":"uri","locationName":"InsightId"},"StartTimeRange":{"shape":"S4m"},"MaxResults":{"type":"integer"},"NextToken":{},"AccountId":{}}},"output":{"type":"structure","members":{"ProactiveAnomalies":{"type":"list","member":{"type":"structure","members":{"Id":{},"Severity":{},"Status":{},"UpdateTime":{"type":"timestamp"},"AnomalyTimeRange":{"shape":"St"},"AnomalyReportedTimeRange":{"shape":"Su"},"PredictionTimeRange":{"shape":"Sv"},"SourceDetails":{"shape":"Sw"},"AssociatedInsightId":{},"ResourceCollection":{"shape":"S21"},"Limit":{"type":"double"},"SourceMetadata":{"shape":"S2b"},"AnomalyResources":{"shape":"S2f"}}}},"ReactiveAnomalies":{"type":"list","member":{"type":"structure","members":{"Id":{},"Severity":{},"Status":{},"AnomalyTimeRange":{"shape":"St"},"AnomalyReportedTimeRange":{"shape":"Su"},"SourceDetails":{"shape":"Sw"},"AssociatedInsightId":{},"ResourceCollection":{"shape":"S21"},"Type":{},"Name":{},"Description":{},"CausalAnomalyId":{},"AnomalyResources":{"shape":"S2f"}}}},"NextToken":{}}}},"ListEvents":{"http":{"requestUri":"/events","responseCode":200},"input":{"type":"structure","required":["Filters"],"members":{"Filters":{"type":"structure","members":{"InsightId":{},"EventTimeRange":{"type":"structure","required":["FromTime","ToTime"],"members":{"FromTime":{"type":"timestamp"},"ToTime":{"type":"timestamp"}}},"EventClass":{},"EventSource":{},"DataSource":{},"ResourceCollection":{"shape":"S21"}}},"MaxResults":{"type":"integer"},"NextToken":{},"AccountId":{}}},"output":{"type":"structure","required":["Events"],"members":{"Events":{"type":"list","member":{"type":"structure","members":{"ResourceCollection":{"shape":"S21"},"Id":{},"Time":{"type":"timestamp"},"EventSource":{},"Name":{},"DataSource":{},"EventClass":{},"Resources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Name":{},"Arn":{}}}}}}},"NextToken":{}}}},"ListInsights":{"http":{"requestUri":"/insights","responseCode":200},"input":{"type":"structure","required":["StatusFilter"],"members":{"StatusFilter":{"shape":"S5b"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ProactiveInsights":{"shape":"S5j"},"ReactiveInsights":{"shape":"S5p"},"NextToken":{}}}},"ListNotificationChannels":{"http":{"requestUri":"/channels","responseCode":200},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"type":"structure","members":{"Id":{},"Config":{"shape":"S2"}}}},"NextToken":{}}}},"ListOrganizationInsights":{"http":{"requestUri":"/organization/insights","responseCode":200},"input":{"type":"structure","required":["StatusFilter"],"members":{"StatusFilter":{"shape":"S5b"},"MaxResults":{"type":"integer"},"AccountIds":{"type":"list","member":{}},"OrganizationalUnitIds":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ProactiveInsights":{"type":"list","member":{"type":"structure","members":{"Id":{},"AccountId":{},"OrganizationalUnitId":{},"Name":{},"Severity":{},"Status":{},"InsightTimeRange":{"shape":"S30"},"PredictionTimeRange":{"shape":"Sv"},"ResourceCollection":{"shape":"S21"},"ServiceCollection":{"shape":"S5l"}}}},"ReactiveInsights":{"type":"list","member":{"type":"structure","members":{"Id":{},"AccountId":{},"OrganizationalUnitId":{},"Name":{},"Severity":{},"Status":{},"InsightTimeRange":{"shape":"S30"},"ResourceCollection":{"shape":"S21"},"ServiceCollection":{"shape":"S5l"}}}},"NextToken":{}}}},"ListRecommendations":{"http":{"requestUri":"/recommendations","responseCode":200},"input":{"type":"structure","required":["InsightId"],"members":{"InsightId":{},"NextToken":{},"Locale":{},"AccountId":{}}},"output":{"type":"structure","members":{"Recommendations":{"type":"list","member":{"type":"structure","members":{"Description":{},"Link":{},"Name":{},"Reason":{},"RelatedEvents":{"type":"list","member":{"type":"structure","members":{"Name":{},"Resources":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{}}}}}}},"RelatedAnomalies":{"type":"list","member":{"type":"structure","members":{"Resources":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{}}}},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"CloudWatchMetrics":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"Namespace":{}}}}}}},"AnomalyId":{}}}},"Category":{}}}},"NextToken":{}}}},"PutFeedback":{"http":{"method":"PUT","requestUri":"/feedback","responseCode":200},"input":{"type":"structure","members":{"InsightFeedback":{"shape":"S2s"}}},"output":{"type":"structure","members":{}}},"RemoveNotificationChannel":{"http":{"method":"DELETE","requestUri":"/channels/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"SearchInsights":{"http":{"requestUri":"/insights/search","responseCode":200},"input":{"type":"structure","required":["StartTimeRange","Type"],"members":{"StartTimeRange":{"shape":"S4m"},"Filters":{"type":"structure","members":{"Severities":{"shape":"S72"},"Statuses":{"shape":"S73"},"ResourceCollection":{"shape":"S21"},"ServiceCollection":{"shape":"S5l"}}},"MaxResults":{"type":"integer"},"NextToken":{},"Type":{}}},"output":{"type":"structure","members":{"ProactiveInsights":{"shape":"S5j"},"ReactiveInsights":{"shape":"S5p"},"NextToken":{}}}},"SearchOrganizationInsights":{"http":{"requestUri":"/organization/insights/search","responseCode":200},"input":{"type":"structure","required":["AccountIds","StartTimeRange","Type"],"members":{"AccountIds":{"type":"list","member":{}},"StartTimeRange":{"shape":"S4m"},"Filters":{"type":"structure","members":{"Severities":{"shape":"S72"},"Statuses":{"shape":"S73"},"ResourceCollection":{"shape":"S21"},"ServiceCollection":{"shape":"S5l"}}},"MaxResults":{"type":"integer"},"NextToken":{},"Type":{}}},"output":{"type":"structure","members":{"ProactiveInsights":{"shape":"S5j"},"ReactiveInsights":{"shape":"S5p"},"NextToken":{}}}},"StartCostEstimation":{"http":{"method":"PUT","requestUri":"/cost-estimation","responseCode":200},"input":{"type":"structure","required":["ResourceCollection"],"members":{"ResourceCollection":{"shape":"S42"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"UpdateEventSourcesConfig":{"http":{"method":"PUT","requestUri":"/event-sources","responseCode":200},"input":{"type":"structure","members":{"EventSources":{"shape":"S2n"}}},"output":{"type":"structure","members":{}}},"UpdateResourceCollection":{"http":{"method":"PUT","requestUri":"/resource-collections","responseCode":200},"input":{"type":"structure","required":["Action","ResourceCollection"],"members":{"Action":{},"ResourceCollection":{"type":"structure","members":{"CloudFormation":{"type":"structure","members":{"StackNames":{"type":"list","member":{}}}},"Tags":{"type":"list","member":{"type":"structure","required":["AppBoundaryKey","TagValues"],"members":{"AppBoundaryKey":{},"TagValues":{"type":"list","member":{}}}}}}}}},"output":{"type":"structure","members":{}}},"UpdateServiceIntegration":{"http":{"method":"PUT","requestUri":"/service-integrations","responseCode":200},"input":{"type":"structure","required":["ServiceIntegration"],"members":{"ServiceIntegration":{"type":"structure","members":{"OpsCenter":{"type":"structure","members":{"OptInStatus":{}}}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","required":["Sns"],"members":{"Sns":{"type":"structure","members":{"TopicArn":{}}}}},"St":{"type":"structure","required":["StartTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"Su":{"type":"structure","required":["OpenTime"],"members":{"OpenTime":{"type":"timestamp"},"CloseTime":{"type":"timestamp"}}},"Sv":{"type":"structure","required":["StartTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"Sw":{"type":"structure","members":{"CloudWatchMetrics":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"Stat":{},"Unit":{},"Period":{"type":"integer"},"MetricDataSummary":{"type":"structure","members":{"TimestampMetricValuePairList":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"MetricValue":{"type":"double"}}}},"StatusCode":{}}}}}},"PerformanceInsightsMetrics":{"type":"list","member":{"type":"structure","members":{"MetricDisplayName":{},"Unit":{},"MetricQuery":{"shape":"S1h"},"ReferenceData":{"type":"list","member":{"type":"structure","members":{"Name":{},"ComparisonValues":{"type":"structure","members":{"ReferenceScalar":{"type":"structure","members":{"Value":{"type":"double"}}},"ReferenceMetric":{"type":"structure","members":{"MetricQuery":{"shape":"S1h"}}}}}}}},"StatsAtAnomaly":{"shape":"S1y"},"StatsAtBaseline":{"shape":"S1y"}}}}}},"S1h":{"type":"structure","members":{"Metric":{},"GroupBy":{"type":"structure","members":{"Group":{},"Dimensions":{"type":"list","member":{}},"Limit":{"type":"integer"}}},"Filter":{"type":"map","key":{},"value":{}}}},"S1y":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{"type":"double"}}}},"S21":{"type":"structure","members":{"CloudFormation":{"type":"structure","members":{"StackNames":{"shape":"S23"}}},"Tags":{"type":"list","member":{"type":"structure","required":["AppBoundaryKey","TagValues"],"members":{"AppBoundaryKey":{},"TagValues":{"shape":"S28"}}}}}},"S23":{"type":"list","member":{}},"S28":{"type":"list","member":{}},"S2b":{"type":"structure","members":{"Source":{},"SourceResourceName":{},"SourceResourceType":{}}},"S2f":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{}}}},"S2n":{"type":"structure","members":{"AmazonCodeGuruProfiler":{"type":"structure","members":{"Status":{}}}}},"S2s":{"type":"structure","members":{"Id":{},"Feedback":{}}},"S30":{"type":"structure","required":["StartTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S35":{"type":"list","member":{}},"S36":{"type":"list","member":{}},"S3g":{"type":"list","member":{"type":"structure","members":{"StackName":{},"Insight":{"shape":"S3i"}}}},"S3i":{"type":"structure","members":{"OpenProactiveInsights":{"type":"integer"},"OpenReactiveInsights":{"type":"integer"},"MeanTimeToRecoverInMilliseconds":{"type":"long"}}},"S3j":{"type":"list","member":{"type":"structure","members":{"ServiceName":{},"Insight":{"type":"structure","members":{"OpenProactiveInsights":{"type":"integer"},"OpenReactiveInsights":{"type":"integer"}}}}}},"S3q":{"type":"list","member":{"type":"structure","members":{"AppBoundaryKey":{},"TagValue":{},"Insight":{"shape":"S3i"}}}},"S42":{"type":"structure","members":{"CloudFormation":{"type":"structure","members":{"StackNames":{"type":"list","member":{}}}},"Tags":{"type":"list","member":{"type":"structure","required":["AppBoundaryKey","TagValues"],"members":{"AppBoundaryKey":{},"TagValues":{"type":"list","member":{}}}}}}},"S4m":{"type":"structure","members":{"FromTime":{"type":"timestamp"},"ToTime":{"type":"timestamp"}}},"S5b":{"type":"structure","members":{"Ongoing":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Closed":{"type":"structure","required":["Type","EndTimeRange"],"members":{"Type":{},"EndTimeRange":{"type":"structure","members":{"FromTime":{"type":"timestamp"},"ToTime":{"type":"timestamp"}}}}},"Any":{"type":"structure","required":["Type","StartTimeRange"],"members":{"Type":{},"StartTimeRange":{"shape":"S4m"}}}}},"S5j":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Severity":{},"Status":{},"InsightTimeRange":{"shape":"S30"},"PredictionTimeRange":{"shape":"Sv"},"ResourceCollection":{"shape":"S21"},"ServiceCollection":{"shape":"S5l"},"AssociatedResourceArns":{"shape":"S5n"}}}},"S5l":{"type":"structure","members":{"ServiceNames":{"type":"list","member":{}}}},"S5n":{"type":"list","member":{}},"S5p":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Severity":{},"Status":{},"InsightTimeRange":{"shape":"S30"},"ResourceCollection":{"shape":"S21"},"ServiceCollection":{"shape":"S5l"},"AssociatedResourceArns":{"shape":"S5n"}}}},"S72":{"type":"list","member":{}},"S73":{"type":"list","member":{}}}}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeOrganizationResourceCollectionHealth":{"input_token":"NextToken","output_token":"NextToken","result_key":["CloudFormation","Account","Service","Tags"]},"DescribeResourceCollectionHealth":{"input_token":"NextToken","output_token":"NextToken","result_key":["CloudFormation","Service","Tags"]},"GetCostEstimation":{"input_token":"NextToken","non_aggregate_keys":["Status","TotalCost","TimeRange","ResourceCollection"],"output_token":"NextToken","result_key":["Costs"]},"GetResourceCollection":{"input_token":"NextToken","non_aggregate_keys":["ResourceCollection"],"output_token":"NextToken","result_key":["ResourceCollection.CloudFormation.StackNames","ResourceCollection.Tags"]},"ListAnomaliesForInsight":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":["ReactiveAnomalies","ProactiveAnomalies"]},"ListEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"},"ListInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":["ProactiveInsights","ReactiveInsights"]},"ListNotificationChannels":{"input_token":"NextToken","output_token":"NextToken","result_key":"Channels"},"ListOrganizationInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":["ProactiveInsights","ReactiveInsights"]},"ListRecommendations":{"input_token":"NextToken","output_token":"NextToken","result_key":"Recommendations"},"SearchInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":["ProactiveInsights","ReactiveInsights"]},"SearchOrganizationInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":["ProactiveInsights","ReactiveInsights"]}}}

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ecrpublic'] = {};
	AWS.ECRPUBLIC = Service.defineService('ecrpublic', ['2020-10-30']);
	Object.defineProperty(apiLoader.services['ecrpublic'], '2020-10-30', {
	  get: function get() {
	    var model = __webpack_require__(942);
	    model.paginators = __webpack_require__(943).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ECRPUBLIC;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-10-30","endpointPrefix":"api.ecr-public","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECR Public","serviceFullName":"Amazon Elastic Container Registry Public","serviceId":"ECR PUBLIC","signatureVersion":"v4","signingName":"ecr-public","targetPrefix":"SpencerFrontendService","uid":"ecr-public-2020-10-30"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Sj"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Sj"},"failures":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sk"},"failureCode":{},"failureReason":{}}}}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"catalogData":{"shape":"Sx"},"tags":{"shape":"S16"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1b"},"catalogData":{"shape":"S1f"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1b"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImageTags":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"imageTagDetails":{"type":"list","member":{"type":"structure","members":{"imageTag":{},"createdAt":{"type":"timestamp"},"imageDetail":{"type":"structure","members":{"imageDigest":{},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"},"imageManifestMediaType":{},"artifactMediaType":{}}}}}},"nextToken":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Sj"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"type":"list","member":{}},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"},"imageManifestMediaType":{},"artifactMediaType":{}}}},"nextToken":{}}}},"DescribeRegistries":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["registries"],"members":{"registries":{"type":"list","member":{"type":"structure","required":["registryId","registryArn","registryUri","verified","aliases"],"members":{"registryId":{},"registryArn":{},"registryUri":{},"verified":{"type":"boolean"},"aliases":{"type":"list","member":{"type":"structure","required":["name","status","primaryRegistryAlias","defaultRegistryAlias"],"members":{"name":{},"status":{},"primaryRegistryAlias":{"type":"boolean"},"defaultRegistryAlias":{"type":"boolean"}}}}}}},"nextToken":{}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1b"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"authorizationData":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"}}}}}},"GetRegistryCatalogData":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["registryCatalogData"],"members":{"registryCatalogData":{"shape":"S2o"}}}},"GetRepositoryCatalogData":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"catalogData":{"shape":"S1f"}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S16"}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageManifestMediaType":{},"imageTag":{},"imageDigest":{}}},"output":{"type":"structure","members":{"image":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sk"},"imageManifest":{},"imageManifestMediaType":{}}}}}},"PutRegistryCatalogData":{"input":{"type":"structure","members":{"displayName":{}}},"output":{"type":"structure","required":["registryCatalogData"],"members":{"registryCatalogData":{"shape":"S2o"}}}},"PutRepositoryCatalogData":{"input":{"type":"structure","required":["repositoryName","catalogData"],"members":{"registryId":{},"repositoryName":{},"catalogData":{"shape":"Sx"}}},"output":{"type":"structure","members":{"catalogData":{"shape":"S1f"}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}}},"shapes":{"Sj":{"type":"list","member":{"shape":"Sk"}},"Sk":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sx":{"type":"structure","members":{"description":{},"architectures":{"shape":"Sz"},"operatingSystems":{"shape":"S11"},"logoImageBlob":{"type":"blob"},"aboutText":{},"usageText":{}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S16":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S1b":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"}}},"S1f":{"type":"structure","members":{"description":{},"architectures":{"shape":"Sz"},"operatingSystems":{"shape":"S11"},"logoUrl":{},"aboutText":{},"usageText":{},"marketplaceCertified":{"type":"boolean"}}},"S2o":{"type":"structure","members":{"displayName":{}}}}}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeImageTags":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageTagDetails"},"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribeRegistries":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"registries"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"}}}

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lookoutvision'] = {};
	AWS.LookoutVision = Service.defineService('lookoutvision', ['2020-11-20']);
	Object.defineProperty(apiLoader.services['lookoutvision'], '2020-11-20', {
	  get: function get() {
	    var model = __webpack_require__(945);
	    model.paginators = __webpack_require__(946).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LookoutVision;


/***/ }),
/* 945 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-20","endpointPrefix":"lookoutvision","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lookout for Vision","serviceId":"LookoutVision","signatureVersion":"v4","signingName":"lookoutvision","uid":"lookoutvision-2020-11-20"},"operations":{"CreateDataset":{"http":{"requestUri":"/2020-11-20/projects/{projectName}/datasets","responseCode":202},"input":{"type":"structure","required":["ProjectName","DatasetType"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"DatasetType":{},"DatasetSource":{"type":"structure","members":{"GroundTruthManifest":{"type":"structure","members":{"S3Object":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{},"Key":{},"VersionId":{}}}}}}},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"DatasetMetadata":{"shape":"Sc"}}}},"CreateModel":{"http":{"requestUri":"/2020-11-20/projects/{projectName}/models","responseCode":202},"input":{"type":"structure","required":["ProjectName","OutputConfig"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"Description":{},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"},"OutputConfig":{"shape":"Si"},"KmsKeyId":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ModelMetadata":{"shape":"Sr"}}}},"CreateProject":{"http":{"requestUri":"/2020-11-20/projects"},"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"ProjectMetadata":{"shape":"S10"}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/2020-11-20/projects/{projectName}/datasets/{datasetType}","responseCode":202},"input":{"type":"structure","required":["ProjectName","DatasetType"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"DatasetType":{"location":"uri","locationName":"datasetType"},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/2020-11-20/projects/{projectName}/models/{modelVersion}","responseCode":202},"input":{"type":"structure","required":["ProjectName","ModelVersion"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ModelVersion":{"location":"uri","locationName":"modelVersion"},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"ModelArn":{}}}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/2020-11-20/projects/{projectName}"},"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"ProjectArn":{}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}/datasets/{datasetType}"},"input":{"type":"structure","required":["ProjectName","DatasetType"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"DatasetType":{"location":"uri","locationName":"datasetType"}}},"output":{"type":"structure","members":{"DatasetDescription":{"type":"structure","members":{"ProjectName":{},"DatasetType":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Status":{},"StatusMessage":{},"ImageStats":{"type":"structure","members":{"Total":{"type":"integer"},"Labeled":{"type":"integer"},"Normal":{"type":"integer"},"Anomaly":{"type":"integer"}}}}}}}},"DescribeModel":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}/models/{modelVersion}"},"input":{"type":"structure","required":["ProjectName","ModelVersion"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ModelVersion":{"location":"uri","locationName":"modelVersion"}}},"output":{"type":"structure","members":{"ModelDescription":{"type":"structure","members":{"ModelVersion":{},"ModelArn":{},"CreationTimestamp":{"type":"timestamp"},"Description":{},"Status":{},"StatusMessage":{},"Performance":{"shape":"Sw"},"OutputConfig":{"shape":"Si"},"EvaluationManifest":{"shape":"S1h"},"EvaluationResult":{"shape":"S1h"},"EvaluationEndTimestamp":{"type":"timestamp"},"KmsKeyId":{}}}}}},"DescribeModelPackagingJob":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}/modelpackagingjobs/{jobName}"},"input":{"type":"structure","required":["ProjectName","JobName"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"JobName":{"location":"uri","locationName":"jobName"}}},"output":{"type":"structure","members":{"ModelPackagingDescription":{"type":"structure","members":{"JobName":{},"ProjectName":{},"ModelVersion":{},"ModelPackagingConfiguration":{"shape":"S1m"},"ModelPackagingJobDescription":{},"ModelPackagingMethod":{},"ModelPackagingOutputDetails":{"type":"structure","members":{"Greengrass":{"type":"structure","members":{"ComponentVersionArn":{},"ComponentName":{},"ComponentVersion":{}}}}},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}}},"DescribeProject":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}"},"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","members":{"ProjectDescription":{"type":"structure","members":{"ProjectArn":{},"ProjectName":{},"CreationTimestamp":{"type":"timestamp"},"Datasets":{"type":"list","member":{"shape":"Sc"}}}}}}},"DetectAnomalies":{"http":{"requestUri":"/2020-11-20/projects/{projectName}/models/{modelVersion}/detect"},"input":{"type":"structure","required":["ProjectName","ModelVersion","Body","ContentType"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ModelVersion":{"location":"uri","locationName":"modelVersion"},"Body":{"type":"blob","requiresLength":true,"streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Body"},"output":{"type":"structure","members":{"DetectAnomalyResult":{"type":"structure","members":{"Source":{"type":"structure","members":{"Type":{}}},"IsAnomalous":{"type":"boolean"},"Confidence":{"type":"float"}}}}}},"ListDatasetEntries":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}/datasets/{datasetType}/entries"},"input":{"type":"structure","required":["ProjectName","DatasetType"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"DatasetType":{"location":"uri","locationName":"datasetType"},"Labeled":{"location":"querystring","locationName":"labeled","type":"boolean"},"AnomalyClass":{"location":"querystring","locationName":"anomalyClass"},"BeforeCreationDate":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"AfterCreationDate":{"location":"querystring","locationName":"createdAfter","type":"timestamp"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SourceRefContains":{"location":"querystring","locationName":"sourceRefContains"}}},"output":{"type":"structure","members":{"DatasetEntries":{"type":"list","member":{}},"NextToken":{}}}},"ListModelPackagingJobs":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}/modelpackagingjobs"},"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ModelPackagingJobs":{"type":"list","member":{"type":"structure","members":{"JobName":{},"ProjectName":{},"ModelVersion":{},"ModelPackagingJobDescription":{},"ModelPackagingMethod":{},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListModels":{"http":{"method":"GET","requestUri":"/2020-11-20/projects/{projectName}/models"},"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Models":{"type":"list","member":{"shape":"Sr"}},"NextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/2020-11-20/projects"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Projects":{"type":"list","member":{"shape":"S10"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2020-11-20/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sm"}}}},"StartModel":{"http":{"requestUri":"/2020-11-20/projects/{projectName}/models/{modelVersion}/start","responseCode":202},"input":{"type":"structure","required":["ProjectName","ModelVersion","MinInferenceUnits"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ModelVersion":{"location":"uri","locationName":"modelVersion"},"MinInferenceUnits":{"type":"integer"},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"Status":{}}}},"StartModelPackagingJob":{"http":{"requestUri":"/2020-11-20/projects/{projectName}/modelpackagingjobs"},"input":{"type":"structure","required":["ProjectName","ModelVersion","Configuration"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ModelVersion":{},"JobName":{},"Configuration":{"shape":"S1m"},"Description":{},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"JobName":{}}}},"StopModel":{"http":{"requestUri":"/2020-11-20/projects/{projectName}/models/{modelVersion}/stop","responseCode":202},"input":{"type":"structure","required":["ProjectName","ModelVersion"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"ModelVersion":{"location":"uri","locationName":"modelVersion"},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"Status":{}}}},"TagResource":{"http":{"requestUri":"/2020-11-20/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2020-11-20/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDatasetEntries":{"http":{"method":"PATCH","requestUri":"/2020-11-20/projects/{projectName}/datasets/{datasetType}/entries","responseCode":202},"input":{"type":"structure","required":["ProjectName","DatasetType","Changes"],"members":{"ProjectName":{"location":"uri","locationName":"projectName"},"DatasetType":{"location":"uri","locationName":"datasetType"},"Changes":{"type":"blob"},"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"}}},"output":{"type":"structure","members":{"Status":{}}}}},"shapes":{"Sc":{"type":"structure","members":{"DatasetType":{},"CreationTimestamp":{"type":"timestamp"},"Status":{},"StatusMessage":{}}},"Si":{"type":"structure","required":["S3Location"],"members":{"S3Location":{"shape":"Sj"}}},"Sj":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Prefix":{}}},"Sm":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sr":{"type":"structure","members":{"CreationTimestamp":{"type":"timestamp"},"ModelVersion":{},"ModelArn":{},"Description":{},"Status":{},"StatusMessage":{},"Performance":{"shape":"Sw"}}},"Sw":{"type":"structure","members":{"F1Score":{"type":"float"},"Recall":{"type":"float"},"Precision":{"type":"float"}}},"S10":{"type":"structure","members":{"ProjectArn":{},"ProjectName":{},"CreationTimestamp":{"type":"timestamp"}}},"S1h":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{},"Key":{}}},"S1m":{"type":"structure","required":["Greengrass"],"members":{"Greengrass":{"type":"structure","required":["S3OutputLocation","ComponentName"],"members":{"CompilerOptions":{},"TargetDevice":{},"TargetPlatform":{"type":"structure","required":["Os","Arch","Accelerator"],"members":{"Os":{},"Arch":{},"Accelerator":{}}},"S3OutputLocation":{"shape":"Sj"},"ComponentName":{},"ComponentVersion":{},"ComponentDescription":{},"Tags":{"shape":"Sm"}}}}}}}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDatasetEntries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DatasetEntries"},"ListModelPackagingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ModelPackagingJobs"},"ListModels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Models"},"ListProjects":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Projects"}}}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sagemakerfeaturestoreruntime'] = {};
	AWS.SageMakerFeatureStoreRuntime = Service.defineService('sagemakerfeaturestoreruntime', ['2020-07-01']);
	Object.defineProperty(apiLoader.services['sagemakerfeaturestoreruntime'], '2020-07-01', {
	  get: function get() {
	    var model = __webpack_require__(948);
	    model.paginators = __webpack_require__(949).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SageMakerFeatureStoreRuntime;


/***/ }),
/* 948 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-01","endpointPrefix":"featurestore-runtime.sagemaker","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon SageMaker Feature Store Runtime","serviceId":"SageMaker FeatureStore Runtime","signatureVersion":"v4","signingName":"sagemaker","uid":"sagemaker-featurestore-runtime-2020-07-01"},"operations":{"BatchGetRecord":{"http":{"requestUri":"/BatchGetRecord"},"input":{"type":"structure","required":["Identifiers"],"members":{"Identifiers":{"type":"list","member":{"shape":"S3"}}}},"output":{"type":"structure","required":["Records","Errors","UnprocessedIdentifiers"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["FeatureGroupName","RecordIdentifierValueAsString","Record"],"members":{"FeatureGroupName":{},"RecordIdentifierValueAsString":{},"Record":{"shape":"Sc"}}}},"Errors":{"type":"list","member":{"type":"structure","required":["FeatureGroupName","RecordIdentifierValueAsString","ErrorCode","ErrorMessage"],"members":{"FeatureGroupName":{},"RecordIdentifierValueAsString":{},"ErrorCode":{},"ErrorMessage":{}}}},"UnprocessedIdentifiers":{"type":"list","member":{"shape":"S3"}}}}},"DeleteRecord":{"http":{"method":"DELETE","requestUri":"/FeatureGroup/{FeatureGroupName}"},"input":{"type":"structure","required":["FeatureGroupName","RecordIdentifierValueAsString","EventTime"],"members":{"FeatureGroupName":{"location":"uri","locationName":"FeatureGroupName"},"RecordIdentifierValueAsString":{"location":"querystring","locationName":"RecordIdentifierValueAsString"},"EventTime":{"location":"querystring","locationName":"EventTime"}}}},"GetRecord":{"http":{"method":"GET","requestUri":"/FeatureGroup/{FeatureGroupName}"},"input":{"type":"structure","required":["FeatureGroupName","RecordIdentifierValueAsString"],"members":{"FeatureGroupName":{"location":"uri","locationName":"FeatureGroupName"},"RecordIdentifierValueAsString":{"location":"querystring","locationName":"RecordIdentifierValueAsString"},"FeatureNames":{"shape":"S7","location":"querystring","locationName":"FeatureName"}}},"output":{"type":"structure","members":{"Record":{"shape":"Sc"}}}},"PutRecord":{"http":{"method":"PUT","requestUri":"/FeatureGroup/{FeatureGroupName}"},"input":{"type":"structure","required":["FeatureGroupName","Record"],"members":{"FeatureGroupName":{"location":"uri","locationName":"FeatureGroupName"},"Record":{"shape":"Sc"}}}}},"shapes":{"S3":{"type":"structure","required":["FeatureGroupName","RecordIdentifiersValueAsString"],"members":{"FeatureGroupName":{},"RecordIdentifiersValueAsString":{"type":"list","member":{}},"FeatureNames":{"shape":"S7"}}},"S7":{"type":"list","member":{}},"Sc":{"type":"list","member":{"type":"structure","required":["FeatureName","ValueAsString"],"members":{"FeatureName":{},"ValueAsString":{}}}}}}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['customerprofiles'] = {};
	AWS.CustomerProfiles = Service.defineService('customerprofiles', ['2020-08-15']);
	Object.defineProperty(apiLoader.services['customerprofiles'], '2020-08-15', {
	  get: function get() {
	    var model = __webpack_require__(951);
	    model.paginators = __webpack_require__(952).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CustomerProfiles;


/***/ }),
/* 951 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-15","endpointPrefix":"profile","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Customer Profiles","serviceFullName":"Amazon Connect Customer Profiles","serviceId":"Customer Profiles","signatureVersion":"v4","signingName":"profile","uid":"customer-profiles-2020-08-15"},"operations":{"AddProfileKey":{"http":{"requestUri":"/domains/{DomainName}/profiles/keys"},"input":{"type":"structure","required":["ProfileId","KeyName","Values","DomainName"],"members":{"ProfileId":{},"KeyName":{},"Values":{"shape":"S4"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"KeyName":{},"Values":{"shape":"S4"}}}},"CreateDomain":{"http":{"requestUri":"/domains/{DomainName}"},"input":{"type":"structure","required":["DomainName","DefaultExpirationDays"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"DefaultExpirationDays":{"type":"integer"},"DefaultEncryptionKey":{},"DeadLetterQueueUrl":{},"Matching":{"shape":"Sb"},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["DomainName","DefaultExpirationDays","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"DefaultExpirationDays":{"type":"integer"},"DefaultEncryptionKey":{},"DeadLetterQueueUrl":{},"Matching":{"shape":"Su"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"CreateIntegrationWorkflow":{"http":{"requestUri":"/domains/{DomainName}/workflows/integrations"},"input":{"type":"structure","required":["DomainName","WorkflowType","IntegrationConfig","ObjectTypeName","RoleArn"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"WorkflowType":{},"IntegrationConfig":{"type":"structure","members":{"AppflowIntegration":{"type":"structure","required":["FlowDefinition"],"members":{"FlowDefinition":{"shape":"S10"},"Batches":{"type":"list","member":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}}}}}},"ObjectTypeName":{},"RoleArn":{},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["WorkflowId","Message"],"members":{"WorkflowId":{},"Message":{}}}},"CreateProfile":{"http":{"requestUri":"/domains/{DomainName}/profiles"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"AccountNumber":{},"AdditionalInformation":{},"PartyType":{},"BusinessName":{},"FirstName":{},"MiddleName":{},"LastName":{},"BirthDate":{},"Gender":{},"PhoneNumber":{},"MobilePhoneNumber":{},"HomePhoneNumber":{},"BusinessPhoneNumber":{},"EmailAddress":{},"PersonalEmailAddress":{},"BusinessEmailAddress":{},"Address":{"shape":"S2g"},"ShippingAddress":{"shape":"S2g"},"MailingAddress":{"shape":"S2g"},"BillingAddress":{"shape":"S2g"},"Attributes":{"shape":"S2h"}}},"output":{"type":"structure","required":["ProfileId"],"members":{"ProfileId":{}}}},"DeleteDomain":{"http":{"method":"DELETE","requestUri":"/domains/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["Message"],"members":{"Message":{}}}},"DeleteIntegration":{"http":{"requestUri":"/domains/{DomainName}/integrations/delete"},"input":{"type":"structure","required":["DomainName","Uri"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"Uri":{}}},"output":{"type":"structure","required":["Message"],"members":{"Message":{}}}},"DeleteProfile":{"http":{"requestUri":"/domains/{DomainName}/profiles/delete"},"input":{"type":"structure","required":["ProfileId","DomainName"],"members":{"ProfileId":{},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"Message":{}}}},"DeleteProfileKey":{"http":{"requestUri":"/domains/{DomainName}/profiles/keys/delete"},"input":{"type":"structure","required":["ProfileId","KeyName","Values","DomainName"],"members":{"ProfileId":{},"KeyName":{},"Values":{"shape":"S4"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"Message":{}}}},"DeleteProfileObject":{"http":{"requestUri":"/domains/{DomainName}/profiles/objects/delete"},"input":{"type":"structure","required":["ProfileId","ProfileObjectUniqueKey","ObjectTypeName","DomainName"],"members":{"ProfileId":{},"ProfileObjectUniqueKey":{},"ObjectTypeName":{},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"Message":{}}}},"DeleteProfileObjectType":{"http":{"method":"DELETE","requestUri":"/domains/{DomainName}/object-types/{ObjectTypeName}"},"input":{"type":"structure","required":["DomainName","ObjectTypeName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ObjectTypeName":{"location":"uri","locationName":"ObjectTypeName"}}},"output":{"type":"structure","required":["Message"],"members":{"Message":{}}}},"DeleteWorkflow":{"http":{"method":"DELETE","requestUri":"/domains/{DomainName}/workflows/{WorkflowId}"},"input":{"type":"structure","required":["DomainName","WorkflowId"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"WorkflowId":{"location":"uri","locationName":"WorkflowId"}}},"output":{"type":"structure","members":{}}},"GetAutoMergingPreview":{"http":{"requestUri":"/domains/{DomainName}/identity-resolution-jobs/auto-merging-preview"},"input":{"type":"structure","required":["DomainName","Consolidation","ConflictResolution"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"Consolidation":{"shape":"Sh"},"ConflictResolution":{"shape":"Sk"}}},"output":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"NumberOfMatchesInSample":{"type":"long"},"NumberOfProfilesInSample":{"type":"long"},"NumberOfProfilesWillBeMerged":{"type":"long"}}}},"GetDomain":{"http":{"method":"GET","requestUri":"/domains/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainName","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"DefaultExpirationDays":{"type":"integer"},"DefaultEncryptionKey":{},"DeadLetterQueueUrl":{},"Stats":{"type":"structure","members":{"ProfileCount":{"type":"long"},"MeteringProfileCount":{"type":"long"},"ObjectCount":{"type":"long"},"TotalSize":{"type":"long"}}},"Matching":{"shape":"Su"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"GetIdentityResolutionJob":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/identity-resolution-jobs/{JobId}"},"input":{"type":"structure","required":["DomainName","JobId"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"JobId":{"location":"uri","locationName":"JobId"}}},"output":{"type":"structure","members":{"DomainName":{},"JobId":{},"Status":{},"Message":{},"JobStartTime":{"type":"timestamp"},"JobEndTime":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"JobExpirationTime":{"type":"timestamp"},"AutoMerging":{"shape":"Sg"},"ExportingLocation":{"shape":"S37"},"JobStats":{"shape":"S3a"}}}},"GetIntegration":{"http":{"requestUri":"/domains/{DomainName}/integrations"},"input":{"type":"structure","required":["DomainName","Uri"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"Uri":{}}},"output":{"type":"structure","required":["DomainName","Uri","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"Uri":{},"ObjectTypeName":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"},"ObjectTypeNames":{"shape":"S3d"},"WorkflowId":{}}}},"GetMatches":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/matches"},"input":{"type":"structure","required":["DomainName"],"members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"NextToken":{},"MatchGenerationDate":{"type":"timestamp"},"PotentialMatches":{"type":"integer"},"Matches":{"type":"list","member":{"type":"structure","members":{"MatchId":{},"ProfileIds":{"type":"list","member":{}},"ConfidenceScore":{"type":"double"}}}}}}},"GetProfileObjectType":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/object-types/{ObjectTypeName}"},"input":{"type":"structure","required":["DomainName","ObjectTypeName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ObjectTypeName":{"location":"uri","locationName":"ObjectTypeName"}}},"output":{"type":"structure","required":["ObjectTypeName","Description"],"members":{"ObjectTypeName":{},"Description":{},"TemplateId":{},"ExpirationDays":{"type":"integer"},"EncryptionKey":{},"AllowProfileCreation":{"type":"boolean"},"SourceLastUpdatedTimestampFormat":{},"Fields":{"shape":"S3q"},"Keys":{"shape":"S3t"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"GetProfileObjectTypeTemplate":{"http":{"method":"GET","requestUri":"/templates/{TemplateId}"},"input":{"type":"structure","required":["TemplateId"],"members":{"TemplateId":{"location":"uri","locationName":"TemplateId"}}},"output":{"type":"structure","members":{"TemplateId":{},"SourceName":{},"SourceObject":{},"AllowProfileCreation":{"type":"boolean"},"SourceLastUpdatedTimestampFormat":{},"Fields":{"shape":"S3q"},"Keys":{"shape":"S3t"}}}},"GetWorkflow":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/workflows/{WorkflowId}"},"input":{"type":"structure","required":["DomainName","WorkflowId"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"WorkflowId":{"location":"uri","locationName":"WorkflowId"}}},"output":{"type":"structure","members":{"WorkflowId":{},"WorkflowType":{},"Status":{},"ErrorDescription":{},"StartDate":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Attributes":{"type":"structure","members":{"AppflowIntegration":{"type":"structure","required":["SourceConnectorType","ConnectorProfileName"],"members":{"SourceConnectorType":{},"ConnectorProfileName":{},"RoleArn":{}}}}},"Metrics":{"type":"structure","members":{"AppflowIntegration":{"type":"structure","required":["RecordsProcessed","StepsCompleted","TotalSteps"],"members":{"RecordsProcessed":{"type":"long"},"StepsCompleted":{"type":"long"},"TotalSteps":{"type":"long"}}}}}}}},"GetWorkflowSteps":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/workflows/{WorkflowId}/steps"},"input":{"type":"structure","required":["DomainName","WorkflowId"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"WorkflowId":{"location":"uri","locationName":"WorkflowId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"WorkflowId":{},"WorkflowType":{},"Items":{"type":"list","member":{"type":"structure","members":{"AppflowIntegration":{"type":"structure","required":["FlowName","Status","ExecutionMessage","RecordsProcessed","BatchRecordsStartTime","BatchRecordsEndTime","CreatedAt","LastUpdatedAt"],"members":{"FlowName":{},"Status":{},"ExecutionMessage":{},"RecordsProcessed":{"type":"long"},"BatchRecordsStartTime":{},"BatchRecordsEndTime":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"}}}}}},"NextToken":{}}}},"ListAccountIntegrations":{"http":{"requestUri":"/integrations"},"input":{"type":"structure","required":["Uri"],"members":{"Uri":{},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"IncludeHidden":{"location":"querystring","locationName":"include-hidden","type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"S4f"},"NextToken":{}}}},"ListDomains":{"http":{"method":"GET","requestUri":"/domains"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","required":["DomainName","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"NextToken":{}}}},"ListIdentityResolutionJobs":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/identity-resolution-jobs"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"IdentityResolutionJobsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"JobId":{},"Status":{},"JobStartTime":{"type":"timestamp"},"JobEndTime":{"type":"timestamp"},"JobStats":{"shape":"S3a"},"ExportingLocation":{"shape":"S37"},"Message":{}}}},"NextToken":{}}}},"ListIntegrations":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/integrations"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"IncludeHidden":{"location":"querystring","locationName":"include-hidden","type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"S4f"},"NextToken":{}}}},"ListProfileObjectTypeTemplates":{"http":{"method":"GET","requestUri":"/templates"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"TemplateId":{},"SourceName":{},"SourceObject":{}}}},"NextToken":{}}}},"ListProfileObjectTypes":{"http":{"method":"GET","requestUri":"/domains/{DomainName}/object-types"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","required":["ObjectTypeName","Description"],"members":{"ObjectTypeName":{},"Description":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"NextToken":{}}}},"ListProfileObjects":{"http":{"requestUri":"/domains/{DomainName}/profiles/objects"},"input":{"type":"structure","required":["DomainName","ObjectTypeName","ProfileId"],"members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"DomainName":{"location":"uri","locationName":"DomainName"},"ObjectTypeName":{},"ProfileId":{},"ObjectFilter":{"type":"structure","required":["KeyName","Values"],"members":{"KeyName":{},"Values":{"shape":"S4"}}}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"ObjectTypeName":{},"ProfileObjectUniqueKey":{},"Object":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"}}}},"ListWorkflows":{"http":{"requestUri":"/domains/{DomainName}/workflows"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"WorkflowType":{},"Status":{},"QueryStartDate":{"type":"timestamp"},"QueryEndDate":{"type":"timestamp"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","required":["WorkflowType","WorkflowId","Status","StatusDescription","CreatedAt","LastUpdatedAt"],"members":{"WorkflowType":{},"WorkflowId":{},"Status":{},"StatusDescription":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"MergeProfiles":{"http":{"requestUri":"/domains/{DomainName}/profiles/objects/merge"},"input":{"type":"structure","required":["DomainName","MainProfileId","ProfileIdsToBeMerged"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MainProfileId":{},"ProfileIdsToBeMerged":{"type":"list","member":{}},"FieldSourceProfileIds":{"type":"structure","members":{"AccountNumber":{},"AdditionalInformation":{},"PartyType":{},"BusinessName":{},"FirstName":{},"MiddleName":{},"LastName":{},"BirthDate":{},"Gender":{},"PhoneNumber":{},"MobilePhoneNumber":{},"HomePhoneNumber":{},"BusinessPhoneNumber":{},"EmailAddress":{},"PersonalEmailAddress":{},"BusinessEmailAddress":{},"Address":{},"ShippingAddress":{},"MailingAddress":{},"BillingAddress":{},"Attributes":{"type":"map","key":{},"value":{}}}}}},"output":{"type":"structure","members":{"Message":{}}}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/domains/{DomainName}/integrations"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"Uri":{},"ObjectTypeName":{},"Tags":{"shape":"Sq"},"FlowDefinition":{"shape":"S10"},"ObjectTypeNames":{"shape":"S3d"}}},"output":{"type":"structure","required":["DomainName","Uri","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"Uri":{},"ObjectTypeName":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"},"ObjectTypeNames":{"shape":"S3d"},"WorkflowId":{}}}},"PutProfileObject":{"http":{"method":"PUT","requestUri":"/domains/{DomainName}/profiles/objects"},"input":{"type":"structure","required":["ObjectTypeName","Object","DomainName"],"members":{"ObjectTypeName":{},"Object":{},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"ProfileObjectUniqueKey":{}}}},"PutProfileObjectType":{"http":{"method":"PUT","requestUri":"/domains/{DomainName}/object-types/{ObjectTypeName}"},"input":{"type":"structure","required":["DomainName","ObjectTypeName","Description"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ObjectTypeName":{"location":"uri","locationName":"ObjectTypeName"},"Description":{},"TemplateId":{},"ExpirationDays":{"type":"integer"},"EncryptionKey":{},"AllowProfileCreation":{"type":"boolean"},"SourceLastUpdatedTimestampFormat":{},"Fields":{"shape":"S3q"},"Keys":{"shape":"S3t"},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["ObjectTypeName","Description"],"members":{"ObjectTypeName":{},"Description":{},"TemplateId":{},"ExpirationDays":{"type":"integer"},"EncryptionKey":{},"AllowProfileCreation":{"type":"boolean"},"SourceLastUpdatedTimestampFormat":{},"Fields":{"shape":"S3q"},"Keys":{"shape":"S3t"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"SearchProfiles":{"http":{"requestUri":"/domains/{DomainName}/profiles/search"},"input":{"type":"structure","required":["DomainName","KeyName","Values"],"members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"DomainName":{"location":"uri","locationName":"DomainName"},"KeyName":{},"Values":{"shape":"S4"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"ProfileId":{},"AccountNumber":{},"AdditionalInformation":{},"PartyType":{},"BusinessName":{},"FirstName":{},"MiddleName":{},"LastName":{},"BirthDate":{},"Gender":{},"PhoneNumber":{},"MobilePhoneNumber":{},"HomePhoneNumber":{},"BusinessPhoneNumber":{},"EmailAddress":{},"PersonalEmailAddress":{},"BusinessEmailAddress":{},"Address":{"shape":"S2g"},"ShippingAddress":{"shape":"S2g"},"MailingAddress":{"shape":"S2g"},"BillingAddress":{"shape":"S2g"},"Attributes":{"shape":"S2h"}}}},"NextToken":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDomain":{"http":{"method":"PUT","requestUri":"/domains/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"DefaultExpirationDays":{"type":"integer"},"DefaultEncryptionKey":{},"DeadLetterQueueUrl":{},"Matching":{"shape":"Sb"},"Tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["DomainName","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"DefaultExpirationDays":{"type":"integer"},"DefaultEncryptionKey":{},"DeadLetterQueueUrl":{},"Matching":{"shape":"Su"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"}}}},"UpdateProfile":{"http":{"method":"PUT","requestUri":"/domains/{DomainName}/profiles"},"input":{"type":"structure","required":["DomainName","ProfileId"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ProfileId":{},"AdditionalInformation":{},"AccountNumber":{},"PartyType":{},"BusinessName":{},"FirstName":{},"MiddleName":{},"LastName":{},"BirthDate":{},"Gender":{},"PhoneNumber":{},"MobilePhoneNumber":{},"HomePhoneNumber":{},"BusinessPhoneNumber":{},"EmailAddress":{},"PersonalEmailAddress":{},"BusinessEmailAddress":{},"Address":{"shape":"S61"},"ShippingAddress":{"shape":"S61"},"MailingAddress":{"shape":"S61"},"BillingAddress":{"shape":"S61"},"Attributes":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","required":["ProfileId"],"members":{"ProfileId":{}}}}},"shapes":{"S4":{"type":"list","member":{}},"Sb":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"JobSchedule":{"shape":"Sd"},"AutoMerging":{"shape":"Sg"},"ExportingConfig":{"shape":"Sm"}}},"Sd":{"type":"structure","required":["DayOfTheWeek","Time"],"members":{"DayOfTheWeek":{},"Time":{}}},"Sg":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Consolidation":{"shape":"Sh"},"ConflictResolution":{"shape":"Sk"}}},"Sh":{"type":"structure","required":["MatchingAttributesList"],"members":{"MatchingAttributesList":{"type":"list","member":{"type":"list","member":{}}}}},"Sk":{"type":"structure","required":["ConflictResolvingModel"],"members":{"ConflictResolvingModel":{},"SourceName":{}}},"Sm":{"type":"structure","members":{"S3Exporting":{"type":"structure","required":["S3BucketName"],"members":{"S3BucketName":{},"S3KeyName":{}}}}},"Sq":{"type":"map","key":{},"value":{}},"Su":{"type":"structure","members":{"Enabled":{"type":"boolean"},"JobSchedule":{"shape":"Sd"},"AutoMerging":{"shape":"Sg"},"ExportingConfig":{"shape":"Sm"}}},"S10":{"type":"structure","required":["FlowName","KmsArn","SourceFlowConfig","Tasks","TriggerConfig"],"members":{"Description":{},"FlowName":{},"KmsArn":{},"SourceFlowConfig":{"type":"structure","required":["ConnectorType","SourceConnectorProperties"],"members":{"ConnectorProfileName":{},"ConnectorType":{},"IncrementalPullConfig":{"type":"structure","members":{"DatetimeTypeFieldName":{}}},"SourceConnectorProperties":{"type":"structure","members":{"Marketo":{"type":"structure","required":["Object"],"members":{"Object":{}}},"S3":{"type":"structure","required":["BucketName"],"members":{"BucketName":{},"BucketPrefix":{}}},"Salesforce":{"type":"structure","required":["Object"],"members":{"Object":{},"EnableDynamicFieldUpdate":{"type":"boolean"},"IncludeDeletedRecords":{"type":"boolean"}}},"ServiceNow":{"type":"structure","required":["Object"],"members":{"Object":{}}},"Zendesk":{"type":"structure","required":["Object"],"members":{"Object":{}}}}}}},"Tasks":{"type":"list","member":{"type":"structure","required":["SourceFields","TaskType"],"members":{"ConnectorOperator":{"type":"structure","members":{"Marketo":{},"S3":{},"Salesforce":{},"ServiceNow":{},"Zendesk":{}}},"DestinationField":{},"SourceFields":{"type":"list","member":{}},"TaskProperties":{"type":"map","key":{},"value":{}},"TaskType":{}}}},"TriggerConfig":{"type":"structure","required":["TriggerType"],"members":{"TriggerType":{},"TriggerProperties":{"type":"structure","members":{"Scheduled":{"type":"structure","required":["ScheduleExpression"],"members":{"ScheduleExpression":{},"DataPullMode":{},"ScheduleStartTime":{"type":"timestamp"},"ScheduleEndTime":{"type":"timestamp"},"Timezone":{},"ScheduleOffset":{"type":"long"},"FirstExecutionFrom":{"type":"timestamp"}}}}}}}}},"S2g":{"type":"structure","members":{"Address1":{},"Address2":{},"Address3":{},"Address4":{},"City":{},"County":{},"State":{},"Province":{},"Country":{},"PostalCode":{}}},"S2h":{"type":"map","key":{},"value":{}},"S37":{"type":"structure","members":{"S3Exporting":{"type":"structure","members":{"S3BucketName":{},"S3KeyName":{}}}}},"S3a":{"type":"structure","members":{"NumberOfProfilesReviewed":{"type":"long"},"NumberOfMatchesFound":{"type":"long"},"NumberOfMergesDone":{"type":"long"}}},"S3d":{"type":"map","key":{},"value":{}},"S3q":{"type":"map","key":{},"value":{"type":"structure","members":{"Source":{},"Target":{},"ContentType":{}}}},"S3t":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"StandardIdentifiers":{"type":"list","member":{}},"FieldNames":{"type":"list","member":{}}}}}},"S4f":{"type":"list","member":{"type":"structure","required":["DomainName","Uri","CreatedAt","LastUpdatedAt"],"members":{"DomainName":{},"Uri":{},"ObjectTypeName":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Tags":{"shape":"Sq"},"ObjectTypeNames":{"shape":"S3d"},"WorkflowId":{}}}},"S61":{"type":"structure","members":{"Address1":{},"Address2":{},"Address3":{},"Address4":{},"City":{},"County":{},"State":{},"Province":{},"Country":{},"PostalCode":{}}}}}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['auditmanager'] = {};
	AWS.AuditManager = Service.defineService('auditmanager', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['auditmanager'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(954);
	    model.paginators = __webpack_require__(955).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AuditManager;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"auditmanager","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Audit Manager","serviceId":"AuditManager","signatureVersion":"v4","signingName":"auditmanager","uid":"auditmanager-2017-07-25"},"operations":{"AssociateAssessmentReportEvidenceFolder":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/associateToAssessmentReport"},"input":{"type":"structure","required":["assessmentId","evidenceFolderId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"evidenceFolderId":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateAssessmentReportEvidence":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/batchAssociateToAssessmentReport"},"input":{"type":"structure","required":["assessmentId","evidenceFolderId","evidenceIds"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"evidenceFolderId":{},"evidenceIds":{"shape":"S5"}}},"output":{"type":"structure","members":{"evidenceIds":{"shape":"S5"},"errors":{"shape":"S7"}}}},"BatchCreateDelegationByAssessment":{"http":{"requestUri":"/assessments/{assessmentId}/delegations"},"input":{"type":"structure","required":["createDelegationRequests","assessmentId"],"members":{"createDelegationRequests":{"type":"list","member":{"shape":"Sd"}},"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{"delegations":{"shape":"Sj"},"errors":{"type":"list","member":{"type":"structure","members":{"createDelegationRequest":{"shape":"Sd"},"errorCode":{},"errorMessage":{}}}}}}},"BatchDeleteDelegationByAssessment":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/delegations"},"input":{"type":"structure","required":["delegationIds","assessmentId"],"members":{"delegationIds":{"type":"list","member":{}},"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"type":"structure","members":{"delegationId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchDisassociateAssessmentReportEvidence":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/batchDisassociateFromAssessmentReport"},"input":{"type":"structure","required":["assessmentId","evidenceFolderId","evidenceIds"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"evidenceFolderId":{},"evidenceIds":{"shape":"S5"}}},"output":{"type":"structure","members":{"evidenceIds":{"shape":"S5"},"errors":{"shape":"S7"}}}},"BatchImportEvidenceToAssessmentControl":{"http":{"requestUri":"/assessments/{assessmentId}/controlSets/{controlSetId}/controls/{controlId}/evidence"},"input":{"type":"structure","required":["assessmentId","controlSetId","controlId","manualEvidence"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"controlId":{"location":"uri","locationName":"controlId"},"manualEvidence":{"type":"list","member":{"shape":"S10"}}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"type":"structure","members":{"manualEvidence":{"shape":"S10"},"errorCode":{},"errorMessage":{}}}}}}},"CreateAssessment":{"http":{"requestUri":"/assessments"},"input":{"type":"structure","required":["name","assessmentReportsDestination","scope","roles","frameworkId"],"members":{"name":{},"description":{},"assessmentReportsDestination":{"shape":"S17"},"scope":{"shape":"S19"},"roles":{"shape":"S1i"},"frameworkId":{},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{"assessment":{"shape":"S1o"}}}},"CreateAssessmentFramework":{"http":{"requestUri":"/assessmentFrameworks"},"input":{"type":"structure","required":["name","controlSets"],"members":{"name":{},"description":{},"complianceType":{},"controlSets":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"controls":{"shape":"S2j"}}}},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{"framework":{"shape":"S2m"}}}},"CreateAssessmentReport":{"http":{"requestUri":"/assessments/{assessmentId}/reports"},"input":{"type":"structure","required":["name","assessmentId"],"members":{"name":{},"description":{},"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{"assessmentReport":{"type":"structure","members":{"id":{},"name":{},"description":{},"awsAccountId":{},"assessmentId":{},"assessmentName":{},"author":{},"status":{},"creationTime":{"type":"timestamp"}}}}}},"CreateControl":{"http":{"requestUri":"/controls"},"input":{"type":"structure","required":["name","controlMappingSources"],"members":{"name":{},"description":{},"testingInformation":{},"actionPlanTitle":{},"actionPlanInstructions":{},"controlMappingSources":{"type":"list","member":{"type":"structure","members":{"sourceName":{},"sourceDescription":{},"sourceSetUpOption":{},"sourceType":{},"sourceKeyword":{"shape":"S33"},"sourceFrequency":{},"troubleshootingText":{}}}},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{"control":{"shape":"S2s"}}}},"DeleteAssessment":{"http":{"method":"DELETE","requestUri":"/assessments/{assessmentId}"},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{}}},"DeleteAssessmentFramework":{"http":{"method":"DELETE","requestUri":"/assessmentFrameworks/{frameworkId}"},"input":{"type":"structure","required":["frameworkId"],"members":{"frameworkId":{"location":"uri","locationName":"frameworkId"}}},"output":{"type":"structure","members":{}}},"DeleteAssessmentFrameworkShare":{"http":{"method":"DELETE","requestUri":"/assessmentFrameworkShareRequests/{requestId}"},"input":{"type":"structure","required":["requestId","requestType"],"members":{"requestId":{"location":"uri","locationName":"requestId"},"requestType":{"location":"querystring","locationName":"requestType"}}},"output":{"type":"structure","members":{}}},"DeleteAssessmentReport":{"http":{"method":"DELETE","requestUri":"/assessments/{assessmentId}/reports/{assessmentReportId}"},"input":{"type":"structure","required":["assessmentId","assessmentReportId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"assessmentReportId":{"location":"uri","locationName":"assessmentReportId"}}},"output":{"type":"structure","members":{}}},"DeleteControl":{"http":{"method":"DELETE","requestUri":"/controls/{controlId}"},"input":{"type":"structure","required":["controlId"],"members":{"controlId":{"location":"uri","locationName":"controlId"}}},"output":{"type":"structure","members":{}}},"DeregisterAccount":{"http":{"requestUri":"/account/deregisterAccount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"status":{}}}},"DeregisterOrganizationAdminAccount":{"http":{"requestUri":"/account/deregisterOrganizationAdminAccount"},"input":{"type":"structure","members":{"adminAccountId":{}}},"output":{"type":"structure","members":{}}},"DisassociateAssessmentReportEvidenceFolder":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/disassociateFromAssessmentReport"},"input":{"type":"structure","required":["assessmentId","evidenceFolderId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"evidenceFolderId":{}}},"output":{"type":"structure","members":{}}},"GetAccountStatus":{"http":{"method":"GET","requestUri":"/account/status"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"status":{}}}},"GetAssessment":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}"},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{"assessment":{"shape":"S1o"},"userRole":{"shape":"S1j"}}}},"GetAssessmentFramework":{"http":{"method":"GET","requestUri":"/assessmentFrameworks/{frameworkId}"},"input":{"type":"structure","required":["frameworkId"],"members":{"frameworkId":{"location":"uri","locationName":"frameworkId"}}},"output":{"type":"structure","members":{"framework":{"shape":"S2m"}}}},"GetAssessmentReportUrl":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/reports/{assessmentReportId}/url"},"input":{"type":"structure","required":["assessmentReportId","assessmentId"],"members":{"assessmentReportId":{"location":"uri","locationName":"assessmentReportId"},"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{"preSignedUrl":{"type":"structure","members":{"hyperlinkName":{},"link":{}}}}}},"GetChangeLogs":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/changelogs"},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"querystring","locationName":"controlSetId"},"controlId":{"location":"querystring","locationName":"controlId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"changeLogs":{"type":"list","member":{"type":"structure","members":{"objectType":{},"objectName":{},"action":{},"createdAt":{"type":"timestamp"},"createdBy":{}}}},"nextToken":{}}}},"GetControl":{"http":{"method":"GET","requestUri":"/controls/{controlId}"},"input":{"type":"structure","required":["controlId"],"members":{"controlId":{"location":"uri","locationName":"controlId"}}},"output":{"type":"structure","members":{"control":{"shape":"S2s"}}}},"GetDelegations":{"http":{"method":"GET","requestUri":"/delegations"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"delegations":{"type":"list","member":{"type":"structure","members":{"id":{},"assessmentName":{},"assessmentId":{},"status":{},"roleArn":{},"creationTime":{"type":"timestamp"},"controlSetName":{}}}},"nextToken":{}}}},"GetEvidence":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/controlSets/{controlSetId}/evidenceFolders/{evidenceFolderId}/evidence/{evidenceId}"},"input":{"type":"structure","required":["assessmentId","controlSetId","evidenceFolderId","evidenceId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"evidenceFolderId":{"location":"uri","locationName":"evidenceFolderId"},"evidenceId":{"location":"uri","locationName":"evidenceId"}}},"output":{"type":"structure","members":{"evidence":{"shape":"S4s"}}}},"GetEvidenceByEvidenceFolder":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/controlSets/{controlSetId}/evidenceFolders/{evidenceFolderId}/evidence"},"input":{"type":"structure","required":["assessmentId","controlSetId","evidenceFolderId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"evidenceFolderId":{"location":"uri","locationName":"evidenceFolderId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"evidence":{"type":"list","member":{"shape":"S4s"}},"nextToken":{}}}},"GetEvidenceFolder":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/controlSets/{controlSetId}/evidenceFolders/{evidenceFolderId}"},"input":{"type":"structure","required":["assessmentId","controlSetId","evidenceFolderId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"evidenceFolderId":{"location":"uri","locationName":"evidenceFolderId"}}},"output":{"type":"structure","members":{"evidenceFolder":{"shape":"S56"}}}},"GetEvidenceFoldersByAssessment":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/evidenceFolders"},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"evidenceFolders":{"shape":"S5a"},"nextToken":{}}}},"GetEvidenceFoldersByAssessmentControl":{"http":{"method":"GET","requestUri":"/assessments/{assessmentId}/evidenceFolders-by-assessment-control/{controlSetId}/{controlId}"},"input":{"type":"structure","required":["assessmentId","controlSetId","controlId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"controlId":{"location":"uri","locationName":"controlId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"evidenceFolders":{"shape":"S5a"},"nextToken":{}}}},"GetInsights":{"http":{"method":"GET","requestUri":"/insights"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"insights":{"type":"structure","members":{"activeAssessmentsCount":{"type":"integer"},"noncompliantEvidenceCount":{"type":"integer"},"compliantEvidenceCount":{"type":"integer"},"inconclusiveEvidenceCount":{"type":"integer"},"assessmentControlsCountByNoncompliantEvidence":{"type":"integer"},"totalAssessmentControlsCount":{"type":"integer"},"lastUpdated":{"type":"timestamp"}}}}}},"GetInsightsByAssessment":{"http":{"method":"GET","requestUri":"/insights/assessments/{assessmentId}"},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"}}},"output":{"type":"structure","members":{"insights":{"type":"structure","members":{"noncompliantEvidenceCount":{"type":"integer"},"compliantEvidenceCount":{"type":"integer"},"inconclusiveEvidenceCount":{"type":"integer"},"assessmentControlsCountByNoncompliantEvidence":{"type":"integer"},"totalAssessmentControlsCount":{"type":"integer"},"lastUpdated":{"type":"timestamp"}}}}}},"GetOrganizationAdminAccount":{"http":{"method":"GET","requestUri":"/account/organizationAdminAccount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"adminAccountId":{},"organizationId":{}}}},"GetServicesInScope":{"http":{"method":"GET","requestUri":"/services"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"serviceMetadata":{"type":"list","member":{"type":"structure","members":{"name":{},"displayName":{},"description":{},"category":{}}}}}}},"GetSettings":{"http":{"method":"GET","requestUri":"/settings/{attribute}"},"input":{"type":"structure","required":["attribute"],"members":{"attribute":{"location":"uri","locationName":"attribute"}}},"output":{"type":"structure","members":{"settings":{"shape":"S5u"}}}},"ListAssessmentControlInsightsByControlDomain":{"http":{"method":"GET","requestUri":"/insights/controls-by-assessment"},"input":{"type":"structure","required":["controlDomainId","assessmentId"],"members":{"controlDomainId":{"location":"querystring","locationName":"controlDomainId"},"assessmentId":{"location":"querystring","locationName":"assessmentId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"controlInsightsByAssessment":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"evidenceInsights":{"shape":"S62"},"controlSetName":{},"lastUpdated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAssessmentFrameworkShareRequests":{"http":{"method":"GET","requestUri":"/assessmentFrameworkShareRequests"},"input":{"type":"structure","required":["requestType"],"members":{"requestType":{"location":"querystring","locationName":"requestType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"assessmentFrameworkShareRequests":{"type":"list","member":{"shape":"S66"}},"nextToken":{}}}},"ListAssessmentFrameworks":{"http":{"method":"GET","requestUri":"/assessmentFrameworks"},"input":{"type":"structure","required":["frameworkType"],"members":{"frameworkType":{"location":"querystring","locationName":"frameworkType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"frameworkMetadataList":{"type":"list","member":{"type":"structure","members":{"arn":{},"id":{},"type":{},"name":{},"description":{},"logo":{},"complianceType":{},"controlsCount":{"type":"integer"},"controlSetsCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAssessmentReports":{"http":{"method":"GET","requestUri":"/assessmentReports"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"assessmentReports":{"type":"list","member":{"type":"structure","members":{"id":{},"name":{},"description":{},"assessmentId":{},"assessmentName":{},"author":{},"status":{},"creationTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAssessments":{"http":{"method":"GET","requestUri":"/assessments"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"assessmentMetadata":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"complianceType":{},"status":{},"roles":{"shape":"S1i"},"delegations":{"shape":"Sj"},"creationTime":{"type":"timestamp"},"lastUpdated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListControlDomainInsights":{"http":{"method":"GET","requestUri":"/insights/control-domains"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"controlDomainInsights":{"shape":"S6q"},"nextToken":{}}}},"ListControlDomainInsightsByAssessment":{"http":{"method":"GET","requestUri":"/insights/control-domains-by-assessment"},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{"location":"querystring","locationName":"assessmentId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"controlDomainInsights":{"shape":"S6q"},"nextToken":{}}}},"ListControlInsightsByControlDomain":{"http":{"method":"GET","requestUri":"/insights/controls"},"input":{"type":"structure","required":["controlDomainId"],"members":{"controlDomainId":{"location":"querystring","locationName":"controlDomainId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"controlInsightsMetadata":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"evidenceInsights":{"shape":"S62"},"lastUpdated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListControls":{"http":{"method":"GET","requestUri":"/controls"},"input":{"type":"structure","required":["controlType"],"members":{"controlType":{"location":"querystring","locationName":"controlType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"controlMetadataList":{"type":"list","member":{"type":"structure","members":{"arn":{},"id":{},"name":{},"controlSources":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListKeywordsForDataSource":{"http":{"method":"GET","requestUri":"/dataSourceKeywords"},"input":{"type":"structure","required":["source"],"members":{"source":{"location":"querystring","locationName":"source"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"keywords":{"type":"list","member":{}},"nextToken":{}}}},"ListNotifications":{"http":{"method":"GET","requestUri":"/notifications"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"notifications":{"type":"list","member":{"type":"structure","members":{"id":{},"assessmentId":{},"assessmentName":{},"controlSetId":{},"controlSetName":{},"description":{},"eventTime":{"type":"timestamp"},"source":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1k"}}}},"RegisterAccount":{"http":{"requestUri":"/account/registerAccount"},"input":{"type":"structure","members":{"kmsKey":{},"delegatedAdminAccount":{}}},"output":{"type":"structure","members":{"status":{}}}},"RegisterOrganizationAdminAccount":{"http":{"requestUri":"/account/registerOrganizationAdminAccount"},"input":{"type":"structure","required":["adminAccountId"],"members":{"adminAccountId":{}}},"output":{"type":"structure","members":{"adminAccountId":{},"organizationId":{}}}},"StartAssessmentFrameworkShare":{"http":{"requestUri":"/assessmentFrameworks/{frameworkId}/shareRequests"},"input":{"type":"structure","required":["frameworkId","destinationAccount","destinationRegion"],"members":{"frameworkId":{"location":"uri","locationName":"frameworkId"},"destinationAccount":{},"destinationRegion":{},"comment":{}}},"output":{"type":"structure","members":{"assessmentFrameworkShareRequest":{"shape":"S66"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1k"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAssessment":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}"},"input":{"type":"structure","required":["assessmentId","scope"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"assessmentName":{},"assessmentDescription":{},"scope":{"shape":"S19"},"assessmentReportsDestination":{"shape":"S17"},"roles":{"shape":"S1i"}}},"output":{"type":"structure","members":{"assessment":{"shape":"S1o"}}}},"UpdateAssessmentControl":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/controlSets/{controlSetId}/controls/{controlId}"},"input":{"type":"structure","required":["assessmentId","controlSetId","controlId"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"controlId":{"location":"uri","locationName":"controlId"},"controlStatus":{},"commentBody":{}}},"output":{"type":"structure","members":{"control":{"shape":"S22"}}}},"UpdateAssessmentControlSetStatus":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/controlSets/{controlSetId}/status"},"input":{"type":"structure","required":["assessmentId","controlSetId","status","comment"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"controlSetId":{"location":"uri","locationName":"controlSetId"},"status":{},"comment":{}}},"output":{"type":"structure","members":{"controlSet":{"shape":"S1y"}}}},"UpdateAssessmentFramework":{"http":{"method":"PUT","requestUri":"/assessmentFrameworks/{frameworkId}"},"input":{"type":"structure","required":["frameworkId","name","controlSets"],"members":{"frameworkId":{"location":"uri","locationName":"frameworkId"},"name":{},"description":{},"complianceType":{},"controlSets":{"type":"list","member":{"type":"structure","required":["name","controls"],"members":{"id":{},"name":{},"controls":{"shape":"S2j"}}}}}},"output":{"type":"structure","members":{"framework":{"shape":"S2m"}}}},"UpdateAssessmentFrameworkShare":{"http":{"method":"PUT","requestUri":"/assessmentFrameworkShareRequests/{requestId}"},"input":{"type":"structure","required":["requestId","requestType","action"],"members":{"requestId":{"location":"uri","locationName":"requestId"},"requestType":{},"action":{}}},"output":{"type":"structure","members":{"assessmentFrameworkShareRequest":{"shape":"S66"}}}},"UpdateAssessmentStatus":{"http":{"method":"PUT","requestUri":"/assessments/{assessmentId}/status"},"input":{"type":"structure","required":["assessmentId","status"],"members":{"assessmentId":{"location":"uri","locationName":"assessmentId"},"status":{}}},"output":{"type":"structure","members":{"assessment":{"shape":"S1o"}}}},"UpdateControl":{"http":{"method":"PUT","requestUri":"/controls/{controlId}"},"input":{"type":"structure","required":["controlId","name","controlMappingSources"],"members":{"controlId":{"location":"uri","locationName":"controlId"},"name":{},"description":{},"testingInformation":{},"actionPlanTitle":{},"actionPlanInstructions":{},"controlMappingSources":{"shape":"S2x"}}},"output":{"type":"structure","members":{"control":{"shape":"S2s"}}}},"UpdateSettings":{"http":{"method":"PUT","requestUri":"/settings"},"input":{"type":"structure","members":{"snsTopic":{},"defaultAssessmentReportsDestination":{"shape":"S17"},"defaultProcessOwners":{"shape":"S1i"},"kmsKey":{}}},"output":{"type":"structure","members":{"settings":{"shape":"S5u"}}}},"ValidateAssessmentReportIntegrity":{"http":{"requestUri":"/assessmentReports/integrity"},"input":{"type":"structure","required":["s3RelativePath"],"members":{"s3RelativePath":{}}},"output":{"type":"structure","members":{"signatureValid":{"type":"boolean"},"signatureAlgorithm":{},"signatureDateTime":{},"signatureKeyId":{},"validationErrors":{"type":"list","member":{}}}}}},"shapes":{"S5":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","members":{"evidenceId":{},"errorCode":{},"errorMessage":{}}}},"Sd":{"type":"structure","members":{"comment":{},"controlSetId":{},"roleArn":{},"roleType":{}}},"Sj":{"type":"list","member":{"type":"structure","members":{"id":{},"assessmentName":{},"assessmentId":{},"status":{},"roleArn":{},"roleType":{},"creationTime":{"type":"timestamp"},"lastUpdated":{"type":"timestamp"},"controlSetId":{},"comment":{},"createdBy":{}}}},"S10":{"type":"structure","members":{"s3ResourcePath":{}}},"S17":{"type":"structure","members":{"destinationType":{},"destination":{}}},"S19":{"type":"structure","members":{"awsAccounts":{"type":"list","member":{"shape":"S1b"}},"awsServices":{"type":"list","member":{"type":"structure","members":{"serviceName":{}}}}}},"S1b":{"type":"structure","members":{"id":{},"emailAddress":{},"name":{}}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","members":{"roleType":{},"roleArn":{}}},"S1k":{"type":"map","key":{},"value":{}},"S1o":{"type":"structure","members":{"arn":{},"awsAccount":{"shape":"S1b"},"metadata":{"type":"structure","members":{"name":{},"id":{},"description":{},"complianceType":{},"status":{},"assessmentReportsDestination":{"shape":"S17"},"scope":{"shape":"S19"},"roles":{"shape":"S1i"},"delegations":{"shape":"Sj"},"creationTime":{"type":"timestamp"},"lastUpdated":{"type":"timestamp"}}},"framework":{"type":"structure","members":{"id":{},"arn":{},"metadata":{"type":"structure","members":{"name":{},"description":{},"logo":{},"complianceType":{}}},"controlSets":{"type":"list","member":{"shape":"S1y"}}}},"tags":{"shape":"S1k"}}},"S1y":{"type":"structure","members":{"id":{},"description":{},"status":{},"roles":{"shape":"S1i"},"controls":{"type":"list","member":{"shape":"S22"}},"delegations":{"shape":"Sj"},"systemEvidenceCount":{"type":"integer"},"manualEvidenceCount":{"type":"integer"}}},"S22":{"type":"structure","members":{"id":{},"name":{},"description":{},"status":{},"response":{},"comments":{"type":"list","member":{"type":"structure","members":{"authorName":{},"commentBody":{},"postedDate":{"type":"timestamp"}}}},"evidenceSources":{"type":"list","member":{}},"evidenceCount":{"type":"integer"},"assessmentReportEvidenceCount":{"type":"integer"}}},"S2j":{"type":"list","member":{"type":"structure","required":["id"],"members":{"id":{}}}},"S2m":{"type":"structure","members":{"arn":{},"id":{},"name":{},"type":{},"complianceType":{},"description":{},"logo":{},"controlSources":{},"controlSets":{"type":"list","member":{"type":"structure","members":{"id":{},"name":{},"controls":{"type":"list","member":{"shape":"S2s"}}}}},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"createdBy":{},"lastUpdatedBy":{},"tags":{"shape":"S1k"}}},"S2s":{"type":"structure","members":{"arn":{},"id":{},"type":{},"name":{},"description":{},"testingInformation":{},"actionPlanTitle":{},"actionPlanInstructions":{},"controlSources":{},"controlMappingSources":{"shape":"S2x"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"createdBy":{},"lastUpdatedBy":{},"tags":{"shape":"S1k"}}},"S2x":{"type":"list","member":{"type":"structure","members":{"sourceId":{},"sourceName":{},"sourceDescription":{},"sourceSetUpOption":{},"sourceType":{},"sourceKeyword":{"shape":"S33"},"sourceFrequency":{},"troubleshootingText":{}}}},"S33":{"type":"structure","members":{"keywordInputType":{},"keywordValue":{}}},"S4s":{"type":"structure","members":{"dataSource":{},"evidenceAwsAccountId":{},"time":{"type":"timestamp"},"eventSource":{},"eventName":{},"evidenceByType":{},"resourcesIncluded":{"type":"list","member":{"type":"structure","members":{"arn":{},"value":{}}}},"attributes":{"type":"map","key":{},"value":{}},"iamId":{},"complianceCheck":{},"awsOrganization":{},"awsAccountId":{},"evidenceFolderId":{},"id":{},"assessmentReportSelection":{}}},"S56":{"type":"structure","members":{"name":{},"date":{"type":"timestamp"},"assessmentId":{},"controlSetId":{},"controlId":{},"id":{},"dataSource":{},"author":{},"totalEvidence":{"type":"integer"},"assessmentReportSelectionCount":{"type":"integer"},"controlName":{},"evidenceResourcesIncludedCount":{"type":"integer"},"evidenceByTypeConfigurationDataCount":{"type":"integer"},"evidenceByTypeManualCount":{"type":"integer"},"evidenceByTypeComplianceCheckCount":{"type":"integer"},"evidenceByTypeComplianceCheckIssuesCount":{"type":"integer"},"evidenceByTypeUserActivityCount":{"type":"integer"},"evidenceAwsServiceSourceCount":{"type":"integer"}}},"S5a":{"type":"list","member":{"shape":"S56"}},"S5u":{"type":"structure","members":{"isAwsOrgEnabled":{"type":"boolean"},"snsTopic":{},"defaultAssessmentReportsDestination":{"shape":"S17"},"defaultProcessOwners":{"shape":"S1i"},"kmsKey":{}}},"S62":{"type":"structure","members":{"noncompliantEvidenceCount":{"type":"integer"},"compliantEvidenceCount":{"type":"integer"},"inconclusiveEvidenceCount":{"type":"integer"}}},"S66":{"type":"structure","members":{"id":{},"frameworkId":{},"frameworkName":{},"frameworkDescription":{},"status":{},"sourceAccount":{},"destinationAccount":{},"destinationRegion":{},"expirationTime":{"type":"timestamp"},"creationTime":{"type":"timestamp"},"lastUpdated":{"type":"timestamp"},"comment":{},"standardControlsCount":{"type":"integer"},"customControlsCount":{"type":"integer"},"complianceType":{}}},"S6q":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"controlsCountByNoncompliantEvidence":{"type":"integer"},"totalControlsCount":{"type":"integer"},"evidenceInsights":{"shape":"S62"},"lastUpdated":{"type":"timestamp"}}}}}}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetChangeLogs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetDelegations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetEvidenceByEvidenceFolder":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetEvidenceFoldersByAssessment":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetEvidenceFoldersByAssessmentControl":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentControlInsightsByControlDomain":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentFrameworkShareRequests":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentFrameworks":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentReports":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListControlDomainInsights":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListControlDomainInsightsByAssessment":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListControlInsightsByControlDomain":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListControls":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListKeywordsForDataSource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListNotifications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['emrcontainers'] = {};
	AWS.EMRcontainers = Service.defineService('emrcontainers', ['2020-10-01']);
	Object.defineProperty(apiLoader.services['emrcontainers'], '2020-10-01', {
	  get: function get() {
	    var model = __webpack_require__(957);
	    model.paginators = __webpack_require__(958).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.EMRcontainers;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-10-01","endpointPrefix":"emr-containers","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon EMR Containers","serviceId":"EMR containers","signatureVersion":"v4","signingName":"emr-containers","uid":"emr-containers-2020-10-01"},"operations":{"CancelJobRun":{"http":{"method":"DELETE","requestUri":"/virtualclusters/{virtualClusterId}/jobruns/{jobRunId}"},"input":{"type":"structure","required":["id","virtualClusterId"],"members":{"id":{"location":"uri","locationName":"jobRunId"},"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"}}},"output":{"type":"structure","members":{"id":{},"virtualClusterId":{}}}},"CreateManagedEndpoint":{"http":{"requestUri":"/virtualclusters/{virtualClusterId}/endpoints"},"input":{"type":"structure","required":["name","virtualClusterId","type","releaseLabel","executionRoleArn","clientToken"],"members":{"name":{},"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"},"type":{},"releaseLabel":{},"executionRoleArn":{},"certificateArn":{"deprecated":true,"deprecatedMessage":"Customer provided certificate-arn is deprecated and would be removed in future."},"configurationOverrides":{"shape":"Sa"},"clientToken":{"idempotencyToken":true},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"id":{},"name":{},"arn":{},"virtualClusterId":{}}}},"CreateVirtualCluster":{"http":{"requestUri":"/virtualclusters"},"input":{"type":"structure","required":["name","containerProvider","clientToken"],"members":{"name":{},"containerProvider":{"shape":"St"},"clientToken":{"idempotencyToken":true},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"id":{},"name":{},"arn":{}}}},"DeleteManagedEndpoint":{"http":{"method":"DELETE","requestUri":"/virtualclusters/{virtualClusterId}/endpoints/{endpointId}"},"input":{"type":"structure","required":["id","virtualClusterId"],"members":{"id":{"location":"uri","locationName":"endpointId"},"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"}}},"output":{"type":"structure","members":{"id":{},"virtualClusterId":{}}}},"DeleteVirtualCluster":{"http":{"method":"DELETE","requestUri":"/virtualclusters/{virtualClusterId}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"virtualClusterId"}}},"output":{"type":"structure","members":{"id":{}}}},"DescribeJobRun":{"http":{"method":"GET","requestUri":"/virtualclusters/{virtualClusterId}/jobruns/{jobRunId}"},"input":{"type":"structure","required":["id","virtualClusterId"],"members":{"id":{"location":"uri","locationName":"jobRunId"},"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"}}},"output":{"type":"structure","members":{"jobRun":{"shape":"S17"}}}},"DescribeManagedEndpoint":{"http":{"method":"GET","requestUri":"/virtualclusters/{virtualClusterId}/endpoints/{endpointId}"},"input":{"type":"structure","required":["id","virtualClusterId"],"members":{"id":{"location":"uri","locationName":"endpointId"},"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"}}},"output":{"type":"structure","members":{"endpoint":{"shape":"S1l"}}}},"DescribeVirtualCluster":{"http":{"method":"GET","requestUri":"/virtualclusters/{virtualClusterId}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"virtualClusterId"}}},"output":{"type":"structure","members":{"virtualCluster":{"shape":"S1s"}}}},"ListJobRuns":{"http":{"method":"GET","requestUri":"/virtualclusters/{virtualClusterId}/jobruns"},"input":{"type":"structure","required":["virtualClusterId"],"members":{"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"},"createdBefore":{"shape":"S1g","location":"querystring","locationName":"createdBefore"},"createdAfter":{"shape":"S1g","location":"querystring","locationName":"createdAfter"},"name":{"location":"querystring","locationName":"name"},"states":{"location":"querystring","locationName":"states","type":"list","member":{}},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"jobRuns":{"type":"list","member":{"shape":"S17"}},"nextToken":{}}}},"ListManagedEndpoints":{"http":{"method":"GET","requestUri":"/virtualclusters/{virtualClusterId}/endpoints"},"input":{"type":"structure","required":["virtualClusterId"],"members":{"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"},"createdBefore":{"shape":"S1g","location":"querystring","locationName":"createdBefore"},"createdAfter":{"shape":"S1g","location":"querystring","locationName":"createdAfter"},"types":{"location":"querystring","locationName":"types","type":"list","member":{}},"states":{"location":"querystring","locationName":"states","type":"list","member":{}},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"endpoints":{"type":"list","member":{"shape":"S1l"}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sn"}}}},"ListVirtualClusters":{"http":{"method":"GET","requestUri":"/virtualclusters"},"input":{"type":"structure","members":{"containerProviderId":{"location":"querystring","locationName":"containerProviderId"},"containerProviderType":{"location":"querystring","locationName":"containerProviderType"},"createdAfter":{"shape":"S1g","location":"querystring","locationName":"createdAfter"},"createdBefore":{"shape":"S1g","location":"querystring","locationName":"createdBefore"},"states":{"location":"querystring","locationName":"states","type":"list","member":{}},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"virtualClusters":{"type":"list","member":{"shape":"S1s"}},"nextToken":{}}}},"StartJobRun":{"http":{"requestUri":"/virtualclusters/{virtualClusterId}/jobruns"},"input":{"type":"structure","required":["virtualClusterId","clientToken","executionRoleArn","releaseLabel","jobDriver"],"members":{"name":{},"virtualClusterId":{"location":"uri","locationName":"virtualClusterId"},"clientToken":{"idempotencyToken":true},"executionRoleArn":{},"releaseLabel":{},"jobDriver":{"shape":"S1a"},"configurationOverrides":{"shape":"Sa"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{"id":{},"name":{},"arn":{},"virtualClusterId":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","members":{"applicationConfiguration":{"shape":"Sb"},"monitoringConfiguration":{"type":"structure","members":{"persistentAppUI":{},"cloudWatchMonitoringConfiguration":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{}}},"s3MonitoringConfiguration":{"type":"structure","required":["logUri"],"members":{"logUri":{}}}}}}},"Sb":{"type":"list","member":{"type":"structure","required":["classification"],"members":{"classification":{},"properties":{"type":"map","key":{},"value":{},"sensitive":true},"configurations":{"shape":"Sb"}}}},"Sn":{"type":"map","key":{},"value":{}},"St":{"type":"structure","required":["type","id"],"members":{"type":{},"id":{},"info":{"type":"structure","members":{"eksInfo":{"type":"structure","members":{"namespace":{}}}},"union":true}}},"S17":{"type":"structure","members":{"id":{},"name":{},"virtualClusterId":{},"arn":{},"state":{},"clientToken":{},"executionRoleArn":{},"releaseLabel":{},"configurationOverrides":{"shape":"Sa"},"jobDriver":{"shape":"S1a"},"createdAt":{"shape":"S1g"},"createdBy":{},"finishedAt":{"shape":"S1g"},"stateDetails":{},"failureReason":{},"tags":{"shape":"Sn"}}},"S1a":{"type":"structure","members":{"sparkSubmitJobDriver":{"type":"structure","required":["entryPoint"],"members":{"entryPoint":{"type":"string","sensitive":true},"entryPointArguments":{"type":"list","member":{"type":"string","sensitive":true}},"sparkSubmitParameters":{"type":"string","sensitive":true}}}}},"S1g":{"type":"timestamp","timestampFormat":"iso8601"},"S1l":{"type":"structure","members":{"id":{},"name":{},"arn":{},"virtualClusterId":{},"type":{},"state":{},"releaseLabel":{},"executionRoleArn":{},"certificateArn":{"deprecated":true,"deprecatedMessage":"Customer provided certificate-arn is deprecated and would be removed in future."},"certificateAuthority":{"type":"structure","members":{"certificateArn":{},"certificateData":{}}},"configurationOverrides":{"shape":"Sa"},"serverUrl":{},"createdAt":{"shape":"S1g"},"securityGroup":{},"subnetIds":{"type":"list","member":{}},"stateDetails":{},"failureReason":{},"tags":{"shape":"Sn"}}},"S1s":{"type":"structure","members":{"id":{},"name":{},"arn":{},"state":{},"containerProvider":{"shape":"St"},"createdAt":{"shape":"S1g"},"tags":{"shape":"Sn"}}}}}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListJobRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobRuns"},"ListManagedEndpoints":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"endpoints"},"ListVirtualClusters":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"virtualClusters"}}}

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['healthlake'] = {};
	AWS.HealthLake = Service.defineService('healthlake', ['2017-07-01']);
	Object.defineProperty(apiLoader.services['healthlake'], '2017-07-01', {
	  get: function get() {
	    var model = __webpack_require__(960);
	    model.paginators = __webpack_require__(961).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.HealthLake;


/***/ }),
/* 960 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"healthlake","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"HealthLake","serviceFullName":"Amazon HealthLake","serviceId":"HealthLake","signatureVersion":"v4","signingName":"healthlake","targetPrefix":"HealthLake","uid":"healthlake-2017-07-01"},"operations":{"CreateFHIRDatastore":{"input":{"type":"structure","required":["DatastoreTypeVersion"],"members":{"DatastoreName":{},"DatastoreTypeVersion":{},"SseConfiguration":{"shape":"S4"},"PreloadDataConfig":{"shape":"S8"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","required":["DatastoreId","DatastoreArn","DatastoreStatus","DatastoreEndpoint"],"members":{"DatastoreId":{},"DatastoreArn":{},"DatastoreStatus":{},"DatastoreEndpoint":{}}}},"DeleteFHIRDatastore":{"input":{"type":"structure","members":{"DatastoreId":{}}},"output":{"type":"structure","required":["DatastoreId","DatastoreArn","DatastoreStatus","DatastoreEndpoint"],"members":{"DatastoreId":{},"DatastoreArn":{},"DatastoreStatus":{},"DatastoreEndpoint":{}}}},"DescribeFHIRDatastore":{"input":{"type":"structure","members":{"DatastoreId":{}}},"output":{"type":"structure","required":["DatastoreProperties"],"members":{"DatastoreProperties":{"shape":"So"}}}},"DescribeFHIRExportJob":{"input":{"type":"structure","required":["DatastoreId","JobId"],"members":{"DatastoreId":{},"JobId":{}}},"output":{"type":"structure","required":["ExportJobProperties"],"members":{"ExportJobProperties":{"shape":"Su"}}}},"DescribeFHIRImportJob":{"input":{"type":"structure","required":["DatastoreId","JobId"],"members":{"DatastoreId":{},"JobId":{}}},"output":{"type":"structure","required":["ImportJobProperties"],"members":{"ImportJobProperties":{"shape":"S14"}}}},"ListFHIRDatastores":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"DatastoreName":{},"DatastoreStatus":{},"CreatedBefore":{"type":"timestamp"},"CreatedAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["DatastorePropertiesList"],"members":{"DatastorePropertiesList":{"type":"list","member":{"shape":"So"}},"NextToken":{}}}},"ListFHIRExportJobs":{"input":{"type":"structure","required":["DatastoreId"],"members":{"DatastoreId":{},"NextToken":{},"MaxResults":{"type":"integer"},"JobName":{},"JobStatus":{},"SubmittedBefore":{"type":"timestamp"},"SubmittedAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["ExportJobPropertiesList"],"members":{"ExportJobPropertiesList":{"type":"list","member":{"shape":"Su"}},"NextToken":{}}}},"ListFHIRImportJobs":{"input":{"type":"structure","required":["DatastoreId"],"members":{"DatastoreId":{},"NextToken":{},"MaxResults":{"type":"integer"},"JobName":{},"JobStatus":{},"SubmittedBefore":{"type":"timestamp"},"SubmittedAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["ImportJobPropertiesList"],"members":{"ImportJobPropertiesList":{"type":"list","member":{"shape":"S14"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sb"}}}},"StartFHIRExportJob":{"input":{"type":"structure","required":["OutputDataConfig","DatastoreId","DataAccessRoleArn","ClientToken"],"members":{"JobName":{},"OutputDataConfig":{"shape":"Sx"},"DatastoreId":{},"DataAccessRoleArn":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["JobId","JobStatus"],"members":{"JobId":{},"JobStatus":{},"DatastoreId":{}}}},"StartFHIRImportJob":{"input":{"type":"structure","required":["InputDataConfig","JobOutputDataConfig","DatastoreId","DataAccessRoleArn","ClientToken"],"members":{"JobName":{},"InputDataConfig":{"shape":"S15"},"JobOutputDataConfig":{"shape":"Sx"},"DatastoreId":{},"DataAccessRoleArn":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["JobId","JobStatus"],"members":{"JobId":{},"JobStatus":{},"DatastoreId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["KmsEncryptionConfig"],"members":{"KmsEncryptionConfig":{"type":"structure","required":["CmkType"],"members":{"CmkType":{},"KmsKeyId":{}}}}},"S8":{"type":"structure","required":["PreloadDataType"],"members":{"PreloadDataType":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"So":{"type":"structure","required":["DatastoreId","DatastoreArn","DatastoreStatus","DatastoreTypeVersion","DatastoreEndpoint"],"members":{"DatastoreId":{},"DatastoreArn":{},"DatastoreName":{},"DatastoreStatus":{},"CreatedAt":{"type":"timestamp"},"DatastoreTypeVersion":{},"DatastoreEndpoint":{},"SseConfiguration":{"shape":"S4"},"PreloadDataConfig":{"shape":"S8"}}},"Su":{"type":"structure","required":["JobId","JobStatus","SubmitTime","DatastoreId","OutputDataConfig"],"members":{"JobId":{},"JobName":{},"JobStatus":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"DatastoreId":{},"OutputDataConfig":{"shape":"Sx"},"DataAccessRoleArn":{},"Message":{}}},"Sx":{"type":"structure","members":{"S3Configuration":{"type":"structure","required":["S3Uri","KmsKeyId"],"members":{"S3Uri":{},"KmsKeyId":{}}}},"union":true},"S14":{"type":"structure","required":["JobId","JobStatus","SubmitTime","DatastoreId","InputDataConfig"],"members":{"JobId":{},"JobName":{},"JobStatus":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"DatastoreId":{},"InputDataConfig":{"shape":"S15"},"JobOutputDataConfig":{"shape":"Sx"},"DataAccessRoleArn":{},"Message":{}}},"S15":{"type":"structure","members":{"S3Uri":{}},"union":true}}}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListFHIRDatastores":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFHIRExportJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFHIRImportJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['sagemakeredge'] = {};
	AWS.SagemakerEdge = Service.defineService('sagemakeredge', ['2020-09-23']);
	Object.defineProperty(apiLoader.services['sagemakeredge'], '2020-09-23', {
	  get: function get() {
	    var model = __webpack_require__(963);
	    model.paginators = __webpack_require__(964).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SagemakerEdge;


/***/ }),
/* 963 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-09-23","endpointPrefix":"edge.sagemaker","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Sagemaker Edge Manager","serviceId":"Sagemaker Edge","signatureVersion":"v4","signingName":"sagemaker","uid":"sagemaker-edge-2020-09-23"},"operations":{"GetDeviceRegistration":{"http":{"requestUri":"/GetDeviceRegistration"},"input":{"type":"structure","required":["DeviceName","DeviceFleetName"],"members":{"DeviceName":{},"DeviceFleetName":{}}},"output":{"type":"structure","members":{"DeviceRegistration":{},"CacheTTL":{}}}},"SendHeartbeat":{"http":{"requestUri":"/SendHeartbeat"},"input":{"type":"structure","required":["AgentVersion","DeviceName","DeviceFleetName"],"members":{"AgentMetrics":{"shape":"S8"},"Models":{"type":"list","member":{"type":"structure","members":{"ModelName":{},"ModelVersion":{},"LatestSampleTime":{"type":"timestamp"},"LatestInference":{"type":"timestamp"},"ModelMetrics":{"shape":"S8"}}}},"AgentVersion":{},"DeviceName":{},"DeviceFleetName":{}}}}},"shapes":{"S8":{"type":"list","member":{"type":"structure","members":{"Dimension":{},"MetricName":{},"Value":{"type":"double"},"Timestamp":{"type":"timestamp"}}}}}}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['amp'] = {};
	AWS.Amp = Service.defineService('amp', ['2020-08-01']);
	Object.defineProperty(apiLoader.services['amp'], '2020-08-01', {
	  get: function get() {
	    var model = __webpack_require__(966);
	    model.paginators = __webpack_require__(967).pagination;
	    model.waiters = __webpack_require__(968).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Amp;


/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-01","endpointPrefix":"aps","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Prometheus Service","serviceId":"amp","signatureVersion":"v4","signingName":"aps","uid":"amp-2020-08-01"},"operations":{"CreateAlertManagerDefinition":{"http":{"requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":202},"input":{"type":"structure","required":["data","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"S6"}}},"idempotent":true},"CreateRuleGroupsNamespace":{"http":{"requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces","responseCode":202},"input":{"type":"structure","required":["data","name","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"name":{},"tags":{"shape":"Sc"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","name","status"],"members":{"arn":{},"name":{},"status":{"shape":"Sh"},"tags":{"shape":"Sc"}}},"idempotent":true},"CreateWorkspace":{"http":{"requestUri":"/workspaces","responseCode":202},"input":{"type":"structure","members":{"alias":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"Sc"}}},"output":{"type":"structure","required":["arn","status","workspaceId"],"members":{"arn":{},"status":{"shape":"Sn"},"tags":{"shape":"Sc"},"workspaceId":{}}},"idempotent":true},"DeleteAlertManagerDefinition":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DeleteRuleGroupsNamespace":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces/{name}","responseCode":202},"input":{"type":"structure","required":["name","workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"name":{"location":"uri","locationName":"name"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DeleteWorkspace":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DescribeAlertManagerDefinition":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["alertManagerDefinition"],"members":{"alertManagerDefinition":{"type":"structure","required":["createdAt","data","modifiedAt","status"],"members":{"createdAt":{"type":"timestamp"},"data":{"type":"blob"},"modifiedAt":{"type":"timestamp"},"status":{"shape":"S6"}}}}}},"DescribeRuleGroupsNamespace":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces/{name}","responseCode":200},"input":{"type":"structure","required":["name","workspaceId"],"members":{"name":{"location":"uri","locationName":"name"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["ruleGroupsNamespace"],"members":{"ruleGroupsNamespace":{"type":"structure","required":["arn","createdAt","data","modifiedAt","name","status"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"data":{"type":"blob"},"modifiedAt":{"type":"timestamp"},"name":{},"status":{"shape":"Sh"},"tags":{"shape":"Sc"}}}}}},"DescribeWorkspace":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"type":"structure","required":["arn","createdAt","status","workspaceId"],"members":{"alias":{},"arn":{},"createdAt":{"type":"timestamp"},"prometheusEndpoint":{},"status":{"shape":"Sn"},"tags":{"shape":"Sc"},"workspaceId":{}}}}}},"ListRuleGroupsNamespaces":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"name":{"location":"querystring","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["ruleGroupsNamespaces"],"members":{"nextToken":{},"ruleGroupsNamespaces":{"type":"list","member":{"type":"structure","required":["arn","createdAt","modifiedAt","name","status"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"modifiedAt":{"type":"timestamp"},"name":{},"status":{"shape":"Sh"},"tags":{"shape":"Sc"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sc"}}}},"ListWorkspaces":{"http":{"method":"GET","requestUri":"/workspaces","responseCode":200},"input":{"type":"structure","members":{"alias":{"location":"querystring","locationName":"alias"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["workspaces"],"members":{"nextToken":{},"workspaces":{"type":"list","member":{"type":"structure","required":["arn","createdAt","status","workspaceId"],"members":{"alias":{},"arn":{},"createdAt":{"type":"timestamp"},"status":{"shape":"Sn"},"tags":{"shape":"Sc"},"workspaceId":{}}}}}}},"PutAlertManagerDefinition":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":202},"input":{"type":"structure","required":["data","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"S6"}}},"idempotent":true},"PutRuleGroupsNamespace":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces/{name}","responseCode":202},"input":{"type":"structure","required":["data","name","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"name":{"location":"uri","locationName":"name"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","name","status"],"members":{"arn":{},"name":{},"status":{"shape":"Sh"},"tags":{"shape":"Sc"}}},"idempotent":true},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateWorkspaceAlias":{"http":{"requestUri":"/workspaces/{workspaceId}/alias","responseCode":204},"input":{"type":"structure","required":["workspaceId"],"members":{"alias":{},"clientToken":{"idempotencyToken":true},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true}},"shapes":{"S6":{"type":"structure","required":["statusCode"],"members":{"statusCode":{},"statusReason":{}}},"Sc":{"type":"map","key":{},"value":{}},"Sh":{"type":"structure","required":["statusCode"],"members":{"statusCode":{},"statusReason":{}}},"Sn":{"type":"structure","required":["statusCode"],"members":{"statusCode":{}}}}}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListRuleGroupsNamespaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"ruleGroupsNamespaces"},"ListWorkspaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"workspaces"}}}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"WorkspaceActive":{"description":"Wait until a workspace reaches ACTIVE status","delay":2,"maxAttempts":60,"operation":"DescribeWorkspace","acceptors":[{"matcher":"path","argument":"workspace.status.statusCode","state":"success","expected":"ACTIVE"},{"matcher":"path","argument":"workspace.status.statusCode","state":"retry","expected":"UPDATING"},{"matcher":"path","argument":"workspace.status.statusCode","state":"retry","expected":"CREATING"}]},"WorkspaceDeleted":{"description":"Wait until a workspace reaches DELETED status","delay":2,"maxAttempts":60,"operation":"DescribeWorkspace","acceptors":[{"matcher":"error","state":"success","expected":"ResourceNotFoundException"},{"matcher":"path","argument":"workspace.status.statusCode","state":"retry","expected":"DELETING"}]}}}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['greengrassv2'] = {};
	AWS.GreengrassV2 = Service.defineService('greengrassv2', ['2020-11-30']);
	Object.defineProperty(apiLoader.services['greengrassv2'], '2020-11-30', {
	  get: function get() {
	    var model = __webpack_require__(970);
	    model.paginators = __webpack_require__(971).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.GreengrassV2;


/***/ }),
/* 970 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-30","endpointPrefix":"greengrass","protocol":"rest-json","serviceAbbreviation":"AWS GreengrassV2","serviceFullName":"AWS IoT Greengrass V2","serviceId":"GreengrassV2","signatureVersion":"v4","uid":"greengrassv2-2020-11-30"},"operations":{"AssociateServiceRoleToAccount":{"http":{"method":"PUT","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{"locationName":"RoleArn"}}},"output":{"type":"structure","members":{"associatedAt":{"locationName":"AssociatedAt"}}}},"BatchAssociateClientDeviceWithCoreDevice":{"http":{"requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}/associateClientDevices","responseCode":200},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"entries":{"type":"list","member":{"type":"structure","required":["thingName"],"members":{"thingName":{}}}},"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"}}},"output":{"type":"structure","members":{"errorEntries":{"type":"list","member":{"type":"structure","members":{"thingName":{},"code":{},"message":{}}}}}}},"BatchDisassociateClientDeviceFromCoreDevice":{"http":{"requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}/disassociateClientDevices","responseCode":200},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"entries":{"type":"list","member":{"type":"structure","required":["thingName"],"members":{"thingName":{}}}},"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"}}},"output":{"type":"structure","members":{"errorEntries":{"type":"list","member":{"type":"structure","members":{"thingName":{},"code":{},"message":{}}}}}}},"CancelDeployment":{"http":{"requestUri":"/greengrass/v2/deployments/{deploymentId}/cancel"},"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{"location":"uri","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"message":{}}}},"CreateComponentVersion":{"http":{"requestUri":"/greengrass/v2/createComponentVersion","responseCode":201},"input":{"type":"structure","members":{"inlineRecipe":{"type":"blob"},"lambdaFunction":{"type":"structure","required":["lambdaArn"],"members":{"lambdaArn":{},"componentName":{},"componentVersion":{},"componentPlatforms":{"shape":"Sq"},"componentDependencies":{"type":"map","key":{},"value":{"type":"structure","members":{"versionRequirement":{},"dependencyType":{}}}},"componentLambdaParameters":{"type":"structure","members":{"eventSources":{"type":"list","member":{"type":"structure","required":["topic","type"],"members":{"topic":{},"type":{}}}},"maxQueueSize":{"type":"integer"},"maxInstancesCount":{"type":"integer"},"maxIdleTimeInSeconds":{"type":"integer"},"timeoutInSeconds":{"type":"integer"},"statusTimeoutInSeconds":{"type":"integer"},"pinned":{"type":"boolean"},"inputPayloadEncodingType":{},"execArgs":{"type":"list","member":{}},"environmentVariables":{"type":"map","key":{},"value":{}},"linuxProcessParams":{"type":"structure","members":{"isolationMode":{},"containerParams":{"type":"structure","members":{"memorySizeInKB":{"type":"integer"},"mountROSysfs":{"type":"boolean"},"volumes":{"type":"list","member":{"type":"structure","required":["sourcePath","destinationPath"],"members":{"sourcePath":{},"destinationPath":{},"permission":{},"addGroupOwner":{"type":"boolean"}}}},"devices":{"type":"list","member":{"type":"structure","required":["path"],"members":{"path":{},"permission":{},"addGroupOwner":{"type":"boolean"}}}}}}}}}}}},"tags":{"shape":"S1g"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["componentName","componentVersion","creationTimestamp","status"],"members":{"arn":{},"componentName":{},"componentVersion":{},"creationTimestamp":{"type":"timestamp"},"status":{"shape":"S1n"}}}},"CreateDeployment":{"http":{"requestUri":"/greengrass/v2/deployments","responseCode":201},"input":{"type":"structure","required":["targetArn"],"members":{"targetArn":{},"deploymentName":{},"components":{"shape":"S1s"},"iotJobConfiguration":{"shape":"S22"},"deploymentPolicies":{"shape":"S2j"},"tags":{"shape":"S1g"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"deploymentId":{},"iotJobId":{},"iotJobArn":{}}}},"DeleteComponent":{"http":{"method":"DELETE","requestUri":"/greengrass/v2/components/{arn}","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}}},"DeleteCoreDevice":{"http":{"method":"DELETE","requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}","responseCode":204},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"}}}},"DescribeComponent":{"http":{"method":"GET","requestUri":"/greengrass/v2/components/{arn}/metadata"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{"arn":{},"componentName":{},"componentVersion":{},"creationTimestamp":{"type":"timestamp"},"publisher":{},"description":{},"status":{"shape":"S1n"},"platforms":{"shape":"Sq"},"tags":{"shape":"S1g"}}}},"DisassociateServiceRoleFromAccount":{"http":{"method":"DELETE","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"disassociatedAt":{"locationName":"DisassociatedAt"}}}},"GetComponent":{"http":{"method":"GET","requestUri":"/greengrass/v2/components/{arn}"},"input":{"type":"structure","required":["arn"],"members":{"recipeOutputFormat":{"location":"querystring","locationName":"recipeOutputFormat"},"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","required":["recipeOutputFormat","recipe"],"members":{"recipeOutputFormat":{},"recipe":{"type":"blob"},"tags":{"shape":"S1g"}}}},"GetComponentVersionArtifact":{"http":{"method":"GET","requestUri":"/greengrass/v2/components/{arn}/artifacts/{artifactName+}"},"input":{"type":"structure","required":["arn","artifactName"],"members":{"arn":{"location":"uri","locationName":"arn"},"artifactName":{"location":"uri","locationName":"artifactName"}}},"output":{"type":"structure","required":["preSignedUrl"],"members":{"preSignedUrl":{}}}},"GetConnectivityInfo":{"http":{"method":"GET","requestUri":"/greengrass/things/{thingName}/connectivityInfo","responseCode":200},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"connectivityInfo":{"shape":"S36","locationName":"ConnectivityInfo"},"message":{"locationName":"Message"}}}},"GetCoreDevice":{"http":{"method":"GET","requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}"},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"}}},"output":{"type":"structure","members":{"coreDeviceThingName":{},"coreVersion":{},"platform":{},"architecture":{},"status":{},"lastStatusUpdateTimestamp":{"type":"timestamp"},"tags":{"shape":"S1g"}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/greengrass/v2/deployments/{deploymentId}"},"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{"location":"uri","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"targetArn":{},"revisionId":{},"deploymentId":{},"deploymentName":{},"deploymentStatus":{},"iotJobId":{},"iotJobArn":{},"components":{"shape":"S1s"},"deploymentPolicies":{"shape":"S2j"},"iotJobConfiguration":{"shape":"S22"},"creationTimestamp":{"type":"timestamp"},"isLatestForTarget":{"type":"boolean"},"tags":{"shape":"S1g"}}}},"GetServiceRoleForAccount":{"http":{"method":"GET","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"associatedAt":{"locationName":"AssociatedAt"},"roleArn":{"locationName":"RoleArn"}}}},"ListClientDevicesAssociatedWithCoreDevice":{"http":{"method":"GET","requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}/associatedClientDevices","responseCode":200},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"associatedClientDevices":{"type":"list","member":{"type":"structure","members":{"thingName":{},"associationTimestamp":{"type":"timestamp"}}}},"nextToken":{}}}},"ListComponentVersions":{"http":{"method":"GET","requestUri":"/greengrass/v2/components/{arn}/versions"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"componentVersions":{"type":"list","member":{"type":"structure","members":{"componentName":{},"componentVersion":{},"arn":{}}}},"nextToken":{}}}},"ListComponents":{"http":{"method":"GET","requestUri":"/greengrass/v2/components"},"input":{"type":"structure","members":{"scope":{"location":"querystring","locationName":"scope"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"components":{"type":"list","member":{"type":"structure","members":{"arn":{},"componentName":{},"latestVersion":{"type":"structure","members":{"arn":{},"componentVersion":{},"creationTimestamp":{"type":"timestamp"},"description":{},"publisher":{},"platforms":{"shape":"Sq"}}}}}},"nextToken":{}}}},"ListCoreDevices":{"http":{"method":"GET","requestUri":"/greengrass/v2/coreDevices"},"input":{"type":"structure","members":{"thingGroupArn":{"location":"querystring","locationName":"thingGroupArn"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"coreDevices":{"type":"list","member":{"type":"structure","members":{"coreDeviceThingName":{},"status":{},"lastStatusUpdateTimestamp":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDeployments":{"http":{"method":"GET","requestUri":"/greengrass/v2/deployments"},"input":{"type":"structure","members":{"targetArn":{"location":"querystring","locationName":"targetArn"},"historyFilter":{"location":"querystring","locationName":"historyFilter"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"deployments":{"type":"list","member":{"type":"structure","members":{"targetArn":{},"revisionId":{},"deploymentId":{},"deploymentName":{},"creationTimestamp":{"type":"timestamp"},"deploymentStatus":{},"isLatestForTarget":{"type":"boolean"}}}},"nextToken":{}}}},"ListEffectiveDeployments":{"http":{"method":"GET","requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}/effectiveDeployments"},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"effectiveDeployments":{"type":"list","member":{"type":"structure","required":["deploymentId","deploymentName","targetArn","coreDeviceExecutionStatus","creationTimestamp","modifiedTimestamp"],"members":{"deploymentId":{},"deploymentName":{},"iotJobId":{},"iotJobArn":{},"description":{},"targetArn":{},"coreDeviceExecutionStatus":{},"reason":{},"creationTimestamp":{"type":"timestamp"},"modifiedTimestamp":{"type":"timestamp"}}}},"nextToken":{}}}},"ListInstalledComponents":{"http":{"method":"GET","requestUri":"/greengrass/v2/coreDevices/{coreDeviceThingName}/installedComponents"},"input":{"type":"structure","required":["coreDeviceThingName"],"members":{"coreDeviceThingName":{"location":"uri","locationName":"coreDeviceThingName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"installedComponents":{"type":"list","member":{"type":"structure","members":{"componentName":{},"componentVersion":{},"lifecycleState":{},"lifecycleStateDetails":{},"isRoot":{"type":"boolean"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1g"}}}},"ResolveComponentCandidates":{"http":{"requestUri":"/greengrass/v2/resolveComponentCandidates"},"input":{"type":"structure","required":["platform","componentCandidates"],"members":{"platform":{"shape":"Sr"},"componentCandidates":{"type":"list","member":{"type":"structure","members":{"componentName":{},"componentVersion":{},"versionRequirements":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{"resolvedComponentVersions":{"type":"list","member":{"type":"structure","members":{"arn":{},"componentName":{},"componentVersion":{},"recipe":{"type":"blob"}}}}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1g"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConnectivityInfo":{"http":{"method":"PUT","requestUri":"/greengrass/things/{thingName}/connectivityInfo","responseCode":200},"input":{"type":"structure","required":["thingName","connectivityInfo"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"connectivityInfo":{"shape":"S36","locationName":"ConnectivityInfo"}}},"output":{"type":"structure","members":{"version":{"locationName":"Version"},"message":{"locationName":"Message"}}}}},"shapes":{"Sq":{"type":"list","member":{"shape":"Sr"}},"Sr":{"type":"structure","members":{"name":{},"attributes":{"type":"map","key":{},"value":{}}}},"S1g":{"type":"map","key":{},"value":{}},"S1n":{"type":"structure","members":{"componentState":{},"message":{},"errors":{"type":"map","key":{},"value":{}}}},"S1s":{"type":"map","key":{},"value":{"type":"structure","members":{"componentVersion":{},"configurationUpdate":{"type":"structure","members":{"merge":{},"reset":{"type":"list","member":{}}}},"runWith":{"type":"structure","members":{"posixUser":{},"systemResourceLimits":{"type":"structure","members":{"memory":{"type":"long"},"cpus":{"type":"double"}}},"windowsUser":{}}}}}},"S22":{"type":"structure","members":{"jobExecutionsRolloutConfig":{"type":"structure","members":{"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}},"maximumPerMinute":{"type":"integer"}}},"abortConfig":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"timeoutConfig":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}}}},"S2j":{"type":"structure","members":{"failureHandlingPolicy":{},"componentUpdatePolicy":{"type":"structure","members":{"timeoutInSeconds":{"type":"integer"},"action":{}}},"configurationValidationPolicy":{"type":"structure","members":{"timeoutInSeconds":{"type":"integer"}}}}},"S36":{"type":"list","member":{"type":"structure","members":{"id":{"locationName":"Id"},"hostAddress":{"locationName":"HostAddress"},"portNumber":{"locationName":"PortNumber","type":"integer"},"metadata":{"locationName":"Metadata"}}}}}}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListClientDevicesAssociatedWithCoreDevice":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"associatedClientDevices"},"ListComponentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"componentVersions"},"ListComponents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"components"},"ListCoreDevices":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"coreDevices"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"deployments"},"ListEffectiveDeployments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"effectiveDeployments"},"ListInstalledComponents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"installedComponents"}}}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotdeviceadvisor'] = {};
	AWS.IotDeviceAdvisor = Service.defineService('iotdeviceadvisor', ['2020-09-18']);
	Object.defineProperty(apiLoader.services['iotdeviceadvisor'], '2020-09-18', {
	  get: function get() {
	    var model = __webpack_require__(973);
	    model.paginators = __webpack_require__(974).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IotDeviceAdvisor;


/***/ }),
/* 973 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-09-18","endpointPrefix":"api.iotdeviceadvisor","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWSIoTDeviceAdvisor","serviceFullName":"AWS IoT Core Device Advisor","serviceId":"IotDeviceAdvisor","signatureVersion":"v4","signingName":"iotdeviceadvisor","uid":"iotdeviceadvisor-2020-09-18"},"operations":{"CreateSuiteDefinition":{"http":{"requestUri":"/suiteDefinitions"},"input":{"type":"structure","members":{"suiteDefinitionConfiguration":{"shape":"S2"},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"suiteDefinitionId":{},"suiteDefinitionArn":{},"suiteDefinitionName":{},"createdAt":{"type":"timestamp"}}}},"DeleteSuiteDefinition":{"http":{"method":"DELETE","requestUri":"/suiteDefinitions/{suiteDefinitionId}"},"input":{"type":"structure","required":["suiteDefinitionId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"}}},"output":{"type":"structure","members":{}}},"GetEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{"thingArn":{"location":"querystring","locationName":"thingArn"},"certificateArn":{"location":"querystring","locationName":"certificateArn"}}},"output":{"type":"structure","members":{"endpoint":{}}}},"GetSuiteDefinition":{"http":{"method":"GET","requestUri":"/suiteDefinitions/{suiteDefinitionId}"},"input":{"type":"structure","required":["suiteDefinitionId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"},"suiteDefinitionVersion":{"location":"querystring","locationName":"suiteDefinitionVersion"}}},"output":{"type":"structure","members":{"suiteDefinitionId":{},"suiteDefinitionArn":{},"suiteDefinitionVersion":{},"latestVersion":{},"suiteDefinitionConfiguration":{"shape":"S2"},"createdAt":{"type":"timestamp"},"lastModifiedAt":{"type":"timestamp"},"tags":{"shape":"S9"}}}},"GetSuiteRun":{"http":{"method":"GET","requestUri":"/suiteDefinitions/{suiteDefinitionId}/suiteRuns/{suiteRunId}"},"input":{"type":"structure","required":["suiteDefinitionId","suiteRunId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"},"suiteRunId":{"location":"uri","locationName":"suiteRunId"}}},"output":{"type":"structure","members":{"suiteDefinitionId":{},"suiteDefinitionVersion":{},"suiteRunId":{},"suiteRunArn":{},"suiteRunConfiguration":{"shape":"Sp"},"testResult":{"type":"structure","members":{"groups":{"type":"list","member":{"type":"structure","members":{"groupId":{},"groupName":{},"tests":{"type":"list","member":{"type":"structure","members":{"testCaseRunId":{},"testCaseDefinitionId":{},"testCaseDefinitionName":{},"status":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"logUrl":{},"warnings":{},"failure":{}}}}}}}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{},"errorReason":{},"tags":{"shape":"S9"}}}},"GetSuiteRunReport":{"http":{"method":"GET","requestUri":"/suiteDefinitions/{suiteDefinitionId}/suiteRuns/{suiteRunId}/report"},"input":{"type":"structure","required":["suiteDefinitionId","suiteRunId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"},"suiteRunId":{"location":"uri","locationName":"suiteRunId"}}},"output":{"type":"structure","members":{"qualificationReportDownloadUrl":{}}}},"ListSuiteDefinitions":{"http":{"method":"GET","requestUri":"/suiteDefinitions"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"suiteDefinitionInformationList":{"type":"list","member":{"type":"structure","members":{"suiteDefinitionId":{},"suiteDefinitionName":{},"defaultDevices":{"shape":"S4"},"intendedForQualification":{"type":"boolean"},"createdAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListSuiteRuns":{"http":{"method":"GET","requestUri":"/suiteRuns"},"input":{"type":"structure","members":{"suiteDefinitionId":{"location":"querystring","locationName":"suiteDefinitionId"},"suiteDefinitionVersion":{"location":"querystring","locationName":"suiteDefinitionVersion"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"suiteRunsList":{"type":"list","member":{"type":"structure","members":{"suiteDefinitionId":{},"suiteDefinitionVersion":{},"suiteDefinitionName":{},"suiteRunId":{},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"endAt":{"type":"timestamp"},"status":{},"passed":{"type":"integer"},"failed":{"type":"integer"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S9"}}}},"StartSuiteRun":{"http":{"requestUri":"/suiteDefinitions/{suiteDefinitionId}/suiteRuns"},"input":{"type":"structure","required":["suiteDefinitionId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"},"suiteDefinitionVersion":{},"suiteRunConfiguration":{"shape":"Sp"},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"suiteRunId":{},"suiteRunArn":{},"createdAt":{"type":"timestamp"}}}},"StopSuiteRun":{"http":{"requestUri":"/suiteDefinitions/{suiteDefinitionId}/suiteRuns/{suiteRunId}/stop"},"input":{"type":"structure","required":["suiteDefinitionId","suiteRunId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"},"suiteRunId":{"location":"uri","locationName":"suiteRunId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S9"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateSuiteDefinition":{"http":{"method":"PATCH","requestUri":"/suiteDefinitions/{suiteDefinitionId}"},"input":{"type":"structure","required":["suiteDefinitionId"],"members":{"suiteDefinitionId":{"location":"uri","locationName":"suiteDefinitionId"},"suiteDefinitionConfiguration":{"shape":"S2"}}},"output":{"type":"structure","members":{"suiteDefinitionId":{},"suiteDefinitionArn":{},"suiteDefinitionName":{},"suiteDefinitionVersion":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}}},"shapes":{"S2":{"type":"structure","members":{"suiteDefinitionName":{},"devices":{"shape":"S4"},"intendedForQualification":{"type":"boolean"},"rootGroup":{},"devicePermissionRoleArn":{}}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","members":{"thingArn":{},"certificateArn":{}}},"S9":{"type":"map","key":{},"value":{}},"Sp":{"type":"structure","members":{"primaryDevice":{"shape":"S5"},"selectedTestList":{"type":"list","member":{}},"parallelRun":{"type":"boolean"}}}}}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListSuiteDefinitions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSuiteRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotfleethub'] = {};
	AWS.IoTFleetHub = Service.defineService('iotfleethub', ['2020-11-03']);
	Object.defineProperty(apiLoader.services['iotfleethub'], '2020-11-03', {
	  get: function get() {
	    var model = __webpack_require__(976);
	    model.paginators = __webpack_require__(977).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTFleetHub;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-03","endpointPrefix":"api.fleethub.iot","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS IoT Fleet Hub","serviceId":"IoTFleetHub","signatureVersion":"v4","signingName":"iotfleethub","uid":"iotfleethub-2020-11-03"},"operations":{"CreateApplication":{"http":{"requestUri":"/applications","responseCode":201},"input":{"type":"structure","required":["applicationName","roleArn"],"members":{"applicationName":{},"applicationDescription":{},"clientToken":{"idempotencyToken":true},"roleArn":{},"tags":{"shape":"S6"}}},"output":{"type":"structure","required":["applicationId","applicationArn"],"members":{"applicationId":{},"applicationArn":{}}}},"DeleteApplication":{"http":{"method":"DELETE","requestUri":"/applications/{applicationId}","responseCode":204},"input":{"type":"structure","required":["applicationId"],"members":{"applicationId":{"location":"uri","locationName":"applicationId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}}},"DescribeApplication":{"http":{"method":"GET","requestUri":"/applications/{applicationId}","responseCode":200},"input":{"type":"structure","required":["applicationId"],"members":{"applicationId":{"location":"uri","locationName":"applicationId"}}},"output":{"type":"structure","required":["applicationId","applicationArn","applicationName","applicationUrl","applicationState","applicationCreationDate","applicationLastUpdateDate","roleArn"],"members":{"applicationId":{},"applicationArn":{},"applicationName":{},"applicationDescription":{},"applicationUrl":{},"applicationState":{},"applicationCreationDate":{"type":"long"},"applicationLastUpdateDate":{"type":"long"},"roleArn":{},"ssoClientId":{},"errorMessage":{},"tags":{"shape":"S6"}}}},"ListApplications":{"http":{"method":"GET","requestUri":"/applications","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"applicationSummaries":{"type":"list","member":{"type":"structure","required":["applicationId","applicationName","applicationUrl"],"members":{"applicationId":{},"applicationName":{},"applicationDescription":{},"applicationUrl":{},"applicationCreationDate":{"type":"long"},"applicationLastUpdateDate":{"type":"long"},"applicationState":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S6"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"http":{"method":"PATCH","requestUri":"/applications/{applicationId}","responseCode":202},"input":{"type":"structure","required":["applicationId"],"members":{"applicationId":{"location":"uri","locationName":"applicationId"},"applicationName":{},"applicationDescription":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applicationSummaries"}}}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iotwireless'] = {};
	AWS.IoTWireless = Service.defineService('iotwireless', ['2020-11-22']);
	Object.defineProperty(apiLoader.services['iotwireless'], '2020-11-22', {
	  get: function get() {
	    var model = __webpack_require__(979);
	    model.paginators = __webpack_require__(980).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTWireless;


/***/ }),
/* 979 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-22","endpointPrefix":"api.iotwireless","protocol":"rest-json","serviceFullName":"AWS IoT Wireless","serviceId":"IoT Wireless","signatureVersion":"v4","signingName":"iotwireless","uid":"iotwireless-2020-11-22"},"operations":{"AssociateAwsAccountWithPartnerAccount":{"http":{"requestUri":"/partner-accounts"},"input":{"type":"structure","required":["Sidewalk"],"members":{"Sidewalk":{"shape":"S2"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Sidewalk":{"shape":"S2"},"Arn":{}}}},"AssociateMulticastGroupWithFuotaTask":{"http":{"method":"PUT","requestUri":"/fuota-tasks/{Id}/multicast-group","responseCode":204},"input":{"type":"structure","required":["Id","MulticastGroupId"],"members":{"Id":{"location":"uri","locationName":"Id"},"MulticastGroupId":{}}},"output":{"type":"structure","members":{}}},"AssociateWirelessDeviceWithFuotaTask":{"http":{"method":"PUT","requestUri":"/fuota-tasks/{Id}/wireless-device","responseCode":204},"input":{"type":"structure","required":["Id","WirelessDeviceId"],"members":{"Id":{"location":"uri","locationName":"Id"},"WirelessDeviceId":{}}},"output":{"type":"structure","members":{}}},"AssociateWirelessDeviceWithMulticastGroup":{"http":{"method":"PUT","requestUri":"/multicast-groups/{Id}/wireless-device","responseCode":204},"input":{"type":"structure","required":["Id","WirelessDeviceId"],"members":{"Id":{"location":"uri","locationName":"Id"},"WirelessDeviceId":{}}},"output":{"type":"structure","members":{}}},"AssociateWirelessDeviceWithThing":{"http":{"method":"PUT","requestUri":"/wireless-devices/{Id}/thing","responseCode":204},"input":{"type":"structure","required":["Id","ThingArn"],"members":{"Id":{"location":"uri","locationName":"Id"},"ThingArn":{}}},"output":{"type":"structure","members":{}}},"AssociateWirelessGatewayWithCertificate":{"http":{"method":"PUT","requestUri":"/wireless-gateways/{Id}/certificate"},"input":{"type":"structure","required":["Id","IotCertificateId"],"members":{"Id":{"location":"uri","locationName":"Id"},"IotCertificateId":{}}},"output":{"type":"structure","members":{"IotCertificateId":{}}}},"AssociateWirelessGatewayWithThing":{"http":{"method":"PUT","requestUri":"/wireless-gateways/{Id}/thing","responseCode":204},"input":{"type":"structure","required":["Id","ThingArn"],"members":{"Id":{"location":"uri","locationName":"Id"},"ThingArn":{}}},"output":{"type":"structure","members":{}}},"CancelMulticastGroupSession":{"http":{"method":"DELETE","requestUri":"/multicast-groups/{Id}/session","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateDestination":{"http":{"requestUri":"/destinations","responseCode":201},"input":{"type":"structure","required":["Name","ExpressionType","Expression","RoleArn"],"members":{"Name":{},"ExpressionType":{},"Expression":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S6"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"CreateDeviceProfile":{"http":{"requestUri":"/device-profiles","responseCode":201},"input":{"type":"structure","members":{"Name":{},"LoRaWAN":{"shape":"S16"},"Tags":{"shape":"S6"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Arn":{},"Id":{}}}},"CreateFuotaTask":{"http":{"requestUri":"/fuota-tasks","responseCode":201},"input":{"type":"structure","required":["FirmwareUpdateImage","FirmwareUpdateRole"],"members":{"Name":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true},"LoRaWAN":{"shape":"S1w"},"FirmwareUpdateImage":{},"FirmwareUpdateRole":{},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Arn":{},"Id":{}}}},"CreateMulticastGroup":{"http":{"requestUri":"/multicast-groups","responseCode":201},"input":{"type":"structure","required":["LoRaWAN"],"members":{"Name":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true},"LoRaWAN":{"shape":"S24"},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Arn":{},"Id":{}}}},"CreateNetworkAnalyzerConfiguration":{"http":{"requestUri":"/network-analyzer-configurations","responseCode":201},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TraceContent":{"shape":"S2a"},"WirelessDevices":{"shape":"S2d"},"WirelessGateways":{"shape":"S2e"},"Description":{},"Tags":{"shape":"S6"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"CreateServiceProfile":{"http":{"requestUri":"/service-profiles","responseCode":201},"input":{"type":"structure","members":{"Name":{},"LoRaWAN":{"type":"structure","members":{"AddGwMetadata":{"type":"boolean"}}},"Tags":{"shape":"S6"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Arn":{},"Id":{}}}},"CreateWirelessDevice":{"http":{"requestUri":"/wireless-devices","responseCode":201},"input":{"type":"structure","required":["Type","DestinationName"],"members":{"Type":{},"Name":{},"Description":{},"DestinationName":{},"ClientRequestToken":{"idempotencyToken":true},"LoRaWAN":{"shape":"S2r"},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Arn":{},"Id":{}}}},"CreateWirelessGateway":{"http":{"requestUri":"/wireless-gateways","responseCode":201},"input":{"type":"structure","required":["LoRaWAN"],"members":{"Name":{},"Description":{},"LoRaWAN":{"shape":"S3h"},"Tags":{"shape":"S6"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Arn":{},"Id":{}}}},"CreateWirelessGatewayTask":{"http":{"requestUri":"/wireless-gateways/{Id}/tasks","responseCode":201},"input":{"type":"structure","required":["Id","WirelessGatewayTaskDefinitionId"],"members":{"Id":{"location":"uri","locationName":"Id"},"WirelessGatewayTaskDefinitionId":{}}},"output":{"type":"structure","members":{"WirelessGatewayTaskDefinitionId":{},"Status":{}}}},"CreateWirelessGatewayTaskDefinition":{"http":{"requestUri":"/wireless-gateway-task-definitions","responseCode":201},"input":{"type":"structure","required":["AutoCreateTasks"],"members":{"AutoCreateTasks":{"type":"boolean"},"Name":{},"Update":{"shape":"S3y"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"DeleteDestination":{"http":{"method":"DELETE","requestUri":"/destinations/{Name}","responseCode":204},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{}}},"DeleteDeviceProfile":{"http":{"method":"DELETE","requestUri":"/device-profiles/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteFuotaTask":{"http":{"method":"DELETE","requestUri":"/fuota-tasks/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteMulticastGroup":{"http":{"method":"DELETE","requestUri":"/multicast-groups/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteNetworkAnalyzerConfiguration":{"http":{"method":"DELETE","requestUri":"/network-analyzer-configurations/{ConfigurationName}","responseCode":204},"input":{"type":"structure","required":["ConfigurationName"],"members":{"ConfigurationName":{"location":"uri","locationName":"ConfigurationName"}}},"output":{"type":"structure","members":{}}},"DeleteQueuedMessages":{"http":{"method":"DELETE","requestUri":"/wireless-devices/{Id}/data","responseCode":204},"input":{"type":"structure","required":["Id","MessageId"],"members":{"Id":{"location":"uri","locationName":"Id"},"MessageId":{"location":"querystring","locationName":"messageId"},"WirelessDeviceType":{"location":"querystring","locationName":"WirelessDeviceType"}}},"output":{"type":"structure","members":{}}},"DeleteServiceProfile":{"http":{"method":"DELETE","requestUri":"/service-profiles/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteWirelessDevice":{"http":{"method":"DELETE","requestUri":"/wireless-devices/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteWirelessGateway":{"http":{"method":"DELETE","requestUri":"/wireless-gateways/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteWirelessGatewayTask":{"http":{"method":"DELETE","requestUri":"/wireless-gateways/{Id}/tasks","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteWirelessGatewayTaskDefinition":{"http":{"method":"DELETE","requestUri":"/wireless-gateway-task-definitions/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DisassociateAwsAccountFromPartnerAccount":{"http":{"method":"DELETE","requestUri":"/partner-accounts/{PartnerAccountId}","responseCode":204},"input":{"type":"structure","required":["PartnerAccountId","PartnerType"],"members":{"PartnerAccountId":{"location":"uri","locationName":"PartnerAccountId"},"PartnerType":{"location":"querystring","locationName":"partnerType"}}},"output":{"type":"structure","members":{}}},"DisassociateMulticastGroupFromFuotaTask":{"http":{"method":"DELETE","requestUri":"/fuota-tasks/{Id}/multicast-groups/{MulticastGroupId}","responseCode":204},"input":{"type":"structure","required":["Id","MulticastGroupId"],"members":{"Id":{"location":"uri","locationName":"Id"},"MulticastGroupId":{"location":"uri","locationName":"MulticastGroupId"}}},"output":{"type":"structure","members":{}}},"DisassociateWirelessDeviceFromFuotaTask":{"http":{"method":"DELETE","requestUri":"/fuota-tasks/{Id}/wireless-devices/{WirelessDeviceId}","responseCode":204},"input":{"type":"structure","required":["Id","WirelessDeviceId"],"members":{"Id":{"location":"uri","locationName":"Id"},"WirelessDeviceId":{"location":"uri","locationName":"WirelessDeviceId"}}},"output":{"type":"structure","members":{}}},"DisassociateWirelessDeviceFromMulticastGroup":{"http":{"method":"DELETE","requestUri":"/multicast-groups/{Id}/wireless-devices/{WirelessDeviceId}","responseCode":204},"input":{"type":"structure","required":["Id","WirelessDeviceId"],"members":{"Id":{"location":"uri","locationName":"Id"},"WirelessDeviceId":{"location":"uri","locationName":"WirelessDeviceId"}}},"output":{"type":"structure","members":{}}},"DisassociateWirelessDeviceFromThing":{"http":{"method":"DELETE","requestUri":"/wireless-devices/{Id}/thing","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DisassociateWirelessGatewayFromCertificate":{"http":{"method":"DELETE","requestUri":"/wireless-gateways/{Id}/certificate","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DisassociateWirelessGatewayFromThing":{"http":{"method":"DELETE","requestUri":"/wireless-gateways/{Id}/thing","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"GetDestination":{"http":{"method":"GET","requestUri":"/destinations/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{},"Expression":{},"ExpressionType":{},"Description":{},"RoleArn":{}}}},"GetDeviceProfile":{"http":{"method":"GET","requestUri":"/device-profiles/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{},"Id":{},"LoRaWAN":{"shape":"S16"}}}},"GetEventConfigurationByResourceTypes":{"http":{"method":"GET","requestUri":"/event-configurations-resource-types"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DeviceRegistrationState":{"shape":"S5i"},"Proximity":{"shape":"S5l"},"Join":{"shape":"S5m"},"ConnectionStatus":{"shape":"S5o"}}}},"GetFuotaTask":{"http":{"method":"GET","requestUri":"/fuota-tasks/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Arn":{},"Id":{},"Status":{},"Name":{},"Description":{},"LoRaWAN":{"type":"structure","members":{"RfRegion":{},"StartTime":{"shape":"S5u"}}},"FirmwareUpdateImage":{},"FirmwareUpdateRole":{},"CreatedAt":{"type":"timestamp"}}}},"GetLogLevelsByResourceTypes":{"http":{"method":"GET","requestUri":"/log-levels","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DefaultLogLevel":{},"WirelessGatewayLogOptions":{"shape":"S5y"},"WirelessDeviceLogOptions":{"shape":"S64"}}}},"GetMulticastGroup":{"http":{"method":"GET","requestUri":"/multicast-groups/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Description":{},"Status":{},"LoRaWAN":{"type":"structure","members":{"RfRegion":{},"DlClass":{},"NumberOfDevicesRequested":{"type":"integer"},"NumberOfDevicesInGroup":{"type":"integer"}}},"CreatedAt":{"type":"timestamp"}}}},"GetMulticastGroupSession":{"http":{"method":"GET","requestUri":"/multicast-groups/{Id}/session"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"LoRaWAN":{"shape":"S6h"}}}},"GetNetworkAnalyzerConfiguration":{"http":{"method":"GET","requestUri":"/network-analyzer-configurations/{ConfigurationName}","responseCode":200},"input":{"type":"structure","required":["ConfigurationName"],"members":{"ConfigurationName":{"location":"uri","locationName":"ConfigurationName"}}},"output":{"type":"structure","members":{"TraceContent":{"shape":"S2a"},"WirelessDevices":{"shape":"S2d"},"WirelessGateways":{"shape":"S2e"},"Description":{},"Arn":{},"Name":{}}}},"GetPartnerAccount":{"http":{"method":"GET","requestUri":"/partner-accounts/{PartnerAccountId}"},"input":{"type":"structure","required":["PartnerAccountId","PartnerType"],"members":{"PartnerAccountId":{"location":"uri","locationName":"PartnerAccountId"},"PartnerType":{"location":"querystring","locationName":"partnerType"}}},"output":{"type":"structure","members":{"Sidewalk":{"shape":"S6q"},"AccountLinked":{"type":"boolean"}}}},"GetResourceEventConfiguration":{"http":{"method":"GET","requestUri":"/event-configurations/{Identifier}"},"input":{"type":"structure","required":["Identifier","IdentifierType"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"},"IdentifierType":{"location":"querystring","locationName":"identifierType"},"PartnerType":{"location":"querystring","locationName":"partnerType"}}},"output":{"type":"structure","members":{"DeviceRegistrationState":{"shape":"S6y"},"Proximity":{"shape":"S70"},"Join":{"shape":"S71"},"ConnectionStatus":{"shape":"S73"}}}},"GetResourceLogLevel":{"http":{"method":"GET","requestUri":"/log-levels/{ResourceIdentifier}","responseCode":200},"input":{"type":"structure","required":["ResourceIdentifier","ResourceType"],"members":{"ResourceIdentifier":{"location":"uri","locationName":"ResourceIdentifier"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}},"output":{"type":"structure","members":{"LogLevel":{}}}},"GetServiceEndpoint":{"http":{"method":"GET","requestUri":"/service-endpoint"},"input":{"type":"structure","members":{"ServiceType":{"location":"querystring","locationName":"serviceType"}}},"output":{"type":"structure","members":{"ServiceType":{},"ServiceEndpoint":{},"ServerTrust":{}}}},"GetServiceProfile":{"http":{"method":"GET","requestUri":"/service-profiles/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{},"Id":{},"LoRaWAN":{"type":"structure","members":{"UlRate":{"type":"integer"},"UlBucketSize":{"type":"integer"},"UlRatePolicy":{},"DlRate":{"type":"integer"},"DlBucketSize":{"type":"integer"},"DlRatePolicy":{},"AddGwMetadata":{"type":"boolean"},"DevStatusReqFreq":{"type":"integer"},"ReportDevStatusBattery":{"type":"boolean"},"ReportDevStatusMargin":{"type":"boolean"},"DrMin":{"type":"integer"},"DrMax":{"type":"integer"},"ChannelMask":{},"PrAllowed":{"type":"boolean"},"HrAllowed":{"type":"boolean"},"RaAllowed":{"type":"boolean"},"NwkGeoLoc":{"type":"boolean"},"TargetPer":{"type":"integer"},"MinGwDiversity":{"type":"integer"}}}}}},"GetWirelessDevice":{"http":{"method":"GET","requestUri":"/wireless-devices/{Identifier}"},"input":{"type":"structure","required":["Identifier","IdentifierType"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"},"IdentifierType":{"location":"querystring","locationName":"identifierType"}}},"output":{"type":"structure","members":{"Type":{},"Name":{},"Description":{},"DestinationName":{},"Id":{},"Arn":{},"ThingName":{},"ThingArn":{},"LoRaWAN":{"shape":"S2r"},"Sidewalk":{"type":"structure","members":{"AmazonId":{},"SidewalkId":{},"SidewalkManufacturingSn":{},"DeviceCertificates":{"shape":"S86"}}}}}},"GetWirelessDeviceStatistics":{"http":{"method":"GET","requestUri":"/wireless-devices/{Id}/statistics","responseCode":200},"input":{"type":"structure","required":["WirelessDeviceId"],"members":{"WirelessDeviceId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"WirelessDeviceId":{},"LastUplinkReceivedAt":{},"LoRaWAN":{"type":"structure","members":{"DevEui":{},"FPort":{"type":"integer"},"DataRate":{"type":"integer"},"Frequency":{"type":"integer"},"Timestamp":{},"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayEui":{},"Snr":{"type":"double"},"Rssi":{"type":"double"}}}}}},"Sidewalk":{"type":"structure","members":{"Rssi":{"type":"integer"},"BatteryLevel":{},"Event":{},"DeviceState":{}}}}}},"GetWirelessGateway":{"http":{"method":"GET","requestUri":"/wireless-gateways/{Identifier}"},"input":{"type":"structure","required":["Identifier","IdentifierType"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"},"IdentifierType":{"location":"querystring","locationName":"identifierType"}}},"output":{"type":"structure","members":{"Name":{},"Id":{},"Description":{},"LoRaWAN":{"shape":"S3h"},"Arn":{},"ThingName":{},"ThingArn":{}}}},"GetWirelessGatewayCertificate":{"http":{"method":"GET","requestUri":"/wireless-gateways/{Id}/certificate"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"IotCertificateId":{},"LoRaWANNetworkServerCertificateId":{}}}},"GetWirelessGatewayFirmwareInformation":{"http":{"method":"GET","requestUri":"/wireless-gateways/{Id}/firmware-information"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"LoRaWAN":{"type":"structure","members":{"CurrentVersion":{"shape":"S43"}}}}}},"GetWirelessGatewayStatistics":{"http":{"method":"GET","requestUri":"/wireless-gateways/{Id}/statistics","responseCode":200},"input":{"type":"structure","required":["WirelessGatewayId"],"members":{"WirelessGatewayId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"WirelessGatewayId":{},"LastUplinkReceivedAt":{},"ConnectionStatus":{}}}},"GetWirelessGatewayTask":{"http":{"method":"GET","requestUri":"/wireless-gateways/{Id}/tasks"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"WirelessGatewayId":{},"WirelessGatewayTaskDefinitionId":{},"LastUplinkReceivedAt":{},"TaskCreatedAt":{},"Status":{}}}},"GetWirelessGatewayTaskDefinition":{"http":{"method":"GET","requestUri":"/wireless-gateway-task-definitions/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"AutoCreateTasks":{"type":"boolean"},"Name":{},"Update":{"shape":"S3y"},"Arn":{}}}},"ListDestinations":{"http":{"method":"GET","requestUri":"/destinations"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"DestinationList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"ExpressionType":{},"Expression":{},"Description":{},"RoleArn":{}}}}}}},"ListDeviceProfiles":{"http":{"method":"GET","requestUri":"/device-profiles"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"DeviceProfileList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"Id":{}}}}}}},"ListEventConfigurations":{"http":{"method":"GET","requestUri":"/event-configurations"},"input":{"type":"structure","required":["ResourceType"],"members":{"ResourceType":{"location":"querystring","locationName":"resourceType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"EventConfigurationsList":{"type":"list","member":{"type":"structure","members":{"Identifier":{},"IdentifierType":{},"PartnerType":{},"Events":{"type":"structure","members":{"DeviceRegistrationState":{"shape":"S6y"},"Proximity":{"shape":"S70"},"Join":{"shape":"S71"},"ConnectionStatus":{"shape":"S73"}}}}}}}}},"ListFuotaTasks":{"http":{"method":"GET","requestUri":"/fuota-tasks"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"FuotaTaskList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}}}}},"ListMulticastGroups":{"http":{"method":"GET","requestUri":"/multicast-groups"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MulticastGroupList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}}}}},"ListMulticastGroupsByFuotaTask":{"http":{"method":"GET","requestUri":"/fuota-tasks/{Id}/multicast-groups"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MulticastGroupList":{"type":"list","member":{"type":"structure","members":{"Id":{}}}}}}},"ListNetworkAnalyzerConfigurations":{"http":{"method":"GET","requestUri":"/network-analyzer-configurations"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"NetworkAnalyzerConfigurationList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}}}}},"ListPartnerAccounts":{"http":{"method":"GET","requestUri":"/partner-accounts"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Sidewalk":{"type":"list","member":{"shape":"S6q"}}}}},"ListQueuedMessages":{"http":{"method":"GET","requestUri":"/wireless-devices/{Id}/data"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"WirelessDeviceType":{"location":"querystring","locationName":"WirelessDeviceType"}}},"output":{"type":"structure","members":{"NextToken":{},"DownlinkQueueMessagesList":{"type":"list","member":{"type":"structure","members":{"MessageId":{},"TransmitMode":{"type":"integer"},"ReceivedAt":{},"LoRaWAN":{"shape":"Sa5"}}}}}}},"ListServiceProfiles":{"http":{"method":"GET","requestUri":"/service-profiles"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"ServiceProfileList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"Id":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"ListWirelessDevices":{"http":{"method":"GET","requestUri":"/wireless-devices"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"DestinationName":{"location":"querystring","locationName":"destinationName"},"DeviceProfileId":{"location":"querystring","locationName":"deviceProfileId"},"ServiceProfileId":{"location":"querystring","locationName":"serviceProfileId"},"WirelessDeviceType":{"location":"querystring","locationName":"wirelessDeviceType"},"FuotaTaskId":{"location":"querystring","locationName":"fuotaTaskId"},"MulticastGroupId":{"location":"querystring","locationName":"multicastGroupId"}}},"output":{"type":"structure","members":{"NextToken":{},"WirelessDeviceList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Id":{},"Type":{},"Name":{},"DestinationName":{},"LastUplinkReceivedAt":{},"LoRaWAN":{"type":"structure","members":{"DevEui":{}}},"Sidewalk":{"type":"structure","members":{"AmazonId":{},"SidewalkId":{},"SidewalkManufacturingSn":{},"DeviceCertificates":{"shape":"S86"}}},"FuotaDeviceStatus":{},"MulticastDeviceStatus":{},"McGroupId":{"type":"integer"}}}}}}},"ListWirelessGatewayTaskDefinitions":{"http":{"method":"GET","requestUri":"/wireless-gateway-task-definitions"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"TaskDefinitionType":{"location":"querystring","locationName":"taskDefinitionType"}}},"output":{"type":"structure","members":{"NextToken":{},"TaskDefinitions":{"type":"list","member":{"type":"structure","members":{"Id":{},"LoRaWAN":{"type":"structure","members":{"CurrentVersion":{"shape":"S43"},"UpdateVersion":{"shape":"S43"}}},"Arn":{}}}}}}},"ListWirelessGateways":{"http":{"method":"GET","requestUri":"/wireless-gateways"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"WirelessGatewayList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Description":{},"LoRaWAN":{"shape":"S3h"},"LastUplinkReceivedAt":{}}}}}}},"PutResourceLogLevel":{"http":{"method":"PUT","requestUri":"/log-levels/{ResourceIdentifier}","responseCode":200},"input":{"type":"structure","required":["ResourceIdentifier","ResourceType","LogLevel"],"members":{"ResourceIdentifier":{"location":"uri","locationName":"ResourceIdentifier"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"LogLevel":{}}},"output":{"type":"structure","members":{}}},"ResetAllResourceLogLevels":{"http":{"method":"DELETE","requestUri":"/log-levels","responseCode":204},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ResetResourceLogLevel":{"http":{"method":"DELETE","requestUri":"/log-levels/{ResourceIdentifier}","responseCode":204},"input":{"type":"structure","required":["ResourceIdentifier","ResourceType"],"members":{"ResourceIdentifier":{"location":"uri","locationName":"ResourceIdentifier"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}},"output":{"type":"structure","members":{}}},"SendDataToMulticastGroup":{"http":{"requestUri":"/multicast-groups/{Id}/data","responseCode":201},"input":{"type":"structure","required":["Id","PayloadData","WirelessMetadata"],"members":{"Id":{"location":"uri","locationName":"Id"},"PayloadData":{},"WirelessMetadata":{"type":"structure","members":{"LoRaWAN":{"type":"structure","members":{"FPort":{"type":"integer"}}}}}}},"output":{"type":"structure","members":{"MessageId":{}}}},"SendDataToWirelessDevice":{"http":{"requestUri":"/wireless-devices/{Id}/data","responseCode":202},"input":{"type":"structure","required":["Id","TransmitMode","PayloadData"],"members":{"Id":{"location":"uri","locationName":"Id"},"TransmitMode":{"type":"integer"},"PayloadData":{},"WirelessMetadata":{"type":"structure","members":{"LoRaWAN":{"shape":"Sa5"},"Sidewalk":{"type":"structure","members":{"Seq":{"type":"integer"},"MessageType":{}}}}}}},"output":{"type":"structure","members":{"MessageId":{}}}},"StartBulkAssociateWirelessDeviceWithMulticastGroup":{"http":{"method":"PATCH","requestUri":"/multicast-groups/{Id}/bulk","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"QueryString":{},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"StartBulkDisassociateWirelessDeviceFromMulticastGroup":{"http":{"requestUri":"/multicast-groups/{Id}/bulk","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"QueryString":{},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"StartFuotaTask":{"http":{"method":"PUT","requestUri":"/fuota-tasks/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"LoRaWAN":{"type":"structure","members":{"StartTime":{"shape":"S5u"}}}}},"output":{"type":"structure","members":{}}},"StartMulticastGroupSession":{"http":{"method":"PUT","requestUri":"/multicast-groups/{Id}/session","responseCode":204},"input":{"type":"structure","required":["Id","LoRaWAN"],"members":{"Id":{"location":"uri","locationName":"Id"},"LoRaWAN":{"shape":"S6h"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"querystring","locationName":"resourceArn"},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"TestWirelessDevice":{"http":{"requestUri":"/wireless-devices/{Id}/test","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Result":{}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"querystring","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDestination":{"http":{"method":"PATCH","requestUri":"/destinations/{Name}","responseCode":204},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"ExpressionType":{},"Expression":{},"Description":{},"RoleArn":{}}},"output":{"type":"structure","members":{}}},"UpdateEventConfigurationByResourceTypes":{"http":{"method":"PATCH","requestUri":"/event-configurations-resource-types","responseCode":204},"input":{"type":"structure","members":{"DeviceRegistrationState":{"shape":"S5i"},"Proximity":{"shape":"S5l"},"Join":{"shape":"S5m"},"ConnectionStatus":{"shape":"S5o"}}},"output":{"type":"structure","members":{}}},"UpdateFuotaTask":{"http":{"method":"PATCH","requestUri":"/fuota-tasks/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"Description":{},"LoRaWAN":{"shape":"S1w"},"FirmwareUpdateImage":{},"FirmwareUpdateRole":{}}},"output":{"type":"structure","members":{}}},"UpdateLogLevelsByResourceTypes":{"http":{"requestUri":"/log-levels","responseCode":200},"input":{"type":"structure","members":{"DefaultLogLevel":{},"WirelessDeviceLogOptions":{"shape":"S64"},"WirelessGatewayLogOptions":{"shape":"S5y"}}},"output":{"type":"structure","members":{}}},"UpdateMulticastGroup":{"http":{"method":"PATCH","requestUri":"/multicast-groups/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"Description":{},"LoRaWAN":{"shape":"S24"}}},"output":{"type":"structure","members":{}}},"UpdateNetworkAnalyzerConfiguration":{"http":{"method":"PATCH","requestUri":"/network-analyzer-configurations/{ConfigurationName}","responseCode":204},"input":{"type":"structure","required":["ConfigurationName"],"members":{"ConfigurationName":{"location":"uri","locationName":"ConfigurationName"},"TraceContent":{"shape":"S2a"},"WirelessDevicesToAdd":{"shape":"S2d"},"WirelessDevicesToRemove":{"shape":"S2d"},"WirelessGatewaysToAdd":{"shape":"S2e"},"WirelessGatewaysToRemove":{"shape":"S2e"},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdatePartnerAccount":{"http":{"method":"PATCH","requestUri":"/partner-accounts/{PartnerAccountId}","responseCode":204},"input":{"type":"structure","required":["Sidewalk","PartnerAccountId","PartnerType"],"members":{"Sidewalk":{"type":"structure","members":{"AppServerPrivateKey":{"shape":"S4"}}},"PartnerAccountId":{"location":"uri","locationName":"PartnerAccountId"},"PartnerType":{"location":"querystring","locationName":"partnerType"}}},"output":{"type":"structure","members":{}}},"UpdateResourceEventConfiguration":{"http":{"method":"PATCH","requestUri":"/event-configurations/{Identifier}","responseCode":204},"input":{"type":"structure","required":["Identifier","IdentifierType"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"},"IdentifierType":{"location":"querystring","locationName":"identifierType"},"PartnerType":{"location":"querystring","locationName":"partnerType"},"DeviceRegistrationState":{"shape":"S6y"},"Proximity":{"shape":"S70"},"Join":{"shape":"S71"},"ConnectionStatus":{"shape":"S73"}}},"output":{"type":"structure","members":{}}},"UpdateWirelessDevice":{"http":{"method":"PATCH","requestUri":"/wireless-devices/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"DestinationName":{},"Name":{},"Description":{},"LoRaWAN":{"type":"structure","members":{"DeviceProfileId":{},"ServiceProfileId":{},"AbpV1_1":{"type":"structure","members":{"FCntStart":{"type":"integer"}}},"AbpV1_0_x":{"type":"structure","members":{"FCntStart":{"type":"integer"}}}}}}},"output":{"type":"structure","members":{}}},"UpdateWirelessGateway":{"http":{"method":"PATCH","requestUri":"/wireless-gateways/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"Description":{},"JoinEuiFilters":{"shape":"S3j"},"NetIdFilters":{"shape":"S3l"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","members":{"AmazonId":{},"AppServerPrivateKey":{"shape":"S4"}}},"S4":{"type":"string","sensitive":true},"S6":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S16":{"type":"structure","members":{"SupportsClassB":{"type":"boolean"},"ClassBTimeout":{"type":"integer"},"PingSlotPeriod":{"type":"integer"},"PingSlotDr":{"type":"integer"},"PingSlotFreq":{"type":"integer"},"SupportsClassC":{"type":"boolean"},"ClassCTimeout":{"type":"integer"},"MacVersion":{},"RegParamsRevision":{},"RxDelay1":{"type":"integer"},"RxDrOffset1":{"type":"integer"},"RxDataRate2":{"type":"integer"},"RxFreq2":{"type":"integer"},"FactoryPresetFreqsList":{"type":"list","member":{"type":"integer"}},"MaxEirp":{"type":"integer"},"MaxDutyCycle":{"type":"integer"},"RfRegion":{},"SupportsJoin":{"type":"boolean"},"Supports32BitFCnt":{"type":"boolean"}}},"S1w":{"type":"structure","members":{"RfRegion":{}}},"S24":{"type":"structure","members":{"RfRegion":{},"DlClass":{}}},"S2a":{"type":"structure","members":{"WirelessDeviceFrameInfo":{},"LogLevel":{}}},"S2d":{"type":"list","member":{}},"S2e":{"type":"list","member":{}},"S2r":{"type":"structure","members":{"DevEui":{},"DeviceProfileId":{},"ServiceProfileId":{},"OtaaV1_1":{"type":"structure","members":{"AppKey":{},"NwkKey":{},"JoinEui":{}}},"OtaaV1_0_x":{"type":"structure","members":{"AppKey":{},"AppEui":{},"GenAppKey":{}}},"AbpV1_1":{"type":"structure","members":{"DevAddr":{},"SessionKeys":{"type":"structure","members":{"FNwkSIntKey":{},"SNwkSIntKey":{},"NwkSEncKey":{},"AppSKey":{}}},"FCntStart":{"type":"integer"}}},"AbpV1_0_x":{"type":"structure","members":{"DevAddr":{},"SessionKeys":{"type":"structure","members":{"NwkSKey":{},"AppSKey":{}}},"FCntStart":{"type":"integer"}}},"FPorts":{"type":"structure","members":{"Fuota":{"type":"integer"},"Multicast":{"type":"integer"},"ClockSync":{"type":"integer"}}}}},"S3h":{"type":"structure","members":{"GatewayEui":{},"RfRegion":{},"JoinEuiFilters":{"shape":"S3j"},"NetIdFilters":{"shape":"S3l"},"SubBands":{"type":"list","member":{"type":"integer"}}}},"S3j":{"type":"list","member":{"type":"list","member":{}}},"S3l":{"type":"list","member":{}},"S3y":{"type":"structure","members":{"UpdateDataSource":{},"UpdateDataRole":{},"LoRaWAN":{"type":"structure","members":{"UpdateSignature":{},"SigKeyCrc":{"type":"long"},"CurrentVersion":{"shape":"S43"},"UpdateVersion":{"shape":"S43"}}}}},"S43":{"type":"structure","members":{"PackageVersion":{},"Model":{},"Station":{}}},"S5i":{"type":"structure","members":{"Sidewalk":{"shape":"S5j"}}},"S5j":{"type":"structure","members":{"WirelessDeviceEventTopic":{}}},"S5l":{"type":"structure","members":{"Sidewalk":{"shape":"S5j"}}},"S5m":{"type":"structure","members":{"LoRaWAN":{"type":"structure","members":{"WirelessDeviceEventTopic":{}}}}},"S5o":{"type":"structure","members":{"LoRaWAN":{"type":"structure","members":{"WirelessGatewayEventTopic":{}}}}},"S5u":{"type":"timestamp","timestampFormat":"iso8601"},"S5y":{"type":"list","member":{"type":"structure","required":["Type","LogLevel"],"members":{"Type":{},"LogLevel":{},"Events":{"type":"list","member":{"type":"structure","required":["Event","LogLevel"],"members":{"Event":{},"LogLevel":{}}}}}}},"S64":{"type":"list","member":{"type":"structure","required":["Type","LogLevel"],"members":{"Type":{},"LogLevel":{},"Events":{"type":"list","member":{"type":"structure","required":["Event","LogLevel"],"members":{"Event":{},"LogLevel":{}}}}}}},"S6h":{"type":"structure","members":{"DlDr":{"type":"integer"},"DlFreq":{"type":"integer"},"SessionStartTime":{"type":"timestamp","timestampFormat":"iso8601"},"SessionTimeout":{"type":"integer"}}},"S6q":{"type":"structure","members":{"AmazonId":{},"Fingerprint":{"type":"string","sensitive":true},"Arn":{}}},"S6y":{"type":"structure","members":{"Sidewalk":{"shape":"S6z"},"WirelessDeviceIdEventTopic":{}}},"S6z":{"type":"structure","members":{"AmazonIdEventTopic":{}}},"S70":{"type":"structure","members":{"Sidewalk":{"shape":"S6z"},"WirelessDeviceIdEventTopic":{}}},"S71":{"type":"structure","members":{"LoRaWAN":{"type":"structure","members":{"DevEuiEventTopic":{}}},"WirelessDeviceIdEventTopic":{}}},"S73":{"type":"structure","members":{"LoRaWAN":{"type":"structure","members":{"GatewayEuiEventTopic":{}}},"WirelessGatewayIdEventTopic":{}}},"S86":{"type":"list","member":{"type":"structure","required":["SigningAlg","Value"],"members":{"SigningAlg":{},"Value":{}}}},"Sa5":{"type":"structure","members":{"FPort":{"type":"integer"}}}}}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDestinations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDeviceProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFuotaTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMulticastGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMulticastGroupsByFuotaTask":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNetworkAnalyzerConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQueuedMessages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListServiceProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWirelessDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWirelessGateways":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['location'] = {};
	AWS.Location = Service.defineService('location', ['2020-11-19']);
	Object.defineProperty(apiLoader.services['location'], '2020-11-19', {
	  get: function get() {
	    var model = __webpack_require__(982);
	    model.paginators = __webpack_require__(983).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Location;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-19","endpointPrefix":"geo","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Location Service","serviceId":"Location","signatureVersion":"v4","signingName":"geo","uid":"location-2020-11-19"},"operations":{"AssociateTrackerConsumer":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/consumers","responseCode":200},"input":{"type":"structure","required":["ConsumerArn","TrackerName"],"members":{"ConsumerArn":{},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"tracking."}},"BatchDeleteDevicePositionHistory":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/delete-positions","responseCode":200},"input":{"type":"structure","required":["DeviceIds","TrackerName"],"members":{"DeviceIds":{"type":"list","member":{}},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error"],"members":{"DeviceId":{},"Error":{"shape":"Sb"}}}}}},"endpoint":{"hostPrefix":"tracking."}},"BatchDeleteGeofence":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/delete-geofences","responseCode":200},"input":{"type":"structure","required":["CollectionName","GeofenceIds"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"GeofenceIds":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["Error","GeofenceId"],"members":{"Error":{"shape":"Sb"},"GeofenceId":{}}}}}},"endpoint":{"hostPrefix":"geofencing."}},"BatchEvaluateGeofences":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/positions","responseCode":200},"input":{"type":"structure","required":["CollectionName","DevicePositionUpdates"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"DevicePositionUpdates":{"type":"list","member":{"shape":"Sl"}}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error","SampleTime"],"members":{"DeviceId":{},"Error":{"shape":"Sb"},"SampleTime":{"shape":"St"}}}}}},"endpoint":{"hostPrefix":"geofencing."}},"BatchGetDevicePosition":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/get-positions","responseCode":200},"input":{"type":"structure","required":["DeviceIds","TrackerName"],"members":{"DeviceIds":{"type":"list","member":{}},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["DevicePositions","Errors"],"members":{"DevicePositions":{"shape":"S11"},"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error"],"members":{"DeviceId":{},"Error":{"shape":"Sb"}}}}}},"endpoint":{"hostPrefix":"tracking."}},"BatchPutGeofence":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/put-geofences","responseCode":200},"input":{"type":"structure","required":["CollectionName","Entries"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"Entries":{"type":"list","member":{"type":"structure","required":["GeofenceId","Geometry"],"members":{"GeofenceId":{},"Geometry":{"shape":"S18"}}}}}},"output":{"type":"structure","required":["Errors","Successes"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["Error","GeofenceId"],"members":{"Error":{"shape":"Sb"},"GeofenceId":{}}}},"Successes":{"type":"list","member":{"type":"structure","required":["CreateTime","GeofenceId","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"UpdateTime":{"shape":"St"}}}}}},"endpoint":{"hostPrefix":"geofencing."}},"BatchUpdateDevicePosition":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/positions","responseCode":200},"input":{"type":"structure","required":["TrackerName","Updates"],"members":{"TrackerName":{"location":"uri","locationName":"TrackerName"},"Updates":{"type":"list","member":{"shape":"Sl"}}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error","SampleTime"],"members":{"DeviceId":{},"Error":{"shape":"Sb"},"SampleTime":{"shape":"St"}}}}}},"endpoint":{"hostPrefix":"tracking."}},"CalculateRoute":{"http":{"requestUri":"/routes/v0/calculators/{CalculatorName}/calculate/route","responseCode":200},"input":{"type":"structure","required":["CalculatorName","DeparturePosition","DestinationPosition"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"},"CarModeOptions":{"shape":"S1m"},"DepartNow":{"type":"boolean"},"DeparturePosition":{"shape":"So"},"DepartureTime":{"shape":"St"},"DestinationPosition":{"shape":"So"},"DistanceUnit":{},"IncludeLegGeometry":{"type":"boolean"},"TravelMode":{},"TruckModeOptions":{"shape":"S1q"},"WaypointPositions":{"type":"list","member":{"shape":"So"}}}},"output":{"type":"structure","required":["Legs","Summary"],"members":{"Legs":{"type":"list","member":{"type":"structure","required":["Distance","DurationSeconds","EndPosition","StartPosition","Steps"],"members":{"Distance":{"type":"double"},"DurationSeconds":{"type":"double"},"EndPosition":{"shape":"So"},"Geometry":{"type":"structure","members":{"LineString":{"type":"list","member":{"shape":"So"}}}},"StartPosition":{"shape":"So"},"Steps":{"type":"list","member":{"type":"structure","required":["Distance","DurationSeconds","EndPosition","StartPosition"],"members":{"Distance":{"type":"double"},"DurationSeconds":{"type":"double"},"EndPosition":{"shape":"So"},"GeometryOffset":{"type":"integer"},"StartPosition":{"shape":"So"}}}}}}},"Summary":{"type":"structure","required":["DataSource","Distance","DistanceUnit","DurationSeconds","RouteBBox"],"members":{"DataSource":{},"Distance":{"type":"double"},"DistanceUnit":{},"DurationSeconds":{"type":"double"},"RouteBBox":{"shape":"S2f"}}}}},"endpoint":{"hostPrefix":"routes."}},"CalculateRouteMatrix":{"http":{"requestUri":"/routes/v0/calculators/{CalculatorName}/calculate/route-matrix","responseCode":200},"input":{"type":"structure","required":["CalculatorName","DeparturePositions","DestinationPositions"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"},"CarModeOptions":{"shape":"S1m"},"DepartNow":{"type":"boolean"},"DeparturePositions":{"type":"list","member":{"shape":"So"}},"DepartureTime":{"shape":"St"},"DestinationPositions":{"type":"list","member":{"shape":"So"}},"DistanceUnit":{},"TravelMode":{},"TruckModeOptions":{"shape":"S1q"}}},"output":{"type":"structure","required":["RouteMatrix","Summary"],"members":{"RouteMatrix":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"Distance":{"type":"double"},"DurationSeconds":{"type":"double"},"Error":{"type":"structure","required":["Code"],"members":{"Code":{},"Message":{}}}}}}},"SnappedDeparturePositions":{"type":"list","member":{"shape":"So"}},"SnappedDestinationPositions":{"type":"list","member":{"shape":"So"}},"Summary":{"type":"structure","required":["DataSource","DistanceUnit","ErrorCount","RouteCount"],"members":{"DataSource":{},"DistanceUnit":{},"ErrorCount":{"type":"integer"},"RouteCount":{"type":"integer"}}}}},"endpoint":{"hostPrefix":"routes."}},"CreateGeofenceCollection":{"http":{"requestUri":"/geofencing/v0/collections","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{},"Description":{},"KmsKeyId":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."},"Tags":{"shape":"S30"}}},"output":{"type":"structure","required":["CollectionArn","CollectionName","CreateTime"],"members":{"CollectionArn":{},"CollectionName":{},"CreateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."},"idempotent":true},"CreateMap":{"http":{"requestUri":"/maps/v0/maps","responseCode":200},"input":{"type":"structure","required":["Configuration","MapName"],"members":{"Configuration":{"shape":"S35"},"Description":{},"MapName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"Tags":{"shape":"S30"}}},"output":{"type":"structure","required":["CreateTime","MapArn","MapName"],"members":{"CreateTime":{"shape":"St"},"MapArn":{},"MapName":{}}},"endpoint":{"hostPrefix":"maps."},"idempotent":true},"CreatePlaceIndex":{"http":{"requestUri":"/places/v0/indexes","responseCode":200},"input":{"type":"structure","required":["DataSource","IndexName"],"members":{"DataSource":{},"DataSourceConfiguration":{"shape":"S39"},"Description":{},"IndexName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"Tags":{"shape":"S30"}}},"output":{"type":"structure","required":["CreateTime","IndexArn","IndexName"],"members":{"CreateTime":{"shape":"St"},"IndexArn":{},"IndexName":{}}},"endpoint":{"hostPrefix":"places."},"idempotent":true},"CreateRouteCalculator":{"http":{"requestUri":"/routes/v0/calculators","responseCode":200},"input":{"type":"structure","required":["CalculatorName","DataSource"],"members":{"CalculatorName":{},"DataSource":{},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"Tags":{"shape":"S30"}}},"output":{"type":"structure","required":["CalculatorArn","CalculatorName","CreateTime"],"members":{"CalculatorArn":{},"CalculatorName":{},"CreateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"routes."},"idempotent":true},"CreateTracker":{"http":{"requestUri":"/tracking/v0/trackers","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"Description":{},"KmsKeyId":{},"PositionFiltering":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."},"Tags":{"shape":"S30"},"TrackerName":{}}},"output":{"type":"structure","required":["CreateTime","TrackerArn","TrackerName"],"members":{"CreateTime":{"shape":"St"},"TrackerArn":{},"TrackerName":{}}},"endpoint":{"hostPrefix":"tracking."},"idempotent":true},"DeleteGeofenceCollection":{"http":{"method":"DELETE","requestUri":"/geofencing/v0/collections/{CollectionName}","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"geofencing."},"idempotent":true},"DeleteMap":{"http":{"method":"DELETE","requestUri":"/maps/v0/maps/{MapName}","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"maps."},"idempotent":true},"DeletePlaceIndex":{"http":{"method":"DELETE","requestUri":"/places/v0/indexes/{IndexName}","responseCode":200},"input":{"type":"structure","required":["IndexName"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"places."},"idempotent":true},"DeleteRouteCalculator":{"http":{"method":"DELETE","requestUri":"/routes/v0/calculators/{CalculatorName}","responseCode":200},"input":{"type":"structure","required":["CalculatorName"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"routes."},"idempotent":true},"DeleteTracker":{"http":{"method":"DELETE","requestUri":"/tracking/v0/trackers/{TrackerName}","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"tracking."},"idempotent":true},"DescribeGeofenceCollection":{"http":{"method":"GET","requestUri":"/geofencing/v0/collections/{CollectionName}","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"}}},"output":{"type":"structure","required":["CollectionArn","CollectionName","CreateTime","Description","UpdateTime"],"members":{"CollectionArn":{},"CollectionName":{},"CreateTime":{"shape":"St"},"Description":{},"KmsKeyId":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"Tags":{"shape":"S30"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."}},"DescribeMap":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","required":["Configuration","CreateTime","DataSource","Description","MapArn","MapName","UpdateTime"],"members":{"Configuration":{"shape":"S35"},"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"MapArn":{},"MapName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"Tags":{"shape":"S30"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"maps."}},"DescribePlaceIndex":{"http":{"method":"GET","requestUri":"/places/v0/indexes/{IndexName}","responseCode":200},"input":{"type":"structure","required":["IndexName"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"}}},"output":{"type":"structure","required":["CreateTime","DataSource","DataSourceConfiguration","Description","IndexArn","IndexName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"DataSource":{},"DataSourceConfiguration":{"shape":"S39"},"Description":{},"IndexArn":{},"IndexName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"Tags":{"shape":"S30"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"places."}},"DescribeRouteCalculator":{"http":{"method":"GET","requestUri":"/routes/v0/calculators/{CalculatorName}","responseCode":200},"input":{"type":"structure","required":["CalculatorName"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"}}},"output":{"type":"structure","required":["CalculatorArn","CalculatorName","CreateTime","DataSource","Description","UpdateTime"],"members":{"CalculatorArn":{},"CalculatorName":{},"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"Tags":{"shape":"S30"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"routes."}},"DescribeTracker":{"http":{"method":"GET","requestUri":"/tracking/v0/trackers/{TrackerName}","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["CreateTime","Description","TrackerArn","TrackerName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"Description":{},"KmsKeyId":{},"PositionFiltering":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"Tags":{"shape":"S30"},"TrackerArn":{},"TrackerName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"tracking."}},"DisassociateTrackerConsumer":{"http":{"method":"DELETE","requestUri":"/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}","responseCode":200},"input":{"type":"structure","required":["ConsumerArn","TrackerName"],"members":{"ConsumerArn":{"location":"uri","locationName":"ConsumerArn"},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"tracking."}},"GetDevicePosition":{"http":{"method":"GET","requestUri":"/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest","responseCode":200},"input":{"type":"structure","required":["DeviceId","TrackerName"],"members":{"DeviceId":{"location":"uri","locationName":"DeviceId"},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["Position","ReceivedTime","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"ReceivedTime":{"shape":"St"},"SampleTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"tracking."}},"GetDevicePositionHistory":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions","responseCode":200},"input":{"type":"structure","required":["DeviceId","TrackerName"],"members":{"DeviceId":{"location":"uri","locationName":"DeviceId"},"EndTimeExclusive":{"shape":"St"},"MaxResults":{"type":"integer"},"NextToken":{},"StartTimeInclusive":{"shape":"St"},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["DevicePositions"],"members":{"DevicePositions":{"shape":"S11"},"NextToken":{}}},"endpoint":{"hostPrefix":"tracking."}},"GetGeofence":{"http":{"method":"GET","requestUri":"/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}","responseCode":200},"input":{"type":"structure","required":["CollectionName","GeofenceId"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"GeofenceId":{"location":"uri","locationName":"GeofenceId"}}},"output":{"type":"structure","required":["CreateTime","GeofenceId","Geometry","Status","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"Geometry":{"shape":"S18"},"Status":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."}},"GetMapGlyphs":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}","responseCode":200},"input":{"type":"structure","required":["FontStack","FontUnicodeRange","MapName"],"members":{"FontStack":{"location":"uri","locationName":"FontStack"},"FontUnicodeRange":{"location":"uri","locationName":"FontUnicodeRange"},"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetMapSprites":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/sprites/{FileName}","responseCode":200},"input":{"type":"structure","required":["FileName","MapName"],"members":{"FileName":{"location":"uri","locationName":"FileName"},"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetMapStyleDescriptor":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/style-descriptor","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetMapTile":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}","responseCode":200},"input":{"type":"structure","required":["MapName","X","Y","Z"],"members":{"MapName":{"location":"uri","locationName":"MapName"},"X":{"location":"uri","locationName":"X"},"Y":{"location":"uri","locationName":"Y"},"Z":{"location":"uri","locationName":"Z"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"ListDevicePositions":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/list-positions","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["DeviceId","Position","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"SampleTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"tracking."}},"ListGeofenceCollections":{"http":{"requestUri":"/geofencing/v0/list-collections","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CollectionName","CreateTime","Description","UpdateTime"],"members":{"CollectionName":{},"CreateTime":{"shape":"St"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"geofencing."}},"ListGeofences":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/list-geofences","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","GeofenceId","Geometry","Status","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"Geometry":{"shape":"S18"},"Status":{},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"geofencing."}},"ListMaps":{"http":{"requestUri":"/maps/v0/list-maps","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","DataSource","Description","MapName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"MapName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"maps."}},"ListPlaceIndexes":{"http":{"requestUri":"/places/v0/list-indexes","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","DataSource","Description","IndexName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"IndexName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"places."}},"ListRouteCalculators":{"http":{"requestUri":"/routes/v0/list-calculators","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CalculatorName","CreateTime","DataSource","Description","UpdateTime"],"members":{"CalculatorName":{},"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"routes."}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S30"}}},"endpoint":{"hostPrefix":"metadata."}},"ListTrackerConsumers":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/list-consumers","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["ConsumerArns"],"members":{"ConsumerArns":{"type":"list","member":{}},"NextToken":{}}},"endpoint":{"hostPrefix":"tracking."}},"ListTrackers":{"http":{"requestUri":"/tracking/v0/list-trackers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","Description","TrackerName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"TrackerName":{},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"tracking."}},"PutGeofence":{"http":{"method":"PUT","requestUri":"/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}","responseCode":200},"input":{"type":"structure","required":["CollectionName","GeofenceId","Geometry"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"GeofenceId":{"location":"uri","locationName":"GeofenceId"},"Geometry":{"shape":"S18"}}},"output":{"type":"structure","required":["CreateTime","GeofenceId","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."}},"SearchPlaceIndexForPosition":{"http":{"requestUri":"/places/v0/indexes/{IndexName}/search/position","responseCode":200},"input":{"type":"structure","required":["IndexName","Position"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"},"Language":{},"MaxResults":{"type":"integer"},"Position":{"shape":"So"}}},"output":{"type":"structure","required":["Results","Summary"],"members":{"Results":{"type":"list","member":{"type":"structure","required":["Distance","Place"],"members":{"Distance":{"type":"double"},"Place":{"shape":"S62"}}}},"Summary":{"type":"structure","required":["DataSource","Position"],"members":{"DataSource":{},"Language":{},"MaxResults":{"type":"integer"},"Position":{"shape":"So"}}}}},"endpoint":{"hostPrefix":"places."}},"SearchPlaceIndexForSuggestions":{"http":{"requestUri":"/places/v0/indexes/{IndexName}/search/suggestions","responseCode":200},"input":{"type":"structure","required":["IndexName","Text"],"members":{"BiasPosition":{"shape":"So"},"FilterBBox":{"shape":"S2f"},"FilterCountries":{"shape":"S68"},"IndexName":{"location":"uri","locationName":"IndexName"},"Language":{},"MaxResults":{"type":"integer"},"Text":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["Results","Summary"],"members":{"Results":{"type":"list","member":{"type":"structure","required":["Text"],"members":{"Text":{}}}},"Summary":{"type":"structure","required":["DataSource","Text"],"members":{"BiasPosition":{"shape":"So"},"DataSource":{},"FilterBBox":{"shape":"S2f"},"FilterCountries":{"shape":"S68"},"Language":{},"MaxResults":{"type":"integer"},"Text":{"type":"string","sensitive":true}}}}},"endpoint":{"hostPrefix":"places."}},"SearchPlaceIndexForText":{"http":{"requestUri":"/places/v0/indexes/{IndexName}/search/text","responseCode":200},"input":{"type":"structure","required":["IndexName","Text"],"members":{"BiasPosition":{"shape":"So"},"FilterBBox":{"shape":"S2f"},"FilterCountries":{"shape":"S68"},"IndexName":{"location":"uri","locationName":"IndexName"},"Language":{},"MaxResults":{"type":"integer"},"Text":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["Results","Summary"],"members":{"Results":{"type":"list","member":{"type":"structure","required":["Place"],"members":{"Distance":{"type":"double"},"Place":{"shape":"S62"},"Relevance":{"type":"double"}}}},"Summary":{"type":"structure","required":["DataSource","Text"],"members":{"BiasPosition":{"shape":"So"},"DataSource":{},"FilterBBox":{"shape":"S2f"},"FilterCountries":{"shape":"S68"},"Language":{},"MaxResults":{"type":"integer"},"ResultBBox":{"shape":"S2f"},"Text":{"type":"string","sensitive":true}}}}},"endpoint":{"hostPrefix":"places."}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S30"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"metadata."}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"metadata."},"idempotent":true},"UpdateGeofenceCollection":{"http":{"method":"PATCH","requestUri":"/geofencing/v0/collections/{CollectionName}","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."}}},"output":{"type":"structure","required":["CollectionArn","CollectionName","UpdateTime"],"members":{"CollectionArn":{},"CollectionName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."},"idempotent":true},"UpdateMap":{"http":{"method":"PATCH","requestUri":"/maps/v0/maps/{MapName}","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"Description":{},"MapName":{"location":"uri","locationName":"MapName"},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."}}},"output":{"type":"structure","required":["MapArn","MapName","UpdateTime"],"members":{"MapArn":{},"MapName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"maps."},"idempotent":true},"UpdatePlaceIndex":{"http":{"method":"PATCH","requestUri":"/places/v0/indexes/{IndexName}","responseCode":200},"input":{"type":"structure","required":["IndexName"],"members":{"DataSourceConfiguration":{"shape":"S39"},"Description":{},"IndexName":{"location":"uri","locationName":"IndexName"},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."}}},"output":{"type":"structure","required":["IndexArn","IndexName","UpdateTime"],"members":{"IndexArn":{},"IndexName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"places."},"idempotent":true},"UpdateRouteCalculator":{"http":{"method":"PATCH","requestUri":"/routes/v0/calculators/{CalculatorName}","responseCode":200},"input":{"type":"structure","required":["CalculatorName"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."}}},"output":{"type":"structure","required":["CalculatorArn","CalculatorName","UpdateTime"],"members":{"CalculatorArn":{},"CalculatorName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"routes."},"idempotent":true},"UpdateTracker":{"http":{"method":"PATCH","requestUri":"/tracking/v0/trackers/{TrackerName}","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"Description":{},"PositionFiltering":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["TrackerArn","TrackerName","UpdateTime"],"members":{"TrackerArn":{},"TrackerName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"tracking."},"idempotent":true}},"shapes":{"Sb":{"type":"structure","members":{"Code":{},"Message":{}}},"Sl":{"type":"structure","required":["DeviceId","Position","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"SampleTime":{"shape":"St"}}},"Sm":{"type":"structure","required":["Horizontal"],"members":{"Horizontal":{"type":"double"}}},"So":{"type":"list","member":{"type":"double"},"sensitive":true},"Sq":{"type":"map","key":{},"value":{},"sensitive":true},"St":{"type":"timestamp","timestampFormat":"iso8601"},"S11":{"type":"list","member":{"type":"structure","required":["Position","ReceivedTime","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"ReceivedTime":{"shape":"St"},"SampleTime":{"shape":"St"}}}},"S18":{"type":"structure","members":{"Polygon":{"type":"list","member":{"type":"list","member":{"shape":"So"}}}}},"S1m":{"type":"structure","members":{"AvoidFerries":{"type":"boolean"},"AvoidTolls":{"type":"boolean"}}},"S1q":{"type":"structure","members":{"AvoidFerries":{"type":"boolean"},"AvoidTolls":{"type":"boolean"},"Dimensions":{"type":"structure","members":{"Height":{"type":"double"},"Length":{"type":"double"},"Unit":{},"Width":{"type":"double"}}},"Weight":{"type":"structure","members":{"Total":{"type":"double"},"Unit":{}}}}},"S2f":{"type":"list","member":{"type":"double"},"sensitive":true},"S30":{"type":"map","key":{},"value":{}},"S35":{"type":"structure","required":["Style"],"members":{"Style":{}}},"S39":{"type":"structure","members":{"IntendedUse":{}}},"S62":{"type":"structure","required":["Geometry"],"members":{"AddressNumber":{},"Country":{},"Geometry":{"type":"structure","members":{"Point":{"shape":"So"}}},"Interpolated":{"type":"boolean"},"Label":{},"Municipality":{},"Neighborhood":{},"PostalCode":{},"Region":{},"Street":{},"SubRegion":{},"TimeZone":{"type":"structure","required":["Name"],"members":{"Name":{},"Offset":{"type":"integer"}}}}},"S68":{"type":"list","member":{}}}}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetDevicePositionHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DevicePositions"},"ListDevicePositions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListGeofenceCollections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListGeofences":{"input_token":"NextToken","output_token":"NextToken","result_key":"Entries"},"ListMaps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListPlaceIndexes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListRouteCalculators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListTrackerConsumers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ConsumerArns"},"ListTrackers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"}}}

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['wellarchitected'] = {};
	AWS.WellArchitected = Service.defineService('wellarchitected', ['2020-03-31']);
	Object.defineProperty(apiLoader.services['wellarchitected'], '2020-03-31', {
	  get: function get() {
	    var model = __webpack_require__(985);
	    model.paginators = __webpack_require__(986).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WellArchitected;


/***/ }),
/* 985 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-03-31","endpointPrefix":"wellarchitected","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Well-Architected","serviceFullName":"AWS Well-Architected Tool","serviceId":"WellArchitected","signatureVersion":"v4","signingName":"wellarchitected","uid":"wellarchitected-2020-03-31"},"operations":{"AssociateLenses":{"http":{"method":"PATCH","requestUri":"/workloads/{WorkloadId}/associateLenses"},"input":{"type":"structure","required":["WorkloadId","LensAliases"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAliases":{"shape":"S3"}}}},"CreateLensShare":{"http":{"requestUri":"/lenses/{LensAlias}/shares"},"input":{"type":"structure","required":["LensAlias","SharedWith","ClientRequestToken"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"SharedWith":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ShareId":{}}}},"CreateLensVersion":{"http":{"requestUri":"/lenses/{LensAlias}/versions"},"input":{"type":"structure","required":["LensAlias","LensVersion","ClientRequestToken"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"LensVersion":{},"IsMajorVersion":{"type":"boolean"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"LensArn":{},"LensVersion":{}}}},"CreateMilestone":{"http":{"requestUri":"/workloads/{WorkloadId}/milestones"},"input":{"type":"structure","required":["WorkloadId","MilestoneName","ClientRequestToken"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"MilestoneName":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"}}}},"CreateWorkload":{"http":{"requestUri":"/workloads"},"input":{"type":"structure","required":["WorkloadName","Description","Environment","ReviewOwner","Lenses","ClientRequestToken"],"members":{"WorkloadName":{},"Description":{},"Environment":{},"AccountIds":{"shape":"Sn"},"AwsRegions":{"shape":"Sp"},"NonAwsRegions":{"shape":"Sr"},"PillarPriorities":{"shape":"St"},"ArchitecturalDesign":{},"ReviewOwner":{},"IndustryType":{},"Industry":{},"Lenses":{"shape":"Sz"},"Notes":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S11"}}},"output":{"type":"structure","members":{"WorkloadId":{},"WorkloadArn":{}}}},"CreateWorkloadShare":{"http":{"requestUri":"/workloads/{WorkloadId}/shares"},"input":{"type":"structure","required":["WorkloadId","SharedWith","PermissionType","ClientRequestToken"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"SharedWith":{},"PermissionType":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WorkloadId":{},"ShareId":{}}}},"DeleteLens":{"http":{"method":"DELETE","requestUri":"/lenses/{LensAlias}"},"input":{"type":"structure","required":["LensAlias","ClientRequestToken","LensStatus"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"ClientRequestToken":{"idempotencyToken":true,"location":"querystring","locationName":"ClientRequestToken"},"LensStatus":{"location":"querystring","locationName":"LensStatus"}}}},"DeleteLensShare":{"http":{"method":"DELETE","requestUri":"/lenses/{LensAlias}/shares/{ShareId}"},"input":{"type":"structure","required":["ShareId","LensAlias","ClientRequestToken"],"members":{"ShareId":{"location":"uri","locationName":"ShareId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"ClientRequestToken":{"idempotencyToken":true,"location":"querystring","locationName":"ClientRequestToken"}}}},"DeleteWorkload":{"http":{"method":"DELETE","requestUri":"/workloads/{WorkloadId}"},"input":{"type":"structure","required":["WorkloadId","ClientRequestToken"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"ClientRequestToken":{"idempotencyToken":true,"location":"querystring","locationName":"ClientRequestToken"}}}},"DeleteWorkloadShare":{"http":{"method":"DELETE","requestUri":"/workloads/{WorkloadId}/shares/{ShareId}"},"input":{"type":"structure","required":["ShareId","WorkloadId","ClientRequestToken"],"members":{"ShareId":{"location":"uri","locationName":"ShareId"},"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"ClientRequestToken":{"idempotencyToken":true,"location":"querystring","locationName":"ClientRequestToken"}}}},"DisassociateLenses":{"http":{"method":"PATCH","requestUri":"/workloads/{WorkloadId}/disassociateLenses"},"input":{"type":"structure","required":["WorkloadId","LensAliases"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAliases":{"shape":"S3"}}}},"ExportLens":{"http":{"method":"GET","requestUri":"/lenses/{LensAlias}/export"},"input":{"type":"structure","required":["LensAlias"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"LensVersion":{"location":"querystring","locationName":"LensVersion"}}},"output":{"type":"structure","members":{"LensJSON":{}}}},"GetAnswer":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}/answers/{QuestionId}"},"input":{"type":"structure","required":["WorkloadId","LensAlias","QuestionId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"QuestionId":{"location":"uri","locationName":"QuestionId"},"MilestoneNumber":{"location":"querystring","locationName":"MilestoneNumber","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"},"LensAlias":{},"LensArn":{},"Answer":{"shape":"S1l"}}}},"GetLens":{"http":{"method":"GET","requestUri":"/lenses/{LensAlias}"},"input":{"type":"structure","required":["LensAlias"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"LensVersion":{"location":"querystring","locationName":"LensVersion"}}},"output":{"type":"structure","members":{"Lens":{"type":"structure","members":{"LensArn":{},"LensVersion":{},"Name":{},"Description":{},"Owner":{},"ShareInvitationId":{}}}}}},"GetLensReview":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}"},"input":{"type":"structure","required":["WorkloadId","LensAlias"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"MilestoneNumber":{"location":"querystring","locationName":"MilestoneNumber","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"},"LensReview":{"shape":"S2h"}}}},"GetLensReviewReport":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}/report"},"input":{"type":"structure","required":["WorkloadId","LensAlias"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"MilestoneNumber":{"location":"querystring","locationName":"MilestoneNumber","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"},"LensReviewReport":{"type":"structure","members":{"LensAlias":{},"LensArn":{},"Base64String":{}}}}}},"GetLensVersionDifference":{"http":{"method":"GET","requestUri":"/lenses/{LensAlias}/versionDifference"},"input":{"type":"structure","required":["LensAlias"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"BaseLensVersion":{"location":"querystring","locationName":"BaseLensVersion"},"TargetLensVersion":{"location":"querystring","locationName":"TargetLensVersion"}}},"output":{"type":"structure","members":{"LensAlias":{},"LensArn":{},"BaseLensVersion":{},"TargetLensVersion":{},"LatestLensVersion":{},"VersionDifferences":{"type":"structure","members":{"PillarDifferences":{"type":"list","member":{"type":"structure","members":{"PillarId":{},"PillarName":{},"DifferenceStatus":{},"QuestionDifferences":{"type":"list","member":{"type":"structure","members":{"QuestionId":{},"QuestionTitle":{},"DifferenceStatus":{}}}}}}}}}}}},"GetMilestone":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/milestones/{MilestoneNumber}"},"input":{"type":"structure","required":["WorkloadId","MilestoneNumber"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"MilestoneNumber":{"location":"uri","locationName":"MilestoneNumber","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"Milestone":{"type":"structure","members":{"MilestoneNumber":{"type":"integer"},"MilestoneName":{},"RecordedAt":{"type":"timestamp"},"Workload":{"shape":"S35"}}}}}},"GetWorkload":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}"},"input":{"type":"structure","required":["WorkloadId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"}}},"output":{"type":"structure","members":{"Workload":{"shape":"S35"}}}},"ImportLens":{"http":{"method":"PUT","requestUri":"/importLens"},"input":{"type":"structure","required":["JSONString","ClientRequestToken"],"members":{"LensAlias":{},"JSONString":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S11"}}},"output":{"type":"structure","members":{"LensArn":{},"Status":{}}}},"ListAnswers":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}/answers"},"input":{"type":"structure","required":["WorkloadId","LensAlias"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"PillarId":{"location":"querystring","locationName":"PillarId"},"MilestoneNumber":{"location":"querystring","locationName":"MilestoneNumber","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"},"LensAlias":{},"LensArn":{},"AnswerSummaries":{"type":"list","member":{"type":"structure","members":{"QuestionId":{},"PillarId":{},"QuestionTitle":{},"Choices":{"shape":"S1r"},"SelectedChoices":{"shape":"S1z"},"ChoiceAnswerSummaries":{"type":"list","member":{"type":"structure","members":{"ChoiceId":{},"Status":{},"Reason":{}}}},"IsApplicable":{"type":"boolean"},"Risk":{},"Reason":{}}}},"NextToken":{}}}},"ListLensReviewImprovements":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}/improvements"},"input":{"type":"structure","required":["WorkloadId","LensAlias"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"PillarId":{"location":"querystring","locationName":"PillarId"},"MilestoneNumber":{"location":"querystring","locationName":"MilestoneNumber","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"},"LensAlias":{},"LensArn":{},"ImprovementSummaries":{"type":"list","member":{"type":"structure","members":{"QuestionId":{},"PillarId":{},"QuestionTitle":{},"Risk":{},"ImprovementPlanUrl":{},"ImprovementPlans":{"type":"list","member":{"type":"structure","members":{"ChoiceId":{},"DisplayText":{},"ImprovementPlanUrl":{}}}}}}},"NextToken":{}}}},"ListLensReviews":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/lensReviews"},"input":{"type":"structure","required":["WorkloadId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"MilestoneNumber":{"location":"querystring","locationName":"MilestoneNumber","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneNumber":{"type":"integer"},"LensReviewSummaries":{"type":"list","member":{"type":"structure","members":{"LensAlias":{},"LensArn":{},"LensVersion":{},"LensName":{},"LensStatus":{},"UpdatedAt":{"type":"timestamp"},"RiskCounts":{"shape":"S2m"}}}},"NextToken":{}}}},"ListLensShares":{"http":{"method":"GET","requestUri":"/lenses/{LensAlias}/shares"},"input":{"type":"structure","required":["LensAlias"],"members":{"LensAlias":{"location":"uri","locationName":"LensAlias"},"SharedWithPrefix":{"location":"querystring","locationName":"SharedWithPrefix"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"LensShareSummaries":{"type":"list","member":{"type":"structure","members":{"ShareId":{},"SharedWith":{},"Status":{}}}},"NextToken":{}}}},"ListLenses":{"http":{"method":"GET","requestUri":"/lenses"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"LensType":{"location":"querystring","locationName":"LensType"},"LensStatus":{"location":"querystring","locationName":"LensStatus"},"LensName":{"location":"querystring","locationName":"LensName"}}},"output":{"type":"structure","members":{"LensSummaries":{"type":"list","member":{"type":"structure","members":{"LensArn":{},"LensAlias":{},"LensName":{},"LensType":{},"Description":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"LensVersion":{},"Owner":{},"LensStatus":{}}}},"NextToken":{}}}},"ListMilestones":{"http":{"requestUri":"/workloads/{WorkloadId}/milestonesSummaries"},"input":{"type":"structure","required":["WorkloadId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"MilestoneSummaries":{"type":"list","member":{"type":"structure","members":{"MilestoneNumber":{"type":"integer"},"MilestoneName":{},"RecordedAt":{"type":"timestamp"},"WorkloadSummary":{"shape":"S4c"}}}},"NextToken":{}}}},"ListNotifications":{"http":{"requestUri":"/notifications"},"input":{"type":"structure","members":{"WorkloadId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NotificationSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"LensUpgradeSummary":{"type":"structure","members":{"WorkloadId":{},"WorkloadName":{},"LensAlias":{},"LensArn":{},"CurrentLensVersion":{},"LatestLensVersion":{}}}}}},"NextToken":{}}}},"ListShareInvitations":{"http":{"method":"GET","requestUri":"/shareInvitations"},"input":{"type":"structure","members":{"WorkloadNamePrefix":{"location":"querystring","locationName":"WorkloadNamePrefix"},"LensNamePrefix":{"location":"querystring","locationName":"LensNamePrefix"},"ShareResourceType":{"location":"querystring","locationName":"ShareResourceType"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"ShareInvitationSummaries":{"type":"list","member":{"type":"structure","members":{"ShareInvitationId":{},"SharedBy":{},"SharedWith":{},"PermissionType":{},"ShareResourceType":{},"WorkloadName":{},"WorkloadId":{},"LensName":{},"LensArn":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{WorkloadArn}"},"input":{"type":"structure","required":["WorkloadArn"],"members":{"WorkloadArn":{"location":"uri","locationName":"WorkloadArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S11"}}}},"ListWorkloadShares":{"http":{"method":"GET","requestUri":"/workloads/{WorkloadId}/shares"},"input":{"type":"structure","required":["WorkloadId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"SharedWithPrefix":{"location":"querystring","locationName":"SharedWithPrefix"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"WorkloadId":{},"WorkloadShareSummaries":{"type":"list","member":{"type":"structure","members":{"ShareId":{},"SharedWith":{},"PermissionType":{},"Status":{}}}},"NextToken":{}}}},"ListWorkloads":{"http":{"requestUri":"/workloadsSummaries"},"input":{"type":"structure","members":{"WorkloadNamePrefix":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WorkloadSummaries":{"type":"list","member":{"shape":"S4c"}},"NextToken":{}}}},"TagResource":{"http":{"requestUri":"/tags/{WorkloadArn}"},"input":{"type":"structure","required":["WorkloadArn","Tags"],"members":{"WorkloadArn":{"location":"uri","locationName":"WorkloadArn"},"Tags":{"shape":"S11"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{WorkloadArn}"},"input":{"type":"structure","required":["WorkloadArn","TagKeys"],"members":{"WorkloadArn":{"location":"uri","locationName":"WorkloadArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAnswer":{"http":{"method":"PATCH","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}/answers/{QuestionId}"},"input":{"type":"structure","required":["WorkloadId","LensAlias","QuestionId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"QuestionId":{"location":"uri","locationName":"QuestionId"},"SelectedChoices":{"shape":"S1z"},"ChoiceUpdates":{"type":"map","key":{},"value":{"type":"structure","required":["Status"],"members":{"Status":{},"Reason":{},"Notes":{}}}},"Notes":{},"IsApplicable":{"type":"boolean"},"Reason":{}}},"output":{"type":"structure","members":{"WorkloadId":{},"LensAlias":{},"LensArn":{},"Answer":{"shape":"S1l"}}}},"UpdateLensReview":{"http":{"method":"PATCH","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}"},"input":{"type":"structure","required":["WorkloadId","LensAlias"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"LensNotes":{},"PillarNotes":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"WorkloadId":{},"LensReview":{"shape":"S2h"}}}},"UpdateShareInvitation":{"http":{"method":"PATCH","requestUri":"/shareInvitations/{ShareInvitationId}"},"input":{"type":"structure","required":["ShareInvitationId","ShareInvitationAction"],"members":{"ShareInvitationId":{"location":"uri","locationName":"ShareInvitationId"},"ShareInvitationAction":{}}},"output":{"type":"structure","members":{"ShareInvitation":{"type":"structure","members":{"ShareInvitationId":{},"ShareResourceType":{},"WorkloadId":{},"LensAlias":{},"LensArn":{}}}}}},"UpdateWorkload":{"http":{"method":"PATCH","requestUri":"/workloads/{WorkloadId}"},"input":{"type":"structure","required":["WorkloadId"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"WorkloadName":{},"Description":{},"Environment":{},"AccountIds":{"shape":"Sn"},"AwsRegions":{"shape":"Sp"},"NonAwsRegions":{"shape":"Sr"},"PillarPriorities":{"shape":"St"},"ArchitecturalDesign":{},"ReviewOwner":{},"IsReviewOwnerUpdateAcknowledged":{"type":"boolean"},"IndustryType":{},"Industry":{},"Notes":{},"ImprovementStatus":{}}},"output":{"type":"structure","members":{"Workload":{"shape":"S35"}}}},"UpdateWorkloadShare":{"http":{"method":"PATCH","requestUri":"/workloads/{WorkloadId}/shares/{ShareId}"},"input":{"type":"structure","required":["ShareId","WorkloadId","PermissionType"],"members":{"ShareId":{"location":"uri","locationName":"ShareId"},"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"PermissionType":{}}},"output":{"type":"structure","members":{"WorkloadId":{},"WorkloadShare":{"type":"structure","members":{"ShareId":{},"SharedBy":{},"SharedWith":{},"PermissionType":{},"Status":{},"WorkloadName":{},"WorkloadId":{}}}}}},"UpgradeLensReview":{"http":{"method":"PUT","requestUri":"/workloads/{WorkloadId}/lensReviews/{LensAlias}/upgrade"},"input":{"type":"structure","required":["WorkloadId","LensAlias","MilestoneName"],"members":{"WorkloadId":{"location":"uri","locationName":"WorkloadId"},"LensAlias":{"location":"uri","locationName":"LensAlias"},"MilestoneName":{},"ClientRequestToken":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"Sn":{"type":"list","member":{}},"Sp":{"type":"list","member":{}},"Sr":{"type":"list","member":{}},"St":{"type":"list","member":{}},"Sz":{"type":"list","member":{}},"S11":{"type":"map","key":{},"value":{}},"S1l":{"type":"structure","members":{"QuestionId":{},"PillarId":{},"QuestionTitle":{},"QuestionDescription":{},"ImprovementPlanUrl":{},"HelpfulResourceUrl":{},"HelpfulResourceDisplayText":{},"Choices":{"shape":"S1r"},"SelectedChoices":{"shape":"S1z"},"ChoiceAnswers":{"type":"list","member":{"type":"structure","members":{"ChoiceId":{},"Status":{},"Reason":{},"Notes":{}}}},"IsApplicable":{"type":"boolean"},"Risk":{},"Notes":{},"Reason":{}}},"S1r":{"type":"list","member":{"type":"structure","members":{"ChoiceId":{},"Title":{},"Description":{},"HelpfulResource":{"shape":"S1w"},"ImprovementPlan":{"shape":"S1w"}}}},"S1w":{"type":"structure","members":{"DisplayText":{},"Url":{}}},"S1z":{"type":"list","member":{}},"S2h":{"type":"structure","members":{"LensAlias":{},"LensArn":{},"LensVersion":{},"LensName":{},"LensStatus":{},"PillarReviewSummaries":{"type":"list","member":{"type":"structure","members":{"PillarId":{},"PillarName":{},"Notes":{},"RiskCounts":{"shape":"S2m"}}}},"UpdatedAt":{"type":"timestamp"},"Notes":{},"RiskCounts":{"shape":"S2m"},"NextToken":{}}},"S2m":{"type":"map","key":{},"value":{"type":"integer"}},"S35":{"type":"structure","members":{"WorkloadId":{},"WorkloadArn":{},"WorkloadName":{},"Description":{},"Environment":{},"UpdatedAt":{"type":"timestamp"},"AccountIds":{"shape":"Sn"},"AwsRegions":{"shape":"Sp"},"NonAwsRegions":{"shape":"Sr"},"ArchitecturalDesign":{},"ReviewOwner":{},"ReviewRestrictionDate":{"type":"timestamp"},"IsReviewOwnerUpdateAcknowledged":{"type":"boolean"},"IndustryType":{},"Industry":{},"Notes":{},"ImprovementStatus":{},"RiskCounts":{"shape":"S2m"},"PillarPriorities":{"shape":"St"},"Lenses":{"shape":"Sz"},"Owner":{},"ShareInvitationId":{},"Tags":{"shape":"S11"}}},"S4c":{"type":"structure","members":{"WorkloadId":{},"WorkloadArn":{},"WorkloadName":{},"Owner":{},"UpdatedAt":{"type":"timestamp"},"Lenses":{"shape":"Sz"},"RiskCounts":{"shape":"S2m"},"ImprovementStatus":{}}}}}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAnswers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLensReviewImprovements":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLensReviews":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLensShares":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLenses":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMilestones":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNotifications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListShareInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkloadShares":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkloads":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lexmodelsv2'] = {};
	AWS.LexModelsV2 = Service.defineService('lexmodelsv2', ['2020-08-07']);
	Object.defineProperty(apiLoader.services['lexmodelsv2'], '2020-08-07', {
	  get: function get() {
	    var model = __webpack_require__(988);
	    model.paginators = __webpack_require__(989).pagination;
	    model.waiters = __webpack_require__(990).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LexModelsV2;


/***/ }),
/* 988 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-07","endpointPrefix":"models-v2-lex","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Lex Models V2","serviceFullName":"Amazon Lex Model Building V2","serviceId":"Lex Models V2","signatureVersion":"v4","signingName":"lex","uid":"models.lex.v2-2020-08-07"},"operations":{"BuildBotLocale":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botLocaleStatus":{},"lastBuildSubmittedDateTime":{"type":"timestamp"}}}},"CreateBot":{"http":{"method":"PUT","requestUri":"/bots/","responseCode":202},"input":{"type":"structure","required":["botName","roleArn","dataPrivacy","idleSessionTTLInSeconds"],"members":{"botName":{},"description":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"},"botTags":{"shape":"Sf"},"testBotAliasTags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"botId":{},"botName":{},"description":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"},"botStatus":{},"creationDateTime":{"type":"timestamp"},"botTags":{"shape":"Sf"},"testBotAliasTags":{"shape":"Sf"}}}},"CreateBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botaliases/","responseCode":202},"input":{"type":"structure","required":["botAliasName","botId"],"members":{"botAliasName":{},"description":{},"botVersion":{},"botAliasLocaleSettings":{"shape":"Sm"},"conversationLogSettings":{"shape":"St"},"sentimentAnalysisSettings":{"shape":"S16"},"botId":{"location":"uri","locationName":"botId"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"botAliasId":{},"botAliasName":{},"description":{},"botVersion":{},"botAliasLocaleSettings":{"shape":"Sm"},"conversationLogSettings":{"shape":"St"},"sentimentAnalysisSettings":{"shape":"S16"},"botAliasStatus":{},"botId":{},"creationDateTime":{"type":"timestamp"},"tags":{"shape":"Sf"}}}},"CreateBotLocale":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId","nluIntentConfidenceThreshold"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{},"description":{},"nluIntentConfidenceThreshold":{"type":"double"},"voiceSettings":{"shape":"S1c"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeName":{},"localeId":{},"description":{},"nluIntentConfidenceThreshold":{"type":"double"},"voiceSettings":{"shape":"S1c"},"botLocaleStatus":{},"creationDateTime":{"type":"timestamp"}}}},"CreateBotVersion":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/","responseCode":202},"input":{"type":"structure","required":["botId","botVersionLocaleSpecification"],"members":{"botId":{"location":"uri","locationName":"botId"},"description":{},"botVersionLocaleSpecification":{"shape":"S1i"}}},"output":{"type":"structure","members":{"botId":{},"description":{},"botVersion":{},"botVersionLocaleSpecification":{"shape":"S1i"},"botStatus":{},"creationDateTime":{"type":"timestamp"}}}},"CreateExport":{"http":{"method":"PUT","requestUri":"/exports/","responseCode":202},"input":{"type":"structure","required":["resourceSpecification","fileFormat"],"members":{"resourceSpecification":{"shape":"S1n"},"fileFormat":{},"filePassword":{"shape":"S1s"}}},"output":{"type":"structure","members":{"exportId":{},"resourceSpecification":{"shape":"S1n"},"fileFormat":{},"exportStatus":{},"creationDateTime":{"type":"timestamp"}}}},"CreateIntent":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/","responseCode":200},"input":{"type":"structure","required":["intentName","botId","botVersion","localeId"],"members":{"intentName":{},"description":{},"parentIntentSignature":{},"sampleUtterances":{"shape":"S1x"},"dialogCodeHook":{"shape":"S20"},"fulfillmentCodeHook":{"shape":"S21"},"intentConfirmationSetting":{"shape":"S2s"},"intentClosingSetting":{"shape":"S2v"},"inputContexts":{"shape":"S2w"},"outputContexts":{"shape":"S2y"},"kendraConfiguration":{"shape":"S32"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"intentId":{},"intentName":{},"description":{},"parentIntentSignature":{},"sampleUtterances":{"shape":"S1x"},"dialogCodeHook":{"shape":"S20"},"fulfillmentCodeHook":{"shape":"S21"},"intentConfirmationSetting":{"shape":"S2s"},"intentClosingSetting":{"shape":"S2v"},"inputContexts":{"shape":"S2w"},"outputContexts":{"shape":"S2y"},"kendraConfiguration":{"shape":"S32"},"botId":{},"botVersion":{},"localeId":{},"creationDateTime":{"type":"timestamp"}}}},"CreateResourcePolicy":{"http":{"requestUri":"/policy/{resourceArn}/","responseCode":200},"input":{"type":"structure","required":["resourceArn","policy"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"policy":{}}},"output":{"type":"structure","members":{"resourceArn":{},"revisionId":{}}}},"CreateResourcePolicyStatement":{"http":{"requestUri":"/policy/{resourceArn}/statements/","responseCode":200},"input":{"type":"structure","required":["resourceArn","statementId","effect","principal","action"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"statementId":{},"effect":{},"principal":{"type":"list","member":{"type":"structure","members":{"service":{},"arn":{}}}},"action":{"type":"list","member":{}},"condition":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{}}},"expectedRevisionId":{"location":"querystring","locationName":"expectedRevisionId"}}},"output":{"type":"structure","members":{"resourceArn":{},"revisionId":{}}}},"CreateSlot":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/slots/","responseCode":200},"input":{"type":"structure","required":["slotName","valueElicitationSetting","botId","botVersion","localeId","intentId"],"members":{"slotName":{},"description":{},"slotTypeId":{},"valueElicitationSetting":{"shape":"S3r"},"obfuscationSetting":{"shape":"S41"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"intentId":{"location":"uri","locationName":"intentId"},"multipleValuesSetting":{"shape":"S43"}}},"output":{"type":"structure","members":{"slotId":{},"slotName":{},"description":{},"slotTypeId":{},"valueElicitationSetting":{"shape":"S3r"},"obfuscationSetting":{"shape":"S41"},"botId":{},"botVersion":{},"localeId":{},"intentId":{},"creationDateTime":{"type":"timestamp"},"multipleValuesSetting":{"shape":"S43"}}}},"CreateSlotType":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/slottypes/","responseCode":200},"input":{"type":"structure","required":["slotTypeName","botId","botVersion","localeId"],"members":{"slotTypeName":{},"description":{},"slotTypeValues":{"shape":"S46"},"valueSelectionSetting":{"shape":"S4b"},"parentSlotTypeSignature":{},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"externalSourceSetting":{"shape":"S4i"}}},"output":{"type":"structure","members":{"slotTypeId":{},"slotTypeName":{},"description":{},"slotTypeValues":{"shape":"S46"},"valueSelectionSetting":{"shape":"S4b"},"parentSlotTypeSignature":{},"botId":{},"botVersion":{},"localeId":{},"creationDateTime":{"type":"timestamp"},"externalSourceSetting":{"shape":"S4i"}}}},"CreateUploadUrl":{"http":{"requestUri":"/createuploadurl/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"importId":{},"uploadUrl":{}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/","responseCode":202},"input":{"type":"structure","required":["botId"],"members":{"botId":{"location":"uri","locationName":"botId"},"skipResourceInUseCheck":{"location":"querystring","locationName":"skipResourceInUseCheck","type":"boolean"}}},"output":{"type":"structure","members":{"botId":{},"botStatus":{}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botaliases/{botAliasId}/","responseCode":202},"input":{"type":"structure","required":["botAliasId","botId"],"members":{"botAliasId":{"location":"uri","locationName":"botAliasId"},"botId":{"location":"uri","locationName":"botId"},"skipResourceInUseCheck":{"location":"querystring","locationName":"skipResourceInUseCheck","type":"boolean"}}},"output":{"type":"structure","members":{"botAliasId":{},"botId":{},"botAliasStatus":{}}}},"DeleteBotLocale":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botLocaleStatus":{}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botversions/{botVersion}/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"skipResourceInUseCheck":{"location":"querystring","locationName":"skipResourceInUseCheck","type":"boolean"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"botStatus":{}}}},"DeleteCustomVocabulary":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/customvocabulary","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"customVocabularyStatus":{}}}},"DeleteExport":{"http":{"method":"DELETE","requestUri":"/exports/{exportId}/","responseCode":202},"input":{"type":"structure","required":["exportId"],"members":{"exportId":{"location":"uri","locationName":"exportId"}}},"output":{"type":"structure","members":{"exportId":{},"exportStatus":{}}}},"DeleteImport":{"http":{"method":"DELETE","requestUri":"/imports/{importId}/","responseCode":202},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"importId":{},"importStatus":{}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/","responseCode":204},"input":{"type":"structure","required":["intentId","botId","botVersion","localeId"],"members":{"intentId":{"location":"uri","locationName":"intentId"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}}},"DeleteResourcePolicy":{"http":{"method":"DELETE","requestUri":"/policy/{resourceArn}/","responseCode":204},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"expectedRevisionId":{"location":"querystring","locationName":"expectedRevisionId"}}},"output":{"type":"structure","members":{"resourceArn":{},"revisionId":{}}}},"DeleteResourcePolicyStatement":{"http":{"method":"DELETE","requestUri":"/policy/{resourceArn}/statements/{statementId}/","responseCode":204},"input":{"type":"structure","required":["resourceArn","statementId"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"statementId":{"location":"uri","locationName":"statementId"},"expectedRevisionId":{"location":"querystring","locationName":"expectedRevisionId"}}},"output":{"type":"structure","members":{"resourceArn":{},"revisionId":{}}}},"DeleteSlot":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/slots/{slotId}/","responseCode":204},"input":{"type":"structure","required":["slotId","botId","botVersion","localeId","intentId"],"members":{"slotId":{"location":"uri","locationName":"slotId"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"intentId":{"location":"uri","locationName":"intentId"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/slottypes/{slotTypeId}/","responseCode":204},"input":{"type":"structure","required":["slotTypeId","botId","botVersion","localeId"],"members":{"slotTypeId":{"location":"uri","locationName":"slotTypeId"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"skipResourceInUseCheck":{"location":"querystring","locationName":"skipResourceInUseCheck","type":"boolean"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/utterances/","responseCode":204},"input":{"type":"structure","required":["botId"],"members":{"botId":{"location":"uri","locationName":"botId"},"localeId":{"location":"querystring","locationName":"localeId"},"sessionId":{"location":"querystring","locationName":"sessionId"}}},"output":{"type":"structure","members":{}}},"DescribeBot":{"http":{"method":"GET","requestUri":"/bots/{botId}/","responseCode":200},"input":{"type":"structure","required":["botId"],"members":{"botId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"botId":{},"botName":{},"description":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"},"botStatus":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"DescribeBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botId}/botaliases/{botAliasId}/","responseCode":200},"input":{"type":"structure","required":["botAliasId","botId"],"members":{"botAliasId":{"location":"uri","locationName":"botAliasId"},"botId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"botAliasId":{},"botAliasName":{},"description":{},"botVersion":{},"botAliasLocaleSettings":{"shape":"Sm"},"conversationLogSettings":{"shape":"St"},"sentimentAnalysisSettings":{"shape":"S16"},"botAliasHistoryEvents":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"startDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}}},"botAliasStatus":{},"botId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"DescribeBotLocale":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"localeName":{},"description":{},"nluIntentConfidenceThreshold":{"type":"double"},"voiceSettings":{"shape":"S1c"},"intentsCount":{"type":"integer"},"slotTypesCount":{"type":"integer"},"botLocaleStatus":{},"failureReasons":{"shape":"S5r"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"lastBuildSubmittedDateTime":{"type":"timestamp"},"botLocaleHistoryEvents":{"type":"list","member":{"type":"structure","required":["event","eventDate"],"members":{"event":{},"eventDate":{"type":"timestamp"}}}},"recommendedActions":{"shape":"S5w"}}}},"DescribeBotRecommendation":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/botrecommendations/{botRecommendationId}/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId","botRecommendationId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"botRecommendationId":{"location":"uri","locationName":"botRecommendationId"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botRecommendationStatus":{},"botRecommendationId":{},"failureReasons":{"shape":"S5r"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"transcriptSourceSetting":{"shape":"S61"},"encryptionSetting":{"shape":"S6a"},"botRecommendationResults":{"type":"structure","members":{"botLocaleExportUrl":{},"associatedTranscriptsUrl":{},"statistics":{"type":"structure","members":{"intents":{"type":"structure","members":{"discoveredIntentCount":{"type":"integer"}}},"slotTypes":{"type":"structure","members":{"discoveredSlotTypeCount":{"type":"integer"}}}}}}}}}},"DescribeBotVersion":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"}}},"output":{"type":"structure","members":{"botId":{},"botName":{},"botVersion":{},"description":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"},"botStatus":{},"failureReasons":{"shape":"S5r"},"creationDateTime":{"type":"timestamp"}}}},"DescribeCustomVocabularyMetadata":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/customvocabulary/DEFAULT/metadata","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"customVocabularyStatus":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"DescribeExport":{"http":{"method":"GET","requestUri":"/exports/{exportId}/","responseCode":200},"input":{"type":"structure","required":["exportId"],"members":{"exportId":{"location":"uri","locationName":"exportId"}}},"output":{"type":"structure","members":{"exportId":{},"resourceSpecification":{"shape":"S1n"},"fileFormat":{},"exportStatus":{},"failureReasons":{"shape":"S5r"},"downloadUrl":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"DescribeImport":{"http":{"method":"GET","requestUri":"/imports/{importId}/","responseCode":200},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"importId":{},"resourceSpecification":{"shape":"S6p"},"importedResourceId":{},"importedResourceName":{},"mergeStrategy":{},"importStatus":{},"failureReasons":{"shape":"S5r"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"DescribeIntent":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/","responseCode":200},"input":{"type":"structure","required":["intentId","botId","botVersion","localeId"],"members":{"intentId":{"location":"uri","locationName":"intentId"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"intentId":{},"intentName":{},"description":{},"parentIntentSignature":{},"sampleUtterances":{"shape":"S1x"},"dialogCodeHook":{"shape":"S20"},"fulfillmentCodeHook":{"shape":"S21"},"slotPriorities":{"shape":"S6x"},"intentConfirmationSetting":{"shape":"S2s"},"intentClosingSetting":{"shape":"S2v"},"inputContexts":{"shape":"S2w"},"outputContexts":{"shape":"S2y"},"kendraConfiguration":{"shape":"S32"},"botId":{},"botVersion":{},"localeId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"DescribeResourcePolicy":{"http":{"method":"GET","requestUri":"/policy/{resourceArn}/","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"resourceArn":{},"policy":{},"revisionId":{}}}},"DescribeSlot":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/slots/{slotId}/","responseCode":200},"input":{"type":"structure","required":["slotId","botId","botVersion","localeId","intentId"],"members":{"slotId":{"location":"uri","locationName":"slotId"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"intentId":{"location":"uri","locationName":"intentId"}}},"output":{"type":"structure","members":{"slotId":{},"slotName":{},"description":{},"slotTypeId":{},"valueElicitationSetting":{"shape":"S3r"},"obfuscationSetting":{"shape":"S41"},"botId":{},"botVersion":{},"localeId":{},"intentId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"multipleValuesSetting":{"shape":"S43"}}}},"DescribeSlotType":{"http":{"method":"GET","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/slottypes/{slotTypeId}/","responseCode":200},"input":{"type":"structure","required":["slotTypeId","botId","botVersion","localeId"],"members":{"slotTypeId":{"location":"uri","locationName":"slotTypeId"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"slotTypeId":{},"slotTypeName":{},"description":{},"slotTypeValues":{"shape":"S46"},"valueSelectionSetting":{"shape":"S4b"},"parentSlotTypeSignature":{},"botId":{},"botVersion":{},"localeId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"externalSourceSetting":{"shape":"S4i"}}}},"ListAggregatedUtterances":{"http":{"requestUri":"/bots/{botId}/aggregatedutterances/","responseCode":200},"input":{"type":"structure","required":["botId","localeId","aggregationDuration"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{},"botVersion":{},"localeId":{},"aggregationDuration":{"shape":"S77"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botAliasId":{},"botVersion":{},"localeId":{},"aggregationDuration":{"shape":"S77"},"aggregationWindowStartTime":{"type":"timestamp"},"aggregationWindowEndTime":{"type":"timestamp"},"aggregationLastRefreshedDateTime":{"type":"timestamp"},"aggregatedUtterancesSummaries":{"type":"list","member":{"type":"structure","members":{"utterance":{},"hitCount":{"type":"integer"},"missedCount":{"type":"integer"},"utteranceFirstRecordedInAggregationDuration":{"type":"timestamp"},"utteranceLastRecordedInAggregationDuration":{"type":"timestamp"},"containsDataFromDeletedResources":{"type":"boolean"}}}},"nextToken":{}}}},"ListBotAliases":{"http":{"requestUri":"/bots/{botId}/botaliases/","responseCode":200},"input":{"type":"structure","required":["botId"],"members":{"botId":{"location":"uri","locationName":"botId"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botAliasSummaries":{"type":"list","member":{"type":"structure","members":{"botAliasId":{},"botAliasName":{},"description":{},"botVersion":{},"botAliasStatus":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{},"botId":{}}}},"ListBotLocales":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"nextToken":{},"botLocaleSummaries":{"type":"list","member":{"type":"structure","members":{"localeId":{},"localeName":{},"description":{},"botLocaleStatus":{},"lastUpdatedDateTime":{"type":"timestamp"},"lastBuildSubmittedDateTime":{"type":"timestamp"}}}}}}},"ListBotRecommendations":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/botrecommendations/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botRecommendationSummaries":{"type":"list","member":{"type":"structure","required":["botRecommendationStatus","botRecommendationId"],"members":{"botRecommendationStatus":{},"botRecommendationId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListBotVersions":{"http":{"requestUri":"/bots/{botId}/botversions/","responseCode":200},"input":{"type":"structure","required":["botId"],"members":{"botId":{"location":"uri","locationName":"botId"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botVersionSummaries":{"type":"list","member":{"type":"structure","members":{"botName":{},"botVersion":{},"description":{},"botStatus":{},"creationDateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListBots":{"http":{"requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botSummaries":{"type":"list","member":{"type":"structure","members":{"botId":{},"botName":{},"description":{},"botStatus":{},"latestBotVersion":{},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListBuiltInIntents":{"http":{"requestUri":"/builtins/locales/{localeId}/intents/","responseCode":200},"input":{"type":"structure","required":["localeId"],"members":{"localeId":{"location":"uri","locationName":"localeId"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"builtInIntentSummaries":{"type":"list","member":{"type":"structure","members":{"intentSignature":{},"description":{}}}},"nextToken":{},"localeId":{}}}},"ListBuiltInSlotTypes":{"http":{"requestUri":"/builtins/locales/{localeId}/slottypes/","responseCode":200},"input":{"type":"structure","required":["localeId"],"members":{"localeId":{"location":"uri","locationName":"localeId"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"builtInSlotTypeSummaries":{"type":"list","member":{"type":"structure","members":{"slotTypeSignature":{},"description":{}}}},"nextToken":{},"localeId":{}}}},"ListExports":{"http":{"requestUri":"/exports/","responseCode":200},"input":{"type":"structure","members":{"botId":{},"botVersion":{},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{},"localeId":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"exportSummaries":{"type":"list","member":{"type":"structure","members":{"exportId":{},"resourceSpecification":{"shape":"S1n"},"fileFormat":{},"exportStatus":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{},"localeId":{}}}},"ListImports":{"http":{"requestUri":"/imports/","responseCode":200},"input":{"type":"structure","members":{"botId":{},"botVersion":{},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{},"localeId":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"importSummaries":{"type":"list","member":{"type":"structure","members":{"importId":{},"importedResourceId":{},"importedResourceName":{},"importStatus":{},"mergeStrategy":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"importedResourceType":{}}}},"nextToken":{},"localeId":{}}}},"ListIntents":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"intentSummaries":{"type":"list","member":{"type":"structure","members":{"intentId":{},"intentName":{},"description":{},"parentIntentSignature":{},"inputContexts":{"shape":"S2w"},"outputContexts":{"shape":"S2y"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListRecommendedIntents":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/botrecommendations/{botRecommendationId}/intents","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId","botRecommendationId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"botRecommendationId":{"location":"uri","locationName":"botRecommendationId"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botRecommendationId":{},"summaryList":{"type":"list","member":{"type":"structure","members":{"intentId":{},"intentName":{},"sampleUtterancesCount":{"type":"integer"}}}},"nextToken":{}}}},"ListSlotTypes":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/slottypes/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"slotTypeSummaries":{"type":"list","member":{"type":"structure","members":{"slotTypeId":{},"slotTypeName":{},"description":{},"parentSlotTypeSignature":{},"lastUpdatedDateTime":{"type":"timestamp"},"slotTypeCategory":{}}}},"nextToken":{}}}},"ListSlots":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/slots/","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId","intentId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"intentId":{"location":"uri","locationName":"intentId"},"sortBy":{"type":"structure","required":["attribute","order"],"members":{"attribute":{},"order":{}}},"filters":{"type":"list","member":{"type":"structure","required":["name","values","operator"],"members":{"name":{},"values":{"shape":"S7h"},"operator":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"intentId":{},"slotSummaries":{"type":"list","member":{"type":"structure","members":{"slotId":{},"slotName":{},"description":{},"slotConstraint":{},"slotTypeId":{},"valueElicitationPromptSpecification":{"shape":"S2t"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceARN}","responseCode":200},"input":{"type":"structure","required":["resourceARN"],"members":{"resourceARN":{"location":"uri","locationName":"resourceARN"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sf"}}}},"SearchAssociatedTranscripts":{"http":{"requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/botrecommendations/{botRecommendationId}/associatedtranscripts","responseCode":200},"input":{"type":"structure","required":["botId","botVersion","localeId","botRecommendationId","filters"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"botRecommendationId":{"location":"uri","locationName":"botRecommendationId"},"searchOrder":{},"filters":{"type":"list","member":{"type":"structure","required":["name","values"],"members":{"name":{},"values":{"shape":"S7h"}}}},"maxResults":{"type":"integer"},"nextIndex":{"type":"integer"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botRecommendationId":{},"nextIndex":{"type":"integer"},"associatedTranscripts":{"type":"list","member":{"type":"structure","members":{"transcript":{}}}},"totalResults":{"type":"integer"}}}},"StartBotRecommendation":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/botrecommendations/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId","transcriptSourceSetting"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"transcriptSourceSetting":{"shape":"S61"},"encryptionSetting":{"shape":"S6a"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botRecommendationStatus":{},"botRecommendationId":{},"creationDateTime":{"type":"timestamp"},"transcriptSourceSetting":{"shape":"S61"},"encryptionSetting":{"shape":"S6a"}}}},"StartImport":{"http":{"method":"PUT","requestUri":"/imports/","responseCode":202},"input":{"type":"structure","required":["importId","resourceSpecification","mergeStrategy"],"members":{"importId":{},"resourceSpecification":{"shape":"S6p"},"mergeStrategy":{},"filePassword":{"shape":"S1s"}}},"output":{"type":"structure","members":{"importId":{},"resourceSpecification":{"shape":"S6p"},"mergeStrategy":{},"importStatus":{},"creationDateTime":{"type":"timestamp"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceARN}","responseCode":200},"input":{"type":"structure","required":["resourceARN","tags"],"members":{"resourceARN":{"location":"uri","locationName":"resourceARN"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceARN}","responseCode":200},"input":{"type":"structure","required":["resourceARN","tagKeys"],"members":{"resourceARN":{"location":"uri","locationName":"resourceARN"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateBot":{"http":{"method":"PUT","requestUri":"/bots/{botId}/","responseCode":202},"input":{"type":"structure","required":["botId","botName","roleArn","dataPrivacy","idleSessionTTLInSeconds"],"members":{"botId":{"location":"uri","locationName":"botId"},"botName":{},"description":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"botId":{},"botName":{},"description":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"},"botStatus":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"UpdateBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botaliases/{botAliasId}/","responseCode":202},"input":{"type":"structure","required":["botAliasId","botAliasName","botId"],"members":{"botAliasId":{"location":"uri","locationName":"botAliasId"},"botAliasName":{},"description":{},"botVersion":{},"botAliasLocaleSettings":{"shape":"Sm"},"conversationLogSettings":{"shape":"St"},"sentimentAnalysisSettings":{"shape":"S16"},"botId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"botAliasId":{},"botAliasName":{},"description":{},"botVersion":{},"botAliasLocaleSettings":{"shape":"Sm"},"conversationLogSettings":{"shape":"St"},"sentimentAnalysisSettings":{"shape":"S16"},"botAliasStatus":{},"botId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"UpdateBotLocale":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId","nluIntentConfidenceThreshold"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"description":{},"nluIntentConfidenceThreshold":{"type":"double"},"voiceSettings":{"shape":"S1c"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"localeName":{},"description":{},"nluIntentConfidenceThreshold":{"type":"double"},"voiceSettings":{"shape":"S1c"},"botLocaleStatus":{},"failureReasons":{"shape":"S5r"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"recommendedActions":{"shape":"S5w"}}}},"UpdateBotRecommendation":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/botrecommendations/{botRecommendationId}/","responseCode":202},"input":{"type":"structure","required":["botId","botVersion","localeId","botRecommendationId","encryptionSetting"],"members":{"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"botRecommendationId":{"location":"uri","locationName":"botRecommendationId"},"encryptionSetting":{"shape":"S6a"}}},"output":{"type":"structure","members":{"botId":{},"botVersion":{},"localeId":{},"botRecommendationStatus":{},"botRecommendationId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"transcriptSourceSetting":{"shape":"S61"},"encryptionSetting":{"shape":"S6a"}}}},"UpdateExport":{"http":{"method":"PUT","requestUri":"/exports/{exportId}/","responseCode":202},"input":{"type":"structure","required":["exportId"],"members":{"exportId":{"location":"uri","locationName":"exportId"},"filePassword":{"shape":"S1s"}}},"output":{"type":"structure","members":{"exportId":{},"resourceSpecification":{"shape":"S1n"},"fileFormat":{},"exportStatus":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"UpdateIntent":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/","responseCode":200},"input":{"type":"structure","required":["intentId","intentName","botId","botVersion","localeId"],"members":{"intentId":{"location":"uri","locationName":"intentId"},"intentName":{},"description":{},"parentIntentSignature":{},"sampleUtterances":{"shape":"S1x"},"dialogCodeHook":{"shape":"S20"},"fulfillmentCodeHook":{"shape":"S21"},"slotPriorities":{"shape":"S6x"},"intentConfirmationSetting":{"shape":"S2s"},"intentClosingSetting":{"shape":"S2v"},"inputContexts":{"shape":"S2w"},"outputContexts":{"shape":"S2y"},"kendraConfiguration":{"shape":"S32"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"}}},"output":{"type":"structure","members":{"intentId":{},"intentName":{},"description":{},"parentIntentSignature":{},"sampleUtterances":{"shape":"S1x"},"dialogCodeHook":{"shape":"S20"},"fulfillmentCodeHook":{"shape":"S21"},"slotPriorities":{"shape":"S6x"},"intentConfirmationSetting":{"shape":"S2s"},"intentClosingSetting":{"shape":"S2v"},"inputContexts":{"shape":"S2w"},"outputContexts":{"shape":"S2y"},"kendraConfiguration":{"shape":"S32"},"botId":{},"botVersion":{},"localeId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"UpdateResourcePolicy":{"http":{"method":"PUT","requestUri":"/policy/{resourceArn}/","responseCode":200},"input":{"type":"structure","required":["resourceArn","policy"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"policy":{},"expectedRevisionId":{"location":"querystring","locationName":"expectedRevisionId"}}},"output":{"type":"structure","members":{"resourceArn":{},"revisionId":{}}}},"UpdateSlot":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/intents/{intentId}/slots/{slotId}/","responseCode":200},"input":{"type":"structure","required":["slotId","slotName","valueElicitationSetting","botId","botVersion","localeId","intentId"],"members":{"slotId":{"location":"uri","locationName":"slotId"},"slotName":{},"description":{},"slotTypeId":{},"valueElicitationSetting":{"shape":"S3r"},"obfuscationSetting":{"shape":"S41"},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"intentId":{"location":"uri","locationName":"intentId"},"multipleValuesSetting":{"shape":"S43"}}},"output":{"type":"structure","members":{"slotId":{},"slotName":{},"description":{},"slotTypeId":{},"valueElicitationSetting":{"shape":"S3r"},"obfuscationSetting":{"shape":"S41"},"botId":{},"botVersion":{},"localeId":{},"intentId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"multipleValuesSetting":{"shape":"S43"}}}},"UpdateSlotType":{"http":{"method":"PUT","requestUri":"/bots/{botId}/botversions/{botVersion}/botlocales/{localeId}/slottypes/{slotTypeId}/","responseCode":202},"input":{"type":"structure","required":["slotTypeId","slotTypeName","botId","botVersion","localeId"],"members":{"slotTypeId":{"location":"uri","locationName":"slotTypeId"},"slotTypeName":{},"description":{},"slotTypeValues":{"shape":"S46"},"valueSelectionSetting":{"shape":"S4b"},"parentSlotTypeSignature":{},"botId":{"location":"uri","locationName":"botId"},"botVersion":{"location":"uri","locationName":"botVersion"},"localeId":{"location":"uri","locationName":"localeId"},"externalSourceSetting":{"shape":"S4i"}}},"output":{"type":"structure","members":{"slotTypeId":{},"slotTypeName":{},"description":{},"slotTypeValues":{"shape":"S46"},"valueSelectionSetting":{"shape":"S4b"},"parentSlotTypeSignature":{},"botId":{},"botVersion":{},"localeId":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"externalSourceSetting":{"shape":"S4i"}}}}},"shapes":{"Sc":{"type":"structure","required":["childDirected"],"members":{"childDirected":{"type":"boolean"}}},"Sf":{"type":"map","key":{},"value":{}},"Sm":{"type":"map","key":{},"value":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"},"codeHookSpecification":{"type":"structure","required":["lambdaCodeHook"],"members":{"lambdaCodeHook":{"type":"structure","required":["lambdaARN","codeHookInterfaceVersion"],"members":{"lambdaARN":{},"codeHookInterfaceVersion":{}}}}}}}},"St":{"type":"structure","members":{"textLogSettings":{"type":"list","member":{"type":"structure","required":["enabled","destination"],"members":{"enabled":{"type":"boolean"},"destination":{"type":"structure","required":["cloudWatch"],"members":{"cloudWatch":{"type":"structure","required":["cloudWatchLogGroupArn","logPrefix"],"members":{"cloudWatchLogGroupArn":{},"logPrefix":{}}}}}}}},"audioLogSettings":{"type":"list","member":{"type":"structure","required":["enabled","destination"],"members":{"enabled":{"type":"boolean"},"destination":{"type":"structure","required":["s3Bucket"],"members":{"s3Bucket":{"type":"structure","required":["s3BucketArn","logPrefix"],"members":{"kmsKeyArn":{},"s3BucketArn":{},"logPrefix":{}}}}}}}}}},"S16":{"type":"structure","required":["detectSentiment"],"members":{"detectSentiment":{"type":"boolean"}}},"S1c":{"type":"structure","required":["voiceId"],"members":{"voiceId":{},"engine":{}}},"S1i":{"type":"map","key":{},"value":{"type":"structure","required":["sourceBotVersion"],"members":{"sourceBotVersion":{}}}},"S1n":{"type":"structure","members":{"botExportSpecification":{"type":"structure","required":["botId","botVersion"],"members":{"botId":{},"botVersion":{}}},"botLocaleExportSpecification":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{},"botVersion":{},"localeId":{}}},"customVocabularyExportSpecification":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{},"botVersion":{},"localeId":{}}}}},"S1s":{"type":"string","sensitive":true},"S1x":{"type":"list","member":{"type":"structure","required":["utterance"],"members":{"utterance":{}}}},"S20":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"}}},"S21":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"},"postFulfillmentStatusSpecification":{"type":"structure","members":{"successResponse":{"shape":"S23"},"failureResponse":{"shape":"S23"},"timeoutResponse":{"shape":"S23"}}},"fulfillmentUpdatesSpecification":{"type":"structure","required":["active"],"members":{"active":{"type":"boolean"},"startResponse":{"type":"structure","required":["delayInSeconds","messageGroups"],"members":{"delayInSeconds":{"type":"integer"},"messageGroups":{"shape":"S24"},"allowInterrupt":{"type":"boolean"}}},"updateResponse":{"type":"structure","required":["frequencyInSeconds","messageGroups"],"members":{"frequencyInSeconds":{"type":"integer"},"messageGroups":{"shape":"S24"},"allowInterrupt":{"type":"boolean"}}},"timeoutInSeconds":{"type":"integer"}}}}},"S23":{"type":"structure","required":["messageGroups"],"members":{"messageGroups":{"shape":"S24"},"allowInterrupt":{"type":"boolean"}}},"S24":{"type":"list","member":{"type":"structure","required":["message"],"members":{"message":{"shape":"S26"},"variations":{"type":"list","member":{"shape":"S26"}}}}},"S26":{"type":"structure","members":{"plainTextMessage":{"type":"structure","required":["value"],"members":{"value":{}}},"customPayload":{"type":"structure","required":["value"],"members":{"value":{}}},"ssmlMessage":{"type":"structure","required":["value"],"members":{"value":{}}},"imageResponseCard":{"type":"structure","required":["title"],"members":{"title":{},"subtitle":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}},"S2s":{"type":"structure","required":["promptSpecification","declinationResponse"],"members":{"promptSpecification":{"shape":"S2t"},"declinationResponse":{"shape":"S23"},"active":{"type":"boolean"}}},"S2t":{"type":"structure","required":["messageGroups","maxRetries"],"members":{"messageGroups":{"shape":"S24"},"maxRetries":{"type":"integer"},"allowInterrupt":{"type":"boolean"}}},"S2v":{"type":"structure","required":["closingResponse"],"members":{"closingResponse":{"shape":"S23"},"active":{"type":"boolean"}}},"S2w":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"S2y":{"type":"list","member":{"type":"structure","required":["name","timeToLiveInSeconds","turnsToLive"],"members":{"name":{},"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}}},"S32":{"type":"structure","required":["kendraIndex"],"members":{"kendraIndex":{},"queryFilterStringEnabled":{"type":"boolean"},"queryFilterString":{}}},"S3r":{"type":"structure","required":["slotConstraint"],"members":{"defaultValueSpecification":{"type":"structure","required":["defaultValueList"],"members":{"defaultValueList":{"type":"list","member":{"type":"structure","required":["defaultValue"],"members":{"defaultValue":{}}}}}},"slotConstraint":{},"promptSpecification":{"shape":"S2t"},"sampleUtterances":{"shape":"S1x"},"waitAndContinueSpecification":{"type":"structure","required":["waitingResponse","continueResponse"],"members":{"waitingResponse":{"shape":"S23"},"continueResponse":{"shape":"S23"},"stillWaitingResponse":{"type":"structure","required":["messageGroups","frequencyInSeconds","timeoutInSeconds"],"members":{"messageGroups":{"shape":"S24"},"frequencyInSeconds":{"type":"integer"},"timeoutInSeconds":{"type":"integer"},"allowInterrupt":{"type":"boolean"}}},"active":{"type":"boolean"}}}}},"S41":{"type":"structure","required":["obfuscationSettingType"],"members":{"obfuscationSettingType":{}}},"S43":{"type":"structure","members":{"allowMultipleValues":{"type":"boolean"}}},"S46":{"type":"list","member":{"type":"structure","members":{"sampleValue":{"shape":"S48"},"synonyms":{"type":"list","member":{"shape":"S48"}}}}},"S48":{"type":"structure","required":["value"],"members":{"value":{}}},"S4b":{"type":"structure","required":["resolutionStrategy"],"members":{"resolutionStrategy":{},"regexFilter":{"type":"structure","required":["pattern"],"members":{"pattern":{}}},"advancedRecognitionSetting":{"type":"structure","members":{"audioRecognitionStrategy":{}}}}},"S4i":{"type":"structure","members":{"grammarSlotTypeSetting":{"type":"structure","members":{"source":{"type":"structure","required":["s3BucketName","s3ObjectKey"],"members":{"s3BucketName":{},"s3ObjectKey":{},"kmsKeyArn":{}}}}}}},"S5r":{"type":"list","member":{}},"S5w":{"type":"list","member":{}},"S61":{"type":"structure","members":{"s3BucketTranscriptSource":{"type":"structure","required":["s3BucketName","transcriptFormat"],"members":{"s3BucketName":{},"pathFormat":{"type":"structure","members":{"objectPrefixes":{"type":"list","member":{}}}},"transcriptFormat":{},"transcriptFilter":{"type":"structure","members":{"lexTranscriptFilter":{"type":"structure","members":{"dateRangeFilter":{"type":"structure","required":["startDateTime","endDateTime"],"members":{"startDateTime":{"type":"timestamp"},"endDateTime":{"type":"timestamp"}}}}}}},"kmsKeyArn":{}}}}},"S6a":{"type":"structure","members":{"kmsKeyArn":{},"botLocaleExportPassword":{"shape":"S6b"},"associatedTranscriptsPassword":{"shape":"S6b"}}},"S6b":{"type":"string","sensitive":true},"S6p":{"type":"structure","members":{"botImportSpecification":{"type":"structure","required":["botName","roleArn","dataPrivacy"],"members":{"botName":{},"roleArn":{},"dataPrivacy":{"shape":"Sc"},"idleSessionTTLInSeconds":{"type":"integer"},"botTags":{"shape":"Sf"},"testBotAliasTags":{"shape":"Sf"}}},"botLocaleImportSpecification":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{},"botVersion":{},"localeId":{},"nluIntentConfidenceThreshold":{"type":"double"},"voiceSettings":{"shape":"S1c"}}},"customVocabularyImportSpecification":{"type":"structure","required":["botId","botVersion","localeId"],"members":{"botId":{},"botVersion":{},"localeId":{}}}}},"S6x":{"type":"list","member":{"type":"structure","required":["priority","slotId"],"members":{"priority":{"type":"integer"},"slotId":{}}}},"S77":{"type":"structure","required":["relativeAggregationDuration"],"members":{"relativeAggregationDuration":{"type":"structure","required":["timeDimension","timeValue"],"members":{"timeDimension":{},"timeValue":{"type":"integer"}}}}},"S7h":{"type":"list","member":{}}}}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAggregatedUtterances":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBotLocales":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBotRecommendations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBuiltInIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListBuiltInSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExports":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListImports":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRecommendedIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSlots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"BotAvailable":{"delay":10,"operation":"DescribeBot","maxAttempts":35,"description":"Wait until a bot is available","acceptors":[{"expected":"Available","matcher":"path","state":"success","argument":"botStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"botStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"botStatus"},{"expected":"Inactive","matcher":"path","state":"failure","argument":"botStatus"}]},"BotAliasAvailable":{"delay":10,"operation":"DescribeBotAlias","maxAttempts":35,"description":"Wait until a bot alias is available","acceptors":[{"expected":"Available","matcher":"path","state":"success","argument":"botAliasStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"botAliasStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"botAliasStatus"}]},"BotExportCompleted":{"delay":10,"operation":"DescribeExport","maxAttempts":35,"description":"Wait until a bot has been exported","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"exportStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"exportStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"exportStatus"}]},"BotImportCompleted":{"delay":10,"operation":"DescribeImport","maxAttempts":35,"description":"Wait until a bot has been imported","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"importStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"importStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"importStatus"}]},"BotLocaleBuilt":{"delay":10,"operation":"DescribeBotLocale","maxAttempts":35,"description":"Wait until a bot locale is built","acceptors":[{"expected":"Built","matcher":"path","state":"success","argument":"botLocaleStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"botLocaleStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"botLocaleStatus"},{"expected":"NotBuilt","matcher":"path","state":"failure","argument":"botLocaleStatus"}]},"BotLocaleExpressTestingAvailable":{"delay":10,"operation":"DescribeBotLocale","maxAttempts":35,"description":"Wait until a bot locale build is ready for express testing","acceptors":[{"expected":"Built","matcher":"path","state":"success","argument":"botLocaleStatus"},{"expected":"ReadyExpressTesting","matcher":"path","state":"success","argument":"botLocaleStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"botLocaleStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"botLocaleStatus"},{"expected":"NotBuilt","matcher":"path","state":"failure","argument":"botLocaleStatus"}]},"BotVersionAvailable":{"delay":10,"operation":"DescribeBotVersion","maxAttempts":35,"description":"Wait until a bot version is available","acceptors":[{"expected":"Available","matcher":"path","state":"success","argument":"botStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"botStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"botStatus"},{"state":"retry","matcher":"status","expected":404}]},"BotLocaleCreated":{"delay":10,"operation":"DescribeBotLocale","maxAttempts":35,"description":"Wait unit a bot locale is created","acceptors":[{"expected":"Built","matcher":"path","state":"success","argument":"botLocaleStatus"},{"expected":"ReadyExpressTesting","matcher":"path","state":"success","argument":"botLocaleStatus"},{"expected":"NotBuilt","matcher":"path","state":"success","argument":"botLocaleStatus"},{"expected":"Deleting","matcher":"path","state":"failure","argument":"botLocaleStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"botLocaleStatus"}]}}}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lexruntimev2'] = {};
	AWS.LexRuntimeV2 = Service.defineService('lexruntimev2', ['2020-08-07']);
	Object.defineProperty(apiLoader.services['lexruntimev2'], '2020-08-07', {
	  get: function get() {
	    var model = __webpack_require__(992);
	    model.paginators = __webpack_require__(993).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LexRuntimeV2;


/***/ }),
/* 992 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-07","endpointPrefix":"runtime-v2-lex","jsonVersion":"1.1","protocol":"rest-json","protocolSettings":{"h2":"eventstream"},"serviceAbbreviation":"Lex Runtime V2","serviceFullName":"Amazon Lex Runtime V2","serviceId":"Lex Runtime V2","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex.v2-2020-08-07"},"operations":{"DeleteSession":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"},"input":{"type":"structure","required":["botId","botAliasId","sessionId","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"}}},"output":{"type":"structure","members":{"botId":{},"botAliasId":{},"localeId":{},"sessionId":{}}}},"GetSession":{"http":{"method":"GET","requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"},"input":{"type":"structure","required":["botId","botAliasId","localeId","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"}}},"output":{"type":"structure","members":{"sessionId":{},"messages":{"shape":"Sa"},"interpretations":{"shape":"Sl"},"sessionState":{"shape":"S11"}}}},"PutSession":{"http":{"requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"},"input":{"type":"structure","required":["botId","botAliasId","localeId","sessionState","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"},"messages":{"shape":"Sa"},"sessionState":{"shape":"S11"},"requestAttributes":{"shape":"S1d"},"responseContentType":{"location":"header","locationName":"ResponseContentType"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"messages":{"location":"header","locationName":"x-amz-lex-messages"},"sessionState":{"location":"header","locationName":"x-amz-lex-session-state"},"requestAttributes":{"location":"header","locationName":"x-amz-lex-request-attributes"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"audioStream":{"shape":"S1p"}},"payload":"audioStream"}},"RecognizeText":{"http":{"requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/text"},"input":{"type":"structure","required":["botId","botAliasId","localeId","text","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"},"text":{"shape":"Sc"},"sessionState":{"shape":"S11"},"requestAttributes":{"shape":"S1d"}}},"output":{"type":"structure","members":{"messages":{"shape":"Sa"},"sessionState":{"shape":"S11"},"interpretations":{"shape":"Sl"},"requestAttributes":{"shape":"S1d"},"sessionId":{}}}},"RecognizeUtterance":{"http":{"requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/utterance"},"input":{"type":"structure","required":["botId","botAliasId","localeId","requestContentType","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"},"sessionState":{"shape":"S1t","location":"header","locationName":"x-amz-lex-session-state"},"requestAttributes":{"shape":"S1t","location":"header","locationName":"x-amz-lex-request-attributes"},"requestContentType":{"location":"header","locationName":"Content-Type"},"responseContentType":{"location":"header","locationName":"Response-Content-Type"},"inputStream":{"shape":"S1p"}},"payload":"inputStream"},"output":{"type":"structure","members":{"inputMode":{"location":"header","locationName":"x-amz-lex-input-mode"},"contentType":{"location":"header","locationName":"Content-Type"},"messages":{"location":"header","locationName":"x-amz-lex-messages"},"interpretations":{"location":"header","locationName":"x-amz-lex-interpretations"},"sessionState":{"location":"header","locationName":"x-amz-lex-session-state"},"requestAttributes":{"location":"header","locationName":"x-amz-lex-request-attributes"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"inputTranscript":{"location":"header","locationName":"x-amz-lex-input-transcript"},"audioStream":{"shape":"S1p"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"}},"shapes":{"Sa":{"type":"list","member":{"type":"structure","required":["contentType"],"members":{"content":{"shape":"Sc"},"contentType":{},"imageResponseCard":{"type":"structure","required":["title"],"members":{"title":{},"subtitle":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}},"Sc":{"type":"string","sensitive":true},"Sl":{"type":"list","member":{"type":"structure","members":{"nluConfidence":{"type":"structure","members":{"score":{"type":"double"}}},"sentimentResponse":{"type":"structure","members":{"sentiment":{},"sentimentScore":{"type":"structure","members":{"positive":{"type":"double"},"negative":{"type":"double"},"neutral":{"type":"double"},"mixed":{"type":"double"}}}}},"intent":{"shape":"Ss"}}}},"Ss":{"type":"structure","required":["name"],"members":{"name":{},"slots":{"type":"map","key":{},"value":{"shape":"Su"}},"state":{},"confirmationState":{}}},"Su":{"type":"structure","members":{"value":{"type":"structure","required":["interpretedValue"],"members":{"originalValue":{},"interpretedValue":{},"resolvedValues":{"type":"list","member":{}}}},"shape":{},"values":{"type":"list","member":{"shape":"Su"}}}},"S11":{"type":"structure","members":{"dialogAction":{"type":"structure","required":["type"],"members":{"type":{},"slotToElicit":{},"slotElicitationStyle":{}}},"intent":{"shape":"Ss"},"activeContexts":{"type":"list","member":{"type":"structure","required":["name","timeToLive","contextAttributes"],"members":{"name":{},"timeToLive":{"type":"structure","required":["timeToLiveInSeconds","turnsToLive"],"members":{"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}},"contextAttributes":{"type":"map","key":{},"value":{"shape":"Sc"}}}}},"sessionAttributes":{"shape":"S1d"},"originatingRequestId":{},"runtimeHints":{"type":"structure","members":{"slotHints":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","required":["runtimeHintValues"],"members":{"runtimeHintValues":{"type":"list","member":{"type":"structure","required":["phrase"],"members":{"phrase":{}}}}}}}}}}}},"S1d":{"type":"map","key":{},"value":{}},"S1p":{"type":"blob","streaming":true},"S1t":{"type":"string","sensitive":true}}}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['fis'] = {};
	AWS.Fis = Service.defineService('fis', ['2020-12-01']);
	Object.defineProperty(apiLoader.services['fis'], '2020-12-01', {
	  get: function get() {
	    var model = __webpack_require__(995);
	    model.paginators = __webpack_require__(996).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Fis;


/***/ }),
/* 995 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-12-01","endpointPrefix":"fis","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"FIS","serviceFullName":"AWS Fault Injection Simulator","serviceId":"fis","signatureVersion":"v4","signingName":"fis","uid":"fis-2020-12-01"},"operations":{"CreateExperimentTemplate":{"http":{"requestUri":"/experimentTemplates","responseCode":200},"input":{"type":"structure","required":["clientToken","description","stopConditions","actions","roleArn"],"members":{"clientToken":{"idempotencyToken":true},"description":{},"stopConditions":{"type":"list","member":{"type":"structure","required":["source"],"members":{"source":{},"value":{}}}},"targets":{"type":"map","key":{},"value":{"type":"structure","required":["resourceType","selectionMode"],"members":{"resourceType":{},"resourceArns":{"shape":"Sc"},"resourceTags":{"shape":"Se"},"filters":{"shape":"Sh"},"selectionMode":{},"parameters":{"shape":"Sn"}}}},"actions":{"type":"map","key":{},"value":{"type":"structure","required":["actionId"],"members":{"actionId":{},"description":{},"parameters":{"shape":"Sv"},"targets":{"shape":"Sy"},"startAfter":{"shape":"S10"}}}},"roleArn":{},"tags":{"shape":"Se"},"logConfiguration":{"type":"structure","required":["logSchemaVersion"],"members":{"cloudWatchLogsConfiguration":{"shape":"S14"},"s3Configuration":{"shape":"S16"},"logSchemaVersion":{"type":"integer"}}}}},"output":{"type":"structure","members":{"experimentTemplate":{"shape":"S1b"}}}},"DeleteExperimentTemplate":{"http":{"method":"DELETE","requestUri":"/experimentTemplates/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"experimentTemplate":{"shape":"S1b"}}}},"GetAction":{"http":{"method":"GET","requestUri":"/actions/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"action":{"type":"structure","members":{"id":{},"description":{},"parameters":{"type":"map","key":{},"value":{"type":"structure","members":{"description":{},"required":{"type":"boolean"}}}},"targets":{"shape":"S21"},"tags":{"shape":"Se"}}}}}},"GetExperiment":{"http":{"method":"GET","requestUri":"/experiments/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"experiment":{"shape":"S27"}}}},"GetExperimentTemplate":{"http":{"method":"GET","requestUri":"/experimentTemplates/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"experimentTemplate":{"shape":"S1b"}}}},"GetTargetResourceType":{"http":{"method":"GET","requestUri":"/targetResourceTypes/{resourceType}","responseCode":200},"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{"location":"uri","locationName":"resourceType"}}},"output":{"type":"structure","members":{"targetResourceType":{"type":"structure","members":{"resourceType":{},"description":{},"parameters":{"type":"map","key":{},"value":{"type":"structure","members":{"description":{},"required":{"type":"boolean"}}}}}}}}},"ListActions":{"http":{"method":"GET","requestUri":"/actions","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{},"targets":{"shape":"S21"},"tags":{"shape":"Se"}}}},"nextToken":{}}}},"ListExperimentTemplates":{"http":{"method":"GET","requestUri":"/experimentTemplates","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"experimentTemplates":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"tags":{"shape":"Se"}}}},"nextToken":{}}}},"ListExperiments":{"http":{"method":"GET","requestUri":"/experiments","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"experiments":{"type":"list","member":{"type":"structure","members":{"id":{},"experimentTemplateId":{},"state":{"shape":"S28"},"creationTime":{"type":"timestamp"},"tags":{"shape":"Se"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"ListTargetResourceTypes":{"http":{"method":"GET","requestUri":"/targetResourceTypes","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"targetResourceTypes":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"description":{}}}},"nextToken":{}}}},"StartExperiment":{"http":{"requestUri":"/experiments","responseCode":200},"input":{"type":"structure","required":["clientToken","experimentTemplateId"],"members":{"clientToken":{"idempotencyToken":true},"experimentTemplateId":{},"tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"experiment":{"shape":"S27"}}}},"StopExperiment":{"http":{"method":"DELETE","requestUri":"/experiments/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"experiment":{"shape":"S27"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Se"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateExperimentTemplate":{"http":{"method":"PATCH","requestUri":"/experimentTemplates/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"},"description":{},"stopConditions":{"type":"list","member":{"type":"structure","required":["source"],"members":{"source":{},"value":{}}}},"targets":{"type":"map","key":{},"value":{"type":"structure","required":["resourceType","selectionMode"],"members":{"resourceType":{},"resourceArns":{"shape":"Sc"},"resourceTags":{"shape":"Se"},"filters":{"shape":"Sh"},"selectionMode":{},"parameters":{"shape":"Sn"}}}},"actions":{"type":"map","key":{},"value":{"type":"structure","members":{"actionId":{},"description":{},"parameters":{"shape":"Sv"},"targets":{"shape":"Sy"},"startAfter":{"shape":"S10"}}}},"roleArn":{},"logConfiguration":{"type":"structure","members":{"cloudWatchLogsConfiguration":{"shape":"S14"},"s3Configuration":{"shape":"S16"},"logSchemaVersion":{"type":"integer"}}}}},"output":{"type":"structure","members":{"experimentTemplate":{"shape":"S1b"}}}}},"shapes":{"Sc":{"type":"list","member":{}},"Se":{"type":"map","key":{},"value":{}},"Sh":{"type":"list","member":{"type":"structure","required":["path","values"],"members":{"path":{},"values":{"shape":"Sk"}}}},"Sk":{"type":"list","member":{}},"Sn":{"type":"map","key":{},"value":{}},"Sv":{"type":"map","key":{},"value":{}},"Sy":{"type":"map","key":{},"value":{}},"S10":{"type":"list","member":{}},"S14":{"type":"structure","required":["logGroupArn"],"members":{"logGroupArn":{}}},"S16":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"prefix":{}}},"S1b":{"type":"structure","members":{"id":{},"description":{},"targets":{"type":"map","key":{},"value":{"type":"structure","members":{"resourceType":{},"resourceArns":{"shape":"Sc"},"resourceTags":{"shape":"Se"},"filters":{"type":"list","member":{"type":"structure","members":{"path":{},"values":{"shape":"Sk"}}}},"selectionMode":{},"parameters":{"shape":"Sn"}}}},"actions":{"type":"map","key":{},"value":{"type":"structure","members":{"actionId":{},"description":{},"parameters":{"shape":"Sv"},"targets":{"shape":"Sy"},"startAfter":{"shape":"S10"}}}},"stopConditions":{"type":"list","member":{"type":"structure","members":{"source":{},"value":{}}}},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"roleArn":{},"tags":{"shape":"Se"},"logConfiguration":{"type":"structure","members":{"cloudWatchLogsConfiguration":{"type":"structure","members":{"logGroupArn":{}}},"s3Configuration":{"type":"structure","members":{"bucketName":{},"prefix":{}}},"logSchemaVersion":{"type":"integer"}}}}},"S21":{"type":"map","key":{},"value":{"type":"structure","members":{"resourceType":{}}}},"S27":{"type":"structure","members":{"id":{},"experimentTemplateId":{},"roleArn":{},"state":{"shape":"S28"},"targets":{"type":"map","key":{},"value":{"type":"structure","members":{"resourceType":{},"resourceArns":{"shape":"Sc"},"resourceTags":{"shape":"Se"},"filters":{"type":"list","member":{"type":"structure","members":{"path":{},"values":{"type":"list","member":{}}}}},"selectionMode":{},"parameters":{"type":"map","key":{},"value":{}}}}},"actions":{"type":"map","key":{},"value":{"type":"structure","members":{"actionId":{},"description":{},"parameters":{"type":"map","key":{},"value":{}},"targets":{"type":"map","key":{},"value":{}},"startAfter":{"type":"list","member":{}},"state":{"type":"structure","members":{"status":{},"reason":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}}},"stopConditions":{"type":"list","member":{"type":"structure","members":{"source":{},"value":{}}}},"creationTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"tags":{"shape":"Se"},"logConfiguration":{"type":"structure","members":{"cloudWatchLogsConfiguration":{"type":"structure","members":{"logGroupArn":{}}},"s3Configuration":{"type":"structure","members":{"bucketName":{},"prefix":{}}},"logSchemaVersion":{"type":"integer"}}}}},"S28":{"type":"structure","members":{"status":{},"reason":{}}}}}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListActions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExperimentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExperiments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListTargetResourceTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lookoutmetrics'] = {};
	AWS.LookoutMetrics = Service.defineService('lookoutmetrics', ['2017-07-25']);
	Object.defineProperty(apiLoader.services['lookoutmetrics'], '2017-07-25', {
	  get: function get() {
	    var model = __webpack_require__(998);
	    model.paginators = __webpack_require__(999).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LookoutMetrics;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"lookoutmetrics","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"LookoutMetrics","serviceFullName":"Amazon Lookout for Metrics","serviceId":"LookoutMetrics","signatureVersion":"v4","signingName":"lookoutmetrics","uid":"lookoutmetrics-2017-07-25"},"operations":{"ActivateAnomalyDetector":{"http":{"requestUri":"/ActivateAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{}}},"output":{"type":"structure","members":{}}},"BackTestAnomalyDetector":{"http":{"requestUri":"/BackTestAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{}}},"output":{"type":"structure","members":{}}},"CreateAlert":{"http":{"requestUri":"/CreateAlert"},"input":{"type":"structure","required":["AlertName","AlertSensitivityThreshold","AnomalyDetectorArn","Action"],"members":{"AlertName":{},"AlertSensitivityThreshold":{"type":"integer"},"AlertDescription":{},"AnomalyDetectorArn":{},"Action":{"shape":"Sa"},"Tags":{"shape":"Sd"}}},"output":{"type":"structure","members":{"AlertArn":{}}}},"CreateAnomalyDetector":{"http":{"requestUri":"/CreateAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorName","AnomalyDetectorConfig"],"members":{"AnomalyDetectorName":{},"AnomalyDetectorDescription":{},"AnomalyDetectorConfig":{"shape":"Sk"},"KmsKeyArn":{},"Tags":{"shape":"Sd"}}},"output":{"type":"structure","members":{"AnomalyDetectorArn":{}}}},"CreateMetricSet":{"http":{"requestUri":"/CreateMetricSet"},"input":{"type":"structure","required":["AnomalyDetectorArn","MetricSetName","MetricList","MetricSource"],"members":{"AnomalyDetectorArn":{},"MetricSetName":{},"MetricSetDescription":{},"MetricList":{"shape":"Sr"},"Offset":{"type":"integer"},"TimestampColumn":{"shape":"Sx"},"DimensionList":{"shape":"Sz"},"MetricSetFrequency":{},"MetricSource":{"shape":"S10"},"Timezone":{},"Tags":{"shape":"Sd"}}},"output":{"type":"structure","members":{"MetricSetArn":{}}}},"DeactivateAnomalyDetector":{"http":{"requestUri":"/DeactivateAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{}}},"output":{"type":"structure","members":{}}},"DeleteAlert":{"http":{"requestUri":"/DeleteAlert"},"input":{"type":"structure","required":["AlertArn"],"members":{"AlertArn":{}}},"output":{"type":"structure","members":{}}},"DeleteAnomalyDetector":{"http":{"requestUri":"/DeleteAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{}}},"output":{"type":"structure","members":{}}},"DescribeAlert":{"http":{"requestUri":"/DescribeAlert"},"input":{"type":"structure","required":["AlertArn"],"members":{"AlertArn":{}}},"output":{"type":"structure","members":{"Alert":{"type":"structure","members":{"Action":{"shape":"Sa"},"AlertDescription":{},"AlertArn":{},"AnomalyDetectorArn":{},"AlertName":{},"AlertSensitivityThreshold":{"type":"integer"},"AlertType":{},"AlertStatus":{},"LastModificationTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}}}}},"DescribeAnomalyDetectionExecutions":{"http":{"requestUri":"/DescribeAnomalyDetectionExecutions"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{},"Timestamp":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExecutionList":{"type":"list","member":{"type":"structure","members":{"Timestamp":{},"Status":{},"FailureReason":{}}}},"NextToken":{}}}},"DescribeAnomalyDetector":{"http":{"requestUri":"/DescribeAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{}}},"output":{"type":"structure","members":{"AnomalyDetectorArn":{},"AnomalyDetectorName":{},"AnomalyDetectorDescription":{},"AnomalyDetectorConfig":{"type":"structure","members":{"AnomalyDetectorFrequency":{}}},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Status":{},"FailureReason":{},"KmsKeyArn":{},"FailureType":{}}}},"DescribeMetricSet":{"http":{"requestUri":"/DescribeMetricSet"},"input":{"type":"structure","required":["MetricSetArn"],"members":{"MetricSetArn":{}}},"output":{"type":"structure","members":{"MetricSetArn":{},"AnomalyDetectorArn":{},"MetricSetName":{},"MetricSetDescription":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Offset":{"type":"integer"},"MetricList":{"shape":"Sr"},"TimestampColumn":{"shape":"Sx"},"DimensionList":{"shape":"Sz"},"MetricSetFrequency":{},"Timezone":{},"MetricSource":{"shape":"S10"}}}},"DetectMetricSetConfig":{"http":{"requestUri":"/DetectMetricSetConfig"},"input":{"type":"structure","required":["AnomalyDetectorArn","AutoDetectionMetricSource"],"members":{"AnomalyDetectorArn":{},"AutoDetectionMetricSource":{"type":"structure","members":{"S3SourceConfig":{"type":"structure","members":{"TemplatedPathList":{"shape":"S12"},"HistoricalDataPathList":{"shape":"S14"}}}}}}},"output":{"type":"structure","members":{"DetectedMetricSetConfig":{"type":"structure","members":{"Offset":{"shape":"S2y"},"MetricSetFrequency":{"shape":"S2y"},"MetricSource":{"type":"structure","members":{"S3SourceConfig":{"type":"structure","members":{"FileFormatDescriptor":{"type":"structure","members":{"CsvFormatDescriptor":{"type":"structure","members":{"FileCompression":{"shape":"S2y"},"Charset":{"shape":"S2y"},"ContainsHeader":{"shape":"S2y"},"Delimiter":{"shape":"S2y"},"HeaderList":{"shape":"S2y"},"QuoteSymbol":{"shape":"S2y"}}},"JsonFormatDescriptor":{"type":"structure","members":{"FileCompression":{"shape":"S2y"},"Charset":{"shape":"S2y"}}}}}}}}}}}}}},"GetAnomalyGroup":{"http":{"requestUri":"/GetAnomalyGroup"},"input":{"type":"structure","required":["AnomalyGroupId","AnomalyDetectorArn"],"members":{"AnomalyGroupId":{},"AnomalyDetectorArn":{}}},"output":{"type":"structure","members":{"AnomalyGroup":{"type":"structure","members":{"StartTime":{},"EndTime":{},"AnomalyGroupId":{},"AnomalyGroupScore":{"type":"double"},"PrimaryMetricName":{},"MetricLevelImpactList":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"NumTimeSeries":{"type":"integer"},"ContributionMatrix":{"type":"structure","members":{"DimensionContributionList":{"type":"list","member":{"type":"structure","members":{"DimensionName":{},"DimensionValueContributionList":{"type":"list","member":{"type":"structure","members":{"DimensionValue":{},"ContributionScore":{"type":"double"}}}}}}}}}}}}}}}}},"GetFeedback":{"http":{"requestUri":"/GetFeedback"},"input":{"type":"structure","required":["AnomalyDetectorArn","AnomalyGroupTimeSeriesFeedback"],"members":{"AnomalyDetectorArn":{},"AnomalyGroupTimeSeriesFeedback":{"type":"structure","required":["AnomalyGroupId"],"members":{"AnomalyGroupId":{},"TimeSeriesId":{}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AnomalyGroupTimeSeriesFeedback":{"type":"list","member":{"type":"structure","members":{"TimeSeriesId":{},"IsAnomaly":{"type":"boolean"}}}},"NextToken":{}}}},"GetSampleData":{"http":{"requestUri":"/GetSampleData"},"input":{"type":"structure","members":{"S3SourceConfig":{"type":"structure","required":["RoleArn","FileFormatDescriptor"],"members":{"RoleArn":{},"TemplatedPathList":{"shape":"S12"},"HistoricalDataPathList":{"shape":"S14"},"FileFormatDescriptor":{"shape":"S16"}}}}},"output":{"type":"structure","members":{"HeaderValues":{"type":"list","member":{}},"SampleRows":{"type":"list","member":{"type":"list","member":{}}}}}},"ListAlerts":{"http":{"requestUri":"/ListAlerts"},"input":{"type":"structure","members":{"AnomalyDetectorArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AlertSummaryList":{"type":"list","member":{"type":"structure","members":{"AlertArn":{},"AnomalyDetectorArn":{},"AlertName":{},"AlertSensitivityThreshold":{"type":"integer"},"AlertType":{},"AlertStatus":{},"LastModificationTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"Tags":{"shape":"Sd"}}}},"NextToken":{}}}},"ListAnomalyDetectors":{"http":{"requestUri":"/ListAnomalyDetectors"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AnomalyDetectorSummaryList":{"type":"list","member":{"type":"structure","members":{"AnomalyDetectorArn":{},"AnomalyDetectorName":{},"AnomalyDetectorDescription":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Status":{},"Tags":{"shape":"Sd"}}}},"NextToken":{}}}},"ListAnomalyGroupRelatedMetrics":{"http":{"requestUri":"/ListAnomalyGroupRelatedMetrics"},"input":{"type":"structure","required":["AnomalyDetectorArn","AnomalyGroupId"],"members":{"AnomalyDetectorArn":{},"AnomalyGroupId":{},"RelationshipTypeFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InterMetricImpactList":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"AnomalyGroupId":{},"RelationshipType":{},"ContributionPercentage":{"type":"double"}}}},"NextToken":{}}}},"ListAnomalyGroupSummaries":{"http":{"requestUri":"/ListAnomalyGroupSummaries"},"input":{"type":"structure","required":["AnomalyDetectorArn","SensitivityThreshold"],"members":{"AnomalyDetectorArn":{},"SensitivityThreshold":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AnomalyGroupSummaryList":{"type":"list","member":{"type":"structure","members":{"StartTime":{},"EndTime":{},"AnomalyGroupId":{},"AnomalyGroupScore":{"type":"double"},"PrimaryMetricName":{}}}},"AnomalyGroupStatistics":{"type":"structure","members":{"EvaluationStartDate":{},"TotalCount":{"type":"integer"},"ItemizedMetricStatsList":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"OccurrenceCount":{"type":"integer"}}}}}},"NextToken":{}}}},"ListAnomalyGroupTimeSeries":{"http":{"requestUri":"/ListAnomalyGroupTimeSeries"},"input":{"type":"structure","required":["AnomalyDetectorArn","AnomalyGroupId","MetricName"],"members":{"AnomalyDetectorArn":{},"AnomalyGroupId":{},"MetricName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AnomalyGroupId":{},"MetricName":{},"TimestampList":{"type":"list","member":{}},"NextToken":{},"TimeSeriesList":{"type":"list","member":{"type":"structure","required":["TimeSeriesId","DimensionList","MetricValueList"],"members":{"TimeSeriesId":{},"DimensionList":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValue"],"members":{"DimensionName":{},"DimensionValue":{}}}},"MetricValueList":{"type":"list","member":{"type":"double"}}}}}}}},"ListMetricSets":{"http":{"requestUri":"/ListMetricSets"},"input":{"type":"structure","members":{"AnomalyDetectorArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"MetricSetSummaryList":{"type":"list","member":{"type":"structure","members":{"MetricSetArn":{},"AnomalyDetectorArn":{},"MetricSetDescription":{},"MetricSetName":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Tags":{"shape":"Sd"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sd","locationName":"Tags"}}}},"PutFeedback":{"http":{"requestUri":"/PutFeedback"},"input":{"type":"structure","required":["AnomalyDetectorArn","AnomalyGroupTimeSeriesFeedback"],"members":{"AnomalyDetectorArn":{},"AnomalyGroupTimeSeriesFeedback":{"type":"structure","required":["AnomalyGroupId","TimeSeriesId","IsAnomaly"],"members":{"AnomalyGroupId":{},"TimeSeriesId":{},"IsAnomaly":{"type":"boolean"}}}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAnomalyDetector":{"http":{"requestUri":"/UpdateAnomalyDetector"},"input":{"type":"structure","required":["AnomalyDetectorArn"],"members":{"AnomalyDetectorArn":{},"KmsKeyArn":{},"AnomalyDetectorDescription":{},"AnomalyDetectorConfig":{"shape":"Sk"}}},"output":{"type":"structure","members":{"AnomalyDetectorArn":{}}}},"UpdateMetricSet":{"http":{"requestUri":"/UpdateMetricSet"},"input":{"type":"structure","required":["MetricSetArn"],"members":{"MetricSetArn":{},"MetricSetDescription":{},"MetricList":{"shape":"Sr"},"Offset":{"type":"integer"},"TimestampColumn":{"shape":"Sx"},"DimensionList":{"shape":"Sz"},"MetricSetFrequency":{},"MetricSource":{"shape":"S10"}}},"output":{"type":"structure","members":{"MetricSetArn":{}}}}},"shapes":{"Sa":{"type":"structure","members":{"SNSConfiguration":{"type":"structure","required":["RoleArn","SnsTopicArn"],"members":{"RoleArn":{},"SnsTopicArn":{}}},"LambdaConfiguration":{"type":"structure","required":["RoleArn","LambdaArn"],"members":{"RoleArn":{},"LambdaArn":{}}}}},"Sd":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","members":{"AnomalyDetectorFrequency":{}}},"Sr":{"type":"list","member":{"type":"structure","required":["MetricName","AggregationFunction"],"members":{"MetricName":{},"AggregationFunction":{},"Namespace":{}}}},"Sx":{"type":"structure","members":{"ColumnName":{},"ColumnFormat":{}}},"Sz":{"type":"list","member":{}},"S10":{"type":"structure","members":{"S3SourceConfig":{"type":"structure","members":{"RoleArn":{},"TemplatedPathList":{"shape":"S12"},"HistoricalDataPathList":{"shape":"S14"},"FileFormatDescriptor":{"shape":"S16"}}},"AppFlowConfig":{"type":"structure","members":{"RoleArn":{},"FlowName":{}}},"CloudWatchConfig":{"type":"structure","members":{"RoleArn":{}}},"RDSSourceConfig":{"type":"structure","members":{"DBInstanceIdentifier":{},"DatabaseHost":{},"DatabasePort":{"type":"integer"},"SecretManagerArn":{},"DatabaseName":{},"TableName":{},"RoleArn":{},"VpcConfiguration":{"shape":"S1q"}}},"RedshiftSourceConfig":{"type":"structure","members":{"ClusterIdentifier":{},"DatabaseHost":{},"DatabasePort":{"type":"integer"},"SecretManagerArn":{},"DatabaseName":{},"TableName":{},"RoleArn":{},"VpcConfiguration":{"shape":"S1q"}}}}},"S12":{"type":"list","member":{}},"S14":{"type":"list","member":{}},"S16":{"type":"structure","members":{"CsvFormatDescriptor":{"type":"structure","members":{"FileCompression":{},"Charset":{},"ContainsHeader":{"type":"boolean"},"Delimiter":{},"HeaderList":{"type":"list","member":{}},"QuoteSymbol":{}}},"JsonFormatDescriptor":{"type":"structure","members":{"FileCompression":{},"Charset":{}}}}},"S1q":{"type":"structure","required":["SubnetIdList","SecurityGroupIdList"],"members":{"SubnetIdList":{"type":"list","member":{}},"SecurityGroupIdList":{"type":"list","member":{}}}},"S2y":{"type":"structure","members":{"Value":{"type":"structure","members":{"S":{},"N":{},"B":{},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{}}}},"Confidence":{},"Message":{}}}}}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAnomalyDetectionExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetFeedback":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAlerts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAnomalyDetectors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAnomalyGroupRelatedMetrics":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAnomalyGroupSummaries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAnomalyGroupTimeSeries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMetricSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['mgn'] = {};
	AWS.Mgn = Service.defineService('mgn', ['2020-02-26']);
	Object.defineProperty(apiLoader.services['mgn'], '2020-02-26', {
	  get: function get() {
	    var model = __webpack_require__(1001);
	    model.paginators = __webpack_require__(1002).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Mgn;


/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-02-26","endpointPrefix":"mgn","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"mgn","serviceFullName":"Application Migration Service","serviceId":"mgn","signatureVersion":"v4","signingName":"mgn","uid":"mgn-2020-02-26"},"operations":{"ChangeServerLifeCycleState":{"http":{"requestUri":"/ChangeServerLifeCycleState","responseCode":200},"input":{"type":"structure","required":["lifeCycle","sourceServerID"],"members":{"lifeCycle":{"type":"structure","required":["state"],"members":{"state":{}}},"sourceServerID":{}}},"output":{"shape":"S5"}},"CreateReplicationConfigurationTemplate":{"http":{"requestUri":"/CreateReplicationConfigurationTemplate","responseCode":201},"input":{"type":"structure","required":["associateDefaultSecurityGroup","bandwidthThrottling","createPublicIP","dataPlaneRouting","defaultLargeStagingDiskType","ebsEncryption","replicationServerInstanceType","replicationServersSecurityGroupsIDs","stagingAreaSubnetId","stagingAreaTags","useDedicatedReplicationServer"],"members":{"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"S1l"},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"S1d"},"tags":{"shape":"S1d"},"useDedicatedReplicationServer":{"type":"boolean"}}},"output":{"shape":"S1o"}},"DeleteJob":{"http":{"requestUri":"/DeleteJob","responseCode":204},"input":{"type":"structure","required":["jobID"],"members":{"jobID":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteReplicationConfigurationTemplate":{"http":{"requestUri":"/DeleteReplicationConfigurationTemplate","responseCode":204},"input":{"type":"structure","required":["replicationConfigurationTemplateID"],"members":{"replicationConfigurationTemplateID":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteSourceServer":{"http":{"requestUri":"/DeleteSourceServer","responseCode":204},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteVcenterClient":{"http":{"requestUri":"/DeleteVcenterClient","responseCode":204},"input":{"type":"structure","required":["vcenterClientID"],"members":{"vcenterClientID":{}}},"idempotent":true},"DescribeJobLogItems":{"http":{"requestUri":"/DescribeJobLogItems","responseCode":200},"input":{"type":"structure","required":["jobID"],"members":{"jobID":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"type":"structure","members":{"event":{},"eventData":{"type":"structure","members":{"conversionServerID":{},"rawError":{},"sourceServerID":{},"targetInstanceID":{}}},"logDateTime":{}}}},"nextToken":{}}}},"DescribeJobs":{"http":{"requestUri":"/DescribeJobs","responseCode":200},"input":{"type":"structure","members":{"filters":{"type":"structure","members":{"fromDate":{},"jobIDs":{"type":"list","member":{}},"toDate":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"shape":"S2a"}},"nextToken":{}}}},"DescribeReplicationConfigurationTemplates":{"http":{"requestUri":"/DescribeReplicationConfigurationTemplates","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{},"replicationConfigurationTemplateIDs":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"shape":"S1o"}},"nextToken":{}}}},"DescribeSourceServers":{"http":{"requestUri":"/DescribeSourceServers","responseCode":200},"input":{"type":"structure","members":{"filters":{"type":"structure","members":{"isArchived":{"type":"boolean"},"lifeCycleStates":{"type":"list","member":{}},"replicationTypes":{"type":"list","member":{}},"sourceServerIDs":{"type":"list","member":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"shape":"S5"}},"nextToken":{}}}},"DescribeVcenterClients":{"http":{"method":"GET","requestUri":"/DescribeVcenterClients","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"type":"structure","members":{"arn":{},"datacenterName":{},"hostname":{},"lastSeenDatetime":{},"sourceServerTags":{"shape":"S1d"},"tags":{"shape":"S1d"},"vcenterClientID":{},"vcenterUUID":{}}}},"nextToken":{}}}},"DisconnectFromService":{"http":{"requestUri":"/DisconnectFromService","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S5"}},"FinalizeCutover":{"http":{"requestUri":"/FinalizeCutover","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S5"}},"GetLaunchConfiguration":{"http":{"requestUri":"/GetLaunchConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S2z"}},"GetReplicationConfiguration":{"http":{"requestUri":"/GetReplicationConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S36"}},"InitializeService":{"http":{"requestUri":"/InitializeService","responseCode":204},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1d"}}}},"MarkAsArchived":{"http":{"requestUri":"/MarkAsArchived","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S5"}},"RetryDataReplication":{"http":{"requestUri":"/RetryDataReplication","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S5"}},"StartCutover":{"http":{"requestUri":"/StartCutover","responseCode":202},"input":{"type":"structure","required":["sourceServerIDs"],"members":{"sourceServerIDs":{"type":"list","member":{}},"tags":{"shape":"S1d"}}},"output":{"type":"structure","members":{"job":{"shape":"S2a"}}}},"StartReplication":{"http":{"requestUri":"/StartReplication","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S5"}},"StartTest":{"http":{"requestUri":"/StartTest","responseCode":202},"input":{"type":"structure","required":["sourceServerIDs"],"members":{"sourceServerIDs":{"type":"list","member":{}},"tags":{"shape":"S1d"}}},"output":{"type":"structure","members":{"job":{"shape":"S2a"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1d"}}},"idempotent":true},"TerminateTargetInstances":{"http":{"requestUri":"/TerminateTargetInstances","responseCode":202},"input":{"type":"structure","required":["sourceServerIDs"],"members":{"sourceServerIDs":{"type":"list","member":{}},"tags":{"shape":"S1d"}}},"output":{"type":"structure","members":{"job":{"shape":"S2a"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{},"sensitive":true}}},"idempotent":true},"UpdateLaunchConfiguration":{"http":{"requestUri":"/UpdateLaunchConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"bootMode":{},"copyPrivateIp":{"type":"boolean"},"copyTags":{"type":"boolean"},"launchDisposition":{},"licensing":{"shape":"S32"},"name":{},"sourceServerID":{},"targetInstanceTypeRightSizingMethod":{}}},"output":{"shape":"S2z"},"idempotent":true},"UpdateReplicationConfiguration":{"http":{"requestUri":"/UpdateReplicationConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"name":{},"replicatedDisks":{"shape":"S37"},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"S1l"},"sourceServerID":{},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"S1d"},"useDedicatedReplicationServer":{"type":"boolean"}}},"output":{"shape":"S36"},"idempotent":true},"UpdateReplicationConfigurationTemplate":{"http":{"requestUri":"/UpdateReplicationConfigurationTemplate","responseCode":200},"input":{"type":"structure","required":["replicationConfigurationTemplateID"],"members":{"arn":{},"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"replicationConfigurationTemplateID":{},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"S1l"},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"S1d"},"useDedicatedReplicationServer":{"type":"boolean"}}},"output":{"shape":"S1o"}},"UpdateSourceServerReplicationType":{"http":{"requestUri":"/UpdateSourceServerReplicationType","responseCode":200},"input":{"type":"structure","required":["replicationType","sourceServerID"],"members":{"replicationType":{},"sourceServerID":{}}},"output":{"shape":"S5"}}},"shapes":{"S5":{"type":"structure","members":{"arn":{},"dataReplicationInfo":{"type":"structure","members":{"dataReplicationError":{"type":"structure","members":{"error":{},"rawError":{}}},"dataReplicationInitiation":{"type":"structure","members":{"nextAttemptDateTime":{},"startDateTime":{},"steps":{"type":"list","member":{"type":"structure","members":{"name":{},"status":{}}}}}},"dataReplicationState":{},"etaDateTime":{},"lagDuration":{},"lastSnapshotDateTime":{},"replicatedDisks":{"type":"list","member":{"type":"structure","members":{"backloggedStorageBytes":{"type":"long"},"deviceName":{},"replicatedStorageBytes":{"type":"long"},"rescannedStorageBytes":{"type":"long"},"totalStorageBytes":{"type":"long"}}}}}},"isArchived":{"type":"boolean"},"launchedInstance":{"type":"structure","members":{"ec2InstanceID":{},"firstBoot":{},"jobID":{}}},"lifeCycle":{"type":"structure","members":{"addedToServiceDateTime":{},"elapsedReplicationDuration":{},"firstByteDateTime":{},"lastCutover":{"type":"structure","members":{"finalized":{"type":"structure","members":{"apiCallDateTime":{}}},"initiated":{"type":"structure","members":{"apiCallDateTime":{},"jobID":{}}},"reverted":{"type":"structure","members":{"apiCallDateTime":{}}}}},"lastSeenByServiceDateTime":{},"lastTest":{"type":"structure","members":{"finalized":{"type":"structure","members":{"apiCallDateTime":{}}},"initiated":{"type":"structure","members":{"apiCallDateTime":{},"jobID":{}}},"reverted":{"type":"structure","members":{"apiCallDateTime":{}}}}},"state":{}}},"replicationType":{},"sourceProperties":{"type":"structure","members":{"cpus":{"type":"list","member":{"type":"structure","members":{"cores":{"type":"long"},"modelName":{}}}},"disks":{"type":"list","member":{"type":"structure","members":{"bytes":{"type":"long"},"deviceName":{}}}},"identificationHints":{"type":"structure","members":{"awsInstanceID":{},"fqdn":{},"hostname":{},"vmPath":{},"vmWareUuid":{}}},"lastUpdatedDateTime":{},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"ips":{"type":"list","member":{}},"isPrimary":{"type":"boolean"},"macAddress":{}}}},"os":{"type":"structure","members":{"fullString":{}}},"ramBytes":{"type":"long"},"recommendedInstanceType":{}}},"sourceServerID":{},"tags":{"shape":"S1d"},"vcenterClientID":{}}},"S1d":{"type":"map","key":{},"value":{},"sensitive":true},"S1l":{"type":"list","member":{}},"S1o":{"type":"structure","required":["replicationConfigurationTemplateID"],"members":{"arn":{},"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"replicationConfigurationTemplateID":{},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"S1l"},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"S1d"},"tags":{"shape":"S1d"},"useDedicatedReplicationServer":{"type":"boolean"}}},"S2a":{"type":"structure","required":["jobID"],"members":{"arn":{},"creationDateTime":{},"endDateTime":{},"initiatedBy":{},"jobID":{},"participatingServers":{"type":"list","member":{"type":"structure","members":{"launchStatus":{},"sourceServerID":{}}}},"status":{},"tags":{"shape":"S1d"},"type":{}}},"S2z":{"type":"structure","members":{"bootMode":{},"copyPrivateIp":{"type":"boolean"},"copyTags":{"type":"boolean"},"ec2LaunchTemplateID":{},"launchDisposition":{},"licensing":{"shape":"S32"},"name":{},"sourceServerID":{},"targetInstanceTypeRightSizingMethod":{}}},"S32":{"type":"structure","members":{"osByol":{"type":"boolean"}}},"S36":{"type":"structure","members":{"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"name":{},"replicatedDisks":{"shape":"S37"},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"S1l"},"sourceServerID":{},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"S1d"},"useDedicatedReplicationServer":{"type":"boolean"}}},"S37":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"iops":{"type":"long"},"isBootDisk":{"type":"boolean"},"stagingDiskType":{},"throughput":{"type":"long"}}}}}}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeJobLogItems":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeReplicationConfigurationTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeSourceServers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeVcenterClients":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"}}}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['lookoutequipment'] = {};
	AWS.LookoutEquipment = Service.defineService('lookoutequipment', ['2020-12-15']);
	Object.defineProperty(apiLoader.services['lookoutequipment'], '2020-12-15', {
	  get: function get() {
	    var model = __webpack_require__(1004);
	    model.paginators = __webpack_require__(1005).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.LookoutEquipment;


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-12-15","endpointPrefix":"lookoutequipment","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"LookoutEquipment","serviceFullName":"Amazon Lookout for Equipment","serviceId":"LookoutEquipment","signatureVersion":"v4","targetPrefix":"AWSLookoutEquipmentFrontendService","uid":"lookoutequipment-2020-12-15"},"operations":{"CreateDataset":{"input":{"type":"structure","required":["DatasetName","ClientToken"],"members":{"DatasetName":{},"DatasetSchema":{"shape":"S3"},"ServerSideKmsKeyId":{},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"DatasetName":{},"DatasetArn":{},"Status":{}}}},"CreateInferenceScheduler":{"input":{"type":"structure","required":["ModelName","InferenceSchedulerName","DataUploadFrequency","DataInputConfiguration","DataOutputConfiguration","RoleArn","ClientToken"],"members":{"ModelName":{},"InferenceSchedulerName":{},"DataDelayOffsetInMinutes":{"type":"long"},"DataUploadFrequency":{},"DataInputConfiguration":{"shape":"Sj"},"DataOutputConfiguration":{"shape":"Sr"},"RoleArn":{},"ServerSideKmsKeyId":{},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"InferenceSchedulerArn":{},"InferenceSchedulerName":{},"Status":{}}}},"CreateModel":{"input":{"type":"structure","required":["ModelName","DatasetName","ClientToken"],"members":{"ModelName":{},"DatasetName":{},"DatasetSchema":{"shape":"S3"},"LabelsInputConfiguration":{"shape":"Sz"},"ClientToken":{"idempotencyToken":true},"TrainingDataStartTime":{"type":"timestamp"},"TrainingDataEndTime":{"type":"timestamp"},"EvaluationDataStartTime":{"type":"timestamp"},"EvaluationDataEndTime":{"type":"timestamp"},"RoleArn":{},"DataPreProcessingConfiguration":{"shape":"S12"},"ServerSideKmsKeyId":{},"Tags":{"shape":"S7"},"OffCondition":{}}},"output":{"type":"structure","members":{"ModelArn":{},"Status":{}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetName"],"members":{"DatasetName":{}}}},"DeleteInferenceScheduler":{"input":{"type":"structure","required":["InferenceSchedulerName"],"members":{"InferenceSchedulerName":{}}}},"DeleteModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}}},"DescribeDataIngestionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"DatasetArn":{},"IngestionInputConfiguration":{"shape":"S1f"},"RoleArn":{},"CreatedAt":{"type":"timestamp"},"Status":{},"FailedReason":{},"DataQualitySummary":{"shape":"S1k"},"IngestedFilesSummary":{"shape":"S1t"},"StatusDetail":{},"IngestedDataSize":{"type":"long"},"DataStartTime":{"type":"timestamp"},"DataEndTime":{"type":"timestamp"}}}},"DescribeDataset":{"input":{"type":"structure","required":["DatasetName"],"members":{"DatasetName":{}}},"output":{"type":"structure","members":{"DatasetName":{},"DatasetArn":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Status":{},"Schema":{"jsonvalue":true},"ServerSideKmsKeyId":{},"IngestionInputConfiguration":{"shape":"S1f"},"DataQualitySummary":{"shape":"S1k"},"IngestedFilesSummary":{"shape":"S1t"},"RoleArn":{},"DataStartTime":{"type":"timestamp"},"DataEndTime":{"type":"timestamp"}}}},"DescribeInferenceScheduler":{"input":{"type":"structure","required":["InferenceSchedulerName"],"members":{"InferenceSchedulerName":{}}},"output":{"type":"structure","members":{"ModelArn":{},"ModelName":{},"InferenceSchedulerName":{},"InferenceSchedulerArn":{},"Status":{},"DataDelayOffsetInMinutes":{"type":"long"},"DataUploadFrequency":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"DataInputConfiguration":{"shape":"Sj"},"DataOutputConfiguration":{"shape":"Sr"},"RoleArn":{},"ServerSideKmsKeyId":{}}}},"DescribeModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}},"output":{"type":"structure","members":{"ModelName":{},"ModelArn":{},"DatasetName":{},"DatasetArn":{},"Schema":{"jsonvalue":true},"LabelsInputConfiguration":{"shape":"Sz"},"TrainingDataStartTime":{"type":"timestamp"},"TrainingDataEndTime":{"type":"timestamp"},"EvaluationDataStartTime":{"type":"timestamp"},"EvaluationDataEndTime":{"type":"timestamp"},"RoleArn":{},"DataPreProcessingConfiguration":{"shape":"S12"},"Status":{},"TrainingExecutionStartTime":{"type":"timestamp"},"TrainingExecutionEndTime":{"type":"timestamp"},"FailedReason":{},"ModelMetrics":{"jsonvalue":true},"LastUpdatedTime":{"type":"timestamp"},"CreatedAt":{"type":"timestamp"},"ServerSideKmsKeyId":{},"OffCondition":{}}}},"ListDataIngestionJobs":{"input":{"type":"structure","members":{"DatasetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Status":{}}},"output":{"type":"structure","members":{"NextToken":{},"DataIngestionJobSummaries":{"type":"list","member":{"type":"structure","members":{"JobId":{},"DatasetName":{},"DatasetArn":{},"IngestionInputConfiguration":{"shape":"S1f"},"Status":{}}}}}}},"ListDatasets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"DatasetNameBeginsWith":{}}},"output":{"type":"structure","members":{"NextToken":{},"DatasetSummaries":{"type":"list","member":{"type":"structure","members":{"DatasetName":{},"DatasetArn":{},"Status":{},"CreatedAt":{"type":"timestamp"}}}}}}},"ListInferenceExecutions":{"input":{"type":"structure","required":["InferenceSchedulerName"],"members":{"NextToken":{},"MaxResults":{"type":"integer"},"InferenceSchedulerName":{},"DataStartTimeAfter":{"type":"timestamp"},"DataEndTimeBefore":{"type":"timestamp"},"Status":{}}},"output":{"type":"structure","members":{"NextToken":{},"InferenceExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"ModelName":{},"ModelArn":{},"InferenceSchedulerName":{},"InferenceSchedulerArn":{},"ScheduledStartTime":{"type":"timestamp"},"DataStartTime":{"type":"timestamp"},"DataEndTime":{"type":"timestamp"},"DataInputConfiguration":{"shape":"Sj"},"DataOutputConfiguration":{"shape":"Sr"},"CustomerResultObject":{"shape":"S1v"},"Status":{},"FailedReason":{}}}}}}},"ListInferenceSchedulers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"InferenceSchedulerNameBeginsWith":{},"ModelName":{}}},"output":{"type":"structure","members":{"NextToken":{},"InferenceSchedulerSummaries":{"type":"list","member":{"type":"structure","members":{"ModelName":{},"ModelArn":{},"InferenceSchedulerName":{},"InferenceSchedulerArn":{},"Status":{},"DataDelayOffsetInMinutes":{"type":"long"},"DataUploadFrequency":{}}}}}}},"ListModels":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{},"ModelNameBeginsWith":{},"DatasetNameBeginsWith":{}}},"output":{"type":"structure","members":{"NextToken":{},"ModelSummaries":{"type":"list","member":{"type":"structure","members":{"ModelName":{},"ModelArn":{},"DatasetName":{},"DatasetArn":{},"Status":{},"CreatedAt":{"type":"timestamp"}}}}}}},"ListSensorStatistics":{"input":{"type":"structure","required":["DatasetName"],"members":{"DatasetName":{},"IngestionJobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SensorStatisticsSummaries":{"type":"list","member":{"type":"structure","members":{"ComponentName":{},"SensorName":{},"DataExists":{"type":"boolean"},"MissingValues":{"shape":"S30"},"InvalidValues":{"shape":"S30"},"InvalidDateEntries":{"shape":"S30"},"DuplicateTimestamps":{"shape":"S30"},"CategoricalValues":{"type":"structure","required":["Status"],"members":{"Status":{},"NumberOfCategory":{"type":"integer"}}},"MultipleOperatingModes":{"type":"structure","required":["Status"],"members":{"Status":{}}},"LargeTimestampGaps":{"type":"structure","required":["Status"],"members":{"Status":{},"NumberOfLargeTimestampGaps":{"type":"integer"},"MaxTimestampGapInDays":{"type":"integer"}}},"MonotonicValues":{"type":"structure","required":["Status"],"members":{"Status":{},"Monotonicity":{}}},"DataStartTime":{"type":"timestamp"},"DataEndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"}}}},"StartDataIngestionJob":{"input":{"type":"structure","required":["DatasetName","IngestionInputConfiguration","RoleArn","ClientToken"],"members":{"DatasetName":{},"IngestionInputConfiguration":{"shape":"S1f"},"RoleArn":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"JobId":{},"Status":{}}}},"StartInferenceScheduler":{"input":{"type":"structure","required":["InferenceSchedulerName"],"members":{"InferenceSchedulerName":{}}},"output":{"type":"structure","members":{"ModelArn":{},"ModelName":{},"InferenceSchedulerName":{},"InferenceSchedulerArn":{},"Status":{}}}},"StopInferenceScheduler":{"input":{"type":"structure","required":["InferenceSchedulerName"],"members":{"InferenceSchedulerName":{}}},"output":{"type":"structure","members":{"ModelArn":{},"ModelName":{},"InferenceSchedulerName":{},"InferenceSchedulerArn":{},"Status":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateInferenceScheduler":{"input":{"type":"structure","required":["InferenceSchedulerName"],"members":{"InferenceSchedulerName":{},"DataDelayOffsetInMinutes":{"type":"long"},"DataUploadFrequency":{},"DataInputConfiguration":{"shape":"Sj"},"DataOutputConfiguration":{"shape":"Sr"},"RoleArn":{}}}}},"shapes":{"S3":{"type":"structure","members":{"InlineDataSchema":{"jsonvalue":true}}},"S7":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sj":{"type":"structure","members":{"S3InputConfiguration":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Prefix":{}}},"InputTimeZoneOffset":{},"InferenceInputNameConfiguration":{"type":"structure","members":{"TimestampFormat":{},"ComponentTimestampDelimiter":{}}}}},"Sr":{"type":"structure","required":["S3OutputConfiguration"],"members":{"S3OutputConfiguration":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Prefix":{}}},"KmsKeyId":{}}},"Sz":{"type":"structure","required":["S3InputConfiguration"],"members":{"S3InputConfiguration":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Prefix":{}}}}},"S12":{"type":"structure","members":{"TargetSamplingRate":{}}},"S1f":{"type":"structure","required":["S3InputConfiguration"],"members":{"S3InputConfiguration":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Prefix":{},"KeyPattern":{}}}}},"S1k":{"type":"structure","required":["InsufficientSensorData","MissingSensorData","InvalidSensorData","UnsupportedTimestamps","DuplicateTimestamps"],"members":{"InsufficientSensorData":{"type":"structure","required":["MissingCompleteSensorData","SensorsWithShortDateRange"],"members":{"MissingCompleteSensorData":{"type":"structure","required":["AffectedSensorCount"],"members":{"AffectedSensorCount":{"type":"integer"}}},"SensorsWithShortDateRange":{"type":"structure","required":["AffectedSensorCount"],"members":{"AffectedSensorCount":{"type":"integer"}}}}},"MissingSensorData":{"type":"structure","required":["AffectedSensorCount","TotalNumberOfMissingValues"],"members":{"AffectedSensorCount":{"type":"integer"},"TotalNumberOfMissingValues":{"type":"integer"}}},"InvalidSensorData":{"type":"structure","required":["AffectedSensorCount","TotalNumberOfInvalidValues"],"members":{"AffectedSensorCount":{"type":"integer"},"TotalNumberOfInvalidValues":{"type":"integer"}}},"UnsupportedTimestamps":{"type":"structure","required":["TotalNumberOfUnsupportedTimestamps"],"members":{"TotalNumberOfUnsupportedTimestamps":{"type":"integer"}}},"DuplicateTimestamps":{"type":"structure","required":["TotalNumberOfDuplicateTimestamps"],"members":{"TotalNumberOfDuplicateTimestamps":{"type":"integer"}}}}},"S1t":{"type":"structure","required":["TotalNumberOfFiles","IngestedNumberOfFiles"],"members":{"TotalNumberOfFiles":{"type":"integer"},"IngestedNumberOfFiles":{"type":"integer"},"DiscardedFiles":{"type":"list","member":{"shape":"S1v"}}}},"S1v":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{},"Key":{}}},"S30":{"type":"structure","required":["Count","Percentage"],"members":{"Count":{"type":"integer"},"Percentage":{"type":"float"}}}}}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDataIngestionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDatasets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListInferenceExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListInferenceSchedulers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListModels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSensorStatistics":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['nimble'] = {};
	AWS.Nimble = Service.defineService('nimble', ['2020-08-01']);
	Object.defineProperty(apiLoader.services['nimble'], '2020-08-01', {
	  get: function get() {
	    var model = __webpack_require__(1007);
	    model.paginators = __webpack_require__(1008).pagination;
	    model.waiters = __webpack_require__(1009).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Nimble;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-01","endpointPrefix":"nimble","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AmazonNimbleStudio","serviceId":"nimble","signatureVersion":"v4","signingName":"nimble","uid":"nimble-2020-08-01"},"operations":{"AcceptEulas":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/eula-acceptances","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"eulaIds":{"shape":"S3"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"eulaAcceptances":{"shape":"S6"}}}},"CreateLaunchProfile":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/launch-profiles","responseCode":200},"input":{"type":"structure","required":["ec2SubnetIds","launchProfileProtocolVersions","name","streamConfiguration","studioComponentIds","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"description":{"shape":"Sc"},"ec2SubnetIds":{"shape":"Sd"},"launchProfileProtocolVersions":{"shape":"Sf"},"name":{"shape":"Sh"},"streamConfiguration":{"shape":"Si"},"studioComponentIds":{"shape":"Sw"},"studioId":{"location":"uri","locationName":"studioId"},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"launchProfile":{"shape":"Sz"}}}},"CreateStreamingImage":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/streaming-images","responseCode":200},"input":{"type":"structure","required":["ec2ImageId","name","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"description":{"type":"string","sensitive":true},"ec2ImageId":{},"name":{"type":"string","sensitive":true},"studioId":{"location":"uri","locationName":"studioId"},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"streamingImage":{"shape":"S1f"}}}},"CreateStreamingSession":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"ec2InstanceType":{},"launchProfileId":{},"ownedBy":{},"streamingImageId":{},"studioId":{"location":"uri","locationName":"studioId"},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"session":{"shape":"S1r"}}}},"CreateStreamingSessionStream":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions/{sessionId}/streams","responseCode":200},"input":{"type":"structure","required":["sessionId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"expirationInSeconds":{"type":"integer"},"sessionId":{"location":"uri","locationName":"sessionId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"stream":{"shape":"S1y"}}},"idempotent":true},"CreateStudio":{"http":{"requestUri":"/2020-08-01/studios","responseCode":200},"input":{"type":"structure","required":["adminRoleArn","displayName","studioName","userRoleArn"],"members":{"adminRoleArn":{},"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"displayName":{"type":"string","sensitive":true},"studioEncryptionConfiguration":{"shape":"S24"},"studioName":{},"tags":{"shape":"Sx"},"userRoleArn":{}}},"output":{"type":"structure","members":{"studio":{"shape":"S29"}}}},"CreateStudioComponent":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/studio-components","responseCode":200},"input":{"type":"structure","required":["name","studioId","type"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"configuration":{"shape":"S2f"},"description":{"shape":"S2v"},"ec2SecurityGroupIds":{"shape":"S2w"},"initializationScripts":{"shape":"S2y"},"name":{"shape":"S33"},"scriptParameters":{"shape":"S34"},"studioId":{"location":"uri","locationName":"studioId"},"subtype":{},"tags":{"shape":"Sx"},"type":{}}},"output":{"type":"structure","members":{"studioComponent":{"shape":"S3b"}}}},"DeleteLaunchProfile":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}","responseCode":200},"input":{"type":"structure","required":["launchProfileId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"launchProfile":{"shape":"Sz"}}},"idempotent":true},"DeleteLaunchProfileMember":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/membership/{principalId}","responseCode":200},"input":{"type":"structure","required":["launchProfileId","principalId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"principalId":{"location":"uri","locationName":"principalId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteStreamingImage":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}/streaming-images/{streamingImageId}","responseCode":200},"input":{"type":"structure","required":["streamingImageId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"streamingImageId":{"location":"uri","locationName":"streamingImageId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"streamingImage":{"shape":"S1f"}}},"idempotent":true},"DeleteStreamingSession":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions/{sessionId}","responseCode":200},"input":{"type":"structure","required":["sessionId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"sessionId":{"location":"uri","locationName":"sessionId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"session":{"shape":"S1r"}}},"idempotent":true},"DeleteStudio":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","required":["studio"],"members":{"studio":{"shape":"S29"}}},"idempotent":true},"DeleteStudioComponent":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}/studio-components/{studioComponentId}","responseCode":200},"input":{"type":"structure","required":["studioComponentId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"studioComponentId":{"location":"uri","locationName":"studioComponentId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"studioComponent":{"shape":"S3b"}}},"idempotent":true},"DeleteStudioMember":{"http":{"method":"DELETE","requestUri":"/2020-08-01/studios/{studioId}/membership/{principalId}","responseCode":200},"input":{"type":"structure","required":["principalId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"principalId":{"location":"uri","locationName":"principalId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetEula":{"http":{"method":"GET","requestUri":"/2020-08-01/eulas/{eulaId}","responseCode":200},"input":{"type":"structure","required":["eulaId"],"members":{"eulaId":{"location":"uri","locationName":"eulaId"}}},"output":{"type":"structure","members":{"eula":{"shape":"S3v"}}}},"GetLaunchProfile":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}","responseCode":200},"input":{"type":"structure","required":["launchProfileId","studioId"],"members":{"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"launchProfile":{"shape":"Sz"}}}},"GetLaunchProfileDetails":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/details","responseCode":200},"input":{"type":"structure","required":["launchProfileId","studioId"],"members":{"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"launchProfile":{"shape":"Sz"},"streamingImages":{"shape":"S41"},"studioComponentSummaries":{"type":"list","member":{"type":"structure","members":{"createdAt":{"shape":"S8"},"createdBy":{},"description":{"shape":"S2v"},"name":{"shape":"S33"},"studioComponentId":{},"subtype":{},"type":{},"updatedAt":{"shape":"S8"},"updatedBy":{}}}}}}},"GetLaunchProfileInitialization":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/init","responseCode":200},"input":{"type":"structure","required":["launchProfileId","launchProfileProtocolVersions","launchPurpose","platform","studioId"],"members":{"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"launchProfileProtocolVersions":{"shape":"S45","location":"querystring","locationName":"launchProfileProtocolVersions"},"launchPurpose":{"location":"querystring","locationName":"launchPurpose"},"platform":{"location":"querystring","locationName":"platform"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"launchProfileInitialization":{"type":"structure","members":{"activeDirectory":{"type":"structure","members":{"computerAttributes":{"shape":"S2h"},"directoryId":{},"directoryName":{},"dnsIpAddresses":{"type":"list","member":{}},"organizationalUnitDistinguishedName":{},"studioComponentId":{},"studioComponentName":{"shape":"S33"}}},"ec2SecurityGroupIds":{"type":"list","member":{}},"launchProfileId":{},"launchProfileProtocolVersion":{},"launchPurpose":{},"name":{"shape":"Sh"},"platform":{},"systemInitializationScripts":{"shape":"S4d"},"userInitializationScripts":{"shape":"S4d"}}}}}},"GetLaunchProfileMember":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/membership/{principalId}","responseCode":200},"input":{"type":"structure","required":["launchProfileId","principalId","studioId"],"members":{"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"principalId":{"location":"uri","locationName":"principalId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"member":{"shape":"S4h"}}}},"GetStreamingImage":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/streaming-images/{streamingImageId}","responseCode":200},"input":{"type":"structure","required":["streamingImageId","studioId"],"members":{"streamingImageId":{"location":"uri","locationName":"streamingImageId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"streamingImage":{"shape":"S1f"}}}},"GetStreamingSession":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions/{sessionId}","responseCode":200},"input":{"type":"structure","required":["sessionId","studioId"],"members":{"sessionId":{"location":"uri","locationName":"sessionId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"session":{"shape":"S1r"}}}},"GetStreamingSessionStream":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions/{sessionId}/streams/{streamId}","responseCode":200},"input":{"type":"structure","required":["sessionId","streamId","studioId"],"members":{"sessionId":{"location":"uri","locationName":"sessionId"},"streamId":{"location":"uri","locationName":"streamId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"stream":{"shape":"S1y"}}}},"GetStudio":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","required":["studio"],"members":{"studio":{"shape":"S29"}}}},"GetStudioComponent":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/studio-components/{studioComponentId}","responseCode":200},"input":{"type":"structure","required":["studioComponentId","studioId"],"members":{"studioComponentId":{"location":"uri","locationName":"studioComponentId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"studioComponent":{"shape":"S3b"}}}},"GetStudioMember":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/membership/{principalId}","responseCode":200},"input":{"type":"structure","required":["principalId","studioId"],"members":{"principalId":{"location":"uri","locationName":"principalId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"member":{"shape":"S4v"}}}},"ListEulaAcceptances":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/eula-acceptances","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"eulaIds":{"shape":"S45","location":"querystring","locationName":"eulaIds"},"nextToken":{"location":"querystring","locationName":"nextToken"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"eulaAcceptances":{"shape":"S6"},"nextToken":{}}}},"ListEulas":{"http":{"method":"GET","requestUri":"/2020-08-01/eulas","responseCode":200},"input":{"type":"structure","members":{"eulaIds":{"shape":"S45","location":"querystring","locationName":"eulaIds"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"eulas":{"type":"list","member":{"shape":"S3v"}},"nextToken":{}}}},"ListLaunchProfileMembers":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/membership","responseCode":200},"input":{"type":"structure","required":["launchProfileId","studioId"],"members":{"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"members":{"type":"list","member":{"shape":"S4h"}},"nextToken":{}}}},"ListLaunchProfiles":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"principalId":{"location":"querystring","locationName":"principalId"},"states":{"location":"querystring","locationName":"states","type":"list","member":{}},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"launchProfiles":{"type":"list","member":{"shape":"Sz"}},"nextToken":{}}}},"ListStreamingImages":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/streaming-images","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"owner":{"location":"querystring","locationName":"owner"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"nextToken":{},"streamingImages":{"shape":"S41"}}}},"ListStreamingSessions":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"createdBy":{"location":"querystring","locationName":"createdBy"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ownedBy":{"location":"querystring","locationName":"ownedBy"},"sessionIds":{"location":"querystring","locationName":"sessionIds"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"nextToken":{},"sessions":{"type":"list","member":{"shape":"S1r"}}}}},"ListStudioComponents":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/studio-components","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"states":{"location":"querystring","locationName":"states","type":"list","member":{}},"studioId":{"location":"uri","locationName":"studioId"},"types":{"location":"querystring","locationName":"types","type":"list","member":{}}}},"output":{"type":"structure","members":{"nextToken":{},"studioComponents":{"type":"list","member":{"shape":"S3b"}}}}},"ListStudioMembers":{"http":{"method":"GET","requestUri":"/2020-08-01/studios/{studioId}/membership","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"members":{"type":"list","member":{"shape":"S4v"}},"nextToken":{}}}},"ListStudios":{"http":{"method":"GET","requestUri":"/2020-08-01/studios","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["studios"],"members":{"nextToken":{},"studios":{"type":"list","member":{"shape":"S29"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2020-08-01/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"}}}},"PutLaunchProfileMembers":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/membership","responseCode":200},"input":{"type":"structure","required":["identityStoreId","launchProfileId","members","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"identityStoreId":{},"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"members":{"type":"list","member":{"type":"structure","required":["persona","principalId"],"members":{"persona":{},"principalId":{}}}},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{}}},"PutStudioMembers":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/membership","responseCode":200},"input":{"type":"structure","required":["identityStoreId","members","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"identityStoreId":{},"members":{"type":"list","member":{"type":"structure","required":["persona","principalId"],"members":{"persona":{},"principalId":{}}}},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{}}},"StartStreamingSession":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions/{sessionId}/start","responseCode":200},"input":{"type":"structure","required":["sessionId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"sessionId":{"location":"uri","locationName":"sessionId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"session":{"shape":"S1r"}}},"idempotent":true},"StartStudioSSOConfigurationRepair":{"http":{"method":"PUT","requestUri":"/2020-08-01/studios/{studioId}/sso-configuration","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","required":["studio"],"members":{"studio":{"shape":"S29"}}},"idempotent":true},"StopStreamingSession":{"http":{"requestUri":"/2020-08-01/studios/{studioId}/streaming-sessions/{sessionId}/stop","responseCode":200},"input":{"type":"structure","required":["sessionId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"sessionId":{"location":"uri","locationName":"sessionId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"session":{"shape":"S1r"}}},"idempotent":true},"TagResource":{"http":{"requestUri":"/2020-08-01/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2020-08-01/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"shape":"S45","location":"querystring","locationName":"tagKeys"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateLaunchProfile":{"http":{"method":"PATCH","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}","responseCode":200},"input":{"type":"structure","required":["launchProfileId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"description":{"shape":"Sc"},"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"launchProfileProtocolVersions":{"shape":"Sf"},"name":{"shape":"Sh"},"streamConfiguration":{"shape":"Si"},"studioComponentIds":{"shape":"Sw"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"launchProfile":{"shape":"Sz"}}}},"UpdateLaunchProfileMember":{"http":{"method":"PATCH","requestUri":"/2020-08-01/studios/{studioId}/launch-profiles/{launchProfileId}/membership/{principalId}","responseCode":200},"input":{"type":"structure","required":["launchProfileId","persona","principalId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"launchProfileId":{"location":"uri","locationName":"launchProfileId"},"persona":{},"principalId":{"location":"uri","locationName":"principalId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"member":{"shape":"S4h"}}}},"UpdateStreamingImage":{"http":{"method":"PATCH","requestUri":"/2020-08-01/studios/{studioId}/streaming-images/{streamingImageId}","responseCode":200},"input":{"type":"structure","required":["streamingImageId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"description":{"type":"string","sensitive":true},"name":{"type":"string","sensitive":true},"streamingImageId":{"location":"uri","locationName":"streamingImageId"},"studioId":{"location":"uri","locationName":"studioId"}}},"output":{"type":"structure","members":{"streamingImage":{"shape":"S1f"}}}},"UpdateStudio":{"http":{"method":"PATCH","requestUri":"/2020-08-01/studios/{studioId}","responseCode":200},"input":{"type":"structure","required":["studioId"],"members":{"adminRoleArn":{},"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"displayName":{"type":"string","sensitive":true},"studioId":{"location":"uri","locationName":"studioId"},"userRoleArn":{}}},"output":{"type":"structure","required":["studio"],"members":{"studio":{"shape":"S29"}}}},"UpdateStudioComponent":{"http":{"method":"PATCH","requestUri":"/2020-08-01/studios/{studioId}/studio-components/{studioComponentId}","responseCode":200},"input":{"type":"structure","required":["studioComponentId","studioId"],"members":{"clientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amz-Client-Token"},"configuration":{"shape":"S2f"},"description":{"shape":"S2v"},"ec2SecurityGroupIds":{"shape":"S2w"},"initializationScripts":{"shape":"S2y"},"name":{"shape":"S33"},"scriptParameters":{"shape":"S34"},"studioComponentId":{"location":"uri","locationName":"studioComponentId"},"studioId":{"location":"uri","locationName":"studioId"},"subtype":{},"type":{}}},"output":{"type":"structure","members":{"studioComponent":{"shape":"S3b"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S6":{"type":"list","member":{"type":"structure","members":{"acceptedAt":{"shape":"S8"},"acceptedBy":{},"accepteeId":{},"eulaAcceptanceId":{},"eulaId":{}}}},"S8":{"type":"timestamp","timestampFormat":"iso8601"},"Sc":{"type":"string","sensitive":true},"Sd":{"type":"list","member":{}},"Sf":{"type":"list","member":{}},"Sh":{"type":"string","sensitive":true},"Si":{"type":"structure","required":["clipboardMode","ec2InstanceTypes","streamingImageIds"],"members":{"clipboardMode":{},"ec2InstanceTypes":{"shape":"Sk"},"maxSessionLengthInMinutes":{"type":"integer"},"maxStoppedSessionLengthInMinutes":{"type":"integer"},"sessionStorage":{"shape":"So"},"streamingImageIds":{"shape":"Su"}}},"Sk":{"type":"list","member":{}},"So":{"type":"structure","required":["mode"],"members":{"mode":{"type":"list","member":{}},"root":{"type":"structure","members":{"linux":{"type":"string","sensitive":true},"windows":{"type":"string","sensitive":true}}}}},"Su":{"type":"list","member":{}},"Sw":{"type":"list","member":{}},"Sx":{"type":"map","key":{},"value":{}},"Sz":{"type":"structure","members":{"arn":{},"createdAt":{"shape":"S8"},"createdBy":{},"description":{"shape":"Sc"},"ec2SubnetIds":{"shape":"Sd"},"launchProfileId":{},"launchProfileProtocolVersions":{"shape":"Sf"},"name":{"shape":"Sh"},"state":{},"statusCode":{},"statusMessage":{},"streamConfiguration":{"type":"structure","required":["clipboardMode","ec2InstanceTypes","streamingImageIds"],"members":{"clipboardMode":{},"ec2InstanceTypes":{"shape":"Sk"},"maxSessionLengthInMinutes":{"type":"integer"},"maxStoppedSessionLengthInMinutes":{"type":"integer"},"sessionStorage":{"shape":"So"},"streamingImageIds":{"shape":"Su"}}},"studioComponentIds":{"shape":"Sw"},"tags":{"shape":"Sx"},"updatedAt":{"shape":"S8"},"updatedBy":{},"validationResults":{"type":"list","member":{"type":"structure","required":["state","statusCode","statusMessage","type"],"members":{"state":{},"statusCode":{},"statusMessage":{},"type":{}}}}}},"S1f":{"type":"structure","members":{"arn":{},"description":{"type":"string","sensitive":true},"ec2ImageId":{},"encryptionConfiguration":{"type":"structure","required":["keyType"],"members":{"keyArn":{},"keyType":{}}},"eulaIds":{"shape":"S3"},"name":{"type":"string","sensitive":true},"owner":{},"platform":{},"state":{},"statusCode":{},"statusMessage":{},"streamingImageId":{},"tags":{"shape":"Sx"}}},"S1r":{"type":"structure","members":{"arn":{},"createdAt":{"shape":"S8"},"createdBy":{},"ec2InstanceType":{},"launchProfileId":{},"ownedBy":{},"sessionId":{},"startedAt":{"shape":"S8"},"startedBy":{},"state":{},"statusCode":{},"statusMessage":{},"stopAt":{"shape":"S8"},"stoppedAt":{"shape":"S8"},"stoppedBy":{},"streamingImageId":{},"tags":{"shape":"Sx"},"terminateAt":{"shape":"S8"},"updatedAt":{"shape":"S8"},"updatedBy":{}}},"S1y":{"type":"structure","members":{"createdAt":{"shape":"S8"},"createdBy":{},"expiresAt":{"shape":"S8"},"ownedBy":{},"state":{},"statusCode":{},"streamId":{},"url":{"type":"string","sensitive":true}}},"S24":{"type":"structure","required":["keyType"],"members":{"keyArn":{},"keyType":{}}},"S29":{"type":"structure","members":{"adminRoleArn":{},"arn":{},"createdAt":{"shape":"S8"},"displayName":{"type":"string","sensitive":true},"homeRegion":{},"ssoClientId":{},"state":{},"statusCode":{},"statusMessage":{},"studioEncryptionConfiguration":{"shape":"S24"},"studioId":{},"studioName":{},"studioUrl":{},"tags":{"shape":"Sx"},"updatedAt":{"shape":"S8"},"userRoleArn":{}}},"S2f":{"type":"structure","members":{"activeDirectoryConfiguration":{"type":"structure","members":{"computerAttributes":{"shape":"S2h"},"directoryId":{},"organizationalUnitDistinguishedName":{}}},"computeFarmConfiguration":{"type":"structure","members":{"activeDirectoryUser":{},"endpoint":{"type":"string","sensitive":true}}},"licenseServiceConfiguration":{"type":"structure","members":{"endpoint":{"type":"string","sensitive":true}}},"sharedFileSystemConfiguration":{"type":"structure","members":{"endpoint":{"shape":"S2s"},"fileSystemId":{},"linuxMountPoint":{"type":"string","sensitive":true},"shareName":{"shape":"S2s"},"windowsMountDrive":{}}}},"union":true},"S2h":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}},"sensitive":true},"S2s":{"type":"string","sensitive":true},"S2v":{"type":"string","sensitive":true},"S2w":{"type":"list","member":{}},"S2y":{"type":"list","member":{"type":"structure","members":{"launchProfileProtocolVersion":{},"platform":{},"runContext":{},"script":{"shape":"S32"}}}},"S32":{"type":"string","sensitive":true},"S33":{"type":"string","sensitive":true},"S34":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}},"sensitive":true},"S3b":{"type":"structure","members":{"arn":{},"configuration":{"shape":"S2f"},"createdAt":{"shape":"S8"},"createdBy":{},"description":{"shape":"S2v"},"ec2SecurityGroupIds":{"shape":"S2w"},"initializationScripts":{"shape":"S2y"},"name":{"shape":"S33"},"scriptParameters":{"shape":"S34"},"state":{},"statusCode":{},"statusMessage":{},"studioComponentId":{},"subtype":{},"tags":{"shape":"Sx"},"type":{},"updatedAt":{"shape":"S8"},"updatedBy":{}}},"S3v":{"type":"structure","members":{"content":{},"createdAt":{"shape":"S8"},"eulaId":{},"name":{},"updatedAt":{"shape":"S8"}}},"S41":{"type":"list","member":{"shape":"S1f"}},"S45":{"type":"list","member":{}},"S4d":{"type":"list","member":{"type":"structure","members":{"script":{"shape":"S32"},"studioComponentId":{},"studioComponentName":{"shape":"S33"}}}},"S4h":{"type":"structure","members":{"identityStoreId":{},"persona":{},"principalId":{},"sid":{}}},"S4v":{"type":"structure","members":{"identityStoreId":{},"persona":{},"principalId":{},"sid":{}}}}}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEulaAcceptances":{"input_token":"nextToken","output_token":"nextToken","result_key":"eulaAcceptances"},"ListEulas":{"input_token":"nextToken","output_token":"nextToken","result_key":"eulas"},"ListLaunchProfileMembers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"members"},"ListLaunchProfiles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"launchProfiles"},"ListStreamingImages":{"input_token":"nextToken","output_token":"nextToken","result_key":"streamingImages"},"ListStreamingSessions":{"input_token":"nextToken","output_token":"nextToken","result_key":"sessions"},"ListStudioComponents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"studioComponents"},"ListStudioMembers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"members"},"ListStudios":{"input_token":"nextToken","output_token":"nextToken","result_key":"studios"}}}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"LaunchProfileDeleted":{"description":"Wait until a LaunchProfile is Deleted. Use this after invoking DeleteLaunchProfile","delay":5,"maxAttempts":150,"operation":"GetLaunchProfile","acceptors":[{"matcher":"path","argument":"launchProfile.state","state":"success","expected":"DELETED"},{"matcher":"path","argument":"launchProfile.state","state":"failure","expected":"DELETE_FAILED"}]},"LaunchProfileReady":{"description":"Wait until a LaunchProfile is Ready. Use this after invoking CreateLaunchProfile or UpdateLaunchProfile","delay":5,"maxAttempts":150,"operation":"GetLaunchProfile","acceptors":[{"matcher":"path","argument":"launchProfile.state","state":"success","expected":"READY"},{"matcher":"path","argument":"launchProfile.state","state":"failure","expected":"CREATE_FAILED"},{"matcher":"path","argument":"launchProfile.state","state":"failure","expected":"UPDATE_FAILED"}]},"StreamingImageDeleted":{"description":"Wait until a StreamingImage Deleted. Use this after invoking DeleteStreamingImage","delay":2,"maxAttempts":60,"operation":"GetStreamingImage","acceptors":[{"matcher":"path","argument":"streamingImage.state","state":"success","expected":"DELETED"},{"matcher":"path","argument":"streamingImage.state","state":"failure","expected":"DELETE_FAILED"}]},"StreamingImageReady":{"description":"Wait until a StreamingImage is Ready. Use this after invoking CreateStreamingImage or UpdateStreamingImage","delay":2,"maxAttempts":60,"operation":"GetStreamingImage","acceptors":[{"matcher":"path","argument":"streamingImage.state","state":"success","expected":"READY"},{"matcher":"path","argument":"streamingImage.state","state":"failure","expected":"CREATE_FAILED"},{"matcher":"path","argument":"streamingImage.state","state":"failure","expected":"UPDATE_FAILED"}]},"StreamingSessionDeleted":{"description":"Wait until a StreamingSessionDeleted. Use this after invoking Deletesession","delay":5,"maxAttempts":180,"operation":"GetStreamingSession","acceptors":[{"matcher":"path","argument":"session.state","state":"success","expected":"DELETED"},{"matcher":"path","argument":"session.state","state":"failure","expected":"DELETE_FAILED"}]},"StreamingSessionReady":{"description":"Wait until a StreamingSession is ready. Use this after invoking CreateStreamingSession, StartStreamingSession","delay":10,"maxAttempts":180,"operation":"GetStreamingSession","acceptors":[{"matcher":"path","argument":"session.state","state":"success","expected":"READY"},{"matcher":"path","argument":"session.state","state":"failure","expected":"CREATE_FAILED"},{"matcher":"path","argument":"session.state","state":"failure","expected":"START_FAILED"}]},"StreamingSessionStopped":{"description":"Wait until a StreamingSessionStopped. Use this after invoking StopStreamingSession","delay":5,"maxAttempts":180,"operation":"GetStreamingSession","acceptors":[{"matcher":"path","argument":"session.state","state":"success","expected":"STOPPED"},{"matcher":"path","argument":"session.state","state":"failure","expected":"STOP_FAILED"}]},"StreamingSessionStreamReady":{"description":"Wait until a StreamingSessionStream is ready. Use this after invoking CreateStreamingSessionStream","delay":5,"maxAttempts":30,"operation":"GetStreamingSessionStream","acceptors":[{"matcher":"path","argument":"stream.state","state":"success","expected":"READY"},{"matcher":"path","argument":"stream.state","state":"failure","expected":"CREATE_FAILED"}]},"StudioComponentDeleted":{"description":"Wait until a StudioComponent Deleted. Use this after invoking DeleteStudioComponent","delay":1,"maxAttempts":120,"operation":"GetStudioComponent","acceptors":[{"matcher":"path","argument":"studioComponent.state","state":"success","expected":"DELETED"},{"matcher":"path","argument":"studioComponent.state","state":"failure","expected":"DELETE_FAILED"}]},"StudioComponentReady":{"description":"Wait until a StudioComponent is Ready. Use this after invoking CreateStudioComponent or UpdateStudioComponent","delay":2,"maxAttempts":60,"operation":"GetStudioComponent","acceptors":[{"matcher":"path","argument":"studioComponent.state","state":"success","expected":"READY"},{"matcher":"path","argument":"studioComponent.state","state":"failure","expected":"CREATE_FAILED"},{"matcher":"path","argument":"studioComponent.state","state":"failure","expected":"UPDATE_FAILED"}]},"StudioDeleted":{"description":"Wait until a Studio is Deleted. Use this after invoking DeleteStudio.","delay":2,"maxAttempts":60,"operation":"GetStudio","acceptors":[{"matcher":"path","argument":"studio.state","state":"success","expected":"DELETED"},{"matcher":"path","argument":"studio.state","state":"failure","expected":"DELETE_FAILED"}]},"StudioReady":{"description":"Wait until a Studio is Ready. Use this after invoking CreateStudio, UpdateStudio, or StartStudioSSOConfigurationRepair","delay":2,"maxAttempts":60,"operation":"GetStudio","acceptors":[{"matcher":"path","argument":"studio.state","state":"success","expected":"READY"},{"matcher":"path","argument":"studio.state","state":"failure","expected":"CREATE_FAILED"},{"matcher":"path","argument":"studio.state","state":"failure","expected":"UPDATE_FAILED"}]}}}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['finspace'] = {};
	AWS.Finspace = Service.defineService('finspace', ['2021-03-12']);
	Object.defineProperty(apiLoader.services['finspace'], '2021-03-12', {
	  get: function get() {
	    var model = __webpack_require__(1011);
	    model.paginators = __webpack_require__(1012).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Finspace;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-03-12","endpointPrefix":"finspace","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"finspace","serviceFullName":"FinSpace User Environment Management service","serviceId":"finspace","signatureVersion":"v4","signingName":"finspace","uid":"finspace-2021-03-12"},"operations":{"CreateEnvironment":{"http":{"requestUri":"/environment"},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"kmsKeyId":{},"tags":{"shape":"S5"},"federationMode":{},"federationParameters":{"shape":"S9"},"superuserParameters":{"type":"structure","required":["emailAddress","firstName","lastName"],"members":{"emailAddress":{"type":"string","sensitive":true},"firstName":{},"lastName":{}}},"dataBundles":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"environmentId":{},"environmentArn":{},"environmentUrl":{}}}},"DeleteEnvironment":{"http":{"method":"DELETE","requestUri":"/environment/{environmentId}"},"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{"location":"uri","locationName":"environmentId"}}},"output":{"type":"structure","members":{}}},"GetEnvironment":{"http":{"method":"GET","requestUri":"/environment/{environmentId}"},"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{"location":"uri","locationName":"environmentId"}}},"output":{"type":"structure","members":{"environment":{"shape":"Ss"}}}},"ListEnvironments":{"http":{"method":"GET","requestUri":"/environment"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"environments":{"type":"list","member":{"shape":"Ss"}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateEnvironment":{"http":{"method":"PUT","requestUri":"/environment/{environmentId}"},"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{"location":"uri","locationName":"environmentId"},"name":{},"description":{},"federationMode":{},"federationParameters":{"shape":"S9"}}},"output":{"type":"structure","members":{"environment":{"shape":"Ss"}}}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"structure","members":{"samlMetadataDocument":{},"samlMetadataURL":{},"applicationCallBackURL":{},"federationURN":{},"federationProviderName":{},"attributeMap":{"type":"map","key":{},"value":{}}}},"Ss":{"type":"structure","members":{"name":{},"environmentId":{},"awsAccountId":{},"status":{},"environmentUrl":{},"description":{},"environmentArn":{},"sageMakerStudioDomainUrl":{},"kmsKeyId":{},"dedicatedServiceAccountId":{},"federationMode":{},"federationParameters":{"shape":"S9"}}}}}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['finspacedata'] = {};
	AWS.Finspacedata = Service.defineService('finspacedata', ['2020-07-13']);
	Object.defineProperty(apiLoader.services['finspacedata'], '2020-07-13', {
	  get: function get() {
	    var model = __webpack_require__(1014);
	    model.paginators = __webpack_require__(1015).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Finspacedata;


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-13","endpointPrefix":"finspace-api","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"FinSpace Data","serviceFullName":"FinSpace Public API","serviceId":"finspace data","signatureVersion":"v4","signingName":"finspace-api","uid":"finspace-2020-07-13"},"operations":{"CreateChangeset":{"http":{"requestUri":"/datasets/{datasetId}/changesetsv2"},"input":{"type":"structure","required":["datasetId","changeType","sourceParams","formatParams"],"members":{"clientToken":{"idempotencyToken":true},"datasetId":{"location":"uri","locationName":"datasetId"},"changeType":{},"sourceParams":{"shape":"S5"},"formatParams":{"shape":"S8"}}},"output":{"type":"structure","members":{"datasetId":{},"changesetId":{}}}},"CreateDataView":{"http":{"requestUri":"/datasets/{datasetId}/dataviewsv2"},"input":{"type":"structure","required":["datasetId","destinationTypeParams"],"members":{"clientToken":{"idempotencyToken":true},"datasetId":{"location":"uri","locationName":"datasetId"},"autoUpdate":{"type":"boolean"},"sortColumns":{"shape":"Sd"},"partitionColumns":{"shape":"Sf"},"asOfTimestamp":{"type":"long"},"destinationTypeParams":{"shape":"Sh"}}},"output":{"type":"structure","members":{"datasetId":{},"dataViewId":{}}}},"CreateDataset":{"http":{"requestUri":"/datasetsv2"},"input":{"type":"structure","required":["datasetTitle","kind","permissionGroupParams"],"members":{"clientToken":{"idempotencyToken":true},"datasetTitle":{},"kind":{},"datasetDescription":{},"ownerInfo":{"shape":"Sr"},"permissionGroupParams":{"type":"structure","members":{"permissionGroupId":{},"datasetPermissions":{"type":"list","member":{"type":"structure","members":{"permission":{}}}}}},"alias":{},"schemaDefinition":{"shape":"S11"}}},"output":{"type":"structure","members":{"datasetId":{}}}},"CreatePermissionGroup":{"http":{"requestUri":"/permission-group"},"input":{"type":"structure","required":["name","applicationPermissions"],"members":{"name":{"shape":"S1b"},"description":{"shape":"S1c"},"applicationPermissions":{"shape":"S1d"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"permissionGroupId":{}}}},"CreateUser":{"http":{"requestUri":"/user"},"input":{"type":"structure","required":["emailAddress","type"],"members":{"emailAddress":{"shape":"Su"},"type":{},"firstName":{"shape":"S1i"},"lastName":{"shape":"S1j"},"ApiAccess":{},"apiAccessPrincipalArn":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"userId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/datasetsv2/{datasetId}"},"input":{"type":"structure","required":["datasetId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"datasetId":{"location":"uri","locationName":"datasetId"}}},"output":{"type":"structure","members":{"datasetId":{}}}},"DeletePermissionGroup":{"http":{"method":"DELETE","requestUri":"/permission-group/{permissionGroupId}"},"input":{"type":"structure","required":["permissionGroupId"],"members":{"permissionGroupId":{"location":"uri","locationName":"permissionGroupId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{"permissionGroupId":{}}}},"DisableUser":{"http":{"requestUri":"/user/{userId}/disable"},"input":{"type":"structure","required":["userId"],"members":{"userId":{"location":"uri","locationName":"userId"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"userId":{}}}},"EnableUser":{"http":{"requestUri":"/user/{userId}/enable"},"input":{"type":"structure","required":["userId"],"members":{"userId":{"location":"uri","locationName":"userId"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"userId":{}}}},"GetChangeset":{"http":{"method":"GET","requestUri":"/datasets/{datasetId}/changesetsv2/{changesetId}"},"input":{"type":"structure","required":["datasetId","changesetId"],"members":{"datasetId":{"location":"uri","locationName":"datasetId"},"changesetId":{"location":"uri","locationName":"changesetId"}}},"output":{"type":"structure","members":{"changesetId":{},"changesetArn":{},"datasetId":{},"changeType":{},"sourceParams":{"shape":"S5"},"formatParams":{"shape":"S8"},"createTime":{"type":"long"},"status":{},"errorInfo":{"shape":"S20"},"activeUntilTimestamp":{"type":"long"},"activeFromTimestamp":{"type":"long"},"updatesChangesetId":{},"updatedByChangesetId":{}}}},"GetDataView":{"http":{"method":"GET","requestUri":"/datasets/{datasetId}/dataviewsv2/{dataviewId}"},"input":{"type":"structure","required":["dataViewId","datasetId"],"members":{"dataViewId":{"location":"uri","locationName":"dataviewId"},"datasetId":{"location":"uri","locationName":"datasetId"}}},"output":{"type":"structure","members":{"autoUpdate":{"type":"boolean"},"partitionColumns":{"shape":"Sf"},"datasetId":{},"asOfTimestamp":{"type":"long"},"errorInfo":{"shape":"S25"},"lastModifiedTime":{"type":"long"},"createTime":{"type":"long"},"sortColumns":{"shape":"Sd"},"dataViewId":{},"dataViewArn":{},"destinationTypeParams":{"shape":"Sh"},"status":{}}}},"GetDataset":{"http":{"method":"GET","requestUri":"/datasetsv2/{datasetId}"},"input":{"type":"structure","required":["datasetId"],"members":{"datasetId":{"location":"uri","locationName":"datasetId"}}},"output":{"type":"structure","members":{"datasetId":{},"datasetArn":{},"datasetTitle":{},"kind":{},"datasetDescription":{},"createTime":{"type":"long"},"lastModifiedTime":{"type":"long"},"schemaDefinition":{"shape":"S11"},"alias":{},"status":{}}}},"GetProgrammaticAccessCredentials":{"http":{"method":"GET","requestUri":"/credentials/programmatic"},"input":{"type":"structure","required":["environmentId"],"members":{"durationInMinutes":{"location":"querystring","locationName":"durationInMinutes","type":"long"},"environmentId":{"location":"querystring","locationName":"environmentId"}}},"output":{"type":"structure","members":{"credentials":{"type":"structure","members":{"accessKeyId":{},"secretAccessKey":{},"sessionToken":{}}},"durationInMinutes":{"type":"long"}}}},"GetUser":{"http":{"method":"GET","requestUri":"/user/{userId}"},"input":{"type":"structure","required":["userId"],"members":{"userId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"userId":{},"status":{},"firstName":{"shape":"S1i"},"lastName":{"shape":"S1j"},"emailAddress":{"shape":"Su"},"type":{},"apiAccess":{},"apiAccessPrincipalArn":{},"createTime":{"type":"long"},"lastEnabledTime":{"type":"long"},"lastDisabledTime":{"type":"long"},"lastModifiedTime":{"type":"long"},"lastLoginTime":{"type":"long"}}}},"GetWorkingLocation":{"http":{"requestUri":"/workingLocationV1"},"input":{"type":"structure","members":{"locationType":{}}},"output":{"type":"structure","members":{"s3Uri":{},"s3Path":{},"s3Bucket":{}}}},"ListChangesets":{"http":{"method":"GET","requestUri":"/datasets/{datasetId}/changesetsv2"},"input":{"type":"structure","required":["datasetId"],"members":{"datasetId":{"location":"uri","locationName":"datasetId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"changesets":{"type":"list","member":{"type":"structure","members":{"changesetId":{},"changesetArn":{},"datasetId":{},"changeType":{},"sourceParams":{"shape":"S5"},"formatParams":{"shape":"S8"},"createTime":{"type":"long"},"status":{},"errorInfo":{"shape":"S20"},"activeUntilTimestamp":{"type":"long"},"activeFromTimestamp":{"type":"long"},"updatesChangesetId":{},"updatedByChangesetId":{}}}},"nextToken":{}}}},"ListDataViews":{"http":{"method":"GET","requestUri":"/datasets/{datasetId}/dataviewsv2"},"input":{"type":"structure","required":["datasetId"],"members":{"datasetId":{"location":"uri","locationName":"datasetId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"dataViews":{"type":"list","member":{"type":"structure","members":{"dataViewId":{},"dataViewArn":{},"datasetId":{},"asOfTimestamp":{"type":"long"},"partitionColumns":{"shape":"Sf"},"sortColumns":{"shape":"Sd"},"status":{},"errorInfo":{"shape":"S25"},"destinationTypeProperties":{"shape":"Sh"},"autoUpdate":{"type":"boolean"},"createTime":{"type":"long"},"lastModifiedTime":{"type":"long"}}}}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/datasetsv2"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datasets":{"type":"list","member":{"type":"structure","members":{"datasetId":{},"datasetArn":{},"datasetTitle":{},"kind":{},"datasetDescription":{},"ownerInfo":{"shape":"Sr"},"createTime":{"type":"long"},"lastModifiedTime":{"type":"long"},"schemaDefinition":{"shape":"S11"},"alias":{}}}},"nextToken":{}}}},"ListPermissionGroups":{"http":{"method":"GET","requestUri":"/permission-group"},"input":{"type":"structure","required":["maxResults"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"permissionGroups":{"type":"list","member":{"type":"structure","members":{"permissionGroupId":{},"name":{"shape":"S1b"},"description":{"shape":"S1c"},"applicationPermissions":{"shape":"S1d"},"createTime":{"type":"long"},"lastModifiedTime":{"type":"long"}}}},"nextToken":{}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/user"},"input":{"type":"structure","required":["maxResults"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"users":{"type":"list","member":{"type":"structure","members":{"userId":{},"status":{},"firstName":{"shape":"S1i"},"lastName":{"shape":"S1j"},"emailAddress":{"shape":"Su"},"type":{},"apiAccess":{},"apiAccessPrincipalArn":{},"createTime":{"type":"long"},"lastEnabledTime":{"type":"long"},"lastDisabledTime":{"type":"long"},"lastModifiedTime":{"type":"long"},"lastLoginTime":{"type":"long"}}}},"nextToken":{}}}},"ResetUserPassword":{"http":{"requestUri":"/user/{userId}/password"},"input":{"type":"structure","required":["userId"],"members":{"userId":{"location":"uri","locationName":"userId"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"userId":{},"temporaryPassword":{"type":"string","sensitive":true}}}},"UpdateChangeset":{"http":{"method":"PUT","requestUri":"/datasets/{datasetId}/changesetsv2/{changesetId}"},"input":{"type":"structure","required":["datasetId","changesetId","sourceParams","formatParams"],"members":{"clientToken":{"idempotencyToken":true},"datasetId":{"location":"uri","locationName":"datasetId"},"changesetId":{"location":"uri","locationName":"changesetId"},"sourceParams":{"shape":"S5"},"formatParams":{"shape":"S8"}}},"output":{"type":"structure","members":{"changesetId":{},"datasetId":{}}}},"UpdateDataset":{"http":{"method":"PUT","requestUri":"/datasetsv2/{datasetId}"},"input":{"type":"structure","required":["datasetId","datasetTitle","kind"],"members":{"clientToken":{"idempotencyToken":true},"datasetId":{"location":"uri","locationName":"datasetId"},"datasetTitle":{},"kind":{},"datasetDescription":{},"alias":{},"schemaDefinition":{"shape":"S11"}}},"output":{"type":"structure","members":{"datasetId":{}}}},"UpdatePermissionGroup":{"http":{"method":"PUT","requestUri":"/permission-group/{permissionGroupId}"},"input":{"type":"structure","required":["permissionGroupId"],"members":{"permissionGroupId":{"location":"uri","locationName":"permissionGroupId"},"name":{"shape":"S1b"},"description":{"shape":"S1c"},"applicationPermissions":{"shape":"S1d"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"permissionGroupId":{}}}},"UpdateUser":{"http":{"method":"PUT","requestUri":"/user/{userId}"},"input":{"type":"structure","required":["userId"],"members":{"userId":{"location":"uri","locationName":"userId"},"type":{},"firstName":{"shape":"S1i"},"lastName":{"shape":"S1j"},"apiAccess":{},"apiAccessPrincipalArn":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"userId":{}}}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S8":{"type":"map","key":{},"value":{}},"Sd":{"type":"list","member":{}},"Sf":{"type":"list","member":{}},"Sh":{"type":"structure","required":["destinationType"],"members":{"destinationType":{},"s3DestinationExportFileFormat":{},"s3DestinationExportFileFormatOptions":{"type":"map","key":{},"value":{}}}},"Sr":{"type":"structure","members":{"name":{},"phoneNumber":{},"email":{"shape":"Su"}}},"Su":{"type":"string","sensitive":true},"S11":{"type":"structure","members":{"tabularSchemaConfig":{"type":"structure","members":{"columns":{"type":"list","member":{"type":"structure","members":{"dataType":{},"columnName":{},"columnDescription":{}}}},"primaryKeyColumns":{"type":"list","member":{}}}}}},"S1b":{"type":"string","sensitive":true},"S1c":{"type":"string","sensitive":true},"S1d":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1j":{"type":"string","sensitive":true},"S20":{"type":"structure","members":{"errorMessage":{},"errorCategory":{}}},"S25":{"type":"structure","members":{"errorMessage":{},"errorCategory":{}}}}}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChangesets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"changesets"},"ListDataViews":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"dataViews"},"ListDatasets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"datasets"},"ListPermissionGroups":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"permissionGroups"},"ListUsers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"users"}}}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ssmcontacts'] = {};
	AWS.SSMContacts = Service.defineService('ssmcontacts', ['2021-05-03']);
	Object.defineProperty(apiLoader.services['ssmcontacts'], '2021-05-03', {
	  get: function get() {
	    var model = __webpack_require__(1017);
	    model.paginators = __webpack_require__(1018).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SSMContacts;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-05-03","endpointPrefix":"ssm-contacts","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"SSM Contacts","serviceFullName":"AWS Systems Manager Incident Manager Contacts","serviceId":"SSM Contacts","signatureVersion":"v4","signingName":"ssm-contacts","targetPrefix":"SSMContacts","uid":"ssm-contacts-2021-05-03"},"operations":{"AcceptPage":{"input":{"type":"structure","required":["PageId","AcceptType","AcceptCode"],"members":{"PageId":{},"ContactChannelId":{},"AcceptType":{},"Note":{},"AcceptCode":{},"AcceptCodeValidation":{}}},"output":{"type":"structure","members":{}}},"ActivateContactChannel":{"input":{"type":"structure","required":["ContactChannelId","ActivationCode"],"members":{"ContactChannelId":{},"ActivationCode":{}}},"output":{"type":"structure","members":{}}},"CreateContact":{"input":{"type":"structure","required":["Alias","Type","Plan"],"members":{"Alias":{},"DisplayName":{},"Type":{},"Plan":{"shape":"Sf"},"Tags":{"shape":"Sp"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{}}}},"CreateContactChannel":{"input":{"type":"structure","required":["ContactId","Name","Type","DeliveryAddress"],"members":{"ContactId":{},"Name":{},"Type":{},"DeliveryAddress":{"shape":"Sy"},"DeferActivation":{"type":"boolean"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["ContactChannelArn"],"members":{"ContactChannelArn":{}}}},"DeactivateContactChannel":{"input":{"type":"structure","required":["ContactChannelId"],"members":{"ContactChannelId":{}}},"output":{"type":"structure","members":{}}},"DeleteContact":{"input":{"type":"structure","required":["ContactId"],"members":{"ContactId":{}}},"output":{"type":"structure","members":{}}},"DeleteContactChannel":{"input":{"type":"structure","required":["ContactChannelId"],"members":{"ContactChannelId":{}}},"output":{"type":"structure","members":{}}},"DescribeEngagement":{"input":{"type":"structure","required":["EngagementId"],"members":{"EngagementId":{}}},"output":{"type":"structure","required":["ContactArn","EngagementArn","Sender","Subject","Content"],"members":{"ContactArn":{},"EngagementArn":{},"Sender":{},"Subject":{},"Content":{},"PublicSubject":{},"PublicContent":{},"IncidentId":{},"StartTime":{"type":"timestamp"},"StopTime":{"type":"timestamp"}}}},"DescribePage":{"input":{"type":"structure","required":["PageId"],"members":{"PageId":{}}},"output":{"type":"structure","required":["PageArn","EngagementArn","ContactArn","Sender","Subject","Content"],"members":{"PageArn":{},"EngagementArn":{},"ContactArn":{},"Sender":{},"Subject":{},"Content":{},"PublicSubject":{},"PublicContent":{},"IncidentId":{},"SentTime":{"type":"timestamp"},"ReadTime":{"type":"timestamp"},"DeliveryTime":{"type":"timestamp"}}}},"GetContact":{"input":{"type":"structure","required":["ContactId"],"members":{"ContactId":{}}},"output":{"type":"structure","required":["ContactArn","Alias","Type","Plan"],"members":{"ContactArn":{},"Alias":{},"DisplayName":{},"Type":{},"Plan":{"shape":"Sf"}}}},"GetContactChannel":{"input":{"type":"structure","required":["ContactChannelId"],"members":{"ContactChannelId":{}}},"output":{"type":"structure","required":["ContactArn","ContactChannelArn","Name","Type","DeliveryAddress"],"members":{"ContactArn":{},"ContactChannelArn":{},"Name":{},"Type":{},"DeliveryAddress":{"shape":"Sy"},"ActivationStatus":{}}}},"GetContactPolicy":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{}}},"output":{"type":"structure","members":{"ContactArn":{},"Policy":{}}}},"ListContactChannels":{"input":{"type":"structure","required":["ContactId"],"members":{"ContactId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ContactChannels"],"members":{"NextToken":{},"ContactChannels":{"type":"list","member":{"type":"structure","required":["ContactChannelArn","ContactArn","Name","DeliveryAddress","ActivationStatus"],"members":{"ContactChannelArn":{},"ContactArn":{},"Name":{},"Type":{},"DeliveryAddress":{"shape":"Sy"},"ActivationStatus":{}}}}}}},"ListContacts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"AliasPrefix":{},"Type":{}}},"output":{"type":"structure","members":{"NextToken":{},"Contacts":{"type":"list","member":{"type":"structure","required":["ContactArn","Alias","Type"],"members":{"ContactArn":{},"Alias":{},"DisplayName":{},"Type":{}}}}}}},"ListEngagements":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"IncidentId":{},"TimeRangeValue":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}}},"output":{"type":"structure","required":["Engagements"],"members":{"NextToken":{},"Engagements":{"type":"list","member":{"type":"structure","required":["EngagementArn","ContactArn","Sender"],"members":{"EngagementArn":{},"ContactArn":{},"Sender":{},"IncidentId":{},"StartTime":{"type":"timestamp"},"StopTime":{"type":"timestamp"}}}}}}},"ListPageReceipts":{"input":{"type":"structure","required":["PageId"],"members":{"PageId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Receipts":{"type":"list","member":{"type":"structure","required":["ReceiptType","ReceiptTime"],"members":{"ContactChannelArn":{},"ReceiptType":{},"ReceiptInfo":{},"ReceiptTime":{"type":"timestamp"}}}}}}},"ListPagesByContact":{"input":{"type":"structure","required":["ContactId"],"members":{"ContactId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Pages"],"members":{"NextToken":{},"Pages":{"shape":"S2d"}}}},"ListPagesByEngagement":{"input":{"type":"structure","required":["EngagementId"],"members":{"EngagementId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Pages"],"members":{"NextToken":{},"Pages":{"shape":"S2d"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sp"}}}},"PutContactPolicy":{"input":{"type":"structure","required":["ContactArn","Policy"],"members":{"ContactArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"SendActivationCode":{"input":{"type":"structure","required":["ContactChannelId"],"members":{"ContactChannelId":{}}},"output":{"type":"structure","members":{}}},"StartEngagement":{"input":{"type":"structure","required":["ContactId","Sender","Subject","Content"],"members":{"ContactId":{},"Sender":{},"Subject":{},"Content":{},"PublicSubject":{},"PublicContent":{},"IncidentId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["EngagementArn"],"members":{"EngagementArn":{}}}},"StopEngagement":{"input":{"type":"structure","required":["EngagementId"],"members":{"EngagementId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sp"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateContact":{"input":{"type":"structure","required":["ContactId"],"members":{"ContactId":{},"DisplayName":{},"Plan":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UpdateContactChannel":{"input":{"type":"structure","required":["ContactChannelId"],"members":{"ContactChannelId":{},"Name":{},"DeliveryAddress":{"shape":"Sy"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sf":{"type":"structure","required":["Stages"],"members":{"Stages":{"type":"list","member":{"type":"structure","required":["DurationInMinutes","Targets"],"members":{"DurationInMinutes":{"type":"integer"},"Targets":{"type":"list","member":{"type":"structure","members":{"ChannelTargetInfo":{"type":"structure","required":["ContactChannelId"],"members":{"ContactChannelId":{},"RetryIntervalInMinutes":{"type":"integer"}}},"ContactTargetInfo":{"type":"structure","required":["IsEssential"],"members":{"ContactId":{},"IsEssential":{"type":"boolean"}}}}}}}}}}},"Sp":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sy":{"type":"structure","members":{"SimpleAddress":{}}},"S2d":{"type":"list","member":{"type":"structure","required":["PageArn","EngagementArn","ContactArn","Sender"],"members":{"PageArn":{},"EngagementArn":{},"ContactArn":{},"Sender":{},"IncidentId":{},"SentTime":{"type":"timestamp"},"DeliveryTime":{"type":"timestamp"},"ReadTime":{"type":"timestamp"}}}}}}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListContactChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ContactChannels"},"ListContacts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Contacts"},"ListEngagements":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Engagements"},"ListPageReceipts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Receipts"},"ListPagesByContact":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Pages"},"ListPagesByEngagement":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Pages"}}}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ssmincidents'] = {};
	AWS.SSMIncidents = Service.defineService('ssmincidents', ['2018-05-10']);
	Object.defineProperty(apiLoader.services['ssmincidents'], '2018-05-10', {
	  get: function get() {
	    var model = __webpack_require__(1020);
	    model.paginators = __webpack_require__(1021).pagination;
	    model.waiters = __webpack_require__(1022).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SSMIncidents;


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-10","endpointPrefix":"ssm-incidents","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"SSM Incidents","serviceFullName":"AWS Systems Manager Incident Manager","serviceId":"SSM Incidents","signatureVersion":"v4","signingName":"ssm-incidents","uid":"ssm-incidents-2018-05-10"},"operations":{"CreateReplicationSet":{"http":{"requestUri":"/createReplicationSet","responseCode":201},"input":{"type":"structure","required":["regions"],"members":{"clientToken":{"idempotencyToken":true},"regions":{"type":"map","key":{},"value":{"type":"structure","members":{"sseKmsKeyId":{}}}}}},"output":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"CreateResponsePlan":{"http":{"requestUri":"/createResponsePlan","responseCode":201},"input":{"type":"structure","required":["incidentTemplate","name"],"members":{"actions":{"shape":"Sa"},"chatChannel":{"shape":"Sl"},"clientToken":{"idempotencyToken":true},"displayName":{},"engagements":{"shape":"Sq"},"incidentTemplate":{"shape":"Ss"},"name":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","required":["arn"],"members":{"arn":{}}},"idempotent":true},"CreateTimelineEvent":{"http":{"requestUri":"/createTimelineEvent","responseCode":201},"input":{"type":"structure","required":["eventData","eventTime","eventType","incidentRecordArn"],"members":{"clientToken":{"idempotencyToken":true},"eventData":{},"eventTime":{"type":"timestamp"},"eventType":{},"incidentRecordArn":{}}},"output":{"type":"structure","required":["eventId","incidentRecordArn"],"members":{"eventId":{},"incidentRecordArn":{}}},"idempotent":true},"DeleteIncidentRecord":{"http":{"requestUri":"/deleteIncidentRecord","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteReplicationSet":{"http":{"requestUri":"/deleteReplicationSet","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"http":{"requestUri":"/deleteResourcePolicy","responseCode":200},"input":{"type":"structure","required":["policyId","resourceArn"],"members":{"policyId":{},"resourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteResponsePlan":{"http":{"requestUri":"/deleteResponsePlan","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteTimelineEvent":{"http":{"requestUri":"/deleteTimelineEvent","responseCode":204},"input":{"type":"structure","required":["eventId","incidentRecordArn"],"members":{"eventId":{},"incidentRecordArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetIncidentRecord":{"http":{"method":"GET","requestUri":"/getIncidentRecord","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","required":["incidentRecord"],"members":{"incidentRecord":{"type":"structure","required":["arn","creationTime","dedupeString","impact","incidentRecordSource","lastModifiedBy","lastModifiedTime","status","title"],"members":{"arn":{},"automationExecutions":{"type":"list","member":{"type":"structure","members":{"ssmExecutionArn":{}},"union":true}},"chatChannel":{"shape":"Sl"},"creationTime":{"type":"timestamp"},"dedupeString":{},"impact":{"type":"integer"},"incidentRecordSource":{"shape":"S1q"},"lastModifiedBy":{},"lastModifiedTime":{"type":"timestamp"},"notificationTargets":{"shape":"Sv"},"resolvedTime":{"type":"timestamp"},"status":{},"summary":{},"title":{}}}}}},"GetReplicationSet":{"http":{"method":"GET","requestUri":"/getReplicationSet","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","required":["replicationSet"],"members":{"replicationSet":{"type":"structure","required":["createdBy","createdTime","deletionProtected","lastModifiedBy","lastModifiedTime","regionMap","status"],"members":{"arn":{},"createdBy":{},"createdTime":{"type":"timestamp"},"deletionProtected":{"type":"boolean"},"lastModifiedBy":{},"lastModifiedTime":{"type":"timestamp"},"regionMap":{"type":"map","key":{},"value":{"type":"structure","required":["status","statusUpdateDateTime"],"members":{"sseKmsKeyId":{},"status":{},"statusMessage":{},"statusUpdateDateTime":{"type":"timestamp"}}}},"status":{}}}}}},"GetResourcePolicies":{"http":{"requestUri":"/getResourcePolicies","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"maxResults":{"type":"integer"},"nextToken":{},"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","required":["resourcePolicies"],"members":{"nextToken":{},"resourcePolicies":{"type":"list","member":{"type":"structure","required":["policyDocument","policyId","ramResourceShareRegion"],"members":{"policyDocument":{},"policyId":{},"ramResourceShareRegion":{}}}}}}},"GetResponsePlan":{"http":{"method":"GET","requestUri":"/getResponsePlan","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","required":["arn","incidentTemplate","name"],"members":{"actions":{"shape":"Sa"},"arn":{},"chatChannel":{"shape":"Sl"},"displayName":{},"engagements":{"shape":"Sq"},"incidentTemplate":{"shape":"Ss"},"name":{}}}},"GetTimelineEvent":{"http":{"method":"GET","requestUri":"/getTimelineEvent","responseCode":200},"input":{"type":"structure","required":["eventId","incidentRecordArn"],"members":{"eventId":{"location":"querystring","locationName":"eventId"},"incidentRecordArn":{"location":"querystring","locationName":"incidentRecordArn"}}},"output":{"type":"structure","required":["event"],"members":{"event":{"type":"structure","required":["eventData","eventId","eventTime","eventType","eventUpdatedTime","incidentRecordArn"],"members":{"eventData":{},"eventId":{},"eventTime":{"type":"timestamp"},"eventType":{},"eventUpdatedTime":{"type":"timestamp"},"incidentRecordArn":{}}}}}},"ListIncidentRecords":{"http":{"requestUri":"/listIncidentRecords","responseCode":200},"input":{"type":"structure","members":{"filters":{"shape":"S2g"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["incidentRecordSummaries"],"members":{"incidentRecordSummaries":{"type":"list","member":{"type":"structure","required":["arn","creationTime","impact","incidentRecordSource","status","title"],"members":{"arn":{},"creationTime":{"type":"timestamp"},"impact":{"type":"integer"},"incidentRecordSource":{"shape":"S1q"},"resolvedTime":{"type":"timestamp"},"status":{},"title":{}}}},"nextToken":{}}}},"ListRelatedItems":{"http":{"requestUri":"/listRelatedItems","responseCode":200},"input":{"type":"structure","required":["incidentRecordArn"],"members":{"incidentRecordArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["relatedItems"],"members":{"nextToken":{},"relatedItems":{"shape":"S2u"}}}},"ListReplicationSets":{"http":{"requestUri":"/listReplicationSets","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["replicationSetArns"],"members":{"nextToken":{},"replicationSetArns":{"type":"list","member":{}}}}},"ListResponsePlans":{"http":{"requestUri":"/listResponsePlans","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["responsePlanSummaries"],"members":{"nextToken":{},"responsePlanSummaries":{"type":"list","member":{"type":"structure","required":["arn","name"],"members":{"arn":{},"displayName":{},"name":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S10"}}}},"ListTimelineEvents":{"http":{"requestUri":"/listTimelineEvents","responseCode":200},"input":{"type":"structure","required":["incidentRecordArn"],"members":{"filters":{"shape":"S2g"},"incidentRecordArn":{},"maxResults":{"type":"integer"},"nextToken":{},"sortBy":{},"sortOrder":{}}},"output":{"type":"structure","required":["eventSummaries"],"members":{"eventSummaries":{"type":"list","member":{"type":"structure","required":["eventId","eventTime","eventType","eventUpdatedTime","incidentRecordArn"],"members":{"eventId":{},"eventTime":{"type":"timestamp"},"eventType":{},"eventUpdatedTime":{"type":"timestamp"},"incidentRecordArn":{}}}},"nextToken":{}}}},"PutResourcePolicy":{"http":{"requestUri":"/putResourcePolicy","responseCode":200},"input":{"type":"structure","required":["policy","resourceArn"],"members":{"policy":{},"resourceArn":{}}},"output":{"type":"structure","required":["policyId"],"members":{"policyId":{}}}},"StartIncident":{"http":{"requestUri":"/startIncident","responseCode":200},"input":{"type":"structure","required":["responsePlanArn"],"members":{"clientToken":{"idempotencyToken":true},"impact":{"type":"integer"},"relatedItems":{"shape":"S2u"},"responsePlanArn":{},"title":{},"triggerDetails":{"type":"structure","required":["source","timestamp"],"members":{"rawData":{},"source":{},"timestamp":{"type":"timestamp"},"triggerArn":{}}}}},"output":{"type":"structure","required":["incidentRecordArn"],"members":{"incidentRecordArn":{}}},"idempotent":true},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateDeletionProtection":{"http":{"requestUri":"/updateDeletionProtection","responseCode":204},"input":{"type":"structure","required":["arn","deletionProtected"],"members":{"arn":{},"clientToken":{"idempotencyToken":true},"deletionProtected":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateIncidentRecord":{"http":{"requestUri":"/updateIncidentRecord","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"arn":{},"chatChannel":{"shape":"Sl"},"clientToken":{"idempotencyToken":true},"impact":{"type":"integer"},"notificationTargets":{"shape":"Sv"},"status":{},"summary":{},"title":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateRelatedItems":{"http":{"requestUri":"/updateRelatedItems","responseCode":204},"input":{"type":"structure","required":["incidentRecordArn","relatedItemsUpdate"],"members":{"clientToken":{"idempotencyToken":true},"incidentRecordArn":{},"relatedItemsUpdate":{"type":"structure","members":{"itemToAdd":{"shape":"S2v"},"itemToRemove":{"shape":"S2w"}},"union":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateReplicationSet":{"http":{"requestUri":"/updateReplicationSet","responseCode":204},"input":{"type":"structure","required":["actions","arn"],"members":{"actions":{"type":"list","member":{"type":"structure","members":{"addRegionAction":{"type":"structure","required":["regionName"],"members":{"regionName":{},"sseKmsKeyId":{}}},"deleteRegionAction":{"type":"structure","required":["regionName"],"members":{"regionName":{}}}},"union":true}},"arn":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"UpdateResponsePlan":{"http":{"requestUri":"/updateResponsePlan","responseCode":204},"input":{"type":"structure","required":["arn"],"members":{"actions":{"shape":"Sa"},"arn":{},"chatChannel":{"shape":"Sl"},"clientToken":{"idempotencyToken":true},"displayName":{},"engagements":{"shape":"Sq"},"incidentTemplateDedupeString":{},"incidentTemplateImpact":{"type":"integer"},"incidentTemplateNotificationTargets":{"shape":"Sv"},"incidentTemplateSummary":{},"incidentTemplateTitle":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateTimelineEvent":{"http":{"requestUri":"/updateTimelineEvent","responseCode":204},"input":{"type":"structure","required":["eventId","incidentRecordArn"],"members":{"clientToken":{"idempotencyToken":true},"eventData":{},"eventId":{},"eventTime":{"type":"timestamp"},"eventType":{},"incidentRecordArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"Sa":{"type":"list","member":{"type":"structure","members":{"ssmAutomation":{"type":"structure","required":["documentName","roleArn"],"members":{"documentName":{},"documentVersion":{},"parameters":{"type":"map","key":{},"value":{"type":"list","member":{}}},"roleArn":{},"targetAccount":{}}}},"union":true}},"Sl":{"type":"structure","members":{"chatbotSns":{"type":"list","member":{}},"empty":{"type":"structure","members":{}}},"union":true},"Sq":{"type":"list","member":{}},"Ss":{"type":"structure","required":["impact","title"],"members":{"dedupeString":{},"impact":{"type":"integer"},"notificationTargets":{"shape":"Sv"},"summary":{},"title":{}}},"Sv":{"type":"list","member":{"type":"structure","members":{"snsTopicArn":{}},"union":true}},"S10":{"type":"map","key":{},"value":{}},"S1q":{"type":"structure","required":["createdBy","source"],"members":{"createdBy":{},"invokedBy":{},"resourceArn":{},"source":{}}},"S2g":{"type":"list","member":{"type":"structure","required":["condition","key"],"members":{"condition":{"type":"structure","members":{"after":{"type":"timestamp"},"before":{"type":"timestamp"},"equals":{"type":"structure","members":{"integerValues":{"type":"list","member":{"type":"integer"}},"stringValues":{"type":"list","member":{}}},"union":true}},"union":true},"key":{}}}},"S2u":{"type":"list","member":{"shape":"S2v"}},"S2v":{"type":"structure","required":["identifier"],"members":{"identifier":{"shape":"S2w"},"title":{}}},"S2w":{"type":"structure","required":["type","value"],"members":{"type":{},"value":{"type":"structure","members":{"arn":{},"metricDefinition":{},"url":{}},"union":true}}}}}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetResourcePolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"resourcePolicies"},"ListIncidentRecords":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"incidentRecordSummaries"},"ListRelatedItems":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"relatedItems"},"ListReplicationSets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"replicationSetArns"},"ListResponsePlans":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"responsePlanSummaries"},"ListTimelineEvents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"eventSummaries"}}}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"WaitForReplicationSetActive":{"description":"Wait for a replication set to become ACTIVE","delay":30,"maxAttempts":5,"operation":"GetReplicationSet","acceptors":[{"matcher":"path","argument":"replicationSet.status","state":"success","expected":"ACTIVE"},{"matcher":"path","argument":"replicationSet.status","state":"retry","expected":"CREATING"},{"matcher":"path","argument":"replicationSet.status","state":"retry","expected":"UPDATING"},{"matcher":"path","argument":"replicationSet.status","state":"failure","expected":"FAILED"}]},"WaitForReplicationSetDeleted":{"description":"Wait for a replication set to be deleted","delay":30,"maxAttempts":5,"operation":"GetReplicationSet","acceptors":[{"matcher":"error","state":"success","expected":"ResourceNotFoundException"},{"matcher":"path","argument":"replicationSet.status","state":"retry","expected":"DELETING"},{"matcher":"path","argument":"replicationSet.status","state":"failure","expected":"FAILED"}]}}}

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['applicationcostprofiler'] = {};
	AWS.ApplicationCostProfiler = Service.defineService('applicationcostprofiler', ['2020-09-10']);
	Object.defineProperty(apiLoader.services['applicationcostprofiler'], '2020-09-10', {
	  get: function get() {
	    var model = __webpack_require__(1024);
	    model.paginators = __webpack_require__(1025).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ApplicationCostProfiler;


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-09-10","endpointPrefix":"application-cost-profiler","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Application Cost Profiler","serviceId":"ApplicationCostProfiler","signatureVersion":"v4","signingName":"application-cost-profiler","uid":"AWSApplicationCostProfiler-2020-09-10"},"operations":{"DeleteReportDefinition":{"http":{"method":"DELETE","requestUri":"/reportDefinition/{reportId}"},"input":{"type":"structure","required":["reportId"],"members":{"reportId":{"location":"uri","locationName":"reportId"}}},"output":{"type":"structure","members":{"reportId":{}}}},"GetReportDefinition":{"http":{"method":"GET","requestUri":"/reportDefinition/{reportId}"},"input":{"type":"structure","required":["reportId"],"members":{"reportId":{"location":"uri","locationName":"reportId"}}},"output":{"type":"structure","required":["reportId","reportDescription","reportFrequency","format","destinationS3Location","createdAt","lastUpdated"],"members":{"reportId":{},"reportDescription":{},"reportFrequency":{},"format":{},"destinationS3Location":{"shape":"S9"},"createdAt":{"type":"timestamp"},"lastUpdated":{"type":"timestamp"}}}},"ImportApplicationUsage":{"http":{"requestUri":"/importApplicationUsage"},"input":{"type":"structure","required":["sourceS3Location"],"members":{"sourceS3Location":{"type":"structure","required":["bucket","key"],"members":{"bucket":{},"key":{},"region":{}}}}},"output":{"type":"structure","required":["importId"],"members":{"importId":{}}}},"ListReportDefinitions":{"http":{"method":"GET","requestUri":"/reportDefinition"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"reportDefinitions":{"type":"list","member":{"type":"structure","members":{"reportId":{},"reportDescription":{},"reportFrequency":{},"format":{},"destinationS3Location":{"shape":"S9"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"PutReportDefinition":{"http":{"requestUri":"/reportDefinition"},"input":{"type":"structure","required":["reportId","reportDescription","reportFrequency","format","destinationS3Location"],"members":{"reportId":{},"reportDescription":{},"reportFrequency":{},"format":{},"destinationS3Location":{"shape":"S9"}}},"output":{"type":"structure","members":{"reportId":{}}}},"UpdateReportDefinition":{"http":{"method":"PUT","requestUri":"/reportDefinition/{reportId}"},"input":{"type":"structure","required":["reportId","reportDescription","reportFrequency","format","destinationS3Location"],"members":{"reportId":{"location":"uri","locationName":"reportId"},"reportDescription":{},"reportFrequency":{},"format":{},"destinationS3Location":{"shape":"S9"}}},"output":{"type":"structure","members":{"reportId":{}}}}},"shapes":{"S9":{"type":"structure","required":["bucket","prefix"],"members":{"bucket":{},"prefix":{}}}}}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListReportDefinitions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"reportDefinitions"}}}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['apprunner'] = {};
	AWS.AppRunner = Service.defineService('apprunner', ['2020-05-15']);
	Object.defineProperty(apiLoader.services['apprunner'], '2020-05-15', {
	  get: function get() {
	    var model = __webpack_require__(1027);
	    model.paginators = __webpack_require__(1028).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppRunner;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-05-15","endpointPrefix":"apprunner","jsonVersion":"1.0","protocol":"json","serviceFullName":"AWS App Runner","serviceId":"AppRunner","signatureVersion":"v4","signingName":"apprunner","targetPrefix":"AppRunner","uid":"apprunner-2020-05-15"},"operations":{"AssociateCustomDomain":{"input":{"type":"structure","required":["ServiceArn","DomainName"],"members":{"ServiceArn":{},"DomainName":{},"EnableWWWSubdomain":{"type":"boolean"}}},"output":{"type":"structure","required":["DNSTarget","ServiceArn","CustomDomain"],"members":{"DNSTarget":{},"ServiceArn":{},"CustomDomain":{"shape":"S7"}}}},"CreateAutoScalingConfiguration":{"input":{"type":"structure","required":["AutoScalingConfigurationName"],"members":{"AutoScalingConfigurationName":{},"MaxConcurrency":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["AutoScalingConfiguration"],"members":{"AutoScalingConfiguration":{"shape":"Sm"}}}},"CreateConnection":{"input":{"type":"structure","required":["ConnectionName","ProviderType"],"members":{"ConnectionName":{},"ProviderType":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["Connection"],"members":{"Connection":{"shape":"Sv"}}}},"CreateObservabilityConfiguration":{"input":{"type":"structure","required":["ObservabilityConfigurationName"],"members":{"ObservabilityConfigurationName":{},"TraceConfiguration":{"shape":"Sz"},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["ObservabilityConfiguration"],"members":{"ObservabilityConfiguration":{"shape":"S12"}}}},"CreateService":{"input":{"type":"structure","required":["ServiceName","SourceConfiguration"],"members":{"ServiceName":{},"SourceConfiguration":{"shape":"S16"},"InstanceConfiguration":{"shape":"S1p"},"Tags":{"shape":"Sh"},"EncryptionConfiguration":{"shape":"S1s"},"HealthCheckConfiguration":{"shape":"S1u"},"AutoScalingConfigurationArn":{},"NetworkConfiguration":{"shape":"S21"},"ObservabilityConfiguration":{"shape":"S24"}}},"output":{"type":"structure","required":["Service","OperationId"],"members":{"Service":{"shape":"S26"},"OperationId":{}}}},"CreateVpcConnector":{"input":{"type":"structure","required":["VpcConnectorName","Subnets"],"members":{"VpcConnectorName":{},"Subnets":{"shape":"S2d"},"SecurityGroups":{"shape":"S2d"},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["VpcConnector"],"members":{"VpcConnector":{"shape":"S2f"}}}},"DeleteAutoScalingConfiguration":{"input":{"type":"structure","required":["AutoScalingConfigurationArn"],"members":{"AutoScalingConfigurationArn":{}}},"output":{"type":"structure","required":["AutoScalingConfiguration"],"members":{"AutoScalingConfiguration":{"shape":"Sm"}}}},"DeleteConnection":{"input":{"type":"structure","required":["ConnectionArn"],"members":{"ConnectionArn":{}}},"output":{"type":"structure","members":{"Connection":{"shape":"Sv"}}}},"DeleteObservabilityConfiguration":{"input":{"type":"structure","required":["ObservabilityConfigurationArn"],"members":{"ObservabilityConfigurationArn":{}}},"output":{"type":"structure","required":["ObservabilityConfiguration"],"members":{"ObservabilityConfiguration":{"shape":"S12"}}}},"DeleteService":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{}}},"output":{"type":"structure","required":["Service","OperationId"],"members":{"Service":{"shape":"S26"},"OperationId":{}}}},"DeleteVpcConnector":{"input":{"type":"structure","required":["VpcConnectorArn"],"members":{"VpcConnectorArn":{}}},"output":{"type":"structure","required":["VpcConnector"],"members":{"VpcConnector":{"shape":"S2f"}}}},"DescribeAutoScalingConfiguration":{"input":{"type":"structure","required":["AutoScalingConfigurationArn"],"members":{"AutoScalingConfigurationArn":{}}},"output":{"type":"structure","required":["AutoScalingConfiguration"],"members":{"AutoScalingConfiguration":{"shape":"Sm"}}}},"DescribeCustomDomains":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["DNSTarget","ServiceArn","CustomDomains"],"members":{"DNSTarget":{},"ServiceArn":{},"CustomDomains":{"type":"list","member":{"shape":"S7"}},"NextToken":{}}}},"DescribeObservabilityConfiguration":{"input":{"type":"structure","required":["ObservabilityConfigurationArn"],"members":{"ObservabilityConfigurationArn":{}}},"output":{"type":"structure","required":["ObservabilityConfiguration"],"members":{"ObservabilityConfiguration":{"shape":"S12"}}}},"DescribeService":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{}}},"output":{"type":"structure","required":["Service"],"members":{"Service":{"shape":"S26"}}}},"DescribeVpcConnector":{"input":{"type":"structure","required":["VpcConnectorArn"],"members":{"VpcConnectorArn":{}}},"output":{"type":"structure","required":["VpcConnector"],"members":{"VpcConnector":{"shape":"S2f"}}}},"DisassociateCustomDomain":{"input":{"type":"structure","required":["ServiceArn","DomainName"],"members":{"ServiceArn":{},"DomainName":{}}},"output":{"type":"structure","required":["DNSTarget","ServiceArn","CustomDomain"],"members":{"DNSTarget":{},"ServiceArn":{},"CustomDomain":{"shape":"S7"}}}},"ListAutoScalingConfigurations":{"input":{"type":"structure","members":{"AutoScalingConfigurationName":{},"LatestOnly":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["AutoScalingConfigurationSummaryList"],"members":{"AutoScalingConfigurationSummaryList":{"type":"list","member":{"shape":"S29"}},"NextToken":{}}}},"ListConnections":{"input":{"type":"structure","members":{"ConnectionName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConnectionSummaryList"],"members":{"ConnectionSummaryList":{"type":"list","member":{"type":"structure","members":{"ConnectionName":{},"ConnectionArn":{},"ProviderType":{},"Status":{},"CreatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"ListObservabilityConfigurations":{"input":{"type":"structure","members":{"ObservabilityConfigurationName":{},"LatestOnly":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ObservabilityConfigurationSummaryList"],"members":{"ObservabilityConfigurationSummaryList":{"type":"list","member":{"type":"structure","members":{"ObservabilityConfigurationArn":{},"ObservabilityConfigurationName":{},"ObservabilityConfigurationRevision":{"type":"integer"}}}},"NextToken":{}}}},"ListOperations":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OperationSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Status":{},"TargetArn":{},"StartedAt":{"type":"timestamp"},"EndedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ServiceSummaryList"],"members":{"ServiceSummaryList":{"type":"list","member":{"type":"structure","members":{"ServiceName":{},"ServiceId":{},"ServiceArn":{},"ServiceUrl":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"Status":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh"}}}},"ListVpcConnectors":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["VpcConnectors"],"members":{"VpcConnectors":{"type":"list","member":{"shape":"S2f"}},"NextToken":{}}}},"PauseService":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{}}},"output":{"type":"structure","required":["Service"],"members":{"Service":{"shape":"S26"},"OperationId":{}}}},"ResumeService":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{}}},"output":{"type":"structure","required":["Service"],"members":{"Service":{"shape":"S26"},"OperationId":{}}}},"StartDeployment":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateService":{"input":{"type":"structure","required":["ServiceArn"],"members":{"ServiceArn":{},"SourceConfiguration":{"shape":"S16"},"InstanceConfiguration":{"shape":"S1p"},"AutoScalingConfigurationArn":{},"HealthCheckConfiguration":{"shape":"S1u"},"NetworkConfiguration":{"shape":"S21"},"ObservabilityConfiguration":{"shape":"S24"}}},"output":{"type":"structure","required":["Service","OperationId"],"members":{"Service":{"shape":"S26"},"OperationId":{}}}}},"shapes":{"S7":{"type":"structure","required":["DomainName","EnableWWWSubdomain","Status"],"members":{"DomainName":{},"EnableWWWSubdomain":{"type":"boolean"},"CertificateValidationRecords":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Value":{},"Status":{}}}},"Status":{}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sm":{"type":"structure","members":{"AutoScalingConfigurationArn":{},"AutoScalingConfigurationName":{},"AutoScalingConfigurationRevision":{"type":"integer"},"Latest":{"type":"boolean"},"Status":{},"MaxConcurrency":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"DeletedAt":{"type":"timestamp"}}},"Sv":{"type":"structure","members":{"ConnectionName":{},"ConnectionArn":{},"ProviderType":{},"Status":{},"CreatedAt":{"type":"timestamp"}}},"Sz":{"type":"structure","required":["Vendor"],"members":{"Vendor":{}}},"S12":{"type":"structure","members":{"ObservabilityConfigurationArn":{},"ObservabilityConfigurationName":{},"TraceConfiguration":{"shape":"Sz"},"ObservabilityConfigurationRevision":{"type":"integer"},"Latest":{"type":"boolean"},"Status":{},"CreatedAt":{"type":"timestamp"},"DeletedAt":{"type":"timestamp"}}},"S16":{"type":"structure","members":{"CodeRepository":{"type":"structure","required":["RepositoryUrl","SourceCodeVersion"],"members":{"RepositoryUrl":{},"SourceCodeVersion":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"CodeConfiguration":{"type":"structure","required":["ConfigurationSource"],"members":{"ConfigurationSource":{},"CodeConfigurationValues":{"type":"structure","required":["Runtime"],"members":{"Runtime":{},"BuildCommand":{"type":"string","sensitive":true},"StartCommand":{"shape":"S1f"},"Port":{},"RuntimeEnvironmentVariables":{"shape":"S1g"}}}}}}},"ImageRepository":{"type":"structure","required":["ImageIdentifier","ImageRepositoryType"],"members":{"ImageIdentifier":{},"ImageConfiguration":{"type":"structure","members":{"RuntimeEnvironmentVariables":{"shape":"S1g"},"StartCommand":{"shape":"S1f"},"Port":{}}},"ImageRepositoryType":{}}},"AutoDeploymentsEnabled":{"type":"boolean"},"AuthenticationConfiguration":{"type":"structure","members":{"ConnectionArn":{},"AccessRoleArn":{}}}}},"S1f":{"type":"string","sensitive":true},"S1g":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true}},"S1p":{"type":"structure","members":{"Cpu":{},"Memory":{},"InstanceRoleArn":{}}},"S1s":{"type":"structure","required":["KmsKey"],"members":{"KmsKey":{}}},"S1u":{"type":"structure","members":{"Protocol":{},"Path":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"HealthyThreshold":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"}}},"S21":{"type":"structure","members":{"EgressConfiguration":{"type":"structure","members":{"EgressType":{},"VpcConnectorArn":{}}}}},"S24":{"type":"structure","required":["ObservabilityEnabled"],"members":{"ObservabilityEnabled":{"type":"boolean"},"ObservabilityConfigurationArn":{}}},"S26":{"type":"structure","required":["ServiceName","ServiceId","ServiceArn","ServiceUrl","CreatedAt","UpdatedAt","Status","SourceConfiguration","InstanceConfiguration","AutoScalingConfigurationSummary","NetworkConfiguration"],"members":{"ServiceName":{},"ServiceId":{},"ServiceArn":{},"ServiceUrl":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"},"DeletedAt":{"type":"timestamp"},"Status":{},"SourceConfiguration":{"shape":"S16"},"InstanceConfiguration":{"shape":"S1p"},"EncryptionConfiguration":{"shape":"S1s"},"HealthCheckConfiguration":{"shape":"S1u"},"AutoScalingConfigurationSummary":{"shape":"S29"},"NetworkConfiguration":{"shape":"S21"},"ObservabilityConfiguration":{"shape":"S24"}}},"S29":{"type":"structure","members":{"AutoScalingConfigurationArn":{},"AutoScalingConfigurationName":{},"AutoScalingConfigurationRevision":{"type":"integer"}}},"S2d":{"type":"list","member":{}},"S2f":{"type":"structure","members":{"VpcConnectorName":{},"VpcConnectorArn":{},"VpcConnectorRevision":{"type":"integer"},"Subnets":{"shape":"S2d"},"SecurityGroups":{"shape":"S2d"},"Status":{},"CreatedAt":{"type":"timestamp"},"DeletedAt":{"type":"timestamp"}}}}}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeCustomDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAutoScalingConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObservabilityConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOperations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVpcConnectors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['proton'] = {};
	AWS.Proton = Service.defineService('proton', ['2020-07-20']);
	Object.defineProperty(apiLoader.services['proton'], '2020-07-20', {
	  get: function get() {
	    var model = __webpack_require__(1030);
	    model.paginators = __webpack_require__(1031).pagination;
	    model.waiters = __webpack_require__(1032).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Proton;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-20","endpointPrefix":"proton","jsonVersion":"1.0","protocol":"json","serviceFullName":"AWS Proton","serviceId":"Proton","signatureVersion":"v4","signingName":"proton","targetPrefix":"AwsProton20200720","uid":"proton-2020-07-20"},"operations":{"AcceptEnvironmentAccountConnection":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","required":["environmentAccountConnection"],"members":{"environmentAccountConnection":{"shape":"S4"}}},"idempotent":true},"CancelEnvironmentDeployment":{"input":{"type":"structure","required":["environmentName"],"members":{"environmentName":{}}},"output":{"type":"structure","required":["environment"],"members":{"environment":{"shape":"Sd"}}}},"CancelServiceInstanceDeployment":{"input":{"type":"structure","required":["serviceInstanceName","serviceName"],"members":{"serviceInstanceName":{},"serviceName":{}}},"output":{"type":"structure","required":["serviceInstance"],"members":{"serviceInstance":{"shape":"Ss"}}}},"CancelServicePipelineDeployment":{"input":{"type":"structure","required":["serviceName"],"members":{"serviceName":{}}},"output":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sw"}}}},"CreateEnvironment":{"input":{"type":"structure","required":["name","spec","templateMajorVersion","templateName"],"members":{"description":{"shape":"Sh"},"environmentAccountConnectionId":{},"name":{},"protonServiceRoleArn":{},"provisioningRepository":{"shape":"Sy"},"spec":{"shape":"So"},"tags":{"shape":"Sz"},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}},"output":{"type":"structure","required":["environment"],"members":{"environment":{"shape":"Sd"}}},"idempotent":true},"CreateEnvironmentAccountConnection":{"input":{"type":"structure","required":["environmentName","managementAccountId","roleArn"],"members":{"clientToken":{"idempotencyToken":true},"environmentName":{},"managementAccountId":{},"roleArn":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","required":["environmentAccountConnection"],"members":{"environmentAccountConnection":{"shape":"S4"}}},"idempotent":true},"CreateEnvironmentTemplate":{"input":{"type":"structure","required":["name"],"members":{"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"encryptionKey":{},"name":{},"provisioning":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","required":["environmentTemplate"],"members":{"environmentTemplate":{"shape":"S1a"}}},"idempotent":true},"CreateEnvironmentTemplateVersion":{"input":{"type":"structure","required":["source","templateName"],"members":{"clientToken":{"idempotencyToken":true},"description":{"shape":"Sh"},"majorVersion":{},"source":{"shape":"S1e"},"tags":{"shape":"Sz"},"templateName":{}}},"output":{"type":"structure","required":["environmentTemplateVersion"],"members":{"environmentTemplateVersion":{"shape":"S1j"}}},"idempotent":true},"CreateRepository":{"input":{"type":"structure","required":["connectionArn","name","provider"],"members":{"connectionArn":{},"encryptionKey":{},"name":{},"provider":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","required":["repository"],"members":{"repository":{"shape":"S1p"}}},"idempotent":true},"CreateService":{"input":{"type":"structure","required":["name","spec","templateMajorVersion","templateName"],"members":{"branchName":{},"description":{"shape":"Sh"},"name":{},"repositoryConnectionArn":{},"repositoryId":{},"spec":{"shape":"So"},"tags":{"shape":"Sz"},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}},"output":{"type":"structure","required":["service"],"members":{"service":{"shape":"S1t"}}},"idempotent":true},"CreateServiceTemplate":{"input":{"type":"structure","required":["name"],"members":{"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"encryptionKey":{},"name":{},"pipelineProvisioning":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","required":["serviceTemplate"],"members":{"serviceTemplate":{"shape":"S1y"}}},"idempotent":true},"CreateServiceTemplateVersion":{"input":{"type":"structure","required":["compatibleEnvironmentTemplates","source","templateName"],"members":{"clientToken":{"idempotencyToken":true},"compatibleEnvironmentTemplates":{"shape":"S21"},"description":{"shape":"Sh"},"majorVersion":{},"source":{"shape":"S1e"},"tags":{"shape":"Sz"},"templateName":{}}},"output":{"type":"structure","required":["serviceTemplateVersion"],"members":{"serviceTemplateVersion":{"shape":"S24"}}},"idempotent":true},"CreateTemplateSyncConfig":{"input":{"type":"structure","required":["branch","repositoryName","repositoryProvider","templateName","templateType"],"members":{"branch":{},"repositoryName":{},"repositoryProvider":{},"subdirectory":{},"templateName":{},"templateType":{}}},"output":{"type":"structure","members":{"templateSyncConfig":{"shape":"S2c"}}},"idempotent":true},"DeleteEnvironment":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"environment":{"shape":"Sd"}}},"idempotent":true},"DeleteEnvironmentAccountConnection":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"environmentAccountConnection":{"shape":"S4"}}},"idempotent":true},"DeleteEnvironmentTemplate":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"environmentTemplate":{"shape":"S1a"}}},"idempotent":true},"DeleteEnvironmentTemplateVersion":{"input":{"type":"structure","required":["majorVersion","minorVersion","templateName"],"members":{"majorVersion":{},"minorVersion":{},"templateName":{}}},"output":{"type":"structure","members":{"environmentTemplateVersion":{"shape":"S1j"}}},"idempotent":true},"DeleteRepository":{"input":{"type":"structure","required":["name","provider"],"members":{"name":{},"provider":{}}},"output":{"type":"structure","members":{"repository":{"shape":"S1p"}}},"idempotent":true},"DeleteService":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"service":{"shape":"S1t"}}},"idempotent":true},"DeleteServiceTemplate":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"serviceTemplate":{"shape":"S1y"}}},"idempotent":true},"DeleteServiceTemplateVersion":{"input":{"type":"structure","required":["majorVersion","minorVersion","templateName"],"members":{"majorVersion":{},"minorVersion":{},"templateName":{}}},"output":{"type":"structure","members":{"serviceTemplateVersion":{"shape":"S24"}}},"idempotent":true},"DeleteTemplateSyncConfig":{"input":{"type":"structure","required":["templateName","templateType"],"members":{"templateName":{},"templateType":{}}},"output":{"type":"structure","members":{"templateSyncConfig":{"shape":"S2c"}}},"idempotent":true},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"shape":"S2x"}}}},"GetEnvironment":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","required":["environment"],"members":{"environment":{"shape":"Sd"}}}},"GetEnvironmentAccountConnection":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","required":["environmentAccountConnection"],"members":{"environmentAccountConnection":{"shape":"S4"}}}},"GetEnvironmentTemplate":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","required":["environmentTemplate"],"members":{"environmentTemplate":{"shape":"S1a"}}}},"GetEnvironmentTemplateVersion":{"input":{"type":"structure","required":["majorVersion","minorVersion","templateName"],"members":{"majorVersion":{},"minorVersion":{},"templateName":{}}},"output":{"type":"structure","required":["environmentTemplateVersion"],"members":{"environmentTemplateVersion":{"shape":"S1j"}}}},"GetRepository":{"input":{"type":"structure","required":["name","provider"],"members":{"name":{},"provider":{}}},"output":{"type":"structure","required":["repository"],"members":{"repository":{"shape":"S1p"}}}},"GetRepositorySyncStatus":{"input":{"type":"structure","required":["branch","repositoryName","repositoryProvider","syncType"],"members":{"branch":{},"repositoryName":{},"repositoryProvider":{},"syncType":{}}},"output":{"type":"structure","members":{"latestSync":{"type":"structure","required":["events","startedAt","status"],"members":{"events":{"type":"list","member":{"type":"structure","required":["event","time","type"],"members":{"event":{},"externalId":{},"time":{"type":"timestamp"},"type":{}}}},"startedAt":{"type":"timestamp"},"status":{}}}}}},"GetService":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"service":{"shape":"S1t"}}}},"GetServiceInstance":{"input":{"type":"structure","required":["name","serviceName"],"members":{"name":{},"serviceName":{}}},"output":{"type":"structure","required":["serviceInstance"],"members":{"serviceInstance":{"shape":"Ss"}}}},"GetServiceTemplate":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","required":["serviceTemplate"],"members":{"serviceTemplate":{"shape":"S1y"}}}},"GetServiceTemplateVersion":{"input":{"type":"structure","required":["majorVersion","minorVersion","templateName"],"members":{"majorVersion":{},"minorVersion":{},"templateName":{}}},"output":{"type":"structure","required":["serviceTemplateVersion"],"members":{"serviceTemplateVersion":{"shape":"S24"}}}},"GetTemplateSyncConfig":{"input":{"type":"structure","required":["templateName","templateType"],"members":{"templateName":{},"templateType":{}}},"output":{"type":"structure","members":{"templateSyncConfig":{"shape":"S2c"}}}},"GetTemplateSyncStatus":{"input":{"type":"structure","required":["templateName","templateType","templateVersion"],"members":{"templateName":{},"templateType":{},"templateVersion":{}}},"output":{"type":"structure","members":{"desiredState":{"shape":"S3t"},"latestSuccessfulSync":{"shape":"S3v"},"latestSync":{"shape":"S3v"}}}},"ListEnvironmentAccountConnections":{"input":{"type":"structure","required":["requestedBy"],"members":{"environmentName":{},"maxResults":{"type":"integer"},"nextToken":{},"requestedBy":{},"statuses":{"type":"list","member":{}}}},"output":{"type":"structure","required":["environmentAccountConnections"],"members":{"environmentAccountConnections":{"type":"list","member":{"type":"structure","required":["arn","environmentAccountId","environmentName","id","lastModifiedAt","managementAccountId","requestedAt","roleArn","status"],"members":{"arn":{},"environmentAccountId":{},"environmentName":{},"id":{},"lastModifiedAt":{"type":"timestamp"},"managementAccountId":{},"requestedAt":{"type":"timestamp"},"roleArn":{},"status":{}}}},"nextToken":{}}}},"ListEnvironmentOutputs":{"input":{"type":"structure","required":["environmentName"],"members":{"environmentName":{},"nextToken":{}}},"output":{"type":"structure","required":["outputs"],"members":{"nextToken":{},"outputs":{"shape":"S4a"}}}},"ListEnvironmentProvisionedResources":{"input":{"type":"structure","required":["environmentName"],"members":{"environmentName":{},"nextToken":{}}},"output":{"type":"structure","required":["provisionedResources"],"members":{"nextToken":{},"provisionedResources":{"shape":"S4g"}}}},"ListEnvironmentTemplateVersions":{"input":{"type":"structure","required":["templateName"],"members":{"majorVersion":{},"maxResults":{"type":"integer"},"nextToken":{},"templateName":{}}},"output":{"type":"structure","required":["templateVersions"],"members":{"nextToken":{},"templateVersions":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastModifiedAt","majorVersion","minorVersion","status","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"lastModifiedAt":{"type":"timestamp"},"majorVersion":{},"minorVersion":{},"recommendedMinorVersion":{},"status":{},"statusMessage":{"shape":"Sg"},"templateName":{}}}}}}},"ListEnvironmentTemplates":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["templates"],"members":{"nextToken":{},"templates":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastModifiedAt","name"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"lastModifiedAt":{"type":"timestamp"},"name":{},"provisioning":{},"recommendedVersion":{}}}}}}},"ListEnvironments":{"input":{"type":"structure","members":{"environmentTemplates":{"type":"list","member":{"type":"structure","required":["majorVersion","templateName"],"members":{"majorVersion":{},"templateName":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["environments"],"members":{"environments":{"type":"list","member":{"type":"structure","required":["arn","createdAt","deploymentStatus","lastDeploymentAttemptedAt","lastDeploymentSucceededAt","name","templateMajorVersion","templateMinorVersion","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"deploymentStatus":{},"deploymentStatusMessage":{"shape":"Sg"},"description":{"shape":"Sh"},"environmentAccountConnectionId":{},"environmentAccountId":{},"lastDeploymentAttemptedAt":{"type":"timestamp"},"lastDeploymentSucceededAt":{"type":"timestamp"},"name":{},"protonServiceRoleArn":{},"provisioning":{},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}}},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["repositories"],"members":{"nextToken":{},"repositories":{"type":"list","member":{"type":"structure","required":["arn","name","provider"],"members":{"arn":{},"name":{},"provider":{}}}}}}},"ListRepositorySyncDefinitions":{"input":{"type":"structure","required":["repositoryName","repositoryProvider","syncType"],"members":{"nextToken":{},"repositoryName":{},"repositoryProvider":{},"syncType":{}}},"output":{"type":"structure","required":["syncDefinitions"],"members":{"nextToken":{},"syncDefinitions":{"type":"list","member":{"type":"structure","required":["branch","directory","parent","target"],"members":{"branch":{},"directory":{},"parent":{},"target":{}}}}}}},"ListServiceInstanceOutputs":{"input":{"type":"structure","required":["serviceInstanceName","serviceName"],"members":{"nextToken":{},"serviceInstanceName":{},"serviceName":{}}},"output":{"type":"structure","required":["outputs"],"members":{"nextToken":{},"outputs":{"shape":"S4a"}}}},"ListServiceInstanceProvisionedResources":{"input":{"type":"structure","required":["serviceInstanceName","serviceName"],"members":{"nextToken":{},"serviceInstanceName":{},"serviceName":{}}},"output":{"type":"structure","required":["provisionedResources"],"members":{"nextToken":{},"provisionedResources":{"shape":"S4g"}}}},"ListServiceInstances":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{},"serviceName":{}}},"output":{"type":"structure","required":["serviceInstances"],"members":{"nextToken":{},"serviceInstances":{"type":"list","member":{"type":"structure","required":["arn","createdAt","deploymentStatus","environmentName","lastDeploymentAttemptedAt","lastDeploymentSucceededAt","name","serviceName","templateMajorVersion","templateMinorVersion","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"deploymentStatus":{},"deploymentStatusMessage":{"shape":"Sg"},"environmentName":{},"lastDeploymentAttemptedAt":{"type":"timestamp"},"lastDeploymentSucceededAt":{"type":"timestamp"},"name":{},"serviceName":{},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}}}}}},"ListServicePipelineOutputs":{"input":{"type":"structure","required":["serviceName"],"members":{"nextToken":{},"serviceName":{}}},"output":{"type":"structure","required":["outputs"],"members":{"nextToken":{},"outputs":{"shape":"S4a"}}}},"ListServicePipelineProvisionedResources":{"input":{"type":"structure","required":["serviceName"],"members":{"nextToken":{},"serviceName":{}}},"output":{"type":"structure","required":["provisionedResources"],"members":{"nextToken":{},"provisionedResources":{"shape":"S4g"}}}},"ListServiceTemplateVersions":{"input":{"type":"structure","required":["templateName"],"members":{"majorVersion":{},"maxResults":{"type":"integer"},"nextToken":{},"templateName":{}}},"output":{"type":"structure","required":["templateVersions"],"members":{"nextToken":{},"templateVersions":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastModifiedAt","majorVersion","minorVersion","status","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"lastModifiedAt":{"type":"timestamp"},"majorVersion":{},"minorVersion":{},"recommendedMinorVersion":{},"status":{},"statusMessage":{"shape":"Sg"},"templateName":{}}}}}}},"ListServiceTemplates":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["templates"],"members":{"nextToken":{},"templates":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastModifiedAt","name"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"lastModifiedAt":{"type":"timestamp"},"name":{},"pipelineProvisioning":{},"recommendedVersion":{}}}}}}},"ListServices":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["services"],"members":{"nextToken":{},"services":{"type":"list","member":{"type":"structure","required":["arn","createdAt","lastModifiedAt","name","status","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"lastModifiedAt":{"type":"timestamp"},"name":{},"status":{},"statusMessage":{"shape":"Sg"},"templateName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"maxResults":{"type":"integer"},"nextToken":{},"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"nextToken":{},"tags":{"shape":"Sz"}}}},"NotifyResourceDeploymentStatusChange":{"input":{"type":"structure","required":["resourceArn","status"],"members":{"deploymentId":{},"outputs":{"type":"list","member":{"shape":"S4b"}},"resourceArn":{},"status":{},"statusMessage":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{}}},"RejectEnvironmentAccountConnection":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","required":["environmentAccountConnection"],"members":{"environmentAccountConnection":{"shape":"S4"}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateAccountSettings":{"input":{"type":"structure","members":{"pipelineProvisioningRepository":{"shape":"Sy"},"pipelineServiceRoleArn":{}}},"output":{"type":"structure","required":["accountSettings"],"members":{"accountSettings":{"shape":"S2x"}}}},"UpdateEnvironment":{"input":{"type":"structure","required":["deploymentType","name"],"members":{"deploymentType":{},"description":{"shape":"Sh"},"environmentAccountConnectionId":{},"name":{},"protonServiceRoleArn":{},"provisioningRepository":{"shape":"Sy"},"spec":{"shape":"So"},"templateMajorVersion":{},"templateMinorVersion":{}}},"output":{"type":"structure","required":["environment"],"members":{"environment":{"shape":"Sd"}}}},"UpdateEnvironmentAccountConnection":{"input":{"type":"structure","required":["id","roleArn"],"members":{"id":{},"roleArn":{}}},"output":{"type":"structure","required":["environmentAccountConnection"],"members":{"environmentAccountConnection":{"shape":"S4"}}},"idempotent":true},"UpdateEnvironmentTemplate":{"input":{"type":"structure","required":["name"],"members":{"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"name":{}}},"output":{"type":"structure","required":["environmentTemplate"],"members":{"environmentTemplate":{"shape":"S1a"}}}},"UpdateEnvironmentTemplateVersion":{"input":{"type":"structure","required":["majorVersion","minorVersion","templateName"],"members":{"description":{"shape":"Sh"},"majorVersion":{},"minorVersion":{},"status":{},"templateName":{}}},"output":{"type":"structure","required":["environmentTemplateVersion"],"members":{"environmentTemplateVersion":{"shape":"S1j"}}}},"UpdateService":{"input":{"type":"structure","required":["name"],"members":{"description":{"shape":"Sh"},"name":{},"spec":{"shape":"So"}}},"output":{"type":"structure","required":["service"],"members":{"service":{"shape":"S1t"}}}},"UpdateServiceInstance":{"input":{"type":"structure","required":["deploymentType","name","serviceName"],"members":{"deploymentType":{},"name":{},"serviceName":{},"spec":{"shape":"So"},"templateMajorVersion":{},"templateMinorVersion":{}}},"output":{"type":"structure","required":["serviceInstance"],"members":{"serviceInstance":{"shape":"Ss"}}}},"UpdateServicePipeline":{"input":{"type":"structure","required":["deploymentType","serviceName","spec"],"members":{"deploymentType":{},"serviceName":{},"spec":{"shape":"So"},"templateMajorVersion":{},"templateMinorVersion":{}}},"output":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sw"}}}},"UpdateServiceTemplate":{"input":{"type":"structure","required":["name"],"members":{"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"name":{}}},"output":{"type":"structure","required":["serviceTemplate"],"members":{"serviceTemplate":{"shape":"S1y"}}}},"UpdateServiceTemplateVersion":{"input":{"type":"structure","required":["majorVersion","minorVersion","templateName"],"members":{"compatibleEnvironmentTemplates":{"shape":"S21"},"description":{"shape":"Sh"},"majorVersion":{},"minorVersion":{},"status":{},"templateName":{}}},"output":{"type":"structure","required":["serviceTemplateVersion"],"members":{"serviceTemplateVersion":{"shape":"S24"}}}},"UpdateTemplateSyncConfig":{"input":{"type":"structure","required":["branch","repositoryName","repositoryProvider","templateName","templateType"],"members":{"branch":{},"repositoryName":{},"repositoryProvider":{},"subdirectory":{},"templateName":{},"templateType":{}}},"output":{"type":"structure","members":{"templateSyncConfig":{"shape":"S2c"}}}}},"shapes":{"S4":{"type":"structure","required":["arn","environmentAccountId","environmentName","id","lastModifiedAt","managementAccountId","requestedAt","roleArn","status"],"members":{"arn":{},"environmentAccountId":{},"environmentName":{},"id":{},"lastModifiedAt":{"type":"timestamp"},"managementAccountId":{},"requestedAt":{"type":"timestamp"},"roleArn":{},"status":{}}},"Sd":{"type":"structure","required":["arn","createdAt","deploymentStatus","lastDeploymentAttemptedAt","lastDeploymentSucceededAt","name","templateMajorVersion","templateMinorVersion","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"deploymentStatus":{},"deploymentStatusMessage":{"shape":"Sg"},"description":{"shape":"Sh"},"environmentAccountConnectionId":{},"environmentAccountId":{},"lastDeploymentAttemptedAt":{"type":"timestamp"},"lastDeploymentSucceededAt":{"type":"timestamp"},"name":{},"protonServiceRoleArn":{},"provisioning":{},"provisioningRepository":{"shape":"Sj"},"spec":{"shape":"So"},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}},"Sg":{"type":"string","sensitive":true},"Sh":{"type":"string","sensitive":true},"Sj":{"type":"structure","required":["arn","branch","name","provider"],"members":{"arn":{},"branch":{},"name":{},"provider":{}}},"So":{"type":"string","sensitive":true},"Ss":{"type":"structure","required":["arn","createdAt","deploymentStatus","environmentName","lastDeploymentAttemptedAt","lastDeploymentSucceededAt","name","serviceName","templateMajorVersion","templateMinorVersion","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"deploymentStatus":{},"deploymentStatusMessage":{"shape":"Sg"},"environmentName":{},"lastDeploymentAttemptedAt":{"type":"timestamp"},"lastDeploymentSucceededAt":{"type":"timestamp"},"name":{},"serviceName":{},"spec":{"shape":"So"},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}},"Sw":{"type":"structure","required":["arn","createdAt","deploymentStatus","lastDeploymentAttemptedAt","lastDeploymentSucceededAt","templateMajorVersion","templateMinorVersion","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"deploymentStatus":{},"deploymentStatusMessage":{"shape":"Sg"},"lastDeploymentAttemptedAt":{"type":"timestamp"},"lastDeploymentSucceededAt":{"type":"timestamp"},"spec":{"shape":"So"},"templateMajorVersion":{},"templateMinorVersion":{},"templateName":{}}},"Sy":{"type":"structure","required":["branch","name","provider"],"members":{"branch":{},"name":{},"provider":{}}},"Sz":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"S18":{"type":"string","sensitive":true},"S1a":{"type":"structure","required":["arn","createdAt","lastModifiedAt","name"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"encryptionKey":{},"lastModifiedAt":{"type":"timestamp"},"name":{},"provisioning":{},"recommendedVersion":{}}},"S1e":{"type":"structure","members":{"s3":{"type":"structure","required":["bucket","key"],"members":{"bucket":{},"key":{}}}},"union":true},"S1j":{"type":"structure","required":["arn","createdAt","lastModifiedAt","majorVersion","minorVersion","status","templateName"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"lastModifiedAt":{"type":"timestamp"},"majorVersion":{},"minorVersion":{},"recommendedMinorVersion":{},"schema":{"shape":"S1l"},"status":{},"statusMessage":{"shape":"Sg"},"templateName":{}}},"S1l":{"type":"string","sensitive":true},"S1p":{"type":"structure","required":["arn","connectionArn","name","provider"],"members":{"arn":{},"connectionArn":{},"encryptionKey":{},"name":{},"provider":{}}},"S1t":{"type":"structure","required":["arn","createdAt","lastModifiedAt","name","spec","status","templateName"],"members":{"arn":{},"branchName":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"lastModifiedAt":{"type":"timestamp"},"name":{},"pipeline":{"shape":"Sw"},"repositoryConnectionArn":{},"repositoryId":{},"spec":{"shape":"So"},"status":{},"statusMessage":{"shape":"Sg"},"templateName":{}}},"S1y":{"type":"structure","required":["arn","createdAt","lastModifiedAt","name"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"displayName":{"shape":"S18"},"encryptionKey":{},"lastModifiedAt":{"type":"timestamp"},"name":{},"pipelineProvisioning":{},"recommendedVersion":{}}},"S21":{"type":"list","member":{"type":"structure","required":["majorVersion","templateName"],"members":{"majorVersion":{},"templateName":{}}}},"S24":{"type":"structure","required":["arn","compatibleEnvironmentTemplates","createdAt","lastModifiedAt","majorVersion","minorVersion","status","templateName"],"members":{"arn":{},"compatibleEnvironmentTemplates":{"type":"list","member":{"type":"structure","required":["majorVersion","templateName"],"members":{"majorVersion":{},"templateName":{}}}},"createdAt":{"type":"timestamp"},"description":{"shape":"Sh"},"lastModifiedAt":{"type":"timestamp"},"majorVersion":{},"minorVersion":{},"recommendedMinorVersion":{},"schema":{"shape":"S1l"},"status":{},"statusMessage":{"shape":"Sg"},"templateName":{}}},"S2c":{"type":"structure","required":["branch","repositoryName","repositoryProvider","templateName","templateType"],"members":{"branch":{},"repositoryName":{},"repositoryProvider":{},"subdirectory":{},"templateName":{},"templateType":{}}},"S2x":{"type":"structure","members":{"pipelineProvisioningRepository":{"shape":"Sj"},"pipelineServiceRoleArn":{}}},"S3t":{"type":"structure","required":["branch","directory","repositoryName","repositoryProvider","sha"],"members":{"branch":{},"directory":{},"repositoryName":{},"repositoryProvider":{},"sha":{}}},"S3v":{"type":"structure","required":["events","initialRevision","startedAt","status","target","targetRevision"],"members":{"events":{"type":"list","member":{"type":"structure","required":["event","time","type"],"members":{"event":{},"externalId":{},"time":{"type":"timestamp"},"type":{}}}},"initialRevision":{"shape":"S3t"},"startedAt":{"type":"timestamp"},"status":{},"target":{},"targetRevision":{"shape":"S3t"}}},"S4a":{"type":"list","member":{"shape":"S4b"}},"S4b":{"type":"structure","members":{"key":{},"valueString":{}},"sensitive":true},"S4g":{"type":"list","member":{"type":"structure","members":{"identifier":{},"name":{},"provisioningEngine":{}}}}}}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListEnvironmentAccountConnections":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"environmentAccountConnections"},"ListEnvironmentOutputs":{"input_token":"nextToken","output_token":"nextToken","result_key":"outputs"},"ListEnvironmentProvisionedResources":{"input_token":"nextToken","output_token":"nextToken","result_key":"provisionedResources"},"ListEnvironmentTemplateVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"templateVersions"},"ListEnvironmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"templates"},"ListEnvironments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"environments"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"repositories"},"ListRepositorySyncDefinitions":{"input_token":"nextToken","output_token":"nextToken","result_key":"syncDefinitions"},"ListServiceInstanceOutputs":{"input_token":"nextToken","output_token":"nextToken","result_key":"outputs"},"ListServiceInstanceProvisionedResources":{"input_token":"nextToken","output_token":"nextToken","result_key":"provisionedResources"},"ListServiceInstances":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"serviceInstances"},"ListServicePipelineOutputs":{"input_token":"nextToken","output_token":"nextToken","result_key":"outputs"},"ListServicePipelineProvisionedResources":{"input_token":"nextToken","output_token":"nextToken","result_key":"provisionedResources"},"ListServiceTemplateVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"templateVersions"},"ListServiceTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"templates"},"ListServices":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"services"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tags"}}}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"EnvironmentDeployed":{"description":"Wait until an Environment is deployed. Use this after invoking CreateEnvironment or UpdateEnvironment","delay":5,"maxAttempts":999,"operation":"GetEnvironment","acceptors":[{"matcher":"path","argument":"environment.deploymentStatus","state":"success","expected":"SUCCEEDED"},{"matcher":"path","argument":"environment.deploymentStatus","state":"failure","expected":"FAILED"}]},"EnvironmentTemplateVersionRegistered":{"description":"Wait until an EnvironmentTemplateVersion is registered. Use this after invoking CreateEnvironmentTemplateVersion","delay":2,"maxAttempts":150,"operation":"GetEnvironmentTemplateVersion","acceptors":[{"matcher":"path","argument":"environmentTemplateVersion.status","state":"success","expected":"DRAFT"},{"matcher":"path","argument":"environmentTemplateVersion.status","state":"success","expected":"PUBLISHED"},{"matcher":"path","argument":"environmentTemplateVersion.status","state":"failure","expected":"REGISTRATION_FAILED"}]},"ServiceCreated":{"description":"Wait until an Service has deployed its instances and possibly pipeline. Use this after invoking CreateService","delay":5,"maxAttempts":999,"operation":"GetService","acceptors":[{"matcher":"path","argument":"service.status","state":"success","expected":"ACTIVE"},{"matcher":"path","argument":"service.status","state":"failure","expected":"CREATE_FAILED_CLEANUP_COMPLETE"},{"matcher":"path","argument":"service.status","state":"failure","expected":"CREATE_FAILED_CLEANUP_FAILED"},{"matcher":"path","argument":"service.status","state":"failure","expected":"CREATE_FAILED"}]},"ServiceDeleted":{"description":"Wait until a Service, its instances, and possibly pipeline have been deleted after DeleteService is invoked","delay":5,"maxAttempts":999,"operation":"GetService","acceptors":[{"matcher":"error","state":"success","expected":"ResourceNotFoundException"},{"matcher":"path","argument":"service.status","state":"failure","expected":"DELETE_FAILED"}]},"ServiceInstanceDeployed":{"description":"Wait until a ServiceInstance is deployed. Use this after invoking CreateService or UpdateServiceInstance","delay":5,"maxAttempts":999,"operation":"GetServiceInstance","acceptors":[{"matcher":"path","argument":"serviceInstance.deploymentStatus","state":"success","expected":"SUCCEEDED"},{"matcher":"path","argument":"serviceInstance.deploymentStatus","state":"failure","expected":"FAILED"}]},"ServicePipelineDeployed":{"description":"Wait until an ServicePipeline is deployed. Use this after invoking CreateService or UpdateServicePipeline","delay":10,"maxAttempts":360,"operation":"GetService","acceptors":[{"matcher":"path","argument":"service.pipeline.deploymentStatus","state":"success","expected":"SUCCEEDED"},{"matcher":"path","argument":"service.pipeline.deploymentStatus","state":"failure","expected":"FAILED"}]},"ServiceTemplateVersionRegistered":{"description":"Wait until a ServiceTemplateVersion is registered. Use this after invoking CreateServiceTemplateVersion","delay":2,"maxAttempts":150,"operation":"GetServiceTemplateVersion","acceptors":[{"matcher":"path","argument":"serviceTemplateVersion.status","state":"success","expected":"DRAFT"},{"matcher":"path","argument":"serviceTemplateVersion.status","state":"success","expected":"PUBLISHED"},{"matcher":"path","argument":"serviceTemplateVersion.status","state":"failure","expected":"REGISTRATION_FAILED"}]},"ServiceUpdated":{"description":"Wait until a Service, its instances, and possibly pipeline have been deployed after UpdateService is invoked","delay":5,"maxAttempts":999,"operation":"GetService","acceptors":[{"matcher":"path","argument":"service.status","state":"success","expected":"ACTIVE"},{"matcher":"path","argument":"service.status","state":"failure","expected":"UPDATE_FAILED_CLEANUP_COMPLETE"},{"matcher":"path","argument":"service.status","state":"failure","expected":"UPDATE_FAILED_CLEANUP_FAILED"},{"matcher":"path","argument":"service.status","state":"failure","expected":"UPDATE_FAILED"},{"matcher":"path","argument":"service.status","state":"failure","expected":"UPDATE_COMPLETE_CLEANUP_FAILED"}]}}}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['route53recoverycluster'] = {};
	AWS.Route53RecoveryCluster = Service.defineService('route53recoverycluster', ['2019-12-02']);
	Object.defineProperty(apiLoader.services['route53recoverycluster'], '2019-12-02', {
	  get: function get() {
	    var model = __webpack_require__(1034);
	    model.paginators = __webpack_require__(1035).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Route53RecoveryCluster;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-02","endpointPrefix":"route53-recovery-cluster","jsonVersion":"1.0","protocol":"json","serviceFullName":"Route53 Recovery Cluster","serviceId":"Route53 Recovery Cluster","signatureVersion":"v4","signingName":"route53-recovery-cluster","targetPrefix":"ToggleCustomerAPI","uid":"route53-recovery-cluster-2019-12-02"},"operations":{"GetRoutingControlState":{"input":{"type":"structure","required":["RoutingControlArn"],"members":{"RoutingControlArn":{}}},"output":{"type":"structure","required":["RoutingControlArn","RoutingControlState"],"members":{"RoutingControlArn":{},"RoutingControlState":{},"RoutingControlName":{}}}},"ListRoutingControls":{"input":{"type":"structure","members":{"ControlPanelArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["RoutingControls"],"members":{"RoutingControls":{"type":"list","member":{"type":"structure","members":{"ControlPanelArn":{},"ControlPanelName":{},"RoutingControlArn":{},"RoutingControlName":{},"RoutingControlState":{}}}},"NextToken":{}}}},"UpdateRoutingControlState":{"input":{"type":"structure","required":["RoutingControlArn","RoutingControlState"],"members":{"RoutingControlArn":{},"RoutingControlState":{},"SafetyRulesToOverride":{"shape":"Se"}}},"output":{"type":"structure","members":{}}},"UpdateRoutingControlStates":{"input":{"type":"structure","required":["UpdateRoutingControlStateEntries"],"members":{"UpdateRoutingControlStateEntries":{"type":"list","member":{"type":"structure","required":["RoutingControlArn","RoutingControlState"],"members":{"RoutingControlArn":{},"RoutingControlState":{}}}},"SafetyRulesToOverride":{"shape":"Se"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Se":{"type":"list","member":{}}}}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListRoutingControls":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"RoutingControls"}}}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['route53recoverycontrolconfig'] = {};
	AWS.Route53RecoveryControlConfig = Service.defineService('route53recoverycontrolconfig', ['2020-11-02']);
	Object.defineProperty(apiLoader.services['route53recoverycontrolconfig'], '2020-11-02', {
	  get: function get() {
	    var model = __webpack_require__(1037);
	    model.paginators = __webpack_require__(1038).pagination;
	    model.waiters = __webpack_require__(1039).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Route53RecoveryControlConfig;


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2020-11-02","endpointPrefix":"route53-recovery-control-config","signingName":"route53-recovery-control-config","serviceFullName":"AWS Route53 Recovery Control Config","serviceId":"Route53 Recovery Control Config","protocol":"rest-json","jsonVersion":"1.1","uid":"route53-recovery-control-config-2020-11-02","signatureVersion":"v4"},"operations":{"CreateCluster":{"http":{"requestUri":"/cluster","responseCode":200},"input":{"type":"structure","members":{"ClientToken":{"idempotencyToken":true},"ClusterName":{},"Tags":{"shape":"S3"}},"required":["ClusterName"]},"output":{"type":"structure","members":{"Cluster":{"shape":"S7"}}}},"CreateControlPanel":{"http":{"requestUri":"/controlpanel","responseCode":200},"input":{"type":"structure","members":{"ClientToken":{"idempotencyToken":true},"ClusterArn":{},"ControlPanelName":{},"Tags":{"shape":"S3"}},"required":["ClusterArn","ControlPanelName"]},"output":{"type":"structure","members":{"ControlPanel":{"shape":"Sg"}}}},"CreateRoutingControl":{"http":{"requestUri":"/routingcontrol","responseCode":200},"input":{"type":"structure","members":{"ClientToken":{"idempotencyToken":true},"ClusterArn":{},"ControlPanelArn":{},"RoutingControlName":{}},"required":["ClusterArn","RoutingControlName"]},"output":{"type":"structure","members":{"RoutingControl":{"shape":"Sl"}}}},"CreateSafetyRule":{"http":{"requestUri":"/safetyrule","responseCode":200},"input":{"type":"structure","members":{"AssertionRule":{"type":"structure","members":{"AssertedControls":{"shape":"So"},"ControlPanelArn":{},"Name":{},"RuleConfig":{"shape":"Sp"},"WaitPeriodMs":{"type":"integer"}},"required":["ControlPanelArn","AssertedControls","RuleConfig","WaitPeriodMs","Name"]},"ClientToken":{"idempotencyToken":true},"GatingRule":{"type":"structure","members":{"ControlPanelArn":{},"GatingControls":{"shape":"So"},"Name":{},"RuleConfig":{"shape":"Sp"},"TargetControls":{"shape":"So"},"WaitPeriodMs":{"type":"integer"}},"required":["TargetControls","ControlPanelArn","GatingControls","RuleConfig","WaitPeriodMs","Name"]},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"AssertionRule":{"shape":"St"},"GatingRule":{"shape":"Su"}}}},"DeleteCluster":{"http":{"method":"DELETE","requestUri":"/cluster/{ClusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"ClusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{}}},"DeleteControlPanel":{"http":{"method":"DELETE","requestUri":"/controlpanel/{ControlPanelArn}","responseCode":200},"input":{"type":"structure","members":{"ControlPanelArn":{"location":"uri","locationName":"ControlPanelArn"}},"required":["ControlPanelArn"]},"output":{"type":"structure","members":{}}},"DeleteRoutingControl":{"http":{"method":"DELETE","requestUri":"/routingcontrol/{RoutingControlArn}","responseCode":200},"input":{"type":"structure","members":{"RoutingControlArn":{"location":"uri","locationName":"RoutingControlArn"}},"required":["RoutingControlArn"]},"output":{"type":"structure","members":{}}},"DeleteSafetyRule":{"http":{"method":"DELETE","requestUri":"/safetyrule/{SafetyRuleArn}","responseCode":200},"input":{"type":"structure","members":{"SafetyRuleArn":{"location":"uri","locationName":"SafetyRuleArn"}},"required":["SafetyRuleArn"]},"output":{"type":"structure","members":{}}},"DescribeCluster":{"http":{"method":"GET","requestUri":"/cluster/{ClusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"ClusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"Cluster":{"shape":"S7"}}}},"DescribeControlPanel":{"http":{"method":"GET","requestUri":"/controlpanel/{ControlPanelArn}","responseCode":200},"input":{"type":"structure","members":{"ControlPanelArn":{"location":"uri","locationName":"ControlPanelArn"}},"required":["ControlPanelArn"]},"output":{"type":"structure","members":{"ControlPanel":{"shape":"Sg"}}}},"DescribeRoutingControl":{"http":{"method":"GET","requestUri":"/routingcontrol/{RoutingControlArn}","responseCode":200},"input":{"type":"structure","members":{"RoutingControlArn":{"location":"uri","locationName":"RoutingControlArn"}},"required":["RoutingControlArn"]},"output":{"type":"structure","members":{"RoutingControl":{"shape":"Sl"}}}},"DescribeSafetyRule":{"http":{"method":"GET","requestUri":"/safetyrule/{SafetyRuleArn}","responseCode":200},"input":{"type":"structure","members":{"SafetyRuleArn":{"location":"uri","locationName":"SafetyRuleArn"}},"required":["SafetyRuleArn"]},"output":{"type":"structure","members":{"AssertionRule":{"shape":"St"},"GatingRule":{"shape":"Su"}}}},"ListAssociatedRoute53HealthChecks":{"http":{"method":"GET","requestUri":"/routingcontrol/{RoutingControlArn}/associatedRoute53HealthChecks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"RoutingControlArn":{"location":"uri","locationName":"RoutingControlArn"}},"required":["RoutingControlArn"]},"output":{"type":"structure","members":{"HealthCheckIds":{"type":"list","member":{}},"NextToken":{}}}},"ListClusters":{"http":{"method":"GET","requestUri":"/cluster","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"shape":"S7"}},"NextToken":{}}}},"ListControlPanels":{"http":{"method":"GET","requestUri":"/controlpanels","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"querystring","locationName":"ClusterArn"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ControlPanels":{"type":"list","member":{"shape":"Sg"}},"NextToken":{}}}},"ListRoutingControls":{"http":{"method":"GET","requestUri":"/controlpanel/{ControlPanelArn}/routingcontrols","responseCode":200},"input":{"type":"structure","members":{"ControlPanelArn":{"location":"uri","locationName":"ControlPanelArn"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["ControlPanelArn"]},"output":{"type":"structure","members":{"NextToken":{},"RoutingControls":{"type":"list","member":{"shape":"Sl"}}}}},"ListSafetyRules":{"http":{"method":"GET","requestUri":"/controlpanel/{ControlPanelArn}/safetyrules","responseCode":200},"input":{"type":"structure","members":{"ControlPanelArn":{"location":"uri","locationName":"ControlPanelArn"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["ControlPanelArn"]},"output":{"type":"structure","members":{"NextToken":{},"SafetyRules":{"type":"list","member":{"type":"structure","members":{"ASSERTION":{"shape":"St"},"GATING":{"shape":"Su"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S3"}},"required":["ResourceArn","Tags"]},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"TagKeys","type":"list","member":{}}},"required":["ResourceArn","TagKeys"]},"output":{"type":"structure","members":{}}},"UpdateControlPanel":{"http":{"method":"PUT","requestUri":"/controlpanel","responseCode":200},"input":{"type":"structure","members":{"ControlPanelArn":{},"ControlPanelName":{}},"required":["ControlPanelArn","ControlPanelName"]},"output":{"type":"structure","members":{"ControlPanel":{"shape":"Sg"}}}},"UpdateRoutingControl":{"http":{"method":"PUT","requestUri":"/routingcontrol","responseCode":200},"input":{"type":"structure","members":{"RoutingControlArn":{},"RoutingControlName":{}},"required":["RoutingControlName","RoutingControlArn"]},"output":{"type":"structure","members":{"RoutingControl":{"shape":"Sl"}}}},"UpdateSafetyRule":{"http":{"method":"PUT","requestUri":"/safetyrule","responseCode":200},"input":{"type":"structure","members":{"AssertionRuleUpdate":{"type":"structure","members":{"Name":{},"SafetyRuleArn":{},"WaitPeriodMs":{"type":"integer"}},"required":["SafetyRuleArn","WaitPeriodMs","Name"]},"GatingRuleUpdate":{"type":"structure","members":{"Name":{},"SafetyRuleArn":{},"WaitPeriodMs":{"type":"integer"}},"required":["SafetyRuleArn","WaitPeriodMs","Name"]}}},"output":{"type":"structure","members":{"AssertionRule":{"shape":"St"},"GatingRule":{"shape":"Su"}}}}},"shapes":{"S3":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"ClusterArn":{},"ClusterEndpoints":{"type":"list","member":{"type":"structure","members":{"Endpoint":{},"Region":{}}}},"Name":{},"Status":{}}},"Sg":{"type":"structure","members":{"ClusterArn":{},"ControlPanelArn":{},"DefaultControlPanel":{"type":"boolean"},"Name":{},"RoutingControlCount":{"type":"integer"},"Status":{}}},"Sl":{"type":"structure","members":{"ControlPanelArn":{},"Name":{},"RoutingControlArn":{},"Status":{}}},"So":{"type":"list","member":{}},"Sp":{"type":"structure","members":{"Inverted":{"type":"boolean"},"Threshold":{"type":"integer"},"Type":{}},"required":["Type","Inverted","Threshold"]},"St":{"type":"structure","members":{"AssertedControls":{"shape":"So"},"ControlPanelArn":{},"Name":{},"RuleConfig":{"shape":"Sp"},"SafetyRuleArn":{},"Status":{},"WaitPeriodMs":{"type":"integer"}},"required":["Status","ControlPanelArn","SafetyRuleArn","AssertedControls","RuleConfig","WaitPeriodMs","Name"]},"Su":{"type":"structure","members":{"ControlPanelArn":{},"GatingControls":{"shape":"So"},"Name":{},"RuleConfig":{"shape":"Sp"},"SafetyRuleArn":{},"Status":{},"TargetControls":{"shape":"So"},"WaitPeriodMs":{"type":"integer"}},"required":["Status","TargetControls","ControlPanelArn","SafetyRuleArn","GatingControls","RuleConfig","WaitPeriodMs","Name"]}}}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAssociatedRoute53HealthChecks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListControlPanels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRoutingControls":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSafetyRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ClusterCreated":{"description":"Wait until a cluster is created","operation":"DescribeCluster","delay":5,"maxAttempts":26,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status","expected":"DEPLOYED"},{"state":"retry","matcher":"path","argument":"Cluster.Status","expected":"PENDING"},{"state":"retry","matcher":"status","expected":500}]},"ClusterDeleted":{"description":"Wait for a cluster to be deleted","operation":"DescribeCluster","delay":5,"maxAttempts":26,"acceptors":[{"state":"success","matcher":"status","expected":404},{"state":"retry","matcher":"path","argument":"Cluster.Status","expected":"PENDING_DELETION"},{"state":"retry","matcher":"status","expected":500}]},"ControlPanelCreated":{"description":"Wait until a control panel is created","operation":"DescribeControlPanel","delay":5,"maxAttempts":26,"acceptors":[{"state":"success","matcher":"path","argument":"ControlPanel.Status","expected":"DEPLOYED"},{"state":"retry","matcher":"path","argument":"ControlPanel.Status","expected":"PENDING"},{"state":"retry","matcher":"status","expected":500}]},"ControlPanelDeleted":{"description":"Wait until a control panel is deleted","operation":"DescribeControlPanel","delay":5,"maxAttempts":26,"acceptors":[{"state":"success","matcher":"status","expected":404},{"state":"retry","matcher":"path","argument":"ControlPanel.Status","expected":"PENDING_DELETION"},{"state":"retry","matcher":"status","expected":500}]},"RoutingControlCreated":{"description":"Wait until a routing control is created","operation":"DescribeRoutingControl","delay":5,"maxAttempts":26,"acceptors":[{"state":"success","matcher":"path","argument":"RoutingControl.Status","expected":"DEPLOYED"},{"state":"retry","matcher":"path","argument":"RoutingControl.Status","expected":"PENDING"},{"state":"retry","matcher":"status","expected":500}]},"RoutingControlDeleted":{"description":"Wait for a routing control to be deleted","operation":"DescribeRoutingControl","delay":5,"maxAttempts":26,"acceptors":[{"state":"success","matcher":"status","expected":404},{"state":"retry","matcher":"path","argument":"RoutingControl.Status","expected":"PENDING_DELETION"},{"state":"retry","matcher":"status","expected":500}]}}}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['route53recoveryreadiness'] = {};
	AWS.Route53RecoveryReadiness = Service.defineService('route53recoveryreadiness', ['2019-12-02']);
	Object.defineProperty(apiLoader.services['route53recoveryreadiness'], '2019-12-02', {
	  get: function get() {
	    var model = __webpack_require__(1041);
	    model.paginators = __webpack_require__(1042).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Route53RecoveryReadiness;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	module.exports = {"metadata":{"apiVersion":"2019-12-02","endpointPrefix":"route53-recovery-readiness","signingName":"route53-recovery-readiness","serviceFullName":"AWS Route53 Recovery Readiness","serviceId":"Route53 Recovery Readiness","protocol":"rest-json","jsonVersion":"1.1","uid":"route53-recovery-readiness-2019-12-02","signatureVersion":"v4"},"operations":{"CreateCell":{"http":{"requestUri":"/cells","responseCode":200},"input":{"type":"structure","members":{"CellName":{"locationName":"cellName"},"Cells":{"shape":"S3","locationName":"cells"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["CellName"]},"output":{"type":"structure","members":{"CellArn":{"locationName":"cellArn"},"CellName":{"locationName":"cellName"},"Cells":{"shape":"S3","locationName":"cells"},"ParentReadinessScopes":{"shape":"S3","locationName":"parentReadinessScopes"},"Tags":{"shape":"S4","locationName":"tags"}}}},"CreateCrossAccountAuthorization":{"http":{"requestUri":"/crossaccountauthorizations","responseCode":200},"input":{"type":"structure","members":{"CrossAccountAuthorization":{"locationName":"crossAccountAuthorization"}},"required":["CrossAccountAuthorization"]},"output":{"type":"structure","members":{"CrossAccountAuthorization":{"locationName":"crossAccountAuthorization"}}}},"CreateReadinessCheck":{"http":{"requestUri":"/readinesschecks","responseCode":200},"input":{"type":"structure","members":{"ReadinessCheckName":{"locationName":"readinessCheckName"},"ResourceSetName":{"locationName":"resourceSetName"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["ResourceSetName","ReadinessCheckName"]},"output":{"type":"structure","members":{"ReadinessCheckArn":{"locationName":"readinessCheckArn"},"ReadinessCheckName":{"locationName":"readinessCheckName"},"ResourceSet":{"locationName":"resourceSet"},"Tags":{"shape":"S4","locationName":"tags"}}}},"CreateRecoveryGroup":{"http":{"requestUri":"/recoverygroups","responseCode":200},"input":{"type":"structure","members":{"Cells":{"shape":"S3","locationName":"cells"},"RecoveryGroupName":{"locationName":"recoveryGroupName"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["RecoveryGroupName"]},"output":{"type":"structure","members":{"Cells":{"shape":"S3","locationName":"cells"},"RecoveryGroupArn":{"locationName":"recoveryGroupArn"},"RecoveryGroupName":{"locationName":"recoveryGroupName"},"Tags":{"shape":"S4","locationName":"tags"}}}},"CreateResourceSet":{"http":{"requestUri":"/resourcesets","responseCode":200},"input":{"type":"structure","members":{"ResourceSetName":{"locationName":"resourceSetName"},"ResourceSetType":{"locationName":"resourceSetType"},"Resources":{"shape":"Sh","locationName":"resources"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["ResourceSetType","ResourceSetName","Resources"]},"output":{"type":"structure","members":{"ResourceSetArn":{"locationName":"resourceSetArn"},"ResourceSetName":{"locationName":"resourceSetName"},"ResourceSetType":{"locationName":"resourceSetType"},"Resources":{"shape":"Sh","locationName":"resources"},"Tags":{"shape":"S4","locationName":"tags"}}}},"DeleteCell":{"http":{"method":"DELETE","requestUri":"/cells/{cellName}","responseCode":204},"input":{"type":"structure","members":{"CellName":{"location":"uri","locationName":"cellName"}},"required":["CellName"]}},"DeleteCrossAccountAuthorization":{"http":{"method":"DELETE","requestUri":"/crossaccountauthorizations/{crossAccountAuthorization}","responseCode":200},"input":{"type":"structure","members":{"CrossAccountAuthorization":{"location":"uri","locationName":"crossAccountAuthorization"}},"required":["CrossAccountAuthorization"]},"output":{"type":"structure","members":{}}},"DeleteReadinessCheck":{"http":{"method":"DELETE","requestUri":"/readinesschecks/{readinessCheckName}","responseCode":204},"input":{"type":"structure","members":{"ReadinessCheckName":{"location":"uri","locationName":"readinessCheckName"}},"required":["ReadinessCheckName"]}},"DeleteRecoveryGroup":{"http":{"method":"DELETE","requestUri":"/recoverygroups/{recoveryGroupName}","responseCode":204},"input":{"type":"structure","members":{"RecoveryGroupName":{"location":"uri","locationName":"recoveryGroupName"}},"required":["RecoveryGroupName"]}},"DeleteResourceSet":{"http":{"method":"DELETE","requestUri":"/resourcesets/{resourceSetName}","responseCode":204},"input":{"type":"structure","members":{"ResourceSetName":{"location":"uri","locationName":"resourceSetName"}},"required":["ResourceSetName"]}},"GetArchitectureRecommendations":{"http":{"method":"GET","requestUri":"/recoverygroups/{recoveryGroupName}/architectureRecommendations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RecoveryGroupName":{"location":"uri","locationName":"recoveryGroupName"}},"required":["RecoveryGroupName"]},"output":{"type":"structure","members":{"LastAuditTimestamp":{"locationName":"lastAuditTimestamp","type":"timestamp","timestampFormat":"iso8601"},"NextToken":{"locationName":"nextToken"},"Recommendations":{"locationName":"recommendations","type":"list","member":{"type":"structure","members":{"RecommendationText":{"locationName":"recommendationText"}},"required":["RecommendationText"]}}}}},"GetCell":{"http":{"method":"GET","requestUri":"/cells/{cellName}","responseCode":200},"input":{"type":"structure","members":{"CellName":{"location":"uri","locationName":"cellName"}},"required":["CellName"]},"output":{"type":"structure","members":{"CellArn":{"locationName":"cellArn"},"CellName":{"locationName":"cellName"},"Cells":{"shape":"S3","locationName":"cells"},"ParentReadinessScopes":{"shape":"S3","locationName":"parentReadinessScopes"},"Tags":{"shape":"S4","locationName":"tags"}}}},"GetCellReadinessSummary":{"http":{"method":"GET","requestUri":"/cellreadiness/{cellName}","responseCode":200},"input":{"type":"structure","members":{"CellName":{"location":"uri","locationName":"cellName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["CellName"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Readiness":{"locationName":"readiness"},"ReadinessChecks":{"shape":"S15","locationName":"readinessChecks"}}}},"GetReadinessCheck":{"http":{"method":"GET","requestUri":"/readinesschecks/{readinessCheckName}","responseCode":200},"input":{"type":"structure","members":{"ReadinessCheckName":{"location":"uri","locationName":"readinessCheckName"}},"required":["ReadinessCheckName"]},"output":{"type":"structure","members":{"ReadinessCheckArn":{"locationName":"readinessCheckArn"},"ReadinessCheckName":{"locationName":"readinessCheckName"},"ResourceSet":{"locationName":"resourceSet"},"Tags":{"shape":"S4","locationName":"tags"}}}},"GetReadinessCheckResourceStatus":{"http":{"method":"GET","requestUri":"/readinesschecks/{readinessCheckName}/resource/{resourceIdentifier}/status","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ReadinessCheckName":{"location":"uri","locationName":"readinessCheckName"},"ResourceIdentifier":{"location":"uri","locationName":"resourceIdentifier"}},"required":["ReadinessCheckName","ResourceIdentifier"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Readiness":{"locationName":"readiness"},"Rules":{"locationName":"rules","type":"list","member":{"type":"structure","members":{"LastCheckedTimestamp":{"shape":"S1d","locationName":"lastCheckedTimestamp"},"Messages":{"shape":"S1e","locationName":"messages"},"Readiness":{"locationName":"readiness"},"RuleId":{"locationName":"ruleId"}},"required":["Messages","Readiness","RuleId","LastCheckedTimestamp"]}}}}},"GetReadinessCheckStatus":{"http":{"method":"GET","requestUri":"/readinesschecks/{readinessCheckName}/status","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ReadinessCheckName":{"location":"uri","locationName":"readinessCheckName"}},"required":["ReadinessCheckName"]},"output":{"type":"structure","members":{"Messages":{"shape":"S1e","locationName":"messages"},"NextToken":{"locationName":"nextToken"},"Readiness":{"locationName":"readiness"},"Resources":{"locationName":"resources","type":"list","member":{"type":"structure","members":{"ComponentId":{"locationName":"componentId"},"LastCheckedTimestamp":{"shape":"S1d","locationName":"lastCheckedTimestamp"},"Readiness":{"locationName":"readiness"},"ResourceArn":{"locationName":"resourceArn"}},"required":["Readiness","LastCheckedTimestamp"]}}}}},"GetRecoveryGroup":{"http":{"method":"GET","requestUri":"/recoverygroups/{recoveryGroupName}","responseCode":200},"input":{"type":"structure","members":{"RecoveryGroupName":{"location":"uri","locationName":"recoveryGroupName"}},"required":["RecoveryGroupName"]},"output":{"type":"structure","members":{"Cells":{"shape":"S3","locationName":"cells"},"RecoveryGroupArn":{"locationName":"recoveryGroupArn"},"RecoveryGroupName":{"locationName":"recoveryGroupName"},"Tags":{"shape":"S4","locationName":"tags"}}}},"GetRecoveryGroupReadinessSummary":{"http":{"method":"GET","requestUri":"/recoverygroupreadiness/{recoveryGroupName}","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RecoveryGroupName":{"location":"uri","locationName":"recoveryGroupName"}},"required":["RecoveryGroupName"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Readiness":{"locationName":"readiness"},"ReadinessChecks":{"shape":"S15","locationName":"readinessChecks"}}}},"GetResourceSet":{"http":{"method":"GET","requestUri":"/resourcesets/{resourceSetName}","responseCode":200},"input":{"type":"structure","members":{"ResourceSetName":{"location":"uri","locationName":"resourceSetName"}},"required":["ResourceSetName"]},"output":{"type":"structure","members":{"ResourceSetArn":{"locationName":"resourceSetArn"},"ResourceSetName":{"locationName":"resourceSetName"},"ResourceSetType":{"locationName":"resourceSetType"},"Resources":{"shape":"Sh","locationName":"resources"},"Tags":{"shape":"S4","locationName":"tags"}}}},"ListCells":{"http":{"method":"GET","requestUri":"/cells","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Cells":{"locationName":"cells","type":"list","member":{"type":"structure","members":{"CellArn":{"locationName":"cellArn"},"CellName":{"locationName":"cellName"},"Cells":{"shape":"S3","locationName":"cells"},"ParentReadinessScopes":{"shape":"S3","locationName":"parentReadinessScopes"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["ParentReadinessScopes","CellArn","CellName","Cells"]}},"NextToken":{"locationName":"nextToken"}}}},"ListCrossAccountAuthorizations":{"http":{"method":"GET","requestUri":"/crossaccountauthorizations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"CrossAccountAuthorizations":{"locationName":"crossAccountAuthorizations","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListReadinessChecks":{"http":{"method":"GET","requestUri":"/readinesschecks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReadinessChecks":{"locationName":"readinessChecks","type":"list","member":{"type":"structure","members":{"ReadinessCheckArn":{"locationName":"readinessCheckArn"},"ReadinessCheckName":{"locationName":"readinessCheckName"},"ResourceSet":{"locationName":"resourceSet"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["ReadinessCheckArn","ResourceSet"]}}}}},"ListRecoveryGroups":{"http":{"method":"GET","requestUri":"/recoverygroups","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"RecoveryGroups":{"locationName":"recoveryGroups","type":"list","member":{"type":"structure","members":{"Cells":{"shape":"S3","locationName":"cells"},"RecoveryGroupArn":{"locationName":"recoveryGroupArn"},"RecoveryGroupName":{"locationName":"recoveryGroupName"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["RecoveryGroupArn","RecoveryGroupName","Cells"]}}}}},"ListResourceSets":{"http":{"method":"GET","requestUri":"/resourcesets","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ResourceSets":{"locationName":"resourceSets","type":"list","member":{"type":"structure","members":{"ResourceSetArn":{"locationName":"resourceSetArn"},"ResourceSetName":{"locationName":"resourceSetName"},"ResourceSetType":{"locationName":"resourceSetType"},"Resources":{"shape":"Sh","locationName":"resources"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["ResourceSetType","ResourceSetName","ResourceSetArn","Resources"]}}}}},"ListRules":{"http":{"method":"GET","requestUri":"/rules","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Rules":{"locationName":"rules","type":"list","member":{"type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"RuleDescription":{"locationName":"ruleDescription"},"RuleId":{"locationName":"ruleId"}},"required":["RuleDescription","RuleId","ResourceType"]}}}}},"ListTagsForResources":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S4","locationName":"tags"}}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"S4","locationName":"tags"}},"required":["ResourceArn","Tags"]},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"S3","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateCell":{"http":{"method":"PUT","requestUri":"/cells/{cellName}","responseCode":200},"input":{"type":"structure","members":{"CellName":{"location":"uri","locationName":"cellName"},"Cells":{"shape":"S3","locationName":"cells"}},"required":["CellName","Cells"]},"output":{"type":"structure","members":{"CellArn":{"locationName":"cellArn"},"CellName":{"locationName":"cellName"},"Cells":{"shape":"S3","locationName":"cells"},"ParentReadinessScopes":{"shape":"S3","locationName":"parentReadinessScopes"},"Tags":{"shape":"S4","locationName":"tags"}}}},"UpdateReadinessCheck":{"http":{"method":"PUT","requestUri":"/readinesschecks/{readinessCheckName}","responseCode":200},"input":{"type":"structure","members":{"ReadinessCheckName":{"location":"uri","locationName":"readinessCheckName"},"ResourceSetName":{"locationName":"resourceSetName"}},"required":["ReadinessCheckName","ResourceSetName"]},"output":{"type":"structure","members":{"ReadinessCheckArn":{"locationName":"readinessCheckArn"},"ReadinessCheckName":{"locationName":"readinessCheckName"},"ResourceSet":{"locationName":"resourceSet"},"Tags":{"shape":"S4","locationName":"tags"}}}},"UpdateRecoveryGroup":{"http":{"method":"PUT","requestUri":"/recoverygroups/{recoveryGroupName}","responseCode":200},"input":{"type":"structure","members":{"Cells":{"shape":"S3","locationName":"cells"},"RecoveryGroupName":{"location":"uri","locationName":"recoveryGroupName"}},"required":["RecoveryGroupName","Cells"]},"output":{"type":"structure","members":{"Cells":{"shape":"S3","locationName":"cells"},"RecoveryGroupArn":{"locationName":"recoveryGroupArn"},"RecoveryGroupName":{"locationName":"recoveryGroupName"},"Tags":{"shape":"S4","locationName":"tags"}}}},"UpdateResourceSet":{"http":{"method":"PUT","requestUri":"/resourcesets/{resourceSetName}","responseCode":200},"input":{"type":"structure","members":{"ResourceSetName":{"location":"uri","locationName":"resourceSetName"},"ResourceSetType":{"locationName":"resourceSetType"},"Resources":{"shape":"Sh","locationName":"resources"}},"required":["ResourceSetName","ResourceSetType","Resources"]},"output":{"type":"structure","members":{"ResourceSetArn":{"locationName":"resourceSetArn"},"ResourceSetName":{"locationName":"resourceSetName"},"ResourceSetType":{"locationName":"resourceSetType"},"Resources":{"shape":"Sh","locationName":"resources"},"Tags":{"shape":"S4","locationName":"tags"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S4":{"type":"map","key":{},"value":{}},"Sh":{"type":"list","member":{"type":"structure","members":{"ComponentId":{"locationName":"componentId"},"DnsTargetResource":{"locationName":"dnsTargetResource","type":"structure","members":{"DomainName":{"locationName":"domainName"},"HostedZoneArn":{"locationName":"hostedZoneArn"},"RecordSetId":{"locationName":"recordSetId"},"RecordType":{"locationName":"recordType"},"TargetResource":{"locationName":"targetResource","type":"structure","members":{"NLBResource":{"locationName":"nLBResource","type":"structure","members":{"Arn":{"locationName":"arn"}}},"R53Resource":{"locationName":"r53Resource","type":"structure","members":{"DomainName":{"locationName":"domainName"},"RecordSetId":{"locationName":"recordSetId"}}}}}}},"ReadinessScopes":{"shape":"S3","locationName":"readinessScopes"},"ResourceArn":{"locationName":"resourceArn"}}}},"S15":{"type":"list","member":{"type":"structure","members":{"Readiness":{"locationName":"readiness"},"ReadinessCheckName":{"locationName":"readinessCheckName"}}}},"S1d":{"type":"timestamp","timestampFormat":"iso8601"},"S1e":{"type":"list","member":{"type":"structure","members":{"MessageText":{"locationName":"messageText"}}}}}}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListReadinessChecks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ReadinessChecks"},"ListResourceSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResourceSets"},"ListCells":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Cells"},"ListRecoveryGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"RecoveryGroups"},"ListRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Rules"},"ListCrossAccountAuthorizations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"CrossAccountAuthorizations"},"GetCellReadinessSummary":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ReadinessChecks","non_aggregate_keys":["Readiness"]},"GetRecoveryGroupReadinessSummary":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ReadinessChecks","non_aggregate_keys":["Readiness"]},"GetReadinessCheckStatus":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Resources","non_aggregate_keys":["Readiness","Messages"]},"GetReadinessCheckResourceStatus":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Rules","non_aggregate_keys":["Readiness"]}}}

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['chimesdkidentity'] = {};
	AWS.ChimeSDKIdentity = Service.defineService('chimesdkidentity', ['2021-04-20']);
	Object.defineProperty(apiLoader.services['chimesdkidentity'], '2021-04-20', {
	  get: function get() {
	    var model = __webpack_require__(1044);
	    model.paginators = __webpack_require__(1045).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ChimeSDKIdentity;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-04-20","endpointPrefix":"identity-chime","protocol":"rest-json","serviceFullName":"Amazon Chime SDK Identity","serviceId":"Chime SDK Identity","signatureVersion":"v4","signingName":"chime","uid":"chime-sdk-identity-2021-04-20"},"operations":{"CreateAppInstance":{"http":{"requestUri":"/app-instances","responseCode":201},"input":{"type":"structure","required":["Name","ClientRequestToken"],"members":{"Name":{"shape":"S2"},"Metadata":{"shape":"S3"},"ClientRequestToken":{"shape":"S4","idempotencyToken":true},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"AppInstanceArn":{}}}},"CreateAppInstanceAdmin":{"http":{"requestUri":"/app-instances/{appInstanceArn}/admins","responseCode":201},"input":{"type":"structure","required":["AppInstanceAdminArn","AppInstanceArn"],"members":{"AppInstanceAdminArn":{},"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceAdmin":{"shape":"Sd"},"AppInstanceArn":{}}}},"CreateAppInstanceUser":{"http":{"requestUri":"/app-instance-users","responseCode":201},"input":{"type":"structure","required":["AppInstanceArn","AppInstanceUserId","Name","ClientRequestToken"],"members":{"AppInstanceArn":{},"AppInstanceUserId":{"type":"string","sensitive":true},"Name":{"shape":"Sh"},"Metadata":{"shape":"S3"},"ClientRequestToken":{"shape":"S4","idempotencyToken":true},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"AppInstanceUserArn":{}}}},"DeleteAppInstance":{"http":{"method":"DELETE","requestUri":"/app-instances/{appInstanceArn}","responseCode":204},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}}},"DeleteAppInstanceAdmin":{"http":{"method":"DELETE","requestUri":"/app-instances/{appInstanceArn}/admins/{appInstanceAdminArn}","responseCode":204},"input":{"type":"structure","required":["AppInstanceAdminArn","AppInstanceArn"],"members":{"AppInstanceAdminArn":{"location":"uri","locationName":"appInstanceAdminArn"},"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}}},"DeleteAppInstanceUser":{"http":{"method":"DELETE","requestUri":"/app-instance-users/{appInstanceUserArn}","responseCode":204},"input":{"type":"structure","required":["AppInstanceUserArn"],"members":{"AppInstanceUserArn":{"location":"uri","locationName":"appInstanceUserArn"}}}},"DeregisterAppInstanceUserEndpoint":{"http":{"method":"DELETE","requestUri":"/app-instance-users/{appInstanceUserArn}/endpoints/{endpointId}","responseCode":204},"input":{"type":"structure","required":["AppInstanceUserArn","EndpointId"],"members":{"AppInstanceUserArn":{"shape":"Sn","location":"uri","locationName":"appInstanceUserArn"},"EndpointId":{"shape":"So","location":"uri","locationName":"endpointId"}}}},"DescribeAppInstance":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}"},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstance":{"type":"structure","members":{"AppInstanceArn":{},"Name":{"shape":"S2"},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Metadata":{"shape":"S3"}}}}}},"DescribeAppInstanceAdmin":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/admins/{appInstanceAdminArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceAdminArn","AppInstanceArn"],"members":{"AppInstanceAdminArn":{"location":"uri","locationName":"appInstanceAdminArn"},"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceAdmin":{"type":"structure","members":{"Admin":{"shape":"Sd"},"AppInstanceArn":{},"CreatedTimestamp":{"type":"timestamp"}}}}}},"DescribeAppInstanceUser":{"http":{"method":"GET","requestUri":"/app-instance-users/{appInstanceUserArn}"},"input":{"type":"structure","required":["AppInstanceUserArn"],"members":{"AppInstanceUserArn":{"location":"uri","locationName":"appInstanceUserArn"}}},"output":{"type":"structure","members":{"AppInstanceUser":{"type":"structure","members":{"AppInstanceUserArn":{},"Name":{"shape":"Sh"},"Metadata":{"shape":"S3"},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}}},"DescribeAppInstanceUserEndpoint":{"http":{"method":"GET","requestUri":"/app-instance-users/{appInstanceUserArn}/endpoints/{endpointId}","responseCode":200},"input":{"type":"structure","required":["AppInstanceUserArn","EndpointId"],"members":{"AppInstanceUserArn":{"shape":"S10","location":"uri","locationName":"appInstanceUserArn"},"EndpointId":{"shape":"So","location":"uri","locationName":"endpointId"}}},"output":{"type":"structure","members":{"AppInstanceUserEndpoint":{"type":"structure","members":{"AppInstanceUserArn":{"shape":"Sn"},"EndpointId":{"shape":"So"},"Name":{"shape":"S10"},"Type":{},"ResourceArn":{"shape":"Sn"},"EndpointAttributes":{"shape":"S14"},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"AllowMessages":{},"EndpointState":{"shape":"S17"}}}}}},"GetAppInstanceRetentionSettings":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/retention-settings","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"}}},"output":{"type":"structure","members":{"AppInstanceRetentionSettings":{"shape":"S1c"},"InitiateDeletionTimestamp":{"type":"timestamp"}}}},"ListAppInstanceAdmins":{"http":{"method":"GET","requestUri":"/app-instances/{appInstanceArn}/admins","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S1h","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstanceArn":{},"AppInstanceAdmins":{"type":"list","member":{"type":"structure","members":{"Admin":{"shape":"Sd"}}}},"NextToken":{"shape":"S1h"}}}},"ListAppInstanceUserEndpoints":{"http":{"method":"GET","requestUri":"/app-instance-users/{appInstanceUserArn}/endpoints","responseCode":200},"input":{"type":"structure","required":["AppInstanceUserArn"],"members":{"AppInstanceUserArn":{"shape":"Sn","location":"uri","locationName":"appInstanceUserArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S1h","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstanceUserEndpoints":{"type":"list","member":{"type":"structure","members":{"AppInstanceUserArn":{"shape":"Sn"},"EndpointId":{"shape":"So"},"Name":{"shape":"S10"},"Type":{},"AllowMessages":{},"EndpointState":{"shape":"S17"}}}},"NextToken":{"shape":"S1h"}}}},"ListAppInstanceUsers":{"http":{"method":"GET","requestUri":"/app-instance-users"},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"querystring","locationName":"app-instance-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S1h","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstanceArn":{},"AppInstanceUsers":{"type":"list","member":{"type":"structure","members":{"AppInstanceUserArn":{},"Name":{"shape":"Sh"},"Metadata":{"shape":"S3"}}}},"NextToken":{"shape":"S1h"}}}},"ListAppInstances":{"http":{"method":"GET","requestUri":"/app-instances"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S1h","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"AppInstances":{"type":"list","member":{"type":"structure","members":{"AppInstanceArn":{},"Name":{"shape":"S2"},"Metadata":{"shape":"S3"}}}},"NextToken":{"shape":"S1h"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags","responseCode":200},"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5"}}}},"PutAppInstanceRetentionSettings":{"http":{"method":"PUT","requestUri":"/app-instances/{appInstanceArn}/retention-settings","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn","AppInstanceRetentionSettings"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"AppInstanceRetentionSettings":{"shape":"S1c"}}},"output":{"type":"structure","members":{"AppInstanceRetentionSettings":{"shape":"S1c"},"InitiateDeletionTimestamp":{"type":"timestamp"}}}},"RegisterAppInstanceUserEndpoint":{"http":{"requestUri":"/app-instance-users/{appInstanceUserArn}/endpoints","responseCode":201},"input":{"type":"structure","required":["AppInstanceUserArn","Type","ResourceArn","EndpointAttributes","ClientRequestToken"],"members":{"AppInstanceUserArn":{"shape":"Sn","location":"uri","locationName":"appInstanceUserArn"},"Name":{"shape":"S10"},"Type":{},"ResourceArn":{"shape":"Sn"},"EndpointAttributes":{"shape":"S14"},"ClientRequestToken":{"shape":"S4","idempotencyToken":true},"AllowMessages":{}}},"output":{"type":"structure","members":{"AppInstanceUserArn":{"shape":"Sn"},"EndpointId":{"shape":"So"}}}},"TagResource":{"http":{"requestUri":"/tags?operation=tag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5"}}}},"UntagResource":{"http":{"requestUri":"/tags?operation=untag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{"shape":"S7"}}}}},"UpdateAppInstance":{"http":{"method":"PUT","requestUri":"/app-instances/{appInstanceArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn","Name","Metadata"],"members":{"AppInstanceArn":{"location":"uri","locationName":"appInstanceArn"},"Name":{"shape":"S2"},"Metadata":{"shape":"S3"}}},"output":{"type":"structure","members":{"AppInstanceArn":{}}}},"UpdateAppInstanceUser":{"http":{"method":"PUT","requestUri":"/app-instance-users/{appInstanceUserArn}","responseCode":200},"input":{"type":"structure","required":["AppInstanceUserArn","Name","Metadata"],"members":{"AppInstanceUserArn":{"location":"uri","locationName":"appInstanceUserArn"},"Name":{"shape":"Sh"},"Metadata":{"shape":"S3"}}},"output":{"type":"structure","members":{"AppInstanceUserArn":{}}}},"UpdateAppInstanceUserEndpoint":{"http":{"method":"PUT","requestUri":"/app-instance-users/{appInstanceUserArn}/endpoints/{endpointId}","responseCode":200},"input":{"type":"structure","required":["AppInstanceUserArn","EndpointId"],"members":{"AppInstanceUserArn":{"shape":"Sn","location":"uri","locationName":"appInstanceUserArn"},"EndpointId":{"shape":"So","location":"uri","locationName":"endpointId"},"Name":{"shape":"S10"},"AllowMessages":{}}},"output":{"type":"structure","members":{"AppInstanceUserArn":{"shape":"Sn"},"EndpointId":{"shape":"So"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S3":{"type":"string","sensitive":true},"S4":{"type":"string","sensitive":true},"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S7"},"Value":{"type":"string","sensitive":true}}}},"S7":{"type":"string","sensitive":true},"Sd":{"type":"structure","members":{"Arn":{},"Name":{"type":"string","sensitive":true}}},"Sh":{"type":"string","sensitive":true},"Sn":{"type":"string","sensitive":true},"So":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S14":{"type":"structure","required":["DeviceToken"],"members":{"DeviceToken":{"shape":"S15"},"VoipDeviceToken":{"shape":"S15"}}},"S15":{"type":"string","sensitive":true},"S17":{"type":"structure","required":["Status"],"members":{"Status":{},"StatusReason":{}}},"S1c":{"type":"structure","members":{"ChannelRetentionSettings":{"type":"structure","members":{"RetentionDays":{"type":"integer"}}}}},"S1h":{"type":"string","sensitive":true}}}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAppInstanceAdmins":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAppInstanceUserEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAppInstanceUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAppInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['chimesdkmessaging'] = {};
	AWS.ChimeSDKMessaging = Service.defineService('chimesdkmessaging', ['2021-05-15']);
	Object.defineProperty(apiLoader.services['chimesdkmessaging'], '2021-05-15', {
	  get: function get() {
	    var model = __webpack_require__(1047);
	    model.paginators = __webpack_require__(1048).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ChimeSDKMessaging;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-05-15","endpointPrefix":"messaging-chime","protocol":"rest-json","serviceFullName":"Amazon Chime SDK Messaging","serviceId":"Chime SDK Messaging","signatureVersion":"v4","signingName":"chime","uid":"chime-sdk-messaging-2021-05-15"},"operations":{"AssociateChannelFlow":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}/channel-flow","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChannelFlowArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelFlowArn":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"BatchCreateChannelMembership":{"http":{"requestUri":"/channels/{channelArn}/memberships?operation=batch-create","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArns","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Type":{},"MemberArns":{"type":"list","member":{}},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"BatchChannelMemberships":{"type":"structure","members":{"InvitedBy":{"shape":"S8"},"Type":{},"Members":{"type":"list","member":{"shape":"S8"}},"ChannelArn":{}}},"Errors":{"type":"list","member":{"type":"structure","members":{"MemberArn":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"ChannelFlowCallback":{"http":{"requestUri":"/channels/{channelArn}?operation=channel-flow-callback","responseCode":200},"input":{"type":"structure","required":["CallbackId","ChannelArn","ChannelMessage"],"members":{"CallbackId":{"idempotencyToken":true},"ChannelArn":{"location":"uri","locationName":"channelArn"},"DeleteResource":{"type":"boolean"},"ChannelMessage":{"type":"structure","required":["MessageId"],"members":{"MessageId":{},"Content":{"shape":"Sk"},"Metadata":{"shape":"Sl"},"PushNotification":{"shape":"Sm"},"MessageAttributes":{"shape":"Sq"}}}}},"output":{"type":"structure","members":{"ChannelArn":{},"CallbackId":{}}}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":201},"input":{"type":"structure","required":["AppInstanceArn","Name","ClientRequestToken","ChimeBearer"],"members":{"AppInstanceArn":{},"Name":{"shape":"Sx"},"Mode":{},"Privacy":{},"Metadata":{"shape":"Sl"},"ClientRequestToken":{"shape":"S10","idempotencyToken":true},"Tags":{"shape":"S11"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{}}}},"CreateChannelBan":{"http":{"requestUri":"/channels/{channelArn}/bans","responseCode":201},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Member":{"shape":"S8"}}}},"CreateChannelFlow":{"http":{"requestUri":"/channel-flows","responseCode":201},"input":{"type":"structure","required":["AppInstanceArn","Processors","Name","ClientRequestToken"],"members":{"AppInstanceArn":{},"Processors":{"shape":"S19"},"Name":{"shape":"Sx"},"Tags":{"shape":"S11"},"ClientRequestToken":{"shape":"S10"}}},"output":{"type":"structure","members":{"ChannelFlowArn":{}}}},"CreateChannelMembership":{"http":{"requestUri":"/channels/{channelArn}/memberships","responseCode":201},"input":{"type":"structure","required":["ChannelArn","MemberArn","Type","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{},"Type":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Member":{"shape":"S8"}}}},"CreateChannelModerator":{"http":{"requestUri":"/channels/{channelArn}/moderators","responseCode":201},"input":{"type":"structure","required":["ChannelArn","ChannelModeratorArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelModeratorArn":{},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"ChannelModerator":{"shape":"S8"}}}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"DeleteChannelBan":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/bans/{memberArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"DeleteChannelFlow":{"http":{"method":"DELETE","requestUri":"/channel-flows/{channelFlowArn}","responseCode":204},"input":{"type":"structure","required":["ChannelFlowArn"],"members":{"ChannelFlowArn":{"location":"uri","locationName":"channelFlowArn"}}}},"DeleteChannelMembership":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/memberships/{memberArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"DeleteChannelMessage":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/messages/{messageId}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","MessageId","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"DeleteChannelModerator":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/moderators/{channelModeratorArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","ChannelModeratorArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelModeratorArn":{"location":"uri","locationName":"channelModeratorArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{channelArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channel":{"type":"structure","members":{"Name":{"shape":"Sx"},"ChannelArn":{},"Mode":{},"Privacy":{},"Metadata":{"shape":"Sl"},"CreatedBy":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"LastMessageTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"ChannelFlowArn":{}}}}}},"DescribeChannelBan":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/bans/{memberArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelBan":{"type":"structure","members":{"Member":{"shape":"S8"},"ChannelArn":{},"CreatedTimestamp":{"type":"timestamp"},"CreatedBy":{"shape":"S8"}}}}}},"DescribeChannelFlow":{"http":{"method":"GET","requestUri":"/channel-flows/{channelFlowArn}","responseCode":200},"input":{"type":"structure","required":["ChannelFlowArn"],"members":{"ChannelFlowArn":{"location":"uri","locationName":"channelFlowArn"}}},"output":{"type":"structure","members":{"ChannelFlow":{"type":"structure","members":{"ChannelFlowArn":{},"Processors":{"shape":"S19"},"Name":{"shape":"Sx"},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}}},"DescribeChannelMembership":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/memberships/{memberArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMembership":{"type":"structure","members":{"InvitedBy":{"shape":"S8"},"Type":{},"Member":{"shape":"S8"},"ChannelArn":{},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}}}},"DescribeChannelMembershipForAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels/{channelArn}?scope=app-instance-user-membership","responseCode":200},"input":{"type":"structure","required":["ChannelArn","AppInstanceUserArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMembership":{"shape":"S27"}}}},"DescribeChannelModeratedByAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels/{channelArn}?scope=app-instance-user-moderated-channel","responseCode":200},"input":{"type":"structure","required":["ChannelArn","AppInstanceUserArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channel":{"shape":"S2c"}}}},"DescribeChannelModerator":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/moderators/{channelModeratorArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChannelModeratorArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelModeratorArn":{"location":"uri","locationName":"channelModeratorArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelModerator":{"type":"structure","members":{"Moderator":{"shape":"S8"},"ChannelArn":{},"CreatedTimestamp":{"type":"timestamp"},"CreatedBy":{"shape":"S8"}}}}}},"DisassociateChannelFlow":{"http":{"method":"DELETE","requestUri":"/channels/{channelArn}/channel-flow/{channelFlowArn}","responseCode":204},"input":{"type":"structure","required":["ChannelArn","ChannelFlowArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChannelFlowArn":{"location":"uri","locationName":"channelFlowArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}}},"GetChannelMembershipPreferences":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/memberships/{memberArn}/preferences","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Member":{"shape":"S8"},"Preferences":{"shape":"S2j"}}}},"GetChannelMessage":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/messages/{messageId}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMessage":{"type":"structure","members":{"ChannelArn":{},"MessageId":{},"Content":{"shape":"S2q"},"Metadata":{"shape":"Sl"},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"LastEditedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Sender":{"shape":"S8"},"Redacted":{"type":"boolean"},"Persistence":{},"Status":{"shape":"S2t"},"MessageAttributes":{"shape":"Sq"}}}}}},"GetChannelMessageStatus":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/messages/{messageId}?scope=message-status","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Status":{"shape":"S2t"}}}},"GetMessagingSessionEndpoint":{"http":{"method":"GET","requestUri":"/endpoints/messaging-session","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Endpoint":{"type":"structure","members":{"Url":{}}}}}},"ListChannelBans":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/bans","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"NextToken":{"shape":"S34"},"ChannelBans":{"type":"list","member":{"type":"structure","members":{"Member":{"shape":"S8"}}}}}}},"ListChannelFlows":{"http":{"method":"GET","requestUri":"/channel-flows","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn"],"members":{"AppInstanceArn":{"location":"querystring","locationName":"app-instance-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"ChannelFlows":{"type":"list","member":{"type":"structure","members":{"ChannelFlowArn":{},"Name":{"shape":"Sx"},"Processors":{"shape":"S19"}}}},"NextToken":{"shape":"S34"}}}},"ListChannelMemberships":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/memberships","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Type":{"location":"querystring","locationName":"type"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"ChannelMemberships":{"type":"list","member":{"type":"structure","members":{"Member":{"shape":"S8"}}}},"NextToken":{"shape":"S34"}}}},"ListChannelMembershipsForAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels?scope=app-instance-user-memberships","responseCode":200},"input":{"type":"structure","required":["ChimeBearer"],"members":{"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelMemberships":{"type":"list","member":{"shape":"S27"}},"NextToken":{"shape":"S34"}}}},"ListChannelMessages":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/messages","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"SortOrder":{"location":"querystring","locationName":"sort-order"},"NotBefore":{"location":"querystring","locationName":"not-before","type":"timestamp"},"NotAfter":{"location":"querystring","locationName":"not-after","type":"timestamp"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"NextToken":{"shape":"S34"},"ChannelMessages":{"type":"list","member":{"type":"structure","members":{"MessageId":{},"Content":{"shape":"S2q"},"Metadata":{"shape":"Sl"},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"LastEditedTimestamp":{"type":"timestamp"},"Sender":{"shape":"S8"},"Redacted":{"type":"boolean"},"Status":{"shape":"S2t"},"MessageAttributes":{"shape":"Sq"}}}}}}},"ListChannelModerators":{"http":{"method":"GET","requestUri":"/channels/{channelArn}/moderators","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"NextToken":{"shape":"S34"},"ChannelModerators":{"type":"list","member":{"type":"structure","members":{"Moderator":{"shape":"S8"}}}}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels","responseCode":200},"input":{"type":"structure","required":["AppInstanceArn","ChimeBearer"],"members":{"AppInstanceArn":{"location":"querystring","locationName":"app-instance-arn"},"Privacy":{"location":"querystring","locationName":"privacy"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"shape":"S28"}},"NextToken":{"shape":"S34"}}}},"ListChannelsAssociatedWithChannelFlow":{"http":{"method":"GET","requestUri":"/channels?scope=channel-flow-associations","responseCode":200},"input":{"type":"structure","required":["ChannelFlowArn"],"members":{"ChannelFlowArn":{"location":"querystring","locationName":"channel-flow-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"Sx"},"ChannelArn":{},"Mode":{},"Privacy":{},"Metadata":{"shape":"Sl"}}}},"NextToken":{"shape":"S34"}}}},"ListChannelsModeratedByAppInstanceUser":{"http":{"method":"GET","requestUri":"/channels?scope=app-instance-user-moderated-channels","responseCode":200},"input":{"type":"structure","required":["ChimeBearer"],"members":{"AppInstanceUserArn":{"location":"querystring","locationName":"app-instance-user-arn"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"shape":"S34","location":"querystring","locationName":"next-token"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"shape":"S2c"}},"NextToken":{"shape":"S34"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags","responseCode":200},"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S11"}}}},"PutChannelMembershipPreferences":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}/memberships/{memberArn}/preferences","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MemberArn","ChimeBearer","Preferences"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MemberArn":{"location":"uri","locationName":"memberArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"},"Preferences":{"shape":"S2j"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Member":{"shape":"S8"},"Preferences":{"shape":"S2j"}}}},"RedactChannelMessage":{"http":{"requestUri":"/channels/{channelArn}/messages/{messageId}?operation=redact","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"MessageId":{}}}},"SendChannelMessage":{"http":{"requestUri":"/channels/{channelArn}/messages","responseCode":201},"input":{"type":"structure","required":["ChannelArn","Content","Type","Persistence","ClientRequestToken","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Content":{"shape":"Sk"},"Type":{},"Persistence":{},"Metadata":{"shape":"Sl"},"ClientRequestToken":{"shape":"S10","idempotencyToken":true},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"},"PushNotification":{"shape":"Sm"},"MessageAttributes":{"shape":"Sq"}}},"output":{"type":"structure","members":{"ChannelArn":{},"MessageId":{},"Status":{"shape":"S2t"}}}},"TagResource":{"http":{"requestUri":"/tags?operation=tag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S11"}}}},"UntagResource":{"http":{"requestUri":"/tags?operation=untag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{"shape":"S13"}}}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","Name","Mode","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"Name":{"shape":"Sx"},"Mode":{},"Metadata":{"shape":"Sl"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{}}}},"UpdateChannelFlow":{"http":{"method":"PUT","requestUri":"/channel-flows/{channelFlowArn}","responseCode":200},"input":{"type":"structure","required":["ChannelFlowArn","Processors","Name"],"members":{"ChannelFlowArn":{"location":"uri","locationName":"channelFlowArn"},"Processors":{"shape":"S19"},"Name":{"shape":"Sx"}}},"output":{"type":"structure","members":{"ChannelFlowArn":{}}}},"UpdateChannelMessage":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}/messages/{messageId}","responseCode":200},"input":{"type":"structure","required":["ChannelArn","MessageId","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"MessageId":{"location":"uri","locationName":"messageId"},"Content":{"shape":"S2q"},"Metadata":{"shape":"Sl"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{},"MessageId":{},"Status":{"shape":"S2t"}}}},"UpdateChannelReadMarker":{"http":{"method":"PUT","requestUri":"/channels/{channelArn}/readMarker","responseCode":200},"input":{"type":"structure","required":["ChannelArn","ChimeBearer"],"members":{"ChannelArn":{"location":"uri","locationName":"channelArn"},"ChimeBearer":{"location":"header","locationName":"x-amz-chime-bearer"}}},"output":{"type":"structure","members":{"ChannelArn":{}}}}},"shapes":{"S8":{"type":"structure","members":{"Arn":{},"Name":{"type":"string","sensitive":true}}},"Sk":{"type":"string","sensitive":true},"Sl":{"type":"string","sensitive":true},"Sm":{"type":"structure","members":{"Title":{"type":"string","sensitive":true},"Body":{"type":"string","sensitive":true},"Type":{}}},"Sq":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"structure","members":{"StringValues":{"type":"list","member":{"type":"string","sensitive":true}}}}},"Sx":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S11":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S13"},"Value":{"type":"string","sensitive":true}}}},"S13":{"type":"string","sensitive":true},"S19":{"type":"list","member":{"type":"structure","required":["Name","Configuration","ExecutionOrder","FallbackAction"],"members":{"Name":{"shape":"Sx"},"Configuration":{"type":"structure","required":["Lambda"],"members":{"Lambda":{"type":"structure","required":["ResourceArn","InvocationType"],"members":{"ResourceArn":{},"InvocationType":{}}}}},"ExecutionOrder":{"type":"integer"},"FallbackAction":{}}}},"S27":{"type":"structure","members":{"ChannelSummary":{"shape":"S28"},"AppInstanceUserMembershipSummary":{"type":"structure","members":{"Type":{},"ReadMarkerTimestamp":{"type":"timestamp"}}}}},"S28":{"type":"structure","members":{"Name":{"shape":"Sx"},"ChannelArn":{},"Mode":{},"Privacy":{},"Metadata":{"shape":"Sl"},"LastMessageTimestamp":{"type":"timestamp"}}},"S2c":{"type":"structure","members":{"ChannelSummary":{"shape":"S28"}}},"S2j":{"type":"structure","members":{"PushNotifications":{"type":"structure","required":["AllowNotifications"],"members":{"AllowNotifications":{},"FilterRule":{"type":"string","sensitive":true}}}}},"S2q":{"type":"string","sensitive":true},"S2t":{"type":"structure","members":{"Value":{},"Detail":{}}},"S34":{"type":"string","sensitive":true}}}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListChannelBans":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelFlows":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelMemberships":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelMembershipsForAppInstanceUser":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelMessages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelModerators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelsAssociatedWithChannelFlow":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListChannelsModeratedByAppInstanceUser":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['snowdevicemanagement'] = {};
	AWS.SnowDeviceManagement = Service.defineService('snowdevicemanagement', ['2021-08-04']);
	Object.defineProperty(apiLoader.services['snowdevicemanagement'], '2021-08-04', {
	  get: function get() {
	    var model = __webpack_require__(1050);
	    model.paginators = __webpack_require__(1051).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.SnowDeviceManagement;


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-08-04","endpointPrefix":"snow-device-management","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Snow Device Management","serviceId":"Snow Device Management","signatureVersion":"v4","signingName":"snow-device-management","uid":"snow-device-management-2021-08-04"},"operations":{"CancelTask":{"http":{"requestUri":"/task/{taskId}/cancel","responseCode":200},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateTask":{"http":{"requestUri":"/task","responseCode":200},"input":{"type":"structure","required":["command","targets"],"members":{"clientToken":{"idempotencyToken":true},"command":{"type":"structure","members":{"reboot":{"type":"structure","members":{}},"unlock":{"type":"structure","members":{}}},"union":true},"description":{},"tags":{"shape":"Sb"},"targets":{"shape":"Sc"}}},"output":{"type":"structure","members":{"taskArn":{},"taskId":{}}}},"DescribeDevice":{"http":{"requestUri":"/managed-device/{managedDeviceId}/describe","responseCode":200},"input":{"type":"structure","required":["managedDeviceId"],"members":{"managedDeviceId":{"location":"uri","locationName":"managedDeviceId"}}},"output":{"type":"structure","members":{"associatedWithJob":{},"deviceCapacities":{"type":"list","member":{"type":"structure","members":{"available":{"type":"long"},"name":{},"total":{"type":"long"},"unit":{},"used":{"type":"long"}}}},"deviceState":{},"deviceType":{},"lastReachedOutAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"managedDeviceArn":{},"managedDeviceId":{},"physicalNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"defaultGateway":{},"ipAddress":{},"ipAddressAssignment":{},"macAddress":{},"netmask":{},"physicalConnectorType":{},"physicalNetworkInterfaceId":{}}}},"software":{"type":"structure","members":{"installState":{},"installedVersion":{},"installingVersion":{}}},"tags":{"shape":"Sb"}}}},"DescribeDeviceEc2Instances":{"http":{"requestUri":"/managed-device/{managedDeviceId}/resources/ec2/describe","responseCode":200},"input":{"type":"structure","required":["instanceIds","managedDeviceId"],"members":{"instanceIds":{"type":"list","member":{}},"managedDeviceId":{"location":"uri","locationName":"managedDeviceId"}}},"output":{"type":"structure","members":{"instances":{"type":"list","member":{"type":"structure","members":{"instance":{"type":"structure","members":{"amiLaunchIndex":{"type":"integer"},"blockDeviceMappings":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"ebs":{"type":"structure","members":{"attachTime":{"type":"timestamp"},"deleteOnTermination":{"type":"boolean"},"status":{},"volumeId":{}}}}}},"cpuOptions":{"type":"structure","members":{"coreCount":{"type":"integer"},"threadsPerCore":{"type":"integer"}}},"createdAt":{"type":"timestamp"},"imageId":{},"instanceId":{},"instanceType":{},"privateIpAddress":{},"publicIpAddress":{},"rootDeviceName":{},"securityGroups":{"type":"list","member":{"type":"structure","members":{"groupId":{},"groupName":{}}}},"state":{"type":"structure","members":{"code":{"type":"integer"},"name":{}}},"updatedAt":{"type":"timestamp"}}},"lastUpdatedAt":{"type":"timestamp"}}}}}}},"DescribeExecution":{"http":{"requestUri":"/task/{taskId}/execution/{managedDeviceId}","responseCode":200},"input":{"type":"structure","required":["managedDeviceId","taskId"],"members":{"managedDeviceId":{"location":"uri","locationName":"managedDeviceId"},"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"executionId":{},"lastUpdatedAt":{"type":"timestamp"},"managedDeviceId":{},"startedAt":{"type":"timestamp"},"state":{},"taskId":{}}}},"DescribeTask":{"http":{"requestUri":"/task/{taskId}","responseCode":200},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"completedAt":{"type":"timestamp"},"createdAt":{"type":"timestamp"},"description":{},"lastUpdatedAt":{"type":"timestamp"},"state":{},"tags":{"shape":"Sb"},"targets":{"shape":"Sc"},"taskArn":{},"taskId":{}}}},"ListDeviceResources":{"http":{"method":"GET","requestUri":"/managed-device/{managedDeviceId}/resources","responseCode":200},"input":{"type":"structure","required":["managedDeviceId"],"members":{"managedDeviceId":{"location":"uri","locationName":"managedDeviceId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"type":{"location":"querystring","locationName":"type"}}},"output":{"type":"structure","members":{"nextToken":{},"resources":{"type":"list","member":{"type":"structure","required":["resourceType"],"members":{"arn":{},"id":{},"resourceType":{}}}}}}},"ListDevices":{"http":{"method":"GET","requestUri":"/managed-devices","responseCode":200},"input":{"type":"structure","members":{"jobId":{"location":"querystring","locationName":"jobId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"type":"structure","members":{"associatedWithJob":{},"managedDeviceArn":{},"managedDeviceId":{},"tags":{"shape":"Sb"}}}},"nextToken":{}}}},"ListExecutions":{"http":{"method":"GET","requestUri":"/executions","responseCode":200},"input":{"type":"structure","required":["taskId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"state":{"location":"querystring","locationName":"state"},"taskId":{"location":"querystring","locationName":"taskId"}}},"output":{"type":"structure","members":{"executions":{"type":"list","member":{"type":"structure","members":{"executionId":{},"managedDeviceId":{},"state":{},"taskId":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sb"}}}},"ListTasks":{"http":{"method":"GET","requestUri":"/tasks","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"state":{"location":"querystring","locationName":"state"}}},"output":{"type":"structure","members":{"nextToken":{},"tasks":{"type":"list","member":{"type":"structure","required":["taskId"],"members":{"state":{},"tags":{"shape":"Sb"},"taskArn":{},"taskId":{}}}}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sb"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"idempotent":true}},"shapes":{"Sb":{"type":"map","key":{},"value":{}},"Sc":{"type":"list","member":{}}}}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDeviceResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"resources"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"devices"},"ListExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"executions"},"ListTasks":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tasks"}}}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['memorydb'] = {};
	AWS.MemoryDB = Service.defineService('memorydb', ['2021-01-01']);
	Object.defineProperty(apiLoader.services['memorydb'], '2021-01-01', {
	  get: function get() {
	    var model = __webpack_require__(1053);
	    model.paginators = __webpack_require__(1054).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MemoryDB;


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-01-01","endpointPrefix":"memory-db","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MemoryDB","serviceFullName":"Amazon MemoryDB","serviceId":"MemoryDB","signatureVersion":"v4","signingName":"memorydb","targetPrefix":"AmazonMemoryDB","uid":"memorydb-2021-01-01"},"operations":{"BatchUpdateCluster":{"input":{"type":"structure","required":["ClusterNames"],"members":{"ClusterNames":{"shape":"S2"},"ServiceUpdate":{"type":"structure","members":{"ServiceUpdateNameToApply":{}}}}},"output":{"type":"structure","members":{"ProcessedClusters":{"shape":"S6"},"UnprocessedClusters":{"type":"list","member":{"type":"structure","members":{"ClusterName":{},"ErrorType":{},"ErrorMessage":{}}}}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{},"KmsKeyId":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"S11"}}}},"CreateACL":{"input":{"type":"structure","required":["ACLName"],"members":{"ACLName":{},"UserNames":{"shape":"S17"},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"ACL":{"shape":"S1a"}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterName","NodeType","ACLName"],"members":{"ClusterName":{},"NodeType":{},"ParameterGroupName":{},"Description":{},"NumShards":{"type":"integer"},"NumReplicasPerShard":{"type":"integer"},"SubnetGroupName":{},"SecurityGroupIds":{"shape":"S1f"},"MaintenanceWindow":{},"Port":{"type":"integer"},"SnsTopicArn":{},"TLSEnabled":{"type":"boolean"},"KmsKeyId":{},"SnapshotArns":{"type":"list","member":{}},"SnapshotName":{},"SnapshotRetentionLimit":{"type":"integer"},"Tags":{"shape":"Sy"},"SnapshotWindow":{},"ACLName":{},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"S7"}}}},"CreateParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Family"],"members":{"ParameterGroupName":{},"Family":{},"Description":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"S1k"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["ClusterName","SnapshotName"],"members":{"ClusterName":{},"SnapshotName":{},"KmsKeyId":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"S11"}}}},"CreateSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName","SubnetIds"],"members":{"SubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S1o"},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"S1q"}}}},"CreateUser":{"input":{"type":"structure","required":["UserName","AuthenticationMode","AccessString"],"members":{"UserName":{},"AuthenticationMode":{"shape":"S1v"},"AccessString":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"User":{"shape":"S20"}}}},"DeleteACL":{"input":{"type":"structure","required":["ACLName"],"members":{"ACLName":{}}},"output":{"type":"structure","members":{"ACL":{"shape":"S1a"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{},"FinalSnapshotName":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"S7"}}}},"DeleteParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"S1k"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"S11"}}}},"DeleteSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName"],"members":{"SubnetGroupName":{}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"S1q"}}}},"DeleteUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}},"output":{"type":"structure","members":{"User":{"shape":"S20"}}}},"DescribeACLs":{"input":{"type":"structure","members":{"ACLName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ACLs":{"type":"list","member":{"shape":"S1a"}},"NextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterName":{},"MaxResults":{"type":"integer"},"NextToken":{},"ShowShardDetails":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{},"Clusters":{"shape":"S6"}}}},"DescribeEngineVersions":{"input":{"type":"structure","members":{"EngineVersion":{},"ParameterGroupFamily":{},"MaxResults":{"type":"integer"},"NextToken":{},"DefaultOnly":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{},"EngineVersions":{"type":"list","member":{"type":"structure","members":{"EngineVersion":{},"EnginePatchVersion":{},"ParameterGroupFamily":{}}}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceName":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Events":{"type":"list","member":{"type":"structure","members":{"SourceName":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"ParameterGroups":{"type":"list","member":{"shape":"S1k"}}}}},"DescribeParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{},"Description":{},"DataType":{},"AllowedValues":{},"MinimumEngineVersion":{}}}}}}},"DescribeServiceUpdates":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ClusterNames":{"shape":"S2"},"Status":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"ServiceUpdates":{"type":"list","member":{"type":"structure","members":{"ClusterName":{},"ServiceUpdateName":{},"ReleaseDate":{"type":"timestamp"},"Description":{},"Status":{},"Type":{},"NodesUpdated":{},"AutoUpdateStartDate":{"type":"timestamp"}}}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ClusterName":{},"SnapshotName":{},"Source":{},"NextToken":{},"MaxResults":{"type":"integer"},"ShowDetail":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{},"Snapshots":{"type":"list","member":{"shape":"S11"}}}}},"DescribeSubnetGroups":{"input":{"type":"structure","members":{"SubnetGroupName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"SubnetGroups":{"type":"list","member":{"shape":"S1q"}}}}},"DescribeUsers":{"input":{"type":"structure","members":{"UserName":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S20"}},"NextToken":{}}}},"FailoverShard":{"input":{"type":"structure","required":["ClusterName","ShardName"],"members":{"ClusterName":{},"ShardName":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"S7"}}}},"ListAllowedNodeTypeUpdates":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{}}},"output":{"type":"structure","members":{"ScaleUpNodeTypes":{"shape":"S3q"},"ScaleDownNodeTypes":{"shape":"S3q"}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"Sy"}}}},"ResetParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"AllParameters":{"type":"boolean"},"ParameterNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"S1k"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"TagList":{"shape":"Sy"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"TagList":{"shape":"Sy"}}}},"UpdateACL":{"input":{"type":"structure","required":["ACLName"],"members":{"ACLName":{},"UserNamesToAdd":{"shape":"S17"},"UserNamesToRemove":{"shape":"S17"}}},"output":{"type":"structure","members":{"ACL":{"shape":"S1a"}}}},"UpdateCluster":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{},"Description":{},"SecurityGroupIds":{"shape":"S1f"},"MaintenanceWindow":{},"SnsTopicArn":{},"SnsTopicStatus":{},"ParameterGroupName":{},"SnapshotWindow":{},"SnapshotRetentionLimit":{"type":"integer"},"NodeType":{},"EngineVersion":{},"ReplicaConfiguration":{"type":"structure","members":{"ReplicaCount":{"type":"integer"}}},"ShardConfiguration":{"type":"structure","members":{"ShardCount":{"type":"integer"}}},"ACLName":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"S7"}}}},"UpdateParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterNameValues"],"members":{"ParameterGroupName":{},"ParameterNameValues":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"S1k"}}}},"UpdateSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName"],"members":{"SubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S1o"}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"S1q"}}}},"UpdateUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"AuthenticationMode":{"shape":"S1v"},"AccessString":{}}},"output":{"type":"structure","members":{"User":{"shape":"S20"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{"shape":"S7"}},"S7":{"type":"structure","members":{"Name":{},"Description":{},"Status":{},"PendingUpdates":{"type":"structure","members":{"Resharding":{"type":"structure","members":{"SlotMigration":{"type":"structure","members":{"ProgressPercentage":{"type":"double"}}}}},"ACLs":{"type":"structure","members":{"ACLToApply":{}}},"ServiceUpdates":{"type":"list","member":{"type":"structure","members":{"ServiceUpdateName":{},"Status":{}}}}}},"NumberOfShards":{"type":"integer"},"Shards":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"Slots":{},"Nodes":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"AvailabilityZone":{},"CreateTime":{"type":"timestamp"},"Endpoint":{"shape":"Sn"}}}},"NumberOfNodes":{"type":"integer"}}}},"AvailabilityMode":{},"ClusterEndpoint":{"shape":"Sn"},"NodeType":{},"EngineVersion":{},"EnginePatchVersion":{},"ParameterGroupName":{},"ParameterGroupStatus":{},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"SubnetGroupName":{},"TLSEnabled":{"type":"boolean"},"KmsKeyId":{},"ARN":{},"SnsTopicArn":{},"SnsTopicStatus":{},"SnapshotRetentionLimit":{"type":"integer"},"MaintenanceWindow":{},"SnapshotWindow":{},"ACLName":{},"AutoMinorVersionUpgrade":{"type":"boolean"}}},"Sn":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"Sy":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S11":{"type":"structure","members":{"Name":{},"Status":{},"Source":{},"KmsKeyId":{},"ARN":{},"ClusterConfiguration":{"type":"structure","members":{"Name":{},"Description":{},"NodeType":{},"EngineVersion":{},"MaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"ParameterGroupName":{},"SubnetGroupName":{},"VpcId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumShards":{"type":"integer"},"Shards":{"type":"list","member":{"type":"structure","members":{"Name":{},"Configuration":{"type":"structure","members":{"Slots":{},"ReplicaCount":{"type":"integer"}}},"Size":{},"SnapshotCreationTime":{"type":"timestamp"}}}}}}}},"S17":{"type":"list","member":{}},"S1a":{"type":"structure","members":{"Name":{},"Status":{},"UserNames":{"shape":"S1b"},"MinimumEngineVersion":{},"PendingChanges":{"type":"structure","members":{"UserNamesToRemove":{"shape":"S1b"},"UserNamesToAdd":{"shape":"S1b"}}},"Clusters":{"type":"list","member":{}},"ARN":{}}},"S1b":{"type":"list","member":{}},"S1f":{"type":"list","member":{}},"S1k":{"type":"structure","members":{"Name":{},"Family":{},"Description":{},"ARN":{}}},"S1o":{"type":"list","member":{}},"S1q":{"type":"structure","members":{"Name":{},"Description":{},"VpcId":{},"Subnets":{"type":"list","member":{"type":"structure","members":{"Identifier":{},"AvailabilityZone":{"type":"structure","members":{"Name":{}}}}}},"ARN":{}}},"S1v":{"type":"structure","members":{"Type":{},"Passwords":{"type":"list","member":{}}}},"S20":{"type":"structure","members":{"Name":{},"Status":{},"AccessString":{},"ACLNames":{"type":"list","member":{}},"MinimumEngineVersion":{},"Authentication":{"type":"structure","members":{"Type":{},"PasswordCount":{"type":"integer"}}},"ARN":{}}},"S3q":{"type":"list","member":{}}}}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['opensearch'] = {};
	AWS.OpenSearch = Service.defineService('opensearch', ['2021-01-01']);
	Object.defineProperty(apiLoader.services['opensearch'], '2021-01-01', {
	  get: function get() {
	    var model = __webpack_require__(1056);
	    model.paginators = __webpack_require__(1057).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.OpenSearch;


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-01-01","endpointPrefix":"es","protocol":"rest-json","serviceFullName":"Amazon OpenSearch Service","serviceId":"OpenSearch","signatureVersion":"v4","uid":"opensearch-2021-01-01"},"operations":{"AcceptInboundConnection":{"http":{"method":"PUT","requestUri":"/2021-01-01/opensearch/cc/inboundConnection/{ConnectionId}/accept"},"input":{"type":"structure","required":["ConnectionId"],"members":{"ConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S4"}}}},"AddTags":{"http":{"requestUri":"/2021-01-01/tags"},"input":{"type":"structure","required":["ARN","TagList"],"members":{"ARN":{},"TagList":{"shape":"Sf"}}}},"AssociatePackage":{"http":{"requestUri":"/2021-01-01/packages/associate/{PackageID}/{DomainName}"},"input":{"type":"structure","required":["PackageID","DomainName"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainPackageDetails":{"shape":"Sm"}}}},"CancelServiceSoftwareUpdate":{"http":{"requestUri":"/2021-01-01/opensearch/serviceSoftwareUpdate/cancel"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"ServiceSoftwareOptions":{"shape":"Sy"}}}},"CreateDomain":{"http":{"requestUri":"/2021-01-01/opensearch/domain"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"EngineVersion":{},"ClusterConfig":{"shape":"S15"},"EBSOptions":{"shape":"S1b"},"AccessPolicies":{},"SnapshotOptions":{"shape":"S1e"},"VPCOptions":{"shape":"S1f"},"CognitoOptions":{"shape":"S1h"},"EncryptionAtRestOptions":{"shape":"S1l"},"NodeToNodeEncryptionOptions":{"shape":"S1n"},"AdvancedOptions":{"shape":"S1o"},"LogPublishingOptions":{"shape":"S1p"},"DomainEndpointOptions":{"shape":"S1t"},"AdvancedSecurityOptions":{"shape":"S1w"},"TagList":{"shape":"Sf"},"AutoTuneOptions":{"type":"structure","members":{"DesiredState":{},"MaintenanceSchedules":{"shape":"S27"}}}}},"output":{"type":"structure","members":{"DomainStatus":{"shape":"S2e"}}}},"CreateOutboundConnection":{"http":{"requestUri":"/2021-01-01/opensearch/cc/outboundConnection"},"input":{"type":"structure","required":["LocalDomainInfo","RemoteDomainInfo","ConnectionAlias"],"members":{"LocalDomainInfo":{"shape":"S5"},"RemoteDomainInfo":{"shape":"S5"},"ConnectionAlias":{}}},"output":{"type":"structure","members":{"LocalDomainInfo":{"shape":"S5"},"RemoteDomainInfo":{"shape":"S5"},"ConnectionAlias":{},"ConnectionStatus":{"shape":"S2u"},"ConnectionId":{}}}},"CreatePackage":{"http":{"requestUri":"/2021-01-01/packages"},"input":{"type":"structure","required":["PackageName","PackageType","PackageSource"],"members":{"PackageName":{},"PackageType":{},"PackageDescription":{},"PackageSource":{"shape":"S2y"}}},"output":{"type":"structure","members":{"PackageDetails":{"shape":"S32"}}}},"DeleteDomain":{"http":{"method":"DELETE","requestUri":"/2021-01-01/opensearch/domain/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainStatus":{"shape":"S2e"}}}},"DeleteInboundConnection":{"http":{"method":"DELETE","requestUri":"/2021-01-01/opensearch/cc/inboundConnection/{ConnectionId}"},"input":{"type":"structure","required":["ConnectionId"],"members":{"ConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S4"}}}},"DeleteOutboundConnection":{"http":{"method":"DELETE","requestUri":"/2021-01-01/opensearch/cc/outboundConnection/{ConnectionId}"},"input":{"type":"structure","required":["ConnectionId"],"members":{"ConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S3b"}}}},"DeletePackage":{"http":{"method":"DELETE","requestUri":"/2021-01-01/packages/{PackageID}"},"input":{"type":"structure","required":["PackageID"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"}}},"output":{"type":"structure","members":{"PackageDetails":{"shape":"S32"}}}},"DescribeDomain":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/domain/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainStatus"],"members":{"DomainStatus":{"shape":"S2e"}}}},"DescribeDomainAutoTunes":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/domain/{DomainName}/autoTunes"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutoTunes":{"type":"list","member":{"type":"structure","members":{"AutoTuneType":{},"AutoTuneDetails":{"type":"structure","members":{"ScheduledAutoTuneDetails":{"type":"structure","members":{"Date":{"type":"timestamp"},"ActionType":{},"Action":{},"Severity":{}}}}}}}},"NextToken":{}}}},"DescribeDomainChangeProgress":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/domain/{DomainName}/progress"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ChangeId":{"location":"querystring","locationName":"changeid"}}},"output":{"type":"structure","members":{"ChangeProgressStatus":{"type":"structure","members":{"ChangeId":{},"StartTime":{"type":"timestamp"},"Status":{},"PendingProperties":{"shape":"S1g"},"CompletedProperties":{"shape":"S1g"},"TotalNumberOfStages":{"type":"integer"},"ChangeProgressStages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"Description":{},"LastUpdated":{"type":"timestamp"}}}}}}}}},"DescribeDomainConfig":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/domain/{DomainName}/config"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainConfig"],"members":{"DomainConfig":{"shape":"S46"}}}},"DescribeDomains":{"http":{"requestUri":"/2021-01-01/opensearch/domain-info"},"input":{"type":"structure","required":["DomainNames"],"members":{"DomainNames":{"type":"list","member":{}}}},"output":{"type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S2e"}}}}},"DescribeInboundConnections":{"http":{"requestUri":"/2021-01-01/opensearch/cc/inboundConnection/search"},"input":{"type":"structure","members":{"Filters":{"shape":"S4w"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"DescribeInstanceTypeLimits":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/instanceTypeLimits/{EngineVersion}/{InstanceType}"},"input":{"type":"structure","required":["InstanceType","EngineVersion"],"members":{"DomainName":{"location":"querystring","locationName":"domainName"},"InstanceType":{"location":"uri","locationName":"InstanceType"},"EngineVersion":{"location":"uri","locationName":"EngineVersion"}}},"output":{"type":"structure","members":{"LimitsByRole":{"type":"map","key":{},"value":{"type":"structure","members":{"StorageTypes":{"type":"list","member":{"type":"structure","members":{"StorageTypeName":{},"StorageSubTypeName":{},"StorageTypeLimits":{"type":"list","member":{"type":"structure","members":{"LimitName":{},"LimitValues":{"shape":"S5e"}}}}}}},"InstanceLimits":{"type":"structure","members":{"InstanceCountLimits":{"type":"structure","members":{"MinimumInstanceCount":{"type":"integer"},"MaximumInstanceCount":{"type":"integer"}}}}},"AdditionalLimits":{"type":"list","member":{"type":"structure","members":{"LimitName":{},"LimitValues":{"shape":"S5e"}}}}}}}}}},"DescribeOutboundConnections":{"http":{"requestUri":"/2021-01-01/opensearch/cc/outboundConnection/search"},"input":{"type":"structure","members":{"Filters":{"shape":"S4w"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"shape":"S3b"}},"NextToken":{}}}},"DescribePackages":{"http":{"requestUri":"/2021-01-01/packages/describe"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PackageDetailsList":{"type":"list","member":{"shape":"S32"}},"NextToken":{}}}},"DescribeReservedInstanceOfferings":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/reservedInstanceOfferings"},"input":{"type":"structure","members":{"ReservedInstanceOfferingId":{"location":"querystring","locationName":"offeringId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ReservedInstanceOfferings":{"type":"list","member":{"type":"structure","members":{"ReservedInstanceOfferingId":{},"InstanceType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"PaymentOption":{},"RecurringCharges":{"shape":"S64"}}}}}}},"DescribeReservedInstances":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/reservedInstances"},"input":{"type":"structure","members":{"ReservedInstanceId":{"location":"querystring","locationName":"reservationId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ReservedInstances":{"type":"list","member":{"type":"structure","members":{"ReservationName":{},"ReservedInstanceId":{},"BillingSubscriptionId":{"type":"long"},"ReservedInstanceOfferingId":{},"InstanceType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"InstanceCount":{"type":"integer"},"State":{},"PaymentOption":{},"RecurringCharges":{"shape":"S64"}}}}}}},"DissociatePackage":{"http":{"requestUri":"/2021-01-01/packages/dissociate/{PackageID}/{DomainName}"},"input":{"type":"structure","required":["PackageID","DomainName"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainPackageDetails":{"shape":"Sm"}}}},"GetCompatibleVersions":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/compatibleVersions"},"input":{"type":"structure","members":{"DomainName":{"location":"querystring","locationName":"domainName"}}},"output":{"type":"structure","members":{"CompatibleVersions":{"type":"list","member":{"type":"structure","members":{"SourceVersion":{},"TargetVersions":{"shape":"S6i"}}}}}}},"GetPackageVersionHistory":{"http":{"method":"GET","requestUri":"/2021-01-01/packages/{PackageID}/history"},"input":{"type":"structure","required":["PackageID"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"PackageID":{},"PackageVersionHistoryList":{"type":"list","member":{"type":"structure","members":{"PackageVersion":{},"CommitMessage":{},"CreatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"GetUpgradeHistory":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/upgradeDomain/{DomainName}/history"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"UpgradeHistories":{"type":"list","member":{"type":"structure","members":{"UpgradeName":{},"StartTimestamp":{"type":"timestamp"},"UpgradeStatus":{},"StepsList":{"type":"list","member":{"type":"structure","members":{"UpgradeStep":{},"UpgradeStepStatus":{},"Issues":{"type":"list","member":{}},"ProgressPercent":{"type":"double"}}}}}}},"NextToken":{}}}},"GetUpgradeStatus":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/upgradeDomain/{DomainName}/status"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"UpgradeStep":{},"StepStatus":{},"UpgradeName":{}}}},"ListDomainNames":{"http":{"method":"GET","requestUri":"/2021-01-01/domain"},"input":{"type":"structure","members":{"EngineType":{"location":"querystring","locationName":"engineType"}}},"output":{"type":"structure","members":{"DomainNames":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"EngineType":{}}}}}}},"ListDomainsForPackage":{"http":{"method":"GET","requestUri":"/2021-01-01/packages/{PackageID}/domains"},"input":{"type":"structure","required":["PackageID"],"members":{"PackageID":{"location":"uri","locationName":"PackageID"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"DomainPackageDetailsList":{"shape":"S79"},"NextToken":{}}}},"ListInstanceTypeDetails":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/instanceTypeDetails/{EngineVersion}"},"input":{"type":"structure","required":["EngineVersion"],"members":{"EngineVersion":{"location":"uri","locationName":"EngineVersion"},"DomainName":{"location":"querystring","locationName":"domainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"InstanceTypeDetails":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"EncryptionEnabled":{"type":"boolean"},"CognitoEnabled":{"type":"boolean"},"AppLogsEnabled":{"type":"boolean"},"AdvancedSecurityEnabled":{"type":"boolean"},"WarmEnabled":{"type":"boolean"},"InstanceRole":{"type":"list","member":{}}}}},"NextToken":{}}}},"ListPackagesForDomain":{"http":{"method":"GET","requestUri":"/2021-01-01/domain/{DomainName}/packages"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"DomainPackageDetailsList":{"shape":"S79"},"NextToken":{}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2021-01-01/tags/"},"input":{"type":"structure","required":["ARN"],"members":{"ARN":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"TagList":{"shape":"Sf"}}}},"ListVersions":{"http":{"method":"GET","requestUri":"/2021-01-01/opensearch/versions"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Versions":{"shape":"S6i"},"NextToken":{}}}},"PurchaseReservedInstanceOffering":{"http":{"requestUri":"/2021-01-01/opensearch/purchaseReservedInstanceOffering"},"input":{"type":"structure","required":["ReservedInstanceOfferingId","ReservationName"],"members":{"ReservedInstanceOfferingId":{},"ReservationName":{},"InstanceCount":{"type":"integer"}}},"output":{"type":"structure","members":{"ReservedInstanceId":{},"ReservationName":{}}}},"RejectInboundConnection":{"http":{"method":"PUT","requestUri":"/2021-01-01/opensearch/cc/inboundConnection/{ConnectionId}/reject"},"input":{"type":"structure","required":["ConnectionId"],"members":{"ConnectionId":{"location":"uri","locationName":"ConnectionId"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S4"}}}},"RemoveTags":{"http":{"requestUri":"/2021-01-01/tags-removal"},"input":{"type":"structure","required":["ARN","TagKeys"],"members":{"ARN":{},"TagKeys":{"shape":"S1g"}}}},"StartServiceSoftwareUpdate":{"http":{"requestUri":"/2021-01-01/opensearch/serviceSoftwareUpdate/start"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"ServiceSoftwareOptions":{"shape":"Sy"}}}},"UpdateDomainConfig":{"http":{"requestUri":"/2021-01-01/opensearch/domain/{DomainName}/config"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ClusterConfig":{"shape":"S15"},"EBSOptions":{"shape":"S1b"},"SnapshotOptions":{"shape":"S1e"},"VPCOptions":{"shape":"S1f"},"CognitoOptions":{"shape":"S1h"},"AdvancedOptions":{"shape":"S1o"},"AccessPolicies":{},"LogPublishingOptions":{"shape":"S1p"},"EncryptionAtRestOptions":{"shape":"S1l"},"DomainEndpointOptions":{"shape":"S1t"},"NodeToNodeEncryptionOptions":{"shape":"S1n"},"AdvancedSecurityOptions":{"shape":"S1w"},"AutoTuneOptions":{"shape":"S4o"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","required":["DomainConfig"],"members":{"DomainConfig":{"shape":"S46"},"DryRunResults":{"type":"structure","members":{"DeploymentType":{},"Message":{}}}}}},"UpdatePackage":{"http":{"requestUri":"/2021-01-01/packages/update"},"input":{"type":"structure","required":["PackageID","PackageSource"],"members":{"PackageID":{},"PackageSource":{"shape":"S2y"},"PackageDescription":{},"CommitMessage":{}}},"output":{"type":"structure","members":{"PackageDetails":{"shape":"S32"}}}},"UpgradeDomain":{"http":{"requestUri":"/2021-01-01/opensearch/upgradeDomain"},"input":{"type":"structure","required":["DomainName","TargetVersion"],"members":{"DomainName":{},"TargetVersion":{},"PerformCheckOnly":{"type":"boolean"},"AdvancedOptions":{"shape":"S1o"}}},"output":{"type":"structure","members":{"UpgradeId":{},"DomainName":{},"TargetVersion":{},"PerformCheckOnly":{"type":"boolean"},"AdvancedOptions":{"shape":"S1o"},"ChangeProgressDetails":{"shape":"S2o"}}}}},"shapes":{"S4":{"type":"structure","members":{"LocalDomainInfo":{"shape":"S5"},"RemoteDomainInfo":{"shape":"S5"},"ConnectionId":{},"ConnectionStatus":{"type":"structure","members":{"StatusCode":{},"Message":{}}}}},"S5":{"type":"structure","members":{"AWSDomainInformation":{"type":"structure","required":["DomainName"],"members":{"OwnerId":{},"DomainName":{},"Region":{}}}}},"Sf":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sm":{"type":"structure","members":{"PackageID":{},"PackageName":{},"PackageType":{},"LastUpdated":{"type":"timestamp"},"DomainName":{},"DomainPackageStatus":{},"PackageVersion":{},"ReferencePath":{},"ErrorDetails":{"shape":"St"}}},"St":{"type":"structure","members":{"ErrorType":{},"ErrorMessage":{}}},"Sy":{"type":"structure","members":{"CurrentVersion":{},"NewVersion":{},"UpdateAvailable":{"type":"boolean"},"Cancellable":{"type":"boolean"},"UpdateStatus":{},"Description":{},"AutomatedUpdateDate":{"type":"timestamp"},"OptionalDeployment":{"type":"boolean"}}},"S15":{"type":"structure","members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"DedicatedMasterEnabled":{"type":"boolean"},"ZoneAwarenessEnabled":{"type":"boolean"},"ZoneAwarenessConfig":{"type":"structure","members":{"AvailabilityZoneCount":{"type":"integer"}}},"DedicatedMasterType":{},"DedicatedMasterCount":{"type":"integer"},"WarmEnabled":{"type":"boolean"},"WarmType":{},"WarmCount":{"type":"integer"},"ColdStorageOptions":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}}}},"S1b":{"type":"structure","members":{"EBSEnabled":{"type":"boolean"},"VolumeType":{},"VolumeSize":{"type":"integer"},"Iops":{"type":"integer"}}},"S1e":{"type":"structure","members":{"AutomatedSnapshotStartHour":{"type":"integer"}}},"S1f":{"type":"structure","members":{"SubnetIds":{"shape":"S1g"},"SecurityGroupIds":{"shape":"S1g"}}},"S1g":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"Enabled":{"type":"boolean"},"UserPoolId":{},"IdentityPoolId":{},"RoleArn":{}}},"S1l":{"type":"structure","members":{"Enabled":{"type":"boolean"},"KmsKeyId":{}}},"S1n":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S1o":{"type":"map","key":{},"value":{}},"S1p":{"type":"map","key":{},"value":{"type":"structure","members":{"CloudWatchLogsLogGroupArn":{},"Enabled":{"type":"boolean"}}}},"S1t":{"type":"structure","members":{"EnforceHTTPS":{"type":"boolean"},"TLSSecurityPolicy":{},"CustomEndpointEnabled":{"type":"boolean"},"CustomEndpoint":{},"CustomEndpointCertificateArn":{}}},"S1w":{"type":"structure","members":{"Enabled":{"type":"boolean"},"InternalUserDatabaseEnabled":{"type":"boolean"},"MasterUserOptions":{"type":"structure","members":{"MasterUserARN":{},"MasterUserName":{"shape":"S1y"},"MasterUserPassword":{"type":"string","sensitive":true}}},"SAMLOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Idp":{"shape":"S21"},"MasterUserName":{"shape":"S1y"},"MasterBackendRole":{},"SubjectKey":{},"RolesKey":{},"SessionTimeoutMinutes":{"type":"integer"}}},"AnonymousAuthEnabled":{"type":"boolean"}}},"S1y":{"type":"string","sensitive":true},"S21":{"type":"structure","required":["MetadataContent","EntityId"],"members":{"MetadataContent":{},"EntityId":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"StartAt":{"type":"timestamp"},"Duration":{"type":"structure","members":{"Value":{"type":"long"},"Unit":{}}},"CronExpressionForRecurrence":{}}}},"S2e":{"type":"structure","required":["DomainId","DomainName","ARN","ClusterConfig"],"members":{"DomainId":{},"DomainName":{},"ARN":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"Endpoint":{},"Endpoints":{"type":"map","key":{},"value":{}},"Processing":{"type":"boolean"},"UpgradeProcessing":{"type":"boolean"},"EngineVersion":{},"ClusterConfig":{"shape":"S15"},"EBSOptions":{"shape":"S1b"},"AccessPolicies":{},"SnapshotOptions":{"shape":"S1e"},"VPCOptions":{"shape":"S2i"},"CognitoOptions":{"shape":"S1h"},"EncryptionAtRestOptions":{"shape":"S1l"},"NodeToNodeEncryptionOptions":{"shape":"S1n"},"AdvancedOptions":{"shape":"S1o"},"LogPublishingOptions":{"shape":"S1p"},"ServiceSoftwareOptions":{"shape":"Sy"},"DomainEndpointOptions":{"shape":"S1t"},"AdvancedSecurityOptions":{"shape":"S2j"},"AutoTuneOptions":{"type":"structure","members":{"State":{},"ErrorMessage":{}}},"ChangeProgressDetails":{"shape":"S2o"}}},"S2i":{"type":"structure","members":{"VPCId":{},"SubnetIds":{"shape":"S1g"},"AvailabilityZones":{"shape":"S1g"},"SecurityGroupIds":{"shape":"S1g"}}},"S2j":{"type":"structure","members":{"Enabled":{"type":"boolean"},"InternalUserDatabaseEnabled":{"type":"boolean"},"SAMLOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Idp":{"shape":"S21"},"SubjectKey":{},"RolesKey":{},"SessionTimeoutMinutes":{"type":"integer"}}},"AnonymousAuthDisableDate":{"type":"timestamp"},"AnonymousAuthEnabled":{"type":"boolean"}}},"S2o":{"type":"structure","members":{"ChangeId":{},"Message":{}}},"S2u":{"type":"structure","members":{"StatusCode":{},"Message":{}}},"S2y":{"type":"structure","members":{"S3BucketName":{},"S3Key":{}}},"S32":{"type":"structure","members":{"PackageID":{},"PackageName":{},"PackageType":{},"PackageDescription":{},"PackageStatus":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"AvailablePackageVersion":{},"ErrorDetails":{"shape":"St"}}},"S3b":{"type":"structure","members":{"LocalDomainInfo":{"shape":"S5"},"RemoteDomainInfo":{"shape":"S5"},"ConnectionId":{},"ConnectionAlias":{},"ConnectionStatus":{"shape":"S2u"}}},"S46":{"type":"structure","members":{"EngineVersion":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"S48"}}},"ClusterConfig":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S15"},"Status":{"shape":"S48"}}},"EBSOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1b"},"Status":{"shape":"S48"}}},"AccessPolicies":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"S48"}}},"SnapshotOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1e"},"Status":{"shape":"S48"}}},"VPCOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2i"},"Status":{"shape":"S48"}}},"CognitoOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1h"},"Status":{"shape":"S48"}}},"EncryptionAtRestOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1l"},"Status":{"shape":"S48"}}},"NodeToNodeEncryptionOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1n"},"Status":{"shape":"S48"}}},"AdvancedOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1o"},"Status":{"shape":"S48"}}},"LogPublishingOptions":{"type":"structure","members":{"Options":{"shape":"S1p"},"Status":{"shape":"S48"}}},"DomainEndpointOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1t"},"Status":{"shape":"S48"}}},"AdvancedSecurityOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2j"},"Status":{"shape":"S48"}}},"AutoTuneOptions":{"type":"structure","members":{"Options":{"shape":"S4o"},"Status":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"ErrorMessage":{},"PendingDeletion":{"type":"boolean"}}}}},"ChangeProgressDetails":{"shape":"S2o"}}},"S48":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"S4o":{"type":"structure","members":{"DesiredState":{},"RollbackOnDisable":{},"MaintenanceSchedules":{"shape":"S27"}}},"S4w":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S5e":{"type":"list","member":{}},"S64":{"type":"list","member":{"type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}}}},"S6i":{"type":"list","member":{}},"S79":{"type":"list","member":{"shape":"Sm"}}}}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeDomainAutoTunes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeInboundConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeOutboundConnections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribePackages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeReservedInstanceOfferings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeReservedInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetPackageVersionHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetUpgradeHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDomainsForPackage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListInstanceTypeDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPackagesForDomain":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['kafkaconnect'] = {};
	AWS.KafkaConnect = Service.defineService('kafkaconnect', ['2021-09-14']);
	Object.defineProperty(apiLoader.services['kafkaconnect'], '2021-09-14', {
	  get: function get() {
	    var model = __webpack_require__(1059);
	    model.paginators = __webpack_require__(1060).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.KafkaConnect;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-09-14","endpointPrefix":"kafkaconnect","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Kafka Connect","serviceFullName":"Managed Streaming for Kafka Connect","serviceId":"KafkaConnect","signatureVersion":"v4","signingName":"kafkaconnect","uid":"kafkaconnect-2021-09-14"},"operations":{"CreateConnector":{"http":{"requestUri":"/v1/connectors","responseCode":200},"input":{"type":"structure","required":["capacity","connectorConfiguration","connectorName","kafkaCluster","kafkaClusterClientAuthentication","kafkaClusterEncryptionInTransit","kafkaConnectVersion","plugins","serviceExecutionRoleArn"],"members":{"capacity":{"type":"structure","members":{"autoScaling":{"type":"structure","required":["maxWorkerCount","mcuCount","minWorkerCount"],"members":{"maxWorkerCount":{"type":"integer"},"mcuCount":{"type":"integer"},"minWorkerCount":{"type":"integer"},"scaleInPolicy":{"type":"structure","required":["cpuUtilizationPercentage"],"members":{"cpuUtilizationPercentage":{"type":"integer"}}},"scaleOutPolicy":{"type":"structure","required":["cpuUtilizationPercentage"],"members":{"cpuUtilizationPercentage":{"type":"integer"}}}}},"provisionedCapacity":{"type":"structure","required":["mcuCount","workerCount"],"members":{"mcuCount":{"type":"integer"},"workerCount":{"type":"integer"}}}}},"connectorConfiguration":{"type":"map","key":{},"value":{},"sensitive":true},"connectorDescription":{},"connectorName":{},"kafkaCluster":{"type":"structure","required":["apacheKafkaCluster"],"members":{"apacheKafkaCluster":{"type":"structure","required":["bootstrapServers","vpc"],"members":{"bootstrapServers":{},"vpc":{"type":"structure","required":["subnets"],"members":{"securityGroups":{"shape":"Sh"},"subnets":{"shape":"Sh"}}}}}}},"kafkaClusterClientAuthentication":{"type":"structure","required":["authenticationType"],"members":{"authenticationType":{}}},"kafkaClusterEncryptionInTransit":{"type":"structure","required":["encryptionType"],"members":{"encryptionType":{}}},"kafkaConnectVersion":{},"logDelivery":{"type":"structure","required":["workerLogDelivery"],"members":{"workerLogDelivery":{"type":"structure","members":{"cloudWatchLogs":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"},"logGroup":{}}},"firehose":{"type":"structure","required":["enabled"],"members":{"deliveryStream":{},"enabled":{"type":"boolean"}}},"s3":{"type":"structure","required":["enabled"],"members":{"bucket":{},"enabled":{"type":"boolean"},"prefix":{}}}}}}},"plugins":{"type":"list","member":{"type":"structure","required":["customPlugin"],"members":{"customPlugin":{"type":"structure","required":["customPluginArn","revision"],"members":{"customPluginArn":{},"revision":{"type":"long"}}}}}},"serviceExecutionRoleArn":{},"workerConfiguration":{"type":"structure","required":["revision","workerConfigurationArn"],"members":{"revision":{"type":"long"},"workerConfigurationArn":{}}}}},"output":{"type":"structure","members":{"connectorArn":{},"connectorName":{},"connectorState":{}}}},"CreateCustomPlugin":{"http":{"requestUri":"/v1/custom-plugins","responseCode":200},"input":{"type":"structure","required":["contentType","location","name"],"members":{"contentType":{},"description":{},"location":{"type":"structure","required":["s3Location"],"members":{"s3Location":{"type":"structure","required":["bucketArn","fileKey"],"members":{"bucketArn":{},"fileKey":{},"objectVersion":{}}}}},"name":{}}},"output":{"type":"structure","members":{"customPluginArn":{},"customPluginState":{},"name":{},"revision":{"type":"long"}}}},"CreateWorkerConfiguration":{"http":{"requestUri":"/v1/worker-configurations","responseCode":200},"input":{"type":"structure","required":["name","propertiesFileContent"],"members":{"description":{},"name":{},"propertiesFileContent":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"creationTime":{"shape":"S19"},"latestRevision":{"shape":"S1a"},"name":{},"workerConfigurationArn":{}}}},"DeleteConnector":{"http":{"method":"DELETE","requestUri":"/v1/connectors/{connectorArn}","responseCode":200},"input":{"type":"structure","required":["connectorArn"],"members":{"connectorArn":{"location":"uri","locationName":"connectorArn"},"currentVersion":{"location":"querystring","locationName":"currentVersion"}}},"output":{"type":"structure","members":{"connectorArn":{},"connectorState":{}}},"idempotent":true},"DeleteCustomPlugin":{"http":{"method":"DELETE","requestUri":"/v1/custom-plugins/{customPluginArn}","responseCode":200},"input":{"type":"structure","required":["customPluginArn"],"members":{"customPluginArn":{"location":"uri","locationName":"customPluginArn"}}},"output":{"type":"structure","members":{"customPluginArn":{},"customPluginState":{}}},"idempotent":true},"DescribeConnector":{"http":{"method":"GET","requestUri":"/v1/connectors/{connectorArn}","responseCode":200},"input":{"type":"structure","required":["connectorArn"],"members":{"connectorArn":{"location":"uri","locationName":"connectorArn"}}},"output":{"type":"structure","members":{"capacity":{"shape":"S1h"},"connectorArn":{},"connectorConfiguration":{"type":"map","key":{},"value":{},"sensitive":true},"connectorDescription":{},"connectorName":{},"connectorState":{},"creationTime":{"shape":"S19"},"currentVersion":{},"kafkaCluster":{"shape":"S1o"},"kafkaClusterClientAuthentication":{"shape":"S1r"},"kafkaClusterEncryptionInTransit":{"shape":"S1s"},"kafkaConnectVersion":{},"logDelivery":{"shape":"S1t"},"plugins":{"shape":"S1y"},"serviceExecutionRoleArn":{},"stateDescription":{"shape":"S21"},"workerConfiguration":{"shape":"S22"}}}},"DescribeCustomPlugin":{"http":{"method":"GET","requestUri":"/v1/custom-plugins/{customPluginArn}","responseCode":200},"input":{"type":"structure","required":["customPluginArn"],"members":{"customPluginArn":{"location":"uri","locationName":"customPluginArn"}}},"output":{"type":"structure","members":{"creationTime":{"shape":"S19"},"customPluginArn":{},"customPluginState":{},"description":{},"latestRevision":{"shape":"S25"},"name":{},"stateDescription":{"shape":"S21"}}}},"DescribeWorkerConfiguration":{"http":{"method":"GET","requestUri":"/v1/worker-configurations/{workerConfigurationArn}","responseCode":200},"input":{"type":"structure","required":["workerConfigurationArn"],"members":{"workerConfigurationArn":{"location":"uri","locationName":"workerConfigurationArn"}}},"output":{"type":"structure","members":{"creationTime":{"shape":"S19"},"description":{},"latestRevision":{"type":"structure","members":{"creationTime":{"shape":"S19"},"description":{},"propertiesFileContent":{"type":"string","sensitive":true},"revision":{"type":"long"}}},"name":{},"workerConfigurationArn":{}}}},"ListConnectors":{"http":{"method":"GET","requestUri":"/v1/connectors","responseCode":200},"input":{"type":"structure","members":{"connectorNamePrefix":{"location":"querystring","locationName":"connectorNamePrefix"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"connectors":{"type":"list","member":{"type":"structure","members":{"capacity":{"shape":"S1h"},"connectorArn":{},"connectorDescription":{},"connectorName":{},"connectorState":{},"creationTime":{"shape":"S19"},"currentVersion":{},"kafkaCluster":{"shape":"S1o"},"kafkaClusterClientAuthentication":{"shape":"S1r"},"kafkaClusterEncryptionInTransit":{"shape":"S1s"},"kafkaConnectVersion":{},"logDelivery":{"shape":"S1t"},"plugins":{"shape":"S1y"},"serviceExecutionRoleArn":{},"workerConfiguration":{"shape":"S22"}}}},"nextToken":{}}}},"ListCustomPlugins":{"http":{"method":"GET","requestUri":"/v1/custom-plugins","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"customPlugins":{"type":"list","member":{"type":"structure","members":{"creationTime":{"shape":"S19"},"customPluginArn":{},"customPluginState":{},"description":{},"latestRevision":{"shape":"S25"},"name":{}}}},"nextToken":{}}}},"ListWorkerConfigurations":{"http":{"method":"GET","requestUri":"/v1/worker-configurations","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"workerConfigurations":{"type":"list","member":{"type":"structure","members":{"creationTime":{"shape":"S19"},"description":{},"latestRevision":{"shape":"S1a"},"name":{},"workerConfigurationArn":{}}}}}}},"UpdateConnector":{"http":{"method":"PUT","requestUri":"/v1/connectors/{connectorArn}","responseCode":200},"input":{"type":"structure","required":["capacity","connectorArn","currentVersion"],"members":{"capacity":{"type":"structure","members":{"autoScaling":{"type":"structure","required":["maxWorkerCount","mcuCount","minWorkerCount","scaleInPolicy","scaleOutPolicy"],"members":{"maxWorkerCount":{"type":"integer"},"mcuCount":{"type":"integer"},"minWorkerCount":{"type":"integer"},"scaleInPolicy":{"type":"structure","required":["cpuUtilizationPercentage"],"members":{"cpuUtilizationPercentage":{"type":"integer"}}},"scaleOutPolicy":{"type":"structure","required":["cpuUtilizationPercentage"],"members":{"cpuUtilizationPercentage":{"type":"integer"}}}}},"provisionedCapacity":{"type":"structure","required":["mcuCount","workerCount"],"members":{"mcuCount":{"type":"integer"},"workerCount":{"type":"integer"}}}}},"connectorArn":{"location":"uri","locationName":"connectorArn"},"currentVersion":{"location":"querystring","locationName":"currentVersion"}}},"output":{"type":"structure","members":{"connectorArn":{},"connectorState":{}}},"idempotent":true}},"shapes":{"Sh":{"type":"list","member":{}},"S19":{"type":"timestamp","timestampFormat":"iso8601"},"S1a":{"type":"structure","members":{"creationTime":{"shape":"S19"},"description":{},"revision":{"type":"long"}}},"S1h":{"type":"structure","members":{"autoScaling":{"type":"structure","members":{"maxWorkerCount":{"type":"integer"},"mcuCount":{"type":"integer"},"minWorkerCount":{"type":"integer"},"scaleInPolicy":{"type":"structure","members":{"cpuUtilizationPercentage":{"type":"integer"}}},"scaleOutPolicy":{"type":"structure","members":{"cpuUtilizationPercentage":{"type":"integer"}}}}},"provisionedCapacity":{"type":"structure","members":{"mcuCount":{"type":"integer"},"workerCount":{"type":"integer"}}}}},"S1o":{"type":"structure","members":{"apacheKafkaCluster":{"type":"structure","members":{"bootstrapServers":{},"vpc":{"type":"structure","members":{"securityGroups":{"shape":"Sh"},"subnets":{"shape":"Sh"}}}}}}},"S1r":{"type":"structure","members":{"authenticationType":{}}},"S1s":{"type":"structure","members":{"encryptionType":{}}},"S1t":{"type":"structure","members":{"workerLogDelivery":{"type":"structure","members":{"cloudWatchLogs":{"type":"structure","members":{"enabled":{"type":"boolean"},"logGroup":{}}},"firehose":{"type":"structure","members":{"deliveryStream":{},"enabled":{"type":"boolean"}}},"s3":{"type":"structure","members":{"bucket":{},"enabled":{"type":"boolean"},"prefix":{}}}}}}},"S1y":{"type":"list","member":{"type":"structure","members":{"customPlugin":{"type":"structure","members":{"customPluginArn":{},"revision":{"type":"long"}}}}}},"S21":{"type":"structure","members":{"code":{},"message":{}}},"S22":{"type":"structure","members":{"revision":{"type":"long"},"workerConfigurationArn":{}}},"S25":{"type":"structure","members":{"contentType":{},"creationTime":{"shape":"S19"},"description":{},"fileDescription":{"type":"structure","members":{"fileMd5":{},"fileSize":{"type":"long"}}},"location":{"type":"structure","members":{"s3Location":{"type":"structure","members":{"bucketArn":{},"fileKey":{},"objectVersion":{}}}}},"revision":{"type":"long"}}}}}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListConnectors":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"connectors"},"ListCustomPlugins":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"customPlugins"},"ListWorkerConfigurations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"workerConfigurations"}}}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['voiceid'] = {};
	AWS.VoiceID = Service.defineService('voiceid', ['2021-09-27']);
	Object.defineProperty(apiLoader.services['voiceid'], '2021-09-27', {
	  get: function get() {
	    var model = __webpack_require__(1062);
	    model.paginators = __webpack_require__(1063).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.VoiceID;


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-09-27","endpointPrefix":"voiceid","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon Voice ID","serviceId":"Voice ID","signatureVersion":"v4","signingName":"voiceid","targetPrefix":"VoiceID","uid":"voice-id-2021-09-27"},"operations":{"CreateDomain":{"input":{"type":"structure","required":["Name","ServerSideEncryptionConfiguration"],"members":{"ClientToken":{"idempotencyToken":true},"Description":{"shape":"S3"},"Name":{"shape":"S4"},"ServerSideEncryptionConfiguration":{"shape":"S5"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Domain":{"shape":"Sc"}}},"idempotent":true},"DeleteDomain":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{}}}},"DeleteFraudster":{"input":{"type":"structure","required":["DomainId","FraudsterId"],"members":{"DomainId":{},"FraudsterId":{"shape":"Sj"}}}},"DeleteSpeaker":{"input":{"type":"structure","required":["DomainId","SpeakerId"],"members":{"DomainId":{},"SpeakerId":{"shape":"Sl"}}}},"DescribeDomain":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{}}},"output":{"type":"structure","members":{"Domain":{"shape":"Sc"}}}},"DescribeFraudster":{"input":{"type":"structure","required":["DomainId","FraudsterId"],"members":{"DomainId":{},"FraudsterId":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Fraudster":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"DomainId":{},"GeneratedFraudsterId":{}}}}}},"DescribeFraudsterRegistrationJob":{"input":{"type":"structure","required":["DomainId","JobId"],"members":{"DomainId":{},"JobId":{}}},"output":{"type":"structure","members":{"Job":{"shape":"Sv"}}}},"DescribeSpeaker":{"input":{"type":"structure","required":["DomainId","SpeakerId"],"members":{"DomainId":{},"SpeakerId":{"shape":"Sl"}}},"output":{"type":"structure","members":{"Speaker":{"shape":"S1b"}}}},"DescribeSpeakerEnrollmentJob":{"input":{"type":"structure","required":["DomainId","JobId"],"members":{"DomainId":{},"JobId":{}}},"output":{"type":"structure","members":{"Job":{"shape":"S1h"}}}},"EvaluateSession":{"input":{"type":"structure","required":["DomainId","SessionNameOrId"],"members":{"DomainId":{},"SessionNameOrId":{}}},"output":{"type":"structure","members":{"AuthenticationResult":{"type":"structure","members":{"AudioAggregationEndedAt":{"type":"timestamp"},"AudioAggregationStartedAt":{"type":"timestamp"},"AuthenticationResultId":{},"Configuration":{"type":"structure","required":["AcceptanceThreshold"],"members":{"AcceptanceThreshold":{"type":"integer"}}},"CustomerSpeakerId":{"shape":"S1c"},"Decision":{},"GeneratedSpeakerId":{},"Score":{"type":"integer"}}},"DomainId":{},"FraudDetectionResult":{"type":"structure","members":{"AudioAggregationEndedAt":{"type":"timestamp"},"AudioAggregationStartedAt":{"type":"timestamp"},"Configuration":{"type":"structure","required":["RiskThreshold"],"members":{"RiskThreshold":{"type":"integer"}}},"Decision":{},"FraudDetectionResultId":{},"Reasons":{"type":"list","member":{}},"RiskDetails":{"type":"structure","required":["KnownFraudsterRisk"],"members":{"KnownFraudsterRisk":{"type":"structure","required":["RiskScore"],"members":{"GeneratedFraudsterId":{},"RiskScore":{"type":"integer"}}}}}}},"SessionId":{},"SessionName":{},"StreamingStatus":{}}}},"ListDomains":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DomainSummaries":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedAt":{"type":"timestamp"},"Description":{"shape":"S3"},"DomainId":{},"DomainStatus":{},"Name":{"shape":"S4"},"ServerSideEncryptionConfiguration":{"shape":"S5"},"UpdatedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"ListFraudsterRegistrationJobs":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{},"JobStatus":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"DomainId":{},"EndedAt":{"type":"timestamp"},"FailureDetails":{"shape":"Sx"},"JobId":{},"JobName":{"shape":"S12"},"JobProgress":{"shape":"S13"},"JobStatus":{}}}},"NextToken":{}}}},"ListSpeakerEnrollmentJobs":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{},"JobStatus":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"DomainId":{},"EndedAt":{"type":"timestamp"},"FailureDetails":{"shape":"Sx"},"JobId":{},"JobName":{"shape":"S12"},"JobProgress":{"shape":"S13"},"JobStatus":{}}}},"NextToken":{}}}},"ListSpeakers":{"input":{"type":"structure","required":["DomainId"],"members":{"DomainId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"SpeakerSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"CustomerSpeakerId":{"shape":"S1c"},"DomainId":{},"GeneratedSpeakerId":{},"Status":{},"UpdatedAt":{"type":"timestamp"}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"}}}},"OptOutSpeaker":{"input":{"type":"structure","required":["DomainId","SpeakerId"],"members":{"DomainId":{},"SpeakerId":{"shape":"Sl"}}},"output":{"type":"structure","members":{"Speaker":{"shape":"S1b"}}}},"StartFraudsterRegistrationJob":{"input":{"type":"structure","required":["DataAccessRoleArn","DomainId","InputDataConfig","OutputDataConfig"],"members":{"ClientToken":{"idempotencyToken":true},"DataAccessRoleArn":{},"DomainId":{},"InputDataConfig":{"shape":"S10"},"JobName":{"shape":"S12"},"OutputDataConfig":{"shape":"S16"},"RegistrationConfig":{"shape":"S17"}}},"output":{"type":"structure","members":{"Job":{"shape":"Sv"}}},"idempotent":true},"StartSpeakerEnrollmentJob":{"input":{"type":"structure","required":["DataAccessRoleArn","DomainId","InputDataConfig","OutputDataConfig"],"members":{"ClientToken":{"idempotencyToken":true},"DataAccessRoleArn":{},"DomainId":{},"EnrollmentConfig":{"shape":"S1i"},"InputDataConfig":{"shape":"S10"},"JobName":{"shape":"S12"},"OutputDataConfig":{"shape":"S16"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1h"}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{"shape":"S9"}}}},"output":{"type":"structure","members":{}}},"UpdateDomain":{"input":{"type":"structure","required":["DomainId","Name","ServerSideEncryptionConfiguration"],"members":{"Description":{"shape":"S3"},"DomainId":{},"Name":{"shape":"S4"},"ServerSideEncryptionConfiguration":{"shape":"S5"}}},"output":{"type":"structure","members":{"Domain":{"shape":"Sc"}}}}},"shapes":{"S3":{"type":"string","sensitive":true},"S4":{"type":"string","sensitive":true},"S5":{"type":"structure","required":["KmsKeyId"],"members":{"KmsKeyId":{}}},"S7":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S9"},"Value":{"type":"string","sensitive":true}}}},"S9":{"type":"string","sensitive":true},"Sc":{"type":"structure","members":{"Arn":{},"CreatedAt":{"type":"timestamp"},"Description":{"shape":"S3"},"DomainId":{},"DomainStatus":{},"Name":{"shape":"S4"},"ServerSideEncryptionConfiguration":{"shape":"S5"},"UpdatedAt":{"type":"timestamp"}}},"Sj":{"type":"string","sensitive":true},"Sl":{"type":"string","sensitive":true},"Sv":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"DataAccessRoleArn":{},"DomainId":{},"EndedAt":{"type":"timestamp"},"FailureDetails":{"shape":"Sx"},"InputDataConfig":{"shape":"S10"},"JobId":{},"JobName":{"shape":"S12"},"JobProgress":{"shape":"S13"},"JobStatus":{},"OutputDataConfig":{"shape":"S16"},"RegistrationConfig":{"shape":"S17"}}},"Sx":{"type":"structure","members":{"Message":{},"StatusCode":{"type":"integer"}}},"S10":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"S12":{"type":"string","sensitive":true},"S13":{"type":"structure","members":{"PercentComplete":{"type":"integer"}}},"S16":{"type":"structure","required":["S3Uri"],"members":{"KmsKeyId":{},"S3Uri":{}}},"S17":{"type":"structure","members":{"DuplicateRegistrationAction":{},"FraudsterSimilarityThreshold":{"type":"integer"}}},"S1b":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"CustomerSpeakerId":{"shape":"S1c"},"DomainId":{},"GeneratedSpeakerId":{},"Status":{},"UpdatedAt":{"type":"timestamp"}}},"S1c":{"type":"string","sensitive":true},"S1h":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"DataAccessRoleArn":{},"DomainId":{},"EndedAt":{"type":"timestamp"},"EnrollmentConfig":{"shape":"S1i"},"FailureDetails":{"shape":"Sx"},"InputDataConfig":{"shape":"S10"},"JobId":{},"JobName":{"shape":"S12"},"JobProgress":{"shape":"S13"},"JobStatus":{},"OutputDataConfig":{"shape":"S16"}}},"S1i":{"type":"structure","members":{"ExistingEnrollmentAction":{},"FraudDetectionConfig":{"type":"structure","members":{"FraudDetectionAction":{},"RiskThreshold":{"type":"integer"}}}}}}}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFraudsterRegistrationJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSpeakerEnrollmentJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSpeakers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['wisdom'] = {};
	AWS.Wisdom = Service.defineService('wisdom', ['2020-10-19']);
	Object.defineProperty(apiLoader.services['wisdom'], '2020-10-19', {
	  get: function get() {
	    var model = __webpack_require__(1065);
	    model.paginators = __webpack_require__(1066).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Wisdom;


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-10-19","endpointPrefix":"wisdom","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Connect Wisdom Service","serviceId":"Wisdom","signatureVersion":"v4","signingName":"wisdom","uid":"wisdom-2020-10-19"},"operations":{"CreateAssistant":{"http":{"requestUri":"/assistants","responseCode":200},"input":{"type":"structure","required":["name","type"],"members":{"clientToken":{"idempotencyToken":true},"description":{},"name":{},"serverSideEncryptionConfiguration":{"shape":"S5"},"tags":{"shape":"S7"},"type":{}}},"output":{"type":"structure","members":{"assistant":{"shape":"Sc"}}},"idempotent":true},"CreateAssistantAssociation":{"http":{"requestUri":"/assistants/{assistantId}/associations","responseCode":200},"input":{"type":"structure","required":["assistantId","association","associationType"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"association":{"type":"structure","members":{"knowledgeBaseId":{}},"union":true},"associationType":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"assistantAssociation":{"shape":"Sl"}}},"idempotent":true},"CreateContent":{"http":{"requestUri":"/knowledgeBases/{knowledgeBaseId}/contents","responseCode":200},"input":{"type":"structure","required":["knowledgeBaseId","name","uploadId"],"members":{"clientToken":{"idempotencyToken":true},"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"},"metadata":{"shape":"Sp"},"name":{},"overrideLinkOutUri":{},"tags":{"shape":"S7"},"title":{},"uploadId":{}}},"output":{"type":"structure","members":{"content":{"shape":"St"}}},"idempotent":true},"CreateKnowledgeBase":{"http":{"requestUri":"/knowledgeBases","responseCode":200},"input":{"type":"structure","required":["knowledgeBaseType","name"],"members":{"clientToken":{"idempotencyToken":true},"description":{},"knowledgeBaseType":{},"name":{},"renderingConfiguration":{"shape":"S10"},"serverSideEncryptionConfiguration":{"shape":"S5"},"sourceConfiguration":{"shape":"S11"},"tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"knowledgeBase":{"shape":"S16"}}},"idempotent":true},"CreateSession":{"http":{"requestUri":"/assistants/{assistantId}/sessions","responseCode":200},"input":{"type":"structure","required":["assistantId","name"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"clientToken":{"idempotencyToken":true},"description":{},"name":{},"tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"session":{"shape":"S1a"}}},"idempotent":true},"DeleteAssistant":{"http":{"method":"DELETE","requestUri":"/assistants/{assistantId}","responseCode":204},"input":{"type":"structure","required":["assistantId"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteAssistantAssociation":{"http":{"method":"DELETE","requestUri":"/assistants/{assistantId}/associations/{assistantAssociationId}","responseCode":204},"input":{"type":"structure","required":["assistantAssociationId","assistantId"],"members":{"assistantAssociationId":{"location":"uri","locationName":"assistantAssociationId"},"assistantId":{"location":"uri","locationName":"assistantId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteContent":{"http":{"method":"DELETE","requestUri":"/knowledgeBases/{knowledgeBaseId}/contents/{contentId}","responseCode":204},"input":{"type":"structure","required":["contentId","knowledgeBaseId"],"members":{"contentId":{"location":"uri","locationName":"contentId"},"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteKnowledgeBase":{"http":{"method":"DELETE","requestUri":"/knowledgeBases/{knowledgeBaseId}","responseCode":204},"input":{"type":"structure","required":["knowledgeBaseId"],"members":{"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetAssistant":{"http":{"method":"GET","requestUri":"/assistants/{assistantId}","responseCode":200},"input":{"type":"structure","required":["assistantId"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"}}},"output":{"type":"structure","members":{"assistant":{"shape":"Sc"}}}},"GetAssistantAssociation":{"http":{"method":"GET","requestUri":"/assistants/{assistantId}/associations/{assistantAssociationId}","responseCode":200},"input":{"type":"structure","required":["assistantAssociationId","assistantId"],"members":{"assistantAssociationId":{"location":"uri","locationName":"assistantAssociationId"},"assistantId":{"location":"uri","locationName":"assistantId"}}},"output":{"type":"structure","members":{"assistantAssociation":{"shape":"Sl"}}}},"GetContent":{"http":{"method":"GET","requestUri":"/knowledgeBases/{knowledgeBaseId}/contents/{contentId}","responseCode":200},"input":{"type":"structure","required":["contentId","knowledgeBaseId"],"members":{"contentId":{"location":"uri","locationName":"contentId"},"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","members":{"content":{"shape":"St"}}}},"GetContentSummary":{"http":{"method":"GET","requestUri":"/knowledgeBases/{knowledgeBaseId}/contents/{contentId}/summary","responseCode":200},"input":{"type":"structure","required":["contentId","knowledgeBaseId"],"members":{"contentId":{"location":"uri","locationName":"contentId"},"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","members":{"contentSummary":{"shape":"S1r"}}}},"GetKnowledgeBase":{"http":{"method":"GET","requestUri":"/knowledgeBases/{knowledgeBaseId}","responseCode":200},"input":{"type":"structure","required":["knowledgeBaseId"],"members":{"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","members":{"knowledgeBase":{"shape":"S16"}}}},"GetRecommendations":{"http":{"method":"GET","requestUri":"/assistants/{assistantId}/sessions/{sessionId}/recommendations","responseCode":200},"input":{"type":"structure","required":["assistantId","sessionId"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"sessionId":{"location":"uri","locationName":"sessionId"},"waitTimeSeconds":{"location":"querystring","locationName":"waitTimeSeconds","type":"integer"}}},"output":{"type":"structure","required":["recommendations"],"members":{"recommendations":{"type":"list","member":{"type":"structure","required":["document","recommendationId"],"members":{"document":{"shape":"S20"},"recommendationId":{},"relevanceLevel":{},"relevanceScore":{"type":"double"},"type":{}}}},"triggers":{"type":"list","member":{"type":"structure","required":["data","id","recommendationIds","source","type"],"members":{"data":{"type":"structure","members":{"query":{"type":"structure","members":{"text":{"shape":"S2f"}}}},"union":true},"id":{},"recommendationIds":{"shape":"S2g"},"source":{},"type":{}}}}}}},"GetSession":{"http":{"method":"GET","requestUri":"/assistants/{assistantId}/sessions/{sessionId}","responseCode":200},"input":{"type":"structure","required":["assistantId","sessionId"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"sessionId":{"location":"uri","locationName":"sessionId"}}},"output":{"type":"structure","members":{"session":{"shape":"S1a"}}}},"ListAssistantAssociations":{"http":{"method":"GET","requestUri":"/assistants/{assistantId}/associations","responseCode":200},"input":{"type":"structure","required":["assistantId"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["assistantAssociationSummaries"],"members":{"assistantAssociationSummaries":{"type":"list","member":{"type":"structure","required":["assistantArn","assistantAssociationArn","assistantAssociationId","assistantId","associationData","associationType"],"members":{"assistantArn":{},"assistantAssociationArn":{},"assistantAssociationId":{},"assistantId":{},"associationData":{"shape":"Sm"},"associationType":{},"tags":{"shape":"S7"}}}},"nextToken":{}}}},"ListAssistants":{"http":{"method":"GET","requestUri":"/assistants","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["assistantSummaries"],"members":{"assistantSummaries":{"type":"list","member":{"type":"structure","required":["assistantArn","assistantId","name","status","type"],"members":{"assistantArn":{},"assistantId":{},"description":{},"name":{},"serverSideEncryptionConfiguration":{"shape":"S5"},"status":{},"tags":{"shape":"S7"},"type":{}}}},"nextToken":{}}}},"ListContents":{"http":{"method":"GET","requestUri":"/knowledgeBases/{knowledgeBaseId}/contents","responseCode":200},"input":{"type":"structure","required":["knowledgeBaseId"],"members":{"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["contentSummaries"],"members":{"contentSummaries":{"shape":"S2w"},"nextToken":{}}}},"ListKnowledgeBases":{"http":{"method":"GET","requestUri":"/knowledgeBases","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["knowledgeBaseSummaries"],"members":{"knowledgeBaseSummaries":{"type":"list","member":{"type":"structure","required":["knowledgeBaseArn","knowledgeBaseId","knowledgeBaseType","name","status"],"members":{"description":{},"knowledgeBaseArn":{},"knowledgeBaseId":{},"knowledgeBaseType":{},"name":{},"renderingConfiguration":{"shape":"S10"},"serverSideEncryptionConfiguration":{"shape":"S5"},"sourceConfiguration":{"shape":"S11"},"status":{},"tags":{"shape":"S7"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S7"}}}},"NotifyRecommendationsReceived":{"http":{"requestUri":"/assistants/{assistantId}/sessions/{sessionId}/recommendations/notify","responseCode":200},"input":{"type":"structure","required":["assistantId","recommendationIds","sessionId"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"recommendationIds":{"shape":"S2g"},"sessionId":{"location":"uri","locationName":"sessionId"}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"type":"structure","members":{"message":{},"recommendationId":{}}}},"recommendationIds":{"shape":"S2g"}}},"idempotent":true},"QueryAssistant":{"http":{"requestUri":"/assistants/{assistantId}/query","responseCode":200},"input":{"type":"structure","required":["assistantId","queryText"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"maxResults":{"type":"integer"},"nextToken":{},"queryText":{"shape":"S2f"}}},"output":{"type":"structure","required":["results"],"members":{"nextToken":{},"results":{"type":"list","member":{"type":"structure","required":["document","resultId"],"members":{"document":{"shape":"S20"},"relevanceScore":{"type":"double"},"resultId":{}}}}}}},"RemoveKnowledgeBaseTemplateUri":{"http":{"method":"DELETE","requestUri":"/knowledgeBases/{knowledgeBaseId}/templateUri","responseCode":204},"input":{"type":"structure","required":["knowledgeBaseId"],"members":{"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","members":{}}},"SearchContent":{"http":{"requestUri":"/knowledgeBases/{knowledgeBaseId}/search","responseCode":200},"input":{"type":"structure","required":["knowledgeBaseId","searchExpression"],"members":{"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"searchExpression":{"shape":"S3f"}}},"output":{"type":"structure","required":["contentSummaries"],"members":{"contentSummaries":{"shape":"S2w"},"nextToken":{}}}},"SearchSessions":{"http":{"requestUri":"/assistants/{assistantId}/searchSessions","responseCode":200},"input":{"type":"structure","required":["assistantId","searchExpression"],"members":{"assistantId":{"location":"uri","locationName":"assistantId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"searchExpression":{"shape":"S3f"}}},"output":{"type":"structure","required":["sessionSummaries"],"members":{"nextToken":{},"sessionSummaries":{"type":"list","member":{"type":"structure","required":["assistantArn","assistantId","sessionArn","sessionId"],"members":{"assistantArn":{},"assistantId":{},"sessionArn":{},"sessionId":{}}}}}}},"StartContentUpload":{"http":{"requestUri":"/knowledgeBases/{knowledgeBaseId}/upload","responseCode":200},"input":{"type":"structure","required":["contentType","knowledgeBaseId"],"members":{"contentType":{},"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"}}},"output":{"type":"structure","required":["headersToInclude","uploadId","url","urlExpiry"],"members":{"headersToInclude":{"type":"map","key":{},"value":{}},"uploadId":{},"url":{"shape":"Sw"},"urlExpiry":{"shape":"Sx"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateContent":{"http":{"requestUri":"/knowledgeBases/{knowledgeBaseId}/contents/{contentId}","responseCode":200},"input":{"type":"structure","required":["contentId","knowledgeBaseId"],"members":{"contentId":{"location":"uri","locationName":"contentId"},"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"},"metadata":{"shape":"Sp"},"overrideLinkOutUri":{},"removeOverrideLinkOutUri":{"type":"boolean"},"revisionId":{},"title":{},"uploadId":{}}},"output":{"type":"structure","members":{"content":{"shape":"St"}}}},"UpdateKnowledgeBaseTemplateUri":{"http":{"requestUri":"/knowledgeBases/{knowledgeBaseId}/templateUri","responseCode":200},"input":{"type":"structure","required":["knowledgeBaseId","templateUri"],"members":{"knowledgeBaseId":{"location":"uri","locationName":"knowledgeBaseId"},"templateUri":{}}},"output":{"type":"structure","members":{"knowledgeBase":{"shape":"S16"}}}}},"shapes":{"S5":{"type":"structure","members":{"kmsKeyId":{}}},"S7":{"type":"map","key":{},"value":{}},"Sc":{"type":"structure","required":["assistantArn","assistantId","name","status","type"],"members":{"assistantArn":{},"assistantId":{},"description":{},"name":{},"serverSideEncryptionConfiguration":{"shape":"S5"},"status":{},"tags":{"shape":"S7"},"type":{}}},"Sl":{"type":"structure","required":["assistantArn","assistantAssociationArn","assistantAssociationId","assistantId","associationData","associationType"],"members":{"assistantArn":{},"assistantAssociationArn":{},"assistantAssociationId":{},"assistantId":{},"associationData":{"shape":"Sm"},"associationType":{},"tags":{"shape":"S7"}}},"Sm":{"type":"structure","members":{"knowledgeBaseAssociation":{"type":"structure","members":{"knowledgeBaseArn":{},"knowledgeBaseId":{}}}},"union":true},"Sp":{"type":"map","key":{},"value":{}},"St":{"type":"structure","required":["contentArn","contentId","contentType","knowledgeBaseArn","knowledgeBaseId","metadata","name","revisionId","status","title","url","urlExpiry"],"members":{"contentArn":{},"contentId":{},"contentType":{},"knowledgeBaseArn":{},"knowledgeBaseId":{},"linkOutUri":{},"metadata":{"shape":"Sp"},"name":{},"revisionId":{},"status":{},"tags":{"shape":"S7"},"title":{},"url":{"shape":"Sw"},"urlExpiry":{"shape":"Sx"}}},"Sw":{"type":"string","sensitive":true},"Sx":{"type":"timestamp","timestampFormat":"unixTimestamp"},"S10":{"type":"structure","members":{"templateUri":{}}},"S11":{"type":"structure","members":{"appIntegrations":{"type":"structure","required":["appIntegrationArn","objectFields"],"members":{"appIntegrationArn":{},"objectFields":{"type":"list","member":{}}}}},"union":true},"S16":{"type":"structure","required":["knowledgeBaseArn","knowledgeBaseId","knowledgeBaseType","name","status"],"members":{"description":{},"knowledgeBaseArn":{},"knowledgeBaseId":{},"knowledgeBaseType":{},"lastContentModificationTime":{"shape":"Sx"},"name":{},"renderingConfiguration":{"shape":"S10"},"serverSideEncryptionConfiguration":{"shape":"S5"},"sourceConfiguration":{"shape":"S11"},"status":{},"tags":{"shape":"S7"}}},"S1a":{"type":"structure","required":["name","sessionArn","sessionId"],"members":{"description":{},"name":{},"sessionArn":{},"sessionId":{},"tags":{"shape":"S7"}}},"S1r":{"type":"structure","required":["contentArn","contentId","contentType","knowledgeBaseArn","knowledgeBaseId","metadata","name","revisionId","status","title"],"members":{"contentArn":{},"contentId":{},"contentType":{},"knowledgeBaseArn":{},"knowledgeBaseId":{},"metadata":{"shape":"Sp"},"name":{},"revisionId":{},"status":{},"tags":{"shape":"S7"},"title":{}}},"S20":{"type":"structure","required":["contentReference"],"members":{"contentReference":{"type":"structure","members":{"contentArn":{},"contentId":{},"knowledgeBaseArn":{},"knowledgeBaseId":{}}},"excerpt":{"shape":"S22"},"title":{"shape":"S22"}}},"S22":{"type":"structure","members":{"highlights":{"type":"list","member":{"type":"structure","members":{"beginOffsetInclusive":{"type":"integer"},"endOffsetExclusive":{"type":"integer"}}}},"text":{"type":"string","sensitive":true}}},"S2f":{"type":"string","sensitive":true},"S2g":{"type":"list","member":{}},"S2w":{"type":"list","member":{"shape":"S1r"}},"S3f":{"type":"structure","required":["filters"],"members":{"filters":{"type":"list","member":{"type":"structure","required":["field","operator","value"],"members":{"field":{},"operator":{},"value":{}}}}}}}}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAssistantAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assistantAssociationSummaries"},"ListAssistants":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"assistantSummaries"},"ListContents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"contentSummaries"},"ListKnowledgeBases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"knowledgeBaseSummaries"},"QueryAssistant":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"results"},"SearchContent":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"contentSummaries"},"SearchSessions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"sessionSummaries"}}}

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['account'] = {};
	AWS.Account = Service.defineService('account', ['2021-02-01']);
	Object.defineProperty(apiLoader.services['account'], '2021-02-01', {
	  get: function get() {
	    var model = __webpack_require__(1068);
	    model.paginators = __webpack_require__(1069).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Account;


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-02-01","endpointPrefix":"account","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Account","serviceId":"Account","signatureVersion":"v4","signingName":"account","uid":"account-2021-02-01"},"operations":{"DeleteAlternateContact":{"http":{"requestUri":"/deleteAlternateContact","responseCode":200},"input":{"type":"structure","required":["AlternateContactType"],"members":{"AccountId":{},"AlternateContactType":{}}},"idempotent":true},"GetAlternateContact":{"http":{"requestUri":"/getAlternateContact","responseCode":200},"input":{"type":"structure","required":["AlternateContactType"],"members":{"AccountId":{},"AlternateContactType":{}}},"output":{"type":"structure","members":{"AlternateContact":{"type":"structure","members":{"AlternateContactType":{},"EmailAddress":{"shape":"S7"},"Name":{"shape":"S8"},"PhoneNumber":{"shape":"S9"},"Title":{"shape":"Sa"}}}}}},"PutAlternateContact":{"http":{"requestUri":"/putAlternateContact","responseCode":200},"input":{"type":"structure","required":["AlternateContactType","EmailAddress","Name","PhoneNumber","Title"],"members":{"AccountId":{},"AlternateContactType":{},"EmailAddress":{"shape":"S7"},"Name":{"shape":"S8"},"PhoneNumber":{"shape":"S9"},"Title":{"shape":"Sa"}}},"idempotent":true}},"shapes":{"S7":{"type":"string","sensitive":true},"S8":{"type":"string","sensitive":true},"S9":{"type":"string","sensitive":true},"Sa":{"type":"string","sensitive":true}}}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['cloudcontrol'] = {};
	AWS.CloudControl = Service.defineService('cloudcontrol', ['2021-09-30']);
	Object.defineProperty(apiLoader.services['cloudcontrol'], '2021-09-30', {
	  get: function get() {
	    var model = __webpack_require__(1071);
	    model.paginators = __webpack_require__(1072).pagination;
	    model.waiters = __webpack_require__(1073).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.CloudControl;


/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-09-30","endpointPrefix":"cloudcontrolapi","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"CloudControlApi","serviceFullName":"AWS Cloud Control API","serviceId":"CloudControl","signatureVersion":"v4","signingName":"cloudcontrolapi","targetPrefix":"CloudApiService","uid":"cloudcontrol-2021-09-30"},"operations":{"CancelResourceRequest":{"input":{"type":"structure","required":["RequestToken"],"members":{"RequestToken":{}}},"output":{"type":"structure","members":{"ProgressEvent":{"shape":"S4"}}},"idempotent":true},"CreateResource":{"input":{"type":"structure","required":["TypeName","DesiredState"],"members":{"TypeName":{},"TypeVersionId":{},"RoleArn":{},"ClientToken":{"idempotencyToken":true},"DesiredState":{"shape":"Sa"}}},"output":{"type":"structure","members":{"ProgressEvent":{"shape":"S4"}}}},"DeleteResource":{"input":{"type":"structure","required":["TypeName","Identifier"],"members":{"TypeName":{},"TypeVersionId":{},"RoleArn":{},"ClientToken":{"idempotencyToken":true},"Identifier":{}}},"output":{"type":"structure","members":{"ProgressEvent":{"shape":"S4"}}}},"GetResource":{"input":{"type":"structure","required":["TypeName","Identifier"],"members":{"TypeName":{},"TypeVersionId":{},"RoleArn":{},"Identifier":{}}},"output":{"type":"structure","members":{"TypeName":{},"ResourceDescription":{"shape":"Sm"}}}},"GetResourceRequestStatus":{"input":{"type":"structure","required":["RequestToken"],"members":{"RequestToken":{}}},"output":{"type":"structure","members":{"ProgressEvent":{"shape":"S4"}}}},"ListResourceRequests":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"ResourceRequestStatusFilter":{"type":"structure","members":{"Operations":{"type":"list","member":{}},"OperationStatuses":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"ResourceRequestStatusSummaries":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"ListResources":{"input":{"type":"structure","required":["TypeName"],"members":{"TypeName":{},"TypeVersionId":{},"RoleArn":{},"NextToken":{},"MaxResults":{"type":"integer"},"ResourceModel":{"shape":"Sa"}}},"output":{"type":"structure","members":{"TypeName":{},"ResourceDescriptions":{"type":"list","member":{"shape":"Sm"}},"NextToken":{}}}},"UpdateResource":{"input":{"type":"structure","required":["TypeName","Identifier","PatchDocument"],"members":{"TypeName":{},"TypeVersionId":{},"RoleArn":{},"ClientToken":{"idempotencyToken":true},"Identifier":{},"PatchDocument":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"ProgressEvent":{"shape":"S4"}}}}},"shapes":{"S4":{"type":"structure","members":{"TypeName":{},"Identifier":{},"RequestToken":{},"Operation":{},"OperationStatus":{},"EventTime":{"type":"timestamp"},"ResourceModel":{"shape":"Sa"},"StatusMessage":{},"ErrorCode":{},"RetryAfter":{"type":"timestamp"}}},"Sa":{"type":"string","sensitive":true},"Sm":{"type":"structure","members":{"Identifier":{},"Properties":{"shape":"Sa"}}}}}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListResourceRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{"ResourceRequestSuccess":{"description":"Wait until resource operation request is successful","operation":"GetResourceRequestStatus","delay":5,"maxAttempts":720,"acceptors":[{"state":"success","matcher":"path","argument":"ProgressEvent.OperationStatus","expected":"SUCCESS"},{"state":"failure","matcher":"path","argument":"ProgressEvent.OperationStatus","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"ProgressEvent.OperationStatus","expected":"CANCEL_COMPLETE"}]}}}

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['grafana'] = {};
	AWS.Grafana = Service.defineService('grafana', ['2020-08-18']);
	Object.defineProperty(apiLoader.services['grafana'], '2020-08-18', {
	  get: function get() {
	    var model = __webpack_require__(1075);
	    model.paginators = __webpack_require__(1076).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Grafana;


/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-18","endpointPrefix":"grafana","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Managed Grafana","serviceId":"grafana","signatureVersion":"v4","signingName":"grafana","uid":"grafana-2020-08-18"},"operations":{"AssociateLicense":{"http":{"requestUri":"/workspaces/{workspaceId}/licenses/{licenseType}","responseCode":202},"input":{"type":"structure","required":["licenseType","workspaceId"],"members":{"licenseType":{"location":"uri","locationName":"licenseType"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"shape":"S5"}}}},"CreateWorkspace":{"http":{"requestUri":"/workspaces","responseCode":202},"input":{"type":"structure","required":["accountAccessType","authenticationProviders","permissionType"],"members":{"accountAccessType":{},"authenticationProviders":{"shape":"S8"},"clientToken":{"idempotencyToken":true},"organizationRoleName":{"shape":"Sl"},"permissionType":{},"stackSetName":{},"tags":{"shape":"Sr"},"workspaceDataSources":{"shape":"Sc"},"workspaceDescription":{"shape":"Se"},"workspaceName":{"shape":"Si"},"workspaceNotificationDestinations":{"shape":"Sj"},"workspaceOrganizationalUnits":{"shape":"Sm"},"workspaceRoleArn":{"shape":"Su"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"shape":"S5"}}},"idempotent":true},"DeleteWorkspace":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"shape":"S5"}}},"idempotent":true},"DescribeWorkspace":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"shape":"S5"}}}},"DescribeWorkspaceAuthentication":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/authentication","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["authentication"],"members":{"authentication":{"shape":"S14"}}}},"DisassociateLicense":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/licenses/{licenseType}","responseCode":202},"input":{"type":"structure","required":["licenseType","workspaceId"],"members":{"licenseType":{"location":"uri","locationName":"licenseType"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"shape":"S5"}}}},"ListPermissions":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/permissions","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"groupId":{"location":"querystring","locationName":"groupId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"userId":{"location":"querystring","locationName":"userId"},"userType":{"location":"querystring","locationName":"userType"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["permissions"],"members":{"nextToken":{},"permissions":{"type":"list","member":{"type":"structure","required":["role","user"],"members":{"role":{},"user":{"shape":"S1v"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sr"}}}},"ListWorkspaces":{"http":{"method":"GET","requestUri":"/workspaces","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["workspaces"],"members":{"nextToken":{},"workspaces":{"type":"list","member":{"type":"structure","required":["authentication","created","endpoint","grafanaVersion","id","modified","status"],"members":{"authentication":{"shape":"S7"},"created":{"type":"timestamp"},"description":{"shape":"Se"},"endpoint":{},"grafanaVersion":{},"id":{},"modified":{"type":"timestamp"},"name":{"shape":"Si"},"notificationDestinations":{"shape":"Sj"},"status":{},"tags":{"shape":"Sr"}}}}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sr"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdatePermissions":{"http":{"method":"PATCH","requestUri":"/workspaces/{workspaceId}/permissions","responseCode":200},"input":{"type":"structure","required":["updateInstructionBatch","workspaceId"],"members":{"updateInstructionBatch":{"type":"list","member":{"shape":"S2a"}},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["errors"],"members":{"errors":{"type":"list","member":{"type":"structure","required":["causedBy","code","message"],"members":{"causedBy":{"shape":"S2a"},"code":{"type":"integer"},"message":{}}}}}}},"UpdateWorkspace":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"accountAccessType":{},"organizationRoleName":{"shape":"Sl"},"permissionType":{},"stackSetName":{},"workspaceDataSources":{"shape":"Sc"},"workspaceDescription":{"shape":"Se"},"workspaceId":{"location":"uri","locationName":"workspaceId"},"workspaceName":{"shape":"Si"},"workspaceNotificationDestinations":{"shape":"Sj"},"workspaceOrganizationalUnits":{"shape":"Sm"},"workspaceRoleArn":{"shape":"Su"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"shape":"S5"}}}},"UpdateWorkspaceAuthentication":{"http":{"requestUri":"/workspaces/{workspaceId}/authentication","responseCode":200},"input":{"type":"structure","required":["authenticationProviders","workspaceId"],"members":{"authenticationProviders":{"shape":"S8"},"samlConfiguration":{"shape":"S18"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["authentication"],"members":{"authentication":{"shape":"S14"}}}}},"shapes":{"S5":{"type":"structure","required":["authentication","created","dataSources","endpoint","grafanaVersion","id","modified","status"],"members":{"accountAccessType":{},"authentication":{"shape":"S7"},"created":{"type":"timestamp"},"dataSources":{"shape":"Sc"},"description":{"shape":"Se"},"endpoint":{},"freeTrialConsumed":{"type":"boolean"},"freeTrialExpiration":{"type":"timestamp"},"grafanaVersion":{},"id":{},"licenseExpiration":{"type":"timestamp"},"licenseType":{},"modified":{"type":"timestamp"},"name":{"shape":"Si"},"notificationDestinations":{"shape":"Sj"},"organizationRoleName":{"shape":"Sl"},"organizationalUnits":{"shape":"Sm"},"permissionType":{},"stackSetName":{},"status":{},"tags":{"shape":"Sr"},"workspaceRoleArn":{"shape":"Su"}}},"S7":{"type":"structure","required":["providers"],"members":{"providers":{"shape":"S8"},"samlConfigurationStatus":{}}},"S8":{"type":"list","member":{}},"Sc":{"type":"list","member":{}},"Se":{"type":"string","sensitive":true},"Si":{"type":"string","sensitive":true},"Sj":{"type":"list","member":{}},"Sl":{"type":"string","sensitive":true},"Sm":{"type":"list","member":{},"sensitive":true},"Sr":{"type":"map","key":{},"value":{}},"Su":{"type":"string","sensitive":true},"S14":{"type":"structure","required":["providers"],"members":{"awsSso":{"type":"structure","members":{"ssoClientId":{}}},"providers":{"shape":"S8"},"saml":{"type":"structure","required":["status"],"members":{"configuration":{"shape":"S18"},"status":{}}}}},"S18":{"type":"structure","required":["idpMetadata"],"members":{"allowedOrganizations":{"type":"list","member":{}},"assertionAttributes":{"type":"structure","members":{"email":{},"groups":{},"login":{},"name":{},"org":{},"role":{}}},"idpMetadata":{"type":"structure","members":{"url":{},"xml":{}},"union":true},"loginValidityDuration":{"type":"integer"},"roleValues":{"type":"structure","members":{"admin":{"shape":"S1i"},"editor":{"shape":"S1i"}}}}},"S1i":{"type":"list","member":{}},"S1v":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S2a":{"type":"structure","required":["action","role","users"],"members":{"action":{},"role":{},"users":{"type":"list","member":{"shape":"S1v"}}}}}}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListPermissions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"permissions"},"ListWorkspaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"workspaces"}}}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['panorama'] = {};
	AWS.Panorama = Service.defineService('panorama', ['2019-07-24']);
	Object.defineProperty(apiLoader.services['panorama'], '2019-07-24', {
	  get: function get() {
	    var model = __webpack_require__(1078);
	    model.paginators = __webpack_require__(1079).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Panorama;


/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-07-24","endpointPrefix":"panorama","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Panorama","serviceFullName":"AWS Panorama","serviceId":"Panorama","signatureVersion":"v4","signingName":"panorama","uid":"panorama-2019-07-24"},"operations":{"CreateApplicationInstance":{"http":{"requestUri":"/application-instances","responseCode":200},"input":{"type":"structure","required":["DefaultRuntimeContextDevice","ManifestPayload"],"members":{"ApplicationInstanceIdToReplace":{},"DefaultRuntimeContextDevice":{},"Description":{},"ManifestOverridesPayload":{"shape":"S5"},"ManifestPayload":{"shape":"S7"},"Name":{},"RuntimeRoleArn":{},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","required":["ApplicationInstanceId"],"members":{"ApplicationInstanceId":{}}}},"CreateJobForDevices":{"http":{"requestUri":"/jobs","responseCode":200},"input":{"type":"structure","required":["DeviceIds","DeviceJobConfig","JobType"],"members":{"DeviceIds":{"type":"list","member":{}},"DeviceJobConfig":{"type":"structure","members":{"OTAJobConfig":{"type":"structure","required":["ImageVersion"],"members":{"ImageVersion":{}}}}},"JobType":{}}},"output":{"type":"structure","required":["Jobs"],"members":{"Jobs":{"type":"list","member":{"type":"structure","members":{"DeviceId":{},"JobId":{}}}}}}},"CreateNodeFromTemplateJob":{"http":{"requestUri":"/packages/template-job","responseCode":200},"input":{"type":"structure","required":["NodeName","OutputPackageName","OutputPackageVersion","TemplateParameters","TemplateType"],"members":{"JobTags":{"shape":"Sr"},"NodeDescription":{},"NodeName":{},"OutputPackageName":{},"OutputPackageVersion":{},"TemplateParameters":{"shape":"Sx"},"TemplateType":{}}},"output":{"type":"structure","required":["JobId"],"members":{"JobId":{}}}},"CreatePackage":{"http":{"requestUri":"/packages","responseCode":200},"input":{"type":"structure","required":["PackageName"],"members":{"PackageName":{},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","required":["StorageLocation"],"members":{"Arn":{},"PackageId":{},"StorageLocation":{"shape":"S16"}}}},"CreatePackageImportJob":{"http":{"requestUri":"/packages/import-jobs","responseCode":200},"input":{"type":"structure","required":["ClientToken","InputConfig","JobType","OutputConfig"],"members":{"ClientToken":{},"InputConfig":{"shape":"S1b"},"JobTags":{"shape":"Sr"},"JobType":{},"OutputConfig":{"shape":"S1i"}}},"output":{"type":"structure","required":["JobId"],"members":{"JobId":{}}}},"DeleteDevice":{"http":{"method":"DELETE","requestUri":"/devices/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["DeviceId"],"members":{"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"DeletePackage":{"http":{"method":"DELETE","requestUri":"/packages/{PackageId}","responseCode":200},"input":{"type":"structure","required":["PackageId"],"members":{"ForceDelete":{"location":"querystring","locationName":"ForceDelete","type":"boolean"},"PackageId":{"location":"uri","locationName":"PackageId"}}},"output":{"type":"structure","members":{}}},"DeregisterPackageVersion":{"http":{"method":"DELETE","requestUri":"/packages/{PackageId}/versions/{PackageVersion}/patch/{PatchVersion}","responseCode":200},"input":{"type":"structure","required":["PackageId","PackageVersion","PatchVersion"],"members":{"OwnerAccount":{"location":"querystring","locationName":"OwnerAccount"},"PackageId":{"location":"uri","locationName":"PackageId"},"PackageVersion":{"location":"uri","locationName":"PackageVersion"},"PatchVersion":{"location":"uri","locationName":"PatchVersion"},"UpdatedLatestPatchVersion":{"location":"querystring","locationName":"UpdatedLatestPatchVersion"}}},"output":{"type":"structure","members":{}}},"DescribeApplicationInstance":{"http":{"method":"GET","requestUri":"/application-instances/{ApplicationInstanceId}","responseCode":200},"input":{"type":"structure","required":["ApplicationInstanceId"],"members":{"ApplicationInstanceId":{"location":"uri","locationName":"ApplicationInstanceId"}}},"output":{"type":"structure","members":{"ApplicationInstanceId":{},"ApplicationInstanceIdToReplace":{},"Arn":{},"CreatedTime":{"type":"timestamp"},"DefaultRuntimeContextDevice":{},"DefaultRuntimeContextDeviceName":{},"Description":{},"HealthStatus":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"RuntimeRoleArn":{},"Status":{},"StatusDescription":{},"Tags":{"shape":"Sb"}}}},"DescribeApplicationInstanceDetails":{"http":{"method":"GET","requestUri":"/application-instances/{ApplicationInstanceId}/details","responseCode":200},"input":{"type":"structure","required":["ApplicationInstanceId"],"members":{"ApplicationInstanceId":{"location":"uri","locationName":"ApplicationInstanceId"}}},"output":{"type":"structure","members":{"ApplicationInstanceId":{},"ApplicationInstanceIdToReplace":{},"CreatedTime":{"type":"timestamp"},"DefaultRuntimeContextDevice":{},"Description":{},"ManifestOverridesPayload":{"shape":"S5"},"ManifestPayload":{"shape":"S7"},"Name":{}}}},"DescribeDevice":{"http":{"method":"GET","requestUri":"/devices/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["DeviceId"],"members":{"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{"AlternateSoftwares":{"type":"list","member":{"type":"structure","members":{"Version":{}}}},"Arn":{},"Brand":{},"CreatedTime":{"type":"timestamp"},"CurrentNetworkingStatus":{"type":"structure","members":{"Ethernet0Status":{"shape":"S2e"},"Ethernet1Status":{"shape":"S2e"},"LastUpdatedTime":{"type":"timestamp"},"NtpStatus":{"type":"structure","members":{"ConnectionStatus":{},"IpAddress":{},"NtpServerName":{}}}}},"CurrentSoftware":{},"Description":{},"DeviceConnectionStatus":{},"DeviceId":{},"LatestAlternateSoftware":{},"LatestSoftware":{},"LeaseExpirationTime":{"type":"timestamp"},"Name":{},"NetworkingConfiguration":{"shape":"S2q"},"ProvisioningStatus":{},"SerialNumber":{},"Tags":{"shape":"Sb"},"Type":{}}}},"DescribeDeviceJob":{"http":{"method":"GET","requestUri":"/jobs/{JobId}","responseCode":200},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{"location":"uri","locationName":"JobId"}}},"output":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"DeviceArn":{},"DeviceId":{},"DeviceName":{},"DeviceType":{},"ImageVersion":{},"JobId":{},"Status":{}}}},"DescribeNode":{"http":{"method":"GET","requestUri":"/nodes/{NodeId}","responseCode":200},"input":{"type":"structure","required":["NodeId"],"members":{"NodeId":{"location":"uri","locationName":"NodeId"},"OwnerAccount":{"location":"querystring","locationName":"OwnerAccount"}}},"output":{"type":"structure","required":["Category","CreatedTime","Description","LastUpdatedTime","Name","NodeId","NodeInterface","OwnerAccount","PackageId","PackageName","PackageVersion","PatchVersion"],"members":{"AssetName":{},"Category":{},"CreatedTime":{"type":"timestamp"},"Description":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"NodeId":{},"NodeInterface":{"type":"structure","required":["Inputs","Outputs"],"members":{"Inputs":{"type":"list","member":{"type":"structure","members":{"DefaultValue":{},"Description":{},"MaxConnections":{"type":"integer"},"Name":{},"Type":{}}}},"Outputs":{"type":"list","member":{"type":"structure","members":{"Description":{},"Name":{},"Type":{}}}}}},"OwnerAccount":{},"PackageArn":{},"PackageId":{},"PackageName":{},"PackageVersion":{},"PatchVersion":{}}}},"DescribeNodeFromTemplateJob":{"http":{"method":"GET","requestUri":"/packages/template-job/{JobId}","responseCode":200},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{"location":"uri","locationName":"JobId"}}},"output":{"type":"structure","required":["CreatedTime","JobId","LastUpdatedTime","NodeName","OutputPackageName","OutputPackageVersion","Status","StatusMessage","TemplateParameters","TemplateType"],"members":{"CreatedTime":{"type":"timestamp"},"JobId":{},"JobTags":{"shape":"Sr"},"LastUpdatedTime":{"type":"timestamp"},"NodeDescription":{},"NodeName":{},"OutputPackageName":{},"OutputPackageVersion":{},"Status":{},"StatusMessage":{},"TemplateParameters":{"shape":"Sx"},"TemplateType":{}}}},"DescribePackage":{"http":{"method":"GET","requestUri":"/packages/metadata/{PackageId}","responseCode":200},"input":{"type":"structure","required":["PackageId"],"members":{"PackageId":{"location":"uri","locationName":"PackageId"}}},"output":{"type":"structure","required":["Arn","CreatedTime","PackageId","PackageName","StorageLocation","Tags"],"members":{"Arn":{},"CreatedTime":{"type":"timestamp"},"PackageId":{},"PackageName":{},"ReadAccessPrincipalArns":{"shape":"S3s"},"StorageLocation":{"shape":"S16"},"Tags":{"shape":"Sb"},"WriteAccessPrincipalArns":{"shape":"S3s"}}}},"DescribePackageImportJob":{"http":{"method":"GET","requestUri":"/packages/import-jobs/{JobId}","responseCode":200},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{"location":"uri","locationName":"JobId"}}},"output":{"type":"structure","required":["CreatedTime","InputConfig","JobId","JobType","LastUpdatedTime","Output","OutputConfig","Status","StatusMessage"],"members":{"ClientToken":{},"CreatedTime":{"type":"timestamp"},"InputConfig":{"shape":"S1b"},"JobId":{},"JobTags":{"shape":"Sr"},"JobType":{},"LastUpdatedTime":{"type":"timestamp"},"Output":{"type":"structure","required":["OutputS3Location","PackageId","PackageVersion","PatchVersion"],"members":{"OutputS3Location":{"type":"structure","required":["BucketName","ObjectKey"],"members":{"BucketName":{},"ObjectKey":{}}},"PackageId":{},"PackageVersion":{},"PatchVersion":{}}},"OutputConfig":{"shape":"S1i"},"Status":{},"StatusMessage":{}}}},"DescribePackageVersion":{"http":{"method":"GET","requestUri":"/packages/metadata/{PackageId}/versions/{PackageVersion}","responseCode":200},"input":{"type":"structure","required":["PackageId","PackageVersion"],"members":{"OwnerAccount":{"location":"querystring","locationName":"OwnerAccount"},"PackageId":{"location":"uri","locationName":"PackageId"},"PackageVersion":{"location":"uri","locationName":"PackageVersion"},"PatchVersion":{"location":"querystring","locationName":"PatchVersion"}}},"output":{"type":"structure","required":["IsLatestPatch","PackageId","PackageName","PackageVersion","PatchVersion","Status"],"members":{"IsLatestPatch":{"type":"boolean"},"OwnerAccount":{},"PackageArn":{},"PackageId":{},"PackageName":{},"PackageVersion":{},"PatchVersion":{},"RegisteredTime":{"type":"timestamp"},"Status":{},"StatusDescription":{}}}},"ListApplicationInstanceDependencies":{"http":{"method":"GET","requestUri":"/application-instances/{ApplicationInstanceId}/package-dependencies","responseCode":200},"input":{"type":"structure","required":["ApplicationInstanceId"],"members":{"ApplicationInstanceId":{"location":"uri","locationName":"ApplicationInstanceId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"PackageObjects":{"type":"list","member":{"type":"structure","required":["Name","PackageVersion","PatchVersion"],"members":{"Name":{},"PackageVersion":{},"PatchVersion":{}}}}}}},"ListApplicationInstanceNodeInstances":{"http":{"method":"GET","requestUri":"/application-instances/{ApplicationInstanceId}/node-instances","responseCode":200},"input":{"type":"structure","required":["ApplicationInstanceId"],"members":{"ApplicationInstanceId":{"location":"uri","locationName":"ApplicationInstanceId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"NodeInstances":{"type":"list","member":{"type":"structure","required":["CurrentStatus","NodeInstanceId"],"members":{"CurrentStatus":{},"NodeId":{},"NodeInstanceId":{},"NodeName":{},"PackageName":{},"PackagePatchVersion":{},"PackageVersion":{}}}}}}},"ListApplicationInstances":{"http":{"method":"GET","requestUri":"/application-instances","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"querystring","locationName":"deviceId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"StatusFilter":{"location":"querystring","locationName":"statusFilter"}}},"output":{"type":"structure","members":{"ApplicationInstances":{"type":"list","member":{"type":"structure","members":{"ApplicationInstanceId":{},"Arn":{},"CreatedTime":{"type":"timestamp"},"DefaultRuntimeContextDevice":{},"DefaultRuntimeContextDeviceName":{},"Description":{},"HealthStatus":{},"Name":{},"Status":{},"StatusDescription":{},"Tags":{"shape":"Sb"}}}},"NextToken":{}}}},"ListDevices":{"http":{"method":"GET","requestUri":"/devices","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","required":["Devices"],"members":{"Devices":{"type":"list","member":{"type":"structure","members":{"Brand":{},"CreatedTime":{"type":"timestamp"},"DeviceId":{},"LastUpdatedTime":{"type":"timestamp"},"LeaseExpirationTime":{"type":"timestamp"},"Name":{},"ProvisioningStatus":{}}}},"NextToken":{}}}},"ListDevicesJobs":{"http":{"method":"GET","requestUri":"/jobs","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"querystring","locationName":"DeviceId"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"DeviceJobs":{"type":"list","member":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"DeviceId":{},"DeviceName":{},"JobId":{}}}},"NextToken":{}}}},"ListNodeFromTemplateJobs":{"http":{"method":"GET","requestUri":"/packages/template-job","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","required":["NodeFromTemplateJobs"],"members":{"NextToken":{},"NodeFromTemplateJobs":{"type":"list","member":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"JobId":{},"NodeName":{},"Status":{},"StatusMessage":{},"TemplateType":{}}}}}}},"ListNodes":{"http":{"method":"GET","requestUri":"/nodes","responseCode":200},"input":{"type":"structure","members":{"Category":{"location":"querystring","locationName":"category"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"OwnerAccount":{"location":"querystring","locationName":"ownerAccount"},"PackageName":{"location":"querystring","locationName":"packageName"},"PackageVersion":{"location":"querystring","locationName":"packageVersion"},"PatchVersion":{"location":"querystring","locationName":"patchVersion"}}},"output":{"type":"structure","members":{"NextToken":{},"Nodes":{"type":"list","member":{"type":"structure","required":["Category","CreatedTime","Name","NodeId","PackageId","PackageName","PackageVersion","PatchVersion"],"members":{"Category":{},"CreatedTime":{"type":"timestamp"},"Description":{},"Name":{},"NodeId":{},"OwnerAccount":{},"PackageArn":{},"PackageId":{},"PackageName":{},"PackageVersion":{},"PatchVersion":{}}}}}}},"ListPackageImportJobs":{"http":{"method":"GET","requestUri":"/packages/import-jobs","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","required":["PackageImportJobs"],"members":{"NextToken":{},"PackageImportJobs":{"type":"list","member":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"JobId":{},"JobType":{},"LastUpdatedTime":{"type":"timestamp"},"Status":{},"StatusMessage":{}}}}}}},"ListPackages":{"http":{"method":"GET","requestUri":"/packages","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"Packages":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedTime":{"type":"timestamp"},"PackageId":{},"PackageName":{},"Tags":{"shape":"Sb"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sb"}}}},"ProvisionDevice":{"http":{"requestUri":"/devices","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Description":{},"Name":{},"NetworkingConfiguration":{"shape":"S2q"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","required":["Arn","Status"],"members":{"Arn":{},"Certificates":{"type":"blob"},"DeviceId":{},"IotThingName":{},"Status":{}}}},"RegisterPackageVersion":{"http":{"method":"PUT","requestUri":"/packages/{PackageId}/versions/{PackageVersion}/patch/{PatchVersion}","responseCode":200},"input":{"type":"structure","required":["PackageId","PackageVersion","PatchVersion"],"members":{"MarkLatest":{"type":"boolean"},"OwnerAccount":{},"PackageId":{"location":"uri","locationName":"PackageId"},"PackageVersion":{"location":"uri","locationName":"PackageVersion"},"PatchVersion":{"location":"uri","locationName":"PatchVersion"}}},"output":{"type":"structure","members":{}}},"RemoveApplicationInstance":{"http":{"method":"DELETE","requestUri":"/application-instances/{ApplicationInstanceId}","responseCode":200},"input":{"type":"structure","required":["ApplicationInstanceId"],"members":{"ApplicationInstanceId":{"location":"uri","locationName":"ApplicationInstanceId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDeviceMetadata":{"http":{"method":"PUT","requestUri":"/devices/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["DeviceId"],"members":{"Description":{},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{"DeviceId":{}}}}},"shapes":{"S5":{"type":"structure","members":{"PayloadData":{}},"union":true},"S7":{"type":"structure","members":{"PayloadData":{}},"union":true},"Sb":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{"type":"structure","required":["ResourceType","Tags"],"members":{"ResourceType":{},"Tags":{"shape":"Sb"}}}},"Sx":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"S16":{"type":"structure","required":["BinaryPrefixLocation","Bucket","GeneratedPrefixLocation","ManifestPrefixLocation","RepoPrefixLocation"],"members":{"BinaryPrefixLocation":{},"Bucket":{},"GeneratedPrefixLocation":{},"ManifestPrefixLocation":{},"RepoPrefixLocation":{}}},"S1b":{"type":"structure","members":{"PackageVersionInputConfig":{"type":"structure","required":["S3Location"],"members":{"S3Location":{"type":"structure","required":["BucketName","ObjectKey"],"members":{"BucketName":{},"ObjectKey":{},"Region":{}}}}}}},"S1i":{"type":"structure","members":{"PackageVersionOutputConfig":{"type":"structure","required":["PackageName","PackageVersion"],"members":{"MarkLatest":{"type":"boolean"},"PackageName":{},"PackageVersion":{}}}}},"S2e":{"type":"structure","members":{"ConnectionStatus":{},"HwAddress":{},"IpAddress":{}}},"S2q":{"type":"structure","members":{"Ethernet0":{"shape":"S2r"},"Ethernet1":{"shape":"S2r"},"Ntp":{"type":"structure","required":["NtpServers"],"members":{"NtpServers":{"type":"list","member":{}}}}}},"S2r":{"type":"structure","required":["ConnectionType"],"members":{"ConnectionType":{},"StaticIpConnectionInfo":{"type":"structure","required":["DefaultGateway","Dns","IpAddress","Mask"],"members":{"DefaultGateway":{},"Dns":{"type":"list","member":{}},"IpAddress":{},"Mask":{}}}}},"S3s":{"type":"list","member":{}}}}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplicationInstanceDependencies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListApplicationInstanceNodeInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListApplicationInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDevicesJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNodeFromTemplateJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNodes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPackageImportJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPackages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['chimesdkmeetings'] = {};
	AWS.ChimeSDKMeetings = Service.defineService('chimesdkmeetings', ['2021-07-15']);
	Object.defineProperty(apiLoader.services['chimesdkmeetings'], '2021-07-15', {
	  get: function get() {
	    var model = __webpack_require__(1081);
	    model.paginators = __webpack_require__(1082).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ChimeSDKMeetings;


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-07-15","endpointPrefix":"meetings-chime","protocol":"rest-json","serviceFullName":"Amazon Chime SDK Meetings","serviceId":"Chime SDK Meetings","signatureVersion":"v4","signingName":"chime","uid":"chime-sdk-meetings-2021-07-15"},"operations":{"BatchCreateAttendee":{"http":{"requestUri":"/meetings/{MeetingId}/attendees?operation=batch-create"},"input":{"type":"structure","required":["MeetingId","Attendees"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"},"Attendees":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"Attendees":{"shape":"S7"},"Errors":{"shape":"Sa"}}}},"CreateAttendee":{"http":{"requestUri":"/meetings/{MeetingId}/attendees"},"input":{"type":"structure","required":["MeetingId","ExternalUserId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"},"ExternalUserId":{"shape":"S5"}}},"output":{"type":"structure","members":{"Attendee":{"shape":"S8"}}}},"CreateMeeting":{"http":{"requestUri":"/meetings"},"input":{"type":"structure","required":["ClientRequestToken","MediaRegion","ExternalMeetingId"],"members":{"ClientRequestToken":{"shape":"Sg","idempotencyToken":true},"MediaRegion":{},"MeetingHostId":{"shape":"S5"},"ExternalMeetingId":{"shape":"Si"},"NotificationsConfiguration":{"shape":"Sj"},"MeetingFeatures":{"shape":"Sl"},"PrimaryMeetingId":{}}},"output":{"type":"structure","members":{"Meeting":{"shape":"Sq"}}}},"CreateMeetingWithAttendees":{"http":{"requestUri":"/meetings?operation=create-attendees"},"input":{"type":"structure","required":["ClientRequestToken","MediaRegion","ExternalMeetingId","Attendees"],"members":{"ClientRequestToken":{"shape":"Sg","idempotencyToken":true},"MediaRegion":{},"MeetingHostId":{"shape":"S5"},"ExternalMeetingId":{"shape":"Si"},"MeetingFeatures":{"shape":"Sl"},"NotificationsConfiguration":{"shape":"Sj"},"Attendees":{"type":"list","member":{"shape":"S4"}},"PrimaryMeetingId":{}}},"output":{"type":"structure","members":{"Meeting":{"shape":"Sq"},"Attendees":{"shape":"S7"},"Errors":{"shape":"Sa"}}}},"DeleteAttendee":{"http":{"method":"DELETE","requestUri":"/meetings/{MeetingId}/attendees/{AttendeeId}","responseCode":204},"input":{"type":"structure","required":["MeetingId","AttendeeId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"},"AttendeeId":{"location":"uri","locationName":"AttendeeId"}}}},"DeleteMeeting":{"http":{"method":"DELETE","requestUri":"/meetings/{MeetingId}","responseCode":204},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"}}}},"GetAttendee":{"http":{"method":"GET","requestUri":"/meetings/{MeetingId}/attendees/{AttendeeId}"},"input":{"type":"structure","required":["MeetingId","AttendeeId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"},"AttendeeId":{"location":"uri","locationName":"AttendeeId"}}},"output":{"type":"structure","members":{"Attendee":{"shape":"S8"}}}},"GetMeeting":{"http":{"method":"GET","requestUri":"/meetings/{MeetingId}"},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"}}},"output":{"type":"structure","members":{"Meeting":{"shape":"Sq"}}}},"ListAttendees":{"http":{"method":"GET","requestUri":"/meetings/{MeetingId}/attendees","responseCode":200},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Attendees":{"shape":"S7"},"NextToken":{}}}},"StartMeetingTranscription":{"http":{"requestUri":"/meetings/{MeetingId}/transcription?operation=start","responseCode":200},"input":{"type":"structure","required":["MeetingId","TranscriptionConfiguration"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"},"TranscriptionConfiguration":{"type":"structure","members":{"EngineTranscribeSettings":{"type":"structure","members":{"LanguageCode":{},"VocabularyFilterMethod":{},"VocabularyFilterName":{},"VocabularyName":{},"Region":{},"EnablePartialResultsStabilization":{"type":"boolean"},"PartialResultsStability":{},"ContentIdentificationType":{},"ContentRedactionType":{},"PiiEntityTypes":{},"LanguageModelName":{},"IdentifyLanguage":{"type":"boolean"},"LanguageOptions":{},"PreferredLanguage":{}}},"EngineTranscribeMedicalSettings":{"type":"structure","required":["LanguageCode","Specialty","Type"],"members":{"LanguageCode":{},"Specialty":{},"Type":{},"VocabularyName":{},"Region":{},"ContentIdentificationType":{}}}}}}}},"StopMeetingTranscription":{"http":{"requestUri":"/meetings/{MeetingId}/transcription?operation=stop","responseCode":200},"input":{"type":"structure","required":["MeetingId"],"members":{"MeetingId":{"location":"uri","locationName":"MeetingId"}}}}},"shapes":{"S4":{"type":"structure","required":["ExternalUserId"],"members":{"ExternalUserId":{"shape":"S5"}}},"S5":{"type":"string","sensitive":true},"S7":{"type":"list","member":{"shape":"S8"}},"S8":{"type":"structure","members":{"ExternalUserId":{"shape":"S5"},"AttendeeId":{},"JoinToken":{"type":"string","sensitive":true}}},"Sa":{"type":"list","member":{"type":"structure","members":{"ExternalUserId":{"shape":"S5"},"ErrorCode":{},"ErrorMessage":{}}}},"Sg":{"type":"string","sensitive":true},"Si":{"type":"string","sensitive":true},"Sj":{"type":"structure","members":{"LambdaFunctionArn":{"shape":"Sk"},"SnsTopicArn":{"shape":"Sk"},"SqsQueueArn":{"shape":"Sk"}}},"Sk":{"type":"string","sensitive":true},"Sl":{"type":"structure","members":{"Audio":{"type":"structure","members":{"EchoReduction":{}}}}},"Sq":{"type":"structure","members":{"MeetingId":{},"MeetingHostId":{"shape":"S5"},"ExternalMeetingId":{"shape":"Si"},"MediaRegion":{},"MediaPlacement":{"type":"structure","members":{"AudioHostUrl":{},"AudioFallbackUrl":{},"SignalingUrl":{},"TurnControlUrl":{},"ScreenDataUrl":{},"ScreenViewingUrl":{},"ScreenSharingUrl":{},"EventIngestionUrl":{}}},"MeetingFeatures":{"shape":"Sl"},"PrimaryMeetingId":{}}}}}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAttendees":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['resiliencehub'] = {};
	AWS.Resiliencehub = Service.defineService('resiliencehub', ['2020-04-30']);
	Object.defineProperty(apiLoader.services['resiliencehub'], '2020-04-30', {
	  get: function get() {
	    var model = __webpack_require__(1084);
	    model.paginators = __webpack_require__(1085).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Resiliencehub;


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-04-30","endpointPrefix":"resiliencehub","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Resilience Hub","serviceId":"resiliencehub","signatureVersion":"v4","signingName":"resiliencehub","uid":"resiliencehub-2020-04-30"},"operations":{"AddDraftAppVersionResourceMappings":{"http":{"requestUri":"/add-draft-app-version-resource-mappings","responseCode":200},"input":{"type":"structure","required":["appArn","resourceMappings"],"members":{"appArn":{},"resourceMappings":{"shape":"S3"}}},"output":{"type":"structure","required":["appArn","appVersion","resourceMappings"],"members":{"appArn":{},"appVersion":{},"resourceMappings":{"shape":"S3"}}}},"CreateApp":{"http":{"requestUri":"/create-app","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"clientToken":{"idempotencyToken":true},"description":{},"name":{},"policyArn":{},"tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sl"}}}},"CreateRecommendationTemplate":{"http":{"requestUri":"/create-recommendation-template","responseCode":200},"input":{"type":"structure","required":["assessmentArn","name"],"members":{"assessmentArn":{},"bucketName":{},"clientToken":{"idempotencyToken":true},"format":{},"name":{},"recommendationIds":{"shape":"Ss"},"recommendationTypes":{"shape":"Su"},"tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"recommendationTemplate":{"shape":"Sx"}}}},"CreateResiliencyPolicy":{"http":{"requestUri":"/create-resiliency-policy","responseCode":200},"input":{"type":"structure","required":["policy","policyName","tier"],"members":{"clientToken":{"idempotencyToken":true},"dataLocationConstraint":{},"policy":{"shape":"S14"},"policyDescription":{},"policyName":{},"tags":{"shape":"Sh"},"tier":{}}},"output":{"type":"structure","required":["policy"],"members":{"policy":{"shape":"S1a"}}}},"DeleteApp":{"http":{"requestUri":"/delete-app","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{},"clientToken":{"idempotencyToken":true},"forceDelete":{"type":"boolean"}}},"output":{"type":"structure","required":["appArn"],"members":{"appArn":{}}}},"DeleteAppAssessment":{"http":{"requestUri":"/delete-app-assessment","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["assessmentArn","assessmentStatus"],"members":{"assessmentArn":{},"assessmentStatus":{}}}},"DeleteRecommendationTemplate":{"http":{"requestUri":"/delete-recommendation-template","responseCode":200},"input":{"type":"structure","required":["recommendationTemplateArn"],"members":{"clientToken":{"idempotencyToken":true},"recommendationTemplateArn":{}}},"output":{"type":"structure","required":["recommendationTemplateArn","status"],"members":{"recommendationTemplateArn":{},"status":{}}}},"DeleteResiliencyPolicy":{"http":{"requestUri":"/delete-resiliency-policy","responseCode":200},"input":{"type":"structure","required":["policyArn"],"members":{"clientToken":{"idempotencyToken":true},"policyArn":{}}},"output":{"type":"structure","required":["policyArn"],"members":{"policyArn":{}}}},"DescribeApp":{"http":{"requestUri":"/describe-app","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sl"}}}},"DescribeAppAssessment":{"http":{"requestUri":"/describe-app-assessment","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{}}},"output":{"type":"structure","required":["assessment"],"members":{"assessment":{"shape":"S1p"}}}},"DescribeAppVersionResourcesResolutionStatus":{"http":{"requestUri":"/describe-app-version-resources-resolution-status","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion"],"members":{"appArn":{},"appVersion":{},"resolutionId":{}}},"output":{"type":"structure","required":["appArn","appVersion","resolutionId","status"],"members":{"appArn":{},"appVersion":{},"errorMessage":{},"resolutionId":{},"status":{}}}},"DescribeAppVersionTemplate":{"http":{"requestUri":"/describe-app-version-template","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion"],"members":{"appArn":{},"appVersion":{}}},"output":{"type":"structure","required":["appArn","appTemplateBody","appVersion"],"members":{"appArn":{},"appTemplateBody":{},"appVersion":{}}}},"DescribeDraftAppVersionResourcesImportStatus":{"http":{"requestUri":"/describe-draft-app-version-resources-import-status","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{}}},"output":{"type":"structure","required":["appArn","appVersion","status","statusChangeTime"],"members":{"appArn":{},"appVersion":{},"errorMessage":{},"status":{},"statusChangeTime":{"type":"timestamp"}}}},"DescribeResiliencyPolicy":{"http":{"requestUri":"/describe-resiliency-policy","responseCode":200},"input":{"type":"structure","required":["policyArn"],"members":{"policyArn":{}}},"output":{"type":"structure","required":["policy"],"members":{"policy":{"shape":"S1a"}}}},"ImportResourcesToDraftAppVersion":{"http":{"requestUri":"/import-resources-to-draft-app-version","responseCode":200},"input":{"type":"structure","required":["appArn","sourceArns"],"members":{"appArn":{},"sourceArns":{"shape":"S2b"}}},"output":{"type":"structure","required":["appArn","appVersion","sourceArns","status"],"members":{"appArn":{},"appVersion":{},"sourceArns":{"shape":"S2b"},"status":{}}}},"ListAlarmRecommendations":{"http":{"requestUri":"/list-alarm-recommendations","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["alarmRecommendations"],"members":{"alarmRecommendations":{"type":"list","member":{"type":"structure","required":["name","recommendationId","referenceId","type"],"members":{"appComponentName":{},"description":{},"items":{"shape":"S2k"},"name":{},"prerequisite":{},"recommendationId":{},"referenceId":{},"type":{}}}},"nextToken":{}}}},"ListAppAssessments":{"http":{"method":"GET","requestUri":"/list-app-assessments","responseCode":200},"input":{"type":"structure","members":{"appArn":{"location":"querystring","locationName":"appArn"},"assessmentName":{"location":"querystring","locationName":"assessmentName"},"assessmentStatus":{"location":"querystring","locationName":"assessmentStatus","type":"list","member":{}},"complianceStatus":{"location":"querystring","locationName":"complianceStatus"},"invoker":{"location":"querystring","locationName":"invoker"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"reverseOrder":{"location":"querystring","locationName":"reverseOrder","type":"boolean"}}},"output":{"type":"structure","required":["assessmentSummaries"],"members":{"assessmentSummaries":{"type":"list","member":{"type":"structure","required":["assessmentArn","assessmentStatus"],"members":{"appArn":{},"appVersion":{},"assessmentArn":{},"assessmentName":{},"assessmentStatus":{},"complianceStatus":{},"cost":{"shape":"S1t"},"endTime":{"type":"timestamp"},"invoker":{},"message":{},"resiliencyScore":{"type":"double"},"startTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAppComponentCompliances":{"http":{"requestUri":"/list-app-component-compliances","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["componentCompliances"],"members":{"componentCompliances":{"type":"list","member":{"type":"structure","members":{"appComponentName":{},"compliance":{"shape":"S1q"},"cost":{"shape":"S1t"},"message":{},"resiliencyScore":{"shape":"S1x"},"status":{}}}},"nextToken":{}}}},"ListAppComponentRecommendations":{"http":{"requestUri":"/list-app-component-recommendations","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["componentRecommendations"],"members":{"componentRecommendations":{"type":"list","member":{"type":"structure","required":["appComponentName","configRecommendations","recommendationStatus"],"members":{"appComponentName":{},"configRecommendations":{"type":"list","member":{"type":"structure","required":["name","optimizationType","referenceId"],"members":{"appComponentName":{},"compliance":{"shape":"S1q"},"cost":{"shape":"S1t"},"description":{},"haArchitecture":{},"name":{},"optimizationType":{},"recommendationCompliance":{"type":"map","key":{},"value":{"type":"structure","required":["expectedComplianceStatus"],"members":{"expectedComplianceStatus":{},"expectedRpoDescription":{},"expectedRpoInSecs":{"type":"integer"},"expectedRtoDescription":{},"expectedRtoInSecs":{"type":"integer"}}}},"referenceId":{},"suggestedChanges":{"type":"list","member":{}}}}},"recommendationStatus":{}}}},"nextToken":{}}}},"ListAppVersionResourceMappings":{"http":{"requestUri":"/list-app-version-resource-mappings","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion"],"members":{"appArn":{},"appVersion":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["resourceMappings"],"members":{"nextToken":{},"resourceMappings":{"shape":"S3"}}}},"ListAppVersionResources":{"http":{"requestUri":"/list-app-version-resources","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion"],"members":{"appArn":{},"appVersion":{},"maxResults":{"type":"integer"},"nextToken":{},"resolutionId":{}}},"output":{"type":"structure","required":["physicalResources","resolutionId"],"members":{"nextToken":{},"physicalResources":{"type":"list","member":{"type":"structure","required":["logicalResourceId","physicalResourceId","resourceType"],"members":{"appComponents":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"logicalResourceId":{"shape":"S3h"},"physicalResourceId":{"shape":"S8"},"resourceName":{},"resourceType":{}}}},"resolutionId":{}}}},"ListAppVersions":{"http":{"requestUri":"/list-app-versions","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["appVersions"],"members":{"appVersions":{"type":"list","member":{"type":"structure","required":["appVersion"],"members":{"appVersion":{}}}},"nextToken":{}}}},"ListApps":{"http":{"method":"GET","requestUri":"/list-apps","responseCode":200},"input":{"type":"structure","members":{"appArn":{"location":"querystring","locationName":"appArn"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"name":{"location":"querystring","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["appSummaries"],"members":{"appSummaries":{"type":"list","member":{"type":"structure","required":["appArn","creationTime","name"],"members":{"appArn":{},"complianceStatus":{},"creationTime":{"type":"timestamp"},"description":{},"name":{},"resiliencyScore":{"type":"double"}}}},"nextToken":{}}}},"ListRecommendationTemplates":{"http":{"method":"GET","requestUri":"/list-recommendation-templates","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{"location":"querystring","locationName":"assessmentArn"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"name":{"location":"querystring","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"recommendationTemplateArn":{"location":"querystring","locationName":"recommendationTemplateArn"},"reverseOrder":{"location":"querystring","locationName":"reverseOrder","type":"boolean"},"status":{"location":"querystring","locationName":"status","type":"list","member":{}}}},"output":{"type":"structure","members":{"nextToken":{},"recommendationTemplates":{"type":"list","member":{"shape":"Sx"}}}}},"ListResiliencyPolicies":{"http":{"method":"GET","requestUri":"/list-resiliency-policies","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"policyName":{"location":"querystring","locationName":"policyName"}}},"output":{"type":"structure","required":["resiliencyPolicies"],"members":{"nextToken":{},"resiliencyPolicies":{"shape":"S3w"}}}},"ListSopRecommendations":{"http":{"requestUri":"/list-sop-recommendations","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["sopRecommendations"],"members":{"nextToken":{},"sopRecommendations":{"type":"list","member":{"type":"structure","required":["recommendationId","referenceId","serviceType"],"members":{"appComponentName":{},"description":{},"items":{"shape":"S2k"},"name":{},"prerequisite":{},"recommendationId":{},"referenceId":{},"serviceType":{}}}}}}},"ListSuggestedResiliencyPolicies":{"http":{"method":"GET","requestUri":"/list-suggested-resiliency-policies","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["resiliencyPolicies"],"members":{"nextToken":{},"resiliencyPolicies":{"shape":"S3w"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sh"}}}},"ListTestRecommendations":{"http":{"requestUri":"/list-test-recommendations","responseCode":200},"input":{"type":"structure","required":["assessmentArn"],"members":{"assessmentArn":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["testRecommendations"],"members":{"nextToken":{},"testRecommendations":{"type":"list","member":{"type":"structure","required":["referenceId"],"members":{"appComponentName":{},"description":{},"intent":{},"items":{"shape":"S2k"},"name":{},"prerequisite":{},"recommendationId":{},"referenceId":{},"risk":{},"type":{}}}}}}},"ListUnsupportedAppVersionResources":{"http":{"requestUri":"/list-unsupported-app-version-resources","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion"],"members":{"appArn":{},"appVersion":{},"maxResults":{"type":"integer"},"nextToken":{},"resolutionId":{}}},"output":{"type":"structure","required":["resolutionId","unsupportedResources"],"members":{"nextToken":{},"resolutionId":{},"unsupportedResources":{"type":"list","member":{"type":"structure","required":["logicalResourceId","physicalResourceId","resourceType"],"members":{"logicalResourceId":{"shape":"S3h"},"physicalResourceId":{"shape":"S8"},"resourceType":{}}}}}}},"PublishAppVersion":{"http":{"requestUri":"/publish-app-version","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{}}},"output":{"type":"structure","required":["appArn"],"members":{"appArn":{},"appVersion":{}}}},"PutDraftAppVersionTemplate":{"http":{"requestUri":"/put-draft-app-version-template","responseCode":200},"input":{"type":"structure","required":["appArn","appTemplateBody"],"members":{"appArn":{},"appTemplateBody":{}}},"output":{"type":"structure","members":{"appArn":{},"appVersion":{}}}},"RemoveDraftAppVersionResourceMappings":{"http":{"requestUri":"/remove-draft-app-version-resource-mappings","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{},"appRegistryAppNames":{"shape":"S4m"},"logicalStackNames":{"type":"list","member":{}},"resourceGroupNames":{"shape":"S4m"},"resourceNames":{"shape":"S4m"}}},"output":{"type":"structure","members":{"appArn":{},"appVersion":{}}}},"ResolveAppVersionResources":{"http":{"requestUri":"/resolve-app-version-resources","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion"],"members":{"appArn":{},"appVersion":{}}},"output":{"type":"structure","required":["appArn","appVersion","resolutionId","status"],"members":{"appArn":{},"appVersion":{},"resolutionId":{},"status":{}}}},"StartAppAssessment":{"http":{"requestUri":"/start-app-assessment","responseCode":200},"input":{"type":"structure","required":["appArn","appVersion","assessmentName"],"members":{"appArn":{},"appVersion":{},"assessmentName":{},"clientToken":{"idempotencyToken":true},"tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["assessment"],"members":{"assessment":{"shape":"S1p"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{},"sensitive":true}}},"output":{"type":"structure","members":{}}},"UpdateApp":{"http":{"requestUri":"/update-app","responseCode":200},"input":{"type":"structure","required":["appArn"],"members":{"appArn":{},"clearResiliencyPolicyArn":{"type":"boolean"},"description":{},"policyArn":{}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sl"}}}},"UpdateResiliencyPolicy":{"http":{"requestUri":"/update-resiliency-policy","responseCode":200},"input":{"type":"structure","required":["policyArn"],"members":{"dataLocationConstraint":{},"policy":{"shape":"S14"},"policyArn":{},"policyDescription":{},"policyName":{},"tier":{}}},"output":{"type":"structure","required":["policy"],"members":{"policy":{"shape":"S1a"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["mappingType","physicalResourceId"],"members":{"appRegistryAppName":{},"logicalStackName":{},"mappingType":{},"physicalResourceId":{"shape":"S8"},"resourceGroupName":{},"resourceName":{}}}},"S8":{"type":"structure","required":["identifier","type"],"members":{"awsAccountId":{},"awsRegion":{},"identifier":{},"type":{}}},"Sh":{"type":"map","key":{},"value":{},"sensitive":true},"Sl":{"type":"structure","required":["appArn","creationTime","name"],"members":{"appArn":{},"complianceStatus":{},"creationTime":{"type":"timestamp"},"description":{},"lastAppComplianceEvaluationTime":{"type":"timestamp"},"lastResiliencyScoreEvaluationTime":{"type":"timestamp"},"name":{},"policyArn":{},"resiliencyScore":{"type":"double"},"status":{},"tags":{"shape":"Sh"}}},"Ss":{"type":"list","member":{}},"Su":{"type":"list","member":{}},"Sx":{"type":"structure","required":["assessmentArn","format","name","recommendationTemplateArn","recommendationTypes","status"],"members":{"appArn":{},"assessmentArn":{},"endTime":{"type":"timestamp"},"format":{},"message":{},"name":{},"needsReplacements":{"type":"boolean"},"recommendationIds":{"shape":"Ss"},"recommendationTemplateArn":{},"recommendationTypes":{"shape":"Su"},"startTime":{"type":"timestamp"},"status":{},"tags":{"shape":"Sh"},"templatesLocation":{"type":"structure","members":{"bucket":{},"prefix":{}}}}},"S14":{"type":"map","key":{},"value":{"type":"structure","required":["rpoInSecs","rtoInSecs"],"members":{"rpoInSecs":{"type":"integer"},"rtoInSecs":{"type":"integer"}}}},"S1a":{"type":"structure","members":{"creationTime":{"type":"timestamp"},"dataLocationConstraint":{},"estimatedCostTier":{},"policy":{"shape":"S14"},"policyArn":{},"policyDescription":{},"policyName":{},"tags":{"shape":"Sh"},"tier":{}}},"S1p":{"type":"structure","required":["assessmentArn","assessmentStatus","invoker"],"members":{"appArn":{},"appVersion":{},"assessmentArn":{},"assessmentName":{},"assessmentStatus":{},"compliance":{"shape":"S1q"},"complianceStatus":{},"cost":{"shape":"S1t"},"endTime":{"type":"timestamp"},"invoker":{},"message":{},"policy":{"shape":"S1a"},"resiliencyScore":{"shape":"S1x"},"startTime":{"type":"timestamp"},"tags":{"shape":"Sh"}}},"S1q":{"type":"map","key":{},"value":{"type":"structure","required":["complianceStatus"],"members":{"achievableRpoInSecs":{"type":"integer"},"achievableRtoInSecs":{"type":"integer"},"complianceStatus":{},"currentRpoInSecs":{"type":"integer"},"currentRtoInSecs":{"type":"integer"},"message":{},"rpoDescription":{},"rpoReferenceId":{},"rtoDescription":{},"rtoReferenceId":{}}}},"S1t":{"type":"structure","required":["amount","currency","frequency"],"members":{"amount":{"type":"double"},"currency":{},"frequency":{}}},"S1x":{"type":"structure","required":["disruptionScore","score"],"members":{"disruptionScore":{"type":"map","key":{},"value":{"type":"double"}},"score":{"type":"double"}}},"S2b":{"type":"list","member":{}},"S2k":{"type":"list","member":{"type":"structure","members":{"alreadyImplemented":{"type":"boolean"},"resourceId":{},"targetAccountId":{},"targetRegion":{}}}},"S3h":{"type":"structure","required":["identifier"],"members":{"identifier":{},"logicalStackName":{},"resourceGroupName":{}}},"S3w":{"type":"list","member":{"shape":"S1a"}},"S4m":{"type":"list","member":{}}}}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAlarmRecommendations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAppAssessments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAppComponentCompliances":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAppComponentRecommendations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAppVersionResourceMappings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAppVersionResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAppVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListApps":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRecommendationTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListResiliencyPolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSopRecommendations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSuggestedResiliencyPolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListTestRecommendations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListUnsupportedAppVersionResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['migrationhubstrategy'] = {};
	AWS.MigrationHubStrategy = Service.defineService('migrationhubstrategy', ['2020-02-19']);
	Object.defineProperty(apiLoader.services['migrationhubstrategy'], '2020-02-19', {
	  get: function get() {
	    var model = __webpack_require__(1087);
	    model.paginators = __webpack_require__(1088).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MigrationHubStrategy;


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-02-19","endpointPrefix":"migrationhub-strategy","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Migration Hub Strategy Recommendations","serviceId":"MigrationHubStrategy","signatureVersion":"v4","signingName":"migrationhub-strategy","uid":"migrationhubstrategy-2020-02-19"},"operations":{"GetApplicationComponentDetails":{"http":{"method":"GET","requestUri":"/get-applicationcomponent-details/{applicationComponentId}","responseCode":200},"input":{"type":"structure","required":["applicationComponentId"],"members":{"applicationComponentId":{"location":"uri","locationName":"applicationComponentId"}}},"output":{"type":"structure","members":{"applicationComponentDetail":{"shape":"S4"},"associatedApplications":{"shape":"Sy"},"associatedServerIds":{"type":"list","member":{}},"moreApplicationResource":{"type":"boolean"}}}},"GetApplicationComponentStrategies":{"http":{"method":"GET","requestUri":"/get-applicationcomponent-strategies/{applicationComponentId}","responseCode":200},"input":{"type":"structure","required":["applicationComponentId"],"members":{"applicationComponentId":{"location":"uri","locationName":"applicationComponentId"}}},"output":{"type":"structure","members":{"applicationComponentStrategies":{"type":"list","member":{"type":"structure","members":{"isPreferred":{"type":"boolean"},"recommendation":{"shape":"So"},"status":{}}}}}}},"GetAssessment":{"http":{"method":"GET","requestUri":"/get-assessment/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"dataCollectionDetails":{"type":"structure","members":{"completionTime":{"type":"timestamp"},"failed":{"type":"integer"},"inProgress":{"type":"integer"},"servers":{"type":"integer"},"startTime":{"type":"timestamp"},"status":{},"success":{"type":"integer"}}},"id":{}}}},"GetImportFileTask":{"http":{"method":"GET","requestUri":"/get-import-file-task/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"completionTime":{"type":"timestamp"},"id":{},"importName":{},"inputS3Bucket":{},"inputS3Key":{},"numberOfRecordsFailed":{"type":"integer"},"numberOfRecordsSuccess":{"type":"integer"},"startTime":{"type":"timestamp"},"status":{},"statusReportS3Bucket":{},"statusReportS3Key":{}}}},"GetPortfolioPreferences":{"http":{"method":"GET","requestUri":"/get-portfolio-preferences","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"applicationPreferences":{"shape":"S1i"},"databasePreferences":{"shape":"S1t"},"prioritizeBusinessGoals":{"shape":"S25"}}}},"GetPortfolioSummary":{"http":{"method":"GET","requestUri":"/get-portfolio-summary","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"assessmentSummary":{"type":"structure","members":{"antipatternReportS3Object":{"shape":"S6"},"antipatternReportStatus":{},"antipatternReportStatusMessage":{},"lastAnalyzedTimestamp":{"type":"timestamp"},"listAntipatternSeveritySummary":{"shape":"Si"},"listApplicationComponentStrategySummary":{"shape":"S2b"},"listApplicationComponentSummary":{"type":"list","member":{"type":"structure","members":{"appType":{},"count":{"type":"integer"}}}},"listServerStrategySummary":{"shape":"S2b"},"listServerSummary":{"type":"list","member":{"type":"structure","members":{"ServerOsType":{},"count":{"type":"integer"}}}}}}}}},"GetRecommendationReportDetails":{"http":{"method":"GET","requestUri":"/get-recommendation-report-details/{id}","responseCode":200},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"id":{},"recommendationReportDetails":{"type":"structure","members":{"completionTime":{"type":"timestamp"},"s3Bucket":{},"s3Keys":{"type":"list","member":{}},"startTime":{"type":"timestamp"},"status":{},"statusMessage":{}}}}}},"GetServerDetails":{"http":{"method":"GET","requestUri":"/get-server-details/{serverId}","responseCode":200},"input":{"type":"structure","required":["serverId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"serverId":{"location":"uri","locationName":"serverId"}}},"output":{"type":"structure","members":{"associatedApplications":{"shape":"Sy"},"nextToken":{},"serverDetail":{"shape":"S2u"}}}},"GetServerStrategies":{"http":{"method":"GET","requestUri":"/get-server-strategies/{serverId}","responseCode":200},"input":{"type":"structure","required":["serverId"],"members":{"serverId":{"location":"uri","locationName":"serverId"}}},"output":{"type":"structure","members":{"serverStrategies":{"type":"list","member":{"type":"structure","members":{"isPreferred":{"type":"boolean"},"numberOfApplicationComponents":{"type":"integer"},"recommendation":{"shape":"So"},"status":{}}}}}}},"ListApplicationComponents":{"http":{"requestUri":"/list-applicationcomponents","responseCode":200},"input":{"type":"structure","members":{"applicationComponentCriteria":{},"filterValue":{},"groupIdFilter":{"shape":"S3d"},"maxResults":{"type":"integer"},"nextToken":{},"sort":{}}},"output":{"type":"structure","members":{"applicationComponentInfos":{"type":"list","member":{"shape":"S4"}},"nextToken":{}}}},"ListCollectors":{"http":{"method":"GET","requestUri":"/list-collectors","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Collectors":{"type":"list","member":{"type":"structure","members":{"collectorHealth":{},"collectorId":{},"collectorVersion":{},"hostName":{},"ipAddress":{},"lastActivityTimeStamp":{},"registeredTimeStamp":{}}}},"nextToken":{}}}},"ListImportFileTask":{"http":{"method":"GET","requestUri":"/list-import-file-task","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"taskInfos":{"type":"list","member":{"type":"structure","members":{"completionTime":{"type":"timestamp"},"id":{},"importName":{},"inputS3Bucket":{},"inputS3Key":{},"numberOfRecordsFailed":{"type":"integer"},"numberOfRecordsSuccess":{"type":"integer"},"startTime":{"type":"timestamp"},"status":{},"statusReportS3Bucket":{},"statusReportS3Key":{}}}}}}},"ListServers":{"http":{"requestUri":"/list-servers","responseCode":200},"input":{"type":"structure","members":{"filterValue":{},"groupIdFilter":{"shape":"S3d"},"maxResults":{"type":"integer"},"nextToken":{},"serverCriteria":{},"sort":{}}},"output":{"type":"structure","members":{"nextToken":{},"serverInfos":{"type":"list","member":{"shape":"S2u"}}}}},"PutPortfolioPreferences":{"http":{"requestUri":"/put-portfolio-preferences","responseCode":200},"input":{"type":"structure","members":{"applicationPreferences":{"shape":"S1i"},"databasePreferences":{"shape":"S1t"},"prioritizeBusinessGoals":{"shape":"S25"}}},"output":{"type":"structure","members":{}}},"StartAssessment":{"http":{"requestUri":"/start-assessment","responseCode":200},"input":{"type":"structure","members":{"s3bucketForAnalysisData":{},"s3bucketForReportData":{}}},"output":{"type":"structure","members":{"assessmentId":{}}}},"StartImportFileTask":{"http":{"requestUri":"/start-import-file-task","responseCode":200},"input":{"type":"structure","required":["S3Bucket","name","s3key"],"members":{"S3Bucket":{},"dataSourceType":{},"groupId":{"shape":"S3d"},"name":{},"s3bucketForReportData":{},"s3key":{}}},"output":{"type":"structure","members":{"id":{}}}},"StartRecommendationReportGeneration":{"http":{"requestUri":"/start-recommendation-report-generation","responseCode":200},"input":{"type":"structure","members":{"groupIdFilter":{"shape":"S3d"},"outputFormat":{}}},"output":{"type":"structure","members":{"id":{}}}},"StopAssessment":{"http":{"requestUri":"/stop-assessment","responseCode":200},"input":{"type":"structure","required":["assessmentId"],"members":{"assessmentId":{}}},"output":{"type":"structure","members":{}}},"UpdateApplicationComponentConfig":{"http":{"requestUri":"/update-applicationcomponent-config/","responseCode":200},"input":{"type":"structure","required":["applicationComponentId"],"members":{"applicationComponentId":{},"inclusionStatus":{},"secretsManagerKey":{"type":"string","sensitive":true},"sourceCodeList":{"type":"list","member":{"type":"structure","members":{"location":{},"sourceVersion":{},"versionControl":{}}}},"strategyOption":{"shape":"S4j"}}},"output":{"type":"structure","members":{}}},"UpdateServerConfig":{"http":{"requestUri":"/update-server-config/","responseCode":200},"input":{"type":"structure","required":["serverId"],"members":{"serverId":{},"strategyOption":{"shape":"S4j"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","members":{"analysisStatus":{},"antipatternReportS3Object":{"shape":"S6"},"antipatternReportStatus":{},"antipatternReportStatusMessage":{},"appType":{},"associatedServerId":{},"databaseConfigDetail":{"type":"structure","members":{"secretName":{}}},"id":{},"inclusionStatus":{},"lastAnalyzedTimestamp":{"type":"timestamp"},"listAntipatternSeveritySummary":{"shape":"Si"},"moreServerAssociationExists":{"type":"boolean"},"name":{},"osDriver":{},"osVersion":{},"recommendationSet":{"shape":"So"},"resourceSubType":{},"sourceCodeRepositories":{"type":"list","member":{"type":"structure","members":{"branch":{},"repository":{},"versionControlType":{}}}},"statusMessage":{}}},"S6":{"type":"structure","members":{"s3Bucket":{},"s3key":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"count":{"type":"integer"},"severity":{}}}},"So":{"type":"structure","members":{"strategy":{},"targetDestination":{},"transformationTool":{"type":"structure","members":{"description":{},"name":{},"tranformationToolInstallationLink":{}}}}},"Sy":{"type":"list","member":{"type":"structure","members":{"id":{},"name":{}}}},"S1i":{"type":"structure","members":{"managementPreference":{"type":"structure","members":{"awsManagedResources":{"type":"structure","required":["targetDestination"],"members":{"targetDestination":{"type":"list","member":{}}}},"noPreference":{"type":"structure","required":["targetDestination"],"members":{"targetDestination":{"type":"list","member":{}}}},"selfManageResources":{"type":"structure","required":["targetDestination"],"members":{"targetDestination":{"type":"list","member":{}}}}},"union":true}}},"S1t":{"type":"structure","members":{"databaseManagementPreference":{},"databaseMigrationPreference":{"type":"structure","members":{"heterogeneous":{"type":"structure","required":["targetDatabaseEngine"],"members":{"targetDatabaseEngine":{"type":"list","member":{}}}},"homogeneous":{"type":"structure","members":{"targetDatabaseEngine":{"type":"list","member":{}}}},"noPreference":{"type":"structure","required":["targetDatabaseEngine"],"members":{"targetDatabaseEngine":{"type":"list","member":{}}}}},"union":true}}},"S25":{"type":"structure","members":{"businessGoals":{"type":"structure","members":{"licenseCostReduction":{"type":"integer"},"modernizeInfrastructureWithCloudNativeTechnologies":{"type":"integer"},"reduceOperationalOverheadWithManagedServices":{"type":"integer"},"speedOfMigration":{"type":"integer"}}}}},"S2b":{"type":"list","member":{"type":"structure","members":{"count":{"type":"integer"},"strategy":{}}}},"S2u":{"type":"structure","members":{"antipatternReportS3Object":{"shape":"S6"},"antipatternReportStatus":{},"antipatternReportStatusMessage":{},"applicationComponentStrategySummary":{"shape":"S2b"},"dataCollectionStatus":{},"id":{},"lastAnalyzedTimestamp":{"type":"timestamp"},"listAntipatternSeveritySummary":{"shape":"Si"},"name":{},"recommendationSet":{"shape":"So"},"serverType":{},"statusMessage":{},"systemInfo":{"type":"structure","members":{"cpuArchitecture":{},"fileSystemType":{},"networkInfoList":{"type":"list","member":{"type":"structure","required":["interfaceName","ipAddress","macAddress","netMask"],"members":{"interfaceName":{},"ipAddress":{},"macAddress":{},"netMask":{}}}},"osInfo":{"type":"structure","members":{"type":{},"version":{}}}}}}},"S3d":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"S4j":{"type":"structure","members":{"isPreferred":{"type":"boolean"},"strategy":{},"targetDestination":{},"toolName":{}}}}}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetServerDetails":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"associatedApplications"},"ListApplicationComponents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"applicationComponentInfos"},"ListCollectors":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"Collectors"},"ListImportFileTask":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"taskInfos"},"ListServers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"serverInfos"}}}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['appconfigdata'] = {};
	AWS.AppConfigData = Service.defineService('appconfigdata', ['2021-11-11']);
	Object.defineProperty(apiLoader.services['appconfigdata'], '2021-11-11', {
	  get: function get() {
	    var model = __webpack_require__(1090);
	    model.paginators = __webpack_require__(1091).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AppConfigData;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-11-11","endpointPrefix":"appconfigdata","jsonVersion":"1.0","protocol":"rest-json","serviceFullName":"AWS AppConfig Data","serviceId":"AppConfigData","signatureVersion":"v4","signingName":"appconfig","uid":"appconfigdata-2021-11-11"},"operations":{"GetLatestConfiguration":{"http":{"method":"GET","requestUri":"/configuration","responseCode":200},"input":{"type":"structure","required":["ConfigurationToken"],"members":{"ConfigurationToken":{"location":"querystring","locationName":"configuration_token"}}},"output":{"type":"structure","members":{"NextPollConfigurationToken":{"location":"header","locationName":"Next-Poll-Configuration-Token"},"NextPollIntervalInSeconds":{"location":"header","locationName":"Next-Poll-Interval-In-Seconds","type":"integer"},"ContentType":{"location":"header","locationName":"Content-Type"},"Configuration":{"type":"blob","sensitive":true}},"payload":"Configuration"}},"StartConfigurationSession":{"http":{"requestUri":"/configurationsessions","responseCode":201},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier","ConfigurationProfileIdentifier"],"members":{"ApplicationIdentifier":{},"EnvironmentIdentifier":{},"ConfigurationProfileIdentifier":{},"RequiredMinimumPollIntervalInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"InitialConfigurationToken":{}}}}},"shapes":{}}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{}}

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['drs'] = {};
	AWS.Drs = Service.defineService('drs', ['2020-02-26']);
	Object.defineProperty(apiLoader.services['drs'], '2020-02-26', {
	  get: function get() {
	    var model = __webpack_require__(1093);
	    model.paginators = __webpack_require__(1094).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Drs;


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-02-26","endpointPrefix":"drs","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"drs","serviceFullName":"Elastic Disaster Recovery Service","serviceId":"drs","signatureVersion":"v4","signingName":"drs","uid":"drs-2020-02-26"},"operations":{"CreateReplicationConfigurationTemplate":{"http":{"requestUri":"/CreateReplicationConfigurationTemplate","responseCode":201},"input":{"type":"structure","required":["associateDefaultSecurityGroup","bandwidthThrottling","createPublicIP","dataPlaneRouting","defaultLargeStagingDiskType","ebsEncryption","pitPolicy","replicationServerInstanceType","replicationServersSecurityGroupsIDs","stagingAreaSubnetId","stagingAreaTags","useDedicatedReplicationServer"],"members":{"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"pitPolicy":{"shape":"S8"},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"Sd"},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"Sg"},"tags":{"shape":"Sg"},"useDedicatedReplicationServer":{"type":"boolean"}}},"output":{"shape":"Sj"}},"DeleteJob":{"http":{"requestUri":"/DeleteJob","responseCode":204},"input":{"type":"structure","required":["jobID"],"members":{"jobID":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteRecoveryInstance":{"http":{"requestUri":"/DeleteRecoveryInstance","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceID"],"members":{"recoveryInstanceID":{}}}},"DeleteReplicationConfigurationTemplate":{"http":{"requestUri":"/DeleteReplicationConfigurationTemplate","responseCode":204},"input":{"type":"structure","required":["replicationConfigurationTemplateID"],"members":{"replicationConfigurationTemplateID":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteSourceServer":{"http":{"requestUri":"/DeleteSourceServer","responseCode":204},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeJobLogItems":{"http":{"requestUri":"/DescribeJobLogItems","responseCode":200},"input":{"type":"structure","required":["jobID"],"members":{"jobID":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"type":"structure","members":{"event":{},"eventData":{"type":"structure","members":{"conversionServerID":{},"rawError":{},"sourceServerID":{},"targetInstanceID":{}}},"logDateTime":{}}}},"nextToken":{}}}},"DescribeJobs":{"http":{"requestUri":"/DescribeJobs","responseCode":200},"input":{"type":"structure","required":["filters"],"members":{"filters":{"type":"structure","members":{"fromDate":{},"jobIDs":{"type":"list","member":{}},"toDate":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"shape":"S1a"}},"nextToken":{}}}},"DescribeRecoveryInstances":{"http":{"requestUri":"/DescribeRecoveryInstances","responseCode":200},"input":{"type":"structure","required":["filters"],"members":{"filters":{"type":"structure","members":{"recoveryInstanceIDs":{"type":"list","member":{}},"sourceServerIDs":{"type":"list","member":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"type":"structure","members":{"arn":{},"dataReplicationInfo":{"type":"structure","members":{"dataReplicationError":{"type":"structure","members":{"error":{},"rawError":{}}},"dataReplicationInitiation":{"type":"structure","members":{"startDateTime":{},"steps":{"type":"list","member":{"type":"structure","members":{"name":{},"status":{}}}}}},"dataReplicationState":{},"etaDateTime":{},"lagDuration":{},"replicatedDisks":{"type":"list","member":{"type":"structure","members":{"backloggedStorageBytes":{"type":"long"},"deviceName":{},"replicatedStorageBytes":{"type":"long"},"rescannedStorageBytes":{"type":"long"},"totalStorageBytes":{"type":"long"}}}}}},"ec2InstanceID":{},"ec2InstanceState":{},"failback":{"type":"structure","members":{"agentLastSeenByServiceDateTime":{},"elapsedReplicationDuration":{},"failbackClientID":{},"failbackClientLastSeenByServiceDateTime":{},"failbackInitiationTime":{},"failbackJobID":{},"failbackToOriginalServer":{"type":"boolean"},"firstByteDateTime":{},"state":{}}},"isDrill":{"type":"boolean"},"jobID":{},"pointInTimeSnapshotDateTime":{},"recoveryInstanceID":{},"recoveryInstanceProperties":{"type":"structure","members":{"cpus":{"shape":"S24"},"disks":{"type":"list","member":{"type":"structure","members":{"bytes":{"type":"long"},"ebsVolumeID":{},"internalDeviceName":{}}}},"identificationHints":{"shape":"S29"},"lastUpdatedDateTime":{},"networkInterfaces":{"shape":"S2a"},"os":{"shape":"S2d"},"ramBytes":{"type":"long"}}},"sourceServerID":{},"tags":{"shape":"Sg"}}}},"nextToken":{}}}},"DescribeRecoverySnapshots":{"http":{"requestUri":"/DescribeRecoverySnapshots","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"filters":{"type":"structure","members":{"fromDateTime":{},"toDateTime":{}}},"maxResults":{"type":"integer"},"nextToken":{},"order":{},"sourceServerID":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"type":"structure","required":["expectedTimestamp","snapshotID","sourceServerID"],"members":{"ebsSnapshots":{"type":"list","member":{}},"expectedTimestamp":{},"snapshotID":{},"sourceServerID":{},"timestamp":{}}}},"nextToken":{}}}},"DescribeReplicationConfigurationTemplates":{"http":{"requestUri":"/DescribeReplicationConfigurationTemplates","responseCode":200},"input":{"type":"structure","required":["replicationConfigurationTemplateIDs"],"members":{"maxResults":{"type":"integer"},"nextToken":{},"replicationConfigurationTemplateIDs":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"shape":"Sj"}},"nextToken":{}}}},"DescribeSourceServers":{"http":{"requestUri":"/DescribeSourceServers","responseCode":200},"input":{"type":"structure","required":["filters"],"members":{"filters":{"type":"structure","members":{"hardwareId":{},"sourceServerIDs":{"type":"list","member":{}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"items":{"type":"list","member":{"shape":"S2w"}},"nextToken":{}}}},"DisconnectRecoveryInstance":{"http":{"requestUri":"/DisconnectRecoveryInstance","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceID"],"members":{"recoveryInstanceID":{}}}},"DisconnectSourceServer":{"http":{"requestUri":"/DisconnectSourceServer","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S2w"}},"GetFailbackReplicationConfiguration":{"http":{"requestUri":"/GetFailbackReplicationConfiguration","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceID"],"members":{"recoveryInstanceID":{}}},"output":{"type":"structure","required":["recoveryInstanceID"],"members":{"bandwidthThrottling":{"type":"long"},"name":{},"recoveryInstanceID":{},"usePrivateIP":{"type":"boolean"}}}},"GetLaunchConfiguration":{"http":{"requestUri":"/GetLaunchConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S3l"}},"GetReplicationConfiguration":{"http":{"requestUri":"/GetReplicationConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S3r"}},"InitializeService":{"http":{"requestUri":"/InitializeService","responseCode":204},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sg"}}}},"RetryDataReplication":{"http":{"requestUri":"/RetryDataReplication","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"sourceServerID":{}}},"output":{"shape":"S2w"}},"StartFailbackLaunch":{"http":{"requestUri":"/StartFailbackLaunch","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceIDs"],"members":{"recoveryInstanceIDs":{"type":"list","member":{}},"tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{"job":{"shape":"S1a"}}}},"StartRecovery":{"http":{"requestUri":"/StartRecovery","responseCode":202},"input":{"type":"structure","required":["sourceServers"],"members":{"isDrill":{"type":"boolean"},"sourceServers":{"type":"list","member":{"type":"structure","required":["sourceServerID"],"members":{"recoverySnapshotID":{},"sourceServerID":{}}}},"tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{"job":{"shape":"S1a"}}}},"StopFailback":{"http":{"requestUri":"/StopFailback","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceID"],"members":{"recoveryInstanceID":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sg"}}},"idempotent":true},"TerminateRecoveryInstances":{"http":{"requestUri":"/TerminateRecoveryInstances","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceIDs"],"members":{"recoveryInstanceIDs":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"job":{"shape":"S1a"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{},"sensitive":true}}},"idempotent":true},"UpdateFailbackReplicationConfiguration":{"http":{"requestUri":"/UpdateFailbackReplicationConfiguration","responseCode":200},"input":{"type":"structure","required":["recoveryInstanceID"],"members":{"bandwidthThrottling":{"type":"long"},"name":{},"recoveryInstanceID":{},"usePrivateIP":{"type":"boolean"}}}},"UpdateLaunchConfiguration":{"http":{"requestUri":"/UpdateLaunchConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"copyPrivateIp":{"type":"boolean"},"copyTags":{"type":"boolean"},"launchDisposition":{},"licensing":{"shape":"S3n"},"name":{},"sourceServerID":{},"targetInstanceTypeRightSizingMethod":{}}},"output":{"shape":"S3l"},"idempotent":true},"UpdateReplicationConfiguration":{"http":{"requestUri":"/UpdateReplicationConfiguration","responseCode":200},"input":{"type":"structure","required":["sourceServerID"],"members":{"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"name":{},"pitPolicy":{"shape":"S8"},"replicatedDisks":{"shape":"S3s"},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"Sd"},"sourceServerID":{},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"Sg"},"useDedicatedReplicationServer":{"type":"boolean"}}},"output":{"shape":"S3r"},"idempotent":true},"UpdateReplicationConfigurationTemplate":{"http":{"requestUri":"/UpdateReplicationConfigurationTemplate","responseCode":200},"input":{"type":"structure","required":["replicationConfigurationTemplateID"],"members":{"arn":{},"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"pitPolicy":{"shape":"S8"},"replicationConfigurationTemplateID":{},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"Sd"},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"Sg"},"useDedicatedReplicationServer":{"type":"boolean"}}},"output":{"shape":"Sj"}}},"shapes":{"S8":{"type":"list","member":{"type":"structure","required":["interval","retentionDuration","units"],"members":{"enabled":{"type":"boolean"},"interval":{"type":"integer"},"retentionDuration":{"type":"integer"},"ruleID":{"type":"long"},"units":{}}}},"Sd":{"type":"list","member":{}},"Sg":{"type":"map","key":{},"value":{},"sensitive":true},"Sj":{"type":"structure","required":["replicationConfigurationTemplateID"],"members":{"arn":{},"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"pitPolicy":{"shape":"S8"},"replicationConfigurationTemplateID":{},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"Sd"},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"Sg"},"tags":{"shape":"Sg"},"useDedicatedReplicationServer":{"type":"boolean"}}},"S1a":{"type":"structure","required":["jobID"],"members":{"arn":{},"creationDateTime":{},"endDateTime":{},"initiatedBy":{},"jobID":{},"participatingServers":{"type":"list","member":{"type":"structure","members":{"launchStatus":{},"recoveryInstanceID":{},"sourceServerID":{}}}},"status":{},"tags":{"shape":"Sg"},"type":{}}},"S24":{"type":"list","member":{"type":"structure","members":{"cores":{"type":"long"},"modelName":{}}}},"S29":{"type":"structure","members":{"awsInstanceID":{},"fqdn":{},"hostname":{},"vmWareUuid":{}}},"S2a":{"type":"list","member":{"type":"structure","members":{"ips":{"type":"list","member":{}},"isPrimary":{"type":"boolean"},"macAddress":{}}}},"S2d":{"type":"structure","members":{"fullString":{}}},"S2w":{"type":"structure","members":{"arn":{},"dataReplicationInfo":{"type":"structure","members":{"dataReplicationError":{"type":"structure","members":{"error":{},"rawError":{}}},"dataReplicationInitiation":{"type":"structure","members":{"nextAttemptDateTime":{},"startDateTime":{},"steps":{"type":"list","member":{"type":"structure","members":{"name":{},"status":{}}}}}},"dataReplicationState":{},"etaDateTime":{},"lagDuration":{},"replicatedDisks":{"type":"list","member":{"type":"structure","members":{"backloggedStorageBytes":{"type":"long"},"deviceName":{},"replicatedStorageBytes":{"type":"long"},"rescannedStorageBytes":{"type":"long"},"totalStorageBytes":{"type":"long"}}}}}},"lastLaunchResult":{},"lifeCycle":{"type":"structure","members":{"addedToServiceDateTime":{},"elapsedReplicationDuration":{},"firstByteDateTime":{},"lastLaunch":{"type":"structure","members":{"initiated":{"type":"structure","members":{"apiCallDateTime":{},"jobID":{},"type":{}}}}},"lastSeenByServiceDateTime":{}}},"recoveryInstanceId":{},"sourceProperties":{"type":"structure","members":{"cpus":{"shape":"S24"},"disks":{"type":"list","member":{"type":"structure","members":{"bytes":{"type":"long"},"deviceName":{}}}},"identificationHints":{"shape":"S29"},"lastUpdatedDateTime":{},"networkInterfaces":{"shape":"S2a"},"os":{"shape":"S2d"},"ramBytes":{"type":"long"},"recommendedInstanceType":{}}},"sourceServerID":{},"tags":{"shape":"Sg"}}},"S3l":{"type":"structure","members":{"copyPrivateIp":{"type":"boolean"},"copyTags":{"type":"boolean"},"ec2LaunchTemplateID":{},"launchDisposition":{},"licensing":{"shape":"S3n"},"name":{},"sourceServerID":{},"targetInstanceTypeRightSizingMethod":{}}},"S3n":{"type":"structure","members":{"osByol":{"type":"boolean"}}},"S3r":{"type":"structure","members":{"associateDefaultSecurityGroup":{"type":"boolean"},"bandwidthThrottling":{"type":"long"},"createPublicIP":{"type":"boolean"},"dataPlaneRouting":{},"defaultLargeStagingDiskType":{},"ebsEncryption":{},"ebsEncryptionKeyArn":{},"name":{},"pitPolicy":{"shape":"S8"},"replicatedDisks":{"shape":"S3s"},"replicationServerInstanceType":{},"replicationServersSecurityGroupsIDs":{"shape":"Sd"},"sourceServerID":{},"stagingAreaSubnetId":{},"stagingAreaTags":{"shape":"Sg"},"useDedicatedReplicationServer":{"type":"boolean"}}},"S3s":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"iops":{"type":"long"},"isBootDisk":{"type":"boolean"},"stagingDiskType":{},"throughput":{"type":"long"}}}}}}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeJobLogItems":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeRecoveryInstances":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeRecoverySnapshots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeReplicationConfigurationTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"},"DescribeSourceServers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"items"}}}

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['migrationhubrefactorspaces'] = {};
	AWS.MigrationHubRefactorSpaces = Service.defineService('migrationhubrefactorspaces', ['2021-10-26']);
	Object.defineProperty(apiLoader.services['migrationhubrefactorspaces'], '2021-10-26', {
	  get: function get() {
	    var model = __webpack_require__(1096);
	    model.paginators = __webpack_require__(1097).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.MigrationHubRefactorSpaces;


/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-10-26","endpointPrefix":"refactor-spaces","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Migration Hub Refactor Spaces","serviceId":"Migration Hub Refactor Spaces","signatureVersion":"v4","signingName":"refactor-spaces","uid":"migration-hub-refactor-spaces-2021-10-26"},"operations":{"CreateApplication":{"http":{"requestUri":"/environments/{EnvironmentIdentifier}/applications","responseCode":200},"input":{"type":"structure","required":["EnvironmentIdentifier","Name","ProxyType","VpcId"],"members":{"ApiGatewayProxy":{"shape":"S2"},"ClientToken":{"idempotencyToken":true},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"Name":{},"ProxyType":{},"Tags":{"shape":"S9"},"VpcId":{}}},"output":{"type":"structure","members":{"ApiGatewayProxy":{"shape":"S2"},"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"EnvironmentId":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"OwnerAccountId":{},"ProxyType":{},"State":{},"Tags":{"shape":"S9"},"VpcId":{}}}},"CreateEnvironment":{"http":{"requestUri":"/environments","responseCode":200},"input":{"type":"structure","required":["Name","NetworkFabricType"],"members":{"ClientToken":{"idempotencyToken":true},"Description":{},"Name":{},"NetworkFabricType":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"Arn":{},"CreatedTime":{"type":"timestamp"},"Description":{},"EnvironmentId":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"NetworkFabricType":{},"OwnerAccountId":{},"State":{},"Tags":{"shape":"S9"}}}},"CreateRoute":{"http":{"requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/routes","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier","RouteType","ServiceIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"ClientToken":{"idempotencyToken":true},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"RouteType":{},"ServiceIdentifier":{},"Tags":{"shape":"S9"},"UriPathRoute":{"shape":"Ss"}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"OwnerAccountId":{},"RouteId":{},"RouteType":{},"ServiceId":{},"State":{},"Tags":{"shape":"S9"},"UriPathRoute":{"shape":"Ss"}}}},"CreateService":{"http":{"requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/services","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EndpointType","EnvironmentIdentifier","Name"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"ClientToken":{"idempotencyToken":true},"Description":{},"EndpointType":{},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"LambdaEndpoint":{"shape":"S13"},"Name":{},"Tags":{"shape":"S9"},"UrlEndpoint":{"shape":"S16"},"VpcId":{}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"Description":{},"EndpointType":{},"EnvironmentId":{},"LambdaEndpoint":{"shape":"S13"},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"OwnerAccountId":{},"ServiceId":{},"State":{},"Tags":{"shape":"S9"},"UrlEndpoint":{"shape":"S16"},"VpcId":{}}}},"DeleteApplication":{"http":{"method":"DELETE","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"EnvironmentId":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"State":{}}},"idempotent":true},"DeleteEnvironment":{"http":{"method":"DELETE","requestUri":"/environments/{EnvironmentIdentifier}","responseCode":200},"input":{"type":"structure","required":["EnvironmentIdentifier"],"members":{"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"}}},"output":{"type":"structure","members":{"Arn":{},"EnvironmentId":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"State":{}}},"idempotent":true},"DeleteResourcePolicy":{"http":{"method":"DELETE","requestUri":"/resourcepolicy/{Identifier}","responseCode":200},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/routes/{RouteIdentifier}","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier","RouteIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"RouteIdentifier":{"location":"uri","locationName":"RouteIdentifier"}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"LastUpdatedTime":{"type":"timestamp"},"RouteId":{},"ServiceId":{},"State":{}}},"idempotent":true},"DeleteService":{"http":{"method":"DELETE","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/services/{ServiceIdentifier}","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier","ServiceIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"ServiceIdentifier":{"location":"uri","locationName":"ServiceIdentifier"}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"EnvironmentId":{},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"ServiceId":{},"State":{}}},"idempotent":true},"GetApplication":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"}}},"output":{"type":"structure","members":{"ApiGatewayProxy":{"type":"structure","members":{"ApiGatewayId":{},"EndpointType":{},"NlbArn":{},"NlbName":{},"ProxyUrl":{},"StageName":{},"VpcLinkId":{}}},"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"EnvironmentId":{},"Error":{"shape":"S1s"},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"OwnerAccountId":{},"ProxyType":{},"State":{},"Tags":{"shape":"S9"},"VpcId":{}}}},"GetEnvironment":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}","responseCode":200},"input":{"type":"structure","required":["EnvironmentIdentifier"],"members":{"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"}}},"output":{"type":"structure","members":{"Arn":{},"CreatedTime":{"type":"timestamp"},"Description":{},"EnvironmentId":{},"Error":{"shape":"S1s"},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"NetworkFabricType":{},"OwnerAccountId":{},"State":{},"Tags":{"shape":"S9"},"TransitGatewayId":{}}}},"GetResourcePolicy":{"http":{"method":"GET","requestUri":"/resourcepolicy/{Identifier}","responseCode":200},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"Identifier"}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRoute":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/routes/{RouteIdentifier}","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier","RouteIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"RouteIdentifier":{"location":"uri","locationName":"RouteIdentifier"}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"EnvironmentId":{},"Error":{"shape":"S1s"},"IncludeChildPaths":{"type":"boolean"},"LastUpdatedTime":{"type":"timestamp"},"Methods":{"shape":"Sv"},"OwnerAccountId":{},"PathResourceToId":{"shape":"S28"},"RouteId":{},"RouteType":{},"ServiceId":{},"SourcePath":{},"State":{},"Tags":{"shape":"S9"}}}},"GetService":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/services/{ServiceIdentifier}","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier","ServiceIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"ServiceIdentifier":{"location":"uri","locationName":"ServiceIdentifier"}}},"output":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"Description":{},"EndpointType":{},"EnvironmentId":{},"Error":{"shape":"S1s"},"LambdaEndpoint":{"type":"structure","members":{"Arn":{}}},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"OwnerAccountId":{},"ServiceId":{},"State":{},"Tags":{"shape":"S9"},"UrlEndpoint":{"type":"structure","members":{"HealthUrl":{},"Url":{}}},"VpcId":{}}}},"ListApplications":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/applications","responseCode":200},"input":{"type":"structure","required":["EnvironmentIdentifier"],"members":{"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ApplicationSummaryList":{"type":"list","member":{"type":"structure","members":{"ApiGatewayProxy":{"type":"structure","members":{"ApiGatewayId":{},"EndpointType":{},"NlbArn":{},"NlbName":{},"ProxyUrl":{},"StageName":{},"VpcLinkId":{}}},"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"EnvironmentId":{},"Error":{"shape":"S1s"},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"OwnerAccountId":{},"ProxyType":{},"State":{},"Tags":{"shape":"S9"},"VpcId":{}}}},"NextToken":{}}}},"ListEnvironmentVpcs":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/vpcs","responseCode":200},"input":{"type":"structure","required":["EnvironmentIdentifier"],"members":{"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"EnvironmentVpcList":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"CidrBlocks":{"type":"list","member":{}},"CreatedTime":{"type":"timestamp"},"EnvironmentId":{},"LastUpdatedTime":{"type":"timestamp"},"VpcId":{},"VpcName":{}}}},"NextToken":{}}}},"ListEnvironments":{"http":{"method":"GET","requestUri":"/environments","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"EnvironmentSummaryList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedTime":{"type":"timestamp"},"Description":{},"EnvironmentId":{},"Error":{"shape":"S1s"},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"NetworkFabricType":{},"OwnerAccountId":{},"State":{},"Tags":{"shape":"S9"},"TransitGatewayId":{}}}},"NextToken":{}}}},"ListRoutes":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/routes","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"RouteSummaryList":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"EnvironmentId":{},"Error":{"shape":"S1s"},"IncludeChildPaths":{"type":"boolean"},"LastUpdatedTime":{"type":"timestamp"},"Methods":{"shape":"Sv"},"OwnerAccountId":{},"PathResourceToId":{"shape":"S28"},"RouteId":{},"RouteType":{},"ServiceId":{},"SourcePath":{},"State":{},"Tags":{"shape":"S9"}}}}}}},"ListServices":{"http":{"method":"GET","requestUri":"/environments/{EnvironmentIdentifier}/applications/{ApplicationIdentifier}/services","responseCode":200},"input":{"type":"structure","required":["ApplicationIdentifier","EnvironmentIdentifier"],"members":{"ApplicationIdentifier":{"location":"uri","locationName":"ApplicationIdentifier"},"EnvironmentIdentifier":{"location":"uri","locationName":"EnvironmentIdentifier"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ServiceSummaryList":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreatedByAccountId":{},"CreatedTime":{"type":"timestamp"},"Description":{},"EndpointType":{},"EnvironmentId":{},"Error":{"shape":"S1s"},"LambdaEndpoint":{"type":"structure","members":{"Arn":{}}},"LastUpdatedTime":{"type":"timestamp"},"Name":{},"OwnerAccountId":{},"ServiceId":{},"State":{},"Tags":{"shape":"S9"},"UrlEndpoint":{"type":"structure","members":{"HealthUrl":{},"Url":{}}},"VpcId":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S9"}}}},"PutResourcePolicy":{"http":{"method":"PUT","requestUri":"/resourcepolicy","responseCode":200},"input":{"type":"structure","required":["Policy","ResourceArn"],"members":{"Policy":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{},"sensitive":true}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"S2":{"type":"structure","members":{"EndpointType":{},"StageName":{}}},"S9":{"type":"map","key":{},"value":{},"sensitive":true},"Ss":{"type":"structure","required":["ActivationState","SourcePath"],"members":{"ActivationState":{},"IncludeChildPaths":{"type":"boolean"},"Methods":{"shape":"Sv"},"SourcePath":{}}},"Sv":{"type":"list","member":{}},"S13":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"S16":{"type":"structure","required":["Url"],"members":{"HealthUrl":{},"Url":{}}},"S1s":{"type":"structure","members":{"AccountId":{},"AdditionalDetails":{"type":"map","key":{},"value":{}},"Code":{},"Message":{},"ResourceIdentifier":{},"ResourceType":{}}},"S28":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ApplicationSummaryList"},"ListEnvironmentVpcs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EnvironmentVpcList"},"ListEnvironments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EnvironmentSummaryList"},"ListRoutes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"RouteSummaryList"},"ListServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ServiceSummaryList"}}}

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['evidently'] = {};
	AWS.Evidently = Service.defineService('evidently', ['2021-02-01']);
	Object.defineProperty(apiLoader.services['evidently'], '2021-02-01', {
	  get: function get() {
	    var model = __webpack_require__(1099);
	    model.paginators = __webpack_require__(1100).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Evidently;


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-02-01","endpointPrefix":"evidently","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon CloudWatch Evidently","serviceId":"Evidently","signatureVersion":"v4","signingName":"evidently","uid":"evidently-2021-02-01"},"operations":{"BatchEvaluateFeature":{"http":{"requestUri":"/projects/{project}/evaluations","responseCode":200},"input":{"type":"structure","required":["project","requests"],"members":{"project":{"location":"uri","locationName":"project"},"requests":{"type":"list","member":{"type":"structure","required":["entityId","feature"],"members":{"entityId":{},"evaluationContext":{"jsonvalue":true},"feature":{}}}}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{"type":"structure","required":["entityId","feature"],"members":{"details":{"jsonvalue":true},"entityId":{},"feature":{},"project":{},"reason":{},"value":{"shape":"Sd"},"variation":{}}}}}},"endpoint":{"hostPrefix":"dataplane."}},"CreateExperiment":{"http":{"requestUri":"/projects/{project}/experiments","responseCode":200},"input":{"type":"structure","required":["metricGoals","name","project","treatments"],"members":{"description":{},"metricGoals":{"shape":"Sk"},"name":{},"onlineAbConfig":{"shape":"St"},"project":{"location":"uri","locationName":"project"},"randomizationSalt":{},"samplingRate":{"type":"long"},"tags":{"shape":"Sy"},"treatments":{"shape":"S11"}}},"output":{"type":"structure","required":["experiment"],"members":{"experiment":{"shape":"S15"}}},"idempotent":true},"CreateFeature":{"http":{"requestUri":"/projects/{project}/features","responseCode":200},"input":{"type":"structure","required":["name","project","variations"],"members":{"defaultVariation":{},"description":{},"entityOverrides":{"shape":"S1l"},"evaluationStrategy":{},"name":{},"project":{"location":"uri","locationName":"project"},"tags":{"shape":"Sy"},"variations":{"shape":"S1n"}}},"output":{"type":"structure","members":{"feature":{"shape":"S1q"}}}},"CreateLaunch":{"http":{"requestUri":"/projects/{project}/launches","responseCode":200},"input":{"type":"structure","required":["groups","name","project"],"members":{"description":{},"groups":{"shape":"S21"},"metricMonitors":{"shape":"S24"},"name":{},"project":{"location":"uri","locationName":"project"},"randomizationSalt":{},"scheduledSplitsConfig":{"shape":"S27"},"tags":{"shape":"Sy"}}},"output":{"type":"structure","required":["launch"],"members":{"launch":{"shape":"S2c"}}}},"CreateProject":{"http":{"requestUri":"/projects","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"dataDelivery":{"type":"structure","members":{"cloudWatchLogs":{"shape":"S2q"},"s3Destination":{"shape":"S2s"}}},"description":{},"name":{},"tags":{"shape":"Sy"}}},"output":{"type":"structure","required":["project"],"members":{"project":{"shape":"S2x"}}}},"DeleteExperiment":{"http":{"method":"DELETE","requestUri":"/projects/{project}/experiments/{experiment}","responseCode":200},"input":{"type":"structure","required":["experiment","project"],"members":{"experiment":{"location":"uri","locationName":"experiment"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteFeature":{"http":{"method":"DELETE","requestUri":"/projects/{project}/features/{feature}","responseCode":200},"input":{"type":"structure","required":["feature","project"],"members":{"feature":{"location":"uri","locationName":"feature"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteLaunch":{"http":{"method":"DELETE","requestUri":"/projects/{project}/launches/{launch}","responseCode":200},"input":{"type":"structure","required":["launch","project"],"members":{"launch":{"location":"uri","locationName":"launch"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{project}","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{}},"idempotent":true},"EvaluateFeature":{"http":{"requestUri":"/projects/{project}/evaluations/{feature}","responseCode":200},"input":{"type":"structure","required":["entityId","feature","project"],"members":{"entityId":{},"evaluationContext":{"jsonvalue":true},"feature":{"location":"uri","locationName":"feature"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{"details":{"jsonvalue":true},"reason":{},"value":{"shape":"Sd"},"variation":{}}},"endpoint":{"hostPrefix":"dataplane."}},"GetExperiment":{"http":{"method":"GET","requestUri":"/projects/{project}/experiments/{experiment}","responseCode":200},"input":{"type":"structure","required":["experiment","project"],"members":{"experiment":{"location":"uri","locationName":"experiment"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{"experiment":{"shape":"S15"}}}},"GetExperimentResults":{"http":{"requestUri":"/projects/{project}/experiments/{experiment}/results","responseCode":200},"input":{"type":"structure","required":["experiment","metricNames","project","treatmentNames"],"members":{"baseStat":{},"endTime":{"type":"timestamp"},"experiment":{"location":"uri","locationName":"experiment"},"metricNames":{"type":"list","member":{}},"period":{"type":"long"},"project":{"location":"uri","locationName":"project"},"reportNames":{"type":"list","member":{}},"resultStats":{"type":"list","member":{}},"startTime":{"type":"timestamp"},"treatmentNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"reports":{"type":"list","member":{"type":"structure","members":{"content":{"jsonvalue":true},"metricName":{},"reportName":{},"treatmentName":{}}}},"resultsData":{"type":"list","member":{"type":"structure","members":{"metricName":{},"resultStat":{},"treatmentName":{},"values":{"type":"list","member":{"type":"double"}}}}},"timestamps":{"type":"list","member":{"type":"timestamp"}}}}},"GetFeature":{"http":{"method":"GET","requestUri":"/projects/{project}/features/{feature}","responseCode":200},"input":{"type":"structure","required":["feature","project"],"members":{"feature":{"location":"uri","locationName":"feature"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","required":["feature"],"members":{"feature":{"shape":"S1q"}}}},"GetLaunch":{"http":{"method":"GET","requestUri":"/projects/{project}/launches/{launch}","responseCode":200},"input":{"type":"structure","required":["launch","project"],"members":{"launch":{"location":"uri","locationName":"launch"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{"launch":{"shape":"S2c"}}}},"GetProject":{"http":{"method":"GET","requestUri":"/projects/{project}","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","required":["project"],"members":{"project":{"shape":"S2x"}}}},"ListExperiments":{"http":{"method":"GET","requestUri":"/projects/{project}/experiments","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"project":{"location":"uri","locationName":"project"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"experiments":{"type":"list","member":{"shape":"S15"}},"nextToken":{}}}},"ListFeatures":{"http":{"method":"GET","requestUri":"/projects/{project}/features","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{"features":{"type":"list","member":{"type":"structure","required":["arn","createdTime","evaluationStrategy","lastUpdatedTime","name","status"],"members":{"arn":{},"createdTime":{"type":"timestamp"},"defaultVariation":{},"evaluationRules":{"shape":"S1s"},"evaluationStrategy":{},"lastUpdatedTime":{"type":"timestamp"},"name":{},"project":{},"status":{},"tags":{"shape":"Sy"}}}},"nextToken":{}}}},"ListLaunches":{"http":{"method":"GET","requestUri":"/projects/{project}/launches","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"project":{"location":"uri","locationName":"project"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"launches":{"type":"list","member":{"shape":"S2c"}},"nextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"type":"list","member":{"type":"structure","required":["arn","createdTime","lastUpdatedTime","name","status"],"members":{"activeExperimentCount":{"type":"long"},"activeLaunchCount":{"type":"long"},"arn":{},"createdTime":{"type":"timestamp"},"description":{},"experimentCount":{"type":"long"},"featureCount":{"type":"long"},"lastUpdatedTime":{"type":"timestamp"},"launchCount":{"type":"long"},"name":{},"status":{},"tags":{"shape":"Sy"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sy"}}}},"PutProjectEvents":{"http":{"requestUri":"/events/projects/{project}","responseCode":200},"input":{"type":"structure","required":["events","project"],"members":{"events":{"type":"list","member":{"type":"structure","required":["data","timestamp","type"],"members":{"data":{"jsonvalue":true},"timestamp":{"type":"timestamp"},"type":{}}}},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{"eventResults":{"type":"list","member":{"type":"structure","members":{"errorCode":{},"errorMessage":{},"eventId":{}}}},"failedEventCount":{"type":"integer"}}},"endpoint":{"hostPrefix":"dataplane."}},"StartExperiment":{"http":{"requestUri":"/projects/{project}/experiments/{experiment}/start","responseCode":200},"input":{"type":"structure","required":["analysisCompleteTime","experiment","project"],"members":{"analysisCompleteTime":{"type":"timestamp"},"experiment":{"location":"uri","locationName":"experiment"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","members":{"startedTime":{"type":"timestamp"}}}},"StartLaunch":{"http":{"requestUri":"/projects/{project}/launches/{launch}/start","responseCode":200},"input":{"type":"structure","required":["launch","project"],"members":{"launch":{"location":"uri","locationName":"launch"},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","required":["launch"],"members":{"launch":{"shape":"S2c"}}}},"StopExperiment":{"http":{"requestUri":"/projects/{project}/experiments/{experiment}/cancel","responseCode":200},"input":{"type":"structure","required":["experiment","project"],"members":{"desiredState":{},"experiment":{"location":"uri","locationName":"experiment"},"project":{"location":"uri","locationName":"project"},"reason":{}}},"output":{"type":"structure","members":{"endedTime":{"type":"timestamp"}}}},"StopLaunch":{"http":{"requestUri":"/projects/{project}/launches/{launch}/cancel","responseCode":200},"input":{"type":"structure","required":["launch","project"],"members":{"desiredState":{},"launch":{"location":"uri","locationName":"launch"},"project":{"location":"uri","locationName":"project"},"reason":{}}},"output":{"type":"structure","members":{"endedTime":{"type":"timestamp"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateExperiment":{"http":{"method":"PATCH","requestUri":"/projects/{project}/experiments/{experiment}","responseCode":200},"input":{"type":"structure","required":["experiment","project"],"members":{"description":{},"experiment":{"location":"uri","locationName":"experiment"},"metricGoals":{"shape":"Sk"},"onlineAbConfig":{"shape":"St"},"project":{"location":"uri","locationName":"project"},"randomizationSalt":{},"samplingRate":{"type":"long"},"treatments":{"shape":"S11"}}},"output":{"type":"structure","required":["experiment"],"members":{"experiment":{"shape":"S15"}}}},"UpdateFeature":{"http":{"method":"PATCH","requestUri":"/projects/{project}/features/{feature}","responseCode":200},"input":{"type":"structure","required":["feature","project"],"members":{"addOrUpdateVariations":{"shape":"S1n"},"defaultVariation":{},"description":{},"entityOverrides":{"shape":"S1l"},"evaluationStrategy":{},"feature":{"location":"uri","locationName":"feature"},"project":{"location":"uri","locationName":"project"},"removeVariations":{"type":"list","member":{}}}},"output":{"type":"structure","required":["feature"],"members":{"feature":{"shape":"S1q"}}}},"UpdateLaunch":{"http":{"method":"PATCH","requestUri":"/projects/{project}/launches/{launch}","responseCode":200},"input":{"type":"structure","required":["launch","project"],"members":{"description":{},"groups":{"shape":"S21"},"launch":{"location":"uri","locationName":"launch"},"metricMonitors":{"shape":"S24"},"project":{"location":"uri","locationName":"project"},"randomizationSalt":{},"scheduledSplitsConfig":{"shape":"S27"}}},"output":{"type":"structure","required":["launch"],"members":{"launch":{"shape":"S2c"}}}},"UpdateProject":{"http":{"method":"PATCH","requestUri":"/projects/{project}","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"description":{},"project":{"location":"uri","locationName":"project"}}},"output":{"type":"structure","required":["project"],"members":{"project":{"shape":"S2x"}}}},"UpdateProjectDataDelivery":{"http":{"method":"PATCH","requestUri":"/projects/{project}/data-delivery","responseCode":200},"input":{"type":"structure","required":["project"],"members":{"cloudWatchLogs":{"shape":"S2q"},"project":{"location":"uri","locationName":"project"},"s3Destination":{"shape":"S2s"}}},"output":{"type":"structure","required":["project"],"members":{"project":{"shape":"S2x"}}}}},"shapes":{"Sd":{"type":"structure","members":{"boolValue":{"type":"boolean"},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"stringValue":{}},"union":true},"Sk":{"type":"list","member":{"type":"structure","required":["metricDefinition"],"members":{"desiredChange":{},"metricDefinition":{"shape":"Sn"}}}},"Sn":{"type":"structure","required":["entityIdKey","name","valueKey"],"members":{"entityIdKey":{},"eventPattern":{"jsonvalue":true},"name":{},"unitLabel":{},"valueKey":{}}},"St":{"type":"structure","members":{"controlTreatmentName":{},"treatmentWeights":{"shape":"Sv"}}},"Sv":{"type":"map","key":{},"value":{"type":"long"}},"Sy":{"type":"map","key":{},"value":{}},"S11":{"type":"list","member":{"type":"structure","required":["feature","name","variation"],"members":{"description":{},"feature":{},"name":{},"variation":{}}}},"S15":{"type":"structure","required":["arn","createdTime","lastUpdatedTime","name","status","type"],"members":{"arn":{},"createdTime":{"type":"timestamp"},"description":{},"execution":{"type":"structure","members":{"endedTime":{"type":"timestamp"},"startedTime":{"type":"timestamp"}}},"lastUpdatedTime":{"type":"timestamp"},"metricGoals":{"type":"list","member":{"type":"structure","required":["metricDefinition"],"members":{"desiredChange":{},"metricDefinition":{"shape":"S1b"}}}},"name":{},"onlineAbDefinition":{"type":"structure","members":{"controlTreatmentName":{},"treatmentWeights":{"shape":"Sv"}}},"project":{},"randomizationSalt":{},"samplingRate":{"type":"long"},"schedule":{"type":"structure","members":{"analysisCompleteTime":{"type":"timestamp"}}},"status":{},"statusReason":{},"tags":{"shape":"Sy"},"treatments":{"type":"list","member":{"type":"structure","required":["name"],"members":{"description":{},"featureVariations":{"shape":"S1i"},"name":{}}}},"type":{}}},"S1b":{"type":"structure","members":{"entityIdKey":{},"eventPattern":{"jsonvalue":true},"name":{},"unitLabel":{},"valueKey":{}}},"S1i":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1n":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"shape":"Sd"}}}},"S1q":{"type":"structure","required":["arn","createdTime","evaluationStrategy","lastUpdatedTime","name","status","valueType","variations"],"members":{"arn":{},"createdTime":{"type":"timestamp"},"defaultVariation":{},"description":{},"entityOverrides":{"shape":"S1l"},"evaluationRules":{"shape":"S1s"},"evaluationStrategy":{},"lastUpdatedTime":{"type":"timestamp"},"name":{},"project":{},"status":{},"tags":{"shape":"Sy"},"valueType":{},"variations":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"shape":"Sd"}}}}}},"S1s":{"type":"list","member":{"type":"structure","required":["type"],"members":{"name":{},"type":{}}}},"S21":{"type":"list","member":{"type":"structure","required":["feature","name","variation"],"members":{"description":{},"feature":{},"name":{},"variation":{}}}},"S24":{"type":"list","member":{"type":"structure","required":["metricDefinition"],"members":{"metricDefinition":{"shape":"Sn"}}}},"S27":{"type":"structure","required":["steps"],"members":{"steps":{"type":"list","member":{"type":"structure","required":["groupWeights","startTime"],"members":{"groupWeights":{"shape":"S2a"},"startTime":{"type":"timestamp"}}}}}},"S2a":{"type":"map","key":{},"value":{"type":"long"}},"S2c":{"type":"structure","required":["arn","createdTime","lastUpdatedTime","name","status","type"],"members":{"arn":{},"createdTime":{"type":"timestamp"},"description":{},"execution":{"type":"structure","members":{"endedTime":{"type":"timestamp"},"startedTime":{"type":"timestamp"}}},"groups":{"type":"list","member":{"type":"structure","required":["featureVariations","name"],"members":{"description":{},"featureVariations":{"shape":"S1i"},"name":{}}}},"lastUpdatedTime":{"type":"timestamp"},"metricMonitors":{"type":"list","member":{"type":"structure","required":["metricDefinition"],"members":{"metricDefinition":{"shape":"S1b"}}}},"name":{},"project":{},"randomizationSalt":{},"scheduledSplitsDefinition":{"type":"structure","members":{"steps":{"type":"list","member":{"type":"structure","required":["startTime"],"members":{"groupWeights":{"shape":"S2a"},"startTime":{"type":"timestamp"}}}}}},"status":{},"statusReason":{},"tags":{"shape":"Sy"},"type":{}}},"S2q":{"type":"structure","members":{"logGroup":{}}},"S2s":{"type":"structure","members":{"bucket":{},"prefix":{}}},"S2x":{"type":"structure","required":["arn","createdTime","lastUpdatedTime","name","status"],"members":{"activeExperimentCount":{"type":"long"},"activeLaunchCount":{"type":"long"},"arn":{},"createdTime":{"type":"timestamp"},"dataDelivery":{"type":"structure","members":{"cloudWatchLogs":{"type":"structure","members":{"logGroup":{}}},"s3Destination":{"type":"structure","members":{"bucket":{},"prefix":{}}}}},"description":{},"experimentCount":{"type":"long"},"featureCount":{"type":"long"},"lastUpdatedTime":{"type":"timestamp"},"launchCount":{"type":"long"},"name":{},"status":{},"tags":{"shape":"Sy"}}}}}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListExperiments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"experiments"},"ListFeatures":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"features"},"ListLaunches":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"launches"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"projects"}}}

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['inspector2'] = {};
	AWS.Inspector2 = Service.defineService('inspector2', ['2020-06-08']);
	Object.defineProperty(apiLoader.services['inspector2'], '2020-06-08', {
	  get: function get() {
	    var model = __webpack_require__(1102);
	    model.paginators = __webpack_require__(1103).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Inspector2;


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-06-08","endpointPrefix":"inspector2","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Inspector2","serviceFullName":"Inspector2","serviceId":"Inspector2","signatureVersion":"v4","signingName":"inspector2","uid":"inspector2-2020-06-08"},"operations":{"AssociateMember":{"http":{"requestUri":"/members/associate","responseCode":200},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{}}},"output":{"type":"structure","required":["accountId"],"members":{"accountId":{}}}},"BatchGetAccountStatus":{"http":{"requestUri":"/status/batch/get","responseCode":200},"input":{"type":"structure","members":{"accountIds":{"shape":"S5"}}},"output":{"type":"structure","required":["accounts"],"members":{"accounts":{"type":"list","member":{"type":"structure","required":["accountId","resourceState","state"],"members":{"accountId":{},"resourceState":{"type":"structure","required":["ec2","ecr"],"members":{"ec2":{"shape":"Sa"},"ecr":{"shape":"Sa"}}},"state":{"shape":"Sa"}}}},"failedAccounts":{"shape":"Se"}}}},"BatchGetFreeTrialInfo":{"http":{"requestUri":"/freetrialinfo/batchget","responseCode":200},"input":{"type":"structure","required":["accountIds"],"members":{"accountIds":{"type":"list","member":{}}}},"output":{"type":"structure","required":["accounts","failedAccounts"],"members":{"accounts":{"type":"list","member":{"type":"structure","required":["accountId","freeTrialInfo"],"members":{"accountId":{},"freeTrialInfo":{"type":"list","member":{"type":"structure","required":["end","start","status","type"],"members":{"end":{"type":"timestamp"},"start":{"type":"timestamp"},"status":{},"type":{}}}}}}},"failedAccounts":{"type":"list","member":{"type":"structure","required":["accountId","code","message"],"members":{"accountId":{},"code":{},"message":{}}}}}}},"CancelFindingsReport":{"http":{"requestUri":"/reporting/cancel","responseCode":200},"input":{"type":"structure","required":["reportId"],"members":{"reportId":{}}},"output":{"type":"structure","required":["reportId"],"members":{"reportId":{}}}},"CreateFilter":{"http":{"requestUri":"/filters/create","responseCode":200},"input":{"type":"structure","required":["action","filterCriteria","name"],"members":{"action":{},"description":{},"filterCriteria":{"shape":"S12"},"name":{},"tags":{"shape":"S1n"}}},"output":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"CreateFindingsReport":{"http":{"requestUri":"/reporting/create","responseCode":200},"input":{"type":"structure","required":["reportFormat","s3Destination"],"members":{"filterCriteria":{"shape":"S12"},"reportFormat":{},"s3Destination":{"shape":"S1s"}}},"output":{"type":"structure","members":{"reportId":{}}}},"DeleteFilter":{"http":{"requestUri":"/filters/delete","responseCode":200},"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"DescribeOrganizationConfiguration":{"http":{"requestUri":"/organizationconfiguration/describe","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"autoEnable":{"shape":"S1y"},"maxAccountLimitReached":{"type":"boolean"}}}},"Disable":{"http":{"requestUri":"/disable","responseCode":200},"input":{"type":"structure","members":{"accountIds":{"shape":"S5"},"resourceTypes":{"type":"list","member":{}}}},"output":{"type":"structure","required":["accounts"],"members":{"accounts":{"shape":"S24"},"failedAccounts":{"shape":"Se"}}}},"DisableDelegatedAdminAccount":{"http":{"requestUri":"/delegatedadminaccounts/disable","responseCode":200},"input":{"type":"structure","required":["delegatedAdminAccountId"],"members":{"delegatedAdminAccountId":{}}},"output":{"type":"structure","required":["delegatedAdminAccountId"],"members":{"delegatedAdminAccountId":{}}}},"DisassociateMember":{"http":{"requestUri":"/members/disassociate","responseCode":200},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{}}},"output":{"type":"structure","required":["accountId"],"members":{"accountId":{}}}},"Enable":{"http":{"requestUri":"/enable","responseCode":200},"input":{"type":"structure","required":["resourceTypes"],"members":{"accountIds":{"shape":"S5"},"clientToken":{"idempotencyToken":true},"resourceTypes":{"type":"list","member":{}}}},"output":{"type":"structure","required":["accounts"],"members":{"accounts":{"shape":"S24"},"failedAccounts":{"shape":"Se"}}}},"EnableDelegatedAdminAccount":{"http":{"requestUri":"/delegatedadminaccounts/enable","responseCode":200},"input":{"type":"structure","required":["delegatedAdminAccountId"],"members":{"clientToken":{"idempotencyToken":true},"delegatedAdminAccountId":{}}},"output":{"type":"structure","required":["delegatedAdminAccountId"],"members":{"delegatedAdminAccountId":{}}}},"GetDelegatedAdminAccount":{"http":{"requestUri":"/delegatedadminaccounts/get","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"delegatedAdmin":{"type":"structure","members":{"accountId":{},"relationshipStatus":{}}}}}},"GetFindingsReportStatus":{"http":{"requestUri":"/reporting/status/get","responseCode":200},"input":{"type":"structure","members":{"reportId":{}}},"output":{"type":"structure","members":{"destination":{"shape":"S1s"},"errorCode":{},"errorMessage":{},"filterCriteria":{"shape":"S12"},"reportId":{},"status":{}}}},"GetMember":{"http":{"requestUri":"/members/get","responseCode":200},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{}}},"output":{"type":"structure","members":{"member":{"shape":"S2r"}}}},"ListAccountPermissions":{"http":{"requestUri":"/accountpermissions/list","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{},"service":{}}},"output":{"type":"structure","required":["permissions"],"members":{"nextToken":{},"permissions":{"type":"list","member":{"type":"structure","required":["operation","service"],"members":{"operation":{},"service":{}}}}}}},"ListCoverage":{"http":{"requestUri":"/coverage/list","responseCode":200},"input":{"type":"structure","members":{"filterCriteria":{"shape":"S32"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"coveredResources":{"type":"list","member":{"type":"structure","required":["accountId","resourceId","resourceType","scanType"],"members":{"accountId":{},"resourceId":{},"resourceMetadata":{"type":"structure","members":{"ec2":{"type":"structure","members":{"amiId":{},"platform":{},"tags":{"shape":"S1n"}}},"ecrImage":{"type":"structure","members":{"tags":{"type":"list","member":{}}}},"ecrRepository":{"type":"structure","members":{"name":{},"scanFrequency":{}}}}},"resourceType":{},"scanStatus":{"type":"structure","required":["reason","statusCode"],"members":{"reason":{},"statusCode":{}}},"scanType":{}}}},"nextToken":{}}}},"ListCoverageStatistics":{"http":{"requestUri":"/coverage/statistics/list","responseCode":200},"input":{"type":"structure","members":{"filterCriteria":{"shape":"S32"},"groupBy":{},"nextToken":{}}},"output":{"type":"structure","required":["totalCounts"],"members":{"countsByGroup":{"type":"list","member":{"type":"structure","members":{"count":{"type":"long"},"groupKey":{}}}},"nextToken":{},"totalCounts":{"type":"long"}}}},"ListDelegatedAdminAccounts":{"http":{"requestUri":"/delegatedadminaccounts/list","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"delegatedAdminAccounts":{"type":"list","member":{"type":"structure","members":{"accountId":{},"status":{}}}},"nextToken":{}}}},"ListFilters":{"http":{"requestUri":"/filters/list","responseCode":200},"input":{"type":"structure","members":{"action":{},"arns":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["filters"],"members":{"filters":{"type":"list","member":{"type":"structure","required":["action","arn","createdAt","criteria","name","ownerId","updatedAt"],"members":{"action":{},"arn":{},"createdAt":{"type":"timestamp"},"criteria":{"shape":"S12"},"description":{},"name":{},"ownerId":{},"reason":{},"tags":{"shape":"S1n"},"updatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListFindingAggregations":{"http":{"requestUri":"/findings/aggregation/list","responseCode":200},"input":{"type":"structure","required":["aggregationType"],"members":{"accountIds":{"shape":"S13"},"aggregationRequest":{"type":"structure","members":{"accountAggregation":{"type":"structure","members":{"findingType":{},"resourceType":{},"sortBy":{},"sortOrder":{}}},"amiAggregation":{"type":"structure","members":{"amis":{"shape":"S13"},"sortBy":{},"sortOrder":{}}},"awsEcrContainerAggregation":{"type":"structure","members":{"architectures":{"shape":"S13"},"imageShas":{"shape":"S13"},"imageTags":{"shape":"S13"},"repositories":{"shape":"S13"},"resourceIds":{"shape":"S13"},"sortBy":{},"sortOrder":{}}},"ec2InstanceAggregation":{"type":"structure","members":{"amis":{"shape":"S13"},"instanceIds":{"shape":"S13"},"instanceTags":{"shape":"S1f"},"operatingSystems":{"shape":"S13"},"sortBy":{},"sortOrder":{}}},"findingTypeAggregation":{"type":"structure","members":{"findingType":{},"resourceType":{},"sortBy":{},"sortOrder":{}}},"imageLayerAggregation":{"type":"structure","members":{"layerHashes":{"shape":"S13"},"repositories":{"shape":"S13"},"resourceIds":{"shape":"S13"},"sortBy":{},"sortOrder":{}}},"packageAggregation":{"type":"structure","members":{"packageNames":{"shape":"S13"},"sortBy":{},"sortOrder":{}}},"repositoryAggregation":{"type":"structure","members":{"repositories":{"shape":"S13"},"sortBy":{},"sortOrder":{}}},"titleAggregation":{"type":"structure","members":{"resourceType":{},"sortBy":{},"sortOrder":{},"titles":{"shape":"S13"},"vulnerabilityIds":{"shape":"S13"}}}},"union":true},"aggregationType":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["aggregationType"],"members":{"aggregationType":{},"nextToken":{},"responses":{"type":"list","member":{"type":"structure","members":{"accountAggregation":{"type":"structure","members":{"accountId":{},"severityCounts":{"shape":"S56"}}},"amiAggregation":{"type":"structure","required":["ami"],"members":{"accountId":{},"affectedInstances":{"type":"long"},"ami":{},"severityCounts":{"shape":"S56"}}},"awsEcrContainerAggregation":{"type":"structure","required":["resourceId"],"members":{"accountId":{},"architecture":{},"imageSha":{},"imageTags":{"type":"list","member":{}},"repository":{},"resourceId":{},"severityCounts":{"shape":"S56"}}},"ec2InstanceAggregation":{"type":"structure","required":["instanceId"],"members":{"accountId":{},"ami":{},"instanceId":{},"instanceTags":{"shape":"S1n"},"networkFindings":{"type":"long"},"operatingSystem":{},"severityCounts":{"shape":"S56"}}},"findingTypeAggregation":{"type":"structure","members":{"accountId":{},"severityCounts":{"shape":"S56"}}},"imageLayerAggregation":{"type":"structure","required":["accountId","layerHash","repository","resourceId"],"members":{"accountId":{},"layerHash":{},"repository":{},"resourceId":{},"severityCounts":{"shape":"S56"}}},"packageAggregation":{"type":"structure","required":["packageName"],"members":{"accountId":{},"packageName":{},"severityCounts":{"shape":"S56"}}},"repositoryAggregation":{"type":"structure","required":["repository"],"members":{"accountId":{},"affectedImages":{"type":"long"},"repository":{},"severityCounts":{"shape":"S56"}}},"titleAggregation":{"type":"structure","required":["title"],"members":{"accountId":{},"severityCounts":{"shape":"S56"},"title":{},"vulnerabilityId":{}}}},"union":true}}}}},"ListFindings":{"http":{"requestUri":"/findings/list","responseCode":200},"input":{"type":"structure","members":{"filterCriteria":{"shape":"S12"},"maxResults":{"type":"integer"},"nextToken":{},"sortCriteria":{"type":"structure","required":["field","sortOrder"],"members":{"field":{},"sortOrder":{}}}}},"output":{"type":"structure","members":{"findings":{"type":"list","member":{"type":"structure","required":["awsAccountId","description","findingArn","firstObservedAt","lastObservedAt","remediation","resources","severity","status","type"],"members":{"awsAccountId":{},"description":{},"findingArn":{},"firstObservedAt":{"type":"timestamp"},"inspectorScore":{"type":"double"},"inspectorScoreDetails":{"type":"structure","members":{"adjustedCvss":{"type":"structure","required":["score","scoreSource","scoringVector","version"],"members":{"adjustments":{"type":"list","member":{"type":"structure","required":["metric","reason"],"members":{"metric":{},"reason":{}}}},"cvssSource":{},"score":{"type":"double"},"scoreSource":{},"scoringVector":{},"version":{}}}}},"lastObservedAt":{"type":"timestamp"},"networkReachabilityDetails":{"type":"structure","required":["networkPath","openPortRange","protocol"],"members":{"networkPath":{"type":"structure","members":{"steps":{"type":"list","member":{"type":"structure","required":["componentId","componentType"],"members":{"componentId":{},"componentType":{}}}}}},"openPortRange":{"type":"structure","required":["begin","end"],"members":{"begin":{"type":"integer"},"end":{"type":"integer"}}},"protocol":{}}},"packageVulnerabilityDetails":{"type":"structure","required":["source","vulnerabilityId","vulnerablePackages"],"members":{"cvss":{"type":"list","member":{"type":"structure","required":["baseScore","scoringVector","source","version"],"members":{"baseScore":{"type":"double"},"scoringVector":{},"source":{},"version":{}}}},"referenceUrls":{"type":"list","member":{}},"relatedVulnerabilities":{"type":"list","member":{}},"source":{},"sourceUrl":{},"vendorCreatedAt":{"type":"timestamp"},"vendorSeverity":{},"vendorUpdatedAt":{"type":"timestamp"},"vulnerabilityId":{},"vulnerablePackages":{"type":"list","member":{"type":"structure","required":["name","version"],"members":{"arch":{},"epoch":{"type":"integer"},"filePath":{},"fixedInVersion":{},"name":{},"packageManager":{},"release":{},"sourceLayerHash":{},"version":{}}}}}},"remediation":{"type":"structure","members":{"recommendation":{"type":"structure","members":{"Url":{},"text":{}}}}},"resources":{"type":"list","member":{"type":"structure","required":["id","type"],"members":{"details":{"type":"structure","members":{"awsEc2Instance":{"type":"structure","members":{"iamInstanceProfileArn":{},"imageId":{},"ipV4Addresses":{"type":"list","member":{}},"ipV6Addresses":{"type":"list","member":{}},"keyName":{},"launchedAt":{"type":"timestamp"},"platform":{},"subnetId":{},"type":{},"vpcId":{}}},"awsEcrContainerImage":{"type":"structure","required":["imageHash","registry","repositoryName"],"members":{"architecture":{},"author":{},"imageHash":{},"imageTags":{"type":"list","member":{}},"platform":{},"pushedAt":{"type":"timestamp"},"registry":{},"repositoryName":{}}}}},"id":{},"partition":{},"region":{},"tags":{"shape":"S1n"},"type":{}}}},"severity":{},"status":{},"title":{},"type":{},"updatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListMembers":{"http":{"requestUri":"/members/list","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{},"onlyAssociated":{"type":"boolean"}}},"output":{"type":"structure","members":{"members":{"type":"list","member":{"shape":"S2r"}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1n"}}}},"ListUsageTotals":{"http":{"requestUri":"/usage/list","responseCode":200},"input":{"type":"structure","members":{"accountIds":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"totals":{"type":"list","member":{"type":"structure","members":{"accountId":{},"usage":{"type":"list","member":{"type":"structure","members":{"currency":{},"estimatedMonthlyCost":{"type":"double"},"total":{"type":"double"},"type":{}}}}}}}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFilter":{"http":{"requestUri":"/filters/update","responseCode":200},"input":{"type":"structure","required":["filterArn"],"members":{"action":{},"description":{},"filterArn":{},"filterCriteria":{"shape":"S12"},"name":{}}},"output":{"type":"structure","required":["arn"],"members":{"arn":{}}}},"UpdateOrganizationConfiguration":{"http":{"requestUri":"/organizationconfiguration/update","responseCode":200},"input":{"type":"structure","required":["autoEnable"],"members":{"autoEnable":{"shape":"S1y"}}},"output":{"type":"structure","required":["autoEnable"],"members":{"autoEnable":{"shape":"S1y"}}}}},"shapes":{"S5":{"type":"list","member":{}},"Sa":{"type":"structure","required":["errorCode","errorMessage","status"],"members":{"errorCode":{},"errorMessage":{},"status":{}}},"Se":{"type":"list","member":{"type":"structure","required":["accountId","errorCode","errorMessage"],"members":{"accountId":{},"errorCode":{},"errorMessage":{},"resourceStatus":{"shape":"Sg"},"status":{}}}},"Sg":{"type":"structure","required":["ec2","ecr"],"members":{"ec2":{},"ecr":{}}},"S12":{"type":"structure","members":{"awsAccountId":{"shape":"S13"},"componentId":{"shape":"S13"},"componentType":{"shape":"S13"},"ec2InstanceImageId":{"shape":"S13"},"ec2InstanceSubnetId":{"shape":"S13"},"ec2InstanceVpcId":{"shape":"S13"},"ecrImageArchitecture":{"shape":"S13"},"ecrImageHash":{"shape":"S13"},"ecrImagePushedAt":{"shape":"S17"},"ecrImageRegistry":{"shape":"S13"},"ecrImageRepositoryName":{"shape":"S13"},"ecrImageTags":{"shape":"S13"},"findingArn":{"shape":"S13"},"findingStatus":{"shape":"S13"},"findingType":{"shape":"S13"},"firstObservedAt":{"shape":"S17"},"inspectorScore":{"type":"list","member":{"shape":"S1a"}},"lastObservedAt":{"shape":"S17"},"networkProtocol":{"shape":"S13"},"portRange":{"type":"list","member":{"type":"structure","members":{"beginInclusive":{"type":"integer"},"endInclusive":{"type":"integer"}}}},"relatedVulnerabilities":{"shape":"S13"},"resourceId":{"shape":"S13"},"resourceTags":{"shape":"S1f"},"resourceType":{"shape":"S13"},"severity":{"shape":"S13"},"title":{"shape":"S13"},"updatedAt":{"shape":"S17"},"vendorSeverity":{"shape":"S13"},"vulnerabilityId":{"shape":"S13"},"vulnerabilitySource":{"shape":"S13"},"vulnerablePackages":{"type":"list","member":{"type":"structure","members":{"architecture":{"shape":"S14"},"epoch":{"shape":"S1a"},"name":{"shape":"S14"},"release":{"shape":"S14"},"sourceLayerHash":{"shape":"S14"},"version":{"shape":"S14"}}}}}},"S13":{"type":"list","member":{"shape":"S14"}},"S14":{"type":"structure","required":["comparison","value"],"members":{"comparison":{},"value":{}}},"S17":{"type":"list","member":{"type":"structure","members":{"endInclusive":{"type":"timestamp"},"startInclusive":{"type":"timestamp"}}}},"S1a":{"type":"structure","members":{"lowerInclusive":{"type":"double"},"upperInclusive":{"type":"double"}}},"S1f":{"type":"list","member":{"type":"structure","required":["comparison","key"],"members":{"comparison":{},"key":{},"value":{}}}},"S1n":{"type":"map","key":{},"value":{}},"S1s":{"type":"structure","required":["bucketName","kmsKeyArn"],"members":{"bucketName":{},"keyPrefix":{},"kmsKeyArn":{}}},"S1y":{"type":"structure","required":["ec2","ecr"],"members":{"ec2":{"type":"boolean"},"ecr":{"type":"boolean"}}},"S24":{"type":"list","member":{"type":"structure","required":["accountId","resourceStatus","status"],"members":{"accountId":{},"resourceStatus":{"shape":"Sg"},"status":{}}}},"S2r":{"type":"structure","members":{"accountId":{},"delegatedAdminAccountId":{},"relationshipStatus":{},"updatedAt":{"type":"timestamp"}}},"S32":{"type":"structure","members":{"accountId":{"shape":"S33"},"ec2InstanceTags":{"type":"list","member":{"type":"structure","required":["comparison","key"],"members":{"comparison":{},"key":{},"value":{}}}},"ecrImageTags":{"shape":"S33"},"ecrRepositoryName":{"shape":"S33"},"resourceId":{"shape":"S33"},"resourceType":{"shape":"S33"},"scanStatusCode":{"shape":"S33"},"scanStatusReason":{"shape":"S33"},"scanType":{"shape":"S33"}}},"S33":{"type":"list","member":{"type":"structure","required":["comparison","value"],"members":{"comparison":{},"value":{}}}},"S56":{"type":"structure","members":{"all":{"type":"long"},"critical":{"type":"long"},"high":{"type":"long"},"medium":{"type":"long"}}}}}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccountPermissions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"permissions"},"ListCoverage":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"coveredResources"},"ListCoverageStatistics":{"input_token":"nextToken","output_token":"nextToken","result_key":"countsByGroup"},"ListDelegatedAdminAccounts":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"delegatedAdminAccounts"},"ListFilters":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"filters"},"ListFindingAggregations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"responses"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"findings"},"ListMembers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"members"},"ListUsageTotals":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"totals"}}}

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['rbin'] = {};
	AWS.Rbin = Service.defineService('rbin', ['2021-06-15']);
	Object.defineProperty(apiLoader.services['rbin'], '2021-06-15', {
	  get: function get() {
	    var model = __webpack_require__(1105);
	    model.paginators = __webpack_require__(1106).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Rbin;


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-06-15","endpointPrefix":"rbin","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Recycle Bin","serviceId":"rbin","signatureVersion":"v4","signingName":"rbin","uid":"rbin-2021-06-15"},"operations":{"CreateRule":{"http":{"requestUri":"/rules","responseCode":201},"input":{"type":"structure","required":["RetentionPeriod","ResourceType"],"members":{"RetentionPeriod":{"shape":"S2"},"Description":{},"Tags":{"shape":"S6"},"ResourceType":{},"ResourceTags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Identifier":{},"RetentionPeriod":{"shape":"S2"},"Description":{},"Tags":{"shape":"S6"},"ResourceType":{},"ResourceTags":{"shape":"Sb"},"Status":{}}}},"DeleteRule":{"http":{"method":"DELETE","requestUri":"/rules/{identifier}","responseCode":204},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"identifier"}}},"output":{"type":"structure","members":{}}},"GetRule":{"http":{"method":"GET","requestUri":"/rules/{identifier}","responseCode":200},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"identifier"}}},"output":{"type":"structure","members":{"Identifier":{},"Description":{},"ResourceType":{},"RetentionPeriod":{"shape":"S2"},"ResourceTags":{"shape":"Sb"},"Status":{}}}},"ListRules":{"http":{"requestUri":"/list-rules","responseCode":200},"input":{"type":"structure","required":["ResourceType"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"ResourceType":{},"ResourceTags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Identifier":{},"Description":{},"RetentionPeriod":{"shape":"S2"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":201},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateRule":{"http":{"method":"PATCH","requestUri":"/rules/{identifier}","responseCode":200},"input":{"type":"structure","required":["Identifier"],"members":{"Identifier":{"location":"uri","locationName":"identifier"},"RetentionPeriod":{"shape":"S2"},"Description":{},"ResourceType":{},"ResourceTags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Identifier":{},"RetentionPeriod":{"shape":"S2"},"Description":{},"ResourceType":{},"ResourceTags":{"shape":"Sb"},"Status":{}}}}},"shapes":{"S2":{"type":"structure","required":["RetentionPeriodValue","RetentionPeriodUnit"],"members":{"RetentionPeriodValue":{"type":"integer"},"RetentionPeriodUnit":{}}},"S6":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"list","member":{"type":"structure","required":["ResourceTagKey"],"members":{"ResourceTagKey":{},"ResourceTagValue":{}}}}}}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Rules"}}}

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['rum'] = {};
	AWS.RUM = Service.defineService('rum', ['2018-05-10']);
	Object.defineProperty(apiLoader.services['rum'], '2018-05-10', {
	  get: function get() {
	    var model = __webpack_require__(1108);
	    model.paginators = __webpack_require__(1109).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.RUM;


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-10","endpointPrefix":"rum","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"CloudWatch RUM","serviceId":"RUM","signatureVersion":"v4","signingName":"rum","uid":"rum-2018-05-10"},"operations":{"CreateAppMonitor":{"http":{"requestUri":"/appmonitor","responseCode":200},"input":{"type":"structure","required":["Domain","Name"],"members":{"AppMonitorConfiguration":{"shape":"S2"},"CwLogEnabled":{"type":"boolean"},"Domain":{},"Name":{},"Tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"Id":{}}},"idempotent":true},"DeleteAppMonitor":{"http":{"method":"DELETE","requestUri":"/appmonitor/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetAppMonitor":{"http":{"method":"GET","requestUri":"/appmonitor/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"AppMonitor":{"type":"structure","members":{"AppMonitorConfiguration":{"shape":"S2"},"Created":{},"DataStorage":{"type":"structure","members":{"CwLog":{"type":"structure","members":{"CwLogEnabled":{"type":"boolean"},"CwLogGroup":{}}}}},"Domain":{},"Id":{},"LastModified":{},"Name":{},"State":{},"Tags":{"shape":"Sf"}}}}}},"GetAppMonitorData":{"http":{"requestUri":"/appmonitor/{Name}/data","responseCode":200},"input":{"type":"structure","required":["Name","TimeRange"],"members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"Name":{"location":"uri","locationName":"Name"},"NextToken":{},"TimeRange":{"type":"structure","required":["After"],"members":{"After":{"type":"long"},"Before":{"type":"long"}}}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{}},"NextToken":{}}}},"ListAppMonitors":{"http":{"requestUri":"/appmonitors","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"AppMonitorSummaries":{"type":"list","member":{"type":"structure","members":{"Created":{},"Id":{},"LastModified":{},"Name":{},"State":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sf"}}}},"PutRumEvents":{"http":{"requestUri":"/appmonitors/{Id}/","responseCode":200},"input":{"type":"structure","required":["AppMonitorDetails","BatchId","Id","RumEvents","UserDetails"],"members":{"AppMonitorDetails":{"type":"structure","members":{"id":{},"name":{},"version":{}}},"BatchId":{},"Id":{"location":"uri","locationName":"Id"},"RumEvents":{"type":"list","member":{"type":"structure","required":["details","id","timestamp","type"],"members":{"details":{"jsonvalue":true},"id":{},"metadata":{"jsonvalue":true},"timestamp":{"type":"timestamp"},"type":{}}}},"UserDetails":{"type":"structure","members":{"sessionId":{},"userId":{}}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"dataplane."}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateAppMonitor":{"http":{"method":"PATCH","requestUri":"/appmonitor/{Name}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"AppMonitorConfiguration":{"shape":"S2"},"CwLogEnabled":{"type":"boolean"},"Domain":{},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","members":{"AllowCookies":{"type":"boolean"},"EnableXRay":{"type":"boolean"},"ExcludedPages":{"shape":"S4"},"FavoritePages":{"type":"list","member":{}},"GuestRoleArn":{},"IdentityPoolId":{},"IncludedPages":{"shape":"S4"},"SessionSampleRate":{"type":"double"},"Telemetries":{"type":"list","member":{}}}},"S4":{"type":"list","member":{}},"Sf":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetAppMonitorData":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Events"},"ListAppMonitors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AppMonitorSummaries"}}}

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['backupgateway'] = {};
	AWS.BackupGateway = Service.defineService('backupgateway', ['2021-01-01']);
	Object.defineProperty(apiLoader.services['backupgateway'], '2021-01-01', {
	  get: function get() {
	    var model = __webpack_require__(1111);
	    model.paginators = __webpack_require__(1112).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.BackupGateway;


/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-01-01","endpointPrefix":"backup-gateway","jsonVersion":"1.0","protocol":"json","serviceFullName":"AWS Backup Gateway","serviceId":"Backup Gateway","signatureVersion":"v4","signingName":"backup-gateway","targetPrefix":"BackupOnPremises_v20210101","uid":"backup-gateway-2021-01-01"},"operations":{"AssociateGatewayToServer":{"input":{"type":"structure","required":["GatewayArn","ServerArn"],"members":{"GatewayArn":{},"ServerArn":{}}},"output":{"type":"structure","members":{"GatewayArn":{}}}},"CreateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayDisplayName","GatewayType"],"members":{"ActivationKey":{},"GatewayDisplayName":{},"GatewayType":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"GatewayArn":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{}}},"output":{"type":"structure","members":{"GatewayArn":{}}},"idempotent":true},"DeleteHypervisor":{"input":{"type":"structure","required":["HypervisorArn"],"members":{"HypervisorArn":{}}},"output":{"type":"structure","members":{"HypervisorArn":{}}},"idempotent":true},"DisassociateGatewayFromServer":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{}}},"output":{"type":"structure","members":{"GatewayArn":{}}}},"ImportHypervisorConfiguration":{"input":{"type":"structure","required":["Host","Name"],"members":{"Host":{},"KmsKeyArn":{},"Name":{},"Password":{"shape":"Sn"},"Tags":{"shape":"S9"},"Username":{"shape":"So"}}},"output":{"type":"structure","members":{"HypervisorArn":{}}}},"ListGateways":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayArn":{},"GatewayDisplayName":{},"GatewayType":{},"HypervisorId":{},"LastSeenTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListHypervisors":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Hypervisors":{"type":"list","member":{"type":"structure","members":{"Host":{},"HypervisorArn":{},"KmsKeyArn":{},"Name":{},"State":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"S9"}}}},"ListVirtualMachines":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"VirtualMachines":{"type":"list","member":{"type":"structure","members":{"HostName":{},"HypervisorId":{},"LastBackupDate":{"type":"timestamp"},"Name":{},"Path":{},"ResourceArn":{}}}}}}},"PutMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayArn","HourOfDay","MinuteOfHour"],"members":{"DayOfMonth":{"type":"integer"},"DayOfWeek":{"type":"integer"},"GatewayArn":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"TestHypervisorConfiguration":{"input":{"type":"structure","required":["GatewayArn","Host"],"members":{"GatewayArn":{},"Host":{},"Password":{"shape":"Sn"},"Username":{"shape":"So"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{},"GatewayDisplayName":{}}},"output":{"type":"structure","members":{"GatewayArn":{}}}},"UpdateHypervisor":{"input":{"type":"structure","required":["HypervisorArn"],"members":{"Host":{},"HypervisorArn":{},"Password":{"shape":"Sn"},"Username":{"shape":"So"}}},"output":{"type":"structure","members":{"HypervisorArn":{}}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sn":{"type":"string","sensitive":true},"So":{"type":"string","sensitive":true}}}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListGateways":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Gateways"},"ListHypervisors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Hypervisors"},"ListVirtualMachines":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"VirtualMachines"}}}

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['iottwinmaker'] = {};
	AWS.IoTTwinMaker = Service.defineService('iottwinmaker', ['2021-11-29']);
	Object.defineProperty(apiLoader.services['iottwinmaker'], '2021-11-29', {
	  get: function get() {
	    var model = __webpack_require__(1114);
	    model.paginators = __webpack_require__(1115).pagination;
	    model.waiters = __webpack_require__(1116).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.IoTTwinMaker;


/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-11-29","endpointPrefix":"iottwinmaker","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS IoT TwinMaker","serviceId":"IoTTwinMaker","signatureVersion":"v4","signingName":"iottwinmaker","uid":"iottwinmaker-2021-11-29"},"operations":{"BatchPutPropertyValues":{"http":{"requestUri":"/workspaces/{workspaceId}/entity-properties","responseCode":200},"input":{"type":"structure","required":["entries","workspaceId"],"members":{"entries":{"type":"list","member":{"shape":"S3"}},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["errorEntries"],"members":{"errorEntries":{"type":"list","member":{"type":"structure","required":["errors"],"members":{"errors":{"type":"list","member":{"type":"structure","required":["entry","errorCode","errorMessage"],"members":{"entry":{"shape":"S3"},"errorCode":{},"errorMessage":{}}}}}}}}},"endpoint":{"hostPrefix":"data."}},"CreateComponentType":{"http":{"requestUri":"/workspaces/{workspaceId}/component-types/{componentTypeId}","responseCode":200},"input":{"type":"structure","required":["componentTypeId","workspaceId"],"members":{"componentTypeId":{"location":"uri","locationName":"componentTypeId"},"description":{},"extendsFrom":{"shape":"Sv"},"functions":{"shape":"Sw"},"isSingleton":{"type":"boolean"},"propertyDefinitions":{"shape":"S13"},"tags":{"shape":"S1a"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","creationDateTime","state"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"},"state":{}}},"endpoint":{"hostPrefix":"api."}},"CreateEntity":{"http":{"requestUri":"/workspaces/{workspaceId}/entities","responseCode":200},"input":{"type":"structure","required":["entityName","workspaceId"],"members":{"components":{"type":"map","key":{},"value":{"type":"structure","members":{"componentTypeId":{},"description":{},"properties":{"shape":"S1j"}}}},"description":{},"entityId":{},"entityName":{},"parentEntityId":{},"tags":{"shape":"S1a"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","creationDateTime","entityId","state"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"},"entityId":{},"state":{}}},"endpoint":{"hostPrefix":"api."}},"CreateScene":{"http":{"requestUri":"/workspaces/{workspaceId}/scenes","responseCode":200},"input":{"type":"structure","required":["contentLocation","sceneId","workspaceId"],"members":{"capabilities":{"shape":"S1q"},"contentLocation":{},"description":{},"sceneId":{},"tags":{"shape":"S1a"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","creationDateTime"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"CreateWorkspace":{"http":{"requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["role","s3Location","workspaceId"],"members":{"description":{},"role":{},"s3Location":{},"tags":{"shape":"S1a"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","creationDateTime"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"DeleteComponentType":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/component-types/{componentTypeId}","responseCode":200},"input":{"type":"structure","required":["componentTypeId","workspaceId"],"members":{"componentTypeId":{"location":"uri","locationName":"componentTypeId"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["state"],"members":{"state":{}}},"endpoint":{"hostPrefix":"api."}},"DeleteEntity":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/entities/{entityId}","responseCode":200},"input":{"type":"structure","required":["entityId","workspaceId"],"members":{"entityId":{"location":"uri","locationName":"entityId"},"isRecursive":{"location":"querystring","locationName":"isRecursive","type":"boolean"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["state"],"members":{"state":{}}},"endpoint":{"hostPrefix":"api."}},"DeleteScene":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/scenes/{sceneId}","responseCode":200},"input":{"type":"structure","required":["sceneId","workspaceId"],"members":{"sceneId":{"location":"uri","locationName":"sceneId"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"DeleteWorkspace":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"GetComponentType":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/component-types/{componentTypeId}","responseCode":200},"input":{"type":"structure","required":["componentTypeId","workspaceId"],"members":{"componentTypeId":{"location":"uri","locationName":"componentTypeId"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","componentTypeId","creationDateTime","updateDateTime","workspaceId"],"members":{"arn":{},"componentTypeId":{},"creationDateTime":{"type":"timestamp"},"description":{},"extendsFrom":{"shape":"Sv"},"functions":{"type":"map","key":{},"value":{"type":"structure","members":{"implementedBy":{"shape":"Sy"},"isInherited":{"type":"boolean"},"requiredProperties":{"shape":"S11"},"scope":{}}}},"isAbstract":{"type":"boolean"},"isSchemaInitialized":{"type":"boolean"},"isSingleton":{"type":"boolean"},"propertyDefinitions":{"type":"map","key":{},"value":{"shape":"S2b"}},"status":{"shape":"S2c"},"updateDateTime":{"type":"timestamp"},"workspaceId":{}}},"endpoint":{"hostPrefix":"api."}},"GetEntity":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/entities/{entityId}","responseCode":200},"input":{"type":"structure","required":["entityId","workspaceId"],"members":{"entityId":{"location":"uri","locationName":"entityId"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","creationDateTime","entityId","entityName","hasChildEntities","parentEntityId","status","updateDateTime","workspaceId"],"members":{"arn":{},"components":{"type":"map","key":{},"value":{"type":"structure","members":{"componentName":{},"componentTypeId":{},"definedIn":{},"description":{},"properties":{"type":"map","key":{},"value":{"type":"structure","members":{"definition":{"shape":"S2b"},"value":{"shape":"Sd"}}}},"status":{"shape":"S2c"}}}},"creationDateTime":{"type":"timestamp"},"description":{},"entityId":{},"entityName":{},"hasChildEntities":{"type":"boolean"},"parentEntityId":{},"status":{"shape":"S2c"},"updateDateTime":{"type":"timestamp"},"workspaceId":{}}},"endpoint":{"hostPrefix":"api."}},"GetPropertyValue":{"http":{"requestUri":"/workspaces/{workspaceId}/entity-properties/value","responseCode":200},"input":{"type":"structure","required":["selectedProperties","workspaceId"],"members":{"componentName":{},"componentTypeId":{},"entityId":{},"selectedProperties":{"shape":"S2n"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["propertyValues"],"members":{"propertyValues":{"type":"map","key":{},"value":{"type":"structure","required":["propertyReference"],"members":{"propertyReference":{"shape":"S4"},"propertyValue":{"shape":"Sd"}}}}}},"endpoint":{"hostPrefix":"data."}},"GetPropertyValueHistory":{"http":{"requestUri":"/workspaces/{workspaceId}/entity-properties/history","responseCode":200},"input":{"type":"structure","required":["selectedProperties","workspaceId"],"members":{"componentName":{},"componentTypeId":{},"endDateTime":{"deprecated":true,"deprecatedMessage":"This field is deprecated and will throw an error in the future. Use endTime instead.","type":"timestamp"},"endTime":{},"entityId":{},"interpolation":{"type":"structure","members":{"interpolationType":{},"intervalInSeconds":{"type":"long"}}},"maxResults":{"type":"integer"},"nextToken":{},"orderByTime":{},"propertyFilters":{"type":"list","member":{"type":"structure","members":{"operator":{},"propertyName":{},"value":{"shape":"Sd"}}}},"selectedProperties":{"shape":"S2n"},"startDateTime":{"deprecated":true,"deprecatedMessage":"This field is deprecated and will throw an error in the future. Use startTime instead.","type":"timestamp"},"startTime":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["propertyValues"],"members":{"nextToken":{},"propertyValues":{"type":"list","member":{"type":"structure","required":["entityPropertyReference"],"members":{"entityPropertyReference":{"shape":"S4"},"values":{"type":"list","member":{"shape":"Sa"}}}}}}},"endpoint":{"hostPrefix":"data."}},"GetScene":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/scenes/{sceneId}","responseCode":200},"input":{"type":"structure","required":["sceneId","workspaceId"],"members":{"sceneId":{"location":"uri","locationName":"sceneId"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","contentLocation","creationDateTime","sceneId","updateDateTime","workspaceId"],"members":{"arn":{},"capabilities":{"shape":"S1q"},"contentLocation":{},"creationDateTime":{"type":"timestamp"},"description":{},"sceneId":{},"updateDateTime":{"type":"timestamp"},"workspaceId":{}}},"endpoint":{"hostPrefix":"api."}},"GetWorkspace":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","creationDateTime","role","s3Location","updateDateTime","workspaceId"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"},"description":{},"role":{},"s3Location":{},"updateDateTime":{"type":"timestamp"},"workspaceId":{}}},"endpoint":{"hostPrefix":"api."}},"ListComponentTypes":{"http":{"requestUri":"/workspaces/{workspaceId}/component-types-list","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"filters":{"type":"list","member":{"type":"structure","members":{"extendsFrom":{},"isAbstract":{"type":"boolean"},"namespace":{}},"union":true}},"maxResults":{"type":"integer"},"nextToken":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["componentTypeSummaries","workspaceId"],"members":{"componentTypeSummaries":{"type":"list","member":{"type":"structure","required":["arn","componentTypeId","creationDateTime","updateDateTime"],"members":{"arn":{},"componentTypeId":{},"creationDateTime":{"type":"timestamp"},"description":{},"status":{"shape":"S2c"},"updateDateTime":{"type":"timestamp"}}}},"maxResults":{"type":"integer"},"nextToken":{},"workspaceId":{}}},"endpoint":{"hostPrefix":"api."}},"ListEntities":{"http":{"requestUri":"/workspaces/{workspaceId}/entities-list","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"filters":{"type":"list","member":{"type":"structure","members":{"componentTypeId":{},"externalId":{},"parentEntityId":{}},"union":true}},"maxResults":{"type":"integer"},"nextToken":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","members":{"entitySummaries":{"type":"list","member":{"type":"structure","required":["arn","creationDateTime","entityId","entityName","status","updateDateTime"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"},"description":{},"entityId":{},"entityName":{},"hasChildEntities":{"type":"boolean"},"parentEntityId":{},"status":{"shape":"S2c"},"updateDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"endpoint":{"hostPrefix":"api."}},"ListScenes":{"http":{"requestUri":"/workspaces/{workspaceId}/scenes-list","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"maxResults":{"type":"integer"},"nextToken":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","members":{"nextToken":{},"sceneSummaries":{"type":"list","member":{"type":"structure","required":["arn","contentLocation","creationDateTime","sceneId","updateDateTime"],"members":{"arn":{},"contentLocation":{},"creationDateTime":{"type":"timestamp"},"description":{},"sceneId":{},"updateDateTime":{"type":"timestamp"}}}}}},"endpoint":{"hostPrefix":"api."}},"ListTagsForResource":{"http":{"requestUri":"/tags-list","responseCode":200},"input":{"type":"structure","required":["resourceARN"],"members":{"maxResults":{"type":"integer"},"nextToken":{},"resourceARN":{}}},"output":{"type":"structure","members":{"nextToken":{},"tags":{"shape":"S1a"}}},"endpoint":{"hostPrefix":"api."}},"ListWorkspaces":{"http":{"requestUri":"/workspaces-list","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"workspaceSummaries":{"type":"list","member":{"type":"structure","required":["arn","creationDateTime","updateDateTime","workspaceId"],"members":{"arn":{},"creationDateTime":{"type":"timestamp"},"description":{},"updateDateTime":{"type":"timestamp"},"workspaceId":{}}}}}},"endpoint":{"hostPrefix":"api."}},"TagResource":{"http":{"requestUri":"/tags","responseCode":200},"input":{"type":"structure","required":["resourceARN","tags"],"members":{"resourceARN":{},"tags":{"shape":"S1a"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags","responseCode":200},"input":{"type":"structure","required":["resourceARN","tagKeys"],"members":{"resourceARN":{"location":"querystring","locationName":"resourceARN"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"api."}},"UpdateComponentType":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/component-types/{componentTypeId}","responseCode":200},"input":{"type":"structure","required":["componentTypeId","workspaceId"],"members":{"componentTypeId":{"location":"uri","locationName":"componentTypeId"},"description":{},"extendsFrom":{"shape":"Sv"},"functions":{"shape":"Sw"},"isSingleton":{"type":"boolean"},"propertyDefinitions":{"shape":"S13"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","componentTypeId","state","workspaceId"],"members":{"arn":{},"componentTypeId":{},"state":{},"workspaceId":{}}},"endpoint":{"hostPrefix":"api."}},"UpdateEntity":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/entities/{entityId}","responseCode":200},"input":{"type":"structure","required":["entityId","workspaceId"],"members":{"componentUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"componentTypeId":{},"description":{},"propertyUpdates":{"shape":"S1j"},"updateType":{}}}},"description":{},"entityId":{"location":"uri","locationName":"entityId"},"entityName":{},"parentEntityUpdate":{"type":"structure","required":["updateType"],"members":{"parentEntityId":{},"updateType":{}}},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["state","updateDateTime"],"members":{"state":{},"updateDateTime":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"UpdateScene":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/scenes/{sceneId}","responseCode":200},"input":{"type":"structure","required":["sceneId","workspaceId"],"members":{"capabilities":{"shape":"S1q"},"contentLocation":{},"description":{},"sceneId":{"location":"uri","locationName":"sceneId"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["updateDateTime"],"members":{"updateDateTime":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}},"UpdateWorkspace":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"description":{},"role":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["updateDateTime"],"members":{"updateDateTime":{"type":"timestamp"}}},"endpoint":{"hostPrefix":"api."}}},"shapes":{"S3":{"type":"structure","required":["entityPropertyReference"],"members":{"entityPropertyReference":{"shape":"S4"},"propertyValues":{"type":"list","member":{"shape":"Sa"}}}},"S4":{"type":"structure","required":["propertyName"],"members":{"componentName":{},"entityId":{},"externalIdProperty":{"type":"map","key":{},"value":{}},"propertyName":{}}},"Sa":{"type":"structure","required":["value"],"members":{"time":{},"timestamp":{"deprecated":true,"deprecatedMessage":"This field is deprecated and will throw an error in the future. Use time instead.","type":"timestamp"},"value":{"shape":"Sd"}}},"Sd":{"type":"structure","members":{"booleanValue":{"type":"boolean"},"doubleValue":{"type":"double"},"expression":{},"integerValue":{"type":"integer"},"listValue":{"shape":"Si"},"longValue":{"type":"long"},"mapValue":{"type":"map","key":{},"value":{"shape":"Sd"}},"relationshipValue":{"type":"structure","members":{"targetComponentName":{},"targetEntityId":{}}},"stringValue":{}}},"Si":{"type":"list","member":{"shape":"Sd"}},"Sv":{"type":"list","member":{}},"Sw":{"type":"map","key":{},"value":{"type":"structure","members":{"implementedBy":{"shape":"Sy"},"requiredProperties":{"shape":"S11"},"scope":{}}}},"Sy":{"type":"structure","members":{"isNative":{"type":"boolean"},"lambda":{"type":"structure","required":["arn"],"members":{"arn":{}}}}},"S11":{"type":"list","member":{}},"S13":{"type":"map","key":{},"value":{"shape":"S14"}},"S14":{"type":"structure","members":{"configuration":{"shape":"S15"},"dataType":{"shape":"S17"},"defaultValue":{"shape":"Sd"},"isExternalId":{"type":"boolean"},"isRequiredInEntity":{"type":"boolean"},"isStoredExternally":{"type":"boolean"},"isTimeSeries":{"type":"boolean"}}},"S15":{"type":"map","key":{},"value":{}},"S17":{"type":"structure","required":["type"],"members":{"allowedValues":{"shape":"Si"},"nestedType":{"shape":"S17"},"relationship":{"type":"structure","members":{"relationshipType":{},"targetComponentTypeId":{}}},"type":{},"unitOfMeasure":{}}},"S1a":{"type":"map","key":{},"value":{}},"S1j":{"type":"map","key":{},"value":{"type":"structure","members":{"definition":{"shape":"S14"},"updateType":{},"value":{"shape":"Sd"}}}},"S1q":{"type":"list","member":{}},"S2b":{"type":"structure","required":["dataType","isExternalId","isFinal","isImported","isInherited","isRequiredInEntity","isStoredExternally","isTimeSeries"],"members":{"configuration":{"shape":"S15"},"dataType":{"shape":"S17"},"defaultValue":{"shape":"Sd"},"isExternalId":{"type":"boolean"},"isFinal":{"type":"boolean"},"isImported":{"type":"boolean"},"isInherited":{"type":"boolean"},"isRequiredInEntity":{"type":"boolean"},"isStoredExternally":{"type":"boolean"},"isTimeSeries":{"type":"boolean"}}},"S2c":{"type":"structure","members":{"error":{"type":"structure","members":{"code":{},"message":{}}},"state":{}}},"S2n":{"type":"list","member":{}}}}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"GetPropertyValueHistory":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListComponentTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEntities":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListScenes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListWorkspaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{}}

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['workspacesweb'] = {};
	AWS.WorkSpacesWeb = Service.defineService('workspacesweb', ['2020-07-08']);
	Object.defineProperty(apiLoader.services['workspacesweb'], '2020-07-08', {
	  get: function get() {
	    var model = __webpack_require__(1118);
	    model.paginators = __webpack_require__(1119).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.WorkSpacesWeb;


/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-08","endpointPrefix":"workspaces-web","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkSpaces Web","serviceId":"WorkSpaces Web","signatureVersion":"v4","signingName":"workspaces-web","uid":"workspaces-web-2020-07-08"},"operations":{"AssociateBrowserSettings":{"http":{"method":"PUT","requestUri":"/portals/{portalArn+}/browserSettings","responseCode":200},"input":{"type":"structure","required":["browserSettingsArn","portalArn"],"members":{"browserSettingsArn":{"location":"querystring","locationName":"browserSettingsArn"},"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","required":["browserSettingsArn","portalArn"],"members":{"browserSettingsArn":{},"portalArn":{}}},"idempotent":true},"AssociateNetworkSettings":{"http":{"method":"PUT","requestUri":"/portals/{portalArn+}/networkSettings","responseCode":200},"input":{"type":"structure","required":["networkSettingsArn","portalArn"],"members":{"networkSettingsArn":{"location":"querystring","locationName":"networkSettingsArn"},"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","required":["networkSettingsArn","portalArn"],"members":{"networkSettingsArn":{},"portalArn":{}}},"idempotent":true},"AssociateTrustStore":{"http":{"method":"PUT","requestUri":"/portals/{portalArn+}/trustStores","responseCode":200},"input":{"type":"structure","required":["portalArn","trustStoreArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"},"trustStoreArn":{"location":"querystring","locationName":"trustStoreArn"}}},"output":{"type":"structure","required":["portalArn","trustStoreArn"],"members":{"portalArn":{},"trustStoreArn":{}}},"idempotent":true},"AssociateUserSettings":{"http":{"method":"PUT","requestUri":"/portals/{portalArn+}/userSettings","responseCode":200},"input":{"type":"structure","required":["portalArn","userSettingsArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"},"userSettingsArn":{"location":"querystring","locationName":"userSettingsArn"}}},"output":{"type":"structure","required":["portalArn","userSettingsArn"],"members":{"portalArn":{},"userSettingsArn":{}}},"idempotent":true},"CreateBrowserSettings":{"http":{"requestUri":"/browserSettings","responseCode":200},"input":{"type":"structure","required":["browserPolicy"],"members":{"additionalEncryptionContext":{"shape":"Sb"},"browserPolicy":{},"clientToken":{"idempotencyToken":true},"customerManagedKey":{},"tags":{"shape":"Sg"}}},"output":{"type":"structure","required":["browserSettingsArn"],"members":{"browserSettingsArn":{}}}},"CreateIdentityProvider":{"http":{"requestUri":"/identityProviders","responseCode":200},"input":{"type":"structure","required":["identityProviderDetails","identityProviderName","identityProviderType","portalArn"],"members":{"clientToken":{"idempotencyToken":true},"identityProviderDetails":{"shape":"Sm"},"identityProviderName":{},"identityProviderType":{},"portalArn":{}}},"output":{"type":"structure","required":["identityProviderArn"],"members":{"identityProviderArn":{}}}},"CreateNetworkSettings":{"http":{"requestUri":"/networkSettings","responseCode":200},"input":{"type":"structure","required":["securityGroupIds","subnetIds","vpcId"],"members":{"clientToken":{"idempotencyToken":true},"securityGroupIds":{"shape":"Sr"},"subnetIds":{"shape":"St"},"tags":{"shape":"Sg"},"vpcId":{}}},"output":{"type":"structure","required":["networkSettingsArn"],"members":{"networkSettingsArn":{}}}},"CreatePortal":{"http":{"requestUri":"/portals","responseCode":200},"input":{"type":"structure","members":{"additionalEncryptionContext":{"shape":"Sb"},"clientToken":{"idempotencyToken":true},"customerManagedKey":{},"displayName":{},"tags":{"shape":"Sg"}}},"output":{"type":"structure","required":["portalArn","portalEndpoint"],"members":{"portalArn":{},"portalEndpoint":{}}}},"CreateTrustStore":{"http":{"requestUri":"/trustStores","responseCode":200},"input":{"type":"structure","required":["certificateList"],"members":{"certificateList":{"shape":"S12"},"clientToken":{"idempotencyToken":true},"tags":{"shape":"Sg"}}},"output":{"type":"structure","required":["trustStoreArn"],"members":{"trustStoreArn":{}}}},"CreateUserSettings":{"http":{"requestUri":"/userSettings","responseCode":200},"input":{"type":"structure","required":["copyAllowed","downloadAllowed","pasteAllowed","printAllowed","uploadAllowed"],"members":{"clientToken":{"idempotencyToken":true},"copyAllowed":{},"downloadAllowed":{},"pasteAllowed":{},"printAllowed":{},"tags":{"shape":"Sg"},"uploadAllowed":{}}},"output":{"type":"structure","required":["userSettingsArn"],"members":{"userSettingsArn":{}}}},"DeleteBrowserSettings":{"http":{"method":"DELETE","requestUri":"/browserSettings/{browserSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["browserSettingsArn"],"members":{"browserSettingsArn":{"location":"uri","locationName":"browserSettingsArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteIdentityProvider":{"http":{"method":"DELETE","requestUri":"/identityProviders/{identityProviderArn+}","responseCode":200},"input":{"type":"structure","required":["identityProviderArn"],"members":{"identityProviderArn":{"location":"uri","locationName":"identityProviderArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteNetworkSettings":{"http":{"method":"DELETE","requestUri":"/networkSettings/{networkSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["networkSettingsArn"],"members":{"networkSettingsArn":{"location":"uri","locationName":"networkSettingsArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeletePortal":{"http":{"method":"DELETE","requestUri":"/portals/{portalArn+}","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteTrustStore":{"http":{"method":"DELETE","requestUri":"/trustStores/{trustStoreArn+}","responseCode":200},"input":{"type":"structure","required":["trustStoreArn"],"members":{"trustStoreArn":{"location":"uri","locationName":"trustStoreArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteUserSettings":{"http":{"method":"DELETE","requestUri":"/userSettings/{userSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["userSettingsArn"],"members":{"userSettingsArn":{"location":"uri","locationName":"userSettingsArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateBrowserSettings":{"http":{"method":"DELETE","requestUri":"/portals/{portalArn+}/browserSettings","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateNetworkSettings":{"http":{"method":"DELETE","requestUri":"/portals/{portalArn+}/networkSettings","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateTrustStore":{"http":{"method":"DELETE","requestUri":"/portals/{portalArn+}/trustStores","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateUserSettings":{"http":{"method":"DELETE","requestUri":"/portals/{portalArn+}/userSettings","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetBrowserSettings":{"http":{"method":"GET","requestUri":"/browserSettings/{browserSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["browserSettingsArn"],"members":{"browserSettingsArn":{"location":"uri","locationName":"browserSettingsArn"}}},"output":{"type":"structure","members":{"browserSettings":{"shape":"S1u"}}}},"GetIdentityProvider":{"http":{"method":"GET","requestUri":"/identityProviders/{identityProviderArn+}","responseCode":200},"input":{"type":"structure","required":["identityProviderArn"],"members":{"identityProviderArn":{"location":"uri","locationName":"identityProviderArn"}}},"output":{"type":"structure","members":{"identityProvider":{"shape":"S1y"}}}},"GetNetworkSettings":{"http":{"method":"GET","requestUri":"/networkSettings/{networkSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["networkSettingsArn"],"members":{"networkSettingsArn":{"location":"uri","locationName":"networkSettingsArn"}}},"output":{"type":"structure","members":{"networkSettings":{"shape":"S21"}}}},"GetPortal":{"http":{"method":"GET","requestUri":"/portals/{portalArn+}","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{"portal":{"shape":"S24"}}}},"GetPortalServiceProviderMetadata":{"http":{"method":"GET","requestUri":"/portalIdp/{portalArn+}","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","required":["portalArn"],"members":{"portalArn":{},"serviceProviderSamlMetadata":{}}}},"GetTrustStore":{"http":{"method":"GET","requestUri":"/trustStores/{trustStoreArn+}","responseCode":200},"input":{"type":"structure","required":["trustStoreArn"],"members":{"trustStoreArn":{"location":"uri","locationName":"trustStoreArn"}}},"output":{"type":"structure","members":{"trustStore":{"type":"structure","members":{"associatedPortalArns":{"shape":"S1v"},"trustStoreArn":{}}}}}},"GetTrustStoreCertificate":{"http":{"method":"GET","requestUri":"/trustStores/{trustStoreArn+}/certificate","responseCode":200},"input":{"type":"structure","required":["thumbprint","trustStoreArn"],"members":{"thumbprint":{"location":"querystring","locationName":"thumbprint"},"trustStoreArn":{"location":"uri","locationName":"trustStoreArn"}}},"output":{"type":"structure","members":{"certificate":{"type":"structure","members":{"body":{"type":"blob"},"issuer":{},"notValidAfter":{"type":"timestamp"},"notValidBefore":{"type":"timestamp"},"subject":{},"thumbprint":{}}},"trustStoreArn":{}}}},"GetUserSettings":{"http":{"method":"GET","requestUri":"/userSettings/{userSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["userSettingsArn"],"members":{"userSettingsArn":{"location":"uri","locationName":"userSettingsArn"}}},"output":{"type":"structure","members":{"userSettings":{"shape":"S2n"}}}},"ListBrowserSettings":{"http":{"method":"GET","requestUri":"/browserSettings","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"browserSettings":{"type":"list","member":{"type":"structure","members":{"browserSettingsArn":{}}}},"nextToken":{}}}},"ListIdentityProviders":{"http":{"method":"GET","requestUri":"/portals/{portalArn+}/identityProviders","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{"identityProviders":{"type":"list","member":{"type":"structure","members":{"identityProviderArn":{},"identityProviderName":{},"identityProviderType":{}}}},"nextToken":{}}}},"ListNetworkSettings":{"http":{"method":"GET","requestUri":"/networkSettings","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"networkSettings":{"type":"list","member":{"type":"structure","members":{"networkSettingsArn":{},"vpcId":{}}}},"nextToken":{}}}},"ListPortals":{"http":{"method":"GET","requestUri":"/portals","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"portals":{"type":"list","member":{"type":"structure","members":{"browserSettingsArn":{},"browserType":{},"creationDate":{"type":"timestamp"},"displayName":{},"networkSettingsArn":{},"portalArn":{},"portalEndpoint":{},"portalStatus":{},"rendererType":{},"trustStoreArn":{},"userSettingsArn":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn+}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sg"}}}},"ListTrustStoreCertificates":{"http":{"method":"GET","requestUri":"/trustStores/{trustStoreArn+}/certificates","responseCode":200},"input":{"type":"structure","required":["trustStoreArn"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"trustStoreArn":{"location":"uri","locationName":"trustStoreArn"}}},"output":{"type":"structure","members":{"certificateList":{"type":"list","member":{"type":"structure","members":{"issuer":{},"notValidAfter":{"type":"timestamp"},"notValidBefore":{"type":"timestamp"},"subject":{},"thumbprint":{}}}},"nextToken":{},"trustStoreArn":{}}}},"ListTrustStores":{"http":{"method":"GET","requestUri":"/trustStores","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"trustStores":{"type":"list","member":{"type":"structure","members":{"trustStoreArn":{}}}}}}},"ListUserSettings":{"http":{"method":"GET","requestUri":"/userSettings","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"userSettings":{"type":"list","member":{"type":"structure","members":{"copyAllowed":{},"downloadAllowed":{},"pasteAllowed":{},"printAllowed":{},"uploadAllowed":{},"userSettingsArn":{}}}}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn+}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"clientToken":{"idempotencyToken":true},"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn+}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateBrowserSettings":{"http":{"method":"PATCH","requestUri":"/browserSettings/{browserSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["browserSettingsArn"],"members":{"browserPolicy":{},"browserSettingsArn":{"location":"uri","locationName":"browserSettingsArn"},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["browserSettings"],"members":{"browserSettings":{"shape":"S1u"}}}},"UpdateIdentityProvider":{"http":{"method":"PATCH","requestUri":"/identityProviders/{identityProviderArn+}","responseCode":200},"input":{"type":"structure","required":["identityProviderArn"],"members":{"clientToken":{"idempotencyToken":true},"identityProviderArn":{"location":"uri","locationName":"identityProviderArn"},"identityProviderDetails":{"shape":"Sm"},"identityProviderName":{},"identityProviderType":{}}},"output":{"type":"structure","required":["identityProvider"],"members":{"identityProvider":{"shape":"S1y"}}}},"UpdateNetworkSettings":{"http":{"method":"PATCH","requestUri":"/networkSettings/{networkSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["networkSettingsArn"],"members":{"clientToken":{"idempotencyToken":true},"networkSettingsArn":{"location":"uri","locationName":"networkSettingsArn"},"securityGroupIds":{"shape":"Sr"},"subnetIds":{"shape":"St"},"vpcId":{}}},"output":{"type":"structure","required":["networkSettings"],"members":{"networkSettings":{"shape":"S21"}}}},"UpdatePortal":{"http":{"method":"PUT","requestUri":"/portals/{portalArn+}","responseCode":200},"input":{"type":"structure","required":["portalArn"],"members":{"displayName":{},"portalArn":{"location":"uri","locationName":"portalArn"}}},"output":{"type":"structure","members":{"portal":{"shape":"S24"}}},"idempotent":true},"UpdateTrustStore":{"http":{"method":"PATCH","requestUri":"/trustStores/{trustStoreArn+}","responseCode":200},"input":{"type":"structure","required":["trustStoreArn"],"members":{"certificatesToAdd":{"shape":"S12"},"certificatesToDelete":{"type":"list","member":{}},"clientToken":{"idempotencyToken":true},"trustStoreArn":{"location":"uri","locationName":"trustStoreArn"}}},"output":{"type":"structure","required":["trustStoreArn"],"members":{"trustStoreArn":{}}}},"UpdateUserSettings":{"http":{"method":"PATCH","requestUri":"/userSettings/{userSettingsArn+}","responseCode":200},"input":{"type":"structure","required":["userSettingsArn"],"members":{"clientToken":{"idempotencyToken":true},"copyAllowed":{},"downloadAllowed":{},"pasteAllowed":{},"printAllowed":{},"uploadAllowed":{},"userSettingsArn":{"location":"uri","locationName":"userSettingsArn"}}},"output":{"type":"structure","required":["userSettings"],"members":{"userSettings":{"shape":"S2n"}}}}},"shapes":{"Sb":{"type":"map","key":{},"value":{}},"Sg":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sm":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{}},"St":{"type":"list","member":{}},"S12":{"type":"list","member":{"type":"blob"}},"S1u":{"type":"structure","required":["browserSettingsArn"],"members":{"associatedPortalArns":{"shape":"S1v"},"browserPolicy":{},"browserSettingsArn":{}}},"S1v":{"type":"list","member":{}},"S1y":{"type":"structure","required":["identityProviderArn"],"members":{"identityProviderArn":{},"identityProviderDetails":{"shape":"Sm"},"identityProviderName":{},"identityProviderType":{}}},"S21":{"type":"structure","required":["networkSettingsArn"],"members":{"associatedPortalArns":{"shape":"S1v"},"networkSettingsArn":{},"securityGroupIds":{"shape":"Sr"},"subnetIds":{"shape":"St"},"vpcId":{}}},"S24":{"type":"structure","members":{"browserSettingsArn":{},"browserType":{},"creationDate":{"type":"timestamp"},"displayName":{},"networkSettingsArn":{},"portalArn":{},"portalEndpoint":{},"portalStatus":{},"rendererType":{},"statusReason":{},"trustStoreArn":{},"userSettingsArn":{}}},"S2n":{"type":"structure","required":["userSettingsArn"],"members":{"associatedPortalArns":{"shape":"S1v"},"copyAllowed":{},"downloadAllowed":{},"pasteAllowed":{},"printAllowed":{},"uploadAllowed":{},"userSettingsArn":{}}}}}

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListBrowserSettings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListIdentityProviders":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListNetworkSettings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPortals":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListTrustStoreCertificates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListTrustStores":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListUserSettings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['amplifyuibuilder'] = {};
	AWS.AmplifyUIBuilder = Service.defineService('amplifyuibuilder', ['2021-08-11']);
	Object.defineProperty(apiLoader.services['amplifyuibuilder'], '2021-08-11', {
	  get: function get() {
	    var model = __webpack_require__(1121);
	    model.paginators = __webpack_require__(1122).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.AmplifyUIBuilder;


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-08-11","endpointPrefix":"amplifyuibuilder","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Amplify UI Builder","serviceId":"AmplifyUIBuilder","signatureVersion":"v4","signingName":"amplifyuibuilder","uid":"amplifyuibuilder-2021-08-11"},"operations":{"CreateComponent":{"http":{"requestUri":"/app/{appId}/environment/{environmentName}/components","responseCode":200},"input":{"type":"structure","required":["appId","componentToCreate","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"componentToCreate":{"type":"structure","required":["bindingProperties","componentType","name","overrides","properties","variants"],"members":{"bindingProperties":{"shape":"S4"},"children":{"shape":"S9"},"collectionProperties":{"shape":"Sn"},"componentType":{},"events":{"shape":"Sb"},"name":{},"overrides":{"shape":"Sv"},"properties":{"shape":"Sl"},"schemaVersion":{},"sourceId":{},"tags":{"shape":"Sx"},"variants":{"shape":"S10"}}},"environmentName":{"location":"uri","locationName":"environmentName"}},"payload":"componentToCreate"},"output":{"type":"structure","members":{"entity":{"shape":"S14"}},"payload":"entity"},"idempotent":true},"CreateTheme":{"http":{"requestUri":"/app/{appId}/environment/{environmentName}/themes","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","themeToCreate"],"members":{"appId":{"location":"uri","locationName":"appId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"environmentName":{"location":"uri","locationName":"environmentName"},"themeToCreate":{"type":"structure","required":["name","values"],"members":{"name":{},"overrides":{"shape":"S1a"},"tags":{"shape":"Sx"},"values":{"shape":"S1a"}}}},"payload":"themeToCreate"},"output":{"type":"structure","members":{"entity":{"shape":"S1e"}},"payload":"entity"},"idempotent":true},"DeleteComponent":{"http":{"method":"DELETE","requestUri":"/app/{appId}/environment/{environmentName}/components/{id}","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","id"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"id":{"location":"uri","locationName":"id"}}},"idempotent":true},"DeleteTheme":{"http":{"method":"DELETE","requestUri":"/app/{appId}/environment/{environmentName}/themes/{id}","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","id"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"id":{"location":"uri","locationName":"id"}}},"idempotent":true},"ExchangeCodeForToken":{"http":{"requestUri":"/tokens/{provider}","responseCode":200},"input":{"type":"structure","required":["provider","request"],"members":{"provider":{"location":"uri","locationName":"provider"},"request":{"type":"structure","required":["code","redirectUri"],"members":{"code":{"shape":"S1k"},"redirectUri":{}}}},"payload":"request"},"output":{"type":"structure","required":["accessToken","expiresIn","refreshToken"],"members":{"accessToken":{"shape":"S1k"},"expiresIn":{"type":"integer"},"refreshToken":{"shape":"S1k"}}}},"ExportComponents":{"http":{"method":"GET","requestUri":"/export/app/{appId}/environment/{environmentName}/components","responseCode":200},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["entities"],"members":{"entities":{"type":"list","member":{"shape":"S14"}},"nextToken":{}}}},"ExportThemes":{"http":{"method":"GET","requestUri":"/export/app/{appId}/environment/{environmentName}/themes","responseCode":200},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["entities"],"members":{"entities":{"type":"list","member":{"shape":"S1e"}},"nextToken":{}}}},"GetComponent":{"http":{"method":"GET","requestUri":"/app/{appId}/environment/{environmentName}/components/{id}","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","id"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"component":{"shape":"S14"}},"payload":"component"}},"GetTheme":{"http":{"method":"GET","requestUri":"/app/{appId}/environment/{environmentName}/themes/{id}","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","id"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"theme":{"shape":"S1e"}},"payload":"theme"}},"ListComponents":{"http":{"method":"GET","requestUri":"/app/{appId}/environment/{environmentName}/components","responseCode":200},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["entities"],"members":{"entities":{"type":"list","member":{"type":"structure","required":["appId","componentType","environmentName","id","name"],"members":{"appId":{},"componentType":{},"environmentName":{},"id":{},"name":{}}}},"nextToken":{}}}},"ListThemes":{"http":{"method":"GET","requestUri":"/app/{appId}/environment/{environmentName}/themes","responseCode":200},"input":{"type":"structure","required":["appId","environmentName"],"members":{"appId":{"location":"uri","locationName":"appId"},"environmentName":{"location":"uri","locationName":"environmentName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["entities"],"members":{"entities":{"type":"list","member":{"type":"structure","required":["appId","environmentName","id","name"],"members":{"appId":{},"environmentName":{},"id":{},"name":{}}}},"nextToken":{}}}},"RefreshToken":{"http":{"requestUri":"/tokens/{provider}/refresh","responseCode":200},"input":{"type":"structure","required":["provider","refreshTokenBody"],"members":{"provider":{"location":"uri","locationName":"provider"},"refreshTokenBody":{"type":"structure","required":["token"],"members":{"token":{"shape":"S1k"}}}},"payload":"refreshTokenBody"},"output":{"type":"structure","required":["accessToken","expiresIn"],"members":{"accessToken":{"shape":"S1k"},"expiresIn":{"type":"integer"}}}},"UpdateComponent":{"http":{"method":"PATCH","requestUri":"/app/{appId}/environment/{environmentName}/components/{id}","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","id","updatedComponent"],"members":{"appId":{"location":"uri","locationName":"appId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"environmentName":{"location":"uri","locationName":"environmentName"},"id":{"location":"uri","locationName":"id"},"updatedComponent":{"type":"structure","members":{"bindingProperties":{"shape":"S4"},"children":{"shape":"S9"},"collectionProperties":{"shape":"Sn"},"componentType":{},"events":{"shape":"Sb"},"id":{},"name":{},"overrides":{"shape":"Sv"},"properties":{"shape":"Sl"},"schemaVersion":{},"sourceId":{},"variants":{"shape":"S10"}}}},"payload":"updatedComponent"},"output":{"type":"structure","members":{"entity":{"shape":"S14"}},"payload":"entity"},"idempotent":true},"UpdateTheme":{"http":{"method":"PATCH","requestUri":"/app/{appId}/environment/{environmentName}/themes/{id}","responseCode":200},"input":{"type":"structure","required":["appId","environmentName","id","updatedTheme"],"members":{"appId":{"location":"uri","locationName":"appId"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"environmentName":{"location":"uri","locationName":"environmentName"},"id":{"location":"uri","locationName":"id"},"updatedTheme":{"type":"structure","required":["values"],"members":{"id":{},"name":{},"overrides":{"shape":"S1a"},"values":{"shape":"S1a"}}}},"payload":"updatedTheme"},"output":{"type":"structure","members":{"entity":{"shape":"S1e"}},"payload":"entity"},"idempotent":true}},"shapes":{"S4":{"type":"map","key":{},"value":{"type":"structure","members":{"bindingProperties":{"type":"structure","members":{"bucket":{},"defaultValue":{},"field":{},"key":{},"model":{},"predicates":{"shape":"S7"},"userAttribute":{}}},"defaultValue":{},"type":{}}}},"S7":{"type":"list","member":{"shape":"S8"}},"S8":{"type":"structure","members":{"and":{"shape":"S7"},"field":{},"operand":{},"operator":{},"or":{"shape":"S7"}}},"S9":{"type":"list","member":{"type":"structure","required":["componentType","name","properties"],"members":{"children":{"shape":"S9"},"componentType":{},"events":{"shape":"Sb"},"name":{},"properties":{"shape":"Sl"},"sourceId":{}}}},"Sb":{"type":"map","key":{},"value":{"type":"structure","members":{"action":{},"bindingEvent":{},"parameters":{"type":"structure","members":{"anchor":{"shape":"Se"},"fields":{"shape":"Sl"},"global":{"shape":"Se"},"id":{"shape":"Se"},"model":{},"state":{"type":"structure","required":["componentName","property","set"],"members":{"componentName":{},"property":{},"set":{"shape":"Se"}}},"target":{"shape":"Se"},"type":{"shape":"Se"},"url":{"shape":"Se"}}}}}},"Se":{"type":"structure","members":{"bindingProperties":{"shape":"Sf"},"bindings":{"type":"map","key":{},"value":{"type":"structure","required":["element","property"],"members":{"element":{},"property":{}}}},"collectionBindingProperties":{"shape":"Sf"},"componentName":{},"concat":{"type":"list","member":{"shape":"Se"}},"condition":{"type":"structure","members":{"else":{"shape":"Se"},"field":{},"operand":{},"operandType":{},"operator":{},"property":{},"then":{"shape":"Se"}}},"configured":{"type":"boolean"},"defaultValue":{},"event":{},"importedValue":{},"model":{},"property":{},"type":{},"userAttribute":{},"value":{}}},"Sf":{"type":"structure","required":["property"],"members":{"field":{},"property":{}}},"Sl":{"type":"map","key":{},"value":{"shape":"Se"}},"Sn":{"type":"map","key":{},"value":{"type":"structure","required":["model"],"members":{"identifiers":{"type":"list","member":{}},"model":{},"predicate":{"shape":"S8"},"sort":{"type":"list","member":{"type":"structure","required":["direction","field"],"members":{"direction":{},"field":{}}}}}}},"Sv":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{}}},"Sx":{"type":"map","key":{},"value":{}},"S10":{"type":"list","member":{"type":"structure","members":{"overrides":{"shape":"Sv"},"variantValues":{"type":"map","key":{},"value":{}}}}},"S14":{"type":"structure","required":["appId","bindingProperties","componentType","createdAt","environmentName","id","name","overrides","properties","variants"],"members":{"appId":{},"bindingProperties":{"shape":"S4"},"children":{"shape":"S9"},"collectionProperties":{"shape":"Sn"},"componentType":{},"createdAt":{"shape":"S15"},"environmentName":{},"events":{"shape":"Sb"},"id":{},"modifiedAt":{"shape":"S15"},"name":{},"overrides":{"shape":"Sv"},"properties":{"shape":"Sl"},"schemaVersion":{},"sourceId":{},"tags":{"shape":"Sx"},"variants":{"shape":"S10"}}},"S15":{"type":"timestamp","timestampFormat":"iso8601"},"S1a":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{"type":"structure","members":{"children":{"shape":"S1a"},"value":{}}}}}},"S1e":{"type":"structure","required":["appId","createdAt","environmentName","id","name","values"],"members":{"appId":{},"createdAt":{"shape":"S15"},"environmentName":{},"id":{},"modifiedAt":{"shape":"S15"},"name":{},"overrides":{"shape":"S1a"},"tags":{"shape":"Sx"},"values":{"shape":"S1a"}}},"S1k":{"type":"string","sensitive":true}}}

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ExportComponents":{"input_token":"nextToken","output_token":"nextToken","result_key":"entities"},"ExportThemes":{"input_token":"nextToken","output_token":"nextToken","result_key":"entities"},"ListComponents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"entities"},"ListThemes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"entities"}}}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['keyspaces'] = {};
	AWS.Keyspaces = Service.defineService('keyspaces', ['2022-02-10']);
	Object.defineProperty(apiLoader.services['keyspaces'], '2022-02-10', {
	  get: function get() {
	    var model = __webpack_require__(1124);
	    model.paginators = __webpack_require__(1125).pagination;
	    model.waiters = __webpack_require__(1126).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Keyspaces;


/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2022-02-10","endpointPrefix":"cassandra","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon Keyspaces","serviceId":"Keyspaces","signatureVersion":"v4","signingName":"cassandra","targetPrefix":"KeyspacesService","uid":"keyspaces-2022-02-10"},"operations":{"CreateKeyspace":{"input":{"type":"structure","required":["keyspaceName"],"members":{"keyspaceName":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}}},"CreateTable":{"input":{"type":"structure","required":["keyspaceName","tableName","schemaDefinition"],"members":{"keyspaceName":{},"tableName":{},"schemaDefinition":{"shape":"Sb"},"comment":{"shape":"Sm"},"capacitySpecification":{"shape":"So"},"encryptionSpecification":{"shape":"Sr"},"pointInTimeRecovery":{"shape":"Su"},"ttl":{"shape":"Sw"},"defaultTimeToLive":{"type":"integer"},"tags":{"shape":"S3"}}},"output":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}}},"DeleteKeyspace":{"input":{"type":"structure","required":["keyspaceName"],"members":{"keyspaceName":{}}},"output":{"type":"structure","members":{}}},"DeleteTable":{"input":{"type":"structure","required":["keyspaceName","tableName"],"members":{"keyspaceName":{},"tableName":{}}},"output":{"type":"structure","members":{}}},"GetKeyspace":{"input":{"type":"structure","required":["keyspaceName"],"members":{"keyspaceName":{}}},"output":{"type":"structure","required":["keyspaceName","resourceArn"],"members":{"keyspaceName":{},"resourceArn":{}}}},"GetTable":{"input":{"type":"structure","required":["keyspaceName","tableName"],"members":{"keyspaceName":{},"tableName":{}}},"output":{"type":"structure","required":["keyspaceName","tableName","resourceArn"],"members":{"keyspaceName":{},"tableName":{},"resourceArn":{},"creationTimestamp":{"type":"timestamp"},"status":{},"schemaDefinition":{"shape":"Sb"},"capacitySpecification":{"type":"structure","required":["throughputMode"],"members":{"throughputMode":{},"readCapacityUnits":{"type":"long"},"writeCapacityUnits":{"type":"long"},"lastUpdateToPayPerRequestTimestamp":{"type":"timestamp"}}},"encryptionSpecification":{"shape":"Sr"},"pointInTimeRecovery":{"type":"structure","required":["status"],"members":{"status":{},"earliestRestorableTimestamp":{"type":"timestamp"}}},"ttl":{"shape":"Sw"},"defaultTimeToLive":{"type":"integer"},"comment":{"shape":"Sm"}}}},"ListKeyspaces":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["keyspaces"],"members":{"nextToken":{},"keyspaces":{"type":"list","member":{"type":"structure","required":["keyspaceName","resourceArn"],"members":{"keyspaceName":{},"resourceArn":{}}}}}}},"ListTables":{"input":{"type":"structure","required":["keyspaceName"],"members":{"nextToken":{},"maxResults":{"type":"integer"},"keyspaceName":{}}},"output":{"type":"structure","members":{"nextToken":{},"tables":{"type":"list","member":{"type":"structure","required":["keyspaceName","tableName","resourceArn"],"members":{"keyspaceName":{},"tableName":{},"resourceArn":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"tags":{"shape":"S3"}}}},"RestoreTable":{"input":{"type":"structure","required":["sourceKeyspaceName","sourceTableName","targetKeyspaceName","targetTableName"],"members":{"sourceKeyspaceName":{},"sourceTableName":{},"targetKeyspaceName":{},"targetTableName":{},"restoreTimestamp":{"type":"timestamp"},"capacitySpecificationOverride":{"shape":"So"},"encryptionSpecificationOverride":{"shape":"Sr"},"pointInTimeRecoveryOverride":{"shape":"Su"},"tagsOverride":{"shape":"S3"}}},"output":{"type":"structure","required":["restoredTableARN"],"members":{"restoredTableARN":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UpdateTable":{"input":{"type":"structure","required":["keyspaceName","tableName"],"members":{"keyspaceName":{},"tableName":{},"addColumns":{"shape":"Sc"},"capacitySpecification":{"shape":"So"},"encryptionSpecification":{"shape":"Sr"},"pointInTimeRecovery":{"shape":"Su"},"ttl":{"shape":"Sw"},"defaultTimeToLive":{"type":"integer"}}},"output":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sb":{"type":"structure","required":["allColumns","partitionKeys"],"members":{"allColumns":{"shape":"Sc"},"partitionKeys":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"clusteringKeys":{"type":"list","member":{"type":"structure","required":["name","orderBy"],"members":{"name":{},"orderBy":{}}}},"staticColumns":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}}}},"Sc":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"Sm":{"type":"structure","required":["message"],"members":{"message":{}}},"So":{"type":"structure","required":["throughputMode"],"members":{"throughputMode":{},"readCapacityUnits":{"type":"long"},"writeCapacityUnits":{"type":"long"}}},"Sr":{"type":"structure","required":["type"],"members":{"type":{},"kmsKeyIdentifier":{}}},"Su":{"type":"structure","required":["status"],"members":{"status":{}}},"Sw":{"type":"structure","required":["status"],"members":{"status":{}}}}}

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListKeyspaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"keyspaces"},"ListTables":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tables"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tags"}}}

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{}}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['billingconductor'] = {};
	AWS.Billingconductor = Service.defineService('billingconductor', ['2021-07-30']);
	Object.defineProperty(apiLoader.services['billingconductor'], '2021-07-30', {
	  get: function get() {
	    var model = __webpack_require__(1128);
	    model.paginators = __webpack_require__(1129).pagination;
	    model.waiters = __webpack_require__(1130).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Billingconductor;


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-07-30","endpointPrefix":"billingconductor","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWSBillingConductor","serviceId":"billingconductor","signatureVersion":"v4","signingName":"billingconductor","uid":"billingconductor-2021-07-30"},"operations":{"AssociateAccounts":{"http":{"requestUri":"/associate-accounts","responseCode":200},"input":{"type":"structure","required":["Arn","AccountIds"],"members":{"Arn":{},"AccountIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"AssociatePricingRules":{"http":{"method":"PUT","requestUri":"/associate-pricing-rules","responseCode":200},"input":{"type":"structure","required":["Arn","PricingRuleArns"],"members":{"Arn":{},"PricingRuleArns":{"shape":"S8"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"BatchAssociateResourcesToCustomLineItem":{"http":{"method":"PUT","requestUri":"/batch-associate-resources-to-custom-line-item","responseCode":200},"input":{"type":"structure","required":["TargetArn","ResourceArns"],"members":{"TargetArn":{},"ResourceArns":{"type":"list","member":{}},"BillingPeriodRange":{"shape":"Sf"}}},"output":{"type":"structure","members":{"SuccessfullyAssociatedResources":{"shape":"Si"},"FailedAssociatedResources":{"shape":"Si"}}},"idempotent":true},"BatchDisassociateResourcesFromCustomLineItem":{"http":{"method":"PUT","requestUri":"/batch-disassociate-resources-from-custom-line-item","responseCode":200},"input":{"type":"structure","required":["TargetArn","ResourceArns"],"members":{"TargetArn":{},"ResourceArns":{"type":"list","member":{}},"BillingPeriodRange":{"shape":"Sf"}}},"output":{"type":"structure","members":{"SuccessfullyDisassociatedResources":{"shape":"Sq"},"FailedDisassociatedResources":{"shape":"Sq"}}},"idempotent":true},"CreateBillingGroup":{"http":{"requestUri":"/create-billing-group","responseCode":200},"input":{"type":"structure","required":["Name","AccountGrouping","ComputationPreference"],"members":{"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"},"Name":{"shape":"Su"},"AccountGrouping":{"type":"structure","required":["LinkedAccountIds"],"members":{"LinkedAccountIds":{"shape":"S3"}}},"ComputationPreference":{"shape":"Sw"},"PrimaryAccountId":{},"Description":{"shape":"Sy"},"Tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"CreateCustomLineItem":{"http":{"requestUri":"/create-custom-line-item","responseCode":200},"input":{"type":"structure","required":["Name","Description","BillingGroupArn","ChargeDetails"],"members":{"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"},"Name":{"shape":"S14"},"Description":{"shape":"S15"},"BillingGroupArn":{},"BillingPeriodRange":{"shape":"Sf"},"Tags":{"shape":"Sz"},"ChargeDetails":{"type":"structure","required":["Type"],"members":{"Flat":{"type":"structure","required":["ChargeValue"],"members":{"ChargeValue":{"type":"double"}}},"Percentage":{"type":"structure","required":["PercentageValue"],"members":{"PercentageValue":{"type":"double"},"AssociatedValues":{"type":"list","member":{}}}},"Type":{}}}}},"output":{"type":"structure","members":{"Arn":{}}}},"CreatePricingPlan":{"http":{"requestUri":"/create-pricing-plan","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"},"Name":{"shape":"S1f"},"Description":{"shape":"S1g"},"PricingRuleArns":{"type":"list","member":{}},"Tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"CreatePricingRule":{"http":{"requestUri":"/create-pricing-rule","responseCode":200},"input":{"type":"structure","required":["Name","Scope","Type","ModifierPercentage"],"members":{"ClientToken":{"idempotencyToken":true,"location":"header","locationName":"X-Amzn-Client-Token"},"Name":{"shape":"S1k"},"Description":{"shape":"S1l"},"Scope":{},"Type":{},"ModifierPercentage":{"type":"double"},"Service":{},"Tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"DeleteBillingGroup":{"http":{"requestUri":"/delete-billing-group","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"DeleteCustomLineItem":{"http":{"requestUri":"/delete-custom-line-item","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"BillingPeriodRange":{"shape":"Sf"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"DeletePricingPlan":{"http":{"requestUri":"/delete-pricing-plan","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"DeletePricingRule":{"http":{"requestUri":"/delete-pricing-rule","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"DisassociateAccounts":{"http":{"requestUri":"/disassociate-accounts","responseCode":200},"input":{"type":"structure","required":["Arn","AccountIds"],"members":{"Arn":{},"AccountIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"DisassociatePricingRules":{"http":{"method":"PUT","requestUri":"/disassociate-pricing-rules","responseCode":200},"input":{"type":"structure","required":["Arn","PricingRuleArns"],"members":{"Arn":{},"PricingRuleArns":{"shape":"S8"}}},"output":{"type":"structure","members":{"Arn":{}}},"idempotent":true},"ListAccountAssociations":{"http":{"requestUri":"/list-account-associations","responseCode":200},"input":{"type":"structure","members":{"BillingPeriod":{},"Filters":{"type":"structure","members":{"Association":{},"AccountId":{}}},"NextToken":{}}},"output":{"type":"structure","members":{"LinkedAccounts":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"BillingGroupArn":{},"AccountName":{"type":"string","sensitive":true},"AccountEmail":{"type":"string","sensitive":true}}}},"NextToken":{}}}},"ListBillingGroupCostReports":{"http":{"requestUri":"/list-billing-group-cost-reports","responseCode":200},"input":{"type":"structure","members":{"BillingPeriod":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"structure","members":{"BillingGroupArns":{"shape":"S2f"}}}}},"output":{"type":"structure","members":{"BillingGroupCostReports":{"type":"list","member":{"type":"structure","members":{"Arn":{},"AWSCost":{},"ProformaCost":{},"Margin":{},"MarginPercentage":{},"Currency":{}}}},"NextToken":{}}}},"ListBillingGroups":{"http":{"requestUri":"/list-billing-groups","responseCode":200},"input":{"type":"structure","members":{"BillingPeriod":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"structure","members":{"Arns":{"shape":"S2f"},"PricingPlan":{}}}}},"output":{"type":"structure","members":{"BillingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"Su"},"Arn":{},"Description":{"shape":"Sy"},"PrimaryAccountId":{},"ComputationPreference":{"shape":"Sw"},"Size":{"type":"long"},"CreationTime":{"type":"long"},"LastModifiedTime":{"type":"long"},"Status":{},"StatusReason":{}}}},"NextToken":{}}}},"ListCustomLineItems":{"http":{"requestUri":"/list-custom-line-items","responseCode":200},"input":{"type":"structure","members":{"BillingPeriod":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"structure","members":{"Names":{"type":"list","member":{"shape":"S14"}},"BillingGroups":{"shape":"S2f"},"Arns":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"CustomLineItems":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{"shape":"S14"},"ChargeDetails":{"shape":"S34"},"CurrencyCode":{},"Description":{"shape":"S15"},"ProductCode":{},"BillingGroupArn":{},"CreationTime":{"type":"long"},"LastModifiedTime":{"type":"long"},"AssociationSize":{"type":"long"}}}},"NextToken":{}}}},"ListPricingPlans":{"http":{"requestUri":"/list-pricing-plans","responseCode":200},"input":{"type":"structure","members":{"BillingPeriod":{},"Filters":{"type":"structure","members":{"Arns":{"shape":"S3c"}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BillingPeriod":{},"PricingPlans":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"S1f"},"Arn":{},"Description":{"shape":"S1g"},"Size":{"type":"long"},"CreationTime":{"type":"long"},"LastModifiedTime":{"type":"long"}}}},"NextToken":{}}}},"ListPricingPlansAssociatedWithPricingRule":{"http":{"requestUri":"/list-pricing-plans-associated-with-pricing-rule","responseCode":200},"input":{"type":"structure","required":["PricingRuleArn"],"members":{"BillingPeriod":{},"PricingRuleArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BillingPeriod":{},"PricingRuleArn":{},"PricingPlanArns":{"shape":"S3c"},"NextToken":{}}}},"ListPricingRules":{"http":{"requestUri":"/list-pricing-rules","responseCode":200},"input":{"type":"structure","members":{"BillingPeriod":{},"Filters":{"type":"structure","members":{"Arns":{"shape":"S3n"}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BillingPeriod":{},"PricingRules":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"S1k"},"Arn":{},"Description":{"shape":"S1l"},"Scope":{},"Type":{},"ModifierPercentage":{"type":"double"},"Service":{},"AssociatedPricingPlanCount":{"type":"long"},"CreationTime":{"type":"long"},"LastModifiedTime":{"type":"long"}}}},"NextToken":{}}}},"ListPricingRulesAssociatedToPricingPlan":{"http":{"requestUri":"/list-pricing-rules-associated-to-pricing-plan","responseCode":200},"input":{"type":"structure","required":["PricingPlanArn"],"members":{"BillingPeriod":{},"PricingPlanArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BillingPeriod":{},"PricingPlanArn":{},"PricingRuleArns":{"shape":"S3n"},"NextToken":{}}}},"ListResourcesAssociatedToCustomLineItem":{"http":{"requestUri":"/list-resources-associated-to-custom-line-item","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"BillingPeriod":{},"Arn":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"structure","members":{"Relationship":{}}}}},"output":{"type":"structure","members":{"Arn":{},"AssociatedResources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Relationship":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sz"}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateBillingGroup":{"http":{"requestUri":"/update-billing-group","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Name":{"shape":"Su"},"Status":{},"ComputationPreference":{"shape":"Sw"},"Description":{"shape":"Sy"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{"shape":"Su"},"Description":{"shape":"Sy"},"PrimaryAccountId":{},"PricingPlanArn":{},"Size":{"type":"long"},"LastModifiedTime":{"type":"long"},"Status":{},"StatusReason":{}}},"idempotent":true},"UpdateCustomLineItem":{"http":{"requestUri":"/update-custom-line-item","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Name":{"shape":"Su"},"Description":{"shape":"S15"},"ChargeDetails":{"type":"structure","members":{"Flat":{"type":"structure","required":["ChargeValue"],"members":{"ChargeValue":{"type":"double"}}},"Percentage":{"type":"structure","required":["PercentageValue"],"members":{"PercentageValue":{"type":"double"}}}}},"BillingPeriodRange":{"shape":"Sf"}}},"output":{"type":"structure","members":{"Arn":{},"BillingGroupArn":{},"Name":{"shape":"S14"},"Description":{"shape":"S15"},"ChargeDetails":{"shape":"S34"},"LastModifiedTime":{"type":"long"},"AssociationSize":{"type":"long"}}},"idempotent":true},"UpdatePricingPlan":{"http":{"method":"PUT","requestUri":"/update-pricing-plan","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Name":{"shape":"S1f"},"Description":{"shape":"S1g"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{"shape":"S1f"},"Description":{"shape":"S1g"},"Size":{"type":"long"},"LastModifiedTime":{"type":"long"}}},"idempotent":true},"UpdatePricingRule":{"http":{"method":"PUT","requestUri":"/update-pricing-rule","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Name":{"shape":"S1k"},"Description":{"shape":"S1l"},"Type":{},"ModifierPercentage":{"type":"double"}}},"output":{"type":"structure","members":{"Arn":{},"Name":{"shape":"S1k"},"Description":{"shape":"S1l"},"Scope":{},"Type":{},"ModifierPercentage":{"type":"double"},"Service":{},"AssociatedPricingPlanCount":{"type":"long"},"LastModifiedTime":{"type":"long"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"list","member":{}},"Sf":{"type":"structure","required":["InclusiveStartBillingPeriod","ExclusiveEndBillingPeriod"],"members":{"InclusiveStartBillingPeriod":{},"ExclusiveEndBillingPeriod":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Error":{"shape":"Sk"}}}},"Sk":{"type":"structure","members":{"Message":{},"Reason":{}}},"Sq":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Error":{"shape":"Sk"}}}},"Su":{"type":"string","sensitive":true},"Sw":{"type":"structure","required":["PricingPlanArn"],"members":{"PricingPlanArn":{}}},"Sy":{"type":"string","sensitive":true},"Sz":{"type":"map","key":{},"value":{}},"S14":{"type":"string","sensitive":true},"S15":{"type":"string","sensitive":true},"S1f":{"type":"string","sensitive":true},"S1g":{"type":"string","sensitive":true},"S1k":{"type":"string","sensitive":true},"S1l":{"type":"string","sensitive":true},"S2f":{"type":"list","member":{}},"S34":{"type":"structure","required":["Type"],"members":{"Flat":{"type":"structure","required":["ChargeValue"],"members":{"ChargeValue":{"type":"double"}}},"Percentage":{"type":"structure","required":["PercentageValue"],"members":{"PercentageValue":{"type":"double"}}},"Type":{}}},"S3c":{"type":"list","member":{}},"S3n":{"type":"list","member":{}}}}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListAccountAssociations":{"input_token":"NextToken","output_token":"NextToken","result_key":"LinkedAccounts"},"ListBillingGroupCostReports":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"BillingGroupCostReports"},"ListBillingGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"BillingGroups"},"ListCustomLineItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CustomLineItems"},"ListPricingPlans":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["BillingPeriod"],"output_token":"NextToken","result_key":"PricingPlans"},"ListPricingPlansAssociatedWithPricingRule":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["BillingPeriod","PricingRuleArn"],"output_token":"NextToken","result_key":"PricingPlanArns"},"ListPricingRules":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["BillingPeriod"],"output_token":"NextToken","result_key":"PricingRules"},"ListPricingRulesAssociatedToPricingPlan":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["BillingPeriod","PricingPlanArn"],"output_token":"NextToken","result_key":"PricingRuleArns"},"ListResourcesAssociatedToCustomLineItem":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["Arn"],"output_token":"NextToken","result_key":"AssociatedResources"}}}

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{}}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['gamesparks'] = {};
	AWS.GameSparks = Service.defineService('gamesparks', ['2021-08-17']);
	Object.defineProperty(apiLoader.services['gamesparks'], '2021-08-17', {
	  get: function get() {
	    var model = __webpack_require__(1132);
	    model.paginators = __webpack_require__(1133).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.GameSparks;


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-08-17","endpointPrefix":"gamesparks","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"GameSparks","serviceId":"GameSparks","signatureVersion":"v4","signingName":"gamesparks","uid":"gamesparks-2021-08-17"},"operations":{"CreateGame":{"http":{"requestUri":"/game","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"ClientToken":{},"Description":{},"GameName":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"Game":{"shape":"S9"}}},"idempotent":true},"CreateSnapshot":{"http":{"requestUri":"/game/{GameName}/snapshot","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"Description":{},"GameName":{"location":"uri","locationName":"GameName"}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"Sh"}}}},"CreateStage":{"http":{"requestUri":"/game/{GameName}/stage","responseCode":200},"input":{"type":"structure","required":["GameName","Role","StageName"],"members":{"ClientToken":{},"Description":{},"GameName":{"location":"uri","locationName":"GameName"},"Role":{},"StageName":{},"Tags":{"shape":"S5"}}},"output":{"type":"structure","members":{"Stage":{"shape":"St"}}},"idempotent":true},"DeleteGame":{"http":{"method":"DELETE","requestUri":"/game/{GameName}","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"GameName":{"location":"uri","locationName":"GameName"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/game/{GameName}/stage/{StageName}","responseCode":200},"input":{"type":"structure","required":["GameName","StageName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisconnectPlayer":{"http":{"requestUri":"/runtime/game/{GameName}/stage/{StageName}/player/{PlayerId}/disconnect","responseCode":200},"input":{"type":"structure","required":["GameName","PlayerId","StageName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"PlayerId":{"location":"uri","locationName":"PlayerId"},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"DisconnectFailures":{"shape":"S14"},"DisconnectSuccesses":{"shape":"S14"}}},"idempotent":true},"ExportSnapshot":{"http":{"method":"GET","requestUri":"/game/{GameName}/snapshot/{SnapshotId}/export","responseCode":200},"input":{"type":"structure","required":["GameName","SnapshotId"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"SnapshotId":{"location":"uri","locationName":"SnapshotId"}}},"output":{"type":"structure","members":{"S3Url":{}}}},"GetExtension":{"http":{"method":"GET","requestUri":"/extension/{Namespace}/{Name}","responseCode":200},"input":{"type":"structure","required":["Name","Namespace"],"members":{"Name":{"location":"uri","locationName":"Name"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Extension":{"shape":"S1d"}}}},"GetExtensionVersion":{"http":{"method":"GET","requestUri":"/extension/{Namespace}/{Name}/version/{ExtensionVersion}","responseCode":200},"input":{"type":"structure","required":["ExtensionVersion","Name","Namespace"],"members":{"ExtensionVersion":{"location":"uri","locationName":"ExtensionVersion"},"Name":{"location":"uri","locationName":"Name"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"ExtensionVersion":{"shape":"S1i"}}}},"GetGame":{"http":{"method":"GET","requestUri":"/game/{GameName}","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"GameName":{"location":"uri","locationName":"GameName"}}},"output":{"type":"structure","members":{"Game":{"shape":"S9"}}}},"GetGameConfiguration":{"http":{"method":"GET","requestUri":"/game/{GameName}/configuration","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"Sections":{"shape":"S1n","location":"querystring","locationName":"Sections"}}},"output":{"type":"structure","members":{"GameConfiguration":{"shape":"S1p"}}}},"GetGeneratedCodeJob":{"http":{"method":"GET","requestUri":"/game/{GameName}/snapshot/{SnapshotId}/generated-sdk-code-job/{JobId}","responseCode":200},"input":{"type":"structure","required":["GameName","JobId","SnapshotId"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"JobId":{"location":"uri","locationName":"JobId"},"SnapshotId":{"location":"uri","locationName":"SnapshotId"}}},"output":{"type":"structure","members":{"GeneratedCodeJob":{"shape":"S1t"}}}},"GetPlayerConnectionStatus":{"http":{"method":"GET","requestUri":"/runtime/game/{GameName}/stage/{StageName}/player/{PlayerId}/connection","responseCode":200},"input":{"type":"structure","required":["GameName","PlayerId","StageName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"PlayerId":{"location":"uri","locationName":"PlayerId"},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"type":"structure","members":{"Created":{"shape":"Sb"},"Id":{}}}}}}},"GetSnapshot":{"http":{"method":"GET","requestUri":"/game/{GameName}/snapshot/{SnapshotId}","responseCode":200},"input":{"type":"structure","required":["GameName","SnapshotId"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"Sections":{"shape":"S1n","location":"querystring","locationName":"Sections"},"SnapshotId":{"location":"uri","locationName":"SnapshotId"}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"Sh"}}}},"GetStage":{"http":{"method":"GET","requestUri":"/game/{GameName}/stage/{StageName}","responseCode":200},"input":{"type":"structure","required":["GameName","StageName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"Stage":{"shape":"St"}}}},"GetStageDeployment":{"http":{"method":"GET","requestUri":"/game/{GameName}/stage/{StageName}/deployment","responseCode":200},"input":{"type":"structure","required":["GameName","StageName"],"members":{"DeploymentId":{"location":"querystring","locationName":"DeploymentId"},"GameName":{"location":"uri","locationName":"GameName"},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"StageDeployment":{"shape":"S27"}}}},"ImportGameConfiguration":{"http":{"method":"PUT","requestUri":"/game/{GameName}/configuration","responseCode":200},"input":{"type":"structure","required":["GameName","ImportSource"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"ImportSource":{"type":"structure","required":["File"],"members":{"File":{"type":"blob"}}}}},"output":{"type":"structure","members":{"GameConfiguration":{"shape":"S1p"}}},"idempotent":true},"ListExtensionVersions":{"http":{"method":"GET","requestUri":"/extension/{Namespace}/{Name}/version","responseCode":200},"input":{"type":"structure","required":["Name","Namespace"],"members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"Name":{"location":"uri","locationName":"Name"},"Namespace":{"location":"uri","locationName":"Namespace"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"ExtensionVersions":{"type":"list","member":{"shape":"S1i"}},"NextToken":{}}}},"ListExtensions":{"http":{"method":"GET","requestUri":"/extension","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Extensions":{"type":"list","member":{"shape":"S1d"}},"NextToken":{}}}},"ListGames":{"http":{"method":"GET","requestUri":"/game","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Games":{"type":"list","member":{"type":"structure","members":{"Description":{},"Name":{},"State":{},"Tags":{"shape":"S5"}}}},"NextToken":{}}}},"ListGeneratedCodeJobs":{"http":{"method":"GET","requestUri":"/game/{GameName}/snapshot/{SnapshotId}/generated-sdk-code-jobs","responseCode":200},"input":{"type":"structure","required":["GameName","SnapshotId"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"SnapshotId":{"location":"uri","locationName":"SnapshotId"}}},"output":{"type":"structure","members":{"GeneratedCodeJobs":{"type":"list","member":{"shape":"S1t"}},"NextToken":{}}}},"ListSnapshots":{"http":{"method":"GET","requestUri":"/game/{GameName}/snapshot","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"Snapshots":{"type":"list","member":{"type":"structure","members":{"Created":{"shape":"Sb"},"Description":{},"Id":{},"LastUpdated":{"shape":"Sb"}}}}}}},"ListStageDeployments":{"http":{"method":"GET","requestUri":"/game/{GameName}/stage/{StageName}/deployments","responseCode":200},"input":{"type":"structure","required":["GameName","StageName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"NextToken":{},"StageDeployments":{"type":"list","member":{"type":"structure","members":{"DeploymentAction":{},"DeploymentId":{},"DeploymentState":{},"LastUpdated":{"shape":"Sb"},"SnapshotId":{}}}}}}},"ListStages":{"http":{"method":"GET","requestUri":"/game/{GameName}/stage","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"Stages":{"type":"list","member":{"type":"structure","members":{"Description":{},"GameKey":{},"Name":{},"State":{},"Tags":{"shape":"S5"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5"}}}},"StartGeneratedCodeJob":{"http":{"requestUri":"/game/{GameName}/snapshot/{SnapshotId}/generated-sdk-code-job","responseCode":200},"input":{"type":"structure","required":["GameName","Generator","SnapshotId"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"Generator":{"type":"structure","members":{"GameSdkVersion":{},"Language":{},"TargetPlatform":{}}},"SnapshotId":{"location":"uri","locationName":"SnapshotId"}}},"output":{"type":"structure","members":{"GeneratedCodeJobId":{}}}},"StartStageDeployment":{"http":{"requestUri":"/game/{GameName}/stage/{StageName}/deployment","responseCode":200},"input":{"type":"structure","required":["GameName","SnapshotId","StageName"],"members":{"ClientToken":{},"GameName":{"location":"uri","locationName":"GameName"},"SnapshotId":{},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"StageDeployment":{"shape":"S27"}}},"idempotent":true},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"tags":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","tagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateGame":{"http":{"method":"PATCH","requestUri":"/game/{GameName}","responseCode":200},"input":{"type":"structure","required":["GameName"],"members":{"Description":{},"GameName":{"location":"uri","locationName":"GameName"}}},"output":{"type":"structure","members":{"Game":{"shape":"S9"}}},"idempotent":true},"UpdateGameConfiguration":{"http":{"method":"PATCH","requestUri":"/game/{GameName}/configuration","responseCode":200},"input":{"type":"structure","required":["GameName","Modifications"],"members":{"GameName":{"location":"uri","locationName":"GameName"},"Modifications":{"type":"list","member":{"type":"structure","required":["Operation","Path","Section"],"members":{"Operation":{},"Path":{},"Section":{},"Value":{"shape":"Sm"}}}}}},"output":{"type":"structure","members":{"GameConfiguration":{"shape":"S1p"}}},"idempotent":true},"UpdateSnapshot":{"http":{"method":"PATCH","requestUri":"/game/{GameName}/snapshot/{SnapshotId}","responseCode":200},"input":{"type":"structure","required":["GameName","SnapshotId"],"members":{"Description":{},"GameName":{"location":"uri","locationName":"GameName"},"SnapshotId":{"location":"uri","locationName":"SnapshotId"}}},"output":{"type":"structure","members":{"Snapshot":{"shape":"Sh"}}},"idempotent":true},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/game/{GameName}/stage/{StageName}","responseCode":200},"input":{"type":"structure","required":["GameName","StageName"],"members":{"Description":{},"GameName":{"location":"uri","locationName":"GameName"},"Role":{},"StageName":{"location":"uri","locationName":"StageName"}}},"output":{"type":"structure","members":{"Stage":{"shape":"St"}}},"idempotent":true}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"structure","members":{"Arn":{},"Created":{"shape":"Sb"},"Description":{},"EnableTerminationProtection":{"type":"boolean"},"LastUpdated":{"shape":"Sb"},"Name":{},"State":{},"Tags":{"shape":"S5"}}},"Sb":{"type":"timestamp","timestampFormat":"iso8601"},"Sh":{"type":"structure","members":{"Created":{"shape":"Sb"},"Description":{},"Id":{},"LastUpdated":{"shape":"Sb"},"Sections":{"shape":"Sj"}}},"Sj":{"type":"map","key":{},"value":{"type":"structure","members":{"Attributes":{"shape":"Sm"},"Name":{},"Size":{"type":"integer"}}}},"Sm":{"type":"structure","members":{},"document":true},"St":{"type":"structure","members":{"Arn":{},"Created":{"shape":"Sb"},"Description":{},"GameKey":{},"LastUpdated":{"shape":"Sb"},"LogGroup":{},"Name":{},"Role":{},"State":{},"Tags":{"shape":"S5"}}},"S14":{"type":"list","member":{}},"S1d":{"type":"structure","members":{"Description":{},"Name":{},"Namespace":{}}},"S1i":{"type":"structure","members":{"Name":{},"Namespace":{},"Schema":{},"Version":{}}},"S1n":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"Created":{"shape":"Sb"},"LastUpdated":{"shape":"Sb"},"Sections":{"shape":"Sj"}}},"S1t":{"type":"structure","members":{"Description":{},"ExpirationTime":{"shape":"Sb"},"GeneratedCodeJobId":{},"S3Url":{},"Status":{}}},"S27":{"type":"structure","members":{"Created":{"shape":"Sb"},"DeploymentAction":{},"DeploymentId":{},"DeploymentState":{},"LastUpdated":{"shape":"Sb"},"SnapshotId":{}}}}}

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListExtensionVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ExtensionVersions"},"ListExtensions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Extensions"},"ListGames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Games"},"ListGeneratedCodeJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"GeneratedCodeJobs"},"ListSnapshots":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Snapshots"},"ListStageDeployments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"StageDeployments"},"ListStages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Stages"}}}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['pinpointsmsvoicev2'] = {};
	AWS.PinpointSMSVoiceV2 = Service.defineService('pinpointsmsvoicev2', ['2022-03-31']);
	Object.defineProperty(apiLoader.services['pinpointsmsvoicev2'], '2022-03-31', {
	  get: function get() {
	    var model = __webpack_require__(1135);
	    model.paginators = __webpack_require__(1136).pagination;
	    model.waiters = __webpack_require__(1137).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.PinpointSMSVoiceV2;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2022-03-31","endpointPrefix":"sms-voice","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon Pinpoint SMS Voice V2","serviceId":"Pinpoint SMS Voice V2","signatureVersion":"v4","signingName":"sms-voice","targetPrefix":"PinpointSMSVoiceV2","uid":"pinpoint-sms-voice-v2-2022-03-31"},"operations":{"AssociateOriginationIdentity":{"input":{"type":"structure","required":["PoolId","OriginationIdentity","IsoCountryCode"],"members":{"PoolId":{},"OriginationIdentity":{},"IsoCountryCode":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PoolArn":{},"PoolId":{},"OriginationIdentityArn":{},"OriginationIdentity":{},"IsoCountryCode":{}}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"Tags":{"shape":"Sa"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"Tags":{"shape":"Sa"},"CreatedTimestamp":{"type":"timestamp"}}}},"CreateEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","MatchingEventTypes"],"members":{"ConfigurationSetName":{},"EventDestinationName":{},"MatchingEventTypes":{"shape":"Sj"},"CloudWatchLogsDestination":{"shape":"Sl"},"KinesisFirehoseDestination":{"shape":"So"},"SnsDestination":{"shape":"Sq"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"EventDestination":{"shape":"St"}}}},"CreateOptOutList":{"input":{"type":"structure","required":["OptOutListName"],"members":{"OptOutListName":{},"Tags":{"shape":"Sa"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"OptOutListArn":{},"OptOutListName":{},"Tags":{"shape":"Sa"},"CreatedTimestamp":{"type":"timestamp"}}}},"CreatePool":{"input":{"type":"structure","required":["OriginationIdentity","IsoCountryCode","MessageType"],"members":{"OriginationIdentity":{},"IsoCountryCode":{},"MessageType":{},"DeletionProtectionEnabled":{"type":"boolean"},"Tags":{"shape":"Sa"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PoolArn":{},"PoolId":{},"Status":{},"MessageType":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"SharedRoutesEnabled":{"type":"boolean"},"DeletionProtectionEnabled":{"type":"boolean"},"Tags":{"shape":"Sa"},"CreatedTimestamp":{"type":"timestamp"}}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"EventDestinations":{"shape":"S16"},"DefaultMessageType":{},"DefaultSenderId":{},"CreatedTimestamp":{"type":"timestamp"}}}},"DeleteDefaultMessageType":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"MessageType":{}}}},"DeleteDefaultSenderId":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"SenderId":{}}}},"DeleteEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"EventDestination":{"shape":"St"}}}},"DeleteKeyword":{"input":{"type":"structure","required":["OriginationIdentity","Keyword"],"members":{"OriginationIdentity":{},"Keyword":{}}},"output":{"type":"structure","members":{"OriginationIdentityArn":{},"OriginationIdentity":{},"Keyword":{},"KeywordMessage":{},"KeywordAction":{}}}},"DeleteOptOutList":{"input":{"type":"structure","required":["OptOutListName"],"members":{"OptOutListName":{}}},"output":{"type":"structure","members":{"OptOutListArn":{},"OptOutListName":{},"CreatedTimestamp":{"type":"timestamp"}}}},"DeleteOptedOutNumber":{"input":{"type":"structure","required":["OptOutListName","OptedOutNumber"],"members":{"OptOutListName":{},"OptedOutNumber":{}}},"output":{"type":"structure","members":{"OptOutListArn":{},"OptOutListName":{},"OptedOutNumber":{},"OptedOutTimestamp":{"type":"timestamp"},"EndUserOptedOut":{"type":"boolean"}}}},"DeletePool":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{}}},"output":{"type":"structure","members":{"PoolArn":{},"PoolId":{},"Status":{},"MessageType":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"SharedRoutesEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"}}}},"DeleteTextMessageSpendLimitOverride":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"MonthlyLimit":{"type":"long"}}}},"DeleteVoiceMessageSpendLimitOverride":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"MonthlyLimit":{"type":"long"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AccountAttributes":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"NextToken":{}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","required":["Name","Used","Max"],"members":{"Name":{},"Used":{"type":"long"},"Max":{"type":"long"}}}},"NextToken":{}}}},"DescribeConfigurationSets":{"input":{"type":"structure","members":{"ConfigurationSetNames":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"type":"structure","required":["ConfigurationSetArn","ConfigurationSetName","EventDestinations","CreatedTimestamp"],"members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"EventDestinations":{"shape":"S16"},"DefaultMessageType":{},"DefaultSenderId":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeKeywords":{"input":{"type":"structure","required":["OriginationIdentity"],"members":{"OriginationIdentity":{},"Keywords":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OriginationIdentityArn":{},"OriginationIdentity":{},"Keywords":{"type":"list","member":{"type":"structure","required":["Keyword","KeywordMessage","KeywordAction"],"members":{"Keyword":{},"KeywordMessage":{},"KeywordAction":{}}}},"NextToken":{}}}},"DescribeOptOutLists":{"input":{"type":"structure","members":{"OptOutListNames":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OptOutLists":{"type":"list","member":{"type":"structure","required":["OptOutListArn","OptOutListName","CreatedTimestamp"],"members":{"OptOutListArn":{},"OptOutListName":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOptedOutNumbers":{"input":{"type":"structure","required":["OptOutListName"],"members":{"OptOutListName":{},"OptedOutNumbers":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OptOutListArn":{},"OptOutListName":{},"OptedOutNumbers":{"type":"list","member":{"type":"structure","required":["OptedOutNumber","OptedOutTimestamp","EndUserOptedOut"],"members":{"OptedOutNumber":{},"OptedOutTimestamp":{"type":"timestamp"},"EndUserOptedOut":{"type":"boolean"}}}},"NextToken":{}}}},"DescribePhoneNumbers":{"input":{"type":"structure","members":{"PhoneNumberIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PhoneNumbers":{"type":"list","member":{"type":"structure","required":["PhoneNumberArn","PhoneNumber","Status","IsoCountryCode","MessageType","NumberCapabilities","NumberType","MonthlyLeasingPrice","TwoWayEnabled","SelfManagedOptOutsEnabled","OptOutListName","DeletionProtectionEnabled","CreatedTimestamp"],"members":{"PhoneNumberArn":{},"PhoneNumberId":{},"PhoneNumber":{},"Status":{},"IsoCountryCode":{},"MessageType":{},"NumberCapabilities":{"shape":"S3f"},"NumberType":{},"MonthlyLeasingPrice":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"DeletionProtectionEnabled":{"type":"boolean"},"PoolId":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribePools":{"input":{"type":"structure","members":{"PoolIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Pools":{"type":"list","member":{"type":"structure","required":["PoolArn","PoolId","Status","MessageType","TwoWayEnabled","SelfManagedOptOutsEnabled","OptOutListName","SharedRoutesEnabled","DeletionProtectionEnabled","CreatedTimestamp"],"members":{"PoolArn":{},"PoolId":{},"Status":{},"MessageType":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"SharedRoutesEnabled":{"type":"boolean"},"DeletionProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeSenderIds":{"input":{"type":"structure","members":{"SenderIds":{"type":"list","member":{"type":"structure","required":["SenderId","IsoCountryCode"],"members":{"SenderId":{},"IsoCountryCode":{}}}},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SenderIds":{"type":"list","member":{"type":"structure","required":["SenderIdArn","SenderId","IsoCountryCode","MessageTypes","MonthlyLeasingPrice"],"members":{"SenderIdArn":{},"SenderId":{},"IsoCountryCode":{},"MessageTypes":{"type":"list","member":{}},"MonthlyLeasingPrice":{}}}},"NextToken":{}}}},"DescribeSpendLimits":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SpendLimits":{"type":"list","member":{"type":"structure","required":["Name","EnforcedLimit","MaxLimit","Overridden"],"members":{"Name":{},"EnforcedLimit":{"type":"long"},"MaxLimit":{"type":"long"},"Overridden":{"type":"boolean"}}}},"NextToken":{}}}},"DisassociateOriginationIdentity":{"input":{"type":"structure","required":["PoolId","OriginationIdentity","IsoCountryCode"],"members":{"PoolId":{},"OriginationIdentity":{},"IsoCountryCode":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PoolArn":{},"PoolId":{},"OriginationIdentityArn":{},"OriginationIdentity":{},"IsoCountryCode":{}}}},"ListPoolOriginationIdentities":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S2f"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PoolArn":{},"PoolId":{},"OriginationIdentities":{"type":"list","member":{"type":"structure","required":["OriginationIdentityArn","OriginationIdentity","IsoCountryCode","NumberCapabilities"],"members":{"OriginationIdentityArn":{},"OriginationIdentity":{},"IsoCountryCode":{},"NumberCapabilities":{"shape":"S3f"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sa"}}}},"PutKeyword":{"input":{"type":"structure","required":["OriginationIdentity","Keyword","KeywordMessage"],"members":{"OriginationIdentity":{},"Keyword":{},"KeywordMessage":{},"KeywordAction":{}}},"output":{"type":"structure","members":{"OriginationIdentityArn":{},"OriginationIdentity":{},"Keyword":{},"KeywordMessage":{},"KeywordAction":{}}}},"PutOptedOutNumber":{"input":{"type":"structure","required":["OptOutListName","OptedOutNumber"],"members":{"OptOutListName":{},"OptedOutNumber":{}}},"output":{"type":"structure","members":{"OptOutListArn":{},"OptOutListName":{},"OptedOutNumber":{},"OptedOutTimestamp":{"type":"timestamp"},"EndUserOptedOut":{"type":"boolean"}}}},"ReleasePhoneNumber":{"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{}}},"output":{"type":"structure","members":{"PhoneNumberArn":{},"PhoneNumberId":{},"PhoneNumber":{},"Status":{},"IsoCountryCode":{},"MessageType":{},"NumberCapabilities":{"shape":"S3f"},"NumberType":{},"MonthlyLeasingPrice":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"CreatedTimestamp":{"type":"timestamp"}}}},"RequestPhoneNumber":{"input":{"type":"structure","required":["IsoCountryCode","MessageType","NumberCapabilities","NumberType"],"members":{"IsoCountryCode":{},"MessageType":{},"NumberCapabilities":{"shape":"S3f"},"NumberType":{},"OptOutListName":{},"PoolId":{},"RegistrationId":{},"DeletionProtectionEnabled":{"type":"boolean"},"Tags":{"shape":"Sa"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PhoneNumberArn":{},"PhoneNumberId":{},"PhoneNumber":{},"Status":{},"IsoCountryCode":{},"MessageType":{},"NumberCapabilities":{"shape":"S3f"},"NumberType":{},"MonthlyLeasingPrice":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"DeletionProtectionEnabled":{"type":"boolean"},"PoolId":{},"Tags":{"shape":"Sa"},"CreatedTimestamp":{"type":"timestamp"}}}},"SendTextMessage":{"input":{"type":"structure","required":["DestinationPhoneNumber"],"members":{"DestinationPhoneNumber":{},"OriginationIdentity":{},"MessageBody":{},"MessageType":{},"Keyword":{},"ConfigurationSetName":{},"MaxPrice":{},"TimeToLive":{"type":"integer"},"Context":{"shape":"S4x"},"DestinationCountryParameters":{"type":"map","key":{},"value":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MessageId":{}}}},"SendVoiceMessage":{"input":{"type":"structure","required":["DestinationPhoneNumber","OriginationIdentity"],"members":{"DestinationPhoneNumber":{},"OriginationIdentity":{},"MessageBody":{},"MessageBodyTextType":{},"VoiceId":{},"ConfigurationSetName":{},"MaxPricePerMinute":{},"TimeToLive":{"type":"integer"},"Context":{"shape":"S4x"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MessageId":{}}}},"SetDefaultMessageType":{"input":{"type":"structure","required":["ConfigurationSetName","MessageType"],"members":{"ConfigurationSetName":{},"MessageType":{}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"MessageType":{}}}},"SetDefaultSenderId":{"input":{"type":"structure","required":["ConfigurationSetName","SenderId"],"members":{"ConfigurationSetName":{},"SenderId":{}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"SenderId":{}}}},"SetTextMessageSpendLimitOverride":{"input":{"type":"structure","required":["MonthlyLimit"],"members":{"MonthlyLimit":{"type":"long"}}},"output":{"type":"structure","members":{"MonthlyLimit":{"type":"long"}}}},"SetVoiceMessageSpendLimitOverride":{"input":{"type":"structure","required":["MonthlyLimit"],"members":{"MonthlyLimit":{"type":"long"}}},"output":{"type":"structure","members":{"MonthlyLimit":{"type":"long"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"type":"list","member":{"shape":"Sb"}}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sj"},"CloudWatchLogsDestination":{"shape":"Sl"},"KinesisFirehoseDestination":{"shape":"So"},"SnsDestination":{"shape":"Sq"}}},"output":{"type":"structure","members":{"ConfigurationSetArn":{},"ConfigurationSetName":{},"EventDestination":{"shape":"St"}}}},"UpdatePhoneNumber":{"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"DeletionProtectionEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"PhoneNumberArn":{},"PhoneNumberId":{},"PhoneNumber":{},"Status":{},"IsoCountryCode":{},"MessageType":{},"NumberCapabilities":{"shape":"S3f"},"NumberType":{},"MonthlyLeasingPrice":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"DeletionProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"}}}},"UpdatePool":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"SharedRoutesEnabled":{"type":"boolean"},"DeletionProtectionEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"PoolArn":{},"PoolId":{},"Status":{},"MessageType":{},"TwoWayEnabled":{"type":"boolean"},"TwoWayChannelArn":{},"SelfManagedOptOutsEnabled":{"type":"boolean"},"OptOutListName":{},"SharedRoutesEnabled":{"type":"boolean"},"DeletionProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"}}}}},"shapes":{"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"structure","required":["IamRoleArn","LogGroupArn"],"members":{"IamRoleArn":{},"LogGroupArn":{}}},"So":{"type":"structure","required":["IamRoleArn","DeliveryStreamArn"],"members":{"IamRoleArn":{},"DeliveryStreamArn":{}}},"Sq":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"St":{"type":"structure","required":["EventDestinationName","Enabled","MatchingEventTypes"],"members":{"EventDestinationName":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sj"},"CloudWatchLogsDestination":{"shape":"Sl"},"KinesisFirehoseDestination":{"shape":"So"},"SnsDestination":{"shape":"Sq"}}},"S16":{"type":"list","member":{"shape":"St"}},"S2f":{"type":"list","member":{}},"S3f":{"type":"list","member":{}},"S4x":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"DescribeAccountAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AccountAttributes"},"DescribeAccountLimits":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AccountLimits"},"DescribeConfigurationSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ConfigurationSets"},"DescribeKeywords":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Keywords"},"DescribeOptOutLists":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"OptOutLists"},"DescribeOptedOutNumbers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"OptedOutNumbers"},"DescribePhoneNumbers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PhoneNumbers"},"DescribePools":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Pools"},"DescribeSenderIds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"SenderIds"},"DescribeSpendLimits":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"SpendLimits"},"ListPoolOriginationIdentities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"OriginationIdentities"}}}

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	module.exports = {"version":2,"waiters":{}}

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['ivschat'] = {};
	AWS.Ivschat = Service.defineService('ivschat', ['2020-07-14']);
	Object.defineProperty(apiLoader.services['ivschat'], '2020-07-14', {
	  get: function get() {
	    var model = __webpack_require__(1139);
	    model.paginators = __webpack_require__(1140).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.Ivschat;


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-07-14","endpointPrefix":"ivschat","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"ivschat","serviceFullName":"Amazon Interactive Video Service Chat","serviceId":"ivschat","signatureVersion":"v4","signingName":"ivschat","uid":"ivschat-2020-07-14"},"operations":{"CreateChatToken":{"http":{"requestUri":"/CreateChatToken","responseCode":200},"input":{"type":"structure","required":["roomIdentifier","userId"],"members":{"attributes":{"type":"map","key":{},"value":{}},"capabilities":{"type":"list","member":{}},"roomIdentifier":{},"sessionDurationInMinutes":{"type":"integer"},"userId":{}}},"output":{"type":"structure","members":{"sessionExpirationTime":{"shape":"Sa"},"token":{},"tokenExpirationTime":{"shape":"Sa"}}}},"CreateRoom":{"http":{"requestUri":"/CreateRoom","responseCode":200},"input":{"type":"structure","members":{"maximumMessageLength":{"type":"integer"},"maximumMessageRatePerSecond":{"type":"integer"},"messageReviewHandler":{"shape":"Sf"},"name":{},"tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"arn":{},"createTime":{"shape":"Sa"},"id":{},"maximumMessageLength":{"type":"integer"},"maximumMessageRatePerSecond":{"type":"integer"},"messageReviewHandler":{"shape":"Sf"},"name":{},"tags":{"shape":"Sj"},"updateTime":{"shape":"Sa"}}}},"DeleteMessage":{"http":{"requestUri":"/DeleteMessage","responseCode":200},"input":{"type":"structure","required":["id","roomIdentifier"],"members":{"id":{},"reason":{},"roomIdentifier":{}}},"output":{"type":"structure","members":{"id":{}}}},"DeleteRoom":{"http":{"requestUri":"/DeleteRoom","responseCode":204},"input":{"type":"structure","required":["identifier"],"members":{"identifier":{}}}},"DisconnectUser":{"http":{"requestUri":"/DisconnectUser","responseCode":200},"input":{"type":"structure","required":["roomIdentifier","userId"],"members":{"reason":{},"roomIdentifier":{},"userId":{}}},"output":{"type":"structure","members":{}}},"GetRoom":{"http":{"requestUri":"/GetRoom","responseCode":200},"input":{"type":"structure","required":["identifier"],"members":{"identifier":{}}},"output":{"type":"structure","members":{"arn":{},"createTime":{"shape":"Sa"},"id":{},"maximumMessageLength":{"type":"integer"},"maximumMessageRatePerSecond":{"type":"integer"},"messageReviewHandler":{"shape":"Sf"},"name":{},"tags":{"shape":"Sj"},"updateTime":{"shape":"Sa"}}}},"ListRooms":{"http":{"requestUri":"/ListRooms","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"messageReviewHandlerUri":{},"name":{},"nextToken":{}}},"output":{"type":"structure","required":["rooms"],"members":{"nextToken":{},"rooms":{"type":"list","member":{"type":"structure","members":{"arn":{},"createTime":{"shape":"Sa"},"id":{},"messageReviewHandler":{"shape":"Sf"},"name":{},"tags":{"shape":"Sj"},"updateTime":{"shape":"Sa"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"Sj"}}}},"SendEvent":{"http":{"requestUri":"/SendEvent","responseCode":200},"input":{"type":"structure","required":["eventName","roomIdentifier"],"members":{"attributes":{"type":"map","key":{},"value":{}},"eventName":{},"roomIdentifier":{}}},"output":{"type":"structure","members":{"id":{}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateRoom":{"http":{"requestUri":"/UpdateRoom","responseCode":200},"input":{"type":"structure","required":["identifier"],"members":{"identifier":{},"maximumMessageLength":{"type":"integer"},"maximumMessageRatePerSecond":{"type":"integer"},"messageReviewHandler":{"shape":"Sf"},"name":{}}},"output":{"type":"structure","members":{"arn":{},"createTime":{"shape":"Sa"},"id":{},"maximumMessageLength":{"type":"integer"},"maximumMessageRatePerSecond":{"type":"integer"},"messageReviewHandler":{"shape":"Sf"},"name":{},"tags":{"shape":"Sj"},"updateTime":{"shape":"Sa"}}}}},"shapes":{"Sa":{"type":"timestamp","timestampFormat":"iso8601"},"Sf":{"type":"structure","members":{"fallbackResult":{},"uri":{}}},"Sj":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListRooms":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;

	apiLoader.services['chimesdkmediapipelines'] = {};
	AWS.ChimeSDKMediaPipelines = Service.defineService('chimesdkmediapipelines', ['2021-07-15']);
	Object.defineProperty(apiLoader.services['chimesdkmediapipelines'], '2021-07-15', {
	  get: function get() {
	    var model = __webpack_require__(1142);
	    model.paginators = __webpack_require__(1143).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});

	module.exports = AWS.ChimeSDKMediaPipelines;


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	module.exports = {"version":"2.0","metadata":{"apiVersion":"2021-07-15","endpointPrefix":"media-pipelines-chime","protocol":"rest-json","serviceFullName":"Amazon Chime SDK Media Pipelines","serviceId":"Chime SDK Media Pipelines","signatureVersion":"v4","signingName":"chime","uid":"chime-sdk-media-pipelines-2021-07-15"},"operations":{"CreateMediaCapturePipeline":{"http":{"requestUri":"/sdk-media-capture-pipelines","responseCode":201},"input":{"type":"structure","required":["SourceType","SourceArn","SinkType","SinkArn"],"members":{"SourceType":{},"SourceArn":{"shape":"S3"},"SinkType":{},"SinkArn":{"shape":"S3"},"ClientRequestToken":{"idempotencyToken":true,"type":"string","sensitive":true},"ChimeSdkMeetingConfiguration":{"shape":"S6"},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{"MediaCapturePipeline":{"shape":"Sq"}}}},"DeleteMediaCapturePipeline":{"http":{"method":"DELETE","requestUri":"/sdk-media-capture-pipelines/{mediaPipelineId}","responseCode":204},"input":{"type":"structure","required":["MediaPipelineId"],"members":{"MediaPipelineId":{"location":"uri","locationName":"mediaPipelineId"}}}},"GetMediaCapturePipeline":{"http":{"method":"GET","requestUri":"/sdk-media-capture-pipelines/{mediaPipelineId}","responseCode":200},"input":{"type":"structure","required":["MediaPipelineId"],"members":{"MediaPipelineId":{"location":"uri","locationName":"mediaPipelineId"}}},"output":{"type":"structure","members":{"MediaCapturePipeline":{"shape":"Sq"}}}},"ListMediaCapturePipelines":{"http":{"method":"GET","requestUri":"/sdk-media-capture-pipelines","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"MediaCapturePipelines":{"type":"list","member":{"type":"structure","members":{"MediaPipelineId":{},"MediaPipelineArn":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags","responseCode":200},"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sl"}}}},"TagResource":{"http":{"requestUri":"/tags?operation=tag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/tags?operation=untag-resource","responseCode":204},"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"string","sensitive":true},"S6":{"type":"structure","members":{"SourceConfiguration":{"type":"structure","members":{"SelectedVideoStreams":{"type":"structure","members":{"AttendeeIds":{"type":"list","member":{}},"ExternalUserIds":{"type":"list","member":{"type":"string","sensitive":true}}}}}},"ArtifactsConfiguration":{"type":"structure","required":["Audio","Video","Content"],"members":{"Audio":{"type":"structure","required":["MuxType"],"members":{"MuxType":{}}},"Video":{"type":"structure","required":["State"],"members":{"State":{},"MuxType":{}}},"Content":{"type":"structure","required":["State"],"members":{"State":{},"MuxType":{}}}}}}},"Sl":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sq":{"type":"structure","members":{"MediaPipelineId":{},"MediaPipelineArn":{},"SourceType":{},"SourceArn":{"shape":"S3"},"Status":{},"SinkType":{},"SinkArn":{"shape":"S3"},"CreatedTimestamp":{"shape":"St"},"UpdatedTimestamp":{"shape":"St"},"ChimeSdkMeetingConfiguration":{"shape":"S6"}}},"St":{"type":"timestamp","timestampFormat":"iso8601"}}}

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	module.exports = {"pagination":{"ListMediaCapturePipelines":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ })
/******/ ])
});
;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/**
 * Module dependencies
 */
var xtend = __webpack_require__(364)

var Readable = __webpack_require__(246).Readable
var streamsOpts = { objectMode: true }
var defaultStoreOptions = {
  clean: true
}

/**
 * In-memory implementation of the message store
 * This can actually be saved into files.
 *
 * @param {Object} [options] - store options
 */
function Store (options) {
  if (!(this instanceof Store)) {
    return new Store(options)
  }

  this.options = options || {}

  // Defaults
  this.options = xtend(defaultStoreOptions, options)

  this._inflights = {}
}

/**
 * Adds a packet to the store, a packet is
 * anything that has a messageId property.
 *
 */
Store.prototype.put = function (packet, cb) {
  this._inflights[packet.messageId] = packet

  if (cb) {
    cb()
  }

  return this
}

/**
 * Creates a stream with all the packets in the store
 *
 */
Store.prototype.createStream = function () {
  var stream = new Readable(streamsOpts)
  var inflights = this._inflights
  var ids = Object.keys(this._inflights)
  var destroyed = false
  var i = 0

  stream._read = function () {
    if (!destroyed && i < ids.length) {
      this.push(inflights[ids[i++]])
    } else {
      this.push(null)
    }
  }

  stream.destroy = function () {
    if (destroyed) {
      return
    }

    var self = this

    destroyed = true

    process.nextTick(function () {
      self.emit('close')
    })
  }

  return stream
}

/**
 * deletes a packet from the store.
 */
Store.prototype.del = function (packet, cb) {
  packet = this._inflights[packet.messageId]
  if (packet) {
    delete this._inflights[packet.messageId]
    cb(null, packet)
  } else if (cb) {
    cb(new Error('missing packet'))
  }

  return this
}

/**
 * get a packet from the store.
 */
Store.prototype.get = function (packet, cb) {
  packet = this._inflights[packet.messageId]
  if (packet) {
    cb(null, packet)
  } else if (cb) {
    cb(new Error('missing packet'))
  }

  return this
}

/**
 * Close the store
 */
Store.prototype.close = function (cb) {
  if (this.options.clean) {
    this._inflights = null
  }
  if (cb) {
    cb()
  }
}

module.exports = Store

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(194);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(575);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(95).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(576);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(89).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(195));
util.inherits = __webpack_require__(102);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1445);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1446);
var destroyImpl = __webpack_require__(577);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(139);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(579).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(139);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(579).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(43)))

/***/ }),
/* 575 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(95).EventEmitter;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(194);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(194);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(195));
util.inherits = __webpack_require__(102);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(1448)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(576);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(89).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(577);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(139);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(139);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43), __webpack_require__(503).setImmediate, __webpack_require__(28)))

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(89).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(139);

/*<replacement>*/
var util = Object.create(__webpack_require__(195));
util.inherits = __webpack_require__(102);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var once = __webpack_require__(1450);

var noop = function() {};

var isRequest = function(stream) {
	return stream.setHeader && typeof stream.abort === 'function';
};

var isChildProcess = function(stream) {
	return stream.stdio && Array.isArray(stream.stdio) && stream.stdio.length === 3
};

var eos = function(stream, opts, callback) {
	if (typeof opts === 'function') return eos(stream, null, opts);
	if (!opts) opts = {};

	callback = once(callback || noop);

	var ws = stream._writableState;
	var rs = stream._readableState;
	var readable = opts.readable || (opts.readable !== false && stream.readable);
	var writable = opts.writable || (opts.writable !== false && stream.writable);
	var cancelled = false;

	var onlegacyfinish = function() {
		if (!stream.writable) onfinish();
	};

	var onfinish = function() {
		writable = false;
		if (!readable) callback.call(stream);
	};

	var onend = function() {
		readable = false;
		if (!writable) callback.call(stream);
	};

	var onexit = function(exitCode) {
		callback.call(stream, exitCode ? new Error('exited with error code: ' + exitCode) : null);
	};

	var onerror = function(err) {
		callback.call(stream, err);
	};

	var onclose = function() {
		process.nextTick(onclosenexttick);
	};

	var onclosenexttick = function() {
		if (cancelled) return;
		if (readable && !(rs && (rs.ended && !rs.destroyed))) return callback.call(stream, new Error('premature close'));
		if (writable && !(ws && (ws.ended && !ws.destroyed))) return callback.call(stream, new Error('premature close'));
	};

	var onrequest = function() {
		stream.req.on('finish', onfinish);
	};

	if (isRequest(stream)) {
		stream.on('complete', onfinish);
		stream.on('abort', onclose);
		if (stream.req) onrequest();
		else stream.on('request', onrequest);
	} else if (writable && !ws) { // legacy streams
		stream.on('end', onlegacyfinish);
		stream.on('close', onlegacyfinish);
	}

	if (isChildProcess(stream)) stream.on('exit', onexit);

	stream.on('end', onend);
	stream.on('finish', onfinish);
	if (opts.error !== false) stream.on('error', onerror);
	stream.on('close', onclose);

	return function() {
		cancelled = true;
		stream.removeListener('complete', onfinish);
		stream.removeListener('abort', onclose);
		stream.removeListener('request', onrequest);
		if (stream.req) stream.req.removeListener('finish', onfinish);
		stream.removeListener('end', onlegacyfinish);
		stream.removeListener('close', onlegacyfinish);
		stream.removeListener('finish', onfinish);
		stream.removeListener('exit', onexit);
		stream.removeListener('end', onend);
		stream.removeListener('error', onerror);
		stream.removeListener('close', onclose);
	};
};

module.exports = eos;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(89).Buffer

/* Protocol - protocol constants */
var protocol = module.exports

/* Command code => mnemonic */
protocol.types = {
  0: 'reserved',
  1: 'connect',
  2: 'connack',
  3: 'publish',
  4: 'puback',
  5: 'pubrec',
  6: 'pubrel',
  7: 'pubcomp',
  8: 'subscribe',
  9: 'suback',
  10: 'unsubscribe',
  11: 'unsuback',
  12: 'pingreq',
  13: 'pingresp',
  14: 'disconnect',
  15: 'reserved'
}

/* Mnemonic => Command code */
protocol.codes = {}
for (var k in protocol.types) {
  var v = protocol.types[k]
  protocol.codes[v] = k
}

/* Header */
protocol.CMD_SHIFT = 4
protocol.CMD_MASK = 0xF0
protocol.DUP_MASK = 0x08
protocol.QOS_MASK = 0x03
protocol.QOS_SHIFT = 1
protocol.RETAIN_MASK = 0x01

/* Length */
protocol.LENGTH_MASK = 0x7F
protocol.LENGTH_FIN_MASK = 0x80

/* Connack */
protocol.SESSIONPRESENT_MASK = 0x01
protocol.SESSIONPRESENT_HEADER = Buffer.from([protocol.SESSIONPRESENT_MASK])
protocol.CONNACK_HEADER = Buffer.from([protocol.codes['connack'] << protocol.CMD_SHIFT])

/* Connect */
protocol.USERNAME_MASK = 0x80
protocol.PASSWORD_MASK = 0x40
protocol.WILL_RETAIN_MASK = 0x20
protocol.WILL_QOS_MASK = 0x18
protocol.WILL_QOS_SHIFT = 3
protocol.WILL_FLAG_MASK = 0x04
protocol.CLEAN_SESSION_MASK = 0x02
protocol.CONNECT_HEADER = Buffer.from([protocol.codes['connect'] << protocol.CMD_SHIFT])

function genHeader (type) {
  return [0, 1, 2].map(function (qos) {
    return [0, 1].map(function (dup) {
      return [0, 1].map(function (retain) {
        var buf = new Buffer(1)
        buf.writeUInt8(
          protocol.codes[type] << protocol.CMD_SHIFT |
          (dup ? protocol.DUP_MASK : 0) |
          qos << protocol.QOS_SHIFT | retain, 0, true)
        return buf
      })
    })
  })
}

/* Publish */
protocol.PUBLISH_HEADER = genHeader('publish')

/* Subscribe */
protocol.SUBSCRIBE_HEADER = genHeader('subscribe')

/* Unsubscribe */
protocol.UNSUBSCRIBE_HEADER = genHeader('unsubscribe')

/* Confirmations */
protocol.ACKS = {
  unsuback: genHeader('unsuback'),
  puback: genHeader('puback'),
  pubcomp: genHeader('pubcomp'),
  pubrel: genHeader('pubrel'),
  pubrec: genHeader('pubrec')
}

protocol.SUBACK_HEADER = Buffer.from([protocol.codes['suback'] << protocol.CMD_SHIFT])

/* Protocol versions */
protocol.VERSION3 = Buffer.from([3])
protocol.VERSION4 = Buffer.from([4])

/* QoS */
protocol.QOS = [0, 1, 2].map(function (qos) {
  return Buffer.from([qos])
})

/* Empty packets */
protocol.EMPTY = {
  pingreq: Buffer.from([protocol.codes['pingreq'] << 4, 0]),
  pingresp: Buffer.from([protocol.codes['pingresp'] << 4, 0]),
  disconnect: Buffer.from([protocol.codes['disconnect'] << 4, 0])
}


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var protocol = __webpack_require__(582)
var Buffer = __webpack_require__(89).Buffer
var empty = Buffer.allocUnsafe(0)
var zeroBuf = Buffer.from([0])
var numbers = __webpack_require__(1458)
var nextTick = __webpack_require__(194).nextTick

var numCache = numbers.cache
var generateNumber = numbers.generateNumber
var generateCache = numbers.generateCache
var writeNumber = writeNumberCached
var toGenerate = true

function generate (packet, stream) {
  if (stream.cork) {
    stream.cork()
    nextTick(uncork, stream)
  }

  if (toGenerate) {
    toGenerate = false
    generateCache()
  }

  switch (packet.cmd) {
    case 'connect':
      return connect(packet, stream)
    case 'connack':
      return connack(packet, stream)
    case 'publish':
      return publish(packet, stream)
    case 'puback':
    case 'pubrec':
    case 'pubrel':
    case 'pubcomp':
    case 'unsuback':
      return confirmation(packet, stream)
    case 'subscribe':
      return subscribe(packet, stream)
    case 'suback':
      return suback(packet, stream)
    case 'unsubscribe':
      return unsubscribe(packet, stream)
    case 'pingreq':
    case 'pingresp':
    case 'disconnect':
      return emptyPacket(packet, stream)
    default:
      stream.emit('error', new Error('Unknown command'))
      return false
  }
}
/**
 * Controls numbers cache.
 * Set to "false" to allocate buffers on-the-flight instead of pre-generated cache
 */
Object.defineProperty(generate, 'cacheNumbers', {
  get: function () {
    return writeNumber === writeNumberCached
  },
  set: function (value) {
    if (value) {
      if (!numCache || Object.keys(numCache).length === 0) toGenerate = true
      writeNumber = writeNumberCached
    } else {
      toGenerate = false
      writeNumber = writeNumberGenerated
    }
  }
})

function uncork (stream) {
  stream.uncork()
}

function connect (opts, stream) {
  var settings = opts || {}
  var protocolId = settings.protocolId || 'MQTT'
  var protocolVersion = settings.protocolVersion || 4
  var will = settings.will
  var clean = settings.clean
  var keepalive = settings.keepalive || 0
  var clientId = settings.clientId || ''
  var username = settings.username
  var password = settings.password

  if (clean === undefined) clean = true

  var length = 0

  // Must be a string and non-falsy
  if (!protocolId ||
     (typeof protocolId !== 'string' && !Buffer.isBuffer(protocolId))) {
    stream.emit('error', new Error('Invalid protocolId'))
    return false
  } else length += protocolId.length + 2

  // Must be 3 or 4
  if (protocolVersion !== 3 && protocolVersion !== 4) {
    stream.emit('error', new Error('Invalid protocol version'))
    return false
  } else length += 1

  // ClientId might be omitted in 3.1.1, but only if cleanSession is set to 1
  if ((typeof clientId === 'string' || Buffer.isBuffer(clientId)) &&
     (clientId || protocolVersion === 4) && (clientId || clean)) {
    length += clientId.length + 2
  } else {
    if (protocolVersion < 4) {
      stream.emit('error', new Error('clientId must be supplied before 3.1.1'))
      return false
    }
    if ((clean * 1) === 0) {
      stream.emit('error', new Error('clientId must be given if cleanSession set to 0'))
      return false
    }
  }

  // Must be a two byte number
  if (typeof keepalive !== 'number' ||
      keepalive < 0 ||
      keepalive > 65535 ||
      keepalive % 1 !== 0) {
    stream.emit('error', new Error('Invalid keepalive'))
    return false
  } else length += 2

  // Connect flags
  length += 1

  // If will exists...
  if (will) {
    // It must be an object
    if (typeof will !== 'object') {
      stream.emit('error', new Error('Invalid will'))
      return false
    }
    // It must have topic typeof string
    if (!will.topic || typeof will.topic !== 'string') {
      stream.emit('error', new Error('Invalid will topic'))
      return false
    } else {
      length += Buffer.byteLength(will.topic) + 2
    }

    // Payload
    if (will.payload && will.payload) {
      if (will.payload.length >= 0) {
        if (typeof will.payload === 'string') {
          length += Buffer.byteLength(will.payload) + 2
        } else {
          length += will.payload.length + 2
        }
      } else {
        stream.emit('error', new Error('Invalid will payload'))
        return false
      }
    } else {
      length += 2
    }
  }

  // Username
  var providedUsername = false
  if (username != null) {
    if (isStringOrBuffer(username)) {
      providedUsername = true
      length += Buffer.byteLength(username) + 2
    } else {
      stream.emit('error', new Error('Invalid username'))
      return false
    }
  }

  // Password
  if (password != null) {
    if (!providedUsername) {
      stream.emit('error', new Error('Username is required to use password'))
      return false
    }

    if (isStringOrBuffer(password)) {
      length += byteLength(password) + 2
    } else {
      stream.emit('error', new Error('Invalid password'))
      return false
    }
  }

  // Generate header
  stream.write(protocol.CONNECT_HEADER)

  // Generate length
  writeLength(stream, length)

  // Generate protocol ID
  writeStringOrBuffer(stream, protocolId)
  stream.write(
    protocolVersion === 4 ? protocol.VERSION4 : protocol.VERSION3
  )

  // Connect flags
  var flags = 0
  flags |= (username != null) ? protocol.USERNAME_MASK : 0
  flags |= (password != null) ? protocol.PASSWORD_MASK : 0
  flags |= (will && will.retain) ? protocol.WILL_RETAIN_MASK : 0
  flags |= (will && will.qos) ? will.qos << protocol.WILL_QOS_SHIFT : 0
  flags |= will ? protocol.WILL_FLAG_MASK : 0
  flags |= clean ? protocol.CLEAN_SESSION_MASK : 0

  stream.write(Buffer.from([flags]))

  // Keepalive
  writeNumber(stream, keepalive)

  // Client ID
  writeStringOrBuffer(stream, clientId)

  // Will
  if (will) {
    writeString(stream, will.topic)
    writeStringOrBuffer(stream, will.payload)
  }

  // Username and password
  if (username != null) {
    writeStringOrBuffer(stream, username)
  }
  if (password != null) {
    writeStringOrBuffer(stream, password)
  }
  // This is a small packet that happens only once on a stream
  // We assume the stream is always free to receive more data after this
  return true
}

function connack (opts, stream) {
  var settings = opts || {}
  var rc = settings.returnCode

  // Check return code
  if (typeof rc !== 'number') {
    stream.emit('error', new Error('Invalid return code'))
    return false
  }

  stream.write(protocol.CONNACK_HEADER)
  writeLength(stream, 2)
  stream.write(opts.sessionPresent ? protocol.SESSIONPRESENT_HEADER : zeroBuf)

  return stream.write(Buffer.from([rc]))
}

function publish (opts, stream) {
  var settings = opts || {}
  var qos = settings.qos || 0
  var retain = settings.retain ? protocol.RETAIN_MASK : 0
  var topic = settings.topic
  var payload = settings.payload || empty
  var id = settings.messageId

  var length = 0

  // Topic must be a non-empty string or Buffer
  if (typeof topic === 'string') length += Buffer.byteLength(topic) + 2
  else if (Buffer.isBuffer(topic)) length += topic.length + 2
  else {
    stream.emit('error', new Error('Invalid topic'))
    return false
  }

  // Get the payload length
  if (!Buffer.isBuffer(payload)) length += Buffer.byteLength(payload)
  else length += payload.length

  // Message ID must a number if qos > 0
  if (qos && typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else if (qos) length += 2

  // Header
  stream.write(protocol.PUBLISH_HEADER[qos][opts.dup ? 1 : 0][retain ? 1 : 0])

  // Remaining length
  writeLength(stream, length)

  // Topic
  writeNumber(stream, byteLength(topic))
  stream.write(topic)

  // Message ID
  if (qos > 0) writeNumber(stream, id)

  // Payload
  return stream.write(payload)
}

/* Puback, pubrec, pubrel and pubcomp */
function confirmation (opts, stream) {
  var settings = opts || {}
  var type = settings.cmd || 'puback'
  var id = settings.messageId
  var dup = (settings.dup && type === 'pubrel') ? protocol.DUP_MASK : 0
  var qos = 0

  if (type === 'pubrel') qos = 1

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  }

  // Header
  stream.write(protocol.ACKS[type][qos][dup][0])

  // Length
  writeLength(stream, 2)

  // Message ID
  return writeNumber(stream, id)
}

function subscribe (opts, stream) {
  var settings = opts || {}
  var dup = settings.dup ? protocol.DUP_MASK : 0
  var id = settings.messageId
  var subs = settings.subscriptions

  var length = 0

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else length += 2

  // Check subscriptions
  if (typeof subs === 'object' && subs.length) {
    for (var i = 0; i < subs.length; i += 1) {
      var itopic = subs[i].topic
      var iqos = subs[i].qos

      if (typeof itopic !== 'string') {
        stream.emit('error', new Error('Invalid subscriptions - invalid topic'))
        return false
      }
      if (typeof iqos !== 'number') {
        stream.emit('error', new Error('Invalid subscriptions - invalid qos'))
        return false
      }

      length += Buffer.byteLength(itopic) + 2 + 1
    }
  } else {
    stream.emit('error', new Error('Invalid subscriptions'))
    return false
  }

  // Generate header
  stream.write(protocol.SUBSCRIBE_HEADER[1][dup ? 1 : 0][0])

  // Generate length
  writeLength(stream, length)

  // Generate message ID
  writeNumber(stream, id)

  var result = true

  // Generate subs
  for (var j = 0; j < subs.length; j++) {
    var sub = subs[j]
    var jtopic = sub.topic
    var jqos = sub.qos

    // Write topic string
    writeString(stream, jtopic)

    // Write qos
    result = stream.write(protocol.QOS[jqos])
  }

  return result
}

function suback (opts, stream) {
  var settings = opts || {}
  var id = settings.messageId
  var granted = settings.granted

  var length = 0

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else length += 2

  // Check granted qos vector
  if (typeof granted === 'object' && granted.length) {
    for (var i = 0; i < granted.length; i += 1) {
      if (typeof granted[i] !== 'number') {
        stream.emit('error', new Error('Invalid qos vector'))
        return false
      }
      length += 1
    }
  } else {
    stream.emit('error', new Error('Invalid qos vector'))
    return false
  }

  // header
  stream.write(protocol.SUBACK_HEADER)

  // Length
  writeLength(stream, length)

  // Message ID
  writeNumber(stream, id)

  return stream.write(Buffer.from(granted))
}

function unsubscribe (opts, stream) {
  var settings = opts || {}
  var id = settings.messageId
  var dup = settings.dup ? protocol.DUP_MASK : 0
  var unsubs = settings.unsubscriptions

  var length = 0

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else {
    length += 2
  }
  // Check unsubs
  if (typeof unsubs === 'object' && unsubs.length) {
    for (var i = 0; i < unsubs.length; i += 1) {
      if (typeof unsubs[i] !== 'string') {
        stream.emit('error', new Error('Invalid unsubscriptions'))
        return false
      }
      length += Buffer.byteLength(unsubs[i]) + 2
    }
  } else {
    stream.emit('error', new Error('Invalid unsubscriptions'))
    return false
  }

  // Header
  stream.write(protocol.UNSUBSCRIBE_HEADER[1][dup ? 1 : 0][0])

  // Length
  writeLength(stream, length)

  // Message ID
  writeNumber(stream, id)

  // Unsubs
  var result = true
  for (var j = 0; j < unsubs.length; j++) {
    result = writeString(stream, unsubs[j])
  }

  return result
}

function emptyPacket (opts, stream) {
  return stream.write(protocol.EMPTY[opts.cmd])
}

/**
 * calcLengthLength - calculate the length of the remaining
 * length field
 *
 * @api private
 */
function calcLengthLength (length) {
  if (length >= 0 && length < 128) return 1
  else if (length >= 128 && length < 16384) return 2
  else if (length >= 16384 && length < 2097152) return 3
  else if (length >= 2097152 && length < 268435456) return 4
  else return 0
}

function genBufLength (length) {
  var digit = 0
  var pos = 0
  var buffer = Buffer.allocUnsafe(calcLengthLength(length))

  do {
    digit = length % 128 | 0
    length = length / 128 | 0
    if (length > 0) digit = digit | 0x80

    buffer.writeUInt8(digit, pos++)
  } while (length > 0)

  return buffer
}

/**
 * writeLength - write an MQTT style length field to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <Number> length - length (>0)
 * @returns <Number> number of bytes written
 *
 * @api private
 */

var lengthCache = {}
function writeLength (stream, length) {
  var buffer = lengthCache[length]

  if (!buffer) {
    buffer = genBufLength(length)
    if (length < 16384) lengthCache[length] = buffer
  }

  stream.write(buffer)
}

/**
 * writeString - write a utf8 string to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> string - string to write
 * @return <Number> number of bytes written
 *
 * @api private
 */

function writeString (stream, string) {
  var strlen = Buffer.byteLength(string)
  writeNumber(stream, strlen)

  stream.write(string, 'utf8')
}

/**
 * writeNumber - write a two byte number to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> number - number to write
 * @return <Number> number of bytes written
 *
 * @api private
 */
function writeNumberCached (stream, number) {
  return stream.write(numCache[number])
}
function writeNumberGenerated (stream, number) {
  return stream.write(generateNumber(number))
}

/**
 * writeStringOrBuffer - write a String or Buffer with the its length prefix
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> toWrite - String or Buffer
 * @return <Number> number of bytes written
 */
function writeStringOrBuffer (stream, toWrite) {
  if (typeof toWrite === 'string') {
    writeString(stream, toWrite)
  } else if (toWrite) {
    writeNumber(stream, toWrite.length)
    stream.write(toWrite)
  } else writeNumber(stream, 0)
}

function byteLength (bufOrString) {
  if (!bufOrString) return 0
  else if (bufOrString instanceof Buffer) return bufOrString.length
  else return Buffer.byteLength(bufOrString)
}

function isStringOrBuffer (field) {
  return typeof field === 'string' || field instanceof Buffer
}

module.exports = generate


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var net = __webpack_require__(1466)

/*
  variables port and host can be removed since
  you have all required information in opts object
*/
function buildBuilder (client, opts) {
  var port, host
  opts.port = opts.port || 1883
  opts.hostname = opts.hostname || opts.host || 'localhost'

  port = opts.port
  host = opts.hostname

  return net.createConnection(port, host)
}

module.exports = buildBuilder


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global wx */
var socketOpen = false
var socketMsgQueue = []

function sendSocketMessage (msg) {
  if (socketOpen) {
    wx.sendSocketMessage({
      data: msg
    })
  } else {
    socketMsgQueue.push(msg)
  }
}

function WebSocket (url, protocols) {
  var ws = {
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
    readyState: socketOpen ? 1 : 0,
    send: sendSocketMessage,
    close: wx.closeSocket,
    onopen: null,
    onmessage: null,
    onclose: null,
    onerror: null
  }

  wx.connectSocket({
    url: url,
    protocols: protocols
  })
  wx.onSocketOpen(function (res) {
    ws.readyState = ws.OPEN
    socketOpen = true
    for (var i = 0; i < socketMsgQueue.length; i++) {
      sendSocketMessage(socketMsgQueue[i])
    }
    socketMsgQueue = []

    ws.onopen && ws.onopen.apply(ws, arguments)
  })
  wx.onSocketMessage(function (res) {
    ws.onmessage && ws.onmessage.apply(ws, arguments)
  })
  wx.onSocketClose(function () {
    ws.onclose && ws.onclose.apply(ws, arguments)
    ws.readyState = ws.CLOSED
    socketOpen = false
  })
  wx.onSocketError(function () {
    ws.onerror && ws.onerror.apply(ws, arguments)
    ws.readyState = ws.CLOSED
    socketOpen = false
  })

  return ws
}

var websocket = __webpack_require__(367)
var urlModule = __webpack_require__(365)

function buildUrl (opts, client) {
  var protocol = opts.protocol === 'wxs' ? 'wss' : 'ws'
  var url = protocol + '://' + opts.hostname + ':' + opts.port + opts.path
  if (typeof (opts.transformWsUrl) === 'function') {
    url = opts.transformWsUrl(url, opts, client)
  }
  return url
}

function setDefaultOpts (opts) {
  if (!opts.hostname) {
    opts.hostname = 'localhost'
  }
  if (!opts.port) {
    if (opts.protocol === 'wss') {
      opts.port = 443
    } else {
      opts.port = 80
    }
  }
  if (!opts.path) {
    opts.path = '/'
  }

  if (!opts.wsOptions) {
    opts.wsOptions = {}
  }
}

function createWebSocket (client, opts) {
  var websocketSubProtocol =
    (opts.protocolId === 'MQIsdp') && (opts.protocolVersion === 3)
      ? 'mqttv3.1'
      : 'mqtt'

  setDefaultOpts(opts)
  var url = buildUrl(opts, client)
  return websocket(WebSocket(url, [websocketSubProtocol]))
}

function buildBuilder (client, opts) {
  if (!opts.hostname) {
    opts.hostname = opts.host
  }

  if (!opts.hostname) {
    // Throwing an error in a Web Worker if no `hostname` is given, because we
    // can not determine the `hostname` automatically.  If connecting to
    // localhost, please supply the `hostname` as an argument.
    if (typeof (document) === 'undefined') {
      throw new Error('Could not determine host. Specify host manually.')
    }
    var parsed = urlModule.parse(document.URL)
    opts.hostname = parsed.hostname

    if (!opts.port) {
      opts.port = parsed.port
    }
  }
  return createWebSocket(client, opts)
}

module.exports = buildBuilder


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var websocket = __webpack_require__(367)
var urlModule = __webpack_require__(365)
var WSS_OPTIONS = [
  'rejectUnauthorized',
  'ca',
  'cert',
  'key',
  'pfx',
  'passphrase'
]
var IS_BROWSER = process.title === 'browser'

function buildUrl (opts, client) {
  var url = opts.protocol + '://' + opts.hostname + ':' + opts.port + opts.path
  if (typeof (opts.transformWsUrl) === 'function') {
    url = opts.transformWsUrl(url, opts, client)
  }
  return url
}

function setDefaultOpts (opts) {
  if (!opts.hostname) {
    opts.hostname = 'localhost'
  }
  if (!opts.port) {
    if (opts.protocol === 'wss') {
      opts.port = 443
    } else {
      opts.port = 80
    }
  }
  if (!opts.path) {
    opts.path = '/'
  }

  if (!opts.wsOptions) {
    opts.wsOptions = {}
  }
  if (!IS_BROWSER && opts.protocol === 'wss') {
    // Add cert/key/ca etc options
    WSS_OPTIONS.forEach(function (prop) {
      if (opts.hasOwnProperty(prop) && !opts.wsOptions.hasOwnProperty(prop)) {
        opts.wsOptions[prop] = opts[prop]
      }
    })
  }
}

function createWebSocket (client, opts) {
  var websocketSubProtocol =
    (opts.protocolId === 'MQIsdp') && (opts.protocolVersion === 3)
      ? 'mqttv3.1'
      : 'mqtt'

  setDefaultOpts(opts)
  var url = buildUrl(opts, client)
  return websocket(url, [websocketSubProtocol], opts.wsOptions)
}

function buildBuilder (client, opts) {
  return createWebSocket(client, opts)
}

function buildBuilderBrowser (client, opts) {
  if (!opts.hostname) {
    opts.hostname = opts.host
  }

  if (!opts.hostname) {
    // Throwing an error in a Web Worker if no `hostname` is given, because we
    // can not determine the `hostname` automatically.  If connecting to
    // localhost, please supply the `hostname` as an argument.
    if (typeof (document) === 'undefined') {
      throw new Error('Could not determine host. Specify host manually.')
    }
    var parsed = urlModule.parse(document.URL)
    opts.hostname = parsed.hostname

    if (!opts.port) {
      opts.port = parsed.port
    }
  }
  return createWebSocket(client, opts)
}

if (IS_BROWSER) {
  module.exports = buildBuilderBrowser
} else {
  module.exports = buildBuilder
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(247));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);
var settle = __webpack_require__(1509);
var buildURL = __webpack_require__(1511);
var parseHeaders = __webpack_require__(1512);
var isURLSameOrigin = __webpack_require__(1513);
var createError = __webpack_require__(591);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1514);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1510);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = exports.Checkbox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = exports.Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!(this.props && this.props.checkboxGroup)) {
        throw new Error('The `Checkbox` component must be used as a child of `CheckboxGroup`.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$checkboxGroup = _props.checkboxGroup,
          name = _props$checkboxGroup.name,
          checkedValues = _props$checkboxGroup.checkedValues,
          onChange = _props$checkboxGroup.onChange,
          rest = _objectWithoutProperties(_props, ['checkboxGroup']);

      var optional = {};
      if (checkedValues) {
        optional.checked = checkedValues.indexOf(this.props.value) >= 0;
      }
      if (typeof onChange === 'function') {
        optional.onChange = onChange.bind(null, this.props.value);
      }

      return _react2.default.createElement('input', _extends({}, rest, {
        type: 'checkbox',
        name: name,
        disabled: this.props.disabled
      }, optional));
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.displayName = 'Checkbox';

var CheckboxGroup = exports.CheckboxGroup = function (_Component2) {
  _inherits(CheckboxGroup, _Component2);

  function CheckboxGroup(props) {
    _classCallCheck(this, CheckboxGroup);

    var _this2 = _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));

    _this2._prepareBoxes = function (children) {
      var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (depth > maxDepth) {
        return children;
      }

      var checkboxGroup = {
        name: _this2.props.name,
        checkedValues: _this2.state.value,
        onChange: _this2._onCheckboxChange
      };

      return _react2.default.Children.map(children, function (child) {
        if (!(child && child.$$typeof)) {
          return child;
        } else if (child.type === Checkbox) {
          return _react2.default.cloneElement(child, { checkboxGroup: checkboxGroup });
        } else {
          return _react2.default.cloneElement(child, {}, child.props.children ? _react2.default.Children.map(child.props.children, function (c) {
            return _this2._prepareBoxes(c, maxDepth, depth + 1);
          }) : null);
        }
      });
    };

    _this2._isControlledComponent = _this2._isControlledComponent.bind(_this2);
    _this2._onCheckboxChange = _this2._onCheckboxChange.bind(_this2);
    _this2.getValue = _this2.getValue.bind(_this2);
    _this2.state = {
      value: _this2.props.value || _this2.props.defaultValue || []
    };
    return _this2;
  }

  _createClass(CheckboxGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value) {
        this.setState({
          value: newProps.value
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          Component = _props2.Component,
          name = _props2.name,
          value = _props2.value,
          onChange = _props2.onChange,
          children = _props2.children,
          _props2$checkboxDepth = _props2.checkboxDepth,
          checkboxDepth = _props2$checkboxDepth === undefined ? 1 : _props2$checkboxDepth,
          rest = _objectWithoutProperties(_props2, ['Component', 'name', 'value', 'onChange', 'children', 'checkboxDepth']);

      return _react2.default.createElement(
        Component,
        rest,
        this._prepareBoxes(children, checkboxDepth)
      );
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: '_isControlledComponent',
    value: function _isControlledComponent() {
      return Boolean(this.props.value);
    }
  }, {
    key: '_onCheckboxChange',
    value: function _onCheckboxChange(checkboxValue, event) {
      var newValue = void 0;
      if (event.target.checked) {
        newValue = this.state.value.concat(checkboxValue);
      } else {
        newValue = this.state.value.filter(function (v) {
          return v !== checkboxValue;
        });
      }

      if (this._isControlledComponent()) {
        this.setState({ value: this.props.value });
      } else {
        this.setState({ value: newValue });
      }

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(newValue, event, this.props.name);
      }
    }
  }]);

  return CheckboxGroup;
}(_react.Component);

CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.defaultProps = {
  Component: "div"
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// Older versions of React do not support static getDerivedStateFromProps.
// As a workaround, use cWM and cWRP to invoke the new static lifecycle.
// Newer versions of React will ignore these methods if gDSFP exists.
function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  if (!Component.prototype || !Component.prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps === 'function') {
    if (typeof Component.prototype.componentWillMount === 'function') {
      throw new Error(
        'Cannot polyfill getDerivedStateFromProps() for components that define componentWillMount()'
      );
    } else if (
      typeof Component.prototype.componentWillReceiveProps === 'function'
    ) {
      throw new Error(
        'Cannot polyfill getDerivedStateFromProps() for components that define componentWillReceiveProps()'
      );
    }

    Component.prototype.componentWillMount = componentWillMount;
    Component.prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  if (typeof Component.prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof Component.prototype.componentWillUpdate === 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that define componentWillUpdate()'
      );
    }
    if (typeof Component.prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    Component.prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = Component.prototype.componentDidUpdate;

    Component.prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

module.exports = polyfill;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _buffer = __webpack_require__(101);

var _cryptoBrowserify = __webpack_require__(597);

var crypto = _interopRequireWildcard(_cryptoBrowserify);

var _BigInteger = __webpack_require__(598);

var _BigInteger2 = _interopRequireDefault(_BigInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
                                                                                                                                                           * Copyright 2016 Amazon.com,
                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
                                                                                                                                                           *
                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
                                                                                                                                                           * You may not use this file except in compliance with the
                                                                                                                                                           * License. A copy of the License is located at
                                                                                                                                                           *
                                                                                                                                                           *     http://aws.amazon.com/asl/
                                                                                                                                                           *
                                                                                                                                                           * or in the "license" file accompanying this file. This file is
                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
                                                                                                                                                           * for the specific language governing permissions and
                                                                                                                                                           * limitations under the License.
                                                                                                                                                           */

var createHash = crypto.createHash;
var createHmac = crypto.createHmac;
var randomBytes = crypto.randomBytes;

var initN = 'FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1' + '29024E088A67CC74020BBEA63B139B22514A08798E3404DD' + 'EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245' + 'E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED' + 'EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D' + 'C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F' + '83655D23DCA3AD961C62F356208552BB9ED529077096966D' + '670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B' + 'E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9' + 'DE2BCBF6955817183995497CEA956AE515D2261898FA0510' + '15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64' + 'ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7' + 'ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B' + 'F12FFA06D98A0864D87602733EC86A64521F2B18177B200C' + 'BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31' + '43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF';

var newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';

/** @class */

var AuthenticationHelper = function () {
  /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */
  function AuthenticationHelper(PoolName) {
    _classCallCheck(this, AuthenticationHelper);

    this.N = new _BigInteger2.default(initN, 16);
    this.g = new _BigInteger2.default('2', 16);
    this.k = new _BigInteger2.default(this.hexHash('00' + this.N.toString(16) + '0' + this.g.toString(16)), 16);

    this.smallAValue = this.generateRandomSmallA();
    this.getLargeAValue(function () {});

    this.infoBits = _buffer.Buffer.from('Caldera Derived Key', 'utf8');

    this.poolName = PoolName;
  }

  /**
   * @returns {BigInteger} small A, a random number
   */


  AuthenticationHelper.prototype.getSmallAValue = function getSmallAValue() {
    return this.smallAValue;
  };

  /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */


  AuthenticationHelper.prototype.getLargeAValue = function getLargeAValue(callback) {
    var _this = this;

    if (this.largeAValue) {
      callback(null, this.largeAValue);
    } else {
      this.calculateA(this.smallAValue, function (err, largeAValue) {
        if (err) {
          callback(err, null);
        }

        _this.largeAValue = largeAValue;
        callback(null, _this.largeAValue);
      });
    }
  };

  /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */


  AuthenticationHelper.prototype.generateRandomSmallA = function generateRandomSmallA() {
    var hexRandom = randomBytes(128).toString('hex');

    var randomBigInt = new _BigInteger2.default(hexRandom, 16);
    var smallABigInt = randomBigInt.mod(this.N);

    return smallABigInt;
  };

  /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */


  AuthenticationHelper.prototype.generateRandomString = function generateRandomString() {
    return randomBytes(40).toString('base64');
  };

  /**
   * @returns {string} Generated random value included in password hash.
   */


  AuthenticationHelper.prototype.getRandomPassword = function getRandomPassword() {
    return this.randomPassword;
  };

  /**
   * @returns {string} Generated random value included in devices hash.
   */


  AuthenticationHelper.prototype.getSaltDevices = function getSaltDevices() {
    return this.SaltToHashDevices;
  };

  /**
   * @returns {string} Value used to verify devices.
   */


  AuthenticationHelper.prototype.getVerifierDevices = function getVerifierDevices() {
    return this.verifierDevices;
  };

  /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */


  AuthenticationHelper.prototype.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
    var _this2 = this;

    this.randomPassword = this.generateRandomString();
    var combinedString = '' + deviceGroupKey + username + ':' + this.randomPassword;
    var hashedString = this.hash(combinedString);

    var hexRandom = randomBytes(16).toString('hex');
    this.SaltToHashDevices = this.padHex(new _BigInteger2.default(hexRandom, 16));

    this.g.modPow(new _BigInteger2.default(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function (err, verifierDevicesNotPadded) {
      if (err) {
        callback(err, null);
      }

      _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
      callback(null, null);
    });
  };

  /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */


  AuthenticationHelper.prototype.calculateA = function calculateA(a, callback) {
    var _this3 = this;

    this.g.modPow(a, this.N, function (err, A) {
      if (err) {
        callback(err, null);
      }

      if (A.mod(_this3.N).equals(_BigInteger2.default.ZERO)) {
        callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
      }

      callback(null, A);
    });
  };

  /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */


  AuthenticationHelper.prototype.calculateU = function calculateU(A, B) {
    this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
    var finalU = new _BigInteger2.default(this.UHexHash, 16);

    return finalU;
  };

  /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */


  AuthenticationHelper.prototype.hash = function hash(buf) {
    var hashHex = createHash('sha256').update(buf).digest('hex');
    return new Array(64 - hashHex.length).join('0') + hashHex;
  };

  /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */


  AuthenticationHelper.prototype.hexHash = function hexHash(hexStr) {
    return this.hash(_buffer.Buffer.from(hexStr, 'hex'));
  };

  /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */


  AuthenticationHelper.prototype.computehkdf = function computehkdf(ikm, salt) {
    var prk = createHmac('sha256', salt).update(ikm).digest();
    var infoBitsUpdate = _buffer.Buffer.concat([this.infoBits, _buffer.Buffer.from(String.fromCharCode(1), 'utf8')]);
    var hmac = createHmac('sha256', prk).update(infoBitsUpdate).digest();
    return hmac.slice(0, 16);
  };

  /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */


  AuthenticationHelper.prototype.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
    var _this4 = this;

    if (serverBValue.mod(this.N).equals(_BigInteger2.default.ZERO)) {
      throw new Error('B cannot be zero.');
    }

    this.UValue = this.calculateU(this.largeAValue, serverBValue);

    if (this.UValue.equals(_BigInteger2.default.ZERO)) {
      throw new Error('U cannot be zero.');
    }

    var usernamePassword = '' + this.poolName + username + ':' + password;
    var usernamePasswordHash = this.hash(usernamePassword);

    var xValue = new _BigInteger2.default(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
    this.calculateS(xValue, serverBValue, function (err, sValue) {
      if (err) {
        callback(err, null);
      }

      var hkdf = _this4.computehkdf(_buffer.Buffer.from(_this4.padHex(sValue), 'hex'), _buffer.Buffer.from(_this4.padHex(_this4.UValue.toString(16)), 'hex'));

      callback(null, hkdf);
    });
  };

  /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  AuthenticationHelper.prototype.calculateS = function calculateS(xValue, serverBValue, callback) {
    var _this5 = this;

    this.g.modPow(xValue, this.N, function (err, gModPowXN) {
      if (err) {
        callback(err, null);
      }

      var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
      intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function (err2, result) {
        if (err2) {
          callback(err2, null);
        }

        callback(null, result.mod(_this5.N));
      });
    });
  };

  /**
  * Return constant newPasswordRequiredChallengeUserAttributePrefix
  * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
  */


  AuthenticationHelper.prototype.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
    return newPasswordRequiredChallengeUserAttributePrefix;
  };

  /**
   * Converts a BigInteger (or hex string) to hex format padded with zeroes for hashing
   * @param {BigInteger|String} bigInt Number or string to pad.
   * @returns {String} Padded hex string.
   */


  AuthenticationHelper.prototype.padHex = function padHex(bigInt) {
    var hashStr = bigInt.toString(16);
    if (hashStr.length % 2 === 1) {
      hashStr = '0' + hashStr;
    } else if ('89ABCDEFabcdef'.indexOf(hashStr[0]) !== -1) {
      hashStr = '00' + hashStr;
    }
    return hashStr;
  };

  return AuthenticationHelper;
}();

exports.default = AuthenticationHelper;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(101).Buffer
var sha = __webpack_require__(1531)
var sha256 = __webpack_require__(1532)
var rng = __webpack_require__(1533)
var md5 = __webpack_require__(1534)

var algorithms = {
  sha1: sha,
  sha256: sha256,
  md5: md5
}

var blocksize = 64
var zeroBuffer = new Buffer(blocksize); zeroBuffer.fill(0)
function hmac(fn, key, data) {
  if(!Buffer.isBuffer(key)) key = new Buffer(key)
  if(!Buffer.isBuffer(data)) data = new Buffer(data)

  if(key.length > blocksize) {
    key = fn(key)
  } else if(key.length < blocksize) {
    key = Buffer.concat([key, zeroBuffer], blocksize)
  }

  var ipad = new Buffer(blocksize), opad = new Buffer(blocksize)
  for(var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var hash = fn(Buffer.concat([ipad, data]))
  return fn(Buffer.concat([opad, hash]))
}

function hash(alg, key) {
  alg = alg || 'sha1'
  var fn = algorithms[alg]
  var bufs = []
  var length = 0
  if(!fn) error('algorithm:', alg, 'is not yet supported')
  return {
    update: function (data) {
      if(!Buffer.isBuffer(data)) data = new Buffer(data)
        
      bufs.push(data)
      length += data.length
      return this
    },
    digest: function (enc) {
      var buf = Buffer.concat(bufs)
      var r = key ? hmac(fn, key, buf) : fn(buf)
      bufs = null
      return enc ? r.toString(enc) : r
    }
  }
}

function error () {
  var m = [].slice.call(arguments).join(' ')
  throw new Error([
    m,
    'we accept pull requests',
    'http://github.com/dominictarr/crypto-browserify'
    ].join('\n'))
}

exports.createHash = function (alg) { return hash(alg) }
exports.createHmac = function (alg, key) { return hash(alg, key) }
exports.randomBytes = function(size, callback) {
  if (callback && callback.call) {
    try {
      callback.call(this, undefined, new Buffer(rng(size)))
    } catch (err) { callback(err) }
  } else {
    return new Buffer(rng(size))
  }
}

function each(a, f) {
  for(var i in a)
    f(a[i], i)
}

// the least I can do is make error messages for the rest of the node.js/crypto api.
each(['createCredentials'
, 'createCipher'
, 'createCipheriv'
, 'createDecipher'
, 'createDecipheriv'
, 'createSign'
, 'createVerify'
, 'createDiffieHellman'
, 'pbkdf2'], function (name) {
  exports[name] = function () {
    error('sorry,', name, 'is not implemented yet')
  }
})


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow

exports.default = BigInteger;

/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */

// (public) Constructor

function BigInteger(a, b) {
  if (a != null) this.fromString(a, b);
}

// return new, unset BigInteger
function nbi() {
  return new BigInteger(null);
}

// Bits per digit
var dbits;

// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
  while (--n >= 0) {
    var v = x * this[i++] + w[j] + c;
    c = Math.floor(v / 0x4000000);
    w[j++] = v & 0x3ffffff;
  }
  return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
  var xl = x & 0x7fff,
      xh = x >> 15;
  while (--n >= 0) {
    var l = this[i] & 0x7fff;
    var h = this[i++] >> 15;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
    w[j++] = l & 0x3fffffff;
  }
  return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
  var xl = x & 0x3fff,
      xh = x >> 14;
  while (--n >= 0) {
    var l = this[i] & 0x3fff;
    var h = this[i++] >> 14;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
    c = (l >> 28) + (m >> 14) + xh * h;
    w[j++] = l & 0xfffffff;
  }
  return c;
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
  BigInteger.prototype.am = am2;
  dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
  BigInteger.prototype.am = am1;
  dbits = 26;
} else {
  // Mozilla/Netscape seems to prefer am3
  BigInteger.prototype.am = am3;
  dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;

var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;

// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
  BI_RC[rr++] = vv;
}rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}function int2char(n) {
  return BI_RM.charAt(n);
}
function intAt(s, i) {
  var c = BI_RC[s.charCodeAt(i)];
  return c == null ? -1 : c;
}

// (protected) copy this to r
function bnpCopyTo(r) {
  for (var i = this.t - 1; i >= 0; --i) {
    r[i] = this[i];
  }r.t = this.t;
  r.s = this.s;
}

// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
  this.t = 1;
  this.s = x < 0 ? -1 : 0;
  if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;
}

// return bigint initialized to value
function nbv(i) {
  var r = nbi();

  r.fromInt(i);

  return r;
}

// (protected) set from string and radix
function bnpFromString(s, b) {
  var k;
  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0;
  this.s = 0;
  var i = s.length,
      mi = false,
      sh = 0;
  while (--i >= 0) {
    var x = intAt(s, i);
    if (x < 0) {
      if (s.charAt(i) == "-") mi = true;
      continue;
    }
    mi = false;
    if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
      this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
      this[this.t++] = x >> this.DB - sh;
    } else this[this.t - 1] |= x << sh;
    sh += k;
    if (sh >= this.DB) sh -= this.DB;
  }
  this.clamp();
  if (mi) BigInteger.ZERO.subTo(this, this);
}

// (protected) clamp off excess high words
function bnpClamp() {
  var c = this.s & this.DM;
  while (this.t > 0 && this[this.t - 1] == c) {
    --this.t;
  }
}

// (public) return string representation in given radix
function bnToString(b) {
  if (this.s < 0) return "-" + this.negate().toString();
  var k;
  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  var km = (1 << k) - 1,
      d,
      m = false,
      r = "",
      i = this.t;
  var p = this.DB - i * this.DB % k;
  if (i-- > 0) {
    if (p < this.DB && (d = this[i] >> p) > 0) {
      m = true;
      r = int2char(d);
    }
    while (i >= 0) {
      if (p < k) {
        d = (this[i] & (1 << p) - 1) << k - p;
        d |= this[--i] >> (p += this.DB - k);
      } else {
        d = this[i] >> (p -= k) & km;
        if (p <= 0) {
          p += this.DB;
          --i;
        }
      }
      if (d > 0) m = true;
      if (m) r += int2char(d);
    }
  }
  return m ? r : "0";
}

// (public) -this
function bnNegate() {
  var r = nbi();

  BigInteger.ZERO.subTo(this, r);

  return r;
}

// (public) |this|
function bnAbs() {
  return this.s < 0 ? this.negate() : this;
}

// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
  var r = this.s - a.s;
  if (r != 0) return r;
  var i = this.t;
  r = i - a.t;
  if (r != 0) return this.s < 0 ? -r : r;
  while (--i >= 0) {
    if ((r = this[i] - a[i]) != 0) return r;
  }return 0;
}

// returns bit length of the integer x
function nbits(x) {
  var r = 1,
      t;
  if ((t = x >>> 16) != 0) {
    x = t;
    r += 16;
  }
  if ((t = x >> 8) != 0) {
    x = t;
    r += 8;
  }
  if ((t = x >> 4) != 0) {
    x = t;
    r += 4;
  }
  if ((t = x >> 2) != 0) {
    x = t;
    r += 2;
  }
  if ((t = x >> 1) != 0) {
    x = t;
    r += 1;
  }
  return r;
}

// (public) return the number of bits in "this"
function bnBitLength() {
  if (this.t <= 0) return 0;
  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}

// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
  var i;
  for (i = this.t - 1; i >= 0; --i) {
    r[i + n] = this[i];
  }for (i = n - 1; i >= 0; --i) {
    r[i] = 0;
  }r.t = this.t + n;
  r.s = this.s;
}

// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
  for (var i = n; i < this.t; ++i) {
    r[i - n] = this[i];
  }r.t = Math.max(this.t - n, 0);
  r.s = this.s;
}

// (protected) r = this << n
function bnpLShiftTo(n, r) {
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << cbs) - 1;
  var ds = Math.floor(n / this.DB),
      c = this.s << bs & this.DM,
      i;
  for (i = this.t - 1; i >= 0; --i) {
    r[i + ds + 1] = this[i] >> cbs | c;
    c = (this[i] & bm) << bs;
  }
  for (i = ds - 1; i >= 0; --i) {
    r[i] = 0;
  }r[ds] = c;
  r.t = this.t + ds + 1;
  r.s = this.s;
  r.clamp();
}

// (protected) r = this >> n
function bnpRShiftTo(n, r) {
  r.s = this.s;
  var ds = Math.floor(n / this.DB);
  if (ds >= this.t) {
    r.t = 0;
    return;
  }
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << bs) - 1;
  r[0] = this[ds] >> bs;
  for (var i = ds + 1; i < this.t; ++i) {
    r[i - ds - 1] |= (this[i] & bm) << cbs;
    r[i - ds] = this[i] >> bs;
  }
  if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
  r.t = this.t - ds;
  r.clamp();
}

// (protected) r = this - a
function bnpSubTo(a, r) {
  var i = 0,
      c = 0,
      m = Math.min(a.t, this.t);
  while (i < m) {
    c += this[i] - a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c -= a.s;
    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i < a.t) {
      c -= a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c -= a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
  r.t = i;
  r.clamp();
}

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
  var x = this.abs(),
      y = a.abs();
  var i = x.t;
  r.t = i + y.t;
  while (--i >= 0) {
    r[i] = 0;
  }for (i = 0; i < y.t; ++i) {
    r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
  }r.s = 0;
  r.clamp();
  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}

// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
  var x = this.abs();
  var i = r.t = 2 * x.t;
  while (--i >= 0) {
    r[i] = 0;
  }for (i = 0; i < x.t - 1; ++i) {
    var c = x.am(i, x[i], r, 2 * i, 0, 1);
    if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
      r[i + x.t] -= x.DV;
      r[i + x.t + 1] = 1;
    }
  }
  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
  r.s = 0;
  r.clamp();
}

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
  var pm = m.abs();
  if (pm.t <= 0) return;
  var pt = this.abs();
  if (pt.t < pm.t) {
    if (q != null) q.fromInt(0);
    if (r != null) this.copyTo(r);
    return;
  }
  if (r == null) r = nbi();
  var y = nbi(),
      ts = this.s,
      ms = m.s;
  var nsh = this.DB - nbits(pm[pm.t - 1]);
  // normalize modulus
  if (nsh > 0) {
    pm.lShiftTo(nsh, y);
    pt.lShiftTo(nsh, r);
  } else {
    pm.copyTo(y);
    pt.copyTo(r);
  }
  var ys = y.t;
  var y0 = y[ys - 1];
  if (y0 == 0) return;
  var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
  var d1 = this.FV / yt,
      d2 = (1 << this.F1) / yt,
      e = 1 << this.F2;
  var i = r.t,
      j = i - ys,
      t = q == null ? nbi() : q;
  y.dlShiftTo(j, t);
  if (r.compareTo(t) >= 0) {
    r[r.t++] = 1;
    r.subTo(t, r);
  }
  BigInteger.ONE.dlShiftTo(ys, t);
  t.subTo(y, y);
  // "negative" y so we can replace sub with am later
  while (y.t < ys) {
    y[y.t++] = 0;
  }while (--j >= 0) {
    // Estimate quotient digit
    var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
      // Try it out
      y.dlShiftTo(j, t);
      r.subTo(t, r);
      while (r[i] < --qd) {
        r.subTo(t, r);
      }
    }
  }
  if (q != null) {
    r.drShiftTo(ys, q);
    if (ts != ms) BigInteger.ZERO.subTo(q, q);
  }
  r.t = ys;
  r.clamp();
  if (nsh > 0) r.rShiftTo(nsh, r);
  // Denormalize remainder
  if (ts < 0) BigInteger.ZERO.subTo(r, r);
}

// (public) this mod a
function bnMod(a) {
  var r = nbi();
  this.abs().divRemTo(a, null, r);
  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
  return r;
}

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
  if (this.t < 1) return 0;
  var x = this[0];
  if ((x & 1) == 0) return 0;
  var y = x & 3;
  // y == 1/x mod 2^2
  y = y * (2 - (x & 0xf) * y) & 0xf;
  // y == 1/x mod 2^4
  y = y * (2 - (x & 0xff) * y) & 0xff;
  // y == 1/x mod 2^8
  y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
  // y == 1/x mod 2^16
  // last step - calculate inverse mod DV directly;
  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
  y = y * (2 - x * y % this.DV) % this.DV;
  // y == 1/x mod 2^dbits
  // we really want the negative inverse, and -DV < y < DV
  return y > 0 ? this.DV - y : -y;
}

function bnEquals(a) {
  return this.compareTo(a) == 0;
}

// (protected) r = this + a
function bnpAddTo(a, r) {
  var i = 0,
      c = 0,
      m = Math.min(a.t, this.t);
  while (i < m) {
    c += this[i] + a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c += a.s;
    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i < a.t) {
      c += a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }
    c += a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
  r.t = i;
  r.clamp();
}

// (public) this + a
function bnAdd(a) {
  var r = nbi();

  this.addTo(a, r);

  return r;
}

// (public) this - a
function bnSubtract(a) {
  var r = nbi();

  this.subTo(a, r);

  return r;
}

// (public) this * a
function bnMultiply(a) {
  var r = nbi();

  this.multiplyTo(a, r);

  return r;
}

// (public) this / a
function bnDivide(a) {
  var r = nbi();

  this.divRemTo(a, r, null);

  return r;
}

// Montgomery reduction
function Montgomery(m) {
  this.m = m;
  this.mp = m.invDigit();
  this.mpl = this.mp & 0x7fff;
  this.mph = this.mp >> 15;
  this.um = (1 << m.DB - 15) - 1;
  this.mt2 = 2 * m.t;
}

// xR mod m
function montConvert(x) {
  var r = nbi();
  x.abs().dlShiftTo(this.m.t, r);
  r.divRemTo(this.m, null, r);
  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
  return r;
}

// x/R mod m
function montRevert(x) {
  var r = nbi();
  x.copyTo(r);
  this.reduce(r);
  return r;
}

// x = x/R mod m (HAC 14.32)
function montReduce(x) {
  while (x.t <= this.mt2) {
    // pad x so am has enough room later
    x[x.t++] = 0;
  }for (var i = 0; i < this.m.t; ++i) {
    // faster way of calculating u0 = x[i]*mp mod DV
    var j = x[i] & 0x7fff;
    var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
    // use am to combine the multiply-shift-add into one call
    j = i + this.m.t;
    x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
    // propagate carry
    while (x[j] >= x.DV) {
      x[j] -= x.DV;
      x[++j]++;
    }
  }
  x.clamp();
  x.drShiftTo(this.m.t, x);
  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}

// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
  x.squareTo(r);

  this.reduce(r);
}

// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
  x.multiplyTo(y, r);

  this.reduce(r);
}

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;

// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
  var i = e.bitLength(),
      k,
      r = nbv(1),
      z = new Montgomery(m);
  if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;

  // precomputation
  var g = new Array(),
      n = 3,
      k1 = k - 1,
      km = (1 << k) - 1;
  g[1] = z.convert(this);
  if (k > 1) {
    var g2 = nbi();
    z.sqrTo(g[1], g2);
    while (n <= km) {
      g[n] = nbi();
      z.mulTo(g2, g[n - 2], g[n]);
      n += 2;
    }
  }

  var j = e.t - 1,
      w,
      is1 = true,
      r2 = nbi(),
      t;
  i = nbits(e[j]) - 1;
  while (j >= 0) {
    if (i >= k1) w = e[j] >> i - k1 & km;else {
      w = (e[j] & (1 << i + 1) - 1) << k1 - i;
      if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
    }

    n = k;
    while ((w & 1) == 0) {
      w >>= 1;
      --n;
    }
    if ((i -= n) < 0) {
      i += this.DB;
      --j;
    }
    if (is1) {
      // ret == 1, don't bother squaring or multiplying it
      g[w].copyTo(r);
      is1 = false;
    } else {
      while (n > 1) {
        z.sqrTo(r, r2);
        z.sqrTo(r2, r);
        n -= 2;
      }
      if (n > 0) z.sqrTo(r, r2);else {
        t = r;
        r = r2;
        r2 = t;
      }
      z.mulTo(r2, g[w], r);
    }

    while (j >= 0 && (e[j] & 1 << i) == 0) {
      z.sqrTo(r, r2);
      t = r;
      r = r2;
      r2 = t;
      if (--i < 0) {
        i = this.DB - 1;
        --j;
      }
    }
  }
  var result = z.revert(r);
  callback(null, result);
  return result;
}

// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;

// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;

// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CognitoJwtToken2 = __webpack_require__(600);

var _CognitoJwtToken3 = _interopRequireDefault(_CognitoJwtToken2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 Amazon.com,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Inc. or its affiliates. All Rights Reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Amazon Software License (the "License").
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may not use this file except in compliance with the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License. A copy of the License is located at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://aws.amazon.com/asl/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * or in the "license" file accompanying this file. This file is
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * CONDITIONS OF ANY KIND, express or implied. See the License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** @class */
var CognitoAccessToken = function (_CognitoJwtToken) {
  _inherits(CognitoAccessToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */
  function CognitoAccessToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        AccessToken = _ref.AccessToken;

    _classCallCheck(this, CognitoAccessToken);

    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, AccessToken || ''));
  }

  return CognitoAccessToken;
}(_CognitoJwtToken3.default);

exports.default = CognitoAccessToken;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _buffer = __webpack_require__(101);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
                                                                                                                                                           * Copyright 2016 Amazon.com,
                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
                                                                                                                                                           *
                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
                                                                                                                                                           * You may not use this file except in compliance with the
                                                                                                                                                           * License. A copy of the License is located at
                                                                                                                                                           *
                                                                                                                                                           *     http://aws.amazon.com/asl/
                                                                                                                                                           *
                                                                                                                                                           * or in the "license" file accompanying this file. This file is
                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
                                                                                                                                                           * for the specific language governing permissions and
                                                                                                                                                           * limitations under the License.
                                                                                                                                                           */

/** @class */
var CognitoJwtToken = function () {
  /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */
  function CognitoJwtToken(token) {
    _classCallCheck(this, CognitoJwtToken);

    // Assign object
    this.jwtToken = token || '';
    this.payload = this.decodePayload();
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoJwtToken.prototype.getJwtToken = function getJwtToken() {
    return this.jwtToken;
  };

  /**
   * @returns {int} the token's expiration (exp member).
   */


  CognitoJwtToken.prototype.getExpiration = function getExpiration() {
    return this.payload.exp;
  };

  /**
   * @returns {int} the token's "issued at" (iat member).
   */


  CognitoJwtToken.prototype.getIssuedAt = function getIssuedAt() {
    return this.payload.iat;
  };

  /**
   * @returns {object} the token's payload.
   */


  CognitoJwtToken.prototype.decodePayload = function decodePayload() {
    var payload = this.jwtToken.split('.')[1];
    try {
      return JSON.parse(_buffer.Buffer.from(payload, 'base64').toString('utf8'));
    } catch (err) {
      return {};
    }
  };

  return CognitoJwtToken;
}();

exports.default = CognitoJwtToken;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CognitoJwtToken2 = __webpack_require__(600);

var _CognitoJwtToken3 = _interopRequireDefault(_CognitoJwtToken2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 Amazon.com,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Inc. or its affiliates. All Rights Reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Amazon Software License (the "License").
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may not use this file except in compliance with the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License. A copy of the License is located at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://aws.amazon.com/asl/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * or in the "license" file accompanying this file. This file is
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * CONDITIONS OF ANY KIND, express or implied. See the License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** @class */
var CognitoIdToken = function (_CognitoJwtToken) {
  _inherits(CognitoIdToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */
  function CognitoIdToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        IdToken = _ref.IdToken;

    _classCallCheck(this, CognitoIdToken);

    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, IdToken || ''));
  }

  return CognitoIdToken;
}(_CognitoJwtToken3.default);

exports.default = CognitoIdToken;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoRefreshToken = function () {
  /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */
  function CognitoRefreshToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        RefreshToken = _ref.RefreshToken;

    _classCallCheck(this, CognitoRefreshToken);

    // Assign object
    this.token = RefreshToken || '';
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoRefreshToken.prototype.getToken = function getToken() {
    return this.token;
  };

  return CognitoRefreshToken;
}();

exports.default = CognitoRefreshToken;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _buffer = __webpack_require__(101);

var _cryptoBrowserify = __webpack_require__(597);

var crypto = _interopRequireWildcard(_cryptoBrowserify);

var _BigInteger = __webpack_require__(598);

var _BigInteger2 = _interopRequireDefault(_BigInteger);

var _AuthenticationHelper = __webpack_require__(596);

var _AuthenticationHelper2 = _interopRequireDefault(_AuthenticationHelper);

var _CognitoAccessToken = __webpack_require__(599);

var _CognitoAccessToken2 = _interopRequireDefault(_CognitoAccessToken);

var _CognitoIdToken = __webpack_require__(601);

var _CognitoIdToken2 = _interopRequireDefault(_CognitoIdToken);

var _CognitoRefreshToken = __webpack_require__(602);

var _CognitoRefreshToken2 = _interopRequireDefault(_CognitoRefreshToken);

var _CognitoUserSession = __webpack_require__(604);

var _CognitoUserSession2 = _interopRequireDefault(_CognitoUserSession);

var _DateHelper = __webpack_require__(605);

var _DateHelper2 = _interopRequireDefault(_DateHelper);

var _CognitoUserAttribute = __webpack_require__(606);

var _CognitoUserAttribute2 = _interopRequireDefault(_CognitoUserAttribute);

var _StorageHelper = __webpack_require__(607);

var _StorageHelper2 = _interopRequireDefault(_StorageHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
                                                                                                                                                           * Copyright 2016 Amazon.com,
                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
                                                                                                                                                           *
                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
                                                                                                                                                           * You may not use this file except in compliance with the
                                                                                                                                                           * License. A copy of the License is located at
                                                                                                                                                           *
                                                                                                                                                           *     http://aws.amazon.com/asl/
                                                                                                                                                           *
                                                                                                                                                           * or in the "license" file accompanying this file. This file is
                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
                                                                                                                                                           * for the specific language governing permissions and
                                                                                                                                                           * limitations under the License.
                                                                                                                                                           */

//import createHmac from 'create-hmac';


var createHmac = crypto.createHmac;

/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */

/**
 * @callback onFailure
 * @param {*} err Failure reason.
 */

/**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */

/**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */

/**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */

/**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */

/**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */

/** @class */
var CognitoUser = function () {
  /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */
  function CognitoUser(data) {
    _classCallCheck(this, CognitoUser);

    if (data == null || data.Username == null || data.Pool == null) {
      throw new Error('Username and pool information are required.');
    }

    this.username = data.Username || '';
    this.pool = data.Pool;
    this.Session = null;

    this.client = data.Pool.client;

    this.signInUserSession = null;
    this.authenticationFlowType = 'USER_SRP_AUTH';

    this.storage = data.Storage || new _StorageHelper2.default().getStorage();
  }

  /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */


  CognitoUser.prototype.setSignInUserSession = function setSignInUserSession(signInUserSession) {
    this.clearCachedTokens();
    this.signInUserSession = signInUserSession;
    this.cacheTokens();
  };

  /**
   * @returns {CognitoUserSession} the current session for this user
   */


  CognitoUser.prototype.getSignInUserSession = function getSignInUserSession() {
    return this.signInUserSession;
  };

  /**
   * @returns {string} the user's username
   */


  CognitoUser.prototype.getUsername = function getUsername() {
    return this.username;
  };

  /**
   * @returns {String} the authentication flow type
   */


  CognitoUser.prototype.getAuthenticationFlowType = function getAuthenticationFlowType() {
    return this.authenticationFlowType;
  };

  /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */


  CognitoUser.prototype.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
    this.authenticationFlowType = authenticationFlowType;
  };

  /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.initiateAuth = function initiateAuth(authDetails, callback) {
    var _this = this;

    var authParameters = authDetails.getAuthParameters();
    authParameters.USERNAME = this.username;

    var jsonReq = {
      AuthFlow: 'CUSTOM_AUTH',
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: authDetails.getValidationData()
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('InitiateAuth', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      var challengeName = data.ChallengeName;
      var challengeParameters = data.ChallengeParameters;

      if (challengeName === 'CUSTOM_CHALLENGE') {
        _this.Session = data.Session;
        return callback.customChallenge(challengeParameters);
      }
      _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
      _this.cacheTokens();
      return callback.onSuccess(_this.signInUserSession);
    });
  };

  /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.authenticateUser = function authenticateUser(authDetails, callback) {
    if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') {
      return this.authenticateUserPlainUsernamePassword(authDetails, callback);
    } else if (this.authenticationFlowType === 'USER_SRP_AUTH') {
      return this.authenticateUserDefaultAuth(authDetails, callback);
    }
    return callback.onFailure(new Error('Authentication flow type is invalid.'));
  };

  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
    var _this2 = this;

    var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1]);
    var dateHelper = new _DateHelper2.default();

    var serverBValue = void 0;
    var salt = void 0;
    var authParameters = {};

    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    authParameters.USERNAME = this.username;
    authenticationHelper.getLargeAValue(function (errOnAValue, aValue) {
      // getLargeAValue callback start
      if (errOnAValue) {
        callback.onFailure(errOnAValue);
      }

      authParameters.SRP_A = aValue.toString(16);

      if (_this2.authenticationFlowType === 'CUSTOM_AUTH') {
        authParameters.CHALLENGE_NAME = 'SRP_A';
      }

      var jsonReq = {
        AuthFlow: _this2.authenticationFlowType,
        ClientId: _this2.pool.getClientId(),
        AuthParameters: authParameters,
        ClientMetadata: authDetails.getValidationData()
      };
      if (_this2.getUserContextData(_this2.username)) {
        jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
      }

      _this2.client.request('InitiateAuth', jsonReq, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        var challengeParameters = data.ChallengeParameters;

        _this2.username = challengeParameters.USER_ID_FOR_SRP;
        serverBValue = new _BigInteger2.default(challengeParameters.SRP_B, 16);
        salt = new _BigInteger2.default(challengeParameters.SALT, 16);
        _this2.getCachedDeviceKeyAndPassword();

        authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function (errOnHkdf, hkdf) {
          // getPasswordAuthenticationKey callback start
          if (errOnHkdf) {
            callback.onFailure(errOnHkdf);
          }

          var dateNow = dateHelper.getNowString();

          var signatureString = createHmac('sha256', hkdf).update(_buffer.Buffer.concat([_buffer.Buffer.from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'), _buffer.Buffer.from(_this2.username, 'utf8'), _buffer.Buffer.from(challengeParameters.SECRET_BLOCK, 'base64'), _buffer.Buffer.from(dateNow, 'utf8')])).digest('base64');

          var challengeResponses = {};

          challengeResponses.USERNAME = _this2.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;

          if (_this2.deviceKey != null) {
            challengeResponses.DEVICE_KEY = _this2.deviceKey;
          }

          var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
            return _this2.client.request('RespondToAuthChallenge', challenge, function (errChallenge, dataChallenge) {
              if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                challengeResponses.DEVICE_KEY = null;
                _this2.deviceKey = null;
                _this2.randomPassword = null;
                _this2.deviceGroupKey = null;
                _this2.clearCachedDeviceKeyAndPassword();
                return respondToAuthChallenge(challenge, challengeCallback);
              }
              return challengeCallback(errChallenge, dataChallenge);
            });
          };

          var jsonReqResp = {
            ChallengeName: 'PASSWORD_VERIFIER',
            ClientId: _this2.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session
          };
          if (_this2.getUserContextData()) {
            jsonReqResp.UserContextData = _this2.getUserContextData();
          }
          respondToAuthChallenge(jsonReqResp, function (errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }

            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'NEW_PASSWORD_REQUIRED') {
              _this2.Session = dataAuthenticate.Session;
              var userAttributes = null;
              var rawRequiredAttributes = null;
              var requiredAttributes = [];
              var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

              if (dataAuthenticate.ChallengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
              }

              if (rawRequiredAttributes) {
                for (var i = 0; i < rawRequiredAttributes.length; i++) {
                  requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
                }
              }
              return callback.newPasswordRequired(userAttributes, requiredAttributes);
            }
            return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
          });
          return undefined;
          // getPasswordAuthenticationKey callback end
        });
        return undefined;
      });
      // getLargeAValue callback end
    });
  };

  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
    var _this3 = this;

    var authParameters = {};
    authParameters.USERNAME = this.username;
    authParameters.PASSWORD = authDetails.getPassword();
    if (!authParameters.PASSWORD) {
      callback.onFailure(new Error('PASSWORD parameter is required'));
      return;
    }
    var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1]);
    this.getCachedDeviceKeyAndPassword();
    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      AuthFlow: 'USER_PASSWORD_AUTH',
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: authDetails.getValidationData()
    };
    if (this.getUserContextData(this.username)) {
      jsonReq.UserContextData = this.getUserContextData(this.username);
    }
    // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
    // Cognito UserPools verifies password and returns tokens.
    this.client.request('InitiateAuth', jsonReq, function (err, authResult) {
      if (err) {
        return callback.onFailure(err);
      }
      return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
    });
  };

  /**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * @param {object} dataAuthenticate authentication data
  * @param {object} authenticationHelper helper created
  * @param {callback} callback passed on from caller
  * @returns {void}
  */


  CognitoUser.prototype.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
    var _this4 = this;

    var challengeName = dataAuthenticate.ChallengeName;
    var challengeParameters = dataAuthenticate.ChallengeParameters;

    if (challengeName === 'SMS_MFA') {
      this.Session = dataAuthenticate.Session;
      return callback.mfaRequired(challengeName, challengeParameters);
    }

    if (challengeName === 'SELECT_MFA_TYPE') {
      this.Session = dataAuthenticate.Session;
      return callback.selectMFAType(challengeName, challengeParameters);
    }

    if (challengeName === 'MFA_SETUP') {
      this.Session = dataAuthenticate.Session;
      return callback.mfaSetup(challengeName, challengeParameters);
    }

    if (challengeName === 'SOFTWARE_TOKEN_MFA') {
      this.Session = dataAuthenticate.Session;
      return callback.totpRequired(challengeName, challengeParameters);
    }

    if (challengeName === 'CUSTOM_CHALLENGE') {
      this.Session = dataAuthenticate.Session;
      return callback.customChallenge(challengeParameters);
    }

    if (challengeName === 'DEVICE_SRP_AUTH') {
      this.getDeviceResponse(callback);
      return undefined;
    }

    this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
    this.cacheTokens();

    var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
    if (newDeviceMetadata == null) {
      return callback.onSuccess(this.signInUserSession);
    }

    authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
      if (errGenHash) {
        return callback.onFailure(errGenHash);
      }

      var deviceSecretVerifierConfig = {
        Salt: _buffer.Buffer.from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
        PasswordVerifier: _buffer.Buffer.from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
      };

      _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
      _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
      _this4.randomPassword = authenticationHelper.getRandomPassword();

      _this4.client.request('ConfirmDevice', {
        DeviceKey: newDeviceMetadata.DeviceKey,
        AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
        DeviceName: navigator.userAgent
      }, function (errConfirm, dataConfirm) {
        if (errConfirm) {
          return callback.onFailure(errConfirm);
        }

        _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
        _this4.cacheDeviceKeyAndPassword();
        if (dataConfirm.UserConfirmationNecessary === true) {
          return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
        }
        return callback.onSuccess(_this4.signInUserSession);
      });
      return undefined;
    });
    return undefined;
  };

  /**
  * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
  * Pass the new password with any new user attributes to be updated.
  * User attribute keys must be of format userAttributes.<attribute_name>.
  * @param {string} newPassword new password for this user
  * @param {object} requiredAttributeData map with values for all required attributes
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *         response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */


  CognitoUser.prototype.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback) {
    var _this5 = this;

    if (!newPassword) {
      return callback.onFailure(new Error('New password is required.'));
    }
    var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1]);
    var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

    var finalUserAttributes = {};
    if (requiredAttributeData) {
      Object.keys(requiredAttributeData).forEach(function (key) {
        finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
      });
    }

    finalUserAttributes.NEW_PASSWORD = newPassword;
    finalUserAttributes.USERNAME = this.username;
    var jsonReq = {
      ChallengeName: 'NEW_PASSWORD_REQUIRED',
      ClientId: this.pool.getClientId(),
      ChallengeResponses: finalUserAttributes,
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('RespondToAuthChallenge', jsonReq, function (errAuthenticate, dataAuthenticate) {
      if (errAuthenticate) {
        return callback.onFailure(errAuthenticate);
      }
      return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
    });
    return undefined;
  };

  /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   * @private
   */


  CognitoUser.prototype.getDeviceResponse = function getDeviceResponse(callback) {
    var _this6 = this;

    var authenticationHelper = new _AuthenticationHelper2.default(this.deviceGroupKey);
    var dateHelper = new _DateHelper2.default();

    var authParameters = {};

    authParameters.USERNAME = this.username;
    authParameters.DEVICE_KEY = this.deviceKey;
    authenticationHelper.getLargeAValue(function (errAValue, aValue) {
      // getLargeAValue callback start
      if (errAValue) {
        callback.onFailure(errAValue);
      }

      authParameters.SRP_A = aValue.toString(16);

      var jsonReq = {
        ChallengeName: 'DEVICE_SRP_AUTH',
        ClientId: _this6.pool.getClientId(),
        ChallengeResponses: authParameters
      };
      if (_this6.getUserContextData()) {
        jsonReq.UserContextData = _this6.getUserContextData();
      }
      _this6.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        var challengeParameters = data.ChallengeParameters;

        var serverBValue = new _BigInteger2.default(challengeParameters.SRP_B, 16);
        var salt = new _BigInteger2.default(challengeParameters.SALT, 16);

        authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function (errHkdf, hkdf) {
          // getPasswordAuthenticationKey callback start
          if (errHkdf) {
            return callback.onFailure(errHkdf);
          }

          var dateNow = dateHelper.getNowString();

          var signatureString = createHmac('sha256', hkdf).update(_buffer.Buffer.concat([_buffer.Buffer.from(_this6.deviceGroupKey, 'utf8'), _buffer.Buffer.from(_this6.deviceKey, 'utf8'), _buffer.Buffer.from(challengeParameters.SECRET_BLOCK, 'base64'), _buffer.Buffer.from(dateNow, 'utf8')])).digest('base64');

          var challengeResponses = {};

          challengeResponses.USERNAME = _this6.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
          challengeResponses.DEVICE_KEY = _this6.deviceKey;

          var jsonReqResp = {
            ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
            ClientId: _this6.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session
          };
          if (_this6.getUserContextData()) {
            jsonReqResp.UserContextData = _this6.getUserContextData();
          }

          _this6.client.request('RespondToAuthChallenge', jsonReqResp, function (errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }

            _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this6.cacheTokens();

            return callback.onSuccess(_this6.signInUserSession);
          });
          return undefined;
          // getPasswordAuthenticationKey callback end
        });
        return undefined;
      });
      // getLargeAValue callback end
    });
  };

  /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: confirmationCode,
      Username: this.username,
      ForceAliasCreation: forceAliasCreation
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request('ConfirmSignUp', jsonReq, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
  };

  /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challange answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback) {
    var _this7 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;

    var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1]);
    this.getCachedDeviceKeyAndPassword();
    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ChallengeName: 'CUSTOM_CHALLENGE',
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      return _this7.authenticateUserInternal(data, authenticationHelper, callback);
    });
  };

  /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */


  CognitoUser.prototype.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType) {
    var _this8 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.SMS_MFA_CODE = confirmationCode;
    var mfaTypeSelection = mfaType || 'SMS_MFA';
    if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') {
      challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
    }

    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ChallengeName: mfaTypeSelection,
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('RespondToAuthChallenge', jsonReq, function (err, dataAuthenticate) {
      if (err) {
        return callback.onFailure(err);
      }

      var challengeName = dataAuthenticate.ChallengeName;

      if (challengeName === 'DEVICE_SRP_AUTH') {
        _this8.getDeviceResponse(callback);
        return undefined;
      }

      _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
      _this8.cacheTokens();

      if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
        return callback.onSuccess(_this8.signInUserSession);
      }

      var authenticationHelper = new _AuthenticationHelper2.default(_this8.pool.getUserPoolId().split('_')[1]);
      authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
        if (errGenHash) {
          return callback.onFailure(errGenHash);
        }

        var deviceSecretVerifierConfig = {
          Salt: _buffer.Buffer.from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
          PasswordVerifier: _buffer.Buffer.from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
        };

        _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
        _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
        _this8.randomPassword = authenticationHelper.getRandomPassword();

        _this8.client.request('ConfirmDevice', {
          DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
          DeviceName: navigator.userAgent
        }, function (errConfirm, dataConfirm) {
          if (errConfirm) {
            return callback.onFailure(errConfirm);
          }

          _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
          _this8.cacheDeviceKeyAndPassword();
          if (dataConfirm.UserConfirmationNecessary === true) {
            return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
          }
          return callback.onSuccess(_this8.signInUserSession);
        });
        return undefined;
      });
      return undefined;
    });
  };

  /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.changePassword = function changePassword(oldUserPassword, newUserPassword, callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('ChangePassword', {
      PreviousPassword: oldUserPassword,
      ProposedPassword: newUserPassword,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to enable MFA for himself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.enableMFA = function enableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    var mfaOptions = [];
    var mfaEnabled = {
      DeliveryMedium: 'SMS',
      AttributeName: 'phone_number'
    };
    mfaOptions.push(mfaEnabled);

    this.client.request('SetUserSettings', {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to enable MFA for himself
   * @param {string[]} smsMfaSettings the sms mfa settings
   * @param {string[]} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('SetUserMFAPreference', {
      SMSMfaSettings: smsMfaSettings,
      SoftwareTokenMfaSettings: softwareTokenMfaSettings,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to disable MFA for himself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.disableMFA = function disableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    var mfaOptions = [];

    this.client.request('SetUserSettings', {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to delete himself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.deleteUser = function deleteUser(callback) {
    var _this9 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('DeleteUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      _this9.clearCachedTokens();
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
   */
  /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.updateAttributes = function updateAttributes(attributes, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('UpdateUserAttributes', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: attributes
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getUserAttributes = function getUserAttributes(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('GetUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      var attributeList = [];

      for (var i = 0; i < userData.UserAttributes.length; i++) {
        var attribute = {
          Name: userData.UserAttributes[i].Name,
          Value: userData.UserAttributes[i].Value
        };
        var userAttribute = new _CognitoUserAttribute2.default(attribute);
        attributeList.push(userAttribute);
      }

      return callback(null, attributeList);
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to get the MFAOptions
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getMFAOptions = function getMFAOptions(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('GetUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, userData.MFAOptions);
    });
    return undefined;
  };

  /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getUserData = function getUserData(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('GetUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, userData);
    });
    return undefined;
  };

  /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.deleteAttributes = function deleteAttributes(attributeList, callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('DeleteUserAttributes', {
      UserAttributeNames: attributeList,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, 'SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.resendConfirmationCode = function resendConfirmationCode(callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username
    };

    this.client.request('ResendConfirmationCode', jsonReq, function (err, result) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, result);
    });
  };

  /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.getSession = function getSession(callback) {
    if (this.username == null) {
      return callback(new Error('Username is null. Cannot retrieve a new session'), null);
    }

    if (this.signInUserSession != null && this.signInUserSession.isValid()) {
      return callback(null, this.signInUserSession);
    }

    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var idTokenKey = keyPrefix + '.idToken';
    var accessTokenKey = keyPrefix + '.accessToken';
    var refreshTokenKey = keyPrefix + '.refreshToken';
    var clockDriftKey = keyPrefix + '.clockDrift';

    if (this.storage.getItem(idTokenKey)) {
      var idToken = new _CognitoIdToken2.default({
        IdToken: this.storage.getItem(idTokenKey)
      });
      var accessToken = new _CognitoAccessToken2.default({
        AccessToken: this.storage.getItem(accessTokenKey)
      });
      var refreshToken = new _CognitoRefreshToken2.default({
        RefreshToken: this.storage.getItem(refreshTokenKey)
      });
      var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;

      var sessionData = {
        IdToken: idToken,
        AccessToken: accessToken,
        RefreshToken: refreshToken,
        ClockDrift: clockDrift
      };
      var cachedSession = new _CognitoUserSession2.default(sessionData);
      if (cachedSession.isValid()) {
        this.signInUserSession = cachedSession;
        return callback(null, this.signInUserSession);
      }

      if (refreshToken.getToken() == null) {
        return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
      }

      this.refreshSession(refreshToken, callback);
    } else {
      callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
    }

    return undefined;
  };

  /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.refreshSession = function refreshSession(refreshToken, callback) {
    var _this10 = this;

    var authParameters = {};
    authParameters.REFRESH_TOKEN = refreshToken.getToken();
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
    var lastUserKey = keyPrefix + '.LastAuthUser';

    if (this.storage.getItem(lastUserKey)) {
      this.username = this.storage.getItem(lastUserKey);
      var deviceKeyKey = keyPrefix + '.' + this.username + '.deviceKey';
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ClientId: this.pool.getClientId(),
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: authParameters
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request('InitiateAuth', jsonReq, function (err, authResult) {
      if (err) {
        if (err.code === 'NotAuthorizedException') {
          _this10.clearCachedTokens();
        }
        return callback(err, null);
      }
      if (authResult) {
        var authenticationResult = authResult.AuthenticationResult;
        if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) {
          authenticationResult.RefreshToken = refreshToken.getToken();
        }
        _this10.signInUserSession = _this10.getCognitoUserSession(authenticationResult);
        _this10.cacheTokens();
        return callback(null, _this10.signInUserSession);
      }
      return undefined;
    });
  };

  /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */


  CognitoUser.prototype.cacheTokens = function cacheTokens() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
    var clockDriftKey = keyPrefix + '.' + this.username + '.clockDrift';
    var lastUserKey = keyPrefix + '.LastAuthUser';

    this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
    this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
    this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
    this.storage.setItem(clockDriftKey, '' + this.signInUserSession.getClockDrift());
    this.storage.setItem(lastUserKey, this.username);
  };

  /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */


  CognitoUser.prototype.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var deviceKeyKey = keyPrefix + '.deviceKey';
    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

    this.storage.setItem(deviceKeyKey, this.deviceKey);
    this.storage.setItem(randomPasswordKey, this.randomPassword);
    this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
  };

  /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */


  CognitoUser.prototype.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var deviceKeyKey = keyPrefix + '.deviceKey';
    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

    if (this.storage.getItem(deviceKeyKey)) {
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      this.randomPassword = this.storage.getItem(randomPasswordKey);
      this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
    }
  };

  /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */


  CognitoUser.prototype.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
    var deviceKeyKey = keyPrefix + '.deviceKey';
    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

    this.storage.removeItem(deviceKeyKey);
    this.storage.removeItem(randomPasswordKey);
    this.storage.removeItem(deviceGroupKeyKey);
  };

  /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */


  CognitoUser.prototype.clearCachedTokens = function clearCachedTokens() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
    var lastUserKey = keyPrefix + '.LastAuthUser';

    this.storage.removeItem(idTokenKey);
    this.storage.removeItem(accessTokenKey);
    this.storage.removeItem(refreshTokenKey);
    this.storage.removeItem(lastUserKey);
  };

  /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */


  CognitoUser.prototype.getCognitoUserSession = function getCognitoUserSession(authResult) {
    var idToken = new _CognitoIdToken2.default(authResult);
    var accessToken = new _CognitoAccessToken2.default(authResult);
    var refreshToken = new _CognitoRefreshToken2.default(authResult);

    var sessionData = {
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken
    };

    return new _CognitoUserSession2.default(sessionData);
  };

  /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.forgotPassword = function forgotPassword(callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request('ForgotPassword', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      if (typeof callback.inputVerificationCode === 'function') {
        return callback.inputVerificationCode(data);
      }
      return callback.onSuccess(data);
    });
  };

  /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: confirmationCode,
      Password: newPassword
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request('ConfirmForgotPassword', jsonReq, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess();
    });
  };

  /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('GetUserAttributeVerificationCode', {
      AttributeName: attributeName,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      if (typeof callback.inputVerificationCode === 'function') {
        return callback.inputVerificationCode(data);
      }
      return callback.onSuccess();
    });
    return undefined;
  };

  /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('VerifyUserAttribute', {
      AttributeName: attributeName,
      Code: confirmationCode,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */


  CognitoUser.prototype.getDevice = function getDevice(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('GetDevice', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess(data);
    });
    return undefined;
  };

  /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('ForgetDevice', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: deviceKey
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.forgetDevice = function forgetDevice(callback) {
    var _this11 = this;

    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: callback.onFailure,
      onSuccess: function onSuccess(result) {
        _this11.deviceKey = null;
        _this11.deviceGroupKey = null;
        _this11.randomPassword = null;
        _this11.clearCachedDeviceKeyAndPassword();
        return callback.onSuccess(result);
      }
    });
  };

  /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('UpdateDeviceStatus', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: 'remembered'
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('UpdateDeviceStatus', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: 'not_remembered'
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */


  CognitoUser.prototype.listDevices = function listDevices(limit, paginationToken, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('ListDevices', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: limit,
      PaginationToken: paginationToken
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess(data);
    });
    return undefined;
  };

  /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */


  CognitoUser.prototype.globalSignOut = function globalSignOut(callback) {
    var _this12 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('GlobalSignOut', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }
      _this12.clearCachedTokens();
      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  };

  /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */


  CognitoUser.prototype.signOut = function signOut() {
    this.signInUserSession = null;
    this.clearCachedTokens();
  };

  /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
    var _this13 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;

    var jsonReq = {
      ChallengeName: 'SELECT_MFA_TYPE',
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      _this13.Session = data.Session;
      if (answerChallenge === 'SMS_MFA') {
        return callback.mfaRequired(data.challengeName, data.challengeParameters);
      }
      if (answerChallenge === 'SOFTWARE_TOKEN_MFA') {
        return callback.totpRequired(data.challengeName, data.challengeParameters);
      }
      return undefined;
    });
  };

  /**
   * This returns the user context data for advanced security feature.
   * @returns {void}
   */


  CognitoUser.prototype.getUserContextData = function getUserContextData() {
    var pool = this.pool;
    return pool.getUserContextData(this.username);
  };

  /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.associateSoftwareToken = function associateSoftwareToken(callback) {
    var _this14 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.request('AssociateSoftwareToken', {
        Session: this.Session
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        _this14.Session = data.Session;
        return callback.associateSecretCode(data.SecretCode);
      });
    } else {
      this.client.request('AssociateSoftwareToken', {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        return callback.associateSecretCode(data.SecretCode);
      });
    }
  };

  /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */


  CognitoUser.prototype.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
    var _this15 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.request('VerifySoftwareToken', {
        Session: this.Session,
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        _this15.Session = data.Session;
        var challengeResponses = {};
        challengeResponses.USERNAME = _this15.username;
        var jsonReq = {
          ChallengeName: 'MFA_SETUP',
          ClientId: _this15.pool.getClientId(),
          ChallengeResponses: challengeResponses,
          Session: _this15.Session
        };
        if (_this15.getUserContextData()) {
          jsonReq.UserContextData = _this15.getUserContextData();
        }
        _this15.client.request('RespondToAuthChallenge', jsonReq, function (errRespond, dataRespond) {
          if (errRespond) {
            return callback.onFailure(errRespond);
          }
          _this15.signInUserSession = _this15.getCognitoUserSession(dataRespond.AuthenticationResult);
          _this15.cacheTokens();
          return callback.onSuccess(_this15.signInUserSession);
        });
        return undefined;
      });
    } else {
      this.client.request('VerifySoftwareToken', {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        return callback.onSuccess(data);
      });
    }
  };

  return CognitoUser;
}();

exports.default = CognitoUser;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserSession = function () {
  /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */
  function CognitoUserSession() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        IdToken = _ref.IdToken,
        RefreshToken = _ref.RefreshToken,
        AccessToken = _ref.AccessToken,
        ClockDrift = _ref.ClockDrift;

    _classCallCheck(this, CognitoUserSession);

    if (AccessToken == null || IdToken == null) {
      throw new Error('Id token and Access Token must be present.');
    }

    this.idToken = IdToken;
    this.refreshToken = RefreshToken;
    this.accessToken = AccessToken;
    this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
  }

  /**
   * @returns {CognitoIdToken} the session's Id token
   */


  CognitoUserSession.prototype.getIdToken = function getIdToken() {
    return this.idToken;
  };

  /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */


  CognitoUserSession.prototype.getRefreshToken = function getRefreshToken() {
    return this.refreshToken;
  };

  /**
   * @returns {CognitoAccessToken} the session's access token
   */


  CognitoUserSession.prototype.getAccessToken = function getAccessToken() {
    return this.accessToken;
  };

  /**
   * @returns {int} the session's clock drift
   */


  CognitoUserSession.prototype.getClockDrift = function getClockDrift() {
    return this.clockDrift;
  };

  /**
   * @returns {int} the computer's clock drift
   */


  CognitoUserSession.prototype.calculateClockDrift = function calculateClockDrift() {
    var now = Math.floor(new Date() / 1000);
    var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());

    return now - iat;
  };

  /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */


  CognitoUserSession.prototype.isValid = function isValid() {
    var now = Math.floor(new Date() / 1000);
    var adjusted = now - this.clockDrift;

    return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
  };

  return CognitoUserSession;
}();

exports.default = CognitoUserSession;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** @class */

var DateHelper = function () {
  function DateHelper() {
    _classCallCheck(this, DateHelper);
  }

  /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */
  DateHelper.prototype.getNowString = function getNowString() {
    var now = new Date();

    var weekDay = weekNames[now.getUTCDay()];
    var month = monthNames[now.getUTCMonth()];
    var day = now.getUTCDate();

    var hours = now.getUTCHours();
    if (hours < 10) {
      hours = '0' + hours;
    }

    var minutes = now.getUTCMinutes();
    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    var seconds = now.getUTCSeconds();
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    var year = now.getUTCFullYear();

    // ddd MMM D HH:mm:ss UTC YYYY
    var dateNow = weekDay + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC ' + year;

    return dateNow;
  };

  return DateHelper;
}();

exports.default = DateHelper;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserAttribute = function () {
  /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */
  function CognitoUserAttribute() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        Name = _ref.Name,
        Value = _ref.Value;

    _classCallCheck(this, CognitoUserAttribute);

    this.Name = Name || '';
    this.Value = Value || '';
  }

  /**
   * @returns {string} the record's value.
   */


  CognitoUserAttribute.prototype.getValue = function getValue() {
    return this.Value;
  };

  /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */


  CognitoUserAttribute.prototype.setValue = function setValue(value) {
    this.Value = value;
    return this;
  };

  /**
   * @returns {string} the record's name.
   */


  CognitoUserAttribute.prototype.getName = function getName() {
    return this.Name;
  };

  /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */


  CognitoUserAttribute.prototype.setName = function setName(name) {
    this.Name = name;
    return this;
  };

  /**
   * @returns {string} a string representation of the record.
   */


  CognitoUserAttribute.prototype.toString = function toString() {
    return JSON.stringify(this);
  };

  /**
   * @returns {object} a flat object representing the record.
   */


  CognitoUserAttribute.prototype.toJSON = function toJSON() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  };

  return CognitoUserAttribute;
}();

exports.default = CognitoUserAttribute;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

var dataMemory = {};

/** @class */

var MemoryStorage = function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);
  }

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  MemoryStorage.setItem = function setItem(key, value) {
    dataMemory[key] = value;
    return dataMemory[key];
  };

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */


  MemoryStorage.getItem = function getItem(key) {
    return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
  };

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */


  MemoryStorage.removeItem = function removeItem(key) {
    return delete dataMemory[key];
  };

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */


  MemoryStorage.clear = function clear() {
    dataMemory = {};
    return dataMemory;
  };

  return MemoryStorage;
}();

/** @class */


var StorageHelper = function () {

  /**
   * This is used to get a storage object
   * @returns {object} the storage
   */
  function StorageHelper() {
    _classCallCheck(this, StorageHelper);

    try {
      this.storageWindow = window.localStorage;
      this.storageWindow.setItem('aws.cognito.test-ls', 1);
      this.storageWindow.removeItem('aws.cognito.test-ls');
    } catch (exception) {
      this.storageWindow = MemoryStorage;
    }
  }

  /**
   * This is used to return the storage
   * @returns {object} the storage
   */


  StorageHelper.prototype.getStorage = function getStorage() {
    return this.storageWindow;
  };

  return StorageHelper;
}();

exports.default = StorageHelper;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

/**!
* @license FusionCharts JavaScript Library
* Copyright FusionCharts, Inc.
* License Information at <http://www.fusioncharts.com/license>
*
* @version 3.18.0
*
* @attributions (infers respective third-party copyrights)
* Raphael 2.1.0 (modified as 'Red Raphael') <http://raphaeljs.com/license.html>
* JSON v2 <http://www.JSON.org/js.html>
* Firebug Lite 1.3.0 <http://getfirebug.com/firebuglite>
*/
"function"!=typeof Object.assign&&(Object.assign=function(e){"use strict";var t,r,n,a;if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(t=Object(e),r=1;r<arguments.length;r++)if(null!=(n=arguments[r]))for(a in n)Object.prototype.hasOwnProperty.call(n,a)&&(t[a]=n[a]);return t}),Function.prototype.bind||(Function.prototype.bind=function(e){"use strict";var t,r,n,a;if("function"!=typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");return t=Array.prototype.slice.call(arguments,1),r=this,n=function(){},a=function(){return r.apply(this instanceof n?this:e,t.concat(Array.prototype.slice.call(arguments)))},this.prototype&&(n.prototype=this.prototype),a.prototype=new n,a}),!document.head&&(document.head=document.getElementsByTagName("head")[0]),function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.FusionCharts=t():e.FusionCharts=t()}(window,(function(){return function(e){function t(t){for(var r,a,i=t[0],o=t[1],s=0,c=[];s<i.length;s++)a=i[s],Object.prototype.hasOwnProperty.call(n,a)&&n[a]&&c.push(n[a][0]),n[a]=0;for(r in o)Object.prototype.hasOwnProperty.call(o,r)&&(e[r]=o[r]);for(l&&l(t);c.length;)c.shift()()}var r={},n={0:0};function a(t){if(r[t])return r[t].exports;var n=r[t]={i:t,l:!1,exports:{}};return e[t].call(n.exports,n,n.exports,a),n.l=!0,n.exports}a.e=function(e){var t=[],r=n[e];if(0!==r)if(r)t.push(r[2]);else{var i=new Promise((function(t,a){r=n[e]=[t,a]}));t.push(r[2]=i);var o,s=document.createElement("script");s.charset="utf-8",s.timeout=120,a.nc&&s.setAttribute("nonce",a.nc),s.src=function(e){return a.p+""+({1:"fusioncharts.charts",2:"fusioncharts.common",3:"fusioncharts.timeseries",4:"fusioncharts.powercharts",5:"fusioncharts.widgets",6:"fusioncharts.zoomline",7:"fusioncharts.gantt",8:"fusioncharts.treemap",9:"fusioncharts.zoomscatter",10:"fusioncharts.msstackedcolumn2dsplinedy",11:"fusioncharts.overlappedbar2d",12:"fusioncharts.overlappedcolumn2d",13:"fusioncharts.excelexport",14:"fusioncharts.accessibility",15:"fusioncharts.maps",16:"fusioncharts.vml"}[e]||e)+".js"}(e);var l=new Error;o=function(t){s.onerror=s.onload=null,clearTimeout(c);var r=n[e];if(0!==r){if(r){var a=t&&("load"===t.type?"missing":t.type),i=t&&t.target&&t.target.src;l.message="Loading chunk "+e+" failed.\n("+a+": "+i+")",l.name="ChunkLoadError",l.type=a,l.request=i,r[1](l)}n[e]=undefined}};var c=setTimeout((function(){o({type:"timeout",target:s})}),12e4);s.onerror=s.onload=o,document.head.appendChild(s)}return Promise.all(t)},a.m=e,a.c=r,a.d=function(e,t,r){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(e,t){if(1&t&&(e=a(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(a.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)a.d(r,n,function(t){return e[t]}.bind(null,n));return r},a.n=function(e){var t=e&&e.__esModule?function(){return e["default"]}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a.oe=function(e){throw console.error(e),e};var i=window.webpackJsonpFusionCharts=window.webpackJsonpFusionCharts||[],o=i.push.bind(i);i.push=t,i=i.slice();for(var s=0;s<i.length;s++)t(i[s]);var l=o;return a(a.s=0)}([function(e,t,r){r(1),r(136),r(214),e.exports=r(218)},function(e,t,r){"use strict";r(2),r(63),r(65),r(67),r(73),r(75),r(80),r(90),r(93),r(95),r(99),r(101),r(103),r(109),r(135);window.getComputedStyle||(window.getComputedStyle=function(e){return this.el=e,this.getPropertyValue=function(t){var r=/(\-([a-z]){1})/g,n=t;return"float"===n&&(n="styleFloat"),r.test(n)&&(n=n.replace(r,(function(){return arguments[2].toUpperCase()}))),e.currentStyle[n]?e.currentStyle[n]:null},this}),Event.prototype.stopPropagation||(Event.prototype.stopPropagation=function(){this.cancelBubble=!0})},function(e,t,r){r(3);var n=r(62).Object;e.exports=function(e){return n.getOwnPropertyNames(e)}},function(e,t,r){var n=r(4),a=r(9),i=r(61).f;n({target:"Object",stat:!0,forced:a((function(){return!Object.getOwnPropertyNames(1)}))},{getOwnPropertyNames:i})},function(e,t,r){var n=r(5),a=r(7).f,i=r(40),o=r(43),s=r(34),l=r(50),c=r(60);e.exports=function(e,t){var r,u,d,f,h,g=e.target,p=e.global,m=e.stat;if(r=p?n:m?n[g]||s(g,{}):(n[g]||{}).prototype)for(u in t){if(f=t[u],d=e.noTargetGet?(h=a(r,u))&&h.value:r[u],!c(p?u:g+(m?".":"#")+u,e.forced)&&d!==undefined){if(typeof f==typeof d)continue;l(f,d)}(e.sham||d&&d.sham)&&i(f,"sham",!0),o(r,u,f,e)}}},function(e,t,r){(function(t){var r=function(e){return e&&e.Math==Math&&e};e.exports=r("object"==typeof globalThis&&globalThis)||r("object"==typeof window&&window)||r("object"==typeof self&&self)||r("object"==typeof t&&t)||function(){return this}()||Function("return this")()}).call(this,r(6))},function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(n){"object"==typeof window&&(r=window)}e.exports=r},function(e,t,r){var n=r(8),a=r(10),i=r(11),o=r(12),s=r(16),l=r(35),c=r(38),u=Object.getOwnPropertyDescriptor;t.f=n?u:function(e,t){if(e=o(e),t=s(t),c)try{return u(e,t)}catch(r){}if(l(e,t))return i(!a.f.call(e,t),e[t])}},function(e,t,r){var n=r(9);e.exports=!n((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(e,t){e.exports=function(e){try{return!!e()}catch(t){return!0}}},function(e,t,r){"use strict";var n={}.propertyIsEnumerable,a=Object.getOwnPropertyDescriptor,i=a&&!n.call({1:2},1);t.f=i?function(e){var t=a(this,e);return!!t&&t.enumerable}:n},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,r){var n=r(13),a=r(15);e.exports=function(e){return n(a(e))}},function(e,t,r){var n=r(9),a=r(14),i="".split;e.exports=n((function(){return!Object("z").propertyIsEnumerable(0)}))?function(e){return"String"==a(e)?i.call(e,""):Object(e)}:Object},function(e,t){var r={}.toString;e.exports=function(e){return r.call(e).slice(8,-1)}},function(e,t){e.exports=function(e){if(e==undefined)throw TypeError("Can't call method on "+e);return e}},function(e,t,r){var n=r(17),a=r(20);e.exports=function(e){var t=n(e,"string");return a(t)?t:String(t)}},function(e,t,r){var n=r(18),a=r(20),i=r(26),o=r(29),s=r(30)("toPrimitive");e.exports=function(e,t){if(!n(e)||a(e))return e;var r,l=i(e,s);if(l){if(t===undefined&&(t="default"),r=l.call(e,t),!n(r)||a(r))return r;throw TypeError("Can't convert object to primitive value")}return t===undefined&&(t="number"),o(e,t)}},function(e,t,r){var n=r(19);e.exports=function(e){return"object"==typeof e?null!==e:n(e)}},function(e,t){e.exports=function(e){return"function"==typeof e}},function(e,t,r){var n=r(19),a=r(21),i=r(22);e.exports=i?function(e){return"symbol"==typeof e}:function(e){var t=a("Symbol");return n(t)&&Object(e)instanceof t}},function(e,t,r){var n=r(5),a=r(19),i=function(e){return a(e)?e:undefined};e.exports=function(e,t){return arguments.length<2?i(n[e]):n[e]&&n[e][t]}},function(e,t,r){var n=r(23);e.exports=n&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},function(e,t,r){var n=r(24),a=r(9);e.exports=!!Object.getOwnPropertySymbols&&!a((function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&n&&n<41}))},function(e,t,r){var n,a,i=r(5),o=r(25),s=i.process,l=i.Deno,c=s&&s.versions||l&&l.version,u=c&&c.v8;u?a=(n=u.split("."))[0]<4?1:n[0]+n[1]:o&&(!(n=o.match(/Edge\/(\d+)/))||n[1]>=74)&&(n=o.match(/Chrome\/(\d+)/))&&(a=n[1]),e.exports=a&&+a},function(e,t,r){var n=r(21);e.exports=n("navigator","userAgent")||""},function(e,t,r){var n=r(27);e.exports=function(e,t){var r=e[t];return null==r?undefined:n(r)}},function(e,t,r){var n=r(19),a=r(28);e.exports=function(e){if(n(e))return e;throw TypeError(a(e)+" is not a function")}},function(e,t){e.exports=function(e){try{return String(e)}catch(t){return"Object"}}},function(e,t,r){var n=r(19),a=r(18);e.exports=function(e,t){var r,i;if("string"===t&&n(r=e.toString)&&!a(i=r.call(e)))return i;if(n(r=e.valueOf)&&!a(i=r.call(e)))return i;if("string"!==t&&n(r=e.toString)&&!a(i=r.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t,r){var n=r(5),a=r(31),i=r(35),o=r(37),s=r(23),l=r(22),c=a("wks"),u=n.Symbol,d=l?u:u&&u.withoutSetter||o;e.exports=function(e){return i(c,e)&&(s||"string"==typeof c[e])||(s&&i(u,e)?c[e]=u[e]:c[e]=d("Symbol."+e)),c[e]}},function(e,t,r){var n=r(32),a=r(33);(e.exports=function(e,t){return a[e]||(a[e]=t!==undefined?t:{})})("versions",[]).push({version:"3.18.0",mode:n?"pure":"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"})},function(e,t){e.exports=!1},function(e,t,r){var n=r(5),a=r(34),i=n["__core-js_shared__"]||a("__core-js_shared__",{});e.exports=i},function(e,t,r){var n=r(5);e.exports=function(e,t){try{Object.defineProperty(n,e,{value:t,configurable:!0,writable:!0})}catch(r){n[e]=t}return t}},function(e,t,r){var n=r(36),a={}.hasOwnProperty;e.exports=Object.hasOwn||function(e,t){return a.call(n(e),t)}},function(e,t,r){var n=r(15);e.exports=function(e){return Object(n(e))}},function(e,t){var r=0,n=Math.random();e.exports=function(e){return"Symbol("+String(e===undefined?"":e)+")_"+(++r+n).toString(36)}},function(e,t,r){var n=r(8),a=r(9),i=r(39);e.exports=!n&&!a((function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},function(e,t,r){var n=r(5),a=r(18),i=n.document,o=a(i)&&a(i.createElement);e.exports=function(e){return o?i.createElement(e):{}}},function(e,t,r){var n=r(8),a=r(41),i=r(11);e.exports=n?function(e,t,r){return a.f(e,t,i(1,r))}:function(e,t,r){return e[t]=r,e}},function(e,t,r){var n=r(8),a=r(38),i=r(42),o=r(16),s=Object.defineProperty;t.f=n?s:function(e,t,r){if(i(e),t=o(t),i(r),a)try{return s(e,t,r)}catch(n){}if("get"in r||"set"in r)throw TypeError("Accessors not supported");return"value"in r&&(e[t]=r.value),e}},function(e,t,r){var n=r(18);e.exports=function(e){if(n(e))return e;throw TypeError(String(e)+" is not an object")}},function(e,t,r){var n=r(5),a=r(19),i=r(35),o=r(40),s=r(34),l=r(44),c=r(45),u=r(49).CONFIGURABLE,d=c.get,f=c.enforce,h=String(String).split("String");(e.exports=function(e,t,r,l){var c,d=!!l&&!!l.unsafe,g=!!l&&!!l.enumerable,p=!!l&&!!l.noTargetGet,m=l&&l.name!==undefined?l.name:t;a(r)&&("Symbol("===String(m).slice(0,7)&&(m="["+String(m).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!i(r,"name")||u&&r.name!==m)&&o(r,"name",m),(c=f(r)).source||(c.source=h.join("string"==typeof m?m:""))),e!==n?(d?!p&&e[t]&&(g=!0):delete e[t],g?e[t]=r:o(e,t,r)):g?e[t]=r:s(t,r)})(Function.prototype,"toString",(function(){return a(this)&&d(this).source||l(this)}))},function(e,t,r){var n=r(19),a=r(33),i=Function.toString;n(a.inspectSource)||(a.inspectSource=function(e){return i.call(e)}),e.exports=a.inspectSource},function(e,t,r){var n,a,i,o=r(46),s=r(5),l=r(18),c=r(40),u=r(35),d=r(33),f=r(47),h=r(48),g=s.WeakMap;if(o||d.state){var p=d.state||(d.state=new g),m=p.get,v=p.has,b=p.set;n=function(e,t){if(v.call(p,e))throw new TypeError("Object already initialized");return t.facade=e,b.call(p,e,t),t},a=function(e){return m.call(p,e)||{}},i=function(e){return v.call(p,e)}}else{var y=f("state");h[y]=!0,n=function(e,t){if(u(e,y))throw new TypeError("Object already initialized");return t.facade=e,c(e,y,t),t},a=function(e){return u(e,y)?e[y]:{}},i=function(e){return u(e,y)}}e.exports={set:n,get:a,has:i,enforce:function(e){return i(e)?a(e):n(e,{})},getterFor:function(e){return function(t){var r;if(!l(t)||(r=a(t)).type!==e)throw TypeError("Incompatible receiver, "+e+" required");return r}}}},function(e,t,r){var n=r(5),a=r(19),i=r(44),o=n.WeakMap;e.exports=a(o)&&/native code/.test(i(o))},function(e,t,r){var n=r(31),a=r(37),i=n("keys");e.exports=function(e){return i[e]||(i[e]=a(e))}},function(e,t){e.exports={}},function(e,t,r){var n=r(8),a=r(35),i=Function.prototype,o=n&&Object.getOwnPropertyDescriptor,s=a(i,"name"),l=s&&"something"===function(){}.name,c=s&&(!n||n&&o(i,"name").configurable);e.exports={EXISTS:s,PROPER:l,CONFIGURABLE:c}},function(e,t,r){var n=r(35),a=r(51),i=r(7),o=r(41);e.exports=function(e,t){for(var r=a(t),s=o.f,l=i.f,c=0;c<r.length;c++){var u=r[c];n(e,u)||s(e,u,l(t,u))}}},function(e,t,r){var n=r(21),a=r(52),i=r(59),o=r(42);e.exports=n("Reflect","ownKeys")||function(e){var t=a.f(o(e)),r=i.f;return r?t.concat(r(e)):t}},function(e,t,r){var n=r(53),a=r(58).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return n(e,a)}},function(e,t,r){var n=r(35),a=r(12),i=r(54).indexOf,o=r(48);e.exports=function(e,t){var r,s=a(e),l=0,c=[];for(r in s)!n(o,r)&&n(s,r)&&c.push(r);for(;t.length>l;)n(s,r=t[l++])&&(~i(c,r)||c.push(r));return c}},function(e,t,r){var n=r(12),a=r(55),i=r(57),o=function(e){return function(t,r,o){var s,l=n(t),c=a(l.length),u=i(o,c);if(e&&r!=r){for(;c>u;)if((s=l[u++])!=s)return!0}else for(;c>u;u++)if((e||u in l)&&l[u]===r)return e||u||0;return!e&&-1}};e.exports={includes:o(!0),indexOf:o(!1)}},function(e,t,r){var n=r(56),a=Math.min;e.exports=function(e){return e>0?a(n(e),9007199254740991):0}},function(e,t){var r=Math.ceil,n=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?n:r)(e)}},function(e,t,r){var n=r(56),a=Math.max,i=Math.min;e.exports=function(e,t){var r=n(e);return r<0?a(r+t,0):i(r,t)}},function(e,t){e.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,r){var n=r(9),a=r(19),i=/#|\.prototype\./,o=function(e,t){var r=l[s(e)];return r==u||r!=c&&(a(t)?n(t):!!t)},s=o.normalize=function(e){return String(e).replace(i,".").toLowerCase()},l=o.data={},c=o.NATIVE="N",u=o.POLYFILL="P";e.exports=o},function(e,t,r){var n=r(12),a=r(52).f,i={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];e.exports.f=function(e){return o&&"[object Window]"==i.call(e)?function(e){try{return a(e)}catch(t){return o.slice()}}(e):a(n(e))}},function(e,t,r){var n=r(5);e.exports=n},function(e,t,r){r(64);var n=r(62).Object,a=e.exports=function(e,t){return n.getOwnPropertyDescriptor(e,t)};n.getOwnPropertyDescriptor.sham&&(a.sham=!0)},function(e,t,r){var n=r(4),a=r(9),i=r(12),o=r(7).f,s=r(8),l=a((function(){o(1)}));n({target:"Object",stat:!0,forced:!s||l,sham:!s},{getOwnPropertyDescriptor:function(e,t){return o(i(e),t)}})},function(e,t,r){r(66);var n=r(62).Object,a=e.exports=function(e,t,r){return n.defineProperty(e,t,r)};n.defineProperty.sham&&(a.sham=!0)},function(e,t,r){var n=r(4),a=r(8);n({target:"Object",stat:!0,forced:!a,sham:!a},{defineProperty:r(41).f})},function(e,t,r){r(68);var n=r(62).Object;e.exports=function(e,t){return n.create(e,t)}},function(e,t,r){r(4)({target:"Object",stat:!0,sham:!r(8)},{create:r(69)})},function(e,t,r){var n,a=r(42),i=r(70),o=r(58),s=r(48),l=r(72),c=r(39),u=r(47),d=u("IE_PROTO"),f=function(){},h=function(e){return"<script>"+e+"<\/script>"},g=function(e){e.write(h("")),e.close();var t=e.parentWindow.Object;return e=null,t},p=function(){try{n=new ActiveXObject("htmlfile")}catch(a){}var e,t;p="undefined"!=typeof document?document.domain&&n?g(n):((t=c("iframe")).style.display="none",l.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(h("document.F=Object")),e.close(),e.F):g(n);for(var r=o.length;r--;)delete p.prototype[o[r]];return p()};s[d]=!0,e.exports=Object.create||function(e,t){var r;return null!==e?(f.prototype=a(e),r=new f,f.prototype=null,r[d]=e):r=p(),t===undefined?r:i(r,t)}},function(e,t,r){var n=r(8),a=r(41),i=r(42),o=r(71);e.exports=n?Object.defineProperties:function(e,t){i(e);for(var r,n=o(t),s=n.length,l=0;s>l;)a.f(e,r=n[l++],t[r]);return e}},function(e,t,r){var n=r(53),a=r(58);e.exports=Object.keys||function(e){return n(e,a)}},function(e,t,r){var n=r(21);e.exports=n("document","documentElement")},function(e,t,r){r(74);var n=r(62);e.exports=n.Object.keys},function(e,t,r){var n=r(4),a=r(36),i=r(71);n({target:"Object",stat:!0,forced:r(9)((function(){i(1)}))},{keys:function(e){return i(a(e))}})},function(e,t,r){r(76);var n=r(78);e.exports=n("Array","indexOf")},function(e,t,r){"use strict";var n=r(4),a=r(54).indexOf,i=r(77),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0,l=i("indexOf");n({target:"Array",proto:!0,forced:s||!l},{indexOf:function(e){return s?o.apply(this,arguments)||0:a(this,e,arguments.length>1?arguments[1]:undefined)}})},function(e,t,r){"use strict";var n=r(9);e.exports=function(e,t){var r=[][e];return!!r&&n((function(){r.call(null,t||function(){throw 1},1)}))}},function(e,t,r){var n=r(5),a=r(79),i=Function.call;e.exports=function(e,t,r){return a(i,n[e].prototype[t],r)}},function(e,t,r){var n=r(27);e.exports=function(e,t,r){if(n(e),t===undefined)return e;switch(r){case 0:return function(){return e.call(t)};case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,a){return e.call(t,r,n,a)}}return function(){return e.apply(t,arguments)}}},function(e,t,r){r(81);var n=r(78);e.exports=n("Array","forEach")},function(e,t,r){"use strict";var n=r(4),a=r(82);n({target:"Array",proto:!0,forced:[].forEach!=a},{forEach:a})},function(e,t,r){"use strict";var n=r(83).forEach,a=r(77)("forEach");e.exports=a?[].forEach:function(e){return n(this,e,arguments.length>1?arguments[1]:undefined)}},function(e,t,r){var n=r(79),a=r(13),i=r(36),o=r(55),s=r(84),l=[].push,c=function(e){var t=1==e,r=2==e,c=3==e,u=4==e,d=6==e,f=7==e,h=5==e||d;return function(g,p,m,v){for(var b,y,x=i(g),w=a(x),C=n(p,m,3),k=o(w.length),_=0,S=v||s,E=t?S(g,k):r||f?S(g,0):undefined;k>_;_++)if((h||_ in w)&&(y=C(b=w[_],_,x),e))if(t)E[_]=y;else if(y)switch(e){case 3:return!0;case 5:return b;case 6:return _;case 2:l.call(E,b)}else switch(e){case 4:return!1;case 7:l.call(E,b)}return d?-1:c||u?u:E}};e.exports={forEach:c(0),map:c(1),filter:c(2),some:c(3),every:c(4),find:c(5),findIndex:c(6),filterReject:c(7)}},function(e,t,r){var n=r(85);e.exports=function(e,t){return new(n(e))(0===t?0:t)}},function(e,t,r){var n=r(86),a=r(87),i=r(18),o=r(30)("species");e.exports=function(e){var t;return n(e)&&(t=e.constructor,(a(t)&&(t===Array||n(t.prototype))||i(t)&&null===(t=t[o]))&&(t=undefined)),t===undefined?Array:t}},function(e,t,r){var n=r(14);e.exports=Array.isArray||function(e){return"Array"==n(e)}},function(e,t,r){var n=r(9),a=r(19),i=r(88),o=r(21),s=r(44),l=[],c=o("Reflect","construct"),u=/^\s*(?:class|function)\b/,d=u.exec,f=!u.exec((function(){})),h=function(e){if(!a(e))return!1;try{return c(Object,l,e),!0}catch(t){return!1}};e.exports=!c||n((function(){var e;return h(h.call)||!h(Object)||!h((function(){e=!0}))||e}))?function(e){if(!a(e))return!1;switch(i(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}return f||!!d.call(u,s(e))}:h},function(e,t,r){var n=r(89),a=r(19),i=r(14),o=r(30)("toStringTag"),s="Arguments"==i(function(){return arguments}());e.exports=n?i:function(e){var t,r,n;return e===undefined?"Undefined":null===e?"Null":"string"==typeof(r=function(e,t){try{return e[t]}catch(r){}}(t=Object(e),o))?r:s?i(t):"Object"==(n=i(t))&&a(t.callee)?"Arguments":n}},function(e,t,r){var n={};n[r(30)("toStringTag")]="z",e.exports="[object z]"===String(n)},function(e,t,r){r(91);var n=r(78);e.exports=n("Array","map")},function(e,t,r){"use strict";var n=r(4),a=r(83).map;n({target:"Array",proto:!0,forced:!r(92)("map")},{map:function(e){return a(this,e,arguments.length>1?arguments[1]:undefined)}})},function(e,t,r){var n=r(9),a=r(30),i=r(24),o=a("species");e.exports=function(e){return i>=51||!n((function(){var t=[];return(t.constructor={})[o]=function(){return{foo:1}},1!==t[e](Boolean).foo}))}},function(e,t,r){r(94);var n=r(78);e.exports=n("Array","filter")},function(e,t,r){"use strict";var n=r(4),a=r(83).filter;n({target:"Array",proto:!0,forced:!r(92)("filter")},{filter:function(e){return a(this,e,arguments.length>1?arguments[1]:undefined)}})},function(e,t,r){r(96);var n=r(78);e.exports=n("Array","reduce")},function(e,t,r){"use strict";var n=r(4),a=r(97).left,i=r(77),o=r(24),s=r(98);n({target:"Array",proto:!0,forced:!i("reduce")||!s&&o>79&&o<83},{reduce:function(e){return a(this,e,arguments.length,arguments.length>1?arguments[1]:undefined)}})},function(e,t,r){var n=r(27),a=r(36),i=r(13),o=r(55),s=function(e){return function(t,r,s,l){n(r);var c=a(t),u=i(c),d=o(c.length),f=e?d-1:0,h=e?-1:1;if(s<2)for(;;){if(f in u){l=u[f],f+=h;break}if(f+=h,e?f<0:d<=f)throw TypeError("Reduce of empty array with no initial value")}for(;e?f>=0:d>f;f+=h)f in u&&(l=r(l,u[f],f,c));return l}};e.exports={left:s(!1),right:s(!0)}},function(e,t,r){var n=r(14),a=r(5);e.exports="process"==n(a.process)},function(e,t,r){r(100);var n=r(62);e.exports=n.Array.isArray},function(e,t,r){r(4)({target:"Array",stat:!0},{isArray:r(86)})},function(e,t,r){r(102);var n=r(78);e.exports=n("Array","some")},function(e,t,r){"use strict";var n=r(4),a=r(83).some;n({target:"Array",proto:!0,forced:!r(77)("some")},{some:function(e){return a(this,e,arguments.length>1?arguments[1]:undefined)}})},function(e,t,r){r(104);var n=r(78);e.exports=n("String","trim")},function(e,t,r){"use strict";var n=r(4),a=r(105).trim;n({target:"String",proto:!0,forced:r(108)("trim")},{trim:function(){return a(this)}})},function(e,t,r){var n=r(15),a=r(106),i="["+r(107)+"]",o=RegExp("^"+i+i+"*"),s=RegExp(i+i+"*$"),l=function(e){return function(t){var r=a(n(t));return 1&e&&(r=r.replace(o,"")),2&e&&(r=r.replace(s,"")),r}};e.exports={start:l(1),end:l(2),trim:l(3)}},function(e,t,r){var n=r(88);e.exports=function(e){if("Symbol"===n(e))throw TypeError("Cannot convert a Symbol value to a string");return String(e)}},function(e,t){e.exports="\t\n\x0B\f\r                　\u2028\u2029\ufeff"},function(e,t,r){var n=r(49).PROPER,a=r(9),i=r(107);e.exports=function(e){return a((function(){return!!i[e]()||"​᠎"!=="​᠎"[e]()||n&&i[e].name!==e}))}},function(e,t,r){r(110),r(112),r(114),r(118),r(119),r(120),r(121),r(122),r(123),r(124),r(125),r(126),r(127),r(128),r(129),r(130),r(131),r(132),r(133),r(134);var n=r(62);e.exports=n.Symbol},function(e,t,r){"use strict";var n=r(4),a=r(9),i=r(86),o=r(18),s=r(36),l=r(55),c=r(111),u=r(84),d=r(92),f=r(30),h=r(24),g=f("isConcatSpreadable"),p=h>=51||!a((function(){var e=[];return e[g]=!1,e.concat()[0]!==e})),m=d("concat"),v=function(e){if(!o(e))return!1;var t=e[g];return t!==undefined?!!t:i(e)};n({target:"Array",proto:!0,forced:!p||!m},{concat:function(e){var t,r,n,a,i,o=s(this),d=u(o,0),f=0;for(t=-1,n=arguments.length;t<n;t++)if(v(i=-1===t?o:arguments[t])){if(f+(a=l(i.length))>9007199254740991)throw TypeError("Maximum allowed index exceeded");for(r=0;r<a;r++,f++)r in i&&c(d,f,i[r])}else{if(f>=9007199254740991)throw TypeError("Maximum allowed index exceeded");c(d,f++,i)}return d.length=f,d}})},function(e,t,r){"use strict";var n=r(16),a=r(41),i=r(11);e.exports=function(e,t,r){var o=n(t);o in e?a.f(e,o,i(0,r)):e[o]=r}},function(e,t,r){var n=r(89),a=r(43),i=r(113);n||a(Object.prototype,"toString",i,{unsafe:!0})},function(e,t,r){"use strict";var n=r(89),a=r(88);e.exports=n?{}.toString:function(){return"[object "+a(this)+"]"}},function(e,t,r){"use strict";var n=r(4),a=r(5),i=r(21),o=r(32),s=r(8),l=r(23),c=r(9),u=r(35),d=r(86),f=r(19),h=r(18),g=r(20),p=r(42),m=r(36),v=r(12),b=r(16),y=r(106),x=r(11),w=r(69),C=r(71),k=r(52),_=r(61),S=r(59),E=r(7),A=r(41),N=r(10),T=r(43),M=r(31),D=r(47),F=r(48),I=r(37),O=r(30),L=r(115),R=r(116),P=r(117),V=r(45),j=r(83).forEach,B=D("hidden"),z=O("toPrimitive"),H=V.set,U=V.getterFor("Symbol"),G=Object.prototype,W=a.Symbol,$=i("JSON","stringify"),X=E.f,Y=A.f,q=_.f,K=N.f,J=M("symbols"),Z=M("op-symbols"),Q=M("string-to-symbol-registry"),ee=M("symbol-to-string-registry"),te=M("wks"),re=a.QObject,ne=!re||!re.prototype||!re.prototype.findChild,ae=s&&c((function(){return 7!=w(Y({},"a",{get:function(){return Y(this,"a",{value:7}).a}})).a}))?function(e,t,r){var n=X(G,t);n&&delete G[t],Y(e,t,r),n&&e!==G&&Y(G,t,n)}:Y,ie=function(e,t){var r=J[e]=w(W.prototype);return H(r,{type:"Symbol",tag:e,description:t}),s||(r.description=t),r},oe=function(e,t,r){e===G&&oe(Z,t,r),p(e);var n=b(t);return p(r),u(J,n)?(r.enumerable?(u(e,B)&&e[B][n]&&(e[B][n]=!1),r=w(r,{enumerable:x(0,!1)})):(u(e,B)||Y(e,B,x(1,{})),e[B][n]=!0),ae(e,n,r)):Y(e,n,r)},se=function(e,t){p(e);var r=v(t),n=C(r).concat(de(r));return j(n,(function(t){s&&!le.call(r,t)||oe(e,t,r[t])})),e},le=function(e){var t=b(e),r=K.call(this,t);return!(this===G&&u(J,t)&&!u(Z,t))&&(!(r||!u(this,t)||!u(J,t)||u(this,B)&&this[B][t])||r)},ce=function(e,t){var r=v(e),n=b(t);if(r!==G||!u(J,n)||u(Z,n)){var a=X(r,n);return!a||!u(J,n)||u(r,B)&&r[B][n]||(a.enumerable=!0),a}},ue=function(e){var t=q(v(e)),r=[];return j(t,(function(e){u(J,e)||u(F,e)||r.push(e)})),r},de=function(e){var t=e===G,r=q(t?Z:v(e)),n=[];return j(r,(function(e){!u(J,e)||t&&!u(G,e)||n.push(J[e])})),n};(l||(T((W=function(){if(this instanceof W)throw TypeError("Symbol is not a constructor");var e=arguments.length&&arguments[0]!==undefined?y(arguments[0]):undefined,t=I(e),r=function n(e){this===G&&n.call(Z,e),u(this,B)&&u(this[B],t)&&(this[B][t]=!1),ae(this,t,x(1,e))};return s&&ne&&ae(G,t,{configurable:!0,set:r}),ie(t,e)}).prototype,"toString",(function(){return U(this).tag})),T(W,"withoutSetter",(function(e){return ie(I(e),e)})),N.f=le,A.f=oe,E.f=ce,k.f=_.f=ue,S.f=de,L.f=function(e){return ie(O(e),e)},s&&(Y(W.prototype,"description",{configurable:!0,get:function(){return U(this).description}}),o||T(G,"propertyIsEnumerable",le,{unsafe:!0}))),n({global:!0,wrap:!0,forced:!l,sham:!l},{Symbol:W}),j(C(te),(function(e){R(e)})),n({target:"Symbol",stat:!0,forced:!l},{"for":function(e){var t=y(e);if(u(Q,t))return Q[t];var r=W(t);return Q[t]=r,ee[r]=t,r},keyFor:function(e){if(!g(e))throw TypeError(e+" is not a symbol");if(u(ee,e))return ee[e]},useSetter:function(){ne=!0},useSimple:function(){ne=!1}}),n({target:"Object",stat:!0,forced:!l,sham:!s},{create:function(e,t){return t===undefined?w(e):se(w(e),t)},defineProperty:oe,defineProperties:se,getOwnPropertyDescriptor:ce}),n({target:"Object",stat:!0,forced:!l},{getOwnPropertyNames:ue,getOwnPropertySymbols:de}),n({target:"Object",stat:!0,forced:c((function(){S.f(1)}))},{getOwnPropertySymbols:function(e){return S.f(m(e))}}),$)&&n({target:"JSON",stat:!0,forced:!l||c((function(){var e=W();return"[null]"!=$([e])||"{}"!=$({a:e})||"{}"!=$(Object(e))}))},{stringify:function(e,t,r){for(var n,a=[e],i=1;arguments.length>i;)a.push(arguments[i++]);if(n=t,(h(t)||e!==undefined)&&!g(e))return d(t)||(t=function(e,t){if(f(n)&&(t=n.call(this,e,t)),!g(t))return t}),a[1]=t,$.apply(null,a)}});if(!W.prototype[z]){var fe=W.prototype.valueOf;T(W.prototype,z,(function(){return fe.apply(this,arguments)}))}P(W,"Symbol"),F[B]=!0},function(e,t,r){var n=r(30);t.f=n},function(e,t,r){var n=r(62),a=r(35),i=r(115),o=r(41).f;e.exports=function(e){var t=n.Symbol||(n.Symbol={});a(t,e)||o(t,e,{value:i.f(e)})}},function(e,t,r){var n=r(41).f,a=r(35),i=r(30)("toStringTag");e.exports=function(e,t,r){e&&!a(e=r?e:e.prototype,i)&&n(e,i,{configurable:!0,value:t})}},function(e,t,r){r(116)("asyncIterator")},function(e,t,r){"use strict";var n=r(4),a=r(8),i=r(5),o=r(35),s=r(19),l=r(18),c=r(41).f,u=r(50),d=i.Symbol;if(a&&s(d)&&(!("description"in d.prototype)||d().description!==undefined)){var f={},h=function(){var e=arguments.length<1||arguments[0]===undefined?undefined:String(arguments[0]),t=this instanceof h?new d(e):e===undefined?d():d(e);return""===e&&(f[t]=!0),t};u(h,d);var g=h.prototype=d.prototype;g.constructor=h;var p=g.toString,m="Symbol(test)"==String(d("test")),v=/^Symbol\((.*)\)[^)]+$/;c(g,"description",{configurable:!0,get:function(){var e=l(this)?this.valueOf():this,t=p.call(e);if(o(f,e))return"";var r=m?t.slice(7,-1):t.replace(v,"$1");return""===r?undefined:r}}),n({global:!0,forced:!0},{Symbol:h})}},function(e,t,r){r(116)("hasInstance")},function(e,t,r){r(116)("isConcatSpreadable")},function(e,t,r){r(116)("iterator")},function(e,t,r){r(116)("match")},function(e,t,r){r(116)("matchAll")},function(e,t,r){r(116)("replace")},function(e,t,r){r(116)("search")},function(e,t,r){r(116)("species")},function(e,t,r){r(116)("split")},function(e,t,r){r(116)("toPrimitive")},function(e,t,r){r(116)("toStringTag")},function(e,t,r){r(116)("unscopables")},function(e,t,r){var n=r(5);r(117)(n.JSON,"JSON",!0)},function(e,t,r){r(117)(Math,"Math",!0)},function(e,t,r){var n=r(4),a=r(5),i=r(117);n({global:!0},{Reflect:{}}),i(a.Reflect,"Reflect",!0)},function(e,t){window.MutationObserver||(window.MutationObserver=function(e){function t(e){this.i=[],this.m=e}function r(t){var r,n={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null};for(r in t)n[r]!==e&&t[r]!==e&&(n[r]=t[r]);return n}function n(t,n){var s=i(t,n);return function(c){var u=c.length;if(n.a&&3===t.nodeType&&t.nodeValue!==s.a&&c.push(new r({type:"characterData",target:t,oldValue:s.a})),n.b&&s.b&&a(c,t,s.b,n.f),n.c||n.g)var d=function(t,n,i,s){function c(e,n,i,o,l){var c,d,f,h=e.length-1;for(l=-~((h-l)/2);f=e.pop();)c=i[f.j],d=o[f.l],s.c&&l&&Math.abs(f.j-f.l)>=h&&(t.push(r({type:"childList",target:n,addedNodes:[c],removedNodes:[c],nextSibling:c.nextSibling,previousSibling:c.previousSibling})),l--),s.b&&d.b&&a(t,c,d.b,s.f),s.a&&3===c.nodeType&&c.nodeValue!==d.a&&t.push(r({type:"characterData",target:c,oldValue:d.a})),s.g&&u(c,d)}function u(n,i){for(var f,h,g,p,m,v=n.childNodes,b=i.c,y=v.length,x=b?b.length:0,w=0,C=0,k=0;C<y||k<x;)(p=v[C])===(m=(g=b[k])&&g.node)?(s.b&&g.b&&a(t,p,g.b,s.f),s.a&&g.a!==e&&p.nodeValue!==g.a&&t.push(r({type:"characterData",target:p,oldValue:g.a})),h&&c(h,n,v,b,w),s.g&&(p.childNodes.length||g.c&&g.c.length)&&u(p,g),C++,k++):(d=!0,f||(f={},h=[]),p&&(f[g=o(p)]||(f[g]=!0,-1===(g=l(b,p,k,"node"))?s.c&&(t.push(r({type:"childList",target:n,addedNodes:[p],nextSibling:p.nextSibling,previousSibling:p.previousSibling})),w++):h.push({j:C,l:g})),C++),m&&m!==v[C]&&(f[g=o(m)]||(f[g]=!0,-1===(g=l(v,m,C))?s.c&&(t.push(r({type:"childList",target:i.node,removedNodes:[m],nextSibling:b[k+1],previousSibling:b[k-1]})),w--):h.push({j:g,l:k})),k++));h&&c(h,n,v,b,w)}var d;return u(n,i),d}(c,t,s,n);(d||c.length!==u)&&(s=i(t,n))}}function a(t,n,a,i){for(var o,s,l={},c=n.attributes,d=c.length;d--;)s=(o=c[d]).name,i&&i[s]===e||(u(n,o)!==a[s]&&t.push(r({type:"attributes",target:n,attributeName:s,oldValue:a[s],attributeNamespace:o.namespaceURI})),l[s]=!0);for(s in a)l[s]||t.push(r({target:n,type:"attributes",attributeName:s,oldValue:a[s]}))}function i(e,t){var r=!0;return function n(e){var a={node:e};return!t.a||3!==e.nodeType&&8!==e.nodeType?(t.b&&r&&1===e.nodeType&&(a.b=s(e.attributes,(function(r,n){return t.f&&!t.f[n.name]||(r[n.name]=u(e,n)),r}),{})),r&&(t.c||t.a||t.b&&t.g)&&(a.c=function(e,t){for(var r=[],n=0;n<e.length;n++)r[n]=t(e[n],n,e);return r}(e.childNodes,n)),r=t.g):a.a=e.nodeValue,a}(e)}function o(e){try{return e.id||(e.mo_id=e.mo_id||d++)}catch(t){try{return e.nodeValue}catch(r){return d++}}}function s(e,t,r){for(var n=0;n<e.length;n++)r=t(r,e[n],n,e);return r}function l(e,t,r,n){for(;r<e.length;r++)if((n?e[r][n]:e[r])===t)return r;return-1}t._period=30,t.prototype={observe:function(e,r){for(var a={b:!!(r.attributes||r.attributeFilter||r.attributeOldValue),c:!!r.childList,g:!!r.subtree,a:!(!r.characterData&&!r.characterDataOldValue)},i=this.i,o=0;o<i.length;o++)i[o].s===e&&i.splice(o,1);r.attributeFilter&&(a.f=s(r.attributeFilter,(function(e,t){return e[t]=!0,e}),{})),i.push({s:e,o:n(e,a)}),this.h||function(e){!function r(){var n=e.takeRecords();n.length&&e.m(n,e),e.h=setTimeout(r,t._period)}()}(this)},takeRecords:function(){for(var e=[],t=this.i,r=0;r<t.length;r++)t[r].o(e);return e},disconnect:function(){this.i=[],clearTimeout(this.h),this.h=null}};var c=document.createElement("i");c.style.top=0;var u=(c="null"!=c.attributes.style.value)?function(e,t){return t.value}:function(e,t){return"style"!==t.name?t.value:e.style.cssText},d=1;return t}(void 0))},function(e,t,r){"use strict";r(137),r(140),r(157),r(159),r(162),r(164),r(166),r(173),r(176),r(178),r(180),r(183),r(186),r(188),r(190),r(193),r(195),r(205),r(207),r(211),Element.prototype.remove||(Element.prototype.remove=function(){this.parentNode&&this.parentNode.removeChild(this)})},function(e,t,r){r(138);var n=r(62);e.exports=n.Object.entries},function(e,t,r){var n=r(4),a=r(139).entries;n({target:"Object",stat:!0},{entries:function(e){return a(e)}})},function(e,t,r){var n=r(8),a=r(71),i=r(12),o=r(10).f,s=function(e){return function(t){for(var r,s=i(t),l=a(s),c=l.length,u=0,d=[];c>u;)r=l[u++],n&&!o.call(s,r)||d.push(e?[r,s[r]]:s[r]);return d}};e.exports={entries:s(!0),values:s(!1)}},function(e,t,r){r(141),r(151);var n=r(62);e.exports=n.Object.fromEntries},function(e,t,r){"use strict";var n=r(12),a=r(142),i=r(143),o=r(45),s=r(144),l=o.set,c=o.getterFor("Array Iterator");e.exports=s(Array,"Array",(function(e,t){l(this,{type:"Array Iterator",target:n(e),index:0,kind:t})}),(function(){var e=c(this),t=e.target,r=e.kind,n=e.index++;return!t||n>=t.length?(e.target=undefined,{value:undefined,done:!0}):"keys"==r?{value:n,done:!1}:"values"==r?{value:t[n],done:!1}:{value:[n,t[n]],done:!1}}),"values"),i.Arguments=i.Array,a("keys"),a("values"),a("entries")},function(e,t,r){var n=r(30),a=r(69),i=r(41),o=n("unscopables"),s=Array.prototype;s[o]==undefined&&i.f(s,o,{configurable:!0,value:a(null)}),e.exports=function(e){s[o][e]=!0}},function(e,t){e.exports={}},function(e,t,r){"use strict";var n=r(4),a=r(32),i=r(49),o=r(19),s=r(145),l=r(147),c=r(149),u=r(117),d=r(40),f=r(43),h=r(30),g=r(143),p=r(146),m=i.PROPER,v=i.CONFIGURABLE,b=p.IteratorPrototype,y=p.BUGGY_SAFARI_ITERATORS,x=h("iterator"),w=function(){return this};e.exports=function(e,t,r,i,h,p,C){s(r,t,i);var k,_,S,E=function(e){if(e===h&&D)return D;if(!y&&e in T)return T[e];switch(e){case"keys":case"values":case"entries":return function(){return new r(this,e)}}return function(){return new r(this)}},A=t+" Iterator",N=!1,T=e.prototype,M=T[x]||T["@@iterator"]||h&&T[h],D=!y&&M||E(h),F="Array"==t&&T.entries||M;if(F&&(k=l(F.call(new e)))!==Object.prototype&&k.next&&(a||l(k)===b||(c?c(k,b):o(k[x])||f(k,x,w)),u(k,A,!0,!0),a&&(g[A]=w)),m&&"values"==h&&M&&"values"!==M.name&&(!a&&v?d(T,"name","values"):(N=!0,D=function(){return M.call(this)})),h)if(_={values:E("values"),keys:p?D:E("keys"),entries:E("entries")},C)for(S in _)(y||N||!(S in T))&&f(T,S,_[S]);else n({target:t,proto:!0,forced:y||N},_);return a&&!C||T[x]===D||f(T,x,D,{name:h}),g[t]=D,_}},function(e,t,r){"use strict";var n=r(146).IteratorPrototype,a=r(69),i=r(11),o=r(117),s=r(143),l=function(){return this};e.exports=function(e,t,r){var c=t+" Iterator";return e.prototype=a(n,{next:i(1,r)}),o(e,c,!1,!0),s[c]=l,e}},function(e,t,r){"use strict";var n,a,i,o=r(9),s=r(19),l=r(69),c=r(147),u=r(43),d=r(30),f=r(32),h=d("iterator"),g=!1;[].keys&&("next"in(i=[].keys())?(a=c(c(i)))!==Object.prototype&&(n=a):g=!0),n==undefined||o((function(){var e={};return n[h].call(e)!==e}))?n={}:f&&(n=l(n)),s(n[h])||u(n,h,(function(){return this})),e.exports={IteratorPrototype:n,BUGGY_SAFARI_ITERATORS:g}},function(e,t,r){var n=r(35),a=r(19),i=r(36),o=r(47),s=r(148),l=o("IE_PROTO"),c=Object.prototype;e.exports=s?Object.getPrototypeOf:function(e){var t=i(e);if(n(t,l))return t[l];var r=t.constructor;return a(r)&&t instanceof r?r.prototype:t instanceof Object?c:null}},function(e,t,r){var n=r(9);e.exports=!n((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype}))},function(e,t,r){var n=r(42),a=r(150);e.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,r={};try{(e=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(r,[]),t=r instanceof Array}catch(i){}return function(r,i){return n(r),a(i),t?e.call(r,i):r.__proto__=i,r}}():undefined)},function(e,t,r){var n=r(19);e.exports=function(e){if("object"==typeof e||n(e))return e;throw TypeError("Can't set "+String(e)+" as a prototype")}},function(e,t,r){var n=r(4),a=r(152),i=r(111);n({target:"Object",stat:!0},{fromEntries:function(e){var t={};return a(e,(function(e,r){i(t,e,r)}),{AS_ENTRIES:!0}),t}})},function(e,t,r){var n=r(42),a=r(153),i=r(55),o=r(79),s=r(154),l=r(155),c=r(156),u=function(e,t){this.stopped=e,this.result=t};e.exports=function(e,t,r){var d,f,h,g,p,m,v,b=r&&r.that,y=!(!r||!r.AS_ENTRIES),x=!(!r||!r.IS_ITERATOR),w=!(!r||!r.INTERRUPTED),C=o(t,b,1+y+w),k=function(e){return d&&c(d,"normal",e),new u(!0,e)},_=function(e){return y?(n(e),w?C(e[0],e[1],k):C(e[0],e[1])):w?C(e,k):C(e)};if(x)d=e;else{if(!(f=l(e)))throw TypeError(String(e)+" is not iterable");if(a(f)){for(h=0,g=i(e.length);g>h;h++)if((p=_(e[h]))&&p instanceof u)return p;return new u(!1)}d=s(e,f)}for(m=d.next;!(v=m.call(d)).done;){try{p=_(v.value)}catch(S){c(d,"throw",S)}if("object"==typeof p&&p&&p instanceof u)return p}return new u(!1)}},function(e,t,r){var n=r(30),a=r(143),i=n("iterator"),o=Array.prototype;e.exports=function(e){return e!==undefined&&(a.Array===e||o[i]===e)}},function(e,t,r){var n=r(27),a=r(42),i=r(155);e.exports=function(e,t){var r=arguments.length<2?i(e):t;if(n(r))return a(r.call(e));throw TypeError(String(e)+" is not iterable")}},function(e,t,r){var n=r(88),a=r(26),i=r(143),o=r(30)("iterator");e.exports=function(e){if(e!=undefined)return a(e,o)||a(e,"@@iterator")||i[n(e)]}},function(e,t,r){var n=r(42),a=r(26);e.exports=function(e,t,r){var i,o;n(e);try{if(!(i=a(e,"return"))){if("throw"===t)throw r;return r}i=i.call(e)}catch(s){o=!0,i=s}if("throw"===t)throw r;if(o)throw i;return n(i),r}},function(e,t,r){r(158);var n=r(62);e.exports=n.Object.values},function(e,t,r){var n=r(4),a=r(139).values;n({target:"Object",stat:!0},{values:function(e){return a(e)}})},function(e,t,r){r(160);var n=r(62);e.exports=n.Math.sign},function(e,t,r){r(4)({target:"Math",stat:!0},{sign:r(161)})},function(e,t){e.exports=Math.sign||function(e){return 0==(e=+e)||e!=e?e:e<0?-1:1}},function(e,t,r){r(163);var n=r(78);e.exports=n("Array","findIndex")},function(e,t,r){"use strict";var n=r(4),a=r(83).findIndex,i=r(142),o=!0;"findIndex"in[]&&Array(1).findIndex((function(){o=!1})),n({target:"Array",proto:!0,forced:o},{findIndex:function(e){return a(this,e,arguments.length>1?arguments[1]:undefined)}}),i("findIndex")},function(e,t,r){r(165);var n=r(78);e.exports=n("Array","find")},function(e,t,r){"use strict";var n=r(4),a=r(83).find,i=r(142),o=!0;"find"in[]&&Array(1).find((function(){o=!1})),n({target:"Array",proto:!0,forced:o},{find:function(e){return a(this,e,arguments.length>1?arguments[1]:undefined)}}),i("find")},function(e,t,r){r(167),r(169);var n=r(62);e.exports=n.Array.from},function(e,t,r){"use strict";var n=r(168).charAt,a=r(106),i=r(45),o=r(144),s=i.set,l=i.getterFor("String Iterator");o(String,"String",(function(e){s(this,{type:"String Iterator",string:a(e),index:0})}),(function(){var e,t=l(this),r=t.string,a=t.index;return a>=r.length?{value:undefined,done:!0}:(e=n(r,a),t.index+=e.length,{value:e,done:!1})}))},function(e,t,r){var n=r(56),a=r(106),i=r(15),o=function(e){return function(t,r){var o,s,l=a(i(t)),c=n(r),u=l.length;return c<0||c>=u?e?"":undefined:(o=l.charCodeAt(c))<55296||o>56319||c+1===u||(s=l.charCodeAt(c+1))<56320||s>57343?e?l.charAt(c):o:e?l.slice(c,c+2):s-56320+(o-55296<<10)+65536}};e.exports={codeAt:o(!1),charAt:o(!0)}},function(e,t,r){var n=r(4),a=r(170);n({target:"Array",stat:!0,forced:!r(172)((function(e){Array.from(e)}))},{from:a})},function(e,t,r){"use strict";var n=r(79),a=r(36),i=r(171),o=r(153),s=r(87),l=r(55),c=r(111),u=r(154),d=r(155);e.exports=function(e){var t=a(e),r=s(this),f=arguments.length,h=f>1?arguments[1]:undefined,g=h!==undefined;g&&(h=n(h,f>2?arguments[2]:undefined,2));var p,m,v,b,y,x,w=d(t),C=0;if(!w||this==Array&&o(w))for(p=l(t.length),m=r?new this(p):Array(p);p>C;C++)x=g?h(t[C],C):t[C],c(m,C,x);else for(y=(b=u(t,w)).next,m=r?new this:[];!(v=y.call(b)).done;C++)x=g?i(b,h,[v.value,C],!0):v.value,c(m,C,x);return m.length=C,m}},function(e,t,r){var n=r(42),a=r(156);e.exports=function(e,t,r,i){try{return i?t(n(r)[0],r[1]):t(r)}catch(o){a(e,"throw",o)}}},function(e,t,r){var n=r(30)("iterator"),a=!1;try{var i=0,o={next:function(){return{done:!!i++}},"return":function(){a=!0}};o[n]=function(){return this},Array.from(o,(function(){throw 2}))}catch(s){}e.exports=function(e,t){if(!t&&!a)return!1;var r=!1;try{var i={};i[n]=function(){return{next:function(){return{done:r=!0}}}},e(i)}catch(s){}return r}},function(e,t,r){r(174);var n=r(78);e.exports=n("Array","fill")},function(e,t,r){var n=r(4),a=r(175),i=r(142);n({target:"Array",proto:!0},{fill:a}),i("fill")},function(e,t,r){"use strict";var n=r(36),a=r(57),i=r(55);e.exports=function(e){for(var t=n(this),r=i(t.length),o=arguments.length,s=a(o>1?arguments[1]:undefined,r),l=o>2?arguments[2]:undefined,c=l===undefined?r:a(l,r);c>s;)t[s++]=e;return t}},function(e,t,r){r(177);var n=r(78);e.exports=n("Array","includes")},function(e,t,r){"use strict";var n=r(4),a=r(54).includes,i=r(142);n({target:"Array",proto:!0},{includes:function(e){return a(this,e,arguments.length>1?arguments[1]:undefined)}}),i("includes")},function(e,t,r){r(179),e.exports=Math.pow(2,-52)},function(e,t,r){r(4)({target:"Number",stat:!0},{EPSILON:Math.pow(2,-52)})},function(e,t,r){r(181);var n=r(62);e.exports=n.Number.parseFloat},function(e,t,r){var n=r(4),a=r(182);n({target:"Number",stat:!0,forced:Number.parseFloat!=a},{parseFloat:a})},function(e,t,r){var n=r(5),a=r(9),i=r(106),o=r(105).trim,s=r(107),l=n.parseFloat,c=n.Symbol,u=c&&c.iterator,d=1/l(s+"-0")!=-Infinity||u&&!a((function(){l(Object(u))}));e.exports=d?function(e){var t=o(i(e)),r=l(t);return 0===r&&"-"==t.charAt(0)?-0:r}:l},function(e,t,r){r(184);var n=r(62);e.exports=n.Number.parseInt},function(e,t,r){var n=r(4),a=r(185);n({target:"Number",stat:!0,forced:Number.parseInt!=a},{parseInt:a})},function(e,t,r){var n=r(5),a=r(9),i=r(106),o=r(105).trim,s=r(107),l=n.parseInt,c=n.Symbol,u=c&&c.iterator,d=/^[+-]?0[Xx]/,f=8!==l(s+"08")||22!==l(s+"0x16")||u&&!a((function(){l(Object(u))}));e.exports=f?function(e,t){var r=o(i(e));return l(r,t>>>0||(d.test(r)?16:10))}:l},function(e,t,r){r(187),e.exports=-9007199254740991},function(e,t,r){r(4)({target:"Number",stat:!0},{MIN_SAFE_INTEGER:-9007199254740991})},function(e,t,r){r(189),e.exports=9007199254740991},function(e,t,r){r(4)({target:"Number",stat:!0},{MAX_SAFE_INTEGER:9007199254740991})},function(e,t,r){r(191);var n=r(62);e.exports=n.Number.isFinite},function(e,t,r){r(4)({target:"Number",stat:!0},{isFinite:r(192)})},function(e,t,r){var n=r(5).isFinite;e.exports=Number.isFinite||function(e){return"number"==typeof e&&n(e)}},function(e,t,r){r(194);var n=r(62);e.exports=n.Number.isNaN},function(e,t,r){r(4)({target:"Number",stat:!0},{isNaN:function(e){return e!=e}})},function(e,t,r){r(141),r(112),r(196),r(167);var n=r(62);e.exports=n.Set},function(e,t,r){"use strict";var n=r(197),a=r(202);e.exports=n("Set",(function(e){return function(){return e(this,arguments.length?arguments[0]:undefined)}}),a)},function(e,t,r){"use strict";var n=r(4),a=r(5),i=r(60),o=r(43),s=r(198),l=r(152),c=r(200),u=r(19),d=r(18),f=r(9),h=r(172),g=r(117),p=r(201);e.exports=function(e,t,r){var m=-1!==e.indexOf("Map"),v=-1!==e.indexOf("Weak"),b=m?"set":"add",y=a[e],x=y&&y.prototype,w=y,C={},k=function(e){var t=x[e];o(x,e,"add"==e?function(e){return t.call(this,0===e?0:e),this}:"delete"==e?function(e){return!(v&&!d(e))&&t.call(this,0===e?0:e)}:"get"==e?function(e){return v&&!d(e)?undefined:t.call(this,0===e?0:e)}:"has"==e?function(e){return!(v&&!d(e))&&t.call(this,0===e?0:e)}:function(e,r){return t.call(this,0===e?0:e,r),this})};if(i(e,!u(y)||!(v||x.forEach&&!f((function(){(new y).entries().next()})))))w=r.getConstructor(t,e,m,b),s.enable();else if(i(e,!0)){var _=new w,S=_[b](v?{}:-0,1)!=_,E=f((function(){_.has(1)})),A=h((function(e){new y(e)})),N=!v&&f((function(){for(var e=new y,t=5;t--;)e[b](t,t);return!e.has(-0)}));A||((w=t((function(t,r){c(t,w,e);var n=p(new y,t,w);return r!=undefined&&l(r,n[b],{that:n,AS_ENTRIES:m}),n}))).prototype=x,x.constructor=w),(E||N)&&(k("delete"),k("has"),m&&k("get")),(N||S)&&k(b),v&&x.clear&&delete x.clear}return C[e]=w,n({global:!0,forced:w!=y},C),g(w,e),v||r.setStrong(w,e,m),w}},function(e,t,r){var n=r(4),a=r(48),i=r(18),o=r(35),s=r(41).f,l=r(52),c=r(61),u=r(37),d=r(199),f=!1,h=u("meta"),g=0,p=Object.isExtensible||function(){return!0},m=function(e){s(e,h,{value:{objectID:"O"+g++,weakData:{}}})},v=e.exports={enable:function(){v.enable=function(){},f=!0;var e=l.f,t=[].splice,r={};r[h]=1,e(r).length&&(l.f=function(r){for(var n=e(r),a=0,i=n.length;a<i;a++)if(n[a]===h){t.call(n,a,1);break}return n},n({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:c.f}))},fastKey:function(e,t){if(!i(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,h)){if(!p(e))return"F";if(!t)return"E";m(e)}return e[h].objectID},getWeakData:function(e,t){if(!o(e,h)){if(!p(e))return!0;if(!t)return!1;m(e)}return e[h].weakData},onFreeze:function(e){return d&&f&&p(e)&&!o(e,h)&&m(e),e}};a[h]=!0},function(e,t,r){var n=r(9);e.exports=!n((function(){return Object.isExtensible(Object.preventExtensions({}))}))},function(e,t){e.exports=function(e,t,r){if(e instanceof t)return e;throw TypeError("Incorrect "+(r?r+" ":"")+"invocation")}},function(e,t,r){var n=r(19),a=r(18),i=r(149);e.exports=function(e,t,r){var o,s;return i&&n(o=t.constructor)&&o!==r&&a(s=o.prototype)&&s!==r.prototype&&i(e,s),e}},function(e,t,r){"use strict";var n=r(41).f,a=r(69),i=r(203),o=r(79),s=r(200),l=r(152),c=r(144),u=r(204),d=r(8),f=r(198).fastKey,h=r(45),g=h.set,p=h.getterFor;e.exports={getConstructor:function(e,t,r,c){var u=e((function(e,n){s(e,u,t),g(e,{type:t,index:a(null),first:undefined,last:undefined,size:0}),d||(e.size=0),n!=undefined&&l(n,e[c],{that:e,AS_ENTRIES:r})})),h=p(t),m=function(e,t,r){var n,a,i=h(e),o=v(e,t);return o?o.value=r:(i.last=o={index:a=f(t,!0),key:t,value:r,previous:n=i.last,next:undefined,removed:!1},i.first||(i.first=o),n&&(n.next=o),d?i.size++:e.size++,"F"!==a&&(i.index[a]=o)),e},v=function(e,t){var r,n=h(e),a=f(t);if("F"!==a)return n.index[a];for(r=n.first;r;r=r.next)if(r.key==t)return r};return i(u.prototype,{clear:function(){for(var e=h(this),t=e.index,r=e.first;r;)r.removed=!0,r.previous&&(r.previous=r.previous.next=undefined),delete t[r.index],r=r.next;e.first=e.last=undefined,d?e.size=0:this.size=0},"delete":function(e){var t=h(this),r=v(this,e);if(r){var n=r.next,a=r.previous;delete t.index[r.index],r.removed=!0,a&&(a.next=n),n&&(n.previous=a),t.first==r&&(t.first=n),t.last==r&&(t.last=a),d?t.size--:this.size--}return!!r},forEach:function(e){for(var t,r=h(this),n=o(e,arguments.length>1?arguments[1]:undefined,3);t=t?t.next:r.first;)for(n(t.value,t.key,this);t&&t.removed;)t=t.previous},has:function(e){return!!v(this,e)}}),i(u.prototype,r?{get:function(e){var t=v(this,e);return t&&t.value},set:function(e,t){return m(this,0===e?0:e,t)}}:{add:function(e){return m(this,e=0===e?0:e,e)}}),d&&n(u.prototype,"size",{get:function(){return h(this).size}}),u},setStrong:function(e,t,r){var n=t+" Iterator",a=p(t),i=p(n);c(e,t,(function(e,t){g(this,{type:n,target:e,state:a(e),kind:t,last:undefined})}),(function(){for(var e=i(this),t=e.kind,r=e.last;r&&r.removed;)r=r.previous;return e.target&&(e.last=r=r?r.next:e.state.first)?"keys"==t?{value:r.key,done:!1}:"values"==t?{value:r.value,done:!1}:{value:[r.key,r.value],done:!1}:(e.target=undefined,{value:undefined,done:!0})}),r?"entries":"values",!r,!0),u(t)}}},function(e,t,r){var n=r(43);e.exports=function(e,t,r){for(var a in t)n(e,a,t[a],r);return e}},function(e,t,r){"use strict";var n=r(21),a=r(41),i=r(30),o=r(8),s=i("species");e.exports=function(e){var t=n(e),r=a.f;o&&t&&!t[s]&&r(t,s,{configurable:!0,get:function(){return this}})}},function(e,t,r){r(141),r(206),r(112),r(167);var n=r(62);e.exports=n.Map},function(e,t,r){"use strict";var n=r(197),a=r(202);e.exports=n("Map",(function(e){return function(){return e(this,arguments.length?arguments[0]:undefined)}}),a)},function(e,t,r){r(208),r(210);var n=r(78);e.exports=n("Array","flat")},function(e,t,r){"use strict";var n=r(4),a=r(209),i=r(36),o=r(55),s=r(56),l=r(84);n({target:"Array",proto:!0},{flat:function(){var e=arguments.length?arguments[0]:undefined,t=i(this),r=o(t.length),n=l(t,0);return n.length=a(n,t,t,r,0,e===undefined?1:s(e)),n}})},function(e,t,r){"use strict";var n=r(86),a=r(55),i=r(79);e.exports=function o(e,t,r,s,l,c,u,d){for(var f,h=l,g=0,p=!!u&&i(u,d,3);g<s;){if(g in r){if(f=p?p(r[g],g,t):r[g],c>0&&n(f))h=o(e,t,f,a(f.length),h,c-1)-1;else{if(h>=9007199254740991)throw TypeError("Exceed the acceptable array length");e[h]=f}h++}g++}return h}},function(e,t,r){r(142)("flat")},function(e,t,r){r(212);var n=r(78);e.exports=n("String","repeat")},function(e,t,r){r(4)({target:"String",proto:!0},{repeat:r(213)})},function(e,t,r){"use strict";var n=r(56),a=r(106),i=r(15);e.exports=function(e){var t=a(i(this)),r="",o=n(e);if(o<0||o==Infinity)throw RangeError("Wrong number of repetitions");for(;o>0;(o>>>=1)&&(t+=t))1&o&&(r+=t);return r}},function(e,t,r){(function(e,t){!function(){"use strict";function r(e){var t=this.constructor;return this.then((function(r){return t.resolve(e()).then((function(){return r}))}),(function(r){return t.resolve(e()).then((function(){return t.reject(r)}))}))}function n(e){return new this((function(t,r){function n(e,r){if(r&&("object"==typeof r||"function"==typeof r)){var o=r.then;if("function"==typeof o)return void o.call(r,(function(t){n(e,t)}),(function(r){a[e]={status:"rejected",reason:r},0==--i&&t(a)}))}a[e]={status:"fulfilled",value:r},0==--i&&t(a)}if(!e||"undefined"==typeof e.length)return r(new TypeError(typeof e+" "+e+" is not iterable(cannot read property Symbol(Symbol.iterator))"));var a=Array.prototype.slice.call(e);if(0===a.length)return t([]);for(var i=a.length,o=0;a.length>o;o++)n(o,a[o])}))}function a(e){return!(!e||"undefined"==typeof e.length)}function i(){}function o(e){if(!(this instanceof o))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],d(e,this)}function s(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,o._immediateFn((function(){var r=1===e._state?t.onFulfilled:t.onRejected;if(null!==r){var n;try{n=r(e._value)}catch(o){return void c(t.promise,o)}l(t.promise,n)}else(1===e._state?l:c)(t.promise,e._value)}))):e._deferreds.push(t)}function l(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var r=t.then;if(t instanceof o)return e._state=3,e._value=t,void u(e);if("function"==typeof r)return void d(function(e,t){return function(){e.apply(t,arguments)}}(r,t),e)}e._state=1,e._value=t,u(e)}catch(i){c(e,i)}}function c(e,t){e._state=2,e._value=t,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn((function(){e._handled||o._unhandledRejectionFn(e._value)}));for(var t=0,r=e._deferreds.length;r>t;t++)s(e,e._deferreds[t]);e._deferreds=null}function d(e,t){var r=!1;try{e((function(e){r||(r=!0,l(t,e))}),(function(e){r||(r=!0,c(t,e))}))}catch(i){if(r)return;r=!0,c(t,i)}}var f=setTimeout;o.prototype["catch"]=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var r=new this.constructor(i);return s(this,new function(e,t,r){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=r}(e,t,r)),r},o.prototype["finally"]=r,o.all=function(e){return new o((function(t,r){function n(e,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,(function(t){n(e,t)}),r)}i[e]=a,0==--o&&t(i)}catch(u){r(u)}}if(!a(e))return r(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var o=i.length,s=0;i.length>s;s++)n(s,i[s])}))},o.allSettled=n,o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o((function(t){t(e)}))},o.reject=function(e){return new o((function(t,r){r(e)}))},o.race=function(e){return new o((function(t,r){if(!a(e))return r(new TypeError("Promise.race accepts an array"));for(var n=0,i=e.length;i>n;n++)o.resolve(e[n]).then(t,r)}))},o._immediateFn="function"==typeof e&&function(t){e(t)}||function(e){f(e,0)},o._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var h=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==t)return t;throw Error("unable to locate global object")}();"function"!=typeof h.Promise?h.Promise=o:h.Promise.prototype["finally"]?h.Promise.allSettled||(h.Promise.allSettled=n):h.Promise.prototype["finally"]=r}()}).call(this,r(215).setImmediate,r(6))},function(e,t,r){(function(e){var n=void 0!==e&&e||"undefined"!=typeof self&&self||window,a=Function.prototype.apply;function i(e,t){this._id=e,this._clearFn=t}t.setTimeout=function(){return new i(a.call(setTimeout,n,arguments),clearTimeout)},t.setInterval=function(){return new i(a.call(setInterval,n,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(n,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout((function(){e._onTimeout&&e._onTimeout()}),t))},r(216),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(this,r(6))},function(e,t,r){(function(e,t){!function(e,r){"use strict";if(!e.setImmediate){var n,a,i,o,s,l=1,c={},u=!1,d=e.document,f=Object.getPrototypeOf&&Object.getPrototypeOf(e);f=f&&f.setTimeout?f:e,"[object process]"==={}.toString.call(e.process)?n=function(e){t.nextTick((function(){g(e)}))}:!function(){if(e.postMessage&&!e.importScripts){var t=!0,r=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=r,t}}()?e.MessageChannel?((i=new MessageChannel).port1.onmessage=function(e){g(e.data)},n=function(e){i.port2.postMessage(e)}):d&&"onreadystatechange"in d.createElement("script")?(a=d.documentElement,n=function(e){var t=d.createElement("script");t.onreadystatechange=function(){g(e),t.onreadystatechange=null,a.removeChild(t),t=null},a.appendChild(t)}):n=function(e){setTimeout(g,0,e)}:(o="setImmediate$"+Math.random()+"$",s=function(t){t.source===e&&"string"==typeof t.data&&0===t.data.indexOf(o)&&g(+t.data.slice(o.length))},e.addEventListener?e.addEventListener("message",s,!1):e.attachEvent("onmessage",s),n=function(t){e.postMessage(o+t,"*")}),f.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var a={callback:e,args:t};return c[l]=a,n(l),l++},f.clearImmediate=h}function h(e){delete c[e]}function g(e){if(u)setTimeout(g,0,e);else{var t=c[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(void 0,r)}}(t)}finally{h(e),u=!1}}}}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,r(6),r(217))},function(e,t){var r,n,a=e.exports={};function i(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function s(e){if(r===setTimeout)return setTimeout(e,0);if((r===i||!r)&&setTimeout)return r=setTimeout,setTimeout(e,0);try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}!function(){try{r="function"==typeof setTimeout?setTimeout:i}catch(e){r=i}try{n="function"==typeof clearTimeout?clearTimeout:o}catch(e){n=o}}();var l,c=[],u=!1,d=-1;function f(){u&&l&&(u=!1,l.length?c=l.concat(c):d=-1,c.length&&h())}function h(){if(!u){var e=s(f);u=!0;for(var t=c.length;t;){for(l=c,c=[];++d<t;)l&&l[d].run();d=-1,t=c.length}l=null,u=!1,function(e){if(n===clearTimeout)return clearTimeout(e);if((n===o||!n)&&clearTimeout)return n=clearTimeout,clearTimeout(e);try{n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}(e)}}function g(e,t){this.fun=e,this.array=t}function p(){}a.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)t[r-1]=arguments[r];c.push(new g(e,t)),1!==c.length||u||s(h)},g.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=p,a.addListener=p,a.once=p,a.off=p,a.removeListener=p,a.removeAllListeners=p,a.emit=p,a.prependListener=p,a.prependOnceListener=p,a.listeners=function(e){return[]},a.binding=function(e){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(e){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(220)),i=n(r(456)),o=n(r(457)),s=n(r(283)),l=r(224);a["default"].addDep(s["default"]);var c,u=(c={},function(e){var t=e;return t=t&&t.replace(/(^\s*)|(\s*$)/g,"")||"",c[t]||(c[t]={key:t,subject:t.replace(/[^\/]*?$/gi,""),predicate:t.replace(/^.*\//gi,"")})});function d(e){switch(i["default"][e]){case"charts":return Promise.all([r.e(2),r.e(1)]).then(r.t.bind(null,459,7));case"timeseries":return Promise.all([r.e(2),r.e(3)]).then(r.t.bind(null,736,7));case"powercharts":return Promise.all([r.e(2),r.e(4)]).then(r.t.bind(null,919,7));case"widgets":return Promise.all([r.e(2),r.e(5)]).then(r.t.bind(null,1084,7));case"zoomline":return Promise.all([r.e(2),r.e(6)]).then(r.t.bind(null,1182,7));case"gantt":return Promise.all([r.e(2),r.e(7)]).then(r.t.bind(null,1193,7));case"treemap":return Promise.all([r.e(2),r.e(8)]).then(r.t.bind(null,1211,7));case"zoomscatter":return Promise.all([r.e(2),r.e(9)]).then(r.t.bind(null,1217,7));case"msstackedcolumn2dsplinedy":return Promise.all([r.e(2),r.e(10)]).then(r.t.bind(null,1221,7));case"overlappedbar2d":return Promise.all([r.e(2),r.e(11)]).then(r.t.bind(null,1225,7));case"overlappedcolumn2d":return Promise.all([r.e(2),r.e(12)]).then(r.t.bind(null,1230,7));default:return(0,o["default"])(""+a["default"].getScriptBaseURI()+function(e){var t,r=a["default"].options,n=e;return n=function(e){return void 0===e&&(e=""),""===e?e:e.replace(/^[\s\S]*\//gi,"").replace(/\?/g,"%3F").replace(/\#/g,"%23").replace(/\:/g,"%3A")}((t=u(n)).predicate),t.subject+r.html5ScriptNamePrefix+n+r.html5ScriptNameSuffix}(e))}}a["default"].addEventListener("resourceRequested",(function(e){var t=e.sender,r=t.chartType(),n=t.options.chartTypeSourcePath||"";a["default"].getDep(r,"chartapi")||a["default"].getDep(r,"maps")||a["default"].addDep({name:r,type:"dependency",extension:d(n+r)})})),a["default"].addEventListener("preconfigure",(function(e){var t=e.sender;if("chartAPI"===t.getType()){var n=t.getFromEnv("dataSource");n&&n.chart&&(0,l.pluck)(n.chart.exportenabled,0)&&!a["default"].getDep("ExcelExport")&&a["default"].addDep({name:"ExcelExport",extension:Promise.all([r.e(2),r.e(13)]).then(r.t.bind(null,1234,7)).then((function(e){var t=e["default"];a["default"].addDep(t)}))}),n&&n.chart&&(0,l.pluckNumber)(n.chart.accessibility,0)&&!a["default"].getDep("AccessibilityExtension")&&a["default"].addDep({name:"AccessibilityExtension",extension:Promise.all([r.e(2),r.e(14)]).then(r.t.bind(null,1243,7)).then((function(e){var t=e["default"];a["default"].addDep(t)}))})}})),window&&r(458)&&(window.FusionCharts=a["default"]);var f=a["default"];t["default"]=f},function(e,t){e.exports=function(e){return e&&e.__esModule?e:{"default":e}},e.exports["default"]=e.exports,e.exports.__esModule=!0},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(221)),i=r(231),o=n(r(412)),s=r(424),l=r(452),c=r(453);a["default"].DataStore=o["default"],a["default"].DataStore.Operators={between:s.between,equals:s.equals,less:s.less,lessEquals:s.lessEquals,greater:s.greater,greaterEquals:s.greaterEquals,filter:s.filter,select:s.select,groupBy:s.groupBy,pipe:s.pipe,sort:s.sort,pivot:s.pivot},a["default"].Utils={duration:c.duration,before:c.before,after:c.after,parseDate:c.parseDate,formatDate:c.formatDate,DatetimeUnits:c.DatetimeUnits,Weekdays:c.Weekdays},a["default"].DataStore.Aggregators={aggregatorStore:l.aggregatorStore};var u=["type","id","width","height","debugMode","registerWithJS","backgroundColor","scaleMode","lang","detectFlashVersion","autoInstallRedirect"],d=function(e,t){var r,n;for(r=0,n=u.length;r<n;r++)"object"==typeof t[r]?Object.assign(e,t[r]):e[u[r]]=t[r];return e};function f(e){var t=e;return this instanceof f?(1===arguments.length&&"object"==typeof t||(t=d({},arguments)),new(Function.prototype.bind.apply(a["default"],[null].concat(t)))):1===arguments.length&&t instanceof Array&&"private"===t[0]?a["default"].register("module",t):1===arguments.length&&"string"==typeof t?a["default"].getChartFromId(t):void(0,i.raiseError)(f,"25081840","run","",new SyntaxError('Use the "new" keyword while creating a new FusionCharts object'))}Object.getOwnPropertyNames(a["default"]).filter((function(e){return!0===Object.getOwnPropertyDescriptor(a["default"],e).writable})).forEach((function(e){f[e]=a["default"][e]}));var h=f;t["default"]=h},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(222));r(281);var i=n(r(283));a["default"].addDep(i["default"]);var o=a["default"];t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(223)),i=r(224),o=r(231),s=r(232),l=r(233),c=n(r(234)),u=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=k(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(235)),d=n(r(249)),f=r(236),h=n(r(252)),g=n(r(253)),p=n(r(254)),m=n(r(255)),v=n(r(258)),b=n(r(260)),y=n(r(261)),x=n(r(276)),w=n(r(280)),C=n(r(245));function k(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(k=function(e){return e?r:t})(e)}function _(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function S(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?_(Object(r),!0).forEach((function(t){(0,a["default"])(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):_(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var E,A,N,T,M,D,F="3.18.0",I=new Date("2021-09-20").getTime(),O=new Date("2020-08-20").getTime(),L=new Date("2020-08-20").getTime(),R=void 0===R?"":new Date("2020-08-20").getTime(),P=new Date("2020-08-20").getTime(),V=new Date("2020-08-20").getTime(),j=/(^|[\/\\])(fusioncharts\.js)([\?#].*)?$/gi,B=/^(FusionCharts|FusionWidgets|FusionMaps)/,z=/[^\%\d]*$/gi,H=/url$/i,U="relative",G="left",W="normal",$="inline-block",X="1",Y="middle",q="normal",K="normal",J="normal",Z="none",Q="inline",ee="0",te="0",re="none",ne="ltr",ae="none",ie=function(e){return e.toString().toLowerCase()},oe=function(){return{state:2}},se=(A={},N=function Oe(){var e,t,r,n,a,i=0,o=parseInt(Fe.options.visibilityTrackingInterval,10)||300;for(e in A)if(i+=1,t=A[e].chart,r=A[e].container,n=A[e].insertMode,a=A[e].callback,t.disposed||!le(r)){if(delete A[e],i-=1,delete t.containerHidden,t.disposed)return;t.renderOpts={containerElement:r,insertMode:n,callback:a},t._addChartDependency("chartContainer",{scopeOf:t,opts:{containerElement:r,insertMode:n,callback:a},resolve:Me}),t._setState()}else A[e]&&A[e].chart&&(A[e].chart.containerHidden=!0,A[e].chart._addChartDependency("chartContainer",{resolve:oe}),A[e].chart._setState());E=i?setTimeout(Oe,o):clearTimeout(E)},function(e,t,r,n){A[e.id]={chart:e,container:t,insertMode:r,callback:n},E||(E=setTimeout(N,parseInt(Fe.options.visibilityTrackingInterval,10)||300))}),le=function Le(e){var t=e.parentNode;return!!t&&9!==t.nodeType&&("none"===function(e,t){var r=t;return window.getComputedStyle?r=window.getComputedStyle(e).getPropertyValue(r):e.currentStyle&&(r=e.currentStyle[r]),r}(e,"display")||!!t&&Le(t))},ce=0,ue=!1,de=["disposed","error","waiting","ready","initialized"],fe={},he="https://www.fusioncharts.com/dev/migration/deprecated-functionalities?version=3.13.0",ge='You are using incompatible files or deprecated "register" API of FusionCharts, please go through the docs to know more at '+he;function pe(){return this.state}function me(){return this.msg}function ve(){return this.msgStyle}function be(){return"chartobject-"+(be.lastId+=1)}function ye(e){var t,r={};for(t in e)r[t.toLowerCase()]=e[t];return r}function xe(e){var t,r=[];for(t in e)r.push(t+"_"+e[t]);return r.sort(),r.join(",")}function we(e){var t,r,n=e.options,a=e.args;return t={imageHAlign:a.loadMessageImageHAlign||n.baseChartMessageImageHAlign,imageVAlign:a.loadMessageImageVAlign||n.baseChartMessageImageVAlign,imageAlpha:a.loadMessageImageAlpha||n.baseChartMessageImageAlpha,imageScale:a.loadMessageImageScale||n.baseChartMessageImageScale},r={color:a.loadMessageColor||n.baseChartMessageColor,fontFamily:a.loadMessageFont||n.baseChartMessageFont,fontSize:a.loadMessageFontSize||n.baseChartMessageFontSize},{msg:e.options.showChartLoadingMessage?n.PBarLoadingText||n.loadMessage:"",msgStyle:{message:r,image:t}}}function Ce(e){var t,r,n=e.args,a=e.options;return t={imageHAlign:n.typeNotSupportedMessageImageHAlign||a.baseChartMessageImageHAlign,imageVAlign:n.typeNotSupportedMessageImageVAlign||a.baseChartMessageImageVAlign,imageAlpha:n.typeNotSupportedMessageImageAlpha||a.baseChartMessageImageAlpha,imageScale:n.typeNotSupportedMessageImageScale||a.baseChartMessageImageScale},r={color:n.typeNotSupportedMessageColor||a.baseChartMessageColor,fontFamily:n.typeNotSupportedMessageFont||a.baseChartMessageFont,fontSize:n.typeNotSupportedMessageFontSize||a.baseChartMessageFontSize},ue&&(a.messageURL=he),{msg:ue?ge:a.typeNotSupportedMessage,msgStyle:{image:t,message:r}}}function ke(e){var t,r,n=e.args,a=e.options;return t={imageHAlign:n.browserNotSupportedMessageImageHAlign||a.baseChartMessageImageHAlign,imageVAlign:n.browserNotSupportedMessageImageVAlign||a.baseChartMessageImageVAlign,imageAlpha:n.browserNotSupportedMessageImageAlpha||a.baseChartMessageImageAlpha,imageScale:n.browserNotSupportedMessageImageScale||a.baseChartMessageImageScale},r={color:n.browserNotSupportedMessageColor||a.baseChartMessageColor,fontFamily:n.browserNotSupportedMessageFont||a.baseChartMessageFont,fontSize:n.browserNotSupportedMessageFontSize||a.baseChartMessageFontSize},{msg:a.browserNotSupportedMessage,msgStyle:{image:t,message:r}}}function _e(){ue=!0}function Se(e){var t,r,n,a=this.opts,c=a.data,u=a.sanitisedFormat,d=a.silent,f=(0,s.getDepsByType)("transcoder"),h=f[u]&&f[u](),g=e.options,p=function(e){var t,r,n=e.options,a=e.args;return t={imageHAlign:(0,i.pluck)(a.dataInvalidMessageImageHAlign,n.baseChartMessageImageHAlign).toLowerCase(),imageVAlign:(0,i.pluck)(a.dataInvalidMessageImageVAlign,n.baseChartMessageImageVAlign).toLowerCase(),imageAlpha:(0,i.pluckNumber)(a.dataInvalidMessageImageAlpha,n.baseChartMessageImageAlpha),imageScale:(0,i.pluckNumber)(a.dataInvalidMessageImageScale,n.baseChartMessageImageScale)},r={fontFamily:a.dataInvalidMessageFont||n.baseChartMessageFont,fontSize:a.dataInvalidMessageFontSize||n.baseChartMessageFontSize,color:a.dataInvalidMessageColor||n.baseChartMessageColor},{msg:n.dataInvalidMessage,msgStyle:{image:t,message:r}}}(e),m=p.msg,v=p.msgStyle;return e.__state.newDataArrived=!0,h&&h.toJSON?n=(r=h.toJSON(c,e)).error?{state:1,msg:m,msgStyle:v}:{state:3}:(r={error:new Error("Unable to convert data.")},n={state:1,msg:m,msgStyle:v}),t=r.error?r:r.data,g.dataErroneous=g.error=r.error,g.dataSource=t,g.dataFormat=u,g.dataErroneous||(0,o.triggerEvent)("beforeDataUpdate",e,function(e,t,r,n){var a={};return a.native="json"===r,a.dataFormat=r,a.format="json",a.data=t,a.dataSource=e,a.silent=!!n,a}(c,t,u,d),M,l.onDataUpdateSuccess,l.onDataUpdateCancel),n}function Ee(e){var t,r,n,a,l,c,u,d=this.opts,f=d.url,h=void 0===f?"":f,g=d.format,p=d.config,m=d.callback,v=d.silent,b=(0,s.getDepsByType)("transcoder"),y=(c=(n=e).options,u=n.args,a={imageHAlign:(0,i.pluck)(u.dataLoadStartMessageImageHAlign,c.baseChartMessageImageHAlign).toLowerCase(),imageVAlign:(0,i.pluck)(u.dataLoadStartMessageImageVAlign,c.baseChartMessageImageVAlign).toLowerCase(),imageAlpha:(0,i.pluckNumber)(u.dataLoadStartMessageImageAlpha,c.baseChartMessageImageAlpha),imageScale:(0,i.pluckNumber)(u.dataLoadStartMessageImageScale,c.baseChartMessageImageScale)},l={fontFamily:u.dataLoadStartMessageFont||c.baseChartMessageFont,fontSize:u.dataLoadStartMessageFontSize||c.baseChartMessageFontSize,color:u.dataLoadStartMessageColor||c.baseChartMessageColor},{msg:c.dataLoadStartMessage,msgStyle:{image:a,message:l}}),x=y.msg,w=y.msgStyle;return null!=g&&"function"==typeof g.toString||(g=e.options.dataFormat,(0,o.raiseWarning)(e,"03091609","param","FusionCharts#setChartDataUrl","Invalid Data Format. Reverting to current data format - "+g)),t=ie(g),H.test(t)||(t+="url"),r=b[t]&&b[t](),e.jsVars.stallLoad=!0,r&&r.toJSON?(r.toJSON(h,p,m,v,e),{state:2,msg:x,msgStyle:w}):{state:1,error:new Error("Unable to fetch data.")}}function Ae(e){var t,r,n=e.__state,a=e.chartType(),l=e.apiInstance&&e.apiInstance.getFromEnv("toolTipController")&&e.apiInstance.getFromEnv("toolTipController").toolTips,c=(0,s.getDep)(n.lastRenderedType,"chartapi")||(0,s.getDep)(n.lastRenderedType,"maps");if(l&&(0,i.removeAllTooltipOnChart)(l,n.lastRenderedType===a),c&&n.lastRenderedType!==a&&((0,o.triggerEvent)("chartTypeChanged",e,{previousType:n.lastRenderedType,newType:a}),t=c))for(r in t)delete e[r];n.lastRenderedType=a}function Ne(e){var t=we(e),n=t.msgStyle,a=t.msg;return Promise.all([r.e(2),r.e(15)]).then(r.t.bind(null,1257,7)).then((function(t){Fe.addDep(t["default"]),Ae(e),e._addChartDependency("mapModuleLoad",{resolve:function(){return{state:3}}}),(0,o.triggerEvent)("loaded",e,{type:e.chartType(),renderer:"javascript"},[e.id]),e._setState()}))["catch"]((function(){var t=Ce(e),r=t.msgStyle,n=t.msg;e._addChartDependency("mapModuleLoad",{resolve:function(){return{state:1,msgStyle:r,msg:n}}}),(0,o.raiseError)(Fe,"12052314141","run","JavaScriptRenderer~Maps",new Error("FusionCharts' maps file is required to render the visualization.")),e._setState(),(0,o.triggerEvent)("charttypeinvalid",e,{},[e.id])})),{state:2,msgStyle:n,msg:a}}function Te(e){var t=this.opts.value,r=Fe.getDep(t,"dependency")||Fe.getDep(t,"chartapi")||Fe.getDep(t,"maps"),n=Ce(e),a=n.msgStyle,i=n.msg;return ue=!1,r?r.then?(Fe.addEventListener("register",_e),r.then((function(r){if(!e.disposed){if(r.__esModule){var n=(0,s.getDep)(t,"maps");Fe.addDep(r["default"]),!n&&Ae(e),e._addChartDependency("chartModuleLoad",{resolve:function(){return n?e._addChartDependency("mapModuleLoad",{scopeOf:e,resolve:Ne}):(0,o.triggerEvent)("loaded",e,{type:t,renderer:"javascript"},[e.id]),{state:3}}})}else e._addChartDependency("chartModuleLoad",{resolve:function(){return(0,s.getDep)(t,"maps")?e._addChartDependency("mapModuleLoad",{scopeOf:e,resolve:Ne}):(Ae(e),(0,o.triggerEvent)("loaded",e,{type:t,renderer:"javascript"},[e.id])),{state:3}}});e._setState()}}))["catch"]((function(t){if(!e.disposed){if(!(t instanceof Event))throw new Error(t.stack);e._addChartDependency("chartModuleLoad",{resolve:function(){return S({state:1},Ce(e))}}),e._setState(),(0,o.triggerEvent)("charttypeinvalid",e,{},[e.id])}})),S({state:2},we(e))):((0,s.getDep)(t,"maps")?(e._addChartDependency("mapModuleLoad",{scopeOf:e,resolve:Ne}),e._setState()):(Ae(e),(0,o.triggerEvent)("loaded",e,{type:t,renderer:"javascript"},[e.id])),{state:3}):((0,o.triggerEvent)("charttypeinvalid",this,{},[this.id]),{state:1,msgStyle:a,msg:i})}function Me(e){var t,r,n,a,s=this.opts,l=s.containerElement,c=s.insertMode,u=s.callback;if(u?"function"!=typeof u&&(u=M):"function"==typeof c?(u=c,c=M):c||"function"!=typeof l||(u=l,l=M),c=(c||e.options.insertMode).toLowerCase()||i.domInsertModes.REPLACE,void 0===l&&(l=e.options.containerElementId||e.options.containerElement),"string"==typeof l&&(l=document.getElementById(l)),null==l)return(0,o.raiseError)(e,"03091456","run",".render()",new Error("Unable to find the container DOM element.")),(0,o.triggerEvent)("containernotfound",e,{},[e.id]),{state:1};if(function(e,t){var r,n,a,i=document.getElementById(e),o=t.id||t.getAttribute("id");if(null===i)return!1;if(e===o)return!0;for(n=0,a=(r=t.getElementsByTagName("*")).length;n<a;n++)if(r[n]===i)return!1;return!0}(e.id,l))return(0,o.raiseError)(e,"05102109","run",".render()",new Error("A duplicate object already exists with the specific Id: "+e.id)),{state:1};if(le(l))return e.containerHidden=!0,se(e,l,c,u),{state:2};if(delete e.containerHidden,((r=window[e.id])&&r.FusionCharts&&r.FusionCharts===e||(r=e.ref)&&r.FusionCharts&&r.FusionCharts===e)&&(e._dispose(),r===window[e.id]&&(window[e.id]=M)),"undefined"!=typeof window[e.id])return(0,o.raiseError)(e,"25081843","comp",".render",new Error("#25081843:IECompatibility() Chart Id is same as a JavaScript variable name. Variable naming error. Please use unique name for chart JS variable, chart-id and container id.")),{state:1};if((t=document.createElement(e.options.containerElementType||"span")).setAttribute("id",e.id),"append"!==c&&"prepend"!==c)for(;l.hasChildNodes();)l.removeChild(l.firstChild);return"prepend"===c&&l.firstChild?l.insertBefore(t,l.firstChild):l.appendChild(t),e.options.containerElement=l,e.options.containerElementId=l.id,(a=t.style)&&(a.position=U,a.textAlign=G,a.lineHeight=W,a.display=$,a.zoom=X,a["vertical-align"]=Y,a.fontWeight=q,a.fontVariant=K,a.fontStyle=J,a.textDecoration=Z,a["*DISPLAY"]=Q,a.padding=ee,a.margin=te,a.border=re,a.direction=ne,a.transform=ae),e.options.containerClassName&&(t.className=e.options.containerClassName),n=(0,i.normalizeCSSDimension)(e.width,e.height,t),e.__state.renderedWidth=n.pixelWidth,e.__state.renderedHeight=n.pixelHeight,e.__state.rendering=!0,e.renderOpts={containerElement:t,insertMode:c,callback:u},{state:3}}be.lastId=0;var De,Fe=function(){function e(){var t,n,a=this,s={},l=e.getDep("vml","dependency");(this.__state={},this.id=i.BLANKSTRING,this._deps={},this.__state._unresolvedDeps={},this.__state.state=4,1===arguments.length&&"object"==typeof(arguments.length<=0?undefined:arguments[0])&&(s=arguments.length<=0?undefined:arguments[0]),arguments.length>1&&"object"==typeof((t=arguments.length-1)<0||arguments.length<=t?undefined:arguments[t]))&&(0,i.extend2)(s,(n=arguments.length-1)<0||arguments.length<=n?undefined:arguments[n],!1,!0);this.id="undefined"==typeof s.id?be():s.id,this.args=s,this._parsePolicies(g["default"]),this._attachDefaultEventListeners(),this.jsVars.fcObj=this,(0,o.triggerEvent)("beforeInitialize",this,s),e.items[this.id]instanceof e&&(0,o.raiseWarning)(this,"06091847","param","",new Error('A FusionCharts object with the specified id "'+this.id+'" already exists.Renaming it to '+(this.id=be()))),this.attributes.id=this.id,r.p=e.getScriptBaseURI(),l&&(this._addChartDependency("chartVmlRendererLoad",{resolve:function(){return l.then((function(t){var r=t["default"];e.addDep(r),a._addChartDependency("chartVmlRendererLoad",{resolve:function(){return{state:3}}}),a._setState()}))["catch"]((function(){(0,o.raiseError)(e,"162162788","run",">RendererError~VMLRendererLoad","Unable to load FusionCharts VML renderer."),a._addChartDependency("chartVmlRendererLoad",{resolve:function(){return{state:1}}}),a._setState()})),{state:2}}}),this._setState()),this.chartType&&this.chartType(s.type||s.swfUrl||""),this.setChartData(this.args.dataSource,this.args.dataFormat,M,M,!0),e.items[this.id]=this,e.defaultOptions=e.options,(0,o.triggerEvent)("initialized",this,s),this._setState()}e.getObjectReference=function(t){return void 0===t&&(t=""),e.items[t]&&e.items[t].ref},e.register=function(){(0,o.triggerEvent)("register",e,arguments,M,(function(){(0,o.raiseError)(this,"0604111219","run",".register()",new Error(ge))}))},e.render=function(t,r){return t instanceof e?(t.render(r),t):new e(t).render(r)},e.addDep=function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return s.addDep.call.apply(s.addDep,[this].concat(t))},e.getDep=function(e,t){return s.getDep.call(this,e,t)},e.addEventListener=function(e,t){return(0,o.addListener)(e,t)},e.on=function(t,r){return e.addEventListener(t,r)},e.removeEventListener=function(e,t){return(0,o.removeListener)(e,t)},e.ready=function(t,r,n){void 0===r&&(r=e),void 0===n&&(n=e);var a=function(){t.call(n,r)};"function"==typeof t&&(T?setTimeout(a,0):e.addEventListener("ready",a))},e.formatNumber=function(e,t,r){void 0===t&&(t={});var n,a=ye(t),i=xe(a);return fe[i]?n=fe[i]:fe[i]=n=new p["default"](a,{useScaleRecursively:!0}),n.configure(a),n.dataLabels(e,r)},e._getCleanValue=function(e,t){void 0===t&&(t={});var r,n=ye(t),a=xe(n);return fe[a]?r=fe[a]:(fe[a]=r=new p["default"](n,{useScaleRecursively:!0}),r.configure(n)),r.getCleanValue(e)},e.transcodeData=function(e,t,r,n){var a,i,l,c=(0,s.getDepsByType)("transcoder"),u=ie(r),d=ie(t);if(d&&"function"==typeof d.toString&&u&&"function"==typeof u.toString&&"undefined"!=typeof c[u]&&"undefined"!=typeof c[d])return(l=c[d]()).toJSON&&(a=l.toJSON(e,this),i=c[u]().fromJSON(a.data,this)),a.error instanceof Error||(i.error=a.error),n?i:i.data;(0,o.raiseError)(this,"14090217","param",".transcodeData()","Unrecognized data-format specified during transcoding.")},e.setAnimation=function(t){!e.options._globalAnimationRule&&(e.options._globalAnimationRule=[]),e.options._globalAnimationRule.push(t)},e.setEasingEffect=function(t,r){e.getDep("redraphael","plugin").easing_formulas[t]=r},e.getScriptBaseURI=function(){return e.options.scriptBaseUri},e.setScriptBaseURI=function(t){e.options.scriptBaseUri=t,r.p=t},e.getChartFromId=function(t){return e.items[t]},e.getVersion=function(e){var t={fcs:F,"fcs-xt":{fc:"3.18.0",fw:"3.18.0",pc:"3.18.0",fm:"3.18.0"},ft:"2.6.0"};return t[e]||t["fcs-xt"][e]||t},e.getReleaseDate=function(e){var t={fcs:I,"fcs-xt":{fc:R,fw:O,pc:L,fm:P},ft:V};return t[e]||t["fcs-xt"][e]||t};var t=e.prototype;return t._attachDefaultEventListeners=function(){var e,t,r=this.options.events;if(r)for(e in r)"function"==typeof r[e]&&this.addEventListener(e,r[e]);for(t in this.options.renderer="javascript",c["default"])this.addEventListener(t,c["default"][t])},t._setState=function(){var e,t,r=this._deps,n=this.__state.state,a=4;for(var i in r)r.hasOwnProperty(i)&&(a>(t=(e=r[i]).getState())&&(a=t,this.__state.currChartMsg=e.getMsg(),this.__state.currChartMsgStyle=e.getMsgStyle()),3===t&&this._removeChartDependency(i));if(this.__state.prevState=n,this.__state.state=a,n!==a&&(0,o.triggerEvent)("stateChanged",this,{prevState:de[n],state:de[a]},[this.id]),!this.containerHidden)if(3===a&&this.__state.renderInvoked&&this.__state.isDrawInvoked){var s=this.renderOpts,l=s.containerElement,c=s.callback;this._renderChart(l,M,c),this._clearPrevContext(),delete this.renderOpts.callback}else if((2===a||1===a)&&this.__state.renderInvoked&&this.__state.isDrawInvoked&&this._contextChanged()&&(!this.__state.renderComplete||2!==a)){var u=this.renderOpts,d=u.containerElement,f=u.callback;this._renderChart(d,"base",1===a&&f,this.__state.currChartMsg,this.__state.currChartMsgStyle),this._clearPrevContext(),1===a&&delete this.renderOpts.callback}},t._clearPrevContext=function(){this.__state.prevChartMsg=i.BLANKSTRING,this.__state.prevChartMsgStyle={}},t._contextChanged=function(){if(this.__state.currChartMsg!==this.__state.prevChartMsg)return this.__state.prevChartMsg=this.__state.currChartMsg,this.__state.prevChartMsgStyle=this.__state.currChartMsgStyle,!0;var e=this.__state.prevChartMsgStyle&&this.__state.prevChartMsgStyle.image,t=this.__state.currChartMsgStyle&&this.__state.currChartMsgStyle.image,r=this.__state.prevChartMsgStyle&&this.__state.prevChartMsgStyle.message,n=this.__state.currChartMsgStyle&&this.__state.currChartMsgStyle.message;return!(!e||e.imageHAlign===t.imageHAlign&&e.imageVAlign===t.imageVAlign&&e.imageAlpha===t.imageAlpha&&e.imageScale===t.imageScale&&r.color===n.color&&r.fontFamily===n.fontFamily&&r.fontSize===n.fontSize)&&(this.__state.prevChartMsg=this.__state.currChartMsg,this.__state.prevChartMsgStyle=this.__state.currChartMsgStyle,!0)},t._sudoSetState=function(e){this.__state.prevState=this.__state.state,this.__state.state=e,(0,o.triggerEvent)("stateChanged",this,{prevState:de[this.__state.prevState],state:de[this.__state.state]},[this.id])},t._getState=function(){return de[this.__state.state]},t._addChartDependency=function(e,t){this._deps&&this._deps[e]&&this._removeChartDependency(e),this._deps[e]=t,t.getState=pe,t.getMsg=me,t.getMsgStyle=ve,Object.assign(t,t.resolve(t.scopeOf))},t._removeChartDependency=function(e){this._deps[e]&&(this._deps[e].removed=!0,delete this._deps[e])},t._parsePolicies=function(e){var t,r,n,a=this.args;for(t in e)if(g["default"][t]instanceof Array)r=a[e[t][0]],this[t]=void 0===r?e[t][1]:r;else for(n in"object"!=typeof this[t]&&(this[t]={}),e[t])r=a[e[t][n][0]],this[t][n]=void 0===r?e[t][n][1]:r},t.hasRendered=function(){return!(!this.jsVars.hcObj||!this.jsVars.hcObj.hasRendered)},t.setTransparent=function(e){var t,r=e;(t=this.jsVars)&&("boolean"!=typeof r&&null!==r&&(r=!0),t.transparent=null!==r&&!0===r)},t.addEventListener=function(e,t){return(0,o.addListener)(e,t,this)},t.on=function(e,t){return this.addEventListener(e,t)},t.removeEventListener=function(e,t){return(0,o.removeListener)(e,t,this)},t.formatNumber=function(e,t,r,n){var a,o,s,l,c,u=this.apiInstance||{},d=u.numberFormatter,f=r;switch(o=xe(f),f=f&&ye(f)||{},""===o?d?l=d:(s=xe(a=this.options.dataSource.chart||{}),fe[s]?l=fe[s]:fe[s]=l=new p["default"](u,a)):(a=this.options.dataSource.chart||{},s=xe(a=(0,i.extend2)((0,i.extend2)({},a),f)),fe[s]?l=fe[s]:fe[s]=l=new p["default"](u,a)),(t&&t.toLowerCase?t:"").toLowerCase()){case"yaxisvalues":c=l.yAxis(e,n);break;case"xaxisvalues":c=l.xAxis(e);break;case"scale":c=l.scale(e);break;default:c=l.dataLabels(e,n)}return c},t.clone=function(t,r){var n=typeof t,a={},o=r,s=(0,i.extend2)({},this.args,!1,!0);switch(function(e,t,r){var n,a;for(n in e)if(e[n]instanceof Array)t[e[n][0]]=r[n];else for(a in e[n])t[e[n][a][0]]=r[n][a]}(g["default"],s,this),delete s.id,delete s.animate,delete s.stallLoad,a.link=s.link,(s=(0,i.extend2)({},s,!1,!0)).link=a.link,n){case"object":(0,i.extend2)(s,t,!1,!0);break;case"boolean":o=t}return o?s:new e(s)},t.isActive=function(){if(!this.ref||window.document.getElementById(this.id)!==this.ref)return!1;try{return B.test("FusionCharts")}catch(e){return!1}},t.chartType=function(t,r){var n,a=r,s=this.options;if("string"==typeof t&&""!==t){if(a="object"==typeof a?a:{},n=t.replace(/[\?\#][\s\S]*$/g,""),s.chartType=n.replace(/^[\s\S]*\//gi,""),s.chartTypeSourcePath=-1===n.indexOf("/")?a.chartTypeSourcePath||e.options.chartTypeSourcePath||"":n.replace(/[^\/]*?$/gi,""),"zoomscatter"===s.chartType&&!document.createElement("canvas").getContext){var l=ke(this),c=l.msgStyle,u=l.msg;return this._addChartDependency("chartModuleLoad",{scopeOf:this,opts:{value:s.chartType},resolve:function(){return{state:1,msgStyle:c,msg:u}}}),void this._setState()}if(("timeseries"===s.chartType||"chord"===s.chartType||"sankey"===s.chartType)&&i.isIE){var d=ke(this),f=d.msgStyle,h=d.msg;return this._addChartDependency("chartModuleLoad",{scopeOf:this,opts:{value:s.chartType},resolve:function(){return{state:1,msgStyle:f,msg:h}}}),void this._setState()}(0,o.triggerEvent)("resourceRequested",this),this._addChartDependency("chartModuleLoad",{scopeOf:this,opts:{value:s.chartType},resolve:Te}),"undefined"!=typeof a.dataSource&&null!==a.dataSource&&this.setChartData(a.dataSource,a.dataFormat,a.dataConfiguration),this._setState()}else if(t!==M){var g=Ce(this),p=g.msgStyle,m=g.msg;return this._addChartDependency("chartModuleLoad",{resolve:function(){return{state:1,msgStyle:p,msg:m}}}),this._setState(),void(0,o.triggerEvent)("charttypeinvalid",this,{},[this.id])}return(s.chartType||"").toLowerCase()},t.setChartDataUrl=function(e,t,r,n,a){var i=e||"";this._addChartDependency("data",{scopeOf:this,opts:{url:i,format:t,config:r,callback:n,silent:a},resolve:Ee}),this._setState()},t.setChartData=function(e,t,r,n,a){void 0===a&&(a=!0);var i,o=e,s=t;if(this.originalDataSource=e,null!=o){if("string"!=typeof s)switch(typeof o){case"function":o=o.call(this,this.options.dataConfiguration),s=this.args.dataFormat="JSON";break;case"string":s=this.args.dataFormat=/^\s*?\{[\s\S]*\}\s*?$/g.test(s)?"JSON":"XML";break;case"object":s=this.args.dataFormat="JSON"}}else s="json";"xml"===(i=ie(s))&&this.apiInstance&&this.apiInstance.config&&this.apiInstance.config.isXMLUnsupported||(H.test(i)?this.setChartDataUrl(o,i,r,n,a):(this._addChartDependency("data",{opts:{data:o,sanitisedFormat:i,config:r,callback:n,silent:a},scopeOf:this,resolve:Se}),!this.disposed&&this._setState()))},t.getChartData=function(e,t,r){var n=e||"json";"object"==typeof e&&e.format&&(n=e.format);var a,o,l=ie(null===n?"json":n),c=(0,s.getDepsByType)("transcoder")[l](),u=this.options,d=this.apiInstance,f=!r&&(a=d&&d.getCollatedData&&d.getCollatedData(u.dataSource))?a:u.dataSource;return"object"==typeof e&&1===e.isRaw?o=this.originalDataSource:"xml"===l&&d&&d.config&&d.config.isXMLUnsupported?i.BLANKSTRING:(!(o=c?c.fromJSON?c.fromJSON(f,this):{error:new Error("Unable to convert data.")}:{error:new Error("Data format not recognized.")}).error&&u.error&&(o.error=u.error),t?o:o.data)},t.dataReady=function(e){return e?this.__state.dataAvailable:this.__state.dataReady},t.setChartAttribute=function(e,t){var r,n,a,o,s=e;if("string"==typeof s)(s={})[arguments[0]]=t;else if(null===s||"object"!=typeof s)return;for(n in o=0,(a=(r=this.getChartData("json")).chart||r.graph||r.map)||(a={},r=Object.assign({chart:a},r)),s)o+=1,null!==s[n]?a[n.toLowerCase()]=s[n]:delete a[n.toLowerCase()];o>0&&("undefined"==typeof a.animation&&(a.animation=i.ZEROSTRING),this.setChartData(r,"json"))},t.getChartAttribute=function(e){var t,r,n=this.getChartData("json"),a=n&&(n.chart||n.graph||n.map);if(0===arguments.length||void 0===e||void 0===a||null===e)return a;if("string"==typeof e)t=a[e.toString().toLowerCase()];else if(e instanceof Array)for(t={},r=0;r<e.length;r+=1)t[e[r]]=a[e[r].toString().toLowerCase()];else(0,o.raiseError)(this,"25081429","param","~getChartAttribute()",'Unexpected value of "attribute"');return t},t.render=function(e,t,r){var n=e||M,a=t||M,i=r||M;return this.disposed||(this.__state.beforeRenderFired=!1,this._addChartDependency("chartContainer",{scopeOf:this,opts:{containerElement:n,insertMode:a,callback:i},resolve:Me}),this.__state.renderInvoked=!0,this.__state.isDrawInvoked=!0),this._setState(),this},t._renderChart=function(e,t,r,n,a,i){if(void 0===i&&(i=!1),!this.disposed){var s,l=this,c=function(){!0!==l.disposed&&l._render(e,t,r&&function(){if(r)try{r.call(l,l.options.containerElement)}catch(e){setTimeout((function(){throw e}))}},n,a)};return i||this.__state.beforeRenderFired?c():(this.__state.beforeRenderFired=!0,(0,o.triggerEvent)("beforeRender",this,s={container:l.options.containerElement,width:this.width,height:this.height,renderer:this.options.renderer},M,c,(function(){(0,o.triggerEvent)("renderCancelled",l,s),this.__state.renderInvoked=!1}))),this}},t._render=function(t,r,n,a,i){var s=this;s.apiInstance&&s.apiInstance.removeJob("resizeScheduled"),s.__state.beforedrawFired?((0,u["default"])(e,s,t,r,n,a,i),s.__state.beforedrawFired=!0):(0,o.triggerEvent)("beforedraw",s,{},M,(function(){(0,u["default"])(e,s,t,r,n,a,i)}),(function(){(0,o.triggerEvent)("drawCancelled",s),this.__state.isDrawInvoked=!1}))},t.resizeTo=function(e,t,r){var n=this,a=n.width,i=n.height,s=n.__state,l=r,c=t,u=e;return(n.apiInstance&&n.apiInstance.config||{}).resize=!0,null!==u&&"object"==typeof u&&(l=c,c=u.h,u=u.w),u=null==u?a:u.toString().replace(z,""),c=null==c?i:c.toString().replace(z,""),!0!==l&&(0,o.triggerEvent)("beforeresize",n,{currentWidth:a,currentHeight:i,newWidth:u,newHeight:c},M,(function(){n.width=u,n.height=c,n.scheduleResize({width:u,height:c}),n.apiInstance&&n.apiInstance.addJob("resized"+ce++,(function(){(0,o.triggerEvent)("resized",n,{id:n.id,width:n.width,height:n.height,prevWidth:a,prevHeight:i,pixelWidth:n.ref&&n.ref.offsetWidth||0,pixelHeight:n.ref&&n.ref.offsetHeight||0,originalWidth:s.renderedWidth,originalHeight:s.renderedHeight})}),f.priorityList.postRender)}),(function(){(0,o.triggerEvent)("resizecancelled",n,{currentWidth:a,currentHeight:i,cancelledTargetWidth:u,cancelledTargetHeight:c})})),this},t.dispose=function(){var t=this,r={},n=function(t){for(var n in t._dispose(),t._addChartDependency("dispose",{resolve:function(){return{state:0}}}),t._setState(),(0,o.triggerEvent)("disposed",t,r),(0,o.disposeEvents)(t),delete e.items[t.id],t)t.hasOwnProperty(n)&&delete t[n];return t.disposed=!0,{state:0}};(0,o.triggerEvent)("beforeDispose",t,r,M,(function(){t._addChartDependency("dispose",{scopeOf:t,resolve:n})}),(function(){(0,o.triggerEvent)("disposeCancelled",t,r)}))},t._dispose=function(){var e,t=this.jsVars;this.apiInstance&&(this.apiInstance.removeJob("resizeScheduled"),this.apiInstance.remove({instant:!0}),delete this.apiInstance,delete t.instanceAPI),(e=window[this.id])&&(!function r(e){var t,n,a,i=e.attributes;if(i)for(t=i.length-1;t>=0;t-=1)"function"==typeof e[a=i[t].name]&&(e[a]=null);if(i=e.childNodes)for(n=i.length,t=0;t<n;t+=1)r(e.childNodes[t])}(e),e.parentNode&&e.parentNode.removeChild(e)),t.container=null},t._config=function(e,t){var r,n,a=e,i=this,o=i.jsVars,s=o.msgStore,l=o.cfgStore,c=i.options;for(r in n={LoadingText:"loadMessage",ChartNotSupported:"typeNotSupportedMessage",RenderChartErrorText:"renderErrorMessage",XMLLoadingText:"dataLoadStartMessage",ChartNoDataText:"dataEmptyMessage",LoadDataErrorText:"dataLoadErrorMessage",InvalidXMLText:"dataInvalidMessage"},"string"==typeof a&&arguments.length>1&&(r=a,(a={})[r]=t),a)"undefined"!=typeof s[r]?s[r]=a[r]:l[r.toLowerCase()]=a[r],n[r]?c[n[r]]=a[r]:c[r]=a[r]},t.configure=function(e,t){var r;e&&("string"==typeof e?(r={})[e]=t:r=e,this._config(r))},t.print=function(e){var t=this.apiInstance,r=(0,i.extend2)({},e);if(t.config.isPrinting||!t.config.hasRendered)return!1;(0,o.triggerEvent)("BeforePrint",this,r,M,(function(){var e,n,a,s,l=t.getFromEnv("chart-container"),c=[],u=l.parentNode,d=document.body||document.getElementsByTagName("body")[0],f=d.childNodes;if(t.config.isPrinting=!0,(0,i.fcEach)(f,(function(e,t){1===e.nodeType&&(c[t]=e.style.display,e.style.display="none")})),!1!==r.hideButtons&&(s=t.getChildren("chartMenuBar")))for(a=0,e=(n=s[0].getChildren("tool")).length;a<e;a++)n[0].getChildren("listContainer")[0].hide();d.appendChild(l),window.print(),setTimeout((function(){u.appendChild(l),(0,i.fcEach)(f,(function(e,t){1===e.nodeType&&(e.style.display=c[t])})),r.hideButtons,t.config.isPrinting=!1,(0,o.triggerEvent)("PrintComplete",t.getFromEnv("chartInstance"),r)}),1e3)}),(function(){(0,o.triggerEvent)("PrintCancelled",t.getFromEnv("chartInstance"),r)}))},t.getSVGString=function(e,t){var r,n=this.apiInstance,a=n&&n.getFromEnv("paper");if(t&&t.keepImages&&(r=!0),"function"!=typeof e)return(new XMLSerializer).serializeToString(a.canvas);n.addJob("getSVG",(function(){e(a&&a.toSVG&&a.toSVG(r))}),f.priorityList.postRender)},t.lockResize=function(e){return"boolean"!=typeof e?!!this.jsVars.resizeLocked:this.jsVars.resizeLocked=e},t.showChartMessage=function(e,t,r,n){var a=e||M,i=t||M,o=r||M,s=n||{},l=this,c=l.apiInstance,u=function(){l._showChartMessage(a,i,o,s)};return c&&("base"===c.getName()?l.addEventListener("renderComplete",u):u()),a},t._showChartMessage=function(e,t,r,n){void 0===n&&(n={});var a,o=this,s=e,l=o.jsVars,c=o.apiInstance,u=o.options;c._hideChartMessage(),void 0!==s?(a={fontFamily:(0,i.pluck)(n.font,u.baseChartMessageFont,"Verdana,sans"),fontSize:(0,i.pluck)(n.fontSize,u.baseChartMessageFontSize,10),color:(0,i.pluck)(n.color&&(0,i.convertColor)(n.color,n.alpha),u.baseChartMessageColor)},l.msgStore[s]&&(s=l.msgStore[s]),c.addJob("showMsg",(function(){t&&c&&c.config.hasRendered?(c._show&&c._show(),o.showMessage(s,a,r)):(c._hide&&c._hide(),c.setChartMessage(s,{_chartMessageStyle:a}),c.drawChartMessage())}),f.priorityList.postRender)):o.hideChartMessage()},t._resize=function(){var e=this.apiInstance,t=this.jsVars.container;this.__state.resize=!0,e?(e.config.elScroll=!1,e.getFromEnv("animationManager").setAnimationState("resize"),e.addToEnv("chartWidth",t.offsetWidth),e.addToEnv("chartHeight",t.offsetHeight),this.args.dataSource&&(this.args.dataSource.data||this.args.dataSource.dataset)&&this._addChartDependency("resize",{resolve:function(){return{state:3}}})):this._addChartDependency("resize",{resolve:function(){return{state:1}}}),this._setState(),this.__state.resize=!1},t.hideChartMessage=function(){var e=this.apiInstance;e._hideChartMessage(),e._show&&e._show()},t.showMessage=function(e,t,r){void 0===e&&(e="");var n,a,o,s=this.apiInstance,l=s.config,c=s.getFromEnv("paper"),u=s.getFromEnv("smartLabel"),d=s.getFromEnv("animationManager"),f=s.getGraphicalElement("messageText"),h=s.getGraphicalElement("messageVeil"),g=c.width,p=c.height;a=s.getChildContainer("messageGroup"),d.setAnimationState("showmessage"),(n=d.setAnimation({el:a||"group",attr:{name:"messageGroup"},component:s,label:"group"})).show().toFront(),a||s.addChildContainer("messageGroup",n),(h=d.setAnimation({el:h||"rect",attr:{x:0,y:0,width:g,height:p,fill:"rgba(0,0,0,0.2)",stroke:"none"},container:n,component:s,label:"rect"})).off("fc-click",n.hide),h.show().toFront().attr("cursor",r?i.POINTER:"default"),r&&h.on("fc-click",s._hideChartMessage,s),s.addGraphicalElement("messageVeil",h),u.setStyle(t),o=u.getSmartText(e,g-(l.marginRight||0)-(l.marginLeft||0),p-(l.marginTop||0)-(l.marginBotton||0)),(f=d.setAnimation({el:f||"text",attr:{"font-size":t.fontSize,"font-family":t.fontFamily,fill:t.color,text:o.text,"line-height":14,x:g/2,y:p/2},container:n,component:s,label:"text"})).attr("cursor",r?i.POINTER:"default")[r?"click":"unclick"](s._hideChartMessage,s).show().toFront(),s.addGraphicalElement("messageText",f)},t.scheduleResize=function(e){var t,r=this,n=r.ref;n&&(r._addChartDependency("resize",{resolve:function(){return{state:2}}}),r.apiInstance.addJob("resizeScheduled",(function(){t=(0,i.normalizeCSSDimension)(e.width,e.height,n),"undefined"!=typeof e.width&&(n.style.width=t.width),"undefined"!==e.height&&(n.style.height=t.height),r._resize()}),f.priorityList.instant))},e}();Fe.id="FusionCharts",Fe.options={html5ScriptNameSuffix:".js",html5ScriptNamePrefix:"fusioncharts.","export":{useCanvas:!1},scriptBaseUri:(De=function(e){var t,r,n=window.document.getElementsByTagName("script"),a=n.length;for(r=0;r<a;r+=1)if(null!=(t=n[r].getAttribute("src"))&&null!==t.match(e))return t.replace(e,"$1")}(j),void 0===De?((0,o.raiseError)(Fe,"1603111624","run",">GenericRuntime~scriptBaseUri","Unable to locate FusionCharts script source location (URL)."),""):De),set creditLabel(e){console.warn("FusionCharts.options.creditLabel property is deprecated. Please use FusionCharts.options.license with a valid license key to remove the watermark.")},license:function(e){e&&C["default"].storeObj(Fe,e)}},r.p=Fe.getScriptBaseURI(),Fe.version=F.split(/[\.\-]/g),Fe.versionDetails=[Fe.version,I],Fe.items={},(0,o.setRootSender)(Fe),T=!1,i.hasSVG||Fe.addDep({name:"vml",type:"dependency",extension:r.e(16).then(r.t.bind(null,1264,7))}),setTimeout((function(){T=!0,(0,o.triggerEvent)("ready",Fe,{version:Fe.version,now:!0})}),1),Fe.addEventListener("dependencyAdded",(function(e,t){if("maps"===t.type){var r={};r[t.name]=["fusioncharts.maps.js"],Fe.getDep("dependency")||Fe.addDep({name:"dependency",extension:r})}})),Fe.addEventListener("initialized",(function Re(){Fe.removeEventListener("initialized",Re),D=new d["default"](document.body||document.getElementsByTagName("body")[0]),u.globalStore.addToEnv("smartLabel",D)})),Fe.addDep(h["default"]),Fe.addDep(m["default"]),Fe.addDep(w["default"]),Fe.addDep(v["default"]),Fe.addDep(b["default"]),Fe.addDep(y["default"]),Fe.addDep(x["default"]);var Ie=Fe;t["default"]=Ie},function(e,t){e.exports=function(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e},e.exports["default"]=e.exports,e.exports.__esModule=!0},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.isInterActiveEvt=function(e){return!!xe[e]},t.addInterActiveEvtName=function(e){e&&e.toLowerCase&&(xe[e.toLowerCase()]=!0)},t.getMouseCoordinate=function(e,t,r){var n,a,i,o=N.webkitIsFullScreen||N.mozFullScreen||N.msFullscreenElement||N.fullscreenElement,s=fe(Se(t)),l=o?s.clientX:s.pageX,u=o?s.clientY:s.pageY,h=r&&r.config||{},g=t.type,p=h&&h.itemFixed,m=(0,c["default"])(h.applycsstransform,0),v=p?_.pageYOffset||_.scrollY||N.documentElement.scrollTop:0,b=p?_.pageXOffset||_.scrollX||N.documentElement.scrollLeft:0;h.elScroll&&h.posOb&&!m?i=h.posOb:(h.elScroll=!0,i=_e(e),h.posOb=i);"touchend"===g?(isNaN(l)&&(l=d),isNaN(u)&&(u=f)):"touchmove"!==g&&"touchstart"!==g||(d=l,f=u);if(n=l-i.left-b,a=u-i.top-v,m){var y=function(e,t){var r,n,a,i,o,s,l=t.x,c=t.y,u=e,d=[],f=0,h=0,g=!1,p=0,m=0;do{if(r=window.getComputedStyle(u),"BODY"===u.tagName||"auto"!==r.getPropertyValue("overflow")&&"scroll"!==r.getPropertyValue("overflow")||(u.scrollHeight>u.offsetHeight&&(p+=u.scrollTop),u.scrollWidth>u.offsetWidth&&(m+=u.scrollLeft)),r.getPropertyValue("transform")&&"none"!==r.getPropertyValue("transform")){var v=r.getPropertyValue("transform-origin").split(" ").map((function(e){return+e.replace(/px/gi,"")}));if(n=v[0],a=v[1],6===(i=r.getPropertyValue("transform").split("(")[1].split(")")[0].split(",").map((function(e){return parseFloat(e.trim())}))).length){var b=i,y=b[0],x=b[1],w=b[2],C=b[3],k=b[4],_=b[5];f=0,h=0,s=u;do{f+=s.offsetLeft,h+=s.offsetTop,s=s.offsetParent}while(s);d.push({elem:u,oriX:n,oriY:a,invM:Ie([y,w,k,x,C,_]),matrix:[y,w,k,x,C,_],offsetLeft:f,offsetTop:h}),g=!0}}u=u.parentElement}while(u);l+=m,c+=p,f=0,h=0,s=e;do{f+=s.offsetLeft,h+=s.offsetTop,s=s.offsetParent}while(s);if(g)for(;u=d.pop();)l-=u.offsetLeft,c-=u.offsetTop,o=Oe({x:l,y:c},{oriX:u.oriX,oriY:u.oriY},u.invM),l=o.x+u.offsetLeft,c=o.y+u.offsetTop;return{x:l-=f,y:c-=h}}(e,{x:l,y:u});n=y.x,a=y.y}return{chartX:n,chartY:a,pageX:l,pageY:u,clientX:s.clientX,clientY:s.clientY}},t.getTouchEvent=Se,t.imprint=function(e,t,r){var n,a=e;if("object"!=typeof a||null===a)return a=t,t;if("object"!=typeof t||null===t)return a;for(n in t)(a[n]===u||!r&&null===a[n])&&(a[n]=t[n]);return a},t.pluck=Fe,t.computeFontSize=function(e){var t,r,n=parseFloat(e),a=function(e){if(e&&"string"==typeof e)return ae.find((function(t){return e.indexOf(t)>-1}))||"px";return"px"}(e),i=this.getLinkedParent(),o=parseInt(window.getComputedStyle(document.documentElement,null).fontSize,10);if("px"===a)return n;switch(a){case"em":t=(t=i.config.style?i.config.style.fontSize:u)||i.config.baseFontSize||o,n*=t;break;case"rem":n*=o;break;case"vw":r=Math.max(document.documentElement.clientWidth||0,window.innerWidth||0),n=n/100*r;break;case"%":t=(t=i.config.style?i.config.style.fontSize:u)||i.config.baseFontSize||o,n=n/100*t}return n},t.getFirstDefinedValue=function(){var e,t,r;for(t=0,r=arguments.length;t<r;t+=1)if((e=arguments[t])||!1===e||0===e||""===e)return e;return u},t.hashify=function(e){return e&&e.replace(/^#?([a-f0-9]+)/gi,"#$1")||"none"},t.dehashify=function(e){return e&&e.replace(/^#?([a-f0-9]+)/gi,"$1")||"none"},t.getComparatorFN=function(e,t){if(e)return t?function(e,r){return e[t]-r[t]}:Be;return t?function(e,r){return r[t]-e[t]}:ze},t.pluckFontSize=function(){var e,t,r;for(t=0,r=arguments.length;t<r;t+=1)if(((e=arguments[t])||!1===e||0===e)&&!isNaN(e=Number(e)))return e<1?1:e;return 1},t.pluckFontSizeMaintainUnit=De,t.getValidValue=Me,t.getPosition=_e,t.bindSelectionEvent=function(e,t){var r=t||{},n=e.config,a=e.getFromEnv("chart-container"),s=n.zoomType,l=(0,o["default"])({},r.attr||{}),u=l["stroke-width"]=(0,c["default"])(l.strokeWidth,l["stroke-width"],1),d=e.eventListeners||(e.eventListeners=[]),f=_e(a);r=(0,o["default"])({chart:e,zoomX:/x/.test(s),zoomY:/y/.test(s),canvasY:n.canvasTop,canvasX:n.canvasLeft,canvasW:n.canvasWidth,canvasH:n.canvasHeight,canvasX2:n.canvasLeft+n.canvasWidth,canvasY2:n.canvasTop+n.canvasHeight,strokeWidth:u,chartPosLeft:f.left,chartPosTop:f.top,attr:l},r),l.stroke=Ne(l.stroke,"rgba(51,153,255,0.8)"),l.fill=Ne(l.fill,"rgba(185,213,241,0.3)"),a&&(i["default"].unlisten(a,"pointerdrag",Ee),d.push(i["default"].listen(a,"pointerdrag",Ee,r)));n.link&&(i["default"].unlisten(e.getFromEnv("chart-container"),"mouseup mousedown",Ae),d.push(i["default"].listen(e.getFromEnv("chart-container"),"mouseup mousedown",Ae,r)))},t.fcEach=function(e,t,r,n){var a,i=r,o=n;i||(i=e);o||(o={});if(de(e)){for(a=0;a<e.length;a+=1)if(!1===t.call(i,e[a],a,e,o))return a}else if(null!==e&&e!==u)for(a in e)if(!1===t.call(i,e[a],a,e,o))return a},t.getDefinedColor=function(e,t){return e||0===e||""===e?e:t},t.getFirstValue=Ne,t.getColorCodeString=function(e,t){var r,n,a="",i=0,o=t.split(",");for(n=o.length;i<n;i+=1)2===(r=o[i].split("-")).length?"-1"!==r[0].indexOf("dark")?a+=(0,s.getLightColor)(e,100-parseInt(r[1],10))+",":a+=(0,s.getDarkColor)(e,100-parseInt(r[1],10))+",":a+=o[i]+",";return a.substring(0,a.length-1)},t.clampNumber=function(e,t,r){void 0===t&&(t=-Infinity);void 0===r&&(r=Infinity);if(e<=t)return t;if(e>=r)return r;return e},t.fastTrim=function(e){var t=e.replace(/^\s\s*/,""),r=t.length;for(;/\s/.test(t.charAt(r-=1)););return t.slice(0,r+1)},t.parseUnsafeString=function(e,t){void 0===t&&(t=!0);var r=-1;if("string"==typeof e)return t?e.replace(/<|>|\'|\"/g,(function(e,t,n){switch(e){case"<":return/^<br\s*[\/]?>/gi.test(n.slice(t,n.length))?(r=t,e):"&lt;";case">":return r>=0&&/<br\s*[\/]?>$/gi.test(n.slice(r,t+1))?(r=-1,e):"&gt;";case'"':return"&#034;";case"'":return"&#039;"}})).replace(H,"<br />"):e.replace(H,"<br />");return""},t.toPrecision=Pe,t.regescape=function(e){return e&&e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&")},t.regReplaceEscape=Te,t.getImageURL=function(e){var t={image:!1},r=e;r!==u&&(r=r.replace(/^\s+/,"").replace(/\s+$/,""),/^i\s*[\-]\s*/i.test(r)?(t.image=!0,t.string=r.replace(/^i\s*[\-]\s*/i,"")):t.string=r.replace(/^\\/,""));return t},t.getCripValues=t.getCrispValue=function(e,t,r){var n=r%2/2,a=Y(e+n)-n,i=Y(e+t+n)-n-a;return{position:a,distance:i}},t.stableSort=function(e,t){var r,n=e.length;for(r=0;r<n;r++)e[r].ssI=r;for(e.sort((function(e,r){var n=t(e,r);return 0===n?e.ssI-r.ssI:n})),r=0;r<n;r++)delete e[r].ssI},t.getLinkAction=function(e,t){return function(r){if(!r||!t.config.clickURLOverridesPlotLinks){var n,a,i,o,s,l,d,f,h,g,p=e.chart||e.map||{},m=(0,c["default"])(p.unescapelinks,1),v=this.entity||u,b=this.entityBox||u,y=this.link,x=y;if(y!==u){switch(m&&(y=_.decodeURIComponent?_.decodeURIComponent(y):_.unescape(y)),-1!==(y=y.replace(/^\s+/,"").replace(/\s+$/,"")).search(/^[a-z]*\s*[\-\:]\s*/i)&&(g=(s=y.split(/\s*[\-\:]\s*/)[0].toLowerCase()).length),r&&(t.config.hotElemClicked=!0),s){case"j":case"javascript":Re(y);break;case"n":y.replace(/^n\s*\-/i,"n-"),_.open(y.slice(2));break;case"f":-1!==(n=(y=y.replace(/^f\s*\-/i,"f-")).indexOf("-",2))?(a=y.substr(2,n-2))&&_.frames[a]?_.frames[a].location=y.slice(n+1):_.open(y.slice(n+1),a):_.open(y.slice(2));break;case"p":n=(y=y.replace(/p\s*\-/i,"p-")).indexOf("-",2),i=y.indexOf(",",2),-1===n&&(n=1),o=y.slice(n+1),(h=_.open(o,y.substr(2,i-2),y.substr(i+1,n-i-1)))&&h.focus();break;case"newchart":case"newmap":switch(":"===y.charAt(g)&&(n=y.indexOf("-",g+1),f=y.substring(g+1,n),g=n),n=y.indexOf("-",g+1),l=y.substring(g+1,n).toLowerCase()){case"xmlurl":case"jsonurl":d=y.substring(n+1,y.length);break;case"xml":case"json":d=function(e,t){var r,n={chart:{}},a=t,i=e.toLowerCase();if(a.linkeddata)for(r=0;r<a.linkeddata.length;r+=1)a.linkeddata[r].id.toLowerCase()===i&&(n=a.linkeddata[r].linkedchart||a.linkeddata[r].linkedmap);return n}(y.substring(n+1,y.length),e),l="json"}t.fireChartInstanceEvent("linkedChartInvoked",{alias:f,linkType:l.toUpperCase(),data:d,clickedEntity:v,clickedEntityBox:b});break;default:_.location.href=y}t.fireChartInstanceEvent("linkClicked",{linkProvided:x,linkInvoked:y,linkAction:s&&s.toLowerCase()})}}}},t.setImageDisplayMode=function(e,t,r,n,a,i,o,s){var c=s.width*(n/100),u=s.height*(n/100),d=i-2*a,f=o-2*a;return(0,l.getAlignImage)(t,r,e,c,u,i,o,a,d,f)},t.setLineHeight=je,t.parsexAxisStyles=function(e,t,r,n,a){var i,o=Ne(e.labelbordercolor,t.bordercolor,r.labelbordercolor,""),l=Fe(e.labelbgcolor,t.bgcolor,r.labelbgcolor),u=(0,c["default"])(e.labelborderthickness,t.borderthickness,r.labelborderthickness,1),d=(0,c["default"])(r.usedataplotcolorforlabels,0)&&a||n.color;return o=o?(0,s.convertColor)(o,(0,c["default"])(e.labelborderalpha,t.borderalpha,r.labelborderalpha,e.labelalpha,t.alpha,r.labelalpha,100)):"",(i={fontFamily:Fe(e.labelfont,t.font,r.labelfont,n.fontFamily),fontSize:Fe(e.labelfontsize,t.fontsize,this.computeFontSize(r.labelfontsize),parseInt(n.fontSize,10))+"px",fontSizeWithUnit:De(e.labelfontsize,t.fontsize,r.labelfontsize,n.fontSizeWithUnit),color:(0,s.convertColor)(Fe(e.labelfontcolor,t.fontcolor,r.labelfontcolor,d),(0,c["default"])(e.labelfontalpha,t.fontalpha,r.labelfontalpha,e.labelalpha,t.alpha,r.labelalpha,100)),fontWeight:(0,c["default"])(e.labelfontbold,t.fontbold,r.labelfontbold)?"bold":"normal",fontStyle:(0,c["default"])(e.labelfontitalic,t.fontitalic,r.labelfontitalic)?"italic":"normal",border:o||l?u+"px solid":"",borderColor:o,borderThickness:u,borderPadding:(0,c["default"])(e.labelborderpadding,t.borderpadding,r.labelborderpadding,2),borderRadius:(0,c["default"])(e.labelborderradius,t.borderradius,r.labelborderradius,0),backgroundColor:l?(0,s.convertColor)(l,(0,c["default"])(e.labelbgalpha,t.bgalpha,r.labelbgalpha,e.labelalpha,t.alpha,r.labelalpha,100)):"",borderDash:(0,c["default"])(e.labelborderdashed,t.borderdashed,r.labelborderdashed,0)?Ve((0,c["default"])(e.labelborderdashlen,t.borderdashlen,r.labelborderdashlen,4),(0,c["default"])(e.labelborderdashgap,t.borderdashgap,r.labelborderdashgap,2)):"none"}).lineHeight=je(i),i},t.getDashStyle=Ve,t.componentDispose=function He(){var e,t,r,n,a,i,o,s,l,c,u,d;if(this&&this!==_){if(this.disposing=!0,e=this.components)for(r in e)if((t=e[r])instanceof Array)for(n=t.length,a=0;a<n;a++)(d=t[a])&&!this.disposing&&(d.dispose?d.dispose():He.call(d));else t&&!t.disposing&&(t.dispose?t.dispose():He.call(t));for(s in i=this.graphics)if(o=i[s])if(o.hide)o.hide(),o.followers&&o.followers[0]&&(u=o.followers[0].el)&&u.hide&&u.hide();else for(l in o)(c=o[l]).hide&&c.hide();for(r in this)delete this[r]}},t.executeJS=Le,t.pseudoEval=Re,t.getContainerBackgroundColor=function(e){var t=e.options,r=t.containerBackgroundColor,n=t.containerBackgroundOpacity;ke(e.jsVars.transparent)?n=e.jsVars.transparent?0:1:(n=parseFloat(n))<0?n=0:n>1&&(n=1);r||(r="#FFFFFF");if(F&&!M)return n?r:"transparent";return r=r.replace(/^#?([a-f0-9]+)/gi,"$1"),(r=(0,s.HEXtoRGB)(r))[3]=n.toString(),"rgba("+r.join(",")+")"},t.capitalizeString=function(e,t){return e?e.replace(t?/(^|\s)([a-z])/g:/(^|\s)([a-z])/,(function(e,t,r){return t+r.toUpperCase()})):e},t.pInt=function(e,t){return parseInt(e,t||10)},t.defined=ke,t.trimString=function(e){var t=e.replace(/^\s\s*/,""),r=t.length;for(;/\s/.test(t.charAt(r-=1)););return t.slice(0,r+1)},t.getSuggestiveRotation=function(){var e,t,r,n;e=arguments[0],1===arguments.length?(t=e.angle,r=e.x,n=e.y):(t=e,r=arguments[1],n=arguments[2]);return"r"+(t=t||0)+","+r+","+n},t.normalizeCSSDimension=function(e,t,r){var n,a=void 0===e?r.offsetWidth||parseFloat(r.style.width):e,i=void 0===t?r.offsetHeight||parseFloat(r.style.height):t,o={},s=r.style;if(s.width=a=a.toString?a.toString():"0",s.height=i=i.toString?i.toString():"0",(o.widthIsRelative=a.match(/^\s*\d*\.?\d*\%\s*$/)&&!a.match(/^\s*0\%\s*$/))&&0===r.offsetWidth)for(n=r;n=n.offsetParent;)if(n.offsetWidth>0){a=(n.offsetWidth*parseFloat(a.match(/\d*/)[0])/100).toString();break}if((o.heightIsRelative=i.match(/^\s*\d*\.?\d*\%\s*$/)&&!i.match(/^\s*0\%\s*$/))&&r.offsetHeight<=20)for(n=r;n=n.offsetParent;)if(n.offsetHeight>0){i=(n.offsetHeight*parseFloat(i.match(/\d*/)[0])/100).toString();break}return o.width=a.replace?a.replace(/^\s*(\d*\.?\d*)\s*$/gi,"$1px"):a,o.height=i.replace?i.replace(/^\s*(\d*\.?\d*)\s*$/gi,"$1px"):i,s.width=o.width,s.height=o.height,o.pixelWidth=o.widthIsRelative?r.offsetWidth:parseInt(o.width,10)||0,o.pixelHeight=o.heightIsRelative?r.offsetHeight:parseInt(o.height,10)||0,o},t._manageInteractiveSpace=function(){var e,t,r,n,a,i,o=this.config,s=this.getChildren(),l=s.xAxis[0],c=s.yAxis[0],u=s.canvas&&s.canvas[0],d=u.config,f=d.canvasBorderWidth,h=d.canvasPaddingTop,g=d.canvasPadding||0,p=d.canvasPaddingLeft,m=o.xAxisSpaceAllocation,v=o.yAxisSpaceAllocation[0].spaceTaken;t=o.xAxisSpaceAllocation=l.placeAxis(o.availableHeight+m.bottom),r=o.yAxisSpaceAllocation[0].spaceTaken=c.placeAxis(o.availableWidth+v.left),e=t.bottom-m.bottom,a=t.top-m.top,n=r.left-v.left,i=r.right-v.right,e&&this._allocateSpace({top:a,bottom:e}),(n||i)&&this._allocateSpace({left:n,right:i}),l&&l.setAxisDimention({x:o.canvasLeft+Math.max(p,g),y:l.config.isOpposit?o.canvasTop-f:o.canvasBottom+f,opposite:l.config.isOpposit?o.canvasBottom+f:o.canvasTop-f,axisLength:o.canvasWidth-Math.max(p,g)-Math.max(d.canvasPaddingRight,g)}),c&&c.setAxisDimention({x:c.config.isOpposit?o.canvasRight+f:o.canvasLeft-f,y:o.canvasTop+h,opposite:c.config.isOpposit?o.canvasLeft-f:o.canvasRight+f,axisLength:o.canvasHeight-h-d.canvasPaddingBottom}),(a||e||n||i)&&u.asyncDraw()},t.removeAllTooltipOnChart=function(e,t){for(var r=e.implicit,n=e.explicit,a=0;a<r.length;a++){var i=r[a];t?i.hide():i.element&&i.element.remove()}for(var o=0;o<n.length;o++){var s=n[o];t?s.hide():s.element&&s.element.remove()}},t.configureDataLabelStyle=function(e,t){void 0===e&&(e={});var r,n,a=t||this.config.JSONData,i=this.getFromEnv("chartConfig");return r=Fe(e.valuebordercolor,a.valuebordercolor,i.valueBorderColor),n=Fe(e.valuebgcolor,a.valuebgcolor,i.valueBgColor),{color:(0,s.convertColor)(Fe(e.valuefontcolor,a.valuefontcolor,i.valueFontColor),i.valueFontAlpha),borderColor:r?(0,s.convertColor)(r,i.valueBorderAlpha):"",backgroundColor:n?(0,s.convertColor)(n,i.valueBgAlpha):""}},t.convertToPixels=function(e,t){if(e&&isNaN(e)){var r=e.split("px");return 2===r.length?parseInt(r[0],10):2===(r=e.split("%")).length?Math.round(t*(parseInt(r[0],10)/100)):void 0}return parseInt(e,10)},t.FIT=t.FILL=t.TILE=t.COMMA=t.animationObjStr=t.configStr=t.ROUND=t.BLANK=t.POINTER=t.HAND=t.BOLD=t.NORMAL=t.mathRound=t.mathAbs=t.animHelperFN=t.xssEncode=t.MathExt=t.defaultGaugePaletteOptions=t.crispBound=t.canvasBorderColorStr=t.attrTypeBool=t.canvasBGAlphaStr=t.attrTypeNum=t.DASH_DEF=t.chartPaletteStr=t.TRACKER_FILL=t.appliedCSS=t.validhexcolor=t.chartAPI=t.getAxisLimits=t.supportedStyle=t.lineHeightFactor=t.isEdge=t.isIE9=t.isIE11=t.isIE=t.TXT_REGEX=t.hasSVG=t.stubFN=t.preDefStr=t.isArray=t.TXT_STRING=t.TXT_HREF=t.txtLabel=t.hasTouch=t.parseTooltext=t.gradientify=t.rgbaToHex=t.toRaphaelColor=t.getViewPortDimension=t.polyPathToPath=t.createElement=t.getEventCoordinate=t.regex=t.HOVER_THRESHOLD_PIXELS=t.CLICK_THRESHOLD_PIXELS=t.TOUCH_THRESHOLD_PIXELS=t.cleanColorCode=t.startsRGBA=t.visibleStr=t.hiddenStr=t.TEXTANCHOR=t.COMMASPACE=t.PXSTRING=t.HUNDREDSTRING=t.SHAPE_RECT=t.FC_CONFIG_STRING=t.INITIALSTR=t.FINALSTR=t.POSITION_END=t.POSITION_START=t.MIDDLESTR=t.POSITION_MIDDLE=t.POSITION_CENTER=t.POSITION_LEFT=t.POSITION_BOTTOM=t.POSITION_RIGHT=t.POSITION_TOP=t.POSITION_ABSOLUTE=t.STRINGUNDEFINED=t.DECIMALSTRING=t.ONESTRING=t.TESTSTR=t.SAMPLESTRING=t.ZEROSTRING=t.COMMASTRING=t.OBJECTSTRING=t.STRINGSTRING=t.BREAKSTRING=t.HASHSTRING=t.COLOR_TRANSPARENT=t.COLOR_WHITE=t.COLOR_GLASS=t.COLOR_BLACK=t.BLANKSTRING=t.UNDERSCORE=t.UNDEF=t.isFirefox=t.BLANKSTRINGPLACEHOLDER=t.getEmptyConstractor=void 0,t.removeHtmlAttrs=t.isSimilarObject=t.snapPoint=t.DEFAULT_FT_FONT=t.isIpad=t.domInsertModes=t.isXSSSafe=t.normalizeAngle=t.LINE_HEIGHT_FACTOR=t.PROJECT_VERSION=t.datasetFactory=t.componentFactory=t.dropHash=t.BGRATIOSTRING=t.VISIBLE=t.touchEnabled=t.MOUSEMOVE=t.MOUSEOUT=void 0;var a=r(225);t.attribDefs=a.attribDefs,t.parseConfiguration=a.parseConfiguration,t.setAttribDefs=a.setAttribDefs,t.hasAttribDefs=a.hasAttribDefs;var i=n(r(226)),o=n(r(227));t.extend2=o["default"];var s=r(228);t.convertColor=s.convertColor,t.getDarkColor=s.getDarkColor,t.getLightColor=s.getLightColor,t.mapSymbolName=s.mapSymbolName,t.getColumnColor=s.getColumnColor,t.getPointColor=s.getPointColor,t.getAngle=s.getAngle,t.parseColor=s.parseColor,t.getValidColor=s.getValidColor,t.RGBtoHex=s.RGBtoHex,t.rawRGBtoHEX=s.rawRGBtoHEX,t.HEXtoRGB=s.HEXtoRGB,t.parsePointValue=s.parsePointValue,t.getFirstColor=s.getFirstColor,t.getFirstAlpha=s.getFirstAlpha;var l=r(229),c=n(r(230));t.pluckNumber=c["default"];t.LINE_HEIGHT_FACTOR=1.2,t.PROJECT_VERSION="3.18.0";var u,d,f,h,g,p,m,v,b,y,x,w,C,k,_=window,S=function(){},E=(k=_.navigator.userAgent.toLowerCase(),!(!(C=-1!==k.indexOf("msie")&&_.parseInt(k.split("msie")[1]))||9!==C)),A=/Firefox/i.test(_.navigator.userAgent),N=_.document,T=_.navigator,M=Boolean(_.SVGAngle||N.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")),D=/trident/i.test(T.userAgent)&&/rv:11/i.test(T.userAgent)&&!window.opera,F=/msie/i.test(T.userAgent)&&!_.opera,I=/Edge/.test(T.userAgent),O=!!T.platform&&/iPad|iPhone|iPod/.test(T.platform),L=/[\\\"<>;&]/,R=/^[^\S]*?(sf|f|ht)(tp|tps):\/\//i,P="rgba(192,192,192,"+(F?.002:1e-6)+")",V="http://www.fusioncharts.com?BS=FCHSEvalMark&utm_source=FCS_trial&pver="+escape("3.18.0"),j="70|117|115|105|111|110|67|104|97|114|116|115|32|84|114|105|97|108".split("|").map((function(e){return String.fromCharCode(+e)})).join(""),B=parseFloat,z=/fusioncharts\.com|fusioncharts\.github\.io$/i,H=/\{br\}\s*/gi,U=/^#?/,G=/^rgba/i,W=/[#\s]/gi,$=Math.abs,X=Math.pow,Y=Math.round,q=X(2,-24),K="ontouchstart"in N,J=K&&!(T.maxTouchPoints||T.msMaxTouchPoints),Z=!z.test(_.location.hostname),Q=Math,ee=Q.max,te=Q.min,re={pageX:0,pageY:0},ne=["8BBA00","F6BD0F","FF654F","AFD8F8","FDB398","CDC309","B1D0D2","FAD1B9","B8A79E","D7CEA5","C4B3CE","E9D3BE","EFE9AD","CEA7A2","B2D9BA"],ae=["rem","em","vw","%","px"],ie={paletteColors:[ne,ne,ne,ne,ne],bgColor:["CBCBCB,E9E9E9","CFD4BE,F3F5DD","C5DADD,EDFBFE","A86402,FDC16D","FF7CA0,FFD1DD"],bgAngle:[270,270,270,270,270],bgRatio:["0,100","0,100","0,100","0,100","0,100"],bgAlpha:["50,50","60,50","40,20","20,10","30,30"],toolTipBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],toolTipBorderColor:["545454","545454","415D6F","845001","68001B"],baseFontColor:["555555","60634E","025B6A","A15E01","68001B"],tickColor:["333333","60634E","025B6A","A15E01","68001B"],trendDarkColor:["333333","60634E","025B6A","A15E01","68001B"],trendLightColor:["f1f1f1","F3F5DD","EDFBFE","FFF5E8","FFD1DD"],pointerBorderColor:["545454","60634E","415D6F","845001","68001B"],pointerBgColor:["545454","60634E","415D6F","845001","68001B"],canvasBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],canvasBgAngle:[0,0,0,0,0],canvasBgAlpha:["100","100","100","100","100"],canvasBgRatio:["","","","",""],canvasBorderColor:["545454","545454","415D6F","845001","68001B"],canvasBorderAlpha:[100,100,100,90,100],altHGridColor:["EEEEEE","D8DCC5","99C4CD","DEC49C","FEC1D0"],altHGridAlpha:[50,35,10,20,15],altVGridColor:["767575","D8DCC5","99C4CD","DEC49C","FEC1D0"],altVGridAlpha:[10,20,10,15,10],borderColor:["767575","545454","415D6F","845001","68001B"],borderAlpha:[50,50,50,50,50],legendBgColor:["ffffff","ffffff","ffffff","ffffff","ffffff"],legendBorderColor:["545454","545454","415D6F","845001","D55979"],plotFillColor:["767575","D8DCC5","99C4CD","DEC49C","FEC1D0"],plotBorderColor:["999999","8A8A8A","6BA9B6","C1934D","FC819F"],msgLogColor:["717170","7B7D6D","92CDD6","965B01","68001B"],TrendLightShadeOffset:30},oe={numDecimals:function(e){var t=e;t=Pe(t,10);var r=Pe((t=Math.abs(t))-Math.floor(t),10),n=String(r).length-2;return n=n<0?0:n,n},toRadians:function(e){return e/180*Math.PI},toDegrees:function(e){return e/Math.PI*180},flashToStandardAngle:function(e){return-1*e},standardToFlashAngle:function(e){return-1*e},flash180ToStandardAngle:function(e){var t=e,r=360-((t%=360)<0?t+360:t);return 360===r?0:r},getAngularPoint:function(e,t,r,n){var a=n*(Math.PI/180);return{x:e+r*Math.cos(a),y:t-r*Math.sin(a)}},remainderOf:function(e,t){return Math.ceil(e%t)},boundAngle:function(e){return e>=0?oe.prototype.remainderOf(e,360):360-oe.prototype.remainderOf(Math.abs(e),360)},toNearestTwip:function(e){var t=e,r=t<0?-1:1,n=Math.abs(t),a=Math.round(100*n),i=Math.floor(a/5);return r*((Number(String(a-5*i))>2?5*i+5:5*i)/100)},roundUp:function(e,t){var r=e,n=t;n=n||2;var a=Math.pow(10,n);return r*=a,r=Math.round(Number(String(r))),r/=a}},se=2*Q.PI,le={chart2D:{bgColor:"bgColor",bgAlpha:"bgAlpha",bgAngle:"bgAngle",bgRatio:"bgRatio",canvasBgColor:"canvasBgColor",canvasBaseColor:"canvasBaseColor",divLineColor:"divLineColor",legendBgColor:"legendBgColor",legendBorderColor:"legendBorderColor",toolTipbgColor:"toolTipbgColor",toolTipBorderColor:"toolTipBorderColor",baseFontColor:"baseFontColor",anchorBgColor:"anchorBgColor"},chart3D:{bgColor:"bgColor3D",bgAlpha:"bgAlpha3D",bgAngle:"bgAngle3D",bgRatio:"bgRatio3D",canvasBgColor:"canvasBgColor3D",canvasBaseColor:"canvasBaseColor3D",divLineColor:"divLineColor3D",divLineAlpha:"divLineAlpha3D",legendBgColor:"legendBgColor3D",legendBorderColor:"legendBorderColor3D",toolTipbgColor:"toolTipbgColor3D",toolTipBorderColor:"toolTipBorderColor3D",baseFontColor:"baseFontColor3D",anchorBgColor:"anchorBgColor3D"}},ce=M?0:.5,ue=["color"],de=function(){if(Array.isArray)return Array.isArray;var e=Object.prototype.toString;return function(t){return e.call(t)===e.call([])}}(),fe=function(e){return e.pageX===u&&(e.pageX=e.clientX+N.body.scrollLeft+N.documentElement.scrollLeft,e.pageY=e.clientY+N.body.scrollTop+N.documentElement.scrollTop),e},he=(b="innerWidth",y="innerHeight",x=N.documentElement||N.body,w=x,"innerWidth"in _?w=_:(b="clientWidth",y="clientHeight"),function(){return{width:w[b],height:w[y],scrollTop:x.scrollTop,scrollLeft:x.scrollLeft}}),ge=(v=/^@window_/g,function(e,t,r){var n,a,i,o,s=e.replace(/\[[\'\"]/g,".").replace(/[\'\"]\]/g,"").replace(/\[/g,".@window_").replace(/\]/g,"").split("."),l=_,c="";for(i=s.length,o=0;o<i;o+=1){if(n=l,(a=s[o]).match(v))l=l[_[a.replace(v,"")]];else{if(l===u||null===l)throw(c||a).replace(v,"")+" is not defined";l=l[a]}c=a}if(!l||"function"!=typeof l.call&&l!==_.alert){if("void"===c)return;setTimeout((function(){throw a.replace(v,"")+"() is not a function"}),0)}else l===_.alert?l(t):r?l.apply(n,t.split("__FC_ARG_SEP__")):l.call(n,t)}),pe=(m={},function(e){var t,r,n,a,i,o=e||this,l=o&&o.FCcolor||o,c=l.color,d=l.ratio,f=l.angle,h=l.alpha,g=l.r,p=l.cx,v=l.cy,b=l.fx,y=l.fy,x=l.gradientUnits,w=l.x1,C=l.y1,k=l.x2,_=l.y2,S=1;if("string"==typeof o)return m[i="~"+o]||(m[i]=o.replace(/^#?([a-f0-9]{3,6})/gi,"#$1"));if(!(c=c||""))return t;if(i=[c,h,d,f,g,p,v,x,b,y,w,k,C,_,l.radialGradient].join("_").replace(/[\(\)\s,\xb0#]/g,"_"),m[i])return m[i];if(d=d&&(d+"").split(",")||[],h=(h||0===h)&&(h+"").split(",")||[],c=c.split(","))if(t="",1===c.length)a=c[0].replace(/^#?([a-f0-9]{3,6})/gi,"$1"),t=h.length?"rgba("+(0,s.HEXtoRGB)(a).join(",")+","+.01*B(h[0])+")":a.replace(/^#?([a-f0-9]{3,6})/gi,"#$1");else{for(r=0,n=c.length;r<n;r++)a=c[r].replace(/^#?([a-f0-9]{3,6})/gi,"$1"),isNaN(d[r])||(d[r]=B(d[r]),a+=":"+d[r],isNaN(d[r+1])||(d[r+1]=B(d[r+1])+d[r])),isNaN(h[r])||""===h[r]||(S=.01*h[r]),c[r]="rgba("+(0,s.HEXtoRGB)(a).join(",")+","+S+")",isNaN(d[r])||(d[r]===d[r-1]&&(d[r]+=.001),c[r]=c[r]+":"+d[r]);t+=c.join("-"),g!==u||b!==u||p!==u||l.radialGradient?t="xr("+[b,y,g,p,v,x].join(",")+")"+t:(t="-"+t,w===u&&C===u&&k===u&&_===u||(t="("+[w,C,k,_,x].join(",")+")"+t),f===u&&(f=0),t=360-B(f)%360+t)}return m[i]=t,t}),me=function(){return""},ve=function(e,t){var r=this.argKey,n=Number(e.match(/\d+/g)[0]);return t[n]?t[n][r]:u},be=function(){var e,t=[{regex:/((^|[^\\])((\\)\\)*\$cleanvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$cleanvalue))/gi,argIndex:2,argKey:"cleanvalue"},{regex:/((^|[^\\])((\\)\\)*\$datavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$datavalue))/gi,argIndex:2,argKey:"formattedValue"},{regex:/((^|[^\\])((\\)\\)*\$value)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$value))/gi,argIndex:3,argKey:"value"},{regex:/((^|[^\\])((\\)\\)*\$label)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$label))/gi,argIndex:2,argKey:"label"},{regex:/((^|[^\\])((\\)\\)*\$seriesname)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$seriesname))/gi,argIndex:5,argKey:"seriesname"},{regex:/((^|[^\\])((\\)\\)*\$yaxisname)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$yaxisname))/gi,argIndex:2,argKey:"yaxisName"},{regex:/((^|[^\\])((\\)\\)*\$xaxisname)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$xaxisname))/gi,argIndex:2,argKey:"xaxisName"},{regex:/((^|[^\\])((\\)\\)*\$displayvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$displayvalue))/gi,argIndex:3,argKey:"displayvalue"},{regex:/((^|[^\\])((\\)\\)*\$xdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$xdatavalue))/gi,argIndex:2,argKey:"xDataValue"},{regex:/((^|[^\\])((\\)\\)*\$ydatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$ydatavalue))/gi,argIndex:2,argKey:"yDataValue"},{regex:/((^|[^\\])((\\)\\)*\$xvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$xvalue))/gi,argIndex:3,argKey:"x"},{regex:/((^|[^\\])((\\)\\)*\$yvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$yvalue))/gi,argIndex:3,argKey:"y"},{regex:/((^|[^\\])((\\)\\)*\$zvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$zvalue))/gi,argIndex:3,argKey:"z"},{regex:/((^|[^\\])((\\)\\)*\$name)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$name))/gi,argIndex:3,argKey:"name"},{regex:/((^|[^\\])((\\)\\)*\$percentValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$percentValue))/gi,argIndex:2,argKey:"percentValue"},{regex:/((^|[^\\])((\\)\\)*\$startValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$startValue))/gi,argIndex:2,argKey:"startValue"},{regex:/((^|[^\\])((\\)\\)*\$startDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$startDataValue))/gi,argIndex:2,argKey:"startDataValue"},{regex:/((^|[^\\])((\\)\\)*\$endValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$endValue))/gi,argIndex:2,argKey:"endValue"},{regex:/((^|[^\\])((\\)\\)*\$endDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$endDataValue))/gi,argIndex:2,argKey:"endDataValue"},{regex:/((^|[^\\])((\\)\\)*\$axisName)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$axisName))/gi,argIndex:2,argKey:"axisName"},{regex:/((^|[^\\])((\\)\\)*\$cumulativevalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$cumulativevalue))/gi,argIndex:2,argKey:"cumulativeValue"},{regex:/((^|[^\\])((\\)\\)*\$cumulativedatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$cumulativedatavalue))/gi,argIndex:2,argKey:"cumulativeDataValue"},{regex:/((^|[^\\])((\\)\\)*\$cumulativePercentValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$cumulativePercentValue))/gi,argIndex:2,argKey:"cumulativePercentValue"},{regex:/((^|[^\\])((\\)\\)*\$cumulativepercentdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$cumulativepercentdatavalue))/gi,argIndex:2,argKey:"cumulativePercentDataValue"},{regex:/((^|[^\\])((\\)\\)*\$sum)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$sum))/gi,argIndex:2,argKey:"sum"},{regex:/((^|[^\\])((\\)\\)*\$unformattedsum)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedsum))/gi,argIndex:2,argKey:"unformattedSum"},{regex:/((^|[^\\])((\\)\\)*\$targetvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$targetvalue))/gi,argIndex:2,argKey:"targetValue"},{regex:/((^|[^\\])((\\)\\)*\$targetdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$targetdatavalue))/gi,argIndex:2,argKey:"targetDataValue"},{regex:/((^|[^\\])((\\)\\)*\$processname)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$processname))/gi,argIndex:2,argKey:"processName"},{regex:/((^|[^\\])((\\)\\)*\$start)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$start))/gi,argIndex:2,argKey:"start"},{regex:/((^|[^\\])((\\)\\)*\$end)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$end))/gi,argIndex:2,argKey:"end"},{regex:/((^|[^\\])((\\)\\)*\$percentcomplete)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$percentcomplete))/gi,argIndex:2,argKey:"percentComplete"},{regex:/((^|[^\\])((\\)\\)*\$taskpercentcomplete)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$taskpercentcomplete))/gi,argIndex:2,argKey:"taskPercentComplete"},{regex:/((^|[^\\])((\\)\\)*\$taskstartdate)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$taskstartdate))/gi,argIndex:2,argKey:"taskStartDate"},{regex:/((^|[^\\])((\\)\\)*\$taskenddate)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$taskenddate))/gi,argIndex:2,argKey:"taskEndDate"},{regex:/((^|[^\\])((\\)\\)*\$tasklabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$tasklabel))/gi,argIndex:2,argKey:"taskLabel"},{regex:/((^|[^\\])((\\)\\)*\$date)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$date))/gi,argIndex:2,argKey:"date"},{regex:/((^|[^\\])((\\)\\)*\$percentofprevvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$percentofprevvalue))/gi,argIndex:2,argKey:"percentOfPrevValue"},{regex:/((^|[^\\])((\\)\\)*\$sname)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$sname))/gi,argIndex:2,argKey:"sName"},{regex:/((^|[^\\])((\\)\\)*\$lname)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$lname))/gi,argIndex:2,argKey:"lName"},{regex:/((^|[^\\])((\\)\\)*\$fromid)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromid))/gi,argIndex:2,argKey:"fromId"},{regex:/((^|[^\\])((\\)\\)*\$fromlabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromlabel))/gi,argIndex:2,argKey:"fromLabel"},{regex:/((^|[^\\])((\\)\\)*\$toid)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toid))/gi,argIndex:2,argKey:"toId"},{regex:/((^|[^\\])((\\)\\)*\$tolabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$tolabel))/gi,argIndex:2,argKey:"toLabel"},{regex:/((^|[^\\])((\\)\\)*\$fromxvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromxvalue))/gi,argIndex:2,argKey:"fromXValue"},{regex:/((^|[^\\])((\\)\\)*\$fromyvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromyvalue))/gi,argIndex:2,argKey:"fromYValue"},{regex:/((^|[^\\])((\\)\\)*\$fromxdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromxdatavalue))/gi,argIndex:2,argKey:"fromXDataValue"},{regex:/((^|[^\\])((\\)\\)*\$fromydatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromydatavalue))/gi,argIndex:2,argKey:"fromYDataValue"},{regex:/((^|[^\\])((\\)\\)*\$fromlabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromlabel))/gi,argIndex:2,argKey:"fromLabel"},{regex:/((^|[^\\])((\\)\\)*\$toxvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toxvalue))/gi,argIndex:2,argKey:"toXValue"},{regex:/((^|[^\\])((\\)\\)*\$toyvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toyvalue))/gi,argIndex:2,argKey:"toYValue"},{regex:/((^|[^\\])((\\)\\)*\$toxdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toxdatavalue))/gi,argIndex:2,argKey:"toXDataValue"},{regex:/((^|[^\\])((\\)\\)*\$toydatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toydatavalue))/gi,argIndex:2,argKey:"toYDataValue"},{regex:/((^|[^\\])((\\)\\)*\$tolabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$tolabel))/gi,argIndex:2,argKey:"toLabel"},{regex:/((^|[^\\])((\\)\\)*\$openvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$openvalue))/gi,argIndex:2,argKey:"openValue"},{regex:/((^|[^\\])((\\)\\)*\$closevalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$closevalue))/gi,argIndex:2,argKey:"closeValue"},{regex:/((^|[^\\])((\\)\\)*\$highvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$highvalue))/gi,argIndex:2,argKey:"highValue"},{regex:/((^|[^\\])((\\)\\)*\$lowvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$lowvalue))/gi,argIndex:2,argKey:"lowValue"},{regex:/((^|[^\\])((\\)\\)*\$opendatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$opendatavalue))/gi,argIndex:2,argKey:"openDataValue"},{regex:/((^|[^\\])((\\)\\)*\$closedatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$closedatavalue))/gi,argIndex:2,argKey:"closeDataValue"},{regex:/((^|[^\\])((\\)\\)*\$highdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$highdatavalue))/gi,argIndex:2,argKey:"highDataValue"},{regex:/((^|[^\\])((\\)\\)*\$lowdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$lowdatavalue))/gi,argIndex:2,argKey:"lowDataValue"},{regex:/((^|[^\\])((\\)\\)*\$maxvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$maxvalue))/gi,argIndex:2,argKey:"maxValue"},{regex:/((^|[^\\])((\\)\\)*\$maxdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$maxdatavalue))/gi,argIndex:2,argKey:"maxDataValue"},{regex:/((^|[^\\])((\\)\\)*\$minvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$minvalue))/gi,argIndex:2,argKey:"minValue"},{regex:/((^|[^\\])((\\)\\)*\$mindatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$mindatavalue))/gi,argIndex:2,argKey:"minDataValue"},{regex:/((^|[^\\])((\\)\\)*\$q1)/gi,argIndex:2,argKey:"Q1"},{regex:/((^|[^\\])((\\)\\)*\$unformattedQ1)/gi,argIndex:2,argKey:"unformattedQ1"},{regex:/((^|[^\\])((\\)\\)*\$q3)/gi,argIndex:2,argKey:"Q3"},{regex:/((^|[^\\])((\\)\\)*\$unformattedQ3)/gi,argIndex:2,argKey:"unformattedQ3"},{regex:/((^|[^\\])((\\)\\)*\$median)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$median))/gi,argIndex:2,argKey:"median"},{regex:/((^|[^\\])((\\)\\)*\$unformattedMedian)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedMedian))/gi,argIndex:2,argKey:"unformattedMedian"},{regex:/((^|[^\\])((\\)\\)*\$SD)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$SD))/gi,argIndex:2,argKey:"SD"},{regex:/((^|[^\\])((\\)\\)*\$unformattedsd)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedsd))/gi,argIndex:2,argKey:"unformattedsd"},{regex:/((^|[^\\])((\\)\\)*\$QD)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$QD))/gi,argIndex:2,argKey:"QD"},{regex:/((^|[^\\])((\\)\\)*\$unformattedQD)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedQD))/gi,argIndex:2,argKey:"unformattedQD"},{regex:/((^|[^\\])((\\)\\)*\$MD)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$MD))/gi,argIndex:2,argKey:"MD"},{regex:/((^|[^\\])((\\)\\)*\$unformattedMD)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedMD))/gi,argIndex:2,argKey:"unformattedMD"},{regex:/((^|[^\\])((\\)\\)*\$mean)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$mean))/gi,argIndex:2,argKey:"mean"},{regex:/((^|[^\\])((\\)\\)*\$unformattedMean)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedMean))/gi,argIndex:2,argKey:"unformattedMean"},{regex:/((^|[^\\])((\\)\\)*\$unformattedMean)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$unformattedMean))/gi,argIndex:2,argKey:"unformattedMean"},{regex:/((^|[^\\])((\\)\\)*\$volumeValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$volumeValue))/gi,argIndex:2,argKey:"volumeValue"},{regex:/((^|[^\\])((\\)\\)*\$volumeDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$volumeDataValue))/gi,argIndex:2,argKey:"volumeDataValue"},{regex:/((^|[^\\])((\\)\\)*\$fromXValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromXValue))/gi,argIndex:2,argKey:"fromXValue"},{regex:/((^|[^\\])((\\)\\)*\$fromYValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromYValue))/gi,argIndex:2,argKey:"fromYValue"},{regex:/((^|[^\\])((\\)\\)*\$fromXDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromXDataValue))/gi,argIndex:2,argKey:"fromXDataValue"},{regex:/((^|[^\\])((\\)\\)*\$fromYDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromYDataValue))/gi,argIndex:2,argKey:"fromYDataValue"},{regex:/((^|[^\\])((\\)\\)*\$fromLabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromLabel))/gi,argIndex:2,argKey:"fromLabel"},{regex:/((^|[^\\])((\\)\\)*\$toXValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toXValue))/gi,argIndex:2,argKey:"toXValue"},{regex:/((^|[^\\])((\\)\\)*\$toYValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toYValue))/gi,argIndex:2,argKey:"toYValue"},{regex:/((^|[^\\])((\\)\\)*\$toXDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toXDataValue))/gi,argIndex:2,argKey:"toXDataValue"},{regex:/((^|[^\\])((\\)\\)*\$toYDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toYDataValue))/gi,argIndex:2,argKey:"toYDataValue"},{regex:/((^|[^\\])((\\)\\)*\$tolabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$tolabel))/gi,argIndex:2,argKey:"toLabel"},{regex:/((^|[^\\])((\\)\\)*\$tlLabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$tlLabel))/gi,argIndex:5,argKey:"tlLabel"},{regex:/((^|[^\\])((\\)\\)*\$trlabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$trlabel))/gi,argIndex:5,argKey:"trLabel"},{regex:/((^|[^\\])((\\)\\)*\$bllabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$bllabel))/gi,argIndex:5,argKey:"blLabel"},{regex:/((^|[^\\])((\\)\\)*\$brlabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$brlabel))/gi,argIndex:5,argKey:"brLabel"},{regex:/((^|[^\\])((\\)\\)*\$rowlabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$rowlabel))/gi,argIndex:5,argKey:"rowLabel"},{regex:/((^|[^\\])((\\)\\)*\$columnlabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$columnlabel))/gi,argIndex:5,argKey:"columnLabel"},{regex:/((^|[^\\])((\\)\\)*\$errorvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$errorvalue))/gi,argIndex:2,argKey:"errorValue"},{regex:/((^|[^\\])((\\)\\)*\$errordatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$errordatavalue))/gi,argIndex:2,argKey:"errorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$errorpercentvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$errorpercentvalue))/gi,argIndex:2,argKey:"errorPercentValue"},{regex:/((^|[^\\])((\\)\\)*\$errorpercentdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$errorpercentdatavalue))/gi,argIndex:2,argKey:"errorPercentDataValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalErrorValue))/gi,argIndex:2,argKey:"horizontalErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalErrorDataValue))/gi,argIndex:2,argKey:"horizontalErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalErrorValue))/gi,argIndex:2,argKey:"verticalErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalErrorDataValue))/gi,argIndex:2,argKey:"verticalErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalErrorPercent)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalErrorPercentValue))/gi,argIndex:2,argKey:"horizontalErrorPercentValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalErrorPercentDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalErrorPercentDataValue))/gi,argIndex:2,argKey:"horizontalErrorPercentDataValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalErrorPercent)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalErrorPercentValue))/gi,argIndex:2,argKey:"verticalErrorPercentValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalErrorPercentDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalErrorPercentDataValue))/gi,argIndex:2,argKey:"verticalErrorPercentDataValue"},{regex:/((^|[^\\])((\\)\\)*\$xaxispercentvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$xaxispercentvalue))/gi,argIndex:2,argKey:"xAxisPercentValue"},{regex:/((^|[^\\])((\\)\\)*\$percentdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$percentdatavalue))/gi,argIndex:2,argKey:"percentDataValue"},{regex:/((^|[^\\])((\\)\\)*\$trType)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$trType))/gi,argIndex:4,argKey:"trtype"},{regex:/((^|[^\\])((\\)\\)*\$tlType)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$tlType))/gi,argIndex:4,argKey:"tltype"},{regex:/((^|[^\\])((\\)\\)*\$brType)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$brType))/gi,argIndex:4,argKey:"brtype"},{regex:/((^|[^\\])((\\)\\)*\$blType)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$blType))/gi,argIndex:4,argKey:"bltype"},{regex:/((^|[^\\])((\\)\\)*\$colorRangeLabel)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$colorRangeLabel))/gi,argIndex:5,argKey:"colorRangeLabel"},{regex:/((^|[^\\])((\\)\\)*\$zdatavalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$zdatavalue))/gi,argIndex:2,argKey:"zDataValue"},{regex:/((^|[^\\])((\\)\\)*\$svalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$svalue))/gi,argIndex:3,argKey:"svalue"},{regex:/((^|[^\\])((\\)\\)*\$positiveErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$positiveErrorValue))/gi,argIndex:2,argKey:"positiveErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$negativeErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$negativeErrorValue))/gi,argIndex:2,argKey:"negativeErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$datasvalue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$datasvalue))/gi,argIndex:2,argKey:"formattedsValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalNegativeErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalNegativeErrorValue))/gi,argIndex:2,argKey:"horizontalNegativeErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalPositiveErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalPositiveErrorValue))/gi,argIndex:2,argKey:"horizontalPositiveErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalNegativeErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalNegativeErrorValue))/gi,argIndex:2,argKey:"verticalNegativeErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalPositiveErrorValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalPositiveErrorValue))/gi,argIndex:2,argKey:"verticalPositiveErrorValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalNegativeErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalNegativeErrorDataValue))/gi,argIndex:2,argKey:"horizontalNegativeErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$horizontalPositiveErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$horizontalPositiveErrorDataValue))/gi,argIndex:2,argKey:"horizontalPositiveErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalPositiveErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalPositiveErrorDataValue))/gi,argIndex:2,argKey:"verticalPositiveErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$verticalNegativeErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$verticalNegativeErrorDataValue))/gi,argIndex:2,argKey:"verticalNegativeErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$positiveErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$positiveErrorDataValue))/gi,argIndex:2,argKey:"positiveErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$negativeErrorDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$negativeErrorDataValue))/gi,argIndex:2,argKey:"negativeErrorDataValue"},{regex:/((^|[^\\])((\\)\\)*\$nodeValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$nodeValue))/gi,argIndex:3,argKey:"nodeValue"},{regex:/((^|[^\\])((\\)\\)*\$nodeDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$nodeDataValue))/gi,argIndex:3,argKey:"nodeDataValue"},{regex:/((^|[^\\])((\\)\\)*\$dominantNode)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$dominantNode))/gi,argIndex:2,argKey:"dominantNode"},{regex:/((^|[^\\])((\\)\\)*\$subservientNode)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$subservientNode))/gi,argIndex:2,argKey:"subservientNode"},{regex:/((^|[^\\])((\\)\\)*\$dominantFlowValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$dominantFlowValue))/gi,argIndex:2,argKey:"dominantFlowValue"},{regex:/((^|[^\\])((\\)\\)*\$dominantFlowDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$dominantFlowDataValue))/gi,argIndex:2,argKey:"dominantFlowDataValue"},{regex:/((^|[^\\])((\\)\\)*\$subservientFlowValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$subservientFlowValue))/gi,argIndex:2,argKey:"subservientFlowValue"},{regex:/((^|[^\\])((\\)\\)*\$subservientFlowDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$subservientFlowDataValue))/gi,argIndex:2,argKey:"subservientFlowDataValue"},{regex:/((^|[^\\])((\\)\\)*\$linkValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$linkValue))/gi,argIndex:3,argKey:"linkValue"},{regex:/((^|[^\\])((\\)\\)*\$linkDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$linkDataValue))/gi,argIndex:3,argKey:"linkDataValue"},{regex:/((^|[^\\])((\\)\\)*\$plotFillColor)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$plotFillColor))/gi,argIndex:3,argKey:"plotFillColor"},{regex:/((^|[^\\])((\\)\\)*\$plotFillAlpha)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$plotFillAlpha))/gi,argIndex:3,argKey:"plotFillAlpha"},{regex:/((^|[^\\])((\\)\\)*\$plotIdentifier)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$plotIdentifier))/gi,argIndex:3,argKey:"plotIdentifier"},{regex:/((^|[^\\])((\\)\\)*\$dominantPlotIdentifier)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$dominantPlotIdentifier))/gi,argIndex:2,argKey:"dominantPlotIdentifier"},{regex:/((^|[^\\])((\\)\\)*\$subservientPlotIdentifier)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$subservientPlotIdentifier))/gi,argIndex:2,argKey:"subservientPlotIdentifier"},{regex:/((^|[^\\])((\\)\\)*\$from\b)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$from\b))/gi,argIndex:2,argKey:"from"},{regex:/((^|[^\\])((\\)\\)*\$to\b)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$to\b))/gi,argIndex:2,argKey:"to"},{regex:/((^|[^\\])((\\)\\)*\$linkValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$linkValue))/gi,argIndex:2,argKey:"linkValue"},{regex:/((^|[^\\])((\\)\\)*\$fromPlotIdentifier)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$fromPlotIdentifier))/gi,argIndex:3,argKey:"fromPlotIdentifier"},{regex:/((^|[^\\])((\\)\\)*\$toPlotIdentifier)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$toPlotIdentifier))/gi,argIndex:3,argKey:"toPlotIdentifier"},{regex:/((^|[^\\])((\\)\\)*\$flowDirection)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$flowDirection))/gi,argIndex:3,argKey:"flowDirection"},{regex:/(((\\)\\)*\$series.[0-9].name)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].name))/gi,argIndex:2,argKey:"name",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].color)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].color))/gi,argIndex:3,argKey:"color",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].plotIdentifier)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].plotIdentifier))/gi,argIndex:3,argKey:"plotIdentifier",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].value)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].value))/gi,argIndex:3,argKey:"value",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].dataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].dataValue))/gi,argIndex:3,argKey:"dataValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].volumeValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].volumeValue))/gi,argIndex:3,argKey:"volumeValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].volumeDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].volumeDataValue))/gi,argIndex:3,argKey:"volumeDataValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].openValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].openValue))/gi,argIndex:3,argKey:"openValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].openDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].openDataValue))/gi,argIndex:3,argKey:"openDataValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].highValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].highValue))/gi,argIndex:3,argKey:"highValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].highDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].highDataValue))/gi,argIndex:3,argKey:"highDataValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].lowValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].lowValue))/gi,argIndex:3,argKey:"lowValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].lowDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].lowDataValue))/gi,argIndex:3,argKey:"lowDataValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].closeValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].closeValue))/gi,argIndex:3,argKey:"closeValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(((\\)\\)*\$series.[0-9].closeDataValue)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$series.[0-9].closeDataValue))/gi,argIndex:3,argKey:"closeDataValue",isTimeseriesMacro:!0,parsingMethod:ve},{regex:/(\$binStart)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$binStart))/gi,argIndex:3,argKey:"binStart",isTimeseriesMacro:!0},{regex:/(\$binEnd)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$binEnd))/gi,argIndex:3,argKey:"binEnd",isTimeseriesMacro:!0},{regex:/(\$bin)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$bin))/gi,argIndex:3,argKey:"bin",isTimeseriesMacro:!0},{regex:/((^|[^\\])((\\)\\)*\$barColor)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$barColor))/gi,argIndex:3,argKey:"barColor"},{regex:/((^|[^\\])((\\)\\)*\$icon)/gi,escapeRegex:/((^|[^\\])((\\)\\)*\\(\$icon))/gi,argIndex:3,argKey:"icon"}],r=[],n=t.length;for(e=0;e<n;e+=1)r.push(e);return function(){var e,n,a,i,o,s,l=arguments[0],c=arguments[1],u=arguments;if(de(c)||(c=r),l)for(o=c.length,s=function(){return a.parsingMethod(arguments[0],u[a.argIndex].series)},i=0;i<o;i+=1)if(a=t[c[i]])if(a.isTimeseriesMacro){var d=a.argKey;a.parsingMethod?l=l.replace(a.regex,s):u[a.argIndex]&&(l=l.replace(a.regex,u[a.argIndex].series[0][d]))}else e=Te(Me((n=arguments[a.argIndex])&&n[a.argKey],"")+""),l=(l=l.replace(a.regex,"$2$4"+(a.parsingMethod?a.parsingMethod(e):e))).replace(a.escapeRegex,"$2$4$5");return l}}(),ye=(h=function(e,t,r,n,a){var i,o=Math.abs(t-e),s=o/(r+1),l=n;return p(o,r,l)||(a&&(i=l>1?2:.5,Number(s)/Number(l)<i&&(l/=10)),o=(s=(Math.floor(s/l)+1)*l)*(r+1)),o},g=function(e){var t=Math.abs(e),r=String(t),n=0,a=r.indexOf(".");return-1!==a&&(n=r.length-a-1),n},p=function(e,t,r){return!(g(e/(t+1))>g(r))},function(e,t,r,n,a,i,o,s){var l,c,d,f,g,m,v,b,y,x,w,C,k,_,S,E,A,N,T,M,D,F,I,O,L,R,P,V=0,j=e,B=t,z=a,H=i,U=o;if((j=!0===isNaN(j)||j===u?.1:j)===(B=!0===isNaN(B)||B===u?0:B)&&0===j&&(j=.1),z=void 0===z||z,H=void 0===H||H,v=Math.floor(Math.log(Math.abs(j))/Math.LN10),b=Math.floor(Math.log(Math.abs(B))/Math.LN10),y=Math.max(b,v),x=Math.pow(10,y),Math.abs(j)/x<2&&Math.abs(B)/x<2&&(y--,x=Math.pow(10,y)),w=Math.floor(Math.log(j-B)/Math.LN10),C=Math.pow(10,w),j-B>0&&x/C>=10&&(x=C,y=w),k=(Math.floor(j/x)+1)*x,_=B<0?(Math.floor(Math.abs(B/x))+1)*x*-1:H||(_=Math.floor(Math.abs(B/x)-1)*x)<0?0:_,z&&j<=0&&(k=0),c=!(!n&&0!==n),d=!1==(l=!(!r&&0!==r))||!0===l&&Number(r)<j&&j-Number(r)>q?k:Number(r),f=!1===c||!0===c&&Number(n)>B&&Number(n)-B>q?_:Number(n),g=Math.abs(d-f),m=x,!1===c&&!1===l&&s)if(d>0&&f<0){for(E=!1,N=h(f,d,U,A=m>10?m/10:m,!1)-(U+1)*A;!1===E;)if(p(N+=(U+1)*A,U,A))if(S=N-g,T=N/(U+1),M=(D=Math.min(Math.abs(f),d))===Math.abs(f)?-1:1,0===U)E=!0;else for(I=1;I<=Math.floor((U+1)/2);I++)(F=T*I)-D>S||F>D&&(R=N-F)/T===Math.floor(R/T)&&F/T===Math.floor(F/T)&&(g=N,d=-1===M?R:F,f=-1===M?-F:-R,E=!0)}else S=(O=h(f,d,U,m,!0))-g,g=O,d>0?d+=S:f-=S;else s&&(P=function(e,t,r){for(var n,a=0,i=1;!p(t,n=0===(n=e+a*i)?1:n,r);){if((a=-1===i||a>e?++a:a)>25){n=0;break}i=a<=e?-1*i:1}return n},U>0&&(0===(L=P(U,g,m))&&(L=P(U,g+1,m),V=1),U=L));return{Max:d,Min:f,Range:g,interval:m,divGap:(d-f+V)/(U+1)}}),xe={keyup:!0,blur:!0,click:!0,load:!0,dragstart:!0,dragmove:!0,dragend:!0,dblclick:!0,mousedown:!0,mousemove:!0,mouseout:!0,mouseover:!0,mouseup:!0,"fc-wheel":!0,"fc-click":!0,"fc-dragstart":!0,"fc-dragmove":!0,"fc-dragend":!0,"fc-dbclick":!0,"fc-mousedown":!0,"fc-mousemove":!0,"fc-mouseout":!0,"fc-mouseover":!0,"fc-mouseup":!0,"fc-pinchstart":K||J,"fc-pinchmove":K||J,"fc-pinchend":K||J,touchstart:K||J,touchmove:K||J,touchend:K||J,touchcancel:K||J},we={stripWhitespace:/\s+/g,dropHash:U,startsRGBA:G,cleanColorCode:W,breakPlaceholder:H,hexcode:/^#?[0-9a-f]{6}/i},Ce={colors:{B90000:"B90000",FFFFFF:"FFFFFF",AAAAAA:"AAAAAA",c000000:"000000"},BLANK:"",DATASET:"dataset",NORMALSTRING:"normal",PX:"px",INPUT:"input",LABEL:"label",BLANKSPACE:" ",COMMA:",",OBJECTBOUNDINGBOX:"objectBoundingBox",GROUPID:"groupId",EVENTARGS:"eventArgs",CIRCLE:"circle",POLYGON:"polygon",SPOKE:"spoke",RECTANGLE:"rectangle",ROLLOUT:"rollout",ROLLOVER:"rollover",DATAPLOTCLICK:"dataplotclick",defaultFontStr:"Verdana,sans",line:"line",bar:"bar",column:"column",volume:"volume",HUNDREDSTRING:"100",SEVENTYSTRING:"70",NINETYSTRING:"90",AUTOSTRING:"auto",configStr:"config",animationObjStr:"animationObj",showHoverEffectStr:"showHoverEffect",hiddenStr:"hidden",visibleStr:"visible",columnStr:"columns",barStr:"bars",barHotStr:"bar-hot",colHotStr:"col-hot",shadowStr:"shadow",dataLabelStr:"datalabel",errorBarStr:"errorBar",errorHotStr:"error-hot",errorShadowStr:"error-shadow",negativeValueStr:"negative-values",positiveValueStr:"positive-values",zeroPlaneStr:"zero-plane",categoryPlotsStr:"categoryplots",noneStr:"none",setRolloverAttrStr:"setRolloverAttr",setRolloutAttrStr:"setRolloutAttr",elementStr:"element",hotElementStr:"hotElement",strokeWidthStr:"stroke-width",strokeDashStr:"stroke-dasharray",strokeLineJoinStr:"stroke-linejoin",miterStr:"miter",visiblilityStr:"visibility",ROUND:"round",PERCENTAGESTRING:"%",pStr:"p",sStr:"s",divLineAlpha3DStr:"divLineAlpha3D",divLineAlphaStr:"divLineAlpha",altVGridColorStr:"altVGridColor",altVGridAlphaStr:"altVGridAlpha",altHGridColorStr:"altHGridColor",altHGridAlphaStr:"altHGridAlpha",PLOTFILLCOLOR_STR:"plotFillColor",UNDERSCORE:"_",gaugeFillColorStr:"gaugeFillColor",gaugeBorderColorStr:"gaugeBorderColor",NORMAL:"normal",BOLD:"bold",POINTER:"pointer",DEFAULT:"default",POSITION_MIDDLE:"middle",POSITION_START:"start",POSITION_TOP:"top",POSITION_BOTTOM:"bottom",POSITION_END:"end"};function ke(e){return null!=e}function _e(e){var t={},r=e.getBoundingClientRect();return t.left=r.left+(window.pageXOffset||document.documentElement.scrollLeft),t.top=r.top+(window.pageYOffset||document.documentElement.scrollTop),t}function Se(e){var t=e&&(e.sourceEvent||e.originalEvent||e);return K&&t&&(t.touches&&t.touches[0]||t.changedTouches&&t.changedTouches[0])||t||re}function Ee(e){var t,r,n,a=e.data,i=a.chart,o=i.getFromEnv("animationManager"),s=fe(Se(e.originalEvent)),l=i.getChildren("canvas")[0],c=t=l.getGraphicalElement("resizeBox"),u=a.layerX=s.pageX-a.chartPosLeft,d=a.layerY=s.pageY-a.chartPosTop,f=u-a.ox,h=d-a.oy,g=a.bBox,p=a.ox,m=a.oy,v=a.zoomX,b=a.zoomY,y=a.canvasY,x=a.canvasX,w=a.canvasX2,C=a.canvasY2,k=a.strokeWidth,_=a.attr;switch(e.state){case"start":r=_e(this),a.chartPosLeft=r.left,a.chartPosTop=r.top,u=s.pageX-a.chartPosLeft,d=s.pageY-a.chartPosTop,a.oy=d,a.ox=u,a.allowMove=!1,_.x=0,_.y=0,_.height=0,_.width=0,c=l.addGraphicalElement("resizeBox",o.setAnimation({el:t||"rect",attr:_,container:i.getChildContainer("trackerGroup")})).show(),t||l.addGraphicalElement("resizeBox",c),u>x&&u<w&&d>y&&d<C&&(a.allowMove=!0),e.target._isTrackerElem&&(a.allowMove=!1);break;case"end":n={chart:i,selectionLeft:(g=c.getBBox()).x,selectionTop:g.y,selectionHeight:g.height,selectionWidth:g.width,originalEvent:e.originalEvent},a.isDragged&&(a.selectionEnd&&a.selectionEnd(n),a.isDragged=0),c.hide(),delete a.oy,delete a.ox;break;default:if(!a.allowMove)return;f=u-a.ox,h=d-a.oy,g=a.bBox,p=a.ox,m=a.oy,a.isDragged||(n={chart:i,selectionLeft:(v?te(p,p+f):x)+.5*k,selectionTop:(b?te(m,m+h):y)+.5*k,selectionHeight:0,selectionWidth:0,originalEvent:e.originalEvent},a.selectionStart&&a.selectionStart(n),a.isDragged=1),f=-(p-te(p-(p-ee(p+f,x)),w)),h=-(m-te(m-(m-ee(m+h,y)),C)),o.setAnimation({el:c,attr:{x:(v?te(p,p+f):x)+.5*k,y:(b?te(m,m+h):y)+.5*k,width:v?$(f):a.canvasW,height:b?$(h):a.canvasH}})}}function Ae(e){var t=e.data,r=e.originalEvent,n=r.target||r.originalTarget||r.srcElement||r.relatedTarget||r.fromElement,a=r.type,i=r.layerX,o=r.layerY;i===u&&(i=r.pageX-t.chartPosLeft,o=r.pageY-t.chartPosTop),"mousedown"===a&&(n.ishot=i>t.canvasX&&i<t.canvasX2&&o>t.canvasY&&o<t.canvasY2),"mouseup"===a&&setTimeout((function(){n.ishot=!1}),1)}function Ne(){var e,t,r;for(t=0,r=arguments.length;t<r;t+=1)if((e=arguments[t])||!1===e||0===e)return e;return""}function Te(e){return e&&e.replace(/\$/g,"$$$$")}function Me(e,t){return e||!1===e||0===e?e:t}function De(){var e,t,r;for(t=0,r=arguments.length;t<r;t+=1)if(((e=arguments[t])||!1===e||0===e)&&!isNaN(parseInt(e,10)))return e<1?1:e;return u}function Fe(){var e,t,r;for(t=0,r=arguments.length;t<r;t+=1)if((e=arguments[t])||!1===e||0===e)return e;return u}function Ie(e){var t;if(6===e.length){var r=e[0],n=e[1],a=e[2],i=e[3],o=e[4],s=e[5];return[o/(t=r*o-i*n),-n/t,(n*s-a*o)/t,-i/t,r/t,-(r*s-a*i)/t]}return[]}function Oe(e,t,r){var n=e.x,a=e.y,i=t.oriX,o=t.oriY;return n-=i,a-=o,6===r.length?{x:r[0]*n+r[1]*a+r[2]+i,y:r[3]*n+r[4]*a+r[5]+o}:{x:n,y:a}}function Le(e,t){ge(e.substr(0,e.indexOf("__FC_ARG_SEP__")).replace(/\s/g,""),e.substr(e.indexOf("__FC_ARG_SEP__")).replace(/__FC_ARG_SEP__/,""),t)}function Re(e){/^j\s*\-/.test(e)?Le(e.replace(/^j\s*\-/,"").replace(/\-/,"__FC_ARG_SEP__")):Le(e.replace(/^javascript\s*\:/i,"").replace(/[\'\"]?\s*\,\s*[\'\"]?/g,"__FC_ARG_SEP__").replace(/\(\s*[\'\"]?(.*)\)\;?/,"__FC_ARG_SEP__$1").replace(/[\'\"]?$/,""),!0)}function Pe(e,t){var r=X(10,t);return Y(e*r)/r}function Ve(e,t,r){return r||r===u?[e,t]:"none"}function je(e,t){return"object"!=typeof e?"":((e.fontSize||e["font-size"])&&(!e.fontSize&&e["font-size"]&&(e.fontSize=e["font-size"],delete e["font-size"]),e.lineHeight=1.2*(parseFloat(e.fontSize)||t||10)+"px",delete e["line-height"]),!e.lineHeight&&e["line-height"]&&(e.lineHeight=e["line-height"],delete e["line-height"]),e.lineHeight)}function Be(e,t){return e-t}function ze(e,t){return t-e}t.appliedCSS=["fontFamily","fontSize","fontWeight","fontStyle"],t.preDefStr=Ce,t.regex=we,t.chartAPI=void 0,t.getAxisLimits=ye,t.parseTooltext=be,t.gradientify=me,t.toRaphaelColor=pe,t.getViewPortDimension=he,t.getEventCoordinate=fe,t.isArray=de,t.createElement=function(e,t,r){var n,a=N.createElement(e);for(n in t)a.setAttribute(n,t[n]);return r&&r.appendChild&&r.appendChild(a),a},t.animHelperFN={getTimeByValue:function(e,t,r){var n=(e.end-e.start)/(t.endPx-t.startPx);return{start:e.start+n*(r.startPx-t.startPx),end:e.start+n*(r.endPx-t.startPx)}},animByWeight:function(e,t,r,n,a){var i=n||1,o=t,s=a||0;return{start:e/--o*r*i+s,end:e/o*r*i+r+s}}},t.rgbaToHex=function(e){var t=e.replace("rgba(","").split(",");return"#"+("000000"+(t[0]<<16|t[1]<<8|t[2]).toString(16)).slice(-6)},t.polyPathToPath=function(e){var t,r,n,a,i,o=e[0],s=e[1],l=e[2],c=e[3],u=e[4],d=e[5];if(t=[],o=_.parseInt(o,10)||0,s=B(s)||0,l=B(l)||0,c=B(c)||0,u=null===u||isNaN(u)?.5*Math.PI:u%360*(Math.PI/180),d=null===d||isNaN(d)?0:B(d),a=u,o>2)switch(r=2*Math.PI/o,d){case 0:for(n=0;n<o;n++)t.push("L",s+c*Math.cos(-a),l+c*Math.sin(-a)),a+=r;t[0]="M",t.push("Z");break;case 1:for(n=0;n<o;n++)t.push("M",s,l,"L",s+c*Math.cos(-a),l+c*Math.sin(-a)),a+=r;break;default:for(r*=.5,i=c*Math.cos(r)*(1-d),n=0;n<o;n++)t.push("L",s+c*Math.cos(-a),l+c*Math.sin(-a)),a+=r,t.push("L",s+i*Math.cos(-a),l+i*Math.sin(-a)),a+=r;t[0]="M",t.push("Z")}else 0===c?t.push("M",s,l,"L",s,l,"Z"):t.push("M",s-c,l,"A",c,c,0,0,0,s+c,l,"A",c,c,0,0,0,s-c,l,"Z");return t},t.removeHtmlAttrs=function(e){return void 0===e&&(e={}),ue.forEach((function(t){return delete e[t]})),e},t.crispBound=function(e,t,r,n,a,i,o){void 0===e&&(e=0),void 0===t&&(t=0),void 0===r&&(r=0),void 0===n&&(n=0),void 0===a&&(a=0),void 0===i&&(i={});var s=a;if(n<1||r<1)return{x:e,y:t,width:r,height:n,"stroke-width":s};(s>=r||s>=n)&&(s=Math.floor(Math.min(r,n)/2)||s);var l=e,c=t,u=e+r,d=s/2,f=s%2,h=t+n;return c=i.top?Math.round(c)+d-ce:f?Math.floor(c)+.5-ce:Math.round(c)-ce,h=i.bottom?Math.round(h)-d-ce:o&&i.top?Math.round(h)+d-ce:f?Math.floor(h)+.5-ce:Math.round(h)-ce,l=i.left?Math.round(l)+d-ce:o&&i.right?Math.round(l)-d-ce:f?Math.floor(l)+.5-ce:Math.round(l)-ce,u=i.right?Math.round(u)-d-ce:f?Math.floor(u)+.5-ce:Math.round(u)-ce,{x:l,y:c,width:Math.abs(u-l),height:Math.abs(h-c),"stroke-width":s}},t.supportedStyle={font:"font",fontFamily:"font-family","font-family":"font-family",fontWeight:"font-weight","font-weight":"font-weight",fontSize:"font-size","font-size":"font-size",lineHeight:"line-height","line-height":"line-height",textDecoration:"text-decoration","text-decoration":"text-decoration",color:"color",whiteSpace:"white-space","white-space":"white-space",padding:"padding",margin:"margin",background:"background",backgroundColor:"background-color","background-color":"background-color",backgroundImage:"background-image","background-image":"background-image",backgroundPosition:"background-position","background-position":"background-position",backgroundPositionLeft:"background-position-left","background-position-left":"background-position-left",backgroundPositionTop:"background-position-top","background-position-top":"background-position-top",backgroundRepeat:"background-repeat","background-repeat":"background-repeat",border:"border",borderColor:"border-color","border-color":"border-color",borderStyle:"border-style","border-style":"border-style",borderThickness:"border-thickness","border-thickness":"border-thickness",borderTop:"border-top","border-top":"border-top",borderTopColor:"border-top-color","border-top-color":"border-top-color",borderTopStyle:"border-top-style","border-top-style":"border-top-style",borderTopThickness:"border-top-thickness","border-top-thickness":"border-top-thickness",borderRight:"border-right","border-right":"border-right",borderRightColor:"border-right-color","border-right-color":"border-right-color",borderRightStyle:"border-right-style","border-right-style":"border-right-style",borderRightThickness:"border-right-thickness","border-right-thickness":"border-right-thickness",borderBottom:"border-bottom","border-bottom":"border-bottom",borderBottomColor:"border-bottom-color","border-bottom-color":"border-bottom-color",borderBottomStyle:"border-bottom-style","border-bottom-style":"border-bottom-style",borderBottomThickness:"border-bottom-thickness","border-bottom-thickness":"border-bottom-thickness",borderLeft:"border-left","border-left":"border-left",borderLeftColor:"border-left-color","border-left-color":"border-left-color",borderLeftStyle:"border-left-style","border-left-Style":"border-left-style",borderLeftThickness:"border-left-thickness","border-left-thickness":"border-left-thickness"},t.chartPaletteStr=le,t.normalizeAngle=function(e,t){var r=t?360:se,n=(e||0)%r;return n<0?r+n:n},t.MathExt=oe,t.xssEncode=function(e){var t=e;return null==t||"function"!=typeof t.toString?"":t=t.toString().replace(/&/g,"&amp;").replace(/\'/g,"&#39;").replace(/\"/g,"&quot;").replace(/</g,"&lt;").replace(/>/g,"&gt;")},t.isXSSSafe=function(e,t){return(!t||null===R.exec(e))&&null===L.exec(e)},t.domInsertModes={REPLACE:"replace",APPEND:"append",PREPEND:"prepend"},t.defaultGaugePaletteOptions=ie,t.txtLabel=Z,t.hasTouch=J,t.touchEnabled=K,t.mathRound=Y,t.mathAbs=$,t.validhexcolor=/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i,t.cleanColorCode=W,t.startsRGBA=G,t.dropHash=U,t.TXT_REGEX=z,t.visibleStr="visible",t.hiddenStr="hidden",t.animationObjStr="animationObj",t.configStr="config",t.lineHeightFactor=1.2,t.HOVER_THRESHOLD_PIXELS=1,t.CLICK_THRESHOLD_PIXELS=5,t.TOUCH_THRESHOLD_PIXELS=15,t.canvasBorderColorStr="canvasBorderColor",t.TXT_STRING=j,t.TXT_HREF=V,t.FIT="fit",t.FILL="fill",t.TILE="tile",t.HAND="pointer",t.POINTER="pointer",t.BOLD="bold",t.NORMAL="normal",t.UNDERSCORE="_",t.ROUND="round",t.canvasBGAlphaStr="canvasBgAlpha",t.TEXTANCHOR="text-anchor",t.COMMASPACE=", ",t.PXSTRING="px",t.VISIBLE="visible",t.INITIALSTR="initial",t.FINALSTR="final",t.HUNDREDSTRING="100",t.SHAPE_RECT="rect",t.FC_CONFIG_STRING="_FCconf",t.POSITION_END="end",t.POSITION_START="start",t.MIDDLESTR=t.POSITION_MIDDLE="middle",t.POSITION_BOTTOM="bottom",t.POSITION_TOP="top",t.STRINGUNDEFINED="undefined",t.DECIMALSTRING=".",t.ONESTRING="1",t.TESTSTR="Ag",t.MOUSEMOVE="fc-mousemove",t.MOUSEOUT="fc-mouseout",t.ZEROSTRING="0",t.COMMA=",",t.COMMASTRING=",",t.BLANKSTRING="",t.BLANK="",t.OBJECTSTRING="object",t.STRINGSTRING="string",t.BREAKSTRING="<br />",t.HASHSTRING="#",t.COLOR_TRANSPARENT="rgba(0,0,0,0)",t.COLOR_WHITE="FFFFFF",t.COLOR_GLASS="rgba(255, 255, 255, 0.3)",t.COLOR_BLACK="000000",t.SAMPLESTRING="Ay0",t.BLANKSTRINGPLACEHOLDER="#BLANK#",t.UNDEF=u,t.POSITION_CENTER="center",t.POSITION_LEFT="left",t.POSITION_RIGHT="right",t.POSITION_ABSOLUTE="absolute",t.TRACKER_FILL=P,t.attrTypeBool=2,t.attrTypeNum=1,t.DEFAULT_FT_FONT="Helvetica, Arial, sans-serif",t.isIpad=O,t.isEdge=I,t.isIE=F,t.isIE11=D,t.hasSVG=M,t.isFirefox=A,t.isIE9=E,t.getEmptyConstractor=function(){return S},t.stubFN=S,t.DASH_DEF="none",t.BGRATIOSTRING=void 0;t.isSimilarObject=function(e,t){if(Object.keys(e).length!==Object.keys(t).length)return!1;var r;for(r in e)if(e[r]!==t[r])return!1;return!0},t.snapPoint=function(e,t,r){for(var n=t.length,a=r.lastSnap,i=1,o=n,s=r.config.setValue;o--;)if($(t[o]-s)<e.snapPixel){a!==o&&(r.lastSnap=e.datasetConf.snapToDivOnly?u:o,s=t[o]),i=0;break}return i&&(r.lastSnap=u),s},t.datasetFactory=function(e,t,r,n,a,i){if(void 0===n&&(n=1),void 0===i&&(i=[]),e&&t&&r){var o,s,l,c=e.getChildren(r)||[];for(o=0;o<n;o+=1)c&&c[o]&&!c[o].getState("removed")?l=c[o]:(l=new t,e.attachChild(l,r)),l.config._childIndex=o,l.setState("_total",n),l.setJSONIndex&&l.setJSONIndex(i[o]||o),a&&a.length>o&&l.configure&&l.configure(a[o]);if(o<(s=c&&c.length))for(;o<s;o+=1)c[o]&&c[o].remove&&c[o].remove()}},t.componentFactory=function(e,t,r,n,a){if(void 0===n&&(n=1),e&&t&&r){var i,o,s,l=e.getChildren(r)||[];for(i=0;i<n;i+=1)l&&l[i]&&!l[i].getState("removed")?s=l[i]:(s=new t,e.attachChild(s,r)),a&&a.length>i&&s.configure&&s.configure(a[i]);if(i<(o=l&&l.length))for(;i<o;i+=1)l[i]&&l[i].remove&&l[i].remove()}}},function(e,t,r){"use strict";t.__esModule=!0,t.parseConfiguration=function(e,r,i,o,s,l){var c,u,d,f=1,h=o,g=l,p=s;for(c in t.attribDefs=n=n||a,h=h||a,g=g||a,p=p||{},e)if(!h[c]&&((u=e[c])||!1===u||0===u))switch((d=g[c]||n[c])&&d.type){case 1:u=Number(u),isNaN(u)||(r[c]=u);break;case 2:u=Number(u),isNaN(u)||(r[c]=!!u);break;default:r[c]=u}if(i)for(c in r)void 0===r[c]&&(d=g[c]||n[c])&&d.pAttr&&(r[c]=i[d.pAttr]);for(;f;)for(c in f=0,r)void 0===r[c]&&(d=g[c]||n[c])&&(d.attr?void 0!==(u=r[d.attr])&&(r[c]=u,f+=1):d.parser&&void 0!==(u=d.parser(r,i,p))&&(r[c]=u,f+=1))},t.setAttribDefs=function(e,r){var a,i;t.attribDefs=n=n||{},"string"==typeof e?(a={})[e]=r:a=e;for(i in a)n[i]||(n[i]=a[i])},t.hasAttribDefs=function(e){return!!n[e]},t.attribDefs=void 0;var n,a={},i=Math.max;t.attribDefs=n,t.attribDefs=n={setBorderWidth:{type:1,pAttr:"plotborderthickness"},plotborderthickness:{type:1,pAttr:"plotborderthickness"},showBorderEffect:{parser:function(){var e=arguments[1],t=.1;return 1==+e.showplotborder&&e.plotborderthickness===t?1:0}},alphaanimation:{type:1},showplotborder:{type:1,pAttr:"showplotborder"},zeroplanethickness:{type:1},showzeroplaneontop:{type:1},stickytracking:{type:1},usemessagelog:{type:1},showtooltip:{type:1,pAttr:"showtooltip"},seriesnameintooltip:{type:1},plothovereffect:{type:1,attr:"anchorhovereffect"},anchorhovereffect:{type:1,attr:"showhovereffect"},showhovereffect:{type:1},linethickness:{type:1,pAttr:"linethickness"},dashed:{type:1,pAttr:"linedashed"},linedashed:{type:1,attr:"plotborderdashed"},plotborderdashed:{type:1,pAttr:"plotborderdashed"},linedashlen:{type:1,pAttr:"linedashlen"},linedashgap:{type:1,pAttr:"linedashgap"},anchoralpha:{pAttr:"anchoralpha"},anchorsides:{type:1,pAttr:"anchorsides"},anchorradius:{type:1,pAttr:"anchorradius"},anchorbgalpha:{pAttr:"anchorbgalpha"},anchorbgcolor:{pAttr:"anchorbgcolor"},anchorbordercolor:{pAttr:"anchorbordercolor"},anchorstartangle:{type:1,pAttr:"anchorstartangle"},anchorimageurl:{pAttr:"anchorimageurl"},anchorimagescale:{type:1,pAttr:"anchorimagescale"},anchorimagealpha:{pAttr:"anchorimagealpha"},anchorimagepadding:{type:1,pAttr:"anchorimagepadding"},anchorborderthickness:{type:1,pAttr:"anchorborderthickness"},anchorshadow:{type:1,pAttr:"anchorshadow"},valuepadding:{type:1,pAttr:"valuepadding"},valueposition:{pAttr:"valueposition"},plotfillangle:{type:1,pAttr:"plotfillangle"},useplotgradientcolor:{type:1},rotatevalues:{type:1,pAttr:"rotatevalues"},includeinlegend:{type:1},connectnulldata:{type:1},plotfillalpha:{pAttr:"plotfillalpha"},alpha:{pAttr:"linealpha"},linealpha:{pAttr:"plotfillalpha"},showvalues:{type:1,pAttr:"showvalues"},showpercentvalues:{type:1,parser:function(e){return e.isstacked&&e.stack100percent?1:0}},showpercentintooltip:{type:1,parser:function(e){return e.isstacked&&e.stack100percent?1:0}},stack100percent:{type:1,attr:"usepercentdistribution"},drawfullareaborder:{type:1},use3dlineshift:{type:1},parentyaxis:{type:1},radarborderthickness:{type:1},radarborderradius:{type:1},gaugeoriginx:{type:1},hasgaugeoriginx:{attr:"gaugeoriginx"},gaugeoriginy:{type:1},hasgaugeoriginy:{attr:"gaugeoriginy"},gaugeradius:{type:1},hasgaugeradius:{attr:"gaugeradius"},showgaugeborder:{type:1},setAdaptiveMin:{type:1},adjustDiv:{type:1},axisNameWidth:{type:1},rotateAxisName:{type:1},useEllipsesWhenOverflow:{type:1},showZeroPlane:{type:1},zeroPlaneAlpha:{type:1},showZeroPlaneValue:{type:1},zeroPlaneOnTop:{type:1},trendlineThickness:{type:1},showTrendlinesOnTop:{type:1},trendlinesAreDashed:{type:1},trendlinesDashLen:{type:1},trendlinesDashGap:{type:1},showTrendlines:{type:1},showTrendlineLabels:{type:1},showLabels:{type:1},rotateLabels:{type:1},slantLabel:{type:1},showAxisValues:{type:1},showTooltip:{type:1},maxLabelHeight:{type:1},useroundedges:{type:1,pAttr:"useroundedges"},placevaluesinside:{type:1},plotpaddingpercent:{type:1},use3dlighting:{type:1,pAttr:"use3dlighting"},usedataplotcolorforlabels:{type:1},plotspacepercent:{type:1,parser:function(e){return i(e.plotspacepercent%100,0)}},ratio:{pAttr:"plotfillratio"},base:{type:1},showMinorDivLineValues:{type:1},numMinorDivLines:{type:1},majorTMNumber:{type:1},majorTMHeight:{type:1},showTickMarks:{type:1},majorTMThickness:{type:1},adjustTM:{type:2},minorTMNumber:{type:1},minorTMThickness:{type:1},tickMarkDistance:{type:1},placeTicksInside:{type:1},placeValuesInside:{type:1},axisValuePadding:{type:1},gridLineWidth:{type:1},showRadarBorder:{type:1},radarBorderThickness:{type:1},maxcolwidth:{type:1,parser:function(e){return Math.abs(e.maxcolwidth)}},maxbarheight:{type:1,parser:function(e){return Math.abs(e.maxbarheight)}},plotborderalpha:{parser:function(e,t){return t.plotborderalpha||e.plotfillalpha}},autoscale:{type:1},plotborderdashlen:{type:1,pAttr:"plotborderdashlen"},plotborderdashgap:{type:1,pAttr:"plotborderdashgap"},plotfillratio:{pAttr:"plotfillratio"},drawverticaljoins:{type:1,pAttr:"drawverticaljoins"},useforwardsteps:{type:1,pAttr:"useforwardsteps"},minimizetendency:{type:1},usepercentdistribution:{type:1},stepatmiddle:{type:1}}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a,i,o,s=n(r(227)),l=window,c=l.document,u="ontouchstart"in l,d="click",f="touchstart",h="touchend",g="touchmove",p="mouseout",m="mouseover",v="keydown",b=((o={}).pointerdrag={start:["mousedown"],end:["mouseup"],onStart:["mousemove"],postHandlers:{},preHandlers:{}},o.pointerhover={start:[m],end:[p]},o.click={start:[d]},o.escape={start:[v],preHandlers:{start:function(e){var t=e||l.event;return!(!t.keyCode||27!==t.keyCode)}}},u&&((i=o.pointerdrag).start.push(f),i.end.push(h),i.onStart.push(g),i.postHandlers.onStart=function(e){e.preventDefault?e.preventDefault():e.returnValue=!1}),o);a=(0,s["default"])({},b);var y=new function(){var e={},t={},r=c.addEventListener?function(e,t,r){e.addEventListener(t,r,!1)}:function(e,t,r){e.attachEvent("on"+t,r)},n=c.removeEventListener?function(e,t,r){e.removeEventListener(t,r,!1)}:function(e,t,r){e.detachEvent("on"+t,r)},i=function(e,t,a,i){var o=i||"closure";return r(e,t,a[o]),function(){n(e,t,a[o])}},o=function(e,t,r){var n,o,s,c,u=[];if(c=a[t],r.start=function(t){for(var n=c.onStart,a=c.end,o=[],s=[],u=n&&n.length||0,d=t||l.event;u--;)o.push(i(e,n[u],r,"onStart"));for(u=a&&a.length||0;u--;)s.push(i(e,a[u],r,"end"));r.startUn=r.startUn?r.startUn.concat(o):o,r.endUn=r.endUn?r.endUn.concat(s):s,r.state="start",r.closure(d)},r.onStart=function(e){var t=e||l.event;r.state="on",r.gDef&&r.gDef.preHandlers&&"function"==typeof r.gDef.preHandlers.onStart&&r.gDef.preHandlers.onStart(t),r.closure(t),r.gDef&&r.gDef.postHandlers&&"function"==typeof r.gDef.postHandlers.onStart&&r.gDef.postHandlers.onStart(t)},r.end=function(e){for(var t=r.startUn,n=r.endUn,a=t&&t.length||0,i=e||l.event;a--;)t[a]();for(delete r.startUn,r.startUn=[],a=n&&n.length||0;a--;)n[a]();delete r.endUn,r.endUn=[],r.state="end",r.closure(i)},c)for(s=(n=c.start).length;s--;)(o=n[s])&&u.push(i(e,o,r,"start"));return u},u=function(e,t,r){var i,o,s,l;if(l=a[t])for(s=(i=l.start).length;s--;)(o=i[s])&&n(e,o,r.start)},d=function(e){return function(t){var r=e.context||e.elem,n=t.originalEvent||t;n=n||l.event,e.handler.call(r,{data:e.data,type:e.type,state:e.state,isGesture:e.isGesture,target:n.target||n.srcElement,originalEvent:n})}};return{listen:function(r,n,s,l,u){var f,h,g,p,m,v=this,b="string"==typeof n?n.split(" "):n,y=b.length,x=[],w=function(e,t,r){x.push((function(){v.unlisten(e,t,r)}))};if(r.ownerDocument&&r.ownerDocument===c)for(;y--;)h=b[y],p=Boolean(a[h]),(g={handler:m="function"==typeof s?s:s[y],elem:r,type:h,isGesture:p,gDef:p?a[h]:null,data:l,context:u,start:[],end:[],links:{prev:null,next:null}}).closure=d(g),p?((f=t[h])||(f=t[h]=[]),f.push(g),o(r,h,g)):((f=e[h])||(f=e[h]=[]),f.push(g),i(r,h,g)),w(r,h,m);else for(;y--;)h=b[y],(g={handler:m="function"==typeof s?s:s[y],elem:r,type:h,isGesture:p,data:l,context:u,start:[],end:[],links:{prev:null,next:null}}).closure=d(g),(f=e[h])||(f=e[h]=[]),f.push(g),i(r,h,g),w(r,h,m);return{unlisten:function(){for(var e=x.length;e--;)x[e]();x.length=0,x=null}}},unlisten:function(r,i,o){var s,l,c,d=!1;if(Boolean(a[i]))for(l=(s=t[i])&&s.length||0;l--;)(c=s[l]).handler===o&&c.elem===r&&(u(r,i,c),s.splice(l,1),d=!0);else for(l=(s=e[i])&&s.length||0;l--;)(c=s[l]).handler===o&&c.elem===r&&(n(r,i,c.closure),s.splice(l,1),d=!0);return d},fire:function(t,r,n,a){var i,o,l,u;if(t.ownerDocument&&t.ownerDocument===c)c.createEvent?((u=c.createEvent("HTMLEvents")).initEvent(r,!0,!0),n&&n.originalEvent&&(n.originalEvent=u),"function"==typeof t[r]&&t[r](),t.dispatchEvent(u),a&&!u.returnValue&&a(u)):((u=c.createEventObject()).eventType=r,n&&(n.originalEvent?n.originalEvent=u:(0,s["default"])(u,n)),"function"==typeof t[r]&&t[r](),t.fireEvent("on"+r,u),a&&!u.returnValue&&a(u));else for(o=(i=e[r])&&i.length||0;o--;)(l=i[o]).elem===t&&l.closure(n)}}};t["default"]=y},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e,t,r,n){var a;if("object"!=typeof e&&"object"!=typeof t)return null;if("object"!=typeof t||null===t)return e;void 0===e&&(e=t instanceof Array?[]:{});if(n)for(a in t)e[a]=t[a];else i(e,t,r);return e},t.cacher=t.showRecursively=t.loadRefImage=t.dashedAttr2CSSMap=t.getArrayCopy=t.merge=void 0;/Firefox/i.test(window.navigator.userAgent);var n=function(e,t){for(var r=t.length,n=-1;r--;)if(e===t[r])return n=r;return n},a=function(e){var t,r,n;for(t=0,r=e.length,n=new Array(r);t<r;t++)n[t]=e[t];return n},i=function o(e,t,r,a,i){var s,l,c,u,d;if(i?(a.push(e),i.push(t)):(a=[e],i=[t]),t instanceof Array)for(s=0;s<t.length;s+=1){try{l=e[s],c=t[s]}catch(f){continue}"object"!=typeof c?r&&void 0===c||(e[s]=c):(null!==l&&"object"==typeof l||(l=e[s]=c instanceof Array?[]:{}),-1!==(d=n(c,i))?l=e[s]=a[d]:o(l,c,r,a,i))}else for(s in t){try{l=e[s],c=t[s]}catch(f){continue}null!==c&&"object"==typeof c?"[object Object]"===(u=Object.prototype.toString.call(c))?(null!==l&&"object"==typeof l||(l=e[s]={}),-1!==(d=n(c,i))?l=e[s]=a[d]:o(l,c,r,a,i)):"[object Array]"===u?(null!==l&&l instanceof Array||(l=e[s]=[]),-1!==(d=n(c,i))?l=e[s]=a[d]:o(l,c,r,a,i)):e[s]=c:e[s]=c}return e};t.merge=i,t.getArrayCopy=a,t.showRecursively=function(e){for(var t={},r=e,n=t;r;)r.node&&r.node.style&&"none"===r.node.style.display&&(r.show(),n._doHide=!0),r=r.parent,n.parent={},n=n.parent;return function(){for(var r=e,n=t;r;)n._doHide&&r.hide(),r=r.parent,n=n.parent}},t.loadRefImage=function(e,t){var r=t.src,n=e._.RefImg;n||(n=e._.RefImg=new Image),t.src!==undefined&&(n.src=r,e._.RefImg=n)},t.dashedAttr2CSSMap={"font-family":"fontFamily","font-size":"fontSize","text-anchor":"textAnchor","font-weight":"fontWeight","letter-spacing":"letterSpacing","font-style":"fontStyle"};t.cacher=function(e,t,r,n,i,o,s){var l=o||{},c=0;return l.__start===undefined&&(l.__start=null),l.__end===undefined&&(l.__end=null),i=i||1e3,n=n||"item",function(o){var u,d,f,h=s?o:a(arguments).join("␀");return(u=l[h=""===h?"__blank":h])?u.__prev&&(l[u.__prev].__next=u.__next,u.__next?u.__next.__prev=u.__prev:l.__end=u.__prev):(u=l[h]={},e&&(l[h][n]=r?r(e.apply(t,arguments)):e.apply(t,arguments)),null===l.__end&&(l.__end=h),++c>i&&l.__end&&(d=l[l.__end],l[d.__prev].__next=null,delete l[l.__end],l.__end=d.__prev,c--)),(f=l.__start)!==u&&(u.__prev=null,u.__next=f,f&&(f.__prev=h),l.__start=u),l[h][n]}}},function(e,t,r){"use strict";t.__esModule=!0,t.convertColor=function(e,t,r){var n,a,i=0,o=0,s=0,l=t;r&&r.match(u)&&(a=r.split(","),i=a[0].slice(a[0].indexOf("(")+1),o=a[1],s=a[2],l||0===l||(l=parseInt(100*a[3].slice(0,a[3].indexOf(")")),10)));if(e)if(e.match(u))a=e.split(","),i=a[0].slice(a[0].indexOf("(")+1),o=a[1],s=a[2];else{switch((n=e.replace(d,"").split(",")[0]).length){case 3:n=n.charAt(0)+n.charAt(0)+n.charAt(1)+n.charAt(1)+n.charAt(2)+n.charAt(2);break;case 6:break;default:n=(n+"FFFFFF").slice(0,6)}i=parseInt(n.slice(0,2),16)||0,o=parseInt(n.slice(2,4),16)||0,s=parseInt(n.slice(4,6),16)||0}l||0===l||(l=100);"string"==typeof l&&(l=l.split(",")[0]);return l=parseInt(l,10)/100,"rgba("+i+","+o+","+s+","+l+")"},t.getDarkColor=m,t.getLightColor=v,t.mapSymbolName=function(e,t){var r=n,o=e;(o=f(o))>=3&&(r=(t?i:a)+o);return r},t.getColumnColor=function(e,t,r,n,a,i,o,s,l){var c,u,d,f,h,g,b,y=e,x=t;u=y.split(","),d=x.split(","),f=i.split(","),b=o.split(","),y=y.replace(/\s/g,"").replace(/\,$/,""),l?c={FCcolor:{color:u[0],alpha:d[0]}}:a?(h=u[0],g=d[0],c={FCcolor:{color:m(h,75)+","+v(h,10)+","+m(h,90)+","+v(h,55)+","+m(h,80),alpha:g+","+g+","+g+","+g+","+g,ratio:"0,11,14,57,18",angle:s?"90":"0"}},f=[m(h,70)]):(x=function(e,t,r){var n,a=e.split(","),i=r;void 0!==i&&(i=Number(i.split(",")[0]));for(i=isNaN(i)?void 0:i,a[0]=p(a[0],i),n=1;n<t;n+=1)a[n]=a[0]*p(a[n],i)/100;return a.join(",")}(x,u.length),c={FCcolor:{color:y,alpha:x,ratio:r,angle:s?-n:n}});return[c,{FCcolor:{color:f[0],alpha:b[0]}}]},t.getPointColor=function(e,t){var r=h(e),n=g(t);return{FCcolor:{gradientUnits:"objectBoundingBox",cx:.4,cy:.4,r:"100%",color:v(r,70)+","+m(r,50),alpha:n+","+n,ratio:void 0,radialGradient:!0}}},t.getAngle=function(e,t,r){var n=180*Math.atan(t/e)/Math.PI;2===r?n=180-n:3===r?n+=180:4===r&&(n=360-n);return n},t.parseColor=b,t.getValidColor=function(e){return c.test(b(e))&&e},t.RGBtoHex=function(e){return("000000"+(e[0]<<16|e[1]<<8|e[2]).toString(16)).slice(-6)},t.rawRGBtoHEX=function(e){var t;return("000000"+((t=e.match(/[\d+]+/g).splice(0,3))[0]<<16|t[1]<<8|t[2]).toString(16)).slice(-6)},t.HEXtoRGB=function(e){var t=parseInt(e,16),r=Math.floor(t/65536),n=Math.floor((t-65536*r)/256),a=Math.floor(t-65536*r-256*n);return[r,n,a]},t.parsePointValue=f,t.getFirstColor=h,t.getFirstAlpha=g;var n="circle",a="poly_",i="spoke_",o=Math.abs,s=/\s+/g,l=/^#?/,c=/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i,u=/^rgba/i,d=/[#\s]/gi;function f(e,t){var r=e;return r=r||!1===r||0===r?Number(r):NaN,isNaN(r)?null:t?o(r):r}function h(e,t){var r=e;return""===(r=(r=r.split(",")[t||0]).replace(s,""))&&(r="000000"),r.replace(l,"#")}function g(e){var t=e;return t=parseInt(t,10),(isNaN(t)||t>100||t<0)&&(t=100),t}function p(e,t){var r=e;return r=Number(r),r=isNaN(r)?100:r,void 0!==t&&(r=r*t/100),r%101}function m(e,t){var r=e,n=t;n=n<0||n>100?100:n,n/=100,r=r.replace(d,"");var a=parseInt(r,16),i=Math.floor(a/65536),o=Math.floor((a-65536*i)/256);return("000000"+(i*n<<16|o*n<<8|(a-65536*i-256*o)*n).toString(16)).slice(-6)}function v(e,t){var r=e,n=t;n=n<0||n>100?100:n,n/=100,r=r.replace(d,"");var a=parseInt(r,16),i=Math.floor(a/65536),o=Math.floor((a-65536*i)/256);return("000000"+(256-(256-i)*n<<16|256-(256-o)*n<<8|256-(256-(a-65536*i-256*o))*n).toString(16)).slice(-6)}function b(e){return e.replace(d,"").replace(l,"#")}},function(e,t,r){"use strict";function n(e,t,r,n,a,i,o){var s={};switch(t){case"top":s.y=e;break;case"bottom":s.y=o-a-e;break;case"middle":s.y=(o-a)/2}switch(r){case"left":s.x=e;break;case"right":s.x=i-n-e;break;case"middle":s.x=(i-n)/2}return s}t.__esModule=!0,t.getAlignImage=function(e,t,r,a,i,o,s,l,c,u){var d,f,h,g,p={};switch(r){case"center":p.width=a,p.height=i,p.y=s/2-i/2,p.x=o/2-a/2;break;case"stretch":p.width=o-2*l,p.height=s-2*l,p.y=l,p.x=l;break;case"tile":p.width=a,p.height=i,p.tileInfo={},p.tileInfo.xCount=f=Math.ceil(c/a),p.tileInfo.yCount=h=Math.ceil(u/i),g=n(l,e,t,a*f,i*h,o,s),p.y=g.y,p.x=g.x;break;case"fit":d=a/i>c/u?c/a:u/i,p.width=a*d,p.height=i*d,g=n(l,e,t,p.width,p.height,o,s),p.y=g.y,p.x=g.x;break;case"fill":d=a/i>c/u?u/i:c/a,p.width=a*d,p.height=i*d,g=n(l,e,t,p.width,p.height,o,s),p.y=g.y,p.x=g.x;break;default:g=n(l,e,t,a,i,o,s),p.width=a,p.height=i,p.y=g.y,p.x=g.x}return p}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(){var e,t,r;for(t=0,r=arguments.length;t<r;t+=1)if(((e=arguments[t])||!1===e||0===e)&&!isNaN(e=Number(e)))return e;return}},function(e,t,r){"use strict";t.__esModule=!0,t.setRootSender=t.raiseEventGroup=t.raiseError=t.raiseWarning=t.disposeEvents=t.getListeners=t.triggerEvent=t.removeListener=t.addListener=void 0;var n={},a={},i=function(e,t,r,n){try{e[0].call(t,r,n||{})}catch(a){setTimeout((function(){throw a}),0)}},o=function(e,t,r){var n,o=0;if(e instanceof Array&&!t.cancelled)for(;o<e.length;o+=1)if(!0!==e[o].removed){if(e[o][1]!==t.sender&&void 0!==e[o][1]||(n=e[o][1]===t.sender?t.sender:a,i(e[o],n,t,r),!0===t.detached&&(e.splice(o,1),o-=1,t.detached=!1)),!0===t.cancelled)break}else e.splice(o,1),o-=1},s=function(){this.originalEvent&&this.originalEvent.stopPropagation&&this.originalEvent.stopPropagation.call&&this.originalEvent.stopPropagation()},l=function(){this.cancelled=!0,this.originalEvent&&this.originalEvent.stopImmediatePropagation&&this.originalEvent.stopImmediatePropagation.call?this.originalEvent.stopImmediatePropagation():this.originalEvent&&this.originalEvent.stopPropagation&&this.originalEvent.stopPropagation.call&&this.originalEvent.stopPropagation()},c=function(){return!1==(this.detached=!0)},u=function(){this.defaultPrevented=!0,this.originalEvent&&this.originalEvent.preventDefault&&this.originalEvent.preventDefault.call&&this.originalEvent.preventDefault()},d={},f=0,h=function(e,t,r,n,a,i){if(!t||!t.disposed){var h,p,m,v,b,y=e;return y=y.toLowerCase(),p=g(y,t),m=g("*",t),v=d[y],b=d["*"],(p&&p.length||m&&m.length||v&&v.length||b&&b.length)&&(h={type:y,eventType:y,eventId:f+=1,sender:t||new Error("Orphan Event"),stopPropagation:s,stopImmediatePropagation:l,cancelled:!1,preventDefault:u,defaultPrevented:!1,originalEvent:n,detached:!1,data:r,detachHandler:c},o(b,h,r),o(v,h,r),t&&(o(g("*",t),h,r),o(g(y,t),h,r))),h&&h.defaultPrevented?i&&"function"==typeof i&&i.call(t,h,r||{}):a&&"function"==typeof a&&a.call(t,h,r||{}),!0}},g=function(e,t){var r=e;if("string"==typeof r)return r=r.toLowerCase(),t?t._evtListeners&&t._evtListeners[r]:d[r];v(t,"03091559","param","::removeListener",new Error("Unspecified Event Type"))},p={type:"TypeException",range:"ValueRangeException",impl:"NotImplementedException",param:"ParameterException",run:"RuntimeException",comp:"DesignTimeError",undefined:"UnspecifiedException"},m=function(e,t,r,n,a,i){var o="#"+t+" "+(e?e.id:"unknown-source")+n+" "+i+" >> ";a instanceof Error?(a.name=p[r],a.module="FusionCharts"+n,a.level=i,a.message=o+a.message,o=a.message,setTimeout((function(){throw a}),0)):o+=a,h(i,e,{id:t,nature:p[r],source:"FusionCharts"+n,message:o})},v=function(e,t,r,n,a){m(e,t,r,n,a,"Error")};t.setRootSender=function(e){void 0===e&&(e={}),a=e},t.raiseEventGroup=function(e,t,r,a,i,o,s){var l=a.id,c=e+l;n[c]?(clearTimeout(n[c]),delete n[c]):l&&c?n[c]=setTimeout((function(){h(t,a,r,i,o,s),delete n[c]}),0):h(t,a,r,i,o,s)},t.raiseWarning=function(e,t,r,n,a){m(e,t,r,n,a,"Warning")},t.raiseError=v,t.disposeEvents=function(e){var t,r=e?e._evtListeners:d;for(t in r)r[t].length&&(r[t].length=0)},t.getListeners=g,t.triggerEvent=h,t.removeListener=function b(e,t,r){var n,a;if("function"==typeof t){if(e instanceof Array)for(a=0;a<e.length;a+=1)b(e[a],t,r);else if((n=g(e,r))instanceof Array&&n.length)for(a=n.length-1;a>=0;a-=1)n[a][0]===t&&n[a][1]===r&&(n[a].removed=!0)}else v(r,"03091560","param","::removeListener",new Error("Invalid Event Listener"))},t.addListener=function y(e,t,r,n){var a,i,o,s=e;if(s instanceof Array){for(a=[],i=0;i<s.length;i+=1)a.push(y(s[i],t,r));return a}if("string"==typeof s){if("function"==typeof t)return s=s.toLowerCase(),r?(r._evtListeners||(r._evtListeners={}),r._evtListeners[s]instanceof Array||(r._evtListeners[s]=[]),o=r._evtListeners[s]):(d[s]instanceof Array||(d[s]=[]),o=d[s]),!function(e,t,r){var n,a=e.length;for(n=0;n<a;n+=1)if(e[n][0]===t&&e[n][1]===r&&!e[n].removed)return!0}(o,t,r)&&(n&&n.priority?o.unshift([t,r]):o.push([t,r]),t);v(r,"03091550","param","::addListener",new Error("Invalid Event Listener"))}else v(r,"03091549","param","::addListener",new Error("Unspecified Event Type"))}},function(e,t,r){"use strict";t.__esModule=!0,t.addDep=function(){for(var e=this,t=arguments.length,r=new Array(t),c=0;c<t;c++)r[c]=arguments[c];if(!r.length)return void(0,n.raiseError)({id:"Extension"},"90211","dependency","Extension",new Error("A FusionCharts extension must have a valid extension property."));r.forEach((function(t){var r,c,u,d,f;t?(c=t.extension?t.extension:t,r=o(t),u=s(t),f=t.requiresFusionCharts,u?(!a[u]&&l(u),(d=a[u][r]!==c)&&(a[u][r]=c)):r&&(d=i[r]!==c)&&(i[r]=c),d&&(0,n.triggerEvent)("dependencyadded",e,{name:r,type:u}),d&&f&&c(e)):(0,n.raiseError)({id:"Extension"},"90211","dependency","Extension",new Error("A FusionCharts extension must have a valid extension property."))}))},t.getDep=function(e,t){var r,n=e&&e.toLowerCase();if(t&&a[t])return a[t][n];if(!t)for(var o in a)if(a.hasOwnProperty(o)&&(r=a[o][n]))return r;return i[n]},t.getDepsByType=function(e){void 0===e&&(e="");return""===e?a:a[e.toLowerCase()]};var n=r(231),a={},i={};function o(e){void 0===e&&(e={});var t=e.getName&&e.getName()||e.name;return void 0===t&&(0,n.raiseError)({id:"Extension"},"90211","extension","Name",new Error("A FusionCharts extension must have a getName API or a name property.")),t&&t.toLowerCase()}function s(e){void 0===e&&(e={});var t=e.getType&&e.getType()||e.type;return t&&t.toLowerCase()}function l(e){"string"==typeof e&&(a[e]={})}},function(e,t,r){"use strict";t.__esModule=!0,t.onDataUpdateSuccess=function(e,t){var r=e.sender,a=r.__state;a.dataReady=void 0,a.dataAvailable=!0,!0!==t.silent?(r.options.dataSource=t.data,!0!==r.options.safeMode||!0!==a.rendering||r.isActive()?delete a.args:(a.updatePending=t,(0,n.raiseWarning)(r,"23091255","run","::DataHandler~update","Renderer update was postponed due to async loading."))):r.options.dataSource=t.data;(0,n.triggerEvent)("dataUpdated",r,t,void 0,t.successcallback)},t.onDataUpdateCancel=function(e,t){(0,n.triggerEvent)("dataUpdateCancelled",e.sender,t,void 0,t.failurecallback)};var n=r(231)},function(e,t,r){"use strict";function n(e){delete e.sender.jsVars._reflowData,e.sender.jsVars._reflowData={},delete e.sender.jsVars._reflowClean}t.__esModule=!0,t["default"]=void 0;var a={beforeInitialize:function(e){var t,r=e.sender,n=r.jsVars;n.fcObj=r,n.msgStore=n.msgStore||{LoadDataErrorText:"Error in loading data.",XMLLoadingText:"Retrieving data. Please wait",InvalidXMLText:"Invalid data.",ChartNoDataText:"No data to display.",ReadingDataText:"Reading data. Please wait",ChartNotSupported:"Chart type not supported.",PBarLoadingText:"",LoadingText:"Loading chart. Please wait",RenderChartErrorText:"Unable to render chart."},n.cfgStore=n.cfgStore||{},n.previousDrawCount=-1,n.drawCount=0,n._reflowData={},r.addEventListener("beforeRender",(function(e){return e.detachHandler()})),n.userModules instanceof Array||(t=n.userModules,n.userModules=[],"string"==typeof t&&(n.userModules=n.userModules.concat(t.split(","))))},beforeDataUpdate:n,beforeDispose:function(e){var t=e.sender.jsVars;t.smartLabel&&!t.smartLabel.disposed&&t.smartLabel.dispose(),n.apply(void 0,arguments)},beforeRender:function(e){delete e.sender.jsVars.drLoadAttempted,n.apply(void 0,arguments)},dataLoadRequested:function(e){var t=e.sender,r=t.jsVars;delete r.loadError,t.ref&&t.options.showDataLoadingMessage?r.hcObj&&!r.hasNativeMessage&&r.hcObj.showLoading?r.hcObj.showMessage(r.msgStore.XMLLoadingText):t.ref.showChartMessage?t.ref.showChartMessage("XMLLoadingText"):r.stallLoad=!0:r.stallLoad=!0},dataLoadRequestCompleted:function(e){delete e.sender.jsVars.stallLoad}};t["default"]=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=t.globalStore=void 0;var a,i,o,s,l=r(224),c=r(231),u=r(232),d=r(236),f=n(r(237)),h=n(r(245)),g=/\%/,p=new f["default"],m=(o={},s=function x(){var e,t,r,n,s,l,c,u,d=0,f=parseInt(i.options.resizeTrackingInterval,10)||300,h={},p=function(){h.itemVar._containerOffsetW=h.parentEle.offsetWidth,h.itemVar._containerOffsetH=h.parentEle.offsetHeight};for(e in o)d+=1,r=(t=o[e]).jsVars,s=t.ref,!t.disposed&&(n=s&&s.parentNode)&&(l=s.style)&&(g.test(l.width)||g.test(l.height))?(c=n.offsetWidth,u=n.offsetHeight,!r.resizeLocked&&(c&&r._containerOffsetW!==c||u&&r._containerOffsetH!==u)&&(t.resizeTo&&t.resizeTo(),h.itemVar=r,h.parentEle=n,setTimeout(p,1))):(delete o[e],d-=1);a=d?setTimeout(x,f):clearTimeout(a)},function(e,t,r){var n=e.jsVars,l=t||e.ref&&e.ref.parentNode||{};i=r,n._containerOffsetW=l.parentNode.offsetWidth,n._containerOffsetH=l.parentNode.offsetHeight,o[e.id]=e,a||(a=setTimeout(s,parseInt(r.options.resizeTrackingInterval,10)||300))});function v(e,t,r){void 0===r&&(r=!1);var n=this.apiInstance,a=this.getChartData((0,u.getDepsByType)("transcoder").JSON,!0,!0).data;r||(0,c.triggerEvent)("dataloaded",this,{},[this.id]),this.__state&&(this.__state.newDataArrived=!1),n.addToEnv("dataSource",a),n.addToEnv("chart-attrib",a.chart||{}),n._checkInvalidData()||n._checkInvalidSpecificData()?(n.getContainer("parentgroup")&&n.getContainer("parentgroup").hide(),n.createBaseComponent(),n.getFromEnv("animationManager").setAnimationState("chartmessage"),n.setChartMessage(),n.drawChartMessage(),this._sudoSetState(1),(0,c.triggerEvent)("nodatatodisplay",this,{},[this.id])):(n.config.hasChartMessage=!1,n.setData(Object.assign({},a)))}function b(e){var t=e.sender.args,r=l.BLANK,n=t.dataFormat||"json";"jsonurl"!==n.toLowerCase()&&"xmlurl"!==n.toLowerCase()||(r=t.dataSource),(0,c.triggerEvent)("dataloadcancelled",e,{url:r,dataFormat:n},[e.id]),e.__state&&(e.__state.newDataArrived=!1)}t.globalStore=p;var y=function(e,t,r,n,a,i,o,s){var f,y,x,w,C,k=n,_=t.apiInstance,S=t.jsVars,E=g.test(t.width)?r.offsetWidth:t.width,A=g.test(t.height)?r.offsetHeight:t.height;if(r.FusionCharts=e.items[t.id],t.__state.beforedrawFired=!0,k=k||t.chartType(),!(f=(0,u.getDep)(k,"chartapi"))&&(x=(0,u.getDep)(k,"maps"))&&(f=(0,u.getDep)("maps","chartapi"),w=!0),_&&_.getName().toLowerCase()!==k.toLowerCase()&&(_.remove({instant:!0}),_=l.UNDEF),_&&_.getName().toLowerCase()===k.toLowerCase()||(_=t.apiInstance=new f,p.attachChild(_,"chartAPI"),_.addToEnv("core-options",e.options),_.addToEnv("chartInstance",t),_.addToEnv("chart",_),_.addToEnv("chart-container",r),_.addToEnv("eventListeners",[])),w)for(var N in x=x[0])x.hasOwnProperty(N)&&(_.config[N]=x[N]);if(_.addToEnv("chartWidth",Math.max(0,E)),_.addToEnv("chartHeight",Math.max(0,A)),_._removeWaitingJobs(),_.setDummyEImethods(k),_.config.origRenderWidth=t.__state.renderedWidth,_.config.origRenderHeight=t.__state.renderedHeight,"base"===k||i)!function(e,t){void 0===t&&(t=!1);var r=e.options.dataErroneous;if(r)return e.__state.dataReady=!1,t||(0,c.triggerEvent)("dataInvalid",e,{error:r},l.UNDEF,(function(){(0,c.triggerEvent)("dataxmlinvalid",e,{},[e.id])})),!0}(t,s),function(e,t){void 0===t&&(t={});e._chartMessageImageStyle=t.image||{},e._chartMessageStyle=t.message||{}}(t,o),_.createBaseComponent(),_.getFromEnv("animationManager").setAnimationState("chartmessage"),_.setChartMessage(i,t,r);else if(t.__state.resize)_.asyncDraw();else{if(_.getFromEnv("toolTipController")||(C=new((0,u.getDep)("ToolTipController"))(r,_),_.addToEnv("toolTipController",C)),_.disposeChartStyleSheet(),r.jsVars=t.jsVars,y=_.eiMethods,t.ref=r,S.type=k,y&&"string"!=typeof y)for(var T in y)r[T]=y[T];!s&&t.__state.newDataArrived?(0,c.triggerEvent)("beforedataload",t,{data:t.getChartData((0,u.getDepsByType)("transcoder").JSON,!0,!0)},l.UNDEF,v,b):v.call(t,l.UNDEF,l.UNDEF,s)}!t.disposed&&function(e,t,r,n,a){var i=e.jsVars,o=e.apiInstance,s=i.fcObj,f=i.overlayButton,g=s.getChartData((0,u.getDepsByType)("transcoder").JSON,!0,!0).data;i.width=o.getFromEnv("chartWidth"),i.height=o.getFromEnv("chartHeight"),i.container=t,i.hcObj=e,i.hcObj.container=t,i.instanceAPI=o,e.hasRendered&&i.overlayButtonActive&&f&&(f.innerHTML=l.BLANK,f.appendChild(document.createTextNode(i.overlayButtonMessage)),e.container.appendChild(f));(g.data||g.dataset)&&(/\%/g.test(s.width)||/\%/g.test(s.height))&&t&&t.parentNode&&!a.options.preventTrackResize&&m(e,t,a);!function(e,t,r,n){e.apiInstance.addJob("fire-rendered",(function(){if(e.apiInstance.config.hasRendered=r.hasRendered,"waiting"!==e._getState()&&"function"==typeof t&&t(r),"waiting"!==e._getState()&&((0,c.triggerEvent)("drawcomplete",e,{width:e.jsVars.width,height:e.jsVars.height,drawCount:e.jsVars.drawCount,displayingMessage:"waiting"===e._getState()||"error"===e._getState(),renderer:"javascript"},[e.id]),e.__state&&delete e.__state.beforedrawFired),!e.disposed&&"ready"===e._getState()){if(e.__state.rendering&&(0,c.triggerEvent)("rendered",e,{renderer:"javascript"},[e.id]),e.disposed)return;if((0,c.triggerEvent)("renderComplete",e,{width:e.jsVars.width,height:e.jsVars.height,drawCount:e.jsVars.drawCount,renderer:"javascript"}),e.disposed)return;e.__state&&delete e.__state.rendering,e.__state.renderComplete=!0,e.args.creditLabel!==l.UNDEF&&console.warn("FusionCharts.options.creditLabel property is deprecated. Please use FusionCharts.options.license with a valid license key to remove the watermark."),h["default"]._mapperParent(n,e)}}),d.priorityList.postRender)}(e,r,n,a)}(t,r,a,{hasRendered:!0,container:r},e)};t["default"]=y},function(e,t,r){"use strict";t.__esModule=!0,t.priorityList=t["default"]=void 0;var n=[],a={},i=[],o={},s=0,l=window,c=l.navigator,u=/trident/i.test(c.userAgent)&&/rv:11/i.test(c.userAgent)&&!l.opera,d=/msie/i.test(c.userAgent)&&!l.opera,f=/Edge/.test(c.userAgent),h={},g=l.requestAnimationFrame||l.webkitRequestAnimationFrame||l.mozRequestAnimationFrame||l.oRequestAnimationFrame||l.msRequestAnimationFrame||function(e){setTimeout(e,16)},p=!1,m=function b(){var e,t,r,a=!0,s=(new Date).getTime();for(p=!0;a&&(e=n[0]);)t=(new Date).getTime(),e.OIAF&&r||e.executeAfter&&!(e.executeAfter<t)||!(t-s<16)?a=!1:(n.shift(),i[e.priority]-=1,o[e.jobID]&&!e.executed&&(e.executed=!0,delete o[e.jobID],e.job(),r=e.OIAF));n.length?g(b):p=!1};t.priorityList={instant:1,render:1,chartEvents:1,configure:2,chartClick:2,draw:3,entitydraw:4,label:4,animation:5,tracker:6,kdTree:6,postRender:7,verification:8},(u||d||f)&&(g=g.bind(window)),h.addJob=function(e,t,r){var a,l,c,u=0,d=r&&r.oneInAFrame,f=r&&r.addToTop?t-1:t;for("function"==typeof e?(l={job:e,priority:t,OIAF:d,jobID:a="JOB_"+ ++s+"_"+(t||1)},r&&r.executionDelay&&(l.executeAfter=(new Date).getTime()+r.executionDelay)):l=e,c=0;c<=f;c++)u+=i[c]||0;return n.splice(u,0,l),o[l.jobID]=l,i[t]=(i[t]||0)+1,p||1!==n.length||(d?g(m):setTimeout(m,0)),a},h.removeJob=function(e){o[e]&&delete o[e]},h.updateJob=function(e,t,r,n){return o[e]?(o[e].job=t,e):this.addJob(t,r,n)},h.pauseExecution=function(e){if(!o[e])return!1;a[e]=o[e],delete o[e]},h.resumeExecution=function(e){var t=a[e];if(!t)return!1;h.addJob(t,t.priority),delete a[e]};var v=h;t["default"]=v},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"globalStore"},r.getType=function(){return"globalStore"},t}(r(240).ComponentInterface);t["default"]=i},function(e,t,r){var n=r(239);e.exports=function(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,n(e,t)},e.exports["default"]=e.exports,e.exports.__esModule=!0},function(e,t){function r(t,n){return e.exports=r=Object.setPrototypeOf||function(e,t){return function(e,t){for(var r=Object.getOwnPropertyNames(t),n=0;n<r.length;n++){var a=r[n],i=Object.getOwnPropertyDescriptor(t,a);i&&i.configurable&&e[a]===undefined&&Object.defineProperty(e,a,i)}}(e,t),e},e.exports["default"]=e.exports,e.exports.__esModule=!0,r(t,n)}e.exports=r,e.exports["default"]=e.exports,e.exports.__esModule=!0},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0;var a=n(r(241));t.ComponentInterface=a["default"];var i=n(r(244));t.SmartRenderer=i["default"]},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=s(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(243));function s(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(s=function(e){return e?r:t})(e)}var l=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r._components={},r._version=1,r.fireEvent("instantiated"),r.__setDefaultConfig(),t}(0,i["default"])(t,e);var r=t.prototype;return r.addGraphicalElement=function(e,t,r,n){void 0===r&&(r=!1);var a=this._graphics;return t&&(r?(void 0===a[e]&&(a[e]=[]),n?a[e][n]=t:a[e].push(t)):(a[e]=t,this.fireEvent("graphicalelementattached",{element:t})),(0,o.addAllEventsOnGraphic)(t,this._middleListeners,this)),t},r.removeGraphicalElement=function(e){var t,r=this,n=r._graphics;(0,o._mapSubFnForward)(n,(function(a,i,s){a===e&&(t=!0,(0,o.removeAllEventsFromGraphic)(a,r._middleListeners),r._setRemoveAnim(a,i),void 0!==s?n[i].splice(s,1):delete n[i])})),t&&this.fireEvent("graphicalelementremoved",{element:e})},r.getGraphicalElement=function(e){return void 0!==e?this._graphics[e]:this._graphics},r.addChildContainer=function(e,t){var r=this._childContainers;return t&&(void 0===r&&(r=this._childContainers={}),r[e]=t,(0,o.addAllEventsOnGraphic)(t,this._middleListeners,this)),t},r.removeChildContainer=function(e){var t=this._childContainers;t&&t[e]&&((0,o.removeAllEventsFromGraphic)(t[e],this._middleListeners),this._setRemoveAnim(t[e],e),delete t[e])},r.getChildContainer=function(e){return void 0===this._childContainers&&(this._childContainers={}),e?this._childContainers[e]:this._childContainers},r.addContainer=function(e,t){var r=this._containers;return t&&(void 0===r&&(r=this._containers={}),r[e]=t),t},r.removeContainer=function(e){var t=this._containers;t&&t[e]&&(this._setRemoveAnim(t[e],e),delete t[e])},r.getContainer=function(e){return void 0===this._containers&&(this._containers={}),e?this._containers[e]:this._containers},r.addEventListener=function(t,r,n){var a=e.prototype.addEventListener.call(this,t,r,n);return!0===a?(function(e,t,r){var n;t&&r&&(n=function(e){e.on&&e.on(t,r)},(0,o._mapSubFnForward)(e.getGraphicalElement(),n),(0,o._mapSubFnForward)(e.getChildContainer(),n))}(this,t,this._middleListeners[t]),r):!!a&&r},r.removeEventListener=function(t,r){e.prototype.removeEventListener.call(this,t,r)&&function(e,t,r){var n;t&&r&&(n=function(e){e.off&&e.off(t,r)},(0,o._mapSubFnForward)(e.getGraphicalElement(),n),(0,o._mapSubFnForward)(e.getChildContainer(),n))}(this,t,this._middleListeners[t])},r._dispose=function(){var t;if(e.prototype._dispose.call(this)){for(t in this.getFromEnv("paper")&&!this.getFromEnv("paper").removed&&((0,o._mapSubFnForward)(this.getChildContainer(),this.__instantRemoveFn),(0,o._mapSubFnForward)(this.getGraphicalElement(),this.__instantRemoveFn),(0,o._mapSubFnForward)(this.getContainer(),this.__instantRemoveFn)),this)this.hasOwnProperty(t)&&delete this[t];this.fireEvent("removed")}},r.removingDraw=function(){(0,o._mapSubFnForward)(this.getChildContainer(),this._setRemoveAnim),(0,o._mapSubFnForward)(this.getGraphicalElement(),this._setRemoveAnim),(0,o._mapSubFnForward)(this.getContainer(),this._setRemoveAnim)},r.attachChild=function(e,t,r){var n=t||e.getType(),a=this._components;return!1===r?a[n]=e:(a[n]&&a[n]instanceof Array||(a[n]=[]),a[n].push(e)),e._setLinkedParent(this),this.fireEvent("childattached",{attachedChild:e}),e},r.getChild=function(e){var t;return void 0===e?this._components:(this._searchChildren(e,(function(e){t=e})),t)},r._searchChildren=function(e,t){var r,n,a,i=this._components;for(n in i)if(i.hasOwnProperty(n))if((r=i[n]).constructor===Array){for(a=r.length-1;a>=0;a--)if(r[a].getId&&r[a].getId()===e)return t(r[a],a,r)}else if(r.getId&&r.getId()===e)return t(n,void 0,i)},r.getChildren=function(e){return e?this._components[e]:this._components},t}(o["default"]);t["default"]=l},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports["default"]=e.exports,e.exports.__esModule=!0},function(e,t,r){"use strict";t.__esModule=!0,t._mapSubFnForward=t.addAllEventsOnGraphic=t.removeAllEventsFromGraphic=t["default"]=void 0;var n=r(224),a=r(231),i=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=o(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var s=a?Object.getOwnPropertyDescriptor(e,i):null;s&&(s.get||s.set)?Object.defineProperty(n,i,s):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(236));function o(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(o=function(e){return e?r:t})(e)}var s=function(e){e&&e.draw&&e.syncDraw()},l=function(e){return e.setDefaults()},c=function(e){e.prepareAttributes&&e.prepareAttributes()},u={},d={executionDelay:16},f=function(e,t){var r,n,a,i;if(e&&e.hasOwnProperty&&t&&t.call)for(r in e)if(e.hasOwnProperty(r))if((n=e[r])instanceof Array)for(i=n.length,a=0;a<i;a++)t(n[a],r,a);else t(n,r)};t.removeAllEventsFromGraphic=function(e,t){var r,n;if(t&&t.hasOwnProperty)for(r in t)t.hasOwnProperty(r)&&(n=(0,a.getListeners)(r,this))&&n.length>=1&&e&&e.off(r,t[r])},t.addAllEventsOnGraphic=function(e,t,r){var n,i;if(t&&t.hasOwnProperty)for(n in t)t.hasOwnProperty(n)&&(i=(0,a.getListeners)(n,r))&&i.length>=1&&e&&e.on(n,t[n])},t._mapSubFnForward=f;var h=function(){function e(){var e=this;e.config={},e._jobList={},e._env={},e._extListeners={},e._state={},e._factories=[],e._factoriyNames={},e._graphics={},e.__drawJob=function(){e.updateVisual()},e.computeFontSize=n.computeFontSize.bind(e),e.__remove=function(){e.getState("removed")&&e._dispose()},e._setRemoveAnim=function(t,r){var n=e.getFromEnv("animationManager");n.setAnimation({el:t,component:e,label:r,props:t.__props}),e._setRemoveAnim=function(t,r){n.setAnimation({el:t,component:e,label:r,props:t.__props})}},e.__instantRemoveFn=function(t){var r=e.getFromEnv("animationManager");r.removeElement(t,!0),e.__instantRemoveFn=function(e){return r.removeElement(e,!0)}}}var t=e.prototype;return t.configure=function(e){this.preConfigure(e),this.configureAttributes(e),this.postConfigure(e),this.invokeFactories()},t.preConfigure=function(e){this.fireEvent("preconfigure",e)},t.configureAttributes=function(){return this},t.postConfigure=function(e){this.fireEvent("postconfigure",e)},t.prepareAttributes=function(){this.fireEvent("beforeattributeprepared"),this.allocatePosition&&this.allocatePosition(),this._mapChildren(c),this.fireEvent("attributeprepared")},t.setDefaults=function(){this.__setDefaultConfig(),this._mapChildren(l)},t.__setDefaultConfig=function(){return this},t.setData=function(e,t){void 0===t&&(t=!1);var r,n=this.getLinkedParent();this.asyncDraw(),!t&&this.setDefaults(),this.configure&&this.configure(e),(r=this.getState("change-info"))&&r.hasNoExternalEffect||n&&n.childChange&&n.childChange(r,this.getId())},t.getName=function(){return"generic"},t.getType=function(){return"generic"},t.getComponentVersion=function(){return this._version},t.getId=function(){return this._id||this.setId(),this._id},t.setId=function(e){var t,r=e;r===n.UNDEF&&(t=this.getType()+n.UNDERSCORE+this.getName(),u[t]||(u[t]=1),r=t+n.UNDERSCORE+u[t],u[t]+=1),this._id=r},t.iterateComponents=function(e){this._mapChildren((function t(r,n,a){!1!==e(r,n,a)&&r._mapChildren&&r._mapChildren(t)}))},t.getFromEnv=function(e){return e?this._env[e]:this._env},t.addToEnv=function(e,t){e&&(this._env[e]=t)},t.deleteFromEnv=function(e){delete this._env[e]},t._updateParentEnv=function(){var e,t,r,n,a=this.getLinkedParent(),i=this._env;if(a){if(e=a.getFromEnv(),((t=function(){}).prototype=e).constructor=t,r=new t,i)for(n in i)i.hasOwnProperty(n)&&(r[n]=i[n]);this._env=r,this._mapChildren((function(e){e._updateParentEnv&&e._updateParentEnv()}))}},t.addJob=function(e,t,r,n){this._jobList[e]?this._jobList[e]=i["default"].updateJob(this._jobList[e],t,r,n):this._jobList[e]=i["default"].addJob(t,r,n)},t.removeJob=function(e){var t=this._jobList[e];t&&(i["default"].removeJob(t),delete this._jobList[e])},t.removeAllJobs=function(){var e,t=this._jobList;for(e in t)t.hasOwnProperty(e)&&(i["default"].removeJob(t[e]),delete t[name])},t.asyncDraw=function(){this.addJob("draw",this.__drawJob,i.priorityList&&i.priorityList.draw,d)},t.syncDraw=function(){var e=this;e.fireEvent("predraw"),e.removeJob("draw"),e.getState("removed")?e.removingDraw():e.draw&&e.draw(),e.addExtEventListener("animationComplete",e.__remove,e.getFromEnv("animationManager")),e.childrenSyncDraw(),e.setState("dirty",!1),e.setState("parentChanged",!1),e.addJob("draw-complete",(function(){e.fireEvent("drawn")}),i.priorityList.instant)},t.updateVisual=function(){this.fireEvent("beforevisualupdate"),this.removeJob("visualupdate"),this.manageSpace&&this.manageSpace(),this.prepareAttributes(),this.syncDraw(),this.fireEvent("visualupdated")},t.childrenSyncDraw=function(){this._mapChildren(s)},t.addEventListener=function(e,t,r){var i,o=this,s=e;return!!(s&&s.toLowerCase&&(s=s.toLowerCase(),(0,a.addListener)(s,t,o,r)))&&((0,n.isInterActiveEvt)(s)&&(i=(0,a.getListeners)(s,o))&&1===i.length?(o._middleListeners||(o._middleListeners={}),o._middleListeners[s]||(o._middleListeners[s]=function(e){o.fireEvent(s,n.UNDEF,n.UNDEF,n.UNDEF,e)}),!0):t)},t.removeEventListener=function(e,t){var r,i=e;if(i&&i.toLowerCase&&(i=i.toLowerCase(),(0,a.removeListener)(i,t,this),(0,n.isInterActiveEvt)(i)&&(r=(0,a.getListeners)(i,this))&&0===r.length&&this._middleListeners&&this._middleListeners[i]))return!0},t.fireEvent=function(e,t,r,n,i){(0,a.triggerEvent)(e,this,t,i,r,n)},t.showWarning=function(e,t,r,n){(0,a.raiseWarning)(this.getFromEnv("chartInstance"),e,t,r,n)},t.showError=function(e,t,r,n){(0,a.raiseError)(this.getFromEnv("chartInstance"),e,t,r,n)},t.addExtEventListener=function(e,t,r){return!!(r&&r.addEventListener&&r.addEventListener(e,t))&&(this._extListeners[e]||(this._extListeners[e]=[]),this._extListeners[e].push({fn:t,component:r}),t)},t.removeExtEventListener=function(e,t,r){var n,a;if(r&&r.addEventListener&&this._extListeners&&this._extListeners[e])for(n=(a=this._extListeners[e]).length-1;n>=0;n-=1)if(a[n]&&a[n].fn===t&&a[n].component===r)return r.removeEventListener(e,t),void a.splice(n,1)},t._setLinkedParent=function(e){var t=this._linkedParent;this._linkedParent=e,t&&t!==e&&(this.setState("parentChanged",!0),this.fireEvent("parentdetached",{oldParent:t}),e&&this.fireEvent("parentAttached",{newParent:e})),this._updateParentEnv&&this._updateParentEnv()},t.getLinkedParent=function(){return this._linkedParent},t.setLinkedItem=function(e,t){this.linkedItems||(this.linkedItems={}),e===n.UNDEF&&t===n.UNDEF||(this.linkedItems[e]=t)},t.getLinkedItem=function(e){if(this.linkedItems)return e!==n.UNDEF?this.linkedItems[e]:this.linkedItems},t.removeLinkedItem=function(e){this.linkedItems&&this.linkedItems[e]&&delete this.linkedItems[e]},t._detachChild=function(e){var t,r=e&&e.getId(),a=this;return r===n.UNDEF?n.UNDEF:(a._searchChildren(r,(function(e,r,i){i&&i.constructor===Array?t=i.splice(r,1)[0]:(t=i[e],delete i[e]),t._setLinkedParent(n.UNDEF),a.fireEvent("childdetached",{detachedChild:t})})),t)},t._mapChildren=function(e,t){t?function(e,t){var r,n,a;if(e&&e.hasOwnProperty&&t&&t.call)for(r in e)if(e.hasOwnProperty(r))if((n=e[r])instanceof Array)for(a=n.length-1;a>=0;a--)t(n[a],r,a);else t(n,r)}(this.getChildren(),e):f(this.getChildren(),e)},t._dispose=function(){var e,t,r,n;if(this&&this!==window&&!0!==this._disposing){if(this._disposing=!0,this.fireEvent("beforeremove"),(e=this.getLinkedParent())&&e._detachChild&&!e._disposing&&e._detachChild(this),this._extListeners)for(r in this._extListeners)for(t=(n=this._extListeners[r]).length-1;t>=0;t--)n[t].component&&n[t].component.addEventListener&&n[t].component.removeEventListener(r,n[t].fn);return this.removeAllJobs(),!0}},t.remove=function(e){this.setState("removed",!0),this.getChildren()&&this._mapChildren((function(t){t&&t.remove&&t.remove(e)}),!0),e&&e.instant&&this._dispose()},t.setState=function(e,t){this._state[e]=t},t.getState=function(e){return this._state&&this._state[e]},t.registerFactory=function(e,t,r){var n={name:e,factory:t,dep:r};if(this._factoriyNames[e])for(var a=0,i=this._factories.length,o=!1;a<i&&!o;a+=1)this._factories[a].name===e&&(this._factories.splice(a,1),o=!0);this._factories.push(n),this._factoriyNames[e]=!0},t.deregisterFactory=function(e){if(this._factoriyNames[e])return delete this._factoriyNames[e],this._factories.splice(this._factories.findIndex((function(t){return t.name===e})),1)[0].factory},t.invokeFactories=function(){for(var e,t=this,r=t._factoriyNames,n={},a=t._factories,i=a.length+1,o=function(a){var i;a.dep&&a.dep.length&&a.dep.forEach((function(e){i=r[e]&&!n[e]})),i?e.push(a):(a.factory(t),n[a.name]=!0)};a.length&&a.length<i;)e=[],a.forEach(o),i=a.length,a=e;a.length&&a.forEach((function(e){return e.factory(t)})),this.fireEvent("factoriesinvoked",{})},e}();t["default"]=h},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=c(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(243)),s=r(224),l=r(236);function c(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(c=function(e){return e?r:t})(e)}var u=function(e,t){var r,n,a;if(e&&e.hasOwnProperty&&t&&t.call)for(r in e)for(a=(n=e[r].elemStore)&&n.length-1;a>=0&&!t(n[a],r,a);a--);},d=function(e,t){var r,n,a,i;if(e&&e.hasOwnProperty&&t&&t.call)for(n in e)for(i=0,r=(a=e[n].elemStore)&&a.length;i<r&&!t(a[i],n,i);i++);},f=function(e,t,r){var n,a,i,o;for(o in void 0===r&&(r={}),e)a=e[o],(i=(0,s.pluck)(t[o],r[o]))!==s.UNDEF?a instanceof Array?"text-bound"===o?(n||(n={}),n[o]=a,n.x=e.x,n.y=e.y):a.toString().replace(/,/g,"")!==i.toString().replace(/,/g,"")&&(n||(n={}),n[o]=a):"string"==typeof a?a.replace(/,/g,"")!==i.toString().replace(/,/g,"")&&(n||(n={}),n[o]=a):a!==i&&(n||(n={}),n[o]=a):(n||(n={}),n[o]=a);return n},h=function(e){function t(t){var r;r=e.call(this,t)||this;var n=(0,a["default"])(r);return n._version=2,n._id=t,n._componentStore={},n._oldComponentStore=[],n.fireEvent("instantiated"),n.__setDefaultConfig(),r}(0,i["default"])(t,e);var r=t.prototype;return r.isDrawingRequired=function(){return this},r.syncDraw=function(){var e=this,t=e.getState("removed");(e.isDrawingRequired()||t)&&(e.fireEvent("predraw"),e.removeJob("draw"),e._resetGraphicalStore(),t?e.addJob("dispose-component",(function(){return e._dispose()}),l.priorityList.postRender):e.draw&&e.draw(),e.childrenSyncDraw(),e._removeUnusedGraphics(),e.fireEvent("drawn"))},r._remove=function(){this.onRemove&&this.onRemove(),this.setState("removed",!0),this.getChildren()&&this._mapChildren((function(e){e.onRemove&&e.onRemove(),e&&e.setState("removed",!0)}),!0)},r.setDimension=function(e,t){this.config.width=e,this.config.height=t},r.setTranslation=function(e,t){var r=this.config;r._translateX=e,r._translateY=t,r.translate="t"+e+","+t},r.getTranslation=function(){return{x:this.config&&this.config._translateX,y:this.config&&this.config._translateY}},r._resetGraphicalStore=function(){this._oldGraphicalStore=this._graphicalStore,this._graphicalStore={}},r._getLastUsedElem=function(){return this.config.lastElemUsed},r.addGraphicalElement=function(e,t){void 0===e&&(e={}),void 0===t&&(t=!1);var r,n,a,i,l,c=e.label,u=this._graphicalStore[c]||(this._graphicalStore[c]={elemStore:[],idMap:{},indexMap:{},lastIndexUsed:-1}),d=!0,h=this._oldGraphicalStore&&this._oldGraphicalStore[c],g=u.lastIndexUsed+=1,p=e.attr,m=e.id;h&&(m&&h.idMap[m]!==s.UNDEF?(i=h.idMap[m],l=h.elemStore[i],delete h.elemStore[i],delete h.indexMap[i],delete h.idMap[m]):h.elemStore[g]&&(h.indexMap[g]||(l=h.elemStore[g],delete h.elemStore[g]))),"text"===e.el&&e.css&&(0,s.removeHtmlAttrs)(e.css),l&&(e.el=l,d=!1,(p=f(e.attr,l.attrs))&&(e.attr=p),e.css&&(n=f(e.css,l.attrs,l.styles))&&(e.css=n)),(a=e.container)?(r=a.isParent?this.getLinkedParent():this,e.container=r.getGraphicalElement(a.id,a.label)||r.getChildContainer(a.id)):e.container=this.getFromEnv("chart-container"),(p||n)&&(l=this.getFromEnv("animationManager").setAnimation(e)),u.elemStore[g]=l,m&&(u.idMap[m]&&(delete u.indexMap[u.idMap[m]],delete u.idMap[m]),u.idMap[m]=g,u.indexMap[g]=m),this.fireEvent("graphicalelementattached",{element:l}),l._skipEvents=t,e.shadow&&l.shadow(e.shadow),e.outlineText!==s.UNDEF&&l.outlineText(e.outlineText,(0,s.convertColor)((0,s.pluck)(e.css.fill,e.attr.fill))),e.tooltext!==s.UNDEF&&this.getFromEnv("toolTipController").enableToolTip(l,e.tooltext),this.config.lastElemUsed=l,!t&&d&&(0,o.addAllEventsOnGraphic)(l,this._middleListeners,this)},r.removeGraphicalElement=function(e,t){var r,n,a=this,i=a._graphicalStore;u(i,"object"==typeof e?function(t,o,s){if(e===t)return n=!0,a._setRemoveAnim(t,o),(r=i[o]).elemStore.splice(s,1),delete r.idMap[r.indexMap[s]],delete r.indexMap[s],!0}:function(o,s,l){if((r=i[s]).indexMap[l]===e&&(!t||t===s))return n=!0,a._setRemoveAnim(o,s),r.elemStore.splice(l,1),delete r.idMap[r.indexMap[l]],delete r.indexMap[l],!0}),n&&this.fireEvent("graphicalelementremoved",{element:void 0})},r.getChildContainer=function(e){return this.getGraphicalElement(s.UNDEF,e)},r._removeUnusedGraphics=function(){var e,t=this,r=t._oldGraphicalStore;u(r,(function(n,a,i){n&&(t._setRemoveAnim(n,a),delete(e=r[a]).idMap[e.indexMap[i]],delete e.indexMap[i])}))},r.getGraphicalElement=function(e,t){var r,n,a,i,o=this._graphicalStore;return t||e?t?(r=o[t],e?r&&r.elemStore&&r.elemStore[r.idMap[e]]:r&&r.elemStore&&r.elemStore[0]):(d(o,(function(){if(i=arguments[2],(n=o[arguments[1]]).idMap[i]===e)return a=n.elemStore[i],!0})),a):o},r.addEventListener=function(t,r,n){var a=e.prototype.addEventListener.call(this,t,r,n);return!0===a?(function(e,t,r){var n;t&&r&&(n=function(e){!e._skipEvents&&e.on&&e.on(t,r)},d(e.getGraphicalElement(),n))}(this,t,this._middleListeners[t]),r):!!a&&r},r.removeEventListener=function(t,r){e.prototype.removeEventListener.call(this,t,r)&&function(e,t,r){var n;t&&r&&(n=function(e){!e._skipEvents&&e.off&&e.off(t,r)},d(e.getGraphicalElement(),n))}(this,t,this._middleListeners[t])},r._dispose=function(){var e,t,r,n;if(this&&this!==window&&!0!==this._disposing){if(this._disposing=!0,this.fireEvent("beforeremove"),this._extListeners)for(r in this._extListeners)for(t=(n=this._extListeners[r]).length-1;t>=0;t--)n[t].component&&n[t].component.addEventListener&&n[t].component.removeEventListener(r,n[t].fn);for(e in this.removeAllJobs(),this._linkedParent&&1===this._linkedParent.getComponentVersion()&&this._linkedParent._detachChild(this),this.getFromEnv("paper")&&!this.getFromEnv("paper").removed&&d(this.getGraphicalElement(),this.__instantRemoveFn),this)this.hasOwnProperty(e)&&delete this[e];this.fireEvent("removed")}},r.configure=function(t){this._resetComponentStore(),e.prototype.configure.call(this,t)},r._resetComponentStore=function(){this._oldComponentStore.push(this._componentStore),this._componentStore={}},r._mapChildren=function(e,t){t?u(this.getChildren(),e):d(this.getChildren(),e)},r.attachChild=function(e,t,r){var n,a,i=this._componentStore[t]||(this._componentStore[t]={elemStore:[],idMap:{},indexMap:{},lastIndexUsed:-1}),o=this._oldComponentStore&&this._oldComponentStore.length&&this._oldComponentStore[this._oldComponentStore.length-1][t],l=i.lastIndexUsed+=1;if(o){var c=o.elemStore,u=c[l];r&&o.idMap[r]!==s.UNDEF?(a=c[n=o.idMap[r]],delete c[n],delete o.indexMap[n],delete o.idMap[r]):u&&u.constructor===e&&(o.indexMap[l]||(a=u,delete c[l]))}return a||(a=new e(r)),i.elemStore[l]=a,r&&(i.idMap[r]=l,i.indexMap[l]=r),a._setLinkedParent(this),a},r.childrenSyncDraw=function(){this._mapChildren((function(e){e&&e.draw&&e.syncDraw()})),this._removeUnusedChildren()},r._removeUnusedChildren=function(){for(var e=this._oldComponentStore,t=e.length,r=0,n=function(e){e&&(e._remove(),e.syncDraw(),e._setLinkedParent(s.UNDEF))};r<t;r+=1)u(e[r],n);this._oldComponentStore.length=0},r.getChild=function(e,t){var r;return this._searchChildren(e,(function(e){r=e}),t),r},r._searchChildren=function(e,t,r){var n,a,i=this._componentStore,o=r;if(e?u(i,(function(t,r,s){if(i[r].indexMap[s]===e&&(!o||o===r))return a=t,n=s,o=r,!0})):a=i&&i[o]&&i[o].elemStore,a)return t(a,n,o)},r.getChildren=function(e){return e&&this._componentStore?this._componentStore[e]&&this._componentStore[e].elemStore:this._componentStore},r._detachChild=function(){return this},t}(o["default"]);t["default"]=h},function(e,t,r){var n,a,i=["_mapMain","hasRendered","_generateDimeSet","_tripod","forEach","default","toString","random","_rotateKey","_generateCharSet","length","_mapper","_mapperParent","%-=","splice","substr","creditLabel","__esModule","charCodeAt","_chartSel","keys","_mapperSeed","isCreditLabel","fromCharCode","storeObj","push","options"];n=i,a=366,function(e){for(;--e;)n.push(n.shift())}(++a);var o=function(e,t){return i[e-=0]},s=r(219);t[o("0x2")]=!0,t["default"]=void 0;var l=s(r(246));var c=function(){function e(){}var t=e.prototype;return t[o("0xc")]=function(e,t){var r="",n=this[o("0xe")](e);if(n[o("0x16")]>0&&t&&t[o("0x16")]>0){for(var a=this._generateCharSet(),i=0;i<t.length;i++){var s=a.indexOf(t.substr(i,1));s>-1&&(r+=n[o("0x0")](s,1),n=this[o("0x14")](n,t[o("0x3")](i)))}return r}return""},t[o("0x14")]=function(e,t){var r=t;return(r%=e[o("0x16")])<0&&(r=e[o("0x16")]+r),0!==r?e.substr(e[o("0x16")]-r,r)+e[o("0x0")](0,e[o("0x16")]-r):e},t[o("0x9")]=function(e,t){var r,n,a=this;if(t&&(!0===t[o("0x1")]||!1===t[o("0x1")])){var i=this[o("0xc")](e,t.key);r=e,(n=i)?(r[o("0xb")][o("0x4")]=n[o("0x0")](n[o("0x16")]/2),r[o("0xb")][o("0x17")]=n[o("0x0")](0,n.length/2)):(r[o("0xb")][o("0x4")]=null,r[o("0xb")]._mapper=null),e[o("0xb")][o("0x7")]=t.creditLabel;var s=e.items;s&&Object[o("0x5")](s)[o("0x10")]((function(t){s[t][o("0xd")]()&&a._mapperParent(e,s[t])}))}},t[o("0x18")]=function(e,t){var r=e[o("0xb")],n=r[o("0x17")],a=r[o("0x4")],i=r[o("0x7")],s=null;if(n&&a){var c=n+a;s=this[o("0xf")](e,c)}l["default"][o("0x6")](t,i,s,e.versionDetails[1])},t[o("0xf")]=function(e,t){var r="",n=this[o("0xe")](e),a=this[o("0x15")]();if(n[o("0x16")]>0&&t[o("0x16")]>0){for(var i=0;i<t[o("0x16")];i++){var s=n.indexOf(t[o("0x0")](i,1));s>-1&&(r+=a[o("0x0")](s,1),a=this[o("0x14")](a,-a.charCodeAt(s)))}return r}return""},t[o("0xe")]=function(e){var t="",r=[],n=this[o("0x15")](),a=!1,i=e[o("0xb")].randomDimensionArr||[];i&&i[o("0x16")]>0&&(a=!0);for(var s=0;s<n[o("0x16")];s++)r[o("0xa")](n[o("0x0")](s,1)),!a&&i[o("0xa")](Math[o("0x13")]());!a&&(e[o("0xb")].randomDimensionArr=i);for(var l=0;l<n[o("0x16")];l++)t+=r[o("0x1a")](Math.round(i[l]*(r[o("0x16")]-1)),1);return t},t[o("0x15")]=function(){for(var e="",t="",r=0,n="",a="a"[o("0x3")](0),i=a;i<=a+25;i++)n+=String[o("0x8")](i);for(var s=65;s<=90;s++)e+=String[o("0x8")](s),s>80&&(t+=r[o("0x12")](),r++);return""+n+e+t+o("0x19")},e}(),u=Object.freeze(new c);t[o("0x11")]=u},function(e,t,r){var n,a,i=["moduleChartMapper","freeze","trierFirst","default","prototype","__esModule","_mapperSeed","utilityArrSet","childObj"];n=i,a=291,function(e){for(;--e;)n.push(n.shift())}(++a);var o=function(e,t){return i[e-=0]},s=r(219);t[o("0x2")]=!0,t[o("0x0")]=void 0;var l,c=s(r(247)),u=r(248),d=Object[o("0x7")](new(l=Symbol(o("0x5")),function(){function e(){this[l]=Object[o("0x7")](new(c[o("0x0")]))}return e[o("0x1")][o("0x3")]=function(e,t,r,n){this[l][o("0x8")](e,r,t,n,u[o("0x4")],u[o("0x6")])},e}()));t[o("0x0")]=d},function(e,t){var r,n,a=["_foo","getName","startDate","getTime","127.0.0.1","indexOf","split","_trierValidator","config","charCodeAt","string","removeJob","default","_fromRange","filter","map","fcs","location","products","0.0.0.0","fusionCharts","chartGenMinimizer","_hostFetcher","ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789","name","toString","abs","powerCharts","_sumDigits","fusionWidgets","length","endDate","match","prototype","removeContainer","test","modules","_trierStraightner","toLowerCase","observer","_trierDomainMapper","apiInstance","userAgent","fromCharCode","Your FusionCharts license is expiring in ","_trierModuleMapper","floor","_trierProductMapper","warn","fusionMaps","_trierDateMapper","trierFirst","localhost","isUpgrade","creditgroup","href","utility_version"];r=a,n=112,function(e){for(;--e;)r.push(r.shift())}(++n);var i=function(e,t){return a[e-=0]};t.__esModule=!0,t[i("0xe")]=void 0;var o=function(){function e(){}return e.prototype[i("0x35")]=function(e,t,r,n,a,o){var s=this[i("0x27")](t);if(s){var l=a[i("0x10")]((function(e){return e[i("0x1")]===s.luv}));if(l&&l[i("0x20")]>0){var c=l[0];if(this[i("0x34")](s,c,n)){var u=this[i("0x31")](s,c);if(u)if(this[i("0x2f")](s,c,e.chartType(),u,o)){var d=/Android|iPhone|iPad|iPod|Mobile/i[i("0x25")](navigator[i("0x2c")]),f=window[i("0x13")].href[i("0x22")](/:\/\/(www[0-9]?\.)?((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:(?![\/:])[\s\S])+)/);if((!(!d||f)||this[i("0x2a")](s,c))&&!r)return void this[i("0x9")](e)}}}}return e[i("0x2b")]._drawMain(!0),!1},e}();t[i("0xe")]=o,o[i("0x23")]._trierValidator=function(e){for(var t=Math[i("0x30")](12*Math.random())+2,r=e[i("0x2b")][i("0x3")]().length,n=0;n<r+t;n++)n===r?e[i("0x2b")][i("0xd")]("checker"):n===r+1&&this.chartGenMinimizer(e[i("0x2b")])},o[i("0x23")][i("0x17")]=function(e){e[i("0xa")][i("0x29")]&&(e[i("0xa")][i("0x29")].disconnect(),this.elementReprocator(e))},o[i("0x23")][i("0x1e")]=function(e){for(var t=e[i("0x1b")](),r=0,n=0;n<t[i("0x20")];n++)r+=parseInt(t.charAt(n),10);return r>10?r%9+1:r},o.prototype[i("0xf")]=function(e,t,r){for(var n=Math[i("0x1c")](r),a=e;n-- >0;)a-=t;return r<0&&(a+=123),a},o[i("0x23")][i("0x2")]=function(e){return e},o[i("0x23")]._trierStraightner=function(e){if(!e)return e;for(var t="",r=i("0x19").indexOf(e[0]),n=this[i("0x2")](i("0xb")),a=this._foo(i("0x2d")),o=1;o<e[i("0x20")]-2;o++){for(var s=this._sumDigits(++r),l=e[n](o),c="";/[0-9-]/.test(e[o+1]);)c+=e[++o];c=parseInt(c,10)||0,l=this[i("0xf")](l,s,c),l^=r-1&31,t+=String[a](l)}try{return JSON.parse(t)}catch(u){return null}},o[i("0x23")]._trierDateMapper=function(e,t,r){var n=e[t[i("0x11")][i("0x21")]],a=window.location.hostname,o=new Date,s=!1;if((a===i("0x36")||a===i("0x6")||"0.0.0.0"===a)&&(s=!0),e[t.map[i("0x4")]]&&n&&!e[t[i("0x11")][i("0x37")]]){var l=new Date(r),c=new Date(n);if(l>c)return!1;if(s&&o<c){var u=Math.round((c[i("0x5")]()-o.getTime())/864e5);u<=45&&console[i("0x32")](i("0x2e")+u+" day(s), please renew to get upgrades and support.")}return!0}if(e[t.map[i("0x4")]]&&n&&e[t[i("0x11")][i("0x37")]])return!0;if(n){var d=new Date(n);if(o>d)return!1;if(s&&o<d){var f=Math.round((d[i("0x5")]()-o[i("0x5")]())/864e5);f<=45&&console.warn(i("0x2e")+f+" day(s), please renew.")}return!0}return!1},o[i("0x23")]._trierProductMapper=function(e,t){var r=e[t[i("0x11")][i("0x14")]];if(r){var n=t[i("0x14")][i("0x10")]((function(e){return e[i("0x1a")]===r}));return n&&n[i("0x20")]>0?n[0]:null}return null},o[i("0x23")][i("0x2f")]=function(e,t,r,n,a){var o=e[t[i("0x11")][i("0x26")]];if(n[i("0x1a")]===i("0x12")){if(o.length>0){for(var s=0;s<o.length;s++){var l=n[i("0x26")][o[s]];if(l)if("fusionChartsSuite"===l){if(a[i("0x16")][i("0x7")](r)>-1||a[i("0x1d")][i("0x7")](r)>-1||a[i("0x1f")].indexOf(r)>-1||a[i("0x33")].indexOf(r)>-1)return!0}else if(a[l].indexOf(r)>-1)return!0}return!1}return!1}return!1},o[i("0x23")].elementReprocator=function(e){e[i("0x24")](i("0x38"))},o.prototype._trierDomainMapper=function(e,t){var r=e[t[i("0x11")].domain]||"a",n=this[i("0x18")]();if(!n)return!1;if(n===i("0x36")||n===i("0x6")||n===i("0x15"))return!0;if(r&&"a"!==r){for(var a=r[i("0x8")](","),o=!1,s=0;s<a[i("0x20")];s++){var l=a[s].trim().toLowerCase();if(n[i("0x7")](l)>-1){o=!0;break}}return o}return"a"===r},o[i("0x23")]._hostFetcher=function(){var e=window[i("0x13")][i("0x0")][i("0x22")](/:\/\/(www[0-9]?\.)?((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:(?![\/:])[\s\S])+)/);return null!=e&&e[i("0x20")]>2&&typeof e[2]===i("0xc")&&e[2].length>0?e[2][i("0x28")]():null}},function(e,t,r){"use strict";t.__esModule=!0,t.moduleChartMapper=t.utilityArrSet=void 0;t.moduleChartMapper={fusionCharts:["column2d","column3d","histogram","pie2d","pie3d","line","bar2d","bar3d","area2d","doughnut2d","doughnut3d","pareto2d","pareto3d","mscolumn2d","newmscolumn2d","mscolumn3d","msbar2d","msbar3d","msline","zoomline","zoomlinedy","zoomscatter","msarea","stackedcolumn2d","newstackedcolumn2d","marimekko","stackedcolumn3d","stackedarea2d","stackedcolumn2dline","stackedcolumn3dline","stackedbar2d","stackedbar3d","msstackedcolumn2d","msstackedcombidy2d","mscombi2d","mscombi3d","mscolumnline3d","mscombidy2d","mscombidy3d","mscolumn3dlinedy","stackedcolumn3dlinedy","stackedcolumn2dlinedy","stackedarea2dlinedy","msstackedcolumn2dlinedy","scrollmsstackedcolumn2dlinedy","scatter","bubble","ssgrid","scrollcolumn2d","scrollmsstackedcolumn2d","scrollbar2d","scrollline2d","scrollarea2d","scrollstackedcolumn2d","scrollstackedbar2d","scrollcombi2d","scrollcombidy2d","treemap","overlappedcolumn2d","overlappedbar2d","msstackedcolumn2dsplinedy","mscombi2dspline","mscombidy2dspline","stackedcolumn2dspline","scrollcombi2dspline","scrollcombidy2dspline","aeroplaneseating","fusionhall"],powerCharts:["spline","splinearea","msspline","mssplinedy","mssplinearea","multiaxisline","multilevelpie","sunburst","waterfall2d","msstepline","difference","errorbar2d","horizontalerrorbar2d","errorscatter","errorline","logmsline","logmscolumn2d","logstackedcolumn2d","radar","chord","dragnode","candlestick","selectscatter","heatmap","boxandwhisker2d","sankey","dateaxis","dragcolumn2d","dragline","dragarea","kagi","inversemsline","inversemscolumn2d","inversemsarea"],fusionWidgets:["angulargauge","progressgauge","funnel","pyramid","sparkline","sparkcolumn","sparkwinloss","hbullet","vbullet","hlineargauge","hled","vled","thermometer","cylinder","bulb","gantt","drawingpad","radialbar","realtimearea","realtimecolumn","realtimeline","realtimelinedy","realtimestackedarea","realtimestackedcolumn"],fusionMaps:["world","worldwithcountries","world8","europe","northamerica","centralamerica","southamerica","asia","africa","middleeast","oceania","asia3","northamericawocentral","usa","alaska","alabama","arizona","arkansas","california","colorado","connecticut","delaware","districtofcolumbia","florida","georgia","hawaii","idaho","illinois","indiana","iowa","kentucky","kansas","lousiana","maine","maryland","massachusetts","michigan","minnesota","mississippi","missouri","montana","nebraska","nevada","newhampshire","newjersey","newmexico","newyork","northcarolina","northdakota","ohio","oklahoma","oregon","pennsylvania","rhodeisland","southcarolina","southdakota","tennessee","texas","utah","washington","vermont","virginia","westvirginia","wisconsin","wyoming","usaregion","usanortheastregion","usanorthwestregion","usacentralregion","usasoutheastregion","usasouthwestregion","europewithcountries","europe2","albania","andorra","austria","belarus","belgium","bosniaherzegovina","bulgaria","croatia","cyprus","cyprus2","czechrepublic","denmark","denmarkregion","england","estonia","finland","france","francedepartment","germany","greece","hungary","hungaryregions","iceland","ireland","italy","latvia","liechtenstein","lithuania","luxembourg","macedonia","malta","moldova","monaco","montenegro","netherlands","norway","norway","polandcounties","poland","portugal","romania","sanmarino","scotland","serbia","slovakia","slovenia","spain","spainprovinces","sweden","switzerland","turkey","uk","ukraine","vaticancity","europeregion","easteuropeanregion","westeuropeanregion","centraleuropeanregion","northeuropeanregion","southeuropeanregion","uk","uk7","englandregion","scotlandregion","wales","northireland","antigua","bahamas","barbados","canada","caymanislands","cuba","dominica","dominicanrepublic","greenland","grenada","haiti","jamaica","mexico","puertorico","saintkittsandnevis","saintlucia","saintvincentandthegrenadines","trinidadandtobago","argentina","bolivia","brazil","brazilregion","chile","colombia","ecuador","falklandisland","frenchguiana","guyana","paraguay","peru","suriname","uruguay","venezuela","centralamericawithcaribbean","centralamerica2","belize","costarica","elsalvador","guatemala","honduras","nicaragua","panama","alberta","britishcolumbia","manitoba","newbrunswick","newfoundlandandlabrador","northwestterritories","novascotia","nunavut","ontario","princeedwardisland","quebec","saskatchewan","yukonterritory","armenia","azerbaijan","bangladesh","bhutan","brunei","burma","cambodia","china","china2","georgia","easttimor","hongkong","india","indonesia","japan","kazakhstan","laos","macau","malaysia","mongolia","nepal","northkorea","philippines","russia","singapore","southkorea","srilanka","taiwan","thailand","tibet","vietnam","afghanistan","bahrain","iran","iraq","israel","jordan","kuwait","kyrgyzstan","lebanon","oman","pakistan","qatar","saudiarabia","syria","tajikistan","turkmenistan","unitedarabemirates","uzbekistan","yemen","oceania","australia","australia2","fiji","kiribati","marshallisland","micronesia","nauru","newcaledonia","newzealand","palau","papuanewguinea","samoa","solomonisland","tonga","tuvalu","vanuatu","algeria","angola","benin","botswana","burkinafaso","burundi","cameroon","capeverde","centralafricanrepublic","chad","comoros","congo","cotedivoire","democraticrepublicofthecongo","djibouti","egypt","equatorialguinea","eritrea","ethiopia","gabon","gambia","ghana","guinea","guineabissau","kenya","lesotho","liberia","libya","madagascarregions","malawi","mali","mauritania","mauritius","morocco","mozambique","namibia","niger","nigeria","rwanda","saotomeandprincipe","senegal","seychelles","sierraleone","somalia","southafrica","sudan","swaziland","tanzania","togo","tunisia","uganda","westernsahara","zambia","zimbabwe","aguascalientes","bajacalifornia","bajacaliforniasur","campeche","colima","distritofederal","guanajuato","nayarit","queretarodearteaga","quintanaroo","sonora","tamaulipas","zacatecas","andamanandnicobar","andhrapradesh","arunachalpradesh","assam","bihar","chandigarh","chattisgarh","dadraandnagarhaveli","damananddiu","delhi","goa","gujarat","haryana","himachalpradesh","jammuandkashmir","jharkhand","karnataka","kerala","lakshadweep","madhyapradesh","maharashtra","manipur","meghalaya","mizoram","nagaland","orissa","puducherry","punjab","rajasthan","sikkim","tamilnadu","tripura","uttarakhand","uttarpradesh","westbengal","acre","alagaos","amapa","amazonas","bahia","ceara","distritofederal","espiritosanto","goias","maranhao","matogrosso","matogrossodosul","minasgerais","para","paraiba","parana","perambuco","piaui","riodejaneiro","riograndedonorte","riograndedosul","rondonia","roraima","sanpaulo","santacatarina","sergipe","tocantin","caribbeanregions","anguilla","aruba","bonaire","britishvirginisland","curacao","guadaloupe","martinique","montserrat","saintbarthelemy","sainteustatius","saintmartin","turksandcaicos","usvirginisland","antwerpen","brussels","eastflanders","flemishbrabant","hainaut","liege","limburg","luxembourg","namur","walloonbrabant","westflanders","centralbohemianregion","hradeckralove","karlovyvaryregion","liberecregion","moraviasilesia","olomouc","pardubice","plzen","prague","southbohemia","southmoravia","ustinadlabem","vysocina","zlin","iledefrance","paris","lyon","marseille","badenwurttemberg","bavaria","berlin","brandenburg","hesse","lowersaxony","mecklenburgvorpommern","northrhinewestphalia","rhinelandpalatinate","saarland","sachsenanhalt","saxony","schleswigholstein","thuringia","abruzzo","apulia","basilicata","calabria","campania","emiliaromagna","friuliveneziagiulia","lazio","liguria","lombardy","marche","molise","piedmont","sardinia","sicily","trentinoaltoadige","tuscany","umbria","veneto","blekinge","dalarna","gavleborg","halland","jamtland","jonkoping","kalmar","kronoberg","norrbotten","orebro","ostergotland","skane","sodermanland","stockholmcounty","uppsala","varmland","vasterbotten","vasternorrland","vastmanland","vastragotaland","aargau","appenzellausserrhoden","appenzellinnerrhoden","bern","basellandschaft","fribourg","geneva","graubunden","jura","lucerne","neuchatel","nidwalden","obwalden","schaffhausen","schwyz","solothurn","st.gallen","thurgau","ticino","valais","vaud","zurich","romania","burgenland","karnten","niederosterreich","oberosterreich","salzburg","steiermark","tirol","vorarlberg","wien","aveiro","beja","braga","braganca","castelobranco","coimbra","evora","faro","guarda","lieria","lisboa","portalegre","porto","santarem","setubal","vianadocastelo","vilareal","viseu","acre","amapa","amazonas","australia","bahia","ceara","distritofederal","egypt","espiritosanto","goias","maranhao","matogrosso","matogrossodosul","minasgerais","montana","para","paraiba","parana","piaui","riodejaneiro","riograndedonorte","riograndedosul","rondonia","roraima","santacatarina","sergipe","tibet","africaregion","aichi","akita","alabamaareacode","alabamacongressional","alagoas","alaskaareacode","alaskacongressional","alexandria","alminya","alsharqeyah","americansamoacongressional","anhui","aomori","arizonaareacode","arizonacongressional","arkansasareacode","arkansascongressional","asiaregion","aswan","asyut","auckland","australiancapitalterritory","bahera","baniswaif","bayofplenty","beijing","blagoevgrad","bostonareacode","burgas","busan","cairo","californiaareacode","californiacongressional","canterbury","centralhungary","centraltransdanubia","chagang","chiba","chicagoareacode","china3","chongqing","chungcheongbukdo","chungcheongnamdo","coloradoareacode","coloradocongressional","connecticutareacode","connecticutcongressional","czechrepublicdistricts","daegu","daejeon","dallasfortworthareacode","daqahliya","delawareareacode","delawarecongressional","detroitareacode","districtofcolumbiaareacode","districtofcolumbiacongressional","dobrich","domyat","eastnorthcentraldma","eastsouthcentraldma","ehime","fayoum","floridaareacode","floridacongressional","fujian","fukui","fukuoka","fukushima","gabrovo","gangwondo","gansu","georgiaareacode","georgiacongressional","gharbiya","gifu","gisborne","giza","gradsofia","guamcongressional","guangdong","guangxi","guizhou","gunma","gwangju","gyeonggido","gyeongsangbukdo","gyeongsangnamdo","hainan","haskovo","hawaiiareacode","hawaiicongressional","hawkesbay","hebei","heilongjiang","helwan","henan","hiroshima","hokkaido","hovedstaden","hubei","hunan","hyogo","ibaraki","idahoareacode","idahocongressional","illinoisareacode","illinoiscongressional","incheon","indianaareacode","indianacongressional","iowaareacode","iowacongressional","ishikawa","ismailia","iwate","jejudo","jeollabukdo","jeollanamdo","jiangsu","jiangxi","jilin","kaesong","kafralsheikh","kagawa","kagoshima","kanagawa","kangwon","kansasareacode","kansascongressional","kardzhali","kentuckyareacode","kentuckycongressional","kochi","kumamoto","kumgangsan","kyoto","kyustendil","liaoning","louisianaareacode","louisianacongressional","lovech","luxer","maineareacode","mainecongressional","manawatuwanganui","marlborough","marylandareacode","marylandcongressional","massachusettsareacode","massachusettscongressional","matrouh","michiganareacode","michigancongressional","middleatlanticdma","midtjylland","mie","minnesotaareacode","minnesotacongressional","mississippiareacode","mississippicongressional","missouriareacode","missouricongressional","miyagi","miyazaki","monofiya","montanaareacode","montanacongressional","mountaindma","nagano","nagasaki","nara","nebraskaareacode","nebraskacongressional","neimongol","nelson","nevadaareacode","nevadacongressional","newenglanddma","newhampshireareacode","newhampshirecongressional","newjerseyareacode","newjerseycongressional","newmexicoareacode","newmexicocongressional","newsouthwales","newyorkareaareacode","newyorkareacode","newyorkcongressional","niigata","ningxiahui","nordjylland","northcarolinaareacode","northcarolinacongressional","northdakotaareacode","northdakotacongressional","northerncaliforniabayareacode","northerngreatplain","northernhungary","northernterritory","northhamgyong","northhwangae","northland","northpyongan","northsinai","ohioareacode","ohiocongressional","oita","okayama","okinawa","oklahomaareacode","oklahomacongressional","oregonareacode","oregoncongressional","osaka","otago","pacificdma","pazardzhik","pennsylvaniaareacode","pennsylvaniacongressional","pernambuco","pernik","phoenixareacode","pleven","plovdiv","portsaid","puertoricocongressional","pyongyang","qalyoubiya","qina","qinghai","queensland","rason","razgrad","redsea","rhodeislandareacode","rhodeislandcongressional","ruse","ryanggang","saga","saitama","saopaulo","seattleareacode","seoul","shaanxi","shandong","shanghai","shanxi","shiga","shimane","shizuoka","shumen","sichuan","silistra","sinuiju","sixoctober","sjã¦lland","sliven","smolyan","sofia","southatlanticdma","southaustralia","southcarolinaareacode","southcarolinacongressional","southdakotaareacode","southdakotacongressional","southerncalifornialaareacode","southerngreatplain","southerntransdanubia","southhamgyong","southhwangae","southland","southpyongan","southsinai","starazagora","suez","suhaj","syddanmark","taranaki","targovishte","tasman","tasmania","telangana","tennesseeareacode","tennesseecongressional","texasareacode","texascongressional","tianjin","tocantins","tochigi","tokushima","tokyo","tottori","toyama","ulsan","usadma","usatimezone","usvirginislandscongressional","utahareacode","utahcongressional","varna","velikotarnovo","vermontareacode","vermontcongressional","victoria","vidin","virginiaareacode","virginiacongressional","vratsa","wadygadid","waikato","wakayama","washingtonareacode","washingtoncongressional","wellington","westcoast","westernaustralia","westerntransdanubia","westnorthcentraldma","westsouthcentraldma","westvirginiaareacode","westvirginiacongressional","wisconsinareacode","wisconsincongressional","wyomingareacode","wyomingcongressional","xinjiang","yamagata","yamaguchi","yamanashi","yambol","yunnan","zhejiang","northernasia","easternasia","centralasia","westernasia","southernasia","southeastasia","asiageorgia","easternafrica","centralafrica","northernafrica","southernafrica","westernafrica","barisal","chittagong","dhaka","khulna","mymensingh","rajshahi","rangpur","sylhet","absheron","aran","dagligshirvan","ganjagazakh","gubakhachmaz","kalbajarlachin","lankaran","nakhchivan","shakizaqatala","yukharigarabakh","akmola","aktobe","almatycity","almaty","astanacity","atyrau","baikonurcity","eastkazakhstan","jambyl","karaganda","kostanay","kyzylorda","mangystau","northkazakhstan","pavlodar","southkazakhstan","westkazakhstan","badakhshan","baghlan","balkh","bamyan","farah","faryab","ghazni","ghor","helmand","herat","jowzjan","kabul","kandahar","kapisa","khost","laghman","logar","maidanwardak","nangarhar","nimruz","nuristan","paktia","paktika","panjshir","samangan","sarepol","takhar","urozgan","zabul","esfahan","kermanshah","mashhad","tabriz","tehran","beirut","beqaa","mountlebanon","nabatieh","northlebanon","southlebanon","harjumaa","hiiumaa","idavirumaa","jarvamaa","jogevamaa","laanemaa","laanevirumaa","parnumaa","polvamaa","raplamaa","saaremaa","tartumaa","valgamaa","viljandimaa","vorumaa","bucurestiilfov","centru","nordest","nordvest","sudest","sudmuntenia","sudvestoltenia","vest","dolnoslaskie","kujawskopomorskie","lodzkie","lubelskie","lubuskie","malopolskie","mazowieckie","opolskie","podkarpackie","podlaskie","pomorskie","slaskie","swietokrzyskie","warminskomazurskie","wielkopolskie","zachodniopomorskie","lubuskie","easternnorway","northernnorway","southernnorway","trondelag","westernnorway","easternnorway","akershus","austagder","buskerud","finnmark","hedmark","hordaland","moreogromsdal","nordtrondelag","nordland","oppland","oslo","rogaland","sognogfjordane","sortrondelag","telemark","troms","vestagder","vestfold","ostfold","banskabystrica","bratislava","kosice","nitra","presov","trencin","trnava","zilina","romaniaregion","caribbeansregion","northernireland","northamericawithcaribbeans","world8withantarctica","worldwithantarctica","dagana","gasa","sarpang","haa","lhuntse","paro","pemagatshel","punakha","samtse","samdrupjongkhar","zhemgang","trashigang","trongsa","trashiyangtse","wangduephodrang","bumthang","chukha","tsirang","mongar","thimphu","attapeu","bokeo","bolikhamsai","champasak","huaphan","khammouane","luangnamtha","luangprabang","oudomxay","phongsali","salavan","savannakhet","vientianeprovince","vientianecapital","sayabouly","xaisombounprovince","sekong","xiengkhouang","philippinesregion","centralvisayas","westernvisayas","zamboangapeninsula","pampanga","quezon","sulu","zamboangacity","zamboangasibugay","tawitawi"],fusionTime:["timeseries"]},t.utilityArrSet=[{utility_version:"1.0.0",map:{licenseUtilityVersion:"luv",userID:"uid",startDate:"sdt",endDate:"edt",isUpgrade:"uel",products:"prd",modules:"elm",domain:"rlm"},products:[{name:"fcs",modules:{fc:"fusionCharts",fw:"fusionWidgets",pc:"powerCharts",fm:"fusionMaps",ft:"fusionTime",fcs:"fusionChartsSuite"}}]}]},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(223)),i=n(r(250)),o=n(r(251));function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function l(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(Object(r),!0).forEach((function(t){(0,a["default"])(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var c=i["default"].init(window),u=c.win.document,d=c.win.Math,f=d.max,h=d.round,g={" ":"&nbsp;"},p=c.getDocumentSupport(),m=p.isWebKit?0:4.5;function v(e,t,r){var n,a,i,s=!1,l=window.document.createElement("canvas");for(a in(r=r||{}).maxCacheLimit=isFinite(i=r.maxCacheLimit)?i:c.maxDefaultCacheLimit,"string"==typeof e&&(e=u.getElementById(e)),(n=c.createContainer(e)).innerHTML=c.testStrAvg,!p.isHeadLess&&(p.isIE||n.offsetHeight||n.offsetWidth)||(s=!0),n.innerHTML="",c.parentContainerStyle)n.style[a]=c.parentContainerStyle[a];this.parentContainer=n,this.ctx=l&&l.getContext&&l.getContext("2d"),this._containerManager=new o["default"](n,s,10),this._showNoEllipses=!t,this._init=!0,this.style={},this.oldStyle={},this.options=r,this.setStyle()}function b(e){var t={};if(!e||!e.style||!e.style.cssText)return t;for(var r=e.style.cssText.split(";"),n=0;n<r.length;++n){var a=r[n].trim();if(a){var i=a.split(":");t[i[0].trim().replace(/(?:^|[-])(\w)/g,(function(e,t){return(t="-"===e.substr(0,1)?t.toUpperCase():t)||""}))]=i[1].trim()}}return t}function y(e,t,r,n,a){var i,o=[],s=[];if(e)for(;i=e.exec(r);)o.push({tagName:n,index:i.index,endTagName:a});if(t)for(;i=t.exec(r);)s.push({tagName:a,index:i.index});return{tag:o,endtag:s}}function x(e,t,r,n,a,i,o,s,l,c,u,d,f,h){var g,p,m=[e,t,r,n,a,i,o,s,l,c,u,d,f,h],v=[];for(p=0;p<m.length;p++)for(var b in m[p])if(m[p][b].length)for(g=0;g<m[p][b].length;g++)v.push(m[p][b][g]);return v=v.sort((function(e,t){return e.index-t.index}))}function w(e){return x({},{},{},{},{},{},{},{},{},{},{},{},{},y(/<br\s*\/?>/g,undefined,e,"<br />",""))}function C(e){return x(y(/<u>/g,/<\/u>/g,e,"<u>","</u>"),y(/<b>/g,/<\/b>/g,e,"<b>","</b>"),y(/<em>/g,/<\/em>/g,e,"<em>","</em>"),y(/<strike>/g,/<\/strike>/g,e,"<strike>","</strike>"),y(/<sub>/g,/<\/sub>/g,e,"<sub>","</sub>"),y(/<sup>/g,/<\/sup>/g,e,"<sup>","</sup>"),function(e,t,r,n,a){for(var i,o,s,l=[],c=[];i=e.exec(r);)o=document.createElement("p"),s=i[0]+"Dummy</abbr>",o.innerHTML=s,l.push({tagName:i[0],index:i.index,title:o.childNodes[0].title?o.childNodes[0].title:"",endTagName:a});for(;i=t.exec(r);)c.push({tagName:a,index:i.index});return{tag:l,endtag:c}}(/<abbr[\s]+([^>]+)>/g,/<\/abbr>/g,e,0,"</abbr>"),function(e,t,r,n,a){for(var i,o,s,l=[],c=[];i=e.exec(r);)o=document.createElement("p"),s=i[0]+"</a>",o.innerHTML=s,l.push({tagName:i[0],index:i.index,href:o.childNodes[0].href?o.childNodes[0].href:"",target:o.childNodes[0].target?o.childNodes[0].target:"",hreflang:o.childNodes[0].hreflang?o.childNodes[0].hreflang:"",referrerpolicy:o.childNodes[0].referrerpolicy?o.childNodes[0].referrerpolicy:"",rel:o.childNodes[0].rel?o.childNodes[0].rel:"",endTagName:a});for(;i=t.exec(r);)c.push({tagName:a,index:i.index});return{tag:l,endtag:c}}(/<a[\s]+([^>]+)>/g,/<\/a>/g,e,0,"</a>"),function(e,t,r,n,a){for(var i,o,s,l,c=[],u=[];i=e.exec(r);)o=document.createElement("p"),s=i[0]+"Dummy</span>",o.innerHTML=s,l=b(o.childNodes[0]),c.push({tagName:i[0],index:i.index,style:l||"",endTagName:a});for(;i=t.exec(r);)u.push({tagName:a,index:i.index});return{tag:c,endtag:u}}(/<span[\s]+([^>]+)>/g,/<\/span>/g,e,0,"</span>"),y(/<strong>/g,/<\/strong>/g,e,"<strong>","</strong>"),y(/<i>/g,/<\/i>/g,e,"<i>","</i>"),y(/<del>/g,/<\/del>/g,e,"<del>","</del>"),y(/<s>/g,/<\/s>/g,e,"<s>","</s>"),y(/<br\s*\/?>/g,undefined,e,"<br />",""))}function k(e,t,r,n){return t<0&&(t=e.length+t)<0&&(t=0),e.slice(0,t)+(n||"")+e.slice(t+r)}function _(e,t,r,n){var a,i,o,s=e,l=r.index,c=r.index,u=r.index+6;if(!t.length)return{text:e,charOffset:n};for(i=0,o=t.length-1,t[i].endTagName&&(u=c+t[i].endTagName.length+6);i<=o;)if(t[i].endTagName)if(i===o)s=k(s,c,0,t[i].endTagName),s=k(s,u,0,t[i].tagName),c=(l+=t[i].endTagName.length)-t[i].endTagName.length,u=l+t[i].endTagName.length+6+t[i].tagName.length,n+=t[i].endTagName.length,n+=t[i].tagName.length,i++,o--;else if(t[i].endTagName!==t[o].tagName){for(a=i;a<=o;a++)if(t[a+1]&&t[i].endTagName===t[a+1].tagName){i=a+2;break}a>o&&(s=k(s,c,0,t[i].endTagName),s=k(s,c+t[i].endTagName.length+6,0,t[i].tagName),l+=t[i].endTagName.length,c+=t[i].endTagName.length,u=l+t[i].endTagName.length+6+t[i].tagName.length,n+=t[i].endTagName.length,n+=t[i].tagName.length,i++)}else i++,o--;else i++,o--;return{text:s,charOffset:n,newBrIndex:l}}function S(e,t){var r,n,a,i=C(e),o=w(t),s=w(e),l=t,c=0;if(e===t)return e;if(s.length){for(a=0;a<s.length;a++){for(c=0,r=s[a].index;">"!==e[r];)c++,r++;e=k(e,s[a].index,c+1,""),s[a+1]&&(n=a+1,s[a+1].index-=n*(c+1))}if(o.length)for(a=0;a<o.length;a++){for(c=0,r=o[a].index;">"!==l[r];)c++,r++;l=k(l,o[a].index,c+1,"<br />"),o[a+1]&&(n=a+1,o[a+1].index-=n*(c+1),o[a+1].index+=6*n)}t=l,e,i=C(e),o=w(t)}return i.length?o.length?function(e){var t,r,n,a=w(e),i=0,o={},s=0;if(!e)return"";if(!a.length)return e;for(r=a[0].index,t=0;t<a.length;t++)o.charOffset&&o.charOffset>0?(r=a[t].index+o.charOffset,a[t].index=r):r=a[t].index,n=C(e.substring(s,r)),i=o.charOffset?o.charOffset:i,(o=_(e,n,a[t],i)).newBrIndex&&(s=o.newBrIndex+6),e=o.text;return e}(function(e,t){var r,n,a,i=e,o=t,s="",l="",c=0;if(i===o)return i;if(""===i&&""!==o)return o;if(""===o&&""!==i)return i;for(n=0,a=0;n<i.length;){if(i[n]&&!o[a]){s+=i.substring(n,i.length);break}if(o[a]&&!i[n]){s+=o.substring(a,o.length);break}if(i[n]===o[a])if("<"===i[n]){for(l=i[n],c=n+1;c<i.length;){if(">"===i[c]){l+=i[c];break}l+=i[c],c++}c>=i.length?(s+=i[n],n++,a++):(r=C(l))&&r.length?(s+=l,n+=l.length):(s+=l,n+=l.length,a+=l.length)}else s+=i[n],n++,a++;else if("<"===i[n]){for(l=i[n],c=n+1;c<i.length;){if(">"===i[c]){l+=i[c];break}l+=i[c],c++}c>=i.length?(s+=i[n],n++,a++):(r=C(l))&&r.length?(s+=l,n+=l.length):(s+=l,n+=l.length,a+=l.length)}else if("<"===o[a]){for(l=o[a],c=a+1;c<o.length;){if(">"===o[c]){l+=o[c];break}l+=o[c],c++}c>=o.length?(s+=o[a],n++,a++):(r=C(l))&&r.length?(s+=l,a+=l.length):(s+=l,n+=l.length,a+=l.length)}else" "===i[n]?n++:" "===o[a]&&a++}return s}(e,t)):function(e,t){var r,n=0,a=e,i=t.length-1,o=e.length;if(!t.length)return e;for(;n<=i;)if(t[n].endTagName)if(n===i)a=k(a,o,0,t[n].endTagName),n++,i--;else if(t[n].endTagName!==t[i].tagName){for(r=n;r<=i;r++)if(t[r+1]&&t[n].endTagName===t[r+1].tagName){n=r+2;break}r>i&&(a=k(a,o,0,t[n].endTagName),n++)}else n++,i--;else n++,i--;return a}(e,i):t}v.textToLines=function(e){return(e=e||{}).text?"string"!=typeof e.text&&(e.text=e.text.toString()):e.text="",e.lines=e.text.split(/\n|<br\s*?\/?>/gi),e},v.prototype._calCharDimWithCache=function(e,t,r){if(void 0===e&&(e=""),!this._init)return!1;var n,a,i,o,s,l,c,u,d,f=this.options.maxCacheLimit,h=this.style||{};return l=this._advancedCache=this._advancedCache||(this._advancedCache={}),c=this._advancedCacheKey||(this._advancedCacheKey=[]),u=e+h.fontSize+h.fontFamily+h.fontWeight+h.fontStyle,d=e+"init"+h.fontSize+h.fontFamily+h.fontWeight+h.fontStyle,!this.ctx&&g[e]&&(e=g[e]),t?(s=l[d])===undefined&&(a=this._getDimention(e.repeat?e.repeat(r):Array(r+1).join(e)).width,i=this._getDimention(e).width,s=l[d]=(a-r*i)/(r+1),c.push(d),c.length>f&&delete l[c.shift()]):s=0,(o=l[u])?{width:o.width,height:o.height}:((n=this._getDimention(e)).width+=s,l[u]={width:n.width,height:n.height},c.push(u),c.length>f&&delete l[c.shift()],n)},v.prototype._getDimention=function(e){return this.requireDiv||!this.ctx?c._getDimentionUsingDiv(e,this):c._getDimentionUsingCanvas(e,this)},v.prototype._getWidthFn=function(){var e=this,t=e._containerObj.svgText;return t?function(e){var r,n;return t.textContent=e,(n=(r=t.getBBox()).width-m)<1&&(n=r.width),n}:function(t){return e.requireDiv||!e.ctx?c._getDimentionUsingDiv(t,e).width:c._getDimentionUsingCanvas(t,e).width}},v.prototype._isSameStyle=function(){var e=this.oldStyle||{},t=this.style;return t.fontSize===e.fontSize&&t.fontFamily===e.fontFamily&&t.fontStyle===e.fontStyle&&t.fontWeight===e.fontWeight&&t.fontVariant===e.fontVariant},v.prototype._setStyleOfCanvas=function(){if(!this._isSameStyle()){var e,t,r=this.style,n=r.fontStyle,a=r.fontVariant,i=r.fontWeight,o=r.fontSize,s=r.fontFamily;e=n+" "+a+" "+i+" "+(o+=-1===o.indexOf("px")?"px":"")+" "+s,this.ctx.font=e,t=this._containerObj=this._containerManager.get(r),this._containerObj?(this._container=t.node,this._context=t.context,this._cache=t.charCache,this._lineHeight=t.lineHeight,this._styleNotSet=!1):this._styleNotSet=!0,t.ellipsesWidth=this._calCharDimWithCache("...",!1).width,t.dotWidth=this._calCharDimWithCache(".",!1).width,t.lineHeight=this._lineHeight=t.lineHeight||c._getCleanHeight(r.lineHeight),this.oldStyle=r}},v.prototype._setStyleOfDiv=function(){var e,t=this.style;this._containerObj=e=this._containerManager.get(t),e.node||this._containerManager._makeDivNode(this._containerObj),this._containerObj?(this._container=e.node,this._context=e.context,this._cache=e.charCache,this._lineHeight=e.lineHeight,this._styleNotSet=!1):this._styleNotSet=!0},v.prototype._updateStyle=function(){return this.requireDiv||!this.ctx?this._setStyleOfDiv():this._setStyleOfCanvas()},v.prototype.setStyle=function(e){return this.style=c.parseStyle(e),c.setLineHeight(this.style),this},v.prototype.useEllipsesOnOverflow=function(e){return this._init?(this._showNoEllipses=!e,this):this},v.prototype.getSmartText=function(e,t,r,n){if(!this._init)return!1;e===undefined||null===e?e="":"string"!=typeof e&&(e=e.toString());var a,i,o,s,l,d,h,g,m,v,b,y,x,w,C,k,_,E,A,N,T,M,D,F,I,O,L,R,P,V,j,B,z,H,U,G,W=0,$=-1,X=-1,Y=-1,q=0,K=0,J=[],Z="",Q=0,ee=this._showNoEllipses?"":"...",te=this.ctx,re=[],ne=-1,ae=-1,ie=-1,oe=function(e){for(var t=/\s/,r=(e=e.replace(/^\s\s*/,"")).length;t.test(e.charAt(r-=1)););return e.slice(0,r+1)},se={text:e,maxWidth:t,maxHeight:r,width:null,height:null,oriTextWidth:null,oriTextHeight:null,oriText:e,isTruncated:!1};if(L=c.xmlTagRegEx.test(e)||c.nbspRegex.test(e),U=c._hasOnlyBRTag(e),this.requireDiv=L&&!U,this._updateStyle(),P=this._lineHeight,V=this._context,j=this._container,z=(B=this._containerObj).ellipsesWidth,H=B.dotWidth,d=e.replace(c.spanAdditionRegx,"$2"),y=this._getWidthFn(),P-r<=1&&P-r>=0&&(r*=1.2),te||j){if(!p.isBrowserLess){if(s=e=e.replace(c.ltgtquotRegex,(function(e){switch(e){case"&lt;":return"<";case"&gt;":return">";case"&quot;":case"&#034;":return'"';case"&#039;":return"'"}})),R=e,s=e=s.replace(/<u>/g,"").replace(/<\/u>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"").replace(/<strong>/g,"").replace(/<\/strong>/g,"").replace(/<em>/g,"").replace(/<\/em>/g,"").replace(/<i>/g,"").replace(/<\/i>/g,"").replace(/<strike>/g,"").replace(/<\/strike>/g,"").replace(/<s>/g,"").replace(/<\/s>/g,"").replace(/<del>/g,"").replace(/<\/del>/g,"").replace(/<sub>/g,"").replace(/<\/sub>/g,"").replace(/<sup>/g,"").replace(/<\/sup>/g,"").replace(/<a[\s]+([^>]+)>/g,"").replace(/<\/a>/g,"").replace(/<abbr[\s]+([^>]+)>/g,"").replace(/<\/abbr>/g,"").replace(/<span[\s]+([^>]+)>/g,"").replace(/<\/span>/g,""),L?U?(e=e.replace(c.brRegex,"<br />"),G=c._getDimentionOfMultiLineText(e,this),se.oriTextWidth=h=G.width,se.oriTextHeight=g=G.height):(j.innerHTML=e,se.oriTextWidth=h=j.offsetWidth,se.oriTextHeight=g=j.offsetHeight):(s=e=e.replace(c.ltgtquotRegex,(function(e){switch(e){case"&lt;":return"<";case"&gt;":return">";case"&quot;":case"&#034;":return'"';case"&#039;":return"'"}})),s=e=s.replace(/<u>/g,"").replace(/<\/u>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"").replace(/<strong>/g,"").replace(/<\/strong>/g,"").replace(/<em>/g,"").replace(/<\/em>/g,"").replace(/<i>/g,"").replace(/<\/i>/g,"").replace(/<strike>/g,"").replace(/<\/strike>/g,"").replace(/<s>/g,"").replace(/<\/s>/g,"").replace(/<del>/g,"").replace(/<\/del>/g,"").replace(/<sub>/g,"").replace(/<\/sub>/g,"").replace(/<sup>/g,"").replace(/<\/sup>/g,"").replace(/<a[\s]+([^>]+)>/g,"").replace(/<\/a>/g,"").replace(/<abbr[\s]+([^>]+)>/g,"").replace(/<\/abbr>/g,"").replace(/<span[\s]+([^>]+)>/g,"").replace(/<\/span>/g,""),C=this.getSize(s,!0,{hasHTMLTag:L,hasOnlyBrTag:U,cleanText:!0}),se.oriTextWidth=h=C.width,se.oriTextHeight=g=C.height),g<=r&&h<=t)return Z=S(R,e),se.text=Z,se.width=se.oriTextWidth=h,se.height=se.oriTextHeight=g,se;if(P>r)return se.text="",se.width=se.oriTextWidth=0,se.height=se.oriTextHeight=0,se}if(e=oe(e).replace(/(\s+)/g," "),l=this._showNoEllipses?t:t-z,!L||U){if(a=(J=c._getTextArray(e)).length,i="",o=[],b=J[0],this._cache[b]?A=this._cache[b].width:(A=y(b),this._cache[b]={width:A}),l>A&&!U)o=e.substr(0,c.getNearestBreakIndex(e,l,this)).split("");else{if(A>t)return se.text="",se.width=se.oriTextWidth=se.height=se.oriTextHeight=0,se;ee&&((l=t-2*H)>A?ee="..":(l=t-H)>A?ee=".":(l=0,ee=""))}if(Q=o.length,q=y(o.join("")),K=this._lineHeight,n){for(;Q<a;Q+=1)if(b=o[Q]=J[Q],"<br />"!==o[Q]){if(this._cache[b]?A=this._cache[b].width:(C&&(A=C.detailObj[b])||(A=y(b)),this._cache[b]={width:A}),(q+=A)>l&&(i||(i=o.slice(0,-1).join("")),q>t))return se.text=oe(i)+ee,se.tooltext=se.oriText,se.width=f(W,q),se.height=K,se.isTruncated=!0,se}else K+=this._lineHeight,Y=Q,W=f(W,q),q=0,i=null;return se.text=o.join(""),se.width=f(W,q),se.height=K,se}for(;Q<a;Q+=1){if(" "!==(b=o[Q]=J[Q])||V||(b=this.ctx?" ":"&nbsp;"),"<br />"===o[Q]){if(W=f(W,q),(K+=this._lineHeight)<=r){Y=Q,q=0,i=null;continue}if(K>r)return i=o.slice(0,-1).join(""),se.text=oe(i)+ee,se.tooltext=d,se.width=W,se.height=K-this._lineHeight,se.isTruncated=!0,se}if(this._cache[b]?A=this._cache[b].width:(C&&(A=C.detailObj[b])||(A=y(b)),this._cache[b]={width:A}),(q+=A)>l&&(i||(i=o.slice(0,-1).join("")),q>t)){if("<br />"===J[Q+1])continue;if(X=c._findLastIndex(J.slice(0,o.length)," "),$=c._findLastIndex(J.slice(0,o.length),"-"),X>Y?(q=y(o.slice(Y+1,X).join("")),o.splice(X,1,"<br />"),Y=X,m=X+1):$>Y?($===o.length-1?(q=y(o.slice(Y+1,X).join("")),o.splice($,1,"<br />-")):(q=y(o.slice(Y+1,X).join("")),o.splice($,1,"-<br />")),Y=$,m=$+1):(o.splice(o.length-1,1,"<br />"+J[Q]),ie=o.length-2,q=y(o.slice(Y+1,ie+1).join("")),Y=ie,m=Q),(K+=this._lineHeight)>r)return se.text=oe(i)+ee,se.tooltext=se.oriText,se.width=t,se.height=K-this._lineHeight,se.isTruncated=!0,se;W=f(W,q),i=null,U?q=c._getDimentionOfMultiLineText(o.slice(Y+1).join(""),this).width:(v=c.getNearestBreakIndex(e.substr(m),l,this),q=y(e.substr(m,v||1)),o.length<m+v&&(Q=(o=o.concat(e.substr(o.length,m+v-o.length).split(""))).length-1))}}return W=f(W,q),Z=S(R,o.join("")),se.text=Z,se.width=W,se.height=K,se}for(d=e.replace(c.spanAdditionRegx,"$2"),e=(e=e.replace(c.spanAdditionRegx,c.spanAdditionReplacer)).replace(/(<br\s*\/*\>)/g,'<span class="'+[c.classNameWithTag," ",c.classNameWithTagBR].join("")+'">$1</span>'),j.innerHTML=e,_=0,E=(k=j[p.childRetriverFn](p.childRetriverString)).length;_<E;_+=1)N=k[_],(p.noClassTesting||c.classNameReg.test(N.className))&&""!==(T=N.innerHTML)&&(" "===T?ae=re.length:"-"===T&&(ne=re.length),re.push({spaceIdx:ae,dashIdx:ne,elem:N}),J.push(T));if(Q=0,(A=(a=re.length)&&re[0].elem.offsetWidth)>t||!a)return se.text="",se.width=se.oriTextWidth=se.height=se.oriTextHeight=0,se;if(A>l&&!this._showNoEllipses&&((l=t-2*H)>A?ee="..":(l=t-H)>A?ee=".":(l=0,ee="")),x=re[0].elem.offsetLeft,w=re[0].elem.offsetTop,n)for(;Q<a;Q+=1)(M=(N=re[Q].elem).offsetLeft-x+N.offsetWidth)>l&&(O||(O=Q),j.offsetWidth>t&&(I=Q,Q=a));else for(;Q<a;Q+=1)D=(N=re[Q].elem).offsetHeight+(N.offsetTop-w),F=null,(M=N.offsetLeft-x+N.offsetWidth)>l?(O||(O=Q),M>t&&(X=re[Q].spaceIdx,$=re[Q].dashIdx,X>Y?(re[X].elem.innerHTML="<br/>",Y=X):$>Y?(re[$].elem.innerHTML=$===Q?"<br/>-":"-<br/>",Y=$):N.parentNode.insertBefore(F=u.createElement("br"),N),N.offsetHeight+N.offsetTop>r?(F?F.parentNode.removeChild(F):Y===$?re[$].elem.innerHTML="-":re[X].elem.innerHTML=" ",I=Q,Q=a):O=null)):D>r&&(I=Q,Q=a);if(I<a){for(se.isTruncated=!0,O=O||I,Q=a-1;Q>=O;Q-=1)(N=re[Q].elem).parentNode.removeChild(N);for(;Q>=0;Q-=1)N=re[Q].elem,c.classNameBrReg.test(N.className)?N.parentNode.removeChild(N):Q=0}return se.text=j.innerHTML.replace(c.spanRemovalRegx,"$1").replace(/\&amp\;/g,"&"),se.isTruncated&&(se.text+=ee,se.tooltext=d),se.height=j.offsetHeight,se.width=j.offsetWidth,se}return se.error=new Error("Body Tag Missing!"),se},v.prototype.getSize=function(e,t,r){if(void 0===e&&(e=""),void 0===t&&(t=!0),void 0===r&&(r={}),!this._init)return!1;e===undefined||null===e?e="":"string"!=typeof e&&(e=e.toString());var n,a,i,o,s,u,d=0,g=0,p={},m=r.hasHTMLTag,v=r.hasOnlyBrTag;if(void 0===m&&(m=c.xmlTagRegEx.test(e)||c.nbspRegex.test(e)),void 0===v&&(v=c._hasOnlyBRTag(e)),this.requireDiv=m&&!v,r.cleanText||(e=(e=e.replace(c.ltgtquotRegex,(function(e){switch(e){case"&lt;":return"<";case"&gt;":return">";case"&quot;":case"&#034;":return'"';case"&#039;":return"'"}}))).replace(/<u>/g,"").replace(/<\/u>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"").replace(/<strong>/g,"").replace(/<\/strong>/g,"").replace(/<em>/g,"").replace(/<\/em>/g,"").replace(/<i>/g,"").replace(/<\/i>/g,"").replace(/<strike>/g,"").replace(/<\/strike>/g,"").replace(/<s>/g,"").replace(/<\/s>/g,"").replace(/<del>/g,"").replace(/<\/del>/g,"").replace(/<sub>/g,"").replace(/<\/sub>/g,"").replace(/<sup>/g,"").replace(/<\/sup>/g,"").replace(/<a[\s]+([^>]+)>/g,"").replace(/<\/a>/g,"").replace(/<abbr[\s]+([^>]+)>/g,"").replace(/<\/abbr>/g,"").replace(/<span[\s]+([^>]+)>/g,"").replace(/<\/span>/g,"")),this._updateStyle(),u=this._container,!t)return this._calCharDimWithCache(e);for(o=0,s=(n=e.split("")).length;o<s;o++)a=n[o],i=this._calCharDimWithCache(a,!1,n.length),g=f(g,i.height),d+=i.width,p[a]=i.width;return v?l(l({},c._getDimentionOfMultiLineText(e,this)),{},{detailObj:p}):m?(u.innerHTML=e,{width:u.offsetWidth,height:u.offsetHeight,detailObj:p}):{width:h(d),height:g,detailObj:p}},v.prototype.getOriSize=function(e,t,r){return void 0===e&&(e=""),void 0===t&&(t=!0),void 0===r&&(r={}),this.getSize(e,t,r)},v.prototype.dispose=function(){return this._init?(this._containerManager&&this._containerManager.dispose&&this._containerManager.dispose(),delete this._container,delete this._context,delete this._cache,delete this._containerManager,delete this._containerObj,delete this.id,delete this.style,delete this.parentContainer,delete this._showNoEllipses,this):this};var E=v;t["default"]=E},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n={init:function(e){var t=e.document,r=e.navigator.userAgent,a=Math.ceil,i=Math.floor,o="fusioncharts-smartlabel-",s=o+"container",l=o+"tag";return n={win:e,containerClass:s,classNameWithTag:l,classNameWithTagBR:"fusioncharts-smartlabel-br",maxDefaultCacheLimit:1e3,classNameReg:/\bfusioncharts-smartlabel-tag\b/,classNameBrReg:/\bfusioncharts-smartlabel-br\b/,spanAdditionRegx:/(<[^<\>]+?\>)|(&(?:[a-z]+|#[0-9]+);|.)/gi,spanAdditionReplacer:'$1<span class="'+l+'">$2</span>',spanRemovalRegx:new RegExp("\\<span[^\\>]+?"+l+"[^\\>]{0,}\\>(.*?)\\<\\/span\\>","ig"),xmlTagRegEx:new RegExp("<[^>][^<]*[^>]+>","i"),brRegex:new RegExp("({br[ ]*})|(<br[ ]*>)|(<br[ ]*/>)|(<BR[ ]*/>)|(<br\\>)","g"),ltgtquotRegex:/&lt;|&gt;|&quot;|&#034;|&#039;/g,nbspRegex:/&nbsp;|&#160;|&#xA0;/g,htmlSpecialEntityRegex:/&amp;|&quot;|&lt;|&gt;/g,brReplaceRegex:/<br\/>/gi,testStrAvg:"WgI",parentContainerStyle:{position:"absolute",top:"-9999em",whiteSpace:"nowrap",padding:"0px",width:"1px",height:"1px",overflow:"hidden"},supportedStyle:{font:"font",fontFamily:"font-family","font-family":"font-family",fontWeight:"font-weight","font-weight":"font-weight",fontSize:"font-size","font-size":"font-size",lineHeight:"line-height","line-height":"line-height",fontStyle:"font-style","font-style":"font-style"},getDocumentSupport:function(){var n,a,i;return t.getElementsByClassName?(n="getElementsByClassName",a=l,i=!0):(n="getElementsByTagName",a="span",i=!1),{isIE:/msie/i.test(r)&&!e.opera,hasSVG:Boolean(e.SVGAngle||t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")),isHeadLess:new RegExp(" HtmlUnit").test(r),isWebKit:new RegExp(" AppleWebKit/").test(r),childRetriverFn:n,childRetriverString:a,noClassTesting:i}},createContainer:function(e){var r,n;if(e&&(e.offsetWidth||e.offsetHeight)){if(e.appendChild)return e.appendChild(n=t.createElement("DIV")),n.className=s,n.setAttribute("aria-hidden","true"),n.setAttribute("role","presentation"),n}else if((r=t.getElementsByTagName("body")[0])&&r.appendChild)return(n=t.createElement("DIV")).className=s,n.setAttribute("aria-hidden","true"),n.setAttribute("role","presentation"),r.appendChild(n),n},getNearestBreakIndex:function(e,t,r){if(!e||!e.length)return 0;var n,o=r._getWidthFn(),s=0,l=0,c=o(e),u=c/e.length;if(n=t,s=a(t/u),c<t)return e.length-1;for(s>e.length&&(n=t-c,s=e.length);n>0;){if(n=t-o(e.substr(0,s)),!(l=i(n/u)))return s;s+=l}for(;n<0;){if(n=t-o(e.substr(0,s)),!(l=i(n/u)))return s;s+=l}return s},parseStyle:function(e){void 0===e&&(e={});var t={};return t.fontSize=(e.fontSize||e["font-size"]||"12px")+"",t.fontVariant=e.fontVariant||e["font-variant"]||"normal",t.fontWeight=e.fontWeight||e["font-weight"]||"normal",t.fontStyle=e.fontStyle||e["font-style"]||"normal",t.fontFamily=e.fontFamily||e["font-family"]||"Verdana,sans",t.fontSize+=-1===t.fontSize.indexOf("px")?"px":"",t},setLineHeight:function(e){var t=e.fontSize;return e.lineHeight=e.lineHeight||e["line-height"]||1.2*parseInt(t,10)+"px",e},_getCleanHeight:function(e){return e=e.replace(/px/g,""),Number(e)},_getDimentionUsingDiv:function(e,t){void 0===e&&(e="");var r=t._container;return e instanceof Array&&(e=e.join("")),r.innerHTML=e,{width:r.offsetWidth,height:r.offsetHeight}},_getDimentionUsingCanvas:function(e,t){void 0===e&&(e="");var r=t.ctx,a=t.style,i=n._getCleanHeight(a.lineHeight);return e=e instanceof Array?(e=e.join("")).replace(/<br \/>/g,""):e.replace(/<br \/>/g,""),{width:r.measureText(e).width,height:i}},_hasOnlyBRTag:function(e){return void 0===e&&(e=""),!n.xmlTagRegEx.test(e)&&n.brRegex.test(e)},_getDimentionOfMultiLineText:function(e,t){void 0===e&&(e="");var r,a,i,o=e.replace(n.brRegex,"<br />"),s=n._getTextArray(o),l=0,c=0,u=t._getWidthFn(),d=n._getCleanHeight(t.style.lineHeight),f=d,h={};for(r=0,a=s.length;r<a;r++)"<br />"===s[r]?(c=Math.max(c,l),l=0,f+=d):(l+=i=u(s[r]),h[s[r]]=i);return{height:f,width:c=Math.max(c,l),detailObj:h}},_getTextArray:function(e){void 0===e&&(e="");var t,r,n,a,i,o,s=[];for(n=(i=e.split("<br />")).length,t=0;t<n;t++){for(a=(o=i[t].split("")).length,r=0;r<a;r++)s.push(o[r]);t!==n-1&&s.push("<br />")}return s},_findLastIndex:function(e,t){var r;for(void 0===e&&(e=[]),r=e.length-1;r>=0;r--)if(e[r]===t)return r;return-1}}}},a=n;t["default"]=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(250))["default"].init(window),i=a.win.document,o=a.getDocumentSupport(),s=o.isWebKit?0:4.5;function l(e,t,r){var n;r=(r=r>5?r:5)<20?r:20,this.maxContainers=r,this.first=null,this.last=null,this.containers={},this.length=0,this.rootNode=e,t&&((n=i.createElementNS("http://www.w3.org/2000/svg","svg")).setAttributeNS("http://www.w3.org/2000/svg","xlink","http://www.w3.org/1999/xlink"),n.setAttributeNS("http://www.w3.org/2000/svg","height","0"),n.setAttributeNS("http://www.w3.org/2000/svg","width","0"),this.svgRoot=n,this.rootNode.appendChild(n))}l.prototype.get=function(e){var t,r,n,i=this.containers,o=this.length,s=this.maxContainers,l="";for(r in a.supportedStyle)e[r]!==undefined&&(l+=a.supportedStyle[r]+":"+e[r]+";");if(!l)return!1;if(n=i[l])this.first!==n&&(n.prev&&(n.prev.next=n.next),n.next&&(n.next.prev=n.prev),n.next=this.first,n.next.prev=n,this.last===n&&(this.last=n.prev),n.prev=null,this.first=n);else{if(o>=s)for(t=o-s+1;t--;)this.removeContainer(this.last);n=this.addContainer(l)}return n},l.prototype._makeDivNode=function(e){var t,r=e.keyStr;e.node||(e.node=i.createElement("div"),e.node.className="fusioncharts-div",this.rootNode.appendChild(e.node)),t=e.node,o.isIE&&!o.hasSVG?t.style.setAttribute("cssText",r):t.setAttribute("style",r),t.setAttribute("aria-hidden","true"),t.setAttribute("role","presentation"),t.style.display="inline-block",t.innerHTML=a.testStrAvg,e.lineHeight=t.offsetHeight,e.avgCharWidth=t.offsetWidth/3,o.isBrowserLess?(e.svgText||(e.svgText=i.createElementNS("http://www.w3.org/2000/svg","text"),this.svgRoot.appendChild(t)),(t=e.svgText).setAttribute("style",r),t.textContent=a.testStrAvg,e.lineHeight=t.getBBox().height,e.avgCharWidth=(t.getBBox().width-s)/3,t.textContent="...",e.ellipsesWidth=t.getBBox().width-s,t.textContent=".",e.dotWidth=t.getBBox().width-s):(t.innerHTML="...",e.ellipsesWidth=t.offsetWidth,t.innerHTML=".",e.dotWidth=t.offsetWidth,t.innerHTML="")},l.prototype.addContainer=function(e){var t;return this.containers[e]=t={next:null,prev:null,node:null,ellipsesWidth:0,lineHeight:0,dotWidth:0,avgCharWidth:4,keyStr:e,charCache:{}},t.next=this.first,t.next&&(t.next.prev=t),this.first=t,this.last||(this.last=t),this.length+=1,t},l.prototype.removeContainer=function(e){var t=e.keyStr;t&&this.length&&e&&(this.length-=1,e.prev&&(e.prev.next=e.next),e.next&&(e.next.prev=e.prev),this.first===e&&(this.first=e.next),this.last===e&&(this.last=e.prev),e.node&&e.node.parentNode.removeChild(e.node),delete this.containers[t])},l.prototype.dispose=function(){var e,t=this.containers;for(e in this.maxContainers=null,t)this.removeContainer(t[e]);this.rootNode.parentNode.removeChild(this.rootNode),this.rootNode=null,this.first=null,this.last=null};var c=l;t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=t.getFile=t.addFile=void 0;var n={},a=function(e){n[e]=!0},i=function(e){return n[e]};t.getFile=i,t.addFile=a;var o={extension:function(e){e.addFile=a,e.getFile=i},name:"fileStore",type:"plugin",requiresFusionCharts:!0};t["default"]=o},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={options:{chartTypeSourcePath:["typeSourcePath",""],product:["product","v3"],insertMode:["insertMode","replace"],safeMode:["safeMode",!0],overlayButton:["overlayButton"],containerBackgroundColor:["containerBackgroundColor","#ffffff"],containerBackgroundOpacity:["containerBackgroundOpacity",1],containerClassName:["containerClassName","fusioncharts-container"],chartType:["type"],baseChartMessageFont:["baseChartMessageFont","Verdana,sans"],baseChartMessageFontSize:["baseChartMessageFontSize","10"],baseChartMessageColor:["baseChartMessageColor","#666666"],baseChartMessageImageHAlign:["baseChartMessageImageHAlign","middle"],baseChartMessageImageVAlign:["baseChartMessageImageVAlign","middle"],baseChartMessageImageAlpha:["baseChartMessageImageAlpha",100],baseChartMessageImageScale:["baseChartMessageImageScale",100],dataLoadStartMessage:["dataLoadStartMessage","Retrieving data. Please wait."],dataLoadErrorMessage:["dataLoadErrorMessage","Error in loading data."],dataInvalidMessage:["dataInvalidMessage","Invalid data."],dataEmptyMessage:["dataEmptyMessage","No data to display."],typeNotSupportedMessage:["typeNotSupportedMessage","Chart type not supported."],browserNotSupportedMessage:["browserNotSupportedMessage","This browser is not supported."],loadMessage:["loadMessage","Loading chart. Please wait."],renderErrorMessage:["renderErrorMessage","Unable to render chart."],messageURL:["messageURL",""],containerElementId:["renderAt"],renderer:["renderer"],containerElementType:["containerElementType"],showChartLoadingMessage:["showChartLoadingMessage",!0],visibilityTrackingInterval:300,events:["events",{}]},jsVars:{},attributes:{lang:["lang","EN"],id:["id"]},link:["link"],width:["width","400"],height:["height","300"]}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n,a,i,o,s,l=r(224),c=Math.abs,u=Math.pow,d=Math.round,f={formatnumber:"1",formatnumberscale:"1",forcenumberscale:"0",defaultnumberscale:"",numberscaleunit:["K","M"],numberscalevalue:[1e3,1e3],numberprefix:"",numbersuffix:"",decimals:"",forcedecimals:"0",yaxisvaluedecimals:"2",decimalseparator:".",thousandseparator:",",thousandseparatorposition:[3],indecimalseparator:"",inthousandseparator:"",sformatnumber:"1",sformatnumberscale:"0",sforcenumberscale:"0",sdefaultnumberscale:"",snumberscaleunit:["K","M"],snumberscalevalue:[1e3,1e3],snumberprefix:"",snumbersuffix:"",sdecimals:"2",sforcedecimals:"0",syaxisvaluedecimals:"2",xFormatNumber:"0",xFormatNumberScale:"0",xforcenumberscale:"0",xDefaultNumberScale:"",xNumberScaleUnit:["K","M"],xNumberScaleValue:[1e3,1e3],xNumberPrefix:"",xNumberSuffix:""},h={mscombidy2d:{formatnumberscale:"1"}},g=function(){function e(e,t){var r=e.getName&&e.getName(),n=this.csConf=(0,l.extend2)({},f),a=h[r];this.cleaneValueCacheStore={},this.percentStrCacheStore={},a&&(n=(0,l.extend2)(n,a)),this.linkedItems={chart:e},this.configure(t)}var t=e.prototype;return t.setDefaults=function(){var e=this.linkedItems.chart,t=e.getName&&e.getName(),r=this.csConf=(0,l.extend2)({},f),n=h[t];n&&(0,l.extend2)(r,n)},t.configure=function(e){var t,r,n,a,i,o,s,c,u,d,h,g,p,m,v,b,y,x,w,C,k,_,S,E,A,N,T,M,D=this,F=D.linkedItems.chart,I=e||F.getFromEnv("chart-attrib"),O=F.getName&&F.getName(),L=F.config,R=D.csConf;if(L||(L=F),D.csConf=R,D.useScaleRecursively=L.useScaleRecursively,(0,l.getValidValue)(I.numberscaleunit)&&(t=I.numberscaleunit.split(",")),(r=(0,l.getValidValue)(I.snumberscaleunit,I.numberscaleunit))&&(r=r.split(",")),(n=(0,l.getValidValue)(I.xnumberscaleunit,I.numberscaleunit))&&(n=n.split(",")),(a=(0,l.getValidValue)(I.ticknumberscaleunit,I.numberscaleunit))&&(a=a.split(",")),(i=(0,l.getValidValue)(I.ynumberscaleunit,I.numberscaleunit))&&(i=i.split(",")),(0,l.getValidValue)(I.numberscalevalue)&&(o=I.numberscalevalue.split(",")),(h=(0,l.getValidValue)(I.snumberscalevalue,I.numberscalevalue))&&(h=h.split(",")),(s=(0,l.getValidValue)(I.xnumberscalevalue,I.numberscalevalue))&&(s=s.split(",")),(c=(0,l.getValidValue)(I.ticknumberscalevalue,I.numberscalevalue))&&(c=c.split(",")),(u=(0,l.getValidValue)(I.ynumberscalevalue,I.numberscalevalue))&&(u=u.split(",")),(0,l.getValidValue)(I.thousandseparatorposition))for(y=(d=I.thousandseparatorposition.split(",")).length,w=f.thousandseparatorposition[0];y--;)(x=parseInt(d[y],10))<=0&&(x=w),w=d[y]=x;C=(0,l.pluckNumber)(I.scalerecursively,0),k=(0,l.pluckNumber)(I.sscalerecursively,C),_=(0,l.pluckNumber)(I.xscalerecursively,C),S=(0,l.pluckNumber)(I.maxscalerecursion,-1),E=(0,l.pluckNumber)(I.smaxscalerecursion,S),A=(0,l.pluckNumber)(I.xmaxscalerecursion,S),N=(0,l.getValidValue)(I.scaleseparator," "),T=(0,l.getValidValue)(I.sscaleseparator,N),M=(0,l.getValidValue)(I.xscaleseparator,N),S||(S=-1),D.baseConf=b={cacheStore:[],formatnumber:(0,l.pluck)(I.formatnumber,R.formatnumber),formatnumberscale:(0,l.pluck)(I.formatnumberscale,L.formatnumberscale,R.formatnumberscale),forcenumberscale:(0,l.pluck)(I.forcenumberscale,R.forcenumberscale),defaultnumberscale:(0,l.getFirstValue)(I.defaultnumberscale,R.defaultnumberscale),numberscaleunit:(0,l.pluck)(t,R.numberscaleunit).concat(),numberscalevalue:(0,l.pluck)(o,R.numberscalevalue).concat(),numberprefix:(0,l.parseUnsafeString)((0,l.getFirstValue)(I.numberprefix,R.numberprefix)),numbersuffix:(0,l.parseUnsafeString)((0,l.getFirstValue)(I.numbersuffix,R.numbersuffix)),decimalprecision:parseInt("auto"===I.decimals?R.decimalprecision:(0,l.pluck)(I.decimals,I.decimalprecision,L.decimals,R.decimals,L.decimalprecision,R.decimalprecision),10),forcedecimals:(0,l.pluck)(I.forcedecimals,R.forcedecimals),decimalseparator:(0,l.pluck)(I.decimalseparator,R.decimalseparator),thousandseparator:(0,l.pluck)(I.thousandseparator,R.thousandseparator),thousandseparatorposition:(0,l.pluck)(d,R.thousandseparatorposition),indecimalseparator:(0,l.getFirstValue)(I.indecimalseparator,R.indecimalseparator),inthousandseparator:(0,l.getFirstValue)(I.inthousandseparator,R.inthousandseparator),scalerecursively:C,maxscalerecursion:S,scaleseparator:N},(0,l.getValidValue)(b.inthousandseparator)&&(D.baseConf._REGinthousandseparator=new RegExp((0,l.regescape)(b.inthousandseparator),"g")),(0,l.getValidValue)(b.indecimalseparator)&&(D.baseConf._REGindecimalseparator=new RegExp((0,l.regescape)(b.indecimalseparator))),D.Y=[],g={cacheStore:[],formatnumber:b.formatnumber,formatnumberscale:b.formatnumberscale,forcenumberscale:b.forcenumberscale,defaultnumberscale:b.defaultnumberscale,numberscaleunit:b.numberscaleunit.concat(),numberscalevalue:b.numberscalevalue.concat(),numberprefix:b.numberprefix,numbersuffix:b.numbersuffix,decimalprecision:b.decimalprecision,forcedecimals:b.forcedecimals,decimalseparator:b.decimalseparator,thousandseparator:b.thousandseparator,thousandseparatorposition:b.thousandseparatorposition,indecimalseparator:b.indecimalseparator,inthousandseparator:b.inthousandseparator,scalerecursively:C,maxscalerecursion:S,scaleseparator:N},L.useScaleRecursively&&(g.numberscalevalue&&g.numberscalevalue.length)===(g.numberscaleunit&&g.numberscaleunit.length)||(g.scalerecursively=C=0),m={cacheStore:[],formatnumber:g.formatnumber,formatnumberscale:g.formatnumberscale,forcenumberscale:g.forcenumberscale,defaultnumberscale:g.defaultnumberscale,numberscaleunit:g.numberscaleunit.concat(),numberscalevalue:g.numberscalevalue.concat(),numberprefix:g.numberprefix,numbersuffix:g.numbersuffix,decimalprecision:parseInt((0,l.pluck)(I.yaxisvaluedecimals,g.decimalprecision,2),10),forcedecimals:(0,l.pluck)(I.forceyaxisvaluedecimals,g.forcedecimals),decimalseparator:g.decimalseparator,thousandseparator:g.thousandseparator,thousandseparatorposition:g.thousandseparatorposition.concat(),indecimalseparator:g.indecimalseparator,inthousandseparator:g.inthousandseparator,scalerecursively:C,maxscalerecursion:S,scaleseparator:N},v={cacheStore:[],formatnumber:(0,l.pluck)(I.sformatnumber,f.sformatnumber),formatnumberscale:(0,l.pluck)(I.sformatnumberscale,f.sformatnumberscale),forcenumberscale:(0,l.pluck)(I.sforcenumberscale,f.sforcenumberscale),defaultnumberscale:(0,l.getFirstValue)(I.sdefaultnumberscale,g.defaultnumberscale),numberscaleunit:(0,l.pluck)(r,f.snumberscaleunit).concat(),numberscalevalue:(0,l.pluck)(h,f.snumberscalevalue).concat(),numberprefix:(0,l.parseUnsafeString)((0,l.getFirstValue)(I.snumberprefix,f.snumberprefix)),numbersuffix:(0,l.parseUnsafeString)((0,l.getFirstValue)(I.snumbersuffix,f.snumbersuffix)),decimalprecision:parseInt((0,l.pluck)(I.syaxisvaluedecimals,I.sdecimals,I.decimals,f.sdecimals),10),forcedecimals:(0,l.pluck)(I.forcesyaxisvaluedecimals,I.sforcedecimals,I.forcedecimals,f.sforcedecimals),decimalseparator:(0,l.pluck)(I.decimalseparator,f.decimalseparator),thousandseparator:(0,l.pluck)(I.thousandseparator,f.thousandseparator),thousandseparatorposition:g.thousandseparatorposition.concat(),indecimalseparator:(0,l.parseUnsafeString)((0,l.pluck)(I.indecimalseparator,f.indecimalseparator)),inthousandseparator:(0,l.parseUnsafeString)((0,l.pluck)(I.inthousandseparator,f.inthousandseparator)),scalerecursively:k,maxscalerecursion:E,scaleseparator:T},(p=(0,l.extend2)({},v)).decimalprecision=parseInt((0,l.pluck)(I.sdecimals,I.decimals,I.syaxisvaluedecimals,f.sdecimals),10),p.forcedecimals=(0,l.pluck)(I.sforcedecimals,I.forcedecimals,I.forcesyaxisvaluedecimals,f.sforcedecimals),p.cacheStore=[],L.useScaleRecursively&&(v.numberscalevalue&&v.numberscalevalue.length)===(v.numberscaleunit&&v.numberscaleunit.length)||(v.scalerecursively=k=0),/^(bubble|scatter|selectscatter|zoomscatter)$/gi.test(O)&&(m.formatnumber=(0,l.pluck)(I.yformatnumber,m.formatnumber),m.formatnumberscale=(0,l.pluck)(I.yformatnumberscale,m.formatnumberscale),m.forcenumberscale=(0,l.pluck)(I.yforcenumberscale,m.forcenumberscale),m.defaultnumberscale=(0,l.getFirstValue)(I.ydefaultnumberscale,m.defaultnumberscale),m.numberscaleunit=(0,l.pluck)(i,m.numberscaleunit),m.numberscalevalue=(0,l.pluck)(u,m.numberscalevalue),m.numberprefix=(0,l.parseUnsafeString)((0,l.pluck)(I.ynumberprefix,m.numberprefix)),m.numbersuffix=(0,l.parseUnsafeString)((0,l.pluck)(I.ynumbersuffix,m.numbersuffix)),g.formatnumber=(0,l.pluck)(I.yformatnumber,g.formatnumber),g.formatnumberscale=(0,l.pluck)(I.yformatnumberscale,g.formatnumberscale),g.forcenumberscale=(0,l.pluck)(I.yforcenumberscale,g.forcenumberscale),g.defaultnumberscale=(0,l.getFirstValue)(I.ydefaultnumberscale,g.defaultnumberscale),g.numberscaleunit=(0,l.pluck)(I.ynumberscaleunit,g.numberscaleunit.concat()),g.numberscalevalue=(0,l.pluck)(I.ynumberscalevalue,g.numberscalevalue.concat()),g.numberprefix=(0,l.parseUnsafeString)((0,l.pluck)(I.ynumberprefix,g.numberprefix)),g.numbersuffix=(0,l.parseUnsafeString)((0,l.pluck)(I.ynumbersuffix,g.numbersuffix))),/^(pie2d|pie3d|doughnut2d|doughnut3d|marimekko|pareto2d|pareto3d)$/.test(O)&&(g.decimalprecision=(0,l.pluck)(I.decimals,"2")),C&&(g.numberscalevalue.push(1),g.numberscaleunit.unshift(g.defaultnumberscale),m.numberscalevalue.push(1),m.numberscaleunit.unshift(m.defaultnumberscale)),k&&(v.numberscalevalue.push(1),v.numberscaleunit.unshift(v.defaultnumberscale),p.numberscalevalue.push(1),p.numberscaleunit.unshift(p.defaultnumberscale)),D.Y[0]={yAxisLabelConf:m,dataLabelConf:g},D.Y[1]={yAxisLabelConf:v,dataLabelConf:p},D.paramLabels=g,D.param1=m,D.param2=v,D.paramLabels2=p,D.paramX={cacheStore:[],formatnumber:(0,l.pluck)(I.xformatnumber,b.formatnumber),formatnumberscale:(0,l.pluck)(I.xformatnumberscale,b.formatnumberscale),forcenumberscale:(0,l.pluck)(I.xforcenumberscale,b.forcenumberscale),defaultnumberscale:(0,l.getFirstValue)(I.xdefaultnumberscale,b.defaultnumberscale),numberscaleunit:(0,l.pluck)(n,b.numberscaleunit.concat()),numberscalevalue:(0,l.pluck)(s,b.numberscalevalue.concat()),numberprefix:(0,l.parseUnsafeString)((0,l.pluck)(I.xnumberprefix,b.numberprefix)),numbersuffix:(0,l.parseUnsafeString)((0,l.pluck)(I.xnumbersuffix,b.numbersuffix)),decimalprecision:parseInt((0,l.pluck)(I.xaxisvaluedecimals,I.xaxisvaluesdecimals,b.decimalprecision,2),10),forcedecimals:(0,l.pluck)(I.forcexaxisvaluedecimals,0),decimalseparator:b.decimalseparator,thousandseparator:b.thousandseparator,thousandseparatorposition:b.thousandseparatorposition.concat(),indecimalseparator:b.indecimalseparator,inthousandseparator:b.inthousandseparator,scalerecursively:_,maxscalerecursion:A,scaleseparator:M},D.paramLegend=(0,l.extend2)((0,l.extend2)({},b),{cacheStore:[],decimalprecision:parseInt((0,l.pluckNumber)(I.legendvaluedecimals,b.decimalprecision,2),10),forcedecimals:(0,l.pluckNumber)(I.legendvalueforcedecimals,b.forcedecimals,0),formatnumberscale:(0,l.pluck)(I.legendvalueformatnumberscale,b.formatnumberscale),forcenumberscale:(0,l.pluck)(I.legendvalueforcenumberscale,b.forcenumberscale),formatnumber:(0,l.pluck)(I.legendvalueformatnumber,b.formatnumber)}),C&&(D.paramLegend.numberscalevalue.push(1),D.paramLegend.numberscaleunit.unshift(D.paramLegend.defaultnumberscale)),L.useScaleRecursively&&(D.paramX.numberscalevalue&&D.paramX.numberscalevalue.length)===(D.paramX.numberscaleunit&&D.paramX.numberscaleunit.length)||(D.paramX.scalerecursively=_=0),_&&(D.paramX.numberscalevalue.push(1),D.paramX.numberscaleunit.unshift(D.paramX.defaultnumberscale)),D.paramScale={cacheStore:[],formatnumber:(0,l.pluck)(I.tickformatnumber,b.formatnumber),formatnumberscale:(0,l.pluck)(I.tickformatnumberscale,b.formatnumberscale),forcenumberscale:(0,l.pluck)(I.tickforcenumberscale,b.forcenumberscale),defaultnumberscale:(0,l.getFirstValue)(I.tickdefaultnumberscale,b.defaultnumberscale),numberscaleunit:(0,l.pluck)(a,b.numberscaleunit.concat()),numberscalevalue:(0,l.pluck)(c,b.numberscalevalue.concat()),numberprefix:(0,l.parseUnsafeString)((0,l.pluck)(I.ticknumberprefix,b.numberprefix)),numbersuffix:(0,l.parseUnsafeString)((0,l.pluck)(I.ticknumbersuffix,b.numbersuffix)),decimalprecision:parseInt((0,l.pluck)(I.tickvaluedecimals,b.decimalprecision,"2"),10),forcedecimals:(0,l.pluck)(I.forcetickvaluedecimals,b.forcedecimals,0),decimalseparator:b.decimalseparator,thousandseparator:b.thousandseparator,thousandseparatorposition:b.thousandseparatorposition.concat(),indecimalseparator:b.indecimalseparator,inthousandseparator:b.inthousandseparator,scalerecursively:C,maxscalerecursion:S,scaleseparator:N},C&&(D.paramScale.numberscalevalue.push(1),D.paramScale.numberscaleunit.unshift(D.paramScale.defaultnumberscale)),D.timeConf={inputDateFormat:(0,l.pluck)(I.inputdateformat,I.dateformat,"mm/dd/yyyy"),outputDateFormat:(0,l.pluck)(I.outputdateformat,I.inputdateformat,I.dateformat,"mm/dd/yyyy"),days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],daySuffix:["","st","nd","rd","th","th","th","th","th","th","th","th","th","th","th","th","th","th","th","th","th","st","nd","rd","th","th","th","th","th","th","th","st"]},D.cleaneValueCacheStore={},D.percentStrCacheStore={}},t.dispose=function(){var e=this;e.Y&&delete e.Y,e.cleaneValueCacheStore&&delete e.cleaneValueCacheStore,e.percentStrCacheStore&&delete e.percentStrCacheStore,e.paramLabels&&delete e.paramLabels,e.param1&&delete e.param1,e.param2&&delete e.param2,e.paramLabels2&&delete e.paramLabels2,e.csConf&&delete e.csConf,e.chart&&delete e.chart,e.baseConf&&delete e.baseConf,e.timeConf&&delete e.timeConf,e.paramX&&delete e.paramX,e.paramScale&&delete e.paramScale},t.parseMLAxisConf=function(e,t){var r,n,a,i,o,s,u,d,h=this.baseConf,g=this.csConf,p=(0,l.pluckNumber)(e.scalerecursively,h.scalerecursively),m=(0,l.pluckNumber)(e.maxscalerecursion,h.maxscalerecursion),v=(0,l.getValidValue)(e.scaleseparator,h.scaleseparator),b=(0,l.pluckNumber)(t,this.Y.length);if((0,l.getValidValue)(e.numberscaleunit)&&(n=e.numberscaleunit.split(",")),(0,l.getValidValue)(e.numberscalevalue)&&(a=e.numberscalevalue.split(",")),m||(m=-1),(0,l.getValidValue)(e.thousandseparatorposition))for(s=(o=e.thousandseparatorposition.split(",")).length,d=f.thousandseparatorposition[0];s--;)(u=(0,l.pluckNumber)(c(o[s])))?d=u:u=d,o[s]=u;r={cacheStore:[],formatnumber:(0,l.pluck)(e.formatnumber,h.formatnumber),formatnumberscale:(0,l.pluck)(e.formatnumberscale,h.formatnumberscale),forcenumberscale:(0,l.pluck)(e.forcenumberscale,h.forcenumberscale),defaultnumberscale:(0,l.getFirstValue)(e.defaultnumberscale,h.defaultnumberscale),numberscaleunit:(0,l.pluck)(n,h.numberscaleunit).concat(),numberscalevalue:(0,l.pluck)(a,h.numberscalevalue).concat(),numberprefix:(0,l.parseUnsafeString)((0,l.getFirstValue)(e.numberprefix,h.numberprefix)),numbersuffix:(0,l.parseUnsafeString)((0,l.getFirstValue)(e.numbersuffix,h.numbersuffix)),forcedecimals:(0,l.pluck)(e.forcedecimals,h.forcedecimals),decimalprecision:parseInt("auto"===e.decimals?g.decimalprecision:(0,l.pluck)(e.decimals,h.decimalprecision),10),decimalseparator:(0,l.pluck)(e.decimalseparator,h.decimalseparator),thousandseparator:(0,l.pluck)(e.thousandseparator,h.thousandseparator),thousandseparatorposition:(0,l.pluck)(o,h.thousandseparatorposition),indecimalseparator:(0,l.parseUnsafeString)((0,l.getFirstValue)(e.indecimalseparator,h.indecimalseparator)),inthousandseparator:(0,l.parseUnsafeString)((0,l.getFirstValue)(e.inthousandseparator,h.inthousandseparator)),scalerecursively:p,maxscalerecursion:m,scaleseparator:v},this.useScaleRecursively&&(r.numberscalevalue&&r.numberscalevalue.length)===(r.numberscaleunit&&r.numberscaleunit.length)||(r.scalerecursively=p=0),i={cacheStore:[],formatnumber:r.formatnumber,formatnumberscale:r.formatnumberscale,forcenumberscale:r.forcenumberscale,defaultnumberscale:r.defaultnumberscale,numberscaleunit:r.numberscaleunit.concat(),numberscalevalue:r.numberscalevalue.concat(),numberprefix:r.numberprefix,numbersuffix:r.numbersuffix,decimalprecision:parseInt((0,l.pluck)(e.yaxisvaluedecimals,r.decimalprecision,2),10),forcedecimals:(0,l.pluck)(e.forceyaxisvaluedecimals,r.forcedecimals),decimalseparator:r.decimalseparator,thousandseparator:r.thousandseparator,thousandseparatorposition:r.thousandseparatorposition.concat(),indecimalseparator:r.indecimalseparator,inthousandseparator:r.inthousandseparator,scalerecursively:p,maxscalerecursion:m,scaleseparator:v},p&&(r.numberscalevalue.push(1),r.numberscaleunit.unshift(r.defaultnumberscale),i.numberscalevalue.push(1),i.numberscaleunit.unshift(i.defaultnumberscale)),this.Y[b]={dataLabelConf:r,yAxisLabelConf:i}},t.percentValue=function(e){var t,r=this.percentStrCacheStore[e];return void 0===r&&(t=isNaN(this.paramLabels.decimalprecision)?"2":this.paramLabels.decimalprecision,r=this.percentStrCacheStore[e]=s(o(e,t,this.paramLabels.forcedecimals),this.paramLabels.decimalseparator,this.paramLabels.thousandseparator,this.paramLabels.thousandseparatorposition)+"%"),r},t.yAxisPercentValue=function(e,t){window.th=this;var r,n,a=this.Y[t]||(t?this.Y[1]:this.Y[0]);return void 0===(r=(a=a&&a.yAxisLabelConf||this.baseConf).cacheStore[e])&&(n=isNaN(a.decimalprecision)?"2":a.decimalprecision,r=a.cacheStore[e]=s(o(e,n,a.forcedecimals),a.decimalseparator,a.thousandseparator,a.thousandseparatorposition)+"%"),r},t.getCleanValue=function(e,t){var r,n=this.cleaneValueCacheStore[e];return(void 0===n||t)&&(r=i(e,this.baseConf),this.cleaneValueCacheStore[e]=n=isNaN(r)?null:t?c(r):r),n},t.dataLabels=function(e,t){var r,a=this.Y[t]||(t?this.Y[1]:this.Y[0]);return void 0===(r=(a=a&&a.dataLabelConf||this.baseConf).cacheStore[e])&&(r=a.cacheStore[e]=n(e,a)),r},t.formatValue=function(e){var t,r=this.baseConf;return void 0===(t=r.cacheStore[e])&&(t=r.cacheStore[e]=n(e,r)),t},t.yAxis=function(e,t){var r,a=this.Y[t]||(t?this.Y[1]:this.Y[0]);return void 0===(r=(a=a&&a.yAxisLabelConf||this.baseConf).cacheStore[e])&&(r=a.cacheStore[e]=n(e,a,!0)),r},t.xAxis=function(e){var t=this.paramX.cacheStore[e];return void 0===t&&(t=this.paramX.cacheStore[e]=n(e,this.paramX,!0)),t},t.sYAxis=function(e){var t,r=this.Y[1];return void 0===(t=(r=r&&r.yAxisLabelConf||this.baseConf).cacheStore[e])&&(t=r.cacheStore[e]=n(e,r)),t},t.scale=function(e){var t=this.paramScale.cacheStore[e];return void 0===t&&(t=this.paramScale.cacheStore[e]=n(e,this.paramScale)),t},t.legendValue=function(e){var t=this.paramLegend.cacheStore[e];return void 0===t&&(t=this.paramLegend.cacheStore[e]=n(e,this.paramLegend)),t},t.legendPercentValue=function(e){var t,r=this.percentStrCacheStore[e],n=this.paramLegend;return void 0===r&&(t=isNaN(n.decimalprecision)?"2":n.decimalprecision,r=this.percentStrCacheStore[e]=s(o(e,t,n.forcedecimals),n.decimalseparator,n.thousandseparator,n.thousandseparatorposition)+"%"),r},t.getDateValue=function(e){var t,r,n,a,i,o=e;return o&&!/\//.test(this.timeConf.inputDateFormat)&&(o=o.replace(new RegExp(this.timeConf.inputDateFormat.replace(/[a-z]/gi,"").slice(0,1),"g"),"/")),o=/^dd/.test(this.timeConf.inputDateFormat)&&o&&o.replace(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/,"$2/$1/$3")||o,/\s24:/.test(o)?(o=o.replace(/\s24:/," 00:"),(t=new Date(o)).setDate(t.getDate()+1)):t=new Date(o),!(i=t.getTime())&&o&&/\:/.test(o)&&(o=o.split(":"),r=(0,l.pluckNumber)(o[0],0),n=(0,l.pluckNumber)(o[1],0),a=(0,l.pluckNumber)(o[2],0),r=r>23?24===r&&0===n&&0===a?r:23:r,n=n>59?59:n,a=a>59?59:a,(t=new Date).setHours(r),t.setMinutes(n),t.setSeconds(a),i=t.getTime()),{ms:i,date:t}},t.getFormattedDate=function(e,t){var r="object"==typeof e&&e||new Date(e),n=this.timeConf,a=(0,l.pluck)(t,n.outputDateFormat),i=r.getFullYear(),o=r.getMonth(),s=r.getDate(),c=r.getDay(),u=r.getMinutes(),d=r.getSeconds(),f=r.getHours();return u=u>9?""+u:"0"+u,d=d>9?""+d:"0"+d,f=f>9?""+f:"0"+f,a.match(/dnl/)&&(a=a.replace(/dnl/gi,n.days[c])),a.match(/dns/)&&(a=a.replace(/dns/gi,n.days[c]&&n.days[c].substr(0,3))),a.match(/dd/)&&(a=a.replace(/dd/gi,s)),a.match(/mnl/)&&(a=a.replace(/mnl/gi,n.months[o])),a.match(/mns/)&&(a=a.replace(/mns/gi,n.months[o]&&n.months[o].substr(0,3))),a.match(/mm/)&&(a=a.replace(/mm/gi,o+1)),a.match(/yyyy/)&&(a=a.replace(/yyyy/gi,i)),a.match(/yy/)&&(a=a.replace(/yy/gi,(i%1e3%100+"").replace(/^(\d)$/,"0$1"))),a.match(/hh12/)&&(a=a.replace(/hh12/gi,f%12||12)),a.match(/hh/)&&(a=a.replace(/hh/gi,f)),a.match(/mn/)&&(a=a.replace(/mn/gi,u)),a.match(/ss/)&&(a=a.replace(/ss/gi,d)),a.match(/ampm/)&&(a=a.replace(/ampm/gi,f<12?"AM":"PM")),a.match(/ds/)&&(a=a.replace(/ds/gi,n.daySuffix[s])),a},e}();n=function(e,t,r){var n,i,c,u,d,f,h,g,p,m,v,b=e;if(null!==b){if(n=(b=Number(b))+"",i=1===Number(t.formatnumberscale)?t.defaultnumberscale:"",m=(p=n.split(".")[1])?p.length:t.forcedecimals?"2":"",1===Number(t.formatnumberscale)&&(n=(v=a(b,t.defaultnumberscale,t.numberscalevalue,t.numberscaleunit,t.scalerecursively,t.forcenumberscale)).value,b=v.value,i=v.scale),t.scalerecursively&&0!==t.formatnumberscale&&"0"!==t.formatnumberscale){if(c=v.value,u=v.scale,d=-1===Number(t.maxscalerecursion)?c.length:Math.min(c.length,t.maxscalerecursion),1===Number(t.formatnumber))for(n=l.BLANKSTRING,g=0;g<d;g++)h=(f=0===g?c[g]:Math.abs(c[g]))+"",g===d-1&&(h=o(f,(0,l.pluck)(t.decimalprecision,m),t.forcedecimals)),n=n+s(h,t.decimalseparator,t.thousandseparator,t.thousandseparatorposition)+u[g]+(g<d-1?t.scaleseparator:l.BLANKSTRING);else for(n=l.BLANKSTRING,g=0;g<d;g++)n=n+(0===g?c[g]:Math.abs(c[g])+"")+u[g]+(g<d-1?t.scaleseparator:"");n=(t.numberprefix||"")+n+(t.numbersuffix||"")}else 1===Number(t.formatnumber)&&(n=o(b,(0,l.pluck)(t.decimalprecision,m),t.forcedecimals),n=s(n,t.decimalseparator,t.thousandseparator,t.thousandseparatorposition,r)),n=(t.numberprefix||"")+n+i+(t.numbersuffix||"");return n}},a=function(e,t,r,n,a,i){var o,s,c,u,d={},f=t,h=0,g=[],p=[],m=e,v=(0,l.pluckNumber)(i)||0;if(a){for(o=(0,l.pluckNumber)(r[0])||1e3,h=0;h<r.length;h++){if(c=(0,l.pluckNumber)(r[h])||1e3,!(Math.abs(Number(m))>=c&&h<r.length-1)){0===h&&""===t&&v?(m=Number(m)/o,g.push(m),p.push(n[1]||"")):(1===h&&""===t&&v?(s=m+(g.length?g.pop():0),p.pop(),g.push(s)):g.push(m),p.push(n[h]));break}m=(m-(u=m%c))/c,0===h&&0!==u&&""===n[h]&&v?(g.push(u/o),p.push(n[1]||"")):0!==u&&(1===h&&""===t&&v?(s=u+(g.length?g.pop():0),p.pop(),g.push(s)):g.push(u),p.push(n[h]))}g.reverse(),p.reverse(),d.value=g,d.scale=p}else{if(r.length===n.length)for(h=0;h<r.length;h++){if(!((c=(0,l.pluckNumber)(r[h])||1e3)&&Math.abs(Number(m))>=c)){0===h&&""===t&&v&&(f=n[0]||"",m=Number(m)/c);break}f=n[h]||"",m=Number(m)/c}d.value=m,d.scale=f}return d},o=function(e,t,r){var n,a,i,o,s=e,l=t;if(l<=0)return s.toFixed(0);if(isNaN(l))return(s+="").length>12&&-1!==s.indexOf(".")&&(l=12-s.split(".")[0].length,n=u(10,l),s=a=d(s*n)/n+""),s;if(n=u(10,l),a=s<0?-d(-s*n)/n+"":d(s*n)/n+"",1===Number(r))for(-1===a.indexOf(".")&&(a+=".0"),i=l-a.split(".")[1].length,o=1;o<=i;o++)a+="0";return a},s=function(e,t,r,n,a){var i,o,s,l,c=Number(e),u="",d=!1,f="",h="",g=0,p=0;if(isNaN(c))return"";if(c>1e15)return i=a?1:14,c.toExponential(i);if(g=0,p=e.length,-1!==e.indexOf(".")&&(u=e.substring(e.indexOf(".")+1,e.length),p=e.indexOf(".")),c<0&&(d=!0,g=1),(o=(f=e.substring(g,p)).length)<(l=n[s=n.length-1]))h=f;else for(;o>=l;)h=(o-l?r:"")+f.substr(o-l,l)+h,(o-=l)<(l=(s-=1)<=0?n[0]:n[s])&&(h=f.substring(o,0)+h);return""!==u&&(h=h+t+u),!0===d&&(h="-"+h),h},i=function(e,t){var r=e;return r+="",t._REGinthousandseparator&&(r=r.replace(t._REGinthousandseparator,"")),t._REGindecimalseparator&&(r=r.replace(t._REGindecimalseparator,".")),r=parseFloat(r),isFinite(r)?r:NaN};var p=g;t["default"]=p},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(256));a["default"].stopPartialEventPropagation=!0,a["default"]._stopabsolutePath=!0;var i={extension:a["default"],name:"redraphael",type:"plugin"};t["default"]=i},function(e,t,r){"use strict";(function(e){var n=r(219);t.__esModule=!0,t["default"]=void 0;var a,i=n(r(257)),o=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=s(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(227));function s(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(s=function(e){return e?r:t})(e)}var l="undefined"!=typeof window?window:void 0!==e?e:null;function c(e){var t,r,n;return c._url===undefined&&(c._url=g),c.is(e,S)?u?e():i["default"].on("raphael.DOMload",e):c.is(e,w)?c._engine.create[v](c,e.splice(0,3+c.is(e[0],y))).add(e):(r=(0,o.getArrayCopy)(arguments),t=Array.prototype.slice.call(r,0),c.is(t[t.length-1],S)?(n=t.pop(),u?n.call(c._engine.create[v](c,t)):i["default"].on("raphael.DOMload",(function(){n.call(c._engine.create[v](c,t))}))):c._engine.create[v](c,arguments))}c.upgrade="1.0.0",c.version="2.1.0",c.eve=i["default"];var u,d,f,h,g="",p=" ",m="hasOwnProperty",v="apply",b="concat",y="number",x="string",w="array",C="object",k="split",_="none",S="function",E=/R/i,A=/trident/i.test(l.navigator.userAgent),N={a:7,c:6,h:1,l:2,m:2,r:4,q:4,s:4,t:2,v:1,z:0},T=Array.prototype.splice,M=function(){}.hasOwnProperty("prototype"),D={doc:l.document,win:l},F=D.doc,I=D.win,O=c.safePointerEventMapping={mouseover:"pointerover",mousedown:"pointerdown",mousemove:"pointermove",mouseup:"pointerup",mouseout:"pointerout"},L=I.navigator,R=c.supportsTouch="ontouchstart"in F||L.maxTouchPoints||L.msMaxTouchPoints,P=c.supportsPointer="onpointerover"in F,V=c.isEdge=/Edge/.test(L.userAgent),j=c.isIE11=/trident/i.test(L.userAgent)&&/rv:11/i.test(L.userAgent)&&!I.opera,B=(c.isIE10=-1!==L.appVersion.indexOf("MSIE 10"),c.isFirefox=/Firefox/.test(L.userAgent)),z=c.isWindows=/Windows/.test(L.userAgent),H="L",U=[],G=/[a-z]/i,W=function(e,t,r){var n=t.toLowerCase(),a=[],i=0;if(U.length=0,r.replace(ke,(function(e,t){t&&U.push(+t)})),"r"===n)d.push([t][b](U));else if("z"===n)d.push([t]);else if(U.length>=N[n]){for(;i<U.length;)i%N[n]?a.push(U[i]):(a.length&&d.push(a)&&(a=[]),a.push(t,U[i])),i++;d.push(a)}},$=function(){},X=(c.ca=c.customAttributes=$.prototype,function(){this.ca=this.customAttributes=new $,this._CustomAttributes=function(){},this._CustomAttributes.prototype=this.ca,this._elementsById={},this.id=c._oid++,(0,i["default"])("raphael.new",this)}),Y=c.fn=X.prototype=c.prototype,q="click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel dragstart dragmove dragend"[k](p),K={dragstart:"touchstart",dragmove:"touchmove",dragend:"touchend"},J=String,Z=I.parseFloat,Q=I.parseInt,ee=Math,te=ee.max,re=ee.min,ne=ee.abs,ae=ee.pow,ie=ee.cos,oe=ee.sin,se=ee.sqrt,le=ee.round,ce=ee.PI,ue=ce/180,de=180/ce,fe=J.prototype.toLowerCase,he=J.prototype.toUpperCase,ge=Object.prototype.toString,pe=/[, ]+/,me=/\{(\d+)\}/g,ve=/^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i,be=/^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,ye=/[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,xe=/,?([achlmqrstvxz]),?/gi,we=/([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,Ce=/([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,ke=/(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/gi,_e={NaN:1,Infinity:1,"-Infinity":1},Se={hs:1,rg:1},Ee=c._availableAttrs=((a={"arrow-end":_,"arrow-start":_,blur:0,"clip-rect":"0 0 1e9 1e9","clip-path":g,cursor:"default",cx:0,cy:0,fill:"#fff","fill-opacity":1,font:'10px "Arial"',"font-family":'"Arial"',"font-size":"10","font-style":"normal","font-weight":400,gradient:0,height:0,href:"about:blank","letter-spacing":0,"line-height":12,"vertical-align":"middle",opacity:1,path:"M0,0",r:0,rx:0,ry:0,src:g,stroke:"#000","stroke-dasharray":g,"stroke-linecap":"butt","stroke-linejoin":"butt","stroke-miterlimit":0,"stroke-opacity":1,"stroke-width":1,target:"_blank","text-anchor":"middle",visibility:g,title:g,transform:g,rotation:0,width:0,x:0,y:0,"shape-rendering":"auto",alpha:y,"font-stretch":"normal","alignment-baseline":"auto","baseline-shift":"auto","clip-rule":"nonzero","dominant-baseline":"auto","fill-rule":"nonzero",filter:_,"flood-color":"#000","flood-opacity":1,"font-size-adjust":_})["font-stretch"]="normal",a["font-variant"]="normal",a.kerning="auto",a["lighting-color"]="white",a["marker-end"]=_,a["marker-mid"]=_,a["marker-start"]=_,a.mask=_,a["pointer-events"]="visiblePainted",a["stop-color"]="#000",a["stop-opacity"]=1,a["stroke-dashoffset"]=0,a["text-decoration"]=_,a["vector-effect"]=g,a.visibility="visible",a["word-spacing"]="normal",a["writing-mode"]="lr-tb",a),Ae=c._availableAnimAttrs={blur:y,"clip-rect":"csv","clip-path":"path",cx:y,cy:y,fill:"colour","fill-opacity":y,"font-size":y,height:y,opacity:y,path:"path",r:y,rx:y,ry:y,stroke:"colour","stroke-opacity":y,"stroke-width":y,transform:"transform",width:y,x:y,y:y,color:"colour",borderColor:"colour",borderWidth:y,alpha:y,"text-bound":"text-bound"},Ne={},Te=function(e,t){return Z(e)-Z(t)},Me=function(e){return e},De=c._rectPath=function(e,t,r,n,a){return a?[["M",e+a,t],["l",r-2*a,0],["a",a,a,0,0,1,a,a],["l",0,n-2*a],["a",a,a,0,0,1,-a,a],["l",2*a-r,0],["a",a,a,0,0,1,-a,-a],["l",0,2*a-n],["a",a,a,0,0,1,a,-a],["z"]]:[["M",e,t],["l",r,0],["l",0,n],["l",-r,0],["z"]]},Fe=function(e,t,r,n){return null==n&&(n=r),[["M",e,t],["m",0,-n],["a",r,n,0,1,1,0,2*n],["a",r,n,0,1,1,0,-2*n],["z"]]},Ie=c._getPath={group:function(){return!1},path:function(e){return e.attr("path")},circle:function(e){var t=e.attrs;return Fe(t.cx,t.cy,t.r)},ellipse:function(e){var t=e.attrs;return Fe(t.cx,t.cy,t.rx,t.ry)},rect:function(e){var t=e.attrs;return De(t.x,t.y,t.width,t.height,t.r)},image:function(e){var t=e.attrs;return De(t.x,t.y,t.width,t.height)},text:function(e){var t=e._getBBox();return De(t.x,t.y,t.width,t.height)}},Oe=c.mapPath=function(e,t){if(!t)return e;var r,n,a,i,o,s,l;for(a=0,o=(e=ot(e).slice(0)).length;a<o;a++)for(i=1,s=(l=e[a]=e[a].slice(0)).length;i<s;i+=2)r=t.x(l[i],l[i+1]),n=t.y(l[i],l[i+1]),l[i]=r,l[i+1]=n;return e},Le=c._lastArgIfGroup=function(e,t){var r=e.length-1,n=e[r];if(n&&n.constructor===c.el.constructor&&"group"===n.type)return t&&(e[r]=undefined,delete e[r],T.call(e,r,1)),n},Re=c._serializeArgs=function(e){var t,r,n,a,i=e[0];if(c.is(i,C)&&!c.is(i,w)&&"group"!==i.type)for(r=i,i.path&&(t=i.path)&&!c.is(t,x)&&!c.is(t[0],w)&&(t+=g),n=1,a=arguments.length;n<a;n+=2)r[arguments[n]]||(r[arguments[n]]=arguments[n+1]);else for(r={},n=1,a=arguments.length;n<a;n+=2)r[arguments[n]]=e[(n-1)/2]||arguments[n+1];return r},Pe=c.is=function(e,t){return"finite"===t?!_e[m](+e):t===w?e instanceof Array:(t!==C||null!=e)&&("null"===t&&null===e||t===typeof e&&null!==e||t===C&&e===Object(e)||t===w&&Array.isArray&&Array.isArray(e)||ge.call(e).slice(8,-1).toLowerCase()===t)},Ve=c.clone=M?function(e){if(Object(e)!==e)return e;if(e instanceof Function)return e;var t=new e.constructor;for(var r in e)"prototype"!==r&&e[m](r)&&(t[r]=Ve(e[r]));return t}:function(e){if(Object(e)!==e)return e;if(e instanceof Function)return e;var t=new e.constructor;for(var r in e)e[m](r)&&(t[r]=Ve(e[r]));return t},je=l.Node;function Be(e){this._comparator=e,this._elements=[]}je&&!je.prototype.contains&&(je.prototype.contains=function(e){for(;e=e.parentNode;)if(e===this)return!0;return!1}),c._g=D,c.merge=o.merge,c.extend=o["default"],c.createUUID=(f=/[xy]/g,h=function(e){var t=16*ee.random()|0;return("x"===e?t:3&t|8).toString(16)},function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(f,h).toUpperCase()}),c._radial_gradient=/^x?r(?:\(([^\)]*?)\))?/,c._ISURL=/^url\(['"]?([^\)]+?)['"]?\)$/i,c.getElementID=function(e){return"rr-"+e},Be.prototype.isEmpty=function(){return 0===this.size()},Be.prototype.peek=function(){return this.isEmpty()?null:this._elements[0]},Be.prototype.deq=function(){var e=this.peek(),t=this._elements.pop(),r=this.size();if(0===r)return e;this._elements[0]=t;for(var n=0;n<r;){var a=n,i=2*n+1,o=2*n+2;if(i<r&&this._compare(i,a)>=0&&(a=i),o<r&&this._compare(o,a)>=0&&(a=o),a===n)break;this._swap(a,n),n=a}return e},Be.prototype.enq=function(e){for(var t=this._elements.push(e),r=t-1;r>0;){var n=Math.floor((r-1)/2);if(this._compare(r,n)<=0)break;this._swap(n,r),r=n}return t},Be.prototype.size=function(){return this._elements.length},Be.prototype._compare=function(e,t){return this._comparator(this._elements[e],this._elements[t])},Be.prototype._swap=function(e,t){var r=this._elements[e];this._elements[e]=this._elements[t],this._elements[t]=r},c.type=I.ENABLE_RED_CANVAS&&(I.CanvasRenderingContext2D||F.createElement("canvas").getContext)?"CANVAS":I.SVGAngle||F.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")?"SVG":"VML",c.svg=!((c.vml="VML"===c.type)||(c.canvas="CANVAS"===c.type)),c._Paper=X,c._id=0,c._oid=0,c.rad=function(e){return e%360*ue},c.deg=function(e){return e*de%360};var ze=function(e){if(c.vml){var t,r=/^\s+|\s+$/g;try{var n=new ActiveXObject("htmlfile");n.write("<body>"),n.close(),t=n.body}catch(s){t=createPopup().document.body}var a=t.createTextRange();ze=(0,o.cacher)((function(e){try{t.style.color=J(e).replace(r,g);var n=a.queryCommandValue("ForeColor");return"#"+("000000"+(n=(255&n)<<16|65280&n|(16711680&n)>>>16).toString(16)).slice(-6)}catch(s){return _}}))}else{var i=D.doc.createElement("i");i.title="Raphaël Colour Picker",i.style.display=_,D.doc.body.appendChild(i),ze=(0,o.cacher)((function(e){return i.style.color=e,D.doc.defaultView.getComputedStyle(i,g).getPropertyValue("color")}))}return ze(e)},He=function(){return"hsb("+[this.h,this.s,this.b]+")"},Ue=function(){return"hsl("+[this.h,this.s,this.l]+")"},Ge=function(){return this.hex},We=function(e,t,r){if(null==t&&Pe(e,C)&&"r"in e&&"g"in e&&"b"in e&&(r=e.b,t=e.g,e=e.r),null==t&&Pe(e,x)){var n=c.getRGB(e);e=n.r,t=n.g,r=n.b}return(e>1||t>1||r>1)&&(e/=255,t/=255,r/=255),[e,t,r]},$e=function(e,t,r,n){var a={r:e*=255,g:t*=255,b:r*=255,hex:c.rgb(e,t,r),toString:Ge};return Pe(n,"finite")&&(a.opacity=n),a};function Xe(){return this.hex}function Ye(e,t){for(var r=[],n=0,a=e.length;a-2*!t>n;n+=2){var i=[{x:+e[n-2],y:+e[n-1]},{x:+e[n],y:+e[n+1]},{x:+e[n+2],y:+e[n+3]},{x:+e[n+4],y:+e[n+5]}];t?n?a-4===n?i[3]={x:+e[0],y:+e[1]}:a-2===n&&(i[2]={x:+e[0],y:+e[1]},i[3]={x:+e[2],y:+e[3]}):i[0]={x:+e[a-2],y:+e[a-1]}:a-4===n?i[3]=i[2]:n||(i[0]={x:+e[n],y:+e[n+1]}),r.push(["C",(-i[0].x+6*i[1].x+i[2].x)/6,(-i[0].y+6*i[1].y+i[2].y)/6,(i[1].x+6*i[2].x-i[3].x)/6,(i[1].y+6*i[2].y-i[3].y)/6,i[2].x,i[2].y])}return r}c.color=function(e){var t;return c.is(e,C)&&"h"in e&&"s"in e&&"b"in e?(t=c.hsb2rgb(e),e.r=t.r,e.g=t.g,e.b=t.b,e.hex=t.hex):c.is(e,C)&&"h"in e&&"s"in e&&"l"in e?(t=c.hsl2rgb(e),e.r=t.r,e.g=t.g,e.b=t.b,e.hex=t.hex):(c.is(e,x)&&(e=c.getRGB(e)),c.is(e,C)&&"r"in e&&"g"in e&&"b"in e?(t=c.rgb2hsl(e),e.h=t.h,e.s=t.s,e.l=t.l,t=c.rgb2hsb(e),e.v=t.b):(e={hex:_}).r=e.g=e.b=e.h=e.s=e.v=e.l=-1),e.toString=Ge,e},c.hsb2rgb=function(e,t,r,n){var a,i,o,s,l;return this.is(e,C)&&"h"in e&&"s"in e&&"b"in e&&(r=e.b,t=e.s,n=(e=e.h).o),s=(l=r*t)*(1-ne((e=(e*=360)%360/60)%2-1)),a=i=o=r-l,$e(a+=[l,s,0,0,s,l][e=~~e],i+=[s,l,l,s,0,0][e],o+=[0,0,s,l,l,s][e],n)},c.hsl2rgb=function(e,t,r,n){var a,i,o,s,l;return this.is(e,C)&&"h"in e&&"s"in e&&"l"in e&&(r=e.l,t=e.s,e=e.h),(e>1||t>1||r>1)&&(e/=360,t/=100,r/=100),s=(l=2*t*(r<.5?r:1-r))*(1-ne((e=(e*=360)%360/60)%2-1)),a=i=o=r-l/2,$e(a+=[l,s,0,0,s,l][e=~~e],i+=[s,l,l,s,0,0][e],o+=[0,0,s,l,l,s][e],n)},c.rgb2hsb=function(e,t,r){var n,a;return e=(r=We(e,t,r))[0],t=r[1],r=r[2],{h:((0===(a=(n=te(e,t,r))-re(e,t,r))?null:n===e?(t-r)/a:n===t?(r-e)/a+2:(e-t)/a+4)+360)%6*60/360,s:0===a?0:a/n,b:n,toString:He}},c.rgb2hsl=function(e,t,r){var n,a,i,o;return e=(r=We(e,t,r))[0],t=r[1],r=r[2],n=((a=te(e,t,r))+(i=re(e,t,r)))/2,{h:((0===(o=a-i)?null:a===e?(t-r)/o:a===t?(r-e)/o+2:(e-t)/o+4)+360)%6*60/360,s:0===o?0:n<.5?o/(2*n):o/(2-2*n),l:n,toString:Ue}},c._path2string=function(){return this.join(",").replace(xe,"$1")},c._cacher=o.cacher,c.getRGB=(0,o.cacher)((function(e){var t,r,n,a,i,o,s;return e&&Pe(e,C)&&"opacity"in e&&(t=e.opacity),!e||(e=J(e)).indexOf("-")+1?{r:-1,g:-1,b:-1,hex:_,error:1,toString:Xe}:e===_?{r:-1,g:-1,b:-1,hex:_,toString:Xe}:(!Se[m](e.toLowerCase().substring(0,2))&&"#"!==e.charAt()&&(e=ze(e)),(s=e.match(ve))?(s[2]&&(a=Q(s[2].substring(5),16),n=Q(s[2].substring(3,5),16),r=Q(s[2].substring(1,3),16)),s[3]&&(a=Q((i=s[3].charAt(3))+i,16),n=Q((i=s[3].charAt(2))+i,16),r=Q((i=s[3].charAt(1))+i,16)),s[4]&&(o=s[4][k](ye),r=Z(o[0]),"%"===o[0].slice(-1)&&(r*=2.55),n=Z(o[1]),"%"===o[1].slice(-1)&&(n*=2.55),a=Z(o[2]),"%"===o[2].slice(-1)&&(a*=2.55),"rgba"===s[1].toLowerCase().slice(0,4)&&(t=Z(o[3])),o[3]&&"%"===o[3].slice(-1)&&(t/=100)),s[5]?(o=s[5][k](ye),r=Z(o[0]),"%"===o[0].slice(-1)&&(r*=2.55),n=Z(o[1]),"%"===o[1].slice(-1)&&(n*=2.55),a=Z(o[2]),"%"===o[2].slice(-1)&&(a*=2.55),("deg"===o[0].slice(-3)||"°"===o[0].slice(-1))&&(r/=360),"hsba"===s[1].toLowerCase().slice(0,4)&&(t=Z(o[3])),o[3]&&"%"===o[3].slice(-1)&&(t/=100),c.hsb2rgb(r,n,a,t)):s[6]?(o=s[6][k](ye),r=Z(o[0]),"%"===o[0].slice(-1)&&(r*=2.55),n=Z(o[1]),"%"===o[1].slice(-1)&&(n*=2.55),a=Z(o[2]),"%"===o[2].slice(-1)&&(a*=2.55),("deg"===o[0].slice(-3)||"°"===o[0].slice(-1))&&(r/=360),"hsla"===s[1].toLowerCase().slice(0,4)&&(t=Z(o[3])),o[3]&&"%"===o[3].slice(-1)&&(t/=100),c.hsl2rgb(r,n,a,t)):((s={r:r,g:n,b:a,toString:Xe}).hex="#"+(16777216|a|n<<8|r<<16).toString(16).slice(1),c.is(t,"finite")&&(s.opacity=t),s)):{r:-1,g:-1,b:-1,hex:_,error:1,toString:Xe})}),c),c.tintshade=(0,o.cacher)((function(e,t){var r,n=c.getRGB(e),a=255;return t<0&&(t*=-1,a=0),t>1&&(t=1),(r=0===t?n:{r:a-(a-n.r)*t,g:a-(a-n.g)*t,b:a-(a-n.b)*t,toString:Xe}).hex=c.rgb(r.r,r.g,r.b),n.error&&(r.error=n.error),"opacity"in n?(r.rgba="rgba("+[r.r,r.g,r.b,n.opacity].join(",")+")",r.opacity=n.opacity):r.rgba="rgb("+[r.r,r.g,r.b].join(",")+")",r}),c),c.rgb=(0,o.cacher)((function(e,t,r){return"#"+(16777216|r|t<<8|e<<16).toString(16).slice(1)})),c.sanitizePath=function(e){var t;return t=e.join?e.join(","):e,t=E.test(t)?c._pathToAbsolute(t):t.replace(xe,"$1")},c.parsePathString=function(e){if(!e||!e.length)return null;var t=qe(e);if(t.arr)return Qe(t.arr);if(d=void 0,c.is(e,w))if(e=J(e).replace(/,?([A-Z]),?/g,",$1,").replace(/(^,?)|(,?$)/g,"").replace(/,,?/g,",").split(","),c.is(e[0],w))d=Qe(e);else{var r,n,a,i=[],o=e.length;for(d=[],r=0;r<o;r+=1)G.test(e[r])?(i.length&&d.push(i),i=[n=e[r]],a=N[n.toLowerCase()]):a?(i.push(+e[r]),a--):e[r].length&&(d.push(i),i=[n].concat(+e[r]),a=N[n.toLowerCase()]-1);d.push(i)}return d&&d.length||(d=[],J(e).replace(we,W)),d.toString=c._path2string,t.arr=d,t.arr},c.parseTransformString=(0,o.cacher)((function(e){if(!e)return null;var t=[];return c.is(e,w)&&c.is(e[0],w)&&(t=Qe(e)),t.length||J(e).replace(Ce,(function(e,r,n){var a=[];fe.call(r);n.replace(ke,(function(e,t){t&&a.push(+t)})),t.push([r][b](a))})),t.toString=c._path2string,t}));var qe=(0,o.cacher)((function(){return{}}),void 0,void 0,void 0,500,{},!0);function Ke(e,t,r,n,a){return e*(e*(-3*t+9*r-9*n+3*a)+6*t-12*r+6*n)-3*t+3*r}function Je(e,t,r,n,a,i,o,s,l){null==l&&(l=1);for(var c=(l=l>1?1:l<0?0:l)/2,u=[-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],d=[.2491,.2491,.2335,.2335,.2032,.2032,.1601,.1601,.1069,.1069,.0472,.0472],f=0,h=0;h<12;h++){var g=c*u[h]+c,p=Ke(g,e,r,a,o),m=Ke(g,t,n,i,s);f+=d[h]*se(p*p+m*m)}return c*f}c.findDotsAtSegment=function(e,t,r,n,a,i,o,s,l){var c=1-l,u=ae(c,3),d=ae(c,2),f=l*l,h=f*l,g=u*e+3*d*l*r+3*c*l*l*a+h*o,p=u*t+3*d*l*n+3*c*l*l*i+h*s,m=e+2*l*(r-e)+f*(a-2*r+e),v=t+2*l*(n-t)+f*(i-2*n+t),b=r+2*l*(a-r)+f*(o-2*a+r),y=n+2*l*(i-n)+f*(s-2*i+n),x=c*e+l*r,w=c*t+l*n,C=c*a+l*o,k=c*i+l*s,_=90-180*ee.atan2(m-b,v-y)/ce;return(m>b||v<y)&&(_+=180),{x:g,y:p,m:{x:m,y:v},n:{x:b,y:y},start:{x:x,y:w},end:{x:C,y:k},alpha:_}},c._removedFactory=function(e){return function(){(0,i["default"])("raphael.log",null,"Raphaël: you are calling to method “"+e+"” of removed object",e)}};var Ze=c.pathBBox=function(e){var t=qe(e);if(!e)return{x:0,y:0,width:0,height:0,x2:0,y2:0};for(var r,n=0,a=0,i=[],o=[],s=0,l=(e=ot(e)).length;s<l;s++)if("M"===(r=e[s])[0])n=r[1],a=r[2],i.push(n),o.push(a);else{var c=it(n,a,r[1],r[2],r[3],r[4],r[5],r[6]);i=i[b](c.min.x,c.max.x),o=o[b](c.min.y,c.max.y),n=r[5],a=r[6]}var u=re[v](0,i),d=re[v](0,o),f=te[v](0,i),h=te[v](0,o),g={x:u,y:d,x2:f,y2:h,width:f-u,height:h-d};return t.bbox=Ve(g),g},Qe=function(e){var t=Ve(e);return t.toString=c._path2string,t},et=c._pathToAbsolute=function(e){var t,r=qe(e);if(!r.abs){if(c.is(e,w)&&c.is(e&&e[0],w)||(e=c.parsePathString(e)),!e||!e.length)return(t=[["M",0,0]]).toString=c._path2string,t;var n=0,a=0,i=0,o=0,s=0;t=[],"M"===e[0][0]&&(i=n=+e[0][1],o=a=+e[0][2],s++,t[0]=["M",n,a]);for(var l,u,d=3===e.length&&"M"===e[0][0]&&"R"===e[1][0].toUpperCase()&&"Z"===e[2][0].toUpperCase(),f=s,h=e.length;f<h;f++){if(t.push(l=[]),(u=e[f])[0]!=he.call(u[0]))switch(l[0]=he.call(u[0]),l[0]){case"A":l[1]=u[1],l[2]=u[2],l[3]=u[3],l[4]=u[4],l[5]=u[5],l[6]=+(u[6]+n),l[7]=+(u[7]+a);break;case"V":l[1]=+u[1]+a;break;case"H":l[1]=+u[1]+n;break;case"R":for(var g=[n,a][b](u.slice(1)),p=2,m=g.length;p<m;p++)g[p]=+g[p]+n,g[++p]=+g[p]+a;t.pop(),t=t[b](Ye(g,d));break;case"M":i=+u[1]+n,o=+u[2]+a;default:for(p=1,m=u.length;p<m;p++)l[p]=+u[p]+(p%2?n:a),p%2?n=l[p]:a=l[p]}else if("R"===u[0])g=[n,a][b](u.slice(1)),t.pop(),t=t[b](Ye(g,d)),l=["R"][b](u.slice(-2));else for(var v=0,y=u.length;v<y;v++)l[v]=u[v];switch(l[0]){case"Z":n=i,a=o;break;case"H":n=l[1];break;case"V":a=l[1];break;case"M":i=l[l.length-2],o=l[l.length-1];default:n=l[l.length-2],a=l[l.length-1]}}t.toString=c._path2string,r.abs=t}return Qe(r.abs)},tt=function(e,t,r,n){return[e,t,r,n,r,n]},rt=function(e,t,r,n,a,i){return[1/3*e+2/3*r,1/3*t+2/3*n,1/3*a+2/3*r,1/3*i+2/3*n,a,i]},nt=function Yt(e,t,r,n,a,i,s,l,c,u){if(s=s&&+s,i=i&&+i,0===r||0===n)return tt(e,t,l,c);var d,f=120*ce/180,h=ue*(+a||0),g=[],p=(0,o.cacher)((function(e,t,r){return{x:e*ie(r)-t*oe(r),y:e*oe(r)+t*ie(r)}}));if(u)E=u[0],A=u[1],_=u[2],S=u[3];else{e=(d=p(e,t,-h)).x,t=d.y,l=(d=p(l,c,-h)).x,c=d.y;ie(ue*a),oe(ue*a);var m=(e-l)/2,v=(t-c)/2,y=m*m/(r*r)+v*v/(n*n);y>1&&(r*=y=se(y),n*=y);var x=r*r,w=n*n,C=(i===s?-1:1)*se(ne((x*w-x*v*v-w*m*m)/(x*v*v+w*m*m))),_=C*r*v/n+(e+l)/2,S=C*-n*m/r+(t+c)/2,E=ee.asin(((t-S)/n).toFixed(9)),A=ee.asin(((c-S)/n).toFixed(9));(E=e<_?ce-E:E)<0&&(E=2*ce+E),(A=l<_?ce-A:A)<0&&(A=2*ce+A),s&&E>A&&(E-=2*ce),!s&&A>E&&(A-=2*ce)}var N=A-E;if(ne(N)>f){var T=A,M=l,D=c;g=Yt(l=_+r*ie(A=E+f*(s&&A>E?1:-1)),c=S+n*oe(A),r,n,a,0,s,M,D,[A,T,_,S])}N=A-E;var F=ie(E),I=oe(E),O=ie(A),L=oe(A),R=ee.tan(N/4),P=4/3*r*R,V=4/3*n*R,j=[e,t],B=[e+P*I,t-V*F],z=[l+P*L,c-V*O],H=[l,c];if(B[0]=2*j[0]-B[0],B[1]=2*j[1]-B[1],u)return[B,z,H][b](g);for(var U=[],G=0,W=(g=[B,z,H][b](g).join()[k](",")).length;G<W;G++)U[G]=G%2?p(g[G-1],g[G],h).y:p(g[G],g[G+1],h).x;return U},at=function(e,t,r,n,a,i,o,s,l){var c=1-l;return{x:ae(c,3)*e+3*ae(c,2)*l*r+3*c*l*l*a+ae(l,3)*o,y:ae(c,3)*t+3*ae(c,2)*l*n+3*c*l*l*i+ae(l,3)*s}},it=(0,o.cacher)((function(e,t,r,n,a,i,o,s){var l,c=a-2*r+e-(o-2*a+r),u=2*(r-e)-2*(a-r),d=e-r,f=(-u+se(u*u-4*c*d))/2/c,h=(-u-se(u*u-4*c*d))/2/c,g=[t,s],p=[e,o];return ne(f)>"1e12"&&(f=.5),ne(h)>"1e12"&&(h=.5),f>0&&f<1&&(l=at(e,t,r,n,a,i,o,s,f),p.push(l.x),g.push(l.y)),h>0&&h<1&&(l=at(e,t,r,n,a,i,o,s,h),p.push(l.x),g.push(l.y)),f=(-(u=2*(n-t)-2*(i-n))+se(u*u-4*(c=i-2*n+t-(s-2*i+n))*(d=t-n)))/2/c,h=(-u-se(u*u-4*c*d))/2/c,ne(f)>"1e12"&&(f=.5),ne(h)>"1e12"&&(h=.5),f>0&&f<1&&(l=at(e,t,r,n,a,i,o,s,f),p.push(l.x),g.push(l.y)),h>0&&h<1&&(l=at(e,t,r,n,a,i,o,s,h),p.push(l.x),g.push(l.y)),{min:{x:re[v](0,p),y:re[v](0,g)},max:{x:te[v](0,p),y:te[v](0,g)}}})),ot=c._path2curve=(0,o.cacher)((function(e,t){var r=!t&&qe(e);if(!t&&r.curve)return Qe(r.curve);for(var n=et(e),a=t&&et(t),i={x:0,y:0,bx:0,by:0,X:0,Y:0,qx:null,qy:null},o={x:0,y:0,bx:0,by:0,X:0,Y:0,qx:null,qy:null},s=function(e,t){if(!e)return["C",t.x,t.y,t.x,t.y,t.x,t.y];switch(!(e[0]in{T:1,Q:1})&&(t.qx=t.qy=null),e[0]){case"M":t.X=e[1],t.Y=e[2];break;case"A":e=["C"][b](nt[v](0,[t.x,t.y][b](e.slice(1))));break;case"S":e=["C",t.x+(t.x-(t.bx||t.x)),t.y+(t.y-(t.by||t.y))][b](e.slice(1));break;case"T":t.qx=t.x+(t.x-(t.qx||t.x)),t.qy=t.y+(t.y-(t.qy||t.y)),e=["C"][b](rt(t.x,t.y,t.qx,t.qy,e[1],e[2]));break;case"Q":t.qx=e[1],t.qy=e[2],e=["C"][b](rt(t.x,t.y,e[1],e[2],e[3],e[4]));break;case"L":e=["C"][b](tt(t.x,t.y,e[1],e[2]));break;case"H":e=["C"][b](tt(t.x,t.y,e[1],t.y));break;case"V":e=["C"][b](tt(t.x,t.y,t.x,e[1]));break;case"Z":e=["C"][b](tt(t.x,t.y,t.X,t.Y))}return e},l=function(e,t){if(e[t].length>7){e[t].shift();for(var r=e[t];r.length;)e.splice(t++,0,["C"][b](r.splice(0,6)));e.splice(t,1),d=te(n.length,a&&a.length||0)}},c=function(e,t,r,i,o){e&&t&&"M"===e[o][0]&&"M"!=t[o][0]&&!o&&(t.splice(o,0,["M",i.x,i.y]),r.bx=0,r.by=0,r.x=e[o][1],r.y=e[o][2],d=te(n.length,a&&a.length||0))},u=0,d=te(n.length,a&&a.length||0);u<d;u++){n[u]=s(n[u],i),l(n,u),a&&(a[u]=s(a[u],o)),a&&l(a,u),c(n,a,i,o,u),c(a,n,o,i,u);var f=n[u],h=a&&a[u],g=f.length,p=a&&h.length;i.x=f[g-2],i.y=f[g-1],i.bx=Z(f[g-4])||i.x,i.by=Z(f[g-3])||i.y,o.bx=a&&(Z(h[p-4])||o.x),o.by=a&&(Z(h[p-3])||o.y),o.x=a&&h[p-2],o.y=a&&h[p-1]}return a||(r.curve=Qe(n)),a?[n,a]:n}),null,Qe),st=(c._parseDots=(0,o.cacher)((function(e){for(var t=[],r=0,n=e.length;r<n;r++){var a={},i=e[r].match(/^([^:]*):?([\d\.]*)/);if(a.color=c.getRGB(i[1]),a.color.error)return null;a.opacity=a.color.opacity,a.color=a.color.hex,i[2]&&(a.offset=i[2]+"%"),t.push(a)}for(r=1,n=t.length-1;r<n;r++)if(!t[r].offset){for(var o=Z(t[r-1].offset||0),s=0,l=r+1;l<n;l++)if(t[l].offset){s=t[l].offset;break}s||(s=100,l=n);for(var u=((s=Z(s))-o)/(l-r+1);r<l;r++)o+=u,t[r].offset=o+"%"}return t})),c._tear=function(e,t){e===t.top&&(t.top=e.prev),e===t.bottom&&(t.bottom=e.next),e.next&&(e.next.prev=e.prev),e.prev&&(e.prev.next=e.next)}),lt=(c._tofront=function(e,t){return t.top!==e&&(st(e,t),e.next=null,e.prev=t.top,t.top.next=e,t.top=e,!0)},c._toback=function(e,t){return t.bottom!==e&&(st(e,t),e.next=t.bottom,e.prev=null,t.bottom.prev=e,t.bottom=e,!0)},c._insertafter=function(e,t,r,n){st(e,r),e.parent=n,t===n.top&&(n.top=e),t.next&&(t.next.prev=e),e.next=t.next,e.prev=t,t.next=e},c._insertbefore=function(e,t,r,n){st(e,r),e.parent=n,t===n.bottom&&(n.bottom=e),t.prev&&(t.prev.next=e),e.prev=t.prev,t.prev=e,e.next=t},c._extractTransform=function(e,t){if(null==t)return e._.transform;t=J(t).replace(/\.{3}|\u2026/g,e._.transform||g);var r,n,a=c.parseTransformString(t),i=0,o=1,s=1,l=e._,u=new dt;if(l.transform=a||[],a)for(var d=0,f=a.length;d<f;d++){var h,p,m,v,b,y=a[d],x=y.length,w=J(y[0]).toLowerCase(),C=y[0]!=w,k=C?u.invert():0;"t"===w&&3===x?C?(h=k.x(0,0),p=k.y(0,0),m=k.x(y[1],y[2]),v=k.y(y[1],y[2]),u.translate(m-h,v-p)):u.translate(y[1],y[2]):"r"===w?2===x?(b=l.bb||(l.bb=e.getBBox(1)),u.rotate(y[1],b.x+b.width/2,b.y+b.height/2),i+=y[1]):4===x&&(C?(m=k.x(y[2],y[3]),v=k.y(y[2],y[3]),u.rotate(y[1],m,v)):u.rotate(y[1],y[2],y[3]),i+=y[1]):"s"===w?2===x||3===x?(b=l.bb||(l.bb=e.getBBox(1)),u.scale(y[1],y[x-1],b.x+b.width/2,b.y+b.height/2),o*=y[1],s*=y[x-1]):5===x&&(C?(m=k.x(y[3],y[4]),v=k.y(y[3],y[4]),u.scale(y[1],y[2],m,v)):u.scale(y[1],y[2],y[3],y[4]),o*=y[1],s*=y[2]):"m"===w&&7===x&&u.add(y[1],y[2],y[3],y[4],y[5],y[6]),l.dirtyT=1,e.matrix=u}e.matrix=u,l.sx=o,l.sy=s,l.deg=i,l.dx=r=u.e,l.dy=n=u.f,1===o&&1===s&&!i&&l.bbox?(l.bbox.x+=+r,l.bbox.y+=+n):l.dirtyT=1}),ct=function(e){var t=e[0];switch(t.toLowerCase()){case"t":return[t,0,0];case"m":return[t,1,0,0,1,0,0];case"r":return 4===e.length?[t,0,e[2],e[3]]:[t,0];case"s":return 5===e.length?[t,1,1,e[3],e[4]]:3===e.length?[t,1,1]:[t,1]}},ut=c._equaliseTransform=function(e,t){t=J(t).replace(/\.{3}|\u2026/g,e),e=c.parseTransformString(e)||[],t=c.parseTransformString(t)||[];for(var r,n,a,i,o=te(e.length,t.length),s=[],l=[],u=0;u<o;u++){if(a=e[u]||ct(t[u]),i=t[u]||ct(a),a[0]!=i[0]||"r"===a[0].toLowerCase()&&(a[2]!=i[2]||a[3]!=i[3])||"s"===a[0].toLowerCase()&&(a[3]!=i[3]||a[4]!=i[4]))return;for(s[u]=[],l[u]=[],r=0,n=te(a.length,i.length);r<n;r++)r in a&&(s[u][r]=a[r]),r in i&&(l[u][r]=i[r])}return{from:s,to:l}};function dt(e,t,r,n,a,i){null!=e?(this.a=+e,this.b=+t,this.c=+r,this.d=+n,this.e=+a,this.f=+i):(this.a=1,this.b=0,this.c=0,this.d=1,this.e=0,this.f=0)}c._getContainer=function(e,t,r,n){var a;if(null!=(a=null!=n||c.is(e,C)?e:D.doc.getElementById(e)))return a.tagName?null==t?{container:a,width:a.style.pixelWidth||a.offsetWidth,height:a.style.pixelHeight||a.offsetHeight}:{container:a,width:t,height:r}:{container:1,x:e,y:t,width:r,height:n}},c._engine={},c.path2curve=ot,c.matrix=function(e,t,r,n,a,i){return new dt(e,t,r,n,a,i)},function(e){function t(e){return e[0]*e[0]+e[1]*e[1]}function r(e){var r=se(t(e));e[0]&&(e[0]/=r),e[1]&&(e[1]/=r)}e.add=function(e,t,r,n,a,i){var o,s,l,c,u=[[],[],[]],d=[[this.a,this.c,this.e],[this.b,this.d,this.f],[0,0,1]],f=[[e,r,a],[t,n,i],[0,0,1]];for(e&&e instanceof dt&&(f=[[e.a,e.c,e.e],[e.b,e.d,e.f],[0,0,1]]),o=0;o<3;o++)for(s=0;s<3;s++){for(c=0,l=0;l<3;l++)c+=d[o][l]*f[l][s];u[o][s]=c}this.a=u[0][0],this.b=u[1][0],this.c=u[0][1],this.d=u[1][1],this.e=u[0][2],this.f=u[1][2]},e.invert=function(){var e=this,t=e.a*e.d-e.b*e.c;return new dt(e.d/t,-e.b/t,-e.c/t,e.a/t,(e.c*e.f-e.d*e.e)/t,(e.b*e.e-e.a*e.f)/t)},e.clone=function(){return new dt(this.a,this.b,this.c,this.d,this.e,this.f)},e.translate=function(e,t){this.add(1,0,0,1,e,t)},e.scale=function(e,t,r,n){null==t&&(t=e),(r||n)&&this.add(1,0,0,1,r,n),this.add(e,0,0,t,0,0),(r||n)&&this.add(1,0,0,1,-r,-n)},e.rotate=function(e,t,r){e=c.rad(e),t=t||0,r=r||0;var n=+ie(e).toFixed(9),a=+oe(e).toFixed(9);this.add(n,a,-a,n,t,r),this.add(1,0,0,1,-t,-r)},e.x=function(e,t){return e*this.a+t*this.c+this.e},e.y=function(e,t){return e*this.b+t*this.d+this.f},e.get=function(e){return+this[J.fromCharCode(97+e)].toFixed(4)},e.toString=function(){return c.svg?"matrix("+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)].join()+")":[this.get(0),this.get(2),this.get(1),this.get(3),0,0].join()},e.toMatrixString=function(){return"matrix("+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)].join()+")"},e.toFilter=function(){return"progid:DXImageTransform.Microsoft.Matrix(M11="+this.get(0)+", M12="+this.get(2)+", M21="+this.get(1)+", M22="+this.get(3)+", Dx="+this.get(4)+", Dy="+this.get(5)+", sizingmethod='auto expand')"},e.offset=function(){return[this.e.toFixed(4),this.f.toFixed(4)]},e.split=function(){var e={};e.dx=this.e,e.dy=this.f;var n=[[this.a,this.c],[this.b,this.d]];e.scalex=se(t(n[0])),r(n[0]),e.shear=n[0][0]*n[1][0]+n[0][1]*n[1][1],n[1]=[n[1][0]-n[0][0]*e.shear,n[1][1]-n[0][1]*e.shear],e.scaley=se(t(n[1])),r(n[1]),e.shear/=e.scaley;var a=-n[0][1],i=n[1][1];return i<0?(e.rotate=c.deg(ee.acos(i)),a<0&&(e.rotate=360-e.rotate)):e.rotate=c.deg(ee.asin(a)),e.isSimple=!(+e.shear.toFixed(9)||e.scalex.toFixed(9)!==e.scaley.toFixed(9)&&e.rotate),e.isSuperSimple=!+e.shear.toFixed(9)&&e.scalex.toFixed(9)===e.scaley.toFixed(9)&&!e.rotate,e.noRotation=!+e.shear.toFixed(9)&&!e.rotate,e},e.toTransformString=function(e){var t=e||this[k]();return t.isSimple?(t.scalex=+t.scalex.toFixed(4),t.scaley=+t.scaley.toFixed(4),t.rotate=+t.rotate.toFixed(4),(t.dx||t.dy?"t"+[t.dx,t.dy]:g)+(1!=t.scalex||1!=t.scaley?"s"+[t.scalex,t.scaley,0,0]:g)+(t.rotate?"r"+[t.rotate,0,0]:g)):"m"+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)]}}(dt.prototype);var ft=(L=I.navigator).userAgent.match(/Version\/(.*?)\s/)||L.userAgent.match(/Chrome\/(\d+)/);"Apple Computer, Inc."===L.vendor&&(ft&&ft[1]<4||"iP"===L.platform.slice(0,2))||"Google Inc."===L.vendor&&ft&&ft[1]<8?Y.safari=function(){var e=this.rect(-99,-99,this.width+99,this.height+99).attr({stroke:_});return setTimeout((function(){e.remove()})),!0}:Y.safari=function(){};for(var ht=function(){this.returnValue=!1},gt=function(){return this.originalEvent.preventDefault()},pt=function(){this.cancelBubble=!0},mt=function(){return this.originalEvent.stopPropagation()},vt={stopPropagation:"fn",stopImmediatePropagation:"fn",preventDefault:"fn",type:!0,clientX:!0,clientY:!0,pageX:!0,pageY:!0,bubbles:!0,cancelable:!0,touches:!0,target:!0,originalTarget:!0,srcElement:!0,relatedTarget:!0,fromElement:!0,changedTouches:!0,layerX:!0,layerY:!0,deltaX:!0,deltaY:!0},bt=c.makeSelectiveCopy=function(e,t){var r=function(r){e[r]="fn"===vt[r]?function(){t[r]()}:t[r]};for(var n in vt)r(n);e.originalEvent=t,e.type||(e.type=t.originalEvent&&t.originalEvent.type)},yt=c.addEvent=D.doc.addEventListener?function(e,t,r,n){var a,i,o=P?O[t]:R?K[t]:t;return A||(i={capture:!1}),n.dragFn&&("pointerup"===o?o="mouseup":void 0===o&&(o="touchend")),a=function(a){var i,o=D.doc.documentElement.scrollTop||D.doc.body.scrollTop,s=D.doc.documentElement.scrollLeft||D.doc.body.scrollLeft;if(R&&K[t])for(var l=0,c=a.targetTouches&&a.targetTouches.length;l<c;l++)if((i=a.targetTouches[l].target)===e||"tspan"===i.nodeName&&i.parentNode===e){var u=a;(a=a.targetTouches[l]).originalEvent=u,a.preventDefault=gt,a.stopPropagation=mt;break}return r.call(n,a,a.clientX+s,a.clientY+o)},e.addEventListener(o,a,i),function(){return e.removeEventListener(o,a,i),!0}}:D.doc.attachEvent?function(e,t,r,n){var a=function(e){e=e||D.win.event;var t=D.doc.documentElement.scrollTop||D.doc.body.scrollTop,a=D.doc.documentElement.scrollLeft||D.doc.body.scrollLeft,i=e.clientX+a,o=e.clientY+t;return e.preventDefault=e.preventDefault||ht,e.stopPropagation=e.stopPropagation||pt,r.call(n,e,i,o)};return e.attachEvent("on"+t,a),function(){return e.detachEvent("on"+t,a),!0}}:void 0,xt=function(e){var t,r=D.doc.documentElement.scrollTop||D.doc.body.scrollTop,n=D.doc.documentElement.scrollLeft||D.doc.body.scrollLeft,a=(void 0!==e.clientX?e.clientX:e.changedTouches&&e.changedTouches[0].clientX)+n,o=(void 0!==e.clientY?e.clientY:e.changedTouches&&e.changedTouches[0].clientY)+r,s={},l=this,u=l.dragInfo.onmove.length;if(!(l.dragStartFn&&!(Math.abs(a-l._drag.x)>=2.5||Math.abs(o-l._drag.y)>=2.5)||l._blockDrag||P&&R&&!e.isPrimary))for(;u--;){if(R&&"touchmove"===e.type)for(var d,f=e.touches.length;f--;)if((d=e.touches[f]).identifier===l._drag.id){a=d.clientX+n,o=d.clientY+r;break}if(!l.removed){if(l.dragStartFn&&(l.dragStartFn(u),l.dragStartFn=undefined,l.dragInfo._dragmove=!0),D.win.opera){var h=c._engine.getNode(l),g=h.nextSibling,p=h.parentNode,m=h.style.display;p.removeChild(h),h.style.display=_,h.style.display=m,g?p.insertBefore(h,g):p.appendChild(h)}bt(s,e),t=s.data=[a-l._drag.x,o-l._drag.y,a,o],(0,i["default"])("raphael.drag.move."+l.id,l.dragInfo.move_scope[u]||l,s,t)}}},wt=function e(t){var r=this,n=r.dragInfo,a=n.onend.length;if(r.dragInfo._dragmove)for(;a--;)r._drag={},(0,i["default"])("raphael.drag.end."+r.id,n.end_scope[a]||n.start_scope[a]||n.move_scope[a]||r,t);r.dragInfo._dragmove=undefined,R&&!j&&!V&&(!z||!B)&&(r.paper.canvas.style["touch-action"]="auto"),c.undragmove.call(r,xt),c.undragend.call(r,e),c.unmousemove.call(r,xt).unmouseup.call(r,e)},Ct=c.el={},kt=q.length;kt--;)!function(e){c[e]=Ct[e]=function(t,r,n){return c.is(t,S)&&(this.events=this.events||[],this.events.push({name:e,f:t,unbind:yt(n||this.shape||this.node||D.doc,e,t,r||this)})),this},c["un"+e]=Ct["un"+e]=function(t){for(var r=this.events||[],n=r.length;n--;)if(r[n].name===e&&r[n].f===t)return r[n].unbind(),r.splice(n,1),!r.length&&delete this.events,this;return this}}(q[kt]);Ct.data=function(e,t){var r=Ne[this.id]=Ne[this.id]||{};if(1===arguments.length){if(c.is(e,C)){for(var n in e)e[m](n)&&this.data(n,e[n]);return this}return c.stopPartialEventPropagation||(0,i["default"])("raphael.data.get."+this.id,this,r[e],e),r[e]}return r[e]=t,c.stopPartialEventPropagation||(0,i["default"])("raphael.data.set."+this.id,this,t,e),this},Ct.removeData=function(e){return null==e?delete Ne[this.id]:Ne[this.id]&&delete Ne[this.id][e],this},Ct.dbclick=function(e,t){var r,n=this,a=function(r){var a;P&&!r.isPrimary||(r&&r.preventDefault(),(!(a=r).touches||a.touches&&1===a.touches.length)&&(n._tappedOnce?(e.call(t||n,r),n._tappedOnce=!1):(n._tappedOnce=!0,setTimeout((function(){n._tappedOnce=!1}),500))))};r=P?"pointerup":c.supportsTouch?"touchstart":"mouseup",n.node.addEventListener(r,a),c.storeHandlers(n,e,a)},Ct.undbclick=function(e){var t=removeHandlers(this,e);t&&this.node.removeEventListener(P?"pointerup":c.supportsTouch?"touchstart":"mouseup",t)},Ct.getData=function(){return Ve(Ne[this.id]||{})};var _t=[],St=function(){this.untrack=yt(D.doc,"mouseup",Et,this)},Et=function(){return this.untrack(),this.untrack=null,this.fn&&this.fn.apply(this.scope||this.el,arguments)};Ct.mouseup=function(e,t,r,n){return r?(_t.push(r={el:this,fn:e,scope:t}),r.unbind=yt(this.shape||this.node||D.doc,"mousedown",St,r),this):c.mouseup.apply(this,[e,t,n])},Ct.unmouseup=function(e){for(var t,r=_t.length;r--;)_t[r].el===this&&_t[r].fn===e&&((t=_t[r]).unbind(),t.untrack&&t.untrack(),_t.splice(r,1));return t?this:c.unmouseup.apply(this,arguments)},Ct.hover=function(e,t,r,n){return this.on("fc-mouseover",e,r).on("fc-mouseout",t,n)},Ct.unhover=function(e,t){return this.off("fc-mouseover",e).off("fc-mouseout",t)},Ct.fcclick=function(e,t){var r,n,a,i,o,s=this,l=s.node,u=function(e){s._lastEventTriggered="mousedown",a=void 0!==e.clientX?e.clientX:e.changedTouches&&e.changedTouches[0].clientX,i=void 0!==e.clientY?e.clientY:e.changedTouches&&e.changedTouches[0].clientY},d=function(e){var t=void 0!==e.clientX?e.clientX:e.changedTouches&&e.changedTouches[0].clientX,r=void 0!==e.clientY?e.clientY:e.changedTouches&&e.changedTouches[0].clientY;(Math.abs(a-t)>=2.5||Math.abs(i-r)>=2.5)&&(s._lastEventTriggered=undefined)};if(s._clickStoreActual||(s._clickStoreActual=[]),s._clickStoreDerived||(s._clickStoreDerived=[]),!s._clickHandlerHelper){for(r in o=!P&&c.supportsTouch?{touchstart:function(){s._lastEventTriggered="touchstart",s._lastEventTriggeredAt=(new Date).getTime()},touchmove:d}:P&&c.supportsTouch?{pointerdown:u,pointermove:d}:{mousedown:u,mousemove:d})l.addEventListener?l.addEventListener(r,o[r]):l.attachEvent("on"+r,o[r]);s._clickHandlerHelper=o}return!P&&c.supportsTouch?(r="touchend",n=function(r){"touchstart"===s._lastEventTriggered&&(new Date).getTime()-s._lastEventTriggeredAt<=500&&setTimeout((function(){e.call(t||s,r)}),0)}):(r="click",n=function(r){"mousedown"===s._lastEventTriggered&&e.call(t||s,r)}),l.addEventListener?l.addEventListener(r,n):l.attachEvent("on"+r,n),s._clickStoreDerived.push(n),s._clickStoreActual.push(e),s},Ct.fcunclick=function(e){var t,r,n=this.node,a=this._clickHandlerHelper,i=this._clickStoreActual,o=this._clickStoreDerived;if(i){for(t=i.length-1;t>=0;t--)i[t]===e&&(n.removeEventListener?n.removeEventListener(!P&&c.supportsTouch?"touchend":"click",o[t]):n.detachEvent("onclick",o[t]),i.splice(t,1),o.splice(t,1));if(!i.length){for(r in a)n.removeEventListener?n.removeEventListener(r,a[r]):n.detachEvent("on"+r,a[r]);this._clickHandlerHelper=undefined}}return this};var At=[];function Nt(){return this.x+p+this.y+p+this.width+" × "+this.height}Ct.drag=function(e,t,r,n,a,o){var s=this,l=s.dragInfo||(s.dragInfo={onmove:[],onstart:[],onend:[],move_scope:[],start_scope:[],end_scope:[]});return e&&l.onmove.push(e)&&l.move_scope.push(n),t&&l.onstart.push(t)&&l.start_scope.push(a),r&&l.onend.push(r)&&l.end_scope.push(o),s.dragFn=s.dragFn||function(e){var t,r,n,a,o,l,u,d,f,h,g=D.doc.documentElement.scrollTop||D.doc.body.scrollTop,p=D.doc.documentElement.scrollLeft||D.doc.body.scrollLeft,m={},v=s.dragInfo,b=[xt,void 0,D.doc];if(!P||e.isPrimary){for(R&&(P?j||V||z&&B||(s.paper.canvas.style["touch-action"]="none"):e.preventDefault()),s._drag.x=f=(void 0!==e.clientX?e.clientX:e.changedTouches&&e.changedTouches[0].clientX)+p,s._drag.y=h=(void 0!==e.clientY?e.clientY:e.changedTouches&&e.changedTouches[0].clientY)+g,s._drag.id=e.identifier,R&&!P?c.dragmove.apply(s,b):c.mousemove.apply(s,b).mouseup.call(s,wt,void 0,void 0,D.doc),R&&c.dragend.call(s,wt,void 0,D.doc),bt(m,e),t=m.data=[f,h],r=0,o=v.onstart.length;r<o;r++)i["default"].on("raphael.drag.start."+s.id,v.onstart[r]);for(n=0,l=v.onmove.length;n<l;n++)i["default"].on("raphael.drag.move."+s.id,v.onmove[n]);for(a=0,u=v.onend.length;a<u;a++)i["default"].on("raphael.drag.end."+s.id,v.onend[a]);o&&!l&&(d=function(){s.undragmove(),v.onmove=[]},v.onmove.push(d),i["default"].on("raphael.drag.end."+s.id,d)),s.dragStartFn=function(e){(0,i["default"])("raphael.drag.start."+s.id,s.dragInfo.start_scope[e]||s.dragInfo.move_scope[e]||s,m,t)}}},s._drag={},At.push({el:s,start:s.dragFn,onstart:t,onmove:e,onend:r}),t&&!s.startHandlerAttached&&(R&&!P?s.dragstart(s.dragFn):s.mousedown(s.dragFn),s.startHandlerAttached=!0),s},Ct.onDragOver=function(e){e?i["default"].on("raphael.drag.over."+this.id,e):i["default"].unbind("raphael.drag.over."+this.id)},Ct.undrag=function(){for(var e=At.length;e--;)At[e].el===this&&(this.unmousedown(this.dragFn),At.splice(e,1),i["default"].unbind("raphael.drag.*."+this.id),this.dragInfo=undefined,this.dragFn=undefined,this.startHandlerAttached=undefined);c.unmousemove.call(this,xt).unmouseup.call(this,wt),c.undragmove.call(this,xt),c.undragend.call(this,wt),delete this._drag},Ct.undragstart=function(e){var t,r,n=this.dragInfo,a=n&&n.onstart,o=n&&n.start_scope;if(e)for(t=0,r=a&&a.length;t<r;t++)if(a[t]===e){a.splice(t,1),o.splice(t,1),i["default"].unbind("raphael.drag.start."+this.id,e);break}a&&a.length&&e||(c.undragstart.call(this,this.dragFn),c.unmousedown.call(this,this.dragFn),i["default"].unbind("raphael.drag.start."+this.id),this.startHandlerAttached=!1,n&&(n.onstart=[],n.start_scope=[]))},Ct.undragmove=function(e){var t,r,n=this.dragInfo,a=n&&n.onmove,o=n&&n.move_scope;if(e)for(t=0,r=a&&a.length;t<r;t++)if(a[t]===e){a.splice(t,1),o.splice(t,1),i["default"].unbind("raphael.drag.move."+this.id,e);break}a&&a.length&&e||(c.undragmove.call(this,xt),c.unmousemove.call(this,xt),n&&(n.onmove=[],n.move_scope=[]),i["default"].unbind("raphael.drag.move."+this.id))},Ct.undragend=function(e){var t,r,n=this.dragInfo,a=n&&n.onend,o=n&&n.end_scope;if(e)for(t=0,r=a&&a.length;t<r;t++)if(a[t]===e){a.splice(t,1),o.splice(t,1),i["default"].unbind("raphael.drag.end."+this.id,e);break}a&&a.length&&e||(c.undragend.call(this,wt),c.unmouseup.call(this,wt),n&&(n.onend=[],n.end_scope=[]),i["default"].unbind("raphael.drag.end."+this.id))},Ct.follow=function(e,t,r){return e.removed||e.constructor!==c.el.constructor||(e.followers.push({el:this,stalk:r={before:"insertBefore",after:"insertAfter"}[r],cb:t}),r&&this[r](e)),this},Ct.unfollow=function(e){if(e.removed||e.constructor!==c.el.constructor)return this;for(var t=0,r=e.followers.length;t<r;t++)if(e.followers[t].el===this){e.followers.splice(t,1);break}return this},Y.hide=function(){return this.canvas.style.visibility="hidden",this},Y.show=function(){return this.canvas.style.visibility=g,this},Y.group=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=c._engine.group(e,t[0],r,!!t[1]);return e.__set__&&e.__set__.push(n),e._elementsById[n.id]=n},Y.circle=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=e._addDefAttribs()?Re(t,"cx",0,"cy",0,"r",0,"fill",_,"stroke","#000"):Re(t),a=c._engine.circle(e,n,r);return e.__set__&&e.__set__.push(a),e._elementsById[a.id]=a},Y.rect=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=e._addDefAttribs()?Re(t,"x",0,"y",0,"width",0,"height",0,"r",0,"fill",_,"stroke","#000"):Re(t),a=c._engine.rect(e,n,r);return e.__set__&&e.__set__.push(a),e._elementsById[a.id]=a},Y.ellipse=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=e._addDefAttribs()?Re(t,"x",0,"y",0,"rx",0,"ry",0,"fill",_,"stroke","#000"):Re(t),a=c._engine.ellipse(this,n,r);return e.__set__&&e.__set__.push(a),e._elementsById[a.id]=a},Y.path=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=e.config,a=n&&n["stroke-linecap"]||"butt",i=e._addDefAttribs()?Re(t,"path",g,"fill",_,"stroke","#000","stroke-linecap",a):Re(t),s=c._engine.path(e,i,r);return e.__set__&&e.__set__.push(s),e._elementsById[s.id]=s},Y.image=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=e._addDefAttribs()?Re(t,"x",0,"y",0,"width",0,"height",0):Re(t),a=c._engine.image(e,n,r);return e.__set__&&e.__set__.push(a),e._elementsById[a.id]=a},Y.text=function(){var e=this,t=(0,o.getArrayCopy)(arguments),r=Le(t,!0),n=e._addDefAttribs()?Re(t,"x",0,"y",0,"text",g,"stroke",_,"fill","#000","text-anchor","middle","vertical-align","middle"):Re(t),a=c._engine.text(e,n,r,t[1]);return e.__set__&&e.__set__.push(a),e._elementsById[a.id]=a},Y._addDefAttribs=function(){return!(c.svg&&this.config&&this.config.noDefaultAttribs)},Y.setConfig=function(e,t){return e!==undefined&&t!==undefined&&(this.config=this.config||{},this.config[e]=t),this.config},Y._createDOMNodes=function(e,t,r){var n,a,i,o,s={},l=c._createNode,u=t.tagName,d=t.children||[];for(o in!r&&(r={}),t)"tagName"!==o&&"children"!==o&&(s[o]=t[o]);if(!s.id&&(s.id=c.getElementID(c.createUUID())),!this.canvas.getElementById(s.id)&&u)for(n=e.appendChild(l(u,s)),r.element=n,r.id=s.id,(i=d.length)>0&&(r.children=[]),a=0;a<i;a++)r.children[a]={},this._createDOMNodes(n,d[a],r.children[a]);return r},Y.addDefs=function(e){if(c.svg){var t,r={},n=this.defs;for(t in e)r[t]={},this._createDOMNodes(n,e[t],r[t]);return r}},Y.setSize=function(e,t){return c._engine.setSize.call(this,e,t)},Y.setDimension=function(e,t){var r;typeof e===C?(r=e.width,t=e.height,this.setSize(e.width,e.height)):(r=e,this.setSize(r,t))},Y.attr=function(e){return null==e?{width:this.width,height:this.height}:c.is(e,x)?this[e]:(this.setDimension(e),this)},Y.status=function(e,t){return Ct.status.call(this,e,t)},Y.animateWith=function(e,t,r,n,a,i,o){return Ct.animateWith.call(this,e,t,r,n,a,i,o)},Y.animate=function(e,t,r,n){return Ct.animate.call(this,e,t,r,n)},Y.setViewBox=function(e,t,r,n,a){return c._engine.setViewBox.call(this,e,t,r,n,a)},Y.getById=function(e){return this._elementsById[e]||null},Y.top=Y.bottom=null,Y.raphael=c,Ct.getBBox=function(e){if(this.removed)return{};var t=this._;return e?(!t.dirty&&t.bboxwt||(this.realPath=Ie[this.type](this),t.bboxwt=Ze(this.realPath),t.bboxwt.toString=Nt,t.dirty=0),t.bboxwt):((t.dirty||t.dirtyT||!t.bbox)&&(!t.dirty&&this.realPath||(t.bboxwt=0,this.realPath=Ie[this.type](this)),t.bbox=Ze(Oe(this.realPath,this.matrix)),t.bbox.toString=Nt,t.dirty=t.dirtyT=0),t.bbox)},Ct.clone=function(e,t){if(this.removed)return null;var r,n,a=this,i=a.attr();if(e){for(r in e)i[r]=e[r];n=a.paper[a.type](i,t)}else n=a.paper[a.type]().attr(i);return a.__set__&&a.__set__.push(n),n};var Tt=function(e,t,r,n,a,i,o,s,l){return null==l?Je(e,t,r,n,a,i,o,s):c.findDotsAtSegment(e,t,r,n,a,i,o,s,function(e,t,r,n,a,i,o,s,l){if(!(l<0||Je(e,t,r,n,a,i,o,s)<l)){var c,u=.5,d=1-u;for(c=Je(e,t,r,n,a,i,o,s,d);ne(c-l)>.01;)c=Je(e,t,r,n,a,i,o,s,d+=(c<l?1:-1)*(u/=2));return d}}(e,t,r,n,a,i,o,s,l))},Mt=function(e,t){return function(r,n,a){r=ot(r);for(var i,o,s,l,u,d=g,f={},h=0,p=0,m=r.length;p<m;p++){if("M"===(s=r[p])[0])i=+s[1],o=+s[2];else{if(h+(l=Tt(i,o,s[1],s[2],s[3],s[4],s[5],s[6]))>n){if(t&&!f.start){if(d+=["C"+(u=Tt(i,o,s[1],s[2],s[3],s[4],s[5],s[6],n-h)).start.x,u.start.y,u.m.x,u.m.y,u.x,u.y],a)return d;f.start=d,d=["M"+u.x,u.y+"C"+u.n.x,u.n.y,u.end.x,u.end.y,s[5],s[6]].join(),h+=l,i=+s[5],o=+s[6];continue}if(!e&&!t)return{x:(u=Tt(i,o,s[1],s[2],s[3],s[4],s[5],s[6],n-h)).x,y:u.y,alpha:u.alpha}}h+=l,i=+s[5],o=+s[6]}d+=s.shift()+s}return f.end=d,(u=e?h:t?f:c.findDotsAtSegment(i,o,s[0],s[1],s[2],s[3],s[4],s[5],1)).alpha&&(u={x:u.x,y:u.y,alpha:u.alpha}),u}},Dt=Mt(1),Ft=Mt();Mt(0,1);c.getTotalLength=Dt,c.getPointAtLength=Ft,Ct.getTotalLength=function(){if("path"==this.type)return this.node.getTotalLength?this.node.getTotalLength():Dt(this.attrs.path)},Ct.getPointAtLength=function(e){if("path"==this.type)return Ft(this.attrs.path,e)};var It=c.easing_formulas={linear:function(e){return e},"<":function(e){return ae(e,1.7)},">":function(e){return ae(e,.48)},"<>":function(e){var t=.48-e/1.04,r=se(.1734+t*t),n=r-t,a=-r-t,i=ae(ne(n),1/3)*(n<0?-1:1)+ae(ne(a),1/3)*(a<0?-1:1)+.5;return 3*(1-i)*i*i+i*i*i},backIn:function(e){var t=1.70158;return e*e*((t+1)*e-t)},backOut:function(e){var t=1.70158;return(e-=1)*e*((t+1)*e+t)+1},elastic:function(e){return e===!!e?e:ae(2,-10*e)*oe(2*ce*(e-.075)/.3)+1},bounce:function(e){var t=7.5625,r=2.75;return e<1/r?t*e*e:e<2/r?t*(e-=1.5/r)*e+.75:e<2.5/r?t*(e-=2.25/r)*e+.9375:t*(e-=2.625/r)*e+.984375},oneBounceOut:function(e){return e<=.9?1.33*It.easeIn(e):1.2-e/5},elasticOnce:function(e){return e===!!e?e:Math.pow(2,-10*e)*Math.sin((e-.225)*(2*Math.PI)/.9)+1},easeInQuad:function(e){return e*e},easeOutQuad:function(e){return e*(2-e)},easeInOutQuad:function(e){return e<.5?2*e*e:(4-2*e)*e-1},easeInCubic:function(e){return e*e*e},easeOutCubic:function(e){return--e*e*e+1},easeInOutCubic:function(e){return e<.5?4*e*e*e:(e-1)*(2*e-2)*(2*e-2)+1},easeInQuart:function(e){return e*e*e*e},easeOutQuart:function(e){return 1- --e*e*e*e},easeInOutQuart:function(e){return e<.5?8*e*e*e*e:1-8*--e*e*e*e},easeInQuint:function(e){return e*e*e*e*e},easeOutQuint:function(e){return 1+--e*e*e*e*e},easeInOutQuint:function(e){return e<.5?16*e*e*e*e*e:1+16*--e*e*e*e*e}};It.easeIn=It["ease-in"]=It["<"],It.easeOut=It["ease-out"]=It[">"],It.easeInOut=It["ease-in-out"]=It["<>"],It["back-in"]=It.backIn,It["back-out"]=It.backOut;var Ot,Lt=[],Rt=function qt(){for(var e,t,r,n=+new Date,a=0,o=[],s=0;a<Lt.length;a++){var l=Lt[a];if(!(l.el.removed||l.paused||l.parentEl&&l.parentEl.e&&l.parentEl.e.paused)){for(var u,d,f,h=n-l.start,v=l.ms,y=l.easing,x=l.from,w=l.diff,C=l.to,k=(l.t,l.el),_={},E={},A=!c.stopPartialEventPropagation,N=(s=0,l.el&&l.el.animElements&&l.el.animElements.peek());N&&N.pos<=h/v;)o.push(l.el.animElements.deq()),N=l.el.animElements.peek();if(l.initstatus?(h=(l.initstatus*l.anim.top-l.prev)/(l.percent-l.prev)*v,l.status=l.initstatus,delete l.initstatus,l.stop&&(delete l.el,Lt.splice(a--,1))):l.status=(l.prev+(l.percent-l.prev)*(h/v))/l.anim.top,d=v,l.parentEl&&l.parentEl.animElements?(v=l.delayend-l.delaystart,h=l.parentEl.cPos-l.delaystart):l.el.animElements&&(l.el.cPos=h/v),!(h<0))if(h<v){var T=y(h/v);for(var M in v=d,x)if(x[m](M)){switch(Ae[M]){case"number":u=+x[M]+T*v*w[M];break;case"colour":if(w[M].length){for(u=[],s=0,D=x[M].length;s<D;++s)0===s?x[M].isRadial||w[M].isRadial?(r="xr(",r+=x[M][0].f1*(1-T)+w[M][0].f1*T||g,r+=",",r+=x[M][0].f2*(1-T)+w[M][0].f2*T||g,r+=",",r+=100*(x[M][0].f3*(1-T)+w[M][0].f3*T)||g,r+="%,",r+=x[M][0].f4*(1-T)+w[M][0].f4*T||g,r+=",",r+=x[M][0].f5*(1-T)+w[M][0].f5*T,r+=",",r+=x[M][0].f6,r+=")",u.push(r)):(u.push(x[M][s]*(1-T)+T*w[M][s]),u[0]<=0&&(u[0]+=360)):u.push("rgba("+[Pt(le(x[M][s].r+T*v*w[M][s].r)),Pt(le(x[M][s].g+T*v*w[M][s].g)),Pt(le(x[M][s].b+T*v*w[M][s].b)),x[M][s].opacity+T*v*w[M][s].opacity].join(",")+"):"+x[M][s].position);u=u.join("-"),(x[M].isRadial||w[M].isRadial)&&(u=u.replace("-",g))}else t=x[M].opacity+T*v*w[M].opacity,isNaN(t)&&(t=1),u="rgba("+[Pt(le(x[M].r+T*v*w[M].r)),Pt(le(x[M].g+T*v*w[M].g)),Pt(le(x[M].b+T*v*w[M].b)),t].join(",")+")";break;case"path":u=[];s=0;for(var D=x[M].length;s<D;s++){var F;u[s]=[x[M][s][0]],F=x[M][s]?x[M][s].length:0;for(var I=1;I<F;I++)u[s][I]=(+x[M][s][I]+T*v*w[M][s][I]).toFixed(4);u[s]=u[s].join(p)}u=u.join(p);break;case"transform":if(w[M].real)for(u=[],s=0,D=x[M].length;s<D;s++)for(u[s]=[x[M][s][0]],I=1,F=x[M][s].length;I<F;I++)u[s][I]=x[M][s][I]+T*v*w[M][s][I];else{var O=function(e){return+x[M][e]+T*v*w[M][e]};u=[["m",O(0),O(1),O(2),O(3),O(4),O(5)]]}break;case"csv":if("clip-rect"===M)for(u=[],s=4;s--;)u[s]=+x[M][s]+T*v*w[M][s];break;case"text-bound":u=[][b](x[M]);break;default:var L=[][b](x[M]);for(u=[],s=k.ca[M].length;s--;)u[s]=+L[s]+T*v*w[M][s]}_[M]=u}k.attr(_),A&&function(e,t,r){setTimeout((function(){(0,i["default"])("raphael.anim.frame."+e,t,r)}))}(k.id,k,l.anim)}else{if(function(e,t,r){setTimeout((function(){A&&(0,i["default"])("raphael.anim.frame."+t.id,t,r),A&&(0,i["default"])("raphael.anim.finish."+t.id,t,r),c.is(e,S)&&e.call(t)}))}(l.callback,k,l.anim),k.attr(C),delete l.el,Lt.splice(a--,1),l.repeat>1&&!l.next){for(f in C)C[m](f)&&(E[f]=l.totalOrigin[f]);l.el.attr(E),Gt(l.anim,l.el,l.anim.percents[0],null,l.totalOrigin,l.repeat-1)}l.next&&!l.stop&&Gt(l.anim,l.el,l.next,null,l.totalOrigin,l.repeat)}}}for(c.svg&&k&&k.paper&&k.paper.safari(),a=0,e=o.length;a<e;++a)c.getInstantAnimFrameFn()(function(e){return function(){Gt.apply(null,o[e].params)}}(a));Lt.length&&(Ot||c.getAnimFrameFn())(qt)},Pt=function(e){return e>255?255:e<0?0:e},Vt=function(e){return e>1&&(e=1),e<0&&(e=0),e};function jt(e,t,r,n,a,i){var o=3*t,s=3*(n-t)-o,l=1-o-s,c=3*r,u=3*(a-r)-c,d=1-c-u;function f(e){return((l*e+s)*e+o)*e}return function(e,t){var r=function(e,t){var r,n,a,i,c,u;for(a=e,u=0;u<8;u++){if(i=f(a)-e,ne(i)<t)return a;if(ne(c=(3*l*a+2*s)*a+o)<1e-6)break;a-=i/c}if(n=1,(a=e)<(r=0))return r;if(a>n)return n;for(;r<n;){if(i=f(a),ne(i-e)<t)return a;e>i?r=a:n=a,a=(n-r)/2+r}return a}(e,t);return((d*r+u)*r+c)*r}(e,1/(200*i))}function Bt(e,t){var r=[],n={};if(this.ms=t,this.times=1,e){for(var a in e)e[m](a)&&(n[Z(a)]=e[a],r.push(Z(a)));r.sort(Te)}this.anim=n,this.top=r[r.length-1],this.percents=r}c.getAnimFrameFn=function(){return Ot=c.requestAnimFrame||l.webkitRequestAnimationFrame||l.mozRequestAnimationFrame||l.oRequestAnimationFrame||l.msRequestAnimationFrame||function(e){setTimeout(e,16)}},c.getInstantAnimFrameFn=function(){return c.instantRequestAnimFrame||l.webkitRequestAnimationFrame||l.mozRequestAnimationFrame||l.oRequestAnimationFrame||l.msRequestAnimationFrame||function(e){setTimeout(e,16)}},Ct.animateWith=function(e,t,r,n,a,i,o){var s,l=this,u={};for(s in o=o||{})o.hasOwnProperty(s)&&(u[s]=o[s]);if(o=u,l.removed)return i&&i.call(l),l;if(0===n)return c.is(i,S)&&setTimeout((function(){i.call(l)}),0),l.attr(r);var d=r instanceof Bt?r:c.animation(r,n,a,i);o.start=Vt(o.start||0),o.end=Vt(o.end||1),o.start>=o.end&&(o.start=o.end),!o.from&&o.start>.01?(e.animElements=e.animElements||new Be((function(e,t){return t.pos-e.pos})),e.animElements.enq({pos:o.start,attr:o.start===o.end,params:[d,l,d.percents[0],null,l.attr(),undefined,e,{start:o.start,end:o.end,smartMorph:o.smartMorph,hookFn:o.hookFn},r],executeOb:{el:this,attrs:r,callback:i,hookFn:o.hookFn}})):Gt(d,l,d.percents[0],null,l.attr(),undefined,e,o);for(var f=0,h=Lt.length;f<h;f++)if(Lt[f].anim===t&&Lt[f].el===e){Lt[h-1].start=Lt[f].start;break}return l},Ct.onAnimation=function(e){return e?i["default"].on("raphael.anim.frame."+this.id,e):i["default"].unbind("raphael.anim.frame."+this.id),this},Bt.prototype.delay=function(e){var t=new Bt(this.anim,this.ms);return t.times=this.times,t.del=+e||0,t},Bt.prototype.repeat=function(e){var t=new Bt(this.anim,this.ms);return t.del=this.del,t.times=ee.floor(te(e,0))||1,t};function zt(e,t,r){var n,a,i=0,o=0,s=[],l=[],c={},u=0,d=[];if(e=e.constructor===Array?e[0]:e,t=t.constructor===Array?t[0]:t,n=e.split("-"),a=t.split("-"),1===n.length&&1===a.length)return[e,t];for(n=f(n),a=f(a),!n.defaultAngleSet&&a.defaultAngleSet&&(a[0]=n[0]),!a.defaultAngleSet&&n.defaultAngleSet&&(n[0]=a[0]),function e(t,r,n){t.isRadial&&!r.isRadial&&(+r[0],r[0]={f1:0,f2:0,f3:0,f4:0,f5:0,f6:g},r.isRadial=!0),n||e(r,t,!0)}(n,a),i=1,o=n.length;i<o;++i)u=n[i].position,d.push(u);for(i=1,o=a.length;i<o;++i)u=a[i].position,-1===d.indexOf(u)&&d.push(u);for(d.push(0),d.sort((function(e,t){return e-t})),s=[n[0]],i=1,o=d.length;i<o;++i)u=d[i],c=n.getColorAtPosition(u),s.push(c);for(l=[a[0]],i=1,o=d.length;i<o;++i)u=d[i],c=a.getColorAtPosition(u),l.push(c);return s.isRadial=n.isRadial,l.isRadial=a.isRadial,[s,l];function f(e){var t,n=0,a=0,i=0,o=[],s={},l=0,c=0,u=0,d=0,f=0,h=0,p={f1:.5,f2:.5};for(1===e.length&&(e[0]===_&&(e[0]="rgba(0,0,0,0)"),e.unshift(0),e.defaultAngleSet=!0),isNaN(e[0])?~"rx".indexOf(e[0].charAt(0))?(e.isRadial=!0,d=1,-1!==e[0].indexOf(")")&&(d=e[0].indexOf(")"),f=e[0].indexOf("(")+1,h=d,o=e[0].substr(f,h-f).split(","),p.f1=parseFloat(o[0])||0,p.f2=parseFloat(o[1])||0,~o[2].indexOf("%")&&(o[2]=parseFloat(o[2])/100),p.f3=parseFloat(o[2])||0,p.f4=parseFloat(o[3])||0,p.f5=parseFloat(o[4])||0,p.f6=o[5]),e[0]=e[0].substr(h+1),e.unshift(p)):e[0]=0:e[0]=+e[0],n=1,a=e.length;n<a;++n)o=e[n].split(":"),s=r(o[0]),e[n]={},e[n].r=s.r,e[n].g=s.g,e[n].b=s.b,e[n].opacity=s.opacity,e[n].opacity=+e[n].opacity,isNaN(e[n].opacity)&&(e[n].opacity=1),e[n].position=+o[1];if(e.sort((function(e,t){return"number"==typeof e||e.f1?-1:"number"==typeof t||e.f2?1:isNaN(e.position)&&isNaN(t.position)?0:isNaN(e.position)?-1:isNaN(t.position)?1:e.position-t.position})),0!=+e[1].position)if(isNaN(e[1].position))e[1].position=0;else{for(t in s={},e[1])s[t]=e[1][t];for(s.position=0,e.push({}),n=e.length-1;1!==n;--n)e[n]=e[n-1];e[1]=s}if(100!==e[a=e.length-1].position)if(isNaN(e[a].position))e[a].position=100;else{for(t in s={},e[a])s[t]=e[a][t];s.position=100,e.push(s)}for(n=2,a=e.length;n<a;++n)if(!e[n].position){for(l=e[n-1].position,u=1,i=n+1;i<a;++i)if(++u,!isNaN(e[i].position)){c=+e[i].position;break}e[n].position=l+(c-l)/u}return e.getColorAtPosition=function(e){for(var t=-1,r=this.length,n=1,a=this.length,i=0,o=g,s={r:0,g:0,b:0};n<a-1;++n)if(this[n].position<=e&&(t=n,r=n+1),!(this[n].position<e)&&this[n].position>=e){r=n;break}for(o in i=(e-this[t].position)/(this[r].position-this[t].position),isNaN(i)&&(i=0),s)s[o]=Pt((1-i)*this[t][o]+i*this[r][o]);return s.position=e,s.opacity=(1-i)*this[t].opacity+i*this[r].opacity,s},e}}function Ht(e,t){var r,n=[],a=[],i=d(e),o=d(t),s=0,l=0,c=document.createElementNS&&document.createElementNS.bind(document),u=c&&c("http://www.w3.org/2000/svg","path");if(!i||!o||!u)return[e,t];if(function(e,t){var r,n,a=g,i=g;if(u.setAttribute("d","M300 10 L300 300 C50 310,50 640,350 650C600 640,600 310,400 300 L400 10 L295 10"),r=u.getTotalLength(),n=u.getPointAtLength(10),r<1829.1||r>1829.2)return!0;if(300!==Math.round(n.x)||20!==Math.round(n.y))return!0;function o(e){for(var t=e.length;t---1&&e[t].join(g)===e[t-1].join(g);)e.pop()}function s(e){for(var t=g,r=0,n=e.length;r<n;++r)t+=e[r].join(p);return t}if(o(e),o(t),a=s(e),i=s(t),a.split(/[Mm]/).length>2||i.split(/[Mm]/).length>2)return!1;if(e.length===t.length)return!0;return!1}(e,t))return[e,t];if(!e||!t)return[e,t];if(!document.createElementNS)return[e,t];if(i=d(e),o=d(t),-1!==i.join().indexOf("undefined"))return[e,t];if(-1!==o.join().indexOf("undefined"))return[e,t];if(!u.getTotalLength||!u.getPointAtLength)return[e,t];function d(e){var t=[],r=0,n=e.length;if(typeof e===x)return e;for(r=0;r<n;++r){if(!e[r].join)return;r&&e[r+1]&&"M"===e[r+1][0]&&"M"===e[r][0]||t.push(e[r].join(p))}for(r=0,n=(t=(t=t.join(g)).split(/[Mm]/).slice(1)).length;r<n;++r)t[r]="M"+t[r];return t}for(l=Math.max(i.length,o.length),s=0;s<l;++s)r=Ut(i[s],o[s]),i[s]=r[0],o[s]=r[1];function f(e){var t,r=0,n=[];for(t=(e=e||[]).length,r=0;r<t;++r)e[r].length-1&&n.push(e[r].join(p));return n.join(g)}function h(e,t){for(var r=e.length;r---1&&e[r].slice(1).toString()===e[r-1].slice(1).toString();)e.pop();1===e.length&&t&&(e.length=0)}function m(e,t){for(var r,n=[],a=[],i=e.length,o=0,s=0,l=0,c=0,u=t-i;u>=0;)o=e.length-1,e.push(e.slice(o)[0]),--u;for(i=e.length,o=0;o<=t;++o)a.push(Math.round(o/t*i));for(o=0,r=a.length-1;o<r;++o)n.push(e.slice(a[o],a[o+1])),"M"!==n[o][0][0]&&"m"!==n[o][0][0]&&(l=n[o-1].length-1,s=n[o-1][l][1],c=n[o-1][l][2],n[o].unshift(["M",s,c]));return n}for(s=i.length;s--;)h(i[s],s),i[s].length||i.pop();for(s=o.length;s--;)h(o[s],s),o[s].length||o.pop();for(function(e){var t,r=[],n=[],a=[],s=0,l=!0;if(0!==e){for(e>0?(r=o,l=!1):(e=-e,r=i),s=0,t=r.length;s<t;++s)n.push(1);for(;e--;)--s<0&&(s=t-1),n[s]++;for(s=0;s<t;++s)1===n[s]?a.push(r[s]):a.push.apply(a,m(r[s],n[s]));l?i=a:o=a}}(i.length-o.length),l=Math.max(i.length,o.length),s=0;s<l;++s)r=Ut(f(i[s]),f(o[s])),i[s]=r[0],o[s]=r[1];for(s=0,l=i.length;s<l;++s)n=n.concat(i[s]);for(s=0,l=o.length;s<l;++s)a=a.concat(o[s]);return[n,a]}function Ut(e,t){var r,n,a,i=0,o=[],s=[];function l(e,t){var r,n,a,i,o=0,s={},l=[],c=[],u=0,d=Math.round;for((r=document.createElementNS("http://www.w3.org/2000/svg","path")).setAttribute("d",e),(n=document.createElementNS("http://www.w3.org/2000/svg","path")).setAttribute("d",t),a=r.getTotalLength(),i=n.getTotalLength(),u=.15*Math.max(a,i),(!(u=Math.ceil(u))||!isFinite(u)||u<10)&&(u=10),o=0;o<=u;++o)s=r.getPointAtLength(o/u*a),l.push([o?H:"M",d(s.x),d(s.y)]),s=n.getPointAtLength(o/u*i),c.push([o?H:"M",d(s.x),d(s.y)]);return[l,c]}for(e&&"M  "!==e||(e=t.split(p).slice(0,3).join(p).replace(/[LC]/,g)),t&&"M  "!==t||(t=e.split(p).slice(0,3).join(p).replace(/[LC]/,g)),n=function(e,t){var r,n,a,i,o=0,s=0,l=0,c=0,u={},d={},f=[],h=[],m=-1,v=-1,b=!0;function y(e){var t,r=0;for(r=0,t=(e=e.split(/[MCLmcl]/).slice(1)).length;r<t;++r)e[r]=e[r].split(p).slice(1),r||e[r].unshift("M"),r&&(2===e[r].length&&e[r].unshift(H)||e[r].unshift("C"));return e}function x(e,t){var r,n,a=0,i=e.length;for(a=0,i=e.length;a<i;++a)r=e[a].join(p),"C"===(n=e[a])[0]&&n[3]===n[5]&&n[4]===n[6]?e[a].stringValue=[H,n[3],n[4]].join(p):n.stringValue=r,t[n.stringValue]&&t[n.stringValue].push(a),t[n.stringValue]||(t[n.stringValue]=[a])}function w(e,t,r,n,a){for(var i,o=r,s=0,l=0;o<n;++o)if(i=t[e[o].stringValue])for(s=0,l=i.length;s<l;++s)if(i[s]>=a)return{index:o,mapValue:i[s],diff:o-r};return-1}function C(e){var t=e.length-1;return["M",e[t-1],e[t]].join(p)}function k(e){return e.join(g)}for(e=y(e),t=y(t),x(e,u),x(t,d),r=e.length,n=t.length,o=0,s=0;o<r&&s<n;){if(++v,f[++m]=[],h[v]=[],b=e[o].stringValue===t[s].stringValue,o&&(f[m].push(C(e[o-1])),h[v].push(C(t[s-1]))),b)for(;o<r&&s<n&&e[o].stringValue===t[s].stringValue;)f[m].push(e[o].stringValue),h[v].push(t[s].stringValue),++o,++s;else{for(a=w(e,d,o,r,s),i=w(t,u,s,n,o),l=a.index,c=a.mapValue,(!~a||a.diff>i.diff)&&(l=i.mapValue,c=i.index),~a||~i||(l=r-1,c=n-1);o<=l;)f[m].push(e[o].stringValue),++o;for(;s<=c;)h[v].push(t[s].stringValue),++s}f[m]=k(f[m]),h[v]=k(h[v])}if(o<r){for(f[++m]=[],f[m].push(C(e[o-1])),h[++v]=[],h[v].push(C(t[s-1]));o<r;)f[m].push(e[o].stringValue),++o;f[m]=k(f[m])}if(s<n){for(f[++m]=[],f[m].push(C(e[o-1])),h[++v]=[],h[v].push(C(t[s-1]));s<n;)h[v].push(t[s].stringValue),++s;h[v]=k(h[v])}return[f,h]}(e,t),i=0,r=n[0].length;i<r;++i)a=l(n[0][i],n[1][i]),i?(o=o.concat(a[0].slice(1)),s=s.concat(a[1].slice(1))):(o=o.concat(a[0]),s=s.concat(a[1]));return[o,s]}function Gt(e,t,r,n,a,o,s,l){r=Z(r);var u,d,f,h,g,p,v,y,w=e.ms,C={},S={},E={};if(null!==t.type){if((l=l||{}).hookFn&&l.hookFn.call(t),l.from=l.from||{},n)for(N=0,T=Lt.length;N<T;N++){var A=Lt[N];if(A.el.id===t.id&&A.anim===e){A.percent!=r?(delete A.el.e,delete A.el,Lt.splice(N,1),f=1):d=A,t.attr(A.totalOrigin);break}}else n=+S;for(var N=0,T=e.percents.length;N<T;N++){if(e.percents[N]===r||e.percents[N]>n*e.top){r=e.percents[N],g=e.percents[N-1]||0,w=w/e.top*(r-g),h=e.percents[N+1],u=e.anim[r];break}n&&t.attr(e.anim[e.percents[N]])}if(u){if(d)d.initstatus=n,d.start=new Date-d.ms*n;else{for(var M in u)if(u[m](M))if(Ae[m](M)||t.ca[M]){switch(C[M]=l.from[M]||t.attr(M),null==C[M]&&(C[M]=Ee[M]),S[M]=u[M],y=!1,Ae[M]){case"number":((v=S[M]-C[M])||isNaN(v))&&(y=!0),E[M]=v/w;break;case"colour":if(C[M]===S[M])break;y=!0;var D=zt(C[M],S[M],c.getRGB);C[M]=D[0];var F=D[1];if(typeof F===x)C[M].toLowerCase()!==_?(C[M]=c.getRGB(C[M]),C[M].opacity||(C[M].opacity=1)):C[M]={r:0,g:0,b:0,opacity:0},S[M].toLowerCase()!==_?(F=c.getRGB(S[M])).opacity||(F.opacity=1):F={r:0,g:0,b:0,opacity:0},E[M]={r:(F.r-C[M].r)/w,g:(F.g-C[M].g)/w,b:(F.b-C[M].b)/w,opacity:(F.opacity-C[M].opacity)/w};else for(E[M]=[],N=0,T=C[M].length;N<T;++N)0===N?E[M].push(F[0]):E[M].push({r:(F[N].r-C[M][N].r)/w,g:(F[N].g-C[M][N].g)/w,b:(F[N].b-C[M][N].b)/w,opacity:(F[N].opacity-C[M][N].opacity)/w});break;case"path":var I,O=ot(C[M],S[M]);for(l.smartMorph&&(O=Ht(O[0],O[1])),I=O[1],C[M]=O[0],E[M]=[],N=0,T=C[M].length;N<T;N++){var L;E[M][N]=[0],L=C[M][N]?C[M][N].length:0;for(var R=1;R<L;R++)E[M][N][R]=(I[N][R]-C[M][N][R])/w,!y&&E[M][N][R]&&(y=!0)}break;case"transform":var P=t._,V=ut(P[M],S[M]);if(y=!0,V)for(C[M]=V.from,S[M]=V.to,E[M]=[],E[M].real=!0,N=0,T=C[M].length;N<T;N++)for(E[M][N]=[C[M][N][0]],R=1,L=C[M][N].length;R<L;R++)E[M][N][R]=(S[M][N][R]-C[M][N][R])/w;else{var j=t.matrix||new dt,B={_:{transform:P.transform},getBBox:function(){return t.getBBox(1)}};C[M]=[j.a,j.b,j.c,j.d,j.e,j.f],lt(B,S[M]),S[M]=B._.transform,E[M]=[(B.matrix.a-j.a)/w,(B.matrix.b-j.b)/w,(B.matrix.c-j.c)/w,(B.matrix.d-j.d)/w,(B.matrix.e-j.e)/w,(B.matrix.f-j.f)/w]}break;case"csv":var z=J(u[M])[k](pe),H=J(C[M])[k](pe);if("clip-rect"===M)for(C[M]=H,E[M]=[],N=H.length;N--;)((v=z[N]-C[M][N])||isNaN(v))&&(y=!0),E[M][N]=v/w;S[M]=z;break;default:for(z=[][b](u[M]),H=[][b](C[M]),E[M]=[],N=t.ca[M].length;N--;)((v=(z[N]||0)-(H[N]||0))||isNaN(v))&&(y=!0),E[M][N]=v/w}y||(delete C[M],delete S[M],delete u[M],delete E[M])}else(c._availableAttrs[m](M)||"text"===M||t.ca[M])&&(t.attr(M,u[M]),delete u[M]);var U=u.easing,G=c.easing_formulas[U];if(!G)if((G=J(U).match(be))&&5===G.length){var W=G;G=function(e){return jt(e,+W[1],+W[2],+W[3],+W[4],w)}}else G=Me;if(p=u.start||e.start||+new Date,t.e=A={anim:e,percent:r,timestamp:p,start:p+(e.del||0),status:0,initstatus:n||0,stop:!1,ms:w,easing:G,from:C,diff:E,to:S,el:t,callback:u.callback,prev:g,next:h,repeat:o||e.times,origin:t.attr(),totalOrigin:a,parentEl:s,delayend:l&&l.end,delaystart:l&&l.start},Lt.push(A),n&&!d&&!f&&(A.stop=!0,A.start=new Date-w*n,1===Lt.length))return Rt();f&&(A.start=new Date-A.ms*n),1===Lt.length&&(Ot||c.getAnimFrameFn())(Rt)}(0,i["default"])("raphael.anim.start."+t.id,t,e)}}}function Wt(e){var t;void 0===e&&(e=this);for(var r=0;r<Lt.length;r++)(t=Lt[r].el.paper)&&t!==e||Lt.splice(r--,1)}c.animation=function(e,t,r,n,a){if(e instanceof Bt)return e;!c.is(r,S)&&r||(n=n||r||null,r=null),!c.stopPartialEventPropagation&&(c.stopPartialEventPropagation=a),e=Object(e),t=+t||0;var i,o,s={};for(o in e)e[m](o)&&Z(o)!=o&&Z(o)+"%"!=o&&(i=!0,s[o]=e[o]);return n&&(i=!0),i?(r&&(s.easing=r),n&&(s.callback=n),new Bt({100:s},t)):new Bt(e,t)},Ct.animate=function(e,t,r,n){if(this.removed)return n&&n.call(this),this;var a=e instanceof Bt?e:c.animation(e,t,r,n);return Gt(a,this,a.percents[0],null,this.attr()),this},Ct.status=function(e,t){var r,n,a=[],i=0;if(null!=t)return Gt(e,this,-1,re(t,1)),this;for(r=Lt.length;i<r;i++)if((n=Lt[i]).el.id===this.id&&(!e||n.anim===e)){if(e)return n.status;a.push({anim:n.anim,status:n.status})}return e?0:a},Ct.pause=function(e,t){var r,n,a=+new Date;for(n=0;n<Lt.length;n++)!((r=Lt[n]).el.id===this.id||t&&r.parentEl&&r.parentEl.e.el&&r.parentEl.e.el.id===this.id)||e&&r.anim!==e||!1!==(0,i["default"])("raphael.anim.pause."+this.id,this,r.anim)&&(r.paused=!0,r.pauseStart=a);return this},Ct.resume=function(e,t){var r,n,a=+new Date;for(n=0;n<Lt.length;n++)!((r=Lt[n]).el.id===this.id||t&&r.parentEl&&r.parentEl.e.el&&r.parentEl.e.el.id===this.id)||e&&r.anim!==e||!1!==(0,i["default"])("raphael.anim.resume."+this.id,this,r.anim)&&(delete r.paused,r.el.status(r.anim,r.status),r.pauseEnd=a,r.start+=(r.parentEl&&r.parentEl.e.pauseEnd||r.pauseEnd)-(r.parentEl&&r.parentEl.e.pauseStart||r.pauseStart)||0);return this},Ct.stop=function(e,t,r){var n,a;if(t)for(o=Lt.length-1;o>=0;o--)!((n=Lt[o]).el.id===this.id||n.parentEl&&n.parentEl.id===this.id)||e&&Lt[o].anim!==e||(a=n.el,r&&a.attr(n.to),n.callback&&n.callback.call(a),delete a.e,delete n.el,Lt.splice(o,1));else for(var o=0;o<Lt.length;o++)(n=Lt[o]).el.id!==this.id||e&&n.anim!==e||!1!==(0,i["default"])("raphael.anim.stop."+this.id,this,n.anim)&&Lt.splice(o--,1);return this.animElements&&function(e){var t;for(;t=e.deq();)(t=t.executeOb).hookFn&&t.hookFn.call(t.el),t.el.attr(t.attrs),t.callback&&t.callback.call(t.el)}(this.animElements),this},i["default"].on("raphael.remove",Wt),i["default"].on("raphael.clear",Wt),Ct.toString=function(){return"Raphaël’s object"},Ct.toFront=function(){if(this.removed)return this;var e,t,r,n=this,a=c._engine.getNode(n),i=n.parent,o=n.followers;for(c._tofront(n,i)&&i.canvas.appendChild(a),t=0,r=o.length;t<r;t++)(e=o[t]).stalk&&e.el[e.stalk](n);return n},Ct.toBack=function(){if(this.removed)return this;var e,t,r,n=this,a=c._engine.getNode(n),i=n.parent,o=n.followers;for(c._toback(n,i)&&i.canvas.insertBefore(a,i.canvas.firstChild),t=0,r=o.length;t<r;t++)(e=o[t]).stalk&&e.el[e.stalk](n);return n},Ct.insertAfter=function(e){if(this.removed)return this;var t,r,n,a=this,i=c._engine.getNode(a),o=c._engine.getLastNode(e),s=e.parent.canvas,l=a.followers;for(o.nextSibling?s.insertBefore(i,o.nextSibling):s.appendChild(i),c._insertafter(a,e,a.parent,e.parent),r=0,n=l.length;r<n;r++)(t=l[r]).stalk&&t.el[t.stalk](e);return a},Ct.insertBefore=function(e){if(this.removed)return this;var t,r,n,a=this,i=c._engine.getNode(a),o=c._engine.getNode(e),s=a.followers;for(e.parent.canvas.insertBefore(i,o),c._insertbefore(a,e,a.parent,e.parent),a.parent=e.parent,r=0,n=s.length;r<n;r++)(t=s[r]).stalk&&t.el[t.stalk](e);return this},Ct.appendChild=function(e){if(this.removed||"group"!==this.type)return this;var t,r,n,a,i=this.followers;if(e.parent===this)return e.toFront(),this;for(r=c._engine.getNode(e),c._tear(e,e.parent),this.canvas.appendChild(r),e.parent=this,!this.bottom&&(this.bottom=e),e.prev=this.top,e.next=null,this.top&&(this.top.next=e),this.top=e,n=0,a=i.length;n<a;n++)(t=i[n]).stalk&&t.el[t.stalk](e);return this},Ct.appendTo=function(e){return e.appendChild(this)},Ct.removeChild=function(e){if(this.removed||"group"!==this.type||e.parent!==this)return this;var t=this,r=c._engine.getNode(e),n=t.paper;return c._tear(e,t),n.canvas.appendChild(r),t.parent=n,!n.bottom&&(n.bottom=t),t.prev=n.top,n.top&&(n.top.next=t),n.top=t,t.next=null,t},c.format=function(e,t){var r=(0,o.getArrayCopy)(arguments),n=c.is(t,w)?[0][b](t):r;return e&&c.is(e,x)&&n.length-1&&(e=e.replace(me,(function(e,t){return null==n[++t]?g:n[t]}))),e||g};var $t=c.vml?.5:0;c.crispBound=(0,o.cacher)((function(e,t,r,n,a){var i,o={};return e=e||0,t=t||0,r=r||0,n=n||0,i=(a=a||0)%2/2+$t,o.x=le(e+i)-i,o.y=le(t+i)-i,o.width=le(e+r+i)-i-o.x,o.height=le(t+n+i)-i-o.y,o["stroke-width"]=a,0===o.width&&0!==r&&(o.width=1),0===o.height&&0!==n&&(o.height=1),o}),c),Ct.crisp=function(){var e,t=this,r=t.attrs,n=t.attr();for(e in n=c.crispBound(n.x,n.y,n.width,n.height,n["stroke-width"]))r[e]===n[e]&&delete n[e];return t.attr(n)},c.define=function(e,t,r,n,a,i){var s,l;if(c.is(e,w))for(s=0,l=e.length;s<l;s++)c.define(e[s]);else if(c.is(e,C))c.define(e.name,e[e.name],e.ca,e.fn,e.e,e.data);else if(e&&!c.fn[e])return c.fn[e]=function(){var i,s=(0,o.getArrayCopy)(arguments),l=t.apply(this,s);if(n&&c.is(n,C))for(i in n)l[i]=n[i];if(a&&c.is(a,C))for(i in a)l[i]&&l[i](a[i]);if(r){if(c.is(r,S))l.ca[e]=r;else for(i in r)l.ca[i]=r[i];l.ca[e]&&(c._lastArgIfGroup(s,!0),s.length&&(s[0][e]?l.attr.apply(l,s):l.attr(e,s[0])))}return l},r&&(c.fn[e].ca=r),n&&(c.fn[e].fn=n),a&&(c.fn[e].e=a),i&&(c.fn[e].data=i),c.fn[e]},function(e,t,r){null==e.readyState&&e.addEventListener&&(e.addEventListener("DOMContentLoaded",r=function(){e.removeEventListener("DOMContentLoaded",r,!1),e.readyState="complete"},!1),e.readyState="loading"),function n(){/in/.test(e.readyState)?setTimeout(n,9):c.eve("raphael.DOMload")}()}(F),i["default"].on("raphael.DOMload",(function(){u=!0})),c._preload=function(e,t){var r=D.doc,n=r.createElement("img");n.style.cssText="position:absolute;left:-9999em;top:-9999em",n.onload=function(){t.call(this),this.onload=null,r.body.removeChild(this)},n.onerror=function(){r.body.removeChild(this)},r.body.appendChild(n),n.src=e};var Xt=c;t["default"]=Xt}).call(this,r(6))},function(e,t,r){"use strict";(function(e){t.__esModule=!0,t["default"]=void 0;var n=r(227),a=function(e){var t,r,a="hasOwnProperty",i=/[\.\/]/,o=/\s*,\s*/,s=function(e,t){return e-t},l={n:{}},c=function(){for(var e=0,t=this.length;e<t;e++)if("undefined"!=typeof this[e])return this[e]},u=function(){for(var e=this.length;--e;)if("undefined"!=typeof this[e])return this[e]},d=Object.prototype.toString,f=String,h=Array.isArray||function(e){return e instanceof Array||"[object Array]"==d.call(e)};function g(e,a){var i,o=r,l=(0,n.getArrayCopy)(arguments),d=Array.prototype.slice.call(l,2),f=g.listeners(e),h=0,p=[],m={},v=[],b=t;v.firstDefined=c,v.lastDefined=u,t=e,r=0;for(var y=0,x=f.length;y<x;y++)"zIndex"in f[y]&&(p.push(f[y].zIndex),f[y].zIndex<0&&(m[f[y].zIndex]=f[y]));for(p.sort(s);p[h]<0;)if(i=m[p[h++]],v.push(i.apply(a,d)),r)return r=o,v;for(y=0;y<x;y++)if("zIndex"in(i=f[y]))if(i.zIndex==p[h]){if(v.push(i.apply(a,d)),r)break;do{if((i=m[p[++h]])&&v.push(i.apply(a,d)),r)break}while(i)}else m[i.zIndex]=i;else if(v.push(i.apply(a,d)),r)break;return r=o,t=b,v}return g._events=l,g.listeners=function(e){var t,r,n,a,o,s,c,u,d=h(e)?e:e.split(i),f=l,g=[f],p=[];for(a=0,o=d.length;a<o;a++){for(u=[],s=0,c=g.length;s<c;s++)for(r=[(f=g[s].n)[d[a]],f["*"]],n=2;n--;)(t=r[n])&&(u.push(t),p=p.concat(t.f||[]));g=u}return p},g.separator=function(e){e?(e="["+(e=f(e).replace(/(?=[\.\^\]\[\-])/g,"\\"))+"]",i=new RegExp(e)):i=/[\.\/]/},g.on=function(e,t){if("function"!=typeof t)return function(){};for(var r=h(e)?h(e[0])?e:[e]:f(e).split(o),n=0,a=r.length;n<a;n++)!function(e){for(var r,n=h(e)?e:f(e).split(i),a=l,o=0,s=n.length;o<s;o++)a=(a=a.n).hasOwnProperty(n[o])&&a[n[o]]||(a[n[o]]={n:{}});for(a.f=a.f||[],o=0,s=a.f.length;o<s;o++)if(a.f[o]==t){r=!0;break}!r&&a.f.push(t)}(r[n]);return function(e){+e==+e&&(t.zIndex=+e)}},g.f=function(e){var t=(0,n.getArrayCopy)(arguments),r=[].slice.call(t,1);return function(){g.apply(null,[e,null].concat(r).concat([].slice.call(t,0)))}},g.stop=function(){r=1},g.nt=function(e){var r=h(t)?t.join("."):t;return e?new RegExp("(?:\\.|\\/|^)"+e+"(?:\\.|\\/|$)").test(r):r},g.nts=function(){return h(t)?t:t.split(i)},g.off=g.unbind=function(e,t){if(e){var r=h(e)?h(e[0])?e:[e]:f(e).split(o);if(r.length>1)for(var n=0,s=r.length;n<s;n++)g.off(r[n],t);else{r=h(e)?e:f(e).split(i);var c,u,d,p,m,v=[l],b=[];for(n=0,s=r.length;n<s;n++)for(p=0;p<v.length;p+=d.length-2){if(d=[p,1],c=v[p].n,"*"!=r[n])c[r[n]]&&(d.push(c[r[n]]),b.unshift({n:c,name:r[n]}));else for(u in c)c[a](u)&&(d.push(c[u]),b.unshift({n:c,name:u}));v.splice.apply(v,d)}for(n=0,s=v.length;n<s;n++)for(c=v[n];c.n;){if(t){if(c.f){for(p=0,m=c.f.length;p<m;p++)if(c.f[p]==t){c.f.splice(p,1);break}!c.f.length&&delete c.f}for(u in c.n)if(c.n[a](u)&&c.n[u].f){var y=c.n[u].f;for(p=0,m=y.length;p<m;p++)if(y[p]==t){y.splice(p,1);break}!y.length&&delete c.n[u].f}}else for(u in delete c.f,c.n)c.n[a](u)&&c.n[u].f&&delete c.n[u].f;c=c.n}e:for(n=0,s=b.length;n<s;n++){for(u in(c=b[n]).n[c.name].f)continue e;for(u in c.n[c.name].n)continue e;delete c.n[c.name]}}}else g._events=l={n:{}}},g.once=function(e,t){return g.on(e,(function r(){return g.off(e,r),t.apply(this,arguments)}))},g.version="0.5.3",g.toString=function(){return"You are running Eve 0.5.3"},g}("undefined"!=typeof window&&window);t["default"]=a}).call(this,r(6))},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(259)),i={extension:function(e){(0,a["default"])(e.getDep("redraphael","plugin"))},name:"redraphaelSvg",type:"plugin",requiresFusionCharts:!0};t["default"]=i},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){if(e.svg){var t="hasOwnProperty",r="vertical-align",a=!1,i=!1,o="function",s={visibility:"hidden","font-size":"0px"},l=String,c=parseFloat,u=parseInt,d={top:0,bottom:-1,middle:-.5},f=e._g.win.navigator,h=!!document.documentMode,g=Math,p=g.max,m=g.abs,v=g.pow,b=g.sqrt,y=/^xlink:/,x=/[, ]+/,w=/\n|<br\s*?\/?>/i,C=/&lt|&gt|&quot|&#039|&#034|<br/i,k=/&nbsp;|&#160;|&#xA0;/g,_=Array.prototype.shift,S=!(!/AppleWebKit/.test(f.userAgent)||/Chrome/.test(f.userAgent)&&!(f.appVersion.match(/Chrome\/(\d+)\./)[1]<29)),E=e.eve,A="",N=" ",T="http://www.w3.org/1999/xlink",M="http://www.w3.org/2000/svg",D=(!!f.platform&&/iPad|iPhone|iPod/.test(f.platform),{block:"M5,0 0,2.5 5,5z",classic:"M5,0 0,2.5 5,5 3.5,3 3.5,2z",diamond:"M2.5,0 5,2.5 2.5,5 0,2.5z",open:"M6,1 1,3.5 6,6",oval:"M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z"}),F={speed:"optimizeSpeed",crisp:"crispEdges",precision:"geometricPrecision"},I=f.userAgent.toLowerCase(),O=!(!(be=-1!=I.indexOf("msie")&&parseInt(I.split("msie")[1]))||9!==be),L=e.supportsPointer,R=e.supportsTouch,P={},V=function(t,r,n,a){e._preload(n[1],(function(){var e=this.offsetWidth,n=this.offsetHeight;re(t,{width:e,height:n}),re(r,{width:e,height:n}),a.safari()}))},j=function(e,t){if(t)for(var r in t)e[r]=t[r]},B={elementInfo:[]},z=e._g.doc,H=(e._g.win,{mouseover:"touchstart",mousedown:"touchstart",mouseup:"touchend",mousemove:"touchmove",mouseout:"touchend"}),U=function(e,t){var r,n,a,i=[],o=[],s=0,l=Q(/<under>/g,/<\/under>/g,e,"<under>","</under>"),c=Q(/<bold>/g,/<\/bold>/g,e,"<bold>","</bold>"),u=Q(/<em>/g,/<\/em>/g,e,"<em>","</em>"),d=Q(/<strike>/g,/<\/strike>/g,e,"<strike>","</strike>"),f=Q(/<sub>/g,/<\/sub>/g,e,"<sub>","</sub>"),h=Q(/<sup>/g,/<\/sup>/g,e,"<sup>","</sup>"),g=q(/<abbr[\s]+([^>]+)>/g,/<\/abbr>/g,e,"<abbr>","</abbr>"),p=Z(/<a[\s]+([^>]+)>/g,/<\/a>/g,e,"<a>","</a>"),m=J(/<span[\s]+([^>]+)>/g,/<\/span>/g,e,"<span>","</span>");if((a=Y(l,c,u,d,f,h,g,p,m)).length){for(a[0].index>s&&(n=e.substring(s,a[0].index),o=$(o,n,i,t,a),s=a[0].index+a[0].tagName.length),r=0;r<a.length;r++)void 0!==a[r+1]&&(i=W(i,a[r]),n=0===s&&0===a[r].index?e.substring(s+a[r].tagName.length,a[r+1].index):e.substring(s,a[r+1].index),o=$(o,n,i,a[r],t,a),s=a[r+1].index+a[r+1].tagName.length);s<e.length&&(n=e.substring(s,e.length),o=$(o,n,[],t,a))}return o},G={"<bold>":{action:"add",tagAttr:"font-weight",tagAttrVal:"bold"},"</bold>":{action:"remove",actionTag:"<bold>"},"<under>":{action:"add",tagAttr:"text-decoration",tagAttrVal:"underline"},"</under>":{action:"remove",actionTag:"<under>"},"<em>":{action:"add",tagAttr:"font-style",tagAttrVal:"italic"},"</em>":{action:"remove",actionTag:"<em>"},"<strike>":{action:"add",tagAttr:"text-decoration",tagAttrVal:"line-through"},"</strike>":{action:"remove",actionTag:"<strike>"},"<sub>":{action:"add",tagAttr:"baseline-shift",tagAttrVal:"sub"},"</sub>":{action:"remove",actionTag:"<sub>"},"<sup>":{action:"add",tagAttr:"baseline-shift",tagAttrVal:"super"},"</sup>":{action:"remove",actionTag:"<sup>"},"<abbr>":{action:"add",tagAttr:"text-decoration",tagAttrVal:"underline"},"</abbr>":{action:"remove",actionTag:"<abbr>"},"<a>":{action:"add"},"</a>":{action:"remove",actionTag:"<a>"},"<span>":{action:"add"},"</span>":{action:"remove",actionTag:"<span>"}},W=function(e,t){var r,n;if(t.tagName.match(/<abbr[\s]+([^>]+)>/g))n=X({tag:"<abbr>",sortedIndex:t}),e.push(n);else if(t.tagName.match(/<a[\s]+([^>]+)>/g))n=X({tag:"<a>",sortedIndex:t}),e.push(n);else if(t.tagName.match(/<span[\s]+([^>]+)>/g))n=X({tag:"<span>",sortedIndex:t}),e.push(n);else if("add"===G[t.tagName].action)n=X({tag:t.tagName,sortedIndex:t}),e.push(n);else if("remove"===G[t.tagName].action)for(r=e.length-1;r>=0;r--)if(e[r].tag===G[t.tagName].actionTag){e.splice(r,1);break}return e},$=function(t,r,o,s,l,c){var u,d,f,g,p=e._g.doc.createTextNode(r),m={},v=!1,b=!1,y=!1,x="";if((h||n.isFirefox)&&(i&&(m.dy=-6,i=!1),a&&(m.dy=6,a=!1)),o.length){for(g=0;g<o.length;g++)"<abbr>"===o[g].tag?(b=!0,x=o[g].sortedIndex.title):"<a>"===o[g].tag?(v=!0,""!==o[g].href&&(m.href=o[g].sortedIndex.href),""!==s.target&&(m.target=o[g].sortedIndex.target),""!==s.hreflang&&(m.hreflang=o[g].sortedIndex.hreflang),""!==s.referrerpolicy&&(m.referrerpolicy=o[g].sortedIndex.referrerpolicy),""!==s.rel&&(m.rel=o[g].sortedIndex.rel),d=re("a",m)):"<span>"===o[g].tag&&(y=!0,u=o[g].sortedIndex.style),G[o[g].tag].tagAttr&&G[o[g].tag].tagAttrVal&&((h||n.isFirefox)&&("<sup>"===o[g].tag?(m.dy=-6,a=!0):"<sub>"===o[g].tag&&(m.dy=6,i=!0)),m[G[o[g].tag].tagAttr]=G[o[g].tag].tagAttrVal);v?""!==r&&((f=re("tspan",m)).appendChild(p),d.appendChild(f),t.push(d),v=!1):b?""!==r&&((f=re("tspan",m)).appendChild(p),l.push({tspan:f,title:x}),t.push(f)):y?""!==r&&(m=X(m,u),(f=re("tspan",m)).appendChild(p),t.push(f)):""!==r&&((f=re("tspan",m)).appendChild(p),t.push(f))}else(f=re("tspan",m)).appendChild(p),t.push(f);return t},X=function ye(e,t){for(var r in t)try{t[r].constructor==Object?e[r]=ye(e[r],t[r]):e[r]=t[r]}catch(n){e[r]=t[r]}return e},Y=function(e,t,r,n,a,i,o,s,l){var c,u,d=[e,t,r,n,a,i,o,s,l],f=[];for(u=0;u<d.length;u++)for(var h in d[u])if(d[u][h].length)for(c=0;c<d[u][h].length;c++)f.push(d[u][h][c]);return f=f.sort((function(e,t){return e.index-t.index}))},q=function(e,t,r,n,a){for(var i,o,s,l,c=[],u=[];i=e.exec(r);)o=document.createElement("p"),s=i[0]+"Dummy</abbr>",o.innerHTML=s,l=o.childNodes[0]?o.childNodes[0].title:"",c.push({tagName:i[0],index:i.index,title:l||""});for(;i=t.exec(r);)u.push({tagName:a,index:i.index});return{tag:c,endtag:u}},K=function(e){var t={};if(!e||!e.style||!e.style.cssText)return t;for(var r=e.style.cssText.split(";"),n=0;n<r.length;++n){var a=r[n].trim();if(a){var i=a.split(":");t[i[0].trim().replace(/(?:^|[-])(\w)/g,(function(e,t){return(t="-"===e.substr(0,1)?t.toUpperCase():t)||""}))]=i[1].trim()}}return t},J=function(e,t,r,n,a){for(var i,o,s,l,c=[],u=[];i=e.exec(r);)o=document.createElement("p"),s=i[0]+"Dummy</span>",o.innerHTML=s,l=K(o.childNodes[0]),c.push({tagName:i[0],index:i.index,style:l||""});for(;i=t.exec(r);)u.push({tagName:a,index:i.index});return{tag:c,endtag:u}},Z=function(e,t,r,n,a){for(var i,o,s,l,c=[],u=[];i=e.exec(r);)o=document.createElement("p"),s=i[0]+"</a>",o.innerHTML=s,l=!!encodeURIComponent(o.childNodes[0].href).match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/g),c.push({tagName:i[0],index:i.index,href:l?o.childNodes[0].href:"",target:o.childNodes[0].target?o.childNodes[0].target:"",hreflang:o.childNodes[0].hreflang?o.childNodes[0].hreflang:"",referrerpolicy:o.childNodes[0].referrerpolicy?o.childNodes[0].referrerpolicy:"",rel:o.childNodes[0].rel?o.childNodes[0].rel:""});for(;i=t.exec(r);)u.push({tagName:a,index:i.index});return{tag:c,endtag:u}},Q=function(e,t,r,n,a){for(var i,o=[],s=[];i=e.exec(r);)o.push({tagName:n,index:i.index});for(;i=t.exec(r);)s.push({tagName:a,index:i.index});return{tag:o,endtag:s}},ee={"accent-height":!0,accumulate:!0,additive:!0,"alignment-baseline":!0,alphabetic:!0,amplitude:!0,"arabic-form":!0,ascent:!0,azimuth:!0,"baseline-shift":!0,bbox:!0,begin:!0,bias:!0,by:!0,"cap-height":!0,"class":!0,clip:!0,"clip-path":!0,"clip-rule":!0,color:!0,"color-interpolation":!0,"color-interpolation-filters":!0,"color-profile":!0,"color-rendering":!0,cursor:!0,cx:!0,cy:!0,d:!0,decelerate:!0,descent:!0,direction:!0,display:!0,divisor:!0,"dominant-baseline":!0,dur:!0,dx:!0,dy:!0,elevation:!0,"enable-background":!0,end:!0,exponent:!0,fill:!0,"fill-opacity":!0,"fill-rule":!0,filter:!0,"flood-color":!0,"flood-opacity":!0,"font-family":!0,"font-size":!0,"font-size-adjust":!0,"font-stretch":!0,"font-style":!0,"font-variant":!0,"font-weight":!0,format:!0,fr:!0,from:!0,fx:!0,fy:!0,g1:!0,g2:!0,"glyph-name":!0,"glyph-orientation-horizontal":!0,"glyph-orientation-vertical":!0,hanging:!0,height:!0,"horiz-adv-x":!0,"horiz-origin-x":!0,href:!0,hreflang:!0,id:!0,ideographic:!0,"image-rendering":!0,in2:!0,"in":!0,intercept:!0,k1:!0,k2:!0,k3:!0,k4:!0,k:!0,kerning:!0,lang:!0,"letter-spacing":!0,"lighting-color":!0,local:!0,"marker-end":!0,"marker-mid":!0,"marker-start":!0,mask:!0,mathematical:!0,max:!0,media:!0,method:!0,min:!0,mode:!0,name:!0,offset:!0,opacity:!0,operator:!0,order:!0,orient:!0,orientation:!0,origin:!0,overflow:!0,"overline-position":!0,"overline-thickness":!0,"paint-order":!0,"panose-1":!0,path:!0,ping:!0,"pointer-events":!0,points:!0,r:!0,radius:!0,rel:!0,"rendering-intent":!0,restart:!0,result:!0,rotate:!0,rx:!0,ry:!0,scale:!0,seed:!0,"shape-rendering":!0,slope:!0,spacing:!0,speed:!0,stemh:!0,stemv:!0,"stop-color":!0,"stop-opacity":!0,"strikethrough-position":!0,"strikethrough-thickness":!0,string:!0,stroke:!0,"stroke-dasharray":!0,"stroke-dashoffset":!0,"stroke-linecap":!0,"stroke-linejoin":!0,"stroke-miterlimit":!0,"stroke-opacity":!0,"stroke-width":!0,style:!0,tabindex:!0,target:!0,"text-anchor":!0,"text-decoration":!0,"text-rendering":!0,to:!0,transform:!0,type:!0,u1:!0,u2:!0,"underline-position":!0,"underline-thickness":!0,unicode:!0,"unicode-bidi":!0,"unicode-range":!0,"units-per-em":!0,"v-alphabetic":!0,"v-hanging":!0,"v-ideographic":!0,"v-mathematical":!0,values:!0,"vector-effect":!0,version:!0,"vert-adv-y":!0,"vert-origin-x":!0,"vert-origin-y":!0,visibility:!0,width:!0,widths:!0,"word-spacing":!0,"writing-mode":!0,x1:!0,x2:!0,x:!0,"x-height":!0,"xlink:actuate":!0,"xlink:arcrole":!0,"xlink:href":!0,"xlink:role":!0,"xlink:show":!0,"xlink:title":!0,"xlink:type":!0,"xml:base":!0,"xml:lang":!0,"xml:space":!0,y1:!0,y2:!0,y:!0,z:!0};R&&z.addEventListener(L?"pointerover":"touchstart",(function(e){if(B.srcElement&&B.srcElement!==(e.srcElement||e.target)){var t,r,n,a=(t=B.elementInfo).length;for(n=0;n<a;n++)(r=t[n]).callback.call(r.el,e)}B={elementInfo:[]}}),!0),e.toString=function(){return"Your browser supports SVG.\nYou are running Raphaël "+this.version},e._url=A;var te=function(e,t,r){void 0===r&&(r="fill");var n="fill"===r?e.gradient:e["stroke-gradient"];if(n){if(n===t)return;n.refCount--,n.refCount||n.parentNode.removeChild(n),"fill"===r?delete e.gradient:delete e["stroke-gradient"]}t&&("fill"===r?e.gradient=t:e["stroke-gradient"]=t,t.refCount++)},re=e._createNode=function(t,r){var n,a;if("string"==typeof t&&(t=e._g.doc.createElementNS(M,t)),r)for(n in r)a=O?l(r[n]):r[n],y.test(n)?t.setAttributeNS(T,n.replace(y,A),a):t.setAttribute(n,a);return t},ne={userSpaceOnUse:"userSpaceOnUse",objectBoundingBox:"objectBoundingBox"},ae={pad:"pad",redlect:"reflect",repeat:"repeat"},ie=function(t,r,n){var a;if(void 0===n&&(n="fill"),!t.paper||!t.paper.defs)return 0;var i,o,s,u,d,f,h="linear",y=t.paper,x=e.getElementID((y.id+"-"+r).replace(/[()\s%:,\xb0#]/g,"_")),w=.5,C=.5,k=t.node,_=k.style,S=e._g.doc.getElementById(x);if(!S){if(r=(r=l(r).replace(e._radial_gradient,(function(e,t){h="radial",t=t?t.split(","):[],u=t[5],d=t[6];var r,n,a=t[0],l=t[1],f=t[2],g=t[3],p=t[4],m=a&&l;return f&&(i=/%/.test(f)?f:c(f)),u===ne.userSpaceOnUse?(m&&(w=a,C=l),g&&p&&(o=g,s=p,m||(w=o,C=s)),A):(m&&(w=c(a),r=2*((C=c(l))>.5)-1,(n=v(w-.5,2))+v(C-.5,2)>.25&&n<.25&&(C=b(.25-n)*r+.5)&&.5!==C&&(C=C.toFixed(5)-1e-5*r)),g&&p&&(o=c(g),r=2*((s=c(p))>.5)-1,(n=v(o-.5,2))+v(s-.5,2)>.25&&n<.25&&(s=b(.25-n)*r+.5)&&.5!==s&&(s=s.toFixed(5)-1e-5*r),m||(w=o,C=s)),A)}))).split(/\s*-\s*/),"linear"===h){var E,N=r.shift(),T=N.match(/\((.*)\)/);if(T=T&&T[1]&&T[1].split(/\s*,\s*/),N=-c(N),isNaN(N))return null;T&&T.length?(T[0]in ne?(u=T.shift(),T[0]in ae&&(d=T.shift())):(T[4]&&(u=T[4]),T[5]&&(d=T[5])),f=[T[0]||"0%",T[1]||"0%",T[2]||"100%",T[3]||"0%"]):(f=[0,0,g.cos(e.rad(N)),g.sin(e.rad(N))],E=1/(p(m(f[2]),m(f[3]))||1),f[2]*=E,f[3]*=E,f[2]<0&&(f[0]=-f[2],f[2]=0),f[3]<0&&(f[1]=-f[3],f[3]=0))}var M=e._parseDots(r);if(!M)return null;(S=re(h+"Gradient",{id:x})).refCount=0,u in ne&&S.setAttribute("gradientUnits",l(u)),d in ae&&S.setAttribute("spreadMethod",l(d)),"radial"===h?(i!==undefined&&S.setAttribute("r",l(i)),o!==undefined&&s!==undefined&&(S.setAttribute("cx",l(o)),S.setAttribute("cy",l(s))),S.setAttribute("fx",l(w)),S.setAttribute("fy",l(C))):re(S,{x1:f[0],y1:f[1],x2:f[2],y2:f[3]});for(var D=0,F=M.length;D<F;D++)S.appendChild(re("stop",{offset:M[D].offset?M[D].offset:D?"100%":"0%","stop-color":M[D].color||"#fff","stop-opacity":M[D].opacity===undefined?1:M[D].opacity}));y.defs.appendChild(S)}return te(t,S,n),re(k,((a={})[n]="url('"+e._url+"#"+x+"')",a[n+"-opacity"]=1,a)),_.fill=A,1},oe=function(e){var t=e.getBBox(1);re(e.pattern,{patternTransform:e.matrix.invert()+" translate("+t.x+","+t.y+")"})},se=function(r,n,a){if("path"==r.type){for(var i,o,s,c,u,d=l(n).toLowerCase().split("-"),f=r.paper,h=a?"end":"start",g=r.node,p=r.attrs,m=p["stroke-width"],v=d.length,b="classic",y=3,x=3,w=5;v--;)switch(d[v]){case"block":case"classic":case"oval":case"diamond":case"open":case"none":b=d[v];break;case"wide":x=5;break;case"narrow":x=2;break;case"long":y=5;break;case"short":y=2}if("open"==b?(y+=2,x+=2,w+=2,s=1,c=a?4:1,u={fill:"none",stroke:p.stroke}):(c=s=y/2,u={fill:p.stroke,stroke:"none"}),r._.arrows?a?(r._.arrows.endPath&&P[r._.arrows.endPath]--,r._.arrows.endMarker&&P[r._.arrows.endMarker]--):(r._.arrows.startPath&&P[r._.arrows.startPath]--,r._.arrows.startMarker&&P[r._.arrows.startMarker]--):r._.arrows={},"none"!=b){var C="raphael-marker-"+b,k="raphael-marker-"+h+b+y+x+"-obj"+r.id;e._g.doc.getElementById(C)?P[C]++:(f.defs.appendChild(re(re("path"),{"stroke-linecap":"round",d:D[b],id:C})),P[C]=1);var _,S=e._g.doc.getElementById(k);S?(P[k]++,_=S.getElementsByTagName("use")[0]):(S=re(re("marker"),{id:k,markerHeight:x,markerWidth:y,orient:"auto",refX:c,refY:x/2}),_=re(re("use"),{"xlink:href":"#"+C,transform:(a?"rotate(180 "+y/2+" "+x/2+") ":A)+"scale("+y/w+","+x/w+")","stroke-width":(1/((y/w+x/w)/2)).toFixed(4)}),S.appendChild(_),f.defs.appendChild(S),P[k]=1),re(_,u);var E=s*("diamond"!=b&&"oval"!=b);a?(i=r._.arrows.startdx*m||0,o=e.getTotalLength(p.path)-E*m):(i=E*m,o=e.getTotalLength(p.path)-(r._.arrows.enddx*m||0)),(u={})["marker-"+h]="url('"+e._url+"#"+k+"')",(o||i)&&(u.d=e.getSubpath(p.path,i,o)),re(g,u),r._.arrows[h+"Path"]=C,r._.arrows[h+"Marker"]=k,r._.arrows[h+"dx"]=E,r._.arrows[h+"Type"]=b,r._.arrows[h+"String"]=n}else a?(i=r._.arrows.startdx*m||0,o=e.getTotalLength(p.path)-i):(i=0,o=e.getTotalLength(p.path)-(r._.arrows.enddx*m||0)),r._.arrows[h+"Path"]&&re(g,{d:e.getSubpath(p.path,i,o)}),delete r._.arrows[h+"Path"],delete r._.arrows[h+"Marker"],delete r._.arrows[h+"dx"],delete r._.arrows[h+"Type"],delete r._.arrows[h+"String"];for(u in P)if(P[t](u)&&!P[u]){var N=e._g.doc.getElementById(u);N&&N.parentNode.removeChild(N)}}},le={"":["none"],none:["none"],"-":[3,1],".":[1,1],"-.":[3,1,1,1],"-..":[3,1,1,1,1,1],". ":[1,3],"- ":[4,3],"--":[8,3],"- .":[4,3,1,3],"--.":[8,3,1,3],"--..":[8,3,1,3,1,3]},ce=function(t,r,n){if(r!==undefined){var a,i,o,s,l,c=le[r.toLowerCase&&r.toLowerCase()];if(r=c||[].concat(r),e.is(r,"array")){if(o={round:i=n["stroke-width"]||t.attrs["stroke-width"]||1,square:i,butt:0}[n["stroke-linecap"]||t.attrs["stroke-linecap"]]||0,s=r.length,l=c?i:1,"none"===r[0])a=r;else for(a=[];s--;)a[s]=r[s]*l+(s%2?1:-1)*o,a[s]<=0&&(a[s]=.01+(i<=1?o:0)),isNaN(a[s])&&(a[s]=0);return{"stroke-dasharray":a.join(",")}}}},ue=e._setFillAndStroke=function(r,a){if(r.paper.canvas){var i,o,s,c,d,f,h=r.node,g=r.attrs,v=r.paper,b={},y={},w={"clip-rect":!0};for(o in"image"===r.type&&(0,n.loadRefImage)(r,a),a)if(o in e._availableAttrs)if((s=a[o])===A&&o in g)delete g[o],h.removeAttribute("src"===o?"href":o);else if(null!==s||w[o])switch(g[o]=s,o){case"blur":r.blur(s);break;case"href":case"title":case"target":var C=h.parentNode;if("a"!==C.tagName.toLowerCase()){if(s===A)break;var k=re("a");k.raphael=!0,k.raphaelid=h.raphaelid,C.insertBefore(k,h),k.appendChild(h),C=k}"target"===o?C.setAttributeNS(T,"show","blank"===s?"new":s):C.setAttributeNS(T,o,s),h.titleNode=C;break;case"cursor":y.cursor=s;break;case"transform":r.transform(s);break;case"rotation":e.is(s,"array")?r.rotate.apply(r,s):r.rotate(s);break;case"arrow-start":se(r,s);break;case"arrow-end":se(r,s,1);break;case"clip-path":c=!0;case"clip-rect":if(f=!c&&l(s).split(x),r._.clipispath=!!c,c||4===f.length){r.clip&&r.clip.parentNode.parentNode.removeChild(r.clip.parentNode);var _=re(c?"path":"rect");(i=re("clipPath")).id=e.getElementID(e.createUUID()),re(_,c?{d:s?g["clip-path"]=e._pathToAbsolute(s):e._availableAttrs.path,fill:"none"}:{x:f[0],y:f[1],width:f[2],height:f[3],transform:r.matrix.invert()}),i.appendChild(_),v.defs.appendChild(i),b["clip-path"]="url('"+e._url+"#"+i.id+"')",r.clip=_}if(!s){var E=h.getAttribute("clip-path");if(E){var N=e._g.doc.getElementById(E.replace(/(^url\(#|\)$)/g,A));N&&N.parentNode.removeChild(N),b["clip-path"]=A,11===document.documentMode&&h.removeAttribute("clip-path"),delete r.clip}}break;case"path":"path"===r.type&&(b.d=s?g.path=e._stopabsolutePath?e.sanitizePath(s):e._pathToAbsolute(s):e._availableAttrs.path,r._.dirty=1,r._.arrows&&("startString"in r._.arrows&&se(r,r._.arrows.startString),"endString"in r._.arrows&&se(r,r._.arrows.endString,1)));break;case"width":if(b[o]=s,r._.dirty=1,!g.fx)break;o="x",s=g.x;case"x":g.fx&&(s=-g.x-(g.width||0));case"rx":if("rx"===o&&"rect"===r.type)break;case"cx":b[o]=s,r.pattern&&oe(r),r._.dirty=1;break;case"height":if(b[o]=s,r._.dirty=1,!g.fy)break;o="y",s=g.y;case"y":if("text"===r.type)break;g.fy&&(s=-g.y-(g.height||0));case"ry":if("ry"===o&&"rect"===r.type)break;case"cy":b[o]=s,r.pattern&&oe(r),r._.dirty=1;break;case"r":"rect"===r.type?b.rx=b.ry=s:b[o]=s,r._.dirty=1;break;case"src":"image"===r.type&&h.setAttributeNS(T,"href",s);break;case"stroke-width":1===r._.sx&&1===r._.sy||(s/=p(m(r._.sx),m(r._.sy))||1),v._vbSize&&(s*=v._vbSize),S&&0===s&&(s=1e-6),b[o]=s,!a["stroke-dasharray"]&&g["stroke-dasharray"]&&""!==a["stroke-dasharray"]&&j(b,ce(r,g["stroke-dasharray"],a)),r._.arrows&&("startString"in r._.arrows&&e.addArrow&&e.addArrow(r,r._.arrows.startString),"endString"in r._.arrows&&e.addArrow&&e.addArrow(r,r._.arrows.endString,1));break;case"stroke-dasharray":j(b,ce(r,s,a));break;case"fill":if(e._ISURL.test(s)){d=s.split(e._ISURL),i=re("pattern");var M=re("image");i.id=e.getElementID(e.createUUID()),re(i,{x:0,y:0,patternUnits:"userSpaceOnUse",height:1,width:1}),re(M,{x:0,y:0,"xlink:href":d[1]}),i.appendChild(M),V(i,M,d,v),v.defs.appendChild(i),b.fill="url('"+e._url+d[1]+"')",r.pattern=i,r.pattern&&oe(r);break}var D=e.getRGB(s);if(D.error){if(("circle"===r.type||"ellipse"===r.type||"r"!==l(s).charAt())&&ie(r,s)){g.gradient=s;break}}else delete a.gradient,delete g.gradient,!e.is(g["fill-opacity"],"undefined")&&e.is(a["fill-opacity"],"undefined")&&(b["fill-opacity"]=g["fill-opacity"]),r.gradient&&te(r);D[t]("opacity")?(b["fill-opacity"]=D.opacity>1?D.opacity/100:D.opacity,r._.fillOpacityDirty=!0):r._.fillOpacityDirty&&e.is(g["fill-opacity"],"undefined")&&e.is(a["fill-opacity"],"undefined")&&(h.removeAttribute("fill-opacity"),delete r._.fillOpacityDirty);case"stroke":(D=e.getRGB(s)).error?"circle"!==r.type&&"ellipse"!==r.type&&"r"===l(s).charAt()||ie(r,s,"stroke"):(b[o]=D.hex,te(r,void 0,o)),"stroke"===o&&(D[t]("opacity")?(b["stroke-opacity"]=D.opacity>1?D.opacity/100:D.opacity,r._.strokeOpacityDirty=!0):r._.strokeOpacityDirty&&e.is(g["stroke-opacity"],"undefined")&&e.is(a["stroke-opacity"],"undefined")&&(h.removeAttribute("stroke-opacity"),delete r._.strokeOpacityDirty),r._.arrows&&("startString"in r._.arrows&&se(r,r._.arrows.startString),"endString"in r._.arrows&&se(r,r._.arrows.endString,1)));break;case"gradient":("circle"===r.type||"ellipse"===r.type||"r"!==l(s).charAt())&&ie(r,s);break;case"visibility":"hidden"===s?r.hide():r.show();break;case"opacity":s=s>1?s/100:s,b.opacity=s;break;case"fill-opacity":s=s>1?s/100:s,b["fill-opacity"]=s;break;case"shape-rendering":r.attrs[o]=s=F[s]||s||"auto",b[o]=s,h.style.shapeRendering=s;break;case"line-height":case"vertical-align":break;default:"font-size"===o&&(s=u(s,10)+"px"),r._.dirty=1,b[o]=s,n.dashedAttr2CSSMap[o]&&(y[n.dashedAttr2CSSMap[o]]=s)}else o in g&&(delete g[o],h.removeAttribute("src"===o?"href":o));else o in ee&&(s===A&&o in g?(delete g[o],h.removeAttribute(o)):(g[o]=s,y[o]=s));for(o in y)h.style[o]=y[o];for(o in b)h.setAttribute(o,b[o]);"text"===r.type&&!a["_do-not-tune"]&&fe(r,a)}},de=e._updateFollowers=function(){var e,t,r,a=(0,n.getArrayCopy)(arguments),i=_.call(a),o=_.call(a);for(e=0,t=i.followers.length;e<t;e++)(r=i.followers[e].el)[o].apply(r,a)},fe=function(n,a){if("text"===n.type&&(a[t]("text")||a[t]("font")||a[t]("font-size")||a[t]("x")||a[t]("y")||a[t]("line-height")||a[t](r)||a[t]("textpath"))){var i,o,u,f,g,p,m,v,b,y,x,_,S,E,T=n.attrs,M=n.paper.defs,D=n.parent,F=n.node,I=n._oldAttr=n._oldAttr||{baseLineDiff:8,valign:-.5},O=c(a["line-height"]||T["line-height"]),L=a.direction||T.direction||D&&D.attrs&&D.attrs.direction||I.direction||"initial",R=!1,P=!1,V=[],j=[],B=[],z=h||"rtl"!==L?1:2,H=!1,G=!1,W=function(e){return e&&k.test(e)},$=function(e){return e.replace(/\s+/g," ").trim().replace(k," ")};if(a[t]("textpath")){var X,Y,q,K=e.getElementID(e.createUUID()),J=a.textpath,Z=0,Q={};for(var ee in J)J.hasOwnProperty(ee)&&("path"!==ee||"href"in J?Q[ee]=J[ee]:I.textPathStr!==J[ee]?(n.textPathDef?(n.textPathDef.setAttribute("d",J[ee]||A),Q.href="#"+n.textPathDef.getAttribute("id"),Q["xlink:href"]="#"+n.textPathDef.getAttribute("id")):(n.textPathDef=M.appendChild(re("path",{id:K,d:J[ee]||A})),Q.href="#"+K,Q["xlink:href"]="#"+K),I.textPathStr=J[ee]):(Q.href="#"+n.textPathDef.getAttribute("id"),Q["xlink:href"]="#"+n.textPathDef.getAttribute("id")));if(a[t]("text")?(q=e._g.doc.createTextNode(a.text||A),I.pathText=T.text=a.text||A):(q=e._g.doc.createTextNode(I.pathText||I.text||A),I.pathText=I.pathText||I.text||A,delete I.text),a[t](r)?("middle"===a[r]?(Z=.3,I.valign=-.5):"bottom"===a[r]?(Z=.7,I.valign=-1):"top"===a[r]&&(I.valign=0),(Y=re("tspan",{dy:Z+"em"})).appendChild(q),I.tSpan=Y):!I.tSpan||I.tSpan.textContent!==a.text&&"string"==typeof a.text?(Z=-.5===I.valign?.3:-1===I.valign?.7:0,(Y=re("tspan",{dy:Z+"em"})).appendChild(q),I.tSpan=Y):Y=I.tSpan,void 0!==a.text){for(delete I.x,delete I.y,F.removeAttribute("x"),F.removeAttribute("y"),(X=re("textPath",Q)).appendChild(Y||q);F.firstChild;)F.removeChild(F.firstChild);F.appendChild(X)}}else{if(I.direction=L,n.textPathDef&&M&&(n.textPathDef.parentNode.removeChild(n.textPathDef),delete n.textPathDef),delete I.txtNode,delete I.tSpan,delete I.textPathStr,O||(O=1.2*(i=(i=a.fontSize||a["font-size"]||T["font-size"]||D&&D.attrs&&D.attrs.fontSize)?i.toString().replace("px",A):10)),(a[t]("text")||I.pathText)&&(S=e.is(a.text,"array")?a.text.join("<br>"):null==a.text?I.pathText:a.text,delete I.pathText,(S=S.toString())!==I.text&&(G=!0,S&&C.test(S)&&(S=S.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;|&#034;/g,'"').replace(/&#039;/g,"'").replace(/&<br\/>lt;|&l<br\/>t;|&lt<br\/>;/g,"<<br/>").replace(/&<br\/>gt;|&g<br\/>t;|&gt<br\/>;/g,"><br/>")),S=S.replace(/<u>/g,"<under>").replace(/<\/u>/g,"</under>").replace(/<b>/g,"<bold>").replace(/<\/b>/g,"</bold>").replace(/<strong>/g,"<bold>").replace(/<\/strong>/g,"</bold>").replace(/<em>/g,"<em>").replace(/<\/em>/g,"</em>").replace(/<i>/g,"<em>").replace(/<\/i>/g,"</em>").replace(/<strike>/g,"<strike>").replace(/<\/strike>/g,"</strike>").replace(/<s>/g,"<strike>").replace(/<\/s>/g,"</strike>").replace(/<del>/g,"<strike>").replace(/<\/del>/g,"</strike>").replace(/<sub>/g,"<sub>").replace(/<\/sub>/g,"</sub>").replace(/<sup>/g,"<sup>").replace(/<\/sup>/g,"</sup>"),I.text=T.text=S,w.test(S)?(I.noTSpan&&(I.noTSpan=!(E=!0)),m=(b=l(S).split(w)).length):(E=!0,I.noTSpan=!0,m=1),I.lineCount!==m&&(I.lineCount=m,H=!0))),O!==I.lineHeight&&(I.lineHeight=O,I.baseLineDiff=.75*O,H=!0),E)for(;F.firstChild;)F.removeChild(F.firstChild);if(I.lineCount>1){if("pre"===F.style.whiteSpace&&(F.style.whiteSpace=""),u={},I.tspanAttr||(I.tspanAttr={},I.tspan0Attr={}),I.tspanAttr.dy!==I.lineHeight&&(I.tspanAttr.dy=u.dy=I.lineHeight,P=!0),a[t]("x")&&I.tspanAttr.x!==a.x&&(I.tspan0Attr.x=I.tspanAttr.x=u.x=T.x,P=!0),G)for(_=F.childNodes,f=0;f<m;f++){if(x=_[f*z],V=U(b[f],B),x){if(x.innerHTML=A,h)for(;x.firstChild;)x.removeChild(x.firstChild);P&&re(x,f?u:I.tspan0Attr)}else x=re("tspan",f?I.tspanAttr:I.tspan0Attr),F.appendChild(x),h||"rtl"!==L||((y=re("tspan",s)).appendChild(e._g.doc.createTextNode("i")),F.appendChild(y));if(b[f]||(x.setAttributeNS("http://www.w3.org/XML/1998/namespace","xml:space","preserve"),b[f]=N),W(b[f])?(b[f]=$(b[f]),x.style.whiteSpace="pre"):"pre"===x.style.whiteSpace&&(x.style.whiteSpace=""),V.length)for(var te=0;te<V.length;te++)x.appendChild(V[te]);else x.appendChild(e._g.doc.createTextNode(b[f]));if(B.length)for(g=0;g<B.length;g++)(p=n.paper.text({display:"none"})).node=B[g].tspan,n.abbrArr||(n.abbrArr=[]),n.abbrArr.push({el:p,title:B[g].title})}else if(P)for(v=(_=F.childNodes).length,f=0;f<v;f+=z)re(_[f],f?u:I.tspan0Attr);if(v=m*z,F.childNodes.length>v)for(f=F.childNodes.length-1;f>=v;f-=1)F.removeChild(F.childNodes[f])}else if(G){if(W(S)?(S=$(S),F.style.whiteSpace="pre"):"pre"===F.style.whiteSpace&&(F.style.whiteSpace=""),(j=U(S,B)).length)for(var ne=0;ne<j.length;ne++)F.appendChild(j[ne]);else F.appendChild(e._g.doc.createTextNode(S));if(B.length)for(g=0;g<B.length;g++)(p=n.paper.text({display:"none"})).node=B[g].tspan,n.abbrArr||(n.abbrArr=[]),n.abbrArr.push({el:p,title:B[g].title})}a[r]&&(o=d[T[r]]||0)!==I.valign&&(I.valign=o,H=!0),H&&(I.shift=I.baseLineDiff+I.lineCount*I.lineHeight*I.valign,R=!0),!a.y&&0!==a.y||I.y===a.y||(I.y=T.y,R=!0),!R||!I.y&&0!==I.y||!I.shift&&0!==I.shift||re(F,{y:Math.round(I.y+I.shift)})}}},he=function(t,r,n){var a=this,i=n||r;
/*! dontAppend && */i.canvas&&i.canvas.appendChild(t),a.node=a[0]=t,t.raphael=!0,t.raphaelid=a.id=e._oid++,a.matrix=e.matrix(),a.realPath=null,a.attrs=a.attrs||{},a.followers=a.followers||[],a.paper=r,a.ca=a.customAttributes=a.customAttributes||new r._CustomAttributes,a._={transform:[],sx:1,sy:1,deg:0,dx:0,dy:0,dirty:1},a.parent=i,!i.bottom&&(i.bottom=a),a.prev=i.top,i.top&&(i.top.next=a),i.top=a,a.next=null},ge=function(e,t,r){var n=r?"pageY":"pageX";return Math.abs(t[n]-e[n])},pe=e.storeHandlers=function(e,t,r){e._actualListners||(e._actualListners=[]),e._derivedListeners||(e._derivedListeners=[]),e._actualListners.push(t),e._derivedListeners.push(r)},me=function(e,t){var r,n=e._actualListners.indexOf(t);return-1!==n&&(r=e._derivedListeners[n],e._actualListners.splice(n,1),e._derivedListeners.splice(n,1)),r},ve=e.el;he.prototype=ve,ve.constructor=he,e._engine.getNode=function(e){var t=e.node||e[0].node;return t.titleNode||t},e._engine.getLastNode=function(e){var t=e.node||e[e.length-1].node;return t.titleNode||t},ve.rotate=function(e,t,r){var n,a=this;return a.removed||(de(a,"rotate",e,t,r),(e=l(e).split(x)).length-1&&(t=c(e[1]),r=c(e[2])),e=c(e[0]),null==r&&(t=r),null!=t&&null!=r||(t=(n=a.getBBox(1)).x+n.width/2,r=n.y+n.height/2),a.transform(a._.transform.concat([["r",e,t,r]]))),a},ve.scale=function(e,t,r,n){var a,i=this;return i.removed||(de(i,"scale",e,t,r,n),(e=l(e).split(x)).length-1&&(t=c(e[1]),r=c(e[2]),n=c(e[3])),e=c(e[0]),null==t&&(t=e),null==n&&(r=n),null!=r&&null!=n||(a=i.getBBox(1)),r=null==r?a.x+a.width/2:r,n=null==n?a.y+a.height/2:n,i.transform(i._.transform.concat([["s",e,t,r,n]]))),i},ve.translate=function(e,t){var r=this;return r.removed||(de(r,"translate",e,t),(e=l(e).split(x)).length-1&&(t=c(e[1])),e=c(e[0])||0,t=+t||0,r.transform(r._.transform.concat([["t",e,t]]))),r},ve.transform=function(t){var r,n=this,a=n._;return null==t?a.transform:(e._extractTransform(n,t),n.clip&&!a.clipispath&&re(n.clip,{transform:n.matrix.invert()}),n.pattern&&oe(n),n.node&&re(n.node,{transform:n.matrix}),1===a.sx&&1===a.sy||(r=n.attrs["stroke-width"])&&n.attr({"stroke-width":r}),n)},ve.hide=function(){var e=this;return de(e,"hide"),!e.removed&&e.paper.safari(e.node.style.display="none"),e},ve.show=function(){var e=this;return de(e,"show"),!e.removed&&e.paper.safari(e.node.style.display=A),e},ve.remove=function(){if(!this.removed&&this.parent.canvas){var t,r=this,n=e._engine.getNode(r),a=r.paper,i=a.defs;for(a.__set__&&a.__set__.exclude(r),E.unbind("raphael.*.*."+r.id),r.gradient&&i&&te(r),r["stroke-gradient"]&&i&&te(r,void 0,"stroke"),r.textPathDef&&i&&(r.textPathDef.parentNode.removeChild(r.textPathDef),delete r.textPathDef);t=r.followers.pop();)t.el.remove();for(;t=r.bottom;)t.remove();if(r._drag&&r.undrag(),r.events)for(;t=r.events.pop();)t.unbind();for(t in r.parent.canvas.contains(n)&&r.parent.canvas.removeChild(n),r.removeData(),delete a._elementsById[r.id],e._tear(r,r.parent),r)r[t]=typeof r[t]===o?e._removedFactory(t):null;r.removed=!0}},ve._getBBox=function(){var e,t,a,i=this,o=i.node,s={},l=i.attrs,c="text"===i.type;h&&c?e=(0,n.showRecursively)(i):"none"===o.style.display&&(i.show(),a=!0);try{s=o.getBBox(),c&&(s.x===undefined&&(s.isCalculated=!0,t=l["text-anchor"],s.x=(l.x||0)-s.width*("start"===t?0:"middle"===t?.5:1)),s.y===undefined&&(s.isCalculated=!0,t=l[r],s.y=(l.y||0)-s.height*("bottom"===t?1:"middle"===t?.5:0)))}catch(u){}finally{s=s||{}}return h&&c?e&&e():a&&i.hide(),s},ve.attr=function(r,n){if(this.removed)return this;var a,i,s,l,c,u,d,f,h=this.attrs,g={},p=this._invokedCa||(this._invokedCa={}),m=this.ca;if(null==r){var v={};for(a in h)h[t](a)&&(v[a]=h[a]);return v.gradient&&"none"===v.fill&&(v.fill=v.gradient)&&delete v.gradient,v.transform=this._.transform,v.visibility="none"===this.node.style.display?"hidden":"visible",v}if(null==n){if(e.is(r,"object"))l=r;else if(e.is(r,"string"))return"fill"===r&&"none"===h.fill&&h.gradient?h.gradient:"transform"===r?this._.transform:"visibility"===r?"none"===this.node.style.display?"hidden":"visible":r in h?h[r]:e.is(m[r],o)?m[r].def:e._availableAttrs[r]}else(l={})[r]=n;if(!e.stopPartialEventPropagation)for(a in l)E("raphael.attr."+a+"."+this.id,this,l[a],a);for(a in l)if((f=m[a])&&!p[a]&&e.is(f,o)){for(c in p[a]=!0,u=f.apply(this,[].concat(l[a])),p[a]=!1,u)g[c]=u[c];h[a]=l[a]}else g[a]=l[a];for(ue(this,g),i=0,s=this.followers.length;i<s;i++)(d=this.followers[i]).cb&&!d.cb.call(d.el,g,this)||d.el.attr(g);return this},ve.pinchstart=function(t,r){var n=this,a={},i=function(i){if(i.touches&&2===i.touches.length){var o=i.touches[0],s=i.touches[1];n._blockDrag=!0,i&&i.preventDefault(),e.makeSelectiveCopy(a,i),a.data={finger0:o,finger1:s,distanceX:ge(o,s),distanceY:ge(o,s,!0)},t.call(r||n,a)}else n._blockDrag=!1};pe(n,t,i),n.node.addEventListener("touchstart",i)},ve.unpinchstart=function(e){var t=me(this,e);this.__blockDrag=!1,this._pinchDragStarted=!1,t&&this.node.removeEventListener("touchstart",t)},ve.pinchmove=function(t,r){var n=this,a={},i=function(i){if(i.touches&&2===i.touches.length){var o=i.touches[0],s=i.touches[1];i&&i.preventDefault(),n._pinchDragStarted=!0,e.makeSelectiveCopy(a,i),a.data={finger0:o,finger1:s,distanceX:ge(o,s),distanceY:ge(o,s,!0)},t.call(r||n,a)}};pe(n,t,i),n.node.addEventListener("touchmove",i)},ve.unpinchmove=function(e){var t=me(this,e);t&&this.node.removeEventListener("touchmove",t)},ve.pinchend=function(e,t){var r=this,n=function(n){r._pinchDragStarted&&(r._pinchDragStarted=!1,e.call(t||r,n))};pe(r,e,n),r.node.addEventListener("touchend",n)},ve.unpinchend=function(e){var t=me(this,e);this._pinchDragStarted=!1,t&&this.node.removeEventListener("touchend",t)},ve.pinch=function(e,t,r){ve.pinchstart.call(this,e),ve.pinchin.call(this,t),ve.pinchend.call(this,r)},ve.unpinch=function(e,t,r){ve.unpinchstart.call(this,e),ve.unpinchin.call(this,t),ve.unpinchend.call(this,r)},ve.fcwheel=function(t,r){var n=this,a={},i=function(i){i&&i.preventDefault(),e.makeSelectiveCopy(a,i),t.call(r||n,a)};pe(n,t,i),n.node.addEventListener("wheel",i)},ve.fcunwheel=function(e){var t=me(this,e);t&&this.node.removeEventListener("wheel",t)},ve.on=function(t,r,n){if(r&&t){var a,i,o=this,s=t.match(/fc-/),l=r;if(this.removed)return this;switch(o._actualListners||(o._actualListners=[]),o._derivedListeners||(o._derivedListeners=[]),t){case"fc-dragstart":return o.drag(null,r),o;case"fc-dragmove":return o.drag(r),o;case"fc-dragend":return o.drag(null,null,r),o;case"fc-dbclick":return o.dbclick(r,n),o;case"fc-pinchstart":return o.pinchstart(r,n),o;case"fc-pinchmove":return o.pinchmove(r,n),o;case"fc-pinchend":return o.pinchend(r,n),o;case"fc-click":return o.fcclick(r,n),o;case"fc-wheel":return o.fcwheel(r,n),o}return s&&(t=t.replace(/fc-/,"")),s&&R&&(i=t,t=(L?e.safePointerEventMapping[t]:H[t])||t,"mouseout"===i&&(l=function(e){L&&R&&!e.isPrimary||(B.elementInfo.push({el:n||o,callback:r}),B.srcElement=e.srcElement||e.target)},t=L?"pointerover":"touchstart")),this._&&this._.RefImg&&("load"===t||"error"===t)?(a=this._.RefImg,l=function(e){!o.removed&&r.call(o,e)}):a=this.node,l===r&&(l=function(e){(!L||!R||e.isPrimary)&&r.call(n||o,e)}),o._actualListners.push(r),o._derivedListeners.push(l),a.addEventListener?a.addEventListener(t,l):a["on"+t]=l,this}},ve.off=function(t,r){var n,a,i,o=r,s=t.match(/fc-/);if(this.removed||!this._actualListners||!t||!r)return this;switch(t){case"fc-dragstart":return this.undragstart(r),this;case"fc-dragmove":return this.undragmove(r),this;case"fc-dragend":return this.undragend(r),this;case"fc-dbclick":return this.undbclick(r),this;case"fc-pinchstart":return this.unpinchstart(r),this;case"fc-pinchmove":return this.unpinchmove(r),this;case"fc-pinchend":return this.unpinchend(r),this;case"fc-click":return this.fcunclick(r),this;case"fc-wheel":return this.fcunwheel(r),this}return s&&(t=t.replace(/fc-/,"")),o=r,s&&R&&(n=t,t=(L?e.safePointerEventMapping[t]:H[t])||t,"mouseout"===n&&(t=L?"pointerover":"touchstart")),i=this._&&this._.RefImg?this._.RefImg:this.node,-1!==(a=this._actualListners.indexOf(o))&&(o=this._derivedListeners[a],this._actualListners.splice(a,1),this._derivedListeners.splice(a,1)),i.removeEventListener?i.removeEventListener(t,o):i["on"+t]=null,this},e._engine.path=function(e,t,r){var n=re("path"),a=new he(n,e,r);return a.type="path",t&&a.attr(t),a},e._engine.group=function(e,t,r,n){var a=re("g"),i=new he(a,e,r);return i.type="group",i.canvas=i.node,i.top=i.bottom=null,i._id=t||A,t&&(n?a.setAttribute("class","raphael-group-"+t):a.setAttribute("class","raphael-group-"+i.id+"-"+t)),i},e._engine.circle=function(e,t,r){var n=re("circle"),a=new he(n,e,r);return a.type="circle",t&&a.attr(t),a},e._engine.rect=function(e,t,r){var n=re("rect"),a=new he(n,e,r);return a.type="rect",t.rx=t.ry=t.r,t&&a.attr(t),a},e._engine.ellipse=function(e,t,r){var n=re("ellipse"),a=new he(n,e,r);return a.type="ellipse",t&&a.attr(t),a},e._engine.image=function(e,t,r){var n=re("image"),a=new he(n,e,r,!0);return a._.group=r||e,a.type="image",n.setAttribute("preserveAspectRatio","none"),t&&a.attr(t),a},e._engine.text=function(e,t,r,n){var a=re("text"),i=new he(a,e,r);return i.type="text",n&&i.css&&i.css(n,undefined,!0),t&&i.attr(t),i},e._engine.setSize=function(e,t){return this.width=e||this.width,this.height=t||this.height,this.canvas.setAttribute("width",this.width),this.canvas.setAttribute("height",this.height),this._viewBox&&this.setViewBox.apply(this,this._viewBox),this},e._engine.create=function(){var t,r=e._getContainer.apply(0,arguments),n=r&&r.container,a=r.x,i=r.y,o=r.width,s=r.height;if(!n)throw new Error("SVG container not found.");var l,c=re("svg"),u="overflow:hidden;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-moz-user-select:-moz-none;-khtml-user-select:none;-ms-user-select:none;user-select:none;-o-user-select:none;cursor:default;vertical-align:middle;";return R&&(e.isIE10?u+="-ms-touch-action:pan-x,pan-y;":u+="touch-action:pan-x,pan-y;"),a=a||0,i=i||0,re(c,{height:s=s||342,version:1.1,width:o=o||512,xmlns:M}),1===n?(c.style.cssText=u+"position:absolute;left:"+a+"px;top:"+i+"px",(n=e._g.doc.body).appendChild(c),l=1):(c.style.cssText=u+"position:relative",n.firstChild?n.insertBefore(c,n.firstChild):n.appendChild(c)),(t=new e._Paper).width=o,t.height=s,t.canvas=c,t.container=n,re(c,{id:"raphael-paper-"+t.id}),t.clear(),t._left=t._top=0,l&&(t.renderfix=function(){}),t.renderfix(),t},e._engine.setViewBox=function(e,t,r,n,a){E("raphael.setViewBox",this,this._viewBox,[e,t,r,n,a]);var i,o,s=p(r/this.width,n/this.height),l=this.top,c=a?"meet":"xMinYMin";if(null==e?(this._vbSize&&(s=1),delete this._vbSize,i="0 0 "+this.width+N+this.height):(this._vbSize=s,i=e+N+t+N+r+N+n),re(this.canvas,{viewBox:i,preserveAspectRatio:c}),s)for(;l;)o="stroke-width"in l.attrs?l.attrs["stroke-width"]:1,l.attr({"stroke-width":o}),l._.dirty=1,l._.dirtyT=1,l=l.prev;return this._viewBox=[e,t,r,n,!!a],this},e.prototype.detachPaper=function(){!1!==this._detached&&(this.container.removeChild(this.canvas),this._detached=!0)},e.prototype.attachPaper=function(){this._detached&&(this.container.appendChild(this.canvas),this._detached=!1)},e.prototype.renderfix=function(){var e,t=this.canvas,r=t.style;try{e=t.getScreenCTM()||t.createSVGMatrix()}catch(i){e=t.createSVGMatrix()}var n=-e.e%1,a=-e.f%1;(n||a)&&(n&&(this._left=(this._left+n)%1,r.left=this._left+"px"),a&&(this._top=(this._top+a)%1,r.top=this._top+"px"))},e.prototype._desc=function(t){var r=this.desc;if(r)for(;r.firstChild;)r.removeChild(r.firstChild);else this.desc=r=re("desc"),this.canvas.appendChild(r);r.appendChild(e._g.doc.createTextNode(e.is(t,"string")?t:"Created with Red Raphaël "+e.version))},e.prototype.clear=function(){var e;for(E("raphael.clear",this);e=this.bottom;)e.remove();for(e=this.canvas;e.firstChild;)e.removeChild(e.firstChild);this.bottom=this.top=null,e.appendChild(this.desc=re("desc")),e.appendChild(this.defs=re("defs"))},e.prototype.remove=function(){var t;for(E("raphael.remove",this);t=this.bottom;)t.remove();for(t in this.defs&&this.defs.parentNode.removeChild(this.defs),this.desc&&this.desc.parentNode.removeChild(this.desc),this.canvas.parentNode&&this.canvas.parentNode.removeChild(this.canvas),this)this[t]=typeof this[t]===o?e._removedFactory(t):null;this.removed=!0},e.prototype.setHTMLClassName=function(){}}var be};var n=r(227)},function(e,t,r){"use strict";function n(e){var t={data:{}};if(!e)return t;if("string"==typeof e)try{t.data=JSON.parse(e)}catch(r){t.error=r}else t.data=e;return t}function a(e){if(!e||!e.isRaw)return this.getChartData({format:"json",isRaw:0});if(e.isRaw&&parseInt(e.isRaw,10)){var t=parseInt(e.isRaw,10);return this.getChartData({format:"json",isRaw:t})}return this.getChartData("json")}function i(e){this.setChartData(e,"json")}t.__esModule=!0,t["default"]=void 0;var o={extension:function(e){return e&&(e.prototype.setJSONData=i),e&&(e.prototype.getJSONData=a),{format:"json",toJSON:n,fromJSON:n}},name:"JSON",type:"transcoder",requiresFusionCharts:!0};t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=h(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(236)),i=n(r(262)),o=n(r(263)),s=n(r(264)),l=n(r(265)),c=n(r(266)),u=n(r(267)),d=n(r(271)),f=n(r(272));function h(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(h=function(e){return e?r:t})(e)}var g={oneInAFrame:!0},p={extension:function(e){var t=e.getDep("redraphael","plugin"),r={};t.fn._elementFromEvent=function(e){if(!e||this.removed)return null;var t=e,n=t.srcElement||t.target||(t=t.originalEvent)&&(t.srcElement||t.target)||r;return"tspan"===n.nodeName&&(n=n.parentNode),this.getById(n.raphaelid)},t.requestAnimFrame=a["default"].addJob&&function(e){a["default"].addJob(e,a.priorityList.animation,g)},t.instantRequestAnimFrame=a["default"].addJob&&function(e){a["default"].addJob(e,a.priorityList.instant)},(0,d["default"])(t),(0,i["default"])(t),(0,o["default"])(t),(0,s["default"])(t),(0,l["default"])(t),(0,c["default"])(t),(0,u["default"])(t),(0,f["default"])(t)},name:"redraphaelExt",type:"plugin",requiresFusionCharts:!0};t["default"]=p},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t,r,a=e.eve,i=e._g,o=e.fn,s=e.el,l=/[, ]+/,c="",u=" ",d=/\B([A-Z]{1})/g,f="fusioncharts-raphael-stylesheet";(r=(t=function(e){this.styleSheet=c,this.rules={},this.ns=e||c}).prototype).getSheet=function(){var t=this.node;return this.styleSheet=r.getStyleSheet(f),this.styleSheet||((t=this.node=i.doc.createElement("style")).setAttribute("id",e.format("raphael-stylesheet-{0}",e._oid++)),t.setAttribute("type","text/css"),t.setAttribute("title",f),(i.doc.head||i.doc.getElementsByTagName("head")[0]).appendChild(this.node),this.styleSheet=r.getStyleSheet(f)),this.styleSheet},r.getStyleSheet=function(e){for(var t,r=i.doc.styleSheets,n=r.length;n--;)if((t=r[n]).title===e)return t},r.applyCSSRule=function(e,t){var r,n=this.styleSheet;if(!n){if(!e||!t)return;n=this.getSheet()}r=(n.rules||n.cssRules||{}).length||0,n.insertRule?n.insertRule(e+"{"+t+"}",r):n.addRule&&n.addRule(e,t,r)},r.removeCSS=function(e){var t,r=this.styleSheet,n=r.rules||r.cssRules||{},a=n.length||0,i=e;for(i=i||this.ns;a--;)t=n[a],new RegExp(i).test(t.selectorText)&&(r.removeRule?r.removeRule(a):r.deleteRule(a))},r.destroy=function(){this.removeCSS(),delete this.node,delete this.styleSheet,delete this.ns,delete this.rules},r.clear=function(){this.removeCSS(),this.rules={}},r.add=function(e,t,r){var n,a=c,i=this.rules[e]||(this.rules[e]={}),o=r?c:"\t",s=r?":":": ";for(n in t)(i[n]=t[n])&&(a+=o+n.replace(d,"-$1").toLowerCase()+s+i[n]+";");this.applyCSSRule(e,a)},r.render=function(){this.setCssText()},r.setCssText=function(e){var t,r,n=e?c:"\t",a=e?":":": ",i=c,o=c;for(t in this.rules){for(r in i=c,o=t.replace(/(^|\,)/g,"$1"+this.ns+u),t=this.rules[t])t[r]&&(i+=n+r.replace(d,"-$1").toLowerCase()+a+t[r]+";");this.applyCSSRule(o,i)}},a.on("raphael.new",(function(){this._stylesheet=this._stylesheet||new t,this.cssNamespace(c)})),a.on("raphael.remove",(function(){this._stylesheet&&this._stylesheet.destroy(),delete this._stylesheet})),o.cssNamespace=function(t){return arguments.length&&(this._stylesheet.ns=e.format("{0}#raphael-paper-{1}",t&&t+u||c,this.id)),this._stylesheet.ns},o.cssAddRule=function(e,t){if(1===arguments.length&&"object"==typeof e){for(var r in e)this.cssAddRule(r,e[r]);return this}return this._stylesheet.add(e,t),this},o.cssRender=function(){return e.svg&&this._stylesheet.render(),this},o.cssClear=function(){return this._stylesheet.clear(),this},e.ca["class"]=function(t){var r,n,a,i,o=this,s=t,l=o.node,d=o.paper,f="."+s,h=d._stylesheet&&d._stylesheet.rules,g=o.parent,p=o.attrs,m={};if(e.svg)s=s||c,l.setAttribute("class","group"===o.type&&o._id?"raphael-group-"+o.id+"-"+o._id+u+s:s);else if(e.vml&&(r=l.className="group"===o.type?s&&o._id+u+s||o._id:"rvml "+s,l.className=r?r+" fusioncharts-div":"fusioncharts-div",f&&h)){for(i in n=h[f])"color"===i&&"text"===o.type&&(i="fill"),!p[i]&&(m[i]=n[i]);for(;g&&g.attr;){if(a=g.attr("class"))for(i in n=h[f="."+a+u+f])"color"===i&&"text"===o.type&&(i="fill"),!p[i]&&!m[i]&&(m[i]=n[i]);g=g.parent}o.css(m)}},s.css=function(t,r,n){var i,o,s,c,u,d,f,h=t;if(this.removed)return this;if(this.styles||(this.styles={}),void 0===r&&e.is(h,"string")){for(s={},d=0,f=(i=h.split(l)).length;d<f;d++)(h=i[d])in this.styles&&(s[h]=this.styles[h]);return f-1?s:s[i[0]]}if(void 0===r&&e.is(h,"array")){for(s={},d=0,f=h.length;d<f;d++)s[h[d]]=this.styles(h[d]);return s}for(d in void 0!==r?(o={})[h]=r:h&&e.is(h,"object")&&(o=h),u={},o)c=d.replace(/\B([A-Z]{1})/g,"-$1").toLowerCase(),e._availableAttrs.hasOwnProperty(c)||"color"===c?("color"===c&&"text"===this.type&&(c="fill"),u[c]=o[d],u.dirty=!0):(a("raphael.css."+c+"."+this.id,this,o[d],c),this.node.style[c]=o[d],this.styles[c]=o[d]);for(d=0,f=this.followers.length;d<f;d++)this.followers[d].el.attr(o);return u.hasOwnProperty("dirty")&&(delete u.dirty,n&&(u["_do-not-tune"]=!0),this.attr(u)),this},s.removeCSS=function(t){var r,a,i,o=t;if(!o&&(o=n.appliedCSS),this.removed)return this;if(e.is(o,"string")&&(o=o.split(",")),e.is(o,"array"))for(i=o.length,a=0;a<i;a++)r=o[a].replace(/\B([A-Z]{1})/g,"-$1").toLowerCase(),this.node.removeAttribute(r),this.node.style[r]="";return this}};var n=r(224)},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t,r=window,a=Math.sqrt,i=r.parseFloat,o=r.parseInt,s="none",l="rgba(0,0,0,1)",c=r.SVGFilterElement||r.SVGFEColorMatrixElement&&2===r.SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE,u={"drop-shadow":"drop-shadow",stroke:"stroke",fill:"fill","stroke-width":"stroke-width","stroke-opacity":"stroke-opacity","stroke-linecap":"stroke-linecap","stroke-linejoin":"stroke-linejoin","shape-rendering":"shape-rendering",opacity:"opacity","fill-opacity":"fill-opacity"};e.svg?(c&&(e.filterShadow=function(t,r){var o,s,c,u,d=t.dx||1,f=t.dy||1,h=t.spread||3,g=t.color||"rgb(64,64,64)",p=t.paper,m=p.cacheShadows||(p.cacheShadows={}),v=t.id||"drop-shadow-"+(r?"layered":"non-layered")+"-"+[d,f,h,g].join(" ")+p.container.id,b=t.id||e.getElementID(v.replace(/[\(\)\s%:,\xb0#]/g,"_")),y=!!(t.id?e._g.doc.getElementById(b):m[v]);return p&&!y?((g=e.color(g)).error&&(g=e.color(l)),c=(0,n.pluck)(g.opacity,1),c=t.opacity||c,s=(o=p.addDefs({filter:{tagName:"filter",id:b,y:"-1000%",x:"-1000%",width:"2000%",height:"2000%",children:[{tagName:"feOffset",result:"offOut","in":"SourceGraphic",dx:i(d),dy:i(f)},{tagName:"feColorMatrix",result:"matrixOut","in":"offOut",type:"matrix",values:"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "+c+" 0"},{tagName:"feGaussianBlur",result:"blurOut","in":"matrixOut",stdDeviation:r?1:a(i(h))},{tagName:"feComposite","in":"SourceGraphic",in2:"blurOut",operator:"over"}]}})).filter.children,u=m[v]={use:1,hash:v,id:b,filter:o.filter.element,offset:s[0].element,matrix:s[1].element,blur:s[2].element,blend:s[3].element}):(u=m[v]).use+=1,u},e.el.dropshadow=function(r,n,a,i,o,l){var c,u,d,f,h,g,p,m,v=this,b=v._.shadowFilter,y=v.paper,x=y.cacheShadows||(y.cacheShadows={}),w="drop-shadow"+[r,n,a,i].join(" ");for(h=f=.05*o,p=1;p<=3;p++)h+=f*p*(o-h);if(u=(c=l?v.shadowElem||v.clone({fill:s,stroke:"rgb(51, 51, 51)","stroke-width":v.attr("stroke-width")||1,opacity:h},l).translate(r,n).follow(v,t,!l&&"before"):v).shadowElem&&c.shadowElem.node||c.node,r===s){if(b){if(b.use-=1,u.removeAttribute("filter"),v.shadowElem&&v.shadowElem.attr("opacity",0),!b.use){for(d in w=b.hash,b)(m=b[d]).parentNode&&m.parentNode.removeChild(m),delete b[d];m=null,delete x[w]}b=null,delete v._.shadowFilter}}else l&&!v.shadowElem&&(g=!0),l&&(v.shadowElem=c),b=b&&x[w]?x[w]:v._.shadowFilter=e.filterShadow({paper:y,dx:r,dy:n,spread:a,color:i,opacity:!l&&h},!!l),!g&&v.shadowElem&&v.shadowElem.attr("opacity",h),u.setAttribute("filter",'url("'+e._url+"#"+b.id+'")');return this}),t=function(e,t){var r,n,a=this,i={};for(n in e)switch(u[n]&&(i[n]=e[n],delete e[n]),n){case"transform":(r=t.matrix.clone()).translate(a.__shadowx,a.__shadowy),a.transform(r.toTransformString());break;case"stroke-width":e[n]=i[n]||1}for(n in a.attr(e),i)e[n]=i[n]},e.ca["drop-shadow"]=function(r,a,i,c,u,d){var f,h,g,p,m,v,b,y=this,x=y._.shadows||(y._.shadows=[]),w=r,C=a,k=c;if(y.__shadowblocked)return!1;if(w===s)for(;h=x.pop();)h.remove();else for((k=e.color(k)).error&&(k=e.color(l)),u instanceof Array?(m=u[0],v=u[1]):m=v=u,m=1/(0,n.pluck)(m,1),v=1/(0,n.pluck)(v,1),w=(0,n.pluck)(w,1)*m,C=(0,n.pluck)(C,1)*m,f=.05*(0,n.pluck)(k.opacity,1),g=o(y.attr("stroke-width")||1,10)+6,(p=y.matrix.clone()).translate(w,C),b=1;b<=3;b++)(h=(x[b-1]||y.clone().follow(y,t,!d&&"before")).attr({stroke:k.hex,"stroke-opacity":f*b,opacity:"1","stroke-width":(g-2*b)*v,transform:p.toTransformString(),"stroke-linecap":"round","stroke-linejoin":"round",fill:s})).__shadowlevel=b,h.__shadowscale=v,h.__shadowx=w,h.__shadowy=C,d&&d.appendChild(h),x.push(h);return!1},e.el.shadow=function(t,r,a,i){var o,l=t,c=r,u=a,d=i;if(u&&u.constructor===e.el.constructor&&(d=u,u=void 0),"object"==typeof l&&(c&&c.constructor===e.el.constructor&&(d=c),c=l.opacity,u=l.scalefactor,o=void 0!==l.useFilter?!!l.useFilter:!n.isIE9,l=void 0===l.apply?!!c:l.apply),void 0===c&&(c=1),this.dropshadow){if(o&&!this.ca.hasOwnProperty("drop-shadow"))return l&&this.dropshadow(1,1,3,"rgb(64,64,64)",c,d)||this.dropshadow(s),this;this._.shadowFilter&&this.dropshadow(s)}return this.attr("drop-shadow",l?[1,1,3,"rgba(64,64,64,"+c+")",u,d]:s)}):e.vml?(e.ca["drop-shadow"]=function(t,r,a,o,c,u){var d,f,h,g,p=this,m=p._.shadow,v=t,b=r,y=o;return p.isShadow||(v===s?m&&(m=p._.shadow=m.remove()):(m||(m=p._.shadow=p.clone(),u&&u.appendChild(m.follow(p))||m.follow(p,void 0,"before"),m.attr({fill:"none","fill-opacity":.5,"stroke-opacity":1}).isShadow=!0,m.attr("stroke-width")<=0&&m.attr("stroke-width",1)),f=(d=m.node.runtimeStyle).filter.replace(/ progid:\S+Blur\([^\)]+\)/g,""),(y=e.color(y)).error&&(y=e.color(l)),g=(0,n.pluck)(y.opacity,1)/5,h=c instanceof Array?c[0]:c,h=1/(0,n.pluck)(c,1),v=(0,n.pluck)(v,1)*h,b=(0,n.pluck)(b,1)*h,m.translate(v,b),d.filter=f+" progid:DXImageTransform.Microsoft.Blur(pixelRadius="+i(.4*a)+" makeShadow=True Color="+y.hex+' shadowOpacity="'+g+'");')),!1},e.el.shadow=function(t,r,n,a){var i=t,o=r,l=n,c=a;return l&&l.constructor===e.el.constructor&&(c=l,l=void 0),"object"==typeof i&&(o&&"group"===o.type&&(c=o),o=i.opacity,l=i.scalefactor,i=void 0===i.apply?!!o:i.apply),void 0===o&&(o=1),this.attr("drop-shadow",i||!o?[1,1,5,"rgba(64,64,64,"+o+")",l,c]:s)}):e.canvas&&(e.el.shadow=function(){return this})};var n=r(224)},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){e.svg?(e.createOutlineFilter=function(t){var r,n,a,i,o,s=t.paper,l=t.rgbObj,c=t.colorMapText,u=s.outlineFilterCaches;return r="text-outline-"+[c,a=s.filterColorMap[c]=function(e){var t=e.R,r=e.G,n=e.B;return(299*t+587*r+114*n)/1e3>123?"darkFilter":"brightFilter"}(l)].join(" "),n=e.getElementID(r.replace(/[\(\)\s%:,\xb0#]/g,"_")),o=(i=e.isFirefox?s.addDefs({filter:{tagName:"filter",id:n,children:[{tagName:"feMorphology",result:"DILATED","in":"SourceAlpha",operator:"dilate",radius:e.isIE11?"1.5":"1"},{tagName:"feFlood",result:"FLOOD","flood-color":"darkFilter"===a?"#000000":"#ffffff","flood-opacity":"1"},{tagName:"feComposite",result:"OUTLINE","in":"FLOOD",in2:"DILATED",operator:"in"},{tagName:"feMerge",children:[{tagName:"feMergeNode","in":"OUTLINE"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]}}):s.addDefs({filter:{tagName:"filter",id:n,children:[{tagName:"feColorMatrix",result:"COLORED","in":"SourceGraphic",type:"matrix",values:"darkFilter"===a?"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0":"1 1 1 1 255 1 1 1 1 255 1 1 1 1 255 0 0 0 1 0"},{tagName:"feOffset",dx:"1",dy:"1",result:"OFFSET11","in":"COLORED"},{tagName:"feOffset",dx:"-1",dy:"-1",result:"OFFSET-1-1","in":"COLORED"},{tagName:"feOffset",dx:"-1",dy:"1",result:"OFFSET-11","in":"COLORED"},{tagName:"feOffset",dx:"1",dy:"-1",result:"OFFSET1-1","in":"COLORED"},{tagName:"feMerge",children:[{tagName:"feMergeNode","in":"OFFSET1-1"},{tagName:"feMergeNode","in":"OFFSET-1-1"},{tagName:"feMergeNode","in":"OFFSET11"},{tagName:"feMergeNode","in":"OFFSET-11"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]}})).filter.children,u[a]={hash:r,id:n,filter:i.filter.element,morph:o[0].element,flood:o[1].element,composite:o[2].element,merge:o[3].element}},e.el.outlineText=function(t,r){var a;if(r&&"none"!==r){a=/(^#[0-9A-Fa-f]{6}$)|(^#[0-9A-Fa-f]{3}$)/.test(r)?(0,n.convertColor)(r):r;var i,o,s=this.node,l=this.paper,c=l.outlineFilterCaches||(l.outlineFilterCaches={}),u=l.filterColorMap||(l.filterColorMap={}),d=function(e){var t=e.split("(")[1].split(")")[0].split(",");return{R:+t[0],G:+t[1],B:+t[2]}}(a),f="rgb-"+d.R+"-"+d.G+"-"+d.B;t?(o=(i=u[f])&&c[i]?c[i]:e.createOutlineFilter({rgbObj:d,paper:l,colorMapText:f}),s.setAttribute("filter",'url("'+e._url+"#"+o.id+'")')):s.removeAttribute("filter")}}):e.el.outlineText=function(){return this}};var n=r(224)},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t=/rgba\([\d]+\,[\d]+\,[\d]+\,0\)$/,r=window,a=Math,i=a.cos,o=a.sin,s=a.PI,l=r.parseInt,c=r.parseFloat,u=String,d=Array.prototype.slice,f="hasOwnProperty",h="none",g="M",p="L",m="Z",v="text-bound",b=/\s*\,\s*/g;e&&e._availableAnimAttrs&&e._availableAnimAttrs.cx&&(e._availableAnimAttrs["scroll-position"]=e._availableAnimAttrs.cx);e.define&&e.define([{name:"polypath",polypath:function(){return this.path(void 0,e._lastArgIfGroup(arguments))},ca:{polypath:function(t,r,n,a,u,d){var f,h,v,b,y,x=t,w=r,C=n,k=a,_=u,S=d;if(f=[],x=l(x,10)||0,w=c(w)||0,C=c(C)||0,k=c(k)||0,_=null===_||isNaN(_)?.5*s:e.rad(_),S=null===S||isNaN(S)?0:c(S),b=_,x>2)switch(h=2*s/x,S){case 0:for(v=0;v<x;v++)f.push(p,w+k*i(-b),C+k*o(-b)),b+=h;f[0]=g,f.push(m);break;case 1:for(v=0;v<x;v++)f.push(g,w,C,p,w+k*i(-b),C+k*o(-b)),b+=h;break;default:for(y=k*i(h*=.5)*(1-S),v=0;v<x;v++)f.push(p,w+k*i(-b),C+k*o(-b)),b+=h,f.push(p,w+y*i(-b),C+y*o(-b)),b+=h;f[0]=g,f.push(m)}else 0===k?f.push(g,w,C,p,w,C,m):f.push(g,w-k,C,"A",k,k,0,0,0,w+k,C,"A",k,k,0,0,0,w-k,C,m);return{path:f}},r:function(e){var t=this.attrs.polypath;return t[3]=e,this.attr("polypath",t),!1}}}]),e.ca[v]=function(r,n,a,i,o,s,l){var c=this,u=c.paper,d=c._.textbound,f=a,g=o;if(this._origOpacity=void 0!==l?l:1,"text"===this.type)return n&&n!==h&&!t.test(n)||r&&r!==h&&!t.test(r)?(c.attrs[v]=arguments,(!f||!e.is(f,"finite"))&&(f=0),(!g||!e.is(g,"finite"))&&(g=0),!d&&(d=c._.textbound=u.rect(0,0,0,0,c.group).follow(c,e.ca[v].reposition,"before")),d.attr({stroke:n||h,"stroke-width":f,fill:r||h,"shape-rendering":1===f?"crisp":"",r:g}),void 0!==l&&d.attr("opacity",l),s&&d.attr("stroke-dasharray",s),e.ca[v].reposition.call(d,c.attr(),c),!1):(c._.textbound=d&&d.unfollow(c).remove(),!1)},e.ca[v].reposition=function(e,t){var r,a,i,o,s,l,d,h,g,p=this,m={};e[f]("visibility")&&p.attr("visibility",e.visibility),(e[f](v)||e[f]("x")||e[f]("y")||e[f]("text")||e[f]("text-anchor")||e[f]("text-align")||e[f]("font-size")||e[f]("line-height")||e[f]("vertical-align")||e[f]("transform")||e[f]("rotation")||e[f]("opacity"))&&(a=(r=t.attrs)[v],i=u(a&&a[3]||"0").split(b),o=c(i[0])||0,s=(0,n.pluck)(c(i[1]),o),h=(l=t.getBBox()).width,g=l.height,p._origOpacity=t._origOpacity||1,d=c(e.opacity||r.opacity),m.opacity=isNaN(d)?p._origOpacity:p._origOpacity*d,isNaN(h)||(m.x=l.x-o,m.y=l.y-s,m.width=Math.max(h+2*o,0),m.height=Math.max(g+2*s,0)),p.attr(m))},e.fn.symbol=function(){var t,r=this,n=arguments,a=n.length-1,i=n[a];return i&&i.constructor===e.el.constructor?n[a]=void 0:i=void 0,(t=r.path(void 0,i)).ca.symbol=e.fn.symbol.ca.symbol,n.length===!!i+0?t:t.attr("symbol",n)},e.fn.getSuggestiveRotation=function(){var e,t,r,n;return e=arguments[0],1===arguments.length?(t=e.angle,r=e.x,n=e.y):(t=e,r=arguments[1],n=arguments[2]),"r"+(t=t||0)+","+r+","+n},e.fn.symbol.cache={"":e._cacher((function(e,t,r,n){var a=r;return arguments.length>3?["M",e,t,"h",a,"v",n,"h",-a,"v",-n,"z"]:["M",e-a,t-a,"h",a*=2,"v",a,"h",-a,"v",-a,"z"]}))},e.fn.symbol.ca={symbol:function(t){var r,n,a=this,i=t,o=e.is(i,"object")&&1===arguments.length&&!e.is(i,"function")?i:arguments;o===i&&(i=o[0]),n=(r=e.is(i,"function")&&i||e.fn.symbol.cache[i]||e.fn.symbol.cache[""])&&r.apply(e,d.call(o,1)),e.is(n,"array")||e.is(n,"string")?a.attr("path",n):n&&a.attr(n)}},e.addSymbol=function(t,r){var n,a,i=r,o=e.fn.symbol.cache,s=[];for(a in n=e.is(i,"function")&&((n={})[t]=i,n)||t)i=n[a],o[a]=e.is(i,"function")&&e._cacher(i,e)||(s.push(a),i);for(a=s.pop();a;)o[a]=o[o[a]],a=s.pop()}};var n=r(224)},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t=function(e){return function(){e.hide();for(var t=0,r=e._.gridElem&&e._.gridElem.length;t<r;t++)e._.gridElem[t].remove();e._.gridElem=[],e._attr({src:e._._src}),setTimeout((function(){e.show()}),100)}},r=function(e,t,r){return function(){var n,i,o,s=a(e._.imageGridAttr,t),l=1,c=1,u=1;if(s.tileInfo&&(l=s.tileInfo.xCount,c=u=s.tileInfo.yCount,o=s.y,delete s.tileInfo),e._.gridElem){for(i=0;i<e._.gridElem.length;i++)e._.gridElem[i].remove();e._.gridElem.length=0}for(i=0;l&&s.width&&s.height;)u--,0===i?e.attr(r?Object.assign(s,{applysrc:e._._src}):s):(n=e.clone().attr({x:s.x,y:s.y}),e._.gridElem.push(n.follow(e,void 0,"after"))),s.y+=s.height,0===u&&(u=c,l--,s.x+=s.width,s.y=o),i++}},a=function(e,t){var r;if(e){var a=e.displayMode,i=e.vAlign,o=e.hAlign,s=e.scale,l=e.canvasBorderWidth,c=e.canvasWidth,u=e.canvasHeight,d=t.width*(s/100),f=t.height*(s/100),h=c-2*l,g=u-2*l;r=(0,n.getAlignImage)(i,o,a,d,f,c,u,l,h,g)}return r||{x:0,y:0,width:t.width,height:t.height}};e.define&&e.define([{name:"imagegrid",imagegrid:function(){var n,a,i=this,o=arguments,s=o.length-1,l=o[s];return l&&l.constructor===e.el.constructor?o[s]=void 0:l=void 0,n=new Image,(a=i.image(l))._.gridElem=[],a._.refImage=n,a._attr=a.attr,a.attr=function(e,t){var r=e,n=Array.isArray(r),i=!n&&"object"==typeof r,o="string"==typeof r;if(n&&(i="object"==typeof(r=r[0])),i){var s=Object.assign({},r),l=s&&s.src,c=s&&s.applysrc;delete s.src,delete s.applysrc,l&&delete a._._src,a._attr(s),l&&a._attr({_src:l}),c&&a._attr({src:c})}else{if(void 0===r&&void 0===t)return this.attrs;if(void 0===t)return this.attrs[r];o&&t&&("src"===r?a._attr({_src:t}):"applysrc"===r?a._attr({src:t}):a._attr({name:t}))}return this},n.onload=r(a,n,!0),n.onerror=t(a),a},ca:{imagegrid:function(e,t,n,a,i,o,s){void 0===a&&(a=100),void 0===i&&(i=0),void 0===o&&(o=0),void 0===s&&(s=0);var l=this,c=t,u=n;"tile"===e||"fill"===e||"fit"===e?("top"!==c&&"middle"!==c&&"bottom"!==c&&(c="middle"),"left"!==u&&"middle"!==u&&"right"!==u&&(u="middle")):("top"!==c&&"middle"!==c&&"bottom"!==c&&(c="top"),"left"!==u&&"middle"!==u&&"right"!==u&&(u="left")),l._.imageGridAttr={displayMode:e,vAlign:c,hAlign:u,scale:a,canvasBorderWidth:i,canvasWidth:o,canvasHeight:s},this._._src&&r(l,l._.refImage)()},_src:function(e){return this._.refImage.src=e,this._._src=e,{_src:e}}}}])};var n=r(229)},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=function(e){var t,r,n,s=window,l=s.document,c=/msie/i.test(s.navigator.userAgent)&&!s.opera,u="VML"===e.type,d={cursor:"cursor"},f={x:"left",y:"top",strokeWidth:"borderThickness","stroke-width":"borderThickness",width:"width",height:"height"},h={fill:"backgroundColor",stroke:"borderColor",color:"color"},g={left:0,top:0,padding:0,border:"none",margin:0,outline:"none","-webkit-apperance":"none",position:"absolute",zIndex:20},p=new o["default"],m=function(e,t,r,n){var a,i=l.createElement(e);for(a in t)f[a]?i.style[a]=t[a]:i.setAttribute(a,t[a]);for(a in r)i.style[a]=r[a];return n&&n.appendChild&&n.appendChild(i),i};(t=(n=function(e,t,r){var a=t;a&&a instanceof n&&(a=a.element),this.element=m(e,r,g,a),this.nodeName=e.toLowerCase(),this.added=Boolean(a),this.attrs={}}).prototype={attr:function(e){var t,r,n,a,i,o,s,g,p,m,v,b=this.element,y={};if("object"!=typeof e)return void 0!==this[e]?this[e]:function(e,t,r){var n,a;if("string"==typeof t)null!=r?e.setAttribute(t,r):e&&e.getAttribute&&(a=e.getAttribute(t));else if(null!=t&&"object"==typeof t)for(n in t)e.setAttribute(n,t[n]);return a}(b,e);for(t in e){if(n=e[t],d[t]){switch(t){case"cursor":"pointer"===n&&u&&(n="hand")}b.style[d[t]]=n,a=!0}else if(f[t])b.style[f[t]]=n+"px",a=!0;else if(h[t])b.style[h[t]]=(v=n)&&v.replace(/^#?([a-f0-9]+)/gi,"#$1")||"none",a=!0;else if(/^visibility$/i.test(t))i="hidden"===n,b.style.display=i?"none":"",this.hidden=i,a=!0;else if(/^opacity$/i.test(t))b.style.opacity=n,c&&(r=100*Number(n),b.style.filter="progid:DXImageTransform.Microsoft.Alpha(Opacity="+r+")"),a=!0;else if(/^innerhtml$/i.test(t)){if(u&&"select"===b.nodeName.toLowerCase()){for(o=n.match(/<option\s?[\s\S]*?(\/>|><\/option>|>[\s\S]*?<\/option>)/gi);b.firstChild;)b.removeChild(b.firstChild);for(g=0,p=o.length;g<p;g+=1)s=o[g],m=l.createElement("option"),/<option\s([\s\S]*[\'\"])\s*?(\/>|>[\s\S]*<\/option>)/gi.test(s)&&(m.value=s.replace(/<option\s([\s\S]*[\'\"])\s*?(\/>|>[\s\S]*<\/option>)/gi,"$1").replace(/[\s\S]*value\s*\=\s*[\'\"]([\s\S]*)[\'\"]/,"$1")),m.text=s.replace(/<option\s*[\s\S]*[\'\"]?\s*?[\/>|\>]([\s\S]*)<\/option>/gi,"$1 "),b.options.add(m)}else"input"!==b.nodeName.toLowerCase()&&void 0!==n&&(b.innerHTML=n||"");a=!0}else/^text$/i.test(t)?("input"!==b.nodeName.toLowerCase()&&(b.innerHTML="",void 0!==n&&b.appendChild(l.createTextNode(n))),a=!0):/^type$/i.test(t)&&c&&this.added&&(a=!0);a&&(y[t]=n,delete e[t],a=!1)}for(t in e)b.setAttribute(t,e[t]);for(t in y)this[t]=this.attrs[t]=e[t]=y[t],delete y[t];return this},val:function(e){var t=this.element,r=void 0===e;if("input"===this.nodeName&&"checkbox"===t.getAttribute("type"))return r?this.checked()?1:0:this.checked(e);if("select"===this.nodeName){var n=t.childNodes,a=t.selectedIndex,o=n.length;if(""===e)return;if(!r)for(var s=0;s<o;s++)if(n[s].value===e)return t.selectedIndex=s,n[s].value;return i.isIE9&&(a=0),r?n[a].value:(n[o-1].value=e,t.selectedIndex=o-1,this)}return r?t.value:(t.value=e,this)},checked:function(e){var t=this.element;return void 0===e?t.checked:(e?t.setAttribute("checked","checked"):t.removeAttribute("checked"),this)},css:function(e,t){var r,n=this.element.style;if("object"==typeof e)for(r in e)n[r]=e[r];else r&&void 0!==t&&(n[r]=t);return this},translate:function(e,t){var r=this.element;return void 0!==e&&(r.style.left=e+"px"),void 0!==t&&(r.style.top=t+"px"),this},add:function(e,t){var r=this.element,n=e.element;return t?n.insertBefore(r,n.firstChild):n.appendChild(r),this.added=!0,this},hide:function(){return this.element.style.display="none",this},show:function(){return this.element.style.display="",this},isVisible:function(){return"none"!==this.element.style.display},focus:function(){"function"==typeof this.element.focus?this.element.focus():a["default"].fire(this.element,"focus")},destroy:function(){var t,n=this.element||{};for(t in n.onclick=n.onmouseout=n.onmouseover=n.onmousemove=n.onblur=n.onfocus=null,n=function(e){r||(r=m("div")),e&&r.appendChild(e),r.innerHTML=""}(n),delete this.element,this)this[t]="function"==typeof this[t]?e._removedFactory(t):null;return this.removed=!0,null},on:function(e,t){var r=t;return p.on(this.element,e,r),this},off:function(e,t){p.off(this.element,e,t)},bind:function(e,t,r){return a["default"].listen(this.element,e,t,r),this},unbind:function(e,t){return a["default"].unlisten(this.element,e,t),this},trigger:function(e,t){return a["default"].fire(this.element,e,t),this}}).remove=t.destroy,t.constructor=n,e.fn.html=function(t,r,a,i){var o,s,l={};for(s in r&&"type"in r&&(l.type=r.type,delete r.type),o=new n(t,i,l).css(a).attr(r),l)r[s]=l[s];return o.ca=function(){return!1},o.appendTo=function(e){var t=e;this.parent=t,t&&t instanceof n&&(t=t.element),t.appendChild(this.element)},o.animateWith=e.el.animateWith,o}};var a=n(r(226)),i=r(224),o=n(r(268))},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(269)),i=n(r(270)),o={elementInfo:[]},s={mouseover:"pointerover",mousedown:"pointerdown",mousemove:"pointermove",mouseup:"pointerup",mouseout:"pointerout"},l={mouseover:"touchstart",mousedown:"touchstart",mouseup:"touchend",mousemove:"touchmove",mouseout:"touchend"},c={blur:!0},u=window.navigator,d="ontouchstart"in document||u.maxTouchPoints||u.msMaxTouchPoints,f="onpointerover"in document,h=function(e,t,r,n){var a;switch(void 0===n&&(n=e),t){case"fc-click":return function(e,t,r){var n,a,i,o,s,l;if(void 0===r&&(r=e),!e._clickHandlerHelper){var c=function(t){e._lastEventTriggered="mousedown",o=void 0!==t.clientX?t.clientX:t.changedTouches&&t.changedTouches[0].clientX,s=void 0!==t.clientY?t.clientY:t.changedTouches&&t.changedTouches[0].clientY},u=function(t){var r=void 0!==t.clientX?t.clientX:t.changedTouches&&t.changedTouches[0].clientX,n=void 0!==t.clientY?t.clientY:t.changedTouches&&t.changedTouches[0].clientY;(Math.abs(o-r)>=2.5||Math.abs(s-n)>=2.5)&&(e._lastEventTriggered=void 0)};for(a in l=!f&&d?{touchstart:function(){e._lastEventTriggered="touchstart",e._lastEventTriggeredAt=(new Date).getTime()},touchmove:u}:f&&d?{pointerdown:c,pointermove:u}:{mousedown:c,mousemove:u})e.addEventListener?e.addEventListener(a,l[a]):e.attachEvent("on"+a,l[a]);e._clickHandlerHelper=l,e._clickEventCount=0}return++e._clickEventCount,!f&&d?(a="touchend",i=function(n){"touchstart"===e._lastEventTriggered&&(new Date).getTime()-e._lastEventTriggeredAt<=500&&setTimeout((function(){t.call(r,n)}),0)}):(a="click",i=function(n){"mousedown"===e._lastEventTriggered&&t.call(r,n)}),(n={})[a]=i,n}(e,r)}var i,u=t,h=u.match(/fc-/),g=r;return h&&(u=u.replace(/fc-/,"")),h&&d&&(i=u,u=(f?s[u]:l[u])||u,"mouseout"===i&&(g=function(e){f&&d&&!e.isPrimary||(o.elementInfo.push({el:n,callback:r}),o.srcElement=e.srcElement||e.target)},u=f?"pointerover":"touchstart")),g===r&&(g=function(e){(!f||!d||e.isPrimary||c[e.type])&&r.call(n,e)}),(a={})[u]=g,a};d&&document.addEventListener(f?"pointerover":"touchstart",(function(e){if(o.srcElement&&o.srcElement!==(e.srcElement||e.target)){var t,r,n=o.elementInfo,a=n.length;for(r=0;r<a;r++)(t=n[r]).callback.call(t.el,e)}o={elementInfo:[]}}),!0);var g=function(){function e(){this.mapper=new a["default"]}var t=e.prototype;return t.on=function(e,t,r,n){void 0===n&&(n={});var a,o,s=this.mapper,l=[e,t,r];if((0,i["default"])(l)&&!(a=s.getValue(l))){for(o in a=h(e,t,r),s.setValue(l,a),a)e.addEventListener?e.addEventListener(o,a[o]):e.attachEvent("on"+o,a[o]);return!0}return!1},t.off=function(e,t,r){var n,a,o=this.mapper,s=[e,t,r];if((0,i["default"])(s)&&(n=o.getValue(s))){for(a in function(e,t){switch(t){case"fc-click":(function(e){var t,r=e._clickHandlerHelper;if(!--e._clickEventCount){for(t in r)e.removeEventListener?e.removeEventListener(t,r[t]):e.detachEvent("on"+t,r[t]);e._clickHandlerHelper=void 0}})(e)}}(e,t),n)e.removeEventListener?e.removeEventListener(a,n[a]):e.detachEvent("on"+a,n[a]);return o.clear(s),!0}return!1},e}();t["default"]=g},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=function(){function e(){this.map=new Map}var t=e.prototype;return t.clear=function(e){var t=this;void 0===e&&(e=[]);var r=this.map,n=e.length;e.forEach((function(a,i){r&&(i===n-1&&r["delete"]?(r["delete"](a),r.size||(e.pop(),t.clear(e))):r=r.has(a)&&r.get(a))}))},t.setValue=function(e,t){void 0===e&&(e=[]);var r=this.map,n=e.length;e.forEach((function(e,a){if(r.has(e))r=r.get(e);else if(a===n-1)r.set(e,t);else{var i=new Map;r.set(e,i),r=i}}))},t.getValue=function(e){void 0===e&&(e=[]);var t=this.map;return e.forEach((function(e){t=t&&t.get&&t.get(e)})),e.length&&t},e}();t["default"]=n},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]=function(e){return e.filter((function(e){return!!e})).length===e.length}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t=[{reg:/xmlns\=\"http\:\/\/www.w3.org\/2000\/svg\"/gi,repStr:""},{reg:/\r?\n|\r/g,repStr:""},{reg:/^.*<svg /,repStr:'<svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" '},{reg:/\/svg>.*$/,repStr:"/svg>"},{reg:/<desc\>[^<]*<\/desc\>/,repStr:""},{reg:/zIndex="[^"]+"/g,repStr:""},{reg:/url\((\\?[\'\"])[^#]+#/g,repStr:"url($1#"},{reg:/ href=/g,repStr:" xlink:href="},{reg:/(id|class|width|height)=([^" >]+)/g,repStr:'$1="$2"'},{reg:/:(path|rect)/g,repStr:"$1"},{reg:/<ima?ge? ([^\>]+?[^\/])\>/gi,repStr:"<image $1 />"},{reg:/<\/ima?ge?\>/g,repStr:""},{reg:/style="([^"]+)"/g,repStr:function(e){return e.toLowerCase()}},{reg:/NS\d+\:href=/g,repStr:"xlink:href="}],r=function(e){var t=JSON.stringify(e);return t=t=(t=(t=(t=t.replace(/([a-z]+)([A-Z]+)([a-z]+)/g,(function(e,t,r,n){return t+"-"+r.toLowerCase()+n}))).replace(/\"\,\"/g,'";"')).replace(/\"/g," ")).replace(/\{|\}/g,"")};e.svg&&(e.fn.toSVG=function(e){var n,a="",i=0,o=t.length;if(this.canvas&&this.canvas.parentNode){for(a=this.canvas.parentNode.innerHTML;i<o;i+=1)n=t[i],a=a.replace(n.reg,n.repStr);this._stylesheet&&this._stylesheet.rules&&(a=function(e,t){var n,a,i,o,s,l,c,u=e,d=function(e){var t=e;return t=t.match(/style\s*=/)?t.replace(/(style\s*=")([^"]+)/g,(function(e,t,r){return t+o+r})):t.replace(/class\s*="[^"]*"/i,(function(e){return e+' style="'+o+'" '}))};for(n in t)if(t.hasOwnProperty(n))for(l in a=/\s+/,i=n.split(a),o=r(t[n]),i)i.hasOwnProperty(l)&&(s=i[l].trim().replace(".",""),c=new RegExp("<[^>]+("+s+")[^>]+","g"),u=u.replace(c,d));return u}(a,this._stylesheet.rules))}return e||(a=a.replace(/<image[^\>]*\>/gi,(function(e){return e.match(/href=\"data\:image/i)?e:""}))),a})}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=function(e){e&&(e.svg?e.el.addPattern=function(t,r){void 0===t&&(t={}),void 0===r&&(r=0);if(this.patternInfo&&(this.patternInfo.element.remove(),delete this.patternInfo),r){var n=this.paper.addDefs({pattern:c({},d(t))}).pattern;this.node.setAttribute("fill",'url("'+e._url+"#"+n.id+'")'),this.patternInfo=n}}:e.el.addPattern=function(){return this})};var a=n(r(223)),i=n(r(273)),o=n(r(274)),s=n(r(275));function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function c(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,a["default"])(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var u={line:i["default"],circle:o["default"],square:s["default"]},d=function(e){var t=e.patternSize+e.patternDensity;return{tagName:"pattern",height:t,width:t,x:e.x||0,y:e.y||0,patternTransform:"rotate("+e.patternAngle+")",patternUnits:"userSpaceOnUse",children:[].concat(u[e.patternType](e))}}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224);t["default"]=function(e){var t=e.patternSize+e.patternDensity,r=(0,n.hashify)(e.color);return[{tagName:"rect",height:t,width:t,fill:e.patternBgColor,opacity:e.alpha/100},{tagName:"path",d:"M 0, "+t/2+" L "+t+", "+t/2,"stroke-width":e.patternSize,stroke:n.validhexcolor.test(r)?r:(0,n.rgbaToHex)(e.color),opacity:e.patternAlpha/100}]}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224);t["default"]=function(e){var t=e.patternSize+e.patternDensity,r=(0,n.hashify)(e.color),a=n.validhexcolor.test(r)?r:(0,n.rgbaToHex)(e.color);return[{tagName:"rect",height:t,width:t,fill:e.patternBgColor,opacity:e.alpha/100},{tagName:"circle",cx:t/2,cy:t/2,r:e.patternSize/2,stroke:a,fill:a,opacity:e.patternAlpha/100}]}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224);t["default"]=function(e){var t=e.patternSize+e.patternDensity,r=(0,n.hashify)(e.color),a=n.validhexcolor.test(r)?r:(0,n.rgbaToHex)(e.color);return[{tagName:"rect",height:t,width:t,fill:e.patternBgColor,opacity:e.alpha/100},{tagName:"rect",x:e.patternDensity/2,y:e.patternDensity/2,height:e.patternSize,width:e.patternSize,stroke:a,fill:a,opacity:e.patternAlpha/100}]}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=t._mouseEvtHandler=void 0;var a=n(r(238)),i=r(224),o=r(231),s=n(r(277)),l=r(240),c=n(r(278)),u=r(232),d=n(r(279)),f=r(236),h="http://www.w3.org/2000/svg",g="M23,11.46V1.87h5.8V3.31h-4.1V6h3.48V7.46H24.71v4Zm7-2.68V4.26h1.69v4.3c0,1.19.34,1.63,1.12,1.63.63,0,1-.3,1.59-1V4.26h1.69v7.2H34.67l-.13-1.05h0a3,3,0,0,1-2.32,1.23C30.64,11.64,30,10.6,30,8.78Zm7.51,1.86.8-1.08a3.23,3.23,0,0,0,2,.8c.78,0,1.14-.36,1.14-.86s-.77-.87-1.54-1.16c-1-.35-2-.9-2-2.1s1-2.15,2.63-2.15A3.94,3.94,0,0,1,42.86,5l-.78,1a2.66,2.66,0,0,0-1.58-.62c-.72,0-1.06.34-1.06.79s.72.8,1.5,1.07c1,.37,2.06.84,2.06,2.19s-1,2.23-2.8,2.23A4.6,4.6,0,0,1,37.47,10.64ZM45.36,3a1,1,0,1,1,1-1A1,1,0,0,1,45.36,3Zm-.85,8.46V4.26H46.2v7.2Zm3.38-3.59a3.44,3.44,0,1,1,6.85,0,3.44,3.44,0,1,1-6.85,0Zm1.73,0c0,1.44.63,2.39,1.69,2.39S53,9.31,53,7.87s-.65-2.41-1.7-2.41S49.62,6.42,49.62,7.87Zm6.79,3.59V4.26H57.8l.12,1H58a3.34,3.34,0,0,1,2.36-1.14c1.54,0,2.21,1,2.21,2.86v4.51H60.87V7.17c0-1.19-.34-1.63-1.13-1.63a2.29,2.29,0,0,0-1.64.89v5ZM64.24,6.7c0-3.14,2-5,4.43-5A3.79,3.79,0,0,1,71.4,2.91L70.46,4a2.42,2.42,0,0,0-1.77-.79C67.12,3.18,66,4.5,66,6.65s1,3.51,2.64,3.51a2.57,2.57,0,0,0,2-1l.94,1.05a3.84,3.84,0,0,1-3,1.39C66.16,11.64,64.24,9.88,64.24,6.7ZM73,11.46V1.11h1.68V3.78l0,1.39A3.3,3.3,0,0,1,77,4.09c1.54,0,2.21,1,2.21,2.86v4.51H77.49V7.17c0-1.19-.34-1.63-1.13-1.63a2.33,2.33,0,0,0-1.65.89v5ZM80.9,9.53c0-1.54,1.29-2.35,4.24-2.67,0-.77-.33-1.41-1.3-1.41a4,4,0,0,0-2,.7L81.2,5a5.64,5.64,0,0,1,3-.93c1.8,0,2.68,1.1,2.68,3.1v4.27H85.45l-.13-.79h0a3.49,3.49,0,0,1-2.22,1A2,2,0,0,1,80.9,9.53Zm1.65-.14c0,.65.42.93,1,.93a2.25,2.25,0,0,0,1.57-.79V7.91C83.19,8.16,82.55,8.68,82.55,9.39Zm6.33,2.07V4.26h1.4l.11,1.28h.06a2.45,2.45,0,0,1,2-1.45,1.86,1.86,0,0,1,.82.14L93,5.7a2.46,2.46,0,0,0-.75-.12c-.57,0-1.26.4-1.7,1.48v4.4ZM94.6,9V5.6h-1V4.33l1.11-.07.21-2h1.4v2h1.84V5.6H96.3V9c0,.85.33,1.26,1,1.26a2,2,0,0,0,.74-.16l.3,1.24a4.43,4.43,0,0,1-1.47.27C95.22,11.64,94.6,10.58,94.6,9Zm4.33,1.61.79-1.08a3.26,3.26,0,0,0,2,.8c.77,0,1.14-.36,1.14-.86s-.78-.87-1.54-1.16c-.95-.35-2-.9-2-2.1s1-2.15,2.62-2.15a3.89,3.89,0,0,1,2.39.86l-.77,1A2.69,2.69,0,0,0,102,5.36c-.72,0-1,.34-1,.79s.71.8,1.49,1.07c1,.37,2.07.84,2.07,2.19s-1,2.23-2.8,2.23A4.58,4.58,0,0,1,98.93,10.64Z",p=["M111.54,4.59h-2.39V3.32h6.28V4.59H113v7h-1.5Z","M116.11,5.38h1.24l.11,1.11h0a2.15,2.15,0,0,1,1.77-1.27,1.7,1.7,0,0,1,.71.13l-.3,1.28a2.1,2.1,0,0,0-.6-.07c-.49,0-1.09.33-1.46,1.28v3.78h-1.51Z","M120.75,3.46a.9.9,0,0,1,1.8,0,.9.9,0,0,1-1.8,0Zm.13,1.92h1.51v6.24h-1.51Z","M123.89,9.94c0-1.37,1.09-2,3.65-2.33,0-.64-.27-1.17-1.11-1.17a3.6,3.6,0,0,0-1.75.58l-.53-1a4.78,4.78,0,0,1,2.56-.82c1.55,0,2.33,1,2.33,2.71v3.69h-1.22l-.12-.69h0a2.93,2.93,0,0,1-1.91.84A1.75,1.75,0,0,1,123.89,9.94Zm3.65,0V8.62c-1.69.21-2.2.59-2.2,1.22s.35.74.86.74A1.85,1.85,0,0,0,127.54,9.94Z","M130.77,10V2.66h1.51v7.4c0,.36.16.49.31.49a1,1,0,0,0,.23,0l.18,1.1a1.77,1.77,0,0,1-.79.14C131.16,11.77,130.77,11.08,130.77,10Z"],m=["M9.76,0L12.93,0L12.93,11.39,L9.76,11.39L9.76,0","M9.76,12.86L12.93,12.86L12.93,16.19L9.76,16.19L9.76,12.86"],v={x:0,y:1.63,width:3.33,height:9.76},b={x:4.8,y:6.43,width:3.41,height:4.96},y={attributes:!1,subtree:!0,characterData:!0,childList:!0},x=function(e){return String.fromCharCode(e)},w=function(e){return e.map(x).join("")},C=w([99,114,101,100,105,116,76,97,98,101,108]),k=w([99,114,101,100,105,116,103,114,111,117,112]),_=[65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122].map(x),S=function(){return _[Math.floor((e=0,t=_.length,Math.random()*(t-e)+e))];var e,t},E=function(e,t,r){var n,a,o,s,l,c,u,d,f=r.mouseTracker,h=t.originalEvent,g=e.config.datasetOrder||e.getDatasets(),p=!1,m=g.length,v=f._lastDatasetIndex,b=f._lastPointIndex;for(a=(n=(0,i.getMouseCoordinate)(e.getFromEnv("chart-container"),h,e)).chartX,o=n.chartY;m--&&!p;)(s=g[m])&&s.getState("visible")&&(l=s._getHoveredPlot&&s._getHoveredPlot(a,o))&&l.hovered&&(p=!0,l.datasetIndex=m,d=f.getMouseEvents(t,l.datasetIndex,l.pointIndex));if((!p||d&&d.fireOut)&&void 0!==v&&g[v]&&g[v]._firePlotEvent&&(d&&!d.events.length?f.mouseoutTimer=setTimeout((function(){e.mouseoutHandler(t,v,b)}),20):(e.mouseoutHandler(t,v,b),clearTimeout(f.mouseoutTimer))),p)for((u=d.events&&d.events.length)&&(f._lastDatasetIndex=l.datasetIndex,b=f._lastPointIndex=l.pointIndex),c=0;c<u;c+=1)s&&s._firePlotEvent&&s&&s._firePlotEvent&&s._firePlotEvent(d.events[c],b,t,l.datasetIndex)};t._mouseEvtHandler=E;var A=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e),t.getName=function(){return"base"};var r=t.prototype;return r.setDummyEImethods=function(e){var t=this.config,r=t._eiStore||(t._eiStore={}),n=function(e){return(d["default"][e]||[]).concat(d["default"]["*"])}(e),a=this.getFromEnv("chartInstance");n.forEach((function(e){var t;!a[e]&&(a[e]=(t=e,function(){!r[t]&&(r[t]=[]),r[t].push(arguments)}))})),a.addEventListener("renderComplete",(function(){var e=function(e){r[e].forEach((function(t){a[e].apply(a,t)}))};for(var n in r)e(n);t._eiStore={}}))},t.getType=function(){return"chartAPI"},r.mouseoutHandler=function(e,t,r){var n=this.config.datasetOrder||this.getDatasets(),a=this.getChildren("mouseTracker")[0];n[t]&&n[t].components.data[r]?n[t]._firePlotEvent("fc-mouseout",r,e):this.getFromEnv("toolTipController").hideAll(),delete a._lastDatasetIndex,delete a._lastPointIndex},r.getName=function(){return"base"},r.getType=function(){return"chartAPI"},r._mouseEvtHandler=function(e,t){E(this,e,t)},r.getComponents=function(e,t){var r=[];return(e||this).iterateComponents((function(e){e.getType()===t&&r.push(e)})),r},r.getDatasets=function(e){var t=[];return(e||this).iterateComponents((function(e){"dataset"===e.getType()&&t.push(e)})),t},r.preConfigure=function(t){e.prototype.preConfigure.call(this,t),function(e,t){var r;for(r in t)t.hasOwnProperty(r)&&(e[r]=t[r])}(this.getFromEnv("chartInstance"),this.eiMethods)},r.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t),this.createBaseComponent()},r.createBaseComponent=function(){var e,t=this;(e=t.getFromEnv("animationManager"))?e.configure():(e=new c["default"],t.addToEnv("animationManager",e),e.addToEnv("chart",t),e.addToEnv("animationManager",e),e.configure(),t.addExtEventListener("animationstart",(function(e){var r=e.data.duration;r&&t.fireChartInstanceEvent("animationinvoked",{duration:r})}),e))},r.setChartMessage=function(e,t,r){var n,a,o=r;(0,i.componentFactory)(this,s["default"],"chartMessage"),a=this.getChildren("chartMessage")[0],o?this.addToEnv("chart-container",o):o=this.getFromEnv("chart-container"),(n=this.getFromEnv("paper"))||((n=new((0,u.getDep)("redraphael","plugin"))(o,this.getFromEnv("chartWidth"),this.getFromEnv("chartHeight"))).setHTMLClassName("fusioncharts-div"),this.addToEnv("paper",n)),n.setConfig("stroke-linecap",i.ROUND),!this.getChildContainer("messageGroup")&&this.addChildContainer("messageGroup",n.group("messageGroup")),this.config.hasChartMessage=!0,a.setData({message:e,chartObj:t,visible:!0},!0)},r.drawChartMessage=function(){this.config.hasChartMessage=!0,this._drawTexts()},r._dispose=function(){this._clearTimers&&this._clearTimers();var t=this.getFromEnv("paper");t&&t.remove&&t.remove(),e.prototype._dispose.call(this)},r.fireChartInstanceEvent=function(e,t,r,n,a){var i=this.getFromEnv("chartInstance");(0,o.triggerEvent)(e,i,t,r,n,a)},r._hideChartMessage=function(){var e=this.getChildren("chartMessage");this.config.hasChartMessage=!1,e&&e[0].setData({visible:!1},!0),this.getGraphicalElement("messageText")&&this.getGraphicalElement("messageText").hide(),this.getGraphicalElement("messageVeil")&&this.getGraphicalElement("messageVeil").hide()},r._removeWaitingJobs=function(){this.iterateComponents((function(e){return e.removeAllJobs()}))},r._drawTexts=function(){this._drawMain(!1)},r._drawMain=function(e){this._crCreate(e),e&&this._scheduleLabelCheck(e)},r._scheduleLabelCheck=function(e){var t=this;t.addJob("checker",(function(){var r,n=t.getContainer(k);!n||(r=n).node&&r.node.parentNode&&11!==r.node.parentNode.nodeType||t._crCreate(e),t._scheduleLabelCheck(e)}),f.priorityList.verification,{oneInAFrame:!0,addToTop:!1,executionDelay:300})},r._crCreate=function(e){var t,r,n=this,a=n.getFromEnv("paper"),o=+n.getFromEnv("chartHeight"),s=n.getGraphicalElement(C),l=n.getContainer("parentgroup"),c={href:i.TXT_HREF};if(e){if(n.getContainer(k)&&n.removeContainer(k),s&&n.removeGraphicalElement(s),!a||!a.group)return;t=n.addContainer(k,a.group(function(e){void 0===e&&(e=8);for(var t=i.BLANK,r=0;r<e;r++)t+=S();return t}(),!0)),l&&t.insertAfter(l),n.addGraphicalElement(C,void 0),r=this._creatingTheLogo(o-27.32),t.node.appendChild(r),n.config.observer?n.config.observer.disconnect():n.config.observer=new MutationObserver((function(){return n._crCreate(e)})),n.config.observer.observe(n.getContainer(k).node,y),t.on("fc-click",(function(){try{open(c.href)}catch(e){(top||window).location.href=c.href}}))}else void 0},r.hoverCallback=function(e){"mouseover"===e.type?this.style.fill="#373c8b":"mouseout"===e.type&&(this.style.fill="#b1b2b7")},r._creatingTheLogo=function(e){var t,r,n,a,i,o,s,l,c,u,d;return(t=document.createElementNS(h,"g")).setAttributeNS(null,"transform","translate(18,"+e+")"),t.setAttributeNS(null,"fill","#b1b2b7"),t.setAttributeNS(null,"cursor","pointer"),t.setAttributeNS(null,"pointer-events","bounding-box"),t.setAttributeNS(null,"style","transition:0.5s;"),(r=document.createElementNS(h,"path")).setAttribute("d",g),r.setAttributeNS(null,"fill",""),r.setAttributeNS(null,"stroke",""),r.setAttributeNS(null,"stroke-linecap",""),(n=document.createElementNS(h,"rect")).setAttributeNS(null,"x",v.x),n.setAttributeNS(null,"y",v.y),n.setAttributeNS(null,"width",v.width),n.setAttributeNS(null,"height",v.height),n.setAttributeNS(null,"fill",""),n.setAttributeNS(null,"stroke",""),n.setAttributeNS(null,"stroke-linecap",""),(a=document.createElementNS(h,"rect")).setAttributeNS(null,"x",b.x),a.setAttributeNS(null,"y",b.y),a.setAttributeNS(null,"width",b.width),a.setAttributeNS(null,"height",b.height),a.setAttributeNS(null,"fill",""),a.setAttributeNS(null,"stroke",""),a.setAttributeNS(null,"stroke-linecap",""),(i=document.createElementNS(h,"path")).setAttributeNS(null,"d",m[0]),i.setAttributeNS(null,"fill",""),i.setAttributeNS(null,"stroke",""),i.setAttributeNS(null,"stroke-linecap",""),(o=document.createElementNS(h,"path")).setAttributeNS(null,"d",m[1]),o.setAttributeNS(null,"fill",""),o.setAttributeNS(null,"stroke",""),o.setAttributeNS(null,"stroke-linecap",""),(s=document.createElementNS(h,"path")).setAttributeNS(null,"d",p[0]),s.setAttributeNS(null,"fill",""),s.setAttributeNS(null,"stroke",""),s.setAttributeNS(null,"stroke-linecap",""),(l=document.createElementNS(h,"path")).setAttributeNS(null,"d",p[1]),l.setAttributeNS(null,"fill",""),l.setAttributeNS(null,"stroke",""),l.setAttributeNS(null,"stroke-linecap",""),(c=document.createElementNS(h,"path")).setAttributeNS(null,"d",p[2]),c.setAttributeNS(null,"fill",""),c.setAttributeNS(null,"stroke",""),c.setAttributeNS(null,"stroke-linecap",""),(u=document.createElementNS(h,"path")).setAttributeNS(null,"d",p[3]),u.setAttributeNS(null,"fill",""),u.setAttributeNS(null,"stroke",""),u.setAttributeNS(null,"stroke-linecap",""),(d=document.createElementNS(h,"path")).setAttributeNS(null,"d",p[4]),d.setAttributeNS(null,"fill",""),d.setAttributeNS(null,"stroke",""),d.setAttributeNS(null,"stroke-linecap",""),t.appendChild(r),t.appendChild(n),t.appendChild(a),t.appendChild(i),t.appendChild(o),t.appendChild(s),t.appendChild(l),t.appendChild(c),t.appendChild(u),t.appendChild(d),t.addEventListener("mouseover",this.hoverCallback),t.addEventListener("mouseout",this.hoverCallback),t},r._hideModal=function(){this.getChildContainer("messageGroup").hide()},r.remove=function(t){var r=this.getFromEnv("animationManager");this.config.observer&&this.config.observer.disconnect(),e.prototype.remove.call(this,t),r&&r.remove(t)},t}(l.ComponentInterface);A.stringConstants={BACKGROUNDLOADED:"BackgroundLoaded",BACKGROUNDLOADERROR:"BackgroundLoadError",clipRectStr:"clip-rect"};var N=A;t["default"]=N},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=o.preDefStr.noneStr,l=function(e,t){e.on("fc-click",(function(){try{open(t)}catch(e){(top||window).location.href=t}})),e.css({cursor:"pointer",_cursor:"pointer"})},c=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"chartMessage"},r.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t);var r=this.config;for(var n in t)t.hasOwnProperty(n)&&(r[n]=t[n])},r._drawBackground=function(e,t){void 0===t&&(t={});var r,n,a,i,c=this,u=c.config,d=c.getFromEnv("paper"),f=c.getFromEnv("chart"),h=u.visible,g=c.getGraphicalElement("backgroundElement"),p=c.getGraphicalElement("backgroundImage"),m=c.getFromEnv("chartWidth"),v=c.getFromEnv("chartHeight"),b=c.getLinkedParent().getChildContainer("messageGroup").show(),y=(0,o.pluckNumber)(t.imageAlpha,100),x=0+o.COMMA+0+o.COMMA+m+o.COMMA+v,w=(0,o.getValidValue)(t.imageVAlign,o.BLANKSTRING).toLowerCase(),C=(0,o.pluck)(t.imageHAlign,o.BLANKSTRING).toLowerCase(),k=(0,o.pluckNumber)(t.imageScale,100),_=c.getFromEnv("chartInstance"),S=u.messageURL,E=(0,o.getContainerBackgroundColor)(_);d.canvas.style.backgroundColor=E,w!==o.POSITION_TOP&&w!==o.POSITION_MIDDLE&&w!==o.POSITION_BOTTOM&&(w=o.POSITION_TOP),C!==o.POSITION_LEFT&&C!==o.POSITION_MIDDLE&&C!==o.POSITION_RIGHT&&(C=o.POSITION_LEFT),n={x:0,y:0,width:m,height:v,stroke:s},g||(g=d.rect(b),c.addGraphicalElement("backgroundElement",g)),g.attr(n),g&&S&&l(g,S),u.bgImageVAlign=w,u.bgImageHAlign=C,u.bgImageScale=k,u.bgSWFAlpha=y,u.imgClipRect=x,e&&((r=p)?r.attr({src:e}):(r=c.getFromEnv("paper").image(b),c.addGraphicalElement("backgroundImage",r),r.attr({src:e}),r.on("load",(function(){if(!(!r||r&&r.removed)){var t=r._.RefImg;a=c.getFromEnv("chartConfig"),u.isImage&&(void 0===a||a.hasChartMessage)&&(i=(0,o.setImageDisplayMode)(s,u.bgImageVAlign,u.bgImageHAlign,u.bgImageScale,0,c.getFromEnv("chartWidth"),c.getFromEnv("chartHeight"),t),(0,o.extend2)(i,{opacity:.01*u.bgSWFAlpha,visibility:"visible","clip-rect":u.imgClipRect}),r.attr(i),h?r.show():r.hide(),r&&S&&l(r,S),f.fireChartInstanceEvent("backgroundloaded",{url:e,bgImageAlpha:100*u.bgSWFAlpha,bgImageDisplayMode:s,bgImageVAlign:u.bgImageVAlign,bgImageHAlign:u.bgImageHAlign,bgImageScale:u.bgImageScale,imageWidth:t.width,imageHeight:t.height}))}})),r.on("error",(function(t){r.removed||f.fireChartInstanceEvent("backgroundloaderror",{url:e,bgImageAlpha:100*u.bgSWFAlpha,error:t,bgImageDisplayMode:s,bgImageVAlign:u.bgImageVAlign,bgImageHAlign:u.bgImageHAlign,bgImageScale:u.bgImageScale},_)}))))},r.configure=function(t){e.prototype.configure.call(this,t);var r,n=this.getFromEnv("chartInstance"),a=n.options,i=n.args,s=this.config,l=s.message,c=s.chartObj;(s.strObj=(0,o.getImageURL)(void 0!==l?l:a.dataEmptyMessage)).image?(r=c?{imageHAlign:(0,o.pluck)(c._chartMessageImageStyle.imageHAlign,a.baseChartMessageImageHAlign).toLowerCase(),imageVAlign:(0,o.pluck)(c._chartMessageImageStyle.imageVAlign,a.baseChartMessageImageVAlign).toLowerCase(),imageAlpha:(0,o.pluckNumber)(c._chartMessageImageStyle.imageAlpha,a.baseChartMessageImageAlpha),imageScale:(0,o.pluckNumber)(c._chartMessageImageStyle.imageScale,a.baseChartMessageImageScale)}:{imageHAlign:(0,o.pluck)(i.dataEmptyMessageImageHAlign,a.baseChartMessageImageHAlign).toLowerCase(),imageVAlign:(0,o.pluck)(i.dataEmptyMessageImageVAlign,a.baseChartMessageImageVAlign).toLowerCase(),imageAlpha:(0,o.pluckNumber)(i.dataEmptyMessageImageAlpha,a.baseChartMessageImageAlpha),imageScale:(0,o.pluckNumber)(i.dataEmptyMessageImageScale,a.baseChartMessageImageScale)},s.chartMessageType="image"):(r=c?{"font-family":c._chartMessageStyle.fontFamily||a.baseChartMessageFont,"font-size":c._chartMessageStyle.fontSize||a.baseChartMessageFontSize,fill:c._chartMessageStyle.color||a.baseChartMessageColor}:{"font-family":i.dataEmptyMessageFont||a.baseChartMessageFont,"font-size":i.dataEmptyMessageFontSize||a.baseChartMessageFontSize,fill:i.dataEmptyMessageColor||a.baseChartMessageColor},s.chartMessageType="text"),s.messageURL=a.messageURL,s.chartMessageStyle=r},r.manageSpace=function(){var e,t,r,n=this.config,a=n.chartMessageStyle,i=this.getFromEnv("smartLabel"),s=n.strObj,l=this.getFromEnv("chartWidth"),c=this.getFromEnv("chartHeight");t=n.width=Number(l),e=n.height=Number(c),s.image?r=s.string:(i.setStyle(a),r={text:i.getSmartText((0,o.parseUnsafeString)(s.string),t,e).text,x:t/2,y:e/2}),n.chartMessageAttr=r},r.draw=function(){var e,t,r,n=this.config,a=this.getFromEnv("paper"),i=n.visible,s=n.isImage="image"===n.chartMessageType,c=n.messageURL,u=s?n.chartMessageAttr:(0,o.extend2)(n.chartMessageAttr,n.chartMessageStyle);e=this.getGraphicalElement("messageText"),r=this._graphics,t=this.getLinkedParent().getChildContainer("messageGroup").show(),s?this._drawBackground(n.chartMessageAttr,n.chartMessageStyle):e||"text"!==n.chartMessageType?(r.message=e.attr(u),i?e.show():e.hide()):e=this.addGraphicalElement("messageText",a.text(u,t)),(e||r.message)&&c&&l(e||r.message,c),this._hideOtherMessage(s)},r._hideOtherMessage=function(e){var t,r,n;e?(r=this.getGraphicalElement("messageText"))&&r.hide():(t=this.getGraphicalElement("backgroundImage"),n=this.getGraphicalElement("backgroundElement"),t&&t.hide(),n&&n.hide())},r.getType=function(){return"chartMessage"},t}(i.ComponentInterface);t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a,i=n(r(242)),o=n(r(238)),s=r(224),l=r(236),c=r(240),u=r(232),d=!s.hasSVG,f={initial:1,update:0,realTimeUpdate:0,resize:0,dispose:0,legendInteraction:0,scroll:0,mouseOut:0,mouseOver:0,"default":0,slicing:.25,timenavSqueeze:0,selectedRange:0,timenavScroll:0},h={MSColumn2D:!0,MSColumn3D:!0,MSBar2D:!0,MSBar3D:!0,StackedColumn2D:!0,StackedColumn3D:!0,StackedBar2D:!0,StackedBar3D:!0,MSStackedColumn2D:!0,ScrollColumn2D:!0,ScrollMSStackedColumn2D:!0,ScrollBar2D:!0,ScrollStackedColumn2D:!0,ScrollStackedBar2D:!0},g=["default","global","chartSpecific"],p={fadeIn:{opacity:{start:0,end:1}},fadeOut:{opacity:{start:1,end:0}}},m={fadeIn:function(){this&&this.show()},fadeOut:function(){this&&this.hide()}},v=function(e){return null===e},b=function(e,t){void 0===t&&(t="");var r=t.split(","),n=[];return r.forEach((function(t){e[t]&&e[t].animation&&n.push(e[t].animation)})),n},y=function(e,t,r){var n,a=Object.assign({},e),i=r/t;return i>.2&&(i=.2),n=a.end-a.start,a.start*=1-i,a.start+=i,a.end=a.start+(1-i)*n,a.start=Math.round(100*a.start)/100,a.end=Math.round(100*a.end)/100,a},x=function(e,t,r){var n,i=p[t],o=s.BLANKSTRING,l={};if(i&&e&&e.el&&e.el[0]){for(o in i)l[o]=e.el.attrs[o],l[o]===a&&(l[o]=null),e.attrs[o]=i[o].end,e.el.attr(o,i[o].start);n=e.callback,e.callback=function(){r&&m[t]&&m[t].call(this),n&&n.call&&n.call(this),this.attr(l)}}},w=function(e,t){var r,n=t,a=!0;if(n){for(e.attrs=e.attrs||{},~(n=n.split("-")).indexOf("nc")&&(a=!1),r=n.length;r--;)x(e,n[r],a);return e}},C=function(e,t,r,n,a,i,o,s){e.animateWith(a,i,t,o,s,r,n)},k=function(e){var t={};for(var r in e)if(e.hasOwnProperty(r)&&"__esModule"!==r){var n=e[r];_(t,n)}return t},_=function(e,t){for(var r in t)t.hasOwnProperty(r)&&(!e[r]&&(e[r]=[]),e[r].push(t[r]))},S=function(e){return"function"==typeof e};function E(e,t,r,n){var a,i,o,s,l,c=e.length,u=0,d=0,f=t;for(i=0,o=0,l=0;l<c;l+=1)(a=e[l]).hasAnimation||!1===a.collapsible?o+=1:i+=a.duration,d+=a.duration;for(i/=o,l=0;l<c;l+=1)(a=e[l]).hasAnimation&&(s=r-t,f=(u=f)+(a.duration/d+i)*s,n[a.name]={start:u,end:f,effect:a.effect,transition:a.transition},a.child&&N(a.child,u,f,n))}function A(e,t,r,n){var a,i,o;i=t+(i=e.start)*(a=r-t),o=t+(o=e.end)*a,n[e.name]={start:i,end:o,effect:e.effect,transition:e.transition},e.child&&N(e.child,i,o,n)}function N(e,t,r,n){var a,i,o=e.length;for(a=0;a<o;a++)i=e[a],Array.isArray(i)?E(i,t,r,n):A(i,t,r,n)}p.fadein=p.fadeIn,p.fadeout=p.fadeOut;var T=function(e){(0,o["default"])(r,e);var t=r.prototype;function r(){var t;t=e.call(this)||this;var r=(0,i["default"])(t);return r._removedGraphics=[],r._animCallBack=function(){if(!r.getState("removed")&&!this.removed){var e=r.getAnimationState();r._removeElems(),r.reset(),r.fireEvent("animationComplete",{currAnimState:e})}},r.startAnimation=function(){r.kickStart(),r.animate()},t}return t.getType=function(){return"animationManager"},t.getName=function(){return"animationManager"},t.stopAnimation=function(){if(this.getState("chartAnimating")){var e,t=this.config.animationObj,r=t&&t.duration;r?(e=this.getGraphicalElement().dummyObj)&&e.stop(a,!0,!0):0===r&&(this.removeJob("anim-callBack"),this._animCallBack())}},t.kickStart=function(){var e,t,r,n=this.config,i=this.getGraphicalElement(),o=this.getFromEnv("paper"),s=n.animationObj,l=n.animationeffect;t=s.duration,s.animObj=r=(0,u.getDep)("redraphael","plugin").animation({x:0},t,l,this._animCallBack,!0),s.animType=l,(e=i.dummyObj)?e.attr({x:100}):(e=o.rect({x:100,y:0,width:10,height:30}),this.addGraphicalElement("dummyObj",e),e.hide()),s.dummyObj=i.dummyObj,e.stop(a,!0,!0),this.fireEvent("animationStart",{duration:t}),this.setState("chartAnimating",!0),e.animate(r)},t.setAnimationState=function(e){void 0===e&&(e=a),e&&this.stopAnimation(),this.config.__state=e,this._setAnimDuration(e)},t.getAnimationState=function(){return this.config&&this.config.__state},t._setAnimDuration=function(e){void 0===e&&(e="default");var t=this.config,n=t.animationObj||(t.animationObj={}),a=t.animationDuration||(t.animationDuration={}),i=this.getFromEnv("chart"),o=i.config.transposeAxis&&"legendInteraction"===e&&h[i.getName()],s=i.getFromEnv("chart-attrib")||{},l=e+"AnimDuration",c=t.killSwitch?0:1e3*(a[l]||s[o?"transposeanimation":l.toLowerCase()]||(o?.25:r.getFallbackAnimDuration(e)));n&&(n[l]=c,n.duration=+c)},t.configureAttributes=function(){var e=this.getFromEnv("chart"),t=e.config,r=this.config,n=e.getFromEnv("chart-attrib")||{};r.killSwitch=!(0,s.pluckNumber)(n.animation,t.animation,1),r.animationeffect=t.animationeffect||"linear",this.invokeAnimationRules(),!r.workingRules&&(r.workingRules={}),!r.animateArr&&(r.animateArr=[]),!r.animationName&&(r.animationName=[])},t.invokeAnimationRules=function(){var e,t=this.getFromEnv("chart"),n=t.getFromEnv("chart-attrib")||{},a=t.config||{},i=this.config,o=t.getFromEnv("chartInstance").args.animation,l=t.getFromEnv("core-options").defaultTheme,c=function(e){var t,r={};for(var n in e)e.hasOwnProperty(n)&&(r[(t=e[n]).name]=t);return r}((0,u.getDepsByType)("theme")),d=(t.getFromEnv("core-options")._globalAnimationRule||[]).concat(b(c,l)),f=(o&&[o]||[]).concat(b(c,a.theme));i.animationRules={global:k(d.map((function(e){return e&&e.rule})).filter((function(e){return e}))),chartSpecific:k(f.map((function(e){return e&&e.rule})).filter((function(e){return e}))),"default":k((0,u.getDepsByType)("animationRule"))},i.animationDuration=e={},d.map((function(t){return Object.assign(e,t.duration)})),f.map((function(t){return Object.assign(e,t.duration)})),e.initialAnimDuration=(0,s.pluckNumber)(e.initialAnimDuration,n.initialanimduration,n.animationduration),this.config.slots=r.getFallbackAnimTimeSlots().concat([].concat.apply([],d.map((function(e){return e.slots}))).filter((function(e){return e}))).concat([].concat.apply([],f.map((function(e){return e.slots}))).filter((function(e){return e})))},t.reInitialize=function(){var e=this.config.animationObj.duration;this.setState("initialized",!0),e?this.addJob("start-animation",this.startAnimation,l.priorityList.animation):(this.fireEvent("animationStart",{duration:e}),this.setState("chartAnimating",!0),this.addJob("anim-callBack",this._animCallBack,l.priorityList.animation))},t.reset=function(){this.setState("initialized",!1),this.config&&this.config.animateArr&&(this.config.animateArr.length=0),this.setState("chartAnimating",!1),this.setAnimationState()},t.registerAnimObj=function(e){var t;for(t in e)this.registerAnimation(e[t],t)},t.getFinalSlots=function(){var e=this.config,t=e.slots,r=e.workingRules={};return function n(e,t){var r,a,i,o,s,l,c=!1;if(!e)return!1;for(i=0,o=e.length;i<o;i+=1)if(a=e[i],Array.isArray(a))for(s=0,l=e[i].length;s<l;s+=1)a=e[i][s],r=!1,-1!==t.indexOf(a.name)?r=!0:a.child&&(r=a.hasAnimation=n(a.child,t)),c=c||r,a.hasAnimation=r;else r=!1,-1!==t.indexOf(a.name)?r=!0:a.child&&(r=a.hasAnimation=n(a.child,t)),c=c||r,a.hasAnimation=r;return c}(t,e.animationName),N(t,0,1,r),r["default"]={start:0,end:1},r},t.registerOne=function(e,t){this.registerAnimation([{data:[e]}],t)},t.registerAnimation=function(e,t){void 0===e&&(e=[]);var r,n,a,i=!1;for(r=0,a=e.length;r<a;r+=1)(n=e[r]).data&&n.data.length&&(this.config.animateArr.push((n.component=t,n)),i=!0);i&&this.config.animationName.push(t),!this.getState("initialized")&&this.reInitialize()},t.onAnimationComplete=function(e){this.addEventListener("animationComplete",(function(t){e(),t.detachHandler()}))},r.removeOpacityFromGroup=function(e,t){t&&d&&("group"===e||"group"===e.type)&&delete t.opacity},t.setAnimation=function(e){void 0===e&&(e={});var t,n,i,o,l,c,u,d,f,h,g,p,m,v,b=this.config,y=b.animationObj,x=e.el,w=e.attr||{},C={},k={},_=function(t,r,n,a){return function(){n.callback&&n.callback.call(this),t&&this.attr(t),r&&e.callback&&e.callback.call(this),a&&this.appendTo(a)}},S=function(e,t,r){return function(){t.hookFn&&t.hookFn.call(this),e&&this.attr(e),r&&this.appendTo(r)}},E=[],A=y.duration,N=this.getState("chartAnimating"),T="object"==typeof x&&e.container&&x.parent!==e.container;if(this.getState("chartAnimating")&&b.animationObj&&b.animationObj.duration&&this.setAnimationState("default"),!N&&A&&(f=this.getAnimAttributes(e))){for(d=f.length,v=!1,g=!(h="appearing"===e.state||"string"==typeof x)&&x.attrs,u={},c=0;c<d;c++){for(o in p=c===d-1,l=E[c]={},t=(m=f[c]).finalAttr,n=m.initialAttr,r.removeOpacityFromGroup(e.el,n),r.removeOpacityFromGroup(e.el,t),n)u[o]=n[o],k[o]===a&&(k[o]=n[o]);for(o in t)u[o]=t[o],h&&k[o]===a&&(k[o]=t[o]);if(l.attrs=t,l.transition=m.transition,l.effect=m.effect,l.animConfig=[m.startEnd],m.callback&&(l.callback=m.callback),(v=T&&m.changeGroup)&&(T=!1),p){if(h)for(o in w)k[o]===a&&(k[o]=w[o]);for(o in w)i=w[o],!u[o]&&h||u[o]===i||(t&&t[o]===a?t[o]=i:C[o]=i);for(o in u)C[o]===a&&(i=(0,s.getFirstValue)(w[o],g[o]),u[o]!==i&&(t&&t[o]===a&&i!==a?t[o]=i:C[o]=i));t||(l.attrs=C),l.callback=_((t||n)&&C,p,m,T&&e.container),x=this.setAttributes(x,{attr:k,inputJSON:e})}(n||m.hookFn||v)&&(l.animConfig[0].hookFn=S((!h||c)&&n,m,v&&e.container))}for(c=0;c<d;c++)E[c].el=x.el,this.registerAnimation([{data:[E[c]]}],f[c].slot)}else N||this.registerAnimation(),x=this.setAttributes(x,{attr:w,inputJSON:e,groupChangeReq:T,immediate:!0});return x.removed?null:x.el},t._removeElems=function(){if(this.getFromEnv("paper")&&!this.getFromEnv("paper").removed){this._removedGraphics.forEach((function(e){return e.remove&&e.remove()})),this._removedGraphics.length=0}},t.removeElement=function(e,t){return t?e.remove():this._removedGraphics.push(e),null},r._ruleSelectorQueryBuilder=function(e,t){void 0===t&&(t=!0);var r=e.label,n=e.state,a=e.component,i=a.getType(),o=a.getName();if(t){var s=["*","*.*","*.*.*"],l=["*.*."+o,"*."+i+".*","*."+i+"."+o];return"*"===n?s.concat(l):s.concat(l,[n+".*",n+".*.*",n+".*."+o,n+"."+i+".*",n+"."+i+"."+o])}return[r+"."+n,r+".*","*."+n,"*.*","*"]},t._getRulesByState=function(e){var t,n,i,o,s=e.component,l=this.getAnimationState()||"*",c=r._ruleSelectorQueryBuilder(Object.assign(e,{state:l}));return(t=(o=s.getState("animRules")||{})[l])?t:(n=o[l]={},i=this.config.animationRules,g.forEach((function(e){var t=i[e];t&&c.forEach((function(e){t[e]&&(Array.isArray(t[e])?t[e].forEach((function(e){n=o[l]=v(e)?null:Object.assign(n||{},S(e)?e.call(s):e)})):n=o[l]=v(t[e])?null:Object.assign(n||{},S(t[e])?t[e].call(s):t[e]))}))})),s.setState("animRules",o),!s.getState("ruleFlushAttached")&&s.addExtEventListener("predraw",(function(){s.setState("animRules",a),s.setState("ruleFlushAttached",!0)}),s.getFromEnv("chart")),n)},r._getRulesByElement=function(e,t){var n;return r._ruleSelectorQueryBuilder(t,!1).forEach((function(t){n===a&&(n=e[t])})),n},t.getAnimAttributes=function(e){var t,n,a,i,o,s=e.component||this.getFromEnv("chart"),l=e.label||("object"==typeof e.el?e.el.type:e.el),c=e.state,u=this._getRulesByState({label:l,component:s}),d=[];if(!v(u)&&(!c&&(c="string"==typeof e.el?"appearing":e.attr?"updating":"disappearing"),t=r._getRulesByElement(u,{component:s,state:c,label:l}),!v(t))){if(!t)return r.getFallbackAnimRule(e);if(!S(t)||(t=t.call(s,e),!v(t))){for(o=t.length,i=0;i<o;i++)a={},(n=t[i]).initialAttr&&(a.initialAttr=S(n.initialAttr)?n.initialAttr.call(s,e):Object.assign({},n.initialAttr)),n.finalAttr&&(a.finalAttr=S(n.finalAttr)?n.finalAttr.call(s,e):Object.assign({},n.finalAttr)),a.startEnd=S(n.startEnd)?n.startEnd.call(s,e):n.startEnd?Object.assign({},n.startEnd):{start:0,end:1},a.slot=n.slot||"default",a.callback=n.callback,a.hookFn=n.hookFn,a.transition=n.transition,a.effect=n.effect||"linear",n.groupChange&&(a.groupChange=!0),d.push(a);return d}}},r.getFallbackAnimRule=function(e){if("appearing"===e.state||"string"==typeof e.el){if("group"!==e.el)return[{initialAttr:{opacity:0},finalAttr:{opacity:(0,s.pluckNumber)(e.attr&&e.attr.opacity,1)},startEnd:{start:0,end:1}}]}else{if("updating"===e.state||e.attr)return[{startEnd:{start:0,end:1}}];if("group"!==e.el.type)return[{initialAttr:{opacity:1},finalAttr:{opacity:0},startEnd:{start:0,end:1}}]}},r.getFallbackAnimDuration=function(e){return f[e]||0},r.getFallbackAnimTimeSlots=function(){return[{name:"_default",start:0,end:1,child:[[{name:"initial",duration:.125},{name:"middle",duration:.75,child:[[{name:"axis",duration:.25},{name:"plot",duration:.75}]]},{name:"final",duration:.125}]]}]},t.createElement=function(e,t,r){void 0===t&&(t={});var n=e,a=this.getFromEnv("paper");if(a||(a=this.getFromEnv("chart").getFromEnv("paper"),this.addToEnv("paper",a)),"group"===n)(n=a.group(r.attr&&r.attr.name||"",r.container)).attr(t);else if("html"===n)n=a.html(r.attr.type,t,r.css,r.container);else{if("text"===n&&r.css)return a[r.el](t,r.css,r.container);n=a[r.el](t,r.container)}return n},t.setAttributes=function(e,t){var r,n=e,a=t.attr,i=t.inputJSON||{};return"string"==typeof n?n=this.createElement(n,a,i):0!==Object.keys(a).length?n.attr(a):i.attr&&"disappearing"!==i.state||(r=!i.doNotRemove),r?this.removeElement(n,t.immediate):(i.css&&n.css(i.css),t.groupChangeReq&&n.appendTo(i.container),t.immediate&&i.callback&&i.callback.call(n)),{el:n,removed:r}},t.prepareAnimateArr=function(e){var t,r,n,i,o,s,l,c,u,d=this.config.preAnimArr=[];function f(e,t){var n,i,o,s={start:0,end:1};for(o in e)if(e.hasOwnProperty(o)){if(e[o].syncWith&&!r[e[o].syncWith])continue;n=e[o].syncWith,s.start=e[o].start===a?0:e[o].start,s.end=e[o].end===a?1:e[o].end,s.hookFn=e[o].hookFn||e.hookFn,s.smartMorph=e[o].smartMorph||e.smartMorph;break}return n=n&&r[n]?n:t&&r[t]?t:"default",i=r[n].end-r[n].start,s.start=r[n].start+s.start*i,s.end=r[n].start+s.end*i,s}for(r=this.getFinalSlots(),i=0,o=e.length;i<o;i+=1){for(n=(t=e[i]).component,s=0,l=t.data.length;s<l;s+=1)(c=(u=t.data[s]).transition||r[n]&&r[n].transition)&&w(u,c),u.preAnimFn&&d.push({el:u.el,fn:u.preAnimFn}),u.animConfig&&(u.animConfig=f(u.animConfig,n));t.effect||r[n]&&(t.effect=r[n].effect),t.animConfig||(t.animConfig=[{}]),t.animConfig=f(t.animConfig,n)}},t.animate=function(){var e,t,r,n,a,i,o,s,l=this.config,c=this.config.animateArr,u=l.animationObj,d=u.animObj,f=u.dummyObj,h=u.duration;for(this.prepareAnimateArr(c),function(e){var t=0,r=e.length;for(t=0;t<r;++t)e[t].fn&&e[t].fn.call(e[t].el)}(this.config.preAnimArr),a=0,i=c.length;a<i;a+=1)for(o=0,s=(t=c[a]).data.length-1;o<=s;o+=1)r=t.data[o].animConfig||t.animConfig,r=y(r,h,180),e=t.data[o].effect||t.effect||"linear",n=a===i&&t.callback||t.data[o].callback,t.data[o].preAttrs&&t.data[o].el.attr(t.data[o].preAttrs),t.data[o].el&&C(t.data[o].el,t.data[o].attrs,n||null,r,f,d,h,e)},t.remove=function(t){this.removeAllJobs(),t.instant&&this.getGraphicalElement("dummyObj")&&this.getGraphicalElement("dummyObj").remove(),e.prototype.remove.call(this,t)},r}(c.ComponentInterface);t["default"]=T},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n={pie2d:["isPlotItemSliced","addData","removeData","updateData","slicePlotItem","startingAngle"],dragcolumn2d:["getDataWithId","getData","setUpperLimit","setLowerLimit","getLowerLimit","getUpperLimit"],realtimecolumn:["feedData","setData","stopUpdate","restartUpdate","isUpdateActive","clearChart","getData","getDataForId","setDataForId","getDataJSON","showLog","hideLog","clearLog"],scrollcolumn2d:["scrollTo"],scrollbar2d:["scrollTo"],boxandwhisker2d:["scrollTo"],doughnut:["centerLabel"],zoomline:["zoomOut","zoomTo","resetChart","setZoomMode","getViewStartIndex","getViewEndIndex","scrollTo"],maps:["getMapName","getEntityList","getMapAttribute","exportMap","addMarker","updateMarker","removeMarker"],"*":["exportChart","getXML","getChartAttribute","getCSVData","getChartData","getDataAsCSV","getJSONData","getSVGString","getXMLData"]};n.pie3d=n.pie2d,n.doughnut2d=n.doughnut3d=n.doughnut.concat(n.pie2d),n.dragarea=n.dragline=n.dragnode=n.dragcolumn2d,n.realtimearea=n.realtimeline=n.realtimelinedy=n.realtimestackedarea=n.realtimestackedcolumn=n.bulb=n.angulargauge=n.hlineargauge=n.hled=n.vled=n.vbullet=n.hbullet=n.thermometer=n.cylinder=n.realtimecolumn,n.scrollarea2d=n.scrollline2d=n.scrollcombidy2d=n.scrollcombi2d=n.scrollstackedcolumn2d=n.scrollmsstackedcolumn2d=n.scrollmsstackedcolumn2dlinedy=n.scrollcolumn2d,n.zoomlinedy=n.zoomline;var a=n;t["default"]=a},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n={extension:function(){function e(){}var t=e.prototype;return t.draw=function(){},t.drawAt=function(){},t.hide=function(){},t.hideAll=function(){},t.enableToolTip=function(){},t.disableToolTip=function(){},t.setStyle=function(){},e}(),name:"ToolTipController",type:"plugin"};t["default"]=n},function(e,t,r){"use strict";r(248),r(282)},function(e,t,r){"use strict";r(246),r(245),r(247)},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(284));t.MessageLogger=a["default"];var i=n(r(287));t.linkedChartsExtension=i["default"];var o=n(r(289));t.XMLTranscoder=o["default"];var s=n(r(290));t.CSVTranscoder=s["default"];var l=n(r(310));t.JSONUrlTranscoder=l["default"];var c=n(r(313));t.XMLUrlTranscoder=c["default"];var u=n(r(314));t.IgnoreCaseExt=u["default"];var d=n(r(315));t.ThemeEngine=d["default"];var f=n(r(316));t.DefaultTheme=f["default"];var h=n(r(317));t.PlotHighlighter=h["default"];var g=n(r(319));t.ToolTipController=g["default"];var p=n(r(321));t.ConsolidatedToolTip=p["default"];var m=n(r(322));t.AlertManager=m["default"];var v=n(r(324));t.DataSkipping=v["default"];var b=n(r(328));t.Annotation=b["default"];var y=n(r(353));t.RegressionExtension=y["default"];var x=n(r(359));t.inputAdapter=x["default"];var w=n(r(388));t.LegendEventManagerLinker=w["default"];var C=n(r(389));t.exportModule=C["default"];var k=n(r(396));t.BatchExportLinker=k["default"];var _=n(r(397));t.LogoExtension=_["default"];var S=n(r(399));t.supportOldThemes=S["default"];var E=n(r(400));t.debug=E["default"];var A=n(r(401));t.CenterLabel=A["default"];var N=n(r(404));t.CrossLine=N["default"];var T=n(r(408));t.MultiCanvasCrossLine=T["default"];var M=n(r(409));t.ResourceString=M["default"];var D={name:"features",type:"package",requiresFusionCharts:!0,extension:function(e){e.addDep(i["default"]),e.addDep(o["default"]),e.addDep(s["default"]),e.addDep(l["default"]),e.addDep(c["default"]),e.addDep(u["default"]),e.addDep(d["default"]),e.addDep(h["default"]),e.addDep(f["default"]),e.addDep(g["default"]),e.addDep(p["default"]),e.addDep(m["default"]),e.addDep(a["default"]),e.addDep(v["default"]),e.addDep(b["default"]),e.addDep(C["default"]),e.addDep(y["default"]),e.addDep(x["default"]),e.addDep(w["default"]),e.addDep(k["default"]),e.addDep(_["default"]),e.addDep(S["default"]),e.addDep(E["default"]),e.addDep(A["default"]),e.addDep(N["default"]),e.addDep(T["default"]),e.addDep(M["default"])}};t["default"]=D},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(285)),i={timeseries:!0},o=function(e){var t=e.sender.getName().toLowerCase();"chartAPI"!==e.sender.getType()||i[t]||e.sender.registerFactory("messageLogger",(function(t){if(t.getChildren("messageLogger"))t.getChildren("messageLogger")[0].configure(t);else{var r=new a["default"];r.configure(t),r.addToEnv("chart-container",t.getFromEnv("chart-container")),t.attachChild(r,"messageLogger"),t.getFromEnv("chartInstance").showLog=function(){return r&&r.show&&r.show()},t.getFromEnv("chartInstance").hideLog=function(){return r&&r.hide&&r.hide()},t.getFromEnv("chartInstance").clearLog=function(){return r&&r.clearLog&&r.clearLog()},e.sender.addEventListener("realtimeDataUpdate",(function(e){e.sender.getChildren("messageLogger")&&e.sender.getChildren("messageLogger")[0].addLog(e.data)}))}}))};var s={extension:function(e){e.addEventListener("instantiated",o)},name:"messageLoggerLinker",type:"extension",requiresFusionCharts:!0};t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(286)),o=r(240),s=r(224),l=Math.min,c=function(e){function t(){var t;return(t=e.call(this)||this).pIndex=1,t.linkedItems=t.linkedItems||(t.linkedItems={}),t.components=t.components||{},t.components.messages=t.components.messages||[],t.graphics=t.graphics||{},t.config=t.config||(t.config={}),t}(0,a["default"])(t,e);var r=t.prototype;return r.getType=function(){return"extension"},r.getName=function(){return"MessageLogger"},r.configure=function(e){this.linkedItems.chart=e;var t=e.getFromEnv("chart-attrib")||{},r=this.config.usemessagelog=e.getFromEnv("chartConfig").usemessagelog;this.config.messageLogWPercent=l((0,s.pluckNumber)(t.messagelogwpercent,80),100),this.config.messageLogHPercent=l((0,s.pluckNumber)(t.messageloghpercent,70),100),this.config.messageLogShowTitle=(0,s.pluckNumber)(t.messagelogshowtitle,1),this.config.messageLogTitle=(0,s.pluck)(t.messagelogtitle,"Message Log"),this.config.messageLogColor=(0,s.pluck)(t.messagelogcolor,"#fbfbfb").replace(/^#?([a-f0-9]+)/gi,"$1"),this.config.messageLogColorRgb=(0,s.HEXtoRGB)(this.config.messageLogColor),this.config.messageGoesToJS=(0,s.pluckNumber)(t.messagegoestojs,0),this.config.messageGoesToLog=(0,s.pluckNumber)(t.messagegoestolog,1),this.config.messageJSHandler=(0,s.pluck)(t.messagejshandler,""),this.config.messagePassAllToJS=(0,s.pluckNumber)(t.messagepassalltojs,0),this.config.messagePassAsObject=(0,s.pluckNumber)(t.messagepassasobject,0),this.config.messageLogIsCancelable=(0,s.pluckNumber)(t.messagelogiscancelable,1),this.config.alwaysShowMessageLogMenu=(0,s.pluckNumber)(t.alwaysshowmessagelogmenu,r),e.config.useShowLogMenu=r&&this.config.messageGoesToLog,this.config.dynamicScrolling=!1,this.config.scrollToBottom=!0},r._createMessage=function(e){var t=new i["default"](e,this);return this.graphics.container&&t.draw(),t},r.addLog=function(e){var t,r=this.components.messages,n=(0,s.pluckNumber)(e.msgGoesToLog,this.config.messageGoesToLog),a=(0,s.pluckNumber)(e.msgGoesToJS,this.config.messageGoesToJS),i=window[this.config.messageJSHandler],o=(0,s.pluck)(e.msgId,""),l=(0,s.pluck)(e.msgTitle,""),c=(0,s.pluck)(e.msgText,""),u=(0,s.pluck)(e.msgType,"literal");0!==this.config.usemessagelog&&(a&&i&&"function"==typeof i&&(this.config.messagePassAllToJS?this.config.messagePassAsObject?i(e):i(o,l,c,u):i(c)),"1"===e.clearLog&&this.clearLog(),n&&(e.msgTitle||e.msgText)&&(t=this._createMessage(e),r.push(t),1!==r.length||this.config.visible||this.show()))},r.show=function(){this.config.visible||1!==this.config.usemessagelog||(this.config.visible=!0,this.draw(),this.graphics.container||this.draw(),this.graphics.container&&this.graphics.container.show())},r.hide=function(){this.config.visible=!1,this.graphics.container&&this.graphics.container.hide()},r.clearLog=function(){var e,t=this.components.messages,r=t.length;for(e=0;e<r;e+=1)t[e]&&t[e].dispose&&t[e].dispose();t.splice(0,r)},r.isDrawn=function(){return!!this.graphics.container},r.draw=function(){var e,t,r=this.components.messages;if(0===this.config.usemessagelog)this.isDrawn()&&(this.clearLog(),this.hide());else for(this._createHTMLDialogue(),this.config.visible||this.hide(),t=r.length,e=0;e<t;e+=1)r[e]&&r[e].draw&&r[e].draw()},r._createHTMLDialogue=function(){var e,t,r,n,a=this,i=this.config,o=this.graphics,s=this.getFromEnv("paper"),l=this.linkedItems.chart.config,c=l.width,u=l.height,d=l.style,f=d&&d.inCanvasStyle,h=this.config.messageLogWPercent,g=this.config.messageLogHPercent,p=this.config.messageLogShowTitle,m=this.config.messageLogIsCancelable,v=this.config.messageLogColor,b=this.config.messageLogTitle,y=c*(h/100),x=u*(g/100),w=(c-y)/2,C=(u-x)/2,k=y-18-22,_=x-18-22,S=v,E=v,A=o.container,N=this.isDrawn()&&l.animation&&l.animation.transposeAnimDuration;A||(A=o.container=s.html("div",{fill:"transparent"},{fontSize:"10px",lineHeight:"15px"},this.getFromEnv("chart-container")),o.veil=s.html("div",{id:"veil",fill:"000000",opacity:.1},void 0,A).on("fc-click",(function(){m&&a.hide()})),b&&p&&(o.title=s.html("p",{id:"Title",innerHTML:b,x:5,y:5},{"font-weight":"bold"},A)),o.dialog=s.html("div",{id:"dialog",strokeWidth:1},{borderRadius:"5px",boxShadow:"1px 1px 3px #000000","-webkit-border-radius":"5px","-webkit-box-shadow":"1px 1px 3px #000000",filter:'progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color="#000000")'},A),o.logBackground=s.html("div",{id:"dialogBackground",x:0,y:0},void 0,o.dialog),m&&(o.closeButton=s.html("div",{id:"closeButton",x:y-11-3,y:2,innerHTML:"<b>x</b>"},{cursor:"pointer",_cursor:"hand"},o.dialog).on("fc-click",(function(){m&&a.hide()}))),o.logWrapper=s.html("div",{id:"logWrapper"},{overflow:"auto"},o.dialog).on("scroll",(function(){var e=this&&this.scrollTop,t=this&&this.scrollHeight,r=this&&this.offsetHeight;i.dynamicScrolling?i.dynamicScrolling=!1:i.scrollToBottom=t-e===r})),o.log=s.html("div",{id:"log",x:0,y:0},{},o.logWrapper)),A.css({fontFamily:f.fontFamily}),o.dialog.attr({fill:"ffffff",stroke:S}),o.logBackground.attr({fill:E}),e={width:c,height:u},t={x:w,y:C,width:y,height:x},r={width:y,height:x},n={x:(y-k)/2,y:(x-_)/2,width:k,height:_},N?(A.animate(e,N,"normal"),o.veil.animate(e,N,"normal"),o.dialog.animate(t,N,"normal"),o.logBackground.animate(r,N,"normal"),o.logWrapper.animate(n,N,"normal")):(A.attr(e),o.veil.attr(e),o.dialog.attr(t),o.logBackground.attr(r),o.logWrapper.attr(n))},t}(o.ComponentInterface);t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a=8===window.document.documentMode,i={},o={display:"block",paddingLeft:"10px",paddingRight:"10px","font-family":"Arial","font-size":"11px"};i.literal=i.info={title:'<span style="color: #005900">$titleVal$</span>',body:'<span">$msgVal$</span>'},i.link={title:i.info.title,body:'<a href="$msgLinkVal$">$msgVal$</a>'},i.error={title:'<span style="color: #CC0000">$titleVal$</span>',body:'<span style="color: #CC0000">$msgVal$</span>'};var s=function(){function e(e,t){this.config={},this.messageType=(e.msgType&&e.msgType.replace(/^[\r\n]+|\.|[\r\n]+$/g,"")||"").toLowerCase(),this.msgTitle=e.msgTitle,this.msgText=e.msgText,this.msgLink=e.msgLink,this.graphics={},this.linkedItems={msgLogger:t},this.msgObj=i[this.messageType]||i.literal,this.configureMsgTextAndMsgTitle()}var t=e.prototype;return t.configureMsgTextAndMsgTitle=function(){this.config.totalHTML=n.BLANKSTRING,this.msgTitle&&(this.config.titleHTML=this.msgObj.title.replace("$titleVal$",this.msgTitle),this.config.totalHTML+=this.config.titleHTML),this.msgText&&(this.config.msgHTML=this.msgObj.body.replace("$msgVal$",this.msgText),this.config.msgHTML=this.config.msgHTML.replace("$msgLinkVal$",this.msgText),this.config.totalHTML+=this.config.msgHTML)},t.draw=function(){var e,t,r,i=this.graphics.element,s=this.linkedItems.msgLogger,l=s.graphics,c=l&&l.log&&l.log.element,u=l.logWrapper&&l.logWrapper.element,d=s.config;if(!i){for(e in i=this.graphics.element=window.document.createElement("span"),o)i.style[e]=o[e];c.appendChild&&c.appendChild(i)}this.graphics.element.innerHTML=this.config.totalHTML,n.isIE&&a&&(t=c.innerHTML,c.innerHTML=t),d.scrollToBottom&&(d.dynamicScrolling=!0,r=u.scrollHeight,u.scrollTop=r)},t.dispose=function(){var e=this.linkedItems.msgLogger;e&&e.graphics&&e.graphics.log&&e.graphics.log.element&&e.graphics.log.element.removeChild&&e.graphics.log.element.removeChild(this.graphics.element),delete this.graphics.element,n.componentDispose.call(this)},e}();t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=l(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(288)),i=r(231),o=r(224),s=n(r(226));function l(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(l=function(e){return e?r:t})(e)}var c=o.regex.dropHash;function u(e,t){return(e.options.containerElement===t.options.containerElement||e.options.containerElementId===t.options.containerElementId)&&e.options.insertMode===o.domInsertModes.REPLACE}function d(e){var t;e.sender.link instanceof a["default"]&&!e.sender.link.root.disposed?e.sender.link.parent instanceof this&&!(t=e.sender.link.parent.link.items)[e.sender.id]&&(t[e.sender.id]=e.sender):e.sender.link=new a["default"](e.sender)}function f(e,t){var r,n=t;if(e instanceof Array){for(r=0;r<e.length;r+=1)"object"!=typeof a.store[this.link.root.id][r]&&(a.store[this.link.root.id][r]={}),(0,o.extend2)(a.store[this.link.root.id][r],e[r],!1,!0);a.store[this.link.root.id].splice(e.length)}else"object"==typeof e?("number"!=typeof n&&(n=this.link.level),"undefined"==typeof a.store[this.link.root.id][n]&&(a.store[this.link.root.id][n]={}),(0,o.extend2)(a.store[this.link.root.id][n],e,!1,!0)):(0,i.raiseError)(this,"25081731","param","~configureLink()","Unable to update link configuration from set parameters")}function h(e){var t,r,n,a=this.jsVars,l=a.overlayButton;if(e&&e.show){for(l||(l=a.overlayButton=document.createElement("span"),s["default"].listen(l,"click",(function(){(0,i.triggerEvent)("OverlayButtonClick",a.fcObj,e)}))),n=e.message?e.message:"Back";l.firstChild;)l.removeChild(l.firstChild);for(r in l.appendChild(document.createTextNode(n)),a.overlayButtonMessage=n,t={border:"1px solid "+(e.borderColor?e.borderColor.replace(c,o.HASHSTRING):"#7f8975"),backgroundColor:e.bgColor?e.bgColor.replace(c,o.HASHSTRING):"#edefec",fontFamily:e.font?e.font:"Verdana,sans",color:e.fontColor,fontSize:(e.fontSize?e.fontSize:"10")+o.PXSTRING,padding:(e.padding?e.padding:"3")+o.PXSTRING,fontWeight:0===parseInt(e.bold,10)?o.NORMAL:o.BOLD,position:"absolute",top:"0",right:"0",cursor:o.POINTER})l.style[r]=t[r];a.hcObj.container.appendChild(l),a.overlayButtonActive=!0}else l&&(a.overlayButton=l.parentNode.removeChild(l),a.overlayButtonActive=!1,delete a.overlayButtonMessage)}var g={type:"extension",name:"LinkedChart",extension:function(e){e.prototype.configureLink=f,e.prototype.drawOverlayButton=h,e.addEventListener("beforeRender",d),e.addEventListener("beforeInitialize",d),e.addEventListener("linkedChartInvoked",(function(t,r){var n,s=t.sender,l=s.clone({dataSource:r.data,dataFormat:r.linkType,link:new a["default"](s.link.root,s,s instanceof e),clickedEntity:r.clickedEntity,clickedEntityBox:r.clickedEntityBox},!0),c=r.alias;c&&(!l.typeSource&&l.swfUrl&&(l.typeSource=l.swfUrl.replace(/(.*?)?[^\/]*\.swf.*?/gi,"$1")),l.type=c),s.args&&0!==parseInt(s.args.animate,10)&&delete l.animate,(0,o.extend2)(l,s.link.configuration(),!1,!0),(0,i.triggerEvent)("beforeLinkedItemOpen",s.link.root,{level:s.link.level},void 0,(function(){e.items[l.id]instanceof e&&e.items[l.id].dispose(),u(n=new e(l),s)||s.options.overlayButton&&s.options.overlayButton.message||("object"!=typeof s.options.overlayButton&&(s.options.overlayButton={}),s.options.overlayButton.message="Close"),n.render(),(0,i.triggerEvent)("linkedItemOpened",s.link.root,{level:s.link.level,item:n})}))})),e.addEventListener("overlayButtonClick",(function(t,r){var n,a,o,s;"LinkManager"===r.id&&(n=t.sender,a=n.link.level-1,o=n.link.parent,s=n.link.root,(0,i.triggerEvent)("beforeLinkedItemClose",s,{level:a,item:n},void 0,(function(){setTimeout((function(){e.items[n.id]&&n.dispose(),(0,i.triggerEvent)("linkedItemClosed",s,{level:a})}),0),o.disposed||o.isActive()||!u(n,o)?(o._addChartDependency("returnFromLinkedChart",{resolve:function(){return{state:3}}}),o._setState()):o.render()})))})),e.addEventListener("DrawComplete",(function(t){var r,n=t.sender;n&&"undefined"!=typeof n.link&&n.link.root!==n&&n.link.parent instanceof e&&(n.ref&&"function"==typeof n.drawOverlayButton?(r=(0,o.extend2)({show:!0,id:"LinkManager"},n.link.parent.options.overlayButton,!1,!0),(0,o.extend2)(r,n.link.parent.link.configuration().overlayButton||{},!1,!0),n.drawOverlayButton(r)):(0,i.raiseWarning)(n,"04091602","run","::LinkManager^Loaded","Unable to draw overlay button on object. -"+n.id))})),e.addEventListener("beforeDispose",(function(t){var r=t.sender;r&&r.link instanceof a["default"]&&(r&&r.link&&r.link.parent instanceof e&&r.link.parent.link&&r.link.parent.link.items&&delete r.link.parent.link.items[t.sender.id],delete a.store[r.id])}))},requiresFusionCharts:!0};t["default"]=g},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=t.store=void 0;var n={};t.store=n;var a=function(){function e(e,t,r){this.items={},this.root=e,this.parent=t,r?this.level=this.parent.link.level+1:(n[e.id]=[{}],this.level=0)}return e.prototype.configuration=function(){return n[this.root.id][this.level]||(n[this.root.id][this.level]={})},e}();t["default"]=a},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n,a=r(224),i=function(e,t,r){return"object"==typeof this.items[e][r]?this.items[e][r][t]:this.items[e][r]};function o(e){return e.replace(/</g,"&lt;").replace(/>/g,"&gt;")}var s,l,c,u,d=(u={arr:{set:!0,node:!0,nodes:!0,link:!0,links:!0,trendlines:!0,vtrendlines:!0,line:{trendlines:!0,vtrendlines:!0},data:!0,dataset:!0,lineset:!0,categories:!0,category:!0,tasks:!0,linkeddata:!0,application:!0,definition:!0,axis:!0,connectors:!0,connector:{connectors:!0},trendset:!0,row:{rows:!0},column:{columns:!0},label:{labels:!0},color:{colorrange:!0},dial:{dials:!0},pointer:{pointers:!0},point:{trendpoints:!0},process:{processes:!0},task:{tasks:!0},milestone:{milestones:!0},datacolumn:{datatable:!0},text:{datacolumn:!0},item:{legend:!0},alert:{alerts:!0},groups:{annotations:!0},items:{groups:!0,data:!0},shapes:!0,shape:{shapes:!0},entitydef:!0,entity:{entitydef:!0}},tag:{chart:"linkedchart",map:"linkedmap",set:"data",node:"nodes",link:"links",vline:{chart:"data",graph:"data",dataset:"data",categories:"category",linkedchart:"data"},apply:{application:"application"},style:{definition:"definition"},marker:{application:"application",definition:"definition",data:"items"},entity:{entitydef:"entitydef",data:"data"},shape:{shapes:"shapes"},connector:{connectors:{chart:"connector",linkedchart:"connector",map:"connectors",linkedmap:"connectors"}},annotationgroup:{annotations:"groups"},annotation:{groups:"items"}},attr:{vline:{vline:"true"}},ins:{chart:!0,map:!0,graph:!0},dsv:{dataset:"data",categories:"category"},text:{target:"target",value:"value"},group:{styles:{definition:!0,application:!0},chart:{value:!0,target:!0},graph:{value:!0,target:!0},linkedchart:{value:!0,target:!0},markers:{definition:!0,application:!0,shapes:!0,connectors:!0,data:!0},map:{entitydef:!0,data:!0},linkedmap:{entitydef:!0,data:!0}}},s={append:function(e,t,r,n){!u.arr[r]||!0!==u.arr[r]&&!0!==u.arr[r][n]?t[r]=e:(t[r]instanceof Array||(t[r]=[]),t[r].push(e))},child:function(e,t,r,n){var i,o,l,c,d,f;for(i=0;i<t.length;i+=1)switch(o=(l=t[i]).nodeName.toLowerCase(),l.nodeType){case 1:if(c=s.attr(l.attributes),!0===(f=u.ins[o])&&(d=c,(c={})[o]=d,d=void 0),"object"==typeof(f=u.attr[o])&&(0,a.extend2)(c,f,!1,!0),f=u.tag[o])if("object"==typeof f&&"object"==typeof f[r]){for(d in d=void 0,f[r])if(n[d]){o=f[r][d];break}}else"object"==typeof f&&"string"==typeof f[r]?o=f[r]:"string"==typeof f&&(o=f);l.childNodes.length&&((f=u.group[r])&&f[o]?s.child(e,l.childNodes,o,n):s.child(c,l.childNodes,o,n)),(f=u.group[r])&&f[o]||s.append(c,e,o,r);break;case 3:(f=u.text[r])&&(o=f,c=l.data,s.append(c,e,o,r)),"string"==typeof(f=u.dsv[r])&&n.chart&&parseInt(n.chart.compactdatamode,10)&&(o=f,c=l.data,e[o]=e[o]?e[o]+c:c)}},attr:function(e){var t,r={};if(!e||!e.length)return r;for(t=0;t<e.length;t+=1)"xml"===c&&(e[t].value?e[t].value=o(e[t].value):e[t].nodeValue&&(e[t].nodeValue=o(e[t].nodeValue))),r[e[t].nodeName.toLowerCase()]=e[t].value||e[t].nodeValue;return r}},l=function(e){var t,r,i,o,c,u,d,f,h,g={},p=e;if("object"!=typeof p&&p&&"function"!=typeof p.toString)return l.errorObject=new TypeError("xml2json.parse()"),g;if(p=p.toString().replace(/<\!--[\s\S]*?-->/g,"").replace(/<\?xml[\s\S]*?\?>/gi,"").replace(/&(?!([^;\n\r]+?;))/g,"&amp;$1"),!(p=(0,a.fastTrim)(p)))return g;try{if(window.DOMParser?t=(new window.DOMParser).parseFromString(p,"text/xml"):document.body&&n.options.allowIESafeXMLParsing?((r=document.createElement("xml")).innerHTML=p,document.body.appendChild(r),t=r.XMLDocument,document.body.removeChild(r),r=null):((t=new window.ActiveXObject("Microsoft.XMLDOM")).async="false",t.loadXML(p)),!(t&&t.childNodes&&1===t.childNodes.length&&(i=t.childNodes[0])&&i.nodeName&&(o=i.nodeName.toLowerCase()))||"chart"!==o&&"map"!==o&&"graph"!==o)return l.errorObject=new TypeError("xml2json.parse()"),g;if("graph"===o){for(c=t.createElement("chart"),h=(d=i.attributes)&&d.length||0;h--;)c.setAttribute(d[h].name,d[h].value),d.removeNamedItem(d[h].name);for((h=(f=i.childNodes)&&f.length||0)&&(h-=1,u=i.removeChild(f[h]),c.appendChild(u));h--;)u=i.removeChild(f[h]),c.insertBefore(u,c.firstChild);t.replaceChild(c,i),i=c}}catch(m){l.errorObject=m}return i?(i.attributes&&(g[o]=s.attr(i.attributes)),i.childNodes&&s.child(g,i.childNodes,o,g),delete l.errorObject):l.errorObject=new TypeError("xml2json.parse()"),g},function(e){return delete l.errorObject,c=arguments[arguments.length-1],{data:l(e),error:l.errorObject}}),f=function(){var e,t;return e={items:{explode:{data:"set",nodes:"node",links:"link",groups:{annotations:"annotationgroup"},items:{groups:"annotation"}},text:{chart:{target:"target",value:"value"},graph:{target:"target",value:"value"}},dsv:{dataset:{data:"dataset"},categories:{category:"categories"}},attr:{chart:{chart:"chart"},graph:{graph:"graph"},map:{map:"map"},linkedmap:{map:"map"},linkedchart:{chart:"chart"}},group:{styles:{definition:"style",application:"apply"},map:{data:"entity",entitydef:"entity"},markers:{definition:"marker",application:"marker",shapes:"shape",connectors:"connector",items:"marker"}},tag:{markers:{items:"data"}}},qualify:i},t=function(r,n,i,o){var s,l,c,u,d=a.BLANKSTRING,f=a.BLANKSTRING,h=a.BLANKSTRING,g=a.BLANKSTRING,p=n;if(p&&"function"==typeof p.toLowerCase&&(p=p.toLowerCase()),void 0===i&&r[p])for(l in r[p])"compactdatamode"===(c=l.toLowerCase())&&(o.applyDSV=1===r[p][l]);if(r instanceof Array)for(l=0;l<r.length;l+=1)"string"==typeof r[l]?h+=(0,a.xssEncode)(r[l]):h+=t(r[l],p,i,o);else{for(l in r)c=l.toLowerCase().replace(/[`~!@#$%^&*()|+\=?;:'", <>\{\}\[\]\\\/]/gi,""),r[l]instanceof Array&&(u=e.qualify("group",c,p))?f+="<"+(s=e.qualify("tag",c,p)||c)+">"+t(r[l],u,p,o)+"</"+s+">":"object"==typeof r[l]?(u=e.qualify("attr",c,p))?(g=t(r[l],u,p,o).replace(/\s*\/\>/gi,""),p=c):f+=t(r[l],c,p,o):o.applyDSV&&(u=e.qualify("dsv",c,p))?f+=r[l]:(u=e.qualify("text",c,p))?f+="<"+(s=e.qualify("tag",c,p)||u)+">"+r[l]+"</"+s+">":"vline"===c&&Boolean(r[l])?p="vline":d+=" "+c+'="'+(0,a.xssEncode)(r[l]).toString().replace(/\"/gi,"&quot;")+'"';(u=e.qualify("explode",i,p))&&(p=u),s=p,h=(""!==g?g:"<"+s)+d+(""!==f?">"+f+"</"+s+">":" />")}return h},function(e){delete t.errorObject;var r=e;if(r&&"string"==typeof r)try{r=JSON.parse(r)}catch(a){t.errorObject=a}var n=r&&r.graph?"graph":r&&r.map?"map":"chart";return{data:t(r,n,void 0,{}),error:t.errorObject}}}(),h=function(){return this.getChartData("xml")},g=function(e){this.setChartData(e,"xml")},p={extension:function(e){return e&&(n=e,e.prototype.getXMLData=h,e.prototype.setXMLData=g),{format:"xml",toJSON:d,fromJSON:f}},name:"XML",type:"transcoder",requiresFusionCharts:!0};t["default"]=p},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(223)),i=r(231),o=r(224),s=n(r(291)),l=n(r(292));function c(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}var u,d,f,h,g,p,m,v,b,y,x,w,C=window,k=C.parseInt,_=C.parseFloat,S=function(e){return e},E=function(){function e(e){this.data=[],this.rowCount=0,this.columnCount=0,this.configure(e)}var t=e.prototype;return t.set=function(e,t,r){var n;if(this.rowCount<=e){for(n=this.rowCount;n<=e;n+=1)this.data[n]=[];this.rowCount=e+1}this.columnCount<=t&&(this.columnCount=t+1),this.data[e][t]=r},t.setRow=function(e,t){var r;if(this.rowCount<=e){for(r=this.rowCount;r<=e;r+=1)this.data[r]=[];this.rowCount=e+1}this.columnCount<t.length&&(this.columnCount=t.length),this.data[e]=t},t.get=function(e,t){var r=this.data;return r[e]&&r[e][t]},t.configure=function(t){var r=e.decodeLiterals;this.delimiter=r(t.delimiter,","),this.qualifier=r(t.qualifier,'"'),this.eolCharacter=r(t.eolCharacter,"\r\n"),this.numberFormatted=!!k(t.numberFormatted,0)},t.clear=function(){this.data=[],this.rowCount=0,this.columnCount=0},t.toString=function(){var e,t,r=o.BLANKSTRING;for(e=0;e<this.rowCount;e+=1)r+='""'===(t=this.qualifier+this.data[e].join(this.qualifier+this.delimiter+this.qualifier)+this.qualifier)?this.eolCharacter:t+this.eolCharacter;return this.rowCount>0&&(r=r.slice(0,r.length-2)),r},e}();function A(){return this.getChartData("csv")}function N(){return this.getCSVData()}E.decodeLiterals=function(e,t){return e!==d&&null!==e&&e.toString?e.replace("{tab}","\t").replace("{quot}",'"').replace("{apos}","'"):t},g=function(e){var t={},r=[];for(var n in(0,s["default"])(e)&&e.forEach((function(e){t[e.id]=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?c(Object(r),!0).forEach((function(t){(0,a["default"])(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):c(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({},e),!t[e.id].parent&&(t[e.id].isRootNode=!0),!t[e.id].categories&&(t[e.id].category=[])})),e.forEach((function(e){var r=t[e.id],n=!1;!r.id||r.value&&isNaN(+r.value)||(!r.parent||r.parent&&t[r.parent])&&(n=!0),n||delete t[r.id]})),t)if(t.hasOwnProperty(n)){var i=t[n];i.parent&&t[i.parent].category.push(i),i.isRootNode&&r.push(i)}return{category:r}},b=function(e,t,r){var n;if(void 0===r&&(r="category"),p.push(e.label||e.name||o.BLANKSTRING),m.push(isNaN(+e.value)?"":e.value),t.setRow(x++,p.slice()),v++,w=Math.max(w,v),e[r]!==d){for(n=0;n<e[r].length;++n)b(e[r][n],t,r);p.pop(),v--}else p.pop(),v--},y=function(e){var t,r,n,a=e,i=a.chart,o=a.data?"data":"category",s=a&&a[o]||[],l=s.length,c=[];for(x=1,w=0,v=0,n=new E({separator:i.exportdataseparator,qualifier:i.exportdataqualifier,numberFormatted:i.exportdataformattedval}),m=[],t=0;t<l;++t)r=s[t],p=[],b(r,n,o);for(t=0;t<w;++t)c.push("Label "+(t+1));for(c.push("Value"),n.setRow(0,c),t=m.length-1;t>=0;t--)n.set(t+1,w,m[t]);return{data:n.toString(),error:d,predictedFormat:{multilevel:!0}}},f=function(e,t){var r,n,a,i,o,s,c,f,h,p,m,v,b,x,w,C,k,A,N,T,M,D,F,I,O,L,R,P,V,j,B,z,H,U,G,W,$,X,Y,q,K,J,Z,Q,ee=e,te=t&&t.jsVars,re=te&&te.instanceAPI,ne=ee.chart||ee.map||ee.graph||{},ae=re&&re.getFromEnv("number-formatter"),ie=ne&&ne.forcedecimals?ne.forcedecimals:0,oe=ne&&ne.decimals!==d?Number(ne.decimals):NaN,se=ae?function(e){return ae.getCleanValue(e)}:t&&t._getCleanValue?function(e){return t._getCleanValue(e,ne)}:S,le=Boolean(ne.exporterrorcolumns||0),ce=ee.categories&&ee.categories[0]&&ee.categories[0].category||[],ue=ee.map&&!ee.chart||te&&te.instanceAPI&&"geo"===te.instanceAPI.defaultSeriesType,de=!1,fe=!1,he=!1,ge=!1,pe=!1,me=re.getChildren("BoxAndWhiskerStatisticalCalc"),ve=!1,be=!1,ye=S,xe={},we=ee.tasks?Array.isArray(ee.tasks)?ee.tasks[0].task:ee.tasks.task:d,Ce=ee.processes?ee.processes.process:d,ke=ee.datatable?Array.isArray(ee.datatable)?ee.datatable[0]:ee.datatable:d,_e=ke?ke.datacolumn:d,Se=we&&Ce,Ee=0,Ae=-1,Ne="timeseries"===t.args.type,Te=re.config.defaultDatasetType,Me=0,De=0,Fe=0,Ie=0;if(!Ne&&(e.category||e.data&&e.data[0].data))return y(e);if(r=new E({separator:ne.exportdataseparator,qualifier:ne.exportdataqualifier,numberFormatted:ne.exportdataformattedval}),u.formatNumber&&r.numberFormatted&&(ye=function(e,t){return u.formatNumber(e,ne,t)}),Ne){for(Z=ee.data.getSchema(),q=ee.data.isUTCEnabled(Z[0].name),K=Z[0].format,J=q?l["default"].utcFormatter(K):l["default"].formatter(K),h=ee.data.getData().data,o=0;o<Z.length-1;o+=1)r.set(0,o,"date"===Z[o].type?"Date Time":Z[o].name);for(c=0;c<h.length;c+=1){for(N=h[c],W=[],s=0;s<o;s+=1)0===s?(Y=J.format(N[s]),W[s]=Y):W[s]=(Ee+=N[s],ye(N[s]));r.setRow(c+1,W)}}else{if(ue)for(R in xe.geo=!0,L=(h=te.instanceAPI.getDatasets())&&h[0]&&h[0].components.data||[],r.setRow(0,["Id"," Short Name","Long Name","Value","Formatted Value"]),o=0,L)z=(V=(P=L[R]).config).cleanValue,!0!==P.hidden&&r.setRow(++o,[R,V.shortLabel,V.label,null===z?"":z,V.formattedValue]);else if((h=ee.dials&&ee.dials.dial||ee.pointers&&ee.pointers.pointer||ee.value)!==d)if(xe.gauge=!0,"string"==typeof h)r.set(0,0,ye(h)),xe.singlevalue=!0,"string"==typeof ee.target&&(r.set(0,1,ye(ee.target)),xe.bullet=!0);else for(r.setRow(0,["Id","Value"]),xe.multivalue=!0,o=0,c=1,s=h.length;o<s;o+=1,c+=1)r.setRow(c,[c,ye(h[o].value)]);else if(!Se&&(h=ee.dataset||!(ee.data instanceof Array)&&[])){if(xe.multiseries=!0,a=1,(p=ee.lineset)&&(h=h.concat(p),xe.lineset=!0),(m=ee.axis)&&(h=h.concat(m),xe.multiaxis=!0),!h.length&&ee.links&&(h=h.concat({data:ee.links})),x=h.length,b=ce.length,!(x=h.length)){for(o=0;o<b;o+=1)w=ce[o],r.set(o+1,0,w.label||w.name);xe.multilevel=!0}for(o=0;o<x;o+=1)for((C=h)[o].dataset?(i=0,v=(C=C[o].dataset).length):(C=h,v=(i=o)+1);i<v&&!de&&!ge&&!he;i+=1)if(k=C[i],Ae++,!(re&&(F=re.getDatasets())&&F[Ae]&&!1===F[Ae].visible)){for(G=(j=re&&F&&F[Ae])&&j.config&&j.config.parentYAxis,r.set(0,a,k.seriesname),"string"==typeof k.data&&(xe.compactdata=!0,k.data=k.data.split(ne.dataseparator||"|")),s=0,c=0,A=k.data&&k.data.length||0;s<A||s<b;s+=1){if(w=ce[s],n=c+1,(N=k.data&&k.data[c]||{}).x!==d&&N.y!==d){de=xe.xy=!0;break}if(N.from!==d&&N.to!==d){he=xe.diagram=!0;break}if(N.open!==d||N.high!==d||N.close!==d||N.low!==d){ve=xe.ohlc=!0;break}if(N.rowid!==d&&N.columnid!==d){ge=xe.heatmap=!0;break}if(Te&&"boxandwhisker2d"===Te){pe=!0;break}(s<b&&!w.vline||!w)&&(Te&&"sparkwinloss"===Te?"W"===(T=N?N.value.toUpperCase():"")?Me++:"L"===T?De++:"D"===T?Fe++:Ie++:(w&&r.set(n,0,w.label||w.name),T=_(se(N?N.value:"")),T=isNaN(T)?"":ye(T,G),r.set(n,a,T)),(fe||le||N.errorvalue)&&(fe||r.set(0,a+1,"Error"),D=1,r.set(n,a+1,ye(N.errorvalue))),c+=1)}Te&&"sparkwinloss"===Te&&(r.clear(),Ie>0?(r.setRow(0,["Win","Loss","Draw","Error"]),r.setRow(1,[Me,De,Fe,Ie])):(r.setRow(0,["Win","Loss","Draw"]),r.setRow(1,[Me,De,Fe]))),D&&(a+=D,D=0),a+=1}p&&(h=h.slice(0,-p.length)),m&&(h=h.slice(0,-m.length))}else if(h=ee.data){for(r.set(0,1,ne.yaxisname||"Value"),xe.singleseries=!0,be="1"==ne.showsumatend,o=0,b=h.length;o<b&&(!X||!$);o+=1)(N=h[o]).vline||(T=_(se(N.value?N.value:"")),1===ie&&!isNaN(oe)&&oe>=0&&(T=T.toFixed(oe)),W=[N.label||N.name,isNaN(T)?"":(Ee+=T,ye(T))],N.id&&N.parent?(X=!0,$=!0):N.parent?X=!0:N.id?$=!0:r.setRow(o+1,W));if(X&&$)return y({chart:ee.chart,category:g(ee.data).category});for(X?r.setRow(0,["Parent Id",ne.xaxisname||"Label","Value"]):$&&r.setRow(0,["Id",ne.xaxisname||"Label","Value"]),b=($||X)&&h.length,o=0;o<b;o++)N=h[o],T=_(se(N.value?N.value:"")),W=[N.label||N.name,isNaN(T)?"":(Ee+=T,ye(T))],$?r.setRow(o+1,[N.id].concat(W)):X&&r.setRow(o+1,[N.parent].concat(W));be&&(xe.summation=!0,r.setRow(o+1,[ne.sumlabel||"Total",ye(Ee)]))}if(ve)for(r.clear(),r.setRow(0,["Open","Close","High","Low","Volume"]),o=0,n=1,v=(h=ee.dataset).length;o<v;o+=1)for(s=0,x=(k=h[o]&&h[o].data||[]).length;s<x;s+=1,n+=1)N=k[s]||{},r.setRow(s+1,[ye(N.open),ye(N.close),ye(N.high),ye(N.low),ye(N.volume)]);else if(de){for(r.clear(),fe=!1,D=0,H=!1,U=0,r.setRow(0,["Series","x","y"]),o=0,n=1,v=(h=ee.dataset).length;o<v;o+=1)if(!(re&&(F=re.getDatasets())&&F[o]&&!1===F[o].visible))for(s=0,x=(k=h[o]&&h[o].data||[]).length;s<x;s+=1,n+=1)(N=k[s]||{}).name&&!H&&(D?r.setRow(0,["Series","Name","x","y","z"]):r.setRow(0,["Series","Name","x","y"]),H=!0,U=s),T=H?[h[o].seriesname,ye(N.name),ye(N.x),ye(N.y)]:[h[o].seriesname,ye(N.x),ye(N.y)],N.z!==d&&(T.push(ye(N.z)),D||(H?r.setRow(0,["Series","Name","x","y","z"]):r.setRow(0,["Series","x","y","z"]),D=1)),(fe||le||N.errorvalue!==d||N.horizontalerrorvalue!==d||N.verticalerrorvalue!==d)&&(M=ye(N.errorvalue),T.push(N.errorvalue,N.horizontalerrorvalue===d?M:ye(N.horizontalerrorvalue),N.verticalerrorvalue===d?M:ye(N.verticalerrorvalue)),fe||(r.set(0,D+3,"Error"),r.set(0,D+4,"Horizontal Error"),r.set(0,D+5,"Vertical Error")),fe=xe.error=!0),r.setRow(n,T);if(H)for(n=1,s=0;s<U;s++,n++)N=k[s]||{},T=[h[o].seriesname,ye(N.name),ye(N.x),ye(N.y)],N.z!==d&&T.push(ye(N.z)),r.setRow(n,T)}else if(he)for(r.clear(),fe=!1,D=0,h=ee&&ee.links,r.setRow(0,["from","to","value"]),s=0;s<h.length;s+=1,n+=1)T=[(N=h[s]||{}).from,N.to,ye(N.value)],N.z!==d&&(T.push(ye(N.z)),D||(r.set(0,3,"z"),D=1)),(fe||le||N.errorvalue!==d||N.horizontalerrorvalue!==d||N.verticalerrorvalue!==d)&&(M=ye(N.errorvalue),T.push(N.errorvalue,N.horizontalerrorvalue===d?M:ye(N.horizontalerrorvalue),N.verticalerrorvalue===d?M:ye(N.verticalerrorvalue)),fe||(r.set(0,D+3,"Error"),r.set(0,D+4,"Horizontal Error"),r.set(0,D+5,"Vertical Error")),fe=xe.error=!0),r.setRow(n,T);else if(ge){for(r.clear(),I={},O={},o=0,s=1,f=(ce=ee.rows&&ee.rows.row||[]).length;o<f;o+=1,s+=1)(w=ce[o]).id&&(I[w.id.toLowerCase()]=s,r.set(s,0,w.label||w.id));for(o=0,s=1,f=(ce=ee.columns&&ee.columns.column||[]).length;o<f;o+=1,s+=1)(w=ce[o]).id&&(O[w.id.toLowerCase()]=s,r.set(0,s,w.label||w.id));for(k=ee.dataset&&ee.dataset[0]&&ee.dataset[0].data||[],B=re&&(F=re.getDatasets())&&F[0]&&F[0].components&&F[0].components.data||[],o=0,f=k.length;o<f;o+=1)if(n=(N=k[o]).rowid.toLowerCase(),a=N.columnid.toLowerCase(),!B[o]||!1!==B[o].visible){if(!I[n]){var Oe=r.rowCount||1;I[n]=Oe,r.set(Oe,0,N.rowid)}if(!O[a]){var Le=r.columnCount||1;O[a]=Le,r.set(0,Le,N.columnid)}r.set(I[n],O[a],ye(N.value||N.displayvalue))}}else if(Se){var Re,Pe,Ve,je,Be,ze,He=["Task name","Start date","End date",ee.processes.headertext||"Process name"],Ue={};_e&&_e.forEach((function(e,t){He.push(e.headertext&&e.headertext.replace(/{br}/g," ")||"DataColumn "+t)})),r.setRow(0,He),we.forEach((function(e,t){e.processid?(je=Ce.filter((function(t,r){return t.id===e.processid&&(Be=r),t.id===e.processid}))[0],Re=je.label||je.name||""):(Be=t,Re=Ce[t]&&(Ce[t].label||Ce[t].name)||""),Ve=e.start||"",ze=e.end||"",Pe=e.label||e.name||"Task "+t,Ue={taskName:Pe,taskStart:Ve,taskEnd:ze,processName:Re},_e&&_e.forEach((function(e,t){Ue["datacolumn"+t]=e.text[Be].label||""})),Object.keys(Ue).forEach((function(e,n){r.set(t+1,n,Ue[e])}))}))}else if(pe&&me){r.clear();var Ge,We,$e,Xe,Ye,qe,Ke,Je,Ze,Qe,et,tt=0,rt=["Maximum","Median","Minimum"];for(ne.showq1values&&rt.push("Q1"),ne.showq3values&&rt.push("Q3"),ne.showmean&&rt.push("Mean"),ne.showmd&&rt.push("MD"),ne.showsd&&rt.push("SD"),ne.showqd&&rt.push("QD"),o=0,f=(ce=ee.categories&&ee.categories[0].category||[]).length;o<f;o+=1)for(w=ce[o],s=0;s<x;s++){var nt=w.label+(1===x?"":"("+ee.dataset[s].seriesname+")"),at=rt.indexOf("Q1"),it=rt.indexOf("Q3"),ot=rt.indexOf("Mean"),st=rt.indexOf("MD"),lt=rt.indexOf("SD"),ct=rt.indexOf("QD"),ut=rt.indexOf("Outliers"),dt=ee.dataset[s].data[o].outliers,ft=me[0];tt+=1,r.set(0,tt,nt),ut<0&&rt.push("Outliers"),ft.setArray(ee.dataset[s].data[o].value),$e=(qe=ft.getQuartiles()).q1,Xe=qe.q3,Ge=(Ye=ft.getMinMax()).min,We=Ye.max,et=ft.getMedian(),Ke=ft.getMean(),Je=ft.getMD(),Ze=ft.getSD(),Qe=ft.getQD(),r.set(1,tt,We),r.set(2,tt,et),r.set(3,tt,Ge),at>-1&&r.set(at+1,tt,$e),it>-1&&r.set(it+1,tt,Xe),ot>-1&&r.set(ot+1,tt,Ke),st>-1&&r.set(st+1,tt,Je),lt>-1&&r.set(lt+1,tt,Ze),ct>-1&&r.set(ct+1,tt,Qe),dt&&r.set(ut>-1?ut+1:rt.length,tt,dt)}rt.forEach((function(e,t){r.set(t+1,0,e)}))}for(m=null,p=null,ce=null,h=null,r.rowCount>0&&r.get(0,0)===d&&r.set(0,0,ne.xaxisname||"Label"),o=1;o<r.rowCount;o++)if(r.data[o][0]!==d){Q=1;break}if(!Q&&xe.multiseries){var ht=[];for(o=0;o<r.rowCount;o++)for(ht.push([]),s=1;s<r.data[o].length;s++)ht[o][s-1]=r.data[o][s];for(o=1;o<r.data[0].length;o++)ht[0][o-1]===d&&(ht[0][o-1]="Value");r.data=ht}}return{data:r.toString(),error:d,predictedFormat:xe}},h=function(e,t){return(0,i.raiseError)(t,"0604111215","run","csvToJson()","fusionCharts CSV data-handler only supports encoding of data."),e};var T={extension:function(e){return e&&(u=e,e.prototype.getDataAsCSV=N,e.prototype.getCSVData=A),{format:"csv",toJSON:h,fromJSON:f}},name:"csv",type:"transcoder",requiresFusionCharts:!0};t["default"]=T},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]=function(e){return Array.isArray(e)}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=t.TimeConverter=void 0;var a=n(r(293)),i=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=g(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(295)),o=r(303),s=r(302),l=n(r(304)),c=n(r(296)),u=n(r(305)),d=n(r(301)),f=n(r(307)),h=n(r(309));function g(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(g=function(e){return e?r:t})(e)}var p=/^\s*\d+/,m=/^\s*Q\d+/,v=/^%/,b=/[\\^$*+?|[\]().{}]/g,y=function(e,t,r){var n=e<0?"-":"",a=(n?-e:e)+"",i=a.length;return n+(i<r?new Array(r-i+1).join(t)+a:a)},x=function(e){return e.replace(b,"\\$&")},w=function(e){return new RegExp("^(?:"+e.map(x).join("|")+")","i")},C=function(e){for(var t={},r=-1,n=e.length;++r<n;)t[e[r].toLowerCase()]=r;return t},k=function(e,t,r){var n=p.exec(t.slice(r,r+1));return n?(e.w=+n[0],r+n[0].length):-1},_=function(e,t,r){var n=p.exec(t.slice(r,r+1));return n?(e.u=+n[0],r+n[0].length):-1},S=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.U=+n[0],r+n[0].length):-1},E=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.V=+n[0],r+n[0].length):-1},A=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.W=+n[0],r+n[0].length):-1},N=function(e,t,r){var n=m.exec(t.slice(r,r+2));return n?(e.m=3*(n[0][1]-1),r+n[0].length):-1},T=function(e,t,r){var n=p.exec(t.slice(r,r+4));return n?(e.y=+n[0],r+n[0].length):-1},M=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.y=+n[0]+(+n[0]>68?1900:2e3),r+n[0].length):-1},D=function(e,t,r){var n=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r,r+6));return n?(e.Z=n[1]?0:-(n[2]+(n[3]||"00")),r+n[0].length):-1},F=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.m=n[0]-1,r+n[0].length):-1},I=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.d=+n[0],r+n[0].length):-1},O=function(e,t,r){var n=p.exec(t.slice(r,r+3));return n?(e.m=0,e.d=+n[0],r+n[0].length):-1},L=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.H=+n[0],r+n[0].length):-1},R=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.M=+n[0],r+n[0].length):-1},P=function(e,t,r){var n=p.exec(t.slice(r,r+2));return n?(e.S=+n[0],r+n[0].length):-1},V=function(e,t,r){var n=p.exec(t.slice(r,r+3));return n?(e.L=+n[0],r+n[0].length):-1},j=function(e,t,r){var n=p.exec(t.slice(r,r+6));return n?(e.L=Math.floor(n[0]/1e3),r+n[0].length):-1},B=function(e,t,r){var n=v.exec(t.slice(r,r+1));return n?r+n[0].length:-1},z=function(e,t,r){var n=p.exec(t.slice(r));return n?(e.Q=+n[0],r+n[0].length):-1},H=function(e,t,r){var n=p.exec(t.slice(r));return n?(e.Q=1e3*+n[0],r+n[0].length):-1},U=function(e,t){return y(e.getDate(),t,2)},G=function(e,t){return y(e.getHours(),t,2)},W=function(e,t){return y(e.getHours()%12||12,t,2)},$=function(e,t){return y(1+c["default"].count(u["default"].floor(e),e),t,3)},X=function(e,t){return y(e.getMilliseconds(),t,3)},Y=function(e,t){return X(e,t)+"000"},q=function(e,t){return y(e.getMonth()+1,t,2)},K=function(e,t){return y(e.getMinutes(),t,2)},J=function(e,t){return y(e.getSeconds(),t,2)},Z=function(e,t){return"Q"+Math.ceil((e.getMonth()+1)/3)},Q=function(e){var t=e.getDay();return 0===t?7:t},ee=function(e,t){return y(o.sunday.count(u["default"].floor(e),e),t,2)},te=function(e,t){var r=e,n=r.getDay();return r=n>=4||0===n?o.thursday.floor(r):o.thursday.ceil(r),y(o.thursday.count(u["default"].floor(r),r)+(4===u["default"].floor(r).getDay()),t,2)},re=function(e){return e.getDay()},ne=function(e,t){return y(o.monday.count(u["default"].floor(e),e),t,2)},ae=function(e,t){return y(e.getFullYear()%100,t,2)},ie=function(e,t){return y(e.getFullYear()%1e4,t,4)},oe=function(e){var t=e.getTimezoneOffset();return(t>0?"-":(t*=-1,"+"))+y(t/60|0,"0",2)+y(t%60,"0",2)},se=function(e,t){return y(e.getUTCDate(),t,2)},le=function(e,t){return y(e.getUTCHours(),t,2)},ce=function(e,t){return y(e.getUTCHours()%12||12,t,2)},ue=function(e,t){return y(1+d["default"].count(f["default"].floor(e),e),t,3)},de=function(e,t){return y(e.getUTCMilliseconds(),t,3)},fe=function(e,t){return de(e,t)+"000"},he=function(e,t){return y(e.getUTCMonth()+1,t,2)},ge=function(e,t){return y(e.getUTCMinutes(),t,2)},pe=function(e,t){return y(e.getUTCSeconds(),t,2)},me=function(e,t){return"Q"+Math.ceil((e.getUTCMonth()+1)/3)},ve=function(e){var t=e.getUTCDay();return 0===t?7:t},be=function(e,t){return y(s.utcSunday.count(f["default"].floor(e),e),t,2)},ye=function(e,t){var r=e,n=r.getUTCDay();return r=n>=4||0===n?s.utcThursday.floor(r):s.utcThursday.ceil(r),y(s.utcThursday.count(f["default"].floor(r),r)+(4===f["default"].floor(r).getUTCDay()),t,2)},xe=function(e){return e.getUTCDay()},we=function(e,t){return y(s.utcMonday.count(f["default"].floor(e),e),t,2)},Ce=function(e,t){return y(e.getUTCFullYear()%100,t,2)},ke=function(e,t){return y(e.getUTCFullYear()%1e4,t,4)},_e=function(){return"+0000"},Se=function(){return"%"},Ee=function(e){return+e},Ae=function(e){return Math.floor(+e/1e3)},Ne=function(){function e(e){var t=this,r=e.dateTime,n=e.date,o=e.time,s=e.periods,l=e.days,c=e.shortDays,u=e.months,d=e.shortMonths,f=w(s),h=C(s),g=w(l),p=C(l),m=w(c),v=C(c),b=w(u),y=C(u),x=w(d),Ne=C(d);this._formats={a:function(e){return c[e.getDay()]},A:function(e){return l[e.getDay()]},b:function(e){return d[e.getMonth()]},B:function(e){return u[e.getMonth()]},d:U,e:U,f:Y,H:G,I:W,j:$,L:X,m:q,M:K,p:function(e){return s[+(e.getHours()>=12)]},q:Z,Q:Ee,s:Ae,S:J,u:Q,U:ee,V:te,w:re,W:ne,y:ae,Y:ie,Z:oe,"%":Se},this._utcFormats={a:function(e){return c[e.getUTCDay()]},A:function(e){return l[e.getUTCDay()]},b:function(e){return d[e.getUTCMonth()]},B:function(e){return u[e.getUTCMonth()]},d:se,e:se,f:fe,H:le,I:ce,j:ue,L:de,m:he,M:ge,p:function(e){return s[+(e.getUTCHours()>=12)]},q:me,Q:Ee,s:Ae,S:pe,u:ve,U:be,V:ye,w:xe,W:we,y:Ce,Y:ke,Z:_e,"%":Se},this._parses={a:function(e,t,r){var n=m.exec(t.slice(r));return n?(e.w=v[n[0].toLowerCase()],r+n[0].length):-1},A:function(e,t,r){var n=g.exec(t.slice(r));return n?(e.w=p[n[0].toLowerCase()],r+n[0].length):-1},b:function(e,t,r){var n=x.exec(t.slice(r));return n?(e.m=Ne[n[0].toLowerCase()],r+n[0].length):-1},B:function(e,t,r){var n=b.exec(t.slice(r));return n?(e.m=y[n[0].toLowerCase()],r+n[0].length):-1},c:null,d:I,e:I,f:j,H:L,I:L,j:O,L:V,m:F,M:R,p:function(e,t,r){var n=f.exec(t.slice(r));return n?(e.p=h[n[0].toLowerCase()],r+n[0].length):-1},Q:z,q:N,s:H,S:P,u:_,U:S,V:E,w:k,W:A,x:null,X:null,y:M,Y:T,Z:D,"%":B},this._formats.x=function(e){return new a["default"](n,t._formats).format(e)},this._formats.X=function(e){return new a["default"](o,t._formats).format(e)},this._formats.c=function(e){return new a["default"](r,t._formats).format(e)},this._utcFormats.x=function(e){return new a["default"](n,t._utcFormats).format(e)},this._utcFormats.X=function(e){return new a["default"](o,t._utcFormats).format(e)},this._utcFormats.c=function(e){return new a["default"](r,t._utcFormats).format(e)},this._parses.c=function(e,n,a){return new i["default"](r,t._parses).parseSpecifier(e,n,a)},this._parses.x=function(e,r,a){return new i["default"](n,t._parses).parseSpecifier(e,r,a)},this._parses.X=function(e,r,n){return new i["default"](o,t._parses).parseSpecifier(e,r,n)}}var t=e.prototype;return t.formatter=function(e){return void 0===e&&(e=""),new a["default"](e.toString(),this._formats)},t.utcFormatter=function(e){return void 0===e&&(e=""),new a["default"](e.toString(),this._utcFormats)},t.parser=function(e){var t=e;return new i["default"](t+="",this._parses,(function(e){var t;if(e.y>=0&&e.y<100)return(t=new Date(-1,e.m,e.d,e.H,e.M,e.S,e.L)).setFullYear(e.y),t;t=new Date(e.y,e.m,e.d,e.H,e.M,e.S,e.L);var r=new Date(e.y,0).getTimezoneOffset(),n=new Date(e.y,6).getTimezoneOffset(),a=new Date(e.y,e.m,e.d,e.H,e.M,e.S,e.L).getTimezoneOffset();return n===r||r>n&&r!==a&&(t=l["default"].offset(t,1)),t}))},t.utcParser=function(e){var t=e;return new i["default"](t+="",this._parses,i.utcDate)},e}();t.TimeConverter=Ne;var Te=new Ne(h["default"]);t["default"]=Te},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(294)),i=function(){function e(e,t){this._specifier=e,this._formats=t}var t=e.prototype;return t.format=function(e){var t,r,n,i=[],o=e,s=-1,l=0,c=this._specifier,u=c.length;for(o instanceof Date||(o=new Date(+o));++s<u;)37===c.charCodeAt(s)&&(i.push(c.slice(l,s)),t=c.charAt(++s),r=a["default"][t],null==r?r="e"===t?" ":"0":t=c.charAt(++s),n=this._formats[t],n&&(t=n(o,r)),i.push(t),l=s+1);return i.push(c.slice(l,s)),i.join("")},t.toString=function(){return this._specifier},e}();t["default"]=i},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"-":"",_:" ",0:"0"}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=t.utcDate=void 0;var a=n(r(294)),i=n(r(296)),o=n(r(301)),s=r(302),l=r(303),c=function(e){return{y:e,m:0,d:1,H:0,M:0,S:0,L:0}},u=function(e){if(e.y>=0&&e.y<100){var t=new Date(Date.UTC(-1,e.m,e.d,e.H,e.M,e.S,e.L));return t.setUTCFullYear(e.y),t}return new Date(Date.UTC(e.y,e.m,e.d,e.H,e.M,e.S,e.L))};t.utcDate=u;var d=function(){function e(e,t,r){this._specifier=e,this._parses=t,this._newDate=r}var t=e.prototype;return t.parseSpecifier=function(e,t,r){for(var n,i,o=0,s=this._specifier.length,l=t.length,c=r;o<s;){if(c>=l)return-1;if(37===(n=this._specifier.charCodeAt(o++))){if(n=this._specifier.charAt(o++),!(i=this._parses[n in a["default"]?this._specifier.charAt(o++):n])||(c=i(e,t,c))<0)return-1}else if(n!==t.charCodeAt(c++))return-1}return c},t.parse=function(e){var t,r,n=c(1900),a=e;if(a+="",this.parseSpecifier(n,a,0)!==a.length)return null;if("Q"in n)return new Date(n.Q);if("p"in n&&(n.H=n.H%12+12*n.p),"V"in n){if(n.V<1||n.V>53)return null;"w"in n||(n.w=1),"Z"in n?(r=(t=u(c(n.y))).getUTCDay(),t=r>4||0===r?s.utcMonday.ceil(t):s.utcMonday.floor(t),t=o["default"].offset(t,7*(n.V-1)),n.y=t.getUTCFullYear(),n.m=t.getUTCMonth(),n.d=t.getUTCDate()+(n.w+6)%7):(r=(t=this._newDate(c(n.y))).getDay(),t=r>4||0===r?l.monday.ceil(t):l.monday.floor(t),t=i["default"].offset(t,7*(n.V-1)),n.y=t.getFullYear(),n.m=t.getMonth(),n.d=t.getDate()+(n.w+6)%7)}else("W"in n||"U"in n)&&("w"in n||(n.w="u"in n?n.u%7:"W"in n?1:0),r="Z"in n?u(c(n.y)).getUTCDay():this._newDate(c(n.y)).getDay(),n.m=0,n.d="W"in n?(n.w+6)%7+7*n.W-(r+5)%7:n.w+7*n.U-(r+6)%7);return"Z"in n?(n.H+=n.Z/100|0,n.M+=n.Z%100,u(n)):this._newDate(n)},t.toString=function(){return this._specifier},e}();t["default"]=d},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.dayObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"day",floor:function(e,t,r){return new Date(Number((0,o.getFloor)(new Date(Number(e.setHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setDate(s.getDate()+t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setDate(s.getDate()+t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e-(t.getTimezoneOffset()-e.getTimezoneOffset())*i.durationMinute)/i.durationDay-Math.floor(a/i.durationDay)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setDate(1),s.setHours(0,0,0,0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getDate()-n.getDate()-Math.floor(l/i.durationDay)}},l=new a["default"](s);t.dayObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=new Date,a=new Date,i=function(e){return null==e},o=function(){function e(e){this._name=e.name,this._floori=e.floor,this._offseti=e.offset,this._count=e.count,this._field=e.field}var t=e.prototype;return t.name=function(){return this._name},t.floor=function(e){var t=new Date(Number(e));return t=this._floori(t,this._clipDates,this._timeUniverse)},t.setClipDates=function(e){this._clipDates=e},t.setTimeUniverse=function(e){this._timeUniverse=e},t.ceil=function(e){var t=new Date(e-1);return t=this._floori(t,this._clipDates,this._timeUniverse),t=this._offseti(t,1,this._clipDates,this._timeUniverse),t=this._floori(t,this._clipDates,this._timeUniverse)},t.round=function(e){var t=this.floor(e),r=this.ceil(e);return e-t<r-e?t:r},t.offset=function(e,t){var r=new Date(Number(e));return r=this._offseti(r,i(t)?1:Math.floor(t),this._clipDates,this._timeUniverse)},t.range=function(e,t,r){var n,a=[],o=this.ceil(e),s=i(r)?1:Math.floor(r);if(!(o<t&&s>0))return a;do{n=new Date(Number(o)),a.push(n),o=this._offseti(o,s,this._clipDates,this._timeUniverse),o=this._floori(o,this._clipDates,this._timeUniverse)}while(n<o&&o<t);return a},t.filter=function(t){var r=this;return new e({name:this.name(),floor:function(e){var n=e;if(!Number.isNaN(Number(n)))for(;r._floori(n,r._clipDates,r._timeUniverse),!t(n);)n.setTime(n-1);return Number(n)},offset:function(e,n){var a=n,i=e;if(!Number.isNaN(Number(i)))if(a<0)for(;++a<=0;){0;do{i=r._offseti(i,-1,r._clipDates,r._timeUniverse)}while(!t(i))}else for(;--a>=0;)do{i=r._offseti(i,1,r._clipDates,r._timeUniverse)}while(!t(i));return Number(i)}})},t.count=function(e,t){var r=0;return this._count&&(n.setTime(Number(e)),a.setTime(Number(t)),n=this._floori(n,this._clipDates,this._timeUniverse),a=this._floori(a,this._clipDates,this._timeUniverse),r=Math.floor(this._count(n,a,this._clipDates))),r},t.every=function(e){var t=this,r=Math.floor(e);return this._count&&Number.isFinite(r)&&r>0?r>1?this.filter(this._field?function(e){return t._field(e,t._clipDates,t._timeUniverse)%r==0}:function(e){return t.count(0,e)%r==0}):this:null},e}();t["default"]=o},function(e,t,r){"use strict";t.__esModule=!0,t.durationYear=t.durationQuarter=t.durationMonth=t.durationWeek=t.durationDay=t.durationHour=t.durationMinute=t.durationSecond=void 0;t.durationYear=31536e6,t.durationQuarter=78894e5,t.durationMonth=2592e6,t.durationWeek=6048e5,t.durationDay=864e5,t.durationHour=36e5,t.durationMinute=6e4,t.durationSecond=1e3},function(e,t,r){"use strict";t.__esModule=!0,t.getClipArray=t.getClippedDatesWithin=t.getClampRangesAround=t.getValidDatesWithin=t.getFloor=t.clampDownDateWithinClip=t.clampUpDateWithinClip=void 0;var n=r(300),a=function(e){return e.charAt(0).toUpperCase()+e.slice(1)},i=function(e,t,r,n){if(n&&Array.isArray(n)&&n.length>0){if(Number(t)>=Number(n[1]))return n[1];if(Number(t)<=Number(n[0]))return n[0]}if(!r||r.length<=0)return t;var a=t,i=r,l=o(i,e,a);return s(a,l,i,n)},o=function(e,t,r){var n=c(e,t,r),a=[];return!e||e.length<=0?a:a=u(n,a)},s=function(e,t,r,n){var a,o=t,s=l(r,e),c=e,d=0;return(o=u(s,o)).length>0&&o.forEach((function(e){d+=Number(e.to)-Number(e.from)})),a=new Date(Number(c.setTime(Number(c)+d))),Number(a)===Number(c)?c:a=i(c,a,r,n)},l=function(e,t){var r=Number(t),i=e,o=0,s=[];if(!e||e.length<=0)return s;if(Array.isArray(i))for(var l=0;l<i.length;l++){var c=i[l],u=c.from,d=c.to;if(o=d-u,c.hasOwnProperty("repeat")){var f=Number(u),h=Number(d),g=n.DatetimeUnits[a(String(c.repeat.unit))].ms*c.repeat.multiplier,p=Math.floor((r-f)/g),m=p,v=void 0,b=void 0;if("month"===String(c.repeat.unit).toLowerCase()?(v=new Date(Number(new Date(f).setMonth(new Date(f).getMonth()+m))),b=new Date(Number(new Date(h).setMonth(new Date(h).getMonth()+m)))):"year"===String(c.repeat.unit).toLowerCase()?(v=new Date(Number(new Date(f).setFullYear(new Date(f).getFullYear()+m))),b=new Date(Number(new Date(h).setFullYear(new Date(h).getFullYear()+m)))):(v=new Date(Number(f)+g*p),b=new Date(Number(v)+o)),p<0)continue;r>=v&&r<b&&s.push({from:v,to:b})}else u<=r&&d>r&&s.push(c)}return s},c=function(e,t,r){var i=+t,o=+r,s=e,l=0,c=[];if(Array.isArray(s))for(var u=0;u<s.length;u++){var d=s[u],f=d.from,h=d.to;if(l=h-f,d.hasOwnProperty("repeat")){var g=Number(f),p=Number(h),m=n.DatetimeUnits[a(String(d.repeat.unit))].ms*d.repeat.multiplier,v=Math.floor((i-g)/m),b=v,y=void 0,x=void 0;if("month"===String(d.repeat.unit).toLowerCase()?(y=new Date(Number(new Date(g).setMonth(new Date(g).getMonth()+b))),x=new Date(Number(new Date(p).setMonth(new Date(p).getMonth()+b)))):"year"===String(d.repeat.unit).toLowerCase()?(y=new Date(Number(new Date(g).setFullYear(new Date(g).getFullYear()+b))),x=new Date(Number(new Date(p).setFullYear(new Date(p).getFullYear()+b)))):(y=new Date(Number(g)+m*v),x=new Date(Number(y)+l)),v<0)continue;for(;Number(y)<Number(o);)Number(y)>Number(i)&&Number(x)<=Number(o)&&c.push({from:y,to:x}),b=Number(d.repeat.multiplier),y=+y,x=+x,"month"===String(d.repeat.unit).toLowerCase()?(y=new Date(Number(new Date(y).setMonth(new Date(y).getMonth()+b))),x=new Date(Number(new Date(x).setMonth(new Date(x).getMonth()+b)))):"year"===String(d.repeat.unit).toLowerCase()?(y=new Date(Number(new Date(y).setFullYear(new Date(y).getFullYear()+b))),x=new Date(Number(new Date(x).setFullYear(new Date(x).getFullYear()+b)))):(y=new Date(Number(y)+m),x=new Date(Number(x)+m))}else f>i&&h<=o&&c.push(d)}return c},u=function(e,t){var r,n=e,a=t;if(!e||e.length<=0)return a;var i=function(){var e=n[r];a.every((function(t){return!(e.from>=t.from&&e.to<=t.to)&&(e.from<=t.from&&e.to>=t.to?t.entryEnabled=!1:e.from>=t.from&&e.from<=t.to&&e.to>=t.to?(e.from=t.from,t.entryEnabled=!1):e.to>=t.from&&e.to<=t.to&&e.from<=t.from?(e.to=t.to,t.entryEnabled=!1):t.entryEnabled=!0,!0)}))&&(e.entryEnabled=!0,a.push(e))};for(r=0;r<n.length;r++)i();return a=a.filter((function(e){return!0===e.entryEnabled}))},d=function(e,t,r,n){if(n&&Array.isArray(n)&&n.length>0){if(Number(t)>=Number(n[1]))return n[1];if(Number(t)<=Number(n[0]))return n[0]}if(!r||r.length<=0)return t;var a=t,i=r,s=o(i,a,e);return f(a,s,i,n)},f=function(e,t,r,n){var a,i=t,o=l(r,e),s=e,c=0;return(i=u(o,i)).length>0&&i.forEach((function(e){c+=Number(e.to)-Number(e.from)})),a=new Date(Number(s.setTime(Number(s)-c))),Number(a)===Number(s)?s:a=d(s,a,r,n)};t.getFloor=function h(e,t,r){if(r&&Array.isArray(r)&&r.length>0){if(Number(e)>=Number(r[1]))return r[1];if(Number(e)<=Number(r[0]))return r[0]}if(!t||t.length<=0)return e;var n,a=e,i=l(t,e),o=[];return 0===i.length?a:(n=(o=u(i,o)).reduce((function(e,t){return e.to>t.to?+new Date(Number(e.to)):+new Date(Number(t.to))}),0),Number(n)===Number(a)?n:h(n,t,r))},t.clampUpDateWithinClip=d,t.getClipArray=u,t.getClippedDatesWithin=c,t.getClampRangesAround=l,t.getValidDatesWithin=o,t.clampDownDateWithinClip=i},function(e,t,r){"use strict";t.__esModule=!0,t.Weekdays=t.DatetimeUnits=void 0;var n=r(298),a={Millisecond:{name:"Millisecond",ms:1},Second:{name:"Second",ms:n.durationSecond},Minute:{name:"Minute",ms:n.durationMinute},Hour:{name:"Hour",ms:n.durationHour},Day:{name:"Day",ms:n.durationDay},Week:{name:"Week",ms:n.durationWeek},Month:{name:"Month",ms:n.durationMonth},Quarter:{name:"Quarter",ms:n.durationQuarter},Year:{name:"Year",ms:n.durationYear}};t.Weekdays={Sunday:{name:"Sunday",id:0},Monday:{name:"Monday",id:1},Tuesday:{name:"Tuesday",id:2},Wednesday:{name:"Wednesday",id:3},Thursday:{name:"Thursday",id:4},Friday:{name:"Friday",id:5},Saturday:{name:"Saturday",id:6}},t.DatetimeUnits=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcDayObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"day",floor:function(e,t,r){return new Date(Number((0,o.getFloor)(new Date(Number(e.setUTCHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setUTCDate(s.getUTCDate()+t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setUTCDate(s.getUTCDate()+t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t-e-Math.floor(a/i.durationDay)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTCDate(1),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getUTCDate()-n.getUTCDate()-Math.floor(l/i.durationDay)}},l=new a["default"](s);t.utcDayObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcWeekObj=t.utcSaturday=t.utcFriday=t.utcThursday=t.utcWednesday=t.utcTuesday=t.utcMonday=t.utcSunday=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"week",floor:function(e,t,r){return e.setUTCDate(e.getUTCDate()-(e.getUTCDay()+7-0)%7),new Date(Number((0,o.getFloor)(new Date(Number(e.setUTCHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setUTCDate(s.getUTCDate()+7*t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setUTCDate(s.getUTCDate()+7*t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t-e-Math.floor(a/i.durationWeek)}},l=function(e,t){return new a["default"]({name:t,floor:function(t,r,n){return t.setUTCDate(t.getUTCDate()-(t.getUTCDay()+7-e)%7),new Date(Number((0,o.getFloor)(new Date(Number(t.setUTCHours(0,0,0,0))),r,n)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setUTCDate(s.getUTCDate()+7*t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setUTCDate(s.getUTCDate()+7*t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t-e-Math.floor(a/i.durationWeek)}})},c=l(0,"week"),u=l(0,"sunday"),d=l(1,"monday"),f=l(2,"tuesday"),h=l(3,"wednesday"),g=l(4,"thursday"),p=l(5,"friday"),m=l(6,"saturday");t.utcSaturday=m,t.utcFriday=p,t.utcThursday=g,t.utcWednesday=h,t.utcTuesday=f,t.utcMonday=d,t.utcSunday=u,t.utcWeekObj=s;var v=c;t["default"]=v},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.weekObj=t.saturday=t.friday=t.thursday=t.wednesday=t.tuesday=t.monday=t.sunday=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"week",floor:function(e,t,r){return e.setDate(e.getDate()-(e.getDay()+7-0)%7),new Date(Number((0,o.getFloor)(new Date(Number(e.setHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setDate(s.getDate()+7*t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setDate(s.getDate()+7*t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e-Math.floor(a/i.durationWeek)-(t.getTimezoneOffset()-e.getTimezoneOffset())*i.durationMinute)/i.durationWeek}},l=function(e,t){return new a["default"]({name:t,floor:function(t,r,n){return t.setDate(t.getDate()-(t.getDay()+7-e)%7),new Date(Number((0,o.getFloor)(new Date(Number(t.setHours(0,0,0,0))),r,n)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setDate(s.getDate()+7*t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setDate(s.getDate()+7*t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e-Math.floor(a/i.durationWeek)-(t.getTimezoneOffset()-e.getTimezoneOffset())*i.durationMinute)/i.durationWeek}})},c=l(0,"week"),u=l(0,"sunday"),d=l(1,"monday"),f=l(2,"tuesday"),h=l(3,"wednesday"),g=l(4,"thursday"),p=l(5,"friday"),m=l(6,"saturday");t.saturday=m,t.friday=p,t.thursday=g,t.wednesday=h,t.tuesday=f,t.monday=d,t.sunday=u,t.weekObj=s;var v=c;t["default"]=v},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.hourObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"hour",floor:function(e,t,r){var n=e.getTimezoneOffset()*i.durationMinute%i.durationHour;return n<0&&(n+=i.durationHour),new Date(Number((0,o.getFloor)(new Date(Number(e.setTime(Math.floor((Number(e)-n)/i.durationHour)*i.durationHour+n))),t,r)))},offset:function(e,t,r,n){var a=t>0,s={date:new Date(Number(e))},l=new Date(Number(s.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationHour))),r,n):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationHour))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e)/i.durationHour-Math.floor(a/i.durationHour)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setHours(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getHours()-n.getHours()-l/i.durationHour}},l=new a["default"](s);t.hourObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.yearObj=t["default"]=void 0;var a=n(r(306)),i=r(298),o=r(299),s={name:"year",floor:function(e,t,r){return e.setMonth(0,1),new Date(Number((0,o.getFloor)(new Date(Number(e.setHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setFullYear(s.getFullYear()+t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setFullYear(s.getFullYear()+t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t.getFullYear()-e.getFullYear()-Math.floor(a/i.durationYear)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setFullYear(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getFullYear()-n.getFullYear()-Math.floor(l/i.durationYear)}},l=new a["default"](s);t.yearObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(297)),o=r(299),s=function(e){function t(){return e.apply(this,arguments)||this}return(0,a["default"])(t,e),t.prototype.every=function(e){var t=Math.floor(e);return this.count&&Number.isFinite(t)&&t>0?new i["default"]({name:"year",floor:function(e,r,n){return e.setFullYear(Math.floor(e.getFullYear()/t)*t),e.setMonth(0,1),new Date(Number((0,o.getFloor)(new Date(Number(e.setHours(0,0,0,0)))),r,"year",n))},offset:function(e,r,n,a){var i=r>0,s={date:new Date(Number(e))},l=new Date(Number(s.date));return new Date(Number(i?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setFullYear(l.getFullYear()+r*t))),n,"year",a):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setFullYear(l.getFullYear()+r*t))),n,"year",a)))}}):null},t}(i["default"]);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcYearObj=t["default"]=void 0;var a=n(r(308)),i=r(299),o=r(298),s={name:"year",floor:function(e,t,r){return e.setUTCMonth(0,1),new Date(Number((0,i.getFloor)(new Date(Number(e.setUTCHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,o={date:new Date(Number(e))},s=new Date(Number(o.date));return new Date(Number(a?(0,i.clampDownDateWithinClip)(o.date,new Date(Number(s.setUTCFullYear(s.getUTCFullYear()+t))),r,n):(0,i.clampUpDateWithinClip)(o.date,new Date(Number(s.setUTCFullYear(s.getUTCFullYear()+t))),r,n)))},count:function(e,t,r){var n=(0,i.getValidDatesWithin)(r,e,t),a=0,s=(0,i.getClampRangesAround)(r,t);return(n=(0,i.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t.getUTCFullYear()-e.getUTCFullYear()-Math.floor(a/o.durationYear)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTCFullYear(0),n=(0,i.getFloor)(new Date(Number(s)),t,r),(0,i.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getUTCFullYear()-n.getUTCFullYear()-Math.floor(l/o.durationYear)}},l=new a["default"](s);t.utcYearObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(297)),o=r(299),s=function(e){function t(){return e.apply(this,arguments)||this}return(0,a["default"])(t,e),t.prototype.every=function(e){var t=e;return isFinite(t=Math.floor(t))&&t>0?new i["default"]({name:"year",floor:function(e,r){return e.setUTCFullYear(Math.floor(e.getUTCFullYear()/t)*t),e.setUTCMonth(0,1),new Date(Number((0,o.getFloor)(new Date(Number(e.setUTCHours(0,0,0,0))),r)))},offset:function(e,r,n){var a=r>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setUTCFullYear(s.getUTCFullYear()+r*t))),n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setUTCFullYear(s.getUTCFullYear()+r*t))),n)))}}):null},t}(i["default"]);t["default"]=s},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n={dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]};t["default"]=n},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(231),a=r(311);function i(e,t,r,i,o){(0,n.triggerEvent)("dataLoadRequested",o,{source:a.sourceName,url:e,dataFormat:"json",silent:!!i,config:t,successcallback:r},void 0,a.onDataLoadRequest,a.onDataLoadRequestCancel)}function o(e){this.setChartDataUrl(e,"jsonurl")}var s={extension:function(e){return e&&(e.prototype.setJSONUrl=o),{format:"jsonurl",toJSON:i}},name:"JSONUrl",type:"transcoder",requiresFusionCharts:!0};t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.onDataLoadRequest=function(e,t){var r=e.sender,n=r.__state,i=t.url;r.options.dataSource=t.url,n.dhmXhrObj||(n.dhmXhrObj=new a["default"](l,c));n.dhmXhrObj.get("function"==typeof window.decodeURIComponent?window.decodeURIComponent(i):window.unescape(i),{obj:r,args:t})},t.onDataLoadRequestCancel=function(e,t){var r=e.sender,n=r.__state;(0,i.triggerEvent)("dataLoadRequestCancelled",r,t),n&&n.dhmXhrObj&&n.dhmXhrObj.abort()},t.sourceName=void 0;var a=n(r(312)),i=r(231);function o(e,t){e.sender.jsVars.stallLoad=!1,e.sender.setChartData(t.dataSource,t.dataFormat,t.config,t.successcallback,t.silent)}function s(e,t){(0,i.triggerEvent)("dataLoadCancelled",e.sender,t),t.xmlHttpRequestObject.abort()}function l(e,t,r,n){var a=r.args;a.dataSource=e,a.xmlHttpRequestObject=t,a.source="XmlHttpRequest",a.url=n,(0,i.triggerEvent)("dataLoadRequestCompleted",r.obj,a,void 0,o,s)}function c(e,t,r){var n=r.obj,a=r.args;a.error=e,a.httpStatus=t.xmlhttp&&t.xmlhttp.status?t.xmlhttp.status:-1,a.xmlHttpRequestObject=t,n._addChartDependency("data",{resolve:function(){return{state:1,msg:n.options.dataLoadErrorMessage,msgStyle:{image:{imageHAlign:n.args.dataLoadErrorMessageImageHAlign||n.options.baseChartMessageImageHAlign,imageVAlign:n.args.dataLoadErrorMessageImageVAlign||n.options.baseChartMessageImageVAlign,imageAlpha:n.args.dataLoadErrorMessageImageAlpha||n.options.baseChartMessageImageAlpha,imageScale:n.args.dataLoadErrorMessageImageScale||n.options.baseChartMessageImageScale},message:{color:n.args.dataLoadErrorMessageColor||n.options.baseChartMessageColor,fontFamily:n.args.dataLoadErrorMessageFont||n.options.baseChartMessageFont,fontSize:n.args.dataLoadErrorMessageFontSize||n.options.baseChartMessageFontSize}}}}}),n._setState(),(0,i.triggerEvent)("dataLoadError",n,a)}t.sourceName="XmlHttpRequest"},function(e,t,r){"use strict";(function(e){t.__esModule=!0,t["default"]=void 0;var n=r(231),a=r(224),i=window,o=parseFloat(i.navigator.appVersion.split("MSIE")[1]),s=!!(o>=5.5&&o<=7),l="file:"===i.location.protocol,c=i.ActiveXObject,u=(!c||!l)&&i.XMLHttpRequest,d={objects:0,xhr:0,requests:0,success:0,failure:0,idle:0},f=function(){var e;if(u)return(f=function(){return d.xhr++,new u})();try{e=new c("Msxml2.XMLHTTP"),f=function(){return d.xhr++,new c("Msxml2.XMLHTTP")}}catch(t){try{e=new c("Microsoft.XMLHTTP"),f=function(){return d.xhr++,new c("Microsoft.XMLHTTP")}}catch(r){e=!1}}return e},h=function(){function t(e,t){this.onSuccess=e,this.onError=t,this.open=!1,d.objects++,d.idle++}t.stats=function(e){return e?d[e]:(0,a.extend2)({},d)};var r=t.prototype;return r.transact=function(r,o,c,u){var h,g,p=this,m=p.xmlhttp,v=t.headers,b=p.onError,y=p.onSuccess,x="POST"===r,w=Object.prototype.hasOwnProperty;-1!==o.search(/^(http:\/\/|https:\/\/)/)&&i.location.hostname!==/(http:\/\/|https:\/\/)([^\/\:]*)/.exec(o)[2]?delete v["X-Requested-By"]:!w.call(v,"X-Requested-By")&&(v["X-Requested-By"]="FusionCharts"),(!m||s||a.isFirefox)&&(m=f(),p.xmlhttp=m),m.onreadystatechange=function(){try{4===m.readyState&&(!m.status&&l||m.status>=200&&m.status<300||304===m.status||1223===m.status||0===m.status?(y&&y(m.responseText,p,u,o),d.success++):b&&(b(new Error("XmlHttprequest Error"),p,u,o),d.failure++),d.idle--,p.open=!1)}catch(e){b&&b(e,p,u,o),i.FC_DEV_ENVIRONMENT&&setTimeout((function(){throw e}),0),d.failure++}};try{if(m.open(x?"POST":"GET",o,!0),m.overrideMimeType&&m.overrideMimeType("text/plain"),x)if("string"==typeof c)h=c;else{for(g in h=[],c)h.push(g+"="+(c[g]+"").replace(/\=/g,"%3D").replace(/\&/g,"%26"));h=h.join("&")}else h=null;for(g in v)m.setRequestHeader(g,v[g]);m.send(h),d.requests++,d.idle++,p.open=!0}catch(C){(0,n.raiseError)(e.core,"1110111515A","run","XmlHttprequest Error",C.message)}return m},r.get=function(e,t){return this.transact("GET",e,void 0,t)},r.post=function(e,t,r){return this.transact("POST",e,t,r)},r.abort=function(){var e=this.xmlhttp;return this.open=!1,e&&"function"==typeof e.abort&&e.readyState&&0!==e.readyState&&e.abort()},r.dispose=function(){var e=this;return e.open&&e.abort(),delete e.onError,delete e.onSuccess,delete e.xmlhttp,delete e.open,d.objects--,null},t}();h.headers={"If-Modified-Since":"Sat, 29 Oct 1994 19:43:31 GMT","X-Requested-With":"XMLHttpRequest","X-Requested-By":"FusionCharts",Accept:"text/plain, */*","Content-Type":"application/x-www-form-urlencoded; charset=UTF-8"};var g=h;t["default"]=g}).call(this,r(6))},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(231),a=r(311);function i(e,t,r,i,o){void 0===e&&(e=""),void 0===t&&(t={}),(0,n.triggerEvent)("dataLoadRequested",o,{source:a.sourceName,url:e,dataFormat:"xml",silent:!!i,config:t,successcallback:r},void 0,a.onDataLoadRequest,a.onDataLoadRequestCancel)}function o(e){this.setChartDataUrl(e,"xmlurl")}function s(){(0,n.raiseWarning)(this,"11171116293","run","JavaScriptRenderer~setDataURL()",'Use of deprecated "setDataURL()". Replace with "setXMLUrl()".'),this.setXMLUrl.apply(this,arguments)}var l={extension:function(e){return e&&(e.prototype.setXMLUrl=o),e&&(e.prototype.setDataURL=s),{format:"xmlurl",toJSON:i}},name:"XMLUrl",type:"transcoder",requiresFusionCharts:!0};t["default"]=l},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a=["series","styledefinition"];var i={extension:function(e){e.addEventListener("beforedataupdate",(function(e,t){t.data=function r(e,t){void 0===t&&(t=!1);var i=typeof e;if("string"===i||"number"===i||"function"===i||"boolean"===i)return e;if(null===e||e===n.UNDEF)return e;if(Array.isArray(e)){for(var o=[],s=0;s<e.length;s++)o.push(r(e[s]));return o}if("object"==typeof e){var l={};for(var c in e){var u=t?c:c.toLowerCase();"data"!==u?l[u]=r(e[c],a.includes(u)):e[c]&&e[c]._dataStore?l[u]=e[c]:l[u]=r(e[c])}return l}}(t.data)}))},name:"IgnoreCaseExt",type:"extension",requiresFusionCharts:!0};t["default"]=i},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(232),s=r(231);function l(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(r)return(r=r.call(e)).next.bind(r);if(Array.isArray(e)||(r=function(e,t){if(!e)return;if("string"==typeof e)return c(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return c(e,t)}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0;return function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var u,d=/\s+!important$/,f=/\\!important$/,h=function(e,t){var r,n,a=t;for(n in a=(a+"").toLowerCase(),e)if(e.hasOwnProperty(n)&&a===(n+"").toLowerCase()){r=e[n];break}return r},g=function(e){var t,r;for(t=0,r=e.length;t<r;t++)if("function"==typeof e[t])return!0;return!1},p=function(e){var t,r=[];for(t in e)r[t]=e[t];return r},m=function(e){return e.replace(/^\s\s*/,"").replace(/\s\s*$/,"")},v=function(e){var t,r={};for(var n in e)e.hasOwnProperty(n)&&(r[(t=e[n]).name]=t);return r},b=function(e,t){for(var r=t.length,n=-1;r--;)if(e===t[r])return n=r;return n},y=function(e,t,r,n){void 0===n&&(n=null);var a=e;return"object"!=typeof a&&"object"!=typeof t?null:("object"!=typeof t||null===t||("object"!=typeof a&&(a=t instanceof Array?[]:{}),function i(e,t,r,n,a,o){var s,l,c,u,d,f=a,h=o;if(h?(f.push(e),h.push(t)):(f=[e],h=[t]),t instanceof Array)for(s=0;s<t.length;s+=1){try{l=e[s],c=t[s]}catch(g){continue}"object"!=typeof c?r&&void 0===c||(e[s]=c):(null!==l&&"object"==typeof l||(l=e[s]=c instanceof Array?[]:{}),-1!==(d=b(c,h))?l=e[s]=f[d]:i(l,c,r,n,f,h))}else for(s in t){try{l=e[s],c=t[s]}catch(g){continue}null!==c&&"object"==typeof c?"[object Object]"===(u=Object.prototype.toString.call(c))?(null!==l&&"object"==typeof l||(l=e[s]={}),-1!==(d=b(c,h))?l=e[s]=f[d]:"data"===s&&c._dataStore?e[s]=n?n(l,c):c:i(l,c,r,n,f,h)):"[object Array]"===u?(null!==l&&l instanceof Array||(l=e[s]=[]),-1!==(d=b(c,h))?l=e[s]=f[d]:i(l,c,r,n,f,h)):e[s]=n?n(l,c):c:e[s]=n?n(l,c):c}return e}(a,t,r,n)),a)},x=function(e){var t=e,r={important:!1,str:""};return t?(t=t.toString(),d.test(t)?(t=t.replace(d,""),r.important=!0):(t=t.replace(f,"!imporant"),r.important=!1),r.str=t,r):r},w=function(e,t){var r=x(e),n=x(t);return r.important&&!n.important?r.str:n.str},C=function(e,t){var r,n,a,i,o,s=t.getAll();for(r in s)n=r.toLowerCase(),a=s[r].toString(),i=x(a),o=x(e[n]),i.important&&!o.important?e[n]=i.str:o.important?e[n]=o.str:void 0===e[n]&&"object"!=typeof s[r]?e[n]="object"!=typeof s[r]?i.str:s[r]:"object"==typeof s[r]&&("undefined"==typeof e[n]&&(e[n]=s[r]),e[n]=y(s[r],e[n],!1,w))},k=function A(e,t){for(var r,n,a,i,o,s,c,u,d,f,h=0,m=0,v=function(e,t){for(var r,n,a=[].concat(Object.keys(e)),i=l(t.themeArray);!(n=i()).done;)r=n.value,a.push.apply(a,Object.keys(r));return Array.from(new Set(a))}(e,t),b=l(v);!(f=b()).done;)if(void 0===(n=e[r=f.value])&&(n=e[r]={}),u="timeseries"===t.type&&t.themeComponents[r]&&g(t.themeComponents[r]),n instanceof Array&&!u)for(s=n.length,o=0;o<s;o+=1)"object"==typeof(i=n[o])&&("category"===r?"true"===i.vline?(a=t.component("vline",h,i))&&(C(i,a),h+=1):(a=t.component("category",m,i,s))&&(C(i,a),m+=1):(a=t.component(r,o,i,s))&&(C(i,a),A(i,a)));else if("object"==typeof n)if(u)if(d=(a=t.component(r,null,n)).getAll(),e[r]=d,/^\d+$/.test(Object.keys(d).join("")))for(d=p(d),e[r]=d,c=0;c<e[r].length;c++)A(e[r][c],a);else A(n,a);else(a=t.component(r,null,n))&&(C(n,a),A(n,a))},_=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configure=function(){!this.config.themeStore&&(this.config.themeStore={})},r.add=function(e){for(var t,r=0,n=e.length;r<n;r+=1)(t=e[r].name)&&(this.config.themeStore[t]=e[r])},r.themify=function(e,r,n,a,i){var l,c,u=r.jsVars,d=e.split(","),f=[],h=d.length;if(this.config.themeStore=v((0,o.getDepsByType)("theme")),h){for(c=0;c<h;c+=1)(l=this.config.themeStore[m(d[c])])&&f.push(t.evaluateThemeJSON(l.theme,r,n,i));f.length?(u.themeObject=new S(f,r,!1,a,n),t.applyTheme(r)):(0,s.raiseWarning)(r,"14051100501","run","api.themes~themify()",'The theme "'+e+'" requested has not been registered.')}},t.evaluateThemeJSON=function(e,t,r,n){var a,i,o={},s=t.jsVars,l=r,c=function(e){var t,r;for(t in e)r=e[t],o[t]=r instanceof Array?y(o[t]||[],r):"object"==typeof r?y(o[t]||{},r):r};return l=l||t.chartType(),s.themeObject&&e!==s.themeObject&&(s.themeObject.dispose(),delete s.themeObject),c(h(e,"base")),n&&(a=h(e,n)),a&&c(a),l&&(i=h(e,l)),i&&c(i),o},t.applyTheme=function(e){var t=e.jsVars.themeObject,r=t.getThemedJSONData().data;r&&k(r,t)},t}(i.ComponentInterface),S=function(e){function t(t,r,n,a,i){var o,s,l=0;for((o=e.call(this)||this).themeArray=t,o.themeComponents={},o.base={},o.type=i,o.chartInstance=r,o.isChildInstance=Boolean(n),o.themedData=n?null:a,o.length=t.length,s=t.length;l<s;l+=1)o.parse(t[l]);return o}(0,a["default"])(t,e);var r=t.prototype;return r.pushTheme=function(e,t){void 0===t&&(t=!1),e&&(this.themeArray.push(e),this.parse(e,t),this.length+=1)},r.parse=function(e,t){var r,n;if(e instanceof Array)for(r=e.length,n=0;n<r;n++)this._parseSubBlock(e[n],t);else this._parseSubBlock(e,t)},r._parseSubBlock=function(e,r){var n,a,i,o,s=this,l=s.base,c=s.type,u=s.themeComponents,d=s.chartInstance,f=s.isChildInstance;for(n in e)"string"==typeof e[n]||"number"==typeof e[n]?l[n]?(a=x(e[n]),i=x(l[n]),!a.important&&i.important||(l[n]=e[n])):l[n]=e[n]:"timeseries"===c&&f?e[n]instanceof Array&&"palettecolors"!==n&&!r?(u[n]||(u[n]=[]),u[n].push(y([],e[n]))):("object"==typeof e[n]||r)&&(l[n]=e[n]):(u[n]||(u[n]=[]),o=u[n],e[n]instanceof Array?o.push(y([],e[n])):"object"==typeof e[n]?o.push(new t([e[n]],d,!0,{},c)):"function"==typeof e[n]&&o.push(e[n]))},r.mergeWithThemeInstance=function(e){var t,r,n,a=this.base,i=e.base,o=this.themeComponents,s=e.themeComponents;for(n in i)t=x(a[n]),r=x(i[n]),t.important&&!r.important||(a[n]=i[n]);for(n in s)o[n]?o[n]=o[n].concat(s[n]):o[n]=[].concat(s[n]);this.length+=e.length},r.get=function(e){return this.base[e]},r.getAll=function(){return y({},this.base)},r.component=function(e,r,n,a){var i,o,s,l,c=this.chartInstance,u=new t([],c,!0,{},this.type);if(!(s=this.themeComponents[e]))return null;for(i=0,o=s.length;i<o;i+=1)"function"==typeof(l=s[i])?"timeseries"!==this.type?u.mergeWithThemeData(l.call(c,r,n,a),r||0,n):u.mergeWithThemeData(l.call(c,n),r,n,!0):u.mergeWithThemeData(l,r,n);return u},r.mergeWithThemeData=function(e,r,n,a){void 0===a&&(a=!1);var i,o=this,s=r;e instanceof Array?(s=s||0,(i=e[s%=e.length])instanceof t?o.mergeWithThemeInstance(i):"function"==typeof i?o.pushTheme(i.call(parent,s,n,length),a):o.pushTheme(i,a)):e instanceof t?o.mergeWithThemeInstance(e):o.pushTheme(e,a)},r.getThemedJSONData=function(){return{data:this.themedData}},r.dispose=function(){var e,t,r=this,n=r.themeComponents;for(e in n)if(t=n[e].length){for(;t--;)n[e][t].dispose&&n[e][t].dispose();delete n[e]}r.themeComponents=null,r.chartInstance=null,r.base=null,r.themeArray=null,r.isChildInstance=null,r.dataWithoutTheme=null},t}(i.ComponentInterface);(u=new _).configure();var E={extension:function(e){e.addEventListener("internal.dataSanitized",(function(t){var r,n,a,i=t.sender,s=i.getFromEnv("chartInstance"),l=v((0,o.getDepsByType)("theme")),c=i.getFromEnv("dataSource"),d=e.options.defaultTheme,f=c&&(c.chart&&c.chart.theme||c.map&&c.map.theme),h=(d||f)&&(d||"")+","+(f||""),g=h&&h.split(","),p=g&&g.length,b=!1;for(n=0;n<p;n++)a=m(g[n]),l&&""!==a&&l.hasOwnProperty(a)&&(b=!0);b?(c=y({},i.getFromEnv("dataSource")),r=s.chartType(),c.map&&(c.chart=c.map,delete c.map),u.themify(h,s,r,c,"geo"===s.apiInstance.defaultSeriesType&&"geo"),i.addToEnv("dataSource",c)):s.jsVars&&s.jsVars.themeObject&&(s.jsVars&&s.jsVars.themeObject.dispose(),s.jsVars&&delete s.jsVars.themeObject)}))},name:"ThemeEngine",type:"extension",requiresFusionCharts:!0};t["default"]=E},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a={extension:{name:"default",theme:{base:{chart:{labelDisplay:"stagger !important",caption:"Theme Caption \\!important",canvasBgColor:"#56EF22",borderThickness:"5 !important",borderColor:"#E60539",baseFontColor:"#781129"},categories:[{fontColor:"#0F4F40",fontSize:15,category:function(e){return{showLabel:e%2?0:1}},vline:{color:"#000000",thickness:2}}],dataset:[{color:"#8C3146",data:function(e,t){return 8===e&&(t.value=n.BLANKSTRING),{color:Number(t.value)<32e3?"#8C3146":"#FF0000",alpha:"100"}}}],trendlines:[{line:function(e){return e?{color:"#ff0000",thickness:3}:{color:"#ffff00",thickness:3}}}]},pie2d:{chart:{bgColor:"#FF0000"}},msline:{chart:{canvasBgColor:"#ff0000"}},geo:{chart:{canvasBgColor:"#0000ff"}},world:{chart:{canvasBgColor:"#00ff00"}}}},name:"DefaultTheme",type:"theme"};
/** !
 * @license FusionCharts JavaScript Library
 * Copyright FusionCharts, Inc.
 * License Information at <http://www.fusioncharts.com/license>
 */t["default"]=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a,i=r(224),o=n(r(318)),s=r(236),l=/^#?[0-9a-f]{6}/i,c=/FFFFFF/i,u=/255,255,255/,d=function(e){var t=e.replace("rgba(","").split(",");return"#"+("000000"+(t[0]<<16|t[1]<<8|t[2]).toString(16)).slice(-6)},f=function(e,t){var r,n,a=[];if("number"==typeof e)return t;for(n=e.split&&e.split(","),r=0;r<n.length;r++)a.push(t);return a.join()},h=function(e){var t;return/rgb/.test(e)?(t=e.match(/[\d\.]+\)/g),parseFloat(t&&t[0])):e.FCcolor?(0,i.getFirstAlpha)(e.FCcolor.alpha):void 0},g=function(e){e.forEach((function(e){return function t(e){e.removeStateCosmetics("highlight",t)}(e)}))},p=function(e,t,r,n,a){var o,s,l,c,u,f;o=d(n.color),l=100*h(n.color),s=a?(0,i.pluck)(r.valuefontcolor,o):o,c=a?(0,i.pluck)(r.valuefontalpha,r.alpha,l):l,o=""===n.backgroundColor?"":d(n.backgroundColor),l=""===n.backgroundColor?0:100*h(n.backgroundColor),isNaN(l)&&(l=0),u=(0,i.toRaphaelColor)({color:a?(0,i.pluck)(r.valuebgcolor,o):o,alpha:a?(0,i.pluck)(r.valuebgalpha,r.alpha,l):l}),o=""===n.borderColor?"":d(n.borderColor),l=""===n.borderColor?"":100*h(n.borderColor),isNaN(l)&&(l=0),f=(0,i.toRaphaelColor)({color:a?(0,i.pluck)(r.valuebordercolor,o):o,alpha:a?(0,i.pluck)(r.valueborderalpha,r.alpha,l):l}),t&&e.setAnimation({el:t,label:"highlightedDataLabel",attr:{fill:(0,i.toRaphaelColor)({color:s,alpha:c}),"text-bound":[u,f,n.borderThickness,n.borderPadding,n.borderRadius,n.borderDash]}})},m=function(e){var t,r,n,a,i,o=e.split(","),s={};for(t=0,r=o.length;t<r;t++)a=(n=o[t].split("="))[0],i=n[1],s[a]=i;return s},v=function(e,t,r){var n,a,o=t.color;return/rgb/.test(e)?(n=(0,i.pluck)(t.alpha,100*h(e)),/rgb/.test(o)&&(o=d(o)),a=r?(0,i.toRaphaelColor)({color:(0,i.pluck)(o,d(e)),alpha:n}):e):e.FCcolor?a=r?(0,i.toRaphaelColor)(function(e,t){var r,n,a={};for(r in e)"alpha"===r?a[r]=t.alpha?f(e[r],t.alpha):e[r]:"color"===r?(-1!==e[r].indexOf(",")&&t.color&&(n=t.color+","+e[r].substring(e[r].indexOf(",")+1)),a[r]=(0,i.pluck)(n||t.color,e[r])):a[r]=e[r];return a}(e.FCcolor,t)):(0,i.toRaphaelColor)(e.FCcolor):l.test(e.color||e)&&(a=r?(0,i.toRaphaelColor)({color:(0,i.pluck)(t.color,e.color,e),alpha:(0,i.pluck)(t.alpha,e.alpha)}):(0,i.toRaphaelColor)({color:e.color||e,alpha:e.alpha})),a},b=function(e,t,r,n,a,o){var s,l,c,u,f,g,p,m,b={},y={};a?(s=(0,i.getColumnColor)(n.color||r.upperColorArr[0].FCcolor.color,n.alpha.toString(),r.upperColorArr[0].FCcolor.ratio,r.upperColorArr[0].FCcolor.angle,o,n.bordercolor||d(r.upperBoxBorder.color),n.borderalpha&&n.borderalpha.toString()||(100*h(r.lowerBoxBorder.color)).toString()),y=(0,i.toRaphaelColor)(s[0]),l=(0,i.getColumnColor)(n.color||r.lowerColorArr[0].FCcolor.color,n.alpha.toString(),r.lowerColorArr[0].FCcolor.ratio,r.lowerColorArr[0].FCcolor.angle,o,n.bordercolor||d(r.lowerBoxBorder.color),n.borderalpha&&n.borderalpha.toString()||(100*h(r.lowerBoxBorder.color)).toString()),b=(0,i.toRaphaelColor)(l[0]),c=v(r.median.color,n,a),g=v(r.lowerQuartile.color,n,a),p=v(r.upperQuartile.color,n,a)):(y=(0,i.toRaphaelColor)(r.upperColorArr[0]),b=(0,i.toRaphaelColor)(r.lowerColorArr[0]),c=r.median.color,u=r.upperBoxBorder.color,f=r.lowerBoxBorder.color,p=r.upperQuartile.color,g=r.lowerQuartile.color),m=t.upperBoxElem,e.setAnimation({el:m,label:"highlightedBoxAnsWhiskerPlot",attr:{fill:y,"drop-shadow":m.attrs["drop-shadow"]&&"none"!==m.attrs["drop-shadow"]?[1,1,3,"rgba(64,64,64,"+h(y)+")",m.attrs[4],m.attrs["drop-shadow"][5]]:"none"}}),m=t.lowerBoxElem,e.setAnimation({el:m,label:"highlightedBoxAnsWhiskerPlot",attr:{fill:b,"drop-shadow":m.attrs["drop-shadow"]&&"none"!==m.attrs["drop-shadow"]?[1,1,3,"rgba(64,64,64,"+h(b)+")",m.attrs[4],m.attrs["drop-shadow"][5]]:"none"}}),m=t.lowerBoxBorderEle,e.setAnimation({el:m,label:"highlightedBoxAnsWhiskerPlot",attr:{stroke:f}}),t.upperBoxBorderEle&&e.setAnimation({el:t.upperBoxBorderEle,label:"highlightedBoxAnsWhiskerPlot",attr:{stroke:u}}),t.lowerQuartileEle&&e.setAnimation({el:t.lowerQuartileEle,label:"highlightedBoxAnsWhiskerPlot",attr:{stroke:g}}),t.upperQuartileEl&&e.setAnimation({el:t.upperQuartileEl,label:"highlightedBoxAnsWhiskerPlot",attr:{stroke:p}}),t.midLineElem&&e.setAnimation({el:t.midLineElem,label:"highlightedBoxAnsWhiskerPlot",attr:{stroke:c}})},y=function(e,t,r){var n,a,o,s,l,c,u,d,f,h=e.getFromEnv("chart"),g=e.getFromEnv("animationManager"),m=(h.config,h.config.dataLabelStyle),v=e.components.data;for(n=0,a=v.length;n<a;n++)if(u=v[n])for(c in o=u.graphics,f=(s=u.config.anchorProps).enabled,l={fillColor:{FCcolor:{alpha:r&&f?(0,i.pluck)(t.anchorbgalpha,t.alpha,s.bgAlpha):s.bgAlpha,color:r&&f?(0,i.pluck)(t.anchorbgcolor,t.color,s.bgColor):s.bgColor}},borderColor:{FCcolor:{alpha:r&&f?(0,i.pluck)(t.borderalpha,t.alpha,s.borderAlpha):s.borderAlpha,color:r&&f?(0,i.pluck)(t.anchorbordercolor,t.color,s.borderColor):s.borderColor}},imageAlpha:r?t.alpha:s.imageAlpha,imageScale:s.imageScale},o)switch((d=!c.match(/error/gi)&&o[c])&&d.type){case"path":g.setAnimation({el:d,label:"highlightedAnchorPlot",attr:{fill:(0,i.toRaphaelColor)(l.fillColor),stroke:(0,i.toRaphaelColor)(l.borderColor)}});break;case"image":g.setAnimation({el:d,label:"highlightedAnchorImagePlot",attr:{opacity:l.imageAlpha/100}});break;case"text":p(g,d,t,m,r)}},x=function(e,t,r,n,a){var o,s=e.getStateCosmetics("default").symbol||{},f=s.fill,h=s.stroke,g=a?(0,i.pluck)(n.color,d(r.text.fill)):d(r.text.fill),p=t.legendItemLine,m=r.symbol.stroke,b=e.getFromEnv("animationManager");p&&m&&(l.test(m)?b.setAnimation({el:p,label:"highlightedLegendItem",attr:{stroke:a?(0,i.toRaphaelColor)({color:(0,i.pluck)(n.color,m),alpha:n.alpha}):m}}):(o=v(m,n,a),b.setAnimation({el:p,label:"highlightedLegendItem",attr:{stroke:o}}))),f&&(f=f.match(l)?a&&!c.test(f)?(0,i.toRaphaelColor)({color:n.color||f,alpha:n.alpha}):f:u.test(f)?f:v(f,n,a)),h&&(h=l.test(h)?a&&!c.test(h)?(0,i.toRaphaelColor)({color:n.color||h,alpha:n.alpha}):h:a&&!u.test(h)&&n.color?(0,i.toRaphaelColor)({color:n.color,alpha:n.alpha}):h),e.setStateCosmetics("highlight",{symbol:{fill:f||"none",stroke:h||"none",opacity:(a?n.alpha:100)/100},text:{fill:(0,i.toRaphaelColor)({color:g,alpha:a?n.alpha:100})}}),e.hasState("hidden")||e.setLegendState("highlight",!0)},w=function(e,t){var r=e.getFromEnv("legend").getItem(t);return r&&r.getGraphicalElement()},C={area:function(e,t,r){var n,a,o,s,l,c,u,d,f,g,p,v,b,C,k,_=this,S=_.getFromEnv("chart"),E=_.getFromEnv("animationManager"),A=S.getFromEnv("legend").getChildren("legendItem")||[],N=arguments[4],T=A.length,M=m(e),D=w(S,N),F=S.config.dataLabelStyle,I=_.getContainer("labelGroup"),O=_.config,L=O.shadow||{},R=L.opacity>0;if(!r&&_.getState("visible")){for(M.alpha=M.alpha||30,a=0;a<T&&(n=A[a]||{}).getId()!==N;a++);I&&E.setAnimation({el:I,label:"highlightedGroup",attr:{opacity:t?M.alpha/100:h(F.color)}}),s=O.plotbordercolor,f=O.plotborderalpha,C=O.plotfillalpha,o=O.plotgradientcolor,v=_.getGraphicalElement("lineElement")||_.getGraphicalElement("splineElement"),u=t?(0,i.pluck)(M.bordercolor,M.color,s):s,M.color&&(g=M.color+(o?","+o:"")),p=O.fillColor.color,l=t?(0,i.pluck)(g,p):p,b=O.plotfillangle,c=t?M.alpha:C,d=t?(0,i.pluck)(M.borderalpha,M.alpha):f,k=!!R&&(t?M.alpha/100:c/100),E.setAnimation({el:v,label:"highlightedAreaPlot",attr:{fill:(0,i.toRaphaelColor)({color:l,alpha:c,angle:b}),stroke:(0,i.toRaphaelColor)({color:u,alpha:d})}}),v.shadow(k),D&&x(n,D,n.parseLegendCosmetics(),M,t),y(_,M,t)}},bubble:function(e,t,r){var n,a,o,s,l,c,u,d,f,g,v,b,y=this,C=y.getFromEnv("chart"),k=y.getFromEnv("animationManager"),_=C.getFromEnv("legend").getChildren("legendItem")||[],S=_.length,E=arguments[4],A=C.config.dataLabelStyle,N=y.getContainer("labelGroup"),T=m(e);if(!1===r&&y.getState("visible")){for(T.alpha||(T.alpha=30),o=y.components.data||[],a=0;a<S&&(n=_[a]||{}).getId()!==E;a++);for(x(n,w(C,E),n.parseLegendCosmetics(),T,t),N&&k.setAnimation({el:N,label:"highlightedGroup",attr:{opacity:t?T.alpha/100:h(A.color)}}),a=0,S=o.length;a<S;a++)(s=o[a])&&(v=s.graphics,c=(l=s.config).colorObj,d=l.is3D,u=v.element,b=v.label,d?(g=t?(0,i.getPointColor)((0,i.pluck)(T.color,c.FCcolor.color),(0,i.pluck)(T.alpha,(0,i.getFirstAlpha)(c.alpha))):c,g=(0,i.toRaphaelColor)(g)):(g=t?(0,i.pluck)(T.color,c.color):c.color,f=t?T.alpha:c.alpha,g=(0,i.toRaphaelColor)({color:g,alpha:f})),u&&k.setAnimation({el:u,label:"highlightedBubblePlot",attr:{fill:g}}),b&&p(k,b,T,A,t))}},pie:function(e,t,r,n){var a,s,l,c,u,d,f,g,v,b,y,C,k,_,S=this,E=n.getFromEnv("chart"),A=n.getFromEnv("animationManager"),N=this,T={},M=arguments[4],D=E.getFromEnv("legend").getChildren("legendItem")||[],F=m(e);if(!1===r){for(F.alpha||(F.alpha=30),s=S.graphics.element,l=S.config,y=0,b=D.length;y<b&&(k=D[y]).getId()!==M;y++);C=w(E,M),x(k,C,k.parseLegendCosmetics(),F,t),u=l.color.color,E=(N=s.data("plotItem")).chart,a=N.style,c=90,f=E.config.is3D,(d=N.center)&&(T={cx:d[0],cy:d[1],r:N.radius}),u=t?(0,o["default"])((0,i.pluck)(F.color,u),F.alpha,c):l.color,_=t?F.alpha:u.alpha,u=(0,i.extend2)(u,T),f?s&&A.setAnimation({el:s,label:"highlightedPiePlot",attr:{color:u.color.split(",")[0],alpha:_}}):s&&A.setAnimation({el:s,label:"highlightedPiePlot",attr:{fill:(0,i.toRaphaelColor)(u)}}),g=S.graphics.label,v=S.graphics.connector,g&&p(A,g,F,a,t),v&&A.setAnimation({el:v,label:"highlightedPieConnectorPlot",attr:{opacity:t?F.alpha/100:h(a.color)}})}},line:function(e,t,r){var n,a,o,s,l,c,u,d=this,f=d.getFromEnv("chart"),g=d.getFromEnv("animationManager"),p=f.getFromEnv("legend").getChildren("legendItem")||[],v=p.length,b=arguments[4],C=f.config.dataLabelStyle,k=m(e),_=w(f,b),S=d.getContainer("labelGroup"),E=d.getContainer("errorPlotGroup"),A=d.config,N=A.linecolor,T=A.alpha||A.lineAlpha,M=A.shadow||{},D=M.opacity>0,F=d.config.lineOb,I="";if(!r&&d.getState("visible")){for(k.alpha||(k.alpha=30),l=0;l<v&&(n=p[l]||{}).getId()!==b;l++);if(E&&(a=A.errorBarColor&&h(A.errorBarColor),o=t?(0,i.pluck)(k.alpha/100,a):a,g.setAnimation({el:E,label:"highlightedGroup",attr:{opacity:o}})),S&&g.setAnimation({el:S,label:"highlightedGroup",attr:{opacity:t?k.alpha/100:h(C.color)}}),s=d.getGraphicalElement("lineElement"),N=t?(0,i.pluck)(k.color,N):N,T=t?(0,i.pluck)(k.alpha,T):T,c=!!D&&(t?k.alpha/100:T/100),s&&g.setAnimation({el:s,label:"highlightedLinePlot",attr:{stroke:(0,i.toRaphaelColor)({color:N,alpha:T})}}),s&&s.shadow(c),"object"==typeof F&&F)for(I in F)(u=F[I]&&F[I].el)&&g.setAnimation({el:u,label:"highlightedLinePlot",attr:{stroke:t?N:F[I].attr.stroke,"stroke-opacity":T/100}}),u&&u.shadow(c);_&&x(n,_,n.parseLegendCosmetics(),k,t),y(d,k,t)}},boxandwhisker2d:function(e,t,r){var n,a,i,o,s,l,c=this,u=c.getFromEnv("chart"),d=c.getFromEnv("animationManager"),f=c.config.isRoundEdges,h=arguments[4],g=w(u,h),p=c.getContainer("lowerWhiskerGroup"),v=c.getContainer("upperWhiskerGroup"),y=c.getContainer("labelGroup"),C=u.getFromEnv("legend").getChildren("legendItem")||[],k=C.length,_=m(e);if(!1===r&&c.getState("visible")){for(_.alpha||(_.alpha=30),n=0;n<k&&(a=C[n]||{}).getId()!==h;n++);for(x(a,g,a.parseLegendCosmetics(),_,t),p&&d.setAnimation({el:p,label:"highlightedGroup",attr:{opacity:t?_.alpha/100:1}}),v&&d.setAnimation({el:v,label:"highlightedGroup",attr:{opacity:t?_.alpha/100:1}}),y&&d.setAnimation({el:y,label:"highlightedGroup",attr:{opacity:t?_.alpha/100:1}}),n=0,k=(l=c.components.data).length;n<k;n++)s=(o=l[n]).config,i=o.graphics,b(d,i,s,_,t,f)}},heatmap:function(e,t,r,n){var a,o,s,l,c,u,f,g,v,b,y,C=this,k=n.getFromEnv("chart"),_=n.getFromEnv("animationManager"),S=k.config,E=S.dataLabelStyle,A=k.getFromEnv("legend"),N=arguments[4],T=m(e),M=A.getChildren("legendItem")||[];if(!r&&n.getState("visible")&&!1!==C.visible){for(T.alpha||(T.alpha=t?30:100),S=C.config,v=0,g=M.length;v<g&&(y=M[v]).getId()!==N;v++);for(u in b=w(k,N),x(y,b,y.parseLegendCosmetics(),T,t),c=d(S.color),l=h(S.color),a=t?(0,i.pluck)(T.color,c):c,o=t?T.alpha:100*l,(s=(f=C.graphics).element)&&_.setAnimation({el:s,label:"highlightedHeatmapPlot",attr:{fill:(0,i.toRaphaelColor)({color:a,alpha:o})}}),f)"text"===(s=f[u]).type&&p(_,s,T,E,t)}},funnelpyramid:function(e,t,r,n){var a,o,s,l,c,u,f,g,v,b,y,C,k,_,S,E=this,A=n.getFromEnv("chart"),N=n.getFromEnv("animationManager"),T=m(e),M=A.getFromEnv("legend").getChildren("legendItem")||[],D=arguments[4];if(!1===r){for(T.alpha||(T.alpha=30),l=E,k=0,C=M.length;k<C&&(S=M[k]).getId()!==D;k++);_=w(A,D),x(S,_,S.parseLegendCosmetics(),T,t),o=l.style,y=l.color,c=d(y),b=h(y),u=t?(0,i.pluck)(T.color,c):c,f=t?T.alpha:100*b,s=E.getGraphicalElement("graphic"),g=E.getGraphicalElement("dataLabel"),v=E.getGraphicalElement("connector"),a=E.style,s&&N.setAnimation({el:s,label:"highlightedFunnelPyramidPlot",attr:{fill:(0,i.toRaphaelColor)({color:u,alpha:f})}}),g&&p(N,g,T,a,t),v&&N.setAnimation({el:v,label:"highlightedFunnelPyramidConnectorPlot",attr:{opacity:t?T.alpha/100:h(o.color)}})}},sankey:function(e,t,r){var n,a,i=e.getLinkedParent(),o=i.getChildren("legend")[0];e.getChildren("nodes").forEach((function(e){n=o.getItem(e.config.legendItemId),e.config.legendItemId===t?(r?e.onFocusCallback():e.onFocusOutCallback(),a=!1):a=!0,a=a&&r,x(n,w(i,t),n.parseLegendCosmetics(),{alpha:30},a)}))},radialbar:function(e,t,r){var n=m(e),a=this.getFromEnv("legend").getItem(this.config.legendItemId),o=parseInt(n.alpha,10)/100*(this.config.realBarAlpha||this.config.baralpha),s=parseInt(n.alpha,10)/100*(this.config.realBarBorderAlpha||this.config.barborderalpha);x(a,w(this.getLinkedParent(),this.config.legendItemId),a.parseLegendCosmetics(),n,t&&!r),this.config.realBarAlpha=this.config.realBarAlpha||this.config.baralpha,this.config.realBarBorderAlpha=this.config.realBarBorderAlpha||this.config.barborderalpha,this.config.realColor=this.config.realColor||this.config.color,this.config.realBarBorderColor=this.config.realBarBorderColor||this.config.barbordercolor,this.config.realBorderAlpha=this.config.realBorderAlpha||this.config.borderalpha,t&&!r?this.setData({baralpha:isNaN(o)?.25:o,barborderalpha:isNaN(s)?.25:s,color:n&&n.color?(0,i.toRaphaelColor)(n.color):this.config.color,barbordercolor:n&&n.bordercolor?(0,i.toRaphaelColor)(n.bordercolor):this.config.bordercolor,borderalpha:n&&n.borderalpha?n.borderalpha:this.config.borderalpha},!0):(this.setData({baralpha:this.config.realBarAlpha,barborderalpha:this.config.realBarBorderAlpha,color:this.config.realColor,barbordercolor:this.config.realBarBorderColor,borderalpha:this.config.realBorderAlpha},!0),g([a]))},"default":function(e,t,r){var n,a,o,s,l,c,u,d,f,g,v,b,y,C,k,_=this,S=_.config,E=_.getFromEnv("chart"),A=_.getFromEnv("animationManager"),N=E.config,T=N.dataLabelStyle,M=N.useroundedges,D=E.config.is3D,F=m(e),I=arguments[4],O=w(E,I),L=_.getContainer("labelGroup"),R=_.getContainer("errorPlotGroup"),P="",V=E.getFromEnv("legend"),j=V.getChildren("legendItem")||[],B=j.length,z=S.showShadow;if(!1===r&&!0===_.getState("visible")){for(F.alpha||(F.alpha="30"),v=_.components.data||[],a=0;a<B&&(C=j[a]||{}).getId()!==I;a++);for(O&&x(C,O,C.parseLegendCosmetics(),F,t),L&&A.setAnimation({el:L,label:"highlightedGroup",attr:{opacity:t?F.alpha/100:h(T.color)}}),R&&(l=S.errorBarColor&&h(S.errorBarColor),c=t?(0,i.pluck)(F.alpha/100,l):l,A.setAnimation({el:R,label:"highlightedGroup",attr:{opacity:c}})),a=0,B=v.length;a<B;a++)(b=v[a])&&b.graphics&&(g=(N=b.config).colorArr[0],k=(o=N.colorArr[1]).FCcolor.alpha,P=-1!==(d=(n=g.FCcolor.color).indexOf(","))&&F.color?F.color+n.substring(d):(0,i.pluck)(F.color,n),f=D?k:(0,i.pluck)(F.borderalpha,F.alpha,k),0===(0,i.pluckNumber)(k)&&(f="0"),u=t?(0,i.getColumnColor)(P,F.alpha,g.FCcolor.ratio,g.FCcolor.angle,M,(0,i.pluck)(F.bordercolor,o.FCcolor.color),f,!1,D):[g,o],(s=b.graphics.element)&&(n=(0,i.toRaphaelColor)(u[0]),o=(0,i.toRaphaelColor)(u[1]),A.setAnimation({el:s,label:"highlightedDefaultPlot",attr:{stroke:o,fill:n}}),s.shadow({opacity:z?(0,i.getFirstAlpha)(u[0].alpha)/100:0})),y=b.graphics.label,p(A,y,F,T,t))}}},k=function(e,t){var r=e.sender.apiInstance;!1!==r.hasInteractiveLegend&&!1!==r.highlightEnabled&&a.applyEffect(r,t,!0)},_=function(e,t){var r=e.sender.apiInstance;!1!==r.hasInteractiveLegend&&!1!==r.highlightEnabled&&a.applyEffect(r,t,!1)},S=function(e,t){var r=e.sender.apiInstance;r.addJob("plothighlighteffect",(function(){r.config.showLegend&&!1!==r.hasInteractiveLegend&&!1!==r.highlightEnabled&&a.applyEffect(r,t,!0)}),s.priorityList.postRender)};var E={extension:function(e){var t;(a=new(function(){function t(){this.effectStore={},this.eventHandlers={}}var r=t.prototype;return r.add=function(e){this.effectStore[e.name]=e},r.attachEventHandlers=function(t,r){this.eventHandlers[t]||(this.eventHandlers[t]={},this.eventHandlers[t].listenerFn=e.addEventListener(t,r))},r.applyEffect=function(e,t,r){var n,a,o,s,l,c,u,d,f,h,p,m,v=this.effectStore,b=e.getFromEnv("chart-attrib"),y=e.config.defaultDatasetType,x=b.plothighlighteffect&&b.plothighlighteffect.toLowerCase(),w=e.getDatasets(),C=e.config.isSingleSeries?w[0].components.data:w,k=(0,i.pluck)(t.itemId,t.legendItemId,t.legendItemIndex),_="";if(g(e.getFromEnv("legend").getChildren("legendItem")),"funnel"===e.getName()||"Pyramid"===e.getName()?C=w[0].getChildren("data"):"RadialBar"===e.getName()&&(C=e.getChildren("plot")),e.getFromEnv("animationManager").setAnimationState("plotHighlighter"),x&&(x=x.replace(/\s+/g,"").split("|"),m=x[0],_=x[1]||""),m&&v[m])if("HeatMap"===e.getName())for(n=e.getFromEnv("colorRange"),p=function(e){var t,r,n=u.getChildren("legendItem"),a=n&&n.length;for(t=0;t<a;++t)if(n[t].config.datasetObj.code===e){r=n[t].getId();break}return r},f=(u=e.getFromEnv("legend")).getItem(k).config.datasetObj,l=0;l<C.length;l++)a=(s=C[l]).config.value,(h=n.getColorObj(a)).outOfRange||(f.code===h.code?v[m][y].call(s,_,r,!0,w[0],k):v[m][y].call(s,_,r,!1,w[0],p(h.code)));else if("sankey"===e.getName())v[m].sankey(w[0],k,r);else if("RadialBar"===e.getName())(u=e.getFromEnv("legend")).getItem(k),C.forEach((function(e){y=(y=e.getName&&e.getName()||y).toLowerCase(),v[m][y].call(e,_,r,e.config.legendItemId===k)}));else for(l=0,d=C.length;l<d;l++)s=C[l],y=(y=s.getName&&s.getName()||y).toLowerCase(),void 0!==(o=(0,i.pluck)(s.config.itemId,s.config.legendItemId))&&(c=o===k,v[m][y]?v[m][y].call(s,_,r,c,w[0],o):v[m]["default"].call(s,_,r,c,w[0],o))},t}())).attachEventHandlers("legenditemrollover",k),a.attachEventHandlers("legenditemrollout",_),a.attachEventHandlers("legenditemclicked",S),(t={name:"fadeout",area:C.area,radar:C.area,bubble:C.bubble,pie2d:C.pie,line:C.line,spline:C.line,splinearea:C.area,pie3d:C.pie,zoomline:C.line,funnelpoint:C.funnelpyramid,pyramidpoint:C.funnelpyramid,scatter:C.line,selectscatter:C.line,dragline:C.line,dragarea:C.area,realtimearea:C.area,realtimeline:C.line,realtimelinedy:C.line,realtimestackedarea:C.area,errorline:C.line,errorscatter:C.line,stepline:C.line,doughnut2d:C.pie,doughnut3d:C.pie,heatmap:C.heatmap,boxandwhisker2d:C.boxandwhisker2d,multiaxisline:C.line,sankey:C.sankey,radialbarplot:C.radialbar,"default":C["default"]})&&a.add(t)},name:"PlotHighlighter",type:"extension",requiresFusionCharts:!0};t["default"]=E},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a=function(e,t,r,a){var i,o,s,l,c,u,d=(0,n.getFirstColor)(e),f=(0,n.getFirstAlpha)(t);return r<100&&n.hasSVG?a?(c=(0,n.getDarkColor)(d,Math.floor(100*(85-.2*(100-r)))/100),u=(0,n.getLightColor)(d,Math.floor(100*(100-.5*r))/100),i={color:c+n.COMMASTRING+u+n.COMMASTRING+u+n.COMMASTRING+c,alpha:f+n.COMMASTRING+f+n.COMMASTRING+f+n.COMMASTRING+f,radialGradient:!0,gradientUnits:"userSpaceOnUse",r:r}):(o=Math.floor(.85*(100-.35*r)*100)/100,s=(0,n.getDarkColor)(d,o),l=Math.floor(.5*(100+r)*100)/100,i={color:(0,n.getLightColor)(d,l)+n.COMMASTRING+s,alpha:f+n.COMMASTRING+f,ratio:r+","+(100-r),radialGradient:!0,gradientUnits:"userSpaceOnUse"}):i={color:d+n.COMMASTRING+d,alpha:f+n.COMMASTRING+f,ratio:"0,100"},i};t["default"]=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(320)),i=r(224),o="__FC_tooltipText",s=function(e,t,r){var n=(0,i.getMouseCoordinate)(t.universe,(0,i.getTouchEvent)(r),t.chart),a=n.chartX,s=n.chartY;a+=11,s+=11,c._draw.call(t,a,s,this.data(o),e)},l=function(e){c._hide(e)},c=function(){function e(t,r){var n=this;n.config={},n.universe=t,this.chart=r,this.restrictWithinCanvas={left:!1,right:!1,top:!1,bottom:!1},n.toolTips={implicit:[],explicit:[]},n.hideImplicitToolTip=function(t){var r=n.lastActiveToolip;r&&t.target!==r.getData("targetElement").node&&(e._hide(r),n.config.lastActiveToolip=i.UNDEF)},n.config.positioningArr=[],n.config.canvasArr=[],t.FusionCharts.jsVars.fcObj.addEventListener("resized",n._updateAllToolTipBounds.bind(n))}var t=e.prototype;return t.setRestrictionWithinCanvas=function(e){void 0===e&&(e={}),Object.assign(this.restrictWithinCanvas,e)},t.getRestrictionWithinCanvas=function(){return this.restrictWithinCanvas},t._updateAllToolTipBounds=function(){var e,t,r=this.config,n=function(t){t.universeBounds&&t.universeBounds.canvas&&(e=r.canvasArr.indexOf(t.universeBounds.canvas)),t.setUniverseBounds(r.positioningArr[e])},a=this.toolTips;for(t in a)a[t].forEach(n)},t._setRelativePosition=function(e){var t=this.config,r=t.canvasArr,n=t.positioningArr,a=r.indexOf(e.canvas);-1===a?(r.push(e.canvas),n.push(e)):(r[a]=e.canvas,n[a]=e)},t._createToolTip=function(e,t){var r,n=this.config;return(r=new a["default"](this.universe,n.positioningArr[n.canvasArr.indexOf(t)])).setRestrictionWithinCanvas(this.restrictWithinCanvas),r.setStyle(this.config.tooltipStyle),this.toolTips[e].push(r),r},t.enableToolTip=function(e,t,r){var n,a,i,c=this,u=c.toolTips.implicit,d=u.length;if(e&&e.abbrArr&&e.abbrArr.length)for(n=0;n<e.abbrArr.length;n++)c.enableToolTip(e.abbrArr[n].el,e.abbrArr[n].title,r);return t?e.data(o)?(d>0&&u.some((function(r){return!(!(a=r).getData("active")||a.data.targetElement!==e)&&(a.show(t),!0)})),e.data(o,t),c):(a=c._getAvailableToolTip("implicit",r),c.disableToolTip(e),e.data(o,t),e.data("__FC_onTooltipMove",s.bind(e,a,c)),e.data("__FC_onTooltipOut",l.bind(e,a)),e.data("__FC_onTooltipOver",(i=e,function(t){c.draw(t,e.data(o),a),a.setData("targetElement",i),c.config.lastActiveToolip=a})),e.on("fc-mousemove",e.data("__FC_onTooltipMove")),e.on("fc-mouseout",e.data("__FC_onTooltipOut")),e.on("fc-mouseover",e.data("__FC_onTooltipOver")),c):(c.disableToolTip(e),c)},t.disableToolTip=function(e){var t=e.data("__FC_onTooltipOut"),r=e.data("__FC_onTooltipMove"),n=e.data("__FC_onTooltipOver");return r&&e.off("fc-mousemove",r),t&&e.off("fc-mouseout",t),n&&e.off("fc-mouseover",n),e.removeData(o),this},t.draw=function(t,r,n,a){var o,s,l=(0,i.getMouseCoordinate)(this.universe,(0,i.getTouchEvent)(t),this.chart),c=n&&!n.disposed?n:this._getAvailableToolTip("explicit",a);return o=l.chartX,s=l.chartY,o+=11,s+=11,e._draw.call(this,o,s,r,c),c},t.drawAt=function(t,r,n,a,i){var o=a&&!a.disposed?a:this._getAvailableToolTip("explicit",i);return e._draw.call(this,t,r,n,o),o},e._draw=function(e,t,r,n){var a=this.config,o=this.chart.getFromEnv("chartConfig").tooltipposition;(0,i.isSimilarObject)(n.previousStyle,a.tooltipStyle)||(n.setStyle(a.tooltipStyle),n.previousStyle=Object.assign({},a.tooltipStyle)),n.show(r),n.update(e,t,o)},t._getAvailableToolTip=function(e,t){for(var r,n=this.toolTips[e],a=0,i=n.length;a<i;a++)if(!1===(r=n[a]).getData("active"))return r;return this._createToolTip(e,t)},t.setStyle=function(e){var t,r=this.config;for(var n in t=r.tooltipStyle={},e)"showToolTipShadow"===n?e[n]?t.boxShadow="1px 1px 3px rgba(64,64,64,0.4)":t.boxShadow="none":t[n]=e[n]},t.hide=function(t){return e._hide(t),this},t.hideAll=function(){var t,r;for(t in this.toolTips)for(r=0;r<this.toolTips[t].length;r++)e._hide(this.toolTips[t][r])},e._hide=function(e,t){e&&(t?e.dispose():e.hide())},e}(),u={extension:c,name:"ToolTipController",type:"plugin"};t["default"]=u},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a="fusioncharts-div",i="#545454",o="3px",s="10px",l="hidden",c="1px",u="#000000",d="nowrap",f="normal",h="absolute",g="solid",p="#ffffff",m="none",v="hidden",b="none",y="left, top",x="auto",w=function(e){var t=e.getBoundingClientRect();return{left:0,top:0,right:t.width||t.right-t.left,bottom:t.height||t.bottom-t.top}},C=function(){function e(e,t){this.text=n.BLANKSTRING,this.x=0,this.y=0,this.visibleWidth=0,this.universe=e,this.setUniverseBounds(t||w(e)),this.data={active:!1,target:!1},this.createElement(e),this.previousStyle={},this.restrictWithinCanvas={left:!1,right:!1,top:!1,bottom:!1}}var t=e.prototype;return t.setUniverseBounds=function(e){this.universeBounds=e||this.universe&&w(this.universe)},t.setRestrictionWithinCanvas=function(e){void 0===e&&(e={}),Object.assign(this.restrictWithinCanvas,e)},t.getRestrictionWithinCanvas=function(){return this.restrictWithinCanvas},t.createElement=function(e){var t=this.element=document.createElement("div");return t.setAttribute("class","fc__tooltip"),t.className+=" "+a,t.innerHTML=this.text,e.appendChild(this.setDefaultStyle()),t},t.setDefaultStyle=function(){var e=this.element;return e.setAttribute("style",""),e.style.color=i,e.style.padding=o,e.style.fontSize=s,e.style.overflow=l,e.style.borderWidth=c,e.style.borderColor=u,e.style.whiteSpace=d,e.style.position=h,e.style.borderStyle=g,e.style.backgroundColor=p,e.style["user-select"]=m,e.style["-ms-user-select"]=m,e.style["-moz-user-select"]=m,e.style["-webkit-user-select"]=m,e.style["-webkit-touch-callout"]=m,e.style.top=this.x+"px",e.style.left=this.y+"px",e.style.visibility=v,e.style["pointer-events"]=b,e},t.setData=function(e,t){this.data[e]=t},t.getData=function(e){return this.data[e]},t.setStyle=function(e){var t,r=this.element.style;for(t in this.setDefaultStyle(),e)r[t]=e[t]},t.show=function(e){var t=e.replace(/&lt;|&gt;|&quot;|&#034;|&#039;/g,(function(e){switch(e){case"&lt;":return"<";case"&gt;":return">";case"&quot;":case"&#034;":return'"';case"&#039;":return"'"}}));this.text!==e&&(this.text=e,this.element.innerHTML=t),this.setData("active",!0),"visible"!==this.element.style.visibility&&(this.element.style.visibility="visible"),this.element.style["will-change"]=y,this.element.style["max-width"]=this.universeBounds.right-this.universeBounds.left-12+"px"},t.update=function(e,t,r){void 0===e&&(e=this.x),void 0===t&&(t=this.y);var n=this.universeBounds,a=(this.restrictWithinCanvas.bottom?n.bottom:this.universe.clientHeight)-12,i=(this.restrictWithinCanvas.right?n.right:this.universe.clientWidth)-12,o=(this.restrictWithinCanvas.left?n.left:0)+12,s=(this.restrictWithinCanvas.top?n.top:0)+12,l=this.element,c=l.offsetWidth,u=l.offsetHeight,h=l.style,g=t-(u+10)>s,p=t+u<a;e+c<i?(h.left=e+"px",h.whiteSpace=d):c<i?e-c>=o?h.left=e-c-12+"px":(h.left=i-c+"px",h.whiteSpace=f):(h.left=n.left+"px",h.whiteSpace=f),h.top="top"===r&&g?t-(u+10)+"px":"bottom"===r&&p||t+u<a?t+"px":u<a&&t-u<=a?t-u+"px":a-u+"px"},t.hide=function(){this.y=0,this.x=0,this.x=n.BLANKSTRING,this.setData("active",!1),this.setData("target",!1),this.element.style.visibility=v,this.element.style["will-change"]=x,this.element.innerHTML=n.BLANKSTRING,this.text=n.UNDEF},t.dispose=function(){this.hide(),this.universe.removeChild(this.element),this.universe=n.UNDEF,this.disposed=!0},e}();t["default"]=C},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a={treemap:!0,scatter:!0,bubble:!0,errorscatter:!0,errorline:!0,errorbar2d:!0,candlestick:!0,stackedcolumn3d:!0,stackedbar3d:!0,mscolumnline3d:!0,mscombi3d:!0,mscolumn3dlinedy:!0,stackedcolumn3dline:!0,stackedcolumn3dlinedy:!0},i=function(e,t){return e+'<div style="margin: 0;">'+t+"</div>"},o=function(e,t){return t.hovered?e+1:e},s=function(e){return e.originalPlotColor||e.plotColor||e.color||"#000000"},l=function(e,t){return t.getJSONIndex()-e.getJSONIndex()};function c(e){var t=e.sender.getFromEnv("chart"),r=t.config.tooltipgrayoutcolor,a=t.config.plotcolorintooltip,c=t.getFromEnv("toolTipController"),u=t.getDatasets().sort(l),d=t.getFromEnv("consolidated-tooltip"),f=(0,n.getMouseCoordinate)(e.sender.getFromEnv("chart-container"),e.originalEvent,t),h=f.chartX,g=f.chartY,p=!1,m=u.map((function(e){return e.getPlotInCategoryAt(h,g)})).filter(Boolean),v=m.reduce(o,0),b=m.map((function(e){var t=e.pointObj.config,i=t.finalTooltext||t.toolText,o=s(t);return v>0?!p&&e.hovered?(i='<div style="display: inline-block;">'+i+"</div>",p=!0):(o=r,i='<div style="color: '+(0,n.hashify)(r)+'; display: inline-block;">'+i+"</div>"):i='<div style="display: inline-block;">'+i+"</div>",a?'<div style="color: '+(0,n.hashify)(o)+'; display: inline-block;">&#9632&nbsp;</div>'+i:i})),y=[].concat(b).reverse().reduce(i,"");this.isWithinCanvas(h,g)&&y?d?c.draw(e.originalEvent,y,d):t.addToEnv("consolidated-tooltip",c.draw(e.originalEvent,y)):d&&c.hide(d)}function u(e){var t=e.sender.getFromEnv("chart"),r=t.getFromEnv("consolidated-tooltip");r&&t.getFromEnv("toolTipController").hide(r)}function d(e){var t=this.apiInstance,r=t.getDatasets().sort(l),a=t.config.plotcolorintooltip,o=t.getFromEnv("toolTipController"),c=t.getFromEnv("consolidated-tooltip"),u=r.map((function(t){var r=t.components.data;return r[e]&&r[e]})).filter(Boolean),d=u[0]&&{x:u[0].config._Px-u[0]._width,y:u[0].config._Py,width:u[0].config._width},f=u.map((function(e){var t=e.config,r=t.finalTooltext||t.toolText;return a?'<div style="color: '+(0,n.hashify)(s(t))+'; display: inline-block;">&#9632&nbsp;</div><div style="display: inline-block;">'+r+"</div>":'<div style="display: inline-block;">'+r+"</div>"})).reduce(i,"");f&&d?c?o.drawAt(d.x,d.y,f,c):t.addToEnv("consolidated-tooltip",o.drawAt(d.x,d.y,f)):c&&o.hide(c)}var f={extension:function(e){e.addEventListener("predraw",(function(e){var t,r;if(e.sender.getType&&"chartAPI"===e.sender.getType()&&(r=e.sender,!a[r.getName().toLowerCase()])){var n=(t=e.sender).getChildren("canvas");t.getFromEnv("chartInstance").drawConsolidatedToolTip=d,n&&n.forEach((function(e){if(!t.config.drawTrendRegion||!t.config.showtooltip)return e.removeEventListener("fc-mouseover",c),e.removeEventListener("fc-mousemove",c),e.removeEventListener("fc-mouseout",u),void e.setState("consolidatedTooltipEventListenerAttached",!1);!e.getState("consolidatedTooltipEventListenerAttached")&&t.config.showtooltip&&(e.addEventListener("fc-mouseover",c),e.addEventListener("fc-mousemove",c),e.addEventListener("fc-mouseout",u),e.setState("consolidatedTooltipEventListenerAttached",!0))}))}}))},name:"ConsolidatedToolTip",type:"extension",requiresFusionCharts:!0};t["default"]=f},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(323)),i=r(224),o=function(e){e.sender.apiInstance.getChildren("alertManager")&&e.sender.apiInstance.getChildren("alertManager")[0].processRTData(e.data)},s=function(e){if("dataset"===e.sender.getType()){var t,r,n=e.sender,a=n.config,o=a.JSONData,s=n.getFromEnv("chart").getChildren("alertManager");if(!s||!o)return;t=(0,i.pluckNumber)(o&&o.checkforalerts,1),(r=(s=s[0]).config||(s.config={})).datasetMap=r.datasetMap||{},r.datasetMap[a.index]=t}},l=function(e){"chartAPI"===e.sender.getType()&&e.sender.registerFactory("alertManager",(function(e){e.getChildren("alertManager")?e.getChildren("alertManager")[0].configure():(0,i.componentFactory)(e.getFromEnv("chart"),a["default"],"alertManager",1,[{}])}))};var c={extension:function(e){e.addEventListener("instantiated",l),e.addEventListener("updateDataReceived",o),e.addEventListener("postConfigure",s)},name:"alertManagerLinker",type:"extension",requiresFusionCharts:!0};t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=r(240),s=function(e){function t(){var t;return(t=e.call(this)||this).pIndex=1,t.linkedItems={chart:{}},t}(0,a["default"])(t,e);var r=t.prototype;return r.getType=function(){return"extension"},r.getName=function(){return"AlertManager"},r.configure=function(){var e,t,r,n=this.getFromEnv("dataSource"),a=n&&n.alerts&&n.alerts.alert,i=this.getFromEnv("number-formatter"),o=this.config||(this.config={});if(a&&a.length)for(o.alertArr=a,e=a.length,t=0;t<e;t+=1)(r=a[t]).minvalue=i.getCleanValue(r.minvalue),r.maxvalue=i.getCleanValue(r.maxvalue);else o.alertArr=[]},r.processRTData=function(e){var t,r,n,a,i,o,s=this.config,l=this.getFromEnv("number-formatter");if(e&&e.dataset&&e.dataset.length)for(n=e.dataset.length,t=0;t<n;t+=1)if((a=e.dataset[t]).data&&a.data.length){if(s.datasetMap&&0===s.datasetMap[t])continue;for(i=a.data.length,r=0;r<i;r+=1)null!==((o=a.data[r])&&l.getCleanValue(o.value))&&this._doAlert(l.getCleanValue(o.value))}},r._doAlert=function(e){var t,r,n,a=this.getLinkedParent(),o=this.config.alertArr,s=o.length;for(r=0;r<s;r+=1)if(n=(t=o[r]).action&&t.action.toLowerCase(),t.minvalue<=e&&t.maxvalue>=e){if("1"!==t.occuronce||!t.hasOccurred){switch(t.hasOccurred=!0,t.state="1",n){case"calljs":setTimeout((0,i.pseudoEval)(t.param));break;case"showannotation":a.showAnnotation&&a.showAnnotation(t.param)}a.fireChartInstanceEvent("AlertComplete",{alertValue:e,alertMaxValue:t.maxvalue,alertMinValue:t.minvalue})}}else"showannotation"===n&&"1"===t.state&&a.hideAnnotation&&a.hideAnnotation(t.param),t.state="2"},t}(o.ComponentInterface);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(325)),i=r(327);var o={extension:function(e){e.addEventListener("preconfigure",(function(e){var t=e.sender,r=t.getFromEnv("chart");i.allowedCharts[r&&r.getName()]&&("dataset"===t.getType()&&"cartesianStackGroup"!==t.getLinkedParent().getName()?(t.setState("applySkippingOnConf",!0),a["default"].dataSkipping({component:t,datasetType:t.getName(),compType:"dataset"})):"cartesianStackGroup"===t.getName()&&(t.setState("applySkippingOnConf",!0),a["default"].dataSkipping({component:t,datasetType:t.getName(),compType:"group"})))})),e.addEventListener("preattributeprepared",(function(e){var t=e.sender.getFromEnv&&e.sender.getFromEnv("chart");if(i.allowedCharts[t&&t.getName()])if("dataset"===e.sender.getType()){var r=e.sender,n=r.getFromEnv("canvasConfig"),o=r.getFromEnv("chart").isBar?n.canvasHeight:n.canvasWidth;"cartesianStackGroup"!==r.getLinkedParent().getName()&&(r.getState("applySkippingOnConf")?r.setState("applySkippingOnConf",!1):a["default"].dataSkipping({component:r,compType:"dataset",datasetType:r.getName(),width:o}))}else if("cartesianStackGroup"===e.sender.getName()){var s=e.sender,l=s.getFromEnv("canvasConfig"),c=s.getFromEnv("chart").isBar?l.canvasHeight:l.canvasWidth,u=Object.keys(s.getChildren())[0];s.getState("applySkippingOnConf")?s.setState("applySkippingOnConf",!1):a["default"].dataSkipping({component:s,compType:"group",datasetType:s.getChildren(u)[0].getName(),width:c})}})),e.addEventListener("dataplotdragend",(function(e,t){if(e.sender.getType&&"dataset"===e.sender.getType()){var r=e.sender,n=r.getSkippingInfo&&r.getSkippingInfo();n&&n.skippingApplied&&a["default"].updateDragMap({component:r,compType:"dataset",evenType:"dataplotdragend",eventArgs:t})}}))},name:"DataSkipping",type:"extension",requiresFusionCharts:!0};t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(326)),i=r(327),o=r(224),s=[],l=0,c={},u=[];function d(e){return void 0===e&&(e=[]),e.filter((function(e){return!s[e]}))}function f(e,t){for(var r=0,n=[],a=1;a<c.noOfPlotBins;++a)e(r,(r+=c.plotsPerBin)-1,t,u,n);return e(r,t.length-1,t,u,n),u=[],n}function h(e){var t,r,n,o,h,g,p,m=i.filterType[e.datasetType],v=e.component,b=v.getSkippingInfo&&v.getSkippingInfo(),y=b&&b.draw.slice(0),x=b&&(b.labelDraw||[]).slice(0),w={},C=[],k=v.getFromEnv("xAxis").getTicksLen();if((!y||!y.length)&&(void 0===(p=l)&&(p=0),y=Array.from(new Array(p),(function(e,t){return t}))),(!x||!x.length)&&(x=y),u=b&&b.dragHashMap,"cartesianStackGroup"===v.getName()){for(o=c.jsonData.length,t=0;t<k;++t){for(n=0,r=0;r<o;++r)g=c.jsonData[r].data,n+=Number(g[t]?g[t].value:0);C.push({value:n})}w.draw=f((0,a["default"])(m),C)}else w.draw=f((0,a["default"])(m),c.jsonData.data);return w.draw.forEach((function(e){s[e]=!0})),w.drawOnlyMap=s,w.hide=d(y),h=function(e){var t,r=c.labelBinSize/c.plotBinSize,n=[],a=[],i=e.length;for(t=0;t<i;t++)t%r||(n.push(e[t]),a[e[t]]=!0);return{drawableLabelIndices:n,labelHashMap:a}}(w.draw),w.labelDraw=h.drawableLabelIndices,s=w.labelDrawOnlyMap=h.labelHashMap,w.hideLabel=d(x),w.plotsPerBin=c.plotsPerBin,w.skippingApplied=!0,w.dragHashMap=[],w.prevDrawInfo=y.slice(0),w}var g={dataSkipping:function(e){void 0===e&&(e={});var t=e.component;!function(e){void 0===e&&(e={});var t,r,n,a,i,u=e.component,d=e.compType,f=u.getFromEnv("chartConfig"),h=u.getFromEnv("dataSource").chart||{},g=(0,o.pluckNumber)(h.plotbinsize,f.plotbinsize);return c.plotBinSize=g,c.labelBinSize=(0,o.pluckNumber)(h.labelbinsize,f.labelbinsize),c.jsonData=u.config.JSONData,"group"===d?(t=c.jsonData[0].data,l=u.config.stackValues&&u.config.stackValues.length||0):"dataset"===d&&(t=c.jsonData.data,l=u.components.data&&u.components.data.length||0),r=t&&t.length,s=[],c.width=i=u.getFromEnv("chart").isBar?e.height||u.getFromEnv("chartHeight"):e.width||u.getFromEnv("chartWidth"),n=r/i,a=Math.floor(n*g),n>=1.5&&a>1&&(c.plotsPerBin=a,c.noOfPlotBins=Math.ceil(r/c.plotsPerBin),!0)}(e)?t.setSkippingInfo&&t.setSkippingInfo():t.setSkippingInfo&&t.setSkippingInfo(h(e))},updateDragMap:function(e){void 0===e&&(e={});var t=e.component,r=e.eventArgs,n=t.getSkippingInfo&&t.getSkippingInfo()||{};r&&(n.dragHashMap[r.dataIndex]=r.endValue)}};t["default"]=g},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=function(e,t,r,n,a){void 0===n&&(n=[]);for(var i,o=r[t].value,s=t,l=t-1;l>=e;--l)(i=void 0!==n[l]?n[l]:r[l].value)>o&&(o=i,s=l);return a.push(s),a},a=function(e,t,r,n,a){void 0===n&&(n=[]);for(var i,o=r[t].value,s=t,l=r[t].value,c=t,u=t-1;u>=e;--u)(i=void 0!==n[u]?n[u]:r[u].value)>o?(o=i,s=u):i<l&&(l=i,c=u);var d=c<s?[c,s]:[s,c];return c=d[0],s=d[1],a.push(c),c!==s&&a.push(s),a};t["default"]=function(e){var t={maxOnly:n,minMax:a};return t[e]||t.maxOnly}},function(e,t,r){"use strict";t.__esModule=!0,t.filterType=t.allowedCharts=void 0;t.filterType={Column:"maxOnly",line:"minMax",area:"minMax"},t.allowedCharts={Column2D:!0,Line:!0,Area2D:!0,Bar2D:!0,MSColumn2D:!0,MSLine:!0,MSBar2D:!0,MSArea:!0,StackedColumn2D:!0,StackedBar2D:!0,StackedArea2D:!0,MSStackedColumn2D:!0,MSCombi2D:!0,StackedColumn2DLine:!0,MSCombidy2D:!0,LogMSColumn2d:!0,LogMSLine:!0,DragColumn:!0,DragLine:!0,DragArea:!0}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(329)),i=n(r(352)),o=function(e,t){return"groups"!==t&&"items"!==t},s=function(e){var t=e.sender;(function(e){return"chartAPI"===e.getType()})(t)&&t.registerFactory("annotation",(function(e){var t=e.getFromEnv("dataSource").annotations,r=e.getChildren().annotation,n=r&&r[0];delete e.getFromEnv("chartInstance").annotations,t&&(n||(n=new a["default"]((0,i["default"])(o,t)),e.attachChild(n,"annotation"),n.config.drawn=!1),n._JSONData=t,n.configure(t),e.getFromEnv("chartInstance").annotations=n)}))};var l={extension:function(e){e.addEventListener("instantiated",s)},name:"Annotation",type:"extension",requiresFusionCharts:!0};t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(330),o=r(224),s=r(232),l=n(r(331)),c=n(r(332)),u=n(r(333)),d=n(r(334)),f=r(240),h=["pie2d","doughnut2d"],g=["pie3d","doughnut3d"],p=function(e,t){return e.getJSONIndex()-t.getJSONIndex()},m=function(e,t,r){void 0===t&&(t={}),void 0===r&&(r={});var n,a={};for(var i in a.annotationType="shape",a.id=e.id,a.type=e.type&&e.type.toLowerCase(),a.toolText=(0,o.pluck)(e.tooltext,e.toolText),a.animationLabel=(0,o.pluck)(e.animationlabel,e.animationLabel),a.dashed=e.dashed,a.dashLen=(0,o.pluck)(e.dashlen,e.dashLen),a.dashGap=(0,o.pluck)(e.dashgap,e.dashGap),a.thickness=e.thickness,a.showBorder=(0,o.pluck)(e.showborder,e.showBorder),a.borderColor=(0,o.pluck)(e.bordercolor,e.borderColor),a.borderAlpha=(0,o.pluck)(e.borderalpha,e.borderAlpha),a.borderThickness=(0,o.pluck)(e.borderthickness,e.borderThickness),a.alpha=e.alpha,a.color=e.color,a.fillColor=(0,o.pluck)(e.fillcolor,e.fillColor),a.fontColor=(0,o.pluck)(e.fontcolor,e.fontColor),a.fillAlpha=(0,o.pluck)(e.fillalpha,e.fillAlpha),a.fillAngle=(0,o.pluck)(e.fillangle,e.fillAngle),a.fillRatio=(0,o.pluck)(e.fillratio,e.fillRatio),a.fillPattern=(0,o.pluck)(e.fillpattern,e.fillPattern),a.sides=e.sides,a.radius=e.radius,a.yRadius=(0,o.pluck)(e.yradius,e.yRadius),a.innerRadius=(0,o.pluck)(e.innerradius,e.innerRadius),a.endAngle=(0,o.pluck)(e.endangle,e.endAngle),a.startAngle=(0,o.pluck)(e.startangle,e.startAngle),a.isVisible=!0==(n=e.visible,!(0===parseInt(n,10))),a.x=e.x,a.y=e.y,a.xPos=(0,o.pluck)(e.xpos,e.xPos),a.yPos=(0,o.pluck)(e.ypos,e.yPos),a.toY=(0,o.pluck)(e.toy,e.toY),a.toX=(0,o.pluck)(e.tox,e.toX),a.autoScale=(0,o.pluck)(e.autoscale,e.autoScale),a.path=e.path,a.css=e.css,a.wrap=e.wrap,a.text=e.text!==o.UNDEF&&null!==e.text&&e.text.toString()||o.UNDEF,a.font=(0,o.pluck)(e.font,t.font,r.basefont),a.bold=(0,o.pluck)(e.bold,e.isbold,e.bold,e.isBold),a.label=e.label,a.align=e.align,a.italic=e.italic,a.vAlign=(0,o.pluck)(e.valign,e.vAlign),a.bgColor=(0,o.pluck)(e.bgcolor,e.bgColor),a.fontSize=(0,o.pluck)(e.fontsize,e.fontSize,t.fontSize,r.basefontsize),a.wrapWidth=(0,o.pluck)(e.wrapwidth,e.wrapWidth),a.leftMargin=(0,o.pluck)(e.leftmargin,e.leftMargin),a.rotateText=(0,o.pluck)(e.rotatetext,e.rotateText),a.wrapHeight=(0,o.pluck)(e.wrapheight,e.wrapHeight),a.showShadow=(0,o.pluck)(e.showshadow,e.showShadow),a.link=e.link,a.url=e.url,a.link=e.link,a.width=e.width,a.height=e.height,a.xScale=(0,o.pluck)(e.xscale,e.xScale),a.yScale=(0,o.pluck)(e.yscale,e.yScale),a.onload=e.onload,a.onerror=e.onerror,a.outlineText=(0,o.pluckNumber)(e.outlinetext,e.outlineText,0),"object"==typeof e.component&&(a.component=e.component),a){if(a.hasOwnProperty(i))void 0===a[i]&&delete a[i]}return a},v=function(e,t){return void 0===e&&(e={groups:[]}),void 0===t&&(t={}),(e.groups||[]).map((function(r){var n,a;return n=e,(a=r).css=a.css||n.css,a.autoscale=(0,o.pluck)(a.autoscale,n.autoscale),a.animationLabel=(0,o.pluck)(a.animationLabel,n.animationLabel),a.constrainedscale=(0,o.pluck)(a.constrainedscale,n.constrainedscale),a.scaletext=(0,o.pluck)(a.scaletext,n.scaletext),a.scaleimages=(0,o.pluck)(a.scaleimages,n.scaleimages),a.xshift=(0,o.pluck)(a.xshift,n.xshift),a.yshift=(0,o.pluck)(a.yshift,n.yshift),a.grpxshift=(0,o.pluck)(a.grpxshift,n.grpxshift),a.grpyshift=(0,o.pluck)(a.grpyshift,n.grpyshift),a.origw=(0,o.pluck)(a.origw,n.origw),a.origh=(0,o.pluck)(a.origh,n.origh),a.showbelow=(0,o.pluck)(a.showbelow,n.showbelow,1),a.onAnnotationClick=n.onAnnotationClick,a.onAnnotationRollover=n.onAnnotationRollover,a.onAnnotationRollout=n.onAnnotationRollout,function(e,t){var r={},n=e.items;for(var a in n=e.items=(0,i.arrangeItems)(n),r.annotationType="group",r.id=e.id,r.showBelow="undefined"==typeof e.showbelow||null===e.showbelow?1:Number(e.showbelow),r.x=e.x,r.y=e.y,r.animationLabel=(0,o.pluck)(e.animationlabel,e.animationLabel),r.xPos=(0,o.pluck)(e.xpos,e.xPos),r.yPos=(0,o.pluck)(e.ypos,e.yPos),r.grpXShift=(0,o.pluck)(e.grpxshift,e.grpXShift),r.grpYShift=(0,o.pluck)(e.grpyshift,e.grpYShift),r.xShift=(0,o.pluck)(e.xshift,e.xShift),r.yShift=(0,o.pluck)(e.yshift,e.yShift),r.color=e.color,r.alpha=e.alpha,r.isVisible=1===Number(e.visible||1),r.font=(0,o.pluck)(e.font,t.basefont),r.link=e.link,r.fontSize=(0,o.pluck)(e.fontsize,e.fontSize,t.basefontsize),r.textAlign=(0,o.pluck)(e.textalign,e.textAlign),r.textVAlign=(0,o.pluck)(e.textvalign,e.textVAlign),r.rotateText=(0,o.pluck)(e.rotatetext,e.rotateText),r.wrapText=(0,o.pluck)(e.wraptext,e.wrapText),r.toolText=(0,o.pluck)(e.tooltext,e.toolText),r.link=e.link,r.showShadow=(0,o.pluck)(e.showshadow,e.showShadow),r.items=e.items,r.css=e.css,r.autoScale=(0,o.pluck)(e.autoscale,e.autoScale),r.scaleText=(0,o.pluck)(e.scaletext,e.scaleText),r.xScale=(0,o.pluck)(e.xscale,e.xScale),r.yScale=(0,o.pluck)(e.yscale,e.yScale),r.scaleImages=(0,o.pluck)(e.scaleimages,e.scaleImages),r.constrainedScale=(0,o.pluck)(e.constrainedscale),r.origH=(0,o.pluck)(e.origh,e.origH,t.origh),r.origW=(0,o.pluck)(e.origw,e.origW,t.origw),r.onAnnotationClick=e.onAnnotationClick,r.onAnnotationRollover=e.onAnnotationRollover,r.onAnnotationRollout=e.onAnnotationRollout,"object"==typeof e.component&&(r.component=e.component),r){if(r.hasOwnProperty(a))void 0===r[a]&&delete r[a]}return Array.isArray(n)&&(r.itemConfigs=n.map((function(e){return m(e,r,t)}))),r}(r,t)}))},b=function(e){function t(t){var r;return r=e.call(this,t)||this,(0,s.addDep)({name:"annotationAnimation",type:"animationRule",extension:l["default"]}),(0,c["default"])((0,s.getDep)("redraphael","plugin")),(0,u["default"])((0,s.getDep)("redraphael","plugin")),r.groups=[],r.config.dependencies={},r._rawJSON={groups:[]},r}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"annotation"},r.getType=function(){return"extension"},r.configureAttributes=function(e){void 0===e&&(e={groups:[]});var t=this,r=t.config;t._rawJSON=(0,o.extend2)({},t._rawJSON,e),e.groups?r.parsedConfigs=v(e,t.getFromEnv("chart").config):r.parsedConfigs=[],r.parsedConfigs.forEach((function(e){t.attachChild(d["default"],"group",e.id).configure(e)})),t.groups=t.getChildren("group")||[]},r.addItem=function(e,t,r){void 0===t&&(t={});var n,a,i,o=this._rawJSON,s=o.groups.length;for(n=0;n<s;n++)if(o.groups[n].id===e){a=o.groups[n];break}return a?a.items=a.items||[]:(a={id:e,items:[]},o.groups.push(a)),a.items.push(t),this.setData(o,!0),(i=this.retrieveGroup(e).items)[i.length-1]},r.addGroup=function(e){void 0===e&&(e={});var t=this._rawJSON;return t.groups.push(e),this.setData(t,!0),this.groups[this.groups.length-1]},r.addCustomGroup=function(e){e&&(this.config.customGroup=e)},r.update=function(e,t){var r,n,a,i,o={};if(e){for(n in t)o[n.toLowerCase()]=t[n]&&t[n].toString();if(!(r=this.retrieveItem(e)||this.retrieveGroup(e))||!r.getElement())return;return"undefined"==typeof o.visible&&(o.visible=r.config.isVisible),a=r.rawConfig,a=Object.assign(a,o),(i=m(a)).isVisible=o.visible,r.setData(i),r}},r.destroy=function(e){var t,r,n,a,i,o=this._rawJSON,s=!1;if(e){for(t=0,n=o.groups.length;t<n;t++)for(r=0,a=((i=o.groups[t]).items||[]).length;r<a;r++)if(i.items[r].id===e){i.items.splice(r,1),s=!0;break}if(!s)for(t=0,n=o.groups.length;t<n;t++)(i=o.groups[t]).id===e&&o.groups.splice(t,1)}else o=this._rawJSON={groups:[]};this.setData(o)},r.clear=function(){this.destroy()},r.retrieveItem=function(e){var t,r,n,a=this.groups.length;for(n=0;n<a;n++)if(t=this.groups[n].retrieveItem(e)){r=t;break}return r},r.retrieveGroup=function(e){var t,r;for(t=0,r=this.groups.length;t<r;t++)if(this.groups[t].getId()===e)return this.groups[t]},r.show=function(e){var t;e?(t=this.retrieveItem(e)||this.retrieveGroup(e))&&t.show():this.groups.forEach((function(e){e.show()}))},r.hide=function(e){var t;e?(t=this.retrieveItem(e)||this.retrieveGroup(e))&&t.hide():this.groups.forEach((function(e){e.hide()}))},r.draw=function(){var e,t,r,n,a,o,s,l,c,u,d,f,m,v;this.addToEnv("snapPoints",(e=this.getFromEnv("chart"),a=e.config,o=e.getChildren(),s=o.caption[0],l=o.subCaption[0],c=o.legend&&o.legend[0]||{},u=o.gLegend&&o.gLegend[0]||{},d=s.config,f=l.config,m=d.width||0,v=f.width||0,"end"===d.align?(t=d.x-m,n=d.x-v):"start"===d.align?t=n=d.x:(t=d.x-m/2,n=d.x-v/2),r=a.gLegendEnabled?u.conf:c.config,{canvasendx:a.canvasRight,canvasendy:a.canvasBottom,canvasheight:a.canvasHeight,canvasstartx:a.canvasLeft,canvasstarty:a.canvasTop,canvaswidth:a.canvasWidth,canvascenterx:a.canvasCenterX||a.canvasLeft+(a.canvasRight-a.canvasLeft)/2,canvascentery:a.canvasCenterY||a.canvasTop+(a.canvasBottom-a.canvasTop)/2,chartcenterx:a.width/2,chartcentery:a.height/2,chartstartx:0,chartstarty:0,chartendx:a.width,chartendy:a.height,chartheight:a.height,chartwidth:a.width,chartleftmargin:a.marginLeft,chartrightmargin:a.marginRight,chartbottommargin:a.marginBottom,charttopmargin:a.marginTop,captionendx:t+d.width,captionendy:d.y+d.height,captionheight:d.height,captionstartx:t,captionstarty:d.y,captionwidth:m,subcaptionendx:n+f.width,subcaptionendy:f.y+f.height,subcaptionheight:f.height,subcaptionstartx:n,subcaptionstarty:f.y,subcaptionwidth:v,legendendx:r&&r.xPos+r.width,legendendy:r&&r.yPos+r.height,legendheight:r&&r.height,legendstartx:r&&r.xPos,legendstarty:r&&r.yPos,legendwidth:r&&r.width,dataset:function(t){var r,n,a,o=t.split(i.DEFAULT_MACRO_SEPARATOR).slice(1),s=[];return e.iterateComponents((function(e){"dataset"===e.getType()&&s.push(e)})),s.sort(p),n=s[Number(o[0])],r=n.components.data[Number(o[2])],h.indexOf(n.getName().toLowerCase())>-1?(0,i.computeSliceBounds)(o[3],r.config):g.indexOf(n.getName().toLowerCase())>-1?(0,i.compute3DSliceBounds)(o[3],r.config):(a=(0,i.computePlotBounds)(r,n.getName()),(0,i.xyCalculator)(o[3],a))},xaxis:(0,i.axisMacroParser)(e,"xAxis"),yaxis:(0,i.axisMacroParser)(e,"yAxis"),gaugestartx:a.gaugeStartX,gaugestarty:a.gaugeStartY,gaugeendx:a.gaugeEndX,gaugeendy:a.gaugeEndY,gaugecenterx:a.gaugeCenterX,gaugecentery:a.gaugeCenterY,gaugestartangle:a.gaugeStartAngle,gaugeendangle:a.gaugeEndAngle,gaugeradius:a.gaugeRadius,plotwidth:a.plotWidth,plotsemiwidth:a.plotSemiWidth})),this.addGraphicalElement({el:"group",attr:{name:"upperannotations"},component:this,container:{label:"group",id:"abovePlotGroup",isParent:!0},id:"upperAnnotationGroup",label:"group"}),this.addGraphicalElement({el:"group",attr:{name:"lowerannotations"},component:this,container:{label:"group",id:"belowPlotGroup",isParent:!0},id:"lowerAnnotationGroup",label:"group"})},t}(f.SmartRenderer);t["default"]=b},function(e,t,r){"use strict";t.__esModule=!0,t.getEventData=t.getScaledVal=t.parseEquation=t.solveEquation=t.isMacro=t.trim=t.pluckBoolean=t.DEFAULT_MACRO_SEPARATOR=t.DEFAULT_MACRO_PREFIX=t.UNDERSCORE=t.xyCalculator=t.axisMacroParser=t.arrangeItems=t.cleanMacro=t.compute3DSliceBounds=t.computeSliceBounds=t.computePlotBounds=t.getQuadrant=t.polarToCartesian=t.deg2Rad=void 0;var n=r(224);t.UNDEF=n.UNDEF;var a=2*Math.PI,i=[-a,-3*a/4,-a/2,-a/4,0],o=[a,3*a/4,a/2,a/4,0],s=function(e){return e*e},l=function(e){return e*(Math.PI/180)},c=function(e,t,r,n){void 0===r&&(r=!0),void 0===n&&(n={});var a=t;return r||(a=l(t)),{x:e*Math.cos(a)+(n.x||0),y:e*Math.sin(a)+(n.y||0)}},u=function(e,t,r){return 0===e||0===t?0:e*t/Math.sqrt(s(t)*s(Math.cos(r))+s(e)*s(Math.sin(r)))},d=function(e){var t,r,o,s,l,u,d,f,h,g=e.ringpath,p=[],m=[],v=Infinity,b=Infinity,y=-Infinity,x=-Infinity;for(t=(0,n.pluckNumber)(g[2]),r=(0,n.pluckNumber)(g[3]),o=(0,n.pluckNumber)(g[4])%a,s=(0,n.pluckNumber)(g[5])%a,l=(0,n.pluckNumber)(g[0]),u=(0,n.pluckNumber)(g[1]),f=c(t,o,!0,{x:l,y:u}),h=c(t,s,!0,{x:l,y:u}),m.push(f),m.push(h),d=0;d<i.length;d++)i[d]>=o&&i[d]<=s&&p.push(d);for(d=0;d<p.length;d++)f=c(t,i[p[d]],!0,{x:l,y:u}),h=c(r,i[p[d]],!0,{x:l,y:u}),m.push(f),m.push(h);for(f=c(r,o,!0,{x:l,y:u}),h=c(r,s,!0,{x:l,y:u}),m.push(f),m.push(h),d=0;d<m.length;d++)y=Math.max(y,m[d].x),v=Math.min(v,m[d].x),x=Math.max(x,m[d].y),b=Math.min(b,m[d].y);return{x:v,y:b,width:Math.abs(y-v),height:Math.abs(b-x)}},f=function(e,t,r){var n,i,o;return o=Math.tan(r),n=e*t/Math.sqrt(t*t+e*e*o*o),i=e*t/Math.sqrt(e*e+t*t/(o*o)),r>a/4&&r<3*a/4?n*=-1:n=Math.abs(n),r>a/2&&r<a?i*=-1:i=Math.abs(i),Math.abs(n)<=1e-5&&(n=0),Math.abs(i)<=1e-5&&(i=0),{x:n,y:i}},h=function(e,t){var r,a,i,o,s,l=e.config||e;switch(t){case"column3D":case"bar2D":case"bar3D":case"paretoColumn":case"waterFall2D":case"errorBar2D":case"candlestick":case"heatMap":case"dragColumn":case"sparkColumn":case"marimekko":case"task":case"column":r={x:(a=l.props.element.attr).x+(0,n.pluckNumber)(a.xDepth,0),y:a.y-(0,n.pluckNumber)(a.yDepth,0),width:a.width,height:a.height};break;case"line":case"zoomLine":case"zoomScatter":case"scatter":case"spline":case"splinearea":case"multiaxisline":case"stepLine":case"errorScatter":case"errorLine":case"radar":case"selectScatter":case"dragLine":case"dragArea":case"kagi":case"sparkLine":case"area":i=e._xPos,o=e._yPos,r={x:i-(s=Number(l.anchorProps.radius)||0),y:o-s,width:2*s,height:2*s};break;case"bubble":r={x:(a=l.props.element.attr).cx-a.r,y:a.cy-a.r,width:2*a.r,height:2*a.r};break;case"dragNode":a=l.props.element.attr,"rect"===l.shapeType?r={x:a.x,y:a.y,width:a.width,height:a.height}:(i=l._xPos,o=l._yPos,r={x:i-(s=+l.radius||0),y:o-s,width:2*s,height:2*s});break;case"boxandwhisker2D":r={x:(a=l.props.upperBoxElem.attr).x,y:a.y,width:a.width,height:a.height};break;case"category":case"polarCategory":case"log":case"numeric":r={x:(a=l.props.label.attr).x-l.width/2,y:a.y-l.height/2,width:l.width,height:l.height},"end"===a["text-anchor"]||"left"===a["text-anchor"]?r.x=a.x-l.width:"start"!==a["text-anchor"]&&"right"!==a["text-anchor"]||(r.x=a.x),"top"===a["vertical-align"]?r.y=a.y:"bottom"===a["vertical-align"]&&(r.y=a.y-l.height);break;case"multiLevelPie":a=l.props.element.attr,r=d(a)}return r},g=function(e,t){var r=0;switch(e){case"startx":r=t.x;break;case"starty":r=t.y;break;case"x":case"middlex":case"centerx":r=t.x+t.width/2;break;case"y":case"middley":case"centery":r=t.y+t.height/2;break;case"endx":r=t.x+t.width;break;case"endy":r=t.y+t.height;break;default:r=0}return r},p=function(e,t){var r;switch(t.axis){case"x":case"toX":r=t.scaleX;break;case"y":case"toY":r=t.scaleY;break;default:r=t.scaleValue||1}return e*r};t.parseEquation=function(e,t,r,a){void 0===r&&(r=!1),void 0===a&&(a="$");var i,o,s,l,c=e.split(/([+])/),u=[],d=c.length;for(o=0;o<d;o++)if("+"!==c[o]){for(s=0,l=(i=c[o].split(/([-])/)).length;s<l;s++)"-"!==i[s]&&(u.push(i[s]),s<l-1&&u.push("-"));o<d-1&&u.push("+")}return u.map((function(e){var i,o,s,l=n.BLANKSTRING,c=n.BLANKSTRING,u=n.BLANKSTRING;if(e.charAt(0)===a){if(u=(c=e.replace(new RegExp("[\\$ ]","g"),"")).split(".")[0],!isNaN(+c))return+c;for(l in t)if(u===l){if(o=new RegExp(l,"g"),"function"==typeof t[l])try{i=u.replace(o,t[l](c))}catch(f){i=u.replace(o,0)}else i=u.replace(o,t[l]||0);break}}else{s=Number(e);var d=e;isNaN(s)?"+"!==e&&"-"!==e&&(d=0):d=r?p(s,r).toString():s.toString(),i=d}return i}))},t.getScaledVal=p,t.solveEquation=function(e){for(var t,r,n=+e[0],a=1,i=e.length;a<i;++a)if(r=e[a],a%2)t=r;else switch(t){case"+":n+=+r;break;case"-":n-=+r}return n},t.isMacro=function(e){return~e.indexOf("$")},t.trim=function(e){return e.replace(/^\s+|\s+$/g,"")},t.pluckBoolean=function(){for(var e,t,r,n=arguments.length,a=new Array(n),i=0;i<n;i++)a[i]=arguments[i];for(t=0,r=a.length;t<r;t++)if(!0===(e=a[t])||!1===e)return e;return!1},t.getEventData=function(e,t,r){var n=r.getFromEnv("getMouseCoordinate")(r.getFromEnv("chart-container"),e,r),a=t.getLinkedParent();return{element:t.getElement(),rawConfig:t.getAttribute(),pageX:n.pageX,pageY:n.pageY,chartX:n.chartX,chartY:n.chartY,annotationId:t.getId(),groupId:a&&a.getId(),annotationOptions:t.rawConfig,groupOptions:a&&a.rawConfig}},t.axisMacroParser=function(e,t){return function(r){var n,a,i,o,s=r.split(".").slice(1),l=isNaN(Number(s[0]))?0:Number(s[0]),c=isNaN(Number(s[0]))?s[1]:s[2],u=isNaN(Number(s[0]))?s[2]:s[3];return o=(n=e.getChildren(t)[l]).components,c=Number(c),o.labelIndexArr&&(c=o.labelIndexArr[c]),a=o.labels[c].config,i=h(a,n.getName()),g(u,i)}},t.xyCalculator=g,t.arrangeItems=function(e){void 0===e&&(e=[]);var t,r,n=[],a=[];for(r=e.length,t=0;t<r;t++)"text"===e[t].type?a.push(e[t]):n.push(e[t]);return n.concat(a)},t.cleanMacro=function(e){var t,r,a=n.BLANKSTRING;for(t=0,r=e.length;t<r;t++)" "!==e[t]&&(a+=e[t]);return a},t.computePlotBounds=h,t.computeSliceBounds=function(e,t){var r,n,a,i,o,s,l=t.props.element.attr,u=l.ringpath;switch(r=u[0],n=u[1],a=u[2],o=u[4],s=u[5],e){case"slicex":case"slicemiddlex":case"slicecenterx":i=c(a,(o+s)/2).x+r;break;case"slicey":case"slicemiddley":case"slicecentery":i=c(a,(o+s)/2).y+n;break;case"slicestartx":i=c(a,s).x+r;break;case"slicestarty":i=c(a,s).y+n;break;case"sliceendx":i=c(a,o).x+r;break;case"sliceendy":i=c(a,o).y+n;break;default:i=g(e,d(l))}return i},t.compute3DSliceBounds=function(e,t){var r,i=t.props.element.attr,s=i.r,l=s*i.radiusYFactor,d=i.cx,h=i.cy,p=i.sAngle,m=i.eAngle;switch(e){case"slicex":case"slicemiddlex":case"slicecenterx":r=f(s,l,(p+m)/2).x+d;break;case"slicey":case"slicemiddley":case"slicecentery":r=f(s,l,(p+m)/2).y+h;break;case"slicestartx":r=f(s,l,p).x+d;break;case"slicestarty":r=f(s,l,p).y+h;break;case"sliceendx":r=f(s,l,m).x+d;break;case"sliceendy":r=f(s,l,m).y+h;break;default:r=g(e,function(e){var t,r,i,s,l,d,f,h,g,p=[],m=[],v=Infinity,b=Infinity,y=-Infinity,x=-Infinity;for(t=(0,n.pluckNumber)(e.r),r=(0,n.pluckNumber)(t*e.radiusYFactor),i=(0,n.pluckNumber)(e.sAngle)%a,s=(0,n.pluckNumber)(e.eAngle)%a,l=(0,n.pluckNumber)(e.cx),d=(0,n.pluckNumber)(e.cy),h=c(u(t,r,i),i,!0,{x:l,y:d}),g=c(u(t,r,s),s,!0,{x:l,y:d}),m.push(h),m.push(g),f=0;f<o.length;f++)o[f]>=i&&o[f]<=s&&p.push(f);for(f=0;f<p.length;f++)h=c(u(t,r,o[p[f]]),o[p[f]],!0,{x:l,y:d}),m.push(h);for(t=(0,n.pluckNumber)(e.innerR,0),r=(0,n.pluckNumber)(t*e.radiusYFactor,0),h=c(u(t,r,i),i,!0,{x:l,y:d}),g=c(u(t,r,s),s,!0,{x:l,y:d}),m.push(h),m.push(g),f=0;f<p.length;f++)h=c(u(t,r,o[p[f]]),o[p[f]],!0,{x:l,y:d}),m.push(h);for(f=0;f<m.length;f++)y=Math.max(y,m[f].x),v=Math.min(v,m[f].x),x=Math.max(x,m[f].y),b=Math.min(b,m[f].y);return{x:v,y:b,width:Math.abs(y-v),height:Math.abs(b-x)}}(i))}return r},t.getQuadrant=function(e,t,r){return e.x>=t?e.y<=r?0:3:e.y<=r?1:2},t.polarToCartesian=c,t.deg2Rad=l,t.DEFAULT_MACRO_SEPARATOR=".",t.DEFAULT_MACRO_PREFIX="$",t.UNDERSCORE="_"},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]},a={"initial.extension.annotation":function(){return{"polypath.appearing":n,"text.appearing":n,"image.appearing":n,"ellipse.appearing":n,"ringpath.appearing":n,"path.appearing":n,"rect.appearing":n,"*":null}}};t["default"]=a},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t=Math,r=t.cos,n=t.sin,a=t.abs,i=t.pow,o=t.PI,s=2*o,l="M",c="A",u=i(2,-24);e.define&&e.define([{name:"ringpath",ringpath:function(){return this.path(void 0,e._lastArgIfGroup(arguments))},ca:function(e,t,i,d,f,h,g,p){var m,v,b,y,x,w,C,k,_,S,E,A,N,T,M=h%s-f%s,D=h-f,F=g,I=p;return isNaN(F)&&(F=i),isNaN(I)&&(I=d),this._.ringangle=.5*(f+h),a(D)<u?(m=r(f),v=n(f),w=[l,e+i*m,t+F*v,"L",e+d*m,t+I*v,"Z"]):a(D)>u&&+(a(D)%s<u||s-a(D)%s<u)?(w=[l,e-i,t,c,i,F,0,0,0,e+i,t,c,i,F,0,0,0,e-i,t],0===d&&0===I||(w=w.concat([l,e-d,t,c,d,I,0,0,1,e+d,t,c,d,I,0,0,1,e-d,t])),w.push("Z")):(m=r(f),v=n(f),b=r(h),y=n(h),(M%=s)<0&&(M+=s),x=M<o?0:1,E=t+F*v,A=t+F*y,_=e+d*b,N=t+I*y,a((C=e+i*m)-(k=e+i*b))<.01&&a(E-A)<.01&&(C=e+i*r(f+.0001745329),E=t+F*n(f+.0001745329)),w=[l,C,E,c,i,F,0,x,1,k,A,"L",_,N],0===d&&0===I||(T=t+I*v,a(_-(S=e+d*m))<.01&&a(N-T)<.01&&(S=e+d*r(f+.0001745329),T=t+I*n(f+.0001745329)),w.push(c,d,I,0,x,0,S,T)),w.push("Z")),{path:w}}}])}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){e.define&&e.define([{name:"arcpath",arcpath:function(){return this.path(void 0,e._lastArgIfGroup(arguments))},ca:function(e,t,r,n){var a=n,i=a-90,o=Math.PI*(i/180);return{path:["M",e,t-r,"A",r,r,0,a>180?1:0,1,e+r*Math.cos(o),t+r*Math.sin(o)]}}}])}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=r(330),s=n(r(335)),l=n(r(336)),c=n(r(347)),u=n(r(348)),d=n(r(349)),f=n(r(350)),h=n(r(351)),g=n(r(243)),p={circle:l["default"],arc:l["default"],line:c["default"],path:c["default"],rectangle:u["default"],polygon:h["default"],image:d["default"],text:f["default"]},m=function(e){function t(t){var r;return(r=e.call(this,t)||this).groups=[],r.items=[],r}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"group"},r.configureAttributes=function(e){var t,r=this,n=r.config;r.rawConfig=e||{},n.id=r.rawConfig.id||r.getId("group"),n.autoScale=(0,i.pluckNumber)(r.rawConfig.autoScale,1),n.scaleText=(0,i.pluckNumber)(r.rawConfig.scaleText,0),n.scaleX=n.origScaleX=(0,i.pluckNumber)(r.rawConfig.xScale)/100,n.scaleY=n.origScaleY=(0,i.pluckNumber)(r.rawConfig.yScale)/100,n.scaleImages=(0,i.pluckNumber)(r.rawConfig.scaleImages,0),n.constrainedScale=(0,i.pluckNumber)(r.rawConfig.constrainedScale,1),n.origH=Number(r.rawConfig.origH),n.origW=Number(r.rawConfig.origW),n.link=r.rawConfig.link,n.color=r.rawConfig.color||"#FF0000",n.alpha=(0,i.pluckNumber)(parseFloat(r.rawConfig.alpha),100),n.showShadow=(0,i.pluckNumber)(r.rawConfig.showShadow,0),n.x=(0,i.pluckNumber)(r.rawConfig.x,r.rawConfig.xPos,0),n.y=(0,i.pluckNumber)(r.rawConfig.y,r.rawConfig.yPos,0),n.font=(0,i.pluck)(r.rawConfig.font,"Verdana, sans"),n.fontSize=(0,i.pluckFontSize)(r.rawConfig.fontSize,10),n.textAlign=(0,i.pluck)(r.rawConfig.textAlign),n.textVAlign=(0,i.pluck)(r.rawConfig.textVAlign),n.rotateText=(0,i.pluck)(r.rawConfig.rotateText),n.wrapText=(0,i.pluck)(r.rawConfig.wrapText),n.grpXShift=(0,i.pluckNumber)(r.rawConfig.grpXShift,0),n.grpYShift=(0,i.pluckNumber)(r.rawConfig.grpYShift,0),n.xShift=(0,i.pluckNumber)(r.rawConfig.xShift,0),n.yShift=(0,i.pluckNumber)(r.rawConfig.yShift,0),n.toolText=r.rawConfig.toolText,n.isVisible=(0,o.pluckBoolean)(r.rawConfig.isVisible,!0),n.elementType="group",n.containerConfiguration={id:r.rawConfig.showBelow?"lowerAnnotationGroup":"upperAnnotationGroup",label:"group",isParent:!0},n.animationLabel="group",r.rawConfig.customComponent instanceof g["default"]?n.customComponent=n.rawConfig.customComponent:delete n.customComponent,r.rawConfig.itemConfigs.forEach((function(e){t=e.type&&e.type.toLowerCase(),p[t]&&r.attachChild(p[t],"item",e.id).configure(e)})),r.items=r.getChildren("item")||[]},r.updateScale=function(){var e,t,r,n,a,i=this.config,o=this.getFromEnv("chart"),s=+o.getFromEnv("chartHeight"),l=+o.getFromEnv("chartWidth"),c=i.autoScale,u=i.constrainedScale;this._setConfig("origW",Number(i.origW)||l),this._setConfig("origH",Number(i.origH)||s),c?(t=l/i.origW*(Number(i.origScaleX)||1),r=s/i.origH*(Number(i.origScaleY)||1)):t=r=1,e=Math.min(t,r),this._setConfig("scaleValue",e),(c>0||isNaN(i.scaleX))&&(n=u?e:t,this._setConfig("scaleX",n)),(c>0||isNaN(i.scaleY))&&(a=u?e:r,this._setConfig("scaleY",a)),i.scaleFont=i.scaleText?Math.min(i.scaleX,i.scaleY):1,i.scaleImageX=i.scaleImages?i.scaleX:1,i.scaleImageY=i.scaleImages?i.scaleY:1,i.scaleInfo={scaleX:i.scaleX,scaleY:i.scaleY,scaleValue:i.scaleValue}},r.updateAttr=function(){var e,t,r,n=this.config,a=n.calculatedAttrs;for(e in a)a[e]&&(n[e]=a[e]);t=this.getScaledVal(n.grpXShift)+n.xShift,r=this.getScaledVal(n.grpYShift)+n.yShift,this._setConfig("attr",{transform:"T"+t+","+r})},r.retrieveItem=function(e){var t,r;for(t=0,r=this.items.length;t<r;t++)if(this.items[t].getId()===e)return this.items[t]},r.getScaledVal=function(e,t){return this?e*(t?this._getConfig("scaleX"):(!1===t?this._getConfig("scaleY"):this._getConfig("scaleValue"))||1):e},r.getScaledFont=function(e){return this?e*this._getConfig("scaleFont"):e},r.getScaledImageVal=function(e,t){return this?e*((t?this._getConfig("scaleImageX"):this._getConfig("scaleImageY"))||1):e},r.getScaleInfo=function(){return this.config.scaleInfo},r.draw=function(){var e,t,r=this._getConfig("attr")||{};this.updateScale(),this.parseAndSetAttribute(),e=this.getScaledVal(this._getConfig("grpXShift"))+this._getConfig("xShift"),t=this.getScaledVal(this._getConfig("grpYShift"))+this._getConfig("yShift"),r.name=this._getConfig("id"),r.transform=r.transform||"T"+e+","+t,r.visibility=this.config.isVisible?i.visibleStr:i.hiddenStr,this.addGraphicalElement({el:"group",attr:r,container:this.config.containerConfiguration,component:this.config.customComponent||this,label:this.config.animationLabel,id:this.config.id})},t}(s["default"]);t["default"]=m},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=r(330),l=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getType=function(){return"shape"},r._setConfig=function(e,t){this.config[e]=t},r._getConfig=function(e){return void 0===e&&(e=""),""===e?this.config:this.config[e]},r.getElement=function(){var e=this.config;return this.getGraphicalElement(e.id,e.animationLabel)},r.getBounds=function(){return this.getElement().getBBox()},r.data=function(e,t){if(e&&"string"==typeof e){if(t===o.UNDEF)return this._data&&this._data[e];!this._data&&(this._data={}),this._data[e]=t}},r.parseAndSetAttribute=function(){var e,t,r=this.rawConfig,n=this.getFromEnv("snapPoints"),a={x:(0,o.pluck)(r.x,r.xPos,0),y:(0,o.pluck)(r.y,r.yPos,0),toX:(0,o.pluck)(r.toX),toY:(0,o.pluck)(r.toY)},i=this.config.calculatedAttrs={},l=this.getScaleInfo();for(var c in a)a.hasOwnProperty(c)&&void 0!==(t=a[c])&&(t=t.toString(),l.axis=c,(0,s.isMacro)(t)?i[c]=(0,s.solveEquation)((0,s.parseEquation)((0,s.cleanMacro)(t.toLowerCase()),n,l)):(i[c]=(0,s.solveEquation)((0,s.parseEquation)((0,s.cleanMacro)(t.toLowerCase()),n)),(0,o.pluckNumber)(r.autoscale,r.autoScale,1)&&(i[c]=(0,s.getScaledVal)(i[c],l))));"group"!==this.config.elementType&&(e=this.getLinkedParent().config.calculatedAttrs,i.x=i.x+(e.x||0),i.y=i.y+(e.y||0),isNaN(Number(i.toX))?i.toX=i.x:i.toX+=e.x||0,isNaN(Number(i.toY))||(i.toY+=e.y||0)),this.updateAttr()},r.getAttribute=function(e){return void 0===e&&(e=""),""===e?this.rawConfig:this.rawConfig[e]},r.show=function(){var e=Object.assign({},this.rawConfig);e.isVisible=!0,this.setData(e)},r.hide=function(){var e=Object.assign({},this.rawConfig);e.isVisible=!1,this.setData(e)},t}(i.SmartRenderer);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=n(r(337));function s(e){return e*(Math.PI/180)}var l=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"circle"},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r,n=this.rawConfig,a=this.getFromEnv("chart"),o=+a.getFromEnv("chartHeight")||700,s=+a.getFromEnv("chartWidth")||350;this.config.radius=n.radius,this.config.xRadius=(0,i.pluckNumber)(parseFloat(n.radius),parseFloat(n.xRadius),Math.sqrt(Math.max(o,s))),this.config.yRadius=(0,i.pluckNumber)(parseFloat(n.yRadius),this.config.xRadius),this.config.startAngle=(0,i.pluckNumber)(parseFloat(n.startAngle),0),this.config.endAngle=(0,i.pluckNumber)(parseFloat(n.endAngle),360),this.config.innerRadius=(0,i.pluckNumber)(parseFloat(n.innerRadius),0),this.config.innerYRadius=(0,i.pluckNumber)(parseFloat(n.innerYRadius),this.config.innerRadius,0),"arc"===this.config.type||0!==(r=this.config).startAngle||360!==r.endAngle||function(e){return e.innerRadius>0||e.innerYRadius>0}(this.config)?this.config.elementType="ringpath":this.config.elementType="ellipse"},r.updateAttr=function(){var e,t=this.config,r=t.calculatedAttrs,n=this.getFromEnv("chart"),a=+n.getFromEnv("chartHeight"),o=+n.getFromEnv("chartWidth"),l=this.getScaledVal(t.xRadius),c=this.getScaledVal(t.yRadius),u=this.getScaledVal(t.innerRadius),d=this.getScaledVal(t.innerYRadius);switch((0,i.pluck)(t.radius)||(t.radius=o<a?this.getScaledVal(o):this.getScaledVal(a),t.radius*=.3,u>t.radius&&(u+=t.radius,t.radius=u-t.radius,u-=t.radius),l=c=t.radius,d=u),t.elementType){case"ringpath":e={ringpath:[(0,i.pluckNumber)(r.x,this.getScaledVal(t.x,!0)),(0,i.pluckNumber)(r.y,this.getScaledVal(t.y,!1)),l,u,s(360-t.endAngle),s(360-t.startAngle),c,d]};break;default:e={cx:(0,i.pluckNumber)(r.x,this.getScaledVal(t.x,!0)),cy:(0,i.pluckNumber)(r.y,this.getScaledVal(t.y,!1))}}this._setConfig("attr",e)},r._getAnnotationAttrs=function(){var e,t=this.config,r=this.config.attr||{},n=t.x,a=t.y,i=this.getScaledVal(t.xRadius),o=this.getScaledVal(t.yRadius);switch(t.xRadius||(i=0),t.yRadius||(o=0),r.fill=t.color,r.stroke=t.borderColor,r["stroke-width"]=t.borderThickness,r["stroke-dasharray"]=t.dashArrayStr,this.config.elementType){case"ringpath":e=[this.getScaledVal(n,!0),this.getScaledVal(a,!1),i,this.getScaledVal(t.innerRadius),s(360-t.endAngle),s(360-t.startAngle),o,this.getScaledVal(t.innerYRadius)],r.ringpath=r.ringpath||e;break;default:r.rx=i,r.ry=o,r.cx="undefined"==typeof r.cx?this.getScaledVal(n,!0):r.cx,r.cy="undefined"==typeof r.cy?this.getScaledVal(a,!1):r.cy}return r},t}(o["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(338)),o=n(r(335)),s=r(224),l=r(330),c=n(r(243)),u=function(e){return void 0===e?void 0:1},d=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(e){var t,r,n=this,a=n.config,o=n.getFromEnv("chart"),d=n.getLinkedParent();n.groupConfig={},n.rawConfig={},null!==d&&(n.groupConfig.x=d._getConfig("x"),n.groupConfig.y=d._getConfig("y"),n.groupConfig.grpXShift=d._getConfig("grpXShift"),n.groupConfig.grpYShift=d._getConfig("grpYShift"),n.groupConfig.color=d._getConfig("color"),n.groupConfig.alpha=d._getConfig("alpha"),n.groupConfig.font=d._getConfig("font"),n.groupConfig.fontSize=d._getConfig("fontSize"),n.groupConfig.textAlign=d._getConfig("textAlign"),n.groupConfig.textVAlign=d._getConfig("textVAlign"),n.groupConfig.rotateText=d._getConfig("rotateText"),n.groupConfig.wrapText=d._getConfig("wrapText"),n.groupConfig.toolText=d._getConfig("toolText"),n.groupConfig.scaleX=d._getConfig("scaleX"),n.groupConfig.scaleY=d._getConfig("scaleY"),n.groupConfig.scaleImageX=d._getConfig("scaleImageX"),n.groupConfig.scaleImageY=d._getConfig("scaleImageY"),n.groupConfig.link=d._getConfig("link")),n.rawConfig=(0,i["default"])(n.rawConfig,e)||{},a.type=n.rawConfig.type,a.color=n._getFillColor(n.rawConfig,this.groupConfig),a.link=(0,s.pluck)(n.rawConfig.link,n.groupConfig.link),a.borderThickness=(0,s.pluckNumber)(parseFloat(n.rawConfig.borderThickness),parseFloat(n.rawConfig.thickness),2),a.showBorder=(0,s.pluckNumber)(n.rawConfig.showBorder,parseFloat(n.rawConfig.borderThickness),parseFloat(n.rawConfig.thickness),u(n.rawConfig.borderColor),u(n.rawConfig.borderAlpha),0),a.borderColor=n._getBorderColor(n.rawConfig),a.dashed=(0,s.pluckNumber)(n.rawConfig.dashed,0),a.dashLen=(0,s.pluckNumber)(n.rawConfig.dashLen,5),a.dashGap=(0,s.pluckNumber)(parseFloat(n.rawConfig.dashGap),3),a.dashArrayStr=a.dashed?(0,s.getDashStyle)(a.dashLen,a.dashGap):"none",a.x=(0,s.pluckNumber)(n.rawConfig.x,n.rawConfig.xPos,0),a.y=(0,s.pluckNumber)(n.rawConfig.y,n.rawConfig.yPos,0),a.tox=(0,s.pluckNumber)(n.rawConfig.toX,a.x,0),a.toy=(0,s.pluckNumber)(n.rawConfig.toY,a.y,0),a.toy>=0&&a.y>=0&&a.toy<a.y&&(t=[a.toy,a.y],a.y=t[0],a.toy=t[1]),a.tox>=0&&a.x>=0&&a.tox<a.x&&(r=[a.tox,a.x],a.x=r[0],a.tox=r[1]),a.showShadow=(0,s.pluckNumber)(n.rawConfig.showShadow,d.config.showShadow,0),a.toolText=(0,s.getFirstValue)(n.rawConfig.toolText,this.groupConfig.toolText,""),a.isVisible=(0,l.pluckBoolean)(n.rawConfig.isVisible,!0),a.id=(0,s.pluck)(n.rawConfig.id,n.getId(n.config.elementType)),a.containerConfiguration={id:n.getLinkedParent().config.id,label:"group",isParent:!0},n._clickHandler=n._clickHandler||function(e){n.config.link&&n.getFromEnv("linkClickFN").call({link:n.config.link},!0),n.rawConfig.onAnnotationClick instanceof Function?n.rawConfig.onAnnotationClick():d.rawConfig.onAnnotationClick instanceof Function?d.rawConfig.onAnnotationClick():o.fireChartInstanceEvent("annotationclick",(0,l.getEventData)(e,n,o),void 0,void 0,e)},n._rollOverHandler=n._rollOverHandler||function(e){n.rawConfig.onAnnotationRollover instanceof Function?n.rawConfig.onAnnotationRollover():d.rawConfig.onAnnotationRollover instanceof Function?d.rawConfig.onAnnotationRollover():o.fireChartInstanceEvent("annotationrollover",(0,l.getEventData)(e,n,o),void 0,void 0,e)},n._rollOutHandler=n._rollOutHandler||function(e){n.rawConfig.onAnnotationRollout instanceof Function?n.rawConfig.onAnnotationRollout():d.rawConfig.onAnnotationRollout instanceof Function?d.rawConfig.onAnnotationRollout():o.fireChartInstanceEvent("annotationrollout",(0,l.getEventData)(e,n,o),void 0,void 0,e)},n.rawConfig.customComponent instanceof c["default"]?a.customComponent=a.rawConfig.customComponent:delete a.customComponent},r._getBorderColor=function(e){var t="none",r={color:s.BLANKSTRING,alpha:s.BLANKSTRING};return"line"!==this.getType()&&(r.color=this.config.rawBorderColor=(0,s.pluck)(e.borderColor,e.fillColor&&e.fillColor.split(",")[0],e.color&&e.color.split(",")[0],"#000000"),0===this.config.showBorder?(r.alpha=1,this.config.borderThickness=2):r.alpha=this.config.rawBorderAlpha=(0,s.pluckNumber)(parseFloat(e.borderAlpha),parseFloat(e.alpha),100),t=(0,s.toRaphaelColor)(r)),t},r._getFillColor=function(e,t){var r=this.config.type,n={color:s.BLANKSTRING,alpha:s.BLANKSTRING,angle:s.BLANKSTRING,ratio:s.BLANKSTRING,radialGradient:"circle"===r||"arc"===r};return"line"===r||"image"===r?(n.color=e.color||t.color||"#FF0000",n.alpha=(0,s.pluckNumber)(parseFloat(e.alpha),t.alpha,100)):(n.color=e.fillColor||e.color||t.color||"#FF0000",n.alpha=(0,s.pluck)(e.fillAlpha,parseFloat(e.alpha),t.alpha,100),n.angle=360-(0,s.pluckNumber)(e.fillAngle,0),n.ratio=(0,s.pluck)(e.fillRatio),e.fillPattern&&(n.radialGradient="radial"===e.fillPattern.toLowerCase()||(0,s.pluckNumber)(e.fillPattern)),n.radialGradient&&(n.gradientUnits="objectBoundingBox",n.cx=.5,n.cy=.5,n.fx=.5,n.fy=.5)),this.config.rawColor=n.color,this.config.rawAlpha=n.alpha,this.config.rawAngle=n.angle,this.config.rawFillPattern=n.radialGradient?"radial":"linear",this.config.rawRatio=n.ratio,(0,s.toRaphaelColor)(n)},t.destroySelectionBox=function(){},r._applyAttr=function(e){var t,r=this.config.elementType,n=Object.assign({},e);("image"!==r||this.config.url)&&((t=this.rawConfig.css||{}).cursor=this.config.link?s.POINTER:"default",this.config.isVisible?n.visibility=s.visibleStr:n.visibility=s.hiddenStr,this.addEventListener("fc-click",this._clickHandler),this.addEventListener("fc-mouseover",this._rollOverHandler),this.addEventListener("fc-mouseout",this._rollOutHandler),this.config.animationLabel=this.rawConfig.animationLabel||this.getLinkedParent().config.animationLabel||r,this.addGraphicalElement({el:r,attr:n,css:t,container:this.config.containerConfiguration,component:this.config.customComponent||this,label:this.config.animationLabel,id:this.config.id,tooltext:this.config.toolText,shadow:{opacity:0!==this.config.showShadow?1:0,useFilter:"path"===r?0:1},outlineText:n.outlineText}))},r.getScaledVal=function(e,t){var r=this.getLinkedParent();return r?r.getScaledVal(e,t):e},r.getScaledFont=function(e){var t=this.getLinkedParent();return t?t.getScaledFont(e):e},r.getScaledImageVal=function(e,t){var r=this.getLinkedParent();return r?r.getScaledImageVal(e,t):e},r.getScaleInfo=function(){return this.getLinkedParent().config.scaleInfo},r.draw=function(){this.parseAndSetAttribute(),this._applyAttr(this._getAnnotationAttrs()||{})},t}(o["default"]);t["default"]=d},function(e,t,r){var n=r(339),a=r(342),i=n((function(e,t){return a((function(e,t,r){return r}),e,t)}));e.exports=i},function(e,t,r){var n=r(340),a=r(341);e.exports=function(e){return function t(r,i){switch(arguments.length){case 0:return t;case 1:return a(r)?t:n((function(t){return e(r,t)}));default:return a(r)&&a(i)?t:a(r)?n((function(t){return e(t,i)})):a(i)?n((function(t){return e(r,t)})):e(r,i)}}}},function(e,t,r){var n=r(341);e.exports=function(e){return function t(r){return 0===arguments.length||n(r)?t:e.apply(this,arguments)}}},function(e,t){e.exports=function(e){return null!=e&&"object"==typeof e&&!0===e["@@functional/placeholder"]}},function(e,t,r){var n=r(343),a=r(344),i=r(345),o=n((function s(e,t,r){return i((function(t,r,n){return a(r)&&a(n)?s(e,r,n):e(t,r,n)}),t,r)}));e.exports=o},function(e,t,r){var n=r(340),a=r(339),i=r(341);e.exports=function(e){return function t(r,o,s){switch(arguments.length){case 0:return t;case 1:return i(r)?t:a((function(t,n){return e(r,t,n)}));case 2:return i(r)&&i(o)?t:i(r)?a((function(t,r){return e(t,o,r)})):i(o)?a((function(t,n){return e(r,t,n)})):n((function(t){return e(r,o,t)}));default:return i(r)&&i(o)&&i(s)?t:i(r)&&i(o)?a((function(t,r){return e(t,r,s)})):i(r)&&i(s)?a((function(t,r){return e(t,o,r)})):i(o)&&i(s)?a((function(t,n){return e(r,t,n)})):i(r)?n((function(t){return e(t,o,s)})):i(o)?n((function(t){return e(r,t,s)})):i(s)?n((function(t){return e(r,o,t)})):e(r,o,s)}}}},function(e,t){e.exports=function(e){return"[object Object]"===Object.prototype.toString.call(e)}},function(e,t,r){var n=r(343),a=r(346),i=n((function(e,t,r){var n,i={};for(n in t)a(n,t)&&(i[n]=a(n,r)?e(n,t[n],r[n]):t[n]);for(n in r)a(n,r)&&!a(n,i)&&(i[n]=r[n]);return i}));e.exports=i},function(e,t){e.exports=function(e,t){return Object.prototype.hasOwnProperty.call(t,e)}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=r(330),s=n(r(337));function l(e){return e<="9"&&e>="0"||"-"===e||"."===e?0:e<="z"&&e>="a"||e<="Z"&&e>="A"?1:2}var c=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"path"},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.rawConfig;this.config.pathStr=(0,i.pluck)(r.path),this.config.x=(0,i.pluckNumber)(r.x,0),this.config.y=(0,i.pluckNumber)(r.y,0),this.config.tox=(0,i.pluckNumber)(r.toX,this.config.x),this.config.toy=(0,i.pluckNumber)(r.toY,this.config.y),this.config.elementType="path"},r.getScaledPath=function(){var e,t,r,n,a,s=this.config.pathStr,c=[],u=i.BLANKSTRING;for(a=s&&s.length,r=0;r<a;r++){for(n=r,t=i.BLANKSTRING,e=l(s[r]);n<a&&l(s[n])===e;)t+=s[n],n++;""!==(t=(0,o.trim)(t))&&e<2&&c.push(t),r=n===r?n:n-1}for(a=c.length,r=0;r<a;)switch(u+=c[r],c[r].toLowerCase()){case"m":case"l":case"t":u+=this.getScaledVal(Number(c[r+1]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+2]),!1).toString(),r+=3;break;case"s":case"q":u+=this.getScaledVal(Number(c[r+1]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+2]),!1).toString()+",",u+=this.getScaledVal(Number(c[r+3]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+4]),!1).toString(),r+=5;break;case"h":u+=this.getScaledVal(Number(c[r+1]),!0).toString(),r+=2;break;case"v":u+=this.getScaledVal(Number(c[r+1]),!1).toString(),r+=2;break;case"c":u+=this.getScaledVal(Number(c[r+1]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+2]),!1).toString()+",",u+=this.getScaledVal(Number(c[r+3]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+4]),!1).toString()+",",u+=this.getScaledVal(Number(c[r+5]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+6]),!1).toString(),r+=7;break;case"a":u+=this.getScaledVal(Number(c[r+1]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+2]),!1).toString()+",",u+=this.getScaledVal(Number(c[r+3]),!0).toString()+",",u+=c[r+4]+",",u+=c[r+5]+",",u+=this.getScaledVal(Number(c[r+6]),!0).toString()+",",u+=this.getScaledVal(Number(c[r+7]),!1).toString(),r+=8;break;case"z":default:r++}return u.toString()},r.updateAttr=function(){var e,t,r=this.config,n=r.calculatedAttrs,a={};e=(0,i.pluckNumber)(n.x,this.getScaledVal(r.x,!0)),t=(0,i.pluckNumber)(n.y,this.getScaledVal(r.y,!1)),r.pathStr?(a.path=this.getScaledPath(),a.transform="T"+e+","+t):a.path="M"+e+","+t+"L"+(0,i.pluckNumber)(n.toX,e,this.getScaledVal(r.tox,!0))+","+(0,i.pluckNumber)(n.toY,t,this.getScaledVal(r.toy,!1)),this._setConfig("attr",a)},r._getAnnotationAttrs=function(){var e,t,r,n,a,i=this.config,o=this._getConfig("attr")||{},s=i.color;return o.stroke=s,this.rawConfig.color&&(o.fill=s),o["stroke-width"]=this.getScaledVal(i.borderThickness),o["stroke-dasharray"]=i.dashArrayStr,e=o.x||this.getScaledVal(i.x,!0),t=o.y||this.getScaledVal(i.y,!1),r=o.toX||this.getScaledVal(i.tox,!0),n=o.toY||this.getScaledVal(i.toy,!1),o.path||((a=this.getScaledPath())?(o.path=a,o.transform=o.transform||"T"+e+","+t):o.path=o.path||"M"+e+","+t+"L"+r+","+n),o},t}(s["default"]);t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=n(r(337)),s=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"rect"},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);this.config.xRadius=(0,i.pluckNumber)(parseFloat(this.rawConfig.radius),0),this.config.elementType="rect"},r.updateAttr=function(){var e,t,r,n,a,o,s=this.config,l=s.calculatedAttrs;r=(0,i.pluckNumber)(l.x,this.getScaledVal(s.x,!0)),n=(0,i.pluckNumber)(l.y,this.getScaledVal(s.y,!1)),a=(0,i.pluckNumber)(l.toX,this.getScaledVal(s.tox,!0)),(o=(0,i.pluckNumber)(l.toY,this.getScaledVal(s.toy,!1)))>=0&&n>=0&&o<n&&(n=(e=[o,n])[0],o=e[1]),a>=0&&r>=0&&a<r&&(r=(t=[a,r])[0],a=t[1]),this._setConfig("attr",{x:r,y:n,width:Math.abs(a-r),height:Math.abs(o-n)})},r._getAnnotationAttrs=function(){var e=this.config,t=this._getConfig("attr")||{},r=this.getScaledVal(e.x),n=this.getScaledVal(e.y);return t.x="undefined"==typeof t.x?r:t.x,t.y="undefined"==typeof t.y?n:t.y,t.width="undefined"==typeof t.width?Math.abs(this.getScaledVal(e.tox)-r):t.width,t.height="undefined"==typeof t.height?Math.abs(this.getScaledVal(e.toy)-n):t.height,t.r=this.getScaledVal(e.xRadius),t.fill=e.color,t.stroke=e.borderColor,t["stroke-width"]=e.borderThickness,t["stroke-dasharray"]=e.dashArrayStr,t},t}(o["default"]);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(337)),o=r(224),s=function(e){var t=this.config,r=e.originalEvent.target,n=r.height,a=r.width,i=this._getConfig("align"),o=this._getConfig("vAlign"),s=this._getConfig("xScale"),l=n*this._getConfig("yScale"),c=a*s,u=function(e){var t=e.height,r=e.width,n=e.vAlign,a=e.align,i=e.x,o=e.y,s={x:i,y:o};switch(a){case"center":s.x=i-r/2;break;case"right":s.x=i-r}switch(n){case"middle":s.y=o-t/2;break;case"bottom":s.y=o-t}return s}({x:t.derivedX,y:t.derivedY,height:l,width:c,align:i,vAlign:o});this.config.loadedWidth=a,this.config.loadedHeight=n,t=Object.assign(this.rawConfig,{x:u.x,y:u.y,width:c,height:l,autoScale:0}),this.getGraphicalElement(this.config.id,this.config.animationLabel).attr(t),this.rawConfig.onload&&this.rawConfig.onload.call(this,{width:c,height:l}),e.detachHandler()},l=function(e){function t(t){var r;return(r=e.call(this,t)||this)._listener=s,r}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"image"},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.rawConfig,n=this.config;n.url=(0,o.getValidValue)(r.url),n.xScale=n.rawXScale=(0,o.pluckNumber)(r.xScale,100)/100,n.yScale=n.rawYScale=(0,o.pluckNumber)(r.yScale,100)/100,n.width=(0,o.pluckNumber)(n.loadedWidth,r.width),n.height=(0,o.pluckNumber)(n.loadedHeight,r.height),n.align=(0,o.pluck)(r.align,"left"),n.vAlign=(0,o.pluck)(r.vAlign,"top"),n.xScale=n.xScale*(this.groupConfig.scaleX||1),n.yScale=n.yScale*(this.groupConfig.scaleY||1),n.elementType="image","undefined"==typeof n.width&&"undefined"==typeof n.height&&this.addEventListener("load",this._listener)},r.updateAttr=function(){var e=this.getLinkedParent(),t=this.config,r=t.calculatedAttrs;this.config.xScale=e.config.scaleX*t.rawXScale,this.config.yScale=e.config.scaleY*t.rawYScale,this._setConfig("attr",{x:(0,o.pluckNumber)(r.x,this.getScaledVal(t.x,!0)),y:(0,o.pluckNumber)(r.y,this.getScaledVal(t.y,!1))})},r._getAnnotationAttrs=function(){var e=this.config,t=e.attr,r=(0,o.pluckNumber)(e.attr.x,e.x),n=(0,o.pluckNumber)(e.attr.y,e.y);return(0,o.pluckNumber)(this.rawConfig.autoscale,this.rawConfig.autoScale,1)||(t={x:r,y:n}),e.derivedX=t.x="undefined"==typeof t.x?this.getScaledVal(r,!0):t.x,e.derivedY=t.y="undefined"==typeof t.y?this.getScaledVal(n,!1):t.y,t.src=e.url,t.opacity=(0,o.pluckNumber)(e.rawAlpha,100)/100,"undefined"!=typeof e.width&&(t.width=e.width*e.xScale),"undefined"!=typeof e.height&&(t.height=e.height*e.yScale),t},t}(i["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(337)),o=r(224),s={left:"start",right:"end",center:"middle"},l={top:"bottom",middle:"middle",bottom:"top"},c={0:"0",1:"270",right:"90",cw:"90",left:"270",ccw:"270"};var u=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"text"},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r,n=this.rawConfig,a=this.groupConfig;this.config.text=(0,o.parseUnsafeString)((0,o.pluck)(n.text,n.label,"")),this.config.font=(0,o.pluck)(n.font,a.font,"Verdana, sans"),this.config.fontSize=(0,o.pluckFontSize)(n.fontSize,a.fontSize,10),this.config.align=(0,o.pluck)(s[n.align&&n.align.toLowerCase()],s[a.textAlign&&a.textAlign.toLowerCase()],"middle"),this.config.vAlign=(0,o.pluck)(l[n.vAlign&&n.vAlign.toLowerCase()],l[a.textVAlign&&a.textVAlign.toLowerCase()],"middle"),this.config.radius=(0,o.pluckNumber)(parseFloat(n.radius),0),this.config.fontWeight=(0,o.pluckNumber)(n.bold,0)?"bold":"normal",this.config.outlineText=(0,o.pluckNumber)(t.outlineText,0),this.config.fontStyle=(0,o.pluckNumber)(n.italic,0)?"italic":"normal",this.config.bgColor=(r=n.bgColor,(/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(r)?r:/(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i.test(r))?n.bgColor:"none"),this.config.borderThickness=(0,o.pluckNumber)(parseFloat(this.rawConfig.borderThickness),parseFloat(this.rawConfig.thickness),1),this.config.rotateText=(0,o.pluck)(n.rotateText,a.rotateText,"0"),this.config.rotateAngle=c[this.config.rotateText&&this.config.rotateText.toLowerCase()],this.config.wrap=(0,o.pluckNumber)(n.wrap,a.wrapText,n.wrapHeight,n.wrapWidth,1),this.config.wrap&&(this.config.wrapWidth=(0,o.pluckNumber)(n.wrapWidth),this.config.wrapHeight=(0,o.pluckNumber)(n.wrapHeight)),this.config.leftMargin=(0,o.pluckNumber)(n.leftMargin,0),this.config.elementType="text"},r.getText=function(){var e=this.config,t=this.getFromEnv("smartLabel"),r=this.getLinkedParent(),n=r&&r._getConfig("scaleText"),a=n?this.getScaledVal(e.wrapWidth,!0):e.wrapWidth,i=n?this.getScaledVal(e.wrapHeight,!1):e.wrapHeight,s={fontStyle:e.fontStyle,fontFamily:e.font,fontWeight:e.fontWeight,fontSize:e.fontSize+"px","text-anchor":e.align,"vertical-align":e.vAlign};return(0,o.setLineHeight)(s),t&&t.setStyle(s),t&&e.wrap?t.getSmartText(e.text,a,i,0).text:e.text},r._getFillColor=function(e,t){var r=this.config.type,n={color:"",alpha:"",angle:"",ratio:"",radialGradient:"circle"===r||"arc"===r};return n.color=e.fontColor||e.fillColor||e.color||t.color||"#FF0000",n.alpha=(0,o.pluck)(e.fillAlpha,parseFloat(e.alpha),t.alpha,100),n.angle=360-(0,o.pluckNumber)(e.fillAngle,0),n.ratio=(0,o.pluck)(e.fillRatio),e.fillPattern&&(n.radialGradient="radial"===e.fillPattern||(0,o.pluckNumber)(e.fillPattern)),n.radialGradient&&(n.gradientUnits="objectBoundingBox",n.cx=.5,n.cy=.5,n.fx=.5,n.fy=.5),this.config.rawColor=n.color,this.config.rawAlpha=n.alpha,this.config.rawAngle=n.angle,this.config.rawFillPattern=n.radialGradient?"radial":"linear",this.config.rawRatio=n.ratio,(0,o.toRaphaelColor)(n)},r.updateAttr=function(){var e,t=this.config,r=t.calculatedAttrs,n=(0,o.pluckNumber)(r.x,this.getScaledVal(t.x,!0)),a=(0,o.pluckNumber)(r.y,this.getScaledVal(t.y,!0));"0"!==t.rotateText&&(e=(0,o.getSuggestiveRotation)(parseFloat(t.rotateAngle),n,a)),this._setConfig("attr",{x:n,y:a,transform:e})},r._getAnnotationAttrs=function(){var e,t,r=this.config,n=this._getConfig("attr")||{},a=this.getScaledVal(r.x,!0),i=this.getScaledVal(r.y,!1);return n.x=("undefined"==typeof n.x?a:n.x)+r.leftMargin/2,n.y="undefined"==typeof n.y?i:n.y,n.text=this.getText(),n.fill=r.color,n.outlineText=r.outlineText,n.text&&(e=this.rawConfig.borderColor,t=this.rawConfig.borderAlpha,e&&"none"!==e&&0!==t||this.rawConfig.bgColor)?n["text-bound"]=[(0,o.toRaphaelColor)(r.bgColor),r.borderColor,r.borderThickness,2,r.radius,r.dashArrayStr]:n["text-bound"]=[],n["font-style"]=r.fontStyle,n["font-weight"]=r.fontWeight,n["font-family"]=r.font,n["font-size"]=this.getScaledFont(r.fontSize),n["text-anchor"]=r.align,n["vertical-align"]=r.vAlign,"0"!==r.rotateText&&(n.transform=n.transform||(0,o.getSuggestiveRotation)(parseFloat(r.rotateAngle),a,i)),n},t}(i["default"]);t["default"]=u},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(337)),o=r(224),s=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"polygon"},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.rawConfig;this.config.sides=(0,o.pluckNumber)((0,o.clampNumber)(r.sides,3),5),this.config.startAngle=(0,o.pluckNumber)(parseFloat(r.startAngle),0),this.config.xRadius=(0,o.pluckNumber)(parseFloat(r.radius),0),this.config.elementType="polypath"},r.updateAttr=function(){var e=this.config,t=e.calculatedAttrs;this._setConfig("attr",{polypath:[e.sides,(0,o.pluckNumber)(t.x,this.getScaledVal(e.x,!0)),(0,o.pluckNumber)(t.y,this.getScaledVal(e.y,!1)),this.getScaledVal(e.xRadius),e.startAngle,0]})},r._getAnnotationAttrs=function(){var e=this.config,t=this._getConfig("attr")||{};return t.fill=e.color,t.stroke=e.borderColor,t["stroke-width"]=e.borderThickness,t["stroke-dasharray"]=e.dashArrayStr,t.polypath=t.polypath||[e.sides,this.getScaledVal(e.x,!0),this.getScaledVal(e.y,!1),this.getScaledVal(e.xRadius),e.startAngle,0],t},t}(i["default"]);t["default"]=s},function(e,t,r){var n=r(339)((function(e,t){var r={};for(var n in t)e(t[n],n,t)&&(r[n]=t[n]);return r}));e.exports=n},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(354)),i=r(224),o=r(357);function s(e){var t=e.sender;(0,o.isValidDataset)(t)&&t.registerFactory("regression",(function(e){var t=e.getFromEnv("chart").getFromEnv("dataSource").chart,r=e.config.JSONData;(0,i.componentFactory)(e,a["default"],"regression",Number((0,o.hasRegressionLine)(t,r)),[e])}))}var l={extension:function(e){e.addEventListener("instantiated",s)},name:"Regression",type:"extension",requiresFusionCharts:!0};t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=n(r(355)),s=n(r(356)),l=r(224),c=r(357),u=r(232),d=n(r(358)),f=function(){this.hide()};(0,u.addDep)({name:"regressionLineAnimation",type:"animationRule",extension:d["default"]});var h=function(e){function t(){var t;return(t=e.call(this)||this)._config={regressionPoints:[]},t.regressionLine=[],t}(0,a["default"])(t,e);var r=t.prototype;return r.getType=function(){return"extension"},r.getName=function(){return"regression"},r.configureAttributes=function(e){var t=this.getFromEnv("dataSource").chart,r=e.config,n=r.JSONData,a=this._config;a.regressionPoints.splice(0,a.regressionPoints.length),a.showYOnX=(0,l.pluckNumber)(n.showyonx,t.showyonx,1),a.regressionLineColor=(0,l.toRaphaelColor)((0,l.pluck)(n.regressionlinecolor,t.regressionlinecolor,r.anchorbordercolor,r.lineColor,r.anchorBgColor,"fff000")),a.polynomialRegressionLineColor=(0,l.toRaphaelColor)((0,l.pluck)(n.polynomialregressionlinecolor,t.polynomialregressionlinecolor,a.regressionLineColor)),a.regressionLineThickness=(0,l.pluckNumber)(n.regressionlinethickness,t.regressionlinethickness,n.anchorborderthickness,1),a.polynomialRegressionLineThickness=(0,l.pluckNumber)(n.polynomialregressionlinethickness,t.polynomialregressionlinethickness,a.regressionLineThickness),a.regressionLineAlpha=(0,l.pluckNumber)(n.regressionlinealpha,t.regressionlinealpha,100),a.polynomialRegressionLineAlpha=(0,l.pluckNumber)(n.polynomialregressionlinealpha,t.polynomialregressionlinealpha,a.regressionLineAlpha),(0,c.createLinear)(t,n)&&a.regressionPoints.push((0,o["default"])(n.data,a.showYOnX)),(0,c.createPolynomial)(t,n)&&a.regressionPoints.push((0,s["default"])(n.data,a.showYOnX))},r.draw=function(){var e,t,r,n,a,i,o,s=this._config,c=this.getFromEnv("xAxis"),u=this.getFromEnv("yAxis"),d=this.getFromEnv("chart"),h=d.getChildren("canvas")[0].config,g=this.getContainer("regressionlinecontainer"),p=this.getFromEnv("animationManager"),m=s.regressionPoints,v=[],b=[],y=this.getGraphicalElement("regressionLineLinear"),x=this.getGraphicalElement("regressionLinePolynomial"),w=f;!this.getLinkedParent().getState("visible")&&(o="disappearing"),g=this.addContainer("regressionlinecontainer",p.setAnimation({el:g||"group",attr:{name:"regressionlinecontainer","clip-rect":[h.canvasLeft,h.canvasTop,h.canvasWidth,h.canvasHeight]},container:d.getChildContainer("abovePlotGroup"),component:this,label:"group"}));for(var C=0;C<m.length;C++){var k=l.BLANKSTRING;if(v=m[C][0],e=(b=m[C][1]).length,0===v.length&&0===b.length)n=!0,k+="M0,0";else if(0!==v.length&&0===b.length)n=!1,k+="M0,0";else if(0===v.length)n=!0,k+="M"+c.getPixel(b[0].x)+","+u.getPixel(b[0].y),k+="L"+c.getPixel(b[e-1].x)+","+u.getPixel(b[e-1].y);else{n=!1,k+="M"+c.getPixel(b[0].x)+","+u.getPixel(b[0].y),k+=" R"+c.getPixel(b[1].x)+","+u.getPixel(b[1].y);for(var _=2;_<e;_++)k+=" "+c.getPixel(b[_].x)+","+u.getPixel(b[_].y)}n?a={opacity:Number(s.regressionLineAlpha)/100,stroke:s.regressionLineColor,"stroke-width":s.regressionLineThickness,path:k}:i={opacity:Number((0,l.pluck)(s.polynomialRegressionLineAlpha,s.regressionLineAlpha))/100,stroke:(0,l.pluck)(s.polynomialRegressionLineColor,s.regressionLineColor),"stroke-width":(0,l.pluck)(s.polynomialRegressionLineThickness,s.regressionLineThickness),path:k}}"disappearing"!==o&&(y&&y.show(),x&&x.show()),t=p.setAnimation({el:y||"path",container:g,component:this,doNotRemove:!0,attr:!("disappearing"===o)&&a,callback:"disappearing"===o&&w,label:"path"}),y||this.addGraphicalElement("regressionLineLinear",t),r=p.setAnimation({el:x||"path",container:g,component:this,doNotRemove:!0,attr:!("disappearing"===o)&&i,callback:"disappearing"===o&&w,label:"path"}),x||this.addGraphicalElement("regressionLinePolynomial",r)},t}(i.ComponentInterface);t["default"]=h},function(e,t,r){"use strict";function n(e,t,r){return parseFloat(e[r])-parseFloat(t[r])}function a(e,t){return n(e,t,"x")}function i(e,t){return n(e,t,"y")}t.__esModule=!0,t["default"]=function(e,t){if(Number(t))return function(e){e.sort(a);for(var t,r,n,i,o=[],s=[],l=0,c=0,u=0,d=0,f=e.length,h=[],g=0;g<e.length;g++)n=Number(e[g].x),i=Number(e[g].y),isNaN(n)||isNaN(i)||(o.push(n),s.push(i));f=o.length;for(var p=0;p<f;p++)l+=o[p],c+=s[p];l/=f,c/=f;for(var m=0;m<f;m++)u+=(o[m]-l)*(s[m]-c),d+=(o[m]-l)*(o[m]-l);if(0===d)return[[],[]];return r=c-(t=u/d)*l,h.push({x:o[0],y:t*o[0]+r}),h.push({x:o[f-1],y:t*o[f-1]+r}),[[],h]}(e);return function(e){e.sort(i);for(var t,r,n,a,o=[],s=[],l=0,c=0,u=0,d=0,f=e.length,h=[],g=0;g<e.length;g++)n=Number(e[g].x),a=Number(e[g].y),isNaN(n)||isNaN(a)||(o.push(n),s.push(a));f=o.length;for(var p=0;p<f;p++)l+=o[p],c+=s[p];l/=f,c/=f;for(var m=0;m<f;m++)u+=(o[m]-l)*(s[m]-c),d+=(s[m]-c)*(s[m]-c);if(0===d)return[[],[]];return r=l-(t=u/d)*c,(h=[]).push({x:t*s[0]+r,y:s[0]}),h.push({x:t*s[f-1]+r,y:s[f-1]}),[[],h]}(e)}},function(e,t,r){"use strict";function n(e,t){return parseFloat(e.x)-parseFloat(t.x)}t.__esModule=!0,t["default"]=function(e,t){if(Number(t))return function(e){e.sort(n);for(var t,r,a,i,o,s,l,c,u,d,f=[],h=[],g=0,p=0,m=e.length,v=0,b=0,y=0,x=0,w=0,C=[],k=0;k<e.length;k++)u=Number(e[k].x),d=Number(e[k].y),isNaN(u)||isNaN(d)||(f.push(u),h.push(d));m=f.length;for(var _=0;_<m;_++)g+=h[_],p+=f[_]*h[_],w+=f[_]*f[_]*h[_],v+=f[_],b+=f[_]*f[_],x+=f[_]*f[_]*f[_],y+=f[_]*f[_]*f[_]*f[_];if(r=p-v*g/m,i=w-b*g/m,(t=b-v*v/m)*(o=y-b*b/m)-(a=x-b*v/m)*a==0||0===m)return[e,[]];c=g/m-(l=(r*o-i*a)/(t*o-a*a))*(v/m)-(s=(i*t-r*a)/(t*o-a*a))*(b/m);for(var S=0;S<m;S++)C.push({x:f[S],y:s*f[S]*f[S]+l*f[S]+c});return[e,C]}(e);return function(e){e.sort(n);for(var t,r,a,i,o,s,l,c,u,d,f=[],h=[],g=0,p=0,m=e.length,v=0,b=0,y=0,x=0,w=0,C=[],k=0;k<e.length;k++)u=Number(e[k].x),d=Number(e[k].y),isNaN(u)||isNaN(d)||(f.push(u),h.push(d));m=f.length;for(var _=0;_<m;_++)g+=f[_],p+=h[_]*f[_],w+=h[_]*h[_]*f[_],v+=h[_],b+=h[_]*h[_],x+=h[_]*h[_]*h[_],y+=h[_]*h[_]*h[_]*h[_];if(r=p-v*g/m,i=w-b*g/m,(t=b-v*v/m)*(o=y-b*b/m)-(a=x-b*v/m)*a==0||0===m)return[e,[]];c=g/m-(l=(r*o-i*a)/(t*o-a*a))*(v/m)-(s=(i*t-r*a)/(t*o-a*a))*(b/m);for(var S=0;S<m;S++)C.push({x:s*h[S]*h[S]+l*h[S]+c,y:h[S]});return[e,C]}(e)}},function(e,t,r){"use strict";t.__esModule=!0,t.createPolynomial=function(e,t){var r=Number(e.showpolynomialregressionline)||0;return isNaN(t.showpolynomialregressionline)&&r||Number(t.showpolynomialregressionline)},t.createLinear=function(e,t){var r=Number(e.showregressionline)||0;return isNaN(t.showregressionline)&&r||Number(t.showregressionline)},t.isInArray=function(e,t){return t.indexOf(e.toLowerCase())>-1},t.hasRegressionLine=function(e,t){return t.showregressionline||e.showregressionline||t.showpolynomialregressionline||e.showpolynomialregressionline},t.isValidDataset=void 0;var n=["scatter","bubble","errorScatter","selectScatter"];t.isValidDataset=function(e){return function(e){return"dataset"===e.getType()}(e)&&n.indexOf(e.getName())>=0}},function(e,t,r){"use strict";function n(){var e,t=this.getFromEnv("chart").getChildren("canvas")[0],r=0,n=[],a=[];for(n.push(t.config.canvasLeft),n.push(t.config.canvasTop),n.push(0),n.push(t.config.canvasHeight),e=n.length;r<e;)a.push(n[r]),r++;return a[2]=t.config.canvasWidth,[{initialAttr:function(){return{"clip-rect":n}},finalAttr:function(){return{"clip-rect":a}},effect:"linear",slot:"plot"}]}t.__esModule=!0,t["default"]=void 0;var a={"initial.extension.regression":function(){return{"path.appearing":null,"path.updating":null,"path.disappearing":null,"group.appearing":n,"*":null}}};t["default"]=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=r(224),i=n(r(360)),o=n(r(361)),s=n(r(379)),l=n(r(380)),c=n(r(381)),u=n(r(382)),d=n(r(383)),f=n(r(384)),h=n(r(385)),g=n(r(386)),p=r(232),m=n(r(387)),v={DragZoomIn:o["default"],ZoomResetButton:s["default"],ZoomOutButton:l["default"],DbTapZoom:u["default"],DragPin:d["default"],ZoomInButton:c["default"],DragPan:f["default"],PinchZoom:h["default"],SwipeGesture:g["default"]};var b={extension:function(e){var t,r;(0,m["default"])((0,p.getDep)("redraphael","plugin")),e.addEventListener("instantiated",(function(e){var n,o=e.sender;"canvas"===o.getType()&&o.registerFactory("inputManager",(function(e){if(r=e.getFromEnv("chart"),t=r.constructor.includeInputOptions&&r.constructor.includeInputOptions()){(0,a.componentFactory)(e,i["default"],"inputManager",1,[{}]),n=e.getChildren("inputManager")[0];for(var o=0,s=t&&t.length;o<s;o++)(0,a.componentFactory)(n,v[t[o]],t[o],1,[{}])}}))}))},name:"inputAdapter",type:"extension",requiresFusionCharts:!0};t["default"]=b},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=function(e,t,r,n){var a,i;(i=n[e])&&(i.some((function(e,n){return e.callback===t&&e.component===r&&(a=n,!0)})),a!==o.UNDEF&&i.splice(a,1))},l=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configure=function(){var e=this.getFromEnv("chart"),t=e.getInputConfigurations;this.addToEnv("canvas",this.getLinkedParent()),this.addToEnv("inputOptions",t&&t.call(e)),this.config={controlObj:{},dependancyObj:{}}},r.addEventToChild=function(){var e=this,t=e.getChildren(),r=["zoomin","zoomout","dragzoomenabled","dragzoomdisabled","pinenabled","pindisabled","panenabled","pandisabled"],n=function(n){r.forEach((function(r){e.addExtEventListener(r,e.manageEvents.bind(e),t[n][0])}))};for(var a in t)n(a)},r.manageEvents=function(e){var t=this.config.dependancyObj,r=e.type;t[r]&&t[r].forEach((function(t){t.component!==e.sender&&t.callback.call(t.component,e)}))},r.fetchZoomableAxes=function(){if(!this.config.axesObArr){var e=this.config.axesObArr=[];this.getLinkedParent().getAxes().forEach((function(t){(t.config.zoomable||t.config.pannable)&&e.push({axis:t.axis,stack:[],isY:t.isY})})),this.addToEnv("axesObArr",e)}},r.draw=function(){this.fetchZoomableAxes(),this.addEventToChild()},r.getControl=function(e,t){var r,n=this.config.controlObj,a=this.getLinkedParent();t||e.forEach((function(e){(r=e.nativeInteraction)instanceof Array?r.forEach((function(t){(n[t]||(n[t]=[])).push({callback:e.callback,component:e.component}),e.component.addExtEventListener(t,e.callback,a)})):((n[r]||(n[r]=[])).push({callback:e.callback,component:e.component}),e.component.addExtEventListener(r,e.callback,a))}))},r.releaseControl=function(e){var t,r=this,n=r.getLinkedParent();e.forEach((function(e){(t=e.nativeInteraction)instanceof Array?t.forEach((function(t){e.component.removeExtEventListener(t,e.callback,n),s(t,e.callback,e.component,r.config.controlObj)})):(e.component.removeExtEventListener(t,e.callback,n),s(t,e.callback,e.component,r.config.controlObj))}))},r._updateControlObj=function(e,t){var r,n;(n=this.config.controlObj[e])&&(n.some((function(e,n){return e.callback===t&&(r=n,!0)})),r!==o.UNDEF&&n.splice(r,1))},r.registerDependancy=function(e){var t,r=this.config.dependancyObj;e.forEach((function(e){(t=e.derivedInteraction)instanceof Array?t.forEach((function(t){(r[t]||(r[t]=[])).push({callback:e.callback,component:e.component,derivedInteraction:t})})):(r[t]||(r[t]=[])).push(e)}))},r.removeDependancy=function(e){var t,r=this;e.forEach((function(e){(t=e.derivedInteraction)instanceof Array?t.forEach((function(t){s(t,e.callback,e.component,r.config.dependancyObj)})):s(t,e.callback,e.component,r.config.dependancyObj)}))},r.zoomOut=function(){var e=this.getChildren("ZoomOutButton");e&&e[0].zoomOut()},r.zoomTo=function(e,t){var r=this.getChildren("DragZoomIn");r&&r[0].zoomTo(e,t)},r.resetChart=function(){var e=this.getChildren("ZoomResetButton");e&&e[0].zoomOut()},r.setZoomMode=function(e){var t=this.getChildren("DragPin");t&&(e?t[0].disable():t[0].enable())},t}(i.ComponentInterface);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=r(224),l=Math.min,c=Math.abs,u=function(e){function t(){var r;r=e.call(this)||this;var n=(0,a["default"])(r);return n.controlArr=[{nativeInteraction:["fc-dragstart"],callback:n.dragStart.bind(n),component:n},{nativeInteraction:["fc-dragmove"],callback:n.onDrag.bind(n),component:n},{nativeInteraction:["fc-dragend"],callback:n.onDragEnd.bind(n),component:n}],s.isFirefox&&n.controlArr.push({nativeInteraction:["fc-mousedown"],callback:t.mousedown,component:n}),n._toggle=function(){n._checkStackLen()&&n.toggle()},r}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"dragZoomIn"},r.configure=function(){e.prototype.configure.call(this);var t=this.config;t.boxStyle=t.boxStyle||{"stroke-width":1,stroke:"red",fill:"#00FF00",opacity:.2,cursor:"ne-resize"},!this.config.skipGraphics&&this.setLinkedItem("button",this.createButton({icon:"zoomModeIcon",tooltext:this.config.tooltext,handlers:{click:this._toggle},state:"activated"})),this.enable("pressed"),this.getLinkedParent().registerDependancy([{derivedInteraction:["pinenabled","pindisabled","panenabled","pandisabled"],callback:this.dependancyFn,component:this}])},t.mousedown=function(e){e&&e.preventDefault()},r.setControl=function(){var e=this.getLinkedParent(),t=this.getLinkedItem("button"),r=this.controlArr;e.releaseControl(r),this.isEnabled()&&e.getControl(r),t&&t.setCurrentState(this.isEnabled()?this.config.state:"disabled")},r.getCoordinates=function(e){var t=this.getFromEnv("chart"),r=(0,s.getMouseCoordinate)(t.getFromEnv("chart-container"),e,t);return{x:r.chartX,y:r.chartY}},r.inCanvasLimit=function(e){var t=this.getFromEnv("canvas").getGraphicalElement("canvasElement").attrs,r=t.x,n=t.y,a=e.x-t.x,i=e.y-t.y,o=t.width-a,s=t.height-i;return e.x>r&&e.y>n&&e.width<o&&e.height<s},r.drawBox=function(){var e,t=this.config,r=this.getGraphicalElement("box"),n=this.getFromEnv("canvas").getGraphicalElement("canvasElement").attrs;r||(r=this.addGraphicalElement("box",this.getFromEnv("paper").rect())).attr(t.boxStyle),e=function(e,t,r,n){t.x<r.x&&(t.x=r.x),t.y<r.y&&(t.y=r.y),t.x>r.width+r.x&&(t.x=r.width+r.x),t.y>r.height+r.y&&(t.y=r.height+r.y);var a,i=t.x-e.x,o=e.y-t.y;return i>0&&o>0?a=n?"ne-resize":"e-resize":i<0&&o>0?a=n?"nw-resize":"w-resize":i<0&&o<0?a=n?"sw-resize":"w-resize":i>0&&o<0&&(a=n?"se-resize":"e-resize"),{x:l(e.x,t.x),y:l(e.y,t.y),width:i=c(i),height:o=c(o),cursor:a}}(this.dragBoxConfig.startPos,this.dragBoxConfig.currentPos,n,this.getFromEnv("chart").isXY),t.scaleX||(e.x=n.x,e.width=n.width),t.scaleY||(e.y=n.y,e.height=n.height),r.attr(e),r.show()},r.onDragEnd=function(e){var t,r,n,a,i=this.config,o=this.getFromEnv("canvas").getGraphicalElement("canvasElement").attrs,s=this.getGraphicalElement("box")||{},l=s.attrs;l&&i.dragmove&&(i.dragmove=!1,s.hide(),i.startPosX=t=(l.x-o.x)/o.width,i.endPosX=r=(l.x+l.width-o.x)/o.width,i.startPosY=n=(l.y-o.y)/o.height,i.endPosY=a=(l.y+l.height-o.y)/o.height,r-t<.01||a-n<.01||this.zoomTo(void 0,void 0,e))},r.zoomTo=function(e,t,r){var n,a,i,o,s,l,c,u,d=this,f=d.config,h=!1,g={},p=f.catZoomLimit-1;d.getFromEnv("axesObArr").forEach((function(m){var v=m.axis,b=v.getFromEnv("chart"),y=b.getChildren("scrollBar")&&b.getChildren("scrollBar")[0],x=v.getVisibleConfig(),w=m.isY?x.maxValue:x.minValue,C=x.maxValue-x.minValue;m.isY?(o=n=void 0===e?w-C*f.endPosY:e,l=a=void 0===t?w-f.startPosY*C:t):(s=n=void 0===e?w+f.startPosX*C:e,c=a=void 0===t?w+C*f.endPosX:t,g=d.constructor._getZoomInfo(s,c,v)),p&&!v.config.isVertical&&Math.round(a-n)<p&&(n=Math.round(n),a=n+p),(C>1||a-n>1)&&(f.dragendFn&&"function"==typeof f.dragendFn&&f.dragendFn(r,n,a),u=v.setVisibleConfig(n,a),b.setScrollBarDimension&&b.setScrollBarDimension(),y&&!y.getState("removed")&&y.asyncDraw(),h=h||u,m.stack.push(x),i=m.stack.length+1)})),h&&d._raiseZoomEvents("zoomin","zoomedin",Object.assign(g,{level:i,startX:s,endX:c,startY:o,endY:l},{originalEvent:r&&r.originalEvent}))},r.onDrag=function(e){var t=this.config,r=this.getCoordinates(e.originalEvent);t.dragmove=!0,this.getFromEnv("animationManager").setAnimationState("drag"),t.dragmoveFn&&"function"==typeof t.dragmoveFn&&t.dragmoveFn(e),this.dragBoxConfig.currentPos=r,this.drawBox()},r.dragStart=function(e){var t=this.config,r=this.getCoordinates(e.originalEvent);t.dragstartFn&&"function"==typeof t.dragstartFn&&t.dragstartFn(e),this.dragBoxConfig={startPos:r,currentPos:r}},r.enable=function(){!0!==this.config.enabled&&(this.config.enabled=!0,this.config.state="pressed",this.fireEvent("dragzoomenabled"),this.setControl())},r.disable=function(){!1!==this.config.enabled&&(this.config.enabled=!1,this.config.state="activated",this.fireEvent("dragzoomdisabled"),this.setControl())},r.dependancyFn=function(e){"pinenabled"===e.type||"panenabled"===e.type?this.disable():"pindisabled"!==e.type&&"pandisabled"!==e.type||this.enable()},t}(o["default"]);t["default"]=u},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(363),s=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configure=function(){var e=this.config={},t=this.getFromEnv("inputOptions")||{};Object.assign(e,t[this.getName()])},r._checkStackLen=function(){var e=this.getFromEnv("axesObArr"),t=0;return e&&e.forEach((function(e){t+=e.stack.length})),t},t._getZoomInfo=function(e,t,r){var n={startIndex:Math.ceil(e),endIndex:Math.floor(t)};return r.getLabel&&(n.startLabel=r.getLabel(n.startIndex).label,n.endLabel=r.getLabel(n.endIndex).label),n},r._raiseZoomEvents=function(e,t,r,n){var a=this.getFromEnv("chart");e&&this.fireEvent(e),t&&a.fireChartInstanceEvent(t,r,n),t&&a.fireChartInstanceEvent("zoomed",r,n)},r.getType=function(){return"canvasInput"},r.enable=function(e){!0!==this.config.enabled&&(this.config.enabled=!0,e&&this.fireEvent(e),this.setControl())},r.disable=function(e){!1!==this.config.enabled&&(this.config.enabled=!1,e&&this.fireEvent(e),this.setControl())},r.toggle=function(e){this.isEnabled()?this.disable(e):this.enable(e)},r.isEnabled=function(){return this.config.enabled},r.setControl=function(){var e=this.getLinkedItem("button");e&&e.setCurrentState(this.isEnabled()?this.config.state:"disabled")},r.createButton=function(e){var t,r=this.getLinkedParent().getFromEnv("chart");for(var n in(t=r.getFromEnv("toolbar").attachChild(o.Tool,"tool",this.getId())).configure(Object.assign({},r.getFromEnv("tool-config"),{name:e.icon,tooltext:e.tooltext})),e.handlers)e.handlers.hasOwnProperty(n)&&t.addEventListener("fc-"+n,e.handlers[n]);return t.setLinkedItem("input",this),t},t}(i.ComponentInterface);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0;var a=r(364);t.ScrollBar=a.ScrollBar,t.Checkbox=a.Checkbox,t.Hamburger=a.Hamburger,t.Label=a.Label,t.MenuItemContainer=a.MenuItemContainer,t.Tool=a.Tool;var i=n(r(378));t.ToolBar=i["default"]},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0;var a=n(r(365));t.ScrollBar=a["default"];var i=n(r(372));t.Checkbox=i["default"];var o=n(r(373));t.Hamburger=o["default"];var s=n(r(376));t.Label=s["default"];var l=n(r(377));t.Separator=l["default"];var c=n(r(374));t.MenuItemContainer=c["default"];var u=n(r(367));t.Tool=u["default"]},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=n(r(366)),s=n(r(367)),l=n(r(369)),c=n(r(370)),u=n(r(371)),d=r(368),f=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.scale=1},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.config,n=this.getFromEnv("chart-attrib");r.conf={},r.isOpposite=t&&!t.isHorizontal?(0,o["default"])(n.scrollposition,"right"):(0,o["default"])(n.scrollposition,"top"),r.color=n.scrollcolor&&(0,i.convertColor)(n.scrollcolor),r.padding=(0,i.pluckNumber)(n.scrollpadding,0),r.height=(0,i.pluckNumber)(n.scrollheight,12),r.width=(0,i.pluckNumber)(n.scrollwidth,12),r.displayFlat=(0,i.pluckNumber)(n.flatscrollbars,0),r.scrollBar3DLighting=(0,i.pluckNumber)(n.scrollbar3dlighting,1),r.startPercent=Math.min(1,Math.max(0,parseFloat(n.scrolltoend)||0)),r.showButtons=!!(0,i.pluckNumber)(n.scrollshowbuttons,1),r.buttonPadding=(0,i.pluckNumber)(n.scrollbtnpadding,0),r.style=t.style,r.drawStripes=t.drawStripes,r.restrictScrollAnchor=(0,i.pluckNumber)(t.restrictScrollAnchor,1),this.setConfiguaration(t),r.evt={tooltext:void 0,click:i.stubFN,hover:[i.stubFN,i.stubFN]},this.createScrollItems()},r.createScrollItems=function(){var e=this.config,t=e.style||{},r=this.getChildren("scrollTrack")&&this.getChildren("scrollTrack")[0],n=this.getChildren("scrollAnchor")&&this.getChildren("scrollAnchor")[0],a=this.getChildren("scrollButtons")&&this.getChildren("scrollButtons")[0],i=this.getChildren("scrollButtons")&&this.getChildren("scrollButtons")[0];r||((r=this.attachChild(l["default"],"scrollTrack")).configure({style:{track:t.track},color:e.color,displayFlat:e.displayFlat,isHorizontal:e.isHorizontal}),r.attachEventHandlers()),n||((n=this.attachChild(c["default"],"scrollAnchor")).configure({style:{scroller:t.scroller,grip:t.grip},drawStripes:e.drawStripes,color:e.color,displayFlat:e.displayFlat,isHorizontal:e.isHorizontal}),n.attachEventHandlers()),!a&&e.showButtons&&((a=this.attachChild(u["default"],"scrollStartButton")).configure({type:"start",color:e.color,style:{button:t.button,arrow:t.arrow}}),a.attachEventHandlers()),!i&&e.showButtons&&((i=this.attachChild(u["default"],"scrollEndButton")).configure({type:"end",color:e.color,style:{button:t.button,arrow:t.arrow}}),i.attachEventHandlers())},r.getName=function(){return"scrollbar"},r.getType=function(){return"scrollbar"},r.setConfiguaration=function(e){var t=this.config;t.color||(t.color="#"+this.getFromEnv("chart").getFromEnv("color-manager").getColor("altHGridColor")),(0,d.mergeConf)(e,t)},r.getLogicalSpace=function(){var t=this.config,r=t.conf,n={};return(0,d.mergeConf)(t,n),(0,d.mergeConf)(n,r),e.prototype.getLogicalSpace.call(this)},r.setDimension=function(t){e.prototype.setDimension.call(this,t);var r=this.getLinkedParent(),n=r.getPosition&&r.getPosition()||{},a=this.getChildren("scrollTrack")[0].config;a.transLateX=n.x||0,a.transLateY=n.y||0},r.draw=function(){var e=this.config,t={};e.conf.isHorizontal?delete t.width:delete t.height,(0,d.mergeConf)(t,e,!0),this.addGraphicalElement({el:"group",attr:{name:"scrollContainer"},component:this,container:{id:"scrollbarContainer",label:"scrollbar",isParent:!0},label:"scrollbarGroup",id:"scrollbarGroup"})},r.attachEventHandlers=function(e){var t=this.config.evt;return e&&(e.scroll&&"function"==typeof e.scroll&&(t.scroll=e.scroll),e.scrollStart&&"function"==typeof e.scrollStart&&(t.scrollStart=e.scrollStart),e.scrollEnd&&"function"==typeof e.scrollEnd&&(t.scrollEnd=e.scrollEnd)),this},t}(s["default"]);f.registerSymbol=void 0,f._setConfiguaration=i.stubFN;var h=f;t["default"]=h},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]=function(e,t){return String(e).toLowerCase()===String(t).toLowerCase()}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=r(368),l=function(e){function t(t){var r;return(r=e.call(this,t)||this)._listeners={},r}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"button"},r.getType=function(){return"tool"},r.__setDefaultConfig=function(){var e=this.config;e.scale=1.15,e.width=o.touchEnabled?20:15,e.height=o.touchEnabled?20:15,e.radius=o.touchEnabled?4:2,e.spacing=2.5,e.marginTop=2.5,e.marginLeft=2.5,e.marginRight=2.5,e.marginBottom=2.5,e.fill="ffffff",e.fillAlpha="cccccc",e.symbolFill="ffffff",e.stroke="bbbbbb",e.symbolStroke="9a9a9a",e.strokeWidth=1,e.symbolStrokeWidth=1,e.symbolPadding=5,e.symbolHPadding=5,e.symbolVPadding=5,e.fillAlpha=100,e.stateStyle={},e.text=o.BLANKSTRING,e.marginTop=e.marginLeft=e.marginRight=e.marginBottom=2.5,e.labelFontSize=12},r.configureAttributes=function(e){void 0===e&&(e={});var t,r,n,a=this.config,i=function(e){for(var t in e)if(e.hasOwnProperty(t)){var r=e[t];(r===o.UNDEF||!/tooltext/.test(t)&&""===r)&&delete e[t]}return e}(e);Object.assign(a,i),a.symbolName=a.name,this.setState("visible",!0!==a.isHidden),a.marginTop=(0,o.pluckNumber)(i.marginTop,i.spacing,a.marginTop),a.marginLeft=(0,o.pluckNumber)(i.marginLeft,i.spacing,a.marginLeft),a.marginRight=(0,o.pluckNumber)(i.marginRight,i.spacing,a.marginRight),a.marginBottom=(0,o.pluckNumber)(i.marginBottom,i.spacing,a.marginBottom),a.fill=(0,o.pluck)(i.fill,a.fill),a.fillAlpha=(0,o.pluckNumber)(i.fillAlpha,a.fillAlpha),a.labelFill=(0,o.pluck)(i.labelFill,a.labelFill),a.symbolFill=(0,o.pluck)(i.symbolFill,a.symbolFill),a.hoverFill=(0,o.pluck)(i.hoverFill,a.hoverFill),a.stroke=(0,o.pluck)(i.stroke,a.stroke),a.symbolStroke=(0,o.pluck)(i.symbolStroke,a.symbolStroke),a.strokeWidth=(0,o.pluckNumber)(i.strokeWidth,a.strokeWidth),a.symbolStrokeWidth=(0,o.pluckNumber)(i.symbolStrokeWidth,a.symbolStrokeWidth),t=a.symbolPadding=(0,o.pluckNumber)(i.symbolPadding,a.symbolPadding),a.symbolHPadding=(0,o.pluckNumber)(i.symbolHPadding,t),a.symbolVPadding=(0,o.pluckNumber)(i.symbolVPadding,t),a.hAlign=(0,o.pluck)(i.hAlign,"center").toLowerCase(),a.vAlign=(0,o.pluck)(i.vAlign,"middle").toLowerCase(),a.containerInfo=i.containerInfo||{id:"group",label:"group",isParent:!0},r=i.x,n=i.y,void 0===r||void 0===n?a.spaceNotHardCoded=!0:(a.x=r,a.y=n,a.spaceNotHardCoded=!1)},r.setDimension=function(e){void 0===e&&(e={});var t=this.config;e.x!==o.UNDEF&&(t.x=e.x),e.y!==o.UNDEF&&(t.y=e.y),e.width!==o.UNDEF&&(t.width=e.width),e.height!==o.UNDEF&&(t.height=e.height)},r.getAlignment=function(){return{hAlign:this.config.hAlign,vAlign:this.config.vAlign}},r.getLogicalSpace=function(){var e=this.config,t=e.width,r=e.height,n=e.marginTop,a=e.marginLeft,i=e.marginRight,o=e.marginBottom,s=e.scale;return t*=s,r*=s,(this.config.skipGraphics||this.getState("removed"))&&(t=r=o=a=i=n=0),{width:t,height:r,marginTop:n,marginLeft:a,marginRight:i,marginBottom:o}},r.setCurrentState=function(e){this.config.state=e,this.asyncDraw()},r.getCurrentState=function(){return this.config.state},r.draw=function(){var e,t,r,n=this.config,a=n,i=n.text,l=this.getFromEnv("tool-config");n.skipGraphics||(t={width:n.width*n.scale,height:n.height*n.scale,r:n.radius*n.scale,verticalPadding:n.symbolVPadding*n.scale,horizontalPadding:n.symbolHPadding},e=(0,o.extend2)({},n.stateStyle[n.state]||s.preConfig[n.state]||{}),"activated"!==n.state&&"disabled"!==n.state&&"pressed"!==n.state||(e.config.normal.fill=(0,o.convertColor)((0,o.pluck)(l.fill,e.config.normal.fill)),e.config.normal["symbol-stroke"]=(0,o.convertColor)((0,o.pluck)(l.symbolStroke,e.config.normal["symbol-stroke"])),e.config.normal.symbolFill=(0,o.convertColor)((0,o.pluck)(l.symbolFill,e.config.normal.symbolFill)),e.config.normal.stroke=(0,o.convertColor)((0,o.pluck)(l.stroke,e.config.normal.stroke)),e.config.normal.symbolStroke=(0,o.convertColor)((0,o.pluck)(l.symbolStroke,e.config.normal.symbolStroke)),e.config.hover.fill=(0,o.convertColor)((0,o.pluck)(l.hoverFill,e.config.hover.fill))),(r=(0,o.extend2)({button:[n.x,n.y,i,n.symbolName,t,n.labelFontSize,n.labelFontFamily],"button-label":i,"button-padding":[n.symbolHPadding,n.symbolVPadding*n.scale],"button-repaint":[a.x,a.y,n.width*n.scale,n.height*n.scale,n.radius*n.scale],fill:(0,o.convertColor)(n.fill),labelFill:(0,o.convertColor)(n.labelFill),symbolFill:(0,o.convertColor)(n.symbolFill),hoverFill:n.hoverFill,stroke:(0,o.convertColor)(n.stroke),"symbol-stroke":(0,o.convertColor)(n.symbolStroke||n.stroke),"stroke-width":n.strokeWidth,"symbol-stroke-width":(0,o.pluckNumber)(n.symbolStrokeWidth,n.strokeWidth)},e)).fill=(0,o.convertColor)((0,o.pluck)(n.fill,e.fill)),!n.isHidden&&this.addGraphicalElement({el:"button",attr:r,css:n.btnTextStyle,component:this,container:n.containerInfo,label:"button",id:"button",tooltext:n.tooltext}))},r.hide=function(){this.config.isHidden=!0,this.setState("visible",!1),this.asyncDraw()},r.show=function(){this.config.isHidden=!1,this.setState("visible",!0),this.asyncDraw()},t}(i.SmartRenderer);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.getEventHandlersFor=function(e,t){var r=function(){a["default"].listen(t,"mousemove",(function(e){e.originalEvent.stopPropagation()}))};switch(e){case"click":return function(e){a["default"].listen(t,"click",(function(t){t.target&&t.target.parentNode&&e.call(t.target)})),r()};case"hover":return function(e,n){a["default"].listen(t,"pointerhover",(function(t){t.target&&t.target.parentNode&&("start"===t.state?e:n).call(t.target)})),r()}}},t.mergeConf=function(e,t,r){var n,a;for(n in e)if((a=e[n])!==o.UNDEF&&null!==a)if(r){if(t[n])continue;t[n]=a}else t[n]=a},t.bottomPath=function(e,t,r,n,a){var i=e,o=t,s=n/2,l=Math.round(a/4+1),c=o+l+3;return["M",i-s,c,"L",i+s,c]},t.RSymbolFns=t.defaultTextStyle=t.SymbolStore=t.preConfig=t.DEFAULT_TIMEOUT=t.CLICK=t.HOVER=void 0;var a=n(r(226)),i=r(232),o=r(224),s={activated:{config:{hover:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff","stroke-width":1,stroke:"#aaaaaa","symbol-stroke":"#aaaaaa",cursor:"pointer"},normal:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff",stroke:"#c2c2c2","symbol-stroke":"#c2c2c2","stroke-width":1,cursor:"pointer"},disable:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff","stroke-width":1,stroke:"#e3e3e3","symbol-stroke":"#e3e3e3","stroke-opacity":1,cursor:"pointer"},pressed:{fill:"#efefef",labelFill:"#efefef",symbolFill:"#efefef",hoverFill:"#efefef","fill-symbol":"#efefef","stroke-width":1,stroke:"#c2c2c2","symbol-stroke":"#c2c2c2",cursor:"pointer"}},"button-disabled":!1,fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff",stroke:"#c2c2c2","symbol-stroke":"#c2c2c2","stroke-opacity":1,cursor:"pointer"},disabled:{config:{hover:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff","stroke-width":1,stroke:"#e3e3e3","symbol-stroke":"#e3e3e3",cursor:"default"},normal:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff",stroke:"#e3e3e3","symbol-stroke":"#e3e3e3","stroke-width":1,cursor:"default"},disable:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff","stroke-width":1,stroke:"#e3e3e3","symbol-stroke":"#e3e3e3","stroke-opacity":1,cursor:"default"},pressed:{fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","fill-symbol":"#ffffff","stroke-width":1,stroke:"#e3e3e3","symbol-stroke":"#e3e3e3",cursor:"default"}},fill:"#ffffff",labelFill:"#ffffff",symbolFill:"#ffffff",hoverFill:"#ffffff","button-disabled":!1,stroke:"#e3e3e3","symbol-stroke":"#e3e3e3","stroke-opacity":1,cursor:"default"},pressed:{config:{hover:{fill:"#dcdcdc",labelFill:"#dcdcdc",symbolFill:"#ffffff",hoverFill:"#dcdcdc","fill-symbol":"#ffffff","stroke-width":1,stroke:"#b7b7b7","symbol-stroke":"#b7b7b7",cursor:"pointer"},normal:{fill:"#dcdcdc",labelFill:"#dcdcdc",symbolFill:"#ffffff",hoverFill:"#dcdcdc","fill-symbol":"#ffffff","stroke-width":1,stroke:"#b7b7b7","symbol-stroke":"#b7b7b7",cursor:"pointer"},pressed:{fill:"#dcdcdc",labelFill:"#dcdcdc",symbolFill:"#ffffff",hoverFill:"#dcdcdc","fill-symbol":"#ffffff","stroke-width":1,stroke:"#b7b7b7","symbol-stroke":"#b7b7b7",cursor:"pointer"}},fill:"#dcdcdc",labelFill:"#dcdcdc",symbolFill:"#ffffff",hoverFill:"#dcdcdc","fill-symbol":"#ffffff","stroke-width":1,stroke:"#b7b7b7","symbol-stroke":"#b7b7b7",cursor:"pointer"}};t.preConfig=s,t.CLICK="click",t.HOVER="hover",t.DEFAULT_TIMEOUT=300;var l=(0,i.getDep)("redraphael","plugin"),c={CB_NOT_CHECKED:function(e,t,r){return["M",e-r,t-r]},CB_CHECKED:function(e,t,r){var n=r/4;return["M",e-3*n,t,"L",e-n,t+r,e+r,t-r]}},u=(l.addSymbol("Internal_CB",c.CB_NOT_CHECKED),{register:function(){var e,t,r,n;if(1===arguments.length){if(null===(r=arguments[0])&&r===o.UNDEF||"object"!=typeof r)return;n=r}else{if(!(arguments.length>1))return;if(t=arguments[1],"string"!=typeof(e=arguments[0])||"function"!=typeof t)return;(n={})[e]=t}for(e in n)t=n[e],{}.hasOwnProperty.call(n,e)&&l.addSymbol(e,t)}});t.defaultTextStyle={fill:"#555555",labelFill:"#555555",symbolFill:"#555555",hoverFill:"#555555",fontFamily:"Verdana,sans",fontSize:"12px",fontStyle:"normal",fontWeight:"normal",lineHeight:"14.399999999999999px"},t.SymbolStore=u,t.RSymbolFns=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(232),s=r(236),l=r(224),c=(0,o.getDep)("redraphael","plugin"),u=Math.max,d=function(e){function t(){var t;return(t=e.call(this)||this)._evtHandlers={},t}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(e){void 0===e&&(e={}),this.config.style={track:Object.assign({},{fill:e.displayFlat&&e.color||[90*e.isHorizontal,c.tintshade(e.color,.15).rgba,e.color].join("-"),stroke:c.tintshade(e.color,-.75).rgba},e.style.track)}},r.attachEventHandlers=function(){var e,t,r,n,a,i=this,o=i.config,l=i.getLinkedParent(),c=l.config,u=function(){c.scrollPosition>1?(c.scrollPosition=1,t=!1):(c.scrollPosition<0||isNaN(c.scrollPosition))&&(c.scrollPosition=0,t=!1),n.asyncDraw(),"function"==typeof c.evt.scroll&&c.evt.scroll(c.scrollPosition)},d=function h(){c.scrollPosition+=.01,r>=c.scrollPosition&&t&&(u(),i.addJob("dragScrollAnchorRight",h,s.priorityList.draw))},f=function g(){c.scrollPosition-=.01,r<=c.scrollPosition&&t&&(u(),i.addJob("dragScrollAnchorLeft",g,s.priorityList.draw))};i.addEventListener("fc-mousedown",i._evtHandlers.mousedown||(i._evtHandlers.mousedown=function(u){n=l.getChildren("scrollAnchor")[0],a=n.config,t=!0,e=c.isHorizontal?u.originalEvent.layerX-(a._nodeDimensions.x+o.transLateX+a._nodeDimensions.width/2):u.originalEvent.layerY-(a._nodeDimensions.y+o.transLateY+a._nodeDimensions.height/2),(r=e/a.trackLength+c.scrollPosition)>=c.scrollPosition?i.addJob("dragScrollAnchorRight",d,s.priorityList.draw):i.addJob("dragScrollAnchorLeft",f,s.priorityList.draw)})),i.addEventListener("fc-mouseup",i._evtHandlers.mouseup||(i._evtHandlers.mouseup=function(){t=!1}))},r.draw=function(){var e=this.config,t=this.getLinkedParent().config,r=(0,l.crispBound)(t.x+.5,t.y+t.padding+.5,t.width-1,t.height-1,t.strokeWidth);this.addGraphicalElement({el:"rect",attr:{x:r.x,y:r.y,width:u(r.width,0),height:u(r.height,0),r:t.roundEdges?2:0,opacity:e.style.track.opacity},css:e.style.track,container:{id:"scrollbarGroup",label:"scrollbarGroup",isParent:!0},component:this,label:"scrollbarTrack",id:"scrollbarTrack"})},t}(i["default"]);t["default"]=d},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(224),s=(0,r(232).getDep)("redraphael","plugin"),l=function(e){function t(){var t;return(t=e.call(this)||this)._evtHandlers={},t}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(e){void 0===e&&(e={});var t=this.config;t.drawStripes=(0,o.pluckNumber)(e.drawStripes,0),t._nodeDimensions={},t.style={scroller:Object.assign({},{fill:e.displayFlat&&s.tintshade(e.color,-.6).rgba||[270*e.isHorizontal,s.tintshade(e.color,.3).rgba+":40",s.tintshade(e.color,-.7).rgba].join("-"),stroke:s.tintshade(e.color,-.6).rgba},e.style.scroller),grip:Object.assign({},{stroke:"#5F5F5F","stroke-linecap":"round","stroke-width":2},e.style.grip)}},r.attachEventHandlers=function(){var e,t,r,n=this,a=this.getLinkedParent().config,i=a.isHorizontal;n.addEventListener("fc-dragmove",n._evtHandlers.dragmove||(n._evtHandlers.dragmove=function(i){(r=e+i.originalEvent.data[t]/this.config.trackLength)>=1?r=1:(r<=0||isNaN(r))&&(r=0),a.scrollPosition=r,n.asyncDraw(),"function"==typeof a.evt.scroll&&a.evt.scroll(a.scrollPosition)})),n.addEventListener("fc-dragstart",n._evtHandlers.dragstart||(n._evtHandlers.dragstart=function(){t=i?0:1,e=a.scrollPosition,"function"==typeof a.evt.scrollStart&&a.evt.scrollStart(a.scrollPosition)})),n.addEventListener("fc-dragend",n._evtHandlers.dragend||(n._evtHandlers.dragend=function(){"function"==typeof a.evt.scrollEnd&&a.evt.scrollEnd(a.scrollPosition)}))},r.draw=function(){var e,t,r=this.config,n=this.getLinkedParent().config,a=n.x+.5,i=n.y+n.padding+.5,s=n.width-1,l=n.height-1<1?1:n.height-1,c=n.restrictScrollAnchor?Math.max(n.scrollRatio,.01):n.scrollRatio,u=n.isHorizontal,d=(0,o.pluckNumber)(n.scrollPosition,n.startPercent,0),f=0,h=u?s*c:l*c;d>=1?d=1:(d<=0||isNaN(d))&&(d=0),n.showButtons&&(h-=2*(f=u?Math.min(l,.5*s):Math.min(s,.5*l))*c),r.trackLength=e=u?s-2*f-h:l-2*f-h,r.trackOffset=t=u?a+f+.5:i+f+.5,r._nodeDimensions={x:u?t+e*d:a,y:u?i:t+e*d,width:u?h-1<1?1:h-1:s<1?1:s,height:u?l<1?1:l:h-1<1?1:h-1},this.addGraphicalElement({el:"rect",attr:{x:r._nodeDimensions.x,y:r._nodeDimensions.y,width:r._nodeDimensions.width,height:r._nodeDimensions.height,r:n.roundEdges?2:0,opacity:r.style.scroller.opacity},css:r.style.scroller,container:{id:"scrollbarGroup",label:"scrollbarGroup",isParent:!0},component:this,label:"scrollbarAnchor",id:"scrollbarAnchor"}),r.drawStripes&&r._nodeDimensions.width>=8&&this.addGraphicalElement({el:"path",attr:{path:["M",r._nodeDimensions.x+r._nodeDimensions.width/2-3,r._nodeDimensions.y+.2*r._nodeDimensions.height,"v",.6*r._nodeDimensions.height,"m",3,-.6*r._nodeDimensions.height,"v",.6*r._nodeDimensions.height,"m",3,-.6*r._nodeDimensions.height,"v",.6*r._nodeDimensions.height],opacity:r.style.grip.opacity},css:r.style.grip,container:{id:"scrollbarGroup",label:"scrollbarGroup",isParent:!0},component:this,label:"scrollbarAnchorStripe",id:"scrollbarAnchorStripe"})},t}(i["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(232),s=r(224),l=r(236),c=(0,o.getDep)("redraphael","plugin"),u=function(e){function t(){var t;return(t=e.call(this)||this)._evtHandlers={},t}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(e){void 0===e&&(e={});var t=this.config;t.type=e.type,t.style={button:Object.assign({},{fill:s.TRACKER_FILL,stroke:"none"},e.style.button),arrow:Object.assign({},{fill:c.tintshade(e.color,-.4).rgba,stroke:"none"},e.style.arrow)}},r.attachEventHandlers=function(){var e,t,r=this,n=r.config,a=r.getLinkedParent(),i=a.config,o=a.getChildren("scrollAnchor")[0],s=function(){i.scrollPosition>=1?i.scrollPosition=1:(i.scrollPosition<=0||isNaN(i.scrollPosition))&&(i.scrollPosition=0),o.asyncDraw(),"function"==typeof i.evt.scroll&&i.evt.scroll(i.scrollPosition)},c=function u(){t=!0,"start"===n.type?i.scrollPosition-=.01:i.scrollPosition+=.01,s(),r.addJob("dragScrollAnchor",u,l.priorityList.draw)};r.addEventListener("fc-mousedown",r._evtHandlers.mousedown||(r._evtHandlers.mousedown=function(){e=setTimeout((function(){r.addJob("dragScrollAnchor",c,l.priorityList.draw)}),300)})),r.addEventListener("fc-mouseup",r._evtHandlers.mouseup||(r._evtHandlers.mouseup=function(){clearTimeout(e),r.removeJob("dragScrollAnchor"),t||("start"===n.type?i.scrollPosition-=.1:i.scrollPosition+=.1,s()),t=!1})),r.addEventListener("fc-mouseout",(function(){t&&r._evtHandlers.mouseup()}))},r.draw=function(){var e=this.config,t=this.getLinkedParent().config,r={id:"scrollbarGroup",label:"scrollbarGroup",isParent:!0},n=t.isHorizontal,a=t.x+.5,i=t.y+t.padding+.5,o=t.width-1<1?1:t.width-1,l=t.height-1<1?1:t.height-1,c=n?Math.min(l,.5*o):Math.min(o,.5*l),u=n?(0,s.polyPathToPath)([3,a+.5*c,i+.5*l,.25*c,180]):(0,s.polyPathToPath)([3,a+.5*o,i+.5*c,.25*c,90]),d=n?(0,s.polyPathToPath)([3,a+o-.5*c,i+.5*c,.25*c,0]):(0,s.polyPathToPath)([3,a+.5*o,i+l-.5*c,.25*c,-90]);this.addGraphicalElement({el:"rect",attr:{x:"start"===e.type?a:n?a+o-c:a,y:"start"===e.type||n?i:i+l-c,width:(e.type,n?c:o),height:(e.type,n?l:c),opacity:e.style.button.opacity},css:e.style.button,container:r,component:this,label:"scrollbar"+e.type+"ButtonRect",id:"scrollbar"+e.type+"ButtonRect"}),this.addGraphicalElement({el:"path",attr:{path:"start"===e.type?u:d,opacity:e.style.arrow.opacity},css:e.style.arrow,container:r,component:this,label:"scrollbar"+e.type+"ButtonPath",id:"scrollbar"+e.type+"ButtonPath"})},t}(i["default"]);t["default"]=u},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(224),s=r(368),l=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.config;r.checked=!!t.isChecked,r.interPadding=3,r.symbolName="Internal_CB",r.text=(0,o.pluck)(t.text,""),r.textStyle=s.defaultTextStyle},r.check=function(){this.config.checked=!0,this.asyncDraw()},r.uncheck=function(){this.config.checked=!1,this.asyncDraw()},r.toggle=function(){this.config.checked?this.uncheck():this.check()},r.getContainer=function(){return this.getFromEnv("chart").getChildContainer("buttonGroup")},r.draw=function(){this.config.checked?s.SymbolStore.register("Internal_CB",s.RSymbolFns.CB_CHECKED):s.SymbolStore.register("Internal_CB",s.RSymbolFns.CB_NOT_CHECKED),e.prototype.draw.call(this)},t}(i["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(224),s=n(r(374)),l=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.config,n=this.getFromEnv("dataSource").chart;r.baseFontFamily=(0,o.pluck)(t.baseFontFamily,n.basefont,"Verdana,sans"),r.baseFontSize=(0,o.pluckNumber)(t.baseFontSize,n.basefontsize,10),r.baseFontSize=this.computeFontSize((0,o.pluckFontSizeMaintainUnit)(t.baseFontSize,n.basefontsize,10)),r.baseFontColor=(0,o.pluck)(t.baseFontColor,n.basefontcolor,"595959"),r.skipGraphics=!0,this.createListContainer()},r.createListContainer=function(){this.attachChild(s["default"],"listContainer","listContainer").configure()},r.appendInMenu=function(e){void 0===e&&(e=[]);var t,r,n=this.getChild("listContainer");for(r=e.length,t=0;t<r;t++)n.addItem(e[t]);this.config.skipGraphics=!1},t}(i["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=n(r(375)),l=r(368),c=r(232);function u(e,t){var r,n,a,i;if(void 0===t&&(t={}),(n=e.attachChild(s["default"],"item",t.id)).configure(t),t.menu instanceof Array&&(i=t.menu.length))for(r=n.attachChild(d,"subContainer","subContainer"),e.config.hasSubMenu=!0,r.configure(),a=0;a<i;a++)r.addItem(t.menu[a])}(0,c.addDep)({name:"manuItemContainerAnimation",type:"animationRule",extension:{"*.menuItemContainer.menuItemContainer":null}});var d=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(){var e=this.config;this.setStyle(),e.counter=0,e.hasSubMenu=!1,e._defaultStyle={position:"absolute","z-index":50,top:0+o.PXSTRING,right:"auto",left:"auto",overflow:"hidden",background:"#ffffff",border:"1px solid #646464","box-shadow":"#999999 2px 2px 5px",padding:"5px 3px",display:"none"}},r.setStyle=function(e){void 0===e&&(e={});var t=this.config;t.hoverOverStyle=e.hoverOverStyle||{background:"#333333",color:"#FFFFFF",cursor:o.POINTER},t.hoverOutStyle=e.hoverOutStyle||{background:"#FFFFFF",color:"#000000"}},r.show=function(){var e=this.getLinkedParent().config,t=(0,o.pluckNumber)(e.scale,1.5),r=e.x,n=e.y,a=e.width*t,i=e.height*t,s=+this.getFromEnv("chart").getFromEnv("chartWidth"),l=this.getGraphicalElement("menu","menu").element,c=l.style;clearTimeout(this.config.hideTimer),c.display="block",l.offsetWidth+r>s?(c.left="auto",c.right=s-r-a+o.PXSTRING):(c.left=r+o.PXSTRING,c.right="auto"),c.top=n+i+5+o.PXSTRING,c.bottom="auto",c.display="block"},r.hide=function(e){void 0===e&&(e={});var t,r=this.getGraphicalElement("menu","menu").element;e.instant?r.style.display="none":(t=(0,o.pluckNumber)(e.timeout,l.DEFAULT_TIMEOUT),this.config.hideTimer=setTimeout((function(){r.style.display="none"}),t))},r.addItem=function(e){void 0===e&&(e={}),u(this,e)},r.draw=function(){this.addGraphicalElement({el:"html",attr:{type:"div"},css:this.config._defaultStyle,component:this,label:"menu",id:"menu"}),this.addEventListener("fc-mouseover",this.show),this.addEventListener("fc-mouseout",this.hide)},r.getName=function(){return"menuItemContainer"},r.getType=function(){return"menuItemContainer"},t}(i.SmartRenderer),f=d;t["default"]=f},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(224),o=r(368),s=r(240);(0,r(232).addDep)({name:"manuItemAnimation",type:"animationRule",extension:{"*.menuItem.menuItem":null}});var l=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(e){void 0===e&&(e={});var t=this.config,r=this.getLinkedParent().getLinkedParent().config;t.name=e.name,t.action=e.action&&e.action.toLowerCase()||o.CLICK,t.eventMap={},t.style={padding:"3px 8px",fontFamily:r.baseFontFamily,fontSize:r.baseFontSize+i.PXSTRING,color:"#000000",position:"static",display:"inline",float:"left",background:"#FFFFFF"},t.pointerStyle={padding:"0px 4px 3px",fontFamily:r.baseFontFamily,fontSize:r.baseFontSize+3+i.PXSTRING,color:"#000000",position:"static",float:"left"},t.itemType=e.menu instanceof Array&&e.menu.length?"subMenu":"item","item"===t.itemType?t.handler=e.handler||i.stubFN:t.handler=i.stubFN,t.hoverOverStyle=e.hoverOverStyle||{},t.hoverOutStyle=e.hoverOutStyle||{}},r.applyStyle=function(e){void 0===e&&(e="mouseover");var t=this.getLinkedParent().config,r=this.getGraphicalElement("menuItem","menuItem"),n=this.getGraphicalElement("container","container"),a=this.getGraphicalElement("menuPointer","menuPointer");switch(e){case"mouseover":r.css(t.hoverOverStyle),n.css(t.hoverOverStyle),a&&a.css(t.hoverOverStyle);break;case"mouseout":r.css(t.hoverOutStyle),n.css(t.hoverOutStyle),a&&a.css(t.hoverOutStyle)}},r.draw=function(){var e=this,t=e.config,r=e.getLinkedParent();e.addGraphicalElement({el:"html",attr:{type:"div"},css:{display:"block",position:"static",overflow:"hidden",height:"100%",width:"100%",background:"#FFFFFF"},container:{id:"menu",label:"menu",isParent:!0},component:e,label:"container",id:"container"}),r.config.hasSubMenu&&e.addGraphicalElement({el:"html",attr:{type:"div",text:"◂"},css:t.pointerStyle,container:{id:"container",label:"container"},component:e,label:"menuPointer",id:"menuPointer"},!0),e.addGraphicalElement({el:"html",attr:{type:"span",text:t.name},css:t.style,container:{id:"container",label:"container"},component:e,label:"menuItem",id:"menuItem"},!0),e._mouseOverEvent||(e._mouseOverEvent=function(){e.applyStyle("mouseover")}),e._mouseOutEvent||(e._mouseOutEvent=function(){e.applyStyle("mouseout")}),e._clickEvent||(e._clickEvent=function(){"item"===e.config.itemType&&(r.hide({instant:!0}),t.handler())}),e.addEventListener("fc-mouseover",e._mouseOverEvent),e.addEventListener("fc-mouseout",e._mouseOutEvent),e.addEventListener("fc-click",e._clickEvent)},r.getName=function(){return"menuItem"},r.getType=function(){return"menuItem"},t}(s.SmartRenderer);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(224),s={left:"start",right:"end",center:"middle"},l={top:o.POSITION_TOP,middle:o.POSITION_MIDDLE,bottom:o.POSITION_BOTTOM},c={0:"0",1:"270",right:"90",cw:"90",left:"270",ccw:"270"},u=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.font="Verdana, sans",t.rotateText=0},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.config;r.font=(0,o.pluck)(t.font,r.font),r.fontSize=(0,o.pluckFontSize)(t["font-size"],t.fontSize,10)*r.scale,r.fontStyle=(0,o.pluck)(t["font-style"],t.fontStyle,"normal"),r.fontWeight=(0,o.pluck)(t["font-weight"],t.fontWeight,"normal"),r.rotateText=(0,o.pluckNumber)(t.rotateText,r.rotateText),r.rotateAngle=parseFloat(c[(0,o.pluck)(t.rotateAngle&&t.rotateAngle.toLowerCase(),"0")])},r.getTextBound=function(){var e=this.config,t=[];return e.showTextBound&&(t=[(0,o.convertColor)(e.fill),e.borderColor,e.borderThickness,2,e.radius]),t},r.getLogicalSpace=function(){var e,t=this.config,r=(t.width,t.height,t.marginTop),n=t.marginLeft,a=t.marginRight,i=t.marginBottom;return{width:(e=this.getFromEnv("smartLabel").getOriSize(this.config.text,!1)).width,height:e.height,marginTop:r,marginLeft:n,marginRight:a,marginBottom:i}},r.draw=function(){var e,t=this.config;t.text&&(e={x:t.x,y:t.y,text:t.text,fill:(0,o.convertColor)(t.labelFill),"text-bound":this.getTextBound(),"font-style":t.fontStyle,"font-weight":t.fontWeight,"font-family":t.font,"font-size":t.fontSize,"text-anchor":s[t.hAlign],"vertical-align":l[t.vAlign],transform:t.rotateText?(0,o.getSuggestiveRotation)(t.rotateAngle,t.x,t.y):"t0,0"},!t.isHidden&&this.addGraphicalElement({el:"text",attr:e,component:this,container:{id:"group",label:"group",isParent:!0},label:"text",id:"label"}))},t}(i["default"]);t["default"]=u},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(367)),o=r(224),s=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.isVertical=1},r.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var r=this.config;r.isVertical=(0,o.pluckNumber)(t.isVertical,r.isVertical)},r.draw=function(){var e=this.config,t=e.x,r=e.y,n=e.width,a=e.height,i={path:e.isVertical?["M",t+n/2,r,"v",a]:["M",t,r,"h",n],stroke:e.stroke,"stroke-width":e.strokeWidth,"stroke-linecap":"round"};!e.isHidden&&this.addGraphicalElement({el:"path",attr:i,component:this,container:{id:"group",label:"group",isParent:!0},css:e.css,label:"path",id:"path"})},t}(i["default"]);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=function(e){e.manageSpace&&e.manageSpace()},l=function(e){function t(t){var r;return(r=e.call(this,t)||this).props={},r}(0,a["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(e){void 0===e&&(e={});var t=this.config,r=this.getFromEnv("chartConfig");this.__setDefaultConfig(),this.props.width=(0,o.pluckNumber)(e.width,0),this.props.height=(0,o.pluckNumber)(e.height,0),t.orientation=(0,o.pluck)(e.toolbarorientation,t.orientation),t.hPadding=(0,o.pluck)(e.toolbarhpadding,t.hPadding),t.vPadding=(0,o.pluck)(e.toolbarvpadding,t.vPadding),t.backgroundcolor=(0,o.pluck)(e.toolbarbackgroundcolor,t.backgroundcolor),t.backgroundalpha=(0,o.pluck)(e.toolbarbackgroundalpha,t.backgroundalpha),t.bordercolor=(0,o.pluck)(e.toolbarbordercolor,t.bordercolor),t.borderalpha=(0,o.pluck)(e.toolbarborderalpha,t.borderalpha),t.borderthickness=(0,o.pluck)(e.toolbarborderthickness,t.borderthickness),t.hDirection=(0,o.pluckNumber)(e.toolbarhdirection,"r"===r.toolbarHAlign?-1:1),t.vDirection=(0,o.pluckNumber)(e.toolbarvdirection,"b"===r.toolbarBAlign?-1:1),t.hAlign=(0,o.pluck)(e.hAlign,"center").toLowerCase(),t.vAlign=(0,o.pluck)(e.vAlign,"middle").toLowerCase(),t.marginTop=(0,o.pluckNumber)(e.marginTop,e.spacing,t.marginTop),t.marginLeft=(0,o.pluckNumber)(e.marginLeft,e.spacing,t.marginLeft),t.marginRight=(0,o.pluckNumber)(e.marginRight,e.spacing,t.marginRight),t.marginBottom=(0,o.pluckNumber)(e.marginBottom,e.spacing,t.marginBottom)},r.__setDefaultConfig=function(){var e=this.config;e.orientation="horizontal",e.hPadding=0,e.vPadding=0,e.backgroundcolor="#eeeeee",e.backgroundalpha=0,e.bordercolor="#eeeeee",e.borderalpha=0,e.borderthickness=1,e.spacing=2.5,e.marginTop=2.5,e.marginLeft=2.5,e.marginRight=2.5,e.marginBottom=2.5},r.getLogicalSpace=function(){var e=this.config,t=this.props,r=0,n=0;return this.getChildren("tool")&&this.getChildren("tool").length&&(this.getChildren("tool").forEach((function(t){if(!t.getState("removed")){var a=t.getLogicalSpace(),i=a.width,s=a.height,l=a.marginTop,c=a.marginLeft,u=a.marginRight,d=a.marginBottom;"horizontal"===e.orientation?(i!==o.UNDEF&&(r+=i+(u||0)+(c||0)),n<(s=s+(l||0)+(d||0))&&(n=s)):(s!==o.UNDEF&&(n+=s+(l||0)+(d||0)),r<(i=i+(u||0)+(c||0))&&(r=i))}})),r+=2*e.hPadding,n+=2*e.vPadding,t.width=t.width>r?t.width:r,t.height=t.height>n?t.height:n),{width:r,height:n,marginTop:e.marginTop,marginLeft:e.marginLeft,marginRight:e.marginLeft,marginBottom:e.marginLeft}},r.manageSpace=function(){var e,t=this.getChildren("tool")||[];for(var r in e="horizontal"===this.config.orientation?this._placeToolHorizontally():this._placeToolVertically())e.hasOwnProperty(r)&&this.getChild(r).setDimension(e[r]);t.forEach(s)},r._placeToolHorizontally=function(){var e,t,r,n=this,a=n.config,i=n.props,o=a.hPadding,s=i.width-a.hPadding,l={},c={left:[],right:[],center:[]},u={left:0,right:0,center:0};return n.getChildren("tool")&&n.getChildren("tool").length&&((a.hDirection>0?n.getChildren("tool"):n.getChildren("tool").slice(0).reverse()).forEach((function(e){if(!e.getState("removed")){var t=e.getAlignment().hAlign,r=e.getLogicalSpace(),o=r.width,s=r.height,d=r.marginTop,f=r.marginLeft,h=r.marginRight,g=r.marginBottom,p=e.getId();u[t]+=o+(f||0)+(h||0),c[t].push(p),l[p]={},l[p].y=n.props.y+d+a.vPadding+(i.height-2*a.vPadding-(s+g+d))/2}})),c.left.forEach((function(e){var t=n.getChild(e).getLogicalSpace(),r=t.width,i=t.marginLeft,s=t.marginRight;o+=i||0,l[e].x=n.props.x+a.hPadding+o,o+=r+(s||0)})),c.right.reverse().forEach((function(e){var t=n.getChild(e).getLogicalSpace(),r=t.width,i=t.marginLeft,o=t.marginRight;s-=r+(o||0),l[e].x=n.props.x+a.hPadding+s,s-=i||0})),e=[u.left+a.hPadding,i.width-(u.right+a.hPadding)],t=Math.abs(e[0]-e[1]),r=e[0]+t/2-u.center/2,c.center.forEach((function(e){var t=n.getChild(e).getLogicalSpace(),i=t.width,o=t.marginLeft,s=t.marginRight;r+=o||0,l[e].x=n.props.x+a.hPadding+r,r+=i+s||0}))),l},r.getAlignment=function(){return{hAlign:this.config.hAlign,vAlign:this.config.vAlign}},r._placeToolVertically=function(){var e,t,r,n=this,a=n.config,i=n.props,o=a.vPadding,s=i.height-a.vPadding,l={top:[],middle:[],bottom:[]},c={top:0,middle:0,bottom:0},u={};return n.getChildren("tool")&&n.getChildren("tool").length&&((a.vDirection>0?n.getChildren("tool"):n.getChildren("tool").reverse()).forEach((function(e){if(!e.getState("removed")){var t=e.getAlignment().vAlign,r=e.getLogicalSpace(),o=r.width,s=r.height,d=r.marginTop,f=r.marginLeft,h=r.marginRight,g=r.marginBottom,p=e.getId();c[t]+=s+(d||0)+(g||0),l[t].push(e.getId()),u[p]={},u[p].x=n.props.x+f+a.hPadding+f+(i.width-2*a.hPadding-(o+f+h))/2}})),l.top.forEach((function(e){var t=n.getChild(e).getLogicalSpace(),r=t.height,i=t.marginTop,s=t.marginBottom;o+=i||0,u[e].y=n.props.y+a.vPadding+o,o+=r+(s||0)})),l.bottom.reverse().forEach((function(e){var t=n.getChild(e).getLogicalSpace(),r=t.height,i=t.marginTop,o=t.marginBottom;s-=r+(o||0),u[e].y=n.props.y+a.vPadding+s,s-=i||0})),e=[c.top+a.vPadding,i.height-(c.bottom+a.vPadding)],t=Math.abs(e[0]-e[1]),r=e[0]+t/2-c.middle/2,l.middle.forEach((function(e){var t=n.getChild(e).getLogicalSpace(),i=t.height,o=t.marginTop,s=t.marginBottom;r+=o||0,u[e].y=n.props.y+a.vPadding+r,r+=i+s||0}))),u},r.setDimension=function(e){void 0===e&&(e={}),e.x!==o.UNDEF&&(this.props.x=e.x),e.y!==o.UNDEF&&(this.props.y=e.y),e.width!==o.UNDEF&&(this.props.width=e.width),e.height!==o.UNDEF&&(this.props.height=e.height)},r.getDimension=function(){return this.props},r.draw=function(){var e=this.config;this.addGraphicalElement({id:"group",el:"group",attr:{name:"toolbar"},container:{id:"toolbar-master",isParent:!0},component:this,label:"group"}),this.addGraphicalElement({id:"carpet",el:"rect",attr:Object.assign({fill:(0,o.toRaphaelColor)({color:e.backgroundcolor,alpha:e.backgroundalpha}),stroke:(0,o.toRaphaelColor)({color:e.bordercolor,alpha:e.borderalpha}),"stroke-width":e.borderthickness},this.getDimension()),container:{label:"group",id:"group"},component:this,label:"carpet"})},r.getName=function(){return"toolbar"},r.getType=function(){return"Toolbar"},t}(i.SmartRenderer);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r._toggle=function(){r.isEnabled()&&r.zoomOut()},t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"zoomResetButton"},r.configure=function(){e.prototype.configure.call(this);var t=this.getLinkedParent();this.configureButton(),this.disable(),t.registerDependancy([{derivedInteraction:["zoomin","zoomout"],callback:this.dependancyFn,component:this}])},r.configureButton=function(){!this.config.skipGraphics&&this.setLinkedItem("button",this.createButton({icon:"resetIcon",handlers:{click:this._toggle},tooltext:this.config.tooltext,state:"disabled"})),this.disable()},r.enable=function(){this.config.state="activated",e.prototype.enable.call(this)},r.zoomOut=function(){var e,t,r,n,a,i,o,s=this,l=s.config.hookFn,c={};s.getFromEnv("axesObArr").forEach((function(u){e=s.getFromEnv("chart"),t=e.getChildren("scrollBar")&&e.getChildren("scrollBar")[0],(o=u.stack[0])&&(s.getFromEnv("chart").getFromEnv("animationManager").setAnimationState("zoomOut"),l&&l(o.minValue,o.maxValue),u.isY?(a=o.minValue,i=o.maxValue):(r=o.minValue,n=o.maxValue,c=s.constructor._getZoomInfo(r,n,u.axis)),u.axis.setVisibleConfig(o.minValue,o.maxValue),e.setScrollBarDimension&&e.setScrollBarDimension(),t&&!t.getState("removed")&&t.asyncDraw(),u.stack.length=0)})),s._raiseZoomEvents("zoomout","zoomreset",Object.assign(c,{level:1,startX:r,endX:n,startY:a,endY:i})),s.disable()},r.dependancyFn=function(e){"zoomin"===e.type?this.enable():"zoomout"===e.type&&(this._checkStackLen()||this.disable())},t}(o["default"]);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r._toggle=function(){r.isEnabled()&&r.zoomOut()},t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"zoomOutButton"},r.configureButton=function(){!this.config.skipGraphics&&this.setLinkedItem("button",this.createButton({icon:"zoomOutIcon",handlers:{click:this._toggle},tooltext:this.config.tooltext,state:"activated"}))},r.zoomOut=function(){var e,t,r,n,a,i,o,s,l=this,c=l.config.hookFn,u={},d=0;l.getFromEnv("axesObArr").forEach((function(f){e=l.getFromEnv("chart"),t=e.getChildren("scrollBar")&&e.getChildren("scrollBar")[0],r=f.stack.pop(),n=f.stack.length,d+=n,r&&(f.isY?(o=r.minValue,s=r.maxValue):(a=r.minValue,i=r.maxValue,u=l.constructor._getZoomInfo(a,i,f.axis)),c&&c(r.minValue,r.maxValue),f.axis.setVisibleConfig(r.minValue,r.maxValue),e.setScrollBarDimension&&e.setScrollBarDimension(),t&&!t.getState("removed")&&t.asyncDraw())})),l._raiseZoomEvents("zoomout","zoomedout",Object.assign(u,{level:n,startX:a,endX:i,startY:o,endY:s})),d||this.disable()},t}(n(r(379))["default"]);t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r._toggle=function(){r.isEnabled()&&r.zoom()},t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"zoomInButton"},r.configure=function(){e.prototype.configure.call(this);var t=this.config;t.stepZoom=t.stepZoom||5.33,!t.skipGraphics&&this.setLinkedItem("button",this.createButton({icon:"zoomInIcon",handlers:{click:this._toggle},tooltext:this.config.tooltext,state:"activated"})),this.enable()},r.zoom=function(){var e,t,r,n,a,i,o,s,l,c=this,u={},d=c.config,f=d.hookFn,h=!1,g=Math.pow(10,d.zoomDecimalLimit)||1;c.getFromEnv("animationManager").setAnimationState("zoom"),c.getFromEnv("axesObArr").forEach((function(p){r=p.axis,e=r.getVisibleConfig(),(t=Math.round((e.maxValue-e.minValue)/d.stepZoom*g)/g)>Number.EPSILON&&(p.stack.push(e),p.isY?(i=e.minValue+t,o=e.maxValue-t):(n=e.minValue+t,a=e.maxValue-t,u=c.constructor._getZoomInfo(n,a,r)),s=p.stack.length+1,f&&f(e.minValue,e.maxValue),l=r.setVisibleConfig(e.minValue+t,e.maxValue-t),h=h||l)})),h&&c._raiseZoomEvents("zoomin","zoomedin",Object.assign(u,{level:s,startX:n,endX:a,startY:i,endY:o}))},t}(n(r(362))["default"]);t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=r(224),l=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r.controlArr=[{nativeInteraction:["fc-dbclick"],callback:r.zoom.bind(r),component:r}],t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"dbTapZoom"},r.configure=function(){e.prototype.configure.call(this),this.enable()},r.setControl=function(){var e=this.controlArr,t=this.getLinkedParent();t.releaseControl(e),this.isEnabled()&&t.getControl(e)},r.zoom=function(e){var t,r,n,a,i,o,l,c,u,d,f=this,h=f.getFromEnv("chart"),g=(0,s.getMouseCoordinate)(h.getLinkedItem("container"),e,h),p=f.config,m=p.hookFn,v={},b=!1,y=Math.pow(10,p.zoomDecimalLimit)||1;h.getFromEnv("animationManager").setAnimationState("zoom"),f.getFromEnv("axesObArr").forEach((function(e){t=e.axis,r=t.getValue(e.isY?g.chartY:g.chartX),a=t.getVisibleConfig(),n=function(e,t,r,n){var a=t-e.minValue,i=e.maxValue-t;return{min:Math.round((t-a/r*(r-1))*n)/n,max:Math.round((t+i/r*(r-1))*n)/n}}(a,r,p.stepzoom,y),e.isY?(c=n.min,u=n.max):(o=n.min,l=n.max,v=f.constructor._getZoomInfo(o,l,t)),t.getZoom()<=y&&(m&&"function"==typeof p.hookFn&&m(n.min,n.max),i=t.setVisibleConfig(n.min,n.max),b=b||i,e.stack.push(a),d=e.stack.length+1)})),b&&f._raiseZoomEvents("zoomin","zoomedin",Object.assign(v,{level:d,startX:o,endX:l,startY:c,endY:u},e.originalEvent))},t}(o["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=r(224),l=r(236),c=r(232),u=Math,d=u.min,f=u.max,h=u.abs,g="rgba(255,0,0,"+(s.isIE?.002:1e-6)+")",p=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r.controlArr=[{nativeInteraction:["fc-dragstart"],callback:r.dragstart.bind(r),component:r},{nativeInteraction:["fc-dragmove"],callback:r.dragmove.bind(r),component:r},{nativeInteraction:["fc-dragend"],callback:r.dragend.bind(r),component:r}],r.toggle=r.toggle.bind(r),t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"dragPin"},r.configure=function(){e.prototype.configure.call(this);var t=this.getFromEnv("chartConfig"),r=this.getFromEnv("dataSource").chart,n=this.config;n.attr=n.attr||{stroke:"#3399ff",fill:"#b9d5f1","stroke-width":0},n.pinAttr=n.pinAttr||{"stroke-width":0,stroke:"none",fill:"#b9d5f1","shape-rendering":"crisp"},n.borderWidth=t.borderWidth||(t.borderWidth=(0,s.pluckNumber)(r.showborder,1)?(0,s.pluckNumber)(r.borderthickness,1):0),!this.config.skipGraphics&&this.setLinkedItem("button",this.createButton({icon:"pinModeIcon",tooltext:(0,s.pluckNumber)(r.showtoolbarbuttontooltext,1)?(0,s.pluck)(this.config.tooltext,"Pin mode"):"",handlers:{click:this.toggle},state:"activated"})),this.getLinkedParent().registerDependancy([{derivedInteraction:["zoomin","zoomout"],callback:this.dependancyFn,component:this}]),this.disable(void 0,!1)},r.enable=function(e,t){var r=this.config;!0!==r.enabled&&(r.enabled=!0,r.state="pressed",this.fireEvent("pinenabled"),this.setControl(),!t&&this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged",{pinModeActive:!0},e&&e.originalEvent))},r.dependancyFn=function(e){"zoomin"!==e.type&&"zoomout"!==e.type||this.disable(e)},r.draw=function(){var e,t=this,r=t.config;t.createPin(),t.config.pinElemVisible&&t.addJob("resizePinElem",(function(){e=t.getFromEnv("xAxis")[0],t.pinRangePixels(e.getPixel(r.boxStartValue),e.getPixel(r.boxEndValue))}),l.priorityList.postRender)},r._setConfig=function(){var e=this.getFromEnv("chart"),t=this.getFromEnv("chartConfig"),r=this.config,n=Object.assign({},r.attr||{}),a=n["stroke-width"]=(0,s.pluckNumber)(n.strokeWidth,n["stroke-width"],1),i=(0,s.getPosition)(e.getFromEnv("chart-container"),e);r.zoomX="horizontal"===r.orientation||"both"===r.orientation,r.zoomY="vertical"===r.orientation||"both"===r.orientation,r.canvasY=t.canvasTop,r.canvasX=t.canvasLeft,r.canvasW=t.canvasWidth,r.canvasH=t.canvasHeight,r.canvasX2=t.canvasLeft+t.canvasWidth,r.canvasY2=t.canvasTop+t.canvasHeight,r.strokeWidth=a,r.chartPosLeft=i.left,r.chartPosTop=i.top},r.disable=function(e,t){var r=this.config,n=this.getContainer("pingroup"),a=this.getGraphicalElement("pintracker");!1!==r.enabled&&(r.enabled=!1,r.state="activated",n&&n.hide(),a&&a.hide(),this.fireEvent("pindisabled"),!t&&this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged",{pinModeActive:!1},e&&e.originalEvent),this.setControl(),r.pinElemVisible=!1)},r.setControl=function(){var e=this.getLinkedParent(),t=this.controlArr,r=this.getLinkedItem("button");e.releaseControl(t),this.isEnabled()&&e.getControl(t),r&&r.setCurrentState(this.config.state)},r.createPin=function(){var e,t,r,n,a,i=this,o=i.getFromEnv("chart"),l=i.getFromEnv("chartConfig"),u=i.getFromEnv("animationManager"),d=l.canvasTop,f=l.canvasBottom,h=l.canvasHeight,p=l.canvasLeft,m=i.config.borderWidth,v=l["clip-pinrect"],b=i.getContainer("pingroup"),y=i.getContainer("pinElemGroup"),x=i.getGraphicalElement("pinrect"),w=i.getGraphicalElement("pintracker");n=l._visw=l.canvasWidth,a=l._visx=l.canvasLeft,e=(0,c.getDep)("redraphael","plugin").crispBound(0,d-f,0,h,m),v=l["clip-pinrect"]=[e.x,d,e.width,e.height],b||i.addContainer("pingroup",b=u.setAnimation({el:"group",finalAttr:{name:"zoompin"},component:i,label:"group"}).insertBefore(o.getChildContainer("plotGroup")).hide()),b.transform(l._pingrouptransform=["T",a,f]),y||i.addContainer("pinElemGroup",y=u.setAnimation({el:"group",attr:{name:"zoompinelements"},component:i,container:b,label:"group"})),i.config.pinAttr.x=0,i.config.pinAttr.y=d-f,i.config.pinAttr.width=n,i.config.pinAttr.height=h,t=u.setAnimation({el:x||"rect",attr:i.config.pinAttr,container:b,component:i}),x||i.addGraphicalElement("pinrect",t),r=u.setAnimation({el:w||"rect",attr:{transform:b.transform(),x:0,y:d-f,width:0,height:h,stroke:"none",fill:g,cursor:s.hasSVG?"ew-resize":"e-resize"},container:o.getChildContainer("trackerGroup"),component:i}).hide(),w||i.addGraphicalElement("pintracker",r),r.undrag(),r.drag((function(e){var t=e.data[0],n=a+t+this.__pindragdelta,o=this.__pinboundleft,l=this.__pinboundright,c=this.data("cliprect").slice(0);n<o?n=o:n>l&&(n=l),b.transform(["T",n,f]),r.transform(b.transform()),s.hasSVG||(c[0]=c[0]+n-a-this.__pindragdelta,u.setAnimation({el:b,attr:{"clip-rect":c},component:i})),this.__pindragoffset=t}),(function(){this.__pinboundleft=0-v[0]+a+p,this.__pinboundright=this.__pinboundleft+n-v[2],this.data("cliprect",b.attr("clip-rect")),b._.clipispath=!0}),(function(){b._.clipispath=!1,this.__pindragdelta+=this.__pindragoffset,delete this.__pindragoffset,delete this.__pinboundleft,delete this.__pinboundright}))},r.pinRangePixels=function(e,t,r){var n,a,i,o,s,l=this.getFromEnv("chart"),c=l.config,u=c.canvasLeft,d=this.getFromEnv("xAxis")[0],f=d.getLimit(),h=f.max,g=f.min,p=this.getContainer("pingroup"),m=c["clip-pinrect"],v=this.getFromEnv("animationManager"),b=c._pingrouptransform,y=[],x=t-e,w=this.getGraphicalElement("pintracker");if(l.iterateComponents((function(e){e.getType&&"dataset"===e.getType()&&y.push(e)})),p&&this.getGraphicalElement("pinrect")){for(e===t&&(p.hide(),w.hide()),s=y.length;s--;)y[s].fireEvent("createpinelements",{group:this.getContainer("pinElemGroup")});m[0]=e+u,m[2]=x,v.setAnimation({el:p,attr:{"clip-rect":m,transform:b},component:this}).show(),w.__pindragdelta=0,w.show(),v.setAnimation({el:w,attr:{transform:b,x:e,width:x},component:this}),this.config.pinElemVisible=!0,n=(n=Math.round(d.getValue(e+u,{wrtVisible:!0})))<g?g:n,a=(a=Math.round(d.getValue(t+u,{wrtVisible:!0})))>h?h:a,i=d.getLabel(n).label,o=d.getLabel(a).label,r&&l.fireChartInstanceEvent("pinned",{startIndex:n||Math.abs(n),endIndex:a||Math.abs(a),startLabel:i,endLabel:o},r.originalEvent)}},r.dragstart=function(e){this._setConfig();var t,r,n=this.getFromEnv("animationManager"),a=this.getFromEnv("chart-container"),i=this.config,o=i.attr,l=this.getGraphicalElement("resizeBox"),c=e.originalEvent,u=i.layerX=(c.pageX||c.data[0])-i.chartPosLeft,d=i.layerY=(c.pageY||c.data[1])-i.chartPosTop,f=i.canvasY,h=i.canvasX,g=i.canvasX2,p=i.canvasY2;t=(0,s.getPosition)(a),i.chartPosLeft=t.left,i.chartPosTop=t.top,i.oy=d,i.ox=u,i.allowMove=!1,o.x=0,o.y=0,o.width=0,o.height=0,r=n.setAnimation({el:l||"rect",attr:o,container:this.getFromEnv("chart").getChildContainer("trackerGroup"),component:this,callback:function(){this.show()}}),l||this.addGraphicalElement("resizeBox",r),u>h&&u<g&&d>f&&d<p&&(i.allowMove=!0),i.dragstartFn&&"function"==typeof i.dragstartFn&&i.dragstartFn(e)},r.dragmove=function(e){this._setConfig();var t=this.config,r=this.getFromEnv("animationManager"),n=e.originalEvent,a=n.pageX||n.data[2],i=n.page||n.data[3],o=t.layerX=a-t.chartPosLeft,s=t.layerY=i-t.chartPosTop,l=o-t.ox,c=s-t.oy,u=t.ox,g=t.oy,p=t.zoomX,m=t.zoomY,v=t.strokeWidth,b=t.canvasW,y=t.canvasH,x=t.canvasY,w=t.canvasX,C=t.canvasX2,k=t.canvasY2;r.setAnimationState("dragMove"),t.allowMove&&(t.isDragged||(t.isDragged=1),l=-(u-d(u-(u-f(u+l,w)),C)),c=-(g-d(g-(g-f(g+c,x)),k)),r.setAnimation({el:this.getGraphicalElement("resizeBox"),attr:{x:(p?d(u,u+l):w)+.5*v,y:(m?d(g,g+c):x)+.5*v,width:p?h(l):b,height:m?h(c):y},component:this}),t.dragmoveFn&&"function"==typeof t.dragmoveFn&&t.dragmoveFn(e))},r.dragend=function(e){this._setConfig();var t,r,n=this.getFromEnv("chart"),a=this.config,i=this.getFromEnv("xAxis")[0],o=this.getGraphicalElement("resizeBox"),s=a.bBox;n.getFromEnv("animationManager").setAnimationState("dragEnd"),s=o.getBBox(),a.isDragged&&(a.dragendFn&&"function"==typeof a.dragendFn&&a.dragendFn(e,{chart:n,selectionLeft:s.x,selectionTop:s.y,selectionHeight:s.height,selectionWidth:s.width,originalEvent:e.originalEvent}),a.isDragged=0),o.hide(),delete a.oy,delete a.ox,(t=s.x-n.config.canvasLeft)!==(r=t+s.width)&&(a.boxStartValue=i.getValue(t),a.boxEndValue=i.getValue(r),this.pinRangePixels(t,r,e))},t}(o["default"]);t["default"]=p},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=r(224),l=function(e){function t(){var r;r=e.call(this)||this;var n=(0,a["default"])(r);return n.controlArr=[{nativeInteraction:["fc-dragstart","fc-dragmove"],callback:n.onDrag.bind(n),component:n},{nativeInteraction:["fc-dragend"],callback:n.onDragEnd.bind(n),component:n}],n.toggle=n.toggle.bind(n),s.isFirefox&&n.controlArr.push({nativeInteraction:["fc-mousedown"],callback:t.mousedown,component:n}),r}(0,i["default"])(t,e),t.mousedown=function(e){e&&e.preventDefault()};var r=t.prototype;return r.configure=function(){e.prototype.configure.call(this);!this.config.skipGraphics&&this.setLinkedItem("button",this.createButton({icon:"panModeIcon",tooltext:this.config.tooltext,handlers:{click:this.toggle},state:"activated"})),this.getLinkedParent().registerDependancy([{derivedInteraction:["zoomin","zoomout","dragzoomenabled","dragzoomdisabled"],callback:this.dependancyFn,component:this}]),this.disable(s.UNDEF,!1)},r.getName=function(){return"dragPan"},r.enable=function(e,t){this._checkStackLen()&&!0!==this.config.enabled&&(this.config.enabled=!0,this.config.state="pressed",this.fireEvent("panenabled"),!t&&this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged",{panModeActive:!0},e&&e.originalEvent),this.setControl())},r.disable=function(e,t){!1!==this.config.enabled&&(this.config.enabled=!1,this.config.state=this._checkStackLen()?"activated":"disabled",this.fireEvent("pandisabled"),!t&&this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged",{panModeActive:!1},e&&e.originalEvent),this.setControl())},r.setControl=function(){var e=this.getLinkedParent(),t=this.getLinkedItem("button"),r=this.controlArr;e.releaseControl(r),this.isEnabled()&&e.getControl(r),t&&t.setCurrentState(this.isEnabled()?this.config.state:"disabled")},r.setDrag=function(e){this.config.isDragging=!!e},r.isDragging=function(){return!!this.config.isDragging},r.onDragEnd=function(){this.setDrag(!1),this.getFromEnv("chart").getContainer("parentgroup").attr({cursor:"default"})},r.onDrag=function(e){var t,r,n,a,i,o,s,l,c,u,d,f=function(e){var t=e;return t.originalEvent&&(t=t.originalEvent),t.type.match(/touch/)?{x:t.touches[0].pageX,y:t.touches[0].pageY}:t.type.match(/mouse|pointer/)?{x:t.pageX,y:t.pageY}:void 0}(e.originalEvent);(function(e){return!e.touches||1===e.touches.length})(e.originalEvent)&&(this.getFromEnv("chart").getContainer("parentgroup").attr({cursor:"move"}),this.getFromEnv("animationManager").setAnimationState("drag"),this.isDragging()?this.getFromEnv("axesObArr").forEach((function(e){var h,g;if(t=e.origConfig.minValue,r=e.origConfig.maxValue,i=e.axis,o=i.config.axisRange,s=i.getScale(),l=s.getRange(),c=s.getDomain(),u=(l[1]-l[0])/(c[1]-c[0]),h=f,g=e.startCoord,d={x:h.x-g.x,y:h.y-g.y},a=r-t,(n=-(n=e.isY?d.y/u:d.x/u))>0)n=Math.min(o.max-r,n);else{if(!(n<0))return;n=-Math.min(t-o.min,-n)}r=(t+=n)+a,i.setVisibleConfig(t,r)})):(this.getFromEnv("axesObArr").forEach((function(e){e.origConfig=e.axis.getVisibleConfig(),e.startCoord=f})),this.setDrag(!0)))},r.dependancyFn=function(e){"zoomout"===e.type?!this._checkStackLen()&&this.disable():"zoomin"===e.type?this.enable(e):"dragzoomdisabled"===e.type?this._checkStackLen()&&this.enable(e):"dragzoomenabled"===e.type&&this.disable(e)},t}(o["default"]);t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=r(224),l=function(e){return e<0?-e:e},c=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r.controlArr=[{nativeInteraction:["fc-pinchstart"],callback:r.pinchstart.bind(r),component:r},{nativeInteraction:["fc-pinchmove"],callback:r.pinchmove.bind(r),component:r}],t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"pinchZoom"},r.configure=function(){e.prototype.configure.call(this),this.enable()},r.getCenter=function(e,t){var r=this.getFromEnv("chart"),n=(0,s.getMouseCoordinate)(r.getLinkedItem("container"),{pageX:(e.pageX+t.pageX)/2,pageY:(e.pageY+t.pageY)/2},r);return{x:n.chartX,y:n.chartY}},r.pinchmove=function(e){var t,r,n,a,i,o,s,c,u=this,d=e.originalEvent.data,f=d.distanceX,h=d.distanceY,g=u.config,p=g.touchConfig,m={},v=!1,b={},y=u.getFromEnv("chart"),x=u.getFromEnv("axesObArr"),w=Math.pow(10,g.zoomDecimalLimit)||1,C=y.getChildContainer().plotGroup;t=l(f/p.distanceX),r=l(h/p.distanceY),x.forEach((function(){C.transform(""),C.scale(t,r,p.center.x,p.center.y)})),clearTimeout(g.chartDraw),g.chartDraw=setTimeout((function(){C.transform(""),x.forEach((function(e){var l=e.axis,d=function(e,t,r,n,a){var i=e.getVisibleConfig(),o=e.getValue(t[n?"y":"x"]+e.getTranslation()),s=o-i.minValue,l=i.maxValue-o,c=e.config.axisRange;return{min:Math.round(Math.max(c.min,o-s/r)*a)/a,max:Math.round(Math.min(c.max,o+l/r)*a)/a}}(l,p.center,e.isY?r:t,e.isY,w),f=d.min,h=d.max,g=e.stack,y=l.getVisibleConfig(),x=l.getLimit(),C=g.length-1,k=g[C],_=Math.floor(f)===x.min&&Math.ceil(h)===x.max,S=l.getZoom()>=w;if(k)if(_)e.stack=[],m.zoomout=!0;else if(k.minValue>f&&k.maxValue<h){for(;k&&k.minValue>f&&k.maxValue<h;)g.pop(),k=g[--C];m.zoomout=!0}else S||(g.push(y),m.zoomin=!0);else _||S||(g.push(y),m.zoomin=!0);e.isY?(o=f,s=h):(a=f,i=h,b=u.constructor._getZoomInfo(a,i,l)),c=e.stack.length+1,n=l.setVisibleConfig(f,h),v=v||n})),v&&(m.zoomout&&u._raiseZoomEvents("zoomout","zoomedout",Object.assign(b,{level:c,startX:a,endX:i,startY:o,endY:s})),m.zoomin&&u._raiseZoomEvents("zoomin","zoomedin",Object.assign(b,{level:c,startX:a,endX:i,startY:o,endY:s}))),g.chartDraw=null}),250)},r.pinchstart=function(e){var t,r=e.originalEvent.data,n=r;this.getFromEnv("animationManager").setAnimationState("touch"),n.center=this.getCenter(r.finger0,r.finger1),this.config.touchConfig=r,this.getFromEnv("axesObArr").forEach((function(e){t=e.axis,e.visibleConfig=t.getVisibleConfig(),e.centerVal=t.getValue(e.isY?n.center.y:n.center.x)}))},r.setControl=function(){var e=this.getLinkedParent(),t=this.controlArr;e.releaseControl(t),this.isEnabled()&&e.getControl(t)},t}(o["default"]);t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=n(r(362)),s=r(224),l=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r.controlArr=[{nativeInteraction:["fc-dragend"],callback:r.end.bind(r),component:r},{nativeInteraction:["fc-dragmove"],callback:r.move.bind(r),component:r},{nativeInteraction:["fc-dragstart"],callback:r.start.bind(r),component:r}],t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"swipeGesture"},r.configure=function(){e.prototype.configure.call(this),this.enable()},r.getPresentScrollValue=function(){var e=this.config.xAxis,t=e.getVisibleConfig(),r=e.getLimit(),n=t.maxValue-t.minValue,a=r.max-r.min;return(t.minValue-r.min)/(a-n)},r.start=function(e){var t,r,n=this.getFromEnv("chart"),a=this.config;t=(0,s.getMouseCoordinate)(n.getFromEnv("chart-container"),e.originalEvent,n),a.previousX=t.chartX,a.previousY=t.chartY,a.presentScrollValue=r=this.getPresentScrollValue(),n.fireChartInstanceEvent("scrollStart",{scrollPosition:r})},r.move=function(e){var t,r=this.config,n=this.getFromEnv("chart"),a=r.xAxis,i=n.getChildren("scrollBar")&&n.getChildren("scrollBar")[0],o=i&&i.getChildren("scrollAnchor")[0],l=a.config.axisRange,c=(0,s.getMouseCoordinate)(n.getFromEnv("chart-container"),e.originalEvent,n),u=c.chartX,d=c.chartY,f=i&&i.config&&!i.config.isHorizontal?(d-r.previousY)/r.plotDifference:(u-r.previousX)/r.plotDifference,h=a.getVisibleConfig(),g=r.previousScrollValue=r.presentScrollValue,p=h.minValue-f,m=r.axisMin,v=r.axisMax,b=h.maxValue-f;p<m&&m===h.minValue||b>v&&v===h.maxValue||(p<m?(b+=f,b-=f=h.minValue-m,p=m):v<b&&(p+=f,p+=f=v-h.maxValue,b=v),t=(p-l.min)/(l.max-l.min-(b-p)),o.config.scrollPosition=t,n.getFromEnv("animationManager").setAnimationState("scroll"),a.setVisibleConfig(p,b),n.setScrollBarDimension&&n.setScrollBarDimension(),i.asyncDraw(),n.fireChartInstanceEvent("onScroll",{scrollPosition:g}),r.previousX=u,r.previousY=d,r.presentScrollValue=this.getPresentScrollValue())},r.end=function(){var e=this.config;this.getFromEnv("chart").fireChartInstanceEvent("scrollEnd",{previousScrollPosition:e.previousScrollValue,scrollPosition:e.presentScrollValue})},r.setControl=function(){var e=this.getLinkedParent(),t=this.controlArr;e.releaseControl(t),this.isEnabled()&&e.getControl(t)},r.draw=function(){var e=this.config,t=this.getFromEnv("canvas").getAxes().filter((function(e){return!e.isY})),r=e.xAxis=t&&t[0]&&t[0].axis,n=r.config.axisRange;e.plotDifference=r.getPixel(1)-r.getPixel(0),e.axisMin=n.min,e.axisMax=n.max},t}(o["default"]);t["default"]=l},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(e){var t=window,r=t.navigator.userAgent,a=/msie/i.test(r)&&!t.opera,i=Math,o=i.min,s=i.round,l=t.parseFloat,c=String,u="rgba(192,192,192,"+(a?.002:1e-6)+")",d={enabled:!1,"false":!1,0:!1,disabled:!0,"true":!0,1:!0};e.define&&e.define([{name:"button",button:function(t,r,n,a,i,o){var s,l=t,c=r,d=n,f=a,h=i,g=o,p=c,m=this.group("button",p),v=l.labelFill,b=l.symbolFill,y=l.fill,x=l.button[5],w=l.button[6],C=l.hoverFill,k=l.stroke,_=l["symbol-stroke"],S=l["stroke-width"],E=l["symbol-stroke-width"],A=l.config;if("object"==typeof l&&l.button){var N=l.button;l=N[0],c=N[1],d=N[2],f=N[3],h=N[4],p=N[5]}for(s in p=p||g,m._.button={bound:this.rect(m),tracker:this.rect(m).attr({fill:u,stroke:u,cursor:"pointer"}).data("compositeButton",m)},!e.is(h,"object")&&(h={}),e.fn.button.fn)m[s]=e.fn.button.fn[s];for(s in e.fn.button.ca)m.ca[s]=e.fn.button.ca[s];return A&&m.attr({config:A}),m.attr({"button-padding":[h.horizontalPadding,h.verticalPadding],"button-label":d,"button-label-size":x,"button-label-family":w,"button-symbol":f,"button-disabled":h.disabled||"false","button-symbol-position":h.symbolPosition,"button-symbol-padding":h.symbolPadding}).attr("button-repaint",[l,c,h.width,h.height,h.r]).attr({labelFill:v,symbolFill:b,fill:y,hoverFill:C,stroke:k,"symbol-stroke":_,"stroke-width":S,"stroke-linecap":"round","symbol-stroke-width":E})},data:{hoverin:function(){var e=this,t=e._.button,r=t.hoverbackIn,n=e._hover||{};n.fill||n["fill-symbol"]||n.stroke||n["stroke-width"]||n.cursor||n.labelFill||n["symbol-stroke"]?(n.fill&&e.bottom.attr("fill",n.fill)&&!n["fill-symbol"]&&t.symbol.attr("fill",n.fill),n["fill-symbol"]&&t.symbol.attr("fill",n["fill-symbol"]),n.stroke&&e.bottom.attr("stroke",n.stroke)&&t.symbol.attr("stroke",n.stroke),n["stroke-width"]&&e.bottom.attr("stroke-width",n["stroke-width"])&&t.symbol.attr("stroke-width",n["stroke-width"]),n.cursor&&t.tracker.attr("cursor",n.cursor),n.labelFill&&t.label&&t.label.attr("fill",n.labelFill),n["symbol-stroke"]&&t.symbol.attr("stroke",n["symbol-stroke"]),r&&r()):r&&!1===r(arguments)||e.attr("fill","hover"),e.hovered=!0},hoverout:function(){var e=this,t=e._.button,r=t.hoverbackOut,n=e._normal||{};n.fill||n["fill-symbol"]||n.stroke||n["stroke-width"]||n.cursor||n.labelFill||n["symbol-stroke"]?(n.fill&&e.bottom.attr("fill",n.fill)&&!n["fill-symbol"]&&t.symbol.attr("fill",n.fill),n.stroke&&e.bottom.attr("stroke",n.stroke)&&t.symbol.attr("stroke",n.stroke),n["fill-symbol"]&&t.symbol.attr("fill",n["fill-symbol"]),n["stroke-width"]&&e.bottom.attr("stroke-width",n["stroke-width"])&&t.symbol.attr("stroke-width",n["stroke-width"]),n["symbol-stroke"]&&t.symbol.attr("stroke",n["symbol-stroke"]),n.labelFill&&t.label&&t.label.attr("fill",n.labelFill),n.cursor&&t.tracker.attr("cursor",n.cursor),r&&r()):r&&!1===r(arguments)||e.attr("fill",e.pressed||e.active?"active":"normal"),e.hovered=!1},mousedown:function(){var e=this,t=e._.button,r=e._pressed||{};r.fill||r["fill-symbol"]||r.stroke||r["stroke-width"]||r.cursor||r.labelFill||r["symbol-stroke"]?(r.fill&&e.bottom.attr("fill",r.fill)&&!r["fill-symbol"]&&t.symbol.attr("fill",r.fill),r.stroke&&e.bottom.attr("stroke",r.stroke)&&t.symbol.attr("stroke",r.stroke),r["fill-symbol"]&&t.symbol.attr("fill",r["fill-symbol"]),r["stroke-width"]&&e.bottom.attr("stroke-width",r["stroke-width"])&&t.symbol.attr("stroke-width",r["stroke-width"]),r.labelFill&&t.label&&t.label.attr("fill",r.labelFill),r["symbol-stroke"]&&t.symbol.attr("stroke",r["symbol-stroke"]),r.cursor&&t.tracker.attr("cursor",r.cursor)):e.attr("fill","active"),e.pressed=!0},mouseup:function(){var e=this,t=e._.button,r=t.callback,n=e._normal||{};n.fill||n["fill-symbol"]||n.stroke||n["stroke-width"]||n.cursor||n.labelFill||n["symbol-stroke"]?(n.fill&&e.bottom.attr("fill",n.fill)&&!n["fill-symbol"]&&t.symbol.attr("fill",n.fill),n.stroke&&e.bottom.attr("stroke",n.stroke)&&t.symbol.attr("stroke",n.stroke),n["fill-symbol"]&&t.symbol.attr("fill",n["fill-symbol"]),n["stroke-width"]&&e.bottom.attr("stroke-width",n["stroke-width"])&&t.symbol.attr("stroke-width",n["stroke-width"]),n.labelFill&&t.label&&t.label.attr("fill",n.labelFill),n["symbol-stroke"]&&t.symbol.attr("stroke",n["symbol-stroke"]),n.cursor&&t.tracker.attr("cursor",n.cursor)):e.attr("fill",(e.hovered?"hover":e.active&&"active")||"normal"),e.pressed=!1,r&&r(arguments)},mousemove:function(){var e=this,t=e._.button,r=t.mousemove;r&&r(arguments)}},fn:{tooltip:function(){return e.el.tooltip&&e.el.tooltip.apply(this._.button.tracker,arguments),this},buttonclick:function(e,t){var r=t,n=this,a=n._.button;return r=r||n,a.callback=function(){return e.apply(r,arguments)},n},labelcss:function(){var e=this._.button,t=e.label;return e.cssArg=arguments,t&&t.css.apply(t,arguments),this.attr("button-repaint",this.attrs["button-repaint"])},buttonhover:function(e,t,r,n,a,i){var o=this,s=o._.button,l=r||o,c=n||o,u=i||o;return a&&(s.mousemove=function(){return a.apply(u,arguments)}),s.hoverbackIn=function(){return e.apply(l,arguments)},s.hoverbackOut=function(){return t.apply(c,arguments)},o},remove:function(){var t,r=this,n=r._.button;for(t in r.attr("button-disabled","true"),n)n[t]&&n[t].remove&&n[t].remove(),n[t]=null;delete r._.button,e.el.remove.apply(r,arguments)}},ca:{"button-active":function(e){var t=this;t.attr("fill",(t.active=!!e)?"active":t.hovered?"hover":"normal")},"button-disabled":function(e){var t=this,r=e,n=t.paper,a=t._.button,i=a.tracker,o=t.attrs["button-disabled"],s=n.button.data,l=t._disabled||{};if(o=d[o],void 0!==(r=d[r])&&r!==o)switch(r){case!0:l.fill||l.stroke||l["stroke-width"]||l.cursor?(l.fill&&t.bottom.attr("fill",l.fill)&&a.symbol.attr("fill",l.fill),l.stroke&&t.bottom.attr("stroke",l.stroke)&&a.symbol.attr("stroke",l.stroke),l["stroke-width"]&&t.bottom.attr("stroke-width",l["stroke-width"]&&a.symbol.attr("fill",l.fill)),l.cursor&&a.tracker.attr("cursor",l.cursor)):i.attr("fill","rgba(204,204,205,.5)"),i.off("fc-mousedown",s.mousedown).off("fc-unmouseup",s.mouseup).unhover(s.hoverin,s.hoverout).unmousemove(s.mousemove);break;case!1:i.attr("fill",u).on("fc-mousedown",s.mousedown,t).on("fc-mouseup",s.mouseup,t).hover(s.hoverin,s.hoverout,t,t).mousemove(s.mousemove,t)}},"button-label":function(e){var t=this,r=t._.button,n=t.attrs,a=e,i=r.label,o=r.cssArg,s=t.attrs["button-repaint"];"none"===(a=c(a||""))?i&&(r.label=i.remove()):a&&(!i&&(i=r.label=t.paper.text(t).insertBefore(r.tracker)),i.attr({text:a,"text-anchor":"middle","vertical-align":"middle"}),o&&o.length&&i.css.apply(i,o)),s&&n["button-label"]!==a&&t.attr("button-repaint",s)},"button-label-size":function(e){var t=this,r=t._.button,n=t.attrs,a=r.label,i=t.attrs["button-label-size"];a&&a.attr({"font-size":e}),i&&n["button-label-size"]!==e&&t.attr("button-label-size",i)},"button-label-family":function(e){var t=this,r=t._.button,n=t.attrs,a=e,i=r.label,o=t.attrs["button-label-family"];i&&(void 0===a&&(a="sans-serif"),i.attr({"font-family":a}),o&&n["button-label-family"]!==a&&t.attr("button-label-family",o))},"button-symbol":function(e){var t=this,r=t._.button,n=e,a=r.symbol,i=t.attrs["button-repaint"];"none"===(n=c(n||""))?(a&&(r.symbol=a.remove()),delete r.symbol):n&&!a&&(a=r.symbol=t.paper.symbol(t).insertAfter(r.bound)),i&&t.attr("button-repaint",i)},"button-symbol-position":function(e){return{"button-symbol-position":{top:"top",right:"right",bottom:"bottom",left:"left",none:"none"}[c(e).toLowerCase()]||"none"}},"button-symbol-padding":function(e){return{"button-symbol-padding":l(e)}},"button-padding":function(e,t){var r=e,n=t;return{"button-padding":[null==r&&(r=5)||l(r),null==n&&r||l(n)]}},"button-repaint":function(t,r,a,i,l){var c,u,d,f,h,g,p,m=this._.button,v=t,b=r,y=a,x=i,w=l,C=m.bound,k=m.label,_=m.symbol,S=this.attrs,E=S["button-padding"],A=E[0],N=E[1];if(void 0===v&&(v=0),void 0===b&&(b=0),void 0!==y&&void 0!==x||(g=k&&k.getBBox()||{width:0,height:0},void 0===y&&(y=2*A+g.width),void 0===x&&(x=2*N+g.height)),(p=e.crispBound(v,b,y,x,C.attr("stroke-width"))).r=w=(0,n.pluck)(w,s(.1*o(x,y))),v=p.x,b=p.y,y=p.width,x=p.height,k&&k.attr({x:v+y/2,y:b+x/2}),_){switch(!e.is(h=S["button-symbol-padding"],"finite")&&(h=.2*x),f=.5*(d=x-N),S["button-symbol-position"]+(k?"+":"-")){case"right+":c=v+(y+=2*f+N)-f-A,u=b+.5*x,k.attr("transform",["t",-(d+h),0]);break;case"left+":y+=2*f+N,c=v+A+f,u=b+.5*x,k.attr("transform",["t",d+h,0]);break;case"top+":x+=2*f+h,c=v+.5*y,u=b+E[1]+f,k.attr("transform",["t",0,d+h]);break;case"bottom+":c=v+.5*y,u=b+(x+=2*f+h)-N-f,k.attr("transform",["t",0,-(d+h)]);break;default:c=v+.5*y,u=b+.5*x}_.attr("symbol",[S["button-symbol"],c,u,f,y,x])}m.bound.attr(p),m.tracker.attr(p)},fill:function(t,r){void 0===r&&(r=!0);var n=this,a=n._.button,i=a.bound,o=t,s={normal:a.gradient,active:a.gradientActive,hover:a.gradientHover}[o];return s||(r||((o=e.getRGB(o)).error&&(o=e.color("#cccccc")),o="opacity"in o?"rgba("+[o.r,o.g,o.b,o.opacity]+")":"rgb("+[o.r,o.g,o.b]+")"),a.gradient=r?o:[90,e.tintshade(o,-.8).rgba+":0",e.tintshade(o,.8).rgba+":100"].join("-"),a.gradientActive=[270,e.tintshade(o,-.8).rgba+":0",e.tintshade(o,.8).rgba+":100"].join("-"),s=(n.pressed||n.active)&&a.gradientActive||n.hovered&&a.gradienthover||a.gradient),i.attr("fill",s),!1},hoverFill:function(t){var r=this._.button,n=t;return n="opacity"in(n=e.getRGB(n))?"rgba("+[n.r,n.g,n.b,n.opacity]+")":"rgb("+[n.r,n.g,n.b]+")",r.gradientHover=n,!1},labelFill:function(e){var t=this._.button,r=t.label;return r&&e&&(t.labelFill=e,r.attr("fill",e)),!1},symbolFill:function(e){var t=this._.button,r=t.symbol;return r&&e&&(t.symbolFill=e,r.attr("fill",e)),!1},stroke:function(t){var r=this._.button,n=t;return(n=e.color(n)).error&&(n=e.color("#999999")),r.bound.attr("stroke",n),!1},"symbol-stroke":function(e){var t=this._.button.symbol;return t&&e&&t.attr("stroke",e),!1},"stroke-width":function(e){var t=this._.button;return t.bound.attr("stroke-width",e),t.tracker.attr("stroke-width",e),!1},"symbol-stroke-width":function(e){var t=this._.button.symbol;return t&&e&&t.attr("stroke-width",e),!1},config:function(e){var t=this;e.hover&&(t._hover={fill:e.hover.fill,stroke:e.hover.stroke,"stroke-width":e.hover["stroke-width"],cursor:e.hover.cursor,"fill-symbol":e.hover["fill-symbol"],"symbol-stroke":e.hover["symbol-stroke"],labelFill:e.hover.labelFill}),e.disabled&&(t._disabled={fill:e.disabled.fill,stroke:e.disabled.stroke,"stroke-width":e.disabled["stroke-width"],"symbol-stroke":e.disabled["symbol-stroke"],cursor:e.disabled.cursor,labelFill:e.disabled.labelFill}),e.pressed&&(t._pressed={fill:e.pressed.fill,stroke:e.pressed.stroke,"stroke-width":e.pressed["stroke-width"],cursor:e.pressed.cursor,"fill-symbol":e.pressed["fill-symbol"],"symbol-stroke":e.pressed["symbol-stroke"],labelFill:e.pressed.labelFill}),e.normal&&(t._normal={fill:e.normal.fill,stroke:e.normal.stroke,"stroke-width":e.normal["stroke-width"],cursor:e.normal.cursor,"fill-symbol":e.normal["fill-symbol"],"symbol-stroke":e.normal["symbol-stroke"],labelFill:e.normal.labelFill}),e.symbol&&(e.symbol={stroke:e.normal.stroke,"stroke-width":e.normal["stroke-width"]})}}}])};var n=r(224)},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a=function(e){s(e,"legendItemClicked")},i=function(e){s(e,"legendItemRollover")},o=function(e){s(e,"legendItemRollout")},s=function(e,t){var r=e.sender,a=r.getLinkedItem("owner"),i=r.getFromEnv("chart"),o=a&&a.getEventArgs?a.getEventArgs(r):r.config.eventArguments,s=(0,n.getMouseCoordinate)(r.getFromEnv("chart-container"),e,i);/click/gi.test(t)||void 0===o.visible||(o.visible=!o.visible),"timeseries"===i.getName().toLowerCase()&&(o.visible=/click/gi.test(t)?!i.config.legendMap[r.config.label].visibility:i.config.legendMap[r.config.label].visibility),o.chartX=s.chartX,o.chartY=s.chartY,o.pageX=s.pageX,o.pageY=s.pageY,o.id=i.getId(),o.legendItemId=r.getId(),o.legendItemIndex=r.config.index,i.fireChartInstanceEvent(t,o,e)},l={extension:function(e){var t;e.addEventListener("instantiated",(function(e){var r;"legendItem"===(t=e.sender).getType()&&((r=t).addEventListener("fc-click",a),r.addEventListener("fc-mouseover",i),r.addEventListener("fc-mouseout",o))}))},name:"legendEventManagerLinker",type:"extension",requiresFusionCharts:!0};t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(390));function i(e){void 0===e&&(e={});var t=this.apiInstance.getChildren("exportModule");return void 0!==(t=t&&t[0])&&(t.exportChart(e),!0)}var o={extension:function(e){e.addEventListener("instantiated",(function(e){var t=e.sender;(function(e){return"chartAPI"===e.getType()})(t)&&t.registerFactory("export",(function(e){var r;t.getFromEnv("chartInstance").exportChart=i,Number(e.getFromEnv("dataSource").chart.exportenabled)&&(e.getChildren("exportModule")?r=e.getChildren("exportModule")[0]:(r=new a["default"],e.attachChild(r,"exportModule"),r.addToEnv("chartInstance",e.getFromEnv("chartInstance")),r.addToEnv("chartMenuList",e.getFromEnv("chartMenuList"))),r.configure({chartConfig:e.getFromEnv("dataSource").chart}))}),["toolbox"])}))},name:"Export",type:"extension",requiresFusionCharts:!0};t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(223)),i=n(r(238)),o=r(240),s=r(232),l=r(224),c=n(r(391)),u=r(392),d=r(395),f=r(393);function h(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}var g=/\s\bx\b=['"][^'"]+?['"]/gi,p=/\s\by\b=['"][^'"]+?['"]/gi,m=window,v=m.document,b="https:"===m.location.protocol?"https://export.api3.fusioncharts.com/":"http://export.api3.fusioncharts.com/",y="https:"===m.location.protocol?"https://export.api3.fusioncharts.com/api/v1.0/logs":"http://export.api3.fusioncharts.com/api/v1.0/logs",x=m.navigator.userAgent.match(/(iPad|iPhone|iPod)/g),w=function(e){function t(){var t;return(t=e.call(this)||this).config={exportOption:{},chartConfig:{caption:"",subcaption:"",width:"",height:""}},t}(0,i["default"])(t,e);var r=t.prototype;return r.getName=function(){return"exportModule"},r.getType=function(){return"extension"},r.configureMenuBar=function(){var e,t,r,n,i,o,c,d,f,g=this,p=g.getFromEnv("toolbar"),v=!!m.btoa,b=g.getFromEnv("chart"),y=g.getFromEnv("chart-attrib").exportformats,x=p.getChild("hamburgerMenu-"+p.getId()+"-"+b.getId()+"-0"),w=(0,s.getDep)("Excelexport"),C={PNG:"Export As "+u.EXPORTFORMAT.PNG.toUpperCase(),JPG:"Export As "+u.EXPORTFORMAT.JPG.toUpperCase(),PDF:"Export As "+u.EXPORTFORMAT.PDF.toUpperCase(),SVG:"Export As "+u.EXPORTFORMAT.SVG.toUpperCase(),CSV:"Export As "+u.EXPORTFORMAT.CSV.toUpperCase(),XLSX:"Export As "+u.EXPORTFORMAT.XLSX.toUpperCase(),XLS:"Export As "+u.EXPORTFORMAT.XLS.toUpperCase()},k=[];if(g.config.exportOption.exportenabled){if(o=function(e){return function(){g.config.exportOption.exportformat=e,g.exportChart({})}},y)for(n=0,i=(e=y.split("|")).length;n<i;n++)t=e[n].split("="),(r=(0,l.trimString)(t[0].toUpperCase())).toLowerCase()===u.EXPORTFORMAT.XLSX&&(f=!0),C[r]&&(C[r]=t[1]||C[r]),C[r]&&(d||(d={}))&&(d[r]=!0);for(r in g.config.exportOption.exportformats=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?h(Object(r),!0).forEach((function(t){(0,a["default"])(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):h(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({},C),C)"XLSX"===r&&(!v||!w||w&&w.then)||d&&!d[r]||"XLS"!==r&&("CSV"!==r||v)&&(c={name:C[r],handler:o(r),action:"click"},k.push(c));x.appendInMenu(k),v&&w&&w.then&&w.then((function(){y&&!f||(x.appendInMenu([{name:C.XLSX,handler:o("XLSX"),action:"click"}]),x.asyncDraw())}))}},r.configure=function(e){var t,r,n,a=this.getFromEnv("chartInstance"),i=this.config,o=i.chartConfig,s=i.exportOption,c=e.chartConfig;c.caption&&(o.caption=(0,l.pluck)(c.caption,"")),c.subcaption&&(o.subcaption=(0,l.pluck)(c.subcaption,"")),s.exportenabled=(0,l.pluckNumber)(c.exportenabled,0),s.exportshowmenuitem=(0,l.pluckNumber)(c.exportshowmenuitem,1),s.exportformat=(0,l.pluck)(c.exportformat,u.EXPORTFORMAT.PNG),s.exporthandler=(0,l.pluck)(c.html5exporthandler,c.exporthandler,b),s.exportaction=c.exportaction&&"string"==typeof c.exportaction?(t=c.exportaction.toLowerCase(),[u.EXPORTACTION.DOWNLOAD,u.EXPORTACTION.SAVE,u.EXPORTACTION.DOWNLOADSAVE].indexOf(t)>=0?t:u.EXPORTACTION.DOWNLOAD):u.EXPORTACTION.DOWNLOAD,s.exporttargetwindow=(0,l.pluck)(c.exporttargetwindow,x?"_parent":"_self"),s.exportfilename=(0,l.pluck)(c.exportfilename,"FusionCharts"),s.exportparameters=(0,l.pluck)(c.exportparameters,""),s.exportcallback=(0,l.pluck)(c.exportcallback,""),s.exportwithimages=(0,l.pluckNumber)(c.exportwithimages,1),s.exportmode=("undefined"!=typeof c.exportatclientside&&(r={1:u.EXPORTMODE.AUTO,0:u.EXPORTMODE.AUTO}[c.exportatclientside]),r=(r=c.exportmode||r||u.EXPORTMODE.AUTO).toLowerCase()),s.logenabled=(0,l.pluckNumber)(c.logenabled,0),s.loghandler=(0,l.pluck)(c.html5loghandler,c.loghandler,y),s.logmode=void 0!==(n=c.logmode)&&"string"==typeof n&&n.toUpperCase()in u.LOGMODE?u.LOGMODE[n.toUpperCase()]:u.LOGMODE.AUTO,s.bgcolor=function(e){return e.jsVars.transparent||0===(0,l.pluckNumber)(e.options.containerBackgroundOpacity,1)?l.BLANKSTRING:e.options.containerBackgroundColor||"#FFFFFF"}(a),s.bgalpha=function(e){return e.jsVars.transparent?0:(0,l.pluckNumber)(e.options.containerBackgroundOpacity,1)+""}(a),s.exportshowmenuitem&&this.configureMenuBar()},r.exportChart=function(e){var t,r,n,a=this,i=a.getFromEnv("chartInstance"),o=a.getFromEnv("chart"),h="object"==typeof e&&function(e){var t,r={};for(t in e)r[t.toLowerCase()]=e[t];return r}(e)||{},b=(0,l.extend2)((0,l.extend2)({},a.config.exportOption),h),y=(b.exportformat||u.EXPORTFORMAT.PNG).toLowerCase(),x=b.exporthandler,w=b.exportaction,C=b.exporttargetwindow||"",k=b.exportfilename,_=b.exportparameters,S=b.exportcallback,E=b.exportwithimages,A=b.exportmode,N=b.logenabled,T=b.loghandler,M=b.logmode,D=function(e){o.fireChartInstanceEvent("exportDataReady",e)};o.fireChartInstanceEvent("beforeExport",b,void 0,(function(){var e,h,F,I,O,L,R,P,V,j=i.id,B=a.config.chartConfig.caption,z=a.config.chartConfig.subcaption,H=this.apiInstance.getFromEnv("paper"),U=this.apiInstance.getFromEnv("core-options")["export"].useCanvas,G=(0,c["default"])(o.getChildren("chartMenuBar"))?o.getChildren("chartMenuBar")[0]:o.getChildren("actionBar")[0],W=G.getChild("hamburgerMenu-"+G.getId()+"-"+o.getId()+"-0"),$={DOMId:j,height:H.height,width:H.width,fileName:k+"."+y,statusCode:void 0,statusMessage:void 0,notice:void 0},X={exportAction:w,exportTargetWindow:C,exportCallback:S,fusionCharts:i,paper:H,chartId:j,exportHandler:x,logEnabled:N,logMode:M,logHandler:T},Y=function(e,t,r){var n;return n=!!N,M===u.LOGMODE.CLIENT&&(n=!1),{charttype:i.chartType(),stream_type:e||"",stream:t||"",meta_bgColor:b.bgcolor||"",meta_bgAlpha:b.bgalpha||"1",meta_DOMId:i.id,meta_width:H.width||a.config.chartConfig.width,meta_height:H.height||a.config.chartConfig.height,chart_caption:B,chart_sub_caption:z,is_single_export:!0,is_full_version:!1,version:l.PROJECT_VERSION,user_time_zone:-(new Date).getTimezoneOffset(),log_enabled:n,parameters:["exportfilename="+k,"exportformat="+y,"exportaction="+(0,u.createExportActionOldString)(w),"exportactionnew="+w,"configuredexportaction="+(r||w),"exportparameters="+_].join("|")}},q=function(){return{chartType:i.chartType(),chartCaption:B,chartSubCaption:z,isSingleExport:!0,isFullVersion:!1,exportAction:w,userTimeZone:-(new Date).getTimezoneOffset(),exportFileName:[k,y].join("."),exportFormat:y,version:l.PROJECT_VERSION}},K=function(e){(0,f.downloadCharts)(null,null,null,Y(u.EXPORTFORMAT.SVG,e),X)},J=function(e,t,r){var n;(n=v.createElement("canvas")).width=H.width,n.height=H.height,(0,f.drawSvgOnCanvas)({svg:F,canvas:n,x:0,y:0,width:H.width,height:H.height,useCanvas:U},(function(){switch(e){case u.EXPORTFORMAT.PNG:t(e,n.toDataURL("image/png"),k,r);break;case u.EXPORTFORMAT.JPEG:case u.EXPORTFORMAT.PDF:default:t(e,n.toDataURL("image/jpeg"),k,r)}}))},Z=function(t,r,n,a,i){var o=r;t===u.EXPORTFORMAT.PDF&&((0,d.addImage)(o,H.height,H.width),o=(0,d.getDataUrl)()),e=i===u.EXPORTMODE.AUTO?Y("IMAGE-DATA",o):null,(0,f.downloadCharts)("url",o,n+"."+t,e,a)},Q=D,ee=function(e){e===u.LOGMODE.CLIENT&&(0,u.logCharts)(q(),X)},te=function(r,n){if(O="undefined"!=typeof m.btoa&&("Chrome"===f.browserDetails.name||"Firefox"===f.browserDetails.name||"Safari"===f.browserDetails.name||"Edge"===f.browserDetails.name||"ie"===f.browserDetails.name),"server"!==A&&O){if(w===u.EXPORTACTION.DOWNLOAD||w===u.EXPORTACTION.DOWNLOADSAVE){if("xlsx"===y||"csv"===y)(0,f.downloadCharts)("blob",r,k+"."+y,null,X);else if("xls"===y){var a="data:application/vnd.ms-excel;base64,"+(s="<html xmlns:o='urn:schemas-microsoft-com:office:office'xmlns:x='urn:schemas-microsoft-com:office:excel'xmlns='http://www.w3.org/TR/REC-html40'><head>\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e</head><body>"+function(){var e,r,n,a,i,o;if(!t.length)return"";for(n=0,o=t.length;n<o;n+=1)if(0===n){for(e="<thead valign='top'><tr>",a=0,i=t[n].length;a<i;a+=1)e+="<th>"+t[n][a]+"</th>";e+="</tr></thead>",r="<tbody>"}else{for(r+="<tr>",a=0,i=t[n].length;a<i;a+=1)r+="<td>"+t[n][a]+"</td>";r+="</tr>"}return"<table align='center' >"+e+(r+="</tbody>")+"</table>"}()+"</body></html>",m.btoa(m.unescape(encodeURIComponent(s))));(0,f.downloadCharts)("url",a,k+"."+y,null,X)}o.fireChartInstanceEvent("exported",$)}w===u.EXPORTACTION.SAVE||w===u.EXPORTACTION.DOWNLOADSAVE?(L=w,w===u.EXPORTACTION.DOWNLOADSAVE&&(w=u.EXPORTACTION.SAVE),e=Y("IMAGE-DATA",r,L),(0,f.downloadCharts)(null,null,null,e,X),ee(M)):M!==u.LOGMODE.SERVER&&(0,u.logCharts)(q(),X)}else{var i=new FileReader;i.onload=function(e){for(var t=l.BLANKSTRING,r=new Uint8Array(e.target.result),a=r.byteLength,i=0;i<a;i++)t+=String.fromCharCode(r[i]);t=n+m.btoa(t),(0,f.downloadCharts)(null,null,null,Y("IMAGE-DATA",t),X),ee(M)},i.readAsArrayBuffer(r)}var s};if("xlsx"===y||"xls"===y){if("undefined"==typeof m.btoa)return o.fireChartInstanceEvent("exportCancelled",b),!1;r=i.getCSVData(),Q(),V=0,t=[],r.replace(/[^\r\n]+/g,(function(e){t[V]=[],t[V]=e.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map((function(e){return e.replace(/"/g,l.BLANKSTRING)})),V+=1})),(R=(0,s.getDep)("ExcelExport"))&&R(t).then((function(e){te(e,"data:application/vnd.ms-excel;base64,")}))}else if("csv"===y){if("undefined"==typeof m.btoa)return o.fireChartInstanceEvent("exportCancelled",b),!1;r=i.getCSVData(),Q(),n=new Blob([r],{type:"text/csv;base64;"}),te(n,"data:text/csv;base64,")}else(I=W.getChild("listContainer").getLinkedParent().getGraphicalElement("button","button"))&&I.attr("visibility","hidden"),h=H.toSVG(E),F=(F=H.toSVG(E&&(0,f.isCanvasElemSupported)())).replace(/&nbsp;/gi," "),I&&I.attr("visibility","visible"),h=(h=(h=h.replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/gi,"$1M 0 0 L 0 0$2")).replace(/NS\d+:/gi,"xlink:")).replace(/&nbsp;/gi," "),F=(F=(F=F.replace(/NS\d+:/gi,"xlink:")).replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/gi,"$1M 0 0 L 0 0$2")).replace(/(xlink:title\s*=\s*)['"].*?["']/gi,""),h=(h=(h=(h=(h=(h=(h=(h=h.replace(/[\w\-]+\=\"undefined\"/gi,"")).replace(/(xlink:title\s*=\s*)['"].*?["']/gi,"")).replace(/rgba\(([^\)]+)\)/gi,(function(e){return"#"+new l.RGBtoHex(e.split(","))}))).replace(/<svg[^>]+/i,(function(e){var t=e;return t.match(/height/i)||!H.height&&!a.config.chartConfig.height||(t+=' height="'+(H.height||a.config.chartConfig.height)+'"'),t.match(/width/i)||!H.width&&!a.config.chartConfig.width||(t+=' width="'+(H.width||a.config.chartConfig.width)+'"'),t}))).replace(/(([\w]+\-)?opacity\s*=\s*)['"][\d\.]+e[\-\+][\d]+["']/gi,'$1"0.001"')).replace(/(([\w]+\-)?opacity\s*:\s*)[\d\.]+e[\-\+][\d]+/gi,"$10.001")).replace(/<text[^\>]+/gi,(function(e){var t=e;return t=(t=(t=(t=(t=(t=(t=(t=t.replace(/stroke\=[\"\']([a-z0-9\#]+)?[\"\']/gi,"")).replace(/stroke\s*\:\s*([a-z0-9\#]+)?;?/gi,"")).replace(/stroke-width\=[\"\']([a-z0-9\#]+)?[\"\']/gi,"")).replace(/stroke-width\s*\:\s*([a-z0-9\#]+)?;?/gi,"")).replace(/stroke-opacity\=[\"\']([a-z0-9\#]+)?[\"\']/gi,"")).replace(/stroke-opacity\s*\:\s*([a-z0-9\#]+)?;?/gi,"")).replace(/(<text[^\>]+fill\=)([\"\'][^\"\']+[\"\'])([^\>]+)/gi,'$1$2 stroke=$2 stroke-width="0.2"$3')).replace(/(<text[^\>]+fill-opacity\=)([\"\'][^\"\']+[\"\'])([^\>]+)/gi,"$1$2 stroke-opacity=$2 $3")}))).replace(/<(\b[^<>s\s]+\b)[^\>]+?opacity\s*=\s*['"][^1][^\>]+?(\/>|>[\s\r\n]*?<\/\1>)/gi,(function(e,t){return' opacity="1" stroke-opacity="1" fill="#cccccc" stroke-width="0" r="0" height="0.5" width="0.5" d="M 0 0 L 1 1" />',e+"<"+t+(g.exec(e)||"")+(p.exec(e)||"")+' opacity="1" stroke-opacity="1" fill="#cccccc" stroke-width="0" r="0" height="0.5" width="0.5" d="M 0 0 L 1 1" />'})),h=(0,u.makeImageUrlsAbsolute)(h),F=(0,u.makeImageUrlsAbsolute)(F),P=A===u.EXPORTMODE.SERVER,(0,u.cacheAllImages)(h,P,(function(){e=Y(u.EXPORTFORMAT.SVG,h),Q(e),e=null;var t,r,n,a,i,s,l,c,g="undefined"!=typeof m.btoa&&("Chrome"===f.browserDetails.name||"Firefox"===f.browserDetails.name||"Safari"===f.browserDetails.name||"Edge"===f.browserDetails.name||"ie"===f.browserDetails.name);(A===u.EXPORTMODE.CLIENT||A===u.EXPORTMODE.AUTO&&!(0,u.hasUndownloadableImage)(h))&&g?(F=(0,u.replaceImagesWithNonDataUrl)(F),w!==u.EXPORTACTION.DOWNLOAD&&w!==u.EXPORTACTION.DOWNLOADSAVE||(i=F,s=X,l=A,y===u.EXPORTFORMAT.SVG?(c=(0,u.svgStrToDataUrl)(i),e=l===u.EXPORTMODE.AUTO?Y("IMAGE-DATA",c):null,(0,f.downloadCharts)("url",c,k+"."+y,e,s)):J(y,(function(){Z(arguments[0],arguments[1],arguments[2],arguments[3],l)}),s),o.fireChartInstanceEvent("exported",$)),w===u.EXPORTACTION.SAVE||w===u.EXPORTACTION.DOWNLOADSAVE?(t=w,w===u.EXPORTACTION.DOWNLOADSAVE&&(w=u.EXPORTACTION.SAVE),function(e,t,r){var n;y===u.EXPORTFORMAT.SVG?(n=(0,u.svgStrToDataUrl)(e),r(n,t)):J(y,(function(){r(arguments[1],t)}),t)}(F,X,(function(r,n){e=Y("IMAGE-DATA",r,t),(0,f.downloadCharts)(null,null,null,e,n),ee(M)})),o.fireChartInstanceEvent("exported",$)):M!==u.LOGMODE.SERVER&&(0,u.logCharts)(q(),X)):A===u.EXPORTMODE.AUTO?(a=h,f.browserDetails.hasCanvas&&"undefined"!=typeof m.btoa?((r=v.createElement("canvas")).width=H.width,r.height=H.height,a=(0,u.embedImagesWithNonDataURL)(a),F=(0,u.replaceImagesWithNonDataUrl)(F),(0,u.hasUndownloadableImage)(a)||y===u.EXPORTFORMAT.SVG?(n=Y(u.EXPORTFORMAT.SVG,a),(0,f.downloadCharts)(null,null,null,n,X)):(0,f.drawSvgOnCanvas)({svg:F,canvas:r,x:0,y:0,width:H.width,height:H.height,useCanvas:U},(function(){var e;switch(y){case u.EXPORTFORMAT.PNG:e=r.toDataURL("image/png");break;case u.EXPORTFORMAT.JPEG:e=r.toDataURL("image/jpeg");break;case u.EXPORTFORMAT.PDF:(0,d.addImage)(r.toDataURL("image/jpeg"),H.height,H.width),e=(0,d.getDataUrl)();break;default:e=r.toDataURL("image/jpeg")}n=Y("IMAGE-DATA",e),(0,f.downloadCharts)(null,null,null,n,X)}))):K(a),ee(M)):A===u.EXPORTMODE.SERVER&&(K(h),ee(M))}))}),(function(){o.fireChartInstanceEvent("exportCancelled",b)}))},t}(o.ComponentInterface);t["default"]=w},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(291));t["default"]=function(e){return(0,a["default"])(e)&&e.length}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.svgStrToDataUrl=t.logCharts=t.extractNonDataImageFromSVG=t.parseUrl=t.extractNonDataURLFromSVG=t.removeImagesWithNonDataURL=t.hasUndownloadableImage=t.replaceImagesWithNonDataUrl=t.embedImagesWithNonDataURL=t.makeImageUrlsAbsolute=t.isCacheAllImagesCompleted=t.getImageCachedDetails=t.cacheAllImages=t.objCacheFunctions=t.createExportActionOldString=t.LOGMODE=t.EXPORTFORMAT=t.EXPORTMODE=t.EXPORTACTION=void 0;var a,i=r(393),o=n(r(312)),s=r(224),l=function(e){var t,r,n,a,i,o;t=/(<image [^\>]*href=["']([^\>'"]*)["'][^\>]*\>)/g,r=/^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i,n=[];do{null!==(a=t.exec(e))&&(i=a[1],o=a[2],r.test(o)||n.push(i))}while(a&&null!==a);return n},c=function(e){var t,r,n,a=e;for(t=l(a),r=0;r<t.length;r++)n=t[r],a=a.replace(n,"");return a},u=function(e,t){var r,n,a,i,o;void 0===t&&(t=!0),r=/<image [^\>]*href=["']([^\>'"]*)["'][^\>]*\>/g,n=/^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i,a=[];do{if(null!==(i=r.exec(e))){if(o=i[1],n.test(o))continue;t&&(o=d(o).href),a.push(o)}}while(i&&null!==i);return a},d=function(e){var t=document.createElement("div");return t.innerHTML="<a></a>",t.firstChild.href=e,t.innerHTML=t.innerHTML,t.firstChild},f={DOWNLOAD:"download",SAVE:"save",DOWNLOADSAVE:"download-save"},h={CLIENT:"client",SERVER:"server",AUTO:"auto"},g=((a={}).cacheCompleted=!1,{cacheAllImages:function(e,t,r){var n,o,l,c;if(void 0===t&&(t=!1),n=u(e),o=n.length,(0,i.isCanvasElemSupported)()&&!t&&o)for(l=0,c=0;c<o;c++)!function(){var e,t;if((e=n[c])in a)return l++,void(o===l&&(a.cacheCompleted=!0,r()));(t=new Image).crossOrigin=s.BLANKSTRING,t.onload=function(){var n,i;(n=document.createElement("canvas")).width=t.width,n.height=t.height,n.getContext("2d").drawImage(this,0,0);try{i=n.toDataURL("image/png"),a[e]={loaded:!0,notCORS:!0,imageUri:i}}catch(s){a[e]={loaded:!0,notCORS:!1}}finally{l++,o===l&&(a.cacheCompleted=!0,r())}},t.onerror=function(){a[e]={loaded:!1},l++,o===l&&(a.cacheCompleted=!0,r())},t.src=e}();else r()},getImageCachedDetails:function(e){return a[e]},isCacheAllImagesCompleted:function(){return a.cacheCompleted}}),p=g.cacheAllImages,m=g.getImageCachedDetails,v=g.isCacheAllImagesCompleted,b=function(e){return e=e.replace(/(:href=")([^"]*)(")/gi,(function(e,t,r,n){return t+d(r).href+n}))},y=function(e){return e.replace(/<image [^\>]*\>/gi,b)},x=function(e){var t,r,n,a,i=y(e);for(t=u(i),r=0;r<t.length;r++)n=t[r],(a=m(n))!==s.UNDEF&&a.loaded&&a.notCORS&&a.imageUri&&(i=i.replace(n,a.imageUri));return i};t.svgStrToDataUrl=function(e){var t=function(e){return'<?xml version="1.0" standalone="no"?>\n      <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN"\n       "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> '+e}(e);return t="data:image/svg+xml;base64,"+window.btoa(window.unescape(encodeURIComponent(t)))},t.logCharts=function(e,t){t.logEnabled&&t.logMode!==h.SERVER&&function(e,t){var r=new o["default"](s.stubFN,s.stubFN);for(var n in e)e.hasOwnProperty(n)&&(e[n]=encodeURIComponent(e[n]));r.post(t.logHandler,e)}(e,t)},t.hasUndownloadableImage=function(e){var t=x(e);return t!==c(t)},t.replaceImagesWithNonDataUrl=function(e){return c(x(e))},t.embedImagesWithNonDataURL=x,t.makeImageUrlsAbsolute=y,t.isCacheAllImagesCompleted=v,t.getImageCachedDetails=m,t.cacheAllImages=p,t.objCacheFunctions=g,t.createExportActionOldString=function(e){return{download:f.DOWNLOAD,"download-save":f.DOWNLOAD,save:f.SAVE}[e]},t.LOGMODE=h,t.EXPORTFORMAT={PNG:"png",SVG:"svg",JPEG:"jpeg",JPG:"jpg",PDF:"pdf",XLSX:"xlsx",XLS:"xls",CSV:"csv"},t.EXPORTMODE={CLIENT:"client",SERVER:"server",AUTO:"auto"},t.EXPORTACTION=f,t.parseUrl=d,t.extractNonDataURLFromSVG=u,t.removeImagesWithNonDataURL=c,t.extractNonDataImageFromSVG=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.isCanvasElemSupported=t.drawSvgOnCanvas=t.browserDetails=t.downloadCharts=void 0;var a=n(r(394)),i=r(224),o=r(231),s=n(r(312)),l=window,c=l.Image,u=document,d="download",f="download-save",h=function(){var e=u.createElement("canvas");return!(!e.getContext||!e.getContext("2d"))},g=function(){var e,t=l.navigator.userAgent;return-1!==(e=t.indexOf("Edge"))?{name:"Edge",version:t.substring(e+5,e+11)}:-1!==(e=t.indexOf("Chrome"))?{name:"Chrome",version:t.substring(e+7,e+11)}:-1!==(e=t.indexOf("MSIE"))||-1!==(e=t.indexOf("rv"))&&-1!==t.indexOf("Trident")?{name:"ie",version:t.substring(e+5,e+9)}:-1!==(e=t.indexOf("Firefox"))?{name:"Firefox",version:t.substring(e+8,e+12)}:-1!==(e=t.indexOf("Safari"))?{name:"Safari",version:t.substring(e+7,e+11)}:{name:"default",version:"Not Known"}},p=g(),m=function(e,t,r,n){void 0===n&&(n={});var a,i,o=g(),s=n.chartId,c=n.exportCallback,d=n.paper,f=t;"Chrome"===o.name||"Firefox"===o.name||"Safari"===o.name?("blob"===e&&(f=l.URL.createObjectURL(f)),(i=u.createElement("a")).download=r,i.href=f,u.body.appendChild(i),i.onclick=function(){c&&l[c]&&"function"==typeof l[c]&&l[c]({statusCode:1,statusMessage:"success",DOMId:s,width:d&&d.width,height:d&&d.height}),i.parentNode.removeChild(i)},i.click()):"ie"!==o.name&&"Edge"!==o.name||l.navigator.msSaveBlob&&(a="url"===e?function(e){var t,r,n,a;for(t=e.split(",")[0].indexOf("base64")>=0?l.atob(e.split(",")[1]):l.unescape(e.split(",")[1]),r=e.split(",")[0].split(":")[1].split(";")[0],n=new Uint8Array(t.length),a=0;a<t.length;a++)n[a]=t.charCodeAt(a);return new l.Blob([n],{type:r})}(f):f,l.navigator.msSaveBlob(a,r)&&c&&l[c]&&"function"==typeof l[c]&&l[c]({statusCode:1,statusMessage:"success",DOMId:s,width:d&&d.width,height:d&&d.height}))},v=function(e,t,r,n){if(t&&r)if("blob"===e){var a=new FileReader;a.readAsDataURL(t),a.onloadend=function(){var e=a.result;b(e,r)}}else b(t,r);else if(n){var i,o=n.parameters.split("|"),s=o[0].substr(o[0].indexOf("=")+1),c=o[1].substr(o[1].indexOf("=")+1),u=s+"."+c;i="svg"===c?"data:image/svg+xml;base64,"+l.btoa(l.unescape(encodeURIComponent(n.stream))):n.stream,b(i,u)}},b=function(e,t){var r={edata:e,name:t,eventName:"download"};window.webViewBridge.send(null,r)};t.drawSvgOnCanvas=function(e,t){void 0===e&&(e={});var r,n,i,s,u=e,d=u.svg,f=u.canvas,h=u.x,g=u.y,m=u.width,v=u.height,b=u.useCanvas;"ie"===p.name||"Edge"===p.name||b?new a["default"](d,f,h,g,m,v,(function(){t()})):(s=function(e){return'<?xml version="1.0" standalone="no"?>\n      <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN"\n       "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> '+e}(d),i=s="data:image/svg+xml;base64,"+l.btoa(l.unescape(encodeURIComponent(s))),r=f.getContext("2d"),(n=new c).onload=function(){r.drawImage(n,h,g,m,v),t()},n.onerror=function(){(0,o.raiseWarning)(this,"","run","libSVGToCanvas:drawSvgOnCanvas","Unable to load image for canvas drawing. Aborting attempt.")},n.src=i)},t.downloadCharts=function(e,t,r,n,a){var c,h=/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent),g=window.location.href.match(/:\/\/(www[0-9]?\.)?((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:(?![\/:])[\s\S])+)/);h&&!g?v(e,t,r,n):!t||(c=t,p.name.toLowerCase()==="Chrome".toLowerCase()&&function(e){var t,r,n;for(t=e.length,n=e.length-1;n>=0;n--)(r=e.charCodeAt(n))>127&&r<=2047?t++:r>2047&&r<=65535&&(t+=2),r>=56320&&r<=57343&&n--;return t}(c)>void 0)?n&&function(e,t){var r,n,a,c,h,g,p,m,v=t.exportAction,b=t.exportTargetWindow,y=t.exportCallback,x=t.fusionCharts.apiInstance,w=t.paper,C=t.chartId,k=t.exportHandler,_=e.parameters;if(v===d||v===f){for(r in/(webkit|gecko)/gi.test(l.navigator.userAgent)&&"_self"===b&&(b=a=C+"export_iframe",m||(m=c=(0,i.createElement)("IFRAME",{name:a,width:"1px",height:"1px"},u.body),c.style.cssText="position:absolute;left:-10px;top:-10px;")),n=(0,i.createElement)("form",{method:"POST",action:k,target:b,style:"display:none;"},u.body),e)(0,i.createElement)("input",{type:"hidden",name:r,value:e[r]},n);return n.submit(),u.body.removeChild(n),n=void 0,g=_.match(/exportfilename=([^|]+)/)[1],p=_.match(/exportformat=([^|]+)/)[1],(0,o.triggerEvent)("exported",x,{DOMId:C,height:w.height,width:w.width,fileName:g+"."+p,statusCode:void 0,statusMessage:void 0,notice:void 0}),y&&l[y]&&"function"==typeof l[y]&&l[y]({statusCode:1,statusMessage:"success",DOMId:C,width:w&&w.width,height:w&&w.height}),!0}for(r in h=new s["default"]((function(e){var t={};e.replace(new RegExp("([^?=&]+)(=([^&]*))?","g"),(function(e,r,n,a){t[r]=a})),y&&l[y]&&"function"==typeof l[y]&&l[y](t),(0,o.triggerEvent)("exported",x,t)}),(function(e){var t={statusCode:0,statusMessage:"failure",error:e,DOMId:C,width:w&&w.width,height:w&&w.height};y&&l[y]&&"function"==typeof l[y]&&l[y](t),(0,o.triggerEvent)("exported",x,t,[t])})),e)e.hasOwnProperty(r)&&(e[r]=encodeURIComponent(e[r]));h.post(k,e)}(n,a):m(e,t,r,a)},t.browserDetails=p,t.isCanvasElemSupported=h,p.hasCanvas=h(),p.hasSvg=i.hasSVG},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n,a="undefined"!=typeof window?window:null,i=a.document,o={},s={};(n=function(e,t,r,a,i,o,s){var l={svg:"",context:"",callBack:"",imageArr:[],canvas:"",dimention:{}};if(!(this instanceof n))throw new Error("This function should be used as class");this._getStore=function(e){return"undefined"!=typeof l[e]&&l[e]},this._setStore=function(e,t){"undefined"!=typeof l[e]&&(l[e]=t)},this._setStore("dimention",{x:r,y:a,width:i,height:o}),e&&this.setSVG(e),t&&this.setContext(t),s&&this.setCallback(s),this.drawOnCanvas()}).prototype.setContext=function(e){var t;if(!e.getContext||!e.getContext("2d"))throw new Error("Please provide valid canvas");t=e.getContext("2d"),this._setStore("canvas",e),this._setStore("context",t)},n.prototype.getContext=function(){return this._getStore("context")},n.prototype.setSVG=function(e){var t;if("undefined"!=typeof e.documentElement)t=e,this._setStore("svg",t);else{if("<"!==e.substr(0,1))throw new Error("Please provide valid SVG");t=s.StrToDom(e),this._setStore("svg",t)}},n.prototype.getSVG=function(){return this._getStore("svg")},n.prototype.setCallback=function(e){"function"==typeof e&&this._setStore("callBack",e)},n.prototype.getCallback=function(){return this._getStore("callBack")},n.prototype.drawOnCanvas=function(e,t,r,n,a,i,o){var l,c,u,d,f,h,g,p;e&&this.setSVG(e),t&&this.setContext(t),o&&this.setCallback(o),t=t||this._getStore("canvas"),g=this._getStore("dimention"),o=this.getCallback(),l=this.getContext(),(c=this.getSVG())&&l&&(u=(p=s.getSvgDimention(c)).width,d=p.height,r=r||g.x||0,n=n||g.y||0,a=a||u||g.width,i=i||d||g.height,f=p.width?g.width/a:1,h=p.height?g.height/i:1,s.startTransform("translate("+r+","+n+") scale("+f+","+h+")",l),l.save(),l.fillStyle="#ffffff",l.fillRect(0,0,a,i),l.restore(),s.storeImagesInArr(this),s.drawNodes([c],[],this,l,(function(){"function"==typeof o&&o(),s.resetTransform(l)})))},o.common=function(e,t,r,n,a){var i,l,c,u,d=e.childNodes,f=function(){e.attributes&&n.restore(),a&&a()};for(l in t)t.hasOwnProperty(l)&&"class"!==t[l].name&&"id"!==t[l].name&&"transform"!==t[l].name&&"clip-path"!==t[l].name&&"object"==typeof t[l]&&e.attributes&&!e.attributes[t[l].name]&&e.setAttribute([t[l].name],t[l].value);if(e.attributes&&e.attributes.style)for(l in c=e.attributes.style.value.replace(/;$/,"").split(";"))if(c.hasOwnProperty(l)&&(u=c[l].split(":")[0].trim(),!e.attributes[u]||"undefined"===e.attributes[u].value))try{e.setAttribute(u,c[l].split(":")[1].trim())}catch(h){}e.attributes&&(n.save(),e.attributes.transform&&s.startTransform(e.attributes.transform.value,n),e.attributes["clip-path"]&&s.applyClip(e.attributes["clip-path"].value,n,r)),0===d.length||1===d.length&&!d[0].tagName?"undefined"!=typeof e.tagName?(i="draw"+e.tagName,o[i]?e.attributes.display&&"none"===e.attributes.display.value?f():o[i](e,n,r,"draw",f):f()):f():s.drawNodes(d,"svg"===e.tagName?[]:e.attributes,r,n,f)},o.drawtext=function(e,t,r,n,a){this.drawtspan(e,t,r,n,a)},o.drawtspan=function(e,t,r,n,o){var l,c,u,d,f,h=e.innerHTML||e.textContent,g=e.attributes.x?e.attributes.x.value:0,p=e.attributes.y?e.attributes.y.value:0,m=e.attributes.dx?e.attributes.dx.value:0,v=e.attributes.dy?e.attributes.dy.value:0,b="serief",y="normal",x="16px",w=[];i.getElementsByTagName("body")[0]&&((l=a.getComputedStyle(i.getElementsByTagName("body")[0],null)).getPropertyValue("font-family")&&(b=l.getPropertyValue("font-family")),l.getPropertyValue("font-weight")&&(y=l.getPropertyValue("font-weight")),l.getPropertyValue("font-size")&&(x=l.getPropertyValue("font-size"))),c=e.attributes["font-family"]?e.attributes["font-family"].value:b,u=e.attributes["font-weight"]?e.attributes["font-weight"].value:y,d=e.attributes["text-anchor"]?e.attributes["text-anchor"].value:"start",f=e.attributes["font-size"]?e.attributes["font-size"].value:x,g=Number(g)+Number(m),p=Number(p)+Number(v),h=h.trim(),d="middle"===d?"center":d,t.save(),t.font=u+" "+f+" "+c,t.textAlign=d,"draw"===n&&((!e.attributes.fill||e.attributes.fill&&"none"!==e.attributes.fill.value)&&(s.applyFillEffect(e,t,r,w),t.fillText(h,g,p),s.endFillEffect(e,t)),(!e.attributes.stroke||e.attributes.stroke&&"none"!==e.attributes.stroke.value)&&(s.applyStrokeEffect(e,t,r,w),t.strokeText(h,g,p),s.endStrokeEffect(e,t))),t.restore(),"function"==typeof o&&o()},o.drawcircle=function(e,t,r,n,a){var i=Number(e.attributes.cx.value),o=Number(e.attributes.cy.value),l=Number(e.attributes.r.value),c=[];t.beginPath(),t.arc(i,o,l,0,2*Math.PI),s.bBoxFromPoint([i,1*i+1*l,1*i-1*l],[o,1*o+1*l,1*o-1*l],c),"draw"===n&&((!e.attributes.fill||e.attributes.fill&&"none"!==e.attributes.fill.value)&&(s.applyFillEffect(e,t,r,c),t.fill(),s.endFillEffect(e,t)),(!e.attributes.stroke||e.attributes.stroke&&"none"!==e.attributes.stroke.value)&&(s.applyStrokeEffect(e,t,r,c),t.stroke(),s.endStrokeEffect(e,t))),t.closePath(),"function"==typeof a&&a()},o.drawrect=function(e,t,r,n,a){var i=e.attributes.x?Number(e.attributes.x.value):0,o=e.attributes.y?Number(e.attributes.y.value):0,l=e.attributes.rx?Number(e.attributes.rx.value):0,c=e.attributes.ry?Number(e.attributes.ry.value):0,u=Number(e.attributes.height.value),d=Number(e.attributes.width.value),f=[],h=t.lineCap;t.lineCap="square",s.bBoxFromPoint([i,i+d],[o,o+u],f),t.beginPath(),t.moveTo(i+l,o),t.lineTo(i+d-l,o),t.quadraticCurveTo(i+d,o,i+d,o+c),t.lineTo(i+d,o+u-c),t.quadraticCurveTo(i+d,o+u,i+d-l,o+u),t.lineTo(i+l,o+u),t.quadraticCurveTo(i,o+u,i,o+u-c),t.lineTo(i,o+c),t.quadraticCurveTo(i,o,i+l,o),"draw"===n&&((!e.attributes.fill||e.attributes.fill&&"none"!==e.attributes.fill.value)&&(s.applyFillEffect(e,t,r,f),t.fill(),s.endFillEffect(e,t)),(!e.attributes.stroke||e.attributes.stroke&&"none"!==e.attributes.stroke.value)&&(s.applyStrokeEffect(e,t,r,f),t.stroke(),s.endStrokeEffect(e,t))),t.closePath(),t.lineCap=h,"function"==typeof a&&a()},o.drawellipse=function(e,t,r,n,a){var i=Number(e.attributes.cx.value),o=Number(e.attributes.cy.value),l=Number(e.attributes.rx.value),c=Number(e.attributes.ry.value),u=.5522848*l,d=.5522848*c,f=i+l,h=o+c,g=[];t.beginPath(),t.moveTo(i-l,o),t.bezierCurveTo(i-l,o-d,i-u,o-c,i,o-c),t.bezierCurveTo(i+u,o-c,f,o-d,f,o),t.bezierCurveTo(f,o+d,i+u,h,i,h),t.bezierCurveTo(i-u,h,i-l,o+d,i-l,o),s.bBoxFromPoint([i+l,i-l],[o+c,o-c],g),"draw"===n&&((!e.attributes.fill||e.attributes.fill&&"none"!==e.attributes.fill.value)&&(s.applyFillEffect(e,t,r,g),t.fill(),s.endFillEffect(e,t)),(!e.attributes.stroke||e.attributes.stroke&&"none"!==e.attributes.stroke.value)&&(s.applyStrokeEffect(e,t,r,g),t.stroke(),s.endStrokeEffect(e,t))),t.closePath(),"function"==typeof a&&a()},o.drawimage=function(e,t,r,n,a){var i,o=e.attributes.x?Number(e.attributes.x.value):0,s=e.attributes.y?Number(e.attributes.y.value):0,l=e.attributes.height?Number(e.attributes.height.value):0,c=e.attributes.width?Number(e.attributes.width.value):0,u=r._getStore("imageArr");t.save(),e.attributes.opacity&&(t.globalAlpha=e.attributes.opacity.value),e.attributes["xlink:href"]?(i=e.attributes["xlink:href"].value,"complete"===u[i].status?(t.drawImage(u[i].obj,o,s,c,l),t.globalAlpha=1,t.restore(),"function"==typeof a&&a()):"error"===u[i].status?(t.globalAlpha=1,t.restore(),"function"==typeof a&&a()):"progress"===u[i].status?(u[i].callback=function(){t.drawImage(u[i].obj,o,s,c,l),t.globalAlpha=1,t.restore(),"function"==typeof a&&a()},u[i].errCallback=function(){t.globalAlpha=1,t.restore(),"function"==typeof a&&a()}):(t.globalAlpha=1,t.restore(),"function"==typeof a&&a())):(t.globalAlpha=1,t.restore(),"function"==typeof a&&a())},o.drawpath=function(e,t,r,n,a){var i,o,l,c,u=e.attributes.d.value.match(/[a-z][^a-z"]*/gi),d=[],f=0,h=0,g={};for(i in t.beginPath(),u)if(u.hasOwnProperty(i))switch(o=u[i].substring(0,1),l=s.getArgsAsArray(u[i].substring(1,u[i].length)),o){case"M":f=Number(l[0]),h=Number(l[1]),t.moveTo(f,h),g.cx=f,g.cy=h;break;case"m":f+=Number(l[0]),h+=Number(l[1]),t.moveTo(f,h),g.cx=f,g.cy=h;break;case"L":for(c=0;l[c];c+=2)s.bBoxFromPoint([f,l[c]],[h,l[c+1]],d),f=Number(l[c]),h=Number(l[c+1]),t.lineTo(f,h);break;case"l":for(c=0;l[c];c+=2)s.bBoxFromPoint([f,1*f+1*l[c]],[h,1*h+1*l[c+1]],d),f+=Number(l[c]),h+=Number(l[c+1]),t.lineTo(f,h);break;case"V":for(c=0;l[c];c+=1)s.bBoxFromPoint([f],[h,l[c]],d),h=Number(l[c]),t.lineTo(f,h);break;case"v":for(c=0;l[c];c+=1)s.bBoxFromPoint([f],[h,1*h+1*l[c]],d),h+=Number(l[c]),t.lineTo(f,h);break;case"H":for(c=0;l[c];c+=1)s.bBoxFromPoint([f,l[c]],[h],d),f=Number(l[c]),t.lineTo(f,h);break;case"h":for(c=0;l[c];c+=1)s.bBoxFromPoint([f,1*f+1*l[c]],[h],d),f+=Number(l[c]),t.lineTo(f,h);break;case"Q":for(c=0;l[c];c+=4)s.qBezierBBox(f,h,l[c],l[c+1],l[c+2],l[c+3],d),t.quadraticCurveTo(Number(l[c]),Number(l[c+1]),Number(l[c+2]),Number(l[c+3])),f=Number(l[c+2]),h=Number(l[c+3]);break;case"q":for(c=0;l[c];c+=4)s.qBezierBBox(f,h,f+1*l[c],h+1*l[c+1],1*f+1*l[c+2],1*h+1*l[c+3],d),t.quadraticCurveTo(f+1*l[c],h+1*l[c+1],f+=Number(l[c+2]),h+=Number(l[c+3]));break;case"C":for(c=0;l[c];c+=6)s.cBezierBBox(f,h,l[c],l[c+1],l[c+2],l[c+3],l[c+4],l[c+5],d),t.bezierCurveTo(l[c],l[c+1],l[c+2],l[c+3],l[c+4],l[c+5]),f=Number(l[c+4]),h=Number(l[c+5]);break;case"c":for(c=0;l[c];c+=6)s.cBezierBBox(f,h,f+1*l[c],1*h+1*l[c+1],f+1*l[c+2],1*h+1*l[c+3],f+1*l[c+4],1*h+1*l[c+5],d),t.bezierCurveTo(f+Number(l[c]),h+Number(l[c+1]),f+Number(l[c+2]),h+Number(l[c+3]),f+=Number(l[c+4]),h+=Number(l[c+5]));break;case"a":case"A":for(c=0;l[c];c+=7){var p,m,v,b,y,x,w,C,k,_,S,E,A,N,T,M,D,F,I=Number(l[c]),O=Number(l[c+1]);if(p=Number(l[c+2])*(Math.PI/180),m=Number(l[c+3]),v=Number(l[c+4]),b=Number(l[c+5]),y=Number(l[c+6]),x=Math.cos(p)*(f-b)/2+Math.sin(p)*(h-y)/2,w=-Math.sin(p)*(f-b)/2+Math.cos(p)*(h-y)/2,I=I<0?-I:I,O=O<0?-O:O,(T=Math.pow(x,2)/Math.pow(I,2)+Math.pow(w,2)/Math.pow(O,2))>1&&(I*=Math.sqrt(T),O*=Math.sqrt(T)),M=I>O?I:O,D=I>O?1:I/O,F=I>O?O/I:1,C=(m===v?-1:1)*Math.sqrt((Math.pow(I,2)*Math.pow(O,2)-Math.pow(I,2)*Math.pow(w,2)-Math.pow(O,2)*Math.pow(x,2))/(Math.pow(I,2)*Math.pow(w,2)+Math.pow(O,2)*Math.pow(x,2))),isNaN(C)&&(C=0),_=O*x*-C/I,S=(k=C*(I*w)/O)*Math.cos(p)-_*Math.sin(p)+(f+b)/2,E=k*Math.sin(p)+_*Math.cos(p)+(h+y)/2,A=s.angleBetweenVectors(1,0,(x-k)/I,(w-_)/O),N=s.angleBetweenVectors((x-k)/I,(w-_)/O,(-x-k)/I,(-w-_)/O),0===v&&N>0&&(N-=Math.PI/180*360),1===v&&N<0&&(N+=Math.PI/180*360),0===I&&0===O){t.lineTo(b,y);break}t.save();var L=s.combineTransformMatrix([[1,0,S,0,1,E],[Math.cos(p),Math.sin(p),0,Math.sin(p),Math.cos(p),0],[D,0,0,0,F,0]]);t.transform(L[0],L[3],L[1],L[4],L[2],L[5]),t.arc(0,0,M,A,A+N,1-v),t.restore(),s.arcBBox(0,0,M,A,A+N,1-v,[L[0],L[3],L[1],L[4],L[2],L[5]],d),"A"===o?(f=Number(l[c+5]),h=Number(l[c+6])):(f+=Number(l[c+5]),h+=Number(l[c+6]))}break;case"Z":case"z":t.closePath(),f=g.cx,h=g.cy}"draw"===n&&((!e.attributes.fill||e.attributes.fill&&"none"!==e.attributes.fill.value)&&(s.applyFillEffect(e,t,r,d),t.fill(),s.endFillEffect(e,t)),(!e.attributes.stroke||e.attributes.stroke&&"none"!==e.attributes.stroke.value)&&(s.applyStrokeEffect(e,t,r,d),t.stroke(),s.endStrokeEffect(e,t)),a())},s.drawNodes=function(e,t,r,n,a){var i=e.length,s=-1,l=0,c=0;!function u(){var d;(s+=1)<i?((d=e[s]).tagName&&"defs"===d.tagName&&(d=e[s+=1]),d.attributes&&(d.attributes.dy&&(c=d.attributes.dy.value=1*d.attributes.dy.value+1*c),d.attributes.dx&&(l=d.attributes.dx.value=1*d.attributes.dx.value+1*l)),o.common(d,t,r,n,u)):a&&a()}()},s.getSvgDimention=function(e){var t,r={width:0,height:0};return t=e.childNodes&&e.childNodes[0]&&e.childNodes[0].attributes,r.width=Number(t.width&&t.width.value||0),r.height=Number(t.height&&t.height.value||0),r},s.storeImagesInArr=function(e){var t,r,n,a,i=e.getSVG();for(a in n=e._getStore("imageArr"),t=i.getElementsByTagName("image"))t.hasOwnProperty(a)&&t[a].attributes&&t[a].attributes["xlink:href"]&&(r=t[a].attributes["xlink:href"].value,n[r]||(n[r]=[],n[r].status="progress",n[r].callback=null,n[r].obj=new Image,n[r].obj.onload=function(e){return function(){var t=n[e].callback;t?(n[e].status="complete",t()):n[e].status="complete"}}(r),n[r].obj.onerror=function(e){return function(){var t=n[e].errCallback;t?(n[e].status="error",t()):n[e].status="error"}}(r),n[r].obj.src=r))},s.startTransform=function(e,t){var r,n,a=e.match(/[^\s][a-z,0-9.\-(\s]+\)/gi);for(n in a)a.hasOwnProperty(n)&&(a[n].indexOf("matrix")>-1&&(r=s.stringToArgs(a[n]),t.transform(r[0],r[1],r[2],r[3],r[4],r[5])),a[n].indexOf("translate")>-1&&(r=s.stringToArgs(a[n]),t.translate(r[0]||0,r[1]||0)),a[n].indexOf("rotate")>-1&&(3===(r=s.stringToArgs(a[n])).length?(t.translate(r[1],r[2]),t.rotate(r[0]*(Math.PI/180)),t.translate(-r[1],-r[2])):t.rotate(r[0]*(Math.PI/180))),a[n].indexOf("scale")>-1&&(1===(r=s.stringToArgs(a[n])).length?t.scale(r[0]||1,r[0]||1):t.scale(r[0]||1,r[1]||1)),a[n].indexOf("skewX")>-1&&(r=s.stringToArgs(a[n]),t.transform(1,0,Math.tan(r[0]*(Math.PI/180)),1,0,0)),a[n].indexOf("skewY")>-1&&(r=s.stringToArgs(a[n]),t.transform(1,Math.tan(r[0]*(Math.PI/180)),0,1,0,0)))},s.resetTransform=function(e){e.setTransform(1,0,0,1,0,0)},s.stringToArgs=function(e){var t=/\(([^)]+)/.exec(e)[1];return s.getArgsAsArray(t)},s.getArgsAsArray=function(e){var t;for(e=e.trim().split(/[\s,]+/),t=0;t<e.length;t++)e[t].trim(),0===e[t].length&&e.splice(t,1);return e},s.applyFillEffect=function(e,t,r,n){var a;e.attributes["fill-opacity"]&&"none"!==e.attributes["fill-opacity"].value?t.globalAlpha=e.attributes["fill-opacity"].value:t.globalAlpha=1,e.attributes.fill&&e.attributes.fill.value.indexOf("url(")>-1?(a=s.getFillStyleById(/url\(.*#([^)'"]+)/.exec(e.attributes.fill.value)[1],t,r,n),t.fillStyle=a):e.attributes.fill?t.fillStyle=e.attributes.fill.value:t.fillStyle="#000000"},s.endFillEffect=function(e,t){t.globalAlpha=1},s.applyStrokeEffect=function(e,t,r,n){e.attributes["stroke-opacity"]&&"none"!==e.attributes["stroke-opacity"].value&&(t.globalAlpha=e.attributes["stroke-opacity"].value),e.attributes["stroke-width"]&&(t.lineWidth=e.attributes["stroke-width"].value,"0"===e.attributes["stroke-width"].value&&(t.globalAlpha=0)),e.attributes["stroke-linecap"]&&"none"!==e.attributes["stroke-linecap"].value&&(t.lineCap=e.attributes["stroke-linecap"].value),e.attributes["stroke-linejoin"]&&"none"!==e.attributes["stroke-linejoin"].value&&(t.lineJoin=e.attributes["stroke-linejoin"].value),e.attributes["stroke-dasharray"]&&"none"!==e.attributes["stroke-dasharray"].value&&t.setLineDash&&t.setLineDash(s.getArgsAsArray(e.attributes["stroke-dasharray"].value)),e.attributes.stroke?t.strokeStyle=e.attributes.stroke.value:t.strokeStyle="#000000"},s.endStrokeEffect=function(e,t){e.attributes["stroke-opacity"]&&"none"!==e.attributes["stroke-opacity"].value&&(t.globalAlpha=1,t.setLineDash&&t.setLineDash([]),t.lineWidth=1),t.globalAlpha=1},s.applyClip=function(e,t,r){var n,a,i,l,c,u=r.getSVG();if(-1!==e.indexOf("url(")){for(l in n=/url\(.*#([^)'"]+)/.exec(e)[1],(a=u.getElementById(n)).attributes&&(t.save(),a.attributes.transform&&s.startTransform(a.attributes.transform.value,t)),i=a.childNodes)i.hasOwnProperty(l)&&i[l].tagName&&i[l].constructor!==Array&&(c="draw"+i[l].tagName,i[l].attributes&&(t.save(),i[l].attributes.transform&&s.startTransform(i[l].attributes.transform.value,t)),o[c]&&(o[c](i[l],t,r,"clip"),t.closePath()),i[l].attributes&&t.restore());a.attributes&&t.restore(),t.clip()}},s.getFillStyleById=function(e,t,r,n){var a=r.getSVG().getElementById(e);return"linearGradient"===a.tagName?s.getLinearGradient(a,t,n):"radialGradient"===a.tagName?s.getRadialGradient(a,t,n):"#FFFFFF"},s.getLinearGradient=function(e,t,r){var n,a,i,o,l,c=e.attributes.x1?s.getPercentValue(e.attributes.x1.value,r.xMax-r.xMin,r.xMin):0,u=e.attributes.y1?s.getPercentValue(e.attributes.y1.value,r.yMax-r.yMin,r.yMin):0,d=e.attributes.x2?s.getPercentValue(e.attributes.x2.value,r.xMax-r.xMin,r.xMin):0,f=e.attributes.y2?s.getPercentValue(e.attributes.y2.value,r.yMax-r.yMin,r.yMin):0;for(i in n=t.createLinearGradient(c,u,d,f),a=e.childNodes)a.hasOwnProperty(i)&&a[i].attributes&&a[i].attributes["stop-color"]&&(o=s.toRGB(a[i].attributes["stop-color"].value),l=a[i].attributes["stop-opacity"]?a[i].attributes["stop-opacity"].value:1,o.status?n.addColorStop(s.getPercentValue(a[i].attributes.offset.value,1,0),"rgba("+o.r+","+o.g+","+o.b+","+Number(l)+")"):n.addColorStop(s.getPercentValue(a[i].attributes.offset.value,1,0),a[i].attributes["stop-color"].value));return n},s.getRadialGradient=function(e,t,r){var n,a,i,o,l,c=e.attributes.cx?s.getPercentValue(e.attributes.cx.value,r.xMax-r.xMin,r.xMin):r.xMin+.5*(r.xMax-r.xMin),u=e.attributes.cy?s.getPercentValue(e.attributes.cy.value,r.yMax-r.yMin,r.yMin):r.yMin+.5*(r.yMax-r.yMin),d=e.attributes.fx?s.getPercentValue(e.attributes.fx.value,r.xMax-r.xMin,r.xMin):r.xMin+.5*(r.xMax-r.xMin),f=e.attributes.fy?s.getPercentValue(e.attributes.fy.value,r.yMax-r.yMin,r.yMin):r.yMin+.5*(r.yMax-r.yMin),h=e.attributes.r?s.getPercentValue(e.attributes.r.value,(r.yMax-r.yMin+r.xMax-r.xMin)/2,0):s.getPercentValue("50%",(r.yMax-r.yMin+r.xMax-r.xMin)/2,0);for(i in n=t.createRadialGradient(d,f,0,c,u,h),a=e.childNodes)a.hasOwnProperty(i)&&a[i].attributes&&a[i].attributes["stop-color"]&&(o=s.toRGB(a[i].attributes["stop-color"].value),l=a[i].attributes["stop-opacity"]?a[i].attributes["stop-opacity"].value:1,o.status?n.addColorStop(s.getPercentValue(a[i].attributes.offset.value,1,0),"rgba("+o.r+","+o.g+","+o.b+","+Number(l)+")"):n.addColorStop(s.getPercentValue(a[i].attributes.offset.value,1,0),a[i].attributes["stop-color"].value));return n},s.getPercentValue=function(e,t,r){var n;return-1!==e.indexOf("%")?((n=/(\d.*)%/.exec(e)[1])>100&&(n=100),n*t/100+1*r):e>1?e:e*t+1*r},s.bBoxFromPoint=function(e,t,r){"undefined"!=typeof r.xMin&&(e.push(r.xMin,r.xMax),t.push(r.yMin,r.yMax)),r.xMin=Math.min.apply(this,e),r.xMax=Math.max.apply(this,e),r.yMin=Math.min.apply(this,t),r.yMax=Math.max.apply(this,t)},s.arcBBox=function(e,t,r,n,a,i,o,s){var l,c,u,d,f,h,g,p,m,v,b;o instanceof Array&&(e=e*o[0]+e*o[2]+o[4],t=t*o[1]+t*o[3]+o[5]),b=function(e,t,r){return(e=(e+2*Math.PI)%(2*Math.PI))<=(t=(t+2*Math.PI)%(2*Math.PI))?e<=r&&r<=t:e>=t?!(e>=r&&r>=t):void 0},l=n%(2*Math.PI),c=a%(2*Math.PI),i&&(l=a%(2*Math.PI),c=n%(2*Math.PI)),u=e+r*Math.cos(l),d=t+r*Math.sin(l),m=[u,e+r*Math.cos(c)],v=[d,t+r*Math.sin(c)],b(l,c,0)&&(m.push(1*e+1*r),v.push(t)),b(l,c,.5*Math.PI)&&(m.push(e),v.push(1*t+1*r)),b(l,c,Math.PI)&&(m.push(e-1*r),v.push(t)),b(l,c,1.5*Math.PI)&&(m.push(e),v.push(t-1*r)),g=Math.max.apply(this,m),f=Math.min.apply(this,m),p=Math.max.apply(this,v),h=Math.min.apply(this,v),"undefined"!=typeof s.xMin?(s.xMin=Math.min(f,s.xMin),s.xMax=Math.max(g,s.xMax),s.yMin=Math.min(h,s.yMin),s.yMax=Math.max(p,s.yMax)):(s.xMin=f,s.xMax=g,s.yMin=h,s.yMax=p)},s.qBezierBBox=function(e,t,r,n,a,i,o){var s,l,c,u,d,f,h,g,p=1*e-2*r+1*a,m=1*t-2*n+1*i;0===p||0===m?(d=Math.max(e,a),c=Math.min(e,a),f=Math.max(t,i),u=Math.min(t,i)):(s=(e-r)/p,l=(t-n)/m,h=e*Math.pow(1-s,2)+2*r*(1-s)*s+a*Math.pow(s,2),g=t*Math.pow(1-l,2)+2*n*(1-l)*l+i*Math.pow(l,2),d=Math.max(e,a,h),c=Math.min(e,a,h),f=Math.max(t,i,g),u=Math.min(t,i,g)),"undefined"!=typeof o.xMin?(o.xMin=Math.min(c,o.xMin),o.xMax=Math.max(d,o.xMax),o.yMin=Math.min(u,o.yMin),o.yMax=Math.max(f,o.yMax)):(o.xMin=c,o.xMax=d,o.yMin=u,o.yMax=f)},s.cBezierBBox=function(e,t,r,n,a,i,o,s,l){var c,u,d,f,h,g,p,m,v,b,y,x,w;null===a&&null===i&&(a=t+2/3*(n-t),n=(r=e+2/3*(r-e))+1/3*(o-e),i=a+1/3*(s-t)),y=function(e,t,r,n,a){return e*Math.pow(1-a,3)+3*t*a*Math.pow(1-a,2)+3*r*a*a*(1-a)+n*a*a*a},h=3*o-9*a+9*r-3*e,g=6*e-12*r+6*a,p=3*r-3*e,o<(c=e)&&(c=o),o>(u=e)&&(u=o),(m=Math.pow(g,2)-4*h*p)>=0&&((v=(-g+Math.sqrt(m))/(2*h))>0&&v<1&&((x=y(e,r,a,o,v))<c&&(c=x),x>u&&(u=x)),(b=(-g-Math.sqrt(m))/(2*h))>0&&b<1&&((x=y(e,r,a,o,b))<c&&(c=x),x>u&&(u=x))),h=3*s-9*i+9*n-3*t,g=6*t-12*n+6*i,p=3*n-3*t,s<(d=t)&&(d=s),s>(f=t)&&(f=s),(m=Math.pow(g,2)-4*h*p)>=0&&((v=(-g+Math.sqrt(m))/(2*h))>0&&v<1&&((w=y(t,n,i,s,v))<d&&(d=w),w>f&&(f=w)),(b=(-g-Math.sqrt(m))/(2*h))>0&&b<1&&((w=y(t,n,i,s,b))<d&&(d=w),w>f&&(f=w))),"undefined"!=typeof l.xMin?(l.xMin=Math.min(c,l.xMin),l.xMax=Math.max(u,l.xMax),l.yMin=Math.min(d,l.yMin),l.yMax=Math.max(f,l.yMax)):(l.xMin=c,l.xMax=u,l.yMin=d,l.yMax=f)},s.combineTransformMatrix=function(e){var t,r,n=e.length-1;if(n<=0)return e[0];for(r=e[0],t=1;t<=n;t++)r[0]=r[0]*e[t][0]+r[1]*e[t][3],r[1]=r[0]*e[t][1]+r[1]*e[t][4],r[2]=r[0]*e[t][2]+r[1]*e[t][5]+1*r[2],r[3]=r[3]*e[t][0]+r[4]*e[t][3],r[4]=r[3]*e[t][1]+r[4]*e[t][4],r[5]=r[3]*e[t][2]+r[4]*e[t][5]+1*r[5];return r},s.angleBetweenVectors=function(e,t,r,n){var a=e*n<t*r?-1:1,i=e*r+t*n,o=Math.sqrt(Math.pow(e,2)+Math.pow(t,2)),s=Math.sqrt(Math.pow(r,2)+Math.pow(n,2));return a*Math.acos(i/(o*s))},s.toRGB=function(e){var t,r,n,a={r:0,g:0,b:0,status:0};return r=function(e){for(n in e)e.hasOwnProperty(n)&&(e[n]<0||isNaN(e[n])?e[n]=0:e[n]>255&&(e[n]=255));return a={r:e[0],g:e[1],b:e[2],status:1}},(e=e.trim()).match(/^rgb\(|^rgba\(/i)?(t=/\(\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})/.exec(e),r([parseInt(t[1]),parseInt(t[2]),parseInt(t[3])])):e.match(/^#/)&&(t=/(\w{2})(\w{2})(\w{2})/.exec(e),r([parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)])),a},s.StrToDom=function(e){var t;return a.DOMParser?t=(new DOMParser).parseFromString(e,"text/xml"):((t=new a.ActiveXObject("Microsoft.XMLDOM")).async=!1,t.loadXML(e)),t};var l=n;t["default"]=l},function(e,t,r){"use strict";t.__esModule=!0,t.addImage=function(e,t,r){l=t,c=r,o=[],s=0,n=void 0,a=void 0,i=void 0,n=l||500,a=c||500,i=atob(/base64,(.+?)$/g.exec(e)[1]);var l,c},t.getDataUrl=function(){return"data:application/pdf;base64,"+btoa(function(){var e,t,r=[];for(l("%PDF-1.7"),r[1]=s,l("1 0 obj"),l("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),l("endobj"),r[4]=s,l("4 0 obj"),l("<< /Length 36>>"),l("stream"),l("q "+a+" 0 0 "+n+" 0 0 cm /Im3 Do Q"),l("endstream"),l("endobj"),r[5]=s,l("5 0 obj"),l("<</Type /Page /Parent 2 0 R /MediaBox [0 0 "+a+" "+n+"] /Contents [4 0 R ] /Resources <</ProcSet 1 0 R /Font <<>> /XObject <</Im3 3 0 R >> >> >>"),l("endobj"),r[3]=s,l("3 0 obj"),l("<</Type /XObject /Subtype /Image /Width "+a+" /Height "+n+" /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length "+i.length+">>"),l("stream"),l(i),l("endstream"),l("endobj"),r[2]=s,l("2 0 obj"),l("<</Type /Pages /Kids [5 0 R ] /Count 1>>"),l("endobj"),r[6]=s,l("6 0 obj"),l("<</Type /Catalog /Pages 2 0 R >>"),l("endobj"),e=s,l("xref"),l("0 7"),l("0000000000 65535 f "),t=1;t<=6;t++)l(("0000000000"+r[t]).slice(-10)+" 00000 n ");return l("trailer"),l("<</Size 7 /Root 6 0 R >>"),l("startxref"),l(e),l("%%EOF"),o.join("\n")}())};var n,a,i,o=[],s=0;function l(e){s+=e.length+1,o.push(e)}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n,a,i=r(393),o=r(395),s=r(224),l=r(392),c=r(231),u=window,d=Math.max,f=u.Image,h=u.navigator.userAgent.match(/(iPad|iPhone|iPod)/g),g="https:"===u.location.protocol?"https://export.api3.fusioncharts.com/api/v1.0/logs":"http://export.api3.fusioncharts.com/api/v1.0/logs",p="https:"===u.location.protocol?"https://export.api3.fusioncharts.com/":"http://export.api3.fusioncharts.com/",m=function(e){return!e.match(/http:\/\/|https:\/\//)||!/(http:\/\/|https:\/\/)([^\/\:]*)/.exec(e)[2]||u.location.hostname===/(http:\/\/|https:\/\/)([^\/\:]*)/.exec(e)[2]},v=function(e,t,r,n){var a=e,i=t;return isNaN(a)&&(a=(0,s.pluckNumber)(t,n)*(r/n)),isNaN(i)&&(i=(0,s.pluckNumber)(e,r)*(n/r)),{width:a,height:i}},b=function(){(0,c.triggerEvent)("exportcancelled")};function y(){var e,t,r,y,x,w,C,k,_,S,E,A,N,T=arguments[0],M=T||{},D=0,F=!1,I={exportTargetWindow:(0,s.pluck)(M.exportTargetWindow,h?"_parent":"_self"),exportAction:M.exportAction&&"string"==typeof M.exportAction?(A=M.exportAction.toLowerCase(),[l.EXPORTACTION.DOWNLOAD,l.EXPORTACTION.SAVE,l.EXPORTACTION.DOWNLOADSAVE].indexOf(A)>=0?A:l.EXPORTACTION.DOWNLOAD):l.EXPORTACTION.DOWNLOAD,exportFileName:(0,s.pluck)(M.exportFileName,"FusionCharts"),exportHandler:(0,s.pluck)(M.exportHandler,p),exportParameters:(0,s.pluck)(M.exportParameters,""),exportFormat:(0,s.pluck)(M.exportFormat,l.EXPORTFORMAT.PNG),exportCallback:(0,s.pluck)(M.exportCallback,""),exportAtClientSide:(0,s.pluckNumber)(M.exportAtClientSide,1),exportMode:("undefined"!=typeof M.exportAtClientSide&&(E={1:l.EXPORTMODE.AUTO,0:l.EXPORTMODE.SERVER}[M.exportAtClientSide]),E=(E=M.exportMode||E||l.EXPORTMODE.AUTO).toLowerCase()),logEnabled:(0,s.pluckNumber)(M.logEnabled,0),logMode:(S=M.logMode,void 0!==S&&"string"==typeof S&&S.toUpperCase()in l.LOGMODE?l.LOGMODE[S.toUpperCase()]:l.LOGMODE.AUTO),logHandler:(0,s.pluck)(M.logHandler,g)},O=I.exportFormat.toLowerCase(),L=0,R=0,P=10,V=P/2,j=a.items,B=v,z=function(e,t,r){var n;return n=!!I.logEnabled,I.logMode===l.LOGMODE.CLIENT&&(n=!1),{charttype:"combined",stream_type:e||"",stream:t||"",is_single_export:!1,is_full_version:!1,version:s.PROJECT_VERSION,user_time_zone:-(new Date).getTimezoneOffset(),log_enabled:n,parameters:["exportfilename="+I.exportFileName,"exportformat="+I.exportFormat,"exportaction="+(0,l.createExportActionOldString)(I.exportAction),"exportactionnew="+I.exportAction,"configuredexportaction="+(r||I.exportAction),"exportparameters="+I].join("|")}},H=function(){return{chartType:"combined",isSingleExport:!1,isFullVersion:!1,exportAction:I.exportAction,userTimeZone:-(new Date).getTimezoneOffset(),exportFileName:[I.exportFileName,I.exportFormat].join("."),exportFormat:I.exportFormat,version:s.PROJECT_VERSION}},U=function(e){e===l.LOGMODE.CLIENT&&(0,l.logCharts)(H(),I)},G=function(e){var t,r,a;(0,c.triggerEvent)("beforeexport",n,n,n,(function(){r="undefined"!=typeof u.btoa&&("Chrome"===i.browserDetails.name||"Firefox"===i.browserDetails.name||"Safari"===i.browserDetails.name||"Edge"===i.browserDetails.name||"ie"===i.browserDetails.name),I.exportMode===l.EXPORTMODE.CLIENT||I.exportMode===l.EXPORTMODE.AUTO&&r?(I.exportAction!==l.EXPORTACTION.DOWNLOAD&&I.exportAction!==l.EXPORTACTION.DOWNLOADSAVE||(t=I.exportMode===l.EXPORTMODE.AUTO?z("IMAGE-DATA",e):null,(0,i.downloadCharts)("url",e,I.exportFileName+"."+O,t,I),(0,c.triggerEvent)("exported",n,{fileName:I.exportFileName+"."+O})),I.exportAction===l.EXPORTACTION.SAVE||I.exportAction===l.EXPORTACTION.DOWNLOADSAVE?(a=I.exportAction,I.exportAction===l.EXPORTACTION.DOWNLOADSAVE&&(I.exportAction=l.EXPORTACTION.SAVE),t=z("IMAGE-DATA",e,a),I.paper={width:n,height:n},I.fusionCharts={},(0,i.downloadCharts)(null,null,null,t,I),delete I.paper,delete I.fusioncharts,U(I.logMode)):I.logMode!==l.LOGMODE.SERVER&&(0,l.logCharts)(H(),I)):(t=z("IMAGE-DATA",e),I.paper={width:n,height:n},I.fusionCharts={},(0,i.downloadCharts)(null,null,null,t,I),delete I.paper,delete I.fusioncharts,U(I.logMode))}),b)},W=function(){if(0===(D-=1)&&F)switch(O){case"png":G(r.toDataURL("image/png"));break;case"jpeg":G(r.toDataURL("image/jpeg"));break;case"pdf":(0,o.addImage)(r.toDataURL("image/jpeg"),L,R),G((0,o.getDataUrl)());break;default:G(r.toDataURL("image/png"))}},$=function(){var e=this;(0,i.drawSvgOnCanvas)({svg:arguments[0],canvas:r,x:e.x,y:e.y,width:e.width,height:e.height,useCanvas:arguments[1]},W)},X=function(e){var t=M.background;(r=u.document.createElement("canvas")).id="newCanvas",r.width=R,r.height=L,r.style.border="1px solid black",(y=r.getContext("2d")).fillStyle=t&&t.bgColor||"#ffffff",y.fillRect(0,0,R,L),t&&t.bgImage&&m(t.bgImage)?((C=new f).src=t.bgImage,C._userData=t,y.globalAlpha=(0,s.pluckNumber)(t.bgImageAlpha,100)/100,C.onload=function(){var t=this._userData,r=(0,s.pluckNumber)(t.bgImageX,0),n=(0,s.pluckNumber)(t.bgImageY,0),a=B(Number(t.bgImageWidth),Number(t.bgImageHeight),this.width,this.height);try{y.drawImage(this,r,n,a.width,a.height)}finally{y.globalAlpha=1,e()}},C.onerror=function(){e()}):e()},Y=function(t,r){var n,i;(e=a.items[t]).jsVars.instanceAPI&&(x=(x=(x=(x=e.jsVars.instanceAPI.getFromEnv("paper").toSVG(!0)).replace(/NS\d+:/gi,"xlink:")).replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/gi,"$1M 0 0 L 0 0$2")).replace(/(xlink:title\s*=\s*)['"].*?["']/gi,""),D+=1,n=x,i=a.options["export"].useCanvas,(0,l.cacheAllImages)(n,!1,(function(){n=(0,l.replaceImagesWithNonDataUrl)(n),$.call(r||e,n,i)})))},q=function(){var e,r,n,a,i,o,s=M.charts;if(t=[],s)for(n in s)s.hasOwnProperty(n)&&(e=j[s[n].id])&&(r=s[n],i=e.width,o=e.height,isNaN(Number(i))&&(i=e.apiInstance.getFromEnv("chartWidth")),isNaN(Number(o))&&(o=e.apiInstance.getFromEnv("chartHeight")),a=B(Number(r.width),Number(r.height),i,o),t.push({id:e.id,width:a.width,height:a.height,x:r.x,y:r.y}));else for(n in j)j.hasOwnProperty(n)&&(i=(e=j[n]).width,o=e.height,isNaN(Number(i))&&(i=e.apiInstance.getFromEnv("chartWidth")),isNaN(Number(o))&&(o=e.apiInstance.getFromEnv("chartHeight")),t.push({id:e.id,width:i,height:o}))};if((N={})[l.EXPORTMODE.CLIENT]=1,N[l.EXPORTMODE.AUTO]=0,N[l.EXPORTMODE.SERVER]=0,I.exportatclientside=N[I.exportMode],i.browserDetails.hasCanvas){for(q(),_=0,w=t.length;_<w;_+=1)(k=t[_]).x=(0,s.pluckNumber)(k.x,V),k.y=(0,s.pluckNumber)(k.y,L+V),k.height=(0,s.pluckNumber)(k.height),k.width=(0,s.pluckNumber)(k.width),L=d(L,k.y+k.height),R=d(R,k.x+k.width);L=M.imageHeight||L+V,R=M.imageWidth||R+V,X((function(){for(_=0,w=t.length;_<w;_+=1)k=t[_],_===w-1&&(F=!0),Y(k.id,k)}))}}var x={extension:function(e){e.batchExport=y,a=e},name:"batchExportLinker",type:"extension",requiresFusionCharts:!0};t["default"]=x},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(398)),i=r(224),o=function(e){var t=e.sender;(function(e,t){return e.getType()===t})(t,"chartAPI")&&t.registerFactory("logo",(function(e){var t=e.getFromEnv("chart-attrib");(0,i.componentFactory)(e,a["default"],"logo",(0,i.getValidValue)(t.logourl,"")?1:0,[t])}))},s={extension:function(e){e.addEventListener("instantiated",o)},name:"LogoExtension",type:"extension",requiresFusionCharts:!0};t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=r(240),s=r(224),l={vAlign:"top",hAlign:"left"},c={link:{cursor:"pointer",_cursor:"pointer"},normal:{cursor:"default",_cursor:"normal"}},u={tr:{vAlign:"top",hAlign:"right"},bl:{vAlign:"bottom",hAlign:"left"},br:{vAlign:"bottom",hAlign:"right"},cc:{vAlign:"middle",hAlign:"middle"}},d=!(!window.SVGAngle&&!document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")),f=function(e){function t(){var t;t=e.call(this)||this;var r=(0,a["default"])(t);return r.config._context={},r.config.handler=function(e){var t=e.config;return{load:function(){var r,n=e.getGraphicalElement("logoImage"),a=e.getFromEnv("chartConfig"),i=a.borderWidth||0,o=t.logoPosition,l=t.logoScale,c=t.logoLeftMargin,u=t.logoTopMargin,f=t.logoURL,h=t.logoAlpha,g=t.logoPositionSTR,p=t.logoLink;n.show(),r=(0,s.setImageDisplayMode)("none",o.vAlign,o.hAlign,l,i,a.width,a.height,n._.RefImg),d&&(r.w=r.width||0,r.h=r.height||0),r.transform="T"+c+","+u,n.attr(r),e.getFromEnv("chart").fireChartInstanceEvent("LogoLoaded",{logoURL:f,logoAlpha:h,logoPosition:g,logoScale:l,logoLink:p})},error:function(r){var n=t.logoURL,a=t.logoAlpha,i=t.logoPositionSTR,o=t.logoScale,s=t.logoLink;e.getFromEnv("chart").fireChartInstanceEvent("LogoLoadError",{logoURL:n,logoAlpha:a,logoPosition:i,logoScale:o,logoLink:s,error:r})},mouseover:function(r){var n=(0,s.getMouseCoordinate)(e.getFromEnv("chartInstance").ref,r),a=t.logoURL,i=t.logoAlpha,o=t.logoPositionSTR,l=t.logoScale,c=t.logoLink;e.getFromEnv("chart").fireChartInstanceEvent("LogoRollover",{logoURL:a,logoAlpha:i,logoPosition:o||"tl",logoScale:l,logoLink:c,chartX:n.chartX,chartY:n.chartY,pageX:n.pageX,pageY:n.pageY})},mouseout:function(r){var n=(0,s.getMouseCoordinate)(e.getFromEnv("chartInstance").ref,r),a=t.logoURL,i=t.logoAlpha,o=t.logoPositionSTR,l=t.logoScale,c=t.logoLink;e.getFromEnv("chart").fireChartInstanceEvent("LogoRollout",{logoURL:a,logoAlpha:i,logoPosition:o||"tl",logoScale:l,logoLink:c,chartX:n.chartX,chartY:n.chartY,pageX:n.pageX,pageY:n.pageY})},click:function(r){var n=(0,s.getMouseCoordinate)(e.getFromEnv("chartInstance").ref,r),a=t.logoURL,i=t.logoAlpha,o=t.logoPositionSTR,l=t.logoScale,c=t.logoLink;e.getFromEnv("chart").fireChartInstanceEvent("LogoClick",{logoURL:a,logoAlpha:i,logoPosition:o||"tl",logoScale:l,logoLink:c,chartX:n.chartX,chartY:n.chartY,pageX:n.pageX,pageY:n.pageY},void 0,t.linkClickFN)}}}(r),r.config.linkClickFN=function(){var e=r.config.logoLink;e&&r.getFromEnv("linkClickFN").call({link:e},!0)},t}(0,i["default"])(t,e);var r=t.prototype;return r.configureAttributes=function(){var e=this.config,t=this.getFromEnv("chart-attrib");e.logoURL=(0,s.getValidValue)(t.logourl,""),e.logoPositionSTR=(0,s.pluck)(t.logoposition,"tl").toLowerCase(),e.logoPosition=u[e.logoPositionSTR]||l,e.logoAlpha=(0,s.pluckNumber)(t.logoalpha,100),e.logoLink=(0,s.getValidValue)(t.logolink),e.logoScale=(0,s.pluckNumber)(t.logoscale,100),e.logoLeftMargin=(0,s.pluckNumber)(t.logoleftmargin,0),e.logoTopMargin=(0,s.pluckNumber)(t.logotopmargin,0),this.setState("dirty",!0)},r._contextChanged=function(){var e,t=this.config,r=this.getFromEnv("chartConfig"),n=r.borderWidth,a=r.width,i=r.height;return n!==t._context.chartBorderWidth&&(t._context.chartBorderWidth=n,e=!0),a!==t._context.chartWidth&&(t._context.chartWidth=a,e=!0),i!==t._context.chartHeight&&(t._context.chartHeight=i,e=!0),e},r.draw=function(){var e=this.config,t=this.getGraphicalElement("logoImage"),r=e.logoURL,n=!this.getState("removed");(!n||this.getState("dirty")||this._contextChanged())&&r&&n&&(t=this.getFromEnv("animationManager").setAnimation({el:t||"image",attr:{opacity:.01*e.logoAlpha||1,src:r},component:this,container:this.getLinkedParent().getChildContainer("logoGroup")}),this.getGraphicalElement("logoImage")||(this.addGraphicalElement("logoImage",t),t.on("load",e.handler.load),t.on("error",e.handler.error),t.on("fc-click",e.handler.click),t.on("fc-mouseover",e.handler.mouseover),t.on("fc-mouseout",e.handler.mouseout)),t.css(c[e.logoLink?"link":"normal"]))},t}(o.ComponentInterface);t["default"]=f},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n={extension:function(e){e.addEventListener("register",(function(t,r){var n,a=r[0],i=r[1];if(a&&"string"==typeof a&&"theme"===a&&i&&"object"==typeof i){if(i instanceof Array)for(n=0;n<i.length;n++)e.addDep({extension:i[n],name:i[n].name+"Theme",type:"theme"});else e.addDep({extension:i,name:i.name+"Theme",type:"theme"});t.preventDefault()}}))},name:"ThemeEngine",type:"extension",requiresFusionCharts:!0};t["default"]=n},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n,a=r(231);(n={outputHelpers:{text:function(e,t){n.outputTo("#"+e.eventId+" ["+(e.sender.id||e.sender).toString()+'] fired "'+e.eventType+'" event. '+("error"===e.eventType||"warning"===e.eventType?t.message:""))},event:function(e,t){this.outputTo(e,t)},verbose:function(e,t){n.outputTo(e.eventId,e.sender.id,e.eventType,t)}},outputHandler:function(e,t){"function"==typeof n.outputTo&&n.currentOutputHelper(e,t)},currentOutputHelper:void 0,outputTo:void 0,enabled:!1}).currentOutputHelper=n.outputHelpers.text;var i={extension:function(e){e["debugger"]={outputFormat:function(e){var t=e;return!(!t||"function"!=typeof t.toLowerCase||"function"!=typeof n.outputHelpers[t=t.toLowerCase()])&&(n.currentOutputHelper=n.outputHelpers[t],!0)},outputTo:function(t){"function"==typeof t?n.outputTo=t:null===t&&(e["debugger"].enable(!1),delete n.outputTo)},enable:function(t,r,i){var o,s=t,l=r,c=i;return"object"==typeof s&&1===arguments.length&&(s=(o=s).state,l=o.outputTo,c=o.outputFormat),"function"==typeof s&&("string"!=typeof l||2!==arguments.length&&!o||(c=l),l=s,s=!0),"boolean"==typeof s&&s!==n.enabled&&(n.enabled=s,n.enabled?(0,a.addListener)("*",n.outputHandler):(0,a.removeListener)("*",n.outputHandler)),"function"==typeof l&&(n.outputTo=l),e["debugger"].outputFormat(c),n.enabled}}},name:"Debugger",type:"extension",requiresFusionCharts:!0};t["default"]=i},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(402)),i=r(224),o=r(236),s=0;function l(e,t){var r=this.apiInstance,n=e||void 0,l=t||void 0,c=r.getChildren("dataset")[0],u=c.getChildren(),d=u.centerLabel&&u.centerLabel[0],f=r.config;void 0===d&&((0,i.componentFactory)(c,a["default"],"centerLabel",1,[f]),d=u.centerLabel&&u.centerLabel[0]),r.addJob("eiMethods-center-lebel"+s++,(function(){var e,t,a=r.getDatasets()[0],i=a.config.piePlotOptions.innerSize;if(e=d.config,"object"!=typeof l)l=e;else{for(t in e)void 0===l[t]&&(l[t]=e[t]);e=Object.assign(e,l)}l.label=n,e.label=n,a.centerLabelConfig=e,i&&d&&d.draw(n||"")}),o.priorityList.postRender)}var c={extension:function(e){e.addEventListener("instantiated",(function(e){var t=e.sender;(function(e){var t=e.getName().toLowerCase();return("doughnut2d"===t||"multilevelpie"===t)&&"dataset"===e.getType()})(t)&&t.registerFactory("centerLabel",(function(){var e=t.getFromEnv("chartConfig"),r=!(!e.centerlabel&&!e.defaultcenterlabel);t.getFromEnv("chartInstance").centerLabel=l,(0,i.componentFactory)(t,a["default"],"centerLabel",r?1:0,[e])}))}))},name:"CenterLabelExtension",type:"extension",requiresFusionCharts:!0};t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=r(232),l=n(r(403));(0,s.addDep)({name:"centerLabelAnimation",type:"animationRule",extension:l["default"]});var c=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"centerLabel"},r.getType=function(){return"centerLabel"},r.configure=function(e){var t=this.getFromEnv("chart-attrib"),r=this.getFromEnv("number-formatter"),n=e.dataLabelStyle,a=this;a.config={label:(0,o.parseUnsafeString)((0,o.pluck)(t.defaultcenterlabel,"")),font:(0,o.pluck)(t.centerlabelfont,n.fontFamily),fontSize:(0,o.pluckNumber)(t.centerlabelfontsize,parseInt(n.fontSize,10)),color:(0,o.getFirstColor)((0,o.pluck)(t.centerlabelcolor,t.valuefontcolor,e.style.inCanvasStyle.color,"555555")),alpha:(0,o.pluckNumber)(t.centerlabelalpha,100),bold:(0,o.pluckNumber)(t.centerlabelbold,n.fontWeight),italic:(0,o.pluckNumber)(t.centerlabelitalic,n.style),bgColor:(0,o.pluck)(t.centerlabelbgcolor,""),bgAlpha:(0,o.pluckNumber)(t.centerlabelbgalpha,100),borderColor:(0,o.pluck)(t.centerlabelbordercolor,n.borderColor),borderAlpha:(0,o.pluckNumber)(t.centerlabelborderalpha,100),borderThickness:(0,o.pluckNumber)(t.centerlabelborderthickness,n.borderThickness),borderRadius:(0,o.pluckNumber)(t.centerlabelborderradius,n.borderRadius),textPadding:(0,o.pluckNumber)(t.centerlabeltextpadding,n.borderPadding),padding:(0,o.pluckNumber)(t.centerlabelpadding,2),bgOval:(0,o.pluckNumber)(t.centerlabelbgoval,0),shadow:(0,o.pluckNumber)(t.showcenterlabelshadow,0),hoverColor:t.centerlabelhovercolor&&(0,o.getFirstColor)((0,o.pluck)(t.centerlabelhovercolor)),hoverAlpha:(0,o.pluckNumber)(t.centerlabelhoveralpha),toolText:(0,o.parseUnsafeString)((0,o.pluck)(t.centerlabeltooltext,o.BLANKSTRING),!1)},a.addExtEventListener("datasetrollover",(function(e){var t=e.data,n=(0,o.pluck)(function(e,t,r){var n=e;if(n)for(var a,i=t.length||0;i--;)a=new RegExp(t[i],"gi"),n=n.replace(a,r[i]);return n}((0,o.parseUnsafeString)(e.sender.getFromEnv("dataSource").chart.centerlabel),["\\$value","\\$percentValue","\\$displayValue","\\$label"],[r.scale(t.value),t.pValue,t.displayValue,t.label]),"");a.draw(n,!1)}),this.getFromEnv("chart").getDatasets()[0]),a.addExtEventListener("datasetrollout",(function(e){a.draw((0,o.pluck)(e.sender.config.label,""),!1)}),this.getFromEnv("chart").getDatasets()[0])},r.draw=function(e){var t,r,n=this,a=n.getFromEnv("chart"),i=a.config.canvasLeft+.5*a.config.canvasWidth,s=a.config.canvasTop+.5*a.config.canvasHeight,l=a.getDatasets()[0].config.innerSize,c=a.getDatasets()[0].config.innerSize,u=a.getDatasets()[0].config,d=this.config,f=n.getFromEnv("animationManager"),h=n.getFromEnv("smartLabel"),g=this.getGraphicalElement("centerLabel"),p=g,m=this.getGraphicalElement("centerLabelBg"),v=a.getChildContainer("plotGroup"),b=d.padding,y=2*d.textPadding,x={fontFamily:d.font,fontSize:d.fontSize+"px",lineHeight:1.2*d.fontSize+"px",fontWeight:d.bold?"bold":"",fontStyle:d.italic?"italic":""},w=1.414*(.5*l-b)-y,C=1.414*(.5*c-b)-y,k=n.getFromEnv("toolTipController");t=(0,o.pluck)(e,d.label),h.setStyle(x),h.useEllipsesOnOverflow(a.config.useEllipsesWhenOverflow),r=h.getSmartText(t,w,C),t?(d.bgOval&&(m=f.setAnimation({el:m||"circle",attr:{cx:i,cy:s,r:.5*l-b,visibility:"visible",container:v,fill:(0,o.hashify)(d.bgColor),"fill-opacity":d.bgAlpha/100,stroke:(0,o.hashify)(d.borderColor),"stroke-width":d.borderThickness,"stroke-opacity":d.borderAlpha/100},component:n})),p=f.setAnimation({el:g||"text",component:n,container:v,css:x,attr:{x:i,y:s,text:r.text,visibility:"visible",direction:a.config.textDirection,fill:(0,o.toRaphaelColor)({FCcolor:{color:d.color,alpha:d.alpha}}),"text-bound":d.bgOval?"none":[(0,o.toRaphaelColor)({FCcolor:{color:d.bgColor,alpha:d.bgAlpha}}),(0,o.toRaphaelColor)({FCcolor:{color:d.borderColor,alpha:d.borderAlpha}}),d.borderThickness,d.textPadding,d.borderRadius]},label:"text"}),k.enableToolTip(p,d.toolText||r.tooltext)):(p&&f.setAnimation({el:p,attr:{visibility:"hidden"},component:n}),m&&f.setAnimation({el:m,attr:{visibility:"hidden"},component:n})),g?p.attr("text")!==t&&n.centerLabelChange(t):(n.addEventListener("fc-mouseover",(function(){n._centerLabelRollover(a)})),n.addEventListener("fc-mouseout",(function(){n._centerLabelRollout(a)})),n.addEventListener("fc-click",(function(){n._centerLabelClick(a)})),n.addGraphicalElement("centerLabel",p),n.addGraphicalElement("centerLabelBg",m)),u.lastCenterLabelConfig=d,u.centerLabelConfig=d},r.centerLabelChange=function(e){var t=this.getFromEnv("chart"),r=t.config,n=this.getFromEnv("chartInstance"),a={height:r.height,width:r.width,pixelHeight:t.getFromEnv("chartWidth"),pixelWidth:t.getFromEnv("chartHeight"),id:n.id,renderer:n.args.renderer,container:n.options.containerElement,centerLabelText:e};t.fireChartInstanceEvent("centerLabelChanged",a)},r._centerLabelRollover=function(e){var t=e.config,r=e.getFromEnv("chartInstance"),n=this.config,a={height:t.height,width:t.width,pixelHeight:e.getFromEnv("chartWidth"),pixelWidth:e.getFromEnv("chartHeight"),id:r.id,renderer:r.args.renderer,container:r.options.containerElement,centerLabelText:n&&n.label};this.getFromEnv("paper").attr("text")&&e.fireChartInstanceEvent("centerLabelRollover",a,void 0,this.hoverOnCenterLabel.bind(this,e))},r._centerLabelRollout=function(e){var t=e.config,r=e.getFromEnv("chartInstance"),n=this.config,a={height:t.height,width:t.width,pixelHeight:e.getFromEnv("chartWidth"),pixelWidth:e.getFromEnv("chartHeight"),id:r.id,renderer:r.args.renderer,container:r.options.containerElement,centerLabelText:n&&n.label};this.getFromEnv("paper").attr("text")&&e.fireChartInstanceEvent("centerLabelRollout",a,void 0,this.hoverOffCenterLabel.bind(this,e))},r._centerLabelClick=function(e){var t,r=e.config,n=e.getFromEnv("chartInstance"),a={height:r.height,width:r.width,pixelHeight:e.getFromEnv("chartWidth"),pixelWidth:e.getFromEnv("chartHeight"),id:n.id,renderer:n.args.renderer,container:n.options.containerElement};t=this.config,a.centerLabelText=t&&t.label,this.getFromEnv("paper").attr("text")&&e.fireChartInstanceEvent("centerLabelClick",a)},r.hoverOnCenterLabel=function(e){var t=e.getChildren("dataset")[0].config.lastCenterLabelConfig;(t.hoverColor||t.hoverAlpha)&&this.getGraphicalElement("centerLabel").attr({fill:(0,o.toRaphaelColor)({FCcolor:{color:t.hoverColor||t.color,alpha:t.hoverAlpha||t.alpha}})})},r.hoverOffCenterLabel=function(e){var t=e.getChildren("dataset")[0].config.lastCenterLabelConfig;(t.hoverColor||t.hoverAlpha)&&this.getGraphicalElement("centerLabel").attr({fill:(0,o.toRaphaelColor)({FCcolor:{color:t.color,alpha:t.alpha}})})},t}(i.ComponentInterface);t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.centerLabel.centerLabel.text.appearing":function(e){if(e.attr)return[{initialAttr:{x:e.attr.x,y:e.attr.y}}]}}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=r(224),i=n(r(405)),o=n(r(407)),s={dragnode:!0,hlineargauge:!0,column3d:!0,mscolumn3d:!0,bar3d:!0,pareto3d:!0,msbar3d:!0,stackedcolumn3d:!0,stackedbar3d:!0,mscombi3d:!0,mscolumnline3d:!0,stackedcolumn3dline:!0,mscolumn3dlinedy:!0,stackedcolumn3dlinedy:!0,realtimearea:!0,realtimecolumn:!0,realtimeline:!0,realtimestackedarea:!0,realtimestackedcolumn:!0,angulargauge:!0,realtimelinedy:!0,kagi:!0,treemap:!0,heatmap:!0,boxandwhisker2d:!0,scatter:!0,timeseries:!0,bubble:!0,errorscatter:!0,sparkwinloss:!0,zoomscatter:!0,zoomline:!0,zoomlinedy:!0,chord:!0},l=function(e){if("chartAPI"===e.sender.getType()){var t=e.sender,r=t.getFromEnv("chartInstance");r.drawCrossline=function(e){r.drawConsolidatedToolTip(e),t.iterateComponents((function(t){"crossline-manager"===t.getType()&&(e!==a.UNDEF?t.show({value:e}):t.hide())}))}}},c=function(e){var t,r,n,a=e.sender.apiInstance.getChildren("canvas");for(n=0;n<a.length;n++)(t=(t=a[n].getChildren("crosslineManagerBand"))&&t[0])&&(r=t._handlerAPI,t.config.axisScrolling=!0,r.onhoverout(e))},u=function(e){var t,r,n=e.sender.apiInstance.getChildren("canvas");for(r=0;r<n.length;r++)(t=n[r].getChildren("crosslineManagerBand"))&&t[0]&&(t[0].config.axisScrolling=!1)},d=function(e){if("canvas"===e.sender.getName()){var t,r,n=e.sender;n.registerFactory("crossLineManager",(function(){var l=e.sender.getFromEnv("chart"),c=l&&l.getName();c&&!s[c.toLowerCase()]&&((0,a.componentFactory)(n,o["default"],"crosslineManagerBand"),t=n.getChildren("crosslineManagerBand")[0],r=t._handlerAPI,t.configure(),(0,a.componentFactory)(t,i["default"],"crossline"),t.addExtEventListener("fc-mouseover",r.onhover,n),t.addExtEventListener("fc-mousemove",r.onhover,n),t.addExtEventListener("fc-mouseout",r.onhoverout,n))}))}},f={extension:function(e){e.addEventListener("preconfigure",l),e.addEventListener("scrollstart",c),e.addEventListener("scrollend",u),e.addEventListener("instantiated",d)},name:"crossline-manager",type:"extension",requiresFusionCharts:!0};t["default"]=f},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=r(240),o=r(224),s=r(232),l=n(r(406)),c=function(e){function t(){var t;return t=e.call(this)||this,(0,s.addDep)({name:"crosslineAnimation",type:"animationRule",extension:l["default"]}),t}(0,a["default"])(t,e);var r=t.prototype;return r.getName=function(){return"crossline"},r.getType=function(){return"crossline"},r.show=function(e){void 0===e&&(e={});var t=!!e.onTop,r=e.type;t!==this.config.prevRenderedOnTop&&this.hide(),!this[r]&&(r="band"),this[r](e),this.config.prevRenderedOnTop=t},r.band=function(e){void 0===e&&(e={});var t,r,n=e.managerId,a=e.x1,i=e.y1,s=e.x2,l=e.y2,c=(0,o.toRaphaelColor)({color:(0,o.pluck)(e.fillcolor,"#EEEEEE"),alpha:(0,o.pluckNumber)(e.alpha,50)}),u=this.getLinkedParent().getLinkedParent().getEffectiveDimensions(),d=[u.left,u.top,u.width,u.height].toString(),f=this.getLinkedParent().getChildContainer("crosslineBottom"),h=this.getLinkedParent().getChildContainer("crosslineTop");r=e.onTop?h:f,(t=this.getGraphicalElement("crosslineBand"+n))?e.animDuration?t.animate({path:["M",a,i,"L",s,l]},e.animDuration,"ease-in"):t.attr({path:["M",a,i,"L",s,l],"clip-rect":d}):this.addGraphicalElement("crosslineBand"+n,this.getFromEnv("paper").path({path:["M",a,i,"L",s,l],"clip-rect":d,stroke:c,fill:c,"stroke-width":e.thickness,"stroke-linecap":"butt"},r))},r.hide=function(){for(var e=this.getGraphicalElement(),t=Object.keys(e),r=t.length-1;r>-1;r--)e[t[r]].stop(o.UNDEF,!0,!0),e[t[r]].remove(),delete e[t[r]]},t}(i.ComponentInterface);t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={crossline:{crossline:{path:{updating:function(e){return[{initialAttr:{path:e.el.attr("path")},finalAttr:{path:e.attr.path}}]}}}}}},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=r(224),s=r(240),l=o.hasSVG?0:.5,c=function(e,t,r){return r.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:e},container:t,state:"appearing",component:r,label:"group"})},u=function(e){function t(){var t,r;return(t=e.call(this)||this)._handlerAPI=(r=(0,a["default"])(t),{onhover:function(e,t){!r.config.axisScrolling&&r.show(t.axes?{axesInfo:t.axes}:{event:e})},onhoverout:function(e){r.hide({event:e})}}),t.mouseOutTimer=o.UNDEF,t}(0,i["default"])(t,e);var r=t.prototype;return r.getAttachedAxisInfo=function(e){void 0===e&&(e={});var t,r,n,a,i=this.getLinkedParent().getAxes(),s=e.originalEvent&&(0,o.getMouseCoordinate)(this.getLinkedParent().getFromEnv("chart-container"),e.originalEvent,this.getFromEnv("chart")),l=s&&s.chartX||0,c=s&&s.chartY||0;for(t=i.length-1;t>=0;t--)if(r=i[t].axis,!i[t].isY)return n=!!r.config.isVertical,a=r.getTranslation(),{value:n?r.getValue(c+a):r.getValue(l+a),axis:r,isVertical:n,isY:!1}},r.configure=function(){var e=this.config,t=this.getFromEnv("chartConfig"),r=this.getFromEnv("chart-attrib");e.drawCrossLine=(0,o.pluckNumber)(r.drawcrossline,t.drawcrossline,0),e.bandStyle={fillcolor:(0,o.pluck)(r.crosslinecolor,t.crosslinecolor,"#EEEEEE"),alpha:(0,o.pluckNumber)(r.crosslinealpha,t.crosslinealpha,50),thickness:(0,o.pluckNumber)(t.defaultcrosslinethickness),managerId:this.getId(),onTop:(0,o.pluckNumber)(r.drawcrosslineontop,t.drawcrosslineontop,0),cursor:"pointer",animDuration:(0,o.pluckNumber)(r.crosslineanimation,0)&&1e3*(0,o.pluckNumber)(r.crosslineanimationduration,.09)}},r.createGroup=function(){var e=this.getLinkedParent().getChildContainer("crosslineBottom"),t=this.getLinkedParent().getChildContainer("crosslineTop");!this.getChildContainer("crosslineTop")&&this.addChildContainer("crosslineTop",c("crosslineTop",t,this)),!this.getChildContainer("crosslineBottom")&&this.addChildContainer("crosslineBottom",c("crosslineBottom",e,this))},r.show=function(e){void 0===e&&(e={});var t=e.event;clearTimeout(this.mouseOutTimer),this.config.attachedCanvasAxisInfo=this.getAttachedAxisInfo(t),this._setAptAxesInfo(e.axesInfo,e.value),this._show(t)},r._setAptAxesInfo=function(e,t){void 0===e&&(e=[]);var r,n,a=e.length,i=this.config.attachedCanvasAxisInfo;if(e.length)for(n=0;n<a;n++)if((r=e[n]).axis===i.axis){i.value=r.value;break}t!==o.UNDEF&&(i.value=t)},r._show=function(e){var t,r,n,a,i,s,c=this.config,u=this.getFromEnv("chartConfig"),d=this.getChildren("crossline")[0],f=c.attachedCanvasAxisInfo,h=f.axis,g=h.getLimit().max-h.config.endPad,p=Math.round(f.value),m=f.axis.getPixel(p)-f.axis.getTranslation(),v=Object.assign({},c.bandStyle),b=this.getFromEnv("canvasConfig"),y=b.canvasTop,x=b.canvasLeft;p<0||p>g||this.config.lastIndex!==p&&c.drawCrossLine&&((n=v.thickness)===o.UNDEF&&(!1===u._hascolumn?n=1:(t=h.getPixel(0),r=h.getPixel(1),n=Math.abs(r-t))),i=m,s=n,a=Math.round(i+(s%2/2+l))-(s%2/2+l),this.createGroup(),v.thickness=n,v=f.isVertical?Object.assign(v,{x1:x,y1:a,x2:x+b.canvasWidth,y2:a}):Object.assign(v,{x1:a,y1:y,x2:a,y2:y+b.canvasHeight}),d.show(v),this.getFromEnv("chart").fireChartInstanceEvent("onChangeCrossLine",{currentIndex:p,lastIndex:this.config.lastIndex,source:e?"mouse interaction":"public API"}),this.config.lastIndex=p)},r.hide=function(e){var t=this;void 0===e&&(e={});var r=this;this.mouseOutTimer=setTimeout((function(){r.getFromEnv("chart").fireChartInstanceEvent("onChangeCrossLine",{lastIndex:r.config.lastIndex,source:e.event?"mouse interaction":"public API"}),delete t.config.lastIndex,t.getChildren("crossline")[0].hide()}),20)},r.getType=function(){return"crossline-manager"},r.getName=function(){return"crossline-manager-band-category-axis"},t}(s.ComponentInterface);t["default"]=u},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(242)),i=n(r(238)),o=r(240),s=r(224),l={candlestick:!0},c=function(e){if(e.sender.getType&&"chartAPI"===e.sender.getType()&&l[e.sender.getName&&e.sender.getName()]){var t,r,n=e.sender;n.registerFactory("multiCanvasCrossline",(function(){(0,s.componentFactory)(n,u,"multiCanvasCrosslineManager"),t=n.getChildren("multiCanvasCrosslineManager")[0],r=t._handlers,n.iterateComponents((function(e){"canvas"===e.getName()&&(e.addEventListener("fc-mouseover",r.onhover),e.addEventListener("fc-mousemove",r.onhover),e.addEventListener("fc-mouseout",r.onhoverout))}))}),["canvas"])}},u=function(e){function t(){var t,r;return(t=e.call(this)||this)._handlers=(r=(0,a["default"])(t),{onhover:function(e){e.originalEvent&&r.show(e)},onhoverout:function(e){e.originalEvent&&r.hide(e)}}),t}(0,i["default"])(t,e);var r=t.prototype;return r.getAxesInfo=function(e,t){void 0===e&&(e={});var r,n,a,i,o=t.getAxes(),l=[],c=(0,s.getMouseCoordinate)(this.getFromEnv("chart-container"),e.originalEvent,this.getFromEnv("chart")),u=c.chartX||0,d=c.chartY||0;for(r=o.length-1;r>=0;r--)n=o[r].axis,a=o[r].isY,i=!!n.config.isVertical,l.push({value:i?n.getValue(d):n.getValue(u),axis:n,isVertical:i,isY:a});return l},r.getName=function(){return"multiCanvasCrosslineManager"},r.getType=function(){return"multiCanvasCrosslineManager"},r.show=function(e){var t=this,r=e.sender;this.getFromEnv("chart").iterateComponents((function(n){"canvas"===n.getName()&&n!==r&&n.fireEvent("fc-mousemove",{axes:t.getAxesInfo(e,r)})}))},r.hide=function(e){var t=e.sender,r=(0,s.getMouseCoordinate)(t.getFromEnv("chart-container"),e&&e.originalEvent,t.getFromEnv("chart"));t.isWithinCanvas(r.chartX,r.chartY)||this.getFromEnv("chart").iterateComponents((function(e){"canvas"===e.getName()&&e!==t&&e.fireEvent("fc-mouseout")}))},t}(o.ComponentInterface),d={extension:function(e){e.addEventListener("instantiated",c)},name:"multi-canvas-crossline-manager",type:"extension",requiresFusionCharts:!0};t["default"]=d},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=r(410),i=n(r(411)),o=function(){function e(e){this.alternateTexts=i["default"]}var t=e.prototype;return t.buildAriaTexts=function(e,t,r){var n=this,a=e&&this.alternateTexts&&this.alternateTexts[e]||{},i=function(e){for(var t in n.alternateTexts["default"]&&n.alternateTexts["default"][e])a.hasOwnProperty(t)||(a[t]=n.alternateTexts["default"][e][t])};return r&&i(r),t&&i(t),i("base"),a},t.setAlternateTexts=function(e){this.alternateTexts=(0,a.mergeDeep)(this.alternateTexts,e)},t.getAlternateTexts=function(e){return this.alternateTexts},e}(),s={extension:function(e){var t=new o(e),r={setAlternateTexts:t.setAlternateTexts.bind(t),getAlternateTexts:t.getAlternateTexts.bind(t)};e.accesibilityTexts=t,e.Accessibility=r},name:"ResourceString",type:"extension",requiresFusionCharts:!0};t["default"]=s},function(e,t,r){"use strict";t.__esModule=!0,t.mergeDeep=function a(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];if(!r.length)return e;var o=r.shift();if(n(e)&&n(o))for(var s in o){var l,c;if(n(o[s]))e[s]||Object.assign(e,((l={})[s]={},l)),a(e[s],o[s]);else Object.assign(e,((c={})[s]=o[s],c))}return a.apply(void 0,[e].concat(r))};var n=function(e){return e&&"object"==typeof e&&!Array.isArray(e)}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n={"default":{base:{chart:"This is a {chartType} chart created with FusionCharts Suite XT. Title of the chart is {caption}. {xAxisName} is plotted on x-axis and {yAxisName} is plotted on y-axis",legendItem:"Toggle the visibility of {legendText}.",exportMenu:"View export options",exportMenuItems:["Export to PNG","Export to JPG","Export to PDF","Export to SVG","Export to XLS"]},singleSeries:{plot:"{yAxisName} for {xAxisName} {label} is {formattedValue}. Plot {plotIndex} of {totalPlots}."},multiSeries:{plot:"{yAxisName} of {seriesName} for {xAxisName} {label} is {formattedValue}. Plot {plotIndex} of {totalPlots}. Series {seriesIndex} of {totalSeries}",exportMenu:"View export options",exportMenuItems:["Export to PNG","Export to JPG","Export to PDF","Export to SVG","Export to XLS"]},nonCartesian:{chart:"This is a {chartType} chart created with FusionCharts Suite XT. {caption} for {subcaption} is plotted.",plot:"{plotIndex}. {label} {formattedValue}.",legendItem:"Toggle the slicing of {legendText}"},scatter:{plot:"X Value : {xValue}, Y Value : {yValue} for {seriesName}. Plot {plotIndex} of {totalPlots}. Series {seriesIndex} of {totalSeries}"},bubble:{plot:"X Value : {xValue}, Y Value : {yValue}, Z Value : {zValue}, Name of the bubble : {bubbleName}, Series : {seriesName}. Plot {plotIndex} of {totalPlots}. Series {seriesIndex} of {totalSeries}"},funnel:{chart:"This is a {chartType} chart created with FusionCharts Suite XT. Title of the chart is {caption}. {plot-0-label} is {plot-0-value}"},heatmap:{plot:"{xAxisLabel} for {yAxisLabel} is {formattedValue}.",upperRange:"Change the upper limit to filter the data. Current range is {currentStartValue} to {currentEndValue}",lowerRange:"Change the lower limit to filter the data. Current range is {currentStartValue} to {currentEndValue}"}}};t["default"]=n},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(413)),i=r(420);t.getConfig=i.getConfig,t.setConfig=i.setConfig;var o=a["default"];t["default"]=o},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(414))["default"];t["default"]=a},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(415)),i=r(422),o=r(416),s=function(){function e(e,t,r){this.dataTables={},this._defaultDataTable=null,this._id=+new Date+"",e&&t&&e.constructor===Array&&t.constructor===Array&&this.createDataTable(e,t,r)}var t=e.prototype;return t.createDataTable=function(e,t,r,n){if(!e||!t)throw new Error("Both data and schema must be provided to build DataTable");if(e.constructor!==Array)throw new Error("Data must be provided in 2D array format or array of json objects");if(t.constructor!==Array||0===t.length)throw new Error("Input schema is not in a correct format - schema must be an array of column configurations");var i,s,l={},c=n;if(s=Object.keys(this.dataTables),c){if(s.includes(c))throw new Error("A table with the id "+c+" already exists in the DataStore. Please use a different id.")}else c=(0,o.createTableID)(s);return Object.assign(l,{enableIndex:!0,enableUTC:!1},r),i=new a["default"](this,(0,o.parseAndIndexData)(e,t,l),t,l,null,null,c),0===s.length&&(this._defaultDataTable=i),this.dataTables[c]=i,i},t.appendRows=function(e,t){var r,n,a,i=this.getDataTable(t),s=i.getSchema();a=(0,o.buildDateColumnsFormatter)(s),n=(0,o.parseData)(e,s,a),(r=i._data).push.apply(r,n),(0,o.indexData)(i._data,s,i._config,a),i.flushResults(),this.trigger("itemsAdded",{rows:e,parsedRows:n,tableID:t})},t.deleteRows=function(e,t){var r=this.getDataTable(t),n=r.query(e),a=n.getData().data,i=r.indexOf("_row_id"),o=n.indexOf("_row_id"),s=a.map((function(e){return e[o]}));r._data=r._data.filter((function(e){return!s.includes(e[i])})),r.flushResults(),this.trigger("itemsRemoved",{rows:a,tableID:t}),n.dispose()},t.getDataTable=function(e){if(e){if(!this.dataTables[e])throw new Error("DataTable with id "+e+" is not found in the DataStore.");return this.dataTables[e]}return this._defaultDataTable},t.on=function(e,t){(0,i.addHandler)(e,t,this)},t.off=function(e,t){(0,i.removeHandler)(e,t,this)},t.trigger=function(e,t){(0,i.triggerEvent)(e,this,t)},t.dispose=function(){var e=this;for(var t in e.dataTables)e.dataTables.hasOwnProperty(t)&&(e.dataTables[t].dispose(),delete e.dataTables[t]);delete e._id,delete e.dataTables,delete e._defaultDataTable,this.trigger("disposed"),e=null},t._propagate=function(e){for(var t in this.trigger("payloadReceived",e),this.dataTables)this.dataTables.hasOwnProperty(t)&&this.dataTables[t]._payloadReceiver(e)},e}();t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=r(416),i=r(422),o=n(r(423)),s=function(){function e(e,t,r,n,a,i,o){this._dataStore=e,this._parentTable=a,this._children=[],this._childrenTableIDs=[],this._opsFunnel=i,this._data=t||[],this._schema=r,this._config=n,this._id=o;var s,l=1;if(this._id||(s=this._parentTable&&this._parentTable._id?this._parentTable._id:"table_1",this._id=s+"_"+l),this._parentTable){for(;this._parentTable._childrenTableIDs.includes(this._id);)this._id=s?s+"_"+ ++l:this._id+"_1";this._parentTable._children.push(this),this._parentTable._childrenTableIDs.push(this._id)}this._result=null}var t=e.prototype;return t.count=function(){return this._executeFunnel().data.length},t.getSchema=function(){return this._executeFunnel().schema},t.getID=function(){return this._id},t.getDataStore=function(){return this._dataStore},t.getChildren=function(e){if(e){for(var t=0;t<this._children.length;t++)if(this._children[t]._id===e)return this._children[t];return null}return this._children},t.getData=function(e,t){var r,n=e,a=t;return n=n||0,a=a&&("string"==typeof a||a instanceof String)||null===a?void 0:a,{data:(r=this._executeFunnel()).data&&r.data.slice(n,a&&a>0?n+a:a),schema:r.schema}},t.dispose=function(){var e=this;if(e._parentTable&&e._parentTable._children){var t;for(t=0;t<e._parentTable._children.length&&("undefined"==typeof e._id||e._id!==e._parentTable._children[t]._id);t++);t!==e._parentTable._children.length&&e._parentTable._children.splice(t,1)}delete e._dataStore,delete e._parentTable,delete e._opsFunnel,delete e._data,delete e._schema,delete e._config,delete e._result,delete e._id,e.disposeChildren(),delete e._children,delete e._childrenTableIDs,e._trigger("disposed"),delete e._evtHandlers,e.disposed=!0,e=null},t.disposeChildren=function(){for(var e=(this._children&&this._children.length||0)-1;e>=0;e--)this._children[e].dispose();this._children=[],this._childrenTableIDs=[]},t.min=function(e){var t=this.getData();return(0,a.columnMinValue)(e,t.data,t.schema)},t.max=function(e){var t=this.getData();return(0,a.columnMaxValue)(e,t.data,t.schema)},t.unique=function(e){var t=this.getData();return(0,a.columnUnique)(e,t.data,t.schema)},t.extents=function(e){var t=this.getData();return(0,a.columnExtents)(e,t.data,t.schema)},t.addColumns=function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];for(var n,a=t.length,i=[],s=0;s<a;s++)(0,o["default"])(t[s])&&i.push(t[s]);n=i.length,this._calcColumns=this._calcColumns||[];for(var l=0;l<n;l++){if(!i[l].name)throw new Error("name is required in column "+(l+1));if(i[l].calcFn&&!(i[l].calcFn instanceof Function))throw new Error("calcFn must be a function in column "+(l+1));i[l].calcFn||(i[l].calcFn=function(){}),this._calcColumns.push(Object.assign({},i[l]))}this._trigger("updated",i)},t.query=function(t){var r=t;return r&&r.constructor!==Array&&(r=[r]),new e(this._dataStore,this._data,this._schema,this._config,this,r)},t.indexOf=function(e){var t=this._executeFunnel();return(0,a.columnIndexOf)(e,t.schema)},t.on=function(e,t){(0,i.addHandler)(e,t,this)},t.off=function(e,t){(0,i.removeHandler)(e,t,this)},t._trigger=function(e,t){(0,i.triggerEvent)(e,this,t)},t._executeFunnel=function(){if(!this._result)if(this._opsFunnel){var e,t,r,n,i;t=(e=this._parentTable._executeFunnel()).data.slice(0),r=e.schema.slice(0),n=Object.assign({},e.config),i=this._opsFunnel.length;for(var o=0;o<i;o++)if(this._opsFunnel[o]&&this._opsFunnel[o].fn){var s=this._opsFunnel[o].fn(t,r,n);t=s.generatorFn?s.generatorFn():s.data,r=s.schema,void 0===(n=Object.assign(n,s.config)).indexBy&&(n.enableIndex=!1)}this._result={data:t,schema:r,config:n}}else this._result={data:this._data,schema:this._schema,config:this._config};if(this._calcColumns&&this._calcColumns.length>0){var l=(0,a.addColumnsSchema)(this._result.schema,this._calcColumns);this._result.schema=l.schema,this._result.data=(0,a.addColumnsData)(this._result.data,this._result.schema,l.calcColumns),delete this._calcColumns}return this._result},t.flushResults=function(){var e=this._result&&this._result.schema.length||0,t=this._children&&this._children.length||0;e&&(this._calcColumns=[]);for(var r=0;r<e;r++)this._result.schema[r].calcFn&&this._calcColumns.push(this._result.schema[r]);this._result&&(this._result=null);for(var n=0;n<t;n++)this._children[n].flushResults()},t.propagate=function(e){this.getDataStore()._propagate({trigger:this,payload:e})},t._payloadReceiver=function(e){var t=this._children&&this._children.length||0;e&&e.trigger&&e.trigger!==this&&this._trigger("payloadReceived",e);for(var r=0;r<t;r++)this._children[r]._payloadReceiver(e)},t.getMinDiff=function(e){var t=this.getData();return(0,a.columnMinDiff)(e,t.data,t.schema,this._config.indexBy)},t.isUTCEnabled=function(e){return(0,a.isUTCEnabled)(e,this.getSchema())},e}();t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.columnIndexOf=u,t.columnMinValue=function(e,t,r){var n,i;if(null===(n=u(e,r))||-1===n)return null;if(t&&t.length>0){var o;i=Number.POSITIVE_INFINITY;for(var s=0;s<t.length;s++)o="interval"===r[n].type?t[s][n]?t[s][n].start:null:t[s][n],(0,a.isNumber)(o)&&o<i&&(i=o)}return i},t.columnMaxValue=function(e,t,r){var n,i;if(null===(n=u(e,r))||-1===n)return null;if(t&&t.length>0){var o;i=Number.NEGATIVE_INFINITY;for(var s=0;s<t.length;s++)o="interval"===r[n].type?t[s][n]?t[s][n].end:null:t[s][n],(0,a.isNumber)(o)&&o>i&&(i=o)}return i},t.columnMinDiff=function(e,t,r,n){var o,s,l=t,c=t.length;if(null===(o=u(e,r))||-1===o)return null;if(r[o]&&["date","number"].indexOf(r[o].type)<0)throw new Error("Operation valid only on date or number columns");n&&e===n||(l=t.slice(0)).sort((function(e,t){return(0,i.numberComparator)(e[o],t[o])}));if(l&&c>0){var d,f,h;s=Number.POSITIVE_INFINITY;for(var g=0;g<l.length-1&&(f=l[g][o],h=l[g+1][o],(0,a.isNumber)(h)&&(0,a.isNumber)(f))&&(d=h-f,0!==(s=(0,a.isNumber)(d)&&d>=0&&d<s?d:s));g++);}return s===Number.POSITIVE_INFINITY?null:s},t.columnExtents=function(e,t,r){var n,i=Number.POSITIVE_INFINITY,o=Number.NEGATIVE_INFINITY,s=u(e,r);if(null===s||-1===s)return null;if(t&&t.length>0)for(var l=0;l<t.length;l++)n="interval"===r[s].type?t[l][s]?t[l][s].start:null:t[l][s],(0,a.isNumber)(n)&&n<i&&(i=n),n="interval"===r[s].type?t[l][s]?t[l][s].end:null:t[l][s],(0,a.isNumber)(n)&&n>o&&(o=n);return{min:i,max:o}},t.columnUnique=function(e,t,r){var n,a=u(e,r),i=[];if(null===a||-1===a)return[];for(var o=0;o<t.length;o++)i.push(t[o][a]);if(t&&t.length>0)return 1===(n=Array.from(new Set(i))).length&&"undefined"==typeof n[0]?[]:n;return[]},t.addColumnsSchema=function(e,t){for(var r=t.length,n=e.slice(0),a=0;a<r;a++){var i=n.length;t[a].originalName=t[a].name;for(var o=0;o<i;o++)t[a].name===n[o].name&&(t[a].i=t[a].i&&++t[a].i||1,t[a].name=t[a].originalName+" "+t[a].i),t[a].type&&-1!==["string","number","date"].indexOf(t[a].type)||(t[a].type="string");delete t[a].originalName,delete t[a].i,n.push({name:t[a].name,type:t[a].type||"string"}),t[a].calcFn&&(n[n.length-1].calcFn=t[a].calcFn),t[a].format&&(n[n.length-1].format=t[a].format),t[a].enableUTC&&(n[n.length-1].enableUTC=t[a].enableUTC),t[a].columnIndex=n.length-1}return{schema:n,calcColumns:t}},t.addColumnsData=function(e,t,r){for(var n,a=e.length,i=r.length,o=t.length,s={},l=f(r),c=0;c<o;c++)s[t[c].name]=c;for(var u=0;u<a;u++)for(var h=0;h<i;h++)r[h].calcFn&&(n=r[h].calcFn(e[u],s,u),n=d(r[h],n,l),e[u][r[h].columnIndex]=n);return e},t.parseAndIndexData=function(e,t,r){var n=f(t),a=h(e,t,n);return g(a,t,r,n),a},t.createTableID=function(e){var t=e.length+1;for(;e.includes("table-"+t);)t++;return"table-"+t},t.buildDateColumnsFormatter=f,t.parseData=h,t.indexData=g,t.isUTCEnabled=function(e,t){var r;if(null===(r=u(e,t))||-1===r||"date"!==t[r].type&&"interval"!==t[r].type)return null;return void 0!==t[r].enableUTC?t[r].enableUTC:(0,s.getConfig)("enableUTC")};var a=r(417),i=r(418),o=n(r(419)),s=r(420),l=n(r(292)),c=n(r(421));function u(e,t){if(!t||!e)return null;for(var r=0;r<t.length;r++)if(t[r]&&t[r].hasOwnProperty("name")&&t[r].name===e)return r;return-1}function d(e,t,r){return void 0!==r[e.name]&&t?r[e.name]?+r[e.name].parse(t):+new Date(t):"number"===e.type?(0,a.isNumber)(t)?t:t?parseFloat(t):null:t}function f(e){for(var t={},r=0;r<e.length;r++){if(!e[r].name)throw new Error("Input schema is not in a correct format - each column must have a name");e[r].type&&"date"===e[r].type&&(t[e[r].name]=e[r].format?(void 0!==e[r].enableUTC?e[r].enableUTC:(0,s.getConfig)("enableUTC"))?l["default"].utcParser(e[r].format):l["default"].parser(e[r].format):null)}return t}function h(e,t,r){var n=[];if(e.length>0){var a,i=r,o=t.findIndex((function(e){return"_row_id"===e.name}));i||(i=f(t)),-1===o&&(o=t.push({name:"_row_id",type:"string"})-1);for(var s=0;s<e.length;s++)e[s][o]=(0,c["default"])();try{for(var l,u,h,g=t.length,p=0;p<e.length;p++){if(l=[],(u=e[p]).constructor===Array)for(h=Math.min(g,u.length),a=0;a<h;a++)l[a]=d(t[a],u[a],i);else{if("object"!=typeof u)continue;for(a=0;a<g;a++)u[t[a].name]&&(l[a]=d(t[a],u[t[a].name],i))}n.push(l)}}catch(m){throw new Error("Error while parsing the data - "+m)}}return n}function g(e,t,r,n){if(r.enableIndex){var a,s,l;if(!r.indexBy){(l=n)||(l=f(t));var c=Object.keys(l);if(c.length>0)r.indexBy=c[0];else{for(a=0;a<t.length;a++)if(t[a].type&&"number"===t[a].type){r.indexBy=t[a].name;break}a===t.length&&(r.indexBy=t[0].name)}}for(a=0;a<t.length&&(!t[a]||t[a].name!==r.indexBy);a++);if(a===t.length)throw new Error("Index column is not found in schema");switch(t[a].type){case"number":case"date":s=i.numberComparator;break;default:s=i.stringComparator}(0,o["default"])(e,(function(e,t){return s(e[a],t[a])}))}}},function(e,t,r){"use strict";t.__esModule=!0,t.isNumber=void 0;t.isNumber=function(e){return"number"==typeof e&&!isNaN(e-e)}},function(e,t,r){"use strict";t.__esModule=!0,t.stringComparator=t.numberComparator=void 0;var n=r(417);t.stringComparator=function(e,t){return null==e?t===e?0:1:(0,n.isNumber)(t)?(0,n.isNumber)(e)?e-t:-1:e===t?0:e<t?-1:1},t.numberComparator=function(e,t){return null==e?t===e?0:1:(0,n.isNumber)(t)?e-t:isNaN(e)&&isNaN(t)?0:-1}},function(e,t,r){"use strict";function n(e,t,r,n,a){var i=r||0,o=n||e.length,s=a||i+1,l=t;for(l||(l=function(e,t){return e-t}),i===s&&++s;s<o;++s){var c=i,u=s,d=e[u];do{var f=c+(u-c>>1);l(d,e[f])<0?u=f:c=f+1}while(c<u);for(var h=s;h>c;--h)e[h]=e[h-1];e[c]=d}}t.__esModule=!0,t.binaryInsertionSort=n,t.mergeSort=function c(e,t){var r,n,a,i=t;if(e.constructor!==Array)throw new TypeError("Merge sort can only be applied on Array.");if(1===e.length)return e;i||(i=function(e,t){return e-t});return r=Math.floor(e.length/2),n=e.slice(0,r),a=e.slice(r),function(e,t,r){var n=[],a=0,i=0;for(;a<e.length&&i<t.length;)r(e[a],t[i])<=0?(n.push(e[a]),a++):(n.push(t[i]),i++);return n.concat(e.slice(a)).concat(t.slice(i))}(c(n,i),c(a,i),i)},t["default"]=void 0;function a(e,t,r,n){var a=r+1;if(a===n)return 1;if(t(e[a++],e[r])<0){for(;a<n&&t(e[a],e[a-1])<0;)a++;!function(e,t,r){var n=r,a=t;for(--n;a<n;){var i=e[a];e[a++]=e[n],e[n--]=i}}(e,r,a)}else for(;a<n&&t(e[a],e[a-1])>=0;)a++;return a-r}function i(e,t,r,n,a,i){var o,s,l=0,c=0,u=1;if(i(e,t[r+a])>0){for(c=n-a;u<c&&i(e,t[r+a+u])>0;)l=u,(u=1+(u<<1))<=0&&(u=c);u>c&&(u=c),l+=a,u+=a}else{for(c=a+1;u<c&&i(e,t[r+a-u])<=0;)l=u,(u=1+(u<<1))<=0&&(u=c);u>c&&(u=c),o=l,l=a-u,u=a-o}for(l++;l<u;)i(e,t[r+(s=l+(u-l>>>1))])>0?l=s+1:u=s;return u}function o(e,t,r,n,a,i){var o,s,l=0,c=0,u=1;if(i(e,t[r+a])<0){for(c=a+1;u<c&&i(e,t[r+a-u])<0;)l=u,(u=1+(u<<1))<=0&&(u=c);u>c&&(u=c),o=l,l=a-u,u=a-o}else{for(c=n-a;u<c&&i(e,t[r+a+u])>=0;)l=u,(u=1+(u<<1))<=0&&(u=c);u>c&&(u=c),l+=a,u+=a}for(l++;l<u;)i(e,t[r+(s=l+(u-l>>>1))])<0?u=s:l=s+1;return u}var s=function(){function e(e,t){this.arr=e,this.comparer=t,this.length=e.length,this.tmpStorageLen=this.length<512?this.length>>>1:256,this.tmp=new Array(this.tmpStorageLen),this.runBaseArr=new Array(40),this.runLenArr=new Array(40),this.minGallop=7,this.stackSize=0}var t=e.prototype;return t.pushRun=function(e,t){this.runBaseArr[this.stackSize]=e,this.runLenArr[this.stackSize]=t,this.stackSize++},t.mergeCollapse=function(){for(var e;this.stackSize>1;){if((e=this.stackSize-2)>=1&&this.runLenArr[e-1]<=this.runLenArr[e]+this.runLenArr[e+1]||e>=2&&this.runLenArr[e-2]<=this.runLenArr[e]+this.runLenArr[e-1])this.runLenArr[e-1]<this.runLenArr[e+1]&&e--;else if(this.runLenArr[e]>this.runLenArr[e+1])break;this.mergeAt(e)}},t.mergeForceCollapse=function(){for(var e;this.stackSize>1;)(e=this.stackSize-2)>0&&this.runLenArr[e-1]<this.runLenArr[e+1]&&e--,this.mergeAt(e)},t.mergeAt=function(e){var t,r=this.comparer,n=this.arr,a=this.runBaseArr[e],s=this.runLenArr[e],l=this.runBaseArr[e+1],c=this.runLenArr[e+1];this.runLenArr[e]=s+c,e===this.stackSize-3&&(this.runBaseArr[e+1]=this.runBaseArr[e+2],this.runLenArr[e+1]=this.runLenArr[e+2]),this.stackSize--,a+=t=o(n[l],n,a,s,0,r),0!==(s-=t)&&0!==(c=i(n[a+s-1],n,l,c,c-1,r))&&(s<=c?this.mergeLo(a,s,l,c):this.mergeHi(a,s,l,c))},t.mergeLo=function(e,t,r,n){var a,s,l,c,u=0,d=0,f=r,h=e,g=t,p=n;for(u=0;u<g;u++)this.tmp[u]=this.arr[e+u];if(this.arr[h++]=this.arr[f++],0!=--p)if(1!==g){for(a=this.minGallop;;){s=0,l=0,c=!1;do{if(this.comparer(this.arr[f],this.tmp[d])<0){if(this.arr[h++]=this.arr[f++],l++,s=0,0==--p){c=!0;break}}else if(this.arr[h++]=this.tmp[d++],s++,l=0,1==--g){c=!0;break}}while((s|l)<a);if(c)break;do{if(0!==(s=o(this.arr[f],this.tmp,d,g,0,this.comparer))){for(u=0;u<s;u++)this.arr[h+u]=this.tmp[d+u];if(h+=s,d+=s,(g-=s)<=1){c=!0;break}}if(this.arr[h++]=this.arr[f++],0==--p){c=!0;break}if(0!==(l=i(this.tmp[d],this.arr,f,p,0,this.comparer))){for(u=0;u<l;u++)this.arr[h+u]=this.arr[f+u];if(h+=l,f+=l,0===(p-=l)){c=!0;break}}if(this.arr[h++]=this.tmp[d++],1==--g){c=!0;break}a--}while(s>=7||l>=7);if(c)break;a<0&&(a=0),a+=2}if(this.minGallop=a,a<1&&(this.minGallop=1),1===g){for(u=0;u<p;u++)this.arr[h+u]=this.arr[f+u];this.arr[h+p]=this.tmp[d]}else for(u=0;u<g;u++)this.arr[h+u]=this.tmp[d+u]}else{for(u=0;u<p;u++)this.arr[h+u]=this.arr[f+u];this.arr[h+p]=this.tmp[d]}else for(u=0;u<g;u++)this.arr[h+u]=this.tmp[d+u]},t.mergeHi=function(e,t,r,n){var a,s,l,c,u=0,d=t,f=n,h=e+d-1,g=f-1,p=r+f-1,m=0,v=0;for(u=0;u<f;u++)this.tmp[u]=this.arr[r+u];if(this.arr[p--]=this.arr[h--],0!=--d)if(1!==f){for(a=this.minGallop;;){s=0,l=0,c=!1;do{if(this.comparer(this.tmp[g],this.arr[h])<0){if(this.arr[p--]=this.arr[h--],s++,l=0,0==--d){c=!0;break}}else if(this.arr[p--]=this.tmp[g--],l++,s=0,1==--f){c=!0;break}}while((s|l)<a);if(c)break;do{if(0!==(s=d-o(this.tmp[g],this.arr,e,d,d-1,this.comparer))){for(d-=s,v=(p-=s)+1,m=(h-=s)+1,u=s-1;u>=0;u--)this.arr[v+u]=this.arr[m+u];if(0===d){c=!0;break}}if(this.arr[p--]=this.tmp[g--],1==--f){c=!0;break}if(0!==(l=f-i(this.arr[h],this.tmp,0,f,f-1,this.comparer))){for(f-=l,v=(p-=l)+1,m=(g-=l)+1,u=0;u<l;u++)this.arr[v+u]=this.tmp[m+u];if(f<=1){c=!0;break}}if(this.arr[p--]=this.arr[h--],0==--d){c=!0;break}a--}while(s>=7||l>=7);if(c)break;a<0&&(a=0),a+=2}if(this.minGallop=a,a<1&&(this.minGallop=1),1===f){for(v=(p-=d)+1,m=(h-=d)+1,u=d-1;u>=0;u--)this.arr[v+u]=this.arr[m+u];this.arr[p]=this.tmp[g]}else for(m=p-(f-1),u=0;u<f;u++)this.arr[m+u]=this.tmp[u]}else{for(v=(p-=d)+1,m=(h-=d)+1,u=d-1;u>=0;u--)this.arr[v+u]=this.arr[m+u];this.arr[p]=this.tmp[g]}else for(m=p-(f-1),u=0;u<f;u++)this.arr[m+u]=this.tmp[u]},e}();var l=function(e,t,r,i){var o,l,c,u,d,f=r,h=i,g=t;if(e.constructor!==Array)throw new TypeError("Sorting can only be applied on arrays.");if(f=f||0,g||(g=function(e,t){return e-t}),!((o=(h=h||e.length)-f)<2))if(o<64)n(e,g,f,h,f+(l=a(e,g,f,h)));else{c=function(e){for(var t=0,r=e;r>=64;)t|=1&r,r>>=1;return r+t}(o),u=new s(e,g);do{(l=a(e,g,f,f+o))<c&&(n(e,g,f,f+(d=o<=c?o:c),f+l),l=d),u.pushRun(f,l),u.mergeCollapse(),o-=l,f+=l}while(0!==o);u.mergeForceCollapse()}};t["default"]=l},function(e,t,r){"use strict";t.__esModule=!0,t.getConfig=function(e){if(!e)throw new Error("configName is missing");return n[e]},t.setConfig=function(e,t){if(!e)throw new Error("configName is missing");n[e]=t};var n={enableUTC:!1}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=0,a=function(e){return void 0===e&&(e=""),e+""+n++};t["default"]=a},function(e,t,r){"use strict";function n(e,t){if("string"!=typeof e)throw new Error("eventName must be a non-empty string");if(!(t instanceof Object))throw new Error("sender must be an object");return t._evtHandlers&&t._evtHandlers[e]||[]}t.__esModule=!0,t.addHandler=function a(e,t,r){var n;if(t instanceof Array){for(var i=[],o=t.length,s=0;s<o;s+=1)i.push(a(e,t[s],r));return i}if(!e||"string"!=typeof e)throw new Error("eventName must be a non-empty string");if("function"!=typeof t)throw new Error("handler must be a function");if(!(r instanceof Object))throw new Error("sender must be an object");r._evtHandlers=r._evtHandlers||{},r._evtHandlers[e]&&r._evtHandlers[e]instanceof Array||(r._evtHandlers[e]=[]);n=r._evtHandlers[e].length;for(var l=0;l<n;l++)if(r._evtHandlers[e][l]===t)return!1;return r._evtHandlers[e].push(t),!0},t.getHanlders=n,t.removeHandler=function i(e,t,r){var a,o;if(t instanceof Array){for(var s=[],l=t.length,c=0;c<l;c+=1)s.push(i(e,t[c],r));return s}if(!e||"string"!=typeof e)throw new Error("eventName must be a non-empty string");if(t&&"function"!=typeof t)throw new Error("handler must be a function");if(!(r instanceof Object))throw new Error("sender must be an object");if(!((a=n(e,r))instanceof Array)||0===a.length)return;if(!t)return delete r._evtHandlers[e],!0;o=a.length;for(var u=0;u<o;u++)a[u]===t&&a.splice(u,1);return!0},t.triggerEvent=function(e,t,r){var a,i,o;if(!e||"string"!=typeof e)throw new Error("eventName must be a non-empty string");if(!(t instanceof Object))throw new Error("sender must be an object");if(a=n(e,t),o={eventName:e,sender:t,data:r},!(a instanceof Array)||0===a.length)return;i=a.length;for(var s=0;s<i;s++)a[s](o);return!0}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]=function(e){return null!==e&&"object"==typeof e&&!Array.isArray(e)}},function(e,t,r){"use strict";t.__esModule=!0;var n=r(425);t.between=n.between,t.equals=n.equals,t.less=n.less,t.lessEquals=n.lessEquals,t.greater=n.greater,t.greaterEquals=n.greaterEquals,t.filter=n.filter,t.select=n.select,t.groupBy=n.groupBy,t.pipe=n.pipe,t.sort=n.sort,t.pivot=n.pivot},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0;var a=r(426);t.indexColBetween=a.indexColBetween,t.between=a.between,t.indexColEquals=a.indexColEquals,t.equals=a.equals,t.indexColLess=a.indexColLess,t.less=a.less,t.indexColLessEquals=a.indexColLessEquals,t.lessEquals=a.lessEquals,t.indexColGreater=a.indexColGreater,t.greater=a.greater,t.indexColGreaterEquals=a.indexColGreaterEquals,t.greaterEquals=a.greaterEquals;var i=r(429);t.filter=i.filter,t.select=i.select;var o=n(r(430));t.groupBy=o["default"];var s=n(r(449));t.pipe=s["default"];var l=n(r(450));t.sort=l["default"];var c=n(r(451));t.pivot=c["default"]},function(e,t,r){"use strict";t.__esModule=!0,t.indexColBetween=s,t.between=function(e,t,r){var n=t,o=r;return{ops:"between",type:i.OperatorTypes.GenericFilter,_updateArgs:function(e,t){n=e,o=t},fn:function(t,r,i,l){var c,u,d=t;if(l&&(d=l.call()),(c=(0,a.columnIndexOf)(e,r))>=0)return u=h(r,c),i&&i.indexBy===e?s(c,n,o,u).fn(d,r,i):{data:d,schema:r,config:i,generatorFn:function(){return d.filter((function(e){return u(e,n)>=0&&u(e,o)<=0}))}};throw new Error("Column '"+e+"' is not found in the schema.")}}},t.indexColEquals=l,t.equals=function(e,t){var r=t;return{ops:"equals",type:i.OperatorTypes.GenericFilter,_updateArgs:function(e){r=e},fn:function(t,n,i,o){var s,c,u=t;if(o&&(u=o.call()),(s=(0,a.columnIndexOf)(e,n))>=0)return c=h(n,s),i&&i.indexBy===e?l(s,r,c).fn(u,n,i):{data:u,schema:n,config:i,generatorFn:function(){return u.filter((function(e){return 0===c(e,r)}))}};throw new Error("Column '"+e+"' is not found in the schema.")}}},t.indexColLess=c,t.less=function(e,t){var r=t;return{ops:"less",type:i.OperatorTypes.GenericFilter,_updateArgs:function(e){r=e},fn:function(t,n,i,o){var s,l,u=t;if(o&&(u=o.call()),(s=(0,a.columnIndexOf)(e,n))>=0)return l=h(n,s),i&&i.indexBy===e?c(s,r,l).fn(u,n,i):{data:u,schema:n,config:i,generatorFn:function(){return u.filter((function(e){return l(e,r)<0}))}};throw new Error("Column '"+e+"' is not found in the schema.")}}},t.indexColLessEquals=u,t.lessEquals=function(e,t){var r=t;return{ops:"lessEquals",type:i.OperatorTypes.GenericFilter,_updateArgs:function(e){r=e},fn:function(t,n,i,o){var s,l,c=t;if(o&&(c=o.call()),(s=(0,a.columnIndexOf)(e,n))>=0)return l=h(n,s),i&&i.indexBy===e?u(s,r,l).fn(c,n,i):{data:c,schema:n,config:i,generatorFn:function(){return c.filter((function(e){return l(e,r)<=0}))}};throw new Error("Column '"+e+"' is not found in the schema.")}}},t.indexColGreater=d,t.greater=function(e,t){var r=t;return{ops:"greater",type:i.OperatorTypes.GenericFilter,_updateArgs:function(e){r=e},fn:function(t,n,i,o){var s,l,c=t;if(o&&(c=o.call()),(s=(0,a.columnIndexOf)(e,n))>=0)return l=h(n,s),i&&i.indexBy===e?d(s,r,l).fn(c,n,i):{data:c,schema:n,config:i,generatorFn:function(){return c.filter((function(e){return null!==e[s]&&"undefined"!=typeof e[s]&&l(e,r)>0}))}};throw new Error("Column '"+e+"' is not found in the schema.")}}},t.indexColGreaterEquals=f,t.greaterEquals=function(e,t){var r=t;return{ops:"greaterEquals",type:i.OperatorTypes.GenericFilter,_updateArgs:function(e){r=e},fn:function(t,n,i,o){var s,l,c=t;if(o&&(c=o.call()),(s=(0,a.columnIndexOf)(e,n))>=0)return l=h(n,s),i&&i.indexBy===e?f(s,r,l).fn(c,n,i):{data:c,schema:n,config:i,generatorFn:function(){return c.filter((function(e){return null!==e[s]&&"undefined"!=typeof e[s]&&l(e,r)>=0}))}};throw new Error("Column '"+e+"' is not found in the schema.")}}};var n=r(427),a=r(416),i=r(428),o=r(418);function s(e,t,r,a){var s=t,l=r,c=a;return{ops:"indexColBetween",type:i.OperatorTypes.IndexOpsFilter,_updateArgs:function(e,t){s=e,l=t},fn:function(t,r,a,i){var u,d,f,g=t;return i&&(g=i.call()),c||(c=h(r,e)),f="interval"===r[e].type?function(t,r){return(0,o.numberComparator)(t[e].end,r)}:c,u=(0,n.leftMostExactOrGreater)(s,g,c,0,g.length),d=(0,n.rightMostExactOrLesser)(l,g,f,u,g.length),{data:g,schema:r,config:a,generatorFn:function(){return g.slice(u,d+1)}}}}}function l(e,t,r){var a=t,o=r;return{ops:"indexColEquals",type:i.OperatorTypes.IndexOpsFilter,_updateArgs:function(e){a=e},fn:function(t,r,i,s){var l,c,u=t;return s&&(u=s.call()),o||(o=h(r,e)),(l=(0,n.leftMostExactOrGreater)(a,u,o,0,u.length))>=u.length||0!==o(u[l],a)?{data:[],schema:r,config:i}:(c=(0,n.rightMostExactOrLesser)(a,u,o,l,u.length),{data:u,schema:r,config:i,generatorFn:function(){return u.slice(l,c+1)}})}}}function c(e,t,r){var a=t,o=r;return{ops:"indexColLess",type:i.OperatorTypes.IndexOpsFilter,_updateArgs:function(e){a=e},fn:function(t,r,i,s){var l,c=t;return s&&(c=s.call()),o||(o=h(r,e)),l=(0,n.leftMostExactOrGreater)(a,c,o,0,c.length),{data:c,schema:r,config:i,generatorFn:function(){return c.slice(0,l)}}}}}function u(e,t,r){var a=t,o=r;return{ops:"indexColLessEquals",type:i.OperatorTypes.IndexOpsFilter,_updateArgs:function(e){a=e},fn:function(t,r,i,s){var l,c=t;return s&&(c=s.call()),o||(o=h(r,e)),l=(0,n.rightMostExactOrLesser)(a,c,o,0,c.length),{data:c,schema:r,config:i,generatorFn:function(){return c.slice(0,l+1)}}}}}function d(e,t,r){var a=t,o=r;return{ops:"indexColGreater",type:i.OperatorTypes.IndexOpsFilter,_updateArgs:function(e){a=e},fn:function(t,r,i,s){var l,c,u=t;return s&&(u=s.call()),o||(o=h(r,e)),l=(0,n.rightMostExactOrLesser)(a,u,o,0,u.length),c=(0,n.leftMostExactOrGreater)(null,u,o,l,u.length),{data:u,schema:r,config:i,generatorFn:function(){return u.slice(l+1,c)}}}}}function f(e,t,r){var a=t,o=r;return{ops:"indexColGreaterEquals",type:i.OperatorTypes.IndexOpsFilter,_updateArgs:function(e){a=e},fn:function(t,r,i,s){var l,c,u=t;return s&&(u=s.call()),o||(o=h(r,e)),l=(0,n.leftMostExactOrGreater)(a,u,o,0,u.length),c=(0,n.leftMostExactOrGreater)(null,u,o,l,u.length),{data:u,schema:r,config:i,generatorFn:function(){return u.slice(l,c)}}}}}var h=function(e,t){switch(e[t].type){case"interval":return function(e,r){return(0,o.numberComparator)(e[t].start,r)};case"number":case"date":return function(e,r){return(0,o.numberComparator)(e[t],r)};default:return function(e,r){return(0,o.stringComparator)(String(e[t]).toLowerCase(),String(r).toLowerCase())}}}},function(e,t,r){"use strict";t.__esModule=!0,t.leftMostExactOrGreater=function(e,t,r,n,a){var i=n,o=a;for(;i<o;){var s=i+Math.floor((o-i)/2);r(t[s],e)<0?i=s+1:o=s}return i},t.rightMostExactOrLesser=function(e,t,r,n,a){var i=n,o=a;for(;i<o;){var s=i+Math.floor((o-i)/2);r(t[s],e)>0?o=s:i=s+1}return i-1}},function(e,t,r){"use strict";t.__esModule=!0,t.OperatorTypes=void 0;t.OperatorTypes={IndexOpsFilter:0,GenericFilter:1,GroupBy:2,Sort:3,Select:4}},function(e,t,r){"use strict";t.__esModule=!0,t.select=function(e,t){var r=e,i=t;return r=r&&r.constructor!==Array?[r]:r,{ops:"select",type:n.OperatorTypes.Select,fn:function(e,t,n,o){var s,l,c=[],u=[];if(r)if((i=i||{exclude:!1}).exclude)for(s=0;s<t.length;s++)r.includes(t[s].name)||(c.push(t[s]),u.push(s));else for(s=0;s<r.length;s++)(l=(0,a.columnIndexOf)(r[s],t))>-1&&!u.includes(l)&&(c.push(t[l]),u.push(l));else c=t;return{data:e,schema:c,config:n,generatorFn:function(){var t=u.length;if(t>0){var r,n,a,i=[];for(r=0;r<e.length;r++){for(a=[],n=0;n<t;n++)a[n]=e[r][u[n]];i[r]=a}return i}return e.slice(0)}}}}},t.filter=function(e){var t=this;return{ops:"filter",type:n.OperatorTypes.GenericFilter,fn:function(r,n,a,i){var o=r;return{data:o,schema:n,config:a,generatorFn:function(){i&&(o=i.call());for(var r={},a=0;a<n.length;a++)r[n[a].name]=a;return o.filter((function(n){return e.call(t,n,r)}))}}}}};var n=r(428),a=r(416)},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t._singleSortedAddRow=p,t._singleSortedAddRowDate=m,t["default"]=void 0;var a=r(416),i=r(431),o=r(444),s=r(445),l=n(r(446)),c=r(420),u=r(428),d=r(427),f=r(418),h=n(r(448));function g(e,t,r,n){var a,i,o,s,c,u=[],d=t,f=r,g=d.length,p=f.length;for(d=d instanceof Array?d:[d],f=f instanceof Array?f:[f],o=0;o<g;o++)a=n(d[o].column,e),c={name:d[o].outputAs||d[o].column,type:"date"===a.type?"interval":a.type},void 0!==a.enableUTC&&(c.enableUTC=a.enableUTC),u.push(c);for(o=0;o<p;o++){if(s=f[o].operation||"avg",a=n(f[o].column,e),!l["default"].resolve(s))throw new Error(s+" is not a defined operation");switch(s){case"first":case"last":i=a.type;break;case"count":i="number";break;default:if("number"!==a.type)throw new Error(s+" can apply only on numbers");i="number"}u.push({name:f[o].outputAs||f[o].column+(s?h["default"]+s:""),type:i})}return u}function p(e,t,r){var n=t;return n&&r===n[0]||(n=[r],e.push(n)),n}function m(e,t,r,n,a){var o=t;if(r>=o[0].end){var l;switch(n.duration.Unit){case"Month":case"Quarter":case"Year":l=(0,i.getDateStart)(r,n.duration,n.enableUTC,n.weekStartFrom,a);break;default:l=r-(r-a)%n.duration.ms}o=[(0,s.interval)(l,n)],e.push(o)}return o}function v(){var e={};return function(t,r,n){if(!e[t]){var i=(0,a.columnIndexOf)(t,r),o=r[i];if(void 0===o)throw new Error("incorrect column name in config - "+t);e[t]=o,e[t].column=t,e[t].index=i,"date"===o.type&&n&&(e[t].peaks=(0,a.columnExtents)(t,n,r))}return e[t]}}function b(e,t,r,n,a,o,l,c,u,d){var f,h,g,p,m="",v=[],b=r.length,x=c;if(e.length>0){for(f=0;f<b;f++)if("date"===(h=a(r[f].column,t)).type){if(o[f].startValFloorVal>e[h.index])return x;switch(r[f].timeUnit.name){case"Month":case"Quarter":case"Year":o[f].value=(0,i.getDateStart)(e[h.index],o[f].intervalConfig.duration,o[f].intervalConfig.enableUTC,o[f].intervalConfig.weekStartFrom,o[f].startValFloorVal);break;default:o[f].value=e[h.index]-(e[h.index]-o[f].startValFloorVal)%o[f].intervalConfig.duration.ms}m+=o[f].value+"-"}else v[f]=e[h.index],m+=e[h.index]+"-";if(l[m=m.slice(0,-1)]>=0)v=u[l[m]],g=l[m];else{for(var w in l[m]=x++,o)p=(0,s.interval)(o[w].value,o[w].intervalConfig),v[w]=p;u.push(v),g=u.length-1}return d[g]=d[g]||{},v&&y(e,t,v,b,n,a,d[g]),x}}function y(e,t,r,n,a,i,o){var s,c,u,d,f=a.length;for(d=0;d<f;d++)if(void 0!==e[(s=i(a[d].column,t)).index]&&null!==e[s.index]){switch(c=a[d].operation||"avg"){case"sum":case"min":case"max":case"first":case"last":u=null;break;default:u=o[d]=o[d]&&o[d]+1||1}r[n+d]="count"===c?u:l["default"].resolve(c)(void 0!==r[n+d]?r[n+d]:null,e[s.index],u)}}var x=function(e,t){var r=e,n=t;return{ops:"groupBy",type:u.OperatorTypes.GroupBy,_updateArgs:function(e,t){r=e,n=t},fn:function(e,t,l,u){var h=e;if(u&&(h=u.call()),!r||0===r.length)throw new Error("groupConfigArray cannot be empty");if(!n||0===n.length)throw new Error("aggrConfigArray cannot be empty");return!(r instanceof Array)&&r instanceof Object&&(r=[r]),!(n instanceof Array)&&n instanceof Object&&(n=[n]),1===r.length&&l&&r[0].column===l.indexBy?function(e,t,r,n,l){var u,h,b,x,w,C,k,_,S,E=[],A=e.length,N=0,T=v(),M=[];if((h=T(n.column,t)).outputAs=n.outputAs,u=g(t,[h],l,T),A>0){if(_=h.enableUTC||(0,c.getConfig)("enableUTC"),"date"===h.type){var D,F,I;if(x=(0,o.duration)(n.timeUnit,Math.abs(n.binSize)||1),e[0]&&e[0][h.index]&&e[A-1]&&e[A-1][h.index]||(D=(0,a.columnExtents)(n.column,e,t,r.indexBy)),F=e[0]&&e[0][h.index]||D.min,(I=n.startValue&&parseInt(n.startValue,10))&&"Week"!==n.timeUnit.name)if(I>=F){w=(0,i.getDateStart)(I,(0,o.duration)(n.timeUnit,1),_,n.weekStartFrom),N=(0,d.leftMostExactOrGreater)(w,e,(function(e,t){return(0,f.numberComparator)(e[h.index],t)}),0,e.length)}else w=(0,i.getDateStart)(F,x,_,n.weekStartFrom,I);else w=(0,i.getDateStart)(F,(0,o.duration)(n.timeUnit,1),_,n.weekStartFrom);b=e[A-1]&&e[A-1][h.index]||D.max}if(void 0===w||w<=b){var O={duration:x,outputFormat:n.outputFormat,enableUTC:_,weekStartFrom:n.weekStartFrom};for(void 0!==w&&(C=[(0,s.interval)(w,O)],E.push(C)),S=N;S<A;S++)e[S].length>0&&("date"===h.type?C=m(E,C,e[S][h.index],O,w):"string"!==h.type&&"number"!==h.type||(C=p(E,C,e[S][h.index])),k=E.length-1,M[k]=M[k]||{},C&&y(e[S],t,C,1,l,T,M[k]))}}return{data:E,schema:u,config:{indexBy:n.outputAs||n.column}}}(h,t,l,r[0],n):function(e,t,r,n,a){var s,l,u,d,f,h=[],p=[],m=!0,y=e.length,x=n.length,w={},C=[],k=v(),_={},S=0;for(f=0;f<x;f++)(l=k(n[f].column,t,e)).outputAs=n[f].outputAs,"date"===l.type&&(w[f]||(n[f].startValue>=l.peaks.max&&(m=!1),w[f]=Object.assign({},l),w[f].intervalConfig={duration:(0,o.duration)(n[f].timeUnit,Math.abs(n[f].binSize)||1),outputFormat:n[f].outputFormat,enableUTC:l.enableUTC||(0,c.getConfig)("enableUTC"),weekStartFrom:n[f].weekStartFrom},u=parseInt(n[f].startValue,10)||l.peaks.min,w[f].startValFloorVal=u&&(0,i.getDateStart)(u,(0,o.duration)(n[f].timeUnit,1),w[f].intervalConfig.enableUTC,w[f].intervalConfig.weekStartFrom,parseInt(n[f].startValue,10)),w[f].max=l.peaks.max)),p[f]=l,d||n[f].column!==r.indexBy||(d=n[f].outputAs||n[f].column);if(s=g(t,p,a,k),m&&y>0)for(f=0;f<y;f++)S=b(e[f],t,n,a,k,w,_,S,h,C);return{data:h,schema:s,config:{indexBy:d}}}(h,t,l,r,n)}}};t["default"]=x},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.getDefaultOutputFormat=function(e){switch(e){case"Millisecond":case"Second":case"Minute":case"Hour":case"Day":case"Month":case"Year":return u[e];case"Week":return u.Day;case"Quarter":return u.Month}},t.dateIntervalToString=function(){var e,t=this.config;switch(e="undefined"!=typeof t.enableUTC&&t.enableUTC?s["default"].utcFormatter(t.outputFormat):s["default"].formatter(t.outputFormat),t.duration.Unit){case"Millisecond":case"Second":case"Minute":case"Hour":case"Day":case"Month":case"Year":return e.format(new Date(this.start))+(t.duration.number>1?" - "+e.format(new Date(this.end-1)):"");case"Week":case"Quarter":return e.format(new Date(this.start))+" - "+e.format(new Date(this.end-1))}},t.dateRangeCaclulator=function(e,t,r,n,a){void 0===a&&(a=!1);var i,o,s;i=e,a&&((s=Object.assign({},t)).number=1,i=h(i,s,r,n));return o=g(i,t.Unit,t.number,r,n),{startDate:i,endDate:o}},t.getDateStart=h,t.getDateOffset=g;var a=c(r(432)),i=c(r(439)),o=r(300),s=n(r(292));function l(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(l=function(e){return e?r:t})(e)}function c(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=l(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}return n["default"]=e,r&&r.set(e,n),n}var u={Year:"%Y",Month:"%b %Y",Day:"%b %d, %Y",Hour:"%b %d, %Y %H hrs",Minute:"%b %d, %Y %H:%M",Second:"%b %d, %Y %H:%M:%S",Millisecond:"%b %d, %Y %H:%M:%S:%L"},d={Millisecond:a.timeMillisecond,Second:a.timeSecond,Minute:a.timeMinute,Hour:a.timeHour,Day:a.timeDay,Week:{0:a.timeSunday,1:a.timeMonday,2:a.timeTuesday,3:a.timeWednesday,4:a.timeThursday,5:a.timeFriday,6:a.timeSaturday},Month:a.timeMonth,Quarter:a.timeQuarter,Year:a.timeYear},f={Millisecond:i.utcMillisecond,Second:i.utcSecond,Minute:i.utcMinute,Hour:i.utcHour,Day:i.utcDay,Week:{0:i.utcSunday,1:i.utcMonday,2:i.utcTuesday,3:i.utcWednesday,4:i.utcThursday,5:i.utcFriday,6:i.utcSaturday},Month:i.utcMonth,Quarter:i.utcQuarter,Year:i.utcYear};function h(e,t,r,n,a){var i,s=void 0!==r&&r?f[t.Unit]:d[t.Unit],l=n;if(l&&!o.Weekdays[l.name])throw new Error("Invalid weekStartFrom provided: "+l);return 1===t.number?"Week"===t.Unit?+s[(l=l||o.Weekdays.Sunday).id].floor(new Date(e)):+s.floor(new Date(e)):a?"Week"===t.Unit?(i=s[(l=l||o.Weekdays.Sunday).id].count(a,e)%t.number)?g(+s[l.id].floor(e),t.Unit,-i,r,l):+s[l.id].floor(e):(i=s.count(a,e)%t.number)?g(+s.floor(e),t.Unit,-i,r,l):+s.floor(e):"Week"===t.Unit?+s[(l=l||o.Weekdays.Sunday).id].every(t.number).floor(new Date(e)):+s.every(t.number).floor(new Date(e))}function g(e,t,r,n,a){switch(t){case"Month":case"Quarter":case"Year":return+(void 0!==n&&n?f[t]:d[t]).offset(new Date(e),r);default:return e+o.DatetimeUnits[t].ms*r}}},function(e,t,r){"use strict";t.__esModule=!0;var n=h(r(433));t.timeMillisecond=n["default"],t.millisecondObj=n.millisecondObj;var a=h(r(435));t.timeSecond=a["default"],t.secondObj=a.secondObj;var i=h(r(436));t.timeMinute=i["default"],t.minuteObj=i.minuteObj;var o=h(r(304));t.timeHour=o["default"],t.hourObj=o.hourObj;var s=h(r(296));t.timeDay=s["default"],t.dayObj=s.dayObj;var l=h(r(303));t.timeWeek=l["default"],t.timeSunday=l.sunday,t.timeMonday=l.monday,t.timeTuesday=l.tuesday,t.timeWednesday=l.wednesday,t.timeThursday=l.thursday,t.timeFriday=l.friday,t.timeSaturday=l.saturday,t.weekObj=l.weekObj;var c=h(r(437));t.timeQuarter=c["default"],t.quarterObj=c.quarterObj;var u=h(r(438));t.timeMonth=u["default"],t.monthObj=u.monthObj;var d=h(r(305));function f(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(f=function(e){return e?r:t})(e)}function h(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=f(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}return n["default"]=e,r&&r.set(e,n),n}t.timeYear=d["default"],t.yearObj=d.yearObj},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.millisecondObj=t["default"]=void 0;var a=n(r(434)),i=r(299),o={name:"millisecond",floor:function(e){return e},offset:function(e,t,r,n){var a=t>0,o={date:new Date(Number(e))},s=new Date(Number(o.date));return new Date(Number(a?(0,i.clampDownDateWithinClip)(o.date,new Date(Number(s.setTime(Number(s)+Number(t)))),r,n):(0,i.clampUpDateWithinClip)(o.date,new Date(Number(s.setTime(Number(s)+Number(t)))),r,n)))},count:function(e,t,r){var n=(0,i.getValidDatesWithin)(r,e,t),a=0,o=(0,i.getClampRangesAround)(r,t);return(n=(0,i.getClipArray)(o,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t-e-a}},s=new a["default"](o);t.millisecondObj=o;var l=s;t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=n(r(238)),i=n(r(297)),o=r(299),s=function(e){function t(){return e.apply(this,arguments)||this}return(0,a["default"])(t,e),t.prototype.every=function(e){var t=Math.floor(e);return this.count&&Number.isFinite(t)&&t>0?t>1?new i["default"]({name:"millisecond",floor:function(e,r,n){return new Date(Number((0,o.getFloor)(new Date(Number(e.setTime(Math.floor(e/t)*t))),r,n)))},offset:function(e,r,n,a){var i=r>0,s={date:new Date(Number(e))},l=new Date(Number(s.date));return new Date(Number(i?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+r*t))),n,a):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+r*t))),n,a)))},count:function(e,r,n){var a=(0,o.getValidDatesWithin)(n,e,r),i=0,s=(0,o.getClampRangesAround)(n,r);return(a=(0,o.getClipArray)(s,a)).forEach((function(e){i+=Number(e.to)-Number(e.from)})),r-e-Math.floor(i/t)}}):this:null},t}(i["default"]);t["default"]=s},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.secondObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"second",floor:function(e,t,r){return new Date(Number((0,o.getFloor)(new Date(Number(e.setTime(Math.floor(e/i.durationSecond)*i.durationSecond))),t,r)))},offset:function(e,t,r,n){var a=t>0,s={date:new Date(Number(e))},l=new Date(Number(s.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationSecond))),r,n):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationSecond))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e)/i.durationSecond-Math.floor(a/i.durationSecond)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTCSeconds(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getUTCSeconds()-n.getUTCSeconds()-l/i.durationSecond}},l=new a["default"](s);t.secondObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.minuteObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"minute",floor:function(e,t,r){return new Date(Number((0,o.getFloor)(new Date(Number(e.setTime(Math.floor(e/i.durationMinute)*i.durationMinute))),t,r)))},offset:function(e,t,r,n){var a=t>0,s={date:new Date(Number(e))},l=new Date(Number(s.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationMinute))),r,n):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationMinute))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e)/i.durationMinute-Math.floor(a/i.durationMinute)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setMinutes(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getMinutes()-n.getMinutes()-Math.floor(l/i.durationMinute)}},l=new a["default"](s);t.minuteObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.quarterObj=t["default"]=void 0;var a=n(r(297)),i=r(299),o=r(298),s={name:"quarter",floor:function(e,t,r){return e.setMonth(e.getMonth()-(e.getMonth()+3)%3,1),new Date(Number((0,i.getFloor)(new Date(Number(e.setHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,o={date:new Date(Number(e))},s=new Date(Number(o.date));return new Date(Number(a?(0,i.clampDownDateWithinClip)(o.date,new Date(Number(s.setMonth(s.getMonth()+3*t))),r,n):(0,i.clampUpDateWithinClip)(o.date,new Date(Number(s.setMonth(s.getMonth()+3*t))),r,n)))},count:function(e,t,r){var n=(0,i.getValidDatesWithin)(r,e,t),a=0,s=(0,i.getClampRangesAround)(r,t);return(n=(0,i.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t.getMonth()-(t.getMonth()+3)%3-(e.getMonth()-(e.getMonth()+3)%3)-Math.floor(a/o.durationMonth))/3+4*(t.getFullYear()-e.getFullYear())},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setMonth(0),n=(0,i.getFloor)(new Date(Number(s)),t,r),(0,i.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),Math.floor((e.getMonth()-n.getMonth()-Math.floor(l/o.durationMonth))/3)}},l=new a["default"](s);t.quarterObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.monthObj=t["default"]=void 0;var a=n(r(297)),i=r(299),o=r(298),s={name:"month",floor:function(e,t,r){return e.setDate(1),new Date(Number((0,i.getFloor)(new Date(Number(e.setHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,o={date:new Date(Number(e))},s=new Date(Number(o.date));return new Date(Number(a?(0,i.clampDownDateWithinClip)(o.date,new Date(Number(s.setMonth(s.getMonth()+t))),r,n):(0,i.clampUpDateWithinClip)(o.date,new Date(Number(s.setMonth(s.getMonth()+t))),r,n)))},count:function(e,t,r){var n=(0,i.getValidDatesWithin)(r,e,t),a=0,s=(0,i.getClampRangesAround)(r,t);return(n=(0,i.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t.getMonth()-e.getMonth()-Math.floor(a/o.durationMonth)+12*(t.getFullYear()-e.getFullYear())},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setMonth(0),n=(0,i.getFloor)(new Date(Number(s)),t,r),(0,i.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getMonth()-n.getMonth()-Math.floor(l/o.durationMonth)}},l=new a["default"](s);t.monthObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=h(r(433));t.utcMillisecond=n["default"],t.millisecondObj=n.millisecondObj;var a=h(r(435));t.utcSecond=a["default"],t.secondObj=a.secondObj;var i=h(r(440));t.utcMinute=i["default"],t.utcMinuteObj=i.utcMinuteObj;var o=h(r(441));t.utcHour=o["default"],t.utcHourObj=o.utcHourObj;var s=h(r(301));t.utcDay=s["default"],t.utcDayObj=s.utcDayObj;var l=h(r(302));t.utcWeek=l["default"],t.utcSunday=l.utcSunday,t.utcMonday=l.utcMonday,t.utcTuesday=l.utcTuesday,t.utcWednesday=l.utcWednesday,t.utcThursday=l.utcThursday,t.utcFriday=l.utcFriday,t.utcSaturday=l.utcSaturday,t.utcWeekObj=l.utcWeekObj;var c=h(r(442));t.utcQuarter=c["default"],t.utcQuarterObj=c.utcQuarterObj;var u=h(r(443));t.utcMonth=u["default"],t.utcMonthObj=u.utcMonthObj;var d=h(r(307));function f(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(f=function(e){return e?r:t})(e)}function h(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=f(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}return n["default"]=e,r&&r.set(e,n),n}t.utcYear=d["default"],t.utcYearObj=d.utcYearObj;var g={getInterval:function(e){switch(e+""){case"millisecond":return n["default"];case"second":return a["default"];case"minute":return i["default"];case"hour":return o["default"];case"day":return s["default"];case"week":return l["default"];case"sunday":return l.utcSunday;case"monday":return l.utcMonday;case"tuesday":return l.utcTuesday;case"wednesday":return l.utcWednesday;case"thursday":return l.utcThursday;case"friday":return l.utcFriday;case"saturday":return l.utcSaturday;case"quarter":return c["default"];case"month":return u["default"];case"year":return d["default"]}}};t["default"]=g},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcMinuteObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"minute",floor:function(e,t,r){return new Date(Number((0,o.getFloor)(new Date(Number(e.setUTCSeconds(0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,s={date:new Date(e)},l=new Date(Number(s.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationMinute))),r,n):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationMinute))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e)/i.durationMinute-Math.floor(a/i.durationMinute)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTCMinutes(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getUTCMinutes()-n.getUTCMinutes()-Math.floor(l/i.durationMinute)}},l=new a["default"](s);t.utcMinuteObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcHourObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"hour",floor:function(e,t,r){return new Date(Number((0,o.getFloor)(new Date(Number(e.setUTCMinutes(0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,s={date:new Date(Number(e))},l=new Date(Number(s.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationHour))),r,n):(0,o.clampUpDateWithinClip)(s.date,new Date(Number(l.setTime(Number(l)+t*i.durationHour))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t-e)/i.durationHour-Math.floor(a/i.durationHour)},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTChours(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getUTCHours()-n.getUTCHours()-Math.floor(l/i.durationHour)}},l=new a["default"](s);t.utcHourObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcQuarterObj=t["default"]=void 0;var a=n(r(297)),i=r(299),o=r(298),s={name:"quarter",floor:function(e,t,r){return e.setUTCMonth(e.getUTCMonth()-(e.getUTCMonth()+3)%3,1),new Date(Number((0,i.getFloor)(new Date(Number(e.setUTCHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,o={date:new Date(Number(e))},s=new Date(Number(o.date));return new Date(Number(a?(0,i.clampDownDateWithinClip)(o.date,new Date(Number(s.setUTCMonth(s.getUTCMonth()+3*t))),r,n):(0,i.clampUpDateWithinClip)(o.date,new Date(Number(s.setUTCMonth(s.getUTCMonth()+3*t))),r,n)))},count:function(e,t,r){var n=(0,i.getValidDatesWithin)(r,e,t),a=0,s=(0,i.getClampRangesAround)(r,t);return(n=(0,i.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),(t.getUTCMonth()-(t.getUTCMonth()+3)%3-(e.getUTCMonth()-(e.getUTCMonth()+3)%3)-Math.floor(a/o.durationMonth))/3+4*(t.getUTCFullYear()-e.getUTCFullYear())},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTCMonth(0),n=(0,i.getFloor)(new Date(Number(s)),t,r),(0,i.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),Math.floor(e.getUTCMonth()-n.getUTCMonth()-Math.floor(l/o.durationMonth))}},l=new a["default"](s);t.utcQuarterObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.utcMonthObj=t["default"]=void 0;var a=n(r(297)),i=r(298),o=r(299),s={name:"month",floor:function(e,t,r){return e.setUTCDate(1),new Date(Number((0,o.getFloor)(new Date(Number(e.setUTCHours(0,0,0,0))),t,r)))},offset:function(e,t,r,n){var a=t>0,i={date:new Date(Number(e))},s=new Date(Number(i.date));return new Date(Number(a?(0,o.clampDownDateWithinClip)(i.date,new Date(Number(s.setUTCMonth(s.getUTCMonth()+t))),r,n):(0,o.clampUpDateWithinClip)(i.date,new Date(Number(s.setUTCMonth(s.getUTCMonth()+t))),r,n)))},count:function(e,t,r){var n=(0,o.getValidDatesWithin)(r,e,t),a=0,s=(0,o.getClampRangesAround)(r,t);return(n=(0,o.getClipArray)(s,n)).forEach((function(e){a+=Number(e.to)-Number(e.from)})),t.getUTCMonth()-e.getUTCMonth()-Math.floor(a/i.durationMonth)+12*(t.getUTCFullYear()-e.getUTCFullYear())},field:function(e,t,r){var n,a={date:new Date(Number(e))},s=new Date(Number(a.date)),l=0;return s.setUTCMonth(0),n=(0,o.getFloor)(new Date(Number(s)),t,r),(0,o.getValidDatesWithin)(t,new Date(Number(n)),a.date).forEach((function(e){l+=Number(e.to)-Number(e.from)})),e.getUTCMonth()-n.getUTCMonth()-Math.floor(l/i.durationMonth)}},l=new a["default"](s);t.utcMonthObj=s;var c=l;t["default"]=c},function(e,t,r){"use strict";t.__esModule=!0,t.duration=function(e,t){var r=t;if(!e||!n.DatetimeUnits[e.name])throw new Error("Invalid Unit provided: "+e);return r=Math.abs(r)||1,{Unit:e.name,number:r,ms:e.ms*r}};var n=r(300)},function(e,t,r){"use strict";t.__esModule=!0,t.interval=function(e,t,r){void 0===r&&(r=!1);if(t.duration.ms){var i=(0,a.dateRangeCaclulator)(e,t.duration,t.enableUTC,t.weekStartFrom||n.Weekdays.Sunday,r),o=i.startDate,s=i.endDate;return t.outputFormat=t.outputFormat||(0,a.getDefaultOutputFormat)(t.duration.Unit),{start:o,end:s,config:t,toString:a.dateIntervalToString}}};var n=r(300),a=r(431)},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(447),a={store:{},_defaultAggregators:{sum:n.sum,avg:n.avg,count:n.count,min:n.min,max:n.max,first:n.first,last:n.last,variance:n.variance,stddev:n.stddev},register:function(e,t){return this.store[e]=t,this},getRegisteredAggregations:function(){return Object.assign(this.store)},getDefaultAggregations:function(){return Object.assign(this._defaultAggregators)},resolve:function(e){return this._defaultAggregators[e]||this.store[e]}};t["default"]=a},function(e,t,r){"use strict";t.__esModule=!0,t.stddev=t.variance=t.last=t.first=t.max=t.min=t.count=t.avg=t.sum=void 0;var n=function(e,t,r){return((r-1)*e+t)/r},a=function(e,t,r){var a,i=t,o=0;return e&&(i=e.avg,o=e.variance),a=i,r>1&&(o=(o*(r-2)+(t-(i=n(i,t,r)))*(t-a))/(r-1)),{avg:i,variance:o}};t.stddev=function(e,t,r){var n,i;return e&&(n={avg:e.avg,variance:e.stddev*e.stddev}),{avg:(i=a(n,t,r)).avg,stddev:Math.sqrt(i.variance)}},t.variance=a,t.last=function(e,t){return t},t.first=function(e,t){return null===e?t:e},t.max=function(e,t){return null!==e?e<t?t:e:t},t.min=function(e,t){return null!==e?e>t?t:e:t},t.count=function(e){return e+1},t.avg=n,t.sum=function(e,t){return e+t}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]=" --fcsep-- "},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=function(){for(var e,t=[],r=[],i=[],o=function(e,t){for(var r=[],n=e.length,i=0;i<n;i++)t[i]||r.push(e[i]);return r&&r.length>0&&(0,a.binaryInsertionSort)(r,(function(e,t){return e.type-t.type})),r},s=function(e){var t=[],r=e.length;(0,a.binaryInsertionSort)(e,(function(e,t){return e.type-t.type})),t.push(e[0]);for(var n=1;n<r;n++)e[n].type>=3&&e[n].type===t[t.length-1].type&&t.pop(),t.push(e[n]);return t},l=arguments.length,c=new Array(l),u=0;u<l;u++)c[u]=arguments[u];e=c.length;for(var d=0;d<e;d++)switch(c[d].type){case n.OperatorTypes.IndexOpsFilter:case n.OperatorTypes.GenericFilter:t.push(c[d]),r.push(!1);break;case n.OperatorTypes.Select:case n.OperatorTypes.Sort:t.push(c[d]),r.push(!0);break;case n.OperatorTypes.GroupBy:i=i.concat(o(t,r),c[d]),t=[],r=[]}return i=i.concat(s(t))};var n=r(428),a=r(419)},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=r(428),i=r(416),o=r(418),s=n(r(419));var l=function(e){var t=e;return{ops:"sort",type:a.OperatorTypes.Sort,_updateArgs:function(e){t=e},fn:function(e,r,n,a){var l=e;return{data:l,schema:r,config:t.constructor===Array&&t.length?{indexBy:t[0].column}:t.constructor===Object?{indexBy:t.column}:void 0,generatorFn:function(){var e;if(a&&(l=a.call()),t.constructor===Function)e=t;else{t.constructor!==Array&&(t=[t]);var n,c,u,d=[],f=[];for(n=0;n<t.length;n++)if(t[n].column){if(c=(0,i.columnIndexOf)(t[n].column,r),f.push(c),-1===c)throw new Error("Sort column is not found in schema - "+t[n].column);switch(r[c].type){case"number":case"interval":case"date":d.push(o.numberComparator);break;default:d.push(o.stringComparator)}}e=function(e,a){for(n=0;n<t.length;n++){if(0!==(u="interval"===r[f[n]].type?"desc"===t[n].order?d[n](a[f[n]].start,e[f[n]].start):d[n](e[f[n]].start,a[f[n]].start):"desc"===t[n].order?d[n](a[f[n]],e[f[n]]):d[n](e[f[n]],a[f[n]])))return u;if(n===t.length-1)return 0}}}return(0,s["default"])(l,e),l}}}}};t["default"]=l},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t["default"]=void 0;var a=r(416),i=r(431),o=r(444),s=r(445),l=n(r(446)),c=r(420),u=r(428),d=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var r=p(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var o=a?Object.getOwnPropertyDescriptor(e,i):null;o&&(o.get||o.set)?Object.defineProperty(n,i,o):n[i]=e[i]}n["default"]=e,r&&r.set(e,n);return n}(r(430)),f=r(418),h=r(427),g=n(r(448));function p(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(p=function(e){return e?r:t})(e)}function m(e,t,r,n,a,i,o,s,c){var u,d,f,h,p,m=a.length;for(h=0;h<m;h++)if(void 0!==e[u=s(a[h].column,t)]&&null!==e[u]){switch(d=a[h].operation||"avg",p=o[e[i]+g["default"]+(a[h].outputAs||a[h].column+(d?g["default"]+d:""))],d){case"sum":case"min":case"max":case"first":case"last":f=null;break;default:f=c[p]=c[p]&&c[p]+1||1}r[n+p]="count"===d?f:l["default"].resolve(d)(void 0!==r[n+p]?r[n+p]:null,e[u],f)}}var v=function(e,t,r){var n=e,p=t,v=r;return{ops:"pivot",type:u.OperatorTypes.GroupBy,_updateArgs:function(e,t,r){n=e,p=t,v=r},fn:function(e,t,r,u){if(0===n.length)throw new Error("groupConfigArray cannot be empty");if(0===v.length)throw new Error("aggrConfigArray cannot be empty");if(!p)throw new Error("pivotCol cannot be empty");return!(n instanceof Array)&&n instanceof Object&&(n=[n]),!(v instanceof Array)&&v instanceof Object&&(v=[v]),1===n.length&&r&&n[0].column===r.indexBy?function(e,t,r,n,u,p){var v,b,y,x,w,C,k,_,S,E,A,N,T,M,D,F=[],I=e.length,O=0,L=(P={},function(e,t){return P[e]||(P[e]=(0,a.columnIndexOf)(e,t)),P[e]}),R=[];var P;if(-1===(x=(0,a.columnIndexOf)(n.column,t)))throw new Error("incorrect column name in groupConfigArr - "+n);if(-1===(C=(0,a.columnIndexOf)(p,t)))throw new Error("incorrect pivot column name");if(w=t[x],k=t[C],(S=Object.assign({},n)).type=w.type,S.outputAs=n.outputAs,y=function(e,t,r,n,i){var o,s,c,u,d,h,p,m,v,b,y,x,w,C=[],k={},_=0,S=r,E=n;for(S=S instanceof Array?S:[S],E=E instanceof Array?E:[E],u=S.length,d=E.length,b=0;b<u;b++){if(h=(0,a.columnIndexOf)(S[b].column,t),p=t[h],-1===h)throw new Error("incorrect column name in groupConfigArr - "+S[b].column);w={name:S[b].outputAs||S[b].column,type:"date"===p.type?"interval":p.type},void 0!==p.enableUTC&&(w.enableUTC=p.enableUTC),C.push(w)}switch(i.type){case"number":case"date":o=f.numberComparator;break;default:o=f.stringComparator}for((s=(0,a.columnUnique)(i.name,e,t)).sort((function(e,t){return o(e,t)})),c=s.length,b=0;b<d;b++){if(x=E[b].operation||"avg",h=(0,a.columnIndexOf)(E[b].column,t),p=t[h],-1===h)throw new Error("incorrect column name in aggrConfigArr - "+E[b].column);if(!l["default"].resolve(x))throw new Error(x+" is not a defined operation");switch(x){case"first":case"last":m=p.type;break;case"count":m="number";break;default:if("number"!==p.type)throw new Error(x+" can apply only on numbers");m="number"}for(y=0;y<c;y++)v=s[y]+g["default"]+(E[b].outputAs||E[b].column+(x?g["default"]+x:"")),k[v]=_++,C.push({name:v,type:m})}return{schema:C,pivots:k}}(e,t,S,u,k),v=y.schema,b=y.pivots,I>0){if(M=w.enableUTC||(0,c.getConfig)("enableUTC"),"date"===w.type){var V,j,B;if(E=(0,o.duration)(n.timeUnit,Math.abs(n.binSize)||1),e[0]&&e[0][x]&&e[I-1]&&e[I-1][x]||(V=(0,a.columnExtents)(n.column,e,t,r.indexBy)),j=e[0]&&e[0][x]||V.min,(B=n.startValue&&parseInt(n.startValue,10))&&"Week"!==n.timeUnit.name)if(B>=j){A=(0,i.getDateStart)(B,(0,o.duration)(n.timeUnit,1),M,n.weekStartFrom),O=(0,h.leftMostExactOrGreater)(A,e,(function(e,t){return(0,f.numberComparator)(e[x],t)}),0,e.length)}else A=(0,i.getDateStart)(j,E,M,n.weekStartFrom,B);else A=(0,i.getDateStart)(j,(0,o.duration)(n.timeUnit,1),M,n.weekStartFrom);_=e[I-1]&&e[I-1][x]||V.max}if(void 0===A||A<=_){var z={duration:E,outputFormat:n.outputFormat,enableUTC:M,weekStartFrom:n.weekStartFrom};for(void 0!==A&&(N=[(0,s.interval)(A,z)],F.push(N)),D=O;D<I;D++)e[D].length>0&&("date"===w.type?N=(0,d._singleSortedAddRowDate)(F,N,e[D][x],z,A):"string"!==w.type&&"number"!==w.type||(N=(0,d._singleSortedAddRow)(F,N,e[D][x])),T=F.length-1,R[T]=R[T]||{},N&&m(e[D],t,N,1,u,C,b,L,R[T]))}}return{data:F,schema:v,config:{indexBy:n.outputAs||n.column}}}(e,t,r,n[0],v,p):function(e,t,r,n,i,o,s){var l,c,u,h,p,m,v,b,y,x,w={},C={},k=function(e){return C.hasOwnProperty(e)?C[e]:-1},_=function(e,t){C[e]=t},S=function(e,t,r,n){return e+g["default"]+(t||r+(n?g["default"]+n:""))},E=function(){for(var e,t=[],r=function(r){if(y.includes(m[r].name))t.push(m[r]),w[m[r].name]=r;else{e=o.filter((function(e){return(e.outputAs||e.column+(e.operation?g["default"]+e.operation:""))===m[r].name}))[0];for(var n=0;n<p.length;n++)t.push({name:S(p[n],e.outputAs,e.column,e.operation),type:m[r].type})}},n=0;n<b;n++)r(n);return t},A=[];switch(l=(0,d["default"])(i.concat({column:s}),o),c=l.fn(e,t,r,n),h=(0,a.columnUnique)(s,e,t),v=(0,a.columnIndexOf)(s,c.schema),c.schema[v].type){case"number":case"date":u=f.numberComparator;break;default:u=f.stringComparator}p=h&&h.sort((function(e,t){return u(e,t)}))||[],m=c.schema.filter((function(e){return e.name!==s})),b=m.length,y=i.map((function(e){return e.outputAs||e.column})),x=E(),c.data.length>0&&(A=function(e){var t,r,n,a,i,l=[],u=e.length,d={},f={},h="";for(t=0;t<u;t++)d[e[t].name]=t;for(t=0;t<c.data.length;t++){for(f={},h="",r=0;r<c.schema.length;r++)w.hasOwnProperty(c.schema[r].name)?(f[d[c.schema[r].name]]=c.data[t][r],"interval"===c.schema[r].type?h+=c.data[t][r].start:h+=c.data[t][r]):c.schema[r].name!==s&&(a=o.filter((function(e){return(e.outputAs||e.column+(e.operation?g["default"]+e.operation:""))===c.schema[r].name}))[0],(i=d[S(c.data[t][v],a.outputAs,a.column,a.operation)])&&(f[i]=c.data[t][r]));if((n=k(h))>-1){var p=l[n];for(var m in f)p[m]=f[m]}else{var b=new Array(u);for(var y in f)b[y]=f[y];l.push(b),_(h,l.length-1)}}return l}(x));return{data:A,schema:x,config:{indexBy:c.config.indexBy===s?void 0:c.config.indexBy}}}(e,t,r,u,n,v,p)}}};t["default"]=v},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0;var a=n(r(446));t.aggregatorStore=a["default"]},function(e,t,r){"use strict";t.__esModule=!0;var n=r(454);t.before=n.before,t.after=n.after;var a=r(455);t.parseDate=a.parseDate,t.formatDate=a.formatDate;var i=r(444);t.duration=i.duration;var o=r(300);t.DatetimeUnits=o.DatetimeUnits,t.Weekdays=o.Weekdays},function(e,t,r){"use strict";t.__esModule=!0,t.before=function(e,t,r,i){if(!e)throw new Error("duration is missing");if(t&&(isNaN(t)||isNaN(+new Date(t))))throw new Error("timestamp is incorrect");return(0,n.getDateOffset)(isNaN(t)||null===t?+new Date:t,e.Unit,-e.number,r,i||a.Weekdays.Sunday)},t.after=function(e,t,r,i){if(!e)throw new Error("duration is missing");if(t&&(isNaN(t)||isNaN(+new Date(t))))throw new Error("timestamp is incorrect");return(0,n.getDateOffset)(isNaN(t)||null===t?+new Date:t,e.Unit,e.number,r,i||a.Weekdays.Sunday)};var n=r(431),a=r(300)},function(e,t,r){"use strict";var n=r(219);t.__esModule=!0,t.parseDate=function(e,t,r){var n,i;t&&(n=void 0!==r&&r?a["default"].utcParser(t):a["default"].parser(t),i=(i=n.parse(e))&&i.getTime());i||(i=void 0!==r&&r?+new Date(e+"Z"):+new Date(e));if(!i)throw new Error("Incorrect string or format provided");return i},t.formatDate=function(e,t,r){var n,i,o=t;if(isNaN(parseInt(e,10)))throw new Error("Timestamp must be a number: "+e);o||(o="%a, %-d %b %Y, %H:%M:%S:%L");if(n=void 0!==r&&r?a["default"].utcFormatter(o):a["default"].formatter(o),!(i=n.format(new Date(e))))throw new Error("Incorrect format provided: "+o);return i};var a=n(r(292))},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={column2d:"charts",column3d:"charts",bar2d:"charts",bar3d:"charts",pie2d:"charts",pie3d:"charts",line:"charts",area2d:"charts",doughnut2d:"charts",doughnut3d:"charts",pareto2d:"charts",pareto3d:"charts",mscolumn2d:"charts",mscolumn3d:"charts",msline:"charts",msarea:"charts",msbar2d:"charts",msbar3d:"charts",stackedcolumn2d:"charts",marimekko:"charts",stackedcolumn3d:"charts",stackedarea2d:"charts",stackedcolumn2dline:"charts",stackedcolumn3dline:"charts",stackedbar2d:"charts",stackedbar3d:"charts",msstackedcolumn2d:"charts",mscombi2d:"charts",mscombi3d:"charts",mscolumnline3d:"charts",mscombidy2d:"charts",mscombidy3d:"charts",mscolumn3dlinedy:"charts",stackedcolumn2dlinedy:"charts",stackedarea2dlinedy:"charts",stackedcolumn3dlinedy:"charts",msstackedcolumn2dlinedy:"charts",scatter:"charts",bubble:"charts",ssgrid:"charts",scrollbar2d:"charts",scrollcolumn2d:"charts",scrollcolumn3d:"charts",scrollline2d:"charts",scrollarea2d:"charts",scrollstackedcolumn2d:"charts",scrollstackedbar2d:"charts",scrollcombi2d:"charts",scrollmsstackedcolumn2d:"charts",scrollmsstackedcolumn2dlinedy:"charts",scrollcombidy2d:"charts",spline:"charts",splinearea:"charts",msspline:"charts",mssplinearea:"charts",mssplinedy:"charts",multiaxisline:"powercharts",multilevelpie:"powercharts",sunburst:"powercharts",waterfall2d:"powercharts",msstepline:"powercharts",inversemsline:"powercharts",inversemscolumn2d:"powercharts",inversemsarea:"powercharts",errorbar2d:"powercharts",errorscatter:"powercharts",errorline:"powercharts",logmsline:"powercharts",logmscolumn2d:"powercharts",logstackedcolumn2d:"powercharts",radar:"powercharts",chord:"powercharts",dragnode:"powercharts",candlestick:"powercharts",selectscatter:"powercharts",dragcolumn2d:"powercharts",dragline:"powercharts",dragarea:"powercharts",boxandwhisker2d:"powercharts",kagi:"powercharts",heatmap:"powercharts",sankey:"powercharts",angulargauge:"widgets",bulb:"widgets",cylinder:"widgets",drawingpad:"widgets",funnel:"widgets",hbullet:"widgets",hled:"widgets",hlineargauge:"widgets",vlineargauge:"widgets",pyramid:"widgets",realtimearea:"widgets",realtimecolumn:"widgets",realtimeline:"widgets",realtimelinedy:"widgets",realtimestackedarea:"widgets",realtimestackedcolumn:"widgets",sparkcolumn:"widgets",sparkline:"widgets",sparkwinloss:"widgets",thermometer:"widgets",vbullet:"widgets",vled:"widgets",radialbar:"widgets",zoomline:"zoomline",zoomlinedy:"zoomline",gantt:"gantt",treemap:"treemap",zoomscatter:"zoomscatter",overlappedbar2d:"overlappedbar2d",overlappedcolumn2d:"overlappedcolumn2d",msstackedcolumn2dsplinedy:"msstackedcolumn2dsplinedy",timeseries:"timeseries"}},function(e,t,r){"use strict";t.__esModule=!0,t["default"]=void 0;var n=r(224),a={};var i=function(e){var t=e;if(!a[t]){var r=document.getElementsByTagName("head")[0],i=document.createElement("script"),o=setTimeout((function(){i.onerror({type:"timeout",target:i})}),12e4);i.charset="utf-8",i.timeout=12e4,a[t]=new Promise((function(e,t){i.onreadystatechange=function(){"loaded"===i.readyState&&i.onload({})},i.onload=function(t){i.onerror=i.onload=null,clearTimeout(o),e(t)},i.onerror=function(e){i.onerror=i.onload=null,clearTimeout(o),t(e)}})),(0,n.isXSSSafe)(t,!1)||(t="function"==typeof window.encodeURIComponent?window.encodeURIComponent(t):window.escape(t)),i.src=t,r.appendChild(i)}return a[t]};t["default"]=i},function(e,t){(function(t){e.exports=t}).call(this,{})}])["default"]}));
//# sourceMappingURL=http://localhost:3052/3.18.0/map/eval/fusioncharts.js.map
(window.webpackJsonpFusionCharts=window.webpackJsonpFusionCharts||[]).push([[2],{1052:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){!function(e){var t=e.getChildren("colorManager");if(!e.getFromEnv("dataSource").colorrange)return t&&(t[0].config.legendItemIds=[]),void e.deleteFromEnv("colorManager");if(t)return e.addToEnv("colorManager",t[0]),void t[0].configure();t=new n["default"],e.attachChild(t,"colorManager"),e.addToEnv("colorManager",t),t.configure()}(e)};var n=i(a(1053))},1053:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=i(a(1054)),l=i(a(1055)),s=a(224);function c(e){var t=e||g;return(0,s.getValidColor)(t)||g}var h,u,d="rgba(192,192,192,"+(s.isIE?.002:1e-6)+")",g="#000000",p=((u={}).legendCarpetConf={spreadFactor:.85,allowDrag:!1,captionAlignment:"center",padding:{v:3,h:3},style:{fill:"#e4d9c1",stroke:"#c4b89d"}},u.legendCaptionConf={spreadFactor:.2,padding:{v:2,h:2},style:{fill:"#786B50",fontFamily:"sans-serif",fontSize:"12px",fontWeight:"bold",fontStyle:"normal"},bound:{style:{stroke:"none"}}},u.legendBodyConf={spreadFactor:.8,padding:{v:2,h:2},bound:{style:{stroke:"none"}}},u.legendAxisConf={legendAxisHeight:11,spreadFactor:.4,padding:{v:1,h:1},style:{stroke:"none","stroke-opacity":0,"stroke-width":1},line:{grooveLength:3,offset:8,style:{stroke:"rgba(255, 255, 255, 0.65)","stroke-width":1.5}},shadow:{style:{stroke:"none",fill:(0,s.toRaphaelColor)({FCcolor:{alpha:"25,0,0",angle:360,color:"000000,FFFFFF,FFFFFF",ratio:"0,30,40"}})}},bound:{style:{stroke:"none"}}},u.sliderGroupConf={showTooltip:1,outerCircle:{rFactor:1.4,style:{fill:d,stroke:"#757575","stroke-width":3}},innerCircle:{rFactor:.65,style:{fill:d,stroke:"#FFFFFF"}}},u.axisTextItemConf={spreadFactor:.3,padding:{v:1,h:1},style:{fill:"#786B50",fontFamily:"sans-serif",fontSize:"12px",fontWeight:"normal",fontStyle:"normal"}},{init:function(e){h=e.chart},legacyDataParser:function(e,t){var a,i,n,o,r,l,u,d,g,p,f,m,b,v={},x=h.getFromEnv("number-formatter"),y=h.getFromEnv("dataSource"),C=y.data,k=t||{};if(!e)return!1;for("maps"!==h.defaultDatasetType||void 0!==k.min&&void 0!==k.max?"HeatMap"!==h.getName()||void 0!==k.min&&void 0!==k.max||(k={min:Infinity,max:-Infinity},y.dataset.forEach((function(e){e.data&&e.data.forEach((function(e){k.min=Math.min(k.min,(0,s.pluckNumber)(e.value,k.min)),k.max=Math.max(k.max,(0,s.pluckNumber)(e.value,k.max))}))}))):(k={min:Infinity,max:-Infinity},C&&C.forEach((function(e){k.min=Math.min(k.min,(0,s.pluckNumber)(e.value,k.min)),k.max=Math.max(k.max,(0,s.pluckNumber)(e.value,k.min))}))),v.mapByPercent=f=!!(0,s.pluckNumber)(e.mapbypercent,0),a=e.color||[],void 0===e.minvalue&&(e.minvalue=void 0!==k.min?f?0:k.min:0),void 0===e.maxvalue&&(e.maxvalue=void 0!==k.max?f?100:k.max:100),e.maxvalue!==e.minvalue&&k.min!==Infinity&&k.max!==-Infinity||(e.minvalue=0,e.maxvalue=100),m=!1,r=0,u=a.length;r<u;r++)if(a[r].maxvalue){m=!0;break}for(m||(a=[]),n=e.code,d=v.colorRange=[],v.gradient=!!(0,s.pluckNumber)(e.gradient,1),a.length?n=c(n):(n?(o=c(n),n=c()):(n=c(),b=n,o=(0,s.getLightColor)(b,1)),a.push({code:o,maxvalue:e.maxvalue,label:void 0})),function(e){var t,a,i,n=h.getFromEnv("number-formatter");for(t=0,a=e.length;t<a;t++)(i=e[t].maxvalue)&&(e[t].maxvalue=n.getCleanValue(i))}(a),a=a.sort((function(e,t){return e.maxvalue-t.maxvalue})),g=p=e.minvalue&&x.getCleanValue(e.minvalue),p=(void 0!==g||null!==g)&&(f?g+"%":x.legendValue(g)),d.push({code:(0,s.dehashify)(n),value:g,displayValue:p,label:e.startlabel}),r=0,u=a.length;r<u;r++)l=c((i=a[r]).code||i.color),g=p=i.maxvalue,isNaN(parseInt(g,10))||(p=(void 0!==g||null!==g)&&(f?g+"%":x.legendValue(g)),d.push({code:(0,s.dehashify)(l),value:g,displayValue:p,label:i.label||i.displayvalue}));return d[d.length-1].label=e.endlabel||i.label,v},getDefaultConf:function(e){return u[e]}}),f=function(e){function t(){var t;return(t=e.call(this)||this).datasource={},t.config.legendItemIds=[],t}(0,n["default"])(t,e);var a=t.prototype;return a.configure=function(){var e,t,a=this.getFromEnv("chart"),i=this.getFromEnv("dataSource").chart.mapbycategory,n=a.config.showLegend,o=a.getChildren("colorRange")&&a.getChildren("colorRange")[0];switch(a.addToEnv("colorManager",this),this.datasource=a.getFromEnv("dataSource"),e=this.datasource.colorrange,o&&o.remove({instant:!0}),n||(this.config.legendItemIds=[]),"maps"===a.defaultDatasetType?e.gradient&&Number(e.gradient)?"gradient":e.color?"icon":"none":"TreeMap"===a.getName()||e.gradient&&"0"!==e.gradient&&!Number(i)?"gradient":"icon"){case"gradient":p.init({chart:a}),t=p.legacyDataParser(e),(0,s.componentFactory)(a,l["default"],"colorRange",1,[t]),o=a.getChildren("colorRange")[0],a.addToEnv("colorRange",o),t||(o._dontPlot=!0),this.config.legendItemIds=[],this._configureGradientLegend(o);break;case"icon":(0,s.componentFactory)(a,r["default"],"colorRange",1,[{colorRange:e,sortLegend:0,mapByCategory:(0,s.pluckNumber)(i,0),defaultColor:"cccccc",numberFormatter:a.getFromEnv("number-formatter")}]),a.addToEnv("colorRange",a.getChildren("colorRange")[0]),n&&this._addLegendItems();break;case"none":a.deleteFromEnv("colorManager"),this.config.legendItemIds=[]}},a._configureGradientLegend=function(e){var t=this,a=t.getFromEnv("chart").getFromEnv("gLegend");a&&(a.setColorRange(e),t.addExtEventListener("rangeUpdated",(function(e,a){t.fireEvent("legendUpdate",{"original-event":e,maxMinArray:a,component:"gradientlegend"})}),a))},a._addLegendItems=function(){var e,t,a,i,n,o=this.config,r=this.getFromEnv("chart"),l=r.getChildren("legend")[0],c=r.getFromEnv("colorRange").colorArr,h=c.length;for(i=0;i<h;i++)n={label:(0,s.pluck)(c[i].label,c[i].displayvalue),datasetObj:c[i],index:i},t=(0,s.getLightColor)(c[i].code,40),e={FCcolor:{color:c[i].code+","+c[i].code+","+t,ratio:"0,70,30",angle:270,alpha:"100,100,100"}},(a=l.getItem(o.legendItemIds[i]))||(o.legendItemIds.push(l.createItem(this)),(a=l.getItem(o.legendItemIds[i])).addEventListener("fc-click",a.itemClickFn)),a.removeLegendState("hidden"),c[i].legendItemId=a&&a.getId(),a.configure(n),a.setStateCosmetics("default",{symbol:{fill:(0,s.toRaphaelColor)(e),rawFillColor:c[i].code}});for(i=h;i<o.legendItemIds.length;i++)l.disposeItem(o.legendItemIds[i]);o.legendItemIds.splice(h)},a.legendInteractivity=function(e){var t=this.getFromEnv("colorRange").colorArr[e.config.index];this.fireEvent("legendUpdate",{legendItem:e,colorObj:t,component:"legend"})},a.getColor=function(e){return!Number(this.datasource.chart.mapbycategory)&&Number(this.datasource.colorrange.gradient)?{code:this.getColorByValue(e),label:this.getLabelByValue(e)}:this.getColorObj(e)},a.getValueRatio=function(){return this.getFromEnv("colorRange").getValueRatio()},a.getCumulativeValueRatio=function(){return this.getFromEnv("colorRange").getCumulativeValueRatio()},a.getBoxFill=function(e){return this.getFromEnv("colorRange").getBoxFill(e)},a.getColorByValue=function(e){return this.getFromEnv("colorRange").getColorByValue(e)},a.getColorObj=function(e){return this.getFromEnv("colorRange").getColorObj(e)},a.getLabelByValue=function(e){return this.getFromEnv("colorRange").getLabelByValue(e)},t}(o.ComponentInterface);t["default"]=f},1054:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(242)),o=i(a(238)),r=a(224),l=a(240),s=function(e,t){return+e.minvalue==+t.minvalue?e.maxvalue-t.maxvalue:e.minvalue-t.minvalue},c=function(e,t,a){var i=e[0],n=e[1],o=e[2],l=i+(t[0]-i)*a,s=n+(t[1]-n)*a,c=o+(t[2]-o)*a;return{hex:(r.COLOR_BLACK+(l<<16|s<<8|c).toString(16)).slice(-6),rgb:[l,s,c]}},h=function(e){function t(){var t;t=e.call(this)||this;var a=(0,n["default"])(t);return a.mapByCategory=!1,a.colorArr=[],a.noValidRange=!0,a.sortLegend=!1,t}(0,o["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.defaultObj={code:"CCCCCC",alpha:"100"}},a.getType=function(){return"colorComponent"},a.getName=function(){return"colorBucket"},a.configure=function(e){if(e){var t,a,i,n,o,l,c,h,u,d,g,p=this.mapByCategory,f=e.numberFormatter,m=e.colorRange||{},b=(0,r.extend2)([],m.color),v=this.getLinkedParent(),x=Math.min(Math.max((0,r.pluckNumber)(this.getFromEnv("dataSource").chart.palette,0)-1,0),4),y=v.defaultPaletteOptions&&v.defaultPaletteOptions.paletteColors[x],C=(0,r.pluckNumber)(f.getCleanValue(m.maxvalue),Infinity),k=(0,r.pluckNumber)(f.getCleanValue(m.minvalue),-Infinity),S=this.colorArr;if(void 0!==e.mapByCategory&&(p=this.mapByCategory=!!Number(e.mapByCategory)),(b=p?b.filter((function(e){return e.code||e.color})):b.filter((function(e){return e.minvalue||e.maxvalue}))).forEach((function(e){e.minvalue&&e.maxvalue&&+e.maxvalue<+e.minvalue&&(h=e.maxvalue,e.maxvalue=e.minvalue,e.minvalue=h),e.minvalue?e.maxvalue?(d=f.getCleanValue(e.minvalue),u=f.getCleanValue(e.maxvalue),e.rangeLabel=f.dataLabels(d)+"-"+f.dataLabels(u)):(d=f.getCleanValue(e.minvalue),e.maxvalue=u=C,e.rangeLabel=u===Infinity?">"+f.dataLabels(d):f.dataLabels(d)+"-"+f.dataLabels(u)):(e.minvalue=d=k,u=f.getCleanValue(e.maxvalue),e.rangeLabel=d===-Infinity?"<"+f.dataLabels(u):f.dataLabels(d)+"-"+f.dataLabels(u))})),b.sort(s),b&&(t=b.length)){for(S.length=0,a=0;a<t;a+=1)c=b[a],i=(0,r.pluck)(c.color,c.code,y&&y[a]),n=(0,r.pluck)(c.alpha),l=(0,r.pluck)(c.bordercolor),o=(0,r.pluck)(c.borderalpha,100),u=(0,r.pluckNumber)(c.maxvalue),d=(0,r.pluckNumber)(c.minvalue),g=(0,r.pluck)(c.label,c.displayvalue,c.rangeLabel),(i&&u>=d||p&&g)&&S.push({code:i,alpha:n||"100",oriAlpha:n,maxvalue:u,minvalue:d,label:(0,r.parseUnsafeString)(g),labelId:g.toLowerCase(),bordercolor:l,borderAlpha:o,name:c.name,tllabelfont:c.tllabelfont,tllabelfontsize:c.tllabelfontsize,tllabelfontcolor:c.tllabelfontcolor,trlabelfont:c.trlabelfont,trlabelfontsize:c.trlabelfontsize,trlabelfontcolor:c.trlabelfontcolor,bllabelfont:c.bllabelfont,bllabelfontsize:c.bllabelfontsize,bllabelfontcolor:c.bllabelfontcolor,brlabelfont:c.brlabelfont,brlabelfontsize:c.brlabelfontsize,brlabelfontcolor:c.brlabelfontcolor});this.sortedColorArr=this.colorArr.slice(0)}else this.noValidRange=!0,this.colorArr=[],this.sortedColorArr=[]}},a.getColorObj=function(e){if(void 0===e)return{outOfRange:!0};var t,a,i,n=this.sortedColorArr,o=this.gradient?1:0,l=n[o],s=e;if(this.mapByCategory){for(s=(0,r.parseUnsafeString)(s).toLowerCase()||s.toString().toLowerCase();l;){if(l.labelId===s||l.maxvalue>=s&&l.minvalue<=s)return{code:l.code,alpha:l.alpha||"100",oriAlpha:l.oriAlpha,seriesIndex:o,legendItemId:l.legendItemId,tlLabelFont:l.tllabelfont,tlLabelFontSize:l.tllabelfontsize,tlLabelFontColor:l.tllabelfontcolor,trLabelFont:l.trlabelfont,trLabelFontSize:l.trlabelfontsize,trLabelFontColor:l.trlabelfontcolor,blLabelFont:l.bllabelfont,blLabelFontSize:l.bllabelfontsize,blLabelFontColor:l.bllabelfontcolor,brLabelFont:l.brlabelfont,brLabelFontSize:l.brlabelfontsize,brLabelFontColor:l.brlabelfontcolor};l=n[o+=1]}return{outOfRange:!0}}if(this.gradient){if(this.scaleMin<=s&&this.scaleMax>=s){for(;l&&l.maxvalue<s;)l=n[o+=1];return i=(s-l.minvalue)/l.range,{code:c(n[o-1].codeRGB,l.codeRGB,i).hex}}return{outOfRange:!0}}for(;l;){if(s<l.minvalue&&!t&&(a=0===o?{code:l.code,alpha:l.alpha||"100",oriAlpha:l.oriAlpha,seriesIndex:o,name:l.name,label:l.label,outOfRange:!0,bordercolor:l.bordercolor,borderalpha:l.borderAlpha}:{code:n[o-1].code,alpha:n[o-1].alpha||"100",oriAlpha:n[o-1].oriAlpha,seriesIndex:o,name:n[o-1].name,label:n[o-1].label,outOfRange:!0,bordercolor:n[o-1].bordercolor,borderalpha:n[o-1].borderAlpha}),s>l.maxvalue&&o===n.length-1&&(a={code:l.code,alpha:l.alpha||"100",oriAlpha:l.oriAlpha,seriesIndex:o,name:l.name,label:l.label,outOfRange:!0,bordercolor:l.bordercolor,borderalpha:l.borderAlpha}),l.maxvalue>s&&l.minvalue<=s?a={code:l.code,alpha:l.alpha||"100",oriAlpha:l.oriAlpha,seriesIndex:o,name:l.name,label:l.label,bordercolor:l.bordercolor,borderalpha:l.borderAlpha}:s===l.maxvalue&&(t={code:l.code,alpha:l.alpha||"100",oriAlpha:l.oriAlpha,seriesIndex:o,name:l.name,label:l.label,bordercolor:l.bordercolor,borderalpha:l.borderAlpha,tlLabelFont:l.tllabelfont,tlLabelFontSize:l.tllabelfontsize,tlLabelFontColor:l.tllabelfontcolor,trLabelFont:l.trlabelfont,trLabelFontSize:l.trlabelfontsize,trLabelFontColor:l.trlabelfontcolor,blLabelFont:l.bllabelfont,blLabelFontSize:l.bllabelfontsize,blLabelFontColor:l.bllabelfontcolor,brLabelFont:l.brlabelfont,brLabelFontSize:l.brlabelfontsize,brLabelFontColor:l.brlabelfontcolor}),o===n.length-1&&t)return t;if(a)return a.tlLabelFont=l.tllabelfont,a.tlLabelFontSize=l.tllabelfontsize,a.tlLabelFontColor=l.tllabelfontcolor,a.trLabelFont=l.trlabelfont,a.trLabelFontSize=l.trlabelfontsize,a.trLabelFontColor=l.trlabelfontcolor,a.blLabelFont=l.bllabelfont,a.blLabelFontSize=l.bllabelfontsize,a.blLabelFontColor=l.bllabelfontcolor,a.brLabelFont=l.brlabelfont,a.brLabelFontSize=l.brlabelfontsize,a.brLabelFontColor=l.brlabelfontcolor,a;l=n[o+=1]}return n.length?void 0:{outOfRange:!0}},a.getColorRangeArr=function(e,t){var a,i,n,o,l,s,c,h,u=[],d=e,g=t;if(!this.defaultAsigned&&(d>g&&(a=d,d=g,g=a),d<g&&(o=this.getColorObj(d),s=this.getColorObj(g),o&&s))){for(l=d,i=o.seriesIndex,n=s.seriesIndex;i<=n;i+=1)(c=(0,r.extend2)({},this.colorArr[i])).minvalue!==l&&(c.minvalue=l),u.push(c),h=c,l=c.maxvalue;h&&(h.maxvalue=g)}return u},t}(l.ComponentInterface);t["default"]=h},1055:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=a(224),l=function(e){function t(){var t;return(t=e.call(this)||this).colorRange={},t.valueRatio={},t.data={},t.mapByPercent=r.UNDEF,t}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"colorComponent"},a.getName=function(){return"gradientColorRange"},a.configure=function(e){if(e){var t,a,i;for(this.data=e,this.appender=r.BLANKSTRING,i=this.colorRange=e.colorRange.sort((function(e,t){return e.value-t.value})),this.valueRatio=r.UNDEF,this.values=[],t=0,a=i.length;t<a;t++)this.values.push(i[t].value)}},a.getValueRatio=function(){var e,t,a=this.colorRange,i=a.length,n=this.valueRatio,o=a[i-1].value,r=a[0].value,l=o-r,s=0;if(n)return n;for(n=this.valueRatio=[],e=0;e<i;e++)t=(a[e].value-r)/l,n.push(100*(t-s)),s=t;return n},a.getCumulativeValueRatio=function(){var e,t,a=this.colorRange,i=a.length,n=a[0].value,o=a[i-1].value,r=[];for(t=0;t<i;t++)e=a[t],r.push((e.value-n)/(o-n)*100);return r},a.getBoxFill=function(e){var t,a,i,n=this.colorRange,o=n.length,l=[];for(i=e?90:0,a=0;a<o;a++)t=n[a],l.push(t.code);return(0,r.toRaphaelColor)({FCcolor:{alpha:"100,100,100",angle:i,color:l.join(","),ratio:this.getValueRatio().join(",")}})},a.getColorByValue=function(e){var t,a,i,n,o=this.values,l=this.colorRange;if(e!==r.UNDEF&&null!==e){for(a=0,t=o.length;a<t;a++){if(e===o[a]){n=l[a].code;break}if(!a&&e<o[a]){i=!0;break}if(a===t-1&&e>o[a]){i=!0;break}if(e>o[a]&&e<o[a+1]){s=l[a],c=l[a+1],h=e,u=void 0,d=void 0,g=void 0,p=void 0,d=s.value,g=(0,r.HEXtoRGB)(s.code),p=(0,r.HEXtoRGB)(c.code),u=c.value-d,n=(0,r.RGBtoHex)([Math.round(g[0]+(p[0]-g[0])/u*(h-d)),Math.round(g[1]+(p[1]-g[1])/u*(h-d)),Math.round(g[2]+(p[2]-g[2])/u*(h-d))]);break}}var s,c,h,u,d,g,p;if(!i)return n}},a.getLabelByValue=function(e){var t,a,i,n,o=this.values,l=this.colorRange;if(e!==r.UNDEF&&null!==e){for(a=0,t=o.length;a<t;a++){if(e===o[a]){n=l[a].label;break}if(!a&&e<o[a]){i=!0;break}if(a===t-1&&e>o[a]){i=!0;break}if(e>o[a]&&e<o[a+1]){n=l[a].label;break}}if(!i)return n}},t}(o.ComponentInterface);t["default"]=l},1056:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){!function(e){var t,a=e.getFromEnv("dataSource").colorrange,i=e.getFromEnv("dataSource").chart.mapbycategory,l="maps"===e.defaultDatasetType,s="TreeMap"===e.getName(),c=e.getFromEnv("legend"),h=e.getFromEnv("gLegend");t=a&&e.config.showLegend?l?a.gradient&&Number(a.gradient)?"gradient":a.color?"icon":"none":s?a.gradient&&"0"!==a.gradient?"gradient":"none":a.gradient&&"0"!==a.gradient&&!Number(i)?"gradient":"icon":"none";switch(t){case"gradient":e.deleteFromEnv("legend"),c&&c.remove(),(0,n.componentFactory)(e,o["default"],"gLegend",1),(h=e.getChildren("gLegend")[0]).configure(),e.addToEnv("gLegend",h);break;case"icon":e.deleteFromEnv("gLegend"),h&&h.remove(),(0,n.componentFactory)(e,r["default"],"legend",1,{showLegend:!0}),(c=e.getChildren("legend")[0]).configure(),e.addToEnv("legend",c);break;case"none":e.deleteFromEnv("gLegend"),e.deleteFromEnv("legend"),h&&h.remove(),c&&c.remove()}}(e)};var n=a(224),o=i(a(1057)),r=i(a(569))},1057:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n,o,r,l,s,c=i(a(242)),h=i(a(238)),u=a(224),d=a(240),g={},p="rgba(192,192,192,"+(u.isIE?.002:1e-6)+")",f={}.hasOwnProperty,m="M",b="L";function v(e,t){return function a(e,t){var i,o;for(o in e)f.call(e,o)&&(i=e[o],t[o]===n?t[o]=i:"object"==typeof i&&null!==i&&a(i,t[o]))}(e,t),t}function x(e){var t=e||"#000000";return(0,u.getValidColor)(t)||"#000000"}function y(e){var t,a=e.fontSize+"";return a?(t=a.replace(/(\d+)(px)*/,"$1px"),e.fontSize=t,e):e}function C(e){return!(e!==n&&null!=e&&!isNaN(e))}g.CAPTION="CAPTION",g.LEGEND_BODY="LEGEND_BODY",g.AXIS_LABEL="LEGEND_LABEL",g.LEGEND_AXIS="LEGEND_AXIS",g.RANGE="RANGE",g.AXIS_VALUE="AXIS_VALUE",(s={}).legendCarpetConf={spreadFactor:.85,allowDrag:!1,captionAlignment:"center",padding:{v:3,h:3},style:{fill:"#e4d9c1",stroke:"#c4b89d"}},s.legendCaptionConf={spreadFactor:.2,padding:{v:2,h:2},style:{fill:"#786B50",fontFamily:"sans-serif",fontSize:"12px",fontWeight:"bold",fontStyle:"normal"},bound:{style:{stroke:"none"}}},s.legendBodyConf={spreadFactor:.8,padding:{v:2,h:2},bound:{style:{stroke:"none"}}},s.legendAxisConf={legendAxisHeight:11,spreadFactor:.4,padding:{v:1,h:1},style:{stroke:"none","stroke-opacity":0,"stroke-width":1},line:{grooveLength:3,offset:8,style:{stroke:"rgba(255, 255, 255, 0.65)","stroke-width":1.5}},shadow:{style:{stroke:"none",fill:(0,u.toRaphaelColor)({FCcolor:{alpha:"25,0,0",angle:360,color:"000000,FFFFFF,FFFFFF",ratio:"0,30,40"}})}},bound:{style:{stroke:"none"}}},s.sliderGroupConf={showTooltip:1,outerCircle:{rFactor:1.4,style:{fill:p,stroke:"#757575","stroke-width":3}},innerCircle:{rFactor:.65,style:{fill:p,stroke:"#FFFFFF"}}},s.axisTextItemConf={spreadFactor:.3,padding:{v:1,h:1},style:{fill:"#786B50",fontFamily:"sans-serif",fontSize:"12px",fontWeight:"normal",fontStyle:"normal"}},o={init:function(e){l=e.chart},legacyDataParser:function(e,t){var a,i,o,r,s,c,h,d,g,p,f,m,b,v={},y=l.getFromEnv("number-formatter");if(!e)return!1;for(v.mapByPercent=f=!!(0,u.pluckNumber)(e.mapbypercent,0),a=e.color||[],e.minvalue===n&&(e.minvalue=t.min!==n?f?0:t.min:0),e.maxvalue===n&&(e.maxvalue=t.max!==n?f?100:t.max:100),m=!1,s=0,h=a.length;s<h;s++)if(a[s].maxvalue){m=!0;break}for(m||(a=[]),o=e.code,d=v.colorRange=[],v.gradient=!!(0,u.pluckNumber)(e.gradient,1),a.length?o=x(o):(o?(r=x(o),o=x()):(o=x(),b=o,r=(0,u.getLightColor)(b,1)),a.push({code:r,maxvalue:e.maxvalue,label:n})),function(e){var t,a,i,n=l.getFromEnv("number-formatter");for(t=0,a=e.length;t<a;t++)(i=e[t].maxvalue)&&(e[t].maxvalue=n.getCleanValue(i))}(a),a=a.sort((function(e,t){return e.maxvalue-t.maxvalue})),g=p=e.minvalue&&y.getCleanValue(e.minvalue),p=(g!==n||null!==g)&&(f?g+"%":y.legendValue(g)),d.push({code:(0,u.dehashify)(o),value:g,displayValue:p,label:e.startlabel}),s=0,h=a.length;s<h;s++)c=x((i=a[s]).code||i.color),g=p=i.maxvalue,isNaN(parseInt(g,10))||(p=(g!==n||null!==g)&&(f?g+"%":y.legendValue(g)),d.push({code:(0,u.dehashify)(c),value:g,displayValue:p,label:(0,u.parseUnsafeString)(i.label||i.displayvalue)}));return d[d.length-1].label=(0,u.parseUnsafeString)(e.endlabel||i.label),v},getDefaultConf:function(e){return s[e]}};var k=function(e){(0,h["default"])(a,e);var t=a.prototype;function a(){var t;return t=e.call(this)||this,r=(0,c["default"])(t),t.enabled=!1,t.drawOptions={},t.components={},t}return t.getType=function(){return"gradientLegend"},t.getName=function(){return"gLegend"},t.setColorRange=function(e){var t=this.drawOptions.colorRange=e;t&&t._preparationGoneWrong&&(this._dontPlot=!0)},t.configureAttributes=function(){var e,t,a,i,r,l,s,c,h,d,g,p,f=this.getFromEnv("chart"),m=this.getFromEnv("dataSource").chart,b=this.conf={},v=m.outcnvbasefont,x=this.computeFontSize(m.outcnvbasefontsize),y=m.outcnvbasefontcolor,C=f.config.dataLabelStyle;o.init({chart:f}),this.data=this.getFromEnv("dataSource").colorrange,this._dontPlot||(this.drawOptions={smartLabel:this.getFromEnv("smartLabel"),gLegend:this},this._dontPlot=!1,this._recalculateLogicalSpace=!0,b.caption=(0,u.parseUnsafeString)((0,u.pluck)(m.legendcaption)),b.legendPosition=(0,u.pluck)(m.legendposition,"bottom").toLowerCase(),b.legendXPosition=(0,u.pluckNumber)(m.legendxposition,0),b.legendYPosition=(0,u.pluckNumber)(m.legendyposition,0),b.legendMaxHeight=(0,u.pluckNumber)(m.legendmaxheight,0),b.legendMaxWidth=(0,u.pluckNumber)(m.legendmaxwidth,0),b.legendVertical="string"==typeof m.legendorientation&&"vertical"===m.legendorientation.toLowerCase(),b.showLegend=(0,u.pluckNumber)(m.showlegend,1),b.interactiveLegend=(0,u.pluckNumber)(m.interactivelegend,1),b.showLegendLabels=(0,u.pluckNumber)(m.showlegendlabels,1),e=m.legenditemfontcolor||y,t=m.legenditemfont||v,a=m.legenditemfontsize||x,i=(0,u.pluckFontSizeMaintainUnit)(m.legenditemfontsize,m.outcnvbasefontsize),r=(0,u.pluckNumber)(m.legenditemfontbold,0),l=m.legendcaptionfontcolor||y,s=m.legendcaptionfont||v,c=m.legendcaptionfontsize||x,h=(0,u.pluckFontSizeMaintainUnit)(m.legendcaptionfontsize,m.outcnvbasefontsize),d=(0,u.pluckNumber)(m.legendcaptionfontbold,1),p=(g=m.legendaxisbordercolor?(0,u.hashify)((0,u.dehashify)(m.legendaxisbordercolor)):n)?(0,u.pluckNumber)(m.legendaxisborderalpha,100)/100:n,b.axisTextItemConf={style:{fill:e?(0,u.convertColor)((0,u.pluck)(e)):C.color,fontFamily:t?(0,u.pluck)(t):C.fontFamily,fontSize:a?(0,u.pluckNumber)(a):C.fontSize.match(/\d+/)[0],fontSizeWithUnit:(0,u.pluckFontSizeMaintainUnit)(i,C.fontSize.match(/\d+/)[0]),fontWeight:r?"bold":C.fontWeight}},b.legendCaptionConf={style:{fill:l?(0,u.convertColor)((0,u.pluck)(l)):C.color,fontFamily:s?(0,u.pluck)(s):C.fontFamily,fontSize:c?(0,u.pluckNumber)(c):C.fontSize.match(/\d+/)[0],fontSizeWithUnit:(0,u.pluckFontSizeMaintainUnit)(h,C.fontSize.match(/\d+/)[0]),fontWeight:d?"bold":C.fontWeight,fontStyle:"normal"}},b.legendAxisConf={legendAxisHeight:11,style:{stroke:g,"stroke-opacity":p},line:{style:{stroke:(0,u.convertColor)((0,u.pluck)(m.legendscalelinecolor,"FFF8E9"),(0,u.pluckNumber)(m.legendscalelinealpha,100)),"stroke-width":(0,u.pluckNumber)(m.legendscalelinethickness)}}},b.sliderGroupConf={showTooltip:(0,u.pluckNumber)(m.showtooltip,1),outerCircle:{rFactor:(0,u.pluckNumber)(m.sliderdiameterfactor),style:{stroke:(0,u.convertColor)((0,u.pluck)(m.legendpointerbordercolor,"757575"),(0,u.pluckNumber)(m.legendpointerborderalpha,100))}},innerCircle:{rFactor:(0,u.pluckNumber)(m.sliderholediameterfactor),style:{stroke:(0,u.convertColor)((0,u.pluck)(m.legendpointercolor,"FFFFFF"),(0,u.pluckNumber)(m.legendpointeralpha,100))}}},b.legendCarpetConf={spreadFactor:(0,u.pluckNumber)(m.legendspreadfactor),allowDrag:!!(0,u.pluckNumber)(m.legendallowdrag,0),captionAlignment:(0,u.pluck)(m.legendcaptionalignment,"center"),style:{fill:(0,u.convertColor)((0,u.pluck)(m.legendbgcolor,"e4d9c1"),(0,u.pluckNumber)(m.legendbgalpha,100)),stroke:(0,u.convertColor)((0,u.pluck)(m.legendbordercolor,"c4b89d"),(0,u.pluckNumber)(m.legendborderalpha,100)),"stroke-width":(0,u.pluckNumber)(m.legendborderthickness,1)}})},t.postConfigureInit=function(){var e,t,a,i,n,r,l,s,c,h,u,d=this.conf,p=d.legendPosition?d.legendPosition.split("-"):[];this.elem={},d.interactiveLegend?(i=v(o.getDefaultConf("sliderGroupConf"),d.sliderGroupConf),this.sGroup?((a=this.elem.sGroup=this.sGroup).configure(i),this.elem.sGroup.gLegend=this):(this.sGroup=this.elem.sGroup=a=new E(i),a.configure(i),this.elem.sGroup.gLegend=this)):(this.sGroup&&this.sGroup.dispose(),this.sGroup&&delete this.sGroup),(i=v(o.getDefaultConf("legendCarpetConf"),d.legendCarpetConf)).legendPosition="absolute"===p[0]&&!d.legendVertical||"top"===p[0]||"bottom"===p[0]?"bottom":"right",u=o.getDefaultConf("legendBodyConf"),"absolute"===p[0]&&!d.legendVertical||"top"===p[0]||"bottom"===p[0]?(this.drawOptions.refSideKey="canvasWidth",this.drawOptions.refOffsetKey="canvasLeft",n=v(o.getDefaultConf("axisTextItemConf"),d.axisTextItemConf),u.legendPosition="bottom",(h=v(o.getDefaultConf("legendAxisConf"),d.legendAxisConf)).legendPosition="bottom",n.legendPosition="bottom"):(this.drawOptions.refSideKey="canvasHeight",this.drawOptions.refOffsetKey="canvasTop",n=v(o.getDefaultConf("axisTextItemConf"),d.axisTextItemConf),u.legendPosition="right",(h=v(o.getDefaultConf("legendAxisConf"),d.legendAxisConf)).legendPosition="right",n.legendPosition="right"),Object.keys(this.components).length||(this.components.LegendCarpet=new w,this.components.LegendBody=new L,this.components.LegendAxis=new F,this.components.LegendValues=new P,d.showLegendLabels&&(this.components.LegendLabels=new N)),t=this.components.LegendAxis,s=this.components.LegendValues,e=this.components.LegendCarpet,r=this.components.LegendBody,d.showLegendLabels&&(l=this.components.LegendLabels),this.components.LegendCarpet.configure(i),this.components.LegendValues.configure(n),this.components.LegendAxis.configure(h),this.components.LegendBody.configure(this.drawOptions.colorRange,u,n),d.showLegendLabels&&l.configure(n),d.caption?(c=v(o.getDefaultConf("legendCaptionConf"),d.legendCaptionConf),this.componentCaption&&Object.keys(this.componentCaption).length?this.componentCaption.configure(d.caption,c):(this.componentCaption=new A).configure(d.caption,c),e.addCompositions(this.componentCaption,g.CAPTION)):(e.removeCompositions(g.CAPTION),this.componentCaption&&this.componentCaption.dispose(),delete this.componentCaption),a&&t.addCompositions(a,g.RANGE),l&&r.addCompositions(l,g.AXIS_LABEL),r.addCompositions(t,g.LEGEND_AXIS),r.addCompositions(s,g.AXIS_VALUE),e.addCompositions(r,g.LEGEND_BODY),this.elem.gl=new S(e)},t.getValueRange=function(){var e,t,a=this.elem&&this.elem.sGroup,i=a.sliders,n=a.extremes;return e=i["false"].currPos,t=n[1]-n[0]+i["true"].currPos,[{min:a.getValueFormPixel(e),max:a.getValueFormPixel(t)}]},t._dispose=function(){this.elem&&this.elem.gl&&this.elem.gl.dispose(),this.elem={},e.prototype._dispose.call(this)},t.getCalculatedLogicalSpace=function(){return this._logicalArea},t.setCalculatedLogicalSpace=function(e){this._logicalArea=e},t.getLogicalSpace=function(e){var t,a,i,n,o,r=this.conf,l={height:0,width:0},s=this.drawOptions,c=this.getFromEnv("chartConfig"),h="absolute"===r.legendPosition.split("-")[0];return this._recalculateLogicalSpace?this._dontPlot?l:(this._recalculateLogicalSpace=!1,this.postConfigureInit(),r.showLegend?(a=s.refSideKey,i=s.refOffsetKey,this.drawOptions.refSide=c[a],this.drawOptions.refOffset=c[i],this.drawOptions.maxOtherSide=e||this.drawOptions.maxOtherSide,this.elem.gl&&(t=this.elem.gl.getLogicalSpace(this.drawOptions,!0),this.elem.gl&&this.setCalculatedLogicalSpace(t)),this.getCalculatedLogicalSpace()):l):(a=s.refSideKey,i=s.refOffsetKey,this.drawOptions.refSide=c[a],h?(n=r.legendMaxHeight<=0?.8*c.height:r.legendMaxHeight<=c.height?r.legendMaxHeight:c.height,o=r.legendMaxWidth<=0?.8*c.width:r.legendMaxWidth<=c.width?r.legendMaxWidth:c.width,r.legendVertical?(this.drawOptions.refSide=n,this.drawOptions.maxOtherSide=o):(this.drawOptions.refSide=o,this.drawOptions.maxOtherSide=n)):(this.drawOptions.refOffset=c[i],this.drawOptions.maxOtherSide=e||this.drawOptions.maxOtherSide),t=this.elem.gl.getLogicalSpace(this.drawOptions,!0),this.setCalculatedLogicalSpace(t),this.getCalculatedLogicalSpace()||l)},t.resetLegend=function(){var e;(e=this.elem&&this.elem.sGroup)&&e.reset()},t._calculateTopPosition=function(e){var t=this.getFromEnv("chart"),a=t.config,i=e,n=t.getChildren("caption")&&t.getChildren("caption")[0],o=t.getChildren("subCaption")&&t.getChildren("subCaption")[0],r=t.getChildren("chartMenuBar")&&t.getChildren("chartMenuBar")[0],l=a.oriTopSpace;return!a.toolbarY&&r&&r.props&&r.props.height&&(l>r.props.height+r.props.y||(i=r.props.y+r.props.height)),n&&n.config&&n.config.text&&n.config.text!==u.BLANKSTRING&&n.config.height&&1===n.config.isOnTop&&(i=n.config.height+n.config.y+n.config.captionPadding),o&&o.config&&o.config.height&&1===o.config.isOnTop&&(i=o.config.y+o.config.height+(n&&n.config&&n.config.captionPadding||0)),i>e?i:e},t.allocatePosition=function(){var e,t,a,i,n,o,r,l,s=this.getFromEnv("chart"),c=s.config,h=this.conf||{},u=h.legendPosition.split("-"),d=c.canvasLeft,g=c.canvasTop,p=c.canvasWidth,f=c.canvasHeight,m=c.marginTop,b=c.marginBottom,v=c.marginRight,x=c.marginLeft;h.axisTextItemConf.style.fontSize=this.computeFontSize(h.axisTextItemConf.style.fontSizeWithUnit),h.legendCaptionConf.style.fontSize=this.computeFontSize(h.legendCaptionConf.style.fontSizeWithUnit),s.config.gLegendEnabled&&(e=this.getCalculatedLogicalSpace(),a=h.width=e.width,i=h.height=e.height,"absolute"===u[0]?(r=c.width-a,l=c.height-i,n=h.legendXPosition<0?0:h.legendXPosition>r?r:h.legendXPosition,o=h.legendYPosition<0?0:h.legendYPosition>l?l:h.legendYPosition):"top"===u[0]||"bottom"===u[0]?(t=p-a,n="left"===u[1]?d:"right"===u[1]?d+(t>0?t:0):d+(t<0?0:t/2),o="top"===u[0]?this._calculateTopPosition(m):c.height-e.height-b-(c.actionBarHeight||0)):(t=f-i,o="top"===u[1]?g:"bottom"===u[1]?g+t:g+(t<0?0:t/2),n="left"===u[0]?x:c.width-e.width-v),h.xPos=n,h.yPos=o)},t.draw=function(){var e=this.getFromEnv("chart"),t=e.getFromEnv("dataSource").colorrange,a=this.conf||{},i=e.hasGradientLegend;e.config.gLegendEnabled&&t&&i&&this.drawLegendComponent(a.xPos,a.yPos,{parentGroup:e.getContainer("parentgroup"),animationManager:e.getFromEnv("animationManager")})},t.drawLegendComponent=function(e,t,a){var i,n=this.conf;this._dontPlot||(n.showLegend?(this.drawOptions.animationManager=a.animationManager,this.drawOptions.parentGroup=a.parentGroup,this.drawOptions.x=e,this.drawOptions.y=t,this.drawOptions.maxOtherSide=this.drawOptions.maxOtherSide||a.maxOtherSide,i=this.elem.gl.draw(this.drawOptions).getBBox(),n.xPos=i.x,n.yPos=i.y,n.height=i.height,n.width=i.width,this.enabled=!0):this.enabled=!1)},a}(d.ComponentInterface),S=function(){function e(e){this.carpet=e}var t=e.prototype;return t.draw=function(e){return this.carpet.draw(e)},t.getLogicalSpace=function(e,t){return this.carpet.getLogicalSpace(e,t)},t.dispose=function(){this.carpet&&this.carpet.group&&this.carpet.group.remove()},e}(),w=function(){function e(e){this.conf=e,this._id="GL_CARPET",this.compositionsByCategory={},this.node=n,this.group=n,this._lSpace=n,this.autoRecalculate=!1,this.groupName="fc-gradient-legend",this.moveInstructions={}}var t=e.prototype;return t.configure=function(e){this.conf=e},t.getName=function(){return"LegendCarpet"},t.getType=function(){return"legend"},t.addCompositions=function(e,t){this.compositionsByCategory[t]=e},t.removeCompositions=function(e){delete this.compositionsByCategory[e]},t.getBoundingBox=function(e){var t,a,i=this.conf,o=i.spreadFactor,r=e.refSide,l=e.alignment,s=e.refOffset,c=e.x,h=e.y;return"bottom"===this.conf.legendPosition?(t=i.width=r*o,a=e.maxOtherSide,!l||c!==n&&null!==c||(c=(s+r)/2-t/2)):(a=i.height=r*o,t=e.maxOtherSide,!l||h!==n&&null!==h||(h=(s+r)/2-a/2)),{width:t,height:a,x:c,y:h}},t.getPostCalcDecisionsH=function(e,t){var a,i=this.conf.padding,n=0;for(a in this.moveInstructions={},t)n+=t[a].height||0;e.height=n+2*i.v},t.getLogicalSpace=function(e,t){var a,i,n,o,r,l=this._lSpace,s=["CAPTION","LEGEND_BODY"],c=this.conf.padding,h=this.compositionsByCategory,u=0,d={},g=0;if(l&&!t)return l.isImpure=!0,l;(C((l=this._lSpace=i=this.getBoundingBox(e)).x)||C(l.y)||C(l.height)||C(l.width))&&(this.autoRecalculate=!0),(n=v(i,{})).height-=2*c.v,n.width-=2*c.h,n.x+=c.h,n.y+=c.v;for(var p=0;p<s.length;p++)(a=h[s[p]])&&((r=v(n,{})).y+=u,u=n.height*a.conf.spreadFactor,r.height=u+g,o=a.getLogicalSpace(v(r,{}),e,t),g=r.height-o.height,d[s[p]]=o,u=o.height);return this.getPostCalcDecisions(i,d),this._lSpace=i,i},t.setupDragging=function(){var e=this.group,t=0,a=0,i=0,n=0;e.css({cursor:"move"}),e.drag((function(o,r){t=o,a=r,e.attr({transform:"t"+(i+t)+","+(n+a)})}),(function(){i+=t,n+=a}),u.stubFN)},t.draw=function(e){var t,a,i,n=this.conf,o=["CAPTION","LEGEND_BODY"],l=this.compositionsByCategory,s=e.animationManager,c=e.parentGroup;this.getLogicalSpace(e,this.autoRecalculate),i=this._lSpace,this.group=t=s.setAnimation({el:this.group||"group",attr:{name:this.groupName},component:r,container:c,label:"carpetGroup"}),this.node=s.setAnimation({el:this.node||"rect",attr:i,css:n.style,component:r,container:t,label:"rect"});for(var h=0;h<o.length;h++)(a=l[o[h]])&&a.draw(n.captionAlignment,i,{animationManager:s,colorRange:e.colorRange,numberFormatter:e.numberFormatter,parentLayer:t,smartLabel:e.smartLabel,moveInstructions:this.moveInstructions[void 0],gLegend:e.gLegend});return n.allowDrag&&this.setupDragging(),this.node},t.getPostCalcDecisions=function(e,t){return"bottom"===this.conf.legendPosition?this.getPostCalcDecisionsH(e,t):this.getPostCalcDecisionsV(e,t)},t.getPostCalcDecisionsV=function(e,t){var a,i,n,o=this.conf.padding,r=Number.NEGATIVE_INFINITY,l=this.moveInstructions;for(i in this.getPostCalcDecisionsH(e,t),t)r=r<(a=t[i].width)?a:r;for(i in e.width=r+2*o.h,t)(n=r-(a=t[i].width))&&(l[i]="t"+n/2+",0")},e}(),A=function(){function e(e,t){this.rawText=e,this.conf=t,this._id="GL_CAPTION",this.node=n,this.bound=n,this._lSpace=n,this.LegendCaption={},this.LegendCaption.LEFT={x:function(e,t){return t.x+e.width/2+2}},this.LegendCaption.RIGHT={x:function(e,t){return t.x+t.width-e.width/2-2}},this.LegendCaption.CENTER={x:function(){var e=arguments[1];return e.x+e.width/2}}}var t=e.prototype;return t.configure=function(e,t){this.rawText=e,this.conf=t},t.getName=function(){return"LegendCaption"},t.getType=function(){return"caption"},t.getLogicalSpace=function(e,t,a){var i,o,r,l,s=this.conf.padding,c=this._lSpace,h=this.rawText,u=t.gLegend.getFromEnv("chartConfig");return c&&!a?(c.isImpure=!0,c):(c=this._lSpace={bound:{height:0,width:0},node:{logicArea:n,smartText:n}},i=t.smartLabel,h?((o=v(e,{})).height-=2*s.v,o.width-=2*s.h,o.x+=s.h,o.y+=s.v,i.useEllipsesOnOverflow(u.useEllipsesWhenOverflow),y(l=v(this.conf.style,{})),i.setStyle(this._metaStyle=l),r=i.getSmartText(h,o.width,o.height),o.height=r.height,o.width=r.width,e.height=r.height+2*s.v,e.width=r.width+2*s.h,c.node.smartText=r,c.node.logicArea=o,c.bound=e,e):c.bound)},t.draw=function(){var e,t,a,i,n,o,l,s,c,h,u,d=this.conf,g=d.bound||{};return arguments.length>=3?(l=arguments[0],s=arguments[1],c=arguments[2]):arguments.length>=2&&(l=arguments[0],c=arguments[1]),e=c.parentLayer,u=c.animationManager,this.group=t=u.setAnimation({el:this.group||"group",attr:{name:"legend-caption"},css:d.style,component:r,container:e}),this.getLogicalSpace(s,c),h=(n=this._lSpace).node,i=n.bound,this.bound=a=u.setAnimation({el:this.bound||"rect",attr:i,css:g.style,container:t,component:r}),o="string"==typeof l?this.LegendCaption[l.toUpperCase()].x(h.smartText,s||h.logicArea):l,this.node=u.setAnimation({el:this.node||"text",attr:{text:h.smartText.text,x:o,y:h.logicArea.y+h.smartText.height/2,lineHeight:this._metaStyle.lineHeight,fill:d.style.fill},container:t,component:r}),{group:t,bound:a,node:this.node}},t.dispose=function(){this.group.remove(),this.bound.remove(),this.node.remove()},e}(),L=function(){function e(e,t,a){this.colorRange=e,this.conf=t,this.childTextConf=a,this._id="GL_BODY",this.bound=n,this.group=n,this.compositionsByCategory={},this._lSpace=n,this.SC_STACK=[g.AXIS_LABEL,g.LEGEND_AXIS,g.AXIS_VALUE],this.DARW_STACK=[g.AXIS_VALUE,g.LEGEND_AXIS,g.AXIS_LABEL]}var t=e.prototype;return t.configure=function(e,t,a){this.colorRange=e,this.conf=t,this.childTextConf=a,this.compositionsByCategory={}},t.getName=function(){return"LegendBody"},t.getType=function(){return"legend"},t.addCompositions=function(e,t){this.compositionsByCategory[t]=e},t.getSpaceTaken=function(e){return"bottom"===this.conf.legendPosition?e.height:e.width},t.getLogicalSpace=function(e,t,a){var i,o,r,l,s,c,h,u=this._lSpace,d=this.conf.padding,g=this.compositionsByCategory,p=0;if(u&&!a)return u.isImpure=!0,u;for(u=this._lSpace={bound:{height:0,width:0},node:{logicArea:n}},(l=v(e,{})).height-=2*d.v,l.width-=2*d.h,l.x+=d.h,l.y+=d.v,s=this.getCompositionPlotAreaFor(l),t.colorRange=this.colorRange,c=0,h=this.SC_STACK.length;c<h;c++)(i=g[this.SC_STACK[c]])&&(o=s(r,i.conf.spreadFactor),r=i.getLogicalSpace(v(o,{}),t,a),p+=this.getSpaceTaken(r));return this.updateEffectivePlotArea(e,l,p),u.node.logicArea=l,u.bound=e,e},t.draw=function(){var e,t,a,i,n,o,l,s,c,h,u=this.childTextConf,d=this.conf,g=d.bound.style||{},p=this.compositionsByCategory;for(arguments.length>=3?(o=arguments[1],s=arguments[2]):arguments.length>=2&&(s=arguments[1]),t=s.parentLayer,e=s.animationManager,this.getLogicalSpace(o,s),l=this._lSpace,this.group=n=e.setAnimation({el:this.group||"group",attr:{name:"legend-body",transform:"t0,0"},css:u.style,container:t,component:r}),this.bound=a=e.setAnimation({el:this.bound||"rect",attr:l.bound,css:g,container:n,component:r}),s.colorRange=this.colorRange,s.parentLayer=n,c=0,h=this.DARW_STACK.length;c<h;c++)(i=p[this.DARW_STACK[c]])&&i.draw(s);return s.moveInstructions&&n.attr({transform:s.moveInstructions}),{bound:a,group:n}},t.getCompositionPlotAreaFor=function(e){var t,a="bottom"===this.conf.legendPosition;return t=v(e,{}),function(i,n){var o=i;return o=o||{},a?(t.y+=o.height||0,t.height=e.height*n):(t.x+=o.width||0,t.width=e.width*n),t}},t.updateEffectivePlotArea=function(e,t,a){var i=this.conf.padding;"bottom"===this.conf.legendPosition?(t.height=a,e.height=a+2*i.v):(t.width=a,e.width=a+2*i.h)},e}(),N=function(){function e(e){this.conf=e,this.node=[],this._id="GL_LABELS"}var t=e.prototype;return t.configure=function(e){this.conf=e},t.getType=function(){return"label"},t.getName=function(){return"LegendLabel"},t.getEffectivePlotArea=function(e){var t=this.conf.padding;return e.height-=2*t.v,e.width-=2*t.h,e.x+=t.h,e.y+=t.v,e},t.getLogicalSpace=function(e,t,a){var i,o,r,l,s,c,h,d,g,p,f,m,b,x,C,k,S,w,A,L,N,F,T,E="bottom"===this.conf.legendPosition,P=this._lSpace,_=this.conf,D=_.padding,I=[],M=t.gLegend.getFromEnv("chartConfig"),O=[];if(P&&!a)return P.isImpure=!0,P;for(i=t.colorRange,o=t.smartLabel,p=i.getCumulativeValueRatio(),r=i.colorRange,b=(P=this._lSpace={bound:{height:0,width:0},node:{logicArea:n,smartTexts:[]}}).node.smartTexts,d=v(e,{}),C=this.getEffectivePlotArea(d),T=E?C.width:C.height,o.useEllipsesOnOverflow(M.useEllipsesWhenOverflow),F=v(_.style,{}),y(this._metaStyle=F),o.setStyle(F),k=o.getSmartText("W"),l=0,s=r.length;l<s;l++)(g=(0,u.parseUnsafeString)(r[l].label))?O.push({oriIndex:l,label:g}):b[l]=n;if(0===(s=O.length))return{height:0,width:0};for(m=f=s>1?(p[O[s-1].oriIndex]-p[O[0].oriIndex])/2*T/100:Math.max(p[O[0].oriIndex],100-p[O[0].oriIndex])/2*T/100,E?((L=o.getSmartText(O[0].label,m,C.height)).x=p[O[0].oriIndex]*C.width/100,c=L.x+L.width):((L=o.getSmartText(O[0].label,m,C.width)).y=p[O[0].oriIndex]*C.height/100,c=L.y+L.width),I.push(L.height),b[O[0].oriIndex]=L,E?((L=o.getSmartText(O[s-1].label,m,C.height)).x=p[O[s-1].oriIndex]*C.width/100,h=L.x-L.width):((L=o.getSmartText(O[s-1].label,m,C.width)).y=p[O[s-1].oriIndex]*C.height/100,h=L.y-L.width),I.push(L.height),b[O[s-1].oriIndex]=L,A=c,l=1;l<s-1;l++)g=O[l].label,N=O[l].oriIndex,L=n,S=l+1===s-1?h:p[O[l+1].oriIndex]*T/100,w=p[O[l].oriIndex]*T/100,(f=Math.min(w-A,S-w))>2*k.width&&(E?(L=o.getSmartText(g,f,C.height)).x=p[N]*C.width/100:(L=o.getSmartText(g,f,C.width)).y=p[N]*C.height/100,A=f,I.push(L.height)),b[O[l].oriIndex]=L;return x=Math.max.apply(Math,I),E?(C.height=x,e.height=x+2*D.v):(C.width=x,e.width=x+2*D.v),P.node.logicArea=C,P.bound=e,e},t.draw=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g="bottom"===this.conf.legendPosition,p=this.conf,f=p.bound&&p.bound.style||{stroke:"none"},m={};arguments.length>=2&&arguments[1]?(i=arguments[0],l=arguments[1]):arguments.length>=1&&(l=arguments[0]),d=l.animationManager,e=l.parentLayer,this.getLogicalSpace(i,l),c=(o=this._lSpace).node.logicArea,h=o.node.smartTexts,this.group=a=d.setAnimation({el:this.group||"group",attr:{name:"legend-labels"},container:e,component:r}),this.bound=t=d.setAnimation({el:this.bound||"rect",attr:o.bound,css:f,container:a,component:r});for(var b=0;b<this.node.length;b++)this.node[b].remove();for(this.node=[],s=0,u=h.length;s<u;s++)(n=h[s])&&(g?(m.y=c.y+n.height/2,m.x=s===u-1?c.x+n.x-n.width/2:s?c.x+n.x:c.x+n.x+n.width/2):(m.x=c.x+n.height/2,m.y=s===u-1?c.y+n.y-n.width/2:s?c.y+n.y:c.y+n.y+n.width/2),this.node.push(d.setAnimation({el:"text",attr:{text:n.text,x:m.x,y:m.y,lineHeight:this._metaStyle.lineHeight,fill:p.style.fill,transform:g?"R0":"R270,"+m.x+","+m.y},container:a,component:r})));return{group:a,bound:t,node:this.node}},e}(),F=function(){function e(e){this.conf=e,this._id="FL_AXIS",this.node=n,this.group=n,this.shadow=n,this.markerLine=n,this.compositionsByCategory={}}var t=e.prototype;return t.configure=function(e){this.conf=e},t.getName=function(){return"LegendAxis"},t.getType=function(){return"axis"},t.addCompositions=function(e,t){this.compositionsByCategory[t]=e},t.getLogicalSpace=function(){var e,t,a,i,o,r,l="bottom"===this.conf.legendPosition,s=arguments[0],c=arguments[2],h=this._lSpace,u=this.conf,d=u.padding,p=u.legendAxisHeight,f=this.compositionsByCategory,m=0;return h&&!c?(h.isImpure=!0,h):(h=this._lSpace={bound:{height:0,width:0},node:{logicArea:n}},(o=v(s,{})).height-=2*d.v,o.width-=2*d.h,o.x+=d.h,o.y+=d.v,e=p/2+u.line.offset,t=p/2,(i=f[g.RANGE])&&(r=i.sliders["false"].conf.outerCircle.rFactor*p,t+=m=Math.max(r/2-p/2,0)),l?(o.y+=m,o.height=a=t+e+m,s.height=a+2*d.v):(o.x+=m,o.width=a=t+e+m,s.width=a+2*d.v),h.node.logicArea=o,h.bound=s,s)},t.getDrawableAxisArea=function(e){var t=this.conf,a="bottom"===this.conf.legendPosition;return{x:e.x,y:e.y,width:a?e.width:t.legendAxisHeight,height:a?t.legendAxisHeight:e.height,r:t.legendAxisHeight/2}},t.preDrawingRangeParamV=function(e){return{x:e.x+e.width/2,calculationBase:e.width,rangeStart:e.y,rangeEnd:e.y+e.height,prop:"x"}},t.preDrawingRangeParamH=function(e){return{y:e.y+e.height/2,calculationBase:e.height,rangeStart:e.x,rangeEnd:e.x+e.width,prop:"y"}},t.preDrawingRangeParam=function(e){return"bottom"===this.conf.legendPosition?this.preDrawingRangeParamH(e):this.preDrawingRangeParamV(e)},t.getScaleMarkerPathStrH=function(e,t){var a,i,n,o,r,l=v(e,{}),s=this.conf.line,c=u.BLANKSTRING,h=u.BLANKSTRING;for(l.x+=l.r,l.width-=2*l.r,r=l.y+l.height,a=0,i=t.length;a<i;a++)n=t[a],o=l.x+n*l.width/100,c+=m+o+","+(r-s.grooveLength)+b+o+","+(r+s.offset);return c+(h+=m+l.x+","+(r+s.offset)+b+(l.x+l.width)+","+(r+s.offset))},t.getColorGradientH=function(e){return{axis:e.getBoxFill(),shadow:(0,u.toRaphaelColor)({FCcolor:{alpha:"25,0,0",angle:90,color:"000000,FFFFFF,FFFFFF",ratio:"0,30,40"}})}},t.draw=function(){var e,t,a,i,n,o,l,s,c,h,u,d,p,f,m=this.conf,b=m.bound||{},v=m.line,x=b.style||{},y=this.compositionsByCategory;for(a in arguments.length>=2?(t=arguments[0],d=arguments[1]):arguments.length>=1&&(d=arguments[0]),p=d.animationManager,e=d.parentLayer,n=(i=d.colorRange).getCumulativeValueRatio(),this.getLogicalSpace(t,d),u=this._lSpace,this.group=l=p.setAnimation({el:this.group||"group",attr:{name:"legend-axis"},container:e,component:r}),this.bound=p.setAnimation({el:this.bound||"rect",attr:u.bound,css:x,component:r,container:l}),h=this.getDrawableAxisArea(u.node.logicArea),c=this.getColorGradient(i),m.style.fill=c.axis,m.shadow.style.fill=c.shadow,this.node=p.setAnimation({el:this.node||"rect",attr:h,css:m.style,container:l,component:r}),this.shadow=p.setAnimation({el:this.shadow||"rect",attr:h,css:m.shadow.style,container:l,component:r}),f=this.getScaleMarkerPathStr(h,n),this.path=p.setAnimation({el:this.path||"path",attr:{path:f},css:v.style,container:l,component:r}),y)switch(o=y[a],a){case g.RANGE:d[(s=this.preDrawingRangeParam(h)).prop]=s[s.prop],d.key=s.prop,d.rCalcBase=s.calculationBase,d.parentLayer=l,o.draw(s.rangeStart,s.rangeEnd,d)}},t.getScaleMarkerPathStr=function(e,t){return"bottom"===this.conf.legendPosition?this.getScaleMarkerPathStrH(e,t):this.getScaleMarkerPathStrV(e,t)},t.getColorGradient=function(e){return"bottom"===this.conf.legendPosition?this.getColorGradientH(e):this.getColorGradientV(e)},t.getScaleMarkerPathStrV=function(e,t){var a,i,n,o,r,l=v(e,{}),s=this.conf.line,c=u.BLANKSTRING,h=u.BLANKSTRING;for(l.y+=l.r,l.height-=2*l.r,o=l.x+l.width,a=0,n=t.length;a<n;a++)i=t[a],r=l.y+i*l.height/100,c+=m+(o-s.grooveLength)+","+r+b+(o+s.offset)+","+r;return c+(h+=m+(o+s.offset)+","+l.y+b+(o+s.offset)+","+(l.y+l.height))},t.getColorGradientV=function(e){return{axis:e.getBoxFill(!0),shadow:(0,u.toRaphaelColor)({FCcolor:{alpha:"25,0,0",angle:360,color:"000000,FFFFFF,FFFFFF",ratio:"0,30,40"}})}},e}(),T=function(){function e(e,t,a){this.conf=t.conf,this.sliderIndex=e,this.rangeGroup=t.sliderGroup,this._id=a,this.node=n,this.tracker=n,this.currPos=0,this.swing=[]}var t=e.prototype;return t.configure=function(e,t,a){this.conf=t.conf,this.sliderIndex=e,this.rangeGroup=t.sliderGroup,this._id=a,this.currPos=0,this.swing=[]},t.getType=function(){return"slider"},t.getName=function(){return"Slider"},t.updateSwingRange=function(e,t){this.swing[+e]=t},t.draw=function(e,t,a,i){var n,o,l,s,c,h,u,d=i.parentLayer,g=i.animationManager,f=this.conf,m=f.outerCircle,b=f.innerCircle,v=g.getFromEnv("chart").config,x=Math.ceil(m.rFactor*i.rCalcBase/2),y=Math.ceil(b.rFactor*i.rCalcBase/2),C=x-y,k=i.gLegend.getFromEnv("toolTipController"),S=this.sliderIndex;return f.outerRadius=x,f.innerRadius=y,this._scaleVal=t,b.style["stroke-width"]=C,y+=s=Math.ceil(m.style["stroke-width"]/2),o=this.node=g.setAnimation({el:this.node||"group",attr:{name:"fc-gl-slider",cursor:"pointer",transform:"t0,0"},container:d,component:r}),"x"===i.key?(c=a,h=e,h+=S?-y:+y):(c=e,h=a,c+=S?-y:+y),this.oCircle=g.setAnimation({el:this.oCircle||"circle",attr:{cx:c,cy:h,r:x},css:m.style,container:o,component:r}),this.iCircle=g.setAnimation({el:this.iCircle||"circle",attr:{cx:c,cy:h,r:y},css:b.style,container:o,component:r}),u=this.tracker=g.setAnimation({el:this.tracker||"circle",attr:{cx:c,cy:h,r:x+5,fill:p,stroke:p,cursor:"pointer"},container:o,component:r}),o.attr({transform:"x"===i.key?"t0,"+this.currPos:"t"+this.currPos+",0"}),n=v.showToolTip?t:"",k.enableToolTip(u,n),this._dragAPI=l=this.getDragAPI("x"===i.key),u.undrag(),u.drag(l.dragging,l.dragStart,l.dragEnd),{translateAscending:x+s}},t.getDragAPI=function(e){var t,a,i,n,o=this,r=o.node,l=o.sliderIndex,s=o.rangeGroup,c=o.conf.innerRadius;return{dragging:function(h){var u,d,g,p,f;return h.stopPropagation(),g=e?h.data[1]:h.data[0],l?(u=t[0]-t[1]+c,d=0):(u=0,d=t[1]-t[0]-c),(f=o.currPos+g)<u?g+=u-f:f>d&&(g-=f-d),r.attr({transform:e?"t0,"+(o.currPos+g):"t"+(o.currPos+g)+",0"}),a=g,i&&clearTimeout(i),i=setTimeout((function(){s.updateWhenInRest(o,o.currPos+g)}),100),p=s.updateWhenInMove(o,o.currPos+g),o.conf.showTooltip&&o.tracker.data("__FC_tooltipText",p),n=!0,!0},dragStart:function(e){e.stopPropagation(),t=o.swing,n=!1,s.dragStarted(o)},dragEnd:function(){var e;s.dragCompleted(o,n,o.currPos+a),n&&(i&&clearTimeout(i),i=setTimeout((function(){s.updateWhenInRest(o,o.currPos)}),100),o.currPos+=a,e=t[+l]+o.currPos,s.updateRange(o,e))}}},t.dispose=function(){this.node.remove(),this.oCircle.remove(),this.iCircle.remove(),this.tracker.remove()},e}(),E=function(){function e(e){var t=e,a={};this._id="GL_SG1",this.conf=e,a.conf=t,this.extremes=[],this.sliders={},this.min=n,this.max=n,a.sliderGroup=this,this.valueRange=[],this.callbacks=[],this.sliders[!1]=new T(!1,a,this._id+"_0"),this.sliders[!0]=new T(!0,a,this._id+"_1")}var t=e.prototype;return t.configure=function(e){var t=e,a={};this.min=n,this.max=n,this.conf=e,a.conf=t,a.sliderGroup=this,this.sliders[!1].configure(!1,a,this._id+"_0"),this.sliders[!0].configure(!0,a,this._id+"_1")},t.getType=function(){return"slider"},t.getName=function(){return"SliderGroup"},t.initRange=function(e,t){var a=e.sliderIndex;this.extremes[+a]=t},t.updateRange=function(e,t){var a=e.sliderIndex;this.sliders[!a].updateSwingRange(a,t)},t.reset=function(){var e={};e.conf=this.conf,e.sliderGroup=this,this.min=n,this.max=n,this.sliders[!1].configure(!1,e,this._id+"_0"),this.sliders[!0].configure(!0,e,this._id+"_1"),this.draw.apply(this,this._drawParams)},t.draw=function(e,t,a){var i,n,o,r,l,s,c=this.sliders,h=c[!1],u=c[!0],d=a.colorRange,g=d.colorRange,p=d.data.mapByPercent,f=a.gLegend.getFromEnv("number-formatter");return this._fcChart=a.gLegend.getFromEnv("chart"),this.getValueFormPixel=function(e,t,a,i){var n=(t-e)/(i-a);this.getValueFormPixel=function(t){return e+n*t}},this.updateWhenInMove=function(e,t){this.updateWhenInMove=function(a,i){var n,o,r=this.extremes;return n=a.sliderIndex?r[1]-r[0]+i:i,o=this.getValueFormPixel(n),o=t?parseFloat(o).toFixed(2)+"%":e.legendValue(o)}},this._drawParams=[e,t,a],this.updateWhenInMove(f,p),o=h.conf.outerCircle,n=h.conf.innerCircle,r=Math.ceil(n.rFactor*a.rCalcBase/2),r+=Math.ceil(o.style["stroke-width"]/2),this.extremes[0]=e+r,this.extremes[1]=t-r,l=this.extremes[1]-this.extremes[0],this.min=this.min?this.min:g[0].value,this.max=this.max?this.max:g[g.length-1].value,s=g[g.length-1].value-g[0].value,h.currPos=l*(this.min-g[0].value)/s,u.currPos=l*(this.max-g[0].value)/s-l,h.draw(e,p?f.legendPercentValue(this.min):f.legendValue(this.min),a[a.key],a),i=u.draw(t,p?f.legendPercentValue(this.max):f.legendValue(this.max),a[a.key],a),h.swing=this.extremes.slice(0),u.swing=this.extremes.slice(0),h.swing[1]+=u.currPos,u.swing[0]+=h.currPos,this.getValueFormPixel(g[0].value,g[g.length-1].value,this.extremes[0],this.extremes[1]),i},t.updateWhenInRest=function(e,t){var a,i,n=this.sliders,o=this.extremes,r=e.sliderIndex;r?(a=n[!r].currPos,i=o[1]-o[0]+t):(a=t,i=o[1]-o[0]+n[!r].currPos),this.min=Number(this.getValueFormPixel(a).toFixed(2)),this.max=Number(this.getValueFormPixel(i).toFixed(2)),this.gLegend.fireEvent("rangeUpdated",[{min:this.min,max:this.max}])},t.dragStarted=function(e){var t=this.sliders,a=this.extremes,i=e.conf,n=this._fcChart;n.fireChartInstanceEvent("legendpointerdragstart",{pointerIndex:+e.sliderIndex,pointers:[{value:this.getValueFormPixel(t["false"].currPos)},{value:this.getValueFormPixel(a[1]-a[0]+t["true"].currPos)}],legendPointerHeight:i.outerRadius,legendPointerWidth:i.innerRadius,outerRadius:i.outerRadius,innerRadius:i.innerRadius},[n.id])},t.dragCompleted=function(e,t,a){var i,n,o=this.sliders,r=this.extremes,l=e.conf,s=this.getValueFormPixel(o["false"].currPos),c=this.getValueFormPixel(r[1]-r[0]+o["true"].currPos),h=this._fcChart;e.sliderIndex?(i=s,n=this.getValueFormPixel(r[1]-r[0]+a)):(i=this.getValueFormPixel(a),n=c),t&&h.fireChartInstanceEvent("legendrangeupdated",{previousMinValue:s,previousMaxValue:c,minValue:i,maxValue:n},[h.id]),h.fireChartInstanceEvent("legendpointerdragstop",{pointerIndex:+e.sliderIndex,pointers:[{value:i},{value:n}],legendPointerHeight:l.outerRadius,legendPointerWidth:l.innerRadius,outerRadius:l.outerRadius,innerRadius:l.innerRadius},[h.id])},t.dispose=function(){this.sliders[!1].dispose(),this.sliders[!0].dispose()},e}(),P=function(e){function t(){var t;return(t=e.call(this,arguments[0])||this)._id="GL_VALUES",t.node=[],t}(0,h["default"])(t,e);var a=t.prototype;return a.configure=function(e){this.conf=e},a.getName=function(){return"LegendValues"},a.getType=function(){return"legend"},a.getLogicalSpace=function(e,t,a){var i,o,r,l,s,c,h,u,d,g,p,f,m,b,x,C,k,S,w,A,L,N,F,T,E,P="bottom"===this.conf.legendPosition,_=this._lSpace,D=this.conf,I=D.padding,M=t.gLegend.getFromEnv("chartConfig"),O=[],R=[];if(_&&!a)return _.isImpure=!0,_;for(i=t.colorRange,o=t.smartLabel,r=i.colorRange,h=i.getCumulativeValueRatio(),E=(_=this._lSpace={bound:{height:0,width:0},node:{logicArea:n,smartTexts:[]}}).node.smartTexts,(A=v(e,{})).height-=2*I.v,A.width-=2*I.h,A.x+=I.h,A.y+=I.v,o.useEllipsesOnOverflow(M.useEllipsesWhenOverflow),T=v(D.style,{}),y(this._metaStyle=T),o.setStyle(T),F=o.getSmartText("W"),c=r.length,P?(p=u=(h[c-1]-h[0])/2*A.width/100,N=r[0].displayValue,(l=o.getSmartText("string"!=typeof N&&N!==n&&N.toString()||N,p,A.height)).x=h[0]*A.width/100,f=l.x+l.width,O.push(l.height)):(p=u=(h[c-1]-h[0])/2*A.height/100,(l=o.getSmartText(r[0].displayValue,A.width,p)).y=h[0]*A.height/100,x=l.y+l.width,R.push(l.width)),E[0]=l,P?((l=o.getSmartText(r[c-1].displayValue,p,A.height)).x=h[c-1]*A.width/100,b=l.x-l.width,O.push(l.height),m=f):((l=o.getSmartText(r[c-1].displayValue,A.width,p)).y=h[c-1]*A.height/100,k=l.y-l.height,R.push(l.width),C=x),E[c-1]=l,s=1;s<c-1;s++)l=n,L=r[s].displayValue,P?(d=s+1===c-1?b:h[s+1]*A.width/100,g=h[s]*A.width/100,(u=Math.min(g-m,d-g))>1.5*F.width&&((l=o.getSmartText(L,2*u,A.height)).x=h[s]*A.width/100,m=u,O.push(l.height))):(d=s+1===c-1?k:h[s+1]*A.height/100,g=h[s]*A.height/100,(u=Math.min(g-C,d-g))>2*F.height&&((l=o.getSmartText(L,A.width,2*u)).y=h[s]*A.height/100,C=u,R.push(l.width))),E[s]=l;return P?(S=Math.max.apply(Math,O),A.height=S,e.height=S+2*I.v):(w=Math.max.apply(Math,R),A.width=w,e.width=w+2*I.h),_.node.logicArea=A,_.bound=e,e},a.draw=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g,p=this.conf,f="bottom"===p.legendPosition,m=p.bound&&p.bound.style||{stroke:"none"},b={};arguments.length>=2&&arguments[1]?(i=arguments[0],l=arguments[1]):arguments.length>=1&&(l=arguments[0]),g=l.animationManager,e=l.parentLayer,s=l.colorRange.getCumulativeValueRatio(),this.getLogicalSpace(i,l),o=(n=this._lSpace).node.logicArea,u=n.node.smartTexts,this.group=a=g.setAnimation({el:this.group||"group",attr:{name:"legend-values"},container:e,component:r}),this.bound=t=g.setAnimation({el:this.bound||"rect",attr:n.bound,css:m,container:a,component:r});for(var v=0;v<this.node.length;v++)this.node[v].remove();for(this.node=[],c=0,h=s.length;c<h;c++)(d=u[c])&&(f?(b.y=o.y+d.height/2,b.x=c===h-1?o.x+d.x-d.width/2:c?o.x+d.x:o.x+d.x+d.width/2):(b.x=o.x+d.width/2,b.y=c===h-1?o.y+d.y-d.height/2:c?o.y+d.y:o.y+d.y+d.height/2),this.node.push(g.setAnimation({el:"text",attr:{text:d.text,x:b.x,y:b.y,lineHeight:this._metaStyle.lineHeight,fill:p.style.fill},container:a,component:r})));return{group:a,bound:t}},t}(N),_=k;t["default"]=_},1062:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.radiansInAngle=t.changeAngleBase=t.findArc=t.normaliseAngle=t.pointOnCircleFromCenter=t.getCoordinates=t.getPlotFromPixel=t.polarToCartesian=t.cartesianToPolar=t.rad2Deg=t.deg2Rad=void 0;var n=i(a(230)),o=function(e){return e*(Math.PI/180)},r=function(e){return e*(180/Math.PI)},l=function(e,t){var a,i;return a=Math.sqrt(e*e+t*t),i=r(Math.atan(t/e)),e<0&&t>=0||e<0&&t<0?i+=180:e>0&&t<0&&(i+=360),{radius:a,theta:o(i)}},s=function(e,t,a){void 0===a&&(a=!0);var i=t;return a||(i=o(i)),{x:e*Math.cos(i),y:e*Math.sin(i)}};t.radiansInAngle=function(e,t){return e/t*(180/Math.PI)},t.changeAngleBase=function(e){return e>=0&&e<90?Math.abs(180-e):e>90&&e<=180?Math.abs(e-180):e>180&&e<270||e>270&&e<360?Math.abs(360-e+180):360===e?180:e},t.findArc=function(e,t){var a;return(a=t>360?t%360:t<0?360+t:t)>e?a-e:360-(e-a)},t.normaliseAngle=function(e){return e-90},t.pointOnCircleFromCenter=function(e,t,a,i){var n=(i-90)*Math.PI/180;return{x:e+a*Math.cos(n),y:t+a*Math.sin(n)}},t.getPlotFromPixel=function(e,t){var a,i,n=e.x,o=e.y,s=t.getScale();return i=l(n,o),a=s.getDomainValue(i.theta),r(a)},t.getCoordinates=function(e,t){var a,i,o=t.getScale(),r=e.radius,l=t.config,c=l.axisDimention.centerX,h=l.axisDimention.centerY;return r=(0,n["default"])(r,l.radius,0),a=o.getRangeValue(e.theta),(i=s(r,a)).x+=c,i.y+=h,i},t.polarToCartesian=s,t.cartesianToPolar=l,t.rad2Deg=r,t.deg2Rad=o},1066:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"axis"}];t["default"]=i},1082:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(404))["default"];t["default"]=n},1188:function(e,t,a){"use strict";t.__esModule=!0,t.symbolList=void 0;var i,n=(0,a(232).getDep)("redraphael","plugin"),o=Math.cos,r=Math.sin,l=Math.PI;t.symbolList=i,t.symbolList=i={pinModeIcon:function(e,t,a){var i=.5*a,n=e-a,o=e+a,r=e-i,l=e+i,s=e+.5,c=s+1,h=s+1.5,u=t-a,d=t+i,g=t-i,p=t+(a-i);return["M",n,u,"L",r,g,r,p,n,d,e-.5,d,e,t+a+.5,s,d,o,d,l,p,l,g,o,u,h,u,h,g,h,p,c,p,c,g,h,g,h,u,"Z"]},zoomOutIcon:function(e,t,a){var i=e-.2*a,l=t-.2*a,s=.8*a,c=n.rad(43),h=n.rad(48),u=i+s*o(c),d=l+s*r(c),g=i+s*o(h),p=l+s*r(h),f=a,m=n.rad(45);return["M",u,d,"A",s,s,0,1,0,g,p,"Z","M",u+1,d+1,"L",u+f*o(m),d+f*r(m),g+f*o(m),p+f*r(m),g+1,p+1,"Z","M",i-2,l,"L",i+2,l,"Z"]},resetIcon:function(e,t,a){var i=a,n=e-i,s=t,c=(l/2+l)/2,h=e+i*o(c),u=t+i*r(c),d=2*i/3;return["M",n,s,"A",i,i,0,1,1,h,u,"L",h+d,u-1,h+2,u+d-.5,h,u]},zoomInIcon:function(e,t,a){var i=e-.2*a,l=t-.2*a,s=.8*a,c=n.rad(43),h=n.rad(48),u=i+s*o(c),d=l+s*r(c),g=i+s*o(h),p=l+s*r(h),f=a,m=n.rad(45);return["M",u,d,"A",s,s,0,1,0,g,p,"Z","M",u+1,d+1,"L",u+f*o(m),d+f*r(m),g+f*o(m)-1,p+f*r(m)-1,g+1,p+1,"Z","M",i-2,l,"L",i+2,l,"Z","M",i,l-2,"L",i,l+2,"Z"]},zoomModeIcon:function(e,t,a){var i=[],l=e-.2*a,s=t-.2*a,c=.8*a,h=n.rad(43),u=n.rad(48),d=l+c*o(h),g=s+c*r(h),p=l+c*o(u),f=s+c*r(u),m=a,b=n.rad(45),v=d+m*o(b),x=g+m*r(b),y=p+m*o(b)-1,C=f+m*r(b)-1;return i=i.concat(["M",d,g,"A",c,c,0,1,0,p,f,"Z","M",d+1,g+1,"L",v,x,y,C,y+1,C-1,y+1.5,C+1.5,y-1,C+1,y,C,p+1,f+1,"Z","M",l-2,s,"L",l+2,s,"Z","M",l,s-2,"L",l,s+2,"Z"])},panModeIcon:function(e,t,a){var i,n=a;return[].concat(["M",(i=e)-(n*=2.5)/16,t-n/8,"L",i+n/16,t-n/8,"L",i+n/16,t-n/3.2,"L",i+6*n/32,t-10*n/32,"L",i,t-n/2,"L",i-6*n/32,t-10*n/32,"L",i-n/16,t-n/3.2,"Z","M",i+4*n/32,t-2*n/32,"L",i+10*n/32,t-2*n/32,"L",i+10*n/32,t-6*n/32,"L",i+16*n/32,t,"L",i+10*n/32,t+6*n/32,"L",i+10*n/32,t+2*n/32,"L",i+4*n/32,t+2*n/32,"Z","M",i+2*n/32,t+5*n/32,"L",i+2*n/32,t+10*n/32,"L",i+6*n/32,t+10*n/32,"L",i,t+16*n/32,"L",i-6*n/32,t+10*n/32,"L",i-2*n/32,t+10*n/32,"L",i-2*n/32,t+5*n/32,"Z","M",i-4*n/32,t-2*n/32,"L",i-10*n/32,t-2*n/32,"L",i-10*n/32,t-6*n/32,"L",i-16*n/32,t,"L",i-10*n/32,t+6*n/32,"L",i-10*n/32,t+2*n/32,"L",i-4*n/32,t+2*n/32,"Z"])}}},1229:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(628)),r=a(224),l=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"group"},a.getName=function(){return"columnOverlappedGroup"},a.setColumnPosition=function(){var e,t=this.getFromEnv("chart-attrib"),a=this.getFromEnv("xAxis"),i=this.getFromEnv("chart"),n=this.getFromEnv("numOfColumns"),o=Math.max((0,r.pluckNumber)(t.plotspacepercent),0),l=Math.max((0,r.pluckNumber)(o,20)%100,0),s=l/200,c=a.getPixel(0),h=a.getPixel(1),u=i.isBar?i.config.maxBarHeight:i.config.maxColWidth,d=Math.abs(h-c),g=!0,p=0,f=0;this.addToEnv("groupMaxWidth",d),this._mapChildren((function(e){e.getState("removed")||!1===e.getState("visible")||f++})),this.addToEnv("numOfColumns",f),this.addToEnv("numColDiff",(0,r.pluckNumber)(n-f,0)),void 0===(e=this.getFromEnv("plotWidth"))&&(e=(1-.01*o)*d||Math.min(d*(1-2*s),u*(f||1))),this._mapChildren((function(t){t.getState("removed")||!1===t.getState("visible")||(t.addToEnv("plotWidth",e-e/f*p),p++)})),h-NaN-(c-NaN+void 0)<4&&(g=!1),0===l&&(g=!0),this.addToEnv("isCrisp",g)},t}(o["default"]);t["default"]=l},1239:function(e,t,a){"use strict";(function(e){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
var i=a(1240),n=a(1241),o=a(1242);function r(){return s.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function l(e,t){if(r()<t)throw new RangeError("Invalid typed array length");return s.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=s.prototype:(null===e&&(e=new s(t)),e.length=t),e}function s(e,t,a){if(!(s.TYPED_ARRAY_SUPPORT||this instanceof s))return new s(e,t,a);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return u(this,e)}return c(this,e,t,a)}function c(e,t,a,i){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,a,i){if(t.byteLength,a<0||t.byteLength<a)throw new RangeError("'offset' is out of bounds");if(t.byteLength<a+(i||0))throw new RangeError("'length' is out of bounds");t=a===undefined&&i===undefined?new Uint8Array(t):i===undefined?new Uint8Array(t,a):new Uint8Array(t,a,i);s.TYPED_ARRAY_SUPPORT?(e=t).__proto__=s.prototype:e=d(e,t);return e}(e,t,a,i):"string"==typeof t?function(e,t,a){"string"==typeof a&&""!==a||(a="utf8");if(!s.isEncoding(a))throw new TypeError('"encoding" must be a valid string encoding');var i=0|p(t,a),n=(e=l(e,i)).write(t,a);n!==i&&(e=e.slice(0,n));return e}(e,t,a):function(e,t){if(s.isBuffer(t)){var a=0|g(t.length);return 0===(e=l(e,a)).length||t.copy(e,0,0,a),e}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(i=t.length)!=i?l(e,0):d(e,t);if("Buffer"===t.type&&o(t.data))return d(e,t.data)}var i;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function h(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function u(e,t){if(h(t),e=l(e,t<0?0:0|g(t)),!s.TYPED_ARRAY_SUPPORT)for(var a=0;a<t;++a)e[a]=0;return e}function d(e,t){var a=t.length<0?0:0|g(t.length);e=l(e,a);for(var i=0;i<a;i+=1)e[i]=255&t[i];return e}function g(e){if(e>=r())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+r().toString(16)+" bytes");return 0|e}function p(e,t){if(s.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var a=e.length;if(0===a)return 0;for(var i=!1;;)switch(t){case"ascii":case"latin1":case"binary":return a;case"utf8":case"utf-8":case undefined:return z(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*a;case"hex":return a>>>1;case"base64":return G(e).length;default:if(i)return z(e).length;t=(""+t).toLowerCase(),i=!0}}function f(e,t,a){var i=!1;if((t===undefined||t<0)&&(t=0),t>this.length)return"";if((a===undefined||a>this.length)&&(a=this.length),a<=0)return"";if((a>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return T(this,t,a);case"utf8":case"utf-8":return L(this,t,a);case"ascii":return N(this,t,a);case"latin1":case"binary":return F(this,t,a);case"base64":return A(this,t,a);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return E(this,t,a);default:if(i)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),i=!0}}function m(e,t,a){var i=e[t];e[t]=e[a],e[a]=i}function b(e,t,a,i,n){if(0===e.length)return-1;if("string"==typeof a?(i=a,a=0):a>2147483647?a=2147483647:a<-2147483648&&(a=-2147483648),a=+a,isNaN(a)&&(a=n?0:e.length-1),a<0&&(a=e.length+a),a>=e.length){if(n)return-1;a=e.length-1}else if(a<0){if(!n)return-1;a=0}if("string"==typeof t&&(t=s.from(t,i)),s.isBuffer(t))return 0===t.length?-1:v(e,t,a,i,n);if("number"==typeof t)return t&=255,s.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?n?Uint8Array.prototype.indexOf.call(e,t,a):Uint8Array.prototype.lastIndexOf.call(e,t,a):v(e,[t],a,i,n);throw new TypeError("val must be string, number or Buffer")}function v(e,t,a,i,n){var o,r=1,l=e.length,s=t.length;if(i!==undefined&&("ucs2"===(i=String(i).toLowerCase())||"ucs-2"===i||"utf16le"===i||"utf-16le"===i)){if(e.length<2||t.length<2)return-1;r=2,l/=2,s/=2,a/=2}function c(e,t){return 1===r?e[t]:e.readUInt16BE(t*r)}if(n){var h=-1;for(o=a;o<l;o++)if(c(e,o)===c(t,-1===h?0:o-h)){if(-1===h&&(h=o),o-h+1===s)return h*r}else-1!==h&&(o-=o-h),h=-1}else for(a+s>l&&(a=l-s),o=a;o>=0;o--){for(var u=!0,d=0;d<s;d++)if(c(e,o+d)!==c(t,d)){u=!1;break}if(u)return o}return-1}function x(e,t,a,i){a=Number(a)||0;var n=e.length-a;i?(i=Number(i))>n&&(i=n):i=n;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");i>o/2&&(i=o/2);for(var r=0;r<i;++r){var l=parseInt(t.substr(2*r,2),16);if(isNaN(l))return r;e[a+r]=l}return r}function y(e,t,a,i){return H(z(t,e.length-a),e,a,i)}function C(e,t,a,i){return H(function(e){for(var t=[],a=0;a<e.length;++a)t.push(255&e.charCodeAt(a));return t}(t),e,a,i)}function k(e,t,a,i){return C(e,t,a,i)}function S(e,t,a,i){return H(G(t),e,a,i)}function w(e,t,a,i){return H(function(e,t){for(var a,i,n,o=[],r=0;r<e.length&&!((t-=2)<0);++r)a=e.charCodeAt(r),i=a>>8,n=a%256,o.push(n),o.push(i);return o}(t,e.length-a),e,a,i)}function A(e,t,a){return 0===t&&a===e.length?i.fromByteArray(e):i.fromByteArray(e.slice(t,a))}function L(e,t,a){a=Math.min(e.length,a);for(var i=[],n=t;n<a;){var o,r,l,s,c=e[n],h=null,u=c>239?4:c>223?3:c>191?2:1;if(n+u<=a)switch(u){case 1:c<128&&(h=c);break;case 2:128==(192&(o=e[n+1]))&&(s=(31&c)<<6|63&o)>127&&(h=s);break;case 3:o=e[n+1],r=e[n+2],128==(192&o)&&128==(192&r)&&(s=(15&c)<<12|(63&o)<<6|63&r)>2047&&(s<55296||s>57343)&&(h=s);break;case 4:o=e[n+1],r=e[n+2],l=e[n+3],128==(192&o)&&128==(192&r)&&128==(192&l)&&(s=(15&c)<<18|(63&o)<<12|(63&r)<<6|63&l)>65535&&s<1114112&&(h=s)}null===h?(h=65533,u=1):h>65535&&(h-=65536,i.push(h>>>10&1023|55296),h=56320|1023&h),i.push(h),n+=u}return function(e){var t=e.length;if(t<=4096)return String.fromCharCode.apply(String,e);var a="",i=0;for(;i<t;)a+=String.fromCharCode.apply(String,e.slice(i,i+=4096));return a}(i)}t.Buffer=s,t.SlowBuffer=function(e){+e!=e&&(e=0);return s.alloc(+e)},t.INSPECT_MAX_BYTES=50,s.TYPED_ARRAY_SUPPORT=e.TYPED_ARRAY_SUPPORT!==undefined?e.TYPED_ARRAY_SUPPORT:function(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(t){return!1}}(),t.kMaxLength=r(),s.poolSize=8192,s._augment=function(e){return e.__proto__=s.prototype,e},s.from=function(e,t,a){return c(null,e,t,a)},s.TYPED_ARRAY_SUPPORT&&(s.prototype.__proto__=Uint8Array.prototype,s.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&s[Symbol.species]===s&&Object.defineProperty(s,Symbol.species,{value:null,configurable:!0})),s.alloc=function(e,t,a){return function(e,t,a,i){return h(t),t<=0?l(e,t):a!==undefined?"string"==typeof i?l(e,t).fill(a,i):l(e,t).fill(a):l(e,t)}(null,e,t,a)},s.allocUnsafe=function(e){return u(null,e)},s.allocUnsafeSlow=function(e){return u(null,e)},s.isBuffer=function(e){return!(null==e||!e._isBuffer)},s.compare=function(e,t){if(!s.isBuffer(e)||!s.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var a=e.length,i=t.length,n=0,o=Math.min(a,i);n<o;++n)if(e[n]!==t[n]){a=e[n],i=t[n];break}return a<i?-1:i<a?1:0},s.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},s.concat=function(e,t){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return s.alloc(0);var a;if(t===undefined)for(t=0,a=0;a<e.length;++a)t+=e[a].length;var i=s.allocUnsafe(t),n=0;for(a=0;a<e.length;++a){var r=e[a];if(!s.isBuffer(r))throw new TypeError('"list" argument must be an Array of Buffers');r.copy(i,n),n+=r.length}return i},s.byteLength=p,s.prototype._isBuffer=!0,s.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)m(this,t,t+1);return this},s.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)m(this,t,t+3),m(this,t+1,t+2);return this},s.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)m(this,t,t+7),m(this,t+1,t+6),m(this,t+2,t+5),m(this,t+3,t+4);return this},s.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?L(this,0,e):f.apply(this,arguments)},s.prototype.equals=function(e){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===s.compare(this,e)},s.prototype.inspect=function(){var e="",a=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,a).match(/.{2}/g).join(" "),this.length>a&&(e+=" ... ")),"<Buffer "+e+">"},s.prototype.compare=function(e,t,a,i,n){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(t===undefined&&(t=0),a===undefined&&(a=e?e.length:0),i===undefined&&(i=0),n===undefined&&(n=this.length),t<0||a>e.length||i<0||n>this.length)throw new RangeError("out of range index");if(i>=n&&t>=a)return 0;if(i>=n)return-1;if(t>=a)return 1;if(this===e)return 0;for(var o=(n>>>=0)-(i>>>=0),r=(a>>>=0)-(t>>>=0),l=Math.min(o,r),c=this.slice(i,n),h=e.slice(t,a),u=0;u<l;++u)if(c[u]!==h[u]){o=c[u],r=h[u];break}return o<r?-1:r<o?1:0},s.prototype.includes=function(e,t,a){return-1!==this.indexOf(e,t,a)},s.prototype.indexOf=function(e,t,a){return b(this,e,t,a,!0)},s.prototype.lastIndexOf=function(e,t,a){return b(this,e,t,a,!1)},s.prototype.write=function(e,t,a,i){if(t===undefined)i="utf8",a=this.length,t=0;else if(a===undefined&&"string"==typeof t)i=t,a=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(a)?(a|=0,i===undefined&&(i="utf8")):(i=a,a=undefined)}var n=this.length-t;if((a===undefined||a>n)&&(a=n),e.length>0&&(a<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");i||(i="utf8");for(var o=!1;;)switch(i){case"hex":return x(this,e,t,a);case"utf8":case"utf-8":return y(this,e,t,a);case"ascii":return C(this,e,t,a);case"latin1":case"binary":return k(this,e,t,a);case"base64":return S(this,e,t,a);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return w(this,e,t,a);default:if(o)throw new TypeError("Unknown encoding: "+i);i=(""+i).toLowerCase(),o=!0}},s.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function N(e,t,a){var i="";a=Math.min(e.length,a);for(var n=t;n<a;++n)i+=String.fromCharCode(127&e[n]);return i}function F(e,t,a){var i="";a=Math.min(e.length,a);for(var n=t;n<a;++n)i+=String.fromCharCode(e[n]);return i}function T(e,t,a){var i=e.length;(!t||t<0)&&(t=0),(!a||a<0||a>i)&&(a=i);for(var n="",o=t;o<a;++o)n+=V(e[o]);return n}function E(e,t,a){for(var i=e.slice(t,a),n="",o=0;o<i.length;o+=2)n+=String.fromCharCode(i[o]+256*i[o+1]);return n}function P(e,t,a){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>a)throw new RangeError("Trying to access beyond buffer length")}function _(e,t,a,i,n,o){if(!s.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>n||t<o)throw new RangeError('"value" argument is out of bounds');if(a+i>e.length)throw new RangeError("Index out of range")}function D(e,t,a,i){t<0&&(t=65535+t+1);for(var n=0,o=Math.min(e.length-a,2);n<o;++n)e[a+n]=(t&255<<8*(i?n:1-n))>>>8*(i?n:1-n)}function I(e,t,a,i){t<0&&(t=4294967295+t+1);for(var n=0,o=Math.min(e.length-a,4);n<o;++n)e[a+n]=t>>>8*(i?n:3-n)&255}function M(e,t,a,i,n,o){if(a+i>e.length)throw new RangeError("Index out of range");if(a<0)throw new RangeError("Index out of range")}function O(e,t,a,i,o){return o||M(e,0,a,4),n.write(e,t,a,i,23,4),a+4}function R(e,t,a,i,o){return o||M(e,0,a,8),n.write(e,t,a,i,52,8),a+8}s.prototype.slice=function(e,t){var a,i=this.length;if((e=~~e)<0?(e+=i)<0&&(e=0):e>i&&(e=i),(t=t===undefined?i:~~t)<0?(t+=i)<0&&(t=0):t>i&&(t=i),t<e&&(t=e),s.TYPED_ARRAY_SUPPORT)(a=this.subarray(e,t)).__proto__=s.prototype;else{var n=t-e;a=new s(n,undefined);for(var o=0;o<n;++o)a[o]=this[o+e]}return a},s.prototype.readUIntLE=function(e,t,a){e|=0,t|=0,a||P(e,t,this.length);for(var i=this[e],n=1,o=0;++o<t&&(n*=256);)i+=this[e+o]*n;return i},s.prototype.readUIntBE=function(e,t,a){e|=0,t|=0,a||P(e,t,this.length);for(var i=this[e+--t],n=1;t>0&&(n*=256);)i+=this[e+--t]*n;return i},s.prototype.readUInt8=function(e,t){return t||P(e,1,this.length),this[e]},s.prototype.readUInt16LE=function(e,t){return t||P(e,2,this.length),this[e]|this[e+1]<<8},s.prototype.readUInt16BE=function(e,t){return t||P(e,2,this.length),this[e]<<8|this[e+1]},s.prototype.readUInt32LE=function(e,t){return t||P(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},s.prototype.readUInt32BE=function(e,t){return t||P(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},s.prototype.readIntLE=function(e,t,a){e|=0,t|=0,a||P(e,t,this.length);for(var i=this[e],n=1,o=0;++o<t&&(n*=256);)i+=this[e+o]*n;return i>=(n*=128)&&(i-=Math.pow(2,8*t)),i},s.prototype.readIntBE=function(e,t,a){e|=0,t|=0,a||P(e,t,this.length);for(var i=t,n=1,o=this[e+--i];i>0&&(n*=256);)o+=this[e+--i]*n;return o>=(n*=128)&&(o-=Math.pow(2,8*t)),o},s.prototype.readInt8=function(e,t){return t||P(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},s.prototype.readInt16LE=function(e,t){t||P(e,2,this.length);var a=this[e]|this[e+1]<<8;return 32768&a?4294901760|a:a},s.prototype.readInt16BE=function(e,t){t||P(e,2,this.length);var a=this[e+1]|this[e]<<8;return 32768&a?4294901760|a:a},s.prototype.readInt32LE=function(e,t){return t||P(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},s.prototype.readInt32BE=function(e,t){return t||P(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},s.prototype.readFloatLE=function(e,t){return t||P(e,4,this.length),n.read(this,e,!0,23,4)},s.prototype.readFloatBE=function(e,t){return t||P(e,4,this.length),n.read(this,e,!1,23,4)},s.prototype.readDoubleLE=function(e,t){return t||P(e,8,this.length),n.read(this,e,!0,52,8)},s.prototype.readDoubleBE=function(e,t){return t||P(e,8,this.length),n.read(this,e,!1,52,8)},s.prototype.writeUIntLE=function(e,t,a,i){(e=+e,t|=0,a|=0,i)||_(this,e,t,a,Math.pow(2,8*a)-1,0);var n=1,o=0;for(this[t]=255&e;++o<a&&(n*=256);)this[t+o]=e/n&255;return t+a},s.prototype.writeUIntBE=function(e,t,a,i){(e=+e,t|=0,a|=0,i)||_(this,e,t,a,Math.pow(2,8*a)-1,0);var n=a-1,o=1;for(this[t+n]=255&e;--n>=0&&(o*=256);)this[t+n]=e/o&255;return t+a},s.prototype.writeUInt8=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,1,255,0),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},s.prototype.writeUInt16LE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):D(this,e,t,!0),t+2},s.prototype.writeUInt16BE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):D(this,e,t,!1),t+2},s.prototype.writeUInt32LE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):I(this,e,t,!0),t+4},s.prototype.writeUInt32BE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):I(this,e,t,!1),t+4},s.prototype.writeIntLE=function(e,t,a,i){if(e=+e,t|=0,!i){var n=Math.pow(2,8*a-1);_(this,e,t,a,n-1,-n)}var o=0,r=1,l=0;for(this[t]=255&e;++o<a&&(r*=256);)e<0&&0===l&&0!==this[t+o-1]&&(l=1),this[t+o]=(e/r>>0)-l&255;return t+a},s.prototype.writeIntBE=function(e,t,a,i){if(e=+e,t|=0,!i){var n=Math.pow(2,8*a-1);_(this,e,t,a,n-1,-n)}var o=a-1,r=1,l=0;for(this[t+o]=255&e;--o>=0&&(r*=256);)e<0&&0===l&&0!==this[t+o+1]&&(l=1),this[t+o]=(e/r>>0)-l&255;return t+a},s.prototype.writeInt8=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,1,127,-128),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},s.prototype.writeInt16LE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):D(this,e,t,!0),t+2},s.prototype.writeInt16BE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):D(this,e,t,!1),t+2},s.prototype.writeInt32LE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,4,2147483647,-2147483648),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):I(this,e,t,!0),t+4},s.prototype.writeInt32BE=function(e,t,a){return e=+e,t|=0,a||_(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):I(this,e,t,!1),t+4},s.prototype.writeFloatLE=function(e,t,a){return O(this,e,t,!0,a)},s.prototype.writeFloatBE=function(e,t,a){return O(this,e,t,!1,a)},s.prototype.writeDoubleLE=function(e,t,a){return R(this,e,t,!0,a)},s.prototype.writeDoubleBE=function(e,t,a){return R(this,e,t,!1,a)},s.prototype.copy=function(e,t,a,i){if(a||(a=0),i||0===i||(i=this.length),t>=e.length&&(t=e.length),t||(t=0),i>0&&i<a&&(i=a),i===a)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(a<0||a>=this.length)throw new RangeError("sourceStart out of bounds");if(i<0)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),e.length-t<i-a&&(i=e.length-t+a);var n,o=i-a;if(this===e&&a<t&&t<i)for(n=o-1;n>=0;--n)e[n+t]=this[n+a];else if(o<1e3||!s.TYPED_ARRAY_SUPPORT)for(n=0;n<o;++n)e[n+t]=this[n+a];else Uint8Array.prototype.set.call(e,this.subarray(a,a+o),t);return o},s.prototype.fill=function(e,t,a,i){if("string"==typeof e){if("string"==typeof t?(i=t,t=0,a=this.length):"string"==typeof a&&(i=a,a=this.length),1===e.length){var n=e.charCodeAt(0);n<256&&(e=n)}if(i!==undefined&&"string"!=typeof i)throw new TypeError("encoding must be a string");if("string"==typeof i&&!s.isEncoding(i))throw new TypeError("Unknown encoding: "+i)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<a)throw new RangeError("Out of range index");if(a<=t)return this;var o;if(t>>>=0,a=a===undefined?this.length:a>>>0,e||(e=0),"number"==typeof e)for(o=t;o<a;++o)this[o]=e;else{var r=s.isBuffer(e)?e:z(new s(e,i).toString()),l=r.length;for(o=0;o<a-t;++o)this[o+t]=r[o%l]}return this};var B=/[^+\/0-9A-Za-z-_]/g;function V(e){return e<16?"0"+e.toString(16):e.toString(16)}function z(e,t){var a;t=t||Infinity;for(var i=e.length,n=null,o=[],r=0;r<i;++r){if((a=e.charCodeAt(r))>55295&&a<57344){if(!n){if(a>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(r+1===i){(t-=3)>-1&&o.push(239,191,189);continue}n=a;continue}if(a<56320){(t-=3)>-1&&o.push(239,191,189),n=a;continue}a=65536+(n-55296<<10|a-56320)}else n&&(t-=3)>-1&&o.push(239,191,189);if(n=null,a<128){if((t-=1)<0)break;o.push(a)}else if(a<2048){if((t-=2)<0)break;o.push(a>>6|192,63&a|128)}else if(a<65536){if((t-=3)<0)break;o.push(a>>12|224,a>>6&63|128,63&a|128)}else{if(!(a<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(a>>18|240,a>>12&63|128,a>>6&63|128,63&a|128)}}return o}function G(e){return i.toByteArray(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(B,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function H(e,t,a,i){for(var n=0;n<i&&!(n+a>=t.length||n>=e.length);++n)t[n+a]=e[n];return n}}).call(this,a(6))},1240:function(e,t,a){"use strict";t.byteLength=function(e){var t=c(e),a=t[0],i=t[1];return 3*(a+i)/4-i},t.toByteArray=function(e){var t,a,i=c(e),r=i[0],l=i[1],s=new o(function(e,t,a){return 3*(t+a)/4-a}(0,r,l)),h=0,u=l>0?r-4:r;for(a=0;a<u;a+=4)t=n[e.charCodeAt(a)]<<18|n[e.charCodeAt(a+1)]<<12|n[e.charCodeAt(a+2)]<<6|n[e.charCodeAt(a+3)],s[h++]=t>>16&255,s[h++]=t>>8&255,s[h++]=255&t;2===l&&(t=n[e.charCodeAt(a)]<<2|n[e.charCodeAt(a+1)]>>4,s[h++]=255&t);1===l&&(t=n[e.charCodeAt(a)]<<10|n[e.charCodeAt(a+1)]<<4|n[e.charCodeAt(a+2)]>>2,s[h++]=t>>8&255,s[h++]=255&t);return s},t.fromByteArray=function(e){for(var t,a=e.length,n=a%3,o=[],r=0,l=a-n;r<l;r+=16383)o.push(h(e,r,r+16383>l?l:r+16383));1===n?(t=e[a-1],o.push(i[t>>2]+i[t<<4&63]+"==")):2===n&&(t=(e[a-2]<<8)+e[a-1],o.push(i[t>>10]+i[t>>4&63]+i[t<<2&63]+"="));return o.join("")};for(var i=[],n=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=0,s=r.length;l<s;++l)i[l]=r[l],n[r.charCodeAt(l)]=l;function c(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var a=e.indexOf("=");return-1===a&&(a=t),[a,a===t?0:4-a%4]}function h(e,t,a){for(var n,o,r=[],l=t;l<a;l+=3)n=(e[l]<<16&16711680)+(e[l+1]<<8&65280)+(255&e[l+2]),r.push(i[(o=n)>>18&63]+i[o>>12&63]+i[o>>6&63]+i[63&o]);return r.join("")}n["-".charCodeAt(0)]=62,n["_".charCodeAt(0)]=63},1241:function(e,t){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
t.read=function(e,t,a,i,n){var o,r,l=8*n-i-1,s=(1<<l)-1,c=s>>1,h=-7,u=a?n-1:0,d=a?-1:1,g=e[t+u];for(u+=d,o=g&(1<<-h)-1,g>>=-h,h+=l;h>0;o=256*o+e[t+u],u+=d,h-=8);for(r=o&(1<<-h)-1,o>>=-h,h+=i;h>0;r=256*r+e[t+u],u+=d,h-=8);if(0===o)o=1-c;else{if(o===s)return r?NaN:(g?-1:1)*Infinity;r+=Math.pow(2,i),o-=c}return(g?-1:1)*r*Math.pow(2,o-i)},t.write=function(e,t,a,i,n,o){var r,l,s,c=8*o-n-1,h=(1<<c)-1,u=h>>1,d=23===n?Math.pow(2,-24)-Math.pow(2,-77):0,g=i?0:o-1,p=i?1:-1,f=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===Infinity?(l=isNaN(t)?1:0,r=h):(r=Math.floor(Math.log(t)/Math.LN2),t*(s=Math.pow(2,-r))<1&&(r--,s*=2),(t+=r+u>=1?d/s:d*Math.pow(2,1-u))*s>=2&&(r++,s/=2),r+u>=h?(l=0,r=h):r+u>=1?(l=(t*s-1)*Math.pow(2,n),r+=u):(l=t*Math.pow(2,u-1)*Math.pow(2,n),r=0));n>=8;e[a+g]=255&l,g+=p,l/=256,n-=8);for(r=r<<n|l,c+=n;c>0;e[a+g]=255&r,g+=p,r/=256,c-=8);e[a+g-p]|=128*f}},1242:function(e,t){var a={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==a.call(e)}},1246:function(e,t,a){(function(e){var i=Object.getOwnPropertyDescriptors||function(e){for(var t=Object.keys(e),a={},i=0;i<t.length;i++)a[t[i]]=Object.getOwnPropertyDescriptor(e,t[i]);return a},n=/%[sdj%]/g;t.format=function(e){if(!b(e)){for(var t=[],a=0;a<arguments.length;a++)t.push(l(arguments[a]));return t.join(" ")}a=1;for(var i=arguments,o=i.length,r=String(e).replace(n,(function(e){if("%%"===e)return"%";if(a>=o)return e;switch(e){case"%s":return String(i[a++]);case"%d":return Number(i[a++]);case"%j":try{return JSON.stringify(i[a++])}catch(t){return"[Circular]"}default:return e}})),s=i[a];a<o;s=i[++a])f(s)||!y(s)?r+=" "+s:r+=" "+l(s);return r},t.deprecate=function(a,i){if(void 0!==e&&!0===e.noDeprecation)return a;if(void 0===e)return function(){return t.deprecate(a,i).apply(this,arguments)};var n=!1;return function(){if(!n){if(e.throwDeprecation)throw new Error(i);e.traceDeprecation?console.trace(i):console.error(i),n=!0}return a.apply(this,arguments)}};var o,r={};function l(e,a){var i={seen:[],stylize:c};return arguments.length>=3&&(i.depth=arguments[2]),arguments.length>=4&&(i.colors=arguments[3]),p(a)?i.showHidden=a:a&&t._extend(i,a),v(i.showHidden)&&(i.showHidden=!1),v(i.depth)&&(i.depth=2),v(i.colors)&&(i.colors=!1),v(i.customInspect)&&(i.customInspect=!0),i.colors&&(i.stylize=s),h(i,e,i.depth)}function s(e,t){var a=l.styles[t];return a?"["+l.colors[a][0]+"m"+e+"["+l.colors[a][1]+"m":e}function c(e,t){return e}function h(e,a,i){if(e.customInspect&&a&&S(a.inspect)&&a.inspect!==t.inspect&&(!a.constructor||a.constructor.prototype!==a)){var n=a.inspect(i,e);return b(n)||(n=h(e,n,i)),n}var o=function(e,t){if(v(t))return e.stylize("undefined","undefined");if(b(t)){var a="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(a,"string")}if(m(t))return e.stylize(""+t,"number");if(p(t))return e.stylize(""+t,"boolean");if(f(t))return e.stylize("null","null")}(e,a);if(o)return o;var r=Object.keys(a),l=function(e){var t={};return e.forEach((function(e,a){t[e]=!0})),t}(r);if(e.showHidden&&(r=Object.getOwnPropertyNames(a)),k(a)&&(r.indexOf("message")>=0||r.indexOf("description")>=0))return u(a);if(0===r.length){if(S(a)){var s=a.name?": "+a.name:"";return e.stylize("[Function"+s+"]","special")}if(x(a))return e.stylize(RegExp.prototype.toString.call(a),"regexp");if(C(a))return e.stylize(Date.prototype.toString.call(a),"date");if(k(a))return u(a)}var c,y="",w=!1,A=["{","}"];(g(a)&&(w=!0,A=["[","]"]),S(a))&&(y=" [Function"+(a.name?": "+a.name:"")+"]");return x(a)&&(y=" "+RegExp.prototype.toString.call(a)),C(a)&&(y=" "+Date.prototype.toUTCString.call(a)),k(a)&&(y=" "+u(a)),0!==r.length||w&&0!=a.length?i<0?x(a)?e.stylize(RegExp.prototype.toString.call(a),"regexp"):e.stylize("[Object]","special"):(e.seen.push(a),c=w?function(e,t,a,i,n){for(var o=[],r=0,l=t.length;r<l;++r)F(t,String(r))?o.push(d(e,t,a,i,String(r),!0)):o.push("");return n.forEach((function(n){n.match(/^\d+$/)||o.push(d(e,t,a,i,n,!0))})),o}(e,a,i,l,r):r.map((function(t){return d(e,a,i,l,t,w)})),e.seen.pop(),function(e,t,a){if(e.reduce((function(e,t){return t.indexOf("\n")>=0&&0,e+t.replace(/\u001b\[\d\d?m/g,"").length+1}),0)>60)return a[0]+(""===t?"":t+"\n ")+" "+e.join(",\n  ")+" "+a[1];return a[0]+t+" "+e.join(", ")+" "+a[1]}(c,y,A)):A[0]+y+A[1]}function u(e){return"["+Error.prototype.toString.call(e)+"]"}function d(e,t,a,i,n,o){var r,l,s;if((s=Object.getOwnPropertyDescriptor(t,n)||{value:t[n]}).get?l=s.set?e.stylize("[Getter/Setter]","special"):e.stylize("[Getter]","special"):s.set&&(l=e.stylize("[Setter]","special")),F(i,n)||(r="["+n+"]"),l||(e.seen.indexOf(s.value)<0?(l=f(a)?h(e,s.value,null):h(e,s.value,a-1)).indexOf("\n")>-1&&(l=o?l.split("\n").map((function(e){return"  "+e})).join("\n").substr(2):"\n"+l.split("\n").map((function(e){return"   "+e})).join("\n")):l=e.stylize("[Circular]","special")),v(r)){if(o&&n.match(/^\d+$/))return l;(r=JSON.stringify(""+n)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(r=r.substr(1,r.length-2),r=e.stylize(r,"name")):(r=r.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),r=e.stylize(r,"string"))}return r+": "+l}function g(e){return Array.isArray(e)}function p(e){return"boolean"==typeof e}function f(e){return null===e}function m(e){return"number"==typeof e}function b(e){return"string"==typeof e}function v(e){return void 0===e}function x(e){return y(e)&&"[object RegExp]"===w(e)}function y(e){return"object"==typeof e&&null!==e}function C(e){return y(e)&&"[object Date]"===w(e)}function k(e){return y(e)&&("[object Error]"===w(e)||e instanceof Error)}function S(e){return"function"==typeof e}function w(e){return Object.prototype.toString.call(e)}function A(e){return e<10?"0"+e.toString(10):e.toString(10)}t.debuglog=function(a){if(v(o)&&(o=e.env.NODE_DEBUG||""),a=a.toUpperCase(),!r[a])if(new RegExp("\\b"+a+"\\b","i").test(o)){var i=e.pid;r[a]=function(){var e=t.format.apply(t,arguments);console.error("%s %d: %s",a,i,e)}}else r[a]=function(){};return r[a]},t.inspect=l,l.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},l.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey","null":"bold",string:"green",date:"magenta",regexp:"red"},t.isArray=g,t.isBoolean=p,t.isNull=f,t.isNullOrUndefined=function(e){return null==e},t.isNumber=m,t.isString=b,t.isSymbol=function(e){return"symbol"==typeof e},t.isUndefined=v,t.isRegExp=x,t.isObject=y,t.isDate=C,t.isError=k,t.isFunction=S,t.isPrimitive=function(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||void 0===e},t.isBuffer=a(1247);var L=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function N(){var e=new Date,t=[A(e.getHours()),A(e.getMinutes()),A(e.getSeconds())].join(":");return[e.getDate(),L[e.getMonth()],t].join(" ")}function F(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.log=function(){console.log("%s - %s",N(),t.format.apply(t,arguments))},t.inherits=a(1248),t._extend=function(e,t){if(!t||!y(t))return e;for(var a=Object.keys(t),i=a.length;i--;)e[a[i]]=t[a[i]];return e};var T="undefined"!=typeof Symbol?Symbol("util.promisify.custom"):undefined;function E(e,t){if(!e){var a=new Error("Promise was rejected with a falsy value");a.reason=e,e=a}return t(e)}t.promisify=function(e){if("function"!=typeof e)throw new TypeError('The "original" argument must be of type Function');if(T&&e[T]){var t;if("function"!=typeof(t=e[T]))throw new TypeError('The "util.promisify.custom" argument must be of type Function');return Object.defineProperty(t,T,{value:t,enumerable:!1,writable:!1,configurable:!0}),t}function t(){for(var t,a,i=new Promise((function(e,i){t=e,a=i})),n=[],o=0;o<arguments.length;o++)n.push(arguments[o]);n.push((function(e,i){e?a(e):t(i)}));try{e.apply(this,n)}catch(r){a(r)}return i}return Object.setPrototypeOf(t,Object.getPrototypeOf(e)),T&&Object.defineProperty(t,T,{value:t,enumerable:!1,writable:!1,configurable:!0}),Object.defineProperties(t,i(e))},t.promisify.custom=T,t.callbackify=function(t){if("function"!=typeof t)throw new TypeError('The "original" argument must be of type Function');function a(){for(var a=[],i=0;i<arguments.length;i++)a.push(arguments[i]);var n=a.pop();if("function"!=typeof n)throw new TypeError("The last argument must be of type Function");var o=this,r=function(){return n.apply(o,arguments)};t.apply(this,a).then((function(t){e.nextTick(r,null,t)}),(function(t){e.nextTick(E,t,r)}))}return Object.setPrototypeOf(a,Object.getPrototypeOf(t)),Object.defineProperties(a,i(t)),a}}).call(this,a(217))},1247:function(e,t){e.exports=function(e){return e&&"object"==typeof e&&"function"==typeof e.copy&&"function"==typeof e.fill&&"function"==typeof e.readUInt8}},1248:function(e,t){"function"==typeof Object.create?e.exports=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(e,t){e.super_=t;var a=function(){};a.prototype=t.prototype,e.prototype=new a,e.prototype.constructor=e}},462:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(463)),r=i(a(537)),l=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("dataset",r["default"],["vCanvas"]),t}(0,n["default"])(t,e),t.getName=function(){return"SSCartesian"};var a=t.prototype;return a.getName=function(){return"SSCartesian"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.hasLegend=!1,t.linethickness=4},a._checkInvalidSpecificData=function(){var e=this.getFromEnv("dataSource").data;if(!e||!e.length)return!0},a._setCategories=function(){var e=this.getFromEnv("dataSource"),t=this.getChildren("xAxis"),a=e.dataset,i=e.data||a&&a[0].data;t[0].setTickValues(i)},t}(o["default"]);t["default"]=l},463:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(464)),r=a(224),l=i(a(479)),s=i(a(480)),c=i(a(530)),h=i(a(533)),u=i(a(535)),d=i(a(366)),g=a(364),p=Math.max,f=Math.min,m=function(e,t){return e<t&&t>0?t-e:0},b=function(e){var t=e.sender,a=e.data.scrollPosition,i=t.getChildren("xAxis")[0],n=i.config,o=i.getVisibleConfig(),r=o.maxValue-o.minValue,s=n.axisRange.max-r,c=(0,l["default"])(n.axisRange.min,s),h=n.isReverse?c(1-a):c(a);i.setVisibleConfig(h,h+r)},v={wrtVisible:!0},x=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("axis",s["default"],["canvas"]),t.registerFactory("canvas",c["default"]),t.registerFactory("vCanvas",h["default"],["axis"]),t.registerFactory("mouseTracker",u["default"],["canvas"]),t.addEventListener("onScroll",b),t}(0,n["default"])(t,e),t.getName=function(){return"Cartesian"};var a=t.prototype;return a.getName=function(){return"Cartesian"},a.getType=function(){return"chartAPI"},a._allocateXAxisLabelSpace=function(e){var t,a=this.config,i=e.getAxisEndLabelDisplaySpace(),n=i.left,o=i.right,r=i.top,l=i.bottom,s=a.availableWidth,c=a.availableHeight,h=a.canvasLeft,u=a.canvasRight,d=a.canvasTop,g=a.canvasBottom,p=a.width,f=a.height;r+l>c&&(r=c*r/(t=r+l),l=c*l/t),n+o>s&&(n=s*n/(t=n+o),o=s*o/t),n=m(h,n),o=m(p-u,o),r=m(d,r),l=m(f-g,l),this._allocateSpace({left:n,right:o,top:r,bottom:l})},a._setCategories=function(){var e=this.getFromEnv("dataSource"),t=this.getChildren("xAxis"),a=e.categories&&e.categories.length&&e.categories[0].category;t&&t[0].setTickValues(a)},a._feedAxesRawData=function(){var e,t,a=this.config,i=this.getFromEnv("dataSource");return e=this.getSpecificxAxisConf(),t=this.getSpecificyAxisConf(),e.vtrendlines=(0,r.extend2)([],i.vtrendlines),t.trendlines=(0,r.extend2)([],i.trendlines),a.isstacked&&(t.isPercent=(0,r.pluckNumber)(a.stack100percent,0)),{yAxisConf:[t],xAxisConf:[e]}},a.allocatePosition=function(){this.setScrollBarDimension()},a.setScrollBarDimension=function(){this.getChildren("scrollBar")&&this.getChildren("scrollBar")[0]&&this.getChildren("scrollBar")[0].setDimension(this.getScrollbarDimension())},a.getSpecificxAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config,a=this.config.is3D,i=this.getBasexAxisConf();return i.isReverse=t.reverseXAxis,i.axisLineColor=(0,r.pluck)(e.xaxislinecolor,e.axislinecolor,"#000000"),i.showAlternateGridColor=(0,r.pluckNumber)(e.showalternatevgridcolor,0),i.numDivLines=(0,r.pluckNumber)(e.numvdivlines,t.numVDivLines),i.axisName=e.xaxisname,i.setAdaptiveMin=(0,r.pluckNumber)(e.setadaptivexmin,t.setadaptivexmin,t.setadaptivexmin),i.showLimits=(0,r.pluckNumber)(e.showvlimits,t.showvlimits),i.showDivLineValues=(0,r.pluckNumber)(e.showvdivlinevalues,e.showvdivlinevalues,t.showvdivlinevalues),i.zeroPlaneThickness=(0,r.pluckNumber)(e.vzeroplanethickness,e.vdivlinethickness,t.zeroplanethickness,2),i.zeroPlaneAlpha=(0,r.pluckNumber)(e.vzeroplanealpha,e.vdivlinealpha,t.zeroplanealpha),i.showZeroPlaneValue=(0,r.pluckNumber)(e.showvzeroplanevalue,t.showzeroplanevalue),i.showAxisLine=a?0:(0,r.pluckNumber)(e.showxaxisline,e.showaxislines,e.drawAxisLines,t.showxaxisline,0),i.maxLabelHeight=e.maxlabelheight,i.showZeroPlane=(0,r.pluckNumber)(e.showvzeroplane,t.showzeroplane),i},a.getSpecificyAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config,a=this.config.is3D,i=a?r.chartPaletteStr.chart3D:r.chartPaletteStr.chart2D,n=t.isInverse,o=this.getFromEnv("color-manager"),l=(0,r.pluckNumber)(e.showzeroplane,t.showzeroplane,1),s=(0,r.pluckNumber)(e.showzeroplanevalue,t.showzeroplanevalue),c=(0,r.pluckFontSizeMaintainUnit)(e.outcnvbasefontsize,e.basefontsize,10);return l||void 0!==s||(s=0),{isVertical:!0,isReverse:!n,isOpposit:(0,d["default"])(e.yaxisposition,"right"),outCanfontFamily:(0,r.pluck)(e.outcnvbasefont,e.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(c),outCanfontSizeWithUnit:c,outCancolor:(0,r.pluck)(e.outcnvbasefontcolor,e.basefontcolor,o.getColor(i.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisBreaks:e.yaxisbreaks,axisNamePadding:e.yaxisnamepadding,axisValuePadding:e.yaxisvaluespadding,axisNameFont:e.yaxisnamefont,axisNameFontSize:this.computeFontSize(e.yaxisnamefontsize),axisNameFontSizeWithUnit:e.yaxisnamefontsize,axisNameFontColor:e.yaxisnamefontcolor,axisNameFontBold:e.yaxisnamefontbold,axisNameFontItalic:e.yaxisnamefontitalic,axisNameBgColor:e.yaxisnamebgcolor,axisNameBorderColor:e.yaxisnamebordercolor,axisNameAlpha:e.yaxisnamealpha,axisNameFontAlpha:e.yaxisnamefontalpha,axisNameBgAlpha:e.yaxisnamebgalpha,axisNameBorderAlpha:e.yaxisnameborderalpha,axisNameBorderPadding:e.yaxisnameborderpadding,axisNameBorderRadius:e.yaxisnameborderradius,axisNameBorderThickness:e.yaxisnameborderthickness,axisNameBorderDashed:e.yaxisnameborderdashed,axisNameBorderDashLen:e.yaxisnameborderdashlen,axisNameBorderDashGap:e.yaxisnameborderdashgap,axisNameWidth:e.yaxisnamewidth,useEllipsesWhenOverflow:e.useellipseswhenoverflow,rotateAxisName:(0,r.pluckNumber)(e.rotateyaxisname,1),axisName:e.yaxisname,divLineColor:(0,r.pluck)(e.divlinecolor,o.getColor(i.divLineColor)),divLineAlpha:(0,r.pluck)(e.divlinealpha,a?o.getColor("divLineAlpha3D"):o.getColor("divLineAlpha")),divLineThickness:(0,r.pluckNumber)(e.divlinethickness,1),divLineIsDashed:Boolean((0,r.pluckNumber)(e.divlinedashed,e.divlineisdashed,0)),divLineDashLen:(0,r.pluckNumber)(e.divlinedashlen,4),divLineDashGap:(0,r.pluckNumber)(e.divlinedashgap,2),showAlternateGridColor:(0,r.pluckNumber)(e.showalternatehgridcolor,1),alternateGridColor:(0,r.pluck)(e.alternatehgridcolor,o.getColor("altHGridColor")),alternateGridAlpha:(0,r.pluck)(e.alternatehgridalpha,o.getColor("altHGridAlpha")),numDivLines:(0,r.pluckNumber)(e.numdivlines,t.numDivLines),axisMinValue:t.yRangeMin||e.yaxisminvalue,axisMaxValue:t.yRangeMax||e.yaxismaxvalue,setAdaptiveMin:(0,r.pluckNumber)(e.setadaptivesymin,e.setadaptiveymin,t.setAdaptiveMin),adjustDiv:e.adjustdiv,labelStep:e.yaxisvaluesstep,showAxisValues:(0,r.pluckNumber)(e.showyaxisvalues,e.showyaxisvalue,t.showyaxisvalues),showLimits:(0,r.pluckNumber)(e.showyaxislimits,e.showlimits,this.showLimits),showDivLineValues:(0,r.pluckNumber)(e.showdivlinevalues,e.showdivlinevalue,t.showdivlinevalues),showZeroPlane:l,zeroPlaneColor:e.zeroplanecolor,zeroPlaneThickness:(0,r.pluckNumber)(e.zeroplanethickness,e.divlinethickness,t.zeroplanethickness,2),zeroPlaneAlpha:(0,r.pluckNumber)(e.zeroplanealpha,e.divlinealpha,t.zeroplanealpha),showZeroPlaneValue:s,showZeroPlaneOnTop:t.showzeroplaneontop,trendlineColor:e.trendlinecolor,trendlineToolText:e.trendlinetooltext,trendlineThickness:e.trendlinethickness,trendlineAlpha:e.trendlinealpha,showTrendlinesOnTop:e.showtrendlinesontop,showAxisLine:a?0:(0,r.pluckNumber)(e.showyaxisline,e.showaxislines,e.drawAxisLines,t.showyaxisline,0),axisLineThickness:(0,r.pluckNumber)(e.yaxislinethickness,e.axislinethickness,1),axisLineAlpha:(0,r.pluckNumber)(e.yaxislinealpha,e.axislinealpha,100),axisLineColor:(0,r.pluck)(e.yaxislinecolor,e.axislinecolor,"#000000"),forceTrendBelow:!!t.is3D,labelFont:e.yaxisvaluefont,labelFontSize:this.computeFontSize(e.yaxisvaluefontsize),labelFontSizeWithUnit:e.yaxisvaluefontsize,labelFontColor:e.yaxisvaluefontcolor,labelAlpha:e.yaxisvaluealpha,labelFontBold:e.yaxisvaluefontbold,labelFontItalic:e.yaxisvaluefontitalic,labelBdrColor:e.yaxisvaluebordercolor,labelBdrAlpha:e.yaxisvalueborderalpha,labelBgAlpha:e.yaxisvaluebgalpha,labelLink:e.yaxisvaluelink,labelBgColor:e.yaxisvaluebgcolor,labelBdrThickness:e.yaxisvalueborderthickness,labelBdrPadding:e.yaxisvalueborderpadding,labelBdrRadius:e.yaxisvalueborderradius,labelBdrDashed:e.yaxisvalueborderdashed,labelBdrDashLen:e.yaxisvalueborderdashlen,labelBdrDashGap:e.yaxisvalueborderdashgap}},a.getBasexAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config.is3D,a=t?r.chartPaletteStr.chart3D:r.chartPaletteStr.chart2D,i=this.getFromEnv("color-manager"),n=(0,r.pluckFontSizeMaintainUnit)(e.outcnvbasefontsize,e.basefontsize,10);return{isVertical:!1,isOpposit:(0,d["default"])(e.xaxisposition,"top"),outCanfontFamily:(0,r.pluck)(e.outcnvbasefont,e.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(n),outCanfontSizeWithUnit:n,outCancolor:(0,r.pluck)(e.outcnvbasefontcolor,e.basefontcolor,i.getColor(a.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:e.xaxisnamepadding,axisValuePadding:e.labelpadding,axisNameFont:e.xaxisnamefont,axisNameFontSize:this.computeFontSize(e.xaxisnamefontsize),axisNameFontSizeWithUnit:e.xaxisnamefontsize,axisNameFontColor:e.xaxisnamefontcolor,axisNameFontBold:e.xaxisnamefontbold,axisNameFontItalic:e.xaxisnamefontitalic,axisNameBgColor:e.xaxisnamebgcolor,axisNameBorderColor:e.xaxisnamebordercolor,axisNameAlpha:e.xaxisnamealpha,axisNameFontAlpha:e.xaxisnamefontalpha,axisNameBgAlpha:e.xaxisnamebgalpha,axisNameBorderAlpha:e.xaxisnameborderalpha,axisNameBorderPadding:e.xaxisnameborderpadding,axisNameBorderRadius:e.xaxisnameborderradius,axisNameBorderThickness:e.xaxisnameborderthickness,axisNameBorderDashed:e.xaxisnameborderdashed,axisNameBorderDashLen:e.xaxisnameborderdashlen,axisNameBorderDashGap:e.xaxisnameborderdashgap,useEllipsesWhenOverflow:e.useellipseswhenoverflow,divLineColor:(0,r.pluck)(e.vdivlinecolor,e.divlinecolor,i.getColor(a.divLineColor)),divLineAlpha:(0,r.pluck)(e.vdivlinealpha,e.divlinealpha,t?i.getColor("divLineAlpha3D"):i.getColor("divLineAlpha")),divLineThickness:(0,r.pluckNumber)(e.vdivlinethickness,e.divlinethickness,1),divLineIsDashed:Boolean((0,r.pluckNumber)(e.vdivlinedashed,e.vdivlineisdashed,e.divlinedashed,e.divlineisdashed,0)),divLineDashLen:(0,r.pluckNumber)(e.vdivlinedashlen,e.divlinedashlen,4),divLineDashGap:(0,r.pluckNumber)(e.vdivlinedashgap,e.divlinedashgap,2),alternateGridColor:(0,r.pluck)(e.alternatevgridcolor,i.getColor("altVGridColor")),alternateGridAlpha:(0,r.pluck)(e.alternatevgridalpha,i.getColor("altVGridAlpha")),labelFont:e.labelfont,labelFontSize:this.computeFontSize(e.labelfontsize),labelFontSizeWithUnit:e.labelfontsize,labelFontColor:e.labelfontcolor,labelAlpha:e.labelalpha,labelFontBold:e.labelfontbold,labelFontItalic:e.labelfontitalic,labelBdrColor:e.labelbordercolor,labelBdrAlpha:e.labelborderalpha,labelLink:e.labellink,labelBgColor:e.labelbgcolor,labelBdrThickness:e.labelborderthickness,labelBdrPadding:e.labelborderpadding,labelBdrRadius:e.labelborderradius,labelBdrDashed:e.labelborderdashed,labelBgAlpha:e.labelbgalpha,labelBdrDashLen:e.labelborderdashlen,labelBdrDashGap:e.labelborderdashgap,axisMinValue:e.xaxisminvalue,axisMaxValue:e.xaxismaxvalue,adjustDiv:e.adjustvdiv,labelDisplay:e.labeldisplay,showLabels:e.showlabels,rotateLabels:e.rotatelabels,slantLabel:(0,r.pluckNumber)(e.slantlabels,e.slantlabel),labelStep:(0,r.pluckNumber)(e.labelstep,e.xaxisvaluesstep),showAxisValues:(0,r.pluckNumber)(e.showxaxisvalues,e.showxaxisvalue),zeroPlaneColor:e.vzeroplanecolor,trendlineColor:e.trendlinecolor,trendlineToolText:e.trendlinetooltext,trendlineThickness:e.trendlinethickness,trendlineAlpha:e.trendlinealpha,showTrendlinesOnTop:e.showtrendlinesontop,axisLineThickness:(0,r.pluckNumber)(e.xaxislinethickness,e.axislinethickness,1),axisLineAlpha:(0,r.pluckNumber)(e.xaxislinealpha,e.axislinealpha,100)}},a.getConfig=function(e){return e?this.config[e]:this.config},a._getSumValueSpace=function(e){var t,a={},i=this.config,n=this.isBar,o=this.getFromEnv("dataSource").chart,l=i.showSum=(0,r.pluckNumber)(o.showsum,i.showSum,0),s=(0,r.pluckNumber)(i.stack100percent),c=i.isstacked,h=0,u=[],d=0;if(this.iterateComponents((function(e){"cartesianStackGroup"!==e.getName()&&"marimekkoStackgroup"!==e.getName()||u.push(e)})),l&&s&&c&&u.length){for(t=u.length-1;t>=0;t--)a=u[t].getMaxSumValueSpace(),n?h=Math.max(h,a.maxWidth):d=Math.max(d,a.maxHeight);d>e&&(d=e),h>e&&(h=e)}return{top:d,right:h}},a.setAxisDimention=function(){var e,t,a=this.getChildren("xAxis")&&this.getChildren("xAxis")[0],i=this.getChildren("yAxis")&&this.getChildren("yAxis")[0],n=this.getChildren("scrollBar")&&this.getChildren("scrollBar")[0]&&this.getChildren("scrollBar")[0].config,o=this.config,l=o.xDepth||0,s=this.getFromEnv("chart-attrib"),c=(0,r.pluckNumber)(s.canvasleftpadding),h=(0,r.pluckNumber)(s.canvasrightpadding),u=this.getChildren("canvas")&&this.getChildren("canvas")[0].config,d=u&&u.canvasBorderWidth,g=this.isScrollEnabled(),p=(g||o.is3D)&&o.shift||0,f=u.canvasPadding,m=u.canvasLeft,b=m+u.canvasWidth,v=u.canvasPaddingLeft,x=u.canvasPaddingRight,y=u.canvasTop,C=o.sumValueSpace&&o.sumValueSpace.top||0,k=u.canvasPaddingTop;e=null==c?Math.max(v,f):c,t=null==h?Math.max(x,f):h,a&&a.setAxisConfig({canvasPaddingLeft:e,canvasPaddingRight:t}),a&&a.setAxisDimention({x:m+l+e,y:a.config.isOpposit?y-d-(g&&+n.isOpposite===a.config.isOpposit?p:0)-C:o.canvasBottom+(o.is3D||g&&+n.isOpposite===a.config.isOpposit?p:0)+d,opposite:a.config.isOpposit?o.canvasBottom+p+d:y-d-p,axisLength:u.canvasWidth-l-e-t}),i&&i.setAxisDimention({x:i.config.isOpposit?b+d:m-d,y:y+k,opposite:i.config.isOpposit?m-d:b+d,axisLength:u.canvasHeight-k-u.canvasPaddingBottom})},a._getTrendLineMinMax=function(e,t){var a,i,n,o,r,l=t,s="v"===e?this.getFromEnv("dataSource").vtrendlines:this.getFromEnv("dataSource").trendlines,c={max:-Infinity,min:Infinity};if(l=l||"p",s)for(i=0,o=s.length;i<o;i+=1)for(n=0,r=s[i].line?s[i].line.length:0;n<r;n+=1)a=s[i].line[n],"s"===l&&"s"!==a.parentyaxis||"s"!==l&&"s"===a.parentyaxis||(c.max=p(a.startvalue||-Infinity,a.endvalue||-Infinity,c.max),c.min=f(a.startvalue||Infinity,a.endvalue||Infinity,c.min));return c},a.setScrollType=function(e){"none"!==e&&"smart"!==e&&"always"!==e||(this.config.scrollType=e,"none"===e?this.disableScroll():this.enableScroll())},a.getScrollType=function(){return this.config.scrollType},a._createScrollBar=function(){var e,t=this,a=t.getFromEnv("animationManager"),i=t.getChildren("scrollBar")&&t.getChildren("scrollBar")[0];i||(i=t.attachChild(new g.ScrollBar,"scrollBar")),i.configure({isHorizontal:!t.isBar}),i.attachEventHandlers({scrollStart:function(a){e=a,t.fireChartInstanceEvent("scrollstart",{scrollPosition:a})},scroll:function(e){a.setAnimationState("scroll"),t.fireChartInstanceEvent("onScroll",{scrollPosition:e}),t.fireEvent("onScroll",{scrollPosition:e})},scrollEnd:function(a){t.fireChartInstanceEvent("scrollend",{scrollPosition:a,prevScrollPosition:e})}})},a._disposeScrollBar=function(){var e=this.getChildren("scrollBar")&&this.getChildren("scrollBar")[0];e&&e.remove()},a.getScrollbarDimension=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g,p,f,m,b,x=this.getChildren("xAxis")[0],y=x.config,C=y.axisRange,k=y.scrollOptions||(y.scrollOptions={}),S=C.max,w=C.min,A=k.vxLength,L=this.getChildren("scrollBar")[0],N=this.getChildren("canvas")[0].config;if(L)return e=L.config,t=N.canvasLeft,a=N.canvasTop,i=N.canvasHeight,n=N.canvasWidth,o=N.canvasBorderWidth,l=y.showAxisLine&&y.axisLineThickness||0,s=(0,r.pluckNumber)(o,y.lineStartExtension),c=(0,r.pluckNumber)(o,y.lineEndExtension),k.viewPortMin=w,k.viewPortMax=S,h=(f=(g=x.getVisibleConfig()).maxValue-(p=g.minValue))/(m=C.max-C.min),b=(p-C.min)/(m-f),u=k.windowedCanvasWidth=x.getPixel(A,v),d=k.fullCanvasWidth=x.getPixel(S-w,v)-u,e.scrollRatio=h,e.roundEdges=N.isRoundEdges,e.fullCanvasWidth=d,e.windowedCanvasWidth=u,e.scrollPosition=b,e.isHorizontal?(e.scrollPosition=b,{x:t-s,y:e.isOpposite?a-o-l-(this.config.shift||0)-(e.padding||0):a+i+o+l,width:n+s+c}):(e.scrollPosition=y.isReverse?1-b:b,{x:e.isOpposite?t+n+o+(e.padding||0):t-this.config.shift-o,y:a-o-(e.padding||0),height:i+2*o})},a.enableScroll=function(){this._createScrollBar()},a.disableScroll=function(){this._disposeScrollBar()},a.isScrollEnabled=function(){var e=this.getChildren("scrollBar");return!(!e||!e[0]||e[0].getState("removed"))},a.decideScroll=function(){var e=this.getScrollType();"always"===e||"smart"===e&&1!==this.getFromEnv("axis").getZoom()?this.enableScroll():this.disableScroll()},t}(o["default"]);t["default"]=x},464:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(465)),r=a(224),l=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a._spaceManager=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g,p,f=this.config,m=this.getChildren("xAxis")&&this.getChildren("xAxis")[0],b=f.legendposition?f.legendposition.split("-"):[],v=f.xDepth,x=f.yDepth,y=f.canvasBgDepth,C=f.canvasBaseDepth,k=f.canvasBasePadding,S=this.getChildren("canvas")[0],w=S.config.canvasBorderWidth,A=f.realTimeConfig&&f.realTimeConfig.showRTValue,L=f.borderWidth,N=f.canvasMarginTop,F=f.canvasMarginBottom,T=f.canvasMarginLeft,E=f.canvasMarginRight,P=f.minCanvasHeight,_=f.minCanvasWidth,D=f.minChartWidth,I=f.minChartHeight,M=f.height,O=f.width,R=!1,B=!1,V=f.origCanvasTopMargin,z=f.origCanvasBottomMargin,G=f.origCanvasLeftMargin,H=f.origCanvasRightMargin;f.canvasWidth-2*L<D&&(h=(f.canvasWidth-D)/2),f.canvasHeight-2*L<I&&(c=(f.canvasHeight-I)/2),this._allocateSpace({top:c||L,bottom:c||L,left:h||L,right:h||L}),this._manageYAxisSpace(),this._allocateSpace(this._manageActionBarSpace&&this._manageActionBarSpace(.225*f.availableHeight)||{}),this._manageLegendSpace&&f.showLegend&&this._manageLegendSpace(void 0),e=b[0]===r.POSITION_TOP||b[0]===r.POSITION_BOTTOM?.6*f.availableHeight:.6*f.availableWidth,x&&(this._allocateSpace({bottom:x}),f.shift=v+k+C),y&&this._allocateSpace({right:y}),f.canvasWidth-2*w<_&&(d=(f.canvasWidth-_)/2),this._allocateSpace({left:d||w,right:d||w}),_>O-T-E&&(B=!0,t=f.canvasWidth-_,p=T+E,T=f.canvasMarginLeft=t*T/p,E=f.canvasMarginRight=t*E/p),n=T>f.canvasLeft?T-f.canvasLeft:0,o=E>O-f.canvasRight?E+f.canvasRight-O:0,this._allocateSpace({left:n,right:o}),B&&(p=G+H,(s=f.canvasWidth)>_&&(n=(t=s-_)*G/p,o=t*H/p),this._allocateSpace({left:n,right:o})),f.actualCanvasMarginRight=o,f.actualCanvasMarginBottom=i,this._manageChartMenuBar(e),e=.2*f.availableHeight,this._getSumValueSpace?(f.sumValueSpace=this._getSumValueSpace(e),this._allocateSpace(f.sumValueSpace)):f.sumValueSpace={top:0,right:0},e=.3*f.availableHeight,f.realtimeEnabled&&(A?this._allocateSpace(this._realTimeValuePositioning(e)):this._hideRealTimeValue()),this._resetViewPortConfig&&this._resetViewPortConfig(),this._setAxisScale&&this._setAxisScale(),e=.6*f.availableHeight,m&&this._calculateChartShift("xAxis"),f.xAxisSpaceAllocation=g=m&&m.placeAxis(e),m&&this._allocateSpace(g),f.canvasHeight-2*w<P&&(u=(f.canvasHeight-P)/2),this._allocateSpace({top:u||w,bottom:u||w}),this._allocateSpace({bottom:C}),P>M-N-F&&(R=!0,t=f.canvasHeight-P,p=N+F,N=f.canvasMarginTop=t*N/p,F=f.canvasMarginBottom=t*F/p),a=N>f.canvasTop?N-f.canvasTop:0,i=F>M-f.canvasBottom?F+f.canvasBottom-M:0,this._allocateSpace({top:a,bottom:i}),R&&(p=V+z,(l=f.canvasHeight)>P&&(a=(t=l-P)*V/p,i=t*z/p),this._allocateSpace({top:a,bottom:i})),f.actualCanvasMarginTop=a,f.actualCanvasMarginLeft=n,S.setDimension({top:f.canvasTop,left:f.canvasLeft,width:f.canvasWidth,height:f.canvasHeight})},a._manageYAxisSpace=function(){var e,t,a,i=this.config,n=this.getChildren("yAxis"),o=[];for(t=0;t<(n&&n.length);t++)(e=n[t])&&this._calculateChartShift("yAxis"),a=e&&e.placeAxis(.7*i.availableWidth)||{},o.push({axisIndex:t,spaceTaken:a}),e&&this._allocateSpace(a);i.yAxisSpaceAllocation=o},a._postSpaceManagement=function(){var e,t=this.config,a=this.getChildren(),i=a.xAxis&&a.xAxis[0],n=a.legend&&a.legend[0],o=t.xDepth,r=this.getChildren("canvas");for(this.setAxisDimention&&this.setAxisDimention(),i&&this._allocateXAxisLabelSpace(i),i&&i.shiftLabels(-o,0),n&&n.postSpaceManager(),e=0;e<(r&&r.length);e++)r[e].setCanvasPadding();this.setAxisDimention&&this.setAxisDimention(),this.allocateDimensionOfChartMenuBar()},a._calculateChartShift=function(e){var t,a=this.getChildren("scrollBar")&&this.getChildren("scrollBar")[0],i=this.getChildren(e)&&this.getChildren(e)[0],n=a&&a.config,o=i.config.isVertical,r={};a&&!a.getState("removed")&&(t=a.getLogicalSpace())&&(o&&!n.isHorizontal?(this.config.shift=t.width+n.conf.padding,r[n.isOpposite?"right":"left"]=this.config.shift,this._allocateSpace(r)):!o&&n.isHorizontal&&(this.config.shift=t.height+n.conf.padding,r[n.isOpposite?"top":"bottom"]=this.config.shift,this._allocateSpace(r)))},t}(o["default"]);t["default"]=l},465:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t._drawDataset=O,t.configurer=R,t["default"]=void 0;var n=i(a(238)),o=i(a(276)),r=i(a(466)),l=i(a(469)),s=a(232),c=i(a(470)),h=a(363),u=i(a(472)),d=i(a(474)),g=i(a(476)),p=i(a(254)),f=a(231),m=i(a(478)),b=a(224),v=i(a(226)),x=["line","circle","square"],y=(0,s.getDep)("redraphael","plugin"),C="VML"===y.type,k=Math.max,S=Math.min,w=Math.round,A={datalabelclick:!0,connectorclick:!0,categoryclick:!0,processclick:!0,milestoneclick:!0,labelclick:!0,dataplotclick:!0},L=b.preDefStr.SEVENTYSTRING,N=b.preDefStr.AUTOSTRING,F="onpointerover"in window.document,T=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:e,container:t,state:"appearing",component:a,label:"group"})},E=function(e){var t=e.data.config;t._containerMouseState="mousedown",t._mdx1=e.clientX!==b.UNDEF?e.clientX:e.changedTouches&&e.changedTouches[0].clientX,t.mdy1=e.clientY!==b.UNDEF?e.clientY:e.changedTouches&&e.changedTouches[0].clientY,"touchstart"===e.type&&(t._touchStartedAt=(new Date).getTime())},P=function(e){var t=e.data.config,a=e.clientX!==b.UNDEF?e.clientX:e.changedTouches&&e.changedTouches[0].clientX,i=e.clientY!==b.UNDEF?e.clientY:e.changedTouches&&e.changedTouches[0].clientY;(Math.abs(t._mdx1-a)>=2.5||Math.abs(t.mdy1-i)>=2.5)&&(e.data.config._containerMouseState=b.UNDEF)},_=function(e){(new Date).getTime()-e.data.config._touchStartedAt<500&&setTimeout((function(){D(e)}))},D=function(e){var t,a=e.data,i=a.getFromEnv("chartInstance"),n=e.originalEvent,o=a.config,r=(0,b.getMouseCoordinate)(a.getFromEnv("chart-container"),n,a);i.ref&&"mousemove"!==o._containerMouseState&&(t=(0,b.extend2)({height:i.args.height,width:i.args.width,pixelHeight:a.getFromEnv("chartHeight"),pixelWidth:a.getFromEnv("chartWidth"),id:i.args.id,renderer:i.args.renderer,container:i.options.containerElement},r),a.fireChartInstanceEvent("chartclick",t),o.link&&(!o.hotElemClicked||o.clickURLOverridesPlotLinks)&&a.getFromEnv("linkClickFN").call({link:o.link}),o.hotElemClicked=!1)},I=function(e){var t=e.type,a=e.data,i=a.getFromEnv("eventListeners");if("mouseover"!==t&&"touchstart"!==t||!1!==a.config.mouseStateIn)"mouseout"!==t&&"touchend"!==t||(a.config.posOb=!1);else{if(B.hoverChart){var n=B.hoverChart;n.forceRollOut=!0,B.winMouseHover(n)}a.config.mouseStateIn=!0,B.onContainerRollOver(e),i.push(v["default"].listen(C?document:window,"mouseover",B.winMouseHover,a)),B.hoverChart=e}};function M(){var e,t,a,i,n=this,o=n,r=n.config,l="t"===r.toolbarVAlign?"chartMenuBar":"actionBar",s=n.getFromEnv("tool-config");e=n.getChildren(l)[0],t=r.printOption.enabled,a=o.config.realTimeConfig||{},i=e.attachChild(h.Hamburger,"tool","hamburgerMenu-"+e.getId()+"-"+n.getId()+"-0"),n.addToEnv("hamburger",i),i.configure(Object.assign({},s,{name:"ContextIcon"})),i._mouseOutEvent||(i._mouseOutEvent=function(){this.getChild("listContainer").hide()}),i._mouseOverEvent||(i._mouseOverEvent=function(){this.getChild("listContainer").show()}),i.addEventListener("fc-mouseover",i._mouseOverEvent),i.addEventListener("fc-mouseout",i._mouseOutEvent),t&&i.appendInMenu([{name:"Print",action:"click",handler:function(){n.getFromEnv("chartInstance").print()}}]),o._setRTmenu&&o._setRTmenu(a.showRTmenuItem,a.useMessageLog)}function O(){this.getChildren("canvas")[0]._mapChildren((function(e){e.syncDraw()}))}function R(e){this.config.skipConfigureIteration={},this.parseChartAttr(e),this.createComponent(e),this.setTooltipStyle(),this.configureChildren()}(0,s.addDep)({name:"commonAnimation",type:"animationRule",extension:m["default"]});var B=function(e){(0,n["default"])(a,e),a.getName=function(){return"CommonAPI"};var t=a.prototype;function a(){var t;return(t=e.call(this)||this).addToEnv("stringConstants",{COMPONENT:"component",CANVAS:"canvas",CAPTION:"caption"}),t.addToEnv("getMouseCoordinate",b.getMouseCoordinate),t._drawDataset=O,t.config.mouseStateIn=!1,t.registerFactory("toolbox",l["default"]),t.registerFactory("canvas",r["default"]),t._firstConfigure=!0,t}return t.plotEventHandler=function(e,t,a,i){void 0===t&&(t={});var n,o,r=t.type,l=a,s=(0,b.getMouseCoordinate)(this.getFromEnv("chart-container"),t,this),c=e&&e.data("eventArgs")||i,h=(0,b.extend2)(s,c),u=this.fireGroupEvent,d=e&&e.data("groupId"),g=function(e,a){t.FusionChartsPreventEvent=!0};"index"in h&&!("dataIndex"in h)&&(h.dataIndex=h.index),"value"in h&&!("dataValue"in h)&&(h.dataValue=h.value),"dataplotrollover"===(l=(0,b.pluck)(l,"dataplotclick").toLowerCase())?(t.FusionChartsPreventEvent=!1,u?(0,f.raiseEventGroup)(d,l,h,this.getFromEnv("chartInstance"),b.UNDEF,b.UNDEF,g):this.fireChartInstanceEvent(l,h,b.UNDEF,b.UNDEF,g)):u&&!A[l]?(0,f.raiseEventGroup)(d,l,h,this.getFromEnv("chartInstance")):this.fireChartInstanceEvent(l,h),"fc-click"!==r&&"click"!==r&&"mouseup"!==r&&"touchend"!==r||!/click/i.test(l)||(o=(n=this.getFromEnv())&&n.linkClickFN,h.link&&o&&o.call({link:h.link},!0))},t.getName=function(){return"Cartesian"},t.preConfigure=function(t){var a=this.getFromEnv("number-formatter");this.addToEnv("chart-attrib",t.chart),a?a.configure():this.addToEnv("number-formatter",new p["default"](this)),e.prototype.preConfigure.call(this,t)},t.postConfigure=function(t){e.prototype.postConfigure.call(this,t),this._firstConfigure=!1},t.setDefaults=function(){e.prototype.setDefaults.call(this);var t=this.getFromEnv("number-formatter");t&&t.setDefaults&&t.setDefaults()},t.getType=function(){return"chartAPI"},t.parseChartAttr=function(e){var t,a,i,n,o,r,l,s,c,h,u,d,p,f,m,v=e||this.getFromEnv("dataSource"),y=this.config.is3D,C=y?b.chartPaletteStr.chart3D:b.chartPaletteStr.chart2D,w=this.isBar,A=this.getFromEnv("color-manager");A||(A=new g["default"](this),this.addToEnv("color-manager",A)),v.chart=v.chart||v.graph||v.map||{},delete v.map,delete v.graph,!(t=v.chart)&&(t=v.chart={}),a=this.config||(this.config={}),(0,b.parseConfiguration)(t,a,{},{showvalues:!0,crosslinecolor:!0,drawcrosslineontop:!0,crosslinealpha:!0,drawcrossline:!0}),a.showValues=(0,b.pluckNumber)(t.showvalues,a.showvalues),a.viewPortConfig={scaleY:1,scaleX:1,x:0,y:0},this.addToEnv("tool-config",function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],n=t.slice(1);return n.forEach((function(e){for(var t in e)e.hasOwnProperty(t)&&e[t]!==b.UNDEF&&(i[t]=e[t])})),i}({},{scale:t.toolbarbuttonscale,width:t.toolbarbuttonwidth,height:t.toolbarbuttonheight,radius:t.toolbarbuttonradius,spacing:t.toolbarbuttonspacing,marginTop:t.toolbarbuttonmargintop,marginLeft:t.toolbarbuttonmarginleft,marginRight:t.toolbarbuttonmarginright,marginBottom:t.toolbarbuttonmarginbottom,fill:t.toolbarbuttoncolor,labelFill:t.toolbarlabelcolor,symbolFill:t.toolbarsymbolcolor,hoverFill:t.toolbarbuttonhovercolor,stroke:t.toolbarbuttonbordercolor,symbolStroke:t.toolbarsymbolbordercolor,strokeWidth:t.toolbarbuttonborderthickness,symbolStrokeWidth:t.toolbarsymbolborderthickness,bSymbolPadding:t.toolbarsymbolpadding,symbolHPadding:t.toolbarsymbolhpadding,symbolVPadding:t.toolbarsymbolvpadding,hAlign:t.toolbarhalign,vAlign:t.toolbarvalign})),y&&(w?(a.xDepth=5,a.yDepth=5):(a.xDepth=10,a.yDepth=10),a.showCanvasBase=m=Boolean((0,b.pluckNumber)(t.showcanvasbase,1)),a.canvasBasePadding=(0,b.pluckNumber)(t.canvasbasepadding,2),a.canvasBaseDepth=m?(0,b.pluckNumber)(t.canvasbasedepth,10):0,a.canvasBgDepth=(0,b.pluckNumber)(t.canvasbgdepth,3)),A&&A.configure(),a.placeAxisLabelsOnTop=(0,b.pluckNumber)(t.placexaxislabelsontop,0),a.enableAnimation=(0,b.pluckNumber)(t.animation,t.defaultanimation,1),a.showToolTip=(0,b.pluckNumber)(t.showtooltip,1),a.printOption={enabled:(0,b.pluckNumber)(t.printshowbutton,t.showprintmenuitem,0)},a.drawCrossLineOnTop=(0,b.pluckNumber)(t.drawcrosslineontop,1),s=a.style={},this.addToEnv("style",s),a.textDirection="1"===t.hasrtltext?"rtl":b.BLANKSTRING,s.inCanfontFamily=i=(0,b.pluck)(t.basefont,"Verdana,sans"),s.inCanfontSize=n=(0,b.pluckFontSize)(this.computeFontSize(t.basefontsize),10),s.inCanfontSizeWithUnit=o=(0,b.pluckFontSizeMaintainUnit)(t.basefontsize,10),s.inCancolor=r=(0,b.pluck)(t.basefontcolor,A.getColor(C.baseFontColor)),s.outCanfontFamily=(0,b.pluck)(t.outcnvbasefont,i),s.fontSize=l=(0,b.pluckFontSize)(this.computeFontSize(t.outcnvbasefontsize),n),s.fontSizeWithUnit=(0,b.pluckFontSizeMaintainUnit)(t.outcnvbasefontsize,o),s.outCanfontSize=l+b.PXSTRING,s.outCanfontSizeWithUnit=(0,b.pluckFontSizeMaintainUnit)(t.outcnvbasefontsize,o),s.outCancolor=(0,b.pluck)(t.outcnvbasefontcolor,r).replace(/^#? ([a-f0-9]+)/gi,"#$1"),s.baseFontSize=n,s.inCanfontSize=n+b.PXSTRING,s.inCancolor=r.replace(/^#? ([a-f0-9]+)/gi,"#$1"),s.inCanvasStyle=u={fontFamily:i,fontSize:n,fontSizeWithUnit:o,color:r},a.valueFontAlpha=(0,b.pluckNumber)(t.valuefontalpha,t.valuealpha,100),a.valueBgAlpha=(0,b.pluckNumber)(t.valuebgalpha,t.valuealpha,100),a.valueBorderAlpha=(0,b.pluckNumber)(t.valueborderalpha,t.valuealpha,100),a.valueFontColor=(0,b.pluck)(t.valuefontcolor,r),a.valueBgColor=(0,b.pluck)(t.valuebgcolor)||b.BLANKSTRING,s.inCanLineHeight=d=(0,b.setLineHeight)(u),f=(0,b.getFirstValue)(t.valuebordercolor,b.BLANKSTRING),f=a.valueBorderColor=f?(0,b.convertColor)(f,a.valueBorderAlpha):b.BLANKSTRING,a.reverseXAxis=this.config.allowreversexaxis&&(0,b.pluckNumber)(t.reversexaxis,0),a.showBorder=(0,b.pluckNumber)(t.showborder,a.showBorder,y?0:1),a.borderWidth=k(a.showBorder?(0,b.pluckNumber)(t.borderthickness,1):0,0),a.usePattern=(0,b.pluckNumber)(t.usepattern,a.usePattern),a.is3D&&(a.usePattern=0),a.patternType=x.includes(t.patterntype)?t.patterntype:a.patternType,a.patternDensity=(0,b.pluckNumber)(t.patterndensity,a.patternDensity),a.patternAlpha=(0,b.pluckNumber)(t.patternalpha,a.patternAlpha),a.patternBgColor=(0,b.pluck)(t.patternbgcolor,a.patternBgColor),a.useplotgradientcolor=(0,b.pluckNumber)(t.plotgradientcolor,a.useplotgradientcolor,0),a.useplotgradientcolor=a.usePattern?0:a.useplotgradientcolor,a.plotfillalpha=(0,b.pluck)(t.plotfillalpha,a.usePattern?b.HUNDREDSTRING:a.plotfillalpha),a.showplotborder=(0,b.pluckNumber)(t.showplotborder,a.usePattern?1:a.showplotborder),a.usePattern&&(a.showhovereffect=0,a.plothovereffect=0),a.valuefontbold=(0,b.pluckNumber)(t.valuefontbold,a.valuefontbold),a.dataLabelStyle=p={fontFamily:(0,b.pluck)(t.valuefont,i),fontSize:(0,b.pluck)(this.computeFontSize(t.valuefontsize),(0,b.pInt)(n,10))+b.PXSTRING,fontSizeWithUnit:(0,b.pluckFontSizeMaintainUnit)(t.valuefontsize,o),lineHeight:d,color:(0,b.convertColor)((0,b.pluck)(t.valuefontcolor,r),a.valueFontAlpha),fontWeight:a.valuefontbold?"bold":"normal",fontStyle:(0,b.pluckNumber)(t.valuefontitalic)?"italic":"normal",border:f||t.valuebgcolor?(0,b.pluckNumber)(t.valueborderthickness,1)+"px solid":b.BLANKSTRING,borderColor:f,borderThickness:(0,b.pluckNumber)(t.valueborderthickness,1),borderPadding:(0,b.pluckNumber)(t.valueborderpadding,2),borderRadius:(0,b.pluckNumber)(t.valueborderradius,0),backgroundColor:t.valuebgcolor?(0,b.convertColor)(t.valuebgcolor,a.valueBgAlpha):b.BLANKSTRING,borderDash:(0,b.pluckNumber)(t.valueborderdashed,0)?(0,b.getDashStyle)((0,b.pluckNumber)(t.valueborderdashlen,4),(0,b.pluckNumber)(t.valueborderdashgap,2)):b.DASH_DEF},(0,b.setLineHeight)(p),a.legendposition=(0,b.pluck)(t.legendposition,b.POSITION_BOTTOM),a.alignLegendWithCanvas=(0,b.pluckNumber)(t.alignlegendwithcanvas,1),a.origMarginTop=(0,b.pluckNumber)(t.charttopmargin,this.chartTopMargin,15),a.origMarginLeft=(0,b.pluckNumber)(t.chartleftmargin,this.chartLeftMargin,15),a.origMarginBottom=(0,b.pluckNumber)(t.chartbottommargin,this.chartBottomMargin,37),a.origMarginRight=(0,b.pluckNumber)(t.chartrightmargin,this.chartRightMargin,15),a.origCanvasLeftMargin=(0,b.pluckNumber)(t.canvasleftmargin,0),a.origCanvasRightMargin=(0,b.pluckNumber)(t.canvasrightmargin,0),a.origCanvasTopMargin=(0,b.pluckNumber)(t.canvastopmargin,0),a.origCanvasBottomMargin=(0,b.pluckNumber)(t.canvasbottommargin,0),a.minChartWidthPercent=(0,b.pluckNumber)(t.minchartwidth,this.minChartWidth,50)/100,a.minChartHeightPercent=(0,b.pluckNumber)(t.minchartheight,this.minChartHeight,50)/100,a.minCanvasWidthPercent=(0,b.pluckNumber)(t.mincanvaswidth,this.minCanvasWidth,60)/100,a.minCanvasHeightPercent=(0,b.pluckNumber)(t.mincanvasheight,this.minCanvasHeight,30)/100,c=(0,b.pluck)(t.zeroplanecolor,t.divlinecolor,A.getColor(C.divLineColor)),h=(0,b.pluck)(t.zeroplanealpha,t.divlinealpha,A.getColor("divLineAlpha")),a.zeroPlaneColor=(0,b.convertColor)(c,h),a.zeroPlaneBorderColor=(0,b.convertColor)((0,b.pluck)(t.zeroplanebordercolor,c),(0,b.pluckNumber)(t.zeroplaneshowborder,1)?h:0),a.zeroPlaneShowBorder=(0,b.pluckNumber)(t.zeroplaneshowborder,1),a.realtimeEnabled=(0,b.pluckNumber)(t.realtimeenabled,this.isRealTime),a.showLegend=(0,b.pluckNumber)(t.showlegend,this.showLegend,1),a.link=t.clickurl,a.transposeAxis=(0,b.pluckNumber)(this.transposeAxis,t.transposeaxis,0),a.useEllipsesWhenOverflow=(0,b.pluckNumber)(t.useellipseswhenoverflow,t.useellipsewhenoverflow,1),a.drawTrendRegion=(0,b.pluckNumber)(t.drawcrossline,0),a.plotcolorintooltip=(0,b.pluckNumber)(t.plotcolorintooltip,this.config.singleseries?0:1),a.plotbinsize=S((0,b.pluckNumber)(t.plotbinsize,this.plotbinsize,.5),1),a.labelbinsize=S((0,b.pluckNumber)(t.labelbinsize,1),1),a.labelbinsize=a.plotbinsize>a.labelbinsize?a.plotbinsize:a.labelbinsize,a.enableMouseOutEvent=(0,b.pluckNumber)(t.enablemouseoutevent,this.enableMouseOutEvent,1),a.plotSpacePercent=Math.max((0,b.pluckNumber)(t.plotspacepercent,this.plotSpacePercent),0),a.maxColWidth=Math.abs((0,b.pluckNumber)(t.maxcolwidth,50)),a.maxBarHeight=Math.abs((0,b.pluckNumber)(t.maxbarheight,50)),a.overlapColumns=(0,b.pluckNumber)(t.overlapcolumns,t.overlapbars,a.is3D?0:1),a.plotPaddingPercent=t.plotpaddingpercent,a.tooltipgrayoutcolor=(0,b.pluck)(t.tooltipgrayoutcolor,b.preDefStr.colors.AAAAAA),a.clickURLOverridesPlotLinks=(0,b.pluckNumber)(t.clickurloverridesplotlinks,0),a.toolbarX=(0,b.pluckNumber)(t.toolbarx),a.toolbarY=(0,b.pluckNumber)(t.toolbary),a.toolbarPosition=function(e){var t=e;switch(t){case"tr":case"rt":case"top right":case"right top":t="tr";break;case"br":case"rb":case"bottom right":case"right bottom":t="br";break;case"tl":case"lt":case"top left":case"left top":t="tl";break;case"bl":case"lb":case"bottom left":case"left bottom":t="bl";break;default:t="tr"}return t}((0,b.pluck)(t.toolbarposition,"tr").toLowerCase()),a.toolbarHAlign="left"===(b.BLANKSTRING+t.toolbarhalign).toLowerCase()?"l":a.toolbarPosition.charAt(1),a.toolbarVAlign="bottom"===(b.BLANKSTRING+t.toolbarvalign).toLowerCase()?"b":a.toolbarPosition.charAt(0),a.toolbarVMargin=(0,b.pluckNumber)(t.toolbarvmargin,6),a.toolbarHMargin=(0,b.pluckNumber)(t.toolbarhmargin,10),this.addToEnv("chartConfig",a),this.addToEnv("linkClickFN",(0,b.getLinkAction)(this.getFromEnv("dataSource"),this)),this.addToEnv("dataLabelStyle",p)},t.createComponent=function(){var e;e=this.config.skipConfigureIteration,this.createBaseComponent(),this.getFromEnv("animationManager").setAnimationState(this._firstConfigure?"initial":"update"),(0,b.componentFactory)(this,c["default"],"caption"),e.caption=!0,(0,b.componentFactory)(this,u["default"],"subCaption"),e.subCaption=!0,(0,b.componentFactory)(this,d["default"],"background"),e.background=!0,this._createConfigurableComponents&&this._createConfigurableComponents(),this.config.realtimeEnabled&&this._realTimeConfigure&&this._realTimeConfigure()},t.configureChildren=function(){var e=this;e._mapChildren((function(t){!t.getState("removed")&&e.config.skipConfigureIteration[t.getName()]&&t.configure&&t.configure()}))},t.attachMenuButtons=function(){M.call(this)},t.configureAttributes=function(e){R.call(this,e)},t.setTooltipStyle=function(){var e=this.config;this.getFromEnv("toolTipController").setStyle({backgroundColor:b.hasSVG?(0,b.convertColor)(e.tooltipbgcolor||"FFF",e.tooltipbgalpha||100):(e.tooltipbgcolor||"FFF").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),color:(e.tooltipcolor||e.basefontcolor||"545454").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),borderColor:b.hasSVG?(0,b.convertColor)(e.tooltipbordercolor||"666",e.tooltipborderalpha||100):(e.tooltipbordercolor||"666").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),borderWidth:(0,b.pluckNumber)(e.tooltipborderthickness,1)+"px",showToolTipShadow:(0,b.pluckNumber)(e.showtooltipshadow,e.showshadow,1),borderRadius:(0,b.pluckNumber)(e.tooltipborderradius,0)+"px",fontSize:(0,b.pluckNumber)(this.computeFontSize(e.basefontsize),10)+"px",fontFamily:e.basefont||this.getFromEnv("style").inCanfontFamily,padding:(0,b.pluckNumber)(e.tooltippadding||3)+"px"})},t.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.valuefontbold=0,t.stickytracking=1,t.usemessagelog=0,t.zeroplanethickness=b.UNDEF,t.animationeffect="linear",t.showshadow=1,t.showhovereffect=b.UNDEF,t.plothovereffect=b.UNDEF,t.anchorhovereffect=b.UNDEF,t.plotborderdashed=b.UNDEF,t.stack100percent=b.UNDEF,t.showpercentvalues=b.UNDEF,t.showpercentintooltip=b.UNDEF,t.plotbordercolor=b.UNDEF,t.showtooltip=1,t.seriesnameintooltip=1,t.rotatevalues=0,t.minimizetendency=0,t.plotfillangle=270,t.valuepadding=2,t.useplotgradientcolor=1,t.plotborderthickness=1,t.plotfillalpha=L,t.showvalues=1,t.valueposition=N,t.drawcrossline=b.UNDEF,t.tooltipsepchar=", ",t.usedataplotcolorforlabels=0,t.placevaluesinside=0,t.showplotborder=1,t.use3dlighting=1,t.useroundedges=0,t.plotspacepercent=20,t.plotpaddingpercent=b.UNDEF,t.plotfillratio=b.UNDEF,t.maxcolwidth=50,t.plotborderdashlen=5,t.plotborderdashgap=4,t.useScaleRecursively=!0,t.formatnumberscale=1,t.decimals=2,t.decimalprecision=10,t.tooltipbgcolor="FFF",t.tooltipcolor=b.UNDEF,t.tooltipbordercolor="666",t.tooltipbgalpha=100,t.tooltipborderthickness=1,t.showtooltipshadow=b.UNDEF,t.basefontsize=10,t.basefont="Verdana, sans",t.tooltipborderradius=0,t.tooltippadding=3,t.tooltipborderalpha=100,t.origw=b.UNDEF,t.origh=b.UNDEF,t.showBorder=b.UNDEF,t.usePattern=0,t.patternType=x[0],t.patternDensity=6,t.patternAlpha=100,t.patternBgColor=b.TRACKER_FILL},t.configure=function(t){var a=t;this.sanitizeData(a),this.addToEnv("dataSource",a),this.fireEvent("internal.dataSanitized",{}),a=this.getFromEnv("dataSource"),e.prototype.configure.call(this,a)},t._checkInvalidData=function(){var e=this.getFromEnv("dataSource"),t=this.getFromEnv("chartInstance");if(!(this.isWidget||this.isMap||e.data&&0!==e.data.length||e.dataset||e.value||e.lineset||e.annotations||e.category||e.tasks||e.process||e.axis))return t.__state.dataReady=!1,t.jsVars.hasNativeMessage=!0,t.jsVars.drawCount+=1,!0},t._checkInvalidSpecificData=function(){var e=this.getFromEnv("dataSource"),t=e.dataset,a=e.categories;if(!t||!a||0===a.length||!a[0].category)return!0},t.sanitizeData=function(e){e.chart=e.chart||e.graph||e.map||{}},t.setChartEvents=function(){var e=this.getFromEnv("eventListeners"),t=this.getFromEnv("dataSource"),i=t&&t.chart,n=this.getFromEnv("paper")&&this.getFromEnv("paper").canvas,o=this.getFromEnv("chart-container"),r=i&&(0,b.pluckNumber)(i.enablechartmousemoveevent,0);(i||n)&&(v["default"].unlisten(o,F?"click":"touchend",F?D:_),e.push(v["default"].listen(o,"mousedown touchstart",E,this)),e.push(v["default"].listen(o,"mousemove touchmove",P,this)),e.push(v["default"].listen(o,F?"click":"touchend",F?D:_,this)),v["default"].unlisten(n,"mouseover",I,this),v["default"].unlisten(n,"touchstart",I,this),v["default"].unlisten(n,"mouseout",I,this),v["default"].unlisten(n,"touchend",I,this),e.push(v["default"].listen(n,"mouseover touchstart mouseout touchend",I,this)),v["default"].unlisten(o,"mousemove",a.onContainerMouseMove,this),v["default"].unlisten(o,"touchmove",a.onContainerMouseMove,this),r&&e.push(v["default"].listen(o,"mousemove touchmove",a.onContainerMouseMove,this)))},t.get=function(e,t){var a=this[e];return t?a&&a[t]:a},t.prepareAttributes=function(){this.config.hasChartMessage||e.prototype.prepareAttributes.call(this)},t.disposeChartStyleSheet=function(){var e=this.getFromEnv("paper");e&&e.cssClear()},t.createChartStyleSheet=function(){this.getFromEnv("paper").cssRender()},t._dispose=function(){var t=this.getFromEnv("eventListeners"),i=t&&t.length;for(a.hoverChart=b.UNDEF;i--;)t[i].unlisten();e.prototype._dispose.call(this)},t._allocateSpace=function(e){var t,a,i=this.getChildren("canvas"),n=i&&i[0].config,o=this.config,r=o.canvasHeight,l=o.canvasWidth,s=o.availableHeight,c=o.availableWidth;a=o.canvasLeft+=e.left||0,t=o.canvasTop+=e.top||0,l=o.canvasWidth=k(l-((e.left||0)+(e.right||0)),0),r=o.canvasHeight=k(r-((e.top||0)+(e.bottom||0)),0),o.availableHeight=k(s-((e.top||0)+(e.bottom||0)),0),o.availableWidth=k(c-((e.left||0)+(e.right||0)),0),o.canvasRight=a+l,o.canvasBottom=t+r,n&&(n.canvasPaddingLeft=k(n.canvasPaddingLeft,e.paddingLeft||0),n.canvasPaddingRight=k(n.canvasPaddingRight,e.paddingRight||0),n.canvasPaddingTop=k(n.canvasPaddingTop,e.paddingTop||0),n.canvasPaddingBottom=k(n.canvasPaddingBottom,e.paddingBottom||0)),i&&i[0].setDimension({top:t,left:a,width:l,height:r})},t._fetchCaptionPos=function(e){var t=this.config,a=t.width,i=this.getChildren("chartMenuBar")&&this.getChildren("chartMenuBar")[0],n=(i?i.getLogicalSpace():{}).width||0,o=(this.getChildren("caption")&&this.getChildren("caption")[0]).config,r=o.width,l="l"===t.toolbarHAlign,s=t.width-e,c=l?e:s,h=t.origMarginRight,u=t.origMarginLeft,d=l?u:h;return o.align===b.POSITION_MIDDLE?c-r/2-d-n:"start"===o.align?l?-1:a-t.canvasLeft-d-r-n+o.horizontalPadding:l?a-(h+u+n+r):-1},t._manageCaptionSpacing=function(e,t){return this.getChildren("caption")[0].manageSpace(e,t)},t._manageChartMenuBar=function(e){var t,a,i,n=this.config,o=this.getChildren("chartMenuBar")&&this.getChildren("chartMenuBar")[0],r=n.toolbarY!==b.UNDEF,l=o?o.getLogicalSpace():{height:0,width:0},s=(this.getChildren("caption")&&this.getChildren("caption")[0]).config,c=s.isOnTop,h=n.width/2,u=n.canvasRight,d=this.getFromEnv("gLegend")||{},g=!!(d.conf||{}).showLegend,p=0,f=u?(n.canvasLeft+u)/2:h,m=0,v=s.alignWithCanvas?f:h;return r&&(l.height=0),o&&o.setDimension({x:n.toolbarX!==b.UNDEF?n.toolbarX:(0,b.pluckNumber)("l"===n.toolbarHAlign?0:+n.width),y:n.toolbarY!==b.UNDEF?n.toolbarY:(0,b.pluckNumber)("t"===n.toolbarVAlign?0:+n.height),width:l.width,height:l.height}),delete s._offsetHeight,i=s.alignWithCanvas?n.canvasWidth:n.width-n.origMarginLeft-n.origMarginRight,c?(t=this._manageCaptionSpacing(e,i),m=this._fetchCaptionPos(v),s._offsetHeight=m<0?l.height:0,t.top=m<0?(0,b.pluckNumber)(t.top,0)+l.height:k(t.top,l.height),this._allocateSpace(t)):(this._allocateSpace({top:l.height}),t=this._manageCaptionSpacing(e,i),this._allocateSpace(t)),g&&this.config.gLegendEnabled&&(p=d.getCalculatedLogicalSpace().width-d.getLogicalSpace().width,"left"===(a=d.conf.legendPosition?d.conf.legendPosition.split("-"):[])[0]?this._allocateSpace({left:-p}):"right"===a[0]&&this._allocateSpace({right:-p})),{top:l?k(l.height,t.top):t.top,bottom:t.bottom}},t._manageSpace=function(){var e,t,a,i,n,o,r,l,s,c,h,u,d=this.getChildren("canvas")&&this.getChildren("canvas")[0],g=d&&d.config,p=this.config,f=this.getFromEnv("chartWidth"),m=this.getFromEnv("chartHeight");p.width=f,p.height=m,p.minChartHeight=s=p.minChartHeightPercent*m,p.minChartWidth=c=p.minChartWidthPercent*f,p.minCanvasWidth=e=p.minCanvasWidthPercent*c,p.minCanvasHeight=t=p.minCanvasHeightPercent*s,p.marginTop=a=p.origMarginTop,p.marginLeft=i=p.origMarginLeft,p.marginBottom=n=p.origMarginBottom,p.marginRight=o=p.origMarginRight,p.canvasMarginTop=p.origCanvasTopMargin,p.canvasMarginLeft=p.origCanvasLeftMargin,p.canvasMarginBottom=p.origCanvasBottomMargin,p.canvasMarginRight=p.origCanvasRightMargin,p.canvasHeight=r=p.height-p.marginTop-p.marginBottom,p.canvasWidth=l=p.width-p.marginLeft-p.marginRight,p.availableHeight=r-t,p.availableWidth=l-e,r<s&&(h=m-s,p.canvasHeight=s,u=a+n,p.marginTop=h*a/u,p.marginBottom=h*n/u,p.availableHeight=s-t),l<c&&(h=f-c,u=o+i,p.canvasWidth=c,p.marginLeft=h*i/u,p.marginRight=h*o/u,p.availableWidth=c-e),p.canvasLeft=p.marginLeft,p.canvasTop=p.marginTop,g&&(g.canvasPaddingLeft=S(g.origCanvasLeftPad,w(.1*p.height)),g.canvasPaddingRight=S(g.origCanvasRightPad,w(.1*p.height)),g.canvasPaddingTop=S(g.origCanvasTopPad,w(.1*p.height)),g.canvasPaddingBottom=S(g.origCanvasBottomPad,w(.1*p.height))),this._spaceManager()},t._preDraw=function(){this._mapChildren((function(e){e.getState("removed")||e.preDraw&&e.preDraw()})),this._setAxisLimits&&this._setAxisLimits(),this._createToolBoxGantt&&this._createToolBoxGantt()},t._clearTimers=function(){var e,t=this.config&&this.config.realTimeConfig,a=this.config.timers,i=a&&a.setTimeout,n=a&&a.setInterval;for(e in t&&(t.refreshIntervalFlag=!1),i)clearTimeout(i[e]);for(e in n)clearInterval(n[e])},t.setChartCursor=function(){var e=this.config.link,t=this.getFromEnv("paper").canvas.style;y.svg?t.cursor=e?b.POINTER:"default":this.getFromEnv("paper").canvas.style.cursor=e?b.HAND:"default"},t._createLayers=function(){var e,t=this.getFromEnv("animationManager");e=this.getContainer("parentgroup")||this.addContainer("parentgroup",t.setAnimation({el:"group",attr:{name:"parentgroup"},component:this})),!this.getChildContainer("backgroundGroup")&&this.addChildContainer("backgroundGroup",T({name:"background"},e,this)),!this.getChildContainer("axisBottomGroup")&&this.addChildContainer("axisBottomGroup",T({name:"axisbottom"},e,this)),!this.getChildContainer("belowPlotGroup")&&this.addChildContainer("belowPlotGroup",T({name:"belowplot"},e,this)),!this.getChildContainer("plotGroup")&&this.addChildContainer("plotGroup",T({name:"plots"},e,this)),!this.getChildContainer("scrollbarContainer")&&this.addChildContainer("scrollbarContainer",T({name:"scrollbar-container"},e,this)),!this.getChildContainer("axisTopGroup")&&this.addChildContainer("axisTopGroup",T({name:"axistop"},e,this)),!this.getChildContainer("sumLabelsLayer")&&this.addChildContainer("sumLabelsLayer",T({name:"sumlabels","class":"fusioncharts-datalabels"},e,this)),!this.getChildContainer("datalabelsGroup")&&this.addChildContainer("datalabelsGroup",T({name:"datalabel"},e,this)),!this.getChildContainer("abovePlotGroup")&&this.addChildContainer("abovePlotGroup",T({name:"aboveplot"},e,this)),!this.getChildContainer("captionGroup")&&this.addChildContainer("captionGroup",T({name:"caption"},e,this)),!this.getChildContainer("defaultGroup")&&this.addChildContainer("defaultGroup",T({name:"chartdefault"},e,this)),!this.getChildContainer("defaultShadowGroup")&&this.addChildContainer("defaultShadowGroup",T({name:"chartdefault-shadow"},e,this)),!this.getChildContainer("trackerGroup")&&this.addChildContainer("trackerGroup",T({name:"tracker"},e,this)),!this.getChildContainer("logoGroup")&&this.addChildContainer("logoGroup",T({name:"logo"},e,this)),!this.getChildContainer("selectorGroup")&&this.addChildContainer("selectorGroup",T({name:"selectorGroup"},e,this)),this.getChildren("legend")!==b.UNDEF&&!this.getChildContainer("legendGroup")&&this.addChildContainer("legendGroup",T({name:"legend"},e,this)),!this.getChildContainer("toolbar-master")&&this.addChildContainer("toolbar-master",T({name:"toolbar-master"},e,this))},t._setDataLabelStyle=function(){var e=this.config.dataLabelStyle,t={fontFamily:e.fontFamily,fontSize:e.fontSize,fontWeight:e.fontWeight,fontStyle:e.fontStyle};this.getChildContainer("datalabelsGroup").css(t)},t._manageCaptionPosition=function(){var e,t,a,i=this.config,n=this.getChildren(),o=n.caption&&n.caption[0],r=n.subCaption&&n.subCaption[0],l=o.config,s=l.widgetValueHeight||0,c=r.config,h=i.canvasWidth,u=l.align,d=l.text,g=l.alignWithCanvas,p=l.horizontalPadding,f=i.width,m=i.canvasLeft,v=i.canvasRight,x=i.marginRight,y=i.marginLeft,C=i.marginTop,k=(w(m)||0)+(0,b.pluckNumber)(h,f)/2,S=l.height,A=c.height,L=n.legend&&n.legend[0]&&n.legend[0].config||{},N=L.height||0,F=L.legendPadding||0,T=i.legendposition?i.legendposition.toLowerCase().split("-"):[],E=this.getFromEnv("gLegend")||{},P=0,_=!!(E.conf||{}).showLegend,D=this.config.borderWidth,I=n.actionBar,M=0;switch(L.isActive||(N=0),_&&this.config.gLegendEnabled&&(P=E.getCalculatedLogicalSpace().height),u){case"end":e=g?v-p:f-p;break;case"start":e=g?m+p:p;break;default:e=g?k:y+.5*(f-y-x)||f/2}l.isOnTop?t=(D||0)+(C||0):("left"!==T[0]&&"right"!==T[0]&&"top"!==T[0]&&"absolute"!==T[0]||(F=0,N=0,P=0),I&&I.length&&((M=(I[0].getLogicalSpace&&I[0].getLogicalSpace()||{}).height)===b.UNDEF||M===Infinity||M<0)&&(M=0),t=this.config.height-this.config.marginBottom-S-(A||0)-(D||0)-(F||0)-(N||0)-P-s-M),t+=l._offsetHeight||0,o.setDimention({x:e,y:t}),a=d?t+S+2:t||C||0,r.setDimention({x:e,y:a})},t.resizeCanvas=function(){var e=this.getFromEnv("paper"),t=this.config,a=this.getFromEnv("animationManager"),i=this.getFromEnv("chartWidth"),n=this.getFromEnv("chartHeight");b.hasSVG||!t._prevWidth&&!t._prevHeight||e.setSize(t._prevWidth,t._prevHeight),a.setAnimation({el:e,attr:{width:i,height:n},component:this})},t._updateVisuals=function(){var e=this.getFromEnv("core-options"),t=this.getFromEnv("paper"),a=this.config,i=this.getFromEnv("chartWidth"),n=this.getFromEnv("chartHeight");e&&!e._SVGDefinitionURLUpdated&&(/^\s*absolute\s*$/i.test(e.SVGDefinitionURL)&&(y._url=(y._g&&y._g.win||window).location.href.replace(/#.*?$/,b.BLANKSTRING)),e._SVGDefinitionURLUpdated=!0),t?this.resizeCanvas():((t=new y(this.getFromEnv("chart-container"),i,n)).setHTMLClassName("fusioncharts-div"),this.addToEnv("paper",t),t.setConfig("stroke-linecap",b.ROUND),this.setChartEvents()),a._prevWidth=i,a._prevHeight=n,this.setChartCursor(),this._createLayers(),this._setDataLabelStyle()},t.allocateDimensionOfChartMenuBar=function(){var e=this.config,t=this.getFromEnv("toolbar"),a=t.config,i=a.hDirection,n=a.vDirection,o=t.getLogicalSpace(),r=t.getDimension(),l=r.y,s=r.x;"t"===e.toolbarVAlign?(l+=e.toolbarVMargin*n+S(0,o.height*n),s+=e.toolbarHMargin*i-k(0,o.width*i),s="l"===e.toolbarHAlign?s+o.width:s-o.width):(l=e.height-e.marginBottom-o.height,s="b"===e.toolbarVAlign&&"r"===e.toolbarHAlign?e.width-e.marginRight-o.width:e.marginLeft),e.toolbarX!==b.UNDEF&&(s=e.toolbarX),e.toolbarY!==b.UNDEF&&(l=e.toolbarY),t.setDimension({x:s,y:l,width:o.width,height:o.height}),t.manageSpace()},t.draw=function(){var e=this.getFromEnv("chartInstance");this.config.hasChartMessage?(this._hide(),this.resizeCanvas(),this.drawChartMessage(),this.fireChartInstanceEvent("nodatatodisplay",{},[e.id]),e.jsVars.drawCount+=1,e.__state.dataReady=!1,e.jsVars.hasNativeMessage=!0):(this._hideChartMessage(),this._clearTimers&&this._clearTimers(),this.config.plotOverFlow=!1,this._show(),this._updateVisuals(),this.setState("initiated",!0),e.jsVars.drawCount+=1,e.jsVars.hasNativeMessage=!1)},t.manageSpace=function(){var e,t,a,i=this.config,n=i.style,o=i.dataLabelStyle;i.hasChartMessage?this.getChildren("chartMessage")[0].manageSpace():(n.inCanfontSize=t=this.computeFontSize(n.inCanfontSizeWithUnit),n.fontSize=e=this.computeFontSize(n.fontSizeWithUnit),n.outCanfontSize=e+b.PXSTRING,n.baseFontSize=t,n.inCanfontSize=t+b.PXSTRING,n.inCanvasStyle.fontSize=t,n.inCanLineHeight=a=(0,b.setLineHeight)(n.inCanvasStyle),o.fontSize=this.computeFontSize(o.fontSizeWithUnit)+b.PXSTRING,o.lineHeight=a,(0,b.setLineHeight)(o),this.setTooltipStyle(),this._preDraw(),this.addToolbar&&this.addToolbar(),this._manageSpace(),this._postSpaceManagement&&this._postSpaceManagement())},t._show=function(){this.getContainer("parentgroup")&&this.getContainer("parentgroup").show()},t._manageActionBarSpace=function(){var e=this.config,t=this.getChildren("actionBar"),a=(t&&t[0]&&t[0].getLogicalSpace()||{}).height||0;return e.actionBarHeight=a,{bottom:a}},t._hide=function(){this.getContainer("parentgroup")&&this.getContainer("parentgroup").hide()},a.onContainerMouseMove=function(e){var t,a=e.data,i=a.getFromEnv("chartInstance"),n=e.originalEvent,o=(0,b.getMouseCoordinate)(a.getFromEnv("chart-container"),n,a);i.ref&&(t=(0,b.extend2)({height:i.args.height,width:i.args.width,pixelHeight:a.getFromEnv("chartHeight"),pixelWidth:a.getFromEnv("chartWidth"),id:i.args.id,renderer:i.args.renderer,container:i.options.containerElement},o),a.fireChartInstanceEvent("chartMouseMove",t))},a.onContainerRollOver=function(e){var t,a=e.data,i=a.getFromEnv("chartInstance"),n=e.originalEvent,o=(0,b.getMouseCoordinate)(a.getFromEnv("chart-container"),n,a);i.ref&&(t=(0,b.extend2)({height:i.args.height,width:i.args.width,pixelHeight:a.getFromEnv("chartHeight"),pixelWidth:a.getFromEnv("chartWidth"),id:i.args.id,renderer:i.args.renderer,container:i.options.containerElement},o),a.fireChartInstanceEvent("chartRollOver",t))},a.onContainerRollOut=function(e){var t,a=e.chart,i=a.getFromEnv("chartInstance"),n=e.event,o=(0,b.getMouseCoordinate)(a.getFromEnv("chart-container"),n,a);i.ref&&(t=(0,b.extend2)({height:i.args.height,width:i.args.width,pixelHeight:a.getFromEnv("chartHeight"),pixelWidth:a.getFromEnv("chartWidth"),id:i.args.id,renderer:i.args.renderer,container:i.options.containerElement},o),a.fireChartInstanceEvent("chartRollOut",t))},a.winMouseHover=function(e){var t=e.originalEvent,i=t.target||t.originalTarget||t.srcElement||t.relatedTarget||t.fromElement,n=e.data,o=n.getFromEnv("paper"),r={chart:n,event:e.originalEvent};C?o.getById(i.parentNode.raphaelid)||(a.onContainerRollOut(r),n.config.mouseStateIn=!1,v["default"].unlisten(document,"mouseover",a.winMouseHover)):i.viewportElement&&!e.forceRollOut||(n.config.mouseStateIn=!1,a.onContainerRollOut(r),a.hoverChart=b.UNDEF,v["default"].unlisten(window,"mouseover",a.winMouseHover),e.forceRollOut=!1)},a}(o["default"]);B.hoverChart=void 0;var V=B;t["default"]=V},466:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t;(0,o.componentFactory)(e,n["default"],"canvas",e.config.showVolumeChart?2:1),t=e.getChildren("canvas");for(var a=0,i=t.length;a<i;a++)t[a].configure()};var n=i(a(467)),o=a(224)},467:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(242)),o=i(a(238)),r=a(240),l=a(224),s=a(232),c=i(a(468)),h=Math.max,u=l.preDefStr.miterStr,d=l.preDefStr.noneStr,g=l.preDefStr.ROUND,p=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:e},container:t,component:a,label:"group"})};(0,s.addDep)({name:"canvasAnimation",type:"animationRule",extension:c["default"]});var f=function(e){function t(){var t;t=e.call(this)||this;var a=(0,n["default"])(t);return a.config={},a.config.axes=a.config.axes||[],a.setLinkedItem("axes",[]),a.setLinkedItem("primaryAxis",{}),a.addToEnv("canvasConfig",t.config),t}(0,o["default"])(t,e);var a=t.prototype;return a.getName=function(){return"canvas"},a.getType=function(){return"canvas"},a.createGroup=function(){var e=this.config,t=this.getFromEnv("chart"),a=t.getChildContainer(),i=t.getContainer("parentgroup"),n=this.getEffectiveDimensions(),o=this.getFromEnv("chart-attrib"),r=(0,l.pluckNumber)(o.areaovercolumns,1),s=this.getChildContainer("axisReferenceVisualsFloor"),c=this.getChildContainer("axisReferenceVisualsBottom"),h=this.getChildContainer("axisReferenceVisualsMiddle"),u=this.getChildContainer("axisReferenceVisualsTop"),d=this.getChildContainer("axisReferenceVisualsCeil"),g=this.getChildContainer("areaGroup"),f=this.getChildContainer("areaShadowGroup"),m=this.getChildContainer("columnGroup"),b=this.getChildContainer("columnShadowGroup"),v=a.plotGroup,x=[n.left,n.top,n.width,n.height].toString();!this.getContainer("canvasGroup")&&this.addContainer("canvasGroup",p("canvas",i,this)).insertAfter(a.backgroundGroup),c||(c=this.addChildContainer("axisReferenceVisualsBottom",p("axisReferenceVisualsBottom",i,this)).insertAfter(a.axisBottomGroup)),c.attr({"clip-rect":e.canvasBorderWidth>0?x:null}),s||(s=this.addChildContainer("axisReferenceVisualsFloor",p("axisReferenceVisualsFloor",i,this)).insertAfter(a.axisBottomGroup)),s.attr({"clip-rect":x}),!this.getChildContainer("crossline")&&this.addChildContainer("crossline",p("crossline",i,this)).insertBefore(a.plotGroup),!this.getChildContainer("crosslineBottom")&&this.addChildContainer("crosslineBottom",p("crosslineBottom",i,this)).insertBefore(a.plotGroup),!this.getChildContainer("crosslineTop")&&this.addChildContainer("crosslineTop",p("crosslineTop",i,this)).insertBefore(a.abovePlotGroup),!this.getChildContainer("datalabelsGroup")&&this.addChildContainer("datalabelsGroup",p("canvasdatalabel",t.getChildContainer("datalabelsGroup"),this)),h||(h=this.addChildContainer("axisReferenceVisualsMiddle",p("axisReferenceVisualsMiddle",i,this)).insertBefore(a.plotGroup)),h.attr({"clip-rect":x}),u||(u=this.addChildContainer("axisReferenceVisualsTop",p("axisReferenceVisualsTop",i,this)).insertBefore(a.datalabelsGroup)),!this.getChildContainer("quadrantGroup")&&this.addChildContainer("quadrantGroup",p("quadrant",i,this)).insertAfter(h),d||this.addChildContainer("axisReferenceVisualsCeil",p("axisReferenceVisualsCeil",i,this)).insertBefore(a.datalabelsGroup),!this.getChildContainer("sumLabelsLayer")&&this.addChildContainer("sumLabelsLayer",a.sumLabelsLayer),b||(b=this.addChildContainer("columnShadowGroup",p("column-shadow-group",v,this))),m||(m=this.addChildContainer("columnGroup",p("column",v,this))),f||(f=this.addChildContainer("areaShadowGroup",p("area-shadow-group",v,this))),g||(g=this.addChildContainer("areaGroup",p("area",v,this))),r?(b.insertBefore(f),m.insertBefore(f)):(f.insertBefore(b),g.insertBefore(b)),!this.getChildContainer("lineShadowGroup")&&this.addChildContainer("lineShadowGroup",p("line-shadow-group",v,this)),!this.getChildContainer("lineGroup")&&this.addChildContainer("lineGroup",p("line",v,this)),!this.getChildContainer("defaultShadowGroup")&&this.addChildContainer("defaultShadowGroup",p("default-shadow-group",v,this)),!this.getChildContainer("defaultGroup")&&this.addChildContainer("defaultGroup",p("default",v,this))},a.isWithinCanvas=function(e,t){var a=this.config,i=a.canvasLeft,n=i+a.canvasWidth,o=a.canvasTop,r=o+a.canvasHeight;return e>=i&&e<=n&&t>=o&&t<=r},a.setCanvasPadding=function(){var e,t=this.config;e=this.getCanvasPadding(),t.canvasPaddingLeft=h(t.canvasPaddingLeft,e.paddingLeft||0),t.canvasPaddingRight=h(t.canvasPaddingRight,e.paddingRight||0),t.canvasPaddingTop=h(t.canvasPaddingTop,e.paddingTop||0),t.canvasPaddingBottom=h(t.canvasPaddingBottom,e.paddingBottom||0)},a.getEffectiveDimensions=function(){var e=this.config;return{left:e.canvasLeft,top:e.canvasTop,width:e.canvasWidth,height:e.canvasHeight,paddingLeft:e.canvasPaddingLeft,paddingTop:e.canvasPaddingTop,paddingRight:e.canvasPaddingRight,paddingBottom:e.canvasPaddingBottom}},a.setDimension=function(e){var t=this.config;t.canvasTop=e.top,t.canvasLeft=e.left,t.canvasWidth=e.width,t.canvasHeight=e.height},a.getCanvasPadding=function(){var e,t,a,i,n=this.getFromEnv("chartConfig").canvasWidth,o=this.config.maxPaddingPercent*n/100,r={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0};return this._mapChildren((function(a){for(t in e=a.getCanvasPadding&&a.getCanvasPadding()||{})e.hasOwnProperty(t)&&(r[t]=h(e[t],r[t]))})),a=r.paddingLeft||0,i=r.paddingRight||0,o<a&&(r.paddingLeft=o),o<i&&(r.paddingRight=o),r},a.configureAttributes=function(e){void 0===e&&(e={});var t,a,i,n,o,r=this.getLinkedParent(),s=this.getFromEnv("chartConfig"),c=this.config,u=this.getFromEnv("chart-attrib"),d=this.getFromEnv("color-manager"),g=s.is3D,p=g?l.chartPaletteStr.chart3D:l.chartPaletteStr.chart2D,f=c.isRoundEdges=(0,l.pluckNumber)(u.useroundedges,0),m=(0,l.pluckNumber)(u.showxaxisline,u.showyaxisline,u.showaxislines,0)?0:1;c.canvasBorderRadius=(0,l.pluckNumber)(u.plotborderradius,f?2:0),i=c.showCanvasBorder=Boolean((0,l.pluckNumber)(u.showcanvasborder,m,t,f?0:1)),o=c.oriCanvasBorderThickness=h((0,l.pluckNumber)(u.canvasborderthickness,f?0:(0,l.pluckNumber)(r.config.canvasborderthickness,2),0)),t=c.canvasBorderWidth=g?0:i?o:0,c.canvasBorderColor=(0,l.convertColor)((0,l.pluck)(u.canvasbordercolor,d.getColor(l.canvasBorderColorStr)),(0,l.pluck)(u.canvasborderalpha,d.getColor("canvasBorderAlpha"))),a=c.canBGAlpha=(0,l.pluck)(u.canvasbgalpha,d.getColor(l.canvasBGAlphaStr)),c.canBGColor={FCcolor:{color:(0,l.pluck)(u.canvasbgcolor,d.getColor(p.canvasBgColor)),alpha:(0,l.pluck)(u.canvasbgalpha,100),angle:(0,l.pluck)(u.canvasbgangle,0),ratio:(0,l.pluck)(u.canvasbgratio)}},n=c.shadow=(0,l.pluckNumber)(u.showshadow,f,0)&&f?{enabled:!0,opacity:a/100}:0,c.shadowOnCanvasFill=n&&n.enabled,c.canvasPadding=(0,l.pluckNumber)(u.canvaspadding,0),c.origCanvasTopPad=(0,l.pluckNumber)(u.canvastoppadding,0),c.origCanvasBottomPad=(0,l.pluckNumber)(u.canvasbottompadding,0),c.origCanvasLeftPad=(0,l.pluckNumber)(u.canvasleftpadding,0),c.origCanvasRightPad=(0,l.pluckNumber)(u.canvasrightpadding,0),Object.assign(c,e),this.config.inputComponents=[],this.config.maxPaddingPercent=12.5,this._mapChildren((function(e){e.getState("removed")||e.getType&&"dataset"===e.getType()||"axisRefVisuals"===e.getType()||e.configure&&e.configure()}))},a.disposeAllInputs=function(){this.config.inputComponents.forEach((function(e){e.dispose()})),this.config.inputComponents.length=0},a.axisExists=function(e){var t,a,i=this.getLinkedItem("axes"),n=!1;for(t=0,a=i.length;t<a;t++)if(i[t].axis===e){n=!0;break}return n},a.attachAxis=function(e,t,a){var i=this.getLinkedItem("axes"),n=t?"yAxis":"xAxis",o=this.getFromEnv(n)||[];return this.axisExists(e)||(i.push({axis:e,isY:t,config:a||{}}),o.push(e),this.addToEnv(n,o)),this},a.setPrimaryAxis=function(e,t){this.getLinkedItem("primaryAxis")[e]=this.getLinkedItem("axes").find((function(e){return e.axis===t}))},a.getAxes=function(){var e;return Object.keys(e=this.getLinkedItem("primaryAxis")).length?[e.xAxis,e.yAxis]:this.getLinkedItem("axes").slice(0)},a.detachAxis=function(e,t){var a=this.getLinkedItem("axes"),i=Infinity;return t?a.splice(t,1):(a.forEach((function(t,a){t.axis===e&&(i=a)})),a.splice(i,1))},a.preDraw=function(){this._mapChildren((function(e){e.getState("removed")||e.preDraw&&e.preDraw()}))},a.draw=function(){this.createGroup(),!this.getFromEnv("chart").config.skipCanvasDrawing&&this.drawCanvas()},a.drawCanvas=function(){var e,t,a,i,n,o,r,s=this,c=s.getFromEnv("chart"),p=c.isBar,f=s.getFromEnv("chart-attrib"),m=s.getFromEnv("animationManager"),b=c.config,v=s.config,x=v.clip={},y=c.getChildContainer("plotGroup"),C=c.getChildContainer("datalabelsGroup"),k=s.getGraphicalElement("canvasBorderElement"),S=s.getGraphicalElement("canvasElement"),w=v.canvasLeft||(v.canvasLeft=b.canvasLeft),A=v.canvasTop||(v.canvasTop=b.canvasTop),L=v.canvasWidth||(v.canvasWidth=b.canvasWidth),N=v.canvasHeight||(v.canvasHeight=b.canvasHeight),F=v.xDepth=b.xDepth||0,T=v.yDepth=b.yDepth||0,E=s.getContainer("canvasGroup"),P=s.getChildContainer("quadrantGroup"),_=v.canvasBorderRadius,D=v.canvasBorderWidth,I=.5*D,M=v.canvasBorderColor,O=v.canBGColor,R=v.canBGAlpha,B=v.shadow,V=v.showCanvasBG=Boolean((0,l.pluckNumber)(f.showcanvasbg,1)),z=v.shadowOnCanvasFill,G=v.showCanvasBorder;i=O,n={x:w-I,y:A-I,width:L+D,height:N+D,r:_,"stroke-width":D,stroke:M,"stroke-linejoin":D>2?g:u},G?(k&&k.show(),t=m.setAnimation({el:k||"rect",component:s,attr:{x:w-I,y:A-I,width:L+D,height:N+D,r:_,"stroke-width":D,stroke:M,"stroke-linejoin":D>2?g:u},label:"rect",container:E}).shadow(B),k||s.addGraphicalElement("canvasBorderElement",t)):k&&(s.removeGraphicalElement(k),m.setAnimation({el:k,component:s,callback:function(){k.hide()}})),o=G?0:v.oriCanvasBorderThickness,x["clip-canvas"]=[h(0,w-F-o),h(0,A-T-o),h(1,L+2*F+2*o),h(1,N+T+2*o)],x["clip-sum-value"]=[h(0,w-F),p?A:0,h(1,p?b.width-w:L+2*F),h(1,p?N+T:A+N)],x["clip-canvas-init"]=[h(0,w-F),h(0,A-T),1,h(1,N+2*T)],e=x["clip-canvas"].slice(0),r=function(e,t){m.setAnimation({el:e,attr:{"clip-rect":t},label:"container",component:s,state:e.attrs["clip-rect"]?"updating":"appearing"})},b.skipClipping||(r(y,e),r(C,e),r(P,e),r(s.getChildContainer("sumLabelsLayer"),x["clip-sum-value"])),V?(n={x:w,y:A,width:L,height:N,r:_,"stroke-width":0,stroke:d,fill:(0,l.toRaphaelColor)(i)},S&&S.show(),a=m.setAnimation({el:S||"rect",attr:n,label:"rect",container:E,component:s}),S||s.addGraphicalElement("canvasElement",a),z?a.shadow({opacity:R/100}):a.shadow(!1)):S&&m.setAnimation({el:S,component:s,callback:function(){S.hide()}})},t}(r.ComponentInterface);t["default"]=f},468:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.canvas.canvas":function(){return{"rect.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]},"*":null}},"update.canvas.canvas":{"rect.updating":[{slot:"middle"}]}}},469:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a=e,l=a.config,s=a.getFromEnv("chart-attrib"),c="t"===l.toolbarVAlign?"chartMenuBar":"actionBar",h="t"===l.toolbarVAlign?"actionBar":"chartMenuBar";(0,i.componentFactory)(a,n.ToolBar,h,0,[s]),(0,i.componentFactory)(a,n.ToolBar,c,1,[s]),t=a.getChildren(c)[0],a.addToEnv("toolbar",t),o.SymbolStore.register("ContextIcon",(function(e,t,a){var i=e,n=t,o=2*a,l=r(o/4),s=.7*r(o/2),c=i-s,h=i+s,u=n+l,d=n-l;return["M",c,n,"L",h,n,"M",c,u,"L",h,u,"M",c,d,"L",h,d]})),a.attachMenuButtons()};var i=a(224),n=a(363),o=a(368),r=Math.round},470:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(224),r=a(240),l=a(232),s=i(a(471)),c=Math.max,h=Math.min,u=Math.ceil;(0,l.addDep)({name:"captionAnimation",type:"animationRule",extension:s["default"]});var d=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"caption"},a.getName=function(){return"caption"},a.configure=function(){var e=this.getFromEnv("chart"),t=e.getFromEnv("chart-attrib"),a=this.config||{},i=e.getFromEnv("style"),n=i.outCanfontFamily,r=i.outCancolor,l=["top","center"];switch(this.config.text=(0,o.parseUnsafeString)(t.caption),a.style={fontFamily:(0,o.pluck)(t.captionfont,n),color:(0,o.convertColor)((0,o.pluck)(t.captionfontcolor,r).replace(/^#? ([a-f0-9]+)/gi,"#$1")),fontSize:(0,o.pluckNumber)(this.computeFontSize(t.captionfontsize),this.computeFontSize(i.fontSizeWithUnit)+3)+"px",fontWeight:0===(0,o.pluckNumber)(t.captionfontbold)?o.NORMAL:o.BOLD},a.align||(a.align=o.BLANKSTRING),a.align=(0,o.pluck)(t.captionposition,t.captionalignment,"center"),a.align&&((l=a.align.split("-"))[0]&&(l[0]=l[0].toLowerCase()),l[1]&&(l[1]=l[1].toLowerCase()),l.length<2&&(l[1]=l[0])),l[0]){case"top":a.isOnTop=1;break;case"bottom":a.isOnTop=0;break;default:a.isOnTop=(0,o.pluckNumber)(t.captionontop,1)}switch(l[1]){case"right":a.align="end";break;case"left":a.align="start";break;default:a.align="middle"}a.isOnLeft=!(0,o.pluckNumber)(t.captiononright,0),a.captionPosition=(0,o.getValidValue)(t.captionposition,"top").toLowerCase(),a.alignWithCanvas=(0,o.pluckNumber)(t.aligncaptionwithcanvas,e.config.alignCaptionWithCanvas,1),a.horizontalPadding=(0,o.pluckNumber)(t.captionhorizontalpadding,a.alignWithCanvas?0:15),a.drawCaption=!0,(0,o.setLineHeight)(a.style)},a.allocatePosition=function(){this.getFromEnv("chart")._manageCaptionPosition()},a.draw=function(){var e,t=this.getFromEnv("chart"),a=t.config,i=t.getFromEnv("animationManager"),n=t.config.textDirection,r=t.getChildContainer().captionGroup,l=t.getFromEnv("smartLabel"),s=this.getGraphicalElement("captionElement"),c=this.getFromEnv("toolTipController"),h=this.config,u=h.style,d=h.text,g=h.x,p=h.align;d?(e={text:h.text,fill:u.color,x:g,y:h.y,"text-anchor":p||"middle","vertical-align":h.verticalAlign||"top",visibility:h.drawCaption?o.visibleStr:o.hiddenStr,direction:n},(s=this.addGraphicalElement("captionElement",i.setAnimation({el:s||"text",attr:e,container:r,state:void 0,component:this,label:"text"}))).css(u),a.showtooltip?c.enableToolTip(s,h.originalText):c.disableToolTip(s),l&&(l.useEllipsesOnOverflow(a.useEllipsesWhenOverflow),l.setStyle(u))):s&&i.setAnimation({el:s,component:this,callback:function(){this.hide()},doNotRemove:!0}),a.savedCaption=s},a.manageSpace=function(e,t){var a,i,n,r,l,s=this.getFromEnv("chart"),d=s.config,g=s.getChildren("caption")[0],p=s.getChildren("subCaption")[0],f=s.getFromEnv("style").fontSizeWithUnit,m=g.config,b=p.config,v=m.style,x=b.style,y=s.getFromEnv("dataSource").chart,C=s.getFromEnv("smartLabel"),k=e,S=(0,o.parseUnsafeString)(y.caption),w=(0,o.parseUnsafeString)(y.subcaption),A=(0,o.pluckNumber)(y.captionpadding,10),L=A,N=!1,F=0,T=0,E=0,P=0,_=0,D=s.getChildren("canvas"),I=c(D&&D[0].config.canvasBorderThickness,0),M=0,O=0;return v.fontSize=(0,o.pluckNumber)(this.computeFontSize(y.captionfontsize),this.computeFontSize(f)+3)+"px",(0,o.setLineHeight)(v),x.fontSize=(0,o.pluckNumber)(this.computeFontSize(y.subcaptionfontsize),(0,o.pluckNumber)(c((0,o.pluckNumber)(this.computeFontSize(y.captionfontsize))-3,-1),this.computeFontSize(f))+(0,o.pluckNumber)(s.subTitleFontSizeExtender,1))+"px",(0,o.setLineHeight)(x),k>3?(A<I&&(A=I+2),S!==o.BLANKSTRING&&(n=m.style,P=u((0,o.pluckNumber)(parseFloat(n.fontHeight,10),parseFloat(n.lineHeight,10),12))),w!==o.BLANKSTRING&&(l=b.style,_=(0,o.pluckNumber)(parseInt(l.fontHeight,10),parseInt(l.lineHeight,10),12)),P>0||_>0?((F=P+_+A)>(k=c(k,0))?(N=!0,(T=F-k)<A?A=c(T,5):(T-=A,A=0,_>T?(E=_-T+10,_=0,b._originalText=b.text,b.text=o.BLANKSTRING):(T-=_,_=0,P>T&&(E=P-T)))):E=k-F,C.useEllipsesOnOverflow(d.useEllipsesWhenOverflow),P>0&&(C.setStyle(n),E=(P+=E)-(a=C.getSmartText(S,t,P)).height,m.height=P=a.height,m.text=a.text,m.originalText=!!a.tooltext&&a.tooltext,M=a.width),_>0&&(C.setStyle(l),E=(_+=E)-(i=C.getSmartText(w,t,_)).height,_=i.height,b.text=i.text,b.height=i.height,b.originalText=!!i.tooltext&&i.tooltext,O=i.width),N&&E>0&&(A+=h(L-A,E)),m.captionPadding=A,m.height=P,m.width=M,b.width=O,b.height=_,F=P+_+A):(m.height=0,b.height=0),F>d.canvasHeight?(F=0,m.drawCaption=!1):m.drawCaption=!0,r=m.isOnTop?{top:F}:{bottom:F,top:5}):(r={bottom:0,top:0},m.drawCaption=!1),r},a.setDimention=function(e){var t=this.config;t.x=e.x,t.y=e.y},t}(r.ComponentInterface);t["default"]=d},471:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.caption.caption":function(){return{"text.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]}}}}},472:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(224),r=i(a(470)),l=a(232),s=i(a(473)),c=Math.max;(0,l.addDep)({name:"subcaptionAnimation",type:"animationRule",extension:s["default"]});var h=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"caption"},a.getName=function(){return"subCaption"},a.configure=function(){var e=this.getFromEnv("chart"),t=e.getFromEnv("chart-attrib"),a=this.config||{},i=e.getFromEnv("style"),n=e.getChildren("caption")[0],r=i.outCanfontFamily,l=i.outCancolor,s=i.fontSizeWithUnit,h=["top","center"];switch(a.text=(0,o.parseUnsafeString)(t.subcaption),a.align||(a.align=o.BLANKSTRING),a.align=(0,o.pluck)(t.captionposition,t.captionalignment,"center"),n.config.align&&((h=n.config.align.split("-"))[0]&&(h[0]=h[0].toLowerCase()),h[1]&&(h[1]=h[1].toLowerCase()),h.length<2&&(h[1]=h[0])),h[0]){case"top":a.isOnTop=1;break;case"bottom":a.isOnTop=0;break;default:a.isOnTop=(0,o.pluckNumber)(t.captionontop,1)}a.alignWithCanvas=(0,o.pluckNumber)(e.aligncaptionwithcanvas,t.aligncaptionwithcanvas,1),a.horizontalPadding=(0,o.pluckNumber)(t.captionhorizontalpadding,n.config.alignWithCanvas?0:15),a.style={fontFamily:(0,o.pluck)(t.subcaptionfont,t.captionfont,r),color:(0,o.convertColor)((0,o.pluck)(t.subcaptionfontcolor,t.captionfontcolor,l).replace(/^#? ([a-f0-9]+)/gi,"#$1")),fontSize:(0,o.pluckNumber)(this.computeFontSize(t.subcaptionfontsize),(0,o.pluckNumber)(c((0,o.pluckNumber)(this.computeFontSize(t.captionfontsize))-3,-1),this.computeFontSize(s))+(0,o.pluckNumber)(e.subTitleFontSizeExtender,1))+"px",fontWeight:0===(0,o.pluckNumber)(t.subcaptionfontbold,e.subTitleFontWeight,t.captionfontbold)?o.NORMAL:o.BOLD},(0,o.setLineHeight)(a.style)},a.draw=function(){var e,t=this.getFromEnv("chart"),a=t.getFromEnv("animationManager"),i=t.getChildren("caption")[0],n=t.config,r=n.textDirection,l=t.getChildContainer().captionGroup,s=this.getGraphicalElement("subCaptionElement"),c=this.getFromEnv("toolTipController"),h=this.config,u=h.style,d=h.text,g=i.config.align;d?(e={text:h.text,fill:u.color,x:h.x,y:h.y,"text-anchor":g||"middle","vertical-align":"top",direction:r,visibility:i.config.drawCaption?o.visibleStr:o.hiddenStr},(s=this.addGraphicalElement("subCaptionElement",a.setAnimation({el:s||"text",attr:e,container:l,state:void 0,component:this,hookFn:function(){this.css(u)},label:"text"}))).css(u),n.showtooltip?c.enableToolTip(s,h.originalText):c.disableToolTip(s)):s&&this.removeGraphicalElement(s),n.savedSubCaption=s},a.setDimention=function(e){this.config.x=e.x,this.config.y=e.y},t}(r["default"]);t["default"]=h},473:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n={"initial.caption.subCaption":i(a(471))["default"]["initial.caption.caption"]};t["default"]=n},474:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(242)),o=i(a(238)),r=a(240),l=a(224),s=a(232),c=i(a(475)),h="BackgroundLoaded",u="BackgroundLoadError",d="none";(0,s.addDep)({name:"backgroundAnimation",type:"animationRule",extension:c["default"]});var g=function(e){function t(){var t,a,i;return(t=e.call(this)||this).config.handler=(a=(0,n["default"])(t),i=a.config,{load:function(){var e=i.bgImageDisplayMode,t=i.bgImageVAlign,n=i.bgImageHAlign,o=i.bgImageScale,r=i.bgSWFAlpha,l=i.bgSWF,s=a.getGraphicalElement("backgroundImage")._.RefImg;a.getFromEnv("chart").fireChartInstanceEvent(h,{url:l,bgImageAlpha:r,bgImageDisplayMode:e,bgImageVAlign:t,bgImageHAlign:n,bgImageScale:o,imageheight:s.height,imagewidth:s.width})},error:function(e){var t=i.bgImageDisplayMode,n=i.bgImageVAlign,o=i.bgImageHAlign,r=i.bgImageScale,l=i.bgSWFAlpha,s=i.bgSWF;a.getFromEnv("chart").fireChartInstanceEvent(u,{url:s,bgImageAlpha:l,error:e,bgImageDisplayMode:t,bgImageVAlign:n,bgImageHAlign:o,bgImageScale:r})}}),t}(0,o["default"])(t,e);var a=t.prototype;return a.getName=function(){return"background"},a.getType=function(){return"background"},a._getBackgroundCosmetics=function(){var e=this.getFromEnv("chart-attrib"),t=this.getFromEnv("color-manager"),a=this.getFromEnv("chartConfig").is3D?l.chartPaletteStr.chart3D:l.chartPaletteStr.chart2D;return{FCcolor:{color:(0,l.pluck)(e.bgcolor,t.getColor(a.bgColor)),alpha:(0,l.pluck)(e.bgalpha,t.getColor(a.bgAlpha)),angle:(0,l.pluck)(e.bgangle,t.getColor(a.bgAngle)),ratio:(0,l.pluck)(e.bgratio,t.getColor(a.bgRatio))}}},a.configureAttributes=function(){var e,t,a,i=this.config,n=this.getFromEnv("chart-attrib"),o=this.getFromEnv("chartConfig"),r=o.is3D,s=this.getFromEnv("color-manager"),c=i.bgImageDisplayMode=(0,l.pluck)(n.bgimagedisplaymode,"none").toLowerCase();i.bgSWF=(0,l.pluck)(n.bgimage,n.bgswf),i.bgSWFAlpha=(0,l.pluckNumber)(n.bgimagealpha,n.bgswfalpha,100),e=i.showBorder=(0,l.pluckNumber)(n.showborder,o.showBorder,r?0:1),i.borderWidth=Math.max(e?(0,l.pluckNumber)(n.borderthickness,1):0,0),i.borderRadius=(0,l.pluckNumber)(n.borderradius,0),i.borderDashStyle=(0,l.pluckNumber)(n.borderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(n.borderdashlen,4),(0,l.pluckNumber)(n.borderdashgap,2),void 0):d,i.borderAlpha=(0,l.pluck)(n.borderalpha,r?"100":s&&s.getColor("borderAlpha")),i.borderColor=(0,l.convertColor)((0,l.pluck)(n.bordercolor,r?"#666666":s&&s.getColor("borderColor")),i.borderAlpha),i.bgImageVAlign=t=(0,l.getValidValue)(n.bgimagevalign,"").toLowerCase(),i.bgImageHAlign=a=(n.bgimagehalign||"").toLowerCase(),i.bgImageScale=(0,l.pluckNumber)(n.bgimagescale,100),i.containerBackgroundColor=(0,l.getContainerBackgroundColor)(this.getFromEnv("chartInstance")),i.backgroundColor=this._getBackgroundCosmetics(),"tile"===c||"fill"===c||"fit"===c?("top"!==t&&"middle"!==t&&"bottom"!==t&&(i.bgImageVAlign="middle"),"left"!==a&&"middle"!==a&&"right"!==a&&(i.bgImageHAlign="middle")):("top"!==t&&"middle"!==t&&"bottom"!==t&&(i.bgImageVAlign="top"),"left"!==a&&"middle"!==a&&"right"!==a&&(i.bgImageHAlign="left"))},a.draw=function(){var e,t,a,i,n,o,r=this.getFromEnv("paper"),s=this.getGraphicalElement("backgroundElement"),c=this.getGraphicalElement("borderElement"),h=this.config,u=this.getFromEnv("chart"),d=this.getFromEnv("chartConfig"),g=h.backgroundColor,p=this.getFromEnv("animationManager"),f=this.getGraphicalElement("backgroundImage"),m=h.bgSWF,b=u.getChildContainer("backgroundGroup"),v=d.width,x=d.height,y=h.borderWidth||0,C=h.borderRadius,k=h.borderDashStyle,S=h.borderColor,w=h.bgSWFAlpha,A=y+","+y+","+(v-2*y)+","+(x-2*y),L=h.bgImageDisplayMode,N=h.bgImageVAlign,F=h.bgImageHAlign,T=h.bgImageScale;r.canvas.style.backgroundColor=h.containerBackgroundColor,a={x:y,y:y,width:(o=v-2*y)<0?0:o,height:(n=x-2*y)>0?n:0,stroke:l.preDefStr.noneStr,fill:(0,l.toRaphaelColor)(g)},(e=p.setAnimation({el:s||"rect",attr:a,container:b,component:this,label:"rect"})).show(),s||this.addGraphicalElement("backgroundElement",e),a={x:y/2,y:y/2,width:(o=v-y)<0?0:o,height:(n=x-y)>0?n:0,stroke:S,"stroke-width":y,"stroke-dasharray":k,fill:l.preDefStr.noneStr,r:C||0},(t=p.setAnimation({el:c||"rect",attr:a,container:b,component:this,label:"rect"})).show(),c||this.addGraphicalElement("borderElement",t),m&&!this.getState("removed")?((i=p.setAnimation({el:f||"imagegrid",attr:{imagegrid:[L,N,F,T,y,v,x],src:m,opacity:.01*w,"clip-rect":A},container:b,component:this,label:"imagegrid"})).show(),f||(this.addGraphicalElement("backgroundImage",i),i.on("load",h.handler.load),i.on("error",h.handler.error))):f&&this.removeGraphicalElement(f)},t}(r.ComponentInterface);t["default"]=g},475:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.background.background":function(){return{"rect.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]}}}}},476:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=a(224),o=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=l(t);if(a&&a.has(e))return a.get(e);var i={},n=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in e)if("default"!==o&&Object.prototype.hasOwnProperty.call(e,o)){var r=n?Object.getOwnPropertyDescriptor(e,o):null;r&&(r.get||r.set)?Object.defineProperty(i,o,r):i[o]=e[o]}i["default"]=e,a&&a.set(e,i);return i}(a(477)),r=i(a(291));function l(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(l=function(e){return e?a:t})(e)}function s(e,t){var a,i,o,r,l,s,c,h,d,g,p,f=u.stringConstants,m=t.replace(/\s/g,f.BLANK).toLowerCase(),b=[];if(m===f.BLANK||null==m)b=[e];else for(o=m.split(f.COMMASTRING),r=e.split(f.COMMASTRING),l=Math.max(o.length,r.length,1),s=o[0],c=r[0],g=/[\{\}]/gi,p=0;p<l;p++)h=(o[p]||s).replace(g,""),d=r[p]||c,"color"===h?b.push(d):"light"===h.substr(0,5)?(i=100-(i=-1===(a=h.indexOf("-"))?1:h.substr(a+1,h.length-a)),b.push((0,n.getLightColor)(d,i))):"dark"===h.substr(0,4)?(i=100-(i=-1===(a=h.indexOf("-"))?1:h.substr(a+1,h.length-a)),b.push((0,n.getDarkColor)(d,i))):b.push(h);return b}function c(e,t){var a,i,o=e.toString().split(u.stringConstants.COMMASTRING),r=[],l=100;for(i=0;i<t;i++)a=(0,n.pluckNumber)(o[i]),u.defined(a)&&(l=a),r[i]=l;return r.join()}function h(e,t){var a,i,n=e.split(u.stringConstants.COMMASTRING),o=[],r=0;for(i=0;i<t;i++)a=n[i],a=(a=isNaN(a)||void 0===a?0:Math.abs(Number(a)))>100?100:a,o[i]=a,r+=a;if(r=r>100?100:r,n.length<t)for(i=n.length;i<t;i++)o[i]=(100-r)/(t-n.length);return o[-1]=0,o.join()}var u=function(){function e(e){this.parseColorMix=s,this.parseAlphaList=c,this.parseRatioList=h,this.linkedItems={iapi:e},this.configure(),this.paletteColors=["AFD8F8","F6BD0F","8BBA00","FF8E46","008E8E","D64646","8E468E","588526","B3AA00","008ED6","9D080D","A186BE","CC6600","FDC689","ABA000","F26D7D","FFF200","0054A6","F7941C","CC3300","006600","663300","6DCFF6"]}var t=e.prototype;return t.configure=function(){var t=this,a=e.stringConstants,i=t.linkedItems.iapi,l=i.getFromEnv("dataSource").chart||{},s=t.paletteOptions=(0,n.extend2)((0,n.extend2)({},o),i.defaultPaletteOptions||{},!1,!0),c=t.themeEnabled=l.palettethemecolor;t.paletteIndex=(l.palette>0&&l.palette<6?l.palette:(0,n.pluckNumber)(i.paletteIndex,1))-1,t.iterator=0,t.paletteColors=s.paletteColors[t.themeEnabled?0:t.paletteIndex],e.defined(l.palettecolors)&&l.palettecolors!==a.BLANK&&(t.paletteColors=(0,r["default"])(l.palettecolors)?l.palettecolors.slice():l.palettecolors.split(/\s*\,\s*/)),t.paletteLen=t.paletteColors.length,t.useFlatColors=(0,n.pluckNumber)(l.useflatdataplotcolor,i.useFlatColor,0),c&&(t.paletteIndex=5,s.bgColor[5]=(0,n.getLightColor)(c,35)+a.COMMASTRING+(0,n.getLightColor)(c,10),s.bgAngle[5]=270,s.bgRatio[5]=a.BGRATIOSTRING,s.bgAlpha[5]="50,50",s.canvasBgColor[5]=a.COLOR_WHITE,s.canvasBgAngle[5]=0,s.canvasBgAlpha[5]=a.HUNDREDSTRING,s.canvasBgRatio[5]=a.BLANK,s.canvasBorderColor[5]=(0,n.getDarkColor)(c,80),s.canvasBorderAlpha[5]=100,s.showShadow[5]=1,s.divLineColor[5]=(0,n.getDarkColor)(c,20),s.divLineAlpha[5]=40,s.altHGridColor[5]=(0,n.getLightColor)(c,20),s.altHGridAlpha[5]=15,s.altVGridColor[5]=(0,n.getLightColor)(c,80),s.altVGridAlpha[5]=10,s.anchorBgColor[5]=a.COLOR_WHITE,s.toolTipBgColor[5]=a.COLOR_WHITE,s.toolTipBorderColor[5]=(0,n.getDarkColor)(c,80),s.baseFontColor[5]=c.split&&c.split(a.COMMASTRING)[0],s.borderColor[5]=(0,n.getDarkColor)(c,60),s.borderAlpha[5]=50,s.legendBgColor[5]=a.COLOR_WHITE,s.legendBorderColor[5]=(0,n.getDarkColor)(c,80),s.plotGradientColor[5]=a.COLOR_WHITE,s.plotBorderColor[5]=(0,n.getDarkColor)(c,85),s.plotFillColor[5]=(0,n.getDarkColor)(c,85),s.bgColor3D[5]=a.COLOR_WHITE,s.bgAlpha3D[5]=a.HUNDREDSTRING,s.bgAngle3D[5]=90,s.bgRatio3D[5]=a.BLANK,s.canvasBgColor3D[5]=(0,n.getLightColor)(c,20),s.canvasBaseColor3D[5]=(0,n.getLightColor)(c,40),s.divLineColor3D[5]=(0,n.getDarkColor)(c,20),s.divLineAlpha3D[5]=40,s.legendBgColor3D[5]=a.COLOR_WHITE,s.legendBorderColor3D[5]=(0,n.getDarkColor)(c,80),s.toolTipbgColor3D[5]=a.COLOR_WHITE,s.toolTipBorderColor3D[5]=(0,n.getDarkColor)(c,80),s.baseFontColor3D[5]=c.split&&c.split(a.COMMASTRING)[0],s.anchorBgColor3D[5]=a.COLOR_WHITE,s.tickColor&&(s.tickColor[5]=(0,n.getDarkColor)(c,90)),s.trendDarkColor&&(s.trendDarkColor[5]=(0,n.getDarkColor)(c,90)),s.trendLightColor&&(s.trendLightColor[5]=(0,n.getLightColor)(c,s.TrendLightShadeOffset)),s.msgLogColor&&(s.msgLogColor[5]=(0,n.getLightColor)(c,80)),s.dialColor&&(s.dialColor[5]=(0,n.getDarkColor)(c,95)+",FFFFFF,"+(0,n.getDarkColor)(c,95)),s.dialBorderColor&&(s.dialBorderColor[5]=(0,n.getDarkColor)(c,95)+",FFFFFF,"+(0,n.getDarkColor)(c,95)),s.pivotColor&&(s.pivotColor[5]=(0,n.getLightColor)(c,95)+",FFFFFF,"+(0,n.getLightColor)(c,95)),s.pivotBorderColor&&(s.pivotBorderColor[5]=(0,n.getDarkColor)(c,95)+",FFFFFF,"+(0,n.getDarkColor)(c,95)),s.pointerBorderColor&&(s.pointerBorderColor[5]=(0,n.getDarkColor)(c,75)),s.pointerBgColor&&(s.pointerBgColor[5]=(0,n.getDarkColor)(c,75)),s.thmBorderColor&&(s.thmBorderColor[5]=(0,n.getDarkColor)(c,90)),s.thmFillColor&&(s.thmFillColor[5]=(0,n.getLightColor)(c,55)),s.gaugeBorderColor&&(s.gaugeBorderColor[5]=(0,n.getDarkColor)(c,90)),s.gaugeFillColor&&(s.gaugeFillColor[5]=(0,n.getLightColor)(c,55)),s.cylFillColor&&(s.cylFillColor[5]=(0,n.getLightColor)(c,55)),s.periodColor&&(s.periodColor[5]=(0,n.getLightColor)(c,10)),s.winColor&&(s.winColor[5]="666666"),s.lossColor&&(s.lossColor[5]="CC0000"),s.drawColor&&(s.drawColor[5]="666666"),s.scorelessColor&&(s.scorelessColor[5]="FF0000"),s.gridColor&&(s.gridColor[5]=(0,n.getLightColor)(c,30)),s.categoryBgColor&&(s.categoryBgColor[5]=(0,n.getLightColor)(c,10)),s.dataTableBgColor&&(s.dataTableBgColor[5]=(0,n.getLightColor)(c,10)),s.gridResizeBarColor&&(s.gridResizeBarColor[5]=(0,n.getDarkColor)(c,90)),s.scrollBarColor&&(s.scrollBarColor[5]=(0,n.getLightColor)(c,50)))},t.getColor=function(e){return this.paletteOptions[e][this.paletteIndex]},t.getPlotColor=function(e){var t=this,a=t.paletteColors,i=t.useFlatColors?t.getColor("plotFillColor"):a[e%t.paletteLen];return i||(t.iterator===t.paletteLen&&(t.iterator=0),i=a[t.iterator],t.iterator+=1),i},e}();u.stringConstants={BLANK:"",COMMASTRING:",",BGRATIOSTRING:"0,100",COLOR_WHITE:"FFFFFF",HUNDREDSTRING:"100"},u.defined=function(e){return null!=e};var d=u;t["default"]=d},477:function(e,t,a){"use strict";t.__esModule=!0,t.anchorBgColor3D=t.baseFontColor3D=t.toolTipBorderColor3D=t.toolTipbgColor3D=t.legendBorderColor3D=t.legendBgColor3D=t.divLineAlpha3D=t.divLineColor3D=t.canvasBaseColor3D=t.canvasBgColor3D=t.bgRatio3D=t.bgAngle3D=t.bgAlpha3D=t.bgColor3D=t.plotFillColor=t.plotBorderColor=t.plotGradientColor=t.legendBorderColor=t.legendBgColor=t.borderAlpha=t.borderColor=t.baseFontColor=t.toolTipBorderColor=t.toolTipBgColor=t.anchorBgColor=t.altVGridAlpha=t.altVGridColor=t.altHGridAlpha=t.altHGridColor=t.divLineAlpha=t.divLineColor=t.showShadow=t.canvasBorderAlpha=t.canvasBorderColor=t.canvasBgRatio=t.canvasBgAlpha=t.canvasBgAngle=t.canvasBgColor=t.bgAlpha=t.bgRatio=t.bgAngle=t.bgColor=t.paletteColors=void 0;var i=["AFD8F8","F6BD0F","8BBA00","FF8E46","008E8E","D64646","8E468E","588526","B3AA00","008ED6","9D080D","A186BE","CC6600","FDC689","ABA000","F26D7D","FFF200","0054A6","F7941C","CC3300","006600","663300","6DCFF6"],n=[i,i,i,i,i],o=[270,270,270,270,270],r=["0,100","0,100","0,100","0,100","0,100"],l=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],s=["100","100","100","100","100"],c=["","","","",""],h=[100,100,100,90,100],u=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],d=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],g=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],p=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],f=["333333","8A8A8A","FFFFFF","FFFFFF","FFFFFF"],m=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],b=["100","100","100","100","100"],v=["","","","",""],x=[100,100,100,100,100],y=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],C=["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"];t.anchorBgColor3D=C,t.baseFontColor3D=["49563A","4A4A4A","49351D","48505A","681C09"],t.toolTipBorderColor3D=["49563A","666666","49351D","576373","681C09"],t.toolTipbgColor3D=y,t.legendBorderColor3D=["C6CFB8","C8C8C8","DFC29C","CFD5DA","FAD1C7"],t.legendBgColor3D=["F0F3ED","F3F3F3","F7F0E8","EEF0F2","FEF8F5"],t.divLineAlpha3D=x,t.divLineColor3D=["ACBB99","A4A4A4","BE9B6B","7C8995","D49B8B"],t.canvasBaseColor3D=["ACBB99","BCBCBD","C8A06C","96A4AF","FAC7BC"],t.canvasBgColor3D=["DDE3D5","D8D8D7","EEDFCA","CFD2D8","FEE8E0"],t.bgRatio3D=v,t.bgAngle3D=[90,90,90,90,90],t.bgAlpha3D=b,t.bgColor3D=m,t.plotFillColor=["767575","D8DCC5","99C4CD","DEC49C","FEC1D0"],t.plotBorderColor=f,t.plotGradientColor=p,t.legendBorderColor=["545454","545454","415D6F","845001","D55979"],t.legendBgColor=g,t.borderAlpha=[50,50,50,50,50],t.borderColor=["767575","545454","415D6F","845001","68001B"],t.baseFontColor=["555555","60634E","025B6A","A15E01","68001B"],t.toolTipBorderColor=["545454","545454","415D6F","845001","68001B"],t.toolTipBgColor=d,t.anchorBgColor=u,t.altVGridAlpha=[10,20,10,15,10],t.altVGridColor=["767575","D8DCC5","99C4CD","DEC49C","FEC1D0"],t.altHGridAlpha=[50,35,10,20,15],t.altHGridColor=["EEEEEE","D8DCC5","99C4CD","DEC49C","FEC1D0"],t.divLineAlpha=[40,45,65,40,30],t.divLineColor=["717170","7B7D6D","92CDD6","965B01","68001B"],t.showShadow=[0,1,1,1,1],t.canvasBorderAlpha=h,t.canvasBorderColor=["545454","545454","415D6F","845001","68001B"],t.canvasBgRatio=c,t.canvasBgAlpha=s,t.canvasBgAngle=[0,0,0,0,0],t.canvasBgColor=l,t.bgAlpha=["50,50","60,50","40,20","20,10","30,30"],t.bgRatio=r,t.bgAngle=o,t.bgColor=["CBCBCB,E9E9E9","CFD4BE,F3F5DD","C5DADD,EDFBFE","A86402,FDC16D","FF7CA0,FFD1DD"],t.paletteColors=n},478:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"*.*.*":{"*.disappearing":[{finalAttr:{opacity:0},slot:"initial",callback:function(){this.hide()}}]}}},479:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){var a=Number(e),i=Number(t)-a;return function(e){return i*e+a}};t["default"]=i},480:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i=e.getChildren("canvas")[0],l=i.getChildren("axisRefVisualCartesian")[0],s={zoomable:!0,pannable:!0},c=e._feedAxesRawData(),h=function(e){var t=e.sender;l.addexplicitDrawItems(t.getId(),t),l.asyncDraw()};(0,n.componentFactory)(e,o["default"],"yAxis",1,c.yAxisConf),(0,n.componentFactory)(e,r["default"],"xAxis",1,c.xAxisConf),t=e.getChildren("yAxis")[0],a=e.getChildren("xAxis")[0],t.setLinkedItem("canvas",i),a.setLinkedItem("canvas",i),l.setLinkedItem(t.getId(),t),l.setLinkedItem(a.getId(),a),l.addExtEventListener("visiblerangeset",h,a),l.addExtEventListener("visiblerangeset",h,t),i.attachAxis(a,!1,e.zoomX?s:{}),i.attachAxis(t,!0,e.zoomY?s:{}),e._setCategories()};var n=a(224),o=i(a(481)),r=i(a(528))},481:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(482)),r=i(a(485)),l=i(a(507)),s=i(a(508)),c=i(a(509)),h=a(516),u=a(224),d=function(e){function t(){var t;return(t=e.call(this)||this).config.scale=new r["default"],t}(0,n["default"])(t,e);var a=t.prototype;return a.getName=function(){return"numeric"},a.generateTicks=function(){var e,t,a,i=this.getScale(),n=this.config,o=n.numDivLines+1,r=i.getDomain(),c=r[0],h=r[1],u=n.axisRange,d=u.min,g=u.max,p=n.dataLimit;return c===d&&h===g?((0,s["default"])(p.min,p.max,i,n),n.ticks):(e=i.ticks(o),t=Math.abs(e[1]-e[0]),c===d&&-1===e.indexOf(d)&&e.unshift(d),h===g&&-1===e.indexOf(g)&&e.push(g),(a=Math.abs(d%t))&&(d-=a),(a=Math.abs(g%t))&&(g-=a),n._allTicks=(0,l["default"])(d,g,t).concat(g),u.tickInterval=t,e)},a.setTickValues=function(e){this.config.userTicks=e||[],this.config.tickValues={tickValue:[]}},a._parseTickValues=function(e){var t,a,i,n,o=this.getFromEnv("chart"),r=this.config,l=e&&e.length,s=0;for(r.tickValues={},t=r.tickValues.tickValue=[],i=0;i<l;i+=1)if(a=(0,u.extend2)({},e[i]),n=Number(a.x),!a.vline){if((0,h.extractStyleInfo)(a,o),!n&&0!==n)continue;a.x=n,r.irregularCatAxis=!0,t.push(a),t[s].label=(0,u.parseUnsafeString)(t[s].label),s+=1}r.oriCatLen=s},a.calculateTicksOnLabelMode=function(){var e,t,a,i,n,o,r,l=this.config,s=l.xAxisLabelMode,c=Object.assign([],l.userTicks),h=this.getFromEnv("number-formatter");if("mixed"===s||"auto"===s){if(t=[],e=h.xAxis,"mixed"===s)for(a=0,n=c.length;a<n;a+=1)t[c[a].x||c[a].y||a]=!0;else c=[];for(r=this.getAxisConfig(),o=l.ticks,i=0;i<o.length;++i)t[a=o[i]]||c.push({label:u.BLANKSTRING+e.call(h,a),x:a,showverticalline:0===a?r.showZeroPlane:1,isNumeric:!0,linecolor:0===a?r.zeroPlaneColor:r.divLineColor,linealpha:0===a?r.zeroPlaneAlpha:r.divLineAlpha,linethickness:0===a?r.zeroPlaneThickness:r.divLineThickness,linedashed:r.divLineIsDashed,linedashLen:r.divLineDashLen,linedashgap:r.divLineDashGap})}this._parseTickValues(c)},a.getInterval=function(){return this.config.axisRange.tickInterval},a._setAxisRange=function(e){var t,a,i,n=e.min,r=e.max,l=this.config,c=l.axisRange,h=l.dataLimit,u=l.dependentInfo;if(!(n>r))if(h.min===n&&h.max===r||(a=!0),void 0===l.visibleMin||l.setPadding||a){var d=(0,o["default"])([n,r,h.min,h.max]);if(n=d[0],r=d[1],h.min=n,h.max=r,this.fireEvent("dataLimitSet",Object.assign({},h)),u){if(u.limit){if(!(t=u.dataLimit))return;var g=(0,o["default"])([n,r,t.min,t.max]);n=g[0],r=g[1],l.isDataLimitSet=!0}if(u.count&&void 0===u.numDivLines)return}(0,s["default"])(n,r,this.getScale(),l),i=l.isZeroTickForced?3:2,this.fireEvent("divlinesSet",l.ticks.length-i),l.tickValues&&this.calculateTicksOnLabelMode(),this.setVisibleConfig(c.min,c.max)}else l.setPadding=!1},a.getTicks=function(){return this.config.ticks},t}(c["default"]);d.prototype.setDataLimit=h.setDataLimit;var g=d;t["default"]=g},482:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(483)),o=i(a(484)),r=function(e,t){return void 0===e&&(e=[]),[(0,n["default"])(e,t),(0,o["default"])(e,t)]};t["default"]=r},483:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){void 0===e&&(e=[]);var a,i,n=e.length,o=-1;if("function"==typeof t){for(;++o<n;)if(null!=(a=t(e[o],o,e))&&a<=a)for(i=a;++o<n;)null!=(a=t(e[o],o,e))&&a<i&&(i=a)}else for(;++o<n;)if(null!=(a=e[o])&&a<=a)for(i=a;++o<n;)null!=(a=e[o])&&a<i&&(i=a);return i};t["default"]=i},484:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){void 0===e&&(e=[]);var a,i,n=e.length,o=-1;if("function"==typeof t){for(;++o<n;)if(null!=(a=t(e[o],o,e))&&a>=a)for(i=a;++o<n;)null!=(a=t(e[o],o,e))&&a>i&&(i=a)}else for(;++o<n;)if(null!=(a=e[o])&&a>=a)for(i=a;++o<n;)null!=(a=e[o])&&a>i&&(i=a);return i};t["default"]=i},485:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=h(a(486)),r=h(a(502)),l=i(a(479)),s=a(503);function c(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(c=function(e){return e?a:t})(e)}function h(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=c(t);if(a&&a.has(e))return a.get(e);var i={},n=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in e)if("default"!==o&&Object.prototype.hasOwnProperty.call(e,o)){var r=n?Object.getOwnPropertyDescriptor(e,o):null;r&&(r.get||r.set)?Object.defineProperty(i,o,r):i[o]=e[o]}return i["default"]=e,a&&a.set(e,i),i}var u=function(e){function t(){return e.call(this,o.deInterpolateLinear,l["default"])||this}(0,n["default"])(t,e);var a=t.prototype;return a.ticks=function(e){void 0===e&&(e=7);var t=this.getDomain();return this.majorTicks=(0,r["default"])(t[0],t[t.length-1],e)},a.tickFormat=function(e,t){return(0,s.tickFormat)(this.getDomain(),e,t,this._localeConverter)},a.nice=function(e){void 0===e&&(e=7);var t,a=this.getDomain(),i=0,n=a.length-1,o=a[i],l=a[n];return l<o&&(t=o,o=l,l=t,t=i,i=n,n=t),(t=(0,r.tickIncrement)(o,l,e))>0?(o=Math.floor(o/t)*t,l=Math.ceil(l/t)*t,t=(0,r.tickIncrement)(o,l,e)):t<0&&(o=Math.ceil(o*t)/t,l=Math.floor(l*t)/t,t=(0,r.tickIncrement)(o,l,e)),t>0?(a[i]=Math.floor(o/t)*t,a[n]=Math.ceil(l/t)*t,this.setDomain(a)):t<0&&(a[i]=Math.ceil(o*t)/t,a[n]=Math.floor(l*t)/t,this.setDomain(a)),this},a.copy=function(){return(0,o.copyScale)(this,new t)},a.minorTicks=function(e,t){void 0===e&&(e=4),void 0===t&&(t=this.majorTicks||this.ticks());var a,i,n,o,r=t.length,l=t[1]-t[0],s=[];for(o=0;o<r-1;++o)for(n=t[o],i=l/(Number(e)+1),a=1;a<=e;a+=1)s.push(n+i*a);return s},a.contextTicks=function(){return this.contextTicksArr||[]},a.getType=function(){return"linear"},t}(o["default"]);t["default"]=u},486:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.copyScale=function(e,t){return t.setInterpolate(e.getInterpolate()).setClamp(e.getClamp()).setDomain(e.getDomain()).setRange(e.getRange())},t.deInterpolateLinear=d,t.bimap=u,t["default"]=void 0;var n=i(a(487)),o=i(a(489)),r=i(a(488)),l=i(a(490)),s=a(491),c=0,h=[0,1];function u(e,t,a,i){var n,o;return e[0]>e[1]?(n=a(e[1],e[0]),o=i(t[1],t[0])):(n=a(e[0],e[1]),o=i(t[0],t[1])),function(e){return o(n(e))}}function d(e,t){var a=Number(e),i=Number(t)-a;return i?function(e){return(e-a)/i}:(0,r["default"])(i)}var g=function(){function e(e,t){this.domain=h,this.range=h,this.deInterpolate=e,this.reInterpolate=t,this.interpolate=n["default"],this.clamp=!1,this.input=null,this.output=null,this.locale=l["default"],this._localeConverter=new s.NumberConverter(l["default"]),this._rescale(),this._id="scale_"+c++}var t=e.prototype;return t._rescale=function(){return this.input=null,this.output=null,this},t.setDomain=function(e){return void 0===e&&(e=h),this.domain=e.map(Number),this._rescale()},t.getDomain=function(){return this.domain.slice()},t.setRange=function(e){return void 0===e&&(e=h),this.range=e.slice(),this._rescale()},t.getRange=function(){return this.range.slice()},t.setInterpolate=function(e){return void 0===e&&(e=n["default"]),this.interpolate=e,this._rescale()},t.getInterpolate=function(){return this.interpolate},t.setClamp=function(e){return void 0===e&&(e=!1),this.clamp=!!e,this._rescale()},t.getClamp=function(){return this.clamp},t.rangeRound=function(e){return void 0===e&&(e=h),this.range=e.slice(),this.interpolate=o["default"],this._rescale()},t.getRangeValue=function(e){var t=null!==e?e:void 0,a=this.getClamp()?function(e){return function(t,a){var i=Number(t),n=Number(a),o=e(i,n);return function(e){return e<=i?0:e>=n?1:o(e)}}}(this.deInterpolate):this.deInterpolate;return this.output||(this.output=u(this.getDomain(),this.getRange(),a,this.interpolate)),this.output(Number(t))},t.getDomainValue=function(e){var t=this.getClamp()?function(e){return function(t,a){var i=Number(t),n=Number(a),o=e(i,n);return function(e){return e<=0?i:e>=1?n:o(e)}}}(this.reInterpolate):this.reInterpolate;return this.input||(this.input=u(this.getRange(),this.getDomain(),d,t)),this.input(Number(e))},t.setLocale=function(e){return void 0===e&&(e=l["default"]),this.locale=e,this._localeConverter=new s.NumberConverter(e),this},t.getLocale=function(){return this.locale},t.getId=function(){return this._id},e}();t["default"]=g},487:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(479)),o=i(a(488));function r(e){return null!=e}var l=function(e,t){var a=n["default"];return r(t)&&r(e)&&"boolean"!=typeof t?a(e,t):(0,o["default"])(t)};t["default"]=l},488:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e){return function(){return e}};t["default"]=i},489:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){var a=Number(e),i=Number(t)-a;return function(e){return Math.round(i*e+a)}};t["default"]=i},490:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i={decimal:".",thousands:",",grouping:[3],prefix:"$",suffix:""};t["default"]=i},491:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=t.NumberConverter=void 0;var n=i(a(490)),o=i(a(492)),r=i(a(494)),l=i(a(500)),s=i(a(501)),c=i(a(495)),h=function(e){return e},u=function(){function e(e){this.localeInfo={group:e.grouping&&e.thousands?(0,l["default"])(e.grouping,e.thousands):h,prefix:e.prefix,suffix:e.suffix,decimal:e.decimal,numerals:e.numerals?(0,s["default"])(e.numerals):h,percent:e.percent||"%",prefixes:e.prefixes||["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"]}}var t=e.prototype;return t.formatter=function(e){return new r["default"](e,this.localeInfo)},t.formatPrefix=function(e,t){var a=new c["default"](e);a.type="f";var i=this.localeInfo.prefix,n=this.localeInfo.suffix,l=Object.assign({},this.localeInfo,{prefix:"",suffix:""}),s=new r["default"](a,l),h=3*Math.max(-8,Math.min(8,Math.floor((0,o["default"])(t)/3))),u=Math.pow(10,-h),d=this.localeInfo.prefixes[8+h/3];return{format:function(e){return i+s.format(u*e)+d+n},setCustomPrefix:function(e){return s.setCustomPrefix(e),this},getCustomPrefix:function(e){return s.getCustomPrefix(e)},setCustomSuffix:function(e){return s.setCustomSuffix(e),this},getCustomSuffix:function(e){return s.getCustomSuffix(e)}}},e}();t.NumberConverter=u;var d=new u(n["default"]);t["default"]=d},492:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(493)),o=function(e){var t=(0,n["default"])(Math.abs(e));return t?t[1]:NaN};t["default"]=o},493:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){var a,i,n;return(a=(n=t?e.toExponential(t-1):e.toExponential()).indexOf("e"))<0?null:[(i=n.slice(0,a)).length>1?i[0]+i.slice(2):i,+n.slice(a+1)]};t["default"]=i},494:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(495)),o=i(a(496)),r=i(a(499)),l=a(497),s=function(e){return null==e},c=function(){function e(e,t){this.specifier=new n["default"](e),this.localeInfo=t;var a=this.specifier.symbol;this.fill=this.specifier.fill,this.align=this.specifier.align,this.sign=this.specifier.sign,this.zero=this.specifier.zero,this.width=this.specifier.width,this.comma=this.specifier.comma,this.precision=this.specifier.precision,this.trim=this.specifier.trim,this.type=this.specifier.type,"n"===this.type?(this.comma=!0,this.type="g"):o["default"][this.type]||(s(this.precision)&&(this.precision=12),this.trim=!0,this.type="g"),(this.zero||"0"===this.fill&&"="===this.align)&&(this.zero=!0,this.fill="0",this.align="="),"$"===a?this.prefix=this.localeInfo.prefix:"#"===a&&/[boxX]/.test(this.type)?this.prefix="0"+this.type.toLowerCase():this.prefix="","$"===a?this.suffix=this.localeInfo.suffix:/[%p]/.test(this.type)?this.suffix=this.localeInfo.percent:this.suffix="",this.formatType=o["default"][this.type],this.mayHaveSuffix=/[defgprs%]/.test(this.type),s(this.precision)?this.precision=6:/[gprs]/.test(this.type)?this.precision=Math.max(1,Math.min(21,this.precision)):this.precision=Math.max(0,Math.min(20,this.precision)),this.setCustomPrefix(""),this.setCustomSuffix("")}var t=e.prototype;return t.format=function(e){var t,a,i,n,o,s,c=this.prefix,h=this.suffix,u=this.formatType,d=e;if("c"===this.type)h=u(d)+h,d="";else if(t=(d=+d)<0,d=u(Math.abs(d),this.precision),this.trim&&(d=(0,r["default"])(d)),t&&0==+d&&(t=!1),c=t?("("===this.sign?this.sign:"-")+c:"-"===this.sign||"("===this.sign?""+c:this.sign+c,h="s"===this.type?this.localeInfo.prefixes[8+l.prefixExponent/3]+h:""+h,h+=t&&"("===this.sign?")":"",this.mayHaveSuffix)for(n=-1,o=d.length;++n<o;)if((s=d.charCodeAt(n))<48||s>57){h=(46===s?this.localeInfo.decimal+d.slice(n+1):d.slice(n))+h,d=d.slice(0,n);break}switch(this.comma&&!this.zero&&(d=this.localeInfo.group(d,Infinity)),i=(a=c.length+d.length+h.length)<this.width?new Array(this.width-a+1).join(this.fill):"",this.comma&&this.zero&&(d=this.localeInfo.group(i+d,i.length?this.width-h.length:Infinity),i=""),this.align){case"<":d=c+d+h+i;break;case"=":d=c+i+d+h;break;case"^":a=i.length/2,d=i.slice(0,a)+c+d+h+i.slice(a);break;default:d=i+c+d+h}return this.getCustomPrefix()+this.localeInfo.numerals(d)+this.getCustomSuffix()},t.setCustomPrefix=function(e){return this._customPrefix=e+"",this},t.getCustomPrefix=function(){return this._customPrefix},t.setCustomSuffix=function(e){return this._customSuffix=e+"",this},t.getCustomSuffix=function(){return this._customSuffix},t.toString=function(){return this.specifier.toString()},e}();t["default"]=c},495:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i,n=function(e){return null==e},o=function(){function e(e){var t=i.exec(e);if(!t)throw new Error("Invalid number format specifier: "+e);this.fill=t[1]||" ",this.align=t[2]||">",this.sign=t[3]||"-",this.symbol=t[4]||"",this.zero=Boolean(t[5]),this.width=t[6]&&Number(t[6]),this.comma=Boolean(t[7]),this.precision=t[8]&&Number(t[8].slice(1)),this.trim=Boolean(t[9]),this.type=t[10]||""}return e.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(n(this.width)?"":Math.max(1,0|this.width))+(this.comma?",":"")+(n(this.precision)?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type},e}();t["default"]=o},496:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(497)),o=i(a(498)),r={"%":function(e,t){return(100*e).toFixed(t)},b:function(e){return Math.round(e).toString(2)},c:function(e){return e+""},d:function(e){return Math.round(e).toString(10)},e:function(e,t){return e.toExponential(t)},f:function(e,t){return e.toFixed(t)},g:function(e,t){return e.toPrecision(t)},o:function(e){return Math.round(e).toString(8)},p:function(e,t){return(0,o["default"])(100*e,t)},r:o["default"],s:n["default"],X:function(e){return Math.round(e).toString(16).toUpperCase()},x:function(e){return Math.round(e).toString(16)}};t["default"]=r},497:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=t.prefixExponent=void 0;var n,o=i(a(493));t.prefixExponent=n;var r=function(e,a){var i,r,l,s,c=(0,o["default"])(e,a);return c?(i=c[0],(l=(r=c[1])-(t.prefixExponent=n=3*Math.max(-8,Math.min(8,Math.floor(r/3))))+1)===(s=i.length)?i:l>s?i+new Array(l-s+1).join("0"):l>0?i.slice(0,l)+"."+i.slice(l):"0."+new Array(1-l).join("0")+(0,o["default"])(e,Math.max(0,a+l-1))[0]):e+""};t["default"]=r},498:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(493)),o=function(e,t){var a,i,o=(0,n["default"])(e,t);return o?(a=o[0],i=o[1],Number(i)<0?"0."+new Array(-i).join("0")+a:a.length>i+1?a.slice(0,i+1)+"."+a.slice(i+1):a+new Array(i-a.length+2).join("0")):e+""};t["default"]=o},499:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e){for(var t,a=e.length,i=1,n=-1;i<a;++i)if("."===e[i])n=t=i;else if("0"===e[i])0===n&&(n=i),t=i;else if(n>0){if(!+e[i])break;n=0}return n>0?e.slice(0,n)+e.slice(t+1):e};t["default"]=i},500:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){return function(a,i){for(var n=a.length,o=[],r=0,l=e[0],s=0;n>0&&l>0&&(s+l+1>i&&(l=Math.max(1,i-s)),o.push(a.substring(n-=l,n+l)),!((s+=l+1)>i));)l=e[r=(r+1)%e.length];return o.reverse().join(t)}};t["default"]=i},501:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e){return function(t){return t.replace(/[0-9]/g,(function(t){return e[+t]}))}};t["default"]=i},502:function(e,t,a){"use strict";t.__esModule=!0,t.tickIncrement=l,t.tickStep=function(e,t,a){void 0===e&&(e=0);void 0===t&&(t=1);void 0===a&&(a=7);var r=Math.abs(t-e)/Math.max(0,a),l=Math.floor(Math.log(r)/Math.LN10),s=Math.pow(10,l),c=r/s;c>=i?s*=10:c>=n?s*=5:c>=o&&(s*=2);return t<e?-s:s},t["default"]=void 0;var i=Math.sqrt(50),n=Math.sqrt(10),o=Math.sqrt(2);function r(e){return e>=i?10:e>=n?5:e>=o?2:1}function l(e,t,a){void 0===e&&(e=0),void 0===t&&(t=1),void 0===a&&(a=7);var i=(t-e)/Math.max(0,a),n=Math.floor(Math.log(i)/Math.LN10),o=i/Math.pow(10,n);return n>=0?r(o)*Math.pow(10,n):-Math.pow(10,-n)/r(o)}var s=function(e,t,a){void 0===e&&(e=0),void 0===t&&(t=1),void 0===a&&(a=7);var i,n,o,r=-1,s=[],c=+t,h=+e,u=+a;if(h===c&&u>0)return[h];if((i=c<h)&&(n=h,h=c,c=n),0===(o=l(h,c,u))||!isFinite(o))return[];if(o>0)for(h=Math.ceil(h/o),c=Math.floor(c/o),n=Math.ceil(c-h+1);++r<n;)s[r]=(h+r)*o;else for(h=Math.floor(h*o),c=Math.ceil(c*o),n=Math.ceil(h-c+1);++r<n;)s[r]=(h-r)/o;return i&&s.reverse(),s};t["default"]=s},503:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.tickIncrement=p,t.tickStep=f,t.tickFormat=function(e,t,a,i){void 0===i&&(i=n["default"]);var c,h,u,g=e[0],p=e[e.length-1],m=f(g,p,d(t)?7:t);switch((u=new l["default"](d(a)?",f":a)).type){case"s":return h=Math.max(Math.abs(g),Math.abs(p)),c=(0,s["default"])(m,h),d(u.precision)&&!isNaN(c)&&(u.precision=c),function(e){return i.formatPrefix(u,h).format(e)};case"":case"e":case"g":case"p":case"r":c=(0,r["default"])(m,Math.max(Math.abs(g),Math.abs(p))),d(u.precision)&&!isNaN(c)&&(u.precision=c-("e"===u.type));break;case"f":case"%":c=(0,o["default"])(m),d(u.precision)&&!isNaN(c)&&(u.precision=c-2*("%"===u.type))}return function(e){return i.formatter(u).format(e)}},t["default"]=void 0;var n=i(a(491)),o=i(a(504)),r=i(a(505)),l=i(a(495)),s=i(a(506)),c=Math.sqrt(50),h=Math.sqrt(10),u=Math.sqrt(2),d=function(e){return null==e};function g(e){return e>=c?10:e>=h?5:e>=u?2:1}function p(e,t,a){void 0===e&&(e=0),void 0===t&&(t=1),void 0===a&&(a=7);var i=(t-e)/Math.max(0,a),n=Math.floor(Math.log(i)/Math.LN10),o=i/Math.pow(10,n);return n>=0?g(o)*Math.pow(10,n):-Math.pow(10,-n)/g(o)}function f(e,t,a){void 0===e&&(e=0),void 0===t&&(t=1),void 0===a&&(a=7);var i=Math.abs(t-e)/Math.max(0,a),n=Math.floor(Math.log(i)/Math.LN10),o=Math.pow(10,n),r=i/o;return r>=c?o*=10:r>=h?o*=5:r>=u&&(o*=2),t<e?-o:o}var m=function(e,t,a){void 0===e&&(e=0),void 0===t&&(t=1),void 0===a&&(a=7);var i,n,o,r,l,s,c=-1,h=[];if(s=+a,(r=+e)===(l=+t)&&s>0)return[r];if((i=l<r)&&(n=r,r=l,l=n),0===(o=p(r,l,s))||!isFinite(o))return[];if(o>0)for(r=Math.ceil(r/o),l=Math.floor(l/o),n=Math.ceil(l-r+1);++c<n;)h[c]=(r+c)*o;else for(r=Math.floor(r*o),l=Math.ceil(l*o),n=Math.ceil(r-l+1);++c<n;)h[c]=(r-c)/o;return i&&h.reverse(),h};t["default"]=m},504:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(492)),o=function(e){return Math.max(0,-(0,n["default"])(Math.abs(e)))};t["default"]=o},505:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(492)),o=function(e,t){var a=Math.abs(e),i=Math.abs(t)-a;return Math.max(0,(0,n["default"])(i)-(0,n["default"])(a))+1};t["default"]=o},506:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(492)),o=function(e,t){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor((0,n["default"])(t)/3)))-(0,n["default"])(Math.abs(e)))};t["default"]=o},507:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(){var e,t,a,i,n,o=[];if(arguments.length>2?(e=arguments.length<=0?undefined:arguments[0],t=arguments.length<=1?undefined:arguments[1],a=arguments.length<=2?undefined:arguments[2]):1===arguments.length?(e=0,t=arguments.length<=0?undefined:arguments[0],a=1):(e=arguments.length<=0?undefined:arguments[0],t=arguments.length<=1?undefined:arguments[1],a=1),i=Math.floor(Math.max(0,Math.ceil((t-e)/a))),isFinite(i))for(n=0;n<i;++n)o.push(a*n+e);return o};t["default"]=i},508:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(507)),o=a(486),r=i(a(479)),l=i(a(483)),s=a(224),c=(0,o.bimap)([2,100],[80,20],o.deInterpolateLinear,r["default"]),h=function(e,t,a,i){var o,r,h,u,d,g,p,f,m,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P=t,_=e,D=i.isPercent?0:i.axisMinValue,I=i.isPercent?100:i.axisMaxValue,M=!!i.adjustDiv,O=i.numDivLines,R=!!i.setAdaptiveMin,B=i.axisRange,V=Math.pow(2,-24),z=!0,G=.2,H=!0,W=i.xAxisLabelMode,j=i.dependentInfo;if(o=i.majorTMNumber!==s.UNDEF?Math.max(0,O-2):O,j&&j.count&&!j.limit&&j.numDivLines!==s.UNDEF&&(o=O=j.numDivLines,M=!1),r=o+1,_===s.UNDEF&&P===s.UNDEF&&(_=0,P=1,z=!1),P===_&&0===P&&(P=1,z=!1),"categories"!==W&&"mixed"!==W||(z=!1),z?(u=Math.floor(Math.log(Math.abs(P))/Math.LN10),h=Math.floor(Math.log(Math.abs(_))/Math.LN10),d=Math.max(h,u),g=Math.pow(10,d),Math.abs(P)/g<2&&Math.abs(_)/g<2&&(d--,g=Math.pow(10,d)),x=Math.floor(Math.log(P-_)/Math.LN10),y=Math.pow(10,x),P-_>0&&g/y>=10&&(g=y,d=x),f=(Math.floor(P/g)+1)*g,m=_<0?(Math.floor(Math.abs(_/g))+1)*g*-1:R?(m=Math.floor(Math.abs(_/g)-1)*g)<0?0:m:0,!R&&P<=0&&(f=0),b=!(!I&&0!==I),v=!(!D&&0!==D),i.freezeLimit||(!1===b||!0===b&&Number(I)<P&&P-Number(I)>V?(P=f,b=!1):P=Number(I),!1===v||!0===v&&Number(D)>_&&Number(D)-_>V?(_=m,v=!1):_=Number(D))):(v=!(!D&&0!==D),!0===(b=!(!I&&0!==I))&&(Number(I)>=P||t===s.UNDEF)?P=Number(I):b=!1,!0===v&&(Number(D)<=_||e===s.UNDEF)?_=Number(D):v=!1),v&&!b&&t===s.UNDEF&&(P=_<0?0:_+1),b&&!v&&e===s.UNDEF&&(_=P>0?0:P-1),w=[_,P],a.setDomain(w),M&&!i.freezeLimit)b||v?(F=(C=(N=function(e,t,a,i,n,o){for(var r,l,c,h,u,d,g,p,f,m,b,v,x=t-e,y=e,C=Math.ceil(a*(1-i)),k=Math.floor(a*(1+i)),S=[],w=-1,A=function(e){return function(e){var t,a,i=[10,5,2,1],n=i.length;for(t=0;t<n;++t)if(e%i[t]%1==0){a=!0;break}return a}(r=x/(e+1))?e:s.UNDEF};!(m&&b||((v=a+ ++w)>=k&&(b=!0),h=A(v))||((v=a-w)<=C&&(m=!0),h=A(v))););for(e<0&&t>0&&n&&(c=!0),l=0;l<h;l++)c&&y<0&&y+r>0&&(S.push(0),u=!0),y+=r,S.push(y);return h===s.UNDEF&&n&&((g=(S=o.ticks(a)).length)>1?(d=.2*(r=Math.abs(S[0]-S[1])),p=S[0],f=S[g-1],Math.abs(e-p)<=d&&0!==p&&S.shift(),Math.abs(t-f)<=d&&0!==f&&S.pop(),0!==p&&0!==f||(u=!0)):0===S[0]&&(u=!0)),c&&!u&&-1===S.indexOf(0)&&(e<0&&S[0]>0?S=[0].concat(S):t>0&&S[S.length-1]<0?S.push(0):S=[0],u=!0),{output:S,interval:r,isZeroTickForced:u}}(_,P,o,G=(E=o)>=100?.2:E<=1?0:c(E)/100,i.forceZeroTick,a)).output).length,T=N.isZeroTickForced,Math.abs((o-F+(T?1:0))/o)>G?p=(P-_)/r:(p=0===F||1===F&&T?P-_:N.interval,i.isZeroTickForced=T,i.ticks=T&&0===_?C.concat(P):[_].concat(C,P),H=!1)):(i.ticks=o?a.nice(r).ticks(r):a.getDomain(),p=Math.abs(i.ticks[1]-i.ticks[0]),H=!1);else if(b||v||i.freezeLimit)p=(P-_)/r;else{var U=a.nice(r).getDomain();((S=(k=U[0])+(p=function(e){if(e<=1)return 1;var t=[],a=Math.ceil(e);return t[2]=a%2,t[5]=a%5,t[10]=a%10,(0,l["default"])(t)+a}(g=((S=U[1])-k)/r))*r)-P)/P>G||(k-_)/_>G?(a.setDomain([_,P]),p=(P-_)/r):(_=k,P=S,a.setDomain([_,P]))}H&&(_<0&&P>0&&i.forceZeroTick?(0===(L=(A=(0,n["default"])(_,0,p))[A.length-1]+p)?L+=p:i.isZeroTickForced=!0,i.ticks=A.concat(0,(0,n["default"])(L,P,p),P)):i.ticks=(0,n["default"])(_,P,p).concat(P));var q=a.getDomain();_=q[0],P=q[1],i._allTicks=i.ticks.slice(),B.tickInterval=p,B.min=_,B.max=P};t["default"]=h},509:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=c(t);if(a&&a.has(e))return a.get(e);var i={},n=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in e)if("default"!==o&&Object.prototype.hasOwnProperty.call(e,o)){var r=n?Object.getOwnPropertyDescriptor(e,o):null;r&&(r.get||r.set)?Object.defineProperty(i,o,r):i[o]=e[o]}i["default"]=e,a&&a.set(e,i);return i}(a(510)),r=a(224),l=a(516),s=i(a(484));function c(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(c=function(e){return e?a:t})(e)}var h=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a._getHMaxLabelDimention=function(e){var t,a,i,n,l,c,h,u,d,g,p,f,m,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P,_,D,I,M,O,R,B,V=this,z=e,G=V.config,H=V.getFromEnv("chart"),W=H.config,j=H.getFromEnv("smartLabel"),U=G.axisRange,q=G.labels,Y=G.labelDisplay,X=G.slantLabel,K=q.style,Z=G.maxLabelHeight,J=V.getInterval(),$=G.staggerLines,Q=G.labelStep,ee=W.canvasLeft,te=W.canvasRight,ae=$-2,ie=U.max,ne=U.min,oe=0,re=G.tickValues&&G.tickValues.tickValue,le=re&&re.length,se=H.distributedColumns,ce=0,he={text:r.UNDEF,width:0,style:r.UNDEF},ue=0,de=4,ge=r.stubFN,pe=r.stubFN,fe=r.stubFN,me={},be=0,ve=!1,xe=0,ye=!1,Ce=Number.POSITIVE_INFINITY,ke=G.ticks,Se=Number.POSITIVE_INFINITY;if(se)for(x=0;x<le;x++)re[x+1]?re[x].x&&(re[x].plotWidth=V.getPixel(re[x+1].x-re[x].x)-V.getPixel(0)):re[x].plotWidth=V.getPixel(W.canvasRight-re[x].x)-V.getPixel(0);if(G.tickValues&&(!re||0===re.length))return{width:0,height:0};function we(e,t){switch(t.toLowerCase()){case"left":return Math.abs(V._getCustomPixel(e));case"right":return Math.abs(W.width-V._getCustomPixel(e))}}if("rotate"===Y&&(G.rotateLabels=1),G.tickValues||(G.irregularCatAxis=!1),G.sWidthAdjstFactor=a=0===ae?1:1===ae?1.5:ae,j.useEllipsesOnOverflow(W.useEllipsesWhenOverflow),j.setStyle({fontSize:K.fontSize,fontFamily:K.fontFamily,lineHeight:K.lineHeight,fontWeight:K.fontWeight}),G.irregularCatAxis){for(re.sort((function(e,t){return e.x-t.x})),x=0,ce=re.length;x<ce;x++){if(l=re[x],void 0!==A){if(Se=Math.abs(l.x-A),N=Math.abs(V._getCustomPixel(ne)-V._getCustomPixel(ne+Se)),j.setStyle(Object.assign({},l.style)),N<1.2*j.getOriSize("W").width){l.label=r.BLANKSTRING,Se=Ce;continue}F._individualIWR=N,l._individualIWL=N,Ce=Se}F=l,A=l.x}for(Se===Number.POSITIVE_INFINITY&&(Se=Math.floor(Math.min(l.x,ie-l.x)),Se=Math.max(Se,4)),x=0,ce=re.length;x<ce;x++)l=re[x],x||(l._individualIWL=Infinity),x===ce-1&&(l._individualIWR=Infinity),l.individualIW=Math.min(l._individualIWL,l._individualIWR);h=Math.abs(V._getCustomPixel(ne)-V._getCustomPixel(ne+Se)),h=Math.min(2*we(re[0].x,"left"),2*we(re[ce-1].x,"right"),h)}else h=Math.abs(V._getCustomPixel(ne)-V._getCustomPixel(ne+J));if(z=Z||z,me.__root__={getHeight:function(e){var t=re[e]._ovrStyle.lineHeight;return parseInt(t.replace(/(\d+)px/,"$1"),10)},getWidth:function(){return z},getCalculatedLabelStep:function(e){var t,a,i,n,o,l,d,g,p,f,m,b=0,v=e.length,x=Number.NEGATIVE_INFINITY,y={},C=0,k=G.rotateLabels,S="wrap"===Y||"auto"===Y;for(b=0;b<v;b++)(n=e[b]).style=n.style||{};if(G.irregularCatAxis)return G.labelStep;for(b=0;b<v;b++)(n=e[b])&&(n.label||(n.label=""),o=n.oriLabel||n.label,c={fontSize:K.fontSize,fontFamily:K.fontFamily,lineHeight:K.lineHeight,fontWeight:K.fontWeight},C++,n.style=n.style||{},(0,r.extend2)(c,n.style),y[t=c.fontSize+c.fontFamily+c.lineHeight+c.fontWeight]?o.length>y[t].label.length&&(y[t].label=o):y[t]={label:o,style:c});for(l in y)y.hasOwnProperty(l)&&(a=y[l].style,i=y[l].label,a.lineHeight=(0,r.setLineHeight)(a),j.setStyle(a),k&&(p=parseInt(a.lineHeight,10)),u=j.getSmartText(i,r.UNDEF,p),(g=0===k?u.width>60?60:u.width:u.height)>x&&(x=g,f=y[l]));if((S&&(x=Math.min(R,x)),d=Math.floor(Math.abs(V._getCustomPixel(ie)-V._getCustomPixel(ne))/x),m=Math.max(Math.ceil(C/d),G.labelStep),h=Math.abs(V._getCustomPixel(ne)-V._getCustomPixel(ne+m)),S&&0===k)&&(j.setStyle(f.style),(0,s["default"])(Object.values(j.getOriSize(f.label).detailObj))>h-2*de))return m+=1,h=Math.abs(V._getCustomPixel(ne)-V._getCustomPixel(ne+m)),m;return C<=d?G.labelStep:m}},me._inProp={},me.getCopyById=function(e){var t,a=this._inProp,i=this.__root__,n=a.copyStore;return(t=(n=n||{})[e])||(0,r.extend2)(t=n[e]={},i),t},G.tickValues){switch(Y){case"rotate":q.rotation=X?300:270,p=me.getCopyById("rotate");break;case"stagger":(p=me.getCopyById("stagger")).getHeight=function(e){var t,a;return a=(t=G.tickValues.tickValue[e])&&t.style||(t.style={}),c={fontSize:K.fontSize,fontFamily:K.fontFamily,lineHeight:K.lineHeight,fontWeight:K.fontWeight},(0,r.extend2)(c,a),j.setStyle(c),j.getOriSize(t.label).height},p.getWidth=function(e){return de=1,e.individualIW?e.individualIW:2*h*a-de},fe=function(e){var t,a,i,n,o,r,l=e.length,s=0;if(j.setStyle(K),i=j.getOriSize("WWW").height,a=e[l-1],Math.floor(a._cumulativeSum)<=Math.ceil(l*(i+2)))o=Math.floor(z/i),$=o-$<0?o:$;else{o=Math.floor(z/(i+4));do{for(s=0,n=(r=o)-1,l=e.length;n<l;){if(l-n<o&&(n=l-1),~~((t=e[n])._cumulativeSum-s)>-~z){ve=!0;break}ve=!1,s=t._cumulativeSum,n+=r}}while(o--&&ve);o++,$=Math.min($,o)}G.drawnStaggerLines=$},ge=function(e){var t,a,n,o,r=0;for(o=0,a=e.length;o<a;o++)(t=e[o]).stepSkipped||((n=(t&&t.style||{}).lineHeight)||(n=K.lineHeight),i=r++%$,t.labelPadding=i?n.replace(/px/i,"")*i:0)};break;case"none":(p=me.getCopyById("none")).getHeight=r.stubFN,p.getWidth=r.stubFN,pe=r.stubFN,G.rotateLabels&&(q.rotation=X?300:270,L=z),p.getCalculatedLabelStep=function(){return G.labelStep};break;default:(p=me.getCopyById("auto")).getHeight=function(){return z},p.getWidth=function(e){return e.individualIW?e.individualIW:h-2*de},j.setStyle(he.style),B=j.getOriSize("WWW"),R=B.width,pe=function(e,t){var a,i,n,o;if(!G.irregularCatAxis&&(j.setStyle(e),B=j.getOriSize("WWW"),(R=B.width)>=h&&0!==G.rotateLabels)){for(q.rotation=X?300:270,q.forceRotate=!0,p=me.getCopyById("rotate"),d=p.getWidth,g=p.getHeight,he.width=0,a=0,i=t.length;a<i;a++)(n=t[a])&&(n.label||n.oriLabel)&&0!==(0,r.pluckNumber)(n.showlabel,G.showLabels,1)&&!0!==n.stepSkipped&&(o=n._ovrStyle,j.setStyle({fontSize:o.fontSize,fontFamily:o.fontFamily,lineHeight:o.lineHeight,fontWeight:o.fontWeight}),u=j.getSmartText(n.oriLabel,d(n),g(a)),n.label=u.text,n.labelTooltext=u.tooltext,n._sLabel=u,he.width<u.width&&(he.text=u.text,he.width=u.width,he.height=u.height,he.style=o));f=he.text}}}for(d=p.getWidth,g=p.getHeight,Q=G.labels.step=G.labelStep=G._oriLabelStep,Q=G.labels.step=G.labelStep=p.getCalculatedLabelStep(re),x=(0,o.minimumEnquiry)(re),m=0,y=0,ce=re.length;x<ce;x++,m++)(l=re[x])&&(l.label||l.oriLabel)&&0!==(0,r.pluckNumber)(l.showlabel,G.showLabels,1)&&(ye=!0,c={fontSize:K.fontSize,fontFamily:K.fontFamily,lineHeight:K.lineHeight,fontWeight:K.fontWeight},(0,r.extend2)(c,l.style),c.lineHeight=(0,r.setLineHeight)(c),(I=c.fontSize+c.fontFamily+c.lineHeight+c.fontWeight)!==D&&(j.setStyle(c),D=I),m%Q?(l.stepSkipped=!0,l.appliedSmartLabel=!1,xe++):(l.appliedSmartLabel=!0,l.stepSkipped=!1,l._ovrStyle=c,re[x].plotWidth?t=Math.max("rotate"===Y?re[x].plotWidth-6:0,g(x)):("rotate"===Y?x<ce-1&&(n=V.getPixel(x+1)-V.getPixel(x)-10):n=0,"rotate"===Y&&isNaN(+n)&&(n=W.canvasWidth/V.getVisibleLength()-3),t=Math.max(n,g(x))),be+=(u=j.getSmartText(l.oriLabel||l.label,d(l),t)).height+2,V.components.labels[y++]={config:{width:u.width,height:u.height,props:{label:{}}}},l._cumulativeSum=be,l.oriLabel=l.oriLabel||l.label,l.label=u.text,l.labelTooltext=u.tooltext,l._sLabel=u,he.width<u.width&&((0,r.extend2)(he,u),he.style=c),ue<u.height&&(ue=u.height)));if(!ye)return{height:0,width:0};if(fe(re,xe),ge(re,xe),pe(he.style,re),f=he.text||"","mixed"===G.xAxisLabelMode)for(S=G.isPercent?H.getFromEnv("number-formatter").percentValue:H.getFromEnv("number-formatter").xAxis,oe=f.length,x=0,M=ke&&ke.length;x<M;++x)k=ke[x],(C=""+S.call(H.getFromEnv("number-formatter"),k,G.axisIndex)).length>oe&&(f=C,oe=C.length);for(he.height=Math.max(ue,he.height||0),P=re.length,x=0,ce=re.length;x<ce&&!(T=re[x])._sLabel;x++);for(x=(ce=re.length)-1;x>=0&&!(E=re[x])._sLabel;x--);_=1!==V.getZoom(),q.rotation||_||!T._sLabel?(G.axisEndLabelDisplaySpace.left=0,G.axisEndLabelDisplaySpace.right=0):(G.axisEndLabelDisplaySpace.left=Math.max(ee-(V._getCustomPixel(T.x||0)-T._sLabel.width/2),0),G.axisEndLabelDisplaySpace.right=Math.max(V._getCustomPixel(E.x||P-1)+E._sLabel.width/2-te,0)),w=he}else{for(S=G.numberFormatterFn?H.getFromEnv("number-formatter")[G.numberFormatterFn]:G.isPercent?H.getFromEnv("number-formatter").percentValue:H.getFromEnv("number-formatter").xAxis,x=0,M=ke&&ke.length;x<M;++x)O=ke[x],k=(0,r.toPrecision)(O,10),C=""+S.call(H.getFromEnv("number-formatter"),k,G.axisIndex),O===ne&&(b=C),O===ie&&(v=C),w=j.getOriSize(C),V.components.labels[x]={config:{width:w.width,height:w.height,props:{label:{}}}},C.length>oe&&(f=C,oe=C.length);j.setStyle({fontSize:K.fontSize,fontFamily:K.fontFamily,lineHeight:K.lineHeight,fontWeight:K.fontWeight}),w=j.getOriSize(f||""),"rotate"===Y&&(q.rotation=270),G.rotateLabels&&(q.rotation=X?300:270),q.rotation||(b=j.getOriSize(b||""),v=j.getOriSize(v||""),G.axisEndLabelDisplaySpace.left=b.width/2+2,G.axisEndLabelDisplaySpace.right=v.width/2+2)}return G.tickValues&&"stagger"===Y&&(w.height=$*he.height),w.width=L?Math.min(L,w.width):w.width,w.width=(0,r.pluckNumber)(w.width),w.maxWidth=(0,r.pluckNumber)(w.maxWidth),w},a._getVMaxLabelDimention=function(e){var t,a,i,n,o,l,s,c,h,u,d,g,p,f,m=e,b=this.config,v=this.getFromEnv("chart"),x=v.config,y=v.getFromEnv("smartLabel"),C=b.labels.style,k=b.useEllipsesWhenOverflow,S=b.maxLabelWidthPercent,w=b.minLabelWidthPercent,A=0,L=v.getFromEnv("dataSource").categories,N={height:0,width:0},F=b.ticks,T={};if(y.useEllipsesOnOverflow(x.useEllipsesWhenOverflow),y.setStyle({fontSize:C.fontSize,fontFamily:C.fontFamily,lineHeight:C.lineHeight,fontWeight:C.fontWeight}),b.tickValues){for(L&&(T={fontFamily:L[0].font,fontSize:L[0].fontsize,color:L[0].fontcolor}),S&&(a=S/100*x.width)<m&&(m=a),w&&(i=w/100*x.width)>m&&(m=i),n=0,h=(c=b.tickValues.tickValue).length;n<h;n++)if(u=c[n],0!==(0,r.pluckNumber)(u.showlabel,b.showLabels)){p={fontFamily:(0,r.pluck)(u.font,u.labelfont,T.fontFamily,C.fontFamily),fontSize:(0,r.pluck)(this.computeFontSize(u.fontsize),u.labelfontsize,T.fontSize,C.fontSize).toString().replace(/px/i,"")+"px",fontWeight:"normal"===C.fontWeight?(0,r.pluckNumber)(u.fontbold,u.labelfontbold,0)?"bold":"normal":C.fontWeight,fontStyle:"normal"===C.fontStyle?(0,r.pluckNumber)(u.fontitalic,u.labelfontitalic,0)?"italic":"normal":C.fontStyle},(f={fontFamily:(0,r.pluck)(p.fontFamily,T.fontFamily,C.fontFamily),fontSize:(0,r.pluck)(p.fontSize,T.fontSize,C.fontSize),fontWeight:(0,r.pluck)(p.fontWeight,C.fontWeight),fontStyle:(0,r.pluck)(p.fontStyle,C.fontStyle)}).lineHeight=(0,r.setLineHeight)(f);var E=y.setStyle(f),P=E&&E.style&&E.style.lineHeight?E.style.lineHeight:C.lineHeight;d=y.getSmartText(u.oriLabel||u.label,m,P.toString().replace(/px/i,""),k),this.components.labels[n]={config:{width:d.width,height:d.height,props:{label:{}}}},u.oriLabel=u.oriLabel||u.label,u.label=s=d.text,u.labelTooltext=d.tooltext,d.width>A&&(N=d,A=d.width)}return N}for(g=b.numberFormatterFn?v.getFromEnv("number-formatter")[b.numberFormatterFn]:b.isPercent?v.getFromEnv("number-formatter").yAxisPercentValue:v.getFromEnv("number-formatter").yAxis,n=0,o=F&&F.length;n<o;++n)l=(0,r.toPrecision)(F[n],10),s=""+g.call(v.getFromEnv("number-formatter"),l,b.axisIndex),d=y.getSmartText(s),this.components.labels[n]={config:{width:d.width,height:d.height,props:{label:{}}}},s.length>A&&(t=s,A=s.length);return y.getOriSize(t)},a.getCleanValue=function(e,t){return this.getFromEnv("number-formatter").getCleanValue(e,t)},a.generateMinorTicks=function(){if(this)return[]},a.setCanvas=function(e){this.config.canvas=e},a._adjustNumberFormatter=function(e){var t,a,i=this.config,n=i.axisIndex,o=i.isVertical,l=this.getFromEnv("chart").getFromEnv("number-formatter"),s=i._defaultDecimalPrecision,c=i._defaultForceDecimal,h=0;a=o||"yAxis"===i.numberFormatterFn?(l.Y[n]||l.Y[0]).yAxisLabelConf:l.paramX,s!==r.UNDEF?a.decimalprecision=s:i._defaultDecimalPrecision=a.decimalprecision,c!==r.UNDEF?a.forcedecimals=c:i._defaultForceDecimal=a.forcedecimals,parseInt(e,10)>0||(t=e.toString().split(".")[1])&&((h=t.match(/^[0]*/)[0].length+1)>a.decimalprecision&&(a.forcedecimals=1),a.decimalprecision=Math.max(h,a.decimalprecision))},a.setLabelConfig=function(e){var t,a=this.config.labels;for(t in e)e.hasOwnProperty(t)&&(a[t]=e[t])},t}(o["default"]);h.prototype._parseLabel=l._parseLabel,h.prototype._drawLabel=l._drawLabel,h.prototype.getTrendLineLimits=l.getTrendLineLimits,h.prototype.setAxisPadding=l.setAxisPadding,h.prototype.getLabel=l.getLabel;var u=h;t["default"]=u},510:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.minimumEnquiry=t.getCrispPath=t["default"]=void 0;var n=i(a(238)),o=i(a(511)),r=a(224),l=i(a(512)),s=i(a(513)),c=i(a(514)),h=a(232),u=a(516),d=function(e,t){var a,i,n=!1,o=t%2;return e[1]===e[4]&&(a=e[1],i=Math.round(a),e[1]=e[4]=o?i>a?i-.5:i+.5:i,n=!0),e[2]===e[5]&&(a=e[2],i=Math.round(a),e[2]=e[5]=o?i>a?i-.5:i+.5:i,n=!0),{path:e,isCrisped:n}},g=function(e){return function(t,a){return!!(e.minValue<=t&&e.maxValue>=t||e.minValue<=a&&e.maxValue>=a)}},p=function(e){return function(t){return!!(e.minValue<=t&&e.maxValue>=t)}},f={wrtVisible:!0},m=function(e){for(var t=0,a=e.length;t<a;t++)if(e[t].label||e[t].oriLabel)return t};t.minimumEnquiry=m,t.getCrispPath=d,(0,h.addDep)({name:"cartesianAxisAnimation",type:"animationRule",extension:l["default"]});var b=function(e){function t(){var t;return(t=e.call(this)||this).config.referenceInfo=[],t.config.prevTicks=[],t.config.prevIntervalArr=[],t.config.prevTrendLabels=[],t.config.prevCategoryIntervalArr=[],t}(0,n["default"])(t,e);var a=t.prototype;return a.placeAxis=function(e){var t=this.getScale(),a=this.getFromEnv("chart"),i=this.config,n=i.isVertical,o=i.isReverse,l=a.config,s=l.dataLabelStyle,c=i.name.style,h=i.trend.trendStyle,u=i.labels.style,d=i.parsedTrendLabels||[],g=i.parsedVlineInfo||[];return c.fontSize=this.computeFontSize(c.fontSizeWithUnit),c.lineHeight=(0,r.setLineHeight)(c),h.fontSize=this.computeFontSize(h.fontSizeWithUnit),h.lineHeight=(0,r.setLineHeight)(h),u.fontSize=this.computeFontSize(u.fontSizeWithUnit),u.lineHeight=(0,r.setLineHeight)(u),s.fontSize=this.computeFontSize(s.fontSizeWithUnit),(0,r.setLineHeight)(s),d.forEach((function(e){e.css.fontSize=h.fontSize,e.css.lineHeight=h.lineHeight})),g.forEach((function(e){e.text&&(e.text.css.fontSize=l.style.inCanfontSize,e.text.css.lineHeight=l.style.inCanLineHeight)})),n?(o?t.setRange([l.canvasBottom,l.canvasTop]):t.setRange([l.canvasTop,l.canvasBottom]),this._placeVerticalAxis(e)):(o?t.setRange([l.canvasRight,l.canvasLeft]):t.setRange([l.canvasLeft,l.canvasRight]),this._placeHorizontalAxis(e))},a._placeVerticalAxis=function(e){var t,a,i,n,o,l,s,c,h,u,d,g,p,f,m,b,v,x,y=e,C=this.config,k=this.getFromEnv("chart"),S=k.config,w=k.getFromEnv("smartLabel"),A=C.axisRange,L=C.minLabelWidthPercent,N=C.name,F=C.isOpposit,T=this.getFromEnv("number-formatter"),E=S.canvasHeight,P=C.labelPadding=(0,r.pluckNumber)(C.rawAttr.axisValuePadding,4),_=(0,r.pluckNumber)(C.rawAttr.axisNamePadding,5),D=C.useEllipsesWhenOverflow,I=C.name.style,M=C.trend.trendStyle,O=C.axisName,R=C.trendLines,B=C.drawLabelsOpposit,V=C.drawAxisNameOpposit,z=0,G=0,H=0,W=0,j=0,U=0,q={left:0,right:0},Y=r.BLANKSTRING,X=r.BLANKSTRING,K=0,Z=-1;if(L&&(Z=L/100*S.width),C.oriCanvasHeight=E,P<0&&(C.labelPadding=2),b=C.drawTick&&C.tickLength?C.axisLineThickness+C.tickLength:C.axisLineThickness,C.showAxisLine?(C.labelPadding=(0,r.pluckNumber)(P,2)+b,C.labelPadding<0&&(C.labelPadding=(C.axisLineThickness<0?0:b)+2),y-=C.axisLineThickness):(C.labelPadding=(0,r.pluckNumber)(P,2),C.labelPadding<0&&(C.labelPadding=2)),h=A.max,u=A.min,C.name.rotation=0,C.labels.step=C.labelStep,C.labels.isDraw=1,C.labels.drawNormalVal=C.showDivLineValues,C.labels.drawLimitVal=C.showLimits,K=I.lineHeight,K=Number(K.replace(/px/i,"")),O&&K<y&&(y-=K),1!==C.showLimits&&1!==C.showDivLineValues&&(C.labels.isDraw=0),((g=C.drawLabels?this._getVMaxLabelDimention(y-C.labelPadding):{width:0,height:0}).width+C.labelPadding>y&&!C.tickValues||0===g.width)&&(C.labels.isDraw=0),C.labels.isDraw&&(C.labelMaxW=g.width>Z?g.width:Z,C.labelMaxH=g.height,H=z=C.labelMaxW+C.labelPadding),C.drawTrendLines&&C.drawTrendLabels&&R&&R.length){for(n=C.isPercent?T.percentValue:C.isVertical?T.yAxis:T.xAxis,w.useEllipsesOnOverflow(S.useEllipsesWhenOverflow),w.setStyle({fontSize:M.fontSize,fontFamily:M.fontFamily,lineHeight:M.lineHeight,fontWeight:M.fontWeight}),t=0,a=R.length;t<a;t+=1)for(c=0,p=R[t].line&&R[t].line.length;c<p;c+=1)f=R[t].line[c],v=T.getCleanValue((0,r.pluck)(f.startvalue,f.value,0)),x=(0,r.pluckNumber)(f.endvalue,v),v<=h&&v>=u&&x<=h&&x>=u&&(s=1===(m=(0,r.pluckNumber)(f.valueonright,F?1:0))?f.endvalue||f.startvalue:f.startvalue||f.endvalue,(d=(0,r.parseUnsafeString)(f.origText||f.displayvalue||s||""))===s&&(d=""+n.call(T,d)),m?d.length>X.length&&(X=d):d.length>Y.length&&(Y=d));for(U=(g=w.getOriSize(X)).width?g.width+C.labelPadding:0,j=(g=w.getOriSize(Y)).width?g.width+C.labelPadding:0,F?(U>H&&U>y&&(U=y),j>y-(H=Math.max(H,U+C.labelPadding))&&(j=Math.min(j,y-H))):(j>H&&j>y&&(j=y),U>y-(H=Math.max(H,j+C.labelPadding))&&(U=Math.min(U,y-H))),t=0,a=R.length;t<a;t+=1)for(c=0,p=R[t].line&&R[t].line.length;c<p;c+=1)f=R[t].line[c],v=T.getCleanValue((0,r.pluck)(f.startvalue,f.value,0)),x=(0,r.pluckNumber)(f.endvalue,v),d=1===Number(f.valueonright)?f.origText||f.displayvalue||""+x||"":f.origText||f.displayvalue||""+v||"",(d=(0,r.parseUnsafeString)(""+d))!==f.endvalue&&d!==f.startvalue||(d=""+n.call(T,d)),f.origText=d,l=(m=(0,r.pluckNumber)(f.valueonright,F?1:0))?w.getSmartText(d,U,k.config.canvasHeight,D):w.getSmartText(d,j,k.config.canvasHeight,D),(i=C.parsedTrendLabels[G++])&&(i.attr.text=f.displayvalue=l.text),l.tooltext?(f.valueToolText=l.tooltext,i&&(i.valueToolText=f.valueToolText)):(delete f.valueToolText,i&&delete i.valueToolText)}return y+=K,!C.drawAxisName||y-H-U<=0||""===O?(N.isDraw=!1,N.value=r.BLANKSTRING):(w.setStyle({fontSize:I.fontSize,fontFamily:I.fontFamily,lineHeight:I.lineHeight,fontWeight:I.fontWeight}),N.isDraw=!0,C.rotateAxisName?(C.name.rotation=F?90:270,o=w.getSmartText(O,E,y-H-U),N.value=O,C.nameMaxW=Math.min(o.height),W=C.nameMaxW+_):(o=w.getSmartText(O,y-H-U,E),N.value=O,C.nameMaxW=Math.min(o.width,y-H),C.nameMaxH=o.height,C.axisNameWidth>=0&&(C.nameMaxW=Math.min(C.nameMaxW,C.axisNameWidth)),W=C.nameMaxW+_)),F?(B?(q.left+=Math.max(z,j),q.right+=U):(q.left+=j,q.right+=Math.max(z,U)),V?(C.axisNamePadding=q.left+_,q.left+=W):(C.axisNamePadding=q.right+_,q.right+=W)):(B?(q.left+=j,q.right+=Math.max(z,U)):(q.left+=Math.max(z,j),q.right+=U),V?(C.axisNamePadding=q.right+_,q.right+=W):(C.axisNamePadding=q.left+_,q.left+=W)),N.isDraw&&C.axisNamePadding+C.nameMaxW>y&&(C.axisNamePadding=y-C.nameMaxW,W=C.nameMaxW+C.axisNamePadding-H),q},a._placeHorizontalAxis=function(e){var t,a,i,n,o,l,s,c,h,u,d,g,p,f,m,b,v,x,y=e,C=this.config,k=this.getFromEnv("chart"),S=k.config,w=k.getFromEnv("smartLabel"),A=C.axisRange,L=C.name,N=C.isOpposit,F=k.getFromEnv("number-formatter"),T=C.drawLabelsOpposit,E=C.drawAxisNameOpposit,P=0,_=S.canvasWidth,D=C.labelPadding=(0,r.pluckNumber)(C.rawAttr.axisValuePadding,4),I=(0,r.pluckNumber)(C.rawAttr.axisNamePadding,5),M=C.useEllipsesWhenOverflow,O=C.name.style,R=C.trend.trendStyle,B=C.axisName,V=C.vTrendLines,z=0,G=0,H=0,W={top:0,bottom:0},j=0,U=0;if(D<0&&(C.labelPadding=2),b=C.drawTick&&C.tickLength?C.axisLineThickness+C.tickLength:C.axisLineThickness,C.showAxisLine?(C.labelPadding=(0,r.pluckNumber)(D,2)+b,C.labelPadding<0&&(C.labelPadding=(C.axisLineThickness<0?0:b)+2),y-=C.axisLineThickness):(C.labelPadding=(0,r.pluckNumber)(D,2),C.labelPadding<0&&(C.labelPadding=2)),s=A.max,c=A.min,C.labels.rotation=0,C.labels.step=C.labelStep,C.labels.isDraw=1,C.labels.drawNormalVal=C.showDivLineValues,C.labels.drawLimitVal=C.showLimits,U=O.lineHeight,U=Number(U.replace(/px/i,"")),B&&U<y&&(y-=U),C.rotateLabels&&"stagger"!==C.labelDisplay&&"none"!==C.labelDisplay&&(C.labelDisplay="rotate"),1!==C.showLimits&&1!==C.showDivLineValues&&(C.labels.isDraw=0),f=C.drawLabels?this._getHMaxLabelDimention(y-C.labelPadding):{width:0,height:0},C.labels.rotation?f.width+C.labelPadding>y&&!C.tickValues&&(C.labels.isDraw=0):f.height+C.labelPadding>y&&!C.tickValues&&(C.labels.isDraw=0),C.labels.isDraw&&(C.labels.rotation?(C.labelMaxW=f.height,C.labelMaxH=f.width,P=f.width+C.labelPadding):(C.labelMaxW=f.width,C.labelMaxH=f.height,P=f.height+C.labelPadding),z=P),d=(z=Math.max(z,C.labelPadding))<=y?y-z:y,C.drawTrendLines&&C.drawTrendLabels&&V&&C.isActive)for(m=C.isPercent?this.getFromEnv("number-formatter").percentValue:C.isVertical?this.getFromEnv("number-formatter").yAxis:this.getFromEnv("number-formatter").xAxis,w.useEllipsesOnOverflow(S.useEllipsesWhenOverflow),w.setStyle({fontSize:R.fontSize,fontFamily:R.fontFamily,lineHeight:R.lineHeight,fontWeight:R.fontWeight}),a=0,i=V.length;a<i;a+=1)for(l=0,u=V[a].line&&V[a].line.length;l<u;l+=1)g=V[a].line[l],v=F.getCleanValue((0,r.pluck)(g.startvalue,g.value,0)),x=(0,r.pluckNumber)(g.endvalue,v),v<=s&&v>=c&&x<=s&&x>=c&&(t=1===(0,r.pluckNumber)(g.valueonright,0)?g.endvalue||g.startvalue:g.startvalue||g.endvalue,(h=(0,r.parseUnsafeString)(g.origText||g.displayvalue||t||""))===t&&(h=""+m.call(k.getFromEnv("number-formatter"),h)),g.origText=h,d-((p=w.getSmartText(h,k.canvasWidth,R.lineHeight,M)).height+2)<0?g.displayvalue=r.BLANKSTRING:((n=C.parsedTrendLabels[G++])&&(n.attr.text=g.displayvalue=p.text),j=j<p.height?p.height:j),p.tooltext?(g.valueToolText=p.tooltext,n&&(n.valueToolText=g.valueToolText)):(delete g.valueToolText,n&&delete n.valueToolText));return d-=j,z+=N?0:j,d+=U,y+=U,!C.drawAxisName||d<=0||""===B?(L.isDraw=!1,L.value=r.BLANKSTRING):(w.setStyle({fontSize:O.fontSize,fontFamily:O.fontFamily,lineHeight:O.lineHeight,fontWeight:O.fontWeight}),L.isDraw=!0,o=w.getSmartText(B,_,d),L.value=B,C.nameMaxW=_,C.nameMaxH=o.height,H=o.height+I,C.axisNamePadding=I+z,C.axisNamePadding+o.height>y&&(C.axisNamePadding=y-o.height,H=o.height+C.axisNamePadding-z)),N?(T?W.bottom+=P+j:(W.top+=P,W.bottom+=j),C.trendBottomPadding=W.bottom-j+2,E?W.bottom+=H:W.top+=H):(T?(W.top+=P,W.bottom+=j):W.bottom+=P+j,C.trendBottomPadding=W.bottom-j+2,E?W.top+=H:W.bottom+=H),W},a._parseCategoryPlotLine=function(){var e,t,a,i=this.config,n=i.axisRange,o=i.tickValues.tickValue,l=(0,r.convertColor)(i.divLineColor,i.divLineAlpha),s=i.divLineThickness,c=i.divLineIsDashed?(0,r.getDashStyle)(i.divLineDashLen,i.divLineDashGap,s):r.DASH_DEF,h=p(this.getVisibleConfig()),u=i._allTicks,d=u.length;if(e={stroke:l,"stroke-width":s,"stroke-dasharray":c},(!o[0]||o[0].x===r.UNDEF&&o[0].y===r.UNDEF)&&i.lines.isDraw&&i.categoryNumDivLines)for(t=0;t<d;++t)h(a=u[t])&&a!==n.min&&a!==n.max&&this.setReferenceInfo({from:a,type:"line",layer:1,attr:e})},a._drawComponents=function(){var e=this.config;e.drawAxisName&&this._drawAxisName(),e.drawAxisLine&&this._drawAxisLine(),e.tickValues?e.drawLabels&&this._drawCategory():e.drawLabels&&this._drawLabel(),e.drawTrendLines&&this.drawTrendLabel()},a.drawTrendLabel=function(){var e,t,a,i,n,o,l,s,h,u,d,g,p,m,b,v,x=this.config,y=x.parsedTrendLabels,C=this.getFromEnv("animationManager"),k=this.getFromEnv("toolTipController"),S=x.axisTrendLabelContainer,w=x.isOpposit,A=x.labelPadding,L=x.vTrendLines,N=x.trendLines,F=x.axisDimention,T=this.getVisibleConfig(),E=T.minValue,P=T.maxValue,_=!0;for(b=0,v=y.length;b<v;b++)y[b].id=b+"_trend";for(L?i=w?F.opposite+(x.trendBottomPadding||0):F.y+(x.trendBottomPadding||0):(i=w?F.opposite-(A||0):F.x-(A||0),n=w?F.x+(A||0):F.opposite+(A||0)),b=0,v=(p=(0,c["default"])((function(e,t){return e.attr.text===t.attr.text}),x.prevTrendLabels,y)).length;b<v;b++)(g=this.getGraphicalElement(p[b].id))&&this.removeGraphicalElement(g);if(x.prevTrendLabels=(0,r.extend2)([],y),x.drawTrendLabels)for(b=0,v=y.length;b<v;b++)t=y[b],a=this.getGraphicalElement(b+"_trend"),l=+t.from,h=+t.to,_=!0,(m=!isNaN(h))?(E>(s=l+(h-l)/2)||P<s)&&(_=!1):(E>l||P<l)&&(_=!1),_?(L?(u=this.getPixel(l,f),d=m?this.getPixel(h,f):0,o=(0,r.pluckNumber)(t.isTrendZone,x.isTrendZone,1),m&&h!==l&&o?(t.attr.x=u+(d-u)/2,t.attr.y=i):(t.attr.x=m?d:u,t.attr.y=i)):N&&(u=this.getPixel(l,f),d=m?this.getPixel(h,f):0,e=(0,r.pluckNumber)(t.valueOnRight,x.isOpposit?1:0),o=(0,r.pluckNumber)(t.isTrendZone,x.isTrendZone,0),m&&h!==l&&o?(t.attr.x=e?n:i,t.attr.y=u+(d-u)/2):(t.attr.x=e?n:i,t.attr.y=m&&e?d:u)),a=this.addGraphicalElement(b+"_trend",C.setAnimation({container:S,el:a||"text",attr:t.attr,css:t.css,data:{value:s||l},component:this,label:"text"})),x.showTooltip&&t.valueToolText?k.enableToolTip(a,t.valueToolText):k.disableToolTip(a)):a&&this.removeGraphicalElement(a);else for(b=0,v=y.length;b<v;b++)(g=this.getGraphicalElement(y[b].id))&&this.removeGraphicalElement(g)},a._drawAxisName=function(){var e,t,a,i,n,o,l=this.config,s=this.getFromEnv("toolTipController"),c=this.getLinkedItem("canvas").getEffectiveDimensions(),h=this.getFromEnv("animationManager"),u=c.left,d=c.top,g=c.width,p=c.height,f=d+p,m=u+g,b=this.getFromEnv("chart").config,v=l.name.style,x=l.name.value,y=l.isOpposit,C=l.isVertical,k=this.getFromEnv("smartLabel"),S=l.axisNameContainer,w=l.axisNamePadding,A=l.nameMaxH,L=l.nameMaxW,N=l.axisDimention,F=C?N.x:N.y,T=N.opposite,E=this.getGraphicalElement("axisName"),P=(0,r.pluckNumber)(l.name.rotation,C?90:270),_=this.getFromEnv("paper"),D={fontFamily:v.fontFamily,fontSize:v.fontSize,lineHeight:v.lineHeight,fontWeight:v.fontWeight,fontStyle:v.fontStyle};l.name.isDraw?(e={fontFamily:v.fontFamily,fill:v.color,"vertical-align":"middle","font-size":v.fontSize,"line-height":v.lineHeight},k.useEllipsesOnOverflow(b.useEllipsesWhenOverflow),k.setStyle({fontSize:v.fontSize,fontFamily:v.fontFamily,lineHeight:v.lineHeight,fontWeight:v.fontWeight}),l.drawAxisNameOpposit&&(y=!y,F=T),C?(w=Math.max(w,function(e,t){var a=0;return e.relativeAxis&&e.relativeAxis.config&&e.relativeAxis.config.axisNamePadding&&(a=Math.max(e.relativeAxis.config.axisNamePadding,a)),e.isOpposit&&t.canvasMarginRight&&(a=Math.max(a,t.canvasMarginRight-t.marginLeft-e.nameMaxW)),!e.isOpposit&&t.canvasMarginLeft&&(a=Math.max(a,t.canvasMarginLeft-t.marginRight-e.nameMaxW)),a}(l,b)),i=l.axisNameAlignCanvas||b.captionalignment&&"left"===b.captionalignment?p:Math.max(p,l.oriCanvasHeight||0),P?(a=(t=k.getSmartText(x,i,L)).tooltext,n=t.width):(a=(t=k.getSmartText(x,L,i)).tooltext,n=t.height),o=l.drawAxisNameFromBottom?f-n/2:n>p?b.height/2:d+p/2,e.text=t.text,e.x=y?(F||m)+w+L/2:(F||u)-w-L/2,e.y=o):(a=(t=k.getSmartText(x,g,A)).tooltext,y&&b.canvasMarginTop&&(w=Math.max(w,b.canvasMarginTop-b.marginTop-A)),!y&&b.canvasMarginBottom&&(w=Math.max(w,b.canvasMarginBottom-b.marginBottom-A)),e.text=t.text,e.x=u+g/2,e.y=y?(F||d)-w-A/2:(F||f)+w+A/2),e["text-bound"]=""===t.text?[]:[v.backgroundColor,v.borderColor,v.borderColor?v.borderThickness:0,v.borderPadding,v.borderRadius,v.borderDash],e.transform=_.getSuggestiveRotation(C?P:0,e.x,e.y),E=this.addGraphicalElement("axisName",h.setAnimation({css:D,el:E||"text",attr:e,container:S,component:this,label:"text"})),l.showTooltip?s.enableToolTip(E,a):s.disableToolTip(E)):E&&this.removeGraphicalElement(E)},a._drawAxisLine=function(){var e,t,a,i,n,o,l,c,h,u,g,p,m,b,v,x,y,C,k=this.config,S=k.isVertical,w=k.isOpposit,A=this.getFromEnv("chart"),L=this.getLinkedItem("canvas").getEffectiveDimensions(),N=this.getFromEnv("animationManager"),F=L.top,T=L.left,E=F+L.height,P=T+L.width,_=k.axisDimention,D=S?_.x:_.y,I=k.drawAxisLineWRTCanvas,M=A.getFromEnv("chart-attrib"),O=k.axisAxisLineContainerBottom,R=this.getGraphicalElement("axisLine"),B=[];if(i=1===(0,r.pluckNumber)(M.showyaxisline,M.showyaxisline)?(0,r.pluckNumber)(M.yaxislinethickness,M.pyaxislinethickness,1):0,k.showAxisLine){if(S?(n=w?(D=I?P:D)+k.axisLineThickness/2:(D=I?T:D)-k.axisLineThickness/2,a=(x=d(["M",n,E,"L",n,F],k.axisLineThickness)).path):(n=w?(D=I?F:D)-k.axisLineThickness/2:(D=I?E:D)+k.axisLineThickness/2,a=(x=d(["M",T-i,n,"L",P,n],k.axisLineThickness)).path),c={path:a,stroke:k.axisLineColor,"stroke-linecap":"butt","stroke-width":k.axisLineThickness,"shape-rendering":x.isCrisped?"crisp":r.UNDEF},k.drawTick&&k.tickLength)for(e={stroke:k.tickColor,"stroke-width":k.tickWidth},o=S?w?n+k.tickLength:n-k.tickLength:w?n-k.tickLength:n+k.tickLength,v=0,C=(y=k.tickValues?k.tickValues.tickValue.map((function(e){return S?e.y:e.x})):k.ticks).length;v<C;v+=1)m=(p=y[v])+"_tick",u=this.getGraphicalElement(m),l=this.getPixel(p,f),e.path=d(S?["M",n,l,"L",o,l]:["M",l,n,"L",l,o],k.tickWidth).path,h=N.setAnimation({el:u||"path",attr:e,data:{value:p,path:e.path},container:O,component:this,label:"path"}),u||this.addGraphicalElement(m,h),B.push(m);t=N.setAnimation({el:R||"path",attr:c,container:O,component:this,label:"path"}),R||this.addGraphicalElement("axisLine",t),B.push("axisLine")}for(v=0,C=(b=(0,s["default"])(k.prevTicks,B)).length;v<C;v++)(g=this.getGraphicalElement(b[v]))&&this.removeGraphicalElement(g);k.prevTicks=B},a._parseCategory=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g,p,m,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P=this.config,_=P.axisDimention||{},D=this.getFromEnv("chart"),I=D.getFromEnv("smartLabel"),M=this.components,O=M.labels,R=this.getLinkedItem("canvas").getEffectiveDimensions(),B=D.config,V=P.isOpposit,z=P.labels,G=z.style,H=P.isVertical,W=R.top,j=R.left,U=W+R.height,q=j+R.width,Y=P.labelPadding,X=H?_.x:_.y,K=_.opposite,Z=D.getFromEnv("dataSource").categories,J={},$=P.tickValues.tickValue,Q=P.axisRange.min,ee=P.drawnStaggerLines,te=(P.labelStep!==P.labels.step||1!==this.getZoom())&&"stagger"===P.labelDisplay;if(P.labels.isDraw)for(H&&(L=Math.abs(this.getPixel(0,f)-this.getPixel(0+P.axisRange.tickInterval,f)),P.labelMaxH>L&&(k=Math.ceil(P.labelMaxH/L)),k>P.labels.step&&(P.labels.step=k)),te&&(A=2*Math.abs(this.getPixel(Q,f)-this.getPixel(Q+P.labels.step,f))*P.sWidthAdjstFactor-1),F=(i=P.labels.rotation)?P.labelMaxH:P.labelMaxW,T=i?P.labelMaxW:P.labelMaxH,P.drawLabelsOpposit&&(V=!V,X=K),Z&&Z[0]&&"auto"!==P.xAxisLabelMode&&(J.fontFamily=Z[0].font,J.fontSize=Z[0].fontsize,J.color=Z[0].fontcolor),P.ParentCss=g={fontFamily:(0,r.pluck)(J.fontFamily,G.fontFamily),fontSize:(0,r.pluck)(J.fontSize,this.computeFontSize(G.fontSizeWithUnit)+r.PXSTRING),fontWeight:(0,r.pluck)(G.fontWeight),fontStyle:(0,r.pluck)(G.fontStyle)},g.lineHeight=(0,r.setLineHeight)(g),y=this._getCategoryArr(),M.labelIndexArr=[],e=0,C=y.length;e<C;e+=1)t=$[E=y[e].index],v=y[e].value,M.labelIndexArr.push(E),c=(0,r.pluck)(t.font,t.labelfont),h=(0,r.pluck)(this.computeFontSize(t.fontsize),t.labelfontsize),u=(0,r.pluck)(t.fontbold,t.labelfontbold)?(0,r.pluckNumber)(t.fontbold,t.labelfontbold,0)?"bold":r.NORMAL:r.UNDEF,d=(0,r.pluck)(t.fontitalic,t.labelfontitalic)?(0,r.pluckNumber)(t.fontitalic,t.labelfontitalic,0)?"italic":r.NORMAL:r.UNDEF,m=(0,r.convertColor)((0,r.pluck)(t.fontcolor,t.labelfontcolor,J.color,G.color),(0,r.pluckNumber)(t.labelalpha,P.rawAttr.labelAlpha,D.config.singleseries?r.UNDEF:t.alpha,100)),c||h||u||d?(s={},c&&(s.fontFamily=c),h&&(s.fontSize=h),u&&(s.fontWeight=u),d&&(s.fontStyle=d),s.lineHeight=h?(0,r.setLineHeight)(s):g.lineHeight):s=r.UNDEF,(s||g)&&-1!==(o=(s||g).lineHeight).indexOf("px")&&(n=o.replace(/px/i,""),n=parseFloat(n)),!1===t.appliedSmartLabel&&(I.setStyle(t._ovrStyle||g),N=I.getSmartText(t.oriLabel||t.label,F,T),t.oriLabel=t.oriLabel||t.label,t.label=N.text,t.labelTooltext=N.labelTooltext,t.appliedSmartLabel=!0),b=this.getPixel(v,f),H?(a=t.label||"",l=Number(t.labelPadding)||0,p={fill:m,"line-height":n,opacity:1,"text-anchor":V?r.POSITION_START:r.POSITION_END,text:a,cursor:!B.singleseries&&t.link||t.labellink||G.labelLink?r.POINTER:"",x:V?(X||q)+Y:(X||j)-Y,y:l?b+l:b}):(a=t.label||"",l=Number(t.labelPadding)||0,p={fill:m,"line-height":n,opacity:1,text:a,cursor:!B.singleseries&&t.link||t.labellink||G.labelLink?r.POINTER:"",x:b,y:V?(X||W)-Y:(X||U)+Y},i?(p["text-anchor"]=V?r.POSITION_START:r.POSITION_END,p["vertical-align"]=r.POSITION_MIDDLE):(p["text-anchor"]=r.POSITION_MIDDLE,p["vertical-align"]=V?r.POSITION_BOTTOM:r.POSITION_TOP),te?((S=t.labelCount%ee)&&((n=t.style.lineHeight)||(n=P.labels.style.lineHeight),w=n.replace(/px/i,"")*S,p.y=V?p.y-w:p.y+w),I.setStyle(t._ovrStyle||g),N=I.getSmartText(t.oriLabel||t.label,A,T),t.oriLabel=t.oriLabel||t.label,p.text=t.label=N.text,t.labelTooltext=N.labelTooltext,t.appliedSmartLabel=!0):l&&(V?p.y-=l:p.y+=l)),x={label:t.label,lineHeight:o,border:(0,r.pluckNumber)(t.borderthickness,t.labelborderthickness)?(0,r.pluckNumber)(t.borderthickness,t.labelborderthickness,1)+"px solid":"",borderColor:t.bordercolor||t.labelbordercolor?(0,r.convertColor)(t.bordercolor||t.labelbordercolor,(0,r.pluckNumber)(t.borderalpha,t.labelborderalpha,t.alpha,t.labelalpha,100)):r.BLANKSTRING,borderThickness:(0,r.pluckNumber)(t.borderthickness,t.labelborderthickness),borderPadding:(0,r.pluckNumber)(t.borderpadding,t.labelborderpadding),borderRadius:(0,r.pluckNumber)(t.borderradius,t.labelborderradius),backgroundColor:t.bgcolor||t.labelbgcolor?(0,r.convertColor)(t.bgcolor||t.labelbgcolor,(0,r.pluckNumber)(t.bgalpha,t.labelbgalpha,t.alpha,t.labelalpha,P.rawAttr.labelAlpha,100)):r.BLANKSTRING,borderDash:(0,r.pluckNumber)(t.borderdashed,t.labelborderdashed,0)?(0,r.getDashStyle)((0,r.pluckNumber)(t.borderdashlen,t.labelborderdashlen,4),(0,r.pluckNumber)(t.borderdashgap,t.labelborderdashgap,2)):0===(0,r.pluckNumber)(t.borderdashed,t.labelborderdashed)?r.DASH_DEF:G.borderDash},t.label?p["text-bound"]=[(0,r.pluck)(x.backgroundColor,G.backgroundColor),(0,r.pluck)(x.borderColor,G.borderColor),(0,r.pluck)(x.borderThickness,G.borderThickness),(0,r.pluck)(x.borderPadding,G.borderPadding),(0,r.pluck)(x.borderRadius,G.borderRadius),(0,r.pluck)(x.borderDash,G.borderDash)]:p["text-bound"]=[],z.shiftX&&(p.x+=z.shiftX),z.shiftY&&(p.y+=z.shiftY),p.transform=(0,r.getSuggestiveRotation)(i,p.x,p.y),O[E]=O[E]||{config:{props:{label:{}}}},O[E].config.props.label.attr=p,O[E].config.props.label.css=s},a.allocatePosition=function(){var e=this.config;e.tickValues?e.drawLabels&&this._parseCategory():e.drawLabels&&this._parseLabel()},a._drawCategory=function(){var e,t,a,i,n,o,l,s,h,u,d,g=this.config,p=this.getFromEnv("chart"),f=p.config,m=g.labels,b=this.getFromEnv("animationManager"),v=m.style,x=this.getFromEnv("toolTipController"),y=g.axisContainer,C=this.config.categoryLabel||(this.config.categoryLabel=[]),k=function(e){return function(t){p.plotEventHandler(this,t,e)}},S=g.tickValues.tickValue,w=[];if(g.labels.isDraw){for(y.css(g.ParentCss),o=this._getCategoryArr(),e=0,s=(n=(0,c["default"])((function(e,t){return e.value===t.value}),g.prevCategoryIntervalArr,o)).length;e<s;e++)(u=this.getGraphicalElement(n[e].value+"_label"))&&this.removeGraphicalElement(u);for(g.prevCategoryIntervalArr=(0,r.extend2)([],o),e=0,s=o.length;e<s;e+=1)w[e]=o[e].value+"_label";for(e=0,s=o.length;e<s;e+=1)t=S[d=o[e].index],i=(h=this.components.labels[d].config).props.label.attr,l=this.getGraphicalElement(w[e]),a=b.setAnimation({el:l||"text",attr:i,container:y,data:{value:void 0},component:this,label:"text",css:h.props.label.css}),l||(this.addGraphicalElement(w[e],a),a.on("fc-click",k("dataLabelClick")).hover(k("dataLabelRollOver"),k("dataLabelRollOut"))),a.data("eventArgs",{link:!f.singleseries&&t.link||t.labellink||v.labelLink,text:i.text,index:d}),t.labelTooltext||a.abbrArr?x.enableToolTip(a,t.labelTooltext):x.disableToolTip(a),C[d]=a}else for(e=0,s=g.prevCategoryIntervalArr.length;e<s;e++)(u=this.getGraphicalElement(g.prevCategoryIntervalArr[e].value+"_label"))&&this.removeGraphicalElement(u)},a._getCategoryArr=function(){var e,t,a,i,n,o,l,s,c,h,u=this.config,d=u.isVertical,g=0,p=0,b=[];for(e=u.tickValues.tickValue,i=m(e),a=e?e.length-1:0,d&&(c=Math.abs(this.getPixel(0,f)-this.getPixel(1,f)),u.labelMaxH>c&&(g=Math.ceil(u.labelMaxH/c)),g>u.labels.step&&(u.labels.step=g)),s=u.labels.step>0?u.labels.step:1,h=1!==this.getZoom(),o=this.getVisibleConfig(),t=i;t<=a;t+=s)(n=e[t])&&(l=(0,r.pluckNumber)(n.x,n.y,t),0!==(0,r.pluckNumber)(n.showlabel,u.showLabels,1)&&(h&&(l<o.minValue||l>o.maxValue)?n.labelCount=p++:("auto"!==u.xAxisLabelMode&&"mixed"!==u.xAxisLabelMode||0!==u.showZeroPlane&&0!==u.showZeroPlaneValue||0!==l)&&(u.labels.drawNormalVal||u.labels.drawLimitVal&&(t===i||t===a))&&(u.labels.drawNormalVal||t===i||t===a)&&(u.labels.drawLimitVal||t!==i&&t!==a)&&(n.labelCount=p++,b.push({index:t,value:l}))));return b},a.getValue=function(e,t){void 0===t&&(t={wrtVisible:!1});var a=this.getScale(),i=this.getTranslation();return a.getDomainValue(t.wrtVisible?e:e-i)},a.getPixel=function(e,t){void 0===t&&(t={wrtVisible:!1});var a=this.getScale(),i=this.getTranslation(),n=a.getRangeValue(e);return t.wrtVisible?n:n+i},a._getCustomPixel=function(e,t,a){if(void 0===a&&(a={wrtVisible:!1}),!t)return this.getPixel(e,a);var i=this.getScale().copy(),n=i.getRange(),o=n[0],r=n[1],l=Math.min(o,r),s=i.getRangeValue(e),c=this.getTranslation();return i.setRange([l,l+t]),a.wrtVisible?s:s+c},a.getTranslation=function(){return this.config.translation||0},a.setVisibleConfig=function(e,t){var a,i=this.config,n=this.getZoom(),o=this.getScale();return!(e>=t||e<i.axisRange.min||t>i.axisRange.max)&&(a=o.setDomain([e,t]).getDomain(),i.visibleMin=a[0],i.visibleMax=a[1],i.zoom=this._computeZoom(),i.translation=this._computeTranslation(),1===n&&1===this.getZoom()||(i.ticks=this.generateTicks(),i.minorTicks=this.generateMinorTicks(),i.tickValues&&this.calculateTicksOnLabelMode&&this.calculateTicksOnLabelMode()),this.clearReferenceInfo(),this._parseReferenceVisuals(),this.fireEvent("visiblerangeset",{minValue:e,maxValue:t}),this.asyncDraw(),!0)},a.hide=function(){var e=this.config;e.axisContainer&&(e.axisLabelContainerTop.hide(),e.axisContainer.hide(),e.axisNameContainer.hide(),e.axisTrendLabelContainer.hide(),e.axisAxisLineContainer.hide(),e.axisAxisLineContainerBottom.hide())},a.show=function(){var e=this.config;e.axisContainer&&(e.axisLabelContainerTop.show(),e.axisContainer.show(),e.axisNameContainer.show(),e.axisTrendLabelContainer.show(),e.axisAxisLineContainer.show(),e.axisAxisLineContainerBottom.show())},a.getZoom=function(){return this.config.zoom||1},a._computeTranslation=function(){var e=this.config,t=this.getVisibleConfig(),a=(0,r.pluckNumber)(t.minValue,e.axisRange.min,0),i=(0,r.pluckNumber)(e.axisRange.min,t.minValue,0);return this.getPixel(a)-this.getPixel(i)},a._computeZoom=function(){var e=this.config,t=this.getVisibleConfig(),a=(0,r.pluckNumber)(t.minValue,e.axisRange.min,0),i=(0,r.pluckNumber)(t.maxValue,e.axisRange.max,1),n=(0,r.pluckNumber)(e.axisRange.min,t.minValue,0),o=(0,r.pluckNumber)(e.axisRange.max,t.maxValue,1),l=e.maxZoomLimit,s=(o-n)/(i-a);return s>l?l:s},a.getTickValues=function(){var e=this.config.tickValues;return e&&e.tickValue||[]},a.dataLabels=function(e){var t=this.config.axisIndex;return this.getFromEnv("number-formatter").dataLabels(e,t)},a.getAxisBase=function(){var e=this.getVisibleConfig(),t=e.minValue,a=e.maxValue;return t<0&&a>0?0:a<=0?a:t},a._parseReferenceVisuals=function(){var e,t,a=this.config,i=this.getTickValues(),n=i.length,o=this.getFromEnv("chartConfig").is3D;a.isActive||(e=a.lines.isDraw,t=a.band.isDraw,a.lines.isDraw=0,a.band.isDraw=0),a.tickValues?a.drawLabels&&this._parseCategoryLine(i,0,n):a.drawPlotlines&&this._parsePlotLine(),a.tickValues&&"auto"!==a.xAxisLabelMode?(a.drawPlotlines&&!o&&this._parseCategoryPlotLine(),a.drawPlotBands&&!o&&this._parseCategoryPlotBand(),"mixed"===a.xAxisLabelMode&&a.drawPlotBands&&!o&&this._parsePlotBand()):a.drawPlotBands&&!o&&this._parsePlotBand(),a.isActive||(a.lines.isDraw=e,a.band.isDraw=t),a.drawTrendLines&&this._parseTrendLine()},a._parseCategoryPlotBand=function(){var e,t,a,i,n,o=this.config,l=o.tickValues.tickValue,s=o.showAlternateGridColor,c=o.alternateGridColor,h=o.alternateGridAlpha,u=o._allTicks,d=this.getLimit(),p=d.min,f=d.max,m=g(this.getVisibleConfig());if((!l[0]||l[0].x===r.UNDEF&&l[0].y===r.UNDEF)&&s&&o.band.isDraw&&o.categoryNumDivLines)for(e={fill:(0,r.toRaphaelColor)((0,r.convertColor)(c,h)),"stroke-width":0},t=0,n=0;n<u.length;++t,++n)m(u[n],u[n+1])&&(a=u[n],t%2==0&&(i=u[n+1])!==r.UNDEF&&(a===p&&(a="canvasStart"),i===f&&(i="canvasEnd"),this.setReferenceInfo({from:a,to:i,layer:0,type:"band",attr:e})))},a._parseTrendLine=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g,p,f,m,b,v,x,y,C=this.config,k=C.isVertical,S=C.axisIndex,w=this.getFromEnv("chart-attrib"),A=this.getFromEnv("number-formatter"),L=C.axisRange,N=L.max,F=L.min,T=C.trend.trendStyle,E={fontFamily:T.fontFamily,fontSize:T.fontSize,lineHeight:T.lineHeight,fontWeight:T.fontWeight,fontStyle:T.fontStyle},P=C.vTrendLines,_=C.trendLines,D=0;if(l=_||P)for(a=0,i=l.length;a<i;a+=1)for(e=0,t=l[a].line&&l[a].line.length;e<t;e+=1)u=l[a].line[e],b=C.isPercent?"yAxisPercentValue":k?"yAxis":"xAxis",u.startvalue||u.value||0,p=A.getCleanValue((0,r.pluck)(u.startvalue,u.value,0)),f=isNaN(u.endvalue)||""===u.endvalue?r.UNDEF:u.endvalue,n=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(l[a].line[e].tooltext,l[0].tooltext,C.trendlineToolText),!1)),n=(0,r.parseTooltext)(n,[7,15,16,17,18,19],{startValue:p,startDataValue:A[b](p,S),endValue:f||p,endDataValue:A[b](f||p,S),axisName:C.axisName},u),p>N||p<F||f>N||f<F||(P?(d=(0,r.parseUnsafeString)(u.displayvalue||""),s=(0,r.pluckNumber)(u.istrendzone,C.isTrendZone,1),f!==r.UNDEF&&""!==f&&f!==p&&s?(c={fill:(0,r.convertColor)((0,r.pluck)(u.color,C.trendlineColor),(0,r.pluck)(u.alpha,C.trendlineAlpha,40)),"stroke-width":0},h={fill:(0,r.convertColor)((0,r.pluck)(u.color,T.color),(0,r.pluck)(u.valuealpha,w.trendvaluealpha,u.alpha,C.trendlineAlpha,99)),"vertical-align":r.POSITION_TOP,text:d}):(m=(0,r.pluckNumber)(u.thickness,C.trendlineThickness,1),c={stroke:(0,r.convertColor)((0,r.pluck)(u.color,C.trendlineColor),(0,r.pluck)(u.alpha,C.trendlineAlpha,99)),"stroke-width":m,"stroke-dasharray":(0,r.pluck)(u.dashed,C.trendlinesAreDashed)===r.ONESTRING?(0,r.getDashStyle)((0,r.pluckNumber)(u.dashlen,C.trendlinesDashLen),(0,r.pluckNumber)(u.dashgap,C.trendlinesDashGap)):r.DASH_DEF},h={fill:(0,r.convertColor)((0,r.pluck)(u.color,T.color),(0,r.pluck)(u.valuealpha,w.trendvaluealpha,u.alpha,C.trendlineAlpha,99)),"vertical-align":r.POSITION_TOP,text:d})):_&&(d=(0,r.pluck)((0,r.parseUnsafeString)(u.displayvalue),u.startvalue,""),g=(0,r.pluckNumber)(u.valueonright,C.isOpposit?1:0),s=(0,r.pluckNumber)(u.istrendzone,C.isTrendZone,0),f!==r.UNDEF&&""!==f&&f!==p&&s?(c={fill:(0,r.convertColor)((0,r.pluck)(u.color,C.trendlineColor),(0,r.pluck)(u.alpha,C.trendlineAlpha,40)),"stroke-width":0},h={"text-anchor":g?r.POSITION_START:r.POSITION_END,fill:(0,r.convertColor)((0,r.pluck)(u.color,T.color),(0,r.pluck)(u.valuealpha,w.trendvaluealpha,u.alpha,C.trendlineAlpha,99)),text:d}):(m=(0,r.pluckNumber)(u.thickness,C.trendlineThickness,1),c={stroke:(0,r.convertColor)((0,r.pluck)(u.color,C.trendlineColor),(0,r.pluck)(u.alpha,C.trendlineAlpha,99)),"stroke-width":m,"stroke-dasharray":(0,r.pluck)(u.dashed,C.trendlinesAreDashed)===r.ONESTRING?(0,r.getDashStyle)((0,r.pluckNumber)(u.dashlen,C.trendlinesDashLen),(0,r.pluckNumber)(u.dashgap,C.trendlinesDashGap)):r.DASH_DEF},h={"text-anchor":g?r.POSITION_START:r.POSITION_END,fill:(0,r.convertColor)((0,r.pluck)(u.color,T.color),(0,r.pluck)(u.valuealpha,w.trendvaluealpha,u.alpha,C.trendlineAlpha,99)),text:d})),h["text-bound"]=h.text?[T.backgroundColor,T.borderColor,T.borderThickness,T.borderPadding,T.borderRadius,T.borderDash]:[],C.showTooltip&&n||(n=r.BLANKSTRING),o=C.forceTrendBelow?0:(0,r.pluckNumber)(u.showontop,w.showtrendlinesontop,0),k?(v=p,y=f!==r.UNDEF?f:p):(v=f!==r.UNDEF?f:p,y=p),x=s&&v!==y?"band":"line",v!==r.UNDEF&&this.setReferenceInfo({from:v,to:y,toolText:n,attr:c,layer:o?3:2,type:x,id:"trend"+D+x}),C.parsedTrendLabels.push({css:E,valueOnRight:g,isTrendZone:s,from:p,to:f,attr:h}),D+=1)},a._parsePlotLine=function(){var e,t,a,i,n,o=this.config,l=o.axisRange,s=l.max,c=l.min,h=p(this.getVisibleConfig()),u=o.showCanvasBorder,d=(0,r.convertColor)(o.divLineColor,o.divLineAlpha),g=o.divLineThickness,f=o.divLineIsDashed?(0,r.getDashStyle)(o.divLineDashLen,o.divLineDashGap):r.DASH_DEF,m=(0,r.convertColor)(o.zeroPlaneColor,o.zeroPlaneAlpha),b=o.zeroPlaneThickness,v=o._allTicks,x=v.length,y=o.showZeroPlaneOnTop,C=o.minorTicks,k=C&&C.length;if(o.lines.isDraw)for(t=0;t<x;++t)h(e=v[t])&&(i={"stroke-dasharray":f},0===o.showZeroPlane&&0===e||u&&(e===s||e===c)||(0===e&&e!==c&&e!==s?(i.stroke=m,i["stroke-width"]=b,y=o.showZeroPlaneOnTop):(y=0,i.stroke=d,i["stroke-width"]=g),this.setReferenceInfo({type:"line",from:e,layer:0===e&&y?3:1,attr:i})));for(n={stroke:o.minorDivlinecolor,"stroke-width":o.minorDivLineThickness,"stroke-dasharray":f},t=0;t<k;++t)a=C[t],this.setReferenceInfo({type:"line",from:a,layer:1,attr:n})},a._parseCategoryLine=function(e,t,a){var i,n,o,l,s,c,h=t,u=a,d=this.config,g=this.getFromEnv("color-manager"),p=this.getFromEnv("chartInstance").getJSONData().categories,f={};if(h=h||0,u=u||e?e.length-1:0,d.drawPlotlines)for(c=1!==this.getZoom(),o=this.getVisibleConfig(),p&&p[0]&&(f.verticalLineColor=p[0].verticallinecolor,f.verticalLineAlpha=p[0].verticallinealpha,f.verticalLineThickness=p[0].verticallinethickness,f.verticalLineDashed=p[0].verticallinedashed,f.verticalLineDashLen=p[0].verticallinedashlen,f.verticalLineDashGap=p[0].verticallinedashgap),i=h;i<=u;i+=1)(n=e[i])&&(s=(0,r.pluckNumber)(n.x,n.y,i),1===Number(n.showverticalline)&&(c&&(s<o.minValue||s>o.maxValue)||((l={stroke:(0,r.convertColor)((0,r.pluck)(n.linecolor,f.verticalLineColor,d.divLineColor,g.getColor("divLineColor")),(0,r.pluck)(n.linealpha,f.verticalLineAlpha,g.getColor("divLineAlpha"))),"stroke-width":(0,r.pluckNumber)(n.linethickness,f.verticalLineThickness,1)})["stroke-dasharray"]=(0,r.pluckNumber)(n.linedashed,f.verticalLineDashed,0)?(0,r.getDashStyle)((0,r.pluckNumber)(n.linedashLen,f.verticalLineDashLen,4),(0,r.pluckNumber)(n.linedashgap,f.verticalLineDashGap,2),l["stroke-width"]):r.DASH_DEF,this.setReferenceInfo({type:"line",from:s,layer:1,attr:l}))))},a._parsePlotBand=function(){var e,t,a,i,n,o,l=this.config,s=l.showAlternateGridColor,c=l.alternateGridColor,h=l.alternateGridAlpha,u=l._allTicks,d=g(this.getVisibleConfig()),p=l.isReverse;if(s&&l.band.isDraw)for(t=1,e={fill:(0,r.toRaphaelColor)((0,r.convertColor)(c,h)),"stroke-width":0},i=0,a=u.length;i<a;++i,++t)d(u[i],u[i+1])&&t%2==0&&u[i+1]!==r.UNDEF&&(o=p?Math.max(u[i],u[i+1]):Math.min(u[i],u[i+1]),n=p?Math.min(u[i],u[i+1]):Math.max(u[i],u[i+1]),this.setReferenceInfo({from:o,to:n,type:"band",layer:0,attr:e}))},a.getReferenceInfo=function(){return this.config.referenceInfo},a.setReferenceInfo=function(e){this.config.referenceInfo.push(e)},a.clearReferenceInfo=function(){var e=this.config;e.referenceInfo=[],e.parsedTrendLabels=[],e.parsedVlineInfo=[]},a.resetStoredLimits=function(){this.config.dataLimit={}},a.getAxisDimension=function(){var e=this.config.axisDimention;return{x:e.x,y:e.y,opposite:e.opposite,axisLength:e.axisLength}},t}(o["default"]);b.prototype.setAxisDimention=u.setAxisDimention,b.prototype.shiftLabels=u.shiftLabels,b.prototype._createContainer=u._createContainer;var v=b;t["default"]=v},511:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=a(224),l=function(e,t){return e<t?t:e},s=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"axis"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.components={labels:[]};var t=this.config;t.setAdaptiveMin=0,t.adjustDiv=1,t.axisNameWidth=r.UNDEF,t.rotateAxisName=0,t.useEllipsesWhenOverflow=1,t.divLineColor=r.UNDEF,t.divLineAlpha=r.UNDEF,t.divLineThickness=r.UNDEF,t.divLineIsDashed=r.UNDEF,t.divLineDashLen=r.UNDEF,t.divLineDashGap=r.UNDEF,t.showAlternateGridColor=r.UNDEF,t.alternateGridColor=r.UNDEF,t.alternateGridAlpha=r.UNDEF,t.showZeroPlane=1,t.zeroPlaneAlpha=80,t.showZeroPlaneValue=1,t.showZeroPlaneOnTop=1,t.showAxisLine=r.UNDEF,t.axisLineThickness=r.UNDEF,t.axisLineAlpha=r.UNDEF,t.tickLength=0,t.trendlineToolText=r.UNDEF,t.trendlineColor="333333",t.trendlineThickness=1,t.trendlineAlpha=r.UNDEF,t.showTrendlinesOnTop=0,t.trendlinesAreDashed=0,t.trendlinesDashLen=5,t.trendlinesDashGap=2,t.isTrendZone=r.UNDEF,t.showTrendlines=1,t.showTrendlineLabels=1,t.showLabels=1,t.maxLabelHeight=r.UNDEF,t.rotateLabels=r.UNDEF,t.slantLabel=0,t.showAxisValues=1,t.showTooltip=1,t.isActive=!0,t.drawLabels=!0,t.drawOnlyCategoryLine=!1,t.drawLabelsOpposit=!1,t.drawPlotlines=!0,t.drawAxisLine=!0,t.drawPlotBands=!0,t.drawAxisName=!0,t.drawAxisNameOpposit=!1,t.axisNameAlignCanvas=!1,t.drawAxisNameFromBottom=!1,t.drawTrendLines=!0,t.drawTrendLabels=!0,t.drawTick=!0,t.drawTickMinor=!0,t.animateAxis=!0,t.drawAxisLineWRTCanvas=!0,t.isRelativeAxisInverse=!1,t.axisIndex=0,t.uniqueClassName=0,t.viewPortRatio={},t.canvas={},t.axisRange={},t.drawnStaggerLines=r.UNDEF,t.axisDimention={},t.forceZeroTick=!0,t.isZeroTickForced=!1,t.extremeLabels={firstLabel:{},lastLabel:{}},t._setRangeAgain=!1,t._defaultForceDecimal=r.UNDEF,t._defaultDecimalPrecision=r.UNDEF,t.rangeChanged=!1,t.dimensionChanged=!1,t.apparentScrollPos=0,t.visibleMin=r.UNDEF,t.visibleMax=r.UNDEF,t.setPadding=!1,t.trendLimits=r.UNDEF},a.configureAttributes=function(e){var t,a,i,n,o=this.config,s=this.getFromEnv("chart"),c=this.getFromEnv("dataSource"),h=s.config.is3D,u=c.chart,d=this.getFromEnv("number-formatter");t=o.rawAttr=e,o.referenceInfo=[],o.parsedTrendLabels=[],o.parsedVlineInfo=[],o.trendLines=t.trendlines,o.vTrendLines=t.vtrendlines,(0,r.parseConfiguration)(t,o),o.axisName=(0,r.parseUnsafeString)(t.axisName),o.axisValuePadding=o.axisNamePadding||(0,r.pluckNumber)(t.axisValuePadding,4),o.axisNamePadding=o.axisNamePadding||(0,r.pluckNumber)(t.axisNamePadding,5),o.maxLabelWidthPercent=(0,r.pluckNumber)(t.maxLabelWidthPercent),o.maxLabelWidthPercent=Math.abs(o.maxLabelWidthPercent),o.minLabelWidthPercent=Math.abs((0,r.pluckNumber)(t.minLabelWidthPercent)),o.numDivLines=(0,r.pluckNumber)(t.numDivLines,4),o.numDivLines=l(o.numDivLines,0),o.categoryNumDivLines=(0,r.pluckNumber)(t.numDivLines,0),o.axisValuePadding=l(o.axisValuePadding,0),o.isReverse=(0,r.pluckNumber)(t.isReverse,0),o.isOpposit=(0,r.pluckNumber)(t.isOpposit,0),o.isVertical=(0,r.pluckNumber)(t.isVertical,0),o.categoryDivLinesFromZero=1,o.axisMinValue=d.getCleanValue(t.axisMinValue),o.axisMaxValue=d.getCleanValue(t.axisMaxValue),o.zeroPlaneColor=(0,r.pluck)(t.zeroPlaneColor,t.divLineColor),o.zeroPlaneThickness=(0,r.pluck)(t.zeroPlaneThickness,t.divLineThickness),o.axisLineColor=(0,r.convertColor)(t.axisLineColor,t.axisLineAlpha),o.tickAlpha=(0,r.pluckNumber)(t.tickAlpha,o.axisLineAlpha),o.tickColor=(0,r.convertColor)((0,r.pluck)(t.tickColor,t.axisLineColor),o.tickAlpha),o.tickWidth=(0,r.pluckNumber)(t.tickWidth,o.axisLineThickness),o.maxZoomLimit=(0,r.pluckNumber)(u.maxzoomlimit,s.maxzoomlimit,1e3),o.showVLines=(0,r.pluckNumber)(u.showvlines,1),o.showVLinesOnTop=(0,r.pluckNumber)(u.showvlinesontop,0),o.showVLineLabels=(0,r.pluckNumber)(u.showvlinelabels,this.showVLineLabels,1),o.showVLineLabelBorder=(0,r.pluckNumber)(u.showvlinelabelborder,1),o.rotateVLineLabels=(0,r.pluckNumber)(u.rotatevlinelabels,0),o.vLineColor=(0,r.pluck)(u.vlinecolor,"333333"),o.vLineLabelColor=(0,r.pluck)(u.vlinelabelcolor),o.vLineThickness=(0,r.pluck)(u.vlinethickness,1),o.vLineAlpha=(0,r.pluckNumber)(u.vlinealpha,80),o.vLineLabelBgColor=(0,r.pluck)(u.vlinelabelbgcolor,"ffffff"),o.vLineLabelBgAlpha=(0,r.pluckNumber)(u.vlinelabelbgalpha,h?50:100),o.staggerLines=Math.max((0,r.pluckNumber)(u.staggerlines,2),2),o.staggerLines=l(o.staggerLines,1),o.trendlineValuesOnOpp=(0,r.pluck)(t.trendlineValuesOnOpp,t.trendlineValuesOnOpp,0),o.labelDisplay=(0,r.pluck)(t.labelDisplay,"auto").toLowerCase(),o.labelStep=(0,r.pluckNumber)(t.labelStep,1),o.labelStep=Math.round(o.labelStep),o.labelStep=l(o.labelStep,1),o.startPad=0,o.endPad=0,o._oriLabelStep=o.labelStep,o.showLimits=(0,r.pluckNumber)(t.showLimits,o.showAxisValues),o.showUpperLimit=t.showLimits,o.showDivLineValues=(0,r.pluckNumber)(t.showDivLineValues,o.showAxisValues),o.showCanvasBorder=s.getChildren("canvas")[0].config.showCanvasBorder?1:0,o.axisBreak=t.axisBreaks,o.isBreak=!!o.axisBreak,o.isBreak&&this._processAxisBreak(),a=(a=(0,r.getFirstValue)(t.axisNameBorderColor,r.BLANKSTRING))?(0,r.convertColor)(a,(0,r.pluckNumber)(t.axisNameBorderAlpha,t.axisNameAlpha,100)):r.BLANKSTRING,o.name=o.name||{},o.name.style={fontFamily:(0,r.pluck)(t.axisNameFont,t.outCanfontFamily),fontSize:(0,r.pluck)(t.axisNameFontSize,(0,r.pInt)(t.outCanfontSize))+r.PXSTRING,fontSizeWithUnit:(0,r.pluckFontSizeMaintainUnit)(t.axisNameFontSizeWithUnit,t.outCanfontSizeWithUnit),color:(0,r.convertColor)((0,r.pluck)(t.axisNameFontColor,t.outCancolor),(0,r.pluckNumber)(t.axisNameFontAlpha,t.axisNameAlpha,100)),fontWeight:(0,r.pluckNumber)(t.axisNameFontBold,1)?"bold":r.NORMAL,fontStyle:(0,r.pluckNumber)(t.axisNameFontItalic)?"italic":r.NORMAL,border:a||t.axisNameBgColor?(0,r.pluckNumber)(t.axisNameBorderThickness,1)+"px solid":r.UNDEF,borderColor:a,borderThickness:(0,r.pluckNumber)(t.axisNameBorderThickness,1),borderPadding:(0,r.pluckNumber)(t.axisNameBorderPadding,2),borderRadius:(0,r.pluckNumber)(t.axisNameBorderRadius,0),backgroundColor:t.axisNameBgColor?(0,r.convertColor)(t.axisNameBgColor,(0,r.pluckNumber)(t.axisNameBgAlpha,t.axisNameAlpha,100)):r.BLANKSTRING,borderDash:(0,r.pluckNumber)(t.axisNameBorderDashed,0)?(0,r.getDashStyle)((0,r.pluckNumber)(t.axisNameBorderDashLen,4),(0,r.pluckNumber)(t.axisNameBorderDashGap,2)):r.DASH_DEF},o.name.style.lineHeight=(0,r.setLineHeight)(o.name.style),i=(i=(0,r.getFirstValue)(u.trendvaluebordercolor,r.BLANKSTRING))?(0,r.convertColor)(i,(0,r.pluckNumber)(u.trendvalueborderalpha,u.trendvaluealpha,100)):r.BLANKSTRING,o.trend=o.trend||{},o.trend.trendStyle={fontFamily:(0,r.pluck)(u.trendvaluefont,t.outCanfontFamily),color:(0,r.pluck)(u.trendvaluefontcolor,t.trendlineColor,t.outCancolor,"333333"),valueAlpha:u.trendvaluealpha,fontSize:(0,r.pluckFontSize)(this.computeFontSize(u.trendvaluefontsize),(0,r.pInt)(t.outCanfontSize))+r.PXSTRING,fontSizeWithUnit:(0,r.pluckFontSizeMaintainUnit)(u.trendvaluefontsize,t.outCanfontSizeWithUnit),fontWeight:(0,r.pluckNumber)(u.trendvaluefontbold)?"bold":r.NORMAL,fontStyle:(0,r.pluckNumber)(u.trendvaluefontitalic)?"italic":r.NORMAL,border:i||u.trendvaluebgcolor?(0,r.pluckNumber)(u.trendvalueborderthickness,1)+"px solid":"",borderColor:i,borderThickness:(0,r.pluckNumber)(u.trendvalueborderthickness,1),borderPadding:(0,r.pluckNumber)(u.trendvalueborderpadding,2),borderRadius:(0,r.pluckNumber)(u.trendvalueborderradius,0),backgroundColor:u.trendvaluebgcolor?(0,r.convertColor)(u.trendvaluebgcolor,(0,r.pluckNumber)(u.trendvaluebgalpha,u.trendvaluealpha,100)):r.BLANKSTRING,borderDash:(0,r.pluckNumber)(u.trendvalueborderdashed,0)?(0,r.getDashStyle)((0,r.pluckNumber)(u.trendvalueborderdashlen,4),(0,r.pluckNumber)(u.trendvalueborderdashgap,2)):r.DASH_DEF},o.trend.trendStyle.lineHeight=(0,r.setLineHeight)(o.trend.trendStyle),o.labels=o.labels||{},o.lines=o.lines||{},o.band=o.band||{},n=(n=(0,r.getFirstValue)(t.labelBdrColor,r.BLANKSTRING))?(0,r.convertColor)(n,(0,r.pluckNumber)(t.labelBdrAlpha,t.labelAlpha,100)):r.BLANKSTRING,o.labels.style={fontFamily:(0,r.pluck)(t.labelFont,t.outCanfontFamily),fontSize:(0,r.pluckNumber)(t.labelFontSize,(0,r.pInt)(t.outCanfontSize))+r.PXSTRING,fontSizeWithUnit:(0,r.pluckFontSizeMaintainUnit)(t.labelFontSizeWithUnit,t.outCanfontSizeWithUnit),fontWeight:(0,r.pluckNumber)(t.labelFontBold)?"bold":r.NORMAL,fontStyle:(0,r.pluckNumber)(t.labelFontItalic)?"italic":r.NORMAL,color:(0,r.convertColor)((0,r.pluck)(t.labelFontColor,t.outCancolor),(0,r.pluckNumber)(t.labelAlpha,100)),labelLink:t.labelLink,border:n||t.labelBgColor?(0,r.pluckNumber)(t.labelBdrThickness,1)+"px solid":"",borderColor:n,borderThickness:(0,r.pluckNumber)(t.labelBdrThickness,1),borderPadding:(0,r.pluckNumber)(t.labelBdrPadding,2),borderRadius:(0,r.pluckNumber)(t.labelBdrRadius,0),backgroundColor:t.labelBgColor?(0,r.convertColor)(t.labelBgColor,(0,r.pluckNumber)(t.labelBgAlpha,t.labelAlpha,100)):r.BLANKSTRING,borderDash:(0,r.pluckNumber)(t.labelBdrDashed,0)?(0,r.getDashStyle)((0,r.pluckNumber)(t.labelBdrDashLen,4),(0,r.pluckNumber)(t.labelBdrDashGap,2)):r.DASH_DEF},o.labels.style.lineHeight=(0,r.setLineHeight)(o.labels.style),o.numberFormatterFn=(0,r.pluck)(t.numberFormatterFn),o.apparentScrollPos=t.apparentScrollPos||o.apparentScrollPos,o.axisRange={},o.dataLimit={},o.axisEndLabelDisplaySpace={left:0,right:0,top:0,bottom:0},o.isConfigured=!0,o._defaultForceDecimal=r.UNDEF,o._defaultDecimalPrecision=r.UNDEF,o.lines.isDraw=(0,r.pluckNumber)(t.lines&&t.lines.isDraw,1),o.band.isDraw=(0,r.pluckNumber)(t.band&&t.band.isDraw,1)},a.createContainer=function(e,t,a){var i=this.getFromEnv("animationManager");return this.addContainer(e,i.setAnimation({container:a,attr:t,el:this.getContainer(e)||"group",component:this,label:"group"}))},a.createGroup=function(e,t,a,i){return void 0===i&&(i="group"),this.getFromEnv("animationManager").setAnimation({container:a,attr:t,el:this.config[e]||"group",component:this,label:i})},a.getValuePadding=function(){var e=this.config;return{left:e.startPad,right:e.endPad}},a.draw=function(){var e,t,a,i,n=this.config,o=this.getFromEnv("chart").config,r=n.isVertical,l=o.viewPortConfig,s=this.getChildren().limitUpdater,c=n.viewPortRatio||{};this._createContainer(),a=l.y*l.scaleY,i=l.x*l.scaleX,c.scaleX&&c.scaleY&&(c.scaleX!==l.scaleX||c.scaleY!==l.scaleY)?(c.scaleX=l.scaleX,c.scaleY=l.scaleY,this._drawComponents()):(r?(t=a-l.y*l.scaleY,n.axisContainer.transform("t0,"+t),n.axisLabelContainerTop.transform("t0,"+t)):(e=i-l.x*l.scaleX,n.axisContainer.transform("t"+e+",0"),n.axisLabelContainerTop.transform("t"+e+",0")),this._drawComponents()),this.addExtEventListener("animationcomplete",(function(){s&&s.forEach((function(e){e.draw()}))}),this.getFromEnv("animationmanager")),this.addToEnv("prevScale",this.getScale().copy())},a.setScale=function(e){this.config.scale=e},a.getScale=function(){return this.config.scale},a.getLimit=function(){var e=this.config.axisRange;return{min:e.min,max:e.max,tickInterval:e.tickInterval}},a.getVisibleConfig=function(){var e=this.config;return{minValue:e.visibleMin,maxValue:e.visibleMax}},a.setAxisConfig=function(e){var t,a=this.config;for(t in e)e.hasOwnProperty(t)&&(a[t]=e[t])},a.getAxisConfig=function(e){var t=this.config;return e?t[e]:t},a.getVisibleLength=function(){var e=this.getVisibleConfig();return Math.abs(e.maxValue-e.minValue)},a.getAxisEndLabelDisplaySpace=function(){return this.config.axisEndLabelDisplaySpace||{}},a.getTicksLen=function(){var e=this.config.tickValues;return e&&e.tickValue.length||0},t}(o.ComponentInterface);t["default"]=s},512:function(e,t,a){"use strict";t.__esModule=!0,t.axisAnimationFinal=t.axisAnimationAxis=t.appearingFinal=t.appearingAxis=t["default"]=void 0;var i=[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"axis"}],n=[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],o={"text.appearing":n,"path.appearing":n,"rect.appearing":n},r={"text.appearing":i,"path.appearing":i,"rect.appearing":i,"scrollbar.appearing":i};t.axisAnimationAxis=r,t.axisAnimationFinal=o,t.appearingFinal=n,t.appearingAxis=i;var l={"initial.axis.numeric":r,"initial.axis.category":r,"initial.axis.log":r,"update.axis.numeric":o,"update.axis.category":o,"update.axis.log":o};t["default"]=l},513:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e,t){return e.filter((function(e){return t.indexOf(e)<0}))};t["default"]=i},514:function(e,t,a){var i=a(515),n=a(343)((function(e,t,a){for(var n=[],o=0,r=t.length;o<r;)i(e,t[o],a)||i(e,t[o],n)||n.push(t[o]),o+=1;return n}));e.exports=n},515:function(e,t){e.exports=function(e,t,a){for(var i=0,n=a.length;i<n;){if(e(t,a[i]))return!0;i+=1}return!1}},516:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t._parseLabel=t.extractStyleInfo=t.getLabel=t.setAxisPadding=t._createContainer=t.shiftLabels=t.setTickValues=t._drawLabel=t.getPixel=t.getTrendLineLimits=t.setDataLimit=t.setAxisDimention=void 0;var n=i(a(517)),o=i(a(482)),r=a(224),l={wrtVisible:!0},s=function(e,t){var a,i,n,o,l,s,c,h={labelfont:["fontFamily"],labelfontcolor:["fontColor"],labelfontsize:["fontSize",function(e){return e?(0,r.pluckNumber)(e)+"px":r.UNDEF}],labelfontbold:["fontWeight",function(e){return e?"bold":"normal"}],labelfontitalic:["fontStyle",function(e){return e?"italic":"normal"}],labelfontalpha:["fontAlpha"]},u=t.getFromEnv("dataSource").categories,d=u&&u[0]||{},g=function(e){return e},p=!1,f={};for(a in d)"category"===a||a in e||(i=d[a],e[a]=i);for(a in h)l=(o=h[a])[0],s=o[1]||g,i=e[a],n=e[l.toLowerCase()],i===r.UNDEF&&n===r.UNDEF||(c=s(i))===r.UNDEF&&(c=s(n))===r.UNDEF||(f[l]=c,p=!0),p&&(e.style=f)};t.getLabel=function(e){var t=this.config,a=t.tickValues&&t.tickValues.tickValue[e],i={};return a&&a.tooltext&&(i.label=a.label,a.tooltext=(0,r.parseTooltext)(a.tooltext,[3],i)),{label:a&&(a.oriLabel||a.label),tooltext:a&&a.tooltext}},t.setAxisPadding=function(e,t){void 0===e&&(e=0),void 0===t&&(t=0);var a,i=this.config,n=e,o=t,r=this.getScale().getDomain(),l=r[0],s=r[1];1===i.oriCatLen&&(0===n&&(n=.5),0===o&&(o=.5)),a=n-i.startPad,i.startPad=Math.max(i.startPad,n),i.endPad=Math.max(i.endPad,o),a>0&&(i.setPadding=!0,this._setAxisRange({min:l-a,max:s+a})),i.tickValues||i.originalMax&&i.originalMin&&this.setDataLimit(i.originalMax,i.originalMin)},t._createContainer=function(){var e,t,a,i,n,o=this.config,r=o.isVertical,l=this.getLinkedParent().getChildContainer(),s=l.axisBottomGroup,c=l.axisTopGroup,h=-this.getTranslation(),u=r?"T0,"+h:"T"+h+",0";t=this.createContainer("axisNameGroup",{name:"dataset-Name-group"},s),e=this.createContainer("axisLineGroup",{name:"axis-Line-group"},c),a=this.createContainer("axisTrendGroupTop",{name:"dataset-Trend-group-top"},c),i=this.createContainer("axisLabelGroup",{name:"dataset-Label-group"},s),n=this.createContainer("axisLabelGroupTop",{name:"dataset-Label-group"},c),o.axisContainer=this.createGroup("axisContainer",{name:"dataset-axis",transform:u},i),o.axisLabelContainerTop=this.createGroup("axisLabelContainerTop",{name:"dataset-top-label",transform:u},n),o.axisAxisLineContainer=this.createGroup("axisAxisLineContainer",{name:"axis-line-tick"},e),o.axisTrendLabelContainer=this.createGroup("axisTrendLabelContainer",{name:"dataset-axis-trend-label"},a),o.axisNameContainer=this.createGroup("axisNameContainer",{name:"dataset-axis-name"},t),o.axisAxisLineContainerBottom=this.createGroup("axisAxisLineContainerBottom",{name:"axis-line-tick-bottom"},s)},t.shiftLabels=function(e,t){var a=this.config.labels;a.shiftX=e,a.shiftY=t},t.setTickValues=function(e){var t,a,i,n=e&&e.length,o=this.config,l=o.startPad||0,c=this.getFromEnv("chart"),h=0,u=o.tickValues={},d=u.tickValue=[],g=u.vline=[],p=u.tickIdMap={},f=o.endPad||0;for(o.hasCategory=1,t=0;t<n;t+=1)i=(a=(0,r.extend2)({},e[t])).id||""===a.id,a.vline?(a.startIndex=d.length-1,g.push(a)):(i&&(p[a.id.toLowerCase()]={tickObj:a,index:h}),(o.mapTickValuesById&&i||!o.mapTickValuesById)&&(s(a,c),d.push(a),d[h].label=(0,r.parseUnsafeString)(d[h].label),h+=1));o.oriCatLen=h,this._setAxisRange({max:Number((0,r.toPrecision)(h-1+f,10)),min:Number((0,r.toPrecision)(0-l,10)),tickInterval:Number((0,r.toPrecision)(1,10))})},t._parseLabel=function(){var e,t,a,i,n,o,s,c,h,u,d,g,p,f,m,b,v=this,x=v.config,y=v.getLinkedItem("canvas").getEffectiveDimensions(),C=x.axisDimention,k=v.getFromEnv("chart"),S=k.config,w=x.axisRange,A=x.isOpposit,L=x.labels,N=v.components,F=N.labels,T=L.style,E=k.getFromEnv("smartLabel"),P=x.isVertical,_=w.max,D=w.min,I=v.getFromEnv("number-formatter"),M=y.top,O=y.left,R=M+y.height,B=O+y.width,V=x.labelPadding,z=x.extremeLabels,G=P?C.x:C.y,H=C.opposite,W=x.labelMaxH,j=x.labelMaxW,U=w.tickInterval,q=Math.abs(v.getPixel(D,l)-v.getPixel(D+U,l)),Y=[],X=x.ticks,K=0,Z=x.isReverse,J=(0,r.pluckNumber)(v.getFromEnv("chart-attrib").showzeroplanevalue),$=!0,Q=v.getLimit();if(T.fontSize=this.computeFontSize(T.fontSizeWithUnit),T.lineHeight=(0,r.setLineHeight)(T),E.useEllipsesOnOverflow(S.useEllipsesWhenOverflow),E.setStyle({fontSize:T.fontSize,fontFamily:T.fontFamily,lineHeight:T.lineHeight,fontWeight:T.fontWeight}),(i=T.lineHeight)&&-1!==i.indexOf("px")&&(i=parseFloat(i.replace("px",""))),0===J&&($=!1),x.labels.isDraw){var ee;if(x.drawLabelsOpposit&&(A=!A,G=H),h={fill:T.color,"line-height":i,"font-size":T.fontSize,opacity:1,cursor:T.labelLink?"pointer":""},a=x.labels.rotation,P?(x.labelMaxH>q&&!x.tickValues&&(s=Math.ceil(x.labelMaxH/q)),h["text-anchor"]=A?r.POSITION_START:r.POSITION_END):(x.labelMaxW>q&&!x.tickValues&&(s=Math.ceil(x.labelMaxW/q)),a?(h["text-anchor"]=A?r.POSITION_START:r.POSITION_END,h["vertical-align"]="middle"):h["vertical-align"]=A?r.POSITION_BOTTOM:r.POSITION_TOP,d=O,g=S.width-B),s>x.labels.step&&(x.labels.step=s),c=x.numberFormatterFn?I[x.numberFormatterFn]:x.isPercent?I.yAxisPercentValue:P?I.yAxis:I.xAxis,z.firstLabel={},z.lastLabel={},b=X.filter((function(e,t,a){return 0!==e||x.showZeroPlaneValue?!(!P&&(x.isReverse?0!==t:t!==a.length-1)&&v.getPixel(e,l)+x.labelMaxW>B)&&!(t%x.labels.step!=0&&(!x.labels.drawLimitVal||0!==t&&t!==a.length-1)||(Y[K++]=t,0)):!(!$||$&&Q.max!==e&&Q.min!==e)&&(Y[K++]=t,!0)})),x.isZeroTickForced&&-1!==b.indexOf(0))K=0,Y=[],m=v.getPixel(0),b=b.filter((function(e,t,a){return ee=v.getPixel(e),0===a[t+1]||0===a[t-1]?P?!(ee+W>=m&&m>=ee-W)&&(Y[K++]=t,!0):!(ee+j>=m&&m>=ee-j)&&(Y[K++]=t,!0):(Y[K++]=t,!0)}));for(n=(P?j:q/2)*x.labels.step,o=P?q/2:W,N.labelIndexArr=Y.slice(),e=0,t=b.length;e<t;e+=1)p=b[e],F[Y[e]]=F[Y[e]]||{config:{props:{label:{}}}},u=Object.assign({},h),f=r.UNDEF,(x.labels.drawNormalVal||p===D||p===_)&&(x.labels.drawLimitVal||p!==D&&p!==_)?p===D&&x.lowerLimitDisplay&&x.labels.drawLimitVal?(f=E.getSmartText(x.lowerLimitDisplay,n,o+i/2),u.text=f.text,u.tooltext=f.tooltext):p===_&&x.upperLimitDisplay&&x.labels.drawLimitVal?(f=E.getSmartText(x.upperLimitDisplay,n,o+i/2),u.text=f.text,u.tooltext=f.tooltext):(u.text=r.BLANKSTRING+c.call(I,p,x.axisIndex),f=E.getOriSize(u.text)):u.text=r.BLANKSTRING,P?(u.x=A?(G||B)+V:(G||O)-V,u.y=v.getPixel(p,l),(Z&&p===D&&x.lowerLimitDisplay||!Z&&p===_&&x.upperLimitDisplay)&&f&&f.height>i&&(u["vertical-align"]=r.POSITION_BOTTOM),(Z&&p===_&&x.upperLimitDisplay||!Z&&p===D&&x.lowerLimitDisplay)&&f&&f.height>i&&(u["vertical-align"]=r.POSITION_TOP),x.placeValuesInside&&(u["text-anchor"]=A?r.POSITION_END:r.POSITION_START)):(u.x=v.getPixel(p,l),u.y=A?(G||M)-V:(G||R)+V,(!Z&&p===D||Z&&p===_)&&f&&f.width>2*d&&(u["text-anchor"]=r.POSITION_START),(!Z&&p===_||Z&&p===D)&&f&&f.width>2*g&&(u["text-anchor"]=r.POSITION_END),x.placeValuesInside?u["vertical-align"]=A?r.POSITION_TOP:r.POSITION_BOTTOM:u["vertical-align"]=A?r.POSITION_BOTTOM:r.POSITION_TOP),u["text-bound"]=void 0===p?[]:[(0,r.pluck)(T.backgroundColor,r.BLANKSTRING),(0,r.pluck)(T.borderColor,r.BLANKSTRING),(0,r.pluck)(T.borderThickness,r.BLANKSTRING),(0,r.pluck)(T.borderPadding,0),(0,r.pluck)(T.borderRadius,0),(0,r.pluck)(T.borderDash,"none")],L.shiftX&&(u.x+=L.shiftX),L.shiftY&&(u.y+=L.shiftY),u.transform=(0,r.getSuggestiveRotation)(a,u.x,u.y),F[Y[e]].config.props.label.attr=u}},t._drawLabel=function(){var e,t,a,i,o,r,l,s,c,h,u,d=this.config,g=this.getFromEnv("animationManager"),p=this.getFromEnv("toolTipController"),f=d.axisRange,m=d.labels.style,b=this.components,v=f.max,x=f.min,y=d.axisContainer,C=d.extremeLabels,k=d.ticks,S=[],w={fontFamily:m.fontFamily,fontSize:m.fontSize,fontWeight:m.fontWeight,fontStyle:m.fontStyle,lineHeight:m.lineHeight};if(d.labels.isDraw)for(u=b.labels,h=b.labelIndexArr,y.css(w),t=0,a=h&&h.length;t<a;t+=1)o=(s=k[e=h[t]])+"_label",i=this.getGraphicalElement(o),l=u[e].config.props.label.attr,i=this.addGraphicalElement(o,g.setAnimation({el:i||"text",attr:l,container:y,data:{value:s},component:this,label:"text"})),l.tooltext||i.abbrArr?p.enableToolTip(i,l.tooltext):p.disableToolTip(i),s===v?C.lastLabel.graphic=i:s===x&&(C.firstLabel.graphic=i),S.push(o);for(e=0,a=(c=(0,n["default"])(d.prevIntervalArr,S)).length;e<a;e++)(r=this.getGraphicalElement(c[e]))&&this.removeGraphicalElement(r);d.prevIntervalArr=S},t.getPixel=function(e){return this.getScale().getRangeValue(e)},t.getTrendLineLimits=function(){var e,t,a,i,n=this.config,l=n.trendLines||n.vTrendLines||n.trendPoints,s=l&&l[0]&&l[0].line||l&&l.point;if(n.trendLimits)return n.trendLimits;var c=(0,o["default"])(s,(function(e){return""===e.startvalue?r.UNDEF:Number(e.startvalue)}));e=c[0],t=c[1];var h=(0,o["default"])(s,(function(e){return""===e.endvalue?r.UNDEF:Number(e.endvalue)}));return a=h[0],i=h[1],n.trendLimits=(0,o["default"])([e,t,a,i],(function(e){return Number(e)})),n.trendLimits},t.setDataLimit=function(e,t){var a,i,n,l,s=e,c=t,h=this.config,u=this.getFromEnv("dataSource").categories,d=u&&u[0]&&u[0].category,g=h.startPad||0,p=h.endPad||0,f=h.xAxisLabelMode;if("categories"===f||"mixed"===f){var m=(0,o["default"])(d,(function(e){return Number(e.x)}));a=m[0],i=m[1]}var b=this.getTrendLineLimits();n=b[0],l=b[1];var v=(0,o["default"])([n,l,a,i,c,s],(function(e){return Number(e)}));c=v[0],s=v[1],h.originalMax=s,h.originalMin=c,s=h.isPercent?100:s+p,c=h.isPercent?0:c-g,this._setAxisRange({min:c,max:s}),h.axisRange.tickInterval!==r.UNDEF&&this._adjustNumberFormatter(h.axisRange.tickInterval)},t.setAxisDimention=function(e){var t=this.getScale(),a=this.config,i=this.getFromEnv("chart").config,n=a.axisDimention||(a.axisDimention={}),o=a.isReverse;n.opposite=(0,r.pluckNumber)(e.opposite,n.opposite),n.x=(0,r.pluckNumber)(e.x,n.x,i.canvasLeft),n.y=(0,r.pluckNumber)(e.y,n.y,i.canvasTop),n.axisLength=(0,r.pluckNumber)(e.axisLength,n.axisLength),a.isVertical?o?t.setRange([n.y+n.axisLength,n.y]):t.setRange([n.y,n.y+n.axisLength]):o?t.setRange([n.x+n.axisLength,n.x]):t.setRange([n.x,n.x+n.axisLength]),a.translation=this._computeTranslation()},t.extractStyleInfo=s},517:function(e,t,a){var i=a(518),n=a(339)((function(e,t){for(var a=[],n=0,o=e.length;n<o;)i(e[n],t)||i(e[n],a)||(a[a.length]=e[n]),n+=1;return a}));e.exports=n},518:function(e,t,a){var i=a(519);e.exports=function(e,t){return i(t,e,0)>=0}},519:function(e,t,a){var i=a(520);e.exports=function(e,t,a){var n,o;if("function"==typeof e.indexOf)switch(typeof t){case"number":if(0===t){for(n=1/t;a<e.length;){if(0===(o=e[a])&&1/o===n)return a;a+=1}return-1}if(t!=t){for(;a<e.length;){if("number"==typeof(o=e[a])&&o!=o)return a;a+=1}return-1}return e.indexOf(t,a);case"string":case"boolean":case"function":case"undefined":return e.indexOf(t,a);case"object":if(null===t)return e.indexOf(t,a)}for(;a<e.length;){if(i(e[a],t))return a;a+=1}return-1}},520:function(e,t,a){var i=a(339),n=a(521),o=i((function(e,t){return n(e,t,[],[])}));e.exports=o},521:function(e,t,a){var i=a(522),n=a(515),o=a(523),r=a(346),l=a(524),s=a(525),c=a(527);function h(e,t,a,o){var r=i(e),l=i(t);function s(e,t){return u(e,t,a.slice(),o.slice())}return!n((function(e,t){return!n(s,t,e)}),l,r)}function u(e,t,a,i){if(l(e,t))return!0;var n=c(e);if(n!==c(t))return!1;if(null==e||null==t)return!1;if("function"==typeof e["fantasy-land/equals"]||"function"==typeof t["fantasy-land/equals"])return"function"==typeof e["fantasy-land/equals"]&&e["fantasy-land/equals"](t)&&"function"==typeof t["fantasy-land/equals"]&&t["fantasy-land/equals"](e);if("function"==typeof e.equals||"function"==typeof t.equals)return"function"==typeof e.equals&&e.equals(t)&&"function"==typeof t.equals&&t.equals(e);switch(n){case"Arguments":case"Array":case"Object":if("function"==typeof e.constructor&&"Promise"===o(e.constructor))return e===t;break;case"Boolean":case"Number":case"String":if(typeof e!=typeof t||!l(e.valueOf(),t.valueOf()))return!1;break;case"Date":if(!l(e.valueOf(),t.valueOf()))return!1;break;case"Error":return e.name===t.name&&e.message===t.message;case"RegExp":if(e.source!==t.source||e.global!==t.global||e.ignoreCase!==t.ignoreCase||e.multiline!==t.multiline||e.sticky!==t.sticky||e.unicode!==t.unicode)return!1}for(var d=a.length-1;d>=0;){if(a[d]===e)return i[d]===t;d-=1}switch(n){case"Map":return e.size===t.size&&h(e.entries(),t.entries(),a.concat([e]),i.concat([t]));case"Set":return e.size===t.size&&h(e.values(),t.values(),a.concat([e]),i.concat([t]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var g=s(e);if(g.length!==s(t).length)return!1;var p=a.concat([e]),f=i.concat([t]);for(d=g.length-1;d>=0;){var m=g[d];if(!r(m,t)||!u(t[m],e[m],p,f))return!1;d-=1}return!0}e.exports=u},522:function(e,t){e.exports=function(e){for(var t,a=[];!(t=e.next()).done;)a.push(t.value);return a}},523:function(e,t){e.exports=function(e){var t=String(e).match(/^function (\w*)/);return null==t?"":t[1]}},524:function(e,t,a){var i=a(339)((function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t}));e.exports=i},525:function(e,t,a){var i=a(340),n=a(346),o=a(526),r=!{toString:null}.propertyIsEnumerable("toString"),l=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],s=function(){"use strict";return arguments.propertyIsEnumerable("length")}(),c=function(e,t){for(var a=0;a<e.length;){if(e[a]===t)return!0;a+=1}return!1},h=i("function"!=typeof Object.keys||s?function(e){if(Object(e)!==e)return[];var t,a,i=[],h=s&&o(e);for(t in e)!n(t,e)||h&&"length"===t||(i[i.length]=t);if(r)for(a=l.length-1;a>=0;)n(t=l[a],e)&&!c(i,t)&&(i[i.length]=t),a-=1;return i}:function(e){return Object(e)!==e?[]:Object.keys(e)});e.exports=h},526:function(e,t,a){var i=a(346),n=Object.prototype.toString;e.exports=function(){return"[object Arguments]"===n.call(arguments)?function(e){return"[object Arguments]"===n.call(e)}:function(e){return i("callee",e)}}},527:function(e,t,a){var i=a(340)((function(e){return null===e?"Null":e===undefined?"Undefined":Object.prototype.toString.call(e).slice(8,-1)}));e.exports=i},528:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(509)),r=i(a(507)),l=i(a(529)),s=a(224),c=a(516),h=s.preDefStr.POSITION_START,u=s.preDefStr.POSITION_MIDDLE,d=s.preDefStr.POSITION_TOP,g=s.preDefStr.POSITION_BOTTOM,p=s.preDefStr.POSITION_END,f={wrtVisible:!0},m=function(e){function t(){var t;return(t=e.call(this)||this).config.scale=new l["default"],t}(0,n["default"])(t,e);var a=t.prototype;return a.getName=function(){return"category"},a.getCategoryFromId=function(e){var t=this.config.tickValues;return(t&&t.tickIdMap)[e]||{}},a.generateTicks=function(){var e=this.getScale(),t=this.config,a=e.getDomain(),i=t.categoryNumDivLines+1,n=(a[1]-a[0])/i,o=t.axisRange,l=o.min,s=o.max,c=(s-l)/i;return t._allTicks=(0,r["default"])(l,s,c).concat(s),o.tickInterval=c,(0,r["default"])(a[0],a[1],n).concat(a[1])},a._parseCategoryVline=function(){var e,t,a,i,n,o,r,l,c,f,m,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P,_,D,I,M,O=this.config,R=O.axisRange,B=R.min,V=R.max,z=this.getFromEnv("chart").config,G=z.style||{},H=O.isVertical,W={fontFamily:z.style.inCanfontFamily,fontSize:z.style.inCanfontSize,color:z.style.inCancolor,lineHeight:z.style.inCanLineHeight};for(a=(t=O.tickValues.vline).length,_=1!==this.getZoom(),D=this.getVisibleConfig(),o=0;o<a;o++)i=t[o],n=(0,s.parseUnsafeString)(i.label),r=Boolean((0,s.pluckNumber)(i.showlabelborder,O.showVLineLabelBorder,1)),e=Boolean((0,s.pluckNumber)(i.showlabelbackground,1)),"center"===(l=(0,s.pluck)(i.labelhalign,H?h:u))?l=u:"left"===l?l=h:"right"===l&&(l=p),(c=(0,s.pluck)(i.labelvalign,H?u:g).toLowerCase())===u?c=u:c===d?c=g:c===g&&(c=d),f=(0,s.pluckNumber)(i.labelposition,0),m=(0,s.pluckNumber)(i.lineposition,.5),b=(0,s.pluckNumber)(i.showvlines,O.showVLines,1),v=(0,s.pluckNumber)(i.alpha,O.vLineAlpha,80),x=(0,s.pluck)(i.color,O.vLineColor).replace(/^#?/,"#"),y=e?(0,s.pluck)(i.labelbgcolor,O.vLineLabelBgColor,"333333").replace(/^#?/,"#"):s.BLANKSTRING,T=(0,s.pluck)(i.labelcolor,O.vLineLabelColor,i.color,G.inCancolor,O.vLineColor).replace(/^#?/,"#"),C=(0,s.pluckNumber)(i.thickness,O.vLineThickness,1),2,k=Boolean(Number((0,s.pluck)(i.dashed,0))),S=(0,s.pluckNumber)(i.dashlen,5),A=(0,s.pluckNumber)(i.dashgap,2),w=W.fontSize,w=parseInt(w.replace(/px/i,""),10),E=(0,s.pluckNumber)(i.rotatelabel,O.rotateVLineLabels)?270:0,m=m<0||m>1?.5:m,f=f<0||f>1?0:f,x=(0,s.convertColor)(x,b?v:"0"),M=i.animate&&!H?i.startIndex+1:i.startIndex,P=this._getVlinePos(M,m)-(i.animate?i.leftShift:0),_&&(P<D.minValue||P>D.maxValue)||P<B||P>V||(L={opacity:1,stroke:x,"stroke-width":C,"stroke-dasharray":k?(0,s.getDashStyle)(S,A):"none"},F={opacity:1,text:n,"text-anchor":l,"vertical-align":c,"text-bound":[]},N={fontSize:W.fontSize,fontFamily:W.fontFamily,lineHeight:W.lineHeight},I={from:P,layer:(0,s.pluckNumber)(i.showontop,O.showVLinesOnTop,0)?3:2,attr:L,type:"line",startIndex:i.startIndex,linePosition:m},n&&(F["text-bound"]=[y,b&&r?x:s.BLANKSTRING,b&&r?1:0,2,s.UNDEF,b&&r?"solid":s.BLANKSTRING],F.fill=b?T:x,I.text={label:n,attr:F,layer:4,labelRotation:E,labelPosition:f,css:N}),this.setReferenceInfo(I),this.config.parsedVlineInfo.push(I))},a._parseReferenceVisuals=function(){e.prototype._parseReferenceVisuals.call(this),this.config.drawPlotlines&&this._parseCategoryVline()},a.categoryInsert=function(e,t,a){var i,n,o,r,l,c=e,h=this.config,u=h.axisRange.min,d=t.length,g=h.endPad||0;for(i=h.tickValues.tickValue,o=h.tickValues.tickIdMap,n=h.tickValues.vline,r=0;r<d;r+=1)"true"!==(l=(0,s.extend2)({},t[r])).vline&&!0!==l.vline&&1!==l.vline&&"1"!==l.vline?(l.id&&(o[l.id]={tickObj:l,i:c}),i.splice(c,0,l),c+=1):(l.startIndex=c-2,n.push(l));a&&this._setAxisRange({min:u,max:Number((0,s.toPrecision)(i.length-1+g,10))})},a.categoryDelete=function(e,t,a){var i,n,o,r=this.config,l=r.axisRange,s=l.min;for(n=0,o=(i=r.tickValues.vline).length;n<o;n++)i[n].animate=!0,i[n].leftShift=t;r.tickValues.tickValue.splice(e,t),this._shiftVline(e,t,"left"),a&&this._setAxisRange({min:s,max:l.max-t})},a._shiftVline=function(e,t,a){var i,n,o=this.config,r=o.tickValues.vline,l=o.tickValues.tickValue.length,s=r.length;for(i=0;i<s;i+=1)(n=r[i]).startIndex>=e&&("right"===a?n.startIndex+=t:n.startIndex-=t,(n.startIndex<0||n.startIndex>=l)&&(r.splice(i,1),s-=1,i-=1))},a.categoryTranslate=function(e){var t,a=e,i=this.config;a=(a||0)*(this.getPixel(1,f)-this.getPixel(0,f)),i.isReverse&&(a=-a),t=["T",a,",","0"].join(""),this.realTimeTranslatableGroups=[{group:i.axisContainer,translationStr:t},{group:i.axisTrendLabelContainer,translationStr:t}]},a.updateTicksValues=function(e,t){var a,i,n,o,r,l,s,c=this.config,h=c.parsedVlineInfo;if((a=c.tickValues.tickValue)[e])for(s in t)t.hasOwnProperty(s)&&("x"===s&&(i=!0),a[e][s]=t[s]);if(i)for(o=0,r=h.length;o<r;++o)if((l=(n=h[o]).startIndex)===e)n.from=this._getVlinePos(l,n.linePosition);else if(l+1===e){n.from=this._getVlinePos(l,n.linePosition);break}},a._getVlinePos=function(e,t){var a,i,n,o=this.getTickValues(),r=this.config,l=this.getLimit(),c=l.min,h=l.max,u=o[e],d=o[e+1];return u?d||(a=o[0]&&o[0].x?h:r.oriCatLen-1,n=!0):(a=o[0]&&o[0].x?c:-1,n=!0),i=n?t:((a=(0,s.pluckNumber)(u.x,u.y,e))-(0,s.pluckNumber)(d.x,d.y,e+1))*t,a+Math.abs(i)},a.getInterval=function(){if(this)return 1},a._setAxisRange=function(e){var t,a,i=e.min,n=e.max,o=this.config,l=o.axisRange,c=o.periodLength,h=o.dataLimit,u=h.max,d=h.min;i>n||(u===n&&d===i||(t=!0),o.visibleMin===s.UNDEF||o.setPadding||t?(h.max=n,h.min=i,c&&(o.categoryNumDivLines=(n-i)/c-1),a=(n-i)/(o.categoryNumDivLines+1),this.getScale().setDomain([i,n]),o.ticks=(0,r["default"])(i,n,a).concat(n),o._allTicks=o.ticks.slice(),l.min=i,l.max=n,l.tickInterval=a,this.setVisibleConfig(l.min,l.max)):o.setPadding=!1)},t}(o["default"]);m.prototype.setTickValues=c.setTickValues;var b=m;t["default"]=b},529:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=l(t);if(a&&a.has(e))return a.get(e);var i={},n=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in e)if("default"!==o&&Object.prototype.hasOwnProperty.call(e,o)){var r=n?Object.getOwnPropertyDescriptor(e,o):null;r&&(r.get||r.set)?Object.defineProperty(i,o,r):i[o]=e[o]}i["default"]=e,a&&a.set(e,i);return i}(a(486)),r=i(a(479));function l(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(l=function(e){return e?a:t})(e)}var s=function(e){function t(){return e.call(this,o.deInterpolateLinear,r["default"])||this}return(0,n["default"])(t,e),t.prototype.copy=function(){return(0,o.copyScale)(this,new t)},t}(o["default"]);t["default"]=s},530:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a=e._parseCanvasCosmetics&&e._parseCanvasCosmetics();if((0,r.componentFactory)(e,n["default"],"canvas",e.config.showVolumeChart?2:1),t=e.getChildren("canvas"))for(var i=0,l=t.length;i<l;i++)t[i].configure(a),(0,r.componentFactory)(t[i],o["default"],"axisRefVisualCartesian")};var n=i(a(467)),o=i(a(531)),r=a(224)},531:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=i(a(479)),l=i(a(513)),s=a(510),c=i(a(532)),h=a(232);(0,h.addDep)({name:"cartesianAxisRefAnimation",type:"animationRule",extension:c["default"]});var u=function(e){function t(){var t;return(t=e.call(this)||this).config.map={},t.config.explicitDrawItems={},t}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"axisRefVisuals"},a.getName=function(){return"axisRefVisualsCartesian"},a.draw=function(){var e,t,a,i,n,o,r,l=this.getDrawingInfo(),s=this.getexplicitDrawItems(),c=this.config,h=c.map,u={},d=this.getLinkedParent(),g=d.getAxes(),p=[],f=d.getChildContainer("axisReferenceVisualsFloor"),m=d.getChildContainer("axisReferenceVisualsBottom"),b=d.getChildContainer("axisReferenceVisualsMiddle"),v=d.getChildContainer("axisReferenceVisualsTop"),x=d.getChildContainer("axisReferenceVisualsCeil");for(d.config.trendlines=[],d.config.vtrendlines=[],t=0;t<g.length;++t)p.push(g[t].axis.getId());for(i in c.containers=[f,m,b,v,x],l)if(l.hasOwnProperty(i)&&(n=this.getLinkedItem(i),p.indexOf(n.getId())>=0))for((o=u[i])||(o=u[i]=[]),e=l[i],t=0;t<e.length;++t)"band"===(a=(r=e[t]).type)?o.push.apply(o,this.createBand(r,n)):"line"===a&&o.push.apply(o,this.createLine(r,n));if(c.isSmartDrawing)for(i in h)h.hasOwnProperty(i)&&!s[i]&&this.getLinkedItem(i)&&(u[i]=h[i]);this.resetexplicitDrawItems(),this.removeExtraElements(u)},a.getDrawingInfo=function(){var e,t,a={},i=this.getexplicitDrawItems(),n=this.isCanvasChnaged(),o=(this.config.isSmartDrawing=Object.keys(i).length&&!n)?i:this.getLinkedItem();for(e in o)o.hasOwnProperty(e)&&(t=o[e],a[e]=t.getReferenceInfo());return a},a.createLine=function(e,t){var a,i,n,o,l=this.config.containers,c=l[e.layer],h=t.config,u=this.getFromEnv("paper"),d=this.getFromEnv("chart").getName(),g=this.getLinkedParent(),p=this.getFromEnv("animationManager"),f=this.getFromEnv("toolTipController"),m=g.config,b=m.trendlines,v=h.isVertical,x=m.canvasLeft,y=m.canvasTop,C=y+m.canvasHeight,k=x+m.canvasWidth,S=(0,r["default"])(x,k),w=(0,r["default"])(y,C),A=t.getScale(),L=A.getRangeValue(e.from),N=void 0!==e.to&&A.getRangeValue(e.to)||L,F=v?["M",x,L,"L",k,N]:["M",L,C,"L",N,y],T=e.attr,E=e.text,P=E&&E.attr,_=E&&E.labelPosition||0,D=t.getId(),I=e.id||e.from,M=D+"_"+I,O=this.getGraphicalElement(M),R=e.handlers,B={start:e.from,end:e.to};for(n in T.path=(0,s.getCrispPath)(F,(o=T["stroke-width"],null!==o?T["stroke-width"]:1)).path.toString(),/trend/.test(e.id)&&b.push({x1:F[1],y1:F[2],x2:F[4],y2:F[5],tooltext:e.toolText,tolerance:T["stroke-width"]<5?2.5:T["stroke-width"]/2}),T["stroke-linecap"]="butt",(O=this.addGraphicalElement(M,p.setAnimation({container:c,el:O||"path",attr:T,component:this,axis:t,data:{value:B,path:F},label:"path"}))).data("data",B),E&&(a=D+"_"+I+P.text,i=this.getGraphicalElement(a),v?(P.x=S(_),P.y=L):(P.x=L,P.y=w(_)),P.text=E.label,P.transform=u.getSuggestiveRotation(E.labelRotation,P.x,P.y),(i=this.addGraphicalElement(a,p.setAnimation({container:l[E.layer],el:i||"text",attr:P,component:this,axis:t,data:{value:e.from},label:"text",css:E.css}))).data("data",e.from)),/zoomscatter/i.test(d)||(e.toolText?f.enableToolTip(O,e.toolText):f.disableToolTip(O)),R)R.hasOwnProperty(n)&&(O.on(n,R[n].bind(t)),i&&i.on(n,R[n].bind(t)));return E?[M,a]:[M]},a.createBand=function(e,t){var a,i,n,o,r,l,s=this.config.containers[e.layer],c=t.config,h=this.getFromEnv("animationManager"),u=this.getFromEnv("toolTipController"),d=this.getLinkedParent(),g=this.getFromEnv("chart").getName(),p=d.config,f=c.isVertical,m=p.canvasLeft,b=p.canvasTop,v=b+p.canvasHeight,x=m+p.canvasWidth,y=t.getScale(),C=e.from,k=void 0!==e.to?e.to:C,S=t.getId(),w=e.attr,A=e.handlers;for(r in a="canvasStart"===C?f?b:m:y.getRangeValue(C),i="canvasEnd"===k?f?v:x:y.getRangeValue(k),l=Math.abs(a-i),f?(w.x=m,w.y=Math.min(a,i),w.width=x-m,w.height=l):(w.x=Math.min(a,i),w.y=b,w.width=l,w.height=v-b),n=S+"_"+(e.id||w.x+"_"+w.y),o=this.getGraphicalElement(n),/trend/.test(e.id)&&d.config.vtrendlines.push({x1:w.x,y1:w.y,x2:w.x+w.width,y2:w.y+w.height,tooltext:e.toolText,tolerance:w["stroke-width"]<5?2.5:w["stroke-width"]/2,isTrendZone:1}),o=this.addGraphicalElement(n,h.setAnimation({container:s,el:o||"rect",attr:w,component:this,label:"rect"})),/zoomscatter/i.test(g)||(e.toolText?u.enableToolTip(o,e.toolText):u.disableToolTip(o)),A)A.hasOwnProperty(r)&&o.on(r,A[r].bind(t));return[n]},a.removeExtraElements=function(e){var t,a,i,n,o,r,s=this.config.map;for(t in s)if(e[t])for(n=(r=(0,l["default"])(s[t],e[t])).length,i=0;i<n;++i)(o=this.getGraphicalElement(r[i]))&&this.removeGraphicalElement(o);else for(n=(a=s[t]).length,i=0;i<n;++i)(o=this.getGraphicalElement(a[i]))&&this.removeGraphicalElement(o);this.config.map=e},a.setLinkedItem=function(t,a){e.prototype.setLinkedItem.call(this,t,a);var i,n=this;"axis"===a.getType()&&n.addExtEventListener("predraw",(function(e){(i=e.sender).getState("removed")&&(n.removeLinkedItem(i.getId()),n.asyncDraw())}),a)},a.addexplicitDrawItems=function(e,t){this.config.explicitDrawItems[e]=t},a.getexplicitDrawItems=function(){return this.config.explicitDrawItems},a.resetexplicitDrawItems=function(){this.config.explicitDrawItems={}},a.isCanvasChnaged=function(){var e,t=this.getLinkedParent().getEffectiveDimensions(),a=this.config;return e=JSON.stringify(t)!==JSON.stringify(a.canvasDim),a.canvasDim=t,e},t}(o.ComponentInterface);t["default"]=u},532:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=a(512),n={"initial.axisRefVisuals.axisRefVisualsCartesian":i.axisAnimationAxis,"update.axisRefVisuals.axisRefVisualsCartesian":i.axisAnimationFinal};t["default"]=n},533:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i,r,l,s,c,h=e.getChildren("canvas"),u=h.length,d=[],g=[];for(r=0;r<u;r++,d=[],g=[])if(!(t=h[r]).getState("removed")){for(i=t.getFromEnv("xAxis"),s=0;s<(i&&i.length);s++)i[s].getState("removed")||d.push(i[s]);for(i=t.getFromEnv("yAxis"),s=0;s<(i&&i.length);s++)i[s].getState("removed")||g.push(i[s]);for((0,o.componentFactory)(t,n["default"],"vCanvas",d.length*g.length),a=t.getChildren("vCanvas"),l=0,s=0;l<(d&&d.length);l++)for(c=0;c<(g&&g.length);c++,s++)a[s].xAxis(d[l]).yAxis(g[c]).canvas(t),a[s].configure(),a[s].addToEnv("vCanvas",a[s])}};var n=i(a(534)),o=a(224)},534:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=a(224),l=function(e,t){var a=e;return a="comp_"+a,t&&(this.config[a]=t),(t||!this.config[a])&&this||this.config[a]},s=function(e,t){return["T",e,",",t].join("")},c=function(e){return-e.getTranslation()},h=function(e,t){return{h:e,v:t}},u=["columnShadowVcanvasGroup","columnVcanvasGroup","areaShadowVcanvasGroup","areaVcanvasGroup","lineShadowVcanvasGroup","lineVcanvasGroup","defaultShadowVcanvasGroup","defaultVcanvasGroup","sumLabelsLayer","vcanvasLabelGroup"],d=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:e},container:t,state:"appearing",component:a,label:"group"})},g=function(e){return!/category/i.test(e.getName())},p=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getName=function(){return"virtualCanvas"},a.getType=function(){return"canvas"},a.xAxis=function(e){var t=l.call(this,"xAxis",e);return e&&this.listenToAxis(e),e&&this.addToEnv("xAxis",e),t},a.yAxis=function(e){var t=l.call(this,"yAxis",e);return e&&this.listenToAxis(e),e&&this.addToEnv("yAxis",e),t},a.paper=function(e){return l.call(this,"paper",e)},a.canvas=function(e){return l.call(this,"canvas",e)},a.configure=function(e){void 0===e&&(e={});var t=this.getFromEnv("chartConfig"),a=this.config;Object.assign(a,e),a.transposeAxis=t.transposeAxis,this._mapChildren((function(e){e.getState("removed")||"dataset"===e.getType()||e.configure&&e.configure()}))},a.getHorizontalVerticalAxes=function(){var e=this.xAxis(),t=this.yAxis();return t.config.isVertical?h(e,t):h(t,e)},a.preDraw=function(){this._mapChildren((function(e){e.getState("removed")||"dataset"===e.getType()||e.setVisibility&&e.setVisibility()}));var e,t=this.config.transposeAxis,a=this.getFromEnv("chart"),i=this.getAxisValuePadding(),n=i.left,o=i.right,r=i.top,l=i.bottom;(e=this.getDataLimits(!t)).min!==Infinity||e.max!==-Infinity?(this._setYAxisLimits(e.min,e.max),a._storeIntialLimit&&a._storeIntialLimit(e.min,e.max)):(this._setYAxisLimits(void 0,void 0),a._storeIntialLimit&&a._storeIntialLimit(void 0,void 0)),this._setXAxisLimits(e.xMin,e.xMax),this._setAxisValuePadding(n,o,r,l)},a.childChanged=function(e){void 0===e&&(e={});var t,a=this.config,i=a.transposeAxis;!1!==e.dataLimitChanged&&(t=this.getDataLimits(!i),!i||t.min===a.range.min&&t.max===a.range.max||(a.range.min=t.min,a.range.max=t.max,this.getFromEnv("yAxis").resetStoredLimits(),t.min!==Infinity||t.max!==-Infinity?this._setYAxisLimits(t.min,t.max):this._setYAxisLimits(void 0,void 0)),t.xMin===a.range.xMin&&t.xMax===a.range.xMax||(a.range.xMin=t.xMin,a.range.xMax=t.xMax,this.getFromEnv("xAxis").resetStoredLimits(),this._setXAxisLimits(t.xMin,t.xMax))),this.asyncDraw()},a._setAxisValuePadding=function(e,t,a,i){this.getFromEnv("xAxis").setAxisPadding(e,t),a&&i&&this.getFromEnv("yAxis").setAxisPadding(e,t)},a.getAxisValuePadding=function(){var e={},t=-Infinity,a=-Infinity,i=-Infinity,n=-Infinity;return this._mapChildren((function(o){o.getState("removed")||(e=o.getAxisValuePadding&&o.getAxisValuePadding()||{},t=Math.max(t,e.left||-Infinity),a=Math.max(a,e.right||-Infinity),i=Math.max(i,e.top||-Infinity),n=Math.max(n,e.bottom||-Infinity))})),t===-Infinity&&(t=0),a===-Infinity&&(a=0),i===-Infinity&&(i=0),n===-Infinity&&(n=0),this.config.padding||(this.config.padding={},this.config.padding.left=t,this.config.padding.right=a,this.config.padding.top=i,this.config.padding.bottom=n),{left:t,right:a,top:i,bottom:n}},a._setYAxisLimits=function(e,t){var a=this.getFromEnv("yAxis");g(a)&&a.setDataLimit(t,e)},a._setXAxisLimits=function(e,t){var a=this.getFromEnv("xAxis");g(a)&&(t!==-Infinity||e!==+Infinity?a.setDataLimit(t,e):a.setDataLimit(void 0,void 0))},a.getDataLimits=function(e){var t,a,i,n=this.getFromEnv("chart"),o=-Infinity,l=+Infinity,s=o,c=l,h=l,u=o;return this._mapChildren((function(n){var d;n.getDataLimits&&!n.getState("removed")&&(e||n.getState("visible"))&&(t=n.getDataLimits(e),d=t,a=(0,r.pluck)(d.xMax,o),i=(0,r.pluck)(d.xMin,l),s=Math.max(s,d.max),c=Math.min(c,d.min),u=Math.max(u,a),h=Math.min(h,i))})),this.config.range||(this.config.range={},this.config.range.min=c,this.config.range.max=s,this.config.range.xMin=h,this.config.range.xMax=u),n.config.yMax=s,n.config.yMin=c,{min:c,max:s,xMin:h,xMax:u}},a.listenToAxis=function(e){var t,a=this;t=function(){a.getState("drawn")&&a.asyncDraw()},this.getState("visiblerangeset"+e.getId())||(this.setState("visiblerangeset"+e.getId(),!0),a.addExtEventListener("visiblerangeset",t,e))},a.createContainer=function(){var e=this.getLinkedParent();!this.getChildContainer("columnShadowVcanvasGroup")&&this.addChildContainer("columnShadowVcanvasGroup",d("vcanvas-column-shadow",e.getChildContainer("columnShadowGroup"),this)),!this.getChildContainer("columnVcanvasGroup")&&this.addChildContainer("columnVcanvasGroup",d("vcanvas-column-plot",e.getChildContainer("columnGroup"),this)),!this.getChildContainer("areaShadowVcanvasGroup")&&this.addChildContainer("areaShadowVcanvasGroup",d("vcanvas-area-shadow",e.getChildContainer("areaShadowGroup"),this)),!this.getChildContainer("areaVcanvasGroup")&&this.addChildContainer("areaVcanvasGroup",d("vcanvas-area-plot",e.getChildContainer("areaGroup"),this)),!this.getChildContainer("lineShadowVcanvasGroup")&&this.addChildContainer("lineShadowVcanvasGroup",d("vcanvas-line-shadow",e.getChildContainer("lineShadowGroup"),this)),!this.getChildContainer("lineVcanvasGroup")&&this.addChildContainer("lineVcanvasGroup",d("vcanvas-line-plot",e.getChildContainer("lineGroup"),this)),!this.getChildContainer("defaultShadowVcanvasGroup")&&this.addChildContainer("defaultShadowVcanvasGroup",d("vcanvas-default-shadow",e.getChildContainer("defaultShadowGroup"),this)),!this.getChildContainer("defaultVcanvasGroup")&&this.addChildContainer("defaultVcanvasGroup",d("vcanvas-default-plot",e.getChildContainer("defaultGroup"),this)),!this.getChildContainer("vcanvasLabelGroup")&&this.addChildContainer("vcanvasLabelGroup",d("vcanvas-label",e.getChildContainer("datalabelsGroup"),this)),!this.getChildContainer("columnTrendGroup")&&this.addChildContainer("columnTrendGroup",d("columnTrendGroup",this.getChildContainer("columnVcanvasGroup"),this)),!this.getChildContainer("sumLabelsLayer")&&this.addChildContainer("sumLabelsLayer",d("vcanvas-sumLabelsLayer",e.getChildContainer("sumLabelsLayer"),this))},a.applyTranslation=function(){var e=this,t=function(e){return s(c(e.h),c(e.v))}(e.getHorizontalVerticalAxes());e.createContainer(),u.forEach((function(a){var i;i=a,(i=e.getChildContainer(i)).attr({transform:t})}))},a.draw=function(){this.applyTranslation(),this.setState("drawn",!0)},a.getCanvasPadding=function(){var e,t,a={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0};return this._mapChildren((function(i){if(i.getCanvasPadding&&!i.getState("removed")&&i.getState("visible"))for(t in e=i.getCanvasPadding()||{})e.hasOwnProperty(t)&&(a[t]=Math.max(e[t],a[t]))})),a},a.rtShiftAnim=function(e,t){var a,i=this,n=e,o=t,r=i.getFromEnv("xAxis"),l=i.getFromEnv("yAxis"),c=r.getPixel(1)-r.getPixel(0),h=l.getPixel(1)-l.getPixel(0),d=i.getFromEnv("animationManager");a=s(n=(n||0)*c,o=(o||0)*h),u.forEach((function(e){i.getChildContainer(e).attr({transform:a}),d.setAnimation({el:i.getChildContainer(e),attrs:{transform:"T0,0"}})}))},t}(o.ComponentInterface);t["default"]=p},535:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t;e.config.enablemousetracking?((0,o.componentFactory)(e,n["default"],"mouseTracker"),t=e.getChildren("mouseTracker")[0],e.config.mouseTrackerEventAdded||(t.addEvents(),e.config.mouseTrackerEventAdded=!0)):((t=e.getChildren("mouseTracker")&&e.getChildren("mouseTracker")[0])&&t._removeListners(),e.config.mouseTrackerEventAdded=!1)};var n=i(a(536)),o=a(224)},536:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(242)),o=i(a(238)),r=a(240),l=function(e){function t(){var t,a;return(t=e.call(this)||this).pIndex=1,t.handler=(a=(0,n["default"])(t),function(e){e.originalEvent&&a.getFromEnv("chart")._mouseEvtHandler(e,a.config.evtData)}),t.eventsList=["fc-mousedown","fc-mouseup","fc-mousemove","fc-click","fc-mouseover"],t.config={},t.config.evtData={},t}(0,o["default"])(t,e);var a=t.prototype;return a.getMouseEvents=function(e,t,a){var i=this._lastDatasetIndex,n=this._lastPointIndex,o={fireOut:!1,events:[]};switch(e.type){case"fc-click":o.events.push("fc-click");break;case"fc-mousemove":i===t&&n===a?(clearTimeout(this.mouseoutTimer),o.events.push("fc-mousemove")):(o.events.push("fc-mouseover"),o.fireOut=!0);break;case"fc-mousedown":i===t&&n===a||(o.fireOut=!0,o.events.push("fc-mouseover")),o.events.push("fc-mousedown");break;case"fc-mouseover":i===t&&n===a?clearTimeout(this.mouseoutTimer):(o.fireOut=!0,o.events.push("fc-mouseover"));break;case"fc-mouseup":this.hasTouchEvent=!1,o.events.push("fc-mouseup");break;case"fc-mouseout":o.fireOut=!0}return o},a.addEvents=function(){var e,t,a,i=this.getFromEnv("chart"),n=i.getChildren("canvas"),o=this.config.evtData,r=this.eventsList;for(i.config.enableMouseOutEvent&&r.push("fc-mouseout"),this._removeListners(),o.chart=i,o.mouseTracker=this,t=0;t<n.length;t++)for(a in e=n[t],r)e.addEventListener(r[a],this.handler)},a._removeListners=function(){var e,t,a,i=this.getFromEnv("chart").getChildren("canvas"),n=this.eventsList;for(a=0;a<i.length;a++)for(t in e=i[a],n)e.removeEventListener(n[t],this.handler);this._removeDocEvents()},a._removeDocEvents=function(){this.eventOutput&&this.eventOutput.unlisten(),this.eventOutput=void 0},a._dispose=function(){this._removeListners(),e.prototype._dispose.call(this)},t}(r.ComponentInterface);t["default"]=l},537:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i=e.getChildren(),n=i.canvas&&i.canvas[0],l=n&&n.getChildren("vCanvas"),h=l&&l[0]||n||e,u=e.getFromEnv("dataSource"),d=u.dataset,g=(0,r["default"])(d)&&d[0].data,p=u.data||g;a=g?s(s({},d[0]),c(p)):c(p);if(!p||0===p.length)return void e.setChartMessage();t=e.getDSdef(),(0,o.datasetFactory)(h,t,"dataset",1,[a])};var n=i(a(223)),o=a(224),r=i(a(391));function l(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function s(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?l(Object(a),!0).forEach((function(t){(0,n["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):l(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var c=function(e){var t=[],a=[];return(0,o.fcEach)(e,(function(e,i){"true"!==e.vline&&!0!==e.vline&&1!==e.vline&&"1"!==e.vline?t.push(e):a.push({index:i,data:e})})),{catData:a,data:t}}},538:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=t.PATTERN_TYPES=t._removePlots=void 0;var n=i(a(242)),o=i(a(238)),r=a(224),l=a(240),s=a(232),c=i(a(539)),h=a(236),u=["line","circle","square"];t.PATTERN_TYPES=u;var d,g=r.hasTouch?r.TOUCH_THRESHOLD_PIXELS:r.HOVER_THRESHOLD_PIXELS,p=r.regex.dropHash,f=r.preDefStr.DEFAULT,m=r.preDefStr.showHoverEffectStr,b=r.preDefStr.setRolloverAttrStr,v=r.preDefStr.setRolloutAttrStr,x=Math,y=x.min,C=x.max,k=x.abs,S={top:!0},w={right:!0},A={left:!0},L={bottom:!0},N=x.ceil,F=x.round,T=function(e,t){if(void 0===e&&(e={}),"function"==typeof t){var a=function(a){if(e.hasOwnProperty(a)){var i=e[a];Array.isArray(i)?i.forEach((function(e){return t(e,a)})):e[a]&&t(e[a],a)}};for(var i in e)a(i)}},E=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:e},container:t,state:"appearing",component:a,label:"group"})},P=function(e,t){void 0===e&&(e=[]),e.forEach((function(e){return T(e&&e.graphics,t)})),e.length=0};t._removePlots=P,(0,s.addDep)({name:"columnAnimation",type:"animationRule",extension:c["default"]});var _=function(e){function t(){var t;t=e.call(this)||this;var a=(0,n["default"])(t);return a.components={},a.components.removeDataArr=[],a.__hideElem=function(e,t){a._setRemoveAnim(e,"label"===t?"plotLabel":"rect")},a.__removeElem=function(e,t){a.__hideElem(e,t)},a.config.primitiveType="column",t}(0,o["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"column"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.showvalues=d,t.includeinlegend=1,t.plotfillalpha=d,t.plotfillangle=d,t.ratio=d,t.patternBgColor=r.TRACKER_FILL},a.preConfigure=function(t){if(!t)return!1;this.trimData(t),this.config.JSONData=t,e.prototype.preConfigure.call(this,t)},a.setSkippingInfo=function(e){this.addToEnv("skipInfo",e||{plotsPerBin:1,drawOnlyMap:[],draw:[],hide:[],skippingApplied:!1,dragHashMap:[]})},a.getSkippingInfo=function(){return this.getFromEnv("skipInfo")||{plotsPerBin:1,drawOnlyMap:[],draw:[],hide:[],skippingApplied:!1,dragHashMap:[]}},a.configure=function(t){if(!t)return!1;e.prototype.configure.call(this,t)},a.configureAttributes=function(){var e=this.getFromEnv("chart"),t=this.config;this.parseAttributes(),this._setConfigure(),this.getState("visible")&&!1===t.oldVisible&&(t.appearing=!0),t.oldVisible=this.getState("visible"),this._realTimeConfigure&&this._realTimeConfigure(),!1!==e.config.hasLegend&&e.config.showLegend&&this._addLegend(),this.ErrorValueConfigure&&this.ErrorValueConfigure(),this.config.YForStackUpdated=!1,this.setState("dirty",!0)},a.parseAttributes=function(){var e,t,a,i=this.getFromEnv("chart"),n=i.getChildren("yAxis")[0].config.isReverse,o=this.config,l=this.config.JSONData,s=i.config,c=s.singleseries,h=i.getFromEnv("chart-attrib"),d=this.getFromEnv("color-manager"),g=this.getJSONIndex(),p=o.plotColor=d.getPlotColor(g),f=(0,r.pluckNumber)(l.dashed,h.plotborderdashed,0),m=(0,r.pluckNumber)(s.useplotgradientcolor,1),b=i.isBar,v=s.is3D,x=s.isdual;o.showTextOutline=(0,r.pluckNumber)(h.textoutline,0),o.dashed=f,o.parentYAxis=x&&"s"===(0,r.pluck)(l.parentyaxis&&l.parentyaxis.toLowerCase(),"p")?1:0,o.maxValue=-Infinity,o.minValue=Infinity,o.minAbsNonZeroValue=Infinity,o.minAbsNonZeroData={},o.defaultPadding={left:.5,right:.5},(0,r.parseConfiguration)(l,o,s,{data:!0}),o.seriesname=(0,r.parseUnsafeString)(l.seriesname),o.showValues=(0,r.pluckNumber)(l.showvalues,h.showvalues,1),o.minplotheightforvalue=(0,r.pluckNumber)(l.minplotheightforvalue,h.minplotheightforvalue,0),o.showplotborder=(0,r.pluckNumber)(h.showplotborder,v?0:1),e=s.plotborderdashlen,t=s.plotborderdashgap,o.plotfillangle=(0,r.pluckNumber)(360-h.plotfillangle,b?180:n?90:270),o.plotfillalpha=a=(0,r.pluck)(l.alpha,h.plotfillalpha,r.HUNDREDSTRING),o.plotColor=p=(0,r.pluck)(l.color,p),o.legendSymbolColor=(0,r.getFirstColor)(o.plotColor),o.plotgradientcolor=(0,r.getDefinedColor)(h.plotgradientcolor,d.getColor("plotGradientColor")),!m&&(o.plotgradientcolor=""),o.plotborderalpha=(0,r.pluck)(h.plotborderalpha,a,r.HUNDREDSTRING),o.plotbordercolor=(0,r.pluck)(h.plotbordercolor,v&&!c?"#ffffff":d.getColor("plotBorderColor")),o.plotborderdashstyle=f?(0,r.getDashStyle)(e,t,void 0):"none",o.showShadow=v?(0,r.pluckNumber)(h.showshadow,1):(0,r.pluckNumber)(h.showshadow,d.getColor("showShadow")),o.definedGroupPadding=C(s.plotSpacePercent,0),o.includeinlegend=(0,r.pluckNumber)(l.includeinlegend,o.seriesname?1:0),this.setState("visible",1===(0,r.pluckNumber)(l.visible,!Number(l.initiallyhidden),1)),!0===this.getState("visible")?this._conatinerHidden=!1:this._containerHidden=!0,o.legendInteractivity=!1,this.setState("visible",1===(0,r.pluckNumber)(this.getState("visible"),o.JSONData.visible,!Number(o.JSONData.initiallyhidden),1)),o.usePattern=(0,r.pluckNumber)(s.usePattern,0),o.patternType=u.includes(l.patterntype)?l.patterntype:s.patternType,o.patternAngle=(0,r.pluckNumber)(l.patternangle,h.patternangle,o.patternType===u[0]?40:0),o.patternDensity=(0,r.pluckNumber)(l.patterndensity,s.patternDensity),o.patternSize=(0,r.pluckNumber)(l.patternsize,o.patternType===u[0]?2:4),o.patternAlpha=(0,r.pluckNumber)(l.patternalpha,s.patternAlpha),o.patternBgColor=(0,r.pluck)(l.patternbgcolor,o.patternBgColor)},a.trimData=function(e){if(this.components||!this.components.data||!this.components.data.length){var t,a,i=this.components,n=this.config,o=n&&n.context,r=this.getFromEnv("chart").isRealTime,l=o&&o.prevCatlen,s=this.getFromEnv("xAxis"),c=r?0:s.getTicksLen(),h=l-c,u=i&&i.data,d=u&&u.length,g=e.data&&e.data.length||0,p=d-g;h>p?(t=h,a=c):(t=p,a=g),t>0&&this.removeData(a,t,!1)}},a.hidePlots=function(){var e,t=this,a=t.components.data,i=t.getSkippingInfo(),n=i.hide,o=i.hideLabel;n.forEach((function(i){(e=a[i])&&e.graphics&&(T(e.graphics,t.__removeElem),e&&(e.graphics={}))})),o.forEach((function(i){(e=a[i])&&e.graphics&&(T(e.graphics,t.__removeElem),e&&(e.graphics={}))}))},a._setConfigure=function(e,t){var a,i,n,o,l,s,c,u,p=this,f=p.getFromEnv("chart"),m=f.config,b=p.config,v=p.getFromEnv("xAxis"),x=f.isRealTime,y=m.realTimeConfig&&m.realTimeConfig.numDisplaySets,C=p.getFromEnv("dataSource").categories&&p.getFromEnv("dataSource").categories[0]&&p.getFromEnv("dataSource").categories[0].category,k=b.initCatLen=x?C&&Array.isArray(C)&&C.filter((function(e){return!e.vline})).length||0:v.getTicksLen(),S=b.JSONData||[],w=e||S.data,A=e&&e.data.length,L=b.showplotborder,N=m.plotborderthickness,F=p.components.data,T=m.isDrag,E=p.getSkippingInfo&&p.getSkippingInfo(),P=E&&E.draw||[],_=E&&E.skippingApplied;for(c=A===d&&k>y?k-y:0,a=x?(0,r.pluckNumber)(A,k):Math.min(k,w&&w.length),m.dragTolerance=T?(L&&N>5?N/2+1:5)+g:0,F||(F=p.components.data=[]),_&&(a=P.length),s=c;s<a;s++)l=P[s]||s,e?(i=e&&e.data[l]||{},o=t!==d?F[u=t+l]:F[u=F.length-a+l],n=u):(i=w&&w[l]||{},o=F[l-=c],n=l),o||(o=F[n]={}),o.config||(o.config={},o.graphics={}),p._plotConfigure(n,i,A),u&&u++;_&&p.addJob("configureRestID",(function(){p._configureRestData()}),h.priorityList.postRender)},a._configureRestData=function(){var e,t,a,i,n,o=this.config,l=this.config.JSONData,s=l.data,c=this.getFromEnv("chart-attrib"),h=this.getFromEnv("xAxis").getTicksLen(),u=(this.getSkippingInfo&&this.getSkippingInfo()).drawOnlyMap,g=this.components.data;for(g||(g=this.components.data=[]),o.maxValue=-Infinity,o.minValue=Infinity,i=0;i<h;i++)u[i]||(a=g[i],t=i,(e=s&&s[i]||{}).tooltext!==d&&(e.tooltext=(0,r.parseTooltext)(e.tooltext,[3],{label:e.label},e,c,l)),a||(a=g[i]={}),a.config||(g[i].config={}),this._plotConfigure(t,e),n&&n++)},a._plotConfigure=function(e,t,a){var i,n,o,l,s,c,h,g,p,f,m,b,v,x,k,S,w,A,L,N,F,T,E,P,_,D,I,M,O,R,B,V,z,G,H=this.getFromEnv("chart"),W=H.config,j=this.config,U=j.JSONData,q=H.config.singleseries,Y=this.getFromEnv("yAxis"),X=this.getFromEnv("xAxis"),K=this.components.data[e],Z=H.getFromEnv("dataSource").chart,J=this.getFromEnv("color-manager"),$=j.showplotborder,Q=j.plotColor,ee=W.showtooltip,te=W.yaxisname,ae=W.xaxisname,ie=W.tooltipsepchar,ne=W.seriesnameintooltip,oe=W.plotborderdashlen,re=W.plotborderdashgap,le=W.plotborderthickness,se=(0,r.pluckNumber)(W.useroundedges,0),ce=W.plothovereffect,he=j.plotfillangle,ue=j.plotborderdashstyle,de=K.config,ge=H.isBar,pe=H.config.is3D,fe=W.use3dlighting,me=W.realTimeConfig&&W.realTimeConfig.numDisplaySets,be=me-j.initCatLen,ve=me&&be>=0?be:0,xe=W.usedataplotcolorforlabels;H.isRealTime||($=(0,r.pluck)((0,r.pluckNumber)(U.data[e].showplotborder,U.showplotborder),$),le=(0,r.pluck)((0,r.pluckNumber)(U.data[e].plotborderthickness,U.plotborderthickness),le)),G=X.getLabel(a?e-a:ve+e),de.origLabel=z=(0,r.getValidValue)((0,r.parseUnsafeString)(G.label)),v=de.label=(0,r.getValidValue)((0,r.parseUnsafeString)(G.tooltext))||z,t.tooltext!==d&&(t.tooltext=(0,r.parseTooltext)(t.tooltext,[3],{label:G.label},t,Z,U)),de.dataLabelStyle=this._configureDataLabelStyle(t),de.minplotheightforvalue=(0,r.pluckNumber)(t.minplotheightforvalue,j.minplotheightforvalue),de.showValue=(0,r.pluckNumber)(t.showvalue,j.showValues),de.givenPlotShowValue=(0,r.pluckNumber)(t.showvalue),de.setValue=b=Y.getCleanValue(t.value,(0,r.pluckNumber)(W.stack100percent)),de.setLink=(0,r.pluck)(t.link),de.toolTipValue=M=Y.dataLabels(b),de.setDisplayValue=O=(0,r.parseUnsafeString)(t.displayvalue),de.displayValue=(0,r.pluck)(O,M),de.dashed=R=(0,r.pluckNumber)(t.dashed,j.dashed),B=(0,r.pluckNumber)(t.dashlen,oe),V=re=(0,r.pluckNumber)(t.dashgap,re),de.valuePadding=(0,r.pluckNumber)(t.valuepadding,U.valuepadding,W.valuepadding),null!==b&&(j.maxValue=C(j.maxValue,b),j.minValue=y(j.minValue,b),0!==b&&j.minAbsNonZeroValue>Math.abs(b)&&(j.minAbsNonZeroValue=Math.abs(b),j.minAbsNonZeroData=de)),de.plotBorderDashStyle=m=1===R?(0,r.getDashStyle)(B,V):0===R?"none":ue,q?(Q=J.getPlotColor((0,r.pluckNumber)(e-a,e)),Q=(0,r.pluck)(t.color,Q),xe&&X.updateTicksValues(e,{labelfontcolor:(0,r.convertColor)(Q)}),f=(0,r.pluck)((0,r.pluckNumber)(U.data[e].plotborderalpha),t.alpha,t.borderalpha,j.plotborderalpha,g).toString(),de.id=t.id?(0,r.pluck)(t.id,de.id):(0,r.getValidValue)((0,r.parseUnsafeString)(G.label))):(Q=(0,r.pluck)(t.color,j.plotColor),f=H.isRealTime?(0,r.pluck)(t.alpha,j.plotborderalpha,g).toString():(0,r.pluck)((0,r.pluckNumber)(U.data[e].plotborderalpha,U.plotborderalpha),t.alpha,j.plotborderalpha,g).toString(),de.id=t.id?(0,r.pluck)(t.id,de.id):(0,r.getValidValue)((0,r.parseUnsafeString)(G.label))+"-"+(U.seriesname?U.seriesname:this.getJSONIndex())),Q=(0,r.hashify)(Q),p=(0,r.pluck)(t.ratio,j.ratio),g=(0,r.pluck)(t.alpha,j.plotfillalpha),de.plotFillAlpha=g,de.plotBorderAlpha=f,de.shadow={opacity:j.showShadow?g/100:0},b<0&&!se&&(c=j.plotfillangle,he=ge?180-he:360-he),H.isRealTime?de.plotbordercolor=(0,r.pluck)(U.plotbordercolor,j.plotbordercolor):de.plotbordercolor=(0,r.pluck)(U.data[e].plotbordercolor,U.plotbordercolor,j.plotbordercolor),("inherit"===de.plotbordercolor||j.usePattern&&!de.plotbordercolor)&&(de.plotbordercolor=Q),de.colorArr=x=(0,r.getColumnColor)(Q+","+j.plotgradientcolor,g,p,he,se,de.plotbordercolor,f,ge?1:0,!!pe),de.originalPlotColor=Q,de.patternType=u.includes(t.patterntype)?t.patterntype:j.patternType,de.patternAngle=(0,r.pluckNumber)(t.patternangle,U.patternangle,Z.patternangle,de.patternType===u[0]?40:0),de.patternDensity=(0,r.pluckNumber)(t.patterndensity,j.patternDensity),de.patternSize=(0,r.pluckNumber)(t.patternsize,U.patternsize,de.patternType===u[0]?2:4),de.patternAlpha=(0,r.pluckNumber)(t.patternalpha,j.patternAlpha),de.patternBgColor=(0,r.pluck)(t.patternbgcolor,j.patternBgColor),0!==ce&&(k=(0,r.pluck)(t.hovercolor,U.hovercolor,Z.plotfillhovercolor,Z.columnhovercolor,Q),S=(0,r.pluck)(t.hoveralpha,U.hoveralpha,Z.plotfillhoveralpha,Z.columnhoveralpha,g),!(w=(0,r.pluck)(t.hovergradientcolor,U.hovergradientcolor,Z.plothovergradientcolor,j.plotgradientcolor))&&(w=""),A=(0,r.pluck)(t.hoverratio,U.hoverratio,Z.plothoverratio,p),L=(0,r.pluckNumber)(360-t.hoverangle,360-U.hoverangle,360-Z.plothoverangle,he),N=(0,r.pluck)(t.borderhovercolor,U.borderhovercolor,Z.plotborderhovercolor,de.plotbordercolor),F=(0,r.pluck)(t.borderhoveralpha,U.borderhoveralpha,Z.plotborderhoveralpha,Z.plotfillhoveralpha,Z.columnhoveralpha,f,g),T=(0,r.pluckNumber)(t.borderhoverthickness,U.borderhoverthickness,Z.plotborderhoverthickness,$&&le),E=t.borderhoverdashed||U.borderhoverdashed||Z.plotborderhoverdashed,P=(0,r.pluckNumber)(t.borderhoverdashgap,U.borderhoverdashgap,Z.plotborderhoverdashgap,oe),_=(0,r.pluckNumber)(t.borderhoverdashlen,U.borderhoverdashlen,Z.plotborderhoverdashlen,re),D=E!==d?Number(E)?(0,r.getDashStyle)(_,P):"":m,(W.drawTrendRegion&&!pe||1===ce&&k===Q)&&(k=(0,r.getLightColor)(k,70)),I=(0,r.getColumnColor)(k+","+w,S,A,L,se,N,F.toString(),ge?1:0,!!pe),de.setRolloutAttr={fill:pe?[(0,r.toRaphaelColor)(x[0]),!fe]:(0,r.toRaphaelColor)(x[0]),stroke:$?(0,r.toRaphaelColor)(x[1]):r.TRACKER_FILL,"stroke-width":$?le:0,"stroke-dasharray":m},de.setRolloverAttr={fill:pe?[(0,r.toRaphaelColor)(I[0]),!fe]:(0,r.toRaphaelColor)(I[0]),stroke:N?(0,r.toRaphaelColor)(I[1]):r.TRACKER_FILL,"stroke-width":T,"stroke-dasharray":D},de.hoverColor=k,de.hoverAlpha=S,de.hoverBorderColor=N,de.hoverBorderAlpha=F),i=de.toolTipValue,de.origToolText=o=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(t.tooltext,U.plottooltext,Z.plottooltext),!1)),ee?null===i?h=!1:o!==d?(s=[1,2,3,4,5,6,7],n={yaxisName:te,xaxisName:ae,formattedValue:i,label:v},h=(0,r.parseTooltext)(o,s,n,t,Z,U)):(ne&&(l=(0,r.getFirstValue)(U&&U.seriesname)),h=l?l+ie:"",h+=v?v+ie:""):h=!1,de.toolText=h,de.setTooltext=h,c&&(he=c),de._x=e,de._y=b},a.updateYForStack=function(){var e,t,a,i,n,o,l=this.getFromEnv("chartConfig"),s=(0,r.pluckNumber)(l.showpercentvalues),c=(0,r.pluckNumber)(l.showpercentintooltip),h=this.config.JSONData,u=this.getFromEnv("chart-attrib"),g=this.getFromEnv("xAxis").getTicksLen(),p=this.components.data,f=this.getFromEnv("stackValues"),m=s||c?-1:1,b=this.getSkippingInfo&&this.getSkippingInfo(),v=b&&b.skippingApplied,x=b&&b.draw||[],y=x&&x.length;for(v&&(g=y),i=0;i<g;i++)t=(e=p[a=x[i]||i])&&e.config,e!==d&&(n=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(t.origToolText,h.plottooltext,u.plottooltext),!1)),o=f[a]&&f[a].positive+m*f[a].negative||0,t._b=this._parseValues(a,t._b,o,n),l.stack100percent&&(t._y=t.value+t._b))},a._parseValues=function(e,t,a,i){var n,o,l=t,s=this.getFromEnv("chartConfig"),c=this.components.data[e].config,h=(0,r.pluckNumber)(s.showpercentvalues),u=(0,r.pluckNumber)(s.showpercentintooltip),d=this.getState("visible"),g=c.setValue,p=(0,r.pluckNumber)(s.stack100percent),f=this.getFromEnv("number-formatter"),m=this.getFromEnv("yAxis"),b=c.setDisplayValue;return o=(d&&g||0)/(a||1)*100,n=f.percentValue(o),p&&(c.value=o,l=(l||0)/(a||1)*100),u&&(c.toolTipValue=n),h&&!b&&(c.displayValue=n),i&&(c.toolText=(0,r.parseTooltext)(c.setTooltext,[14,24,25,112],{percentValue:n,sum:m.dataLabels(a),unformattedSum:a})),l},a._addLegend=function(){var e,t,a,i=this.getFromEnv("chart").isBar,n=this.getFromEnv("chart-attrib"),o=this.config.JSONData||{},l=this.config,s=(0,r.getFirstColor)(l.legendSymbolColor),c=this.getFromEnv("legend"),h=!l.usePattern&&(0,r.pluckNumber)(n.use3dlighting,n.useplotgradientcolor,1),u=(0,r.getLightColor)(s,60).replace(p,r.HASHSTRING);l.includeinlegend?(e=h?{FCcolor:{color:s+","+s+","+(0,r.getLightColor)(s,40)+","+s+","+s,ratio:"0,30,30,30,10",angle:i?0:270,alpha:"100,100,100,100,100"}}:{FCcolor:{color:s,angle:i?0:270,ratio:"0",alpha:"100"}},a=c.getItem(this.config.legendItemId),t={type:this.getName(),index:this.getJSONIndex(),label:(0,r.getFirstValue)(this.config.JSONData.seriesname),usePattern:l.usePattern,legendIconAlpha:(0,r.pluckNumber)(o.legendiconalpha),patternAttr:{patternType:l.patternType,patternAngle:l.patternAngle,patternDensity:l.patternDensity,patternSize:l.patternSize,color:l.plotColor,patternAlpha:l.patternAlpha,patternBgColor:l.patternBgColor,alpha:l.plotfillalpha}},a||(this.config.legendItemId=c.createItem(this),a=c.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){a.itemClickFn()}),a)),a.configure(t),a.setStateCosmetics("default",{symbol:{fill:(0,r.toRaphaelColor)(e),bgAlpha:(0,r.pluckNumber)(o.legendiconbgalpha,o.legendiconalpha,n.legendiconbgalpha,n.legendiconalpha,l.plotfillalpha),borderAlpha:(0,r.pluckNumber)(o.legendiconborderalpha,o.legendiconalpha,n.legendiconborderalpha,n.legendiconalpha,"100"),rawFillColor:s,stroke:(0,r.toRaphaelColor)(u)}}),this.getState("visible")?a.removeLegendState("hidden"):a.setLegendState("hidden")):this.config.legendItemId&&c.disposeItem(this.config.legendItemId)},a.legendInteractivity=function(e){var t=e.getLinkedParent().getFromEnv("chart"),a=this.getState("visible"),i=this.config;if(t.getFromEnv("animationManager").setAnimationState("legendInteraction"),i.legendInteractivity=!0,a?this.hide():this.show(),r.isFirefox){var n=t.getChildContainer("plotGroup");n.attrs["clip-rect"]&&n.attr({"clip-rect":n.attrs["clip-rect"]})}i.drawnEvtListenerAttached||(i.drawnEvtListenerAttached=!0,this.addEventListener("drawn",(function(){i.legendInteractivity=!1})))},a.createPinElem=function(){var e,t,a,i=this,n=i.getFromEnv("chart"),o=arguments[1].group,r=i.components.data,l=i.graphics.pinElems||(i.graphics.pinElems=[]),s=i.getLinkedParent().getChildContainer().columnVcanvasGroup;for(e=l.length-1;e>=0;e--)l[e].remove(),l.pop();if(i.getState("visible"))for(e=i.config.scrollMinVal;e<i.config.scrollMaxVal;e++)(a=r[e])&&a.graphics&&(t=a.graphics.element.clone().attr({transform:["T",-(n.config._visx+k(s.transform()[0][1])),-n.config.canvasBottom]}),o.appendChild(t),l.push(t))},a._checkPointerOverColumn=function(e,t,a){var i,n,o,r,l,s,c,h,u,p=this.getFromEnv("chart").config,f=p.plotborderthickness,m=p.showplotborder,b=this.components.data,v=b&&b.length,x=0,y=0,C=p.dragTolerance||0,k=(this.getSkippingInfo&&this.getSkippingInfo()).plotsPerBin;for(c=u=(u=(h=(N(e/k)-1)*k+1)+k-1)<v?u:v;c>=h;c--){if(!(i=b[c]))return;if(i._height<g&&(x=g),i._width<g&&(y=g),(i._xPos||i._yPos)&&(n=i.config.setValue,m&&f!==d?s=f/2:f=s=0,null!==n&&(o=t-i._xPos+s,r=a-i._yPos+s+(n>=0?C:0),l=o>=-y/2&&o<=(y||i._width)+f&&r>=-x/2&&r<=(x||i._height)+f+(n<0?2*C:C))))return{pointIndex:c,hovered:l,pointObj:b[c]}}},a._getHoveredPlot=function(e,t){var a,i,n=e,o=t,r=this.getFromEnv("chart").isBar,l=this.getFromEnv("xAxis");return r?o+=l.getTranslation():n+=l.getTranslation(),a=l.getValue(r?o:n),(i=Math.round(a))-a>0?this._checkPointerOverColumn(i,n,o)||this._checkPointerOverColumn(i-1,n,o):this._checkPointerOverColumn(i+1,n,o)||this._checkPointerOverColumn(i,n,o)},a.getPlotInCategoryAt=function(e,t){void 0===e&&(e=0),void 0===t&&(t=0);var a,i,n,o,r=this.components.data,l=this.getFromEnv("xAxis"),s=this.getFromEnv("yAxis"),c=l.getTranslation()||0,h=s.getTranslation()||0,u=this.getState("visible"),d=e+c,g=t+h;if("category"===l.getName()&&l.config.hasCategory)i=l;else{if("category"!==s.getName()||!s.config.hasCategory)return!1;i=s}return null!=(n=i.config.isVertical)&&(a=r[Math.round(i.getValue(n?g:d))],o=this._getHoveredPlot(e,t),u&&o?o:!(!u||!a)&&{pointIndex:a._index,hovered:!1,pointObj:a})},a._decideTooltipType=function(e,t){var a=this.getFromEnv("chart").config.drawTrendRegion,i=this.components,n=this.getFromEnv("toolTipController"),o=i.data[e],r=o&&(o.config.finalTooltext||o.config.toolText),l=this.config.currentToolTip,s=t.originalEvent;r&&!a&&(l?s.target&&"tspan"===s.target.nodeName&&o.graphics&&o.graphics.label&&o.graphics.label.abbrArr&&o.graphics.label.abbrArr.length?n.hide(l):n.draw(s,r,l):l=this.config.currentToolTip=n.draw(s,r))},a._firePlotEvent=function(e,t,a){var i,n=this.getFromEnv("chart"),o=this.components,r=this.getFromEnv("toolTipController"),l=o.data[t],s=l.graphics&&l.graphics.element,c=l.graphics&&l.graphics.label,h=this.config.currentToolTip;if(s)switch(i=l.config.setLink,e){case"fc-mouseover":this._decideTooltipType(t,a),function(e,t,a,i,n){var o=t.graphics,r=o&&o.element,l=e.getFromEnv("animationManager"),s=r&&r.getData();!0!==s.draged&&(r&&0!==s.showHoverEffect&&(l.setAnimationState("mouseOver"),l.setAnimation({el:r,label:"rect",component:n,attr:r.getData().setRolloverAttr})),!i&&r&&e.plotEventHandler(r,a,"DataPlotRollOver"))}(n,l,a,d,this),i&&(s.css({cursor:"pointer"}),c&&c.css({cursor:"pointer"}));break;case"fc-mouseout":r.hide(h),function(e,t,a,i,n){var o=t.graphics,r=o&&o.element,l=e.getFromEnv("animationManager"),s=r&&r.getData();!0!==s.draged&&(r&&0!==s.showHoverEffect&&(l.setAnimationState("mouseOut"),l.setAnimation({el:r,label:"rect",component:n,attr:r.getData().setRolloutAttr})),!i&&r&&e.plotEventHandler(r,a,"DataPlotRollOut"))}(n,l,a,d,this),i&&(s.css({cursor:f}),c&&c.css({cursor:f}));break;case"fc-click":n.plotEventHandler(s,a);break;case"fc-mousemove":this._decideTooltipType(t,a)}},a.createContainer=function(){var e,t,a,i,n,o=this.getType(),r=this.getFromEnv("chart"),l=this.getLinkedParent(),s=this.config.primitiveType||o;!l.getChildContainer(s+"VcanvasGroup")&&(s="default"),e=l.getChildContainer(s+"VcanvasGroup"),n=l.getChildContainer(s+"ShadowVcanvasGroup"),t=l.getChildContainer("commonElemGroup")||e,i=l.getChildContainer("commonElemGroupLine"),a=l.getChildContainer("anchorGroup")||e,!this.getContainer("shadowGroup")&&this.addContainer("shadowGroup",E("shadow-group",n,this)),!this.getContainer("errorShadowGroup")&&this.addContainer("errorShadowGroup",E("error-shadow-group",n,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("commonElemsGroup",E("common-elems-group",t,this)),i?!this.getContainer("commonElemsGroupLine")&&this.addContainer("commonElemsGroupLine",E("common-elems-group",i,this)):this.removeContainer("commonElemsGroupLine"),!this.getContainer("plotGroup")&&this.addContainer("plotGroup",E("plot-group",a,this)),!this.getContainer("errorPlotGroup")&&this.addContainer("errorPlotGroup",E("error-plot-group",e,this)),r.hasAnchor&&this.getContainer("errorPlotGroup").insertBefore(this.getContainer("plotGroup")),!this.getContainer("labelGroup")&&this.addContainer("labelGroup",E("label-group",l.getChildContainer("vcanvasLabelGroup"),this).attr("class","fusioncharts-datalabels"))},a.createCoordinates=function(){var e,t,a,i,n,o,r,l,s,c,h=this.config,u=this.components.data,g=this.getFromEnv("chart"),p=g.isBar,f=this.getFromEnv("yAxis"),m=this.getFromEnv("xAxis"),b=f.getAxisBase(),v=f.getPixel(b),x=m.config.isVertical,y=g.config.xDepth||0,C=g.config.yDepth||0,k=u.length,S=this.components,w=this.getLinkedParent(),A=w.getstackConf&&w.getstackConf(),L=S.data,N=this.getSkippingInfo&&this.getSkippingInfo(),F=N&&N.skippingApplied,T=N&&N.draw||[],E=T&&T.length;for(!p&&(y=-y),p&&(C=-C),F&&(k=E),n=0;n<k;n++)t=(e=L[i=T[n]||n])&&e.config,e!==d&&(a=t._b,s=m.getPixel(A&&A[i]&&A[i].x||t._x),o=(isFinite(s)?s:0)+y,c=f.getPixel(t._y),r=(isFinite(c)?c:0)+C,l=(a?f.getPixel(a):v)+C,x?(t._Px=r,t._Py=o,t._Pby=o,t._Pbx=l):(t._Px=o,t._Py=r,t._Pby=l,t._Pbx=o),0===t.givenPlotShowValue?t.showValue=0:1===t.givenPlotShowValue?t.showValue=1:1!==t.givenPlotShowValue&&h.showValues&&(Math.sqrt((l-r)*(l-r))<t.minplotheightforvalue?t.showValue=0:t.showValue=1),this.getLineShift&&(t._Py+=this.getLineShift("y")))},a.setContainerVisibility=function(e){var t,a=this.getContainer();for(t in a)a.hasOwnProperty(t)&&(!1!==this.getState("visible")||!1!==this._conatinerHidden&&this._conatinerHidden!==d||e?(a[t].show(),this._conatinerHidden=!1):(a[t].hide(),this._conatinerHidden=!0))},a.plotAnimManager=function(e,t,a,i,n){void 0===n&&(n={});var o,r,l,s,c,h,u=this.getFromEnv("chart"),d=u.getFromEnv("animationManager"),g=u.config.is3D,p=u.config,f=this.getState("visible"),m=t.x,b=this.getSkippingInfo&&this.getSkippingInfo(),v=b&&b.draw||[],x=this.getFromEnv("plotGroup3d");h=((l=e&&e.config)&&l.setValue)<0,c=g?(r=h?x.negativeGroupArray:x.positiveGroupAarray)[u.isBar?r.length-1-a:a]:this.getContainer("plotGroup"),s={el:(o=e.graphics.element)||(g?"cubepath":"rect"),container:c,attr:f&&t,doNotRemove:!0,props:{originalIndex:v[a]||a},index:a,length:i,component:this,label:"rect"},f||(s.callback=function(){this.hide()}),e.graphics.element=o=d.setAnimation(s),g&&(o.appendTo(c),(p.isstacked&&h||!p.isstacked&&u.isBar)&&o.toBack()),o.addPattern(n,this.config.usePattern),null!==e.config.setValue?this.getState("visible")&&o.show():(o.remove(),delete e.graphics.element),l._oldPx=l._Px,l._oldX=m,f&&(e.oldPrevDataObj=e.prevDataObj)},a.flushOnScroll=function(e,t){for(var a,i=this.components.data,n=e,o=t-1;n<=o;n++)(a=i[n])&&a.graphics&&(T(a.graphics,this.__removeElem),a.graphics={})},a.removingDraw=function(){var t=this;t.components.data.forEach((function(e){T(e.graphics,t.__removeElem),delete e.graphics})),e.prototype.removingDraw.call(this)},a._contextChanged=function(){var e;this.config.context||(this.config.context={});var t,a=this.config.context,i=a.shift,n=this.getFromEnv("xAxis"),o=this.getFromEnv("yAxis"),r=a.axisLimit,l=!1,s={yAxis:{limit:o.getVisibleConfig()},xAxis:{limit:n.getVisibleConfig()}};return s.yAxis.limitPixel={min:o.getPixel(s.yAxis.limit.minValue),max:o.getPixel(s.yAxis.limit.maxValue)},s.xAxis.limitPixel={min:n.getPixel(s.xAxis.limit.minValue),max:n.getPixel(s.xAxis.limit.maxValue)},r!==(t=JSON.stringify(s))&&(a.axisLimit=t,l=!0),i!==this.getFromEnv("shift")&&(a.shift=this.getFromEnv("shift"),l=!0),a.prevColNum!==this.getFromEnv("numOfColumns")&&(a.prevColNum=this.getFromEnv("numOfColumns"),l=!0),n.getProcessLen?e=n.getProcessLen():n.getTicksLen&&(e=n.getTicksLen()),a.prevCatlen!==e&&(a.prevCatlen=e,l=!0),!!this.getFromEnv("chart").isRealTime||l},a.calculateScrollRange=function(){var e,t=this.config,a=this.getFromEnv("xAxis"),i=a.getTicksLen(),n=this.getSkippingInfo&&this.getSkippingInfo()||{},o=n.skippingApplied,r=n.draw||[],l=n.labelDraw||[],s=r.length;e=o?s-1:i,t.scrollMinVal=C(F(a.getVisibleConfig().minValue),0)-1,t.scrollMaxVal=y(F(a.getVisibleConfig().maxValue)+1,e)+1,e=o?l.length-1:i,t.scrollMinValForLabel=C(F(a.getVisibleConfig().minValue),0)-1,t.scrollMaxValForLabel=y(F(a.getVisibleConfig().maxValue)+1,e)+1},a.drawPlots=function(){var e,t,a,i,n,o,r,l,s,c=this.getFromEnv("chart"),h=this.config,u=c.config.plothovereffect,d=this.components.data,g=this.getContainer("shadowGroup"),p=h._oldStartIndex,f=h._oldEndIndex,x=this.getSkippingInfo&&this.getSkippingInfo(),y=x&&x.draw;for(r=h.scrollMinVal,l=h.scrollMaxVal,r>p&&this.flushOnScroll(p,r>f?f:r),l<f&&this.flushOnScroll(l<p?p:l,f),h._oldStartIndex=r,h._oldEndIndex=l,e=r,s=l-1;e<l;e++,s--)(t=d[y[e]||e])&&(o=(i=t.config).props.element.attr,this.plotAnimManager(t,o,e,l,i.props.element.patternAttr),n=t.trackerConfig,(a=t.graphics.element)&&(a.shadow(i.shadow,g).data("BBox",void 0),c.config.enablemousetracking&&a.data("eventArgs",n.eventArgs).data(m,u).data(b,i.setRolloverAttr||{}).data(v,i.setRolloutAttr||{})))},a.setColumnPosition=function(){var e,t;if((e=this.getFromEnv("plotWidth"))===d){var a,i,n=this.getFromEnv("xAxis"),o=this.getFromEnv("chartConfig"),l=this.getSkippingInfo().plotsPerBin,s=C(o.plotSpacePercent,0),c=C((0,r.pluckNumber)(s,20)%100,0),h=1===l?c/200:0,u=n.getPixel(0),g=n.getPixel(l),p=this.getFromEnv("chart"),f=p.isBar?p.config.maxBarHeight:p.config.maxColWidth,m=k(g-u),b=!0;e=(a=(1-.01*s)*m||y(m*(1-2*h),1*f))/1,g-(i=a/2)-(u-i+a)<4&&(b=!1),0===c&&(b=!0),this.addToEnv("isCrisp",b)}this.addToEnv("columnWidth",e),t=this.getFromEnv("shift")||0,this.addToEnv("columnXShift",t-this.getFromEnv("columnWidth")/2)},a.addDatasetSpecificEvtArgs=function(e){var t=this.config,a=e,i=a.config,n=this.getFromEnv("chart").config,o=a.trackerConfig.eventArgs;Object.assign(o,{color:i.originalPlotColor,gradientColor:t.plotgradientcolor,alpha:i.plotFillAlpha,borderColor:i.plotbordercolor||t.plotbordercolor,borderAlpha:i.plotBorderAlpha,borderThickness:n.plotborderthickness,borderDashed:i.dashed,hoverColor:i.hoverColor,hoverAlpha:i.hoverAlpha,borderHoverColor:i.hoverBorderColor,borderHoverAlpha:i.hoverBorderAlpha}),t.usePattern?(o.pattern={patternType:i.patternType,patternColor:i.color,patternBgColor:i.patternBgColor===r.TRACKER_FILL?d:i.patternBgColor},delete o.color):delete o.pattern},a.parsePlotAttributes=function(e,t){var a,i,n,o,l,s,c,h,u,d,p,f,m,b,v,x,C,N,F,T,E,P,_,D,I=this.config,M=this.config.JSONData,O=this.getFromEnv("chart"),R=O.getFromEnv("dataSource").chart,B=O.config.isstacked,V=this.config,z=this.groupManager,G=this.getJSONIndex(),H=t,W=this.getState("visible"),j=O.config,U=O.config.is3D,q=O.isBar,Y=j.xDepth||0,X=j.yDepth||0,K=this.getFromEnv("yAxis"),Z=this.getFromEnv("xAxis"),J=j.showtooltip,$=!1!==this.getState("visible"),Q=this.components.data,ee=e.config,te=K.getAxisBase(),ae=K.yBasePos=K.getPixel(te),ie=(0,r.pluckNumber)(V.plotborderthickness,j.plotborderthickness),ne=(0,r.pluckNumber)(j.useroundedges,0),oe=V.use3dlighting,re=z&&z.stackConf,le=this.getFromEnv("columnXShift"),se=O.config.viewPortConfig,ce=se.x,he=se.scaleX,ue=(0,r.pluckNumber)(j.showplotborder);if(O.isRealTime||(ue=(0,r.pluckNumber)((0,r.pluck)(M.data[t].showplotborder,M.showplotborder),ue),ie=(0,r.pluck)((0,r.pluckNumber)(M.data[t].plotborderthickness,M.plotborderthickness),ie)),m=ee.setLink,v=ee.colorArr||[],Z.config.isVertical?(h=this.getFromEnv("columnWidth"),c=le):(l=this.getFromEnv("columnWidth"),s=le),e.graphics||(Q[H].graphics={}),b=ee.displayValue,!$&&(ee._Py=ee._Pby),F=y(ee._Px,ee._Pbx)+(s||0)+ce*he,T=y(ee._Py,ee._Pby)+(c||0),re&&(F-=l/2),E=l||k(ee._Px-ee._Pbx),P=h||k(ee._Py-ee._Pby),a=q?ee._Px-ee._Pbx>0?w:A:ee._Py-ee._Pby>0?L:S,f=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(ee.origToolText,M.plottooltext,R.plottooltext),!1)),this.fineTunePlotDimension&&(F=(D=this.fineTunePlotDimension(F,T,P,E,H)).xPos,T=D.yPos,E=D.width,P=D.height),i=F,n=T,u=E,d=P,o=Z.getPixel(1)-Z.getPixel(0)-(q?d:u),!isFinite(d)&&(d=0),W){if(o<5&&this.getFromEnv("columnWidth")<5||(C=(0,r.crispBound)(F,T,u,d,ie,a,B)),C?(i=C.x,n=C.y,ie=C["stroke-width"],u=C.width,d=C.height):(i=F,n=T),Z.config.isVertical){if(0===u){var de=I.minAbsNonZeroData,ge=k(de._Px-de._Pbx);u=ge<.5?ge:.5}}else if(0===d){var pe=I.minAbsNonZeroData,fe=k(pe._Py-pe._Pby);d=fe>0&&fe<.5?fe:.5,n===ae&&(n-=d)}ee.setRolloutAttr&&(ee.setRolloutAttr["stroke-width"]=ue?ie:0)}p=ee.finalTooltext=!1!==ee.toolText?ee.toolText+(f?"":ee.toolTipValue):"",x=ee.plotBorderDashStyle,(N=e.trackerConfig={}).eventArgs={index:H,link:m,value:ee.setValue,displayValue:b,categoryLabel:ee.origLabel,toolText:p,id:ee.id,datasetIndex:G,datasetName:M.seriesname,visible:W},this.addDatasetSpecificEvtArgs(e),_=ae===n+0,ee.props={element:{attr:{x:i||0,width:u||0,height:d||0,y:n||0,r:ne,fill:(0,r.toRaphaelColor)(v[0])||"",stroke:ue?V.usePattern?ee.originalPlotColor:(0,r.toRaphaelColor)(v[1])||"":r.TRACKER_FILL,"stroke-width":ue?ie:0,"stroke-dasharray":x,"stroke-linejoin":"miter",visibility:W,cursor:m?"pointer":""}}},ee.props.element.patternAttr={patternType:ee.patternType,patternAngle:ee.patternAngle,patternDensity:ee.patternDensity,patternSize:ee.patternSize,color:ee.originalPlotColor,patternAlpha:ee.patternAlpha,patternBgColor:ee.patternBgColor,alpha:ee.plotFillAlpha,x:ee.props.element.attr.x,y:ee.props.element.attr.y},U&&(ee.props.element.attr.noGradient=!oe,ee.props.element.attr.xDepth=Y,ee.props.element.attr.yDepth=X),e._xPos=i+Y,e._width=u,e._yPos=n-X,e._height=d,e._index=H,e._plotBorderThickness=ie,(m||J)&&(d<g&&(n-=(g-d)/2,d=g),N.attr={x:i,y:n,width:u,height:d,r:ne,cursor:m?"pointer":"",stroke:r.TRACKER_FILL,"stroke-width":ue?ie:0,fill:r.TRACKER_FILL,visibility:W}),ee.oldValue=void 0,e._oldYBaseTouched=_},a.parseLabelAttributes=function(e){var t,a,i,n,o,r,l,s,c,h,u,g,p,f=this.getFromEnv("chart"),m=f.config,b=f.getFromEnv("smartLabel"),v=f.config.dataLabelStyle,x=this.config.legendInteractivity,y=this.getState("visible"),C=m.rotatevalues?270:0;if(h=(u=e&&e.config)&&u.setValue,e===d||h===d||null===h||!0===u.labelSkip)return u&&delete u.labelSkip,void((p=e&&e.graphics)&&p.label&&p.label.hide());(o=e.graphics)&&(s=e._yPos,c=e._xPos,i=u.displayValue,u.showValue&&null!==h?(x&&u._state||(b.setStyle(v),n=b.getOriSize(i),u._state=C?{labelWidth:n.height,labelHeight:n.width}:{labelWidth:n.width,labelHeight:n.height}),l=(g=this._getValuePosition({labelWidth:u._state.labelWidth,labelHeight:u._state.labelHeight,width:e._width,height:e._height,yPos:s,xPos:c,value:h,valuePadding:u.valuePadding})).textX,r=g.textY,u.props||(u.props={}),t=u.dataLabelStyle,u.props.label={attr:{x:l,y:r,text:i,"text-bound":[t.backgroundColor,t.borderColor,v.borderThickness,v.borderPadding,v.borderRadius,v.borderDash],opacity:y?1:0}},a=u.props.label.attr,x||(a["line-height"]=v.lineHeight,a.fill=t.color)):o.label&&(o.label.attr({"text-bound":[]}),o.label.hide()))},a.allocatePosition=function(){var e,t,a,i,n,o,r,l,s=this.getFromEnv("chart"),c=s.config,h=this.config,u=this.components.data.length,d=this.getFromEnv("yAxis"),g=this.components.data,p=c.isstacked,f=this.getSkippingInfo&&this.getSkippingInfo(),m=f&&f.draw;for(this.deleteFromEnv("columnWidth"),this.setColumnPosition(),this.calculateScrollRange(),p&&this.updateYForStack(),this.createCoordinates(),i=d.getLimit(),r=d.getPixel(i.max),l=d.getPixel(i.min),n=h.scrollMinVal,o=h.scrollMaxVal,r>l?(h.yAxisMaxPixel=r,h.yAxisMinPixel=l):(h.yAxisMaxPixel=l,h.yAxisMinPixel=r),t=0;t<u;t++)e=m[t]||t,s.hasScroll&&(e<n||e>o)||(a=g[e])&&(this.parsePlotAttributes(a,e),this.parseLabelAttributes(a))},a.draw=function(){var e,t,a=this,i=a.config,n=a.getState("visible"),o=a.getFromEnv("xAxis"),r=o.getPixel(0),l=o.getPixel(1),s=a.getFromEnv("groupMaxWidth"),c=a.getFromEnv("chart").config.xDepth||0,u=a.getFromEnv("yAxis"),d=i.drawn,g=u.getLimit(),p=g.max,f=g.min,m=p>0&&f<0,b=a._contextChanged(),v=(a.getSkippingInfo&&a.getSkippingInfo()||{}).skippingApplied;s||(s=k(l-r),a.addToEnv("groupMaxWidth",s)),(a.getState("removed")||a.getState("dirty")||b&&n)&&(!d&&a.createContainer(),a.setContainerVisibility(!0),v&&a.hidePlots(),a.drawPlots(),a.drawCommonElements&&!a.config.skipCommonElements&&a.drawCommonElements(),e=i.scrollMinValForLabel,t=i.scrollMaxValForLabel,i.drawn?a.drawLabel(e,t):a.addJob("labelDrawID",(function(){a.drawLabel(e,t)}),h.priorityList.label),i.drawn=!0,i.appearing&&(i.appearing=!1),a.removePlots(),i.oldGroupMaxWidth=s,i.oldDataIsPositiveNegative=m,i.oldZeroAxisPos=u.getPixel(u.getAxisBase())+c,a.drawErrorValue&&a.drawErrorValue(),i.prevVisible=n,i.catDiff=0)},a.show=function(){var e=this.getLinkedParent(),t=this.getFromEnv("legend");t&&t.getItem(this.config.legendItemId)&&t.getItem(this.config.legendItemId).removeLegendState("hidden"),this.setState("visible",!0),this.config.appearing=!0,this._conatinerHidden=!1,this.setState("dirty",!0),e.childChanged(),this.asyncDraw()},a.hide=function(){var e=this.getLinkedParent(),t=this.getFromEnv("legend");t&&t.getItem(this.config.legendItemId)&&t.getItem(this.config.legendItemId).setLegendState("hidden"),this.setState("dirty",!0),this.setState("visible",!1),e.childChanged(),this.asyncDraw()},a.drawLabel=function(e,t){var a,i,n,o,l,s,c,h,u,g,p,f,m=this.getFromEnv("chart"),b=this.getFromEnv("animationManager"),v=this.getFromEnv("toolTipController"),x=m.config,y=this.getFromEnv("xAxis"),C=this.getFromEnv("paper"),k=this.getState("visible"),S=m.getFromEnv("smartLabel"),w=m.config.dataLabelStyle,A=this.config,L=y.getTicksLen(),N=this.components,F=N.data,T=N.pool,E=x.rotatevalues?270:0,P=A.labelDrawn,_=this.getSkippingInfo&&this.getSkippingInfo(),D=_&&_.skippingApplied,I=_&&_.labelDraw||[],M=I.length,O=(0,r.pluckNumber)(e,0),R=(0,r.pluckNumber)(t,D?M:L),B=M===Math.abs(R-(O+1)),V=function(){this.attr({"text-bound":[]}),this.hide()};for((f=this.getContainer("labelGroup")).css({fontFamily:w.fontFamily,fontSize:w.fontSize,fontWeight:w.fontWeight,fontStyle:w.fontStyle}),f.show(),S.useEllipsesOnOverflow(m.config.useEllipsesWhenOverflow),S.setStyle(w),o=O;o<R;o++)c=(h=(a=F[n=D&&B?I[o]:o])&&a.config)&&h.setValue,a!==d&&c!==d&&null!==c&&!0!==h.labelSkip?(l=a.graphics)&&(h.showValue&&null!==c?(i=h.props.label.attr,s=a._xPos,!l.label&&P&&m.isRealTime&&((u=(0,r.extend2)({},i)).x=i.x-s+(a._newXPos||0),u.transform=C.getSuggestiveRotation(E,u.x,i.y),T&&T.label[0]&&(l.label=T.label[0],T.label.splice(0,1))),i.transform=C.getSuggestiveRotation(E,i.x,i.y),(g=l.label)||T&&T.label[0]&&(g=l.label=T.label[0],T.label.splice(0,1)),g=b.setAnimation({el:l.label||"text",attr:i,component:this,label:"plotLabel",index:n,container:f,callback:!k&&V}),x.showtooltip&&g.abbrArr&&g.abbrArr.length&&v.enableToolTip(g,d),g&&g.show(),g&&g.outlineText(A.showTextOutline,i.fill),l.label||(l.label=this.addGraphicalElement("plotLabel",g,!0))):l.label&&(l.label.attr({"text-bound":[]}),l.label.hide())):(h&&delete h.labelSkip,(p=a&&a.graphics)&&p.label&&p.label.hide());A.labelDrawn=!0},a._getValuePosition=function(e){var t,a,i,n,o,l,s,c,h,u=this.getFromEnv("chart"),d=u.getChildren(),g=u.config,p=d.yAxis[0],f=g.xDepth||0,m=g.yDepth||0,b=g.canvasTop,v=g.canvasHeight+m,x=e.yPos,k=u.config.is3D,S=u.config.isstacked,w=e.valuePadding+2,A=e.height,L=e.width,N=g.placevaluesinside,F=e.labelHeight,T=p.getAxisConfig("isReverse"),E=e.value;return T||(c=!(E<0)),l=h=F+w,n=A,i=x-(s=.5*h+w),a=e.xPos+.5*L,(o=(0,r.pluck)(c,E<0))?(t=b+v-(x+A+m),i=x):t=x-b,S?(i=y(b+v-.5*l,i=x+.5*A+(m||0)),i=C(b+.5*l,i),a-=f):N?n>=l?(i=x+(o?A-s:s),k&&(a-=f,i+=m)):t>=l?(i=x+(o?A+s:-s),k&&o&&(a-=f,i+=m)):(i=x+(o?A-s:s),k&&(a-=f,i+=m)):t>=l?(i=x+(o?A+s:-s),k&&(o?(a-=f,i+=m):a-=f/2)):(i=x+(o?A-s:s),k&&(a-=f,i+=m)),{textX:a,textY:i}},a.getDataLimits=function(){return{max:this.config.maxValue,min:this.config.minValue}},a.addData=function(e,t,a){var i,n=this.components,o=n.data,r=e.data.length;for(n.addDataArr=e.data,0===t?this.startPosition=!0:t+r!==o.length&&t!==d||(this.startPosition=!1),i=0;i<r;i++)t!==d?o.splice(t+i,0,{config:{}}):o.push({config:{}});this._setConfigure(e,t),a&&this.asyncDraw()},a.removeData=function(e,t,a){var i,n,o=e,r=t,l=this.getFromEnv("chart"),s=this.components,c=s.data,h=s.removeDataArr||(s.removeDataArr=[]);for(r===d&&(r=1),(o=o||0)+r!==c.length&&l.isRealTime?0!==o&&o!==d||(this.endPosition=!1):this.endPosition=!0,s.removeDataArr=h=h.concat(c.splice(o,r)),i=(n=h.length)-1;i>=0;i--)h[i]||h.splice(i,1);this.removeDataLen=n,a&&this.asyncDraw()},a.updateData=function(e,t,a){var i=this.config,n=i.maxValue,o=i.prevMin,r=this.getFromEnv("chart"),l=this.groupManager||this,s=r.getFromEnv("xAxis"),c=r.getFromEnv("yAxis");this._setConfigure(e,t),this.getDataLimits(),i.maxValue===n&&i.minValue===o||(this.maxminFlag=!0),a&&(r._setAxisLimits(),s&&s[0].asyncDraw(),c&&c[0].asyncDraw(),l.asyncDraw())},a.removePlots=function(){var e=this.components,t=e&&e.removeDataArr;P(t,this.__removeElem)},a.removeGraphicElem=function(e,t){this.__removeElem(e,t)},a.getAxisValuePadding=function(){return this.config.defaultPadding},a.getCanvasPadding=function(){var e,t,a,i,n,o,l=this.config||(this.config={}),s=this.components||{},c=this.getFromEnv("chart"),h=c.config.rotatevalues,u=this.getFromEnv("xAxis"),g=this.getFromEnv("yAxis"),p=c.config.dataLabelStyle,f=this.getSkippingInfo(),m=f.skippingApplied,b=f.draw,v=s.data||[],x=m?b[0]:0,y=m?b[b.length-1]:v.length-1,k=l.leftMostData||v[x],S=l.rightMostData||v[y],w={},A={},L=0,N=0,F=0,T=u.getPixel(0),E=this.getFromEnv("smartLabel"),P={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0},_=0,D=u.getValuePadding(),I=l.topMostData,M=l.bottomMostData;return this.setColumnPosition(),o={xPosOffset:this.getFromEnv("columnXShift"),columnWidth:this.getFromEnv("columnWidth"),height:d},k&&(i=(e=k.config).showValue,a=e&&e.anchorProps||{},i&&(t=e.displayValue,E.useEllipsesOnOverflow(c.config.useEllipsesWhenOverflow),E.setStyle(p),A=E.getOriSize(t),_=h?A.height:A.width),null!==e.setValue&&(n=u.getPixel(D.left),(F=(L=a.enabled&&(0,r.pluckNumber)(a.radius,0)+(0,r.pluckNumber)(a.borderThickness,0)/2||0)-(n-T))<0&&(F=0),(N=(_||0)/2-(n-T)-(o&&o.xPosOffset+o.columnWidth/2||0))<0&&(N=0)),P.paddingLeft=C(F,N)),F=N=0,S&&(i=(e=S.config).showValue,a=e&&e.anchorProps||{},i&&!h&&(t=e.displayValue,E.setStyle(p),w=E.getOriSize(t),_=h?w.height:w.width),null!==e.setValue&&(n=u.getPixel(D.right),(F=(L=a.enabled&&(0,r.pluckNumber)(a.radius,0)+(0,r.pluckNumber)(a.borderThickness,0)/2||0)-(n-T))<0&&(F=0),(N=(_||0)/2-(n-T)+(o&&o.xPosOffset+o.columnWidth/2||0))<0&&(N=0)),P.paddingRight=C(F,N)),I&&(i=(e=I.config).showValue,a=e&&e.anchorProps||{},null!==e.setValue&&(L=(0,r.pluckNumber)(a.radius,0)+(0,r.pluckNumber)(a.borderThickness,0)/2,N=Math.max(L-(g.getPixel(e.setValue.y)-g.getPixel(g.getLimit().max)),0)),P.paddingTop=N),M&&(a=(e=M.config)&&e.anchorProps||{},null!==e.setValue&&(L=(0,r.pluckNumber)(a.radius,0)+(0,r.pluckNumber)(a.borderThickness,0)/2,N=Math.max(L-(g.getPixel(g.getLimit().min)-g.getPixel(e.setValue.y)),0)),P.paddingBottom=N),P},a.getEventArgs=function(){var e=this.config||{};return{datasetName:(this.config.JSONData||{}).seriesname,datasetIndex:this.getJSONIndex(),id:e.userID,visible:!this.getState("visible")}},a.getData=function(){return this.components.data},a.setJSONIndex=function(e){this.config.index=e},a.getJSONIndex=function(){return this.config.index||0},a.remove=function(t){var a=this.config.legendItemId,i=this.getFromEnv("chart").getChildren("legend"),n=this.getFromEnv("legend");i&&i.length&&n&&a&&n.disposeItem(a),e.prototype.remove.call(this,t)},a.setMaxMin=function(e){var t,a,i,n=this.components,o=n.data,r=n.removeDataArr,l=this.config,s=o.length,c=-Infinity,h=+Infinity,u=l.maxValue,g=l.minValue,p=r.length,f=!1;if(e)f=u===e.startValue||g===e.startValue||u<e.config.setValue||g>e.config.setValue;else if(p)for(t=0;t<p;++t)if(u===(i=r[t]&&r[t].config&&r[t].config.setValue)||g===i){f=!0;break}if(f){for(t=0;t<s;t++)o[t]&&(a=o[t].config.setValue)!==d&&(c=C(c,a),h=y(h,a));l.maxValue=c,l.minValue=h}},t}(l.ComponentInterface);_.prototype._configureDataLabelStyle=r.configureDataLabelStyle;var D=_;t["default"]=D},539:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=a(224),n={"initial.dataset.column":function(){var e=this,t=e.getFromEnv("chart"),a=t.config.yDepth||0,n="y",o="height",r="x",l="width",s=e.getFromEnv("yAxis"),c=e.getFromEnv("xAxis"),h=function(i,c){var h,u,d,g,p=e.config,f=c&&c.graphics&&c.graphics.element,m=i.attr,b=s.getPixel(s.getAxisBase())+(t.isBar?-a:a),v={},x=p.oldZeroAxisPos;if(h=f.attr(),v[n]=u=h[n],v[o]=h[o],v[r]=h[r],v[l]=h[l],d=h[n]+h[o],b!==x&&(x-b>=0?(u>b&&u<=x+.7&&(v[n]=b,d>x&&(v[o]=d-v[n])),d>b&&d<=x+.7&&(v[o]=b-(v[n]||0===v[n]?v[n]:u))):(u<b&&u>=x-.7&&(v[n]=b,d>b&&(v[o]=d-v[n])),d<b&&d>=x-.7&&(v[o]=b-(v[n]||0===v[n]?v[n]:u))),g=!0),e.config.catDiff&&(v[r]=m[r],v[l]=m[l],g=!0),c._plot_1Start=v,g)return{finalAttr:v,slot:"axis"}};return{"rect.appearing":function(h){var u,d,g,p,f=s.getPixel(s.getAxisBase())+(t.isBar?-a:a),m=h.props&&h.props.originalIndex||h.index,b=e.components.data[m],v=h.attr;return c.config.isVertical&&(n="x",o="width",r="y",l="height"),u=v[n],d=v[o],p=Math.sign(u+d/2-f),g=1===p?u:u+d,b._posWRT0=p,[{initialAttr:function(){var e={};return e[n]=g,e.opacity=0,e[o]=0,e},finalAttr:{opacity:1},startEnd:function(){var t=h.length;return i.animHelperFN.getTimeByValue(i.animHelperFN.animByWeight(h.index,t,.6),{startPx:f,endPx:1===p?e.config.yAxisMaxPixel:e.config.yAxisMinPixel},{startPx:g,endPx:1===p?v[n]+v[o]:v[n]})},hookFn:function(){this.attr({opacity:1})},effect:"linear",slot:"plot"}]},"rect.updating":function(i){var u,d,g,p,f,m,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P,_,D,I,M,O,R,B,V=[],z=e.components.data[i.props&&i.props.originalIndex||i.index],G=i.attr,H=z&&z.graphics&&z.graphics.element,W=s.getPixel(s.getAxisBase())+(t.isBar?-a:a),j=0,U=e.getFromEnv("numColDiff");return c.config.isVertical&&(n="x",o="width",r="y",l="height"),(B=h(i,z))&&V.push(B),S=(k=z.prevDataObj)&&k._plot_1Start,T=k&&k._plot_1End,w=k&&k._plot_2Start,A=z.oldPrevDataObj,L=z.oldPrevDataObj&&z.oldPrevDataObj._plot_1End,g=(u=(v=z._plot_1Start)[n])+(d=v[o]),p=u+d/2,b=(f=G[n])+(m=G[o])/2,N=(g+(f+m))/2,E=Math.sign(p-W),P=Math.sign(b-W),(C={})[n]=(y={})[n]=(u+f)/2,C[o]=y[o]=(d+m)/2,d?E!==P?(C[o]=y[o]=0,y[n]=A&&A._oldPosWRT0===E?L[n]+(1===E?L[o]:0):W,C[n]=w?w[n]+(1===P?w[o]:0):W,F=x=!0):k!==A&&(D=(_=L||!(!T||Math.sign(T[n]+T[o]/2-W)!==E)&&T)?_[n]+(1===E?_[o]:0):W,1===E?(C[n]=y[n]=D,C[o]=y[o]=N-y[n]):C[o]=y[o]=D-y[n],x=!0):k&&k._oldPosWRT0===P||0===e.stackIndex?((O={})[o]=0,O[n]=S?S[n]+(k._posWRT0>0?S[o]:0):W,z._posWRT0=P,z._plot_1Start=O,C[n]=y[n]=(O[n]+f)/2,C[o]=y[o]=m/2):p===W&&(P!==z._posWRT0?j=.5:(x=!0,y[n]=1===P?W:W-y[o])),U<0?(y[r]=G[r],y[l]=G[l],x=!0):U>0?j=.5:v[r]===G[r]&&v[l]===G[l]||(.5===j?((O={})[r]=G[r],O[l]=G[l],I=function(){F&&H.attr(C),H.attr(O)}):(y[r]=G[r],y[l]=G[l],x=!0,I&&(M=function(){H.attr(O)},I=void 0))),x&&(V.push({finalAttr:y,startEnd:{start:0,end:.5},hookFn:M,slot:"plot"}),j=.5),!I&&(I=function(){F&&H.attr(C)}),V.push({effect:"linear",startEnd:{start:j,end:1},finalAttr:{x:G.x,y:G.y,width:G.width,height:G.height},callback:function(){null!==z.config.setValue&&void 0!==z.config.setValue||this.hide()},hookFn:I,slot:"plot"}),delete(R=Object.assign({},G)).x,delete R.y,delete R.width,delete R.height,V.push({finalAttr:R,effect:"linear",slot:"plot"}),z._plot_1End=y,z._plot_2Start=C,z._oldPosWRT0=z._posWRT0,z._posWRT0=P,V},"rect._disappearing":function(i){var r,l,c,u,d,g=s.getPixel(s.getAxisBase())+(t.isBar?-a:a),p=e.components.removeDataArr,f=p&&p[i.props&&i.props.originalIndex||i.index]||e.components.data[i.props&&i.props.originalIndex||i.index],m=f&&f.graphics&&f.graphics.element,b=f.oldPrevDataObj&&f.oldPrevDataObj._plot_1End,v=[];if(m)return(u=h(i,f))&&v.push(u),s.config.isVertical||(n="x",o="width"),r=(l=(d=f._plot_1Start)[n])+d[o]/2>g?b?b[n]+b[o]:l:b?b[n]:g,(c={})[n]=r,c[o]=0,c.width=f._width,c.x=f._xPos,v.push({startEnd:{start:0,end:e.getFromEnv("numOfColumns")<1?1:.5},finalAttr:c,slot:"plot"}),f._plot_1End=i.finalAttr,v},"plotLabel.appearing":[{initialAttr:{opacity:0},slot:"final"}],"plotLabel._disappearing":[{hookFn:function(){this.hide()},slot:"initial"}],"plotLabel.updating":[{hookFn:function(){this.hide()},slot:"initial"},{hookFn:function(){this.show()},initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"group.appearing":function(e){return"label-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]},"*":null}},"legendInteraction.dataset.column":function(){var e=function(e){return null==e},t=this,a=t.getFromEnv("chart"),i=a.config.yDepth||0,n=t.getFromEnv("yAxis"),o=t.getFromEnv("xAxis"),r="y",l="height",s="x",c="width";return{"rect.disappearing":function(h){var u,d,g,p,f,m,b,v=h.props&&h.props.originalIndex||h.index,x=t.components.data[v],y=t.getFromEnv("updatedIndex"),C=t.getFromEnv("stackIndex"),k=n.getFromEnv("prevScale");if(o.config.isVertical&&(r="x",l="width",s="y",c="height"),e(C)?d=t.getFromEnv("numOfColumns"):(g=t.getFromEnv("numOfColumns"),d=e(y)?g:t.getLinkedParent().getLinkedParent().getFromEnv("numOfColumns")),!e(C)&&g)b=0,m=n.getPixel(x.config._b)+(a.isBar?-i:i);else if(0===d)b=0,m=k.getRangeValue(n.getAxisBase())+(a.isBar?-i:i);else{p=o.getPixel(v)-t.getFromEnv("groupNetWidth")/2+y*(t.getFromEnv("plotWidth")+t.getFromEnv("plotPadding")+t.getFromEnv("plotPadding")/2),f=0}return[{finalAttr:(u={},u[c]=f,u[r]=m,u[l]=b,u[s]=p,u)}]},"rect.updating":function(h){var u,d,g,p,f,m,b=h.props&&h.props.originalIndex||h.index,v=t.components.data[b],x=t.getFromEnv("updatedIndex"),y=t.getFromEnv("stackIndex"),C=n.getFromEnv("prevScale"),k={};if(!t.config.appearing)return[{}];if(o.config.isVertical&&(r="x",l="width",s="y",c="height"),e(y)?u=t.getFromEnv("numOfColumns"):(d=t.getFromEnv("numOfColumns"),u=e(x)?d:t.getLinkedParent().getLinkedParent().getFromEnv("numOfColumns")),e(y)||e(d)||1===d)if(1===u)m=0,p=C.getRangeValue(n.getAxisBase())+(a.isBar?-i:i);else{g=o.getPixel(b)-t.getFromEnv("oldGroupNetWidth")/2+x*(t.getFromEnv("oldPlotWidth")+t.getFromEnv("oldPlotPadding")+t.getFromEnv("oldPlotPadding")/2),f=0}else m=0,p=C.getRangeValue(v.config._b)+(a.isBar?-i:i);return k[s]=e(g)?h.attr[s]:g,k[r]=e(p)?h.attr[r]:p,k[l]=e(m)?h.attr[l]:m,k[c]=e(f)?h.attr[c]:f,[{initialAttr:k}]},"plotLabel.updating":function(){return!t.config.appearing&&t.getState("visible")?[{}]:[{initialAttr:{opacity:0},finalAttr:{opacity:0}}]},"*":null}}};t["default"]=n},555:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(556)),r=a(224),l=a(232),s=i(a(558)),c=Math.abs;(0,l.addDep)({name:"lineAnimation",type:"animationRule",extension:s["default"]});var h=function(e){function t(){var t;return(t=e.call(this)||this).updateYForStack=r.stubFN,t.config.primitiveType="line",t}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"line"},a.createPinElem=function(){var e,t,a,i=this,n=i.getFromEnv("chart"),o=arguments[1].group,r=i.config.lineOb,l=i.getGraphicalElement("pinElems")||i.addGraphicalElement("pinElems",[]),s=i.getFromEnv("paper"),h=i.getLinkedParent().getChildContainer("lineVcanvasGroup");for(t=l.length-1;t>=0;t--)l[t].remove(),l.pop();if(i.getState("visible"))for(a in r)e=r[a].el,l.push(s.path(o).attr({path:e.attrs.path,transform:["T",-(n.config._visx+c(h.transform()[0][1])),-n.config.canvasBottom]}).attr(i.config.pin))},a._addLegend=function(){var e,t,a,i=this.getFromEnv("chart"),n=this.config,o=this.getFromEnv("chart-attrib"),l=i.getChildren("legend")[0],s=(0,r.pluckNumber)(n.drawanchors,1),c=this.config.JSONData||{};n.includeinlegend?(a={enabled:n.includeinlegend,type:this.getName(),drawLine:(0,r.pluck)(n.drawLine,!0),index:this.getJSONIndex(),anchorSide:s?n.anchorsides:0,label:(0,r.getFirstValue)(this.config.JSONData.seriesname),legendIconAlpha:(0,r.pluckNumber)(c.legendiconalpha)},(e=l.getItem(this.config.legendItemId))||(this.config.legendItemId=l.createItem(this),e=l.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){e.itemClickFn()}),e)),t={symbol:{fill:(0,r.toRaphaelColor)({color:n.anchorbgcolor,alpha:n.anchorbgalpha}),bgAlpha:(0,r.pluckNumber)(c.legendiconalpha,c.legendiconbgalpha,c.alpha),borderAlpha:(0,r.pluckNumber)(c.legendiconborderalpha,c.legendiconalpha,o.legendiconborderalpha,o.legendiconalpha,"100"),rawFillColor:n.anchorbgcolor,rawStrokeColor:n.anchorbordercolor,stroke:(0,r.toRaphaelColor)({color:n.anchorbordercolor,alpha:"100"}),"stroke-width":n.anchorborderthickness,lineWidth:n.linethickness}},e.setStateCosmetics("default",t),this.getState("visible")?e.removeLegendState("hidden"):e.setLegendState("hidden"),e.configure(a)):this.config.legendItemId&&l.disposeItem(this.config.legendItemId)},a._getDataLimits=function(){var e=this.config,t=this.getFromEnv("chart").config,a=e.maxValue,i=e.minValue,n=-Infinity,o=+Infinity,r=t.transposeAxis;return!1===this.getState("visible")&&r&&(a=n,i=o),{max:a,min:i}},a._drawCommonElementsHelper=function(e){var t,a,i,n=this,o=r.BLANKSTRING,l={},s=n.getFromEnv("animationManager"),c=n.config,h=c.shadow,u=c.linethickness,d=n.getContainer("commonElemsGroup"),g=function(){!1===n.getState("visible")&&this.hide()};for(o in e){for(t=["M0,0"],a=0,i=(l=e[o]).path&&l.path.length;a<i;++a)t=t.concat(l.path[a].getPathArr());n.config.drawLine?(l.el=s.setAnimation({el:l.el||"path",container:d,component:n,attr:!1!==n.getState("visible")&&Object.assign({path:t},l.attr),label:"line",callback:g}),n.getState("visible")&&l.el&&l.el.show()):l.el&&(l.el=s.setAnimation({el:l.el,component:n,doNotRemove:!0,callback:function(){this.hide()}})),!l.used&&delete e[o],l.el&&(u?l.el.shadow(h,d):l.el.shadow({opacity:0},d),l.el.toFront()),l.old=!0,l.used=!1,l.prevPath=l.path,l.attrs=void 0,l.path=void 0}},a.getLineShift=function(e){var t=this.getFromEnv("chart"),a=t.config.is3D,i=t.config.use3dlineshift;return"y"===e?a?i?0:-10:0:a?10:0},a.drawCommonElements=function(){var e,t,a,i,n,o,l,s,c,h,u=this.components.data,d=this.config,g=this.getFromEnv("xAxis"),p=this.getFromEnv("yAxis"),f=d.lineDashStyle,m=d.linethickness,b={color:d.linecolor,alpha:d.alpha},v=[(0,r.toRaphaelColor)(b),f].join(":"),x=v,y={x:g.getLimit(),y:p.getLimit()},C=u.length,k=this.config.lineOb||{},S=0,w=!1,A=this.getSkippingInfo&&this.getSkippingInfo(),L=A&&A.draw||[],N=L.length,F=A&&A.skippingApplied,T=function(e,t,a){var i=k[e];i||(i=k[e]={}),e!==x&&(i.hasDifferentColor=!0),i.used=!0,i.pathWithNull=a,i.path=i.path||[],i.stroke=e.split(":")[0],i.dashStyle=e.split(":")[1],i.path.push(t),i.dashStyle=i.dashStyle&&i.dashStyle.split(","),i.attr={"stroke-dasharray":i.dashStyle,"stroke-width":m,stroke:i.stroke,"stroke-linecap":"round","stroke-linejoin":m>2?"round":"miter"}},E=[];for(y.x.minPixel=g.getPixel(y.x.min),y.x.maxPixel=g.getPixel(y.x.max),y.y.minPixel=p.getPixel(y.y.min),y.y.maxPixel=p.getPixel(y.y.max),y.y.base=p.getPixel(0),y.x.base=g.getPixel(0),F&&(C=N),i=0;i<C;++i)(n=u[a=L[i]||i])&&((l=n.config||{})._Pbx=void 0,l._Pby=void 0,E[a]={config:{_Px:l._Px,_Py:l._Py,setValue:l.setValue}},t={color:l.setColor,alpha:l.setAlpha},e=l.dashStyle,v!==(o=[(0,r.toRaphaelColor)({color:(0,r.pluck)(t.color,b.color),alpha:(0,r.pluck)(t.alpha,b.alpha)}),e||f].join(":"))&&null!==n._yVal&&(w=!0,s=a,c=this.getLinePath(u,{begin:S,end:s+1}),h=this.getLinePath(u,{begin:S,end:s+1},void 0),l.connStartIndex=S,l.connEndIndex=s,T(v,c,h.getPathArr()),v=o,S=a,s=null),null!==n._yVal&&(v=o));o||(o=r.BLANKSTRING),d.pathStartIndex=S,d.pathEndIndex=s,T(o,c=this.getLinePath(u,{begin:w?S:d.scrollMinVal,end:w?s:d.scrollMaxVal}),(h=this.getLinePath(u,{begin:S,end:s},void 0)).getPathArr()),this._drawCommonElementsHelper(k),this.config.lineOb=k,d.prevLim=y,d.prevDataStore=E},a.show=function(){e.prototype.show.call(this),this.fireEvent("datasetVisibilityChanged",{dataset:this,state:"show"})},a.hide=function(){e.prototype.hide.call(this),this.fireEvent("datasetVisibilityChanged",{dataset:this,state:"hide"})},t}(o["default"]);t["default"]=h},556:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(242)),o=i(a(238)),r=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=d(t);if(a&&a.has(e))return a.get(e);var i={},n=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in e)if("default"!==o&&Object.prototype.hasOwnProperty.call(e,o)){var r=n?Object.getOwnPropertyDescriptor(e,o):null;r&&(r.get||r.set)?Object.defineProperty(i,o,r):i[o]=e[o]}i["default"]=e,a&&a.set(e,i);return i}(a(538)),l=a(224),s=a(236),c=a(232),h=i(a(557)),u=i(a(291));function d(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(d=function(e){return e?a:t})(e)}var g,p=!l.hasSVG,f="DataPlotRollOver",m="DataPlotRollOut",b="L",v="Z",x=l.hasTouch?l.TOUCH_THRESHOLD_PIXELS:l.CLICK_THRESHOLD_PIXELS,y=l.preDefStr.DEFAULT,C=l.preDefStr.setRolloverAttrStr,k=l.preDefStr.setRolloutAttrStr,S=function(e){void 0===e&&(e="full");var t=this.pathMap,a=this.path2Map,i=[],n=[],o=!0;switch(e){case"detailed":for(var r in t)if(t.hasOwnProperty(r)&&(i.push(t[r]),a[r].length)){var l=t[r],s=Object.assign([],a[r]);if(s[s.length-1]===v&&s.pop(),s.length){var c=Object.assign([],l[l.length-1]),h=Object.assign([],l[0]);c[0]="M",h[0]=b,s.unshift(c),s.push(h)}n.push(s)}return(i=i.flat()).length?{top:i,bottom:n.flat()}:{top:["M0,0"],bottom:["M0,0"]};case"top":o=!1;default:for(var u in t)t.hasOwnProperty(u)&&(i.push(t[u]),o&&i.push(a[u]));return(i=i.flat()).length?i:["M0,0"]}},w=function(e){return e!==g&&null!==e&&""!==e},A=Math,L=A.min,N=A.max,F=A.ceil,T=function(e,t){var a,i,n,o,r,s,c,h,u,d,g,f,m,b,v,x,y=e.getFromEnv("chart").config,S=t.config,w=t.graphics,A=w.image||w.element,F=S.eventArgs,T=A._.RefImg,E=t._xPos,P=t._yPos,_=S.anchorProps,D=e.getContainer("shadowGroup"),I=S.hoverEffects,M=S.setLink,O=_.imageScale,R=_.imageAlpha,B=I.imageHoverAlpha,V=I.imageHoverScale,z=T.height*O*.01,G=T.width*O*.01,H=T.width*V*.01,W=T.height*V*.01;b=_.isAnchorRadius,_.markerRadius=i=_.radius=b?_.radius:L(G,z)/2,p?(f={x:E-T.width*O*.005,y:P-T.height*O*.005,width:G,height:z},g={x:E-T.width*V*.005,y:P-T.height*V*.005,width:H,height:T.height*V*.01,alpha:B},S.isAnchorsDrawn=!0,y.dragTolerance=y.dragTolerance<z?z+.5:y.dragTolerance,A.data("alwaysInvisible",!O).data("setRolloverProperties",I).data("hoverEnabled",I).data(C,g).data(k,f).data("imgRef",T).data("anchorRadius",O).data("anchorHoverRadius",V),A.attr(f),f.alpha=R):(a=_.symbol[1],v=I.isAnchorHoverRadius,n=_.shadow,h=_.imagePadding,I.radius=v?I.anchorRadius:i+1,r=I.radius-h-.5*I.anchorBorderThickness,c=i-h-.5*_.borderThickness,g=f={},y.dragTolerance=y.dragTolerance<i?i+.5:y.dragTolerance,x={fill:(0,l.toRaphaelColor)({color:_.bgColor,alpha:_.bgAlpha}),"stroke-width":_.borderThickness,stroke:(0,l.toRaphaelColor)({color:_.borderColor,alpha:_.borderAlpha})},f=(0,l.extend2)({path:(0,l.polyPathToPath)([a||2,E,P,i,_.startAngle,void 0])},x),I&&(g={path:(0,l.polyPathToPath)([I.anchorSides||2,E,P,I.radius,I.startAngle,I.dip]),fill:(0,l.toRaphaelColor)({color:I.anchorColor,alpha:I.anchorBgAlpha}),"stroke-width":I.anchorBorderThickness,stroke:(0,l.toRaphaelColor)({color:I.anchorBorderColor,alpha:I.anchorBorderAlpha})},B>(d=N(I.anchorAlpha,I.anchorBorderAlpha))&&(B=d)),_.bgAlpha&&_.borderAlpha&&R>(u=N(_.bgAlpha,_.borderAlpha))&&(R=u),(m=w.element).attr(Object.assign(x,{path:f.path})),m.attr({cursor:M?"pointer":""}).data("alwaysInvisible",!i).data("setRolloverProperties",I).data("hoverEnabled",I.enabled).data(C,g).data(k,f).data("anchorRadius",i).data("anchorHoverRadius",I&&I.radius).data("eventArgs",F).shadow(n,D),s=(0,l.polyPathToPath)([a||2,E,P,c>0?c:0,_.startAngle,void 0]),o=(0,l.polyPathToPath)([a||2,E,P,r>0?r:0,I.startAngle,I.dip]),_.imgRefWidth=T.width,_.imgRefHeight=T.height,_.imgRefScale=O,_.rolloutClipRadius=c,f={x:E-T.width*O*.005,y:P-T.height*O*.005,width:G,height:z,"clip-path":s},g={x:E-T.width*V*.005,y:P-T.height*V*.005,width:H,height:W,alpha:B,"clip-path":o},A.attr({x:f.x,y:f.y,width:f.width,height:f.height,"clip-path":f["clip-path"]}).data("alwaysInvisible",!O).data("setRolloverProperties",I).data(C,g).data(k,f).data("anchorRadius",O).data("imgRef",T).data("anchorHoverRadius",V),S.isAnchorsDrawn=!0,i=N(i,I&&I.anchorRadius||0,2)),t._xPos=E,t._yPos=P,e.parseLabelAttributes(t,t._index)};(0,c.addDep)({name:"areaAnimation",type:"animationRule",extension:h["default"]});var E=function(e){function t(){var t;t=e.call(this)||this;var a=(0,n["default"])(t);return a.__removeElem=function(e,t){a._setRemoveAnim(e,"element"===t||"image"===t?"anchor":"label")},a.config.primitiveType="area",t}(0,o["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"area"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.valueposition=g,t.plotborderdashlen=g,t.plotborderdashgap=g,t.plotborderdashstyle=g,t.plotborderthickness=g,t.linethickness=g,t.linedashlen=g,t.linedashgap=g,t.dashed=g,t.linedashstyle=g,t.linecolor=g,t.linealpha=g,t.anchorbgcolor=g,t.anchorbordercolor=g,t.anchorradius=g,t.anchoralpha=g,t.anchorimageurl=g,t.anchorsides=g,t.anchorbgalpha=g,t.anchorborderthickness=g,t.anchorshadow=g,t.anchorstartangle=g,t.anchorimagealpha=g,t.anchorimagescale=g,t.anchorimagepadding=g,t.alpha=g,t.parentyaxis=g,t.inheritplotbordercolor=g},a._getHoveredPlot=function(e,t){var a,i,n,o,r,l,s=e,c=this.getFromEnv("xAxis"),h=this.components.data,u=h.length,d=this.config,g=this.getFromEnv("chartConfig").viewPortConfig.step||1,p=d&&d.radius||0,f=(this.getSkippingInfo&&this.getSkippingInfo()).plotsPerBin;for(s+=c.getTranslation(),i=Math.floor(Math.max(c.getValue(s-p),0)),n=Math.ceil(Math.min(c.getValue(s+p),u-1)),r+f-1,f>1&&(i=r=(F(i/f)-1)*f+1,n=F(n/f)*f),l=n;l>=i&&(!(a=h[l])||l%g||!(o=this.isWithinShape(a,l,s,t)));l--);return o},a.getClip=function(e){var t=this.getFromEnv("xAxis"),a=this.getFromEnv("yAxis"),i=a.getLimit(),n=t.getLimit(),o=t.getPixel(n.min),r=a.getPixel(i.min),l=a.getPixel(i.max),s=Math.abs(t.getPixel(n.max)-o),c=r-l,h=[];return h.push(o),h.push(c<0?r:l),"init"===e?h.push(0):"canvas"===e&&h.push(s),h.push(Math.abs(c)),h},a.isWithinShape=function(e,t,a,i,n){var o,r,s,c,h,u,d,g,p,f,m,b,v,y,C=n;if(e&&((C=e.config.setValue)||0===C))return o=e.config.anchorProps,r=e.config,c=o&&o.borderThickness,this,h=this.getFromEnv("chart").config.viewPortConfig,u=this.components.data,d=(0,l.pluckNumber)(r.dragTolerance,0),y=h?h.x*h.scaleX:0,g=e._xPos-y,null!==(p=e._yPos)?(v=e.config.hoverEffects,(s=Math.max(o&&o.radius,v&&v.anchorRadius||0,x)+c/2)||(s=3),f=a-g,m=i-p,((b=Math.sqrt(Math.pow(f,2)+Math.pow(m,2)))<=s||b<=d)&&{pointIndex:t,hovered:!0,pointObj:u[t]}):void 0},a._parseShadowOptions=function(){var e=this.getFromEnv("chart"),t=this.config,a=e.getFromEnv("dataSource").chart,i=this.getFromEnv("color-manager"),n=(0,l.pluckNumber)(e.defaultPlotShadow,i.getColor("showShadow"));return{opacity:(0,l.pluckNumber)(a.showshadow,n)?t.alpha/100:0}},a._firePlotEvent=function(e,t,a){var i,n,o,r=this.getFromEnv("chart"),l=this.components,s=this.getFromEnv("toolTipController"),c=l.data[t]||{},h=this.getGraphicalElement("sharedAnchor"),u=c.graphics&&c.graphics.element||(c.config&&c.config.setValue)!==g&&h,d=this.config.currentToolTip,p=r.getFromEnv("paper").canvas.style;if(u)switch(o=(i=c.config).setLink,n=i.eventArgs,e){case"fc-mouseover":this._decideTooltipType(t,a),this._rolloverResponseSetter(r,c,a),o&&(p.cursor="pointer");break;case"fc-mouseout":s.hide(d),this._rolloutResponseSetter(r,c,a),p.cursor=y;break;case"fc-click":r.plotEventHandler(u,a,"dataplotclick",n);break;case"fc-mousemove":this._decideTooltipType(t,a)}},a._rolloverResponseSetter=function(e,t,a,i){var n=t.graphics,o=n&&(n.element||this.getAnchor(t)),r=o&&o.data("draged"),l=o&&o.data("hoverEnabled");!0!==r&&(this._hoverFunc(t,f,l,e.getFromEnv("dataSource").chart),!i&&o&&e.plotEventHandler(o,a,f))},a._rolloutResponseSetter=function(e,t,a,i){var n=t.graphics,o=n&&(n.element||this.getAnchor(t)),r=o&&o.data("draged"),l=o&&o.data("hoverEnabled"),s=this.type,c=t.config,h=c.anchorProps,u=h.radius&&h.anchorAlpha;!0!==r&&(this._hoverFunc(t,m,l,e.getFromEnv("dataSource").chart),!i&&o&&e.plotEventHandler(o,a,m)),c.isAnchorsDrawn&&!u&&"area"===s&&o&&o.hide()},a.getAnchor=function(e){void 0===e&&(e={});var t,a,i,n,o,r,l,s,c,h=this.getFromEnv("animationManager"),u=this.getGraphicalElement("sharedAnchor"),d=e.config;return u?(t=d.anchorProps,a=d.eventArgs,(r=(o=d.hoverEffects).enabled)&&(i=o.attrs&&o.attrs.setRolloutAttr,n=o.attrs&&o.attrs.setRolloverAttr),l=t.radius,s=t.shadow,c=this.getFromEnv("chartConfig").prevAnchorHovered,o.anchorAnimation=0,e._index!==c&&(u.shadow(s,this.getContainer("shadowGroup")).data("anchorRadius",l).data("anchorHoverRadius",o.anchorRadius).data("hoverEnabled",r).data("eventArgs",a),r&&u.data(C,n).data(k,i)),this.getFromEnv("chartConfig").prevAnchorHovered=e._index,u):(u=h.setAnimation({el:"path",container:this.getContainer("plotGroup"),label:"anchor",doNotRemove:!0,component:this}),this.addGraphicalElement("sharedAnchor",u),u)},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e);var t=this.getFromEnv("chart");this.config.JSONData=e,this.parseAttributes(),this._setConfigure(),this._realTimeConfigure&&this._realTimeConfigure(),!1!==t.config.hasLegend&&t.config.showLegend&&this._addLegend(),this.setState("dirty",!0)},a.parseAttributes=function(){var e,t,a=this.getFromEnv("chart"),i=a.config,n=this.config,o=this.getName(),s=this.config.JSONData,c=a.getFromEnv("chart-attrib"),h=a.config.singleseries,u=this.getFromEnv("color-manager"),d=Math.floor(this.getJSONIndex()),p=(0,l.pluckNumber)(s.showplotborder,c.showplotborder||1),f=(0,l.getFirstColor)(!h||(0,l.getValidValue)(c.palettecolors)?u.getPlotColor(d):u.getColor("plotFillColor").split(/\s*\,\s*/)[0]),m=i.isdual,b=i.haslineset;n.showTextOutline=(0,l.pluckNumber)(c.textoutline,0),n.maxValue=-Infinity,n.minValue=Infinity,(0,l.parseConfiguration)(s,n,a.config,{data:!0}),n.inheritplotbordercolor=(0,l.pluckNumber)(s.inheritplotbordercolor,c.inheritplotbordercolor,0),n.showValues=(0,l.pluckNumber)(s.showvalues,c.showvalues,"radar"===o?0:1),n.anchorimageurl=(0,l.pluck)(s.anchorimageurl,c.anchorimageurl,g),n.plotColor=f,n.parentYAxis=m&&(b||"s"===(0,l.pluck)(s.parentyaxis&&s.parentyaxis.toLowerCase(),"p"))?1:0,n.valueposition=n.valueposition.toLowerCase(),n.plotfillcolor=(0,l.pluck)(s.color,c.plotfillcolor,f),n.seriesname=(0,l.parseUnsafeString)(s.seriesname),e=i.useplotgradientcolor,n.plotgradientcolor=0!==e?(0,l.getDefinedColor)(c.plotgradientcolor,u.getColor("plotGradientColor")):"",n.usePattern=(0,l.pluckNumber)(i.usePattern,0),n.patternType=r.PATTERN_TYPES.includes(s.patterntype)?s.patterntype:i.patternType,n.patternDensity=(0,l.pluckNumber)(s.patterndensity,i.patternDensity),n.patternAlpha=(0,l.pluckNumber)(s.patternalpha,i.patternAlpha),n.patternBgColor=(0,l.pluck)(s.patternbgcolor,i.patternBgColor,n.patternBgColor),n.patternAngle=(0,l.pluckNumber)(s.patternangle,c.patternangle,n.patternType===r.PATTERN_TYPES[0]?40:0),n.patternSize=(0,l.pluckNumber)(s.patternsize,c.patternsize,n.patternType===r.PATTERN_TYPES[0]?2:4),n.plotfillalpha=(0,l.pluckNumber)(s.alpha,i.plotfillalpha),n.fillColor={color:n.plotfillcolor+(n.plotgradientcolor?","+n.plotgradientcolor:""),alpha:n.plotfillalpha,angle:n.plotfillangle},n.plotborderalpha=p?(0,l.pluck)(s.plotborderalpha,c.plotborderalpha,s.alpha,n.inheritplotbordercolor?"100":c.plotfillalpha,"95"):0,n.plotbordercolor=(0,l.pluck)(s.plotbordercolor,c.plotbordercolor,c.areabordercolor,n.usePattern?n.plotfillcolor:n.inheritplotbordercolor?n.fillColor.color:h?(0,l.getValidValue)(c.palettecolors)?u.getPlotColor(0):u.getColor("plotBorderColor").split(/\s*\,\s*/)[0]:"666666"),n.plotborderColorObject={color:n.plotbordercolor,alpha:n.plotborderalpha,angle:n.plotfillangle},n.drawLine=(0,l.pluckNumber)(s.drawline,c.drawlines,1),n.plotborderdashstyle=n.dashed?(0,l.getDashStyle)(n.plotborderdashlen,n.plotborderdashgap):"none",n.linecolor=(0,l.pluck)(s.color,c.linecolor,n.plotColor),n.legendSymbolColor="line"===this.type?n.linecolor:n.plotfillcolor,n.includeinlegend=(0,l.pluckNumber)(s.includeinlegend,n.seriesname?1:0),t=(0,l.getDashStyle)(n.linedashlen,n.linedashgap),n.lineDashStyle=n.dashed?t:"none",n.defaultPadding={left:0,right:0},n.shadow=this._parseShadowOptions(),n.drawanchors=(0,l.pluckNumber)(s.drawanchors,s.showanchors,c.showanchors,c.drawanchors),n.anchorbgcolor=(0,l.getFirstColor)((0,l.pluck)("inherit"===s.anchorbgcolor?n.linecolor:s.anchorbgcolor,"inherit"===c.anchorbgcolor?n.linecolor:i.anchorbgcolor,u.getColor("anchorBgColor"))),n.anchorbordercolor=(0,l.getFirstColor)((0,l.pluck)("inherit"===s.anchorbordercolor?n.linecolor:s.anchorbordercolor,"inherit"===c.anchorbordercolor?n.linecolor:i.anchorbordercolor,n.linecolor,n.plotColor)),this.setState("visible",1===(0,l.pluckNumber)(s.visible,!Number(s.initiallyhidden),1)&&n.drawLine)},a._setConfigure=function(e,t){var a,i,n,o,r,c,h,u,d,p=this.getFromEnv("chart"),f=this.config,m=p.config,b=this.config.JSONData||[],v=this.getFromEnv("xAxis"),y=p.isRealTime,C=m.realTimeConfig&&m.realTimeConfig.numDisplaySets,k=this.getFromEnv("dataSource").categories&&this.getFromEnv("dataSource").categories[0]&&this.getFromEnv("dataSource").categories[0].category,S=f.initCatLen=y?k&&Array.isArray(k)&&k.filter((function(e){return!e.vline})).length||0:v.getTicksLen(),w=e||b.data,A=e&&e.data.length,L=m.isDrag,N=this.getSkippingInfo&&this.getSkippingInfo(),F=N&&N.draw||[],T=F.length,E=N&&N.skippingApplied;for(d=A===g&&S>C?S-C:0,n=y?(0,l.pluckNumber)(A,S):Math.min(S,w&&w.length),f.imageCount=0,(o=this.components.data)||(o=this.components.data=[]),f.maxRadius=-Infinity,m.dragTolerance=m.dragTolerance||-Infinity,E&&(n=T),c=d;c<n;c++)r=F[c]||c,e?(a=e&&e.data[r]||{},i=t!==g?o[u=t+r]:o[u=o.length-n+r],h=u):(a=w&&w[r]||{},i=o[r-=d],h=r),i||(i=o[h]={}),i.config||(i.config={}),i.graphics||(i.graphics={}),this._plotConfigure(h,a,A),u&&u++;E&&this.addJob("configureRestID",this._configureRestData.bind(this),s.priorityList.postRender),m.dragTolerance=L?(m.dragTolerance>5?m.dragTolerance:5.5)+x:0,this.ErrorValueConfigure&&this.ErrorValueConfigure()},a._configureRestData=function(){var e,t,a,i,n,o,r=this.getFromEnv("chart"),l=this.config,s=r.config,c=this.config.JSONData.data||[],h=(this.getSkippingInfo&&this.getSkippingInfo()).drawOnlyMap,u=this.getFromEnv("xAxis").getTicksLen();for(l.imageCount=0,(a=this.components.data)||(a=this.components.data=[]),l.maxRadius=-Infinity,s.dragTolerance=s.dragTolerance||-Infinity,l.maxValue=-Infinity,l.minValue=Infinity,i=0;i<u;i++)h[i]||(t=a[i],e=c&&c[i]||{},n=i,t||(t=a[i]={}),t.config||(a[i].config={}),t.graphics||(t.graphics={}),this._plotConfigure(n,e),o&&o++)},a._plotConfigure=function(e,t,a){var i,n,o,r,s,c,h,u,d,p,f=this.getFromEnv("chart"),m=f.config.singleseries,b=this.config,v=f.config,y=this.config.JSONData,C=f.getFromEnv("dataSource").chart,k=this.components.data[e],S=this.getFromEnv("xAxis"),w=this.getFromEnv("yAxis"),A=v.isDrag,F=k&&k.config,T=(0,l.parseUnsafeString)(v.yaxisname),E=(0,l.parseUnsafeString)(v.xaxisname),P=v.tooltipsepchar,_=b.dashed,D=v.realTimeConfig&&v.realTimeConfig.numDisplaySets,I=D-b.initCatLen,M=D&&I>=0?I:0;d=S.getLabel(a?e-a:M+e),F.label=(0,l.getValidValue)((0,l.parseUnsafeString)(d.tooltext||d.label)),t.tooltext!==g&&(t.tooltext=(0,l.parseTooltext)(t.tooltext,[3],{label:d.label},t,C,y)),F.id=m?t.id?(0,l.pluck)(t.id,F.id):(0,l.getValidValue)((0,l.parseUnsafeString)(d.label)):t.id?(0,l.pluck)(t.id,F.id):(0,l.getValidValue)((0,l.parseUnsafeString)(d.label))+"-"+(y.seriesname?y.seriesname:this.getJSONIndex()),F.dataLabelStyle=this._configureDataLabelStyle(t),F.setValue=o=w.getCleanValue(t.value,b.stack100percent),F.setLink=(0,l.pluck)(t.link),F.valuePadding=(0,l.pluckNumber)(t.valuepadding,y.valuepadding,v.valuepadding),F.dragTolerance=A?(p<6?5.5:p+.5)+x:0,F.label=(0,l.getValidValue)((0,l.parseUnsafeString)(d.tooltext||d.label)),F.showValue=(0,l.pluckNumber)(t.showvalue,b.showValues),F.givenPlotShowValue=(0,l.pluckNumber)(t.showvalue),F.dashed=(0,l.pluckNumber)(t.dashed,_),F.dashStyle=F.dashed?(0,l.getDashStyle)(b.linedashlen,b.linedashgap):"none",F.color=(0,l.pluck)(t.color,b.linecolor),F.setColor=t.color,F.setAlpha=t.alpha,F.setDashed=t.dashed,F.alpha=(0,l.pluck)(t.alpha,t.linealpha,b.alpha,b.linealpha),F.origLabel=(0,l.getValidValue)((0,l.parseUnsafeString)(d.label)),F.anchorProps=this._parseAnchorProperties(e),b.maxRadius=N(F.anchorProps.radius+F.anchorProps.borderThickness/2,b.maxRadius),p=F.anchorProps.radius+F.anchorProps.borderThickness/2,null!==o&&(b.maxValue=N(b.maxValue,o),b.minValue=L(b.minValue,o)),F.setTooltext=(0,l.parseUnsafeString)(t.toolText,!1),F.toolTipValue=n=w.dataLabels(o),F.setDisplayValue=r=(0,l.parseUnsafeString)(t.displayvalue),F.displayValue=(0,l.pluck)(r,n),F.formatedVal=h=F.toolTipValue,F.setTooltext=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(t.tooltext,y.plottooltext,C.plottooltext),!1)),F.valuePosition=(0,l.pluck)(t.valueposition,b.valueposition),F.valuePosition&&(F.valuePosition=F.valuePosition.toLowerCase()),v.showtooltip?null===h?i=!1:F.setTooltext!==g?(s=[1,2,3,4,5,6,7],c={yaxisName:T,xaxisName:E,formattedValue:h,label:F.label},i=(0,l.parseTooltext)(F.setTooltext,s,c,t,C,y)):(v.seriesnameintooltip&&(u=(0,l.getFirstValue)(y&&y.seriesname)),i=u?u+P:"",i+=F.label?F.label+P:"",i+=F.setTooltext?"":F.toolTipValue):i=!1,F.toolText=i,F.setTooltext=i,F.setLevelTooltext=F.setTooltext,F._x=t.index===g?e:t.index,F._y=o,F.finalTooltext=F.setTooltext=i,F.hoverEffects=this._parseHoverEffectOptions(k,t),F.anchorProps.isAnchorHoverRadius=F.hoverEffects.anchorRadius,v.dragTolerance=N(v.dragTolerance,b.maxRadius,F.hoverEffects.anchorRadius)},a.drawCommonElements=function(){var e,t,a,i,n,o,r,s,c,h,d,p,f,m=this,b=m.components.data,v=m.getFromEnv("chart"),x=m.config,y=v.config,C=m.getLinkedParent(),k=m.getJSONIndex(),S=C.config.firstDataSetIndex,w=m.getFromEnv("xAxis"),A=m.getFromEnv("yAxis"),L=x.scrollMinVal,N=x.scrollMaxVal,F=!y.drawfullareaborder,T=x.plotborderColorObject,E=x.plotborderdashstyle,P=x.plotborderthickness,_=x.fillColor,D=m.getFromEnv("animationManager"),I={x:w.getLimit(),y:A.getLimit()},M=[],O=0,R=0,B="",V=x.shadow,z=m.getContainer("shadowGroup"),G=w.getState("scrolling"),H=m.getSkippingInfo&&m.getSkippingInfo(),W=H&&H.draw||[],j=W.length,U=H&&H.skippingApplied;for(I.x.minPixel=w.getPixel(I.x.min),I.x.maxPixel=w.getPixel(I.x.max),I.y.minPixel=A.getPixel(I.y.min),I.y.maxPixel=A.getPixel(I.y.max),I.y.base=A.getPixel(0),I.x.base=w.getPixel(0),U&&(L=0,N=j),p=L;p<N;p++)b[d=W[p]||p]&&b[d].config&&(M[d]={config:{_Px:b[d].config._Px,_Pbx:b[d].config._Pbx,_Py:b[d].config._Py,_Pby:b[d].config._Pby,setValue:b[d].config.setValue}});if(f={begin:L,end:N},o={path:(a=this.getLinePath(b,G?f:null,!m.getState("visible")&&"base")).getPathArr(),stroke:"none",fill:(0,l.toRaphaelColor)(_)},t=m.getGraphicalElement("lineElement"),e=D.setAnimation({el:t||"path",container:m.getContainer("commonElemsGroup"),attr:m.getState("visible")&&o,component:m,doNotRemove:!0,label:"line",callback:function(){!m.getState("visible")&&this.hide()}}),"string"==typeof o.path?B=o.path:(0,u["default"])(o.path)&&"string"==typeof o.path[0]&&(B=o.path[0]),B){var q=B.split(",");O=parseFloat(q[0].split("M")[1],10),R=parseFloat(q[1],10)}else o.path.length&&(O=o.path[0][1],R=o.path[0][2]);if(e.addPattern({patternType:x.patternType,patternAngle:x.patternAngle,patternDensity:x.patternDensity,patternSize:x.patternSize,color:o.fill,patternAlpha:x.patternAlpha,patternBgColor:x.patternBgColor,alpha:x.plotfillalpha,x:O,y:R},x.usePattern),!t&&e&&m.addGraphicalElement("lineElement",e),m.getState("visible")&&e&&e.show(),m.getState("visible")&&!G&&e.shadow(V,z),r=m.getGraphicalElement("connector"),h=m.getGraphicalElement("bottomConnector"),m.getState("visible")&&r&&r.show(),F)i=a.getPathArr("top"),n="topBorderPath";else if(S===g||k===S)i=a.getPathArr(),n="line";else{var Y=a.getPathArr("detailed");i=Y.top,s=Y.bottom,n="topBorderPath",m.getState("visible")&&h&&h.show(),c=m.addGraphicalElement("bottomConnector",D.setAnimation({attr:{path:s,stroke:(0,l.toRaphaelColor)(T),"stroke-width":P,"stroke-linecap":"round","stroke-linejoin":P>2?"round":"miter","stroke-dasharray":E},el:h||"path",container:m.getContainer("commonElemsGroup"),component:m,label:"bottomPath",callback:function(){!m.getState("visible")&&this.hide()}}))}h&&!c&&m.removeGraphicalElement(h),r=m.addGraphicalElement("connector",D.setAnimation({attr:{path:i,stroke:(0,l.toRaphaelColor)(T),"stroke-width":P,"stroke-linecap":"round","stroke-linejoin":P>2?"round":"miter","stroke-dasharray":E},el:r||"path",container:m.getContainer("commonElemsGroupLine")||m.getContainer("commonElemsGroup"),component:m,label:n,callback:function(){!m.getState("visible")&&this.hide()}})),x.prevLim=I,x.prevDataStore=M,"realTimeUpdate"===v.state&&(m.realTimeUpdated=!0),y.connectnulldataOld=y.connectnulldata},a.addDatasetSpecificEvtArgs=function(e){var t=this.config,a=e.config,i=a.anchorProps,n=a.eventArgs,o=a.hoverEffects;Object.assign(n,{color:a.color,alpha:a.alpha,anchorBgColor:i.bgColor,anchorBgAlpha:i.anchorBgAlpha,anchorAlpha:i.anchorAlpha,anchorBorderColor:i.borderColor,anchorBorderThickness:i.borderThickness,anchorRadius:i.radius,anchorSides:i.sides,anchorStartAngle:i.startAngle,anchorHoverColor:o.anchorColor,anchorHoverAlpha:o.anchorAlpha,anchorHoverSides:o.anchorSides,dashed:a.dashed,valuePosition:a.valuePosition}),this.config.usePattern?(n.pattern={patternType:t.patternType,patternColor:t.plotfillcolor,patternBgColor:t.patternBgColor===l.TRACKER_FILL?g:t.patternBgColor},delete n.color):delete n.pattern},a.parsePlotAttributes=function(e,t){var a,i,n,o,r,s,c,h,u,d,g,p=this.getJSONIndex(),f=this.getState("visible"),m=this.config,b=this.config.JSONData,v=t,x={},y={},S={};h=(g=e.config)._Px,u=g._Py,a=g._x,i=g._y,o=g.setLink,n=g.setValue,x=g.anchorProps,d=g.displayValue,c=g.hoverEffects,s=g.finalTooltext=g.toolText,g.eventArgs={index:v,link:o,value:n,displayValue:d,categoryLabel:g.origLabel,toolText:s,id:g.id,datasetIndex:p||0,datasetName:b.seriesname,visible:f},this.addDatasetSpecificEvtArgs(e),r=x.symbol,e._xPos=h,e._yPos=u,e._xVal=a,e._yVal=i,e._index=v,null!==i&&null!==a?(g.eventArgs.x=a,g.eventArgs.y=i,c.enabled&&(S={path:(0,l.polyPathToPath)([c.anchorSides||2,h,u,c.anchorRadius,c.startAngle,c.dip?c.dip:+("spoke"===m.dip)]),fill:(0,l.toRaphaelColor)({color:c.anchorColor,alpha:c.anchorBgAlpha}),stroke:(0,l.toRaphaelColor)({color:c.anchorBorderColor,alpha:c.anchorBorderAlpha}),"stroke-width":c.anchorBorderThickness},y={path:(0,l.polyPathToPath)([r[1]||2,h,u,x.radius,x.startAngle,g.dip||0]),fill:(0,l.toRaphaelColor)({color:x.bgColor,alpha:x.bgAlpha}),stroke:(0,l.toRaphaelColor)({color:x.borderColor,alpha:x.borderAlpha}),"stroke-width":x.borderThickness},c.attrs={hoverEnabled:c.enabled,anchorRadius:x.radius,anchorHoverRadius:c.anchorRadius},c.attrs[C]=S,c.attrs[k]=y,x.isAnchorHoverRadius=c.attrs.anchorRadius),x.imageUrl&&(g.anchorImageLoaded=!1),g.props={element:{attr:{path:(0,l.polyPathToPath)([r[1]||2,h,u,x.radius,x.startAngle,g.dip||0]),fill:(0,l.toRaphaelColor)({color:x.bgColor,alpha:x.bgAlpha}),stroke:(0,l.toRaphaelColor)({color:x.borderColor,alpha:x.borderAlpha}),"stroke-width":x.borderThickness}}}):n&&(n.isNull=!0)},a.parseLabelAttributes=function(e,t){var a,i,n,o,r,l,s,c,h,u,d,p,f,m,b,v,x,y,C,k,S,A,L,N,F=this.getFromEnv("chart"),T=F.config,E=this.getFromEnv("smartLabel"),P=F.config.dataLabelStyle,_=this.components.data,D=T.stack100percent,I=T.rotatevalues?270:0,M=T.canvasTop,O=T.canvasHeight,R=F.config.isstacked,B=t;if(A=(m=e&&e.config)&&m.setValue,e!==g&&A!==g&&null!==A&&!0!==m.labelSkip){switch(u=m.anchorProps,v=e._yPos||e.config._Py,b=e._xPos||e.config._Px,S=u.markerRadius||u.radius-3,n=m.valuePadding+2+S,m.valuePosition){case"above":d=0;break;case"below":d=1;break;default:x=_[B-1]&&_[B-1].config||{},R&&D?(y=x.value,C=m.value):(y=x.setValue,C=m.setValue),d=B&&y>C?1:0}if(a=m.displayValue,k=m.showValue,i=m.dataLabelStyle,w(a)&&""!==a&&null!==C&&k){if(N={text:a,fill:i.color,"text-bound":[i.backgroundColor,i.borderColor,P.borderThickness,P.borderPadding,P.borderRadius,P.borderDash]},o=E.getOriSize(a),m._state=m._state||{},I?(m._state.labelWidth=o.height,m._state.labelHeight=o.width,m._rotated=!0):(m._state.labelWidth=o.width,m._state.labelHeight=o.height,m._rotated=!1),r=l=m._state.labelHeight,h=.5*l+n,p=v-M,f=M+O-v,s=v,c=b,L=(r+=n)+4,d?f>L?(s+=h,m._valueBelowPoint=1):p>L&&(s-=h,m._valueBelowPoint=0):p>L?(s-=h,m._valueBelowPoint=0):f>L&&(s+=h,m._valueBelowPoint=1),this.getFromEnv("useImprovedLabelPlacement")&&T.showSum&&!D){var V=r+2;s<M+V+r/2?s=M+V+r/2:s>M+O-V-r/2+h&&(s=M+O-V-r/2+h)}N.x=c,N.y=s}m.props=m.props||{},m.props.label={attr:N}}else m&&delete m.labelSkip},a.allocatePosition=function(){var e,t,a=this,i=a.config,n=a.getFromEnv("chart"),o=n.config,r=a.components,l=r.data,s=a.getFromEnv("xAxis"),c=0,h=0,u=o.isstacked,d=o.viewPortConfig.step||1,p=n.hasScroll,f=a.getSkippingInfo&&a.getSkippingInfo(),m=f&&f.labelDraw||[],b=f&&f.draw||[];for(t=r.animAttrs=[],a.calculateScrollRange(),s.getState("scrolling")||u&&a.updateYForStack(),a.createCoordinates(),h=i.scrollMinVal;h<i.scrollMaxVal;h+=d)c=b[h]||h,p&&!o.skipAttr&&(c<void 0||c>void 0)||((e=l[c])&&e.config?a.parsePlotAttributes(e,c):t[c]=g);for(d>1&&i.skipIgnorerIndices.map((function(e){return l[e]})).filter((function(e){return e||e.config})).forEach((function(e){return a.parsePlotAttributes(e,c)})),h=i.scrollMinValForLabel;h<i.scrollMaxValForLabel;h+=d)c=m[h]||h,e=l[c],a.parseLabelAttributes(e,c)},a.drawPlot=function(e,t){var a,i,n,o=this.config,r=e.config,l=e.graphics,s=r.anchorProps,c=this.getState("visible"),h=s.radius,u=s.shadow,d=s.anchorAlpha,p=h&&d,f=this.getContainer("plotGroup"),m=this.getContainer("shadowGroup"),b=this.getFromEnv("animationManager");null!==r._y&&null!==r._x?(s.imageUrl?this.drawAnchorImage(e):(a=l.element,(n=l.image)&&n.remove(),delete l.image,(o.drawanchors||p)&&c&&null!==e.config.setValue?(a=l.element=b.setAnimation({el:a||"path",container:f,attr:r.props.element.attr,index:t,length:length,callback:function(){this.show()},component:this,label:"anchor"})).shadow(u,m):a&&(this.__removeElem(l.element,"element"),delete l.element,a=g)),i=r.hoverEffects,a&&(i.enabled?a.data("hoverEnabled",i.attrs.hoverEnabled).data("anchorRadius",i.attrs.anchorRadius).data("anchorHoverRadius",i.attrs.anchorHoverRadius).data(C,i.attrs[C]).data(k,i.attrs[k]):a.data("hoverEnabled",!1),a.data("eventArgs",r&&r.eventArgs))):l.element&&(l.element=b.setAnimation({el:l.element,component:this}))},a.drawPlots=function(){var e,t,a,i=this,n=i.getFromEnv("chart").config,o=i.components,r=i.config,l=o.data,s=0,c=0,h=o.animAttrs,u=r._oldStartIndex,d=r._oldEndIndex,p=i.getGraphicalElement("sharedAnchor"),f=n.viewPortConfig.step||1,m=i.getSkippingInfo&&i.getSkippingInfo(),b=m&&m.draw||[];for(h=o.animAttrs=[],t=r.scrollMinVal,a=r.scrollMaxVal,t>u&&i.flushOnScroll(u,t>d?d:t),a<d&&i.flushOnScroll(a<u?u:a,d),r._oldStartIndex=t,r._oldEndIndex=a,i.hideAllAnchors&&i.hideAllAnchors(),c=t;c<a;c+=f)s=b[c]||c,(e=l[s])&&e.config?i.drawPlot(e,s):h[s]=g;f>1&&r.skipIgnorerIndices.map((function(e){return l[e]})).filter((function(e){return e||e.config})).forEach((function(e){return i.drawPlot(e,s)})),0===s||r.drawanchors?p&&p.hide():p?p.hide():i.getAnchor()},a.drawAnchorImage=function(e){var t,a=this.getContainer("plotGroup"),i=e.graphics,n=this.getFromEnv("animationManager"),o=p?i.element:i.image,r=e.config.anchorProps,l=r.anchorAlpha&&r.radius,s=r.imageAlpha;this.getState("visible")&&l?(p||(i.element=n.setAnimation({el:i.element||"path",container:a,attr:e.config.props.element.attr,label:"anchor",component:this}).show()),e.config.props.element.attr.opacity=.01*s,t=n.setAnimation({el:o||"image",container:a,component:this,label:"anchor",attr:{opacity:.01*s}}),p?i.element=t:i.image=t,o?t.attrs.src!==r.imageUrl?t.attr("src",r.imageUrl):t._.RefImg&&T(this,e):(t.on("load",this._onAnchorImageLoad(e)),t.attr("src",r.imageUrl)),t.show()):(i.image&&n.setAnimation({el:i.image,state:"disappearing",component:this,doNotRemove:!0,callback:function(){this.hide()}}),i.element&&n.setAnimation({el:i.element,state:"disappearing",component:this,doNotRemove:!0,callback:function(){this.hide()}}))},a.getLineSegment=function(e,t,a){var i=t._Px,n=t._Py,o=t._Pbx,r=t._Pby,l=this.getFromEnv("yAxis").getPixel(0),s=t.setValue,c="path-"+e.pathCount,h=this.getFromEnv("chart").config.connectnulldata;return"zero"===a?(n=l,r=l):"base"===a&&(n=t._Pby),e.pathMap[c]||(e.pathMap[c]=[]),e.path2Map[c]||(e.path2Map[c]=[]),null===s||s.isNull?h||(e.pointsJoined>0&&e.path2Map[c][e.path2Map[c].length-1]!==v&&r!==g&&e.path2Map[c].push(v),e.temp=[],e.temp2=[],e.lastValidValue=!1):e.lastValidValue?(e.temp.length&&(e.pathMap[c]=e.pathMap[c].concat(e.temp),o!==g&&(e.path2Map[c]=e.temp2,e.temp2=[]),e.temp=[],e.pointsJoined++),e.pathMap[c].push([b,i,n]),r!==g&&e.path2Map[c].unshift([b,i,r])):(e.temp.push(["M",i,n]),r!==g&&e.temp2.push([b,o,r]),e.pointsJoined=0,e.lastValidValue=!0,e.pathCount++),e},a.getLinePath=function(e,t,a){var i,n,o,r,l,s,c,h,u,d=this,p=d.getFromEnv("chart").config,f=e.length,m=t&&t.begin||0,b=d.getState("visible")?t&&t.end||f:0,x=p.viewPortConfig.step||1,y=(d.removeDataLen,[]),C=d.getSkippingInfo&&d.getSkippingInfo(),k=C&&C.draw||[],w=k.length,A=C&&C.skippingApplied,L=d.config.skipIgnorerIndices,N=[],F={},T=0;for(0,y=y.concat(e),A&&(m=0,b=w),n=m+0;n<b+0;n+=x)if(l=y[i=k[n]||n])if((o=l.config).setValue===g||o&&!0===o.isSkipped)o&&delete o.isSkipped;else{if(x>1)for(;L[T]<n;)(c=y[L[T]])&&((h=c.config).setValue===g||h&&!0===h.isSkipped?h&&delete h.isSkipped:(N=N.concat(h),T++));N=N.concat(o),r=o._Pby,s=n}if(x>1)for(i=s+1;i<=n;i++)(l=y[k[i]||i])&&((o=l.config).setValue===g||o&&!0===o.isSkipped?o&&delete o.isSkipped:L.includes(i)&&(N=N.concat(o),r=o._Pby));return u="path-"+(F=N.reduce((function(e,t){return d.getLineSegment(e,t,a)}),{temp:[],temp2:[],pathMap:{},path2Map:{},pointsJoined:0,lastValidValue:!1,getPathArr:S,pathCount:0})).pathCount,F.path2Map[u]&&F.path2Map[u][F.path2Map[u].length-1]!==v&&F.pointsJoined>0&&r!==g&&F.path2Map[u].push(v),F},a._removeDataVisuals=function(e){var t,a,i,n,o=this.components.pool||(this.components.pool={});if(e)for(a in i=e.graphics)t=o[a]||(o[a]=[]),(n=i[a])&&n.hide&&"function"==typeof n.hide&&(n.attr({"text-bound":[]}),n.hide(),n.shadow&&n.shadow(!1)),t.push(i[a])},a._parseAnchorProperties=function(e,t){var a,i,n,o=this.config,r=this.getName(),s=this.getFromEnv("chart"),c=s.config.anchoralpha,h=this.components.data[e],u=h&&h.config,d=!s.config.anchoralpha&&/area/gi.test(r)?0:1,p=o.JSONData,f=s.getFromEnv("dataSource").chart,m=(t||p.data||[])[e]||{},b={};return i=(0,l.pluck)(m.anchorstartangle,p.anchorstartangle,f.anchorstartangle,m.anchorimagealpha,p.anchorimagealpha,f.anchorimagealpha,m.anchorimagescale,p.anchorimagescale,f.anchorimagescale,m.anchorimagepadding,p.anchorimagepadding,f.anchorimagepadding,m.anchorimageurl,p.anchorimageurl,f.anchorimageurl,m.anchorradius,p.anchorradius,f.anchorradius,m.anchorbgcolor,p.anchorbgcolor,f.anchorbgcolor,m.anchorbordercolor,p.anchorbordercolor,f.anchorbordercolor,m.anchoralpha,p.anchoralpha,f.anchoralpha,m.anchorsides,p.anchorsides,f.anchorsides,m.anchorborderthickness,p.anchorborderthickness,f.anchorborderthickness,g)!==g,n=(0,l.pluckNumber)(m.drawanchors,o.drawanchors),b.enabled=i?(0,l.pluckNumber)(n,i):(0,l.pluckNumber)(n,d),b.startAngle=(0,l.pluckNumber)(m.anchorstartangle,o.anchorstartangle),b.imageAlpha=(0,l.pluckNumber)("inherit"===m.anchorimagealpha?u.alpha:m.anchorimagealpha,"inherit"===p.anchorimagealpha?u.alpha:p.anchorimagealpha,"inherit"===f.anchorimagealpha?u.alpha:f.anchorimagealpha,o.anchorimagealpha),b.imageScale=(0,l.pluckNumber)(m.anchorimagescale,o.anchorimagescale),b.imagePadding=(0,l.pluckNumber)(m.anchorimagepadding,o.anchorimagepadding),b.imagePadding<0&&(b.imagePadding=0),b.imageUrl=(0,l.pluck)(m.anchorimageurl,o.anchorimageurl),b.imageUrl&&o.imageCount++,b.radius=b.enabled?(0,l.pluckNumber)(m.anchorradius,o.anchorradius):0,b.isAnchorRadius=(0,l.pluck)(m.anchorradius,p.anchorradius,f.anchorradius),b.bgColor=(0,l.pluck)("inherit"===m.anchorbgcolor?u.color:m.anchorbgcolor,"inherit"===p.anchorbgcolor?u.color:p.anchorbgcolor,"inherit"===f.anchorbgcolor?u.color:o.anchorbgcolor),c=b.enabled?(0,l.getFirstAlpha)((0,l.pluck)("inherit"===m.anchoralpha?u.alpha:m.anchoralpha,"inherit"===p.anchoralpha?u.alpha:p.anchoralpha,"inherit"===f.anchoralpha?u.alpha:f.anchoralpha,o.anchoralpha,b.enabled?l.HUNDREDSTRING:"0")):0,b.anchorAlpha=c,b.anchorBgAlpha=(0,l.pluckNumber)("inherit"===m.anchorbgalpha?u.alpha:m.anchorbgalpha,"inherit"===p.anchorbgalpha?u.alpha:p.anchorbgalpha,"inherit"===f.anchorbgalpha?u.alpha:f.anchorbgalpha,o.anchorbgalpha,c),b.bgAlpha=(0,l.getFirstAlpha)(b.anchorBgAlpha)*c/100,b.imageAlpha=b.imageAlpha*c/100,b.borderColor=(0,l.pluck)("inherit"===m.anchorbordercolor?u.color:m.anchorbordercolor,"inherit"===p.anchorbordercolor?u.color:p.anchorbordercolor,"inherit"===f.anchorbordercolor?u.color:o.anchorbordercolor),b.borderAlpha=c,b.sides=(0,l.pluck)(m.anchorsides,o.anchorsides),b.borderThickness=(0,l.pluck)(m.anchorborderthickness,o.anchorborderthickness),b.symbol=(0,l.mapSymbolName)(b.sides).split("_"),a=(0,l.pluckNumber)(m.anchorshadow,o.anchorshadow)&&b.radius>=1,b.shadow={opacity:a?c/100:0},b},a._hideGraphics=function(e){var t,a;for(a in e)if(e.hasOwnProperty(a)){if(!(t=e[a]))continue;t.hide?t.hide():this._hideGraphics(t)}},a._parseHoverEffectOptions=function(e,t){var a=t,i=this.config.JSONData,n=this.getFromEnv("chart"),o=n.getFromEnv("dataSource").chart,r=n.config,s=e.config,c=this.config,h=s.anchorProps||{},u=r.plothovereffect,d=c.drawanchors,p={enabled:!1};return a=a||{},0!==u&&0!==d&&(p.enabled=(0,l.pluck)(a.hovercolor,a.anchorhovercolor,a.hovercolor,i.hovercolor,a.anchorbghovercolor,i.anchorbghovercolor,o.anchorbghovercolor,i.anchorhovercolor,o.anchorhovercolor,a.hoveralpha,a.anchorhoveralpha,i.anchorhoveralpha,o.anchorhoveralpha,a.bghoveralpha,a.anchorbghoveralpha,i.anchorbghoveralpha,o.anchorbghoveralpha,a.anchorborderhovercolor,a.borderhovercolor,i.anchorborderhovercolor,o.anchorborderhovercolor,a.anchorborderhoverthickness,a.borderhoverthickness,i.anchorborderhoverthickness,o.anchorborderhoverthickness,a.anchorborderhoveralpha,a.borderhoveralpha,i.anchorborderhoveralpha,o.anchorborderhoveralpha,a.hoverdip,a.anchorhoverdip,i.anchorhoverdip,o.anchorhoverdip,a.anchorhoverstartangle,i.anchorhoverstartangle,o.anchorhoverstartangle,a.hoversides,a.anchorhoversides,i.anchorhoversides,o.anchorhoversides,a.hoverradius,a.anchorhoverradius,i.anchorhoverradius,o.anchorhoverradius,i.plotfillhovercolor,o.plotfillhovercolor,r.plothovereffect,g)!==g,p.startAngle=(0,l.pluckNumber)(a.anchorhoverstartangle,i.anchorhoverstartangle,o.anchorhoverstartangle,h.startAngle),p.hoverColor=(0,l.pluck)(a.hovercolor,a.anchorhovercolor,i.hovercolor,a.anchorbghovercolor,i.anchorbghovercolor,o.anchorbghovercolor,i.anchorhovercolor,o.anchorhovercolor,o.plotfillhovercolor),p.hoverAlpha=(0,l.pluck)(a.hoveralpha,a.anchorhoveralpha,i.anchorhoveralpha,o.anchorhoveralpha,a.bghoveralpha,a.anchorbghoveralpha,i.anchorbghoveralpha,o.anchorbghoveralpha,i.hoveralpha,o.plotfillhoveralpha),p.anchorSides=(0,l.pluckNumber)(a.hoversides,a.anchorhoversides,i.anchorhoversides,o.anchorhoversides,h.sides),p.anchorRadius=(0,l.pluckNumber)(a.anchorhoverradius,i.anchorhoverradius,o.anchorhoverradius),p.isAnchorHoverRadius=p.anchorRadius,p.anchorRadius=(0,l.pluckNumber)(p.anchorRadius,h.radius+(u?2:0)),p.anchorScale=(0,l.pluck)(a.hoverscale,i.anchorscale,o.anchorscale),p.imageHoverScale=(0,l.pluckNumber)(a.anchorimagehoverScale,i.anchorimagehoverscale,o.anchorimagehoverscale,110),p.imageHoverAlpha=(0,l.pluckNumber)(a.anchorimagehoveralpha,i.anchorimaghoverealpha,o.anchorimagehoveralpha),p.anchorAlpha=(0,l.pluck)(a.anchorhoveralpha,a.hoveralpha,i.anchorhoveralpha,o.anchorhoveralpha,h.anchorAlpha),p.anchorColor=(0,l.getFirstColor)((0,l.pluck)(a.hovercolor,a.anchorhovercolor,a.hoverColor,a.anchorbghovercolor,i.anchorbghovercolor,i.anchorhovercolor,i.hovercolor,o.anchorbghovercolor,o.anchorhovercolor,o.plotfillhovercolor,h.bgColor)),p.anchorBgAlpha=(0,l.pluck)(a.bghoveralpha,a.anchorbghoveralpha,i.anchorbghoveralpha,o.anchorbghoveralpha,o.plotfillhoveralpha,h.bgAlpha),p.anchorBgAlpha=p.anchorBgAlpha*p.anchorAlpha/100,p.anchorBorderColor=(0,l.pluck)(a.borderhovercolor,a.anchorborderhovercolor,i.anchorborderhovercolor,o.anchorborderhovercolor,h.borderColor),p.anchorBorderAlpha=(0,l.pluck)(a.borderhoveralpha,a.anchorborderhoveralpha,i.anchorborderhoveralpha,o.anchorborderhoveralpha,p.anchorAlpha,h.borderAlpha),p.anchorBorderThickness=(0,l.pluckNumber)(a.borderhoverthickness,a.anchorborderhoverthickness,i.anchorborderhoverthickness,o.anchorborderhoverthickness,o.anchorBorderThickness,h.borderThickness),p.dip=(0,l.pluck)(a.hoverdip,a.anchorhoverdip,i.anchorhoverdip,o.anchorhoverdip,h.dip),p.anchorAnimation=(0,l.pluckNumber)(a.anchorhoveranimation,i.anchorhoveranimation,o.anchorhoveranimation,1)),p},a._hoverPlotAnchor=function(e,t){var a,i,n,o,r,l=this.getFromEnv("smartLabel"),s=this.getFromEnv("chart").getChildren("canvas")[0].getEffectiveDimensions(),c=s.top,h=c+s.height,u=e.config._Py,d=this.getFromEnv("animationManager"),g=this.getGraphicalElement("sharedAnchor"),b=e.graphics.element||g,v=e.graphics.label,x=e.config||{},y=x.anchorProps.anchorAlpha,S=x&&x.anchorProps.imageUrl,w=p&&S?e.graphics.element:e.graphics.image,A="image"===b.type,L=b.data("anchorRadius"),N=b.data("anchorHoverRadius"),F=b.data(C)||{},T=b.data(k)||{},E=v&&(v.data("isBelow")?1:-1)*(A?.5*(F.height-T.height):N-L),P=t===f?F:T,_=!0,D={path:P.path},I={fill:P.fill,"stroke-width":P["stroke-width"],stroke:P.stroke},M=v&&v.data("rotation")||"";u-3*(a=l.getOriSize(x.displayValue).height)/2+E<c?E=c-u+3*a/2:u+3*a/2+E>h&&(E=h-u-3*a/2),r={transform:"T0,"+(t===f?E:0)+M},d.setAnimationState(t===f?"mouseOver":"mouseOut"),w&&(n=w.data(C),o=w.data(k),(i=t===f?n:o).alpha*=.01),A?D.alpha*=.01:Object.assign(D,I),(t===f&&!N||t===m&&!L)&&(_=!1),d.setAnimation({el:b,label:"anchor",component:this,doNotRemove:!0,callback:function(){!_&&b.hide()},attr:_&&D}),_&&b.show(),w&&(d.setAnimation({el:w,label:"anchor",component:this,attr:_&&i}),_&&w.show()),(e.graphics&&e.graphics.element||g&&g.element)&&y&&v&&d.setAnimation({el:v,label:"label",component:this,doNotRemove:!0,attr:r})},a.drawLabel=function(e,t){var a,i,n,o,r,s,c,h,u,d,p,f,m=this.config,b=this.getFromEnv("chart"),v=b.config,x=this.getFromEnv("smartLabel"),y=b.config.dataLabelStyle,C=this.getFromEnv("toolTipController"),k=this.components.data,S=this.getFromEnv("paper"),A=this.getFromEnv("animationManager"),L="",N=v.rotatevalues?270:0,F=this.getContainer("labelGroup"),T=this.getState("visible"),E=k.length,P=this.getSkippingInfo&&this.getSkippingInfo(),_=P&&P.skippingApplied,D=P&&P.labelDraw||[],I=D.length,M=(0,l.pluckNumber)(e,0),O=(0,l.pluckNumber)(t,_?I:E),R=I===Math.abs(O-(M+1));for(c={"font-weight":y.fontWeight,"font-style":y.fontStyle,"font-family":y.fontFamily,"font-size":y.fontSize,"line-height":y.lineHeight},x.setStyle(c),u=M;u<O;u++)d=(o=(h=k[_&&R?D[u]:u])&&h.config)&&o.setValue,h!==g&&d!==g&&null!==d&&!0!==o.labelSkip?(a=h.graphics,L=o.displayValue,r=o.showValue,s=a.label,p=o.props.label.attr,w(L)&&r&&T?(n=o.props.label.attr.x,i=o.props.label.attr.y,p.transform=S.getSuggestiveRotation(N,n,i),a.label=s=A.setAnimation({el:s||"text",container:F,component:this,attr:p,label:"label"}),s.data("isBelow",o._valueBelowPoint),s.data("rotation",p.transform),s&&s.outlineText(m.showTextOutline,p.fill),v.showtooltip&&s.abbrArr&&s.abbrArr.length&&C.enableToolTip(s,g)):s&&(a.label=A.setAnimation({el:s,component:this,label:"label"}))):(o&&delete o.labelSkip,(f=h&&h.graphics)&&f.label&&(f.label=A.setAnimation({el:f.label,component:this})))},a.getAxisValuePadding=function(){return this.config.defaultPadding},a._hoverFunc=function(e,t,a,i){if(a)return this._hoverPlotAnchor(e,t,i)},a._onAnchorImageLoad=function(e){var t=this;return function(){var a=e._index;T(t,e),t.config.drawn?t.drawLabel(a,a+1):t.addJob("labelUpdateOnImageLoadID"+a,(function(){t.drawLabel(a,a+1)}),s.priorityList.label)}},t}(r["default"]);t["default"]=E},557:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(e){var t=e.component,a=t.components.data,i=t.getFromEnv("chartConfig").isstacked,n=t.getLinePath(a).getPathArr("detailed").bottom,o=t.getState("_total"),r=t.config._childIndex;if(n.length&&Array.isArray(n[0])){var l=n.length;n[0]=Object.assign([],n[1]),n[0][0]="M",n[l-1]=Object.assign([],n[l-2])}return[{initialAttr:{opacity:0,path:n},finalAttr:{opacity:1,path:e.attr.path},startEnd:{start:i?.5/o*r:0,end:i?.5/o*(r+1):.5},slot:"plot",hookFn:function(){this.attr({opacity:1})}}]},n=function(e){var t=e.component,a=t.components.data,i=t.getFromEnv("chartConfig").isstacked,n=t.getFromEnv("chartConfig").is3D,o=t.getLinePath(a,null,i||n?"base":"zero").getPathArr("top"),r=e.attr,l=t.getState("_total"),s=t.config._childIndex;return[{initialAttr:{opacity:0,path:o},finalAttr:{opacity:1,path:r.path},startEnd:{start:i?.5/l*s:0,end:i?.5/l*(s+1):.5},slot:"plot",hookFn:function(){this.attr({opacity:1})}}]},o=function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},r=function(e){return"label-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:"plot-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]},l=function(e){var t=e.component,a=t.components.data,i=t.getFromEnv("chartConfig").isstacked,n=t.getFromEnv("chartConfig").is3D,o=t.getLinePath(a,null,i||n?"base":"zero"),r=e.attr,l=t.getState("_total"),s=t.config._childIndex;return[{initialAttr:{opacity:0,path:o.getPathArr()},finalAttr:{opacity:1,path:r.path},startEnd:{start:i?.5/l*s:0,end:i?.5/l*(s+1):.5},slot:"plot",hookFn:function(){this.attr({opacity:1})}}]},s={"*.dataset.area":function(){return{"anchor.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}],"anchor.updating":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"anchor.disappearing":[{finalAttr:{opacity:0,"fill-opacity":0,"stroke-opacity":0},slot:"final"}],"line.appearing":l,"topBorderPath.appearing":n,"bottomPath.appearing":i,"label.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"label.updating":o,"group.appearing":r,"*":null}}};t["default"]=s},558:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"*.dataset.line":function(){var e=this.getClip("canvas"),t=this.getClip("init");return{"anchor.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},"anchor.updating":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}]},"anchor.disappearing":function(){return[{finalAttr:{opacity:0,"fill-opacity":0,"stroke-opacity":0},slot:"plot"}]},"line.appearing":function(){return[{initialAttr:{"clip-rect":t},finalAttr:{"clip-rect":e},slot:"middle",callback:function(){this.attr({"clip-rect":null})}}]},"line.updating":function(){return[{initialAttr:{opacity:1,"clip-rect":t},finalAttr:{opacity:1,"clip-rect":e},slot:"plot"}]},"label.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"group.appearing":function(e){return"label-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:"plot-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]},"*":null}}}},564:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.__feedAxesRawData=c,t.__spaceManager=h,t.__postSpaceManagement=u,t["default"]=void 0;var n=i(a(238)),o=i(a(565)),r=i(a(538)),l=a(224),s=i(a(366));function c(){var e,t,a=this.config,i=this.getFromEnv("color-manager"),n=this.getFromEnv("dataSource"),o=n.chart,r=this.config.is3D,c=r?l.chartPaletteStr.chart3D:l.chartPaletteStr.chart2D,h=(0,l.pluckFontSizeMaintainUnit)(o.outcnvbasefontsize,o.basefontsize,10);return e={isVertical:!0,isReverse:!1,isOpposit:(0,s["default"])(o.xaxisposition,"right"),outCanfontFamily:(0,l.pluck)(o.outcnvbasefont,o.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(h),outCanfontSizeWithUnit:h,outCancolor:(0,l.pluck)(o.outcnvbasefontcolor,o.basefontcolor,i.getColor(c.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:o.xaxisnamepadding,maxLabelWidthPercent:o.maxlabelwidthpercent,minLabelWidthPercent:o.minlabelwidthpercent,axisValuePadding:o.labelpadding,axisNameFont:o.xaxisnamefont,axisNameFontSize:this.computeFontSize(o.xaxisnamefontsize),axisNameFontSizeWithUnit:o.xaxisnamefontsize,axisNameFontColor:o.xaxisnamefontcolor,axisNameFontBold:o.xaxisnamefontbold,axisNameFontItalic:o.xaxisnamefontitalic,axisNameBgColor:o.xaxisnamebgcolor,axisNameBorderColor:o.xaxisnamebordercolor,axisNameAlpha:o.xaxisnamealpha,axisNameFontAlpha:o.xaxisnamefontalpha,axisNameBgAlpha:o.xaxisnamebgalpha,axisNameBorderAlpha:o.xaxisnameborderalpha,axisNameBorderPadding:o.xaxisnameborderpadding,axisNameBorderRadius:o.xaxisnameborderradius,axisNameBorderThickness:o.xaxisnameborderthickness,axisNameBorderDashed:o.xaxisnameborderdashed,axisNameBorderDashLen:o.xaxisnameborderdashlen,axisNameBorderDashGap:o.xaxisnameborderdashgap,axisNameWidth:o.xaxisnamewidth,useEllipsesWhenOverflow:o.useellipseswhenoverflow,divLineColor:(0,l.pluck)(o.vdivlinecolor,o.divlinecolor,i.getColor(c.divLineColor)),divLineAlpha:(0,l.pluck)(o.vdivlinealpha,o.divlinealpha,r?i.getColor("divLineAlpha3D"):i.getColor("divLineAlpha")),divLineThickness:(0,l.pluckNumber)(o.vdivlinethickness,o.divlinethickness,1),divLineIsDashed:Boolean((0,l.pluckNumber)(o.vdivlinedashed,o.vdivlineisdashed,o.divlinedashed,o.divlineisdashed,0)),divLineDashLen:(0,l.pluckNumber)(o.vdivlinedashlen,o.divlinedashlen,4),divLineDashGap:(0,l.pluckNumber)(o.vdivlinedashgap,o.divlinedashgap,2),showAlternateGridColor:0,alternateGridColor:(0,l.pluck)(o.alternatehgridcolor,i.getColor("altHGridColor")),alternateGridAlpha:(0,l.pluck)(o.alternatehgridalpha,i.getColor("altHGridAlpha")),numDivLines:o.numvdivlines,labelFont:o.labelfont,labelFontSize:this.computeFontSize(o.labelfontsize),labelFontSizeWithUnit:o.labelfontsize,labelFontColor:o.labelfontcolor,labelAlpha:o.labelalpha,labelFontBold:o.labelfontbold,labelFontItalic:o.labelfontitalic,labelBdrColor:o.labelbordercolor,labelBdrAlpha:o.labelborderalpha,labelLink:o.labellink,labelBgColor:o.labelbgcolor,labelBgAlpha:o.labelbgalpha,labelBdrThickness:o.labelborderthickness,labelBdrPadding:o.labelborderpadding,labelBdrRadius:o.labelborderradius,labelBdrDashed:o.labelborderdashed,labelBdrDashLen:o.labelborderdashlen,labelBdrDashGap:o.labelborderdashgap,axisName:o.xaxisname,axisMinValue:o.xaxisminvalue,axisMaxValue:o.xaxismaxvalue,setAdaptiveMin:o.setadaptivexmin,adjustDiv:o.adjustvdiv,labelDisplay:o.labeldisplay,showLabels:o.showlabels,rotateLabels:o.rotatelabels,slantLabel:(0,l.pluckNumber)(o.slantlabels,o.slantlabel),labelStep:(0,l.pluckNumber)(o.labelstep,o.xaxisvaluesstep),showAxisValues:(0,l.pluckNumber)(o.showxaxisvalues,o.showxaxisvalue),showLimits:o.showvlimits,showDivLineValues:(0,l.pluckNumber)(o.showvdivlinevalues,o.showvdivlinevalues),zeroPlaneColor:o.vzeroplanecolor,zeroPlaneThickness:(0,l.pluckNumber)(o.vzeroplanethickness,o.vdivlinethickness,2),zeroPlaneAlpha:(0,l.pluckNumber)(o.vzeroplanealpha,o.vdivlinealpha,a.zeroplanealpha),showZeroPlaneValue:o.showvzeroplanevalue,trendlineColor:o.trendlinecolor,trendlineToolText:o.trendlinetooltext,trendlineThickness:o.trendlinethickness,rotateAxisName:(0,l.pluckNumber)(o.rotatexaxisname,1),trendlineAlpha:o.trendlinealpha,showTrendlinesOnTop:o.showtrendlinesontop,showAxisLine:r?0:(0,l.pluckNumber)(o.showxaxisline,o.showaxislines,o.drawAxisLines,0),axisLineThickness:(0,l.pluckNumber)(o.xaxislinethickness,o.axislinethickness,1),axisLineAlpha:(0,l.pluckNumber)(o.xaxislinealpha,o.axislinealpha,100),axisLineColor:(0,l.pluck)(o.xaxislinecolor,o.axislinecolor,"#000000")},(t={isVertical:!1,isReverse:!1,isOpposit:(0,s["default"])(o.yaxisposition,"top"),outCanfontFamily:(0,l.pluck)(o.outcnvbasefont,o.basefont,"Verdana,sans"),outCanfontSize:h,outCanfontSizeWithUnit:h,outCancolor:(0,l.pluck)(o.outcnvbasefontcolor,o.basefontcolor,i.getColor(c.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:o.yaxisnamepadding,axisValuePadding:o.yaxisvaluespadding,axisNameFont:o.yaxisnamefont,axisNameFontSize:this.computeFontSize(o.yaxisnamefontsize),axisNameFontSizeWithUnit:o.yaxisnamefontsize,axisNameFontColor:o.yaxisnamefontcolor,axisNameFontBold:o.yaxisnamefontbold,axisNameFontItalic:o.yaxisnamefontitalic,axisNameBgColor:o.yaxisnamebgcolor,axisNameBorderColor:o.yaxisnamebordercolor,axisNameAlpha:o.yaxisnamealpha,axisNameFontAlpha:o.yaxisnamefontalpha,axisNameBgAlpha:o.yaxisnamebgalpha,axisNameBorderAlpha:o.yaxisnameborderalpha,axisNameBorderPadding:o.yaxisnameborderpadding,axisNameBorderRadius:o.yaxisnameborderradius,axisNameBorderThickness:o.yaxisnameborderthickness,axisNameBorderDashed:o.yaxisnameborderdashed,axisNameBorderDashLen:o.yaxisnameborderdashlen,axisNameBorderDashGap:o.yaxisnameborderdashgap,axisNameWidth:o.yaxisnamewidth,useEllipsesWhenOverflow:o.useellipseswhenoverflow,axisName:o.yaxisname,divLineColor:(0,l.pluck)(o.divlinecolor,i.getColor(c.divLineColor)),divLineAlpha:(0,l.pluck)(o.divlinealpha,r?i.getColor("divLineAlpha3D"):i.getColor("divLineAlpha")),divLineThickness:(0,l.pluckNumber)(o.divlinethickness,1),divLineIsDashed:Boolean((0,l.pluckNumber)(o.divlinedashed,o.divlineisdashed,0)),divLineDashLen:(0,l.pluckNumber)(o.divlinedashlen,4),divLineDashGap:(0,l.pluckNumber)(o.divlinedashgap,2),showAlternateGridColor:(0,l.pluckNumber)(o.showalternatevgridcolor,1),alternateGridColor:(0,l.pluck)(o.alternatevgridcolor,i.getColor("altVGridColor")),alternateGridAlpha:(0,l.pluck)(o.alternatevgridalpha,i.getColor("altVGridAlpha")),numDivLines:o.numdivlines,axisMinValue:o.yaxisminvalue,axisMaxValue:o.yaxismaxvalue,setAdaptiveMin:o.setadaptiveymin,adjustDiv:o.adjustdiv,labelStep:o.yaxisvaluesstep,showAxisValues:(0,l.pluckNumber)(o.showyaxisvalues,o.showyaxisvalue),showLimits:(0,l.pluckNumber)(o.showyaxislimits,o.showlimits,this.showLimits),showDivLineValues:(0,l.pluckNumber)(o.showdivlinevalues,o.showdivlinevalue),zeroPlaneColor:o.zeroplanecolor,zeroPlaneThickness:(0,l.pluckNumber)(o.zeroplanethickness,o.divlinethickness,2),zeroPlaneAlpha:(0,l.pluckNumber)(o.zeroplanealpha,o.divlinealpha,a.zeroplanealpha),showZeroPlaneValue:o.showzeroplanevalue,trendlineColor:o.trendlinecolor,trendlineToolText:o.trendlinetooltext,trendlineThickness:o.trendlinethickness,trendlineAlpha:o.trendlinealpha,isTrendZone:0,showTrendlinesOnTop:o.showtrendlinesontop,showAxisLine:r?0:(0,l.pluckNumber)(o.showyaxisline,o.showaxislines,o.drawAxisLines,0),axisLineThickness:(0,l.pluckNumber)(o.yaxislinethickness,o.axislinethickness,1),axisLineAlpha:(0,l.pluckNumber)(o.yaxislinealpha,o.axislinealpha,100),axisLineColor:(0,l.pluck)(o.yaxislinecolor,o.axislinecolor,"#000000"),numberFormatterFn:"yAxis",showZeroPlaneOnTop:a.showzeroplaneontop,forceTrendBelow:!!a.is3D,labelFont:o.yaxisvaluefont,labelFontSize:this.computeFontSize(o.yaxisvaluefontsize),labelFontSizeWithUnit:o.yaxisvaluefontsize,labelFontColor:o.yaxisvaluefontcolor,labelAlpha:o.yaxisvaluealpha,labelFontBold:o.yaxisvaluefontbold,labelFontItalic:o.yaxisvaluefontitalic,labelBdrColor:o.yaxisvaluebordercolor,labelBdrAlpha:o.yaxisvalueborderalpha,labelBgAlpha:o.yaxisvaluebgalpha,labelLink:o.yaxisvaluelink,labelBgColor:o.yaxisvaluebgcolor,labelBdrThickness:o.yaxisvalueborderthickness,labelBdrPadding:o.yaxisvalueborderpadding,labelBdrRadius:o.yaxisvalueborderradius,labelBdrDashed:o.yaxisvalueborderdashed,labelBdrDashLen:o.yaxisvalueborderdashlen,labelBdrDashGap:o.yaxisvalueborderdashgap}).vtrendlines=n.trendlines,e.trendlines=n.vtrendlines,a.isstacked&&(t.isPercent=(0,l.pluckNumber)(a.stack100percent,0),t.isPercent&&delete t.numberFormatterFn),{xAxisConf:[e],yAxisConf:[t]}}function h(){var e,t,a,i,n,o,r,s,c,h,u,d,g,p,f,m,b,v,x,y=this.config,C=this.getChildren(),k=C.yAxis&&C.yAxis[0],S=C.xAxis&&C.xAxis||[],w=l.preDefStr.POSITION_BOTTOM,A=l.preDefStr.POSITION_TOP,L=y.legendposition?y.legendposition.split("-"):[],N=y.xDepth,F=y.yDepth,T=C.canvas[0],E=y.canvasBgDepth,P=y.canvasBaseDepth,_=y.canvasBasePadding,D=C.canvas[0].config.canvasBorderWidth,I=y.realTimeConfig&&y.realTimeConfig.showRTValue,M=y.borderWidth,O=y.canvasMarginTop,R=y.canvasMarginBottom,B=y.canvasMarginLeft,V=y.canvasMarginRight,z=y.minCanvasHeight,G=y.minCanvasWidth,H=y.minChartWidth,W=y.minChartHeight,j=y.height,U=y.width,q=!1,Y=!1,X=y.origCanvasTopMargin,K=y.origCanvasBottomMargin,Z=y.origCanvasLeftMargin,J=y.origCanvasRightMargin;y.canvasWidth-2*M<H&&(d=(y.canvasWidth-H)/2),y.canvasHeight-2*M<W&&(u=(y.canvasHeight-W)/2),this._allocateSpace({top:u||M,bottom:u||M,left:d||M,right:d||M}),a=S[0],this._resetViewPortConfig&&this._resetViewPortConfig(),this._setAxisScale&&this._setAxisScale(),e=.7*y.availableWidth,this._calculateChartShift("yAxis"),y.yAxisSpaceAllocation=b=a&&a.placeAxis(e),a&&this._allocateSpace(b),f=.225*y.availableHeight,p=this._manageActionBarSpace&&this._manageActionBarSpace(f)||{},this._allocateSpace(p),this._manageLegendSpace&&this._manageLegendSpace(),t=L[0]===w||L[0]===A?.6*y.availableHeight:.6*y.availableWidth,F&&(this._allocateSpace({left:F}),y.shift=N+_+P),E&&this._allocateSpace({top:E}),y.canvasWidth-2*D<G&&(m=(y.canvasWidth-G)/2),this._allocateSpace({left:m||D,right:m||D}),G>U-B-V&&(Y=!0,i=y.canvasWidth-G,x=B+V,B=y.canvasMarginLeft=i*B/x,V=y.canvasMarginRight=i*V/x),r=B>y.canvasLeft?B-y.canvasLeft:0,s=V>U-y.canvasRight?V+y.canvasRight-U:0,this._allocateSpace({left:r,right:s}),this._allocateSpace({left:P}),Y&&(x=Z+J,(h=y.canvasWidth)>G&&(r=(i=h-G)*Z/x,s=i*J/x),this._allocateSpace({left:r,right:s})),y.actualCanvasMarginRight=s,y.actualCanvasMarginBottom=o,this._manageChartMenuBar(t),t=.2*y.availableHeight,y.sumValueSpace=this._getSumValueSpace(t),this._allocateSpace(y.sumValueSpace),t=.3*y.availableHeight,y.realtimeEnabled&&(I?this._allocateSpace(this._realTimeValuePositioning(t)):this._hideRealTimeValue()),t=.6*y.availableHeight,this._calculateChartShift("xAxis"),y.xAxisSpaceAllocation=v=k&&k.placeAxis(t),k&&this._allocateSpace(v),t=.3*y.availableHeight,this._manageScrollbarPosition&&this._manageScrollbarPosition(t),y.canvasHeight-2*D<z&&(g=(y.canvasHeight-z)/2),this._allocateSpace({top:g||D,bottom:g||D}),z>j-O-R&&(q=!0,i=y.canvasHeight-z,x=O+R,O=y.canvasMarginTop=i*O/x,R=y.canvasMarginBottom=i*R/x),n=O>y.canvasTop?O-y.canvasTop:0,o=R>j-y.canvasBottom?R+y.canvasBottom-j:0,this._allocateSpace({top:n,bottom:o}),q&&(x=X+K,(c=y.canvasHeight)>z&&(n=(i=c-z)*X/x,o=i*K/x),this._allocateSpace({top:n,bottom:o})),y.actualCanvasMarginTop=n,y.actualCanvasMarginLeft=r,T.setDimension({top:y.canvasTop,left:y.canvasLeft,width:y.canvasWidth,height:y.canvasHeight})}function u(){var e,t,a,i,n=this.config,o=this.getChildren(),r=o.xAxis&&o.xAxis[0],l=o.yAxis&&o.yAxis[0],s=o.scrollBar&&o.scrollBar[0]&&o.scrollBar[0].config,c=o.legend&&o.legend[0],h=n.xDepth||0,u=o.canvas[0].config,d=u.canvasBorderWidth,g=u.canvasPadding,p=u.canvasTop,f=u.canvasLeft,m=p-d,b=p+u.canvasHeight+d,v=f-(n.shift||0)-d,x=f+u.canvasWidth+d+n.sumValueSpace.right;l&&this._allocateXAxisLabelSpace(l),e=u.canvasPaddingLeft,t=u.canvasPaddingRight,a=u.canvasPaddingTop,i=u.canvasPaddingBottom,l&&l.setAxisDimention({x:u.canvasLeft+e,y:l.config.isOpposit?m:b,opposite:l.config.isOpposit?b:m,axisLength:u.canvasWidth-e-t}),r&&r.setAxisDimention({x:(r.config.isOpposit?x:v)+(this.isScrollEnabled()&&s.isOpposite&&n.shift||0),y:p+h+Math.max(a,g),opposite:r.config.isOpposit?v:x,axisLength:u.canvasHeight-h-Math.max(a,g)-Math.max(i,g)}),c&&c.postSpaceManager(),this.allocateDimensionOfChartMenuBar()}var d=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getName=function(){return"MSBarCartesian"},t.getName=function(){return"MSBarCartesian"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.enablemousetracking=!0},a._feedAxesRawData=function(){return c.call(this)},a._spaceManager=function(){h.call(this)},a._postSpaceManagement=function(){u.call(this)},a.getDSdef=function(){return r["default"]},a.getDSGroupdef=function(){},t}(o["default"]);t["default"]=d},565:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(463)),r=a(566),l=i(a(567)),s=i(a(568)),c=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("dataset",l["default"],["vCanvas"]),t.registerFactory("legend",s["default"]),t}(0,n["default"])(t,e),t.getName=function(){return"MSCartesian"};var a=t.prototype;return a.getName=function(){return"MSCartesian"},a.getType=function(){return"chartAPI"},a._manageLegendSpace=function(){r._manageLegendSpace.call(this)},a.manageGradientLegendSpace=function(e){return r.manageGradientLegendSpace.call(this,e)},t}(o["default"]);t["default"]=c},566:function(e,t,a){"use strict";t.__esModule=!0,t._manageLegendSpace=function(){var e,t,a,n,o=this.config,r=this.getChildren("legend")&&this.getChildren("legend")[0],l=this.getChildren("gLegend")&&this.getChildren("gLegend")[0],s=this.getFromEnv("dataSource").colorrange,c=o.hasLegend,h={},u=this.hasGradientLegend,d=this.getFromEnv("dataSource").chart,g=(0,i.pluckNumber)(d.mapbycategory,0);u&&s&&(0,i.pluckNumber)(s.gradient)&&!g?(e=l.conf,u=!0,o.gLegendEnabled=!0,t=e.legendPosition?e.legendPosition.split("-"):[],n=t[0]===i.POSITION_RIGHT||t[0]===i.POSITION_LEFT?.4:.5):(e=r&&r.config,u=!1,o.gLegendEnabled=!1,t=e&&e.legendPos?e.legendPos.split("-"):[i.POSITION_BOTTOM],n=t[0]===i.POSITION_RIGHT||t[0]===i.POSITION_LEFT?.8:.4);a=t[0]===i.POSITION_ABSOLUTE?.4*o.availableHeight:t[0]===i.POSITION_RIGHT||t[0]===i.POSITION_LEFT?o.availableWidth*n:o.availableHeight*n;u?h=this.manageGradientLegendSpace(a):!1!==c&&r&&!r.getState("removed")&&(h=r&&r._manageLegendPosition(a));h&&this._allocateSpace(h)},t.manageGradientLegendSpace=function(e){var t,a,n,o=this.config,r=this.getFromEnv("gLegend"),l=r&&r.conf,s={top:0,bottom:0,left:0,right:0};o.gLegendPadding=(0,i.pluckNumber)(this.getFromEnv("chart-attrib").legendpadding,10),a=Math.min(o.gLegendPadding,.5*e),l&&(t=l.legendPosition?l.legendPosition.split("-"):[],n=r.getLogicalSpace(e),t[0]===i.POSITION_BOTTOM?s.bottom=(n.height||0)+a:t[0]===i.POSITION_TOP?s.top=(n.height||0)+a:t[0]===i.POSITION_LEFT?s.left=(n.width||0)+a:t[0]!==i.POSITION_ABSOLUTE&&(s.right=(n.width||0)+a));return s};var i=a(224)},567:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a,n,o,r=e.getFromEnv("dataSource").dataset,l=e.getChildren().canvas[0],s=t=l.getChildren("vCanvas")[0],c=e.config.defaultDatasetType||"";if(!r)return void e.setChartMessage();(n=e.getDSGroupdef())&&((0,i.componentFactory)(t,n,"datasetGroup_"+c,1,[r]),o=t.getChildren("datasetGroup_"+c));o&&(s=o[0]),a=e.getDSdef(),(0,i.datasetFactory)(s,a,"dataset",r.length,r)};var i=a(224)},568:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t;(0,n.componentFactory)(e,o["default"],"legend"),(t=e.getChildren("legend")[0]).configure(),e.addToEnv("legend",t),e.config.showLegend||t.remove()};var n=a(224),o=i(a(569))},569:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(223)),o=i(a(242)),r=i(a(238)),l=a(224),s=a(240),c=i(a(570)),h=a(232),u=a(363),d=i(a(572)),g=a(236),p=a(573);function f(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function m(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?f(Object(a),!0).forEach((function(t){(0,n["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):f(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var b,v={left:l.POSITION_START,right:l.POSITION_END,center:l.POSITION_MIDDLE},x=Math,y=x.min,C=x.max,k=x.floor,S=x.ceil,w=l.preDefStr.NORMAL,A={fontWeight:{1:l.preDefStr.BOLD,0:w},fontStyle:{1:"italic",0:w},textDecoration:{1:"underline",0:l.preDefStr.noneStr}};(0,h.addDep)({name:"legendAnimation",type:"animationRule",extension:d["default"]});var L=function(e){return Array(e).fill()},N=function(e){function t(){var t;t=e.call(this)||this;var a=(0,o["default"])(t);return a._stateCosmetics={},a._legendState=[],a.dragDraw=function(){a.draw()},a.drawScroll=function(){a.createItemGroup(),a.createCaptionGroup()},a.config.handlers=function(e){var t,a;return{dragstart:function(){t=e.config.xL||e.config.xPos,a=e.config.yL||e.config.yPos},dragmove:function(i){var n,o,r=i.originalEvent.data[0],l=i.originalEvent.data[1],s=e.config,c=e.getFromEnv("chartConfig"),h=(s.borderWidth||0)+2;n=y(C(t+r,h),c.width-s.width-h),o=y(C(a+l,h),c.height-s.height-h),s.xPos=s.xL=n,s.yPos=s.yL=o,e.addJob("draw",e.dragDraw,g.priorityList&&g.priorityList.draw)}}}(a),t}(0,r["default"])(t,e);var a=t.prototype;return a.createItem=function(e){var t;return t=new c["default"],this.attachChild(t,"legendItem"),t.setLinkedItem("owner",e),t.addEventListener("mouseover",(function(){t.setLegendState("hover",!0)})),t.addEventListener("mouseout",(function(){t.removeLegendState("hover")})),t.getId()},a.getItem=function(e){var t=this.getChildren().legendItem;if(void 0===e)return!1;if(t)for(var a=0;a<t.length;a++)if(t[a].getId()===e)return t[a]},a.getSortedLegendItems=function(){var e,t,a=this.getChildren("legendItem")||[],i=this.config.reverselegend,n={},o=[];for(e=0,t=a.length;e<t;e++)void 0===a[e].config.index?n[t+e]=a[e]:n[a[e].config.index]=a[e];return Object.keys(n).sort((function(e,t){return i?t-e:e-t})).forEach((function(e){o.push(n[e])})),o},a.disposeItem=function(e){var t=this.getItem(e);t&&t.remove()},a.getName=function(){return"legend"},a.getType=function(){return"legend"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.enabled=!0,t.symbolWidth=12,t.borderRadius=1,t.lastScrollPos=0,t.oriSymbolPadding=3,t.textPadding=4,t.scrollY=0,t.scrollX=0,t.backgroundColor="#ffffff",t.initialItemX=0,t.title={text:l.BLANKSTRING,x:0,y:0,padding:2},t.scroll={},t.horizontalScroll={},t.itemStyle={}},a.createLegendGroup=function(){var e,t=this.config,a=this.getFromEnv("chart"),i=a.config,n=this.getFromEnv("animationManager"),o=.5*(t.borderWidth||0)+2,r=this.getContainer("legendGroup");t.xL&&(t.xL=y(C(t.xL,o),i.width-t.width-o)),t.yL&&(t.yL=y(C(t.yL,o),i.height-t.height-o)),e=n.setAnimation({el:r||"group",attr:{name:"legendGroup",transform:["T",t.xL||t.xPos,t.yL||t.yPos]},container:a.getChildContainer("legendGroup"),component:this}),r||this.addContainer("legendGroup",e)},a.drawDualScrollRect=function(){var e=this.getGraphicalElement("dualScrollRect"),t=this.getGraphicalElement("scrollbarContainer"),a=this.getFromEnv("animationManager");this.config.scroll.enabled&&this.config.horizontalScroll.enabled?(e=a.setAnimation({el:e||"rect",attr:{x:this.config.width-12,y:this.config.height-12,height:12,width:12,fill:this.config.legendScrollBgColor,stroke:"none"},component:this,container:t}),e=this.addGraphicalElement("dualScrollRect",e)):e&&e.remove()},a.draw=function(){this.createLegendGroup(),this.drawLegendBox(),this.createItemGroup(),this.createCaptionGroup(),this.drawCaption(),this.createScrollGroup(),this.decideScroll(),this.drawDualScrollRect()},a.decideScroll=function(){var e=this.config,t=e.scroll.enabled,a=e.horizontalScroll.enabled;t?this.createScrollBar():e.hasScroll&&(this.getChildren("legendScrollBar")[0].remove(),e.hasScroll=!1),a?this.createScrollBar(a):e.hasHorizontalScroll&&(this.getChildren("legendHorizontalScrollBar")[0].remove(),e.hasHorizontalScroll=!1)},a.createCaptionGroup=function(){var e,t=this.getChildContainer("captionGroup"),a=this.getFromEnv("animationManager"),i=this.getContainer("legendGroup"),n=(0,l.pluckNumber)(this.config.padding,4),o=.5*n,r=C(this.config.height-n,0),s=C(this.config.width-n,0),c=","+(this.config.horizontalScroll.enabled?s:this.config.width)+","+(this.config.scroll.enabled?r:this.config.height);this.config.horizontalScroll.enabled?(e=this.addChildContainer("captionGroup",a.setAnimation({el:t&&null!==t[0]?t:"group",attr:{name:"captionGroup",transform:["T",0,this.config.scrollY||0]},container:i,component:this})),this.config.scroll.enabled?e.attr({"clip-rect":"0,"+o+c}):e.attr({"clip-rect":null})):t&&t.remove()},a.createItemGroup=function(){var e,t=this.getFromEnv("animationManager"),a=this.getContainer("legendGroup"),i=this.getChildContainer("itemGroup"),n=(0,l.pluckNumber)(this.config.padding,4),o=.5*n,r=C(this.config.height-n,0),s=C(this.config.width-n,0),c=","+(this.config.horizontalScroll.enabled?s:this.config.width)+","+(this.config.scroll.enabled?r:this.config.height);return e=t.setAnimation({el:i||"group",attr:{name:"item",transform:["T",this.config.scrollX||0,this.config.scrollY||0]},container:a,component:this}),i||this.addChildContainer("itemGroup",e),this.config.scroll.enabled||this.config.horizontalScroll.enabled?e.attr({"clip-rect":"0,"+o+c}):e.attr({"clip-rect":null}),e},a.createScrollGroup=function(){var e=this.getFromEnv("animationManager"),t=this.getChildContainer("scrollGroup"),a=this.getContainer("legendGroup");!this.config.scroll.enabled&&!this.config.horizontalScroll.enabled||this.getGraphicalElement("scrollbarContainer")||this.addGraphicalElement("scrollbarContainer",e.setAnimation({el:t||"group",attr:{name:"scrollGroup"},container:a,component:this,label:"scrollbar"}))},a.createScrollBar=function(e){void 0===e&&(e=!1);var t,a,i,n,o,r,s,c,h=this,d=h.config,p=h.getFromEnv("chart-attrib"),f=e?"legendHorizontalScrollBar":"legendScrollBar",m=h.getChildren(f)&&h.getChildren(f)[0],v=d.borderWidth||0,x=.5*v,y=(0,l.pluckNumber)(d.padding,4),k=d.width,S=d.height;t={conf:{isHorizontal:e},handler:{scroll:function(t){function a(e){e.preventDefault()}document.addEventListener("touchmove",a,{passive:!1}),d.lastScrollPos=t,e?d.scrollX=(n-d.totalWidth)*t:d.scrollY=(i-d.totalHeight)*t,h.addJob("scrollDraw",h.drawScroll,g.priorityList&&g.priorityList.draw),b&&clearTimeout(b),b=setTimeout((function(){document.removeEventListener("touchmove",a)}),250)},mousedown:function(e){e.preventDefault(),e.stopPropagation()}}},p.legendscrollbgcolor&&(t.conf.color=(0,l.convertColor)(p.legendscrollbgcolor)),m||(m=h.attachChild(new u.ScrollBar,f),e?this.config.hasHorizontalScroll=!0:this.config.hasScroll=!0),m.configure(t.conf),m.attachEventHandlers(t.handler),a=m.config,e?(o=x,r=S-m.getLogicalSpace().height-v+.5*y,c=k-v,this.config.scroll.enabled&&this.config.horizontalScroll.enabled&&(c-=12),c=C(c,0),n=C(k-y,0),a.scrollRatio=(n+y)/d.totalWidth):(i=C(S-y,0),o=k-m.getLogicalSpace().width-v+.5*y,r=x,s=S-v,this.config.scroll.enabled&&this.config.horizontalScroll.enabled&&(s-=12),s=C(s,0),a.scrollRatio=(i+y)/d.totalHeight),a.startPercent=0,a.scrollPosition=d.lastScrollPos,a.parentLayer=h.getChildContainer("scrollGroup"),m.setDimension({x:o,y:r,height:s,width:c})},a.drawCaption=function(){var e,t,a,i,n=this.getGraphicalElement("caption"),o=this.config.horizontalScroll.enabled?this.getChildContainer("captionGroup"):this.getChildContainer("itemGroup"),r=this.getFromEnv("animationManager"),s=this.config,c=(0,l.pluckNumber)(s.padding,4),h=s.scroll.enabled,u=s.width;if(s.title&&s.title.text!==l.BLANKSTRING&&s.validLegendItem){switch(s.title.align){case l.POSITION_START:a=c;break;case l.POSITION_END:a=u-c-(h?10:0);break;default:a=.5*u}t=s.title.style,e={text:s.title.text,title:s.title.originalText||l.BLANKSTRING,x:a,y:c,fill:s.title.style.color,direction:s.textDirection,"line-height":t.lineHeight,"vertical-align":l.POSITION_TOP,"text-anchor":s.title.align,opacity:1},i={"font-weight":t.fontWeight,"font-style":t.fontStyle,"font-family":t.fontFamily,"font-size":t.fontSize},n&&n.show(),n&&n[0]?r.setAnimation({el:n,attr:e,component:this,container:o,css:i}):(n=r.setAnimation({el:"text",attr:e,component:this,container:o,css:i}),n=this.addGraphicalElement("caption",n)),this.getFromEnv("toolTipController").enableToolTip(n,s.title.originalText)}else n&&r.setAnimation({el:n,component:this,doNotRemove:!0,callback:function(){n.hide()}})},a.drawLegendBox=function(){var e,t=this.getFromEnv("animationManager"),a=this.config,i=this.getContainer("legendGroup"),n=a.width,o=this.getGraphicalElement("box"),r=a.height,l=a.borderRadius,s=a.backgroundColor,c=a.borderColor,h=a.borderAlpha,u=a.backgroundAlpha,d=a.borderWidth||0;return e=t.setAnimation({el:o||"rect",attr:{x:0,y:0,width:n,height:r,r:l,stroke:c,"stroke-width":d,fill:s||"none","stroke-opacity":h/100,"fill-opacity":u/100,cursor:a.legendAllowDrag?"move":"default"},container:i,component:this,label:"legendGroup"}),o||(this.addGraphicalElement("box",e),e.shadow(a.shadow)),e},a._calculateTopPosition=function(e){var t=this.getFromEnv("chart"),a=t.config,i=e,n=t.getChildren("caption")&&t.getChildren("caption")[0],o=t.getChildren("subCaption")&&t.getChildren("subCaption")[0],r=t.getChildren("chartMenuBar")&&t.getChildren("chartMenuBar")[0],s=a.oriTopSpace;return!a.toolbarY&&r&&r.props&&r.props.height&&(s>r.props.height+r.props.y||(i=r.props.y+r.props.height)),n&&n.config&&n.config.text&&n.config.text!==l.BLANKSTRING&&n.config.height&&1===n.config.isOnTop&&(i=n.config.height+n.config.y+n.config.captionPadding),o&&o.config&&o.config.height&&1===o.config.isOnTop&&(i=o.config.y+o.config.height+(n&&n.config&&n.config.captionPadding||0)),C(i,e)},a.getPosition=function(){var e,t,a,i,n,o,r,s,c,h,u=this.getFromEnv("chart"),d=u.config,g=this.config,p=u.getChildren("canvas"),f=p&&p.length>1?d.height-p[0].config.canvasBottom:d.height-d.canvasBottom,m=d.canvasLeft,b=d.canvasRight,v=d.canvasWidth,x=g.chartMarginLeft||0,y=g.chartMarginRight||0,C=g.chartMarginTop||0,k=g.chartMarginBottom||0,S=d.actionBarHeight||0,w=g.actualCanvasMarginLeft||0,A=d.actualCanvasMarginTop||0,L=d.actualCanvasMarginBottom||0,N=d.actualCanvasMarginRight||0,F=g.alignLegendWithCanvas,T=d.height,E=d.canvasTop,P=g.width||0,_=g.height||0,D=d.borderWidth,I=d.oriCanvasLeft,M=d.oriCanvasRight,O=d.oriTopSpace,R=d.oriBottomSpace,B=0,V=0,z=g.borderWidth||0,G=g.legendPos?g.legendPos.split("-"):[],H=u.getChildren("caption")&&u.getChildren("caption")[0],W=u.getChildren("subCaption")&&u.getChildren("subCaption")[0];return G[0]!==l.POSITION_LEFT&&G[0]!==l.POSITION_RIGHT||(g.align=G[0],g.verticalAlign=l.POSITION_MIDDLE,c=g.layout="vertical"),G[0]===l.POSITION_ABSOLUTE?(e=g.legendXPosition,t=g.legendYPosition,e>(a=d.width-P-D)&&(e=a),t>(i=d.height-_-D)&&(t=i)):c?(G[0]===l.POSITION_LEFT?e=x+w+D:G[0]===l.POSITION_RIGHT&&(e=d.width-y-N-P-D),B=(0,l.pluckNumber)(O,E),V=(0,l.pluckNumber)(R,f),G[1]===l.POSITION_TOP?(t=B+(g.y||0),t=this._calculateTopPosition(t)):G[1]===l.POSITION_BOTTOM?(t=T-V-_+(g.y||0),(h=V-(D+k+S+(H&&0===H.config.isOnTop&&H.config.height?H.config.height+H.config.captionPadding:0)+(W&&0===H.config.isOnTop?W.config.height:0)))<0&&(t+=h)):t=B+.5*(T-V-B-_)+(g.y||0)):(r=d.width-(x+w+(y+N)),s=F?v-P:r-P,n=F?(0,l.pluckNumber)(I,m):x+w,o=F?d.width-(0,l.pluckNumber)(M,b):y+N,e=G[1]===l.POSITION_LEFT?n:G[1]===l.POSITION_RIGHT?d.width-(P+o):n+s/2,G[0]===l.POSITION_TOP?(t=C+A,t=this._calculateTopPosition(t)):t=T-_-L-k-S),(0,l.crispBound)(e,t,P,_,z)},a.setTranslation=function(e,t){var a=this.config;a._translateX=e,a._translateY=t,a.translate="t"+e+","+t},a.allocatePosition=function(){var e,t=this.config;e=t.translate?(0,l.crispBound)(t._translateX,t._translateY,t.width,t.height,t.borderWidth):this.getPosition(),t.xPos=e.x,t.yPos=e.y,t.width=e.width,t.height=e.height},a._manageLegendPosition=function(e){var t,a=this.config,i=a.legendPos?a.legendPos.split("-"):[],n={left:0,right:0,top:0,bottom:0};return a.padding=4,a.textPadding=4,t=i[0]===l.POSITION_ABSOLUTE?this._placeLegendBlockBottom(e,.6):i[0]===l.POSITION_LEFT||i[0]===l.POSITION_RIGHT?this._placeLegendBlockRight(e):this._placeLegendBlockBottom(e),i[0]===l.POSITION_LEFT?n.left=t&&t.right||0:i[0]===l.POSITION_RIGHT?n.right=t&&t.right||0:i[0]===l.POSITION_TOP?n.top=t&&t.bottom||0:i[0]!==l.POSITION_ABSOLUTE&&(n.bottom=t&&t.bottom||0,n.right=t&&t.right||0),n},a.setDimension=function(e){var t,a,i,n,o,r,s,c,h,u,d,g,f,b,v,x,w,A,N,F,T,E,P,_,D,I,M=this.config,O=this.getSortedLegendItems(),R=O.length,B=e.width,V=e.height,z=V,G=0,H=0,W=0,j=0,U=0,q=0,Y=0,X=[],K=M.padding,Z=M.textPadding,J=this.getFromEnv("smartLabel"),$=this.getStateCosmetics("default"),Q=this.computeFontSize(M.legendFontSizeWithUnit),ee=parseInt((0,l.setLineHeight)({fontSize:Q+"px"}),10),te=parseInt($.text["font-size"],10)||10,ae=M.title,ie=ae.padding,ne=0,oe=M.minimiseWrappingInLegend,re=M.legendPadding,le=M.legendScale,se=M.alignLegendWithCanvas,ce=M.numColumns,he=M.numRows,ue=M.oriSymbolPadding,de=Number.MAX_SAFE_INTEGER,ge=B,pe=!1,fe=!!he,me=0;for(d={width:2*K,height:2*K},this.setStateCosmetics("default",{text:{fill:$.text.fill,"font-family":$.text["font-family"],cursor:$.text.cursor,"font-size":Q,"line-height":ee,"vertical-align":l.POSITION_TOP,"text-anchor":l.POSITION_START,direction:$.text.direction,"font-weight":$.text["font-weight"]},symbol:{bgColor:$.symbol.bgColor,cursor:$.symbol.cursor,borderColor:$.symbol.borderColor,bgAlpha:$.symbol.bgAlpha,borderAlpha:$.symbol.borderAlpha,borderThickness:$.symbol.borderThickness,startAngle:$.symbol.startAngle,sides:$.symbol.sides}}),(u=te+1)<=0&&(u=1),B=Math.max(B-2*K,0),ue*=le,(u=y(u*=le,B))<=0&&(ue=u=0),M.symbolWidth=u,M.textPadding=4,M.legendHeight=h=u+2*ue,M.rowHeight=r=C(parseInt($.text["line-height"],10)||12,h),o=Z+ue+K,J.setStyle((0,l.extend2)({},$.text)),s=re+M.borderWidth/2+1,s=C(y(s,V-ee-8),0),re=.05*r,M.initialItemY=0,M.initialItemX=0,_=h+re+Z+ue+2*K,g=0;g<R;g+=1)a=t=(n=O[g]).config||(n.config={}),(i=t.name=(0,l.parseUnsafeString)(a.label))===l.BLANKSTRING||0===a.enabled||!1===a.enabled||n.getState("removed")?t.enabled=0:(t.enabled=1,W+=1,F=!0,T=J.getOriSize(i),G=C(G,y(T.width,B-_)),q=C(q,y(T.height,z)),t._selfTotalWidth=T.width+_,H+=T.width);if(M.validLegendItem=F,j=H/W,H+=_*W,M.x=!se&&H>ge?0:M.x,F){if(j+=_,G+=_,ae.oriText!==l.BLANKSTRING&&(pe=!0,J.setStyle(ae.style),T=J.getSmartText(ae.oriText,B-2*K),ae.text=T.text,T.tooltext&&(ae.originalText=T.tooltext),ne=T.width+2*K,Y=T.height+ie),b=G,he?!ce&&he?(me=1,W<he&&(he=W),ce=S(W/he)):S(W/ce)<he&&S(W/he)<ce||W>ce*he?he=S(W/ce):ce===S(W/he)&&(me=1):H<=B?b=1===(he=S(W/(ce=ce||W)))?H/W:G:!ce&&B>G&&(oe||1.5*j>G)?(W<(ce=k(B/G))&&(ce=W),b=G):ce&&B/ce>j?(b=B/ce)>G&&(b=G):!ce&&B>=2*j?(W<(ce=k(B/j))&&(ce=W),(b=k(B/ce))>G&&(b=G)):ce||(ce=1,b=B),U=fe?G:b,!fe&&1.5*j<G&&(b=j),he&&!oe){var be,ve,xe=U;G>1.5*j&&(xe=j),ve=y(W,k(B/xe)),be=S(W/ve),M.numRows&&be!==he||M.numColumns&&ve!==ce||1===he&&1!==be||(U=xe,ce=ve,he=be)}for(J.setStyle((0,l.extend2)({},$.text)),g=0;g<R;g++)t=O[g].config,1===he&&(U=G>2.5*j?j:t._selfTotalWidth),0===(c=Math.ceil(U-_))?(t.name=l.BLANKSTRING,t._totalWidth=u+ue,t._selfTotalWidth=t._totalWidth,t._selfTotalHeight=r):(T=J.getSmartText(t.name,c<t._selfTotalWidth-_?c+Z:void 0),t.name=T.text,t._textHeight=T.height,T.tooltext&&(t.originalText=T.tooltext),t._selfTotalHeight=T.height+Z>r?Z+T.height:r,t._totalWidth=u+o+T.width,t._selfTotalWidth=_+T.width,t._legendTestY=r>T.height?(r-T.height)/2:0,q=C(q,t._textHeight),de=C(1,y(de,t._textHeight)));if(v={style:{display:"grid",justifyItems:"center",alignItems:"start"}},x=[],pe&&x.push({style:{width:ne,height:Y,gridRowStart:1,gridRowEnd:2,gridColumnStart:1,gridColumnEnd:2}}),x.push({style:{display:"grid",justifyItems:"start",alignItems:"start",width:y(H,B,U*ce),paddingEnd:K,paddingTop:K,gridRowStart:x.length+1,gridRowEnd:x.length+2,gridColumnStart:1,gridColumnEnd:2}}),w=[],fe||1===he)for(f=0,g=1;f<R;f++)1===(t=(n=O[f]).config).enabled&&(0===me?(D=S(g/ce),I=g%ce==0?ce:g%ce):(D=g%he==0?he:g%he,I=S(g/he)),w.push({style:{width:1===he||I===ce?t._selfTotalWidth:U,height:t._selfTotalHeight,gridRowStart:D,gridRowEnd:D+1,gridColumnStart:I,gridColumnEnd:I+1}}),g+=1);else{for(he=0,de=C(de,r),f=0;f<R;f++)1===(t=(n=O[f]).config).enabled&&(he+=Math.ceil(t._selfTotalHeight/de));0===he&&(he=Math.max(1,Math.ceil(W/ce))),X=L(he).map((function(){return L(ce)}));var ye,Ce=0,ke=0;for(f=0,g=1;f<R;f++)if(1===(t=(n=O[f]).config).enabled){for(;Ce<he;){for(;ke<ce;){if(void 0===X[Ce][ke]){I=ke+1,D=Ce+1,ye=1===ce?1:+(t._selfTotalHeight/de).toFixed(0),X[Ce][ke]=!0;for(var Se=Ce;Se<Ce+ye;Se++)X[Se][ke]=!0}if(ke++,X[Ce][ke-1])break}if(ke>=ce&&(ke=0,Ce++),ye)break}w.push({style:{width:I===ce?t._selfTotalWidth:b,height:t._selfTotalHeight,gridRowStart:D,gridRowEnd:D+ye,gridColumnStart:I,gridColumnEnd:I+1}}),g+=1,ye=void 0}for(g=he=0;g<X.length;g++)for(f=0;f<ce;f++)if(X[g][f]){he++;break}ce>1&&(x[x.length-1].style.gridTemplateRows=(de+" ").repeat(he).slice(0,-1))}for(x[x.length-1].children=w,A=(0,p.computeLayout)(m(m({},v),{},{children:x})),M.itemWidth=U,(c=S(U-_))<0&&(ue=c=Z=0),M.symbolPadding=ue,M.textPadding=Z,M.width=M.totalWidth=C(A.layout.width,A.children[A.children.length-1].layout.width),J.setStyle((0,l.extend2)({},$.text)),f=0,g=0;f<R;f++)t=(n=O[f]).config,1===he&&(c=t._selfTotalWidth)<0&&(ue=c=Z=0),1===t.enabled&&(0===c&&(t.name=l.BLANKSTRING,t._totalWidth=u+ue),t._legendX=A.children[A.children.length-1].children[g].layout.x,t._legendY=A.children[A.children.length-1].children[g].layout.y,t._legendH=A.children[A.children.length-1].children[g].layout.height,g+=1);if(N=he,d.height+=N*r+Y,M.height=M.totalHeight=A.layout.height+2*K,M.rowHeight=r,M.legendNumColumns=ce,M.initialItemX=pe&&ne>A.children[A.children.length-1].layout.width&&B>M.width?A.children[A.children.length-1].layout.x:0,M.initialItemY=A.children[A.children.length-1].layout.y,M.height-2*ue>V?(M.height=V,(E=M.scroll||(M.scroll={})).enabled=!0,E.flatScrollBars=M.flatScrollBars,E.scrollBar3DLighting=M.scrollBar3DLighting,M.width=M.width+12>B?M.width:M.width+12):M.scroll.enabled=!1,M.width>B?(M.width=B,(P=M.horizontalScroll||(M.horizontalScroll={})).enabled=!0,P.flatScrollBars=M.flatScrollBars,P.scrollBar3DLighting=M.scrollBar3DLighting,M.height+12<=V?M.height=M.height+12:(M.height=V,M.totalHeight+=4,(E=M.scroll||(M.scroll={})).enabled=!0,E.flatScrollBars=M.flatScrollBars,E.scrollBar3DLighting=M.scrollBar3DLighting,M.scroll.enabled=!0)):M.horizontalScroll.enabled=!1,M.totalWidth>M.width&&M.totalWidth-M.width<=4){for(f=0,g=0;f<R;f++)1===(t=(n=O[f]).config).enabled&&(A.children[A.children.length-1].children[g].style.gridColumnStart%ce!=1&&(t._legendX+=4,1===A.children[A.children.length-1].children[g].style.gridRowStart&&(M.totalWidth+=4)),g+=1);M.totalHeight+=4}s+=M.height,M.isActive=!0,M.enabled=!0}else M.enabled=!1,M.width=0,s=0;return{width:M.width,height:s}},a._placeLegendBlockBottom=function(e,t){void 0===t&&(t=1);var a,i,n,o,r,s=this.getFromEnv("chart"),c=s.config,h=s.getFromEnv("chartWidth"),u=s.getFromEnv("chartHeight"),d=c.canvasLeft,g=c.width-(c.canvasRight||0),p=s.getFromEnv("smartLabel"),f=this.config,m=f.chartMarginLeft,b=f.chartMarginRight,v=f.chartMarginTop,x=f.alignLegendWithCanvas,y=this.getSortedLegendItems().length,C=f.legendPadding,k=c.canvasMarginRight,S=c.canvasMarginLeft,w=s.getChildren("yAxis"),A=w&&w[0].config.isVertical?w:s.getChildren("xAxis"),L=A&&A[0],N=A&&A[1],F=L&&L.config||{},T=N&&N.config||{},E=F.nameMaxW,P=T.nameMaxW,_=F.name&&F.name.style||{},D=T.name&&T.name.style||{},I=F.axisName||l.BLANKSTRING,M=T.axisName||l.BLANKSTRING,O=c.canvasWidth-c.canvasMarginLeft-c.canvasMarginRight,R=c.width,B=c.height,V=f.legendPos?f.legendPos.split("-"):[];return f.paddingBottom=c.height-c.canvasBottom,p.useEllipsesOnOverflow(c.useEllipsesWhenOverflow),p.setStyle(_),o=p.getOriSize(I),p.setStyle(D),r=p.getOriSize(M),O<C&&(f.padding=C=O=0),(o||r)&&(i=(0,l.pluckNumber)(o.height,0)>(0,l.pluckNumber)(r.height,0)?(n=E)&&o.width:(n=P)&&r.width),O=x?O:h-(i+v>u-e?2*n+b+m+k+S:b+m+S+k),V[0]===l.POSITION_ABSOLUTE&&(O=R,f.legendMaxWidth<R?O=f.legendMaxWidth:O*=t),f.showLegend&&0!==y?(f.x=(d-m-g+b)/2,a=this.setDimension({width:O,height:V[0]===l.POSITION_ABSOLUTE?f.legendMaxHeight<B?f.legendMaxHeight:B:e}).height):(a=0,f.height=0,f.width=0),{bottom:a,right:0}},a._placeLegendBlockRight=function(e){var t,a=e,i=this.config,n=this.getFromEnv("chart"),o=n.config,r=n.getFromEnv("smartLabel"),s=i.legendPadding,c=this.getStateCosmetics("default"),h=o.canvasHeight,u={},d=this.getSortedLegendItems().length;return a<s&&(i.padding=s=a=0),r.useEllipsesOnOverflow(o.useEllipsesWhenOverflow),r.setStyle((0,l.extend2)({},c.text)),i.numColumns||i.numRows||(i.numColumns=1),i.showLegend&&0!==d?(t=this.setDimension({width:a-s,height:h}).width,u.right=t+s,u.right+10<=a&&(u.right+=10)):(u.right=0,i.height=0,i.width=0),u},a.postSpaceManager=function(){var e=this.config,t=e.legendPos?e.legendPos.split("-"):[],a=this.getFromEnv("chart").config.canvasHeight;t[0]!==l.POSITION_RIGHT&&t[0]!==l.POSITION_LEFT||(e.totalHeight>a?(e.totalHeight<=e.height&&(e.scroll.enabled=!0,e.scroll.flatScrollBars=e.flatScrollBars,e.scroll.scrollBar3DLighting=e.scrollBar3DLighting,e.width+=(e.scroll.scrollBarWidth=10)+(e.scroll.scrollBarPadding=2)),e.height=a):e.scroll.enabled=!1)},a.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var a,i,n,o,r,s=this.config,c=this.getFromEnv("chart"),h=c.config,u=this.getFromEnv("style"),d=c.getFromEnv("chart-attrib"),g=c.config.is3D,p=this.getFromEnv("color-manager"),f=g?l.chartPaletteStr.chart3D:l.chartPaletteStr.chart2D,m=s.interactiveLegend=!1!==c.hasInteractiveLegend&&Boolean((0,l.pluckNumber)(d.interactivelegend,1)),b=(0,l.pluckNumber)(d.useroundedges,0),x=u.outCancolor,y=t.style&&t.style.text,k=(0,l.pluck)(d.legenditemfont,y&&y["font-family"],u.outCanfontFamily),S=(0,l.pluckNumber)(d.legendiconscale,1),w=(0,l.pluckFontSize)(d.legenditemfontsize,y&&y["font-size"],u.fontSize)+"px",L=(0,l.pluck)(d.legenditemfontcolor,y&&y.color,x).replace(/^#?([a-f0-9]+)/gi,"#$1"),N=(0,l.getFirstColor)((0,l.pluck)(d.legenditemhoverfontcolor,L));s.isActive=!1,s.chartMarginTop=h.origMarginTop,s.chartMarginRight=h.origMarginRight,s.chartMarginBottom=h.origMarginBottom,s.chartMarginLeft=h.origMarginLeft,s.reverselegend=(0,l.pluckNumber)(d.reverselegend,0),s.showLegend=(0,l.pluckNumber)(d.showlegend,!c.dontShowLegendByDefault,1),s.legendFontSizeWithUnit=(0,l.pluckFontSizeMaintainUnit)(d.legenditemfontsize,u.fontSizeWithUnit||u.fontSize),a=(0,l.setLineHeight)({fontSize:w}),s.legendPos=(0,l.pluck)(d.legendposition,c.legendposition,t.legendPosition,l.POSITION_BOTTOM).toLowerCase(),s.numColumns=(0,l.pluckNumber)(Math.floor(d.legendnumcolumns)),s.numRows=(0,l.pluckNumber)(Math.floor(d.legendnumrows)),s.numColumns<0&&(s.numColumns=void 0),s.numRows<0&&(s.numRows=void 0),s.legendXPosition=C((0,l.pluckNumber)(d.legendxposition,c.legendxposition,t.legendXPosition,0),0),s.legendYPosition=C((0,l.pluckNumber)(d.legendyposition,c.legendyposition,t.legendYPosition,0),0),s.legendMaxWidth=(0,l.pluckNumber)(d.legendmaxwidth,c.legendmaxwidth,t.legendMaxWidth),s.legendMaxHeight=(0,l.pluckNumber)(d.legendmaxheight,c.legendmaxheight,t.legendMaxHeight),s.legendMaxWidth<0&&(s.legendMaxWidth=void 0),s.legendMaxHeight<0&&(s.legendMaxHeight=void 0),s.xL=s.yL=0,(S<=0||S>5)&&(S=1),s.drawCustomLegendIcon=(0,l.pluckNumber)(d.drawcustomlegendicon,t.drawcustomlegendicon,0),s.legendScale=S,s.legendPadding=(0,l.pluckNumber)(d.legendpadding,7),s.alignLegendWithCanvas=(0,l.pluckNumber)(t.alignlegendwithcanvas,h.alignLegendWithCanvas),s.title.style={fontFamily:(0,l.pluck)(d.legendcaptionfont,k),fontSize:(0,l.pluckFontSize)(d.legendcaptionfontsize,u.fontSize)+"px",color:(0,l.pluck)(d.legendcaptionfontcolor,x).replace(/^#?([a-f0-9]+)/gi,"#$1"),fontWeight:A.fontWeight[(0,l.pluckNumber)(d.legendcaptionfontbold,1)]||l.BLANKSTRING},r=d.legendcaptionalignment?d.legendcaptionalignment.toLowerCase():v.center,s.title.align=v[r]||v.center,s.title.style["text-anchor"]=s.title.align,s.padding=4,i=(0,l.pluck)(d.legendbordercolor,p.getColor(f.legendBorderColor)),n=s.borderAlpha=(0,l.pluckNumber)(d.legendborderalpha,100),s.borderColor=(0,l.convertColor)(i,n),s.borderWidth=(0,l.pluckNumber)(d.legendborderthickness,t.legendborderthickness,!b||d.legendbordercolor?1:0),s.borderRadius=(0,l.pluckNumber)(b,0),s.backgroundAlpha=o=(0,l.pluckNumber)(d.legendbgalpha,t.legendbgalpha,100),s.backgroundColor=(0,l.convertColor)((0,l.pluck)(d.legendbgcolor,p.getColor(f.legendBgColor)),o),s.symbol3DLighting=Boolean((0,l.pluckNumber)(d.use3dlighting,d.useplotgradientcolor,1)),s.symbol3DLighting=!h.usePattern&&s.symbol3DLighting,s.shadow=Boolean((0,l.pluckNumber)(d.legendshadow,1)),s.shadow&&(s.shadow={enabled:s.shadow,opacity:C(n,o)/100}),s.prevReversed=Boolean((0,l.pluckNumber)(s.reversed,0)),s.reversed=Boolean((0,l.pluckNumber)(d.reverselegend,0)),s.lineWidth=(0,l.pluckNumber)(d.linethickness,2),s.borderRadius=(0,l.pluckNumber)(d.legendborderradius,b?3:0),s.legendAllowDrag=Boolean((0,l.pluckNumber)(d.legendallowdrag,0)),s.title.oriText=(0,l.parseUnsafeString)((0,l.getFirstValue)(d.legendcaption,l.BLANKSTRING)),s.legendScrollBgColor=(0,l.getFirstColor)((0,l.pluck)(d.legendscrollbgcolor,d.scrollcolor,p.getColor("altHGridColor"))),s.legendScrollBarColor=(0,l.pluck)(d.legendscrollbarcolor,i),s.legendScrollBtnColor=(0,l.pluck)(d.legendscrollbtncolor,i),s.minimiseWrappingInLegend=(0,l.pluckNumber)(d.minimisewrappinginlegend,0),s.flatScrollBars=(0,l.pluckNumber)(d.flatscrollbars,0),s.scrollBar3DLighting=(0,l.pluckNumber)(d.scrollbar3dlighting,1),s.orderReversed=!1,this.setStateCosmetics("hidden",{symbol:{fill:(0,l.convertColor)((0,l.pluck)(d.legenditemhiddencolor,"cccccc").replace(/^#?([a-f0-9]+)/gi,"#$1")),stroke:(0,l.convertColor)((0,l.pluck)(d.legenditemhiddencolor,"cccccc").replace(/^#?([a-f0-9]+)/gi,"#$1"))},text:{fill:(0,l.convertColor)((0,l.pluck)(d.legenditemhiddencolor,"cccccc").replace(/^#?([a-f0-9]+)/gi,"#$1"))}}),this.setStateCosmetics("default",{text:{fill:(0,l.convertColor)(L),"font-family":k,cursor:m?l.preDefStr.POINTER:"default","font-size":w,"line-height":a,"vertical-align":l.POSITION_TOP,"text-anchor":l.POSITION_START,direction:"rtl"===h.textDirection?"rtl":"initial","font-weight":A.fontWeight[(0,l.pluckNumber)(d.legenditemfontbold,0)]||l.BLANKSTRING},symbol:{bgColor:(0,l.pluck)(d.legendiconbgcolor),cursor:m?l.preDefStr.POINTER:"default",borderColor:(0,l.pluck)(d.legendiconbordercolor),bgAlpha:(0,l.pluckNumber)(d.legendiconbgalpha,d.legendiconalpha,100),borderAlpha:(0,l.pluckNumber)(d.legendiconborderalpha,d.legendiconalpha,100),borderThickness:(0,l.pluckNumber)(d.legendiconborderthickness),startAngle:(0,l.pluckNumber)(d.legendiconstartangle,45),sides:(0,l.pluckNumber)(d.legendiconsides,t.legendiconsides,4)}}),this.setStateCosmetics("hover",(function(e,t){return t.hasState("hidden")||(e.text||(e.text={}),e.text.fill=(0,l.convertColor)(N.replace(/^#?([a-f0-9]+)/gi,"#$1")),e.text.cursor="inherit"),e})),s.legendAllowDrag&&!s._dragEvtListenerBinded?(this.addEventListener("fc-dragstart",s.handlers.dragstart),this.addEventListener("fc-dragmove",s.handlers.dragmove),s._dragEvtListenerBinded=!0):!s.legendAllowDrag&&s._dragEvtListenerBinded&&(this.removeEventListener("fc-dragstart",s.handlers.dragstart),this.removeEventListener("fc-dragmove",s.handlers.dragmove),s._dragEvtListenerBinded=!1)},a.getLegendState=function(){return this._legendState},a.hasState=function(e){var t,a,i=this.getLegendState();for(t=0,a=i.length;t<a;t++)if(i[t]===e)return!0;return!1},a.setLegendState=function(e,t){this.hasState(e)||(t?this._legendState.push(e):this._legendState.unshift(e)),this.asyncDraw()},a.removeLegendState=function(e){var t,a,i=1;if(e)for(t=0,a=this._legendState.length;t<a&&i;t++)e===this._legendState[t]&&(this._legendState.splice(t,1),i=0);else this._legendState.length=0;this.asyncDraw()},a.setStateCosmetics=function(e,t){this._stateCosmetics[e]=t},a.removeStateCosmetics=function(e){delete this._stateCosmetics[e]},a.getStateCosmetics=function(e){return this._stateCosmetics[e]},a.hide=function(){var e=this.getFromEnv("chart").getChildContainer("legendGroup");e&&e.hide()},t}(s.ComponentInterface);t["default"]=N},570:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(223)),o=i(a(238)),r=a(224),l=a(240),s=a(232),c=i(a(571));function h(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function u(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?h(Object(a),!0).forEach((function(t){(0,n["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):h(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var d=r.preDefStr.POINTER,g="M",p="L",f="Z",m="A",b=function(e,t,a,i,n){var o,r,l,s,c,h,u,d,b,v=[g];switch(n){case"column":case"dragColumn":case"column3D":case"realtimeColumn":case"errorBar2D":r=.5*(o=.25*a),l=.7*i,s=.4*i,v=v.concat([e,t+i,"l",0,-l,o,0,0,l,"z","m",o+r,0,"l",0,-i,o,0,0,i,"z","m",o+r,0,"l",0,-s,o,0,0,s,"z"]);break;case"bar2D":case"bar3D":o=.3*a,r=.6*a,s=(l=i/4)/2,v=v.concat([e,t,p,e+r,t,e+r,t+l,e,t+l,f,g,e,t+l+s,p,e+a,t+l+s,e+a,t+l+s+l,e,t+2*l+s,f,g,e,t+2*(l+s),p,e+o,t+2*(l+s),e+o,t+i,e,t+i,f]);break;case"area":case"area3d":case"areaspline":case"dragArea":case"realTimeArea":case"splinearea":o=.3*a,r=.6*a,l=.6*i,s=.2*i,c=.8*i,v=v.concat([e,t+c,p,e,t+l,e+o,t+s,e+r,t+l,e+a,t+s,e+a,t+c,f]);break;case"pie2D":case"pie3d":case"doughnut2D":case"doughnut3D":r=.9*(o=.5*a),1,1,h=e+o+1,d=t+o-1,u=e+o-1,b=t+o+1,v=v.concat([h,d,p,h,d-r+1,m,r-1,r-1,0,0,1,h+r-1,d,f,g,u,b,p,u,b-r,m,r,r,0,1,0,u+r,b,f]);break;case"boxandwhisker2d":v=v.concat([e,t,p,e+a,t,e+a,t+i,e,t+i,f]);break;case"radialBar":r=e+a,d=t+(o=.5*a),v=v.concat([e,d,m,o,o,0,0,0,r,d,m,o,o,0,0,0,e,d]);break;default:v=v.concat([e,t,p,e+a,t,e+a,t+i,e,t+i,f])}return{path:v}},v=function(e,t){var a=e.config,i=e.getLinkedParent().config,n=.5*i.symbolWidth,o=(i.initialItemX||0)+a._legendX,l=(i.initialItemY||0)+a._legendY,s=o+i.symbolPadding+n,c=l+(a._markerYGutter||0)+i.symbolPadding+n,h=(0,r.mapSymbolName)(a.anchorSide),u=a.symbol=h&&h.split("_")||[],g="spoke"===u[0]?1:0;return("line"===a.type||a.drawLine)&&(n*=.6),{path:(0,r.polyPathToPath)([u[1]||2,s,c,n,a.startAngle,a.spoke||g]),cursor:t.cursor||d,stroke:t.stroke,fill:t.fill,"stroke-width":t["stroke-width"]||.5}};(0,s.addDep)({name:"legendItemAnimation",type:"animationRule",extension:c["default"]});var x=function(e){function t(){var t;return(t=e.call(this)||this)._stateCosmetics={},t._legendState=[],t}(0,o["default"])(t,e);var a=t.prototype;return a.getName=function(){return"legendItem"},a.parseLegendCosmetics=function(){var e,t,a,i=this.getLinkedParent(),n=i.getLegendState(),o=this.getLegendState(),l=["default"],s={};for(l=l.concat(n,o),a=0;a<l.length;a++)e=i.getStateCosmetics(l[a]),t=this.getStateCosmetics(l[a]),e&&("function"==typeof e?s=e(s,this):(0,r.extend2)(s,e)),t&&("function"==typeof t?s=t(s,this):(0,r.extend2)(s,t));return s},a.getType=function(){return"legendItem"},a.configure=function(e){var t,a,i=this.config;for(t in e)if(e.hasOwnProperty(t))if("object"!=typeof e[t])i[t]=e[t];else{var n=i[t]?i[t]:{};for(a in e[t])n[a]=e[t][a];i[t]=n}},a.itemClickFn=function(){var e=this.getFromEnv("chart-attrib"),t=(0,r.pluckNumber)(e.interactivelegend,1),a=this.getLinkedItem("owner");t&&a.legendInteractivity(this)},a.dispose=function(){this.removeEventListener("fc-click",this.click),this.removeEventListener("fc-mouseover",this.mouseover),this._dispose()},a.getLegendState=function(){return this._legendState},a.hasState=function(e){var t,a,i=this.getLegendState();for(t=0,a=i.length;t<a;t++)if(i[t]===e)return!0;return!1},a.setLegendState=function(e,t){this.hasState(e)||(t?this._legendState.push(e):this._legendState.unshift(e)),this.asyncDraw()},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.eventArguments={}},a.removeLegendState=function(e){var t,a,i=1;if(e)for(t=0,a=this._legendState.length;t<a&&i;t++)e===this._legendState[t]&&(this._legendState.splice(t,1),i=0);else this._legendState.length=0;this.asyncDraw()},a.removeStateCosmetics=function(e){delete this._stateCosmetics[e]},a.setStateCosmetics=function(e,t){this._stateCosmetics[e]=t},a.getStateCosmetics=function(e){return this._stateCosmetics[e]},a.draw=function(){var e,t,a,i,n,o,l,s,c,h,f,m,x,y,C,k,S,w,A,L,N,F,T,E,P,_,D,I,M,O,R,B,V,z,G,H,W,j,U,q,Y,X=this.getLinkedParent(),K=X.getFromEnv("chart").config,Z=this.getFromEnv("animationManager"),J=this.config,$=X.config,Q=$.legendHeight,ee=$.symbolPadding,te=$.symbolWidth,ae=$.interactiveLegend,ie=$.textPadding||2,ne=2,oe=$.itemHoverStyle,re=X.getChildContainer("itemGroup"),le=$.drawCustomLegendIcon,se=this.hasState("hidden"),ce={};a=(e=this.parseLegendCosmetics()).symbol,i=$.initialItemX||0,n=$.initialItemY||0,c=J.type,N=e.symbol.stroke||"000000",F=e.symbol.fill,t=e.symbol.lineWidth||$.lineWidth,E=J.anchorSide,P=J.drawLine,h=i+J._legendX,f=n+J._legendY,V=this.getGraphicalElement("legendItemBackground"),s=this.getGraphicalElement("legendItemText"),m=this.getGraphicalElement("legendItemLine"),C=this.getGraphicalElement("legendItemSymbol"),k=this.getGraphicalElement("legendItemIcon"),!(ae=(0,r.pluck)(J.interactiveLegend,ae))&&(e.cursor="default"),z=e.text,q=h+Q+ie-2,Y=f+(J._legendTestY||0),z.text=J.name,z.x=q,z.y=Y,l=Z.setAnimation({el:s||"text",attr:z,component:this,container:re,label:"icon"}),s||(l=this.addGraphicalElement("legendItemText",l)),l.data("legendItem",J),k&&this.removeGraphicalElement("legendItemIcon"),G=!1,e.symbol.bgAlpha=(0,r.pluckNumber)(e.symbol.bgAlpha,K.legendiconalpha,K.legendiconbgalpha,K.plotfillalpha),e.symbol.bgAlpha=e.symbol.bgAlpha>100||e.symbol.bgAlpha<0?1:e.symbol.bgAlpha,"radialBar"===c&&J.showIcon?W={src:J.iconUrl,x:h+ee,y:f+(J._markerYGutter||0)+ee,width:te,height:te}:le&&!1!==J.customLegendIcon?(I=!se&&a.borderColor,M=(0,r.pluck)(a.borderAlpha),_=!se&&a.bgColor,D=(0,r.pluck)(a.bgAlpha,"100"),O=e.symbol.rawFillColor,F=se?e.symbol.fill:_||O,F=(0,r.convertColor)(F,D),R=e.symbol.rawStrokeColor,N=se?e.symbol.stroke:I||R||O,N=(0,r.convertColor)(N,M),S=h+ee+(w=.5*te),o=f+(J._markerYGutter||0)+ee+w,A="spoke"===(L=(0,r.mapSymbolName)(a.sides)&&(0,r.mapSymbolName)(a.sides).split("_")||[])[0]?1:0,H={path:(0,r.polyPathToPath)([L[1]||2,S,o,w,a.startAngle||0,A]),cursor:e.symbol.cursor||d,stroke:N,fill:F,"stroke-width":(0,r.pluckNumber)(a.borderThickness,1)}):"line"===c||P?(E&&(H=v(this,e.symbol),ne=J.anchorSide>1&&J.anchorSide<10?4:7),o=f+(J._markerYGutter||0)+ee+.5*te,U={path:[g,h+ee,o,p,h+ee+te/ne,o,g,h+ee+te-te/ne,o,p,h+ee+te,o]},G=!0,ce={opacity:(0,r.pluckNumber)(e.symbol.bgAlpha,1),"stroke-width":t,stroke:N,cursor:e.cursor||d}):E?H=v(this,e.symbol):"radialBar"!==c||J.showIcon?"line"!==c&&(N=J.symbolStroke||N,H={path:b(h+ee,f+(J._markerYGutter||0)+ee,te,te,c).path,"stroke-width":.5,stroke:N,fill:F,cursor:e.cursor||d}):(N=J.symbolStroke||N,H={path:b(h+ee,f+(J._markerYGutter||0)+ee,te,te,c).path,"stroke-width":.5,stroke:N,fill:F,cursor:e.cursor||d}),U&&G?(Object.assign(U,ce),m=Z.setAnimation({el:m||"path",attr:U,component:this,callback:function(){this.show()},container:re}),this.getGraphicalElement("legendItemLine")||(m=this.addGraphicalElement("legendItemLine",m))):m&&m.hide(),W?(y=Z.setAnimation({el:k||"image",attr:W,component:this,callback:function(){this.show()},container:re,label:"icon"}),k&&k.node||(y=this.addGraphicalElement("legendItemIcon",y)),y.data("legendItem",J)):k&&this.removeGraphicalElement(k),H?(H.opacity=(0,r.pluckNumber)(e.symbol.bgAlpha,1),x=Z.setAnimation({el:C||"path",attr:H,component:this,callback:function(){this.show()},container:re,label:"icon"}),J.usePattern&&J.patternAttr&&x.addPattern(u(u({},J.patternAttr),{},{color:se?H.stroke:J.patternAttr.color,x:h,y:f}),J.usePattern),C&&C.node||(x=this.addGraphicalElement("legendItemSymbol",x)),x.data("legendItem",J)):C&&C.hide(),T=e.background&&e.background.legendBackgroundColor?(0,r.convertColor)(e.background.legendBackgroundColor,e.background.alpha):r.TRACKER_FILL,j={x:h,y:f,width:J._totalWidth,height:J._legendH,r:0,fill:T,opacity:1,"stroke-width":1,stroke:"none",cursor:e.symbol.cursor||d},B=Z.setAnimation({el:V||"rect",attr:j,css:void 0,component:this,label:"background",container:re}),V||this.addGraphicalElement("legendItemBackground",B),B.data("legendItem",this).data("interactive",ae).data("itemHoverStyle",oe).data("itemStyle",e)},t}(l.ComponentInterface);t["default"]=x},571:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=a(224),n={"*.legendItem.legendItem":function(){return{"icon.appearing":function(e){return[{initialAttr:{opacity:0},slot:"plot",startEnd:{start:.5,end:1},finalAttr:{opacity:(0,i.pluckNumber)(e.attr.opacity,1)}}]},"background.appearing":function(e){return[{initialAttr:{opacity:0},slot:"plot",startEnd:{start:.5,end:1},finalAttr:{opacity:e.attr.opacity}}]},"icon.disappearing":function(){return[{finalAttr:{opacity:0},slot:"initial"}]}}}};t["default"]=n},572:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}],n=[{slot:"plot",startEnd:{start:0,end:.5}}],o=[{slot:"intial"}],r={"*.legend.legend":function(){return{"legendGroup.appearing":i,"legendGroup.updating":n,"legendGroup.disappearing":o,"scrollbar.appearing":i,"scrollbar.updating":n,"scrollbar.disappearing":o}}};t["default"]=r},573:function(e,t,a){"use strict";t.__esModule=!0,t.computeLayout=void 0;var i=a(574),n=a(575),o=a(576),r=function(){function e(){this.gridLayoutEngine=o.computeGridLayout}return e.prototype.compute=function(e){switch((0,i.getDisplayProperty)(e)){case n.DISPLAY_GRID:case n.DISPLAY_FLEX:default:return this.gridLayoutEngine(e)}},e}();t.computeLayout=function(e){var t,a=new r,n=(0,i.cloneObject)(e);return n.root=!0,t=a.compute(n),(0,i.attachLayoutInformation)(e,t),e}},574:function(e,t,a){"use strict";t.__esModule=!0,t.pluckNumber=t.getDisplayProperty=t.attachLayoutInformation=t.cloneObject=void 0;var i=a(575);t.pluckNumber=function(){var e,t,a;for(t=0,a=arguments.length;t<a;t+=1)if(((e=arguments[t])||!1===e||0===e)&&!isNaN(e=Number(e)))return e},t.attachLayoutInformation=function n(e,t){var a,i;for(void 0===e&&(e={}),void 0===t&&(t={}),e.layout=t.layout,a=0,i=(e.children||[]).length;a<i;a++)n(e.children[a],t.children[a])},t.cloneObject=function o(e){if(i.ATOMIC_DATA_TYPE.indexOf(typeof e)>-1||null===e)return e;if(Array.isArray(e)){var t,a,n=[];for(t=0,a=e.length;t<a;t++)n.push(o(e[t]));return n}if("object"==typeof e){var r,l={};for(r in e)l[r]=o(e[r]);return l}},t.getDisplayProperty=function(e){return e.style&&e.style.display}},575:function(e,t,a){"use strict";t.__esModule=!0,t.ATOMIC_DATA_TYPE=t.STRETCH=t.END=t.START=t.CENTER=t.DISPLAY_FLEX=t.DISPLAY_GRID=void 0;t.ATOMIC_DATA_TYPE=["string","number","function","boolean","undefined"],t.STRETCH="stretch",t.END="end",t.START="start",t.CENTER="center",t.DISPLAY_FLEX="flex",t.DISPLAY_GRID="grid"},576:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.computeGridLayout=function(e,t){void 0===t&&(t=1);var a,i,n,r,l=e.style;if(!e||!e.style)return;e.userGivenStyles||(e.style.width=isNaN(e.style.width)?"auto":e.style.width,e.style.height=isNaN(e.style.height)?"auto":e.style.height,l.paddingStart=(0,o.pluckNumber)(l.paddingStart,l.padding,0),l.paddingEnd=(0,o.pluckNumber)(l.paddingEnd,l.padding,0),l.paddingTop=(0,o.pluckNumber)(l.paddingTop,l.padding,0),l.paddingBottom=(0,o.pluckNumber)(l.paddingBottom,l.padding,0),e.userGivenStyles={gridTemplateColumns:e.style.gridTemplateColumns,gridTemplateRows:e.style.gridTemplateRows,width:e.style.width,height:e.style.height});for(e.unResolvedChildren=[],a=0,i=e.children&&e.children.length;a<i;a++)n=e.children[a],(0,o.getDisplayProperty)(n)&&(f(n)?this.compute(n):e.unResolvedChildren.push(n));(r=new y).set("domTree",e).set("parent",this).compute(),t<2&&this.gridLayoutEngine(function(e,t){var a,i,n,r,l,s,c,h,u,d,g=e.style,p=t.getConfig("rowTracks"),f=t.getConfig("colTracks"),m=t.getConfig("mapping"),b=g.gridTemplateRows,v=g.gridTemplateColumns;for(e.style.gridTemplateRows=C(b,p),e.style.gridTemplateColumns=C(v,f),i=0,r=(e.children||[]).length;i<r;i++)if(a=e.children[i],(0,o.getDisplayProperty)(a)){if(a.style.gridTemplateColumns=a.userGivenStyles.gridTemplateColumns,a.style.gridTemplateRows=a.userGivenStyles.gridTemplateRows,isNaN(a.userGivenStyles.width)){for(u=a.style.gridColumnStart,d=a.style.gridColumnEnd,u=m.col.nameToLineMap[u],d=m.col.nameToLineMap[d],n=u,s=0;n<d;n++)s+=f[n].calculatedStyle.baseSize;a.style.width=s}if(isNaN(a.userGivenStyles.height)){for(c=a.style.gridRowStart,h=a.style.gridRowEnd,c=m.row.nameToLineMap[c],h=m.row.nameToLineMap[h],n=c,l=0;n<h;n++)l+=p[n].calculatedStyle.baseSize;a.style.height=l}}return e}(e,r),2);return e};var n=i(a(223)),o=a(574),r=i(a(577)),l=a(575),s=a(578);function c(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function h(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?c(Object(a),!0).forEach((function(t){(0,n["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):c(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var u=["auto","none"],d=/minmax/,g=/(?:[^\s[\]()]+|\[[^[\]]*\]|\([^()]*\))+/g,p=function(e){return e.charAt(0).toUpperCase()+e.slice(1)},f=function(e){var t=e.style||{},a=t.gridTemplateColumns,i=t.gridTemplateRows;return!/repeat\(/g.test(a)&&!/repeat\(/g.test(i)},m=function(e){return e.split(/\(|\)/g)[1].split(",").map((function(e){return e&&e.trim()}))},b=function(e,t){var a,i,n=p(t),r="width"===t?"col":"row";return e.map((function(e){return a=e.style["gridTemplate"+p("col"===r?"columns":"rows")],i="grid"===(0,o.getDisplayProperty)(e)&&/repeat\(/g.test(a)?m(a)[1]:e.style["min"+n+"Contribution"]||e.style[t]||"auto",{start:e[r+"Start"],end:e[r+"End"],size:i}}))},v=function(e,t,a){var i,n;for(i=t.x;i<a.x;i++)for(n=t.y;n<a.y;n++)e[i][n]=!0},x=function(e,t){var a=e.gridRowStart,i=e.gridRowEnd,n=e.gridColumnStart,o=e.gridColumnEnd;if(e.gridColumn){var r=e.gridColumn.split("/").map((function(e){return e.trim()}));n=r[0],o=r[1],n=t?t.col.nameToLineMap[n]:1,/span\s+\d+/g.test(o)&&(o=n+ +o.match(/span\s+(\d+)/)[1]),o=t?t.col.nameToLineMap[o]:1}if(e.gridRow){var l=e.gridRow.split("/").map((function(e){return e.trim()}));a=l[0],i=l[1],a=t?t.row.nameToLineMap[a]:1,/span\s\d+/g.test(i)&&(i=a+ +i.match(/span\s(\d+)/)[1]),i=t?t.row.nameToLineMap[i]:1}return{gridRowStart:a,gridRowEnd:i,gridColumnStart:n,gridColumnEnd:o}},y=function(){function e(){this.setup()}var t=e.prototype;return t.setup=function(){return this._tsa=new r["default"],this.props={},this._config={mapping:{}},this},t.set=function(e,t){return this.props[e]=t,this},t.getProps=function(e){return this.props[e]},t.getConfig=function(e){return this._config[e]},t.compute=function(e){var t=e||this.props.domTree;this._sanitizeTracks(t)._sanitizeItems(t)._inflateTracks()._assignCoordinatesToCells(t)},t._sanitizeTracks=function(e){void 0===e&&(e={});var t,a=e.style,i=a.gridTemplateRows,n=a.gridTemplateColumns,o=this._config,r=function(e){var t,a=1,i=1;return e.forEach((function(e){t=x(e.style),i=Math.max(isNaN(+t.gridColumnStart)?0:+t.gridColumnStart,i,isNaN(+t.gridColumnEnd-1)?0:+t.gridColumnEnd-1),a=Math.max(isNaN(+t.gridRowStart)?0:+t.gridRowStart,a,isNaN(+t.gridRowEnd-1)?0:+t.gridRowEnd-1)})),{maxRow:a,maxColumn:i}}(e.children),l=r.maxColumn,s=r.maxRow;return this.set("maxTracks",s),t=this._fetchTrackInformation(i),o.mapping.row={nameToLineMap:t.nameToLineMap,lineToNameMap:t.lineToNameMap},o.rowTracks=t.tracks,this.set("maxTracks",l),t=this._fetchTrackInformation(n),o.mapping.col={nameToLineMap:t.nameToLineMap,lineToNameMap:t.lineToNameMap},o.colTracks=t.tracks,this},t._fetchTrackInformation=function(e){void 0===e&&(e="none");var t,a,i,n,o,r,l=e.match(g),s=[{}],c={},h={};for(i=l.filter((function(e){return!e||"string"!=typeof e||!e.length||(a=e.length,"["===e[0]&&"]"===e[a-1])})),n=l.filter((function(e){return!!e&&(a=(e+"").toLowerCase().replace(/px|fr/,""),!(!(u.indexOf(a)>=0||d.test(a))&&isNaN(a)))})).map((function(e){return function(e){if("auto"===(e=e.trim()))return e;if(!isNaN(+e))return+e;if(d.test(e)){var t=e.split(/\(|\)/g)[1].split(",");return[t[0].trim(),t[1].trim()]}return e}(e)})),a=n.length,"none"===e&&(a=this.getProps("maxTracks")),t=0;t<a;t++)o=i[t]&&i[t].replace(/\[|\]/g,"").split(" ").filter((function(e){return e.length})).map((function(e){return e.trim()}))||[t+1+""],r=i[t+1]&&i[t+1].replace(/\[|\]/g,"").split(" ").filter((function(e){return e.length})).map((function(e){return e.trim()}))||[t+2+""],s.push({start:t+1,end:t+2,size:n[t]||"auto"}),h[t+1]=o,h[t+2]=r,o.forEach((function(e){return c[e]=t+1})),r.forEach((function(e){return c[e]=t+2})),c[t+1]=t+1,c[t+2]=t+2;return{tracks:s,nameToLineMap:c,lineToNameMap:h}},t._sanitizeItems=function(e){var t,a,i,n,o,r,l,s=e||this.props.domTree,c=s.children||[],u=this._config.mapping,d=s.style.gridAutoFlow||"row",g=Object.keys(u.row.lineToNameMap).length,p=Object.keys(u.col.lineToNameMap).length,f=[],m=[],b=[[]],y=[];for(o=1;o<=g;o++)b.push([]);for(o=0,l=c.length;o<l;o++)t=x(c[o].style,u),f.push(h(h({},c[o]),{},{rowStart:u.row.nameToLineMap[t.gridRowStart],rowEnd:u.row.nameToLineMap[t.gridRowEnd],colStart:u.col.nameToLineMap[t.gridColumnStart],colEnd:u.col.nameToLineMap[t.gridColumnEnd]})),i=f[o],v(b,{x:i.rowStart,y:i.colStart},{x:i.rowEnd,y:i.colEnd});if((m=f.filter((function(e){return!e.colStart||!e.rowStart})))&&"row"===d){for(o=1;o<g;o++)for(r=1;r<p;r++)b[o][r]||y.push({row:o,col:r});for(;m.length&&y.length;)i=m.shift(),a=y.shift(),i.rowStart=a.row,i.colStart=a.col,i.rowEnd=a.row+1,i.colEnd=a.col+1;if(n=Math.ceil(m.length/p)){for(;n--;)s.style.gridTemplateRows+="auto ",u.row.nameToLineMap[g+1]=g+1,u.row.nameToLineMap[g+2]=g+2,g++,b.push([]);for(s.style.gridTemplateRows=s.style.gridTemplateRows.trim(),y=[],o=1;o<=g;o++)for(r=1;r<=p;r++)b[o][r]||y.push({row:o,col:r});for(;m.length;)i=m.shift(),a=y.shift(),i.rowStart=a.row,i.colStart=a.col,i.rowEnd=a.row+1,i.colEnd=a.col+1}}return this._config.sanitizedItems=f,this},t._inflateTracks=function(){var e,t=this._config,a=t.sanitizedItems,i=t.colTracks,n=t.rowTracks,o=0,l=0,s=this.props.domTree,c=s.style||{},h=c.paddingStart,u=c.paddingEnd,d=c.paddingTop,g=c.paddingBottom,p=c.width,f=c.height,m=new r["default"];return isNaN(+p)||(p-=h+u),e=m.clear().set("tracks",i).set("items",b(a,"width")).set("containerSize",p||"auto").resolveTracks(),i.forEach((function(t,a){t.calculatedStyle=e[a],l+=e[a].baseSize||0})),this._solveUnresolvedChildren(),isNaN(+f)||(f-=d+g),e=m.clear().set("tracks",n).set("items",b(a,"height")).set("containerSize",f||"auto").resolveTracks(),n.forEach((function(t,a){t.calculatedStyle=e[a],o+=e[a].baseSize||0})),s.style.minHeightContribution=o,s.style.minWidthContribution=l,this},t._solveUnresolvedChildren=function(e){var t,a,i,n,o,r,l,c,h=((e||this.props.domTree).unResolvedChildren||[]).filter((function(e){return/repeat\(/g.test(e.style.gridTemplateColumns)||/repeat\(/g.test(e.style.gridTemplateRows)})),u=this._config,d=u.colTracks,g=u.mapping,p=this.getProps("parent"),f=[0];if(!h.length)return this;for(a=1,i=d.length;a<i;a++)f[a]=f[a-1]+d[a].calculatedStyle.baseSize;return h.forEach((function(e){r=m(e.style.gridTemplateColumns)[1],l=g.col.nameToLineMap[e.style.gridColumnStart],c=g.col.nameToLineMap[e.style.gridColumnEnd],n=f[c-1]-f[l-1],o={itemWidth:r,width:n},t=(0,s.repeatResolver)(e,o),e.style.gridTemplateColumns=t.gridTemplateColumns,e.style.gridTemplateRows=t.gridTemplateRows,p.gridLayoutEngine(e)})),this},t._assignCoordinatesToCells=function(e){var t,a,i,n,r,s,c,h,u,d=e||this.props.domTree,g=this._config,p=g.sanitizedItems,f=g.rowTracks,m=g.colTracks,b=d.style,v=b.justifyItems,x=b.alignItems,y=b.paddingStart,C=b.paddingTop,k=[y],S=[C];for(i=1,a=f.length;i<a;i++)k[i]=k[i-1]+f[i].calculatedStyle.baseSize;for(i=1,a=m.length;i<a;i++)S[i]=S[i-1]+m[i].calculatedStyle.baseSize;return d.layout={x:0,y:0,width:isNaN(d.style.width)?S[S.length-1]:d.style.width,height:isNaN(d.style.height)?k[k.length-1]:d.style.height},(d.children||[]).forEach((function(e,a){switch(t=p[a],n=S[t.colEnd-1]-S[t.colStart-1],r=k[t.rowEnd-1]-k[t.rowStart-1],s=isNaN(+e.style.width)?n:+e.style.width,c=isNaN(+e.style.height)?r:+e.style.height,v||e.style.justifySelf){case l.CENTER:h=S[t.colStart-1]+n/2-s/2;break;case l.END:h=S[t.colEnd-1]-s;break;case l.STRETCH:s=n,h=S[t.colStart-1];break;default:h=S[t.colStart-1]}switch(x||e.style.alignSelf){case l.CENTER:u=k[t.rowStart-1]+r/2-c/2;break;case l.END:u=k[t.rowEnd-1]-c;break;case l.STRETCH:c=r,u=k[t.rowStart-1];break;default:u=k[t.rowStart-1]}h+=(0,o.pluckNumber)(t.style.paddingStart,t.style.padding,0),u+=(0,o.pluckNumber)(t.style.paddingTop,t.style.padding,0),e.layout={x:h,y:u,x2:h+s,y2:u+c,width:s,height:c}})),this},e}(),C=function(e,t){void 0===e&&(e="");var a=(e.match(g)||[]).filter((function(e){return e&&!!e.trim()})),i="",n=1;return a.length&&!/repeat\(/.test(e)?a.forEach((function(e){u.indexOf(e)>-1||/[0-9]fr/.test(e)||d.test(e)||!isNaN(e)?(i+=t[n].calculatedStyle.baseSize+" ",n++):i+=e+" "})):t.forEach((function(e){isNaN(e.calculatedStyle.baseSize)||(i+=e.calculatedStyle.baseSize+" ")})),i.trim()}},577:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(223));function o(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function r(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?o(Object(a),!0).forEach((function(t){(0,n["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):o(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var l=function(e){return+e.replace(/fr/,"")},s=function(){function e(e,t,a){return void 0===e&&(e=[]),void 0===t&&(t=[]),void 0===a&&(a=600),this.clear(),this.set("tracks",e),this.set("items",t),this.set("containerSize",a),this}var t=e.prototype;return t.set=function(e,t){switch(this.props[e]=t,e){case"tracks":this._initTrackSize();break;case"items":this._initItems();break;case"containerSize":this.props[e]=isNaN(+t)?0:+t}return this},t.get=function(e){return this.props[e]},t._initTrackSize=function(e){var t,a,i,n,o,s,c,h=e||this.props.tracks||[],u=this._config,d=[{}];for(u.frTracks=[],u.intrinsicTracks=[],t=1,a=h.length;t<a;t++)i=h[t].size,o=1,Array.isArray(i)?(s=+i[0]||0,i[1].indexOf("fr")>0||i[0].indexOf("fr")>0?(c=Infinity,u.frTracks.push(t),n="minmax"):"auto"===i[1]||"auto"===i[0]?(c=Infinity,u.intrinsicTracks.push(t),n="minmax"):isNaN(+i[0])||isNaN(+i[1])||(c=Math.max(+i[0],+i[1]),s=Math.min(+i[0],+i[1]),u.intrinsicTracks.push(t),n="minmax")):isNaN(+i)?i.indexOf("fr")>0?(s=0,c=Infinity,u.frTracks.push(t),n="flex",o=l(i)):(s=0,c=Infinity,n="intrinsic",u.intrinsicTracks.push(t)):(s=c=+i,n="fixed"),d.push(r(r({},h[t]),{},{type:n,multiplier:o,baseSize:s,growthLimit:c}));return u.sanitizedTracks=d},t._initItems=function(e){var t,a,i,n,o=e||this.props.items||[],l=this._config,s=[],c=0;for(i=0,n=o.length;i<n;i++)isNaN(o[i].start)||isNaN(o[i].end)?l.autoFlow.push(o[i]):(s.push(r({},o[i])),a=s[c],c++,a.size=isNaN(a.size)?this._getParentSize(a):+a.size);for(s.sort((function(e,t){var a=e.end-e.start,i=t.end-t.start;return a===i?e.start-t.start:a-i})),i=0,t=n=s.length;i<n;i++)if(s[i].end-s[i].start>1){t=i;break}return this._config.nonSpanningItemStartIndex=t,this._config.sanitizedItems=s},t._getParentSize=function(e){var t=this._config.sanitizedTracks,a=0;return t.filter((function(t){return t.start>=e.start&&t.end<=e.end})).forEach((function(e){return a+=e.baseSize})),a||0},t.resolveTracks=function(){return this._placeNonSpanningItems()._placeSpanningItems()._distributeFreeSpace(),this._config.sanitizedTracks},t._placeNonSpanningItems=function(){var e,t,a=this._config,i=a.sanitizedItems,n=a.sanitizedTracks,o=a.nonSpanningItemStartIndex;return i.slice(0,o).forEach((function(a){t=a.start,"fixed"!==(e=n[t]).type&&(e.baseSize=Math.max(e.baseSize,a.size),e.growthLimit=Math.max(e.growthLimit,e.baseSize))})),this},t._placeSpanningItems=function(){var e,t,a,i,n,o,r,l=this._config,s=l.sanitizedItems,c=l.sanitizedTracks,h=l.nonSpanningItemStartIndex,u=l.frTracks,d=s.slice(h),g=[0];if(!d.length)return this;for(o=1,r=c.length;o<r;o++)g[o]=g[o-1]+(c[o].baseSize||0);return d.forEach((function(r){if(e=g[r.end-1]-g[r.start-1],t=Math.max(0,r.size-e)){for(o=r.start,n=!1,i=0;o<r.end;o++)u.indexOf(o)>=0&&(n=!0),"fixed"!==c[o].type&&i++;if(i&&!n)for(a=t/i,o=r.start;o<r.end;o++)"fixed"!==c[o].type&&(c[o].baseSize+=a)}})),this},t._distributeFreeSpace=function(){var e=this._config,t=e.frTracks,a=e.intrinsicTracks,i=e.sanitizedTracks,n=this.props.containerSize,o=0;return i.forEach((function(e){return o+=e.baseSize||0})),o<n&&(t.length?(t.forEach((function(e,a){t[a]=i[e]})),t.forEach((function(e){return o-=e.baseSize})),function r(e,t,a){var i,n,o=0;if(e.length){if(e.forEach((function(e){return o+=e.multiplier})),i=(a-t)/o,(n=e.filter((function(e){return e.baseSize<=e.multiplier*i}))).length<e.length)return e.filter((function(e){return e.baseSize>e.multiplier*i})).forEach((function(e){return t+=e.baseSize})),r(n,t,a);n.forEach((function(e){return e.baseSize=e.multiplier*i}))}}(t,o,n)):a.length&&(a.forEach((function(e,t){a[t]=i[e]})),function(e,t,a){var i,n,o,r,l,s,c,h=0;if(e.length){for(i=a-t,(l=e.filter((function(e){return"minmax"===e.type&&e.growthLimit!==Infinity}))).sort((function(e,t){return e.growthLimit-e.baseSize-(t.growthLimit-t.baseSize)})),r=l.length;h<r&&i;)for(n=i/(l.length-h||1),o=0,r=l.length;o<r;o++)s=l[o].growthLimit,i-=(c=Math.min(n+l[o].baseSize,s))-l[o].baseSize,l[o].baseSize=c,s!==c||l[o].frozen||(l[o].frozen=!0,h++);e=e.filter((function(e){return"minmax"===e.type&&e.growthLimit===Infinity||"minmax"!==e.type})),n=i/e.length,e.forEach((function(e){return e.baseSize+=n}))}}(a,o,n))),this},t.clear=function(){return this.props={},this._config={frTracks:[],intrinsicTracks:[],autoFlow:[]},this},e}();t["default"]=s},578:function(e,t,a){"use strict";t.__esModule=!0,t.repeatResolver=function(e,t){var a,i,n,o=e.children,r=0,l=0,s="",c="",h=0,u=t.itemWidth,d=t.width;for(d=isNaN(+d)?0:+d,o.forEach((function(e){return h=Math.max(h,+e.style.height||0)})),r+=u=+u,s+=u+" ",l=1,i=1,n=o.length;i<n&&!(r+u>d);i++)r+=u,s+=u+" ";for(l=i,a=Math.ceil(n/l);a--;)c+=h+" ";return{gridTemplateColumns:s.trim(),gridTemplateRows:c.trim()}}},579:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=t.drawLabel=void 0;var n=i(a(238)),o=i(a(538)),r=a(224),l=a(232),s=i(a(580)),c=r.preDefStr.visibleStr,h=r.preDefStr.hiddenStr,u=r.preDefStr.POSITION_MIDDLE,d=r.preDefStr.POSITION_START,g=r.preDefStr.POSITION_END,p=Math,f=p.min,m=p.max,b=function(e,t){var a,i,n,o,l,s,p,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P,_,D,I=this.getFromEnv("chart"),M=this.getFromEnv("toolTipController"),O=I.config,R=this.config,B=R.JSONData,V=this.getFromEnv("animationManager"),z=I.getChildren("canvas")[0].config,G=I.config.dataLabelStyle,H=B.data,W=I.config.categories,j=I.config.is3D,U=I.config.isstacked,q=W&&W.length,Y=H&&H.length,X=this.getData(),K=I.getFromEnv("smartLabel"),Z=z.yDepth,J=z.xDepth,$=I.getFromEnv("number-formatter"),Q=r.BLANKSTRING,ee=O.placevaluesinside,te=O.canvasWidth,ae=O.canvasLeft,ie=this.getContainer("labelGroup"),ne=this.getSkippingInfo&&this.getSkippingInfo(),oe=ne&&ne.skippingApplied,re=ne&&ne.labelDraw||[],le=re.length,se=(0,r.pluckNumber)(e,0),ce=(0,r.pluckNumber)(t,oe?le:q<Y?q:Y),he=le===Math.abs(ce-(se+1)),ue=this.getState("visible"),de=function(){this.hide()};for(ue&&ie.show(),K.setStyle(G),l=se;l<ce;l++)L=(E=(i=X[o=oe&&he?re[l]:l])&&i.config)&&E.setValue,void 0!==i&&null!=L&&!0!==E.labelSkip?(p=i.graphics)&&(s=H[o],S=i._yPos,w=i._xPos,L=$.getCleanValue(s.value),k=(0,r.pluckNumber)(L)<0,b=i._height,A=i._width,v=E.valuePadding+2,N=U?u:k?ee?d:g:ee?g:d,Q=E.displayValue,_=p.label,E.showValue&&null!=Q&&Q!==r.BLANKSTRING&&null!==L?(n={text:Q,fill:(a=E.dataLabelStyle).color,"text-bound":[a.backgroundColor,a.borderColor,G.borderThickness,G.borderPadding,G.borderRadius,G.borderDash],"line-height":G.lineHeight,visibility:this.getState("visible")?c:h},F=K.getOriSize(Q).width,F+=v,T=v,x=S+.5*b,y=w+(k?0:A),C=k?w-ae:ae+te-(w+A),U?(y=m(ae+.5*F,y+=.5*(k?A:-A)),y=f(ae+te-.5*F,y),y-=j?J:0,x+=j?Z:0):ee?A>=F?(y+=k?T:-T,j&&(x+=Z,y-=J)):F<C?(y+=k?-T:T,N=k?g:d,j&&k&&(y-=J)):(k?(y=w+A+m(F-w-A+ae,0)-T,N=g):(y=w-m(F-(ae+te-w),0)+T,N=d),j&&(y-=J,x+=Z)):C>=F?(y+=k?-T:T,j&&k&&(y-=J,x+=J)):(y+=k?T+F:-(T+F),j&&(y-=J,x+=Z)),(y>ae+te||y<ae)&&(y=ae+4,N=d),n["text-anchor"]=N,n.x=y,n.y=x,n.opacity=ue?1:0,(P=V.setAnimation({el:_||"text",container:ie,component:this,attr:n,callback:!ue&&de,label:"plotLabel"})).outlineText(R.showTextOutline,n.fill),O.showtooltip&&P.abbrArr&&P.abbrArr.length&&M.enableToolTip(P,void 0),_||(p.label=P)):p.label&&(p.label=V.setAnimation({el:p.label,component:this}))):((D=i&&i.graphics)&&D.label&&D.label.hide(),E&&delete E.labelSkip);this.config.labelDrawn=!0};t.drawLabel=b,(0,l.addDep)({name:"barAnimation",type:"animationRule",extension:s["default"]});var v=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"bar2D"},a.drawLabel=function(){var e=this.config;b.call(this,e.scrollMinValForLabel,e.scrollMaxValForLabel)},t}(o["default"]);t["default"]=v},580:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=a(224),o={"initial.dataset.bar2D":function(){var e=this,t=e.getFromEnv("chart"),a=t.config.yDepth||0,i=e.getFromEnv("yAxis");return{"rect.appearing":function(o){var r,l,s,c,h=i.getPixel(i.getAxisBase())+(t.isBar?-a:a),u=o.index,d=e.components.data[u],g=o.attr;return r=g.x,l=g.width,c=Math.sign(r+l/2-h),s=1===c?r:r+l,d._posWRT0=c,[{initialAttr:function(){var e={};return e.x=s,e.width=0,e.opacity=0,e},finalAttr:{opacity:1},startEnd:function(){var t=o.length;return n.animHelperFN.getTimeByValue(n.animHelperFN.animByWeight(u,t,.6),{startPx:h,endPx:1===c?e.config.yAxisMaxPixel:e.config.yAxisMinPixel},{startPx:s,endPx:1===c?g.x+g.width:g.x})},hookFn:function(){this.attr({opacity:1})},effect:"linear",slot:"plot"}]},"plotLabel.appearing":function(){return[{initialAttr:{opacity:0},slot:"final"}]},"*":null}},"legendInteraction.dataset.bar2D":i(a(539))["default"]["legendInteraction.dataset.column"]};t["default"]=o},588:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t.trimData=K,t.hideFn=t.plotClickHandler=t.labelClickFn=t.plotGraphicClick=t["default"]=void 0;var n,o=i(a(223)),r=i(a(242)),l=i(a(238)),s=i(a(556)),c=a(538),h=a(224),u=a(232),d=i(a(589)),g=i(a(332)),p=a(236),f=i(a(318)),m=a(590);function b(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function v(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?b(Object(a),!0).forEach((function(t){(0,o["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):b(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var x=(0,u.getDep)("redraphael","plugin"),y=window,C=y.document,k=!h.hasSVG,S="createTouch"in C,w=S&&!(y.navigator.maxTouchPoints||y.navigator.msMaxTouchPoints),A=Math,L=A.atan2,N=A.sin,F=A.cos,T=A.max,E=A.min,P=A.abs,_=A.floor,D=A.PI,I=180/A.PI,M=2*D,O=function(e){var t,a,i,n=[[],[],[],[]];for(t=0,a=e.length;t<a;t++)i=(0,m.getCleanAngle)(e[t].point.config.angle),n[(0,m.getQuadrant)(i)].push({point:e[t].point,angle:i});return n},R=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:e},container:t,component:a,label:"group"})},B=function(e,t){var a=t?1:n;return(0,h.toRaphaelColor)({color:(0,h.getFirstColor)(e.color,a),alpha:(0,h.getFirstAlpha)(e.alpha,a)})},V=function(e,t,a,i,n){return L((t-a[1]-i.top)/n,e-a[0]-i.left)},z=function(e,t){return function(a){!t.data("plotItem").seriesData.isRotating&&e.plotGraphicClick.call(t,a)}},G=function(e){return function(t){var a,i,n,o,r,l,s,c,h,u,d,g,p,f=this.element||this,m=f.plotItem||f.data("plotItem"),b=f.data("eventArgs")||{},v=m.chart,x=e.getFromEnv("animationManager"),y=m.index,C=e.config,k=C.enableMultiSlicing,A=e.components.data[y],L=A.graphics,N=A.config,F=N.doNotSlice,T=N.slicedTranslation;if(!C.isRotating&&t&&v.plotEventHandler(f,t),!(C.isRotating||C.singletonCase||F)&&v.config&&(i=!k&&e.sliceInOtherPies(y),!(l=N.sliced)||!i)){if(S&&!w){if(d=(new Date).getTime(),m.lastSliceTimeStamp&&d-m.lastSliceTimeStamp<400)return;m.lastSliceTimeStamp=d}return n=L.element,h=L.connector,o=L.label||L.dataLabel,r=L.innerLabel,T="object"==typeof T?"t"+T:T,u=N.connectorPath,s=(l?-1:1)*N.transX,c=(l?-1:1)*N.transY,g=n.data("eventArgs")||n.data("eventArgs",{}),v.fireChartInstanceEvent("slicingStart",{slicedState:l,dataIndex:"index"in b&&b.index,data:e.getPlotData(y,l)}),x.setAnimationState("slicing"),x.setAnimation({el:n,attr:{transform:l?"t0,0":T},component:e,label:"slice",callback:function(){v.fireChartInstanceEvent("slicingEnd",{slicedState:l,dataIndex:"index"in b&&b.index,data:e.getPlotData(y,!l)})}}),o&&o.x&&((a=o.data("textPos"))||(a=o.data("textPos",{x:o.x,y:o.y})),x.setAnimation({el:o,attr:{x:o.x+(l?0:s),y:o.y+(l?0:c)},label:"label-sliced",component:e}),a.x=o.x+(l?0:s)),r&&x.setAnimation({el:r,attr:{x:r.x+(l?0:s),y:r.y+(l?0:c)},label:"label-sliced",component:e}),h&&u&&((p=u.slice(0))[1]+=s,p[2]+=c,p[4]+=s,p[5]+=c,p[6]+=s,p[7]+=c,x.setAnimation({el:h,attr:{path:p},label:"connector-sliced",component:e}),N.connectorPath=p),g.isSliced=l=N.sliced=!l,l}}},H=function(e){var t=e.getFromEnv("animationManager");return{plotDragMove:function(t){var a,i=this.data("plotItem"),n=i.chart,o=t.data,r=o[0],l=o[1],s=o[2],c=o[3],h=i.seriesData,u=e.config;isNaN(r)||isNaN(l)||!u.enableRotation||h.singletonCase||h.isRightClicked||(a=V.call(t,s,c,h.pieCenter,h.chartPosition,1),h.dragStartAngle===a||h.isRotating||(h.isRotating=!0,n.fireChartInstanceEvent("RotationStart",{startingAngle:h._rotationalStartAngle=n._startingAngle()})),u.startAngle+=a-h.dragStartAngle,h.dragStartAngle=a,h.moveDuration=0,u.updateInited||(u.updateInited=!0,n.addJob("pie_batch_rotate",n._batchRotate||(n._batchRotate=function(){e._rotate(),u.updateInited=!1}),p.priorityList.draw,{oneInAFrame:!0})))},plotDragStart:function(t){var a,i=this.data("plotItem"),n=i.chart,o=i.seriesData,r=e.config,l=(0,h.pluckNumber)(t.button,t.originalEvent.button),s=-r.startAngle*I,c=t.data[0],u=t.data[1];o.isRightClicked=!(h.touchEnabled||0===l||1===l),r.enableRotation&&!o.isRightClicked&&(o.isRotating=!1,o.chartPosition=function(e,t){var a,i={left:0,top:0},n=e;if(n.getBoundingClientRect)a=n.getBoundingClientRect(),i.top=a.top+(y.pageYOffset||C.scrollTop||0)-(C.clientTop||0),i.left=a.left+(y.pageXOffset||C.scrollLeft||0)-(C.clientLeft||0);else for(;n;)i.left+=n.offsetLeft||0,i.top+=n.offsetTop||0,n===C.body||n===C.documentElement||t||(i.left-=n.scrollLeft||0,i.top-=n.scrollTop||0),n=n.offsetParent;return i}(n.getFromEnv("chart-container")),a=V.call(t,c,u,o.pieCenter,o.chartPosition,1),o.dragStartAngle=a,o.startingAngleOnDragStart=s)},plotDragEnd:function(){var t=this.data("plotItem"),a=t.chart,i=a.getChildren("dataset")[0].config,n=a.config,o=t.seriesData,r=-i.startAngle*I;o.isRightClicked||(n.clicked=!0,a.disposed||e._rotate(),delete n.clicked,o.isRotating&&(setTimeout((function(){o.isRotating=!1}),0),a.fireChartInstanceEvent("RotationEnd",{startingAngle:(0,h.normalizeAngle)(r,!0),changeInAngle:r-i.startingAngleOnDragStart})),!o.isHovered&&e.config.handlersAPI.onPlotHover(this,!1))},plotRollOver:function(e){var t=this.plotItem||this.data("plotItem"),a=t.chart,i=t.seriesData,n=a.getDatasets()[0],o=n.getFromEnv("animationManager");i.isRotating||(a.plotEventHandler(this,e,"DataPlotRollOver"),n.config.handlersAPI.onPlotHover(this,!0,o)),n.fireEvent("datasetrollover",t),i.isHovered=!0},plotRollOut:function(e){var t=this.plotItem||this.data("plotItem"),a=t.chart,i=t.seriesData,n=a.getDatasets()[0];i.isRotating||(a.plotEventHandler(this,e,"DataPlotRollOut"),n.config.handlersAPI.onPlotHover(this,!1)),n.fireEvent("datasetrollout",t),i.isHovered=!1},onPlotHover:function(a,i){var n=a.data("plotItem"),o=n.center,r=n.rolloverProperties||{},l=i?r.color:n.color,s=i?r.borderWidth:n.borderWidth,c=i?r.borderColor:n.borderColor;l&&(i&&(l.cx=o[0],l.cy=o[1],l.r=n.radius),r.enabled&&t.setAnimation({el:n.graphic,component:e,attr:{fill:(0,h.toRaphaelColor)(l),"stroke-width":s,stroke:c}}))}}},W=function(e,t){return e.point.config.value-t.point.config.value},j=function(e,t){return e.angle-t.angle},U=function(e,t){t&&e.getFromEnv("linkClickFN")&&e.getFromEnv("linkClickFN").call({link:t},!0)},q=function(){this.remove()},Y=[1,1,-1,-1],X=[1,-1,-1,1];function K(e){if(this.config.JSONData){var t,a,i,n,o=this.getFromEnv("legend"),r=this.config.JSONData,l=r.data&&r.data.length,s=e.data&&e.data.length||0,c=l-s;for(c>0&&this.removeData(s,c,!1),t=0,a=(i=this.components.removeDataArr||[]).length;t<a;t++)(n=i[t].config).legendItemId&&o.disposeItem(n.legendItemId)}}t.hideFn=function(){this.hide()},t.labelClickFn=U,t.plotGraphicClick=G,t.plotClickHandler=z,(0,u.addDep)({name:"pie2dAnimation",type:"animationRule",extension:d["default"]}),(0,g["default"])(x);var Z=function(e){function t(){var t;return(t=e.call(this)||this).plotGraphicClick=G((0,r["default"])(t)),t}(0,l["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"pie2D"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.doughnutradius=0},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,i,o,r,l=this.getFromEnv("chart"),s=l.config,u=this.config,d=this.config.JSONData,g=this.getFromEnv("chart-attrib"),p=l.config.is3D,f=/pie/.test(this.getName());u.handlersAPI=H(this),this.setState("visible",1===(0,h.pluckNumber)(this.config.JSONData.visible,!Number(this.config.JSONData.initiallyhidden),1)),(0,h.parseConfiguration)({},this.config,l&&l.config),r=u.enableAnimation=(0,h.pluckNumber)(g.animation,g.defaultanimation,1),u.animation=!!r&&{duration:1e3*(0,h.pluckNumber)(g.animationduration,g.moveduration,1)},u.transposeAnim=!(!r&&!(0,h.pluckNumber)(u.transposeanimation,1))&&{duration:1e3*(0,h.pluckNumber)(g.transposeanimduration,.2)},u.showPlotBorder=(0,h.pluckNumber)(g.showplotborder,1),u.usePattern=(0,h.pluckNumber)(s.usePattern,0),u.patternType=c.PATTERN_TYPES.includes(d.patterntype)?d.patterntype:s.patternType,u.patternDensity=(0,h.pluckNumber)(d.patterndensity,s.patternDensity),u.patternAlpha=(0,h.pluckNumber)(d.patternalpha,s.patternAlpha),u.patternBgColor=(0,h.pluck)(d.patternbgcolor,u.patternBgColor),u.showHoverEffect=(0,h.pluckNumber)(g.plothovereffect,g.showhovereffect,n),u.usePattern&&(u.showHoverEffect=0),u.showTooltip=(0,h.pluckNumber)(g.showtooltip,1),u.toolText=(0,h.getValidValue)((0,h.parseUnsafeString)((0,h.pluck)(d.plottooltext,g.plottooltext),!1)),o=u.enableMultiSlicing=(0,h.pluckNumber)(g.enablemultislicing,1),a=u.use3DLighting=(0,h.pluckNumber)(g.use3dlighting,1),u.usePattern&&(a=u.use3DLighting=0),t=u.radius3D=a?(0,h.pluckNumber)(g.radius3d,90):100,u.showZeroPies=(0,h.pluckNumber)(g.showzeropies,1),u.showPercentInToolTip=(0,h.pluckNumber)(g.showpercentintooltip,1),u.showLabels=(0,h.pluckNumber)(g.showlabels,1),u.showTextOutline=(0,h.pluckNumber)(g.textoutline,0),u.labelFontColor=(0,h.pluck)(d.labelfontcolor,g.labelfontcolor,s.labelfontcolor),u.labelFont=(0,h.pluck)(d.labelfont,g.labelfont,s.basefont),u.showValues=(0,h.pluckNumber)(d.showvalues,g.showvalues,1),u.showPercentValues=(0,h.pluckNumber)(g.showpercentvalues,g.showpercentagevalues,0),i=u.toolTipSepChar=(0,h.pluck)(g.tooltipsepchar,g.hovercapsepchar,h.COMMASPACE),u.labelSepChar=(0,h.parseUnsafeString)((0,h.pluck)(g.labelsepchar,i)),u.pieBorderColor=(0,h.pluck)(g.plotbordercolor,g.piebordercolor),u.pieBorderAlpha=(0,h.pluckNumber)(g.plotborderalpha,g.pieborderalpha),u.pieBorderThickness=u.showPlotBorder?(0,h.pluckNumber)(g.plotborderthickness,g.pieborderthickness,s.plotborderthickness,1):0,u.plotDashLen=(0,h.pluckNumber)(g.plotborderdashlen,5),u.plotDashGap=(0,h.pluckNumber)(g.plotborderdashgap,4),u.showValueInLegend=(0,h.pluckNumber)(g.showvalueinlegend,0),u.showLabelInLegend=(0,h.pluckNumber)(g.showlabelinlegend,1),u.valueBeforeLabelInLegend=(0,h.pluckNumber)(g.valuebeforelabelinlegend,0),u.showValueAsPercentInLegend=(0,h.pluckNumber)(g.showvalueaspercentinlegend,1),u.legendSepChar=(0,h.pluck)(g.legendsepchar,", "),u.showvalues=(0,h.pluckNumber)(g.showvalues,1),u.chartPosition=(0,h.getPosition)(l.getFromEnv("chart-container"),l),u.timerThreshold=30,t>100&&(t=100),t<0&&(t=0),u.showLegend=(0,h.pluckNumber)(g.showlegend,0),u.reverselegend=!(0,h.pluckNumber)(g.reverselegend,0),l.config.is3D=p,u.pieYScale=(0,h.pluckNumber)(g.pieyscale,40),u.pieYScale<1&&(u.pieYScale=1),u.pieYScale>=100&&(u.pieYScale=80),u.pieYScale/=100,u.pieSliceDepth=(0,h.pluckNumber)(g.pieslicedepth,15),u.pieSliceDepth<1&&(u.pieSliceDepth=1),u.managedPieSliceDepth=u.pieSliceDepth,u.enableMultiSlicing=!!o,u.startAngle=(0,h.pluckNumber)(g.startingangle,0)%360*(-D/180),u.usePerPointLabelColor=g.colorlabelsfromplot===h.ONESTRING,u.reversePlotOrder=(0,h.pluckNumber)(g.reverseplotorder,0),u.animateClockWise=(0,h.pluckNumber)(g.animateclockwise,u.reversePlotOrder),u.showShadow=(0,h.pluckNumber)(g.showshadow,1),u.innerLabelRadiusPercent=(0,h.pluckNumber)(g.innerlabelradiuspercent,67)/100,u.minAngleForValue=(0,h.pluckNumber)(g.minangleforvalue,0)*(D/180),u.minAngleForLabel=(0,h.pluckNumber)(g.minangleforlabel,0)*(D/180),u.singletonCase=1===d.data.length,u.labelPosition=(0,h.pluck)(g.labelposition,u.singletonCase&&f?"inside":"outside").toLowerCase(),u.valuePosition=(0,h.pluck)(g.valueposition,u.singletonCase&&f?"inside":"outside").toLowerCase(),u.valueTotal=0,this._setConfigure(),s.showLegend&&this._addLegend()},a.trimData=function(e){K.call(this,e)},a._parseDisplayProperties=function(e,t){var a,i,o,r,l,s,c,u,d,g,p,f,m=h.BLANKSTRING,b=this.getFromEnv("chart"),v=this.getFromEnv("number-formatter"),x=b.getFromEnv("chart-attrib"),y=this.config,C=(0,h.pluckNumber)(t.y,v.getCleanValue(e.value,!0)),k=y.valueTotal,S=y.showLabels,w=(0,h.parseUnsafeString)((0,h.pluck)(t.seriesName,e.label,e.name,h.BLANKSTRING)),A=y.showPercentValues,L=y.showPercentInToolTip,N=y.labelSepChar,F=y.toolTipSepChar,T=y.showTooltip;a=(0,h.getValidValue)((0,h.parseUnsafeString)((0,h.pluck)(e.tooltext,y.toolText),!1)),i=t.pValue=v.percentValue(C/k*100),r=t.value=v.dataLabels(C)||h.BLANKSTRING,d=t.showLabel=(0,h.pluckNumber)(e.showlabel,S),g=t.showValue=(0,h.pluckNumber)(e.showvalue,y.showValues),t.labelFontColor=(0,h.pluck)(e.labelfontcolor,y.labelFontColor),t.labelFont=(0,h.pluck)(e.labelfont,y.labelFont),l=t.labelText=1===d?w:h.BLANKSTRING,s=t.valueText=1===g?1===A?i:r:h.BLANKSTRING,o=L?i:r,c=(0,h.getValidValue)((0,h.parseUnsafeString)(e.displayvalue)),t.labelPosition=(0,h.pluck)(e.labelposition,y.labelPosition).toLowerCase(),t.valuePosition=(0,h.pluck)(e.valueposition,y.valuePosition).toLowerCase(),p=(0,h.pluckNumber)(e.minangleforlabel),isNaN(p)?t.minAngleForLabel=y.minAngleForLabel:t.minAngleForLabel=p%360*(D/180),f=(0,h.pluckNumber)(e.minangleforvalue),isNaN(f)?t.minAngleForValue=y.minAngleForValue:t.minAngleForValue=f%360*(D/180),t.innerLabelRadiusPercent=(0,h.pluckNumber)(e.innerlabelradiuspercent,y.innerLabelRadiusPercent),u=(0,h.pluck)(c,w+N+(A?i:r),h.BLANKSTRING),c!==n&&g?(s=t.labelText=c,t.valueText=h.BLANKSTRING):s=s!==h.BLANKSTRING&&l!==h.BLANKSTRING?l+N+s:(0,h.pluck)(l,s),T&&(m=a!==n?(0,h.parseTooltext)(a,[1,2,3,5,6,7,14,24,25],{formattedValue:r,label:w,yaxisName:(0,h.parseUnsafeString)(x.yaxisname),xaxisName:(0,h.parseUnsafeString)(x.xaxisname),percentValue:i,sum:v.dataLabels(k),unformattedSum:k},e,x):(m=w)!==h.BLANKSTRING?m+F+o:o),t.displayValue=s,t.displayValueArgs=u,t.toolText=m,t.seriesName=w,t.categoryLabel=w,t.id=e.id?e.id:w},a._isStyled=function(e){if(this.getFromEnv("chart").config.usedataplotcolorforlabels||e.labelbordercolor||e.labelbgcolor||e.labelborderthickness||e.labelborderalpha||e.labelalpha||e.labelfont||e.labelfontsize||e.labelfontcolor||e.labelfontalpha||e.labelalpha||e.labelfontbold||e.labelfontitalic||e.labelborderpadding||e.labelborderradius||e.labelbgalpha||e.labelborderdashed||e.labelborderdashlen||e.labelborderdashgap)return!0},a._setConfigure=function(e,t){var a,i,o,r,l,s,u,d,g,p,m,b,v,x,y,C,k,S,w,A=this.components,L=A.removeDataArr=A.removeDataArr||[],N=this.getFromEnv("chart"),F=N.getFromEnv("dataSource").chart,E=N.config,P=this.config,_=this.config.JSONData,D=(e||_).data,I=D&&D.length,M=P.showZeroPies,O=P.valueTotal||0,R=[],B=(0,h.pluckNumber)(F.plotborderdashed,0),V=this.components.data||(this.components.data=[]),z=this.getFromEnv("number-formatter"),G=this.getFromEnv("color-manager"),H=P.labelInLeg,W=P.valInLeg,j=P.pieBorderThickness,U=P.reversePlotOrder,q=P.radius3D,Y=P.enableMultiSlicing,X=P.lastSlicedid||0,K=(0,h.pluckNumber)(F.plotBorderDashed,5),Z=(0,h.pluckNumber)(F.plotborderdashgap,4),J=(0,h.pluckNumber)(F.valuebeforelabelinlegend,0),$=(0,h.pluckNumber)(F.showvalueaspercentinlegend,1),Q=0,ee=[],te=(0,h.pluck)(F.legendsepchar,", ");for(E.dataLabelStyle=h.parsexAxisStyles.apply(this,[{},{},F,E.dataLabelStyle,o]),a=0;a<I;a+=1)x=D[a],null===(k=z.getCleanValue(x.value,!0))||!M&&0===k?Q+=1:(R.push(x),ee.push(a),O+=k);if(!P.singletonCase&&(P.singletonCase=I-Q==1),Q&&V.length>I-Q)for(a=V.length-1;Q>0;a-=1,Q-=1)V[a]&&(S=(x=V[a]).config,L.push(x),S.y=null);for(0===O&&(R=[]),P.valueTotal=O,P.dataLabelCounter=0,E.allPlotSliceEnabled=E.enableslicing,a=(I=R.length)-1;a>=0;a-=1)y=a,e?(w=R[a],x=t!==n?V[y=t+a]:V[y=V.length-I+a]):(x=V[a]||(V[a]={graphics:{},config:{}}),w=R[a]),(C=x&&x.config)||(C=V[y].config={}),x.graphics||(V[y].graphics={}),C.y=k=z.getCleanValue(w.value,!0),C.seriesName=i=(0,h.parseUnsafeString)((0,h.pluck)(w.label,w.name,h.BLANKSTRING)),C.labellink=(0,h.pluck)(w.labellink,F.labellink),o=(0,h.pluck)(w.color,G.getPlotColor(ee[a])),o=(0,h.hashify)(o),r=(0,h.pluck)(w.alpha,F.plotfillalpha,h.HUNDREDSTRING),s=(l=C.borderConfig=this._parseBorderConfig(o,r,w)).setPlotBorderColor,u=l.setPlotBorderAlpha,d={opacity:T(r,u)/100},(m=Boolean((0,h.pluckNumber)(w.issliced,F.issliced,0)))&&(Y||(-1!==X&&(V[V.length-X-1].sliced=!1),P.lastSlicedid=a),P.preSliced=m),C.patternType=c.PATTERN_TYPES.includes(w.patterntype)?w.patterntype:P.patternType,C.patternAngle=(0,h.pluckNumber)(w.patternangle,F.patternangle,C.patternType===c.PATTERN_TYPES[0]?40:0),C.patternDensity=(0,h.pluckNumber)(w.patterndensity,P.patternDensity),C.patternSize=(0,h.pluckNumber)(w.patternsize,C.patternType===c.PATTERN_TYPES[0]?2:4),C.patternAlpha=(0,h.pluckNumber)(w.patternalpha,P.patternAlpha),C.patternBgColor=(0,h.pluck)(w.patternbgcolor,P.patternBgColor),v=(b=(0,h.pluckNumber)(w.dashed,B))?(0,h.getDashStyle)((0,h.pluck)(w.dashlen,K),(0,h.pluck)(w.dashgap,Z),j):"none",this._parseDisplayProperties(w,C),g=H?i:h.BLANKSTRING,W&&(p=$?z.legendPercentValue(k/O*100):z.legendValue(k),g=J?p+(g&&te+g):(g&&g+te)+p),P.dataLabelCounter+=1,this._isStyled(w)?C.style=h.parsexAxisStyles.apply(this,[w,{},F,E.dataLabelStyle,o]):C.style&&delete C.style,C.showInLegend=g!==h.BLANKSTRING,C.isVisible=!0,C.name=g,C.shadow=d,C.setColor=o,C.setAlpha=r,C.color=(0,f["default"])(o,r,q,P.doughnutradius),C._3dAlpha=r,C.borderColor=(0,h.convertColor)(s,u),C.borderWidth=j,C.link=(0,h.getValidValue)(w.link),C.sliced=m,C.dashStyle=v,C.setBorderDashed=b,(C.doNotSlice=(0,h.pluck)(w.enableslicing,E.enableslicing)!==h.ONESTRING)||E.allPlotSliceEnabled!==h.ZEROSTRING||(E.allPlotSliceEnabled=h.ONESTRING),this._parseHoverEffectOptions(a),C.centerLabelConfig=void 0,C.radius3D=q;U&&V&&V.reverse(),P.dataArr=R,P.enableRotation=V.length>1?(0,h.pluckNumber)(F.enablerotation,1):0},a._parseHoverEffectOptions=function(e){var t,a,i,o,r,l,s,c,u,d,g=this.getFromEnv("chart").getFromEnv("dataSource").chart,p=this.config,f=this.components.data[e].config,m=this.config.JSONData,b=m.data[e],v=f.setColor,x=f._3dAlpha,y=p.radius3D,C=f.borderConfig,k=C.setPlotBorderAlpha,S=C.setPlotBorderColor,w=p.setBorderWidth,A=p.usePattern?0:(0,h.pluckNumber)(f.hovereffect,p.showHoverEffect),L=f.hoverEffects={enabled:A};if(A!==n||p.usePattern||(A=L.enabled=(0,h.pluck)(b.hovercolor,m.hovercolor,g.plotfillhovercolor,b.hoveralpha,m.hoveralpha,g.plotfillhoveralpha,b.borderhovercolor,m.borderhovercolor,g.plotborderhovercolor,b.borderhoveralpha,m.borderhoveralpha,g.plotborderhoveralpha,g.plotfillhoveralpha,b.borderhoverthickness,m.borderhoverthickness,g.plotborderhoverthickness,n)!==n),A){if(t=(0,h.pluckNumber)(b.highlightonhover,m.highlight,g.highlight,1),(a=(0,h.pluck)(b.hovercolor,m.hovercolor,g.plotfillhovercolor))&&t&&(t=0),a=(0,h.pluck)(a,v),i=(0,h.pluck)(b.hoveralpha,m.hoveralpha,g.plotfillhoveralpha,x),o=(0,h.pluck)(b.borderhovercolor,m.borderhovercolor,g.plotborderhovercolor,S),f.hoverBorderColor=o,r=(0,h.pluck)(b.borderhoveralpha,m.borderhoveralpha,g.plotborderhoveralpha,g.plotfillhoveralpha,k),l=(0,h.pluckNumber)(b.borderhoverthickness,m.borderhoverthickness,g.plotborderhoverthickness,w),a.replace(/,+?$/,""),1===t){for(u=(c=(s="string"==typeof a)?a.split(/\s{0,},\s{0,}/):a.color.split(/\s{0,},\s{0,}/)).length,d=0;d<u;d++)c[d]=(0,h.getLightColor)(c[d],70);s?a=c.join(","):a.color=c.join(",")}this._setHoverColor(L,a,i,y),L.hoverColor=a,L.alpha=i,L.borderColor=(0,h.convertColor)(o,r),L.borderAlpha=r,L.borderWidth=l}else L.enabled=!1},a.organizeDatalabels=function(){var e,t,a,i,n,o=this.config,r=this.components.data,l=[],s=[],c=r.length;for(e=0;e<c;e++)i=(t=r[e].config).labelPosition,n=t.valuePosition,null!==t.y&&"undefined"!=typeof t.y&&!1!==t.isVisible&&("outside"===i&&"outside"===n?l.push({point:r[e]}):("inside"===i&&"inside"===n||l.push({point:r[e]}),s.push({point:r[e]})));a=O(l),o.labelsPlacedOutside=this.skipOverlappingLabels(a),o.labelsPlacedInside=s,this.rotateDataLabels()},a.skipOverlappingLabels=function(e){var t,a,i,n,o,r,l=e,s=this.config,c=s.dataLabelOptions,h=c.distance+s.pieMinRadius,u=[];for(o=s.labelLineHeight=parseInt(c.style.fontSize,10),s.labelsMaxInQuadrant=r=_(h/o),a=0;a<4;a++)if(c.skipOverlapLabels&&(t=l[a].length-r)>0)for(l[a].sort(W),i=0,n=(t=l[a].splice(0,t)).length;i<n;i++)this.disposeLabelAndConnector(t[i].point.graphics,[{el:"label",animLabel:"label"},{el:"innerLabel",animLabel:"label"},{el:"connector",animLabel:"connector"}]);for(a=0;a<4;a++)for(i=0,n=l[a].length;i<n;i++)u.push(l[a][i]);return u},a.rotateDataLabels=function(){this.rotateOuterLabels(),this.rotateInnerLabels()},a.rotateOuterLabels=function(){var e,t,a,i,o,r,l,s,c,u,d,g,p,f,b,x,y,C,k,S,w,A,L,_,D,I=this.config,M=this.getFromEnv("chart"),R=M.getFromEnv("animationManager"),B=M.getChildren("legend")[0],V=B&&B.config||{},G=this.getFromEnv("smartLabel"),H=M.config,W=I.dataLabelOptions,q=I.labelLineHeight,K=I.pieMinRadius,Z=M.config,J=Z.canvasLeft,$=Z.canvasWidth,Q=Z.useEllipsesWhenOverflow,ee=W.connectorPadding,te=W.manageLabelOverflow,ae=W.distance,ie=W.enableSmartLabels,ne=O(I.labelsPlacedOutside),oe=ae+K,re=T(ne[0].length,ne[1].length,ne[2].length,ne[3].length),le=J+.5*$,se=H.canvasTop+.5*H.canvasHeight,ce=I.handlersAPI,he=ce.plotDragStart,ue=ce.plotDragEnd,de=ce.plotDragMove,ge=ce.plotRollOver,pe=ce.plotRollOut,fe=[],me=[],be=this.getFromEnv("toolTipController"),ve=this.getContainer("label-group");for(t=T(E(re,I.labelsMaxInQuadrant)*q,oe+q),a=0;a<4;a++)ne[a].sort(j);for(ne[0].reverse(),ne[2].reverse(),i=0;i<4;i++){for(S=t,k=ne[i].length*q,fe=[],a=0,o=ne[i].length;a<o;a++)y=ne[i][a],(l=P(t*N(y.angle)))>S?l=S:l<k&&(l=k),k-=q,S=l-q,fe.push(l);for(k=0,S=t-(o-1)*q,me=[],a=ne[i].length-1;a>=0;a--)y=ne[i][a],(l=P(t*N(y.angle)))<k?l=k:l>S&&(l=S),k=l+q,S+=q,me.push(l);for(a=0;a<o;a++)l=E(t,(fe[a]+me[o-1-a])/2),s=t*F(Math.asin(l/t)),p=(r=(y=ne[i][a]).point).config,f=r.graphics,b=p.props.connector.attr,g=h.BLANKSTRING,(w=Object.assign({},p.props.label.attr))["text-anchor"]=0===i||3===i?"start":"end",w.y=u=se+Y[i]*l,w.x=c=le+X[i]*(s+2*ee),p.sliced&&(w.y+=p.transY,w.x+=p.transX),"outside"===p.labelPosition&&"outside"===p.valuePosition?this.disposeLabelAndConnector(f,[{el:"innerLabel",animLabel:"label"}]):w.text="outside"===p.labelPosition?p.labelText:p.valueText,w.text?(C={x:le+K*F(y.angle),y:se+K*N(y.angle)},x=p.connectorPath=(0,m.getConnectorPath)(C,{x:le+X[i]*s,y:se+Y[i]*l},{isSlanted:W.isSmartLineSlanted,padding:ee,quadrant:i,transX:p.sliced?p.transX:0,transY:p.sliced?p.transY:0}),te&&(d=1===i||2===i?w.x-J:J+$-w.x,"right"!==V.align&&"left"!==V.align||(d-=V.symbolWidth+2*V.borderWidth),G.useEllipsesOnOverflow(Q),G.setStyle(p.style),e=G.getSmartText(w.text,d,parseFloat(G.style.lineHeight)),w.text=e.text,g=e.tooltext),D=f.label,f.label=_=R.setAnimation({el:D||"text",attr:w,css:p.props.label.css,component:this,container:ve,label:"label"}),_.outlineText(I.showTextOutline,w.fill),H.showtooltip&&_.abbrArr&&_.abbrArr.length&&be.enableToolTip(_,n),D||_.on("fc-dragstart",he).on("fc-dragmove",de).on("fc-dragend",ue).on("fc-click",U.bind(_,M,p.labellink)).on("fc-click",z(this,_)).on("fc-mouseover",ge).on("fc-mouseout",pe),g?g&&be.enableToolTip(_,g):be.disableToolTip(_),_.x=c,_.y=u,_&&_.data("textPos",{x:w.x,y:w.y}).data("plotItem",p.plotItem).data("eventArgs",p.eventArgs),L=f.connector,ie?(f.connector=A=R.setAnimation({el:L||"path",attr:v({path:x},b),container:ve,component:this,label:"connector"}),L||A.on("fc-dragstart",he).on("fc-dragmove",de).on("fc-dragend",ue).on("fc-mouseover",ge).on("fc-mouseout",pe),A.data("connectorPath",{path:x}).data("plotItem",p.plotItem).data("eventArgs",p.eventArgs)):L&&this.disposeLabelAndConnector(f,[{el:"connector",animLabel:"connector"}])):this.disposeLabelAndConnector(f,[{el:"label",animLabel:"label"},{el:"connector",animLabel:"connector"}])}},a.rotateInnerLabels=function(){var e,t,a,i,o,r,l,s,c,u,d,g,p,f,b=this.config,v=this.getFromEnv("chart").config,x=this.getFromEnv("toolTipController"),y=b.labelsPlacedInside,C=b.pieCenter,k=this.getFromEnv("animationManager"),S=C[0],w=C[1],A=y.length,L=this.components.data.length,T=b.handlersAPI,E=T.plotDragStart,_=T.plotDragEnd,D=T.plotDragMove,I=T.plotRollOver,M=T.plotRollOut;for(a=0;a<A;a++)o=(i=y[a].point).config,r=i.graphics,g=Object.assign({},o.props.label.attr),d=P(o.startAngle-o.endAngle),c=o.minAngleForLabel,u=o.minAngleForValue,"inside"===o.valuePosition&&"inside"===o.labelPosition?(this.disposeLabelAndConnector(r,[{el:"label",animLabel:"label"},{el:"connector",animLabel:"connector"}]),d>=u&&d<c?g.text=o.valueText:d<u&&d>=c?g.text=o.labelText:d<u&&d<c&&(g.text=h.BLANKSTRING)):"inside"===o.valuePosition?g.text=d>=u?o.valueText:h.BLANKSTRING:g.text=d>=c?o.labelText:h.BLANKSTRING,g.text?(s=b.pieMinRadius*o.innerLabelRadiusPercent,l=(0,m.getCleanAngle)(o.angle),g.x=e=S+(L>1?s*F(l):0),g.y=t=w+(L>1?s*N(l):0),o.sliced&&(g.y+=o.transY,g.x+=o.transX),g["text-anchor"]="middle",f=r.innerLabel,r.innerLabel=p=k.setAnimation({el:f||"text",attr:g,css:o.props.label.css,component:this,container:this.getContainer("label-group"),label:"label"}),p.outlineText(b.showTextOutline,g.fill),v.showtooltip&&p.abbrArr&&p.abbrArr.length&&x.enableToolTip(p,n),f||p.on("fc-dragstart",E).on("fc-dragmove",D).on("fc-dragend",_).on("fc-click",U.bind(p,this.getFromEnv("chart"),o.labellink)).on("fc-click",z(this,p)).on("fc-mouseover",I).on("fc-mouseout",M),p.x=e,p.y=t,p&&p.data("textPos",{x:g.x,y:g.y}).data("plotItem",o.plotItem).data("eventArgs",o.eventArgs)):this.disposeLabelAndConnector(r,[{el:"innerLabel",animLabel:"label"}])},a.disposeLabelAndConnector=function(e,t){void 0===t&&(t=[]);var a,i,n,o=this.getFromEnv("animationManager"),r=t.length;for(a=0;a<r;a++)e[n=(i=t[a]).el]&&(e[n]=o.setAnimation({el:e[n],component:this,label:i.animLabel})),delete e[n]},a._setHoverColor=function(e,t,a,i){i?e.color=(0,f["default"])(t,a,i,this.config.doughnutradius):(e.color=t,e.alpha=a)},a.updateData=function(){var t=this,a=t.config,i=t.components.data;a.valueTotal-=i[arguments[1]].config.y,e.prototype.updateData.call(this,arguments)},a._rotate=function(){var e,t,a,i,o,r,l,s,c,u=this.getFromEnv("chart"),d=this.config,g=this.components.data,p=u.config,f=d.piePlotOptions,m=(d.startAngle||0)%M,b=d.slicingDistance,v=d.valueTotal,x=M/v,y=p.canvasLeft+.5*p.canvasWidth,C=p.canvasTop+.5*p.canvasHeight,k=d.pieMinRadius,S=.5*(f.innerSize||0);for(o=r=m,c=0;c<g.length;c+=1)l=g[c].config,s=g[c].graphics,null!==(a=l.y)&&a!==n&&(r=o,i=.5*((o-=d.singletonCase?M:a*x)+r),l.angle=i,l.transX=F(i)*b,l.transY=N(i)*b,l.slicedTranslation="t"+F(i)*b+h.COMMASTRING+N(i)*b,(t=l._rotateAttrs)||(t=l._rotateAttrs={ringpath:[],transform:h.BLANKSTRING}),(e=t.ringpath)[0]=y,e[1]=C,e[2]=k,e[3]=S,e[4]=o,e[5]=r,s.element.attr({ringpath:t.ringpath,transform:l.sliced?l.slicedTranslation:""}));this.organizeDatalabels()},a._parsePiePlotOptions=function(){var e=this.config;return{size:e.pieMinRadius,slicedOffset:e.slicingDistance}},a._parseDataLabelOptions=function(){return{style:this.getFromEnv("chart").config.dataLabelStyle}},a._addLegend=function(){var e,t,a,i,n=this.config,o=this.getFromEnv("chart-attrib"),r=this.getFromEnv("legend"),l=this.config.JSONData.data||{},s=this.components.data;for(e=0;e<s.length;e++)if(null!==(t=s[e].config).y&&t.seriesName)i={index:e,type:this.getName(),label:t.seriesName,enabled:(0,h.pluckNumber)(t.includeInLegend,1),usePattern:n.usePattern,legendIconAlpha:(0,h.pluckNumber)(l[e].legendiconalpha),patternAttr:{patternType:t.patternType,patternAngle:t.patternAngle,patternDensity:t.patternDensity,patternSize:t.patternSize,color:t.setColor,patternAlpha:t.patternAlpha,patternBgColor:t.patternBgColor,alpha:t.setAlpha}},(a=r.getItem(t.legendItemId))||(t.legendItemId=r.createItem(this),a=r.getItem(t.legendItemId),this.addExtEventListener("fc-click",a.itemClickFn,a)),a.configure(i),a.setStateCosmetics("default",{symbol:{fill:(0,h.toRaphaelColor)(t.setColor),bgAlpha:(0,h.pluckNumber)(l[e].legendiconbgalpha,l[e].legendiconalpha,o.legendiconbgalpha,o.legendiconalpha,t.setAlpha),borderAlpha:(0,h.pluckNumber)(l[e].legendiconborderalpha,l[e].legendiconalpha,o.legendiconborderalpha,o.legendiconalpha,"100"),rawFillColor:t.setColor,stroke:(0,h.toRaphaelColor)(t.borderColor)}});else{if(!t.legendItemId)continue;(a=r.getItem(t.legendItemId))&&r.disposeItem(a.getId()),delete t.legendItemId}},a.getPlotData=function(e,t){var a,i,n,o=this.components.data[e].config,r=this.config.userData||(this.config.userData=[]);if(r[e])a=r[e];else{for(n in a=r[e]={},o)"object"!=typeof(i=o[n])&&"function"!=typeof i&&0!==n.indexOf("_")&&(a[n]=i);a.value=a.y,a.categoryLabel=a.label=a.seriesName,delete a.y,delete a.total,delete a.doNotSlice,delete a.name,delete a.seriesName,delete a.centerAngle,delete a.showInLegend,delete a.angle,delete a.endAngle,delete a.isVisible,delete a.setColor,delete a.slicedTranslation,delete a.startAngle,delete a.transX,delete a.transY,delete a.pValue}return a.sliced=t,a},a._parseBorderConfig=function(e,t,a){var i=this.config,n=i.pieBorderColor,o=this.getFromEnv("chart").getFromEnv("dataSource").chart,r=(0,h.pluck)(a.bordercolor,n),l=(0,h.pluck)(a.borderalpha,o.plotborderalpha,o.pieborderalpha);return i.usePattern&&(r||(r=e),l||0===l||(l=t)),{setPlotBorderColor:r=(0,h.pluck)(r,(0,h.getLightColor)(e,25)).split(h.COMMASTRING)[0],setPlotBorderAlpha:l=o.showplotborder===h.ZEROSTRING?h.ZEROSTRING:(0,h.pluck)(l,t,"80")}},a.legendInteractivity=function(e){var t,a,i,n=this.components.data,o=e.getId();for(a=0,t=n.length;a<t;a++)n[a].config.legendItemId===o&&(i=n[a].graphics,this.plotGraphicClick.call(i.element))},a._createContainer=function(){var e,t,a,i,n=this.getName(),o=this.groupName,r=this.getLinkedParent(),l=o||this.dsGroup||n;!r.getChildContainer(l+"Group")&&(l="default"),e=r.getChildContainer("datalabelsGroup"),t=this.getContainer("pie-groups")||this.addContainer("pie-groups",R("pie",e,this)),a=this.getContainer("pie-plot-groups")||this.addContainer("pie-plot-groups",R("pie-plot",t,this)),i=this.getContainer("pie-label-groups")||this.addContainer("pie-label-groups",R("pie-label",t,this)),this.getContainer("plot-group")||this.addContainer("plot-group",R("plots",a,this)),this.getContainer("plot-shadow-group")||this.addContainer("plot-shadow-group",R("plot-shadows",a,this).toBack()),this.getContainer("label-group")||this.addContainer("label-group",R("labels",i,this)),this.getContainer("connector-shadow-group")||this.addContainer("connector-shadow-group",R("connector-shadows",i,this)),this.getContainer("anchor-shadow-group")||this.addContainer("anchor-shadow-group",R("anchor-shadows",i,this))},a.allocatePosition=function(){var e,t,a=this.components.data,i=a.length;for(e=0;e<i;e++)t=a[e],this.parsePlotAttributes(t,e),this.parseLabelAttributes(t,e)},a.parsePlotAttributes=function(e,t){var a,i,o,r,l,s,c,u,d,g,p,f,m,b,v=this.components.data,x=this.getFromEnv("chart"),y=x.config,C=this.config,S=t,w=v.length,A=y.canvasWidth,L=y.canvasHeight,T=y.canvasLeft+.5*A,E=y.canvasTop+.5*L,P=C.valueTotal,_=C.piePlotOptions=this._parsePiePlotOptions(),D=_.slicedOffset,I=_.size,O=.5*(C.innerSize||0),R=(C.startAngle||0)%M,V=R-M,z=C.animateClockWise;m=P&&M/P,C.pieCenter=[T,E],r=R,l=R,t>0&&(r=v[t-1].config.startAngle,l=v[t-1].config.endAngle),c=(s=e.config).y,u=s.displayValue,d=s.sliced,a=s.toolText,i=!!s.link,null!==c&&c!==n&&!1!==s.isVisible&&((g=s.color).r=I,g.cx=T,g.cy=E,l=r,p=.5*((r-=C.singletonCase?M:c*m)+l),z?V:R,f=C.previousData={cx:T,cy:E,r:I,r2:O},o=this.config.drawn?[f.cx,f.cy,f.r,f.r2,r,l]:[T,E,I,O,r,l],d&&(s.slicedTranslation="t"+F(p)*D+","+N(p)*D),b={"stroke-width":s.borderWidth,stroke:s.borderColor,fill:k?B(s.color,C.doughnutradius):(0,h.toRaphaelColor)(s.color),transform:d?s.slicedTranslation:"","stroke-dasharray":s.dashStyle,redrawDataLabels:R,ringpath:o,cursor:i?"pointer":""},s.props={element:{attr:b}},s.props.element.patternAttr={patternType:s.patternType,patternAngle:s.patternAngle,patternDensity:s.patternDensity,patternSize:s.patternSize,color:s.setColor,patternAlpha:s.patternAlpha,patternBgColor:s.patternBgColor,alpha:s.setAlpha,x:o[0],y:o[1]},s.eventArgs={index:C.reversePlotOrder?w-1-S:S,link:s.link,value:s.y,displayValue:s.displayValueArgs,categoryLabel:s.categoryLabel,isSliced:d,toolText:a,pValue:s.pValue,color:s.setColor,alpha:s.setAlpha,borderColor:s.borderConfig.setPlotBorderColor,borderAlpha:s.borderConfig.setPlotBorderAlpha,dashed:s.setBorderDashed,showLabel:s.showLabel,showValue:s.showValue,labelPosition:s.labelPosition,valuePosition:s.valuePosition,labelFont:s.labelFont,labelFontColor:s.labelFontColor||"#555555",labelLink:s.labellink,hoverColor:s.hoverEffects.hoverColor,hoverAlpha:s.hoverEffects.alpha,borderHoverColor:s.hoverBorderColor,borderHoverAlpha:s.hoverEffects.borderAlpha,id:s.id},C.usePattern&&(s.eventArgs.pattern={patternType:s.patternType,patternColor:s.setColor,patternBgColor:s.patternBgColor===h.TRACKER_FILL?n:s.patternBgColor},delete s.eventArgs.color),s.plotItem={chart:x,index:S,seriesData:C,value:c,pValue:s.pValue,displayValue:s.displayValue||"",angle:s.angle=p,angle1:s.startAngle=r,angle2:s.endAngle=l,slicedX:F(p)*D,slicedY:N(p)*D,sliced:d,labelText:u,toolText:a,name:s.name,link:s.link,percentage:P?c*P/100:0,originalIndex:w-S-1,style:s.style,color:(0,h.toRaphaelColor)(s.color),borderColor:s.borderColor,borderWidth:s.borderWidth,rolloverProperties:s.hoverEffects,radius:I,center:[T,E],innerDiameter:2*O,centerLabelConfig:s.centerLabelConfig,isVisible:s.isVisible,label:s.seriesName,connector:void 0,transX:s.transX=F(p)*D,transY:s.transY=N(p)*D,slicedTranslation:s.slicedTranslation="t"+F(p)*D+","+N(p)*D})},a.parseLabelAttributes=function(e){var t,a,i,o,r,l=this.getFromEnv("chart").config,s=l.dataLabelStyle,c=this.config,u=l.style,d=l.textDirection,g=c.dataLabelOptions;(o=(t=e.config)._textAttrs)||(o=t._textAttrs={}),a=t.y,i=t.displayValue,u=t.style,null!==a&&a!==n&&!1!==t.isVisible&&(i!==n?(u&&((r=t._textCss)||(r=t._textCss={}),u.fontSize=this.computeFontSize(u.fontSizeWithUnit),u.lineHeight=(0,h.setLineHeight)(u),r.fontFamily=u.fontFamily,r.fontSize=u.fontSize,r.lineHeight=u.lineHeight,r.fontWeight=u.fontWeight,r.fontStyle=u.fontStyle),t.plotItem.style=t.style=u||(u=s),o.text=i,o.fill=u.color||"#000000",o.cursor=e.config.link?"pointer":"",o["text-bound"]=[u.backgroundColor,u.borderColor,u.borderThickness,u.borderPadding,u.borderRadius,u.borderDash],o.direction=d,o["line-height"]=u.lineHeight):o.text=h.BLANKSTRING,t.props.label={attr:o,css:r},t.props.connector={attr:{"stroke-width":g.connectorWidth,stroke:g.connectorColor||"#606060"}})},a.draw=function(){var e,t,a,i,o,r,l,s,c,u,d,g,p,f,m,b,v,x=this.getFromEnv("animationManager"),y=this.getFromEnv("chart").config,C=y.dataLabelStyle,k=this.config,S=k.showShadow,w=this.components,A=w.removeDataArr=w.removeDataArr||[],L=this.getState("visible"),N=w.data||[],F=N.length,T=y.canvasWidth,E=y.canvasHeight,_=y.canvasLeft+.5*T,D=y.canvasTop+.5*E,I=k.handlersAPI.plotDragStart,M=k.handlersAPI.plotDragEnd,O=k.handlersAPI.plotDragMove,R=k.handlersAPI.plotRollOver,B=k.handlersAPI.plotRollOut,V=function(){var e=k.pieCenter||[],t=k.piePlotOptions||[],a={cx:e[0],cy:e[1],r:t.size,r2:.5*(k.innerSize||0)};return function(e){var t,i=!1;for(t in e)if(P(e[t]-a[t])>5){i=!0;break}return i}}(),G=(k.piePlotOptions=this._parsePiePlotOptions()).size,H=.5*(k.innerSize||0),W=this.getFromEnv("toolTipController");for(this.getContainer("pie-groups")||this._createContainer(),s=this.getContainer("plot-group"),c=this.getContainer("plot-shadow-group"),u=this.getContainer("label-group"),d=this.getContainer("connector-shadow-group"),g=this.getContainer("anchor-shadow-group"),this.config.drawn&&(e=V({cx:_,cy:D,r:G,r2:H})&&!1),u.css(C),v=k.valueTotal,L&&v?(s.show(),c.show(),u.show(),d.show(),g.show()):(s.hide(),c.hide(),u.hide(),d.hide(),g.hide()),A.length&&this.removeElement(),t=0;t<F;t+=1)p=(a=N[t]).graphics,m=(f=a.config).y,i=f.toolText,null!==m&&m!==n&&!1!==f.isVisible&&(r=p.element,(o=x.setAnimation({el:r||"ringpath",attr:f.props.element.attr,label:"ringpath",props:{startAngle:this.config.startAngle},container:s,component:this})).addPattern(f.props.element.patternAttr,k.usePattern),r||(p.element=o,o.on("fc-dragstart",I).on("fc-dragmove",O).on("fc-dragend",M).on("fc-click",z(this,o)).on("fc-mouseover",R).on("fc-mouseout",B)),b=f.plotItem,l=f.eventArgs,b.graphic=o,o.show().shadow(S&&f.shadow,c).data("plotItem",b).data("dataset",this).data("eventArgs",l),W.enableToolTip(o,i));this.organizeDatalabels(),!this.config.__attachRestoreColor&&this.addExtEventListener("animationComplete",(function(){var t,a;if(e)for(t=0;t<F;t+=1)(a=N[t]).graphics.element&&a.graphics.element.attr({fill:(0,h.toRaphaelColor)(a.config.color)})}),x),this.config.__attachRestoreColor=!0,this.config.drawn=!0},a.sliceInOtherPies=function(e){var t,a=this.components.data,i=a.length,n=0;for(this.enableMultiSlicing=!0;i--;)i!==e&&(t=a[i]).config.sliced&&++n&&this.plotGraphicClick.call(t.graphics);return this.enableMultiSlicing=!1,!!n},a.removeElement=function(){var e,t,a,i,n=this.getFromEnv("animationManager"),o=this.getFromEnv("chart").config,r=this.components.removeDataArr||[],l=r.length,s=this.config,c=o.canvasWidth,h=o.canvasHeight,u=o.canvasLeft+.5*c,d=o.canvasTop+.5*h,g=s.pieMinRadius,p=.5*(s.innerSize||0),f=s.startAngle-M;for(i=0;i<l;i++){for(t in a=r[0].graphics)if(a.hasOwnProperty(t)){if(!(e=a[t]))continue;"element"===t?(n.setAnimation({el:e,attr:{ringpath:[u,d,g,p,f,f+.01],transform:""},callback:q,component:this}),delete a[t]):this.disposeLabelAndConnector(a,[{el:"label",animLabel:"label"},{el:"innerLabel",animLabel:"label"},{el:"connector",animLabel:"connector"}])}r.splice(0,1)}},a.getEventArgs=function(e){var t=e.config.index,a=this.components.data[t].config||{};return{datasetName:a.seriesName,datasetIndex:t,id:a.id,visible:a.isVisible,label:a.seriesName,value:a.value,percentValue:a.pValue,tooltext:a.toolText,link:a.link,sliced:a.sliced}},a.remove=function(t){var a=this.config.legendItemId,i=this.getFromEnv("legend");i&&a&&i.disposeItem(a),e.prototype.remove.call(this,t)},t}(s["default"]);t["default"]=Z},589:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i={"initial.dataset.pie2D":function(){return{"group.appearing":function(e){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:e.component.getFromEnv("chartConfig").alphaanimation?"plot":"initial"}]},"ringpath.appearing":function(e){var t=e.component,a=e.attr.ringpath.slice(0),i=e.attr.ringpath.slice(0),n=e.props.startAngle,o=e.component.config,r=t.getFromEnv("chartConfig"),l=o.animateClockWise;return r.alphaanimation?[{}]:(l&&(i[4]+=2*Math.PI,i[5]+=2*Math.PI),a[4]=n,a[5]=n,[{initialAttr:{ringpath:a},finalAttr:{ringpath:i,transform:""},startEnd:{start:0,end:.75},effect:"linear",slot:"plot"},{initialAttr:{transform:"",ringpath:i},finalAttr:{ringpath:i},startEnd:{start:.75,end:1},effect:"linear",slot:"plot"}])},"label.appearing":[{initialAttr:{opacity:"0"},finalAttr:{opacity:"1"},slot:"final"}],"connector.appearing":function(e){return[{initialAttr:{path:e.attr.path,opacity:"0"},finalAttr:{opacity:"1"},slot:"final"}]},"label.updating":function(e){return[{initialAttr:{x:e.el.attrs.x},slot:"plot"}]}}},"slicing.dataset.pie2D":function(){return{"slice.updating":function(e){return"t0,0"!==(e.attr&&e.attr.transform)?[{initialAttr:{transform:"t0,0"},slot:"plot"}]:[{finalAttr:{transform:"t0,0"},slot:"plot"}]}}}};t["default"]=i},590:function(e,t,a){"use strict";t.__esModule=!0,t.getConnectorPath=t.getQuadrant=t.getCleanAngle=void 0;var i=Math.PI,n=i/2,o=3*i/2,r=2*i,l=function(e){var t=e%r;return t<0?t+r:t};t.getConnectorPath=function(e,t,a){void 0===a&&(a={});var i=a,n=i.isSlanted,o=i.quadrant,r=i.padding,l=i.transX,s=i.transY,c=e.x+l,h=e.y+s,u=t.x+l,d=t.y+s;return["M",c,h,"L",n?u:c,d,u+(1===o||2===o?-1:1)*(r||0),d]},t.getQuadrant=function(e){var t=l(e);return t>=0&&t<n?0:t<i?1:t<o?2:3},t.getCleanAngle=l},598:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a,i,n=window.parseFloat,o=e._createNode,r=e._setFillAndStroke,l=e.el.constructor,s={Q:"L",Z:"X",q:"l",z:"x",",":" "},c=/,?([achlmqrstvxz]),?/gi,h=function(){return this.join(",").replace(c,t)};e.svg?(t="$1",a=function(){var a=this,i=e.is(arguments[0],"array")?arguments[0]:Array.prototype.slice.call(arguments);i?"string"==typeof i?i=i.replace(c,t):i.toString=h:i="M0,0",a.node.setAttribute("d",i.toString())},e._engine.litepath=function(t,a,i,n,s){var c,h=o("path");return(n||a).canvas.appendChild(h),(c=new l(h,a,n)).type="litepath",c.id=h.raphaelid=e._oid++,h.raphael=!0,r(c,s||{fill:"none",stroke:"#000"}),c},e._getPath.litepath=function(t){return e.parsePathString(t.node.getAttribute("d"))}):e.vml&&(t=function(e,t){return s[t]||t},i=function(){var e=this;return e._transform.apply(e,arguments),e._.bcoord&&(e.node.coordsize=e._.bcoord),e},a=function(e){var a=e;return a?"string"==typeof a?a=a.replace(c,t):a.toString=h:a="M0,0",this.node.path=a,this},e._engine.litepath=function(t,a,r,s,c){var h,u=o("shape"),d=u.style,g=new l(u,a,s),p=c||{fill:"none",stroke:"#000"},f=r;return d.cssText="position:absolute;left:0;top:0;width:21600px;height:21600px;",f=n(f),isNaN(f)?u.coordsize="21600 21600":(g._.bzoom=f,d.width="1px",d.height="1px",u.coordsize=g._.bcoord=f+" "+f),u.coordorigin=a.coordorigin,g.type="litepath",g.id=u.raphaelid=e._oid++,u.raphael=!0,g._transform=g.transform,g.transform=i,e._setFillAndStroke(g,p),(s||a).canvas.appendChild(u),(h=o("skew")).on=!0,u.appendChild(h),g.skew=h,g},e._getPath.litepath=function(t){return e.parsePathString(t.node.path||"")});e.fn.litepath=function(t,i,n){var o,r,s,c=t,h=i,u=n;return"object"==typeof c&&c.constructor!==l&&(o=c,r=(c=c.litepath).zoom,u=c.group),h&&h.constructor===l?(u=h,r=void 0):r=h,c&&c.constructor===l&&(u=c,c=""),(s=e._engine.litepath(c,this,r,u,o)).ca.litepath=a,c&&s.attr("litepath",e.is(c,"array")?[c]:c),this.__set__&&this.__set__.push(s),this._elementsById[s.id]=s}}},607:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=t.setAxisDimention=t.getSpecificyAxisConf=t.getSpecificxAxisConf=t._feedAxesRawData=void 0;var n,o,r,l,s=i(a(238)),c=i(a(565)),h=i(a(608)),u=a(224),d=i(a(609)),g=i(a(366)),p=i(a(484)),f=Math.max;t.setAxisDimention=l,t.getSpecificyAxisConf=r,t.getSpecificxAxisConf=o,t._feedAxesRawData=n;var m=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("axis",h["default"],["canvas"]),t.registerFactory("dataset",d["default"],["vCanvas"]),t}(0,s["default"])(t,e),t.getName=function(){return"MSDyBaseCartesian"};var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.syncaxislimits=0},a._feedAxesRawData=function(){var e,t,a,i,n,o,r,l,s,c=this.config,h=this.getFromEnv("color-manager"),d=this.getFromEnv("dataSource"),p=this.getFromEnv("chart-attrib"),f=this.config.is3D,m=f?u.chartPaletteStr.chart3D:u.chartPaletteStr.chart2D,b=c.primaryAxisOnleft=(0,u.pluckNumber)(p.primaryaxisonleft,1),v=(0,u.pluckNumber)(p.syncaxislimits,0),x=[{line:[]}],y=[{line:[]}],C=d.trendlines||[],k=(0,u.pluckNumber)(p.showzeroplane,1),S=(0,u.pluckNumber)(p.showzeroplanevalue),w=(0,u.pluckFontSizeMaintainUnit)(p.outcnvbasefontsize,p.basefontsize,10);for(k||S!==u.UNDEF||(S=0),e=this.getSpecificxAxisConf(),t=this.getSpecificyAxisConf(),c.isstacked&&(t.isPercent=(0,u.pluckNumber)(c.stack100percent,0),"stackedcolumn2dlinedy"!==this.getName().toLowerCase()&&"stackedcolumn3dlinedy"!==this.getName().toLowerCase()||(t.isPercent=0)),a={isActive:!1,isPercent:this.isPercentage,axisIndex:1,uniqueClassName:1,outCanfontFamily:(0,u.pluck)(p.outcnvbasefont,p.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(w),outCanfontSizeWithUnit:w,outCancolor:(0,u.pluck)(p.outcnvbasefontcolor,p.basefontcolor,h.getColor(m.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:p.yaxisnamepadding,axisValuePadding:p.yaxisvaluespadding,axisNameFont:p.syaxisnamefont,axisNameFontSize:p.syaxisnamefontsize,axisNameFontSizeWithUnit:p.syaxisnamefontsize,axisNameFontColor:p.syaxisnamefontcolor,axisNameFontBold:p.syaxisnamefontbold,axisNameFontItalic:p.syaxisnamefontitalic,axisNameBgColor:p.syaxisnamebgcolor,axisNameBorderColor:p.syaxisnamebordercolor,axisNameAlpha:p.syaxisnamealpha,axisNameFontAlpha:p.syaxisnamefontalpha,axisNameBgAlpha:p.syaxisnamebgalpha,axisNameBorderAlpha:p.syaxisnameborderalpha,axisNameBorderPadding:p.syaxisnameborderpadding,axisNameBorderRadius:p.syaxisnameborderradius,axisNameBorderThickness:p.syaxisnameborderthickness,axisNameBorderDashed:p.syaxisnameborderdashed,axisNameBorderDashLen:p.syaxisnameborderdashlen,axisNameBorderDashGap:p.syaxisnameborderdashgap,axisNameWidth:p.syaxisnamewidth,useEllipsesWhenOverflow:p.useellipseswhenoverflow,rotateAxisName:(0,u.pluckNumber)(p.rotateyaxisname,1),axisName:p.syaxisname,divLineColor:(0,u.pluck)(p.divlinecolor,h.getColor(m.divLineColor)),divLineAlpha:(0,u.pluck)(p.divlinealpha,h.getColor("divLineAlpha")),divLineThickness:(0,u.pluckNumber)(p.divlinethickness,1),divLineIsDashed:Boolean((0,u.pluckNumber)(p.divlinedashed,p.divlineisdashed,0)),divLineDashLen:(0,u.pluckNumber)(p.divlinedashlen,4),divLineDashGap:(0,u.pluckNumber)(p.divlinedashgap,2),showAlternateGridColor:(0,u.pluckNumber)(p.showalternatehgridcolor,1),alternateGridColor:(0,u.pluck)(p.alternatehgridcolor,h.getColor("altHGridColor")),alternateGridAlpha:(0,u.pluck)(p.alternatehgridalpha,h.getColor("altHGridAlpha")),numDivLines:p.numdivlines,axisMinValue:v?(0,u.pluckNumber)(p.syaxisminvalue,p.pyaxisminvalue,p.yaxisminvalue):p.syaxisminvalue,axisMaxValue:v?(0,u.pluckNumber)(p.syaxismaxvalue,p.pyaxismaxvalue,p.yaxismaxvalue):p.syaxismaxvalue,setAdaptiveMin:p.setadaptivesymin||p.setadaptiveymin,adjustDiv:p.adjustdiv,labelStep:p.yaxisvaluesstep,showAxisValues:(0,u.pluckNumber)(p.showsyaxisvalues,p.showsyaxisvalue,p.showyaxisvalues,p.showyaxisvalue),showLimits:(0,u.pluckNumber)(p.showsecondarylimits,p.showyaxislimits,p.showlimits),showDivLineValues:(0,u.pluckNumber)(p.showdivlinesecondaryvalue,p.showyaxisvalues,p.showyaxisvalue,1),showZeroPlane:k,zeroPlaneColor:p.zeroplanecolor,zeroPlaneThickness:(0,u.pluckNumber)(p.zeroplanethickness,p.divlinethickness,2),zeroPlaneAlpha:p.zeroplanealpha,showZeroPlaneValue:S,trendlineColor:p.trendlinecolor,trendlineToolText:p.trendlinetooltext,trendlineThickness:p.trendlinethickness,trendlineAlpha:p.trendlinealpha,showTrendlinesOnTop:p.showtrendlinesontop,showAxisLine:f?0:(0,u.pluckNumber)(p.showsyaxisline,p.showaxislines,p.drawAxisLines,0),axisLineThickness:(0,u.pluckNumber)(p.syaxislinethickness,p.axislinethickness,1),axisLineAlpha:(0,u.pluckNumber)(p.syaxislinealpha,p.axislinealpha,100),axisLineColor:(0,u.pluck)(p.syaxislinecolor,p.axislinecolor,"#000000"),labelFont:p.yaxisvaluefont,labelFontSize:this.computeFontSize(p.yaxisvaluefontsize),labelFontSizeWithUnit:p.yaxisvaluefontsize,labelFontColor:p.yaxisvaluefontcolor,labelAlpha:p.yaxisvaluealpha,labelFontBold:p.yaxisvaluefontbold,labelFontItalic:p.yaxisvaluefontitalic,labelBdrColor:p.yaxisvaluebordercolor,labelBdrAlpha:p.yaxisvalueborderalpha,labelBgAlpha:p.yaxisvaluebgalpha,labelLink:p.yaxisvaluelink,labelBgColor:p.yaxisvaluebgcolor,labelBdrThickness:p.yaxisvalueborderthickness,labelBdrPadding:p.yaxisvalueborderpadding,labelBdrRadius:p.yaxisvalueborderradius,labelBdrDashed:p.yaxisvalueborderdashed,labelBdrDashLen:p.yaxisvalueborderdashlen,labelBdrDashGap:p.yaxisvalueborderdashgap},e.vtrendlines=(0,u.extend2)([],d.vtrendlines),l=0,r=C.length;l<r;l++)for(o=(i=C[l]&&C[l].line||[]).length,s=0;s<o;s++)n=i[s]||{},(0,g["default"])(n.parentyaxis,"s")?x[0].line.push(n):y[0].line.push(n);return t.trendlines=(0,u.extend2)([],y),a.trendlines=(0,u.extend2)([],x),1===b?(t.isVertical=!0,t.isReverse=!0,t.isOpposit=!1,a.isVertical=!0,a.isReverse=!0,a.isOpposit=!0):(t.isVertical=!0,t.isReverse=!0,t.isOpposit=!0,a.isVertical=!0,a.isReverse=!0,a.isOpposit=!1),{yAxisConf:[t,a],xAxisConf:[e]}},a.getSpecificxAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config.is3D,a=this.getBasexAxisConf(),i=this.config;return a.zeroPlaneThickness=(0,u.pluckNumber)(e.vzeroplanethickness,e.vdivlinethickness,2),a.zeroPlaneAlpha=(0,u.pluckNumber)(e.vzeroplanealpha,e.vdivlinealpha,i.zeroplanealpha),a.showZeroPlaneValue=e.showvzeroplanevalue,a.showAxisLine=t?0:(0,u.pluckNumber)(e.showxaxisline,e.showaxislines,e.drawAxisLines,0),a.axisLineColor=(0,u.pluck)(e.xaxislinecolor,e.axislinecolor,"#000000"),a.isReverse=!1,a.showAlternateGridColor=(0,u.pluckNumber)(e.showalternatevgridcolor,0),a.numDivLines=e.numvdivlines,a.maxLabelHeight=e.maxlabelheight,a.axisName=e.xaxisname,a.setAdaptiveMin=e.setadaptivexmin,a.showLimits=e.showvlimits,a.showDivLineValues=(0,u.pluckNumber)(e.showvdivlinevalues,e.showvdivlinevalues),a},a.getSpecificyAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config.is3D,a=t?u.chartPaletteStr.chart3D:u.chartPaletteStr.chart2D,i=this.config,n=this.getFromEnv("color-manager"),o=(0,u.pluckNumber)(e.syncaxislimits,0),r=(0,u.pluckNumber)(e.showzeroplane,1),l=(0,u.pluckNumber)(e.showzeroplanevalue),s=(0,u.pluckFontSizeMaintainUnit)(e.outcnvbasefontsize,e.basefontsize,10);return r||l!==u.UNDEF||(l=0),{outCanfontFamily:(0,u.pluck)(e.outcnvbasefont,e.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(s),outCanfontSizeWithUnit:s,outCancolor:(0,u.pluck)(e.outcnvbasefontcolor,e.basefontcolor,n.getColor(a.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:(0,u.pluckNumber)(e.pyaxisnamepadding,e.yaxisnamepadding),axisValuePadding:(0,u.pluckNumber)(e.pyaxisvaluespadding,e.yaxisvaluespadding),axisNameFont:(0,u.pluck)(e.pyaxisnamefont,e.yaxisnamefont),axisNameFontSize:(0,u.pluckNumber)(e.pyaxisnamefontsize,this.computeFontSize(e.yaxisnamefontsize)),axisNameFontSizeWithUnit:(0,u.pluckFontSizeMaintainUnit)(e.pyaxisnamefontsize,e.yaxisnamefontsize),axisNameFontColor:(0,u.pluck)(e.pyaxisnamefontcolor,e.yaxisnamefontcolor),axisNameFontBold:(0,u.pluckNumber)(e.pyaxisnamefontbold,e.yaxisnamefontbold),axisNameFontItalic:(0,u.pluckNumber)(e.pyaxisnamefontitalic,e.yaxisnamefontitalic),axisNameBgColor:(0,u.pluck)(e.pyaxisnamebgcolor,e.yaxisnamebgcolor),axisNameBorderColor:(0,u.pluck)(e.pyaxisnamebordercolor,e.yaxisnamebordercolor),axisNameAlpha:(0,u.pluckNumber)(e.pyaxisnamealpha,e.yaxisnamealpha),axisNameFontAlpha:(0,u.pluckNumber)(e.pyaxisnamefontalpha,e.yaxisnamefontalpha),axisNameBgAlpha:(0,u.pluckNumber)(e.pyaxisnamebgalpha,e.yaxisnamebgalpha),axisNameBorderAlpha:(0,u.pluckNumber)(e.pyaxisnameborderalpha,e.yaxisnameborderalpha),axisNameBorderPadding:(0,u.pluckNumber)(e.pyaxisnameborderpadding,e.yaxisnameborderpadding),axisNameBorderRadius:(0,u.pluckNumber)(e.pyaxisnameborderradius,e.yaxisnameborderradius),axisNameBorderThickness:(0,u.pluckNumber)(e.pyaxisnameborderthickness,e.yaxisnameborderthickness),axisNameBorderDashed:(0,u.pluckNumber)(e.pyaxisnameborderdashed,e.yaxisnameborderdashed),axisNameBorderDashLen:(0,u.pluckNumber)(e.pyaxisnameborderdashlen,e.yaxisnameborderdashlen),axisNameBorderDashGap:(0,u.pluckNumber)(e.pyaxisnameborderdashgap,e.yaxisnameborderdashgap),axisNameWidth:(0,u.pluckNumber)(e.pyaxisnamewidth,e.yaxisnamewidth),useEllipsesWhenOverflow:e.useellipseswhenoverflow,rotateAxisName:(0,u.pluckNumber)(e.rotateyaxisname,1),axisName:(0,u.pluck)(e.pyaxisname,e.yaxisname),divLineColor:(0,u.pluck)(e.divlinecolor,n.getColor(a.divLineColor)),divLineAlpha:(0,u.pluck)(e.divlinealpha,n.getColor("divLineAlpha")),divLineThickness:(0,u.pluckNumber)(e.divlinethickness,1),divLineIsDashed:Boolean((0,u.pluckNumber)(e.divlinedashed,e.divlineisdashed,0)),divLineDashLen:(0,u.pluckNumber)(e.divlinedashlen,4),divLineDashGap:(0,u.pluckNumber)(e.divlinedashgap,2),showAlternateGridColor:(0,u.pluckNumber)(e.showalternatehgridcolor,1),alternateGridColor:(0,u.pluck)(e.alternatehgridcolor,n.getColor("altHGridColor")),alternateGridAlpha:(0,u.pluck)(e.alternatehgridalpha,n.getColor("altHGridAlpha")),numDivLines:e.numdivlines,axisMinValue:o?(0,u.pluckNumber)(e.syaxisminvalue,e.pyaxisminvalue,e.yaxisminvalue):(0,u.pluckNumber)(e.pyaxisminvalue,e.yaxisminvalue),axisMaxValue:o?(0,u.pluckNumber)(e.syaxismaxvalue,e.pyaxismaxvalue,e.yaxismaxvalue):(0,u.pluckNumber)(e.pyaxismaxvalue,e.yaxismaxvalue),setAdaptiveMin:e.setadaptiveymin,adjustDiv:e.adjustdiv,labelStep:e.yaxisvaluesstep,showAxisValues:(0,u.pluckNumber)(e.showyaxisvalues,e.showyaxisvalue),showLimits:(0,u.pluckNumber)(e.showyaxislimits,e.showlimits,this.showLimits),showDivLineValues:(0,u.pluckNumber)(e.showdivlinevalues,e.showdivlinevalue),showZeroPlane:r,zeroPlaneColor:e.zeroplanecolor,zeroPlaneThickness:(0,u.pluckNumber)(e.zeroplanethickness,e.divlinethickness,i.zeroplanethickness,2),zeroPlaneAlpha:(0,u.pluckNumber)(e.zeroplanealpha,e.divlinealpha,i.zeroplanealpha),showZeroPlaneValue:l,showZeroPlaneOnTop:i.showzeroplaneontop,trendlineColor:e.trendlinecolor,trendlineToolText:e.trendlinetooltext,trendlineThickness:e.trendlinethickness,trendlineAlpha:e.trendlinealpha,showTrendlinesOnTop:e.showtrendlinesontop,showAxisLine:t?0:(0,u.pluckNumber)(e.showyaxisline,e.showaxislines,e.drawAxisLines,0),axisLineThickness:(0,u.pluckNumber)(e.yaxislinethickness,e.axislinethickness,1),axisLineAlpha:(0,u.pluckNumber)(e.yaxislinealpha,e.axislinealpha,100),axisLineColor:(0,u.pluck)(e.yaxislinecolor,e.axislinecolor,"#000000"),forceTrendBelow:!!i.is3D,labelFont:e.yaxisvaluefont,labelFontSize:this.computeFontSize(e.yaxisvaluefontsize),labelFontSizeWithUnit:e.yaxisvaluefontsize,labelFontColor:e.yaxisvaluefontcolor,labelAlpha:e.yaxisvaluealpha,labelFontBold:e.yaxisvaluefontbold,labelFontItalic:e.yaxisvaluefontitalic,labelBdrColor:e.yaxisvaluebordercolor,labelBgAlpha:e.yaxisvaluebgalpha,labelBdrAlpha:e.yaxisvalueborderalpha,labelLink:e.yaxisvaluelink,labelBgColor:e.yaxisvaluebgcolor,labelBdrThickness:e.yaxisvalueborderthickness,labelBdrPadding:e.yaxisvalueborderpadding,labelBdrRadius:e.yaxisvalueborderradius,labelBdrDashed:e.yaxisvalueborderdashed,labelBdrDashLen:e.yaxisvalueborderdashlen,labelBdrDashGap:e.yaxisvalueborderdashgap}},a.setAxisDimention=function(){var e,t,a=this.config,i=this.getChildren(),n=this.getChildren("scrollBar")&&this.getChildren("scrollBar")[0]&&this.getChildren("scrollBar")[0].config,o=i.yAxis,r=i.xAxis&&i.xAxis[0],l=o[0],s=o[1],c=a.xDepth||0,h=i.canvas[0].config,u=h.canvasBorderWidth,d=h.canvasPadding,g=h.canvasPaddingLeft,p=h.canvasPaddingRight,m=h.canvasPaddingTop,b=this&&this.isScrollEnabled(),v=a.shift&&(a.is3D||b&&+n.isOpposite===r.config.isOpposit)?a.shift:0,x=a.sumValueSpace&&a.sumValueSpace.top||0,y=a.primaryAxisOnleft,C=h.canvasPaddingBottom,k=f(g,d);r&&r.setAxisDimention({x:a.canvasLeft+c+k,y:r.config.isOpposit?a.canvasTop-u-(a.is3D?0:v)-x:a.canvasBottom+v+u,opposite:r.config.isOpposit?a.canvasBottom+v+u:a.canvasTop-u,axisLength:a.canvasWidth-c-k-f(p,d)}),y?(a.yAxisStartXPos=a.canvasLeft-u,a.sYAxisStartXPos=a.canvasRight+u):(a.yAxisStartXPos=a.canvasRight+u,a.sYAxisStartXPos=a.canvasLeft-u),e=a.yAxisStartXPos,t=a.sYAxisStartXPos,l&&l.setAxisDimention({x:e,y:a.canvasTop+m,opposite:t,axisLength:a.canvasHeight-m-C}),s&&s.setAxisDimention({x:t,y:a.canvasTop+m,opposite:e,axisLength:a.canvasHeight-m-C})},a._manageYAxisSpace=function(){var e,t,a,i=this.config,n=this.getChildren("yAxis"),o=[],r=0;for(t=0;t<(n&&n.length);t++)a=(e=n[t])&&e.placeAxis(.7*(i.availableWidth-r))||{},0===t&&(r=a.left),o.push({axisIndex:t,spaceTaken:a});n&&n[0]&&this._allocateSpace({left:(0,p["default"])(o,(function(e){return e.spaceTaken.left})),right:(0,p["default"])(o,(function(e){return e.spaceTaken.right}))}),i.yAxisSpaceAllocation=o},t}(c["default"]);t._feedAxesRawData=n=m.prototype._feedAxesRawData,t.getSpecificxAxisConf=o=m.prototype.getSpecificxAxisConf,t.getSpecificyAxisConf=r=m.prototype.getSpecificyAxisConf,t.setAxisDimention=l=m.prototype.setAxisDimention;var b=m;t["default"]=b},608:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i,l=e.getChildren("canvas")[0],s=function(e,t){return JSON.stringify(e)!==JSON.stringify(t)},c={zoomable:!0,pannable:!0},h=!!Number(e.config.syncaxislimits),u=l.getChildren("axisRefVisualCartesian")[0],d=e._feedAxesRawData(),g=function(e){var t=e.sender;u.addexplicitDrawItems(t.getId(),t),u.asyncDraw()};(0,n.componentFactory)(e,r["default"],"xAxis",1,d.xAxisConf),(0,n.componentFactory)(e,o["default"],"yAxis",2,d.yAxisConf),t=e.getChildren(),a=t.xAxis[0],(i=t.yAxis).forEach((function(t){t.setLinkedItem("canvas",l),u.setLinkedItem(t.getId(),t),u.addExtEventListener("visiblerangeset",g,t),l.attachAxis(t,!0,e.zoomY?c:{})})),a.setLinkedItem("canvas",l),u.setLinkedItem(a.getId(),a),i[1].setAxisConfig({dependentInfo:{id:i[0].getId(),count:!0,limit:h}}),i[1].getState("divlineEventAdded")||(i[1].addExtEventListener("divlinesSet",(function(e){var t=i[1].config.dependentInfo;e.sender.getId()===t.id&&(t.numDivLines=e.data)}),i[0]),i[1].setState("divlineEventAdded",!0));h&&(i[1].getState("dataLimitEventAdded")||(i[1].addExtEventListener("dataLimitSet",(function(e){var t=i[1].config.dependentInfo;e.sender.getId()===t.id&&s(t.dataLimit,e.data)&&(t.dataLimit=e.data,i[1].config.isDataLimitSet&&i[1].setDataLimit())}),i[0]),i[1].setState("dataLimitEventAdded",!0)),i[0].setAxisConfig({dependentInfo:{id:i[1].getId(),limit:!0}}),i[0].getState("dataLimitEventAdded")||(i[0].addExtEventListener("dataLimitSet",(function(e){var t=i[0].config.dependentInfo;e.sender.getId()===t.id&&s(t.dataLimit,e.data)&&(t.dataLimit=e.data,i[0].setDataLimit())}),i[1]),i[0].setState("dataLimitEventAdded",!0)));u.addExtEventListener("visiblerangeset",g,a),l.attachAxis(a,!1,e.zoomX?c:{}),e._setCategories()};var n=a(224),o=i(a(481)),r=i(a(528))},609:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a,o,r,l,s,c,h,u,d,g=e.getFromEnv("dataSource").dataset,p=e.getChildren().canvas[0].getChildren("vCanvas"),f=p[0],m=p[1],b=e.getFromEnv("chartConfig").isdual,v={vCanvasDatasetsDef0:{},vCanvasDatasetsDef1:{}},x={vCanvas0:{},vCanvas1:{}};g||e.setChartMessage();for(a=0;a<g.length;a++)t=g[a],"s"===(h=t.parentyaxis||"").toLowerCase()&&b?(c=(0,i.pluck)(t.renderas,e.config.sDefaultDatasetType),u=m,d=x.vCanvas1,r=v.vCanvasDatasetsDef1):(c=(0,i.pluck)(t.renderas,e.config.defaultDatasetType),u=f,d=x.vCanvas0,r=v.vCanvasDatasetsDef0),c=e.getDSType(c,"s"===h.toLowerCase()),(s=e.getDSGroupdef(c,"s"===h.toLowerCase()))&&((0,i.componentFactory)(u,s,"multiseriesColumnManager"),d[s.getName().toLowerCase()]=!0),d[c.toLowerCase()]=!0,r[c]?(r[c].conf.push(t),r[c].indices.push(a)):(r[c]={},r[c].indices=[a],r[c].classDef=e.getDSdef(c),r[c].conf=[t],r[c].pYAxis=h.toLowerCase(),r[c].parent=s?u.getChildren("multiseriesColumnManager")[0]:u);for(var y in e.config._hascolumn=!1,v)if(v.hasOwnProperty(y))for(c in r=v[y])r.hasOwnProperty(c)&&("group"===(l=r[c]).parent.getType()&&l.parent.configure(l.conf),(0,i.datasetFactory)(l.parent,l.classDef,"dataset_"+c,l.conf.length,l.conf,l.indices),"column"===c&&(e.config._hascolumn=!0));(o=e.getDatasets()).sort((function(e,t){var a=e.getName(),i=t.getName(),n={line:1,area:2,column:3};return n[a]>n[i]?-1:n[a]<n[i]?1:0})),e.config.datasetOrder=o,(0,n.removeComponents)(p[0],Object.keys(x.vCanvas0)),(0,n.removeComponents)(p[1],Object.keys(x.vCanvas1))};var i=a(224),n=a(610)},610:function(e,t,a){"use strict";t.__esModule=!0,t.removeComponents=void 0;t.removeComponents=function(e,t){e&&e.iterateComponents((function(e){-1!==t.indexOf(e.getName().toLowerCase())||e.getLinkedParent().getState("removed")||e.remove()}))}},622:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(556)),r=a(224),l=i(a(623)),s=a(232),c=a(624),h=i(a(625)),u=r.preDefStr.setRolloverAttrStr,d=r.preDefStr.setRolloutAttrStr;(0,s.addDep)({name:"mssplineareaAnimation",type:"animationRule",extension:h["default"]});var g=function(e){function t(){var t;return(t=e.call(this)||this).drawCommonElements=r.stubFN,t}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.configureAttributes=function(t){e.prototype.configureAttributes&&e.prototype.configureAttributes.call(this,t),l["default"].call(this)},a.getDataLimits=function(){return{max:this.config.maxValue,min:this.config.minValue}},a.drawPlots=function(){var e,t,a,i,n,o,l,s,h,g,p,f,m,b,v,x,y,C,k,S,w,A,L,N,F,T=this.config,E=this.getFromEnv("chart"),P=E.config,_=this.getFromEnv("xAxis"),D=null,I=[],M=this.components.data,O=P.connectnulldata,R=P.minimizetendency,B=T.plotBorderDashStyle,V=T.plotborderthickness,z=this.getContainer(),G=[],H=this.getGraphicalElement("splineElement"),W=T.fillColor,j=this.components.removeDataArr||[],U=j.length,q=z&&z.shadowGroup,Y=T.shadow,X=this.getState("visible"),K={},Z=!P.drawfullareaborder,J=T.plotborderColorObject,$=this.getGraphicalElement("connector"),Q=this.getFromEnv("animationManager"),ee=T._oldStartIndex,te=T._oldEndIndex,ae=this.config.JSONData.renderas||E.config.defaultDatasetType,ie=/area/gi.test(ae);for(T.imagesLoaded=0,M||(M=this.components.data),e=_.getTicksLen(),N=T.scrollMinVal,F=T.scrollMaxVal,N>ee&&this.flushOnScroll(ee,N>te?te:N),F<te&&this.flushOnScroll(F<ee?ee:F,te),T._oldStartIndex=N,T._oldEndIndex=F,t=N;t<F;t++)(h=M[t])&&(f=(s=h&&h.config).setValue,k=(K=s.anchorProps).shadow,g=h.graphics.element,p=h.graphics.hotElement,w=h.graphics.image,null===f?(g&&g.hide(),p&&p.hide(),w&&w.hide(),O||(D=null)):(n=s._Py,i=s._Px,!1===X&&(n=s._Pby),I.push({x:i,y:n,lastXPos:o,lastYPos:D}),o=i,D=n,v=K.anchorAlpha,C=K.radius&&v,b=s.hoverEffects,y=g?X&&C?"updating":"disappearing":"appearing",K.imageUrl?this.drawAnchorImage(h):(x=Object.assign({},s.props.element.attr),"disappearing"!==y&&X||(x=r.UNDEF),g=h.graphics.element=Q.setAnimation({el:g||"path",attr:x,container:z.plotGroup,component:this,label:"anchor"}),w&&w.hide(),g&&g.show().shadow(k,z.anchorShadowGroup).data("anchorRadius",K.radius).data("anchorHoverRadius",b.anchorRadius).data("eventArgs",s.eventArgs),b.enabled&&g&&g.data("anchorRadius",K.radius).data("anchorHoverRadius",b.anchorRadius).data("hoverEnabled",b.enabled).data(u,b.attrs.setRolloverAttr).data(d,b.attrs.setRolloutAttr))));for(a=e,A={path:G=(G=(l=(0,c.getSplinePath)(I,s&&s._Pby,R,ie,a)).closedPath).join(),stroke:(0,r.toRaphaelColor)(J),"stroke-width":Z?0:V,fill:(0,r.toRaphaelColor)(W),"stroke-linecap":"round","stroke-linejoin":V>2?"round":"miter","stroke-dasharray":B},this.getState("visible")||(A=r.UNDEF),(m=Q.setAnimation({el:H||"path",attr:A,container:z.commonElemsGroup,component:this,label:"line"}))&&m.addPattern({patternType:T.patternType,patternAngle:T.patternAngle,patternDensity:T.patternDensity,patternSize:T.patternSize,color:T.plotfillcolor,patternAlpha:T.patternAlpha,patternBgColor:T.patternBgColor,alpha:T.plotfillalpha,x:0,y:0},T.usePattern),!m&&H&&this.removeGraphicalElement(H),H||this.addGraphicalElement("splineElement",m),""!==G&&this.getState("visible")?m.show().shadow(Y,q):m&&m.hide(),Z?(L={path:l.openPath.join(),stroke:(0,r.toRaphaelColor)(J),"stroke-width":V,"stroke-linecap":"round","stroke-linejoin":V>2?"round":"miter","stroke-dasharray":B,name:"connector"},S=Q.setAnimation({el:$||"path",attr:L,container:z.commonElemsGroup,state:$?this.getState("visible")?"updating":"disappearing":"appearing",component:this,label:"connectorLine"}),$||this.addGraphicalElement("connector",S)):S&&this.removeGraphicalElement(S),t=0;t<U;t++)this._removeDataVisuals(j.shift())},a.getName=function(){return"splinearea"},t}(o["default"]);t["default"]=g},623:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=a(224),n=function(e,t,a){var i,n,r,l,s={};for(n=0;n<e.length;++n)s["D"+e[n].index]=0;for(i=0;i<10;++i)for(n=0;n<e.length;++n)r=0===n?(3*(e[n+1].y-e[n].y)-s["D"+e[n+1].index])/2:n===e.length-1?(3*(e[n].y-e[n-1].y)-s["D"+e[n-1].index])/2:(3*(e[n+1].y-e[n-1].y)-s["D"+e[n+1].index]-s["D"+e[n-1].index])/4,s["D"+e[n].index]=r;for(l=Math.round(t/(e.length-1)),n=1;n<e.length;++n)o(n,e,s,a,l)},o=function(e,t,a,i,n){var o,r,l,s,c,h,u,d,g,p,f,m,b=t,v=e;for(o=a["D"+b[0].index],r=a["D"+b[v].index],l=b[0].y,s=o,c=3*(b[v].y-b[0].y)-2*o-r,h=2*(b[0].y-b[v].y)+o+r,u=i.max,d=i.min,g=0,p=n;g<=p;g++)(m=l+s*(f=g/p)+c*f*f+h*f*f*f)<d&&(d=m),m>u&&(u=m);i.max=u,i.min=d},r=function(){var e,t=this.config,a=this.getFromEnv("chart"),o=this.getFromEnv("chartConfig"),r=a.config.origRenderWidth,l=o.connectnulldata,s=o.minimizetendency,c=this.components.data,h=Number.MIN_VALUE,u=Number.MAX_VALUE;0===s&&(e=function d(e,t,a,i,o){var r=[],l=!1,s=i||0,c=o;for(c=c||{max:Number.MIN_VALUE,min:Number.MAX_VALUE};s<e.length;++s)if(l){if(isNaN(e[s].config.setValue)||null===e[s].config.setValue){if(a)continue;break}r.push({index:s,y:e[s].config.setValue})}else{if(isNaN(e[s].config.setValue)||null===e[s].config.setValue)continue;l=!0,r.push({index:s,y:e[s].config.setValue})}return r.length>2&&n(r,t,c),s<e.length&&!a&&d(e,t,a,s,c),c}(c,r,l),t.maxValue=Math.max(t.maxValue,e.max),t.minValue=Math.min(t.minValue,e.min),t.maxValue===h&&(t.maxValue=i.UNDEF),t.minValue===u&&(t.minValue=i.UNDEF))};t["default"]=r},624:function(e,t,a){"use strict";t.__esModule=!0,t.getSplinePath=function(e,t,a,r,l){var s,p,f,m,b,v,x,y,C,k,S,w,A,L,N,F,T,E,P,_,D,I,M,O,R,B,V=a,z=[null],G=[],H=[];for(R=0,B=e.length;R<B;R+=1)A=e[R],M=e[R-1]||{},O=e[R+1]||{},v=A.x,f=A.y,x=M.x,m=M.y,y=O.x,b=O.y,C=A.lastYPos,k=A.lastXPos,P=G.length,S=H.length,V?null!==C?(p=D,R===e.length-1?(E=z[R-_-1],T=h(F=L=(v+x)/2,E,x,m),(m>f&&T<f||m<f&&T>f)&&(F=u(T=f,E,x,m)),D.push(F,T,L,(f+m)/2,v,f),G.push(D),H.push(D),r&&g(G,!0,I,t),r&&g(H,!1)):(E=z[R-_-1],m>f&&b>=f||m<f&&b<=f?(w=0,L=d(x,m,v,f),N=f,R-_!=1?(T=h(F=L,E,x,m),(m>f&&T<f||m<f&&T>f)&&(F=u(T=f,E,x,m)),D.push(F,T,L,N,v,f)):D.push((v+x)/2,(f+m)/2,L,N,v,f)):m===f?(w=0,D.push(x,m,v,f,v,f)):(m>f&&f>b||m<f&&f<b)&&(w=c(x,m,y,b),L=d(x,m,v,f),N=h(L,w,v,f),(m>f&&N>m||m<f&&N<m)&&(L=u(N=m,w,v,f)),R-_!=1?(T=h(F=L,E,x,m),(m>f&&T<f||m<f&&T>f)&&(F=u(T=f,E,x,m)),D.push(F,T,L,N,v,f)):D.push((v+x)/2,(f+m)/2,L,N,v,f)),z.push(w))):null===C&&0!==R?(p||(p=[]),p[0]===o&&(G.push(D),H.push(D),r&&g(G,!0,I,t),r&&g(H,!1)),G.push([i,v,f]),H.push([i,v,f]),I=v,D=[o],_=R,z=[null]):(G.push([i,v,f]),H.push([i,v,f]),I=v,D=[o],_=R):null!==C?P>=2?(G[P-1][0]===i&&G.push([n]),H[S-1][0]===i&&H.push([n]),P=G.length,S=H.length,p=G[P-1],s=p.length,G[P-1].push(v),G[P-1].push(f),H[S-1].push(v),H[S-1].push(f),R===l-1&&p[0]===n&&(g(G,!0,I,t),g(H,!1))):(G.push([i,k,C]),G.push([n,v,f]),H.push([i,k,C]),H.push([n,v,f]),I=k):null===C&&P>=2&&((p=G[P-1])[0]===n&&(g(G,!0,I,t),g(H,!1)),G.push([i,v,f]),H.push([i,v,f]),I=v);p=G[G.length-1],r&&p&&(s=p.length,"Z"===p[s-1]||p[0]!==n&&p[0]!==o||(g(G,!0,I,t),g(H,!1)));r||(G=V?G:H).length>=2&&g(G,!1);return{closedPath:G,openPath:H}};var i="M",n="R",o="C",r=Math,l=r.sqrt,s=r.abs,c=function(e,t,a,i){return(i-t)/(a-e)},h=function(e,t,a,i){return(e-a)*t+i},u=function(e,t,a,i){return(e-i)/t+a},d=function(e,t,a,i){var n=(i-t)/l((a-e)*(a-e)+(i-t)*(i-t)),o=s(.5*n);return e*o+a*(1-o)},g=function(e,t,a,i){var r=e.length,l=e[r-1],s=l.length,c=l[0],h=l[s-2];s<3||(c!==n&&c!==o||3!==s||(e[r-1][0]="L"),t&&e.push(["L",h,i,a,i,"Z"]))}},625:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=a(224);function n(e){var t,a,n,o=e.length,r=[],l=!1,s=!0;for(n=0;n<o;++n)t=e[n],s?(r.push(t),a=(0,i.extend2)([],t),s=!1):"Z"!==t?l||(r.push(t),t.toString()===e[n-1].toString()&&(l=!0)):(s=!0,l=!1,a[0]="L",r.push(a,"Z"));return r}function o(e){var t=e.component,a=t.components.data,i=t.getLinePath(a,null,"zero"),n=i.getPathArr().slice(0,i.getPathArr().length/2),o=e.attr;return[{initialAttr:{opacity:0,path:n},finalAttr:{opacity:1,path:o&&o.path},startEnd:{start:0,end:.5},slot:"plot",hookFn:function(){this.attr({opacity:1})}}]}function r(e){return"label-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:"plot-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]}function l(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]}function s(e){var t=e.component,a=t.components.data,i=t.getLinePath(a,null,"zero"),o=e.attr;return[{initialAttr:{opacity:0,path:n(i.getPathArr())},finalAttr:{opacity:1,path:o&&o.path},startEnd:{start:0,end:.5},slot:"plot",hookFn:function(){this.attr({opacity:1})}}]}var c={"*.dataset.splinearea":function(){return{"anchor.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}],"anchor.updating":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"anchor.disappearing":[{finalAttr:{opacity:0,"fill-opacity":0,"stroke-opacity":0},slot:"final"}],"line.appearing":s,"label.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"label.updating":l,"group.appearing":r,"connectorLine.appearing":o}}};t["default"]=c},626:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(555)),r=a(224),l=i(a(623)),s=a(232),c=a(624),h=i(a(627));(0,s.addDep)({name:"mssplineAnimation",type:"animationRule",extension:h["default"]});var u=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"spline"},a.configureAttributes=function(t){e.prototype.configureAttributes&&e.prototype.configureAttributes.call(this,t),l["default"].call(this)},a.getDataLimits=function(){return{max:this.config.maxValue,min:this.config.minValue}},a.drawCommonElements=function(){var e,t,a,i,n,o=this.components.data,l=this.config,s=Number(this.getFromEnv("chartConfig").connectnulldata),h=this.getFromEnv("xAxis"),u=this.getFromEnv("yAxis"),d=l.lineDashStyle,g=l.linethickness,p=[],f=null,m={color:l.linecolor,alpha:l.alpha},b={x:h.getLimit(),y:u.getLimit()},v=this.getState("visible")?o.length:0,x=l.lineOb||{},y=[],C=this.getFromEnv("chart"),k=/area/gi.test(C.defaultDatasetType);for(b.x.minPixel=h.getPixel(b.x.min),b.x.maxPixel=h.getPixel(b.x.max),b.y.minPixel=u.getPixel(b.y.min),b.y.maxPixel=u.getPixel(b.y.max),b.y.base=u.getPixel(0),b.x.base=h.getPixel(0),t=0;t<v;++t)(a=o[t])&&(n=(i=a.config||{}).setValue,i._Pbx=void 0,i._Pby=void 0,y[t]={config:{_Px:i._Px,_Py:i._Py,setValue:i.setValue}},null!=n?(p.push({x:i._Px,y:i._Py,lastYPos:f,lastXPos:e}),f=i._Py,e=i._Px):s||(f=null));l.pathStartIndex=0,l.pathEndIndex=void 0,x["default"]=x["default"]||{},x["default"].used=!0,x["default"].path=[{pathArr:(0,c.getSplinePath)(p,u.getPixel(u.getAxisBase()),C.config.minimizetendency,k).closedPath,path2Arr:[],getPathArr:function(){var e=this.pathArr,t=this.path2Arr;return e.length||t.length?e.concat(t):[]}}],x["default"].attr={"stroke-dasharray":d,"stroke-width":g,stroke:(0,r.toRaphaelColor)(m),"stroke-linecap":"round"},this._drawCommonElementsHelper(x),this.config.lineOb=x,l.prevLim=b,l.prevDataStore=y},t}(o["default"]);t["default"]=u},627:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n={"*.dataset.spline":i(a(558))["default"]["*.dataset.line"]};t["default"]=n},628:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=a(224),l=Math,s=l.min,c=l.max,h=l.abs,u=function(e){function t(){var t;return(t=e.call(this)||this).setState("visible",!0),t}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"group"},t.getName=function(){return"columnMultiSeriesgroup"},a.getName=function(){return"columnMultiSeriesgroup"},a.preConfigure=function(t){if(!t)return!1;this.config.JSONData=t,e.prototype.preConfigure.call(this,t)},a.configure=function(t){if(!t)return!1;e.prototype.configure.call(this,t)},a.setVisibility=function(){var e=0;this._mapChildren((function(e){e.setVisibility&&e.setVisibility()})),this._mapChildren((function(t){t.getState("visible")&&e++})),this.setState("visible",!!e)},a.createContainer=function(){var e,t,a=this.getFromEnv("animationManager"),i=this.getLinkedParent().getChildContainer();for(e in i)t=i[e],!this.getChildContainer(e)&&this.addChildContainer(e,a.setAnimation({el:"group",attr:{name:"manager-"+e},component:this,container:t}))},a.allocatePosition=function(){this.setColumnPosition()},a.draw=function(){this.createContainer()},a.getCanvasPadding=function(){var e,t,a={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0};return this.setColumnPosition(),this._mapChildren((function(i){for(t in e=!i.getState("removed")&&i.getState("visible")&&i.getCanvasPadding&&i.getCanvasPadding()||{})e.hasOwnProperty(t)&&(a[t]=Math.max(e[t],a[t]))})),a},a.setColumnPosition=function(){var e,t,a,i,n,o=this.getFromEnv("chartConfig"),l=this.getFromEnv("chart-attrib"),u=this.getFromEnv("xAxis"),d=this.getFromEnv("numOfColumns"),g=o.plotSpacePercent,p=c((0,r.pluckNumber)(g,20)%100,0),f=p/200,m=u.getPixel(0),b=u.getPixel(1),v=this.getFromEnv("chart").isBar?o.maxBarHeight:o.maxColWidth,x=h(b-m),y=o.plotPaddingPercent,C=!0,k=o.overlapColumns,S=0,w=0,A=0;this.addToEnv("groupMaxWidth",x),this._mapChildren((function(e){e.getState("removed")||!1===e.getState("visible")||(w++,e.addToEnv("updatedIndex",A++))})),this.addToEnv("numOfColumns",w),this.addToEnv("numColDiff",(0,r.pluckNumber)(d-w,0)),e=(1-.01*g)*x||s(x*(1-2*f),v*(w||1)),void 0===l.plotspacepercent&&e>=o.canvasWidth/2&&(e=x-v/2),i=s((t=0===w?e:e/w)-1,w>1?k||void 0!==y?y>0?t*y/100:0:4:0),this.addToEnv("oldPlotWidth",this.getFromEnv("plotWidth")),this.addToEnv("plotWidth",t-i),this.addToEnv("oldPlotPadding",this.getFromEnv("plotPadding")),this.addToEnv("plotPadding",i),a=-(w/2*t-t/2),this.addToEnv("oldGroupNetWidth",this.getFromEnv("groupNetWidth")),this.addToEnv("groupNetWidth",e),this._mapChildren((function(e){!e.getState("removed")&&e.getState("visible")&&(e.addToEnv("shift",a+S*t+i/2),S++)})),b-(n=e/2)-(m-n+e)<4&&(C=!1),0===p&&(C=!0),this.addToEnv("isCrisp",C)},a.childChanged=function(e){void 0===e&&(e={});var t,a,i=this.config,n=this.getLinkedParent(),o=0,r=this.getState("visible"),l={};this._mapChildren((function(e){e.getState("visible")&&o++})),this.setState("visible",!!o),r!==!!o&&(a=!0),!1!==e.dataLimitChanged&&((t=this.getDataLimits()).min===i.range.min&&t.max===i.range.max||(i.range.min=t.min,i.range.max=t.max,l.dataLimitChanged=!0,a=!0)),a?n.childChanged&&n.childChanged(l):this.asyncDraw()},a.getAxisValuePadding=function(){var e={},t=-Infinity,a=-Infinity;return this._mapChildren((function(i){i.getState("removed")||(e=i.getAxisValuePadding&&i.getAxisValuePadding()||{},t=Math.max(t,e.left||-Infinity),a=Math.max(a,e.right||-Infinity))})),t===-Infinity&&(t=0),a===-Infinity&&(a=0),this.config.padding||(this.config.padding={},this.config.padding.left=t,this.config.padding.right=a),{left:t,right:a}},a.getDataLimits=function(e){var t,a=+Infinity,i=-Infinity,n=0,o=function(e){i=Math.max(i,e.max),a=Math.min(a,e.min)};return this._mapChildren((function(a){a.getState("removed")||(!1!==a.getState("visible")?(n++,t=a.getDataLimits(e),o(t)):e&&(t=a.getDataLimits(e),o(t)))})),n?this.setState("visible",!0):this.setState("visible",!1),this.config.range||(this.config.range={},this.config.range.min=this.config.dataMin,this.config.range.max=this.config.dataMax),{max:i,min:a}},a.isVisible=function(){return!this.isNotVisible},t}(o.ComponentInterface);t["default"]=u},629:function(e,t,a){"use strict";t.__esModule=!0,t.scrollTo=function(e){var t=this.apiInstance;t.addJob("scrollToAPoint",(function(){if(e>=0&&e<=1){var a=t.getChildren&&t.getChildren(),i=a.xAxis[0],n=a.scrollBar&&a.scrollBar[0],o=n&&n.getChildren("scrollAnchor")[0],r=i.getLimit&&i.getLimit(),l=i.getVisibleConfig&&i.getVisibleConfig(),s=l.maxValue-l.minValue,c=r.max-r.min,h=e*(c-s)+r.min,u=h+s,d=(l.minValue-r.min)/(c-s);o.config.scrollPosition=e,t.fireChartInstanceEvent("scrollStart",{scrollPosition:d}),i.setVisibleConfig(h,u),t.fireChartInstanceEvent("scrollEnd",{previousScrollPosition:d,scrollPosition:e})}}),i.priorityList.postRender)},t.setAxisScale=function(e){void 0===e&&(e="column");var t,a,i,r,l,s=this.config,c=this.getChildren("xAxis")[0],h=c.getTicksLen(),u="bar2d"===e,d=u?"bar2D":e,g=this.getFromEnv("dataSource").chart,p=u?s.height:s.width,f=0,m=s.scrollToEnd,b=(0,n.pluckNumber)(g.numvisibleplot,o(p/s.avgScrollPointWidth));s.isstacked?this.iterateComponents((function(e){"cartesianStackGroup"===e.getName()&&!e.getState("removed")&&f++})):this.iterateComponents((function(e){e.getType&&"dataset"===e.getType()&&e.getName&&e.getName().toLowerCase()===d&&!e.getState("removed")&&f++}));i=h*(f=f||1);var v=c.getVisibleConfig();a=v.maxValue,t=v.minValue,b>=2&&b<i?(r=b/f,this.setScrollType("always"),m?t=a-r:a=t+r,0===t&&(a-=1),c.setVisibleConfig(t,a)):(l=c.getLimit(),c.setVisibleConfig(l.min,l.max),this.setScrollType("none"))},t.resetViewPortConfig=function(){this.config.viewPortConfig={scaleX:1,scaleY:1,x:0,y:0}},t.configurer=function(){var e,t=this.getFromEnv("dataSource").chart;(e=this.config).scrollToEnd=(0,n.pluckNumber)(t.scrolltoend,0),e.lastScrollPosition=void 0};var i=a(236),n=a(224),o=Math.floor},634:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(565)),r=i(a(538)),l=i(a(628)),s=function(e){(0,n["default"])(a,e),a.getName=function(){return"MSColumn2D"};var t=a.prototype;function a(){var t;return(t=e.call(this)||this).eiMethods={},t}return t.getName=function(){return"MSColumn2D"},t.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.friendlyName="Multi-series Column Chart",this.config.defaultDatasetType="column",this.config.enablemousetracking=!0},t.getDSdef=function(){return r["default"]},t.getDSGroupdef=function(){return l["default"]},a}(o["default"]);t["default"]=s},637:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(240),r=a(224),l=a(232),s=i(a(638)),c=r.preDefStr.visibleStr,h=Math,u=h.min,d=h.max;(0,l.addDep)({name:"cartesianStackAnimation",type:"animationRule",extension:s["default"]});var g=function(e){function t(){var t;return(t=e.call(this)||this).setState("visible",!0),t}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"group"},t.getName=function(){return"cartesianStackGroup"},a.getName=function(){return"cartesianStackGroup"},a.preConfigure=function(t){if(!t)return!1;this.config.JSONData=t,e.prototype.preConfigure.call(this,t)},a.configure=function(t){if(!t)return!1;e.prototype.configure.call(this,t)},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t);var a=this.config,i=this.getFromEnv("chartConfig"),n=this.getFromEnv("chart-attrib");a.showTextOutline=(0,r.pluckNumber)(n.textoutline,0),a.showSum=(0,r.pluckNumber)(n.showsum,i.showSum,0),a.sumInside=0},a.setSkippingInfo=function(e){this.addToEnv("skipInfo",e||{drawOnlyMap:[],plotsPerBin:1,draw:[],hide:[],skippingApplied:!1,dragHashMap:[],prevDrawArray:[]})},a.getSkippingInfo=function(){return this.getFromEnv("skipInfo")||{drawOnlyMap:[],plotsPerBin:1,draw:[],hide:[],skippingApplied:!1,dragHashMap:[],prevDrawArray:[]}},a.setVisibility=function(){var e=0;this._mapChildren((function(t){t.getState("visible")&&e++})),this.setState("visible",!!e)},a.createContainer=function(){var e,t,a=this.getFromEnv("animationManager"),i=this.getLinkedParent(),n=i.getChildContainer();for(e in n)t=n[e],!this.getChildContainer(e)&&this.addChildContainer(e,a.setAnimation({el:"group",attr:{name:"manager-"+e},container:t,component:this}));!this.getContainer("sumLabelsLayer")&&this.addContainer("sumLabelsLayer",a.setAnimation({el:"group",attr:{name:"manager-sumLabelsLayer","class":"fusioncharts-datalabels"},label:"group",container:i.getChildContainer("sumLabelsLayer"),component:this})),!this.getChildContainer("commonElemGroupLine")&&this.addChildContainer("commonElemGroupLine",a.setAnimation({el:"group",attr:{name:"manager-common-elem-group"},label:"group",container:i.getChildContainer("lineVcanvasGroup"),component:this})),!this.getChildContainer("commonElemGroup")&&this.addChildContainer("commonElemGroup",a.setAnimation({el:"group",attr:{name:"manager-common-elem-group"},label:"group",container:i.getChildContainer("areaVcanvasGroup"),component:this})),!this.getChildContainer("anchorGroup")&&this.addChildContainer("anchorGroup",a.setAnimation({el:"group",attr:{name:"manager-anchor-group"},label:"group",container:this.getFromEnv("useLinePlotGroupForAnchorPlacement")?i.getChildContainer("lineVcanvasGroup"):i.getChildContainer("areaVcanvasGroup"),component:this}))},a.draw=function(){this.createContainer(),this.getFirstDataSet(),this.drawSumValue()},a._setStackPosition=function(){var e,t=+Infinity,a=-Infinity,i=this.getFromEnv("numOfColumns"),n=0,o=[],l=[],s=this.getSkippingInfo&&this.getSkippingInfo()||{},c=s.draw||[],h=c.length,g=s.skippingApplied,p=0;this._mapChildren((function(i){if(!i.getState("removed")&&!1!==i.getState("visible")){i.addToEnv("stackIndex",p++),n++;var r,s,f,m,b=i.getData(),v=0,x=b&&b.length,y=0;for(g&&(x=h),f=0;f<x;f++)(r=b[s=c[f]||f])&&r.config&&void 0!==r.config.setValue&&(o[s]||(o[s]={}),m=r.config.setValue,e=r.config.setLink,o[s].positive||(o[s].positive=0),o[s].negative||(o[s].negative=0),m>=0?(v=m+(y=o[s].positive),o[s].positive=v):m<0&&(v=m+(y=o[s].negative),o[s].negative=v),null!==m&&(o[s].isNotNull=!0),l[s]=e,a=d(v,a),t=u(v,t),r.config._y=v,r.config._b=y)}})),this.config.setLink=l,this.config.stackValues=o,this.config.dataMin=t,this.config.dataMax=a,n?this.setState("visible",!0):this.setState("visible",!1),this.addToEnv("stackValues",o),this.addToEnv("numOfColumns",n),this.addToEnv("numColDiff",(0,r.pluckNumber)(i-n,0))},a.allocatePosition=function(){this._setStackPosition()},a._getXpos=function(e){var t=this.getFromEnv("shift")||0;return this.getFromEnv("xAxis").getPixel(e)+t},a.drawSumValue=function(e,t){void 0===e&&(e=0);var a,i,n,o,l,s,h,u,d,g,p,f,m,b,v,x,y=this.config,C=this.getFromEnv("yAxis"),k=this.getFromEnv("paper"),S=this.getFromEnv("animationManager"),w=this.getFromEnv("chart"),A=w.isBar,L=this.getFromEnv("smartLabel"),N=w.config,F=N.canvasRight,T=(0,r.pluckNumber)(N.stack100percent),E=N.rotatevalues?270:0,P=y.stackValues,_=y.setLink,D=t||P&&P.length,I=N.dataLabelStyle,M=this.getContainer("sumLabelsLayer"),O=this.getGraphicalElement("sumLabels");if(this.config.showSum){if(M.css(I),L.setStyle(I),(b=O&&O.length)>(v=P.length))for(;b>=v;)x=O[b],b--,x&&(x.hide(),this.removeGraphicalElement(x));for(a=e;a<D;a++)h=Array.isArray(O)&&O[a],P[a]&&P[a].isNotNull?(p=(m=(d=P[a].positive)+(g=P[a].negative))<0?g:d,(f=C.dataLabels(m))&&(o=I.backgroundColor,l=I.borderColor,s=L.getOriSize(f),A?(n=this._getXpos(a),i=C.getPixel(T?100:p),T?i+=s.width/2:i-=i+s.width>F?i+s.width-F:0):(i=this._getXpos(a),n=C.getPixel(T?100:p)),(u=this.getSumValuePosition(s,{stack100percent:T,rotateValues:E,xPos:i,yPos:n,offsetY:p,index:a})).text=f,u.cursor=_[a]&&1===this.config.sumInside?r.POINTER:"",u.fill=I.color,u["text-bound"]=[o,l,I.borderThickness,I.borderPadding,I.borderRadius,I.borderDash],u["line-height"]=I.lineHeight,u.visibility=c,u.transform=k.getSuggestiveRotation(E,u.x,u.y),u["text-anchor"]&&delete u["text-bound"],M&&M.show(),(h=S.setAnimation({el:h||"text",attr:u,label:"text",container:M,component:this})).show(),h.outlineText(y.showTextOutline,u.fill),Array.isArray(O)&&O[a]||this.addGraphicalElement("sumLabels",h,!0))):h&&h.hide()}else M.hide()},a.getSumValuePosition=function(e,t){var a,i,n,o,r,l,s,c=this.getFromEnv("chart"),h=c.config,u=this.getFromEnv("xAxis"),d=c.getChildren("scrollBar")&&c.getChildren("scrollBar")[0],g=h.canvasBottom,p=h.canvasTop,f=c.config.is3D,m=c.isBar,b=t.stack100percent,v=h.yDepth,x=h.xDepth,y=t.yPos,C=t.xPos,k=this.getFromEnv("canvasConfig").canvasBorderWidth,S=t.offsetY;if(t.rotateValues?(l=e.width,s=e.height):(l=e.height,s=e.width),o=(o=a=l)/2+2,r=(r=i=s)/2+2,b)if(p<=a)y=o;else{var w=u.getAxisConfig("isOpposit"),A=f?0:w?u.getAxisConfig("axisLineThickness"):0,L=d&&d.config.isOpposite,N=c.isScrollEnabled()&&L?c.config.shift:0;y=m?t.yPos:p-o-k-N-A,C+=m?k+A+N:0}else S>=0&&(m?((n=h.canvasLeft+h.canvasWidth-C)<i?(C=C-r+n,this.config.sumInside=1):C+=r,f&&(y+=v/2)):(n=y-p)<a?(this.config.sumInside=1,y=y+o-n):(y-=m?0:o,C+=m?2:0,this.getFromEnv("useImprovedLabelPlacement")&&(y=this._adjustSumValuePosition(t.index,!0,y,o))-o<p&&(y=p+o))),S<0&&(m?C=(n=C-h.canvasLeft)<i?C+r+2-n:C-r-2:(n=g-y)<a?y-=o:(y+=o,this.getFromEnv("useImprovedLabelPlacement")&&(y=this._adjustSumValuePosition(t.index,!1,y,o))+o>g&&(y=g-o)),f&&(C-=x,y+=v));return{x:C,y:y}},a.childChanged=function(e){void 0===e&&(e={});var t,a,i=this.config,n=this.getLinkedParent(),o=this.getState("visible"),r=0,l={};this._mapChildren((function(e){e.getState("visible")&&r++})),this.setState("visible",!!r),o!==!!r&&(a=!0),!1!==e.dataLimitChanged&&((t=this.getDataLimits()).min===i.range.min&&t.max===i.range.max||(i.range.min=t.min,i.range.max=t.max,l.dataLimitChanged=!0,a=!0)),a?n.childChanged&&n.childChanged(l):this.asyncDraw()},a.getAxisValuePadding=function(){var e={},t=-Infinity,a=-Infinity;return this._mapChildren((function(i){i.getState("removed")||(e=i.getAxisValuePadding&&i.getAxisValuePadding()||{},t=Math.max(t,e.left||-Infinity),a=Math.max(a,e.right||-Infinity))})),t===-Infinity&&(t=0),a===-Infinity&&(a=0),this.config.padding||(this.config.padding={},this.config.padding.left=t,this.config.padding.right=a),{left:t,right:a}},a.getDataLimits=function(e){return this._setStackPosition(),this.config.range||(this.config.range||(this.config.range={}),this.config.range.min=this.config.dataMin,this.config.range.max=this.config.dataMax),e?this._getStackLimit():{max:this.config.dataMax,min:this.config.dataMin}},a._getStackLimit=function(){var e=+Infinity,t=-Infinity,a=[],i=this.getSkippingInfo&&this.getSkippingInfo()||{},n=i.draw||[],o=n.length,r=i.skippingApplied;return this._mapChildren((function(i){if(!i.getState("removed")){var l,s,c,h,g=i.getData(),p=0,f=g&&g.length;for(r&&(f=o),c=0;c<f;c++)(l=g[s=n[c]||c])&&l.config&&void 0!==l.config.setValue&&null!==l.config.setValue&&(a[s]||(a[s]={}),h=l.config.setValue,a[s].positive||(a[s].positive=0),a[s].negative||(a[s].negative=0),h>0?(p=h+a[s].positive,a[s].positive=p):h<0&&(p=h+a[s].negative,a[s].negative=p),t=d(p,t),e=u(p,e))}})),{max:t,min:e}},a.isVisible=function(){return!this.isNotVisible},a.getMaxSumValueSpace=function(){var e,t,a,i,n,o=this.config.stackValues,r=this.getFromEnv("chart"),l={},s=o&&o.length,c=this.getFromEnv("number-formatter"),h=0,u=0,g=this.getFromEnv("smartLabel"),p=r.config.dataLabelStyle;for(g.useEllipsesOnOverflow(r.config.useEllipsesWhenOverflow),g.setStyle(p),e=0;e<s;e++)o[e]&&(n=o[e].positive+o[e].negative,t=c.dataLabels(n),a=(l=g.getOriSize(t)).width,i=l.height,u=d(u,a),h=d(h,i));return{maxWidth:u,maxHeight:h}},a.getCanvasPadding=function(){var e,t,a,i,n,o=this.getSkippingInfo(),r=o.skippingApplied,l=o.draw,s=this.config.stackValues,c=s[r?l[0]:0],h=s[r?l[l.length-1]:s.length-1],u=this.getFromEnv("xAxis"),g=this.getFromEnv("yAxis"),p=this.getFromEnv("chartConfig"),f=this.getFromEnv("smartLabel"),m=u.getValuePadding(),b=0,v=u.getPixel(0),x=p.rotatevalues,y={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0};return this._setStackPosition(),this._mapChildren((function(a){for(t in e=a.getCanvasPadding&&a.getCanvasPadding()||{})e.hasOwnProperty(t)&&(y[t]=Math.max(e[t],y[t]))})),this.config.showSum&&(c&&(a=g.dataLabels(c.positive+c.negative),f.useEllipsesOnOverflow(p.useEllipsesWhenOverflow),f.setStyle(p.dataLabelStyle),i=f.getOriSize(a),n=x?i.height:i.width,c.isNotNull&&(b=(n||0)/2-(u.getPixel(m.left)-v))<0&&(b=0),y.paddingLeft=d(y.paddingLeft,b)),b=0,h&&(a=g.dataLabels(h.positive+h.negative),f.setStyle(p.dataLabelStyle),i=f.getOriSize(a),n=x?i.height:i.width,h.isNotNull&&(b=(n||0)/2-(u.getPixel(m.right)-v))<0&&(b=0),y.paddingRight=d(y.paddingRight,b))),y},a.getFirstDataSet=function(){var e=this.getChildren("dataset");if(e)for(var t=0;t<e.length;t++){var a=e[t];if(a.getState("visible")&&!a.getState("removed")){this.config.firstDataSetIndex=t;break}this.config.firstDataSetIndex=null}},a._adjustSumValuePosition=function(e,t,a,i){var n,o,r=[],l=a,s=this.getChildren();for(n in s)s.hasOwnProperty(n)&&(o=s[n],r=r.concat(o.filter((function(e){return"dataset"===e.getType()}))));return r.forEach((function(a){var n,o,r=a.components.data[e],s=r&&r.config,h=s&&s._state,u=s&&s.props&&s.props.label&&s.props.label.attr;!a.getState("removed")&&a.getState(c)&&u&&h&&(n={y:u.y,height:h.labelHeight},o={y:l,height:i},(n.y<=o.y&&o.y<=n.y+n.height||n.y<=o.y+o.height&&o.y+o.height<=n.y+n.height)&&(l=t?u.y-.6*h.labelHeight-.6*i:u.y+.6*h.labelHeight+.6*i))})),l},t}(o.ComponentInterface);t["default"]=g},638:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(){return[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"plot"}]},n=function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},o={"initial.group.cartesianStackGroup":function(){return{"group.appearing":i,"text.appearing":n,"*":null}},"legendInteraction.group.cartesianStackGroup":{"text.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:0}}]},"initial.group.marimekkoStackgroup":function(){return{"text.appearing":n,"*":null}}};t["default"]=o},641:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t._checkInvalidSpecificData=t["default"]=void 0;var n=i(a(238)),o=i(a(565)),r=i(a(538)),l=i(a(637)),s=i(a(642)),c=function(){var e,t=this.getFromEnv("dataSource"),a=t.dataset,i=t.categories;if(!a||!i)return!0;if(e=a.length)for(;e--;)if(!a[e].dataset)return!0};t._checkInvalidSpecificData=c;var h=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("dataset",s["default"],["vCanvas"]),t}(0,n["default"])(t,e),t.getName=function(){return"MSStackedColumn2D"};var a=t.prototype;return a._checkInvalidSpecificData=function(){return c.call(this)},a.getName=function(){return"MSStackedColumn2D"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.friendlyName="Multi-series Stacked Column Chart",t.defaultDatasetType="column",t.isstacked=!0,t.showSum=0,t.enablemousetracking=!0},a.getDSdef=function(){return r["default"]},a.getDSGroupdef=function(){return l["default"]},t}(o["default"]);t["default"]=h},642:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i,r,l,s,c=e.getFromEnv("dataSource").dataset,h=c&&c.length,u=0,d=e.getChildren("canvas")[0].getChildren("vCanvas")[0],g=[];if(!c)return void e.setChartMessage();for((0,n.componentFactory)(d,o["default"],"multiSeriesGroup_column"),s=d.getChildren("multiSeriesGroup_column")[0],t=0;t<h;t++)g.push(c[t].dataset);for((0,n.componentFactory)(s,e.getDSGroupdef(),"stackedGroup_column",h,g),l=s.getChildren("stackedGroup_column"),t=0;t<l.length;t++)if(!0!==l[t].getState("removed")){if(!(i=c[t].dataset))return void e.setChartMessage();a=i&&i.length,r=Array(a).fill(u).map((function(e,t){return e+t})),(0,n.datasetFactory)(l[t],e.getDSdef(),"dataset_column",a,i,r),u+=a}e.config._lastDatasetIndex=r[r.length-1]};var n=a(224),o=i(a(628))},645:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(224),r=i(a(607)),l=a(641),s=i(a(555)),c=i(a(538)),h=i(a(637)),u=i(a(646)),d=o.preDefStr.SEVENTYSTRING,g=function(e){function t(){var t;return(t=e.call(this)||this).stack100percent=0,t.hasLineSet=!0,t.lineset=!0,t.registerFactory("dataset",u["default"],["vCanvas"]),t}(0,n["default"])(t,e),t.getName=function(){return"MSStackedColumn2DLineDy"};var a=t.prototype;return a.getName=function(){return"MSStackedColumn2DLineDy"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.sDefaultDatasetType="line",t.friendlyName="Multi-series Dual Y-Axis Stacked Column and Line Chart",t.defaultDatasetType="column",t.isdual=!0,t.haslineset=!0,t.isstacked=!0,t.enablemousetracking=!0,t.anchorborderthickness=1,t.anchorimageurl=void 0,t.anchorimagepadding=1,t.anchorsides=1,t.anchoralpha=void 0,t.anchorbgalpha=o.HUNDREDSTRING,t.anchorimagealpha=o.HUNDREDSTRING,t.anchorimagescale=100,t.anchorstartangle=90,t.anchorshadow=0,t.anchorbgcolor=void 0,t.anchorbordercolor=void 0,t.anchorradius=3,t.showvalues=1,t.plotfillalpha=d,t.linedashlen=5,t.linedashgap=4,t.linedashed=void 0,t.linealpha=o.HUNDREDSTRING,t.linethickness=2,t.drawfullareaborder=1,t.connectnulldata=0,t.showSum=0},a._checkInvalidSpecificData=function(){return l._checkInvalidSpecificData.call(this)},a.getDSdef=function(e){return"line"===e?s["default"]:c["default"]},a.getDSGroupdef=function(){return h["default"]},t}(r["default"]);t["default"]=g},646:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i=e.getFromEnv("dataSource"),r=i.dataset,l=i.lineset,s=e.getChildren("canvas")[0].getChildren("vCanvas")[1];if(!r&&0===l.length)return void e.setChartMessage();(0,n["default"])(e),t=e.config._lastDatasetIndex+1,l&&l.length?(a=Array(l.length).fill(t).map((function(e,t){return e+t})),(0,o.datasetFactory)(s,e.getDSdef("line"),"dataset_line",l.length,l,a)):function(e){var t,a=e.getChildren("dataset_line");for(t=a&&a.length-1;t>-1;t--)a[t].remove()}(s)};var n=i(a(642)),o=a(224)},658:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(634)),r=i(a(659)),l=i(a(661)),s=i(a(568)),c=a(224),h=function(e,t,a){var i,n,o,r,l,s,c,h,u,d,g=a&&a.length,p=e,f=t;if(g)for(i=g-1;i>=0;i--)if(c=(o=a[i]).x1,h=o.y1,u=o.x2,d=o.y2,o.isTrendZone){if(p>=c&&p<=u&&f>=h&&f<=d)return o}else if(h!==d&&c!==u?(r=n=(h-d)/(c-u),-1,l=h-n*c,s=Math.abs(r*p+-1*f+l)/Math.sqrt(Math.pow(r,2)+Math.pow(-1,2))):c===u?s=Math.abs(c-p):h===d&&(s=Math.abs(h-f)),s<=o.tolerance)return o},u=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("axis",l["default"],["canvas"]),t.registerFactory("legend",s["default"]),t.registerFactory("quadrant",(function(e){var t,a=e.getChildren("canvas")[0],i=e.getChildren(),n=function(){return t.asyncDraw()};(0,c.componentFactory)(a,r["default"],"quadrant"),(t=a.getChildren("quadrant")[0]).addExtEventListener("visiblerangeset",n,i.xAxis[0]),t.addExtEventListener("visiblerangeset",n,i.yAxis[0]),t.configure()}),["dataset"]),t}(0,n["default"])(t,e),t.getName=function(){return"ScatterBase"};var a=t.prototype;return a.mouseoutHandler=function(e,t,a){var i=this.config.datasetOrder||this.getDatasets(),n=this.getChildren("mouseTracker")[0];i[t]&&i[t].components.data[a]?i[t]._firePlotEvent("fc-mouseout",a,e):this.getFromEnv("toolTipController").hideAll(),delete n._lastDatasetIndex,delete n._lastPointIndex},a.parseChartAttr=function(t){e.prototype.parseChartAttr.call(this,t),this.config.drawTrendRegion=0},a.__setDefaultConfig=function(){var t=this.config;e.prototype.__setDefaultConfig&&e.prototype.__setDefaultConfig.call(this),t.valuefontbold=0,t.stickytracking=1,t.usemessagelog=0,t.animationeffect="linear",t.showshadow=1,t.showhovereffect=void 0,t.plothovereffect=void 0,t.anchorhovereffect=void 0,t.plotborderdashed=void 0,t.stack100percent=void 0,t.showpercentvalues=void 0,t.showpercentintooltip=void 0,t.plotbordercolor=void 0,t.showtooltip=1,t.seriesnameintooltip=1,t.rotatevalues=0,t.minimizetendency=0,t.plotfillangle=270,t.valuepadding=2,t.useplotgradientcolor=1,t.plotborderthickness=1,t.plotfillalpha="70",t.showvalues=1,t.valueposition="auto",t.tooltipsepchar=", ",t.usedataplotcolorforlabels=0,t.placevaluesinside=0,t.showplotborder=1,t.use3dlighting=1,t.useroundedges=0,t.plotspacepercent=20,t.plotpaddingpercent=void 0,t.plotfillratio=void 0,t.maxcolwidth=50,t.plotborderdashlen=5,t.plotborderdashgap=4,t.useScaleRecursively=!0,t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.setadaptivexmin=1},a._drawTrendTooltip=function(e,t){var a=this.getFromEnv("toolTipController"),i=this.config.currentTrendToolTip,n=e.tooltext,o=t.originalEvent;i?a.draw(o,n,i):i=this.config.currentTrendToolTip=a.draw(o,n)},a._mouseEvtHandler=function(e,t){var a,i,n,o,r,l,s,u,d,g,p=this,f=t.mouseTracker,m=p.getChildren("canvas")[0],b=p.getFromEnv("toolTipController"),v=e.originalEvent,x=p.config,y=x.canvasBaseDepth||0,C=x.canvasLeft-(x.toleranceLeft||0),k=x.canvasRight+(x.toleranceRight||0),S=x.canvasBottom+(x.toleranceBottom||0),w=x.canvasTop-(x.toleranceTop||0),A=x.datasetOrder||p.getDatasets(),L=!1,N=A.length,F=f._lastDatasetIndex,T=f._lastPointIndex;if(o=(n=(0,c.getMouseCoordinate)(p.getFromEnv("chart-container"),v,p)).chartX,r=n.chartY,o>C-y&&o<k&&r>w&&r<S+y){for(;N--&&!L;)(l=A[N])&&l.getState("visible")&&((s=l._getHoveredPlot&&l._getHoveredPlot(o,r))&&s.hovered||a)&&(L=!0,s.datasetIndex=N,g=f.getMouseEvents(e,s.datasetIndex,s.pointIndex));a=h(o,r,m.config.vtrendlines),i=h(o,r,m.config.trendlines)}if((!L||g&&g.fireOut)&&void 0!==F&&A[F]&&A[F]._firePlotEvent&&(g&&!g.events.length?f.mouseoutTimer=setTimeout((function(){p.mouseoutHandler(e,F,T)}),20):(p.mouseoutHandler(e,F,T),clearTimeout(f.mouseoutTimer))),L)for(p.config.currentTrendToolTip&&b.hide(p.config.currentTrendToolTip),(d=g.events&&g.events.length)&&(f._lastDatasetIndex=s.datasetIndex,T=f._lastPointIndex=s.pointIndex),u=0;u<d;u+=1)l&&l._firePlotEvent&&l._firePlotEvent(g.events[u],T,e,s.datasetIndex);else a&&a.tooltext?p._drawTrendTooltip(a,e):i&&i.tooltext?p._drawTrendTooltip(i,e):p.config.currentTrendToolTip&&b.hide(p.config.currentTrendToolTip)},a._setCategories=function(){var e=this.getFromEnv("dataSource"),t=this.getChildren("xAxis"),a=String((0,c.pluck)(e.chart.xaxislabelmode,"categories")).toLowerCase(),i=e.categories,n=i&&i[0]&&i[0].category;t[0].setAxisConfig({xAxisLabelMode:"categories"}),"auto"!==a&&"mixed"!==a&&n&&n.length>0?t[0].setTickValues(n):"auto"!==a?(t[0].setTickValues(n),t[0].setAxisConfig({xAxisLabelMode:"mixed"})):(t[0].setTickValues(n),t[0].setAxisConfig({xAxisLabelMode:"auto"}))},a._allocateSpace=function(e){var t=this.getChildren("canvas"),a=t&&t[0].config,i=this.config,n=i.canvasHeight,o=i.canvasWidth,r=i.availableHeight,l=i.availableWidth;i.canvasLeft+=e.left||0,i.canvasTop+=e.top||0,o=i.canvasWidth=Math.max(o-((e.left||0)+(e.right||0)),0),n=i.canvasHeight=Math.max(n-((e.top||0)+(e.bottom||0)),0),i.availableHeight=Math.max(r-((e.top||0)+(e.bottom||0)),0),i.availableWidth=Math.max(l-((e.left||0)+(e.right||0)),0),i.canvasRight=i.canvasLeft+o,i.canvasBottom=i.canvasTop+n,a&&(a.canvasPaddingLeft=Math.max(a.canvasPaddingLeft,e.paddingLeft||0),a.canvasPaddingRight=Math.max(a.canvasPaddingRight,e.paddingRight||0),a.canvasPaddingTop=Math.max(a.canvasPaddingTop,e.paddingTop||0),a.canvasPaddingBottom=Math.max(a.canvasPaddingBottom,e.paddingBottom||0)),t[0].setDimension({top:i.canvasTop,left:i.canvasLeft,width:i.canvasWidth,height:i.canvasHeight})},a._postSpaceManagement=function(){var e,t=this.config,a=this.getChildren(),i=a.xAxis&&a.xAxis[0],n=a.legend&&a.legend[0],o=t.xDepth,r=this.getChildren("canvas");for(this.setAxisDimention(),i&&this._allocateXAxisLabelSpace(i),i&&i.shiftLabels(-o,0),n&&n.postSpaceManager(),e=0;e<(r&&r.length);e++)r[e].setCanvasPadding();this.setAxisDimention(),this.allocateDimensionOfChartMenuBar()},a._checkInvalidSpecificData=function(){if(!this.getFromEnv("dataSource").dataset)return!0},t}(o["default"]);t["default"]=u},659:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(242)),o=i(a(238)),r=a(240),l=a(224),s=a(232),c=i(a(660)),h=l.preDefStr.POSITION_START,u=l.preDefStr.POSITION_TOP,d=l.preDefStr.POSITION_BOTTOM,g=l.preDefStr.POSITION_END;(0,s.addDep)({name:"quadrantAnimation",type:"animationRule",extension:c["default"]});var p=function(e){function t(){var t;t=e.call(this)||this;var a=(0,n["default"])(t);return a.pIndex=1,a.components={},a.conf={},a.graphics={},t}(0,o["default"])(t,e);var a=t.prototype;return a.getType=function(){return"canvas"},a.getName=function(){return"quadrant"},a.configure=function(){var e,t,a,i,n,o,r,s,c,h,u,d,g,p,f,m,b,v,x,y,C,k,S,w,A=this.conf,L=this.getFromEnv("chart"),N=L.config,F=L.getFromEnv("dataSource").chart,T=L.getChildren("canvas")[0].config,E=N.dataLabelStyle,P=L.getFromEnv("smartLabel");(A.enabled=(0,l.pluckNumber)(F.drawquadrant,0))&&(b=(0,l.pluckNumber)(F.quadrantxval),v=(0,l.pluckNumber)(F.quadrantyval),x=(0,l.convertColor)((0,l.pluck)(F.quadrantlinecolor,T.canvasBorderColor),(0,l.pluck)(F.quadrantlinealpha,F.quadrantlinealpha,l.HUNDREDSTRING)),y=(0,l.pluckNumber)(F.quadrantlinethickness,T.canvasBorderThickness),k=(0,l.pluckNumber)(F.quadrantlinedashed,F.quadrantlineisdashed,0),C=(0,l.pluckNumber)(F.quadrantlinedashlen,4),S=(0,l.pluckNumber)(F.quadrantlinedashgap,2),w=k?(0,l.getDashStyle)(C,S):"none",A.xVal=b,A.yVal=v,A.quadrantLineColor=x,A.quadrantLineThickness=y,A.dashStyle=w,g=(0,l.parseUnsafeString)((0,l.getValidValue)(F.quadrantlabeltl,"")),p=(0,l.parseUnsafeString)((0,l.getValidValue)(F.quadrantlabeltr,"")),f=(0,l.parseUnsafeString)((0,l.getValidValue)(F.quadrantlabelbl,"")),m=(0,l.parseUnsafeString)((0,l.getValidValue)(F.quadrantlabelbr,"")),A.quadrantLabelPadding=(0,l.pluckNumber)(F.quadrantlabelpadding,3),P.useEllipsesOnOverflow(N.useEllipsesWhenOverflow),P.setStyle(E),""!==g?(o=(0,l.getFirstValue)(F.quadrantlabeltlbordercolor,F.quadrantlabelbordercolor,""),r=(0,l.pluck)(F.quadrantlabeltlbgcolor,F.quadrantlabelbgcolor),s=(0,l.pluckNumber)(F.quadrantlabeltlborderthickness,F.quadrantlabelborderthickness,1),o=o?(0,l.convertColor)(o,(0,l.pluckNumber)(F.quadrantlabeltlborderalpha,F.quadrantlabelborderalpha,F.quadrantlabeltlalpha,F.quadrantlabelalpha,100)):"",(c=A.tlConfig)||(c=A.tlConfig={enabled:!0,styleObj:{}}),c.label=g,c.styleObj.fontSize=(0,l.pluck)((0,l.pluckNumber)(F.quadrantlabeltlfontsize,F.quadrantlabelfontsize),parseInt(E.fontSize,10))+"px",c.styleObj.fontSizeWithUnit=(0,l.pluckFontSizeMaintainUnit)((0,l.pluckNumber)(F.quadrantlabeltlfontsize,F.quadrantlabelfontsize),E.fontSizeWithUnit),c.styleObj.lineHeight=E.lineHeight,c.styleObj.fontFamily=(0,l.pluck)(F.quadrantlabeltlfont,F.quadrantlabelfont,E.fontFamily),c.styleObj.color=(0,l.convertColor)((0,l.pluck)(F.quadrantlabeltlfontcolor,F.quadrantlabelfontcolor,E.color),(0,l.pluckNumber)(F.quadrantlabeltlfontalpha,F.quadrantlabelfontalpha,100)),c.styleObj.fontWeight=(0,l.pluckNumber)(F.quadrantlabeltlfontbold,F.quadrantlabelfontbold)?"bold":"normal",c.styleObj.fontStyle=(0,l.pluckNumber)(F.quadrantlabeltlfontitalic,F.quadrantlabelfontitalic)?"italic":"normal",(0,l.setLineHeight)(c.styleObj),e=o,t=(0,l.pluckNumber)(F.quadrantlabeltlborderpadding,F.quadrantlabelborderpadding,2),a=(0,l.pluckNumber)(F.quadrantlabeltlborderradius,F.quadrantlabelborderradius,0),i=r?(0,l.convertColor)(r,(0,l.pluckNumber)(F.quadrantlabeltlbgalpha,F.quadrantlabelbgalpha,F.quadrantlabeltlalpha,F.quadrantlabelalpha,100)):"",n=(0,l.pluckNumber)(F.quadrantlabeltlborderdashed,F.quadrantlabelborderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(F.quadrantlabeltlborderdashlen,F.quadrantlabelborderdashlen,4),(0,l.pluckNumber)(F.quadrantlabeltlborderdashgap,F.quadrantlabelborderdashgap,2)):"none",c["text-bound"]=[i,e,s,t,a,n]):A.tlConfig&&(A.tlConfig.label=g),""!==p?(o=(0,l.getFirstValue)(F.quadrantlabeltrbordercolor,F.quadrantlabelbordercolor,""),r=(0,l.pluck)(F.quadrantlabeltrbgcolor,F.quadrantlabelbgcolor),s=(0,l.pluckNumber)(F.quadrantlabeltrborderthickness,F.quadrantlabelborderthickness,1),o=o?(0,l.convertColor)(o,(0,l.pluckNumber)(F.quadrantlabeltrborderalpha,F.quadrantlabelborderalpha,F.quadrantlabeltralpha,F.quadrantlabelalpha,100)):"",(h=A.trConfig)||(h=A.trConfig={enabled:!0,styleObj:{}}),h.label=(0,l.parseUnsafeString)((0,l.getValidValue)(F.quadrantlabeltr,"")),h.styleObj.fontSize=(0,l.pluck)((0,l.pluckNumber)(F.quadrantlabeltrfontsize,F.quadrantlabelfontsize),parseInt(E.fontSize,10))+"px",h.styleObj.fontSizeWithUnit=(0,l.pluckFontSizeMaintainUnit)((0,l.pluckNumber)(F.quadrantlabeltrfontsize,F.quadrantlabelfontsize),E.fontSizeWithUnit),h.styleObj.lineHeight=E.lineHeight,h.styleObj.fontFamily=(0,l.pluck)(F.quadrantlabeltrfont,F.quadrantlabelfont,E.fontFamily),h.styleObj.color=(0,l.convertColor)((0,l.pluck)(F.quadrantlabeltrfontcolor,F.quadrantlabelfontcolor,E.color),(0,l.pluckNumber)(F.quadrantlabeltrfontalpha,F.quadrantrabelfontalpha,100)),h.styleObj.fontWeight=(0,l.pluckNumber)(F.quadrantlabeltrfontbold,F.quadrantlabelfontbold)?"bold":"normal",h.styleObj.fontStyle=(0,l.pluckNumber)(F.quadrantlabeltrfontitalic,F.quadrantlabelfontitalic)?"italic":"normal",(0,l.setLineHeight)(h.styleObj),e=o,t=(0,l.pluckNumber)(F.quadrantlabeltrborderpadding,F.quadrantlabelborderpadding,2),a=(0,l.pluckNumber)(F.quadrantlabeltrborderradius,F.quadrantlabelborderradius,0),i=r?(0,l.convertColor)(r,(0,l.pluckNumber)(F.quadrantlabeltrbgalpha,F.quadrantlabelbgalpha,F.quadrantlabeltralpha,F.quadrantlabelalpha,100)):"",n=(0,l.pluckNumber)(F.quadrantlabeltrborderdashed,F.quadrantlabelborderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(F.quadrantlabeltrborderdashlen,F.quadrantlabelborderdashlen,4),(0,l.pluckNumber)(F.quadrantlabeltrborderdashgap,F.quadrantlabelborderdashgap,2)):"none",h["text-bound"]=[i,e,s,t,a,n]):A.trConfig&&(A.trConfig.label=p),""!==f?(o=(0,l.getFirstValue)(F.quadrantlabelblbordercolor,F.quadrantlabelbordercolor,""),r=(0,l.pluck)(F.quadrantlabelblbgcolor,F.quadrantlabelbgcolor),s=(0,l.pluckNumber)(F.quadrantlabelblborderthickness,F.quadrantlabelborderthickness,1),o=o?(0,l.convertColor)(o,(0,l.pluckNumber)(F.quadrantlabelblborderalpha,F.quadrantlabelborderalpha,F.quadrantlabelblalpha,F.quadrantlabelalpha,100)):"",(u=A.blConfig)||(u=A.blConfig={enabled:!0,styleObj:{}}),u.label=f,u.styleObj.fontSize=(0,l.pluck)((0,l.pluckNumber)(F.quadrantlabelblfontsize,F.quadrantlabelfontsize),parseInt(E.fontSize,10))+"px",u.styleObj.fontSizeWithUnit=(0,l.pluckFontSizeMaintainUnit)((0,l.pluckNumber)(F.quadrantlabelblfontsize,F.quadrantlabelfontsize),E.fontSizeWithUnit),u.styleObj.lineHeight=E.lineHeight,u.styleObj.fontFamily=(0,l.pluck)(F.quadrantlabelblfont,F.quadrantlabelfont,E.fontFamily),u.styleObj.color=(0,l.convertColor)((0,l.pluck)(F.quadrantlabelblfontcolor,F.quadrantlabelfontcolor,E.color),(0,l.pluckNumber)(F.quadrantlabelblfontalpha,F.quadrantlabelfontalpha,100)),u.styleObj.fontWeight=(0,l.pluckNumber)(F.quadrantlabelblfontbold,F.quadrantlabelfontbold)?"bold":"normal",u.styleObj.fontStyle=(0,l.pluckNumber)(F.quadrantlabelblfontitalic,F.quadrantlabelfontitalic)?"italic":"normal",(0,l.setLineHeight)(u.styleObj),e=o,t=(0,l.pluckNumber)(F.quadrantlabelblborderpadding,F.quadrantlabelborderpadding,2),a=(0,l.pluckNumber)(F.quadrantlabelblborderradius,F.quadrantlabelborderradius,0),i=r?(0,l.convertColor)(r,(0,l.pluckNumber)(F.quadrantlabelblbgalpha,F.quadrantlabelbgalpha,F.quadrantlabelblalpha,F.quadrantlabelalpha,100)):"",n=(0,l.pluckNumber)(F.quadrantlabelblborderdashed,F.quadrantlabelborderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(F.quadrantlabelblborderdashlen,F.quadrantlabelborderdashlen,4),(0,l.pluckNumber)(F.quadrantlabelblborderdashgap,F.quadrantlabelborderdashgap,2)):"none",u["text-bound"]=[i,e,s,t,a,n]):A.blConfig&&(A.blConfig.label=f),""!==m?(o=(0,l.getFirstValue)(F.quadrantlabelbrbordercolor,F.quadrantlabelbordercolor,""),r=(0,l.pluck)(F.quadrantlabelbrbgcolor,F.quadrantlabelbgcolor),s=(0,l.pluckNumber)(F.quadrantlabelbrborderthickness,F.quadrantlabelborderthickness,1),o=o?(0,l.convertColor)(o,(0,l.pluckNumber)(F.quadrantlabelbrborderalpha,F.quadrantlabelborderalpha,F.quadrantlabelbralpha,F.quadrantlabelalpha,100)):"",(d=A.brConfig)||(d=A.brConfig={enabled:!0,styleObj:{}}),d.label=(0,l.parseUnsafeString)((0,l.getValidValue)(F.quadrantlabelbr,"")),d.styleObj.fontSize=(0,l.pluck)((0,l.pluckNumber)(F.quadrantlabelbrfontsize,F.quadrantlabelfontsize),parseInt(E.fontSize,10))+"px",d.styleObj.fontSizeWithUnit=(0,l.pluckFontSizeMaintainUnit)((0,l.pluckNumber)(F.quadrantlabelbrfontsize,F.quadrantlabelfontsize),E.fontSizeWithUnit),d.styleObj.lineHeight=E.lineHeight,d.styleObj.fontFamily=(0,l.pluck)(F.quadrantlabelbrfont,F.quadrantlabelfont,E.fontFamily),d.styleObj.color=(0,l.convertColor)((0,l.pluck)(F.quadrantlabelbrfontcolor,F.quadrantlabelfontcolor,E.color),(0,l.pluckNumber)(F.quadrantlabelbrfontalpha,F.quadrantrabelfontalpha,100)),d.styleObj.fontWeight=(0,l.pluckNumber)(F.quadrantlabelbrfontbold,F.quadrantlabelfontbold)?"bold":"normal",d.styleObj.fontStyle=(0,l.pluckNumber)(F.quadrantlabelbrfontitalic,F.quadrantlabelfontitalic)?"italic":"normal",(0,l.setLineHeight)(d.styleObj),i=r?(0,l.convertColor)(r,(0,l.pluckNumber)(F.quadrantlabelbrbgalpha,F.quadrantlabelbgalpha,F.quadrantlabelbralpha,F.quadrantlabelalpha,100)):"",e=o,t=(0,l.pluckNumber)(F.quadrantlabelbrborderpadding,F.quadrantlabelborderpadding,2),a=(0,l.pluckNumber)(F.quadrantlabelbrborderradius,F.quadrantlabelborderradius,0),n=(0,l.pluckNumber)(F.quadrantlabelbrborderdashed,F.quadrantlabelborderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(F.quadrantlabelbrborderdashlen,F.quadrantlabelborderdashlen,4),(0,l.pluckNumber)(F.quadrantlabelbrborderdashgap,F.quadrantlabelborderdashgap,2)):"none",d["text-bound"]=[i,e,s,t,a,n]):A.brConfig&&(A.brConfig.label=m))},a._preDraw=function(){var e,t,a,i,n,o,r=this.conf,s=this.getFromEnv("chart"),c=s.getChildren("xAxis")[0],h=s.getChildren("yAxis")[0],u=c.getLimit(),d=h.getLimit(),g=u.max,p=d.max,f=u.min,m=d.min,b=s.config,v=b.canvasWidth,x=b.canvasHeight,y=r.quadrantLabelPadding,C=r.tlConfig,k=r.trConfig,S=r.blConfig,w=r.brConfig;return C&&(C.styleObj.fontSize=this.computeFontSize(C.styleObj.fontSizeWithUnit),(0,l.setLineHeight)(C.styleObj)),k&&(k.styleObj.fontSize=this.computeFontSize(k.styleObj.fontSizeWithUnit),(0,l.setLineHeight)(k.styleObj)),S&&(S.styleObj.fontSize=this.computeFontSize(S.styleObj.fontSizeWithUnit),(0,l.setLineHeight)(S.styleObj)),w&&(w.styleObj.fontSize=this.computeFontSize(w.styleObj.fontSizeWithUnit),(0,l.setLineHeight)(w.styleObj)),e=r.xVal||(r.xVal=(f+g)/2),(t=r.yVal||(r.yVal=(m+p)/2))>=m&&t<=p&&e>=f&&e<=g?(i=v-(a=v/(g-f)*(e-f)),n=x-(o=x/(p-m)*(t-m)),a-=y,i-=y,o-=y,((n-=y)<0||a<0)&&(C.enabled=!1),(n<0||i<0)&&(k.enabled=!1),(o<0||a<0)&&(S.enabled=!1),(o<0||a<0)&&(w.enabled=!1),r.enabled&&(r.drawQuadrant=!0)):r.drawQuadrant=!1,this},a._createGroups=function(){var e,t=this.getFromEnv("chart"),a=t.getFromEnv("animationManager"),i=t.getChildren("canvas")[0].getChildContainer("quadrantGroup"),n=this.getContainer("quadrantChildContainer"),o=this.getContainer("quadrantLineGroup"),r=this.getContainer("quadrantTLGroup"),l=this.getContainer("quadrantTRGroup"),s=this.getContainer("quadrantBLGroup"),c=this.getContainer("quadrantBRGroup");e=a.setAnimation({el:n||"group",attr:{name:"quadrant-child-container"},container:i,component:this,label:"group"}),n||this.addContainer("quadrantChildContainer",e),this.addContainer("quadrantLineGroup",a.setAnimation({el:o||"group",attr:{name:"quadrantLineGroup"},container:e,component:this,label:"group"})),this.addContainer("quadrantTLGroup",a.setAnimation({el:r||"group",attr:{name:"quadrantTLGroup"},container:e,component:this,label:"group"})),this.addContainer("quadrantTRGroup",a.setAnimation({el:l||"group",attr:{name:"quadrantTRGroup"},container:e,component:this,label:"group"})),this.addContainer("quadrantBLGroup",a.setAnimation({el:s||"group",attr:{name:"quadrantBLGroup"},container:e,component:this,label:"group"})),this.addContainer("quadrantBRGroup",a.setAnimation({el:c||"group",attr:{name:"quadrantBRGroup"},container:e,component:this,label:"group"}))},a.draw=function(){var e,t,a,i,n,o,r,l=this._preDraw(),s=l.conf,c=l.getFromEnv("chart"),p=c.config,f=p.reverseXAxis,m={wrtVisible:!0},b=l.getFromEnv("smartLabel"),v=l.getFromEnv("animationManager"),x=l.graphics,y=x.tlLabel,C=x.trLabel,k=x.blLabel,S=x.brLabel,w=p.textDirection,A=c.getChildren("xAxis")[0],L=c.getChildren("yAxis")[0],N=s.tlConfig||{},F=s.trConfig||{},T=s.blConfig||{},E=s.brConfig||{},P=N.enabled&&N.label,_=F.enabled&&F.label,D=T.enabled&&T.label,I=E.enabled&&E.label,M=p.canvasLeft,O=p.canvasTop,R=s.quadrantLabelPadding,B=A.getLimit(),V=L.getLimit(),z=f?B.min:B.max,G=f?B.max:B.min,H=V.max,W=V.min,j=A.getPixel(G,m)+R,U=A.getPixel(z,m)-R,q=L.getPixel(W,m)-R,Y=L.getPixel(H,m)+R,X=A.getPixel(s.xVal,m),K=L.getPixel(s.yVal,m),Z=X-j,J=U-X,$=K-Y,Q=q-K,ee=x.horizontalQuadLine,te=x.verticalQuadLine,ae=function(){this.hide()};l._createGroups(),t=l.getContainer("quadrantChildContainer"),a=l.getContainer("quadrantLineGroup"),i=l.getContainer("quadrantTLGroup"),n=l.getContainer("quadrantTRGroup"),o=l.getContainer("quadrantBLGroup"),r=l.getContainer("quadrantBRGroup"),s.enabled&&s.drawQuadrant?(t.show(),x.horizontalQuadLine=v.setAnimation({el:ee||"path",container:a,attr:{path:"M"+M+" "+K+"h"+p.canvasWidth,stroke:s.quadrantLineColor,"stroke-dasharray":s.dashStyle,"stroke-width":s.quadrantLineThickness,"stroke-linecap":"butt"},component:l,label:"path"}),x.verticalQuadLine=v.setAnimation({el:te||"path",container:a,attr:{path:"M"+X+" "+O+"v"+p.canvasHeight,stroke:s.quadrantLineColor,"stroke-width":s.quadrantLineThickness,"stroke-dasharray":s.dashStyle,"stroke-linecap":"butt"},component:l,label:"path"}),P?(b.useEllipsesOnOverflow(p.useEllipsesWhenOverflow),b.setStyle(s.tlConfig.styleObj),e=b.getSmartText(P,Z,$),(y=x.tlLabel=v.setAnimation({el:y||"text",attr:{"text-anchor":h,"vertical-align":u,x:j,y:Y,text:e.text,direction:w,"text-bound":s.tlConfig["text-bound"]},container:i,component:l,label:"text"})).css(s.tlConfig.styleObj)):y&&v.setAnimation({el:y,callback:ae,component:this,label:"text"}),_?(b.setStyle(s.trConfig.styleObj),e=b.getSmartText(_,J,$),(C=x.trLabel=v.setAnimation({el:C||"text",attr:{"text-anchor":g,"vertical-align":u,direction:w,x:U,y:Y,text:e.text,"text-bound":s.trConfig["text-bound"]},container:n,component:l,label:"text"})).css(s.trConfig.styleObj)):C&&v.setAnimation({el:C,callback:ae,component:this,label:"text"}),D?(b.setStyle(s.blConfig.styleObj),e=b.getSmartText(D,Z,Q),(k=x.blLabel=v.setAnimation({el:k||"text",attr:{"text-anchor":h,"vertical-align":d,direction:w,x:j,y:q,text:e.text,"text-bound":s.blConfig["text-bound"]},container:o,component:l,label:"text"})).css(s.blConfig.styleObj)):k&&v.setAnimation({el:k,callback:ae,component:this,label:"text"}),I?(b.setStyle(s.brConfig.styleObj),e=b.getSmartText(I,J,Q),(S=x.brLabel=v.setAnimation({el:S||"text",attr:{"text-anchor":g,"vertical-align":d,direction:w,x:U,y:q,text:e.text,"text-bound":s.brConfig["text-bound"]},container:r,component:l,label:"text"})).css(s.brConfig.styleObj)):S&&v.setAnimation({el:S,callback:ae,component:this,label:"text"})):t&&v.setAnimation({el:t,component:l,doNotRemove:!0,callback:function(){this.hide()},label:"group"})},t}(r.ComponentInterface);t["default"]=p},660:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.canvas.quadrant":function(){return{"path.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"axis"}]},"text.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}]}}}}},661:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,i=e.getChildren("canvas")[0],r=i.getChildren("axisRefVisualCartesian")[0],l={zoomable:!0,pannable:!0},s=e._feedAxesRawData(),c=function(e){var t=e.sender;r.addexplicitDrawItems(t.getId(),t),r.asyncDraw()};(0,n.componentFactory)(e,o["default"],"yAxis",1,s.yAxisConf),(0,n.componentFactory)(e,o["default"],"xAxis",1,s.xAxisConf),t=e.getChildren("yAxis")[0],a=e.getChildren("xAxis")[0],t.setLinkedItem("canvas",i),a.setLinkedItem("canvas",i),r.setLinkedItem(t.getId(),t),r.setLinkedItem(a.getId(),a),r.addExtEventListener("visiblerangeset",c,a),r.addExtEventListener("visiblerangeset",c,t),i.attachAxis(a,!1,e.zoomX?l:{}),i.attachAxis(t,!0,e.zoomY?l:{}),e._setCategories()};var n=a(224),o=i(a(481))},662:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(555)),r=a(224),l=a(232),s=i(a(663)),c=i(a(664)),h=Math,u=h.max,d=h.min,g=h.round;(0,l.addDep)({name:"scatterAnimation",type:"animationRule",extension:c["default"]});var p=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.setupHoverTracker=function(){var e,t,a,i,n,o,r,l=this.config.searchDataArr=[],c=this.components.data,h={},u=this.getSkippingInfo&&this.getSkippingInfo(),d=u&&u.draw||[],g=d.length,p=u&&u.skippingApplied;for(a=c.length,p&&(a=g),t=0;t<a;t++)(o=c[e=d[t]||[t]])&&(i=(r=o.config)._Px,n=r._Py,h=r.anchorProps,l.push({x:i,y:n,index:e,data:o,r:h.radius||0}));this.config.dataTree=(new s["default"]).buildKdTree(l)},a.getName=function(){return"scatter"},a.addDatasetSpecificEvtArgs=function(e){var t=e.config,a=t.anchorProps,i=t.eventArgs;Object.assign(i,{showValue:t.showValue,hoverColor:!0===t.hoverEffects.enabled?t.hoverEffects.hoverColor||a.bgColor:void 0,hoverAlpha:!0===t.hoverEffects.enabled?t.hoverEffects.hoverAlpha||"100":void 0,anchorBgColor:a.bgColor,anchorBgAlpha:a.anchorBgAlpha,anchorAlpha:a.anchorAlpha,anchorBorderColor:a.borderColor,anchorBorderThickness:a.borderThickness,anchorRadius:a.radius,anchorSides:a.sides,anchorStartAngle:a.startAngle,anchorHoverSides:t.hoverEffects.anchorSides})},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,i,n,o,l=this.getFromEnv("chart"),s=this.config,c=s.JSONData,h=l.areaAlpha,u=l.getFromEnv("dataSource").chart,d=this.getFromEnv("color-manager"),g=(0,r.pluckNumber)(c.showplotborder,u.showplotborder||1),p=d.getPlotColor(this.index),f=s.lineDashed=(0,r.pluckNumber)(c.linedashed,c.dashed,u.linedashed,0),m=this.isLineSet;s.plotColor=p,n=(0,r.pluckNumber)(l.defaultPlotShadow,d.getColor("showShadow")),s.toolTipSepChar=(0,r.pluck)(u.tooltipsepchar,", "),s.defaultValuePadding={left:0,right:0},s.parentYAxis=a=m||"s"===(0,r.pluck)(c.parentyaxis&&c.parentyaxis.toLowerCase(),"p")?1:0,this.config.yAxis=this.getFromEnv("yAxis")[a],s.connectNullData=(0,r.pluckNumber)(u.connectnulldata,0),s.seriesname=(0,r.parseUnsafeString)(c.seriesname),s.includeinlegend=(0,r.pluckNumber)(c.includeinlegend,s.seriesname?1:0),s.showTextOutline=(0,r.pluckNumber)(u.textoutline,0),s.enableAnimation=i=(0,r.pluckNumber)(u.animation,u.defaultanimation,1),s.animation=!!i&&{duration:1e3*(0,r.pluckNumber)(u.animationduration,1)},s.transposeanimation=(0,r.pluckNumber)(u.transposeanimation,i),s.transposeanimduration=1e3*(0,r.pluckNumber)(u.transposeanimduration,.2),s.showvalues=(0,r.pluckNumber)(c.showvalues,u.showvalues),s.valuePadding=(0,r.pluckNumber)(u.valuepadding,2),s.valuePosition=(0,r.pluck)(c.valueposition,u.valueposition,"auto"),s.showTooltip=(0,r.pluckNumber)(u.showtooltip,1),s.seriesNameInTooltip=(0,r.pluckNumber)(u.seriesnameintooltip,1),s.plotFillColor=s.plotfillcolor=(0,r.pluck)(c.color,u.plotfillcolor,p),s.plotFillAngle=s.plotFillAngle=(0,r.pluck)(u.plotfillangle,270),s.plotFillAlpha=s.plotfillalpha=(0,r.pluck)(c.alpha,u.plotfillalpha,h,"70"),o=(0,r.pluckNumber)(u.useplotgradientcolor,1),s.plotGradientColor=s.plotgradientcolor=0!==o?(0,r.getDefinedColor)(u.plotgradientcolor,d.getColor("plotGradientColor")):"",s.fillColor=s.fillcolor={color:s.plotfillcolor+(s.plotgradientcolor?","+s.plotgradientcolor:r.BLANKSTRING),alpha:s.plotfillalpha,angle:s.plotFillAngle},s.plotBorderAlpha=s.plotborderalpha=g?(0,r.pluck)(c.plotborderalpha,u.plotborderalpha,c.alpha,"95"):0,s.plotBorderColor=s.plotbordercolor=(0,r.pluck)(c.plotbordercolor,u.plotbordercolor,u.areabordercolor,"666666"),s.dashed=t=(0,r.pluckNumber)(c.dashed,u.plotborderdashed),s.plotBorderDashLen=s.plotborderdashlen=(0,r.pluck)(c.plotborderdashlen,u.plotborderdashlen,5),s.plotBorderDashGap=s.plotborderdashgap=(0,r.pluck)(c.plotborderdashgap,u.plotborderdashgap,4),s.plotBorderThickness=s.plotborderthickness=(0,r.pluckNumber)(c.plotborderthickness,u.plotborderthickness,1),s.plotBorderDashStyle=s.plotborderdashstyle=t?(0,r.getDashStyle)(s.plotborderdashlen,s.plotborderdashgap):"none",s.showHoverEffect=s.showhovereffect=(0,r.pluckNumber)(u.plothovereffect,u.anchorhovereffect,u.showhovereffect,void 0),s.rotateValues=(0,r.pluckNumber)(u.rotatevalues)?270:0,s.drawLine=(0,r.pluckNumber)(c.drawline,u.drawlines,0),s.lineThickness=s.linethickness=(0,r.pluckNumber)(c.linethickness,u.linethickness,2),s.lineDashLen=s.linedashlen=(0,r.pluckNumber)(c.linedashlen,u.linedashlen,5),s.lineDashGap=s.linedashgap=(0,r.pluckNumber)(c.linedashgap,u.linedashgap,4),s.lineAlpha=s.linealpha=(0,r.pluckNumber)(c.linealpha,u.linealpha,c.alpha,r.HUNDREDSTRING),s.lineColor=s.linecolor=(0,r.pluck)(c.linecolor,u.linecolor,c.color,s.plotColor),s.lineDashStyle=s.linedashstyle=(0,r.getDashStyle)(s.linedashlen,s.linedashgap),s.lineDashStyle=s.linedashstyle=f?s.linedashstyle:"none",s.shadow={opacity:(0,r.pluckNumber)(u.showshadow,n)?s.linealpha/100:0},s.drawanchors=(0,r.pluckNumber)(c.drawanchors,c.showanchors,u.drawanchors,u.showanchors),s.anchorbgcolor=(0,r.getFirstColor)((0,r.pluck)(c.anchorbgcolor,u.anchorbgcolor,d.getColor("anchorBgColor"))),s.anchorbordercolor=(0,r.getFirstColor)((0,r.pluck)(c.anchorbordercolor,c.color,u.anchorbordercolor,s.linecolor)),s.anchorradius=(0,r.pluckNumber)(c.anchorradius,u.anchorradius,3),s.anchoralpha=(0,r.pluck)(c.anchoralpha,c.alpha,u.anchoralpha,r.HUNDREDSTRING),s.anchorbgalpha=(0,r.pluck)(c.anchorbgalpha,c.alpha,u.anchorbgalpha,r.HUNDREDSTRING),s.anchorborderthickness=(0,r.pluck)(c.anchorborderthickness,u.anchorborderthickness,1),s.anchorsides=(0,r.pluckNumber)(c.anchorsides,u.anchorsides,s.index+3),s.anchorimageurl=(0,r.pluck)(c.anchorimageurl,u.anchorimageurl),s.anchorimagealpha=(0,r.pluckNumber)(c.anchorimagealpha,u.anchorimagealpha,100),s.anchorimagescale=(0,r.pluckNumber)(c.anchorimagescale,u.anchorimagescale,100),s.anchorimagepadding=(0,r.pluckNumber)(c.anchorimagepadding,u.anchorimagepadding,1),s.anchorstartangle=(0,r.pluckNumber)(c.anchorstartangle,u.anchorstartangle,90),s.anchorshadow=(0,r.pluckNumber)(c.anchorshadow,u.anchorshadow,0),s.plotToolText=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(c.plottooltext,u.plottooltext),!1)),this.setState("visible",1===(0,r.pluckNumber)(c.visible,!Number(c.initiallyhidden),1)),this._setConfigure(),!1!==l.config.hasLegend&&l.config.showLegend&&this._addLegend(),this.setState("dirty",!0)},a.calculateScrollRange=function(){var e=this.config,t=this.getFromEnv("chart"),a=this.getFromEnv("xAxis"),i=t.hasScroll,n=this.components.data.length;e.scrollMinVal=i?u(g(a.getVisibleConfig().minValue)-1,0):0,e.scrollMaxVal=i?d(g(a.getVisibleConfig().maxValue)+2,n):n,e.scrollMinValForLabel=e.scrollMinVal,e.scrollMaxValForLabel=e.scrollMaxVal},a._setConfigure=function(){var e,t,a,i,n,o,l,s,c,h,u,d,g=-Infinity,p=+Infinity,f=g,m=p,b=p,v=g,x=this.components.data||(this.components.data=[]),y=this.getFromEnv("chart"),C=this.config,k=C.JSONData,S=y.getFromEnv("dataSource").chart,w=k.data||[],A=w.length,L=this.getFromEnv("number-formatter"),N=(0,r.parseUnsafeString)(S.yaxisname),F=(0,r.parseUnsafeString)(S.xaxisname),T=C.lineDashed,E=C.linedashstyle,P=C.parentYAxis,_=C.toolTipSepChar,D=C.seriesname;for(C.imageCount=0,e=0;e<A;e+=1)i=w[e],(t=(a=x[e]||(x[e]={})).config||(a.config={})).setValue=n={x:L.getCleanValue(i.x),y:L.getCleanValue(i.y)},null!==n.x&&null!==n.y&&(n.x>v&&(v=n.x,C.rightMostData=a),n.x<b&&(b=n.x,C.leftMostData=a),n.y>f&&(f=n.y,C.topMostData=a),n.y<m&&(m=n.y,C.bottomMostData=a)),t._x=n.x,t._y=n.y,t.dataLabelStyle=this._configureDataLabelStyle(i),t.setLink=(0,r.pluck)(i.link),t.anchorProps=this._parseAnchorProperties(e),t.showValue=(0,r.pluckNumber)(i.showvalue,C.showvalues),t.dashed=(0,r.pluckNumber)(i.dashed,T),t.color=(0,r.pluck)(i.color,C.linecolor),t.alpha=(0,r.pluck)(i.alpha,C.linealpha),t.valuePadding=(0,r.pluckNumber)(i.valuepadding,k.valuepadding,y.config.valuepadding),t.dashStyle=t.dashed?E:"none",t.toolTipValue=l=L.dataLabels(n.y,P),t.setDisplayValue=d=(0,r.parseUnsafeString)(i.displayvalue),h=t.formatedVal=(0,r.pluck)(i.toolTipValue,L.dataLabels(n.y,P)),u=L.xAxis(n.x),t.displayValue=(0,r.pluck)(d,l),t.setTooltext=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(i.tooltext,C.plotToolText),!1)),C.showTooltip?void 0!==t.setTooltext?(s=[4,5,6,7,8,9,10,11],c={yaxisName:N,xaxisName:F,yDataValue:h,xDataValue:u},o=(0,r.parseTooltext)(t.setTooltext,s,c,i,S,k)):null===h?o=!1:(o=D?D+_:r.BLANKSTRING,o+=n.x?u+_:r.BLANKSTRING,o+=l):o=!1,t.toolText=o,a?a.graphics||(x[e].graphics={}):a=x[e]={graphics:{}},t.hoverEffects=this._parseHoverEffectOptions(a,i),t.anchorProps.isAnchorHoverRadius=t.hoverEffects.anchorRadius;C.xMax=v,C.xMin=b,C.yMin=m,C.yMax=f,this.ErrorValueConfigure&&this.ErrorValueConfigure()},a._getHoveredPlot=function(e,t){var a=this.config.dataTree.getNeighbour({x:e,y:t},!0);if(a)return{pointIndex:a.index||a.i,hovered:!0,pointObj:a.data}},a.drawPlots=function(){e.prototype.drawPlots.call(this),this.setupHoverTracker()},a.getRegressionPoints=function(){var e,t,a,i,n,o,r,l,s=this.getChildren("regression"),c=-Infinity,h=Infinity,u=-Infinity,d=Infinity;if(s&&s.length&&!s[0].getState("removed")){for(r=(e=s[0]._config.regressionPoints||[]).length,t=0;t<r;t++)for(n=e[t],a=0;a<n.length;a++)for(l=(o=n[a]||[]).length,i=0;i<l;i++)c=Math.max(c,o[i].x),h=Math.min(h,o[i].x),u=Math.max(u,o[i].y),d=Math.min(d,o[i].y);return{max:u,min:d,xMax:c,xMin:h}}},a.getDataLimits=function(){var e=this.config,t=this.getFromEnv("chart").config,a=e.yMax,i=e.yMin,n=e.xMax,o=e.xMin,r=-Infinity,l=+Infinity,s=t.transposeAxis,c=this.getRegressionPoints();return!1===this.getState("visible")&&s&&(a=r,i=l,n=r,o=l),c&&(a=Math.max(a,c.max),i=Math.min(i,c.min),n=Math.max(n,c.xMax),o=Math.min(o,c.xMin)),{max:a,min:i,xMax:n,xMin:o}},a.getAxisValuePadding=function(){return this.config.defaultValuePadding},a.getCanvasPadding=function(){var e,t,a,i,n,o,l,s,c,h,g,p,f,m,b,v,x,y=this.config||(this.config={}),C=this.components||{},k=this.getFromEnv("chartConfig"),S=k.rotatevalues,w=this.getFromEnv("xAxis"),A=this.getFromEnv("yAxis"),L=w.config.isReverse,N=this.getFromEnv("dataLabelStyle"),F=C.data||[],T=F.length,E=y.leftMostData||F[0],P=y.rightMostData||F[F.length-1],_=y.topMostData,D=y.bottomMostData,I=d(k.canvasHeight,k.canvasWidth)/8,M=w.getValue(0),O=1,R=1,B=k.zMax,V=y.bubbleScale,z={},G={},H=0,W=0,j=w.config.axisRange,U=j.min,q=j.max,Y=A.config.axisRange,X=Y.min,K=Y.max,Z=w.getPixel(U),J=w.getPixel(q),$=this.getFromEnv("smartLabel"),Q={paddingLeft:0,paddingRight:0},ee=0;for(e=I/Math.sqrt(B),c=0;c<T;c++)t=F[c].config,a=E.config,i=P.config,l=Math.sqrt(t.z),m=Math.round(l*e)*V||0,b=w.getValue(m)-M,h=t.x-b/2,1===O&&(l=Math.sqrt(a.z),m=Math.round(l*e)*V||0,b=w.getValue(m)-M,g=a.x-b/2),1===R&&(l=Math.sqrt(i.z),m=Math.round(l*e)*V||0,b=w.getValue(m)-M,p=i.x-b/2),O=0,R=0,g>h&&(E=F[c],O=1),p<h&&(P=F[c],R=1);return E&&(o=(n=E.config).anchorProps.radius,(v=n.showValue)&&(f=n.displayValue,$.useEllipsesOnOverflow(k.useEllipsesWhenOverflow),$.setStyle(N),G=$.getOriSize(f),ee=S?G.height:G.width),null!==n.setValue&&(h=w.getPixel(n.setValue.x),W=L?J-(s=h-.5*ee):Z-(s=h-.5*ee),H=!L&&h-o<=Z||L&&h-o<=J?L?J-(h-o):Z-(h-o):0),Q.paddingLeft=u(W,H)),P&&(v=(n=P.config).showValue,o=n.anchorProps.radius,v&&(f=n.displayValue,$.setStyle(N),z=$.getOriSize(f),ee=S?z.height:z.width),null!==n.setValue&&(W=(s=(h=w.getPixel(n.setValue.x))-Z+.5*ee)-J+Z,L&&(W=s),H=!L&&h+o>=J||L&&h+o>=Z?L?h+o-Z:h+o-J:0),Q.paddingRight=u(W,H)),_&&(o=(n=_.config).anchorProps.radius||0,K=A.getPixel(K),null!==n.setValue&&(x=A.getPixel(n.setValue.y),H=(0,r.pluckNumber)(o,0)+(0,r.pluckNumber)(n.anchorProps.borderThickness,0)/2),Q.paddingTop=K-(x-H)>0?K-(x-H):0),D&&(o=(n=D.config).anchorProps.radius||0,X=A.getPixel(X),null!==n.setValue&&(x=A.getPixel(n.setValue.y),H=(0,r.pluckNumber)(o,0)+(0,r.pluckNumber)(n.anchorProps.borderThickness,0)/2),Q.paddingBottom=x+H-X>0?x+H-X:0),Q},a._addLegend=function(){var e,t,a,i,n,o,l,s,c,h=this.getFromEnv("chart"),u=this.getFromEnv("chart-attrib"),d=this.config,g=this.config.JSONData||{},p=h.getChildren("legend")[0],f=(0,r.pluckNumber)(d.drawanchors,1),m={fillColor:(o=d.anchorbgcolor,l=d.plotFillAlpha,s=o,c=l,s=(0,r.getFirstColor)(s),c=(0,r.getFirstAlpha)(c),{FCcolor:{gradientUnits:"objectBoundingBox",cx:.4,cy:.4,r:"100%",color:(0,r.getLightColor)(s,70)+","+(0,r.getDarkColor)(s,50),alpha:c+","+c,ratio:r.BGRATIOSTRING,radialGradient:!0}}),lineColor:{FCcolor:{color:d.anchorbordercolor,alpha:d.anchoralpha}},lineWidth:d.anchorborderthickness};p.config.symbol3DLighting?m.fillcolor&&m.fillcolor.FCcolor?(e=(0,r.extend2)({},m.fillcolor)).FCcolor.alpha=d.plotFillAlpha:e=(0,r.pluck)(m.fillColor):e={FCcolor:{color:(0,r.pluck)((t=m.fillColor)&&(t.FCcolor&&t.FCcolor.color.split(",")[0]||t)),angle:0,ratio:"0",alpha:"100"}},i={enabled:d.includeInLegend,type:this.type,drawLine:(0,r.pluck)(d.drawLine,!0),anchorSide:f?d.anchorsides:0,label:(0,r.getFirstValue)(this.config.JSONData.seriesname),legendIconAlpha:(0,r.pluckNumber)(g.legendiconalpha)},d.includeinlegend?((n=p.getItem(this.config.legendItemId))?n.configure({style:p.config.itemStyle,hiddenStyle:p.config.itemHiddenStyle,datasetVisible:p.config.datasetVisible,hoverStyle:p.config.itemHoverStyle}):(this.config.legendItemId=p.createItem(this),n=p.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){n.itemClickFn()}),n)),n.configure(i),n.setStateCosmetics("default",{symbol:{fill:(0,r.toRaphaelColor)(e),bgAlpha:(0,r.pluckNumber)(g.legendiconbgalpha,g.legendiconalpha,u.legendiconbgalpha,u.legendiconalpha,d.plotFillAlpha),borderAlpha:(0,r.pluckNumber)(g.legendiconborderalpha,g.legendiconalpha,u.legendiconborderalpha,u.legendiconalpha,"100"),rawFillColor:d.anchorbgcolor,rawStrokeColor:d.lineColor,stroke:(0,r.toRaphaelColor)((0,r.pluck)((a=m.lineColor)&&(a.FCcolor&&a.FCcolor.color.split(",")[0]||a))),"stroke-width":d.anchorborderthickness}}),this.getState("visible")?n.removeLegendState("hidden"):n.setLegendState("hidden")):this.config.legendItemId&&p.disposeItem(this.config.legendItemId)},a.getDSGroupdef=function(){},a.trimData=function(e){if(this.config.JSONData){var t,a,i=this.config,n=i&&i.context,o=n&&n.prevCatlen,r=this.getFromEnv("xAxis").getTicksLen(),l=o-r,s=i.JSONData,c=s.data&&s.data.length,h=e.data&&e.data.length||0,u=c-h;l>u?(t=l,a=r):(t=u,a=h),t>0&&this.removeData(a,t,!1)}},t}(o["default"]);t["default"]=p},663:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;
/** !
 * @license FusionCharts JavaScript Library - KDtree
 * Copyright FusionCharts, Inc.
 * License Information at <http://www.fusioncharts.com/license>
 *
 * @version //? write(JSON.parse(require('fs').readFileSync('./package.json')).version);
 */
var i=function(e,t,a,i,n){return Math.pow(a-e,2)+Math.pow(i-t,2)<=Math.pow(n,2)},n=Math.PI,o=Math.cos,r=Math.sin,l=Math.max,s=Math.min,c=n/180,h=function(e,t,a,i,n,o){var r,l,s;return r=(i-t)*(n-a),l=(a-e)*(o-i),isNaN(r)&&(r=0),isNaN(l)&&(l=0),0===(s=r-l)?0:s>0?1:2},u=function(e,t,a,i,n,o){return a<=l(e,n)&&a>=s(e,n)&&i<=l(t,o)&&i>=s(t,o)},d=function(e,t,a,i,n,o,r,l){var s=h(e,t,a,i,n,o),c=h(e,t,a,i,r,l),d=h(n,o,r,l,e,t),g=h(n,o,r,l,a,i);return s!==c&&d!==g||(!(0!==s||!u(e,t,n,o,a,i))||(!(0!==c||!u(e,t,r,l,a,i))||(!(0!==d||!u(n,o,e,t,r,l))||!(0!==g||!u(n,o,a,i,r,l)))))},g=function(e,t,a,l,s,g,p){var f,m,b,v,x,y,C,k=Infinity,S=0,w=!1;if(i(e,t,a,l,s)&&g>=3){for(m=void 0===p?.5*n:p%360*c,C=2*n/g,b=a+s*o(-m),y=l+s*r(-m),f=0;f<g;f++){if(v=a+s*o(-(m+=C)),x=l+s*r(-m),d(b,y,v,x,e,t,k,t)){if(0===h(b,y,e,t,v,x))return u(b,y,e,t,v,x);S++}b=v,y=x}w=S%2!=0}return w},p=function(e,t){return!e||e&&t&&t.i>e.i?t:e};var f=function(){function e(e){this.configure(e)}var t=e.prototype;return t.configure=function(e){this.validatorFn=e?this.shapeValidator():this.defaultValidator()},t.defaultValidator=function(){var e=this;return function(t){var a=e.mousePoint;return!!(t&&Math.pow((t.x-a.x)/e.xLimit,2)+Math.pow((t.y-a.y)/e.yLimit,2)<=1)}},t.shapeValidator=function(){var e=this;return function(t){var a,n,o,r,l,s,c,h,u=e.mousePoint,d=t&&t.shapeInfo,p=!1,f=u.x,m=u.y;switch(d&&d.type){case"circle":n=d.radius,p=i(f,m,t.x,t.y,n);break;case"arc":a=d.innerradius,n=d.radius,p=!i(f,m,t.x,t.y,a)&&i(f,m,t.x,t.y,n);break;case"polygon":n=d.radius,r=d.startAngle,o=d.sides,p=g(f,m,t.x,t.y,n,o,r);break;case"rect":case"rectangle":l=t.x,c=t.y,s=l+(d.width||0),h=c+(d.height||0),p=f>=l&&f<=s&&m>=c&&m<=h;break;case"default":p=!1}return p}},t.buildKdTree=function(e){return this.kdTree=function(e){var t,a,i,n=e,o=n&&n[0]&&n[0].r||5,r=Math.max,l=Math.floor,s=Math.sqrt,c=Math.min,h=Math.log,u=Math.exp,d=Math.pow;function g(e,t,a){var i=e[t];e[t]=e[a],e[a]=i}for(a=function(e,t,i,n){for(var o,d,p,f,m,b,v,x,y,C,k=i,S=n;S>k;){for(S-k>600&&(d=t-k+1,p=h(o=S-k+1),f=.5*u(2*p/3),m=.5*s(p*f*(o-f)/o)*(d-o/2<0?-1:1),b=r(k,l(t-d*f/o+m)),v=c(S,l(t+(o-d)*f/o+m)),a(e,t,b,v)),x=e[t],y=k,C=S,g(e,k,t),e[S].x>x.x&&g(e,k,S);y<C;){for(g(e,y,C),y++,C--;e[y].x<x.x;)y++;for(;e[C].x>x.x;)C--}e[k].x===x.x?g(e,k,C):g(e,++C,S),C<=t&&(k=C+1),t<=C&&(S=C-1)}},i=function(e,t,a,n){for(var o,d,p,f,m,b,v,x,y,C,k=a,S=n,w=e;S>k;){for(S-k>600&&(d=t-k+1,p=h(o=S-k+1),f=.5*u(2*p/3),m=.5*s(p*f*(o-f)/o)*(d-o/2<0?-1:1),b=r(k,l(t-d*f/o+m)),v=c(S,l(t+(o-d)*f/o+m)),i(w,t,b,v)),x=w[t],y=k,C=S,g(w,k,t),w[S].y>x.y&&g(w,k,S);y<C;){for(g(w,y,C),y++,C--;w[y].y<x.y;)y++;for(;w[C].y>x.y;)C--}w[k].y===x.y?g(w,k,C):g(w,++C,S),C<=t&&(k=C+1),t<=C&&(S=C-1)}},t=(n=n||[]).length;t--;)n[t].r>o&&(o=n[t].r),n[t].i=t,n[t].x=+n[t].x,n[t].y=+n[t].y;return{tree:0===n.length?{}:function p(e,t,n,o){var r,l={},s=o?"y":"x";return t===n?(l.point=e[t],l):n-t==1?(e[t][s]>e[n][s]?(l.point=e[t],l.left={point:e[n]}):(l.point=e[n],l.left={point:e[t]}),l):(r=t+n>>1,o?i(e,r,t,n):a(e,r,t,n),l.point=e[r],l.left=p(e,t,r-1,!o),l.right=p(e,r+1,n,!o),l)}(n,0,n.length-1,!1),search:function(e,t,a,i){var n,r,l,c=this.tree,h=i,u=e-o,g=e+o,p=t-o,f=t+o,m=!1,b=0;function v(e,t,a,i){return s(d(e-a,2)+d(t-i,2))}function x(i,n){return"circle"===a?v(i,n,e,t)<=u:i>=u&&i<=g&&n>=p&&n<=f}function y(e,t,a){return e>=t&&e<=a}function C(a){var i=y(e,a.x1,a.x2)&&y(t,a.y1,a.y2),o=v(e,t,a.point.x,a.point.y);if(!n)return n=a,m=i,void(b=o);i?m?a.point.i>n.point.i&&(n=a,m=i,b=o):(n=a,m=i,b=o):m||o<b&&(n=a,m=i,b=o)}function k(i,n){"circle"===a?u=i:(u=e-i||0,g=e+i||0,p=t-n||0,f=t+n||0)}return h=h||{},l=function(e){e&&e.point&&(k(h.rx||e.point.r,h.ry||e.point.r),x(e.point.x,e.point.y)&&C(e),p<=e.point.y&&r(e.left),f>=e.point.y&&r(e.right))},(r=function(e){e&&e.point&&(k(h.rx||e.point.r,h.ry||e.point.r),x(e.point.x,e.point.y)&&C(e),u<=e.point.x&&l(e.left),g>=e.point.x&&l(e.right))})(c),n&&n.point||n}}}(e),this.tree=this.kdTree.tree,this},t.getNeighbour=function(e,t,a){var i=this.tree,n={x1:e.x-this.xLimit,x2:e.x+this.xLimit,y1:e.y-this.yLimit,y2:e.y+this.yLimit},o=this.validatorFn;return this.mousePoint=e,t?this.kdTree&&this.kdTree.search(e.x,e.y,a,e.options):i?this._searchBtwnLimit(n,i,!0,o):void 0},t._searchBtwnLimit=function(e,t,a,i){var n,o,r=a?"x":"y",l=a?e.x1:e.y1,s=a?e.x2:e.y2;if(void 0!==(n=t&&t.point&&t.point[r]))return i(t.point)&&(o=t.point),n>=l&&t.left&&(o=p(o,this._searchBtwnLimit(e,t.left,!a,i))),n<=s&&t.right&&(o=p(o,this._searchBtwnLimit(e,t.right,!a,i))),o},t._setSearchLimit=function(e,t){this.xLimit=e,this.yLimit=t},e}();f.prototype.constructor=f;var m=f;t["default"]=m},664:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n={"*.dataset.scatter":i(a(558))["default"]["*.dataset.line"]};t["default"]=n},672:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(556)),r=i(a(673)),l=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=0,t}(0,n["default"])(t,e),t.getName=function(){return"MSArea"};var a=t.prototype;return a.getName=function(){return"MSArea"},a.getDSdef=function(){return o["default"]},a.getDSGroupdef=function(){},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.friendlyName="Multi-series Area Chart",t.defaultDatasetType="area",t.defaultcrosslinethickness=1},t}(r["default"]);t["default"]=l},673:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t._setDefaultConfig=t["default"]=void 0;var n=i(a(238)),o=i(a(634)),r=a(224),l=r.preDefStr.SEVENTYSTRING,s=function(){var e=this.config;e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha=r.HUNDREDSTRING,e.anchorimagealpha=r.HUNDREDSTRING,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=l,e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha=r.HUNDREDSTRING,e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0};t._setDefaultConfig=s;var c=function(e){function t(){return e.apply(this,arguments)||this}return(0,n["default"])(t,e),t.getName=function(){return"AreaBase"},t.prototype.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),s.call(this)},t}(o["default"]);t["default"]=c},717:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(673)),r=i(a(555)),l=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t.axisPaddingLeft=0,t.axisPaddingRight=0,t}(0,n["default"])(t,e),t.getName=function(){return"MSLine"};var a=t.prototype;return a.getName=function(){return"MSLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.friendlyName="Multi-series Line Chart",t.defaultDatasetType="line",t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1},a.getDSdef=function(){return r["default"]},a.getDSGroupdef=function(){},t}(o["default"]);t["default"]=l},720:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(721))["default"];t["default"]=n},721:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(722))["default"];t["default"]=n},722:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(673),r=i(a(626)),l=i(a(462)),s=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t}(0,n["default"])(t,e),t.getName=function(){return"Spline"};var a=t.prototype;return a.getName=function(){return"Spline"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.friendlyName="Spline Chart",t.singleseries=!0,t.defaultDatasetType="msspline",t.minimizetendency=0,t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,o._setDefaultConfig.call(this)},a.getDSdef=function(){return r["default"]},t}(l["default"]);t["default"]=s},723:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(724))["default"];t["default"]=n},724:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(722)),r=a(673),l=i(a(622)),s=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=0,t}(0,n["default"])(t,e),t.getName=function(){return"SplineArea"};var a=t.prototype;return a.getName=function(){return"SplineArea"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;r._setDefaultConfig.call(this),t.friendlyName="Spline Area Chart",t.singleseries=!0,t.hasLegend=!1,t.defaultDatasetType="mssplinearea",t.anchoralpha="100",t.minimizetendency=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,t.showzeroplaneontop=1,t.inheritplotbordercolor=0},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){},t}(o["default"]);t["default"]=s},725:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(726))["default"];t["default"]=n},726:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(727))["default"];t["default"]=n},727:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(673),r=i(a(626)),l=i(a(565)),s=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t}(0,n["default"])(t,e),t.getName=function(){return"MSSpline"};var a=t.prototype;return a.getName=function(){return"MSSpline"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.friendlyName="Multi-series Spline  Chart",t.defaultDatasetType="msspline",t.minimizetendency=0,t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,o._setDefaultConfig.call(this)},a.getDSdef=function(){return r["default"]},a.getDSGroupdef=function(){},t}(l["default"]);t["default"]=s},728:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(729))["default"];t["default"]=n},729:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=a(673),r=i(a(607)),l=i(a(626)),s=function(e){function t(){var t;return(t=e.call(this)||this).isDual=!0,t}(0,n["default"])(t,e),t.getName=function(){return"MSSplineDy"};var a=t.prototype;return a.getName=function(){return"MSSplineDy"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.friendlyName="Multi-series Dual Y-Axis Spline Chart",t.defaultDatasetType="msspline",t.minimizetendency=0,t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,t.isdual=!0,o._setDefaultConfig.call(this)},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){},a.getDSType=function(){return"spline"},t}(r["default"]);t["default"]=s},730:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(731))["default"];t["default"]=n},731:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(727)),r=a(673),l=i(a(622)),s=function(e){function t(){var t;return(t=e.call(this)||this).friendlyName="Multi-series Spline Area Chart",t.defaultPlotShadow=0,t}(0,n["default"])(t,e),t.getName=function(){return"MSSplineArea"};var a=t.prototype;return a.getName=function(){return"MSSplineArea"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;r._setDefaultConfig.call(this),t.defaultDatasetType="mssplinearea",t.minimizetendency=0,t.zeroplanethickness=2,t.zeroplanealpha=80,t.showzeroplaneontop=1,t.enablemousetracking=!0,t.defaultcrosslinethickness=1},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){},t}(o["default"]);t["default"]=s},740:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(744),o=a(747),r=a(750),l=a(758),s=Object(i["default"])(Object(n["default"])(["fantasy-land/chain","chain"],r["default"],(function(e,t){return"function"==typeof t?function(a){return e(t(a))(a)}:Object(o["default"])(!1)(Object(l["default"])(e,t))})));t["default"]=s},741:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return o}));var i=a(742),n=a(743);function o(e){return function t(a,o){switch(arguments.length){case 0:return t;case 1:return Object(n["default"])(a)?t:Object(i["default"])((function(t){return e(a,t)}));default:return Object(n["default"])(a)&&Object(n["default"])(o)?t:Object(n["default"])(a)?Object(i["default"])((function(t){return e(t,o)})):Object(n["default"])(o)?Object(i["default"])((function(t){return e(a,t)})):e(a,o)}}}},742:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return n}));var i=a(743);function n(e){return function t(a){return 0===arguments.length||Object(i["default"])(a)?t:e.apply(this,arguments)}}},743:function(e,t,a){"use strict";function i(e){return null!=e&&"object"==typeof e&&!0===e["@@functional/placeholder"]}a.r(t),a.d(t,"default",(function(){return i}))},744:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return o}));var i=a(745),n=a(746);function o(e,t,a){return function(){if(0===arguments.length)return a();var o=Array.prototype.slice.call(arguments,0),r=o.pop();if(!Object(i["default"])(r)){for(var l=0;l<e.length;){if("function"==typeof r[e[l]])return r[e[l]].apply(r,o);l+=1}if(Object(n["default"])(r)){var s=t.apply(null,o);return s(r)}}return a.apply(this,arguments)}}},745:function(e,t,a){"use strict";a.r(t),t["default"]=Array.isArray||function(e){return null!=e&&e.length>=0&&"[object Array]"===Object.prototype.toString.call(e)}},746:function(e,t,a){"use strict";function i(e){return"function"==typeof e["@@transducer/step"]}a.r(t),a.d(t,"default",(function(){return i}))},747:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return n}));var i=a(748);function n(e){return function t(a){for(var n,o,r,l=[],s=0,c=a.length;s<c;){if(Object(i["default"])(a[s]))for(r=0,o=(n=e?t(a[s]):a[s]).length;r<o;)l[l.length]=n[r],r+=1;else l[l.length]=a[s];s+=1}return l}}},748:function(e,t,a){"use strict";a.r(t);var i=a(742),n=a(745),o=a(749),r=Object(i["default"])((function(e){return!!Object(n["default"])(e)||!!e&&("object"==typeof e&&(!Object(o["default"])(e)&&(1===e.nodeType?!!e.length:0===e.length||e.length>0&&(e.hasOwnProperty(0)&&e.hasOwnProperty(e.length-1)))))}));t["default"]=r},749:function(e,t,a){"use strict";function i(e){return"[object String]"===Object.prototype.toString.call(e)}a.r(t),a.d(t,"default",(function(){return i}))},750:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(751),o=a(758),r=Object(i["default"])((function(e,t){return Object(o["default"])(e,Object(n["default"])(t))}));t["default"]=r},751:function(e,t,a){"use strict";a.r(t);var i=a(752),n=a(748),o=a(753),r=a(757);t["default"]=function(e){var t=function(e){return{"@@transducer/init":r["default"].init,"@@transducer/result":function(t){return e["@@transducer/result"](t)},"@@transducer/step":function(t,a){var n=e["@@transducer/step"](t,a);return n["@@transducer/reduced"]?Object(i["default"])(n):n}}}(e);return{"@@transducer/init":r["default"].init,"@@transducer/result":function(e){return t["@@transducer/result"](e)},"@@transducer/step":function(e,a){return Object(n["default"])(a)?Object(o["default"])(t,e,a):Object(o["default"])(t,e,[a])}}}},752:function(e,t,a){"use strict";function i(e){return{"@@transducer/value":e,"@@transducer/reduced":!0}}a.r(t),a.d(t,"default",(function(){return i}))},753:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return c}));var i=a(748),n=a(754),o=a(755);function r(e,t,a){for(var i=a.next();!i.done;){if((t=e["@@transducer/step"](t,i.value))&&t["@@transducer/reduced"]){t=t["@@transducer/value"];break}i=a.next()}return e["@@transducer/result"](t)}function l(e,t,a,i){return e["@@transducer/result"](a[i](Object(o["default"])(e["@@transducer/step"],e),t))}var s="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator";function c(e,t,a){if("function"==typeof e&&(e=Object(n["default"])(e)),Object(i["default"])(a))return function(e,t,a){for(var i=0,n=a.length;i<n;){if((t=e["@@transducer/step"](t,a[i]))&&t["@@transducer/reduced"]){t=t["@@transducer/value"];break}i+=1}return e["@@transducer/result"](t)}(e,t,a);if("function"==typeof a["fantasy-land/reduce"])return l(e,t,a,"fantasy-land/reduce");if(null!=a[s])return r(e,t,a[s]());if("function"==typeof a.next)return r(e,t,a);if("function"==typeof a.reduce)return l(e,t,a,"reduce");throw new TypeError("reduce: list must be array or iterable")}},754:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return n}));var i=function(){function e(e){this.f=e}return e.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},e.prototype["@@transducer/result"]=function(e){return e},e.prototype["@@transducer/step"]=function(e,t){return this.f(e,t)},e}();function n(e){return new i(e)}},755:function(e,t,a){"use strict";a.r(t);var i=a(756),n=a(741),o=Object(n["default"])((function(e,t){return Object(i["default"])(e.length,(function(){return e.apply(t,arguments)}))}));t["default"]=o},756:function(e,t,a){"use strict";function i(e,t){switch(e){case 0:return function(){return t.apply(this,arguments)};case 1:return function(e){return t.apply(this,arguments)};case 2:return function(e,a){return t.apply(this,arguments)};case 3:return function(e,a,i){return t.apply(this,arguments)};case 4:return function(e,a,i,n){return t.apply(this,arguments)};case 5:return function(e,a,i,n,o){return t.apply(this,arguments)};case 6:return function(e,a,i,n,o,r){return t.apply(this,arguments)};case 7:return function(e,a,i,n,o,r,l){return t.apply(this,arguments)};case 8:return function(e,a,i,n,o,r,l,s){return t.apply(this,arguments)};case 9:return function(e,a,i,n,o,r,l,s,c){return t.apply(this,arguments)};case 10:return function(e,a,i,n,o,r,l,s,c,h){return t.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}a.r(t),a.d(t,"default",(function(){return i}))},757:function(e,t,a){"use strict";a.r(t),t["default"]={init:function(){return this.xf["@@transducer/init"]()},result:function(e){return this.xf["@@transducer/result"](e)}}},758:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(744),o=a(759),r=a(753),l=a(760),s=a(761),c=a(763),h=Object(i["default"])(Object(n["default"])(["fantasy-land/map","map"],l["default"],(function(e,t){switch(Object.prototype.toString.call(t)){case"[object Function]":return Object(s["default"])(t.length,(function(){return e.call(this,t.apply(this,arguments))}));case"[object Object]":return Object(r["default"])((function(a,i){return a[i]=e(t[i]),a}),{},Object(c["default"])(t));default:return Object(o["default"])(e,t)}})));t["default"]=h},759:function(e,t,a){"use strict";function i(e,t){for(var a=0,i=t.length,n=Array(i);a<i;)n[a]=e(t[a]),a+=1;return n}a.r(t),a.d(t,"default",(function(){return i}))},760:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(757),o=function(){function e(e,t){this.xf=t,this.f=e}return e.prototype["@@transducer/init"]=n["default"].init,e.prototype["@@transducer/result"]=n["default"].result,e.prototype["@@transducer/step"]=function(e,t){return this.xf["@@transducer/step"](e,this.f(t))},e}(),r=Object(i["default"])((function(e,t){return new o(e,t)}));t["default"]=r},761:function(e,t,a){"use strict";a.r(t);var i=a(756),n=a(742),o=a(741),r=a(762),l=Object(o["default"])((function(e,t){return 1===e?Object(n["default"])(t):Object(i["default"])(e,Object(r["default"])(e,[],t))}));t["default"]=l},762:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return o}));var i=a(756),n=a(743);function o(e,t,a){return function(){for(var r=[],l=0,s=e,c=0;c<t.length||l<arguments.length;){var h;c<t.length&&(!Object(n["default"])(t[c])||l>=arguments.length)?h=t[c]:(h=arguments[l],l+=1),r[c]=h,Object(n["default"])(h)||(s-=1),c+=1}return s<=0?a.apply(this,r):Object(i["default"])(s,o(e,r,a))}}},763:function(e,t,a){"use strict";a.r(t);var i=a(742),n=a(764),o=a(765),r=!{toString:null}.propertyIsEnumerable("toString"),l=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],s=function(){return arguments.propertyIsEnumerable("length")}(),c=function(e,t){for(var a=0;a<e.length;){if(e[a]===t)return!0;a+=1}return!1},h="function"!=typeof Object.keys||s?function(e){if(Object(e)!==e)return[];var t,a,i=[],h=s&&Object(o["default"])(e);for(t in e)!Object(n["default"])(t,e)||h&&"length"===t||(i[i.length]=t);if(r)for(a=l.length-1;a>=0;)t=l[a],Object(n["default"])(t,e)&&!c(i,t)&&(i[i.length]=t),a-=1;return i}:function(e){return Object(e)!==e?[]:Object.keys(e)},u=Object(i["default"])(h);t["default"]=u},764:function(e,t,a){"use strict";function i(e,t){return Object.prototype.hasOwnProperty.call(t,e)}a.r(t),a.d(t,"default",(function(){return i}))},765:function(e,t,a){"use strict";a.r(t);var i=a(764),n=Object.prototype.toString;t["default"]=function(){return"[object Arguments]"===n.call(arguments)?function(e){return"[object Arguments]"===n.call(e)}:function(e){return Object(i["default"])("callee",e)}}},766:function(e,t,a){"use strict";a.r(t);var i=a(767),n=a(742),o=Object(n["default"])((function(e){return null!=e&&"function"==typeof e.clone?e.clone():Object(i["default"])(e,[],[],!0)}));t["default"]=o},767:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return o}));var i=a(768),n=a(769);function o(e,t,a,r){var l=function(i){for(var n=t.length,l=0;l<n;){if(e===t[l])return a[l];l+=1}for(var s in t[l+1]=e,a[l+1]=i,e)i[s]=r?o(e[s],t,a,!0):e[s];return i};switch(Object(n["default"])(e)){case"Object":return l({});case"Array":return l([]);case"Date":return new Date(e.valueOf());case"RegExp":return Object(i["default"])(e);default:return e}}},768:function(e,t,a){"use strict";function i(e){return new RegExp(e.source,(e.global?"g":"")+(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.sticky?"y":"")+(e.unicode?"u":""))}a.r(t),a.d(t,"default",(function(){return i}))},769:function(e,t,a){"use strict";a.r(t);var i=a(742),n=Object(i["default"])((function(e){return null===e?"Null":e===undefined?"Undefined":Object.prototype.toString.call(e).slice(8,-1)}));t["default"]=n},770:function(e,t,a){"use strict";a.r(t);var i=a(771),n=a(773),o=Object(n["default"])(i["default"]);t["default"]=o},771:function(e,t,a){"use strict";a.r(t);var i=a(742),n=a(772),o=Object(i["default"])(n["default"]);t["default"]=o},772:function(e,t,a){"use strict";function i(e){return e}a.r(t),a.d(t,"default",(function(){return i}))},773:function(e,t,a){"use strict";a.r(t);var i=a(774),n=a(741),o=Object(n["default"])((function(e,t){for(var a,n,o=new i["default"],r=[],l=0;l<t.length;)a=e(n=t[l]),o.add(a)&&r.push(n),l+=1;return r}));t["default"]=o},774:function(e,t,a){"use strict";a.r(t);var i=a(775),n=function(){function e(){this._nativeSet="function"==typeof Set?new Set:null,this._items={}}return e.prototype.add=function(e){return!o(e,!0,this)},e.prototype.has=function(e){return o(e,!1,this)},e}();function o(e,t,a){var n,o=typeof e;switch(o){case"string":case"number":return 0===e&&1/e==-Infinity?!!a._items["-0"]||(t&&(a._items["-0"]=!0),!1):null!==a._nativeSet?t?(n=a._nativeSet.size,a._nativeSet.add(e),a._nativeSet.size===n):a._nativeSet.has(e):o in a._items?e in a._items[o]||(t&&(a._items[o][e]=!0),!1):(t&&(a._items[o]={},a._items[o][e]=!0),!1);case"boolean":if(o in a._items){var r=e?1:0;return!!a._items[o][r]||(t&&(a._items[o][r]=!0),!1)}return t&&(a._items[o]=e?[!1,!0]:[!0,!1]),!1;case"function":return null!==a._nativeSet?t?(n=a._nativeSet.size,a._nativeSet.add(e),a._nativeSet.size===n):a._nativeSet.has(e):o in a._items?!!Object(i["default"])(e,a._items[o])||(t&&a._items[o].push(e),!1):(t&&(a._items[o]=[e]),!1);case"undefined":return!!a._items[o]||(t&&(a._items[o]=!0),!1);case"object":if(null===e)return!!a._items["null"]||(t&&(a._items["null"]=!0),!1);default:return(o=Object.prototype.toString.call(e))in a._items?!!Object(i["default"])(e,a._items[o])||(t&&a._items[o].push(e),!1):(t&&(a._items[o]=[e]),!1)}}t["default"]=n},775:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return n}));var i=a(776);function n(e,t){return Object(i["default"])(t,e,0)>=0}},776:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return n}));var i=a(777);function n(e,t,a){var n,o;if("function"==typeof e.indexOf)switch(typeof t){case"number":if(0===t){for(n=1/t;a<e.length;){if(0===(o=e[a])&&1/o===n)return a;a+=1}return-1}if(t!=t){for(;a<e.length;){if("number"==typeof(o=e[a])&&o!=o)return a;a+=1}return-1}return e.indexOf(t,a);case"string":case"boolean":case"function":case"undefined":return e.indexOf(t,a);case"object":if(null===t)return e.indexOf(t,a)}for(;a<e.length;){if(Object(i["default"])(e[a],t))return a;a+=1}return-1}},777:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(778),o=Object(i["default"])((function(e,t){return Object(n["default"])(e,t,[],[])}));t["default"]=o},778:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return u}));var i=a(779),n=a(780),o=a(781),r=a(764),l=a(782),s=a(763),c=a(769);function h(e,t,a,o){var r=Object(i["default"])(e),l=Object(i["default"])(t);function s(e,t){return u(e,t,a.slice(),o.slice())}return!Object(n["default"])((function(e,t){return!Object(n["default"])(s,t,e)}),l,r)}function u(e,t,a,i){if(Object(l["default"])(e,t))return!0;var n=Object(c["default"])(e);if(n!==Object(c["default"])(t))return!1;if(null==e||null==t)return!1;if("function"==typeof e["fantasy-land/equals"]||"function"==typeof t["fantasy-land/equals"])return"function"==typeof e["fantasy-land/equals"]&&e["fantasy-land/equals"](t)&&"function"==typeof t["fantasy-land/equals"]&&t["fantasy-land/equals"](e);if("function"==typeof e.equals||"function"==typeof t.equals)return"function"==typeof e.equals&&e.equals(t)&&"function"==typeof t.equals&&t.equals(e);switch(n){case"Arguments":case"Array":case"Object":if("function"==typeof e.constructor&&"Promise"===Object(o["default"])(e.constructor))return e===t;break;case"Boolean":case"Number":case"String":if(typeof e!=typeof t||!Object(l["default"])(e.valueOf(),t.valueOf()))return!1;break;case"Date":if(!Object(l["default"])(e.valueOf(),t.valueOf()))return!1;break;case"Error":return e.name===t.name&&e.message===t.message;case"RegExp":if(e.source!==t.source||e.global!==t.global||e.ignoreCase!==t.ignoreCase||e.multiline!==t.multiline||e.sticky!==t.sticky||e.unicode!==t.unicode)return!1}for(var d=a.length-1;d>=0;){if(a[d]===e)return i[d]===t;d-=1}switch(n){case"Map":return e.size===t.size&&h(e.entries(),t.entries(),a.concat([e]),i.concat([t]));case"Set":return e.size===t.size&&h(e.values(),t.values(),a.concat([e]),i.concat([t]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var g=Object(s["default"])(e);if(g.length!==Object(s["default"])(t).length)return!1;var p=a.concat([e]),f=i.concat([t]);for(d=g.length-1;d>=0;){var m=g[d];if(!Object(r["default"])(m,t)||!u(t[m],e[m],p,f))return!1;d-=1}return!0}},779:function(e,t,a){"use strict";function i(e){for(var t,a=[];!(t=e.next()).done;)a.push(t.value);return a}a.r(t),a.d(t,"default",(function(){return i}))},780:function(e,t,a){"use strict";function i(e,t,a){for(var i=0,n=a.length;i<n;){if(e(t,a[i]))return!0;i+=1}return!1}a.r(t),a.d(t,"default",(function(){return i}))},781:function(e,t,a){"use strict";function i(e){var t=String(e).match(/^function (\w*)/);return null==t?"":t[1]}a.r(t),a.d(t,"default",(function(){return i}))},782:function(e,t,a){"use strict";a.r(t);var i=a(741),n=Object(i["default"])((function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t}));t["default"]=n},783:function(e,t,a){"use strict";a.r(t);var i=a(741),n=Object(i["default"])((function(e,t){for(var a,i=0,n=e.length,o=t.length,r=[];i<n;){for(a=0;a<o;)r[r.length]=[e[i],t[a]],a+=1;i+=1}return r}));t["default"]=n},784:function(e,t,a){"use strict";a.r(t);var i=a(785),n=a(742),o=a(761),r=Object(n["default"])((function(e){return Object(o["default"])(e.length,(function(){var t=0,a=arguments[0],n=arguments[arguments.length-1],o=Array.prototype.slice.call(arguments,0);return o[0]=function(){var e=a.apply(this,Object(i["default"])(arguments,[t,n]));return t+=1,e},e.apply(this,o)}))}));t["default"]=r},785:function(e,t,a){"use strict";function i(e,t){var a;t=t||[];var i=(e=e||[]).length,n=t.length,o=[];for(a=0;a<i;)o[o.length]=e[a],a+=1;for(a=0;a<n;)o[o.length]=t[a],a+=1;return o}a.r(t),a.d(t,"default",(function(){return i}))},797:function(e,t,a){"use strict";var i=a(219);t.__esModule=!0,t["default"]=void 0;var n=i(a(238)),o=i(a(488)),r=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=c(t);if(a&&a.has(e))return a.get(e);var i={},n=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in e)if("default"!==o&&Object.prototype.hasOwnProperty.call(e,o)){var r=n?Object.getOwnPropertyDescriptor(e,o):null;r&&(r.get||r.set)?Object.defineProperty(i,o,r):i[o]=e[o]}i["default"]=e,a&&a.set(e,i);return i}(a(486)),l=i(a(798)),s=i(a(230));function c(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(c=function(e){return e?a:t})(e)}var h=function(e,t){var a=t,i=e;return(a=Math.log(a/i))?function(e){return Math.log(e/i)/a}:(0,o["default"])(a)},u=function(e,t){return e<0?function(a){return-Math.pow(-t,a)*Math.pow(-e,1-a)}:function(a){return Math.pow(t,a)*Math.pow(e,1-a)}},d=function(e){return isFinite(e)?+("1e"+e):e<0?0:e},g=function(e){return 10===e?d:e===Math.E?Math.exp:function(t){return Math.pow(e,t)}},p=function(e){return e===Math.E?Math.log:10===e?Math.log10:2===e?Math.log2:function(t){return Math.log(t)/Math.log(e)}},f=function(e){return function(t){return-e(-t)}},m=function(e){function t(){var t;return(t=e.call(this,h,u)||this).setDomain([1,10]),t.base=10,t.logs=p(t.base),t.pows=g(t.base),t}(0,n["default"])(t,e);var a=t.prototype;return a._rescaleLog=function(){return this.logs=p(this.base),this.pows=g(this.base),this.getDomain()[0]<0&&(this.logs=f(this.logs),this.pows=f(this.pows)),this},a.setBase=function(e){return void 0===e&&(e=10),this.base=Number(e),this._rescaleLog()},a.getBase=function(){return this.base},a.setDomain=function(t){return void 0===t&&(t=[1,10]),e.prototype.setDomain.call(this,t),this._rescaleLog()},a.nice=function(){var e,t,a=this.getDomain(),i=a[0],n=a[1],o=this.base;return i===n&&(i-=i/100),e=Math.log(i)/Math.log(o),t=Math.log(n)/Math.log(o),(e%1||t%1)&&(i<=n?(i=this.pows(Math.floor(e)),n=this.pows(Math.ceil(t))):(i=this.pows(Math.ceil(e)),n=this.pows(Math.floor(t))),this.setDomain([i,n])),this},a.tickFormat=function(e,t){var a=this.base,i=t,n=e;return null==i&&(i=10===a?".0e":","),"function"!=typeof i&&(i=this._localeConverter.formatter(i)),null==n&&(n=10),function(e){return i.format(e)}},a.ticks=function(){var e,t,a,i,n,o,r=this.getDomain(),l=r[0],s=r[1],c=1,h=0,u=[],d=this.base;if(l<=0||s<=0)return u;if(l>s){var g=this.getDomain();s=g[0],l=g[1],c=0}for(d>1?(t=e=Math.ceil(Math.log(s)/Math.log(d)),a=Math.floor(Math.log(l)/Math.log(d))):d>0&&d<1&&(e=Math.floor(Math.log(s)/Math.log(d)),t=Math.ceil(Math.log(l)/Math.log(d)),a=e),n=e,o=t;o>=a;--o)l<=(i=this.pows(n))&&s>=i&&(u[h++]=i),d>1?n--:n++;return this.majorTicks=c?u.reverse():u},a.copy=function(){return(0,r.copyScale)(this,(new t).setBase(this.base))},a.minorTicks=function(e,t){void 0===t&&(t=this.majorTicks||this.ticks());var a,i,n,o,r,c=this.base,h=(0,l["default"])(t),u=[],d=Math.log(c)/Math.log(10),g=c>1?-1:1,p=e;return p=(0,s["default"])(Number(p),d%1?4:8),h.forEach((function(e){var t=e[0],l=e[1];for(c>1?i=Math.ceil(Math.log(l)/Math.log(c)):c>0&&c<1&&(i=Math.floor(Math.log(l)/Math.log(c))),o=Math.pow(c,i)-Math.pow(c,i+g),n=o/(p+1),a=1;a<=p;++a)t<=(r=Math.pow(c,i+g)+n*a)&&l>=r&&u.push(r)})),u},a.contextTicks=function(){return this.contextTicksArr||[]},a.getType=function(){return"log"},t}(r["default"]);t["default"]=m},798:function(e,t,a){"use strict";function i(e,t){return[e,t]}t.__esModule=!0,t["default"]=void 0;var n=function(e,t){var a=t,n=0,o=e.length-1,r=e[0],l=new Array(o<0?0:o);for(null==a&&(a=i);n<o;)l[n]=a(r,r=e[++n]);return l};t["default"]=n},813:function(e,t,a){"use strict";a.r(t);var i=a(814),n=a(741),o=Object(n["default"])((function(e,t){return Object(i["default"])({},e,t)}));t["default"]=o},814:function(e,t,a){"use strict";a.r(t);var i=a(815);t["default"]="function"==typeof Object.assign?Object.assign:i["default"]},815:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return n}));var i=a(764);function n(e){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var t=Object(e),a=1,n=arguments.length;a<n;){var o=arguments[a];if(null!=o)for(var r in o)Object(i["default"])(r,o)&&(t[r]=o[r]);a+=1}return t}},838:function(e,t,a){"use strict";a.r(t);var i=a(742),n=Object(i["default"])((function(e){for(var t=0,a=[];t<e.length;){for(var i=e[t],n=0;n<i.length;)"undefined"==typeof a[n]&&(a[n]=[]),a[n].push(i[n]),n+=1;t+=1}return a}));t["default"]=n},841:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(842),o=Object(i["default"])((function(e,t){return Object(n["default"])((function(e,t,a){return a}),e,t)}));t["default"]=o},842:function(e,t,a){"use strict";a.r(t);var i=a(843),n=a(844),o=a(845),r=Object(i["default"])((function l(e,t,a){return Object(o["default"])((function(t,a,i){return Object(n["default"])(a)&&Object(n["default"])(i)?l(e,a,i):e(t,a,i)}),t,a)}));t["default"]=r},843:function(e,t,a){"use strict";a.r(t),a.d(t,"default",(function(){return r}));var i=a(742),n=a(741),o=a(743);function r(e){return function t(a,r,l){switch(arguments.length){case 0:return t;case 1:return Object(o["default"])(a)?t:Object(n["default"])((function(t,i){return e(a,t,i)}));case 2:return Object(o["default"])(a)&&Object(o["default"])(r)?t:Object(o["default"])(a)?Object(n["default"])((function(t,a){return e(t,r,a)})):Object(o["default"])(r)?Object(n["default"])((function(t,i){return e(a,t,i)})):Object(i["default"])((function(t){return e(a,r,t)}));default:return Object(o["default"])(a)&&Object(o["default"])(r)&&Object(o["default"])(l)?t:Object(o["default"])(a)&&Object(o["default"])(r)?Object(n["default"])((function(t,a){return e(t,a,l)})):Object(o["default"])(a)&&Object(o["default"])(l)?Object(n["default"])((function(t,a){return e(t,r,a)})):Object(o["default"])(r)&&Object(o["default"])(l)?Object(n["default"])((function(t,i){return e(a,t,i)})):Object(o["default"])(a)?Object(i["default"])((function(t){return e(t,r,l)})):Object(o["default"])(r)?Object(i["default"])((function(t){return e(a,t,l)})):Object(o["default"])(l)?Object(i["default"])((function(t){return e(a,r,t)})):e(a,r,l)}}}},844:function(e,t,a){"use strict";function i(e){return"[object Object]"===Object.prototype.toString.call(e)}a.r(t),a.d(t,"default",(function(){return i}))},845:function(e,t,a){"use strict";a.r(t);var i=a(843),n=a(764),o=Object(i["default"])((function(e,t,a){var i,o={};for(i in t)Object(n["default"])(i,t)&&(o[i]=Object(n["default"])(i,a)?e(i,t[i],a[i]):t[i]);for(i in a)Object(n["default"])(i,a)&&!Object(n["default"])(i,o)&&(o[i]=a[i]);return o}));t["default"]=o},885:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(744),o=a(886),r=Object(i["default"])(Object(n["default"])(["all"],o["default"],(function(e,t){for(var a=0;a<t.length;){if(!e(t[a]))return!1;a+=1}return!0})));t["default"]=r},886:function(e,t,a){"use strict";a.r(t);var i=a(741),n=a(887),o=a(757),r=function(){function e(e,t){this.xf=t,this.f=e,this.all=!0}return e.prototype["@@transducer/init"]=o["default"].init,e.prototype["@@transducer/result"]=function(e){return this.all&&(e=this.xf["@@transducer/step"](e,!0)),this.xf["@@transducer/result"](e)},e.prototype["@@transducer/step"]=function(e,t){return this.f(t)||(this.all=!1,e=Object(n["default"])(this.xf["@@transducer/step"](e,!1))),e},e}(),l=Object(i["default"])((function(e,t){return new r(e,t)}));t["default"]=l},887:function(e,t,a){"use strict";function i(e){return e&&e["@@transducer/reduced"]?e:{"@@transducer/value":e,"@@transducer/reduced":!0}}a.r(t),a.d(t,"default",(function(){return i}))},952:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var i=function(){var e,t,a,i,n,o=this.getChildren(),r=this.getDatasets(),l=o.xAxis&&o.xAxis[0]||o.scale,s=[],c=0;if(r){for(e=r.length,t=0;t<e;t++)c=Math.max(c,r[t].components.data.length);for(t=0;t<c;t++)for((n=s[t]=[])[0]=l.getLabel(t).label,a=1;a<=e;a++)i=r[a-1].components.data[t],n[a]=i&&i.config.setValue;return s}};t["default"]=i}}]);
//# sourceMappingURL=http://localhost:3052/3.18.0/map/eval/fusioncharts.common.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports) {

!function(t){"object"==typeof module&&"undefined"!=typeof module.exports?module.exports=t:t()}((function(){(window.webpackJsonpFusionCharts=window.webpackJsonpFusionCharts||[]).push([[1],{459:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(460));e.Column2D=o["default"];var r=n(a(540));e.Column3D=r["default"];var i=n(a(553));e.Line=i["default"];var l=n(a(559));e.Area=l["default"];var s=n(a(561));e.Bar2D=s["default"];var c=n(a(581));e.Bar3D=c["default"];var u=n(a(586));e.Pie2D=u["default"];var d=n(a(592));e.Pie3D=d["default"];var h=n(a(599));e.Doughnut2D=h["default"];var f=n(a(601));e.Doughnut3D=f["default"];var p=n(a(605));e.Pareto2D=p["default"];var g=n(a(616));e.Pareto3D=g["default"];var v=n(a(619));e.ScrollCombiDy2D=v["default"];var m=n(a(630));e.ScrollCombi2D=m["default"];var b=n(a(635));e.ScrollStackedColumn2D=b["default"];var C=n(a(639));e.ScrollMSStackedColumn2D=C["default"];var D=n(a(643));e.ScrollMSStackedColumn2dLineDY=D["default"];var _=n(a(647));e.ScrollStackedBar2D=_["default"];var y=n(a(650));e.ScrollArea2D=y["default"];var S=n(a(651));e.ScrollLine2D=S["default"];var k=n(a(653));e.ScrollColumn2D=k["default"];var A=n(a(654));e.ScrollBar2D=A["default"];var x=n(a(655));e.Bubble=x["default"];var P=n(a(668));e.Scatter=P["default"];var w=n(a(669));e.MSStackedColumn2D=w["default"];var N=n(a(670));e.StackedArea2D=N["default"];var T=n(a(674));e.StackedBar3D=T["default"];var F=n(a(679));e.StackedBar2D=F["default"];var M=n(a(682));e.StackedColumn3D=M["default"];var B=n(a(686));e.StackedColumn2D=B["default"];var E=n(a(688));e.MSStackedColumn2DLineDy=E["default"];var L=n(a(689));e.StackedColumn3DLineDy=L["default"];var I=n(a(694));e.MSColumn3DLineDy=I["default"];var O=n(a(695));e.MSCombidy2D=O["default"];var R=n(a(696));e.MSCombidy3D=R["default"];var G=n(a(698));e.StackedColumn3DLine=G["default"];var V=n(a(701));e.StackedColumn2DLine=V["default"];var z=n(a(704));e.MSColumnLine3D=z["default"];var H=n(a(706));e.MSCombi3D=H["default"];var W=n(a(707));e.MSCombi2D=W["default"];var Y=n(a(708));e.Marimekko=Y["default"];var U=n(a(713));e.MSArea=U["default"];var j=n(a(714));e.MSBar3D=j["default"];var X=n(a(715));e.MSBar2D=X["default"];var Z=n(a(716));e.MSLine=Z["default"];var J=n(a(718));e.MSColumn3D=J["default"];var q=n(a(719));e.MSColumn2D=q["default"];var K=n(a(720));e.Spline=K["default"];var $=n(a(723));e.Splinearea=$["default"];var Q=n(a(725));e.Msspline=Q["default"];var tt=n(a(728));e.MSSplineDy=tt["default"];var et=n(a(730));e.Mssplinearea=et["default"];var at=n(a(732));e.StackedColumn2DLineDy=at["default"];var nt=n(a(734));e.StackedArea2DLineDy=nt["default"];var ot={name:"charts",type:"package",requiresFusionCharts:!0,extension:function(t){t.addDep(o["default"]),t.addDep(r["default"]),t.addDep(i["default"]),t.addDep(l["default"]),t.addDep(s["default"]),t.addDep(c["default"]),t.addDep(u["default"]),t.addDep(d["default"]),t.addDep(h["default"]),t.addDep(f["default"]),t.addDep(p["default"]),t.addDep(g["default"]),t.addDep(v["default"]),t.addDep(m["default"]),t.addDep(b["default"]),t.addDep(C["default"]),t.addDep(D["default"]),t.addDep(_["default"]),t.addDep(y["default"]),t.addDep(S["default"]),t.addDep(k["default"]),t.addDep(A["default"]),t.addDep(x["default"]),t.addDep(P["default"]),t.addDep(w["default"]),t.addDep(N["default"]),t.addDep(T["default"]),t.addDep(F["default"]),t.addDep(M["default"]),t.addDep(B["default"]),t.addDep(E["default"]),t.addDep(L["default"]),t.addDep(at["default"]),t.addDep(nt["default"]),t.addDep(I["default"]),t.addDep(O["default"]),t.addDep(R["default"]),t.addDep(G["default"]),t.addDep(V["default"]),t.addDep(z["default"]),t.addDep(H["default"]),t.addDep(W["default"]),t.addDep(Y["default"]),t.addDep(U["default"]),t.addDep(j["default"]),t.addDep(X["default"]),t.addDep(Z["default"]),t.addDep(J["default"]),t.addDep(q["default"]),t.addDep(K["default"]),t.addDep($["default"]),t.addDep(tt["default"]),t.addDep(Q["default"]),t.addDep(et["default"])}};e["default"]=ot},460:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(461))["default"];e["default"]=o},461:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(462)),i=n(a(538)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"Column2D"};var a=e.prototype;return a.getName=function(){return"Column2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.friendlyName="Column Chart",this.config.singleseries=!0,this.config.defaultDatasetType="column",this.config.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},540:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(541))["default"];e["default"]=o},541:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(542)),i=n(a(550)),l=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.defaultZeroPlaneHighlighted=!1,e}(0,o["default"])(e,t),e.getName=function(){return"Column3D"};var a=e.prototype;return a.getName=function(){return"Column3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.hasLegend=!1,e.singleseries=!0,e.friendlyName="3D Column Chart",e.showplotborder=0,e.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},542:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(462)),i=n(a(543)),l=n(a(547)),s=function(t){function e(){var e;return(e=t.call(this)||this).registerFactory("canvas",i["default"]),e.registerFactory("dataset",l["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"SSCartesian3D"};var a=e.prototype;return a.getName=function(){return"SSCartesian3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.hasLegend=!1,e.showplotborder=0,e.drawcrosslineontop=0,e.showzeroplaneontop=0},e}(r["default"]);e["default"]=s},543:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=function(t){var e;if((0,i.componentFactory)(t,o["default"],"canvas",t.config.showVolumeChart?2:1),e=t.getChildren("canvas"))for(var a=0,n=e.length;a<n;a++)e[a].configure(),(0,i.componentFactory)(e[a],r["default"],"axisRefVisualCartesian")};var o=n(a(544)),r=n(a(531)),i=a(224)},544:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(467)),i=a(224),l=a(232),s=n(a(545)),c=n(a(546)),u=(0,l.getDep)("redraphael","plugin"),d=i.preDefStr.ROUND,h=i.preDefStr.miterStr,f=Math.max,p=u,g="M",v={chart2D:{bgColor:"bgColor",bgAlpha:"bgAlpha",bgAngle:"bgAngle",bgRatio:"bgRatio",canvasBgColor:"canvasBgColor",canvasBaseColor:"canvasBaseColor",divLineColor:"divLineColor",legendBgColor:"legendBgColor",legendBorderColor:"legendBorderColor",toolTipbgColor:"toolTipbgColor",toolTipBorderColor:"toolTipBorderColor",baseFontColor:"baseFontColor",anchorBgColor:"anchorBgColor"},chart3D:{bgColor:"bgColor3D",bgAlpha:"bgAlpha3D",bgAngle:"bgAngle3D",bgRatio:"bgRatio3D",canvasBgColor:"canvasBgColor3D",canvasBaseColor:"canvasBaseColor3D",divLineColor:"divLineColor3D",divLineAlpha:"divLineAlpha3D",legendBgColor:"legendBgColor3D",legendBorderColor:"legendBorderColor3D",toolTipbgColor:"toolTipbgColor3D",toolTipBorderColor:"toolTipBorderColor3D",baseFontColor:"baseFontColor3D",anchorBgColor:"anchorBgColor3D"}},m=function(){this.hide()},b=function(){this.hide(),this._.cubeside.hide(),this._.cubetop.hide()},C=function(){this.show(),this._.cubeside.show(),this._.cubetop.show()};(0,l.addDep)({name:"canvas3dAnimation",type:"animationRule",extension:s["default"]}),(0,c["default"])(u);var D=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getName=function(){return"canvas"},a.getType=function(){return"canvas"},a.drawCanvas=function(){this.getFromEnv("chart").isBar?this.drawCanvas3dBar():this.drawCanvas3dColumn()},a.configureAttributes=function(){t.prototype.configureAttributes.call(this),this.config.xDepth=10,this.config.yDepth=10},a.drawCanvas3dColumn=function(){var t,e,a,n,o,r,l,s,c,d,p,D,_,y,S,k,A=this.getFromEnv("chart"),x=A.getFromEnv("dataSource"),P=this.config,w=A.config,N=P.canvasLeft,T=P.canvasTop,F=P.canvasWidth,M=P.canvasHeight,B=x.chart,E=this.getFromEnv("animationManager"),L=A.getFromEnv("color-manager"),I=this.getGraphicalElement("canvasBorderElement"),O=this.getGraphicalElement("canvasElement"),R=this.config,G=R.clip={},V=this.getContainer("canvasGroup"),z=this.getGraphicalElement("canvasBg"),H=this.getGraphicalElement("canvas3DBase"),W=A.getChildContainer("plotGroup"),Y=A.getChildContainer("datalabelsGroup"),U=this.getGraphicalElement("canvas3dbaseline"),j=R.canvasBgColor,X=R.showCanvasBG=Boolean((0,i.pluckNumber)(B.showcanvasbg,1)),Z=w.canvasBgDepth,J=w.showCanvasBase,q=w.canvasBaseDepth,K=R.canvasBaseColor3D=(0,i.pluck)(B.canvasbasecolor,L.getColor("canvasBaseColor3D")),$=R.use3DLighting=(0,i.pluckNumber)(B.use3dlighting,1),Q=v.chart3D,tt=R.canvasBorderRadius=(0,i.pluckNumber)(B.plotborderradius,0),et=R.canvasBorderColor=(0,i.convertColor)((0,i.pluck)(B.canvasbordercolor,L.getColor(i.canvasBorderColorStr))),at=R.canBGAlpha=(0,i.pluck)(B.canvasbgalpha,L.getColor("canvasBgAlpha")),nt=R.canBGColor=(0,i.pluck)(B.canvasbgcolor,L.getColor(Q.canvasBgColor)),ot=w.canvasBasePadding||2;j=R.canvasBgColor=$?{FCcolor:{color:(0,i.getDarkColor)(nt,85)+i.COMMASTRING+(0,i.getLightColor)(nt,55),alpha:at+i.COMMASTRING+at,ratio:i.BGRATIOSTRING,angle:(0,i.getAngle)(w.width-(w.marginLeft+w.marginRight),w.height-(w.marginTop+w.marginBottom),1)}}:(0,i.convertColor)(nt,at),nt=nt.split(i.COMMASTRING)[0],at=at.split(i.COMMASTRING)[0],S=R.xDepth,k=R.yDepth,r={x:N-0,y:T-0,width:F+0,height:M+0,r:tt,"stroke-width":0,stroke:et,"stroke-linejoin":h},t=E.setAnimation({el:I||"rect",attr:r,component:this,label:"canvas",container:V}),I||this.addGraphicalElement("canvasBorderElement",t),G["clip-canvas"]=[f(0,N-S),f(0,T),f(1,F+S),f(1,M+k)],G["clip-canvas-init"]=[f(0,N-S),f(0,T-k),1,f(1,M+2*k)],_=G["clip-canvas"].slice(0),E.setAnimation({el:W,attr:{"clip-rect":_},component:this}),E.setAnimation({el:Y,attr:{"clip-rect":_},component:this}),r={x:N,y:T,width:F,height:M,r:tt,"stroke-width":0,stroke:"none",fill:(0,i.toRaphaelColor)(j)},e=E.setAnimation({el:O||"rect",attr:r,component:this,label:"canvas",callback:X?i.stubFN:m,container:V}),O||this.addGraphicalElement("canvasElement",e),o=[g,N+F,T,"L",N+F+Z,T+1.2*Z,N+F+Z,T+M-Z,N+F,T+M,"Z"],a=E.setAnimation({el:z||"path",attr:{path:o,"stroke-width":0,stroke:"none",fill:(0,i.toRaphaelColor)(j)},component:this,label:"canvas",callback:X?i.stubFN:m,container:V}),z||this.addGraphicalElement("canvasBg",a),X?(a.show(),e.show()):(a.hide(),e.hide()),l=N-S-ot,s=T+M+k+ot,c=F,d=q,p=S+ot,D=k+ot,n=E.setAnimation({el:H||"cubepath",component:this,index:0,attr:{cubepath:[l,s,c,d,p,D],stroke:"none","stroke-width":0,visibility:J?"visible":"hidden",fill:K.replace(i.dropHash,i.HASHSTRING),noGradient:!$},callback:J?i.stubFN:b,label:"canvas",container:V}),H||this.addGraphicalElement("canvas3DBase",n),y=E.setAnimation({el:U||"path",attr:{path:[g,N,T+M,"H",F+N],stroke:u.tintshade(K.replace(i.dropHash,i.HASHSTRING),.05).rgba},component:this,callback:J?i.stubFN:m,label:"canvas",container:V}),U||this.addGraphicalElement("canvas3dbaseline",y),J&&(C.call(n),y.show())},a.drawCanvas3dBar=function(){var t,e,a,n,o,r,l,s,c,u,D,_,y,S,k=this.getFromEnv("chart"),A=k.getFromEnv("dataSource"),x=k.config,P=x.canvasLeft,w=x.canvasTop,N=x.canvasWidth,T=x.canvasHeight,F=A.chart,M=k.getFromEnv("color-manager"),B=this.getGraphicalElement("canvasBorderElement"),E=this.getGraphicalElement("canvasElement"),L=this.config,I=L.clip={},O=this.getContainer("canvasGroup"),R=this.getGraphicalElement("canvasBg"),G=this.getGraphicalElement("canvas3DBase"),V=k.getChildContainer("plotGroup"),z=k.getChildContainer("datalabelsGroup"),H=this.getFromEnv("animationManager"),W=this.getGraphicalElement("canvas3dbaseline"),Y=L.canvasBgColor,U=L.showCanvasBG=Boolean((0,i.pluckNumber)(F.showcanvasbg,1)),j=x.canvasBgDepth,X=x.showCanvasBase,Z=x.canvasBaseDepth,J=L.canvasBaseColor3D=(0,i.pluck)(F.canvasbasecolor,M.getColor("canvasBaseColor3D")),q=L.use3DLighting=(0,i.pluckNumber)(F.use3dlighting,1),K=v.chart3D,$=L.canvasBorderRadius=(0,i.pluckNumber)(F.plotborderradius,0),Q=L.canvasBorderWidth=0,tt=.5*Q,et=L.canvasBorderColor=(0,i.convertColor)((0,i.pluck)(F.canvasbordercolor,M.getColor(i.canvasBorderColorStr))),at=L.canBGAlpha=(0,i.pluck)(F.canvasbgalpha,M.getColor("canvasBgAlpha")),nt=L.canBGColor=(0,i.pluck)(F.canvasbgcolor,M.getColor(K.canvasBgColor)),ot=L.xDepth,rt=L.yDepth;Y=L.canvasBgColor=q?{FCcolor:{color:(0,i.getDarkColor)(nt,85)+","+(0,i.getLightColor)(nt,55),alpha:at+","+at,ratio:i.BGRATIOSTRING,angle:(0,i.getAngle)(x.width-(x.marginLeft+x.marginRight),x.height-(x.marginTop+x.marginBottom),1)}}:(0,i.convertColor)(nt,at),nt=nt.split(",")[0],at=at.split(",")[0],ot=L.xDepth=5,rt=L.yDepth=5,o={x:P-tt,y:w-tt,width:N+Q,height:T+Q,r:$,"stroke-width":Q,stroke:et,"stroke-linejoin":Q>2?d:h},t=H.setAnimation({el:B||"rect",attr:o,container:O,label:"canvas",component:this}),B||this.addGraphicalElement("canvasBorderElement",t),I["clip-canvas"]=[f(0,P-ot),f(0,w),f(1,N+ot),f(1,T+rt)],I["clip-canvas-init"]=[f(0,P-ot),f(0,w-rt),1,f(1,T+2*rt)],y=I["clip-canvas"].slice(0),H.setAnimation({el:V,attr:{"clip-rect":y},component:this}),H.setAnimation({el:z,attr:{"clip-rect":y},component:this}),o={x:P,y:w,width:N,height:T,r:$,"stroke-width":0,stroke:"none",fill:(0,i.toRaphaelColor)(Y)},e=H.setAnimation({el:E||"rect",attr:o,component:this,label:"canvas",container:O}),E||this.addGraphicalElement("canvasElement",e),r=[g,P,w,"L",P+1.2*j,w-j,P+N-j,w-j,P+N,w,"Z"],a=H.setAnimation({el:R||"path",attr:{path:r,"stroke-width":0,stroke:"none",fill:(0,i.toRaphaelColor)(Y)},component:this,callback:U?i.stubFN:m,label:"canvas",container:O}),R||this.addGraphicalElement("canvasBg",a),U?(e.show(),a.show()):(e.hide(),a.hide()),l=P-ot-Z-1,s=w+rt+1,c=Z,u=T,D=ot+1,_=rt+1,n=H.setAnimation({el:G||"cubepath",attr:{cubepath:[l,s,c,u,D,_],stroke:"none","stroke-width":0,visibility:"hidden",fill:J.replace(i.dropHash,i.HASHSTRING),noGradient:!q},component:this,callback:X?i.stubFN:b,label:"canvas",container:O}),G||this.addGraphicalElement("canvas3DBase",n),S=H.setAnimation({el:W||"path",attr:{path:[g,P,w,"V",T+w],stroke:p.tintshade(J.replace(i.dropHash,i.HASHSTRING),.05).rgba},component:this,callback:X?i.stubFN:m,label:"canvas",container:O}),W||this.addGraphicalElement("canvas3dbaseline",S),X&&(S.show(),C.call(n))},e}(r["default"]);e["default"]=D},545:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var n={"initial.canvas.canvas":{"canvas.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]}};e["default"]=n},546:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=function(t){var e,a=Math.atan2;t.define&&t.define([{name:"cubepath",cubepath:function(){var a,o,r,i,l=this,s={"stroke-linejoin":"round","shape-rendering":"precision",stroke:"none"},c=arguments,u=c.length-1,d=c[u],h=function(t,a,o,r,i,l){var s=this,c=s._.cubetop,u=s._.cubeside,d=t,h=a,f=o,p=r,g=i,v=l;return"object"==typeof d||d===e&&h===e&&f===e&&p===e&&g===e&&v===e||(d=(0,n.pluckNumber)(d,s.attrs.x,0),h=(0,n.pluckNumber)(h,s.attrs.y,0),f=(0,n.pluckNumber)(f,s.attrs.width,0),p=(0,n.pluckNumber)(p,s.attrs.height,0),g=(0,n.pluckNumber)(g,s.attrs.xDepth,0),v=(0,n.pluckNumber)(v,s.attrs.yDepth,0),s.attrs.x=d,s.attrs.y=h,s.attrs.width=f,s.attrs.height=p,s.attrs.xDepth=g,s.attrs.yDepth=v,s._attr("path",["M",d+f,h,"l",0,p,-f,0,0,-p,"z"]),c.attr("path",["M",d,h,"l",1,1,f-1,0,0,-1,g,-v,-f,0,"z"]),u.attr("path",["M",d+f-1,h+1,"l",0,p-1,1,0,g,-v,0,-p,-g,v])),this},f=function(t,e,a,n){var o=this,r=o._.cubetop,i=o._.cubeside;return o.dropshadow&&(r.dropshadow(t,-e,a,n),i.dropshadow(t,-e,a,n)),!1};for(r in d&&d.constructor===t.el.constructor?c[u]=e:d=e,a=l.path(s,d),o=l.path(s,d),(i=l.path(s,d))._.cubetop=a.follow(i,e,"before"),i._.cubeside=o.follow(i,e,"before"),t.fn.cubepath.ca)i.ca[r]=t.fn.cubepath.ca[r];return i._attr=i.attr,i._shadow=i.shadow,i.attr=function(t,a){var n="object"==typeof t,o=a;return n&&(t.cubepath?o=[].concat(t.cubepath):((o=[]).push(t.x),o.push(t.y),o.push(t.width),o.push(t.height),o.push(t.xDepth),o.push(t.yDepth)),t.noGradient!==e&&(i.attrs.noGradient=t.noGradient)),t===e&&o===e?this.attrs:o===e?this.attrs[t]:(n?h.apply(this,o):"drop-shadow"===t&&f.apply(this,[].concat(o)),i._attr(t),this)},i.appendTo=function(t){t.appendChild(i._.cubetop),t.appendChild(i._.cubeside),t.appendChild(i)},"object"==typeof c[0]?i.attr(c[0]):h.apply(i,[c[0],c[1],c[2],c[3],c[4],c[5]])},fn:{_getBBox2:function(){var t=this._.cubeside.getBBox(),e=this._.cubetop.getBBox(),a=this.getBBox();return{x:a.x+e.height,y:a.y-t.width,width:a.width,height:a.height}},shadow:function(){return this._.cubeside.shadow.apply(this._.cubeside,arguments),this._.cubetop.shadow.apply(this._.cubetop,arguments),this._shadow.apply(this,arguments)}},ca:{"stroke-linejoin":function(){return{"stroke-linejoin":"round"}},fill:function(n,o){var r,i=this,l=i._.cubetop,s=i._.cubeside,c=i._attr("cubepath")||[0,0,0,0,0,0],u=n,d=o,h=c[2],f=c[4],p=c[5];return d===e&&(d=i._attr("noGradient")),"object"==typeof(u=t.color(u))&&(u=r="opacity"in u?"rgba("+[u.r,u.g,u.b,u.opacity]+")":"rgb("+[u.r,u.g,u.b]+")"),d?(i._attr("fill",u),l.attr("fill",t.tintshade(u,-.78).rgba),s.attr("fill",t.tintshade(u,-.65).rgba)):(i._attr("fill",[270,t.tintshade(r,.55).rgba,t.tintshade(r,-.65).rgba].join("-")),s.attr("fill",[270,t.tintshade(r,-.75).rgba,t.tintshade(r,-.35).rgba].join("-")),l.attr("fill",[45+t.deg(a(p,f+h)),t.tintshade(r,-.78).rgba,t.tintshade(r,.22).rgba].join("-"))),!1}}}])};var n=a(224)},547:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=function(t){var e,a,n,i=t.getChildren().canvas[0].getChildren("vCanvas")[0],l=t.getFromEnv("dataSource"),s=l.dataset,c=t.config.defaultDatasetType||"",u=l.data||s&&s[0].data;if(a=function(t){var e=[];return(0,o.fcEach)(t,(function(t){"true"!==t.vline&&!0!==t.vline&&1!==t.vline&&"1"!==t.vline&&e.push(t)})),{data:e}}(u),!(u&&0!==u.length))return void t.setChartMessage();(0,o.componentFactory)(i,r["default"],"datasetGroup_"+c),n=i.getChildren("datasetGroup_"+c)[0],e=t.getDSdef(),(0,o.datasetFactory)(n,e,"dataset",1,[a])};var o=a(224),r=n(a(548))},548:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=a(240),i=a(232),l=n(a(549));(0,i.addDep)({name:"column3dManagerAnimation",type:"animationRule",extension:l["default"]});var s=function(t){function e(){var e;return(e=t.call(this)||this).setState("visible",!0),e}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"group"},a.getName=function(){return"column3d"},a.getCanvasPadding=function(){var t,e,a={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0};return this._mapChildren((function(n){for(e in t=n.getCanvasPadding&&n.getCanvasPadding()||{})t.hasOwnProperty(e)&&(a[e]=Math.max(t[e],a[e]))})),a},a.createContainer=function(){var t,e,a=this.getFromEnv("animationManager"),n=this.getLinkedParent().getChildContainer();for(t in n)e=n[t],!this.getChildContainer(t)&&this.addChildContainer(t,a.setAnimation({el:"group",attr:{name:"manager"+t},container:e,component:this,label:"group"}))},a.draw3DContainer=function(){var t,e=this.getFromEnv("animationManager"),a=this.getChildContainer("plotGroup3d"),n=this.getFromEnv("xAxis").getTicksLen(),o=a&&a.negative,r=a&&a.positive,i=this.getLinkedParent().getChildContainer().columnVcanvasGroup;for(!this.getChildContainer("plotGroup3d")&&this.addChildContainer("plotGroup3d",e.setAnimation({el:"group",attr:{name:"3d-plots"},container:i,component:this,label:"group"})),a=this.getChildContainer("plotGroup3d"),this.addToEnv("plotGroup3d",a),o=a.negative=e.setAnimation({el:o||"group",attr:{name:"negative-values"},container:a,component:this,label:"group"}),r=a.positive=e.setAnimation({el:r||"group",attr:{name:"positive-values"},container:a,component:this,label:"group"}),a.zeroPlane=e.setAnimation({el:a.zeroPlane||"group",attr:{name:"zero-plane"},container:a,component:this,label:"group"}).insertBefore(a.positive),(a.negativeGroupArray=a.negativeGroupArray=o.data("categoryplots"))||(o.data("categoryplots",new Array(n)),a.negativeGroupArray=o.data("categoryplots")),(a.positiveGroupAarray=a.positiveGroupAarray=r.data("categoryplots"))||(r.data("categoryplots",new Array(n)),a.positiveGroupAarray=r.data("categoryplots")),t=0;t<n;t++)a.negativeGroupArray[t]=e.setAnimation({el:a.negativeGroupArray[t]||"group",attr:{name:"negative-group-"+t},container:o,component:this,label:"group"}),a.positiveGroupAarray[t]=e.setAnimation({el:a.positiveGroupAarray[t]||"group",attr:{name:"positive-group-"+t},container:r,component:this,label:"group"})},a.drawZeroPlane=function(){var t,e,a=this.getFromEnv("chart"),n=a.getFromEnv("animationManager"),o=a.isBar,r=a.config,i=r.use3dlighting,l=this.getChildContainer("plotGroup3d"),s=this.getFromEnv("yAxis"),c=s.getLimit(),u=c.max,d=c.min,h=this.getGraphicalElement("zeroplane"),f={},p=r.xDepth,g=r.yDepth,v=s.getPixel(s.getAxisBase());d<0&&u>=0?(!this.graphics&&(this.graphics={}),e=l.zeroPlane,f.fill=r.zeroPlaneColor,f.noGradient=!i,f.stroke=r.zeroPlaneBorderColor||"none",f["stroke-width"]=r.zeroPlaneShowBorder?1:0,f.x=o?v-p:r.canvasLeft-p,f.y=o?r.canvasTop+g:v+g,f.width=o?1:r.canvasWidth,f.height=o?r.canvasHeight:1,f.xDepth=p,f.yDepth=g,h&&(h.show(),h._.cubetop.show(),h._.cubeside.show()),t={el:h||"cubepath",attr:f,container:e,component:this,label:"zeroPlane"}):h&&(t={el:h,attr:o?{x:v-g}:{y:v+g},component:this,doNotRemove:!0,callback:function(){h.hide(),h._.cubetop.hide(),h._.cubeside.hide()},container:l,label:"zeroPlane"}),t&&this.addGraphicalElement("zeroplane",n.setAnimation(t))},a.draw=function(){this.createContainer(),this.draw3DContainer(),this.drawZeroPlane()},a.childChanged=function(t){void 0===t&&(t={});var e,a,n=this.config,o=this.getLinkedParent(),r=0,i=this.getState("visible"),l={};this._mapChildren((function(t){t.getState("visible")&&r++})),this.setState("visible",!!r),i!==!!r&&(a=!0),!1!==t.dataLimitChanged&&((e=this.getDataLimits()).min===n.range.min&&e.max===n.range.max||(n.range.min=e.min,n.range.max=e.max,l.dataLimitChanged=!0,a=!0)),a?o.childChanged&&o.childChanged(l):this.asyncDraw()},a.getAxisValuePadding=function(){var t={},e=-Infinity,a=-Infinity;return this._mapChildren((function(n){n.getState("removed")||(t=n.getAxisValuePadding&&n.getAxisValuePadding()||{},e=Math.max(e,t.left||-Infinity),a=Math.max(a,t.right||-Infinity))})),e===-Infinity&&(e=0),a===-Infinity&&(a=0),this.config.padding||(this.config.padding={},this.config.padding.left=e,this.config.padding.right=a),{left:e,right:a}},a.getDataLimits=function(t){var e,a=+Infinity,n=-Infinity,o=0,r=function(t){n=Math.max(n,t.max),a=Math.min(a,t.min)};return this._mapChildren((function(a){a.getState("removed")||(!1!==a.getState("visible")?(o++,e=a.getDataLimits(t),r(e)):t&&(e=a.getDataLimits(t),r(e)))})),o?this.setState("visible",!0):this.setState("visible",!1),this.config.range||(this.config.range={},this.config.range.min=this.config.dataMin,this.config.range.max=this.config.dataMax),{max:n,min:a}},a.isVisible=function(){return!this.isNotVisible},e}(r.ComponentInterface);e["default"]=s},549:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;e["default"]={"initial.group.column3d":function(){return{"zeroPlane.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"axis"}]}}}}},550:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(538)),i=a(224),l=a(551),s=a(232),c=n(a(552));(0,s.addDep)({name:"column3dAnimation",type:"animationRule",extension:c["default"]});var u=function(t){function e(){var e;return(e=t.call(this)||this).setContainerVisibility=i.stubFN,e}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"column3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.use3dlighting=i.UNDEF},a.createContainer=function(){var t=this.getLinkedParent(),e=this.getFromEnv("paper");!this.getContainer("labelGroup")&&this.addContainer("labelGroup",function(t,e,a){return e.group(t,a)}("label-group",e,t.getChildContainer("vcanvasLabelGroup")).attr("class","fusioncharts-datalabels")).attr("opacity",1)},a._getHoveredPlot=function(t,e){var a,n,o=this.getFromEnv("chart").isBar;return a=this.getFromEnv("xAxis").getValue(o?e:t),(n=Math.round(a))-a>0?l._checkPointerOverColumn.call(this,n,t,e)||l._checkPointerOverColumn.call(this,n-1,t,e):l._checkPointerOverColumn.call(this,n+1,t,e)||l._checkPointerOverColumn.call(this,n,t,e)},e}(r["default"]);e["default"]=u},551:function(t,e,a){"use strict";e.__esModule=!0,e._checkPointerOverColumn=function(t,e,a){var o,r,i,l,s,c,u,d,h,f=this.getFromEnv("chart").config,p=f.plotborderthickness,g=f.showplotborder,v=this.components.data,m=v[t];if(!m)return;if(o=m.config.setValue,s=(s=(p=g?p:0)/2)%2==0?s+1:n(s),null!==o&&(c=m._xPos-10,d=m._width+10,u=m._yPos,h=m._height+10,i=a-u+s,l=!!(l=!!(l=(r=e-c+s)>=0&&r<=d+p&&i>=0&&i<=h+p)&&e+a-(c+u)-10>0)&&e+a-(c+u+d+h)+10<0))return{pointIndex:t,hovered:l,pointObj:v[t]}};var n=Math.round},552:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(539)),r={"initial.dataset.column3D":o["default"]["initial.dataset.column"],"legendInteraction.dataset.column3D":o["default"]["legendInteraction.dataset.column"]};e["default"]=r},553:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(554))["default"];e["default"]=o},554:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(462)),i=n(a(555)),l=a(224),s=l.preDefStr.SEVENTYSTRING,c=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.axisPaddingLeft=0,e.axisPaddingRight=0,e}(0,o["default"])(e,t),e.getName=function(){return"Line"};var a=e.prototype;return a.getName=function(){return"Line"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Line Chart",e.singleseries=!0,e.defaultDatasetType="line",e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha=l.HUNDREDSTRING,e.anchorimagealpha=l.HUNDREDSTRING,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=s,e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha=l.HUNDREDSTRING,e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0,e.zeroplanethickness=1,e.enablemousetracking=!0,e.zeroplanealpha=40,e.showzeroplaneontop=0,e.defaultcrosslinethickness=1},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=c},559:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(560))["default"];e["default"]=o},560:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(462)),i=n(a(556)),l=a(224),s=l.preDefStr.SEVENTYSTRING,c=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=0,e}(0,o["default"])(e,t),e.getName=function(){return"Area2D"};var a=e.prototype;return a.getName=function(){return"Area2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Area Chart",e.singleseries=!0,e.defaultDatasetType="area",e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha=l.HUNDREDSTRING,e.anchorimagealpha=l.HUNDREDSTRING,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=s,e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha=l.HUNDREDSTRING,e.linethickness=2,e.drawfullareaborder=1,e.inheritplotbordercolor=0,e.connectnulldata=0,e.enablemousetracking=!0,e.defaultcrosslinethickness=1},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=c},561:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(562))["default"];e["default"]=o},562:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(563)),i=n(a(579)),l=function(t){function e(){var e;return(e=t.call(this)||this).isBar=!0,e}(0,o["default"])(e,t),e.getName=function(){return"Bar2D"};var a=e.prototype;return a.getType=function(){return"chartAPI"},a.getName=function(){return"Bar2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.friendlyName="Bar Chart",this.config.singleseries=!0,this.config.defaultDatasetType="bar2d",this.config.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){},e}(r["default"]);e["default"]=l},563:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(462)),i=a(564),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getName=function(){return"SSBarCartesian"},e.getName=function(){return"SSBarCartesian"},a._feedAxesRawData=function(){return i.__feedAxesRawData.call(this)},a._spaceManager=function(){i.__spaceManager.call(this)},a._postSpaceManagement=function(){i.__postSpaceManagement.call(this)},e}(r["default"]);e["default"]=l},581:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(582))["default"];e["default"]=o},582:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(583)),i=n(a(584)),l=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.fireGroupEvent=!0,e.isBar=!0,e.defaultZeroPlaneHighlighted=!1,e}(0,o["default"])(e,t),e.getName=function(){return"Bar3D"};var a=e.prototype;return a.getName=function(){return"Bar3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.singleseries=!0,e.friendlyName="3D Bar Chart",e.defaultDatasetType="bar3d",e.showplotborder=0,e.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},583:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(542)),i=a(564),l=function(t){function e(){var e;return(e=t.call(this)||this).__feedAxesRawData=i.__feedAxesRawData,e.__spaceManager=i.__spaceManager,e.__postSpaceManagement=i.__postSpaceManagement,e}(0,o["default"])(e,t),e.getName=function(){return"SSBarCartesian3D"};var a=e.prototype;return a.getName=function(){return"SSBarCartesian3D"},a._feedAxesRawData=function(){return i.__feedAxesRawData.call(this)},a._spaceManager=function(){i.__spaceManager.call(this)},a._postSpaceManagement=function(){i.__postSpaceManagement.call(this)},e}(r["default"]);e["default"]=l},584:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(550)),i=a(579),l=a(232),s=n(a(585));(0,l.addDep)({name:"bar3DAnimation",type:"animationRule",extension:s["default"]});var c=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"bar3D"},a._checkPointerOverColumn=function(t,e,a){var n,o,r,i,l,s,c,u=this.getFromEnv("chart").config,d=u.plotborderthickness,h=u.showplotborder,f=this.components.data,p=f[t];if(p)return d=h?d:0,null!==p.config.setValue&&(l=p._yPos,c=p._height+5,i=p._xPos-5,s=p._width+5,o=a-l,r=!!(r=!!(r=(n=e-i)>=0&&n<=s+d&&o>=0&&o<=c+d)&&e+a-(i+l)-5>0)&&e+a-(i+l+s+c)+5<0)?{pointIndex:t,hovered:r,pointObj:f[t]}:void 0},a._getHoveredPlot=function(t,e){var a,n,o=this.getFromEnv("chart").isBar;return a=this.getFromEnv("xAxis").getValue(o?e:t),(n=Math.round(a))-a>0?this._checkPointerOverColumn(n,t,e)||this._checkPointerOverColumn(n-1,t,e):this._checkPointerOverColumn(n+1,t,e)||this._checkPointerOverColumn(n,t,e)},a.drawLabel=function(){var t=this.config;i.drawLabel.call(this,t.scrollMinVal,t.scrollMaxVal)},e}(r["default"]);e["default"]=c},585:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(580)),r={"initial.dataset.bar3D":o["default"]["initial.dataset.bar2D"],"legendInteraction.dataset.bar3D":o["default"]["legendInteraction.dataset.bar2D"]};e["default"]=r},586:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(587))["default"];e["default"]=o},587:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(588)),i=n(a(465)),l=a(224),s=n(a(470)),c=n(a(472)),u=n(a(474)),d=n(a(591)),h=n(a(568)),f=a(566),p=a(236),g=Math,v=g.min,m=g.max,b=g.abs,C=g.PI,D=g.round,_=C/180,y=180/C,S=0,k=function(t,e,a){var n,o,r,i,l=!!a,s=e;return t?((i=(n=t.components&&t.components.data||[])[s=t.config.reversePlotOrder?n.length-s-1:s])&&(o=i.config,r=l!==i.config.sliced||void 0===a?t.plotGraphicClick.call(i.graphics.element):o.sliced),r):r},A=function(t){(0,o["default"])(a,t),a.getName=function(){return"Pie2D"};var e=a.prototype;function a(){var e;return(e=t.call(this)||this).defaultSeriesType="pie",e.defaultPlotShadow=1,e.reverseLegend=1,e.defaultPaletteOptions=void 0,e.sliceOnLegendClick=!0,e.dontShowLegendByDefault=!0,e.defaultZeroPlaneHighlighted=!1,e.hasCanvas=!0,e.eiMethods={isPlotItemSliced:function(t){var e,a,n=this.apiInstance,o=n&&n.getDatasets();return o&&(o=o[0])&&(e=o.components.data)&&e[t]&&(a=e[t].config)&&a.sliced},addData:function(){var t=this.apiInstance,e=t&&t.getDatasets();return e&&(e=e[0])&&e.addData.apply(e,arguments)},removeData:function(){var t=this.apiInstance,e=t&&t.getDatasets();return e&&(e=e[0])&&e.removeData.apply(e,arguments)},updateData:function(){var t=this.apiInstance,e=t&&t.getDatasets();return e&&(e=e[0])&&e.updateData.apply(e,arguments)},slicePlotItem:function(t,e,a){var n=this.apiInstance;if(!a)return k(n.getDatasets()[0],t,e);n.addJob("eiMethods-slice-plot"+S++,(function(){var o=k(n.getDatasets()[0],t,e);return"function"==typeof a&&a(o)}),p.priorityList.postRender)},startingAngle:function(t,e,a){var n,o=this.apiInstance;if(!a)return o._startingAngle(t,e);o.addJob("eiMethods-start-angle"+S++,(function(){n=o._startingAngle(t,e),"function"==typeof a&&a(n)}),p.priorityList.postRender)}},e.registerFactory("dataset",d["default"],["vCanvas","legend"]),e.registerFactory("legend",h["default"]),e}return e.getName=function(){return"Pie2D"},e.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.alignCaptionWithCanvas=0,e.formatnumberscale=1,e.isSingleSeries=!0,e.friendlyName="Pie Chart",e.defaultDatasetType="Pie2D",e.plotborderthickness=1,e.decimals=2,e.alphaanimation=0,e.singletonPlaceValue=!0,e.usedataplotcolorforlabels=0,e.enableslicing=l.ONESTRING,e.skipCanvasDrawing=!0},e.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e);var a=this.getFromEnv("chart-attrib");this.config.showLegend=(0,l.pluckNumber)(a.showlegend,0),this.config.showvalues=(0,l.pluckNumber)(a.showvalues,1),this.config.showlabels=(0,l.pluckNumber)(a.showlabels,1)},e.configureAttributes=function(t){var e=this.config;this.parseChartAttr(t),this.createComponent(t),this.config.skipConfigureIteration.axis=!0,this.configureChildren(),this.getFromEnv("toolTipController").setStyle({backgroundColor:l.hasSVG?(0,l.convertColor)(e.tooltipbgcolor||"FFF",e.tooltipbgalpha||100):(e.tooltipbgcolor||"FFF").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),color:(e.tooltipcolor||e.basefontcolor||"545454").replace(/^#?([a-f0-9]+)/gi,"#$1"),borderColor:l.hasSVG?(0,l.convertColor)(e.tooltipbordercolor||"666",e.tooltipborderalpha||100):(e.tooltipbordercolor||"666").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),borderWidth:(0,l.pluckNumber)(e.tooltipborderthickness,1)+"px",showToolTipShadow:(0,l.pluckNumber)(e.showtooltipshadow||0),borderRadius:(0,l.pluckNumber)(e.tooltipborderradius,0)+"px",fontSize:(0,l.pluckNumber)(this.computeFontSize(e.basefontsize),10)+"px",fontFamily:e.basefont||this.getFromEnv("style").inCanfontFamily,padding:(0,l.pluckNumber)(e.tooltippadding||3)+"px"})},e.createComponent=function(){var t;t=this.config.skipConfigureIteration={},this.createBaseComponent(),this.getFromEnv("animationManager").setAnimationState(this._firstConfigure?"initial":"update"),(0,l.componentFactory)(this,s["default"],"caption"),t.caption=!0,(0,l.componentFactory)(this,c["default"],"subCaption"),t.subCaption=!0,(0,l.componentFactory)(this,u["default"],"background"),t.background=!0,t.canvas=!0,this._createConfigurableComponents&&this._createConfigurableComponents(),this.config.realtimeEnabled&&this._realTimeConfigure&&this._realTimeConfigure()},e._postSpaceManagement=function(){this.config.showLegend&&this.getChildren("legend")&&this.getChildren("legend")[0].postSpaceManager(),this.allocateDimensionOfChartMenuBar()},e._checkInvalidSpecificData=function(){var t,e,a,n=0,o=0,r=this.getFromEnv("dataSource").data;if(!r)return!0;for(e=r.length||0,t=0;t<e;t++)a=Number(r[t].value),n+=isNaN(a)||0!==a?0:1,o+=isNaN(a)?1:0;return n+o>=e},e._spaceManager=function(){var t,e,a,n,o,r,i=this.config,s=this.getChildren("dataset")[0],c=s.components.data,u=s.config,d=this.getFromEnv("legend"),h=this.getFromEnv("color-manager"),f=this.getFromEnv("smartLabel"),p=this.getFromEnv("chartWidth"),g=this.getFromEnv("chartHeight"),C=[],D=u.dataLabelCounter,_=0,y=this.getFromEnv("dataSource").chart,S=(0,l.pluckNumber)(y.managelabeloverflow,0),k=(0,l.pluckNumber)(y.slicingdistance),A=u.preSliced||i.allPlotSliceEnabled!==l.ZEROSTRING||y.showlegend===l.ONESTRING&&y.interactivelegend!==l.ZEROSTRING?b((0,l.pluckNumber)(k,20)):0,x=/%/g.test(y.pieradius),P=(0,l.pluckNumber)(x?Math.min(p/2,g/2)*(parseFloat(y.pieradius)/100):y.pieradius,0),w=(0,l.pluckNumber)(y.enablesmartlabels,y.enablesmartlabel,1),N=w?(0,l.pluckNumber)(y.skipoverlaplabels,y.skipoverlaplabel,1):0,T=(0,l.pluckNumber)(y.issmartlineslanted,1),F=D?(0,l.pluckNumber)(y.labeldistance,y.smartlabelclearance,5):A,M=i.width,B=i.height,E=(this._manageActionBarSpace(.225*B)||{}).bottom,L=M-(i.marginRight+i.marginLeft),I=B-(i.marginTop+i.marginBottom)-(E?E+i.marginBottom:0),O=v(I,L),R=(0,l.pluck)(y.smartlinecolor,h.getColor("plotFillColor")),G=(0,l.pluckNumber)(y.smartlinealpha,100),V=(0,l.pluckNumber)(y.smartlinethickness,.7),z=u.dataLabelOptions=s._parseDataLabelOptions(),H=z.style,W=D?(0,l.pluckNumber)(parseInt(H.lineHeight,10),12):0,Y=0===P?.15*O:P,U=2*Y,j=u.pieYScale,X=u.pieSliceDepth,Z=(0,l.pluck)(y.legendposition,l.POSITION_BOTTOM).toLowerCase().split("-");if(z.connectorWidth=V,z.connectorPadding=(0,l.pluckNumber)(y.connectorpadding,5),z.connectorColor=(0,l.convertColor)(R,G),r=U+2*(W+(t=(i.showvalues||i.showlabels)&&("inside"!==u.labelPosition||"inside"!==u.valuePosition)?F+A:F)),I-=((a=this._manageChartMenuBar(r<I?I-r:I/2)).top||0)+(a.bottom||0),u.showLegend&&(this.config.hasLegend=!0,Z[0]===l.POSITION_RIGHT||Z[0]===l.POSITION_LEFT?(e=d._manageLegendPosition(I/2),L-=m(e.left,e.right)):(e=d._manageLegendPosition(I/2),I-=m(e.top,e.bottom)),e&&this._allocateSpace(e)),f.useEllipsesOnOverflow(i.useEllipsesWhenOverflow),1!==D)for(;D--;)f.setStyle(c[D].config.style||i.dataLabelStyle),C[D]=n=f.getOriSize(c[D].config.displayValue),_="inside"!==u.labelPosition||"inside"!==u.valuePosition?m(_,n.width):0;0===P?Y=this._stubRadius(L,_,I,t,A,W,Y,F):(u.slicingDistance=A,u.pieMinRadius=Y,z.distance=F),o=I-2*(Y*j+W),u.managedPieSliceDepth=X>o?X-o:u.pieSliceDepth,z.isSmartLineSlanted=T,z.enableSmartLabels=w,z.skipOverlapLabels=N,z.manageLabelOverflow=S},e._stubRadius=function(t,e,a,n,o,r,i,s){var c,u=i,d=o,h=this.getChildren("dataset")[0],f=h.config,p=this.getFromEnv("dataSource").chart,g=(0,l.pluckNumber)(p.slicingdistance),b=f.dataLabelOptions||(f.dataLabelOptions=h._parseDataLabelOptions());return(c=v(t/2-e-d,a/2-r)-n)>=u?u=c:g||(d=m(v(n-(u-c),d),10)),f.slicingDistance=d,f.pieMinRadius=u,b.distance=s,u},e._startingAngle=function(t,e){var a,n=t,o=this.getChildren("dataset")[0],r=o.config,i=(a=r.startAngle)*-y+(-1*a<0?360:0);return isNaN(n)||r.singletonCase||r.isRotating||(n+=e?i:0,r.startAngle=-n*_,o._rotate(n),i=n),D(100*((i%=360)+(i<0?360:0)))/100},e._manageLegendSpace=function(){f._manageLegendSpace.call(this)},e.getDSdef=function(){return r["default"]},a}(i["default"]);e["default"]=A},591:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=function(t){var e,a,o=t.getFromEnv("dataSource"),r=o.dataset,i=o.data||r&&r[0].data;if(a=function(t){var e=[];return(0,n.fcEach)(t,(function(t){"true"!==t.vline&&!0!==t.vline&&1!==t.vline&&"1"!==t.vline&&e.push(t)})),{catData:[],data:e}}(i),!(i&&0!==i.length))return void t.setChartMessage();e=t.getDSdef(),(0,n.datasetFactory)(t,e,"dataset",1,[a])};var n=a(224)},592:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(593))["default"];e["default"]=o},593:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(587)),i=n(a(594)),l=a(224),s=Math,c=s.round,u=s.min,d=s.max,h=s.PI,f=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=0,e}(0,o["default"])(e,t),e.getName=function(){return"Pie3D"};var a=e.prototype;return a.getName=function(){return"Pie3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="3D Pie Chart",e.defaultDatasetType="Pie3D",e.plotborderthickness=.1,e.alphaanimation=1},a.animate=function(){var t,e,a,n,o,r,i,l,s=this.components.dataset[0],c=s.config,u=s.components.data,d=u.length,f=c.alphaAnimation,p=this.get("config","animationObj"),g=p.duration||0,v=p.dummyObj,m=p.animObj,b=p.animType;if(!f)for(t=0;t<d;t++)a=(e=u[t]).graphics,o=e.config.shapeArgs,r=2*h,(n=a.element)&&(n.attr({sAngle:r,eAngle:r}),i=o.sAngle,l=o.eAngle,(void 0).animateWith(v,m,{cx:i-r,cy:l-r},g,b))},a._stubRadius=function(t,e,a,n,o,r,i){var s,c=a,h=i,f=o,p=n,g=this.getChildren("dataset")[0],v=g.config,m=g.config,b=(0,l.pluckNumber)(m.slicingdistance),C=v.dataLabelOptions||(v.dataLabelOptions=g._parseDataLabelOptions()),D=v.pieYScale,_=v.pieSliceDepth;return(s=u(t/2-e-f,((c-=_)/2-r)/D)-p)>=h?h=s:b||(f=p=d(u(p-(h-s),f),10)),v.slicingDistance=f,v.pieMinRadius=h,C.distance=p,h},a._startingAngle=function(t,e){var a,n=t,o=this.getChildren("dataset")[0],r=o.config,i=(a=r.startAngle)+(a<0?360:0);return isNaN(n)||r.singletonCase||r.isRotating||(n+=e?i:0,o._rotate(n),i=n),c(100*((i%=360)+(i<0?360:0)))/100},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=f},594:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(242)),r=n(a(238)),i=function(t,e){if(!e&&t&&t.__esModule)return t;if(null===t||"object"!=typeof t&&"function"!=typeof t)return{"default":t};var a=f(e);if(a&&a.has(t))return a.get(t);var n={},o=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var r in t)if("default"!==r&&Object.prototype.hasOwnProperty.call(t,r)){var i=o?Object.getOwnPropertyDescriptor(t,r):null;i&&(i.get||i.set)?Object.defineProperty(n,r,i):n[r]=t[r]}n["default"]=t,a&&a.set(t,n);return n}(a(588)),l=a(224),s=a(240),c=a(595),u=n(a(597)),d=a(232),h=n(a(598));function f(t){if("function"!=typeof WeakMap)return null;var e=new WeakMap,a=new WeakMap;return(f=function(t){return t?a:e})(t)}var p,g=(0,d.getDep)("redraphael","plugin"),v=window,m=8===window.document.documentMode?"visible":"",b=l.preDefStr.elementStr,C="M",D="L",_="v",y="A",S="Z",k=Math,A=k.max,x=k.min,P=k.abs,w=k.ceil,N=k.sin,T=k.atan2,F=k.cos,M=k.floor,B=k.round,E=k.PI,L=2*E,I=E/2,O=E+I,R=function(t,e){for(var a=[],n=0,o=t.length;n<o;n++)a[n]=e.call(t[n],t[n],n,t);return a},G=function(t){return"string"==typeof t},V=function(t,e){return parseInt(t,e||10)},z={lighting3D:{},lighting2D:{}},H=function(t,e,a,n,o){return T((e-a[1]-n.top)/o,t-a[0]-n.left)},W=function(t){var e=this.data("plotItem"),a=e.index,n=e.chart,o=n.getFromEnv("animationManager"),r=n.config,i=n.getChildren("dataset")[0],l=i.config,s=i.components.data[a],c=s.graphics,u=s.config,d=c.element,h=u.hoverEffects;l.isRotating||(n.plotEventHandler(d,t,"DataPlotRollOver"),h.enabled&&o.setAnimation({el:d,attr:h,component:i})),r.isHovered=!0},Y=function(t){var e,a,n=this.data("plotItem"),o=n.index,r=n.chart,i=r.getFromEnv("animationManager"),l=r.config,s=r.getChildren("dataset")[0],c=s.config,u=s.components.data[o];u&&(e=u.config,a=u.graphics.element,c.isRotating||(r.plotEventHandler(a,t,"DataPlotRollOut"),i.setAnimation({el:a,attr:{color:e.color.color.split(",")[0],alpha:e._3dAlpha,borderWidth:e.borderWidth,borderColor:e.borderColor},component:s})),l.isHovered=!1)},U=function(t){var e,a=this.data("plotItem").chart.getChildren("dataset")[0],n=(0,l.pluckNumber)(t.button,t.originalEvent.button),o=a.config,r=t.data[0],i=t.data[1];o.isRightClicked=!(l.touchEnabled||0===n||1===n),o.enableRotation&&!o.isRightClicked&&(o.isRotating=!1,e=H.call(t,r,i,o.center,o.chartPosition=(0,l.getPosition)(a.getFromEnv("chart-container")),o.pieYScale),o.dragStartAngle=e,o._lastAngle=-o.startAngle,o.startingAngleOnDragStart=o.startAngle)},j=function(){var t=this.data("plotItem"),e=t.index,a=t.chart,n=a.getFromEnv("animationManager"),o=a.config,r=a.getChildren("dataset")[0],i=r.config,s=r.components.data[e],c=s.graphics,u=s.config,d=c.element,h=i.startAngle;i.isRightClicked||i.isRotating&&(setTimeout((function(){i.isRotating=!1}),0),a.fireChartInstanceEvent("rotationEnd",{startingAngle:(0,l.normalizeAngle)(h,!0),changeInAngle:h-i.startingAngleOnDragStart}),!o.isHovered&&n.setAnimation({el:d,attr:{color:u.color.color.split(",")[0],alpha:u._3dAlpha,borderWidth:u.borderWidth,borderColor:u.borderColor},component:r}))},X=function(t){var e,a,n,o=this.data("plotItem").chart,r=t.data,i=r[0],s=r[1],c=r[2],u=r[3],d=o.getChildren("dataset")[0],h=d.config;isNaN(i)||isNaN(s)||!h.enableRotation||h.singletonCase||h.isRightClicked||(e=H.call(t,c,u,h.center,h.chartPosition,h.pieYScale),h.dragStartAngle===e||h.isRotating||(h.isRotating=!0,o.fireChartInstanceEvent("rotationStart",{startingAngle:(0,l.normalizeAngle)(h.startAngle,!0)})),n=e-h.dragStartAngle,h.dragStartAngle=e,h.moveDuration=0,h._lastAngle+=180*n/E,a=(new Date).getTime(),(!h._lastTime||h._lastTime+h.timerThreshold<a)&&(h._lastTime||d._rotate(),h.timerId=setTimeout((function(){o.disposed&&o.disposing||d._rotate()}),h.timerThreshold),h._lastTime=a))},Z=function(t,e){return t._conf.index-e._conf.index||t._conf.cIndex-e._conf.cIndex||t._conf.isStart-e._conf.isStart||t._conf.si-e._conf.si},J=function(t,e){return t.point.value-e.point.value},q=function(t,e){return t.angle-e.angle},K=["start","start","end","end"],$=[-1,1,1,-1],Q=[1,1,-1,-1],tt={stroke:!0,strokeWidth:!0,"stroke-width":!0,dashstyle:!0,"stroke-dasharray":!0,translateX:!0,translateY:!0,"stroke-opacity":!0,fill:!0,"fill-opacity":!0,opacity:!0,transform:!0,cursor:!0,sAngle:!0,eAngle:!0,color:!0,alpha:!0,borderColor:!0,borderAlpha:!0,borderWidth:!0,rolloverProps:!0,showBorderEffect:!0,positionIndex:!0,cx:!0,cy:!0,radiusYFactor:!0,r:!0,innerR:!0},et=function(t,e){var a,n,o,r,i,l,s,c=t,u=this,d=u._confObject,h={},f=d.elements,g=d.Pie3DManager;if(G(c)&&((s=e)!==p&&null!==s)&&(a=c,(c={})[a]=e),!c||G(c))u=tt[c]?d[c]:u._attr(c);else{for(a in c)n=c[a],tt[a]?(d[a]=n,"cursor"===a||"transform"===a||"opacity"===a||"fill-opacity"===a?(h[a]=n,l=!0):"sAngle"===a||"eAngle"===a||"cx"===a||"cy"===a||"radiusYFactor"===a||"r"===a||"innerR"===a?r=!0:"color"!==a&&"alpha"!==a&&"borderColor"!==a&&"borderAlpha"!==a&&"borderWidth"!==a||(i=!0)):u._attr(a,n);if(r&&(g._setSliceShape(d),g.refreshDrawing()),(i||r)&&g._setSliceCosmetics(d),l){for(o in f)f[o].attr(h);u._attr(h)}}return u},at=function(t,e,a){if(!a){var n,o=this._confObject.elements;for(n in o)o[n].on(t,e);return this._on(t,e)}this._on(t,e,!0)},nt=function(t,e,a){var n,o=this._confObject.elements,r=v.navigator.userAgent.toLowerCase().indexOf("android")>-1;for(n in o)r&&"topBorder"!==n&&"frontOuter"!==n&&"startSlice"!==n&&"endSlice"!==n||o[n].drag(t,e,a);return this._drag(t,e,a)},ot=function(){var t,e=this._confObject.elements;for(t in e)e[t].hide();return this._hide()},rt=function(){var t,e=this._confObject.elements;for(t in e)e[t].show();return this._show()},it=function(){var t,e=this._confObject,a=e.elements;for(t in a)a[t].destroy();return l.hasSVG&&(e.clipTop.destroy(),e.clipOuterFront.destroy(),e.clipOuterBack.destroy(),e.clipOuterFront1&&e.clipOuterFront1.destroy(),e.clipInnerFront&&e.clipInnerFront.destroy(),e.clipInnerBack&&e.clipInnerBack.destroy()),this._destroy()},lt=function(t,e){var a,n=this._confObject.elements;if(e===p)return this._data(t);for(a in n)n[a].data(t,e);return this._data(t,e)},st=0;(0,d.addDep)({name:"pie3dAnimation",type:"animationRule",extension:u["default"]});var ct=function(t){function e(){return t.apply(this,arguments)||this}(0,r["default"])(e,t);var a=e.prototype;return a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.setBorderWidth=p,e.alphaanimation=1,e.showBorderEffect=p},a.placeDataLabels=function(t){var e,a,n,o,r,s,c,u,d,h,f,g,v,b,_,y,S,T,M,R,G,V,z,H,Z,tt,et,at,nt,ot,rt,it,lt,st,ct,ut,dt,ht=this,ft=ht.getFromEnv("chart"),pt=ft.getFromEnv("toolTipController"),gt=ft.config,vt=ht.config,mt=ht.components.data,bt=vt.piePlotOptions,Ct=gt.canvasLeft,Dt=gt.canvasTop,_t=gt.canvasWidth,yt=Ct+.5*gt.canvasWidth,St=Dt+.5*gt.canvasHeight,kt=ft.getFromEnv("smartLabel"),At=vt.dataLabelOptions,xt=At.style,Pt=(0,l.pluckNumber)(w(parseFloat(xt.lineHeight)),12),wt=(0,l.getFirstValue)(At.placeInside,!1),Nt=At.skipOverlapLabels,Tt=At.manageLabelOverflow,Ft=At.connectorPadding,Mt=At.distance,Bt=At.connectorWidth,Et=[[],[],[],[]],Lt=Ct,It=Dt,Ot=_t,Rt=parseInt(xt.fontSize,10),Gt=Rt,Vt=Gt/2,zt=[Ft,Ft,-Ft,-Ft],Ht=At.isSmartLineSlanted,Wt=Mt>0,Yt=vt.center||(vt.center=[yt,St,bt.size,bt.innerSize||0]),Ut=Yt[1],jt=Yt[0],Xt=Yt[2],Zt=Yt[4],Jt=vt.labelsRadius,qt=B(100*vt.labelsRadiusY)/100,Kt=vt.maxLabels,$t=vt.enableSmartLabels,Qt=vt.pieSliceDepth/2,te=ft.getFromEnv("animationManager"),ee=ht.getContainer("label-group");if(kt.useEllipsesOnOverflow(gt.useEllipsesWhenOverflow),vt.dataLabelCounter)if(t||kt.setStyle(xt),1===mt.length)G=mt[0],rt=G.graphics,ot=G.config,dt=ot._textAttrs,ut=ot._textCss,Z=rt.label,it=rt.connector,ot.slicedTranslation=[Lt,It],null!==ot.y&&ot.y!==p&&(dt.visibility=m,dt["text-anchor"]="middle",dt.x=jt,dt.y=Ut+Vt-2,dt._x=jt),ut.cursor=ot.labellink?"pointer":"",Z=rt.label=te.setAnimation({el:rt.label||"text",attr:dt,css:ut,label:"label",container:ee,component:ht}),gt.showtooltip&&Z.abbrArr&&Z.abbrArr.length&&pt.enableToolTip(Z,p),Z.on("fc-dragstart",U).on("fc-dragmove",X).on("fc-dragend",j).on("fc-click",i.labelClickFn.bind(Z,ft,G.config.labellink)).on("fc-mouseup",(0,i.plotClickHandler)(ht,Z)).on("fc-mouseover",W).on("fc-mouseout",Y),dt._x&&(Z.x=dt._x,delete dt.x),Z.data("plotItem",dt.plotItem).data("eventArgs",dt.eventArgs),dt.visibility===m&&Z.show(),it&&it.hide();else if(wt)(0,l.fcEach)(mt,(function(t){var e,a,n;rt=t.graphics,ot=t.config,dt=ot._textAttrs,Z=rt.label,null!==ot.y&&ot.y!==p&&(V=ot.angle,M=Ut+Yt[6]*N(V)+Vt-2,_=jt+Yt[5]*F(V),dt._x=_,dt._y=M,ot.sliced&&(a=(e=t.slicedTranslation)[0]-Lt,n=e[1]-It,_+=a,M+=n),dt.visibility=m,dt.align="middle",dt.x=_,dt.y=M),ut.cursor=ot.labellink?"pointer":"",Z=rt.label=te.setAnimation({el:rt.label||"text",attr:dt,css:ut,label:"label",container:ee,component:ht}),gt.showtooltip&&Z&&Z.abbrArr&&Z.abbrArr.length&&pt.enableToolTip(Z,p),Z.data("plotItem",dt.plotItem).data("eventArgs",dt.eventArgs),dt.visibility===m&&Z.show(),Z.x=dt._x,Z._x=dt._x,Z._y=dt._y}));else{for((0,l.fcEach)(mt,(function(t){if(rt=t.graphics,ot=t.config,ut=ot._textCss,!((dt=ot._textAttrs).text=ot.displayValue))return rt.connector&&te.setAnimation({el:rt.connector,component:ht,callback:i.hideFn}),void(rt.label&&te.setAnimation({el:rt.label,component:ht,callback:i.hideFn}));rt=t.graphics,null!==ot.y&&ot.y!==p&&(Z=rt.label,(it=rt.connector)&&it.show(),Z&&Z.show()),Z=rt.label,gt.showtooltip&&Z&&Z.abbrArr&&Z.abbrArr.length&&pt.enableToolTip(Z,p),(V=ot.angle)<0&&(V=L+V),Et[V>=0&&V<I?1:V<E?2:V<O?3:0].push({point:t,angle:V})})),o=4;o--;){if(Nt&&(z=Et[o].length-Kt)>0)for(Et[o].sort(J),s=0,h=(H=Et[o].splice(0,z)).length;s<h;s+=1)G=H[s].point,(rt=G.graphics).label&&te.setAnimation({el:rt.label,attr:{visibility:"hidden"},component:ht}),rt.connector&&te.setAnimation({el:rt.connector,attr:{visibility:"hidden"},component:ht});Et[o].sort(q)}for(ct=A(Et[0].length,Et[1].length,Et[2].length,Et[3].length),st=A(x(ct,Kt)*Gt,qt+Gt),Et[1].reverse(),Et[3].reverse(),kt.setStyle(xt),f=4;f--;){for(h=(R=Et[f]).length,Nt||(Vt=(Gt=h>Kt?st/h:Rt)/2),d=h*Gt,a=st,o=0;o<h;o+=1,d-=Gt)a<(c=P(st*N(R[o].angle)))?c=a:c<d&&(c=d),a=(R[o].oriY=c)-Gt;for(n=K[f],u=st-(h-1)*Gt,a=0,o=R.length-1;o>=0;o-=1,u+=Gt)G=R[o].point,rt=G.graphics,ot=G.config,dt=ot._textAttrs,ut=ot._textCss,null!==ot.y&&dt.text&&(V=R[o].angle,g=ot.sliced,Z=rt.label,(c=P(st*N(V)))<a?c=a:c>u&&(c=u),a=c+Gt,S=(c+R[o].oriY)/2,v=jt+Q[f]*Jt*F(k.asin(S/st)),S*=$[f],S+=Ut,T=Ut+Zt*N(V),b=jt+Xt*F(V),(f<2&&v<b||f>1&&v>b)&&(v=b),M=S+Vt-2,y=(_=v+zt[f])+zt[f],dt._x=y,Tt&&(r=f>1?y-Ct:Ct+Ot-y,kt.setStyle(ot.style),Pt=(0,l.pluckNumber)(w(parseFloat(ot.style.lineHeight)),12)+(2*w(parseFloat(ot.style.border),12)||0),nt=kt.getSmartText(ot.displayValue,r,Pt),dt.text=nt.text,dt.tooltip=nt.tooltext),V<E&&(S+=Qt,T+=Qt,M+=Qt),dt._y=M,g&&(et=ot.transX,at=ot.transY,_+=et,v+=et,b+=et,S+=at,T+=at,y+=et),dt.visibility=m,dt["text-anchor"]=n,dt.x=y,dt.y=S,dt.opacity=1,ut.cursor=ot.labellink?"pointer":"",tt=rt.label,Z=te.setAnimation({el:tt||"text",attr:dt,css:ut,container:ee,component:ht,label:"label"}),gt.showtooltip&&Z&&Z.abbrArr&&Z.abbrArr.length&&pt.enableToolTip(Z,p),Z.outlineText(vt.showTextOutline,dt.fill),Z.data("textPos",{x:y,y:S}).data("plotItem",dt.plotItem).data("eventArgs",dt.eventArgs),tt||(rt.label=Z,Z.on("fc-dragstart",U).on("fc-dragmove",X).on("fc-dragend",j).on("fc-click",i.labelClickFn.bind(Z,ft,G.config.labellink)).on("fc-click",(0,i.plotClickHandler)(ht,Z)).on("fc-mouseover",W).on("fc-mouseout",Y)),Z.x=dt._x,Z._x=dt._x,Z.y=dt._y,dt.tooltip&&(pt.enableToolTip(Z,dt.tooltip),delete dt.tooltip),Wt&&Bt&&$t&&(it=rt.connector,ot.connectorPath=lt=[C,b,T,D,Ht?v:b,S,_,S],e={path:lt,"stroke-width":Bt,stroke:At.connectorColor||"#606060",opacity:1,visibility:m},it&&te.setAnimation({el:it,attr:e,label:"connector",component:ht})))}}},a._parsePie3DOptions=function(){var t=this.config;return{size:2*t.pieMinRadius,slicedOffset:t.slicingDistance,allowPointSelect:!0,cursor:"pointer",innerSize:"pie3d"===this.getName()?0:c._getInnerSize.call(this)}},a._parseBorderConfig=function(t,e,a){var n=this.config.pieBorderColor,o=this.getFromEnv("chart-attrib"),r=(0,l.pluck)(a.bordercolor,n),i=(0,l.pluck)(a.borderalpha,o.plotborderalpha,o.pieborderalpha);return{setPlotBorderColor:r=(0,l.pluck)(r,(0,l.getLightColor)(t,90)).split(",")[0],setPlotBorderAlpha:i=o.showplotborder===l.ZEROSTRING?l.ZEROSTRING:(0,l.pluck)(i,e,"80")}},a._initPie3dManager=function(){var t,e,a,n,o,r,i,s,c,u,d,h=this.getFromEnv("chart"),f=h.config,p=0,g=this.config,v=this.components,m=g.dataLabelOptions,b=g.pie3DOptions=this._parsePie3DOptions(),C=(0,l.pluck)(g.startAngle,0)%L,D=g.managedPieSliceDepth,_=g.slicedOffset=b.slicedOffset,y=f.canvasWidth,S=f.canvasHeight,A=[f.canvasLeft+.5*y,f.canvasTop+.5*S-.5*D],P=v.data,w=x(y,S),T=m.distance,E=g.pieYScale,I=g.slicedOffsetY||(g.slicedOffsetY=_*g.pieYScale),O=this.getFromEnv("pie3DManager");for(A.push(2*g.pieMinRadius,b.innerSize||0),(A=R(A,(function(t,e){return/%$/.test(t)?[y,S-D,w,w][e]*V(t)/100:t})))[2]/=2,A[3]/=2,A.push(A[2]*E),A.push((A[2]+A[3])/2),A.push(A[5]*E),this.getX=function(t,e){return r=k.asin((t-A[1])/(A[2]+T)),A[0]+(e?-1:1)*(F(r)*(A[2]+T))},g.center=A,(0,l.fcEach)(P,(function(t){p+=t.config.y})),g.labelsRadius=A[2]+T,g.labelsRadiusY=g.labelsRadius*E,g.quadrantHeight=(S-D)/2,g.quadrantWidth=y/2,s=(i=B(1e3*(i=C))/1e3)+L,e=(0,l.pluckNumber)(parseInt(m.style.fontSize,10),10)+4,g.maxLabels=M(g.quadrantHeight/e),g.labelFontSize=e,g.connectorPadding=(0,l.pluckNumber)(m.connectorPadding,5),g.isSmartLineSlanted=(0,l.pluck)(m.isSmartLineSlanted,!0),g.connectorWidth=(0,l.pluckNumber)(m.connectorWidth,1),g.enableSmartLabels=m.enableSmartLabels,O||(O=new ut(h),this.attachChild(O,"pie3DManager",!1),this.addToEnv("pie3DManager",O)),this._configurePie3DManager(),t=P.length-1;t>=0;t-=1)n=P[t].config,a=i,c=p?n.y/p:0,(i=B(1e3*(i+c*L))/1e3)>s&&(i=s),o=i,n.shapeArgs={sAngle:B(1e3*a)/1e3,eAngle:B(1e3*o)/1e3},n.centerAngle=r=(o+a)/2%L,n.slicedTranslation=[B(F(r)*_),B(N(r)*I)],u=F(r)*A[2],g.radiusY=d=N(r)*A[4],n.tooltipPos=[A[0]+.7*u,A[1]+d],n.percentage=100*c,n.total=p},a._configurePie3DManager=function(){var t=this.config,e=this.components,a=this.getFromEnv("pie3DManager"),n=e.data;a&&a.configure(t.pieSliceDepth,1===n.length,t.use3DLighting,!1)},a.allocatePosition=function(){var t,e,a,n,o,r,i,s=this.getFromEnv("chart").config,c=this.config,u=this.components.data,d=(0,l.pluck)(c.startAngle,0)%L,h=c.pie3DOptions=this._parsePie3DOptions(),f=c.pieYScale,p=c.managedPieSliceDepth,g=s.canvasWidth,v=s.canvasHeight,m=x(g,v),b=[s.canvasLeft+.5*g,s.canvasTop+.5*v-.5*p],C=0,D=u.length;for(b.push(2*c.pieMinRadius,h.innerSize||0),(b=R(b,(function(t,e){return/%$/.test(t)?[g,v-p,m,m][e]*V(t)/100:t})))[2]/=2,b[3]/=2,b.push(b[2]*f),b.push((b[2]+b[3])/2),b.push(b[5]*f),c.center=b,(0,l.fcEach)(u,(function(t){C+=t.config.y})),i=(d=B(1e3*d)/1e3)+L,t=u.length-1;t>=0;t-=1)o=u[t],a=d,r=C?o.config.y/C:0,(d=B(1e3*(d+r*L))/1e3)>i&&(d=i),n=d,o.config.shapeArgs={sAngle:B(1e3*a)/1e3,eAngle:B(1e3*n)/1e3};for(t=0;t<D;t++)e=u[t],this.parsePlotAttributes(e,t),this.parseLabelAttributes(e,t)},a.parsePlotAttributes=function(t,e){var a,n,o,r,i,s,c,u,d,h,f,g,v,m,b,C,D,_,y=this.components,S=this.config,k=this.getFromEnv("chart"),A=k.config,x=y.data,P=S.dataLabelOptions,w=P.style,T=S.slicingDistance,M=S.slicedOffsetY||(S.slicedOffsetY=T*S.pieYScale),B=S.showBorderEffect,E=x.length,L=S.usePerPointLabelColor,I=A.textDirection,O=e,R=A.dataLabelStyle;a=S.center,S.prevPositions,n=S.pieYScale,(m=(v=t.config)._textAttrs)||(m=v._textAttrs={}),(b=v._textCss)||(b=v._textCss={}),i=v.y,s=v.displayValue,u=v.sliced,f=v.shapeArgs,d=v.centerAngle,g=v.toolText,c=!!v.link,w=v.style,null!==i&&i!==p&&(C={sAngle:f.sAngle,eAngle:f.eAngle,r:a[2],innerR:a[3],cx:a[0],cy:a[1],radiusYFactor:n,opacity:1},s!==p?(w?((b=v._textCss)||(b=v._textCss={}),b.fontFamily=w.fontFamily,b.fontSize=w.fontSize,b.lineHeight=w.lineHeight,b.fontWeight=w.fontWeight,b.fontStyle=w.fontStyle):v._textCss&&(delete v._textCss,b=p),v.style=w||(w=R),m.text=s,m.fill=(L?(0,l.toRaphaelColor)(v.color):w.color)||"#000000",m["text-bound"]=[w.backgroundColor,w.borderColor,w.borderThickness,w.borderPadding,w.borderRadius,w.borderDash],m.direction=I,m.lineHeight=w.lineHeight,P.distance>0&&(h=P.connectorWidth)&&P.enableSmartLabels&&(D={"stroke-width":h,stroke:P.connectorColor||"#606060",cursor:c?"pointer":"",opacity:1})):m.text=l.BLANKSTRING,v.plotItem=r={chart:k,index:O,seriesData:S,value:i,angle:v.angle=d,link:v.link,shapeArgs:f,slicedX:u&&!S.singletonCase?F(d)*T:0,slicedY:u&&!S.singletonCase?N(d)*M:0,sliced:u,labelText:s,name:v.name,percentage:v.percentage,toolText:g,originalIndex:E-O-1,style:v.style,transX:v.transX=F(d)*T,transY:v.transY=N(d)*M,slicedTranslation:v.slicedTranslation="t"+v.transX+","+v.transY,label:void 0,connector:void 0},v.eventArgs=o={index:S.reversePlotOrder?E-1-O:O,link:v.link,value:v.y,displayValue:v.displayValueArgs,categoryLabel:v.categoryLabel,isSliced:v.sliced,toolText:v.toolText,color:v.setColor,alpha:v.setAlpha,borderColor:v.borderConfig.setPlotBorderColor,borderAlpha:v.borderConfig.setPlotBorderAlpha,dashed:v.setBorderDashed,showLabel:v.showLabel,showValue:v.showValue,labelPosition:v.labelPosition,valuePosition:v.valuePosition,labelFont:v.labelFont,labelFontColor:v.labelFontColor||"#555555",labelLink:v.labelLink,hoverColor:v.hoverEffects.hoverColor,hoverAlpha:v.hoverEffects.alpha,borderHoverColor:v.hoverBorderColor,borderHoverAlpha:v.hoverEffects.borderAlpha,id:v.id},_={color:v.color.color.split(",")[0],alpha:v._3dAlpha,borderWidth:v.borderWidth,borderColor:v.borderColor,borderAlpha:v.borderConfig.setPlotBorderAlpha},(0,l.extend2)(C,_),C.cursor=c?"pointer":"",C.showBorderEffect=B,C.transform="t"+r.slicedX+","+r.slicedY,m.plotItem=r,m.eventArgs=o,v.props={element:{attr:C},connector:{attr:D},label:{attr:m,css:b}})},a.draw=function(){var t,e,a,n,o,r,s,c,u,d,h,f,g,v,m,b,C,D,_,y,S,k,A,x,P,w,T,M,B=this,E=B.components,L=B.config,I=B.getFromEnv("chart"),O=I.config,R=I.getFromEnv("animationManager"),G=E.data,V=L.dataLabelOptions,z=V.style,H=L.slicingDistance,Z=L.slicedOffsetY||(L.slicedOffsetY=H*L.pieYScale),J=L.showBorderEffect,q=G.length,K=L.usePerPointLabelColor,$=O.textDirection,Q=L.valueTotal,tt=E.removeDataArr||[],et=B.getState("visible"),at=B.getContainer("labelGroup"),nt={},ot=B.getFromEnv("toolTipController"),rt=O.dataLabelStyle;for(B.getContainer("pie-groups")||B._createContainer(),at=B.getContainer("label-group"),y=B.getContainer("plot-group"),R.setAnimation({el:at,attr:{css:rt},component:B,label:"labelcontainer",callback:function(){et&&Q?(at.show(),y.show()):(at.hide(),y.hide())}}),B._initPie3dManager(),a=B.getFromEnv("pie3DManager"),tt.length&&B.remove(),t=L.center,L.prevPositions||t,e=L.pieYScale,G&&q||(G=[]),_=-1;++_<q;)if((k=(m=(r=G[_]).config)._textAttrs)||(k=m._textAttrs={}),b=r.graphics,s=m.y,c=m.displayValue,d=m.sliced,g=m.shapeArgs,h=m.centerAngle,v=m.toolText,u=!!m.link,z=m.style,null!==s&&s!==p){for(T in S=b.element,C=b.label,D=b.connector,x={sAngle:g.sAngle,eAngle:g.eAngle,r:t[2],innerR:t[3],cx:t[0],cy:t[1],radiusYFactor:e,opacity:1},S?w=!1:(w=!0,(S=b.element=a.useSliceFromPool())||(S=b.element=a.createSlice().drag(X,U,j).on("fc-mouseover",W).on("fc-mouseout",Y)).on("fc-click",(0,i.plotClickHandler)(B,S))),c!==p&&(z?((A=m._textCss)||(A=m._textCss={}),A.fontFamily=z.fontFamily,A.fontSize=z.fontSize,A.lineHeight=z.lineHeight,A.fontWeight=z.fontWeight,A.fontStyle=z.fontStyle):m._textCss&&(C&&C.removeCSS(),delete m._textCss,A=p),m.style=z||(z=rt),k.text=c,k.fill=(K?(0,l.toRaphaelColor)(m.color):z.color)||"#000000",k["text-bound"]=[z.backgroundColor,z.borderColor,z.borderThickness,z.borderPadding,z.borderRadius,z.borderDash],k.direction=$,k.lineHeight=z.lineHeight,V.distance>0&&(f=V.connectorWidth)&&V.enableSmartLabels&&(P={"stroke-width":f,stroke:V.connectorColor||"#606060",cursor:u?"pointer":"",opacity:1},at.show(),D=b.connector=R.setAnimation({el:b.connector||"path",attr:P,container:at,label:"connector",component:B}).show().on("fc-dragstart",U).on("fc-dragmove",X).on("fc-dragend",j).on("fc-mouseover",W).on("fc-mouseout",Y))),Q?(C&&C.show(),D&&D.show()):(C&&C.hide(),D&&D.hide()),o={chart:I,index:_,seriesData:L,value:s,angle:m.angle=h,link:m.link,shapeArgs:g,slicedX:d&&!L.singletonCase?F(h)*H:0,slicedY:d&&!L.singletonCase?N(h)*Z:0,sliced:d,labelText:c,name:m.name,percentage:m.percentage,toolText:v,originalIndex:q-_-1,style:m.style,graphic:S,transX:m.transX=F(h)*H,transY:m.transY=N(h)*Z,slicedTranslation:m.slicedTranslation="t"+m.transX+","+m.transY,label:C,connector:D},n={index:L.reversePlotOrder?q-1-_:_,link:m.link,value:m.y,displayValue:m.displayValueArgs,categoryLabel:m.categoryLabel,isSliced:m.sliced,toolText:m.toolText,color:m.setColor,alpha:m.setAlpha,borderColor:m.borderConfig.setPlotBorderColor,borderAlpha:m.borderConfig.setPlotBorderAlpha,dashed:m.setBorderDashed,showLabel:m.showLabel,showValue:m.showValue,labelPosition:m.labelPosition,valuePosition:m.valuePosition,labelFont:m.labelFont,labelFontColor:m.labelFontColor||"#555555",labelLink:m.labellink,hoverColor:m.hoverEffects.hoverColor,hoverAlpha:m.hoverEffects.alpha,borderHoverColor:m.hoverBorderColor,borderHoverAlpha:m.hoverEffects.borderAlpha,id:m.id},nt={color:m.color.color.split(",")[0],alpha:m._3dAlpha,borderWidth:m.borderWidth,borderColor:m.borderColor,borderAlpha:m.borderConfig.setPlotBorderAlpha},w&&(0,l.extend2)(x,nt),S.data("groupId",_).data("plotItem",o).data("eventArgs",n),S.data("groupId",_).data("plotItem",o).data("eventArgs",n),x.cursor=u?"pointer":"",x.showBorderEffect=J,x.color=m.color.color.split(",")[0],x.alpha=m._3dAlpha,x.borderWidth=m.borderWidth,x.borderColor=m.borderColor,ot.enableToolTip(S,v),M=S._confObject.elements)ot.enableToolTip(M[T],v);x.transform="t"+o.slicedX+","+o.slicedY,k.plotItem=o,k.eventArgs=n,R.setAnimation({el:S,attr:x,component:B,label:"slice",state:w?"appearing":"updating"}),D&&D.data("plotItem",o).data("eventArgs",n)}at.show(),B.placeDataLabels(!1),B.drawn=!0,L.prevPositions=t.slice(0)},a.remove=function(){var t,e,a,n,o=this.config,r=this.components,i=this.getFromEnv("animationManager"),l=r.removeDataArr||[],s=this.pool=this.pool=[],c=l.length,u=this.getFromEnv("pie3DManager"),d=function(t,e){return function(){e===b?(u.removeSlice(t.element),delete t.element):t[e].hide()}},h=o.startAngle,f=o.center;for(a=0;a<c;a++){for(t in e=l[0].graphics)n=e[t],s[t]||(s[t]=[]),t===b?i.setAnimation({el:n,attr:{sAngle:-h,eAngle:.01-h,r:f[2],innerR:f[3],cx:f[0],cy:f[1]},component:this,callback:d(e,t)}):i.setAnimation({el:n,attr:{opacity:0},component:this,callback:d(e,t)});l.splice(0,1)}},a._rotate=function(t){var e,a=this,n=t,o=a.config,r=a.getFromEnv("animationManager"),i=a.components.data,s=o.slicedOffset,c=o.slicedOffsetY,u=o.startAngle,d=a.getFromEnv("pie3DManager");n=isNaN(n)?-o._lastAngle:n,e=(n-u)%360,o.startAngle=(0,l.pluckNumber)(n,o.startAngle)%360,e=-e*E/180,d&&d.rotate(e),(0,l.fcEach)(i,(function(t){var n,o=t.graphics,i=t.config,u=o.element,d=i.shapeArgs,h=d.sAngle+=e,f=d.eAngle+=e,p=i.angle=(0,l.normalizeAngle)((h+f)/2),g=i.sliced,v=F(p),m=N(p);n=i.slicedTranslation=[B(v*s),B(m*c)],i.transX=n[0],i.transY=n[1],i.slicedX=g?F(e)*s:0,i.slicedY=g?N(e)*c:0,u&&g&&r.setAnimation({el:u,attr:{transform:"t"+n[0]+","+n[1]},component:a})})),a.placeDataLabels(!0,i)},a.foldingFn=function(){var t=this.config.startAngle;return{sAngle:-t,eAngle:.01-t}},a.getType=function(){return"dataset"},a.getName=function(){return"pie3d"},e}(i["default"]);g&&g._availableAnimAttrs&&g._availableAnimAttrs.cx&&(g._availableAnimAttrs.innerR=g._availableAnimAttrs.depth=g._availableAnimAttrs.radiusYFactor=g._availableAnimAttrs.sAngle=g._availableAnimAttrs.eAngle=g._availableAnimAttrs.cx),(0,h["default"])(g);var ut=function(t){function e(e){var a;a=t.call(this)||this;var n=(0,o["default"])(a);return n.config={},n.linkedItems={chart:e},a}(0,r["default"])(e,t);var a=e.prototype;return a.getType=function(){return"pie3DManager"},a.getName=function(){return"pie3d"},a.createSlice=function(){var t,e=this.renderer,a={elements:{},Pie3DManager:this},n=this.slicingWallsArr,o=a.elements,r=l.hasSVG?"litepath":"path";return(t=e[r](this.getContainer("topGroup")))._confObject=a,a.thisElement=t,t._destroy=t.destroy,t.destroy=it,t._show=t.show,t.show=rt,t._hide=t.hide,t.hide=ot,t._on=t.on,t.on=at,t._drag=t.drag,t.drag=nt,t._attr=t.attr,t.attr=et,t._data=t.data,t.data=lt,this.pointElemStore.push(t),o.topBorder=e[r](this.getContainer("topGroup")),o.bottom=e[r](this.getContainer("bottomBorderGroup")).attr({"stroke-width":0}),o.bottomBorder=e[r](this.getContainer("bottomBorderGroup")),o.frontOuter=e[r](this.getContainer("slicingWallsFrontGroup")).attr({"stroke-width":0}),o.backOuter=e[r](this.getContainer("slicingWallsFrontGroup")).attr({"stroke-width":0}),o.startSlice=e[r](this.getContainer("slicingWallsFrontGroup")),o.endSlice=e[r](this.getContainer("slicingWallsFrontGroup")),o.frontOuter1=e[r](this.getContainer("slicingWallsFrontGroup")).attr({"stroke-width":0}),o.frontOuter._conf={si:st,isStart:.5},o.frontOuter1._conf={si:st,isStart:.5},o.startSlice._conf={si:st,isStart:0},o.endSlice._conf={si:st,isStart:1},o.backOuter._conf={si:st,isStart:.4},n.push(o.startSlice,o.frontOuter1,o.frontOuter,o.backOuter,o.endSlice),this.isDoughnut&&(o.frontInner=e[r](this.getContainer("slicingWallsFrontGroup")).attr({"stroke-width":0}),o.backInner=e[r](this.getContainer("slicingWallsFrontGroup")).attr({"stroke-width":0}),o.backInner._conf={si:st,isStart:.5},o.frontInner._conf={si:st,isStart:.4},n.push(o.frontInner,o.backInner)),st+=1,t},a.refreshDrawing=function(){var t,e,a,n,o,r=this.slicingWallsArr,i=0,l=r.length,s=this.getContainer("slicingWallsFrontGroup"),c=this.getContainer("slicingWallsBackGroup");for(r.sort(Z),e=function(t){var e,a,n,o,r=t[0]&&t[0]._conf.index;for(n=r<=E,a=1,e=t.length;a<e;a+=1)if((o=t[a]._conf.index)<=E!==n||o<r)return a;return 0}(r);i<l;i+=1,e+=1)e===l&&(e=0),(o=(t=r[e])._conf.index)<I?s.appendChild(t):o<=E?(a?t.insertBefore(a):s.appendChild(t),a=t):o<=O?(n?t.insertBefore(n):c.appendChild(t),n=t):c.appendChild(t)},a.configure=function(t,e,a,n){var o=t,r=e,i=a,l=n,s=this.getLinkedParent(),c=this.getFromEnv("paper"),u=s.getContainer("plot-group");"object"==typeof o&&(r=(o=o.depth).hasOnePoint,i=o.use3DLighting,l=o.isDoughnut),this.renderer||(this.renderer=c),this.hasOnePoint=r,this.use3DLighting=i,this.isDoughnut=l,this.depth=o,!this.getContainer("bottomBorderGroup")&&this.addContainer("bottomBorderGroup",c.group("bottom-border",u)),this.getContainer("bottomBorderGroup").attr({transform:"t0,"+o}),!this.getContainer("slicingWallsBackGroup")&&this.addContainer("slicingWallsBackGroup",c.group("slicingWalls-back-Side",u)),!this.getContainer("slicingWallsFrontGroup")&&this.addContainer("slicingWallsFrontGroup",c.group("slicingWalls-front-Side",u)),!this.getContainer("topGroup")&&this.addContainer("topGroup",c.group("top-Side",u)),!this.pointElemStore&&(this.pointElemStore=[]),!this.slicingWallsArr&&(this.slicingWallsArr=[]),this.moveCmdArr=[C],this.lineCmdArr=[D],this.closeCmdArr=[S],this.colorObjs=[]},a._parseSliceColor=function(t,e,a){var n,o,r,i,s,c,u,d,h,f,p,g,v,m,b,C,D,_,y,S,k=t,A=e,x=3,P=this.use3DLighting,w=P?z.lighting3D:z.lighting2D,N=a.radiusYFactor,T=a.cx,F=a.cy,M=a.r,B=M*N,E=a.innerR||0,L=T+M,I=T-M,O=T+E,R=T-E;return~k.indexOf("rgb")&&(k=(0,l.rawRGBtoHEX)(k)),p=(A=A||100)/2,w[k]&&w[k][A]?S=w[k][A]:(w[k]||(w[k]={}),w[k][A]||(w[k][A]={}),S=w[k][A],P?(n=(0,l.getDarkColor)(k,80),o=(0,l.getDarkColor)(k,75),c=(0,l.getLightColor)(k,85),u=(0,l.getLightColor)(k,70),d=(0,l.getLightColor)(k,40),h=(0,l.getLightColor)(k,50),f=(0,l.getLightColor)(k,65),r=(0,l.getDarkColor)(k,69),i=(0,l.getDarkColor)(k,75),s=(0,l.getDarkColor)(k,95)):(x=10,n=(0,l.getDarkColor)(k,90),o=(0,l.getDarkColor)(k,87),c=(0,l.getLightColor)(k,93),u=(0,l.getLightColor)(k,87),d=(0,l.getLightColor)(k,80),f=h=(0,l.getLightColor)(k,85),s=(0,l.getDarkColor)(k,85),r=(0,l.getDarkColor)(k,75),i=(0,l.getDarkColor)(k,80)),g=o+","+c+","+u+","+c+","+o,m=A+","+A+","+A+","+A+","+A,v=o+","+k+","+c+","+k+","+o,b=p+","+p+","+p+","+p+","+p,D=o+","+k+","+d+","+k+","+o,_=i+","+c+","+h+","+c+","+r,y="FFFFFF,FFFFFF,FFFFFF,FFFFFF,FFFFFF",C="0,"+p/x+","+A/x+","+p/x+",0",l.hasSVG?S.top={FCcolor:{gradientUnits:"userSpaceOnUse",radialGradient:!0,color:f+","+s,alpha:A+","+A,ratio:"0,100"}}:S.top={FCcolor:{gradientUnits:"objectBoundingBox",color:u+","+u+","+c+","+o,alpha:A+","+A+","+A+","+A,angle:-72,ratio:"0,8,15,77"}},S.frontOuter={FCcolor:{gradientUnits:"userSpaceOnUse",y1:0,y2:0,color:_,alpha:m,angle:0,ratio:"0,20,15,15,50"}},S.backOuter={FCcolor:{gradientUnits:"userSpaceOnUse",y1:0,y2:0,color:D,alpha:b,angle:0,ratio:"0,62,8,8,22"}},S.frontInner={FCcolor:{gradientUnits:"userSpaceOnUse",y1:0,y2:0,color:v,alpha:b,angle:0,ratio:"0,25,5,5,65"}},S.backInner={FCcolor:{gradientUnits:"userSpaceOnUse",y1:0,y2:0,color:g,alpha:m,angle:0,ratio:"0,62,8,8,22"}},S.topBorder={FCcolor:{gradientUnits:"userSpaceOnUse",y1:0,y2:0,color:y,alpha:C,angle:0,ratio:"0,20,15,15,50"}},S.topInnerBorder={FCcolor:{gradientUnits:"userSpaceOnUse",y1:0,y2:0,color:y,alpha:C,angle:0,ratio:"0,50,15,15,20"}},S.bottom=(0,l.toRaphaelColor)((0,l.convertColor)(k,p)),S.startSlice=(0,l.toRaphaelColor)((0,l.convertColor)(n,A)),S.endSlice=(0,l.toRaphaelColor)((0,l.convertColor)(n,A))),S.cx===T&&S.cy===F&&S.rx===M&&S.radiusYFactor===N&&S.innerRx===E||(l.hasSVG&&(S.top.FCcolor.cx=T,S.top.FCcolor.cy=F,S.top.FCcolor.r=M,S.top.FCcolor.fx=T-.3*M,S.top.FCcolor.fy=F+1.2*B),S.topBorder.FCcolor.x1=S.backOuter.FCcolor.x1=S.frontOuter.FCcolor.x1=I,S.topBorder.FCcolor.x2=S.backOuter.FCcolor.x2=S.frontOuter.FCcolor.x2=L,S.topInnerBorder.FCcolor.x1=S.backInner.FCcolor.x1=S.frontInner.FCcolor.x1=R,S.topInnerBorder.FCcolor.x2=S.backInner.FCcolor.x2=S.frontInner.FCcolor.x2=O,S.cx=T,S.cy=F,S.rx=M,S.radiusYFactor=N,S.innerRx=E),S},a.allocatePosition=function(){},a.rotate=function(t){var e,a=this.pointElemStore,n=0,o=a.length;if(!this.hasOnePoint){for(;n<o;n+=1)(e=a[n]._confObject).sAngle+=t,e.eAngle+=t,this._setSliceShape(e);this.refreshDrawing()}},a.removeSlice=function(t){var e,a,n=this.pointElemStore,o=t._confObject.elements,r=this.slicingWallsArr,i=n.length;for(e=i-1;e>=0;e-=1)n[e]===t&&n.splice(e,1);for(e=(i=r.length)-1;e>=0;e-=1)(a=r[e])!==o.startSlice&&a!==o.frontOuter1&&a!==o.frontOuter&&a!==o.backInner&&a!==o.endSlice||r.splice(e,1);t.hide&&t.hide(),this._slicePool||(this._slicePool=[]),this._slicePool.push(t),this.refreshDrawing()},a.useSliceFromPool=function(){var t,e=this._slicePool||(this._slicePool=[]),a=this.slicingWallsArr,n=!1;return e.length&&(n=e.shift(),this.pointElemStore.push(n),n.show(),t=n._confObject.elements,a.push(t.startSlice,t.frontOuter1,t.frontOuter),t.backInner&&a.push(t.backInner),a.push(t.endSlice)),n},a._setSliceShape=function(t,e){var a,n,o,r,i,s,c,u,d,h,f,p,g,v,m,b,k,A,x,P,w,T,M,B,R,G,V,z,H,W,Y,U,j,X,Z,J,q,K,$,Q,tt,et,at,nt=function(t,e,a,n,o,r,i,l){return t===a&&e===n?[]:[y,o,r,0,l,i,a,n]},ot=t.sAngle,rt=t.eAngle,it=(0,l.normalizeAngle)(ot),lt=(0,l.normalizeAngle)(rt),st=this.isDoughnut,ct=t.radiusYFactor,ut=t.cx,dt=t.cy,ht=t.r,ft=ht*ct,pt=ht+(l.hasSVG?-1:2),gt=ft+(l.hasSVG?-1:2),vt=t.innerR||0,mt=vt*ct,bt=this.depth,Ct=bt+dt,Dt=ut+ht,_t=ut-ht,yt=ut+vt,St=ut-vt,kt=dt-ft,At=[C,St,kt,D,St,Ct+ft,S],xt=t.elements,Pt="path",wt=(it+lt)/2,Nt=it>lt;s=ut+ht*(n=F(it)),u=ut+pt*n,d=dt+gt*(o=N(it)),A=(c=dt+ft*o)+bt,x=ut+ht*(r=F(lt)),h=ut+pt*r,f=dt+gt*(i=N(lt)),w=(P=dt+ft*i)+bt,st?(p=ut+vt*n,b=(g=dt+mt*o)+bt,v=ut+vt*r,k=(m=dt+mt*i)+bt,t.startSlice=[C,s,c,D,s,A,p,b,p,g,S],t.endSlice=[C,x,P,D,x,w,v,k,v,m,S]):(t.startSlice=[C,s,c,D,s,A,ut,Ct,ut,dt,S],t.endSlice=[C,x,P,D,x,w,ut,Ct,ut,dt,S]),l.hasSVG?(a=function(t,e){return(t>e?L:0)+e-t}(it,lt),t.clipTopPath=st?[[C,s,c,y,ht,ft,0,a>E?1:0,1,x,P,D,v,m,y,vt,mt,0,a>E?1:0,0,p,g,S]]:[[C,s,c,y,ht,ft,0,a>E?1:0,1,x,P,D,ut,dt,S]],t.clipOuterFrontPath1=[At],t.clipTopBorderPath=[[C,u,d,y,pt,gt,0,a>E?1:0,1,h,f,D,x,P,x,P+1,y,ht,ft,0,a>E?1:0,0,s,c+1,D,s,c,S]],ot!==rt?it>lt?it<E?(t.clipOuterFrontPath=[[C,Dt,dt,y,ht,ft,0,0,1,x,P,_,bt,y,ht,ft,0,0,0,Dt,dt+bt,S]],t.clipOuterFrontPath1=[[C,_t,dt,y,ht,ft,0,0,0,s,c,_,bt,y,ht,ft,0,0,1,_t,dt+bt,S]],t.clipOuterBackPath=[[C,Dt,dt,y,ht,ft,0,1,0,_t,dt,_,bt,y,ht,ft,0,1,1,Dt,dt+bt,S]],st&&(t.clipInnerBackPath=[[C,yt,dt,y,vt,mt,0,1,0,St,dt,_,bt,y,vt,mt,0,1,1,yt,dt+bt,S]],t.clipInnerFrontPath=[[C,yt,dt,y,vt,mt,0,0,1,v,m,_,bt,y,vt,mt,0,0,0,yt,dt+bt,S,C,St,dt,y,vt,mt,0,0,0,p,g,_,bt,y,vt,mt,0,0,1,St,dt+bt,S]])):lt>E?(t.clipOuterFrontPath=[[C,Dt,dt,y,ht,ft,0,1,1,_t,dt,_,bt,y,ht,ft,0,1,0,Dt,dt+bt,S]],t.clipOuterBackPath=[[C,_t,dt,y,ht,ft,0,0,1,x,P,_,bt,y,ht,ft,0,0,0,_t,dt+bt,S,C,Dt,dt,y,ht,ft,0,0,0,s,c,_,bt,y,ht,ft,0,0,1,Dt,dt+bt,S]],st&&(t.clipInnerFrontPath=[[C,yt,dt,y,vt,mt,0,1,1,St,dt,_,bt,y,vt,mt,0,1,0,yt,dt+bt,S]],t.clipInnerBackPath=[[C,St,dt,y,vt,mt,0,0,1,v,m,_,bt,y,vt,mt,0,0,0,St,dt+bt,S,C,yt,dt,y,vt,mt,0,0,0,p,g,_,bt,y,vt,mt,0,0,1,yt,dt+bt,S]])):(t.clipOuterFrontPath=[[C,Dt,dt,y,ht,ft,0,0,1,x,P,_,bt,y,ht,ft,0,0,0,Dt,dt+bt,S]],t.clipOuterBackPath=[[C,s,c,y,ht,ft,0,0,1,Dt,dt,_,bt,y,ht,ft,0,0,0,s,A,S]],st&&(t.clipInnerFrontPath=[[C,yt,dt,y,vt,mt,0,0,1,v,m,_,bt,y,vt,mt,0,0,0,yt,dt+bt,S]],t.clipInnerBackPath=[[C,p,g,y,vt,mt,0,0,1,yt,dt,_,bt,y,vt,mt,0,0,0,p,b,S]])):it<E?lt>E?(t.clipOuterFrontPath=[[C,s,c,y,ht,ft,0,0,1,_t,dt,_,bt,y,ht,ft,0,0,0,s,A,S]],t.clipOuterBackPath=[[C,_t,dt,y,ht,ft,0,0,1,x,P,_,bt,y,ht,ft,0,0,0,_t,dt+bt,S]],st&&(t.clipInnerFrontPath=[[C,p,g,y,vt,mt,0,0,1,St,dt,_,bt,y,vt,mt,0,0,0,p,b,S]],t.clipInnerBackPath=[[C,St,dt,y,vt,mt,0,0,1,v,m,_,bt,y,vt,mt,0,0,0,St,dt+bt,S]])):(t.clipOuterFrontPath=[[C,s,c,y,ht,ft,0,0,1,x,P,_,bt,y,ht,ft,0,0,0,s,A,S]],t.clipOuterBackPath=[At],st&&(t.clipInnerFrontPath=[[C,p,g,y,vt,mt,0,0,1,v,m,_,bt,y,vt,mt,0,0,0,p,b,S]],t.clipInnerBackPath=[At])):(t.clipOuterFrontPath=[At],t.clipOuterBackPath=[[C,s,c,y,ht,ft,0,0,1,x,P,_,bt,y,ht,ft,0,0,0,s,A,S]],st&&(t.clipInnerFrontPath=[At],t.clipInnerBackPath=[[C,p,g,y,vt,mt,0,0,1,v,m,_,bt,y,vt,mt,0,0,0,p,b,S]])):t.clipOuterFrontPath=t.clipOuterBackPath=t.clipInnerBackPath=t.clipInnerFrontPath=[At],Pt="litepath",t.clipBottomBorderPath=t.clipTopPath,t.startSlice=[t.startSlice],t.endSlice=[t.endSlice]):(z=this.moveCmdArr,H=this.lineCmdArr,W=this.closeCmdArr,Y=[ut,dt],U=[_t,dt],j=[ut,kt],X=[Dt,dt],Z=[ut,dt+ft],J=[_t,Ct],q=[Dt,Ct],K=[St,dt],$=[yt,dt],Q=[St,Ct],tt=[yt,Ct],t.clipOuterFrontPath1=[],ot!==rt?(it>lt?it<E?(T=nt(s,c,_t,dt,ht,ft,1,0),B=nt(_t,dt,Dt,dt,ht,ft,1,0),G=nt(Dt,dt,x,P,ht,ft,1,0),t.clipOuterBackPath=z.concat(U,B,H,q,nt(Dt,Ct,_t,Ct,ht,ft,0,0),W),t.clipOuterFrontPath1=z.concat([s,c],T,H,J,nt(_t,Ct,s,A,ht,ft,0,0),W),t.clipOuterFrontPath=z.concat(X,G,H,[x,w],nt(x,w,Dt,Ct,ht,ft,0,0),W),t.clipTopBorderPath=z.concat([s,c],T,B,G),st?(M=nt(v,m,yt,dt,vt,mt,0,0),R=nt(yt,dt,St,dt,vt,mt,0,0),V=nt(St,dt,p,g,vt,mt,0,0),t.clipInnerBackPath=z.concat($,R,H,Q,nt(St,Ct,yt,Ct,vt,mt,1,0),W),t.clipInnerFrontPath=z.concat(K,V,H,[p,b],nt(p,b,St,Ct,vt,mt,1,0),W,z,[v,m],M,H,tt,nt(yt,Ct,v,k,vt,mt,1,0),W),t.clipTopPath=t.clipTopBorderPath.concat(H,[v,m],M,R,V,W),t.clipTopBorderPath=t.clipTopBorderPath.concat(z,[v,m],M,R,V)):t.clipTopPath=t.clipTopBorderPath.concat(H,Y,W)):lt>E?(T=nt(s,c,Dt,dt,ht,ft,1,0),B=nt(Dt,dt,_t,dt,ht,ft,1,0),G=nt(_t,dt,x,P,ht,ft,1,0),t.clipOuterFrontPath=z.concat(X,B,H,J,nt(_t,Ct,Dt,Ct,ht,ft,0,0),W),t.clipOuterBackPath=z.concat([s,c],T,H,q,nt(Dt,Ct,s,A,ht,ft,0,0),W,z,U,G,H,[x,w],nt(x,w,_t,Ct,ht,ft,0,0),W),t.clipTopBorderPath=z.concat([s,c],T,B,G),st?(M=nt(v,m,St,dt,vt,mt,0,0),R=nt(St,dt,yt,dt,vt,mt,0,0),V=nt(yt,dt,p,g,vt,mt,0,0),t.clipInnerFrontPath=z.concat(K,R,H,tt,nt(yt,Ct,St,Ct,vt,mt,1,0),W),t.clipInnerBackPath=z.concat($,V,H,[p,b],nt(p,b,yt,Ct,vt,mt,1,0),W,z,[v,m],M,H,Q,nt(St,Ct,v,k,vt,mt,1,0),W),t.clipTopPath=t.clipTopBorderPath.concat(H,[v,m],M,R,V,W),t.clipTopBorderPath=t.clipTopBorderPath.concat(z,[v,m],M,R,V)):t.clipTopPath=t.clipTopBorderPath.concat(H,Y,W)):(T=nt(s,c,Dt,dt,ht,ft,1,0),B=nt(Dt,dt,x,P,ht,ft,1,0),t.clipOuterFrontPath=z.concat(X,B,H,[x,w],nt(x,w,Dt,Ct,ht,ft,0,0),W),t.clipOuterBackPath=z.concat([s,c],T,H,q,nt(Dt,Ct,s,A,ht,ft,0,0),W),t.clipTopBorderPath=z.concat([s,c],T,B),st?(M=nt(v,m,yt,dt,vt,mt,0,0),R=nt(yt,dt,p,g,vt,mt,0,0),t.clipInnerFrontPath=z.concat([v,m],M,H,tt,nt(yt,Ct,v,k,vt,mt,1,0),W),t.clipInnerBackPath=z.concat($,R,H,[p,b],nt(p,b,yt,Ct,vt,mt,1,0),W),t.clipTopPath=t.clipTopBorderPath.concat(H,[v,m],M,R,W),t.clipTopBorderPath=t.clipTopBorderPath.concat(z,[v,m],M,R)):t.clipTopPath=t.clipTopBorderPath.concat(H,Y,W)):it<E?lt>E?(T=nt(s,c,_t,dt,ht,ft,1,0),B=nt(_t,dt,x,P,ht,ft,1,0),t.clipOuterBackPath=z.concat(U,B,H,[x,w],nt(x,w,_t,Ct,ht,ft,0,0),W),t.clipOuterFrontPath=z.concat([s,c],T,H,J,nt(_t,Ct,s,A,ht,ft,0,0),W),t.clipTopBorderPath=z.concat([s,c],T,B),st?(M=nt(v,m,St,dt,vt,mt,0,0),R=nt(St,dt,p,g,vt,mt,0,0),t.clipInnerBackPath=z.concat([v,m],M,H,Q,nt(St,Ct,v,k,vt,mt,1,0),W),t.clipInnerFrontPath=z.concat(K,R,H,[p,b],nt(p,b,St,Ct,vt,mt,1,0),W),t.clipTopPath=t.clipTopBorderPath.concat(H,[v,m],M,R,W),t.clipTopBorderPath=t.clipTopBorderPath.concat(z,[v,m],M,R)):t.clipTopPath=t.clipTopBorderPath.concat(H,Y,W)):(T=nt(s,c,x,P,ht,ft,1,0),t.clipOuterBackPath=z.concat([s,c]),t.clipTopBorderPath=t.clipOuterBackPath.concat(T),t.clipOuterFrontPath=t.clipTopBorderPath.concat(H,[x,w],nt(x,w,s,A,ht,ft,0,0),W),st?(M=nt(v,m,p,g,vt,mt,0,0),t.clipInnerBackPath=z.concat([v,m]),t.clipTopPath=t.clipTopBorderPath.concat(H,[v,m],M,W),t.clipTopBorderPath=t.clipTopBorderPath.concat(z,[v,m],M),t.clipInnerFrontPath=t.clipInnerBackPath.concat(M,H,[p,b],nt(p,b,v,k,vt,mt,1,0),W)):t.clipTopPath=t.clipTopBorderPath.concat(H,Y,W)):(T=nt(s,c,x,P,ht,ft,1,0),t.clipOuterFrontPath=z.concat([s,c]),t.clipTopBorderPath=t.clipOuterFrontPath.concat(T),t.clipOuterBackPath=t.clipTopBorderPath.concat(H,[x,w],nt(x,w,s,A,ht,ft,0,0),W),st?(M=nt(v,m,p,g,vt,mt,0,0),t.clipInnerFrontPath=z.concat([v,m]),t.clipTopPath=t.clipTopBorderPath.concat(H,[v,m],M,W),t.clipTopBorderPath=t.clipTopBorderPath.concat(t.clipInnerFrontPath,M),t.clipInnerBackPath=t.clipInnerFrontPath.concat(M,H,[p,b],nt(p,b,v,k,vt,mt,1,0),W)):t.clipTopPath=t.clipTopBorderPath.concat(H,Y,W)),T=z.concat(U,H,X),M=z.concat(j,H,Z),t.clipTopPath=t.clipTopPath.concat(T,M),t.clipOuterFrontPath=t.clipOuterFrontPath.concat(T),t.clipOuterFrontPath1=t.clipOuterFrontPath1.concat(T),t.clipOuterBackPath=t.clipOuterBackPath.concat(T),st&&(M=z.concat(K,H,$),t.clipInnerFrontPath=t.clipInnerFrontPath.concat(M),t.clipInnerBackPath=t.clipInnerBackPath.concat(M))):(t.clipTopPath=t.clipOuterFrontPath=t.clipOuterBackPath=[],st&&(t.clipInnerFrontPath=t.clipInnerBackPath=[])),t.clipBottomBorderPath=t.clipTopBorderPath),e||(xt.startSlice._conf.index=it,xt.endSlice._conf.index=lt,xt.backOuter._conf.index=at=Nt&&(it<=O||lt>O)||it<=O&&lt>O?O:it>E?it:lt,xt.frontOuter._conf.index=et=lt<=I?lt:it>lt||it<=I?I:it,xt.frontOuter1._conf.index=it,xt.frontOuter1._conf.cIndex=E,it>lt?(xt.backOuter._conf.cIndex=it<O?O:L,xt.startSlice._conf.cIndex=it<E?(it+E)/2:(it+L)/2,xt.endSlice._conf.cIndex=xt.frontOuter._conf.cIndex=0):xt.backOuter._conf.cIndex=xt.startSlice._conf.cIndex=xt.endSlice._conf.cIndex=xt.frontOuter._conf.cIndex=wt,a>E?xt.frontOuter1.show().attr(Pt,t.clipOuterFrontPath1):xt.frontOuter1.hide(),t.thisElement._attr(Pt,t.clipTopPath),xt.bottom.attr(Pt,t.clipTopPath),xt.bottomBorder.attr(Pt,t.clipBottomBorderPath),xt.topBorder&&xt.topBorder.attr(Pt,t.clipTopBorderPath),xt.frontOuter.attr(Pt,t.clipOuterFrontPath),xt.backOuter.attr(Pt,t.clipOuterBackPath),st&&(xt.backInner.attr(Pt,t.clipInnerBackPath),xt.frontInner.attr(Pt,t.clipInnerFrontPath),xt.backInner._conf.index=at,xt.frontInner._conf.index=et,it>lt?(xt.backInner._conf.cIndex=L,xt.frontInner._conf.cIndex=0):xt.backInner._conf.cIndex=xt.frontInner._conf.cIndex=wt),this.hasOnePoint?(xt.startSlice.hide(),xt.endSlice.hide()):(xt.startSlice.attr(Pt,t.startSlice).show(),xt.endSlice.attr(Pt,t.endSlice).show()))},a._setSliceCosmetics=function(t){var e,a,n=t.thisElement,o=t.showBorderEffect,r=t.elements,i=(0,l.convertColor)(t.borderColor,(0,l.pluckNumber)(t.borderAlpha,t.alpha)),s=t.borderWidth;t.color&&(t.color=t.color.color?t.color.color:t.color,e=this._parseSliceColor(t.color,t.alpha,t),l.hasSVG?(a={fill:(0,l.toRaphaelColor)(e.top),"stroke-width":0},o?r.topBorder.show().attr({fill:(0,l.toRaphaelColor)(e.topBorder),"stroke-width":0}):(r.topBorder.hide(),a.stroke=i,a["stroke-width"]=s),n._attr(a)):(n._attr({fill:(0,l.toRaphaelColor)(e.top),"stroke-width":0}),r.topBorder.attr({stroke:i,"stroke-width":s})),r.bottom.attr({fill:(0,l.toRaphaelColor)(e.bottom)}),r.bottomBorder.attr({stroke:i,"stroke-width":s}),r.frontOuter.attr({fill:(0,l.toRaphaelColor)(e.frontOuter)}),r.frontOuter1.attr({fill:(0,l.toRaphaelColor)(e.frontOuter)}),r.backOuter.attr({fill:(0,l.toRaphaelColor)(e.backOuter)}),r.startSlice.attr({fill:(0,l.toRaphaelColor)(e.startSlice),stroke:i,"stroke-width":s}),r.endSlice.attr({fill:(0,l.toRaphaelColor)(e.endSlice),stroke:i,"stroke-width":s}),this.isDoughnut&&(r.frontInner.attr({fill:(0,l.toRaphaelColor)(e.frontInner)}),r.backInner.attr({fill:(0,l.toRaphaelColor)(e.backInner)})))},e}(s.ComponentInterface),dt=ct;e["default"]=dt},595:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=e._getInnerSize=void 0;var o=n(a(238)),r=n(a(588)),i=a(232),l=a(224),s=n(a(596)),c=function(){var t,e,a,n,o,r,i,s,c,u=this.getFromEnv("chart"),d=this.config,h=u.getFromEnv("dataSource").chart,f=d.doughnutradius,p=(0,l.pluckNumber)(h.use3dlighting,1)?(0,l.pluckNumber)(h.radius3d,h["3dradius"],50):100,g=d.pieMinRadius;if(p>100&&(p=100),p<0&&(p=0),t=/%/.test(f)?g*(f=Number(f.split("%")[0])/100):f<=0||f>=g?g/2:(0,l.pluckNumber)(f),d.innerRadius=t,p>0&&l.hasSVG&&(a=(100-(e=parseInt(t/g*100,10)))/2,r=e+","+(n=parseInt(a*p/100,10))+","+2*(a-n)+","+n,this&&(s=this.components.data)))for(i=0,c=s.length;i<c;i+=1)(o=s[i].config).color&&(o.color.ratio=r,o.hoverEffects&&o.hoverEffects.color&&(o.hoverEffects.color.ratio=r));return 2*t};e._getInnerSize=c,(0,i.addDep)({name:"doughnut2dAnimation",type:"animationRule",extension:s["default"]});var u=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"doughnut2D"},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.config,n=this.getFromEnv("chartConfig");a.doughnutradius=(0,l.pluck)(n.doughnutradius,a.doughnutradius,"50%")},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.doughnutradius="50%"},a._parsePiePlotOptions=function(){var e=t.prototype._parsePiePlotOptions.call(this);return e.innerSize=this._getInnerSize(),e},a._getInnerSize=function(){return c.call(this)},a.allocatePosition=function(){this.config.innerSize=this._getInnerSize(),t.prototype.allocatePosition.call(this)},e}(r["default"]);e["default"]=u},596:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o={"initial.dataset.doughnut2D":n(a(589))["default"]["initial.dataset.pie2D"]};e["default"]=o},597:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var n={"initial.dataset.pie3d":function(){return{"group.appearing":function(t){var e=t.component.getFromEnv("chartConfig");return"plots"===t.attr.name?[{initialAttr:{opacity:"0"},finalAttr:{opacity:"1"},slot:e.alphaanimation?"plot":"initial"}]:[{initialAttr:{opacity:"1"},finalAttr:{opacity:"1"},slot:"final"}]},"slice.appearing":function(t){var e=t.component,a=e.getFromEnv("chart").config,n=e.config,o=t.attr;return a.alphaanimation?[{initialAttr:{opacity:"1"},slot:"plot"}]:n.animateClockWise?[{initialAttr:{sAngle:0,eAngle:0,transform:""},finalAttr:{sAngle:o.sAngle,eAngle:o.eAngle,transform:""},slot:"plot",startEnd:{start:0,end:.75}},{finalAttr:{transform:o.transform},slot:"plot",startEnd:{start:.75,end:1}}]:[{initialAttr:{sAngle:2*Math.PI,eAngle:2*Math.PI,transform:""},finalAttr:{sAngle:o.sAngle,eAngle:o.eAngle,transform:""},slot:"plot",startEnd:{start:0,end:.75}},{finalAttr:{transform:o.transform},slot:"plot",startEnd:{start:.75,end:1}}]},"label.updating":[{initialAttr:{opacity:"1"},finalAttr:{opacity:"1"},slot:"final"}],"label.appearing":[{initialAttr:{opacity:"0"},finalAttr:{opacity:"1"},slot:"final"}],"connector.updating":function(t){return[{initialAttr:{path:t.el.attr("path")||t.attr.path,opacity:t.el.attr("opacity")},finalAttr:{path:t.attr.path},slot:"final"}]},"connector.appearing":function(t){return[{initialAttr:"string"==typeof t.el?{opacity:"0"}:{path:t.attr.path,opacity:"0"},slot:"final"}]},"connector-sliced.updating":function(t){return[{initialAttr:{path:t.el.attr("path")},finalAttr:{path:t.attr.path},slot:"plot"}]},"label-sliced.updating":function(t){return[{initialAttr:{x:t.el.attr("x"),y:t.el.attr("y")},slot:"plot"}]},"*":null}}};e["default"]=n},599:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(600))["default"];e["default"]=o},600:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(587)),i=n(a(595)),l=a(224),s=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"Doughnut2D"};var a=e.prototype;return a.getName=function(){return"Doughnut2D"},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.config,n=this.getFromEnv("chart-attrib");a.doughnutradius=(0,l.pluck)(n.doughnutradius,"50%")},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Doughnut Chart",e.defaultDatasetType="Doughnut2D",e.singletonPlaceValue=!1},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=s},601:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(602))["default"];e["default"]=o},602:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(593)),i=n(a(603)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"Doughnut3D"};var a=e.prototype;return a.getName=function(){return"Doughnut3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="3D Doughnut Chart",e.defaultDatasetType="Doughnut3D",e.singletonPlaceValue=!1},a.getDSdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},603:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(594)),i=n(a(604)),l=a(232),s=a(224);(0,l.addDep)({name:"doughnut3dAnimation",type:"animationRule",extension:i["default"]});var c=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"doughnut3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.doughnutradius="50%"},a._configurePie3DManager=function(){var t=this.config,e=this.components,a=this.getFromEnv("pie3DManager"),n=e.data;a&&a.configure(t.pieSliceDepth,1===n.length,t.use3DLighting,!0)},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.config,n=this.getFromEnv("chartConfig");a.doughnutradius=(0,s.pluck)(n.doughnutradius,a.doughnutradius,"50%")},e}(r["default"]);e["default"]=c},604:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o={"initial.dataset.doughnut3D":n(a(597))["default"]["initial.dataset.pie3d"]};e["default"]=o},605:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(606))["default"];e["default"]=o},606:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e._setCategories=h,e["default"]=void 0;var o=n(a(238)),r=n(a(607)),i=a(611),l=a(613),s=n(a(614)),c=a(224),u=n(a(615)),d=c.preDefStr.NINETYSTRING;function h(){var t,e,a=this.getFromEnv("dataSource"),n=a.dataset,o=this.getFromEnv("number-formatter"),r=this.getChildren("xAxis"),i=a.data||n&&n[0].data||[],l=[],s={};for(e=i.length-1;e>=0;e--)"true"===(t=i[e]).vline||"1"===t.vline||1===t.vline||!0===t.vline?(s[e]=t,i.splice(e,1)):null===o.getCleanValue(t.value,!0)&&i.splice(e,1);for(e in i.sort((function(t,e){return o.getCleanValue(e.value,!0)-o.getCleanValue(t.value,!0)})),l=i.slice(),s)l.splice(e,0,s[e]);r[0].setTickValues(l)}var f=function(t){function e(){var e;return(e=t.call(this)||this).isPercentage=!0,e.registerFactory("axis",s["default"],["canvas"]),e.registerFactory("dataset",u["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"Pareto2D"};var a=e.prototype;return a.getName=function(){return"Pareto2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.singleseries=!0,e.hasLegend=!1,e.defaultDatasetType="column",e.plotfillalpha=d,e.enablemousetracking=!0},a._setCategories=function(){h.call(this)},a._checkInvalidSpecificData=function(){var t=this.getFromEnv("dataSource").data;if(!t||!t.length)return!0},a.getDSdef=function(t){return"column"===t?i.ParetoColumnDataset:l.ParetoLineDataset},a.getDSGroupdef=function(){},e}(r["default"]);e["default"]=f},611:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e.ParetoColumnDataset=void 0;var o=n(a(238)),r=a(224),i=function(t,e){if(!e&&t&&t.__esModule)return t;if(null===t||"object"!=typeof t&&"function"!=typeof t)return{"default":t};var a=c(e);if(a&&a.has(t))return a.get(t);var n={},o=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var r in t)if("default"!==r&&Object.prototype.hasOwnProperty.call(t,r)){var i=o?Object.getOwnPropertyDescriptor(t,r):null;i&&(i.get||i.set)?Object.defineProperty(n,r,i):n[r]=t[r]}n["default"]=t,a&&a.set(t,n);return n}(a(538)),l=a(232),s=n(a(612));function c(t){if("function"!=typeof WeakMap)return null;var e=new WeakMap,a=new WeakMap;return(c=function(t){return t?a:e})(t)}var u=Math,d=u.min,h=u.max,f=u.abs;(0,l.addDep)({name:"paretoAnimation",type:"animationRule",extension:s["default"]});var p=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"paretoColumn"},a.configureAttributes=function(t){if(!t)return!1;this.trimData(t),this.config.JSONData=t;var e,a,n,o,l,s,c,u,p,g,v,m,b,C,D,_,y,S,k,A,x,P,w,N,T,F,M,B,E,L,I,O,R,G,V,z,H,W,Y,U,j,X,Z,J,q,K,$,Q,tt=this.getFromEnv("chart"),et=this.config,at=this.getFromEnv("xAxis"),nt=et.JSONData,ot=nt.data,rt=ot&&ot.length,it=this.getFromEnv("chart-attrib"),lt=this.getFromEnv("color-manager"),st=this.index||this.positionIndex,ct=lt.getPlotColor(st),ut=(0,r.pluckNumber)(nt.dashed,it.plotborderdashed),dt=tt.config,ht=dt.useplotgradientcolor,ft=(0,r.pluckNumber)(it.showtooltip,1),pt=(0,r.parseUnsafeString)(it.yaxisname),gt=(0,r.parseUnsafeString)(it.xaxisname),vt=this.components.data,mt=this.getFromEnv("number-formatter"),bt=dt.is3D,Ct=-Infinity,Dt=+Infinity,_t=0,yt=[],St=0,kt=et.tootipSepChar=(0,r.pluck)(it.tooltipsepchar,", ");for(et.minAbsNonZeroValue=Infinity,et.minAbsNonZeroData={},et.defaultPadding={left:.5,right:.5},et.enableAnimation=U=(0,r.pluckNumber)(it.animation,it.defaultanimation,1),et.animation=!!U&&{duration:1e3*(0,r.pluckNumber)(it.animationduration,1)},et.showTooltip=(0,r.pluckNumber)(it.showtooltip,1),et.showTextOutline=(0,r.pluckNumber)(it.textoutline,0),et.valuePadding=(0,r.pluckNumber)(it.valuepadding,2),et.rotateValues=(0,r.pluckNumber)(it.rotatevalues)?270:0,et.usePattern=(0,r.pluckNumber)(dt.usePattern,0),et.patternType=i.PATTERN_TYPES.includes(nt.patterntype)?nt.patterntype:dt.patternType,et.patternDensity=(0,r.pluckNumber)(nt.patterndensity,dt.patternDensity),et.patternAlpha=(0,r.pluckNumber)(nt.patternalpha,dt.patternAlpha),et.patternBgColor=(0,r.pluck)(nt.patternbgcolor,et.patternBgColor),et.showHoverEffect=m=(0,r.pluckNumber)(it.plothovereffect,it.showhovereffect,void 0),et.usePattern&&(et.showHoverEffect=m=0),et.showShadow=v||bt?(0,r.pluckNumber)(it.showshadow,1):(0,r.pluckNumber)(it.showshadow,lt.getColor("showShadow")),et.useDataPlotColorForLabels=Q=(0,r.pluckNumber)(it.usedataplotcolorforlabels,0),et.use3dlineshift=(0,r.pluckNumber)(it.use3dlineshift,tt.use3dlineshift),e=et.showplotborder=(0,r.pluckNumber)(it.showplotborder,bt?0:1),et.plotDashLen=u=(0,r.pluckNumber)(it.plotborderdashlen,5),et.plotDashGap=p=(0,r.pluckNumber)(it.plotborderdashgap,4),et.plotfillangle=b=(0,r.pluckNumber)(360-it.plotfillangle,90),et.plotfillalpha=C=(0,r.pluck)(it.plotfillalpha,"100"),et.plotColor=ct,et.isRoundEdges=v=(0,r.pluckNumber)(it.useroundedges,0),et.plotRadius=(0,r.pluckNumber)(it.useRoundEdges,et.isRoundEdges?1:0),et.plotfillratio=D=(0,r.pluck)(it.plotfillratio),et.plotgradientcolor=_=(0,r.getDefinedColor)(it.plotgradientcolor,lt.getColor("plotGradientColor")),!ht&&(_=""),et.plotborderalpha=y=e&&!bt?(0,r.pluck)(it.plotborderalpha,C,"100"):0,et.plotbordercolor=S=(0,r.pluck)(it.plotbordercolor,bt?"#ffffff":lt.getColor("plotBorderColor")),et.plotborderthickness=g=(0,r.pluckNumber)(it.plotborderthickness,1),et.plotBorderDashStyle=A=ut?(0,r.getDashStyle)(u,p):"none",et.showValues=(0,r.pluckNumber)(it.showvalues,1),et.definedGroupPadding=h((0,r.pluckNumber)(it.plotspacepercent),0),et.plotSpacePercent=h((0,r.pluckNumber)(it.plotspacepercent,20)%100,0),et.maxcolwidth=(0,r.pluckNumber)(it.maxcolwidth,50),et.plotpaddingpercent=(0,r.pluckNumber)(it.plotpaddingpercent),et.placevaluesinside=(0,r.pluckNumber)(it.placevaluesinside,0),et.use3dlighting=(0,r.pluckNumber)(it.use3dlighting,1),et.parentYAxis=0,this.setState("visible",1===(0,r.pluckNumber)(nt.visible,1)),this.setState("dirty",!0),vt||(vt=this.components.data=[]),J=0;J<rt;J++)_t+=K=f(mt.getCleanValue(ot[J].value)),yt[J]=(0,r.extend2)({},ot[J]),yt[J].value=K;for(yt.sort((function(t,e){return e.value-t.value})),et.imageCount=0,J=0;J<rt;J++)x=yt[J],(w=vt[J])||(w=vt[J]={graphics:{}}),w.config||(N=vt[J].config={}),null!==(P=f(mt.getCleanValue(x.value)))&&(N=w&&w.config,$=at.getLabel(J),N.label=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)($.label))),N.showValue=(0,r.pluckNumber)(x.showvalue,et.showValues),N.setValue=P,N.setLink=(0,r.pluck)(x.link),N.setDisplayValue=F=(0,r.parseUnsafeString)(x.displayvalue),St+=N.setValue,q=mt.dataLabels(P),N.id=x.id?(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(x.id))):N.label,N.valuePadding=(0,r.pluckNumber)(x.valuepadding,nt.valuepadding,dt.valuepadding),N.patternType=i.PATTERN_TYPES.includes(x.patterntype)?x.patterntype:et.patternType,N.patternAngle=(0,r.pluckNumber)(x.patternangle,nt.patternangle,it.patternangle,N.patternType===i.PATTERN_TYPES[0]?40:0),N.patternDensity=(0,r.pluckNumber)(x.patterndensity,et.patternDensity),N.patternSize=(0,r.pluckNumber)(x.patternsize,nt.patternsize,N.patternType===i.PATTERN_TYPES[0]?2:4),N.patternAlpha=(0,r.pluckNumber)(x.patternalpha,et.patternAlpha),N.patternBgColor=(0,r.pluck)(x.patternbgcolor,et.patternBgColor),N.dataLabelStyle=this._configureDataLabelStyle(x),N.shadow={opacity:et.showShadow?C/100:0},j=(0,r.pluckNumber)(x.dashed),X=(0,r.pluckNumber)(x.dashlen,u),Z=p=(0,r.pluckNumber)(x.dashgap,p),N.plotBorderDashStyle=k=1===j?(0,r.getDashStyle)(X,Z):0===j?"none":A,ct=lt.getPlotColor(J),ct=(0,r.pluck)(x.color,ct),D=(0,r.pluck)(x.ratio,et.plotfillratio),C=(0,r.pluck)(x.alpha,et.plotfillalpha),y=(0,r.pluck)(x.alpha,et.plotborderalpha),P<0&&!v&&(s=b,b=360-b),N.colorArr=T=(0,r.getColumnColor)(ct+","+_,C,D,b,v,S,y.toString(),0,!!bt),0!==m&&(M=(0,r.pluck)(x.hovercolor,it.plotfillhovercolor,it.columnhovercolor,ct),B=(0,r.pluck)(x.hoveralpha,it.plotfillhoveralpha,it.columnhoveralpha,C),!(E=(0,r.pluck)(x.hovergradientcolor,it.plothovergradientcolor,_))&&(E=""),L=(0,r.pluck)(x.hoverratio,it.plothoverratio,D),I=(0,r.pluckNumber)(360-x.hoverangle,360-nt.hoverangle,360-it.plothoverangle,b),O=(0,r.pluck)(x.borderhovercolor,it.plotborderhovercolor,S),R=(0,r.pluck)(x.borderhoveralpha,nt.borderhoveralpha,it.plotborderhoveralpha,it.plotfillhoveralpha,y,C),G=(0,r.pluckNumber)(x.borderhoverthickness,nt.borderhoverthickness,it.plotborderhoverthickness,g),V=(0,r.pluckNumber)(x.borderhoverdashed,it.plotborderhoverdashed),z=(0,r.pluckNumber)(x.borderhoverdashgap,it.plotborderhoverdashgap,u),H=(0,r.pluckNumber)(x.borderhoverdashlen,it.plotborderhoverdashlen,p),W=V?(0,r.getDashStyle)(H,z):k,1===m&&M===ct&&(M=(0,r.getLightColor)(M,70)),Y=(0,r.getColumnColor)(M+","+E,B,L,I,v,O,R.toString(),0,!!bt),N.setRolloutAttr={fill:bt?[(0,r.toRaphaelColor)(T[0]),!et.use3dlighting]:(0,r.toRaphaelColor)(T[0]),stroke:e&&(0,r.toRaphaelColor)(T[1]),"stroke-width":g,"stroke-dasharray":k},N.setRolloverAttr={fill:bt?[(0,r.toRaphaelColor)(Y[0]),!et.use3dlighting]:(0,r.toRaphaelColor)(Y[0]),stroke:e&&(0,r.toRaphaelColor)(Y[1]),"stroke-width":G,"stroke-dasharray":W}),Q&&at.updateTicksValues(J,{labelfontcolor:(0,r.convertColor)(ct)}),N.originalPlotColor=(0,r.hashify)(ct),N.displayValue=(0,r.pluck)(F,q),o=N.setTooltext=N.origToolText=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(x.tooltext,it.plottooltext),!1)),N.toolTipValue=mt.dataLabels(P,et.parentYAxis),N._x=J,N._y=P,a=N.toolTipValue,Ct=h(Ct,P),Dt=d(Dt,P),0!==P&&et.minAbsNonZeroValue>Math.abs(P)&&(et.minAbsNonZeroValue=Math.abs(P),et.minAbsNonZeroData=N),ft?(et.showTooltip?void 0!==o?(n={formattedValue:a,label:N.label,yaxisName:pt,xaxisName:gt,cumulativeValue:St,cumulativeDataValue:mt.dataLabels(St),cumulativePercentValue:void 0,sum:mt.dataLabels(_t),unformattedSum:_t},l=[1,2,3,5,6,7,20,21,22,23,24,25],c=(0,r.parseTooltext)(o,l,n,x,it)):c=N.label?N.label+kt:"":c=!1,N.toolText=c):c=!1,N.toolText=c,N.tooltext=o,N.setTooltext=c,s&&(b=s));et.maxValue=Ct,et.minValue=Dt},e}(i["default"]);e.ParetoColumnDataset=p},612:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o={"initial.dataset.paretoColumn":n(a(539))["default"]["initial.dataset.column"]};e["default"]=o},613:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e.ParetoLineDataset=void 0;var o=n(a(238)),r=n(a(555)),i=a(224),l=Math,s=l.min,c=l.max,u=l.abs,d=function(t){function e(){return t.apply(this,arguments)||this}return(0,o["default"])(e,t),e.prototype.configureAttributes=function(t){if(!t)return!1;this.trimData(t),this.config.JSONData=t;var e,a,n,o,r,l,d,h,f,p,g,v,m=this.getFromEnv("chart"),b=this.config,C=this.getFromEnv("xAxis"),D=b.JSONData,_=D.data,y=_&&_.length,S=this.getFromEnv("chart-attrib"),k=this.getFromEnv("color-manager"),A=(0,i.pluckNumber)(S.showtooltip,1),x=((0,i.parseUnsafeString)(S.yaxisname),(0,i.parseUnsafeString)(S.xaxisname),this.components.data),P=this.getFromEnv("number-formatter"),w=m.config.is3D,N=-Infinity,T=+Infinity,F=0,M=[],B=0,E=b.tootipSepChar=(0,i.pluck)(S.tooltipsepchar,", ");for(b.defaultPadding={left:.5,right:.5},b.enableAnimation=l=(0,i.pluckNumber)(S.animation,S.defaultanimation,1),b.animation=!!l&&{duration:1e3*(0,i.pluckNumber)(S.animationduration,1)},b.showTooltip=(0,i.pluckNumber)(S.showtooltip,1),b.valuePadding=(0,i.pluckNumber)(S.valuepadding,2),b.showTextOutline=(0,i.pluckNumber)(S.textoutline,0),b.rotateValues=(0,i.pluckNumber)(S.rotatevalues)?270:0,b.showHoverEffect=(0,i.pluckNumber)(S.plothovereffect,S.showhovereffect,void 0),b.showShadow=w?(0,i.pluckNumber)(S.showshadow,1):(0,i.pluckNumber)(S.showshadow,k.getColor("showShadow")),b.useDataPlotColorForLabels=(0,i.pluckNumber)(S.usedataplotcolorforlabels,0),b.use3dlineshift=(0,i.pluckNumber)(S.use3dlineshift,m.use3dlineshift),b.drawLine=1,b.linecolor=(0,i.getFirstColor)((0,i.pluck)(S.linecolor,k.getColor("plotBorderColor"))),b.linethickness=(0,i.pluckNumber)(S.linethickness,2),b.linealpha=(0,i.pluck)(S.linealpha,"100"),b.linedashed=(0,i.pluckNumber)(S.linedashed,0),b.linedashlen=(0,i.pluckNumber)(D.linedashlen,S.linedashlen,5),b.linedashgap=(0,i.pluckNumber)(D.linedashgap,S.linedashgap,4),d=(0,i.getDashStyle)(b.linedashlen,b.linedashgap),b.lineDashStyle=b.linedashed?d:"none",b.drawanchors=(0,i.pluckNumber)(S.drawanchors,S.showanchors),b.anchorbgcolor=(0,i.pluck)(S.anchorbgcolor,k.getColor("anchorBgColor")),b.anchorbordercolor=(0,i.pluck)(S.anchorbordercolor,b.linecolor),b.anchorradius=(0,i.pluckNumber)(S.anchorradius,3),b.anchoralpha=(0,i.pluck)(S.anchoralpha),b.anchorbgalpha=(0,i.pluck)(S.anchorbgalpha,100),b.anchorborderthickness=(0,i.pluck)(S.anchorborderthickness,1),b.anchorsides=(0,i.pluck)(S.anchorsides,0),b.anchorimageurl=(0,i.pluck)(S.anchorimageurl),b.anchorimagealpha=(0,i.pluckNumber)(S.anchorimagealpha,100),b.anchorimagescale=(0,i.pluckNumber)(S.anchorimagescale,100),b.anchorimagepadding=(0,i.pluckNumber)(S.anchorimagepadding,1),b.anchorstartangle=(0,i.pluckNumber)(S.anchorstartangle,90),b.parentYAxis=1,b.valuePosition=(0,i.pluck)(S.valueposition,"auto"),b.showvalues=b.showValues=(0,i.pluckNumber)(S.showlinevalues,S.showvalues,1),this.setState("visible",1===(0,i.pluckNumber)(D.visible,1)),this.setState("dirty",!0),b.shadow={opacity:b.showShadow?b.linealpha/100:0},b.showCumulativeLine=(0,i.pluckNumber)(S.showcumulativeline,1),b.maxRadius=-Infinity,x||(x=this.components.data=[]),h=0;h<y;h++)F+=p=u(P.getCleanValue(_[h].value)),M[h]=(0,i.extend2)({},_[h]),M[h].value=p;for(M.sort((function(t,e){return e.value-t.value})),b.imageCount=0,h=0;h<y;h++)a=M[h],(o=x[h])||(o=x[h]={graphics:{}}),o.config||(r=x[h].config={}),null!==(n=u(P.getCleanValue(a.value)))&&(r=o&&o.config,g=C.getLabel(h),r.label=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(g.label))),r.showValue=(0,i.pluckNumber)(a.showvalue,b.showValues),r.setValue=n,r.setLink=(0,i.pluck)(a.link),r.setDisplayValue=(0,i.parseUnsafeString)(a.displayvalue),B+=r.setValue,r.dataLabelStyle=this._configureDataLabelStyle(a),r.valuePadding=(0,i.pluckNumber)(a.valuepadding,D.valuepadding,m.config.valuepadding),n=r.setValue=B/F*100,f=P.percentValue(n),r.toolTipValue=f,r.displayValue=f,r.valuePosition=(0,i.pluck)(a.valueposition,b.valuePosition),r.anchorProps=this._parseAnchorProperties(h,M),r.hoverEffects=this._parseHoverEffectOptions(o),v=r.anchorProps,b.maxRadius=Math.max(b.maxRadius,v.radius+v.borderThickness/2),r._x=h,r._y=n,r.toolTipValue,N=c(N,n),T=s(T,n),A?(e=!!b.showTooltip&&(r.label?r.label+E+r.toolTipValue:""),r.toolText=e):e=!1,r.toolText=e,r.tooltext=void 0,r.setTooltext=e);b.maxValue=N,b.minValue=T},e}(r["default"]);e.ParetoLineDataset=d},614:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=function(t){var e,a,n,l=t.getFromEnv("chart-attrib"),s=(0,i.pluckNumber)(l.showcumulativeline,1),c=t.getChildren("canvas")[0],u=c.getChildren("axisRefVisualCartesian")[0],d={zoomable:!0,pannable:!0},h=t._feedAxesRawData(),f=function(){return u.asyncDraw()};(0,i.componentFactory)(t,r["default"],"xAxis",1,h.xAxisConf),e=t.getChildren(),n=e.xAxis[0],u.setLinkedItem(n.getId(),n),c.attachAxis(n,!1,t.zoomX?d:{}),n.setLinkedItem("canvas",c),(0,i.componentFactory)(t,o["default"],"yAxis",s?2:1,h.yAxisConf),(a=t.getChildren("yAxis"))&&a[1]&&a[1].setAxisConfig({isPercent:!0,drawLabels:!0,drawPlotLines:!0,drawAxisName:!0,drawAxisLine:!0,drawPlotBands:!0,drawTrendLines:!0,drawTrendLabels:!0}),a.forEach((function(e){!0!==e.getState("removed")?(e.setLinkedItem("canvas",c),u.setLinkedItem(e.getId(),e),c.attachAxis(e,!0,t.zoomY?d:{}),u.setLinkedItem(e.getId(),e),u.addExtEventListener("visiblerangeset",f,e)):c.detachAxis(e)})),t._setCategories()};var o=n(a(481)),r=n(a(528)),i=a(224)},615:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=function(t){var e,a,n,i=t.getChildren(),l=t.getFromEnv("chart-attrib"),s=i.canvas[0].getChildren("vCanvas"),c=t.getFromEnv("dataSource"),u=c.dataset,d=(0,r.pluckNumber)(l.showcumulativeline,1),h=c.data||u&&u[0].data;if(n={data:h},!(h&&0!==h.length))return void t.setChartMessage();e=t.getDSdef("column"),t.config.is3D&&((0,r.componentFactory)(s[0],o["default"],"datasetGroup_column"),a=s[0].getChildren("datasetGroup_column")[0]);(0,r.datasetFactory)(a||s[0],e,"dataset",1,[n]),d&&(e=t.getDSdef("line"),(0,r.datasetFactory)(s[1],e,"dataset",1,[n],[1]))};var o=n(a(548)),r=a(224)},616:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(617))["default"];e["default"]=o},617:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(606)),i=a(224),l=a(618),s=a(613),c=n(a(543)),u=function(t){function e(){var e;return(e=t.call(this)||this).fireGroupEvent=!0,e.defaultPlotShadow=1,e.isPercentage=!0,e.registerFactory("canvas",c["default"]),e}(0,o["default"])(e,t),e.getName=function(){return"Pareto3D"};var a=e.prototype;return a.getName=function(){return"Pareto3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="3D Pareto Chart",e.singleseries=!0,e.hasLegend=!1,e.defaultDatasetType="column3d",e.plotfillalpha=i.preDefStr.NINETYSTRING,e.use3dlineshift=1,e.enablemousetracking=!0,e.showzeroplaneontop=0},a.getDSdef=function(t){return"column"===t?l.ParetoColumn3DDataset:s.ParetoLineDataset},e}(r["default"]);e["default"]=u},618:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e.ParetoColumn3DDataset=void 0;var o=n(a(238)),r=a(611),i=a(551),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a._getHoveredPlot=function(t,e){var a,n;return a=this.getFromEnv("xAxis").getValue(t),(n=Math.round(a))-a>0?i._checkPointerOverColumn.call(this,n,t,e)||i._checkPointerOverColumn.call(this,n-1,t,e):i._checkPointerOverColumn.call(this,n+1,t,e)||i._checkPointerOverColumn.call(this,n,t,e)},a.createContainer=function(){var t=this.getLinkedParent();!this.getContainer("labelGroup")&&this.addContainer("labelGroup",function(t,e,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:t},container:e,state:"appearing",component:a,label:"group"})}("label-group",t.getChildContainer("vcanvasLabelGroup"),this).attr("class","fusioncharts-datalabels"))},e}(r.ParetoColumnDataset);e.ParetoColumn3DDataset=l},619:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(620))["default"];e["default"]=o},620:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(621)),i=a(629),l=function(t){function e(){var e;return(e=t.call(this)||this).hasScroll=!0,e.eiMethods={scrollTo:i.scrollTo},e}(0,o["default"])(e,t),e.getName=function(){return"ScrollCombiDy2D"},e.includeInputOptions=function(){return["SwipeGesture"]};var a=e.prototype;return a.getName=function(){return"ScrollCombiDy2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Dual Y-Axis Combination Chart",e.defaultDatasetType="column",e.showzeroplaneontop=0,e.avgScrollPointWidth=40,e.canvasborderthickness=1},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),i.configurer.call(this,e)},a._setAxisScale=function(){i.setAxisScale.call(this)},a._resetViewPortConfig=function(){i.resetViewPortConfig.call(this)},e}(r["default"]);e["default"]=l},621:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(607)),i=n(a(538)),l=n(a(556)),s=n(a(555)),c=n(a(622)),u=n(a(626)),d=n(a(628)),h=a(224),f=n(a(609)),p=h.preDefStr.SEVENTYSTRING,g=function(t){function e(){var e;return(e=t.call(this)||this).isDual=!0,e.registerFactory("dataset",f["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSCombidy2D"};var a=e.prototype;return a.getName=function(){return"MSCombidy2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Multi-series Dual Y-Axis Combination Chart",e.sDefaultDatasetType="line",e.defaultDatasetType="column",e.enablemousetracking=!0,e.isdual=1,e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha=h.HUNDREDSTRING,e.anchorimagealpha=h.HUNDREDSTRING,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=p,e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha=h.HUNDREDSTRING,e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0,e.showzeroplaneontop=0},a.getDSdef=function(t){return"splinearea"===t?c["default"]:"spline"===t?u["default"]:"area"===t?l["default"]:"line"===t?s["default"]:i["default"]},a.getDSGroupdef=function(t){return"column"===t?d["default"]:void 0},a.getDSType=function(t){return void 0===t&&(t=""),"splinearea"===t.toLowerCase()?"splinearea":"spline"===t.toLowerCase()?"spline":"area"===t.toLowerCase()?"area":"line"===t.toLowerCase()?"line":"column"},e}(r["default"]);e["default"]=g},630:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(631))["default"];e["default"]=o},631:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(632)),i=n(a(538)),l=n(a(556)),s=n(a(555)),c=n(a(622)),u=n(a(626)),d=n(a(628)),h=n(a(609)),f=function(t){function e(){var e;return(e=t.call(this)||this).hasScroll=!0,e.defaultPlotShadow=1,e.registerFactory("dataset",h["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"ScrollCombi2D"};var a=e.prototype;return a.getName=function(){return"ScrollCombi2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Combination Chart",e.defaultDatasetType="column",e.zeroplanethickness=1,e.zeroplanealpha=80,e.enablemousetracking=!0,e.showzeroplaneontop=0,e.defaultcrosslinethickness=null,e.avgScrollPointWidth=40,e.canvasborderthickness=1},a.getDSdef=function(t){return"splinearea"===t?c["default"]:"spline"===t?u["default"]:"area"===t?l["default"]:"line"===t?s["default"]:i["default"]},a.getDSGroupdef=function(t){return"column"===t?d["default"]:void 0},a.getDSType=function(t){return void 0===t&&(t=""),"splinearea"===t.toLowerCase()?"splinearea":"spline"===t.toLowerCase()?"spline":"area"===t.toLowerCase()?"area":"line"===t.toLowerCase()?"line":"column"},e}(r["default"]);e["default"]=f},632:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(633)),i=n(a(556)),l=a(224),s=l.preDefStr.SEVENTYSTRING,c=function(t){function e(){var e;return(e=t.call(this)||this).hasScroll=!0,e.defaultPlotShadow=0,e.binSize=0,e}(0,o["default"])(e,t),e.getName=function(){return"ScrollArea2D"};var a=e.prototype;return a.getName=function(){return"ScrollArea2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Multi-series Area Chart",e.defaultDatasetType="scrollarea2d",e.enablemousetracking=!0,e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha=l.HUNDREDSTRING,e.anchorimagealpha=l.HUNDREDSTRING,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=s,e.canvasborderthickness=1,e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha=l.HUNDREDSTRING,e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0,e.defaultcrosslinethickness=1,e.avgScrollPointWidth=75},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){},e}(r["default"]);e["default"]=c},633:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(634)),i=n(a(538)),l=n(a(628)),s=a(629),c=function(t){function e(){var e;return(e=t.call(this)||this).tooltipConstraint="plot",e.hasScroll=!0,e.defaultPlotShadow=1,e.binSize=0,e.eiMethods.scrollTo=s.scrollTo,e}(0,o["default"])(e,t),e.getName=function(){return"ScrollColumn2D"},e.includeInputOptions=function(){return["SwipeGesture"]};var a=e.prototype;return a.getName=function(){return"ScrollColumn2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.defaultDatasetType="column",e.showzeroplaneontop=1,e.friendlyName="Scrollable Multi-series Column Chart",e.avgScrollPointWidth=40,e.canvasborderthickness=1},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),s.configurer.call(this,e)},a._setAxisScale=function(){s.setAxisScale.call(this)},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e)},a._resetViewPortConfig=function(){s.resetViewPortConfig.call(this)},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},e}(r["default"]);e["default"]=c},635:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(636))["default"];e["default"]=o},636:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(633)),i=n(a(637)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"ScrollStackedColumn2D"};var a=e.prototype;return a.getName=function(){return"ScrollStackedColumn2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Stacked Column Chart",e.isstacked=!0,e.showSum=0,e.canvasborderthickness=1,e.avgScrollPointWidth=75},a.getDSGroupdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},639:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(640))["default"];e["default"]=o},640:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(641)),i=a(629),l=function(t){function e(){var e;return(e=t.call(this)||this).hasScroll=!0,e.eiMethods={scrollTo:i.scrollTo},e}(0,o["default"])(e,t),e.getName=function(){return"ScrollMSStackedColumn2D"},e.includeInputOptions=function(){return["SwipeGesture"]};var a=e.prototype;return a.getName=function(){return"ScrollMSStackedColumn2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.isstacked=!0,e.friendlyName="Scrollable MultiSeries Stacked Column Chart",e.defaultDatasetType="column",e.showzeroplaneontop=1,e.avgScrollPointWidth=75,e.canvasborderthickness=1},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),i.configurer.call(this,e)},e}(r["default"]);l.prototype._setAxisScale=i.setAxisScale,l.prototype._resetViewPortConfig=i.resetViewPortConfig;var s=l;e["default"]=s},643:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(644))["default"];e["default"]=o},644:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(645)),i=a(629),l=function(t){function e(){var e;return(e=t.call(this)||this).hasScroll=!0,e.eiMethods={scrollTo:i.scrollTo},e}(0,o["default"])(e,t),e.getName=function(){return"ScrollMSStackedColumn2DLineDY"},e.includeInputOptions=function(){return["SwipeGesture"]};var a=e.prototype;return a.getName=function(){return"ScrollMSStackedColumn2DLineDY"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.isstacked=!0,e.friendlyName="Scrollable Multi-series Dual Y-Axis Stacked Column and Line Chart",e.defaultDatasetType="column",e.sDefaultDatasetType="line",e.showzeroplaneontop=1,e.avgScrollPointWidth=75,e.canvasborderthickness=1},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),i.configurer.call(this,e)},a._setAxisScale=function(){i.setAxisScale.call(this)},a._resetViewPortConfig=function(){i.resetViewPortConfig.call(this)},e}(r["default"]);l.prototype._setAxisScale=i.setAxisScale,l.prototype._resetViewPortConfig=i.resetViewPortConfig;var s=l;e["default"]=s},647:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(648))["default"];e["default"]=o},648:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(649)),i=n(a(637)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"ScrollStackedBar2D"};var a=e.prototype;return a.getName=function(){return"ScrollStackedBar2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Stacked Bar Chart",e.isstacked=!0,e.avgScrollPointWidth=75,e.canvasborderthickness=1,e.showSum=0},a.getDSGroupdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},649:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(564)),i=n(a(579)),l=n(a(628)),s=n(a(567)),c=a(629),u=function(t){function e(){var e;return(e=t.call(this)||this).isBar=!0,e.eiMethods={scrollTo:c.scrollTo},e.hasScroll=!0,e.registerFactory("dataset",s["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"ScrollBar2D"},e.includeInputOptions=function(){return["SwipeGesture"]};var a=e.prototype;return a.getName=function(){return"ScrollBar2D"},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Multi-series Bar Chart",e.hasLegend=!0,e.defaultDatasetType="bar2d",e.avgScrollPointWidth=40},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),c.configurer.call(this,e)},a._setAxisScale=function(){c.setAxisScale.call(this,"bar2d")},a._resetViewPortConfig=function(){c.resetViewPortConfig.call(this)},e}(r["default"]);e["default"]=u},650:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(632))["default"];e["default"]=o},651:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(652))["default"];e["default"]=o},652:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(632)),i=n(a(555)),l=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.binSize=0,e}(0,o["default"])(e,t),e.getName=function(){return"ScrollLine2D"};var a=e.prototype;return a.getName=function(){return"ScrollLine2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scrollable Multi-series Line Chart",e.defaultDatasetType="line",e.zeroplanethickness=1,e.zeroplanealpha=40,e.showzeroplaneontop=0,e.enablemousetracking=!0,e.defaultcrosslinethickness=1,e.avgScrollPointWidth=75,e.canvasborderthickness=1},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){},e}(r["default"]);e["default"]=l},653:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(633))["default"];e["default"]=o},654:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(649))["default"];e["default"]=o},655:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(656))["default"];e["default"]=o},656:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(657)),i=n(a(665)),l=n(a(667)),s=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"Bubble"};var a=e.prototype;return a.getName=function(){return"Bubble"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Bubble Chart",e.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},e}(r["default"]);e["default"]=s},657:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(658)),i=n(a(662)),l=function(t){function e(){var e;return(e=t.call(this)||this).isXY=!0,e.defaultZeroPlaneHighlighted=!1,e}(0,o["default"])(e,t),e.getName=function(){return"Scatter"};var a=e.prototype;return a.getName=function(){return"Scatter"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Scatter Chart",e.hasLegend=!0,e.allowreversexaxis=!0,e.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){},e}(r["default"]);e["default"]=l},665:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(662)),i=a(538),l=a(224),s=n(a(663)),c=a(232),u=n(a(666)),d=l.hasTouch?l.TOUCH_THRESHOLD_PIXELS:l.CLICK_THRESHOLD_PIXELS,h=l.preDefStr.setRolloverAttrStr,f=l.preDefStr.setRolloutAttrStr,p=Math,g=p.round,v=p.min,m=p.max;(0,c.addDep)({name:"bubbleAnimation",type:"animationRule",extension:u["default"]});var b=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"bubble"},a.configureAttributes=function(t){if(!t)return!1;this.trimData(t),this.config.JSONData=t;var e,a,n,o,r,s,c,u,d,h,f,p,g,b,C,D,_,y,S,k,A,x,P,w=this.getFromEnv("chart"),N=w.getFromEnv("dataSource"),T=w.config,F=N.chart,M=this.config.JSONData,B=this.config,E=M.data||[],L=this.getFromEnv("color-manager"),I=this.index,O=this.getFromEnv("number-formatter"),R=(0,l.pluck)((0,l.parseUnsafeString)(F.tooltipsepchar),", "),G=-Infinity,V=+Infinity,z=G,H=V,W=G,Y=V,U=G,j=V;for(B.usePattern=(0,l.pluckNumber)(T.usePattern,0),B.patternType=i.PATTERN_TYPES.includes(M.patterntype)?M.patterntype:T.patternType,B.patternAngle=(0,l.pluckNumber)(M.patternangle,F.patternangle,B.patternType===i.PATTERN_TYPES[0]?40:0),B.patternDensity=(0,l.pluckNumber)(M.patterndensity,T.patternDensity),B.patternSize=(0,l.pluckNumber)(M.patternsize,B.patternType===i.PATTERN_TYPES[0]?2:4),B.patternAlpha=(0,l.pluckNumber)(M.patternalpha,T.patternAlpha),B.patternBgColor=(0,l.pluck)(M.patternbgcolor,B.patternBgColor),B.seriesname=(0,l.parseUnsafeString)(M.seriesname),B.includeinlegend=(0,l.pluckNumber)(M.includeinlegend,B.seriesname?1:0),B.anchorBgColor=(0,l.getFirstColor)((0,l.pluck)(M.color,M.plotfillcolor,F.plotfillcolor,L.getPlotColor(I))),B.showPlotBorder=(0,l.pluckNumber)(M.showplotborder,F.showplotborder,1),B.anchorBorderThickness=B.showPlotBorder?(0,l.pluckNumber)(M.plotborderthickness,F.plotborderthickness,1):0,B.anchorBorderColor=(0,l.getFirstColor)((0,l.pluck)(M.plotbordercolor,F.plotbordercolor,B.usePattern?B.anchorBgColor:"666666")),B.plotFillAlpha=(0,l.pluck)(M.plotfillalpha,M.bubblefillalpha,F.plotfillalpha,"100"),B.plotBorderAlpha=(0,l.pluck)(M.plotborderalpha,F.plotborderalpha,"95"),B.negativeColor=(0,l.pluck)(F.negativecolor,"FF0000"),B.is3d=0!==(0,l.pluckNumber)(F.use3dlighting,M.is3d,F.is3d),B.usePattern&&(B.is3d=0),B.bubbleScale=(0,l.pluckNumber)(F.bubblescale,1),B.showTextOutline=(0,l.pluckNumber)(F.textoutline,0),B.minBubbleRadius=(0,l.pluckNumber)(F.minbubbleradius),B.minRadiusForValue=(0,l.pluckNumber)(M.minradiusforvalue,F.minradiusforvalue,0),B.clipBubbles=(0,l.pluckNumber)(F.clipbubbles,1),B.enableAnimation=u=(0,l.pluckNumber)(F.animation,F.defaultanimation,1),B.animation=!!u&&{duration:1e3*(0,l.pluckNumber)(F.animationduration,1)},B.showTooltip=(0,l.pluckNumber)(F.showtooltip,1),B.transposeAnimation=(0,l.pluckNumber)(F.transposeanimation,u),B.transposeAnimDuration=1e3*(0,l.pluckNumber)(F.transposeanimduration,.2),B.seriesNameInTooltip=(0,l.pluckNumber)(F.seriesnameintooltip,1),B.rotateValues=(0,l.pluckNumber)(F.rotatevalues)?270:0,B.showHoverEffect=(0,l.pluckNumber)(F.plothovereffect,F.showhovereffect,void 0),B.usePattern&&(B.showHoverEffect=0),B.showValues=B.showvalues=(0,l.pluckNumber)(M.showvalues,F.showvalues,0),o=this.components.data=this.components.data||(this.components.data=[]),e=E.length,B.fillColor=B.is3d?(0,l.toRaphaelColor)((0,l.getPointColor)(B.anchorBgColor,B.plotFillAlpha)):(0,l.toRaphaelColor)({color:B.anchorBgColor,alpha:B.plotFillAlpha}),B.strokeColor=(0,l.toRaphaelColor)({color:B.anchorBorderColor,alpha:B.plotFillAlpha}),a=0;a<e;a++)if(d=E[a],!(n=o[a]=o[a]||(o[a]={})).graphics&&(n.graphics={}),(h=n.config={}).x=O.getCleanValue(d.x),h.y=O.getCleanValue(d.y),h.z=O.getCleanValue(d.z,!0),h.setValue={x:h.x,y:h.y,z:h.z},h.patternType=i.PATTERN_TYPES.includes(d.patterntype)?d.patterntype:B.patternType,h.patternAngle=(0,l.pluckNumber)(d.patternangle,M.patternangle,F.patternangle,h.patternType===i.PATTERN_TYPES[0]?40:0),h.patternDensity=(0,l.pluckNumber)(d.patterndensity,B.patternDensity),h.patternSize=(0,l.pluckNumber)(d.patternsize,M.patternsize,h.patternType===i.PATTERN_TYPES[0]?2:4),h.patternAlpha=(0,l.pluckNumber)(d.patternalpha,B.patternAlpha),h.patternBgColor=(0,l.pluck)(d.patternbgcolor,B.patternBgColor),h.dataLabelStyle=this._configureDataLabelStyle(d),h._x=h.x,h._y=h.y,h._z=h.z,h.showValue=(0,l.pluckNumber)(d.showvalue,B.showValues,0),h.plotShowValue=(0,l.pluckNumber)(d.showvalue),h.plotMinRadiusForValue=(0,l.pluckNumber)(d.minradiusforvalue,B.minRadiusForValue),h.anchorProps={},D=h.label=h.x,h.setLink=(0,l.getValidValue)(d.link),B.max=U=m(U,h.z||0),B.min=j=v(j,h.z||0),h.is3d=0!==(0,l.pluckNumber)(d.is3d,B.is3d),z=m(z,h.x),H=v(H,h.x),W=m(W,h.y),Y=v(Y,h.y),r=h.color=(0,l.getFirstColor)((0,l.pluck)(d.color,d.z<0?B.negativeColor:B.anchorBgColor)),s=h.alpha=(0,l.pluck)(d.alpha,B.plotFillAlpha),h.colorObj=A=h.is3d?(0,l.getPointColor)(r,s):{color:r,alpha:s},h.setDisplayValue=_=(0,l.parseUnsafeString)((0,l.pluck)(d.displayvalue,d.name,d.label)),c=h.formatedVal=null===h.y?h.y:O.dataLabels(h.y),h.displayValue=(0,l.pluck)(_,h.formatedVal),h.setTooltext=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(d.tooltext,M.plottooltext,F.plottooltext),!1)),B.showTooltip?null===c?f=!1:void 0!==h.setTooltext?(C=[4,5,6,7,8,9,10,11,12,13,118],b={yDataValue:c,xDataValue:O.xAxis(D),yaxisName:(0,l.parseUnsafeString)(F.yaxisname),xaxisName:(0,l.parseUnsafeString)(F.xaxisname),zDataValue:O.dataLabels(h.z)},f=(0,l.parseTooltext)(h.setTooltext,C,b,d,F,M)):(B.seriesNameInTooltip&&(g=(0,l.getFirstValue)(M&&M.seriesname)),f=g?g+R:l.BLANKSTRING,f+=D?O.xAxis(D)+R:l.BLANKSTRING,f+=c,f+=d.z?R+O.formatValue(d.z):l.BLANKSTRING):f=!1,h.toolText=f,p=h.hoverEffects={},0!==B.showHoverEffect){if(x=p.enabled=void 0!==(0,l.pluck)(d.hoveralpha,M.hoveralpha,F.bubblehoveralpha,d.hovercolor,M.hovercolor,M.bubblehovercolor,F.bubblehovercolor,d.borderhovercolor,M.borderhovercolor,F.plotborderhovercolor,d.borderhoveralpha,M.borderhoveralpha,F.plotborderhoveralpha,d.hoverscale,M.bubblehoverscale,F.bubblehoverscale,d.borderhovercolor,M.borderhovercolor,F.plotborderhovercolor,d.borderhoverthickness,M.borderhoverthickness,F.plotborderhoverthickness,d.negativehovercolor,M.negativeColor,F.negativecolor,d.is3donhover,F.plotfillhovercolor,M.is3donhover,F.is3donhover,void 0),p.negativeColor=(0,l.pluck)(d.negativehovercolor,M.negativehovercolor,F.negativehovercolor,B.negativeColor),p.is3d=(0,l.pluckNumber)(d.is3donhover,M.is3donhover,F.is3donhover,h.is3d),p.color=(0,l.pluck)(d.hovercolor,M.hovercolor,M.bubblehovercolor,F.plotfillhovercolor,F.bubblehovercolor,h.is3d?A.FCcolor.color:r),p.color=p.negativeColor&&d.z<0?p.negativeColor:p.color,p.scale=(0,l.pluck)(d.hoverscale,M.hoverscale,M.bubblehoverscale,F.bubblehoverscale,1),p.color=(0,l.getFirstColor)(p.color),h.hoverColor=p.color,p.alpha=(0,l.pluck)(d.hoveralpha,M.hoveralpha,F.plotfillhoveralpha,F.bubblehoveralpha,s),p.borderColor=(0,l.pluck)(d.borderhovercolor,M.borderhovercolor,F.plotborderhovercolor,B.anchorBorderColor),p.borderAlpha=(0,l.pluck)(d.borderhoveralpha,M.borderhoveralpha,F.plotborderhoveralpha,p.alpha,B.plotBorderAlpha),p.borderThickness=(0,l.pluckNumber)(d.borderhoverthickness,M.borderhoverthickness,F.plotborderhoverthickness,B.anchorBorderThickness),p.color=p.is3d?(0,l.getPointColor)(p.color,p.alpha):{FCcolor:{color:p.color,alpha:p.alpha}},1===(x&&B.showHoverEffect?0:B.showHoverEffect)){for(k=(P=(y="string"==typeof p.color)?p.color.split(/\s{0,},\s{0,}/):p.color.FCcolor.color.split(/\s{0,},\s{0,}/)).length,S=0;S<k;S++)P[S]=(0,l.getLightColor)(P[S],70);y?p.color=P.join(","):p.color.FCcolor.color=P.join(",")}!1===x&&(p.enabled=Boolean(B.showHoverEffect))}else p.enabled=!1;B.xMax=z,B.xMin=H,B.yMin=Y,B.yMax=W,this.setState("dirty",!0),this.setState("visible",1===(0,l.pluckNumber)(M.visible,!Number(M.initiallyhidden),1)),w.config.showLegend&&this._addLegend(),this.setState("dirty",!0)},a._getHoveredPlot=function(t,e){var a=this.config.dataTree.getNeighbour({x:t,y:e},!0,"circle");if(a)return{pointIndex:a.index||a.i,hovered:!0,pointObj:a.data}},a._hoverPlotAnchor=function(t,e,a){var n=this.getFromEnv("animationManager"),o=t.graphics.element,r="DataPlotRollOut"===e?o.data(f):o.data(h);a&&o&&(n.setAnimationState&&n.setAnimationState("DataPlotRollOut"===e?"mouseOut":"mouseOver"),n.setAnimation({el:o,attr:r,component:this}))},a._addLegend=function(){var t,e,a=this.getFromEnv("chart"),n=this.config,o=this.getFromEnv("chart-attrib"),r=a.getChildren("legend")[0],i=this.config.JSONData||{};n.includeinlegend?(e={enabled:n.includeInLegend,anchorSide:1,type:this.type,label:n.seriesname,usePattern:n.usePattern,legendIconAlpha:(0,l.pluckNumber)(i.legendiconalpha),patternAttr:{patternType:n.patternType,patternAngle:n.patternAngle,patternDensity:n.patternDensity,patternSize:n.patternSize,color:n.anchorBgColor,patternAlpha:n.patternAlpha,patternBgColor:n.patternBgColor,alpha:n.plotFillAlpha}},(t=r.getItem(this.config.legendItemId))?t.configure({style:r.config.itemStyle,hiddenStyle:r.config.itemHiddenStyle,datasetVisible:r.config.datasetVisible,hoverStyle:r.config.itemHoverStyle}):(this.config.legendItemId=r.createItem(this),t=r.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){t.itemClickFn()}),t)),t.configure(e),t.setStateCosmetics("default",{symbol:{fill:n.fillColor,bgAlpha:(0,l.pluckNumber)(i.legendiconbgalpha,i.legendiconalpha,o.legendiconbgalpha,o.legendiconalpha,n.plotFillAlpha),borderAlpha:(0,l.pluckNumber)(i.legendiconborderalpha,i.legendiconalpha,o.legendiconborderalpha,o.legendiconalpha,"100"),rawFillColor:n.anchorBgColor,rawStrokeColor:n.anchorBorderColor,stroke:n.strokeColor}}),this.getState("visible")?t.removeLegendState("hidden"):t.setLegendState("hidden")):this.config.legendItemId&&r.disposeItem(this.config.legendItemId)},a.getBubbleRadius=function(t){var e,a=p.sqrt,n=this.config,o=n.bubbleScale,r=n.minBubbleRadius,i=this.getFromEnv("chartConfig"),l=v(i.canvasHeight,i.canvasWidth)/8,s=a(this.getLinkedParent().getDataLimitRange().zMax),c=a(t);return e=g(c*l/s)*o||0,r&&(e=m(e,r)),e},a.createCoordinates=function(){var t,e,a,n,o,r,i,l=this.components,s=l.data,c=this.getFromEnv("yAxis"),u=c.getAxisBase(),d=c.getPixel(u),h=this.getFromEnv("xAxis"),f=h.config.isVertical,p=s.length,g=l.data;for(n=0;n<p;n++)e=(t=g[n])&&t.config,void 0!==t&&(a=e._b,o=h.getPixel(e._x),r=c.getPixel(e._y),i=a?c.getPixel(a):d,"bubble"===this.getName()&&(e.r=this.getBubbleRadius(e._z),e.showValue=void 0!==e.plotShowValue?+e.plotShowValue:e.r>=e.plotMinRadiusForValue&&this.config.showValues),f?(e._Px=r,e._Py=o,e._Pby=r,e._Pbx=i):(e._Px=o,e._Py=r,e._Pby=i,e._Pbx=o))},a.parsePlotAttributes=function(t,e){var a,n,o,r,i,s,c,u,h,f,p,g,v,b=this.config.JSONData,C=this.getFromEnv("chart").config,D=this.config,_=e,y=this.getState("visible"),S=D.anchorBorderThickness;r=t.config,s=(0,l.pluckNumber)(r.x,_),c=r.y,u=r.z,h=r.setLink,f=r.displayValue,i=r.toolText,r.finalTooltext=r.toolText,p=r.hoverEffects,null!==c&&((v=r.eventArgs||(r.eventArgs={})).index=_,v.link=h,v.value=c,v.y=c,v.x=s,v.z=u,v.displayValue=f,v.toolText=i,v.id=this.userID,v.datasetIndex=this.config.index,v.datasetName=b.seriesname,v.visible=y,v.color=r.color,v.alpha=r.alpha,v.is3dOnHover=p.is3d,v.hoverScale=p.scale,v.use3dLighting=r.is3d,v.hoverColor=r.hoverColor,v.hoverAlpha=p.alpha,D.usePattern?(v.pattern={patternType:r.patternType,patternColor:r.color,patternBgColor:r.patternBgColor===l.TRACKER_FILL?void 0:r.patternBgColor},delete v.color):delete v.pattern,n=r._Py,o=r._Px,a=r.r,[].push({x:o,y:n,r:a}),g=r.setRolloutAttr={fill:(0,l.toRaphaelColor)(r.colorObj),"stroke-width":D.anchorBorderThickness,stroke:(0,l.toRaphaelColor)({color:D.anchorBorderColor,alpha:D.plotBorderAlpha}),r:a},!1!==p.enabled&&(r.setRolloverAttr={fill:(0,l.toRaphaelColor)(p.color),"stroke-width":p.borderThickness,stroke:(0,l.toRaphaelColor)({color:p.borderColor,alpha:p.borderAlpha}),r:a*p.scale}),r.props={element:{attr:{cx:o,cy:y?n:C.canvasBottom+a,r:a||0,fill:(0,l.toRaphaelColor)(r.colorObj),"stroke-width":D.anchorBorderThickness,visibility:y,stroke:g.stroke}}},r.props.element.patternAttr={patternType:r.patternType,patternAngle:r.patternAngle,patternDensity:r.patternDensity,patternSize:r.patternSize,color:r.props.element.attr.fill,patternAlpha:r.patternAlpha,patternBgColor:r.patternBgColor,alpha:r.alpha,x:r.props.element.attr.cx,y:r.props.element.attr.cy},r.trackerConfig||(r.trackerConfig={}),r.trackerConfig.trackerRadius=m(a+(S||0),d),t._xPos=o,t._yPos=n)},a.allocatePosition=function(){var t,e,a,n,o,r,i,l=this.components.data,c=[];for(this.createCoordinates(),e=0,a=l.length;e<a;e+=1)t=l[e],this.parsePlotAttributes(t,e),this.parseLabelAttributes(t,e),t&&(n=(r=t.config)._Px,o=r._Py,i=r.r||0,c.push({x:n,y:o,index:e,data:t,r:i}));this.config.dataTree=(new s["default"]).buildKdTree(c)},a.getCanvasPadding=function(){var t,e,a,n,o,r,i,l,s,c,u,d,h,f,p,g=this.config||(this.config={}),m=this.components||{},b=this.getFromEnv("chartConfig"),C=b.rotatevalues,D=this.getFromEnv("xAxis"),_=this.getFromEnv("dataLabelStyle"),y=m.data||[],S=y.length,k=g.leftMostData||y[0],A=g.rightMostData||y[y.length-1],x=v(b.canvasHeight,b.canvasWidth)/8,P=1,w=1,N=b.zMax,T=g.bubbleScale,F=D.config.axisRange,M=F.max,B=F.min,E=D.getPixel(M),L=D.getPixel(B),I={},O={},R=this.getFromEnv("smartLabel"),G={paddingLeft:0,paddingRight:0},V=0;for(t=x/Math.sqrt(N),l=0;l<S;l++)e=y[l].config,a=k.config,n=A.config,r=Math.sqrt(e.z),h=Math.round(r*t)*T||0,f=D.getValue(h)-B,s=e.x-f/2,1===P&&(r=Math.sqrt(a.z),h=Math.round(r*t)*T||0,f=D.getValue(h)-B,c=a.x-f/2),1===w&&(r=Math.sqrt(n.z),h=Math.round(r*t)*T||0,f=D.getValue(h)-B,u=n.x-f/2),P=0,w=0,c>s&&(k=y[l],P=1),u<s&&(A=y[l],w=1);return R.useEllipsesOnOverflow(b.useEllipsesWhenOverflow),R.setStyle(_),k&&k.config.showValue&&(d=(o=k.config).displayValue,O=R.getOriSize(d),V=C?O.height:O.width,L>(i=D.getPixel(o.x)-.5*V)&&(G.paddingLeft=L-i)),A&&A.config.showValue&&(d=(o=A.config).displayValue,I=R.getOriSize(d),V=C?I.height:I.width,E<(p=D.getPixel(o.x)+.5*V)&&(G.paddingRight=p-E)),G},a.drawPlots=function(){var t,e,a,n,o,r,i,l,s,c=this,u=c.getFromEnv("animationManager"),d=c.components.data,p=c.getContainer(),g=c.getState("visible"),v=c.getContainer("labelGroup"),m=function(){!1===g&&(p.plotGroup.hide(),p.commonElemsGroup.hide(),v&&v.hide(),c._containerHidden=!0)},b={};for(o=0,r=d.length;o<r;o+=1)l=(i=(n=d[o]).config).y,t=n.graphics.element,b=i.hoverEffects,a=n.graphics.hotElement,s=n.graphics.label,null!==l?(e=n.graphics.element,(t=u.setAnimation({el:e||"circle",attr:i.props.element.attr,label:"circle",callback:m,component:c,container:p.plotGroup})).addPattern(i.props.element.patternAttr,c.config.usePattern),e||(n.graphics.element=t),t.show(),t.data("hoverEnabled",b.enabled).data(h,i.setRolloverAttr).data(f,i.setRolloutAttr).data("anchorRadius",i.r).data("anchorHoverRadius",i.r),t&&t.data("eventArgs",i&&i.eventArgs)):(t&&t.hide(),a&&a.hide(),s&&s.hide()),t&&(t.isDrawn=!0)},a.getDataLimits=function(){var t=this.getFromEnv("chart").config,e=this.config,a=e.yMax,n=e.yMin,o=-Infinity,r=+Infinity,i=t.transposeAxis,l=e.xMin,s=e.xMax,c=e.max,u=e.min,d=this.getRegressionPoints();return!1===this.getState("visible")&&i&&(a=o,n=r,l=r,s=o),d&&(a=Math.max(a,d.max),n=Math.min(n,d.min),s=Math.max(s,d.xMax),l=Math.min(l,d.xMin)),{max:a,min:n,xMin:l,xMax:s,zMax:c,zMin:u}},e}(r["default"]);e["default"]=b},666:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;e["default"]={"initial.dataset.bubble":function(){return{"circle.appearing":function(t){return[{initialAttr:{cx:t.attr.cx,cy:t.attr.cy,r:0},slot:"plot"}]},"group.appearing":function(t){return"label-group"===t.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]},"*":null}}}},667:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=a(240),i=a(224),l=function(t){function e(){var e;return(e=t.call(this)||this).setState("visible",!0),e}(0,o["default"])(e,t);var a=e.prototype;return a.createContainer=function(){var t,e,a=this.getFromEnv("animationManager"),n=this.getLinkedParent().getChildContainer();for(t in n)e=n[t],!this.getChildContainer(t)&&this.addChildContainer(t,a.setAnimation({el:"group",attr:{name:"manager-"+t},component:this,container:e}))},a.draw=function(){this.createContainer()},a.getDataLimitRange=function(){var t,e,a,n,o,r=this.getChildren(),i=-Infinity,l=+Infinity,s=-Infinity,c=+Infinity;for(e in r)if(r.hasOwnProperty(e)&&(a=r[e])instanceof Array)for(n=a.length,t=0;t<n;t++)a[t].getState("removed")||(o=a[t].getDataLimits(),s=Math.max(s,o.xMax||-Infinity),c=Math.min(c,o.xMin||+Infinity),i=Math.max(i,o.zMax||-Infinity),l=Math.min(l,o.zMin||+Infinity));return{xMax:s,xMin:c,zMax:i=i===-Infinity?0:i,zMin:l=l===+Infinity?0:l}},a.childChanged=function(t){void 0===t&&(t={});var e,a,n,o=this.config,r=this.getLinkedParent(),i={};!1===t.hide&&!1===t.show||(this._mapChildren((function(t){t.setState("dirty",!0)})),n=!0),!1!==t.dataLimitChanged&&((e=this.getDataLimits()).min===o.range.min&&e.max===o.range.max||(o.range.min=e.min,o.range.max=e.max,i.dataLimitChanged=!0,n=!0)),!1!==t.paddingChanged&&((a=this.getAxisValuePadding()).left===o.padding.left&&a.right===o.padding.right||(o.padding.left=a.left,o.padding.right=a.right,i.paddingChanged=!0,n=!0)),n?r.childChanged&&r.childChanged(i):this.asyncDraw()},a.getAxisValuePadding=function(){var t={},e=-Infinity,a=-Infinity;return this._mapChildren((function(n){n.getState("removed")||!1===n.getState("visible")||(t=n.getAxisValuePadding&&n.getAxisValuePadding()||{},e=Math.max(e,t.left||-Infinity),a=Math.max(a,t.right||-Infinity))})),e===-Infinity&&(e=0),a===-Infinity&&(a=0),this.config.padding||(this.config.padding={},this.config.padding.left=e,this.config.padding.right=a),{left:e,right:a}},a.getCanvasPadding=function(){var t,e,a={paddingLeft:0,paddingRight:0,paddingTop:0,paddingBottom:0};return this._mapChildren((function(n){if(!n.getState("removed"))for(e in t=n.getCanvasPadding&&n.getCanvasPadding()||{})t.hasOwnProperty(e)&&(a[e]=Math.max(t[e],a[e]))})),a},a.getDataLimits=function(){var t,e,a,n=this.getFromEnv("chart"),o=-Infinity,r=+Infinity,l=o,s=r,c=r,u=o;return this._mapChildren((function(n){var d;n.getDataLimits&&!n.getState("removed")&&(t=n.getDataLimits(),d=t,e=(0,i.pluck)(d.xMax,o),a=(0,i.pluck)(d.xMin,r),l=Math.max(l,d.max),s=Math.min(s,d.min),u=Math.max(u,e),c=Math.min(c,a))})),l===-Infinity&&(l=0),s===+Infinity&&(s=0),this.config.range||(this.config.range={},this.config.range.min=s,this.config.range.max=l,this.config.range.xMin=c,this.config.range.xMax=u),n.config.yMax=l,n.config.yMin=s,{min:s,max:l,xMin:c,xMax:u}},a.isVisible=function(){return!this.isNotVisible},a.getType=function(){return"manager"},a.getName=function(){return"BubbleGroupManager"},a.remove=function(){this._mapChildren((function(t){t.getState("removed")||t.remove()})),t.prototype.remove.call(this)},e}(r.ComponentInterface);e["default"]=l},668:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(657))["default"];e["default"]=o},669:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(641))["default"];e["default"]=o},670:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(671))["default"];e["default"]=o},671:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(672)),i=n(a(637)),l=a(224),s=n(a(230)),c=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedArea2D"};var a=e.prototype;return a.getName=function(){return"StackedArea2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Stacked Area Chart",e.plotfillalpha=l.HUNDREDSTRING,e.showSum=0,e.isstacked=1,this.addToEnv("useImprovedLabelPlacement",!0),this.addToEnv("useLinePlotGroupForAnchorPlacement",!0)},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.config,n=this.getFromEnv("chart-attrib");a.showSum=(0,s["default"])(n.showsum,a.showSum),a.showSum&&(a.valueposition=(0,l.parseUnsafeString)((0,l.pluck)(n.valueposition,"below")))},a.getDSGroupdef=function(){return i["default"]},e}(r["default"]);e["default"]=c},674:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(675))["default"];e["default"]=o},675:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(676)),i=n(a(637)),l=n(a(584)),s=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedBar3D"};var a=e.prototype;return a.getName=function(){return"StackedBar3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="3D Stacked Bar Chart",e.enablemousetracking=!0,e.maxbarheight=50,e.isstacked=!0,e.showSum=0},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){return i["default"]},e}(r["default"]);e["default"]=s},676:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(677)),i=n(a(628)),l=n(a(584)),s=n(a(678)),c=function(t){function e(){var e;return(e=t.call(this)||this).defaultSeriesType="bar3d",e.defaultPlotShadow=1,e.isBar=!0,e.defaultZeroPlaneHighlighted=!1,e.registerFactory("dataset",s["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSBar3D"};var a=e.prototype;return a.getName=function(){return"MSBar3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="Multi-series 3D Bar Chart",e.hasLegend=!0,e.defaultDatasetType="bar3d",e.showplotborder=0,e.enablemousetracking=!0},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){return i["default"]},e}(r["default"]);e["default"]=c},677:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(564)),i=n(a(543)),l=n(a(678)),s=function(t){function e(){var e;return(e=t.call(this)||this).registerFactory("canvas",i["default"]),e.registerFactory("dataset",l["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSBarCartesian3D"};var a=e.prototype;return a.getName=function(){return"MSBarCartesian3D"},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.drawTrendRegion=0},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.showplotborder=0,e.showzeroplaneontop=0},e}(r["default"]);e["default"]=s},678:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=function(t){var e,a,n,i,l,s=t.getFromEnv("dataSource").dataset,c=t.getChildren().canvas[0],u=e=c.getChildren("vCanvas")[0],d=t.config.defaultDatasetType||"";s||t.setChartMessage();(0,o.componentFactory)(e,r["default"],"datasetGroup_"+d),l=e.getChildren("datasetGroup_"+d)[0],a=t.getDSGroupdef(),(0,o.componentFactory)(l,a,"datasetGroup_"+d,1,[{}]),(i=l.getChildren("datasetGroup_"+d))&&(u=i[0]),n=t.getDSdef(),(0,o.datasetFactory)(u,n,"dataset",s.length,s)};var o=a(224),r=n(a(548))},679:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(680))["default"];e["default"]=o},680:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(681)),i=n(a(637)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedBar2D"};var a=e.prototype;return a.getName=function(){return"StackedBar2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Stacked Bar Chart",e.enablemousetracking=!0,e.maxbarheight=50,e.isstacked=!0,e.showSum=0},a.getDSGroupdef=function(){return i["default"]},e}(r["default"]);e["default"]=l},681:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(564)),i=n(a(579)),l=n(a(628)),s=n(a(567)),c=function(t){function e(){var e;return(e=t.call(this)||this).isBar=!0,e.registerFactory("dataset",s["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSBar2D"};var a=e.prototype;return a.getName=function(){return"MSBar2D"},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Multi-series Bar Chart",e.hasLegend=!0,e.defaultDatasetType="bar2d"},e}(r["default"]);e["default"]=c},682:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(683))["default"];e["default"]=o},683:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(684)),i=n(a(550)),l=n(a(637)),s=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedColumn3D"};var a=e.prototype;return a.getName=function(){return"StackedColumn3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="3D Stacked Column Chart",e.showSum=0,e.maxbarheight=50,e.enablemousetracking=!0,e.isstacked=!0},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},e}(r["default"]);e["default"]=s},684:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(685)),i=n(a(550)),l=n(a(628)),s=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.defaultZeroPlaneHighlighted=!1,e}(0,o["default"])(e,t),e.getName=function(){return"MSColumn3D"};var a=e.prototype;return a.getName=function(){return"MSColumn3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="Multi-series 3D Column Chart",e.defaultDatasetType="column3d",e.showplotborder=0,e.enablemousetracking=!0},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},e}(r["default"]);e["default"]=s},685:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(565)),i=n(a(543)),l=n(a(678)),s=function(t){function e(){var e;return(e=t.call(this)||this).registerFactory("canvas",i["default"]),e.registerFactory("dataset",l["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSCartesian3D"};var a=e.prototype;return a.getName=function(){return"MSCartesian3D"},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.drawTrendRegion=0},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.showplotborder=0,e.drawcrosslineontop=0,e.showzeroplaneontop=0},e}(r["default"]);e["default"]=s},686:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(687))["default"];e["default"]=o},687:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(634)),i=n(a(538)),l=n(a(637)),s=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedColumn2D"};var a=e.prototype;return a.getName=function(){return"StackedColumn2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Stacked Column Chart",e.isstacked=!0,e.showSum=0},a.getDSdef=function(){return i["default"]},a.getDSGroupdef=function(){return l["default"]},e}(r["default"]);e["default"]=s},688:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(645))["default"];e["default"]=o},689:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(690))["default"];e["default"]=o},690:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(691)),i=n(a(637)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedColumn3DLineDy"};var a=e.prototype;return a.getName=function(){return"StackedColumn3DLineDy"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.sDefaultDatasetType="line",e.friendlyName="Stacked 3D Column and Line Chart",e.defaultDatasetType="column3d",e.use3dlineshift=1,e.isdual=!0,e.isstacked=!0,e.showplotborder=0,e.enablemousetracking=!0,e.showSum=0},a.getDSGroupdef=function(t){return"column3d"===t?i["default"]:void 0},e}(r["default"]);e["default"]=l},691:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(692)),i=n(a(550)),l=n(a(555)),s=n(a(628)),c=n(a(693)),u=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.isDual=!0,e.registerFactory("dataset",c["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSColumn3DLineDy"};var a=e.prototype;return a.getName=function(){return"MSColumn3DLineDy"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.sDefaultDatasetType="line",e.friendlyName="Multi-series 3D Column and Line Chart",e.defaultDatasetType="column3d",e.use3dlineshift=1,e.isdual=!0,e.showplotborder=0,e.enablemousetracking=!0,e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha="100",e.anchorimagealpha="100",e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha="70",e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha="100",e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0},a.getDSdef=function(t){return"line"===t?l["default"]:i["default"]},a.getDSGroupdef=function(t){return"column3d"===t?s["default"]:void 0},a.getDSType=function(t,e){return t&&"line"===t.toLowerCase()||e?"line":"column3d"},e}(r["default"]);e["default"]=u},692:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(607)),i=n(a(543)),l=function(t){function e(){var e;return(e=t.call(this)||this).registerFactory("canvas",i["default"]),e}(0,o["default"])(e,t);var a=e.prototype;return a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.drawTrendRegion=0},e.getName=function(){return"MSDybaseCartesian3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.is3D=!0,this.config.showzeroplaneontop=0},a.getName=function(){return"MSDybaseCartesian3D"},e}(r["default"]);e["default"]=l},693:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=function(t){var e,a,n,l,s,c,u,d,h,f,p=t.getFromEnv("dataSource").dataset,g=t.getChildren().canvas[0].getChildren("vCanvas"),v=g[0],m=g[1],b=t.getFromEnv("chartConfig").isdual,C={vCanvasDatasetsDef0:{},vCanvasDatasetsDef1:{}},D={vCanvas0:{},vCanvas1:{}};p||t.setChartMessage();for(a=0;a<p.length;a++)e=p[a],"s"===(d=e.parentyaxis||"").toLowerCase()&&b?(u=(0,r.pluck)(e.renderas,t.config.sDefaultDatasetType),h=m,f=D.vCanvas1,l=C.vCanvasDatasetsDef1):(u=(0,r.pluck)(e.renderas,t.config.defaultDatasetType),h=v,f=D.vCanvas0,l=C.vCanvasDatasetsDef0),u=t.getDSType(u,"s"===d.toLowerCase()),(c=t.getDSGroupdef(u,d))&&((0,r.componentFactory)(h,o["default"],"multiseriesColumnManager3D"),n=h.getChildren("multiseriesColumnManager3D")[0],f[n.getName()]=!0,(0,r.componentFactory)(n,c,"multiseriesColumnManager"),f[c.getName().toLowerCase()]=!0),f[u.toLowerCase()]=!0,l[u]?(l[u].conf.push(e),l[u].indices.push(a)):(l[u]={},l[u].indices=[a],l[u].classDef=t.getDSdef(u),l[u].conf=[e],l[u].pYAxis=d.toLowerCase(),l[u].parent=c?n.getChildren("multiseriesColumnManager")[0]:h);for(var _ in C)if(C.hasOwnProperty(_))for(u in l=C[_])l.hasOwnProperty(u)&&("group"===(s=l[u]).parent.getType()&&s.parent.configure(s.conf),(0,r.datasetFactory)(s.parent,s.classDef,"dataset_"+u,s.conf.length,s.conf,s.indices));(0,i.removeComponents)(g[0],Object.keys(D.vCanvas0)),(0,i.removeComponents)(g[1],Object.keys(D.vCanvas1))};var o=n(a(548)),r=a(224),i=a(610)},694:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(691))["default"];e["default"]=o},695:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(621))["default"];e["default"]=o},696:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(697))["default"];e["default"]=o},697:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(692)),i=n(a(550)),l=n(a(556)),s=n(a(555)),c=n(a(622)),u=n(a(626)),d=n(a(628)),h=a(224),f=n(a(693)),p=h.preDefStr.HUNDREDSTRING,g=h.preDefStr.SEVENTYSTRING,v=function(t){function e(){var e;return(e=t.call(this)||this).isDual=!0,e.registerFactory("dataset",f["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSCombiDY3D"};var a=e.prototype;return a.getName=function(){return"MSCombiDY3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.sDefaultDatasetType="line",e.defaultDatasetType="column3d",e.showplotborder=0,e.isdual=1,e.enablemousetracking=!0,e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha=p,e.anchorimagealpha=p,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=g,e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha=p,e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0},a.getDSGroupdef=function(t){return"column3d"===t.toLowerCase()?d["default"]:void 0},a.getDSdef=function(t){return"splinearea"===t.toLowerCase()?c["default"]:"spline"===t.toLowerCase()?u["default"]:"area"===t.toLowerCase()?l["default"]:"line"===t.toLowerCase()?s["default"]:i["default"]},a.getDSType=function(t){return"splinearea"===t.toLowerCase()?"splinearea":"spline"===t.toLowerCase()?"spline":"area"===t.toLowerCase()?"area":"line"===t.toLowerCase()?"line":"column3d"},e}(r["default"]);e["default"]=v},698:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(699))["default"];e["default"]=o},699:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(700)),i=n(a(550)),l=n(a(555)),s=n(a(637)),c=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedColumn3DLine"};var a=e.prototype;return a.getName=function(){return"StackedColumn3DLine"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="Stacked 3D Column and Line Chart",e.use3dlineshift=1,e.isstacked=!0,e.stack100percent=0,e.showplotborder=0,e.enablemousetracking=!0,e.showSum=0},a.getDSdef=function(t){return"line"===t?l["default"]:i["default"]},a.getDSGroupdef=function(t){return"column"===t?s["default"]:void 0},a.getDSType=function(t){return t&&"line"===t.toLowerCase()?"line":"column"},e}(r["default"]);e["default"]=c},700:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(685)),i=n(a(550)),l=n(a(622)),s=n(a(626)),c=n(a(556)),u=n(a(555)),d=n(a(628)),h=n(a(693)),f=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e.registerFactory("dataset",h["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSCombi3D"};var a=e.prototype;return a.getName=function(){return"MSCombi3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="Multi-series 3D Combination Chart",e.defaultDatasetType="column3d",e.showplotborder=0,e.enablemousetracking=!0,e.anchorborderthickness=1,e.anchorimageurl=void 0,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=void 0,e.anchorbgalpha="100",e.anchorimagealpha="100",e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=void 0,e.anchorbordercolor=void 0,e.anchorradius=3,e.showvalues=1,e.plotfillalpha="70",e.linedashlen=5,e.linedashgap=4,e.linedashed=void 0,e.linealpha="100",e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0},a.getDSdef=function(t){return"splinearea"===t?l["default"]:"spline"===t?s["default"]:"area"===t?c["default"]:"line"===t?u["default"]:i["default"]},a.getDSGroupdef=function(t){return"column3d"===t?d["default"]:void 0},a.getDSType=function(t){return void 0===t&&(t=""),"area"===t.toLowerCase()?"area":"line"===t.toLowerCase()?"line":"spline"===t.toLowerCase()?"spline":"splinearea"===t.toLowerCase()?"splinearea":"column3d"},e}(r["default"]);e["default"]=f},701:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(702))["default"];e["default"]=o},702:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(703)),i=n(a(538)),l=n(a(555)),s=n(a(626)),c=n(a(637)),u=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedColumn2DLine"};var a=e.prototype;return a.getName=function(){return"StackedColumn2DLine"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Stacked Column and Line Chart",e.defaultDatasetType="column",e.isstacked=!0,e.stack100percent=0,e.enablemousetracking=!0,e.showSum=0},a.getDSdef=function(t){return"spline"===t?s["default"]:"line"===t?l["default"]:i["default"]},a.getDSGroupdef=function(t){return"column"===t?c["default"]:void 0},a.getDSType=function(t){return void 0===t&&(t=""),"line"===t.toLowerCase()?"line":"column"},e}(r["default"]);e["default"]=u},703:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(673)),i=n(a(538)),l=n(a(556)),s=n(a(555)),c=n(a(622)),u=n(a(626)),d=n(a(628)),h=n(a(609)),f=function(t){function e(){var e;return(e=t.call(this)||this).registerFactory("dataset",h["default"],["vCanvas"]),e}(0,o["default"])(e,t),e.getName=function(){return"MSCombi2D"};var a=e.prototype;return a.getName=function(){return"MSCombi2D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Multi-series Combination Chart",e.defaultDatasetType="column",e.enablemousetracking=!0,e.showzeroplaneontop=0},a.getDSdef=function(t){return"splinearea"===t?c["default"]:"spline"===t?u["default"]:"area"===t?l["default"]:"line"===t?s["default"]:i["default"]},a.getDSGroupdef=function(t){return"column"===t?d["default"]:void 0},a.getDSType=function(t){return void 0===t&&(t=""),"splinearea"===t.toLowerCase()?"splinearea":"spline"===t.toLowerCase()?"spline":"area"===t.toLowerCase()?"area":"line"===t.toLowerCase()?"line":"column"},e}(r["default"]);e["default"]=f},704:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(705))["default"];e["default"]=o},705:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(700)),i=n(a(550)),l=n(a(555)),s=n(a(628)),c=function(t){function e(){var e;return(e=t.call(this)||this).defaultPlotShadow=1,e}(0,o["default"])(e,t),e.getName=function(){return"MSColumnLine3D"};var a=e.prototype;return a.getName=function(){return"MSColumnLine3D"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.is3D=!0,e.friendlyName="Multi-series Column and Line Chart",e.use3dlineshift=1,e.showplotborder=0,e.enablemousetracking=!0},a.getDSdef=function(t){return"line"===t?l["default"]:i["default"]},a.getDSGroupdef=function(t){return"column3d"===t?s["default"]:void 0},a.getDSType=function(t){return t&&"line"===t.toLowerCase()?"line":"column3d"},e}(r["default"]);e["default"]=c},706:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(700))["default"];e["default"]=o},707:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(703))["default"];e["default"]=o},708:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(709))["default"];e["default"]=o},709:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(565)),i=n(a(710)),l=n(a(712)),s=n(a(567)),c=a(224),u=function(t){(0,o["default"])(a,t),a.getName=function(){return"Marimekko"};var e=a.prototype;function a(){var e;return(e=t.call(this)||this).isValueAbs=!0,e.distributedColumns=!0,e.stack100percent=!0,e.isStacked=!0,e.registerFactory("dataset",(function(t){(0,s["default"])(t);var e=t.getChildren().canvas[0].getChildren("vCanvas")[0],a=t.config.defaultDatasetType||"";e.getChildren("datasetGroup_"+a)[0].addToEnv("categories",t.getFromEnv("dataSource").categories)}),["vCanvas"]),e}return e._checkInvalidSpecificData=function(){var t=this.getFromEnv("dataSource"),e=t.dataset,a=t.categories;if(!(e&&a&&0!==a.length&&a[0].category&&a[0].category instanceof Array))return!0},e.getName=function(){return"Marimekko"},e.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.showXAxisPercentValues=(0,c.pluckNumber)(e.chart&&e.chart.showxaxispercentvalues,1)},e.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Marimekko Chart",e.defaultDatasetType="marimekko",e.isstacked=!0,e.showpercentvalues=0,e.usepercentdistribution=1,e.showSum=1,e.enablemousetracking=!0},e.getDSdef=function(){return i["default"]},e.getDSGroupdef=function(){return l["default"]},a}(r["default"]);e["default"]=u},710:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(538)),i=a(224),l=n(a(711)),s=a(232),c=i.regex.dropHypeash,u=Math,d=u.round,h=u.abs;(0,s.addDep)({name:"marimekkoAnimation",type:"animationRule",extension:l["default"]});var f=function(t){function e(){var e;return(e=t.call(this)||this).config.groupName="column",e}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"marimekko"},a.configure=function(e){(0,i.fcEach)(e.data,(function(t){t&&(t.value=+t.value?h(t.value):"string"==typeof t.value&&"-"===t.value.charAt(0)?t.value.substring(1):t.value,t.value&&""!==t.value||(t.value=0))})),t.prototype.configure.call(this,e)},a._addLegend=function(){var t,e,a,n,o=this.getFromEnv("chart-attrib"),r=this.config,l=this.getFromEnv("legend"),s=(0,i.pluckNumber)(this.getFromEnv("chart-attrib").useplotgradientcolor,1),u=r.legendSymbolColor,d=this.config.JSONData||{};t=(0,i.getLightColor)(u,60).replace(c,i.HASHSTRING),e=s?{FCcolor:{color:u+","+u+","+(0,i.getLightColor)(u,40)+","+u+","+u,ratio:"0,70,30",angle:270,alpha:"100,100,100,100,100"}}:{FCcolor:{color:u,angle:0,ratio:"0",alpha:"100"}},a={enabled:r.includeInLegend,type:this.type,label:(0,i.getFirstValue)(this.config.JSONData.seriesname),usePattern:r.usePattern,legendIconAlpha:(0,i.pluckNumber)(d.legendiconalpha),patternAttr:{patternType:r.patternType,patternAngle:r.patternAngle,patternDensity:r.patternDensity,patternSize:r.patternSize,color:r.plotColor,patternAlpha:r.patternAlpha,patternBgColor:r.patternBgColor,alpha:r.plotfillalpha}},r.includeinlegend?((n=l.getItem(this.config.legendItemId))||(this.config.legendItemId=l.createItem(this),n=l.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){n.itemClickFn()}),n)),n.configure(a),n.setStateCosmetics("default",{symbol:{fill:(0,i.toRaphaelColor)(e),bgAlpha:(0,i.pluckNumber)(d.legendiconbgalpha,d.legendiconalpha,o.legendiconbgalpha,o.legendiconalpha,r.plotfillalpha),borderAlpha:(0,i.pluckNumber)(d.legendiconborderalpha,d.legendiconalpha,o.legendiconbordergalpha,o.legendiconalpha,"100"),rawFillColor:e.FCcolor.color,stroke:(0,i.toRaphaelColor)(t)}}),this.getState("visible")?n.removeLegendState("hidden"):n.setLegendState("hidden")):this.config.legendItemId&&l.disposeItem(this.config.legendItemId)},a.searchIndex=function(t,e){for(var a,n,o=this.getFromEnv("xAxis"),r=0,i=e.length-1;r<=i;)if(a=Math.round((r+i)/2)||0,(n=o.getPixel(e[a].x)+e[a].columnWidth/2)<t)r=a+1;else{if(!(n>t))return a;i=a-1}return r},a.allocatePosition=function(){this.getLinkedParent()._setStackDimensions(),t.prototype.allocatePosition.call(this)},a._getHoveredPlot=function(t,e){var a,n,o,r,i=this.getLinkedParent(),l=i.getstackConf(),s=this.getFromEnv("chartConfig"),c=i.config,u=s.plotborderthickness,d=s.showplotborder,h=l.length-1;return n=t+(a=(a=(u=d?u:0)/2)%2==0?a+1:Math.round(a)),r=o&&c.datasetIndex||this.searchIndex(n,l),c.datasetIndex||(c.datasetIndex=r),((o=this._checkPointerOverColumn(r,t,e))||this.index===h)&&delete c.datasetIndex,o},a.setColumnPosition=function(){return this},a.fineTunePlotDimension=function(t,e,a,n,o){var r=a,i=n,l=t,s=e,c=this.getLinkedParent().getstackConf(),u=this.getFromEnv("chart"),h=u.config.plotborderthickness,f=u.getChildren("canvas")[0].config,p=f.canvasBorderWidth>0,g=f.canvasRight,v=f.canvasTop,m=f.canvasLeft;return c.length?(l-=(i=c[o].columnWidth)/2,parseInt(s,10)<=v&&(r-=v-s-+p,s=v-+p),h<=1&&(d(l)<=m&&(i+=l,i-=l=m-h/2+ +!!h-+p),d(l+i)>=g&&(i=g-l+h/2-+!!h+ +p)),{xPos:l,yPos:s,width:i,height:r}):{xPos:l,yPos:s,width:i,height:r}},e}(r["default"]);e["default"]=f},711:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var n=a(224),o={"initial.dataset.marimekko":function(){var t=this,e=t.getFromEnv("chart"),a=e.config.yDepth||0,o=t.getFromEnv("yAxis");return{"rect.appearing":function(r){var i,l,s,c,u=o.getPixel(o.getAxisBase())+(e.isBar?-a:a),d=r.attr;return i=d.y,l=d.height,c=Math.sign(i+l/2-u),s=i+l,[{initialAttr:function(){var t={};return t.y=s,t.height=0,t},slot:"plot",startEnd:function(){return n.animHelperFN.getTimeByValue({start:0,end:.6},{startPx:u,endPx:1===c?t.config.yAxisMaxPixel:t.config.yAxisMinPixel},{startPx:s,endPx:1===c?d.y+d.height:d.y})},effect:"linear"}]},"group.appearing":null,"group.updating":null,"plotLabel.appearing":[{initialAttr:{opacity:0},slot:"final"}],"*":null}}};e["default"]=o},712:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(637)),i=a(224),l=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t);var a=e.prototype;return a.getType=function(){return"group"},a.getName=function(){return"marimekkoStackgroup"},a.getstackConf=function(){return this.config.stackConf},a._setStackPosition=function(){t.prototype._setStackPosition.call(this);var e,a,n,o,r,i,l=this.config,s=l.stackConf||(l.stackConf=[]),c=l.stackValues,u=this.getFromEnv("categories")[0].category,d=this.getFromEnv("number-formatter"),h=0,f=0,p=0,g=this.getFromEnv("xAxis"),v=g.getVisibleConfig(),m=v.minValue,b=v.maxValue-m,C=m;for(o=0,r=c.length;o<r;o++)f+=c[o]&&c[o].positive||0;for(l.totalSumValue=f,o=0;o<u.length;o++)(a=u[o]).widthpercent&&(h+=d.getCleanValue(a.widthpercent));for(100==+h.toFixed(8)&&(h=+h.toFixed(8),l.setUserWidth=1),e=this.getStackSumPercent(),o=0,r=c.length;o<r;o++)(n=s[o])||(n=s[o]={}),p+=e[o]/100,i=e[o]/100*b/2+C,C=p*b+m,n.x=i,g.updateTicksValues(o,{x:i})},a.getStackSumPercent=function(){var t,e=this.config,a=e.stackValues,n=e.totalSumValue,o=this.getFromEnv("number-formatter"),r=this.getFromEnv("categories")[0].category,i=e.setUserWidth,l=[];for(t=0;t<a.length;t++)l[t]=i?o.getCleanValue(r[t].widthpercent):(a[t]&&a[t].positive||0)/n*100;return l},a.draw=function(){t.prototype.draw.call(this),this.drawLabel()},a.createContainer=function(){t.prototype.createContainer.call(this);var e=this.getLinkedParent();!this.getContainer("commonLabelContainer")&&this.addContainer("commonLabelContainer",function(t,e,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:t},container:e,component:a,label:"group"})}("manager-commonLabelContainer",e.getChildContainer("vcanvasLabelGroup"),this))},a.drawLabel=function(){var t,e,a,n,o,r,l,s,c,u,d,h,f,p,g,v=this.config,m=this.getFromEnv("smartLabel"),b=this.getFromEnv("animationManager"),C=this.getStackSumPercent(),D=this.getFromEnv("chart-attrib"),_=this.getChildren("dataset"),y=v.stackConf,S=this.getContainer("commonLabelContainer"),k=this.getFromEnv("number-formatter"),A=0,x=this.getFromEnv("chartConfig"),P=x.canvasBottom,w=this.getFromEnv("xAxis"),N=this.getFromEnv("style"),T=x.dataLabelStyle,F=C.length,M=v.stackValues,B=x.showXAxisPercentValues,E=this.getGraphicalElement("commonLabels")||[],L=E.length;if(m.setStyle(T),B){for(h=(0,i.pluck)(T.backgroundColor,"#ffffff"),d=(0,i.pluck)(T.borderColor===i.BLANKSTRING?"#"+N.inCancolor:T.borderColor,"#000000"),f=(0,i.pluck)(T.borderThickness,1),r=0;r<F-1;r++)M[r]&&(A+=C[r],l=k.percentValue(A),n=w.getPixel(y[r].x)+y[r].columnWidth/2,o=P,u=E[r],M[r].positive!==M[r].negative?(s={text:l,fill:T.color,"text-bound":[h,d,f,T.borderPadding,T.borderRadius,T.borderDash],"line-height":T.lineHeight,visibility:i.visibleStr},o=o-m.getOriSize(l).height/2-f,s.x=n,s.y=o,u&&u.show(),c=b.setAnimation({el:u||"text",container:S,attr:s,label:"text",component:this}),u||this.addGraphicalElement("commonLabels",c,!0)):(l=i.BLANKSTRING,u&&u.hide()));for(var I=r;I<L;I++)E[I].hide()}for(p=0;p<_.length;p++)for(a=(e=_[p]).components.data,t=e.config.JSONData,g=0;g<a.length;g++)a[g].config.finalTooltext=(0,i.parseTooltext)(a[g].config.finalTooltext,[111],{xAxisPercentValue:C[g]&&C[g].toPrecision(4)+"%"},a,D,t)},a._getXpos=function(t){return this.getFromEnv("xAxis").getPixel(this.config.stackConf[t].x)},a._setStackDimensions=function(){var t,e,a,n,o,r,i=this.config,l=i.stackValues,s=this.getFromEnv("categories")[0].category,c=0,u=this.getFromEnv("number-formatter"),d=this.getStackSumPercent(),h=this.getFromEnv("canvasConfig").canvasWidth,f=i.stackConf||(i.stackConf=[]);for(t=0;t<s.length;t++)(e=s[t]).widthpercent&&(c+=u.getCleanValue(e.widthpercent));for(100==+c.toFixed(8)&&(a=i.setUserWidth=1,c=+c.toFixed(8)),t=0,n=l.length;t<n;t++)e=s[t],(o=f[t])||(o=f[t]={}),r=a?u.getCleanValue(e.widthpercent)/100:d[t]/100,o.columnWidth=r*h},e}(r["default"]);e["default"]=l},713:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(672))["default"];e["default"]=o},714:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(676))["default"];e["default"]=o},715:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(681))["default"];e["default"]=o},716:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(717))["default"];e["default"]=o},718:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(684))["default"];e["default"]=o},719:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(634))["default"];e["default"]=o},732:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(733))["default"];e["default"]=o},733:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=a(224),i=n(a(637)),l=n(a(555)),s=n(a(538)),c=n(a(607)),u="Stacked 2D Column and Line Chart",d=r.preDefStr.SEVENTYSTRING,h=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedColumn2DLineDy"};var a=e.prototype;return a.getName=function(){return"StackedColumn2DLineDy"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName=u,e.sDefaultDatasetType="line",e.friendlyName=u,e.defaultDatasetType="column",e.isdual=!0,e.isstacked=!0,e.enablemousetracking=!0,e.stack100percent=0,e.showSum=0,e.anchorborderthickness=1,e.anchorimageurl=r.UNDEF,e.anchorimagepadding=1,e.anchorsides=1,e.anchoralpha=r.UNDEF,e.anchorbgalpha=r.HUNDREDSTRING,e.anchorimagealpha=r.HUNDREDSTRING,e.anchorimagescale=100,e.anchorstartangle=90,e.anchorshadow=0,e.anchorbgcolor=r.UNDEF,e.anchorbordercolor=r.UNDEF,e.anchorradius=3,e.showvalues=1,e.plotfillalpha=d,e.linedashlen=5,e.linedashgap=4,e.linedashed=r.UNDEF,e.linealpha=r.HUNDREDSTRING,e.linethickness=2,e.drawfullareaborder=1,e.connectnulldata=0,e.showzeroplaneontop=0},a.getDSdef=function(t){return"line"===t?l["default"]:s["default"]},a.getDSGroupdef=function(t){return"column"===t?i["default"]:r.UNDEF},a.getDSType=function(t){return void 0===t&&(t=""),"line"===t.toLowerCase()?"line":"column"},e}(c["default"]);e["default"]=h},734:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(735))["default"];e["default"]=o},735:function(t,e,a){"use strict";var n=a(219);e.__esModule=!0,e["default"]=void 0;var o=n(a(238)),r=n(a(637)),i=n(a(555)),l=n(a(556)),s=n(a(733)),c=a(224),u=function(t){function e(){return t.apply(this,arguments)||this}(0,o["default"])(e,t),e.getName=function(){return"StackedArea2DLineDy"};var a=e.prototype;return a.getName=function(){return"StackedArea2DLineDy"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Stacked 2D Area and Line Chart",e.plotfillalpha=c.HUNDREDSTRING,e.isstacked=1,e.defaultDatasetType="area",e.stack100percent=0,e.defaultcrosslinethickness=1,this.addToEnv("useImprovedLabelPlacement",!0),this.addToEnv("useLinePlotGroupForAnchorPlacement",!0)},a.getDSdef=function(t){return"line"===t?i["default"]:l["default"]},a.getDSGroupdef=function(t){return"area"===t?r["default"]:void 0},a.getDSType=function(t){return void 0===t&&(t=""),"line"===t.toLowerCase()?"line":"area"},e}(s["default"]);e["default"]=u}}])}));
//# sourceMappingURL=http://localhost:3052/3.18.0/map/eval/fusioncharts.charts.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(147),
    metaMap = __webpack_require__(614);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(615);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141),
    root = __webpack_require__(49);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(617),
    composeArgsRight = __webpack_require__(618),
    countHolders = __webpack_require__(1557),
    createCtor = __webpack_require__(250),
    createRecurry = __webpack_require__(619),
    getHolder = __webpack_require__(380),
    reorder = __webpack_require__(1569),
    replaceHolders = __webpack_require__(252),
    root = __webpack_require__(49);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 618 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1558),
    setData = __webpack_require__(622),
    setWrapToString = __webpack_require__(623);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(614),
    noop = __webpack_require__(898);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(287),
    baseLodash = __webpack_require__(379);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(613),
    shortOut = __webpack_require__(612);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1563),
    insertWrapDetails = __webpack_require__(1564),
    setToString = __webpack_require__(428),
    updateWrapDetails = __webpack_require__(1565);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 624 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(899);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(321);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1584),
    baseUnary = __webpack_require__(419),
    nodeUtil = __webpack_require__(861);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(862),
    arraySome = __webpack_require__(903),
    cacheHas = __webpack_require__(863);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(105);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1625);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(423),
    isArguments = __webpack_require__(381),
    isArray = __webpack_require__(51),
    isIndex = __webpack_require__(251),
    isLength = __webpack_require__(382),
    toKey = __webpack_require__(205);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(2)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(9);

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isDate_index_js__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isDate_index_js__["default"])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(1678);






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(9);




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a" /* default */])(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__ = __webpack_require__(258);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(9);




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a" /* default */])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a" /* default */])(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["a"] = (longFormatters);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isProtectedDayOfYearToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = isProtectedWeekYearToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var days = amount * 7;
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["default"])(dirtyDate, days);
}

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["default"])(dirtyDate, amount * 12);
}

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(9);




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var month = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(787);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1744);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(399);

var callBind = __webpack_require__(401);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(790);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveConfigurableNames = __webpack_require__(1754).functionsHaveConfigurableNames();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, 'name', { value: 'get flags' });
}


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(792);

var supportsDescriptors = __webpack_require__(196).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["a"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyles__ = __webpack_require__(1779);
/* unused harmony reexport default */


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(797);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ThemeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ThemeContext.displayName = 'ThemeContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ThemeContext);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = StylesProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jssPreset__ = __webpack_require__(406);







 // Default JSS instance.

var jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["create"])(Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__["a" /* default */])(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(defaultOptions);

if (false) {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(StylesContext);

  var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["create"])({
      plugins: Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ __webpack_exports__["a"] = (noopTheme);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__ = __webpack_require__(1800);
/* unused harmony reexport default */


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled__ = __webpack_require__(1801);
/* unused harmony reexport default */


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__ = __webpack_require__(1802);
/* unused harmony reexport default */


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withStyles__ = __webpack_require__(1803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withStyles__["a"]; });


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(808);
/* unused harmony reexport default */
/* unused harmony namespace reexport */



/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withThemeCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(166);







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["innerRef"]);

      var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme = withThemeCreator();
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createTheme__ = __webpack_require__(1804);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createTheme__["a" /* default */])();
/* harmony default export */ __webpack_exports__["a"] = (defaultTheme);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export border */
/* unused harmony export borderTop */
/* unused harmony export borderRight */
/* unused harmony export borderBottom */
/* unused harmony export borderLeft */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* unused harmony default export */ var _unused_webpack_default_export = (borders);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (responsivePropType);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export css */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(268);






function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

var warnedOnce = false;

function styleFunctionSx(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    if (props.sx) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.sx))), omit(props.sx, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    css: chainPropTypes(PropTypes.object, function (props) {
      if (!warnedOnce && props.css !== undefined) {
        warnedOnce = true;
        return new Error('Material-UI: The `css` prop is deprecated, please use the `sx` prop instead.');
      }

      return null;
    }),
    sx: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css', 'sx'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}
/**
 *
 * @deprecated
 * The css style function is deprecated. Use the `styleFunctionSx` instead.
 */


function css(styleFunction) {
  if (false) {
    console.warn('Material-UI: The `css` function is deprecated. Use the `styleFunctionSx` instead.');
  }

  return styleFunctionSx(styleFunction);
}
/* unused harmony default export */ var _unused_webpack_default_export = (styleFunctionSx);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flexBasis */
/* unused harmony export flexDirection */
/* unused harmony export flexWrap */
/* unused harmony export justifyContent */
/* unused harmony export alignItems */
/* unused harmony export alignContent */
/* unused harmony export order */
/* unused harmony export flex */
/* unused harmony export flexGrow */
/* unused harmony export flexShrink */
/* unused harmony export alignSelf */
/* unused harmony export justifyItems */
/* unused harmony export justifySelf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);


var flexBasis = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexBasis'
});
var flexDirection = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexDirection'
});
var flexWrap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexWrap'
});
var justifyContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyContent'
});
var alignItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignItems'
});
var alignContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignContent'
});
var order = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'order'
});
var flex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flex'
});
var flexGrow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexGrow'
});
var flexShrink = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexShrink'
});
var alignSelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignSelf'
});
var justifyItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyItems'
});
var justifySelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifySelf'
});
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* unused harmony default export */ var _unused_webpack_default_export = (flexbox);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gridGap */
/* unused harmony export gridColumnGap */
/* unused harmony export gridRowGap */
/* unused harmony export gridColumn */
/* unused harmony export gridRow */
/* unused harmony export gridAutoFlow */
/* unused harmony export gridAutoColumns */
/* unused harmony export gridAutoRows */
/* unused harmony export gridTemplateColumns */
/* unused harmony export gridTemplateRows */
/* unused harmony export gridTemplateAreas */
/* unused harmony export gridArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);


var gridGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridGap'
});
var gridColumnGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumnGap'
});
var gridRowGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRowGap'
});
var gridColumn = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumn'
});
var gridRow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRow'
});
var gridAutoFlow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoColumns'
});
var gridAutoRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateAreas'
});
var gridArea = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridArea'
});
var grid = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* unused harmony default export */ var _unused_webpack_default_export = (grid);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export color */
/* unused harmony export bgcolor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);


var color = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(color, bgcolor);
/* unused harmony default export */ var _unused_webpack_default_export = (palette);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export position */
/* unused harmony export zIndex */
/* unused harmony export top */
/* unused harmony export right */
/* unused harmony export bottom */
/* unused harmony export left */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);


var position = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'position'
});
var zIndex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'top'
});
var right = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'right'
});
var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bottom'
});
var left = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'left'
});
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(position, zIndex, top, right, bottom, left));

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export width */
/* unused harmony export maxWidth */
/* unused harmony export minWidth */
/* unused harmony export height */
/* unused harmony export maxHeight */
/* unused harmony export minHeight */
/* unused harmony export sizeWidth */
/* unused harmony export sizeHeight */
/* unused harmony export boxSizing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);



function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'width',
  transform: transform
});
var maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minWidth',
  transform: transform
});
var height = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'height',
  transform: transform
});
var maxHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minHeight',
  transform: transform
});
var sizeWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
var sizeHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var boxSizing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxSizing'
});
var sizing = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* unused harmony default export */ var _unused_webpack_default_export = (sizing);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUnarySpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memoize__ = __webpack_require__(1826);





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = Object(__WEBPACK_IMPORTED_MODULE_4__memoize__["a" /* default */])(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  }).reduce(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */], {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
/* unused harmony default export */ var _unused_webpack_default_export = (spacing);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fontFamily */
/* unused harmony export fontSize */
/* unused harmony export fontStyle */
/* unused harmony export fontWeight */
/* unused harmony export letterSpacing */
/* unused harmony export lineHeight */
/* unused harmony export textAlign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);


var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'letterSpacing'
});
var lineHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'lineHeight'
});
var textAlign = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textAlign'
});
var typography = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* unused harmony default export */ var _unused_webpack_default_export = (typography);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["a"] = (zIndex);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var TableContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  TableContext.displayName = 'TableContext';
}

/* harmony default export */ __webpack_exports__["a"] = (TableContext);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var FormControlContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](FormControlContext);
}
/* harmony default export */ __webpack_exports__["a"] = (FormControlContext);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasValue */
/* harmony export (immutable) */ __webpack_exports__["a"] = isFilled;
/* unused harmony export isAdornedStart */
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var ListContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ListContext.displayName = 'ListContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ListContext);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(144);

function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" /* default */])(node);
  return doc.defaultView || window;
}

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaHidden;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__ = __webpack_require__(826);





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container);

  if (doc.body === container) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__["a" /* default */])(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__["a" /* default */])();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();



/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormControlContext__ = __webpack_require__(822);


function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__FormControlContext__["a" /* default */]);
}

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(274);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(1873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(104);







/**
 * @ignore - internal component.
 */

var NativeSelectInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant))], disabled && classes.disabled)
  }));
});
 false ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,

  /**
   * @ignore
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (NativeSelectInput);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1894);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadThemeConfig = uploadThemeConfig;
exports.uploadProfileImage = uploadProfileImage;
exports.uploadLogo = uploadLogo;

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

var _reactNotifications = __webpack_require__(78);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

var AWS = __webpack_require__(572);

AWS.config.region = CONST.REGION; // 1. Enter your region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: CONST.IDENTITY_POOL_ID // 2. Enter your identity pool
});
AWS.config.credentials.get(function () {});
var bucketName = CONST.BUCKET_NAME; // Enter your bucket name
var bucket = new AWS.S3({
  params: {
    Bucket: bucketName
  }
});

function uploadThemeConfig(fileContent, fileName) {
  var promiseForThemeUpload = new Promise(function (resolve, reject) {
    var file = new Blob([fileContent], { type: 'plain/text' });
    if (file) {
      var objKey = fileName;
      var params = {
        Key: objKey,
        ContentType: file.type,
        Body: file,
        ACL: 'public-read'
      };

      bucket.putObject(params, function (err, data) {
        if (err) {
          _reactNotifications.NotificationManager.error(err.message);
          reject(err);
        } else {
          // NotificationManager.success(uploadType + " successfully updated.");
          resolve(data);
        }
      });
    }
  });

  return promiseForThemeUpload;
}

function uploadProfileImage(fileChooser, username) {
  var file = fileChooser.files[0];

  var promiseForImageUpload = new Promise(function (resolve, reject) {
    if (file) {
      // Check file type and show error if file type is not an image of type jgp, jpeg or png
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        var objKey = 'profile/' + username;
        var params = {
          Key: objKey,
          ContentType: file.type,
          Body: file,
          ACL: 'public-read'
        };

        bucket.putObject(params, function (err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
            // listObjs(objKey);
          }
        });
      } else {
        reject(new Error('Only file types of type JPG, JPEG and PNG are supported.'));
      }
    } else {
      reject(new Error('Please upload a file'));
    }
  });

  return promiseForImageUpload;
}

function uploadLogo(fileChooser, name) {
  var file = fileChooser.files[0];

  var promiseForImageUpload = new Promise(function (resolve, reject) {
    if (file) {
      // Check file type and show error if file type is not an image of type jgp, jpeg or png
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        var objKey = 'logos/' + name;
        var params = {
          Key: objKey,
          ContentType: file.type,
          Body: file,
          ACL: 'public-read'
        };

        bucket.putObject(params, function (err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
            // listObjs(objKey);
          }
        });
      } else {
        reject(new Error('Only file types of type JPG, JPEG and PNG are supported.'));
      }
    } else {
      reject(new Error('Please upload a file'));
    }
  });

  return promiseForImageUpload;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(uploadThemeConfig, 'uploadThemeConfig', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(uploadProfileImage, 'uploadProfileImage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(uploadLogo, 'uploadLogo', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(bucketName, 'bucketName', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(bucket, 'bucket', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CONST, 'CONST', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, '_interopRequireWildcard', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(bucketName, 'bucketName', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(bucket, 'bucket', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(uploadThemeConfig, 'uploadThemeConfig', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(uploadProfileImage, 'uploadProfileImage', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(uploadLogo, 'uploadLogo', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/fileManager.js');
}();

;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Switch = __webpack_require__(837);

var _Switch2 = _interopRequireDefault(_Switch);

var _reactRedux = __webpack_require__(30);

var _reactRouterDom = __webpack_require__(39);

var _index = __webpack_require__(548);

var _index2 = __webpack_require__(1927);

var _index3 = _interopRequireDefault(_index2);

var _heartbeatList = __webpack_require__(1939);

var _heartbeatList2 = _interopRequireDefault(_heartbeatList);

var _reactSortableHoc = __webpack_require__(424);

var _ThemeColors = __webpack_require__(223);

var _materialUi = __webpack_require__(1940);

var _reactBootstrapSweetalert = __webpack_require__(427);

var _reactBootstrapSweetalert2 = _interopRequireDefault(_reactBootstrapSweetalert);

var _index4 = __webpack_require__(222);

var _reduxPersist = __webpack_require__(226);

var _userManager = __webpack_require__(117);

var _awsManager = __webpack_require__(59);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

var _CircularIndeterminate = __webpack_require__(386);

var _reactNotifications = __webpack_require__(78);

var _util = __webpack_require__(77);

var _fileManager = __webpack_require__(835);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var LayoutInfo = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
    var layoutInfo = _ref.layoutInfo;

    return _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'row mx-0' }, layoutInfo.map(function (contact, index) {
        return _react2.default.createElement(_index3.default, { key: index, index: index, contact: contact });
    })));
});

var SetThemeColor = function (_React$Component) {
    _inherits(SetThemeColor, _React$Component);

    _createClass(SetThemeColor, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.symbioticReducer.hasOwnProperty('layoutHeartbeat')) {
                this.setState({ layoutInfo: nextProps.symbioticReducer.layoutHeartbeat });
            }
            if (this.state.isMARight !== nextProps.symbioticReducer.isMARight) {
                this.setState({ isMARight: nextProps.symbioticReducer.isMARight });
            }
            if (nextProps.symbioticReducer.deviceId !== this.state.deviceId) {
                this.setState({
                    deviceId: nextProps.symbioticReducer.deviceId
                });
            }
        }
    }]);

    function SetThemeColor(props) {
        _classCallCheck(this, SetThemeColor);

        var _this = _possibleConstructorReturn(this, (SetThemeColor.__proto__ || Object.getPrototypeOf(SetThemeColor)).call(this, props));

        _this.mapLatLongToStates = function (latLong) {
            var self = _this;
            return new Promise(function (resolve, reject) {
                $.getJSON(CONST.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART + latLong + CONST.MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART, function (data) {
                    if (data.results.length !== 0) {
                        switch (data.results[0].address_components[0].short_name) {
                            case 'NSW':
                                self.setState({ NSWCount: self.state.NSWCount + 1 });
                                break;
                            case 'SA':
                                self.setState({ SACount: self.state.SACount + 1 });
                                break;
                            case 'WA':
                                self.setState({ WACount: self.state.WACount + 1 });
                                break;
                            case 'NT':
                                self.setState({ NTCount: self.state.NTCount + 1 });
                                break;
                            case 'QLD':
                                self.setState({ QLDCount: self.state.QLDCount + 1 });
                                break;
                            case 'VI':
                                self.setState({ VICount: self.state.VICount + 1 });
                                break;
                            case 'TA':
                                self.setState({ TACount: self.state.TACount + 1 });
                                break;
                        }

                        resolve(data.results[0].address_components[0].short_name);
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    reject(errorThrown);
                });
                // }
            });
        };

        _this.onSortEnd = function (_ref2) {
            var oldIndex = _ref2.oldIndex,
                newIndex = _ref2.newIndex;

            _this.setState({
                layoutInfo: (0, _reactSortableHoc.arrayMove)(_this.state.layoutInfo, oldIndex, newIndex)
            });
        };

        _this.handleThemeColor = function (colorCode) {
            _this.props.setThemeColor(colorCode);
            var body = $('#body');
            body.removeClass(_this.props.themeColor);
            body.removeClass('dark-theme');
            body.addClass(colorCode);
            _this.setDefaultThemeColor(colorCode);
            _this.setState({ setGroupThemeColor: colorCode });
        };

        _this.handleDarkTheme = function () {
            _this.props.setDarkTheme();
            var body = $('#body');
            body.toggleClass(_this.props.themeColor);
            body.toggleClass('dark-theme');
            _this.setDefaultThemeColor('dark-theme');
            _this.setState({ setGroupThemeColor: 'dark-theme' });
        };

        _this.setDefaultThemeColor = function () {
            // initialSettings.themeColor = colorCode;
        };

        _this.resetLayout = function () {
            _this.setState({
                layoutInfo: _heartbeatList2.default
            });
        };

        _this.updateGroupName = function () {

            var self = _this;

            var content = JSON.stringify({
                theme: {
                    name: _this.state.setGroupThemeColor
                }
            });
            (0, _awsManager.updateThemeConfiguration)(CONST.USER_POOL_ID, content, null).then(function () {
                self.showSuccessAndSignoutPopup();
            });
        };

        _this.updateLayout = function () {

            var self = _this;

            var content = JSON.stringify({
                heartbeatData: _this.state.layoutInfo,
                maPosition: _this.state.isMARight
            });
            (0, _awsManager.updateThemeConfiguration)(CONST.USER_POOL_ID, null, content).then(function () {
                self.showSuccessAndSignoutPopup();
            });
        };

        _this.changeMAPosition = function () {
            if (_this.state.isMARight) {
                _this.setState({
                    isMARight: false
                });
            } else {
                _this.setState({
                    isMARight: true
                });
            }
        };

        _this.signUserOutInnerFunctionality = function () {

            _this.props.signOut();
            _this.props.setDefaultTheme();
            var body = $('#body');
            body.removeClass();
            body.addClass(_this.props.themeColor);
            (0, _reduxPersist.purgeStoredState)(_index4.persistConfig);
        };

        _this.signUserOut = function () {
            (0, _userManager.signOut)().then(function () {
                _this.setState({
                    isSignOutAlertShown: false,
                    signoutTimeLeft: 10
                });
                clearInterval(_this.signOutInterval);
                clearTimeout(_this.signOutTimeout);
                _this.signUserOutInnerFunctionality();
            }, function () {
                clearInterval(_this.signOutInterval);
                clearTimeout(_this.signOutTimeout);
                _this.signUserOutInnerFunctionality();
            });
        };

        _this.onCancelClick = function () {
            clearTimeout(_this.signOutTimeout);
            clearInterval(_this.signOutInterval);
            _this.setState({
                isSignOutAlertShown: false
            });
            _this.setState({
                signoutTimeLeft: 10
            });
        };

        _this.getAllDevices = function () {
            var self = _this;
            (0, _awsManager.requestStateWiseDevices)(CONST.STATEWISE_DEVICES_TABLE_NAME).then(function (data) {
                self.deviceCount = parseInt(data.Items[0].NSW) + parseInt(data.Items[0].WA) + parseInt(data.Items[0].QLD) + parseInt(data.Items[0].NT) + parseInt(data.Items[0].SA) + parseInt(data.Items[0].VI) + parseInt(data.Items[0].TA);
                self.setStateNumberOfDevice();
            }, function () {});
        };

        _this.setStateNumberOfDevice = function () {
            _this.setState({
                numberOfDevices: _this.deviceCount
            });
        };

        _this.calculateNumberOfDevices = function () {
            var self = _this;
            var latLong = void 0;
            var stateShortName = void 0;
            (0, _awsManager.requestAustraliaLocations)(CONST.AUSTRALIA_LOCATIONS_TABLE_NAME).then(function (data) {
                for (var i = 0; i < data.Count; i++) {
                    latLong = data.Items[i].location;
                    stateShortName = self.mapLatLongToStates(latLong).then(function () {}, function () {});
                }
            });
        };

        _this.updateStateWiseDeviceTable = function () {
            var self = _this;
            (0, _awsManager.updateDeviceCount)(CONST.STATEWISE_DEVICES_TABLE_NAME, self.state.NSWCount, self.state.WACount, self.state.NTCount, self.state.QLDCount, self.state.SACount, self.state.VICount, self.state.TACount).then(function () {
                (0, _util.createNotification)('Devices updated successfully', '', 'Success');
                self.getAllDevices();
            });
        };

        _this.UploadLogoAndUpdateLink = function () {
            var self = _this;
            var fileChooser = document.getElementById('file-chooser');

            if (fileChooser.files.length > 0) {
                var imageNameAndExtension = fileChooser.files[0].name.split('.');
                var imageExtension = fileChooser.files[0].name.split('.').pop().toLowerCase();
                var imageName = imageNameAndExtension[0].toLowerCase();
                (0, _fileManager.uploadLogo)(fileChooser, imageName + '.' + imageExtension).then(function () {
                    var linkInString = JSON.stringify({
                        link: self.state.link
                    });
                    var linkToLogo = self.imageUrl = 'http://' + CONST.BUCKET_NAME + '.s3.amazonaws.com/logos/' + imageName + '.' + imageExtension;
                    (0, _awsManager.updateThemeConfiguration)(CONST.USER_POOL_ID, null, null, linkInString, linkToLogo).then(function () {
                        self.showSuccessAndSignoutPopup();
                    });
                }, function (err) {
                    (0, _util.createNotification)(err.message, 'Error', 'Error');
                });
            } else if (fileChooser.files.length === 0) {
                var linkInString = JSON.stringify({
                    link: self.state.link
                });
                (0, _awsManager.updateThemeConfiguration)(CONST.USER_POOL_ID, null, null, linkInString).then(function () {
                    self.showSuccessAndSignoutPopup();
                });
            }
        };

        _this.showSuccessAndSignoutPopup = function () {
            _this.setState({
                isSignOutAlertShown: true
            });
            _this.signOutTimeout = setTimeout(function () {
                _this.signUserOut();
            }, 10000);
            _this.signOutInterval = setInterval(function () {
                _this.setState({
                    signoutTimeLeft: _this.state.signoutTimeLeft - 1
                });
            }, 1000);
        };

        _this.onLinkTextChange = function (e) {
            _this.setState({
                link: e.target.value
            });
        };

        _this.state = {
            drawerStatus: false,
            setGroupThemeColor: '',
            layoutInfo: _heartbeatList2.default,
            isMARight: true,
            isSignOutAlertShown: false,
            signoutTimeLeft: 10,
            numberOfDevices: 0,
            WACount: 0,
            NTCount: 0,
            QLDCount: 0,
            SACount: 0,
            NSWCount: 0,
            VICount: 0,
            TACount: 0,

            link: _this.props.symbioticReducer.linkOfLogo,
            deviceId: _this.props.symbioticReducer.deviceId
        };
        _this.getAllDevices();
        return _this;
    }

    _createClass(SetThemeColor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            $('#body').addClass(this.props.themeColor);
            $('.theme_color').slimscroll({
                height: '100%'
            });
            this.calculateNumberOfDevices();
        }

        // toggleLightDarkThemeColors() {
        //     $('#lightThemeColor').toggleClass('d-none');
        //     $('#darkThemeColor').toggleClass('d-none');
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                themeColor = _props.themeColor,
                darkTheme = _props.darkTheme;

            // console.log("Theme color and dark theme", themeColor, darkTheme);

            var layoutInfo = this.state.layoutInfo;

            return _react2.default.createElement('div', { className: 'row', id: 'adminPanel' }, _react2.default.createElement(_reactNotifications.NotificationContainer, null), _react2.default.createElement(_reactBootstrapSweetalert2.default, {
                show: this.state.isSignOutAlertShown,
                style: { color: 'black' },
                showCancel: true,
                confirmBtnBsStyle: 'primary',
                cancelBtnBsStyle: 'primary',
                title: 'Your changes have been saved. Sign out is required for the changes to reflect. You will automatically be signed out in ' + this.state.signoutTimeLeft + ' seconds for the changes to apply!',
                cancelBtnText: 'Cancel',
                confirmBtnText: 'SignOut Now',
                onCancel: this.onCancelClick,
                onConfirm: this.signUserOut
            }, 'Click cancel if you want to sign out later.'), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'page-heading d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Set Theme Color'))), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-2 pt-3 pl-4' }, _react2.default.createElement('h3', null, 'Light Sidenav')), _react2.default.createElement('div', { className: 'col-10 pl-5' }, _react2.default.createElement('div', { id: 'lightThemeColor' }, _react2.default.createElement('ul', { className: 'color-option' }, _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.INDIGO),
                className: 'bg-indigo ' + (themeColor === _ThemeColors.INDIGO && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.CYAN),
                className: 'bg-cyan ' + (themeColor === _ThemeColors.CYAN && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.AMBER),
                className: 'bg-amber ' + (themeColor === _ThemeColors.AMBER && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DEEP_ORANGE),
                className: 'bg-deep-orange ' + (themeColor === _ThemeColors.DEEP_ORANGE && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.PINK),
                className: 'bg-pink ' + (themeColor === _ThemeColors.PINK && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.BLUE),
                className: 'bg-blue ' + (themeColor === _ThemeColors.BLUE && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DEEP_PURPLE),
                className: 'bg-deep-purple ' + (themeColor === _ThemeColors.DEEP_PURPLE && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.GREEN),
                className: 'bg-green ' + (themeColor === _ThemeColors.GREEN && 'active')
            })))))), _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-2 pt-3 pl-4' }, _react2.default.createElement('h3', null, 'Dark Sidenav')), _react2.default.createElement('div', { className: 'col-10 pl-5' }, _react2.default.createElement('div', { id: 'darkThemeColor' }, _react2.default.createElement('ul', { className: 'color-option cr-op-dark-sidebar' }, _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_INDIGO),
                className: 'bg-indigo ' + (themeColor === _ThemeColors.DARK_INDIGO && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_CYAN),
                className: 'bg-cyan ' + (themeColor === _ThemeColors.DARK_CYAN && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_AMBER),
                className: 'bg-amber ' + (themeColor === _ThemeColors.DARK_AMBER && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_DEEP_ORANGE),
                className: 'bg-deep-orange ' + (themeColor === _ThemeColors.DARK_DEEP_ORANGE && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_PINK),
                className: 'bg-pink ' + (themeColor === _ThemeColors.DARK_PINK && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_BLUE),
                className: 'bg-blue ' + (themeColor === _ThemeColors.DARK_BLUE && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_DEEP_PURPLE),
                className: 'bg-deep-purple ' + (themeColor === _ThemeColors.DARK_DEEP_PURPLE && 'active')
            })), _react2.default.createElement('li', null, _react2.default.createElement('a', {
                href: 'javascript:void(0)',
                onClick: this.handleThemeColor.bind(this, _ThemeColors.DARK_GREEN),
                className: 'bg-green ' + (themeColor === _ThemeColors.DARK_GREEN && 'active')
            })), _react2.default.createElement('div', { className: 'mt-4' }, _react2.default.createElement('h3', { className: 'mb-1 pl-1' }, 'Dark Theme'), _react2.default.createElement(_Switch2.default, {
                color: 'primary',
                checked: darkTheme,
                onChange: this.handleDarkTheme
            })))), _react2.default.createElement('div', { className: 'mt-4' }, _react2.default.createElement(_materialUi.Button, {
                variant: 'raised',
                className: 'jr-btn bg-primary text-white',
                onClick: this.updateGroupName
            }, ' Update Theme Color'))))), _react2.default.createElement('div', { className: 'col-12 my-5' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-lg-2 col-md-12 pt-3 pl-4' }, _react2.default.createElement('h3', null, 'Edit Layout')), _react2.default.createElement('div', { className: 'col-lg-10 col-md-12 pl-lg-5' }, _react2.default.createElement('div', { className: 'animated slideInUpTiny animation-duration-3' }, _react2.default.createElement(LayoutInfo, {
                layoutInfo: layoutInfo,
                axis: 'xy',
                onSortEnd: this.onSortEnd,
                useDragHandle: true
            })), _react2.default.createElement('div', null, _react2.default.createElement('h3', { className: 'mb-1 pl-1 mt-4' }, 'Movement & Accelaration'), _react2.default.createElement('img', { className: 'pr-2 pb-1', src: 'assets/images/maOnLeft.svg', style: { width: '50px' } }), 'Left', _react2.default.createElement(_Switch2.default, {
                color: 'primary',
                checked: this.state.isMARight,
                onChange: this.changeMAPosition
            }), 'Right', _react2.default.createElement('img', { className: 'pl-2 pb-1', src: 'assets/images/maOnRight.svg', style: { width: '50px' } })), _react2.default.createElement('div', { className: 'mt-4' }, _react2.default.createElement(_materialUi.Button, {
                variant: 'raised',
                className: 'jr-btn bg-primary text-white',
                onClick: this.updateLayout
            }, 'Save Layout'), _react2.default.createElement(_materialUi.Button, {
                onClick: this.resetLayout,
                variant: 'raised',
                className: 'jr-btn bg-primary text-white'
            }, 'Reset Layout')))), _react2.default.createElement('div', { className: 'row my-3' }, _react2.default.createElement('div', { className: 'col-lg-2 col-md-12 pt-3 pl-4' }, _react2.default.createElement('h3', null, 'Device Details')), _react2.default.createElement('div', { className: 'col-lg-10 col-md-12 pl-lg-5 mt-3' }, _react2.default.createElement('p', null, 'Total number of devices placed are'), this.state.numberOfDevices || _react2.default.createElement('div', { className: '' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate2, null)), _react2.default.createElement('div', { className: 'mt-4' }, _react2.default.createElement(_materialUi.Button, {
                variant: 'raised',
                className: 'jr-btn bg-primary text-white',
                onClick: this.updateStateWiseDeviceTable
            }, 'Re-Calculate & Save')))), _react2.default.createElement('div', { className: 'row my-3' }, _react2.default.createElement('div', { className: 'col-lg-2 col-md-12 pt-3 pl-4' }, _react2.default.createElement('h3', null, 'Customise Logo')), _react2.default.createElement('div', { className: 'col-lg-10 col-md-12 pl-lg-5 mt-3' }, _react2.default.createElement('p', null, 'Upload Logo and Link'), _react2.default.createElement('div', null, _react2.default.createElement('input', { className: 'jr-btn bg-primary text-white', type: 'file', id: 'file-chooser' })), _react2.default.createElement('div', { className: 'mt-3' }, _react2.default.createElement('input', { placeholder: 'Enter Link', className: 'link-input-style', value: this.state.link,
                onChange: function onChange(e) {
                    _this2.onLinkTextChange(e);
                } })), _react2.default.createElement('div', { className: 'mt-3' }, _react2.default.createElement(_materialUi.Button, {
                variant: 'raised',
                className: 'jr-btn bg-primary text-white',
                onClick: this.UploadLogoAndUpdateLink
            }, 'Update logo and link'))))));
        }
    }]);

    return SetThemeColor;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref3) {
    var settings = _ref3.settings,
        symbioticReducer = _ref3.symbioticReducer;
    var themeColor = settings.themeColor,
        darkTheme = settings.darkTheme;

    return { themeColor: themeColor, darkTheme: darkTheme, symbioticReducer: symbioticReducer };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        signOut: function signOut() {
            dispatch({ type: 'SIGN_OUT' });
        },
        setDefaultTheme: function setDefaultTheme() {
            dispatch({ type: 'SET_DEFAULT_THEME' });
        },
        setThemeColor: function setThemeColor(colorCode) {
            dispatch((0, _index.setThemeColor)(colorCode));
        },
        setDarkTheme: function setDarkTheme() {
            dispatch((0, _index.setDarkTheme)());
        }
    };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SetThemeColor));

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(LayoutInfo, 'LayoutInfo', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js');

    __REACT_HOT_LOADER__.register(SetThemeColor, 'SetThemeColor', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_Switch2, "_Switch2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_index3, "_index3", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_heartbeatList2, "_heartbeatList2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert2, "_reactBootstrapSweetalert2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(LayoutInfo, "LayoutInfo", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(SetThemeColor, "SetThemeColor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/SetThemeColor.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(1926);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null && target.parentNode) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

/**
 * Listen for click events that are triggered outside of the component children.
 */

var ClickAwayListener = function (_React$Component) {
  (0, _inherits3.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.mounted) {
        var el = (0, _reactDom.findDOMNode)(_this);
        var doc = (0, _ownerDocument2.default)(el);

        if (doc.documentElement && doc.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactEventListener2.default,
        {
          target: 'document',
          onMouseup: this.handleClickAway,
          onTouchend: this.handleClickAway
        },
        this.props.children
      );
    }
  }]);
  return ClickAwayListener;
}(_react2.default.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  onClickAway: _propTypes2.default.func.isRequired
} : {};

exports.default = ClickAwayListener;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  }
};

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
function FormGroup(props) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      row = props.row,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'children', 'row']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.row, row), className)
    }, other),
    children
  );
}

FormGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes2.default.bool
} : {};

FormGroup.defaultProps = {
  row: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormGroup' })(FormGroup);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(417);

var _helpers = __webpack_require__(35);

var _reactHelpers = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      position: 'relative',
      // Reset fieldset default style
      minWidth: 0,
      padding: 0,
      margin: 0,
      border: 0
    },
    marginNormal: {
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit
    },
    marginDense: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit / 2
    },
    fullWidth: {
      width: '100%'
    }
  };
};

/**
 * Provides context such as dirty/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stay
 * consitent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */

var FormControl = function (_React$Component) {
  (0, _inherits3.default)(FormControl, _React$Component);

  function FormControl(props, context) {
    (0, _classCallCheck3.default)(this, FormControl);

    // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.
    var _this = (0, _possibleConstructorReturn3.default)(this, (FormControl.__proto__ || (0, _getPrototypeOf2.default)(FormControl)).call(this, props, context));

    _this.state = {
      adornedStart: false,
      dirty: false,
      focused: false
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState(function (state) {
        return !state.focused ? { focused: true } : null;
      });
    };

    _this.handleBlur = function (event) {
      // The event might be undefined.
      // For instance, a child component might call this hook
      // when an input is disabled but still having the focus.
      if (_this.props.onBlur && event) {
        _this.props.onBlur(event);
      }
      _this.setState(function (state) {
        return state.focused ? { focused: false } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.dirty) {
        _this.setState({ dirty: true });
      }
    };

    _this.handleClean = function () {
      if (_this.state.dirty) {
        _this.setState({ dirty: false });
      }
    };

    var children = _this.props.children;

    if (children) {
      _react2.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
          return;
        }

        if ((0, _Input.isDirty)(child.props, true)) {
          _this.state.dirty = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;

        if (input && (0, _Input.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }
    return _this;
  }

  (0, _createClass3.default)(FormControl, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          disabled = _props.disabled,
          error = _props.error,
          required = _props.required,
          margin = _props.margin;
      var _state = this.state,
          adornedStart = _state.adornedStart,
          dirty = _state.dirty,
          focused = _state.focused;


      return {
        muiFormControl: {
          adornedStart: adornedStart,
          dirty: dirty,
          disabled: disabled,
          error: error,
          focused: focused,
          margin: margin,
          required: required,
          onDirty: this.handleDirty,
          onClean: this.handleClean,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          classes = _props2.classes,
          className = _props2.className,
          Component = _props2.component,
          disabled = _props2.disabled,
          error = _props2.error,
          fullWidth = _props2.fullWidth,
          margin = _props2.margin,
          required = _props2.required,
          other = (0, _objectWithoutProperties3.default)(_props2, ['classes', 'className', 'component', 'disabled', 'error', 'fullWidth', 'margin', 'required']);


      return _react2.default.createElement(Component, (0, _extends3.default)({
        className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['margin' + (0, _helpers.capitalize)(margin)], margin !== 'none'), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other, {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }));
    }
  }]);
  return FormControl;
}(_react2.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool
} : {};

FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};

FormControl.childContextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControl' })(FormControl);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: theme.spacing.unit,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0
    },
    error: {
      color: theme.palette.error.main
    },
    disabled: {
      color: theme.palette.text.disabled
    },
    marginDense: {
      marginTop: theme.spacing.unit / 2
    }
  };
};

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disabledProp = props.disabled,
      errorProp = props.error,
      marginProp = props.margin,
      Component = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disabled', 'error', 'margin', 'component']);
  var muiFormControl = context.muiFormControl;


  var disabled = disabledProp;
  var error = errorProp;
  var margin = marginProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = muiFormControl.margin;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense'])
} : {};

FormHelperText.defaultProps = {
  component: 'p'
};

FormHelperText.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormHelperText' })(FormHelperText);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hidden = __webpack_require__(1974);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hidden).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(844);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Select).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectInput = __webpack_require__(1995);

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(282);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import to enforce the CSS injection order

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      width: '100%'
    },
    select: {
      '-moz-appearance': 'none', // Reset
      '-webkit-appearance': 'none', // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: theme.spacing.unit * 4,
      width: 'calc(100% - ' + theme.spacing.unit * 4 + 'px)',
      minWidth: theme.spacing.unit * 2, // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style
      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      }
    },
    selectMenu: {
      width: 'auto', // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height
    },
    disabled: {
      cursor: 'default'
    },
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)', // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.
    }
  };
}; // @inheritedComponent Input

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      other = (0, _objectWithoutProperties3.default)(props, ['autoWidth', 'children', 'classes', 'displayEmpty', 'input', 'inputProps', 'MenuProps', 'multiple', 'native', 'onClose', 'onOpen', 'open', 'renderValue', 'SelectDisplayProps']);


  return _react2.default.cloneElement(input, (0, _extends3.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _SelectInput2.default,
    inputProps: (0, _extends3.default)({
      autoWidth: autoWidth,
      children: children,
      classes: classes,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      native: native,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps,
      type: undefined }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes2.default.bool,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes2.default.element,
  /**
   * Properties applied to the `input` element.
   * When `native` is `true`, the properties are applied on the `select` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes2.default.bool,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback
   * @param {object} child The react element that was selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes2.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes2.default.func,
  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes2.default.object,
  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  input: _react2.default.createElement(_Input2.default, null),
  multiple: false,
  native: false
};

Select.muiName = 'Select';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSelect' })(Select);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _colorManipulator = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);

  return {
    root: (_root = {
      pointerEvents: 'initial',
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px ' + theme.spacing.unit * 3 + 'px'
    }, (0, _defineProperty3.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: 2
    }), (0, _defineProperty3.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),
    message: {
      padding: theme.spacing.unit + 'px 0'
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: theme.spacing.unit * 3,
      marginRight: -theme.spacing.unit
    }
  };
}; // @inheritedComponent Paper

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'classes', 'className', 'message']);


  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({
      component: _Typography2.default,
      headlineMapping: {
        body1: 'div'
      },
      role: 'alertdialog',
      square: true,
      elevation: 6,
      className: (0, _classnames2.default)(classes.root, className)
    }, other),
    _react2.default.createElement(
      'div',
      { className: classes.message },
      message
    ),
    action ? _react2.default.createElement(
      'div',
      { className: classes.action },
      action
    ) : null
  );
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The message to display.
   */
  message: _propTypes2.default.node
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSnackbarContent' })(SnackbarContent);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _StepIcon = __webpack_require__(847);

var _StepIcon2 = _interopRequireDefault(_StepIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    horizontal: {},
    vertical: {},
    alternativeLabel: {
      flexDirection: 'column'
    },
    disabled: {
      cursor: 'default'
    },
    label: {
      color: theme.palette.text.secondary
    },
    labelActive: {
      color: theme.palette.text.primary,
      fontWeight: 500
    },
    labelCompleted: {
      color: theme.palette.text.primary,
      fontWeight: 500
    },
    labelAlternativeLabel: {
      textAlign: 'center',
      marginTop: theme.spacing.unit * 2
    },
    iconContainer: {
      paddingRight: theme.spacing.unit
    },
    iconContainerAlternativeLabel: {
      paddingRight: 0
    },
    labelContainer: {
      width: '100%'
    }
  };
};

function StepLabel(props) {
  var _classNames, _classNames3;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'disabled', 'icon', 'last', 'optional', 'orientation']);


  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.alternativeLabel, alternativeLabel), _classNames), classNameProp)
    }, other),
    icon && _react2.default.createElement(
      'span',
      {
        className: (0, _classnames2.default)(classes.iconContainer, (0, _defineProperty3.default)({}, classes.iconContainerAlternativeLabel, alternativeLabel))
      },
      _react2.default.createElement(_StepIcon2.default, {
        completed: completed,
        active: active,
        icon: icon,
        alternativeLabel: alternativeLabel
      })
    ),
    _react2.default.createElement(
      'span',
      { className: classes.labelContainer },
      _react2.default.createElement(
        _Typography2.default,
        {
          variant: 'body1',
          component: 'span',
          className: (0, _classnames2.default)(classes.label, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.labelAlternativeLabel, alternativeLabel), (0, _defineProperty3.default)(_classNames3, classes.labelCompleted, completed), (0, _defineProperty3.default)(_classNames3, classes.labelActive, active), _classNames3))
        },
        children
      ),
      optional
    )
  );
}

StepLabel.propTypes =  false ? {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes2.default.node,
  /**
   * Custom styles for component.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the default icon.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * The optional node to display.
   */
  optional: _propTypes2.default.node,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

StepLabel.defaultProps = {
  active: false,
  alternativeLabel: false,
  completed: false,
  disabled: false,
  last: false,
  orientation: 'horizontal'
};

StepLabel.muiName = 'StepLabel';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepLabel' })(StepLabel);

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _CheckCircle = __webpack_require__(2003);

var _CheckCircle2 = _interopRequireDefault(_CheckCircle);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _StepPositionIcon = __webpack_require__(2004);

var _StepPositionIcon2 = _interopRequireDefault(_StepPositionIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$completed': {
        color: theme.palette.primary.main
      }
    },
    active: {},
    completed: {}
  };
};

function StepIcon(props) {
  var completed = props.completed,
      icon = props.icon,
      active = props.active,
      classes = props.classes;


  if (typeof icon === 'number' || typeof icon === 'string') {
    if (completed) {
      return _react2.default.createElement(_CheckCircle2.default, { className: (0, _classnames2.default)(classes.root, classes.completed) });
    }
    return _react2.default.createElement(_StepPositionIcon2.default, {
      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.active, active)),
      position: icon
    });
  }

  return icon;
}

StepIcon.propTypes =  false ? {
  /**
   * Whether this step is active.
   */
  active: _propTypes2.default.bool,
  /**
   * Classses for component style customizations.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes2.default.node.isRequired
} : {};

StepIcon.defaultProps = {
  active: false,
  completed: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepIcon' })(StepIcon);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

var _colorManipulator = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: '1px solid\n    ' + (theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
      textAlign: 'left',
      padding: theme.spacing.unit / 2 + 'px ' + theme.spacing.unit * 7 + 'px ' + theme.spacing.unit / 2 + 'px ' + theme.spacing.unit * 3 + 'px',
      '&:last-child': {
        paddingRight: theme.spacing.unit * 3
      }
    },
    head: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      position: 'relative' // Workaround for Tooltip positioning issue.
    },
    body: {
      fontSize: theme.typography.pxToRem(13),
      color: theme.palette.text.primary
    },
    footer: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents
    },
    paddingDense: {
      paddingRight: theme.spacing.unit * 3
    },
    paddingCheckbox: {
      padding: '0 12px'
    },
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    }
  };
};

function TableCell(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      numeric = props.numeric,
      padding = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'sortDirection', 'numeric', 'padding', 'scope', 'variant']);
  var table = context.table;

  var Component = void 0;
  if (component) {
    Component = component;
  } else {
    Component = table && table.head ? 'th' : 'td';
  }

  var scope = scopeProp;
  if (!scope && table && table.head) {
    scope = 'col';
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.head, variant ? variant === 'head' : table && table.head), (0, _defineProperty3.default)(_classNames, classes.body, variant ? variant === 'body' : table && table.body), (0, _defineProperty3.default)(_classNames, classes.footer, variant ? variant === 'footer' : table && table.footer), (0, _defineProperty3.default)(_classNames, classes.numeric, numeric), (0, _defineProperty3.default)(_classNames, classes['padding' + (0, _helpers.capitalize)(padding)], padding !== 'default'), _classNames), classNameProp);

  var ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className, 'aria-sort': ariaSort, scope: scope }, other),
    children
  );
}

TableCell.propTypes =  false ? {
  /**
   * The table cell contents.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, content will align to the right.
   */
  numeric: _propTypes2.default.bool,
  /**
   * Sets the padding applied to the cell.
   */
  padding: _propTypes2.default.oneOf(['default', 'checkbox', 'dense', 'none']),
  /**
   * Set scope attribute.
   */
  scope: _propTypes2.default.string,
  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes2.default.oneOf(['asc', 'desc', false]),
  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes2.default.oneOf(['head', 'body', 'footer'])
} : {};

TableCell.defaultProps = {
  numeric: false,
  padding: 'default'
};

TableCell.contextTypes = {
  table: _propTypes2.default.object.isRequired
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableCell' })(TableCell);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' });

var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
KeyboardArrowLeft = (0, _pure2.default)(KeyboardArrowLeft);
KeyboardArrowLeft.muiName = 'SvgIcon';

exports.default = KeyboardArrowLeft;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' });

var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
KeyboardArrowRight = (0, _pure2.default)(KeyboardArrowRight);
KeyboardArrowRight.muiName = 'SvgIcon';

exports.default = KeyboardArrowRight;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextRow = (_temp = _class = function (_React$Component) {
  _inherits(TextRow, _React$Component);

  function TextRow() {
    _classCallCheck(this, TextRow);

    return _possibleConstructorReturn(this, (TextRow.__proto__ || Object.getPrototypeOf(TextRow)).apply(this, arguments));
  }

  _createClass(TextRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          maxHeight = _props.maxHeight,
          color = _props.color,
          lineSpacing = _props.lineSpacing,
          style = _props.style;


      var defaultStyles = {
        maxHeight: maxHeight,
        width: '100%',
        height: '1em',
        backgroundColor: color,
        marginTop: lineSpacing
      };

      var classes = ['text-row', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement('div', {
        className: classes,
        style: _extends({}, defaultStyles, style)
      });
    }
  }]);

  return TextRow;
}(_react2.default.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  lineSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
}, _class.defaultProps = {
  lineSpacing: '0.7em'
}, _temp);
exports.default = TextRow;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoundShape = (_temp = _class = function (_React$Component) {
  _inherits(RoundShape, _React$Component);

  function RoundShape() {
    _classCallCheck(this, RoundShape);

    return _possibleConstructorReturn(this, (RoundShape.__proto__ || Object.getPrototypeOf(RoundShape)).apply(this, arguments));
  }

  _createClass(RoundShape, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color;


      var defaultStyles = {
        backgroundColor: color,
        borderRadius: '500rem',
        width: '100%',
        height: '100%'
      };

      var classes = ['round-shape', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement('div', { className: classes, style: _extends({}, defaultStyles, style) });
    }
  }]);

  return RoundShape;
}(_react2.default.Component), _class.propTypes = {
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
}, _temp);
exports.default = RoundShape;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextRow = __webpack_require__(851);

var _TextRow2 = _interopRequireDefault(_TextRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlock = (_temp2 = _class = function (_React$Component) {
  _inherits(TextBlock, _React$Component);

  function TextBlock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextBlock.__proto__ || Object.getPrototypeOf(TextBlock)).call.apply(_ref, [this].concat(args))), _this), _this.getRowStyle = function (i) {
      var _this$props = _this.props,
          rows = _this$props.rows,
          color = _this$props.color,
          widths = _this$props.widths;


      return {
        backgroundColor: color,
        maxHeight: 100 / (rows * 2 - 1) + '%',
        width: widths[(i + widths.length) % widths.length] + '%'
      };
    }, _this.getRows = function () {
      var _this$props2 = _this.props,
          rows = _this$props2.rows,
          lineSpacing = _this$props2.lineSpacing;

      var range = [].concat(_toConsumableArray(Array(rows)));
      return range.map(function (x, i) {
        return _react2.default.createElement(_TextRow2.default, {
          style: _this.getRowStyle(i),
          lineSpacing: i !== 0 ? lineSpacing : 0,
          key: i
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className;


      var classes = ['text-block', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement(
        'div',
        { className: classes, style: _extends({}, style, { width: '100%' }) },
        this.getRows()
      );
    }
  }]);

  return TextBlock;
}(_react2.default.Component), _class.propTypes = {
  rows: _propTypes2.default.number.isRequired,
  color: _propTypes2.default.string.isRequired,
  lineSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  widths: _propTypes2.default.arrayOf(_propTypes2.default.number),
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  widths: [97, 100, 94, 90, 98, 95, 98, 40]
}, _temp2);
exports.default = TextBlock;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(1547)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(1575)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(1576)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(1642)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(1643)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(1644)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(1645)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(1646)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(1647)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(1648)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(1654)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(1655)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(1656)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(1657)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(1658)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(1659)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(1660)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(288);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(435),
    baseAssignValue = __webpack_require__(436);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1618),
    Map = __webpack_require__(383),
    Promise = __webpack_require__(1619),
    Set = __webpack_require__(909),
    WeakMap = __webpack_require__(615),
    baseGetTag = __webpack_require__(169),
    toSource = __webpack_require__(611);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(866),
    baseOrderBy = __webpack_require__(1933),
    baseRest = __webpack_require__(204),
    isIterateeCall = __webpack_require__(420);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.8
 *
 */
(function(e){e.fn.extend({slimScroll:function(f){var a=e.extend({width:"auto",height:"250px",size:"7px",color:"#000",position:"right",distance:"1px",start:"top",opacity:.4,alwaysVisible:!1,disableFadeOut:!1,railVisible:!1,railColor:"#333",railOpacity:.2,railDraggable:!0,railClass:"slimScrollRail",barClass:"slimScrollBar",wrapperClass:"slimScrollDiv",allowPageScroll:!1,wheelStep:20,touchScrollStep:200,borderRadius:"7px",railBorderRadius:"7px"},f);this.each(function(){function v(d){if(r){d=d||window.event;
var c=0;d.wheelDelta&&(c=-d.wheelDelta/120);d.detail&&(c=d.detail/3);e(d.target||d.srcTarget||d.srcElement).closest("."+a.wrapperClass).is(b.parent())&&n(c,!0);d.preventDefault&&!k&&d.preventDefault();k||(d.returnValue=!1)}}function n(d,g,e){k=!1;var f=b.outerHeight()-c.outerHeight();g&&(g=parseInt(c.css("top"))+d*parseInt(a.wheelStep)/100*c.outerHeight(),g=Math.min(Math.max(g,0),f),g=0<d?Math.ceil(g):Math.floor(g),c.css({top:g+"px"}));l=parseInt(c.css("top"))/(b.outerHeight()-c.outerHeight());g=
l*(b[0].scrollHeight-b.outerHeight());e&&(g=d,d=g/b[0].scrollHeight*b.outerHeight(),d=Math.min(Math.max(d,0),f),c.css({top:d+"px"}));b.scrollTop(g);b.trigger("slimscrolling",~~g);w();p()}function x(){u=Math.max(b.outerHeight()/b[0].scrollHeight*b.outerHeight(),30);c.css({height:u+"px"});var a=u==b.outerHeight()?"none":"block";c.css({display:a})}function w(){x();clearTimeout(B);l==~~l?(k=a.allowPageScroll,C!=l&&b.trigger("slimscroll",0==~~l?"top":"bottom")):k=!1;C=l;u>=b.outerHeight()?k=!0:(c.stop(!0,
!0).fadeIn("fast"),a.railVisible&&m.stop(!0,!0).fadeIn("fast"))}function p(){a.alwaysVisible||(B=setTimeout(function(){a.disableFadeOut&&r||y||z||(c.fadeOut("slow"),m.fadeOut("slow"))},1E3))}var r,y,z,B,A,u,l,C,k=!1,b=e(this);if(b.parent().hasClass(a.wrapperClass)){var q=b.scrollTop(),c=b.siblings("."+a.barClass),m=b.siblings("."+a.railClass);x();if(e.isPlainObject(f)){if("height"in f&&"auto"==f.height){b.parent().css("height","auto");b.css("height","auto");var h=b.parent().parent().height();b.parent().css("height",
h);b.css("height",h)}else"height"in f&&(h=f.height,b.parent().css("height",h),b.css("height",h));if("scrollTo"in f)q=parseInt(a.scrollTo);else if("scrollBy"in f)q+=parseInt(a.scrollBy);else if("destroy"in f){c.remove();m.remove();b.unwrap();return}n(q,!1,!0)}}else if(!(e.isPlainObject(f)&&"destroy"in f)){a.height="auto"==a.height?b.parent().height():a.height;q=e("<div></div>").addClass(a.wrapperClass).css({position:"relative",overflow:"hidden",width:a.width,height:a.height});b.css({overflow:"hidden",
width:a.width,height:a.height});var m=e("<div></div>").addClass(a.railClass).css({width:a.size,height:"100%",position:"absolute",top:0,display:a.alwaysVisible&&a.railVisible?"block":"none","border-radius":a.railBorderRadius,background:a.railColor,opacity:a.railOpacity,zIndex:90}),c=e("<div></div>").addClass(a.barClass).css({background:a.color,width:a.size,position:"absolute",top:0,opacity:a.opacity,display:a.alwaysVisible?"block":"none","border-radius":a.borderRadius,BorderRadius:a.borderRadius,MozBorderRadius:a.borderRadius,
WebkitBorderRadius:a.borderRadius,zIndex:99}),h="right"==a.position?{right:a.distance}:{left:a.distance};m.css(h);c.css(h);b.wrap(q);b.parent().append(c);b.parent().append(m);a.railDraggable&&c.bind("mousedown",function(a){var b=e(document);z=!0;t=parseFloat(c.css("top"));pageY=a.pageY;b.bind("mousemove.slimscroll",function(a){currTop=t+a.pageY-pageY;c.css("top",currTop);n(0,c.position().top,!1)});b.bind("mouseup.slimscroll",function(a){z=!1;p();b.unbind(".slimscroll")});return!1}).bind("selectstart.slimscroll",
function(a){a.stopPropagation();a.preventDefault();return!1});m.hover(function(){w()},function(){p()});c.hover(function(){y=!0},function(){y=!1});b.hover(function(){r=!0;w();p()},function(){r=!1;p()});b.bind("touchstart",function(a,b){a.originalEvent.touches.length&&(A=a.originalEvent.touches[0].pageY)});b.bind("touchmove",function(b){k||b.originalEvent.preventDefault();b.originalEvent.touches.length&&(n((A-b.originalEvent.touches[0].pageY)/a.touchScrollStep,!0),A=b.originalEvent.touches[0].pageY)});
x();"bottom"===a.start?(c.css({top:b.outerHeight()-c.outerHeight()}),n(0,!0)):"top"!==a.start&&(n(e(a.start).position().top,null,!0),a.alwaysVisible||c.hide());window.addEventListener?(this.addEventListener("DOMMouseScroll",v,!1),this.addEventListener("mousewheel",v,!1)):document.attachEvent("onmousewheel",v)}});return this}});e.fn.extend({slimscroll:e.fn.slimScroll})})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1566);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(560);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(384),
    setCacheAdd = __webpack_require__(1613),
    setCacheHas = __webpack_require__(1614);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(907),
    stubArray = __webpack_require__(908);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(434),
    isFlattenable = __webpack_require__(1932);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Snackbar = __webpack_require__(1997);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Snackbar).default;
  }
});

var _SnackbarContent = __webpack_require__(845);

Object.defineProperty(exports, 'SnackbarContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SnackbarContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var has = __webpack_require__(61);
var cof = __webpack_require__(70);
var inheritIfRequired = __webpack_require__(296);
var toPrimitive = __webpack_require__(79);
var fails = __webpack_require__(23);
var gOPN = __webpack_require__(124).f;
var gOPD = __webpack_require__(63).f;
var dP = __webpack_require__(36).f;
var $trim = __webpack_require__(151).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(123)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(34) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(54)(global, NUMBER, $Number);
}


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toInteger = __webpack_require__(71);
var aNumberValue = __webpack_require__(448);
var repeat = __webpack_require__(297);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(23)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $fails = __webpack_require__(23);
var aNumberValue = __webpack_require__(448);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(3);
var _isFinite = __webpack_require__(20).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', { isInteger: __webpack_require__(449) });


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(3);
var isInteger = __webpack_require__(449);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(447);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(446);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3);
var log1p = __webpack_require__(450);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3);
var sign = __webpack_require__(298);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3);
var $expm1 = __webpack_require__(299);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { fround: __webpack_require__(451) });


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(23)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { log1p: __webpack_require__(450) });


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { sign: __webpack_require__(298) });


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(299);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(23)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(299);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(377);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(360);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1579),
    keys = __webpack_require__(170);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1581),
    isArguments = __webpack_require__(381),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(431),
    isIndex = __webpack_require__(251),
    isTypedArray = __webpack_require__(627);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 902 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(49);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(906),
    getSymbols = __webpack_require__(865),
    keys = __webpack_require__(170);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(434),
    isArray = __webpack_require__(51);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 907 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 908 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141),
    root = __webpack_require__(49);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.MarkerClusterer = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _MarkerClusterer$chil

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _markerClustererPlus = __webpack_require__(1661)

var _markerClustererPlus2 = _interopRequireDefault(_markerClustererPlus)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `MarkerClusterer`
 *
 * @see https://github.com/mahnunchik/markerclustererplus/blob/master/docs/reference.html
 */
var MarkerClusterer = (exports.MarkerClusterer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(MarkerClusterer, _React$PureComponent)

  /*
   * @see https://github.com/mahnunchik/markerclustererplus/blob/master/docs/reference.html
   */
  function MarkerClusterer(props, context) {
    ;(0, _classCallCheck3.default)(this, MarkerClusterer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        MarkerClusterer.__proto__ ||
        (0, _getPrototypeOf2.default)(MarkerClusterer)
      ).call(this, props, context)
    )

    var markerClusterer = new _markerClustererPlus2.default()
    ;(0, _MapChildHelper.construct)(
      MarkerClusterer.propTypes,
      updaterMap,
      _this.props,
      markerClusterer
    )
    markerClusterer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.MARKER_CLUSTERER,
      markerClusterer
    )
    return _this
  }

  ;(0, _createClass3.default)(MarkerClusterer, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        var _ref

        var markerClusterer = this.state[_constants.MARKER_CLUSTERER]
        return (
          (_ref = {}),
          (0, _defineProperty3.default)(
            _ref,
            _constants.ANCHOR,
            markerClusterer
          ),
          (0, _defineProperty3.default)(
            _ref,
            _constants.MARKER_CLUSTERER,
            markerClusterer
          ),
          _ref
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER_CLUSTERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER_CLUSTERER],
          eventMap,
          updaterMap,
          prevProps
        )
        this.state[_constants.MARKER_CLUSTERER].repaint()
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var markerClusterer = this.state[_constants.MARKER_CLUSTERER]
        if (markerClusterer) {
          markerClusterer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },
    },
  ])
  return MarkerClusterer
})(_react2.default.PureComponent))

MarkerClusterer.propTypes = {
  /**
   * @type boolean
   */
  defaultAverageCenter: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultBatchSizeIE: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultBatchSize: _propTypes2.default.number,

  /**
   * @type function
   */
  defaultCalculator: _propTypes2.default.func,

  /**
   * @type string
   */
  defaultClusterClass: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultEnableRetinaIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultGridSize: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultIgnoreHidden: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultImageExtension: _propTypes2.default.string,

  /**
   * @type string
   */
  defaultImagePath: _propTypes2.default.string,

  /**
   * @type Array
   */
  defaultImageSizes: _propTypes2.default.array,

  /**
   * @type number
   */
  defaultMaxZoom: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultMinimumClusterSize: _propTypes2.default.number,

  /**
   * @type Array
   */
  defaultStyles: _propTypes2.default.array,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultZoomOnClick: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  averageCenter: _propTypes2.default.bool,

  /**
   * @type number
   */
  batchSizeIE: _propTypes2.default.number,

  /**
   * @type number
   */
  batchSize: _propTypes2.default.number,

  /**
   * @type function
   */
  calculator: _propTypes2.default.func,

  /**
   * @type string
   */
  clusterClass: _propTypes2.default.string,

  /**
   * @type boolean
   */
  enableRetinaIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  gridSize: _propTypes2.default.number,

  /**
   * @type boolean
   */
  ignoreHidden: _propTypes2.default.bool,

  /**
   * @type string
   */
  imageExtension: _propTypes2.default.string,

  /**
   * @type string
   */
  imagePath: _propTypes2.default.string,

  /**
   * @type Array
   */
  imageSizes: _propTypes2.default.array,

  /**
   * @type number
   */
  maxZoom: _propTypes2.default.number,

  /**
   * @type number
   */
  minimumClusterSize: _propTypes2.default.number,

  /**
   * @type Array
   */
  styles: _propTypes2.default.array,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  zoomOnClick: _propTypes2.default.bool,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClusteringBegin: _propTypes2.default.func,

  /**
   * function
   */
  onClusteringEnd: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,
}
MarkerClusterer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
MarkerClusterer.childContextTypes = ((_MarkerClusterer$chil = {}),
(0, _defineProperty3.default)(
  _MarkerClusterer$chil,
  _constants.ANCHOR,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _MarkerClusterer$chil,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_MarkerClusterer$chil)
exports.default = MarkerClusterer

var eventMap = {
  onClick: "click",
  onClusteringBegin: "clusteringbegin",
  onClusteringEnd: "clusteringend",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
}

var updaterMap = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter)
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE)
  },
  batchSize: function batchSize(instance, _batchSize) {
    instance.setBatchSize(_batchSize)
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator)
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass)
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons)
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize)
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden)
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension)
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath)
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes)
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom)
  },
  minimumClusterSize: function minimumClusterSize(
    instance,
    _minimumClusterSize
  ) {
    instance.setMinimumClusterSize(_minimumClusterSize)
  },
  styles: function styles(instance, _styles) {
    instance.setStyles(_styles)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick)
  },
}


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1930),
    findIndex = __webpack_require__(1931);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(285),
    isArrayLike = __webpack_require__(148);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(915);
module.exports = __webpack_require__(1088);


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(916);

__webpack_require__(1084);

__webpack_require__(1085);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(917);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(877);
__webpack_require__(878);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(968);
__webpack_require__(969);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
__webpack_require__(984);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(988);
__webpack_require__(989);
__webpack_require__(990);
__webpack_require__(991);
__webpack_require__(309);
__webpack_require__(992);
__webpack_require__(456);
__webpack_require__(993);
__webpack_require__(457);
__webpack_require__(994);
__webpack_require__(995);
__webpack_require__(996);
__webpack_require__(997);
__webpack_require__(998);
__webpack_require__(460);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(999);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
__webpack_require__(1003);
__webpack_require__(1004);
__webpack_require__(1005);
__webpack_require__(1006);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1029);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(1032);
__webpack_require__(1033);
__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
__webpack_require__(1037);
__webpack_require__(1038);
__webpack_require__(1039);
__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1042);
__webpack_require__(1043);
__webpack_require__(1044);
__webpack_require__(1045);
__webpack_require__(1046);
__webpack_require__(1047);
__webpack_require__(1048);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(1051);
__webpack_require__(1052);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);
__webpack_require__(1057);
__webpack_require__(1058);
__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1061);
__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(1066);
__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
__webpack_require__(1071);
__webpack_require__(1072);
__webpack_require__(1073);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1079);
__webpack_require__(1080);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1083);
module.exports = __webpack_require__(68);


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(20);
var has = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(34);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(54);
var META = __webpack_require__(107).KEY;
var $fails = __webpack_require__(23);
var shared = __webpack_require__(175);
var setToStringTag = __webpack_require__(149);
var uid = __webpack_require__(120);
var wks = __webpack_require__(32);
var wksExt = __webpack_require__(438);
var wksDefine = __webpack_require__(290);
var enumKeys = __webpack_require__(919);
var isArray = __webpack_require__(208);
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(26);
var toObject = __webpack_require__(37);
var toIObject = __webpack_require__(62);
var toPrimitive = __webpack_require__(79);
var createDesc = __webpack_require__(119);
var _create = __webpack_require__(123);
var gOPNExt = __webpack_require__(441);
var $GOPD = __webpack_require__(63);
var $GOPS = __webpack_require__(207);
var $DP = __webpack_require__(36);
var $keys = __webpack_require__(121);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(124).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(177).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(106)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(53)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175)('native-function-to-string', Function.toString);


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(121);
var gOPS = __webpack_require__(207);
var pIE = __webpack_require__(177);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(123) });


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(34), 'Object', { defineProperty: __webpack_require__(36).f });


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(34), 'Object', { defineProperties: __webpack_require__(440) });


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(62);
var $getOwnPropertyDescriptor = __webpack_require__(63).f;

__webpack_require__(81)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(37);
var $getPrototypeOf = __webpack_require__(64);

__webpack_require__(81)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(37);
var $keys = __webpack_require__(121);

__webpack_require__(81)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(81)('getOwnPropertyNames', function () {
  return __webpack_require__(441).f;
});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(107).onFreeze;

__webpack_require__(81)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(107).onFreeze;

__webpack_require__(81)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(107).onFreeze;

__webpack_require__(81)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(26);

__webpack_require__(81)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(26);

__webpack_require__(81)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(26);

__webpack_require__(81)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(442) });


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { is: __webpack_require__(443) });


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(294).set });


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(150);
var test = {};
test[__webpack_require__(32)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(54)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', { bind: __webpack_require__(444) });


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(36).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(34) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(64);
var HAS_INSTANCE = __webpack_require__(32)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(36).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(446);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(447);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(122);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(62);
var toLength = __webpack_require__(33);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(151)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(209)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(300)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $at = __webpack_require__(209)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(33);
var context = __webpack_require__(302);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(303)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(3);
var context = __webpack_require__(302);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(303)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(297)
});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(33);
var context = __webpack_require__(302);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(303)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(55)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(55)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(55)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(55)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(55)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(55)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(55)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(55)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(55)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(55)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(55)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(55)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(55)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(79);

$export($export.P + $export.F * __webpack_require__(23)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3);
var toISOString = __webpack_require__(967);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(23);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(54)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(32)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(53)(proto, TO_PRIMITIVE, __webpack_require__(970));


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(79);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', { isArray: __webpack_require__(208) });


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(69);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(37);
var call = __webpack_require__(452);
var isArrayIter = __webpack_require__(304);
var toLength = __webpack_require__(33);
var createProperty = __webpack_require__(305);
var getIterFn = __webpack_require__(306);

$export($export.S + $export.F * !__webpack_require__(211)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var createProperty = __webpack_require__(305);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(23)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(3);
var toIObject = __webpack_require__(62);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(176) != Object || !__webpack_require__(72)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var html = __webpack_require__(293);
var cof = __webpack_require__(70);
var toAbsoluteIndex = __webpack_require__(122);
var toLength = __webpack_require__(33);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(23)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var aFunction = __webpack_require__(47);
var toObject = __webpack_require__(37);
var fails = __webpack_require__(23);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(72)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $forEach = __webpack_require__(82)(0);
var STRICT = __webpack_require__(72)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var isArray = __webpack_require__(208);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $map = __webpack_require__(82)(1);

$export($export.P + $export.F * !__webpack_require__(72)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $filter = __webpack_require__(82)(2);

$export($export.P + $export.F * !__webpack_require__(72)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $some = __webpack_require__(82)(3);

$export($export.P + $export.F * !__webpack_require__(72)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $every = __webpack_require__(82)(4);

$export($export.P + $export.F * !__webpack_require__(72)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(453);

$export($export.P + $export.F * !__webpack_require__(72)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(453);

$export($export.P + $export.F * !__webpack_require__(72)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $indexOf = __webpack_require__(206)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(72)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(62);
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(33);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(72)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { copyWithin: __webpack_require__(454) });

__webpack_require__(108)('copyWithin');


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { fill: __webpack_require__(308) });

__webpack_require__(108)('fill');


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(82)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(108)(KEY);


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(82)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(108)(KEY);


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125)('Array');


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var inheritIfRequired = __webpack_require__(296);
var dP = __webpack_require__(36).f;
var gOPN = __webpack_require__(124).f;
var isRegExp = __webpack_require__(210);
var $flags = __webpack_require__(178);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(34) && (!CORRECT_NEW || __webpack_require__(23)(function () {
  re2[__webpack_require__(32)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(54)(global, 'RegExp', $RegExp);
}

__webpack_require__(125)('RegExp');


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(457);
var anObject = __webpack_require__(18);
var $flags = __webpack_require__(178);
var DESCRIPTORS = __webpack_require__(34);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(54)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(23)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(18);
var toLength = __webpack_require__(33);
var advanceStringIndex = __webpack_require__(311);
var regExpExec = __webpack_require__(212);

// @@match logic
__webpack_require__(213)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(18);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(33);
var toInteger = __webpack_require__(71);
var advanceStringIndex = __webpack_require__(311);
var regExpExec = __webpack_require__(212);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(213)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(18);
var sameValue = __webpack_require__(443);
var regExpExec = __webpack_require__(212);

// @@search logic
__webpack_require__(213)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(210);
var anObject = __webpack_require__(18);
var speciesConstructor = __webpack_require__(179);
var advanceStringIndex = __webpack_require__(311);
var toLength = __webpack_require__(33);
var callRegExpExec = __webpack_require__(212);
var regexpExec = __webpack_require__(310);
var fails = __webpack_require__(23);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(213)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(106);
var global = __webpack_require__(20);
var ctx = __webpack_require__(69);
var classof = __webpack_require__(150);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(26);
var aFunction = __webpack_require__(47);
var anInstance = __webpack_require__(126);
var forOf = __webpack_require__(127);
var speciesConstructor = __webpack_require__(179);
var task = __webpack_require__(312).set;
var microtask = __webpack_require__(313)();
var newPromiseCapabilityModule = __webpack_require__(314);
var perform = __webpack_require__(458);
var userAgent = __webpack_require__(214);
var promiseResolve = __webpack_require__(459);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(32)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(128)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(149)($Promise, PROMISE);
__webpack_require__(125)(PROMISE);
Wrapper = __webpack_require__(68)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(211)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(464);
var validate = __webpack_require__(129);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(215)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $typed = __webpack_require__(216);
var buffer = __webpack_require__(315);
var anObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(122);
var toLength = __webpack_require__(33);
var isObject = __webpack_require__(26);
var ArrayBuffer = __webpack_require__(20).ArrayBuffer;
var speciesConstructor = __webpack_require__(179);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(23)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(125)(ARRAY_BUFFER);


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(216).ABV, {
  DataView: __webpack_require__(315).DataView
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(18);
var rApply = (__webpack_require__(20).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(23)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(3);
var create = __webpack_require__(123);
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(23);
var bind = __webpack_require__(444);
var rConstruct = (__webpack_require__(20).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(36);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(79);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(23)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(3);
var gOPD = __webpack_require__(63).f;
var anObject = __webpack_require__(18);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(18);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(301)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(64);
var has = __webpack_require__(61);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(18);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(63);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(18);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(3);
var getProto = __webpack_require__(64);
var anObject = __webpack_require__(18);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(18);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(466) });


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(18);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(36);
var gOPD = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(64);
var has = __webpack_require__(61);
var $export = __webpack_require__(3);
var createDesc = __webpack_require__(119);
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(26);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(3);
var setProto = __webpack_require__(294);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(3);
var $includes = __webpack_require__(206)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(108)('includes');


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(467);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(33);
var aFunction = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(307);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(108)('flatMap');


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(467);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(33);
var toInteger = __webpack_require__(71);
var arraySpeciesCreate = __webpack_require__(307);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(108)('flatten');


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(3);
var $at = __webpack_require__(209)(true);
var $fails = __webpack_require__(23);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(468);
var userAgent = __webpack_require__(214);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(468);
var userAgent = __webpack_require__(214);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(151)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(151)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(3);
var defined = __webpack_require__(80);
var toLength = __webpack_require__(33);
var isRegExp = __webpack_require__(210);
var getFlags = __webpack_require__(178);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(301)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(290)('asyncIterator');


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(290)('observable');


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(3);
var ownKeys = __webpack_require__(466);
var toIObject = __webpack_require__(62);
var gOPD = __webpack_require__(63);
var createProperty = __webpack_require__(305);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $values = __webpack_require__(469)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $entries = __webpack_require__(469)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(37);
var aFunction = __webpack_require__(47);
var $defineProperty = __webpack_require__(36);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(34) && $export($export.P + __webpack_require__(217), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(37);
var aFunction = __webpack_require__(47);
var $defineProperty = __webpack_require__(36);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(34) && $export($export.P + __webpack_require__(217), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(79);
var getPrototypeOf = __webpack_require__(64);
var getOwnPropertyDescriptor = __webpack_require__(63).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(34) && $export($export.P + __webpack_require__(217), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(79);
var getPrototypeOf = __webpack_require__(64);
var getOwnPropertyDescriptor = __webpack_require__(63).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(34) && $export($export.P + __webpack_require__(217), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(470)('Map') });


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(470)('Set') });


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(218)('Map');


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(218)('Set');


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(218)('WeakMap');


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(218)('WeakSet');


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(219)('Map');


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(219)('Set');


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(219)('WeakMap');


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(219)('WeakSet');


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.G, { global: __webpack_require__(20) });


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.S, 'System', { global: __webpack_require__(20) });


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(3);
var cof = __webpack_require__(70);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var scale = __webpack_require__(472);
var fround = __webpack_require__(451);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { scale: __webpack_require__(472) });


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(3);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(3);
var core = __webpack_require__(68);
var global = __webpack_require__(20);
var speciesConstructor = __webpack_require__(179);
var promiseResolve = __webpack_require__(459);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(3);
var newPromiseCapability = __webpack_require__(314);
var perform = __webpack_require__(458);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(64);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(462);
var from = __webpack_require__(471);
var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(64);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(64);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(97);
var anObject = __webpack_require__(18);
var aFunction = __webpack_require__(47);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(3);
var microtask = __webpack_require__(313)();
var process = __webpack_require__(20).process;
var isNode = __webpack_require__(70)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(3);
var global = __webpack_require__(20);
var core = __webpack_require__(68);
var microtask = __webpack_require__(313)();
var OBSERVABLE = __webpack_require__(32)('observable');
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(18);
var anInstance = __webpack_require__(126);
var redefineAll = __webpack_require__(128);
var hide = __webpack_require__(53);
var forOf = __webpack_require__(127);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(125)('Observable');


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(20);
var $export = __webpack_require__(3);
var userAgent = __webpack_require__(214);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $task = __webpack_require__(312);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(309);
var getKeys = __webpack_require__(121);
var redefine = __webpack_require__(54);
var global = __webpack_require__(20);
var hide = __webpack_require__(53);
var Iterators = __webpack_require__(152);
var wks = __webpack_require__(32);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1086);
module.exports = __webpack_require__(68).RegExp.escape;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(3);
var $re = __webpack_require__(1087)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var rootEl = document.getElementById('app-site');

// Create a reusable render method that we can call more than once
var render = function render() {
    // Dynamically import our main App component, and render it
    var MainApp = __webpack_require__(1093).default;
    _reactDom2.default.render(_react2.default.createElement(MainApp, null), rootEl);
};

if (false) {
    module.hot.accept('./MainApp', function () {
        var NextApp = require('./MainApp').default;
        render(_react2.default.createElement(NextApp, null), rootEl);
    });
}

render();
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(rootEl, 'rootEl', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');

    __REACT_HOT_LOADER__.register(render, 'render', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');

    __REACT_HOT_LOADER__.register(_reactDom2, '_reactDom2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');

    __REACT_HOT_LOADER__.register(rootEl, 'rootEl', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');

    __REACT_HOT_LOADER__.register(render, 'render', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/index.js');
}();

;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(83),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(83),r=__webpack_require__(1091);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1092);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.persistor = exports.store = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(316);

var _reactRedux = __webpack_require__(30);

var _reactRouterDom = __webpack_require__(39);

var _store = __webpack_require__(222);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(225);

var _App = __webpack_require__(1187);

var _App2 = _interopRequireDefault(_App);

var _react3 = __webpack_require__(2058);

__webpack_require__(31);

__webpack_require__(2059);

__webpack_require__(2061);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _configureStore = (0, _store2.default)();

var store = _configureStore.store,
    persistor = _configureStore.persistor;
exports.store = store;
exports.persistor = persistor;

var MainApp = function MainApp() {
    return _react2.default.createElement(_reactRedux.Provider, { store: store }, _react2.default.createElement(_react3.PersistGate, { loading: null, persistor: persistor }, _react2.default.createElement(_reactRouterRedux.ConnectedRouter, { history: _store.history }, _react2.default.createElement(_reactRouterDom.Switch, null, _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _App2.default })))));
};

var _default = MainApp;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(store, 'store', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(persistor, 'persistor', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(MainApp, 'MainApp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_store2, '_store2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_App2, '_App2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_configureStore, '_configureStore', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(store, 'store', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(persistor, 'persistor', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(MainApp, 'MainApp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/MainApp.js');
}();

;

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(483);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history;

    this.store = propsStore || this.context.store;

    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    this.handleLocationChange(history.location);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1096);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(473);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(477);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(478);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(318);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(480);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(481);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(317);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(221);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(482);
/* unused harmony reexport withRouter */





















/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(484);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(319);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1104);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1106);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1127);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(492);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1115);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1113);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(489);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1117);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(490);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(491);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(492);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(493);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1128);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(319);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(322);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(322);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(473);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(495);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(477);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(478);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(480);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(481);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(317);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(221);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(482);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialSettings = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _ActionTypes = __webpack_require__(41);

var _ThemeColors = __webpack_require__(223);

var rltLocale = ['ar'];
var initialSettings = exports.initialSettings = {
  navCollapsed: false,
  drawerType: _ActionTypes.MINI_DRAWER,
  themeColor: _ThemeColors.DARK_PINK,
  darkTheme: false,
  width: $(window).width(),
  isDirectionRTL: false,
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us'
  }
};

var settings = function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSettings;
  var action = arguments[1];

  switch (action.type) {

    case '@@router/LOCATION_CHANGE':
      return _extends({}, state, {
        navCollapsed: false
      });
    case _ActionTypes.TOGGLE_COLLAPSED_NAV:
      return _extends({}, state, {
        navCollapsed: action.isNavCollapsed
      });
    case _ActionTypes.DRAWER_TYPE:
      return _extends({}, state, {
        drawerType: action.drawerType
      });
    case _ActionTypes.WINDOW_WIDTH:
      return _extends({}, state, {
        width: action.width
      });
    case _ActionTypes.THEME_COLOR:
      return _extends({}, state, {
        darkTheme: false,
        themeColor: action.color
      });
    case _ActionTypes.DARK_THEME:
      return _extends({}, state, {
        darkTheme: !state.darkTheme
      });
    case _ActionTypes.SWITCH_LANGUAGE:

      return _extends({}, state, {
        locale: action.payload
        // isDirectionRTL: rltLocale.includes(action.payload.locale)

      });

    case 'SET_DEFAULT_THEME':
      return {
        navCollapsed: false,
        drawerType: _ActionTypes.MINI_DRAWER,
        themeColor: _ThemeColors.DARK_PINK,
        darkTheme: false,
        width: $(window).width(),
        isDirectionRTL: false,
        locale: {
          languageId: 'english',
          locale: 'en',
          name: 'English',
          icon: 'us'
        }
      };

    default:
      return state;
  }
};

var _default = settings;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialSettings, 'initialSettings', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(rltLocale, 'rltLocale', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(settings, 'settings', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(rltLocale, 'rltLocale', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(initialSettings, 'initialSettings', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(settings, 'settings', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Settings.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _ActionTypes = __webpack_require__(41);

var INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: true,
    noContentFoundMessage: 'No contact found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    user: {
        name: 'Robert Johnson',
        email: 'robert.johnson@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
    searchUser: '',
    filterOption: 'All contacts',
    allContact: [],
    contactList: [],
    selectedContact: null,
    selectedContacts: 0,
    addContactState: false
};

var _default = function _default() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.ADD_FAVOURITE:
            {
                return _extends({}, state, {
                    alertMessage: action.payload.starred ? 'Contact removed as star' : 'Contact marked as star',
                    showMessage: true,
                    contactList: state.contactList.map(function (contact) {
                        return contact.id === action.payload.id ? _extends({}, contact, {
                            starred: !action.payload.starred
                        }) : contact;
                    }),
                    allContact: state.allContact.map(function (contact) {
                        return contact.id === action.payload.id ? _extends({}, contact, {
                            starred: !action.payload.starred
                        }) : contact;
                    })
                });
            }
        case _ActionTypes.FETCH_ALL_CONTACT_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    allContact: action.payload,
                    contactList: action.payload
                });
            }
        case _ActionTypes.SHOW_MESSAGE:
            {
                return _extends({}, state, {
                    alertMessage: action.payload,
                    showMessage: true,
                    loader: false
                });
            }
        case _ActionTypes.ON_CONTACT_SELECT:
            {
                action.payload.selected = !action.payload.selected;
                var selectedContacts = 0;
                var contactList = state.contactList.map(function (contact) {
                    if (contact.selected) {
                        selectedContacts++;
                    }
                    if (contact.id === action.payload.id) {
                        if (contact.selected) {
                            selectedContacts++;
                        }
                        return action.payload;
                    } else {
                        return contact;
                    }
                });
                return _extends({}, state, { INIT_STATE: INIT_STATE,
                    selectedContacts: selectedContacts,
                    contactList: contactList
                });
            }
        case _ActionTypes.ON_ADD_CONTACT:
            {
                return _extends({}, state, { addContactState: true });
            }
        case _ActionTypes.ON_CONTACT_CLOSE:
            {
                return _extends({}, state, { addContactState: false });
            }
        case _ActionTypes.ON_FILTER_OPTION_SELECT:
            {
                var selectedSectionId = 0;
                var filterOption = '';
                var _contactList = [];
                switch (action.payload.name) {
                    case 'All contacts':
                        {
                            selectedSectionId = action.payload.id;
                            filterOption = action.payload.name;
                            _contactList = state.allContact;
                            break;
                        }
                    case 'Frequently contacted':
                        {
                            selectedSectionId = action.payload.id;
                            filterOption = action.payload.name;
                            _contactList = state.allContact.filter(function (contact) {
                                return contact.frequently;
                            });
                            break;
                        }
                    case 'Starred contacts':
                        {
                            selectedSectionId = action.payload.id;
                            filterOption = action.payload.name;
                            _contactList = state.allContact.filter(function (contact) {
                                return contact.starred;
                            });
                            break;
                        }
                }
                return _extends({}, state, { selectedSectionId: selectedSectionId, filterOption: filterOption, contactList: _contactList, drawerState: false
                });
            }
        case _ActionTypes.ON_SAVE_CONTACT:
            {
                var isNew = true;
                var _contactList2 = state.allContact.map(function (contact) {
                    if (contact.id === action.payload.id) {
                        isNew = false;
                        return action.payload;
                    } else {
                        return contact;
                    }
                });
                if (isNew) {
                    _contactList2.push(action.payload);
                }
                return _extends({}, state, {
                    alertMessage: isNew ? 'Contact Added Successfully' : 'Contact Updated Successfully',
                    showMessage: true,
                    contactList: _contactList2,
                    allContact: _contactList2
                });
            }
        case _ActionTypes.ON_DELETE_CONTACT:
            {
                return _extends({}, state, {
                    alertMessage: 'Contact Deleted Successfully',
                    showMessage: true,
                    allContact: state.allContact.filter(function (contact) {
                        return contact.id !== action.payload.id;
                    }),
                    contactList: state.allContact.filter(function (contact) {
                        return contact.id !== action.payload.id;
                    })
                });
            }
        case _ActionTypes.ON_DELETE_SELECTED_CONTACT:
            {
                var contacts = state.allContact.filter(function (contact) {
                    return !contact.selected;
                });
                return _extends({}, state, {
                    alertMessage: 'Contact Deleted Successfully',
                    showMessage: true,
                    allContact: contacts,
                    contactList: contacts,
                    selectedContacts: 0
                });
            }
        case _ActionTypes.FILTER_CONTACT:
            {
                var _filterOption = state.filterOption;

                var _contactList3 = [];
                if (action.payload === '') {
                    _contactList3 = state.allContact;
                } else {
                    var filterContact = state.allContact.filter(function (contact) {
                        return contact.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
                    });
                    if (_filterOption === 'All contacts') {
                        _contactList3 = filterContact;
                    } else if (_filterOption === 'Frequently contacted') {
                        _contactList3 = filterContact.filter(function (contact) {
                            return contact.frequently;
                        });
                    } else if (_filterOption === 'Starred contacts') {
                        _contactList3 = filterContact.filter(function (contact) {
                            return contact.starred;
                        });
                    }
                }
                return _extends({}, state, { contactList: _contactList3 });
            }
        case _ActionTypes.GET_ALL_CONTACT:
            {
                var _contactList4 = state.allContact.map(function (contact) {
                    return contact ? _extends({}, contact, {
                        selected: true
                    }) : contact;
                });
                return _extends({}, state, {
                    selectedContacts: _contactList4.length,
                    allContact: _contactList4,
                    contactList: _contactList4
                });
            }
        case _ActionTypes.GET_UNSELECTED_ALL_CONTACT:
            {
                var _contactList5 = state.allContact.map(function (contact) {
                    return contact ? _extends({}, contact, {
                        selected: false
                    }) : contact;
                });
                return _extends({}, state, {
                    selectedContacts: 0,
                    allContact: _contactList5,
                    contactList: _contactList5
                });
            }
        case _ActionTypes.ON_ALL_CONTACT_SELECT:
            {
                var selectAll = state.selectedContacts < state.contactList.length;
                var _selectedContacts = 0;
                var _contactList6 = [];
                if (selectAll) {
                    _contactList6 = state.allContact.map(function (contact) {
                        return contact ? _extends({}, contact, {
                            selected: true
                        }) : contact;
                    });
                    _selectedContacts = _contactList6.length;
                } else {
                    _contactList6 = state.allContact.map(function (contact) {
                        return contact ? _extends({}, contact, {
                            selected: true
                        }) : contact;
                    });
                    _selectedContacts = 0;
                }
                return _extends({}, state, {
                    selectedContacts: _selectedContacts,
                    allContact: _contactList6,
                    contactList: _contactList6
                });
            }
        case _ActionTypes.UPDATE_SEARCH_USER:
            {
                return _extends({}, state, { searchUser: action.payload });
            }
        case _ActionTypes.HANDLE_REQUEST_CLOSE:
            {
                return _extends({}, state, { showMessage: false });
            }
        case _ActionTypes.ON_TOGGLE_DRAWER:
            {
                return _extends({}, state, { drawerState: !state.drawerState });
            }

        default:
            return state;
    }
};

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Contact.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Contact.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Contact.js');

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Contact.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Contact.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Contact.js');
}();

;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _ActionTypes = __webpack_require__(41);

var INIT_STATE = {
    searchMail: '',
    noContentFoundMessage: 'No mail found in selected folder',
    alertMessage: '',
    showMessage: false,
    drawerState: false,
    anchorEl: null,
    allMail: [],
    optionName: 'None',
    loader: true,
    currentMail: null,
    user: {
        name: 'Robert Johnson',
        email: 'robert@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
    selectedMails: 0,
    selectedFolder: 0,
    composeMail: false,
    labelMenuState: false,
    folderMenuState: false,
    optionMenuState: false,
    folderMails: []

};

var _default = function _default() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.GET_ALL_MAIL:
            {
                var mails = state.allMail.map(function (mail) {
                    return mail.folder === state.selectedFolder ? _extends({}, mail, {
                        selected: true
                    }) : mail;
                });
                return _extends({}, state, {
                    selectedMails: mails.length,
                    optionName: 'All',
                    allMail: mails,
                    folderMails: mails.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.FETCH_ALL_MAIL_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    allMail: action.payload,
                    folderMails: action.payload.filter(function (mail) {
                        return mail.folder === 0;
                    })
                });
            }
        case _ActionTypes.GET_IMPORTANT_MAIL:
            {
                var selectedMail = 0;
                var _mails = state.allMail.filter(function (mail) {
                    return mail.folder === state.selectedFolder;
                });
                _mails = _mails.map(function (mail) {
                    if (mail.important) {
                        selectedMail++;
                        return _extends({}, mail, { selected: true });
                    }
                    return _extends({}, mail, { selected: false });
                });
                return _extends({}, state, {
                    selectedMails: selectedMail,
                    optionName: 'Important',
                    allMail: _mails,
                    folderMails: _mails.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.GET_NAV_FILTERS:
            {
                var filterMails = state.allMail.filter(function (mail) {
                    if (action.payload.id === 0 && mail.starred) {
                        return mail;
                    } else if (action.payload.id === 1 && mail.important) {
                        return mail;
                    }
                });
                return _extends({}, state, {
                    noContentFoundMessage: 'No mail found in selected filter',
                    loader: true,
                    folderMails: filterMails
                });
            }
        case _ActionTypes.ON_FOLDER_SELECT:
            {
                return _extends({}, state, { folderMenuState: !state.folderMenuState });
            }
        case _ActionTypes.GET_NAV_LABELS:
            {
                var _filterMails = state.allMail.filter(function (mail) {
                    return mail.labels.includes(action.payload.id);
                });
                return _extends({}, state, {
                    loader: true,
                    noContentFoundMessage: 'No mail found in selected label',
                    folderMails: _filterMails
                });
            }
        case _ActionTypes.GET_READ_MAIL:
            {
                var _selectedMail = 0;
                var _mails2 = state.allMail.filter(function (mail) {
                    return mail.folder === state.selectedFolder;
                });
                _mails2 = _mails2.map(function (mail) {
                    if (mail.read) {
                        _selectedMail++;
                        return _extends({}, mail, { selected: true });
                    }
                    return _extends({}, mail, { selected: false });
                });
                return _extends({}, state, {
                    selectedMails: _selectedMail,
                    allMail: _mails2,
                    optionName: 'Read',
                    folderMails: _mails2.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.GET_STARRED_MAIL:
            {
                var _selectedMail2 = 0;
                var _mails3 = state.allMail.filter(function (mail) {
                    return mail.folder === state.selectedFolder;
                });
                _mails3 = _mails3.map(function (mail) {
                    if (mail.starred) {
                        _selectedMail2++;
                        return _extends({}, mail, { selected: true });
                    }
                    return _extends({}, mail, { selected: false });
                });
                return _extends({}, state, {
                    selectedMails: _selectedMail2,
                    allMail: _mails3,
                    optionName: 'Stared',
                    folderMails: _mails3.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.GET_UNIMPORTANT_MAIL:
            {
                var _selectedMail3 = 0;
                var _mails4 = state.allMail.filter(function (mail) {
                    return mail.folder === state.selectedFolder;
                });
                _mails4 = _mails4.map(function (mail) {
                    if (!mail.important) {
                        _selectedMail3++;
                        return _extends({}, mail, { selected: true });
                    }
                    return _extends({}, mail, { selected: false });
                });
                return _extends({}, state, {
                    selectedMails: _selectedMail3,
                    allMail: _mails4,
                    optionName: 'Unimportant',
                    noContentFoundMessage: 'No Mail found in selected Label',
                    folderMails: _mails4.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.GET_UNREAD_MAIL:
            {
                var _selectedMail4 = 0;
                var _mails5 = state.allMail.filter(function (mail) {
                    return mail.folder === state.selectedFolder;
                });
                _mails5 = _mails5.map(function (mail) {
                    if (!mail.read) {
                        _selectedMail4++;
                        return _extends({}, mail, { selected: true });
                    }
                    return _extends({}, mail, { selected: false });
                });
                return _extends({}, state, {
                    selectedMails: _selectedMail4,
                    allMail: _mails5,
                    optionName: 'Unread',
                    folderMails: _mails5.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.GET_UNSELECTED_ALL_MAIL:
            {
                var _mails6 = state.allMail.map(function (mail) {
                    return mail.folder === state.selectedFolder ? _extends({}, mail, {
                        selected: false
                    }) : mail;
                });
                return _extends({}, state, {
                    selectedMails: 0,
                    optionName: 'None',
                    allMail: _mails6,
                    folderMails: _mails6.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.GET_UNSTARRED_MAIL:
            {
                var _selectedMail5 = 0;
                var _mails7 = state.allMail.filter(function (mail) {
                    return mail.folder === state.selectedFolder;
                });
                _mails7 = _mails7.map(function (mail) {
                    if (!mail.starred) {
                        _selectedMail5++;
                        return _extends({}, mail, { selected: true });
                    }
                    return _extends({}, mail, { selected: false });
                });
                return _extends({}, state, {
                    selectedMails: _selectedMail5,
                    optionName: 'UnStarred',
                    allMail: _mails7,
                    folderMails: _mails7.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.HANDLE_REQUEST_CLOSE:
            {
                return _extends({}, state, {
                    composeMail: false,
                    showMessage: false,
                    folderMenuState: false,
                    labelMenuState: false,
                    optionMenuState: false
                });
            }
        case _ActionTypes.ON_ALL_MAIL_SELECT:
            {
                return _extends({}, state);
            }
        case _ActionTypes.ON_FOLDER_MENU_ITEM_SELECT:
            {
                var _mails8 = state.allMail.map(function (mail) {
                    return mail.selected && mail.folder === state.selectedFolder ? _extends({}, mail, { folder: action.payload, selected: false }) : mail;
                });

                return _extends({}, state, {
                    selectedMails: 0,
                    allMail: _mails8,
                    noContentFoundMessage: 'No mail found in selected folder',
                    alertMessage: 'Mail has been moved successfully',
                    showMessage: true,
                    folderMails: _mails8.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.ON_IMPORTANT_SELECT:
            {
                action.payload.important = !action.payload.important;
                return _extends({}, state, {
                    alertMessage: action.payload.important ? 'Mail Mark as Important' : 'Mail Remove as Important',
                    showMessage: true,
                    folderMails: state.folderMails.map(function (mail) {
                        return mail.id === action.payload.id ? action.payload : mail;
                    })
                });
            }
        case _ActionTypes.ON_LABEL_MENU_ITEM_SELECT:
            {
                var currentMail = state.currentMail;
                var _mails9 = state.allMail.map(function (mail) {
                    if (mail.selected && mail.folder === state.selectedFolder) {
                        if (mail.labels.includes(action.payload.id)) {
                            mail.labels.splice(mail.labels.indexOf(action.payload.id), 1);
                            if (currentMail !== null && mail.id === currentMail.id) {
                                currentMail.labels = mail.labels;
                            }
                            return _extends({}, mail, { labels: mail.labels });
                        } else {
                            mail.labels = mail.labels.concat(action.payload.id);
                            if (currentMail !== null && mail.id === currentMail.id) {
                                currentMail.labels = mail.labels;
                            }
                            return _extends({}, mail, { labels: mail.labels });
                        }
                    } else {
                        return mail;
                    }
                });

                return _extends({}, state, {
                    currentMail: currentMail,
                    noContentFoundMessage: 'No mail found in selected label',
                    alertMessage: 'Label Updated Successfully',
                    showMessage: true,
                    allMail: _mails9,
                    folderMails: _mails9.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.ON_LABEL_SELECT:
            {
                return _extends({}, state, { labelMenuState: !state.labelMenuState });
            }
        case _ActionTypes.ON_MAIL_CHECKED:
            {
                action.payload.selected = !action.payload.selected;
                var _selectedMail6 = 0;
                var _mails10 = state.folderMails.map(function (mail) {
                    if (mail.selected) {
                        _selectedMail6++;
                    }
                    if (mail.id === action.payload.id) {
                        if (mail.selected) {
                            _selectedMail6++;
                        }
                        return action.payload;
                    } else {
                        return mail;
                    }
                });
                return _extends({}, state, {
                    selectedMails: _selectedMail6,
                    folderMails: _mails10
                });
            }
        case _ActionTypes.ON_MAIL_SELECT:
            {
                return _extends({}, state, {
                    loader: true,
                    currentMail: action.payload
                });
            }
        case _ActionTypes.ON_MAIL_SEND:
            {
                return _extends({}, state, {
                    alertMessage: 'Mail Sent Successfully',
                    showMessage: true,
                    folderMails: state.allMail.concat(action.payload),
                    allMail: state.allMail.concat(action.payload)
                });
            }
        case _ActionTypes.ON_OPTION_MENU_SELECT:
            {
                return _extends({}, state, { optionMenuState: !state.optionMenuState });
            }
        case _ActionTypes.GET_NAV_FOLDER:
            {
                var _filterMails2 = state.allMail.filter(function (mail) {
                    return mail.folder === action.payload.id;
                });
                return _extends({}, state, {
                    selectedFolder: action.payload.id,
                    noContentFoundMessage: 'No mail found in selected folder',
                    currentMail: null,
                    loader: true,
                    folderMails: _filterMails2
                });
            }

        case _ActionTypes.ON_START_SELECT:
            {
                action.payload.starred = !action.payload.starred;
                return _extends({}, state, {
                    alertMessage: action.payload.starred ? 'Mail Mark as Star' : 'Mail Remove as Star',
                    showMessage: true,
                    folderMails: state.folderMails.map(function (mail) {
                        return mail.id === action.payload.id ? action.payload : mail;
                    })
                });
            }

        case _ActionTypes.SEARCH_MAIL:
            {
                if (action.payload === '') {
                    return _extends({}, state, { folderMails: state.allMail.filter(function (mail) {
                            return !mail.deleted;
                        }) });
                } else {
                    var searchMails = state.allMail.filter(function (mail) {
                        return !mail.deleted && mail.subject.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
                    });
                    return _extends({}, state, {
                        folderMails: searchMails
                    });
                }
            }

        case _ActionTypes.UPDATE_SEARCH:
            {
                return _extends({}, state, { searchMail: action.payload });
            }
        case _ActionTypes.ON_HIDE_LOADER:
            {
                return _extends({}, state, { loader: false });
            }
        case _ActionTypes.ON_TOGGLE_DRAWER:
            {
                return _extends({}, state, { drawerState: !state.drawerState });
            }
        case _ActionTypes.SET_CURRENT_MAIL_NULL:
            {
                return _extends({}, state, { currentMail: null });
            }
        case _ActionTypes.ON_DELETE_MAIL:
            {

                var _mails11 = state.allMail.map(function (mail) {
                    return mail.selected && mail.folder === state.selectedFolder ? _extends({}, mail, { folder: 4, selected: false }) : mail;
                });

                return _extends({}, state, {
                    alertMessage: 'Mail Deleted Successfully',
                    showMessage: true,
                    selectedMails: 0,
                    allMail: _mails11,
                    folderMails: _mails11.filter(function (mail) {
                        return mail.folder === state.selectedFolder;
                    })
                });
            }
        case _ActionTypes.ON_COMPOSE_MAIL:
            {
                return _extends({}, state, { composeMail: true });
            }
        case _ActionTypes.SHOW_MESSAGE:
            {
                return _extends({}, state, {
                    alertMessage: action.payload,
                    showMessage: true,
                    loader: false
                });
            }

        default:
            return state;
    }
};

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Mail.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Mail.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Mail.js');

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Mail.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Mail.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Mail.js');
}();

;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _ActionTypes = __webpack_require__(41);

var INIT_STATE = {
    searchTodo: '',
    alertMessage: '',
    loader: true,
    showMessage: false,
    optionName: 'None',
    drawerState: false,
    allToDos: [],
    currentTodo: null,
    user: {
        name: 'Robert Johnson',
        email: 'robert.johnson@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
    selectedToDos: 0,
    labelMenuState: false,
    optionMenuState: false,
    toDos: [],
    filter: -1,
    todoConversation: [],
    conversation: null
};

var _default = function _default() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.ON_SORTEND:
            {
                return _extends({}, state, { toDos: arrayMove(state.toDos, action.payload.oldIndex, action.payload.newIndex)
                });
            }
        case _ActionTypes.ON_LABEL_SELECT:
            {
                return _extends({}, state, {
                    labelMenuState: !state.labelMenuState
                });
            }
        case _ActionTypes.ON_OPTION_MENU_SELECT:
            {
                return _extends({}, state, {
                    optionMenuState: !state.optionMenuState
                });
            }
        case _ActionTypes.ON_OPTION_MENU_ITEM_SELECT:
            {
                return _extends({}, state);
            }
        case _ActionTypes.SELECT_ALL_TODO:
            {
                var toDos = state.allToDos.map(function (todo) {
                    return todo ? _extends({}, todo, {
                        selected: true
                    }) : todo;
                });

                return _extends({}, state, {
                    selectedToDos: toDos.length,
                    allToDos: toDos,
                    optionName: 'All',
                    toDos: toDos
                });
            }
        case _ActionTypes.GET_ALL_TODO:
            {
                return _extends({}, state, {
                    currentTodo: null,
                    toDos: state.allToDos
                });
            }
        case _ActionTypes.GET_UNSELECTED_ALL_TODO:
            {

                var _toDos = state.allToDos.map(function (todo) {
                    return todo ? _extends({}, todo, {
                        selected: false
                    }) : todo;
                });
                return _extends({}, state, {
                    selectedToDos: 0,
                    allToDos: _toDos,
                    optionName: 'None',
                    toDos: _toDos
                });
            }
        case _ActionTypes.GET_STARRED_TODO:
            {
                var selectedToDos = 0;
                var _toDos2 = state.allToDos.map(function (todo) {
                    if (todo.starred) {
                        selectedToDos++;
                        return _extends({}, todo, { selected: true });
                    }
                    return _extends({}, todo, { selected: false });
                });
                return _extends({}, state, {
                    selectedToDos: selectedToDos,
                    allToDos: _toDos2,
                    optionName: 'Stared',
                    toDos: _toDos2.filter(function (todo) {
                        return !todo.deleted;
                    })
                });
            }
        case _ActionTypes.GET_UNSTARRED_TODO:
            {
                var _selectedToDos = 0;
                var _toDos3 = state.allToDos.map(function (todo) {
                    if (!todo.starred) {
                        _selectedToDos++;
                        return _extends({}, todo, { selected: true });
                    }
                    return _extends({}, todo, { selected: false });
                });
                return _extends({}, state, {
                    selectedToDos: _selectedToDos,
                    allToDos: _toDos3,
                    optionName: 'UnStarred',
                    toDos: _toDos3.filter(function (todo) {
                        return !todo.deleted;
                    })
                });
            }
        case _ActionTypes.GET_IMPORTANT_TODO:
            {
                var _selectedToDos2 = 0;
                var _toDos4 = state.allToDos.map(function (todo) {
                    if (todo.important) {
                        _selectedToDos2++;
                        return _extends({}, todo, { selected: true });
                    }
                    return _extends({}, todo, { selected: false });
                });
                return _extends({}, state, {
                    selectedToDos: _selectedToDos2,
                    allToDos: _toDos4,
                    optionName: 'Important',
                    toDos: _toDos4.filter(function (todo) {
                        return !todo.deleted;
                    })
                });
            }

        case _ActionTypes.GET_MARK_AS_START:
            {
                var _toDos5 = state.allToDos.map(function (todo) {
                    if (todo.id === action.payload.id) {
                        return action.payload;
                    } else {
                        return todo;
                    }
                });
                return _extends({}, state, {
                    alertMessage: 'ToDo Updated Successfully',
                    showMessage: true,
                    allToDos: _toDos5,
                    toDos: _toDos5
                });
            }
        case _ActionTypes.GET_UNIMPORTANT_TODO:
            {
                var _selectedToDos3 = 0;
                var _toDos6 = state.allToDos.map(function (todo) {
                    if (!todo.important) {
                        _selectedToDos3++;
                        return _extends({}, todo, { selected: true });
                    }
                    return _extends({}, todo, { selected: false });
                });

                return _extends({}, state, {
                    selectedToDos: _selectedToDos3,
                    allToDos: _toDos6,
                    optionName: 'Unimportant',
                    toDos: _toDos6.filter(function (todo) {
                        return !todo.deleted;
                    })
                });
            }
        case _ActionTypes.ON_LABEL_MENU_ITEM_SELECT:
            {
                var _toDos7 = state.allToDos.map(function (todo) {
                    if (todo.selected) {
                        if (todo.labels.includes(action.payload.id)) {
                            todo.labels.splice(todo.labels.indexOf(action.payload.id), 1);
                            return _extends({}, todo, { labels: todo.labels });
                        } else {
                            return _extends({}, todo, { labels: todo.labels.concat(action.payload.id) });
                        }
                    } else {
                        return todo;
                    }
                });
                return _extends({}, state, {
                    alertMessage: 'Label Updated Successfully',
                    showMessage: true,
                    allToDos: _toDos7,
                    toDos: _toDos7
                });
            }
        case _ActionTypes.ON_LABEL_UPDATE:
            {
                if (action.payload.data.labels.includes(action.payload.label.id)) {
                    action.payload.data.labels.splice(action.payload.data.labels.indexOf(action.payload.label.id), 1);
                } else {
                    action.payload.data.labels = action.payload.data.labels.concat(action.payload.label.id);
                }
                var _toDos8 = state.allToDos.map(function (todo) {
                    if (todo.id === action.payload.data.id) {
                        return action.payload.data;
                    } else {
                        return todo;
                    }
                });

                return _extends({}, state, {
                    alertMessage: 'Label Updated Successfully',
                    showMessage: true,
                    currentTodo: action.payload,
                    allToDos: _toDos8,
                    toDos: _toDos8
                });
            }
        case _ActionTypes.ON_TODO_UPDATE:
            {
                var _toDos9 = state.allToDos.map(function (todo) {
                    if (todo.id === action.payload.id) {
                        return action.payload;
                    } else {
                        return todo;
                    }
                });
                return _extends({}, state, {
                    alertMessage: 'ToDo Updated Successfully',
                    showMessage: true,
                    currentTodo: action.payload,
                    allToDos: _toDos9,
                    toDos: _toDos9
                });
            }
        case _ActionTypes.ON_DELETE_TODO:
            {
                var _selectedToDos4 = 0;
                var _toDos10 = state.allToDos.map(function (todo) {
                    if (todo.selected) {
                        _selectedToDos4++;
                    }
                    if (action.payload.id === todo.id) {
                        if (todo.selected) {
                            _selectedToDos4--;
                        }
                        return _extends({}, todo, { deleted: true });
                    } else {
                        return todo;
                    }
                });
                return _extends({}, state, {
                    alertMessage: 'ToDo Deleted Successfully',
                    showMessage: true,
                    allToDos: _toDos10,
                    currentTodo: null,
                    selectedToDos: _selectedToDos4,
                    toDos: _toDos10.filter(function (todo) {
                        return !todo.deleted;
                    })
                });
            }

        case _ActionTypes.GET_NAV_LABELS:
            {
                var filterMails = state.allToDos.filter(function (todo) {
                    return todo.labels.includes(action.payload.id);
                });
                return _extends({}, state, {
                    loader: true,
                    currentTodo: null,
                    toDos: filterMails
                });
            }
        case _ActionTypes.GET_NAV_FILTERS:
            {
                var _filterMails = state.allToDos.filter(function (todo) {
                    if (action.payload.id === 0 && todo.starred) {
                        return todo;
                    } else if (action.payload.id === 1 && todo.important) {
                        return todo;
                    } else if (action.payload.id === 2 && todo.important) {
                        return todo;
                    } else if (action.payload.id === 3 && todo.important) {
                        return todo;
                    } else if (action.payload.id === 4 && todo.completed) {
                        return todo;
                    } else if (action.payload.id === 5 && todo.deleted) {
                        return todo;
                    }
                });
                return _extends({}, state, {
                    loader: true,
                    currentTodo: null,
                    filter: action.payload.id,
                    toDos: _filterMails
                });
            }

        case _ActionTypes.SEARCH_TODO:
            {
                if (action.payload === '') {
                    return _extends({}, state, { toDos: state.allToDos.filter(function (todo) {
                            return !todo.deleted;
                        }) });
                } else {
                    var searchToDos = state.allToDos.filter(function (todo) {
                        return !todo.deleted && todo.title.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
                    });
                    return _extends({}, state, { toDos: searchToDos });
                }
            }
        case _ActionTypes.SHOW_TODOS:
            {
                return _extends({}, state);
            }
        case _ActionTypes.GET_TODO_CONVERSATION:
            {
                return _extends({}, state);
            }
        case _ActionTypes.ON_TODO_CHECKED:
            {
                action.payload.selected = !action.payload.selected;
                var _selectedToDos5 = 0;
                var _toDos11 = state.toDos.map(function (todo) {
                    if (todo.selected) {
                        _selectedToDos5++;
                    }
                    if (todo.id === action.payload.id) {
                        if (todo.selected) {
                            _selectedToDos5++;
                        }
                        return action.payload;
                    } else {
                        return todo;
                    }
                });
                return _extends({}, state, {
                    selectedToDos: _selectedToDos5,
                    toDos: _toDos11
                });
            }
        case _ActionTypes.ON_TODO_ADD:
            {
                return _extends({}, state, {
                    toDos: state.allToDos.concat(action.payload),
                    allToDos: state.allToDos.concat(action.payload)
                });
            }
        case _ActionTypes.ON_TODO_SELECT:
            {
                var conversationList = state.todoConversation.find(function (conversation) {
                    return conversation.id === action.payload.id;
                });
                if (conversationList) {
                    conversationList = conversationList.conversationData;
                } else {
                    conversationList = [];
                }
                return _extends({}, state, {
                    currentTodo: action.payload,
                    loader: true,
                    conversation: conversationList
                });
            }
        case _ActionTypes.SET_CURRENT_TODO_NULL:
            {
                return _extends({}, state, { currentTodo: null });
            }
        case _ActionTypes.UPDATE_SEARCH:
            {
                return _extends({}, state, { searchTodo: action.payload });
            }
        case _ActionTypes.ON_TOGGLE_DRAWER:
            {
                return _extends({}, state, { drawerState: !state.drawerState });
            }
        case _ActionTypes.HANDLE_REQUEST_CLOSE:
            {
                return _extends({}, state, { showMessage: false, addTodo: false, labelMenuState: false, optionMenuState: false });
            }
        case _ActionTypes.ON_HIDE_LOADER:
            {
                return _extends({}, state, { loader: false });
            }
        case _ActionTypes.FETCH_ALL_TODO_SUCCESS:
            {
                return _extends({}, state, {
                    allToDos: action.payload,
                    toDos: action.payload,
                    loader: false
                });
            }
        case _ActionTypes.FETCH_ALL_TODO_CONVERSATION_SUCCESS:
            {
                return _extends({}, state, {
                    todoConversation: action.payload
                });
            }
        case _ActionTypes.SHOW_MESSAGE:
            {
                return _extends({}, state, {
                    alertMessage: action.payload,
                    showMessage: true,
                    loader: false
                });
            }

        default:
            return state;
    }
};

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ToDo.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ToDo.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ToDo.js');

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ToDo.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ToDo.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ToDo.js');
}();

;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _ActionTypes = __webpack_require__(41);

var INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    initURL: '/app/components/summary',
    authUser: localStorage.getItem('user_id')
};

var _default = function _default() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _ActionTypes.SIGNUP_USER_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    authUser: action.payload
                });
            }
        case _ActionTypes.SIGNIN_USER_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    authUser: action.payload
                });
            }
        case _ActionTypes.INIT_URL:
            {
                return _extends({}, state, {
                    initURL: action.payload
                });
            }
        case _ActionTypes.SIGNOUT_USER_SUCCESS:
            {
                return _extends({}, state, {
                    authUser: null,
                    initURL: '/app/components/summary',
                    loader: false
                });
            }

        case _ActionTypes.SHOW_MESSAGE:
            {
                return _extends({}, state, {
                    alertMessage: action.payload,
                    showMessage: true,
                    loader: false
                });
            }
        case _ActionTypes.HIDE_MESSAGE:
            {
                return _extends({}, state, {
                    alertMessage: '',
                    showMessage: false,
                    loader: false
                });
            }

        case _ActionTypes.SIGNIN_GOOGLE_USER_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    authUser: action.payload
                });
            }
        case _ActionTypes.SIGNIN_FACEBOOK_USER_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    authUser: action.payload
                });
            }
        case _ActionTypes.SIGNIN_TWITTER_USER_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    authUser: action.payload
                });
            }
        case _ActionTypes.SIGNIN_GITHUB_USER_SUCCESS:
            {
                return _extends({}, state, {
                    loader: false,
                    authUser: action.payload
                });
            }
        case _ActionTypes.ON_SHOW_LOADER:
            {
                return _extends({}, state, {
                    loader: true
                });
            }
        case _ActionTypes.ON_HIDE_LOADER:
            {
                return _extends({}, state, {
                    loader: false
                });
            }
        default:
            return state;
    }
};

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Auth.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Auth.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Auth.js');

    __REACT_HOT_LOADER__.register(INIT_STATE, 'INIT_STATE', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Auth.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Auth.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/Auth.js');
}();

;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

var initalState = {
    deviceId: CONST.INITIAL_DEVICE_ID,
    // temperatureThreshold: CONST.TEMPERATURE_THRESHOLD,
    // spatialDepthThreshold: CONST.SPATIAL_DEPTH_THRESHOLD,
    // humidityThreshold: CONST.HUMIDITY_THRESHOLD,
    // powerLeakageThreshold: CONST.POWER_LEAKAGE_THRESHOLD,
    // gasLeakageThreshold: CONST.GAS_LEAKAGE_THRESHOLD,
    // batteryChargeThreshold: CONST.BATTERY_CHARGE_THRESHOLD,
    // waterTimeThreshold: CONST.WATER_TIME_THRESHOLD,
    // gasTimeThreshold: CONST.GAS_TIME_THRESHOLD,
    // powerVoltThreshold: CONST.POWER_VOLT_THRESHOLD,
    // intrusionThreshold: CONST.INTRUSION_THRESHOLD,
    thresholds: CONST.THRESHOLDS,
    isLoaderShown: false,
    linkToLogo: null,
    linkOfLogo: null,
    payload: null,
    notificationPageTimestampOfElementToHighlight: null,
    notificationDeviceId: null,
    notificationTimestamp: null,
    deviceCatalogue: {
        data: [],
        pageNumber: 0
    },
    deviceCatalogueFilter: {
        data: [],
        pageNumber: 0
    },
    nodeVitals: {
        data: [],
        pageNumber: 0
    },
    nodeVitalsFilter: {
        data: [],
        pageNumber: 0
    },
    nodeVitalFilter: [],
    deviceCatalogueFilters: [],
    dataExtract: {
        data: [],
        pageNumber: 0
    },
    alertModification: {
        data: [],
        pageNumber: 0
    },
    alertModificationFilter: {
        data: [],
        pageNumber: 0
    },
    alertFilter: []
};

var symbioticReducer = function symbioticReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
    var action = arguments[1];

    switch (action.type) {
        case 'UPDATE_DEVICE_ID':
            return _extends({}, state, {
                deviceId: action.deviceId
            });
        case 'DEVICE_CATELOGUE_DATA':
            return _extends({}, state, {
                deviceCatalogue: action.deviceCatalogue
            });
        case 'DEVICE_CATELOGUE_FILTER_DATA':
            return _extends({}, state, {
                deviceCatalogueFilter: action.deviceCatalogueFilter
            });
        case 'NODE_VITALS_DATA':
            return _extends({}, state, {
                nodeVitals: action.nodeVitals
            });
        case 'NODE_VITALS_FILTER_DATA':
            return _extends({}, state, {
                nodeVitalsFilter: action.nodeVitalsFilter
            });
        case 'NODE_VITALS_FILTER':
            return _extends({}, state, {
                nodeVitalFilter: action.nodeVitalFilter
            });
        case 'DEVICE_CATALOGUE_FILTER':
            return _extends({}, state, {
                deviceCatalogueFilters: action.deviceCatalogueFilters
            });
        case 'EXTRACT_DATA':
            return _extends({}, state, {
                dataExtract: action.dataExtract
            });
        case 'ALERT_MODIFICATION_DATA':
            return _extends({}, state, {
                alertModification: action.alertModification
            });
        case 'ALERT_MODIFICATION_FILTER_DATA':
            return _extends({}, state, {
                alertModificationFilter: action.alertModification
            });
        case 'ALERT_FILTER':
            return _extends({}, state, {
                alertFilter: action.alertFilter
            });
        case 'UPDATE_THRESHOLDS':
            var thresholds = action.data.slice();
            return _extends({}, state, {
                thresholds: _extends({}, state.thresholds, thresholds[0])
                // temperatureThreshold: thresholds[0].thresholdTemperatureValue,
                // spatialDepthThreshold: thresholds[0].thresholdSpatialValue,
                // humidityThreshold: thresholds[0].thresholdHumidityValue,
                // powerLeakageThreshold: thresholds[0].thresholdPowerValue,
                // gasLeakageThreshold: thresholds[0].thresholdGasValue,
                // batteryChargeThreshold: thresholds[0].thresholdBatteryValue,
                // waterTimeThreshold: thresholds[0].thresholdWaterTime,
                // gasTimeThreshold: thresholds[0].thresholdGasTime,
                // powerVoltThreshold: thresholds[0].thresholdPowerVolt,
                // intrusionThreshold: thresholds[0].thresholdIntrusionValue,
            });
        case 'CHANGE_HEARTBEAT_LAYOUT':
            return _extends({}, state, {
                layoutHeartbeat: action.layout
            });
        case 'CHANGE_HEARTBEAT_MA':
            return _extends({}, state, {
                isMARight: action.isRight
            });
        case 'SHOW_OVERALL_APP_LOADER':
            return _extends({}, state, {
                isLoaderShown: true
            });
        case 'HIDE_OVERALL_APP_LOADER':
            return _extends({}, state, {
                isLoaderShown: false
            });
        case 'UPDATE_LOGO_AND_LINK':
            return _extends({}, state, {
                linkToLogo: action.payload.linkToLogo,
                linkOfLogo: action.payload.linkOfLogo
            });
        case 'SIGN_OUT':
            return _extends({}, initalState);
        case 'DEVICE_PAYLOAD':
            return _extends({}, state, {
                payload: action.payload
            });
        case 'UPDATE_DEVICE_ID_AND_TIMESTAMP':
            return _extends({}, state, {
                deviceId: action.deviceId,
                notificationPageTimestampOfElementToHighlight: action.notificationPageTimestampOfElementToHighlight
            });
        case 'MANUAL_CLEAR_CLICKED':
            return _extends({}, state, {
                notificationDeviceId: action.notificationDeviceId,
                notificationTimestamp: action.notificationTimestamp
            });
        default:
            return state;
    }
};

var _default = symbioticReducer;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(initalState, 'initalState', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(symbioticReducer, 'symbioticReducer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(CONST, 'CONST', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(_interopRequireWildcard, '_interopRequireWildcard', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(initalState, 'initalState', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(symbioticReducer, 'symbioticReducer', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/SymbioticReducer.js');
}();

;

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports = {"userPoolId":"ap-southeast-2_86UHUeiBr","clientID":"1qf5mksp3u1fn20sop470odcui","regionName":"ap-southeast-2","accessKeyId":"AKIA5PIDJAVEZHMR7IEB","secretAccessKey":"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","identityPoolId":"ap-southeast-2:194ba2f5-64be-47a2-8bc8-4190773118cf","bucketName":"symbiotic-heartbeat-v2","host":"a24zcer962yu5i-ats.iot.ap-southeast-2.amazonaws.com"}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

// import * as CONST from '../util/app-constants';

var initalState = {
    username: 'James Anderson',
    password: null,
    signedIn: null,
    data: null,
    userAttributes: null,
    isAdmin: null,
    themeToApply: null,
    cognitoUser: null,
    smsNotification: null
};

var profileInfo = function profileInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
    var action = arguments[1];

    if (action.type === 'SIGN_IN') {
        return _extends({}, state, {
            username: action.payload.username,
            password: action.payload.password,
            signedIn: true,
            data: action.loginData
        });
    }

    if (action.type === 'SIGN_OUT') {
        return _extends({}, initalState);
    }

    if (action.type === 'UPDATE_USERNAME') {
        return _extends({}, state, {
            username: action.username
        });
    }
    if (action.type === 'COGNITO_USER_SET') {
        return _extends({}, state, {
            userData: action.userData
        });
    }

    if (action.type === 'UPDATE_EMAIL_VERIFY_FIELD') {
        return _extends({}, state, {
            data: action.payload
        });
    }

    if (action.type === 'FETCHED_USER_ATTRIBUTES') {
        var attributeList = {};
        var name = void 0;
        var value = void 0;
        var isSMSEnabled = void 0;
        for (var i = 0; i < action.payload.length; i += 1) {
            name = action.payload[i].Name;
            value = action.payload[i].Value;
            attributeList[name] = value;
        }
        isSMSEnabled = attributeList['custom:smsNotification'];

        // console.log('Attribute List', attributeList);

        return _extends({}, state, {
            userAttributes: attributeList,
            smsNotification: isSMSEnabled
        });
    }

    if (action.type === 'PROFILE_DETAILS_UPDATE') {
        return _extends({}, state, {
            userAttributes: action.payload
        });
    }

    if (action.type === 'IS_ADMIN?') {
        return _extends({}, state, {
            isAdmin: action.payload
        });
    }

    if (action.type === 'CHANGE_THEME_IN_STORE') {
        return _extends({}, state, {
            themeToApply: action.color
        });
    }
    if (action.type === 'UPDATE_SMS_NOTIFICATION') {
        return _extends({}, state, {
            smsNotification: action.isSMSNotificationChecked
        });
    }

    return state;
};

var _default = profileInfo;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(initalState, 'initalState', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');

    __REACT_HOT_LOADER__.register(profileInfo, 'profileInfo', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');

    __REACT_HOT_LOADER__.register(initalState, 'initalState', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');

    __REACT_HOT_LOADER__.register(profileInfo, 'profileInfo', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/reducers/ProfileInfo.js');
}();

;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1149)('createHashHistory');
module.exports = __webpack_require__(1150).createHashHistory;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1151);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(474)),valueEqual=_interopDefault(__webpack_require__(475));__webpack_require__(180);var invariant=_interopDefault(__webpack_require__(476));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "runSaga", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_buffers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return __WEBPACK_IMPORTED_MODULE_6__internal_io__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1158);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "effects", function() { return __WEBPACK_IMPORTED_MODULE_7__effects__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_8__utils__; });

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(499);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["c" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(155);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(155);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["f" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(65);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["m" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(501);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["d" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["f" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_proc__["a"]; });




/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rootSaga;

var _effects = __webpack_require__(183);

var _Mail = __webpack_require__(1160);

var _Mail2 = _interopRequireDefault(_Mail);

var _Contact = __webpack_require__(1175);

var _Contact2 = _interopRequireDefault(_Contact);

var _Auth = __webpack_require__(1176);

var _Auth2 = _interopRequireDefault(_Auth);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);
//import toDoSagas from './Todo';

// import chatSagas from './Chat';


function rootSaga(getState) {
    return regeneratorRuntime.wrap(function rootSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.all)([(0, _Mail2.default)(),
                    // toDoSagas(),
                    (0, _Contact2.default)(),
                    // chatSagas(),
                    (0, _Auth2.default)()]);

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_Mail2, '_Mail2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');

    __REACT_HOT_LOADER__.register(_Contact2, '_Contact2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');

    __REACT_HOT_LOADER__.register(_Auth2, '_Auth2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');

    __REACT_HOT_LOADER__.register(_marked, '_marked', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/index.js');
}();

;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rootSaga;

var _effects = __webpack_require__(183);

var _Mail = __webpack_require__(502);

var _firebase = __webpack_require__(225);

var _ActionTypes = __webpack_require__(41);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchMailRequest),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

function _asyncToGenerator(fn) {
    return function () {
        var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
            function step(key, arg) {
                try {
                    var info = gen[key](arg);var value = info.value;
                } catch (error) {
                    reject(error);return;
                }if (info.done) {
                    resolve(value);
                } else {
                    return Promise.resolve(value).then(function (value) {
                        step("next", value);
                    }, function (err) {
                        step("throw", err);
                    });
                }
            }return step("next");
        });
    };
}

var getMails = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return _firebase.database.ref('prod/mail').once('value').then(function (snapshot) {
                            var mails = [];
                            snapshot.forEach(function (rawData) {
                                var mail = rawData.val();

                                // change object to array
                                var labels = [];
                                if (mail.labels) {
                                    mail.labels.forEach(function (label) {
                                        return labels.push(label);
                                    });
                                }

                                // change object to array
                                var tos = [];
                                mail.to.forEach(function (to) {
                                    return tos.push(to);
                                });

                                mail.to = tos;
                                mail.labels = labels;
                                mails.push(mail);
                            });
                            return mails;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function getMails() {
        return _ref.apply(this, arguments);
    };
}();

function fetchMailRequest() {
    var fetchedMail;
    return regeneratorRuntime.wrap(function fetchMailRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(getMails);

                case 3:
                    fetchedMail = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)((0, _Mail.fetchMailsSuccess)(fetchedMail));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)((0, _Mail.showMailMessage)(_context2.t0));

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function rootSaga() {
    return regeneratorRuntime.wrap(function rootSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.all)([(0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_MAIL, fetchMailRequest)]);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked2, this);
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fetchMailRequest, 'fetchMailRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(getMails, 'getMails', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_marked, '_marked', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(_marked2, '_marked2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(_asyncToGenerator, '_asyncToGenerator', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(getMails, 'getMails', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(fetchMailRequest, 'fetchMailRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Mail.js');
}();

;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var firebase = __webpack_require__(1162);
__webpack_require__(1166);
__webpack_require__(1168);
__webpack_require__(1171);
__webpack_require__(1173);

module.exports = firebase;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1163);
module.exports = __webpack_require__(184).default;


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(setImmediate, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = Promise;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document) && _isObject(document.createElement);
var _domCreate = function (it) {
  return is ? document.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

_core.inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});
var _shared = function (key) {
  return store[key] || (store[key] = {});
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var SPECIES = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

var find = _core.Array.find;

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

var findIndex = _core.Array.findIndex;

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = _stringContext(this, searchString, STARTS_WITH);
    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var startsWith = _core.String.startsWith;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(503).setImmediate, __webpack_require__(28)))

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(43)))

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1167);


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function() {
  var firebase = __webpack_require__(184).default;
  var g,aa=aa||{},k=this;function l(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
function la(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=la;return r.apply(null,arguments)}
function ma(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var na=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.lb=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.ad=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function oa(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function pa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function qa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}t(qa,u);qa.prototype.name="AssertionError";function ra(a,b){throw new qa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function sa(a,b){this.c=a;this.f=b;this.b=0;this.a=null}sa.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function ta(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function ua(){this.b=this.a=null}var wa=new sa(function(){return new va},function(a){a.reset()});ua.prototype.add=function(a,b){var c=wa.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function xa(){var a=ya,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function va(){this.next=this.b=this.a=null}va.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};va.prototype.reset=function(){this.next=this.b=this.a=null};var za=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},v=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
function Aa(a,b){var c=a.length,d=l(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}
var Ba=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=l(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Ca=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
function Da(a){a:{var b=Ea;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function Fa(a,b){return 0<=za(a,b)}function Ga(a,b){b=za(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function w(a,b){var c=0;Aa(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ha(a){return Array.prototype.concat.apply([],arguments)}
function Ia(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Ja(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var Ka=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};
function La(a){if(!Ma.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(Na,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(Oa,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(Pa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(Qa,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(Ra,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(Sa,"&#0;"));return a}var Na=/&/g,Oa=/</g,Pa=/>/g,Qa=/"/g,Ra=/'/g,Sa=/\x00/g,Ma=/[\x00&<>"']/;function x(a,b){return-1!=a.indexOf(b)}function Ta(a,b){return a<b?-1:a>b?1:0};var Ua;a:{var Va=k.navigator;if(Va){var Wa=Va.userAgent;if(Wa){Ua=Wa;break a}}Ua=""}function y(a){return x(Ua,a)};function Xa(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ya(a){for(var b in a)return!1;return!0}function Za(a){var b={},c;for(c in a)b[c]=a[c];return b}var $a="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ab(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<$a.length;f++)c=$a[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function bb(a){k.setTimeout(function(){throw a;},0)}var cb;
function db(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.rb;c.rb=null;a()}};return function(a){d.next={rb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function eb(a,b){fb||gb();hb||(fb(),hb=!0);ya.add(a,b)}var fb;function gb(){if(k.Promise&&k.Promise.resolve){var a=k.Promise.resolve(void 0);fb=function(){a.then(ib)}}else fb=function(){var a=ib;!n(k.setImmediate)||k.Window&&k.Window.prototype&&!y("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(cb||(cb=db()),cb(a)):k.setImmediate(a)}}var hb=!1,ya=new ua;function ib(){for(var a;a=xa();){try{a.a.call(a.b)}catch(b){bb(b)}ta(wa,a)}hb=!1};function z(a,b){this.a=jb;this.j=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){kb(c,lb,a)},function(a){if(!(a instanceof mb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}kb(c,nb,a)})}catch(d){kb(this,nb,d)}}var jb=0,lb=2,nb=3;function ob(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}ob.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var pb=new sa(function(){return new ob},function(a){a.reset()});
function qb(a,b,c){var d=pb.get();d.g=a;d.b=b;d.f=c;return d}function A(a){if(a instanceof z)return a;var b=new z(ca);kb(b,lb,a);return b}function B(a){return new z(function(b,c){c(a)})}function rb(a,b,c){sb(a,b,c,null)||eb(ma(b,a))}function tb(a){return new z(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},h=function(a){c(a)},m=0,p;m<a.length;m++)p=a[m],rb(p,ma(f,m),h);else b(e)})}
function ub(a){return new z(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Zb:!0,value:f}:{Zb:!1,reason:f};0==c&&b(d)},f=0,h;f<a.length;f++)h=a[f],rb(h,ma(e,f,!0),ma(e,f,!1));else b(d)})}z.prototype.then=function(a,b,c){return vb(this,n(a)?a:null,n(b)?b:null,c)};oa(z);g=z.prototype;g.ha=function(a,b){a=qb(a,a,b);a.c=!0;wb(this,a);return this};g.m=function(a,b){return vb(this,null,a,b)};g.cancel=function(a){this.a==jb&&eb(function(){var b=new mb(a);xb(this,b)},this)};
function xb(a,b){if(a.a==jb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,h=c.b;h&&(h.c||(d++,h.a==a&&(e=h),!(e&&1<d)));h=h.next)e||(f=h);e&&(c.a==jb&&1==d?xb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):yb(c),zb(c,e,nb,b)))}a.c=null}else kb(a,nb,b)}function wb(a,b){a.b||a.a!=lb&&a.a!=nb||Ab(a);a.f?a.f.next=b:a.b=b;a.f=b}
function vb(a,b,c,d){var e=qb(null,null,null);e.a=new z(function(a,h){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(E){h(E)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof mb?h(b):a(e)}catch(E){h(E)}}:h});e.a.c=a;wb(a,e);return e.a}g.Kc=function(a){this.a=jb;kb(this,lb,a)};g.Lc=function(a){this.a=jb;kb(this,nb,a)};
function kb(a,b,c){a.a==jb&&(a===c&&(b=nb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,sb(c,a.Kc,a.Lc,a)||(a.j=c,a.a=b,a.c=null,Ab(a),b!=nb||c instanceof mb||Bb(a,c)))}function sb(a,b,c,d){if(a instanceof z)return wb(a,qb(b||ca,c||null,d)),!0;if(pa(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(n(e))return Cb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Cb(a,b,c,d,e){function f(a){m||(m=!0,d.call(e,a))}function h(a){m||(m=!0,c.call(e,a))}var m=!1;try{b.call(a,h,f)}catch(p){f(p)}}function Ab(a){a.h||(a.h=!0,eb(a.Ub,a))}function yb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}g.Ub=function(){for(var a;a=yb(this);)zb(this,a,this.a,this.j);this.h=!1};
function zb(a,b,c,d){if(c==nb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Db(b,c,d);else try{b.c?b.g.call(b.f):Db(b,c,d)}catch(e){Eb.call(null,e)}ta(pb,b)}function Db(a,b,c){b==lb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Bb(a,b){a.g=!0;eb(function(){a.g&&Eb.call(null,b)})}var Eb=bb;function mb(a){u.call(this,a)}t(mb,u);mb.prototype.name="cancel";function Fb(){0!=Gb&&(Hb[this[ia]||(this[ia]=++ja)]=this);this.pa=this.pa;this.oa=this.oa}var Gb=0,Hb={};Fb.prototype.pa=!1;function Ib(a){if(!a.pa&&(a.pa=!0,a.ua(),0!=Gb)){var b=a[ia]||(a[ia]=++ja);if(0!=Gb&&a.oa&&0<a.oa.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Hb[b]}}Fb.prototype.ua=function(){if(this.oa)for(;this.oa.length;)this.oa.shift()()};function Jb(a){Jb[" "](a);return a}Jb[" "]=ca;function Kb(a,b){var c=Lb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Mb=y("Opera"),C=y("Trident")||y("MSIE"),Nb=y("Edge"),Ob=Nb||C,Pb=y("Gecko")&&!(x(Ua.toLowerCase(),"webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),Qb=x(Ua.toLowerCase(),"webkit")&&!y("Edge");function Rb(){var a=k.document;return a?a.documentMode:void 0}var Sb;
a:{var Tb="",Ub=function(){var a=Ua;if(Pb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Nb)return/Edge\/([\d\.]+)/.exec(a);if(C)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Qb)return/WebKit\/(\S+)/.exec(a);if(Mb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Ub&&(Tb=Ub?Ub[1]:"");if(C){var Vb=Rb();if(null!=Vb&&Vb>parseFloat(Tb)){Sb=String(Vb);break a}}Sb=Tb}var Lb={};
function Wb(a){return Kb(a,function(){for(var b=0,c=Ka(String(Sb)).split("."),d=Ka(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=Ta(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||Ta(0==h[2].length,0==m[2].length)||Ta(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var Xb;var Yb=k.document;
Xb=Yb&&C?Rb()||("CSS1Compat"==Yb.compatMode?parseInt(Sb,10):5):void 0;var Zb=Object.freeze||function(a){return a};var $b=!C||9<=Number(Xb),ac=C&&!Wb("9"),bc=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function D(a,b){this.type=a;this.b=this.target=b;this.Eb=!0}D.prototype.preventDefault=function(){this.Eb=!1};function cc(a,b){D.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Pb){a:{try{Jb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:dc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(cc,D);var dc=Zb({2:"touch",3:"pen",4:"mouse"});cc.prototype.preventDefault=function(){cc.lb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,ac)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};cc.prototype.f=function(){return this.a};var ec="closure_listenable_"+(1E6*Math.random()|0),fc=0;function gc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++fc;this.ma=this.Ha=!1}function hc(a){a.ma=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null};function jc(a){this.src=a;this.a={};this.b=0}jc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=kc(a,b,d,e);-1<h?(b=a[h],c||(b.Ha=!1)):(b=new gc(b,this.src,f,!!d,e),b.Ha=c,a.push(b));return b};function lc(a,b){var c=b.type;c in a.a&&Ga(a.a[c],b)&&(hc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function kc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ma&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var mc="closure_lm_"+(1E6*Math.random()|0),nc={},oc=0;function pc(a,b,c,d,e){if(d&&d.once)qc(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)pc(a,b[f],c,d,e);else c=rc(c),a&&a[ec]?sc(a,b,c,q(d)?!!d.capture:!!d,e):tc(a,b,c,!1,d,e)}
function tc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=q(e)?!!e.capture:!!e,m=uc(a);m||(a[mc]=m=new jc(a));c=m.add(b,c,d,h,f);if(!c.proxy){d=vc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)bc||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(wc(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");oc++}}
function vc(){var a=xc,b=$b?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function qc(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)qc(a,b[f],c,d,e);else c=rc(c),a&&a[ec]?yc(a,b,c,q(d)?!!d.capture:!!d,e):tc(a,b,c,!0,d,e)}
function F(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)F(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=rc(c),a&&a[ec])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=kc(f,c,d,e),-1<c&&(hc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=uc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=kc(b,c,d,e)),(c=-1<a?b[a]:null)&&zc(c))}
function zc(a){if("number"!=typeof a&&a&&!a.ma){var b=a.src;if(b&&b[ec])lc(b.u,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(wc(c),d):b.addListener&&b.removeListener&&b.removeListener(d);oc--;(c=uc(b))?(lc(c,a),0==c.b&&(c.src=null,b[mc]=null)):hc(a)}}}function wc(a){return a in nc?nc[a]:nc[a]="on"+a}
function Ac(a,b,c,d){var e=!0;if(a=uc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ma&&(f=Bc(f,d),e=e&&!1!==f)}return e}function Bc(a,b){var c=a.listener,d=a.La||a.src;a.Ha&&zc(a);return c.call(d,b)}
function xc(a,b){if(a.ma)return!0;if(!$b){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new cc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Ac(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Ac(d[e],a,!1,b),c=c&&f}return c}return Bc(a,
new cc(b,this))}function uc(a){a=a[mc];return a instanceof jc?a:null}var Cc="__closure_events_fn_"+(1E9*Math.random()>>>0);function rc(a){if(n(a))return a;a[Cc]||(a[Cc]=function(b){return a.handleEvent(b)});return a[Cc]};function G(){Fb.call(this);this.u=new jc(this);this.Mb=this;this.Ta=null}t(G,Fb);G.prototype[ec]=!0;G.prototype.addEventListener=function(a,b,c,d){pc(this,a,b,c,d)};G.prototype.removeEventListener=function(a,b,c,d){F(this,a,b,c,d)};
G.prototype.dispatchEvent=function(a){var b,c=this.Ta;if(c)for(b=[];c;c=c.Ta)b.push(c);c=this.Mb;var d=a.type||a;if(l(a))a=new D(a,c);else if(a instanceof D)a.target=a.target||c;else{var e=a;a=new D(d,c);ab(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.b=b[f];e=Dc(h,d,!0,a)&&e}h=a.b=c;e=Dc(h,d,!0,a)&&e;e=Dc(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.b=b[f],e=Dc(h,d,!1,a)&&e;return e};
G.prototype.ua=function(){G.lb.ua.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,hc(d[e]);delete a.a[c];a.b--}}this.Ta=null};function sc(a,b,c,d,e){a.u.add(String(b),c,!1,d,e)}function yc(a,b,c,d,e){a.u.add(String(b),c,!0,d,e)}
function Dc(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.ma&&h.capture==c){var m=h.listener,p=h.La||h.src;h.Ha&&lc(a.u,h);e=!1!==m.call(p,d)&&e}}return e&&0!=d.Eb};function Ec(a,b,c){if(n(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Fc(a){var b=null;return(new z(function(c,d){b=Ec(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).m(function(a){k.clearTimeout(b);throw a;})};function Gc(a){if(a.S&&"function"==typeof a.S)return a.S();if(l(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Hc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(ha(a)||l(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function Ic(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||l(a))v(a,b,void 0);else for(var c=Hc(a),d=Gc(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Kc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Kc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}g=Kc.prototype;g.S=function(){Lc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.U=function(){Lc(this);return this.a.concat()};
g.clear=function(){this.b={};this.c=this.a.length=0};function Lc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Mc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Mc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return Mc(this.b,a)?this.b[a]:b};g.set=function(a,b){Mc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
g.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Mc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Nc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Oc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Pc(a,b){this.b=this.l=this.c="";this.j=null;this.h=this.g="";this.f=!1;if(a instanceof Pc){this.f=void 0!==b?b:a.f;Qc(this,a.c);this.l=a.l;this.b=a.b;Rc(this,a.j);this.g=a.g;b=a.a;var c=new Sc;c.c=b.c;b.a&&(c.a=new Kc(b.a),c.b=b.b);Tc(this,c);this.h=a.h}else a&&(c=String(a).match(Nc))?(this.f=!!b,Qc(this,c[1]||"",!0),this.l=Uc(c[2]||""),this.b=Uc(c[3]||"",!0),Rc(this,c[4]),this.g=Uc(c[5]||"",!0),Tc(this,c[6]||"",!0),this.h=Uc(c[7]||"")):(this.f=!!b,this.a=new Sc(null,this.f))}
Pc.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Vc(b,Wc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(Vc(b,Wc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.j,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Vc(c,"/"==c.charAt(0)?Xc:Yc,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Vc(c,Zc));return a.join("")};
function Qc(a,b,c){a.c=c?Uc(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Rc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.j=b}else a.j=null}function Tc(a,b,c){b instanceof Sc?(a.a=b,$c(a.a,a.f)):(c||(b=Vc(b,ad)),a.a=new Sc(b,a.f))}function H(a,b,c){a.a.set(b,c)}function bd(a,b){return a.a.get(b)}function cd(a){return a instanceof Pc?new Pc(a):new Pc(a,void 0)}function dd(a,b){var c=new Pc(null,void 0);Qc(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
function Uc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Vc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,ed),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function ed(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Wc=/[#\/\?@]/g,Yc=/[#\?:]/g,Xc=/[#\?]/g,ad=/[#\?@]/g,Zc=/#/g;function Sc(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}
function fd(a){a.a||(a.a=new Kc,a.b=0,a.c&&Oc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function gd(a){var b=Hc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Sc(null,void 0);a=Gc(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?hd(c,e,f):c.add(e,f)}return c}g=Sc.prototype;g.add=function(a,b){fd(this);this.c=null;a=id(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};
function jd(a,b){fd(a);b=id(a,b);Mc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Mc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Lc(a)))}g.clear=function(){this.a=this.c=null;this.b=0};function kd(a,b){fd(a);b=id(a,b);return Mc(a.a.b,b)}g.forEach=function(a,b){fd(this);this.a.forEach(function(c,d){v(c,function(c){a.call(b,c,d,this)},this)},this)};g.U=function(){fd(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
g.S=function(a){fd(this);var b=[];if(l(a))kd(this,a)&&(b=Ha(b,this.a.get(id(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Ha(b,a[c])}return b};g.set=function(a,b){fd(this);this.c=null;a=id(this,a);kd(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.S(a):[];return 0<a.length?String(a[0]):b};function hd(a,b,c){jd(a,b);0<c.length&&(a.c=null,a.a.set(id(a,b),Ia(c)),a.b+=c.length)}
g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function id(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function $c(a,b){b&&!a.f&&(fd(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(jd(this,b),hd(this,c,a))},a));a.f=b};var ld=!C||9<=Number(Xb);function md(){this.a="";this.b=nd}md.prototype.la=!0;md.prototype.ja=function(){return this.a};md.prototype.toString=function(){return"Const{"+this.a+"}"};function od(a){if(a instanceof md&&a.constructor===md&&a.b===nd)return a.a;ra("expected object of type Const, got '"+a+"'");return"type_error:Const"}var nd={};function pd(a){var b=new md;b.a=a;return b}pd("");function qd(){this.a="";this.b=rd}qd.prototype.la=!0;qd.prototype.ja=function(){return this.a};qd.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function sd(a){if(a instanceof qd&&a.constructor===qd&&a.b===rd)return a.a;ra("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}
function td(a,b){var c=od(a);if(!ud.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(vd,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof md?od(a):encodeURIComponent(String(a))});return wd(a)}var vd=/%{(\w+)}/g,ud=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank#/i,rd={};
function wd(a){var b=new qd;b.a=a;return b};function xd(){this.a="";this.b=yd}xd.prototype.la=!0;xd.prototype.ja=function(){return this.a};xd.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function zd(a){if(a instanceof xd&&a.constructor===xd&&a.b===yd)return a.a;ra("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var Ad=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function Bd(a){if(a instanceof xd)return a;a=a.la?a.ja():String(a);Ad.test(a)||(a="about:invalid#zClosurez");return Cd(a)}var yd={};function Cd(a){var b=new xd;b.a=a;return b}Cd("about:blank");function Dd(){this.a="";this.b=Ed}Dd.prototype.la=!0;Dd.prototype.ja=function(){return this.a};Dd.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Fd(a){if(a instanceof Dd&&a.constructor===Dd&&a.b===Ed)return a.a;ra("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var Ed={};function Gd(a){var b=new Dd;b.a=a;return b}Gd("<!DOCTYPE html>");Gd("");Gd("<br>");function Hd(a){var b=document;return l(a)?b.getElementById(a):a}function Id(a,b){Xa(b,function(b,d){b&&b.la&&(b=b.ja());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Jd.hasOwnProperty(d)?a.setAttribute(Jd[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
var Jd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function Kd(a,b,c){var d=arguments,e=document,f=String(d[0]),h=d[1];if(!ld&&h&&(h.name||h.type)){f=["<",f];h.name&&f.push(' name="',La(h.name),'"');if(h.type){f.push(' type="',La(h.type),'"');var m={};ab(m,h);delete m.type;h=m}f.push(">");f=f.join("")}f=e.createElement(f);h&&(l(h)?f.className=h:fa(h)?f.className=h.join(" "):Id(f,h));2<d.length&&Ld(e,f,d);return f}
function Ld(a,b,c){function d(c){c&&b.appendChild(l(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):v(Md(f)?Ia(f):f,d)}}function Md(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(n(a))return"function"==typeof a.item}return!1};function Nd(a){var b=[];Od(new Pd,a,b);return b.join("")}function Pd(){}
function Od(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Od(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Qd(d,c),c.push(":"),Od(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Qd(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Rd={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Sd=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function Qd(a,b){b.push('"',a.replace(Sd,function(a){var b=Rd[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Rd[a]=b);return b}),'"')};function Td(){var a=I();return C&&!!Xb&&11==Xb||/Edge\/\d+/.test(a)}function Ud(){return k.window&&k.window.location.href||self&&self.location&&self.location.href||""}function Vd(a,b){b=b||k.window;var c="about:blank";a&&(c=zd(Bd(a)));b.location.href=c}
function Wd(a,b){var c=[],d;for(d in a)if(d in b)if(typeof a[d]!=typeof b[d])c.push(d);else if(fa(a[d])){a:{var e=void 0;var f=a[d],h=b[d];for(e in f)if(!(e in h)||f[e]!==h[e]){e=!1;break a}for(e in h)if(!(e in f)){e=!1;break a}e=!0}e||c.push(d)}else"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Wd(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d);else c.push(d);for(d in b)d in a||c.push(d);return c}
function Xd(){var a=I();a=Yd(a)!=Zd?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!C||!Xb||9<Xb}function $d(a){a=(a||I()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ae(a){a=a||k.window;try{a.close()}catch(b){}}
function be(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=I().toLowerCase();d&&(b.target=d,x(c,"crios/")&&(b.target="_blank"));Yd(I())==ce&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof xd?c:Bd("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
for(h in a)switch(h){case "width":case "height":case "top":case "left":e.push(h+"="+a[h]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(h+"="+(a[h]?1:0))}var h=e.join(",");(y("iPhone")&&!y("iPod")&&!y("iPad")||y("iPad")||y("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(h=d.document.createElement("A"),b instanceof xd||b instanceof xd||(b=b.la?b.ja():String(b),Ad.test(b)||(b="about:invalid#zClosurez"),b=Cd(b)),h.href=zd(b),h.setAttribute("target",c),a.noreferrer&&
h.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),h.dispatchEvent(a),h={}):a.noreferrer?(h=d.open("",c,h),a=zd(b),h&&(Ob&&x(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),h.opener=null,pd("b/12014412, meta tag with sanitized URL"),a='<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+La(a)+'">',a=Gd(a),h.document.write(Fd(a)),h.document.close())):(h=d.open(zd(b),c,h))&&a.noopener&&(h.opener=null);if(h)try{h.focus()}catch(m){}return h}
function de(a){return new z(function(b){function c(){Fc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var ee=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function fe(){var a=null;return(new z(function(b){"complete"==k.document.readyState?b():(a=function(){b()},qc(window,"load",a))})).m(function(b){F(window,"load",a);throw b;})}
function ge(){return he(void 0)?fe().then(function(){return new z(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):B(Error("Cordova must run in an Android or iOS file scheme."))}function he(a){a=a||I();return!("file:"!==ie()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function je(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function ke(){return"object"!==typeof k.window&&"function"===typeof k.importScripts}function le(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":ke()?"Worker":"Browser"}function me(){var a=le();return"ReactNative"===a||"Node"===a}var ce="Firefox",Zd="Chrome";
function Yd(a){var b=a.toLowerCase();if(x(b,"opera/")||x(b,"opr/")||x(b,"opios/"))return"Opera";if(x(b,"iemobile"))return"IEMobile";if(x(b,"msie")||x(b,"trident/"))return"IE";if(x(b,"edge/"))return"Edge";if(x(b,"firefox/"))return ce;if(x(b,"silk/"))return"Silk";if(x(b,"blackberry"))return"Blackberry";if(x(b,"webos"))return"Webos";if(!x(b,"safari/")||x(b,"chrome/")||x(b,"crios/")||x(b,"android"))if(!x(b,"chrome/")&&!x(b,"crios/")||x(b,"edge/")){if(x(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return Zd;else return"Safari";return"Other"}var ne={Qc:"FirebaseCore-web",Sc:"FirebaseUI-web"};function oe(a,b){b=b||[];var c=[],d={},e;for(e in ne)d[ne[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=le();"Browser"===c?(d=I(),c=Yd(d)):"Worker"===c&&(d=I(),c=Yd(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function I(){return k.navigator&&k.navigator.userAgent||""}
function J(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function pe(){try{var a=k.localStorage,b=qe();if(a)return a.setItem(b,"1"),a.removeItem(b),Td()?!!k.indexedDB:!0}catch(c){return ke()&&!!k.indexedDB}return!1}function re(){return(se()||"chrome-extension:"===ie()||he())&&!me()&&pe()&&!ke()}function se(){return"http:"===ie()||"https:"===ie()}function ie(){return k.location&&k.location.protocol||null}
function te(a){a=a||I();return $d(a)||Yd(a)==ce?!1:!0}function ue(a){return"undefined"===typeof a?null:Nd(a)}function ve(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function we(a){if(null!==a)return JSON.parse(a)}function qe(a){return a?a:Math.floor(1E9*Math.random()).toString()}function xe(a){a=a||I();return"Safari"==Yd(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function ye(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function ze(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=I();b=le();this.b=$d(a)||"ReactNative"===b}
ze.prototype.get=function(){var a=k.navigator;return(a&&"boolean"===typeof a.onLine&&(se()||"chrome-extension:"===ie()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Ae(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function Be(){var a=k.document,b=null;return Ae()||!a?A():(new z(function(c){b=function(){Ae()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).m(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Ce(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function De(){return!(!J("fireauth.oauthhelper",k)&&!J("fireauth.iframe",k))};var Ee={};var Fe;try{var Ge={};Object.defineProperty(Ge,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Ge,"abcd",{configurable:!0,enumerable:!0,value:2});Fe=2==Ge.abcd}catch(a){Fe=!1}function K(a,b,c){Fe?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function L(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&K(a,c,b[c])}function He(a){var b={};L(b,a);return b}function Ie(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function Je(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function Ke(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)K(b,c,Ke(a[c]))}return b};function Le(a){var b={},c=a[Me],d=a[Ne];a=a[Oe];if(!a||a!=Pe&&!c)throw Error("Invalid provider user info!");b[Qe]=d||null;b[Re]=c||null;K(this,Se,a);K(this,Te,Ke(b))}var Pe="EMAIL_SIGNIN",Me="email",Ne="newEmail",Oe="requestType",Re="email",Qe="fromEmail",Te="data",Se="operation";function M(a,b){this.code=Ue+a;this.message=b||Ve[a]||""}t(M,Error);M.prototype.C=function(){return{code:this.code,message:this.message}};M.prototype.toJSON=function(){return this.C()};function We(a){var b=a&&a.code;return b?new M(b.substring(Ue.length),a.message):null}
var Ue="auth/",Ve={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
"invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
"invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
"invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.",
"user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function Xe(a){var b=a[Ye];if("undefined"===typeof b)throw new M("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new M("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[Ze];if(c&&"object"===typeof c){b=c[$e];var d=c[af];c=c[bf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new M("argument-error",af+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new M("argument-error",bf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new M("argument-error",$e+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new M("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new M("argument-error",Ze+" property must be a non null object when specified.");this.f=null;if((b=a[cf])&&"object"===
typeof b)if(b=b[df],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new M("argument-error",df+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new M("argument-error",cf+" property must be a non null object when specified.");a=a[ef];if("undefined"!==typeof a&&"boolean"!==typeof a)throw new M("argument-error",ef+" property must be a boolean when specified.");this.c=!!a}
var Ze="android",ef="handleCodeInApp",cf="iOS",Ye="url",af="installApp",bf="minimumVersion",$e="packageName",df="bundleId";function ff(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;for(var c in b)null===b[c]&&delete b[c];return b};function gf(a){return Ba(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var hf=null,jf=null;function kf(a){var b="";lf(a,function(a){b+=String.fromCharCode(a)});return b}function lf(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=jf[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}mf();for(var d=0;;){var e=c(-1),f=c(0),h=c(64),m=c(64);if(64===m&&-1===e)break;b(e<<2|f>>4);64!=h&&(b(f<<4&240|h>>2),64!=m&&b(h<<6&192|m))}}
function mf(){if(!hf){hf={};jf={};for(var a=0;65>a;a++)hf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),jf[hf[a]]=a,62<=a&&(jf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function nf(a){this.c=a.sub;na();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}nf.prototype.f=function(){return this.b};function of(a){return(a=pf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new nf(a):null}function pf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(kf(a))}catch(d){}return null};var qf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),rf=["client_id","response_type","scope","redirect_uri","state"],sf={Rc:{Ma:"locale",Aa:500,za:600,Na:"facebook.com",cb:rf},Tc:{Ma:null,Aa:500,za:620,Na:"github.com",cb:rf},Uc:{Ma:"hl",Aa:515,za:680,Na:"google.com",cb:rf},$c:{Ma:"lang",Aa:485,za:705,Na:"twitter.com",cb:qf}};function tf(a){for(var b in sf)if(sf[b].Na==a)return sf[b];return null};function uf(a){var b={};b["facebook.com"]=vf;b["google.com"]=wf;b["github.com"]=xf;b["twitter.com"]=yf;var c=a&&a[zf];try{if(c)return b[c]?new b[c](a):new Af(a);if("undefined"!==typeof a[Bf])return new Cf(a)}catch(d){}return null}var Bf="idToken",zf="providerId";
function Cf(a){var b=a[zf];if(!b&&a[Bf]){var c=of(a[Bf]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);K(this,"providerId",b);K(this,"isNewUser",c)}function Af(a){Cf.call(this,a);a=we(a.rawUserInfo||"{}");K(this,"profile",Ke(a||{}))}t(Af,Cf);
function vf(a){Af.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(vf,Af);function xf(a){Af.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",this.profile&&this.profile.login||null)}t(xf,Af);function wf(a){Af.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(wf,Af);
function yf(a){Af.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",a.screenName||null)}t(yf,Af);function Df(a){this.a=cd(a)};function Ef(a){var b=cd(a),c=bd(b,"link"),d=bd(cd(c),"link");b=bd(b,"deep_link_id");return bd(cd(b),"link")||b||d||c||a};function Ff(a,b){return a.then(function(a){if(a[Gf]){var c=of(a[Gf]);if(!c||b!=c.c)throw new M("user-mismatch");return a}throw new M("user-mismatch");}).m(function(a){throw a&&a.code&&a.code==Ue+"user-not-found"?new M("user-mismatch"):a;})}
function Hf(a,b,c){if(b.idToken||b.accessToken)b.idToken&&K(this,"idToken",b.idToken),b.accessToken&&K(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)K(this,"accessToken",b.oauthToken),K(this,"secret",b.oauthTokenSecret);else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",c)}Hf.prototype.xa=function(a){return If(a,Jf(this))};Hf.prototype.c=function(a,b){var c=Jf(this);c.idToken=b;return Kf(a,c)};
Hf.prototype.f=function(a,b){var c=Jf(this);return Ff(Lf(a,c),b)};function Jf(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:gd(b).toString(),requestUri:"http://localhost"}}
Hf.prototype.C=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};function Mf(a,b){this.Ac=b||[];L(this,{providerId:a,isOAuthProvider:!0});this.tb={};this.Za=(tf(a)||{}).Ma||null;this.Xa=null}Mf.prototype.Ca=function(a){this.tb=Za(a);return this};function N(a){Mf.call(this,a,rf);this.a=[]}t(N,Mf);
N.prototype.ta=function(a){Fa(this.a,a)||this.a.push(a);return this};N.prototype.yb=function(){return Ia(this.a)};N.prototype.credential=function(a,b){if(!a&&!b)throw new M("argument-error","credential failed: must provide the ID token and/or the access token.");return new Hf(this.providerId,{idToken:a||null,accessToken:b||null},this.providerId)};function Nf(){N.call(this,"facebook.com")}t(Nf,N);K(Nf,"PROVIDER_ID","facebook.com");K(Nf,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function Of(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Nf).credential(null,b)}function Pf(){N.call(this,"github.com")}t(Pf,N);K(Pf,"PROVIDER_ID","github.com");K(Pf,"GITHUB_SIGN_IN_METHOD","github.com");function Qf(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Pf).credential(null,b)}
function Rf(){N.call(this,"google.com");this.ta("profile")}t(Rf,N);K(Rf,"PROVIDER_ID","google.com");K(Rf,"GOOGLE_SIGN_IN_METHOD","google.com");function Sf(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new Rf).credential(c,b)}function Tf(){Mf.call(this,"twitter.com",qf)}t(Tf,Mf);K(Tf,"PROVIDER_ID","twitter.com");K(Tf,"TWITTER_SIGN_IN_METHOD","twitter.com");
function Uf(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new M("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Hf("twitter.com",c,"twitter.com")}function Vf(a,b,c){this.a=a;this.b=b;K(this,"providerId","password");K(this,"signInMethod",c===O.EMAIL_LINK_SIGN_IN_METHOD?O.EMAIL_LINK_SIGN_IN_METHOD:O.EMAIL_PASSWORD_SIGN_IN_METHOD)}
Vf.prototype.xa=function(a){return this.signInMethod==O.EMAIL_LINK_SIGN_IN_METHOD?P(a,Wf,{email:this.a,oobCode:this.b}):P(a,Xf,{email:this.a,password:this.b})};Vf.prototype.c=function(a,b){return this.signInMethod==O.EMAIL_LINK_SIGN_IN_METHOD?P(a,Yf,{idToken:b,email:this.a,oobCode:this.b}):P(a,Zf,{idToken:b,email:this.a,password:this.b})};Vf.prototype.f=function(a,b){return Ff(this.xa(a),b)};Vf.prototype.C=function(){return{email:this.a,password:this.b,signInMethod:this.signInMethod}};
function O(){L(this,{providerId:"password",isOAuthProvider:!1})}function $f(a,b){b=ag(b);if(!b)throw new M("argument-error","Invalid email link!");return new Vf(a,b,O.EMAIL_LINK_SIGN_IN_METHOD)}function ag(a){a=Ef(a);a=new Df(a);var b=bd(a.a,"oobCode")||null;return"signIn"===(bd(a.a,"mode")||null)&&b?b:null}L(O,{PROVIDER_ID:"password"});L(O,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});L(O,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
function bg(a){if(!(a.Ra&&a.Qa||a.Ea&&a.Z))throw new M("internal-error");this.a=a;K(this,"providerId","phone");K(this,"signInMethod","phone")}bg.prototype.xa=function(a){return a.Sa(cg(this))};bg.prototype.c=function(a,b){var c=cg(this);c.idToken=b;return P(a,dg,c)};bg.prototype.f=function(a,b){var c=cg(this);c.operation="REAUTH";a=P(a,eg,c);return Ff(a,b)};
bg.prototype.C=function(){var a={providerId:"phone"};this.a.Ra&&(a.verificationId=this.a.Ra);this.a.Qa&&(a.verificationCode=this.a.Qa);this.a.Ea&&(a.temporaryProof=this.a.Ea);this.a.Z&&(a.phoneNumber=this.a.Z);return a};function cg(a){return a.a.Ea&&a.a.Z?{temporaryProof:a.a.Ea,phoneNumber:a.a.Z}:{sessionInfo:a.a.Ra,code:a.a.Qa}}
function fg(a){try{this.a=a||firebase.auth()}catch(b){throw new M("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}L(this,{providerId:"phone",isOAuthProvider:!1})}
fg.prototype.Sa=function(a,b){var c=this.a.b;return A(b.verify()).then(function(d){if(!l(d))throw new M("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return gg(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new M("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function hg(a,b){if(!a)throw new M("missing-verification-id");if(!b)throw new M("missing-verification-code");return new bg({Ra:a,Qa:b})}L(fg,{PROVIDER_ID:"phone"});L(fg,{PHONE_SIGN_IN_METHOD:"phone"});
function ig(a){if(a.temporaryProof&&a.phoneNumber)return new bg({Ea:a.temporaryProof,Z:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return Sf(a,c);case "facebook.com":return Of(c);case "github.com":return Qf(c);case "twitter.com":return Uf(c,d);default:return(new N(b)).credential(a,c)}}catch(e){return null}}
function jg(a){if(!a.isOAuthProvider)throw new M("invalid-oauth-provider");};function kg(a,b,c,d,e){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new M("invalid-auth-event");if(this.f&&!this.g)throw new M("invalid-auth-event");}else throw new M("invalid-auth-event");}kg.prototype.C=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,error:this.a&&this.a.C()}};function lg(a){a=a||{};return a.type?new kg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&We(a.error)):null};function mg(){this.b=null;this.a=[]}var ng=null;mg.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(a){for(var c=0;c<b.a.length;c++)b.a[c](a)},a=J("universalLinks.subscribe",k),"function"===typeof a&&a(null,this.b))};mg.prototype.unsubscribe=function(a){w(this.a,function(b){return b==a})};function og(a){var b="unauthorized-domain",c=void 0,d=cd(a);a=d.b;d=d.c;"chrome-extension"==d?c=Ja("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Ja("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
M.call(this,b,c)}t(og,M);function pg(a,b,c){M.call(this,a,c);a=b||{};a.ub&&K(this,"email",a.ub);a.Z&&K(this,"phoneNumber",a.Z);a.credential&&K(this,"credential",a.credential)}t(pg,M);pg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.C();b&&ab(a,b);return a};pg.prototype.toJSON=function(){return this.C()};
function qg(a){if(a.code){var b=a.code||"";0==b.indexOf(Ue)&&(b=b.substring(Ue.length));var c={credential:ig(a)};if(a.email)c.ub=a.email;else if(a.phoneNumber)c.Z=a.phoneNumber;else return new M(b,a.message||void 0);return new pg(b,c,a.message)}return null};var rg=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function sg(){}sg.prototype.c=null;function tg(a){return a.c||(a.c=a.b())};var ug;function vg(){}t(vg,sg);vg.prototype.a=function(){var a=wg(this);return a?new ActiveXObject(a):new XMLHttpRequest};vg.prototype.b=function(){var a={};wg(this)&&(a[0]=!0,a[1]=!0);return a};
function wg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}ug=new vg;function xg(){}t(xg,sg);xg.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new yg;throw Error("Unsupported browser");};xg.prototype.b=function(){return{}};
function yg(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText="";this.a.onload=r(this.bc,this);this.a.onerror=r(this.zb,this);this.a.onprogress=r(this.cc,this);this.a.ontimeout=r(this.fc,this)}g=yg.prototype;g.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
g.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};g.abort=function(){this.a.abort()};g.setRequestHeader=function(){};g.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};g.bc=function(){this.status=200;this.responseText=this.a.responseText;zg(this,4)};g.zb=function(){this.status=500;this.responseText="";zg(this,4)};g.fc=function(){this.zb()};
g.cc=function(){this.status=200;zg(this,1)};function zg(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}g.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Ag(a,b,c){this.reset(a,b,c,void 0,void 0)}Ag.prototype.a=null;var Bg=0;Ag.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Bg++;d||na();delete this.a};function Cg(a){this.f=a;this.b=this.c=this.a=null}function Dg(a,b){this.name=a;this.value=b}Dg.prototype.toString=function(){return this.name};var Eg=new Dg("SEVERE",1E3),Fg=new Dg("WARNING",900),Gg=new Dg("CONFIG",700),Hg=new Dg("FINE",500);function Ig(a){if(a.c)return a.c;if(a.a)return Ig(a.a);ra("Root logger has no level set.");return null}Cg.prototype.log=function(a,b,c){if(a.value>=Ig(this).value)for(n(b)&&(b=b()),a=new Ag(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Jg={},Kg=null;
function Lg(a){Kg||(Kg=new Cg(""),Jg[""]=Kg,Kg.c=Gg);var b;if(!(b=Jg[a])){b=new Cg(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Lg(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Jg[a]=b}return b};function Q(a,b){a&&a.log(Hg,b,void 0)};function Mg(a){this.f=a}t(Mg,sg);Mg.prototype.a=function(){return new Ng(this.f)};Mg.prototype.b=function(a){return function(){return a}}({});function Ng(a){G.call(this);this.j=a;this.readyState=Og;this.status=0;this.responseText=this.statusText="";this.onreadystatechange=null;this.g=new Headers;this.b=null;this.h="GET";this.c="";this.a=!1;this.f=Lg("goog.net.FetchXmlHttp")}t(Ng,G);var Og=0;g=Ng.prototype;
g.open=function(a,b){if(this.readyState!=Og)throw this.abort(),Error("Error reopening a connection");this.h=a;this.c=b;this.readyState=1;Pg(this)};g.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.g,method:this.h,credentials:void 0,cache:void 0};a&&(b.body=a);this.j.fetch(new Request(this.c,b)).then(this.ec.bind(this),this.Ab.bind(this))};
g.abort=function(){this.responseText="";this.g=new Headers;this.status=0;1<=this.readyState&&this.a&&4!=this.readyState&&(this.readyState=4,this.a=!1,Pg(this));this.readyState=Og};g.ec=function(a){this.a&&(this.b||(this.b=a.headers,this.readyState=2,Pg(this)),this.a&&(this.readyState=3,Pg(this),this.a&&a.text().then(this.dc.bind(this,a),this.Ab.bind(this))))};g.dc=function(a,b){this.a&&(this.status=a.status,this.statusText=a.statusText,this.responseText=b,this.readyState=4,Pg(this))};
g.Ab=function(a){var b=this.f;b&&b.log(Fg,"Failed to fetch url "+this.c,a instanceof Error?a:Error(a));this.a&&(this.readyState=4,Pg(this))};g.setRequestHeader=function(a,b){this.g.append(a,b)};g.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.f)&&a.log(Fg,"Attempting to get response header but no headers have been received for url: "+this.c,void 0),"")};
g.getAllResponseHeaders=function(){if(!this.b){var a=this.f;a&&a.log(Fg,"Attempting to get all response headers but no headers have been received for url: "+this.c,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Pg(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Qg(a){G.call(this);this.headers=new Kc;this.D=a||null;this.c=!1;this.B=this.a=null;this.h=this.N=this.l="";this.f=this.I=this.j=this.G=!1;this.g=0;this.s=null;this.o=Rg;this.v=this.O=!1}t(Qg,G);var Rg="";Qg.prototype.b=Lg("goog.net.XhrIo");var Sg=/^https?$/i,Tg=["POST","PUT"];
function Ug(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.D?a.D.a():ug.a();a.B=a.D?tg(a.D):tg(ug);a.a.onreadystatechange=r(a.Db,a);try{Q(a.b,Vg(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(h){Q(a.b,Vg(a,"Error opening Xhr: "+h.message));Wg(a,h);return}b=d||"";var f=new Kc(a.headers);e&&Ic(e,function(a,b){f.set(b,a)});e=Da(f.U());d=k.FormData&&b instanceof
k.FormData;!Fa(Tg,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.o&&(a.a.responseType=a.o);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{Xg(a),0<a.g&&(a.v=Yg(a.a),Q(a.b,Vg(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=r(a.Fa,a)):a.s=Ec(a.Fa,a.g,a)),Q(a.b,Vg(a,"Sending request")),a.j=!0,a.a.send(b),a.j=!1}catch(h){Q(a.b,Vg(a,
"Send error: "+h.message)),Wg(a,h)}}function Yg(a){return C&&Wb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ea(a){return"content-type"==a.toLowerCase()}g=Qg.prototype;g.Fa=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Q(this.b,Vg(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function Wg(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;Zg(a);$g(a)}
function Zg(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}g.abort=function(){this.a&&this.c&&(Q(this.b,Vg(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),$g(this))};g.ua=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),$g(this,!0));Qg.lb.ua.call(this)};g.Db=function(){this.pa||(this.I||this.j||this.f?ah(this):this.tc())};g.tc=function(){ah(this)};
function ah(a){if(a.c&&"undefined"!=typeof aa)if(a.B[1]&&4==bh(a)&&2==ch(a))Q(a.b,Vg(a,"Local request error detected and ignored"));else if(a.j&&4==bh(a))Ec(a.Db,0,a);else if(a.dispatchEvent("readystatechange"),4==bh(a)){Q(a.b,Vg(a,"Request complete"));a.c=!1;try{var b=ch(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Nc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
f=h.substr(0,h.length-1)}e=!Sg.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var m=2<bh(a)?a.a.statusText:""}catch(p){Q(a.b,"Can not get status: "+p.message),m=""}a.h=m+" ["+ch(a)+"]";Zg(a)}}finally{$g(a)}}}function $g(a,b){if(a.a){Xg(a);var c=a.a,d=a.B[0]?ca:null;a.a=null;a.B=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Eg,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function Xg(a){a.a&&a.v&&(a.a.ontimeout=null);a.s&&(k.clearTimeout(a.s),a.s=null)}function bh(a){return a.a?a.a.readyState:0}function ch(a){try{return 2<bh(a)?a.a.status:-1}catch(b){return-1}}function dh(a){try{return a.a?a.a.responseText:""}catch(b){return Q(a.b,"Can not get responseText: "+b.message),""}}
g.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.o){case Rg:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Eg,"Response type "+this.o+" is not supported on this browser",void 0);return null}catch(b){return Q(this.b,"Can not get response: "+b.message),null}};function Vg(a,b){return b+" ["+a.N+" "+a.l+" "+ch(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function eh(a,b){this.g=[];this.v=a;this.s=b||null;this.f=this.a=!1;this.c=void 0;this.u=this.B=this.j=!1;this.h=0;this.b=null;this.l=0}eh.prototype.cancel=function(a){if(this.a)this.c instanceof eh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.s,this):this.u=!0;this.a||(a=new fh(this),gh(this),hh(this,!1,a))}};eh.prototype.o=function(a,b){this.j=!1;hh(this,a,b)};function hh(a,b,c){a.a=!0;a.c=c;a.f=!b;ih(a)}
function gh(a){if(a.a){if(!a.u)throw new jh(a);a.u=!1}}eh.prototype.D=function(){gh(this);hh(this,!0,null)};function kh(a,b){lh(a,null,b,void 0)}function lh(a,b,c,d){a.g.push([b,c,d]);a.a&&ih(a)}eh.prototype.then=function(a,b,c){var d,e,f=new z(function(a,b){d=a;e=b});lh(this,d,function(a){a instanceof fh?f.cancel():e(a)});return f.then(a,b,c)};oa(eh);function mh(a){return Ca(a.g,function(a){return n(a[1])})}
function ih(a){if(a.h&&a.a&&mh(a)){var b=a.h,c=nh[b];c&&(k.clearTimeout(c.a),delete nh[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.j;){var e=a.g.shift(),f=e[0],h=e[1];e=e[2];if(f=a.f?h:f)try{var m=f.call(e||a.s,b);void 0!==m&&(a.f=a.f&&(m==b||m instanceof Error),a.c=b=m);if(pa(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.j=!0}catch(p){b=p,a.f=!0,mh(a)||(c=!0)}}a.c=b;d&&(m=r(a.o,a,!0),d=r(a.o,a,!1),b instanceof eh?(lh(b,m,d),b.B=!0):b.then(m,d));c&&(b=
new oh(b),nh[b.a]=b,a.h=b.a)}function jh(){u.call(this)}t(jh,u);jh.prototype.message="Deferred has already fired";jh.prototype.name="AlreadyCalledError";function fh(){u.call(this)}t(fh,u);fh.prototype.message="Deferred was canceled";fh.prototype.name="CanceledError";function oh(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}oh.prototype.c=function(){delete nh[this.a];throw this.b;};var nh={};function ph(a){var b={},c=b.document||document,d=sd(a),e=document.createElement("SCRIPT"),f={Fb:e,Fa:void 0},h=new eh(qh,f),m=null,p=null!=b.timeout?b.timeout:5E3;0<p&&(m=window.setTimeout(function(){rh(e,!0);var a=new sh(th,"Timeout reached for loading script "+d);gh(h);hh(h,!1,a)},p),f.Fa=m);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(rh(e,b.bd||!1,m),h.D())};e.onerror=function(){rh(e,!0,m);var a=new sh(uh,"Error while loading script "+
d);gh(h);hh(h,!1,a)};f=b.attributes||{};ab(f,{type:"text/javascript",charset:"UTF-8"});Id(e,f);e.src=sd(a);vh(c).appendChild(e);return h}function vh(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function qh(){if(this&&this.Fb){var a=this.Fb;a&&"SCRIPT"==a.tagName&&rh(a,!0,this.Fa)}}
function rh(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var uh=0,th=1;function sh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(sh,u);function wh(a){this.f=a}t(wh,sg);wh.prototype.a=function(){return new this.f};wh.prototype.b=function(){return{}};
function xh(a,b,c){this.b=a;a=b||{};this.j=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.l=a.secureTokenTimeout||yh;this.f=Za(a.secureTokenHeaders||zh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Ah;this.a=Za(a.firebaseHeaders||Bh);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==le();c=k.XMLHttpRequest||c&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!c&&
!ke())throw new M("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;ke()?this.c=new Mg(self):me()?this.c=new wh(c):this.c=new xg}var Ch,Gf="idToken",yh=new ze(3E4,6E4),zh={"Content-Type":"application/x-www-form-urlencoded"},Ah=new ze(3E4,6E4),Bh={"Content-Type":"application/json"};function Dh(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function Eh(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function Fh(a,b,c,d,e,f,h){Xd()||ke()?a=r(a.o,a):(Ch||(Ch=new z(function(a,b){Gh(a,b)})),a=r(a.u,a));a(b,c,d,e,f,h)}
xh.prototype.o=function(a,b,c,d,e,f){if(ke()&&("undefined"===typeof k.fetch||"undefined"===typeof k.Headers||"undefined"===typeof k.Request))throw new M("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var h=new Qg(this.c);if(f){h.g=Math.max(0,f);var m=setTimeout(function(){h.dispatchEvent("timeout")},f)}sc(h,"complete",function(){m&&clearTimeout(m);var a=null;try{a=
JSON.parse(dh(this))||null}catch(E){a=null}b&&b(a)});yc(h,"ready",function(){m&&clearTimeout(m);Ib(this)});yc(h,"timeout",function(){m&&clearTimeout(m);Ib(this);b&&b(null)});Ug(h,a,c,d,e)};var Hh=pd("https://apis.google.com/js/client.js?onload=%{onload}"),Ih="__fcb"+Math.floor(1E6*Math.random()).toString();
function Gh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Ih]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=td(Hh,{onload:Ih});kh(ph(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
xh.prototype.u=function(a,b,c,d,e){var f=this;Ch.then(function(){window.gapi.client.setApiKey(f.b);var h=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(h);b&&b(a)}})}).m(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
function Jh(a,b){return new z(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Fh(a,a.j+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Kh(a)):a.access_token&&a.refresh_token?c(a):d(new M("internal-error")):d(new M("network-request-failed"))},"POST",gd(b).toString(),a.f,a.l.get()):d(new M("internal-error"))})}
function Lh(a,b,c,d,e,f){var h=cd(a.g+b);H(h,"key",a.b);f&&H(h,"cb",na().toString());var m="GET"==c;if(m)for(var p in d)d.hasOwnProperty(p)&&H(h,p,d[p]);return new z(function(b,f){Fh(a,h.toString(),function(a){a?a.error?f(Kh(a,e||{})):b(a):f(new M("network-request-failed"))},c,m?void 0:Nd(ve(d)),a.a,a.h.get())})}function Mh(a){if(!rg.test(a.email))throw new M("invalid-email");}function Nh(a){"email"in a&&Mh(a)}
function Oh(a,b){return P(a,Ph,{identifier:b,continueUri:se()?Ud():"http://localhost"}).then(function(a){return a.allProviders||[]})}function Qh(a,b){return P(a,Ph,{identifier:b,continueUri:se()?Ud():"http://localhost"}).then(function(a){return a.signinMethods||[]})}function Rh(a){return P(a,Sh,{}).then(function(a){return a.authorizedDomains||[]})}function Th(a){if(!a[Gf])throw new M("internal-error");}
function Uh(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new M("internal-error");}else{if(!a.sessionInfo)throw new M("missing-verification-id");if(!a.code)throw new M("missing-verification-code");}}xh.prototype.jb=function(){return P(this,Vh,{})};xh.prototype.mb=function(a,b){return P(this,Wh,{idToken:a,email:b})};xh.prototype.nb=function(a,b){return P(this,Zf,{idToken:a,password:b})};var Xh={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};g=xh.prototype;
g.ob=function(a,b){var c={idToken:a},d=[];Xa(Xh,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return P(this,Wh,c)};g.gb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};ab(a,b);return P(this,Yh,a)};g.hb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};ab(a,b);return P(this,Zh,a)};g.fb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};ab(a,b);return P(this,$h,a)};function gg(a,b){return P(a,ai,b)}g.Sa=function(a){return P(this,bi,a)};
function ci(a,b,c){return P(a,di,{idToken:b,deleteProvider:c})}function ei(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new M("internal-error");}
function fi(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=qg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=qg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=qg(a)):a.errorMessage&&(b=gi(a.errorMessage));if(b)throw b;if(!a[Gf])throw new M("internal-error");}function If(a,b){b.returnIdpCredential=!0;return P(a,hi,b)}function Kf(a,b){b.returnIdpCredential=!0;return P(a,ii,b)}
function Lf(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return P(a,ji,b)}function ki(a){if(!a.oobCode)throw new M("invalid-action-code");}g.Wa=function(a,b){return P(this,li,{oobCode:a,newPassword:b})};g.Ia=function(a){return P(this,mi,{oobCode:a})};g.Ua=function(a){return P(this,ni,{oobCode:a})};
var ni={endpoint:"setAccountInfo",A:ki,ba:"email"},mi={endpoint:"resetPassword",A:ki,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new M("internal-error");}},oi={endpoint:"signupNewUser",A:function(a){Mh(a);if(!a.password)throw new M("weak-password");},J:Th,R:!0},Ph={endpoint:"createAuthUri"},pi={endpoint:"deleteAccount",T:["idToken"]},di={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],A:function(a){if(!fa(a.deleteProvider))throw new M("internal-error");}},Wf=
{endpoint:"emailLinkSignin",T:["email","oobCode"],A:Mh,J:Th,R:!0},Yf={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],A:Mh,J:Th,R:!0},qi={endpoint:"getAccountInfo"},Zh={endpoint:"getOobConfirmationCode",T:["requestType"],A:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new M("internal-error");Mh(a)},ba:"email"},$h={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new M("internal-error");},ba:"email"},Yh={endpoint:"getOobConfirmationCode",
T:["requestType"],A:function(a){if("PASSWORD_RESET"!=a.requestType)throw new M("internal-error");Mh(a)},ba:"email"},Sh={pb:!0,endpoint:"getProjectConfig",Cb:"GET"},ri={pb:!0,endpoint:"getRecaptchaParam",Cb:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new M("internal-error");}},li={endpoint:"resetPassword",A:ki,ba:"email"},ai={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],ba:"sessionInfo"},Wh={endpoint:"setAccountInfo",T:["idToken"],A:Nh,R:!0},Zf={endpoint:"setAccountInfo",
T:["idToken"],A:function(a){Nh(a);if(!a.password)throw new M("weak-password");},J:Th,R:!0},Vh={endpoint:"signupNewUser",J:Th,R:!0},hi={endpoint:"verifyAssertion",A:ei,J:fi,R:!0},ji={endpoint:"verifyAssertion",A:ei,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new M("user-not-found");if(a.errorMessage)throw gi(a.errorMessage);if(!a[Gf])throw new M("internal-error");},R:!0},ii={endpoint:"verifyAssertion",A:function(a){ei(a);if(!a.idToken)throw new M("internal-error");},J:fi,
R:!0},si={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new M("invalid-custom-token");},J:Th,R:!0},Xf={endpoint:"verifyPassword",A:function(a){Mh(a);if(!a.password)throw new M("wrong-password");},J:Th,R:!0},bi={endpoint:"verifyPhoneNumber",A:Uh,J:Th},dg={endpoint:"verifyPhoneNumber",A:function(a){if(!a.idToken)throw new M("internal-error");Uh(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",qg(a);Th(a)}},eg={Tb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",
A:Uh,J:Th};function P(a,b,c){if(!Je(c,b.T))return B(new M("internal-error"));var d=b.Cb||"POST",e;return A(c).then(b.A).then(function(){b.R&&(c.returnSecureToken=!0);return Lh(a,b.endpoint,d,c,b.Tb,b.pb||!1)}).then(function(a){return e=a}).then(b.J).then(function(){if(!b.ba)return e;if(!(b.ba in e))throw new M("internal-error");return e[b.ba]})}function gi(a){return Kh({error:{errors:[{message:a}],code:400,message:a}})}
function Kh(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new M(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};ab(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new M(d[e],b);!b&&a&&(b=ue(a));return new M("internal-error",b)};var ti={Wc:{Ya:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",eb:"https://securetoken.googleapis.com/v1/token",id:"p"},Yc:{Ya:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",eb:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},Zc:{Ya:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",eb:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function ui(a){for(var b in ti)if(ti[b].id===a)return a=ti[b],{firebaseEndpoint:a.Ya,secureTokenEndpoint:a.eb};return null}var vi;vi=ui("__EID__")?"__EID__":void 0;function wi(a){this.b=a;this.a=null;this.ab=xi(this)}
function xi(a){return yi().then(function(){return new z(function(b,c){J("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},zi.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function Ai(a,b){return a.ab.then(function(){return new z(function(c){a.a.send(b.type,b,c,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Bi(a,b){a.ab.then(function(){a.a.register("authEvent",b,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Ci=pd("https://apis.google.com/js/api.js?onload=%{onload}"),Di=new ze(3E4,6E4),zi=new ze(5E3,15E3),Ei=null;
function yi(){return Ei?Ei:Ei=(new z(function(a,b){function c(){ye();J("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){ye();b(Error("Network Error"))},timeout:Di.get()})}if(J("gapi.iframes.Iframe"))a();else if(J("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){J("gapi.load")?c():b(Error("Network Error"))};d=td(Ci,{onload:d});A(ph(d)).m(function(){b(Error("Network Error"))})}})).m(function(a){Ei=null;throw a;})};function Fi(a,b,c){this.j=a;this.g=b;this.h=c;this.f=null;this.a=dd(this.j,"/__/auth/iframe");H(this.a,"apiKey",this.g);H(this.a,"appName",this.h);this.b=null;this.c=[]}Fi.prototype.toString=function(){this.f?H(this.a,"v",this.f):jd(this.a.a,"v");this.b?H(this.a,"eid",this.b):jd(this.a.a,"eid");this.c.length?H(this.a,"fw",this.c.join(",")):jd(this.a.a,"fw");return this.a.toString()};function Gi(a,b,c,d,e){this.o=a;this.u=b;this.c=c;this.l=d;this.h=this.g=this.j=null;this.a=e;this.f=null}
Gi.prototype.toString=function(){var a=dd(this.o,"/__/auth/handler");H(a,"apiKey",this.u);H(a,"appName",this.c);H(a,"authType",this.l);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().ca()}catch(m){c=null}b.Xa=c;H(a,"providerId",this.a.providerId);b=this.a;c=ve(b.tb);for(var d in c)c[d]=c[d].toString();d=b.Ac;c=Za(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.Za&&b.Xa&&!c[b.Za]&&(c[b.Za]=b.Xa);Ya(c)||H(a,"customParameters",ue(c))}"function"===typeof this.a.yb&&
(b=this.a.yb(),b.length&&H(a,"scopes",b.join(",")));this.j?H(a,"redirectUrl",this.j):jd(a.a,"redirectUrl");this.g?H(a,"eventId",this.g):jd(a.a,"eventId");this.h?H(a,"v",this.h):jd(a.a,"v");if(this.b)for(var h in this.b)this.b.hasOwnProperty(h)&&!bd(a,h)&&H(a,h,this.b[h]);this.f?H(a,"eid",this.f):jd(a.a,"eid");h=Hi(this.c);h.length&&H(a,"fw",h.join(","));return a.toString()};function Hi(a){try{return firebase.app(a).auth().Ka()}catch(b){return[]}}
function Ii(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.o=this.s=this.v=null;this.g=[];this.l=this.a=null}
function Ji(a){var b=Ud();return Rh(a).then(function(a){a:{var c=cd(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var h=a[f];var m=c;var p=e;0==h.indexOf("chrome-extension://")?m=cd(h).b==m&&"chrome-extension"==p:"http"!=p&&"https"!=p?m=!1:ee.test(h)?m=m==h:(h=h.split(".").join("\\."),m=(new RegExp("^(.+\\."+h+"|"+h+")$","i")).test(m));if(m){a=!0;break a}}a=!1}if(!a)throw new og(Ud());})}
function Ki(a){if(a.l)return a.l;a.l=fe().then(function(){if(!a.s){var b=a.c,c=a.h,d=Hi(a.b),e=new Fi(a.u,a.f,a.b);e.f=b;e.b=c;e.c=Ia(d||[]);a.s=e.toString()}a.j=new wi(a.s);Li(a)});return a.l}g=Ii.prototype;g.Da=function(a,b,c){var d=new M("popup-closed-by-user"),e=new M("web-storage-unsupported"),f=this,h=!1;return this.ea().then(function(){Mi(f).then(function(c){c||(a&&ae(a),b(e),h=!0)})}).m(function(){}).then(function(){if(!h)return de(a)}).then(function(){if(!h)return Fc(c).then(function(){b(d)})})};
g.Gb=function(){var a=I();return!te(a)&&!xe(a)};g.Bb=function(){return!1};
g.xb=function(a,b,c,d,e,f,h){if(!a)return B(new M("popup-blocked"));if(h&&!te())return this.ea().m(function(b){ae(a);e(b)}),d(),A();this.a||(this.a=Ji(Ni(this)));var m=this;return this.a.then(function(){var b=m.ea().m(function(b){ae(a);e(b);throw b;});d();return b}).then(function(){jg(c);if(!h){var d=Oi(m.u,m.f,m.b,b,c,null,f,m.c,void 0,m.h);Vd(d,a)}}).m(function(a){"auth/network-request-failed"==a.code&&(m.a=null);throw a;})};
function Ni(a){a.o||(a.v=a.c?oe(a.c,Hi(a.b)):null,a.o=new xh(a.f,ui(a.h),a.v));return a.o}g.Ba=function(a,b,c){this.a||(this.a=Ji(Ni(this)));var d=this;return this.a.then(function(){jg(b);var e=Oi(d.u,d.f,d.b,a,b,Ud(),c,d.c,void 0,d.h);Vd(e)}).m(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};g.ea=function(){var a=this;return Ki(this).then(function(){return a.j.ab}).m(function(){a.a=null;throw new M("network-request-failed");})};g.Lb=function(){return!0};
function Oi(a,b,c,d,e,f,h,m,p,E){a=new Gi(a,b,c,d,e);a.j=f;a.g=h;a.h=m;a.b=Za(p||null);a.f=E;return a.toString()}function Li(a){if(!a.j)throw Error("IfcHandler must be initialized!");Bi(a.j,function(b){var c={};if(b&&b.authEvent){var d=!1;b=lg(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return A(c)}c.status="ERROR";return A(c)})}
function Mi(a){var b={type:"webStorageSupport"};return Ki(a).then(function(){return Ai(a.j,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}g.va=function(a){this.g.push(a)};g.Ja=function(a){w(this.g,function(b){return b==a})};function Pi(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new M("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}g=Pi.prototype;g.get=function(a){return A(this.a.getItem(a)).then(function(a){return a&&we(a)})};g.set=function(a,b){return A(this.a.setItem(a,ue(b)))};g.P=function(a){return A(this.a.removeItem(a))};g.Y=function(){};g.aa=function(){};function Qi(){if(!Ri())throw new M("web-storage-unsupported");this.f={};this.a=[];this.b=0;this.g=k.indexedDB;this.type="indexedDB"}var Si;function Ti(a){return new z(function(b,c){var d=a.g.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(a){c(Error(a.target.error))}})}
function Ui(a){return new z(function(b,c){var d=a.g.open("firebaseLocalStorageDb",1);d.onerror=function(a){try{a.preventDefault()}catch(f){}c(Error(a.target.error))};d.onupgradeneeded=function(a){a=a.target.result;try{a.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(d){d=d.target.result;d.objectStoreNames.contains("firebaseLocalStorage")?b(d):Ti(a).then(function(){return Ui(a)}).then(function(a){b(a)}).m(function(a){c(a)})}})}
function Vi(a){a.h||(a.h=Ui(a));return a.h}function Ri(){try{return!!k.indexedDB}catch(a){return!1}}function Wi(a){return a.objectStore("firebaseLocalStorage")}function Xi(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function Yi(a){return new z(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})}g=Qi.prototype;
g.set=function(a,b){var c=!1,d,e=this;return Vi(this).then(function(b){d=b;b=Wi(Xi(d,!0));return Yi(b.get(a))}).then(function(f){var h=Wi(Xi(d,!0));if(f)return f.value=b,Yi(h.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return Yi(h.add(f))}).then(function(){e.f[a]=b}).ha(function(){c&&e.b--})};g.get=function(a){return Vi(this).then(function(b){return Yi(Wi(Xi(b,!1)).get(a))}).then(function(a){return a&&a.value})};
g.P=function(a){var b=!1,c=this;return Vi(this).then(function(d){b=!0;c.b++;return Yi(Wi(Xi(d,!0))["delete"](a))}).then(function(){delete c.f[a]}).ha(function(){b&&c.b--})};
g.Jc=function(){var a=this;return Vi(this).then(function(a){var b=Wi(Xi(a,!1));return b.getAll?Yi(b.getAll()):new z(function(a,c){var d=[],e=b.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){c(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=Wd(a.f,c);a.f=c}return d})};g.Y=function(a){0==this.a.length&&Zi(this);this.a.push(a)};
g.aa=function(a){w(this.a,function(b){return b==a});0==this.a.length&&this.c&&this.c.cancel("STOP_EVENT")};function Zi(a){function b(){a.c=Fc(800).then(r(a.Jc,a)).then(function(b){0<b.length&&v(a.a,function(a){a(b)})}).then(b).m(function(a){"STOP_EVENT"!=a.message&&b()});return a.c}a.c&&a.c.cancel("STOP_EVENT");b()};function $i(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=A().then(function(){return Ri()?(Si||(Si=new Qi),c=Si,c.set("__sak","!").then(function(){return c.get("__sak")}).then(function(a){if("!"!==a)throw Error("indexedDB not supported!");return c.P("__sak")}).then(function(){return c}).m(function(){return b.c})):b.c}).then(function(a){b.type=a.type;a.Y(function(a){v(b.a,function(b){b(a)})});return a})}g=$i.prototype;g.get=function(a){return this.b.then(function(b){return b.get(a)})};
g.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};g.P=function(a){return this.b.then(function(b){return b.P(a)})};g.Y=function(a){this.a.push(a)};g.aa=function(a){w(this.a,function(b){return b==a})};function aj(){this.a={};this.type="inMemory"}g=aj.prototype;g.get=function(a){return A(this.a[a])};g.set=function(a,b){this.a[a]=b;return A()};g.P=function(a){delete this.a[a];return A()};g.Y=function(){};g.aa=function(){};function bj(){if(!cj()){if("Node"==le())throw new M("internal-error","The LocalStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=dj()||firebase.INTERNAL.node.localStorage;this.type="localStorage"}function dj(){try{var a=k.localStorage,b=qe();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function cj(){var a="Node"==le();a=dj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=bj.prototype;g.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return we(c)})};g.set=function(a,b){var c=this;return A().then(function(){var d=ue(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};
g.Y=function(a){k.window&&pc(k.window,"storage",a)};g.aa=function(a){k.window&&F(k.window,"storage",a)};function ej(){this.type="nullStorage"}g=ej.prototype;g.get=function(){return A(null)};g.set=function(){return A()};g.P=function(){return A()};g.Y=function(){};g.aa=function(){};function fj(){if(!gj()){if("Node"==le())throw new M("internal-error","The SessionStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=hj()||firebase.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function hj(){try{var a=k.sessionStorage,b=qe();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function gj(){var a="Node"==le();a=hj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=fj.prototype;g.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return we(c)})};g.set=function(a,b){var c=this;return A().then(function(){var d=ue(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};g.Y=function(){};
g.aa=function(){};function ij(){var a={};a.Browser=jj;a.Node=kj;a.ReactNative=lj;a.Worker=mj;this.a=a[le()]}var nj,jj={w:bj,Pa:fj},kj={w:bj,Pa:fj},lj={w:Pi,Pa:ej},mj={w:bj,Pa:ej};var oj={Vc:"local",NONE:"none",Xc:"session"};function pj(a){var b=new M("invalid-persistence-type"),c=new M("unsupported-persistence-type");a:{for(d in oj)if(oj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(le()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!pe()&&"none"!==a)throw c;}}
function qj(){var a=!xe(I())&&je()?!0:!1,b=te(),c=pe();this.o=a;this.h=b;this.l=c;this.a={};nj||(nj=new ij);a=nj;try{this.g=!Td()&&De()||!k.indexedDB?new a.a.w:new $i(ke()?new aj:new a.a.w)}catch(d){this.g=new aj,this.h=!0}try{this.j=new a.a.Pa}catch(d){this.j=new aj}this.u=new aj;this.f=r(this.Kb,this);this.b={}}var rj;function sj(){rj||(rj=new qj);return rj}function tj(a,b){switch(b){case "session":return a.j;case "none":return a.u;default:return a.g}}
function uj(a,b){return"firebase:"+a.name+(b?":"+b:"")}function vj(a,b,c){var d=uj(b,c),e=tj(a,b.w);return a.get(b,c).then(function(f){var h=null;try{h=we(k.localStorage.getItem(d))}catch(m){}if(h&&!f)return k.localStorage.removeItem(d),a.set(b,h,c);h&&f&&"localStorage"!=e.type&&k.localStorage.removeItem(d)})}g=qj.prototype;g.get=function(a,b){return tj(this,a.w).get(uj(a,b))};function wj(a,b,c){c=uj(b,c);"local"==b.w&&(a.b[c]=null);return tj(a,b.w).P(c)}
g.set=function(a,b,c){var d=uj(a,c),e=this,f=tj(this,a.w);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.w&&(e.b[d]=b)})};g.addListener=function(a,b,c){a=uj(a,b);this.l&&(this.b[a]=k.localStorage.getItem(a));Ya(this.a)&&(tj(this,"local").Y(this.f),this.h||(Td()||!De())&&k.indexedDB||!this.l||xj(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
g.removeListener=function(a,b,c){a=uj(a,b);this.a[a]&&(w(this.a[a],function(a){return a==c}),0==this.a[a].length&&delete this.a[a]);Ya(this.a)&&(tj(this,"local").aa(this.f),yj(this))};function xj(a){yj(a);a.c=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new cc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Kb(c))}},1E3)}function yj(a){a.c&&(clearInterval(a.c),a.c=null)}
g.Kb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Va(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?tj(this,"local").aa(this.f):yj(this);if(this.o)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.Va(b)};C&&Xb&&10==Xb&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else v(a,r(this.Va,this))};g.Va=function(a){this.a[a]&&v(this.a[a],function(a){a()})};function zj(a){this.a=a;this.b=sj()}var Aj={name:"authEvent",w:"local"};function Bj(a){return a.b.get(Aj,a.a).then(function(a){return lg(a)})};function Cj(){this.a=sj()};function Dj(){this.b=-1};function Ej(a,b){this.b=-1;this.b=Fj;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.j=a;this.h=b;this.l=k.Int32Array?new Int32Array(64):Array(64);void 0!==Gj||(k.Int32Array?Gj=new Int32Array(Hj):Gj=Hj);this.reset()}var Gj;t(Ej,Dj);for(var Fj=64,Ij=Fj-1,Jj=[],Kj=0;Kj<Ij;Kj++)Jj[Kj]=0;var Lj=Ha(128,Jj);Ej.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):Ia(this.h)};
function Mj(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,h=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+h|0}d=a.a[0]|0;e=a.a[1]|0;var m=a.a[2]|0,p=a.a[3]|0,E=a.a[4]|0,ic=a.a[5]|0,Jc=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var El=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&m^e&m)|0;h=E&ic^~E&Jc;f=f+((E>>>6|E<<26)^(E>>>11|E<<21)^(E>>>
25|E<<7))|0;h=h+(Gj[b]|0)|0;h=f+(h+(c[b]|0)|0)|0;f=Jc;Jc=ic;ic=E;E=p+h|0;p=m;m=e;e=d;d=h+El|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+m|0;a.a[3]=a.a[3]+p|0;a.a[4]=a.a[4]+E|0;a.a[5]=a.a[5]+ic|0;a.a[6]=a.a[6]+Jc|0;a.a[7]=a.a[7]+f|0}
function Nj(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(l(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(Mj(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(Mj(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var Hj=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Oj(){Ej.call(this,8,Pj)}t(Oj,Ej);var Pj=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function Qj(a,b,c,d,e){this.u=a;this.j=b;this.l=c;this.o=d||null;this.s=e||null;this.h=b+":"+c;this.v=new Cj;this.g=new zj(this.h);this.f=null;this.b=[];this.a=this.c=null}function Rj(a){return new M("invalid-cordova-configuration",a)}g=Qj.prototype;
g.ea=function(){return this.ya?this.ya:this.ya=ge().then(function(){if("function"!==typeof J("universalLinks.subscribe",k))throw Rj("cordova-universal-links-plugin is not installed");if("undefined"===typeof J("BuildInfo.packageName",k))throw Rj("cordova-plugin-buildinfo is not installed");if("function"!==typeof J("cordova.plugins.browsertab.openUrl",k))throw Rj("cordova-plugin-browsertab is not installed");if("function"!==typeof J("cordova.InAppBrowser.open",k))throw Rj("cordova-plugin-inappbrowser is not installed");
},function(){throw new M("cordova-not-ready");})};function Sj(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Tj(a){var b=new Oj;Nj(b,a);a=[];var c=8*b.g;56>b.c?Nj(b,Lj,56-b.c):Nj(b,Lj,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;Mj(b);for(d=c=0;d<b.j;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return gf(a)}
g.Da=function(a,b){b(new M("operation-not-supported-in-this-environment"));return A()};g.xb=function(){return B(new M("operation-not-supported-in-this-environment"))};g.Lb=function(){return!1};g.Gb=function(){return!0};g.Bb=function(){return!0};
g.Ba=function(a,b,c){if(this.c)return B(new M("redirect-operation-pending"));var d=this,e=k.document,f=null,h=null,m=null,p=null;return this.c=A().then(function(){jg(b);return Uj(d)}).then(function(){return Vj(d,a,b,c)}).then(function(){return(new z(function(a,b){h=function(){var b=J("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.va(h);m=function(){f||(f=Fc(2E3).then(function(){b(new M("redirect-cancelled-by-user"))}))};
p=function(){Ae()&&m()};e.addEventListener("resume",m,!1);I().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",p,!1)})).m(function(a){return Wj(d).then(function(){throw a;})})}).ha(function(){m&&e.removeEventListener("resume",m,!1);p&&e.removeEventListener("visibilitychange",p,!1);f&&f.cancel();h&&d.Ja(h);d.c=null})};
function Vj(a,b,c,d){var e=Sj(),f=new kg(b,d,null,e,new M("no-auth-event")),h=J("BuildInfo.packageName",k);if("string"!==typeof h)throw new M("invalid-cordova-configuration");var m=J("BuildInfo.displayName",k),p={};if(I().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(I().toLowerCase().match(/android/))p.apn=h;else return B(new M("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);e=Tj(e);p.sessionId=e;var E=Oi(a.u,a.j,a.l,b,c,null,d,a.o,p,a.s);return a.ea().then(function(){var b=
a.h;return a.v.a.set(Aj,f.C(),b)}).then(function(){var b=J("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new M("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=J("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new M("invalid-cordova-configuration");c(E)}else{c=J("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new M("invalid-cordova-configuration");b=I();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.a=c(E,b?"_blank":"_system","location=yes")}})})}function Xj(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Uj(a){a.f||(a.f=a.ea().then(function(){return new z(function(b){function c(d){b(d);a.Ja(c);return!1}a.va(c);Yj(a)})}));return a.f}function Wj(a){var b=null;return Bj(a.g).then(function(c){b=c;c=a.g;return wj(c.b,Aj,c.a)}).then(function(){return b})}
function Yj(a){function b(b){d=!0;e&&e.cancel();Wj(a).then(function(d){var e=c;if(d&&b&&b.url){var f=null;e=Ef(b.url);-1!=e.indexOf("/__/auth/callback")&&(f=cd(e),f=we(bd(f,"firebaseError")||null),f=(f="object"===typeof f?We(f):null)?new kg(d.b,d.c,null,null,f):new kg(d.b,d.c,e,d.g));e=f||c}Xj(a,e)})}var c=new kg("unknown",null,null,null,new M("no-auth-event")),d=!1,e=Fc(500).then(function(){return Wj(a).then(function(){d||Xj(a,c)})}),f=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(J("BuildInfo.packageName",
k).toLowerCase()+"://")&&b({url:a});if("function"===typeof f)try{f(a)}catch(m){console.error(m)}};ng||(ng=new mg);ng.subscribe(b)}g.va=function(a){this.b.push(a);Uj(this).m(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new kg("unknown",null,null,null,new M("no-auth-event")),a(b))})};g.Ja=function(a){w(this.b,function(b){return b==a})};function Zj(a){this.a=a;this.b=sj()}var ak={name:"pendingRedirect",w:"session"};function bk(a){return a.b.set(ak,"pending",a.a)}function ck(a){return wj(a.b,ak,a.a)}function dk(a){return a.b.get(ak,a.a).then(function(a){return"pending"==a})};function ek(a,b,c){this.v=a;this.l=b;this.u=c;this.h=[];this.f=!1;this.j=r(this.o,this);this.c=new fk;this.s=new gk;this.g=new Zj(this.l+":"+this.u);this.b={};this.b.unknown=this.c;this.b.signInViaRedirect=this.c;this.b.linkViaRedirect=this.c;this.b.reauthViaRedirect=this.c;this.b.signInViaPopup=this.s;this.b.linkViaPopup=this.s;this.b.reauthViaPopup=this.s;this.a=hk(this.v,this.l,this.u,vi)}function hk(a,b,c,d){var e=firebase.SDK_VERSION||null;return he()?new Qj(a,b,c,e,d):new Ii(a,b,c,e,d)}
ek.prototype.reset=function(){this.f=!1;this.a.Ja(this.j);this.a=hk(this.v,this.l,this.u)};function ik(a){a.f||(a.f=!0,a.a.va(a.j));var b=a.a;return a.a.ea().m(function(c){a.a==b&&a.reset();throw c;})}function jk(a){a.a.Gb()&&ik(a).m(function(b){var c=new kg("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));kk(b)&&a.o(c)});a.a.Bb()||lk(a.c)}
ek.prototype.subscribe=function(a){Fa(this.h,a)||this.h.push(a);if(!this.f){var b=this;dk(this.g).then(function(a){a?ck(b.g).then(function(){ik(b).m(function(a){var c=new kg("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));kk(a)&&b.o(c)})}):jk(b)}).m(function(){jk(b)})}};ek.prototype.unsubscribe=function(a){w(this.h,function(b){return b==a})};
ek.prototype.o=function(a){if(!a)throw new M("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.qb(a.b,a.c)){(b=this.b[a.b])&&b.h(a,d);b=!0;break}}lk(this.c);return b};var mk=new ze(2E3,1E4),nk=new ze(3E4,6E4);ek.prototype.da=function(){return this.c.da()};function ok(a,b,c,d,e,f){return a.a.xb(b,c,d,function(){a.f||(a.f=!0,a.a.va(a.j))},function(){a.reset()},e,f)}function kk(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
ek.prototype.Ba=function(a,b,c){var d=this,e;return bk(this.g).then(function(){return d.a.Ba(a,b,c).m(function(a){if(kk(a))throw new M("operation-not-supported-in-this-environment");e=a;return ck(d.g).then(function(){throw e;})}).then(function(){return d.a.Lb()?new z(function(){}):ck(d.g).then(function(){return d.da()}).then(function(){}).m(function(){})})})};ek.prototype.Da=function(a,b,c,d){return this.a.Da(c,function(c){a.ga(b,null,c,d)},mk.get())};var pk={};
function qk(a,b,c){var d=b+":"+c;pk[d]||(pk[d]=new ek(a,b,c));return pk[d]}function fk(){this.b=null;this.f=[];this.c=[];this.a=null;this.g=!1}fk.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
fk.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;"unknown"!=c||e||f?a.a?(rk(this,!0,null,a.a),A()):b.wa(c,d)?sk(this,a,b):B(new M("invalid-auth-event")):(rk(this,!1,null,null),A())}else B(new M("invalid-auth-event"))};function lk(a){a.g||(a.g=!0,rk(a,!1,null,null))}
function sk(a,b,c){c=c.wa(b.b,b.c);var d=b.f,e=b.g,f=!!b.b.match(/Redirect$/);c(d,e).then(function(b){rk(a,f,b,null)}).m(function(b){rk(a,f,null,b)})}function tk(a,b){a.b=function(){return B(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function uk(a,b){a.b=function(){return A(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function rk(a,b,c,d){b?d?tk(a,d):uk(a,c):uk(a,{user:null});a.f=[];a.c=[]}
fk.prototype.da=function(){var a=this;return new z(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),vk(a))})};function vk(a){var b=new M("timeout");a.a&&a.a.cancel();a.a=Fc(nk.get()).then(function(){a.b||rk(a,!0,null,b)})}function gk(){}gk.prototype.h=function(a,b){if(a){var c=a.b,d=a.c;a.a?(b.ga(a.b,null,a.a,a.c),A()):b.wa(c,d)?wk(a,b):B(new M("invalid-auth-event"))}else B(new M("invalid-auth-event"))};
function wk(a,b){var c=a.c,d=a.b;b.wa(d,c)(a.f,a.g).then(function(a){b.ga(d,a,null,c)}).m(function(a){b.ga(d,null,a,c)})};function xk(a,b){this.a=b;K(this,"verificationId",a)}xk.prototype.confirm=function(a){a=hg(this.verificationId,a);return this.a(a)};function yk(a,b,c,d){return(new fg(a)).Sa(b,c).then(function(a){return new xk(a,d)})};function zk(a){var b=pf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new M("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this,{token:a,expirationTime:Ce(1E3*b.exp),authTime:Ce(1E3*b.auth_time),issuedAtTime:Ce(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function Ak(a,b,c){this.h=a;this.j=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}Ak.prototype.start=function(){this.a=this.c;Bk(this,!0)};function Ck(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Bk(a,b){a.stop();a.b=Fc(Ck(a,b)).then(function(){return Be()}).then(function(){return a.h()}).then(function(){Bk(a,!0)}).m(function(b){a.j(b)&&Bk(a,!1)})}
Ak.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Dk(a){this.f=a;this.b=this.a=null;this.c=0}Dk.prototype.C=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Ek(a,b){var c=b[Gf],d=b.refreshToken;b=Fk(b.expiresIn);a.b=c;a.c=b;a.a=d}function Fk(a){return na()+1E3*parseInt(a,10)}
function Gk(a,b){return Jh(a.f,b).then(function(b){a.b=b.access_token;a.c=Fk(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).m(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}Dk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?B(new M("user-token-expired")):a||!this.b||na()>this.c-3E4?this.a?Gk(this,{grant_type:"refresh_token",refresh_token:this.a}):A(null):A({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function Hk(a,b){this.a=a||null;this.b=b||null;L(this,{lastSignInTime:Ce(b||null),creationTime:Ce(a||null)})}function Ik(a){return new Hk(a.a,a.b)}Hk.prototype.C=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Jk(a,b,c,d,e,f){L(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Kk(a,b){D.call(this,a);for(var c in b)this[c]=b[c]}t(Kk,D);
function Lk(a,b,c){this.D=[];this.G=a.apiKey;this.s=a.appName;this.B=a.authDomain||null;a=firebase.SDK_VERSION?oe(firebase.SDK_VERSION):null;this.b=new xh(this.G,ui(vi),a);this.h=new Dk(this.b);Mk(this,b[Gf]);Ek(this.h,b);K(this,"refreshToken",this.h.a);Nk(this,c||{});G.call(this);this.I=!1;this.B&&re()&&(this.a=qk(this.B,this.G,this.s));this.N=[];this.j=null;this.l=Ok(this);this.V=r(this.Ga,this);var d=this;this.ia=null;this.sa=function(a){d.na(a.g)};this.X=null;this.O=[];this.ra=function(a){Pk(d,
a.c)};this.W=null}t(Lk,G);Lk.prototype.na=function(a){this.ia=a;Dh(this.b,a)};Lk.prototype.ca=function(){return this.ia};function Qk(a,b){a.X&&F(a.X,"languageCodeChanged",a.sa);(a.X=b)&&pc(b,"languageCodeChanged",a.sa)}function Pk(a,b){a.O=b;Eh(a.b,firebase.SDK_VERSION?oe(firebase.SDK_VERSION,a.O):null)}Lk.prototype.Ka=function(){return Ia(this.O)};function Rk(a,b){a.W&&F(a.W,"frameworkChanged",a.ra);(a.W=b)&&pc(b,"frameworkChanged",a.ra)}Lk.prototype.Ga=function(){this.l.b&&(this.l.stop(),this.l.start())};
function Sk(a){try{return firebase.app(a.s).auth()}catch(b){throw new M("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.s+"'!");}}function Ok(a){return new Ak(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-na()-3E5;return 0<b?b:0})}function Tk(a){a.o||a.l.b||(a.l.start(),F(a,"tokenChanged",a.V),pc(a,"tokenChanged",a.V))}function Uk(a){F(a,"tokenChanged",a.V);a.l.stop()}
function Mk(a,b){a.qa=b;K(a,"_lat",b)}function Vk(a,b){w(a.N,function(a){return a==b})}function Wk(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return ub(b).then(function(){return a})}function Xk(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
function Nk(a,b){L(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new Hk(b.createdAt,b.lastLoginAt),providerData:[]})}K(Lk.prototype,"providerId","firebase");function Yk(){}function Zk(a){return A().then(function(){if(a.o)throw new M("app-deleted");})}function $k(a){return Ba(a.providerData,function(a){return a.providerId})}
function al(a,b){b&&(bl(a,b.providerId),a.providerData.push(b))}function bl(a,b){w(a.providerData,function(a){return a.providerId==b})}function cl(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&K(a,b,c)}
function dl(a,b){a!=b&&(L(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?K(a,"metadata",Ik(b.metadata)):K(a,"metadata",new Hk),v(b.providerData,function(b){al(a,b)}),a.h=b.h,K(a,"refreshToken",a.h.a))}g=Lk.prototype;g.reload=function(){var a=this;return R(this,Zk(this).then(function(){return el(a).then(function(){return Wk(a)}).then(Yk)}))};
function el(a){return a.F().then(function(b){var c=a.isAnonymous;return fl(a,b).then(function(){c||cl(a,"isAnonymous",!1);return b})})}g.ac=function(a){return this.F(a).then(function(a){return new zk(a)})};g.F=function(a){var b=this;return R(this,Zk(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new M("internal-error");a.accessToken!=b.qa&&(Mk(b,a.accessToken),b.dispatchEvent(new Kk("tokenChanged")));cl(b,"refreshToken",a.refreshToken);return a.accessToken}))};
g.getToken=function(a){Ee["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]||(Ee["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.F(a)};
function gl(a,b){b[Gf]&&a.qa!=b[Gf]&&(Ek(a.h,b),a.dispatchEvent(new Kk("tokenChanged")),Mk(a,b[Gf]),cl(a,"refreshToken",a.h.a))}function fl(a,b){return P(a.b,qi,{idToken:b}).then(r(a.uc,a))}
g.uc=function(a){a=a.users;if(!a||!a.length)throw new M("internal-error");a=a[0];Nk(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=hl(a),c=0;c<b.length;c++)al(this,b[c]);cl(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function hl(a){return(a=a.providerUserInfo)&&a.length?Ba(a,function(a){return new Jk(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}g.bb=function(a){var b=this,c=null;return R(this,a.f(this.b,this.uid).then(function(a){gl(b,a);c=il(b,a,"reauthenticate");b.j=null;return b.reload()}).then(function(){return c}),!0)};g.vc=function(a){return this.bb(a).then(function(){})};
function jl(a,b){return el(a).then(function(){if(Fa($k(a),b))return Wk(a).then(function(){throw new M("provider-already-linked");})})}g.$a=function(a){var b=this,c=null;return R(this,jl(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.c(b.b,c)}).then(function(a){c=il(b,a,"link");return kl(b,a)}).then(function(){return c}))};g.mc=function(a){return this.$a(a).then(function(a){return a.user})};
g.nc=function(a,b){var c=this;return R(this,jl(this,"phone").then(function(){return yk(Sk(c),a,b,r(c.$a,c))}))};g.wc=function(a,b){var c=this;return R(this,A().then(function(){return yk(Sk(c),a,b,r(c.bb,c))}),!0)};function il(a,b,c){var d=ig(b);b=uf(b);return He({user:a,credential:d,additionalUserInfo:b,operationType:c})}function kl(a,b){gl(a,b);return a.reload().then(function(){return a})}
g.mb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.mb(c,a)}).then(function(a){gl(b,a);return b.reload()}))};g.Nc=function(a){var b=this;return R(this,this.F().then(function(c){return a.c(b.b,c)}).then(function(a){gl(b,a);return b.reload()}))};g.nb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.nb(c,a)}).then(function(a){gl(b,a);return b.reload()}))};
g.ob=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Zk(this);var b=this;return R(this,this.F().then(function(c){return b.b.ob(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){gl(b,a);cl(b,"displayName",a.displayName||null);cl(b,"photoURL",a.photoUrl||null);v(b.providerData,function(a){"password"===a.providerId&&(K(a,"displayName",b.displayName),K(a,"photoURL",b.photoURL))});return Wk(b)}).then(Yk))};
g.Mc=function(a){var b=this;return R(this,el(this).then(function(c){return Fa($k(b),a)?ci(b.b,c,[a]).then(function(a){var c={};v(a.providerUserInfo||[],function(a){c[a.providerId]=!0});v($k(b),function(a){c[a]||bl(b,a)});c[fg.PROVIDER_ID]||K(b,"phoneNumber",null);return Wk(b)}):Wk(b).then(function(){throw new M("no-such-provider");})}))};
g.delete=function(){var a=this;return R(this,this.F().then(function(b){return P(a.b,pi,{idToken:b})}).then(function(){a.dispatchEvent(new Kk("userDeleted"))})).then(function(){for(var b=0;b<a.D.length;b++)a.D[b].cancel("app-deleted");Qk(a,null);Rk(a,null);a.D=[];a.o=!0;Uk(a);K(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
g.qb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.$||null)==b||"reauthViaRedirect"==a&&(this.$||null)==b?!0:!1};g.ga=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
g.wa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.vb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.wb,this):"linkViaRedirect"==a&&(this.$||null)==b?r(this.vb,this):"reauthViaRedirect"==a&&(this.$||null)==b?r(this.wb,this):null};g.oc=function(a){var b=this;return ll(this,"linkViaPopup",a,function(){return jl(b,a.providerId).then(function(){return Wk(b)})},!1)};g.xc=function(a){return ll(this,"reauthViaPopup",a,function(){return A()},!0)};
function ll(a,b,c,d,e){if(!re())return B(new M("operation-not-supported-in-this-environment"));if(a.j&&!e)return B(a.j);var f=tf(c.providerId),h=qe(a.uid+":::"),m=null;(!te()||je())&&a.B&&c.isOAuthProvider&&(m=Oi(a.B,a.G,a.s,b,c,null,h,firebase.SDK_VERSION||null));var p=be(m,f&&f.Aa,f&&f.za);d=d().then(function(){ml(a);if(!e)return a.F().then(function(){})}).then(function(){return ok(a.a,p,b,c,h,!!m)}).then(function(){return new z(function(c,d){a.ga(b,null,new M("cancelled-popup-request"),a.g||null);
a.f=c;a.v=d;a.g=h;a.c=a.a.Da(a,b,p,h)})}).then(function(a){p&&ae(p);return a?He(a):null}).m(function(a){p&&ae(p);throw a;});return R(a,d,e)}g.pc=function(a){var b=this;return nl(this,"linkViaRedirect",a,function(){return jl(b,a.providerId)},!1)};g.yc=function(a){return nl(this,"reauthViaRedirect",a,function(){return A()},!0)};
function nl(a,b,c,d,e){if(!re())return B(new M("operation-not-supported-in-this-environment"));if(a.j&&!e)return B(a.j);var f=null,h=qe(a.uid+":::");d=d().then(function(){ml(a);if(!e)return a.F().then(function(){})}).then(function(){a.$=h;return Wk(a)}).then(function(b){a.fa&&(b=a.fa,b=b.b.set(ol,a.C(),b.a));return b}).then(function(){return a.a.Ba(b,c,h)}).m(function(b){f=b;if(a.fa)return pl(a.fa);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function ml(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new M("internal-error");throw new M("auth-domain-config-required");}}g.vb=function(a,b){var c=this;this.c&&(this.c.cancel(),this.c=null);var d=null,e=this.F().then(function(d){return Kf(c.b,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=il(c,a,"link");return kl(c,a)}).then(function(){return d});return R(this,e)};
g.wb=function(a,b){var c=this;this.c&&(this.c.cancel(),this.c=null);var d=null,e=A().then(function(){return Ff(Lf(c.b,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=il(c,a,"reauthenticate");gl(c,a);c.j=null;return c.reload()}).then(function(){return d});return R(this,e,!0)};g.fb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Ya(a)?{}:ff(new Xe(a))}).then(function(a){return b.b.fb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
function R(a,b,c){var d=ql(a,b,c);a.D.push(d);d.ha(function(){Ga(a.D,d)});return d}function ql(a,b,c){return a.j&&!c?(b.cancel(),B(a.j)):b.m(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.j||a.dispatchEvent(new Kk("userInvalidated")),a.j=b);throw b;})}g.toJSON=function(){return this.C()};
g.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.G,appName:this.s,authDomain:this.B,stsTokenManager:this.h.C(),redirectEventId:this.$||null};this.metadata&&ab(a,this.metadata.C());v(this.providerData,function(b){a.providerData.push(Ie(b))});return a};
function rl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[Gf]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-na())/1E3;else return null;var d=new Lk(b,c,a);a.providerData&&v(a.providerData,function(a){a&&al(d,He(a))});a.redirectEventId&&(d.$=a.redirectEventId);return d}
function sl(a,b,c,d){var e=new Lk(a,b);c&&(e.fa=c);d&&Pk(e,d);return e.reload().then(function(){return e})};function tl(a){this.a=a;this.b=sj()}var ol={name:"redirectUser",w:"session"};function pl(a){return wj(a.b,ol,a.a)}function ul(a,b){return a.b.get(ol,a.a).then(function(a){a&&b&&(a.authDomain=b);return rl(a||{})})};function vl(a){this.a=a;this.b=sj();this.c=null;this.f=wl(this);this.b.addListener(xl("local"),this.a,r(this.g,this))}vl.prototype.g=function(){var a=this,b=xl("local");yl(this,function(){return A().then(function(){return a.c&&"local"!=a.c.w?a.b.get(b,a.a):null}).then(function(c){if(c)return zl(a,"local").then(function(){a.c=b})})})};function zl(a,b){var c=[],d;for(d in oj)oj[d]!==b&&c.push(wj(a.b,xl(oj[d]),a.a));c.push(wj(a.b,Al,a.a));return tb(c)}
function wl(a){var b=xl("local"),c=xl("session"),d=xl("none");return vj(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(Al,a.a).then(function(a){return a?xl(a):b})})})}).then(function(b){a.c=b;return zl(a,b.w)}).m(function(){a.c||(a.c=b)})}var Al={name:"persistence",w:"session"};function xl(a){return{name:"authUser",w:a}}
vl.prototype.ib=function(a){var b=null,c=this;pj(a);return yl(this,function(){return a!=c.c.w?c.b.get(c.c,c.a).then(function(d){b=d;return zl(c,a)}).then(function(){c.c=xl(a);if(b)return c.b.set(c.c,b,c.a)}):A()})};function Bl(a){return yl(a,function(){return a.b.set(Al,a.c.w,a.a)})}function Cl(a,b){return yl(a,function(){return a.b.set(a.c,b.C(),a.a)})}function Dl(a){return yl(a,function(){return wj(a.b,a.c,a.a)})}
function Fl(a,b){return yl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return rl(a||{})})})}function yl(a,b){a.f=a.f.then(b,b);return a.f};function Gl(a){this.l=!1;K(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?oe(firebase.SDK_VERSION):null,this.b=new xh(S(this).options&&S(this).options.apiKey,ui(vi),a);else throw new M("invalid-api-key");this.N=[];this.o=[];this.I=[];this.Ob=firebase.INTERNAL.createSubscribe(r(this.ic,this));this.O=void 0;this.Pb=firebase.INTERNAL.createSubscribe(r(this.jc,this));Hl(this,null);this.h=new vl(S(this).options.apiKey+":"+S(this).name);this.G=new tl(S(this).options.apiKey+
":"+S(this).name);this.V=T(this,Il(this));this.j=T(this,Jl(this));this.X=!1;this.ia=r(this.Ic,this);this.Ga=r(this.ka,this);this.qa=r(this.Yb,this);this.ra=r(this.gc,this);this.sa=r(this.hc,this);Kl(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.qc,this);this.s=0;G.call(this);Ll(this);this.D=[]}t(Gl,G);function Ml(a){D.call(this,"languageCodeChanged");this.g=a}t(Ml,D);function Nl(a){D.call(this,"frameworkChanged");this.c=a}t(Nl,D);g=Gl.prototype;
g.ib=function(a){a=this.h.ib(a);return T(this,a)};g.na=function(a){this.W===a||this.l||(this.W=a,Dh(this.b,this.W),this.dispatchEvent(new Ml(this.ca())))};g.ca=function(){return this.W};g.Oc=function(){var a=k.navigator;this.na(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};g.qc=function(a){this.D.push(a);Eh(this.b,firebase.SDK_VERSION?oe(firebase.SDK_VERSION,this.D):null);this.dispatchEvent(new Nl(this.D))};g.Ka=function(){return Ia(this.D)};
function Ll(a){Object.defineProperty(a,"lc",{get:function(){return this.ca()},set:function(a){this.na(a)},enumerable:!1});a.W=null}g.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).C()}};function Ol(a){return a.Nb||B(new M("auth-domain-config-required"))}
function Kl(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&re()&&(a.Nb=a.V.then(function(){if(!a.l){a.a=qk(b,c,S(a).name);a.a.subscribe(a);U(a)&&Xk(U(a));if(a.B){Xk(a.B);var d=a.B;d.na(a.ca());Qk(d,a);d=a.B;Pk(d,a.D);Rk(d,a);a.B=null}return a.a}}))}g.qb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
g.ga=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};g.wa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.Xb,this):null};
g.Xb=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.c&&(this.c.cancel(),this.c=null);var d=null,e=null,f=If(c.b,a).then(function(a){d=ig(a);e=uf(a);return a});a=c.V.then(function(){return f}).then(function(a){return Pl(c,a)}).then(function(){return He({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return T(this,a)};
g.Gc=function(a){if(!re())return B(new M("operation-not-supported-in-this-environment"));var b=this,c=tf(a.providerId),d=qe(),e=null;(!te()||je())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Oi(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=be(e,c&&c.Aa,c&&c.za);c=Ol(this).then(function(b){return ok(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new z(function(a,c){b.ga("signInViaPopup",null,new M("cancelled-popup-request"),
b.g);b.f=a;b.v=c;b.g=d;b.c=b.a.Da(b,"signInViaPopup",f,d)})}).then(function(a){f&&ae(f);return a?He(a):null}).m(function(a){f&&ae(f);throw a;});return T(this,c)};g.Hc=function(a){if(!re())return B(new M("operation-not-supported-in-this-environment"));var b=this,c=Ol(this).then(function(){return Bl(b.h)}).then(function(){return b.a.Ba("signInViaRedirect",a)});return T(this,c)};
g.da=function(){if(!re())return B(new M("operation-not-supported-in-this-environment"));var a=this,b=Ol(this).then(function(){return a.a.da()}).then(function(a){return a?He(a):null});return T(this,b)};function Pl(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.V.then(function(){return sl(c,b,a.G,a.Ka())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return dl(U(a),b),a.ka(b);Hl(a,b);Xk(b);return a.ka(b)}).then(function(){Ql(a)})}
function Hl(a,b){U(a)&&(Vk(U(a),a.Ga),F(U(a),"tokenChanged",a.qa),F(U(a),"userDeleted",a.ra),F(U(a),"userInvalidated",a.sa),Uk(U(a)));b&&(b.N.push(a.Ga),pc(b,"tokenChanged",a.qa),pc(b,"userDeleted",a.ra),pc(b,"userInvalidated",a.sa),0<a.s&&Tk(b));K(a,"currentUser",b);b&&(b.na(a.ca()),Qk(b,a),Pk(b,a.D),Rk(b,a))}g.kb=function(){var a=this,b=this.j.then(function(){if(!U(a))return A();Hl(a,null);return Dl(a.h).then(function(){Ql(a)})});return T(this,b)};
function Rl(a){var b=ul(a.G,S(a).options.authDomain).then(function(b){if(a.B=b)b.fa=a.G;return pl(a.G)});return T(a,b)}function Il(a){var b=S(a).options.authDomain,c=Rl(a).then(function(){return Fl(a.h,b)}).then(function(b){return b?(b.fa=a.G,a.B&&(a.B.$||null)==(b.$||null)?b:b.reload().then(function(){return Cl(a.h,b).then(function(){return b})}).m(function(c){return"auth/network-request-failed"==c.code?b:Dl(a.h)})):null}).then(function(b){Hl(a,b||null)});return T(a,c)}
function Jl(a){return a.V.then(function(){return a.da()}).m(function(){}).then(function(){if(!a.l)return a.ia()}).m(function(){}).then(function(){if(!a.l){a.X=!0;var b=a.h;b.b.addListener(xl("local"),b.a,a.ia)}})}
g.Ic=function(){var a=this;return Fl(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return dl(U(a),b),U(a).F();if(U(a)||b)Hl(a,b),b&&(Xk(b),b.fa=a.G),a.a&&a.a.subscribe(a),Ql(a)}})};g.ka=function(a){return Cl(this.h,a)};g.Yb=function(){Ql(this);this.ka(U(this))};g.gc=function(){this.kb()};g.hc=function(){this.kb()};
function Sl(a,b){var c=null,d=null;return T(a,b.then(function(b){c=ig(b);d=uf(b);return Pl(a,b)}).then(function(){return He({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}g.ic=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};g.jc=function(a){var b=this;Tl(this,function(){a.next(U(b))})};g.sc=function(a,b,c){var d=this;this.X&&firebase.Promise.resolve().then(function(){n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Ob(a,b,c)};
g.rc=function(a,b,c){var d=this;this.X&&firebase.Promise.resolve().then(function(){d.O=d.getUid();n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Pb(a,b,c)};g.$b=function(a){var b=this,c=this.j.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};g.Cc=function(a){return this.Hb(a).then(function(a){return a.user})};
g.Hb=function(a){var b=this;return this.j.then(function(){return Sl(b,P(b.b,si,{token:a}))}).then(function(a){var c=a.user;cl(c,"isAnonymous",!1);b.ka(c);return a})};g.Ib=function(a,b){var c=this;return this.j.then(function(){return Sl(c,P(c.b,Xf,{email:a,password:b}))})};g.Dc=function(a,b){return this.Ib(a,b).then(function(a){return a.user})};g.Sb=function(a,b){return this.sb(a,b).then(function(a){return a.user})};
g.sb=function(a,b){var c=this;return this.j.then(function(){return Sl(c,P(c.b,oi,{email:a,password:b}))})};g.Bc=function(a){return this.Oa(a).then(function(a){return a.user})};g.Oa=function(a){var b=this;return this.j.then(function(){return Sl(b,a.xa(b.b))})};g.jb=function(){return this.Jb().then(function(a){return a.user})};
g.Jb=function(){var a=this;return this.j.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=He({providerId:null,isNewUser:!1});return He({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Sl(a,a.b.jb()).then(function(b){var c=b.user;cl(c,"isAnonymous",!0);a.ka(c);return b})})};function S(a){return a.app}function U(a){return a.currentUser}g.getUid=function(){return U(this)&&U(this).uid||null};function Ul(a){return U(a)&&U(a)._lat||null}
function Ql(a){if(a.X){for(var b=0;b<a.o.length;b++)if(a.o[b])a.o[b](Ul(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Ul(a))}}g.Qb=function(a){this.addAuthTokenListener(a);this.s++;0<this.s&&U(this)&&Tk(U(this))};g.zc=function(a){var b=this;v(this.o,function(c){c==a&&b.s--});0>this.s&&(this.s=0);0==this.s&&U(this)&&Uk(U(this));this.removeAuthTokenListener(a)};
g.addAuthTokenListener=function(a){var b=this;this.o.push(a);T(this,this.j.then(function(){b.l||Fa(b.o,a)&&a(Ul(b))}))};g.removeAuthTokenListener=function(a){w(this.o,function(b){return b==a})};function Tl(a,b){a.I.push(b);T(a,a.j.then(function(){!a.l&&Fa(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(Ul(a)))}))}
g.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(xl("local"),a.a,this.ia));this.a&&this.a.unsubscribe(this);return firebase.Promise.resolve()};function T(a,b){a.N.push(b);b.ha(function(){Ga(a.N,b)});return b}g.Vb=function(a){return T(this,Oh(this.b,a))};g.Wb=function(a){return T(this,Qh(this.b,a))};g.kc=function(a){return!!ag(a)};
g.hb=function(a,b){var c=this;return T(this,A().then(function(){var a=new Xe(b);if(!a.c)throw new M("argument-error",ef+" must be true when sending sign in link to email");return ff(a)}).then(function(b){return c.b.hb(a,b)}).then(function(){}))};g.Pc=function(a){return this.Ia(a).then(function(a){return a.data.email})};g.Wa=function(a,b){return T(this,this.b.Wa(a,b).then(function(){}))};g.Ia=function(a){return T(this,this.b.Ia(a).then(function(a){return new Le(a)}))};
g.Ua=function(a){return T(this,this.b.Ua(a).then(function(){}))};g.gb=function(a,b){var c=this;return T(this,A().then(function(){return"undefined"===typeof b||Ya(b)?{}:ff(new Xe(b))}).then(function(b){return c.b.gb(a,b)}).then(function(){}))};g.Fc=function(a,b){return T(this,yk(this,a,b,r(this.Oa,this)))};g.Ec=function(a,b){var c=this;return T(this,A().then(function(){var d=$f(a,b||Ud());return c.Oa(d)}))};function Vl(a,b,c,d,e,f){K(this,"type","recaptcha");this.b=this.c=null;this.o=!1;this.l=b;this.a=c||{theme:"light",type:"image"};this.g=[];if(this.a[Wl])throw new M("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.h="invisible"===this.a[Xl];if(!k.document)throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");if(!Hd(b)||!this.h&&
Hd(b).hasChildNodes())throw new M("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new xh(a,f||null,e||null);this.s=d||function(){return null};var h=this;this.j=[];var m=this.a[Yl];this.a[Yl]=function(a){Zl(h,a);if("function"===typeof m)m(a);else if("string"===typeof m){var b=J(m,k);"function"===typeof b&&b(a)}};var p=this.a[$l];this.a[$l]=function(){Zl(h,null);if("function"===typeof p)p();else if("string"===typeof p){var a=J(p,k);"function"===
typeof a&&a()}}}var Yl="callback",$l="expired-callback",Wl="sitekey",Xl="size";function Zl(a,b){for(var c=0;c<a.j.length;c++)try{a.j[c](b)}catch(d){}}function am(a,b){w(a.j,function(a){return a==b})}function bm(a,b){a.g.push(b);b.ha(function(){Ga(a.g,b)});return b}g=Vl.prototype;
g.ya=function(){var a=this;return this.c?this.c:this.c=bm(this,A().then(function(){if(se()&&!ke())return fe();throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return cm(dm(),a.s())}).then(function(){return P(a.u,ri,{})}).then(function(b){a.a[Wl]=b.recaptchaSiteKey}).m(function(b){a.c=null;throw b;}))};
g.render=function(){em(this);var a=this;return bm(this,this.ya().then(function(){if(null===a.b){var b=a.l;if(!a.h){var c=Hd(b);b=Kd("DIV");c.appendChild(b)}a.b=grecaptcha.render(b,a.a)}return a.b}))};g.verify=function(){em(this);var a=this;return bm(this,this.render().then(function(b){return new z(function(c){var d=grecaptcha.getResponse(b);if(d)c(d);else{var e=function(b){b&&(am(a,e),c(b))};a.j.push(e);a.h&&grecaptcha.execute(a.b)}})}))};g.reset=function(){em(this);null!==this.b&&grecaptcha.reset(this.b)};
function em(a){if(a.o)throw new M("internal-error","RecaptchaVerifier instance has been destroyed.");}g.clear=function(){em(this);this.o=!0;dm().b--;for(var a=0;a<this.g.length;a++)this.g[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.h){a=Hd(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};var fm=pd("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}");
function gm(){this.b=k.grecaptcha?Infinity:0;this.c=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var hm=new ze(3E4,6E4);
function cm(a,b){return new z(function(c,d){var e=setTimeout(function(){d(new M("network-request-failed"))},hm.get());if(!k.grecaptcha||b!==a.c&&!a.b){k[a.a]=function(){if(k.grecaptcha){a.c=b;var f=k.grecaptcha.render;k.grecaptcha.render=function(b,c){b=f(b,c);a.b++;return b};clearTimeout(e);c()}else clearTimeout(e),d(new M("internal-error"));delete k[a.a]};var f=td(fm,{onload:a.a,hl:b||""});A(ph(f)).m(function(){clearTimeout(e);d(new M("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c()})}var im=null;function dm(){im||(im=new gm);return im}
function jm(a,b,c){try{this.f=c||firebase.app()}catch(f){throw new M("argument-error","No firebase.app.App instance is currently initialized.");}if(this.f.options&&this.f.options.apiKey)c=this.f.options.apiKey;else throw new M("invalid-api-key");var d=this,e=null;try{e=this.f.auth().Ka()}catch(f){}e=firebase.SDK_VERSION?oe(firebase.SDK_VERSION,e):null;Vl.call(this,c,a,b,function(){try{var a=d.f.auth().ca()}catch(h){a=null}return a},e,ui(vi))}t(jm,Vl);function km(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,h=0;h<b.length;h++)if(b[h].optional)f=!0;else{if(f)throw new M("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=lm.length)throw new M("internal-error",
"Argument validator received an unsupported number of arguments.");c=lm[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new M("argument-error",a+" failed: "+d);}var lm="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:l}}function mm(){return{name:"opt_forceRefresh",K:"a boolean",optional:!0,M:ba}}
function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function nm(a,b){return{name:a||"",K:"a function",optional:!!b,M:n}}function om(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function pm(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function qm(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof Gl)}}}
function rm(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof firebase.app.App)}}}function sm(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.xa||!c)}}}
function tm(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function um(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&l(a.type)&&n(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=vm(d,a[c],b[c].i)}}function Z(a,b,c,d){a[b]=vm(b,c,d)}function vm(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);km(e,c,a);return b.apply(this,a)}if(!c)return b;var e=wm(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function wm(a){a=a.split(".");return a[a.length-1]};Y(Gl.prototype,{Ua:{name:"applyActionCode",i:[V("code")]},Ia:{name:"checkActionCode",i:[V("code")]},Wa:{name:"confirmPasswordReset",i:[V("code"),V("newPassword")]},Sb:{name:"createUserWithEmailAndPassword",i:[V("email"),V("password")]},sb:{name:"createUserAndRetrieveDataWithEmailAndPassword",i:[V("email"),V("password")]},Vb:{name:"fetchProvidersForEmail",i:[V("email")]},Wb:{name:"fetchSignInMethodsForEmail",i:[V("email")]},da:{name:"getRedirectResult",i:[]},kc:{name:"isSignInWithEmailLink",i:[V("emailLink")]},
rc:{name:"onAuthStateChanged",i:[X(W(),nm(),"nextOrObserver"),nm("opt_error",!0),nm("opt_completed",!0)]},sc:{name:"onIdTokenChanged",i:[X(W(),nm(),"nextOrObserver"),nm("opt_error",!0),nm("opt_completed",!0)]},gb:{name:"sendPasswordResetEmail",i:[V("email"),X(W("opt_actionCodeSettings",!0),om(null,!0),"opt_actionCodeSettings",!0)]},hb:{name:"sendSignInLinkToEmail",i:[V("email"),W("actionCodeSettings")]},ib:{name:"setPersistence",i:[V("persistence")]},Oa:{name:"signInAndRetrieveDataWithCredential",
i:[sm()]},jb:{name:"signInAnonymously",i:[]},Jb:{name:"signInAnonymouslyAndRetrieveData",i:[]},Bc:{name:"signInWithCredential",i:[sm()]},Cc:{name:"signInWithCustomToken",i:[V("token")]},Hb:{name:"signInAndRetrieveDataWithCustomToken",i:[V("token")]},Dc:{name:"signInWithEmailAndPassword",i:[V("email"),V("password")]},Ec:{name:"signInWithEmailLink",i:[V("email"),V("emailLink",!0)]},Ib:{name:"signInAndRetrieveDataWithEmailAndPassword",i:[V("email"),V("password")]},Fc:{name:"signInWithPhoneNumber",i:[V("phoneNumber"),
um()]},Gc:{name:"signInWithPopup",i:[tm()]},Hc:{name:"signInWithRedirect",i:[tm()]},kb:{name:"signOut",i:[]},toJSON:{name:"toJSON",i:[V(null,!0)]},Oc:{name:"useDeviceLanguage",i:[]},Pc:{name:"verifyPasswordResetCode",i:[V("code")]}});(function(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].Rb;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){km(d,[e],[a],!0);this[c]=a},enumerable:!0})}}})(Gl.prototype,{lc:{name:"languageCode",Rb:X(V(),om(),"languageCode")}});
Gl.Persistence=oj;Gl.Persistence.LOCAL="local";Gl.Persistence.SESSION="session";Gl.Persistence.NONE="none";
Y(Lk.prototype,{"delete":{name:"delete",i:[]},ac:{name:"getIdTokenResult",i:[mm()]},F:{name:"getIdToken",i:[mm()]},getToken:{name:"getToken",i:[mm()]},$a:{name:"linkAndRetrieveDataWithCredential",i:[sm()]},mc:{name:"linkWithCredential",i:[sm()]},nc:{name:"linkWithPhoneNumber",i:[V("phoneNumber"),um()]},oc:{name:"linkWithPopup",i:[tm()]},pc:{name:"linkWithRedirect",i:[tm()]},bb:{name:"reauthenticateAndRetrieveDataWithCredential",i:[sm()]},vc:{name:"reauthenticateWithCredential",i:[sm()]},wc:{name:"reauthenticateWithPhoneNumber",
i:[V("phoneNumber"),um()]},xc:{name:"reauthenticateWithPopup",i:[tm()]},yc:{name:"reauthenticateWithRedirect",i:[tm()]},reload:{name:"reload",i:[]},fb:{name:"sendEmailVerification",i:[X(W("opt_actionCodeSettings",!0),om(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",i:[V(null,!0)]},Mc:{name:"unlink",i:[V("provider")]},mb:{name:"updateEmail",i:[V("email")]},nb:{name:"updatePassword",i:[V("password")]},Nc:{name:"updatePhoneNumber",i:[sm("phone")]},ob:{name:"updateProfile",i:[W("profile")]}});
Y(z.prototype,{ha:{name:"finally"},m:{name:"catch"},then:{name:"then"}});Y(xk.prototype,{confirm:{name:"confirm",i:[V("verificationCode")]}});Z(O,"credential",function(a,b){return new Vf(a,b)},[V("email"),V("password")]);Y(Nf.prototype,{ta:{name:"addScope",i:[V("scope")]},Ca:{name:"setCustomParameters",i:[W("customOAuthParameters")]}});Z(Nf,"credential",Of,[X(V(),W(),"token")]);Z(O,"credentialWithLink",$f,[V("email"),V("emailLink")]);
Y(Pf.prototype,{ta:{name:"addScope",i:[V("scope")]},Ca:{name:"setCustomParameters",i:[W("customOAuthParameters")]}});Z(Pf,"credential",Qf,[X(V(),W(),"token")]);Y(Rf.prototype,{ta:{name:"addScope",i:[V("scope")]},Ca:{name:"setCustomParameters",i:[W("customOAuthParameters")]}});Z(Rf,"credential",Sf,[X(V(),X(W(),om()),"idToken"),X(V(),om(),"accessToken",!0)]);Y(Tf.prototype,{Ca:{name:"setCustomParameters",i:[W("customOAuthParameters")]}});Z(Tf,"credential",Uf,[X(V(),W(),"token"),V("secret",!0)]);
Y(N.prototype,{ta:{name:"addScope",i:[V("scope")]},credential:{name:"credential",i:[X(V(),om(),"idToken",!0),X(V(),om(),"accessToken",!0)]},Ca:{name:"setCustomParameters",i:[W("customOAuthParameters")]}});Z(fg,"credential",hg,[V("verificationId"),V("verificationCode")]);Y(fg.prototype,{Sa:{name:"verifyPhoneNumber",i:[V("phoneNumber"),um()]}});Y(M.prototype,{toJSON:{name:"toJSON",i:[V(null,!0)]}});Y(pg.prototype,{toJSON:{name:"toJSON",i:[V(null,!0)]}});
Y(og.prototype,{toJSON:{name:"toJSON",i:[V(null,!0)]}});Y(jm.prototype,{clear:{name:"clear",i:[]},render:{name:"render",i:[]},verify:{name:"verify",i:[]}});
(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:Gl,Error:M};Z(a,"EmailAuthProvider",O,[]);Z(a,"FacebookAuthProvider",Nf,[]);Z(a,"GithubAuthProvider",Pf,[]);Z(a,"GoogleAuthProvider",Rf,[]);Z(a,"TwitterAuthProvider",Tf,[]);Z(a,"OAuthProvider",N,[V("providerId")]);Z(a,"PhoneAuthProvider",fg,[qm()]);Z(a,"RecaptchaVerifier",jm,[X(V(),pm(),"recaptchaContainer"),W("recaptchaParameters",!0),rm()]);firebase.INTERNAL.registerService("auth",function(a,
c){a=new Gl(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.$b,a),addAuthTokenListener:r(a.Qb,a),removeAuthTokenListener:r(a.zc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:Lk})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();
}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = __webpack_require__(1169);


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var util = __webpack_require__(324);
var logger = __webpack_require__(1170);
var tslib_1 = __webpack_require__(325);
var firebase = _interopDefault(__webpack_require__(184));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = util.stringToByteArray(str);
    var sha1 = new util.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger$1 = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = logger.LogLevel.VERBOSE;
        logger$1 = logClient.log.bind(logClient);
        if (persistent)
            SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        logger$1 = logger_;
    }
    else {
        logger$1 = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger$1 === null && SessionStorage.get('logging_enabled') === true)
            enableLogging(true);
    }
    if (logger$1) {
        var message = buildLogMessage_.apply(null, var_args);
        logger$1(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
};
/**
 * @param {...string} var_args
 */
var fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} var_args
 */
var warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if (util.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util.stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
var each = function (obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    }
    else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        util.forEach(obj, function (key, val) { return fn(val, key); });
    }
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost || this.isCustomHost();
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util.assert(typeof type === 'string', 'typeof type must == string');
        util.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        util.forEach(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var results = {};
    if (queryString.startsWith('?')) {
        queryString = queryString.substring(1);
    }
    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
        var segment = _a[_i];
        if (segment.length === 0) {
            continue;
        }
        var kv = segment.split('=');
        if (kv.length === 2) {
            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
        else {
            warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
var parseRepoInfo = function (dataURL) {
    var parsedUrl = parseURL(dataURL), namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
var parseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Support `ns` query param if subdomain not already set
        if (subdomain === '' && 'ns' in queryParams) {
            subdomain = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        util.stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false, hasActualChild_1 = false;
        util.forEach(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) {
                // .priority is OK
            }
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    util.forEach(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (isInvalidJSONNumber(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!isValidKey(key))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!isValidPathString(pathString))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib_1.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function () {
            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
        else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util.contains(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = util.clone(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = util.clone(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util.safeGet(_this.indexSet_, indexName);
            util.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib_1.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        util.forEach(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        util.forEach(jsonObj_1, function (key, childData) {
            if (util.contains(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib_1.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherCount = util.getCount(other.callbacks_);
                var thisCount = util.getCount(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = util.getAnyKey(other.callbacks_);
                        var thisKey /** @type {!string} */ = util.getAnyKey(this.callbacks_);
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return util.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util.assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util.validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        util.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util.validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        util.validateCallback('Query.off', 2, callback, true);
        util.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param cancelOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
        var _this = this;
        util.validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        util.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error$$1 = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error$$1);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */ (function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return util.contains(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return util.isEmpty(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return util.getCount(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        util.forEach(this.set, function (k, v) { return fn(k, v); });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        util.forEach(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        }
        else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        }
        else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        }
        else {
            if (this.children_ == null) {
                this.children_ = new CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        }
        else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree();
    tree.forEachTree(new Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        util.forEach(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        util.assert(type == Change.CHILD_ADDED ||
            type == Change.CHILD_CHANGED ||
            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = util.safeGet(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childRemovedChange(childKey, oldChange.oldSnap);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap_[childKey] = Change.childAddedChange(childKey, change.snapshotNode);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            }
            else {
                throw util.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return util.getValues(this.changeMap_);
    };
    return ChildChangeAccumulator;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap
                        .getNode()
                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return util.isEmpty(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = util.safeGet(this.views_, queryId);
            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events_1 = [];
            util.forEach(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = util.safeGet(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            util.forEach(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        }
        else {
            // remove the callback from the specific view.
            var view = util.safeGet(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
        return values.filter(function (view) {
            return !view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        util.forEach(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return util.safeGet(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = util.findValue(this.views_, function (view) {
            return view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        util.forEach(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        }
        else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                }
                else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                util.forEach(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!util.findKey(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = util.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else {
                    throw util.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                util.forEach(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
                else {
                    // There's nothing below us, so nothing we need to start listening on
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        else {
            // No-op, this listener must've been already removed
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                util.forEach(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return /** @type {!Query} */ query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    util.forEach(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error$$1 = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error$$1);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return util.safeGet(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error$$1) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error$$1 && error$$1.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error$$1);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn(errorMessage);
    };
    return AuthTokenProvider;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util.deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = util.clone(newStats);
        if (this.last_) {
            util.forEach(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        util.forEach(stats, function (stat, value) {
            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger$1) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0], arg1 = args[1], arg2 = args[2];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0], data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!util.isNodeSdk() &&
                typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return (BrowserPollConnection.forceAllow_ ||
            (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp() &&
                !util.isNodeSdk()));
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if (util.isNodeSdk() && this.myID) {
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function () {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (!util.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util.isNodeSdk()) {
                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + firebase.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = process['env'];
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error$$1 = e.message || e.data;
            if (error$$1) {
                this.log_(error$$1);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error$$1 = e.message || e.data;
            if (error$$1) {
                _this.log_(error$$1);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports_1 = (this.transports_ = []);
            each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util.stringify(msg));
        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
            var warnings = util.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request[ /*hash*/'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            error('Unrecognized action received from server: ' +
                util.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error$$1) {
                self_1.log_('Failed to get token: ' + error$$1);
                if (!canceled_1) {
                    if (util.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn(error$$1);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if (util.getCount(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        util.forEach(this.listens_, function (pathString, queries) {
            util.forEach(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + firebase.SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return util.isEmpty(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParamaters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParamaters, function (error$$1, result) {
            var data = result;
            if (error$$1 === 404) {
                data = null;
                error$$1 = null;
            }
            if (error$$1 === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error$$1) {
                    status_1 = 'ok';
                }
                else if (error$$1 == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error$$1;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                util.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new AuthTokenProvider(app);
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util.map(data, function (raw) {
                    return nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util.map(data, function (raw) {
                return nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        util.forEach(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON$1(changedValue);
            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            util.forEach(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util.isEmpty(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                util.forEach(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        util.forEach(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++)
                stat += ' ';
            console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error$$1 = new Error(message);
                    error$$1.code = code;
                    callback(error$$1);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference = /** @class */ (function (_super) {
    tslib_1.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null)
                validateRootPathString('Reference.child', 1, pathString, false);
            else
                validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util.validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        util.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error$$1, committed, snapshot) {
            if (error$$1) {
                deferred.reject(error$$1);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error$$1, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        util.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util.validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference;
SyncPoint.__referenceConstructor = Reference;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        util.forEach(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util.contains(newVal, '.priority')) {
            priorityForNode = util.safeGet(newVal, '.priority');
            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
                // Already marked.  No action needed.
            }
            else if (queue[i].status === TransactionStatus.SENT) {
                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        util.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
var listens = function (firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  listens: listens,
  forceRestClient: forceRestClient
});

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference,
        Query: Query,
        Database: Database,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util.isNodeSdk()) {
        module.exports = namespace;
    }
}
registerDatabase(firebase);

exports.registerDatabase = registerDatabase;
exports.Database = Database;
exports.Query = Query;
exports.Reference = Reference;
exports.enableLogging = enableLogging;
exports.ServerValue = ServerValue;
exports.DataSnapshot = DataSnapshot;
exports.OnDisconnect = OnDisconnect;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel)
        return;
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}




/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1172);


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerMessaging", function() { return registerMessaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(184);




/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_CODES = {
    AVAILABLE_IN_WINDOW: 'only-available-in-window',
    AVAILABLE_IN_SW: 'only-available-in-sw',
    SHOULD_BE_INHERITED: 'should-be-overriden',
    BAD_SENDER_ID: 'bad-sender-id',
    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
    PERMISSION_DEFAULT: 'permission-default',
    PERMISSION_BLOCKED: 'permission-blocked',
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
    INVALID_SAVED_TOKEN: 'invalid-saved-token',
    SW_REG_REDUNDANT: 'sw-reg-redundant',
    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
    TOKEN_UNSUBSCRIBE_FAILED: 'token-unsubscribe-failed',
    TOKEN_UPDATE_FAILED: 'token-update-failed',
    TOKEN_UPDATE_NO_TOKEN: 'token-update-no-token',
    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
    INVALID_DELETE_TOKEN: 'invalid-delete-token',
    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
    NO_SW_IN_REG: 'no-sw-in-reg',
    BAD_SCOPE: 'bad-scope',
    BAD_VAPID_KEY: 'bad-vapid-key',
    BAD_SUBSCRIPTION: 'bad-subscription',
    BAD_TOKEN: 'bad-token',
    BAD_PUSH_SET: 'bad-push-set',
    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key',
    INVALID_PUBLIC_VAPID_KEY: 'invalid-public-vapid-key',
    USE_PUBLIC_KEY_BEFORE_GET_TOKEN: 'use-public-key-before-get-token',
    PUBLIC_KEY_DECRYPTION_FAILED: 'public-vapid-key-decryption-failed'
};
var ERROR_MAP = (_a = {}, _a[ERROR_CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.', _a[ERROR_CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.', _a[ERROR_CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.', _a[ERROR_CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
        'correctly in the options passed into firebase.initializeApp().', _a[ERROR_CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.', _a[ERROR_CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.', _a[ERROR_CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
        'required to use the firebase SDK.', _a[ERROR_CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.', _a[ERROR_CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
        'default service worker. {$browserErrorMessage}', _a[ERROR_CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.', _a[ERROR_CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
        'any existing Push Subscriptions.', _a[ERROR_CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.', _a[ERROR_CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.', _a[ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED] = 'A problem occured while unsubscribing the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_FAILED] = 'A problem occured while updating the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_NO_TOKEN] = 'FCM returned no token when updating ' + 'the user to push.', _a[ERROR_CODES.USE_SW_BEFORE_GET_TOKEN] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.', _a[ERROR_CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
        'deleteToken(), i.e. the token from getToken().', _a[ERROR_CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
        'be performed as the token was not found.', _a[ERROR_CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
        'scope could not be performed as the scope was not found.', _a[ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.', _a[ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.', _a[ERROR_CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
        'the FCM token for push messaging. Will have to resubscribe the ' +
        'user on next visit. {$message}', _a[ERROR_CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
        'user on next visit.', _a[ERROR_CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.', _a[ERROR_CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
        'successful, there was a problem accessing the service worker itself.', _a[ERROR_CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.", _a[ERROR_CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
        'least one character.', _a[ERROR_CODES.BAD_VAPID_KEY] = 'The public VAPID key is not a Uint8Array with 65 bytes.', _a[ERROR_CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.', _a[ERROR_CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
        'a valid token string.', _a[ERROR_CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
        'not a valid push set string.', _a[ERROR_CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.', _a[ERROR_CODES.INVALID_PUBLIC_VAPID_KEY] = 'The public VAPID key must be a string.', _a[ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED] = 'The public VAPID key did not equal ' + '65 bytes when decrypted.', _a);
var errorFactory = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);
var _a;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_PUBLIC_VAPID_KEY = new Uint8Array([
    0x04,
    0x33,
    0x94,
    0xf7,
    0xdf,
    0xa1,
    0xeb,
    0xb1,
    0xdc,
    0x03,
    0xa2,
    0x5e,
    0x15,
    0x71,
    0xdb,
    0x48,
    0xd3,
    0x2e,
    0xed,
    0xed,
    0xb2,
    0x34,
    0xdb,
    0xb7,
    0x47,
    0x3a,
    0x0c,
    0x8f,
    0xc4,
    0xcc,
    0xe1,
    0x6f,
    0x3c,
    0x8c,
    0x84,
    0xdf,
    0xab,
    0xb6,
    0x66,
    0x3e,
    0xf2,
    0x0c,
    0xd4,
    0x8b,
    0xfe,
    0xe3,
    0xf9,
    0x76,
    0x2f,
    0x14,
    0x1c,
    0x63,
    0x08,
    0x6a,
    0x6f,
    0x2d,
    0xb1,
    0x1a,
    0x95,
    0xb0,
    0xce,
    0x37,
    0xc0,
    0x9c,
    0x6e
]);
var ENDPOINT = 'https://fcm.googleapis.com';

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MessageParameter;
(function (MessageParameter) {
    MessageParameter["TYPE_OF_MSG"] = "firebase-messaging-msg-type";
    MessageParameter["DATA"] = "firebase-messaging-msg-data";
})(MessageParameter || (MessageParameter = {}));
var MessageType;
(function (MessageType) {
    MessageType["PUSH_MSG_RECEIVED"] = "push-msg-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isArrayBufferEqual(a, b) {
    if (a == null || b == null) {
        return false;
    }
    if (a === b) {
        return true;
    }
    if (a.byteLength !== b.byteLength) {
        return false;
    }
    var viewA = new DataView(a);
    var viewB = new DataView(b);
    for (var i = 0; i < a.byteLength; i++) {
        if (viewA.getUint8(i) !== viewB.getUint8(i)) {
            return false;
        }
    }
    return true;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return btoa(String.fromCharCode.apply(null, uint8Version));
}
function arrayBufferToBase64(arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IIDModel = /** @class */ (function () {
    function IIDModel() {
    }
    IIDModel.prototype.getToken = function (senderId, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var p256dh, auth, fcmSubscribeBody, applicationPubKey, headers, subscribeOptions, responseData, response, err_1, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (publicVapidKey !== DEFAULT_PUBLIC_VAPID_KEY) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmSubscribeBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        subscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmSubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED);
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED, {
                                message: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN);
                        }
                        if (!responseData.pushSet) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET);
                        }
                        return [2 /*return*/, {
                                token: responseData.token,
                                pushSet: responseData.pushSet
                            }];
                }
            });
        });
    };
    /**
     * Update the underlying token details for fcmToken.
     */
    IIDModel.prototype.updateToken = function (senderId, fcmToken, fcmPushSet, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var p256dh, auth, fcmUpdateBody, applicationPubKey, headers, updateOptions, responseData, response, err_2, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmUpdateBody = "push_set=" + fcmPushSet + "&" +
                            ("token=" + fcmToken + "&") +
                            ("authorized_entity=" + senderId + "&") +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (publicVapidKey !== DEFAULT_PUBLIC_VAPID_KEY) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmUpdateBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        updateOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUpdateBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', updateOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED);
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED, {
                                message: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_NO_TOKEN);
                        }
                        return [2 /*return*/, responseData.token];
                }
            });
        });
    };
    /**
     * Given a fcmToken, pushSet and messagingSenderId, delete an FCM token.
     */
    IIDModel.prototype.deleteToken = function (senderId, fcmToken, fcmPushSet) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var fcmUnsubscribeBody, headers, unsubscribeOptions, response, responseData, message, err_3;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fcmUnsubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("token=" + fcmToken + "&") +
                            ("pushSet=" + fcmPushSet);
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        unsubscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUnsubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/unsubscribe', unsubscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED, {
                                message: message
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return IIDModel;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function base64ToArrayBuffer(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'undefined';
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function handleDb(db) {
    if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
        // We found a database with the name 'undefined', but our expected object
        // store isn't defined.
        return;
    }
    var transaction = db.transaction(OLD_OBJECT_STORE_NAME);
    var objectStore = transaction.objectStore(OLD_OBJECT_STORE_NAME);
    var iidModel = new IIDModel();
    var openCursorRequest = objectStore.openCursor();
    openCursorRequest.onerror = function (event) {
        // NOOP - Nothing we can do.
        console.warn('Unable to cleanup old IDB.', event);
    };
    openCursorRequest.onsuccess = function () {
        var cursor = openCursorRequest.result;
        if (cursor) {
            // cursor.value contains the current record being iterated through
            // this is where you'd do something with the result
            var tokenDetails = cursor.value;
            iidModel.deleteToken(tokenDetails.fcmSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet);
            cursor.continue();
        }
        else {
            db.close();
            indexedDB.deleteDatabase(OLD_DB_NAME);
        }
    };
}
function cleanV1() {
    var request = indexedDB.open(OLD_DB_NAME);
    request.onerror = function (event) {
        // NOOP - Nothing we can do.
    };
    request.onsuccess = function (event) {
        var db = request.result;
        handleDb(db);
    };
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DBInterface = /** @class */ (function () {
    function DBInterface() {
        this.dbPromise = null;
    }
    /** Gets record(s) from the objectStore that match the given key. */
    DBInterface.prototype.get = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.get(key); });
    };
    /** Gets record(s) from the objectStore that match the given index. */
    DBInterface.prototype.getIndex = function (index, key) {
        function runRequest(objectStore) {
            var idbIndex = objectStore.index(index);
            return idbIndex.get(key);
        }
        return this.createTransaction(runRequest);
    };
    /** Assigns or overwrites the record for the given value. */
    // tslint:disable-next-line:no-any IndexedDB values are of type "any"
    DBInterface.prototype.put = function (value) {
        return this.createTransaction(function (objectStore) { return objectStore.put(value); }, 'readwrite');
    };
    /** Deletes record(s) from the objectStore that match the given key. */
    DBInterface.prototype.delete = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.delete(key); }, 'readwrite');
    };
    /**
     * Close the currently open database.
     */
    DBInterface.prototype.closeDatabase = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var db;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dbPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dbPromise];
                    case 1:
                        db = _a.sent();
                        db.close();
                        this.dbPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates an IndexedDB Transaction and passes its objectStore to the
     * runRequest function, which runs the database request.
     *
     * @return Promise that resolves with the result of the runRequest function
     */
    DBInterface.prototype.createTransaction = function (runRequest, mode) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var db, transaction, request, result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDb()];
                    case 1:
                        db = _a.sent();
                        transaction = db.transaction(this.objectStoreName, mode);
                        request = transaction.objectStore(this.objectStoreName);
                        return [4 /*yield*/, promisify(runRequest(request))];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                transaction.oncomplete = function () {
                                    resolve(result);
                                };
                                transaction.onerror = function () {
                                    reject(transaction.error);
                                };
                            })];
                }
            });
        });
    };
    /** Gets the cached db connection or opens a new one. */
    DBInterface.prototype.getDb = function () {
        var _this = this;
        if (!this.dbPromise) {
            this.dbPromise = new Promise(function (resolve, reject) {
                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                request.onsuccess = function () {
                    resolve(request.result);
                };
                request.onerror = function () {
                    _this.dbPromise = null;
                    reject(request.error);
                };
                request.onupgradeneeded = function (event) { return _this.onDbUpgrade(request, event); };
            });
        }
        return this.dbPromise;
    };
    return DBInterface;
}());
/** Promisifies an IDBRequest. Resolves with the IDBRequest's result. */
function promisify(request) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function () {
            resolve(request.result);
        };
        request.onerror = function () {
            reject(request.error);
        };
    });
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TokenDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(TokenDetailsModel, _super);
    function TokenDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_token_details_db';
        _this.dbVersion = 3;
        _this.objectStoreName = 'fcm_token_object_Store';
        return _this;
    }
    TokenDetailsModel.prototype.onDbUpgrade = function (request, event) {
        var db = request.result;
        // Lack of 'break' statements is intentional.
        switch (event.oldVersion) {
            case 0: {
                // New IDB instance
                var objectStore = db.createObjectStore(this.objectStoreName, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', { unique: true });
            }
            case 1: {
                // Prior to version 2, we were using either 'fcm_token_details_db'
                // or 'undefined' as the database name due to bug in the SDK
                // So remove the old tokens and databases.
                cleanV1();
            }
            case 2: {
                var objectStore = request.transaction.objectStore(this.objectStoreName);
                var cursorRequest_1 = objectStore.openCursor();
                cursorRequest_1.onsuccess = function () {
                    var cursor = cursorRequest_1.result;
                    if (cursor) {
                        var value = cursor.value;
                        var newValue = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, value);
                        if (!value.createTime) {
                            newValue.createTime = Date.now();
                        }
                        if (typeof value.vapidKey === 'string') {
                            newValue.vapidKey = base64ToArrayBuffer(value.vapidKey);
                        }
                        if (typeof value.auth === 'string') {
                            newValue.auth = base64ToArrayBuffer(value.auth).buffer;
                        }
                        if (typeof value.auth === 'string') {
                            newValue.p256dh = base64ToArrayBuffer(value.p256dh).buffer;
                        }
                        cursor.update(newValue);
                        cursor.continue();
                    }
                };
            }
        }
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!fcmToken) {
                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
                }
                validateInputs({ fcmToken: fcmToken });
                return [2 /*return*/, this.getIndex('fcmToken', fcmToken)];
            });
        });
    };
    /**
     * Given a service worker scope, this method will look up the details in
     * indexedDB.
     * @return The details associated with that token.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!swScope) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                validateInputs({ swScope: swScope });
                return [2 /*return*/, this.get(swScope)];
            });
        });
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @param input A plain js object containing args to save.
     */
    TokenDetailsModel.prototype.saveTokenDetails = function (tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!tokenDetails.swScope) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                if (!tokenDetails.vapidKey) {
                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
                }
                if (!tokenDetails.endpoint || !tokenDetails.auth || !tokenDetails.p256dh) {
                    throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
                }
                if (!tokenDetails.fcmSenderId) {
                    throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
                }
                if (!tokenDetails.fcmToken) {
                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
                }
                if (!tokenDetails.fcmPushSet) {
                    throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
                }
                validateInputs(tokenDetails);
                return [2 /*return*/, this.put(tokenDetails)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     *
     * @return Resolves once the FCM token details have been deleted and returns
     * the deleted details.
     */
    TokenDetailsModel.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof token !== 'string' || token.length === 0) {
                            return [2 /*return*/, Promise.reject(errorFactory.create(ERROR_CODES.INVALID_DELETE_TOKEN))];
                        }
                        return [4 /*yield*/, this.getTokenDetailsFromToken(token)];
                    case 1:
                        details = _a.sent();
                        if (!details) {
                            throw errorFactory.create(ERROR_CODES.DELETE_TOKEN_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.delete(details.swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, details];
                }
            });
        });
    };
    return TokenDetailsModel;
}(DBInterface));
/**
 * This method takes an object and will check for known arguments and
 * validate the input.
 * @return Promise that resolves if input is valid, rejects otherwise.
 */
function validateInputs(input) {
    if (input.fcmToken) {
        if (typeof input.fcmToken !== 'string' || input.fcmToken.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
        }
    }
    if (input.swScope) {
        if (typeof input.swScope !== 'string' || input.swScope.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
        }
    }
    if (input.vapidKey) {
        if (!(input.vapidKey instanceof Uint8Array) ||
            input.vapidKey.length !== 65) {
            throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
        }
    }
    if (input.endpoint) {
        if (typeof input.endpoint !== 'string' || input.endpoint.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.auth) {
        if (!(input.auth instanceof ArrayBuffer)) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.p256dh) {
        if (!(input.p256dh instanceof ArrayBuffer)) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.fcmSenderId) {
        if (typeof input.fcmSenderId !== 'string' ||
            input.fcmSenderId.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
        }
    }
    if (input.fcmPushSet) {
        if (typeof input.fcmPushSet !== 'string' || input.fcmPushSet.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
        }
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
var VapidDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(VapidDetailsModel, _super);
    function VapidDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_vapid_details_db';
        _this.dbVersion = 1;
        _this.objectStoreName = 'fcm_vapid_object_Store';
        return _this;
    }
    VapidDetailsModel.prototype.onDbUpgrade = function (request) {
        var db = request.result;
        db.createObjectStore(this.objectStoreName, { keyPath: 'swScope' });
    };
    /**
     * Given a service worker scope, this method will look up the vapid key
     * in indexedDB.
     */
    VapidDetailsModel.prototype.getVapidFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof swScope !== 'string' || swScope.length === 0) {
                            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                        }
                        return [4 /*yield*/, this.get(swScope)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.vapidKey : undefined];
                }
            });
        });
    };
    /**
     * Save a vapid key against a swScope for later date.
     */
    VapidDetailsModel.prototype.saveVapidDetails = function (swScope, vapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (typeof swScope !== 'string' || swScope.length === 0) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                if (vapidKey === null || vapidKey.length !== UNCOMPRESSED_PUBLIC_KEY_SIZE) {
                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
                }
                details = {
                    swScope: swScope,
                    vapidKey: vapidKey
                };
                return [2 /*return*/, this.put(details)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM VAPID key for a SW scope.
     * Resolves once the scope/vapid details have been deleted and returns the
     * deleted vapid key.
     */
    VapidDetailsModel.prototype.deleteVapidDetails = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var vapidKey;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVapidFromSWScope(swScope)];
                    case 1:
                        vapidKey = _a.sent();
                        if (!vapidKey) {
                            throw errorFactory.create(ERROR_CODES.DELETE_SCOPE_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.delete(swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, vapidKey];
                }
            });
        });
    };
    return VapidDetailsModel;
}(DBInterface));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SENDER_ID_OPTION_NAME = 'messagingSenderId';
// Database cache should be invalidated once a week.
var TOKEN_EXPIRATION_MILLIS = 7 * 24 * 60 * 60 * 1000; // 7 days
var ControllerInterface = /** @class */ (function () {
    /**
     * An interface of the Messaging Service API
     */
    function ControllerInterface(app) {
        var _this = this;
        if (!app.options[SENDER_ID_OPTION_NAME] ||
            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
        }
        this.messagingSenderId = app.options[SENDER_ID_OPTION_NAME];
        this.tokenDetailsModel = new TokenDetailsModel();
        this.vapidDetailsModel = new VapidDetailsModel();
        this.iidModel = new IIDModel();
        this.app = app;
        this.INTERNAL = {
            delete: function () { return _this.delete(); }
        };
    }
    /**
     * @export
     */
    ControllerInterface.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var currentPermission, swReg, publicVapidKey, pushSubscription, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentPermission = this.getNotificationPermission_();
                        if (currentPermission !== 'granted') {
                            if (currentPermission === 'denied') {
                                return [2 /*return*/, Promise.reject(errorFactory.create(ERROR_CODES.NOTIFICATIONS_BLOCKED))];
                            }
                            // We must wait for permission to be granted
                            return [2 /*return*/, Promise.resolve(null)];
                        }
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        return [4 /*yield*/, this.getPublicVapidKey_()];
                    case 2:
                        publicVapidKey = _a.sent();
                        return [4 /*yield*/, this.getPushSubscription(swReg, publicVapidKey)];
                    case 3:
                        pushSubscription = _a.sent();
                        return [4 /*yield*/, this.tokenDetailsModel.getTokenDetailsFromSWScope(swReg.scope)];
                    case 4:
                        tokenDetails = _a.sent();
                        if (tokenDetails) {
                            return [2 /*return*/, this.manageExistingToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                        }
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    /**
     * manageExistingToken is triggered if there's an existing FCM token in the
     * database and it can take 3 different actions:
     * 1) Retrieve the existing FCM token from the database.
     * 2) If VAPID details have changed: Delete the existing token and create a
     * new one with the new VAPID key.
     * 3) If the database cache is invalidated: Send a request to FCM to update
     * the token, and to check if the token is still valid on FCM-side.
     */
    ControllerInterface.prototype.manageExistingToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var isTokenValid, now;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isTokenValid = isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails);
                        if (isTokenValid) {
                            now = Date.now();
                            if (now < tokenDetails.createTime + TOKEN_EXPIRATION_MILLIS) {
                                return [2 /*return*/, tokenDetails.fcmToken];
                            }
                            else {
                                return [2 /*return*/, this.updateToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                            }
                        }
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        return [4 /*yield*/, this.deleteTokenFromDB(tokenDetails.fcmToken)];
                    case 1:
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        _a.sent();
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    ControllerInterface.prototype.updateToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var updatedToken, allDetails, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 6]);
                        return [4 /*yield*/, this.iidModel.updateToken(this.messagingSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet, pushSubscription, publicVapidKey)];
                    case 1:
                        updatedToken = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: updatedToken,
                            fcmPushSet: tokenDetails.fcmPushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, updatedToken];
                    case 4:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 5:
                        _a.sent();
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ControllerInterface.prototype.getNewToken = function (swReg, pushSubscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var tokenDetails, allDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.iidModel.getToken(this.messagingSenderId, pushSubscription, publicVapidKey)];
                    case 1:
                        tokenDetails = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: tokenDetails.token,
                            fcmPushSet: tokenDetails.pushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, tokenDetails.token];
                }
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after,
     * unsubscribes the token from FCM  and then unregisters the push
     * subscription if it exists. It returns a promise that indicates
     * whether or not the unsubscribe request was processed successfully.
     * @export
     */
    ControllerInterface.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var registration, pushSubscription;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Delete the token details from the database.
                    return [4 /*yield*/, this.deleteTokenFromDB(token)];
                    case 1:
                        // Delete the token details from the database.
                        _a.sent();
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        registration = _a.sent();
                        if (!registration) return [3 /*break*/, 4];
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 3:
                        pushSubscription = _a.sent();
                        if (pushSubscription) {
                            return [2 /*return*/, pushSubscription.unsubscribe()];
                        }
                        _a.label = 4;
                    case 4: 
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * This method will delete the token from the client database, and make a
     * call to FCM to remove it from the server DB. Does not temper with the
     * push subscription.
     */
    ControllerInterface.prototype.deleteTokenFromDB = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenDetailsModel.deleteToken(token)];
                    case 1:
                        details = _a.sent();
                        return [4 /*yield*/, this.iidModel.deleteToken(details.fcmSenderId, details.fcmToken, details.fcmPushSet)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a PushSubscription for the current user.
     */
    ControllerInterface.prototype.getPushSubscription = function (swRegistration, publicVapidKey) {
        return swRegistration.pushManager.getSubscription().then(function (subscription) {
            if (subscription) {
                return subscription;
            }
            return swRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: publicVapidKey
            });
        });
    };
    //
    // The following methods should only be available in the window.
    //
    ControllerInterface.prototype.requestPermission = function () {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    ControllerInterface.prototype.useServiceWorker = function (registration) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    ControllerInterface.prototype.usePublicVapidKey = function (b64PublicKey) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    ControllerInterface.prototype.onMessage = function (nextOrObserver, error, completed) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    ControllerInterface.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    //
    // The following methods are used by the service worker only.
    //
    ControllerInterface.prototype.setBackgroundMessageHandler = function (callback) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_SW);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    ControllerInterface.prototype.delete = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.tokenDetailsModel.closeDatabase(),
                            this.vapidDetailsModel.closeDatabase()
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current Notification Permission state.
     */
    ControllerInterface.prototype.getNotificationPermission_ = function () {
        // TODO: Remove the cast when this issue is fixed:
        // https://github.com/Microsoft/TypeScript/issues/14701
        // tslint:disable-next-line no-any
        return Notification.permission;
    };
    ControllerInterface.prototype.getTokenDetailsModel = function () {
        return this.tokenDetailsModel;
    };
    ControllerInterface.prototype.getVapidDetailsModel = function () {
        return this.vapidDetailsModel;
    };
    // Visible for testing
    // TODO: make protected
    ControllerInterface.prototype.getIIDModel = function () {
        return this.iidModel;
    };
    return ControllerInterface;
}());
/**
 * Checks if the tokenDetails match the details provided in the clients.
 */
function isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails) {
    if (!isArrayBufferEqual(publicVapidKey.buffer, tokenDetails.vapidKey.buffer)) {
        return false;
    }
    var isEndpointEqual = pushSubscription.endpoint === tokenDetails.endpoint;
    var isAuthEqual = isArrayBufferEqual(pushSubscription.getKey('auth'), tokenDetails.auth);
    var isP256dhEqual = isArrayBufferEqual(pushSubscription.getKey('p256dh'), tokenDetails.p256dh);
    return isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FCM_MSG = 'FCM_MSG';
var SWController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(SWController, _super);
    function SWController(app) {
        var _this = _super.call(this, app) || this;
        _this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            _this.onPush(e);
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            _this.onSubChange(e);
        });
        self.addEventListener('notificationclick', function (e) {
            _this.onNotificationClick(e);
        });
        return _this;
    }
    // Visible for testing
    // TODO: Make private
    SWController.prototype.onPush = function (event) {
        event.waitUntil(this.onPush_(event));
    };
    // Visible for testing
    // TODO: Make private
    SWController.prototype.onSubChange = function (event) {
        event.waitUntil(this.onSubChange_(event));
    };
    // Visible for testing
    // TODO: Make private
    SWController.prototype.onNotificationClick = function (event) {
        event.waitUntil(this.onNotificationClick_(event));
    };
    /**
     * A handler for push events that shows notifications based on the content of
     * the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The
     * value of the `notification` property will be used as the NotificationOptions
     * object passed to showNotification. Additionally, the `title` property of the
     * notification object will be used as the title.
     *
     * If there is no notification data in the payload then no notification will be
     * shown.
     */
    SWController.prototype.onPush_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var msgPayload, hasVisibleClients, notificationDetails, notificationTitle, reg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.data) {
                            return [2 /*return*/];
                        }
                        try {
                            msgPayload = event.data.json();
                        }
                        catch (err) {
                            // Not JSON so not an FCM message
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.hasVisibleClients_()];
                    case 1:
                        hasVisibleClients = _a.sent();
                        if (hasVisibleClients) {
                            // Do not need to show a notification.
                            if (msgPayload.notification || this.bgMessageHandler) {
                                // Send to page
                                return [2 /*return*/, this.sendMessageToWindowClients_(msgPayload)];
                            }
                            return [2 /*return*/];
                        }
                        notificationDetails = this.getNotificationData_(msgPayload);
                        if (!notificationDetails) return [3 /*break*/, 3];
                        notificationTitle = notificationDetails.title || '';
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        reg = _a.sent();
                        return [2 /*return*/, reg.showNotification(notificationTitle, notificationDetails)];
                    case 3:
                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bgMessageHandler(msgPayload)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SWController.prototype.onSubChange_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var registration, err_1, err_2, tokenDetailsModel, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        registration = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.UNABLE_TO_RESUBSCRIBE, {
                            message: err_1
                        });
                    case 3:
                        _a.trys.push([3, 5, , 8]);
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        err_2 = _a.sent();
                        tokenDetailsModel = this.getTokenDetailsModel();
                        return [4 /*yield*/, tokenDetailsModel.getTokenDetailsFromSWScope(registration.scope)];
                    case 6:
                        tokenDetails = _a.sent();
                        if (!tokenDetails) {
                            // This should rarely occure, but could if indexedDB
                            // is corrupted or wiped
                            throw err_2;
                        }
                        // Attempt to delete the token if we know it's bad
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 7:
                        // Attempt to delete the token if we know it's bad
                        _a.sent();
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SWController.prototype.onNotificationClick_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var msgPayload, clickAction, windowClient, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.notification ||
                            !event.notification.data ||
                            !event.notification.data[FCM_MSG]) {
                            // Not an FCM notification, do nothing.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        msgPayload = event.notification.data[FCM_MSG];
                        if (!msgPayload.notification) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        clickAction = msgPayload.notification.click_action;
                        if (!clickAction) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getWindowClient_(clickAction)];
                    case 1:
                        windowClient = _a.sent();
                        if (!!windowClient) return [3 /*break*/, 3];
                        return [4 /*yield*/, self.clients.openWindow(clickAction)];
                    case 2:
                        // Unable to find window client so need to open one.
                        windowClient = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, windowClient.focus()];
                    case 4:
                        windowClient = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!windowClient) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        // Delete notification data from payload before sending to the page.
                        delete msgPayload.notification;
                        internalMsg = createNewMsg(MessageType.NOTIFICATION_CLICKED, msgPayload);
                        // Attempt to send a message to the client to handle the data
                        // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
                        return [2 /*return*/, this.attemptToMessageClient_(windowClient, internalMsg)];
                }
            });
        });
    };
    // Visible for testing
    // TODO: Make private
    SWController.prototype.getNotificationData_ = function (msgPayload) {
        if (!msgPayload) {
            return;
        }
        if (typeof msgPayload.notification !== 'object') {
            return;
        }
        var notificationInformation = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation.data = (_a = {}, _a[FCM_MSG] = msgPayload, _a);
        return notificationInformation;
        var _a;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received
     * and a notification must be shown. The callback will be given the data from
     * the push message.
     */
    SWController.prototype.setBackgroundMessageHandler = function (callback) {
        if (!callback || typeof callback !== 'function') {
            throw errorFactory.create(ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED);
        }
        this.bgMessageHandler = callback;
    };
    /**
     * @param url The URL to look for when focusing a client.
     * @return Returns an existing window client or a newly opened WindowClient.
     */
    // Visible for testing
    // TODO: Make private
    SWController.prototype.getWindowClient_ = function (url) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var parsedURL, clientList, suitableClient, i, parsedClientUrl;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedURL = new URL(url, self.location.href).href;
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        suitableClient = null;
                        for (i = 0; i < clientList.length; i++) {
                            parsedClientUrl = new URL(clientList[i].url, self.location.href)
                                .href;
                            if (parsedClientUrl === parsedURL) {
                                suitableClient = clientList[i];
                                break;
                            }
                        }
                        return [2 /*return*/, suitableClient];
                }
            });
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @param client The WindowClient to send the message to.
     * @param message The message to send to the client.
     * @returns Returns a promise that resolves after sending the message. This
     * does not guarantee that the message was successfully received.
     */
    // Visible for testing
    // TODO: Make private
    SWController.prototype.attemptToMessageClient_ = function (client, message) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                // NOTE: This returns a promise in case this API is abstracted later on to
                // do additional work
                if (!client) {
                    throw errorFactory.create(ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG);
                }
                client.postMessage(message);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns If there is currently a visible WindowClient, this method will
     * resolve to true, otherwise false.
     */
    // Visible for testing
    // TODO: Make private
    SWController.prototype.hasVisibleClients_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var clientList;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        return [2 /*return*/, clientList.some(function (client) { return client.visibilityState === 'visible'; })];
                }
            });
        });
    };
    /**
     * @param msgPayload The data from the push event that should be sent to all
     * available pages.
     * @returns Returns a promise that resolves once the message has been sent to
     * all WindowClients.
     */
    // Visible for testing
    // TODO: Make private
    SWController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            var clientList, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        internalMsg = createNewMsg(MessageType.PUSH_MSG_RECEIVED, msgPayload);
                        return [4 /*yield*/, Promise.all(clientList.map(function (client) {
                                return _this.attemptToMessageClient_(client, internalMsg);
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @return he service worker registration to be used for the push service.
     */
    SWController.prototype.getSWRegistration_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                return [2 /*return*/, self.registration];
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the
     * public VAPID key provided by the developer.
     */
    SWController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var swReg, vapidKeyFromDatabase;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        if (!swReg) {
                            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
                        }
                        return [4 /*yield*/, this.getVapidDetailsModel().getVapidFromSWScope(swReg.scope)];
                    case 2:
                        vapidKeyFromDatabase = _a.sent();
                        if (vapidKeyFromDatabase == null) {
                            return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
                        }
                        return [2 /*return*/, vapidKeyFromDatabase];
                }
            });
        });
    };
    return SWController;
}(ControllerInterface));
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function createNewMsg(msgType, msgData) {
    return _a = {}, _a[MessageParameter.TYPE_OF_MSG] = msgType, _a[MessageParameter.DATA] = msgData, _a;
    var _a;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        _this.registrationToUse = null;
        _this.publicVapidKeyToUse = null;
        _this.manifestCheckPromise = null;
        _this.messageObserver = null;
        // @ts-ignore: Unused variable error, this is not implemented yet.
        _this.tokenRefreshObserver = null;
        _this.onMessageInternal = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"])(function (observer) {
            _this.messageObserver = observer;
        });
        _this.onTokenRefreshInternal = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"])(function (observer) {
            _this.tokenRefreshObserver = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * This method returns an FCM token if it can be generated.
     * The return promise will reject if the browser doesn't support
     * FCM, if permission is denied for notifications or it's not
     * possible to generate a token.
     *
     * @return Returns a promise that resolves to an FCM token or null if
     * permission isn't granted.
     */
    WindowController.prototype.getToken = function () {
        var _this = this;
        // Check that the required API's are available
        if (!this.isSupported_()) {
            return Promise.reject(errorFactory.create(ERROR_CODES.UNSUPPORTED_BROWSER));
        }
        return this.manifestCheck_().then(function () {
            return _super.prototype.getToken.call(_this);
        });
    };
    /**
     * The method checks that a manifest is defined and has the correct GCM
     * sender ID.
     * @return Returns a promise that resolves if the manifest matches
     * our required sender ID
     */
    // Visible for testing
    // TODO: make private
    WindowController.prototype.manifestCheck_ = function () {
        if (this.manifestCheckPromise) {
            return this.manifestCheckPromise;
        }
        var manifestTag = document.querySelector('link[rel="manifest"]');
        if (!manifestTag) {
            this.manifestCheckPromise = Promise.resolve();
        }
        else {
            this.manifestCheckPromise = fetch(manifestTag.href)
                .then(function (response) {
                return response.json();
            })
                .catch(function () {
                // If the download or parsing fails allow check.
                // We only want to error if we KNOW that the gcm_sender_id is incorrect.
            })
                .then(function (manifestContent) {
                if (!manifestContent) {
                    return;
                }
                if (!manifestContent['gcm_sender_id']) {
                    return;
                }
                if (manifestContent['gcm_sender_id'] !== '103953800507') {
                    throw errorFactory.create(ERROR_CODES.INCORRECT_GCM_SENDER_ID);
                }
            });
        }
        return this.manifestCheckPromise;
    };
    /**
     * Request permission if it is not currently granted
     *
     * @return Resolves if the permission was granted, otherwise rejects
     */
    WindowController.prototype.requestPermission = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (
                // TODO: Remove the cast when this issue is fixed:
                // https://github.com/Microsoft/TypeScript/issues/14701
                // tslint:disable-next-line no-any
                Notification.permission === 'granted') {
                    return [2 /*return*/];
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var managePermissionResult = function (result) {
                            if (result === 'granted') {
                                return resolve();
                            }
                            else if (result === 'denied') {
                                return reject(errorFactory.create(ERROR_CODES.PERMISSION_BLOCKED));
                            }
                            else {
                                return reject(errorFactory.create(ERROR_CODES.PERMISSION_DEFAULT));
                            }
                        };
                        // The Notification.requestPermission API was changed to
                        // return a promise so now have to handle both in case
                        // browsers stop support callbacks for promised version
                        var permissionPromise = Notification.requestPermission(managePermissionResult);
                        if (permissionPromise) {
                            // Prefer the promise version as it's the future API.
                            permissionPromise.then(managePermissionResult);
                        }
                    })];
            });
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     *
     * @param registration The service worker registration that should be used to
     * receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
        }
        if (this.registrationToUse != null) {
            throw errorFactory.create(ERROR_CODES.USE_SW_BEFORE_GET_TOKEN);
        }
        this.registrationToUse = registration;
    };
    /**
     * This method allows a developer to override the default vapid key
     * and instead use a custom VAPID public key.
     *
     * @param publicKey A URL safe base64 encoded string.
     */
    WindowController.prototype.usePublicVapidKey = function (publicKey) {
        if (typeof publicKey !== 'string') {
            throw errorFactory.create(ERROR_CODES.INVALID_PUBLIC_VAPID_KEY);
        }
        if (this.publicVapidKeyToUse != null) {
            throw errorFactory.create(ERROR_CODES.USE_PUBLIC_KEY_BEFORE_GET_TOKEN);
        }
        var parsedKey = base64ToArrayBuffer(publicKey);
        if (parsedKey.length !== 65) {
            throw errorFactory.create(ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED);
        }
        this.publicVapidKeyToUse = parsedKey;
    };
    /**
     * @export
     * @param nextOrObserver An observer object or a function triggered on
     * message.
     * @param error A function triggered on message error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onMessageInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onMessageInternal(nextOrObserver);
        }
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on token
     * refresh.
     * @param error A function triggered on token refresh error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onTokenRefreshInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onTokenRefreshInternal(nextOrObserver);
        }
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @param registration Registration to wait for service worker to become active
     * @return Wait for service worker registration to become active
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(errorFactory.create(ERROR_CODES.NO_SW_IN_REG));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
                return;
            }
            var stateChangeListener = function () {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                }
                else if (serviceWorker.state === 'redundant') {
                    reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
                }
                else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will register the default service worker and return the registration
     * @return The service worker registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse) {
            return this.waitForRegistrationToActivate_(this.registrationToUse);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse is no longer undefined
        this.registrationToUse = null;
        return navigator.serviceWorker
            .register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        })
            .catch(function (err) {
            throw errorFactory.create(ERROR_CODES.FAILED_DEFAULT_REGISTRATION, {
                browserErrorMessage: err.message
            });
        })
            .then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service work to not
                // install
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the public VAPID key
     * provided by the developer.
     */
    WindowController.prototype.getPublicVapidKey_ = function () {
        if (this.publicVapidKeyToUse) {
            return Promise.resolve(this.publicVapidKeyToUse);
        }
        return Promise.resolve(DEFAULT_PUBLIC_VAPID_KEY);
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        if (!('serviceWorker' in navigator)) {
            return;
        }
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data || !event.data[MessageParameter.TYPE_OF_MSG]) {
                // Not a message from FCM
                return;
            }
            var workerPageMessage = event.data;
            switch (workerPageMessage[MessageParameter.TYPE_OF_MSG]) {
                case MessageType.PUSH_MSG_RECEIVED:
                case MessageType.NOTIFICATION_CLICKED:
                    var pushMessage = workerPageMessage[MessageParameter.DATA];
                    if (_this.messageObserver) {
                        _this.messageObserver.next(pushMessage);
                    }
                    break;
                default:
                    // Noop.
                    break;
            }
        }, false);
    };
    /**
     * Checks to see if the required API's are valid or not.
     * @return Returns true if the desired APIs are available.
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.isSupported_ = function () {
        return ('serviceWorker' in navigator &&
            'PushManager' in window &&
            'Notification' in window &&
            'fetch' in window &&
            ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
            PushSubscription.prototype.hasOwnProperty('getKey'));
    };
    return WindowController;
}(ControllerInterface));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function (app) {
        if (self && 'ServiceWorkerGlobalScope' in self) {
            return new SWController(app);
        }
        // Assume we are in the window context.
        return new WindowController(app);
    };
    var namespaceExports = {
        // no-inline
        Messaging: WindowController
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(__WEBPACK_IMPORTED_MODULE_2__firebase_app__["default"]);




/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1174);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStorage", function() { return registerStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(184);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Constants used in the Firebase Storage library.
 */
/**
 * Domain and scheme for API calls.
 */
var domainBase = 'https://firebasestorage.googleapis.com';
/**
 * Domain and scheme for object downloads.
 */
var downloadBase = 'https://firebasestorage.googleapis.com';
/**
 * Base URL for non-upload calls to the API.
 */
var apiBaseUrl = '/v0';
/**
 * Base URL for upload calls to the API.
 */
var apiUploadBaseUrl = '/v0';
var configOption = 'storageBucket';
/**
 * 2 minutes
 */
var defaultMaxOperationRetryTime = 2 * 60 * 1000;
/**
 * 10 minutes
 */
var defaultMaxUploadRetryTime = 10 * 60 * 100;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */
var minSafeInteger = -9007199254740991;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseStorageError = /** @class */ (function () {
    function FirebaseStorageError(code, message) {
        this.code_ = prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function () {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function (code) {
        return prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function () {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function () {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function () {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function () {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function () {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}());
var Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    var message = 'An unknown error occurred, please check the error payload for ' +
        'server response.';
    return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
        bucket +
        "' exceeded, please view quota on " +
        'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    var message = 'User is not authenticated, please authenticate using Firebase ' +
        'Authentication and try again.';
    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function canceled() {
    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
}
function invalidUrl(url) {
    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function cannotSliceBlob() {
    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function invalidArgument(index, fnName, message) {
    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    }
    else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
        fnName +
        '`: Expected ' +
        countPart +
        ' ' +
        plural +
        ', received ' +
        real +
        '.');
}
function appDeleted() {
    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */
function invalidRootOperation(name) {
    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
        name +
        "' cannot be performed on a root reference, create a non-root " +
        "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */
function invalidFormat(format, message) {
    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */
function internalError(message) {
    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
};
function formatValidator(stringFormat) {
    switch (stringFormat) {
        case StringFormat.RAW:
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
        case StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' +
                StringFormat.RAW +
                ', ' +
                StringFormat.BASE64 +
                ', ' +
                StringFormat.BASE64URL +
                ', ' +
                StringFormat.DATA_URL +
                '].';
    }
}
/**
 * @struct
 */
var StringData = /** @class */ (function () {
    function StringData(data, opt_contentType) {
        this.data = data;
        this.contentType = opt_contentType || null;
    }
    return StringData;
}());
function dataFromString(format, string) {
    switch (format) {
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(string));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, string));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
    }
    // assert(false);
    throw unknown();
}
function utf8Bytes_(string) {
    var b = [];
    for (var i = 0; i < string.length; i++) {
        var c = string.charCodeAt(i);
        if (c <= 127) {
            b.push(c);
        }
        else {
            if (c <= 2047) {
                b.push(192 | (c >> 6), 128 | (c & 63));
            }
            else {
                if ((c & 64512) == 55296) {
                    // The start of a surrogate pair.
                    var valid = i < string.length - 1 &&
                        (string.charCodeAt(i + 1) & 64512) == 56320;
                    if (!valid) {
                        // The second surrogate wasn't there.
                        b.push(239, 191, 189);
                    }
                    else {
                        var hi = c;
                        var lo = string.charCodeAt(++i);
                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
                else {
                    if ((c & 64512) == 56320) {
                        // Invalid low surrogate.
                        b.push(239, 191, 189);
                    }
                    else {
                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
            }
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(string) {
    var decoded;
    try {
        decoded = decodeURIComponent(string);
    }
    catch (e) {
        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, string) {
    switch (format) {
        case StringFormat.BASE64: {
            var hasMinus = string.indexOf('-') !== -1;
            var hasUnder = string.indexOf('_') !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? '-' : '_';
                throw invalidFormat(format, "Invalid character '" +
                    invalidChar +
                    "' found: is it base64url encoded?");
            }
            break;
        }
        case StringFormat.BASE64URL: {
            var hasPlus = string.indexOf('+') !== -1;
            var hasSlash = string.indexOf('/') !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? '+' : '/';
                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            string = string.replace(/-/g, '+').replace(/_/g, '/');
            break;
        }
    }
    var bytes;
    try {
        bytes = atob(string);
    }
    catch (e) {
        throw invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) {
        array[i] = bytes.charCodeAt(i);
    }
    return array;
}
/**
 * @struct
 */
var DataURLParts = /** @class */ (function () {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) {
            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        }
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64
                ? middle.substring(0, middle.length - ';base64'.length)
                : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}());
function dataURLBytes_(string) {
    var parts = new DataURLParts(string);
    if (parts.base64) {
        return base64Bytes_(StringFormat.BASE64, parts.rest);
    }
    else {
        return percentEncodedBytes_(parts.rest);
    }
}
function dataURLContentType_(string) {
    var parts = new DataURLParts(string);
    return parts.contentType;
}
function endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) {
        return false;
    }
    return s.substring(s.length - end.length) === end;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */
    STATE_CHANGED: 'state_changed'
};
var InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var TaskState = {
    /** The task is currently transferring data. */
    RUNNING: 'running',
    /** The task was paused by the user. */
    PAUSED: 'paused',
    /** The task completed successfully. */
    SUCCESS: 'success',
    /** The task was canceled. */
    CANCELED: 'canceled',
    /** The task failed with an error. */
    ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch (state) {
        case InternalTaskState.RUNNING:
        case InternalTaskState.PAUSING:
        case InternalTaskState.CANCELING:
            return TaskState.RUNNING;
        case InternalTaskState.PAUSED:
            return TaskState.PAUSED;
        case InternalTaskState.SUCCESS:
            return TaskState.SUCCESS;
        case InternalTaskState.CANCELED:
            return TaskState.CANCELED;
        case InternalTaskState.ERROR:
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains methods for working with objects.
 */
function contains(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function forEach(obj, f) {
    for (var key in obj) {
        if (contains(obj, key)) {
            f(key, obj[key]);
        }
    }
}
function clone(obj) {
    if (obj == null) {
        return {};
    }
    var c = {};
    forEach(obj, function (key, val) {
        c[key] = val;
    });
    return c;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Implements the promise abstraction interface for external
 * (public SDK) packaging, which just passes through to the firebase-app impl.
 */
/**
 * @template T
 * @param {function((function(T): void),
 *                  (function(!Error): void))} resolver
 */
function make(resolver) {
    return new Promise(resolver);
}
/**
 * @template T
 */
function resolve(value) {
    return Promise.resolve(value);
}
function reject(error) {
    return Promise.reject(error);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @return False if the object is undefined or null, true otherwise.
 */
function isDef(p) {
    return p != null;
}
function isJustDef(p) {
    return p !== void 0;
}
function isFunction(p) {
    return typeof p === 'function';
}
function isObject(p) {
    return typeof p === 'object';
}
function isNonNullObject(p) {
    return isObject(p) && p !== null;
}
function isNonArrayObject(p) {
    return isObject(p) && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */
var NetworkXhrIo = /** @class */ (function () {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = ErrorCode.NO_ERROR;
        this.sendPromise_ = make(function (resolve$$1, reject$$1) {
            _this.xhr_.addEventListener('abort', function (event) {
                _this.errorCode_ = ErrorCode.ABORT;
                resolve$$1(_this);
            });
            _this.xhr_.addEventListener('error', function (event) {
                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
                resolve$$1(_this);
            });
            _this.xhr_.addEventListener('load', function (event) {
                resolve$$1(_this);
            });
        });
    }
    /**
     * @override
     */
    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
        var _this = this;
        if (this.sent_) {
            throw internalError('cannot .send() more than once');
        }
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (isDef(opt_headers)) {
            var headers = opt_headers;
            forEach(headers, function (key, val) {
                _this.xhr_.setRequestHeader(key, val.toString());
            });
        }
        if (isDef(opt_body)) {
            this.xhr_.send(opt_body);
        }
        else {
            this.xhr_.send();
        }
        return this.sendPromise_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getErrorCode = function () {
        if (!this.sent_) {
            throw internalError('cannot .getErrorCode() before sending');
        }
        return this.errorCode_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getStatus = function () {
        if (!this.sent_) {
            throw internalError('cannot .getStatus() before sending');
        }
        try {
            return this.xhr_.status;
        }
        catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseText = function () {
        if (!this.sent_) {
            throw internalError('cannot .getResponseText() before sending');
        }
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */
    NetworkXhrIo.prototype.abort = function () {
        this.xhr_.abort();
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseHeader = function (header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.addEventListener('progress', listener);
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.removeEventListener('progress', listener);
        }
    };
    return NetworkXhrIo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = /** @class */ (function () {
    function XhrIoPool() {
    }
    XhrIoPool.prototype.createXhrIo = function () {
        return new NetworkXhrIo();
    };
    return XhrIoPool;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
function jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    }
    catch (e) {
        return null;
    }
    if (isNonArrayObject(obj)) {
        return obj;
    }
    else {
        return null;
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Location = /** @class */ (function () {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function () {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function (bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        }
        catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') {
            return bucketLocation;
        }
        else {
            throw invalidDefaultBucket(bucketString);
        }
    };
    Location.makeFromUrl = function (url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') {
                loc.path_ = loc.path_.slice(0, -1);
            }
        }
        var gsPath = '(/(.*))?$';
        var path = '(/([^?#]*).*)?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = { bucket: 1, path: 3 };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' +
            version +
            '/b/' +
            bucketDomain +
            '/o' +
            path, 'i');
        var httpIndices = { bucket: 1, path: 3 };
        var groups = [
            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
        ];
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) {
                    pathValue = '';
                }
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) {
            throw invalidUrl(url);
        }
        return location;
    };
    return Location;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains helper methods for manipulating paths.
 */
/**
 * @return Null if the path is already at the root.
 */
function parent(path) {
    if (path.length == 0) {
        return null;
    }
    var index = path.lastIndexOf('/');
    if (index === -1) {
        return '';
    }
    var newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    var canonicalChildPath = childPath
        .split('/')
        .filter(function (component) {
        return component.length > 0;
    })
        .join('/');
    if (path.length === 0) {
        return canonicalChildPath;
    }
    else {
        return path + '/' + canonicalChildPath;
    }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */
function lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) {
        return path;
    }
    else {
        return path.slice(index + 1);
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeNormalUrl(urlPart) {
    return domainBase + apiBaseUrl + urlPart;
}
function makeDownloadUrl(urlPart) {
    return downloadBase + apiBaseUrl + urlPart;
}
function makeUploadUrl(urlPart) {
    return domainBase + apiUploadBaseUrl + urlPart;
}
function makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    forEach(params, function (key, val) {
        var nextPart = encode(key) + '=' + encode(val);
        queryPart = queryPart + nextPart + '&';
    });
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */
var Mapping = /** @class */ (function () {
    function Mapping(server, opt_local, opt_writable, opt_xform) {
        this.server = server;
        this.local = opt_local || server;
        this.writable = !!opt_writable;
        this.xform = opt_xform || noXform_;
    }
    return Mapping;
}());
var mappings_ = null;
function xformPath(fullPath) {
    var valid = isString(fullPath);
    if (!valid || fullPath.length < 2) {
        return fullPath;
    }
    else {
        fullPath = fullPath;
        return lastComponent(fullPath);
    }
}
function getMappings() {
    if (mappings_) {
        return mappings_;
    }
    var mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(metadata, fullPath) {
        return xformPath(fullPath);
    }
    var nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */
    function xformSize(metadata, size) {
        if (isDef(size)) {
            return +size;
        }
        else {
            return size;
        }
    }
    var sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    /**
     * Transforms a comma-separated string of tokens into a list of download
     * URLs.
     */
    function xformTokens(metadata, tokens) {
        var valid = isString(tokens) && tokens.length > 0;
        if (!valid) {
            // This can happen if objects are uploaded through GCS and retrieved
            // through list, so we don't want to throw an Error.
            return [];
        }
        var encode = encodeURIComponent;
        var tokensList = tokens.split(',');
        var urls = tokensList.map(function (token) {
            var bucket = metadata['bucket'];
            var path = metadata['fullPath'];
            var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
            var base = makeDownloadUrl(urlPart);
            var queryString = makeQueryString({
                alt: 'media',
                token: token
            });
            return base + queryString;
        });
        return urls;
    }
    mappings.push(new Mapping('downloadTokens', 'downloadURLs', false, xformTokens));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', { get: generateRef });
}
function fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, authWrapper);
    return metadata;
}
function fromResourceString(authWrapper, resourceString, mappings) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromResource(authWrapper, resource, mappings);
}
function toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        if (mapping.writable) {
            resource[mapping.server] = metadata[mapping.local];
        }
    }
    return JSON.stringify(resource);
}
function metadataValidator(p) {
    var validType = p && isObject(p);
    if (!validType) {
        throw 'Expected Metadata object.';
    }
    for (var key in p) {
        var val = p[key];
        if (key === 'customMetadata') {
            if (!isObject(val)) {
                throw 'Expected object for \'customMetadata\' mapping.';
            }
        }
        else {
            if (isNonNullObject(val)) {
                throw "Mapping for '" + key + "' cannot be an object.";
            }
        }
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */
function validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for (var i = 0; i < specs.length; i++) {
        if (specs[i].optional) {
            minArgs = i;
            break;
        }
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) {
        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    }
    for (var i = 0; i < passed.length; i++) {
        try {
            specs[i].validator(passed[i]);
        }
        catch (e) {
            if (e instanceof Error) {
                throw invalidArgument(i, name, e.message);
            }
            else {
                throw invalidArgument(i, name, e);
            }
        }
    }
}
/**
 * @struct
 */
var ArgSpec = /** @class */ (function () {
    function ArgSpec(validator, opt_optional) {
        var self = this;
        this.validator = function (p) {
            if (self.optional && !isJustDef(p)) {
                return;
            }
            validator(p);
        };
        this.optional = !!opt_optional;
    }
    return ArgSpec;
}());
function and_(v1, v2) {
    return function (p) {
        v1(p);
        v2(p);
    };
}
function stringSpec(opt_validator, opt_optional) {
    function stringValidator(p) {
        if (!isString(p)) {
            throw 'Expected string.';
        }
    }
    var validator;
    if (opt_validator) {
        validator = and_(stringValidator, opt_validator);
    }
    else {
        validator = stringValidator;
    }
    return new ArgSpec(validator, opt_optional);
}
function uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array ||
            p instanceof ArrayBuffer ||
            (isNativeBlobDefined() && p instanceof Blob);
        if (!valid) {
            throw 'Expected Blob or File.';
        }
    }
    return new ArgSpec(validator);
}
function metadataSpec(opt_optional) {
    return new ArgSpec(metadataValidator, opt_optional);
}
function nonNegativeNumberSpec() {
    function validator(p) {
        var valid = isNumber(p) && p >= 0;
        if (!valid) {
            throw 'Expected a number 0 or greater.';
        }
    }
    return new ArgSpec(validator);
}
function looseObjectSpec(opt_validator, opt_optional) {
    function validator(p) {
        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
        if (!isLooseObject) {
            throw 'Expected an Object.';
        }
        if (opt_validator !== undefined && opt_validator !== null) {
            opt_validator(p);
        }
    }
    return new ArgSpec(validator, opt_optional);
}
function nullFunctionSpec(opt_optional) {
    function validator(p) {
        var valid = p === null || isFunction(p);
        if (!valid) {
            throw 'Expected a Function.';
        }
    }
    return new ArgSpec(validator, opt_optional);
}

function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') {
        return BlobBuilder;
    }
    else if (typeof WebKitBlobBuilder !== 'undefined') {
        return WebKitBlobBuilder;
    }
    else {
        return undefined;
    }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param var_args The values that will make up the resulting blob.
 * @return The blob.
 */
function getBlob() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var BlobBuilder = getBlobBuilder();
    if (BlobBuilder !== undefined) {
        var bb = new BlobBuilder();
        for (var i = 0; i < var_args.length; i++) {
            bb.append(var_args[i]);
        }
        return bb.getBlob();
    }
    else {
        if (isNativeBlobDefined()) {
            return new Blob(var_args);
        }
        else {
            throw Error("This browser doesn't seem to support creating Blobs");
        }
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) {
        return blob.webkitSlice(start, end);
    }
    else if (blob.mozSlice) {
        return blob.mozSlice(start, end);
    }
    else if (blob.slice) {
        return blob.slice(start, end);
    }
    return null;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */
var FbsBlob = /** @class */ (function () {
    function FbsBlob(data, opt_elideCopy) {
        var size = 0;
        var blobType = '';
        if (isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        }
        else if (data instanceof ArrayBuffer) {
            if (opt_elideCopy) {
                this.data_ = new Uint8Array(data);
            }
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        }
        else if (data instanceof Uint8Array) {
            if (opt_elideCopy) {
                this.data_ = data;
            }
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function () {
        return this.size_;
    };
    FbsBlob.prototype.type = function () {
        return this.type_;
    };
    FbsBlob.prototype.slice = function (startByte, endByte) {
        if (isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) {
                return null;
            }
            return new FbsBlob(sliced);
        }
        else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        if (isNativeBlobDefined()) {
            var blobby = var_args.map(function (val) {
                if (val instanceof FbsBlob) {
                    return val.data_;
                }
                else {
                    return val;
                }
            });
            return new FbsBlob(getBlob.apply(null, blobby));
        }
        else {
            var uint8Arrays = var_args.map(function (val) {
                if (isString(val)) {
                    return dataFromString(StringFormat.RAW, val).data;
                }
                else {
                    // Blobs don't exist, so this has to be a Uint8Array.
                    return val.data_;
                }
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function (array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function (array) {
                for (var i = 0; i < array.length; i++) {
                    merged_1[index_1++] = array[i];
                }
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function () {
        return this.data_;
    };
    return FbsBlob;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns true if the object is contained in the array (compared with ===).
 * @template T
 */
function contains$1(array, elem) {
    return array.indexOf(elem) !== -1;
}
/**
 * Returns a shallow copy of the array or array-like object (e.g. arguments).
 * @template T
 */
function clone$1(arraylike) {
    return Array.prototype.slice.call(arraylike);
}
/**
 * Removes the given element from the given array, if it is contained.
 * Directly modifies the passed-in array.
 * @template T
 */
function remove(array, elem) {
    var i = array.indexOf(elem);
    if (i !== -1) {
        array.splice(i, 1);
    }
}

var RequestInfo = /** @class */ (function () {
    function RequestInfo(url, method, 
    /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */
    handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */
        this.progressCallback = null;
        this.successCodes = [200];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */
function handlerCheck(cndn) {
    if (!cndn) {
        throw unknown();
    }
}
function metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            newErr = unauthenticated();
        }
        else {
            if (xhr.getStatus() === 402) {
                newErr = quotaExceeded(location.bucket);
            }
            else {
                if (xhr.getStatus() === 403) {
                    newErr = unauthorized(location.path);
                }
                else {
                    newErr = err;
                }
            }
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    var shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) {
            newErr = objectNotFound(location.path);
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'PATCH';
    var body = toResourceString(metadata, mappings);
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(xhr, text) { }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [200, 204];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return ((metadata && metadata['contentType']) ||
        (blob && blob.type()) ||
        'application/octet-stream');
}
function metadataForUpload_(location, blob, opt_metadata) {
    var metadata = clone(opt_metadata);
    metadata['fullPath'] = location.path;
    metadata['size'] = blob.size();
    if (!metadata['contentType']) {
        metadata['contentType'] = determineContentType_(null, blob);
    }
    return metadata;
}
function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for (var i = 0; i < 2; i++) {
            str =
                str +
                    Math.random()
                        .toString()
                        .slice(2);
        }
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var metadataString = toResourceString(metadata, mappings);
    var preBlobPart = '--' +
        boundary +
        '\r\n' +
        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
        metadataString +
        '\r\n--' +
        boundary +
        '\r\n' +
        'Content-Type: ' +
        metadata['contentType'] +
        '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) {
        throw cannotSliceBlob();
    }
    var urlParams = { name: metadata['fullPath'] };
    var url = makeUploadUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */
var ResumableUploadStatus = /** @class */ (function () {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}());
function checkResumeHeader_(xhr, opt_allowed) {
    var status;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    }
    catch (e) {
        handlerCheck(false);
    }
    var allowed = opt_allowed || ['active'];
    handlerCheck(contains$1(allowed, status));
    return status;
}
function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var urlParams = { name: metadata['fullPath'] };
    var url = makeUploadUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = toResourceString(metadata, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr, text) {
        checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        }
        catch (e) {
            handlerCheck(false);
        }
        handlerCheck(isString(url));
        return url;
    }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */
function getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = { 'X-Goog-Upload-Command': 'query' };
    function handler(xhr, text) {
        var status = checkResumeHeader_(xhr, ['active', 'final']);
        var sizeString;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        }
        catch (e) {
            handlerCheck(false);
        }
        var size = parseInt(sizeString, 10);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */
var resumableUploadChunkSize = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param opt_status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */
function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status = new ResumableUploadStatus(0, 0);
    if (opt_status) {
        status.current = opt_status.current;
        status.total = opt_status.total;
    }
    else {
        status.current = 0;
        status.total = blob.size();
    }
    if (blob.size() !== status.total) {
        throw serverFileWrongSize();
    }
    var bytesLeft = status.total - status.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) {
        bytesToUpload = Math.min(bytesToUpload, chunkSize);
    }
    var startByte = status.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) {
        throw cannotSliceBlob();
    }
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
        var newCurrent = status.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') {
            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
        }
        else {
            metadata = null;
        }
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = opt_progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Observer = /** @class */ (function () {
    function Observer(nextOrObserver, opt_error, opt_complete) {
        var asFunctions = isFunction(nextOrObserver) ||
            isDef(opt_error) ||
            isDef(opt_complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = opt_error || null;
            this.complete = opt_complete || null;
        }
        else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}());

var UploadTaskSnapshot = /** @class */ (function () {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    Object.defineProperty(UploadTaskSnapshot.prototype, "downloadURL", {
        get: function () {
            if (this.metadata !== null) {
                var urls = this.metadata['downloadURLs'];
                if (urls != null && urls[0] != null) {
                    return urls[0];
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    return UploadTaskSnapshot;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
function async(f) {
    return function () {
        var argsToForward = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsToForward[_i] = arguments[_i];
        }
        resolve(true).then(function () {
            f.apply(null, argsToForward);
        });
    };
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */
var UploadTask = /** @class */ (function () {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */
    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        if (metadata === void 0) { metadata = null; }
        var _this = this;
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = InternalTaskState.RUNNING;
        this.errorHandler_ = function (error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals(Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function (error) {
            _this.request_ = null;
            if (error.codeEquals(Code.CANCELED)) {
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.promise_ = make(function (resolve$$1, reject$$1) {
            _this.resolve_ = resolve$$1;
            _this.reject_ = reject$$1;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function () { });
    }
    UploadTask.prototype.makeProgressCallback_ = function () {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function (loaded, total) {
            _this.updateProgress_(sizeBefore + loaded);
        };
    };
    UploadTask.prototype.shouldDoResumable_ = function (blob) {
        return blob.size() > 256 * 1024;
    };
    UploadTask.prototype.start_ = function () {
        if (this.state_ !== InternalTaskState.RUNNING) {
            // This can happen if someone pauses us in a resume callback, for example.
            return;
        }
        if (this.request_ !== null) {
            return;
        }
        if (this.resumable_) {
            if (this.uploadUrl_ === null) {
                this.createResumable_();
            }
            else {
                if (this.needToFetchStatus_) {
                    this.fetchStatus_();
                }
                else {
                    if (this.needToFetchMetadata_) {
                        // Happens if we miss the metadata on upload completion.
                        this.fetchMetadata_();
                    }
                    else {
                        this.continueUpload_();
                    }
                }
            }
        }
        else {
            this.oneShotUpload_();
        }
    };
    UploadTask.prototype.resolveToken_ = function (callback) {
        var _this = this;
        this.authWrapper_.getAuthToken().then(function (authToken) {
            switch (_this.state_) {
                case InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case InternalTaskState.CANCELING:
                    _this.transition_(InternalTaskState.CANCELED);
                    break;
                case InternalTaskState.PAUSING:
                    _this.transition_(InternalTaskState.PAUSED);
                    break;
                default:
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function (url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function () {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function (status) {
                status = status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) {
                    _this.needToFetchMetadata_ = true;
                }
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function () {
        var _this = this;
        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo;
            try {
                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            }
            catch (e) {
                _this.error_ = e;
                _this.transition_(InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest
                .getPromise()
                .then(function (newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_(InternalTaskState.SUCCESS);
                }
                else {
                    _this.completeTransitions_();
                }
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function () {
        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 32 * 1024 * 1024) {
            this.chunkMultiplier_ *= 2;
        }
    };
    UploadTask.prototype.fetchMetadata_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function (transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) {
            this.notifyObservers_();
        }
    };
    UploadTask.prototype.transition_ = function (state) {
        if (this.state_ === state) {
            return;
        }
        switch (state) {
            case InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function () {
        switch (this.state_) {
            case InternalTaskState.PAUSING:
                this.transition_(InternalTaskState.PAUSED);
                break;
            case InternalTaskState.CANCELING:
                this.transition_(InternalTaskState.CANCELED);
                break;
            case InternalTaskState.RUNNING:
                this.start_();
                break;
            default:
                // TODO(andysoto): assert(false);
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function () {
            var externalState = taskStateFromInternalTaskState(this.state_);
            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */
    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
        if (nextOrObserver === void 0) { nextOrObserver = undefined; }
        if (error === void 0) { error = undefined; }
        if (completed === void 0) { completed = undefined; }
        function typeValidator(_p) {
            if (type !== TaskEvent.STATE_CHANGED) {
                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
            }
        }
        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
            '`next`, `error`, `complete` properties.';
        var nextValidator = nullFunctionSpec(true).validator;
        var observerValidator = looseObjectSpec(null, true).validator;
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            }
            catch (e) { }
            try {
                observerValidator(p);
                var anyDefined = isJustDef(p['next']) ||
                    isJustDef(p['error']) ||
                    isJustDef(p['complete']);
                if (!anyDefined) {
                    throw '';
                }
                return;
            }
            catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            stringSpec(typeValidator),
            looseObjectSpec(nextOrObserverValidator, true),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, opt_complete) {
                if (specs !== null) {
                    validate('on', specs, arguments);
                }
                var observer = new Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function () {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) {
                throw nextOrObserverMessage;
            }
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            looseObjectSpec(binderNextOrObserverValidator),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        var typeOnly = !(isJustDef(nextOrObserver) ||
            isJustDef(error) ||
            isJustDef(completed));
        if (typeOnly) {
            return makeBinder(binderSpecs);
        }
        else {
            return makeBinder(null)(nextOrObserver, error, completed);
        }
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */
    UploadTask.prototype.then = function (onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */
    UploadTask.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */
    UploadTask.prototype.addObserver_ = function (observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */
    UploadTask.prototype.removeObserver_ = function (observer) {
        remove(this.observers_, observer);
    };
    UploadTask.prototype.notifyObservers_ = function () {
        var _this = this;
        this.finishPromise_();
        var observers = clone$1(this.observers_);
        observers.forEach(function (observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function () {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch (taskStateFromInternalTaskState(this.state_)) {
                case TaskState.SUCCESS:
                    async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case TaskState.CANCELED:
                case TaskState.ERROR:
                    var toCall = this.reject_;
                    async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function (observer) {
        var externalState = taskStateFromInternalTaskState(this.state_);
        switch (externalState) {
            case TaskState.RUNNING:
            case TaskState.PAUSED:
                if (observer.next !== null) {
                    async(observer.next.bind(observer, this.snapshot))();
                }
                break;
            case TaskState.SUCCESS:
                if (observer.complete !== null) {
                    async(observer.complete.bind(observer))();
                }
                break;
            case TaskState.CANCELED:
            case TaskState.ERROR:
                if (observer.error !== null) {
                    async(observer.error.bind(observer, this.error_))();
                }
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error !== null) {
                    async(observer.error.bind(observer, this.error_))();
                }
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.resume = function () {
        validate('resume', [], arguments);
        var valid = this.state_ === InternalTaskState.PAUSED ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.RUNNING);
        }
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.pause = function () {
        validate('pause', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING;
        if (valid) {
            this.transition_(InternalTaskState.PAUSING);
        }
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.cancel = function () {
        validate('cancel', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.CANCELING);
        }
        return valid;
    };
    return UploadTask;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */
var Reference = /** @class */ (function () {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof Location) {
            this.location = location;
        }
        else {
            this.location = Location.makeFromUrl(location);
        }
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */
    Reference.prototype.toString = function () {
        validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function (authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function () {
        return getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */
    Reference.prototype.child = function (childPath) {
        validate('child', [stringSpec()], arguments);
        var newPath = child(this.location.path, childPath);
        var location = new Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */
        get: function () {
            var newPath = parent(this.location.path);
            if (newPath === null) {
                return null;
            }
            var location = new Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */
        get: function () {
            var location = new Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function () {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function () {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function () {
            return lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function () {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.put = function (data, metadata) {
        if (metadata === void 0) { metadata = null; }
        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
        this.throwIfRoot_('put');
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param string The string to upload.
     * @param opt_format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.putString = function (string, format, opt_metadata) {
        if (format === void 0) { format = StringFormat.RAW; }
        validate('putString', [
            stringSpec(),
            stringSpec(formatValidator, true),
            metadataSpec(true)
        ], arguments);
        this.throwIfRoot_('putString');
        var data = dataFromString(format, string);
        var metadata = clone(opt_metadata);
        if (!isDef(metadata['contentType']) && isDef(data.contentType)) {
            metadata['contentType'] = data.contentType;
        }
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadata);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */
    Reference.prototype.delete = function () {
        validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = deleteObject(self.authWrapper, self.location);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */
    Reference.prototype.getMetadata = function () {
        validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getMetadata(self.authWrapper, self.location, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */
    Reference.prototype.updateMetadata = function (metadata) {
        validate('updateMetadata', [metadataSpec()], arguments);
        this.throwIfRoot_('updateMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */
    Reference.prototype.getDownloadURL = function () {
        validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        return this.getMetadata().then(function (metadata) {
            var url = metadata['downloadURLs'][0];
            if (isDef(url)) {
                return url;
            }
            else {
                throw noDownloadURL();
            }
        });
    };
    Reference.prototype.throwIfRoot_ = function (name) {
        if (this.location.path === '') {
            throw invalidRootOperation(name);
        }
    };
    return Reference;
}());

/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */
var FailRequest = /** @class */ (function () {
    function FailRequest(error) {
        this.promise_ = reject(error);
    }
    /** @inheritDoc */
    FailRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    FailRequest.prototype.cancel = function (appDelete) {
        if (appDelete === void 0) { appDelete = false; }
    };
    return FailRequest;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var RequestMap = /** @class */ (function () {
    function RequestMap() {
        this.map_ = {};
        this.id_ = minSafeInteger;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     * @param r The request to register.
     */
    RequestMap.prototype.addRequest = function (r) {
        var id = this.id_;
        this.id_++;
        this.map_[id] = r;
        var self = this;
        function unmap() {
            delete self.map_[id];
        }
        r.getPromise().then(unmap, unmap);
    };
    /**
     * Cancels all registered requests.
     */
    RequestMap.prototype.clear = function () {
        forEach(this.map_, function (key, val) {
            if (val) {
                val.cancel(true);
            }
        });
        this.map_ = {};
    };
    return RequestMap;
}());

/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */
var AuthWrapper = /** @class */ (function () {
    function AuthWrapper(app, maker, requestMaker, service, pool) {
        this.bucket_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if (isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
            }
        }
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = defaultMaxOperationRetryTime;
        this.maxUploadRetryTime_ = defaultMaxUploadRetryTime;
        this.requestMap_ = new RequestMap();
    }
    AuthWrapper.extractBucket_ = function (config) {
        var bucketString = config[configOption] || null;
        if (bucketString == null) {
            return null;
        }
        var loc = Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function () {
        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
        // (b/28673818).
        if (this.app_ !== null &&
            isDef(this.app_.INTERNAL) &&
            isDef(this.app_.INTERNAL.getToken)) {
            return this.app_.INTERNAL.getToken().then(function (response) {
                if (response !== null) {
                    return response.accessToken;
                }
                else {
                    return null;
                }
            }, function (_error) {
                return null;
            });
        }
        else {
            return resolve(null);
        }
    };
    AuthWrapper.prototype.bucket = function () {
        if (this.deleted_) {
            throw appDeleted();
        }
        else {
            return this.bucket_;
        }
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */
    AuthWrapper.prototype.service = function () {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */
    AuthWrapper.prototype.makeStorageReference = function (loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        }
        else {
            return new FailRequest(appDeleted());
        }
    };
    /**
     * Stop running requests and prevent more from being created.
     */
    AuthWrapper.prototype.deleteApp = function () {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */
function start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    function triggerCallback() {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, arguments);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function () {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function handler(success) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (triggeredCallback) {
            return;
        }
        if (success) {
            triggerCallback.apply(null, arguments);
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.apply(null, arguments);
            return;
        }
        if (waitSeconds < 64) {
            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
            waitSeconds *= 2;
        }
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        }
        else {
            waitMillis = (waitSeconds + Math.random()) * 1000;
        }
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) {
            return;
        }
        stopped = true;
        if (triggeredCallback) {
            return;
        }
        if (timeoutId !== null) {
            if (!wasTimeout) {
                cancelState = 2;
            }
            clearTimeout(timeoutId);
            callWithDelay(0);
        }
        else {
            if (!wasTimeout) {
                cancelState = 1;
            }
        }
    }
    callWithDelay(0);
    setTimeout(function () {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */
function stop(id) {
    id(false);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 * @template T
 */
var NetworkRequest = /** @class */ (function () {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        var self = this;
        this.promise_ = make(function (resolve$$1, reject$$1) {
            self.resolve_ = resolve$$1;
            self.reject_ = reject$$1;
            self.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */
    NetworkRequest.prototype.start_ = function () {
        var self = this;
        function doTheRequest(backoffCallback, canceled$$1) {
            if (canceled$$1) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) {
                    self.progressCallback_(loaded, total);
                }
            }
            if (self.progressCallback_ !== null) {
                xhr.addUploadProgressListener(progressListener);
            }
            xhr
                .send(self.url_, self.method_, self.body_, self.headers_)
                .then(function (xhr) {
                if (self.progressCallback_ !== null) {
                    xhr.removeUploadProgressListener(progressListener);
                }
                self.pendingXhr_ = null;
                xhr = xhr;
                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = contains$1(self.successCodes_, status);
                backoffCallback(true, new RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */
        function backoffDone(requestWentThrough, status) {
            var resolve$$1 = self.resolve_;
            var reject$$1 = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) {
                try {
                    var result = self.callback_(xhr, xhr.getResponseText());
                    if (isJustDef(result)) {
                        resolve$$1(result);
                    }
                    else {
                        resolve$$1();
                    }
                }
                catch (e) {
                    reject$$1(e);
                }
            }
            else {
                if (xhr !== null) {
                    var err = unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) {
                        reject$$1(self.errorCallback_(xhr, err));
                    }
                    else {
                        reject$$1(err);
                    }
                }
                else {
                    if (status.canceled) {
                        var err = self.appDelete_
                            ? appDeleted()
                            : canceled();
                        reject$$1(err);
                    }
                    else {
                        var err = retryLimitExceeded();
                        reject$$1(err);
                    }
                }
            }
        }
        if (this.canceled_) {
            backoffDone(false, new RequestEndStatus(false, null, true));
        }
        else {
            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
        }
    };
    /** @inheritDoc */
    NetworkRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    NetworkRequest.prototype.cancel = function (appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) {
            stop(this.backoffId_);
        }
        if (this.pendingXhr_ !== null) {
            this.pendingXhr_.abort();
        }
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = contains$1(extraRetryCodes, status);
        var isRequestSpecificRetryCode = contains$1(this.additionalRetryCodes_, status);
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}());
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */
var RequestEndStatus = /** @class */ (function () {
    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!opt_canceled;
    }
    return RequestEndStatus;
}());
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) {
        headers['Authorization'] = 'Firebase ' + authToken;
    }
}
function addVersionHeader_(headers) {
    var number = typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"] !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"].SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
}
/**
 * @template T
 */
function makeRequest(requestInfo, authToken, pool) {
    var queryPart = makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = clone(requestInfo.headers);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */
var Service = /** @class */ (function () {
    function Service(app, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new Reference(authWrapper, loc);
        }
        this.authWrapper_ = new AuthWrapper(app, maker, makeRequest, this, pool);
        this.app_ = app;
        if (url != null) {
            this.bucket_ = Location.makeFromBucketSpec(url);
        }
        else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) {
                this.bucket_ = new Location(authWrapperBucket, '');
            }
        }
        this.internals_ = new ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */
    Service.prototype.ref = function (path) {
        function validator(path) {
            if (/^[A-Za-z]+:\/\//.test(path)) {
                throw 'Expected child path but got a URL, use refFromURL instead.';
            }
        }
        validate('ref', [stringSpec(validator, true)], arguments);
        if (this.bucket_ == null) {
            throw new Error('No Storage Bucket defined in Firebase Options.');
        }
        var ref = new Reference(this.authWrapper_, this.bucket_);
        if (path != null) {
            return ref.child(path);
        }
        else {
            return ref;
        }
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */
    Service.prototype.refFromURL = function (url) {
        function validator(p) {
            if (!/^[A-Za-z]+:\/\//.test(p)) {
                throw 'Expected full URL but got a child path, use ref instead.';
            }
            try {
                Location.makeFromUrl(p);
            }
            catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        validate('refFromURL', [stringSpec(validator, false)], arguments);
        return new Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function () {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function (time) {
        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
        get: function () {
            return this.authWrapper_.maxOperationRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxOperationRetryTime = function (time) {
        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function () {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}());
/**
 * @struct
 */
var ServiceInternals = /** @class */ (function () {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */
    ServiceInternals.prototype.delete = function () {
        this.service_.authWrapper_.deleteApp();
        return resolve(undefined);
    };
    return ServiceInternals;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Storage.
 */
var STORAGE_TYPE = 'storage';
function factory(app, unused, opt_url) {
    return new Service(app, new XhrIoPool(), opt_url);
}
function registerStorage(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: TaskState,
        TaskEvent: TaskEvent,
        StringFormat: StringFormat,
        Storage: Service,
        Reference: Reference
    };
    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
    // Allow multiple storage instances per app.
    true);
}
registerStorage(__WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"]);




/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rootSaga;

var _effects = __webpack_require__(183);

var _Contact = __webpack_require__(426);

var _firebase = __webpack_require__(225);

var _ActionTypes = __webpack_require__(41);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchContactRequest),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

function _asyncToGenerator(fn) {
    return function () {
        var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
            function step(key, arg) {
                try {
                    var info = gen[key](arg);var value = info.value;
                } catch (error) {
                    reject(error);return;
                }if (info.done) {
                    resolve(value);
                } else {
                    return Promise.resolve(value).then(function (value) {
                        step("next", value);
                    }, function (err) {
                        step("throw", err);
                    });
                }
            }return step("next");
        });
    };
}

var getContacts = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return _firebase.database.ref('prod/contacts').once('value').then(function (snapshot) {
                            var contacts = [];
                            snapshot.forEach(function (rawData) {
                                contacts.push(rawData.val());
                            });
                            return contacts;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function getContacts() {
        return _ref.apply(this, arguments);
    };
}();

function fetchContactRequest() {
    var fetchedContact;
    return regeneratorRuntime.wrap(function fetchContactRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(getContacts);

                case 3:
                    fetchedContact = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)((0, _Contact.fetchContactsSuccess)(fetchedContact));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)((0, _Contact.showContactMessage)(_context2.t0));

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function rootSaga() {
    return regeneratorRuntime.wrap(function rootSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.all)([(0, _effects.takeEvery)(_ActionTypes.FETCH_ALL_CONTACT, fetchContactRequest)]);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked2, this);
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(fetchContactRequest, 'fetchContactRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(getContacts, 'getContacts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_marked, '_marked', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(_marked2, '_marked2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(_asyncToGenerator, '_asyncToGenerator', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(getContacts, 'getContacts', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(fetchContactRequest, 'fetchContactRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Contact.js');
}();

;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createUserAccount = createUserAccount;
exports.signInWithGoogle = signInWithGoogle;
exports.signInWithFacebook = signInWithFacebook;
exports.signInWithTwitter = signInWithTwitter;
exports.signInWithGithub = signInWithGithub;
exports.signInUser = signInUser;
exports.signOutUser = signOutUser;
exports.default = rootSaga;

var _effects = __webpack_require__(183);

var _firebase = __webpack_require__(225);

var _ActionTypes = __webpack_require__(41);

var _Auth = __webpack_require__(185);

var _Auth2 = __webpack_require__(185);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createUserWithEmailPassword),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(signInUserWithGoogle),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(signInUserWithFacebook),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(signInUserWithGithub),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(signInUserWithTwitter),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(signInUserWithEmailPassword),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(signOut),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createUserAccount),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(signInWithGoogle),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(signInWithFacebook),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(signInWithTwitter),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(signInWithGithub),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(signInUser),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(signOutUser),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

function _asyncToGenerator(fn) {
    return function () {
        var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
            function step(key, arg) {
                try {
                    var info = gen[key](arg);var value = info.value;
                } catch (error) {
                    reject(error);return;
                }if (info.done) {
                    resolve(value);
                } else {
                    return Promise.resolve(value).then(function (value) {
                        step("next", value);
                    }, function (err) {
                        step("throw", err);
                    });
                }
            }return step("next");
        });
    };
}

var createUserWithEmailPasswordRequest = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email, password) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return _firebase.auth.createUserWithEmailAndPassword(email, password).then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function createUserWithEmailPasswordRequest(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var signInUserWithEmailPasswordRequest = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(email, password) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return _firebase.auth.signInWithEmailAndPassword(email, password).then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function signInUserWithEmailPasswordRequest(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

var signOutRequest = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return _firebase.auth.signOut().then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context3.abrupt('return', _context3.sent);

                    case 3:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined);
    }));

    return function signOutRequest() {
        return _ref3.apply(this, arguments);
    };
}();

function createUserWithEmailPassword(_ref4) {
    var payload = _ref4.payload;
    var email, password, signUpUser;
    return regeneratorRuntime.wrap(function createUserWithEmailPassword$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    email = payload.email, password = payload.password;
                    _context4.prev = 1;
                    _context4.next = 4;
                    return (0, _effects.call)(createUserWithEmailPasswordRequest, email, password);

                case 4:
                    signUpUser = _context4.sent;

                    if (!signUpUser.message) {
                        _context4.next = 10;
                        break;
                    }

                    _context4.next = 8;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(signUpUser.message));

                case 8:
                    _context4.next = 13;
                    break;

                case 10:
                    localStorage.setItem('user_id', signUpUser.uid);
                    _context4.next = 13;
                    return (0, _effects.put)((0, _Auth.userSignUpSuccess)(signUpUser));

                case 13:
                    _context4.next = 19;
                    break;

                case 15:
                    _context4.prev = 15;
                    _context4.t0 = _context4['catch'](1);
                    _context4.next = 19;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context4.t0));

                case 19:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked, this, [[1, 15]]);
}

var signInUserWithGoogleRequest = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return _firebase.auth.signInWithPopup(_firebase.googleAuthProvider).then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context5.abrupt('return', _context5.sent);

                    case 3:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee4, undefined);
    }));

    return function signInUserWithGoogleRequest() {
        return _ref5.apply(this, arguments);
    };
}();

var signInUserWithFacebookRequest = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return _firebase.auth.signInWithPopup(_firebase.facebookAuthProvider).then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context6.abrupt('return', _context6.sent);

                    case 3:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee5, undefined);
    }));

    return function signInUserWithFacebookRequest() {
        return _ref6.apply(this, arguments);
    };
}();

var signInUserWithGithubRequest = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return _firebase.auth.signInWithPopup(_firebase.githubAuthProvider).then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context7.abrupt('return', _context7.sent);

                    case 3:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee6, undefined);
    }));

    return function signInUserWithGithubRequest() {
        return _ref7.apply(this, arguments);
    };
}();

var signInUserWithTwitterRequest = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.next = 2;
                        return _firebase.auth.signInWithPopup(_firebase.twitterAuthProvider).then(function (authUser) {
                            return authUser;
                        }).catch(function (error) {
                            return error;
                        });

                    case 2:
                        return _context8.abrupt('return', _context8.sent);

                    case 3:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee7, undefined);
    }));

    return function signInUserWithTwitterRequest() {
        return _ref8.apply(this, arguments);
    };
}();

function signInUserWithGoogle() {
    var signUpUser;
    return regeneratorRuntime.wrap(function signInUserWithGoogle$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.prev = 0;
                    _context9.next = 3;
                    return (0, _effects.call)(signInUserWithGoogleRequest);

                case 3:
                    signUpUser = _context9.sent;

                    if (!signUpUser.message) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 7;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(signUpUser.message));

                case 7:
                    _context9.next = 12;
                    break;

                case 9:
                    localStorage.setItem('user_id', signUpUser.uid);
                    _context9.next = 12;
                    return (0, _effects.put)((0, _Auth2.userGoogleSignInSuccess)(signUpUser));

                case 12:
                    _context9.next = 18;
                    break;

                case 14:
                    _context9.prev = 14;
                    _context9.t0 = _context9['catch'](0);
                    _context9.next = 18;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context9.t0));

                case 18:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked2, this, [[0, 14]]);
}

function signInUserWithFacebook() {
    var signUpUser;
    return regeneratorRuntime.wrap(function signInUserWithFacebook$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.prev = 0;
                    _context10.next = 3;
                    return (0, _effects.call)(signInUserWithFacebookRequest);

                case 3:
                    signUpUser = _context10.sent;

                    if (!signUpUser.message) {
                        _context10.next = 9;
                        break;
                    }

                    _context10.next = 7;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(signUpUser.message));

                case 7:
                    _context10.next = 12;
                    break;

                case 9:
                    localStorage.setItem('user_id', signUpUser.uid);
                    _context10.next = 12;
                    return (0, _effects.put)((0, _Auth2.userFacebookSignInSuccess)(signUpUser));

                case 12:
                    _context10.next = 18;
                    break;

                case 14:
                    _context10.prev = 14;
                    _context10.t0 = _context10['catch'](0);
                    _context10.next = 18;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context10.t0));

                case 18:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked3, this, [[0, 14]]);
}

function signInUserWithGithub() {
    var signUpUser;
    return regeneratorRuntime.wrap(function signInUserWithGithub$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.prev = 0;
                    _context11.next = 3;
                    return (0, _effects.call)(signInUserWithGithubRequest);

                case 3:
                    signUpUser = _context11.sent;

                    if (!signUpUser.message) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 7;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(signUpUser.message));

                case 7:
                    _context11.next = 12;
                    break;

                case 9:
                    localStorage.setItem('user_id', signUpUser.uid);
                    _context11.next = 12;
                    return (0, _effects.put)((0, _Auth2.userGithubSignInSuccess)(signUpUser));

                case 12:
                    _context11.next = 18;
                    break;

                case 14:
                    _context11.prev = 14;
                    _context11.t0 = _context11['catch'](0);
                    _context11.next = 18;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context11.t0));

                case 18:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked4, this, [[0, 14]]);
}

function signInUserWithTwitter() {
    var signUpUser;
    return regeneratorRuntime.wrap(function signInUserWithTwitter$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.prev = 0;
                    _context12.next = 3;
                    return (0, _effects.call)(signInUserWithTwitterRequest);

                case 3:
                    signUpUser = _context12.sent;

                    if (!signUpUser.message) {
                        _context12.next = 14;
                        break;
                    }

                    if (!(signUpUser.message.length > 100)) {
                        _context12.next = 10;
                        break;
                    }

                    _context12.next = 8;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)('Your request has been canceled.'));

                case 8:
                    _context12.next = 12;
                    break;

                case 10:
                    _context12.next = 12;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(signUpUser.message));

                case 12:
                    _context12.next = 17;
                    break;

                case 14:
                    localStorage.setItem('user_id', signUpUser.uid);
                    _context12.next = 17;
                    return (0, _effects.put)((0, _Auth2.userTwitterSignInSuccess)(signUpUser));

                case 17:
                    _context12.next = 23;
                    break;

                case 19:
                    _context12.prev = 19;
                    _context12.t0 = _context12['catch'](0);
                    _context12.next = 23;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context12.t0));

                case 23:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked5, this, [[0, 19]]);
}

function signInUserWithEmailPassword(_ref9) {
    var payload = _ref9.payload;

    var email, password, _signInUser;

    return regeneratorRuntime.wrap(function signInUserWithEmailPassword$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    email = payload.email, password = payload.password;
                    _context13.prev = 1;
                    _context13.next = 4;
                    return (0, _effects.call)(signInUserWithEmailPasswordRequest, email, password);

                case 4:
                    _signInUser = _context13.sent;

                    if (!_signInUser.message) {
                        _context13.next = 10;
                        break;
                    }

                    _context13.next = 8;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_signInUser.message));

                case 8:
                    _context13.next = 13;
                    break;

                case 10:
                    localStorage.setItem('user_id', _signInUser.uid);
                    _context13.next = 13;
                    return (0, _effects.put)((0, _Auth.userSignInSuccess)(_signInUser));

                case 13:
                    _context13.next = 19;
                    break;

                case 15:
                    _context13.prev = 15;
                    _context13.t0 = _context13['catch'](1);
                    _context13.next = 19;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context13.t0));

                case 19:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked6, this, [[1, 15]]);
}

function signOut() {
    var _signOutUser;

    return regeneratorRuntime.wrap(function signOut$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _context14.prev = 0;
                    _context14.next = 3;
                    return (0, _effects.call)(signOutRequest);

                case 3:
                    _signOutUser = _context14.sent;

                    if (!signInUser.message) {
                        _context14.next = 9;
                        break;
                    }

                    _context14.next = 7;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(signInUser.message));

                case 7:
                    _context14.next = 12;
                    break;

                case 9:
                    localStorage.removeItem('user_id');
                    _context14.next = 12;
                    return (0, _effects.put)((0, _Auth.userSignOutSuccess)(signInUser));

                case 12:
                    _context14.next = 18;
                    break;

                case 14:
                    _context14.prev = 14;
                    _context14.t0 = _context14['catch'](0);
                    _context14.next = 18;
                    return (0, _effects.put)((0, _Auth.showAuthMessage)(_context14.t0));

                case 18:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked7, this, [[0, 14]]);
}

function createUserAccount() {
    return regeneratorRuntime.wrap(function createUserAccount$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNUP_USER, createUserWithEmailPassword);

                case 2:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked8, this);
}

function signInWithGoogle() {
    return regeneratorRuntime.wrap(function signInWithGoogle$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    _context16.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_GOOGLE_USER, signInUserWithGoogle);

                case 2:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked9, this);
}

function signInWithFacebook() {
    return regeneratorRuntime.wrap(function signInWithFacebook$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_FACEBOOK_USER, signInUserWithFacebook);

                case 2:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked10, this);
}

function signInWithTwitter() {
    return regeneratorRuntime.wrap(function signInWithTwitter$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    _context18.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_TWITTER_USER, signInUserWithTwitter);

                case 2:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked11, this);
}

function signInWithGithub() {
    return regeneratorRuntime.wrap(function signInWithGithub$(_context19) {
        while (1) {
            switch (_context19.prev = _context19.next) {
                case 0:
                    _context19.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_GITHUB_USER, signInUserWithGithub);

                case 2:
                case 'end':
                    return _context19.stop();
            }
        }
    }, _marked12, this);
}

function signInUser() {
    return regeneratorRuntime.wrap(function signInUser$(_context20) {
        while (1) {
            switch (_context20.prev = _context20.next) {
                case 0:
                    _context20.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNIN_USER, signInUserWithEmailPassword);

                case 2:
                case 'end':
                    return _context20.stop();
            }
        }
    }, _marked13, this);
}

function signOutUser() {
    return regeneratorRuntime.wrap(function signOutUser$(_context21) {
        while (1) {
            switch (_context21.prev = _context21.next) {
                case 0:
                    _context21.next = 2;
                    return (0, _effects.takeEvery)(_ActionTypes.SIGNOUT_USER, signOut);

                case 2:
                case 'end':
                    return _context21.stop();
            }
        }
    }, _marked14, this);
}

function rootSaga() {
    return regeneratorRuntime.wrap(function rootSaga$(_context22) {
        while (1) {
            switch (_context22.prev = _context22.next) {
                case 0:
                    _context22.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(signInUser), (0, _effects.fork)(createUserAccount), (0, _effects.fork)(signInWithGoogle), (0, _effects.fork)(signInWithFacebook), (0, _effects.fork)(signInWithTwitter), (0, _effects.fork)(signInWithGithub), (0, _effects.fork)(signOutUser)]);

                case 2:
                case 'end':
                    return _context22.stop();
            }
        }
    }, _marked15, this);
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(createUserWithEmailPassword, 'createUserWithEmailPassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGoogle, 'signInUserWithGoogle', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithFacebook, 'signInUserWithFacebook', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGithub, 'signInUserWithGithub', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithTwitter, 'signInUserWithTwitter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithEmailPassword, 'signInUserWithEmailPassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signOut, 'signOut', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(createUserAccount, 'createUserAccount', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithGoogle, 'signInWithGoogle', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithFacebook, 'signInWithFacebook', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithTwitter, 'signInWithTwitter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithGithub, 'signInWithGithub', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUser, 'signInUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signOutUser, 'signOutUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(createUserWithEmailPasswordRequest, 'createUserWithEmailPasswordRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithEmailPasswordRequest, 'signInUserWithEmailPasswordRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signOutRequest, 'signOutRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGoogleRequest, 'signInUserWithGoogleRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithFacebookRequest, 'signInUserWithFacebookRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGithubRequest, 'signInUserWithGithubRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithTwitterRequest, 'signInUserWithTwitterRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_marked, '_marked', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked2, '_marked2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked3, '_marked3', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked4, '_marked4', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked5, '_marked5', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked6, '_marked6', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked7, '_marked7', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked8, '_marked8', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked9, '_marked9', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked10, '_marked10', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked11, '_marked11', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked12, '_marked12', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked13, '_marked13', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked14, '_marked14', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_marked15, '_marked15', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_asyncToGenerator, '_asyncToGenerator', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(createUserWithEmailPasswordRequest, 'createUserWithEmailPasswordRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithEmailPasswordRequest, 'signInUserWithEmailPasswordRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signOutRequest, 'signOutRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(createUserWithEmailPassword, 'createUserWithEmailPassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGoogleRequest, 'signInUserWithGoogleRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithFacebookRequest, 'signInUserWithFacebookRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGithubRequest, 'signInUserWithGithubRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithTwitterRequest, 'signInUserWithTwitterRequest', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGoogle, 'signInUserWithGoogle', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithFacebook, 'signInUserWithFacebook', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithGithub, 'signInUserWithGithub', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithTwitter, 'signInUserWithTwitter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUserWithEmailPassword, 'signInUserWithEmailPassword', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signOut, 'signOut', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(createUserAccount, 'createUserAccount', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithGoogle, 'signInWithGoogle', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithFacebook, 'signInWithFacebook', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithTwitter, 'signInWithTwitter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInWithGithub, 'signInWithGithub', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signInUser, 'signInUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(signOutUser, 'signOutUser', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(rootSaga, 'rootSaga', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/sagas/Auth.js');
}();

;

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistCombineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(1180);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(reducers));
}

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
      });
    },
    persist: function persist() {
      store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMigrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(130);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransform;


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(1185);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(1186);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(327);

var _reactRouterDom = __webpack_require__(39);

var _reactRedux = __webpack_require__(30);

var _reactIntl = __webpack_require__(353);

__webpack_require__(1300);

__webpack_require__(1303);

__webpack_require__(1305);

__webpack_require__(1317);

var _indigoTheme = __webpack_require__(1319);

var _indigoTheme2 = _interopRequireDefault(_indigoTheme);

var _cyanTheme = __webpack_require__(1320);

var _cyanTheme2 = _interopRequireDefault(_cyanTheme);

var _orangeTheme = __webpack_require__(1321);

var _orangeTheme2 = _interopRequireDefault(_orangeTheme);

var _amberTheme = __webpack_require__(1322);

var _amberTheme2 = _interopRequireDefault(_amberTheme);

var _pinkTheme = __webpack_require__(1323);

var _pinkTheme2 = _interopRequireDefault(_pinkTheme);

var _blueTheme = __webpack_require__(1324);

var _blueTheme2 = _interopRequireDefault(_blueTheme);

var _purpleTheme = __webpack_require__(1325);

var _purpleTheme2 = _interopRequireDefault(_purpleTheme);

var _greenTheme = __webpack_require__(1326);

var _greenTheme2 = _interopRequireDefault(_greenTheme);

var _darkTheme = __webpack_require__(1327);

var _darkTheme2 = _interopRequireDefault(_darkTheme);

var _languageProvider = __webpack_require__(1328);

var _languageProvider2 = _interopRequireDefault(_languageProvider);

var _ThemeColors = __webpack_require__(223);

var _index = __webpack_require__(1347);

var _index2 = _interopRequireDefault(_index);

var _SignIn = __webpack_require__(2052);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _SignUp = __webpack_require__(2055);

var _SignUp2 = _interopRequireDefault(_SignUp);

var _Auth = __webpack_require__(185);

var _ActionTypes = __webpack_require__(41);

var _Setting = __webpack_require__(240);

var _SetThemeColor = __webpack_require__(836);

var _SetThemeColor2 = _interopRequireDefault(_SetThemeColor);

var _theme = __webpack_require__(2056);

var _theme2 = _interopRequireDefault(_theme);

var _homePage = __webpack_require__(2057);

var _homePage2 = _interopRequireDefault(_homePage);

var _CircularIndeterminate = __webpack_require__(386);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
}

var RestrictedRoute = function RestrictedRoute(_ref) {
    var Component = _ref.component,
        rest = _objectWithoutProperties(_ref, ['component']),
        authUser = _ref.authUser;

    return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
        render: function render(props) {
            return authUser ? _react2.default.createElement(Component, props) : _react2.default.createElement(_reactRouterDom.Redirect, {
                to: {
                    pathname: '/signin',
                    state: { from: props.location }
                }
            });
        }
    }));
};

var App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.initURL === '') {
                this.props.setInitUrl(this.props.history.location.pathname);
            }
        }
    }, {
        key: 'getColorTheme',
        value: function getColorTheme(themeColor, applyTheme) {
            switch (themeColor) {
                case _ThemeColors.INDIGO:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_indigoTheme2.default);
                        break;
                    }
                case _ThemeColors.CYAN:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_cyanTheme2.default);
                        break;
                    }
                case _ThemeColors.AMBER:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_amberTheme2.default);
                        break;
                    }
                case _ThemeColors.DEEP_ORANGE:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_orangeTheme2.default);
                        break;
                    }
                case _ThemeColors.PINK:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_pinkTheme2.default);
                        break;
                    }
                case _ThemeColors.BLUE:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_blueTheme2.default);
                        break;
                    }
                case _ThemeColors.DEEP_PURPLE:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_purpleTheme2.default);
                        break;
                    }
                case _ThemeColors.GREEN:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_greenTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_INDIGO:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_indigoTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_CYAN:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_cyanTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_AMBER:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_amberTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_DEEP_ORANGE:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_orangeTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_PINK:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_pinkTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_BLUE:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_blueTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_DEEP_PURPLE:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_purpleTheme2.default);
                        break;
                    }
                case _ThemeColors.DARK_GREEN:
                    {
                        applyTheme = (0, _styles.createMuiTheme)(_greenTheme2.default);
                        break;
                    }
            }
            return applyTheme;
        }
    }, {
        key: 'render',
        value: function render() {
            // $('#body').addClass(themeConfig.theme.name);
            var _props = this.props,
                match = _props.match,
                location = _props.location,
                themeColor = _props.themeColor,
                isDarkTheme = _props.isDarkTheme,
                locale = _props.locale,
                authUser = _props.authUser,
                initURL = _props.initURL;

            var applyTheme = (0, _styles.createMuiTheme)(_indigoTheme2.default);
            if (isDarkTheme) {
                applyTheme = (0, _styles.createMuiTheme)(_darkTheme2.default);
            } else {
                applyTheme = this.getColorTheme(themeColor, applyTheme);
            }
            if (location.pathname === '/') {
                if (this.props.profileInfo.signedIn === null) {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/homePage' });
                } else if (initURL === '' || this.props.initURL === '/signin' || this.props.initURL === '/signin') {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '' }); //redirect to = ('/app/dashboard/default')
                } else {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: initURL });
                }
            }

            if (window.innerWidth < 576) {
                this.props.setDrawerType(_ActionTypes.COLLAPSED_DRAWER);
            }

            var currentAppLocale = _languageProvider2.default[locale.locale];
            return _react2.default.createElement('div', { className: 'app-index-wrapper' }, _react2.default.createElement(_styles.MuiThemeProvider, { theme: applyTheme }, _react2.default.createElement(_reactIntl.IntlProvider, {
                locale: currentAppLocale.locale,
                messages: currentAppLocale.messages
            }, _react2.default.createElement('div', { className: 'app-main' }, _react2.default.createElement(RestrictedRoute, { path: match.url + 'app', authUser: this.props.profileInfo.signedIn,
                component: _index2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: '/homePage', component: _homePage2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: '/signin', component: _SignIn2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: '/signup', component: _SignUp2.default })))), this.props.isLoaderShown ? _react2.default.createElement('div', { className: 'overlay-and-loader d-flex justify-content-center align-items-center' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate3, null)) : "");
        }
    }]);

    return App;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var settings = _ref2.settings,
        auth = _ref2.auth,
        profileInfo = _ref2.profileInfo,
        symbioticReducer = _ref2.symbioticReducer;
    var themeColor = settings.themeColor,
        sideNavColor = settings.sideNavColor,
        darkTheme = settings.darkTheme,
        locale = settings.locale;
    var authUser = auth.authUser,
        initURL = auth.initURL;

    return { themeColor: themeColor, sideNavColor: sideNavColor, isDarkTheme: darkTheme, locale: locale, authUser: authUser, initURL: initURL, profileInfo: profileInfo, isLoaderShown: symbioticReducer.isLoaderShown };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, { setInitUrl: _Auth.setInitUrl, setDrawerType: _Setting.setDrawerType })(App);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(RestrictedRoute, 'RestrictedRoute', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js');

    __REACT_HOT_LOADER__.register(App, 'App', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_extends, "_extends", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_indigoTheme2, "_indigoTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_cyanTheme2, "_cyanTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_orangeTheme2, "_orangeTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_amberTheme2, "_amberTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_pinkTheme2, "_pinkTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_blueTheme2, "_blueTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_purpleTheme2, "_purpleTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_greenTheme2, "_greenTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_darkTheme2, "_darkTheme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_languageProvider2, "_languageProvider2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_index2, "_index2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_SignIn2, "_SignIn2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_SignUp2, "_SignUp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_SetThemeColor2, "_SetThemeColor2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_theme2, "_theme2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_homePage2, "_homePage2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_objectWithoutProperties, "_objectWithoutProperties", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(RestrictedRoute, "RestrictedRoute", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/App.js");
}();

;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1189), __esModule: true };

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1190);
module.exports = __webpack_require__(45).Object.assign;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(50);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1191) });


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(75);
var getKeys = __webpack_require__(187);
var gOPS = __webpack_require__(337);
var pIE = __webpack_require__(230);
var toObject = __webpack_require__(135);
var IObject = __webpack_require__(330);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(133)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(156);
var toLength = __webpack_require__(227);
var toAbsoluteIndex = __webpack_require__(1193);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(333);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createTypography;

var _deepmerge = __webpack_require__(231);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === undefined ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === undefined ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === undefined ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === undefined ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === undefined ? 16 : _ref$htmlFontSize,
      other = (0, _objectWithoutProperties3.default)(_ref, ['fontFamily', 'fontSize', 'fontWeightLight', 'fontWeightRegular', 'fontWeightMedium', 'htmlFontSize']);

  function pxToRem(value) {
    return value / htmlFontSize + 'rem';
  }

  return (0, _deepmerge2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: {
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: round(128 / 112) + 'em',
      marginLeft: '-.06em',
      color: palette.text.secondary
    },
    display3: {
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: round(73 / 56) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display2: {
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(48 / 45) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display1: {
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(41 / 34) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    headline: {
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(32.5 / 24) + 'em',
      color: palette.text.primary
    },
    title: {
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: round(24.5 / 21) + 'em',
      color: palette.text.primary
    },
    subheading: {
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(24 / 16) + 'em',
      color: palette.text.primary
    },
    body2: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: round(24 / 14) + 'em',
      color: palette.text.primary
    },
    body1: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(20.5 / 14) + 'em',
      color: palette.text.primary
    },
    caption: {
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(16.5 / 12) + 'em',
      color: palette.text.secondary
    },
    button: {
      fontSize: pxToRem(fontSize),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily
    }
  }, other, {
    clone: false // No need to clone deep
  });
}

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dark = exports.light = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createPalette;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(231);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _indigo = __webpack_require__(338);

var _indigo2 = _interopRequireDefault(_indigo);

var _pink = __webpack_require__(232);

var _pink2 = _interopRequireDefault(_pink);

var _grey = __webpack_require__(339);

var _grey2 = _interopRequireDefault(_grey);

var _red = __webpack_require__(512);

var _red2 = _interopRequireDefault(_red);

var _common = __webpack_require__(340);

var _common2 = _interopRequireDefault(_common);

var _colorManipulator = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = exports.light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common2.default.white,
    default: _grey2.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};

var dark = exports.dark = {
  text: {
    primary: _common2.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey2.default[800],
    default: '#303030'
  },
  action: {
    active: _common2.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === undefined ? {
    light: _indigo2.default[300],
    main: _indigo2.default[500],
    dark: _indigo2.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === undefined ? {
    light: _pink2.default.A200,
    main: _pink2.default.A400,
    dark: _pink2.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === undefined ? {
    light: _red2.default[300],
    main: _red2.default[500],
    dark: _red2.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === undefined ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === undefined ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === undefined ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties3.default)(palette, ['primary', 'secondary', 'error', 'type', 'contrastThreshold', 'tonalOffset']);


  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(contrast >= 3, ['Material-UI: the contrast ratio of ' + contrast + ':1 for ' + contrastText + ' on ' + background, 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color, mainShade, lightShade, darkShade) {
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary, 500, 300, 700);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error, 500, 300, 700);

  var types = { dark: dark, light: light };

   false ? (0, _warning2.default)(types[type], 'Material-UI: the palette type `' + type + '` is not supported.') : void 0;

  var paletteOutput = (0, _deepmerge2.default)((0, _extends3.default)({
    // A collection of common colors.
    common: _common2.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey2.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep
  });

  return paletteOutput;
}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = createMixins;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends4.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return (0, _extends4.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty3.default)({}, breakpoints.up('sm'), (0, _extends4.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty3.default)(_toolbar, breakpoints.up('xs') + ' and (orientation: landscape)', {
      minHeight: 48
    }), (0, _defineProperty3.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1198);
var $Object = __webpack_require__(45).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(50);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(75), 'Object', { defineProperty: __webpack_require__(74).f });


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + shadowKeyUmbraOpacity + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + shadowKeyPenumbraOpacity + ')', (arguments.length <= 8 ? undefined : arguments[8]) + 'px ' + (arguments.length <= 9 ? undefined : arguments[9]) + 'px ' + (arguments.length <= 10 ? undefined : arguments[10]) + 'px ' + (arguments.length <= 11 ? undefined : arguments[11]) + 'px rgba(0, 0, 0, ' + shadowAmbientShadowOpacity + ')'].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

exports.default = shadows;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1201);
module.exports = __webpack_require__(45).Object.keys;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(135);
var $keys = __webpack_require__(187);

__webpack_require__(514)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1203);
module.exports = __webpack_require__(45).Number.isNaN;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(50);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

exports.default = zIndex;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
  unit: 8
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(114);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(517);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(1210);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(1212);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(342);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(1213);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(1215);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(157);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(342);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(1214);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(157);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(342);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _brcast = __webpack_require__(1242);

var _brcast2 = _interopRequireDefault(_brcast);

var _themeListener = __webpack_require__(349);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _exactProp = __webpack_require__(190);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider = function (_React$Component) {
  (0, _inherits3.default)(MuiThemeProvider, _React$Component);

  function MuiThemeProvider(props, context) {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);

    // Get the outer theme from the context, can be null
    var _this = (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).call(this, props, context));

    _this.broadcast = (0, _brcast2.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener2.default.initial(context);
    // Propagate the theme so it can be accessed by the children
    _this.broadcast.setState(_this.mergeOuterLocalTheme(_this.props.theme));
    return _this;
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _ref;

      var _props = this.props,
          sheetsManager = _props.sheetsManager,
          disableStylesGeneration = _props.disableStylesGeneration;

      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return _ref = {}, (0, _defineProperty3.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty3.default)(_ref, 'muiThemeProviderOptions', muiThemeProviderOptions), _ref;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme;
        // Forward the parent theme update to the children
        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Propagate a local theme update
      if (this.props.theme !== nextProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(nextProps.theme));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
      }
    }
    // We are not using the React state in order to avoid unnecessary rerender.

  }, {
    key: 'mergeOuterLocalTheme',


    // Simple merge between the outer theme and the local theme
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning2.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends3.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react2.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can only provide a single element with react@15, a node with react@16.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes2.default.bool,
  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes2.default.object,
  /**
   * A theme object.
   */
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired
} : {};

MuiThemeProvider.propTypes =  false ? (0, _exactProp2.default)(MuiThemeProvider.propTypes, 'MuiThemeProvider') : {};

MuiThemeProvider.childContextTypes = (0, _extends3.default)({}, _themeListener2.default.contextTypes, {
  muiThemeProviderOptions: _propTypes2.default.object
});

MuiThemeProvider.contextTypes = (0, _extends3.default)({}, _themeListener2.default.contextTypes, {
  muiThemeProviderOptions: _propTypes2.default.object
});

exports.default = MuiThemeProvider;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1219);
module.exports = __webpack_require__(45).Object.getPrototypeOf;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(135);
var $getPrototypeOf = __webpack_require__(518);

__webpack_require__(514)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1221), __esModule: true };

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
__webpack_require__(520);
module.exports = __webpack_require__(346).f('iterator');


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(333);
var defined = __webpack_require__(332);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(233);
var descriptor = __webpack_require__(186);
var setToStringTag = __webpack_require__(234);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(111)(IteratorPrototype, __webpack_require__(66)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(74);
var anObject = __webpack_require__(132);
var getKeys = __webpack_require__(187);

module.exports = __webpack_require__(75) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(84).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1227);
var step = __webpack_require__(521);
var Iterators = __webpack_require__(189);
var toIObject = __webpack_require__(156);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(345)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1229), __esModule: true };

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1230);
__webpack_require__(525);
__webpack_require__(1233);
__webpack_require__(1234);
module.exports = __webpack_require__(45).Symbol;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(84);
var has = __webpack_require__(134);
var DESCRIPTORS = __webpack_require__(75);
var $export = __webpack_require__(50);
var redefine = __webpack_require__(519);
var META = __webpack_require__(347).KEY;
var $fails = __webpack_require__(133);
var shared = __webpack_require__(335);
var setToStringTag = __webpack_require__(234);
var uid = __webpack_require__(229);
var wks = __webpack_require__(66);
var wksExt = __webpack_require__(346);
var wksDefine = __webpack_require__(348);
var enumKeys = __webpack_require__(1231);
var isArray = __webpack_require__(522);
var anObject = __webpack_require__(132);
var isObject = __webpack_require__(99);
var toObject = __webpack_require__(135);
var toIObject = __webpack_require__(156);
var toPrimitive = __webpack_require__(329);
var createDesc = __webpack_require__(186);
var _create = __webpack_require__(233);
var gOPNExt = __webpack_require__(1232);
var $GOPD = __webpack_require__(524);
var $GOPS = __webpack_require__(337);
var $DP = __webpack_require__(74);
var $keys = __webpack_require__(187);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(523).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(230).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(228)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(111)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(187);
var gOPS = __webpack_require__(337);
var pIE = __webpack_require__(230);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(156);
var gOPN = __webpack_require__(523).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(348)('asyncIterator');


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(348)('observable');


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1236), __esModule: true };

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1237);
module.exports = __webpack_require__(45).Object.setPrototypeOf;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(50);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1238).set });


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(99);
var anObject = __webpack_require__(132);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(131)(Function.call, __webpack_require__(524).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1240), __esModule: true };

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1241);
var $Object = __webpack_require__(45).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(50);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(233) });


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    delete listeners[id];
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1244), __esModule: true };

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(525);
__webpack_require__(344);
__webpack_require__(520);
__webpack_require__(1245);
__webpack_require__(1252);
__webpack_require__(1255);
__webpack_require__(1257);
module.exports = __webpack_require__(45).Map;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1246);
var validate = __webpack_require__(532);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(1248)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(74).f;
var create = __webpack_require__(233);
var redefineAll = __webpack_require__(526);
var ctx = __webpack_require__(131);
var anInstance = __webpack_require__(527);
var forOf = __webpack_require__(235);
var $iterDefine = __webpack_require__(345);
var step = __webpack_require__(521);
var setSpecies = __webpack_require__(1247);
var DESCRIPTORS = __webpack_require__(75);
var fastKey = __webpack_require__(347).fastKey;
var validate = __webpack_require__(532);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(84);
var core = __webpack_require__(45);
var dP = __webpack_require__(74);
var DESCRIPTORS = __webpack_require__(75);
var SPECIES = __webpack_require__(66)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(84);
var $export = __webpack_require__(50);
var meta = __webpack_require__(347);
var fails = __webpack_require__(133);
var hide = __webpack_require__(111);
var redefineAll = __webpack_require__(526);
var forOf = __webpack_require__(235);
var anInstance = __webpack_require__(527);
var isObject = __webpack_require__(99);
var setToStringTag = __webpack_require__(234);
var dP = __webpack_require__(74).f;
var each = __webpack_require__(1249)(0);
var DESCRIPTORS = __webpack_require__(75);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(131);
var IObject = __webpack_require__(330);
var toObject = __webpack_require__(135);
var toLength = __webpack_require__(227);
var asc = __webpack_require__(1250);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1251);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
var isArray = __webpack_require__(522);
var SPECIES = __webpack_require__(66)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(50);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(1253)('Map') });


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(531);
var from = __webpack_require__(1254);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(235);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(1256)('Map');


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(50);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(1258)('Map');


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(50);
var aFunction = __webpack_require__(508);
var ctx = __webpack_require__(131);
var forOf = __webpack_require__(235);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1260), __esModule: true };

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1261);
module.exports = -0x1fffffffffffff;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(50);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(1);

var _ns = __webpack_require__(534);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(1263);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(1265);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(236);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(535);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(1266);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(192);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(352);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(538);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(1270);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(536);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(157);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(539);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(1271);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(1272);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(1278);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(1279);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(352);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(158);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(538);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(237);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(1280);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(1281);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(1273);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(1274);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(1275);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(1276);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(1277);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(192);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(192);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(351);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(351);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(158);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(237);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(536);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(192);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(158);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(237);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(352);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(158);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(236);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(231);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!theme.overrides || !name || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends3.default)({}, styles);

    (0, _keys2.default)(overrides).forEach(function (key) {
       false ? (0, _warning2.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', 'Fix the `' + key + '` key of `theme.overrides.' + name + '`.'].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge2.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });

    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

exports.default = getStylesCreator;

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1285), src$en$$ = __webpack_require__(1290);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(541), src$es5$$ = __webpack_require__(1286), src$compiler$$ = __webpack_require__(1287), intl$messageformat$parser$$ = __webpack_require__(1288);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(541);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1289)['default'];
exports['default'] = exports;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1293)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1298);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1294);
var en_1 = __webpack_require__(1297);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(540);
var diff_1 = __webpack_require__(1295);
var es5_1 = __webpack_require__(1296);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1301);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(115)(false);
// imports


// module
exports.push([module.i, ".rbc-btn{color:inherit;font:inherit;margin:0}button.rbc-btn{overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer}button[disabled].rbc-btn{cursor:not-allowed}button.rbc-input::-moz-focus-inner{border:0;padding:0}.rbc-calendar{box-sizing:border-box;height:100%;display:flex;flex-direction:column;align-items:stretch}.rbc-calendar *,.rbc-calendar :after,.rbc-calendar :before{box-sizing:inherit}.rbc-abs-full,.rbc-row-bg{overflow:hidden;position:absolute;top:0;left:0;right:0;bottom:0}.rbc-ellipsis,.rbc-event-label,.rbc-row-segment .rbc-event-content,.rbc-show-more{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rbc-rtl{direction:rtl}.rbc-off-range{color:#999}.rbc-off-range-bg{background:#e5e5e5}.rbc-header{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 3px;text-align:center;vertical-align:middle;font-weight:700;font-size:90%;min-height:0}.rbc-header>a,.rbc-header>a:active,.rbc-header>a:visited{color:inherit;text-decoration:none}.rbc-row-content{position:relative;user-select:none;-webkit-user-select:none;z-index:4}.rbc-today{background-color:#eaf6ff}.rbc-toolbar{display:flex;align-items:center;margin-bottom:10px;font-size:16px}.rbc-toolbar .rbc-toolbar-label{flex-grow:1;padding:0 10px;text-align:center}.rbc-toolbar button{color:#373a3c;display:inline-block;margin:0;text-align:center;vertical-align:middle;background:none;background-image:none;border:1px solid #ccc;padding:.375rem 1rem;border-radius:4px;line-height:normal;white-space:nowrap}.rbc-toolbar button.rbc-active,.rbc-toolbar button:active{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125);background-color:#e6e6e6;border-color:#adadad}.rbc-toolbar button.rbc-active:focus,.rbc-toolbar button.rbc-active:hover,.rbc-toolbar button:active:focus,.rbc-toolbar button:active:hover{color:#373a3c;background-color:#d4d4d4;border-color:#8c8c8c}.rbc-toolbar button:focus,.rbc-toolbar button:hover{color:#373a3c;background-color:#e6e6e6;border-color:#adadad}.rbc-btn-group{display:inline-block;white-space:nowrap}.rbc-btn-group>button:first-child:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.rbc-btn-group>button:last-child:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.rbc-rtl .rbc-btn-group>button:first-child:not(:last-child){border-radius:4px;border-top-left-radius:0;border-bottom-left-radius:0}.rbc-rtl .rbc-btn-group>button:last-child:not(:first-child){border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.rbc-btn-group>button:not(:first-child):not(:last-child){border-radius:0}.rbc-btn-group button+button{margin-left:-1px}.rbc-rtl .rbc-btn-group button+button{margin-left:0;margin-right:-1px}.rbc-btn-group+.rbc-btn-group,.rbc-btn-group+button{margin-left:10px}.rbc-event{cursor:pointer;padding:2px 5px;background-color:#3174ad;border-radius:5px;color:#fff}.rbc-event.rbc-selected{background-color:#265985}.rbc-event-label{font-size:80%}.rbc-event-overlaps{box-shadow:-1px 1px 5px 0 rgba(51,51,51,.5)}.rbc-event-continues-prior{border-top-left-radius:0;border-bottom-left-radius:0}.rbc-event-continues-after{border-top-right-radius:0;border-bottom-right-radius:0}.rbc-event-continues-earlier{border-top-left-radius:0;border-top-right-radius:0}.rbc-event-continues-day-after,.rbc-event-continues-later{border-bottom-left-radius:0;border-bottom-right-radius:0}.rbc-event-continues-day-prior{border-top-left-radius:0;border-top-right-radius:0}.rbc-row{display:flex;flex-direction:row}.rbc-row-segment{padding:0 1px 1px}.rbc-selected-cell{background-color:rgba(0,0,0,.1)}.rbc-show-more{background-color:hsla(0,0%,100%,.3);z-index:4;font-weight:700;font-size:85%;height:auto;line-height:normal;white-space:nowrap}.rbc-month-view{position:relative;border:1px solid #ddd;display:flex;flex-direction:column;flex:1 0 0;width:100%;user-select:none;-webkit-user-select:none;height:100%}.rbc-month-view .rbc-header{border-bottom:1px solid #ddd}.rbc-month-view .rbc-header+.rbc-header{border-left:1px solid #ddd}.rbc-rtl .rbc-month-view .rbc-header+.rbc-header{border-left-width:0;border-right:1px solid #ddd}.rbc-month-header{display:flex;flex-direction:row}.rbc-month-row{display:flex;position:relative;flex-direction:column;flex:1 0 0;overflow:hidden;height:100%}.rbc-month-row+.rbc-month-row{border-top:1px solid #ddd}.rbc-date-cell{padding-right:5px;text-align:right}.rbc-date-cell.rbc-now{font-weight:700}.rbc-date-cell>a,.rbc-date-cell>a:active,.rbc-date-cell>a:visited{color:inherit;text-decoration:none}.rbc-row-bg{display:flex;flex-direction:row;flex:1 0 0;overflow:hidden}.rbc-day-bg+.rbc-day-bg{border-left:1px solid #ddd}.rbc-rtl .rbc-day-bg+.rbc-day-bg{border-left-width:0;border-right:1px solid #ddd}.rbc-overlay{position:absolute;z-index:5;border:1px solid #e5e5e5;background-color:#fff;box-shadow:0 5px 15px rgba(0,0,0,.25);padding:10px}.rbc-overlay>*+*{margin-top:1px}.rbc-overlay-header{border-bottom:1px solid #e5e5e5;margin:-10px -10px 5px;padding:2px 10px}.rbc-agenda-view{display:flex;flex-direction:column;flex:1 0 0;overflow:auto}.rbc-agenda-view table{width:100%;border:1px solid #ddd}.rbc-agenda-view table tbody>tr>td{padding:5px 10px;vertical-align:top}.rbc-agenda-view table .rbc-agenda-time-cell{padding-left:15px;padding-right:15px;text-transform:lowercase}.rbc-agenda-view table tbody>tr>td+td{border-left:1px solid #ddd}.rbc-rtl .rbc-agenda-view table tbody>tr>td+td{border-left-width:0;border-right:1px solid #ddd}.rbc-agenda-view table tbody>tr+tr{border-top:1px solid #ddd}.rbc-agenda-view table thead>tr>th{padding:3px 5px;text-align:left;border-bottom:1px solid #ddd}.rbc-rtl .rbc-agenda-view table thead>tr>th{text-align:right}.rbc-agenda-time-cell{text-transform:lowercase}.rbc-agenda-time-cell .rbc-continues-after:after{content:\" \\BB\"}.rbc-agenda-time-cell .rbc-continues-prior:before{content:\"\\AB   \"}.rbc-agenda-date-cell,.rbc-agenda-time-cell{white-space:nowrap}.rbc-agenda-event-cell{width:100%}.rbc-time-column{display:flex;flex-direction:column;min-height:100%}.rbc-time-column .rbc-timeslot-group{flex:1}.rbc-timeslot-group{border-bottom:1px solid #ddd;min-height:40px;display:flex;flex-flow:column nowrap}.rbc-header-gutter,.rbc-time-gutter{flex:none}.rbc-label{padding:0 5px}.rbc-day-slot{position:relative}.rbc-day-slot .rbc-event{border:1px solid #265985;display:flex;max-height:100%;flex-flow:column wrap;align-items:flex-start;overflow:hidden}.rbc-day-slot .rbc-event-label{flex:none;padding-right:5px;width:auto}.rbc-day-slot .rbc-event-content{width:100%;flex:1 1 0;word-wrap:break-word;line-height:1;height:100%;min-height:1em}.rbc-day-slot .rbc-time-slot{border-top:1px solid #f7f7f7}.rbc-time-slot{flex:1 0 0}.rbc-time-slot.rbc-now{font-weight:700}.rbc-day-header{text-align:center}.rbc-day-slot .rbc-event{position:absolute;z-index:2}.rbc-slot-selection{z-index:10;position:absolute;cursor:default;background-color:rgba(0,0,0,.5);color:#fff;font-size:75%;padding:3px}.rbc-time-view{display:flex;flex-direction:column;flex:1;width:100%;border:1px solid #ddd;min-height:0}.rbc-time-view .rbc-time-gutter{white-space:nowrap}.rbc-time-view .rbc-allday-cell{width:100%;position:relative}.rbc-time-view .rbc-allday-events{position:relative;z-index:4}.rbc-time-view .rbc-row{min-height:20px}.rbc-time-header{display:flex;flex:0 0 auto;flex-direction:column}.rbc-time-header.rbc-overflowing{border-right:1px solid #ddd}.rbc-rtl .rbc-time-header.rbc-overflowing{border-right-width:0;border-left:1px solid #ddd}.rbc-time-header>.rbc-row>*+*{border-left:1px solid #ddd}.rbc-rtl .rbc-time-header>.rbc-row>*+*{border-left-width:0;border-right:1px solid #ddd}.rbc-time-header>.rbc-row:first-child{border-bottom:1px solid #ddd}.rbc-time-header .rbc-gutter-cell{flex:none}.rbc-time-header>.rbc-gutter-cell+*{width:100%}.rbc-time-content{display:flex;flex:1 0 0;align-items:flex-start;width:100%;border-top:2px solid #ddd;overflow-y:auto;position:relative}.rbc-time-content>.rbc-time-gutter{flex:none}.rbc-time-content>*+*>*{border-left:1px solid #ddd}.rbc-rtl .rbc-time-content>*+*>*{border-left-width:0;border-right:1px solid #ddd}.rbc-time-content>.rbc-day-slot{width:100%;user-select:none;-webkit-user-select:none}.rbc-current-time-indicator{position:absolute;z-index:1;left:0;height:1px;background-color:#74ad31;pointer-events:none}.rbc-current-time-indicator:before{display:block;position:absolute;left:-3px;top:-3px;content:\" \";background-color:#74ad31;border-radius:50%;width:8px;height:8px}.rbc-rtl .rbc-current-time-indicator:before{left:0;right:-3px}", ""]);

// exports


/***/ }),
/* 1302 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1304);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./bootstrap.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./bootstrap.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(238);
exports = module.exports = __webpack_require__(115)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i);", ""]);

// module
exports.push([module.i, "@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}/*!\r\n * Bootstrap v4.0.0 (https://getbootstrap.com)\r\n * Copyright 2011-2018 The Bootstrap Authors\r\n * Copyright 2011-2018 Twitter, Inc.\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\r\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#3f51b5;--secondary:#e91e63;--success:#4caf50;--info:#00bcd4;--warning:#ff9800;--danger:#f44336;--light:#e8eaf6;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:\"Roboto\",sans-serif;--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,:after,:before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:Roboto,sans-serif;font-size:14px;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#f8f9fa}[tabindex=\"-1\"]:focus{outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:12px}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;text-decoration:underline dotted;cursor:help;border-bottom:0}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#3f51b5;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#32408f;text-decoration:underline}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:12px;font-family:inherit;font-weight:400;line-height:1.2;color:inherit}.h1,h1{font-size:24px}.h2,h2{font-size:20px}.h3,h3{font-size:17px}.h4,h4{font-size:15px}.h5,h5{font-size:13px}.h6,h6{font-size:12px}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem}.display-1,.display-2{font-weight:300;line-height:1.2}.display-2{font-size:5.5rem}.display-3{font-size:4.5rem}.display-3,.display-4{font-weight:300;line-height:1.2}.display-4{font-size:3.5rem}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer:before{content:\"\\2014   \\A0\"}.img-fluid,.img-thumbnail{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;box-shadow:0 1px 2px rgba(0,0,0,.075)}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:2px;box-shadow:inset 0 -.1rem 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:12px;padding-left:12px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:12px;padding-left:12px;margin-right:auto;margin-left:auto}.row{display:flex;flex-wrap:wrap;margin-right:-12px;margin-left:-12px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{position:relative;width:100%;min-height:1px;padding-right:12px;padding-left:12px}.col{flex-basis:0;flex-grow:1;max-width:100%}.col-auto{flex:0 0 auto;width:auto;max-width:none}.col-1{flex:0 0 8.33333%;max-width:8.33333%}.col-2{flex:0 0 16.66667%;max-width:16.66667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.33333%;max-width:33.33333%}.col-5{flex:0 0 41.66667%;max-width:41.66667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.33333%;max-width:58.33333%}.col-8{flex:0 0 66.66667%;max-width:66.66667%}.col-9{flex:0 0 75%;max-width:75%}.col-10{flex:0 0 83.33333%;max-width:83.33333%}.col-11{flex:0 0 91.66667%;max-width:91.66667%}.col-12{flex:0 0 100%;max-width:100%}.order-first{order:-1}.order-last{order:13}.order-0{order:0}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.offset-1{margin-left:8.33333%}.offset-2{margin-left:16.66667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333%}.offset-5{margin-left:41.66667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333%}.offset-8{margin-left:66.66667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333%}.offset-11{margin-left:91.66667%}@media (min-width:576px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.col-sm-auto{flex:0 0 auto;width:auto;max-width:none}.col-sm-1{flex:0 0 8.33333%;max-width:8.33333%}.col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.col-sm-12{flex:0 0 100%;max-width:100%}.order-sm-first{order:-1}.order-sm-last{order:13}.order-sm-0{order:0}.order-sm-1{order:1}.order-sm-2{order:2}.order-sm-3{order:3}.order-sm-4{order:4}.order-sm-5{order:5}.order-sm-6{order:6}.order-sm-7{order:7}.order-sm-8{order:8}.order-sm-9{order:9}.order-sm-10{order:10}.order-sm-11{order:11}.order-sm-12{order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.col-md-auto{flex:0 0 auto;width:auto;max-width:none}.col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.col-md-12{flex:0 0 100%;max-width:100%}.order-md-first{order:-1}.order-md-last{order:13}.order-md-0{order:0}.order-md-1{order:1}.order-md-2{order:2}.order-md-3{order:3}.order-md-4{order:4}.order-md-5{order:5}.order-md-6{order:6}.order-md-7{order:7}.order-md-8{order:8}.order-md-9{order:9}.order-md-10{order:10}.order-md-11{order:11}.order-md-12{order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.col-lg-auto{flex:0 0 auto;width:auto;max-width:none}.col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.col-lg-12{flex:0 0 100%;max-width:100%}.order-lg-first{order:-1}.order-lg-last{order:13}.order-lg-0{order:0}.order-lg-1{order:1}.order-lg-2{order:2}.order-lg-3{order:3}.order-lg-4{order:4}.order-lg-5{order:5}.order-lg-6{order:6}.order-lg-7{order:7}.order-lg-8{order:8}.order-lg-9{order:9}.order-lg-10{order:10}.order-lg-11{order:11}.order-lg-12{order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.col-xl-auto{flex:0 0 auto;width:auto;max-width:none}.col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.col-xl-12{flex:0 0 100%;max-width:100%}.order-xl-first{order:-1}.order-xl-last{order:13}.order-xl-0{order:0}.order-xl-1{order:1}.order-xl-2{order:2}.order-xl-3{order:3}.order-xl-4{order:4}.order-xl-5{order:5}.order-xl-6{order:6}.order-xl-7{order:7}.order-xl-8{order:8}.order-xl-9{order:9}.order-xl-10{order:10}.order-xl-11{order:11}.order-xl-12{order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.table{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table .table{background-color:#f8f9fa}.table-sm td,.table-sm th{padding:.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered td,.table-bordered th{font-size:12px;border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{font-size:14px;border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#c9ceea}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#b7bde3}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#f9c0d3}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#f7a9c3}.table-success,.table-success>td,.table-success>th{background-color:#cde9ce}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#bbe1bd}.table-info,.table-info>td,.table-info>th{background-color:#b8ecf3}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#a2e6ef}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffe2b8}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffd89f}.table-danger,.table-danger>td,.table-danger>th{background-color:#fccac7}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#fbb3af}.table-light,.table-light>td,.table-light>th{background-color:#f9f9fc}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#e8e8f4}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark td,.table-dark th,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(0,0%,100%,.05)}.table-dark.table-hover tbody tr:hover{background-color:hsla(0,0%,100%,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:14px;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25)}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:not([size]):not([multiple]){height:calc(2.25rem + 2px)}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:18px;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:14px;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding-top:.375rem;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm,.input-group-lg>.form-control-plaintext.form-control,.input-group-lg>.input-group-append>.form-control-plaintext.btn,.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,.input-group-sm>.form-control-plaintext.form-control,.input-group-sm>.input-group-append>.form-control-plaintext.btn,.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:14px;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:18px;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:calc(2.875rem + 2px)}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(40,167,69,.8);border-radius:.2rem}.custom-select.is-valid,.form-control.is-valid,.was-validated .custom-select:valid,.was-validated .form-control:valid{border-color:#28a745}.custom-select.is-valid:focus,.form-control.is-valid:focus,.was-validated .custom-select:valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-select.is-valid~.valid-feedback,.custom-select.is-valid~.valid-tooltip,.form-control.is-valid~.valid-feedback,.form-control.is-valid~.valid-tooltip,.was-validated .custom-select:valid~.valid-feedback,.was-validated .custom-select:valid~.valid-tooltip,.was-validated .form-control:valid~.valid-feedback,.was-validated .form-control:valid~.valid-tooltip{display:block}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label:before,.was-validated .custom-control-input:valid~.custom-control-label:before{background-color:#71dd8a}.custom-control-input.is-valid~.valid-feedback,.custom-control-input.is-valid~.valid-tooltip,.was-validated .custom-control-input:valid~.valid-feedback,.was-validated .custom-control-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid:checked~.custom-control-label:before,.was-validated .custom-control-input:valid:checked~.custom-control-label:before{background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label:before,.was-validated .custom-control-input:valid:focus~.custom-control-label:before{box-shadow:0 0 0 1px #f8f9fa,0 0 0 .2rem rgba(40,167,69,.25)}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label:before,.was-validated .custom-file-input:valid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-valid~.valid-feedback,.custom-file-input.is-valid~.valid-tooltip,.was-validated .custom-file-input:valid~.valid-feedback,.was-validated .custom-file-input:valid~.valid-tooltip{display:block}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.5rem;margin-top:.1rem;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(220,53,69,.8);border-radius:.2rem}.custom-select.is-invalid,.form-control.is-invalid,.was-validated .custom-select:invalid,.was-validated .form-control:invalid{border-color:#dc3545}.custom-select.is-invalid:focus,.form-control.is-invalid:focus,.was-validated .custom-select:invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-select.is-invalid~.invalid-feedback,.custom-select.is-invalid~.invalid-tooltip,.form-control.is-invalid~.invalid-feedback,.form-control.is-invalid~.invalid-tooltip,.was-validated .custom-select:invalid~.invalid-feedback,.was-validated .custom-select:invalid~.invalid-tooltip,.was-validated .form-control:invalid~.invalid-feedback,.was-validated .form-control:invalid~.invalid-tooltip{display:block}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label:before,.was-validated .custom-control-input:invalid~.custom-control-label:before{background-color:#efa2a9}.custom-control-input.is-invalid~.invalid-feedback,.custom-control-input.is-invalid~.invalid-tooltip,.was-validated .custom-control-input:invalid~.invalid-feedback,.was-validated .custom-control-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid:checked~.custom-control-label:before,.was-validated .custom-control-input:invalid:checked~.custom-control-label:before{background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label:before,.was-validated .custom-control-input:invalid:focus~.custom-control-label:before{box-shadow:0 0 0 1px #f8f9fa,0 0 0 .2rem rgba(220,53,69,.25)}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label:before,.was-validated .custom-file-input:invalid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-invalid~.invalid-feedback,.custom-file-input.is-invalid~.invalid-tooltip,.was-validated .custom-file-input:invalid~.invalid-feedback,.was-validated .custom-file-input:invalid~.invalid-tooltip{display:block}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:flex;flex-flow:row wrap;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{justify-content:center}.form-inline .form-group,.form-inline label{display:flex;align-items:center;margin-bottom:0}.form-inline .form-group{flex:0 0 auto;flex-flow:row wrap}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group{width:auto}.form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{align-items:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;user-select:none;border:1px solid transparent;padding:.375rem .75rem;font-size:14px;line-height:1.2;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.btn:focus,.btn:hover{text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65;box-shadow:none}.btn:not(:disabled):not(.disabled){cursor:pointer}.btn:not(:disabled):not(.disabled).active,.btn:not(:disabled):not(.disabled):active{background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn:not(:disabled):not(.disabled).active:focus,.btn:not(:disabled):not(.disabled):active:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.25),inset 0 3px 5px rgba(0,0,0,.125)}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#3f51b5;border-color:#3f51b5;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-primary:hover{color:#fff;background-color:#354499;border-color:#32408f}.btn-primary.focus,.btn-primary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(63,81,181,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#32408f;border-color:#2f3c86}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.btn-secondary{color:#fff;background-color:#e91e63;border-color:#e91e63;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-secondary:hover{color:#fff;background-color:#cd1453;border-color:#c1134e}.btn-secondary.focus,.btn-secondary:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(233,30,99,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#e91e63;border-color:#e91e63}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#c1134e;border-color:#b61249}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.btn-success{color:#fff;background-color:#4caf50;border-color:#4caf50;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-success:hover{color:#fff;background-color:#409444;border-color:#3d8b40}.btn-success.focus,.btn-success:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(76,175,80,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#4caf50;border-color:#4caf50}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#3d8b40;border-color:#39833c}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.btn-info{color:#fff;background-color:#00bcd4;border-color:#00bcd4;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-info:hover{color:#fff;background-color:#009aae;border-color:#008fa1}.btn-info.focus,.btn-info:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,188,212,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#008fa1;border-color:#008394}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.btn-warning{color:#212529;background-color:#ff9800;border-color:#ff9800;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-warning:hover{color:#fff;background-color:#d98100;border-color:#cc7a00}.btn-warning.focus,.btn-warning:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(255,152,0,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ff9800;border-color:#ff9800}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#fff;background-color:#cc7a00;border-color:#bf7200}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.btn-danger{color:#fff;background-color:#f44336;border-color:#f44336;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-danger:hover{color:#fff;background-color:#f22112;border-color:#ea1c0d}.btn-danger.focus,.btn-danger:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(244,67,54,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#f44336;border-color:#f44336}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#ea1c0d;border-color:#de1b0c}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.btn-light{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-light:hover{color:#212529;background-color:#cdd1eb;border-color:#c3c9e8}.btn-light.focus,.btn-light:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(232,234,246,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#c3c9e8;border-color:#bac0e4}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075),0 0 0 .2rem rgba(52,58,64,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-primary{color:#3f51b5;background-color:transparent;background-image:none;border-color:#3f51b5}.btn-outline-primary:hover{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(63,81,181,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#3f51b5;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#3f51b5;border-color:#3f51b5}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(63,81,181,.5)}.btn-outline-secondary{color:#e91e63;background-color:transparent;background-image:none;border-color:#e91e63}.btn-outline-secondary:hover{color:#fff;background-color:#e91e63;border-color:#e91e63}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(233,30,99,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#e91e63;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#e91e63;border-color:#e91e63}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(233,30,99,.5)}.btn-outline-success{color:#4caf50;background-color:transparent;background-image:none;border-color:#4caf50}.btn-outline-success:hover{color:#fff;background-color:#4caf50;border-color:#4caf50}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(76,175,80,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#4caf50;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#4caf50;border-color:#4caf50}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(76,175,80,.5)}.btn-outline-info{color:#00bcd4;background-color:transparent;background-image:none;border-color:#00bcd4}.btn-outline-info:hover{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(0,188,212,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#00bcd4;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#00bcd4;border-color:#00bcd4}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(0,188,212,.5)}.btn-outline-warning{color:#ff9800;background-color:transparent;background-image:none;border-color:#ff9800}.btn-outline-warning:hover{color:#212529;background-color:#ff9800;border-color:#ff9800}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,152,0,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ff9800;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ff9800;border-color:#ff9800}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(255,152,0,.5)}.btn-outline-danger{color:#f44336;background-color:transparent;background-image:none;border-color:#f44336}.btn-outline-danger:hover{color:#fff;background-color:#f44336;border-color:#f44336}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(244,67,54,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#f44336;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#f44336;border-color:#f44336}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(244,67,54,.5)}.btn-outline-light{color:#e8eaf6;background-color:transparent;background-image:none;border-color:#e8eaf6}.btn-outline-light:hover{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(232,234,246,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#e8eaf6;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#e8eaf6;border-color:#e8eaf6}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(232,234,246,.5)}.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125),0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#3f51b5;background-color:transparent}.btn-link:hover{color:#32408f;background-color:transparent}.btn-link.focus,.btn-link:focus,.btn-link:hover{text-decoration:underline;border-color:transparent}.btn-link.focus,.btn-link:focus{box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#6c757d}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:18px;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:14px;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.show{opacity:1}.collapse{display:none}.collapse.show{display:block}tr.collapse.show{display:table-row}tbody.collapse.show{display:table-row-group}.collapsing{height:0;overflow:hidden;transition:height .35s ease}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty:after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:14px;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem;box-shadow:0 .5rem 1rem rgba(0,0,0,.175)}.dropup .dropdown-menu{margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-menu{margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-toggle:after{vertical-align:0}.dropleft .dropdown-menu{margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropleft .dropdown-toggle:before{display:inline-block;width:0;height:0;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty:after{margin-left:0}.dropleft .dropdown-toggle:before{vertical-align:0}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#6c757d;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:14px;color:#6c757d;white-space:nowrap}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;flex:0 1 auto}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-group-vertical .btn+.btn,.btn-group-vertical .btn+.btn-group,.btn-group-vertical .btn-group+.btn,.btn-group-vertical .btn-group+.btn-group,.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group.show .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.show .dropdown-toggle.btn-link{box-shadow:none}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical .btn,.btn-group-vertical .btn-group{width:100%}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio],.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control{position:relative;flex:1 1 auto;width:1%;margin-bottom:0}.input-group>.custom-file:focus,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control{margin-left:-1px}.input-group>.custom-select:not(:last-child),.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:flex;align-items:center}.input-group>.custom-file:not(:last-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label:before{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.custom-file:not(:first-child) .custom-file-label,.input-group>.custom-file:not(:first-child) .custom-file-label:before{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label:before{color:#fff;background-color:#007bff;box-shadow:none}.custom-control-input:focus~.custom-control-label:before{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:active~.custom-control-label:before{color:#fff;background-color:#b3d7ff;box-shadow:none}.custom-control-input:disabled~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label:before{background-color:#e9ecef}.custom-control-label{margin-bottom:0}.custom-control-label:before{pointer-events:none;user-select:none;background-color:#dee2e6;box-shadow:inset 0 .25rem .25rem rgba(0,0,0,.1)}.custom-control-label:after,.custom-control-label:before{position:absolute;top:.25rem;left:0;display:block;width:1rem;height:1rem;content:\"\"}.custom-control-label:after{background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-label:before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:before{background-color:#007bff;box-shadow:none}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label:before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-radio .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 5px rgba(128,189,255,.5)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{height:calc(1.8125rem + 2px);font-size:75%}.custom-select-lg,.custom-select-sm{padding-top:.375rem;padding-bottom:.375rem}.custom-select-lg{height:calc(2.875rem + 2px);font-size:125%}.custom-file{display:inline-block;margin-bottom:0}.custom-file,.custom-file-input{position:relative;width:100%;height:calc(2.25rem + 2px)}.custom-file-input{z-index:2;margin:0;opacity:0}.custom-file-input:focus~.custom-file-control{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:focus~.custom-file-control:before{border-color:#80bdff}.custom-file-input:lang(en)~.custom-file-label:after{content:\"Browse\"}.custom-file-label{left:0;z-index:1;height:calc(2.25rem + 2px);background-color:#fff;border:1px solid #ced4da;border-radius:.25rem;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.custom-file-label,.custom-file-label:after{position:absolute;top:0;right:0;padding:.375rem .75rem;line-height:1.5;color:#495057}.custom-file-label:after{bottom:0;z-index:3;display:block;height:calc((2.25rem + 2px) - 1px * 2);content:\"Browse\";background-color:#e9ecef;border-left:1px solid #ced4da;border-radius:0 .25rem .25rem 0}.nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{flex:1 1 auto;text-align:center}.nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:.5rem 1rem}.navbar,.navbar>.container,.navbar>.container-fluid{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler:not(:disabled):not(.disabled){cursor:pointer}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat 50%;background-size:100% 100%}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .dropup .dropdown-menu{top:auto;bottom:100%}}.navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid{flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .dropup .dropdown-menu{top:auto;bottom:100%}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0,0,0,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a,.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:hsla(0,0%,100%,.5);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-text a,.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-body{flex:1 1 auto;padding:24px}.card-title{margin-bottom:20px}.card-subtitle{margin-top:-10px}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:24px}.card-header{padding:20px 24px;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:20px 24px;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-bottom:-20px;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-12px;margin-left:-12px}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img{width:100%;border-radius:calc(.25rem - 1px)}.card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck{display:flex;flex-direction:column}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{display:flex;flex:1 0 0%;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group{display:flex;flex-direction:column}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{flex-flow:row wrap}.card-group>.card{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:first-child .card-header,.card-group>.card:first-child .card-img-top{border-top-right-radius:0}.card-group>.card:first-child .card-footer,.card-group>.card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:last-child .card-header,.card-group>.card:last-child .card-img-top{border-top-left-radius:0}.card-group>.card:last-child .card-footer,.card-group>.card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group>.card:only-child{border-radius:.25rem}.card-group>.card:only-child .card-header,.card-group>.card:only-child .card-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card-group>.card:only-child .card-footer,.card-group>.card:only-child .card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-group>.card:not(:first-child):not(:last-child):not(:only-child),.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top{border-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{column-count:3;column-gap:1.25rem}.card-columns .card{display:inline-block;width:100%}}.breadcrumb{display:flex;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:2px}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:flex;padding-left:0;list-style:none;border-radius:2px}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:2;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-link:not(:disabled):not(.disabled){cursor:pointer}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:2px;border-bottom-left-radius:2px}.page-item:last-child .page-link{border-top-right-radius:2px;border-bottom-right-radius:2px}.page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:18px;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm .page-link{padding:.25rem .5rem;font-size:14px;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:2px;border-bottom-left-radius:2px}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:2px;border-bottom-right-radius:2px}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#3f51b5}.badge-primary[href]:focus,.badge-primary[href]:hover{color:#fff;text-decoration:none;background-color:#32408f}.badge-secondary{color:#fff;background-color:#e91e63}.badge-secondary[href]:focus,.badge-secondary[href]:hover{color:#fff;text-decoration:none;background-color:#c1134e}.badge-success{color:#fff;background-color:#4caf50}.badge-success[href]:focus,.badge-success[href]:hover{color:#fff;text-decoration:none;background-color:#3d8b40}.badge-info{color:#fff;background-color:#00bcd4}.badge-info[href]:focus,.badge-info[href]:hover{color:#fff;text-decoration:none;background-color:#008fa1}.badge-warning{color:#212529;background-color:#ff9800}.badge-warning[href]:focus,.badge-warning[href]:hover{color:#212529;text-decoration:none;background-color:#cc7a00}.badge-danger{color:#fff;background-color:#f44336}.badge-danger[href]:focus,.badge-danger[href]:hover{color:#fff;text-decoration:none;background-color:#ea1c0d}.badge-light{color:#212529;background-color:#e8eaf6}.badge-light[href]:focus,.badge-light[href]:hover{color:#212529;text-decoration:none;background-color:#c3c9e8}.badge-dark{color:#fff;background-color:#343a40}.badge-dark[href]:focus,.badge-dark[href]:hover{color:#fff;text-decoration:none;background-color:#1d2124}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:6px}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#212a5e;background-color:#d9dcf0;border-color:#c9ceea}.alert-primary hr{border-top-color:#b7bde3}.alert-primary .alert-link{color:#141938}.alert-secondary{color:#791033;background-color:#fbd2e0;border-color:#f9c0d3}.alert-secondary hr{border-top-color:#f7a9c3}.alert-secondary .alert-link{color:#4c0a20}.alert-success{color:#285b2a;background-color:#dbefdc;border-color:#cde9ce}.alert-success hr{border-top-color:#bbe1bd}.alert-success .alert-link{color:#18381a}.alert-info{color:#00626e;background-color:#ccf2f6;border-color:#b8ecf3}.alert-info hr{border-top-color:#a2e6ef}.alert-info .alert-link{color:#00353b}.alert-warning{color:#854f00;background-color:#ffeacc;border-color:#ffe2b8}.alert-warning hr{border-top-color:#ffd89f}.alert-warning .alert-link{color:#523100}.alert-danger{color:#7f231c;background-color:#fdd9d7;border-color:#fccac7}.alert-danger hr{border-top-color:#fbb3af}.alert-danger .alert-link{color:#551713}.alert-light{color:#797a80;background-color:#fafbfd;border-color:#f9f9fc}.alert-light hr{border-top-color:#e8e8f4}.alert-light .alert-link{color:#606166}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.progress{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem;box-shadow:inset 0 .1rem .1rem rgba(0,0,0,.1)}.progress-bar{display:flex;flex-direction:column;justify-content:center;color:#fff;text-align:center;background-color:#007bff;transition:width .6s ease}.progress-bar-striped{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated{animation:progress-bar-stripes 1s linear infinite}.media{display:flex;align-items:flex-start}.media-body{flex:1}.list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item:focus,.list-group-item:hover{z-index:1;text-decoration:none}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.list-group-flush:first-child .list-group-item:first-child{border-top:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom:0}.list-group-item-primary{color:#212a5e;background-color:#c9ceea}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#212a5e;background-color:#b7bde3}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#212a5e;border-color:#212a5e}.list-group-item-secondary{color:#791033;background-color:#f9c0d3}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#791033;background-color:#f7a9c3}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#791033;border-color:#791033}.list-group-item-success{color:#285b2a;background-color:#cde9ce}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#285b2a;background-color:#bbe1bd}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#285b2a;border-color:#285b2a}.list-group-item-info{color:#00626e;background-color:#b8ecf3}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#00626e;background-color:#a2e6ef}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#00626e;border-color:#00626e}.list-group-item-warning{color:#854f00;background-color:#ffe2b8}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#854f00;background-color:#ffd89f}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#854f00;border-color:#854f00}.list-group-item-danger{color:#7f231c;background-color:#fccac7}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#7f231c;background-color:#fbb3af}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#7f231c;border-color:#7f231c}.list-group-item-light{color:#797a80;background-color:#f9f9fc}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#797a80;background-color:#e8e8f4}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#797a80;border-color:#797a80}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:focus,.close:hover{color:#000;text-decoration:none;opacity:.75}.close:not(:disabled):not(.disabled){cursor:pointer}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translateY(-25%)}.modal.show .modal-dialog{transform:translate(0)}.modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 .25rem .5rem rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #e9ecef;border-top-left-radius:6px;border-top-right-radius:6px}.modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.result-color{color:#000!important}.modal-body{position:relative;flex:1 1 auto;padding:1rem}.modal-footer{display:flex;align-items:center;justify-content:flex-end;padding:1rem;border-top:1px solid #e9ecef}.modal-footer>:not(:first-child){margin-left:.25rem}.modal-footer>:not(:last-child){margin-right:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-content{box-shadow:0 .5rem 1rem rgba(0,0,0,.5)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:800px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:Roboto,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow:before,.bs-tooltip-top .arrow:before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow:before,.bs-tooltip-right .arrow:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow:before,.bs-tooltip-bottom .arrow:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow:before,.bs-tooltip-left .arrow:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{top:0;left:0;z-index:1060;max-width:276px;font-family:Roboto,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;box-shadow:0 .25rem .5rem rgba(0,0,0,.2)}.popover,.popover .arrow{position:absolute;display:block}.popover .arrow{width:1rem;height:.5rem;margin:0 6px}.popover .arrow:after,.popover .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top] .arrow,.bs-popover-top .arrow{bottom:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:after,.bs-popover-top .arrow:before{border-width:.5rem .5rem 0}.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:before{bottom:0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-top .arrow:after{bottom:1px;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right] .arrow,.bs-popover-right .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:6px 0}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:after,.bs-popover-right .arrow:before{border-width:.5rem .5rem .5rem 0}.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:before{left:0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-right .arrow:after{left:1px;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom] .arrow,.bs-popover-bottom .arrow{top:calc((.5rem + 1px) * -1)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:after,.bs-popover-bottom .arrow:before{border-width:0 .5rem .5rem}.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:before{top:0;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-bottom .arrow:after{top:1px;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header:before,.bs-popover-bottom .popover-header:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left] .arrow,.bs-popover-left .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:6px 0}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:after,.bs-popover-left .arrow:before{border-width:.5rem 0 .5rem .5rem}.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:before{right:0;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-left .arrow:after{right:1px;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:14px;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:5px;border-top-right-radius:5px}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-item{position:relative;display:none;align-items:center;width:100%;transition:transform .6s ease;backface-visibility:hidden;perspective:1000px}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.carousel-item-next,.carousel-item-prev{position:absolute;top:0}.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{transform:translateX(0)}@supports (transform-style:preserve-3d){.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{transform:translateZ(0)}}.active.carousel-item-right,.carousel-item-next{transform:translateX(100%)}@supports (transform-style:preserve-3d){.active.carousel-item-right,.carousel-item-next{transform:translate3d(100%,0,0)}}.active.carousel-item-left,.carousel-item-prev{transform:translateX(-100%)}@supports (transform-style:preserve-3d){.active.carousel-item-left,.carousel-item-prev{transform:translate3d(-100%,0,0)}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat 50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")}.carousel-indicators{position:absolute;right:0;bottom:10px;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{position:relative;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:hsla(0,0%,100%,.5)}.carousel-indicators li:before{top:-10px}.carousel-indicators li:after,.carousel-indicators li:before{position:absolute;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators li:after{bottom:-10px}.carousel-indicators .active{background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#3f51b5!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#32408f!important}.bg-secondary{background-color:#e91e63!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#c1134e!important}.bg-success{background-color:#4caf50!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#3d8b40!important}.bg-info{background-color:#00bcd4!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#008fa1!important}.bg-warning{background-color:#ff9800!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#cc7a00!important}.bg-danger{background-color:#f44336!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#ea1c0d!important}.bg-light{background-color:#e8eaf6!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#c3c9e8!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#3f51b5!important}.border-secondary{border-color:#e91e63!important}.border-success{border-color:#4caf50!important}.border-info{border-color:#00bcd4!important}.border-warning{border-color:#ff9800!important}.border-danger{border-color:#f44336!important}.border-light{border-color:#e8eaf6!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:2px!important}.rounded-top{border-top-left-radius:2px!important}.rounded-right,.rounded-top{border-top-right-radius:2px!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:2px!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:2px!important}.rounded-left{border-top-left-radius:2px!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.clearfix:after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive:before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9:before{padding-top:42.85714%}.embed-responsive-16by9:before{padding-top:56.25%}.embed-responsive-4by3:before{padding-top:75%}.embed-responsive-1by1:before{padding-top:100%}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{align-self:stretch!important}@media (min-width:576px){.flex-sm-row{flex-direction:row!important}.flex-sm-column{flex-direction:column!important}.flex-sm-row-reverse{flex-direction:row-reverse!important}.flex-sm-column-reverse{flex-direction:column-reverse!important}.flex-sm-wrap{flex-wrap:wrap!important}.flex-sm-nowrap{flex-wrap:nowrap!important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-sm-start{justify-content:flex-start!important}.justify-content-sm-end{justify-content:flex-end!important}.justify-content-sm-center{justify-content:center!important}.justify-content-sm-between{justify-content:space-between!important}.justify-content-sm-around{justify-content:space-around!important}.align-items-sm-start{align-items:flex-start!important}.align-items-sm-end{align-items:flex-end!important}.align-items-sm-center{align-items:center!important}.align-items-sm-baseline{align-items:baseline!important}.align-items-sm-stretch{align-items:stretch!important}.align-content-sm-start{align-content:flex-start!important}.align-content-sm-end{align-content:flex-end!important}.align-content-sm-center{align-content:center!important}.align-content-sm-between{align-content:space-between!important}.align-content-sm-around{align-content:space-around!important}.align-content-sm-stretch{align-content:stretch!important}.align-self-sm-auto{align-self:auto!important}.align-self-sm-start{align-self:flex-start!important}.align-self-sm-end{align-self:flex-end!important}.align-self-sm-center{align-self:center!important}.align-self-sm-baseline{align-self:baseline!important}.align-self-sm-stretch{align-self:stretch!important}}@media (min-width:768px){.flex-md-row{flex-direction:row!important}.flex-md-column{flex-direction:column!important}.flex-md-row-reverse{flex-direction:row-reverse!important}.flex-md-column-reverse{flex-direction:column-reverse!important}.flex-md-wrap{flex-wrap:wrap!important}.flex-md-nowrap{flex-wrap:nowrap!important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-md-start{justify-content:flex-start!important}.justify-content-md-end{justify-content:flex-end!important}.justify-content-md-center{justify-content:center!important}.justify-content-md-between{justify-content:space-between!important}.justify-content-md-around{justify-content:space-around!important}.align-items-md-start{align-items:flex-start!important}.align-items-md-end{align-items:flex-end!important}.align-items-md-center{align-items:center!important}.align-items-md-baseline{align-items:baseline!important}.align-items-md-stretch{align-items:stretch!important}.align-content-md-start{align-content:flex-start!important}.align-content-md-end{align-content:flex-end!important}.align-content-md-center{align-content:center!important}.align-content-md-between{align-content:space-between!important}.align-content-md-around{align-content:space-around!important}.align-content-md-stretch{align-content:stretch!important}.align-self-md-auto{align-self:auto!important}.align-self-md-start{align-self:flex-start!important}.align-self-md-end{align-self:flex-end!important}.align-self-md-center{align-self:center!important}.align-self-md-baseline{align-self:baseline!important}.align-self-md-stretch{align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{flex-direction:row!important}.flex-lg-column{flex-direction:column!important}.flex-lg-row-reverse{flex-direction:row-reverse!important}.flex-lg-column-reverse{flex-direction:column-reverse!important}.flex-lg-wrap{flex-wrap:wrap!important}.flex-lg-nowrap{flex-wrap:nowrap!important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-lg-start{justify-content:flex-start!important}.justify-content-lg-end{justify-content:flex-end!important}.justify-content-lg-center{justify-content:center!important}.justify-content-lg-between{justify-content:space-between!important}.justify-content-lg-around{justify-content:space-around!important}.align-items-lg-start{align-items:flex-start!important}.align-items-lg-end{align-items:flex-end!important}.align-items-lg-center{align-items:center!important}.align-items-lg-baseline{align-items:baseline!important}.align-items-lg-stretch{align-items:stretch!important}.align-content-lg-start{align-content:flex-start!important}.align-content-lg-end{align-content:flex-end!important}.align-content-lg-center{align-content:center!important}.align-content-lg-between{align-content:space-between!important}.align-content-lg-around{align-content:space-around!important}.align-content-lg-stretch{align-content:stretch!important}.align-self-lg-auto{align-self:auto!important}.align-self-lg-start{align-self:flex-start!important}.align-self-lg-end{align-self:flex-end!important}.align-self-lg-center{align-self:center!important}.align-self-lg-baseline{align-self:baseline!important}.align-self-lg-stretch{align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{flex-direction:row!important}.flex-xl-column{flex-direction:column!important}.flex-xl-row-reverse{flex-direction:row-reverse!important}.flex-xl-column-reverse{flex-direction:column-reverse!important}.flex-xl-wrap{flex-wrap:wrap!important}.flex-xl-nowrap{flex-wrap:nowrap!important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xl-start{justify-content:flex-start!important}.justify-content-xl-end{justify-content:flex-end!important}.justify-content-xl-center{justify-content:center!important}.justify-content-xl-between{justify-content:space-between!important}.justify-content-xl-around{justify-content:space-around!important}.align-items-xl-start{align-items:flex-start!important}.align-items-xl-end{align-items:flex-end!important}.align-items-xl-center{align-items:center!important}.align-items-xl-baseline{align-items:baseline!important}.align-items-xl-stretch{align-items:stretch!important}.align-content-xl-start{align-content:flex-start!important}.align-content-xl-end{align-content:flex-end!important}.align-content-xl-center{align-content:center!important}.align-content-xl-between{align-content:space-between!important}.align-content-xl-around{align-content:space-around!important}.align-content-xl-stretch{align-content:stretch!important}.align-self-xl-auto{align-self:auto!important}.align-self-xl-start{align-self:flex-start!important}.align-self-xl-end{align-self:flex-end!important}.align-self-xl-center{align-self:center!important}.align-self-xl-baseline{align-self:baseline!important}.align-self-xl-stretch{align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:sticky!important}.fixed-top{top:0}.fixed-bottom,.fixed-top{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}@supports (position:sticky){.sticky-top{position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal;clip-path:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#3f51b5!important}a.text-primary:focus,a.text-primary:hover{color:#32408f!important}.text-secondary{color:#e91e63!important}a.text-secondary:focus,a.text-secondary:hover{color:#c1134e!important}.text-success{color:#4caf50!important}a.text-success:focus,a.text-success:hover{color:#3d8b40!important}.text-info{color:#00bcd4!important}a.text-info:focus,a.text-info:hover{color:#008fa1!important}.text-warning{color:#ff9800!important}a.text-warning:focus,a.text-warning:hover{color:#cc7a00!important}.text-danger{color:#f44336!important}a.text-danger:focus,a.text-danger:hover{color:#ea1c0d!important}.text-light{color:#e8eaf6!important}a.text-light:focus,a.text-light:hover{color:#c3c9e8!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#1d2124!important}.text-muted{color:#6c757d!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,:after,:before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}.container,body{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}", ""]);

// exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1306);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(238);
exports = module.exports = __webpack_require__(115)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i);", ""]);

// module
exports.push([module.i, "@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.jr-menu-icon .menu-icon{position:relative;width:70%;background-color:#fff}.jr-menu-icon .menu-icon,.jr-menu-icon .menu-icon:after,.jr-menu-icon .menu-icon:before{height:1px;min-height:1px;color:inherit;display:block;-webkit-transition:all .4s ease;-o-transition:all .4s ease;transition:all .4s ease}.jr-menu-icon .menu-icon:after,.jr-menu-icon .menu-icon:before{position:absolute;background-color:inherit;left:0;content:\"\"}.jr-menu-icon .menu-icon:after{width:120%;bottom:-6px}.jr-menu-icon .menu-icon:before{width:130%;top:-6px}.jr-menu-icon:hover .menu-icon,.jr-menu-icon:hover .menu-icon:after,.jr-menu-icon:hover .menu-icon:before{width:100%}.jr-fab-btn,.size-50,.user-avatar{height:50px!important;width:50px!important;line-height:50px}.jr-btn-fab-lg,.size-60{height:60px!important;width:60px!important;line-height:60px}.size-80{height:80px!important;width:80px!important;line-height:80px}.size-100,.user-list .user-avatar{height:100px!important;width:100px!important;line-height:100px}.icon,.jr-btn-fab-xs,.jr-menu-icon,.size-30{height:30px!important;width:30px!important;line-height:30px}.jr-btn-fab-sm,.size-40{height:40px!important;width:40px!important;line-height:40px}.profile-intro img.avatar-circle,.size-120{height:120px!important;width:120px!important;line-height:120px}.icon-addon{display:inline-block;text-align:center;background-color:inherit}.jr-card,.page-heading{padding:18px 24px;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);margin-bottom:24px;background-color:#fff;border-radius:2px;position:relative}.ripple-effect{position:relative;overflow:hidden}.ripple-effect:after{content:\"\";position:absolute;top:50%;left:50%;width:5px;height:5px;background:hsla(0,0%,100%,.5);opacity:0;border-radius:100%;transform:scale(1) translate(-50%);transform-origin:50% 50%}.ripple-effect:hover:after{animation:ripple 1s ease-out}@keyframes ripple{0%{transform:scale(0);opacity:.5}20%{transform:scale(60);opacity:.3}to{opacity:0;transform:scale(100)}}@-webkit-keyframes ripple{0%{transform:scale(0);opacity:.5}20%{transform:scale(60);opacity:.3}to{opacity:0;transform:scale(100)}}.quick-menu .icon-alert:after{-webkit-box-shadow:0 0 0 rgba(244,67,54,.4);-moz-box-shadow:0 0 0 rgba(244,67,54,.4);-o-box-shadow:0 0 0 rgba(244,67,54,.4);box-shadow:0 0 0 rgba(244,67,54,.4);animation:pulse 2s infinite}@-webkit-keyframes pulse{0%{-webkit-box-shadow:0 0 0 0 rgba(244,67,54,.4)}70%{-webkit-box-shadow:0 0 0 10px rgba(244,67,54,0)}to{-webkit-box-shadow:0 0 0 0 rgba(244,67,54,0)}}@keyframes pulse{0%{-moz-box-shadow:0 0 0 0 rgba(244,67,54,.4);box-shadow:0 0 0 0 rgba(244,67,54,.4)}70%{-moz-box-shadow:0 0 0 10px rgba(244,67,54,0);box-shadow:0 0 0 10px rgba(244,67,54,0)}to{-moz-box-shadow:0 0 0 0 rgba(244,67,54,0);box-shadow:0 0 0 0 rgba(244,67,54,0)}}.chat-avatar-mode .chat-mode.offline,.chat-avatar-mode .chat-mode.online{display:block;-webkit-box-shadow:0 0 0 rgba(40,167,69,.4);-moz-box-shadow:0 0 0 rgba(40,167,69,.4);-o-box-shadow:0 0 0 rgba(40,167,69,.4);box-shadow:0 0 0 rgba(40,167,69,.4);animation:online 2s infinite}@-webkit-keyframes online{0%{-webkit-box-shadow:0 0 0 0 rgba(40,167,69,.4)}70%{-webkit-box-shadow:0 0 0 10px rgba(40,167,69,0)}to{-webkit-box-shadow:0 0 0 0 rgba(40,167,69,0)}}@keyframes online{0%{-moz-box-shadow:0 0 0 0 rgba(40,167,69,.4);box-shadow:0 0 0 0 rgba(40,167,69,.4)}70%{-moz-box-shadow:0 0 0 10px rgba(40,167,69,0);box-shadow:0 0 0 10px rgba(40,167,69,0)}to{-moz-box-shadow:0 0 0 0 rgba(40,167,69,0);box-shadow:0 0 0 0 rgba(40,167,69,0)}}.chat-avatar-mode .chat-mode.away{display:block;-webkit-box-shadow:0 0 0 rgba(255,193,7,.4);-moz-box-shadow:0 0 0 rgba(255,193,7,.4);-o-box-shadow:0 0 0 rgba(255,193,7,.4);box-shadow:0 0 0 rgba(255,193,7,.4);animation:away 2s infinite}@-webkit-keyframes away{0%{-webkit-box-shadow:0 0 0 0 rgba(255,193,7,.4)}70%{-webkit-box-shadow:0 0 0 10px rgba(255,193,7,0)}to{-webkit-box-shadow:0 0 0 0 rgba(255,193,7,0)}}@keyframes away{0%{-moz-box-shadow:0 0 0 0 rgba(255,193,7,.4);box-shadow:0 0 0 0 rgba(255,193,7,.4)}70%{-moz-box-shadow:0 0 0 10px rgba(255,193,7,0);box-shadow:0 0 0 10px rgba(255,193,7,0)}to{-moz-box-shadow:0 0 0 0 rgba(255,193,7,0);box-shadow:0 0 0 0 rgba(255,193,7,0)}}.brand-logo,.grid-thumb-equal{position:relative;padding-bottom:68%;height:0;width:100%;overflow:hidden}.brand-logo .brand-logo-inner,.grid-thumb-cover{display:block;position:absolute;width:100%;height:100%}.grid-thumb-cover img{height:auto;max-width:100%;min-height:100%;object-fit:cover;width:100%}a.badge-danger,a.badge-danger:focus,a.badge-danger:hover,a.badge-dark,a.badge-dark:focus,a.badge-dark:hover,a.badge-info,a.badge-info:focus,a.badge-info:hover,a.badge-success,a.badge-success:focus,a.badge-success:hover,a.badge-warning,a.badge-warning:focus,a.badge-warning:hover,a.btn-danger,a.btn-danger:focus,a.btn-danger:hover,a.btn-dark,a.btn-dark:focus,a.btn-dark:hover,a.btn-info,a.btn-info:focus,a.btn-info:hover,a.btn-success,a.btn-success:focus,a.btn-success:hover,a.btn-warning,a.btn-warning:focus,a.btn-warning:hover{color:#fff!important}.carousel-control-next,.carousel-control-prev{cursor:pointer}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-25{max-width:25%!important}.mw-50{max-width:50%!important}.mw-75{max-width:75%!important}.mw-100{max-width:100%!important}.mh-25{max-height:25%!important}.mh-50{max-height:50%!important}.mh-75{max-height:75%!important}.mh-100{max-height:100%!important}.bg-primary{background-color:#3f51b5!important}.text-primary{color:#3f51b5!important}.text-primary.icon-outline{border-color:#3f51b5!important}.bg-primary.lighten-5{background-color:#e8eaf6!important}.text-primary.text-lighten-5{color:#e8eaf6!important}.text-primary.text-lighten-5.icon-outline{border-color:#e8eaf6!important}.bg-primary.lighten-4{background-color:#c5cae9!important}.text-primary.text-lighten-4{color:#c5cae9!important}.text-primary.text-lighten-4.icon-outline{border-color:#c5cae9!important}.bg-primary.lighten-3{background-color:#9fa8da!important}.text-primary.text-lighten-3{color:#9fa8da!important}.text-primary.text-lighten-3.icon-outline{border-color:#9fa8da!important}.bg-primary.lighten-2{background-color:#7986cb!important}.text-primary.text-lighten-2{color:#7986cb!important}.text-primary.text-lighten-2.icon-outline{border-color:#7986cb!important}.bg-primary.lighten-1{background-color:#5c6bc0!important}.text-primary.text-lighten-1{color:#5c6bc0!important}.text-primary.text-lighten-1.icon-outline{border-color:#5c6bc0!important}.bg-primary.darken-1{background-color:#3949ab!important}.text-primary.text-darken-1{color:#3949ab!important}.text-primary.text-darken-1.icon-outline{border-color:#3949ab!important}.bg-primary.darken-2{background-color:#303f9f!important}.text-primary.text-darken-2{color:#303f9f!important}.text-primary.text-darken-2.icon-outline{border-color:#303f9f!important}.bg-primary.darken-3{background-color:#283593!important}.text-primary.text-darken-3{color:#283593!important}.text-primary.text-darken-3.icon-outline{border-color:#283593!important}.bg-primary.darken-4{background-color:#1a237e!important}.text-primary.text-darken-4{color:#1a237e!important}.text-primary.text-darken-4.icon-outline{border-color:#1a237e!important}.bg-primary.accent-1{background-color:#8c9eff!important}.text-primary.text-accent-1{color:#8c9eff!important}.text-primary.text-accent-1.icon-outline{border-color:#8c9eff!important}.bg-primary.accent-2{background-color:#536dfe!important}.text-primary.text-accent-2{color:#536dfe!important}.text-primary.text-accent-2.icon-outline{border-color:#536dfe!important}.bg-primary.accent-3{background-color:#3d5afe!important}.text-primary.text-accent-3{color:#3d5afe!important}.text-primary.text-accent-3.icon-outline{border-color:#3d5afe!important}.bg-primary.accent-4{background-color:#304ffe!important}.text-primary.text-accent-4{color:#304ffe!important}.text-primary.text-accent-4.icon-outline{border-color:#304ffe!important}.bg-red{background-color:#f44336!important}.text-red{color:#f44336!important}.text-red.icon-outline{border-color:#f44336!important}.bg-red.lighten-5{background-color:#ffebee!important}.text-red.text-lighten-5{color:#ffebee!important}.text-red.text-lighten-5.icon-outline{border-color:#ffebee!important}.bg-red.lighten-4{background-color:#ffcdd2!important}.text-red.text-lighten-4{color:#ffcdd2!important}.text-red.text-lighten-4.icon-outline{border-color:#ffcdd2!important}.bg-red.lighten-3{background-color:#ef9a9a!important}.text-red.text-lighten-3{color:#ef9a9a!important}.text-red.text-lighten-3.icon-outline{border-color:#ef9a9a!important}.bg-red.lighten-2{background-color:#e57373!important}.text-red.text-lighten-2{color:#e57373!important}.text-red.text-lighten-2.icon-outline{border-color:#e57373!important}.bg-red.lighten-1{background-color:#ef5350!important}.text-red.text-lighten-1{color:#ef5350!important}.text-red.text-lighten-1.icon-outline{border-color:#ef5350!important}.bg-red.darken-1{background-color:#e53935!important}.text-red.text-darken-1{color:#e53935!important}.text-red.text-darken-1.icon-outline{border-color:#e53935!important}.bg-red.darken-2{background-color:#d32f2f!important}.text-red.text-darken-2{color:#d32f2f!important}.text-red.text-darken-2.icon-outline{border-color:#d32f2f!important}.bg-red.darken-3{background-color:#c62828!important}.text-red.text-darken-3{color:#c62828!important}.text-red.text-darken-3.icon-outline{border-color:#c62828!important}.bg-red.darken-4{background-color:#b71c1c!important}.text-red.text-darken-4{color:#b71c1c!important}.text-red.text-darken-4.icon-outline{border-color:#b71c1c!important}.bg-red.accent-1{background-color:#ff8a80!important}.text-red.text-accent-1{color:#ff8a80!important}.text-red.text-accent-1.icon-outline{border-color:#ff8a80!important}.bg-red.accent-2{background-color:#ff5252!important}.text-red.text-accent-2{color:#ff5252!important}.text-red.text-accent-2.icon-outline{border-color:#ff5252!important}.bg-red.accent-3{background-color:#ff1744!important}.text-red.text-accent-3{color:#ff1744!important}.text-red.text-accent-3.icon-outline{border-color:#ff1744!important}.bg-red.accent-4{background-color:#d50000!important}.text-red.text-accent-4{color:#d50000!important}.text-red.text-accent-4.icon-outline{border-color:#d50000!important}.bg-pink{background-color:#e91e63!important}.text-pink{color:#e91e63!important}.text-pink.icon-outline{border-color:#e91e63!important}.bg-pink.lighten-5{background-color:#fce4ec!important}.text-pink.text-lighten-5{color:#fce4ec!important}.text-pink.text-lighten-5.icon-outline{border-color:#fce4ec!important}.bg-pink.lighten-4{background-color:#f8bbd0!important}.text-pink.text-lighten-4{color:#f8bbd0!important}.text-pink.text-lighten-4.icon-outline{border-color:#f8bbd0!important}.bg-pink.lighten-3{background-color:#f48fb1!important}.text-pink.text-lighten-3{color:#f48fb1!important}.text-pink.text-lighten-3.icon-outline{border-color:#f48fb1!important}.bg-pink.lighten-2{background-color:#f06292!important}.text-pink.text-lighten-2{color:#f06292!important}.text-pink.text-lighten-2.icon-outline{border-color:#f06292!important}.bg-pink.lighten-1{background-color:#ec407a!important}.text-pink.text-lighten-1{color:#ec407a!important}.text-pink.text-lighten-1.icon-outline{border-color:#ec407a!important}.bg-pink.darken-1{background-color:#d81b60!important}.text-pink.text-darken-1{color:#d81b60!important}.text-pink.text-darken-1.icon-outline{border-color:#d81b60!important}.bg-pink.darken-2{background-color:#c2185b!important}.text-pink.text-darken-2{color:#c2185b!important}.text-pink.text-darken-2.icon-outline{border-color:#c2185b!important}.bg-pink.darken-3{background-color:#ad1457!important}.text-pink.text-darken-3{color:#ad1457!important}.text-pink.text-darken-3.icon-outline{border-color:#ad1457!important}.bg-pink.darken-4{background-color:#880e4f!important}.text-pink.text-darken-4{color:#880e4f!important}.text-pink.text-darken-4.icon-outline{border-color:#880e4f!important}.bg-pink.accent-1{background-color:#ff80ab!important}.text-pink.text-accent-1{color:#ff80ab!important}.text-pink.text-accent-1.icon-outline{border-color:#ff80ab!important}.bg-pink.accent-2{background-color:#ff4081!important}.text-pink.text-accent-2{color:#ff4081!important}.text-pink.text-accent-2.icon-outline{border-color:#ff4081!important}.bg-pink.accent-3{background-color:#f50057!important}.text-pink.text-accent-3{color:#f50057!important}.text-pink.text-accent-3.icon-outline{border-color:#f50057!important}.bg-pink.accent-4{background-color:#c51162!important}.text-pink.text-accent-4{color:#c51162!important}.text-pink.text-accent-4.icon-outline{border-color:#c51162!important}.bg-purple{background-color:#9c27b0!important}.text-purple{color:#9c27b0!important}.text-purple.icon-outline{border-color:#9c27b0!important}.bg-purple.lighten-5{background-color:#f3e5f5!important}.text-purple.text-lighten-5{color:#f3e5f5!important}.text-purple.text-lighten-5.icon-outline{border-color:#f3e5f5!important}.bg-purple.lighten-4{background-color:#e1bee7!important}.text-purple.text-lighten-4{color:#e1bee7!important}.text-purple.text-lighten-4.icon-outline{border-color:#e1bee7!important}.bg-purple.lighten-3{background-color:#ce93d8!important}.text-purple.text-lighten-3{color:#ce93d8!important}.text-purple.text-lighten-3.icon-outline{border-color:#ce93d8!important}.bg-purple.lighten-2{background-color:#ba68c8!important}.text-purple.text-lighten-2{color:#ba68c8!important}.text-purple.text-lighten-2.icon-outline{border-color:#ba68c8!important}.bg-purple.lighten-1{background-color:#ab47bc!important}.text-purple.text-lighten-1{color:#ab47bc!important}.text-purple.text-lighten-1.icon-outline{border-color:#ab47bc!important}.bg-purple.darken-1{background-color:#8e24aa!important}.text-purple.text-darken-1{color:#8e24aa!important}.text-purple.text-darken-1.icon-outline{border-color:#8e24aa!important}.bg-purple.darken-2{background-color:#7b1fa2!important}.text-purple.text-darken-2{color:#7b1fa2!important}.text-purple.text-darken-2.icon-outline{border-color:#7b1fa2!important}.bg-purple.darken-3{background-color:#6a1b9a!important}.text-purple.text-darken-3{color:#6a1b9a!important}.text-purple.text-darken-3.icon-outline{border-color:#6a1b9a!important}.bg-purple.darken-4{background-color:#4a148c!important}.text-purple.text-darken-4{color:#4a148c!important}.text-purple.text-darken-4.icon-outline{border-color:#4a148c!important}.bg-purple.accent-1{background-color:#ea80fc!important}.text-purple.text-accent-1{color:#ea80fc!important}.text-purple.text-accent-1.icon-outline{border-color:#ea80fc!important}.bg-purple.accent-2{background-color:#e040fb!important}.text-purple.text-accent-2{color:#e040fb!important}.text-purple.text-accent-2.icon-outline{border-color:#e040fb!important}.bg-purple.accent-3{background-color:#d500f9!important}.text-purple.text-accent-3{color:#d500f9!important}.text-purple.text-accent-3.icon-outline{border-color:#d500f9!important}.bg-purple.accent-4{background-color:#a0f!important}.text-purple.text-accent-4{color:#a0f!important}.text-purple.text-accent-4.icon-outline{border-color:#a0f!important}.bg-deep-purple{background-color:#673ab7!important}.text-deep-purple{color:#673ab7!important}.text-deep-purple.icon-outline{border-color:#673ab7!important}.bg-deep-purple.lighten-5{background-color:#ede7f6!important}.text-deep-purple.text-lighten-5{color:#ede7f6!important}.text-deep-purple.text-lighten-5.icon-outline{border-color:#ede7f6!important}.bg-deep-purple.lighten-4{background-color:#d1c4e9!important}.text-deep-purple.text-lighten-4{color:#d1c4e9!important}.text-deep-purple.text-lighten-4.icon-outline{border-color:#d1c4e9!important}.bg-deep-purple.lighten-3{background-color:#b39ddb!important}.text-deep-purple.text-lighten-3{color:#b39ddb!important}.text-deep-purple.text-lighten-3.icon-outline{border-color:#b39ddb!important}.bg-deep-purple.lighten-2{background-color:#9575cd!important}.text-deep-purple.text-lighten-2{color:#9575cd!important}.text-deep-purple.text-lighten-2.icon-outline{border-color:#9575cd!important}.bg-deep-purple.lighten-1{background-color:#7e57c2!important}.text-deep-purple.text-lighten-1{color:#7e57c2!important}.text-deep-purple.text-lighten-1.icon-outline{border-color:#7e57c2!important}.bg-deep-purple.darken-1{background-color:#5e35b1!important}.text-deep-purple.text-darken-1{color:#5e35b1!important}.text-deep-purple.text-darken-1.icon-outline{border-color:#5e35b1!important}.bg-deep-purple.darken-2{background-color:#512da8!important}.text-deep-purple.text-darken-2{color:#512da8!important}.text-deep-purple.text-darken-2.icon-outline{border-color:#512da8!important}.bg-deep-purple.darken-3{background-color:#4527a0!important}.text-deep-purple.text-darken-3{color:#4527a0!important}.text-deep-purple.text-darken-3.icon-outline{border-color:#4527a0!important}.bg-deep-purple.darken-4{background-color:#311b92!important}.text-deep-purple.text-darken-4{color:#311b92!important}.text-deep-purple.text-darken-4.icon-outline{border-color:#311b92!important}.bg-deep-purple.accent-1{background-color:#b388ff!important}.text-deep-purple.text-accent-1{color:#b388ff!important}.text-deep-purple.text-accent-1.icon-outline{border-color:#b388ff!important}.bg-deep-purple.accent-2{background-color:#7c4dff!important}.text-deep-purple.text-accent-2{color:#7c4dff!important}.text-deep-purple.text-accent-2.icon-outline{border-color:#7c4dff!important}.bg-deep-purple.accent-3{background-color:#651fff!important}.text-deep-purple.text-accent-3{color:#651fff!important}.text-deep-purple.text-accent-3.icon-outline{border-color:#651fff!important}.bg-deep-purple.accent-4{background-color:#6200ea!important}.text-deep-purple.text-accent-4{color:#6200ea!important}.text-deep-purple.text-accent-4.icon-outline{border-color:#6200ea!important}.bg-indigo{background-color:#3f51b5!important}.text-indigo{color:#3f51b5!important}.text-indigo.icon-outline{border-color:#3f51b5!important}.bg-indigo.lighten-5{background-color:#e8eaf6!important}.text-indigo.text-lighten-5{color:#e8eaf6!important}.text-indigo.text-lighten-5.icon-outline{border-color:#e8eaf6!important}.bg-indigo.lighten-4{background-color:#c5cae9!important}.text-indigo.text-lighten-4{color:#c5cae9!important}.text-indigo.text-lighten-4.icon-outline{border-color:#c5cae9!important}.bg-indigo.lighten-3{background-color:#9fa8da!important}.text-indigo.text-lighten-3{color:#9fa8da!important}.text-indigo.text-lighten-3.icon-outline{border-color:#9fa8da!important}.bg-indigo.lighten-2{background-color:#7986cb!important}.text-indigo.text-lighten-2{color:#7986cb!important}.text-indigo.text-lighten-2.icon-outline{border-color:#7986cb!important}.bg-indigo.lighten-1{background-color:#5c6bc0!important}.text-indigo.text-lighten-1{color:#5c6bc0!important}.text-indigo.text-lighten-1.icon-outline{border-color:#5c6bc0!important}.bg-indigo.darken-1{background-color:#3949ab!important}.text-indigo.text-darken-1{color:#3949ab!important}.text-indigo.text-darken-1.icon-outline{border-color:#3949ab!important}.bg-indigo.darken-2{background-color:#303f9f!important}.text-indigo.text-darken-2{color:#303f9f!important}.text-indigo.text-darken-2.icon-outline{border-color:#303f9f!important}.bg-indigo.darken-3{background-color:#283593!important}.text-indigo.text-darken-3{color:#283593!important}.text-indigo.text-darken-3.icon-outline{border-color:#283593!important}.bg-indigo.darken-4{background-color:#1a237e!important}.text-indigo.text-darken-4{color:#1a237e!important}.text-indigo.text-darken-4.icon-outline{border-color:#1a237e!important}.bg-indigo.accent-1{background-color:#8c9eff!important}.text-indigo.text-accent-1{color:#8c9eff!important}.text-indigo.text-accent-1.icon-outline{border-color:#8c9eff!important}.bg-indigo.accent-2{background-color:#536dfe!important}.text-indigo.text-accent-2{color:#536dfe!important}.text-indigo.text-accent-2.icon-outline{border-color:#536dfe!important}.bg-indigo.accent-3{background-color:#3d5afe!important}.text-indigo.text-accent-3{color:#3d5afe!important}.text-indigo.text-accent-3.icon-outline{border-color:#3d5afe!important}.bg-indigo.accent-4{background-color:#304ffe!important}.text-indigo.text-accent-4{color:#304ffe!important}.text-indigo.text-accent-4.icon-outline{border-color:#304ffe!important}.bg-blue{background-color:#2196f3!important}.text-blue{color:#2196f3!important}.text-blue.icon-outline{border-color:#2196f3!important}.bg-blue.lighten-5{background-color:#e3f2fd!important}.text-blue.text-lighten-5{color:#e3f2fd!important}.text-blue.text-lighten-5.icon-outline{border-color:#e3f2fd!important}.bg-blue.lighten-4{background-color:#bbdefb!important}.text-blue.text-lighten-4{color:#bbdefb!important}.text-blue.text-lighten-4.icon-outline{border-color:#bbdefb!important}.bg-blue.lighten-3{background-color:#90caf9!important}.text-blue.text-lighten-3{color:#90caf9!important}.text-blue.text-lighten-3.icon-outline{border-color:#90caf9!important}.bg-blue.lighten-2{background-color:#64b5f6!important}.text-blue.text-lighten-2{color:#64b5f6!important}.text-blue.text-lighten-2.icon-outline{border-color:#64b5f6!important}.bg-blue.lighten-1{background-color:#42a5f5!important}.text-blue.text-lighten-1{color:#42a5f5!important}.text-blue.text-lighten-1.icon-outline{border-color:#42a5f5!important}.bg-blue.darken-1{background-color:#1e88e5!important}.text-blue.text-darken-1{color:#1e88e5!important}.text-blue.text-darken-1.icon-outline{border-color:#1e88e5!important}.bg-blue.darken-2{background-color:#1976d2!important}.text-blue.text-darken-2{color:#1976d2!important}.text-blue.text-darken-2.icon-outline{border-color:#1976d2!important}.bg-blue.darken-3{background-color:#1565c0!important}.text-blue.text-darken-3{color:#1565c0!important}.text-blue.text-darken-3.icon-outline{border-color:#1565c0!important}.bg-blue.darken-4{background-color:#0d47a1!important}.text-blue.text-darken-4{color:#0d47a1!important}.text-blue.text-darken-4.icon-outline{border-color:#0d47a1!important}.bg-blue.accent-1{background-color:#82b1ff!important}.text-blue.text-accent-1{color:#82b1ff!important}.text-blue.text-accent-1.icon-outline{border-color:#82b1ff!important}.bg-blue.accent-2{background-color:#448aff!important}.text-blue.text-accent-2{color:#448aff!important}.text-blue.text-accent-2.icon-outline{border-color:#448aff!important}.bg-blue.accent-3{background-color:#2979ff!important}.text-blue.text-accent-3{color:#2979ff!important}.text-blue.text-accent-3.icon-outline{border-color:#2979ff!important}.bg-blue.accent-4{background-color:#2962ff!important}.text-blue.text-accent-4{color:#2962ff!important}.text-blue.text-accent-4.icon-outline{border-color:#2962ff!important}.bg-light-blue{background-color:#03a9f4!important}.text-light-blue{color:#03a9f4!important}.text-light-blue.icon-outline{border-color:#03a9f4!important}.bg-light-blue.lighten-5{background-color:#e1f5fe!important}.text-light-blue.text-lighten-5{color:#e1f5fe!important}.text-light-blue.text-lighten-5.icon-outline{border-color:#e1f5fe!important}.bg-light-blue.lighten-4{background-color:#b3e5fc!important}.text-light-blue.text-lighten-4{color:#b3e5fc!important}.text-light-blue.text-lighten-4.icon-outline{border-color:#b3e5fc!important}.bg-light-blue.lighten-3{background-color:#81d4fa!important}.text-light-blue.text-lighten-3{color:#81d4fa!important}.text-light-blue.text-lighten-3.icon-outline{border-color:#81d4fa!important}.bg-light-blue.lighten-2{background-color:#4fc3f7!important}.text-light-blue.text-lighten-2{color:#4fc3f7!important}.text-light-blue.text-lighten-2.icon-outline{border-color:#4fc3f7!important}.bg-light-blue.lighten-1{background-color:#29b6f6!important}.text-light-blue.text-lighten-1{color:#29b6f6!important}.text-light-blue.text-lighten-1.icon-outline{border-color:#29b6f6!important}.bg-light-blue.darken-1{background-color:#039be5!important}.text-light-blue.text-darken-1{color:#039be5!important}.text-light-blue.text-darken-1.icon-outline{border-color:#039be5!important}.bg-light-blue.darken-2{background-color:#0288d1!important}.text-light-blue.text-darken-2{color:#0288d1!important}.text-light-blue.text-darken-2.icon-outline{border-color:#0288d1!important}.bg-light-blue.darken-3{background-color:#0277bd!important}.text-light-blue.text-darken-3{color:#0277bd!important}.text-light-blue.text-darken-3.icon-outline{border-color:#0277bd!important}.bg-light-blue.darken-4{background-color:#01579b!important}.text-light-blue.text-darken-4{color:#01579b!important}.text-light-blue.text-darken-4.icon-outline{border-color:#01579b!important}.bg-light-blue.accent-1{background-color:#80d8ff!important}.text-light-blue.text-accent-1{color:#80d8ff!important}.text-light-blue.text-accent-1.icon-outline{border-color:#80d8ff!important}.bg-light-blue.accent-2{background-color:#40c4ff!important}.text-light-blue.text-accent-2{color:#40c4ff!important}.text-light-blue.text-accent-2.icon-outline{border-color:#40c4ff!important}.bg-light-blue.accent-3{background-color:#00b0ff!important}.text-light-blue.text-accent-3{color:#00b0ff!important}.text-light-blue.text-accent-3.icon-outline{border-color:#00b0ff!important}.bg-light-blue.accent-4{background-color:#0091ea!important}.text-light-blue.text-accent-4{color:#0091ea!important}.text-light-blue.text-accent-4.icon-outline{border-color:#0091ea!important}.bg-cyan{background-color:#00bcd4!important}.text-cyan{color:#00bcd4!important}.text-cyan.icon-outline{border-color:#00bcd4!important}.bg-cyan.lighten-5{background-color:#e0f7fa!important}.text-cyan.text-lighten-5{color:#e0f7fa!important}.text-cyan.text-lighten-5.icon-outline{border-color:#e0f7fa!important}.bg-cyan.lighten-4{background-color:#b2ebf2!important}.text-cyan.text-lighten-4{color:#b2ebf2!important}.text-cyan.text-lighten-4.icon-outline{border-color:#b2ebf2!important}.bg-cyan.lighten-3{background-color:#80deea!important}.text-cyan.text-lighten-3{color:#80deea!important}.text-cyan.text-lighten-3.icon-outline{border-color:#80deea!important}.bg-cyan.lighten-2{background-color:#4dd0e1!important}.text-cyan.text-lighten-2{color:#4dd0e1!important}.text-cyan.text-lighten-2.icon-outline{border-color:#4dd0e1!important}.bg-cyan.lighten-1{background-color:#26c6da!important}.text-cyan.text-lighten-1{color:#26c6da!important}.text-cyan.text-lighten-1.icon-outline{border-color:#26c6da!important}.bg-cyan.darken-1{background-color:#00acc1!important}.text-cyan.text-darken-1{color:#00acc1!important}.text-cyan.text-darken-1.icon-outline{border-color:#00acc1!important}.bg-cyan.darken-2{background-color:#0097a7!important}.text-cyan.text-darken-2{color:#0097a7!important}.text-cyan.text-darken-2.icon-outline{border-color:#0097a7!important}.bg-cyan.darken-3{background-color:#00838f!important}.text-cyan.text-darken-3{color:#00838f!important}.text-cyan.text-darken-3.icon-outline{border-color:#00838f!important}.bg-cyan.darken-4{background-color:#006064!important}.text-cyan.text-darken-4{color:#006064!important}.text-cyan.text-darken-4.icon-outline{border-color:#006064!important}.bg-cyan.accent-1{background-color:#84ffff!important}.text-cyan.text-accent-1{color:#84ffff!important}.text-cyan.text-accent-1.icon-outline{border-color:#84ffff!important}.bg-cyan.accent-2{background-color:#18ffff!important}.text-cyan.text-accent-2{color:#18ffff!important}.text-cyan.text-accent-2.icon-outline{border-color:#18ffff!important}.bg-cyan.accent-3{background-color:#00e5ff!important}.text-cyan.text-accent-3{color:#00e5ff!important}.text-cyan.text-accent-3.icon-outline{border-color:#00e5ff!important}.bg-cyan.accent-4{background-color:#00b8d4!important}.text-cyan.text-accent-4{color:#00b8d4!important}.text-cyan.text-accent-4.icon-outline{border-color:#00b8d4!important}.bg-teal{background-color:#009688!important}.text-teal{color:#009688!important}.text-teal.icon-outline{border-color:#009688!important}.bg-teal.lighten-5{background-color:#e0f2f1!important}.text-teal.text-lighten-5{color:#e0f2f1!important}.text-teal.text-lighten-5.icon-outline{border-color:#e0f2f1!important}.bg-teal.lighten-4{background-color:#b2dfdb!important}.text-teal.text-lighten-4{color:#b2dfdb!important}.text-teal.text-lighten-4.icon-outline{border-color:#b2dfdb!important}.bg-teal.lighten-3{background-color:#80cbc4!important}.text-teal.text-lighten-3{color:#80cbc4!important}.text-teal.text-lighten-3.icon-outline{border-color:#80cbc4!important}.bg-teal.lighten-2{background-color:#4db6ac!important}.text-teal.text-lighten-2{color:#4db6ac!important}.text-teal.text-lighten-2.icon-outline{border-color:#4db6ac!important}.bg-teal.lighten-1{background-color:#26a69a!important}.text-teal.text-lighten-1{color:#26a69a!important}.text-teal.text-lighten-1.icon-outline{border-color:#26a69a!important}.bg-teal.darken-1{background-color:#00897b!important}.text-teal.text-darken-1{color:#00897b!important}.text-teal.text-darken-1.icon-outline{border-color:#00897b!important}.bg-teal.darken-2{background-color:#00796b!important}.text-teal.text-darken-2{color:#00796b!important}.text-teal.text-darken-2.icon-outline{border-color:#00796b!important}.bg-teal.darken-3{background-color:#00695c!important}.text-teal.text-darken-3{color:#00695c!important}.text-teal.text-darken-3.icon-outline{border-color:#00695c!important}.bg-teal.darken-4{background-color:#004d40!important}.text-teal.text-darken-4{color:#004d40!important}.text-teal.text-darken-4.icon-outline{border-color:#004d40!important}.bg-teal.accent-1{background-color:#a7ffeb!important}.text-teal.text-accent-1{color:#a7ffeb!important}.text-teal.text-accent-1.icon-outline{border-color:#a7ffeb!important}.bg-teal.accent-2{background-color:#64ffda!important}.text-teal.text-accent-2{color:#64ffda!important}.text-teal.text-accent-2.icon-outline{border-color:#64ffda!important}.bg-teal.accent-3{background-color:#1de9b6!important}.text-teal.text-accent-3{color:#1de9b6!important}.text-teal.text-accent-3.icon-outline{border-color:#1de9b6!important}.bg-teal.accent-4{background-color:#00bfa5!important}.text-teal.text-accent-4{color:#00bfa5!important}.text-teal.text-accent-4.icon-outline{border-color:#00bfa5!important}.bg-green{background-color:#4caf50!important}.text-green{color:#4caf50!important}.text-green.icon-outline{border-color:#4caf50!important}.bg-green.lighten-5{background-color:#e8f5e9!important}.text-green.text-lighten-5{color:#e8f5e9!important}.text-green.text-lighten-5.icon-outline{border-color:#e8f5e9!important}.bg-green.lighten-4{background-color:#c8e6c9!important}.text-green.text-lighten-4{color:#c8e6c9!important}.text-green.text-lighten-4.icon-outline{border-color:#c8e6c9!important}.bg-green.lighten-3{background-color:#a5d6a7!important}.text-green.text-lighten-3{color:#a5d6a7!important}.text-green.text-lighten-3.icon-outline{border-color:#a5d6a7!important}.bg-green.lighten-2{background-color:#81c784!important}.text-green.text-lighten-2{color:#81c784!important}.text-green.text-lighten-2.icon-outline{border-color:#81c784!important}.bg-green.lighten-1{background-color:#66bb6a!important}.text-green.text-lighten-1{color:#66bb6a!important}.text-green.text-lighten-1.icon-outline{border-color:#66bb6a!important}.bg-green.darken-1{background-color:#43a047!important}.text-green.text-darken-1{color:#43a047!important}.text-green.text-darken-1.icon-outline{border-color:#43a047!important}.bg-green.darken-2{background-color:#388e3c!important}.text-green.text-darken-2{color:#388e3c!important}.text-green.text-darken-2.icon-outline{border-color:#388e3c!important}.bg-green.darken-3{background-color:#2e7d32!important}.text-green.text-darken-3{color:#2e7d32!important}.text-green.text-darken-3.icon-outline{border-color:#2e7d32!important}.bg-green.darken-4{background-color:#1b5e20!important}.text-green.text-darken-4{color:#1b5e20!important}.text-green.text-darken-4.icon-outline{border-color:#1b5e20!important}.bg-green.accent-1{background-color:#b9f6ca!important}.text-green.text-accent-1{color:#b9f6ca!important}.text-green.text-accent-1.icon-outline{border-color:#b9f6ca!important}.bg-green.accent-2{background-color:#69f0ae!important}.text-green.text-accent-2{color:#69f0ae!important}.text-green.text-accent-2.icon-outline{border-color:#69f0ae!important}.bg-green.accent-3{background-color:#00e676!important}.text-green.text-accent-3{color:#00e676!important}.text-green.text-accent-3.icon-outline{border-color:#00e676!important}.bg-green.accent-4{background-color:#00c853!important}.text-green.text-accent-4{color:#00c853!important}.text-green.text-accent-4.icon-outline{border-color:#00c853!important}.bg-light-green{background-color:#8bc34a!important}.text-light-green{color:#8bc34a!important}.text-light-green.icon-outline{border-color:#8bc34a!important}.bg-light-green.lighten-5{background-color:#f1f8e9!important}.text-light-green.text-lighten-5{color:#f1f8e9!important}.text-light-green.text-lighten-5.icon-outline{border-color:#f1f8e9!important}.bg-light-green.lighten-4{background-color:#dcedc8!important}.text-light-green.text-lighten-4{color:#dcedc8!important}.text-light-green.text-lighten-4.icon-outline{border-color:#dcedc8!important}.bg-light-green.lighten-3{background-color:#c5e1a5!important}.text-light-green.text-lighten-3{color:#c5e1a5!important}.text-light-green.text-lighten-3.icon-outline{border-color:#c5e1a5!important}.bg-light-green.lighten-2{background-color:#aed581!important}.text-light-green.text-lighten-2{color:#aed581!important}.text-light-green.text-lighten-2.icon-outline{border-color:#aed581!important}.bg-light-green.lighten-1{background-color:#9ccc65!important}.text-light-green.text-lighten-1{color:#9ccc65!important}.text-light-green.text-lighten-1.icon-outline{border-color:#9ccc65!important}.bg-light-green.darken-1{background-color:#7cb342!important}.text-light-green.text-darken-1{color:#7cb342!important}.text-light-green.text-darken-1.icon-outline{border-color:#7cb342!important}.bg-light-green.darken-2{background-color:#689f38!important}.text-light-green.text-darken-2{color:#689f38!important}.text-light-green.text-darken-2.icon-outline{border-color:#689f38!important}.bg-light-green.darken-3{background-color:#558b2f!important}.text-light-green.text-darken-3{color:#558b2f!important}.text-light-green.text-darken-3.icon-outline{border-color:#558b2f!important}.bg-light-green.darken-4{background-color:#33691e!important}.text-light-green.text-darken-4{color:#33691e!important}.text-light-green.text-darken-4.icon-outline{border-color:#33691e!important}.bg-light-green.accent-1{background-color:#ccff90!important}.text-light-green.text-accent-1{color:#ccff90!important}.text-light-green.text-accent-1.icon-outline{border-color:#ccff90!important}.bg-light-green.accent-2{background-color:#b2ff59!important}.text-light-green.text-accent-2{color:#b2ff59!important}.text-light-green.text-accent-2.icon-outline{border-color:#b2ff59!important}.bg-light-green.accent-3{background-color:#76ff03!important}.text-light-green.text-accent-3{color:#76ff03!important}.text-light-green.text-accent-3.icon-outline{border-color:#76ff03!important}.bg-light-green.accent-4{background-color:#64dd17!important}.text-light-green.text-accent-4{color:#64dd17!important}.text-light-green.text-accent-4.icon-outline{border-color:#64dd17!important}.bg-lime{background-color:#cddc39!important}.text-lime{color:#cddc39!important}.text-lime.icon-outline{border-color:#cddc39!important}.bg-lime.lighten-5{background-color:#f9fbe7!important}.text-lime.text-lighten-5{color:#f9fbe7!important}.text-lime.text-lighten-5.icon-outline{border-color:#f9fbe7!important}.bg-lime.lighten-4{background-color:#f0f4c3!important}.text-lime.text-lighten-4{color:#f0f4c3!important}.text-lime.text-lighten-4.icon-outline{border-color:#f0f4c3!important}.bg-lime.lighten-3{background-color:#e6ee9c!important}.text-lime.text-lighten-3{color:#e6ee9c!important}.text-lime.text-lighten-3.icon-outline{border-color:#e6ee9c!important}.bg-lime.lighten-2{background-color:#dce775!important}.text-lime.text-lighten-2{color:#dce775!important}.text-lime.text-lighten-2.icon-outline{border-color:#dce775!important}.bg-lime.lighten-1{background-color:#d4e157!important}.text-lime.text-lighten-1{color:#d4e157!important}.text-lime.text-lighten-1.icon-outline{border-color:#d4e157!important}.bg-lime.darken-1{background-color:#c0ca33!important}.text-lime.text-darken-1{color:#c0ca33!important}.text-lime.text-darken-1.icon-outline{border-color:#c0ca33!important}.bg-lime.darken-2{background-color:#afb42b!important}.text-lime.text-darken-2{color:#afb42b!important}.text-lime.text-darken-2.icon-outline{border-color:#afb42b!important}.bg-lime.darken-3{background-color:#9e9d24!important}.text-lime.text-darken-3{color:#9e9d24!important}.text-lime.text-darken-3.icon-outline{border-color:#9e9d24!important}.bg-lime.darken-4{background-color:#827717!important}.text-lime.text-darken-4{color:#827717!important}.text-lime.text-darken-4.icon-outline{border-color:#827717!important}.bg-lime.accent-1{background-color:#f4ff81!important}.text-lime.text-accent-1{color:#f4ff81!important}.text-lime.text-accent-1.icon-outline{border-color:#f4ff81!important}.bg-lime.accent-2{background-color:#eeff41!important}.text-lime.text-accent-2{color:#eeff41!important}.text-lime.text-accent-2.icon-outline{border-color:#eeff41!important}.bg-lime.accent-3{background-color:#c6ff00!important}.text-lime.text-accent-3{color:#c6ff00!important}.text-lime.text-accent-3.icon-outline{border-color:#c6ff00!important}.bg-lime.accent-4{background-color:#aeea00!important}.text-lime.text-accent-4{color:#aeea00!important}.text-lime.text-accent-4.icon-outline{border-color:#aeea00!important}.bg-yellow{background-color:#ffeb3b!important}.text-yellow{color:#ffeb3b!important}.text-yellow.icon-outline{border-color:#ffeb3b!important}.bg-yellow.lighten-5{background-color:#fffde7!important}.text-yellow.text-lighten-5{color:#fffde7!important}.text-yellow.text-lighten-5.icon-outline{border-color:#fffde7!important}.bg-yellow.lighten-4{background-color:#fff9c4!important}.text-yellow.text-lighten-4{color:#fff9c4!important}.text-yellow.text-lighten-4.icon-outline{border-color:#fff9c4!important}.bg-yellow.lighten-3{background-color:#fff59d!important}.text-yellow.text-lighten-3{color:#fff59d!important}.text-yellow.text-lighten-3.icon-outline{border-color:#fff59d!important}.bg-yellow.lighten-2{background-color:#fff176!important}.text-yellow.text-lighten-2{color:#fff176!important}.text-yellow.text-lighten-2.icon-outline{border-color:#fff176!important}.bg-yellow.lighten-1{background-color:#ffee58!important}.text-yellow.text-lighten-1{color:#ffee58!important}.text-yellow.text-lighten-1.icon-outline{border-color:#ffee58!important}.bg-yellow.darken-1{background-color:#fdd835!important}.text-yellow.text-darken-1{color:#fdd835!important}.text-yellow.text-darken-1.icon-outline{border-color:#fdd835!important}.bg-yellow.darken-2{background-color:#fbc02d!important}.text-yellow.text-darken-2{color:#fbc02d!important}.text-yellow.text-darken-2.icon-outline{border-color:#fbc02d!important}.bg-yellow.darken-3{background-color:#f9a825!important}.text-yellow.text-darken-3{color:#f9a825!important}.text-yellow.text-darken-3.icon-outline{border-color:#f9a825!important}.bg-yellow.darken-4{background-color:#f57f17!important}.text-yellow.text-darken-4{color:#f57f17!important}.text-yellow.text-darken-4.icon-outline{border-color:#f57f17!important}.bg-yellow.accent-1{background-color:#ffff8d!important}.text-yellow.text-accent-1{color:#ffff8d!important}.text-yellow.text-accent-1.icon-outline{border-color:#ffff8d!important}.bg-yellow.accent-2{background-color:#ff0!important}.text-yellow.text-accent-2{color:#ff0!important}.text-yellow.text-accent-2.icon-outline{border-color:#ff0!important}.bg-yellow.accent-3{background-color:#ffea00!important}.text-yellow.text-accent-3{color:#ffea00!important}.text-yellow.text-accent-3.icon-outline{border-color:#ffea00!important}.bg-yellow.accent-4{background-color:#ffd600!important}.text-yellow.text-accent-4{color:#ffd600!important}.text-yellow.text-accent-4.icon-outline{border-color:#ffd600!important}.bg-amber{background-color:#ffc107!important}.text-amber{color:#ffc107!important}.text-amber.icon-outline{border-color:#ffc107!important}.bg-amber.lighten-5{background-color:#fff8e1!important}.text-amber.text-lighten-5{color:#fff8e1!important}.text-amber.text-lighten-5.icon-outline{border-color:#fff8e1!important}.bg-amber.lighten-4{background-color:#ffecb3!important}.text-amber.text-lighten-4{color:#ffecb3!important}.text-amber.text-lighten-4.icon-outline{border-color:#ffecb3!important}.bg-amber.lighten-3{background-color:#ffe082!important}.text-amber.text-lighten-3{color:#ffe082!important}.text-amber.text-lighten-3.icon-outline{border-color:#ffe082!important}.bg-amber.lighten-2{background-color:#ffd54f!important}.text-amber.text-lighten-2{color:#ffd54f!important}.text-amber.text-lighten-2.icon-outline{border-color:#ffd54f!important}.bg-amber.lighten-1{background-color:#ffca28!important}.text-amber.text-lighten-1{color:#ffca28!important}.text-amber.text-lighten-1.icon-outline{border-color:#ffca28!important}.bg-amber.darken-1{background-color:#ffb300!important}.text-amber.text-darken-1{color:#ffb300!important}.text-amber.text-darken-1.icon-outline{border-color:#ffb300!important}.bg-amber.darken-2{background-color:#ffa000!important}.text-amber.text-darken-2{color:#ffa000!important}.text-amber.text-darken-2.icon-outline{border-color:#ffa000!important}.bg-amber.darken-3{background-color:#ff8f00!important}.text-amber.text-darken-3{color:#ff8f00!important}.text-amber.text-darken-3.icon-outline{border-color:#ff8f00!important}.bg-amber.darken-4{background-color:#ff6f00!important}.text-amber.text-darken-4{color:#ff6f00!important}.text-amber.text-darken-4.icon-outline{border-color:#ff6f00!important}.bg-amber.accent-1{background-color:#ffe57f!important}.text-amber.text-accent-1{color:#ffe57f!important}.text-amber.text-accent-1.icon-outline{border-color:#ffe57f!important}.bg-amber.accent-2{background-color:#ffd740!important}.text-amber.text-accent-2{color:#ffd740!important}.text-amber.text-accent-2.icon-outline{border-color:#ffd740!important}.bg-amber.accent-3{background-color:#ffc400!important}.text-amber.text-accent-3{color:#ffc400!important}.text-amber.text-accent-3.icon-outline{border-color:#ffc400!important}.bg-amber.accent-4{background-color:#ffab00!important}.text-amber.text-accent-4{color:#ffab00!important}.text-amber.text-accent-4.icon-outline{border-color:#ffab00!important}.bg-orange{background-color:#ff9800!important}.text-orange{color:#ff9800!important}.text-orange.icon-outline{border-color:#ff9800!important}.bg-orange.lighten-5{background-color:#fff3e0!important}.text-orange.text-lighten-5{color:#fff3e0!important}.text-orange.text-lighten-5.icon-outline{border-color:#fff3e0!important}.bg-orange.lighten-4{background-color:#ffe0b2!important}.text-orange.text-lighten-4{color:#ffe0b2!important}.text-orange.text-lighten-4.icon-outline{border-color:#ffe0b2!important}.bg-orange.lighten-3{background-color:#ffcc80!important}.text-orange.text-lighten-3{color:#ffcc80!important}.text-orange.text-lighten-3.icon-outline{border-color:#ffcc80!important}.bg-orange.lighten-2{background-color:#ffb74d!important}.text-orange.text-lighten-2{color:#ffb74d!important}.text-orange.text-lighten-2.icon-outline{border-color:#ffb74d!important}.bg-orange.lighten-1{background-color:#ffa726!important}.text-orange.text-lighten-1{color:#ffa726!important}.text-orange.text-lighten-1.icon-outline{border-color:#ffa726!important}.bg-orange.darken-1{background-color:#fb8c00!important}.text-orange.text-darken-1{color:#fb8c00!important}.text-orange.text-darken-1.icon-outline{border-color:#fb8c00!important}.bg-orange.darken-2{background-color:#f57c00!important}.text-orange.text-darken-2{color:#f57c00!important}.text-orange.text-darken-2.icon-outline{border-color:#f57c00!important}.bg-orange.darken-3{background-color:#ef6c00!important}.text-orange.text-darken-3{color:#ef6c00!important}.text-orange.text-darken-3.icon-outline{border-color:#ef6c00!important}.bg-orange.darken-4{background-color:#e65100!important}.text-orange.text-darken-4{color:#e65100!important}.text-orange.text-darken-4.icon-outline{border-color:#e65100!important}.bg-orange.accent-1{background-color:#ffd180!important}.text-orange.text-accent-1{color:#ffd180!important}.text-orange.text-accent-1.icon-outline{border-color:#ffd180!important}.bg-orange.accent-2{background-color:#ffab40!important}.text-orange.text-accent-2{color:#ffab40!important}.text-orange.text-accent-2.icon-outline{border-color:#ffab40!important}.bg-orange.accent-3{background-color:#ff9100!important}.text-orange.text-accent-3{color:#ff9100!important}.text-orange.text-accent-3.icon-outline{border-color:#ff9100!important}.bg-orange.accent-4{background-color:#ff6d00!important}.text-orange.text-accent-4{color:#ff6d00!important}.text-orange.text-accent-4.icon-outline{border-color:#ff6d00!important}.bg-deep-orange{background-color:#ff5722!important}.text-deep-orange{color:#ff5722!important}.text-deep-orange.icon-outline{border-color:#ff5722!important}.bg-deep-orange.lighten-5{background-color:#fbe9e7!important}.text-deep-orange.text-lighten-5{color:#fbe9e7!important}.text-deep-orange.text-lighten-5.icon-outline{border-color:#fbe9e7!important}.bg-deep-orange.lighten-4{background-color:#ffccbc!important}.text-deep-orange.text-lighten-4{color:#ffccbc!important}.text-deep-orange.text-lighten-4.icon-outline{border-color:#ffccbc!important}.bg-deep-orange.lighten-3{background-color:#ffab91!important}.text-deep-orange.text-lighten-3{color:#ffab91!important}.text-deep-orange.text-lighten-3.icon-outline{border-color:#ffab91!important}.bg-deep-orange.lighten-2{background-color:#ff8a65!important}.text-deep-orange.text-lighten-2{color:#ff8a65!important}.text-deep-orange.text-lighten-2.icon-outline{border-color:#ff8a65!important}.bg-deep-orange.lighten-1{background-color:#ff7043!important}.text-deep-orange.text-lighten-1{color:#ff7043!important}.text-deep-orange.text-lighten-1.icon-outline{border-color:#ff7043!important}.bg-deep-orange.darken-1{background-color:#f4511e!important}.text-deep-orange.text-darken-1{color:#f4511e!important}.text-deep-orange.text-darken-1.icon-outline{border-color:#f4511e!important}.bg-deep-orange.darken-2{background-color:#e64a19!important}.text-deep-orange.text-darken-2{color:#e64a19!important}.text-deep-orange.text-darken-2.icon-outline{border-color:#e64a19!important}.bg-deep-orange.darken-3{background-color:#d84315!important}.text-deep-orange.text-darken-3{color:#d84315!important}.text-deep-orange.text-darken-3.icon-outline{border-color:#d84315!important}.bg-deep-orange.darken-4{background-color:#bf360c!important}.text-deep-orange.text-darken-4{color:#bf360c!important}.text-deep-orange.text-darken-4.icon-outline{border-color:#bf360c!important}.bg-deep-orange.accent-1{background-color:#ff9e80!important}.text-deep-orange.text-accent-1{color:#ff9e80!important}.text-deep-orange.text-accent-1.icon-outline{border-color:#ff9e80!important}.bg-deep-orange.accent-2{background-color:#ff6e40!important}.text-deep-orange.text-accent-2{color:#ff6e40!important}.text-deep-orange.text-accent-2.icon-outline{border-color:#ff6e40!important}.bg-deep-orange.accent-3{background-color:#ff3d00!important}.text-deep-orange.text-accent-3{color:#ff3d00!important}.text-deep-orange.text-accent-3.icon-outline{border-color:#ff3d00!important}.bg-deep-orange.accent-4{background-color:#dd2c00!important}.text-deep-orange.text-accent-4{color:#dd2c00!important}.text-deep-orange.text-accent-4.icon-outline{border-color:#dd2c00!important}.bg-brown{background-color:#795548!important}.text-brown{color:#795548!important}.text-brown.icon-outline{border-color:#795548!important}.bg-brown.lighten-5{background-color:#efebe9!important}.text-brown.text-lighten-5{color:#efebe9!important}.text-brown.text-lighten-5.icon-outline{border-color:#efebe9!important}.bg-brown.lighten-4{background-color:#d7ccc8!important}.text-brown.text-lighten-4{color:#d7ccc8!important}.text-brown.text-lighten-4.icon-outline{border-color:#d7ccc8!important}.bg-brown.lighten-3{background-color:#bcaaa4!important}.text-brown.text-lighten-3{color:#bcaaa4!important}.text-brown.text-lighten-3.icon-outline{border-color:#bcaaa4!important}.bg-brown.lighten-2{background-color:#a1887f!important}.text-brown.text-lighten-2{color:#a1887f!important}.text-brown.text-lighten-2.icon-outline{border-color:#a1887f!important}.bg-brown.lighten-1{background-color:#8d6e63!important}.text-brown.text-lighten-1{color:#8d6e63!important}.text-brown.text-lighten-1.icon-outline{border-color:#8d6e63!important}.bg-brown.darken-1{background-color:#6d4c41!important}.text-brown.text-darken-1{color:#6d4c41!important}.text-brown.text-darken-1.icon-outline{border-color:#6d4c41!important}.bg-brown.darken-2{background-color:#5d4037!important}.text-brown.text-darken-2{color:#5d4037!important}.text-brown.text-darken-2.icon-outline{border-color:#5d4037!important}.bg-brown.darken-3{background-color:#4e342e!important}.text-brown.text-darken-3{color:#4e342e!important}.text-brown.text-darken-3.icon-outline{border-color:#4e342e!important}.bg-brown.darken-4{background-color:#3e2723!important}.text-brown.text-darken-4{color:#3e2723!important}.text-brown.text-darken-4.icon-outline{border-color:#3e2723!important}.bg-blue-grey{background-color:#607d8b!important}.text-blue-grey{color:#607d8b!important}.text-blue-grey.icon-outline{border-color:#607d8b!important}.bg-blue-grey.lighten-5{background-color:#eceff1!important}.text-blue-grey.text-lighten-5{color:#eceff1!important}.text-blue-grey.text-lighten-5.icon-outline{border-color:#eceff1!important}.bg-blue-grey.lighten-4{background-color:#cfd8dc!important}.text-blue-grey.text-lighten-4{color:#cfd8dc!important}.text-blue-grey.text-lighten-4.icon-outline{border-color:#cfd8dc!important}.bg-blue-grey.lighten-3{background-color:#b0bec5!important}.text-blue-grey.text-lighten-3{color:#b0bec5!important}.text-blue-grey.text-lighten-3.icon-outline{border-color:#b0bec5!important}.bg-blue-grey.lighten-2{background-color:#90a4ae!important}.text-blue-grey.text-lighten-2{color:#90a4ae!important}.text-blue-grey.text-lighten-2.icon-outline{border-color:#90a4ae!important}.bg-blue-grey.lighten-1{background-color:#78909c!important}.text-blue-grey.text-lighten-1{color:#78909c!important}.text-blue-grey.text-lighten-1.icon-outline{border-color:#78909c!important}.bg-blue-grey.darken-1{background-color:#546e7a!important}.text-blue-grey.text-darken-1{color:#546e7a!important}.text-blue-grey.text-darken-1.icon-outline{border-color:#546e7a!important}.bg-blue-grey.darken-2{background-color:#455a64!important}.text-blue-grey.text-darken-2{color:#455a64!important}.text-blue-grey.text-darken-2.icon-outline{border-color:#455a64!important}.bg-blue-grey.darken-3{background-color:#37474f!important}.text-blue-grey.text-darken-3{color:#37474f!important}.text-blue-grey.text-darken-3.icon-outline{border-color:#37474f!important}.bg-blue-grey.darken-4{background-color:#263238!important}.text-blue-grey.text-darken-4{color:#263238!important}.text-blue-grey.text-darken-4.icon-outline{border-color:#263238!important}.bg-grey{background-color:#9e9e9e!important}.text-grey{color:#9e9e9e!important}.text-grey.icon-outline{border-color:#9e9e9e!important}.bg-grey.lighten-5{background-color:#fafafa!important}.text-grey.text-lighten-5{color:#fafafa!important}.text-grey.text-lighten-5.icon-outline{border-color:#fafafa!important}.bg-grey.lighten-4{background-color:#f5f5f5!important}.text-grey.text-lighten-4{color:#f5f5f5!important}.text-grey.text-lighten-4.icon-outline{border-color:#f5f5f5!important}.bg-grey.lighten-3{background-color:#eee!important}.text-grey.text-lighten-3{color:#eee!important}.text-grey.text-lighten-3.icon-outline{border-color:#eee!important}.bg-grey.lighten-2{background-color:#e0e0e0!important}.text-grey.text-lighten-2{color:#e0e0e0!important}.text-grey.text-lighten-2.icon-outline{border-color:#e0e0e0!important}.bg-grey.lighten-1{background-color:#bdbdbd!important}.text-grey.text-lighten-1{color:#bdbdbd!important}.text-grey.text-lighten-1.icon-outline{border-color:#bdbdbd!important}.bg-grey.darken-1{background-color:#757575!important}.text-grey.text-darken-1{color:#757575!important}.text-grey.text-darken-1.icon-outline{border-color:#757575!important}.bg-grey.darken-2{background-color:#616161!important}.text-grey.text-darken-2{color:#616161!important}.text-grey.text-darken-2.icon-outline{border-color:#616161!important}.bg-grey.darken-3{background-color:#424242!important}.text-grey.text-darken-3{color:#424242!important}.text-grey.text-darken-3.icon-outline{border-color:#424242!important}.bg-grey.darken-4{background-color:#212121!important}.text-grey.text-darken-4{color:#212121!important}.text-grey.text-darken-4.icon-outline{border-color:#212121!important}.bg-black{background-color:#000!important}.text-black{color:#000!important}.text-black.icon-outline{border-color:#000!important}.bg-white{background-color:#fff!important}.text-white{color:#fff!important}.text-white.icon-outline{border-color:#fff!important}.bg-transparent{background-color:transparent!important}.text-transparent{color:transparent!important}.text-transparent.icon-outline{border-color:transparent!important}@keyframes flipCenter{0%{animation-timing-function:ease-in;opacity:0;transform:perspective(100000px) rotateX(90deg)}40%{animation-timing-function:ease-in;transform:perspective(100000px) rotateX(0deg)}60%{opacity:1;transform:perspective(100000px) rotateX(0deg)}80%{transform:perspective(100000px) rotateX(0deg)}to{transform:perspective(100000px)}}@-webkit-keyframes flipCenter{0%{animation-timing-function:ease-in;opacity:0;transform:perspective(100000px) rotateX(90deg)}40%{animation-timing-function:ease-in;transform:perspective(100000px) rotateX(0deg)}60%{opacity:1;transform:perspective(100000px) rotateX(0deg)}80%{transform:perspective(100000px) rotateX(0deg)}to{transform:perspective(100000px)}}.flipCenter{animation-name:flipCenter;backface-visibility:visible}@keyframes desployDown{0%{transform:scaleY(0);transform-origin:center top 0}to{opacity:1;transform:scaleY(1);transform-origin:center top 0}}@-webkit-keyframes desployDown{0%{transform:scaleY(0);transform-origin:center top 0}to{opacity:1;transform:scaleY(1);transform-origin:center top 0}}.desployDown{animation-name:desployDown;backface-visibility:visible}@keyframes fadeInRightTiny{0%{opacity:0;transform:translate3d(30%,0,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeInRightTiny{0%{opacity:0;transform:translate3d(30%,0,0)}to{opacity:1;transform:none}}.fadeInRightTiny{animation-name:fadeInRightTiny}@keyframes fadeInLeftTiny{0%{opacity:0;transform:translate3d(-30%,0,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeInLeftTiny{0%{opacity:0;transform:translate3d(-30%,0,0)}to{opacity:1;transform:none}}.fadeInLeftTiny{animation-name:fadeInLeftTiny}@keyframes slideInRightTiny{0%{transform:translate3d(30%,0,0)}to{transform:none}}@-webkit-keyframes slideInRightTiny{0%{transform:translate3d(30%,0,0)}to{transform:none}}.slideInRightTiny{animation-name:slideInRightTiny}@keyframes slideInLeftTiny{0%{transform:translate3d(-30%,0,0)}to{transform:none}}@-webkit-keyframes slideInLeftTiny{0%{transform:translate3d(-30%,0,0)}to{transform:none}}.slideInLeftTiny{animation-name:slideInLeftTiny}@keyframes slideInUpTiny{0%{transform:translate3d(0,5%,0)}to{transform:none}}@-webkit-keyframes slideInUpTiny{0%{transform:translate3d(0,5%,0)}to{transform:none}}.slideInUpTiny{animation-name:slideInUpTiny}.animation-duration-1{animation-duration:.1s}.animation-duration-2{animation-duration:.2s}.animation-duration-3{animation-duration:.3s}.animation-duration-4{animation-duration:.4s}.animation-duration-5{animation-duration:.5s}.animation-duration-6{animation-duration:.6s}.animation-duration-7{animation-duration:.7s}.animation-duration-8{animation-duration:.8s}.animation-duration-9{animation-duration:.9s}.animation-duration-10{animation-duration:1s}.animation-duration-11{animation-duration:1.1s}.animation-duration-12{animation-duration:1.2s}.animation-duration-13{animation-duration:1.3s}.animation-duration-14{animation-duration:1.4s}.animation-duration-15{animation-duration:1.5s}.animation-duration-16{animation-duration:1.6s}.animation-duration-17{animation-duration:1.7s}.animation-duration-18{animation-duration:1.8s}.animation-duration-19{animation-duration:1.9s}.animation-duration-20{animation-duration:2s}.animation-duration-21{animation-duration:2.1s}.animation-duration-22{animation-duration:2.2s}.animation-duration-23{animation-duration:2.3s}.animation-duration-24{animation-duration:2.4s}.animation-duration-25{animation-duration:2.5s}.animation-duration-26{animation-duration:2.6s}.animation-duration-27{animation-duration:2.7s}.animation-duration-28{animation-duration:2.8s}.animation-duration-29{animation-duration:2.9s}.animation-duration-30{animation-duration:3s}.animation-duration-31{animation-duration:3.1s}.animation-duration-32{animation-duration:3.2s}.animation-duration-33{animation-duration:3.3s}.animation-duration-34{animation-duration:3.4s}.animation-duration-35{animation-duration:3.5s}.animation-duration-36{animation-duration:3.6s}.animation-duration-37{animation-duration:3.7s}.animation-duration-38{animation-duration:3.8s}.animation-duration-39{animation-duration:3.9s}.animation-duration-40{animation-duration:4s}.animation-delay-1{animation-delay:.1s}.animation-delay-2{animation-delay:.2s}.animation-delay-3{animation-delay:.3s}.animation-delay-4{animation-delay:.4s}.animation-delay-5{animation-delay:.5s}.animation-delay-6{animation-delay:.6s}.animation-delay-7{animation-delay:.7s}.animation-delay-8{animation-delay:.8s}.animation-delay-9{animation-delay:.9s}.animation-delay-10{animation-delay:1s}.animation-delay-11{animation-delay:1.1s}.animation-delay-12{animation-delay:1.2s}.animation-delay-13{animation-delay:1.3s}.animation-delay-14{animation-delay:1.4s}.animation-delay-15{animation-delay:1.5s}.animation-delay-16{animation-delay:1.6s}.animation-delay-17{animation-delay:1.7s}.animation-delay-18{animation-delay:1.8s}.animation-delay-19{animation-delay:1.9s}.animation-delay-20{animation-delay:2s}.animation-delay-21{animation-delay:2.1s}.animation-delay-22{animation-delay:2.2s}.animation-delay-23{animation-delay:2.3s}.animation-delay-24{animation-delay:2.4s}.animation-delay-25{animation-delay:2.5s}.animation-delay-26,.animation-delay-27{animation-delay:2.6s}.animation-delay-28{animation-delay:2.8s}.animation-delay-29{animation-delay:2.9s}.animation-delay-30{animation-delay:3s}.animation-delay-31{animation-delay:3.1s}.animation-delay-32{animation-delay:3.2s}.animation-delay-33{animation-delay:3.3s}.animation-delay-34{animation-delay:3.4s}.animation-delay-35{animation-delay:3.5s}.animation-delay-36{animation-delay:3.6s}.animation-delay-37{animation-delay:3.7s}.animation-delay-38{animation-delay:3.8s}.animation-delay-39{animation-delay:3.9s}.animation-delay-40{animation-delay:4s}.animation-delay-41{animation-delay:4.1s}.animation-delay-42{animation-delay:4.2s}.animation-delay-43{animation-delay:4.3s}.animation-delay-44{animation-delay:4.4s}.animation-delay-45{animation-delay:4.5s}.animation-delay-46{animation-delay:4.6s}.animation-delay-47{animation-delay:4.7s}.animation-delay-48{animation-delay:4.8s}.animation-delay-49{animation-delay:4.9s}.animation-delay-50{animation-delay:5s}@font-face{font-family:aguda_blackregular;src:url(" + escape(__webpack_require__(1307)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1308)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:aguda_black_unicaseregular;src:url(" + escape(__webpack_require__(1309)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1310)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:aguda_boldregular1;src:url(" + escape(__webpack_require__(1311)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1312)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:aguda_bold_unicaseregular;src:url(" + escape(__webpack_require__(1313)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1314)) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:font-awesome;src:url(" + escape(__webpack_require__(1315)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(1316)) + ") format(\"woff\");font-weight:400;font-style:normal}body,html{height:100%}body{font-family:Roboto Regular,sans-serif;font-size:14px;font-weight:400;color:#212529;background-color:#f8f9fa;overflow:hidden}body.ios-mobile-view-height{height:auto!important;overflow:visible!important}#nprogress .bar{z-index:5000!important;background:#e91e63!important}#nprogress .peg{-webkit-box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important;-moz-box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important;-o-box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important;box-shadow:0 0 10px #e91e63,0 0 5px #e91e63!important}#nprogress .spinner{z-index:5000!important}#nprogress .spinner-icon{border-top-color:#e91e63!important;border-left-color:#e91e63!important}.text-transform-none{text-transform:none}.br-break{word-break:break-all!important}.font-weight-semibold{font-weight:500!important}.z-index-20{z-index:20}.border-bottom{border-bottom:1px solid #dee2e6}div[tabindex=\"-1\"]{z-index:1500!important}.col-with-divider div[class*=col-]{border-left:1px solid #dee2e6}.col-with-divider div[class*=col-]:first-child{border:0 none}.height-100{height:100px!important}.height-150{height:150px!important}.height-200{height:200px!important}.max-width-100{max-width:100px!important}.max-height-120{max-height:120px!important}.right-arrow{display:inline-block;color:#3f51b5;text-transform:capitalize}.right-arrow:after{content:\"\\F30F\";font-family:Material-Design-Iconic-Font;color:#3f51b5;margin-left:8px;font-size:20px;vertical-align:middle}.right-arrow:focus,.right-arrow:hover{text-decoration:none}.letter-spacing-base{letter-spacing:3px}.letter-spacing-lg{letter-spacing:6px}.letter-spacing-xl{letter-spacing:8px}.page-heading{margin-bottom:36px;padding:18px 24px}.page-heading .title{text-transform:capitalize}.page-heading .breadcrumb{padding:0!important;background-color:transparent!important;margin-bottom:0}@media screen and (max-width:575px){.page-heading{margin-bottom:18px}}.sub-heading{font-size:14px;color:#6c757d;margin-bottom:0}.sub-heading:not(:last-child){margin-bottom:16px!important}.manage-margin{margin-bottom:0}.manage-margin>*{margin-bottom:6px}.manage-margin>:not(:last-child){margin-right:16px}.no-shadow{-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.shadow-sm{-webkit-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);box-shadow:0 1px 2px 0 rgba(0,0,0,.15)}.shadow{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.shadow-lg{-webkit-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-moz-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-o-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);box-shadow:0 1px 8px -1px rgba(0,0,0,.2)}.shadow-xl{-webkit-box-shadow:0 0 16px 0 rgba(0,0,0,.2);-moz-box-shadow:0 0 16px 0 rgba(0,0,0,.2);-o-box-shadow:0 0 16px 0 rgba(0,0,0,.2);box-shadow:0 0 16px 0 rgba(0,0,0,.2)}.avatar-shadow{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.5);-moz-box-shadow:0 1px 3px 0 rgba(0,0,0,.5);-o-box-shadow:0 1px 3px 0 rgba(0,0,0,.5);box-shadow:0 1px 3px 0 rgba(0,0,0,.5)}.remove-table-border td,.remove-table-border th{border:0 none}.media-list{margin-bottom:10px}.media-list:not(:last-child){border-bottom:1px solid #e9ecef;padding-bottom:15px;margin-bottom:20px;position:relative}.border-2{border:2px solid #ced4da!important}.border-w2{border-width:2px}.border-primary{border-color:#3f51b5!important}.border-red{border-color:#f44336!important}.border-pink{border-color:#e91e63!important}.border-purple{border-color:#9c27b0!important}.border-deep-purple{border-color:#673ab7!important}.border-indigo{border-color:#3f51b5!important}.border-blue{border-color:#2196f3!important}.border-light-blue{border-color:#03a9f4!important}.border-cyan{border-color:#00bcd4!important}.border-teal{border-color:#009688!important}.border-green{border-color:#4caf50!important}.border-light-green{border-color:#8bc34a!important}.border-lime{border-color:#cddc39!important}.border-yellow{border-color:#ffeb3b!important}.border-amber{border-color:#ffc107!important}.border-orange{border-color:#ff9800!important}.border-deep-orange{border-color:#ff5722!important}.border-brown{border-color:#795548!important}.border-blue-grey{border-color:#607d8b!important}.border-grey{border-color:#9e9e9e!important}.center-crop-img{position:relative;width:100%;min-height:120px;overflow:hidden}.center-crop-img img{position:absolute;left:50%;top:50%;height:100%;width:auto;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.center-crop-img img.portrait{width:100%;height:auto}.pointer{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-weight:50;margin:0 0 12px;color:inherit}.h1,h1{font-size:24px}.h2,h2{font-size:20px}.h3,.h4,h3,h4{font-size:15px}.h5,h5{font-size:13px}.h6,h6{font-size:12px}.text-strikethrough{text-decoration:line-through!important}@media screen and (max-width:991px){.h1,h1{font-size:20px}.h2,.h3,h2,h3{font-size:15px}}.desc-list{margin-bottom:0}.desc-list li{padding:18px 24px;border-bottom:1px solid #adb5bd;margin-left:-24px;margin-right:-24px}.desc-list li:last-child{border-bottom:0 none}.desc-list li .card-title{margin-bottom:6px}.desc-list.even-odd li{border-bottom:0 none}.desc-list.even-odd li:nth-child(2n){background-color:#dee2e6}#app-site,.app-main{display:flex;width:100%;height:100%}.app-container{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;width:100%}.app-container,.app-sidebar{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.app-sidebar{width:280px;min-width:280px;max-width:280px}.app-main-container,.app-sidebar{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.app-main-container{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;overflow:hidden}.app-header{min-height:70px}.app-main-content-wrapper{flex:1;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;overflow-x:hidden;overflow-y:auto}.app-container.fixed-drawer .app-main-header{width:auto!important;-webkit-transition:all .5s cubic-bezier(0,0,.2,1)!important;-o-transition:all .5s cubic-bezier(0,0,.2,1)!important;transition:all .5s cubic-bezier(0,0,.2,1)!important;left:0;right:0}@media screen and (max-width:1199px){.app-container.fixed-drawer .app-main-header{left:0;right:0}}.app-container.collapsible-drawer .app-main-header{left:0}.app-container.collapsible-drawer .app-main-header,.app-container.mini-drawer .app-main-header{width:auto!important;-webkit-transition:all .5s cubic-bezier(0,0,.2,1)!important;-o-transition:all .5s cubic-bezier(0,0,.2,1)!important;transition:all .5s cubic-bezier(0,0,.2,1)!important;right:0}.app-container.mini-drawer .app-main-header{left:80px}.app-container.mini-drawer .app-sidebar{width:80px;min-width:80px;max-width:80px}.jr-menu-icon{outline:none!important;-webkit-justify-content:flex-start!important;justify-content:flex-start!important;padding:0 5px!important;margin-right:15px}.app-main-header{background-color:#3f51b5!important;color:#fff!important}.app-main-header .search-bar input{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;background-color:#4d5ec1;color:#fff}.app-main-header .search-bar input+.search-icon{top:0}.app-main-header .search-bar input+.search-icon i{color:#000}.app-main-header .search-bar input:focus{background-color:#fff;color:#212529}.app-main-header .search-bar input:focus+.search-icon i{color:\"#000\"}.app-logo img{height:35px}@media screen and (max-width:575px){.app-logo img{height:28px}}.app-toolbar{min-height:70px;height:70px;max-height:70px}.app-toolbar .search-bar{margin-left:100px;margin-right:auto;max-width:400px;width:380px}@media screen and (max-width:991px){.app-toolbar .search-bar{width:280px}}@media screen and (max-width:767px){.app-toolbar .search-bar{margin-left:40px;width:200px}}.app-toolbar .nav-searchbox .search-bar{margin-left:0;width:100%}.app-toolbar .nav-searchbox .search-bar input{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;background-color:#fff;color:#212529}.app-toolbar .nav-searchbox .search-bar input+.search-icon i{color:#000}.app-toolbar .nav-searchbox .search-bar input:focus{background-color:transparent;color:#212529}.app-toolbar .nav-searchbox .search-bar input:focus+.search-icon i{color:#000}.header-notifications{margin-bottom:0}.header-notifications li{vertical-align:middle}.quick-menu .dropdown-menu{padding:5px 10px;width:350px}.quick-menu .dropdown-menu .jr-card-header{margin:-5px -10px 5px;padding:10px 10px 10px 20px;-webkit-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 2px 0 rgba(0,0,0,.15);box-shadow:0 1px 2px 0 rgba(0,0,0,.15);z-index:10}.quick-menu .dropdown-menu:after{border-bottom:5px solid #fff;top:-9px;height:9px}.quick-menu .dropdown-menu:after,.quick-menu .dropdown-menu:before{border-left:5px solid transparent;border-right:5px solid transparent;content:\"\";position:absolute;right:8px;width:10px}.quick-menu .dropdown-menu:before{border-bottom:5px solid #000;top:-10px;height:10px}@media screen and (max-width:449px){.quick-menu .dropdown-menu{width:280px}}@media screen and (max-width:359px){.quick-menu .dropdown-menu{width:240px}}.quick-menu .messages-list .user-avatar{position:relative}.quick-menu .messages-list .badge{position:absolute;left:-4px;top:-4px;height:16px;width:16px;line-height:16px;text-align:center;padding:0}@media screen and (max-width:575px){.nav-searchbox.quick-menu .dropdown-menu{width:200px}}@media screen and (max-width:399px){.nav-searchbox.quick-menu .dropdown-menu{width:100px}}.messages-list.language-list ul li{padding:7px 6px 6px}.messages-list ul li{position:relative;padding:20px 10px 14px;border:1px solid #dee2e6;background-color:#38414b;cursor:pointer}.messages-list ul li .user-name a{color:#3f51b5}.messages-list ul li .sub-heading{font-size:11px;margin-bottom:6px!important}.messages-list ul li .sub-heading.mb-0{margin-bottom:0!important}.messages-list ul li:last-child{border-bottom:0 none}.messages-list ul li .jr-btn{margin-right:0!important}.messages-list ul li .jr-btn-xs{font-size:11px!important;padding:5px!important}.quick-menu .icon-btn{color:#fff}.quick-menu .icon-alert{position:relative}.quick-menu .icon-alert:after{display:block;position:absolute;content:\"\";right:0;top:0;z-index:10;width:8px;height:8px;background-color:#f44336;border-radius:50%}.quick-menu i.animated.infinite{-moz-animation-iteration-count:25;-webkit-animation-iteration-count:25;-o-animation-iteration-count:25;animation-iteration-count:25}.quick-menu .dropdown-menu{display:block;visibility:hidden;left:auto!important;right:0!important;opacity:0;transform:translate3d(0,100px,0)!important;-webkit-transition:all .2s linear 0ms;-o-transition:all .2s linear 0ms;transition:all .2s linear 0ms}.quick-menu.show .dropdown-menu{opacity:1;transform:translate3d(0,30px,0)!important;visibility:visible}.app-main-content{flex:1;width:100%}.app-wrapper{padding:24px;width:100%}@media screen and (max-width:575px){.app-wrapper{padding:20px}}.app-footer{padding:0 24px;-webkit-box-shadow:0 -1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 -1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 -1px 4px 0 rgba(0,0,0,.15);box-shadow:0 -1px 4px 0 rgba(0,0,0,.15);background-color:#f8f9fa;line-height:50px;min-height:50px;height:50px;max-height:50px}.app-footer,.app-footer a{color:#a1a1a1}.app-footer a:hover{color:#fff}@media screen and (max-width:400px){.app-footer{font-size:12px;padding:0 20px}}.app-sidebar-content.right-sidebar{z-index:1501!important}.color-theme{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;max-width:300px;height:100%}@media screen and (max-width:499px){.color-theme{max-width:250px}}.color-theme-header{background-color:#3f51b5;color:#fff;padding:16px 25px;text-transform:uppercase;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.color-theme-header .color-theme-title{margin-bottom:0}@media screen and (max-width:499px){.color-theme-header{padding:16px 15px}}.color-theme-body{padding:28px 25px}.color-theme-body h3{margin-bottom:20px}@media screen and (max-width:499px){.color-theme-body{padding:25px 15px}}.color-option{list-style:none;padding-left:0;margin:0 -7px 10px}.color-option li{position:relative;display:inline-block;padding:0 7px;margin-bottom:10px}.color-option li a{height:45px;width:45px;line-height:45px;display:inline-block;color:transparent!important;position:relative}.color-option li a:before{content:\"\\F26B\";font-family:Material-Design-Iconic-Font;font-size:20px;height:45px;width:45px;line-height:45px;position:absolute;top:0;left:0;color:#fff;text-align:center;display:none;z-index:2}.color-option li a.active:before{display:block}.cr-op-dark-sidebar li a:after{content:\"\";position:absolute;left:0;top:0;bottom:0;z-index:1;background-color:#212529;width:8px}.theme-option{position:fixed;top:30%;right:0;z-index:1500;background-color:#9c27b0;border-top-left-radius:2px;border-bottom-left-radius:2px;-webkit-box-shadow:1px 1px 4px rgba(0,0,0,.5);-moz-box-shadow:1px 1px 4px rgba(0,0,0,.5);-o-box-shadow:1px 1px 4px rgba(0,0,0,.5);box-shadow:1px 1px 4px rgba(0,0,0,.5);color:#fff}@media screen and (max-width:499px){.color-theme .jr-btn{padding:10px 15px!important}}.alert{border:0 none;padding:20px 24px;border-radius:2px;position:relative}.alert .close{line-height:inherit;font-weight:300}.alert .alert-addon{width:60px;background-color:rgba(0,0,0,.2);display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center;position:absolute;left:0;top:0;bottom:0;z-index:1}.alert-dismissible{padding-right:60px}.alert-addon-card{padding-left:80px}.user-avatar{margin-right:8px}.user-avatar img{max-width:100%;height:auto}.user-detail .user-name{margin-bottom:2px;font-weight:400;text-transform:capitalize}.user-detail .user-description{font-size:13px;margin-bottom:0;color:#6c757d}.badge{font-weight:400;padding:3px 8px;line-height:inherit;margin-bottom:6px;border-radius:2px}.badge:not(:last-child){margin-right:15px}table .badge{margin-bottom:0}.badge-pill{border-radius:20px}.badge-border{border:2px solid!important}blockquote{padding:10px 0 10px 20px}blockquote,blockquote .blockquote-footer{font-size:14px!important}.blockquote{border-left:5px solid #e9ecef}.blockquote-reverse{border-left:0 none;border-right:5px solid #e9ecef;text-align:right;padding-left:0;padding-right:20px}.bottom-navigation button{min-width:10px!important}.breadcrumb{border-radius:2px}.breadcrumb-item+.breadcrumb-item:before{content:\"\\F2FB\";font-family:Material-Design-Iconic-Font;font-size:16px;line-height:1;vertical-align:middle}button{outline:0 none!important;cursor:pointer}.btn,.jr-btn{position:relative;min-width:10px!important;min-height:10px!important;font-size:14px!important;font-weight:400!important;text-transform:capitalize!important;line-height:1.2!important;border-radius:2px!important;cursor:pointer}.btn:active,.btn:focus{outline:0 none!important;-webkit-box-shadow:none!important;-moz-box-shadow:none!important;-o-box-shadow:none!important;box-shadow:none!important}.text-uppercase{text-transform:uppercase!important}.btn,.jr-btn,.jr-fab-btn{margin-bottom:6px}.btn:not(:last-child),.jr-btn:not(:last-child),.jr-fab-btn:not(:last-child){margin-right:15px}.jr-fab-btn{min-height:10px!important}.jr-btn{padding:12px 20px!important}.jr-btn i+span,.jr-btn span+i{margin-left:6px}.jr-btn-group{margin:0 -10px}.jr-btn-group:not(:last-child){margin-bottom:16px}.jr-btn-group .jr-btn,.jr-btn-group .jr-fab-btn{margin:0 10px 18px}.jr-btn-rounded{border-radius:50px!important}.btn-group-lg>.jr-btn,.jr-btn-lg{padding:16px 24px!important}.btn-group-sm>.jr-btn,.jr-btn-sm{padding:8px 15px!important}.jr-btn-xs{padding:6px 10px!important}.btn-group-lg>.jr-btn,.jr-btn-fab-lg,.jr-btn-lg{font-size:18px!important}.btn-group-lg>.jr-btn i,.jr-btn-fab-lg i,.jr-btn-lg i{font-size:20px!important}.btn-group-sm>.jr-btn,.btn-group-sm>.jr-btn i,.jr-btn-fab-sm,.jr-btn-fab-sm i,.jr-btn-sm,.jr-btn-sm i{font-size:14px!important}.jr-btn-fab-xs,.jr-btn-fab-xs i,.jr-btn-xs,.jr-btn-xs i{font-size:10px!important}.complex-btn-wrapper{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;min-width:200px;width:100%}.complex-btn{position:relative;height:200px;overflow:hidden}@media screen and (max-width:767px){.complex-btn{width:100%!important;height:100px!important}}.complex-btn:hover{z-index:1}.complex-btn:hover .img-btn-overlay{opacity:.15}.complex-btn:hover .img-marked{opacity:0}.complex-btn:hover .img-title{border:4px solid currentColor}.complex-btn .img-btn{display:flex;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;color:#fff}.complex-btn .img-btn,.complex-btn .img-src{position:absolute;left:0;right:0;top:0;bottom:0}.complex-btn .img-src{background-size:cover;background-position:center 40%}.complex-btn .img-btn-overlay{position:absolute;left:0;right:0;top:0;bottom:0;background:#000;opacity:.4;-webkit-transition:all .5s cubic-bezier(.4,0,.2,1);-o-transition:all .5s cubic-bezier(.4,0,.2,1);transition:all .5s cubic-bezier(.4,0,.2,1)}.complex-btn .img-title{position:relative;padding:16px 32px 14px}.complex-btn .img-marked{height:3px;width:18px;background:#fff;position:absolute;bottom:-2px;left:calc(50% - 9px);-webkit-transition:all .5s cubic-bezier(.4,0,.2,1);-o-transition:all .5s cubic-bezier(.4,0,.2,1);transition:all .5s cubic-bezier(.4,0,.2,1)}.btn-group-mins{margin:0 -5px}.btn-group-mins .btn,.btn-group-mins .jr-btn{margin:0 5px 5px}.jr-btn.jr-btn-label i{background-color:hsla(0,0%,100%,.2);width:40px;height:100%;line-height:42px}.jr-btn.jr-btn-label.left i{position:absolute;top:0;left:0;bottom:0;z-index:1}.jr-btn.jr-btn-label.right i{position:absolute;top:0;right:0;bottom:0;z-index:1}.jr-btn.jr-btn-label.left i+span{margin-left:30px}.jr-btn.jr-btn-label.right i+span{margin-right:30px;margin-left:0}.btn-group-lg>.jr-btn.jr-btn-label i,.jr-btn.jr-btn-label.jr-btn-lg i{line-height:54px}.btn-group-sm>.jr-btn.jr-btn-label i,.jr-btn.jr-btn-label.jr-btn-sm i{line-height:32px}.jr-btn.jr-btn-label.jr-btn-xs i{line-height:24px;width:30px}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.jr-btn,.btn-group>.jr-btn{position:relative;flex:0 1 auto}.btn-group-vertical>.jr-btn.active,.btn-group-vertical>.jr-btn:active,.btn-group-vertical>.jr-btn:focus,.btn-group-vertical>.jr-btn:hover,.btn-group>.jr-btn.active,.btn-group>.jr-btn:active,.btn-group>.jr-btn:focus,.btn-group>.jr-btn:hover{z-index:2}.btn-group-vertical .btn-group+.btn-group,.btn-group-vertical .btn-group+.jr-btn,.btn-group-vertical .jr-btn+.jr-btn,.btn-group-vertical .jr-btn+.jr-btn-group,.btn-group .btn-group+.btn-group,.btn-group .btn-group+.jr-btn,.btn-group .jr-btn+.jr-btn,.btn-group .jr-btn+.jr-btn-group{margin-left:-1px}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0!important}.btn-group>.jr-btn:first-child{margin-left:0}.btn-group>.jr-btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0!important;border-bottom-right-radius:0!important}.btn-group>.dropdown-toggle:not(:first-child),.btn-group>.jr-btn:last-child:not(:first-child){border-top-left-radius:0!important;border-bottom-left-radius:0!important}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.jr-btn{border-radius:0!important}.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle,.btn-group>.btn-group:first-child:not(:last-child)>.jr-btn:last-child{border-top-right-radius:0!important;border-bottom-right-radius:0!important}.btn-group>.btn-group:last-child:not(:first-child)>.jr-btn:first-child{border-top-left-radius:0!important;border-bottom-left-radius:0!important}.jr-btn+.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.jr-btn+.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.jr-btn+.dropdown-toggle-split,.jr-btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.jr-btn+.dropdown-toggle-split,.jr-btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group.show .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);-o-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.show .dropdown-toggle.btn-link{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical .btn-group,.btn-group-vertical .jr-btn{width:100%}.btn-group-vertical>.btn-group+.btn-group,.btn-group-vertical>.btn-group+.jr-btn,.btn-group-vertical>.jr-btn+.btn-group,.btn-group-vertical>.jr-btn+.jr-btn{margin-top:-1px;margin-left:0}.btn-group-vertical>.jr-btn:not(:first-child):not(:last-child){border-radius:0!important}.btn-group-vertical>.jr-btn:first-child:not(:last-child){border-bottom-right-radius:0!important;border-bottom-left-radius:0!important}.btn-group-vertical>.jr-btn:last-child:not(:first-child){border-top-left-radius:0!important;border-top-right-radius:0!important}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.jr-btn{border-radius:0!important}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.jr-btn:last-child{border-bottom-right-radius:0!important;border-bottom-left-radius:0!important}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.jr-btn:first-child{border-top-left-radius:0!important;border-top-right-radius:0!important}[data-toggle=buttons]>.btn-group>.jr-btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.jr-btn input[type=radio],[data-toggle=buttons]>.jr-btn input[type=checkbox],[data-toggle=buttons]>.jr-btn input[type=radio]{position:absolute;clip:rect(0,0,0,0)}.btn-group-vertical>.btn,.btn-group-vertical>.jr-btn,.btn-group>.btn,.btn-group>.jr-btn{margin:0!important}.card-image .grid-thumb-equal{padding-bottom:82%}.product-row{position:relative;overflow:hidden;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;text-align:right}.product-row.even{text-align:left}.product-col{order:1;width:50%}.odd .product-thumb{order:2}.product-content{padding:20px 55px}.product-row .grid-thumb-equal{padding-bottom:69%}.product-thumb img{width:100%}.product-content h4{margin-bottom:25px}@media screen and (max-width:1230px){.product-row .grid-thumb-equal{padding-bottom:71%}}@media screen and (max-width:1199px){.product-content h4{margin-bottom:10px}.product-content{padding:20px 35px}.product-row .grid-thumb-equal{padding-bottom:85%}}@media screen and (max-width:991px){.card-image .grid-thumb-equal{padding-bottom:120%}}@media screen and (max-width:767px){.product-row{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.product-row,.product-row.even{text-align:center}.product-content{padding:20px 0}.odd .product-thumb,.product-col{order:1;width:100%}.card-image .grid-thumb-equal,.product-row .grid-thumb-equal{padding-bottom:44%}}.profile-intro{background-color:#fff;border-radius:2px!important;overflow:hidden}.profile-intro:hover{-webkit-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-moz-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-o-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);box-shadow:0 1px 8px -1px rgba(0,0,0,.2)}.profile-intro:hover .avatar-circle{-webkit-transition:border-radius .4s ease .1s;-o-transition:border-radius .4s ease .1s;transition:border-radius .4s ease .1s;border-radius:25%!important}.profile-intro img.avatar-circle{display:inline-block;border-radius:50%!important;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);position:relative;margin:0 auto;-webkit-transform:translateY(50px);-ms-transform:translateY(50px);transform:translateY(50px);-webkit-transition:all .4s ease-in-out;-o-transition:all .4s ease-in-out;transition:all .4s ease-in-out;z-index:1}.profile-intro .card-image{position:relative;width:100%;min-height:100%;background-image:url(\"http://via.placeholder.com/1920x1000\");background-position:50%;background-repeat:no-repeat;background-size:cover}.profile-intro .pi-content{padding:70px 40px 24px!important}.profile-intro .pi-footer{padding:0 40px 24px!important}.profile-intro .icon{display:inline-block;-webkit-transition:all .2s ease 0s;-o-transition:all .2s ease 0s;transition:all .2s ease 0s;color:#3f51b5}.profile-intro .icon:active,.profile-intro .icon:focus,.profile-intro .icon:hover{-webkit-transform:scale(1.2);-ms-transform:scale(1.2);transform:scale(1.2)}.profile-intro .icon:not(:last-child){margin-right:10px}.layer:before{display:block;content:\"\";background-color:rgba(0,0,0,.3);position:absolute;top:0;bottom:0;left:0;right:0;height:100%;width:100%;z-index:0}.jr-card>.jr-card-body:first-child{margin-top:6px}.jr-card.p-0>.jr-card-body:first-child{margin-top:0}.jr-card .jr-card-thumb{margin:-18px -24px 0}.jr-card .jr-card-thumb .card-img{border-radius:2px 2px 0 0}@media screen and (max-width:575px){.jr-card{margin-bottom:18px}}.jr-card-header{margin-bottom:24px}.jr-card-header .card-heading{margin-bottom:4px}.jr-card-header .badge{padding:2px 5px}.jr-card-header .badge:last-child{margin-left:10px}@media screen and (max-width:575px){.jr-card-header{margin-bottom:18px}}.jr-entry-header{margin-bottom:24px}.jr-entry-header .entry-heading{margin-bottom:4px}.jr-entry-header .entry-description{margin-bottom:0;font-size:13px;color:#6c757d}@media screen and (max-width:575px){.jr-entry-header{margin-bottom:18px}}.card{margin-bottom:24px;border-radius:2px}@media screen and (max-width:575px){.card{margin-bottom:18px}}.card-header{font-size:16px}.card-title{font-size:15px;text-transform:capitalize}@media screen and (max-width:991px){.card-title{margin-bottom:10px}}.product-item-vertical .card-footer{padding-right:0;padding-left:0}.card-subtitle{font-size:14px;color:#495057}.card-subtitle:not(:last-child){margin-bottom:15px}.card-mt-footer{padding:0 10px 14px;margin-top:-10px}.jr-card-social{font-size:22px;padding-top:20px}.social-link{list-style:none;padding-left:0;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin:0 -5px 10px}.social-link li{padding:0 5px;margin-bottom:5px}.social-link li a{color:#212529}.social-link li.active a,.social-link li a:focus,.social-link li a:hover{color:#e91e63}.jr-card-social .social-link{margin-bottom:0}.jr-card-social .social-link,.jr-cart-ab{-webkit-justify-content:space-around;justify-content:space-around}.jr-cart-ab{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;position:absolute;left:0;top:0;right:0;bottom:0;z-index:1;color:#fff;font-size:15px}.jr-cart-ab i{vertical-align:middle;font-size:25px}.img-overlay-card{border-radius:2px;margin-bottom:24px}@media screen and (max-width:1199px){.img-overlay-card .center-crop-img{min-height:135px}}@media screen and (max-width:575px){.img-overlay-card{margin-bottom:18px}}.chart-header{padding:15px 18px}.chart-header .card-title h4{color:#fff;margin-bottom:4px}.chart-header .title h4,.chart-header p{margin-bottom:4px}.chip-outline{background-color:transparent!important;border:1px solid #adb5bd!important}.carousel-caption h3{font-size:20px}.cp-color{width:36px;height:14px;border-radius:2px}.cp-swatch{padding:5px;background:#fff;border-radius:1px;-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.1);-moz-box-shadow:0 0 0 1px rgba(0,0,0,.1);-o-box-shadow:0 0 0 1px rgba(0,0,0,.1);box-shadow:0 0 0 1px rgba(0,0,0,.1);display:inline-block;cursor:pointer}.cp-popover{position:absolute;z-index:2}.cp-cover{position:fixed;top:0;right:0;bottom:0;left:0}.alpha-picker,.hue-picker,.material-picker,.photoshop-picker,.swatches-picker{width:100%!important}.material-picker{height:100%!important}.drawer{width:250px}.full-drawer{width:100%}.product-item,.product-item-vertical{border:0 none;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.2);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.2);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.2);box-shadow:0 1px 4px 0 rgba(0,0,0,.2)}.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:110%}@media screen and (max-width:1199px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:74%}}@media screen and (max-width:991px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:110%}}@media screen and (max-width:829px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:120%}}@media screen and (max-width:767px){.product-item-vertical .card-image .grid-thumb-equal{padding-bottom:44%}}.gl-advanced,.gl-image,.gl-list,.gl-single-line{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-justify-content:space-around;justify-content:space-around;overflow:hidden}.gl{max-width:100%;max-height:360px;transform:translateZ(0)}.gl-single-line .slg{-ms-flex-wrap:nowrap;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;max-width:100%}.title-gradient{background:-webkit-linear-gradient(180deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important;background:-o-linear-gradient(to bottom,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent 100%)!important;background:linear-gradient(180deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important}.title-gradient-bottom{background:-webkit-linear-gradient(0deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important;background:-o-linear-gradient(to top,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent 100%)!important;background:linear-gradient(0deg,rgba(0,0,0,.7) 0,rgba(0,0,0,.3) 70%,transparent)!important}.icon{text-align:center}.icon,.icons-wrapper{display:inline-block}.icons-wrapper+.icons-wrapper{margin-left:25px}label{margin-bottom:0}.pinned-list{position:relative;height:370px;overflow:auto;width:auto}.user-list{width:100%;padding:20px 15px 10px}.user-list .user-avatar{margin-right:20px}@media screen and (max-width:575px){.user-list .user-avatar{height:80px!important;width:80px!important;line-height:80px}}.user-list h6{color:#7e8b98}.list-inline{margin-left:-5px;margin-right:-5px}.list-inline li{padding:0 5px}.card-strip{border-bottom:1px solid #dee2e6;margin-bottom:10px}.jr-mbtn-list{margin-left:-20px}.nav-link{cursor:pointer}.card-header.bg-primary .nav-link{color:#fff}.card-header.bg-primary .nav-link.active,.card-header.bg-primary .nav-link:focus,.card-header.bg-primary .nav-link:hover{color:#000;background-color:#fff}.card-header.bg-primary .nav-link.disabled{color:#f8f9fa}.card-header.bg-primary .nav-link.disabled:hover{color:#212529}.pt-circle .package,.pt-classic .package,.pt-dark .package,.pt-default .package{position:relative;padding:0;overflow:hidden;border:0 none;border-radius:10px;-webkit-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.pt-circle .package:active,.pt-circle .package:focus,.pt-circle .package:hover,.pt-classic .package:active,.pt-classic .package:focus,.pt-classic .package:hover,.pt-dark .package:active,.pt-dark .package:focus,.pt-dark .package:hover,.pt-default .package:active,.pt-default .package:focus,.pt-default .package:hover{-webkit-box-shadow:0 0 16px hsla(0,0%,40%,.5);-moz-box-shadow:0 0 16px hsla(0,0%,40%,.5);-o-box-shadow:0 0 16px hsla(0,0%,40%,.5);box-shadow:0 0 16px hsla(0,0%,40%,.5);-webkit-transform:scale(1.05);-ms-transform:scale(1.05);transform:scale(1.05)}.pt-circle .package.highlight,.pt-classic .package.highlight,.pt-dark .package.highlight,.pt-default .package.highlight{-webkit-transform:scale(1.05);-ms-transform:scale(1.05);-o-transform:scale(1.05);transform:scale(1.05);z-index:2}.pt-circle .package-header,.pt-classic .package-header,.pt-dark .package-header,.pt-default .package-header{padding:35px;text-align:center}.pt-circle .package-header>.price,.pt-classic .package-header>.price,.pt-dark .package-header>.price,.pt-default .package-header>.price{display:inline-block;font-size:36px;font-weight:700;margin-left:0;margin-bottom:12px}.pt-circle .package-header>.price>i,.pt-classic .package-header>.price>i,.pt-dark .package-header>.price>i,.pt-default .package-header>.price>i{display:inline-block;margin-right:6px;font-weight:700}.pt-circle .package-header h5,.pt-classic .package-header h5,.pt-dark .package-header h5,.pt-default .package-header h5{color:inherit}.pt-circle .package-items,.pt-classic .package-items,.pt-dark .package-items,.pt-default .package-items{list-style:none;font-size:14px;margin:0;padding:50px 50px 120px}.pt-circle .package-items li,.pt-classic .package-items li,.pt-dark .package-items li,.pt-default .package-items li{margin-bottom:16px;line-height:inherit}.pt-circle .package-items li:after,.pt-circle .package-items li:before,.pt-classic .package-items li:after,.pt-classic .package-items li:before,.pt-dark .package-items li:after,.pt-dark .package-items li:before,.pt-default .package-items li:after,.pt-default .package-items li:before{content:\" \";display:table}.pt-circle .package-items li:after,.pt-classic .package-items li:after,.pt-dark .package-items li:after,.pt-default .package-items li:after{clear:both}.pt-circle .package-items li i,.pt-classic .package-items li i,.pt-dark .package-items li i,.pt-default .package-items li i{float:left;min-width:20px;margin-right:16px;line-height:inherit}.pt-circle .package-items li span,.pt-classic .package-items li span,.pt-dark .package-items li span,.pt-default .package-items li span{display:block;overflow:hidden}.pt-circle .package-footer,.pt-classic .package-footer,.pt-dark .package-footer,.pt-default .package-footer{bottom:0;left:0;position:absolute;right:0;padding:40px 50px;text-align:center}.pt-circle .package-footer .btn,.pt-classic .package-footer .btn,.pt-dark .package-footer .btn,.pt-default .package-footer .btn{color:inherit;padding:10px 30px;border:0 none}.pt-classic .package{border:0 none;border-radius:0}.pt-dark .package:hover{border-radius:20px}.pt-circle .package-header{border-radius:50%;height:224px;width:224px;margin:40px auto 0;-webkit-align-items:center;align-items:center}.pt-circle .package-header .price{margin-top:30px}@media only screen and (max-width:991px){.pt-circle .package-header,.pt-classic .package-header,.pt-dark .package-header,.pt-default .package-header{padding:30px 20px}.pt-circle .package-items,.pt-classic .package-items,.pt-dark .package-items,.pt-default .package-items{padding:30px 20px 120px}.pt-circle .package-header{height:204px;width:204px}}@media only screen and (max-width:767px){.pt-circle .package.highlight,.pt-circle .package:active,.pt-circle .package:focus,.pt-circle .package:hover,.pt-classic .package.highlight,.pt-classic .package:active,.pt-classic .package:focus,.pt-classic .package:hover,.pt-dark .package.highlight,.pt-dark .package:active,.pt-dark .package:focus,.pt-dark .package:hover,.pt-default .package.highlight,.pt-default .package:active,.pt-default .package:focus,.pt-default .package:hover{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}}.pb-wrapper{display:flex;align-items:center}.pb-btn-wrapper{margin:8px;position:relative}.pb-btn-wrapper .btn-success{background-color:#4caf50}.pb-btn-wrapper .btn-success:hover{background-color:#388e3c}.fab-progress{top:-6px;left:-6px;z-index:1}.btn-progress,.fab-progress{color:#4caf50;position:absolute}.btn-progress{top:50%;left:50%;margin-top:-12px;margin-left:-12px}.popover{z-index:1510}.popover-header{background-color:transparent;border-bottom:0 none;color:#000;font-size:20px;padding:15px 20px 0}.popover-body{padding:15px 20px}.table-header{padding-right:2px!important}.table-header.highlight-light{color:#616161;background-color:#e0e0e0}.table-header.highlight-dark{color:#fff;background-color:#616161}.spacer{-webkit-flex:1 1 100%;-ms-flex:1 1 100%;flex:1 1 100%}.actions{color:#f44336}.title{-webkit-flex:0 0 auto;-ms-flex:0 0 auto;flex:0 0 auto}.table-hover tbody tr:hover{background-color:rgba(63,81,181,.075)}.table-material{width:100%!important;max-width:100%!important;background-color:transparent!important}.table-material td,.table-material th{padding:.75rem!important;vertical-align:top!important;border-top:1px solid #dee2e6!important}.table-material thead th{vertical-align:bottom!important;border-bottom:2px solid #dee2e6!important}.table-material tbody+tbody{border-top:2px solid #dee2e6!important}.table-material .table-material{background-color:#f8f9fa!important}.d-flex-stretch{-webkit-align-items:stretch;align-items:stretch;display:-webkit-flex;display:-webkit-box;display:-moz-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.default-table{margin-bottom:0}.default-table thead th{font-weight:400;font-size:16px}.default-table td{vertical-align:middle}.table-unbordered td,.table-unbordered th{border:0 none!important}.table-unbordered .th-border-b th{border-bottom:2px solid #ced4da!important}.table-responsive-material{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive-material{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive-material>.table{margin-bottom:0}.table-responsive-material>.table>tbody>tr>td,.table-responsive-material>.table>tbody>tr>th,.table-responsive-material>.table>tfoot>tr>td,.table-responsive-material>.table>tfoot>tr>th,.table-responsive-material>.table>thead>tr>td,.table-responsive-material>.table>thead>tr>th{white-space:nowrap}.table-responsive-material>.table-bordered{border:0}.table-responsive-material>.table-bordered>tbody>tr>td:first-child,.table-responsive-material>.table-bordered>tbody>tr>th:first-child,.table-responsive-material>.table-bordered>tfoot>tr>td:first-child,.table-responsive-material>.table-bordered>tfoot>tr>th:first-child,.table-responsive-material>.table-bordered>thead>tr>td:first-child,.table-responsive-material>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive-material>.table-bordered>tbody>tr>td:last-child,.table-responsive-material>.table-bordered>tbody>tr>th:last-child,.table-responsive-material>.table-bordered>tfoot>tr>td:last-child,.table-responsive-material>.table-bordered>tfoot>tr>th:last-child,.table-responsive-material>.table-bordered>thead>tr>td:last-child,.table-responsive-material>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive-material>.table-bordered>tbody>tr:last-child>td,.table-responsive-material>.table-bordered>tbody>tr:last-child>th,.table-responsive-material>.table-bordered>tfoot>tr:last-child>td,.table-responsive-material>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}.tab{min-width:10px!important}.tab-icon>span{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.testimonial-in-bg{background-color:rgba(0,0,0,.8);box-shadow:5px 5px 6px rgba(0,0,0,.06);padding:30px 30px 30px 150px;overflow:hidden;position:relative}@media screen and (max-width:450px){.testimonial-in-bg{padding-left:100px}}.testimonial-in-bg .pic{display:inline-block;width:80px;height:80px;border-radius:50%;overflow:hidden;position:absolute;top:30px;left:20px;border:4px solid #ffa000}@media screen and (max-width:450px){.testimonial-in-bg .pic{width:50px;height:50px}}.testimonial-in-bg .pic img{width:100%;height:auto}.testimonial-in-bg .description{color:#bdbdbd;font-style:italic;font-weight:400;line-height:25px;margin-bottom:15px;position:relative}.testimonial-in-bg .description:before{content:\"\\F1B2\";font-family:Material-Design-Iconic-Font;font-size:24px;-moz-transform:scaleX(-1);-webkit-transform:scaleX(-1);-o-transform:scaleX(-1);transform:scaleX(-1);position:absolute;left:-24px}.testimonial-in-bg .title{color:#ffa000;margin-bottom:2px}.classic-testimonial{text-align:center}.classic-testimonial .pic{margin:0 auto;margin-bottom:30px;width:120px;height:120px}@media screen and (max-width:500px){.classic-testimonial .pic{width:80px;height:80px}}.classic-testimonial .pic img{width:100%;height:100%}.timeline-left{float:left;margin-right:20px}.timeline-right{float:right;margin-left:20px}.timeline-circle{border-radius:50%}.timeline-section{margin-bottom:25px}.timeline-item{padding-bottom:25px;padding-left:80px;position:relative}.timeline-item:before{border-left:2px solid #dee2e6;content:\"\";left:25px;position:absolute;top:25px;bottom:-20px;width:2px;z-index:1}.timeline-item:first-child:before,.timeline-item:last-child:before{border-left-style:dashed}.timeline-badge{background-color:#dee2e6;height:50px;width:50px;line-height:50px;position:absolute;left:0;top:16px;z-index:2;font-size:16px;color:#fff;text-align:center;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}.timeline-badge.timeline-img{background-color:transparent}.timeline-badge svg{vertical-align:calc(100% - 56px)}.timeline-header-img>img,.timeline-img>img{display:inline-block;max-width:100%;height:auto}.timeline-panel{padding:20px 30px;position:relative;background-color:#fff;border-radius:6px;-webkit-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-moz-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-o-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);box-shadow:0 1px 8px -1px rgba(0,0,0,.2)}.timeline-panel:after,.timeline-panel:before{content:\"\";position:absolute;border-style:solid;display:inline-block}.timeline-panel:before{border-color:transparent #dee2e6;border-width:15px 15px 15px 0;left:-15px;top:27px}.timeline-panel:after{border-color:transparent #fff;border-width:14px 14px 14px 0;left:-14px;top:27px}.timeline-no-padding{padding:0}.timeline-no-shadow{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.timeline-no-shadow:after,.timeline-no-shadow:before{display:none}.timeline-header-img,.timeline-panel-header{margin-bottom:10px}.timeline-inverted .timeline-left{float:right;margin-right:0;margin-left:20px}.timeline-heading{overflow:hidden;margin-bottom:10px}.timeline-body{clear:both}.timeline-center .timeline-item{clear:both;float:right;width:50%;padding-left:55px}.timeline-center .timeline-item:before{left:0}.timeline-center .timeline-badge{left:-25px;right:auto}.timeline-center .timeline-time{position:absolute;top:32px;left:-150px;right:auto;z-index:2}.timeline-center .timeline-inverted{float:left;text-align:right;padding-left:0;padding-right:55px}.timeline-center .timeline-inverted:before{border-left:0 none;border-right:2px solid #dee2e6;left:auto;right:-2px}.timeline-center .timeline-inverted .timeline-badge{left:auto;right:-25px}.timeline-center .timeline-inverted .timeline-panel:before{border-width:15px 0 15px 15px;left:auto;right:-15px}.timeline-center .timeline-inverted .timeline-panel:after{border-width:14px 0 14px 14px;left:auto;right:-14px}.timeline-center .timeline-inverted .timeline-time{position:absolute;top:32px;right:-150px;left:auto;z-index:2}.timeline-zigzag .timeline-item{padding-left:150px}.timeline-zigzag .timeline-item+.timeline-item{margin-top:-80px}.timeline-zigzag .timeline-img{width:90px;height:90px;left:5px}.timeline-zigzag .timeline-img>img{width:100%}.timeline-zigzag .timeline-inverted .timeline-img{right:5px!important}.timeline-zigzag .timeline-item:before{-webkit-transform:rotate(35deg);-ms-transform:rotate(35deg);-o-transform:rotate(35deg);transform:rotate(35deg);top:20px;bottom:20px}.timeline-zigzag .timeline-inverted{padding-left:0;padding-right:150px}.timeline-zigzag .timeline-inverted:before{-webkit-transform:rotate(-35deg);-ms-transform:rotate(-35deg);-o-transform:rotate(-35deg);transform:rotate(-35deg)}.timeline-zigzag .timeline-item:first-child:before{border-left-style:solid}.timeline-zigzag .timeline-item:last-child:before{display:none}.timeline-item:last-child:before{bottom:25px}@media screen and (max-width:991px){.timeline-zigzag .timeline-item+.timeline-item{margin-top:-60px}.timeline-zigzag .timeline-item:before{bottom:0}.timeline-zigzag .timeline-item{padding-left:120px}.timeline-zigzag .timeline-inverted{padding-right:120px;padding-left:0}}@media screen and (max-width:767px){.timeline-center .timeline-item{float:none;padding-left:80px;width:auto}.timeline-center .timeline-item:before{left:25px}.timeline-center .timeline-badge{left:0}.timeline-center .timeline-inverted{float:none;text-align:left;padding-right:0}.timeline-center .timeline-inverted:before{border-left:2px solid #dee2e6;border-right:0 none;left:24px;right:auto}.timeline-center .timeline-inverted .timeline-badge{right:auto;left:0}.timeline-center .timeline-inverted .timeline-panel:before{border-width:15px 15px 15px 0;left:-15px;right:auto}.timeline-center .timeline-inverted .timeline-panel:after{border-width:14px 14px 14px 0;left:-14px;right:auto}.timeline-inverted .timeline-panel-header{float:none}.timeline-inverted .timeline-left{float:left;margin-left:0;margin-right:20px}.timeline-zigzag .timeline-panel{max-height:none;min-height:10px;overflow-y:visible}.timeline-zigzag .timeline-item{padding-left:100px}.timeline-zigzag .timeline-item+.timeline-item{margin-top:0}.timeline-zigzag .timeline-item:before{transform:none;top:25px;bottom:-25px;left:45px}.timeline-zigzag .timeline-item:last-child:before{bottom:0}.timeline-zigzag .timeline-inverted:before{transform:none}.timeline-center .timeline-inverted .timeline-time,.timeline-center .timeline-time{position:relative;top:auto;left:auto;right:auto;margin-bottom:6px}.timeline-center .timeline-time-item .timeline-panel:before{top:10px}.timeline-center .timeline-time-item .timeline-panel:after{top:11px}}@media screen and (max-width:399px){.timeline-left{float:none;margin-right:0}.timeline-right{float:none;margin-left:0}.timeline-inverted .timeline-left{float:none;margin-right:0}}.joyride-beacon{background-color:transparent;border:0;cursor:pointer;display:inline-block;line-height:1;padding:0;height:36px;position:relative;width:36px;z-index:1500}.joyride-beacon:active,.joyride-beacon:focus,.joyride-beacon:hover{outline:none}.joyride-beacon__inner{animation:joyride-beacon-inner 1.2s infinite ease-in-out;background-color:#f04;border-radius:50%;display:block;height:50%;left:50%;opacity:.7;position:absolute;top:50%;transform:translate(-50%,-50%);width:50%}.joyride-beacon__outer{animation:joyride-beacon-outer 1.2s infinite ease-in-out;background-color:rgba(255,0,68,.2);border:2px solid #f04;border-radius:50%;box-sizing:border-box;display:block;height:100%;left:0;opacity:.9;position:absolute;top:0;transform:translateY(-50%);transform-origin:center;width:100%}.joyride-overlay{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1500}.joyride-hole{border-radius:4px;box-shadow:0 0 0 9999px rgba(0,0,0,.5),0 0 15px rgba(0,0,0,.5);position:absolute}.joyride-hole.safari{box-shadow:0 0 999px 9999px rgba(0,0,0,.5),0 0 15px rgba(0,0,0,.5)}.joyride-tooltip{background-color:#fff;border-radius:4px;color:#555;cursor:default;filter:drop-shadow(-1px -2px 3px rgba(0,0,0,.3)) drop-shadow(1px 2px 3px rgba(0,0,0,.3));opacity:0;padding:20px;transform:translateZ(0);width:290px;z-index:1510}.joyride-tooltip--animate{animation:joyride-tooltip .4s forwards;animation-timing-function:cubic-bezier(0,1.05,.55,1.18)}.joyride-tooltip__triangle{background-repeat:no-repeat;position:absolute}.joyride-tooltip.bottom,.joyride-tooltip.bottom-left,.joyride-tooltip.bottom-right{margin-top:18px}.joyride-tooltip.bottom-left .joyride-tooltip__triangle,.joyride-tooltip.bottom-right .joyride-tooltip__triangle,.joyride-tooltip.bottom .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='36' height='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M36 18L18 0 0 18z'/%3E%3C/svg%3E\");height:18px;left:50%;top:-16px;transform:translateX(-50%);width:36px}.joyride-tooltip.top,.joyride-tooltip.top-left,.joyride-tooltip.top-right{margin-bottom:18px}.joyride-tooltip.top-left .joyride-tooltip__triangle,.joyride-tooltip.top-right .joyride-tooltip__triangle,.joyride-tooltip.top .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='36' height='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M0 0l18 18L36 0z'/%3E%3C/svg%3E\");bottom:-16px;height:18px;left:50%;transform:translateX(-50%);width:36px}.joyride-tooltip.bottom-left .joyride-tooltip__triangle,.joyride-tooltip.top-left .joyride-tooltip__triangle{left:3%;transform:translateX(0)}@media screen and (min-width:480px){.joyride-tooltip.bottom-left .joyride-tooltip__triangle,.joyride-tooltip.top-left .joyride-tooltip__triangle{left:2%}}.joyride-tooltip.bottom-right .joyride-tooltip__triangle,.joyride-tooltip.top-right .joyride-tooltip__triangle{left:auto;right:3%;transform:translateX(0)}@media screen and (min-width:480px){.joyride-tooltip.bottom-right .joyride-tooltip__triangle,.joyride-tooltip.top-right .joyride-tooltip__triangle{right:2%}}.joyride-tooltip.left{margin-right:18px}.joyride-tooltip.left .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M0 36l18-18L0 0z'/%3E%3C/svg%3E\");height:36px;right:-16px;width:18px}.joyride-tooltip.right{margin-left:18px}.joyride-tooltip.right .joyride-tooltip__triangle{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23fff' d='M18 0L0 18l18 18z'/%3E%3C/svg%3E\");height:36px;left:-16px;width:18px}.joyride-tooltip__close{background-color:transparent;border:0;cursor:pointer;display:inline-block;line-height:1;padding:0;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='12' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.117.323L8.044 6.398 2.595.323a1.105 1.105 0 0 0-1.562 1.562L6.482 7.96.323 14.119a1.105 1.105 0 0 0 1.562 1.562L7.96 9.608l5.449 6.073a1.103 1.103 0 1 0 1.56-1.562L9.517 8.046l6.159-6.161a1.103 1.103 0 1 0-1.56-1.562z' fill='rgba(85,85,85,0.5)'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:contain;height:12px;position:absolute;right:10px;text-decoration:none;top:10px;width:12px;z-index:10;display:block}.joyride-tooltip__close:active,.joyride-tooltip__close:focus,.joyride-tooltip__close:hover{outline:none}.joyride-tooltip__close:focus,.joyride-tooltip__close:hover{color:rgba(60,60,60,.5);outline:none}.joyride-tooltip__close--header{right:20px;top:20px}.joyride-tooltip__header{border-bottom:1px solid #f04;color:#555;font-size:16px;padding-bottom:6px;padding-right:18px;position:relative}.joyride-tooltip__header~.joyride-tooltip__main{padding:12px 0 18px}.joyride-tooltip__main{font-size:14px;padding-bottom:18px;padding-right:18px}.joyride-tooltip__footer{text-align:right}.joyride-tooltip__button{background-color:transparent;border:0;cursor:pointer;display:inline-block;line-height:1;padding:0}.joyride-tooltip__button:active,.joyride-tooltip__button:focus,.joyride-tooltip__button:hover{outline:none}.joyride-tooltip__button--primary{background-color:#f04;border-radius:4px;color:#fff;padding:6px 12px;transition:background-color .2s ease-in-out}.joyride-tooltip__button--primary:active,.joyride-tooltip__button--primary:focus,.joyride-tooltip__button--primary:hover{background-color:#ff1f5a;color:#fff}.joyride-tooltip__button--secondary{color:#f04;margin-right:10px}.joyride-tooltip__button--skip{color:#ccc;float:left;margin-right:10px}.joyride-tooltip--standalone .joyride-tooltip__main{padding-bottom:0}.joyride-tooltip--standalone .joyride-tooltip__footer{display:none}@media screen and (min-width:480px){.joyride-tooltip{width:360px}}@media screen and (min-width:960px){.joyride-tooltip{width:450px}}@keyframes joyride-tooltip{0%{transform:scale(.1)}to{opacity:1;transform:perspective(1px) scale(1)}}@keyframes joyride-beacon-inner{20%{opacity:.9}90%{opacity:.7}}@keyframes joyride-beacon-outer{0%{transform:scale(1)}45%{opacity:.7;transform:scale(.75)}to{opacity:.9;transform:scale(1)}}@media screen and (max-width:575px){.horizontal-stepper p,.horizontal-stepper span{opacity:0;visibility:hidden;font-size:12px}.horizontal-stepper.active p,.horizontal-stepper.active span{opacity:1;visibility:visible}.horizontal-stepper>*,.horizontal-stepper>button>*{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.horizontal-stepper .stepperbutton,.horizontal-stepper .stepperbutton span:first-child,.horizontal-stepper .stepperlabel,.horizontal-stepper .stepperlabel span:first-child{opacity:1;visibility:visible}.horizontal-stepper-linear{padding-left:0!important;padding-right:0!important}}::-webkit-input-placeholder{font-size:12px}::-moz-placeholder{font-size:12px}:-ms-input-placeholder{font-size:12px}:-moz-placeholder{font-size:12px}.module-box-header ::-webkit-input-placeholder{font-size:14px}.module-box-header ::-moz-placeholder{font-size:14px}.module-box-header :-ms-input-placeholder{font-size:14px}.module-box-header :-moz-placeholder{font-size:14px}.search-bar{background-color:#fff;position:relative}.search-bar .form-group{width:100%;height:100%;margin-bottom:0}.search-bar input[type=search]{padding-right:50px}.search-bar .search-icon{background-color:transparent;border:0 none;color:#868e96;height:36px;width:30px}.search-bar .form-control{box-shadow:none}.search-bar .form-control.form-control-lg+.search-icon{position:absolute;right:14px;top:6px}.search-bar .search-icon{position:absolute;right:14px;top:3px}.search-bar.right-side-icon input[type=search]{padding-right:16px;padding-left:50px}.search-bar.right-side-icon .search-icon{position:absolute;left:14px;top:2px}.search-bar.right-side-icon .form-control{box-shadow:none}.search-bar.right-side-icon .form-control.form-control-lg+.search-icon{position:absolute;left:14px;top:6px}.nav-searchbox .search-bar input+.search-icon i{color:#000}@media screen and (max-width:767px){.jr-card .app-main-header .search-bar{width:150px}}.page-error-container{padding:30px 0;position:relative}@media screen and (max-width:575px){.page-error-container{padding:15px 0}}.page-error-content{margin:0 auto;padding:40px 0;width:380px;max-width:94%}@media screen and (max-width:767px){.page-error-content{padding:15px 0}}@media screen and (max-width:575px){.page-error-content{padding:0}}.error-code{color:#212529;font-size:160px;text-align:center;line-height:1;font-weight:600;text-shadow:10px 6px 8px hsla(0,0%,46%,.8)}@media screen and (max-width:991px){.error-code{font-size:130px}}@media screen and (max-width:767px){.error-code{font-size:100px}}@media screen and (max-width:575px){.error-code{font-size:80px}}.page-error-content h2{margin-bottom:50px}@media screen and (max-width:767px){.page-error-content h2{margin-bottom:20px}}.rdw-inline-wrapper{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.rdw-option-wrapper{margin-bottom:6px}.contact-form{padding:60px}.contact-block .contact-info{list-style:none;padding-left:0;margin-bottom:0;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-align-content:stretch;-ms-flex-align:stretch;align-content:stretch}.contact-block .contact-info li{-webkit-flex:1 1 0;-ms-flex:1 1 0;flex:1 1 0;overflow:hidden;padding:10px 40px;border-right:2px solid #212529;word-wrap:break-word}.contact-block .contact-info li:last-child{border:0 none}.contact-block .contact-info li>i{float:left;font-size:16px;margin-right:5px}.contact-block .contact-info li .contact-body{overflow:hidden}.contact-block .contact-info li .contact-body .icons-wrapper{margin-top:15px;margin-left:0}.contact-block .contact-info li .contact-body .icon{background-color:#5c6bc0;color:#fff;border-radius:50%;margin-right:6px;margin-bottom:6px}.contact-block .contact-info li .contact-body .icon:last-child{margin-right:0}.contact-block .contact-info li .contact-body .twitter-icon{background-color:#40c4ff}.contact-block .contact-info li .contact-body .google-icon{background-color:#ef5350}.contact-block .contact-info li .contact-body .linkedin-icon{background-color:#0277bd}.contact-block .contact-info.vertical{display:block;margin-bottom:0}.contact-block .contact-info.vertical li{padding:0 0 24px;border-right:0 none;border-bottom:2px solid #212529;margin-bottom:24px}.contact-block .contact-info.vertical li:last-child{border:0 none;margin-bottom:0;padding-bottom:0}@media screen and (max-width:767px){.contact-form{padding:30px}.contact-block .contact-info{display:block;margin-bottom:0}.contact-block .contact-info li{padding:0 0 24px;border-right:0 none;border-bottom:2px solid #212529;margin-bottom:24px}.contact-block .contact-info li:last-child{border:0 none;margin-bottom:0;padding-bottom:0}.content-section{padding:20px 10px 0;text-align:center}.content-section h2{font-size:28px}.content-section p{font-size:18px}}.portfolio-section .card-image{margin-bottom:20px}.portfolio-section .card-image img{width:100%;-webkit-transition:all 1.2s ease;-o-transition:all 1.2s ease;transition:all 1.2s ease}.portfolio-section .card-image:hover img{-webkit-box-shadow:0 2px 8px -2px rgba(0,0,0,.6);-moz-box-shadow:0 2px 8px -2px rgba(0,0,0,.6);-o-box-shadow:0 2px 8px -2px rgba(0,0,0,.6);box-shadow:0 2px 8px -2px rgba(0,0,0,.6);-webkit-transform:scale(1.08);-ms-transform:scale(1.08);transform:scale(1.08)}.filter-with-bg-color ul{padding-left:0;margin:0 -10px 45px}.filter-with-bg-color ul li{display:inline-block;margin-bottom:10px;padding:0 10px}.filter-with-bg-color ul li a{text-transform:uppercase;font-size:12px;padding:10px 24px;border:1px solid #3f51b5;display:block;text-decoration:none}.filter-with-bg-color ul li a.active,.filter-with-bg-color ul li a:focus,.filter-with-bg-color ul li a:hover{cursor:pointer;background-color:#3f51b5;border-color:#3f51b5;color:#fff}@media screen and (max-width:575px){.filter-with-bg-color ul{margin-bottom:15px}}.Collapsible{background-color:#fff;margin-bottom:15px}.Collapsible__contentInner{padding:20px;border:1px solid #fff;border-top:0}.Collapsible__contentInner p{margin-bottom:10px;font-size:14px;line-height:20px}.Collapsible__contentInner p:last-child{margin-bottom:0}.Collapsible__trigger{display:block;font-weight:400;text-decoration:none;position:relative;padding:18px 20px;border-radius:6px;background:#3f51b5;color:#fff}.Collapsible__trigger:after{content:\"\\F2F9\";font-family:Material-Design-Iconic-Font;font-size:20px;position:absolute;right:24px;top:16px;display:block;transition:transform .3s}.Collapsible__trigger.is-open{border-radius:6px 6px 0 0}.Collapsible__trigger.is-open:after{transform:rotate(180deg)}.categories-list{margin-bottom:0}.categories-list li{margin-bottom:10px}.categories-list li:last-child{margin-bottom:0}.categories-list li.active a{color:#3f51b5}.categories-list .badge{font-size:9px}.articles-section .articles{margin-bottom:26px}.articles-section .articles:last-child{margin-bottom:0}.article-image{display:block;margin-bottom:12px}.article-image>img{border-radius:6px;width:100%}.article-description p{font-weight:500;margin-bottom:2px}.meta-wrapper{margin-bottom:10px}.meta-comment,.meta-date{font-size:12px;color:#6c757d;display:inline-block}.meta-comment i,.meta-date i{display:inline-block;margin-right:6px}.meta-date+.meta-comment{margin-left:10px}.box{position:relative}.box .box-bottom,.box .box-top{height:100px;padding:32px 15px;font-size:40px;line-height:40px;text-align:center;font-weight:300}.box .box-bottom .size-h5,.box .box-top .size-h5{font-size:24px;margin-left:2px}.box .box-bottom .material-icons,.box .box-top .material-icons{font-size:40px;line-height:40px}.box .box-bottom{border-top:1px solid rgba(0,0,0,.15)}.box .box-info{position:absolute;width:100%;top:50%;margin-top:-12px;text-align:center}.box .box-info span{height:24px;display:inline-block;padding:4px 10px;text-transform:uppercase;line-height:14px;background-color:#fff;border:1px solid rgba(0,0,0,.15);font-size:12px;color:#6c757d;border-radius:1em}.box .box-info span .material-icons{line-height:14px;font-size:11px}.contact-list{margin-bottom:14px}.contact-list i{margin-right:14px;color:#3f51b5}.contact-list .media{margin-bottom:10px}.temp-section .detail-icon,.temp-section .temp-point{font-size:54px}.assignment-table tbody tr:nth-child(odd){background-color:#dee2e6!important}.assignment-table td{padding-top:10px;padding-bottom:10px}.status-cell{min-width:100px;max-width:120px;padding-right:24px!important}.status-cell .badge{min-width:70px}.thumbnail-list{margin-bottom:0}.thumbnail-list .thumbnail-item{padding:0 2.5px;display:inline-block;width:33.333%;margin-bottom:5px}@media screen and (max-width:767px){.thumbnail-list .thumbnail-item{width:50%}}@media screen and (max-width:575px){.thumbnail-list .thumbnail-item{width:33.333%}}.post-list .post-image .grid-thumb-equal{padding-bottom:100%}.chart-f30{font-size:30px}@media screen and (max-width:1099px){.chart-f30{font-size:20px}}.chart-f20{font-size:20px}@media screen and (max-width:1099px){.chart-f20{font-size:16px}}.chart-order .col-5{order:2;text-align:center}@media screen and (max-width:575px){.chart-order .col-5{order:1}}.chart-order .col-7{order:1}@media screen and (max-width:575px){.chart-order .col-7{order:2}}.tab-notifications{margin-left:-24px;margin-right:-24px;border-bottom:1px solid #adb5bd}@media screen and (max-width:567px){.tab-notifications button,.tab-notifications button *{font-size:12px!important}}.chart-title h2{font-size:22px;margin-bottom:5px}.img-fluid{width:100%}.comment-footer button{margin-bottom:6px}.net-chart{padding-left:0;padding-right:8px;min-height:100px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.net-chart .jr-card-thumb{margin:0 20px 0 0;width:65px;-webkit-transition:all .2s ease .1s;-o-transition:all .2s ease .1s;transition:all .2s ease .1s}.net-chart:hover .jr-card-thumb{margin-right:5px;width:80px}.net-chart .jr-card-thumb img{border-radius:50%;width:50px;height:50px;-webkit-transition:all .2s ease .1s;-o-transition:all .2s ease .1s;transition:all .2s ease .1s;overflow:hidden;margin-left:15px}.net-chart:hover .jr-card-thumb img{width:80px;height:100px;border-radius:0;margin:-18px 15px -18px 0}.net-chart .jr-card-body,.net-chart:hover .jr-card-body{width:calc(100% - 95px)}.jr-chart-or .chart-header{padding-bottom:0}.net-chart-hr{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;min-height:120px;padding-right:8px;overflow:hidden}.net-chart-hr .jr-card-thumb{margin:-30px 12px -30px -24px;min-width:100px}.net-chart-hr .grid-thumb-equal{padding-bottom:130%}.net-chart-hr .jr-card-body{width:calc(100% - 100px)}.user-profile{padding:10px 0}.mh-120{min-height:120px}.jr-card-header-top{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin-right:-16px}.jr-card-header-color{padding:10px 20px 20px;margin:-18px -24px 25px}.todo-cell-group .todo-cell:not(:last-child){margin-bottom:8px}.social-list-line{position:relative}.social-list-line:not(:last-child):before{border-left:1px solid #adb5bd;content:\"\";left:20px;position:absolute;top:5px;bottom:0;width:1px;z-index:1}.list-line-item{position:relative;padding-left:40px}.list-line-item:not(:last-child):before{border-left:1px solid #adb5bd;content:\"\";left:20px;position:absolute;top:-25px;bottom:-25px;width:1px;z-index:1}.list-line-badge{position:absolute;left:16px;top:15px;z-index:2;border-radius:50%;height:10px;width:10px;background-color:#adb5bd}.brand-logo{border:1px solid #dee2e6;background-color:#fff;border-radius:6px;margin-bottom:20px;padding-bottom:75%}.brand-logo .brand-logo-inner{text-align:center}.brand-logo .brand-logo-inner:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}.brand-logo .brand-logo-inner img{height:auto;max-height:100%;max-width:100%;display:inline-block;vertical-align:middle;width:auto!important}.brand-logo:hover{-webkit-box-shadow:0 8px 10px rgba(0,0,0,.2);-moz-box-shadow:0 8px 10px rgba(0,0,0,.2);-o-box-shadow:0 8px 10px rgba(0,0,0,.2);box-shadow:0 8px 10px rgba(0,0,0,.2);-webkit-transition:all .4s ease-in-out .1s;-o-transition:all .4s ease-in-out .1s;transition:all .4s ease-in-out .1s;background-color:#f2f2f2}@media screen and (max-width:575px){.brand-logo{margin-bottom:15px}}.owl-app-frame.owl-carousel .owl-item img{display:inline-block;width:auto}.carousel-item img{max-width:100%}.app-wrapper-module{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-align-items:stretch;align-items:stretch;height:100%}.app-module{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;flex-wrap:nowrap;margin:-24px}.app-module,.module-side{position:relative;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap}.module-side{z-index:2;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;flex-wrap:nowrap;-webkit-flex:0 1 230px;-ms-flex:0 1 230px;flex:0 1 230px;max-width:230px;min-width:230px}.module-side-header{border-bottom:1px solid #e9ecef;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-side-header .user-detail{padding:15px 10px;text-align:center}.module-logo{padding:10px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:center;justify-content:center;min-height:78px;font-size:20px;background-color:#f9fafb;color:#2f353a}.module-logo .zmdi{font-size:28px}.module-side-content,.module-user-info{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-user-detail{font-size:12px}.module-add-task{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:24px}.module-nav{list-style:none;padding-left:0;-webkit-justify-content:center;justify-content:center}.module-nav,.module-nav li{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-nav,.module-nav li,.module-nav li a{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-nav li a{padding:12px 29px;color:#9ba5ae;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;text-decoration:none}.module-nav li a:focus,.module-nav li a:hover{color:#212529}.module-nav li a.active{color:#3f51b5}.module-nav li i{margin-right:16px;font-size:16px}.module-nav li span{display:inline-block;vertical-align:middle}.module-nav li.module-nav-label{padding:12px 29px}.module-box{position:relative;z-index:2;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:calc(100% - 231px)}.module-box,.module-box-header{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-box-header{padding:10px 26px;min-height:79px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;background-color:#fff;border-bottom:1px solid #e9ecef}.module-box-header .search-bar.right-side-icon{min-width:350px}.module-box-header .search-bar.right-side-icon .form-control{border-radius:0;height:46px;padding:10px 18px 10px 40px}.module-box-header .search-bar.right-side-icon .form-control:focus{background-color:#f8f9fa}.module-box-header .search-bar.right-side-icon .search-icon{width:25px;height:46px;font-size:16px;left:10px;top:0;padding:0}.module-box-header-inner{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.module-box-content,.module-box-header-inner{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-box-content{background-color:#fff;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.module-box-topbar{padding:8px 12px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;border-bottom:1px solid #e9ecef}.module-box-topbar button+button{border-radius:0}.module-box-topbar-todo{padding-left:64px}@media screen and (max-width:575px){.module-box-topbar-todo{padding-left:27px}}.module-list-icon{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;padding-right:10px}.bar-icon{margin-right:15px}.toolbar-separator{border-left:1px solid #ced4da;height:100%;width:1px;margin:0 12px}.toolbar-left{margin-left:auto}.module-list{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.module-list,.module-list-item{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.module-list-item{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;padding:15px 28px;border-bottom:1px solid #e9ecef;z-index:5;position:relative;cursor:pointer}.module-list-item>.check-label{margin-left:0;margin-bottom:0}.module-list-item.mail-cell{padding-left:12px;-webkit-align-items:start;align-items:start}.module-detail-header{margin-bottom:10px}.module-detail-header>.check-label{margin-right:auto}.module-list-info{-webkit-flex:1 1 0;-ms-flex:1 1 0;flex:1 1 0;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;max-width:calc(100% - 169px)}.module-todo-content{position:relative}.module-todo-content .subject{margin-bottom:5px}.module-list-actions{text-align:right}.app-module-sidenav{background-color:#fff;border-right:1px solid #e9ecef;position:relative;z-index:9}.app-module-sidenav .chat-sidenav-main{max-width:300px;min-width:300px;width:90%}.module-date{max-width:160px}.module-date>div:before{display:none}.module-detail-item{padding:10px 28px}.task-title{font-size:18px}.chat-todo-avatar{margin-right:15px}.modal-title{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-justify-content:space-between;justify-content:space-between;width:100%;font-size:18px}.loader-view,.loader-view-block,.modal-title{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-align-items:center;align-items:center}.loader-view,.loader-view-block{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.loader-view-block .slimScrollBar,.loader-view .slimScrollBar{display:none!important}.module-date>div{-webkit-align-items:center;align-items:center}@media screen and (max-width:1199px){.module-side{display:-webkit-block;display:-moz-block;display:-ms-block;display:-o-block;display:block;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:280px;min-width:280px}.module-box-header{position:relative;min-height:58px;padding:5px 26px 5px 75px}.module-box-header .drawer-btn{position:absolute;left:0;top:0;z-index:1;border-right:1px solid #e9ecef;height:58px;width:56px;border-radius:0;font-size:22px}.module-box-header .search-bar.right-side-icon .form-control{height:38px;padding:5px 18px 5px 40px}.module-box-header .search-bar.right-side-icon .search-icon{height:38px}.chat-loader-view{height:calc(100vh - 120px)}.module-box{max-width:100%}}@media screen and (min-width:991px){.modal-dialog{max-width:750px}}@media screen and (max-width:991px){.app-module{padding-top:0}}@media screen and (max-width:599px){.module-box-header .search-bar{margin-left:0;max-width:none}.module-box-header .search-bar.right-side-icon{min-width:250px}}@media screen and (max-width:575px){.module-list-item{padding:10px 12px}.module-list-info{max-width:100%}.module-box-header .nav-searchbox.quick-menu .dropdown-menu{right:auto!important;left:0!important}.module-box-header .search-bar.right-side-icon{min-width:200px}.module-box-header .search-bar.right-side-icon .form-control{border-radius:.25rem}.module-box-header .nav-searchbox.quick-menu .dropdown-menu:after,.module-box-header .nav-searchbox.quick-menu .dropdown-menu:before{right:auto;left:9px}.module-box-header .search-bar{padding-right:2px}}@media screen and (max-width:399px){.module-box-header .search-bar.right-side-icon{min-width:100px}}@media screen and (min-width:399px){.d-xs-flex{display:flex!important}}.chat-module{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}.chat-module:before{left:-29px}.chat-module-box{-webkit-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-moz-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);-o-box-shadow:0 1px 8px -1px rgba(0,0,0,.2);box-shadow:0 1px 8px -1px rgba(0,0,0,.2);display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;background-color:#f8f9fa;position:relative;z-index:2;width:100%}.chat-sidenav{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:0 1 315px;-ms-flex:0 1 315px;flex:0 1 315px;min-width:315px;border-right:1px solid #e9ecef}.chat-box,.chat-sidenav{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.chat-box{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:100%}.chat-sidenav-header{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding:25px 20px 12px;background-color:#f9fafb}.chat-sidenav-header,.chat-user-hd{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.chat-user-hd{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:25px}.chat-sidenav-header .search-wrapper{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin-bottom:0}.chat-sidenav-header .search-wrapper .search-bar.right-side-icon{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .form-control{-webkit-box-shadow:0 0 3px rgba(0,0,0,.3);-moz-box-shadow:0 0 3px rgba(0,0,0,.3);-o-box-shadow:0 0 3px rgba(0,0,0,.3);box-shadow:0 0 3px rgba(0,0,0,.3);border-radius:0;padding-left:42px;height:42px}.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .search-icon{left:10px;top:0;height:42px;padding:0}.chat-avatar{min-width:50px}.chat-user-item .chat-avatar{padding:0 5px;min-width:10px}.chat-user-hd .chat-avatar{cursor:pointer}.chat-avatar-mode{position:relative;max-width:50px}.chat-avatar-mode .chat-mode{display:block;position:absolute;left:0;top:2px;z-index:1;width:12px;height:12px;border-radius:50%}.chat-avatar-mode .chat-mode.small{width:8px;height:8px}.chat-avatar-mode .chat-mode.online{background-color:#4caf50}.chat-avatar-mode .chat-mode.offline{background-color:#fff;border:1px solid #4caf50}.chat-avatar-mode .chat-mode.away{background-color:#fdd835}.chat-main-header-info .chat-avatar-mode{max-width:60px}.chat-sidenav-content{background-color:#fff}.chat-sidenav-title{padding:10px 16px;font-size:14px;color:#00bcd4;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center}.chat-tabs-header{background-color:#f9fafb!important}.chat-user{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.chat-user.chat-user-center{-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center}.chat-user.chat-user-center .chat-avatar{margin-left:auto}.chat-user-item{border-bottom:1px solid #e9ecef;padding:16px;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;cursor:pointer;max-height:96px}.chat-user-item.active,.chat-user-item:hover{background-color:#e4e7f6}.chat-user-row{margin:0 -5px;-webkit-align-items:center;align-items:center}.chat-contact-col,.chat-info{padding:0 5px}.chat-contact-col p,.chat-info p{margin-bottom:0}.chat-contact-col .h4,.chat-info .h4{display:block;margin-bottom:3px}.chat-info-des{color:#6c757d;font-size:13px}.chat-date{padding:0 5px;text-align:right}.chat-box-main,.module-default{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;justify-content:center;height:100%}.module-default{-webkit-align-items:center;align-items:center;padding:15px}.s-128{font-size:128px!important;width:128px!important;height:128px!important;line-height:128px!important;margin-bottom:12px}.chat-main{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.chat-main-header{border-bottom:1px solid #e9ecef;padding:16px;background-color:#fff;width:100%}.chat-main-header,.chat-main-header-info{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.chat-main-header-info{margin-right:auto}.chat-contact-name{font-size:20px;font-weight:500}.chat-main-footer{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;border-top:1px solid #e9ecef;padding:16px;background-color:#fff;width:100%}.chat-main-footer .form-group{margin-bottom:0}.todo-main-footer{padding:6px 16px}.chat-item{padding:16px}.chat-item .bubble{padding:8px 12px;background-color:#fff;-webkit-box-shadow:0 0 2px rgba(0,0,0,.13);-moz-box-shadow:0 0 2px rgba(0,0,0,.13);-o-box-shadow:0 0 2px rgba(0,0,0,.13);box-shadow:0 0 2px rgba(0,0,0,.13);border-radius:20px 20px 20px 0;position:relative;margin-left:16px;max-width:600px}.chat-item.flex-row-reverse .bubble{margin-right:16px;margin-left:0;background-color:#e4e7f6;border-radius:20px 20px 0 20px}.chat-btn{font-size:38px!important;margin:0 10px 0 -8px}.chat-textarea{height:40px;-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none;border-radius:0}.last-message-time{font-size:11px;color:#adb5bd}@media screen and (max-width:1399px){.s-128{font-size:100px!important;width:100px!important;height:100px!important;line-height:100px!important}}@media screen and (max-width:1199px){.chat-module{margin:-24px -29px -23px;padding-top:0}.chat-main-header{padding:8px 24px}.chat-main-header .size-60{height:50px!important;width:50px!important;line-height:50px}.chat-main-header button{margin-bottom:0}.chat-main-header-info .chat-avatar-mode{max-width:50px}.chat-contact-name,.chat-sidenav-title{font-size:16px}.chat-main-footer{padding:8px 16px}.s-128{font-size:128px!important;width:128px!important;height:128px!important;line-height:128px!important}}@media screen and (max-width:991px){.s-128{font-size:100px!important;width:100px!important;height:100px!important;line-height:100px!important;margin-bottom:10px}}@media screen and (max-width:767px){.chat-contact-name,.chat-sidenav-title{font-size:15px}.s-128{font-size:80px!important;width:80px!important;height:80px!important;line-height:80px!important}}@media screen and (max-width:575px){.module-default h1{font-size:17px}.s-128{font-size:40px!important;width:40px!important;height:40px!important;line-height:40px!important}}.module-box-row{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.module-box-column,.module-box-row{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;width:100%}.module-box-column{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mail-user-info{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.mail-user-info .avatar{margin-right:10px}.mail-user-info .time,.mail-user-info button{margin-left:auto}.mail-user-info .badge{margin-bottom:0}.module-list-item.mail-cell{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.mail-detail .module-list-scroll{padding:24px}.mail-header{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center}.mail-header,.mail-header-content{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}.mail-header-content{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mail-header-content .subject{margin-bottom:5px}.show-detail{cursor:pointer}.module-list-content .message p,.module-list-content .subject,.text-truncate{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.module-list-content .message{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;color:#919ca6;font-size:13px}.module-list-content .message p{margin-bottom:8px}.size{margin:5px 0}.sender-name{margin-right:0;font-weight:500;font-size:15px}.mail-header-actions{text-align:right;min-width:100px}.mail-header-actions .btn:not(:last-child){margin-right:3px}@media screen and (max-width:991px){.module-list-item.mail-cell{padding-right:20px}}@media screen and (max-width:576px){.mail-list{border-right:0 none}.mail-detail,.mail-list{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;max-width:100%}.mail-detail .module-list-scroll{padding:24px}}@media screen and (max-width:499px){.mail-header{display:block;-webkit-align-items:flex-start;align-items:flex-start;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.mail-header-actions{text-align:left;min-width:10px}.MuiDialog-paperWidthSm-99{max-width:250px!important}}.contact-item{-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;border-bottom:1px solid #e9ecef;padding:8px 12px}.contact-name{font-size:15px}.modal-box{position:relative}.modal-w{max-width:400px;min-width:350px}.modal-box-mail .modal-w{min-width:600px}.modal-box-header{color:#fff;border-top-left-radius:4px;border-top-right-radius:4px}.modal-box-header h2{color:#fff;position:relative}.modal-box-header h2 button{position:absolute;right:0;top:-10px;z-index:1;color:#fff}.modal-box-content{padding:24px}.modal-box-content .avatar{margin:0 auto}.modal-box-footer{padding:0 24px 24px}.modal-box-footer .attach-file{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;margin-bottom:15px}.btn-fixed{position:fixed!important;right:40px;bottom:60px;z-index:100}.draggable-icon{cursor:all-scroll;color:#6c757d}.draggable-icon:active,.draggable-icon:focus,.draggable-icon:hover{cursor:all-scroll;color:#212529}.module-side-nav{padding:20px 0}@media screen and (max-width:767px){.modal-box-mail .modal-w{min-width:500px}.modal-box-header h2{font-size:18px}}@media screen and (max-width:575px){.modal-w{min-width:300px}.modal-box-mail .modal-w{min-width:400px}.modal-box-header h2{font-size:16px}}@media screen and (max-width:419px){.modal-box-mail .modal-w,.modal-w{min-width:250px}}@media screen and (max-width:399px){.con-inf-mw-100{min-width:100%!important}}.app-calendar .rbc-calendar{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;min-height:calc(100vh - 160px)}.app-cul-calendar .rbc-calendar{min-height:calc(100vh - 200px)}.rbc-event{background-color:#3f51b5}.rbc-event.rbc-selected{background-color:#32408f}.rbc-slot-selection{background-color:rgba(63,81,181,.7)}.rbc-toolbar button.rbc-active,.rbc-toolbar button:active{background-image:none;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);-o-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.rbc-toolbar button.rbc-active,.rbc-toolbar button.rbc-active:focus,.rbc-toolbar button.rbc-active:hover,.rbc-toolbar button:active,.rbc-toolbar button:active:focus,.rbc-toolbar button:active:hover,.rbc-toolbar button:focus,.rbc-toolbar button:hover{color:#fff;background-color:rgba(63,81,181,.9);border-color:#3f51b5}.rbc-month-row{min-height:100px}.rbc-event{min-height:50px}@media screen and (max-width:867px){.rbc-toolbar{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-align-items:flex-start;align-items:flex-start}.rbc-toolbar .rbc-toolbar-label{margin:8px 0}}@media screen and (max-height:600px){.app-calendar .rbc-calendar,.app-cul-calendar .rbc-calendar{min-height:400px}}@media screen and (max-width:467px){.rbc-toolbar{font-size:12px}.rbc-toolbar button{padding:5px 10px}}.indigo .right-arrow,.indigo .right-arrow:after,.indigo a,.indigo a.text-primary{color:#e2e3e5}.indigo a.text-primary:focus,.indigo a.text-primary:hover,.indigo a:focus,.indigo a:hover{color:#c7c9cd}.indigo .text-primary{color:#e2e3e5!important}.indigo .page-link,.indigo .page-link:focus,.indigo .page-link:hover{color:#e2e3e5}.indigo .badge-primary,.indigo .bg-primary{background-color:#e2e3e5!important;color:#fff!important}.indigo .btn-primary{background-color:#e2e3e5;border-color:#e2e3e5;color:#fff}.indigo .btn-primary:active,.indigo .btn-primary:focus,.indigo .btn-primary:hover{background-color:#d5d6d9!important;border-color:#d5d6d9!important;color:#fff!important}.indigo .bg-primary.lighten-4{background-color:#c5cae9!important}.indigo .bg-primary.lighten-3{background-color:#9fa8da!important}.indigo .bg-primary.lighten-2{background-color:#7986cb!important}.indigo .bg-primary.lighten-1{background-color:#5c6bc0!important}.indigo .bg-primary.darken-1{background-color:#3949ab!important}.indigo .bg-primary.darken-2{background-color:#303f9f!important}.indigo .bg-primary.darken-3{background-color:#283593!important}.indigo .bg-primary.darken-4{background-color:#1a237e!important}.indigo .bg-primary.accent-1{background-color:#8c9eff!important}.indigo .bg-primary.accent-2{background-color:#536dfe!important}.indigo .bg-primary.accent-3{background-color:#3d5afe!important}.indigo .bg-primary.accent-4{background-color:#304ffe!important}.indigo a.text-secondary{color:#ff4081}.indigo a.text-secondary:focus,.indigo a.text-secondary:hover{color:#ff0d5f!important}.indigo .text-secondary{color:#ff4081!important}.indigo .badge-secondary,.indigo .bg-secondary{background-color:#ff4081!important;color:#fff!important}.indigo .btn-secondary{background-color:#ff4081;border-color:#ff4081;color:#fff}.indigo .btn-secondary:active,.indigo .btn-secondary:focus,.indigo .btn-secondary:hover{background-color:#ff2770!important;border-color:#ff2770!important;color:#fff!important}.indigo .app-main-header{background-color:#e2e3e5!important}.indigo .app-main-header .search-bar input{background-color:#eff0f1}.indigo .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.indigo .app-main-header .search-dropdown input{background-color:#fff}}.indigo .color-theme-header{background-color:#e2e3e5}.indigo .side-nav{background-color:#fff!important;color:#868e96!important}.indigo .side-nav,.indigo .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.indigo .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.indigo .side-nav .customizer{border-bottom:1px solid #e6e7e9}.indigo .side-nav .user-detail .user-name{color:#e2e3e5}.indigo ul.nav-menu .nav-header,.indigo ul.nav-menu li a{color:#868e96}.indigo ul.nav-menu>li.open>a,.indigo ul.nav-menu>li>a:focus,.indigo ul.nav-menu>li>a:hover{background-color:#fff;color:#e2e3e5}.indigo ul.nav-menu li.menu.open>a{border-color:#e2e3e5}.indigo ul.nav-menu li.menu>a:focus:before,.indigo ul.nav-menu li.menu>a:hover:before{color:#e2e3e5}.indigo ul.nav-menu li ul{background-color:#fff}.indigo ul.nav-menu li.menu>a:before{color:#868e96}.indigo ul.nav-menu li.menu.open>a:before,.indigo ul.nav-menu li.menu>a:focus:before,.indigo ul.nav-menu li.menu li>a:hover:before{color:#e2e3e5}.indigo ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.indigo ul.nav-menu li.menu.open .sub-menu li.active>a,.indigo ul.nav-menu li.menu.open .sub-menu li.active>a:before,.indigo ul.nav-menu li.menu .sub-menu li>a:focus,.indigo ul.nav-menu li.menu .sub-menu li>a:focus:before,.indigo ul.nav-menu li.menu .sub-menu li>a:hover,.indigo ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#e2e3e5}.indigo .module-nav li a.active{border-color:#e2e3e5}.indigo .rbc-event{background-color:#e2e3e5}.indigo .rbc-event.rbc-selected{background-color:#c7c9cd}.indigo .rbc-slot-selection{background-color:hsla(220,5%,89%,.7)}.indigo .rbc-toolbar button.rbc-active,.indigo .rbc-toolbar button.rbc-active:focus,.indigo .rbc-toolbar button.rbc-active:hover,.indigo .rbc-toolbar button:active,.indigo .rbc-toolbar button:active:focus,.indigo .rbc-toolbar button:active:hover,.indigo .rbc-toolbar button:focus,.indigo .rbc-toolbar button:hover{background-color:hsla(220,5%,89%,.9);border-color:#e2e3e5}.indigo .contact-list i{color:#e2e3e5}.indigo .Collapsible__trigger{background:#e2e3e5}.indigo .categories-list li.active a,.indigo .categories-list li a:focus,.indigo .categories-list li a:hover{color:#e2e3e5}.indigo .filter-with-bg-color ul li a,.indigo .login-content .form-control:focus{border-color:#e2e3e5}.indigo .filter-with-bg-color ul li a.active,.indigo .filter-with-bg-color ul li a:focus,.indigo .filter-with-bg-color ul li a:hover{background-color:#e2e3e5}.indigo .profile-intro .icon{color:#e2e3e5}.indigo .actions,.indigo .social-link li.active a,.indigo .social-link li a:focus,.indigo .social-link li a:hover{color:#ff4081}.indigo .table-hover tbody tr:hover{background-color:hsla(220,5%,89%,.075)}.indigo .border-primary{border-color:#e2e3e5!important}.indigo .app-logo-content{background-color:#e2e3e5}.indigo .app-social-block .social-link button{border:1px solid #e2e3e5;color:#e2e3e5}.indigo .app-social-block .social-link button:focus,.indigo .app-social-block .social-link button:hover{color:#fff;background-color:#e2e3e5}.cyan .right-arrow,.cyan .right-arrow:after,.cyan a,.cyan a.text-primary{color:#00bcd4}.cyan a.text-primary:focus,.cyan a.text-primary:hover,.cyan a:focus,.cyan a:hover{color:#008fa1}.cyan .text-primary{color:#00bcd4!important}.cyan .page-link,.cyan .page-link:focus,.cyan .page-link:hover{color:#00bcd4}.cyan .badge-primary,.cyan .bg-primary{background-color:#00bcd4!important;color:#fff!important}.cyan .btn-primary{background-color:#00bcd4;border-color:#00bcd4;color:#fff!important}.cyan .btn-primary:active,.cyan .btn-primary:focus,.cyan .btn-primary:hover{background-color:#00a5bb!important;border-color:#00a5bb!important;color:#fff!important}.cyan .bg-primary.lighten-4{background-color:#b2ebf2!important}.cyan .bg-primary.lighten-3{background-color:#80deea!important}.cyan .bg-primary.lighten-2{background-color:#4dd0e1!important}.cyan .bg-primary.lighten-1{background-color:#26c6da!important}.cyan .bg-primary.darken-1{background-color:#00acc1!important}.cyan .bg-primary.darken-2{background-color:#0097a7!important}.cyan .bg-primary.darken-3{background-color:#00838f!important}.cyan .bg-primary.darken-4{background-color:#006064!important}.cyan .bg-primary.accent-1{background-color:#84ffff!important}.cyan .bg-primary.accent-2{background-color:#18ffff!important}.cyan .bg-primary.accent-3{background-color:#00e5ff!important}.cyan .bg-primary.accent-4{background-color:#00b8d4!important}.cyan a.text-secondary{color:#69f0ae}.cyan a.text-secondary:focus,.cyan a.text-secondary:hover{color:#3beb95!important}.cyan .text-secondary{color:#69f0ae!important}.cyan .badge-secondary,.cyan .bg-secondary{background-color:#69f0ae!important;color:#fff!important}.cyan .btn-secondary{background-color:#69f0ae;border-color:#69f0ae;color:#fff}.cyan .btn-secondary:active,.cyan .btn-secondary:focus,.cyan .btn-secondary:hover{background-color:#52eea1!important;border-color:#52eea1!important;color:#fff!important}.cyan .app-main-header{background-color:#00bcd4!important}.cyan .app-main-header .search-bar input{background-color:#00d3ee}.cyan .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.cyan .app-main-header .search-dropdown input{background-color:#fff}}.cyan .color-theme-header{background-color:#00bcd4}.cyan .side-nav{background-color:#fff!important;color:#868e96!important}.cyan .side-nav,.cyan .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.cyan .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.cyan .side-nav .customizer{border-bottom:1px solid #e6e7e9}.cyan .side-nav .user-detail .user-name{color:#00bcd4}.cyan ul.nav-menu .nav-header,.cyan ul.nav-menu li a{color:#868e96}.cyan ul.nav-menu>li.open>a,.cyan ul.nav-menu>li>a:focus,.cyan ul.nav-menu>li>a:hover{background-color:#fff;color:#00bcd4}.cyan ul.nav-menu li.menu.open>a{border-color:#00bcd4}.cyan ul.nav-menu li.menu>a:focus:before,.cyan ul.nav-menu li.menu>a:hover:before{color:#00bcd4}.cyan ul.nav-menu li ul{background-color:#fff}.cyan ul.nav-menu li.menu>a:before{color:#868e96}.cyan ul.nav-menu li.menu.open>a:before,.cyan ul.nav-menu li.menu>a:focus:before,.cyan ul.nav-menu li.menu li>a:hover:before{color:#00bcd4}.cyan ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.cyan ul.nav-menu li.menu.open .sub-menu li.active>a,.cyan ul.nav-menu li.menu.open .sub-menu li.active>a:before,.cyan ul.nav-menu li.menu .sub-menu li>a:focus,.cyan ul.nav-menu li.menu .sub-menu li>a:focus:before,.cyan ul.nav-menu li.menu .sub-menu li>a:hover,.cyan ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#00bcd4}.cyan .module-nav li a.active{border-color:#00bcd4}.cyan .rbc-event{background-color:#00bcd4}.cyan .rbc-event.rbc-selected{background-color:#008fa1}.cyan .rbc-slot-selection{background-color:rgba(0,188,212,.7)}.cyan .rbc-toolbar button.rbc-active,.cyan .rbc-toolbar button.rbc-active:focus,.cyan .rbc-toolbar button.rbc-active:hover,.cyan .rbc-toolbar button:active,.cyan .rbc-toolbar button:active:focus,.cyan .rbc-toolbar button:active:hover,.cyan .rbc-toolbar button:focus,.cyan .rbc-toolbar button:hover{background-color:rgba(0,188,212,.9);border-color:#00bcd4}.cyan .contact-list i{color:#00bcd4}.cyan .Collapsible__trigger{background:#00bcd4}.cyan .categories-list li.active a,.cyan .categories-list li a:focus,.cyan .categories-list li a:hover{color:#00bcd4}.cyan .filter-with-bg-color ul li a,.cyan .login-content .form-control:focus{border-color:#00bcd4}.cyan .filter-with-bg-color ul li a.active,.cyan .filter-with-bg-color ul li a:focus,.cyan .filter-with-bg-color ul li a:hover{background-color:#00bcd4}.cyan .profile-intro .icon{color:#00bcd4}.cyan .actions,.cyan .social-link li.active a,.cyan .social-link li a:focus,.cyan .social-link li a:hover{color:#69f0ae}.cyan .table-hover tbody tr:hover{background-color:rgba(0,188,212,.075)}.cyan .border-primary{border-color:#00bcd4!important}.cyan .app-logo-content{background-color:#00bcd4}.cyan .app-social-block .social-link button{border:1px solid #00bcd4;color:#00bcd4}.cyan .app-social-block .social-link button:focus,.cyan .app-social-block .social-link button:hover{color:#fff;background-color:#00bcd4}.amber .side-nav,.amber .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.amber .side-nav .customizer{border-bottom:1px solid #e6e7e9}.amber .right-arrow,.amber .right-arrow:after,.amber a,.amber a.text-primary{color:#ffc107}.amber a.text-primary:focus,.amber a.text-primary:hover,.amber a:focus,.amber a:hover{color:#d39e00}.amber .text-primary{color:#ffc107!important}.amber .page-link,.amber .page-link:focus,.amber .page-link:hover{color:#ffc107}.amber .badge-primary,.amber .bg-primary{background-color:#ffc107!important;color:#fff!important}.amber .btn-primary{background-color:#ffc107;border-color:#ffc107;color:#fff}.amber .btn-primary:active,.amber .btn-primary:focus,.amber .btn-primary:hover{background-color:#edb100!important;border-color:#edb100!important;color:#fff!important}.amber .bg-primary.lighten-4{background-color:#ffecb3!important}.amber .bg-primary.lighten-3{background-color:#ffe082!important}.amber .bg-primary.lighten-2{background-color:#ffd54f!important}.amber .bg-primary.lighten-1{background-color:#ffca28!important}.amber .bg-primary.darken-1{background-color:#ffb300!important}.amber .bg-primary.darken-2{background-color:#ffa000!important}.amber .bg-primary.darken-3{background-color:#ff8f00!important}.amber .bg-primary.darken-4{background-color:#ff6f00!important}.amber .bg-primary.accent-1{background-color:#ffe57f!important}.amber .bg-primary.accent-2{background-color:#ffd740!important}.amber .bg-primary.accent-3{background-color:#ffc400!important}.amber .bg-primary.accent-4{background-color:#ffab00!important}.amber a.text-secondary{color:#ff3d00}.amber a.text-secondary:focus,.amber a.text-secondary:hover{color:#cc3100!important}.amber .text-secondary{color:#ff3d00!important}.amber .badge-secondary,.amber .bg-secondary{background-color:#ff3d00!important;color:#fff!important}.amber .btn-secondary{background-color:#ff3d00;border-color:#ff3d00;color:#fff}.amber .btn-secondary:active,.amber .btn-secondary:focus,.amber .btn-secondary:hover{background-color:#e63700;border-color:#e63700;color:#fff}.amber .app-main-header{background-color:#ffc107!important}.amber .app-main-header .search-bar input{background-color:#ffc721}.amber .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.amber .app-main-header .search-dropdown input{background-color:#fff}}.amber .color-theme-header{background-color:#ffc107}.amber .side-nav{background-color:#fff!important;color:#868e96!important}.amber .side-nav .user-profile{background-color:#fff}.amber .side-nav .user-detail .user-name{color:#ffc107}.amber ul.nav-menu .nav-header,.amber ul.nav-menu li a{color:#868e96}.amber ul.nav-menu>li.open>a,.amber ul.nav-menu>li>a:focus,.amber ul.nav-menu>li>a:hover{background-color:#fff;color:#ffc107}.amber ul.nav-menu li.open>a{border-color:#ffc107}.amber ul.nav-menu li.menu>a:focus:before,.amber ul.nav-menu li.menu>a:hover:before{color:#ffc107}.amber ul.nav-menu li ul{background-color:#fff}.amber ul.nav-menu li.menu>a:before{color:#a1a1a1}.amber ul.nav-menu li.menu.open>a:before,.amber ul.nav-menu li.menu>a:focus:before,.amber ul.nav-menu li.menu li>a:hover:before{color:#ffc107}.amber ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.amber ul.nav-menu li.menu.open .sub-menu li.active>a,.amber ul.nav-menu li.menu.open .sub-menu li.active>a:before,.amber ul.nav-menu li.menu .sub-menu li>a:focus,.amber ul.nav-menu li.menu .sub-menu li>a:focus:before,.amber ul.nav-menu li.menu .sub-menu li>a:hover,.amber ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#ffc107}.amber .module-nav li a.active{border-color:#ffc107}.amber .rbc-event{background-color:#ffc107}.amber .rbc-event.rbc-selected{background-color:#d39e00}.amber .rbc-slot-selection{background-color:rgba(255,193,7,.7)}.amber .rbc-toolbar button.rbc-active,.amber .rbc-toolbar button.rbc-active:focus,.amber .rbc-toolbar button.rbc-active:hover,.amber .rbc-toolbar button:active,.amber .rbc-toolbar button:active:focus,.amber .rbc-toolbar button:active:hover,.amber .rbc-toolbar button:focus,.amber .rbc-toolbar button:hover{background-color:rgba(255,193,7,.9);border-color:#ffc107}.amber .contact-list i{color:#ffc107}.amber .Collapsible__trigger{background:#ffc107}.amber .categories-list li.active a,.amber .categories-list li a:focus,.amber .categories-list li a:hover{color:#ffc107}.amber .filter-with-bg-color ul li a,.amber .login-content .form-control:focus{border-color:#ffc107}.amber .filter-with-bg-color ul li a.active,.amber .filter-with-bg-color ul li a:focus,.amber .filter-with-bg-color ul li a:hover{background-color:#ffc107}.amber .profile-intro .icon{color:#ffc107}.amber .actions,.amber .social-link li.active a,.amber .social-link li a:focus,.amber .social-link li a:hover{color:#ff3d00}.amber .table-hover tbody tr:hover{background-color:rgba(255,193,7,.075)}.amber .border-primary{border-color:#ffc107!important}.amber .app-logo-content{background-color:#ffc107}.amber .app-social-block .social-link button{border:1px solid #ffc107;color:#ffc107}.amber .app-social-block .social-link button:focus,.amber .app-social-block .social-link button:hover{color:#fff;background-color:#ffc107}.deep-orange .right-arrow,.deep-orange .right-arrow:after,.deep-orange a,.deep-orange a.text-primary{color:#ff5722}.deep-orange a.text-primary:focus,.deep-orange a.text-primary:hover,.deep-orange a:focus,.deep-orange a:hover{color:#ee3900}.deep-orange .text-primary{color:#ff5722!important}.deep-orange .page-link,.deep-orange .page-link:focus,.deep-orange .page-link:hover{color:#ff5722}.deep-orange .badge-primary,.deep-orange .bg-primary{background-color:#ff5722!important;color:#fff!important}.deep-orange .btn-primary{background-color:#ff5722;border-color:#ff5722;color:#fff}.deep-orange .btn-primary:active,.deep-orange .btn-primary:focus,.deep-orange .btn-primary:hover{background-color:#ff4409!important;border-color:#ff4409!important;color:#fff!important}.deep-orange .bg-primary.lighten-4{background-color:#ffccbc!important}.deep-orange .bg-primary.lighten-3{background-color:#ffab91!important}.deep-orange .bg-primary.lighten-2{background-color:#ff8a65!important}.deep-orange .bg-primary.lighten-1{background-color:#ff7043!important}.deep-orange .bg-primary.darken-1{background-color:#f4511e!important}.deep-orange .bg-primary.darken-2{background-color:#e64a19!important}.deep-orange .bg-primary.darken-3{background-color:#d84315!important}.deep-orange .bg-primary.darken-4{background-color:#bf360c!important}.deep-orange .bg-primary.accent-1{background-color:#ff9e80!important}.deep-orange .bg-primary.accent-2{background-color:#ff6e40!important}.deep-orange .bg-primary.accent-3{background-color:#ff3d00!important}.deep-orange .bg-primary.accent-4{background-color:#dd2c00!important}.deep-orange a.text-secondary{color:#40c4ff}.deep-orange a.text-secondary:focus,.deep-orange a.text-secondary:hover{color:#0db4ff!important}.deep-orange .text-secondary{color:#40c4ff!important}.deep-orange .badge-secondary,.deep-orange .bg-secondary{background-color:#40c4ff!important}.deep-orange .btn-secondary{background-color:#40c4ff;border-color:#40c4ff}.deep-orange .btn-secondary:active,.deep-orange .btn-secondary:focus,.deep-orange .btn-secondary:hover{background-color:#27bcff!important;border-color:#27bcff!important}.deep-orange .app-main-header{background-color:#ff5722!important}.deep-orange .app-main-header .search-bar input{background-color:#ff6a3c}.deep-orange .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.deep-orange .app-main-header .search-dropdown input{background-color:#fff}}.deep-orange .color-theme-header{background-color:#ff5722}.deep-orange .side-nav{background-color:#fff!important;color:#868e96!important}.deep-orange .side-nav,.deep-orange .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.deep-orange .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.deep-orange .side-nav .customizer{border-bottom:1px solid #e6e7e9}.deep-orange .side-nav .user-detail .user-name{color:#ff5722}.deep-orange ul.nav-menu .nav-header,.deep-orange ul.nav-menu li a{color:#868e96}.deep-orange ul.nav-menu>li.open>a,.deep-orange ul.nav-menu>li>a:focus,.deep-orange ul.nav-menu>li>a:hover{background-color:#fff;color:#ff5722}.deep-orange ul.nav-menu li.menu.open>a{border-color:#ff5722}.deep-orange ul.nav-menu li.menu>a:focus:before,.deep-orange ul.nav-menu li.menu>a:hover:before{color:#ff5722}.deep-orange ul.nav-menu li ul{background-color:#fff}.deep-orange ul.nav-menu li.menu>a:before{color:#868e96}.deep-orange ul.nav-menu li.menu.open>a:before,.deep-orange ul.nav-menu li.menu>a:focus:before,.deep-orange ul.nav-menu li.menu li>a:hover:before{color:#ff5722}.deep-orange ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.deep-orange ul.nav-menu li.menu.open .sub-menu li.active>a,.deep-orange ul.nav-menu li.menu.open .sub-menu li.active>a:before,.deep-orange ul.nav-menu li.menu .sub-menu li>a:focus,.deep-orange ul.nav-menu li.menu .sub-menu li>a:focus:before,.deep-orange ul.nav-menu li.menu .sub-menu li>a:hover,.deep-orange ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#ff5722}.deep-orange .module-nav li a.active{border-color:#ff5722}.deep-orange .rbc-event{background-color:#ff5722}.deep-orange .rbc-event.rbc-selected{background-color:#ee3900}.deep-orange .rbc-slot-selection{background-color:rgba(255,87,34,.7)}.deep-orange .rbc-toolbar button.rbc-active,.deep-orange .rbc-toolbar button.rbc-active:focus,.deep-orange .rbc-toolbar button.rbc-active:hover,.deep-orange .rbc-toolbar button:active,.deep-orange .rbc-toolbar button:active:focus,.deep-orange .rbc-toolbar button:active:hover,.deep-orange .rbc-toolbar button:focus,.deep-orange .rbc-toolbar button:hover{background-color:rgba(255,87,34,.9);border-color:#ff5722}.deep-orange .contact-list i{color:#ff5722}.deep-orange .Collapsible__trigger{background:#ff5722}.deep-orange .categories-list li.active a,.deep-orange .categories-list li a:focus,.deep-orange .categories-list li a:hover{color:#ff5722}.deep-orange .filter-with-bg-color ul li a,.deep-orange .login-content .form-control:focus{border-color:#ff5722}.deep-orange .filter-with-bg-color ul li a.active,.deep-orange .filter-with-bg-color ul li a:focus,.deep-orange .filter-with-bg-color ul li a:hover{background-color:#ff5722}.deep-orange .profile-intro .icon{color:#ff5722}.deep-orange .actions,.deep-orange .social-link li.active a,.deep-orange .social-link li a:focus,.deep-orange .social-link li a:hover{color:#40c4ff}.deep-orange .table-hover tbody tr:hover{background-color:rgba(255,87,34,.075)}.deep-orange .border-primary{border-color:#ff5722!important}.deep-orange .app-logo-content{background-color:#ff5722}.deep-orange .app-social-block .social-link button{border:1px solid #ff5722;color:#ff5722}.deep-orange .app-social-block .social-link button:focus,.deep-orange .app-social-block .social-link button:hover{color:#fff;background-color:#ff5722}.pink .right-arrow,.pink .right-arrow:after,.pink a,.pink a.text-primary{color:#e91e63}.pink a.text-primary:focus,.pink a.text-primary:hover,.pink a:focus,.pink a:hover{color:#c1134e}.pink .text-primary{color:#e91e63!important}.pink .page-link,.pink .page-link:focus,.pink .page-link:hover{color:#e91e63}.pink .badge-primary,.pink .bg-primary{background-color:#e91e63!important;color:#fff!important}.pink .btn-primary{background-color:#e91e63;border-color:#e91e63;color:#fff}.pink .btn-primary:active,.pink .btn-primary:focus,.pink .btn-primary:hover{background-color:#d81558!important;border-color:#d81558!important;color:#fff!important}.pink .bg-primary.lighten-4{background-color:#f8bbd0!important}.pink .bg-primary.lighten-3{background-color:#f48fb1!important}.pink .bg-primary.lighten-2{background-color:#f06292!important}.pink .bg-primary.lighten-1{background-color:#ec407a!important}.pink .bg-primary.darken-1{background-color:#d81b60!important}.pink .bg-primary.darken-2{background-color:#c2185b!important}.pink .bg-primary.darken-3{background-color:#ad1457!important}.pink .bg-primary.darken-4{background-color:#880e4f!important}.pink .bg-primary.accent-1{background-color:#ff80ab!important}.pink .bg-primary.accent-2{background-color:#ff4081!important}.pink .bg-primary.accent-3{background-color:#f50057!important}.pink .bg-primary.accent-4{background-color:#c51162!important}.deep-orange a.text-secondary{color:#00bfa5}.deep-orange a.text-secondary:focus,.deep-orange a.text-secondary:hover{color:#008c79!important}.deep-orange .text-secondary{color:#00bfa5!important}.deep-orange .badge-secondary,.deep-orange .bg-secondary{background-color:#00bfa5!important;color:#fff!important}.deep-orange .btn-secondary{background-color:#00bfa5;border-color:#00bfa5;color:#fff}.deep-orange .btn-secondary:active,.deep-orange .btn-secondary:focus,.deep-orange .btn-secondary:hover{background-color:#00a68f!important;border-color:#00a68f!important;color:#fff!important}.pink .app-main-header{background-color:#e91e63!important}.pink .app-main-header .search-bar input{background-color:#eb3573}.pink .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.pink .app-main-header .search-dropdown input{background-color:#fff}}.pink .color-theme-header{background-color:#e91e63}.pink .side-nav{background-color:#fff!important;color:#868e96!important}.pink .side-nav,.pink .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.pink .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.pink .side-nav .customizer{border-bottom:1px solid #e6e7e9}.pink .side-nav .user-detail .user-name{color:#e91e63}.pink ul.nav-menu .nav-header,.pink ul.nav-menu li a{color:#868e96}.pink ul.nav-menu>li.open>a,.pink ul.nav-menu>li>a:focus,.pink ul.nav-menu>li>a:hover{background-color:#fff;color:#e91e63}.pink ul.nav-menu li.menu.open>a{border-color:#e91e63}.pink ul.nav-menu li.menu>a:focus:before,.pink ul.nav-menu li.menu>a:hover:before{color:#e91e63}.pink ul.nav-menu li ul{background-color:#fff}.pink ul.nav-menu li.menu>a:before{color:#868e96}.pink ul.nav-menu li.menu.open>a:before,.pink ul.nav-menu li.menu>a:focus:before,.pink ul.nav-menu li.menu li>a:hover:before{color:#e91e63}.pink ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.pink ul.nav-menu li.menu.open .sub-menu li.active>a,.pink ul.nav-menu li.menu.open .sub-menu li.active>a:before,.pink ul.nav-menu li.menu .sub-menu li>a:focus,.pink ul.nav-menu li.menu .sub-menu li>a:focus:before,.pink ul.nav-menu li.menu .sub-menu li>a:hover,.pink ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#e91e63}.pink .module-nav li a.active{border-color:#e91e63}.pink .rbc-event{background-color:#e91e63}.pink .rbc-event.rbc-selected{background-color:#c1134e}.pink .rbc-slot-selection{background-color:rgba(233,30,99,.7)}.pink .rbc-toolbar button.rbc-active,.pink .rbc-toolbar button.rbc-active:focus,.pink .rbc-toolbar button.rbc-active:hover,.pink .rbc-toolbar button:active,.pink .rbc-toolbar button:active:focus,.pink .rbc-toolbar button:active:hover,.pink .rbc-toolbar button:focus,.pink .rbc-toolbar button:hover{background-color:rgba(233,30,99,.9);border-color:#e91e63}.pink .contact-list i{color:#e91e63}.pink .Collapsible__trigger{background:#e91e63}.pink .categories-list li.active a,.pink .categories-list li a:focus,.pink .categories-list li a:hover{color:#e91e63}.pink .filter-with-bg-color ul li a,.pink .login-content .form-control:focus{border-color:#e91e63}.pink .filter-with-bg-color ul li a.active,.pink .filter-with-bg-color ul li a:focus,.pink .filter-with-bg-color ul li a:hover{background-color:#e91e63}.pink .profile-intro .icon{color:#e91e63}.pink .actions,.pink .social-link li.active a,.pink .social-link li a:focus,.pink .social-link li a:hover{color:#00bfa5}.pink .table-hover tbody tr:hover{background-color:rgba(233,30,99,.075)}.pink .border-primary{border-color:#e91e63!important}.pink .app-logo-content{background-color:#e91e63}.pink .app-social-block .social-link button{border:1px solid #e91e63;color:#e91e63}.pink .app-social-block .social-link button:focus,.pink .app-social-block .social-link button:hover{color:#fff;background-color:#e91e63}.blue .right-arrow,.blue .right-arrow:after,.blue a,.blue a.text-primary{color:#2196f3}.blue a.text-primary:focus,.blue a.text-primary:hover,.blue a:focus,.blue a:hover{color:#0c7cd5}.blue .text-primary{color:#2196f3!important}.blue .page-link,.blue .page-link:focus,.blue .page-link:hover{color:#2196f3}.blue .badge-primary,.blue .bg-primary{background-color:#2196f3!important;color:#fff!important}.blue .btn-primary{background-color:#2196f3;border-color:#2196f3;color:#fff}.blue .btn-primary:active,.blue .btn-primary:focus,.blue .btn-primary:hover{background-color:#0d8aee!important;border-color:#0d8aee!important;color:#fff!important}.blue .bg-primary.lighten-4{background-color:#bbdefb!important}.blue .bg-primary.lighten-3{background-color:#90caf9!important}.blue .bg-primary.lighten-2{background-color:#64b5f6!important}.blue .bg-primary.lighten-1{background-color:#42a5f5!important}.blue .bg-primary.darken-1{background-color:#1e88e5!important}.blue .bg-primary.darken-2{background-color:#1976d2!important}.blue .bg-primary.darken-3{background-color:#1565c0!important}.blue .bg-primary.darken-4{background-color:#0d47a1!important}.blue .bg-primary.accent-1{background-color:#82b1ff!important}.blue .bg-primary.accent-2{background-color:#448aff!important}.blue .bg-primary.accent-3{background-color:#2979ff!important}.blue .bg-primary.accent-4{background-color:#2962ff!important}.blue a.text-secondary{color:#ff6e40}.blue a.text-secondary:focus,.blue a.text-secondary:hover{color:#ff470d!important}.blue .text-secondary{color:#ff6e40!important}.blue .badge-secondary,.blue .bg-secondary{background-color:#ff6e40!important;color:#fff!important}.blue .btn-secondary{background-color:#ff6e40;border-color:#ff6e40;color:#fff}.blue .btn-secondary:active,.blue .btn-secondary:focus,.blue .btn-secondary:hover{background-color:#ff5b27!important;border-color:#ff5b27!important;color:#fff!important}.blue .app-main-header{background-color:#2196f3!important}.blue .app-main-header .search-bar input{background-color:#39a1f4}.blue .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.blue .app-main-header .search-dropdown input{background-color:#fff}}.blue .color-theme-header{background-color:#2196f3}.blue .side-nav{background-color:#fff!important;color:#868e96!important}.blue .side-nav,.blue .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.blue .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.blue .side-nav .customizer{border-bottom:1px solid #e6e7e9}.blue .side-nav .user-detail .user-name{color:#2196f3}.blue ul.nav-menu .nav-header,.blue ul.nav-menu li a{color:#868e96}.blue ul.nav-menu>li.open>a,.blue ul.nav-menu>li>a:focus,.blue ul.nav-menu>li>a:hover{background-color:#fff;color:#2196f3}.blue ul.nav-menu li.menu.open>a{border-color:#2196f3}.blue ul.nav-menu li.menu>a:focus:before,.blue ul.nav-menu li.menu>a:hover:before{color:#2196f3}.blue ul.nav-menu li ul{background-color:#fff}.blue ul.nav-menu li.menu>a:before{color:#868e96}.blue ul.nav-menu li.menu.open>a:before,.blue ul.nav-menu li.menu>a:focus:before,.blue ul.nav-menu li.menu li>a:hover:before{color:#2196f3}.blue ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.blue ul.nav-menu li.menu.open .sub-menu li.active>a,.blue ul.nav-menu li.menu.open .sub-menu li.active>a:before,.blue ul.nav-menu li.menu .sub-menu li>a:focus,.blue ul.nav-menu li.menu .sub-menu li>a:focus:before,.blue ul.nav-menu li.menu .sub-menu li>a:hover,.blue ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#2196f3}.blue .module-nav li a.active{border-color:#2196f3}.blue .rbc-event{background-color:#2196f3}.blue .rbc-event.rbc-selected{background-color:#0c7cd5}.blue .rbc-slot-selection{background-color:rgba(33,150,243,.7)}.blue .rbc-toolbar button.rbc-active,.blue .rbc-toolbar button.rbc-active:focus,.blue .rbc-toolbar button.rbc-active:hover,.blue .rbc-toolbar button:active,.blue .rbc-toolbar button:active:focus,.blue .rbc-toolbar button:active:hover,.blue .rbc-toolbar button:focus,.blue .rbc-toolbar button:hover{background-color:rgba(33,150,243,.9);border-color:#2196f3}.blue .contact-list i{color:#2196f3}.blue .Collapsible__trigger{background:#2196f3}.blue .categories-list li.active a,.blue .categories-list li a:focus,.blue .categories-list li a:hover{color:#2196f3}.blue .filter-with-bg-color ul li a,.blue .login-content .form-control:focus{border-color:#2196f3}.blue .filter-with-bg-color ul li a.active,.blue .filter-with-bg-color ul li a:focus,.blue .filter-with-bg-color ul li a:hover{background-color:#2196f3}.blue .profile-intro .icon{color:#2196f3}.blue .actions,.blue .social-link li.active a,.blue .social-link li a:focus,.blue .social-link li a:hover{color:#ff6e40}.blue .table-hover tbody tr:hover{background-color:rgba(33,150,243,.075)}.blue .border-primary{border-color:#2196f3!important}.blue .app-logo-content{background-color:#2196f3}.blue .app-social-block .social-link button{border:1px solid #2196f3;color:#2196f3}.blue .app-social-block .social-link button:focus,.blue .app-social-block .social-link button:hover{color:#fff;background-color:#2196f3}.deep-purple .right-arrow,.deep-purple .right-arrow:after,.deep-purple a,.deep-purple a.text-primary{color:#673ab7}.deep-purple a.text-primary:focus,.deep-purple a.text-primary:hover,.deep-purple a:focus,.deep-purple a:hover{color:#512e90}.deep-purple .text-primary{color:#673ab7!important}.deep-purple .page-link,.deep-purple .page-link:focus,.deep-purple .page-link:hover{color:#673ab7}.deep-purple .badge-primary,.deep-purple .bg-primary{background-color:#673ab7!important;color:#fff!important}.deep-purple .btn-primary{background-color:#673ab7;border-color:#673ab7;color:#fff}.deep-purple .btn-primary:active,.deep-purple .btn-primary:focus,.deep-purple .btn-primary:hover{background-color:#5c34a4!important;border-color:#5c34a4!important;color:#fff!important}.deep-purple .bg-primary.lighten-4{background-color:#d1c4e9!important}.deep-purple .bg-primary.lighten-3{background-color:#b39ddb!important}.deep-purple .bg-primary.lighten-2{background-color:#9575cd!important}.deep-purple .bg-primary.lighten-1{background-color:#7e57c2!important}.deep-purple .bg-primary.darken-1{background-color:#5e35b1!important}.deep-purple .bg-primary.darken-2{background-color:#512da8!important}.deep-purple .bg-primary.darken-3{background-color:#4527a0!important}.deep-purple .bg-primary.darken-4{background-color:#311b92!important}.deep-purple .bg-primary.accent-1{background-color:#b388ff!important}.deep-purple .bg-primary.accent-2{background-color:#7c4dff!important}.deep-purple .bg-primary.accent-3{background-color:#651fff!important}.deep-purple .bg-primary.accent-4{background-color:#6200ea!important}.deep-purple a.text-secondary{color:#ffab00}.deep-purple a.text-secondary:focus,.deep-purple a.text-secondary:hover{color:#cc8900!important}.deep-purple .text-secondary{color:#ffab00!important}.deep-purple .badge-secondary,.deep-purple .bg-secondary{background-color:#ffab00!important;color:#fff!important}.deep-purple .btn-secondary{background-color:#ffab00;border-color:#ffab00;color:#fff}.deep-purple .btn-secondary:active,.deep-purple .btn-secondary:focus,.deep-purple .btn-secondary:hover{background-color:#e69a00!important;border-color:#e69a00!important;color:#fff!important}.deep-purple .app-main-header{background-color:#673ab7!important}.deep-purple .app-main-header .search-bar input{background-color:#7446c4}.deep-purple .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.deep-purple .app-main-header .search-dropdown input{background-color:#fff}}.deep-purple .color-theme-header{background-color:#673ab7}.deep-purple .side-nav{background-color:#fff!important;color:#868e96!important}.deep-purple .side-nav,.deep-purple .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.deep-purple .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.deep-purple .side-nav .customizer{border-bottom:1px solid #e6e7e9}.deep-purple .side-nav .user-detail .user-name{color:#673ab7}.deep-purple ul.nav-menu .nav-header,.deep-purple ul.nav-menu li a{color:#868e96}.deep-purple ul.nav-menu>li.open>a,.deep-purple ul.nav-menu>li>a:focus,.deep-purple ul.nav-menu>li>a:hover{background-color:#fff;color:#673ab7}.deep-purple ul.nav-menu li.menu.open>a{border-color:#673ab7}.deep-purple ul.nav-menu li.menu>a:focus:before,.deep-purple ul.nav-menu li.menu>a:hover:before{color:#673ab7}.deep-purple ul.nav-menu li ul{background-color:#fff}.deep-purple ul.nav-menu li.menu>a:before{color:#868e96}.deep-purple ul.nav-menu li.menu.open>a:before,.deep-purple ul.nav-menu li.menu>a:focus:before,.deep-purple ul.nav-menu li.menu li>a:hover:before{color:#673ab7}.deep-purple ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.deep-purple ul.nav-menu li.menu.open .sub-menu li.active>a,.deep-purple ul.nav-menu li.menu.open .sub-menu li.active>a:before,.deep-purple ul.nav-menu li.menu .sub-menu li>a:focus,.deep-purple ul.nav-menu li.menu .sub-menu li>a:focus:before,.deep-purple ul.nav-menu li.menu .sub-menu li>a:hover,.deep-purple ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#673ab7}.deep-purple .module-nav li a.active{border-color:#673ab7}.deep-purple .rbc-event{background-color:#673ab7}.deep-purple .rbc-event.rbc-selected{background-color:#512e90}.deep-purple .rbc-slot-selection{background-color:rgba(103,58,183,.7)}.deep-purple .rbc-toolbar button.rbc-active,.deep-purple .rbc-toolbar button.rbc-active:focus,.deep-purple .rbc-toolbar button.rbc-active:hover,.deep-purple .rbc-toolbar button:active,.deep-purple .rbc-toolbar button:active:focus,.deep-purple .rbc-toolbar button:active:hover,.deep-purple .rbc-toolbar button:focus,.deep-purple .rbc-toolbar button:hover{background-color:rgba(103,58,183,.9);border-color:#673ab7}.deep-purple .contact-list i{color:#673ab7}.deep-purple .Collapsible__trigger{background:#673ab7}.deep-purple .categories-list li.active a,.deep-purple .categories-list li a:focus,.deep-purple .categories-list li a:hover{color:#673ab7}.deep-purple .filter-with-bg-color ul li a,.deep-purple .login-content .form-control:focus{border-color:#673ab7}.deep-purple .filter-with-bg-color ul li a.active,.deep-purple .filter-with-bg-color ul li a:focus,.deep-purple .filter-with-bg-color ul li a:hover{background-color:#673ab7}.deep-purple .profile-intro .icon{color:#673ab7}.deep-purple .actions,.deep-purple .social-link li.active a,.deep-purple .social-link li a:focus,.deep-purple .social-link li a:hover{color:#ffab00}.deep-purple .table-hover tbody tr:hover{background-color:rgba(103,58,183,.075)}.deep-purple .border-primary{border-color:#673ab7!important}.deep-purple .app-logo-content{background-color:#673ab7}.deep-purple .app-social-block .social-link button{border:1px solid #673ab7;color:#673ab7}.deep-purple .app-social-block .social-link button:focus,.deep-purple .app-social-block .social-link button:hover{color:#fff;background-color:#673ab7}.green .right-arrow,.green .right-arrow:after,.green a,.green a.text-primary{color:#4caf50}.green a.text-primary:focus,.green a.text-primary:hover,.green a:focus,.green a:hover{color:#3d8b40}.green .text-primary{color:#4caf50!important}.green .page-link,.green .page-link:focus,.green .page-link:hover{color:#4caf50}.green .badge-primary,.green .bg-primary{background-color:#4caf50!important;color:#fff!important}.green .btn-primary{background-color:#4caf50;border-color:#4caf50;color:#fff}.green .btn-primary:active,.green .btn-primary:focus,.green .btn-primary:hover{background-color:#449d48!important;border-color:#449d48!important;color:#fff!important}.green .bg-primary.lighten-4{background-color:#c8e6c9!important}.green .bg-primary.lighten-3{background-color:#a5d6a7!important}.green .bg-primary.lighten-2{background-color:#81c784!important}.green .bg-primary.lighten-1{background-color:#66bb6a!important}.green .bg-primary.darken-1{background-color:#43a047!important}.green .bg-primary.darken-2{background-color:#388e3c!important}.green .bg-primary.darken-3{background-color:#2e7d32!important}.green .bg-primary.darken-4{background-color:#1b5e20!important}.green .bg-primary.accent-1{background-color:#b9f6ca!important}.green .bg-primary.accent-2{background-color:#69f0ae!important}.green .bg-primary.accent-3{background-color:#00e676!important}.green .bg-primary.accent-4{background-color:#00c853!important}.green a.text-secondary{color:#ff6d00}.green a.text-secondary:focus,.green a.text-secondary:hover{color:#cc5700!important}.green .text-secondary{color:#ff6d00!important}.green .badge-secondary,.green .bg-secondary{background-color:#ff6d00!important;color:#fff!important}.green .btn-secondary{background-color:#ff6d00;border-color:#ff6d00;color:#fff}.green .btn-secondary:active,.green .btn-secondary:focus,.green .btn-secondary:hover{background-color:#e66200!important;border-color:#e66200!important;color:#fff!important}.green .app-main-header{background-color:#4caf50!important}.green .app-main-header .search-bar input{background-color:#5cb860}.green .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.green .app-main-header .search-dropdown input{background-color:#fff}}.green .color-theme-header{background-color:#4caf50}.green .side-nav{background-color:#fff!important;color:#868e96!important}.green .side-nav,.green .side-nav .user-profile{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}.green .side-nav .user-profile{background-color:#fff;position:relative;z-index:2}.green .side-nav .customizer{border-bottom:1px solid #e6e7e9}.green .side-nav .user-detail .user-name{color:#4caf50}.green ul.nav-menu .nav-header,.green ul.nav-menu li a{color:#868e96}.green ul.nav-menu>li.open>a,.green ul.nav-menu>li>a:focus,.green ul.nav-menu>li>a:hover{background-color:#fff;color:#4caf50}.green ul.nav-menu li.menu.open>a{border-color:#4caf50}.green ul.nav-menu li.menu>a:focus:before,.green ul.nav-menu li.menu>a:hover:before{color:#4caf50}.green ul.nav-menu li ul{background-color:#fff}.green ul.nav-menu li.menu>a:before{color:#868e96}.green ul.nav-menu li.menu.open>a:before,.green ul.nav-menu li.menu>a:focus:before,.green ul.nav-menu li.menu li>a:hover:before{color:#4caf50}.green ul.nav-menu li.menu .sub-menu li>a:before{color:#868e96}.green ul.nav-menu li.menu.open .sub-menu li.active>a,.green ul.nav-menu li.menu.open .sub-menu li.active>a:before,.green ul.nav-menu li.menu .sub-menu li>a:focus,.green ul.nav-menu li.menu .sub-menu li>a:focus:before,.green ul.nav-menu li.menu .sub-menu li>a:hover,.green ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#fff;color:#4caf50}.green .module-nav li a.active{border-color:#4caf50}.green .rbc-event{background-color:#4caf50}.green .rbc-event.rbc-selected{background-color:#3d8b40}.green .rbc-slot-selection{background-color:rgba(76,175,80,.7)}.green .rbc-toolbar button.rbc-active,.green .rbc-toolbar button.rbc-active:focus,.green .rbc-toolbar button.rbc-active:hover,.green .rbc-toolbar button:active,.green .rbc-toolbar button:active:focus,.green .rbc-toolbar button:active:hover,.green .rbc-toolbar button:focus,.green .rbc-toolbar button:hover{background-color:rgba(76,175,80,.9);border-color:#4caf50}.green .contact-list i{color:#4caf50}.green .Collapsible__trigger{background:#4caf50}.green .categories-list li.active a,.green .categories-list li a:focus,.green .categories-list li a:hover{color:#4caf50}.green .filter-with-bg-color ul li a,.green .login-content .form-control:focus{border-color:#4caf50}.green .filter-with-bg-color ul li a.active,.green .filter-with-bg-color ul li a:focus,.green .filter-with-bg-color ul li a:hover{background-color:#4caf50}.green .profile-intro .icon{color:#4caf50}.green .actions,.green .social-link li.active a,.green .social-link li a:focus,.green .social-link li a:hover{color:#ff6d00}.green .table-hover tbody tr:hover{background-color:rgba(76,175,80,.075)}.green .border-primary{border-color:#4caf50!important}.green .app-logo-content{background-color:#4caf50}.green .app-social-block .social-link button{border:1px solid #4caf50;color:#4caf50}.green .app-social-block .social-link button:focus,.green .app-social-block .social-link button:hover{color:#fff;background-color:#4caf50}.dark-indigo .right-arrow,.dark-indigo .right-arrow:after,.dark-indigo a,.dark-indigo a.text-primary{color:#3f51b5}.dark-indigo a.text-primary:focus,.dark-indigo a.text-primary:hover,.dark-indigo a:focus,.dark-indigo a:hover{color:#32408f}.dark-indigo .text-primary{color:#3f51b5!important}.dark-indigo .page-link,.dark-indigo .page-link:focus,.dark-indigo .page-link:hover{color:#3f51b5}.dark-indigo .badge-primary,.dark-indigo .bg-primary{background-color:#3f51b5!important;color:#fff!important}.dark-indigo .btn-primary{background-color:#3f51b5;border-color:#3f51b5;color:#fff}.dark-indigo .btn-primary:active,.dark-indigo .btn-primary:focus,.dark-indigo .btn-primary:hover{background-color:#3849a2!important;border-color:#3849a2!important;color:#fff!important}.dark-indigo .bg-primary.lighten-4{background-color:#c5cae9!important}.dark-indigo .bg-primary.lighten-3{background-color:#9fa8da!important}.dark-indigo .bg-primary.lighten-2{background-color:#7986cb!important}.dark-indigo .bg-primary.lighten-1{background-color:#5c6bc0!important}.dark-indigo .bg-primary.darken-1{background-color:#3949ab!important}.dark-indigo .bg-primary.darken-2{background-color:#303f9f!important}.dark-indigo .bg-primary.darken-3{background-color:#283593!important}.dark-indigo .bg-primary.darken-4{background-color:#1a237e!important}.dark-indigo .bg-primary.accent-1{background-color:#8c9eff!important}.dark-indigo .bg-primary.accent-2{background-color:#536dfe!important}.dark-indigo .bg-primary.accent-3{background-color:#3d5afe!important}.dark-indigo .bg-primary.accent-4{background-color:#304ffe!important}.dark-indigo a.text-secondary{color:#ff4081}.dark-indigo a.text-secondary:focus,.dark-indigo a.text-secondary:hover{color:#ff0d5f!important}.dark-indigo .text-secondary{color:#ff4081!important}.dark-indigo .badge-secondary,.dark-indigo .bg-secondary{background-color:#ff4081!important;color:#fff!important}.dark-indigo .btn-secondary{background-color:#ff4081;border-color:#ff4081;color:#fff}.dark-indigo .btn-secondary:active,.dark-indigo .btn-secondary:focus,.dark-indigo .btn-secondary:hover{background-color:#ff2770!important;border-color:#ff2770!important;color:#fff!important}.dark-indigo .app-main-header{background-color:#3f51b5!important}.dark-indigo .app-main-header .search-bar input{background-color:#4d5ec1}.dark-indigo .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-indigo .app-main-header .search-dropdown input{background-color:#fff}}.dark-indigo .color-theme-header{background-color:#3f51b5}.dark-indigo .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-indigo .side-nav,.dark-indigo .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-indigo .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-indigo .side-nav .customizer{border-bottom:0 none}.dark-indigo .side-nav .user-detail .user-name{color:#fff}.dark-indigo ul.nav-menu .nav-header,.dark-indigo ul.nav-menu li a{color:#a1a1a1}.dark-indigo ul.nav-menu>li.open>a,.dark-indigo ul.nav-menu>li>a:focus,.dark-indigo ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-indigo ul.nav-menu li.menu.open>a{border-color:#ff9800}.dark-indigo ul.nav-menu li.menu>a:focus:before,.dark-indigo ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-indigo ul.nav-menu li ul{background-color:#1d1d1d}.dark-indigo ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-indigo ul.nav-menu li.menu.open>a:before,.dark-indigo ul.nav-menu li.menu>a:focus:before,.dark-indigo ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-indigo ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-indigo ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-indigo ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:focus,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:hover,.dark-indigo ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-indigo .module-nav li a.active{color:#3f51b5}.dark-indigo .rbc-event{background-color:#3f51b5}.dark-indigo .rbc-event.rbc-selected{background-color:#32408f}.dark-indigo .rbc-slot-selection{background-color:rgba(63,81,181,.7)}.dark-indigo .rbc-toolbar button.rbc-active,.dark-indigo .rbc-toolbar button.rbc-active:focus,.dark-indigo .rbc-toolbar button.rbc-active:hover,.dark-indigo .rbc-toolbar button:active,.dark-indigo .rbc-toolbar button:active:focus,.dark-indigo .rbc-toolbar button:active:hover,.dark-indigo .rbc-toolbar button:focus,.dark-indigo .rbc-toolbar button:hover{background-color:rgba(63,81,181,.9);border-color:#3f51b5}.dark-indigo .categories-list li.active a,.dark-indigo .categories-list li a:focus,.dark-indigo .categories-list li a:hover,.dark-indigo .contact-list i{color:#3f51b5}.dark-indigo .filter-with-bg-color ul li a,.dark-indigo .login-content .form-control:focus{border-color:#3f51b5}.dark-indigo .filter-with-bg-color ul li a.active,.dark-indigo .filter-with-bg-color ul li a:focus,.dark-indigo .filter-with-bg-color ul li a:hover{background-color:#3f51b5}.dark-indigo .profile-intro .icon{color:#3f51b5}.dark-indigo .actions,.dark-indigo .social-link li.active a,.dark-indigo .social-link li a:focus,.dark-indigo .social-link li a:hover{color:#ff4081}.dark-indigo .table-hover tbody tr:hover{background-color:rgba(63,81,181,.075)}.dark-indigo .border-primary{border-color:#3f51b5!important}.dark-indigo .app-logo-content{background-color:#3f51b5}.dark-indigo .app-social-block .social-link button{border:1px solid #3f51b5;color:#3f51b5}.dark-indigo .app-social-block .social-link button:focus,.dark-indigo .app-social-block .social-link button:hover{color:#fff;background-color:#3f51b5}.dark-cyan .right-arrow,.dark-cyan .right-arrow:after,.dark-cyan a,.dark-cyan a.text-primary{color:#00bcd4}.dark-cyan a.text-primary:focus,.dark-cyan a.text-primary:hover,.dark-cyan a:focus,.dark-cyan a:hover{color:#008fa1}.dark-cyan .text-primary{color:#00bcd4!important}.dark-cyan .page-link,.dark-cyan .page-link:focus,.dark-cyan .page-link:hover{color:#00bcd4}.dark-cyan .badge-primary,.dark-cyan .bg-primary{background-color:#00bcd4!important;color:#fff!important}.dark-cyan .btn-primary{background-color:#00bcd4;border-color:#00bcd4;color:#fff}.dark-cyan .btn-primary:active,.dark-cyan .btn-primary:focus,.dark-cyan .btn-primary:hover{background-color:#00a5bb!important;border-color:#00a5bb!important;color:#fff!important}.dark-cyan .bg-primary.lighten-4{background-color:#b2ebf2!important}.dark-cyan .bg-primary.lighten-3{background-color:#80deea!important}.dark-cyan .bg-primary.lighten-2{background-color:#4dd0e1!important}.dark-cyan .bg-primary.lighten-1{background-color:#26c6da!important}.dark-cyan .bg-primary.darken-1{background-color:#00acc1!important}.dark-cyan .bg-primary.darken-2{background-color:#0097a7!important}.dark-cyan .bg-primary.darken-3{background-color:#00838f!important}.dark-cyan .bg-primary.darken-4{background-color:#006064!important}.dark-cyan .bg-primary.accent-1{background-color:#84ffff!important}.dark-cyan .bg-primary.accent-2{background-color:#18ffff!important}.dark-cyan .bg-primary.accent-3{background-color:#00e5ff!important}.dark-cyan .bg-primary.accent-4{background-color:#00b8d4!important}.dark-cyan a.text-secondary{color:#69f0ae}.dark-cyan a.text-secondary:focus,.dark-cyan a.text-secondary:hover{color:#3beb95!important}.dark-cyan .text-secondary{color:#69f0ae!important}.dark-cyan .badge-secondary,.dark-cyan .bg-secondary{background-color:#69f0ae!important;color:#fff!important}.dark-cyan .btn-secondary{background-color:#69f0ae;border-color:#69f0ae;color:#fff}.dark-cyan .btn-secondary:active,.dark-cyan .btn-secondary:focus,.dark-cyan .btn-secondary:hover{background-color:#52eea1!important;border-color:#52eea1!important;color:#fff!important}.dark-cyan .app-main-header{background-color:#00bcd4!important}.dark-cyan .app-main-header .search-bar input{background-color:#00d3ee}.dark-cyan .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-cyan .app-main-header .search-dropdown input{background-color:#fff}}.dark-cyan .color-theme-header{background-color:#00bcd4}.dark-cyan .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-cyan .side-nav,.dark-cyan .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-cyan .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-cyan .side-nav .customizer{border-bottom:0 none}.dark-cyan .side-nav .user-detail .user-name{color:#fff}.dark-cyan ul.nav-menu .nav-header,.dark-cyan ul.nav-menu li a{color:#a1a1a1}.dark-cyan ul.nav-menu>li.open>a,.dark-cyan ul.nav-menu>li>a:focus,.dark-cyan ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-cyan ul.nav-menu li.menu.open>a{border-color:#00bcd4}.dark-cyan ul.nav-menu li.menu>a:focus:before,.dark-cyan ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-cyan ul.nav-menu li ul{background-color:#1d1d1d}.dark-cyan ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-cyan ul.nav-menu li.menu.open>a:before,.dark-cyan ul.nav-menu li.menu>a:focus:before,.dark-cyan ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-cyan ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-cyan ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-cyan ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:focus,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:hover,.dark-cyan ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-cyan .module-nav li a.active{border-color:#00bcd4}.dark-cyan .rbc-event{background-color:#00bcd4}.dark-cyan .rbc-event.rbc-selected{background-color:#008fa1}.dark-cyan .rbc-slot-selection{background-color:rgba(0,188,212,.7)}.dark-cyan .rbc-toolbar button.rbc-active,.dark-cyan .rbc-toolbar button.rbc-active:focus,.dark-cyan .rbc-toolbar button.rbc-active:hover,.dark-cyan .rbc-toolbar button:active,.dark-cyan .rbc-toolbar button:active:focus,.dark-cyan .rbc-toolbar button:active:hover,.dark-cyan .rbc-toolbar button:focus,.dark-cyan .rbc-toolbar button:hover{background-color:rgba(0,188,212,.9);border-color:#00bcd4}.dark-cyan .chat-sidenav-title{color:#00bcd4}.dark-cyan .chat-user-item.active,.dark-cyan .chat-user-item:hover{background-color:#bbf7ff}.dark-cyan .contact-list i{color:#00bcd4}.dark-cyan .Collapsible__trigger{background:#00bcd4}.dark-cyan .categories-list li.active a,.dark-cyan .categories-list li a:focus,.dark-cyan .categories-list li a:hover{color:#00bcd4}.dark-cyan .filter-with-bg-color ul li a,.dark-cyan .login-content .form-control:focus{border-color:#00bcd4}.dark-cyan .filter-with-bg-color ul li a.active,.dark-cyan .filter-with-bg-color ul li a:focus,.dark-cyan .filter-with-bg-color ul li a:hover{background-color:#00bcd4}.dark-cyan .profile-intro .icon{color:#00bcd4}.dark-cyan .actions,.dark-cyan .social-link li.active a,.dark-cyan .social-link li a:focus,.dark-cyan .social-link li a:hover{color:#69f0ae}.dark-cyan .table-hover tbody tr:hover{background-color:rgba(0,188,212,.075)}.dark-cyan .border-primary{border-color:#00bcd4!important}.dark-cyan .app-logo-content{background-color:#00bcd4}.dark-cyan .app-social-block .social-link button{border:1px solid #00bcd4;color:#00bcd4}.dark-cyan .app-social-block .social-link button:focus,.dark-cyan .app-social-block .social-link button:hover{color:#fff;background-color:#00bcd4}.dark-amber .right-arrow,.dark-amber .right-arrow:after,.dark-amber a,.dark-amber a.text-primary{color:#ffc107}.dark-amber a.text-primary:focus,.dark-amber a.text-primary:hover,.dark-amber a:focus,.dark-amber a:hover{color:#d39e00}.dark-amber .text-primary{color:#ffc107!important}.dark-amber .page-link,.dark-amber .page-link:focus,.dark-amber .page-link:hover{color:#ffc107}.dark-amber .badge-primary,.dark-amber .bg-primary{background-color:#ffc107!important;color:#fff!important}.dark-amber .btn-primary{background-color:#ffc107;border-color:#ffc107;color:#fff}.dark-amber .btn-primary:active,.dark-amber .btn-primary:focus,.dark-amber .btn-primary:hover{background-color:#edb100!important;border-color:#edb100!important;color:#fff!important}.dark-amber .bg-primary.lighten-4{background-color:#ffecb3!important}.dark-amber .bg-primary.lighten-3{background-color:#ffe082!important}.dark-amber .bg-primary.lighten-2{background-color:#ffd54f!important}.dark-amber .bg-primary.lighten-1{background-color:#ffca28!important}.dark-amber .bg-primary.darken-1{background-color:#ffb300!important}.dark-amber .bg-primary.darken-2{background-color:#ffa000!important}.dark-amber .bg-primary.darken-3{background-color:#ff8f00!important}.dark-amber .bg-primary.darken-4{background-color:#ff6f00!important}.dark-amber .bg-primary.accent-1{background-color:#ffe57f!important}.dark-amber .bg-primary.accent-2{background-color:#ffd740!important}.dark-amber .bg-primary.accent-3{background-color:#ffc400!important}.dark-amber .bg-primary.accent-4{background-color:#ffab00!important}.dark-amber a.text-secondary{color:#ff3d00}.dark-amber a.text-secondary:focus,.dark-amber a.text-secondary:hover{color:#cc3100!important}.dark-amber .text-secondary{color:#ff3d00!important}.dark-amber .badge-secondary,.dark-amber .bg-secondary{background-color:#ff3d00!important;color:#fff!important}.dark-amber .btn-secondary{background-color:#ff3d00;border-color:#ff3d00;color:#fff}.dark-amber .btn-secondary:active,.dark-amber .btn-secondary:focus,.dark-amber .btn-secondary:hover{background-color:#e63700!important;border-color:#e63700!important;color:#fff!important}.dark-amber .app-main-header{background-color:#ffc107!important}.dark-amber .app-main-header .search-bar input{background-color:#ffc721}.dark-amber .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-amber .app-main-header .search-dropdown input{background-color:#fff}}.dark-amber .color-theme-header{background-color:#ffc107}.dark-amber .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-amber .side-nav,.dark-amber .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-amber .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-amber .side-nav .customizer{border-bottom:0 none}.dark-amber .side-nav .user-detail .user-name{color:#fff}.dark-amber ul.nav-menu .nav-header,.dark-amber ul.nav-menu li a{color:#a1a1a1}.dark-amber ul.nav-menu>li.open>a,.dark-amber ul.nav-menu>li>a:focus,.dark-amber ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-amber ul.nav-menu li.menu.open>a{border-color:#ffc107}.dark-amber ul.nav-menu li.menu>a:focus:before,.dark-amber ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-amber ul.nav-menu li ul{background-color:#1d1d1d}.dark-amber ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-amber ul.nav-menu li.menu.open>a:before,.dark-amber ul.nav-menu li.menu>a:focus:before,.dark-amber ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-amber ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-amber ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-amber ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-amber ul.nav-menu li.menu .sub-menu li>a:focus,.dark-amber ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-amber ul.nav-menu li.menu .sub-menu li>a:hover,.dark-amber ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-amber .module-nav li a.active{border-color:#ffc107}.dark-amber .rbc-event{background-color:#ffc107}.dark-amber .rbc-event.rbc-selected{background-color:#d39e00}.dark-amber .rbc-slot-selection{background-color:rgba(255,193,7,.7)}.dark-amber .rbc-toolbar button.rbc-active,.dark-amber .rbc-toolbar button.rbc-active:focus,.dark-amber .rbc-toolbar button.rbc-active:hover,.dark-amber .rbc-toolbar button:active,.dark-amber .rbc-toolbar button:active:focus,.dark-amber .rbc-toolbar button:active:hover,.dark-amber .rbc-toolbar button:focus,.dark-amber .rbc-toolbar button:hover{background-color:rgba(255,193,7,.9);border-color:#ffc107}.dark-amber .chat-sidenav-title{color:#ffc107}.dark-amber .chat-user-item.active,.dark-amber .chat-user-item:hover{background-color:#fffaed}.dark-amber .contact-list i{color:#ffc107}.dark-amber .Collapsible__trigger{background:#ffc107}.dark-amber .categories-list li.active a,.dark-amber .categories-list li a:focus,.dark-amber .categories-list li a:hover{color:#ffc107}.dark-amber .filter-with-bg-color ul li a,.dark-amber .login-content .form-control:focus{border-color:#ffc107}.dark-amber .filter-with-bg-color ul li a.active,.dark-amber .filter-with-bg-color ul li a:focus,.dark-amber .filter-with-bg-color ul li a:hover{background-color:#ffc107}.dark-amber .profile-intro .icon{color:#ffc107}.dark-amber .actions,.dark-amber .social-link li.active a,.dark-amber .social-link li a:focus,.dark-amber .social-link li a:hover{color:#ff3d00}.dark-amber .table-hover tbody tr:hover{background-color:rgba(255,193,7,.075)}.dark-amber .border-primary{border-color:#ffc107!important}.dark-amber .app-logo-content{background-color:#ffc107}.dark-amber .app-social-block .social-link button{border:1px solid #ffc107;color:#ffc107}.dark-amber .app-social-block .social-link button:focus,.dark-amber .app-social-block .social-link button:hover{color:#fff;background-color:#ffc107}.dark-deep-orange .right-arrow,.dark-deep-orange .right-arrow:after,.dark-deep-orange a,.dark-deep-orange a.text-primary{color:#ff5722}.dark-deep-orange a.text-primary:focus,.dark-deep-orange a.text-primary:hover,.dark-deep-orange a:focus,.dark-deep-orange a:hover{color:#ee3900}.dark-deep-orange .text-primary{color:#ff5722!important}.dark-deep-orange .page-link,.dark-deep-orange .page-link:focus,.dark-deep-orange .page-link:hover{color:#ff5722}.dark-deep-orange .badge-primary,.dark-deep-orange .bg-primary{background-color:#ff5722!important;color:#fff!important}.dark-deep-orange .btn-primary{background-color:#ff5722;border-color:#ff5722;color:#fff}.dark-deep-orange .btn-primary:active,.dark-deep-orange .btn-primary:focus,.dark-deep-orange .btn-primary:hover{background-color:#ff4409!important;border-color:#ff4409!important;color:#fff!important}.dark-deep-orange .bg-primary.lighten-4{background-color:#ffccbc!important}.dark-deep-orange .bg-primary.lighten-3{background-color:#ffab91!important}.dark-deep-orange .bg-primary.lighten-2{background-color:#ff8a65!important}.dark-deep-orange .bg-primary.lighten-1{background-color:#ff7043!important}.dark-deep-orange .bg-primary.darken-1{background-color:#f4511e!important}.dark-deep-orange .bg-primary.darken-2{background-color:#e64a19!important}.dark-deep-orange .bg-primary.darken-3{background-color:#d84315!important}.dark-deep-orange .bg-primary.darken-4{background-color:#bf360c!important}.dark-deep-orange .bg-primary.accent-1{background-color:#ff9e80!important}.dark-deep-orange .bg-primary.accent-2{background-color:#ff6e40!important}.dark-deep-orange .bg-primary.accent-3{background-color:#ff3d00!important}.dark-deep-orange .bg-primary.accent-4{background-color:#dd2c00!important}.dark-deep-orange a.text-secondary{color:#40c4ff}.dark-deep-orange a.text-secondary:focus,.dark-deep-orange a.text-secondary:hover{color:#0db4ff!important}.dark-deep-orange .text-secondary{color:#40c4ff!important}.dark-deep-orange .badge-secondary,.dark-deep-orange .bg-secondary{background-color:#40c4ff!important;color:#fff!important}.dark-deep-orange .btn-secondary{background-color:#40c4ff;border-color:#40c4ff;color:#fff}.dark-deep-orange .btn-secondary:active,.dark-deep-orange .btn-secondary:focus,.dark-deep-orange .btn-secondary:hover{background-color:#27bcff!important;border-color:#27bcff!important;color:#fff!important}.dark-deep-orange .app-main-header{background-color:#ff5722!important}.dark-deep-orange .app-main-header .search-bar input{background-color:#ff6a3c}.dark-deep-orange .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-deep-orange .app-main-header .search-dropdown input{background-color:#fff}}.dark-deep-orange .color-theme-header{background-color:#ff5722}.dark-deep-orange .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-deep-orange .side-nav,.dark-deep-orange .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-deep-orange .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-deep-orange .side-nav .customizer{border-bottom:0 none}.dark-deep-orange .side-nav .user-detail .user-name{color:#fff}.dark-deep-orange ul.nav-menu .nav-header,.dark-deep-orange ul.nav-menu li a{color:#a1a1a1}.dark-deep-orange ul.nav-menu>li.open>a,.dark-deep-orange ul.nav-menu>li>a:focus,.dark-deep-orange ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-deep-orange ul.nav-menu li.menu.open>a{border-color:#ff5722}.dark-deep-orange ul.nav-menu li.menu>a:focus:before,.dark-deep-orange ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-deep-orange ul.nav-menu li ul{background-color:#1d1d1d}.dark-deep-orange ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-deep-orange ul.nav-menu li.menu.open>a:before,.dark-deep-orange ul.nav-menu li.menu>a:focus:before,.dark-deep-orange ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-deep-orange ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-deep-orange ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:focus,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:hover,.dark-deep-orange ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-deep-orange .module-nav li a.active{border-color:#ff5722}.dark-deep-orange .rbc-event{background-color:#ff5722}.dark-deep-orange .rbc-event.rbc-selected{background-color:#ee3900}.dark-deep-orange .rbc-slot-selection{background-color:rgba(255,87,34,.7)}.dark-deep-orange .rbc-toolbar button.rbc-active,.dark-deep-orange .rbc-toolbar button.rbc-active:focus,.dark-deep-orange .rbc-toolbar button.rbc-active:hover,.dark-deep-orange .rbc-toolbar button:active,.dark-deep-orange .rbc-toolbar button:active:focus,.dark-deep-orange .rbc-toolbar button:active:hover,.dark-deep-orange .rbc-toolbar button:focus,.dark-deep-orange .rbc-toolbar button:hover{background-color:rgba(255,87,34,.9);border-color:#ff5722}.dark-deep-orange .contact-list i{color:#ff5722}.dark-deep-orange .Collapsible__trigger{background:#ff5722}.dark-deep-orange .categories-list li.active a,.dark-deep-orange .categories-list li a:focus,.dark-deep-orange .categories-list li a:hover{color:#ff5722}.dark-deep-orange .filter-with-bg-color ul li a,.dark-deep-orange .login-content .form-control:focus{border-color:#ff5722}.dark-deep-orange .filter-with-bg-color ul li a.active,.dark-deep-orange .filter-with-bg-color ul li a:focus,.dark-deep-orange .filter-with-bg-color ul li a:hover{background-color:#ff5722}.dark-deep-orange .profile-intro .icon{color:#ff5722}.dark-deep-orange .actions,.dark-deep-orange .social-link li.active a,.dark-deep-orange .social-link li a:focus,.dark-deep-orange .social-link li a:hover{color:#40c4ff}.dark-deep-orange .table-hover tbody tr:hover{background-color:rgba(255,87,34,.075)}.dark-deep-orange .border-primary{border-color:#ff5722!important}.dark-deep-orange .app-logo-content{background-color:#ff5722}.dark-deep-orange .app-social-block .social-link button{border:1px solid #ff5722;color:#ff5722}.dark-deep-orange .app-social-block .social-link button:focus,.dark-deep-orange .app-social-block .social-link button:hover{color:#fff;background-color:#ff5722}.dark-pink .right-arrow,.dark-pink .right-arrow:after,.dark-pink a,.dark-pink a.text-primary{color:#e91e63}.dark-pink a.text-primary:focus,.dark-pink a.text-primary:hover,.dark-pink a:focus,.dark-pink a:hover{color:#c1134e}.dark-pink .text-primary{color:#e91e63!important}.dark-pink .page-link,.dark-pink .page-link:focus,.dark-pink .page-link:hover{color:#e91e63}.dark-pink .badge-primary,.dark-pink .bg-primary{background-color:#e91e63!important;color:#fff!important}.dark-pink .btn-primary{background-color:#e91e63;border-color:#e91e63;color:#fff}.dark-pink .btn-primary:active,.dark-pink .btn-primary:focus,.dark-pink .btn-primary:hover{background-color:#d81558!important;border-color:#d81558!important;color:#fff!important}.dark-pink .bg-primary.lighten-4{background-color:#f8bbd0!important}.dark-pink .bg-primary.lighten-3{background-color:#f48fb1!important}.dark-pink .bg-primary.lighten-2{background-color:#f06292!important}.dark-pink .bg-primary.lighten-1{background-color:#ec407a!important}.dark-pink .bg-primary.darken-1{background-color:#d81b60!important}.dark-pink .bg-primary.darken-2{background-color:#c2185b!important}.dark-pink .bg-primary.darken-3{background-color:#ad1457!important}.dark-pink .bg-primary.darken-4{background-color:#880e4f!important}.dark-pink .bg-primary.accent-1{background-color:#ff80ab!important}.dark-pink .bg-primary.accent-2{background-color:#ff4081!important}.dark-pink .bg-primary.accent-3{background-color:#f50057!important}.dark-pink .bg-primary.accent-4{background-color:#c51162!important}.dark-pink a.text-secondary{color:#00bfa5}.dark-pink a.text-secondary:focus,.dark-pink a.text-secondary:hover{color:#008c79!important}.dark-pink .text-secondary{color:#00bfa5!important}.dark-pink .badge-secondary,.dark-pink .bg-secondary{background-color:#00bfa5!important;color:#fff!important}.dark-pink .btn-secondary{background-color:#00bfa5;border-color:#00bfa5;color:#fff}.dark-pink .btn-secondary:active,.dark-pink .btn-secondary:focus,.dark-pink .btn-secondary:hover{background-color:#00a68f!important;border-color:#00a68f!important;color:#fff!important}.dark-pink .app-main-header{background-color:#e91e63!important}.dark-pink .app-main-header .search-bar input{background-color:#eb3573}.dark-pink .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-pink .app-main-header .search-dropdown input{background-color:#fff}}.dark-pink .color-theme-header{background-color:#e91e63}.dark-pink .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-pink .side-nav,.dark-pink .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-pink .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-pink .side-nav .customizer{border-bottom:0 none}.dark-pink .side-nav .user-detail .user-name{color:#fff}.dark-pink ul.nav-menu .nav-header,.dark-pink ul.nav-menu li a{color:#a1a1a1}.dark-pink ul.nav-menu>li.open>a,.dark-pink ul.nav-menu>li>a:focus,.dark-pink ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-pink ul.nav-menu li.menu.open>a{border-color:#e91e63}.dark-pink ul.nav-menu li.menu>a:focus:before,.dark-pink ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-pink ul.nav-menu li ul{background-color:#1d1d1d}.dark-pink ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-pink ul.nav-menu li.menu.open>a:before,.dark-pink ul.nav-menu li.menu>a:focus:before,.dark-pink ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-pink ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-pink ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-pink ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-pink ul.nav-menu li.menu .sub-menu li>a:focus,.dark-pink ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-pink ul.nav-menu li.menu .sub-menu li>a:hover,.dark-pink ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-pink .module-nav li a.active{border-color:#e91e63}.dark-pink .rbc-event{background-color:#e91e63}.dark-pink .rbc-event.rbc-selected{background-color:#c1134e}.dark-pink .rbc-slot-selection{background-color:rgba(233,30,99,.7)}.dark-pink .rbc-toolbar button.rbc-active,.dark-pink .rbc-toolbar button.rbc-active:focus,.dark-pink .rbc-toolbar button.rbc-active:hover,.dark-pink .rbc-toolbar button:active,.dark-pink .rbc-toolbar button:active:focus,.dark-pink .rbc-toolbar button:active:hover,.dark-pink .rbc-toolbar button:focus,.dark-pink .rbc-toolbar button:hover{background-color:rgba(233,30,99,.9);border-color:#e91e63}.dark-pink .chat-sidenav-title{color:#e91e63}.dark-pink .chat-user-item.active,.dark-pink .chat-user-item:hover{background-color:#fdeff4}.dark-pink .contact-list i{color:#e91e63}.dark-pink .Collapsible__trigger{background:#e91e63}.dark-pink .categories-list li.active a,.dark-pink .categories-list li a:focus,.dark-pink .categories-list li a:hover{color:#e91e63}.dark-pink .filter-with-bg-color ul li a,.dark-pink .login-content .form-control:focus{border-color:#e91e63}.dark-pink .filter-with-bg-color ul li a.active,.dark-pink .filter-with-bg-color ul li a:focus,.dark-pink .filter-with-bg-color ul li a:hover{background-color:#e91e63}.dark-pink .profile-intro .icon{color:#e91e63}.dark-pink .actions,.dark-pink .social-link li.active a,.dark-pink .social-link li a:focus,.dark-pink .social-link li a:hover{color:#00bfa5}.dark-pink .table-hover tbody tr:hover{background-color:rgba(233,30,99,.075)}.dark-pink .border-primary{border-color:#e91e63!important}.dark-pink .app-logo-content{background-color:#e91e63}.dark-pink .app-social-block .social-link button{border:1px solid #e91e63;color:#e91e63}.dark-pink .app-social-block .social-link button:focus,.dark-pink .app-social-block .social-link button:hover{color:#fff;background-color:#e91e63}.dark-blue .right-arrow,.dark-blue .right-arrow:after,.dark-blue a,.dark-blue a.text-primary{color:#2196f3}.dark-blue a.text-primary:focus,.dark-blue a.text-primary:hover,.dark-blue a:focus,.dark-blue a:hover{color:#0c7cd5}.dark-blue .text-primary{color:#2196f3!important}.dark-blue .page-link,.dark-blue .page-link:focus,.dark-blue .page-link:hover{color:#2196f3}.dark-blue .badge-primary,.dark-blue .bg-primary{background-color:#2196f3!important;color:#fff!important}.dark-blue .btn-primary{background-color:#2196f3;border-color:#2196f3;color:#fff}.dark-blue .btn-primary:active,.dark-blue .btn-primary:focus,.dark-blue .btn-primary:hover{background-color:#0d8aee!important;border-color:#0d8aee!important;color:#fff!important}.dark-blue .bg-primary.lighten-4{background-color:#bbdefb!important}.dark-blue .bg-primary.lighten-3{background-color:#90caf9!important}.dark-blue .bg-primary.lighten-2{background-color:#64b5f6!important}.dark-blue .bg-primary.lighten-1{background-color:#42a5f5!important}.dark-blue .bg-primary.darken-1{background-color:#1e88e5!important}.dark-blue .bg-primary.darken-2{background-color:#1976d2!important}.dark-blue .bg-primary.darken-3{background-color:#1565c0!important}.dark-blue .bg-primary.darken-4{background-color:#0d47a1!important}.dark-blue .bg-primary.accent-1{background-color:#82b1ff!important}.dark-blue .bg-primary.accent-2{background-color:#448aff!important}.dark-blue .bg-primary.accent-3{background-color:#2979ff!important}.dark-blue .bg-primary.accent-4{background-color:#2962ff!important}.dark-blue a.text-secondary{color:#ff6e40}.dark-blue a.text-secondary:focus,.dark-blue a.text-secondary:hover{color:#ff470d!important}.dark-blue .text-secondary{color:#ff6e40!important}.dark-blue .badge-secondary,.dark-blue .bg-secondary{background-color:#ff6e40!important;color:#fff!important}.dark-blue .btn-secondary{background-color:#ff6e40;border-color:#ff6e40;color:#fff}.dark-blue .btn-secondary:active,.dark-blue .btn-secondary:focus,.dark-blue .btn-secondary:hover{background-color:#ff5b27!important;border-color:#ff5b27!important;color:#fff!important}.dark-blue .app-main-header{background-color:#2196f3!important}.dark-blue .app-main-header .search-bar input{background-color:#39a1f4}.dark-blue .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-blue .app-main-header .search-dropdown input{background-color:#fff}}.dark-blue .color-theme-header{background-color:#2196f3}.dark-blue .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-blue .side-nav,.dark-blue .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-blue .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-blue .side-nav .customizer{border-bottom:0 none}.dark-blue .side-nav .user-detail .user-name{color:#fff}.dark-blue ul.nav-menu .nav-header,.dark-blue ul.nav-menu li a{color:#a1a1a1}.dark-blue ul.nav-menu>li.open>a,.dark-blue ul.nav-menu>li>a:focus,.dark-blue ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-blue ul.nav-menu li.menu.open>a{border-color:#2196f3}.dark-blue ul.nav-menu li.menu>a:focus:before,.dark-blue ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-blue ul.nav-menu li ul{background-color:#1d1d1d}.dark-blue ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-blue ul.nav-menu li.menu.open>a:before,.dark-blue ul.nav-menu li.menu>a:focus:before,.dark-blue ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-blue ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-blue ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-blue ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-blue ul.nav-menu li.menu .sub-menu li>a:focus,.dark-blue ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-blue ul.nav-menu li.menu .sub-menu li>a:hover,.dark-blue ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-blue .module-nav li a.active{border-color:#2196f3}.dark-blue .rbc-event{background-color:#2196f3}.dark-blue .rbc-event.rbc-selected{background-color:#0c7cd5}.dark-blue .rbc-slot-selection{background-color:rgba(33,150,243,.7)}.dark-blue .rbc-toolbar button.rbc-active,.dark-blue .rbc-toolbar button.rbc-active:focus,.dark-blue .rbc-toolbar button.rbc-active:hover,.dark-blue .rbc-toolbar button:active,.dark-blue .rbc-toolbar button:active:focus,.dark-blue .rbc-toolbar button:active:hover,.dark-blue .rbc-toolbar button:focus,.dark-blue .rbc-toolbar button:hover{background-color:rgba(33,150,243,.9);border-color:#2196f3}.dark-blue .contact-list i{color:#2196f3}.dark-blue .Collapsible__trigger{background:#2196f3}.dark-blue .categories-list li.active a,.dark-blue .categories-list li a:focus,.dark-blue .categories-list li a:hover{color:#2196f3}.dark-blue .filter-with-bg-color ul li a,.dark-blue .login-content .form-control:focus{border-color:#2196f3}.dark-blue .filter-with-bg-color ul li a.active,.dark-blue .filter-with-bg-color ul li a:focus,.dark-blue .filter-with-bg-color ul li a:hover{background-color:#2196f3}.dark-blue .profile-intro .icon{color:#2196f3}.dark-blue .actions,.dark-blue .social-link li.active a,.dark-blue .social-link li a:focus,.dark-blue .social-link li a:hover{color:#ff6e40}.dark-blue .table-hover tbody tr:hover{background-color:rgba(33,150,243,.075)}.dark-blue .border-primary{border-color:#2196f3!important}.dark-blue .app-logo-content{background-color:#2196f3}.dark-blue .app-social-block .social-link button{border:1px solid #2196f3;color:#2196f3}.dark-blue .app-social-block .social-link button:focus,.dark-blue .app-social-block .social-link button:hover{color:#fff;background-color:#2196f3}.dark-deep-purple .right-arrow,.dark-deep-purple .right-arrow:after,.dark-deep-purple a,.dark-deep-purple a.text-primary{color:#673ab7}.dark-deep-purple a.text-primary:focus,.dark-deep-purple a.text-primary:hover,.dark-deep-purple a:focus,.dark-deep-purple a:hover{color:#512e90}.dark-deep-purple .text-primary{color:#673ab7!important}.dark-deep-purple .page-link,.dark-deep-purple .page-link:focus,.dark-deep-purple .page-link:hover{color:#673ab7}.dark-deep-purple .badge-primary,.dark-deep-purple .bg-primary{background-color:#673ab7!important;color:#fff!important}.dark-deep-purple .btn-primary{background-color:#673ab7;border-color:#673ab7;color:#fff}.dark-deep-purple .btn-primary:active,.dark-deep-purple .btn-primary:focus,.dark-deep-purple .btn-primary:hover{background-color:#5c34a4!important;border-color:#5c34a4!important;color:#fff!important}.dark-deep-purple .bg-primary.lighten-4{background-color:#d1c4e9!important}.dark-deep-purple .bg-primary.lighten-3{background-color:#b39ddb!important}.dark-deep-purple .bg-primary.lighten-2{background-color:#9575cd!important}.dark-deep-purple .bg-primary.lighten-1{background-color:#7e57c2!important}.dark-deep-purple .bg-primary.darken-1{background-color:#5e35b1!important}.dark-deep-purple .bg-primary.darken-2{background-color:#512da8!important}.dark-deep-purple .bg-primary.darken-3{background-color:#4527a0!important}.dark-deep-purple .bg-primary.darken-4{background-color:#311b92!important}.dark-deep-purple .bg-primary.accent-1{background-color:#b388ff!important}.dark-deep-purple .bg-primary.accent-2{background-color:#7c4dff!important}.dark-deep-purple .bg-primary.accent-3{background-color:#651fff!important}.dark-deep-purple .bg-primary.accent-4{background-color:#6200ea!important}.dark-deep-purple a.text-secondary{color:#ffab00}.dark-deep-purple a.text-secondary:focus,.dark-deep-purple a.text-secondary:hover{color:#cc8900!important}.dark-deep-purple .text-secondary{color:#ffab00!important}.dark-deep-purple .badge-secondary,.dark-deep-purple .bg-secondary{background-color:#ffab00!important;color:#fff!important}.dark-deep-purple .btn-secondary{background-color:#ffab00;border-color:#ffab00;color:#fff}.dark-deep-purple .btn-secondary:active,.dark-deep-purple .btn-secondary:focus,.dark-deep-purple .btn-secondary:hover{background-color:#e69a00!important;border-color:#e69a00!important;color:#fff!important}.dark-deep-purple .app-main-header{background-color:#673ab7!important}.dark-deep-purple .app-main-header .search-bar input{background-color:#7446c4}.dark-deep-purple .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-deep-purple .app-main-header .search-dropdown input{background-color:#fff}}.dark-deep-purple .color-theme-header{background-color:#673ab7}.dark-deep-purple .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-deep-purple .side-nav,.dark-deep-purple .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-deep-purple .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-deep-purple .side-nav .customizer{border-bottom:0 none}.dark-deep-purple .side-nav .user-detail .user-name{color:#fff}.dark-deep-purple ul.nav-menu .nav-header,.dark-deep-purple ul.nav-menu li a{color:#a1a1a1}.dark-deep-purple ul.nav-menu>li.open>a,.dark-deep-purple ul.nav-menu>li>a:focus,.dark-deep-purple ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-deep-purple ul.nav-menu li.menu.open>a{border-color:#ffab00}.dark-deep-purple ul.nav-menu li.menu>a:focus:before,.dark-deep-purple ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-deep-purple ul.nav-menu li ul{background-color:#1d1d1d}.dark-deep-purple ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-deep-purple ul.nav-menu li.menu.open>a:before,.dark-deep-purple ul.nav-menu li.menu>a:focus:before,.dark-deep-purple ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-deep-purple ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-deep-purple ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:focus,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:hover,.dark-deep-purple ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-deep-purple .module-nav li a.active{border-color:#673ab7}.dark-deep-purple .rbc-event{background-color:#673ab7}.dark-deep-purple .rbc-event.rbc-selected{background-color:#512e90}.dark-deep-purple .rbc-slot-selection{background-color:rgba(103,58,183,.7)}.dark-deep-purple .rbc-toolbar button.rbc-active,.dark-deep-purple .rbc-toolbar button.rbc-active:focus,.dark-deep-purple .rbc-toolbar button.rbc-active:hover,.dark-deep-purple .rbc-toolbar button:active,.dark-deep-purple .rbc-toolbar button:active:focus,.dark-deep-purple .rbc-toolbar button:active:hover,.dark-deep-purple .rbc-toolbar button:focus,.dark-deep-purple .rbc-toolbar button:hover{background-color:rgba(103,58,183,.9);border-color:#673ab7}.dark-deep-purple .contact-list i{color:#673ab7}.dark-deep-purple .Collapsible__trigger{background:#673ab7}.dark-deep-purple .categories-list li.active a,.dark-deep-purple .categories-list li a:focus,.dark-deep-purple .categories-list li a:hover{color:#673ab7}.dark-deep-purple .filter-with-bg-color ul li a,.dark-deep-purple .login-content .form-control:focus{border-color:#673ab7}.dark-deep-purple .filter-with-bg-color ul li a.active,.dark-deep-purple .filter-with-bg-color ul li a:focus,.dark-deep-purple .filter-with-bg-color ul li a:hover{background-color:#673ab7}.dark-deep-purple .profile-intro .icon{color:#673ab7}.dark-deep-purple .actions,.dark-deep-purple .social-link li.active a,.dark-deep-purple .social-link li a:focus,.dark-deep-purple .social-link li a:hover{color:#ffab00}.dark-deep-purple .table-hover tbody tr:hover{background-color:rgba(103,58,183,.075)}.dark-deep-purple .border-primary{border-color:#673ab7!important}.dark-deep-purple .app-logo-content{background-color:#673ab7}.dark-deep-purple .app-social-block .social-link button{border:1px solid #673ab7;color:#673ab7}.dark-deep-purple .app-social-block .social-link button:focus,.dark-deep-purple .app-social-block .social-link button:hover{color:#fff;background-color:#673ab7}.dark-green .right-arrow,.dark-green .right-arrow:after,.dark-green a,.dark-green a.text-primary{color:#4caf50}.dark-green a.text-primary:focus,.dark-green a.text-primary:hover,.dark-green a:focus,.dark-green a:hover{color:#3d8b40}.dark-green .text-primary{color:#4caf50!important}.dark-green .page-link,.dark-green .page-link:focus,.dark-green .page-link:hover{color:#4caf50}.dark-green .badge-primary,.dark-green .bg-primary{background-color:#4caf50!important;color:#fff!important}.dark-green .btn-primary{background-color:#4caf50;border-color:#4caf50;color:#fff}.dark-green .btn-primary:active,.dark-green .btn-primary:focus,.dark-green .btn-primary:hover{background-color:#449d48!important;border-color:#449d48!important;color:#fff!important}.dark-green .bg-primary.lighten-4{background-color:#c8e6c9!important}.dark-green .bg-primary.lighten-3{background-color:#a5d6a7!important}.dark-green .bg-primary.lighten-2{background-color:#81c784!important}.dark-green .bg-primary.lighten-1{background-color:#66bb6a!important}.dark-green .bg-primary.darken-1{background-color:#43a047!important}.dark-green .bg-primary.darken-2{background-color:#388e3c!important}.dark-green .bg-primary.darken-3{background-color:#2e7d32!important}.dark-green .bg-primary.darken-4{background-color:#1b5e20!important}.dark-green .bg-primary.accent-1{background-color:#b9f6ca!important}.dark-green .bg-primary.accent-2{background-color:#69f0ae!important}.dark-green .bg-primary.accent-3{background-color:#00e676!important}.dark-green .bg-primary.accent-4{background-color:#00c853!important}.dark-green a.text-secondary{color:#ff6d00}.dark-green a.text-secondary:focus,.dark-green a.text-secondary:hover{color:#cc5700!important}.dark-green .text-secondary{color:#ff6d00!important}.dark-green .badge-secondary,.dark-green .bg-secondary{background-color:#ff6d00!important;color:#fff!important}.dark-green .btn-secondary{background-color:#ff6d00;border-color:#ff6d00;color:#fff}.dark-green .btn-secondary:active,.dark-green .btn-secondary:focus,.dark-green .btn-secondary:hover{background-color:#e66200!important;border-color:#e66200!important;color:#fff!important}.dark-green .app-main-header{background-color:#4caf50!important}.dark-green .app-main-header .search-bar input{background-color:#5cb860}.dark-green .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-green .app-main-header .search-dropdown input{background-color:#fff}}.dark-green .color-theme-header{background-color:#4caf50}.dark-green .side-nav{background-color:#252525!important;color:#a1a1a1!important}.dark-green .side-nav,.dark-green .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-green .side-nav .user-profile{background-color:#1d1d1d;position:relative;z-index:2}.dark-green .side-nav .customizer{border-bottom:0 none}.dark-green .side-nav .user-detail .user-name{color:#fff}.dark-green ul.nav-menu .nav-header,.dark-green ul.nav-menu li a{color:#a1a1a1}.dark-green ul.nav-menu>li.open>a,.dark-green ul.nav-menu>li>a:focus,.dark-green ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}.dark-green ul.nav-menu li.menu.open>a{border-color:#4caf50}.dark-green ul.nav-menu li.menu>a:focus:before,.dark-green ul.nav-menu li.menu>a:hover:before{color:#fff}.dark-green ul.nav-menu li ul{background-color:#1d1d1d}.dark-green ul.nav-menu li.menu>a:before{color:#a1a1a1}.dark-green ul.nav-menu li.menu.open>a:before,.dark-green ul.nav-menu li.menu>a:focus:before,.dark-green ul.nav-menu li.menu li>a:hover:before{color:#fff}.dark-green ul.nav-menu li.menu .sub-menu li>a:before{color:#a1a1a1}.dark-green ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-green ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-green ul.nav-menu li.menu .sub-menu li>a:focus,.dark-green ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-green ul.nav-menu li.menu .sub-menu li>a:hover,.dark-green ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.dark-green .module-nav li a.active{border-color:#4caf50}.dark-green .rbc-event{background-color:#4caf50}.dark-green .rbc-event.rbc-selected{background-color:#3d8b40}.dark-green .rbc-slot-selection{background-color:rgba(76,175,80,.7)}.dark-green .rbc-toolbar button.rbc-active,.dark-green .rbc-toolbar button.rbc-active:focus,.dark-green .rbc-toolbar button.rbc-active:hover,.dark-green .rbc-toolbar button:active,.dark-green .rbc-toolbar button:active:focus,.dark-green .rbc-toolbar button:active:hover,.dark-green .rbc-toolbar button:focus,.dark-green .rbc-toolbar button:hover{background-color:rgba(76,175,80,.9);border-color:#4caf50}.dark-green .chat-sidenav-title{color:#4caf50}.dark-green .chat-user-item.active,.dark-green .chat-user-item:hover{background-color:#eaf6eb}.dark-green .contact-list i{color:#4caf50}.dark-green .Collapsible__trigger{background:#4caf50}.dark-green .categories-list li.active a,.dark-green .categories-list li a:focus,.dark-green .categories-list li a:hover{color:#4caf50}.dark-green .filter-with-bg-color ul li a,.dark-green .login-content .form-control:focus{border-color:#4caf50}.dark-green .filter-with-bg-color ul li a.active,.dark-green .filter-with-bg-color ul li a:focus,.dark-green .filter-with-bg-color ul li a:hover{background-color:#4caf50}.dark-green .profile-intro .icon{color:#4caf50}.dark-green .actions,.dark-green .social-link li.active a,.dark-green .social-link li a:focus,.dark-green .social-link li a:hover{color:#ff6d00}.dark-green .table-hover tbody tr:hover{background-color:rgba(76,175,80,.075)}.dark-green .border-primary{border-color:#4caf50!important}.dark-green .app-logo-content{background-color:#4caf50}.dark-green .app-social-block .social-link button{border:1px solid #4caf50;color:#4caf50}.dark-green .app-social-block .social-link button:focus,.dark-green .app-social-block .social-link button:hover{color:#fff;background-color:#4caf50}body.dark-theme{color:#e0e0e0;background-color:#e2e3e5}.dark-theme .card,.dark-theme .jr-card,.dark-theme .page-heading{background-color:#eff0f1}.dark-theme .meta-comment,.dark-theme .meta-date,.dark-theme .sub-heading,.dark-theme .text-muted,.dark-theme .user-detail .user-description{color:#adadad}.dark-theme .right-arrow,.dark-theme .right-arrow:after,.dark-theme a,.dark-theme a.text-primary{color:#d3d3d3}.dark-theme a.text-primary:focus,.dark-theme a.text-primary:hover,.dark-theme a:focus,.dark-theme a:hover{color:#c7c7c7}.dark-theme a.badge-light{color:#616161}.dark-theme a.badge-light:focus,.dark-theme a.badge-light:hover{color:#474747!important}.dark-theme .text-primary{color:#d3d3d3!important}.dark-theme .page-link{color:#fff}.dark-theme .page-link:focus,.dark-theme .page-link:hover{color:#fdfdfd}.dark-theme .badge-primary,.dark-theme .bg-primary,.dark-theme .btn-primary{background-color:#d5d6d9!important;color:#e0e0e0!important}.dark-theme .btn-primary{border-color:#e2e3e5}.dark-theme .btn-primary:active,.dark-theme .btn-primary:focus,.dark-theme .btn-primary:hover{background-color:#d5d6d9!important;border-color:#d5d6d9!important;color:#d3d3d3!important}.dark-theme a.text-secondary{color:#fdfdfd}.dark-theme a.text-secondary:focus,.dark-theme a.text-secondary:hover{color:#e2e3e5!important}.dark-theme .text-secondary{color:#fdfdfd!important}.dark-theme .bg-secondary{background-color:#fdfdfd!important;color:#d3d3d3!important}.dark-theme .badge-secondary{background-color:#e2e3e5!important;color:#d3d3d3!important}.dark-theme .btn-secondary{background-color:#fdfdfd;border-color:#fdfdfd;color:#d3d3d3}.dark-theme .btn-secondary:active,.dark-theme .btn-secondary:focus,.dark-theme .btn-secondary:hover{background-color:#eff0f1!important;border-color:#eff0f1!important;color:#d3d3d3!important}.dark-theme .app-main-header{background-color:#e2e3e5!important}.dark-theme .app-main-header .search-bar input{background-color:#eff0f1}.dark-theme .app-main-header .search-bar input:focus{background-color:#fff}@media screen and (max-width:575px){.dark-theme .app-main-header .search-dropdown input{background-color:#fff}}.dark-theme .app-footer{padding:0 24px;background-color:#e2e3e5;color:#e0e0e0}.dark-theme .app-footer a.text-secondary{color:#e0e0e0!important}.dark-theme .app-footer a.text-secondary:hover{color:#c7c7c7!important}.dark-theme .color-theme-header{background-color:#e2e3e5}.dark-theme .side-nav{background-color:#d5d6d9!important;color:#e0e0e0!important}.dark-theme .side-nav,.dark-theme .side-nav .user-profile{-webkit-box-shadow:none;-moz-box-shadow:none;-o-box-shadow:none;box-shadow:none}.dark-theme .side-nav .user-profile{background-color:#dddee0;position:relative;z-index:2}.dark-theme .side-nav .customizer{border-bottom:0 none}.dark-theme .side-nav .user-detail .user-name{color:#d3d3d3}.dark-theme ul.nav-menu .nav-header,.dark-theme ul.nav-menu li a{color:#e0e0e0}.dark-theme ul.nav-menu>li.open>a,.dark-theme ul.nav-menu>li>a:focus,.dark-theme ul.nav-menu>li>a:hover{background-color:#dddee0;color:#d3d3d3}.dark-theme ul.nav-menu li.menu.open>a{border-color:#d3d3d3}.dark-theme ul.nav-menu li.menu>a:focus:before,.dark-theme ul.nav-menu li.menu>a:hover:before{color:#d3d3d3}.dark-theme ul.nav-menu li ul{background-color:#dddee0}.dark-theme ul.nav-menu li.menu>a:before{color:#e0e0e0}.dark-theme ul.nav-menu li.menu.open>a:before,.dark-theme ul.nav-menu li.menu>a:focus:before,.dark-theme ul.nav-menu li.menu li>a:hover:before{color:#d3d3d3}.dark-theme ul.nav-menu li.menu .sub-menu li>a:before{color:#e0e0e0}.dark-theme ul.nav-menu li.menu.open .sub-menu li.active>a,.dark-theme ul.nav-menu li.menu.open .sub-menu li.active>a:before,.dark-theme ul.nav-menu li.menu .sub-menu li>a:focus,.dark-theme ul.nav-menu li.menu .sub-menu li>a:focus:before,.dark-theme ul.nav-menu li.menu .sub-menu li>a:hover,.dark-theme ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#d5d6d9;color:#fff}.dark-theme .module-nav li a.active{border-color:#c7c9cd}.dark-theme .rbc-event{background-color:#fff}.dark-theme .rbc-event.rbc-selected{background-color:#c7c9cd}.dark-theme .rbc-slot-selection{background-color:hsla(220,5%,89%,.7)}.dark-theme .rbc-toolbar button,.dark-theme .rbc-toolbar button.rbc-active,.dark-theme .rbc-toolbar button.rbc-active:focus,.dark-theme .rbc-toolbar button.rbc-active:hover,.dark-theme .rbc-toolbar button:active,.dark-theme .rbc-toolbar button:active:focus,.dark-theme .rbc-toolbar button:active:hover,.dark-theme .rbc-toolbar button:focus,.dark-theme .rbc-toolbar button:hover{background-color:hsla(220,5%,89%,.9);border-color:#fff;color:#fff}.dark-theme .rbc-show-more{background-color:#fff}.dark-theme .rbc-off-range-bg{background-color:#fdfdfd}.dark-theme .contact-list i{color:#e2e3e5}.dark-theme .Collapsible__trigger{background:#e2e3e5}.dark-theme .categories-list li.active a,.dark-theme .categories-list li a:focus,.dark-theme .categories-list li a:hover{color:#a0a0a0}.dark-theme .filter-with-bg-color ul li a,.dark-theme .login-content .form-control:focus{border-color:#e2e3e5}.dark-theme .filter-with-bg-color ul li a.active,.dark-theme .filter-with-bg-color ul li a:focus,.dark-theme .filter-with-bg-color ul li a:hover{background-color:#e2e3e5}.dark-theme .profile-intro .icon{color:#e2e3e5}.dark-theme .actions,.dark-theme .social-link li.active a,.dark-theme .social-link li a:focus,.dark-theme .social-link li a:hover{color:#d3d3d3}.dark-theme .table-hover tbody tr:hover{background-color:hsla(220,5%,89%,.075)}.dark-theme .border-primary{border-color:#d3d3d3!important}.dark-theme .breadcrumb,.dark-theme .desc-list.even-odd li:nth-child(2n){background-color:#e2e3e5}.dark-theme .timeline-panel{background-color:#fdfdfd}.dark-theme .timeline-panel:after{border-color:transparent #fdfdfd}.dark-theme .timeline-panel:before{border-color:transparent #e2e3e5}.dark-theme .login-content{background-color:#eff0f1}.dark-theme .modal-box-footer,.dark-theme .module-box-content,.dark-theme .module-detail-header{background-color:#e2e3e5}.dark-theme .modal-box-content{background-color:#eff0f1}.dark-theme .module-nav li a{color:#adb5bd}.dark-theme .module-nav li a.active,.dark-theme .module-nav li a:focus,.dark-theme .module-nav li a:hover{color:#343a40}.dark-theme .app-logo-content{background-color:#e2e3e5}.dark-theme .app-social-block .social-link button{border:1px solid #e2e3e5;color:#e2e3e5}.dark-theme .app-social-block .social-link button:focus,.dark-theme .app-social-block .social-link button:hover{color:#fff;background-color:#e2e3e5}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}body.dark-theme{color:#000!important}.box{display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;width:100%}.app-wrapper .heartbeat-page svg{background-color:transparent!important}.heartbeat-page .clickable{cursor:pointer}.heartbeat-page .table{overflow:auto;display:block;min-height:343px;max-height:360px}.heartbeat-page .googleMap{height:95%;width:100%}.heartbeat-page svg{background-color:transparent!important}.heartbeat-page .modal-wrapper .modal-overlay-and-loader{background-color:#38414c;display:flex;position:absolute;top:0;left:0;height:100%;width:100%;opacity:1;transition:.5s ease;z-index:9999}.heartbeat-page .spacial-depth-img,.heartbeat-page .temperature-img{padding-left:1rem;height:1.5rem}.heartbeat-page .gm-style .gm-style-iw-c{padding:0!important}.heartbeat-page .gm-ui-hover-effect{display:none!important}.heartbeat-page .gm-style .gm-style-iw-d{max-height:none!important;overflow:hidden!important}.heartbeat-page .battery-charge-img,.heartbeat-page .gas-leakage-img,.heartbeat-page .humidity-img,.heartbeat-page .power-leakage-img{padding-left:1rem;height:1.5rem}.heartbeat-page .m-chart-img{padding-left:0;height:1.5rem}.heartbeat-page h3{font-size:13px}.heartbeat-page p{font-size:12px}@media (min-width:576px){.heartbeat-page .current-status{height:91%}.heartbeat-page .current-status .collapse-status{height:76%;align-items:center!important;display:flex!important}.heartbeat-page .current-status .collapse-status h3{font-size:13px}.heartbeat-page .current-status .collapse-status strong{font-size:14px}}@media only screen and (min-width:992px) and (max-width:1500px){.heartbeat-page .btn{font-size:11px!important}}.heartbeat-page .jr-card{padding:0}.heartbeat-page .jr-card .jr-card-header.threshold{background-color:#ef5350}.heartbeat-page .jr-card .sensor-chart-overlay{background-color:#38414b;position:absolute;top:0;left:0;height:100%;width:100%}.heartbeat-page .jr-card .jr-card-header{background:#e2e3e5;padding:.5rem;border:0}.heartbeat-page .jr-card .jr-card-header h3{font-size:11.88px}@media (min-width:576px){.heartbeat-page .jr-card .jr-card-header{height:auto;pointer-events:none}}@media screen and (min-width:576px){.heartbeat-page #collapseFive,.heartbeat-page #collapseFour,.heartbeat-page #collapseOne,.heartbeat-page #collapseSeven,.heartbeat-page #collapseSix,.heartbeat-page #collapseThree,.heartbeat-page #collapseTwo{display:block}}@media only screen and (min-width:992px) and (max-width:1012px){.heartbeat-page .ma-font{font-size:11.88px!important}}.heartbeat-page .card-heading,.heartbeat-page .popupHeading{font-size:15px;letter-spacing:.8px;padding-top:3px}.heartbeat-page .heartbeat-main-heading{font-size:22px;letter-spacing:.8px;font-weight:600}.heartbeat-page .signalBatteryIcon{font-size:x-large}.heartbeat-page #mxChart-popup .mx-chart-text1,.heartbeat-page #mxChart-popup .mx-chart-text2{align-items:center;justify-content:center;width:100%}.heartbeat-page svg{background-color:#434f59!important}.heartbeat-page .mainHeight{height:95%!important}@media (min-width:1024px){.heartbeat-page .screenContainer{margin-left:100px;margin-right:100px}}.heartbeat-page .contentContainer{padding-right:0;padding-left:0}.heartbeat-page .recordContainer{display:flex!important;min-height:320px;flex-direction:column!important}.heartbeat-page .recordOuterContainer{min-width:85%;max-width:85%}.heartbeat-page .tableHeading{position:sticky!important;top:-1px;background:#fff!important}.mfp-content{width:80%!important;top:2%}.mfp-content .mx-chartIcon{top:13px!important}.mfp-content .jr-card{padding:0}.mfp-content .jr-card .jr-card-header{background:#e2e3e5;height:40px;display:flex;align-items:center;color:#000}.mfp-content .jr-card .jr-card-header .card-heading{padding-left:15px;color:#000}.mfp-content .jr-card .jr-card-header .popupHeading{position:absolute;top:11px;right:80px}.mfp-content .jr-card .jr-card-header img{width:17px;position:absolute;top:6px;right:50px}.mfp-content .jr-card .jr-card-header .spacial-depth-img{width:25px;position:absolute;top:8px;right:44px}.mfp-content .jr-card .jr-card-header .gas-leakage-img{width:25px;position:absolute;top:4px;right:44px}.mfp-content .jr-card .jr-card-header .power-leakage-img{width:25px;position:absolute;top:8px;right:44px}.mfp-content .jr-card .jr-card-body{padding:18px 24px}.mfp-content .wrapper-dialChart{display:flex;justify-content:center;align-items:center;text-align:center}@media (max-width:576px){.mfp-content .wrapper-dialChart{display:block}}.mfp-content .wrapper-dialChart #mzChart,.mfp-content .wrapper-dialChart .dialInner-text{width:100%;max-width:100%;flex:100%}.mfp-close-btn-in .mfp-close{color:#000!important}.btn-popup{background:#e2e3e5;color:#000;float:right;padding:2px 12px;cursor:pointer}.bottomSection{width:100%}.bottomSection .data-correlation table tr td span{color:#000;font-size:.7rem}.bottomSection .data-correlation table tr td .span-pit{color:#000}.bottomSection .data-correlation table tr .date-position{display:block}.bottomSection .jr-card{min-height:220px}.bottomSection .jr-card .fooer-btn button{border:0}.bottomSection .circle-tick-image{width:40px}.bottomSection table tr td span{font-size:12px;letter-spacing:.8px}.heartBeat-popupWrapper{z-index:99999!important}@media (max-width:767px){.heartBeat-popupWrapper{width:90%;margin:auto}}.heartBeat-popupWrapper .t-blue{color:#4eb0eb}.heartBeat-popupWrapper .modal-dialog{height:93%;display:flex;justify-content:center;align-items:center;max-width:70%}@media (max-width:767px){.heartBeat-popupWrapper .modal-dialog{max-width:100%}.heartBeat-popupWrapper .modal-dialog .modal{height:500px;position:fixed;overflow-y:scroll;-webkit-overflow-scrolling:touch}}.heartBeat-popupWrapper .modal-dialog .modal-content{width:100%;border-radius:0}.heartBeat-popupWrapper .modal-dialog .modal-content .modal-body{background:#393e44}.heartBeat-popupWrapper .modal-dialog span{margin:15px 0}.heartBeat-popupWrapper .modal-dialog .modal-content{background:\"#fff\"!important}.heartBeat-popupWrapper .modal-dialog .modal-header.threshold{background-color:#ef5350}.heartBeat-popupWrapper .modal-dialog .modal-header{background:#e2e3e5;border-radius:0;display:flex;align-items:center}.heartBeat-popupWrapper .modal-dialog .modal-header h4{font-size:16px;color:\"#000\"}.heartBeat-popupWrapper .modal-dialog .modal-header h6{font-size:15px;margin-bottom:2px}.heartBeat-popupWrapper .modal-dialog .modal-header h5{top:13px}.heartBeat-popupWrapper .modal-dialog .modal-header .icon-height{height:22px;font-weight:400;font-size:.9rem}.heartBeat-popupWrapper .modal-dialog .modal-header .close{font-size:16px;margin:0;padding:0;color:\"#000\";text-shadow:none;opacity:1;cursor:pointer;display:flex;align-items:center}.heartBeat-popupWrapper .modal-dialog .modal-header .close p{display:-webkit-inline-box;margin-bottom:0;font-size:13px}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.configuration-page #searchModalComponent .modal-content{background-color:#e2e3e5!important}.configuration-page #searchModalComponent .modal-content .search-bar{margin:0;width:100%;max-width:inherit}.configuration-page #searchModalComponent .modal-content .btn-filter{width:30%;border-bottom-left-radius:6px;border-top-left-radius:6px}.configuration-page #searchModalComponent .modal-content .inner-height{max-height:430px}.configuration-page #searchModalComponent .modal-content .inner-height h3{color:#000;margin:15px}.configuration-page #searchModalComponent .modal-header{background:#e2e3e5;margin-top:10px;display:flex;align-items:center}.configuration-page #searchModalComponent .modal-header h4{font-size:16px;color:#000}.configuration-page #searchModalComponent .modal-header h6{font-size:15px;margin-bottom:2px}.configuration-page #searchModalComponent .modal-header h5{top:13px}.configuration-page #searchModalComponent .modal-header .icon-height{height:22px;font-weight:400;font-size:.9rem}.configuration-page #searchModalComponent .modal-header .close{font-size:16px;margin:0;padding:0;color:#fff;text-shadow:none;opacity:1;cursor:pointer;display:flex;align-items:center}.configuration-page #searchModalComponent .modal-header .close p{display:-webkit-inline-box;margin-bottom:0;font-size:13px}.configuration-page #searchModalComponent .search-table td a{cursor:pointer;text-decoration:underline;color:#4eb0eb}.configuration-page #searchModalComponent .search-results{width:100%}.configuration-page #searchModalComponent .search-results1{background-color:#4eb0eb;height:50px;border-radius:0!important}.configuration-page #searchModalComponent .search-table{color:#000;background-color:#fff;font-size:.6rem;border:1px solid gray}.configuration-page #searchModalComponent .search-table thead{background-color:#fff}.configuration-page #searchModalComponent #back-button,.configuration-page #searchModalComponent #showMore-button{background-color:#92d050;color:#fff}.configuration-page #searchModalComponent .dropdown-toggle:after{display:none}.configuration-page .quick-menu .clear-Button{text-align:center}.configuration-page .quick-menu .clear-Button a{font-size:12px;cursor:pointer;text-decoration:underline;color:#4eb0eb}.configuration-page .quick-menu .active-results{text-align:center}.configuration-page .quick-menu .active-results a{font-size:12px;color:#e2e3e5!important}.configuration-page .slimScrollDiv,.configuration-page .slimScrollDiv .messages-list{height:auto!important}.configuration-page .slimScrollDiv .messages-list ul{max-height:300px}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}#device-distribution-map{height:400px}.devices-page .btn-refresh{background:#262a2e;border:2px solid #424242;color:#fff;padding:2px 12px;cursor:pointer}.devices-page .btn-refresh:hover{background:#4eb0eb;border-color:#033452}.devices-page .btn-refresh:active{background:#033452;border-color:#033452}.devices-page .btn-width{width:10%}.devices-page .btn-width button{width:100%}.devices-page .map-height{min-height:100%}.devices-page .map-height .jr-card{height:50%;min-height:94%}.devices-page .map-height .jr-card .jr-card-header{margin-bottom:.8rem}.devices-page .map-height .jr-card .jr-card-header h3{font-size:12.25px}.devices-page .map-height .jr-card .jr-card-body{height:100%}.devices-page .map-height .jr-card .jr-card-body .embed-responsive{height:100%!important}.devices-page .card-height{min-height:100%}.devices-page .card-height .jr-card{height:88%;min-height:88%}.devices-page .card-height .jr-card .jr-card-header{margin-bottom:.8rem}.devices-page .card-height .jr-card .jr-card-header h3{float:left;font-size:12.25px}.devices-page .card-height .jr-card p{font-size:14px}.devices-page .card-height .jr-card .jr-card-body{width:100%}.devices-page .card-height .jr-card .inner-height{align-items:center;justify-content:flex-start;display:flex;width:100%;height:100%}.devices-page .t-cost{font-size:2.5rem;color:#4eb0eb}.devices-page .t-blue{color:#4eb0eb}.devices-page .set-background{background:#434f59;color:#fff}.devices-page .set-background .info-card .left-text{display:flex;align-items:flex-end}.devices-page .set-background .info-card img{width:50px}.devices-page .inputContainer{background-color:#fff;border-style:none;color:#132c3c;text-decoration:underline;box-shadow:0 1px 2px 1px #255775;text-align:center;width:5rem;padding:6px 0 7px}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.app-main-header #searchModal .modal-content{background-color:#e2e3e5!important}.app-main-header #searchModal .modal-content .search-bar{margin:0;width:100%;max-width:inherit}.app-main-header #searchModal .modal-content .btn-filter{width:30%;border-bottom-left-radius:6px;border-top-left-radius:6px}.app-main-header #searchModal .modal-content .inner-height{max-height:430px}.app-main-header #searchModal .modal-content .inner-height h3{color:#000}.app-main-header #searchModal .modal-dialog{border-radius:0!important}.app-main-header #searchModal .modal-header{background:#e2e3e5;border-radius:0;display:flex;align-items:center}.app-main-header #searchModal .modal-header h4{font-size:16px;color:#000}.app-main-header #searchModal .modal-header h6{font-size:15px;margin-bottom:2px}.app-main-header #searchModal .modal-header h5{top:13px}.app-main-header #searchModal .modal-header .icon-height{height:22px;font-weight:400;font-size:.9rem}.app-main-header #searchModal .modal-header .close{font-size:16px;margin:0;padding:0;color:#fff;text-shadow:none;opacity:1;cursor:pointer;display:flex;align-items:center}.app-main-header #searchModal .modal-header .close p{display:-webkit-inline-box;margin-bottom:0;font-size:13px}.app-main-header #searchModal .search-table td a{cursor:pointer;text-decoration:underline;color:#4eb0eb}.app-main-header #searchModal .search-results{width:100%}.app-main-header #searchModal .search-results1{background-color:#4eb0eb;height:50px;border-radius:0!important}.app-main-header #searchModal .search-table{color:#000;background-color:#fff;font-size:.6rem;border:1px solid gray}.app-main-header #searchModal .search-table thead{background-color:#fff}.app-main-header #searchModal #back-button,.app-main-header #searchModal #showMore-button{background-color:#92d050;color:#fff}.app-main-header #searchModal .dropdown-toggle:after{display:none}.app-main-header .quick-menu .clear-Button{text-align:center}.app-main-header .quick-menu .clear-Button a{font-size:12px;cursor:pointer;text-decoration:underline;color:#4eb0eb}.app-main-header .quick-menu .active-results{text-align:center}.app-main-header .quick-menu .active-results a{font-size:12px;color:#e2e3e5!important}.app-main-header .slimScrollDiv,.app-main-header .slimScrollDiv .messages-list{height:auto!important}.app-main-header .slimScrollDiv .messages-list ul{max-height:300px}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.clearedNotification-wrapper{margin-top:1px}@media only screen and (min-width:992px) and (max-width:1200px){.clearedNotification-wrapper table{font-size:.75rem}}@media only screen and (max-width:700px){.clearedNotification-wrapper table{font-size:.75rem}}.clearedNotification-wrapper table tr td:last-child,.clearedNotification-wrapper table tr td:nth-child(2),.clearedNotification-wrapper table tr td:nth-child(4),.clearedNotification-wrapper table tr td:nth-child(5){text-align:center}@media only screen and (min-width:700px) and (max-width:992px){.clearedNotification-wrapper table tr td:last-child{min-width:130px}}@media only screen and (min-width:1200px){.clearedNotification-wrapper table tr td:last-child{min-width:130px}}.forCenter{text-align:center}.descriptionNotification-wrapper{margin-top:1px}@media only screen and (min-width:992px) and (max-width:1200px){.descriptionNotification-wrapper{font-size:.7rem}}.descriptionNotification-wrapper Button{border-color:#92d050}.descriptionNotification-wrapper table Input{background-color:#132c3c;border-style:none;color:#fff;text-decoration:underline;box-shadow:0 1px 2px 1px #255775;text-align:center;width:3rem}.notifications-page .label-font span{font-family:Roboto Regular,sans-serif!important}.notifications-page .checkbox{height:10px}.notifications-page .checkbox svg{font-size:20px}.notifications-page .checkbox input{background-color:#132c3c;border-style:none;color:#fff;text-decoration:underline;box-shadow:0 1px 2px 1px #255775;text-align:center;width:3rem}.notifications-page .btn-refresh{background:#262a2e;border:2px solid #424242;color:#fff;padding:2px 12px;cursor:pointer}.notifications-page .btn-refresh:hover{background:#4eb0eb;border-color:#033452}.notifications-page .btn-refresh:active{background:#033452;border-color:#033452}.notifications-page .btn-showMore{border:2px solid #2c5600}.notifications-page .btn-showMore:hover{background:#2c5600}.notifications-page .btn-showMore:active{background:#648e37}.notifications-page p{font-size:smaller;color:#fff;margin-bottom:0}.notifications-page table{color:#fff}.notifications-page table tr td{padding:.25rem;vertical-align:middle}.notifications-page table tr td:first-child{background:#4eb0eb;min-width:106px}.notifications-page table tr td:nth-child(2){min-width:100px}.notifications-page table tr td:nth-child(4){background-color:#92d050}.notifications-page table th{text-align:center;padding-top:0;padding-bottom:0;vertical-align:inherit}.notifications-page .selectedNotification{border-width:3px;border:solid;border-color:#ef5350}.notifications-page .background-color-blue{background-color:#4eb0eb}.notifications-page span{font-size:smaller;color:#fff}.notifications-page input{display:inline-block}.notifications-page button{background-color:#92d050;color:#fff}.notifications-page .vertical-align-middle{vertical-align:middle}.notifications-page .manual-clear-hover:hover{cursor:pointer}.activeNotification-wrapper{margin-top:1px}@media only screen and (min-width:992px) and (max-width:1200px){.activeNotification-wrapper table{font-size:.75rem}}@media only screen and (max-width:700px){.activeNotification-wrapper table{font-size:.75rem}}.activeNotification-wrapper table tr td:nth-child(2){text-align:center}.activeNotification-wrapper table tr td:nth-child(4){text-align:center;background-color:#ef5350}.activeNotification-wrapper table tr td:last-child,.activeNotification-wrapper table tr td:nth-child(5){text-align:center}@media only screen and (min-width:700px) and (max-width:992px){.activeNotification-wrapper table tr td:last-child{min-width:130px}}@media only screen and (min-width:1200px){.activeNotification-wrapper table tr td:last-child{min-width:130px}}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.parentContent-wrapper{height:100%}.parentContent-wrapper .landingPage-wrapper{background:url(\"/assets/images/bg-image-senstra.jpg\") no-repeat;background-size:cover}.parentContent-wrapper .landingPage-wrapper .left-logo{display:flex;justify-content:flex-start;align-items:center}.parentContent-wrapper .landingPage-wrapper .left-logo img{width:220px}.parentContent-wrapper .landingPage-wrapper .right-awsIcon{display:flex;justify-content:flex-end;align-items:center}.parentContent-wrapper .landingPage-wrapper .right-awsIcon img{width:140px}.parentContent-wrapper .landingPage-wrapper .caption-outer{padding-top:7%}.parentContent-wrapper .landingPage-wrapper .caption-outer h1{color:#00b0f0;font-size:60px;line-height:110px}.parentContent-wrapper .landingPage-wrapper .caption-outer p{font-size:18px;color:#fff;letter-spacing:1px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer img{width:80px;padding:40px 0 50px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .getStarted-btn{background:#92d050;padding:13px 58px;border:0;color:#fff;border-radius:8px;cursor:pointer}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog{max-width:600px;height:92%;display:flex;justify-content:center;align-items:center}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-header{background:#e2e3e5;border-radius:0;display:flex;align-items:center;border-bottom:0}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-header .modal-title{font-size:16px;color:#fff}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-header .close{font-size:16px;margin:0;padding:0;color:#fff;text-shadow:none;opacity:1;cursor:pointer}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-header .close p{display:-webkit-inline-box;margin-bottom:0;font-size:13px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body{background:#393e44;padding-left:6%}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body label{font-size:14px;color:#fff;padding-right:8%;letter-spacing:1px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body input[type=password],.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body input[type=text]{border:0;padding-left:8px;height:35px;font-size:14px;letter-spacing:.5px;width:60%}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .text-filedTop{font-size:10px;letter-spacing:.5px;padding-left:150px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .forgot-links{padding-left:149px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .forgot-links .checkbox-input input{vertical-align:sub!important}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .forgot-links .checkbox-input label{padding-right:0;font-size:11px;margin-bottom:0;padding-left:5px;vertical-align:unset;text-decoration:underline}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .forgot-links span input[type=text]{margin-top:4px}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .forgot-links span a{font-size:11px;padding-left:20px;text-decoration:underline}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer .login-popupWrapper .modal-dialog .modal-body .lets-goBtn button{background:#92d050;border:0;margin-top:15px;padding:10px 30px;border-radius:5px;font-size:13px;color:#fff;letter-spacing:.5px;cursor:pointer}.parentContent-wrapper .landingPage-wrapper .videoBtn-outer h6{color:#fff;font-size:19px;letter-spacing:1px}#correlation .contentInner-wrapper{margin-top:5px}#correlation h3{font-size:12.25px}#correlation .source-systems .img-container{width:100%;height:60%}#correlation .source-systems .center-the-text{left:0;position:absolute;text-align:center;-ms-transform:translateY(-100%);-webkit-transform:translateY(-100%);transform:translateY(-100%);width:100%;font-size:small;color:#fff}#correlation .source-systems .blue-circle-position{position:absolute;right:0;top:0}#correlation .source-systems .number-position{position:absolute;right:.5rem;top:.4rem;color:#fff;font-size:small}#correlation .source-systems .center-the-small-text{position:absolute;text-align:center;top:80%;left:0;width:100%;font-size:.5rem;color:#fff}.login-container{position:relative;height:100%}.login-content{width:420px;margin:auto;padding:35px 35px 20px;background-color:#fff;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border-radius:4px;font-size:14px;max-width:94%}.login-header{margin-bottom:30px}.input-for-search{color:#000!important}.login-content .form-control{background-color:#f5f5f5}.login-content .form-control:focus{box-shadow:none;border-color:#3f51b5}.login-content .btn,.login-content .jr-btn{padding:10px 35px!important}.app-login-container{position:relative;max-width:680px;width:94%;margin:0 auto}.app-login-container .loader-view{position:absolute;left:0;right:0;text-align:center;top:0;bottom:0;z-index:2}.app-login-main-content{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:#fff;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-moz-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);-o-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border-radius:10px;font-size:14px;overflow:hidden}.app-login-content{padding:35px 35px 20px;width:60%;order:1}@media screen and (max-width:575px){.app-login-content{width:100%;order:2}}.app-login-header{margin-bottom:30px}.app-login-content .form-control{background-color:#f5f5f5}.app-login-content .form-control:focus{box-shadow:none;border-color:#3f51b5}.app-login-content .btn,.login-content .jr-btn{padding:10px 35px!important}.app-logo-content{background-color:#3f51b5;padding:35px 35px 20px;width:40%;order:2}@media screen and (max-width:575px){.app-logo-content{width:100%;order:1}}.app-social-block{display:-webkit-flex;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-items:center;align-items:center;-webkit-justify-content:space-between;justify-content:space-between}.app-social-block .social-link,.app-social-block .social-link li{margin:0}.app-social-block .social-link button{border:1px solid #3f51b5;border-radius:50%;color:#3f51b5}.app-social-block .social-link button:focus,.app-social-block .social-link button:hover{color:#fff;background-color:#3f51b5}.app-social-block p{margin-bottom:0}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}#metrics .contentInner-wrapper{margin-top:5px}#metrics .dimensionRow{display:inline-flex;background:#393e44;margin-top:5px;width:100%}#metrics .dimensionRow li{text-align:center;list-style:none;padding:10px;color:#fff;font-size:12px;align-self:center}#metrics .dimensionRow li input{background:#292c2f;border-style:none;color:#fff;text-align:center;width:86%}#metrics .row-30{height:25%;background:#393e44}@media only screen and (max-width:768px){#metrics .row-30{height:40%}}#metrics .text-underline{text-decoration:underline}#metrics .text-heading{color:#fff;font-size:12px}#metrics .text-options{color:#fff;font-size:10px}@media only screen and (min-width:992px){#metrics .text-options{font-size:8px}}#metrics .t-cost{font-size:2.5rem;color:#4eb0eb}@media only screen and (max-width:1199px) and (min-width:768px){#metrics .t-cost{font-size:1rem}}#metrics .t-blue{color:#4eb0eb}#metrics .metric-export{background:#92d050;border-style:none;color:#fff;border-radius:5px;width:100%}#metrics .left{float:left}#metrics .right{float:right}#metrics .inline{display:inline-flex}#metrics .set-background{background:#434f59;color:#fff}#metrics .set-background .finance-section .dollar{font-size:18px;font-weight:400;top:-1em}@media only screen and (max-width:1199px) and (min-width:768px){#metrics .set-background .finance-section .dollar{font-size:12px;font-weight:400;top:-.25em}}#metrics .set-background .finance-section .cost-suffix{font-size:18px;font-weight:400;top:0;left:-.1em}@media only screen and (max-width:1199px) and (min-width:768px){#metrics .set-background .finance-section .cost-suffix{font-size:12px}}#metrics .set-background .finance-section .left-text{display:flex;align-items:flex-end}#metrics .set-background .finance-section img{width:inherit}@media only screen and (max-width:768px){#metrics .set-background .finance-section img{width:15%}}#metrics .horizontalBarWrapper{font-size:.9rem;align-self:center;text-align:center}#metrics .horizontalBarWrapper span,#metrics .horizontalBarWrapper svg{height:50px!important}#metrics .jr-card-sb{padding:22px 6px}#metrics .jr-card-sb h3{font-size:12.25px}@media only screen and (min-width:991px) and (max-width:1418px){#metrics .ma-font{font-size:11px!important}}#metrics .li-font{font-size:10px}#metrics .label-min-width{min-width:30px!important}#metrics svg{background-color:#434f59!important}.profile-popupWrapper .modal-dialog{height:92%;display:flex;justify-content:center;align-items:center;max-width:70%;border-radius:0!important}.profile-popupWrapper .modal-dialog .modal-content{width:100%}.profile-popupWrapper .modal-dialog .modal-content .modal-header{background:#e2e3e5;border-radius:0;display:flex;align-items:center;border-bottom:0;height:auto!important}.profile-popupWrapper .modal-dialog .modal-content .modal-header .modal-title{height:auto!important}.profile-popupWrapper .modal-dialog .modal-content .modal-header h4{font-size:16px;color:#fff}.profile-popupWrapper .modal-dialog .modal-content .modal-header .close{font-size:16px;margin:0;padding:0;color:#fff;text-shadow:none;opacity:1;cursor:pointer}.profile-popupWrapper .modal-dialog .modal-content .modal-header .close p{display:-webkit-inline-box;margin-bottom:0;font-size:13px}.profile-popupWrapper .modal-dialog .modal-content .modal-body{background:#393e44}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-detail table td{min-width:10rem}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-detail ul{padding-left:0}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-detail ul li{font-size:12px;list-style:none;line-height:15px}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-detail ul li span p{display:-webkit-inline-flex;padding-left:5%;margin-bottom:0}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-img img{width:90%}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-links ul{padding-left:0}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-links ul li{list-style:none;line-height:15px;letter-spacing:.8px}.profile-popupWrapper .modal-dialog .modal-content .modal-body .profile-links ul li a{font-size:12px;text-decoration:underline;cursor:pointer}.node-vitals .signalBatteryIcon{font-size:x-large}.node-vitals th{padding:8px 24px;font-size:large!important;color:rgba(0,0,0,.54);font-weight:500}.node-vitals td{padding:8px 24px;font-size:medium!important;color:rgba(0,0,0,.87)}.node-vitals #deviceId:hover{color:blue;cursor:pointer}.device-catalogue .statusImage,.node-vitals .statusImage{padding-left:1rem;height:1.5rem}.device-catalogue th{padding:8px 10px;font-size:medium!important;color:rgba(0,0,0,.54);font-weight:500;background-color:\"#e2e3e5\"}.device-catalogue #deviceId:hover{color:blue;cursor:pointer}.device-catalogue td{padding:8px 10px;font-size:small!important;color:rgba(0,0,0,.87)}#landing-screen h6{color:#fff}#landing-screen h3{color:#000;font-size:20px}#landing-screen h4{font-size:12.25px}#landing-screen .set-background{background-color:#393e44}#landing-screen .set-background p{text-align:left}#landing-screen p{color:#fff}#landing-screen .first-line{font-size:1rem}#landing-screen .second-line,#landing-screen .third-line{font-size:.6rem}#landing-screen .gm-style .gm-style-iw-c{padding:0!important}#landing-screen .gm-ui-hover-effect{display:none!important}#landing-screen .gm-style .gm-style-iw-d{max-height:none!important;overflow:hidden!important}#landing-screen button{background-color:#92d050;color:#fff;margin-top:1rem}#landing-screen svg{background-color:#434f59!important}#landing-screen .caption-outer{padding-top:7%}#landing-screen .caption-outer h1{color:#3f51b5!important;font-size:115px;line-height:110px}#landing-screen .caption-outer p{font-size:18px;color:#fff;letter-spacing:1px}.side-nav{width:280px;background-color:#252525!important;color:#a1a1a1!important;border-right:0 none!important;z-index:1250!important}.side-nav .user-profile{background-color:#e2e3e5!important;padding:13px 20px!important}.side-nav .user-avatar{margin:0 15px 0 0!important;height:44px!important;width:44px!important;line-height:44px}.side-nav .user-detail .user-name{color:#fff;cursor:pointer;font-size:14px;font-weight:400;white-space:nowrap}.side-nav .icons{font-size:x-large}.user-detail .user-name{cursor:pointer}ul.nav-menu{position:relative;font-size:14px;list-style:outside none none;margin:0;padding:0}ul.nav-menu li{position:relative;margin-bottom:1px}ul.nav-menu li.menu+.nav-header{margin-top:20px}ul.nav-menu li.menu .sub-menu{display:none}ul.nav-menu li.menu.open .menu.active>.sub-menu,ul.nav-menu li.menu.open>.sub-menu{display:block}ul.nav-menu li a{color:#a1a1a1;display:block;font-size:14px;min-width:inherit!important;padding:16px 20px;font-weight:400;text-transform:capitalize;text-decoration:none;border-radius:0}ul.nav-menu .nav-header{color:#a1a1a1;padding:10px 20px;font-size:11px;text-transform:uppercase}ul.nav-menu .nav-header:first-child{margin-top:10px}ul.nav-menu>li.open>a,ul.nav-menu>li>a:focus,ul.nav-menu>li>a:hover{background-color:#1d1d1d;color:#fff}ul.nav-menu li.menu>a{border-left:2px solid transparent}ul.nav-menu li.menu.open>a{border-color:#ff9800}ul.nav-menu li.menu>a:focus:before,ul.nav-menu li.menu>a:hover:before{color:#fff}ul.nav-menu li i{margin-right:16px;font-size:15px}ul.nav-menu li ul{list-style:outside none none;margin:0;padding:0;position:relative;z-index:1;background-color:#1d1d1d;overflow:hidden}ul.nav-menu li ul>li>a{padding-left:56px}ul.nav-menu li ul>li>ul>li>a{padding-left:76px}ul.nav-menu li ul>li>ul>li>ul>li>a{padding-left:96px}ul.nav-menu li ul>li>ul>li>ul>li>ul>li>a{padding-left:116px}ul.nav-menu li.menu>a:before{color:#a1a1a1;content:\"\\F2FB\";display:inline-block;float:right;font-family:Material-Design-Iconic-Font;font-size:15px;margin-left:10px;position:relative;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;transition:all .3s ease-in-out;font-weight:400}ul.nav-menu li.menu.no-arrow>a:before{display:none}ul.nav-menu li.menu.open>a:before,ul.nav-menu li.menu>a:focus:before,ul.nav-menu li.menu li>a:hover:before{background-color:transparent;color:#fff}ul.nav-menu li.menu.active>a:before,ul.nav-menu li.menu.open>a:before{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}ul.nav-menu li.menu.open .sub-menu li.active>a,ul.nav-menu li.menu.open .sub-menu li.active>a:before,ul.nav-menu li.menu .sub-menu li>a:focus,ul.nav-menu li.menu .sub-menu li>a:focus:before,ul.nav-menu li.menu .sub-menu li>a:hover,ul.nav-menu li.menu .sub-menu li>a:hover:before{background-color:#1d1d1d;color:#fff}.app-container.mini-drawer .side-nav{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;width:80px}.app-container.mini-drawer .side-nav .customizer,.app-container.mini-drawer .side-nav .nav-menu li span.nav-text,.app-container.mini-drawer .side-nav .user-profile .user-detail{display:none}.app-container.mini-drawer .side-nav .nav-menu .menu.open>.sub-menu{display:none!important}.app-container.mini-drawer .side-nav .nav-header{padding:10px}.app-container.mini-drawer .side-nav .nav-menu li{text-align:center}.app-container.mini-drawer .side-nav .nav-menu li i{margin-right:0}.app-container.mini-drawer .side-nav ul.nav-menu li a{padding:16px 20px}.app-container.mini-drawer .side-nav ul.nav-menu ul.sub-menu li a{padding-left:30px}.app-container.mini-drawer .side-nav ul.nav-menu>li>a:before{display:none}.app-container.mini-drawer .side-nav:hover{width:280px}.app-container.mini-drawer .side-nav:hover .nav-menu li span.nav-text,.app-container.mini-drawer .side-nav:hover .user-profile .user-detail{display:inline-block!important}.app-container.mini-drawer .side-nav:hover .nav-menu .menu.open>.sub-menu{display:block!important}.app-container.mini-drawer .side-nav:hover .nav-header{padding:10px 20px}.app-container.mini-drawer .side-nav:hover .customizer{display:flex!important}.app-container.mini-drawer .side-nav:hover ul.nav-menu li{text-align:left}.app-container.mini-drawer .side-nav:hover ul.nav-menu li i{margin-right:16px}.app-container.mini-drawer .side-nav:hover ul.nav-menu li a{padding:16px 20px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a{padding-left:56px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>a{padding-left:76px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>a{padding-left:96px}.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>ul>li>a{padding-left:116px}.app-container.mini-drawer .side-nav:hover ul.nav-menu>li>a:before{display:block}.customizer{padding:20px 35px}.customizer img{padding:5px;cursor:pointer}.user-info ul li{font-size:15px}ul.nav-menu li.menu.no-arrow>a:before{content:\"\"}#machine-learning h6{color:#fff}#machine-learning h4{font-size:12.25px}#machine-learning .set-background{background-color:#393e44}#machine-learning .set-background p{text-align:left}#machine-learning p{color:#fff}#machine-learning .first-line{font-size:1rem}#machine-learning .second-line,#machine-learning .third-line{font-size:.6rem}#machine-learning button{background-color:#92d050;color:#fff;margin-top:1rem}#machine-learning svg{background-color:#434f59!important}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.bg-wrapper{background-image:url(\"/assets/images/bg-image-senstra.jpg\");background-size:cover;background-position:50%}#sign-in a{cursor:pointer}#sign-in .forgot-password-text:hover{text-decoration:underline}#sign-in .app-logo-content{background-image:url(\"/assets/images/06.jpg\");background-repeat:round;box-shadow:0 0 10px 0 hsla(0,0%,9%,.8)}#sign-in .link-color{color:#aaa!important}@media only screen and (min-width:575px) and (max-width:640px){#sign-in .link-font-size{font-size:11px!important}}@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}#signup .app-logo-content{background-image:url(\"/assets/images/06.jpg\");background-size:cover;background-position:50%;box-shadow:0 0 10px 0 hsla(0,0%,9%,.8)}#signup .link-color{color:#aaa!important}.fa-rotate-45{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.drag-border{border:1px solid #ccc}.dragger{font-size:15px!important}@media only screen and (min-width:600px){.dragger{font-size:20px!important}}@media (max-width:576px){.profile-and-settings .profile-detail{font-size:10px}}.profile-and-settings i{cursor:pointer}.profile-and-settings img{border-radius:50%}.profile-and-settings .profile-side-nav{color:#fff;list-style-type:none}.profile-and-settings .profile-side-nav li{cursor:pointer;padding:.5rem}.profile-and-settings .profile-side-nav .MuiPaper-root-439{color:#000}@media only screen and (min-width:295px) and (max-width:991px){.profile-and-settings .image-size{width:150px}}.profile-sidebar :nth-child(2){background-color:#21272b!important}.profile-sidebar :nth-child(2) ul{list-style-type:none}.profile-sidebar .profile-side-nav{color:#fff}.profile-sidebar .profile-side-nav li{padding:5px 0}.profile-sidebar .profile-side-nav h1:after{content:\" \";width:20%;margin-top:5px;display:block;border:.5px solid #d0d0d0;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05);-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}#adminPanel .cursor-pointer,#adminPanel h3{cursor:pointer}#adminPanel .link-input-style{background-color:#132c3c;border-style:none;color:#fff;text-decoration:underline;box-shadow:0 1px 2px 1px #255775;text-align:center}.app-index-wrapper{width:100vw}.app-index-wrapper .overlay-and-loader{background-color:#38414b;display:flex;position:absolute;top:0;left:0;height:100vh;width:100vw;opacity:1;transition:.5s ease;z-index:99999}", ""]);

// exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "427238f67009808ae296f5af0c6f4e52.woff2";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "08a1820fb8f68f6e7ac70dc747575d5a.woff";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1ef7dd144f921cc220abc60a9a30630f.woff2";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49aac2260586d57e388b3b0a014afb95.woff";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f29d51094af65998592290de22a03ba4.woff2";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cdcdea1a83fc234ba92c8dc6d20086d7.woff";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4e595ab54f0887b1bb441b12ebae5ffe.woff2";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ddae912fc4fea0411e8d8ddedb39f79.woff";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1318);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app-rtl.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./app-rtl.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(238);
exports = module.exports = __webpack_require__(115)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i);", ""]);

// module
exports.push([module.i, "@font-face{font-family:aguda_boldregular;src:url(" + escape(__webpack_require__(56)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(57)) + ") format(\"woff\");font-weight:400;font-style:normal}.rtl .color-option,.rtl .contact-info,.rtl .list-inline,.rtl .list-unstyled,.rtl .module-nav,.rtl .social-link{padding-right:0}.rtl .zmdi-hc-ul{margin-left:0;margin-right:2.14285714em}.rtl .zmdi-hc-li{left:auto;right:-2.14285714em}.rtl .ml-0,.rtl .mr-0{margin-left:0!important;margin-right:0!important}.rtl .mr-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-0,.rtl .pr-0{padding-left:0!important;padding-right:0!important}.rtl .pr-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-auto{margin-right:auto!important;margin-left:0!important}@media (min-width:576px){.rtl .ml-sm-0,.rtl .mr-sm-0{margin-left:0!important;margin-right:0!important}.rtl .mr-sm-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-sm-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-sm-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-sm-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-sm-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-sm-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-sm-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-sm-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-sm-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-sm-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-sm-0,.rtl .pr-sm-0{padding-left:0!important;padding-right:0!important}.rtl .pr-sm-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-sm-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-sm-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-sm-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-sm-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-sm-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-sm-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-sm-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-sm-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-sm-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-sm-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-sm-auto{margin-right:auto!important;margin-left:0!important}}@media (min-width:768px){.rtl .ml-md-0,.rtl .mr-md-0{margin-left:0!important;margin-right:0!important}.rtl .mr-md-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-md-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-md-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-md-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-md-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-md-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-md-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-md-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-md-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-md-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-md-0,.rtl .pr-md-0{padding-left:0!important;padding-right:0!important}.rtl .pr-md-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-md-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-md-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-md-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-md-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-md-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-md-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-md-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-md-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-md-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-md-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-md-auto{margin-right:auto!important;margin-left:0!important}}@media (min-width:992px){.rtl .ml-lg-0,.rtl .mr-lg-0{margin-left:0!important;margin-right:0!important}.rtl .mr-lg-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-lg-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-lg-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-lg-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-lg-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-lg-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-lg-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-lg-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-lg-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-lg-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-lg-0,.rtl .pr-lg-0{padding-left:0!important;padding-right:0!important}.rtl .pr-lg-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-lg-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-lg-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-lg-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-lg-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-lg-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-lg-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-lg-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-lg-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-lg-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-lg-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-lg-auto{margin-right:auto!important;margin-left:0!important}}@media (min-width:1200px){.rtl .ml-xl-0,.rtl .mr-xl-0{margin-left:0!important;margin-right:0!important}.rtl .mr-xl-1{margin-left:.25rem!important;margin-right:0!important}.rtl .ml-xl-1{margin-right:.25rem!important;margin-left:0!important}.rtl .mr-xl-2{margin-left:.5rem!important;margin-right:0!important}.rtl .ml-xl-2{margin-right:.5rem!important;margin-left:0!important}.rtl .mr-xl-3{margin-left:1rem!important;margin-right:0!important}.rtl .ml-xl-3{margin-right:1rem!important;margin-left:0!important}.rtl .mr-xl-4{margin-left:1.5rem!important;margin-right:0!important}.rtl .ml-xl-4{margin-right:1.5rem!important;margin-left:0!important}.rtl .mr-xl-5{margin-left:3rem!important;margin-right:0!important}.rtl .ml-xl-5{margin-right:3rem!important;margin-left:0!important}.rtl .pl-xl-0,.rtl .pr-xl-0{padding-left:0!important;padding-right:0!important}.rtl .pr-xl-1{padding-left:.25rem!important;padding-right:0!important}.rtl .pl-xl-1{padding-right:.25rem!important;padding-left:0!important}.rtl .pr-xl-2{padding-left:.5rem!important;padding-right:0!important}.rtl .pl-xl-2{padding-right:.5rem!important;padding-left:0!important}.rtl .pr-xl-3{padding-left:1rem!important;padding-right:0!important}.rtl .pl-xl-3{padding-right:1rem!important;padding-left:0!important}.rtl .pr-xl-4{padding-left:1.5rem!important;padding-right:0!important}.rtl .pl-xl-4{padding-right:1.5rem!important;padding-left:0!important}.rtl .pr-xl-5{padding-left:3rem!important;padding-right:0!important}.rtl .pl-xl-5{padding-right:3rem!important;padding-left:0!important}.rtl .mr-xl-auto{margin-left:auto!important;margin-right:0!important}.rtl .ml-xl-auto{margin-right:auto!important;margin-left:0!important}}.rtl .text-left{text-align:right!important}.rtl .text-right{text-align:left!important}@media (min-width:576px){.rtl .text-sm-left{text-align:right!important}.rtl .text-sm-right{text-align:left!important}}@media (min-width:768px){.rtl .text-md-left{text-align:right!important}.rtl .text-md-right{text-align:left!important}}@media (min-width:992px){.rtl .text-lg-left{text-align:right!important}.rtl .text-lg-right{text-align:left!important}}@media (min-width:1200px){.rtl .text-xl-left{text-align:right!important}.rtl .text-xl-right{text-align:left!important}}.rtl .jr-menu-icon .menu-icon:after,.rtl .jr-menu-icon .menu-icon:before{left:auto;right:0}.rtl .side-nav{border-left:0 none!important}.rtl .side-nav .user-avatar{margin:0 0 0 15px!important}.rtl ul.nav-menu li.menu>a{border-left:0 none;border-right:2px solid transparent}.rtl ul.nav-menu li.menu>a:before{float:left;-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg);margin-left:0;margin-right:10px}.rtl ul.nav-menu li.menu.active>a:before,.rtl ul.nav-menu li.menu.open>a:before{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}.rtl ul.nav-menu li i{margin-left:16px;margin-right:0}.rtl ul.nav-menu li ul>li>a{padding-left:20px;padding-right:56px}.rtl ul.nav-menu li ul>li>ul>li>a{padding-left:20px;padding-right:76px}.rtl ul.nav-menu li ul>li>ul>li>ul>li>a{padding-left:20px;padding-right:96px}.rtl ul.nav-menu li ul>li>ul>li>ul>li>ul>li>a{padding-left:20px;padding-right:116px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu li{text-align:right}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu li i{margin-left:16px;margin-right:0}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a{padding-left:20px;padding-right:56px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>a{padding-left:20px;padding-right:76px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>a{padding-left:20px;padding-right:96px}.rtl .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu>li>ul>li>ul>li>ul>li>a{padding-left:20px;padding-right:116px}.rtl .theme-option{right:auto;left:0;border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:2px;border-bottom-right-radius:2px}.rtl .cr-op-dark-sidebar li a:after{left:auto;right:0}.rtl .app-container.fixed-drawer .app-main-header{left:0;right:280px}@media screen and (max-width:1199px){.rtl .app-container.fixed-drawer .app-main-header{left:0;right:0}}.rtl .app-container.mini-drawer .app-main-header{left:0;right:80px}.rtl .jr-menu-icon{margin-right:0;margin-left:15px}.rtl .app-toolbar .search-bar{margin-left:auto;margin-right:100px}@media screen and (max-width:767px){.rtl .app-toolbar .search-bar{margin-left:auto;margin-right:40px}}.rtl .app-toolbar .nav-searchbox .search-bar{margin-left:auto;margin-right:0}.rtl .quick-menu .dropdown-menu .jr-card-header{padding:10px 20px 10px 10px}.rtl .quick-menu .dropdown-menu:after,.rtl .quick-menu .dropdown-menu:before{right:auto;left:8px}.rtl .quick-menu .messages-list .badge{left:auto;right:-4px}.rtl .messages-list ul li .jr-btn{margin-right:auto!important;margin-left:0!important}.rtl .quick-menu .icon-alert:after{right:auto;left:0}.rtl .quick-menu .dropdown-menu{right:auto!important;left:0!important}.rtl .net-chart{padding-left:8px;padding-right:0}.rtl .net-chart .jr-card-thumb{margin:0 0 0 20px}.rtl .net-chart:hover .jr-card-thumb{margin-right:0;margin-left:5px}.rtl .net-chart .jr-card-thumb img{margin-left:0;margin-right:15px}.rtl .net-chart:hover .jr-card-thumb img{margin:-18px 0 -18px 15px}.rtl .net-chart-hr{padding-right:24px;padding-left:8px}.rtl .net-chart-hr .jr-card-thumb{margin:-30px -24px -30px 12px}.rtl .jr-card-header-top{margin-right:0;margin-left:-16px}.rtl .social-list-line:not(:last-child):before{border-left:0 none;border-right:1px solid #adb5bd;left:0;right:20px}.rtl .list-line-item{padding-left:0;padding-right:40px}.rtl .list-line-item:not(:last-child):before{border-left:0 none;border-right:1px solid #adb5bd;left:0;right:20px}.rtl .list-line-badge{left:0;right:16px}.rtl .box .box-bottom .size-h5,.rtl .box .box-top .size-h5{margin-left:0;margin-right:2px}.rtl .contact-list i{margin-right:0;margin-left:14px}.rtl .status-cell{padding-right:0!important;padding-left:24px!important}.rtl .breadcrumb-item+.breadcrumb-item:before,.rtl .zmdi-chevron-right:before{content:\"\\F2FA\"}.rtl .chartAreaWrapper,.rtl .chartWrapper,.rtl .recharts-responsive-container{direction:rtl}.rtl .manage-margin>:not(:last-child){margin-right:0;margin-left:16px}.rtl .col-with-divider div[class*=col-]{border-left:0 none;border-right:1px solid #dee2e6}.rtl .right-arrow:after{margin-left:0;margin-right:8px}.rtl .btn-group>.jr-btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:2px!important;border-bottom-right-radius:2px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important}.rtl .btn-group>.dropdown-toggle:not(:first-child),.rtl .btn-group>.jr-btn:last-child:not(:first-child){border-top-left-radius:2px!important;border-bottom-left-radius:2px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.rtl .app-module{margin-left:0;margin-right:-24px}.rtl .app-module:before{right:0;left:-24px}.rtl .module-side-header{padding:24px 29px 24px 10px}.rtl .module-nav li i{margin-right:0;margin-left:16px}.rtl .module-box-header .search-bar.right-side-icon .form-control{padding:18px 70px 18px 18px}.rtl .module-box-header .search-bar.right-side-icon .search-icon{left:auto;right:9px}.rtl .toolbar-separator{border-left:0 none;border-right:1px solid #ced4da}.rtl .module-list-item.mail-cell{padding-left:0;padding-right:12px}.rtl .module-list-actions{text-align:left}.rtl .search-wrapper .search-bar.right-side-icon .form-control{padding-left:0;padding-right:32px}.rtl .search-wrapper .search-bar.right-side-icon .search-icon{left:auto;right:0}.rtl .modal-box-header h2 button{right:auto;left:0}.rtl .btn-fixed{right:auto;left:40px}.rtl .mail-user-info .avatar{margin-right:0;margin-left:10px}.rtl .sender-name{margin-right:0;margin-left:8px}.rtl .mail-header-actions{text-align:left}.rtl .mail-header-actions .btn:not(:last-child){margin-right:0;margin-left:3px}.rtl .contact-block .contact-info li{border-right:0 none;border-left:2px solid #212529}.rtl .contact-block .contact-info li>i{float:right;margin-right:0;margin-left:5px}.rtl .contact-block .contact-info li .contact-body .icon{margin-right:0;margin-left:6px}.rtl .contact-block .contact-info li .contact-body .icon:last-child{margin-left:0}.rtl .contact-block .contact-info.vertical li{border-left:0 none}.rtl .Collapsible__trigger:after{right:auto;left:24px}.rtl .meta-date+.meta-comment{margin-left:0;margin-right:10px}.rtl .search-bar input[type=search]{padding-right:15px;padding-left:50px}.rtl .search-bar .form-control.form-control-lg+.search-icon,.rtl .search-bar .search-icon{right:auto;left:14px}.rtl .search-bar.right-side-icon input[type=search]{padding-right:50px;padding-left:16px}.rtl .search-bar.right-side-icon .form-control.form-control-lg+.search-icon,.rtl .search-bar.right-side-icon .search-icon{left:auto;right:14px}.rtl .meta-comment i,.rtl .meta-date i{margin-right:0;margin-left:6px}.rtl .alert .alert-addon{left:auto;right:0}.rtl .alert-dismissible{padding-left:60px}.rtl .alert-addon-card{padding-right:80px}.rtl .user-avatar{margin-right:0;margin-left:8px}.rtl .badge:not(:last-child){margin-right:0;margin-left:15px}.rtl blockquote{padding:10px 20px 10px 0}.rtl .blockquote{border-left:0 none;border-right:5px solid #e9ecef}.rtl .blockquote-reverse{border-right:0 none;border-left:5px solid #e9ecef;text-align:left;padding-left:20px;padding-right:0}.rtl .btn:not(:last-child),.rtl .jr-btn:not(:last-child),.rtl .jr-fab-btn:not(:last-child){margin-right:0;margin-left:15px}.rtl .jr-btn i+span,.rtl .jr-btn span+i{margin-left:0;margin-right:6px}.rtl .complex-btn .img-marked{left:auto;right:calc(50% - 9px)}.rtl .jr-btn.jr-btn-label.left i{left:auto;right:0}.rtl .jr-btn.jr-btn-label.right i{right:auto;left:0}.rtl .jr-btn.jr-btn-label.left i+span{margin-left:0;margin-right:30px}.rtl .jr-btn.jr-btn-label.right i+span{margin-right:0;margin-left:30px}.rtl .product-row{text-align:left}.rtl .product-row.even{text-align:right}.rtl .profile-intro .icon:not(:last-child){margin-right:0;margin-left:10px}.rtl .jr-card-header .badge:last-child{margin-left:0;margin-right:10px}.rtl .icons-wrapper+.icons-wrapper{margin-left:0;margin-right:25px}.rtl .user-list .user-avatar{margin-right:0;margin-left:20px}.rtl .jr-mbtn-list{margin-left:0;margin-right:-20px}.rtl .pt-circle .package-header>.price>i,.rtl .pt-classic .package-header>.price>i,.rtl .pt-dark .package-header>.price>i,.rtl .pt-default .package-header>.price>i{margin-right:0;margin-left:6px}.rtl .pt-circle .package-items li i,.rtl .pt-classic .package-items li i,.rtl .pt-dark .package-items li i,.rtl .pt-default .package-items li i{float:right;margin-right:0;margin-left:16px}.rtl .fab-progress{left:auto;right:-6px}.rtl .btn-progress{margin-left:0;margin-right:-12px}.rtl .table-header{padding-right:24px!important;padding-left:2px!important}.rtl .testimonial-in-bg{padding:30px 150px 30px 30px}@media screen and (max-width:450px){.rtl .testimonial-in-bg{padding-left:30px;padding-right:100px}}.rtl .testimonial-in-bg .pic{left:auto;right:20px}.rtl .testimonial-in-bg .description:before{left:auto;right:-24px}.rtl .timeline-left{float:right;margin-right:0;margin-left:20px}.rtl .timeline-right{float:left;margin-left:0;margin-right:20px}.rtl .timeline-item{padding-left:0;padding-right:80px}.rtl .timeline-item:before{border-left:0 none;border-right:2px solid #dee2e6;left:auto;right:25px}.rtl .timeline-item:first-child:before,.rtl .timeline-item:last-child:before{border-right-style:dashed}.rtl .timeline-badge{left:auto;right:0}.rtl .timeline-panel:before{border-width:15px 0 15px 15px;left:auto;right:-15px}.rtl .timeline-panel:after{border-width:14px 0 14px 14px;left:auto;right:-14px}.rtl .timeline-inverted .timeline-left{float:left;margin-right:20px;margin-left:0}.rtl .timeline-center .timeline-item{float:left;padding-left:0;padding-right:55px}.rtl .timeline-center .timeline-item:before{left:auto;right:0}.rtl .timeline-center .timeline-badge{left:auto;right:-25px}.rtl .timeline-center .timeline-time{left:auto;right:-150px}.rtl .timeline-center .timeline-inverted{float:right;text-align:left;padding-left:55px;padding-right:0}.rtl .timeline-center .timeline-inverted:before{border-left:2px solid #dee2e6;border-right:0 none;left:-2px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-badge{left:-25px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-panel:before{border-width:15px 15px 15px 0;left:-15px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-panel:after{border-width:14px 14px 14px 0;left:-14px;right:auto}.rtl .timeline-center .timeline-inverted .timeline-time{right:auto;left:-150px}.rtl .timeline-zigzag .timeline-item{padding-left:0;padding-right:150px}.rtl .timeline-zigzag .timeline-img{left:auto;right:5px}.rtl .timeline-zigzag .timeline-inverted .timeline-img{right:auto!important;left:5px!important}.rtl .timeline-zigzag .timeline-inverted{padding-left:150px;padding-right:0}.rtl .timeline-zigzag .timeline-item:first-child:before{border-right-style:solid}@media screen and (max-width:1199px){.rtl .app-module{margin-right:0}.rtl .app-module:before{right:-24px}.rtl .module-box-header .search-bar.right-side-icon .form-control{padding-left:0;padding-right:100px}.rtl .module-box-header .search-bar.right-side-icon .search-icon{left:auto;right:48px}.rtl .module-box-header .drawer-btn{left:auto;right:0}}@media screen and (max-width:991px){.rtl .module-list-item.mail-cell{padding-right:0;padding-left:20px}.rtl .timeline-zigzag .timeline-item{padding-left:0;padding-right:120px}.rtl .timeline-zigzag .timeline-inverted{padding-right:0;padding-left:120px}}@media screen and (max-width:767px){.rtl .contact-block .contact-info li{border-left:0 none}.rtl .timeline-center .timeline-item{padding-left:0;padding-right:80px}.rtl .timeline-center .timeline-item:before{left:auto;right:25px}.rtl .timeline-center .timeline-badge{left:auto;right:0}.rtl .timeline-center .timeline-inverted{text-align:right;padding-left:0}.rtl .timeline-center .timeline-inverted:before{border-left:0 none;border-right:2px solid #dee2e6;left:auto;right:24px}.rtl .timeline-center .timeline-inverted .timeline-badge{right:0;left:auto}.rtl .timeline-center .timeline-inverted .timeline-panel:before{border-width:15px 0 15px 15px;left:auto;right:-15px}.rtl .timeline-center .timeline-inverted .timeline-panel:after{border-width:14px 0 14px 14px;left:auto;right:-14px}.rtl .timeline-inverted .timeline-left{float:right;margin-left:20px;margin-right:0}.rtl .timeline-zigzag .timeline-item{padding-left:0;padding-right:100px}.rtl .timeline-zigzag .timeline-item:before{left:auto;right:45px}.rtl .product-row,.rtl .product-row.even{text-align:center}.rtl .timeline-center .timeline-time{right:0}}@media screen and (max-width:575px){.rtl .jr-menu-icon{margin-left:0}.rtl .app-main-header .list-inline-item:not(:last-child){margin-right:0}}@media screen and (max-width:499px){.rtl .mail-header-actions{text-align:right}}@media screen and (max-width:399px){.rtl .timeline-left{margin-left:10px}.rtl .timeline-right{margin-right:0}.rtl .timeline-inverted .timeline-left{margin-left:0}}", ""]);

// exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _indigo = __webpack_require__(338);

var _indigo2 = _interopRequireDefault(_indigo);

var _pink = __webpack_require__(232);

var _pink2 = _interopRequireDefault(_pink);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _indigo2.default[300],
            main: _indigo2.default[500],
            dark: _indigo2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _pink2.default[300],
            main: _pink2.default['A200'],
            dark: _pink2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/indigoTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_indigo2, '_indigo2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/indigoTheme.js');

    __REACT_HOT_LOADER__.register(_pink2, '_pink2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/indigoTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/indigoTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/indigoTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/indigoTheme.js');
}();

;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cyan = __webpack_require__(542);

var _cyan2 = _interopRequireDefault(_cyan);

var _green = __webpack_require__(354);

var _green2 = _interopRequireDefault(_green);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _cyan2.default[300],
            main: _cyan2.default[500],
            dark: _cyan2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _green2.default[300],
            main: _green2.default['A200'],
            dark: _green2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/cyanTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_cyan2, '_cyan2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/cyanTheme.js');

    __REACT_HOT_LOADER__.register(_green2, '_green2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/cyanTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/cyanTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/cyanTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/cyanTheme.js');
}();

;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deepOrange = __webpack_require__(239);

var _deepOrange2 = _interopRequireDefault(_deepOrange);

var _lightBlue = __webpack_require__(543);

var _lightBlue2 = _interopRequireDefault(_lightBlue);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _deepOrange2.default[300],
            main: _deepOrange2.default[500],
            dark: _deepOrange2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _lightBlue2.default[300],
            main: _lightBlue2.default['A200'],
            dark: _lightBlue2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/orangeTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_deepOrange2, '_deepOrange2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/orangeTheme.js');

    __REACT_HOT_LOADER__.register(_lightBlue2, '_lightBlue2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/orangeTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/orangeTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/orangeTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/orangeTheme.js');
}();

;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deepOrange = __webpack_require__(239);

var _deepOrange2 = _interopRequireDefault(_deepOrange);

var _amber = __webpack_require__(355);

var _amber2 = _interopRequireDefault(_amber);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _amber2.default[300],
            main: _amber2.default[500],
            dark: _amber2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _deepOrange2.default[300],
            main: _deepOrange2.default['A400'],
            dark: _deepOrange2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },

    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/amberTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_deepOrange2, '_deepOrange2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/amberTheme.js');

    __REACT_HOT_LOADER__.register(_amber2, '_amber2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/amberTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/amberTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/amberTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/amberTheme.js');
}();

;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pink = __webpack_require__(232);

var _pink2 = _interopRequireDefault(_pink);

var _teal = __webpack_require__(544);

var _teal2 = _interopRequireDefault(_teal);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _pink2.default[300],
            main: _pink2.default[500],
            dark: _pink2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _teal2.default[300],
            main: _teal2.default['A700'],
            dark: _teal2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/pinkTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_pink2, '_pink2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/pinkTheme.js');

    __REACT_HOT_LOADER__.register(_teal2, '_teal2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/pinkTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/pinkTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/pinkTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/pinkTheme.js');
}();

;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _blue = __webpack_require__(545);

var _blue2 = _interopRequireDefault(_blue);

var _deepOrange = __webpack_require__(239);

var _deepOrange2 = _interopRequireDefault(_deepOrange);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _blue2.default[300],
            main: _blue2.default[500],
            dark: _blue2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _deepOrange2.default[300],
            main: _deepOrange2.default['A200'],
            dark: _deepOrange2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/blueTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_blue2, '_blue2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/blueTheme.js');

    __REACT_HOT_LOADER__.register(_deepOrange2, '_deepOrange2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/blueTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/blueTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/blueTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/blueTheme.js');
}();

;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deepPurple = __webpack_require__(546);

var _deepPurple2 = _interopRequireDefault(_deepPurple);

var _amber = __webpack_require__(355);

var _amber2 = _interopRequireDefault(_amber);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _deepPurple2.default[300],
            main: _deepPurple2.default[500],
            dark: _deepPurple2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _amber2.default[300],
            main: _amber2.default['A700'],
            dark: _amber2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/purpleTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_deepPurple2, '_deepPurple2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/purpleTheme.js');

    __REACT_HOT_LOADER__.register(_amber2, '_amber2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/purpleTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/purpleTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/purpleTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/purpleTheme.js');
}();

;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _green = __webpack_require__(354);

var _green2 = _interopRequireDefault(_green);

var _orange = __webpack_require__(547);

var _orange2 = _interopRequireDefault(_orange);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        primary: {
            light: _green2.default[300],
            main: _green2.default[500],
            dark: _green2.default[700],
            contrastText: '#fff'
        },
        secondary: {
            light: _orange2.default[300],
            main: _orange2.default['A700'],
            dark: _orange2.default[700],
            contrastText: '#fff'
        }
    },
    status: {
        danger: 'orange'
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/greenTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_green2, '_green2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/greenTheme.js');

    __REACT_HOT_LOADER__.register(_orange2, '_orange2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/greenTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/greenTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/greenTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/greenTheme.js');
}();

;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _grey = __webpack_require__(339);

var _grey2 = _interopRequireDefault(_grey);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var _default = {
    palette: {
        type: 'dark',
        types: {
            dark: {
                background: {
                    paper: '#2d353c',
                    default: '#2d353c',
                    appBar: '#2d353c',
                    contentFrame: '#2d353c',
                    chip: '#2d353c',
                    avatar: '#2d353c'
                }
            }
        },
        primary: {
            light: _grey2.default[400],
            main: _grey2.default[700],
            dark: _grey2.default[900],
            contrastText: '#fff'
        },
        secondary: {
            light: _grey2.default[200],
            main: _grey2.default[500],
            dark: _grey2.default[700],
            contrastText: '#fff'
        },
        background: {
            paper: '#2d353c',
            default: '#2d353c',
            appBar: '#2d353c',
            contentFrame: '#2d353c',
            chip: '#2d353c',
            avatar: '#2d353c'
        }
    },
    status: {
        danger: 'orange'
    },

    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
};
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/darkTheme.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_grey2, '_grey2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/darkTheme.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/darkTheme.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/darkTheme.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/themes/darkTheme.js');
}();

;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _enUS = __webpack_require__(1329);

var _enUS2 = _interopRequireDefault(_enUS);

var _zhHansCN = __webpack_require__(1332);

var _zhHansCN2 = _interopRequireDefault(_zhHansCN);

var _ar_SA = __webpack_require__(1335);

var _ar_SA2 = _interopRequireDefault(_ar_SA);

var _it_IT = __webpack_require__(1338);

var _it_IT2 = _interopRequireDefault(_it_IT);

var _es_ES = __webpack_require__(1341);

var _es_ES2 = _interopRequireDefault(_es_ES);

var _fr_FR = __webpack_require__(1344);

var _fr_FR2 = _interopRequireDefault(_fr_FR);

var _reactIntl = __webpack_require__(353);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var AppLocale = {
    en: _enUS2.default,
    zh: _zhHansCN2.default,
    ar: _ar_SA2.default,
    it: _it_IT2.default,
    es: _es_ES2.default,
    fr: _fr_FR2.default
};
(0, _reactIntl.addLocaleData)(AppLocale.en.data);
(0, _reactIntl.addLocaleData)(AppLocale.zh.data);
(0, _reactIntl.addLocaleData)(AppLocale.ar.data);
(0, _reactIntl.addLocaleData)(AppLocale.it.data);
(0, _reactIntl.addLocaleData)(AppLocale.es.data);
(0, _reactIntl.addLocaleData)(AppLocale.fr.data);

var _default = AppLocale;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(AppLocale, 'AppLocale', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_enUS2, '_enUS2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_zhHansCN2, '_zhHansCN2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_ar_SA2, '_ar_SA2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_it_IT2, '_it_IT2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_es_ES2, '_es_ES2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_fr_FR2, '_fr_FR2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(AppLocale, 'AppLocale', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/index.js');
}();

;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _en = __webpack_require__(1330);

var _en2 = _interopRequireDefault(_en);

var _en_US = __webpack_require__(1331);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var EnLang = {
    messages: _extends({}, _en_US2.default),
    locale: 'en-US',
    data: _en2.default
};
var _default = EnLang;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(EnLang, 'EnLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(_en2, '_en2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(_en_US2, '_en_US2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(EnLang, 'EnLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/en-US.js');
}();

;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"View","sidebar.dashboard":"Dashboard","sidebar.dashboard.default":"Default","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"News","sidebar.dashboard.intranet":"Intranet","sidebar.components":"Components","sidebar.components.alerts":"Alerts","sidebar.components.appbar":"App Bar","sidebar.components.autocomplete":"AutoComplete","sidebar.components.avatars":"Avatars","sidebar.components.badge":"Badge","sidebar.components.bottomNavigation":"Bottom Navigation","sidebar.components.breadcrumbs":"Breadcrumbs","sidebar.components.buttons":"Buttons","sidebar.components.buttonGroup":"Button Group","sidebar.components.cards":"Cards","sidebar.components.carousel":"Carousel","sidebar.components.chips":"Chips","sidebar.components.colorPicker":"Color Picker","sidebar.components.dialogs":"Dialogs","sidebar.components.dividers":"Dividers","sidebar.components.expansionPanel":"Expansion Panel","sidebar.components.drawer":"Drawer","sidebar.components.gridList":"Grid List","sidebar.components.lists":"Lists","sidebar.components.menusPaper":"Menus & Paper","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"Popovers","sidebar.components.progress":"Progress","sidebar.components.selects":"Selects","sidebar.components.selectionControl":"Selection Controls","sidebar.components.snackbars":"Snackbars","sidebar.components.stepper":"Stepper","sidebar.components.tables":"Tables","sidebar.components.tabs":"Tabs","sidebar.components.textFields":"Text Fields","sidebar.components.tooltips":"Tooltips","sidebar.components.typography":"Typography","sidebar.widgets":"Widgets","sidebar.metrics":"Metrics","sidebar.view":"View","sidebar.tables":"Tables","sidebar.tables.basicTable":"Basic Table","sidebar.tables.dataTable":"Data Table","sidebar.timeLine":"Time Line","sidebar.timeLine.default":"Default","sidebar.timeLine.defaultwithIcons":"Default with Icons","sidebar.timeLine.leftAligned":"Left Aligned","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Custom Views","sidebar.customViews.plainListView":"Plain List View","sidebar.customViews.withDivider":"Plain List with Divider","sidebar.customViews.cardListView":"Cards List View","sidebar.form":"Form","sidebar.forms":"Forms","sidebar.forms.components":"Components","sidebar.forms.stepper":"Stepper","sidebar.extensions":"Extensions","sidebar.editors":"Editors","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"WYSISWYG Editor","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Date & Time Pickers","sidebar.pickers.colorPickers":"Color Pickers","sidebar.extensions.dragNDrop":"Drag and Drop","sidebar.extensions.sweetAlert":"Sweet Alert","sidebar.extensions.notification":"Notification","sidebar.chart":"Chart","sidebar.chart.line":"Line Chart","sidebar.chart.bar":"Bar Chart","sidebar.chart.area":"Area Chart","sidebar.chart.composed":"Composed Chart","sidebar.chart.scatter":"Scatter Chart","sidebar.chart.pie":"Pie Chart","sidebar.chart.radial":"Radial Chart","sidebar.chart.radar":"Radar Chart","sidebar.chart.tree":"Tree Chart","sidebar.map":"Google Map","sidebar.map.simple":"Simple Map","sidebar.map.styled":"Styled Map","sidebar.map.geoLocation":"Geo Location","sidebar.map.mapDirection":"Map Direction","sidebar.map.overlay":"Map Overlay","sidebar.map.kmLayer":"Map Km Layer","sidebar.map.popupInfo":"Map Popup Info","sidebar.map.trafficLayer":"Map Traffic Layer","sidebar.map.streetView":"Street View","sidebar.map.eventListener":"Event Listener","sidebar.map.mapDrawing":"Map Drawing","sidebar.map.mapClustering":"Map Clustering","sidebar.modules":"Modules","sidebar.calendar":"Calendar","sidebar.calendar.basic":"Basic","sidebar.calendar.cultures":"Cultures","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Popup","sidebar.calendar.rendering":"Rendering","sidebar.calendar.selectable":"Selectable","sidebar.calendar.timeslots":"Timeslots","sidebar.eCommerce":"eCommerce","sidebar.eCommerce.productsList":"Products List","sidebar.eCommerce.productsGrid":"Products Grid","sidebar.appModule":"App Module","sidebar.appModule.login1":"Login Page 1","sidebar.appModule.login2":"Login Page 2","sidebar.appModule.loginStepper":"Login with Stepper","sidebar.appModule.signup1":"Signup Page 1","sidebar.appModule.signup2":"Signup Page 2","sidebar.appModule.forgotPassword1":"Forgot Password 1","sidebar.appModule.forgotPassword2":"Forgot Password 2","sidebar.appModule.lock1":"Lock Screen 1","sidebar.appModule.lock2":"Lock Screen 2","sidebar.appModule.toDo":"To-Do","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"Mail","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Chat","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contact","sidebar.appModule.contactRedux":"Contact Redux","sidebar.extras":"Extras","sidebar.icons":"Icons","sidebar.icons.material":"Google Material Icons","sidebar.extraElements":"Extra Elements","sidebar.extraElements.pricingTable":"Pricing Table","sidebar.extraElements.callouts":"Callouts","sidebar.extraElements.testimonials":"Testimonials","sidebar.extraPages":"Extra Pages","sidebar.extraPages.aboutUs":"About Us","sidebar.extraPages.contactUs":"Contact Us","sidebar.extraPages.blog":"Blog","sidebar.extraPages.faq":"FAQ","sidebar.extraPages.portfolio":"Portfolio","sidebar.extraPages.404":"404 Error Page","sidebar.extraPages.500":"500 Error Page","sidebar.menuLevels":"Menu Levels","sidebar.menuLevels.level1":"Level 1","sidebar.menuLevels.level2":"Level 2","sidebar.menuLevels.level3":"Level 3","appModule.forgotPassword":"Forgot your password?","appModule.dntRememberEmail":"Don't remember your email?","appModule.contactSupport":"Contact Support","appModule.resetPassword":"Reset Password","appModule.enterPasswordUnlock":"Enter your password to unlock the screen!","appModule.unlock":"Unlock","appModule.signInDiffAccount":"Sign in using different account","appModule.rememberMe":"Remember me","appModule.signIn":"Sign In","appModule.next":"Next","appModule.back":"Back","appModule.allStepsCompleted":"All steps completed","appModule.reset":"Reset","appModule.loginSuccessfully":"Login Successfully","appModule.password":"Password","appModule.email":"Email","appModule.name":"Name","appModule.phone":"Phone","appModule.designation":"Designation","appModule.regsiter":"Regsiter","appModule.hvAccount":"Have an account","appModule.createAccount":"Create an account","chart.area":"Area Graph","chart.bar":"Bar Graph","chart.composed":"Composed Graph","chart.line":"Line Graph","chart.pie":"Pie Graph","chart.radar":"Radar Graph","chart.radial":"Radial Graph","chart.scatter":"Scatter Graph","chart.tree":"Tree Graph","chat.selectUserChat":"Select User to start Chat","chat.selectContactChat":"Select contact to start Chat","chat.chatUser":"Chats","chat.contacts":"Contacts","chat.searchStartNewChat":"Search or start new chat","chat.typeMessage":"Type and hit enter to send message","chat.status":"it's a status....not your diary...","contact.saveContact":"Save Contact","contact.addContact":"Add Contact","contact.searchContact":"Search contact","button.modify":"Modify","button.delete":"Delete","button.yes":"Yes","button.no":"No","eCommerce.readMore":"Read More","eCommerce.addToCart":"Add to Cart","eCommerce.buyNow":"Buy now","extension.sweetAlerts":"Sweet Alerts","extension.notification":"Notification","sweetAlerts.basic":"Basic","sweetAlerts.description":"With Description","sweetAlerts.success":"Success","sweetAlerts.warning":"Warning","sweetAlerts.custom":"Custom","sweetAlerts.htmlTag":"Html Tag","sweetAlerts.prompt":"Prompt","sweetAlerts.itsBlue":"It's blue!","sweetAlerts.passwordPrompt":"Password Prompt","sweetAlerts.customStyle":"Custom Style","sweetAlerts.itPretty":"It's pretty, isn't it?","sweetAlerts.btnClicked":"You clicked the button!","sweetAlerts.youWillFind":"You will find they are up!","sweetAlerts.youWillNotAble":"You will not be able to recover this imaginary file!","sweetAlerts.hereIsaMessage":"Here's a message!","sweetAlerts.goodJob":"Good job!","sweetAlerts.yesDeleteIt":"Yes, delete it!","sweetAlerts.areYouSure":"Are you sure?","sweetAlerts.doYouLikeThumb":"Do you like thumbs?","sweetAlerts.anInput":"An input!","sweetAlerts.writeSomethingInteresting":"Write something interesting:","sweetAlerts.writeSomething":"Write something","sweetAlerts.youMustEnterPassword":"You must enter your password!","sweetAlerts.enterPassword":"Enter Password","notification.infoMsg":"Info message","notification.successMessage":"Success message","notification.warningMessage":"Warning message","notification.closeAfter3000ms":"Close after 3000ms","notification.errorMessage":"Error message","notification.titleHere":"Title here","notification.clickMe":"Click me!","notification.info":"Info","notification.success":"Success","notification.warning":"Warning","notification.error":"Error","extraElements.callouts":"Callouts","extraElements.pricingTable":"Pricing Table","extraElements.testimonials":"Testimonials","callouts.viewRange":"View Range","callouts.basic":"Basic","pricingTable.basic":"Basic","pricingTable.circle":"Circle","pricingTable.classic":"Classic","pricingTable.dark":"Dark","pricingTable.personal":"PERSONAL","pricingTable.easyTranslation":"Easy Translation","pricingTable.awesomeGoogleFonts":"Awesome Google Fonts","pricingTable.hotelBookingSystem":"Hotel Booking System","pricingTable.emailComposeInterface":"Email Compose Interface","pricingTable.locationFinderApp":"Location Finder App","pricingTable.buyNow":"buy now","pricingTable.business":"BUSINESS","pricingTable.professional":"PROFESSIONAL","testimonials.basic":"Basic","testimonials.classic":"Classic","testimonials.standard":"Standard","extraPages.goHome":"Go to Home","extraPages.ourClients":"Our Clients","extraPages.all":"All","extraPages.graphicDesign":"graphic design","extraPages.logo":"logo","extraPages.mobileApp":"mobile app","extraPages.web":"web","extraPages.404Msg":"Oops, an error has occurred. Page not found!","extraPages.500Msg":"Sorry, server goes wrong","extraPages.aboutUs.showCase":"Showcase your services here with information about them","aboutUs.readMore":"Read More","extraPages.goSomewhere":"Go somewhere","icon.material":"900+ Official Material Design Icons","mail.mailbox":"Mailbox","mail.compose":"COMPOSE","mail.filters":"Filters","mail.labels":"Labels","picker.color.alpha":"Alpha Pickers","picker.color.hue":"Hue Pickers","picker.color.circle":"Circle Pickers","picker.color.compact":"Compact Pickers","picker.color.block":"Block Pickers","picker.color.chrome":"Chrome Pickers","picker.color.github":"Github Pickers","picker.color.twitter":"Twitter Pickers","picker.color.withRedux":"With Redux","picker.color.sketch":"Sketch Pickers","picker.color.material":"Material Pickers","picker.color.slider":"Slider Pickers","picker.color.basic":"Basic Pickers","picker.color.basicToggle":"Basic Toggle","picker.color.custom":"Custom Pickers","picker.color.customPointer":"Custom Pointer","picker.color.photoshop":"Photoshop Pickers","picker.color.swatches":"Swatches Pickers","picker.color.basicPositioning":"Basic Positioning","picker.date.pickers":"Pickers","picker.date.date":"Date Pickers","picker.date.time":"Time Pickers","picker.date.week":"Week Pickers","picker.date.dateNTime":"Date & Time Pickers","picker.date.customDate":"Custom Date & Time Pickers","table.marketingCampaign":"Marketing Campaign","table.thisWeek":"This Week","table.recentOrders":"Recent Orders","table.dataTable":"Data Table","table.basicTable":"Basic Table","table.application":"Application Table","todo":"To-Do","todo.addTask":"ADD TASK","todo.all":"All","todo.filters":"Filters","todo.labels":"Labels","dashboard.recentActivities":"Recent Activities","dashboard.lastActivity":"Last activity was 2 days ago","dashboard.currentProjects":"Current Projects List","dashboard.toDoItems":"To-do Items List","dashboard.today":"Today","dashboard.marketingCampaign":"Marketing Campaign","dashboard.yourDailyFeed":"Your Daily Feed","dashboard.googleInsight":"Google insight score","dashboard.lastCalculated":"Las calculated 1 month ago","dashboard.refresh":"Refresh","dashboard.upgradeToday":"upgrade today","dashboard.onlineSignups":"Online Signups","dashboard.lastMonthSale":"Last Month Sale","dashboard.newVisits":"New Visits this month","dashboard.totalRevenue":"Total Revenue this year","dashboard.latestPosts":"Latest Posts","dashboard.loremIpsum":"Lorem ipsum is dummy content dollar sit is...","dashboard.viewAllPosts":"VIEW ALL POSTS","dashboard.popularProducts":"Popular Products","dashboard.popularProductsTxt":"It is a long established fact that a reader will be distracted by the readable content..","dashboard.allProducts":"all products","dashboard.userStatstics":"User Statstics","dashboard.orders":"Orders","dashboard.thisYearSaleReport":"This Year Sale Report","dashboard.post9MonthData":"Post 9 month data","dashboard.newCustomers":"New Customers","dashboard.newThisMonth":"32 new this Month","dashboard.monthly":"Monthly","dashboard.totalView":"Total View","dashboard.annual":"Annual","dashboard.newOrder":"New order","dashboard.visited":"Visited","dashboard.rapidPace":"Rapid pace","dashboard.slowPace":"Slow pace","dashboard.newConnections":"New Connections","dashboard.thisWeek":"3 This week","dashboard.newFeed":"23 New Feeds","dashboard.newSubscriber":"New Subscriber","dashboard.newArticles":"New Articles","dashboard.newAuthors":"New Authors","dashboard.avgDailyTraffic":"Avg Daily Traffic","dashboard.popularAuthors":"Popular Authors","dashboard.authorsWith":"Authors With 500+ avg. view","dashboard.popularArticles":"Popular Articles","dashboard.comments":"Comments","component.alert.default":"Default Alerts","component.alert.highlighted":"Highlighted Alerts","component.alert.dismissible":"Dismissible Alerts","component.alert.withIcons":"Alerts With Icons","component.alert.withDetailedHTML":"Alert With Detailed HTML","component.appbar.simple":"Simple App bar","component.appbar.colored":"Colored App bar","component.appbar.fullyFeatured":"Fully Featured App bar","component.autocomplete.reactSelect":"React Select","component.autocomplete.reactAutosuggest":"React Autosuggest","component.autocomplete.downshift":"Downshift","component.avatars.image":"Image Avatars","component.avatars.letter":"Letter Avatars","component.avatars.icon":"Icon Avatars","component.badge.scaling":"Scaling Badges","component.badge.insideLinks":"Inside Links & Butons","component.badge.contextual":"Contextual variations","component.badge.pill":"Pill Badges","component.badge.link":"Link Badges","component.bottomNavigation.withLabels":"Bottom Navigation with labels","component.bottomNavigation.withActiveLabels":"Bottom Navigation With Active Label","component.bottomNavigation.withNoLabels":"Bottom Navigation with No Label","component.breadcrumbs.simple":"Simple","component.breadcrumbs.noList":"No list","component.buttons.colorScheme":"Color Scheme","component.buttons.colorSchemeTxt":"Bootstrap Color Scheme With Material Concept","component.buttons.icon":"Icon Buttons","component.buttons.iconTxt":"You can pick any icon from the font-icons listed under Icons page. Or feel free to add any new font icons and use that.","component.buttons.differentSizes":"Different Sizes","component.buttons.differentSizesTxt":"Material buttons with different sizes","component.buttons.flatFullWidth":"Flat & Full Width Buttons","component.buttons.flatFullWidthTxt":"All type buttons with disabled states","component.buttons.raised":"Raised Buttons","component.buttons.raisedTxt":"Bootstrap Color Scheme With Material Concept","component.buttons.fab":"Floating Action Buttons","component.buttons.fabTxt":"Bootstrap Color Scheme With Material Concept","component.buttons.socialMedia":"Social Media Buttons","component.buttons.socialMediaTxt":"Various social media buttons for your project","component.buttons.complex":"Complex Buttons","component.buttonGroup.horizontalVariations":"Horizontal Variations","component.buttonGroup.defaultStyle":"Default buttons group style","component.buttonGroup.highlightedStyle":"Highlighted button group style","component.buttonGroup.flatStyle":"Flat button group style","component.buttonGroup.default":"Default Button Group","component.buttonGroup.flat":"Flat Button Group","component.buttonGroup.highlighted":"Highlighted Button Group","component.buttonGroup.icon":"Icon Button Group","component.buttonGroup.iconFlat":"Icon Flat Button Group","component.buttonGroup.nested":"Nested Button Group","component.cards.basic":"Basic Cards","component.cards.special":"Special Cards","component.cards.withHeader":"Cards with Header, Footer and Alignment","component.cards.navigational":"Navigational Cards","component.cards.image":"Image Cards","component.cards.solid":"Solid Cards","component.carousel.basic":"Basic Carousel","component.carousel.basicTxt":"Basic BS4 Carousel Powered With ReactStrap","component.carousel.product":"Product Carousel","component.carousel.productTxt":"A Horizontal Grid View Carousel","component.carousel.testimonial":"Testimonial Carousel","component.carousel.testimonialTxt":"One item carousel at a time","component.chips.default":"Default Chip","component.chips.outline":"Outline Chip","component.chips.chipWithText":"Chip With Text Avatar","component.chips.clickable":"Clickable Chip","component.chips.withImage":"Chip With Image Avatar","component.chips.deletable":"Deletable Chip","component.chips.withIcon":"Chip With Icon Avatar","component.chips.custom":"Custom Clickable Chip","component.chips.array":"Chip Array","component.chips.withInput":"Chips Implementation With Input Box","component.dividers.list":"List Dividers","component.dividers.inset":"Inset Dividers","component.dividers.default":"Default","component.drawer.persistent":"Persistent Drawer","component.drawer.permanent":"Permanent Drawer","component.drawer.mini":"Mini Drawer","component.drawer.responsive":"Responsive Drawer","component.expansionPanel.simple":"Simple Expansion Panel","component.expansionPanel.controlled":"Controlled Accordion","component.expansionPanel.secondary":"Secondary heading and Columns","component.gridList.image":"Image-only Grid list","component.gridList.advanced":"Advanced Grid list","component.gridList.singleLine":"Single line Grid list","component.gridList.withTitlebars":"Grid list with titlebars","component.lists.folder":"Folder List","component.lists.switch":"Switch List Controls","component.lists.dividers":"List Dividers","component.lists.simple":"Simple List","component.lists.inset":"Inset List","component.lists.nested":"Nested List","component.lists.checkbox":"Checkbox Secondary List Controls","component.lists.checkboxControls":"Checkbox List Controls","component.lists.pinned":"Pinned Subheader List","component.lists.interactive":"Interactive List Controls","component.chips":"Recent","component.menusPaper.simple":"Simple menus","component.menusPaper.withIcon":"Menu With Icon","component.menusPaper.withMoreButton":"Menu with More Button","component.menusPaper.withSelectedValue":"Menu With Selected Value","component.menusPaper.paper":"Paper","component.pickers.Date":"Date pickers","component.progress.indeterminateCircular":"Indeterminate Circular","component.progress.determinateCircular":"Determinate Circular","component.progress.indeterminateLinear":"Indeterminate Linear","component.progress.determinateLinear":"Determinate Linear","component.progress.bufferLinear":"Buffer Linear","component.progress.interactiveIntegration":"Interactive Integration","component.progress.queryLinear":"Query Linear","component.selectionControl.checkboxes":"Checkboxes","component.selectionControl.disabled":"Disabled","component.selectionControl.intermediate":"Intermediate","component.selectionControl.checkboxesWithForm":"Checkboxes with Form Group","component.selectionControl.basicRadio":"Basic Radio Buttons","component.selectionControl.disabledRadio":"Disabled Radio Buttons","component.selectionControl.withError":"With Error Message","component.selectionControl.switches":"Switches","component.selectionControl.verticalSwitches":"Vertical Switches","component.selectionControl.groupedSwitches":"Grouped Switches","component.selectionControl.verticalImplementation":"Vertical implementation of switches","component.selectionControl.generalSettings":"General Settings","component.selectionControl.themeSettings":"Theme Settings","component.selectionControl.onOffSwitches":"on/off switches","component.selectionControl.verticalInlineRadio":"Vertical and Inline radio buttons","component.selectionControl.checkboxesWithFormTxt":"Menus are positioned over their emitting elements such that the currently selected menu item appears on top of the emitting element.","component.selects.simple":"Simple Select","component.selects.native":"Native Select","component.selects.multiple":"Multiple Select","component.selects.dialog":"Dialog Select","component.snackbars.transition":"Transition Control Direction","component.snackbars.simple":"Simple","component.snackbars.positioned":"Positioned","component.snackbars.messageWithButton":"Message With Button","component.snackbars.colors":"Colors","component.snackbars.multilineText":"Multiline Text","component.snackbars.onlyMessage":"Only Message","component.snackbars.withIconButton":"Message with IconButton","component.stepper.horizontalLinear":"Horizontal Linear","component.stepper.horizontalLinearAlternativeLabel":"Horizontal Linear - Alternative Label","component.stepper.vertical":"Vertical Stepper","component.stepper.horizontalNonLinear":"Horizontal Non-linear","component.stepper.horizontalNonLinearAlternativeLabel":"Horizontal Non Linear - Alternative Label","component.stepper.mobileDots":"Mobile Stepper - Dots","component.stepper.mobileProgress":"Mobile Stepper - Progress","component.stepper.mobileText":"Mobile Stepper - Text","component.tabs.basic":"Basic Tabs","component.tabs.fixed":"Fixed Tabs Full width","component.tabs.icon":"Icon Tabs","component.tabs.disabled":"Disabled Tab","component.tabs.wrappedLabels":"Wrapped Labels","component.tabs.iconWithLabel":"Icon Tabs with Label","component.tabs.fixedCentered":"Fixed Tabs Centered","component.tabs.automaticScroll":"Automatic Scroll Buttons","component.tabs.forcedScroll":"Forced Scroll Buttons","component.tabs.preventScroll":"Prevent Scroll Buttons","component.textFields.textfield":"TextField","component.textFields.components":"Components","component.textFields.layout":"Layout","component.textFields.inputAdornments":"Input Adornments","component.textFields.formattedInputs":"Formatted Inputs","component.textFields.inputs":"Inputs","component.tooltips.avatar":"Avatar Tooltip","component.tooltips.button":"Button Tooltip","component.tooltips.icon":"Icon Tooltip","component.tooltips.controlled":"Controlled Tooltip","component.tooltips.positioned":"Positioned Tooltip","component.typography.lightHeadings":"Light Headings","component.typography.normalHeadings":"Normal Headings","component.typography.semiBoldHeadings":"Semi-bold Headings","component.typography.boldHeadings":"Bold Headings","component.typography.paragraphText":"Paragraph Text","component.typography.leadParagraphText":"Lead Paragraph Text","component.typography.unstyledList":"Unstyled List","component.typography.orderedList":"Ordered List","component.typography.unorderedList":"Unordered List","component.typography.listWithIcons":"List With Icons","component.typography.compactList":"Compact List","component.typography.extendedList":"Extended List","component.typography.leftIconGroupedList":"Left Icon Grouped List","component.typography.rightIconGroupedList":"Right Icon Grouped List","component.typography.badgesGroupedList":"Badges Grouped List","component.typography.defaultDescriptionList":"Default Description List","component.typography.evenOddDescriptionList":"Even-Odd Description List","component.typography.leftBlockquoteWithAuthorAvatar":"Left Blockquote With Author Avatar","component.typography.rightBlockquoteWithAuthorAvatar":"Right Blockquote With Author Avatar","signIn.success":"Login successfully!","signIn.error":"Invalid email or password!","signUp.success":"Account successfully created","signUp.error":"Right","signIn.signUp":"Create an account","signIn.connectWith":"or connect with","signUp.alreadyMember":"I am already a member","appModule.signin":"Sign In","appModule.signup":"Sign Up","pages.samplePage":"Sample Page","pages.samplePage.description":"Start building your app. Happy Coding!","mailNotification.title":"Messages","appNotification.title":" Notifications","mailNotification.message":" No new messages as of now!","appNotification.message":"No notifications as of now!","popup.profile":"Profile","popup.setting":"Setting","popup.logout":"Logout","popup.updateData":"Update Data","popup.detailedLog":"Detailed Log","popup.statistics":"Statistics","popup.clearData":"Clear Data","component.selectionControl.radioBtnGroup":"Radio Buttons Group","component.popover.anchorPlayground":"Anchor Playground"}

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _zh = __webpack_require__(1333);

var _zh2 = _interopRequireDefault(_zh);

var _zhHans = __webpack_require__(1334);

var _zhHans2 = _interopRequireDefault(_zhHans);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var ZhLan = {
    messages: _extends({}, _zhHans2.default),
    locale: 'zh-Hans-CN',
    data: _zh2.default
};
var _default = ZhLan;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ZhLan, 'ZhLan', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(_zh2, '_zh2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(_zhHans2, '_zhHans2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(ZhLan, 'ZhLan', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/zh-Hans-CN.js');
}();

;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"主要","sidebar.dashboard":"仪表板","sidebar.dashboard.default":"默认","sidebar.dashboard.ecommerce":"电子商务","sidebar.dashboard.news":"新闻","sidebar.dashboard.intranet":"内部网","sidebar.components":"组件","sidebar.components.alerts":"警报","sidebar.components.appbar":"应用程序栏","sidebar.components.autocomplete":"自动完成","sidebar.components.avatars":"头像","sidebar.components.badge":"徽章","sidebar.components.bottomNavigation":"底部导航","sidebar.components.breadcrumbs":"面包屑","sidebar.components.buttons":"纽扣","sidebar.components.buttonGroup":"按钮组","sidebar.components.cards":"牌","sidebar.components.carousel":"圆盘传送带","sidebar.components.chips":"芯片","sidebar.components.colorPicker":"选色器","sidebar.components.dialogs":"对话框","sidebar.components.dividers":"分频器","sidebar.components.expansionPanel":"扩展面板","sidebar.components.drawer":"抽屉","sidebar.components.gridList":"网格列表","sidebar.components.lists":"清单","sidebar.components.menusPaper":"菜单和纸张","sidebar.components.pickers":"拾荒者","sidebar.components.popovers":"约夏克布丁","sidebar.components.progress":"进展","sidebar.components.selects":"选择","sidebar.components.selectionControl":"选择控件","sidebar.components.snackbars":"小吃店","sidebar.components.stepper":"步进","sidebar.components.tables":"表","sidebar.components.tabs":"标签","sidebar.components.textFields":"文本字段","sidebar.components.tooltips":"提示","sidebar.components.typography":"活版印刷","sidebar.widgets":"小工具","sidebar.metrics":"度量","sidebar.view":"视图","sidebar.tables":"表","sidebar.tables.basicTable":"基本表","sidebar.tables.dataTable":"数据表","sidebar.timeLine":"时间线","sidebar.timeLine.default":"默认","sidebar.timeLine.defaultwithIcons":"默认使用图标","sidebar.timeLine.leftAligned":"左对齐","sidebar.timeLine.zigzag":"蜿蜒","sidebar.customViews":"自定义视图","sidebar.customViews.plainListView":"普通列表视图","sidebar.customViews.withDivider":"带分隔线的普通列表","sidebar.customViews.cardListView":"卡列表视图","sidebar.form":"形成","sidebar.forms":"形式","sidebar.forms.components":"组件","sidebar.forms.stepper":"步进","sidebar.extensions":"扩展","sidebar.editors":"编者","sidebar.editors.CKEditor":"CK编辑的","sidebar.editors.WYSISWYGEditor":"所见即所得的编辑器","sidebar.pickers":"拾荒者","sidebar.pickers.dateTimePickers":"日期和时间选择器","sidebar.pickers.colorPickers":"颜色选择器","sidebar.extensions.dragNDrop":"拖放","sidebar.extensions.sweetAlert":"甜蜜警报","sidebar.extensions.notification":"通知","sidebar.chart":"图表","sidebar.chart.line":"折线图","sidebar.chart.bar":"条形图","sidebar.chart.area":"面积图","sidebar.chart.composed":"组成图表","sidebar.chart.scatter":"散点图","sidebar.chart.pie":"饼形图","sidebar.chart.radial":"径向图","sidebar.chart.radar":"雷达图","sidebar.chart.tree":"树图","sidebar.map":"谷歌地图","sidebar.map.simple":"简单的地图","sidebar.map.styled":"风格地图","sidebar.map.geoLocation":"地理位置","sidebar.map.mapDirection":"地图方向","sidebar.map.overlay":"地图覆盖","sidebar.map.kmLayer":"地图Km层","sidebar.map.popupInfo":"地图弹出信息","sidebar.map.trafficLayer":"映射流量层","sidebar.map.streetView":"街景","sidebar.map.eventListener":"事件监听器","sidebar.map.mapDrawing":"地图绘制","sidebar.map.mapClustering":"地图集群","sidebar.modules":"模块","sidebar.calendar":"日历","sidebar.calendar.basic":"基本","sidebar.calendar.cultures":"文化","sidebar.calendar.dnd":"DND","sidebar.calendar.popup":"弹出","sidebar.calendar.rendering":"渲染","sidebar.calendar.selectable":"可选","sidebar.calendar.timeslots":"时隙","sidebar.eCommerce":"电子商务","sidebar.eCommerce.productsList":"产品列表","sidebar.eCommerce.productsGrid":"产品网格","sidebar.appModule":"App模块","sidebar.appModule.login1":"登录页面1","sidebar.appModule.login2":"登录页面2","sidebar.appModule.loginStepper":"用步进器登录","sidebar.appModule.signup1":"注册页面1","sidebar.appModule.signup2":"注册第2页","sidebar.appModule.forgotPassword1":"忘记密码1","sidebar.appModule.forgotPassword2":"忘记密码2","sidebar.appModule.lock1":"锁屏1","sidebar.appModule.lock2":"锁屏2","sidebar.appModule.toDo":"去做","sidebar.appModule.toDoRedux":"待办事项终极版","sidebar.appModule.mail":"邮件","sidebar.appModule.mailRedux":"邮件终极版","sidebar.appModule.chat":"聊","sidebar.appModule.chatRedux":"聊天终极版","sidebar.appModule.contact":"联系","sidebar.appModule.contactRedux":"联系终极版","sidebar.extras":"附加功能","sidebar.icons":"图标","sidebar.icons.material":"谷歌材料图标","sidebar.extraElements":"额外的元素","sidebar.extraElements.pricingTable":"定价表","sidebar.extraElements.callouts":"标注","sidebar.extraElements.testimonials":"褒奖","sidebar.extraPages":"额外页面","sidebar.extraPages.aboutUs":"关于我们","sidebar.extraPages.contactUs":"联系我们","sidebar.extraPages.blog":"博客","sidebar.extraPages.faq":"常问问题","sidebar.extraPages.portfolio":"投资组合","sidebar.extraPages.404":"404错误页面","sidebar.extraPages.500":"500错误页面","sidebar.menuLevels":"菜单级别","sidebar.menuLevels.level1":"1级","sidebar.menuLevels.level2":"2级","sidebar.menuLevels.level3":"3级","appModule.forgotPassword":"忘记密码了吗？","appModule.dntRememberEmail":"不记得你的电子邮件？","appModule.contactSupport":"联系支持","appModule.resetPassword":"重设密码","appModule.enterPasswordUnlock":"输入您的密码解锁屏幕！","appModule.unlock":"开锁","appModule.signInDiffAccount":"使用其他帐户登录","appModule.rememberMe":"记住我","appModule.signIn":"签到","appModule.next":"下一个","appModule.back":"背部","appModule.allStepsCompleted":"所有步骤完成","appModule.reset":"重启","appModule.loginSuccessfully":"成功登录","appModule.password":"密码","appModule.email":"电子邮件","appModule.name":"名称","appModule.phone":"电话","appModule.designation":"指定","appModule.regsiter":"寄存器","appModule.hvAccount":"有一个账户","appModule.createAccount":"创建一个帐户","chart.area":"面积图","chart.bar":"条状图","chart.composed":"组合图","chart.line":"线形图","chart.pie":"饼图","chart.radar":"雷达图","chart.radial":"径向图","chart.scatter":"散点图","chart.tree":"树图","chat.selectUserChat":"选择用户开始聊天","chat.selectContactChat":"选择联系人即可开始聊天","chat.chatUser":"聊天","chat.contacts":"往来","chat.searchStartNewChat":"搜索或开始新的聊天","chat.typeMessage":"键入并按回车键发送消息","chat.status":"这是一个地位....不是你的日记...","contact.saveContact":"保存联系人","contact.addContact":"增加联系人","contact.searchContact":"搜索联系人","button.modify":"修改","button.delete":"删除","button.yes":"是","button.no":"没有","eCommerce.readMore":"阅读更多","eCommerce.addToCart":"添加到购物车","eCommerce.buyNow":"立即购买","extension.sweetAlerts":"甜蜜警报","extension.notification":"通知","sweetAlerts.basic":"基本","sweetAlerts.description":"带说明","sweetAlerts.success":"成功","sweetAlerts.warning":"警告","sweetAlerts.custom":"习惯","sweetAlerts.htmlTag":"HTML标记","sweetAlerts.prompt":"提示","sweetAlerts.itsBlue":"它是蓝色的！","sweetAlerts.passwordPrompt":"密码提示","sweetAlerts.customStyle":"自定义样式","sweetAlerts.itPretty":"真漂亮，不是吗？","sweetAlerts.btnClicked":"你点击了按钮！","sweetAlerts.youWillFind":"你会发现他们已经起来了！","sweetAlerts.youWillNotAble":"你将无法恢复这个虚构的文件！","sweetAlerts.hereIsaMessage":"这是一条消息！","sweetAlerts.goodJob":"做得好！","sweetAlerts.yesDeleteIt":"是的，删除它！","sweetAlerts.areYouSure":"你确定？","sweetAlerts.doYouLikeThumb":"你喜欢大拇指吗？","sweetAlerts.anInput":"一个输入！","sweetAlerts.writeSomethingInteresting":"写点有趣的东西：","sweetAlerts.writeSomething":"写一些东西","sweetAlerts.youMustEnterPassword":"你必须输入你的密码！","sweetAlerts.enterPassword":"输入密码","notification.infoMsg":"信息消息","notification.successMessage":"成功消息","notification.warningMessage":"警告信息","notification.closeAfter3000ms":"3000ms后关闭","notification.errorMessage":"错误信息","notification.titleHere":"标题在这里","notification.clickMe":"点击我！","notification.info":"信息","notification.success":"成功","notification.warning":"警告","notification.error":"错误","extraElements.callouts":"标注","extraElements.pricingTable":"定价表","extraElements.testimonials":"褒奖","callouts.viewRange":"查看范围","callouts.basic":"基本","pricingTable.basic":"基本","pricingTable.circle":"圈","pricingTable.classic":"经典","pricingTable.dark":"黑暗","pricingTable.personal":"个人","pricingTable.easyTranslation":"易于翻译","pricingTable.awesomeGoogleFonts":"令人敬畏的Google字体","pricingTable.hotelBookingSystem":"酒店预订系统","pricingTable.emailComposeInterface":"电子邮件撰写界面","pricingTable.locationFinderApp":"位置搜索器应用程序","pricingTable.buyNow":"立即购买","pricingTable.business":"商业","pricingTable.professional":"专业的","testimonials.basic":"基本","testimonials.classic":"经典","testimonials.standard":"标准","extraPages.goHome":"回家","extraPages.ourClients":"我们的客户","extraPages.all":"所有","extraPages.graphicDesign":"平面设计","extraPages.logo":"商标","extraPages.mobileApp":"移动应用","extraPages.web":"卷筒纸","extraPages.404Msg":"糟糕，发生错误。 找不到网页！","extraPages.500Msg":"对不起，服务器出错了","extraPages.aboutUs.showCase":"在这里展示您的服务并提供关于它们的信息","aboutUs.readMore":"阅读更多","extraPages.goSomewhere":"去一个地方","icon.material":"900+正式材料设计图标","mail.mailbox":"邮箱","mail.compose":"撰写","mail.filters":"过滤器","mail.labels":"标签","picker.color.alpha":"阿尔法挑选者","picker.color.hue":"色相选择器","picker.color.circle":"圈选手","picker.color.compact":"紧凑型拾取器","picker.color.block":"块挑选器","picker.color.chrome":"铬挑选器","picker.color.github":"Github捡拾器","picker.color.twitter":"推特挑选者","picker.color.withRedux":"与终极版","picker.color.sketch":"素描选择器","picker.color.material":"材料捡拾器","picker.color.slider":"滑块挑选器","picker.color.basic":"基本拾取器","picker.color.basicToggle":"基本切换","picker.color.custom":"自定义选取器","picker.color.customPointer":"自定义指针","picker.color.photoshop":"Photoshop的选择","picker.color.swatches":"色板拾取器","picker.color.basicPositioning":"基本定位","picker.date.pickers":"拾荒者","picker.date.date":"日期选择器","picker.date.time":"时间选择器","picker.date.week":"周选手","picker.date.dateNTime":"日期和时间选择器","picker.date.customDate":"自定义日期和时间选择器","table.marketingCampaign":"营销活动","table.thisWeek":"本星期","table.recentOrders":"最近的订单","table.dataTable":"数据表","table.basicTable":"基本表","table.application":"应用程序表","todo":"去做","todo.addTask":"添加任务","todo.all":"所有","todo.filters":"过滤器","todo.labels":"标签","dashboard.recentActivities":"近期活动","dashboard.lastActivity":"最后的活动是2天前","dashboard.currentProjects":"当前项目列表","dashboard.toDoItems":"待办事项列表","dashboard.today":"今天","dashboard.marketingCampaign":"营销活动","dashboard.yourDailyFeed":"您的每日饲料","dashboard.googleInsight":"Google洞察分数","dashboard.lastCalculated":"拉斯维加斯计算1个月前","dashboard.refresh":"刷新","dashboard.upgradeToday":"今日更新","dashboard.onlineSignups":"在线注册","dashboard.lastMonthSale":"上个月销售","dashboard.newVisits":"本月新访问","dashboard.totalRevenue":"今年的总收入","dashboard.latestPosts":"最新帖子","dashboard.loremIpsum":"Lorem ipsum是虚拟内容美元坐是...","dashboard.viewAllPosts":"查看所有帖子","dashboard.popularProducts":"热门产品","dashboard.popularProductsTxt":"这是一个长期以来确定的事实，读者会被可读内容分心。","dashboard.allProducts":"所有产品","dashboard.userStatstics":"用户统计","dashboard.orders":"命令","dashboard.thisYearSaleReport":"今年的销售报告","dashboard.post9MonthData":"发布9个月的数据","dashboard.newCustomers":"新客户","dashboard.newThisMonth":"本月32新","dashboard.monthly":"每月一次","dashboard.totalView":"总观点","dashboard.annual":"全年","dashboard.newOrder":"新命令","dashboard.visited":"访问","dashboard.rapidPace":"急速","dashboard.slowPace":"慢节奏","dashboard.newConnections":"新的连接","dashboard.thisWeek":"3本周","dashboard.newFeed":"23个新资讯提供","dashboard.newSubscriber":"新用户","dashboard.newArticles":"新文章","dashboard.newAuthors":"新作者","dashboard.avgDailyTraffic":"平均每日流量","dashboard.popularAuthors":"流行的作者","dashboard.authorsWith":"作者500+平均。 视图","dashboard.popularArticles":"热门文章","dashboard.comments":"注释","component.alert.default":"默认警报","component.alert.highlighted":"突出显示的提醒","component.alert.dismissible":"可接受的警报","component.alert.withIcons":"与图标的警报","component.alert.withDetailedHTML":"警报与详细的HTML","component.appbar.simple":"简单的应用栏","component.appbar.colored":"彩色的应用栏","component.appbar.fullyFeatured":"全功能应用程序栏","component.autocomplete.reactSelect":"反应选择","component.autocomplete.reactAutosuggest":"反应自动建议","component.autocomplete.downshift":"降档","component.avatars.image":"图像头像","component.avatars.letter":"信头像","component.avatars.icon":"图标头像","component.badge.scaling":"缩放徽章","component.badge.insideLinks":"内部链接和按钮","component.badge.contextual":"环境变化","component.badge.pill":"丸徽章","component.badge.link":"链接徽章","component.bottomNavigation.withLabels":"底部导航与标签","component.bottomNavigation.withActiveLabels":"带有活动标签的底部导航","component.bottomNavigation.withNoLabels":"底部导航没有标签","component.breadcrumbs.simple":"简单","component.breadcrumbs.noList":"没有名单","component.buttons.colorScheme":"配色方案","component.buttons.colorSchemeTxt":"带材料概念的Bootstrap配色方案","component.buttons.icon":"图标按钮","component.buttons.iconTxt":"您可以从图标页面下列出的字体图标中选取任何图标。 或者随意添加任何新的字体图标并使用它。","component.buttons.differentSizes":"不同的尺寸","component.buttons.differentSizesTxt":"材质按钮大小不同","component.buttons.flatFullWidth":"平面和全宽度按钮","component.buttons.flatFullWidthTxt":"所有类型的按钮具有禁用状态","component.buttons.raised":"凸起的按钮","component.buttons.raisedTxt":"带材料概念的Bootstrap配色方案","component.buttons.fab":"浮动操作按钮","component.buttons.fabTxt":"带材料概念的Bootstrap配色方案","component.buttons.socialMedia":"社交媒体按钮","component.buttons.socialMediaTxt":"您的项目的各种社交媒体按钮","component.buttons.complex":"复杂的按钮","component.buttonGroup.horizontalVariations":"水平变化","component.buttonGroup.defaultStyle":"默认按钮组风格","component.buttonGroup.highlightedStyle":"突出显示的按钮组样式","component.buttonGroup.flatStyle":"平面按钮组风格","component.buttonGroup.default":"默认按钮组","component.buttonGroup.flat":"平面按钮组","component.buttonGroup.highlighted":"突出显示的按钮组","component.buttonGroup.icon":"图标按钮组","component.buttonGroup.iconFlat":"图标平面按钮组","component.buttonGroup.nested":"嵌套按钮组","component.cards.basic":"基本卡片","component.cards.special":"特殊卡片","component.cards.withHeader":"卡片与页眉，页脚和对齐","component.cards.navigational":"导航卡","component.cards.image":"图像卡","component.cards.solid":"固体卡","component.carousel.basic":"基本传送带","component.carousel.basicTxt":"带反应带的基本BS4旋转木马","component.carousel.product":"产品轮播","component.carousel.productTxt":"一个水平网格视图传送带","component.carousel.testimonial":"见证旋转木马","component.carousel.testimonialTxt":"一次一件物品转盘","component.chips.default":"默认芯片","component.chips.outline":"大纲芯片","component.chips.chipWithText":"与文本具体化的芯片","component.chips.clickable":"可点击芯片","component.chips.withImage":"有图象具体化的芯片","component.chips.deletable":"可删除芯片","component.chips.withIcon":"与象具体化的芯片","component.chips.custom":"自定义可点击芯片","component.chips.array":"芯片阵列","component.chips.withInput":"用输入框实现芯片","component.dividers.list":"列出分隔线","component.dividers.inset":"插入分隔线","component.dividers.default":"默认","component.drawer.persistent":"持久的抽屉","component.drawer.permanent":"永久性抽屉","component.drawer.mini":"迷你抽屉","component.drawer.responsive":"响应式抽屉","component.expansionPanel.simple":"简单的扩展面板","component.expansionPanel.controlled":"受控手风琴","component.expansionPanel.secondary":"次要标题和栏目","component.gridList.image":"仅限图片的网格列表","component.gridList.advanced":"高级网格列表","component.gridList.singleLine":"单行网格列表","component.gridList.withTitlebars":"带标题栏的网格列表","component.lists.folder":"文件夹列表","component.lists.switch":"切换列表控件","component.lists.dividers":"列出分隔线","component.lists.simple":"简单列表","component.lists.inset":"插入列表","component.lists.nested":"嵌套列表","component.lists.checkbox":"复选框二级列表控件","component.lists.checkboxControls":"复选框列表控件","component.lists.pinned":"固定的副标题列表","component.lists.interactive":"交互式列表控件","component.chips":"最近","component.menusPaper.simple":"简单的菜单","component.menusPaper.withIcon":"带有图标的菜单","component.menusPaper.withMoreButton":"带有更多按钮的菜单","component.menusPaper.withSelectedValue":"具有选定值的菜单","component.menusPaper.paper":"纸","component.pickers.Date":"日期选择器","component.progress.indeterminateCircular":"不确定通知","component.progress.determinateCircular":"确定通函","component.progress.indeterminateLinear":"不确定线性","component.progress.determinateLinear":"确定线性","component.progress.bufferLinear":"缓冲线性","component.progress.interactiveIntegration":"交互式集成","component.progress.queryLinear":"查询线性","component.selectionControl.checkboxes":"复选框","component.selectionControl.disabled":"残","component.selectionControl.intermediate":"中间","component.selectionControl.checkboxesWithForm":"与表单组复选框","component.selectionControl.basicRadio":"基本的单选按钮","component.selectionControl.disabledRadio":"禁用的单选按钮","component.selectionControl.withError":"与错误消息","component.selectionControl.switches":"开关","component.selectionControl.verticalSwitches":"垂直开关","component.selectionControl.groupedSwitches":"分组交换机","component.selectionControl.verticalImplementation":"垂直实现交换机","component.selectionControl.generalSettings":"常规设置","component.selectionControl.themeSettings":"主题设置","component.selectionControl.onOffSwitches":"开/关开关","component.selectionControl.verticalInlineRadio":"垂直和内联单选按钮","component.selectionControl.checkboxesWithFormTxt":"菜单位于其发光元件上方，使得当前选择的菜单项出现在发光元件的顶部。","component.selects.simple":"简单的选择","component.selects.native":"本地选择","component.selects.multiple":"多选","component.selects.dialog":"对话框选择","component.snackbars.transition":"过渡控制方向","component.snackbars.simple":"简单","component.snackbars.positioned":"定位","component.snackbars.messageWithButton":"消息与按钮","component.snackbars.colors":"颜色","component.snackbars.multilineText":"多行文本","component.snackbars.onlyMessage":"只有消息","component.snackbars.withIconButton":"消息与IconButton","component.stepper.horizontalLinear":"水平线性","component.stepper.horizontalLinearAlternativeLabel":"水平线性 - 可选标签","component.stepper.vertical":"垂直步进器","component.stepper.horizontalNonLinear":"水平非线性","component.stepper.horizontalNonLinearAlternativeLabel":"水平非线性 - 可选标签","component.stepper.mobileDots":"移动步进 - 点","component.stepper.mobileProgress":"移动步进 - 进步","component.stepper.mobileText":"移动步进器 - 文本","component.tabs.basic":"基本选项卡","component.tabs.fixed":"固定标签全宽","component.tabs.icon":"图标选项卡","component.tabs.disabled":"禁用选项卡","component.tabs.wrappedLabels":"包装的标签","component.tabs.iconWithLabel":"与标签的图标选项卡","component.tabs.fixedCentered":"固定标签居中","component.tabs.automaticScroll":"自动滚动按钮","component.tabs.forcedScroll":"强制滚动按钮","component.tabs.preventScroll":"防止滚动按钮","component.textFields.textfield":"文本域","component.textFields.components":"组件","component.textFields.layout":"布局","component.textFields.inputAdornments":"输入装饰品","component.textFields.formattedInputs":"格式化输入","component.textFields.inputs":"输入","component.tooltips.avatar":"头像工具提示","component.tooltips.button":"按钮工具提示","component.tooltips.icon":"图标工具提示","component.tooltips.controlled":"受控工具提示","component.tooltips.positioned":"定位工具提示","component.typography.lightHeadings":"轻的标题","component.typography.normalHeadings":"正常标题","component.typography.semiBoldHeadings":"半粗体标题","component.typography.boldHeadings":"大胆的标题","component.typography.paragraphText":"段落文本","component.typography.leadParagraphText":"铅段文本","component.typography.unstyledList":"无风格列表","component.typography.orderedList":"有序列表","component.typography.unorderedList":"无序列表","component.typography.listWithIcons":"与图标列表","component.typography.compactList":"紧凑列表","component.typography.extendedList":"扩展列表","component.typography.leftIconGroupedList":"扩展列表","component.typography.rightIconGroupedList":"右图标分组列表","component.typography.badgesGroupedList":"徽章分组列表","component.typography.defaultDescriptionList":"默认描述列表","component.typography.evenOddDescriptionList":"偶数描述列表","component.typography.leftBlockquoteWithAuthorAvatar":"左块引用作者头像","component.typography.rightBlockquoteWithAuthorAvatar":"右屏蔽报价与作者头像","signIn.success":"登录成功！","signIn.error":"无效的电子邮件或密码！","signUp.success":"成功建立帐户","signUp.error":"对","signIn.success1":"对","signIn.signUp":"创建一个帐户","signIn.connectWith":"或连接","signUp.alreadyMember":"我已经是会员了","appModule.signin":"签到","appModule.signup":"注册","pages.samplePage":"示例页面","pages.samplePage.description":"开始构建你的应用。 快乐编码！","mailNotification.title":"消息","appNotification.title":"通知","mailNotification.message":"目前没有新消息！","appNotification.message":"截至目前没有通知！","popup.profile":"轮廓","popup.setting":"设置","popup.logout":"登出","popup.updateData":"更新数据","popup.detailedLog":"详细的日志","popup.statistics":"统计","popup.clearData":"清除数据","component.selectionControl.radioBtnGroup":"单选按钮组","component.popover.anchorPlayground":"锚地游乐场"}

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _ar = __webpack_require__(1336);

var _ar2 = _interopRequireDefault(_ar);

var _ar_SA = __webpack_require__(1337);

var _ar_SA2 = _interopRequireDefault(_ar_SA);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var saLang = {
    messages: _extends({}, _ar_SA2.default),
    locale: 'ar-SA',
    data: _ar2.default
};
var _default = saLang;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(_ar2, '_ar2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(_ar_SA2, '_ar_SA2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/ar_SA.js');
}();

;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 1337 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"الأساسية","sidebar.dashboard":"لوحة القيادة","sidebar.dashboard.default":"افتراضي","sidebar.dashboard.ecommerce":"التجارة الإلكترونية","sidebar.dashboard.news":"أخبار","sidebar.dashboard.intranet":"الشبكة الداخلية","sidebar.components":"المكونات","sidebar.components.alerts":"التنبيهات","sidebar.components.appbar":"بار التطبيق","sidebar.components.autocomplete":"الإكمال التلقائي","sidebar.components.avatars":"الآلهة","sidebar.components.badge":"شارة","sidebar.components.bottomNavigation":"التنقل السفلي","sidebar.components.breadcrumbs":"فتات الخبز","sidebar.components.buttons":"وصفت","sidebar.components.buttonGroup":"زر المجموعة","sidebar.components.cards":"بطاقات","sidebar.components.carousel":"دائري","sidebar.components.chips":"رقائق","sidebar.components.colorPicker":"منتقي الألوان","sidebar.components.dialogs":"الحوارات","sidebar.components.dividers":"فواصل","sidebar.components.expansionPanel":"لوحة التوسع","sidebar.components.drawer":"الدرج","sidebar.components.gridList":"الشبكة قائمة","sidebar.components.lists":"قوائم","sidebar.components.menusPaper":"القوائم والورق","sidebar.components.pickers":"جامعي","sidebar.components.popovers":"بوبوفيرس","sidebar.components.progress":"تقدم","sidebar.components.selects":"يختار","sidebar.components.selectionControl":"ضوابط التحديد","sidebar.components.snackbars":"الوجبات الخفيفة","sidebar.components.stepper":"السائر","sidebar.components.tables":"الجداول","sidebar.components.tabs":"علامات التبويب","sidebar.components.textFields":"حقول النص","sidebar.components.tooltips":"تلميحات","sidebar.components.typography":"طباعة","sidebar.widgets":"الحاجيات","sidebar.metrics":"المقاييس","sidebar.view":"رأي","sidebar.tables":"الجداول","sidebar.tables.basicTable":"الجدول الأساسي","sidebar.tables.dataTable":"جدول البيانات","sidebar.timeLine":"الجدول الزمني","sidebar.timeLine.default":"افتراضي","sidebar.timeLine.defaultwithIcons":"الافتراضي مع الرموز","sidebar.timeLine.leftAligned":"اليسار الانحياز","sidebar.timeLine.zigzag":"متعرج","sidebar.customViews":"طرق عرض مخصصة","sidebar.customViews.plainListView":"عرض قائمة عادي","sidebar.customViews.withDivider":"قائمة بسيطة مع الحاجز","sidebar.customViews.cardListView":"عرض قائمة البطاقات","sidebar.form":"شكل","sidebar.forms":"إستمارات","sidebar.forms.components":"المكونات","sidebar.forms.stepper":"السائر","sidebar.extensions":"ملحقات","sidebar.editors":"المحررين","sidebar.editors.CKEditor":"محرر سك","sidebar.editors.WYSISWYGEditor":"محرر ويسيويغ","sidebar.pickers":"جامعي","sidebar.pickers.dateTimePickers":"التاريخ والوقت المنتقى","sidebar.pickers.colorPickers":"لون بيكرز","sidebar.extensions.dragNDrop":"السحب والإفلات","sidebar.extensions.sweetAlert":"الحلو تنبيه","sidebar.extensions.notification":"إعلام","sidebar.chart":"خريطة","sidebar.chart.line":"خط الرسم البياني","sidebar.chart.bar":"شريط الرسم البياني","sidebar.chart.area":"مخطط المنطقة","sidebar.chart.composed":"مخطط","sidebar.chart.scatter":"مخطط مبعثر","sidebar.chart.pie":"مخطط دائري","sidebar.chart.radial":"مخطط شعاعي","sidebar.chart.radar":"مخطط الرادار","sidebar.chart.tree":"مخطط الشجرة","sidebar.map":"خرائط جوجل","sidebar.map.simple":"خريطة بسيطة","sidebar.map.styled":"خريطة الأنماط","sidebar.map.geoLocation":"الموقع الجغرافي","sidebar.map.mapDirection":"اتجاه الخريطة","sidebar.map.overlay":"تراكب الخريطة","sidebar.map.kmLayer":"خريطة كم طبقة","sidebar.map.popupInfo":"خريطة معلومات بوبوب","sidebar.map.trafficLayer":"خريطة طبقة حركة المرور","sidebar.map.streetView":"منظر الشارع","sidebar.map.eventListener":"الحدث المستمع","sidebar.map.mapDrawing":"رسم الخريطة","sidebar.map.mapClustering":"خريطة التجمع","sidebar.modules":"وحدات","sidebar.calendar":"التقويم","sidebar.calendar.basic":"الأساسية","sidebar.calendar.cultures":"الثقافات","sidebar.calendar.dnd":"DND","sidebar.calendar.popup":"يظهر فجأة","sidebar.calendar.rendering":"استدعاء","sidebar.calendar.selectable":"اختيار","sidebar.calendar.timeslots":"فتحات الوقت","sidebar.eCommerce":"التجارة الإلكترونية","sidebar.eCommerce.productsList":"قائمة المنتجات","sidebar.eCommerce.productsGrid":"المنتجات الشبكة","sidebar.appModule":"وحدة التطبيق","sidebar.appModule.login1":"تسجيل الدخول الصفحة 1","sidebar.appModule.login2":"تسجيل الدخول الصفحة 2","sidebar.appModule.loginStepper":"تسجيل الدخول مع السائر","sidebar.appModule.signup1":"الاشتراك الصفحة 1","sidebar.appModule.signup2":"الاشتراك الصفحة 2","sidebar.appModule.forgotPassword1":"نسيت كلمة المرور 1","sidebar.appModule.forgotPassword2":"نسيت كلمة المرور 2","sidebar.appModule.lock1":"قفل الشاشة 1","sidebar.appModule.lock2":"قفل الشاشة 2","sidebar.appModule.toDo":"لكى يفعل","sidebar.appModule.toDoRedux":"لكى يفعل...","sidebar.appModule.mail":"بريد","sidebar.appModule.mailRedux":"البريد ريدوكس","sidebar.appModule.chat":"دردشة","sidebar.appModule.chatRedux":"الدردشة","sidebar.appModule.contact":"اتصل","sidebar.appModule.contactRedux":"الاتصال ريدوكس","sidebar.extras":"إضافات","sidebar.icons":"الرموز","sidebar.icons.material":"رموز غوغل ماتريال","sidebar.extraElements":"عناصر إضافية","sidebar.extraElements.pricingTable":"جدول التسعير","sidebar.extraElements.callouts":"الشرح","sidebar.extraElements.testimonials":"الشهادات - التوصيات","sidebar.extraPages":"صفحات إضافية","sidebar.extraPages.aboutUs":"معلومات عنا","sidebar.extraPages.contactUs":"اتصل بنا","sidebar.extraPages.blog":"مدونة","sidebar.extraPages.faq":"التعليمات","sidebar.extraPages.portfolio":"محفظة","sidebar.extraPages.404":"404 صفحة خطأ","sidebar.extraPages.500":"500 صفحة خطأ","sidebar.menuLevels":"مستويات القائمة","sidebar.menuLevels.level1":"المستوى 1","sidebar.menuLevels.level2":"المستوي 2","sidebar.menuLevels.level3":"مستوى 3","appModule.forgotPassword":"نسيت رقمك السري؟","appModule.dntRememberEmail":"ألا تتذكر بريدك الإلكتروني؟","appModule.contactSupport":"اتصل بالدعم","appModule.resetPassword":"إعادة تعيين كلمة المرور","appModule.enterPasswordUnlock":"أدخل كلمة المرور لفتح الشاشة!","appModule.unlock":"فتح","appModule.signInDiffAccount":"سجل الدخول باستخدام حساب مختلف","appModule.rememberMe":"تذكرنى","appModule.signIn":"تسجيل الدخول","appModule.next":"التالى","appModule.back":"الى الخلف","appModule.allStepsCompleted":"جميع الخطوات المكتملة","appModule.reset":"إعادة تعيين","appModule.loginSuccessfully":"تسجيل الدخول بنجاح","appModule.password":"كلمه السر","appModule.email":"البريد الإلكتروني","appModule.name":"اسم","appModule.phone":"هاتف","appModule.designation":"تعيين","appModule.regsiter":"تسجيل","appModule.hvAccount":"لديك حساب","appModule.createAccount":"انشئ حساب","chart.area":"منطقة الرسم البياني","chart.bar":"شريط الرسم البياني","chart.composed":"الرسم البياني","chart.line":"الرسم البياني...","chart.pie":"رسم بياني","chart.radar":"رادار الرسم البياني","chart.radial":"شعاعي الرسم البياني","chart.scatter":"الرسم البياني مبعثر","chart.tree":"الرسم البياني للشجرة","chat.selectUserChat":"حدد المستخدم لبدء الدردشة","chat.selectContactChat":"حدد جهة الاتصال لبدء الدردشة","chat.chatUser":"الدردشة","chat.contacts":"جهات الاتصال","chat.searchStartNewChat":"بحث أو بدء دردشة جديدة","chat.typeMessage":"اكتب واضغط على إنتر لإرسال الرسالة","chat.status":"انها حالة .... لا اليوميات الخاصة بك ...","contact.saveContact":"حفظ جهة الاتصال","contact.addContact":"إضافة جهة اتصال","contact.searchContact":"بحث الاتصال","button.modify":"تعديل","button.delete":"حذف","button.yes":"نعم فعلا","button.no":"لا","eCommerce.readMore":"اقرأ أكثر","eCommerce.addToCart":"أضف إلى السلة","eCommerce.buyNow":"اشتري الآن","extension.sweetAlerts":"تنبيهات حلوة","extension.notification":"إعلام","sweetAlerts.basic":"الأساسية","sweetAlerts.description":"مع الوصف","sweetAlerts.success":"نجاح","sweetAlerts.warning":"تحذير","sweetAlerts.custom":"العادة","sweetAlerts.htmlTag":"علامة هتمل","sweetAlerts.prompt":"مستعجل","sweetAlerts.itsBlue":"إنه أزرق!","sweetAlerts.passwordPrompt":"كلمة السر موجه","sweetAlerts.customStyle":"نمط مخصص","sweetAlerts.itPretty":"انها جميلة، أليس كذلك؟","sweetAlerts.btnClicked":"النقر على زر!","sweetAlerts.youWillFind":"سوف تجد أنها حتى!","sweetAlerts.youWillNotAble":"لن تكون قادرا على استرداد هذا الملف الخيالي!","sweetAlerts.hereIsaMessage":"إليك رسالة!","sweetAlerts.goodJob":"عمل جيد!","sweetAlerts.yesDeleteIt":"نعم، حذفه!","sweetAlerts.areYouSure":"نعم، حذفه!...","sweetAlerts.doYouLikeThumb":"هل تحب الابهام؟","sweetAlerts.anInput":"مدخلات!","sweetAlerts.writeSomethingInteresting":"كتابة شيء مثير للاهتمام:","sweetAlerts.writeSomething":"أكتب شيئا","sweetAlerts.youMustEnterPassword":"يجب إدخال كلمة المرور الخاصة بك!","sweetAlerts.enterPassword":"أدخل كلمة المرور","notification.infoMsg":"معلومات الرسالة","notification.successMessage":"نجاح رسالة","notification.warningMessage":"رسالة تحذير","notification.closeAfter3000ms":"إغلاق بعد 3000ms","notification.errorMessage":"رسالة خطأ","notification.titleHere":"العنوان هنا","notification.clickMe":"انقر فوق لي!","notification.info":"معلومات","notification.success":"نجاح","notification.warning":"تحذير","notification.error":"خطأ","extraElements.callouts":"الشرح","extraElements.pricingTable":"جدول التسعير","extraElements.testimonials":"الشهادات - التوصيات","callouts.viewRange":"عرض النطاق","callouts.basic":"الأساسية","pricingTable.basic":"الأساسية","pricingTable.circle":"دائرة","pricingTable.classic":"كلاسيكي","pricingTable.dark":"داكن","pricingTable.personal":"الشخصية","pricingTable.easyTranslation":"ترجمة سهلة","pricingTable.awesomeGoogleFonts":"خطوط غوغل رهيبة","pricingTable.hotelBookingSystem":"نظام حجز الفنادق","pricingTable.emailComposeInterface":"البريد الإلكتروني إنشاء واجهة","pricingTable.locationFinderApp":"الموقع الباحث التطبيق","pricingTable.buyNow":"اشتري الآن","pricingTable.business":"اعمال","pricingTable.professional":"المحترفين","testimonials.basic":"الأساسية","testimonials.classic":"كلاسيكي","testimonials.standard":"اساسي","extraPages.goHome":"اساسي...","extraPages.ourClients":"عملائنا","extraPages.all":"الكل","extraPages.graphicDesign":"التصميم الجرافيكي","extraPages.logo":"شعار","extraPages.mobileApp":"شعار...","extraPages.web":"شبكة","extraPages.404Msg":"عفوا، حدث خطأ. الصفحة غير موجودة!","extraPages.500Msg":"عذرا، هناك خطأ في الخادم","extraPages.aboutUs.showCase":"اعرض خدماتك هنا مع معلومات عنها","aboutUs.readMore":"اقرأ أكثر","extraPages.goSomewhere":"اذهب لمكان ما","icon.material":"900+ الرسمية أيقونات تصميم المواد","mail.mailbox":"صندوق بريد","mail.compose":"مؤلف موسيقى","mail.filters":"مرشحات","mail.labels":"تسميات","picker.color.alpha":"ألفا بيكرز","picker.color.hue":"هيو بيكرز","picker.color.circle":"دائرة المنتقى","picker.color.compact":"كومباكت بيكرز","picker.color.block":"بلوك بيكرز","picker.color.chrome":"كروم بيكرز","picker.color.github":"جيثب بيكرز","picker.color.twitter":"تويتر المنتقى","picker.color.withRedux":"مع ريدوكس","picker.color.sketch":"رسم بيكرز","picker.color.material":"المواد المنتقى","picker.color.slider":"المتزلجون المنتقى","picker.color.basic":"المنتقى الأساسيون","picker.color.basicToggle":"تبديل أساسي","picker.color.custom":"مخصصون","picker.color.customPointer":"مؤشر مخصص","picker.color.photoshop":"فوتوشوب بيكرز","picker.color.swatches":"سواتشس بيكرز","picker.color.basicPositioning":"تحديد المواقع الأساسية","picker.date.pickers":"جامعي","picker.date.date":"تاريخ المنتقى","picker.date.time":"الوقت المنتقى","picker.date.week":"الأسبوع المنتقى","picker.date.dateNTime":"التاريخ والوقت المنتقى","picker.date.customDate":"مخصص التاريخ والوقت المنتقى","table.marketingCampaign":"حملة تسويق","table.thisWeek":"هذا الاسبوع","table.recentOrders":"الطلبيات الأخيرة","table.dataTable":"جدول البيانات","table.basicTable":"الجدول الأساسي","table.application":"جدول التطبيق","todo":"لكى يفعل","todo.addTask":"إضافة مهمة","todo.all":"الكل","todo.filters":"مرشحات","todo.labels":"تسميات","dashboard.recentActivities":"أنشطة حالية","dashboard.lastActivity":"آخر نشاط كان قبل يومين","dashboard.currentProjects":"قائمة المشاريع الحالية","dashboard.toDoItems":"تأليف لائحة البنود","dashboard.today":"اليوم","dashboard.marketingCampaign":"حملة تسويق","dashboard.yourDailyFeed":"الخلاصة اليومية","dashboard.googleInsight":"النتيجة البصيرة جوجل","dashboard.lastCalculated":"لاس كالكولاتد 1 مونث أغو","dashboard.refresh":"تحديث","dashboard.upgradeToday":"ترقية اليوم","dashboard.onlineSignups":"الاشتراك عبر الإنترنت","dashboard.lastMonthSale":"الشهر الماضي بيع","dashboard.newVisits":"الزيارات الجديدة هذا الشهر","dashboard.totalRevenue":"إجمالي الإيرادات هذا العام","dashboard.latestPosts":"آخر المشاركات","dashboard.loremIpsum":"أبجد هوز هو محتوى دمية الدولار الجلوس ...","dashboard.viewAllPosts":"عرض جميع المشاركات","dashboard.popularProducts":"المنتجات الشعبية","dashboard.popularProductsTxt":"ومن الحقائق الثابتة منذ فترة طويلة أن القارئ سوف يصرف من قبل محتوى قابل للقراءة ..","dashboard.allProducts":"جميع المنتجات","dashboard.userStatstics":"إحصائيات المستخدم","dashboard.orders":"أوامر","dashboard.thisYearSaleReport":"تقرير بيع هذا العام","dashboard.post9MonthData":"نشر بيانات 9 أشهر","dashboard.newCustomers":"زبائن الجدد","dashboard.newThisMonth":"32 جديد هذا الشهر","dashboard.monthly":"شهريا","dashboard.totalView":"إجمالي العرض","dashboard.annual":"سنوي","dashboard.newOrder":"أمر جديد","dashboard.visited":"زار","dashboard.rapidPace":"ايقاع متسارع","dashboard.slowPace":"بطء","dashboard.newConnections":"اتصالات جديدة","dashboard.thisWeek":"3 هذا الأسبوع","dashboard.newFeed":"23 خلاصات جديدة","dashboard.newSubscriber":"مشترك جديد","dashboard.newArticles":"مقالات جديدة","dashboard.newAuthors":"المؤلفون الجدد","dashboard.avgDailyTraffic":"متوسط عدد الزيارات اليومية","dashboard.popularAuthors":"مؤلفون شعبيون","dashboard.authorsWith":"المؤلفون مع 500+ أفغ. رأي","dashboard.popularArticles":"المواد شعبية","dashboard.comments":"تعليقات","component.alert.default":"التنبيهات الافتراضية","component.alert.highlighted":"أبرز التنبيهات","component.alert.dismissible":"التنبيهات القابلة للتصفية","component.alert.withIcons":"التنبيهات مع الرموز","component.alert.withDetailedHTML":"تنبيه مع هتمل مفصل","component.appbar.simple":"بسيطة التطبيق بار","component.appbar.colored":"الملونة التطبيق بار","component.appbar.fullyFeatured":"بار متميز تماما التطبيقات","component.autocomplete.reactSelect":"رد حدد","component.autocomplete.reactAutosuggest":"رد أوتوسوجست","component.autocomplete.downshift":"بالاستعداد","component.avatars.image":"الصورة الرمزية","component.avatars.letter":"رسالة الرمزية","component.avatars.icon":"الرمز الرمزية","component.badge.scaling":"شارات التحجيم","component.badge.insideLinks":"داخل الروابط والأزرار","component.badge.contextual":"الاختلافات السياقية","component.badge.pill":"حبوب منع الحمل، الشارات","component.badge.link":"شارات الارتباط","component.bottomNavigation.withLabels":"التنقل في الأسفل مع التصنيفات","component.bottomNavigation.withActiveLabels":"التنقل السفلي مع التسمية النشطة","component.bottomNavigation.withNoLabels":"التنقل السفلي بدون تسمية","component.breadcrumbs.simple":"بسيط","component.breadcrumbs.noList":"ليست هناك قائمة","component.buttons.colorScheme":"نظام الألوان","component.buttons.colorSchemeTxt":"بوتستراب، لون، برنامج، ب، مادة، كونسيبت","component.buttons.icon":"أزرار الرمز","component.buttons.iconTxt":"يمكنك اختيار أي رمز من الرموز الخط المدرجة تحت صفحة الأيقونات. أو لا تتردد في إضافة أي رموز الخط الجديد واستخدام ذلك.","component.buttons.differentSizes":"مقاسات مختلفة","component.buttons.differentSizesTxt":"أزرار المواد مع أحجام مختلفة","component.buttons.flatFullWidth":"أزرار مسطحة و كاملة العرض","component.buttons.flatFullWidthTxt":"جميع أزرار نوع مع حالات تعطيل","component.buttons.raised":"أزرار أثارت","component.buttons.raisedTxt":"بوتستراب، لون، برنامج، ب، مادة، كونسيبت","component.buttons.fab":"أزرار العمل العائمة","component.buttons.fabTxt":"بوتستراب، لون، برنامج، ب، مادة، كونسيبت","component.buttons.socialMedia":"أزرار وسائل الإعلام الاجتماعية","component.buttons.socialMediaTxt":"مختلف أزرار وسائل الاعلام الاجتماعية لمشروعك","component.buttons.complex":"أزرار معقدة","component.buttonGroup.horizontalVariations":"الاختلافات الأفقية","component.buttonGroup.defaultStyle":"نمط مجموعة الأزرار الافتراضية","component.buttonGroup.highlightedStyle":"نمط مجموعة الزر المميز","component.buttonGroup.flatStyle":"شقة زر مجموعة نمط","component.buttonGroup.default":"مجموعة زر افتراضي","component.buttonGroup.flat":"شقة زر المجموعة","component.buttonGroup.highlighted":"أبرز مجموعة زر","component.buttonGroup.icon":"أيقونة زر المجموعة","component.buttonGroup.iconFlat":"أيقونة زر شقة المجموعة","component.buttonGroup.nested":"مجموعة زر متداخلة","component.cards.basic":"البطاقات الأساسية","component.cards.special":"بطاقات خاصة","component.cards.withHeader":"بطاقات مع رأس، تذييل و محاذاة","component.cards.navigational":"البطاقات الملاحية","component.cards.image":"بطاقات الصورة","component.cards.solid":"بطاقات صلبة","component.carousel.basic":"دائري الأساسي","component.carousel.basicTxt":"الأساسية BS4 دائري بدعم مع رياكتستراب","component.carousel.product":"المنتج دائري","component.carousel.productTxt":"الأفقي عرض الشبكة كاروسيل","component.carousel.testimonial":"شهادة دائري","component.carousel.testimonialTxt":"عنصر واحد دائري في وقت واحد","component.chips.default":"رقاقة افتراضية","component.chips.outline":"الخطوط العريضة رقاقة","component.chips.chipWithText":"رقاقة مع النص الرمزية","component.chips.clickable":"شريحة قابلة للنقر","component.chips.withImage":"رقاقة مع الصورة الرمزية","component.chips.deletable":"رقاقة قابلة للتحرير","component.chips.withIcon":"رقاقة مع رمز الرمزية","component.chips.custom":"العرف رقاقة قابلة للنقر","component.chips.array":"رقاقة صفيف","component.chips.withInput":"تنفيذ رقائق مع مربع الإدخال","component.dividers.list":"قائمة الفواصل","component.dividers.inset":"فواصل مقسمة","component.dividers.default":"افتراضي","component.drawer.persistent":"درج ثابت","component.drawer.permanent":"درج دائم","component.drawer.mini":"درج صغير","component.drawer.responsive":"درج الاستجابة","component.expansionPanel.simple":"لوحة توسع بسيطة","component.expansionPanel.controlled":"الأكورديون الخاضعة للرقابة","component.expansionPanel.secondary":"العنوان الثانوي والأعمدة","component.gridList.image":"إيماج-أونلي غريد ليست","component.gridList.advanced":"قائمة الشبكة المتقدمة","component.gridList.singleLine":"قائمة شبكة خط واحد","component.gridList.withTitlebars":"قائمة الشبكة مع تيتلبارس","component.lists.folder":"قائمة المجلدات","component.lists.switch":"تبديل عناصر التحكم في القائمة","component.lists.dividers":"قائمة الفواصل","component.lists.simple":"قائمة بسيطة","component.lists.inset":"قائمة إدراج","component.lists.nested":"قائمة متداخلة","component.lists.checkbox":"مربع الاختيار عناصر تحكم القائمة الثانوية","component.lists.checkboxControls":"ضوابط قائمة الاختيار","component.lists.pinned":"بيند سوبهيدر ليست","component.lists.interactive":"عناصر التحكم في القائمة التفاعلية","component.chips":"الأخيرة","component.menusPaper.simple":"القوائم بسيطة","component.menusPaper.withIcon":"القائمة مع أيقونة","component.menusPaper.withMoreButton":"القائمة مع المزيد من زر","component.menusPaper.withSelectedValue":"القائمة مع القيمة المحددة","component.menusPaper.paper":"ورقة","component.pickers.Date":"منتقي التاريخ","component.progress.indeterminateCircular":"تعميم غير محدد","component.progress.determinateCircular":"تحديد التعميم","component.progress.indeterminateLinear":"غير محدد الخطية","component.progress.determinateLinear":"تحديد الخطي","component.progress.bufferLinear":"المخزن المؤقت الخطي","component.progress.interactiveIntegration":"التكامل التفاعلي","component.progress.queryLinear":"الاستعلام الخطي","component.selectionControl.checkboxes":"مربعات","component.selectionControl.disabled":"معاق","component.selectionControl.intermediate":"متوسط","component.selectionControl.checkboxesWithForm":"مربعات الاختيار مع مجموعة النموذج","component.selectionControl.basicRadio":"أزرار الراديو الأساسية","component.selectionControl.disabledRadio":"أزرار راديو معطل","component.selectionControl.withError":"مع رسالة خطأ","component.selectionControl.switches":"مفاتيح","component.selectionControl.verticalSwitches":"مفاتيح عمودية","component.selectionControl.groupedSwitches":"مفاتيح مجمعة","component.selectionControl.verticalImplementation":"تنفيذ عمودي من مفاتيح","component.selectionControl.generalSettings":"الاعدادات العامة","component.selectionControl.themeSettings":"إعدادات الموضوع","component.selectionControl.onOffSwitches":"تشغيل / إيقاف مفاتيح","component.selectionControl.verticalInlineRadio":"أزرار الراديو العمودية والمضمنة","component.selectionControl.checkboxesWithFormTxt":"يتم وضع القوائم على العناصر التي تنبعث منها بحيث يظهر عنصر القائمة المحدد حاليا أعلى العنصر الذي ينبعث منه.","component.selects.simple":"بسيطة حدد","component.selects.native":"ناتف سيليكت","component.selects.multiple":"تحديد متعددة","component.selects.dialog":"حدد الحوار","component.snackbars.transition":"اتجاه التحكم في الانتقال","component.snackbars.simple":"بسيط","component.snackbars.positioned":"وضع","component.snackbars.messageWithButton":"رسالة مع زر","component.snackbars.colors":"الألوان","component.snackbars.multilineText":"نص متعدد الطبقات","component.snackbars.onlyMessage":"الرسالة فقط","component.snackbars.withIconButton":"رسالة مع إكونبوتون","component.stepper.horizontalLinear":"أفقي الخطي","component.stepper.horizontalLinearAlternativeLabel":"أفقي خطي - تسمية بديلة","component.stepper.vertical":"السائر العمودي","component.stepper.horizontalNonLinear":"أفقي غير خطي","component.stepper.horizontalNonLinearAlternativeLabel":"أفقي غير خطي - تسمية بديلة","component.stepper.mobileDots":"السائر المحمول - النقاط","component.stepper.mobileProgress":"السائر المحمول - التقدم","component.stepper.mobileText":"السائر المحمول - النص","component.tabs.basic":"علامات التبويب الأساسية","component.tabs.fixed":"علامات التبويب الثابتة العرض الكامل","component.tabs.icon":"أيقونة علامات التبويب","component.tabs.disabled":"تم تعطيل علامة التبويب","component.tabs.wrappedLabels":"ملفوفة","component.tabs.iconWithLabel":"أيقونة علامات التبويب مع التسمية","component.tabs.fixedCentered":"علامات التبويب الثابتة المتمركزة","component.tabs.automaticScroll":"أزرار التمرير التلقائي","component.tabs.forcedScroll":"أزرار التمرير القسري","component.tabs.preventScroll":"منع أزرار التمرير","component.textFields.textfield":"حقل النص","component.textFields.components":"المكونات","component.textFields.layout":"نسق","component.textFields.inputAdornments":"إدخال الزينة","component.textFields.formattedInputs":"المدخلات المنسقة","component.textFields.inputs":"المدخلات","component.tooltips.avatar":"الصورة الرمزية تولتيب","component.tooltips.button":"بوتون تولتيب","component.tooltips.icon":"إيكون تولتيب","component.tooltips.controlled":"تلميح أدوات التحكم","component.tooltips.positioned":"تلميح محدد الموضع","component.typography.lightHeadings":"العناوين الخفيفة","component.typography.normalHeadings":"العناوين العادية","component.typography.semiBoldHeadings":"عناوين شبه جريئة","component.typography.boldHeadings":"عناوين غامقة","component.typography.paragraphText":"نص الفقرة","component.typography.leadParagraphText":"نص فقرة الرصاص","component.typography.unstyledList":"قائمة غير مستغلة","component.typography.orderedList":"قائمة المطلوبة","component.typography.unorderedList":"قائمة غير مرتبة","component.typography.listWithIcons":"قائمة بأيقونات","component.typography.compactList":"قائمة مدمجة","component.typography.extendedList":"القائمة الموسعة","component.typography.leftIconGroupedList":"اليسار رمز قائمة مجمعة","component.typography.rightIconGroupedList":"الحق قائمة رمز مجمعة","component.typography.badgesGroupedList":"شارات قائمة مجمعة","component.typography.defaultDescriptionList":"قائمة الوصف الافتراضي","component.typography.evenOddDescriptionList":"حتى الغريب قائمة الوصف","component.typography.leftBlockquoteWithAuthorAvatar":"اليسار اقتباس اقتباس مع الكاتب الصورة الرمزية","component.typography.rightBlockquoteWithAuthorAvatar":"الحق اقتباس مع الكاتب الصورة الرمزية","signIn.success":"تسجيل الدخول بنجاح!","signIn.error":"البريد الإلكتروني أو كلمة السر خاطئة!","signUp.success":"تم إنشاء الحساب بنجاح","signUp.error":"حق","signIn.success1":"حق","signIn.signUp":"انشئ حساب","signIn.connectWith":"أو التواصل مع","signUp.alreadyMember":"أنا عضو بالفعل","appModule.signin":"تسجيل الدخول","appModule.signup":"سجل","pages.samplePage":"نموذج الصفحة","pages.samplePage.description":"ابدأ في إنشاء تطبيقك. سعيد الترميز!","mailNotification.title":"رسائل","appNotification.title":"إخطارات","mailNotification.message":"لا رسائل جديدة حتى الآن!","appNotification.message":"لا الإخطارات حتى الآن!","popup.profile":"الملف الشخصي","popup.setting":"ضبط","popup.logout":"الخروج","popup.updateData":"تحديث البيانات","popup.detailedLog":"سجل مفصل","popup.statistics":"الإحصاء","popup.clearData":"امسح البيانات","component.selectionControl.radioBtnGroup":"مجموعة أزرار الراديو","component.popover.anchorPlayground":"ملعب انكور"}

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _it = __webpack_require__(1339);

var _it2 = _interopRequireDefault(_it);

var _it_IT = __webpack_require__(1340);

var _it_IT2 = _interopRequireDefault(_it_IT);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var saLang = {
    messages: _extends({}, _it_IT2.default),
    locale: 'it-IT',
    data: _it2.default
};
var _default = saLang;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(_it2, '_it2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(_it_IT2, '_it_IT2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/it_IT.js');
}();

;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 1340 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"Principale","sidebar.dashboard":"Cruscotto","sidebar.dashboard.default":"Predefinito","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"notizia","sidebar.dashboard.intranet":"Intranet","sidebar.components":"componenti","sidebar.components.alerts":"avvisi","sidebar.components.appbar":"App Bar","sidebar.components.autocomplete":"Completamento automatico","sidebar.components.avatars":"avatars","sidebar.components.badge":"Distintivo","sidebar.components.bottomNavigation":"Navigazione inferiore","sidebar.components.breadcrumbs":"Briciole di pane","sidebar.components.buttons":"pulsanti","sidebar.components.buttonGroup":"Gruppo di pulsanti","sidebar.components.cards":"Carte","sidebar.components.carousel":"Giostra","sidebar.components.chips":"Patatine fritte","sidebar.components.colorPicker":"Color Picker","sidebar.components.dialogs":"Finestre di dialogo","sidebar.components.dividers":"divisori","sidebar.components.expansionPanel":"Pannello di espansione","sidebar.components.drawer":"Cassetto","sidebar.components.gridList":"Grid List","sidebar.components.lists":"elenchi","sidebar.components.menusPaper":"Menu e carta","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"popovers","sidebar.components.progress":"Progresso","sidebar.components.selects":"Seleziona","sidebar.components.selectionControl":"Controlli di selezione","sidebar.components.snackbars":"snackbars","sidebar.components.stepper":"stepper","sidebar.components.tables":"tabelle","sidebar.components.tabs":"Tabs","sidebar.components.textFields":"Campi di testo","sidebar.components.tooltips":"Tooltips","sidebar.components.typography":"Tipografia","sidebar.widgets":"widget","sidebar.metrics":"Metrica","sidebar.view":"vista","sidebar.tables":"tabelle","sidebar.tables.basicTable":"Tabella di base","sidebar.tables.dataTable":"Tabella dati","sidebar.timeLine":"Sequenza temporale","sidebar.timeLine.default":"Predefinito","sidebar.timeLine.defaultwithIcons":"Predefinito con icone","sidebar.timeLine.leftAligned":"Sinistra allineata","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Visualizzazioni personalizzate","sidebar.customViews.plainListView":"Lista semplice","sidebar.customViews.withDivider":"Lista semplice con divisore","sidebar.customViews.cardListView":"Visualizzazione elenco schede","sidebar.form":"Modulo","sidebar.forms":"Forme","sidebar.forms.components":"componenti","sidebar.forms.stepper":"stepper","sidebar.extensions":"estensioni","sidebar.editors":"Editors","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"WYSIWYG Editor","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Raccoglitori di data e ora","sidebar.pickers.colorPickers":"Raccoglitori di colori","sidebar.extensions.dragNDrop":"Trascinare e rilasciare","sidebar.extensions.sweetAlert":"Dolce avviso","sidebar.extensions.notification":"Notifica","sidebar.chart":"Grafico","sidebar.chart.line":"Grafico a linee","sidebar.chart.bar":"Grafico a barre","sidebar.chart.area":"Area grafico","sidebar.chart.composed":"Grafico composto","sidebar.chart.scatter":"Grafico a dispersione","sidebar.chart.pie":"Grafico a torta","sidebar.chart.radial":"Grafico radiale","sidebar.chart.radar":"Grafico radar","sidebar.chart.tree":"Grafico ad albero","sidebar.map":"Google Map","sidebar.map.simple":"Mappa semplice","sidebar.map.styled":"Mappa in stile","sidebar.map.geoLocation":"Posizione geografica","sidebar.map.mapDirection":"Direzione della mappa","sidebar.map.overlay":"Sovrapposizione mappa","sidebar.map.kmLayer":"Mappa Km Layer","sidebar.map.popupInfo":"Mappa Informazioni popup","sidebar.map.trafficLayer":"Mappa dello strato di traffico","sidebar.map.streetView":"vista stradale","sidebar.map.eventListener":"Listener di eventi","sidebar.map.mapDrawing":"Disegno della mappa","sidebar.map.mapClustering":"Raggruppamento di mappe","sidebar.modules":"moduli","sidebar.calendar":"Calendario","sidebar.calendar.basic":"Di base","sidebar.calendar.cultures":"culture","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Apparire","sidebar.calendar.rendering":"Rendering","sidebar.calendar.selectable":"selezionabile","sidebar.calendar.timeslots":"Fasce orarie","sidebar.eCommerce":"eCommerce","sidebar.eCommerce.productsList":"Elenco prodotti","sidebar.eCommerce.productsGrid":"Griglia di prodotti","sidebar.appModule":"Modulo dell'app","sidebar.appModule.login1":"Pagina di accesso 1","sidebar.appModule.login2":"Pagina di accesso 2","sidebar.appModule.loginStepper":"Accedi con Stepper","sidebar.appModule.signup1":"Pagina di iscrizione 1","sidebar.appModule.signup2":"Iscriviti Pagina 2","sidebar.appModule.forgotPassword1":"Password dimenticata 1","sidebar.appModule.forgotPassword2":"Password dimenticata 2","sidebar.appModule.lock1":"Blocca schermo 1","sidebar.appModule.lock2":"Blocca schermo 2","sidebar.appModule.toDo":"Fare","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"posta","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Chiacchierare","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contatto","sidebar.appModule.contactRedux":"Contatta Redux","sidebar.extras":"extra","sidebar.icons":"Icone","sidebar.icons.material":"Google Material Icons","sidebar.extraElements":"Elementi extra","sidebar.extraElements.pricingTable":"Tabella dei prezzi","sidebar.extraElements.callouts":"didascalie","sidebar.extraElements.testimonials":"Testimonianze","sidebar.extraPages":"Pagine extra","sidebar.extraPages.aboutUs":"Riguardo a noi","sidebar.extraPages.contactUs":"Contattaci","sidebar.extraPages.blog":"blog","sidebar.extraPages.faq":"FAQ","sidebar.extraPages.portfolio":"Portafoglio","sidebar.extraPages.404":"404 Pagina di errore","sidebar.extraPages.500":"500 Pagina di errore","sidebar.menuLevels":"Livelli di menu","sidebar.menuLevels.level1":"Livello 1","sidebar.menuLevels.level2":"Livello 2","sidebar.menuLevels.level3":"Livello 3","appModule.forgotPassword":"Hai dimenticato la password?","appModule.dntRememberEmail":"Non ricordi la tua email?","appModule.contactSupport":"Contatta il supporto","appModule.resetPassword":"Resetta la password","appModule.enterPasswordUnlock":"Inserisci la tua password per sbloccare lo schermo!","appModule.unlock":"Sbloccare","appModule.signInDiffAccount":"Accedi utilizzando un account diverso","appModule.rememberMe":"Ricordati di me","appModule.signIn":"Registrati","appModule.next":"Il prossimo","appModule.back":"Indietro","appModule.allStepsCompleted":"Tutti i passaggi completati","appModule.reset":"Reset","appModule.loginSuccessfully":"Accedi con successo","appModule.password":"Parola d'ordine","appModule.email":"E-mail","appModule.name":"Nome","appModule.phone":"Telefono","appModule.designation":"Designazione","appModule.regsiter":"Registrare","appModule.hvAccount":"Avere un conto","appModule.createAccount":"Crea un account","chart.area":"Area Graph","chart.bar":"Istogramma","chart.composed":"Grafico composto","chart.line":"Grafico a linee","chart.pie":"Grafico a torta","chart.radar":"Grafico radar","chart.radial":"Grafico radiale","chart.scatter":"Grafico di dispersione","chart.tree":"Grafico ad albero","chat.selectUserChat":"Seleziona Utente per avviare la chat","chat.selectContactChat":"Seleziona contatto per avviare la chat","chat.chatUser":"Chat","chat.contacts":"Contatti","chat.searchStartNewChat":"Cerca o inizia nuova chat","chat.typeMessage":"Scrivi e premi invio per inviare un messaggio","chat.status":"è uno status .... non è il tuo diario ...","contact.saveContact":"Salva contatto","contact.addContact":"Aggiungi contatto","contact.searchContact":"Cerca contatto","button.modify":"Modificare","button.delete":"Elimina","button.yes":"sì","button.no":"No","eCommerce.readMore":"Leggi di più","eCommerce.addToCart":"Aggiungi al carrello","eCommerce.buyNow":"Acquista ora","extension.sweetAlerts":"Avvisi dolci","extension.notification":"Notifica","sweetAlerts.basic":"Di base","sweetAlerts.description":"Con descrizione","sweetAlerts.success":"Successo","sweetAlerts.warning":"avvertimento","sweetAlerts.custom":"costume","sweetAlerts.htmlTag":"Tag HTML","sweetAlerts.prompt":"Richiesta","sweetAlerts.itsBlue":"È blu!","sweetAlerts.passwordPrompt":"Richiesta password","sweetAlerts.customStyle":"Stile personalizzato","sweetAlerts.itPretty":"È carino, non è vero?","sweetAlerts.btnClicked":"Hai fatto clic sul pulsante!","sweetAlerts.youWillFind":"Scoprirai che sono su!","sweetAlerts.youWillNotAble":"Non sarai in grado di recuperare questo file immaginario!","sweetAlerts.hereIsaMessage":"Ecco un messaggio!","sweetAlerts.goodJob":"Buon lavoro!","sweetAlerts.yesDeleteIt":"Sì, cancellalo!","sweetAlerts.areYouSure":"Sei sicuro?","sweetAlerts.doYouLikeThumb":"Ti piacciono i pollici?","sweetAlerts.anInput":"Un input!","sweetAlerts.writeSomethingInteresting":"Scrivi qualcosa di interessante:","sweetAlerts.writeSomething":"Scrivi qualcosa","sweetAlerts.youMustEnterPassword":"Devi inserire la tua password!","sweetAlerts.enterPassword":"Inserire la password","notification.infoMsg":"Messaggio informativo","notification.successMessage":"Messaggio di successo","notification.warningMessage":"Messaggio di avvertimento","notification.closeAfter3000ms":"Chiudi dopo 3000 ms","notification.errorMessage":"Messaggio di errore","notification.titleHere":"Titolo qui","notification.clickMe":"Cliccami!","notification.info":"Informazioni","notification.success":"Successo","notification.warning":"avvertimento","notification.error":"Errore","extraElements.callouts":"didascalie","extraElements.pricingTable":"Tabella dei prezzi","extraElements.testimonials":"Testimonianze","callouts.viewRange":"Visualizza gamma","callouts.basic":"Di base","pricingTable.basic":"Di base","pricingTable.circle":"Cerchio","pricingTable.classic":"Classico","pricingTable.dark":"Buio","pricingTable.personal":"PERSONALE","pricingTable.easyTranslation":"Traduzione semplice","pricingTable.awesomeGoogleFonts":"Font Google fantastici","pricingTable.hotelBookingSystem":"Sistema di prenotazione alberghiera","pricingTable.emailComposeInterface":"Email Compose Interface","pricingTable.locationFinderApp":"Location Finder App","pricingTable.buyNow":"acquista ora","pricingTable.business":"ATTIVITÀ COMMERCIALE","pricingTable.professional":"PROFESSIONALE","testimonials.basic":"Di base","testimonials.classic":"Classico","testimonials.standard":"Standard","extraPages.goHome":"Vai a casa","extraPages.ourClients":"I nostri clienti","extraPages.all":"Tutti","extraPages.graphicDesign":"disegno grafico","extraPages.logo":"logo","extraPages.mobileApp":"app mobile","extraPages.web":"web","extraPages.404Msg":"Spiacenti, si è verificato un errore. Pagina non trovata!","extraPages.500Msg":"Spiacente, il server va male","extraPages.aboutUs.showCase":"Mostra i tuoi servizi qui con le informazioni su di loro","aboutUs.readMore":"Leggi di più","extraPages.goSomewhere":"Andare da qualche parte","icon.material":"Oltre 900 icone ufficiali di design dei materiali","mail.mailbox":"Cassetta postale","mail.compose":"COMPORRE","mail.filters":"filtri","mail.labels":"etichette","picker.color.alpha":"Raccoglitrici Alpha","picker.color.hue":"Selezionatori di tinte","picker.color.circle":"Raccoglitori di cerchi","picker.color.compact":"Picker compatti","picker.color.block":"Raccoglitori di blocchi","picker.color.chrome":"Raccoglitrici di cromo","picker.color.github":"Github Pickers","picker.color.twitter":"Raccoglitori di Twitter","picker.color.withRedux":"Con Redux","picker.color.sketch":"Raccoglitori di schizzo","picker.color.material":"Raccoglitori di materiale","picker.color.slider":"Raccoglitori di cursori","picker.color.basic":"Raccoglitori di base","picker.color.basicToggle":"Toggle di base","picker.color.custom":"Raccoglitori personalizzati","picker.color.customPointer":"Puntatore personalizzato","picker.color.photoshop":"Selettori di Photoshop","picker.color.swatches":"Raccoglitrici di campioni","picker.color.basicPositioning":"Posizionamento di base","picker.date.pickers":"Pickers","picker.date.date":"Raccoglitori di date","picker.date.time":"Raccoglitori di tempo","picker.date.week":"Raccoglitori di settimane","picker.date.dateNTime":"Raccoglitori di data e ora","picker.date.customDate":"Raccoglitori di data e ora personalizzati","table.marketingCampaign":"Campagna di marketing","table.thisWeek":"Questa settimana","table.recentOrders":"Ordini Recenti","table.dataTable":"Tabella dati","table.basicTable":"Tabella di base","table.application":"Tabella delle applicazioni","todo":"Fare","todo.addTask":"AGGIUNGI TASK","todo.all":"Tutti","todo.filters":"filtri","todo.labels":"etichette","dashboard.recentActivities":"Attività recenti","dashboard.lastActivity":"L'ultima attività è stata 2 giorni fa","dashboard.currentProjects":"Elenco Progetti attuali","dashboard.toDoItems":"Lista delle cose da fare","dashboard.today":"Oggi","dashboard.marketingCampaign":"Campagna di marketing","dashboard.yourDailyFeed":"Il tuo feed giornaliero","dashboard.googleInsight":"Punteggio di intuizione di Google","dashboard.lastCalculated":"Las calcolato 1 mese fa","dashboard.refresh":"ricaricare","dashboard.upgradeToday":"aggiorna oggi","dashboard.onlineSignups":"Iscrizioni online","dashboard.lastMonthSale":"Vendita del mese scorso","dashboard.newVisits":"Nuove visite questo mese","dashboard.totalRevenue":"Totale delle entrate di quest'anno","dashboard.latestPosts":"ultimi post","dashboard.loremIpsum":"Lorem ipsum è finto contenuto dollaro si siede è ...","dashboard.viewAllPosts":"VISUALIZZA TUTTI I POSTI","dashboard.popularProducts":"Prodotti popolari","dashboard.popularProductsTxt":"È un fatto ormai consolidato che un lettore sarà distratto dal contenuto leggibile.","dashboard.allProducts":"tutti i prodotti","dashboard.userStatstics":"Statistiche utente","dashboard.orders":"Ordini","dashboard.thisYearSaleReport":"Questo rapporto di vendita di anno","dashboard.post9MonthData":"Invia dati a 9 mesi","dashboard.newCustomers":"nuovi clienti","dashboard.newThisMonth":"32 nuovi questo mese","dashboard.monthly":"Mensile","dashboard.totalView":"Vista totale","dashboard.annual":"Annuale","dashboard.newOrder":"Nuovo ordine","dashboard.visited":"visitato","dashboard.rapidPace":"Ritmo veloce","dashboard.slowPace":"Passo lento","dashboard.newConnections":"Nuove connessioni","dashboard.thisWeek":"3 Questa settimana","dashboard.newFeed":"23 nuovi feed","dashboard.newSubscriber":"Nuovo iscritto","dashboard.newArticles":"Nuovi articoli","dashboard.newAuthors":"Nuovi autori","dashboard.avgDailyTraffic":"Traffico giornaliero medio","dashboard.popularAuthors":"Autori popolari","dashboard.authorsWith":"Autori con oltre 500 avg. vista","dashboard.popularArticles":"Articoli popolari","dashboard.comments":"Commenti","component.alert.default":"Avvisi predefiniti","component.alert.highlighted":"Avvisi evidenziati","component.alert.dismissible":"Avvisi non ammissibili","component.alert.withIcons":"Avvisi con icone","component.alert.withDetailedHTML":"Avviso con HTML dettagliato","component.appbar.simple":"App semplice","component.appbar.colored":"Barra delle applicazioni colorata","component.appbar.fullyFeatured":"Barra delle applicazioni completamente in evidenza","component.autocomplete.reactSelect":"Reagire Seleziona","component.autocomplete.reactAutosuggest":"Reagire Autosuggest","component.autocomplete.downshift":"downshift","component.avatars.image":"Avatar di immagini","component.avatars.letter":"Avatar di lettere","component.avatars.icon":"Avatar di icone","component.badge.scaling":"Distillare i distintivi","component.badge.insideLinks":"All'interno di collegamenti e pulsanti","component.badge.contextual":"Variazioni contestuali","component.badge.pill":"Distintivi della pillola","component.badge.link":"Link Badge","component.bottomNavigation.withLabels":"Navigazione inferiore con etichette","component.bottomNavigation.withActiveLabels":"Navigazione inferiore con etichetta attiva","component.bottomNavigation.withNoLabels":"Navigazione inferiore senza etichetta","component.breadcrumbs.simple":"Semplice","component.breadcrumbs.noList":"Nessuna lista","component.buttons.colorScheme":"Combinazione di colori","component.buttons.colorSchemeTxt":"Schema dei colori Bootstrap con il concetto di materiale","component.buttons.icon":"Pulsanti icona","component.buttons.iconTxt":"Puoi scegliere qualsiasi icona dalle icone dei caratteri elencati nella pagina Icone. O sentiti libero di aggiungere nuove icone di font e usarlo.","component.buttons.differentSizes":"Misure differenti","component.buttons.differentSizesTxt":"Bottoni materiale con diverse dimensioni","component.buttons.flatFullWidth":"Pulsanti di larghezza piatta e intera","component.buttons.flatFullWidthTxt":"Tutti i pulsanti di tipo con stati disabilitati","component.buttons.raised":"Pulsanti sollevati","component.buttons.raisedTxt":"Schema dei colori Bootstrap con il concetto di materiale","component.buttons.fab":"Pulsanti di azione fluttuanti","component.buttons.fabTxt":"Schema dei colori Bootstrap con il concetto di materiale","component.buttons.socialMedia":"Pulsanti di social media","component.buttons.socialMediaTxt":"Vari pulsanti di social media per il tuo progetto","component.buttons.complex":"Pulsanti complessi","component.buttonGroup.horizontalVariations":"Variazioni orizzontali","component.buttonGroup.defaultStyle":"Stile di gruppo pulsanti predefiniti","component.buttonGroup.highlightedStyle":"Evidenziato stile del gruppo di pulsanti","component.buttonGroup.flatStyle":"Stile del gruppo di pulsanti piatto","component.buttonGroup.default":"Gruppo di pulsanti predefinito","component.buttonGroup.flat":"Gruppo di pulsanti piatto","component.buttonGroup.highlighted":"Gruppo di pulsanti evidenziati","component.buttonGroup.icon":"Icona Pulsante Gruppo","component.buttonGroup.iconFlat":"Icona Gruppo pulsante piatto","component.buttonGroup.nested":"Gruppo di pulsanti annidati","component.cards.basic":"Carte base","component.cards.special":"Carte speciali","component.cards.withHeader":"Carte con intestazione, piè di pagina e allineamento","component.cards.navigational":"Carte di navigazione","component.cards.image":"Carte Immagine","component.cards.solid":"Carte solide","component.carousel.basic":"Carosello di base","component.carousel.basicTxt":"Carosello di base BS4 alimentato con ReactStrap","component.carousel.product":"Carousel prodotto","component.carousel.productTxt":"Una giostra con vista a griglia orizzontale","component.carousel.testimonial":"Testimonial Carousel","component.carousel.testimonialTxt":"Un elemento carosello alla volta","component.chips.default":"Chip predefinito","component.chips.outline":"Chip di contorno","component.chips.chipWithText":"Chip con Avatar di testo","component.chips.clickable":"Chip cliccabile","component.chips.withImage":"Chip con Avatar di immagini","component.chips.deletable":"Chip eliminabile","component.chips.withIcon":"Chip con Icon Avatar","component.chips.custom":"Chip cliccabile personalizzato","component.chips.array":"Chip Array","component.chips.withInput":"Implementazione di chip con casella di input","component.dividers.list":"Lista divisori","component.dividers.inset":"Divisori interni","component.dividers.default":"Predefinito","component.drawer.persistent":"Cassetto persistente","component.drawer.permanent":"Cassetto permanente","component.drawer.mini":"Mini cassetto","component.drawer.responsive":"Cassetto reattivo","component.expansionPanel.simple":"Semplice pannello di espansione","component.expansionPanel.controlled":"Fisarmonica controllata","component.expansionPanel.secondary":"Intestazione secondaria e colonne","component.gridList.image":"Elenco griglia di immagini","component.gridList.advanced":"Elenco griglia avanzato","component.gridList.singleLine":"Elenco Griglia a riga singola","component.gridList.withTitlebars":"Elenco griglia con barre del titolo","component.lists.folder":"Elenco cartelle","component.lists.switch":"Commuta i controlli dell'elenco","component.lists.dividers":"Lista divisori","component.lists.simple":"Lista semplice","component.lists.inset":"Elenco inserto","component.lists.nested":"Elenco annidato","component.lists.checkbox":"Checkbox Controlli dell'elenco secondario","component.lists.checkboxControls":"Controlli Elenco caselle di controllo","component.lists.pinned":"Elenco Sottotitoli aggiunti","component.lists.interactive":"Controlli elenco interattivo","component.chips":"Recente","component.menusPaper.simple":"Menu semplici","component.menusPaper.withIcon":"Menu con l'icona","component.menusPaper.withMoreButton":"Menu con più pulsanti","component.menusPaper.withSelectedValue":"Menu con valore selezionato","component.menusPaper.paper":"Carta","component.pickers.Date":"Raccoglitori di date","component.progress.indeterminateCircular":"Circolare indeterminata","component.progress.determinateCircular":"Determina circolare","component.progress.indeterminateLinear":"Lineare indeterminata","component.progress.determinateLinear":"Determina lineare","component.progress.bufferLinear":"Buffer lineare","component.progress.interactiveIntegration":"Integrazione interattiva","component.progress.queryLinear":"Interrogazione lineare","component.selectionControl.checkboxes":"caselle di controllo","component.selectionControl.disabled":"Disabilitato","component.selectionControl.intermediate":"Intermedio","component.selectionControl.checkboxesWithForm":"Caselle di controllo con gruppo di moduli","component.selectionControl.basicRadio":"Pulsanti radio di base","component.selectionControl.disabledRadio":"Pulsanti radio disabilitati","component.selectionControl.withError":"Con messaggio di errore","component.selectionControl.switches":"Interruttori","component.selectionControl.verticalSwitches":"Interruttori verticali","component.selectionControl.groupedSwitches":"Interruttori raggruppati","component.selectionControl.verticalImplementation":"Implementazione verticale di interruttori","component.selectionControl.generalSettings":"impostazioni generali","component.selectionControl.themeSettings":"Impostazioni tema","component.selectionControl.onOffSwitches":"interruttori on / off","component.selectionControl.verticalInlineRadio":"Pulsanti radio verticali e in linea","component.selectionControl.checkboxesWithFormTxt":"I menu sono posizionati sopra i loro elementi di emissione in modo che la voce di menu attualmente selezionata appaia sopra l'elemento emittente.","component.selects.simple":"Selezione semplice","component.selects.native":"Selezione nativa","component.selects.multiple":"Selezione multipla","component.selects.dialog":"Dialog Select","component.snackbars.transition":"Direzione del controllo di transizione","component.snackbars.simple":"Semplice","component.snackbars.positioned":"posizionato","component.snackbars.messageWithButton":"Messaggio con pulsante","component.snackbars.colors":"Colori","component.snackbars.multilineText":"Testo multilinea","component.snackbars.onlyMessage":"Solo messaggio","component.snackbars.withIconButton":"Messaggio con IconButton","component.stepper.horizontalLinear":"Lineare orizzontale","component.stepper.horizontalLinearAlternativeLabel":"Lineare orizzontale - Etichetta alternativa","component.stepper.vertical":"Stepper verticale","component.stepper.horizontalNonLinear":"Orizzontale Non lineare","component.stepper.horizontalNonLinearAlternativeLabel":"Orizzontale non lineare - Etichetta alternativa","component.stepper.mobileDots":"Stepper mobile - Punti","component.stepper.mobileProgress":"Mobile Stepper: progresso","component.stepper.mobileText":"Stepper mobile - Testo","component.tabs.basic":"Schede di base","component.tabs.fixed":"Fixed Tabs Full width","component.tabs.icon":"Schede icona","component.tabs.disabled":"Scheda disabilitata","component.tabs.wrappedLabels":"Etichette avvolte","component.tabs.iconWithLabel":"Schede icona con etichetta","component.tabs.fixedCentered":"Corrette le schede centrate","component.tabs.automaticScroll":"Pulsanti di scorrimento automatici","component.tabs.forcedScroll":"Pulsanti di scorrimento forzato","component.tabs.preventScroll":"Previene i pulsanti di scorrimento","component.textFields.textfield":"Campo di testo","component.textFields.components":"componenti","component.textFields.layout":"disposizione","component.textFields.inputAdornments":"Input ornamenti","component.textFields.formattedInputs":"Input formattati","component.textFields.inputs":"ingressi","component.tooltips.avatar":"Tooltip Avatar","component.tooltips.button":"Pulsante Tooltip","component.tooltips.icon":"Icona Tooltip","component.tooltips.controlled":"Tooltip controllato","component.tooltips.positioned":"Tooltip posizionato","component.typography.lightHeadings":"Titoli chiari","component.typography.normalHeadings":"Intestazioni normali","component.typography.semiBoldHeadings":"Intestazioni semi-audaci","component.typography.boldHeadings":"Intestazioni audaci","component.typography.paragraphText":"Testo del paragrafo","component.typography.leadParagraphText":"Testo del paragrafo principale","component.typography.unstyledList":"Elenco Unstyled","component.typography.orderedList":"Lista ordinata","component.typography.unorderedList":"Lista non ordinata","component.typography.listWithIcons":"Elenco con icone","component.typography.compactList":"Elenco compatto","component.typography.extendedList":"Elenco esteso","component.typography.leftIconGroupedList":"Icona raggruppata a sinistra","component.typography.rightIconGroupedList":"Elenco delle icone a destra","component.typography.badgesGroupedList":"Lista raggruppata distintivi","component.typography.defaultDescriptionList":"Elenco di descrizione predefinito","component.typography.evenOddDescriptionList":"Elenco di descrizione pari-dispari","component.typography.leftBlockquoteWithAuthorAvatar":"Left Blockquote With Author Avatar","component.typography.rightBlockquoteWithAuthorAvatar":"Right Blockquote With Author Avatar","signIn.success":"Accedi con successo!","signIn.error":"E-mail o password non validi!","signUp.success":"account creato con successo","signUp.error":"Destra","signIn.success1":"Destra","signIn.signUp":"Crea un account","signIn.connectWith":"o connettersi con","signUp.alreadyMember":"Sono già un membro","appModule.signin":"Registrati","appModule.signup":"Iscriviti","pages.samplePage":"Pagina di esempio","pages.samplePage.description":"Inizia a costruire la tua app. Felice codifica!","mailNotification.title":"messaggi","appNotification.title":"notifiche","mailNotification.message":"Nessun nuovo messaggio al momento!","appNotification.message":"Nessuna notifica al momento!","popup.profile":"Profilo","popup.setting":"Ambientazione","popup.logout":"Disconnettersi","popup.updateData":"Aggiorna dati","popup.detailedLog":"Log dettagliato","popup.statistics":"statistica","popup.clearData":"Cancella i dati","component.selectionControl.radioBtnGroup":"Gruppo pulsanti radio","component.popover.anchorPlayground":"Parco giochi di ancoraggio"}

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _es = __webpack_require__(1342);

var _es2 = _interopRequireDefault(_es);

var _es_ES = __webpack_require__(1343);

var _es_ES2 = _interopRequireDefault(_es_ES);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var saLang = {
    messages: _extends({}, _es_ES2.default),
    locale: 'es',
    data: _es2.default
};
var _default = saLang;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(_es2, '_es2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(_es_ES2, '_es_ES2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/es_ES.js');
}();

;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"Principal","sidebar.dashboard":"Tablero","sidebar.dashboard.default":"Defecto","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"Noticias","sidebar.dashboard.intranet":"Intranet","sidebar.components":"Componentes","sidebar.components.alerts":"Alertas","sidebar.components.appbar":"Barra de aplicaciones","sidebar.components.autocomplete":"Autocompletar","sidebar.components.avatars":"Avatares","sidebar.components.badge":"Distintivo","sidebar.components.bottomNavigation":"Navegación inferior","sidebar.components.breadcrumbs":"Migas de pan","sidebar.components.buttons":"Botones","sidebar.components.buttonGroup":"Grupo de botones","sidebar.components.cards":"Tarjetas","sidebar.components.carousel":"Carrusel","sidebar.components.chips":"Papas fritas","sidebar.components.colorPicker":"Selector de color","sidebar.components.dialogs":"Diálogos","sidebar.components.dividers":"Divisores","sidebar.components.expansionPanel":"Panel de Expansión","sidebar.components.drawer":"Cajón","sidebar.components.gridList":"Lista de cuadrícula","sidebar.components.lists":"Liza","sidebar.components.menusPaper":"Menús y papel","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"Popovers","sidebar.components.progress":"Progreso","sidebar.components.selects":"Selecciona","sidebar.components.selectionControl":"Controles de selección","sidebar.components.snackbars":"Barras de merienda","sidebar.components.stepper":"Paso a paso","sidebar.components.tables":"Mesas","sidebar.components.tabs":"Pestañas","sidebar.components.textFields":"Campos de texto","sidebar.components.tooltips":"Información sobre herramientas","sidebar.components.typography":"Tipografía","sidebar.widgets":"Widgets","sidebar.metrics":"Métrica","sidebar.view":"Ver","sidebar.tables":"Mesas","sidebar.tables.basicTable":"Tabla básica","sidebar.tables.dataTable":"Tabla de datos","sidebar.timeLine":"Time Line","sidebar.timeLine.default":"Defecto","sidebar.timeLine.defaultwithIcons":"Predeterminado con iconos","sidebar.timeLine.leftAligned":"Alineado a la izquierda","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Vistas personalizadas","sidebar.customViews.plainListView":"Vista de lista simple","sidebar.customViews.withDivider":"Lista simple con divisor","sidebar.customViews.cardListView":"Vista de lista de tarjetas","sidebar.form":"Formar","sidebar.forms":"Formularios","sidebar.forms.components":"Componentes","sidebar.forms.stepper":"Paso a paso","sidebar.extensions":"Extensiones","sidebar.editors":"Editores","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"Editor WYSIWYG","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Selector de fecha y hora","sidebar.pickers.colorPickers":"Selector de color","sidebar.extensions.dragNDrop":"Arrastrar y soltar","sidebar.extensions.sweetAlert":"Sweet Alert","sidebar.extensions.notification":"Notificación","sidebar.chart":"Gráfico","sidebar.chart.line":"Gráfico de linea","sidebar.chart.bar":"Gráfico de barras","sidebar.chart.area":"Carta de área","sidebar.chart.composed":"Gráfico compuesto","sidebar.chart.scatter":"Gráfico de dispersión","sidebar.chart.pie":"Gráfico circular","sidebar.chart.radial":"Gráfico radial","sidebar.chart.radar":"Gráfico de radar","sidebar.chart.tree":"Árbol de Carta","sidebar.map":"Mapa de Google","sidebar.map.simple":"Mapa simple","sidebar.map.styled":"Mapa de estilo","sidebar.map.geoLocation":"Ubicación geográfica","sidebar.map.mapDirection":"Dirección del mapa","sidebar.map.overlay":"Superposición de mapa","sidebar.map.kmLayer":"Mapa Km Layer","sidebar.map.popupInfo":"Mapa de información emergente","sidebar.map.trafficLayer":"Mapa Traffic Layer","sidebar.map.streetView":"vista de calle","sidebar.map.eventListener":"Escucha del evento","sidebar.map.mapDrawing":"Mapa de dibujo","sidebar.map.mapClustering":"Agrupación de mapas","sidebar.modules":"Módulos","sidebar.calendar":"Calendario","sidebar.calendar.basic":"BASIC","sidebar.calendar.cultures":"Culturas","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Surgir","sidebar.calendar.rendering":"Representación","sidebar.calendar.selectable":"Seleccionable","sidebar.calendar.timeslots":"Ranuras de tiempo","sidebar.eCommerce":"eCommerce","sidebar.eCommerce.productsList":"Lista de productos","sidebar.eCommerce.productsGrid":"Cuadrícula de productos","sidebar.appModule":"Módulo de aplicación","sidebar.appModule.login1":"Inicio de sesión Página 1","sidebar.appModule.login2":"Inicio de sesión Página 2","sidebar.appModule.loginStepper":"Iniciar sesión con Stepper","sidebar.appModule.signup1":"Registrarse Página 1","sidebar.appModule.signup2":"Registrarse Página 2","sidebar.appModule.forgotPassword1":"Olvidé mi contraseña 1","sidebar.appModule.forgotPassword2":"Olvidé mi contraseña 2","sidebar.appModule.lock1":"Pantalla de bloqueo 1","sidebar.appModule.lock2":"Pantalla de bloqueo 2","sidebar.appModule.toDo":"Que hacer","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"Correo","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Charla","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contacto","sidebar.appModule.contactRedux":"Contactar con Redux","sidebar.extras":"Extras","sidebar.icons":"Iconos","sidebar.icons.material":"Iconos de material de Google","sidebar.extraElements":"Elementos extra","sidebar.extraElements.pricingTable":"Tabla de precios","sidebar.extraElements.callouts":"Llamadas","sidebar.extraElements.testimonials":"Testimonios","sidebar.extraPages":"Páginas extra","sidebar.extraPages.aboutUs":"Sobre nosotros","sidebar.extraPages.contactUs":"Contáctenos","sidebar.extraPages.blog":"Blog","sidebar.extraPages.faq":"Preguntas más frecuentes","sidebar.extraPages.portfolio":"portafolio","sidebar.extraPages.404":"Página de error 404","sidebar.extraPages.500":"500 página de error","sidebar.menuLevels":"Niveles de menú","sidebar.menuLevels.level1":"Nivel 1","sidebar.menuLevels.level2":"Nivel 2","sidebar.menuLevels.level3":"Nivel 3","appModule.forgotPassword":"¿Olvidaste tu contraseña?","appModule.dntRememberEmail":"¿No recuerdas tu correo electrónico?","appModule.contactSupport":"Soporte de contacto","appModule.resetPassword":"Restablecer la contraseña","appModule.enterPasswordUnlock":"¡Ingresa tu contraseña para desbloquear la pantalla!","appModule.unlock":"desbloquear","appModule.signInDiffAccount":"Inicie sesión usando una cuenta diferente","appModule.rememberMe":"Recuérdame","appModule.signIn":"Registrarse","appModule.next":"Siguiente","appModule.back":"Espalda","appModule.allStepsCompleted":"Todos los pasos completados","appModule.reset":"Reiniciar","appModule.loginSuccessfully":"Iniciar sesión exitosamente","appModule.password":"Contraseña","appModule.email":"Email","appModule.name":"Nombre","appModule.phone":"Teléfono","appModule.designation":"Designacion","appModule.regsiter":"Registro","appModule.hvAccount":"Tener una cuenta","appModule.createAccount":"Crea una cuenta","chart.area":"Gráfico de área","chart.bar":"Gráfico de barras","chart.composed":"Gráfico compuesto","chart.line":"Gráfico de líneas","chart.pie":"Gráfico de torta","chart.radar":"Gráfico de radar","chart.radial":"Gráfico radial","chart.scatter":"Gráfico de dispersión","chart.tree":"Gráfico de árbol","chat.selectUserChat":"Seleccionar usuario para iniciar el chat","chat.selectContactChat":"Seleccionar contacto para iniciar el chat","chat.chatUser":"Chats","chat.contacts":"Contactos","chat.searchStartNewChat":"Buscar o iniciar un chat nuevo","chat.typeMessage":"Escribe y presiona enter para enviar el mensaje","chat.status":"es un estado ... no es tu diario ...","contact.saveContact":"Guardar contacto","contact.addContact":"Agregar contacto","contact.searchContact":"Buscar contacto","button.modify":"Modificar","button.delete":"Borrar","button.yes":"Sí","button.no":"No","eCommerce.readMore":"Lee mas","eCommerce.addToCart":"añadir a la cesta","eCommerce.buyNow":"Compra ahora","extension.sweetAlerts":"Sweet Alerts","extension.notification":"Notificación","sweetAlerts.basic":"BASIC","sweetAlerts.description":"Con descripción","sweetAlerts.success":"Éxito","sweetAlerts.warning":"Advertencia","sweetAlerts.custom":"Personalizado","sweetAlerts.htmlTag":"Etiqueta Html","sweetAlerts.prompt":"Rápido","sweetAlerts.itsBlue":"¡Es azul!","sweetAlerts.passwordPrompt":"Indicación de contraseña","sweetAlerts.customStyle":"Estilo personalizado","sweetAlerts.itPretty":"Es lindo, ¿verdad?","sweetAlerts.btnClicked":"Hiciste clic en el botón!","sweetAlerts.youWillFind":"¡Encontrarás que están listos!","sweetAlerts.youWillNotAble":"¡No podrás recuperar este archivo imaginario!","sweetAlerts.hereIsaMessage":"¡Aquí hay un mensaje!","sweetAlerts.goodJob":"¡Buen trabajo!","sweetAlerts.yesDeleteIt":"Sí, eliminarlo!","sweetAlerts.areYouSure":"¿Estás seguro?","sweetAlerts.doYouLikeThumb":"¿Te gustan los pulgares?","sweetAlerts.anInput":"Una entrada!","sweetAlerts.writeSomethingInteresting":"Escribe algo interesante:","sweetAlerts.writeSomething":"Escribe algo","sweetAlerts.youMustEnterPassword":"¡Debes ingresar tu contraseña!","sweetAlerts.enterPassword":"Introducir la contraseña","notification.infoMsg":"Mensaje de información","notification.successMessage":"Mensaje de éxito","notification.warningMessage":"Mensaje de advertencia","notification.closeAfter3000ms":"Cerrar después de 3000ms","notification.errorMessage":"Mensaje de error","notification.titleHere":"Título aquí","notification.clickMe":"¡Haz click en mi!","notification.info":"Información","notification.success":"Éxito","notification.warning":"Advertencia","notification.error":"Error","extraElements.callouts":"Llamadas","extraElements.pricingTable":"Tabla de precios","extraElements.testimonials":"Testimonios","callouts.viewRange":"Ver rango","callouts.basic":"BASIC","pricingTable.basic":"BASIC","pricingTable.circle":"Circulo","pricingTable.classic":"Clásico","pricingTable.dark":"Oscuro","pricingTable.personal":"PERSONAL","pricingTable.easyTranslation":"Traducción fácil","pricingTable.awesomeGoogleFonts":"Fuentes increíbles de Google","pricingTable.hotelBookingSystem":"Sistema de reserva de hotel","pricingTable.emailComposeInterface":"Interfaz de redacción de correo electrónico","pricingTable.locationFinderApp":"Aplicación de buscador de ubicación","pricingTable.buyNow":"compra ahora","pricingTable.business":"NEGOCIO","pricingTable.professional":"PROFESIONAL","testimonials.basic":"BASIC","testimonials.classic":"Clásico","testimonials.standard":"Estándar","extraPages.goHome":"Ir a casa","extraPages.ourClients":"Nuestros clientes","extraPages.all":"Todas","extraPages.graphicDesign":"diseño gráfico","extraPages.logo":"logo","extraPages.mobileApp":"aplicación movil","extraPages.web":"web","extraPages.404Msg":"Vaya, ha ocurrido un error. ¡Página no encontrada!","extraPages.500Msg":"Lo siento, el servidor sale mal","extraPages.aboutUs.showCase":"Muestre sus servicios aquí con información sobre ellos","aboutUs.readMore":"Lee mas","extraPages.goSomewhere":"Ve a algún lugar","icon.material":"Más de 900 iconos de diseño de material oficial","mail.mailbox":"Buzón","mail.compose":"COMPONER","mail.filters":"Filtros","mail.labels":"Etiquetas","picker.color.alpha":"Recolectores alfa","picker.color.hue":"Recogedores de tono","picker.color.circle":"Seleccionadores de círculo","picker.color.compact":"Selector compacto","picker.color.block":"Selector de bloque","picker.color.chrome":"Recogedores de Chrome","picker.color.github":"Segadores Github","picker.color.twitter":"Seleccionadores de Twitter","picker.color.withRedux":"Con Redux","picker.color.sketch":"Recogedores de bosquejos","picker.color.material":"Recogedores de materiales","picker.color.slider":"Seleccionadores de control deslizante","picker.color.basic":"Selector básico","picker.color.basicToggle":"Alternar básico","picker.color.custom":"Recogedores personalizados","picker.color.customPointer":"Puntero personalizado","picker.color.photoshop":"Selector de Photoshop","picker.color.swatches":"Selector de muestras","picker.color.basicPositioning":"Posicionamiento Básico","picker.date.pickers":"Pickers","picker.date.date":"Selector de fecha","picker.date.time":"Selectores de tiempo","picker.date.week":"Recolectores de semana","picker.date.dateNTime":"Selector de fecha y hora","picker.date.customDate":"Selector de fecha y hora personalizados","table.marketingCampaign":"CAMPAÑA de Marketing","table.thisWeek":"Esta semana","table.recentOrders":"órdenes recientes","table.dataTable":"Tabla de datos","table.basicTable":"Tabla básica","table.application":"Tabla de aplicaciones","todo":"Que hacer","todo.addTask":"AGREGAR TAREA","todo.all":"Todas","todo.filters":"Filtros","todo.labels":"Etiquetas","dashboard.recentActivities":"Actividades recientes","dashboard.lastActivity":"Última actividad fue hace 2 días","dashboard.currentProjects":"Lista de proyectos actuales","dashboard.toDoItems":"Lista de elementos para hacer","dashboard.today":"Hoy","dashboard.marketingCampaign":"CAMPAÑA de Marketing","dashboard.yourDailyFeed":"Tu alimentación diaria","dashboard.googleInsight":"Puntaje de información de Google","dashboard.lastCalculated":"Las calculó hace 1 mes","dashboard.refresh":"Refrescar","dashboard.upgradeToday":"actualice hoy","dashboard.onlineSignups":"Suscripciones en línea","dashboard.lastMonthSale":"Última venta del mes","dashboard.newVisits":"Nuevas visitas este mes","dashboard.totalRevenue":"Ingresos totales este año","dashboard.latestPosts":"últimas publicaciones","dashboard.loremIpsum":"Lorem ipsum es un tonto contenido dólar sentarse es ...","dashboard.viewAllPosts":"VER TODOS LOS PUESTOS","dashboard.popularProducts":"productos populares","dashboard.popularProductsTxt":"Es un hecho establecido desde hace tiempo que un lector se distraerá con el contenido legible.","dashboard.allProducts":"todos los productos","dashboard.userStatstics":"Estadísticas de usuario","dashboard.orders":"Pedidos","dashboard.thisYearSaleReport":"Reporte de venta de este año","dashboard.post9MonthData":"Publicar datos de 9 meses","dashboard.newCustomers":"nuevos clientes","dashboard.newThisMonth":"32 nuevos este mes","dashboard.monthly":"Mensual","dashboard.totalView":"Vista total","dashboard.annual":"Anual","dashboard.newOrder":"Nuevo orden","dashboard.visited":"Visitó","dashboard.rapidPace":"Paso veloz","dashboard.slowPace":"Paso lento","dashboard.newConnections":"Nuevas conexiones","dashboard.thisWeek":"3 Esta semana","dashboard.newFeed":"23 nuevos feeds","dashboard.newSubscriber":"Nuevo suscriptor","dashboard.newArticles":"Artículos nuevos","dashboard.newAuthors":"Nuevos autores","dashboard.avgDailyTraffic":"Avg Daily Traffic","dashboard.popularAuthors":"Autores populares","dashboard.authorsWith":"Autores con más de 500 prom. ver","dashboard.popularArticles":"articulos populares","dashboard.comments":"Comentarios","component.alert.default":"Alertas predeterminadas","component.alert.highlighted":"Alertas destacadas","component.alert.dismissible":"Alertas imposibles","component.alert.withIcons":"Alertas con iconos","component.alert.withDetailedHTML":"Alerta con HTML detallado","component.appbar.simple":"Barra de aplicación simple","component.appbar.colored":"Barra de aplicaciones de color","component.appbar.fullyFeatured":"Barra de aplicaciones totalmente destacada","component.autocomplete.reactSelect":"React Select","component.autocomplete.reactAutosuggest":"Reaccionar Autosuggest","component.autocomplete.downshift":"Cambio descendente","component.avatars.image":"Avatares de imagen","component.avatars.letter":"Carta Avatares","component.avatars.icon":"Avatares de icono","component.badge.scaling":"Insignias de escala","component.badge.insideLinks":"Enlaces y botones internos","component.badge.contextual":"Variaciones contextuales","component.badge.pill":"Insignias de píldoras","component.badge.link":"Insignias de enlace","component.bottomNavigation.withLabels":"Navegación inferior con etiquetas","component.bottomNavigation.withActiveLabels":"Navegación inferior con etiqueta activa","component.bottomNavigation.withNoLabels":"Navegación inferior sin etiqueta","component.breadcrumbs.simple":"Sencillo","component.breadcrumbs.noList":"Sin lista","component.buttons.colorScheme":"Esquema de colores","component.buttons.colorSchemeTxt":"Esquema de color Bootstrap con concepto de material","component.buttons.icon":"Botones de icono","component.buttons.iconTxt":"Puede elegir cualquier ícono de los íconos de fuentes que figuran en la página de Iconos. O siéntase libre de agregar cualquier ícono de fuente nuevo y usarlo.","component.buttons.differentSizes":"Diferentes tamaños","component.buttons.differentSizesTxt":"Botones de material con diferentes tamaños","component.buttons.flatFullWidth":"Botones de ancho plano y completo","component.buttons.flatFullWidthTxt":"Todos los botones de tipo con estados desactivados","component.buttons.raised":"Botones elevados","component.buttons.raisedTxt":"Esquema de color Bootstrap con concepto de material","component.buttons.fab":"Botones de acción flotante","component.buttons.fabTxt":"Esquema de color Bootstrap con concepto de material","component.buttons.socialMedia":"Botones de redes sociales","component.buttons.socialMediaTxt":"Varios botones de redes sociales para su proyecto","component.buttons.complex":"Botones complejos","component.buttonGroup.horizontalVariations":"Variaciones horizontales","component.buttonGroup.defaultStyle":"Estilo de grupo de botones predeterminados","component.buttonGroup.highlightedStyle":"Estilo resaltado del grupo de botones","component.buttonGroup.flatStyle":"Estilo de grupo de botón plano","component.buttonGroup.default":"Grupo de botones predeterminados","component.buttonGroup.flat":"Grupo de botones planos","component.buttonGroup.highlighted":"Grupo de botones resaltados","component.buttonGroup.icon":"Grupo de botones de icono","component.buttonGroup.iconFlat":"Grupo de botones planos de iconos","component.buttonGroup.nested":"Grupo de botones anidados","component.cards.basic":"Tarjetas básicas","component.cards.special":"Tarjetas especiales","component.cards.withHeader":"Tarjetas con encabezado, pie de página y alineación","component.cards.navigational":"Tarjetas de navegación","component.cards.image":"Tarjetas de imagen","component.cards.solid":"Tarjetas sólidas","component.carousel.basic":"Carrusel básico","component.carousel.basicTxt":"Carrusel básico BS4 con ReactStrap","component.carousel.product":"Carrusel de productos","component.carousel.productTxt":"Un carrusel de vista de cuadrícula horizontal","component.carousel.testimonial":"Carrusel testimonial","component.carousel.testimonialTxt":"Un carrusel de elementos a la vez","component.chips.default":"Chip predeterminado","component.chips.outline":"Chip de esquema","component.chips.chipWithText":"Chip con texto Avatar","component.chips.clickable":"Chip Clickable","component.chips.withImage":"Chip con imagen de Avatar","component.chips.deletable":"Chip eliminable","component.chips.withIcon":"Chip con el icono de Avatar","component.chips.custom":"Chip Clickable personalizado","component.chips.array":"Chip Array","component.chips.withInput":"Implementación de chips con cuadro de entrada","component.dividers.list":"List Dividers","component.dividers.inset":"Divisores de inserción","component.dividers.default":"Defecto","component.drawer.persistent":"Cajón persistente","component.drawer.permanent":"Cajón permanente","component.drawer.mini":"Mini cajón","component.drawer.responsive":"Cajón de respuesta","component.expansionPanel.simple":"Panel de expansión simple","component.expansionPanel.controlled":"Acordeón controlado","component.expansionPanel.secondary":"Título secundario y Columnas","component.gridList.image":"Lista de cuadrícula solo de imagen","component.gridList.advanced":"Lista de rejilla avanzada","component.gridList.singleLine":"Lista de cuadrícula de una sola línea","component.gridList.withTitlebars":"Cuadrícula lista con barras de título","component.lists.folder":"Lista de carpetas","component.lists.switch":"Controles de lista de cambio","component.lists.dividers":"List Dividers","component.lists.simple":"Lista simple","component.lists.inset":"Lista de inserción","component.lists.nested":"Lista anidada","component.lists.checkbox":"Casilla de verificación Controles de lista secundaria","component.lists.checkboxControls":"Controles de lista de casillas de verificación","component.lists.pinned":"Lista de subcarpetas fijadas","component.lists.interactive":"Controles de lista interactivos","component.chips":"Reciente","component.menusPaper.simple":"Menús simples","component.menusPaper.withIcon":"Menú con icono","component.menusPaper.withMoreButton":"Menú con más botón","component.menusPaper.withSelectedValue":"Menú con valor seleccionado","component.menusPaper.paper":"Papel","component.pickers.Date":"Selectores de fecha","component.progress.indeterminateCircular":"Circular indeterminada","component.progress.determinateCircular":"Circular determinada","component.progress.indeterminateLinear":"Indeterminado Linear","component.progress.determinateLinear":"Determinado lineal","component.progress.bufferLinear":"Buffer Linear","component.progress.interactiveIntegration":"Integración Interactiva","component.progress.queryLinear":"Consulta lineal","component.selectionControl.checkboxes":"Casillas de verificación","component.selectionControl.disabled":"Discapacitado","component.selectionControl.intermediate":"Intermedio","component.selectionControl.checkboxesWithForm":"Casillas de verificación con grupo de formularios","component.selectionControl.basicRadio":"Botones de radio básicos","component.selectionControl.disabledRadio":"Botones de radio desactivados","component.selectionControl.withError":"Con mensaje de error","component.selectionControl.switches":"Interruptores","component.selectionControl.verticalSwitches":"Interruptores verticales","component.selectionControl.groupedSwitches":"Interruptores agrupados","component.selectionControl.verticalImplementation":"Implementación vertical de interruptores","component.selectionControl.generalSettings":"Configuración general","component.selectionControl.themeSettings":"Ajustes de tema","component.selectionControl.onOffSwitches":"interruptores de encendido / apagado","component.selectionControl.verticalInlineRadio":"Botones de radio verticales y en línea","component.selectionControl.checkboxesWithFormTxt":"Los menús se colocan sobre sus elementos emisores de manera que el elemento del menú seleccionado actualmente aparece sobre el elemento emisor.","component.selects.simple":"Simple Select","component.selects.native":"Selección nativa","component.selects.multiple":"Selección múltiple","component.selects.dialog":"Dialog Select","component.snackbars.transition":"Dirección de control de transición","component.snackbars.simple":"Sencillo","component.snackbars.positioned":"Posicionado","component.snackbars.messageWithButton":"Mensaje con el botón","component.snackbars.colors":"Colores","component.snackbars.multilineText":"Texto de líneas múltiples","component.snackbars.onlyMessage":"Solo mensaje","component.snackbars.withIconButton":"Mensaje con IconButton","component.stepper.horizontalLinear":"Horizontal lineal","component.stepper.horizontalLinearAlternativeLabel":"Horizontal lineal - Etiqueta alternativa","component.stepper.vertical":"Stepper vertical","component.stepper.horizontalNonLinear":"Horizontal no lineal","component.stepper.horizontalNonLinearAlternativeLabel":"Horizontal no lineal - Etiqueta alternativa","component.stepper.mobileDots":"Paso a paso móvil - Puntos","component.stepper.mobileProgress":"Paso a paso móvil - Progreso","component.stepper.mobileText":"Paso a paso móvil - Texto","component.tabs.basic":"Pestañas básicas","component.tabs.fixed":"Pestañas fijas Ancho completo","component.tabs.icon":"Pestañas de iconos","component.tabs.disabled":"Pestaña deshabilitada","component.tabs.wrappedLabels":"Etiquetas envueltas","component.tabs.iconWithLabel":"Pestañas de icono con etiqueta","component.tabs.fixedCentered":"Pestañas fijas centradas","component.tabs.automaticScroll":"Botones de desplazamiento automáticos","component.tabs.forcedScroll":"Botones de desplazamiento forzado","component.tabs.preventScroll":"Evitar botones de desplazamiento","component.textFields.textfield":"Campo de texto","component.textFields.components":"Componentes","component.textFields.layout":"Diseño","component.textFields.inputAdornments":"Adornos de entrada","component.textFields.formattedInputs":"Entradas formateadas","component.textFields.inputs":"Entradas","component.tooltips.avatar":"Avatar Tooltip","component.tooltips.button":"Button Tooltip","component.tooltips.icon":"Icon Tooltip","component.tooltips.controlled":"Información sobre herramientas controladas","component.tooltips.positioned":"Información sobre herramientas posicionada","component.typography.lightHeadings":"Encabezados ligeros","component.typography.normalHeadings":"Encabezados normales","component.typography.semiBoldHeadings":"Encabezados semiarudados","component.typography.boldHeadings":"Encabezados audaces","component.typography.paragraphText":"Texto de párrafo","component.typography.leadParagraphText":"Texto del párrafo principal","component.typography.unstyledList":"Lista sin estilo","component.typography.orderedList":"Lista ordenada","component.typography.unorderedList":"Lista desordenada","component.typography.listWithIcons":"Lista con iconos","component.typography.compactList":"Lista compacta","component.typography.extendedList":"Lista extendida","component.typography.leftIconGroupedList":"Lista Agrupada de Íconos Izquierdos","component.typography.rightIconGroupedList":"Lista derecha de iconos agrupados","component.typography.badgesGroupedList":"Inscripciones Lista agrupada","component.typography.defaultDescriptionList":"Lista de descripción predeterminada","component.typography.evenOddDescriptionList":"Even-Odd Description List","component.typography.leftBlockquoteWithAuthorAvatar":"Left Blockquote con el autor Avatar","component.typography.rightBlockquoteWithAuthorAvatar":"Right Blockquote con el autor Avatar","signIn.success":"¡Ingresa exitosamente!","signIn.error":"Correo electrónico o contraseña inválidos","signUp.success":"Cuenta creada con éxito","signUp.error":"Derecha","signIn.success1":"Derecha","signIn.signUp":"Crea una cuenta","signIn.connectWith":"o conectarse con","signUp.alreadyMember":"Yo ya soy un miembro","appModule.signin":"Registrarse","appModule.signup":"Regístrate","pages.samplePage":"Página de Ejemplo","pages.samplePage.description":"Comience a construir su aplicación. Feliz Codificación!","mailNotification.title":"Mensajes","appNotification.title":"Notificaciones","mailNotification.message":"¡No hay mensajes nuevos a partir de ahora!","appNotification.message":"Sin notificaciones a partir de ahora!","popup.profile":"Perfil","popup.setting":"Ajuste","popup.logout":"Cerrar sesión","popup.updateData":"Actualizar datos","popup.detailedLog":"Registro detallado","popup.statistics":"Estadística","popup.clearData":"Borrar datos","component.selectionControl.radioBtnGroup":"Grupo de botones de radio","component.popover.anchorPlayground":"Anchor Playground"}

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

var _fr = __webpack_require__(1345);

var _fr2 = _interopRequireDefault(_fr);

var _fr_FR = __webpack_require__(1346);

var _fr_FR2 = _interopRequireDefault(_fr_FR);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var saLang = {
    messages: _extends({}, _fr_FR2.default),
    locale: 'fr-FR',
    data: _fr2.default
};
var _default = saLang;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_extends, '_extends', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(_fr2, '_fr2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(_fr_FR2, '_fr_FR2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(saLang, 'saLang', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/languageProvider/entries/fr_FR.js');
}();

;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports = {"sidebar.main":"Principale","sidebar.dashboard":"Tableau de bord","sidebar.dashboard.default":"Défaut","sidebar.dashboard.ecommerce":"eCommerce","sidebar.dashboard.news":"Nouvelles","sidebar.dashboard.intranet":"Intranet","sidebar.components":"Composants","sidebar.components.alerts":"Alertes","sidebar.components.appbar":"App Bar","sidebar.components.autocomplete":"Saisie semi-automatique","sidebar.components.avatars":"Avatars","sidebar.components.badge":"Badge","sidebar.components.bottomNavigation":"Navigation par le bas","sidebar.components.breadcrumbs":"Chapelure","sidebar.components.buttons":"Boutons","sidebar.components.buttonGroup":"Groupe de boutons","sidebar.components.cards":"Cartes","sidebar.components.carousel":"Carrousel","sidebar.components.chips":"chips","sidebar.components.colorPicker":"Pipette à couleurs","sidebar.components.dialogs":"Dialogues","sidebar.components.dividers":"Intercalaires","sidebar.components.expansionPanel":"Panneau d'extension","sidebar.components.drawer":"Tiroir","sidebar.components.gridList":"Grille Liste","sidebar.components.lists":"Listes","sidebar.components.menusPaper":"Menus et papier","sidebar.components.pickers":"Pickers","sidebar.components.popovers":"Popovers","sidebar.components.progress":"popovers","sidebar.components.selects":"Sélectionne","sidebar.components.selectionControl":"Contrôles de sélection","sidebar.components.snackbars":"Barre de céréales","sidebar.components.stepper":"Stepper","sidebar.components.tables":"les tables","sidebar.components.tabs":"Tabs","sidebar.components.textFields":"Champs de texte","sidebar.components.tooltips":"Info-bulles","sidebar.components.typography":"Typographie","sidebar.widgets":"Widgets","sidebar.metrics":"Métrique","sidebar.view":"Vue","sidebar.tables":"les tables","sidebar.tables.basicTable":"Table de base","sidebar.tables.dataTable":"Tableau de données","sidebar.timeLine":"Chronologie","sidebar.timeLine.default":"Défaut","sidebar.timeLine.defaultwithIcons":"Par défaut avec des icônes","sidebar.timeLine.leftAligned":"Aligné à gauche","sidebar.timeLine.zigzag":"Zigzag","sidebar.customViews":"Affichages personnalisés","sidebar.customViews.plainListView":"Vue en liste simple","sidebar.customViews.withDivider":"Liste simple avec diviseur","sidebar.customViews.cardListView":"Vue liste de cartes","sidebar.form":"Forme","sidebar.forms":"Formes","sidebar.forms.components":"Composants","sidebar.forms.stepper":"Stepper","sidebar.extensions":"Extensions","sidebar.editors":"Éditeurs","sidebar.editors.CKEditor":"CKEditor","sidebar.editors.WYSISWYGEditor":"Éditeur WYSIWYG","sidebar.pickers":"Pickers","sidebar.pickers.dateTimePickers":"Sélecteurs de date et d'heure","sidebar.pickers.colorPickers":"Color Pickers","sidebar.extensions.dragNDrop":"Glisser déposer","sidebar.extensions.sweetAlert":"Alerte douce","sidebar.extensions.notification":"Notification","sidebar.chart":"Graphique","sidebar.chart.line":"Graphique en ligne","sidebar.chart.bar":"Diagramme à bandes","sidebar.chart.area":"Graphique de zone","sidebar.chart.composed":"Tableau composé","sidebar.chart.scatter":"Diagramme de dispersion","sidebar.chart.pie":"Camembert","sidebar.chart.radial":"Graphique radial","sidebar.chart.radar":"Graphique radar","sidebar.chart.tree":"Arbre","sidebar.map":"Google Map","sidebar.map.simple":"Carte simple","sidebar.map.styled":"Carte stylée","sidebar.map.geoLocation":"Emplacement géographique","sidebar.map.mapDirection":"Direction de la carte","sidebar.map.overlay":"Superposition de carte","sidebar.map.kmLayer":"Carte Km Layer","sidebar.map.popupInfo":"Map Popup Info","sidebar.map.trafficLayer":"Couche routière","sidebar.map.streetView":"Street View","sidebar.map.eventListener":"Event Listener","sidebar.map.mapDrawing":"Dessin de carte","sidebar.map.mapClustering":"Clustering de carte","sidebar.modules":"Modules","sidebar.calendar":"Calendrier","sidebar.calendar.basic":"De base","sidebar.calendar.cultures":"Des cultures","sidebar.calendar.dnd":"Dnd","sidebar.calendar.popup":"Apparaitre","sidebar.calendar.rendering":"Le rendu","sidebar.calendar.selectable":"Sélectionnable","sidebar.calendar.timeslots":"Tranches de temps","sidebar.eCommerce":"commerce électronique","sidebar.eCommerce.productsList":"Liste de produits","sidebar.eCommerce.productsGrid":"Grille de produits","sidebar.appModule":"Module App","sidebar.appModule.login1":"Connexion Page 1","sidebar.appModule.login2":"Connexion Page 2","sidebar.appModule.loginStepper":"Login with Stepper","sidebar.appModule.signup1":"Inscription Page 1","sidebar.appModule.signup2":"Inscription Page 2","sidebar.appModule.forgotPassword1":"Mot de passe oublié 1","sidebar.appModule.forgotPassword2":"Mot de passe oublié 2","sidebar.appModule.lock1":"Verrouiller l'écran 1","sidebar.appModule.lock2":"Verrouiller l'écran 2","sidebar.appModule.toDo":"Faire","sidebar.appModule.toDoRedux":"To-Do Redux","sidebar.appModule.mail":"Courrier","sidebar.appModule.mailRedux":"Mail Redux","sidebar.appModule.chat":"Bavarder","sidebar.appModule.chatRedux":"Chat Redux","sidebar.appModule.contact":"Contact","sidebar.appModule.contactRedux":"Contactez Redux","sidebar.extras":"Extras","sidebar.icons":"Icônes","sidebar.icons.material":"Icônes de matériel de Google","sidebar.extraElements":"Éléments supplémentaires","sidebar.extraElements.pricingTable":"Tableau de tarification","sidebar.extraElements.callouts":"Légendes","sidebar.extraElements.testimonials":"Témoignages","sidebar.extraPages":"Pages supplémentaires","sidebar.extraPages.aboutUs":"À propos de nous","sidebar.extraPages.contactUs":"Contactez nous","sidebar.extraPages.blog":"Blog","sidebar.extraPages.faq":"FAQ","sidebar.extraPages.portfolio":"Portefeuille","sidebar.extraPages.404":"404 Page d'erreur","sidebar.extraPages.500":"500 page d'erreur","sidebar.menuLevels":"Niveaux de menu","sidebar.menuLevels.level1":"Niveau 1","sidebar.menuLevels.level2":"Niveau 2","sidebar.menuLevels.level3":"Niveau 3","appModule.forgotPassword":"Mot de passe oublié?","appModule.dntRememberEmail":"Vous ne vous souvenez pas de votre email?","appModule.contactSupport":"Contactez le support","appModule.resetPassword":"réinitialiser le mot de passe","appModule.enterPasswordUnlock":"Entrez votre mot de passe pour déverrouiller l'écran!","appModule.unlock":"Ouvrir","appModule.signInDiffAccount":"Connectez-vous en utilisant un compte différent","appModule.rememberMe":"Souviens-toi de moi","appModule.signIn":"Se connecter","appModule.next":"Prochain","appModule.back":"Arrière","appModule.allStepsCompleted":"Toutes les étapes sont terminées","appModule.reset":"Réinitialiser","appModule.loginSuccessfully":"Connectez-vous avec succès","appModule.password":"Mot de passe","appModule.email":"Email","appModule.name":"prénom","appModule.phone":"Téléphone","appModule.designation":"La désignation","appModule.regsiter":"registre","appModule.hvAccount":"Avoir un compte","appModule.createAccount":"Créer un compte","chart.area":"Graphique de secteur","chart.bar":"Graphique à barres","chart.composed":"Graphique composé","chart.line":"Graphique linéaire","chart.pie":"Diagramme circulaire","chart.radar":"Graphique radar","chart.radial":"Graphique radial","chart.scatter":"Scatter Graphique","chart.tree":"Arbre graphique","chat.selectUserChat":"Sélectionnez Utilisateur pour lancer le chat","chat.selectContactChat":"Sélectionnez le contact pour démarrer le chat","chat.chatUser":"Chats","chat.contacts":"Contacts","chat.searchStartNewChat":"Rechercher ou démarrer une nouvelle discussion","chat.typeMessage":"Tapez et appuyez sur Entrée pour envoyer un message","chat.status":"c'est un statut ... pas votre journal ...","contact.saveContact":"Enregistrer le contact","contact.addContact":"Ajouter le contact","contact.searchContact":"Rechercher un contact","button.modify":"Modifier","button.delete":"Effacer","button.yes":"Oui","button.no":"Non","eCommerce.readMore":"Lire la suite","eCommerce.addToCart":"Ajouter au panier","eCommerce.buyNow":"Acheter maintenant","extension.sweetAlerts":"Alertes douces","extension.notification":"Notification","sweetAlerts.basic":"De base","sweetAlerts.description":"Avec description","sweetAlerts.success":"Succès","sweetAlerts.warning":"Attention","sweetAlerts.custom":"Douane","sweetAlerts.htmlTag":"Balise Html","sweetAlerts.prompt":"Rapide","sweetAlerts.itsBlue":"C'est bleu!","sweetAlerts.passwordPrompt":"Invite de mot de passe","sweetAlerts.customStyle":"Style personnalisé","sweetAlerts.itPretty":"C'est joli, n'est-ce pas?","sweetAlerts.btnClicked":"Vous avez cliqué sur le bouton!","sweetAlerts.youWillFind":"Vous trouverez qu'ils sont en place!","sweetAlerts.youWillNotAble":"Vous ne serez pas capable de récupérer ce fichier imaginaire!","sweetAlerts.hereIsaMessage":"Voici un message!","sweetAlerts.goodJob":"Bon travail!","sweetAlerts.yesDeleteIt":"Oui, supprimez-le!","sweetAlerts.areYouSure":"Êtes-vous sûr?","sweetAlerts.doYouLikeThumb":"Aimez-vous les pouces?","sweetAlerts.anInput":"Une entrée!","sweetAlerts.writeSomethingInteresting":"Ecrire quelque chose d'intéressant:","sweetAlerts.writeSomething":"Write something","sweetAlerts.youMustEnterPassword":"Vous devez entrer votre mot de passe!","sweetAlerts.enterPassword":"Entrer le mot de passe","notification.infoMsg":"Message d'information","notification.successMessage":"Message de réussite","notification.warningMessage":"Message d'alerte","notification.closeAfter3000ms":"Fermer après 3000ms","notification.errorMessage":"Message d'erreur","notification.titleHere":"Titre ici","notification.clickMe":"Clique moi!","notification.info":"Info","notification.success":"Succès","notification.warning":"Attention","notification.error":"Erreur","extraElements.callouts":"Légendes","extraElements.pricingTable":"Tableau de tarification","extraElements.testimonials":"Témoignages","callouts.viewRange":"Afficher la plage","callouts.basic":"De base","pricingTable.basic":"De base","pricingTable.circle":"Cercle","pricingTable.classic":"Classique","pricingTable.dark":"Foncé","pricingTable.personal":"PERSONNEL","pricingTable.easyTranslation":"Traduction facile","pricingTable.awesomeGoogleFonts":"Impressionnant Google Fonts","pricingTable.hotelBookingSystem":"Système de réservation d'hôtel","pricingTable.emailComposeInterface":"Email Compose Interface","pricingTable.locationFinderApp":"Application de localisation","pricingTable.buyNow":"Acheter maintenant","pricingTable.business":"ENTREPRISE","pricingTable.professional":"PROFESSIONNEL","testimonials.basic":"De base","testimonials.classic":"Classique","testimonials.standard":"la norme","extraPages.goHome":"Aller à la maison","extraPages.ourClients":"Nos clients","extraPages.all":"Tout","extraPages.graphicDesign":"conception graphique","extraPages.logo":"logo","extraPages.mobileApp":"application mobile","extraPages.web":"web","extraPages.404Msg":"Oups, une erreur s'est produite. Page non trouvée!","extraPages.500Msg":"Désolé, le serveur va mal","extraPages.aboutUs.showCase":"Présentez vos services ici avec des informations à leur sujet","aboutUs.readMore":"Lire la suite","extraPages.goSomewhere":"Aller quelque part","icon.material":"900+ icônes officielles de conception de matériel","mail.mailbox":"Boites aux lettres","mail.compose":"COMPOSER","mail.filters":"Filtres","mail.labels":"LabelsÉtiquettes","picker.color.alpha":"Alpha Pickers","picker.color.hue":"Pickers de teinte","picker.color.circle":"Cueilleurs de cercle","picker.color.compact":"Pickers compacts","picker.color.block":"Ramasseurs de blocs","picker.color.chrome":"Chrome Pickers","picker.color.github":"Github Cueilleurs","picker.color.twitter":"Capteurs Twitter","picker.color.withRedux":"Avec Redux","picker.color.sketch":"Sketch Pickers","picker.color.material":"Ramasseurs de matériel","picker.color.slider":"Sliders Pickers","picker.color.basic":"Cueilleurs de base","picker.color.basicToggle":"Bascule basique","picker.color.custom":"Pickers personnalisés","picker.color.customPointer":"Pointeur personnalisé","picker.color.photoshop":"Photoshop Pickers","picker.color.swatches":"Nuanciers","picker.color.basicPositioning":"Positionnement de base","picker.date.pickers":"Pickers","picker.date.date":"Sélecteurs de date","picker.date.time":"Time Pickers","picker.date.week":"Cueilleurs de la semaine","picker.date.dateNTime":"Sélecteurs de date et d'heure","picker.date.customDate":"Sélecteurs de date et d'heure personnalisés","table.marketingCampaign":"Campagne de marketing","table.thisWeek":"Cette semaine","table.recentOrders":"Dernières commandes","table.dataTable":"Tableau de données","table.basicTable":"Table de base","table.application":"Tableau d'application","todo":"Faire","todo.addTask":"AJOUTER UNE TÂCHE","todo.all":"Tout","todo.filters":"Filtres","todo.labels":"Étiquettes","dashboard.recentActivities":"Activités récentes","dashboard.lastActivity":"Dernière activité il y a 2 jours","dashboard.currentProjects":"Liste des projets en cours","dashboard.toDoItems":"Liste des éléments à faire","dashboard.today":"Aujourd'hui","dashboard.marketingCampaign":"Campagne de marketing","dashboard.yourDailyFeed":"Votre flux quotidien","dashboard.googleInsight":"Score Google Insight","dashboard.lastCalculated":"Las calculé il y a 1 mois","dashboard.refresh":"Rafraîchir","dashboard.upgradeToday":"mettre à jour aujourd'hui","dashboard.onlineSignups":"Inscription en ligne","dashboard.lastMonthSale":"Vente du mois dernier","dashboard.newVisits":"Nouvelles visites ce mois-ci","dashboard.totalRevenue":"Total des revenus cette année","dashboard.latestPosts":"Derniers messages","dashboard.loremIpsum":"Lorem ipsum est le contenu factice dollar sit est ...","dashboard.viewAllPosts":"VOIR TOUS LES POSTES","dashboard.popularProducts":"Produits populaires","dashboard.popularProductsTxt":"C'est un fait établi depuis longtemps qu'un lecteur sera distrait par le contenu lisible.","dashboard.allProducts":"tous les produits","dashboard.userStatstics":"Statistiques de l'utilisateur","dashboard.orders":"Ordres","dashboard.thisYearSaleReport":"Ce rapport de vente d'année","dashboard.post9MonthData":"Post 9 mois de données","dashboard.newCustomers":"nouveaux clients","dashboard.newThisMonth":"32 nouveau ce mois","dashboard.monthly":"Mensuel","dashboard.totalView":"Total View","dashboard.annual":"Annuel","dashboard.newOrder":"nouvel ordre","dashboard.visited":"A visité","dashboard.rapidPace":"Pas rapide","dashboard.slowPace":"Rythme lent","dashboard.newConnections":"Nouvelles connexions","dashboard.thisWeek":"3 Cette semaine","dashboard.newFeed":"23 nouveaux flux","dashboard.newSubscriber":"Nouvel abonné","dashboard.newArticles":"Nouveaux articles","dashboard.newAuthors":"Nouveaux auteurs","dashboard.avgDailyTraffic":"Trafic quotidien moyen","dashboard.popularAuthors":"Auteurs populaires","dashboard.authorsWith":"Auteurs Avec 500+ avg. vue","dashboard.popularArticles":"Articles populaires","dashboard.comments":"commentaires","component.alert.default":"Alertes par défaut","component.alert.highlighted":"Alertes en surbrillance","component.alert.dismissible":"Alertes inadmissibles","component.alert.withIcons":"Alertes avec des icônes","component.alert.withDetailedHTML":"Alerte avec HTML détaillé","component.appbar.simple":"Barre d'application simple","component.appbar.colored":"Barre d'application colorée","component.appbar.fullyFeatured":"Barre d'application entièrement sélectionnée","component.autocomplete.reactSelect":"Réagir Sélectionner","component.autocomplete.reactAutosuggest":"Réagir Autosuggest","component.autocomplete.downshift":"Rétrogradage","component.avatars.image":"Avatars d'images","component.avatars.letter":"Avatars de lettre","component.avatars.icon":"Avatars d'icônes","component.badge.scaling":"Badges d'échelle","component.badge.insideLinks":"Liens intérieurs et boutons","component.badge.contextual":"Variations contextuelles","component.badge.pill":"Badges","component.badge.link":"Badges de liaison","component.bottomNavigation.withLabels":"Navigation par le bas avec des étiquettes","component.bottomNavigation.withActiveLabels":"Navigation inférieure avec étiquette active","component.bottomNavigation.withNoLabels":"Navigation par le bas sans étiquette","component.breadcrumbs.simple":"Simple","component.breadcrumbs.noList":"Pas de liste","component.buttons.colorScheme":"Schéma de couleur","component.buttons.colorSchemeTxt":"Bootstrap Color Scheme avec le concept de matériel","component.buttons.icon":"Boutons d'icône","component.buttons.iconTxt":"Vous pouvez choisir n'importe quelle icône parmi les icônes de polices listées sous la page Icônes. Ou n'hésitez pas à ajouter de nouvelles icônes de polices et utilisez-les.","component.buttons.differentSizes":"Des tailles différentes","component.buttons.differentSizesTxt":"Boutons de matière avec différentes tailles","component.buttons.flatFullWidth":"Boutons plats et pleine largeur","component.buttons.flatFullWidthTxt":"Tous les boutons de type avec des états désactivés","component.buttons.raised":"Boutons surélevés","component.buttons.raisedTxt":"Bootstrap Color Scheme avec le concept de matériel","component.buttons.fab":"Boutons d'action flottants","component.buttons.fabTxt":"Bootstrap Color Scheme avec le concept de matériel","component.buttons.socialMedia":"Boutons de médias sociaux","component.buttons.socialMediaTxt":"Divers boutons de médias sociaux pour votre projet","component.buttons.complex":"Boutons complexes","component.buttonGroup.horizontalVariations":"Variations horizontales","component.buttonGroup.defaultStyle":"Style de groupe de boutons par défaut","component.buttonGroup.highlightedStyle":"Style de groupe de boutons en surbrillance","component.buttonGroup.flatStyle":"Style de groupe bouton plat","component.buttonGroup.default":"Groupe de boutons par défaut","component.buttonGroup.flat":"Groupe de boutons plats","component.buttonGroup.highlighted":"Groupe de boutons en surbrillance","component.buttonGroup.icon":"Groupe de boutons d'icônes","component.buttonGroup.iconFlat":"Groupe de boutons plats","component.buttonGroup.nested":"Groupe de boutons imbriqués","component.cards.basic":"Cartes de base","component.cards.special":"Cartes spéciales","component.cards.withHeader":"Cartes avec en-tête, pied de page et alignement","component.cards.navigational":"Cartes de navigation","component.cards.image":"Cartes d'image","component.cards.solid":"Cartes solides","component.carousel.basic":"Carrousel de base","component.carousel.basicTxt":"Carousel de base de BS4 actionné avec ReactStrap","component.carousel.product":"Carrousel de produit","component.carousel.productTxt":"Un carrousel de vue de grille horizontale","component.carousel.testimonial":"Carousel Témoignage","component.carousel.testimonialTxt":"Un carrousel à la fois","component.chips.default":"Puce par défaut","component.chips.outline":"Puce de contour","component.chips.chipWithText":"Puce avec Avatar texte","component.chips.clickable":"Puce cliquable","component.chips.withImage":"Puce avec Image Avatar","component.chips.deletable":"Puce Deletable","component.chips.withIcon":"Puce avec icône Avatar","component.chips.custom":"Puce Clickable personnalisée","component.chips.array":"Chip Array","component.chips.withInput":"Implémentation de puces avec boîte de saisie","component.dividers.list":"List Diviseurs","component.dividers.inset":"Intercalaires","component.dividers.default":"Défaut","component.drawer.persistent":"Tiroir persistant","component.drawer.permanent":"Tiroir permanent","component.drawer.mini":"Mini tiroir","component.drawer.responsive":"Tiroir réactif","component.expansionPanel.simple":"Panneau d'extension simple","component.expansionPanel.controlled":"Accordéon contrôlé","component.expansionPanel.secondary":"En-tête secondaire et colonnes","component.gridList.image":"Liste de grille d'images uniquement","component.gridList.advanced":"Liste de grille avancée","component.gridList.singleLine":"Liste de grille simple ligne","component.gridList.withTitlebars":"Liste de grille avec des barres de titre","component.lists.folder":"Liste des dossiers","component.lists.switch":"Commuter la liste de contrôle","component.lists.dividers":"List Diviseurs","component.lists.simple":"Liste simple","component.lists.inset":"Liste d'encart","component.lists.nested":"Liste imbriquée","component.lists.checkbox":"Contrôles de liste secondaire de case à cocher","component.lists.checkboxControls":"Contrôles de la liste de cases","component.lists.pinned":"Liste de sous-titres épinglés","component.lists.interactive":"Contrôles interactifs de liste","component.chips":"Récent","component.menusPaper.simple":"Menus simples","component.menusPaper.withIcon":"Menu avec icône","component.menusPaper.withMoreButton":"Menu avec plus de bouton","component.menusPaper.withSelectedValue":"Menu avec la valeur sélectionnée","component.menusPaper.paper":"Papier","component.pickers.Date":"Cueilleurs de date","component.progress.indeterminateCircular":"Circulaire indéterminée","component.progress.determinateCircular":"Circulaire indéterminée...","component.progress.indeterminateLinear":"Linéaire indéterminée","component.progress.determinateLinear":"Déterminé linéaire","component.progress.bufferLinear":"Tampon linéaire","component.progress.interactiveIntegration":"Intégration interactive","component.progress.queryLinear":"Requête linéaire","component.selectionControl.checkboxes":"Cases à cocher","component.selectionControl.disabled":"désactivé","component.selectionControl.intermediate":"Intermédiaire","component.selectionControl.checkboxesWithForm":"Cases à cocher avec groupe de formulaires","component.selectionControl.basicRadio":"Boutons radio de base","component.selectionControl.disabledRadio":"Boutons radio désactivés","component.selectionControl.withError":"Avec un message d'erreur","component.selectionControl.switches":"Commutateurs","component.selectionControl.verticalSwitches":"Commutateurs verticaux","component.selectionControl.groupedSwitches":"Commutateurs groupés","component.selectionControl.verticalImplementation":"Implantation verticale des commutateurs","component.selectionControl.generalSettings":"réglages généraux","component.selectionControl.themeSettings":"Réglage des thèmes","component.selectionControl.onOffSwitches":"interrupteurs marche / arrêt","component.selectionControl.verticalInlineRadio":"Boutons radio verticaux et en ligne","component.selectionControl.checkboxesWithFormTxt":"Les menus sont positionnés sur leurs éléments émetteurs de sorte que l'élément de menu actuellement sélectionné apparaisse au-dessus de l'élément émetteur.","component.selects.simple":"Simple Select","component.selects.native":"Sélection native","component.selects.multiple":"Sélection multiple","component.selects.dialog":"Dialog Select","component.snackbars.transition":"Direction du contrôle de la transition","component.snackbars.simple":"Simple","component.snackbars.positioned":"Positionné","component.snackbars.messageWithButton":"Message avec bouton","component.snackbars.colors":"Couleurs","component.snackbars.multilineText":"Texte multiligne","component.snackbars.onlyMessage":"Seul message","component.snackbars.withIconButton":"Message avec IconButton","component.stepper.horizontalLinear":"Linéaire linéaire","component.stepper.horizontalLinearAlternativeLabel":"Horizontal Linéaire - Étiquette alternative","component.stepper.vertical":"Stepper vertical","component.stepper.horizontalNonLinear":"Horizontal non linéaire","component.stepper.horizontalNonLinearAlternativeLabel":"Horizontal non linéaire - Autre étiquette","component.stepper.mobileDots":"Mobile Stepper - Points","component.stepper.mobileProgress":"Mobile Stepper - Progress","component.stepper.mobileText":"Stepper mobile - Texte","component.tabs.basic":"Onglets de base","component.tabs.fixed":"Onglets fixes pleine largeur","component.tabs.icon":"Icônes","component.tabs.disabled":"Onglet désactivé","component.tabs.wrappedLabels":"Étiquettes enveloppées","component.tabs.iconWithLabel":"Icônes avec étiquette","component.tabs.fixedCentered":"Onglets fixes centrés","component.tabs.automaticScroll":"Boutons de défilement automatiques","component.tabs.forcedScroll":"Boutons de défilement forcé","component.tabs.preventScroll":"Empêcher les boutons de défilement","component.textFields.textfield":"Champ de texte","component.textFields.components":"Composants","component.textFields.layout":"Disposition","component.textFields.inputAdornments":"Adornments d'entrée","component.textFields.formattedInputs":"Entrées formatées","component.textFields.inputs":"Contributions","component.tooltips.avatar":"Avatar Tooltip","component.tooltips.button":"Bouton Info-bulle","component.tooltips.icon":"Icon Tooltip","component.tooltips.controlled":"Info-bulle contrôlée","component.tooltips.positioned":"Info-bulle positionnée","component.typography.lightHeadings":"Rubriques légères","component.typography.normalHeadings":"Rubriques normales","component.typography.semiBoldHeadings":"Rubriques semi-bold","component.typography.boldHeadings":"En-têtes gras","component.typography.paragraphText":"Texte du paragraphe","component.typography.leadParagraphText":"Texte du paragraphe principal","component.typography.unstyledList":"Liste non nommée","component.typography.orderedList":"Liste ordonnée","component.typography.unorderedList":"Liste non ordonnée","component.typography.listWithIcons":"Liste avec des icônes","component.typography.compactList":"Liste compacte","component.typography.extendedList":"Liste étendue","component.typography.leftIconGroupedList":"Liste des icônes de gauche","component.typography.rightIconGroupedList":"Liste groupée des icônes droites","component.typography.badgesGroupedList":"Liste groupée des badges","component.typography.defaultDescriptionList":"Liste de description par défaut","component.typography.evenOddDescriptionList":"Liste de description paire-impaire","component.typography.leftBlockquoteWithAuthorAvatar":"Blocage de gauche avec avatar d'auteur","component.typography.rightBlockquoteWithAuthorAvatar":"Blockquote à droite avec l'avatar de l'auteur","signIn.success":"Connectez-vous avec succès!","signIn.error":"Email ou mot de passe invalide!","signUp.success":"Compte créé avec succès","signUp.error":"Droite","signIn.success1":"Droite","signIn.signUp":"Créer un compte","signIn.connectWith":"ou se connecter avec","signUp.alreadyMember":"Je suis déjà membre","appModule.signin":"Se connecter","appModule.signup":"S'inscrire","pages.samplePage":"Page d'exemple","pages.samplePage.description":"Commencez à construire votre application. Codage heureux!","mailNotification.title":"Messages","appNotification.title":"Notifications","mailNotification.message":"Pas de nouveaux messages à partir de maintenant!","appNotification.message":"Aucune notification pour le moment!","popup.profile":"Profil","popup.setting":"Réglage","popup.logout":"Connectez - Out","popup.updateData":"Mettre à jour","popup.detailedLog":"Journal détaillé","popup.statistics":"Statistiques","popup.clearData":"Effacer les données","component.selectionControl.radioBtnGroup":"Groupe de boutons radio","component.popover.anchorPlayground":"Anchor Playground"}

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _reactRedux = __webpack_require__(30);

var _index = __webpack_require__(548);

var _index2 = __webpack_require__(1349);

var _index3 = _interopRequireDefault(_index2);

var _index4 = __webpack_require__(1524);

var _index5 = _interopRequireDefault(_index4);

var _components = __webpack_require__(1540);

var _components2 = _interopRequireDefault(_components);

var _extensions = __webpack_require__(2038);

var _extensions2 = _interopRequireDefault(_extensions);

var _map = __webpack_require__(2049);

var _map2 = _interopRequireDefault(_map);

var _appModule = __webpack_require__(2050);

var _appModule2 = _interopRequireDefault(_appModule);

var _ActionTypes = __webpack_require__(41);

var _reactDeviceDetect = __webpack_require__(2051);

var _AsyncFunc = __webpack_require__(283);

var _AsyncFunc2 = _interopRequireDefault(_AsyncFunc);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.onToggleCollapsedNav = function () {
            var val = !_this.props.navCollapsed;
            _this.props.toggleCollapsedNav(val);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(App, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                match = _props.match,
                drawerType = _props.drawerType;

            var drawerStyle = drawerType.includes(_ActionTypes.FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

            // set default height and overflow for iOS mobile Safari 10+ support.
            if (_reactDeviceDetect.isIOS && _reactDeviceDetect.isMobile) {
                $('#body').addClass('ios-mobile-view-height');
            } else if ($('#body').hasClass('ios-mobile-view-height')) {
                $('#body').removeClass('ios-mobile-view-height');
            }

            return _react2.default.createElement('div', { className: 'app-container ' + drawerStyle }, _react2.default.createElement(_index5.default, { onToggleCollapsedNav: this.onToggleCollapsedNav.bind(this) }), _react2.default.createElement('div', { className: 'app-main-container' }, _react2.default.createElement('div', { className: 'app-header' }, _react2.default.createElement(_index3.default, { drawerType: drawerType, onToggleCollapsedNav: this.onToggleCollapsedNav })), _react2.default.createElement('main', { className: 'app-main-content-wrapper' }, _react2.default.createElement('div', { className: 'app-main-content' }, _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/components', component: _components2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/extensions', component: _extensions2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/map', component: _map2.default }), _react2.default.createElement(_reactRouterDom.Route, {
                path: match.url + '/widgets',
                component: (0, _AsyncFunc2.default)(function () {
                    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 2093));
                })
            }), _react2.default.createElement(_reactRouterDom.Route, {
                path: match.url + '/metrics',
                component: (0, _AsyncFunc2.default)(function () {
                    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2094));
                })
            }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/app-module', component: _appModule2.default }), _react2.default.createElement(_reactRouterDom.Route, {
                path: match.url + '/contact',
                component: (0, _AsyncFunc2.default)(function () {
                    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2095));
                })
            }), _react2.default.createElement(_reactRouterDom.Route, {
                path: match.url + '/contact-redux',
                component: (0, _AsyncFunc2.default)(function () {
                    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2096));
                })
            })))));
        }
    }]);

    return App;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var settings = _ref2.settings;
    var navCollapsed = settings.navCollapsed,
        drawerType = settings.drawerType;

    return { navCollapsed: navCollapsed, drawerType: drawerType };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, { toggleCollapsedNav: _index.toggleCollapsedNav })(App));

exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(App, 'App', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js');
}();

;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_index3, "_index3", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_index5, "_index5", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_components2, "_components2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_extensions2, "_extensions2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_map2, "_map2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_appModule2, "_appModule2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_AsyncFunc2, "_AsyncFunc2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");

    __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/ToDo.js");
}();

;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(30);

var _AppBar = __webpack_require__(549);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _reactRouterDom = __webpack_require__(39);

var _Toolbar = __webpack_require__(137);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _reactstrap = __webpack_require__(92);

var _ActionTypes = __webpack_require__(41);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _index = __webpack_require__(1377);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1388);

var _index4 = _interopRequireDefault(_index3);

var _Setting = __webpack_require__(240);

var _IntlMessages = __webpack_require__(145);

var _IntlMessages2 = _interopRequireDefault(_IntlMessages);

var _reactBootstrapSweetalert = __webpack_require__(427);

var _reactBootstrapSweetalert2 = _interopRequireDefault(_reactBootstrapSweetalert);

var _awsManager = __webpack_require__(59);

var _SearchModal = __webpack_require__(1522);

var _SearchModal2 = _interopRequireDefault(_SearchModal);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

var _highlightSidebarOption = __webpack_require__(140);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import LanguageSwitcher from 'components/LanguageSwitcher/index';


var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  // mqttClient;
  function Header() {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));

    _this.searchPageNumber = 1;
    _this.getAllNotificationPageNumber = 1;

    _this.onAppNotificationSelect = function () {
      _this.setState({
        appNotification: !_this.state.appNotification
      });
    };

    _this.onLangSwitcherSelect = function (event) {
      _this.setState({
        langSwitcher: !_this.state.langSwitcher,
        anchorEl: event.currentTarget
      });
    };

    _this.onSearchBoxSelect = function () {
      _this.setState({
        searchBox: !_this.state.searchBox
      });
    };

    _this.handleRequestClose = function () {
      _this.setState({
        langSwitcher: false,
        mailNotification: false,
        appNotification: false,
        searchBox: false
      });
    };

    _this.saveDeviceIdAndTimestampToStoreAndNavigateToNotificationsPage = function (deviceId, timestamp) {
      (0, _highlightSidebarOption.highlightNavigatedMenu)("notifications", "#" + _this.currentPath);
      _this.props.history.push("/app/components/notifications");
      _this.props.updateDeviceIdAndSetTimestamp(deviceId, timestamp); // TODO: find out better way to pass props
    };

    _this.clearSearchText = function () {
      _this.setState({
        searchText: ""
      });
    };

    _this.unique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    _this.onButtonClick = function () {
      _this.setState({
        searchModal: ""
      });

      if (_this.state.searchText) {
        (0, _awsManager.searchDevices)(_this.state.searchText, _this.searchPageNumber).then(function (data) {
          if (data.length != 1) {
            var uniqueSearchResults = data.filter(_this.unique);
            _this.setState({
              searchModal: _react2.default.createElement(_SearchModal2.default, {
                clearSearchText: _this.clearSearchText,
                data: uniqueSearchResults,
                defaultText: _this.state.searchText,
                onViewPitClick: _this.updateStoreAndRedirectToHeartbeatPage
              })
            });

            $("#searchModal").modal();
          } else {
            _this.setState({
              searchText: ''
            });
            _this.updateStoreAndRedirectToHeartbeatPage(data[0]);
          }
        }, function () {});
      }
    };

    _this.updateStoreAndRedirectToHeartbeatPage = function (deviceId) {
      _this.props.updateDeviceId(deviceId);
      $("#searchModal").modal("hide");
      if (!(_this.currentPath === "/app/components/heartbeat" || _this.currentPath === "/app/components/notifications")) {
        (0, _highlightSidebarOption.highlightNavigatedMenu)("heartbeat", "#" + _this.currentPath);
        _this.props.history.push("/app/components/heartbeat");
      }
      _this.setState({
        searchModal: false
      });
    };

    _this.handleKeyPress = function (e) {
      if (e.key === "Enter") {
        _this.onButtonClick();
      }
    };

    _this.removeWobbleAndBadge = function () {
      $("#bell-icon").removeClass("icon-alert animated infinite wobble");
    };

    _this.addWobbleAndBadge = function () {
      $("#bell-icon").addClass("icon-alert animated infinite wobble");
    };

    _this.clearNotification = function () {
      _this.setState({
        activeNotifications: [],
        closeNotification: false,
        activeResults: "No Notifications to display"
      });
    };

    _this.onCancelClick = function () {
      _this.setState({
        closeNotification: false
      });
    };

    _this.handleClearNotification = function () {
      _this.setState({
        closeNotification: true
      });
    };

    _this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: "",
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      searchModal: "",
      linkOfLogo: "",
      linkToLogo: "./assets/images/Senstra_logo-2.png",
      notificationTopic: "symbiotic/notification",
      activeNotifications: [],
      activeResults: "",
      closeNotification: false
    };

    _this.onButtonClick.bind(_this);
    _this.updateStoreAndRedirectToHeartbeatPage.bind(_this);
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // getThresholdData(this.props.deviceId).then((data) => {
      //   this.props.updateThresholds(data.Items);
      // });

      this.currentPath = this.props.location.pathname;

      if (this.props.profileInfo.themeToApply !== null) {
        if (this.props.profileInfo.themeToApply === "dark-theme") {
          this.props.setDarkTheme();
          var body = $("#body");
          body.removeClass();
          body.addClass("dark-theme");
        } else {
          this.props.setThemeColor(this.props.profileInfo.themeToApply);
          var _body = $("#body");
          _body.removeClass("dark-theme");
          _body.removeClass();
          _body.addClass(this.props.profileInfo.themeToApply);
        }
      }

      // this.initialiseMQTT();

      $("#bell-icon").on("click", function () {
        return _this2.removeWobbleAndBadge();
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.deviceId !== nextProps.deviceId) {
        // getThresholdData(nextProps.deviceId).then((data) => {
        //   this.props.updateThresholds(data.Items);
        // });
      }

      if (nextProps.linkOfLogo && nextProps.linkOfLogo !== this.state.linkOfLogo) {
        this.setState({
          linkOfLogo: nextProps.linkOfLogo
        });
      }

      if (nextProps.linkToLogo && nextProps.linkToLogo !== this.state.linkToLogo) {
        this.setState({
          linkToLogo: nextProps.linkToLogo
        });
      }

      if (this.props.notificationDeviceId !== nextProps.notificationDeviceId || this.props.notificationTimestamp !== nextProps.notificationTimestamp) {
        this.removeNotificationFromList(nextProps.notificationDeviceId, nextProps.notificationTimestamp);
      }
    }
  }, {
    key: "updateSearchText",
    value: function updateSearchText(evt) {
      this.setState({
        searchText: evt.target.value
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      this.unlisten = this.props.history.listen(function (location) {
        _this3.currentPath = location.pathname;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
      // this.disconnectMQTT();
    }
  }, {
    key: "removeNotificationFromList",

    // initialiseMQTT() {
    //     let header = this;
    //     mqttClientConnect();
    //     header.mqttClient = getMqttClient();
    //     header.registerCallbacks();
    //     authenticate().then(() => {
    //         console.log("## authenticated");
    //         return getNotifications("AllActive", this.getAllNotificationPageNumber, null);
    //     }).then((data) => {
    //         if(data.Items)
    //         {
    //             header.setState({ activeNotifications: data.Items });
    //         }
    //         if (header.state.activeNotifications.length === 0) {
    //             this.setState({
    //                 activeResults: 'No Notifications to display',
    //             });
    //             header.removeWobbleAndBadge();
    //         } else {
    //             this.setState({
    //                 activeResults: '',
    //             });
    //             header.addWobbleAndBadge();
    //         }
    //     }).catch((err) => {
    //         console.error(err);
    //     });
    // }

    value: function removeNotificationFromList(deviceID, timestamp) {
      var currentNotifications = [].concat(_toConsumableArray(this.state.activeNotifications)); // make a separate copy of the array
      currentNotifications = currentNotifications.filter(function (notification) {
        return notification && !(notification.deviceID === deviceID && notification.notificationTimestamp === timestamp);
      });
      this.setState({ activeNotifications: currentNotifications });
    }

    // registerCallbacks = () => {
    //     let header = this;
    //     header.mqttClient.on('connect', () => {
    //         console.log("### connected, subscribing to ", header.state.notificationTopic);
    //         // Subscribe to our current topic.
    //         header.mqttClient.subscribe(header.state.notificationTopic);
    //     });

    //     header.mqttClient.on('message', (topic, payload) => {
    //         try {
    //             console.log("### message", topic);
    //             switch (topic) {
    //                 case header.state.notificationTopic:
    //                     header.addWobbleAndBadge();
    //                     this.setState({
    //                         activeNotifications: [JSON.parse(payload), ...this.state.activeNotifications]
    //                     });
    //                     break;
    //                 default:
    //                     header.props.sendDevicePayload(payload);
    //             }
    //         } catch (e) {
    //             // NOTE: in case of error, we don't want onMessage callback to stop working. Hence catching the error and just logging.
    //             console.error("### Error onMessage ", e);
    //         }
    //     });

    //     header.mqttClient.on('offline', () => {
    //         console.log("### offline");
    //     });

    //     header.mqttClient.on('close', () => {
    //         console.log("### close");
    //     });

    //     header.mqttClient.on('reconnect', () => {
    //         console.log("### reconnect")
    //     });

    //     header.mqttClient.on('error', (e) => {
    //         // console.error("### Error Connecting MQTT Client.", e ? e.toString() : '')
    //     });
    // };

    // disconnectMQTT() {
    //     console.log("### Unsubscribing from ", this.state.notificationTopic);
    //     this.mqttClient.unsubscribe(this.state.notificationTopic);
    //     this.mqttClient.end();
    // }

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          onToggleCollapsedNav = _props.onToggleCollapsedNav,
          drawerType = _props.drawerType;

      var drawerStyle = drawerType.includes(_ActionTypes.FIXED_DRAWER) ? "d-block d-xl-none" : drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) ? "d-block" : "d-none";

      return _react2.default.createElement(_AppBar2.default, { className: "app-main-header" }, _react2.default.createElement(_Toolbar2.default, { className: "app-toolbar", disableGutters: false }, _react2.default.createElement(_reactBootstrapSweetalert2.default, {
        show: this.state.closeNotification,
        style: { color: "black" },
        showCancel: true,
        confirmBtnBsStyle: "primary",
        cancelBtnBsStyle: "primary",
        title: "All notifications have been cleared",
        cancelBtnText: "Cancel",
        confirmBtnText: "OK",
        onCancel: this.onCancelClick,
        onConfirm: this.clearNotification
      }, "Click cancel if you don't want to clear all Notifications."), _react2.default.createElement(_IconButton2.default, {
        className: "jr-menu-icon " + drawerStyle,
        "aria-label": "Menu",
        onClick: onToggleCollapsedNav
      }, _react2.default.createElement("span", { className: "menu-icon text-black" })), _react2.default.createElement("a", { className: "app-logo", href: this.state.linkOfLogo, target: "_blank" }, _react2.default.createElement("img", {
        src: this.state.linkToLogo,
        onError: function onError(e) {
          e.target.src = CONST.DEFAULT_LOGO_IMG;
        }
      })), _react2.default.createElement(_SearchBox2.default, {
        styleName: "d-none d-sm-block",
        placeholder: "Search by Device ID",
        onChange: this.updateSearchText.bind(this),
        value: this.state.searchText,
        onKeyPress: this.handleKeyPress.bind(this),
        onButtonClick: this.onButtonClick
      }), this.state.searchModal, _react2.default.createElement("ul", { className: "header-notifications list-inline ml-auto" }, _react2.default.createElement("li", { className: "d-inline-block d-sm-none list-inline-item" }, _react2.default.createElement(_reactstrap.Dropdown, {
        className: "quick-menu nav-searchbox",
        isOpen: this.state.searchBox,
        toggle: this.onSearchBoxSelect.bind(this)
      }, _react2.default.createElement(_reactstrap.DropdownToggle, {
        className: "d-inline-block",
        tag: "span",
        "data-toggle": "dropdown"
      }, _react2.default.createElement(_IconButton2.default, { className: "icon-btn size-30" }, _react2.default.createElement("i", { className: "icon-color-search zmdi zmdi-search zmdi-hc-fw" }))), _react2.default.createElement(_reactstrap.DropdownMenu, { right: true, className: "p-0" }, _react2.default.createElement(_SearchBox2.default, {
        styleName: "search-dropdown",
        placeholder: "",
        onChange: this.updateSearchText.bind(this),
        value: this.state.searchText,
        onKeyPress: this.handleKeyPress.bind(this),
        onButtonClick: this.onButtonClick
      })))), _react2.default.createElement("li", { className: "list-inline-item" }, _react2.default.createElement(_reactstrap.Dropdown, {
        className: "quick-menu",
        isOpen: this.state.langSwitcher,
        toggle: this.onLangSwitcherSelect.bind(this)
      })), _react2.default.createElement("li", { className: "list-inline-item app-tour" }, _react2.default.createElement("div", { className: "dropdown quick-menu" }, _react2.default.createElement("div", { className: "dropdown-menu pr-1 pl-1" }, _react2.default.createElement(_index4.default, {
        styleName: "align-items-center",
        heading: _react2.default.createElement(_IntlMessages2.default, { id: "appNotification.title" })
      }), _react2.default.createElement(_index2.default, {
        notifications: this.state.activeNotifications,
        onNotificationClick: function onNotificationClick(deviceID, timestamp) {
          _this4.saveDeviceIdAndTimestampToStoreAndNavigateToNotificationsPage(deviceID, timestamp);
        }
      }), this.state.activeNotifications.length ? _react2.default.createElement("div", { className: "clear-Button" }, _react2.default.createElement("a", { onClick: this.handleClearNotification }, "Clear All Notifications")) : _react2.default.createElement("div", { className: "active-results" }, _react2.default.createElement("a", null, this.state.activeResults)))), _react2.default.createElement(_reactstrap.Dropdown, {
        className: "quick-menu",
        isOpen: this.state.appNotification,
        toggle: function toggle() {
          _this4.props.signOut();
          window.open("https://senstra.com.au/platform");
        }
      })))));
    }
  }]);

  return Header;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    signOut: function signOut() {
      dispatch({ type: "SIGN_OUT" });
    },
    updateDeviceId: function updateDeviceId(id) {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateDeviceIdAndSetTimestamp: function updateDeviceIdAndSetTimestamp(deviceId, timestamp) {
      dispatch({
        type: "UPDATE_DEVICE_ID_AND_TIMESTAMP",
        deviceId: deviceId,
        notificationPageTimestampOfElementToHighlight: timestamp
      });
    },
    updateThresholds: function updateThresholds(data) {
      if (data && data[0]) {
        dispatch({ type: "UPDATE_THRESHOLDS", data: data });
      }
    },
    switchLanguage: _Setting.switchLanguage,
    setThemeColor: function setThemeColor(color) {
      dispatch({ type: _ActionTypes.THEME_COLOR, color: color });
    },
    setDarkTheme: function setDarkTheme() {
      dispatch({ type: _ActionTypes.DARK_THEME });
    },
    sendDevicePayload: function sendDevicePayload(payload) {
      dispatch({ type: "DEVICE_PAYLOAD", payload: payload });
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings,
      symbioticReducer = _ref.symbioticReducer,
      profileInfo = _ref.profileInfo;
  var locale = settings.locale;

  return {
    locale: locale,
    deviceId: symbioticReducer.deviceId,
    profileInfo: profileInfo,
    linkOfLogo: symbioticReducer.linkOfLogo,
    linkToLogo: symbioticReducer.linkToLogo,
    notificationDeviceId: symbioticReducer.notificationDeviceId,
    notificationTimestamp: symbioticReducer.notificationTimestamp
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header));

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Header, "Header", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_AppBar2, "_AppBar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_Toolbar2, "_Toolbar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_index4, "_index4", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages2, "_IntlMessages2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_reactBootstrapSweetalert2, "_reactBootstrapSweetalert2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_SearchModal2, "_SearchModal2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_toConsumableArray, "_toConsumableArray", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(Header, "Header", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Paper

var styles = exports.styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box', // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionStatic: {
      position: 'static'
    },
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'position']);


  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalize)(position)], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, component: 'header', elevation: 4, className: className }, other),
    children
  );
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
  /**
   * The positioning type. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes2.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
} : {};

AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAppBar' })(AppBar);

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations['elevation' + index] = {
      boxShadow: shadow
    };
  });

  return (0, _extends3.default)({
    root: {
      backgroundColor: theme.palette.background.paper
    },
    rounded: {
      borderRadius: 2
    }
  }, elevations);
};

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'square', 'elevation']);


   false ? (0, _warning2.default)(elevation >= 0 && elevation < 25, 'Material-UI: this elevation `' + elevation + '` is not implemented.') : void 0;

  var className = (0, _classnames2.default)(classes.root, classes['elevation' + elevation], (0, _defineProperty3.default)({}, classes.rounded, !square), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes2.default.number,
  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes2.default.bool
} : {};

Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPaper' })(Paper);

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.mixins.toolbar, {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }),
    gutters: theme.mixins.gutters()
  };
};

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableGutters']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.gutters, !disableGutters), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes2.default.bool
} : {};

Toolbar.defaultProps = {
  disableGutters: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiToolbar' })(Toolbar);

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: 48,
      height: 48,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      })
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};

/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */
function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled']);


  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), className),
      centerRipple: true,
      focusRipple: true,
      disabled: disabled
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      children
    )
  );
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes2.default.bool
} : {};

IconButton.defaultProps = {
  color: 'default',
  disabled: false,
  disableRipple: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIconButton' })(IconButton);

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _ownerWindow = __webpack_require__(241);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _keyboardFocus = __webpack_require__(1355);

var _TouchRipple = __webpack_require__(1356);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _createRippleHandler = __webpack_require__(1366);

var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent', // Reset default value
    outline: 'none',
    border: 0,
    margin: 0, // Remove the margin in Safari
    borderRadius: 0,
    padding: 0, // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none', // Reset
    '-webkit-appearance': 'none', // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.
    }
  },
  disabled: {
    pointerEvents: 'none', // Disable link interactions
    cursor: 'default'
  },
  keyboardFocused: {}
};

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = function (_React$Component) {
  (0, _inherits3.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      keyboardFocused: false
    }, _this.onKeyboardFocusHandler = function (event) {
      _this.keyDown = false;
      _this.setState({ keyboardFocused: true });

      if (_this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event);
      }
    }, _this.onRippleRef = function (node) {
      _this.ripple = node;
    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 50, _this.keyboardFocusMaxCheckTimes = 5, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;

      var key = (0, _keycode2.default)(event);

      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();
        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      }

      // Keyboard accessibility for non interactive elements
      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        if (onClick) {
          onClick(event);
        }
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.ripple && _this.state.keyboardFocused) {
        _this.keyDown = false;
        event.persist();
        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      if (_this.state.keyboardFocused) {
        _this.setState({ keyboardFocused: false });
      }
    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
      if (_this.state.keyboardFocused) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleTouchMove = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      _this.setState({ keyboardFocused: false });
    }), _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }

      // Fix for https://github.com/facebook/react/issues/7769
      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _keyboardFocus.detectKeyboardFocus)(_this, _this.button, function () {
        _this.onKeyboardFocusHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.button = (0, _reactDom.findDOMNode)(this);
      (0, _keyboardFocus.listenForFocusKeys)((0, _ownerWindow2.default)(this.button));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!this.props.disabled && nextProps.disabled && this.state.keyboardFocused) {
        this.setState({
          keyboardFocused: false
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.keyboardFocused && this.state.keyboardFocused) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.keyboardFocusTimeout);
    } // Used to help track keyboard activation keyDown

  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          buttonRef = _props.buttonRef,
          centerRipple = _props.centerRipple,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          component = _props.component,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          focusRipple = _props.focusRipple,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onKeyboardFocus = _props.onKeyboardFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onTouchEnd = _props.onTouchEnd,
          onTouchMove = _props.onTouchMove,
          onTouchStart = _props.onTouchStart,
          tabIndex = _props.tabIndex,
          TouchRippleProps = _props.TouchRippleProps,
          type = _props.type,
          other = (0, _objectWithoutProperties3.default)(_props, ['buttonRef', 'centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'tabIndex', 'TouchRippleProps', 'type']);


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.keyboardFocused, this.state.keyboardFocused), _classNames), classNameProp);

      var buttonProps = {};

      var ComponentProp = component;

      if (!ComponentProp) {
        if (other.href) {
          ComponentProp = 'a';
        } else {
          ComponentProp = 'button';
        }
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react2.default.createElement(
        ComponentProp,
        (0, _extends3.default)({
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onMouseUp: this.handleMouseUp,
          onTouchEnd: this.handleTouchEnd,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          tabIndex: disabled ? '-1' : tabIndex,
          className: className,
          ref: buttonRef
        }, buttonProps, other),
        children,
        !disableRipple && !disabled ? _react2.default.createElement(_TouchRipple2.default, (0, _extends3.default)({ innerRef: this.onRippleRef, center: centerRipple }, TouchRippleProps)) : null
      );
    }
  }]);
  return ButtonBase;
}(_react2.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes2.default.func,
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes2.default.func,
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  type: _propTypes2.default.string
} : {};

ButtonBase.defaultProps = {
  centerRipple: false,
  disableRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButtonBase' })(ButtonBase);

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusKeyPressed = focusKeyPressed;
exports.detectKeyboardFocus = detectKeyboardFocus;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(242);

var _contains2 = _interopRequireDefault(_contains);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var internal = {
  focusKeyPressed: false
};

function focusKeyPressed(pressed) {
  if (typeof pressed !== 'undefined') {
    internal.focusKeyPressed = Boolean(pressed);
  }

  return internal.focusKeyPressed;
}

function detectKeyboardFocus(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

   false ? (0, _warning2.default)(instance.keyboardFocusCheckTime, 'Material-UI: missing instance.keyboardFocusCheckTime') : void 0;
   false ? (0, _warning2.default)(instance.keyboardFocusMaxCheckTimes, 'Material-UI: missing instance.keyboardFocusMaxCheckTimes') : void 0;

  instance.keyboardFocusTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument2.default)(element);

    if (focusKeyPressed() && (doc.activeElement === element || (0, _contains2.default)(element, doc.activeElement))) {
      callback();
    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
      detectKeyboardFocus(instance, element, callback, attempt + 1);
    }
  }, instance.keyboardFocusCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true;
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.DELAY_RIPPLE = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(160);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(1362);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Ripple = __webpack_require__(1364);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DURATION = 550;
var DELAY_RIPPLE = exports.DELAY_RIPPLE = 80;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    ripplePulsate: {
      animationDuration: theme.transitions.duration.shorter + 'ms'
    },
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      background: 'currentColor'
    },
    childLeaving: {
      opacity: 0,
      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: 'mui-ripple-pulsate 2500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite'
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

/**
 * @ignore - internal component.
 */

var TouchRipple = function (_React$Component) {
  (0, _inherits3.default)(TouchRipple, _React$Component);

  function TouchRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TouchRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextKey: 0,
      ripples: []
    }, _this.ignoringMouseDown = false, _this.startTimer = null, _this.startTimerCommit = null, _this.pulsate = function () {
      _this.start({}, { pulsate: true });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments[2];
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === undefined ? false : _options$fakeElement;


      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom2.default.findDOMNode(_this);
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };

      // Get the size of the ripple
      var rippleX = void 0;
      var rippleY = void 0;
      var rippleSize = void 0;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

        // For some reason the animation is broken on Mobile Chrome if the size if even.
        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      }

      // Touche devices
      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
        };
        // Deplay the execution of the ripple effect.
        _this.startTimer = setTimeout(function () {
          _this.startTimerCommit();
          _this.startTimerCommit = null;
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
      }
    }, _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      var ripples = _this.state.ripples;

      // Add a ripple to the ripples array.
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
        key: _this.state.nextKey,
        classes: _this.props.classes,
        timeout: {
          exit: DURATION,
          enter: DURATION
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);

      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    }, _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples;

      // The touch interaction occures to quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();
        _this.startTimerCommit();
        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }

    // Used to filter out mouse emulated events on mobile.

    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.

    // This is the hook called once the previous timeout is ready.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          center = _props.center,
          classes = _props.classes,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);


      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({
          component: 'span',
          enter: true,
          exit: true,
          className: (0, _classnames2.default)(classes.root, className)
        }, other),
        this.state.ripples
      );
    }
  }]);
  return TouchRipple;
}(_react2.default.Component);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

TouchRipple.defaultProps = {
  center: false
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiTouchRipple' })(TouchRipple);

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1358), __esModule: true };

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
__webpack_require__(1359);
module.exports = __webpack_require__(45).Array.from;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(131);
var $export = __webpack_require__(50);
var toObject = __webpack_require__(135);
var call = __webpack_require__(528);
var isArrayIter = __webpack_require__(529);
var toLength = __webpack_require__(227);
var createProperty = __webpack_require__(1360);
var getIterFn = __webpack_require__(530);

$export($export.S + $export.F * !__webpack_require__(1361)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(74);
var createDesc = __webpack_require__(186);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(66)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(550);

var _ChildMapping = __webpack_require__(1363);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Transition = __webpack_require__(161);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var Ripple = function (_React$Component) {
  (0, _inherits3.default)(Ripple, _React$Component);

  function Ripple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ripple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: false,
      leaving: false
    }, _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    }, _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ripple, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          pulsate = _props.pulsate,
          rippleX = _props.rippleX,
          rippleY = _props.rippleY,
          rippleSize = _props.rippleSize,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
      var _state = this.state,
          visible = _state.visible,
          leaving = _state.leaving;


      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty3.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);

      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };

      var childClassName = (0, _classnames2.default)(classes.child, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty3.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
        _react2.default.createElement(
          'span',
          { className: rippleClassName, style: rippleStyles },
          _react2.default.createElement('span', { className: childClassName })
        )
      );
    }
  }]);
  return Ripple;
}(_react2.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes2.default.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes2.default.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes2.default.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes2.default.number
} : {};

Ripple.defaultProps = {
  pulsate: false
};

exports.default = Ripple;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    if (event.defaultPrevented) {
      return false;
    }

    if (instance.ripple) {
      instance.ripple[action](event);
    }

    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
      instance.props['on' + eventName](event);
    }

    return true;
  };
}

exports.default = createRippleHandler;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(1370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(1371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(1372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(1374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(1373);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _NotificationItem = __webpack_require__(1378);

var _NotificationItem2 = _interopRequireDefault(_NotificationItem);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var AppNotification = function AppNotification(_ref) {
    var notifications = _ref.notifications,
        _onNotificationClick = _ref.onNotificationClick;

    $('.messages-list').slimscroll({
        height: '280px'
    });
    return _react2.default.createElement("div", { className: "messages-list" }, _react2.default.createElement("ul", { className: "list-unstyled" }, notifications && notifications.map && notifications.map(function (notification, index) {
        return _react2.default.createElement(_NotificationItem2.default, { key: index, notification: notification,
            onNotificationClick: function onNotificationClick(deviceID, timestamp) {
                _onNotificationClick(deviceID, timestamp);
            } });
    })));
};

AppNotification.propTypes = {
    notifications: _propTypes2.default.array.isRequired,
    onNotificationClick: _propTypes2.default.func.isRequired
};

var _default = AppNotification;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(AppNotification, "AppNotification", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(_NotificationItem2, "_NotificationItem2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(_propTypes2, "_propTypes2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(AppNotification, "AppNotification", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Avatar = __webpack_require__(356);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _util = __webpack_require__(77);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var NotificationItem = function NotificationItem(_ref) {
    var notification = _ref.notification,
        onNotificationClick = _ref.onNotificationClick;
    var notificationType = notification.notificationType,
        description = notification.description,
        deviceID = notification.deviceID,
        notificationTimestampActive = notification.notificationTimestampActive;

    return _react2.default.createElement('li', { className: 'media', onClick: function onClick() {
            return onNotificationClick(deviceID, notificationTimestampActive);
        } }, _react2.default.createElement(_Avatar2.default, {
        alt: notificationType,
        src: (0, _util.getImageSourceFromType)(notificationType),
        className: ' mr-2'
    }), _react2.default.createElement('div', { className: 'media-body align-self-center' }, _react2.default.createElement('p', { className: 'sub-heading mb-0' }, description), _react2.default.createElement('span', { className: 'meta-date float-left' }, _react2.default.createElement('small', null, deviceID)), _react2.default.createElement('span', { className: 'meta-date float-right' }, _react2.default.createElement('small', null, (0, _util.getFormattedDate)(notificationTimestampActive, false)))));
};

NotificationItem.propTypes = {
    notification: _propTypes2.default.object.isRequired,
    onNotificationClick: _propTypes2.default.func.isRequired
};

var _default = NotificationItem;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(NotificationItem, 'NotificationItem', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(_Avatar2, '_Avatar2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(_propTypes2, '_propTypes2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(NotificationItem, 'NotificationItem', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/AppNotification/NotificationItem.js');
}();

;

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(554);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" /* default */])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" /* default */])(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["classNames"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["d" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* harmony default export */ __webpack_exports__["a"] = (CSSTransition);

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(1381);

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!Object(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" /* default */])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasClass;
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(555);






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" /* default */], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ReplaceTransition);

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildMapping;
/* unused harmony export mergeChildMappings */
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialChildMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextChildMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(359);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */]:
        component = current;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" /* default */].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ __webpack_exports__["a"] = (SwitchTransition);

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notification = /*#__PURE__*/function (_React$Component) {
  _inherits(Notification, _React$Component);

  var _super = _createSuper(Notification);

  function Notification() {
    var _this;

    _classCallCheck(this, Notification);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var timeOut = _this.props.timeOut;

      if (timeOut !== 0) {
        _this.timer = setTimeout(_this.requestHide, timeOut);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }

      _this.requestHide();
    });

    _defineProperty(_assertThisInitialized(_this), "requestHide", function () {
      var onRequestHide = _this.props.onRequestHide;

      if (onRequestHide) {
        onRequestHide();
      }
    });

    return _this;
  }

  _createClass(Notification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          message = _this$props.message;
      var title = this.props.title;
      var className = (0, _classnames.default)(['notification', "notification-".concat(type)]);
      title = title ? /*#__PURE__*/_react.default.createElement("h4", {
        className: "title"
      }, title) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "notification-message",
        role: "alert"
      }, title, /*#__PURE__*/_react.default.createElement("div", {
        className: "message"
      }, message)));
    }
  }]);

  return Notification;
}(_react.default.Component);

_defineProperty(Notification, "propTypes", {
  type: _propTypes.default.oneOf(['info', 'success', 'warning', 'error']),
  title: _propTypes.default.node,
  message: _propTypes.default.node,
  timeOut: _propTypes.default.number,
  onClick: _propTypes.default.func,
  onRequestHide: _propTypes.default.func
});

_defineProperty(Notification, "defaultProps", {
  type: 'info',
  title: null,
  message: null,
  timeOut: 5000,
  onClick: function onClick() {},
  onRequestHide: function onRequestHide() {}
});

var _default = Notification;
exports.default = _default;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _NotificationManager = _interopRequireDefault(__webpack_require__(556));

var _Notifications = _interopRequireDefault(__webpack_require__(552));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationContainer, _React$Component);

  var _super = _createSuper(NotificationContainer);

  function NotificationContainer() {
    var _this;

    _classCallCheck(this, NotificationContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      notifications: []
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _NotificationManager.default.addChangeListener(_this.handleStoreChange);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _NotificationManager.default.removeChangeListener(_this.handleStoreChange);
    });

    _defineProperty(_assertThisInitialized(_this), "handleStoreChange", function (notifications) {
      _this.setState({
        notifications: notifications
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
      _NotificationManager.default.remove(notification);
    });

    return _this;
  }

  _createClass(NotificationContainer, [{
    key: "render",
    value: function render() {
      var notifications = this.state.notifications;
      var _this$props = this.props,
          enterTimeout = _this$props.enterTimeout,
          leaveTimeout = _this$props.leaveTimeout;
      return /*#__PURE__*/_react.default.createElement(_Notifications.default, {
        enterTimeout: enterTimeout,
        leaveTimeout: leaveTimeout,
        notifications: notifications,
        onRequestHide: this.handleRequestHide
      });
    }
  }]);

  return NotificationContainer;
}(_react.default.Component);

_defineProperty(NotificationContainer, "propTypes", {
  enterTimeout: _propTypes.default.number,
  leaveTimeout: _propTypes.default.number
});

_defineProperty(NotificationContainer, "defaultProps", {
  enterTimeout: 400,
  leaveTimeout: 400
});

var _default = NotificationContainer;
exports.default = _default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _CardMenu = __webpack_require__(1389);

var _CardMenu2 = _interopRequireDefault(_CardMenu);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CardHeader = function (_React$Component) {
    _inherits(CardHeader, _React$Component);

    function CardHeader() {
        _classCallCheck(this, CardHeader);

        var _this = _possibleConstructorReturn(this, (CardHeader.__proto__ || Object.getPrototypeOf(CardHeader)).call(this));

        _this.onOptionMenuSelect = function (event) {
            _this.setState({ menuState: true, anchorEl: event.currentTarget });
        };

        _this.handleRequestClose = function () {
            _this.setState({ menuState: false });
        };

        _this.state = {
            anchorEl: undefined,
            menuState: false
        };
        return _this;
    }

    _createClass(CardHeader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                heading = _props.heading,
                subHeading = _props.subHeading;
            var styleName = this.props.styleName;
            var _state = this.state,
                anchorEl = _state.anchorEl,
                menuState = _state.menuState;

            return _react2.default.createElement('div', { className: 'jr-card-header d-flex ' + styleName }, _react2.default.createElement('div', { className: 'mr-auto' }, _react2.default.createElement('h3', { className: 'card-heading' }, heading), subHeading && _react2.default.createElement('p', { className: 'sub-heading' }, subHeading)));
        }
    }]);

    return CardHeader;
}(_react2.default.Component);

var _default = CardHeader;
exports.default = _default;

CardHeader.defaultProps = {
    styleName: '',
    subHeading: ''
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(CardHeader, 'CardHeader', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_CardMenu2, "_CardMenu2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(CardHeader, "CardHeader", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardHeader/index.js");
}();

;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Menu = __webpack_require__(203);

var _Menu2 = _interopRequireDefault(_Menu);

var _IntlMessages = __webpack_require__(145);

var _IntlMessages2 = _interopRequireDefault(_IntlMessages);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CardMenu = function (_React$Component) {
    _inherits(CardMenu, _React$Component);

    function CardMenu() {
        _classCallCheck(this, CardMenu);

        return _possibleConstructorReturn(this, (CardMenu.__proto__ || Object.getPrototypeOf(CardMenu)).apply(this, arguments));
    }

    _createClass(CardMenu, [{
        key: 'render',
        value: function render() {
            var ITEM_HEIGHT = 40;
            var options = [_react2.default.createElement(_IntlMessages2.default, { id: 'popup.updateData' }), _react2.default.createElement(_IntlMessages2.default, { id: 'popup.detailedLog' }), _react2.default.createElement(_IntlMessages2.default, { id: 'popup.statistics' }), _react2.default.createElement(_IntlMessages2.default, { id: 'popup.clearData' })];
            var _props = this.props,
                menuState = _props.menuState,
                anchorEl = _props.anchorEl,
                handleRequestClose = _props.handleRequestClose;

            return _react2.default.createElement(_Menu2.default, { id: 'long-menu',
                anchorEl: anchorEl,
                open: menuState,
                onClose: handleRequestClose,
                style: { maxHeight: ITEM_HEIGHT * 4.5 },
                MenuListProps: {
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    }
                } }, options.map(function (option) {
                return _react2.default.createElement(_Menu.MenuItem, { key: option, onClick: handleRequestClose }, option);
            }));
        }
    }]);

    return CardMenu;
}(_react2.default.Component);

var _default = CardMenu;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(CardMenu, 'CardMenu', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_Menu2, "_Menu2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_IntlMessages2, "_IntlMessages2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(CardMenu, "CardMenu", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/dashboard/Common/CardMenu.js");
}();

;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(242);

var _contains2 = _interopRequireDefault(_contains);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(241);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Modal = __webpack_require__(244);

var _Modal2 = _interopRequireDefault(_Modal);

var _Grow = __webpack_require__(568);

var _Grow2 = _interopRequireDefault(_Grow);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
} // @inheritedComponent Modal

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? n + 'px' : n;
  }).join(' ');
}

// Sum the scrollTop between two elements.
function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }
  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = exports.styles = {
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 32px)',
    '&:focus': {
      outline: 'none'
    }
  }
};

var Popover = function (_React$Component) {
  (0, _inherits3.default)(Popover, _React$Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillUnmount = function () {
      _this.handleResize.cancel();
    }, _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);
        element.style.top = positioning.top;
        element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
      }
    }, _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          marginThreshold = _this$props.marginThreshold;

      // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);
      // Get the offset of of the anchoring element
      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      };
      // Get the transform origin point on the element itself
      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      // Calculate element positioning
      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width;

      // Use the parent window of the anchorEl if provided
      var containerWindow = (0, _ownerWindow2.default)(getAnchorEl(anchorEl));

      // Window thresholds taking required margin into account
      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold;

      // Check if the vertical axis needs shifting
      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;
        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning2.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', 'Some part of it can not be seen on the screen (' + (elemRect.height - heightThreshold) + 'px).', 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0;

      // Check if the horizontal axis needs shifting
      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;
        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;
        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: top + 'px',
        left: left + 'px',
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    }, _this.transitionEl = undefined, _this.handleGetOffsetTop = getOffsetTop, _this.handleGetOffsetLeft = getOffsetLeft, _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    }, _this.handleResize = (0, _debounce2.default)(function () {
      var element = _reactDom2.default.findDOMNode(_this.transitionEl);
      _this.setPositioningStyles(element);
    }, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: 'getAnchorOffset',


    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _props = this.props,
          anchorEl = _props.anchorEl,
          anchorOrigin = _props.anchorOrigin,
          anchorReference = _props.anchorReference,
          anchorPosition = _props.anchorPosition;


      if (anchorReference === 'anchorPosition') {
        return anchorPosition;
      }

      // If an anchor element wasn't provided, just use the parent body element of this Popover
      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(this.transitionEl)).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';

      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    }

    // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: 'getContentAnchorOffset',
    value: function getContentAnchorOffset(element) {
      var _props2 = this.props,
          getContentAnchorEl = _props2.getContentAnchorEl,
          anchorReference = _props2.anchorReference;

      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && (0, _contains2.default)(element, contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        }

        // != the default value
         false ? (0, _warning2.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or left `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    }

    // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: 'getTransformOrigin',
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;

      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: 'render',
    // Corresponds to 10 frames at 60 Hz.

    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          action = _props3.action,
          anchorEl = _props3.anchorEl,
          anchorOrigin = _props3.anchorOrigin,
          anchorPosition = _props3.anchorPosition,
          anchorReference = _props3.anchorReference,
          children = _props3.children,
          classes = _props3.classes,
          containerProp = _props3.container,
          elevation = _props3.elevation,
          getContentAnchorEl = _props3.getContentAnchorEl,
          marginThreshold = _props3.marginThreshold,
          onEnter = _props3.onEnter,
          onEntered = _props3.onEntered,
          onEntering = _props3.onEntering,
          onExit = _props3.onExit,
          onExited = _props3.onExited,
          onExiting = _props3.onExiting,
          open = _props3.open,
          PaperProps = _props3.PaperProps,
          role = _props3.role,
          transformOrigin = _props3.transformOrigin,
          TransitionProp = _props3.transition,
          transitionDuration = _props3.transitionDuration,
          other = (0, _objectWithoutProperties3.default)(_props3, ['action', 'anchorEl', 'anchorOrigin', 'anchorPosition', 'anchorReference', 'children', 'classes', 'container', 'elevation', 'getContentAnchorEl', 'marginThreshold', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'role', 'transformOrigin', 'transition', 'transitionDuration']);

      // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container

      var container = containerProp || (anchorEl ? (0, _ownerDocument2.default)(getAnchorEl(anchorEl)).body : undefined);

      var transitionProps = {};
      // The provided transition might not support the auto timeout value.
      if (TransitionProp === _Grow2.default) {
        transitionProps.timeout = transitionDuration;
      }

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ container: container, open: open, BackdropProps: { invisible: true } }, other),
        _react2.default.createElement(
          TransitionProp,
          (0, _extends3.default)({
            appear: true,
            'in': open,
            onEnter: this.handleEnter,
            onEntered: onEntered,
            onEntering: onEntering,
            onExit: onExit,
            onExited: onExited,
            onExiting: onExiting,
            role: role,
            ref: function ref(node) {
              _this2.transitionEl = node;
            }
          }, transitionProps),
          _react2.default.createElement(
            _Paper2.default,
            (0, _extends3.default)({
              className: classes.paper,

              elevation: elevation
            }, PaperProps),
            _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
            children
          )
        )
      );
    }
  }]);
  return Popover;
}(_react2.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    left: _propTypes2.default.number
  }),
  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes2.default.oneOf(['anchorEl', 'anchorPosition']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it's using the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * The elevation of the popover.
   */
  elevation: _propTypes2.default.number,
  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes2.default.func,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes2.default.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  transition: _Grow2.default,
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPopover' })(Popover);

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(49);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1393);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 1393 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(172);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1395 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(561);

var assertThisInitialized = __webpack_require__(1399);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

module.exports = _inherits;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1403);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _activeElement = __webpack_require__(562);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(242);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(243);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _RefHolder = __webpack_require__(563);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _Portal = __webpack_require__(564);

var _Portal2 = _interopRequireDefault(_Portal);

var _addEventListener = __webpack_require__(1407);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _helpers = __webpack_require__(35);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ModalManager = __webpack_require__(565);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Backdrop = __webpack_require__(567);

var _Backdrop2 = _interopRequireDefault(_Backdrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
} // @inheritedComponent Portal

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      height: '100%',
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      top: 0,
      left: 0
    },
    hidden: {
      visibility: 'hidden'
    }
  };
};

var Modal = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal(props, context) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props, context));

    _this.dialog = null;
    _this.mounted = false;
    _this.mountNode = null;

    _this.handleRendered = function () {
      _this.autoFocus();

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument2.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add(_this, container);
      _this.onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this.handleDocumentKeyDown);
      _this.onFocusinListener = (0, _addEventListener2.default)(doc, 'focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove(_this);
      _this.onDocumentKeydownListener.remove();
      _this.onFocusinListener.remove();
      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({ exited: true });
      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode2.default)(event) !== 'esc') {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      if (_inDOM2.default) {
        _this.lastFocus = (0, _activeElement2.default)();
      }
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var dialogElement = _this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this.mountNode));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        dialogElement.focus();
      }
    };

    _this.state = {
      exited: !_this.props.open
    };
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open) {
        this.setState({ exited: false });
      } else if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.checkForFocus();
      }

      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: 'getDialogElement',
    value: function getDialogElement() {
      return _reactDom2.default.findDOMNode(this.dialog);
    }
  }, {
    key: 'autoFocus',
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var dialogElement = this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this.mountNode));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!dialogElement.hasAttribute('tabIndex')) {
           false ? (0, _warning2.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          dialogElement.setAttribute('tabIndex', -1);
        }

        dialogElement.focus();
      }
    }
  }, {
    key: 'restoreLastFocus',
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        this.lastFocus.focus();
        this.lastFocus = null;
      }
    }
  }, {
    key: 'isTopModal',
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          BackdropComponent = _props.BackdropComponent,
          BackdropProps = _props.BackdropProps,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          container = _props.container,
          disableAutoFocus = _props.disableAutoFocus,
          disableBackdropClick = _props.disableBackdropClick,
          disableEnforceFocus = _props.disableEnforceFocus,
          disableEscapeKeyDown = _props.disableEscapeKeyDown,
          disableRestoreFocus = _props.disableRestoreFocus,
          hideBackdrop = _props.hideBackdrop,
          keepMounted = _props.keepMounted,
          onBackdropClick = _props.onBackdropClick,
          onClose = _props.onClose,
          onEscapeKeyDown = _props.onEscapeKeyDown,
          onRendered = _props.onRendered,
          open = _props.open,
          manager = _props.manager,
          other = (0, _objectWithoutProperties3.default)(_props, ['BackdropComponent', 'BackdropProps', 'children', 'classes', 'className', 'container', 'disableAutoFocus', 'disableBackdropClick', 'disableEnforceFocus', 'disableEscapeKeyDown', 'disableRestoreFocus', 'hideBackdrop', 'keepMounted', 'onBackdropClick', 'onClose', 'onEscapeKeyDown', 'onRendered', 'open', 'manager']);
      var exited = this.state.exited;

      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      // It's a Transition like component
      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react2.default.createElement(
        _Portal2.default,
        {
          ref: function ref(node) {
            _this2.mountNode = node ? node.getMountNode() : node;
          },
          container: container,
          onRendered: this.handleRendered
        },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({
            className: (0, _classnames2.default)(classes.root, className, (0, _defineProperty3.default)({}, classes.hidden, exited))
          }, other),
          hideBackdrop ? null : _react2.default.createElement(BackdropComponent, (0, _extends3.default)({ open: open, onClick: this.handleBackdropClick }, BackdropProps)),
          _react2.default.createElement(
            _RefHolder2.default,
            {
              ref: function ref(node) {
                _this2.dialog = node;
              }
            },
            _react2.default.cloneElement(children, childProps)
          )
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. Useful for custom backdrop rendering.
   */
  BackdropComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `Backdrop` element.
   */
  BackdropProps: _propTypes2.default.object,
  /**
   * A single child content element.
   */
  children: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes2.default.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes2.default.bool,
  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes2.default.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes2.default.bool,
  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes2.default.bool,
  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes2.default.bool,
  /**
   * A modal manager used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container.
   */
  manager: _propTypes2.default.object,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes2.default.func,
  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes2.default.func,
  /**
   * If `true`, the modal is open.
   */
  open: _propTypes2.default.bool.isRequired
} : {};

Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager2.default(),
  BackdropComponent: _Backdrop2.default
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiModal' })(Modal);

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _exactProp = __webpack_require__(190);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

/**
 * This component shares many concepts with
 * [react-overlays](https://react-bootstrap.github.io/react-overlays/#portals)
 * But has been forked in order to fix some bugs, reduce the number of dependencies
 * and take the control of our destiny.
 */

var Portal = function (_React$Component) {
  (0, _inherits3.default)(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return _this.mountNode;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setContainer(this.props.container);
      this.forceUpdate(this.props.onRendered);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.container !== this.props.container) {
        this.setContainer(nextProps.container);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: 'setContainer',
    value: function setContainer(container) {
      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }

    /**
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return this.mountNode ? _reactDom2.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react2.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it's using the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes2.default.func
} : {};

Portal.propTypes =  false ? (0, _exactProp2.default)(Portal.propTypes, 'Portal') : {};

exports.default = Portal;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _exactProp = __webpack_require__(190);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

/**
 * @ignore - internal component.
 *
 * This module will soon be gone. We should drop it as soon as react@15.x support stop.
 */

var LegacyPortal = function (_React$Component) {
  (0, _inherits3.default)(LegacyPortal, _React$Component);

  function LegacyPortal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LegacyPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LegacyPortal.__proto__ || (0, _getPrototypeOf2.default)(LegacyPortal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return _this.mountNode;
    }, _this.mountOverlayTarget = function () {
      if (!_this.overlayTarget) {
        _this.overlayTarget = document.createElement('div');
        _this.mountNode = getContainer(_this.props.container, getOwnerDocument(_this).body);
        _this.mountNode.appendChild(_this.overlayTarget);
      }
    }, _this.unmountOverlayTarget = function () {
      if (_this.overlayTarget) {
        _this.mountNode.removeChild(_this.overlayTarget);
        _this.overlayTarget = null;
      }
      _this.mountNode = null;
    }, _this.unrenderOverlay = function () {
      if (_this.overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this.overlayTarget);
        _this.overlayInstance = null;
      }
    }, _this.renderOverlay = function () {
      var overlay = _this.props.children;
      _this.mountOverlayTarget();
      var initialRender = !_this.overlayInstance;
      _this.overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this.overlayTarget, function () {
        if (initialRender && _this.props.onRendered) {
          _this.props.onRendered();
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LegacyPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.renderOverlay();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.overlayTarget && nextProps.container !== this.props.container) {
        this.mountNode.removeChild(this.overlayTarget);
        this.mountNode = getContainer(nextProps.container, getOwnerDocument(this).body);
        this.mountNode.appendChild(this.overlayTarget);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderOverlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.unrenderOverlay();
      this.unmountOverlayTarget();
    }

    /**
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return LegacyPortal;
}(_react2.default.Component);

LegacyPortal.propTypes =  false ? {
  children: _propTypes2.default.element.isRequired,
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  onRendered: _propTypes2.default.func
} : {};

LegacyPortal.propTypes =  false ? (0, _exactProp2.default)(LegacyPortal.propTypes, 'LegacyPortal') : {};

exports.default = LegacyPortal;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  node.addEventListener(event, handler, capture);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, capture);
    }
  };
};

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(566));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1410));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1412));

var _removeStyle = _interopRequireDefault(__webpack_require__(1413));

var _properties = __webpack_require__(1414);

var _isTransform = _interopRequireDefault(__webpack_require__(1415));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1411));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(566));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(94);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(243));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(1417);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(76);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(241);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

// Do we have a scroll bar?
function isOverflowing(container) {
  var doc = (0, _ownerDocument2.default)(container);
  var win = (0, _ownerWindow2.default)(doc);

  /* istanbul ignore next */
  if (!(0, _isWindow2.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  }

  // Takes in account potential non zero margin on the body.
  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);

  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign
  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    },
    padding: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    dense: {
      paddingTop: theme.spacing.unit / 2,
      paddingBottom: theme.spacing.unit / 2
    },
    subheader: {
      paddingTop: 0
    }
  };
};

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          dense = _props.dense,
          disablePadding = _props.disablePadding,
          subheader = _props.subheader,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'component', 'dense', 'disablePadding', 'subheader']);

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty3.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty3.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: className }, other),
        subheader,
        children
      );
    }
  }]);
  return List;
}(_react2.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes2.default.bool,
  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes2.default.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes2.default.node
} : {};

List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};

List.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiList' })(List);

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(18),
      marginRight: 4
    },
    icon: {
      width: 20,
      height: 20,
      fontSize: theme.typography.pxToRem(20)
    }
  };
};

/**
 * It's a simple wrapper to apply the `dense` mode styles to `Avatar`.
 */
function ListItemAvatar(props, context) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  if (context.dense === undefined) {
     false ? (0, _warning2.default)(false, 'Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.') : void 0;
    return props.children;
  }

  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.root, context.dense), classNameProp, children.props.className),
    childrenClassName: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.icon, context.dense), children.props.childrenClassName)
  }, other));
}

ListItemAvatar.propTypes =  false ? {
  /**
   * The content of the component, normally `Avatar`.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

ListItemAvatar.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItemAvatar.muiName = 'ListItemAvatar';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemAvatar' })(ListItemAvatar);

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 ' + theme.spacing.unit * 2 + 'px',
      '&:first-child': {
        paddingLeft: 0
      }
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.spacing.unit * 7
      }
    },
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    textDense: {}
  };
};

function ListItemText(props, context) {
  var _classNames3;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primaryProp = props.primary,
      secondaryProp = props.secondary,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableTypography', 'inset', 'primary', 'secondary']);
  var dense = context.dense;


  var primary = primaryProp || children;
  if (primary && !disableTypography) {
    primary = _react2.default.createElement(
      _Typography2.default,
      {
        variant: 'subheading',
        className: (0, _classnames2.default)(classes.primary, (0, _defineProperty3.default)({}, classes.textDense, dense))
      },
      primary
    );
  }

  var secondary = secondaryProp;
  if (secondary && !disableTypography) {
    secondary = _react2.default.createElement(
      _Typography2.default,
      {
        variant: 'body1',
        className: (0, _classnames2.default)(classes.secondary, (0, _defineProperty3.default)({}, classes.textDense, dense)),
        color: 'textSecondary'
      },
      secondary
    );
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.dense, dense), (0, _defineProperty3.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
    }, other),
    primary,
    secondary
  );
}

ListItemText.propTypes =  false ? {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, that can be useful to can render an h4 instead of a
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes2.default.bool,
  primary: _propTypes2.default.node,
  secondary: _propTypes2.default.node
} : {};

ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};

ListItemText.contextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemText' })(ListItemText);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      margin: 0
    },
    display4: theme.typography.display4,
    display3: theme.typography.display3,
    display2: theme.typography.display2,
    display1: theme.typography.display1,
    headline: theme.typography.headline,
    title: theme.typography.title,
    subheading: theme.typography.subheading,
    body2: theme.typography.body2,
    body1: theme.typography.body1,
    caption: theme.typography.caption,
    button: theme.typography.button,
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    gutterBottom: {
      marginBottom: '0.35em'
    },
    paragraph: {
      marginBottom: theme.spacing.unit * 2
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      componentProp = props.component,
      color = props.color,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['align', 'classes', 'className', 'component', 'color', 'gutterBottom', 'headlineMapping', 'noWrap', 'paragraph', 'variant']);


  var className = (0, _classnames2.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty3.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty3.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty3.default)(_classNames, classes['align' + (0, _helpers.capitalize)(align)], align !== 'inherit'), _classNames), classNameProp);

  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes2.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['inherit', 'primary', 'textSecondary', 'secondary', 'error', 'default']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes2.default.bool,
  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes2.default.object,
  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes2.default.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes2.default.bool,
  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes2.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};

Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTypography' })(Typography);

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 24,
      marginRight: theme.spacing.unit * 2,
      width: 24,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `material-ui-icons` SVG icon element.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemIcon' })(ListItemIcon);

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      right: 4,
      top: '50%',
      marginTop: -theme.spacing.unit * 3
    }
  };
};

function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

ListItemSecondaryAction.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemSecondaryAction' })(ListItemSecondaryAction);

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
    }),
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorInherit: {
      color: 'inherit'
    },
    inset: {
      paddingLeft: theme.spacing.unit * 9
    },
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};

function ListSubheader(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'component', 'disableSticky', 'inset']);


  return _react2.default.createElement(Component, (0, _extends3.default)({
    className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.inset, inset), (0, _defineProperty3.default)(_classNames, classes.sticky, !disableSticky), _classNames), className)
  }, other));
}

ListSubheader.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'primary', 'inherit']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes2.default.bool,
  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes2.default.bool
} : {};

ListSubheader.defaultProps = {
  color: 'default',
  component: 'li',
  disableSticky: false,
  inset: false
};

ListSubheader.muiName = 'ListSubheader';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListSubheader' })(ListSubheader);

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ListItem = __webpack_require__(571);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.subheading, {
      height: theme.spacing.unit * 3,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),
    selected: {}
  };
}; // @inheritedComponent ListItem

function MenuItem(props) {
  var classes = props.classes,
      className = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'selected', 'role']);


  return _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.selected, selected), className),
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * Use to apply selected styling.
   */
  selected: _propTypes2.default.bool
} : {};

MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenuItem' })(MenuItem);

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// third-party

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SuccessIcon = __webpack_require__(1428);

var _SuccessIcon2 = _interopRequireDefault(_SuccessIcon);

var _ErrorIcon = __webpack_require__(1429);

var _ErrorIcon2 = _interopRequireDefault(_ErrorIcon);

var _InfoIcon = __webpack_require__(1430);

var _InfoIcon2 = _interopRequireDefault(_InfoIcon);

var _WarningIcon = __webpack_require__(1431);

var _WarningIcon2 = _interopRequireDefault(_WarningIcon);

var _CustomIcon = __webpack_require__(1432);

var _CustomIcon2 = _interopRequireDefault(_CustomIcon);

var _Buttons = __webpack_require__(1433);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Input = __webpack_require__(1434);

var _Input2 = _interopRequireDefault(_Input);

var _ValidationMessage = __webpack_require__(1435);

var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);

var _Title = __webpack_require__(1436);

var _Title2 = _interopRequireDefault(_Title);

var _Content = __webpack_require__(1437);

var _Content2 = _interopRequireDefault(_Content);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


// styles


var defaultRegex = /^.+$/;
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var style = _SweetAlertStyles2.default.sweetAlert;

if (typeof window !== 'undefined') {
  if (window && window.innerWidth && window.innerWidth < 767) {
    style = (0, _objectAssign2.default)({}, style, _SweetAlertStyles2.default.sweetAlertMobile);
  }
}

var SweetAlert = function (_React$Component) {
  _inherits(SweetAlert, _React$Component);

  function SweetAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SweetAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SweetAlert.__proto__ || Object.getPrototypeOf(SweetAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      type: 'default',
      focusConfirmBtn: true,
      inputValue: '',
      showValidationMessage: false,
      timer: null
    }, _this.setStateFromProps = function (props) {
      props = props || _this.props;
      var type = _this.getTypeFromProps(props);
      _this.setState({
        type: type,
        focusConfirmBtn: props.focusConfirmBtn && type !== 'input'
      });
    }, _this.getTypeFromProps = function (props) {
      if (props.type) return props.type;
      if (props.info) return 'info';
      if (props.success) return 'success';
      if (props.warning) return 'warning';
      if (props.danger || props.error) return 'danger';
      if (props.input) return 'input';
      if (props.custom) return 'custom';
      return _this.state.type;
    }, _this.unsupportedProp = function (oldProp, message) {
      try {
        console.warn('react-bootstrap-sweetalert: Unsupported prop \'' + oldProp + '\'. Please ' + message);
      } catch (e) {}
    }, _this.getIcon = function () {
      switch (_this.state.type) {
        case 'danger':
        case 'error':
          return _react2.default.createElement(_ErrorIcon2.default, null);
        case 'warning':
          return _react2.default.createElement(_WarningIcon2.default, null);
        case 'info':
          return _react2.default.createElement(_InfoIcon2.default, null);
        case 'success':
          return _react2.default.createElement(_SuccessIcon2.default, null);
        case 'custom':
          if (_this.props.customIcon) {
            if (typeof _this.props.customIcon == 'string') {
              return _react2.default.createElement(_CustomIcon2.default, { iconUrl: _this.props.customIcon });
            } else {
              return _this.props.customIcon;
            }
          }
      }
    }, _this.onChangeInput = function (e) {
      _this.setState({
        inputValue: e.target.value,
        showValidationMessage: false
      });
    }, _this.isValidInput = function () {
      if (!_this.props.required) {
        return true;
      }
      var regex = _this.props.validationRegex || (_this.props.inputType === 'email' ? emailRegex : defaultRegex);
      return regex.test(_this.state.inputValue);
    }, _this.onConfirm = function () {
      if (_this.state.type === 'input') {
        if (_this.isValidInput()) {
          _this.props.onConfirm(_this.state.inputValue);
        } else {
          _this.setState({
            showValidationMessage: true
          });
        }
      } else {
        _this.props.onConfirm();
      }
    }, _this.onInputKeyDown = function (e) {
      if (e.keyCode == 13) {
        if (_this.props.onConfirm) {
          _this.onConfirm();
          e.stopPropagation();
        }
      }
    }, _this.onKeyDown = function (e) {
      if (e.keyCode == 27) {
        if (_this.props.allowEscape && _this.props.onCancel) {
          _this.props.onCancel();
          e.stopPropagation();
        }
      }
    }, _this.onClickOutside = function () {
      if (_this.props.closeOnClickOutside && _this.props.onCancel) {
        _this.props.onCancel();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SweetAlert, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.inputPlaceHolder) {
        this.unsupportedProp('inputPlaceHolder', 'use props.placeholder');
      }
      if (this.props.inputValidationMsg) {
        this.unsupportedProp('inputValidationMsg', 'use props.validationMsg');
      }
      if (this.props.content) {
        this.unsupportedProp('content', 'use props.children <SweetAlert>your content</SweetAlert>');
      }
      if (this.props.defaultValue != null) {
        this.setState({
          inputValue: this.props.defaultValue
        });
      }

      this.setStateFromProps();

      this.props.beforeMount();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.afterMount();
      this.handleTimeout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.getTypeFromProps(this.props) !== this.getTypeFromProps(nextProps)) {
        this.setStateFromProps(nextProps);
        this.handleTimeout(nextProps);
      } else if (this.props.timeout !== nextProps.timeout) {
        this.handleTimeout(nextProps);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.props.beforeUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.props.afterUpdate(prevProps, prevState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.beforeUnmount();
    }
  }, {
    key: 'handleTimeout',
    value: function handleTimeout(props) {
      props = props || this.props;

      if (this.state.timer) {
        clearTimeout(this.state.timer);
      }

      if (props.timeout && props.timeout > 0) {
        var timer = setTimeout(function () {
          return props.onConfirm();
        }, props.timeout);

        this.setState({ timer: timer });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.show) {
        return false;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'style',
          { type: 'text/css', scoped: true },
          '@-webkit-keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @-webkit-keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @-webkit-keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @-webkit-keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }'
        ),
        !this.props.hideOverlay && _react2.default.createElement('div', { style: _SweetAlertStyles2.default.overlay, onClick: this.onClickOutside }),
        _react2.default.createElement(
          'div',
          {
            style: (0, _objectAssign2.default)({}, style, this.props.style),
            tabIndex: '0',
            ref: 'container',
            onKeyDown: this.onKeyDown,
            className: 'sweet-alert ' + this.props.customClass
          },
          this.getIcon(),
          _react2.default.createElement(
            _Title2.default,
            null,
            this.props.title
          ),
          _react2.default.createElement(
            _Content2.default,
            null,
            this.props.children
          ),
          this.state.type === 'input' && _react2.default.createElement(_Input2.default, _extends({}, this.props, this.state, {
            type: this.state.type,
            onInputKeyDown: this.onInputKeyDown,
            onChangeInput: this.onChangeInput
          })),
          this.state.showValidationMessage && _react2.default.createElement(_ValidationMessage2.default, this.props),
          _react2.default.createElement(_Buttons2.default, _extends({}, this.props, {
            type: this.state.type,
            onConfirm: this.onConfirm,
            focusConfirmBtn: this.state.focusConfirmBtn
          }))
        )
      );
    }
  }]);

  return SweetAlert;
}(_react2.default.Component);

SweetAlert.propTypes = {
  type: _propTypes2.default.oneOf(['default', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom']),
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
  onCancel: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func.isRequired,
  confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  confirmBtnCssClass: _propTypes2.default.string,
  confirmBtnStyle: _propTypes2.default.object,
  cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  cancelBtnCssClass: _propTypes2.default.string,
  cancelBtnStyle: _propTypes2.default.object,
  btnSize: _propTypes2.default.string,
  customIcon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  show: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  validationMsg: _propTypes2.default.string,
  validationRegex: _propTypes2.default.object,
  defaultValue: _propTypes2.default.string,
  inputType: _propTypes2.default.string,
  style: _propTypes2.default.object,
  customClass: _propTypes2.default.string,
  showConfirm: _propTypes2.default.bool,
  showCancel: _propTypes2.default.bool,
  allowEscape: _propTypes2.default.bool,
  closeOnClickOutside: _propTypes2.default.bool,
  hideOverlay: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusConfirmBtn: _propTypes2.default.bool,
  beforeMount: _propTypes2.default.func,
  afterMount: _propTypes2.default.func,
  beforeUpdate: _propTypes2.default.func,
  afterUpdate: _propTypes2.default.func,
  beforeUnmount: _propTypes2.default.func,
  timeout: _propTypes2.default.number
};
SweetAlert.defaultProps = {
  allowEscape: true,
  closeOnClickOutside: true,
  validationMsg: null,
  validationRegex: null,
  inputType: 'text',
  customClass: '',
  hideOverlay: false,
  show: true,
  required: true,
  disabled: false,
  focusConfirmBtn: true,
  beforeMount: function beforeMount() {},
  afterMount: function afterMount() {},
  beforeUpdate: function beforeUpdate() {},
  afterUpdate: function afterUpdate() {},
  beforeUnmount: function beforeUnmount() {},
  timeout: 0
};
SweetAlert.SuccessIcon = _SuccessIcon2.default;
SweetAlert.ErrorIcon = _ErrorIcon2.default;
SweetAlert.InfoIcon = _InfoIcon2.default;
SweetAlert.WarningIcon = _WarningIcon2.default;
SweetAlert.CustomIcon = _CustomIcon2.default;
SweetAlert.Buttons = _Buttons2.default;
SweetAlert.Input = _Input2.default;
SweetAlert.ValidationMessage = _ValidationMessage2.default;
SweetAlert.Title = _Title2.default;
SweetAlert.Content = _Content2.default;
exports.default = SweetAlert;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        'div',
        { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconSuccess) },
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessBefore) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineTip) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineLong) }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessPlaceholder }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessFix }),
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessAfter) })
    );
};

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconError) },
		_react2.default.createElement(
			'span',
			{ style: _SweetAlertStyles2.default.iconErrorX },
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineLeft) }),
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineRight) })
		)
	);
};

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
       return _react2.default.createElement(
              'div',
              { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconInfo) },
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoBefore }),
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoAfter })
       );
};

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconWarning) },
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningBody }),
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningDot })
	);
};

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconCustom);

exports.default = function (_ref) {
    var iconUrl = _ref.iconUrl;
    return _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, style, { backgroundImage: 'url(' + iconUrl + ')' }) });
};

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Buttons = function (_React$Component) {
    _inherits(Buttons, _React$Component);

    function Buttons() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Buttons);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call.apply(_ref, [this].concat(args))), _this), _this.buttonStyles = {}, _this.getButtonStyle = function (bsStyle) {
            if (bsStyle === 'error') bsStyle = 'danger';
            if (_this.buttonStyles[bsStyle] == null) {
                var style = Buttons.styles[bsStyle] || Buttons.styles.default;
                var borderColor = 'borderColor: ' + style.borderColor + ' !important';
                var boxShadow = 'boxShadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px ' + style.shadowColor + ' !important;';
                _this.buttonStyles[bsStyle] = ' ' + borderColor + ' ' + boxShadow;
            }
            return _this.buttonStyles[bsStyle];
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Buttons, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusButton();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            // when displaying back to back alerts React will treat this
            // as an update to the same alert. this causes componentDidMount
            // to not be called for the subsequent alerts. i hope to find a better
            // way to handle this in the future, but for now i'm checking if the
            // title, type, or button text has changed
            if (prevProps.type !== this.props.type || prevProps.confirmBtnText !== this.props.confirmBtnText || prevProps.title !== this.props.title) {
                setTimeout(function () {
                    return _this2.focusButton();
                }, 0);
            }
        }
    }, {
        key: 'focusButton',
        value: function focusButton() {
            if (this.props.focusConfirmBtn && this.refs.confirmBtn) {
                try {
                    this.refs.confirmBtn.focus();
                } catch (e) {
                    // whoops
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.showConfirm && !this.props.showCancel) {
                return false;
            }
            var cancelBtnBsStyle = this.props.cancelBtnBsStyle === 'error' ? 'danger' : this.props.cancelBtnBsStyle;
            var confirmBtnBsStyle = this.props.confirmBtnBsStyle === 'error' ? 'danger' : this.props.confirmBtnBsStyle;
            return _react2.default.createElement(
                'p',
                { style: { marginTop: 20 } },
                this.props.showCancel && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(cancelBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.cancelBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + cancelBtnBsStyle + ' ' + this.props.cancelBtnCssClass,
                            onClick: this.props.onCancel,
                            type: 'button' },
                        this.props.cancelBtnText
                    )
                ),
                this.props.showConfirm && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(confirmBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            ref: 'confirmBtn',
                            disabled: this.props.disabled,
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.confirmBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + confirmBtnBsStyle + ' ' + this.props.confirmBtnCssClass,
                            onClick: this.props.onConfirm,
                            type: 'button' },
                        this.props.confirmBtnText
                    )
                )
            );
        }
    }]);

    return Buttons;
}(_react2.default.Component);

Buttons.propTypes = {
    confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    confirmBtnCssClass: _propTypes2.default.string,
    confirmBtnStyle: _propTypes2.default.object,
    cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    cancelBtnCssClass: _propTypes2.default.string,
    cancelBtnStyle: _propTypes2.default.object,
    btnSize: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onConfirm: _propTypes2.default.func,
    showConfirm: _propTypes2.default.bool,
    showCancel: _propTypes2.default.bool,
    focusConfirmBtn: _propTypes2.default.bool
};
Buttons.defaultProps = {
    confirmBtnText: 'OK',
    confirmBtnBsStyle: 'primary',
    confirmBtnCssClass: '',
    confirmBtnStyle: {},
    cancelBtnText: 'Cancel',
    cancelBtnBsStyle: 'link',
    cancelBtnCssClass: '',
    cancelBtnStyle: {},
    focusConfirmBtn: true,
    showConfirm: true,
    showCancel: false,
    btnSize: 'lg'
};
Buttons.styles = {
    primary: {
        borderColor: '#286090',
        shadowColor: 'rgb(165, 202, 234)'
    },
    success: {
        borderColor: '#4cae4c',
        shadowColor: 'rgba(76, 174, 76, 0.6)'
    },
    info: {
        borderColor: '#46b8da',
        shadowColor: 'rgba(70, 184, 218, 0.6)'
    },
    danger: {
        borderColor: '#d43f3a',
        shadowColor: 'rgba(212, 63, 58, 0.6)'
    },
    warning: {
        borderColor: '#eea236',
        shadowColor: 'rgba(238, 162, 54, 0.6)'
    },
    default: {
        borderColor: '#cccccc',
        shadowColor: 'rgba(204, 204, 204, 0.6)'
    }
};
exports.default = Buttons;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(83);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
	_inherits(Input, _React$Component);

	function Input() {
		_classCallCheck(this, Input);

		return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	}

	_createClass(Input, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.type === 'input') {
				try {
					this.refs.input.focus();
				} catch (e) {
					// whoops
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ style: { position: 'relative' } },
				this.props.inputType === 'textarea' ? _react2.default.createElement('textarea', {
					ref: 'input',
					rows: 4,
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }) : _react2.default.createElement('input', {
					type: this.props.inputType,
					ref: 'input',
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }),
				this.props.showValidationMessage && _react2.default.createElement(
					'div',
					{ style: _SweetAlertStyles2.default.inputErrorIcon },
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconBefore) }),
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconAfter) })
				)
			);
		}
	}]);

	return Input;
}(_react2.default.Component);

exports.default = Input;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SweetAlertStyles = __webpack_require__(100);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMessage = 'Please enter a response!';
var emailMessage = 'Please enter a valid email!';

exports.default = function (_ref) {
    var validationMsg = _ref.validationMsg,
        inputType = _ref.inputType;

    var message = validationMsg || (inputType === 'email' ? emailMessage : defaultMessage);

    return _react2.default.createElement(
        'div',
        { style: _SweetAlertStyles2.default.validationMessage },
        _react2.default.createElement(
            'div',
            { style: _SweetAlertStyles2.default.exclamationIcon },
            '!'
        ),
        message
    );
};

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'h2',
    null,
    children
  );
};

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'text-muted lead' },
        children
    );
};

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

/*
 * Expose AWS IoT Embedded Javascript SDK modules
 */
module.exports.device = __webpack_require__(363);
module.exports.thingShadow = __webpack_require__(1502);
module.exports.jobs = __webpack_require__(1503);


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var MqttClient = __webpack_require__(1442)
var Store = __webpack_require__(573)
var url = __webpack_require__(365)
var xtend = __webpack_require__(364)
var protocols = {}

if (process.title !== 'browser') {
  protocols.mqtt = __webpack_require__(584)
  protocols.tcp = __webpack_require__(584)
  protocols.ssl = __webpack_require__(366)
  protocols.tls = __webpack_require__(366)
  protocols.mqtts = __webpack_require__(366)
} else {
  protocols.wx = __webpack_require__(585)
  protocols.wxs = __webpack_require__(585)
}

protocols.ws = __webpack_require__(586)
protocols.wss = __webpack_require__(586)

/**
 * Parse the auth attribute and merge username and password in the options object.
 *
 * @param {Object} [opts] option object
 */
function parseAuthOptions (opts) {
  var matches
  if (opts.auth) {
    matches = opts.auth.match(/^(.+):(.+)$/)
    if (matches) {
      opts.username = matches[1]
      opts.password = matches[2]
    } else {
      opts.username = opts.auth
    }
  }
}

/**
 * connect - connect to an MQTT broker.
 *
 * @param {String} [brokerUrl] - url of the broker, optional
 * @param {Object} opts - see MqttClient#constructor
 */
function connect (brokerUrl, opts) {
  if ((typeof brokerUrl === 'object') && !opts) {
    opts = brokerUrl
    brokerUrl = null
  }

  opts = opts || {}

  if (brokerUrl) {
    var parsed = url.parse(brokerUrl, true)
    if (parsed.port != null) {
      parsed.port = Number(parsed.port)
    }

    opts = xtend(parsed, opts)

    if (opts.protocol === null) {
      throw new Error('Missing protocol')
    }
    opts.protocol = opts.protocol.replace(/:$/, '')
  }

  // merge in the auth options if supplied
  parseAuthOptions(opts)

  // support clientId passed in the query string of the url
  if (opts.query && typeof opts.query.clientId === 'string') {
    opts.clientId = opts.query.clientId
  }

  if (opts.cert && opts.key) {
    if (opts.protocol) {
      if (['mqtts', 'wss', 'wxs'].indexOf(opts.protocol) === -1) {
        switch (opts.protocol) {
          case 'mqtt':
            opts.protocol = 'mqtts'
            break
          case 'ws':
            opts.protocol = 'wss'
            break
          case 'wx':
            opts.protocol = 'wxs'
            break
          default:
            throw new Error('Unknown protocol for secure connection: "' + opts.protocol + '"!')
        }
      }
    } else {
      // don't know what protocol he want to use, mqtts or wss
      throw new Error('Missing secure protocol key')
    }
  }

  if (!protocols[opts.protocol]) {
    var isSecure = ['mqtts', 'wss'].indexOf(opts.protocol) !== -1
    opts.protocol = [
      'mqtt',
      'mqtts',
      'ws',
      'wss',
      'wx',
      'wxs'
    ].filter(function (key, index) {
      if (isSecure && index % 2 === 0) {
        // Skip insecure protocols when requesting a secure one.
        return false
      }
      return (typeof protocols[key] === 'function')
    })[0]
  }

  if (opts.clean === false && !opts.clientId) {
    throw new Error('Missing clientId for unclean clients')
  }

  function wrapper (client) {
    if (opts.servers) {
      if (!client._reconnectCount || client._reconnectCount === opts.servers.length) {
        client._reconnectCount = 0
      }

      opts.host = opts.servers[client._reconnectCount].host
      opts.port = opts.servers[client._reconnectCount].port
      opts.hostname = opts.host

      client._reconnectCount++
    }

    return protocols[opts.protocol](client, opts)
  }

  return new MqttClient(wrapper, opts)
}

module.exports = connect
module.exports.connect = connect
module.exports.MqttClient = MqttClient
module.exports.Store = Store

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

/**
 * Module dependencies
 */
var events = __webpack_require__(95)
var Store = __webpack_require__(573)
var eos = __webpack_require__(581)
var mqttPacket = __webpack_require__(1452)
var Writable = __webpack_require__(246).Writable
var inherits = __webpack_require__(102)
var reInterval = __webpack_require__(1459)
var validations = __webpack_require__(1460)
var xtend = __webpack_require__(364)
var setImmediate = global.setImmediate || function (callback) {
  // works in node v0.8
  process.nextTick(callback)
}
var defaultConnectOptions = {
  keepalive: 60,
  reschedulePings: true,
  protocolId: 'MQTT',
  protocolVersion: 4,
  reconnectPeriod: 1000,
  connectTimeout: 30 * 1000,
  clean: true,
  resubscribe: true
}

function defaultId () {
  return 'mqttjs_' + Math.random().toString(16).substr(2, 8)
}

function sendPacket (client, packet, cb) {
  client.emit('packetsend', packet)

  var result = mqttPacket.writeToStream(packet, client.stream)

  if (!result && cb) {
    client.stream.once('drain', cb)
  } else if (cb) {
    cb()
  }
}

function storeAndSend (client, packet, cb) {
  client.outgoingStore.put(packet, function storedPacket (err) {
    if (err) {
      return cb && cb(err)
    }
    sendPacket(client, packet, cb)
  })
}

function nop () {}

/**
 * MqttClient constructor
 *
 * @param {Stream} stream - stream
 * @param {Object} [options] - connection options
 * (see Connection#connect)
 */
function MqttClient (streamBuilder, options) {
  var k
  var that = this

  if (!(this instanceof MqttClient)) {
    return new MqttClient(streamBuilder, options)
  }

  this.options = options || {}

  // Defaults
  for (k in defaultConnectOptions) {
    if (typeof this.options[k] === 'undefined') {
      this.options[k] = defaultConnectOptions[k]
    } else {
      this.options[k] = options[k]
    }
  }

  this.options.clientId = (typeof this.options.clientId === 'string') ? this.options.clientId : defaultId()

  this.streamBuilder = streamBuilder

  // Inflight message storages
  this.outgoingStore = this.options.outgoingStore || new Store()
  this.incomingStore = this.options.incomingStore || new Store()

  // Should QoS zero messages be queued when the connection is broken?
  this.queueQoSZero = this.options.queueQoSZero === undefined ? true : this.options.queueQoSZero

  // map of subscribed topics to support reconnection
  this._resubscribeTopics = {}

  // map of a subscribe messageId and a topic
  this.messageIdToTopic = {}

  // Ping timer, setup in _setupPingTimer
  this.pingTimer = null
  // Is the client connected?
  this.connected = false
  // Are we disconnecting?
  this.disconnecting = false
  // Packet queue
  this.queue = []
  // connack timer
  this.connackTimer = null
  // Reconnect timer
  this.reconnectTimer = null
  // MessageIDs starting with 1
  this.nextId = Math.floor(Math.random() * 65535)

  // Inflight callbacks
  this.outgoing = {}

  // Mark connected on connect
  this.on('connect', function () {
    if (this.disconnected) {
      return
    }

    this.connected = true
    var outStore = null
    outStore = this.outgoingStore.createStream()

    // Control of stored messages
    outStore.once('readable', function () {
      function storeDeliver () {
        var packet = outStore.read(1)
        var cb

        if (!packet) {
          return
        }

        // Avoid unnecesary stream read operations when disconnected
        if (!that.disconnecting && !that.reconnectTimer && that.options.reconnectPeriod > 0) {
          outStore.read(0)
          cb = that.outgoing[packet.messageId]
          that.outgoing[packet.messageId] = function (err, status) {
            // Ensure that the original callback passed in to publish gets invoked
            if (cb) {
              cb(err, status)
            }

            storeDeliver()
          }
          that._sendPacket(packet)
        } else if (outStore.destroy) {
          outStore.destroy()
        }
      }
      storeDeliver()
    })
    .on('error', this.emit.bind(this, 'error'))
  })

  // Mark disconnected on stream close
  this.on('close', function () {
    this.connected = false
    clearTimeout(this.connackTimer)
  })

  // Setup ping timer
  this.on('connect', this._setupPingTimer)

  // Send queued packets
  this.on('connect', function () {
    var queue = this.queue

    function deliver () {
      var entry = queue.shift()
      var packet = null

      if (!entry) {
        return
      }

      packet = entry.packet

      that._sendPacket(
        packet,
        function (err) {
          if (entry.cb) {
            entry.cb(err)
          }
          deliver()
        }
      )
    }

    deliver()
  })

  var firstConnection = true
  // resubscribe
  this.on('connect', function () {
    if (!firstConnection &&
        this.options.clean &&
        Object.keys(this._resubscribeTopics).length > 0) {
      if (this.options.resubscribe) {
        this._resubscribeTopics.resubscribe = true
        this.subscribe(this._resubscribeTopics)
      } else {
        this._resubscribeTopics = {}
      }
    }

    firstConnection = false
  })

  // Clear ping timer
  this.on('close', function () {
    if (that.pingTimer !== null) {
      that.pingTimer.clear()
      that.pingTimer = null
    }
  })

  // Setup reconnect timer on disconnect
  this.on('close', this._setupReconnect)

  events.EventEmitter.call(this)

  this._setupStream()
}
inherits(MqttClient, events.EventEmitter)

/**
 * setup the event handlers in the inner stream.
 *
 * @api private
 */
MqttClient.prototype._setupStream = function () {
  var connectPacket
  var that = this
  var writable = new Writable()
  var parser = mqttPacket.parser(this.options)
  var completeParse = null
  var packets = []

  this._clearReconnect()

  this.stream = this.streamBuilder(this)

  parser.on('packet', function (packet) {
    packets.push(packet)
  })

  function nextTickWork () {
    process.nextTick(work)
  }

  function work () {
    var packet = packets.shift()
    var done = completeParse

    if (packet) {
      that._handlePacket(packet, nextTickWork)
    } else {
      completeParse = null
      done()
    }
  }

  writable._write = function (buf, enc, done) {
    completeParse = done
    parser.parse(buf)
    work()
  }

  this.stream.pipe(writable)

  // Suppress connection errors
  this.stream.on('error', nop)

  // Echo stream close
  eos(this.stream, this.emit.bind(this, 'close'))

  // Send a connect packet
  connectPacket = Object.create(this.options)
  connectPacket.cmd = 'connect'
  // avoid message queue
  sendPacket(this, connectPacket)

  // Echo connection errors
  parser.on('error', this.emit.bind(this, 'error'))

  // many drain listeners are needed for qos 1 callbacks if the connection is intermittent
  this.stream.setMaxListeners(1000)

  clearTimeout(this.connackTimer)
  this.connackTimer = setTimeout(function () {
    that._cleanUp(true)
  }, this.options.connectTimeout)
}

MqttClient.prototype._handlePacket = function (packet, done) {
  this.emit('packetreceive', packet)

  switch (packet.cmd) {
    case 'publish':
      this._handlePublish(packet, done)
      break
    case 'puback':
    case 'pubrec':
    case 'pubcomp':
    case 'suback':
    case 'unsuback':
      this._handleAck(packet)
      done()
      break
    case 'pubrel':
      this._handlePubrel(packet, done)
      break
    case 'connack':
      this._handleConnack(packet)
      done()
      break
    case 'pingresp':
      this._handlePingresp(packet)
      done()
      break
    default:
      // do nothing
      // maybe we should do an error handling
      // or just log it
      break
  }
}

MqttClient.prototype._checkDisconnecting = function (callback) {
  if (this.disconnecting) {
    if (callback) {
      callback(new Error('client disconnecting'))
    } else {
      this.emit('error', new Error('client disconnecting'))
    }
  }
  return this.disconnecting
}

/**
 * publish - publish <message> to <topic>
 *
 * @param {String} topic - topic to publish to
 * @param {String, Buffer} message - message to publish
 * @param {Object} [opts] - publish options, includes:
 *    {Number} qos - qos level to publish on
 *    {Boolean} retain - whether or not to retain the message
 *    {Boolean} dup - whether or not mark a message as duplicate
 * @param {Function} [callback] - function(err){}
 *    called when publish succeeds or fails
 * @returns {MqttClient} this - for chaining
 * @api public
 *
 * @example client.publish('topic', 'message');
 * @example
 *     client.publish('topic', 'message', {qos: 1, retain: true, dup: true});
 * @example client.publish('topic', 'message', console.log);
 */
MqttClient.prototype.publish = function (topic, message, opts, callback) {
  var packet

  // .publish(topic, payload, cb);
  if (typeof opts === 'function') {
    callback = opts
    opts = null
  }

  // default opts
  var defaultOpts = {qos: 0, retain: false, dup: false}
  opts = xtend(defaultOpts, opts)

  if (this._checkDisconnecting(callback)) {
    return this
  }

  packet = {
    cmd: 'publish',
    topic: topic,
    payload: message,
    qos: opts.qos,
    retain: opts.retain,
    messageId: this._nextId(),
    dup: opts.dup
  }

  switch (opts.qos) {
    case 1:
    case 2:

      // Add to callbacks
      this.outgoing[packet.messageId] = callback || nop
      this._sendPacket(packet)
      break
    default:
      this._sendPacket(packet, callback)
      break
  }

  return this
}

/**
 * subscribe - subscribe to <topic>
 *
 * @param {String, Array, Object} topic - topic(s) to subscribe to, supports objects in the form {'topic': qos}
 * @param {Object} [opts] - optional subscription options, includes:
 *    {Number} qos - subscribe qos level
 * @param {Function} [callback] - function(err, granted){} where:
 *    {Error} err - subscription error (none at the moment!)
 *    {Array} granted - array of {topic: 't', qos: 0}
 * @returns {MqttClient} this - for chaining
 * @api public
 * @example client.subscribe('topic');
 * @example client.subscribe('topic', {qos: 1});
 * @example client.subscribe({'topic': 0, 'topic2': 1}, console.log);
 * @example client.subscribe('topic', console.log);
 */
MqttClient.prototype.subscribe = function () {
  var packet
  var args = Array.prototype.slice.call(arguments)
  var subs = []
  var obj = args.shift()
  var resubscribe = obj.resubscribe
  var callback = args.pop() || nop
  var opts = args.pop()
  var invalidTopic
  var that = this

  delete obj.resubscribe

  if (typeof obj === 'string') {
    obj = [obj]
  }

  if (typeof callback !== 'function') {
    opts = callback
    callback = nop
  }

  invalidTopic = validations.validateTopics(obj)
  if (invalidTopic !== null) {
    setImmediate(callback, new Error('Invalid topic ' + invalidTopic))
    return this
  }

  if (this._checkDisconnecting(callback)) {
    return this
  }

  var defaultOpts = { qos: 0 }
  opts = xtend(defaultOpts, opts)

  if (Array.isArray(obj)) {
    obj.forEach(function (topic) {
      if (that._resubscribeTopics[topic] < opts.qos ||
          !that._resubscribeTopics.hasOwnProperty(topic) ||
          resubscribe
        ) {
        subs.push({
          topic: topic,
          qos: opts.qos
        })
      }
    })
  } else {
    Object
      .keys(obj)
      .forEach(function (k) {
        if (that._resubscribeTopics[k] < obj[k] ||
            !that._resubscribeTopics.hasOwnProperty(k) ||
            resubscribe
          ) {
          subs.push({
            topic: k,
            qos: obj[k]
          })
        }
      })
  }

  packet = {
    cmd: 'subscribe',
    subscriptions: subs,
    qos: 1,
    retain: false,
    dup: false,
    messageId: this._nextId()
  }

  if (!subs.length) {
    callback(null, [])
    return
  }

  // subscriptions to resubscribe to in case of disconnect
  if (this.options.resubscribe) {
    var topics = []
    subs.forEach(function (sub) {
      if (that.options.reconnectPeriod > 0) {
        that._resubscribeTopics[sub.topic] = sub.qos
        topics.push(sub.topic)
      }
    })
    that.messageIdToTopic[packet.messageId] = topics
  }

  this.outgoing[packet.messageId] = function (err, packet) {
    if (!err) {
      var granted = packet.granted
      for (var i = 0; i < granted.length; i += 1) {
        subs[i].qos = granted[i]
      }
    }

    callback(err, subs)
  }

  this._sendPacket(packet)

  return this
}

/**
 * unsubscribe - unsubscribe from topic(s)
 *
 * @param {String, Array} topic - topics to unsubscribe from
 * @param {Function} [callback] - callback fired on unsuback
 * @returns {MqttClient} this - for chaining
 * @api public
 * @example client.unsubscribe('topic');
 * @example client.unsubscribe('topic', console.log);
 */
MqttClient.prototype.unsubscribe = function (topic, callback) {
  var packet = {
    cmd: 'unsubscribe',
    qos: 1,
    messageId: this._nextId()
  }
  var that = this

  callback = callback || nop

  if (this._checkDisconnecting(callback)) {
    return this
  }

  if (typeof topic === 'string') {
    packet.unsubscriptions = [topic]
  } else if (typeof topic === 'object' && topic.length) {
    packet.unsubscriptions = topic
  }

  if (this.options.resubscribe) {
    packet.unsubscriptions.forEach(function (topic) {
      delete that._resubscribeTopics[topic]
    })
  }

  this.outgoing[packet.messageId] = callback

  this._sendPacket(packet)

  return this
}

/**
 * end - close connection
 *
 * @returns {MqttClient} this - for chaining
 * @param {Boolean} force - do not wait for all in-flight messages to be acked
 * @param {Function} cb - called when the client has been closed
 *
 * @api public
 */
MqttClient.prototype.end = function (force, cb) {
  var that = this

  if (typeof force === 'function') {
    cb = force
    force = false
  }

  function closeStores () {
    that.disconnected = true
    that.incomingStore.close(function () {
      that.outgoingStore.close(cb)
    })
    if (that._deferredReconnect) {
      that._deferredReconnect()
    }
  }

  function finish () {
    // defer closesStores of an I/O cycle,
    // just to make sure things are
    // ok for websockets
    that._cleanUp(force, setImmediate.bind(null, closeStores))
  }

  if (this.disconnecting) {
    return this
  }

  this._clearReconnect()

  this.disconnecting = true

  if (!force && Object.keys(this.outgoing).length > 0) {
    // wait 10ms, just to be sure we received all of it
    this.once('outgoingEmpty', setTimeout.bind(null, finish, 10))
  } else {
    finish()
  }

  return this
}

/**
 * removeOutgoingMessage - remove a message in outgoing store
 * the outgoing callback will be called withe Error('Message removed') if the message is removed
 *
 * @param {Number} mid - messageId to remove message
 * @returns {MqttClient} this - for chaining
 * @api public
 *
 * @example client.removeOutgoingMessage(client.getLastMessageId());
 */
MqttClient.prototype.removeOutgoingMessage = function (mid) {
  var cb = this.outgoing[mid]
  delete this.outgoing[mid]
  this.outgoingStore.del({messageId: mid}, function () {
    cb(new Error('Message removed'))
  })
  return this
}

/**
 * reconnect - connect again using the same options as connect()
 *
 * @param {Object} [opts] - optional reconnect options, includes:
 *    {Store} incomingStore - a store for the incoming packets
 *    {Store} outgoingStore - a store for the outgoing packets
 *    if opts is not given, current stores are used
 * @returns {MqttClient} this - for chaining
 *
 * @api public
 */
MqttClient.prototype.reconnect = function (opts) {
  var that = this
  var f = function () {
    if (opts) {
      that.options.incomingStore = opts.incomingStore
      that.options.outgoingStore = opts.outgoingStore
    } else {
      that.options.incomingStore = null
      that.options.outgoingStore = null
    }
    that.incomingStore = that.options.incomingStore || new Store()
    that.outgoingStore = that.options.outgoingStore || new Store()
    that.disconnecting = false
    that.disconnected = false
    that._deferredReconnect = null
    that._reconnect()
  }

  if (this.disconnecting && !this.disconnected) {
    this._deferredReconnect = f
  } else {
    f()
  }
  return this
}

/**
 * _reconnect - implement reconnection
 * @api privateish
 */
MqttClient.prototype._reconnect = function () {
  this.emit('reconnect')
  this._setupStream()
}

/**
 * _setupReconnect - setup reconnect timer
 */
MqttClient.prototype._setupReconnect = function () {
  var that = this

  if (!that.disconnecting && !that.reconnectTimer && (that.options.reconnectPeriod > 0)) {
    if (!this.reconnecting) {
      this.emit('offline')
      this.reconnecting = true
    }
    that.reconnectTimer = setInterval(function () {
      that._reconnect()
    }, that.options.reconnectPeriod)
  }
}

/**
 * _clearReconnect - clear the reconnect timer
 */
MqttClient.prototype._clearReconnect = function () {
  if (this.reconnectTimer) {
    clearInterval(this.reconnectTimer)
    this.reconnectTimer = null
  }
}

/**
 * _cleanUp - clean up on connection end
 * @api private
 */
MqttClient.prototype._cleanUp = function (forced, done) {
  if (done) {
    this.stream.on('close', done)
  }

  if (forced) {
    this.stream.destroy()
  } else {
    this._sendPacket(
      { cmd: 'disconnect' },
      setImmediate.bind(
        null,
        this.stream.end.bind(this.stream)
      )
    )
  }

  if (!this.disconnecting) {
    this._clearReconnect()
    this._setupReconnect()
  }

  if (this.pingTimer !== null) {
    this.pingTimer.clear()
    this.pingTimer = null
  }
}

/**
 * _sendPacket - send or queue a packet
 * @param {String} type - packet type (see `protocol`)
 * @param {Object} packet - packet options
 * @param {Function} cb - callback when the packet is sent
 * @api private
 */
MqttClient.prototype._sendPacket = function (packet, cb) {
  if (!this.connected) {
    if (((packet.qos || 0) === 0 && this.queueQoSZero) || packet.cmd !== 'publish') {
      this.queue.push({ packet: packet, cb: cb })
    } else if (packet.qos > 0) {
      cb = this.outgoing[packet.messageId]
      this.outgoingStore.put(packet, function (err) {
        if (err) {
          return cb && cb(err)
        }
      })
    } else if (cb) {
      cb(new Error('No connection to broker'))
    }

    return
  }

  // When sending a packet, reschedule the ping timer
  this._shiftPingInterval()

  if (packet.cmd !== 'publish') {
    sendPacket(this, packet, cb)
    return
  }

  switch (packet.qos) {
    case 2:
    case 1:
      storeAndSend(this, packet, cb)
      break
    /**
     * no need of case here since it will be caught by default
     * and jshint comply that before default it must be a break
     * anyway it will result in -1 evaluation
     */
    case 0:
      /* falls through */
    default:
      sendPacket(this, packet, cb)
      break
  }
}

/**
 * _setupPingTimer - setup the ping timer
 *
 * @api private
 */
MqttClient.prototype._setupPingTimer = function () {
  var that = this

  if (!this.pingTimer && this.options.keepalive) {
    this.pingResp = true
    this.pingTimer = reInterval(function () {
      that._checkPing()
    }, this.options.keepalive * 1000)
  }
}

/**
 * _shiftPingInterval - reschedule the ping interval
 *
 * @api private
 */
MqttClient.prototype._shiftPingInterval = function () {
  if (this.pingTimer && this.options.keepalive && this.options.reschedulePings) {
    this.pingTimer.reschedule(this.options.keepalive * 1000)
  }
}
/**
 * _checkPing - check if a pingresp has come back, and ping the server again
 *
 * @api private
 */
MqttClient.prototype._checkPing = function () {
  if (this.pingResp) {
    this.pingResp = false
    this._sendPacket({ cmd: 'pingreq' })
  } else {
    // do a forced cleanup since socket will be in bad shape
    this._cleanUp(true)
  }
}

/**
 * _handlePingresp - handle a pingresp
 *
 * @api private
 */
MqttClient.prototype._handlePingresp = function () {
  this.pingResp = true
}

/**
 * _handleConnack
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handleConnack = function (packet) {
  var rc = packet.returnCode
  var errors = [
    '',
    'Unacceptable protocol version',
    'Identifier rejected',
    'Server unavailable',
    'Bad username or password',
    'Not authorized'
  ]

  clearTimeout(this.connackTimer)

  if (rc === 0) {
    this.reconnecting = false
    this.emit('connect', packet)
  } else if (rc > 0) {
    var err = new Error('Connection refused: ' + errors[rc])
    err.code = rc
    this.emit('error', err)
  }
}

/**
 * _handlePublish
 *
 * @param {Object} packet
 * @api private
 */
/*
those late 2 case should be rewrite to comply with coding style:

case 1:
case 0:
  // do not wait sending a puback
  // no callback passed
  if (1 === qos) {
    this._sendPacket({
      cmd: 'puback',
      messageId: mid
    });
  }
  // emit the message event for both qos 1 and 0
  this.emit('message', topic, message, packet);
  this.handleMessage(packet, done);
  break;
default:
  // do nothing but every switch mus have a default
  // log or throw an error about unknown qos
  break;

for now i just suppressed the warnings
*/
MqttClient.prototype._handlePublish = function (packet, done) {
  var topic = packet.topic.toString()
  var message = packet.payload
  var qos = packet.qos
  var mid = packet.messageId
  var that = this

  switch (qos) {
    case 2:
      this.incomingStore.put(packet, function () {
        that._sendPacket({cmd: 'pubrec', messageId: mid}, done)
      })
      break
    case 1:
      // emit the message event
      this.emit('message', topic, message, packet)
      this.handleMessage(packet, function (err) {
        if (err) {
          return done && done(err)
        }
        // send 'puback' if the above 'handleMessage' method executed
        // successfully.
        that._sendPacket({cmd: 'puback', messageId: mid}, done)
      })
      break
    case 0:
      // emit the message event
      this.emit('message', topic, message, packet)
      this.handleMessage(packet, done)
      break
    default:
      // do nothing
      // log or throw an error about unknown qos
      break
  }
}

/**
 * Handle messages with backpressure support, one at a time.
 * Override at will.
 *
 * @param Packet packet the packet
 * @param Function callback call when finished
 * @api public
 */
MqttClient.prototype.handleMessage = function (packet, callback) {
  callback()
}

/**
 * _handleAck
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handleAck = function (packet) {
  /* eslint no-fallthrough: "off" */
  var mid = packet.messageId
  var type = packet.cmd
  var response = null
  var cb = this.outgoing[mid]
  var that = this

  if (!cb) {
    // Server sent an ack in error, ignore it.
    return
  }

  // Process
  switch (type) {
    case 'pubcomp':
      // same thing as puback for QoS 2
    case 'puback':
      // Callback - we're done
      delete this.outgoing[mid]
      this.outgoingStore.del(packet, cb)
      break
    case 'pubrec':
      response = {
        cmd: 'pubrel',
        qos: 2,
        messageId: mid
      }

      this._sendPacket(response)
      break
    case 'suback':
      delete this.outgoing[mid]
      if (packet.granted.length === 1 && (packet.granted[0] & 0x80) !== 0) {
        // suback with Failure status
        var topics = this.messageIdToTopic[mid]
        if (topics) {
          topics.forEach(function (topic) {
            delete that._resubscribeTopics[topic]
          })
        }
      }
      cb(null, packet)
      break
    case 'unsuback':
      delete this.outgoing[mid]
      cb(null)
      break
    default:
      that.emit('error', new Error('unrecognized packet type'))
  }

  if (this.disconnecting &&
      Object.keys(this.outgoing).length === 0) {
    this.emit('outgoingEmpty')
  }
}

/**
 * _handlePubrel
 *
 * @param {Object} packet
 * @api private
 */
MqttClient.prototype._handlePubrel = function (packet, callback) {
  var mid = packet.messageId
  var that = this

  var comp = {cmd: 'pubcomp', messageId: mid}

  that.incomingStore.get(packet, function (err, pub) {
    if (!err && pub.cmd !== 'pubrel') {
      that.emit('message', pub.topic, pub.payload, pub)
      that.incomingStore.put(packet)
      that.handleMessage(pub, function (err) {
        if (err) {
          return callback && callback(err)
        }
        that._sendPacket(comp, callback)
      })
    } else {
      that._sendPacket(comp, callback)
    }
  })
}

/**
 * _nextId
 */
MqttClient.prototype._nextId = function () {
  var id = this.nextId++
  // Ensure 16 bit unsigned int:
  if (id === 65535) {
    this.nextId = 1
  }
  return id
}

/**
 * getLastMessageId
 */
MqttClient.prototype.getLastMessageId = function () {
  return (this.nextId === 1) ? 65535 : (this.nextId - 1)
}

module.exports = MqttClient

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(43)))

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1445 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(89).Buffer;
var util = __webpack_require__(1447);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(580);

/*<replacement>*/
var util = Object.create(__webpack_require__(195));
util.inherits = __webpack_require__(102);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

var wrappy = __webpack_require__(1451)
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}


/***/ }),
/* 1451 */
/***/ (function(module, exports) {

// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.parser = __webpack_require__(1453)
exports.generate = __webpack_require__(1457)
exports.writeToStream = __webpack_require__(583)


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bl = __webpack_require__(1454)
var inherits = __webpack_require__(102)
var EE = __webpack_require__(95).EventEmitter
var Packet = __webpack_require__(1456)
var constants = __webpack_require__(582)

function Parser () {
  if (!(this instanceof Parser)) return new Parser()

  this._states = [
    '_parseHeader',
    '_parseLength',
    '_parsePayload',
    '_newPacket'
  ]

  this._resetState()
}

inherits(Parser, EE)

Parser.prototype._resetState = function () {
  this.packet = new Packet()
  this.error = null
  this._list = bl()
  this._stateCounter = 0
}

Parser.prototype.parse = function (buf) {
  if (this.error) this._resetState()

  this._list.append(buf)

  while ((this.packet.length !== -1 || this._list.length > 0) &&
         this[this._states[this._stateCounter]]() &&
         !this.error) {
    this._stateCounter++

    if (this._stateCounter >= this._states.length) this._stateCounter = 0
  }

  return this._list.length
}

Parser.prototype._parseHeader = function () {
  // There is at least one byte in the buffer
  var zero = this._list.readUInt8(0)
  this.packet.cmd = constants.types[zero >> constants.CMD_SHIFT]
  this.packet.retain = (zero & constants.RETAIN_MASK) !== 0
  this.packet.qos = (zero >> constants.QOS_SHIFT) & constants.QOS_MASK
  this.packet.dup = (zero & constants.DUP_MASK) !== 0

  this._list.consume(1)

  return true
}

Parser.prototype._parseLength = function () {
  // There is at least one byte in the list
  var bytes = 0
  var mul = 1
  var length = 0
  var result = true
  var current

  while (bytes < 5) {
    current = this._list.readUInt8(bytes++)
    length += mul * (current & constants.LENGTH_MASK)
    mul *= 0x80

    if ((current & constants.LENGTH_FIN_MASK) === 0) break
    if (this._list.length <= bytes) {
      result = false
      break
    }
  }

  if (result) {
    this.packet.length = length
    this._list.consume(bytes)
  }

  return result
}

Parser.prototype._parsePayload = function () {
  var result = false

  // Do we have a payload? Do we have enough data to complete the payload?
  // PINGs have no payload
  if (this.packet.length === 0 || this._list.length >= this.packet.length) {
    this._pos = 0

    switch (this.packet.cmd) {
      case 'connect':
        this._parseConnect()
        break
      case 'connack':
        this._parseConnack()
        break
      case 'publish':
        this._parsePublish()
        break
      case 'puback':
      case 'pubrec':
      case 'pubrel':
      case 'pubcomp':
        this._parseMessageId()
        break
      case 'subscribe':
        this._parseSubscribe()
        break
      case 'suback':
        this._parseSuback()
        break
      case 'unsubscribe':
        this._parseUnsubscribe()
        break
      case 'unsuback':
        this._parseUnsuback()
        break
      case 'pingreq':
      case 'pingresp':
      case 'disconnect':
        // These are empty, nothing to do
        break
      default:
        this._emitError(new Error('Not supported'))
    }

    result = true
  }

  return result
}

Parser.prototype._parseConnect = function () {
  var protocolId // Protocol ID
  var clientId // Client ID
  var topic // Will topic
  var payload // Will payload
  var password // Password
  var username // Username
  var flags = {}
  var packet = this.packet

  // Parse protocolId
  protocolId = this._parseString()

  if (protocolId === null) return this._emitError(new Error('Cannot parse protocolId'))
  if (protocolId !== 'MQTT' && protocolId !== 'MQIsdp') {
    return this._emitError(new Error('Invalid protocolId'))
  }

  packet.protocolId = protocolId

  // Parse constants version number
  if (this._pos >= this._list.length) return this._emitError(new Error('Packet too short'))

  packet.protocolVersion = this._list.readUInt8(this._pos)

  if (packet.protocolVersion !== 3 && packet.protocolVersion !== 4) {
    return this._emitError(new Error('Invalid protocol version'))
  }

  this._pos++

  if (this._pos >= this._list.length) {
    return this._emitError(new Error('Packet too short'))
  }

  // Parse connect flags
  flags.username = (this._list.readUInt8(this._pos) & constants.USERNAME_MASK)
  flags.password = (this._list.readUInt8(this._pos) & constants.PASSWORD_MASK)
  flags.will = (this._list.readUInt8(this._pos) & constants.WILL_FLAG_MASK)

  if (flags.will) {
    packet.will = {}
    packet.will.retain = (this._list.readUInt8(this._pos) & constants.WILL_RETAIN_MASK) !== 0
    packet.will.qos = (this._list.readUInt8(this._pos) &
                          constants.WILL_QOS_MASK) >> constants.WILL_QOS_SHIFT
  }

  packet.clean = (this._list.readUInt8(this._pos) & constants.CLEAN_SESSION_MASK) !== 0
  this._pos++

  // Parse keepalive
  packet.keepalive = this._parseNum()
  if (packet.keepalive === -1) return this._emitError(new Error('Packet too short'))

  // Parse clientId
  clientId = this._parseString()
  if (clientId === null) return this._emitError(new Error('Packet too short'))
  packet.clientId = clientId

  if (flags.will) {
    // Parse will topic
    topic = this._parseString()
    if (topic === null) return this._emitError(new Error('Cannot parse will topic'))
    packet.will.topic = topic

    // Parse will payload
    payload = this._parseBuffer()
    if (payload === null) return this._emitError(new Error('Cannot parse will payload'))
    packet.will.payload = payload
  }

  // Parse username
  if (flags.username) {
    username = this._parseString()
    if (username === null) return this._emitError(new Error('Cannot parse username'))
    packet.username = username
  }

  // Parse password
  if (flags.password) {
    password = this._parseBuffer()
    if (password === null) return this._emitError(new Error('Cannot parse password'))
    packet.password = password
  }

  return packet
}

Parser.prototype._parseConnack = function () {
  var packet = this.packet

  if (this._list.length < 2) return null

  packet.sessionPresent = !!(this._list.readUInt8(this._pos++) & constants.SESSIONPRESENT_MASK)
  packet.returnCode = this._list.readUInt8(this._pos)

  if (packet.returnCode === -1) return this._emitError(new Error('Cannot parse return code'))
}

Parser.prototype._parsePublish = function () {
  var packet = this.packet
  packet.topic = this._parseString()

  if (packet.topic === null) return this._emitError(new Error('Cannot parse topic'))

  // Parse messageId
  if (packet.qos > 0) if (!this._parseMessageId()) { return }

  packet.payload = this._list.slice(this._pos, packet.length)
}

Parser.prototype._parseSubscribe = function () {
  var packet = this.packet
  var topic
  var qos

  if (packet.qos !== 1) {
    return this._emitError(new Error('Wrong subscribe header'))
  }

  packet.subscriptions = []

  if (!this._parseMessageId()) { return }

  while (this._pos < packet.length) {
    // Parse topic
    topic = this._parseString()
    if (topic === null) return this._emitError(new Error('Cannot parse topic'))

    if (this._pos >= packet.length) return this._emitError(new Error('Malformed Subscribe Payload'))
    qos = this._list.readUInt8(this._pos++)

    // Push pair to subscriptions
    packet.subscriptions.push({ topic: topic, qos: qos })
  }
}

Parser.prototype._parseSuback = function () {
  this.packet.granted = []

  if (!this._parseMessageId()) { return }

  // Parse granted QoSes
  while (this._pos < this.packet.length) {
    this.packet.granted.push(this._list.readUInt8(this._pos++))
  }
}

Parser.prototype._parseUnsubscribe = function () {
  var packet = this.packet

  packet.unsubscriptions = []

  // Parse messageId
  if (!this._parseMessageId()) { return }

  while (this._pos < packet.length) {
    var topic

    // Parse topic
    topic = this._parseString()
    if (topic === null) return this._emitError(new Error('Cannot parse topic'))

    // Push topic to unsubscriptions
    packet.unsubscriptions.push(topic)
  }
}

Parser.prototype._parseUnsuback = function () {
  if (!this._parseMessageId()) return this._emitError(new Error('Cannot parse messageId'))
}

Parser.prototype._parseMessageId = function () {
  var packet = this.packet

  packet.messageId = this._parseNum()

  if (packet.messageId === null) {
    this._emitError(new Error('Cannot parse messageId'))
    return false
  }

  return true
}

Parser.prototype._parseString = function (maybeBuffer) {
  var length = this._parseNum()
  var result
  var end = length + this._pos

  if (length === -1 || end > this._list.length || end > this.packet.length) return null

  result = this._list.toString('utf8', this._pos, end)
  this._pos += length

  return result
}

Parser.prototype._parseBuffer = function () {
  var length = this._parseNum()
  var result
  var end = length + this._pos

  if (length === -1 || end > this._list.length || end > this.packet.length) return null

  result = this._list.slice(this._pos, end)

  this._pos += length

  return result
}

Parser.prototype._parseNum = function () {
  if (this._list.length - this._pos < 2) return -1

  var result = this._list.readUInt16BE(this._pos)
  this._pos += 2

  return result
}

Parser.prototype._newPacket = function () {
  if (this.packet) {
    this._list.consume(this.packet.length)
    this.emit('packet', this.packet)
  }

  this.packet = new Packet()

  return true
}

Parser.prototype._emitError = function (err) {
  this.error = err
  this.emit('error', err)
}

module.exports = Parser


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var DuplexStream = __webpack_require__(1455)
  , util         = __webpack_require__(245)
  , Buffer       = __webpack_require__(89).Buffer


function BufferList (callback) {
  if (!(this instanceof BufferList))
    return new BufferList(callback)

  this._bufs  = []
  this.length = 0

  if (typeof callback == 'function') {
    this._callback = callback

    var piper = function piper (err) {
      if (this._callback) {
        this._callback(err)
        this._callback = null
      }
    }.bind(this)

    this.on('pipe', function onPipe (src) {
      src.on('error', piper)
    })
    this.on('unpipe', function onUnpipe (src) {
      src.removeListener('error', piper)
    })
  } else {
    this.append(callback)
  }

  DuplexStream.call(this)
}


util.inherits(BufferList, DuplexStream)


BufferList.prototype._offset = function _offset (offset) {
  var tot = 0, i = 0, _t
  if (offset === 0) return [ 0, 0 ]
  for (; i < this._bufs.length; i++) {
    _t = tot + this._bufs[i].length
    if (offset < _t || i == this._bufs.length - 1)
      return [ i, offset - tot ]
    tot = _t
  }
}


BufferList.prototype.append = function append (buf) {
  var i = 0

  if (Buffer.isBuffer(buf)) {
    this._appendBuffer(buf);
  } else if (Array.isArray(buf)) {
    for (; i < buf.length; i++)
      this.append(buf[i])
  } else if (buf instanceof BufferList) {
    // unwrap argument into individual BufferLists
    for (; i < buf._bufs.length; i++)
      this.append(buf._bufs[i])
  } else if (buf != null) {
    // coerce number arguments to strings, since Buffer(number) does
    // uninitialized memory allocation
    if (typeof buf == 'number')
      buf = buf.toString()

    this._appendBuffer(Buffer.from(buf));
  }

  return this
}


BufferList.prototype._appendBuffer = function appendBuffer (buf) {
  this._bufs.push(buf)
  this.length += buf.length
}


BufferList.prototype._write = function _write (buf, encoding, callback) {
  this._appendBuffer(buf)

  if (typeof callback == 'function')
    callback()
}


BufferList.prototype._read = function _read (size) {
  if (!this.length)
    return this.push(null)

  size = Math.min(size, this.length)
  this.push(this.slice(0, size))
  this.consume(size)
}


BufferList.prototype.end = function end (chunk) {
  DuplexStream.prototype.end.call(this, chunk)

  if (this._callback) {
    this._callback(null, this.slice())
    this._callback = null
  }
}


BufferList.prototype.get = function get (index) {
  return this.slice(index, index + 1)[0]
}


BufferList.prototype.slice = function slice (start, end) {
  if (typeof start == 'number' && start < 0)
    start += this.length
  if (typeof end == 'number' && end < 0)
    end += this.length
  return this.copy(null, 0, start, end)
}


BufferList.prototype.copy = function copy (dst, dstStart, srcStart, srcEnd) {
  if (typeof srcStart != 'number' || srcStart < 0)
    srcStart = 0
  if (typeof srcEnd != 'number' || srcEnd > this.length)
    srcEnd = this.length
  if (srcStart >= this.length)
    return dst || Buffer.alloc(0)
  if (srcEnd <= 0)
    return dst || Buffer.alloc(0)

  var copy   = !!dst
    , off    = this._offset(srcStart)
    , len    = srcEnd - srcStart
    , bytes  = len
    , bufoff = (copy && dstStart) || 0
    , start  = off[1]
    , l
    , i

  // copy/slice everything
  if (srcStart === 0 && srcEnd == this.length) {
    if (!copy) { // slice, but full concat if multiple buffers
      return this._bufs.length === 1
        ? this._bufs[0]
        : Buffer.concat(this._bufs, this.length)
    }

    // copy, need to copy individual buffers
    for (i = 0; i < this._bufs.length; i++) {
      this._bufs[i].copy(dst, bufoff)
      bufoff += this._bufs[i].length
    }

    return dst
  }

  // easy, cheap case where it's a subset of one of the buffers
  if (bytes <= this._bufs[off[0]].length - start) {
    return copy
      ? this._bufs[off[0]].copy(dst, dstStart, start, start + bytes)
      : this._bufs[off[0]].slice(start, start + bytes)
  }

  if (!copy) // a slice, we need something to copy in to
    dst = Buffer.allocUnsafe(len)

  for (i = off[0]; i < this._bufs.length; i++) {
    l = this._bufs[i].length - start

    if (bytes > l) {
      this._bufs[i].copy(dst, bufoff, start)
      bufoff += l
    } else {
      this._bufs[i].copy(dst, bufoff, start, start + bytes)
      bufoff += l
      break
    }

    bytes -= l

    if (start)
      start = 0
  }

  // safeguard so that we don't return uninitialized memory
  if (dst.length > bufoff) return dst.slice(0, bufoff)

  return dst
}

BufferList.prototype.shallowSlice = function shallowSlice (start, end) {
  start = start || 0
  end = end || this.length

  if (start < 0)
    start += this.length
  if (end < 0)
    end += this.length

  var startOffset = this._offset(start)
    , endOffset = this._offset(end)
    , buffers = this._bufs.slice(startOffset[0], endOffset[0] + 1)

  if (endOffset[1] == 0)
    buffers.pop()
  else
    buffers[buffers.length-1] = buffers[buffers.length-1].slice(0, endOffset[1])

  if (startOffset[1] != 0)
    buffers[0] = buffers[0].slice(startOffset[1])

  return new BufferList(buffers)
}

BufferList.prototype.toString = function toString (encoding, start, end) {
  return this.slice(start, end).toString(encoding)
}

BufferList.prototype.consume = function consume (bytes) {
  // first, normalize the argument, in accordance with how Buffer does it
  bytes = Math.trunc(bytes)
  // do nothing if not a positive number
  if (Number.isNaN(bytes) || bytes <= 0) return this

  while (this._bufs.length) {
    if (bytes >= this._bufs[0].length) {
      bytes -= this._bufs[0].length
      this.length -= this._bufs[0].length
      this._bufs.shift()
    } else {
      this._bufs[0] = this._bufs[0].slice(bytes)
      this.length -= bytes
      break
    }
  }
  return this
}


BufferList.prototype.duplicate = function duplicate () {
  var i = 0
    , copy = new BufferList()

  for (; i < this._bufs.length; i++)
    copy.append(this._bufs[i])

  return copy
}


BufferList.prototype.destroy = function destroy () {
  this._bufs.length = 0
  this.length = 0
  this.push(null)
}


;(function () {
  var methods = {
      'readDoubleBE' : 8
    , 'readDoubleLE' : 8
    , 'readFloatBE'  : 4
    , 'readFloatLE'  : 4
    , 'readInt32BE'  : 4
    , 'readInt32LE'  : 4
    , 'readUInt32BE' : 4
    , 'readUInt32LE' : 4
    , 'readInt16BE'  : 2
    , 'readInt16LE'  : 2
    , 'readUInt16BE' : 2
    , 'readUInt16LE' : 2
    , 'readInt8'     : 1
    , 'readUInt8'    : 1
  }

  for (var m in methods) {
    (function (m) {
      BufferList.prototype[m] = function (offset) {
        return this.slice(offset, offset + methods[m])[m](0)
      }
    }(m))
  }
}())


module.exports = BufferList


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(139);


/***/ }),
/* 1456 */
/***/ (function(module, exports) {


function Packet () {
  this.cmd = null
  this.retain = false
  this.qos = 0
  this.dup = false
  this.length = -1
  this.topic = null
  this.payload = null
}

module.exports = Packet


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(89).Buffer
var writeToStream = __webpack_require__(583)
var EE = __webpack_require__(95).EventEmitter
var inherits = __webpack_require__(102)

function generate (packet) {
  var stream = new Accumulator()
  writeToStream(packet, stream)
  return stream.concat()
}

function Accumulator () {
  this._array = new Array(20)
  this._i = 0
}

inherits(Accumulator, EE)

Accumulator.prototype.write = function (chunk) {
  this._array[this._i++] = chunk
  return true
}

Accumulator.prototype.concat = function () {
  var length = 0
  var lengths = new Array(this._array.length)
  var list = this._array
  var pos = 0
  var i
  var result

  for (i = 0; i < list.length && list[i] !== undefined; i++) {
    if (typeof list[i] !== 'string') lengths[i] = list[i].length
    else lengths[i] = Buffer.byteLength(list[i])

    length += lengths[i]
  }

  result = Buffer.allocUnsafe(length)

  for (i = 0; i < list.length && list[i] !== undefined; i++) {
    if (typeof list[i] !== 'string') {
      list[i].copy(result, pos)
      pos += lengths[i]
    } else {
      result.write(list[i], pos)
      pos += lengths[i]
    }
  }

  return result
}

module.exports = generate


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(89).Buffer
var max = 65536
var cache = {}

function generateBuffer (i) {
  var buffer = Buffer.allocUnsafe(2)
  buffer.writeUInt8(i >> 8, 0)
  buffer.writeUInt8(i & 0x00FF, 0 + 1)

  return buffer
}

function generateCache () {
  for (var i = 0; i < max; i++) {
    cache[i] = generateBuffer(i)
  }
}

module.exports = {
  cache: cache,
  generateCache: generateCache,
  generateNumber: generateBuffer
}


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ReInterval (callback, interval, args) {
  var self = this;

  this._callback = callback;
  this._args = args;

  this._interval = setInterval(callback, interval, this._args);

  this.reschedule = function (interval) {
    // if no interval entered, use the interval passed in on creation
    if (!interval)
      interval = self._interval;

    if (self._interval)
      clearInterval(self._interval);
    self._interval = setInterval(self._callback, interval, self._args);
  };

  this.clear = function () {
    if (self._interval) {
      clearInterval(self._interval);
      self._interval = undefined;
    }
  };
  
  this.destroy = function () {
    if (self._interval) {
      clearInterval(self._interval);
    }
    self._callback = undefined;
    self._interval = undefined;
    self._args = undefined;
  };
}

function reInterval () {
  if (typeof arguments[0] !== 'function')
    throw new Error('callback needed');
  if (typeof arguments[1] !== 'number')
    throw new Error('interval needed');

  var args;

  if (arguments.length > 0) {
    args = new Array(arguments.length - 2);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 2];
    }
  }

  return new ReInterval(arguments[0], arguments[1], args);
}

module.exports = reInterval;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Validate a topic to see if it's valid or not.
 * A topic is valid if it follow below rules:
 * - Rule #1: If any part of the topic is not `+` or `#`, then it must not contain `+` and '#'
 * - Rule #2: Part `#` must be located at the end of the mailbox
 *
 * @param {String} topic - A topic
 * @returns {Boolean} If the topic is valid, returns true. Otherwise, returns false.
 */
function validateTopic (topic) {
  var parts = topic.split('/')

  for (var i = 0; i < parts.length; i++) {
    if (parts[i] === '+') {
      continue
    }

    if (parts[i] === '#') {
      // for Rule #2
      return i === parts.length - 1
    }

    if (parts[i].indexOf('+') !== -1 || parts[i].indexOf('#') !== -1) {
      return false
    }
  }

  return true
}

/**
 * Validate an array of topics to see if any of them is valid or not
  * @param {Array} topics - Array of topics
 * @returns {String} If the topics is valid, returns null. Otherwise, returns the invalid one
 */
function validateTopics (topics) {
  if (topics.length === 0) {
    return 'empty_topic_list'
  }
  for (var i = 0; i < topics.length; i++) {
    if (!validateTopic(topics[i])) {
      return topics[i]
    }
  }
  return null
}

module.exports = {
  validateTopics: validateTopics
}


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module), __webpack_require__(28)))

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1464);
exports.encode = exports.stringify = __webpack_require__(1465);


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1466 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {var stream = __webpack_require__(246)
var eos = __webpack_require__(581)
var inherits = __webpack_require__(102)
var shift = __webpack_require__(1469)

var SIGNAL_FLUSH = (Buffer.from && Buffer.from !== Uint8Array.from)
  ? Buffer.from([0])
  : new Buffer([0])

var onuncork = function(self, fn) {
  if (self._corked) self.once('uncork', fn)
  else fn()
}

var autoDestroy = function (self, err) {
  if (self._autoDestroy) self.destroy(err)
}

var destroyer = function(self, end) {
  return function(err) {
    if (err) autoDestroy(self, err.message === 'premature close' ? null : err)
    else if (end && !self._ended) self.end()
  }
}

var end = function(ws, fn) {
  if (!ws) return fn()
  if (ws._writableState && ws._writableState.finished) return fn()
  if (ws._writableState) return ws.end(fn)
  ws.end()
  fn()
}

var toStreams2 = function(rs) {
  return new (stream.Readable)({objectMode:true, highWaterMark:16}).wrap(rs)
}

var Duplexify = function(writable, readable, opts) {
  if (!(this instanceof Duplexify)) return new Duplexify(writable, readable, opts)
  stream.Duplex.call(this, opts)

  this._writable = null
  this._readable = null
  this._readable2 = null

  this._autoDestroy = !opts || opts.autoDestroy !== false
  this._forwardDestroy = !opts || opts.destroy !== false
  this._forwardEnd = !opts || opts.end !== false
  this._corked = 1 // start corked
  this._ondrain = null
  this._drained = false
  this._forwarding = false
  this._unwrite = null
  this._unread = null
  this._ended = false

  this.destroyed = false

  if (writable) this.setWritable(writable)
  if (readable) this.setReadable(readable)
}

inherits(Duplexify, stream.Duplex)

Duplexify.obj = function(writable, readable, opts) {
  if (!opts) opts = {}
  opts.objectMode = true
  opts.highWaterMark = 16
  return new Duplexify(writable, readable, opts)
}

Duplexify.prototype.cork = function() {
  if (++this._corked === 1) this.emit('cork')
}

Duplexify.prototype.uncork = function() {
  if (this._corked && --this._corked === 0) this.emit('uncork')
}

Duplexify.prototype.setWritable = function(writable) {
  if (this._unwrite) this._unwrite()

  if (this.destroyed) {
    if (writable && writable.destroy) writable.destroy()
    return
  }

  if (writable === null || writable === false) {
    this.end()
    return
  }

  var self = this
  var unend = eos(writable, {writable:true, readable:false}, destroyer(this, this._forwardEnd))

  var ondrain = function() {
    var ondrain = self._ondrain
    self._ondrain = null
    if (ondrain) ondrain()
  }

  var clear = function() {
    self._writable.removeListener('drain', ondrain)
    unend()
  }

  if (this._unwrite) process.nextTick(ondrain) // force a drain on stream reset to avoid livelocks

  this._writable = writable
  this._writable.on('drain', ondrain)
  this._unwrite = clear

  this.uncork() // always uncork setWritable
}

Duplexify.prototype.setReadable = function(readable) {
  if (this._unread) this._unread()

  if (this.destroyed) {
    if (readable && readable.destroy) readable.destroy()
    return
  }

  if (readable === null || readable === false) {
    this.push(null)
    this.resume()
    return
  }

  var self = this
  var unend = eos(readable, {writable:false, readable:true}, destroyer(this))

  var onreadable = function() {
    self._forward()
  }

  var onend = function() {
    self.push(null)
  }

  var clear = function() {
    self._readable2.removeListener('readable', onreadable)
    self._readable2.removeListener('end', onend)
    unend()
  }

  this._drained = true
  this._readable = readable
  this._readable2 = readable._readableState ? readable : toStreams2(readable)
  this._readable2.on('readable', onreadable)
  this._readable2.on('end', onend)
  this._unread = clear

  this._forward()
}

Duplexify.prototype._read = function() {
  this._drained = true
  this._forward()
}

Duplexify.prototype._forward = function() {
  if (this._forwarding || !this._readable2 || !this._drained) return
  this._forwarding = true

  var data

  while (this._drained && (data = shift(this._readable2)) !== null) {
    if (this.destroyed) continue
    this._drained = this.push(data)
  }

  this._forwarding = false
}

Duplexify.prototype.destroy = function(err) {
  if (this.destroyed) return
  this.destroyed = true

  var self = this
  process.nextTick(function() {
    self._destroy(err)
  })
}

Duplexify.prototype._destroy = function(err) {
  if (err) {
    var ondrain = this._ondrain
    this._ondrain = null
    if (ondrain) ondrain(err)
    else this.emit('error', err)
  }

  if (this._forwardDestroy) {
    if (this._readable && this._readable.destroy) this._readable.destroy()
    if (this._writable && this._writable.destroy) this._writable.destroy()
  }

  this.emit('close')
}

Duplexify.prototype._write = function(data, enc, cb) {
  if (this.destroyed) return cb()
  if (this._corked) return onuncork(this, this._write.bind(this, data, enc, cb))
  if (data === SIGNAL_FLUSH) return this._finish(cb)
  if (!this._writable) return cb()

  if (this._writable.write(data) === false) this._ondrain = cb
  else cb()
}

Duplexify.prototype._finish = function(cb) {
  var self = this
  this.emit('preend')
  onuncork(this, function() {
    end(self._forwardEnd && self._writable, function() {
      // haxx to not emit prefinish twice
      if (self._writableState.prefinished === false) self._writableState.prefinished = true
      self.emit('prefinish')
      onuncork(self, cb)
    })
  })
}

Duplexify.prototype.end = function(data, enc, cb) {
  if (typeof data === 'function') return this.end(null, null, data)
  if (typeof enc === 'function') return this.end(data, null, enc)
  this._ended = true
  if (data) this.write(data)
  if (!this._writableState.ending) this.write(SIGNAL_FLUSH)
  return stream.Writable.prototype.end.call(this, cb)
}

module.exports = Duplexify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101).Buffer, __webpack_require__(43)))

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

module.exports = shift

function shift (stream) {
  var rs = stream._readableState
  if (!rs) return null
  return (rs.objectMode || typeof stream._duplexState === 'number') ? stream.read() : stream.read(getStateLength(rs))
}

function getStateLength (state) {
  if (state.buffer.length) {
    // Since node 6.3.0 state.buffer is a BufferList not an array
    if (state.buffer.head) {
      return state.buffer.head.data.length
    }

    return state.buffer[0].length
  }

  return state.length
}


/***/ }),
/* 1470 */
/***/ (function(module, exports) {


var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
}

module.exports = ws


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(247), __webpack_require__(1472), __webpack_require__(1473), __webpack_require__(162), __webpack_require__(163), __webpack_require__(368), __webpack_require__(587), __webpack_require__(1474), __webpack_require__(588), __webpack_require__(1475), __webpack_require__(1476), __webpack_require__(1477), __webpack_require__(369), __webpack_require__(1478), __webpack_require__(164), __webpack_require__(42), __webpack_require__(1479), __webpack_require__(1480), __webpack_require__(1481), __webpack_require__(1482), __webpack_require__(1483), __webpack_require__(1484), __webpack_require__(1485), __webpack_require__(1486), __webpack_require__(1487), __webpack_require__(1488), __webpack_require__(1489), __webpack_require__(1490), __webpack_require__(1491), __webpack_require__(1492), __webpack_require__(1493), __webpack_require__(1494));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(587));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(247), __webpack_require__(588));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(247));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(368), __webpack_require__(369));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(162), __webpack_require__(163), __webpack_require__(164), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(162), __webpack_require__(163), __webpack_require__(164), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(162), __webpack_require__(163), __webpack_require__(164), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(162), __webpack_require__(163), __webpack_require__(164), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(22), __webpack_require__(162), __webpack_require__(163), __webpack_require__(164), __webpack_require__(42));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps

//app deps

//begin module
module.exports = {
   INVALID_CONNECT_OPTIONS: 'Invalid connect options supplied.',
   INVALID_CLIENT_ID_OPTION: 'Invalid "clientId" (mqtt client id) option supplied.',
   INVALID_RECONNECT_TIMING: 'Invalid reconnect timing options supplied.',
   INVALID_OFFLINE_QUEUEING_PARAMETERS: 'Invalid offline queueing options supplied.'
};


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
var filesys = __webpack_require__(370);

//npm deps

//app deps
var isUndefined = __webpack_require__(248);
var exceptions = __webpack_require__(1497);

//begin module
/**
 * This method is the exposed module; it validates and prepares the tls
 * options as required for connection to the AWS IoT service.
 *
 * @param {Object} options
 * @access public
 */
module.exports = function(options) {

   // verify certificate paths
   if (isUndefined(options.keyPath) && isUndefined(options.privateKey)) {
      throw new Error(exceptions.NO_KEY_OPTION);
   }
   if (isUndefined(options.certPath) && isUndefined(options.clientCert)) {
      throw new Error(exceptions.NO_CERT_OPTION);
   }
   if (isUndefined(options.caPath) && isUndefined(options.caCert)) {
      throw new Error(exceptions.NO_CA_OPTION);
   }
   //
   // Certificates and private keys may be passed in files using options
   // ending in 'Path', e.g. 'keyPath', 'certPath', and 'caPath'.  In addition,
   // they can also be passed in as buffers or files using the options
   // 'privateKey', 'clientCert', and 'caCert'.  This second set is the one
   // that the AWS Console generates a JSON configuration document for.
   //
   if (!isUndefined(options.caCert)) {
      if (Buffer.isBuffer(options.caCert)) {
         options.ca = options.caCert;
      } else {
         if (filesys.existsSync(options.caCert)) {
            options.ca = filesys.readFileSync(options.caCert);
         } else {
            throw new Error(exceptions.INVALID_CA_CERT_OPTION);
         }
      }
   }
   if (!isUndefined(options.privateKey)) {
      if (Buffer.isBuffer(options.privateKey)) {
         options.key = options.privateKey;
      } else {
         if (filesys.existsSync(options.privateKey)) {
            options.key = filesys.readFileSync(options.privateKey);
         } else {
            throw new Error(exceptions.INVALID_PRIVATE_KEY_OPTION);
         }
      }
   }
   if (!isUndefined(options.clientCert)) {
      if (Buffer.isBuffer(options.clientCert)) {
         options.cert = options.clientCert;
      } else {
         if (filesys.existsSync(options.clientCert)) {
            options.cert = filesys.readFileSync(options.clientCert);
         } else {
            throw new Error(exceptions.INVALID_CLIENT_CERT_OPTION);
         }
      }
   }

   // Parse PEM files.  Options ending in 'Path' must be files
   // and will override options which do not end in 'Path'.

   if (filesys.existsSync(options.keyPath)) {
      options.key = filesys.readFileSync(options.keyPath);
   } else if (!isUndefined(options.keyPath)) {
      throw new Error(exceptions.INVALID_KEY_PATH_OPTION);
   }
   if (filesys.existsSync(options.certPath)) {
      options.cert = filesys.readFileSync(options.certPath);
   } else if (!isUndefined(options.certPath)) {
      throw new Error(exceptions.INVALID_CERT_PATH_OPTION);
   }
   if (filesys.existsSync(options.caPath)) {
      options.ca = filesys.readFileSync(options.caPath);
   } else if (!isUndefined(options.caPath)) {
      throw new Error(exceptions.INVALID_CA_PATH_OPTION);
   }

   // request certificate from partner
   options.requestCert = true;

   // require certificate authentication
   options.rejectUnauthorized = true;

};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101).Buffer))

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps

//app deps

//begin module
module.exports = {
   NO_KEY_OPTION: 'No "keyPath" or "privateKey" option supplied.',
   NO_CERT_OPTION: 'No "certPath" or "clientCert" option supplied.',
   NO_CA_OPTION: 'No "caPath" or "caCert" option supplied.',
   INVALID_KEY_PATH_OPTION: 'Invalid "keyPath" option supplied.',
   INVALID_CERT_PATH_OPTION: 'Invalid "certPath" option supplied.',
   INVALID_CA_PATH_OPTION: 'Invalid "caPath" option supplied.',
   INVALID_CLIENT_CERT_OPTION: 'Invalid "clientCert" option supplied.',
   INVALID_PRIVATE_KEY_OPTION: 'Invalid "privateKey" option supplied.',
   INVALID_CA_CERT_OPTION: 'Invalid "caCert" option supplied.'
};


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports = {"_from":"aws-iot-device-sdk@2.2.1","_id":"aws-iot-device-sdk@2.2.1","_inBundle":false,"_integrity":"sha1-Dff6i0xSBNJNil9yoSzkMwGwnFM=","_location":"/aws-iot-device-sdk","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"aws-iot-device-sdk@2.2.1","name":"aws-iot-device-sdk","escapedName":"aws-iot-device-sdk","rawSpec":"2.2.1","saveSpec":null,"fetchSpec":"2.2.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/aws-iot-device-sdk/-/aws-iot-device-sdk-2.2.1.tgz","_shasum":"0df7fa8b4c5204d24d8a5f72a12ce43301b09c53","_spec":"aws-iot-device-sdk@2.2.1","_where":"F:\\Australia Projects\\senstra04052022\\heartbeat-dashboard","author":{"name":"Amazon Web Services","url":"http://aws.amazon.com"},"bugs":{"url":"http://github.com/aws/aws-iot-device-sdk-js/issues"},"bundleDependencies":false,"dependencies":{"crypto-js":"3.1.6","minimist":"1.2.0","mqtt":"2.15.1","websocket-stream":"^5.0.1"},"deprecated":false,"description":"AWS IoT Node.js SDK for Embedded Devices","devDependencies":{"gulp":"^3.9.0","gulp-beautify":"^2.0.0","gulp-concat":"^2.6.0","gulp-coverage":"^0.3.38","gulp-jscs":"^4.0.0","gulp-jshint":"^2.0.0","gulp-mocha":"^3.0.1","jshint":"^2.9.1","jshint-stylish":"^2.2.1","rewire":"^2.5.1","sinon":"^1.17.3"},"engines":{"node":">=4.0.0"},"homepage":"https://github.com/aws/aws-iot-device-sdk-js","keywords":["api","amazon","aws","iot","mqtt"],"license":"Apache-2.0","main":"index.js","name":"aws-iot-device-sdk","repository":{"type":"git","url":"git://github.com/aws/aws-iot-device-sdk-js.git"},"scripts":{"beautify":"node ./node_modules/gulp/bin/gulp.js beautify","browserize":"./scripts/browserize.sh","test":"node ./node_modules/gulp/bin/gulp.js test --verbose"},"version":"2.2.1"}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
var tls = __webpack_require__(370);

//npm deps

//app deps

function buildBuilder(mqttClient, opts) {
   var connection;

   connection = tls.connect(opts);

   function handleTLSerrors(err) {
      mqttClient.emit('error', err);
      connection.end();
   }

   connection.on('secureConnect', function() {
      if (!connection.authorized) {
         connection.emit('error', new Error('TLS not authorized'));
      } else {
         connection.removeListener('error', handleTLSerrors);
      }
   });

   connection.on('error', handleTLSerrors);
   return connection;
}

module.exports = buildBuilder;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps
const websocket = __webpack_require__(367);

//app deps

function buildBuilder(client, opts) {
   return websocket(opts.url, ['mqttv3.1'], opts.websocketOptions);
}

module.exports = buildBuilder;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
var events = __webpack_require__(95);
var inherits = __webpack_require__(245).inherits;

//npm deps

//app deps
var deviceModule = __webpack_require__(363);
var isUndefined = __webpack_require__(248);

//
// private functions
//
function buildThingShadowTopic(thingName, operation, type) {
   if (!isUndefined(type)) {
      return '$aws/things/' + thingName + '/shadow/' + operation + '/' + type;
   }
   return '$aws/things/' + thingName + '/shadow/' + operation;
}

function isReservedTopic(topic) {
   if (topic.substring(0, 12) === '$aws/things/') {
      return true;
   }
   return false;
}

function isThingShadowTopic(topicTokens, direction) {
   var rc = false;
   if (topicTokens[0] === '$aws') {
      //
      // Thing shadow topics have the form:
      //
      //      $aws/things/{thingName}/shadow/{Operation}/{Status}
      //
      // Where {Operation} === update|get|delete
      //   And    {Status} === accepted|rejected|delta
      //
      if ((topicTokens[1] === 'things') &&
         (topicTokens[3] === 'shadow') &&
         ((topicTokens[4] === 'update') ||
            (topicTokens[4] === 'get') ||
            (topicTokens[4] === 'delete'))) {
         //
         // Looks good so far; now check the direction and see if
         // still makes sense.
         //
         if (direction === 'subscribe') {
            if (((topicTokens[5] === 'accepted') ||
                  (topicTokens[5] === 'rejected') ||
                  (topicTokens[5] === 'delta')) &&
               (topicTokens.length === 6)) {
               rc = true;
            }
         } else // direction === 'publish'
         {
            if (topicTokens.length === 5) {
               rc = true;
            }
         }
      }
   }
   return rc;
}

//begin module

function ThingShadowsClient(deviceOptions, thingShadowOptions) {
   //
   // Force instantiation using the 'new' operator; this will cause inherited
   // constructors (e.g. the 'events' class) to be called.
   //
   if (!(this instanceof ThingShadowsClient)) {
      return new ThingShadowsClient(deviceOptions, thingShadowOptions);
   }

   //
   // A copy of 'this' for use inside of closures
   //
   var that = this;

   //
   // Track Thing Shadow registrations in here.
   //
   var thingShadows = [{}];

   //
   // Implements for every operation, used to construct clientToken.
   //
   var operationCount = 0;

   //
   // Operation timeout (milliseconds).  If no accepted or rejected response
   // to a thing operation is received within this time, subscriptions
   // to the accepted and rejected sub-topics for a thing are cancelled.
   //
   var operationTimeout = 10000; /* milliseconds */

   //
   // Variable used by the testing API setConnectionStatus() to simulate
   // network connectivity failures.
   //
   var connected = true;

   //
   // Instantiate the device.
   //
   var device = deviceModule.DeviceClient(deviceOptions);

   if (!isUndefined(thingShadowOptions)) {
      if (!isUndefined(thingShadowOptions.operationTimeout)) {
         operationTimeout = thingShadowOptions.operationTimeout;
      }
   }

   //
   // Private function to subscribe and unsubscribe from topics.
   //
   this._handleSubscriptions = function(thingName, topicSpecs, devFunction, callback) {
      var topics = [];

      //
      // Build an array of topic names.
      //
      for (var i = 0, topicsLen = topicSpecs.length; i < topicsLen; i++) {
         for (var j = 0, opsLen = topicSpecs[i].operations.length; j < opsLen; j++) {
            for (var k = 0, statLen = topicSpecs[i].statii.length; k < statLen; k++) {
               topics.push(buildThingShadowTopic(thingName,
                  topicSpecs[i].operations[j],
                  topicSpecs[i].statii[k]));
            }
         }
      }

      if (thingShadows[thingName].debug === true) {
         console.log(devFunction + ' on ' + topics);
      }
      //
      // Subscribe/unsubscribe from the topics and perform callback when complete.
      //
      var args = [];
      args.push(topics);
      if (devFunction === 'subscribe') {
         // QoS only applicable for subscribe
         args.push({
            qos: thingShadows[thingName].qos
         });
         // add our callback to check the SUBACK response for granted subscriptions
         args.push(function(err, granted) {
            if (!isUndefined(callback)) {
               if (err) {
                  callback(err);
                  return;
               }
               //
               // Check to see if we got all topic subscriptions granted.
               //
              var failedTopics = [];
              for (var k = 0, grantedLen = granted.length; k < grantedLen; k++) {
                 //
                 // 128 is 0x80 - Failure from the MQTT lib.
                 //
                 if (granted[k].qos === 128) {
                    failedTopics.push(granted[k]);
                 }
              }

              if (failedTopics.length > 0) {
                 callback('Not all subscriptions were granted', failedTopics);
                 return;
              }

              // all subscriptions were granted
              callback();
            }
         });
      } else {
         if (!isUndefined(callback)) {
            args.push(callback);
         }
      }

      device[devFunction].apply(device, args);
   };

   //
   // Private function to handle messages and dispatch them accordingly.
   //
   this._handleMessages = function(thingName, operation, operationStatus, payload) {
      var stateObject = {};
      try {
         stateObject = JSON.parse(payload.toString());
      } catch (err) {
         if (deviceOptions.debug === true) {
            console.error('failed parsing JSON \'' + payload.toString() + '\', ' + err);
         }
         return;
      }
      var clientToken = stateObject.clientToken;
      var version = stateObject.version;
      //
      // Remove the properties 'clientToken' and 'version' from the stateObject;
      // these properties are internal to this class.
      //
      delete stateObject.clientToken;
      //Expose shadow version from raw object
      //delete stateObject.version;
      //
      // Update the thing version on every accepted or delta message which 
      // contains it.
      //
      if ((!isUndefined(version)) && (operationStatus !== 'rejected')) {
         //
         // The thing shadow version is incremented by AWS IoT and should always
         // increase.  Do not update our local version if the received version is
         // less than our version.  
         //
         if ((isUndefined(thingShadows[thingName].version)) ||
            (version >= thingShadows[thingName].version)) {
            thingShadows[thingName].version = version;
         } else {
            //
            // We've received a message from AWS IoT with a version number lower than
            // we would expect.  There are two things that can cause this:
            //
            //  1) The shadow has been deleted (version # reverts to 1 in this case.)
            //  2) The message has arrived out-of-order.
            //
            // For case 1) we can look at the operation to determine that this
            // is the case and notify the client if appropriate.  For case 2, 
            // we will not process it unless the client has specifically expressed
            // an interested in these messages by setting 'discardStale' to false.
            //
            if (operation !== 'delete' && thingShadows[thingName].discardStale === true) {
               if (deviceOptions.debug === true) {
                  console.warn('out-of-date version \'' + version + '\' on \'' +
                     thingName + '\' (local version \'' +
                     thingShadows[thingName].version + '\')');
               }
               return;
            }
         }
      }
      //
      // If this is a 'delta' message, emit an event for it and return.
      //
      if (operationStatus === 'delta') {
         this.emit('delta', thingName, stateObject);
         return;
      }
      //
      // only accepted/rejected messages past this point
      // ===============================================
      // If this is an unkown clientToken (e.g., it doesn't have a corresponding
      // client token property, the shadow has been modified by another client.
      // If it's an update/accepted or delete/accepted, update the shadow and
      // notify the client.
      //
      if (isUndefined(thingShadows[thingName].clientToken) ||
         thingShadows[thingName].clientToken !== clientToken) {
         if ((operationStatus === 'accepted') && (operation !== 'get')) {
            //
            // This is a foreign update or delete accepted, update our
            // shadow with the latest state and send a notification.
            //
            this.emit('foreignStateChange', thingName, operation, stateObject);
         }
         return;
      }
      //
      // A response has been received, so cancel any outstanding timeout on this
      // thingName/clientToken, delete the timeout handle, and unsubscribe from
      // all sub-topics.
      //
      clearTimeout(
         thingShadows[thingName].timeout);

      delete thingShadows[thingName].timeout;
      //
      // Delete the operation's client token.
      //
      delete thingShadows[thingName].clientToken;
      //
      // Mark this operation as complete.
      //
      thingShadows[thingName].pending = false;

      //
      // Unsubscribe from the 'accepted' and 'rejected' sub-topics unless we are
      // persistently subscribed to this thing shadow.
      //
      if (thingShadows[thingName].persistentSubscribe === false) {
         this._handleSubscriptions(thingName, [{
            operations: [operation],
            statii: ['accepted', 'rejected']
         }], 'unsubscribe');
      }

      //
      // Emit an event detailing the operation status; the clientToken is included
      // as an argument so that the application can correlate status events to
      // the operations they are associated with.
      //
      this.emit('status', thingName, operationStatus, clientToken, stateObject);
   };

   device.on('connect', function() {
      that.emit('connect');
   });
   device.on('close', function() {
      that.emit('close');
   });
   device.on('reconnect', function() {
      that.emit('reconnect');
   });
   device.on('offline', function() {
      that.emit('offline');
   });
   device.on('error', function(error) {
      that.emit('error', error);
   });
   device.on('packetsend', function(packet) {
      that.emit('packetsend', packet);
   });
   device.on('packetreceive', function(packet) {
      that.emit('packetreceive', packet);
   });
   device.on('message', function(topic, payload) {

      if (connected === true) {
         //
         // Parse the topic to determine what to do with it.
         //
         var topicTokens = topic.split('/');
         //
         // First, do a rough check to see if we should continue or not.
         //
         if (isThingShadowTopic(topicTokens, 'subscribe')) {
            //
            // This looks like a valid Thing topic, so see if the Thing is in the
            // registered Thing table.
            //
            if (thingShadows.hasOwnProperty(topicTokens[2])) {
               //
               // This is a registered Thing, so perform message handling on it.
               //
               that._handleMessages(topicTokens[2], // thingName
                  topicTokens[4], // operation
                  topicTokens[5], // status
                  payload);
            }
            //
            // Any messages received for unregistered Things fall here and are ignored.
            //
         } else {
            //
            // This isn't a Thing topic, so pass it along to the instance if they have
            // indicated they want to handle it.
            //
            that.emit('message', topic, payload);
         }
      }
   });

   this._thingOperation = function(thingName, operation, stateObject) {
      var rc = null;

      if (thingShadows.hasOwnProperty(thingName)) {
         //
         // Don't allow a new operation if an existing one is still in process.
         //
         if (thingShadows[thingName].pending === false) {
            //
            // Starting a new operation
            //
            thingShadows[thingName].pending = true;
            //
            // If not provided, construct a clientToken from the clientId and a rolling 
            // operation count.  The clientToken is transmitted in any published stateObject 
            // and is returned to the caller for each operation.  Applications can use
            // clientToken values to correlate received responses or timeouts with
            // the original operations.
            //
            var clientToken;

            if (isUndefined(stateObject.clientToken)) {
               //
               // AWS IoT restricts client tokens to 64 bytes, so use only the last 48
               // characters of the client ID when constructing a client token.
               //
               var clientIdLength = deviceOptions.clientId.length;

               if (clientIdLength > 48) {
                  clientToken = deviceOptions.clientId.substr(clientIdLength - 48) + '-' + operationCount++;
               } else {
                  clientToken = deviceOptions.clientId + '-' + operationCount++;
               }
            } else {
               clientToken = stateObject.clientToken;
            }
            //
            // Remember the client token for this operation; it will be
            // deleted when the operation completes or times out.
            //
            thingShadows[thingName].clientToken = clientToken;

            var publishTopic = buildThingShadowTopic(thingName,
               operation);
            //
            // Subscribe to the 'accepted' and 'rejected' sub-topics for this get
            // operation and set a timeout beyond which they will be unsubscribed if 
            // no messages have been received for either of them.
            //
            thingShadows[thingName].timeout = setTimeout(
               function(thingName, clientToken) {
                  //
                  // Timed-out.  Unsubscribe from the 'accepted' and 'rejected' sub-topics unless
                  // we are persistently subscribing to this thing shadow.
                  //
                  if (thingShadows[thingName].persistentSubscribe === false) {
                     that._handleSubscriptions(thingName, [{
                        operations: [operation],
                        statii: ['accepted', 'rejected']
                     }], 'unsubscribe');
                  }
                  //
                  // Mark this operation as complete.
                  //
                  thingShadows[thingName].pending = false;
                  //
                  // Emit an event for the timeout; the clientToken is included as an argument
                  // so that the application can correlate timeout events to the operations
                  // they are associated with.
                  //
                  that.emit('timeout', thingName, clientToken);
                  //
                  // Delete the timeout handle and client token for this thingName.
                  //
                  delete thingShadows[thingName].timeout;
                  delete thingShadows[thingName].clientToken;
               }, operationTimeout,
               thingName, clientToken);
            //
            // Subscribe to the 'accepted' and 'rejected' sub-topics unless we are
            // persistently subscribing, in which case we can publish to the topic immediately
            // since we are already subscribed to all applicable sub-topics.
            //
            if (thingShadows[thingName].persistentSubscribe === false) {
               this._handleSubscriptions(thingName, [{
                     operations: [operation],
                     statii: ['accepted', 'rejected'],
                  }], 'subscribe',
                  function(err, failedTopics) {
                     if (!isUndefined(err) || !isUndefined(failedTopics)) {
                        console.warn('failed subscription to accepted/rejected topics');
                        return;
                     }

                     //
                     // If 'stateObject' is defined, publish it to the publish topic for this
                     // thingName+operation.
                     //
                     if (!isUndefined(stateObject)) {
                        //
                        // Add the version # (if known and versioning is enabled) and 
                        // 'clientToken' properties to the stateObject.
                        //
                        if (!isUndefined(thingShadows[thingName].version) &&
                           thingShadows[thingName].enableVersioning) {
                           stateObject.version = thingShadows[thingName].version;
                        }
                        stateObject.clientToken = clientToken;

                        device.publish(publishTopic,
                           JSON.stringify(stateObject), {
                              qos: thingShadows[thingName].qos
                           });
                        if (!(isUndefined(thingShadows[thingName])) &&
                           thingShadows[thingName].debug === true) {
                           console.log('publishing \'' + JSON.stringify(stateObject) +
                              ' on \'' + publishTopic + '\'');
                        }
                     }
                  });
            } else {
               //
               // Add the version # (if known and versioning is enabled) and 
               // 'clientToken' properties to the stateObject.
               //
               if (!isUndefined(thingShadows[thingName].version) &&
                  thingShadows[thingName].enableVersioning) {
                  stateObject.version = thingShadows[thingName].version;
               }
               stateObject.clientToken = clientToken;

               device.publish(publishTopic,
                  JSON.stringify(stateObject), {
                     qos: thingShadows[thingName].qos
                  });
               if (thingShadows[thingName].debug === true) {
                  console.log('publishing \'' + JSON.stringify(stateObject) +
                     ' on \'' + publishTopic + '\'');
               }
            }
            rc = clientToken; // return the clientToken to the caller
         } else {
            if (deviceOptions.debug === true) {
               console.error(operation + ' still in progress on thing: ', thingName);
            }
         }
      } else {
         if (deviceOptions.debug === true) {
            console.error('attempting to ' + operation + ' unknown thing: ', thingName);
         }
      }
      return rc;
   };

   this.register = function(thingName, options, callback) {

      if (!thingShadows.hasOwnProperty(thingName)) {
         //
         // Initialize the registration entry for this thing; because the version # is 
         // not yet known, do not add the property for it yet. The version number 
         // property will be added after the first accepted update from AWS IoT.
         //
         var ignoreDeltas = false;
         var topicSpecs = [];
         thingShadows[thingName] = {
            persistentSubscribe: true,
            debug: false,
            discardStale: true,
            enableVersioning: true,
            qos: 0,
            pending: true
         };
         if (typeof options === 'function') {
            callback = options;
            options = null;
         }
         if (!isUndefined(options)) {
            if (!isUndefined(options.ignoreDeltas)) {
               ignoreDeltas = options.ignoreDeltas;
            }
            if (!isUndefined(options.persistentSubscribe)) {
               thingShadows[thingName].persistentSubscribe = options.persistentSubscribe;
            }
            if (!isUndefined(options.debug)) {
               thingShadows[thingName].debug = options.debug;
            }
            if (!isUndefined(options.discardStale)) {
               thingShadows[thingName].discardStale = options.discardStale;
            }
            if (!isUndefined(options.enableVersioning)) {
               thingShadows[thingName].enableVersioning = options.enableVersioning;
            }
            if (!isUndefined(options.qos)) {
               thingShadows[thingName].qos = options.qos;
            }
         }
         //
         // Always listen for deltas unless requested otherwise.
         //
         if (ignoreDeltas === false) {
            topicSpecs.push({
               operations: ['update'],
               statii: ['delta']
            });
         }
         //
         // If we are persistently subscribing, we subscribe to everything we could ever
         // possibly be interested in.  This will provide us the ability to publish
         // without waiting at the cost of potentially increased irrelevant traffic
         // which the application will need to filter out.
         //
         if (thingShadows[thingName].persistentSubscribe === true) {
            topicSpecs.push({
               operations: ['update', 'get', 'delete'],
               statii: ['accepted', 'rejected']
            });
         }

         if (topicSpecs.length > 0) {
            this._handleSubscriptions(thingName, topicSpecs, 'subscribe', function(err, failedTopics) {
               if (isUndefined(err) && isUndefined(failedTopics)) {
                  thingShadows[thingName].pending = false;
               }
               if (!isUndefined(callback)) {
                  callback(err, failedTopics);
               }
            });
         } else {
            thingShadows[thingName].pending = false;
            if (!isUndefined(callback)) {
               callback();
            }
         }

      } else {
         if (deviceOptions.debug === true) {
            console.error('thing already registered: ', thingName);
         }
      }
   };

   this.unregister = function(thingName) {
      if (thingShadows.hasOwnProperty(thingName)) {
         var topicSpecs = [];

         //
         // If an operation is outstanding, it will have a timeout set; when it
         // expires any accept/reject sub-topic subscriptions for the thing will be 
         // deleted.  If any messages arrive after the thing has been deleted, they
         // will simply be ignored as it no longer exists in the thing registrations.
         // The only sub-topic we need to unsubscribe from is the delta sub-topic,
         // which is always active.
         //
         topicSpecs.push({
            operations: ['update'],
            statii: ['delta']
         });
         //
         // If we are persistently subscribing, we subscribe to everything we could ever
         // possibly be interested in; this means that when it's time to unregister
         // interest in a thing, we need to unsubscribe from all of these topics.
         //
         if (thingShadows[thingName].persistentSubscribe === true) {
            topicSpecs.push({
               operations: ['update', 'get', 'delete'],
               statii: ['accepted', 'rejected']
            });
         }

         this._handleSubscriptions(thingName, topicSpecs, 'unsubscribe');

         //
         // Delete any pending timeout
         //
         if (!isUndefined(thingShadows[thingName].timeout)) {
            clearTimeout(thingShadows[thingName].timeout);
         }
         //
         // Delete the thing from the Thing registrations.
         //
         delete thingShadows[thingName];
      } else {
         if (deviceOptions.debug === true) {
            console.error('attempting to unregister unknown thing: ', thingName);
         }
      }
   };

   //
   // Perform an update operation on the given thing shadow.
   //
   this.update = function(thingName, stateObject) {
      var rc = null;
      //
      // Verify that the message does not contain a property named 'version',
      // as these property is reserved for use within this class.
      //
      if (isUndefined(stateObject.version)) {
         rc = that._thingOperation(thingName, 'update', stateObject);
      } else {
         console.error('message can\'t contain \'version\' property');
      }
      return rc;
   };

   //
   // Perform a get operation on the given thing shadow; allow the user
   // to specify their own client token if they don't want to use the
   // default.
   //
   this.get = function(thingName, clientToken) {
      var stateObject = {};
      if (!isUndefined(clientToken)) {
         stateObject.clientToken = clientToken;
      }
      return that._thingOperation(thingName, 'get', stateObject);
   };

   //
   // Perform a delete operation on the given thing shadow.
   //
   this.delete = function(thingName, clientToken) {
      var stateObject = {};
      if (!isUndefined(clientToken)) {
         stateObject.clientToken = clientToken;
      }
      return that._thingOperation(thingName, 'delete', stateObject);
   };
   //
   // Publish on non-thing topics.
   //
   this.publish = function(topic, message, options, callback) {
      if (!isReservedTopic(topic)) {
         device.publish(topic, message, options, callback);
      } else {
         throw ('cannot publish to reserved topic \'' + topic + '\'');
      }
   };

   //
   // Subscribe to non-thing topics.
   //
   this.subscribe = function(topics, options, callback) {
      var topicsArray = [];
      if (typeof topics === 'string') {
         topicsArray.push(topics);
      } else if (typeof topics === 'object' && topics.length) {
         topicsArray = topics;
      }
      for (var i = 0; i < topicsArray.length; i++) {
         if (isReservedTopic(topicsArray[i])) {
            throw ('cannot subscribe to topic array since one of them is a reserved topic \'' + topicsArray[i] + '\'');
         }
      }
      device.subscribe(topicsArray, options, callback);
   };
   //
   // Unsubscribe from non-thing topics.
   //
   this.unsubscribe = function(topics, callback) {
      var topicsArray = [];
      if (typeof topics === 'string') {
         topicsArray.push(topics);
      } else if (typeof topics === 'object' && topics.length) {
         topicsArray = topics;
      }
      for (var i = 0; i < topicsArray.length; i++) {
         if (isReservedTopic(topicsArray[i])) {
            throw ('cannot unsubscribe from topic array since one of them is a reserved topic \'' + topicsArray[i] + '\'');
         }
      }
      device.unsubscribe(topicsArray, callback);
   };
   //
   // Close the device connection; this will be passed through to
   // the device class.
   //
   this.end = function(force, callback) {
      device.end(force, callback);
   };
   //
   // Call this function to update the credentials used when
   // connecting via WebSocket/SigV4; this will be passed through
   // to the device class.
   //
   this.updateWebSocketCredentials = function(accessKeyId, secretKey, sessionToken, expiration) {
      device.updateWebSocketCredentials(accessKeyId, secretKey, sessionToken, expiration);
   };
   //
   // Call this function to update the custom auth headers
   // This will be passed through to the device class
   //
   this.updateCustomAuthHeaders = function(newHeaders) {
      device.updateCustomAuthHeaders(newHeaders);
   };

   //
   // This is an unpublished API used for testing.
   //
   this.setConnectionStatus = function(connectionStatus) {
      connected = connectionStatus;
   };
   events.EventEmitter.call(this);
}

//
// Allow instances to listen in on events that we produce for them
//
inherits(ThingShadowsClient, events.EventEmitter);

module.exports = ThingShadowsClient;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
var events = __webpack_require__(95);
var inherits = __webpack_require__(245).inherits;

//npm deps

//app deps
var deviceModule = __webpack_require__(363);
var isUndefined = __webpack_require__(248);

//
// private functions
//

function isJobTopic(topicTokens) {
   //
   // Job topics have the forms:
   //
   //      $aws/things/{thingName}/jobs/#
   //
   return (topicTokens[0] === '$aws' && topicTokens[1] === 'things' && topicTokens[3] === 'jobs');
}

function buildJobTopic(thingName, jobId, operation) {
   var result = '$aws/things/' + thingName + '/jobs/';

   // check for omitted jobId and fixup parameters
   if (isUndefined(operation)) {
      operation = jobId;
   } else {
      result += jobId.toString() + '/';
   }

   result += operation;

   return result;
}


//begin module

function jobsClient(options) {
   //
   // Force instantiation using the 'new' operator; this will cause inherited
   // constructors (e.g. the 'events' class) to be called.
   //
   if (!(this instanceof jobsClient)) {
      return new jobsClient(options);
   }

   //
   // A copy of 'this' for use inside of closures
   //
   var that = this;

   //
   // Track job subscriptions
   //
   // [
   //    { 
   //       "thingName": "string",
   //       "operations": [
   //          { 
   //             "operationName": "string",  // if null then treat as default
   //             "currentJob": job,
   //             "callback": callback
   //          }
   //       ]
   //    }
   // ]
   //
   var jobSubscriptions = [];

   //
   // Instantiate the device
   //
   var device = deviceModule.DeviceClient(options);

   //
   // Private function to update job execution status for given thing
   //
   this._updateJobStatus = function(thingName, job, status, statusDetails, callback) {
      // Check for omitted statusDetails and update parameters
      if (typeof statusDetails === "function") {
         callback = statusDetails;
         statusDetails = undefined;
      }

      if ((!isUndefined(options)) && (options.debug === true)) {
         console.log('updateJobStatus:', { thingName: thingName, jobId: job.id, status: status, statusDetails: statusDetails });
      }

      device.publish(buildJobTopic(thingName, job.id, 'update'), JSON.stringify({ status: status, statusDetails: statusDetails}), null, function(err){
         if (isUndefined(err)) {
            job.status = { status: status, statusDetails: statusDetails };
         }

         if (!isUndefined(callback)) {
            callback(err);
         }
      });
   }

   //
   // Private function to build job object for passing to callback supplied in subscribeToJobs
   //
   this._buildJobObject = function(thingName, jobExecution) {
      if (isUndefined(jobExecution) || isUndefined(jobExecution.jobId)) {
         return null;
      }

      var job = {};

      job.id = jobExecution.jobId;
      job.document = jobExecution.jobDocument;
      job.operation = job.document.operation;
      job.status = { status: jobExecution.status, statusDetails: jobExecution.statusDetails };

      job.inProgress = function(statusDetails, callback) {
         that._updateJobStatus(thingName, job, 'IN_PROGRESS', statusDetails, callback);
      }

      job.failed = function(statusDetails, callback) {
         that._updateJobStatus(thingName, job, 'FAILED', statusDetails, callback);
      }

      job.succeeded = function(statusDetails, callback) {
         that._updateJobStatus(thingName, job, 'SUCCEEDED', statusDetails, callback);
      }

      return job;
   }

   //
   // Private function to handle job messages and process them accordingly
   //
   this._handleMessages = function(topic, payload) {
      var topicTokens = topic.split('/');

      // If not a job topic emit to application and return
      if (!isJobTopic(topicTokens)) {
         that.emit('message', topic, payload);
         return;
      }

      var thingName = topicTokens[2];

      var thing = jobSubscriptions.find(function(elem) { 
         return elem.thingName === thingName; 
      });

      // Do nothing if thing not found in job subscriptions 
      if (isUndefined(thing)) {
         return;
      }

      var jobExecutionData = {};

      try {
         jobExecutionData = JSON.parse(payload.toString());
      } catch (err) {
         if (options.debug === true) {
            console.error('failed parsing JSON \'' + payload.toString() + '\', ' + err);
         }
         return;
      }

      if (isUndefined(jobExecutionData.execution) || 
          isUndefined(jobExecutionData.execution.jobId) || 
          isUndefined(jobExecutionData.execution.jobDocument)) {
         return;
      }

      var operationName = jobExecutionData.execution.jobDocument.operation;
      var operation = thing.operations.find(function(elem) { 
         return (isUndefined(operationName) ? isUndefined(elem.operationName) : operationName === elem.operationName); 
      });

      // If operation subscription not found by operation name then look for default operation subscription
      if (isUndefined(operation)) {
         operation = thing.operations.find(function(elem) { return (isUndefined(elem.operationName)); });

         if (isUndefined(operation)) {
            return;
         }
      }

      operation.callback(null, that._buildJobObject(thingName, jobExecutionData.execution));
   }

   this.subscribeToJobs = function(thingName, operationName, callback) {
      // Check for omitted optional operationName and fixup parameters
      if (isUndefined(callback)) {
         callback = operationName;
         operationName = null;
      }

      if ((!isUndefined(options)) && (options.debug === true)) {
         console.log('subscribeToJobs:', { thingName: thingName, operationName: operationName });
      }

      var thing = jobSubscriptions.find(function(elem) { 
         return elem.thingName === thingName; 
      });

      // Check for previously unseen thing and add to job subscriptions
      if (isUndefined(thing)) {
         thing = { thingName: thingName, operations: [] };
         jobSubscriptions.push(thing);

         device.subscribe([ buildJobTopic(thingName, '$next/get/accepted'), buildJobTopic(thingName, 'notify-next') ], function(err, granted) {
            if (!isUndefined(err)) {
               callback(err);
            }
         });
      }

      // Find existing subscription for the given operationName
      var operation = thing.operations.find(function(elem) { 
         return (isUndefined(operationName) ? isUndefined(elem.operationName) : operationName === elem.operationName); 
      });

      // If existing subscription found then update callback, otherwise create new entry in the thing's operations array
      if (!isUndefined(operation)) {
         operation.callback = callback;
      } else {
         operation = { operationName: operationName, callback: callback };
         thing.operations.push(operation);
      }
   }

   this.unsubscribeFromJobs = function(thingName, operationName, callback) {
      // Check for omitted optional operationName and fixup parameters
      if (isUndefined(callback)) {
         callback = operationName;
         operationName = null;
      }

      if ((!isUndefined(options)) && (options.debug === true)) {
         console.log('unsubscribeFromJobs:', { thingName: thingName, operationName: operationName });
      }

      var iThing = jobSubscriptions.findIndex(function(elem) { 
         return elem.thingName === thingName;
      });

      var notFoundError = new Error('subscription not found for given thing');

      // Check for previously unseen thing and add to job subscriptions and publish to get to retrieve first job to be executed
      if (iThing < 0) {
         callback(notFoundError);
         return;
      }

      var iOperation = jobSubscriptions[iThing].operations.findIndex(function (elem) {
         return (isUndefined(operationName) ? isUndefined(elem.operationName) : operationName === elem.operationName);
      });

      if (iOperation < 0) {
         callback(notFoundError);
         return;
      }

      jobSubscriptions[iThing].operations.splice(iOperation, 1);

      if (jobSubscriptions[iThing].operations.length === 0) {
         jobSubscriptions.splice(iThing, 1);
         device.unsubscribe([ buildJobTopic(thingName, '$next/get/accepted'), buildJobTopic(thingName, 'notify-next') ], callback);
         return;
      }

      callback();
   }

   this.startJobNotifications = function(thingName, callback) {
      if ((!isUndefined(options)) && (options.debug === true)) {
         console.log('startJobNotifications:', { thingName: thingName });
      }

      device.publish(buildJobTopic(thingName, '$next', 'get'), '{}', callback);
   }

   device.on('connect', function() {
      that.emit('connect');
   });
   device.on('close', function() {
      that.emit('close');
   });
   device.on('reconnect', function() {
      that.emit('reconnect');
   });
   device.on('offline', function() {
      that.emit('offline');
   });
   device.on('error', function(error) {
      that.emit('error', error);
   });

   device.on('message', that._handleMessages);

   this.publish = device.publish;
   this.subscribe = device.subscribe;
   this.unsubscribe = device.unsubscribe;
   this.end = device.end;
   this.handleMessage = device.handleMessage;
   this.updateWebSocketCredentials = device.updateWebSocketCredentials;

   //
   // Used for integration testing only
   //
   this.simulateNetworkFailure = device.simulateNetworkFailure;
}

//
// Allow instances to listen in on events that we produce for them
//
inherits(jobsClient, events.EventEmitter);

module.exports = jobsClient;


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1505);

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);
var bind = __webpack_require__(589);
var Axios = __webpack_require__(1507);
var defaults = __webpack_require__(371);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(593);
axios.CancelToken = __webpack_require__(1520);
axios.isCancel = __webpack_require__(592);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1521);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1506 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(371);
var utils = __webpack_require__(67);
var InterceptorManager = __webpack_require__(1515);
var dispatchRequest = __webpack_require__(1516);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(591);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);
var transformData = __webpack_require__(1517);
var isCancel = __webpack_require__(592);
var defaults = __webpack_require__(371);
var isAbsoluteURL = __webpack_require__(1518);
var combineURLs = __webpack_require__(1519);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(67);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(593);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SearchFilter = __webpack_require__(1523);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _index = __webpack_require__(93);

var _index2 = _interopRequireDefault(_index);

var _awsManager = __webpack_require__(59);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SearchModal = function (_Component) {
  _inherits(SearchModal, _Component);

  function SearchModal(props) {
    _classCallCheck(this, SearchModal);

    var _this = _possibleConstructorReturn(this, (SearchModal.__proto__ || Object.getPrototypeOf(SearchModal)).call(this, props));

    _this.technologyTypeSelectedArray = [];
    _this.accessTypeSelectedArray = [];
    _this.locationSelectedArray = [];
    _this.notificationTypeSelectedArray = [];
    _this.incidentPrioritySelectedArray = [];
    _this.rspSelectedArray = [];
    _this.sdpSelectedArray = [];
    _this.searchModalPageNumber = 1;
    _this.dataSource = [];
    _this.searchedData = [];

    _this.technologyTypeChanged = function (selected) {
      _this.technologyTypeSelectedArray = selected;
    };

    _this.accessTypeChanged = function (selected) {
      _this.accessTypeSelectedArray = selected;
    };

    _this.locationChanged = function (selected) {
      _this.locationSelectedArray = selected;
    };

    _this.notificationTypeChanged = function (selected) {
      _this.notificationTypeSelectedArray = selected;
    };

    _this.incidentPriorityChanged = function (selected) {
      _this.incidentPrioritySelectedArray = selected;
    };

    _this.rspChanged = function (selected) {
      _this.rspSelectedArray = selected;
    };

    _this.sdpChanged = function (selected) {
      _this.sdpSelectedArray = selected;
    };

    _this.toggleFilter = function () {
      _this.setState({
        toggleBool: !_this.state.toggleBool
      });
    };

    _this.onButtonClick = function () {
      _this.searchModalPageNumber = 1;
      _this.searchedData = [];
      if (_this.state.searchText) {
        _this.searchedDeviceData(_this.state.searchText, _this.searchModalPageNumber);
      };
    };

    _this.showMoreButtonClick = function () {
      _this.searchModalPageNumber = _this.searchModalPageNumber + 1;
      _this.searchedDeviceData(_this.state.searchText, _this.searchModalPageNumber);
    };

    _this.unique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    _this.searchedDeviceData = function (searchText, pagenumber) {
      (0, _awsManager.searchDevices)(searchText, pagenumber).then(function (data) {
        var uniqueSearchResults = data.filter(_this.unique);
        _this.queryData = uniqueSearchResults;
        _this.setState({
          dataSource: 'Modal'
        });
        _this.setData();
      }, function () {});
    };

    _this.setData = function () {
      var initialDigit = 0,
          buttonValue = '',
          totalRecords = 0,
          count = 0;

      if (_this.state.dataSource === 'Modal') {
        _this.dataSource = _this.queryData;
        totalRecords = _this.queryData.Count;
      } else if (_this.state.dataSource === 'Header') {
        _this.dataSource = _this.props.data;
        totalRecords = _this.props.data.Count;
      }
      if (_this.dataSource) {
        _this.dataSource.forEach(function (item) {
          _this.searchedData.push(item);
        });
        // if (this.searchedData.length != this.dataSource.Count) {
        //   buttonValue = (<button id="showMore-button"
        //     className="btn mr-3"
        //     onClick={() => {
        //       this.showMoreButtonClick();
        //     }}
        //   >Show More...</button>);
        // }
        // else {
        //   buttonValue = '';
        // }
        buttonValue = '';
      }
      var content = _this.searchedData.map(function (el, index) {
        if (el) {
          return _react2.default.createElement('tr', { key: index }, _react2.default.createElement('td', null, el), _react2.default.createElement('td', null, _react2.default.createElement('a', { onClick: function onClick() {
              _this.props.onViewPitClick(el);
            }
          }, 'View Pit')));
        }

        return null;
      });

      if (_this.searchedData.length > 0) {
        initialDigit = 1;
      }

      _this.setState({
        content: content,
        showMoreDevices: buttonValue,
        initialDigit: initialDigit,
        totalRecords: totalRecords,
        count: _this.searchedData.length
      });
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.onButtonClick();
      }
    };

    _this.render = function () {
      return _react2.default.createElement('div', { className: 'modal fade temprature-popupWrapper', id: 'searchModal' }, _react2.default.createElement('div', { className: 'modal-dialog modal-lg' }, _react2.default.createElement('div', { className: 'modal-content' }, _react2.default.createElement('div', { className: 'modal-header py-2 border-0' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-9' }, _react2.default.createElement('h4', { className: 'modal-title' }, 'Search Results')), _react2.default.createElement('div', { className: 'col-3' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'd-flex align-items-center justify-content-end col-6' }, _react2.default.createElement('h5', { className: 'mb-0 pl-2' })), _react2.default.createElement('div', { className: 'd-flex align-items-center col-6 justify-content-end' }, _react2.default.createElement('button', { type: 'button', className: 'close', 'data-dismiss': 'modal' }, _react2.default.createElement('h6', { className: 'input-for-search' }, '\xD7'), _react2.default.createElement('h4', { className: 'pl-1 modal-title' }, 'Close')))))))), _react2.default.createElement('div', { className: 'modal-body' }, _react2.default.createElement('div', { className: 'd-flex' }, _react2.default.createElement(_index2.default, {
        onChange: _this.updateSearchText.bind(_this),
        value: _this.state.searchText,
        onKeyPress: _this.handleKeyPress.bind(_this),
        onButtonClick: _this.onButtonClick
      })), _react2.default.createElement('div', { className: 'mx-4 mb-4' }, _this.state.toggleBool ? _react2.default.createElement(_SearchFilter2.default, {
        technologyTypeChanged: function technologyTypeChanged(array) {
          _this.technologyTypeChanged(array);
        },
        accessTypeChanged: function accessTypeChanged(array) {
          _this.accessTypeChanged(array);
        },
        locationChanged: function locationChanged(array) {
          _this.locationChanged(array);
        },
        notificationTypeChanged: function notificationTypeChanged(array) {
          _this.notificationTypeChanged(array);
        },
        incidentPriorityChanged: function incidentPriorityChanged(array) {
          _this.incidentPriorityChanged(array);
        },
        rspChanged: function rspChanged(array) {
          _this.rspChanged(array);
        },
        sdpChanged: function sdpChanged(array) {
          _this.sdpChanged(array);
        }
      }) : ''), _react2.default.createElement('div', { className: 'inner-height' }, _this.state.content.length > 0 ? _react2.default.createElement('table', { className: 'table search-table mt-3 table-bordered' }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', null, 'ID'), _react2.default.createElement('th', null, 'View'))), _react2.default.createElement('tbody', null, _this.state.content)) : _react2.default.createElement('h3', null, 'No results to display')), _this.state.showMoreDevices))));
    };

    _this.state = {
      toggleBool: false,
      searchBox: false,
      searchText: props.defaultText,
      dataSource: 'Header',
      showMoreDevices: null,
      content: null,
      initialDigit: 0,
      totalRecords: 0,
      count: 0
    };

    _this.onButtonClick.bind(_this);
    _this.technologyTypeChanged.bind(_this);
    _this.accessTypeChanged.bind(_this);
    _this.locationChanged.bind(_this);
    _this.notificationTypeChanged.bind(_this);
    _this.incidentPriorityChanged.bind(_this);
    _this.rspChanged.bind(_this);
    _this.sdpChanged.bind(_this);
    return _this;
  }

  _createClass(SearchModal, [{
    key: 'updateSearchText',
    value: function updateSearchText(evt) {
      this.setState({
        searchText: evt.target.value
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;
      $('.inner-height').slimscroll({
        height: '100%'
      });
      $('#searchModal').on('hidden.bs.modal', function () {
        self.props.clearSearchText();
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setData();
    }
  }]);

  return SearchModal;
}(_react.Component);

var _default = SearchModal;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchModal, 'SearchModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_SearchFilter2, "_SearchFilter2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_index2, "_index2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(SearchModal, "SearchModal", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchModal.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _reactCheckboxGroup = __webpack_require__(594);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var searchFilter = function (_Component) {
  _inherits(searchFilter, _Component);

  function searchFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, searchFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = searchFilter.__proto__ || Object.getPrototypeOf(searchFilter)).call.apply(_ref, [this].concat(args))), _this), _this.technologyTypeChanged = function (selected) {
      _this.props.technologyTypeChanged(selected);
    }, _this.accessTypeChanged = function (selected) {
      _this.props.accessTypeChanged(selected);
    }, _this.locationChanged = function (selected) {
      _this.props.locationChanged(selected);
    }, _this.notificationTypeChanged = function (selected) {
      _this.props.notificationTypeChanged(selected);
    }, _this.incidentPriorityChanged = function (selected) {
      _this.props.incidentPriorityChanged(selected);
    }, _this.rspChanged = function (selected) {
      _this.props.rspChanged(selected);
    }, _this.sdpChanged = function (selected) {
      _this.props.sdpChanged(selected);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(searchFilter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('ul', { className: 'list-unstyled text-left h-100 l-height-3' }, _react2.default.createElement('li', null, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex pb-2 px-0'
      }, _react2.default.createElement('div', { className: 'col text-left' }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'Adjust Filter:')))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex pt-2 px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'Technology Type')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'technologyType',
        onChange: this.technologyTypeChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'FTTN' }), ' FTTN')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'FTTP' }), ' FTTP')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'FTTC' }), ' FTTC')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'HFC' }), ' HFC')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Fixed Wireless' }), ' Fixed Wireless')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Satellite' }), ' Satellite')))))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'Access Type')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'accessType',
        onChange: this.accessTypeChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Business' }), ' Business')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Residential' }), ' Residential')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Other' }), ' Other')))))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'Location')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'location',
        onChange: this.locationChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'NSW' }), ' NSW')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'QLD' }), ' QLD')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'VIC' }), ' VIC')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'SA' }), ' SA')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'WA' }), ' WA')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'NT' }), ' NT')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'ACT' }), ' ACT')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'TAS' }), ' TAS')))))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'Notification Type')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'notificationType',
        onChange: this.notificationTypeChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Water Flooding' }), ' Water Flooding')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Power Leakage' }), ' Power Leakage')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Gas Leakage' }), ' Gas Leakage')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Intrusion Detection' }), ' Intrusion Detection')))))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'Incident Priority')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'incidentPriority',
        onChange: this.incidentPriorityChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Priority 1' }), ' Priority 1')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Priority 2' }), ' Priority 2')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Priority 3' }), ' Priority 3')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Priority 4' }), ' Priority 4')))))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'By RSP')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'rsp',
        onChange: this.rspChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Telstra' }), ' Telstra')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Singtel' }), ' Singtel')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'M2 Group' }), ' M2 Group')))))), _react2.default.createElement('li', { className: 'dropdown' }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement(_reactRouterDom.Link, {
        to: '#',
        className: 'dropdown-toggle w-100',
        id: 'dropdownMenuButton',
        'data-toggle': 'dropdown'
      }, _react2.default.createElement('div', {
        className: 'col-12 d-inline-flex px-0'
      }, _react2.default.createElement('div', {
        className: 'col text-left'
      }, _react2.default.createElement('div', {
        className: 'text-nowrap text-white'
      }, 'By SDP')), _react2.default.createElement('div', {
        className: 'col text-right'
      }, _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: '../../../../../assets/images/dropdown.png'
      }))))), _react2.default.createElement('div', { className: 'dropdown-menu' }, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
        checkboxDepth: 3,
        name: 'sdp',
        onChange: this.sdpChanged
      }, _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Telstra' }), ' Telstra')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Optus' }), ' Optus')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Lend Lease' }), ' Lend Lease')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Broadspectrum' }), ' Broadspectrum')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Fulton Hogan' }), ' Fulton Hogan')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'Downer' }), ' Downer')), _react2.default.createElement('a', { className: 'dropdown-item' }, _react2.default.createElement('label', null, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { value: 'ISGM' }), ' ISGM')))))));
    }
  }]);

  return searchFilter;
}(_react.Component);

var _default = searchFilter;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(searchFilter, 'searchFilter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js');
}();

;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(searchFilter, "searchFilter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");

  __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/Header/SearchFilter.js");
}();

;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(30);

var _reactRouterDom = __webpack_require__(39);

var _Drawer = __webpack_require__(286);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _ThemeColors = __webpack_require__(223);

var _SidenavContent = __webpack_require__(1526);

var _SidenavContent2 = _interopRequireDefault(_SidenavContent);

var _UserInfo = __webpack_require__(1528);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _ActionTypes = __webpack_require__(41);

var _Setting = __webpack_require__(240);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SideNav = function (_React$PureComponent) {
    _inherits(SideNav, _React$PureComponent);

    function SideNav(props) {
        _classCallCheck(this, SideNav);

        return _possibleConstructorReturn(this, (SideNav.__proto__ || Object.getPrototypeOf(SideNav)).call(this, props));
    }

    _createClass(SideNav, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            window.addEventListener('resize', function () {
                _this2.props.updateWindowWidth($(window).width());
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                navCollapsed = _props.navCollapsed,
                drawerType = _props.drawerType,
                width = _props.width;

            var drawerStyle = drawerType.includes(_ActionTypes.FIXED_DRAWER) ? 'd-xl-flex' : drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) ? '' : 'd-flex';
            var type = 'permanent';
            if (drawerType.includes(_ActionTypes.COLLAPSED_DRAWER) || drawerType.includes(_ActionTypes.FIXED_DRAWER) && width < 1200) {
                type = 'temporary';
            }

            return _react2.default.createElement('div', { className: 'app-sidebar d-none ' + drawerStyle }, _react2.default.createElement(_Drawer2.default, { className: 'app-sidebar-content',
                variant: type,
                open: type.includes('temporary') ? navCollapsed : true,
                onClose: this.props.onToggleCollapsedNav,
                classes: {
                    paper: 'side-nav'
                }
            }, _react2.default.createElement(_UserInfo2.default, null), _react2.default.createElement(_SidenavContent2.default, null)));
        }
    }]);

    return SideNav;
}(_react2.default.PureComponent);

var mapStateToProps = function mapStateToProps(_ref) {
    var settings = _ref.settings;
    var navCollapsed = settings.navCollapsed,
        drawerType = settings.drawerType,
        width = settings.width;

    return { navCollapsed: navCollapsed, drawerType: drawerType, width: width };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, { updateWindowWidth: _Setting.updateWindowWidth })(SideNav));

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(SideNav, 'SideNav', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_Drawer2, "_Drawer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_SidenavContent2, "_SidenavContent2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_UserInfo2, "_UserInfo2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(SideNav, "SideNav", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Modal = __webpack_require__(244);

var _Modal2 = _interopRequireDefault(_Modal);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Slide = __webpack_require__(372);

var _Slide2 = _interopRequireDefault(_Slide);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

var _helpers = __webpack_require__(35);

var _transitions = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSlideDirection(anchor) {
  if (anchor === 'left') {
    return 'right';
  } else if (anchor === 'right') {
    return 'left';
  } else if (anchor === 'top') {
    return 'down';
  }

  // (anchor === 'bottom')
  return 'up';
} // @inheritedComponent Modal

var styles = exports.styles = function styles(theme) {
  return {
    docked: {
      flex: '0 0 auto'
    },
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch', // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      '&:focus': {
        outline: 'none'
      }
    },
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorDockedLeft: {
      borderRight: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedTop: {
      borderBottom: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedRight: {
      borderLeft: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedBottom: {
      borderTop: '1px solid ' + theme.palette.divider
    },
    modal: {} // Just here so people can override the style.
  };
};

var Drawer = function (_React$Component) {
  (0, _inherits3.default)(Drawer, _React$Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // Let's assume that the Drawer will always be rendered on user space.
      // We use that state is order to skip the appear transition during the
      // initial mount of the component.
      firstMount: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Drawer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        firstMount: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          anchorProp = _props.anchor,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          elevation = _props.elevation,
          ModalProps = _props.ModalProps,
          onClose = _props.onClose,
          open = _props.open,
          PaperProps = _props.PaperProps,
          SlideProps = _props.SlideProps,
          theme = _props.theme,
          transitionDuration = _props.transitionDuration,
          variant = _props.variant,
          other = (0, _objectWithoutProperties3.default)(_props, ['anchor', 'children', 'classes', 'className', 'elevation', 'ModalProps', 'onClose', 'open', 'PaperProps', 'SlideProps', 'theme', 'transitionDuration', 'variant']);


      var anchor = anchorProp;
      if (theme.direction === 'rtl' && ['left', 'right'].indexOf(anchor) !== -1) {
        anchor = anchor === 'left' ? 'right' : 'left';
      }

      var drawer = _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({
          elevation: variant === 'temporary' ? elevation : 0,
          square: true,
          className: (0, _classnames2.default)(classes.paper, classes['paperAnchor' + (0, _helpers.capitalize)(anchor)], (0, _defineProperty3.default)({}, classes['paperAnchorDocked' + (0, _helpers.capitalize)(anchor)], variant !== 'temporary'))
        }, PaperProps),
        children
      );

      if (variant === 'permanent') {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
          drawer
        );
      }

      var slidingDrawer = _react2.default.createElement(
        _Slide2.default,
        (0, _extends3.default)({
          'in': open,
          direction: getSlideDirection(anchor),
          timeout: transitionDuration,
          appear: !this.state.firstMount
        }, SlideProps),
        drawer
      );

      if (variant === 'persistent') {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
          slidingDrawer
        );
      }

      // variant === temporary
      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({
          BackdropProps: {
            transitionDuration: transitionDuration
          },
          className: (0, _classnames2.default)(classes.modal, className),
          open: open,
          onClose: onClose
        }, other, ModalProps),
        slidingDrawer
      );
    }
  }]);
  return Drawer;
}(_react2.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes2.default.oneOf(['left', 'top', 'right', 'bottom']),
  /**
   * The contents of the drawer.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes2.default.number,
  /**
   * Properties applied to the `Modal` element.
   */
  ModalProps: _propTypes2.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes2.default.bool,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Slide` element.
   */
  SlideProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })]),
  /**
   * The type of drawer.
   */
  variant: _propTypes2.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};

Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen },
  variant: 'temporary' // Mobile first.
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDrawer', flip: false, withTheme: true })(Drawer);

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

__webpack_require__(859);

var _IntlMessages = __webpack_require__(145);

var _IntlMessages2 = _interopRequireDefault(_IntlMessages);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SidenavContent = function (_Component) {
  _inherits(SidenavContent, _Component);

  function SidenavContent() {
    _classCallCheck(this, SidenavContent);

    return _possibleConstructorReturn(this, (SidenavContent.__proto__ || Object.getPrototypeOf(SidenavContent)).apply(this, arguments));
  }

  _createClass(SidenavContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var history = this.props.history;

      var $nav = $(this.nav);
      var slideDuration = 250;

      $nav.slimscroll({
        height: "100%"
      });

      var pathname = "#" + history.location.pathname; // get current path

      $("ul.nav-menu > li.menu").click(function () {
        var menuLi = this;
        $("ul.nav-menu > li.menu").not(menuLi).removeClass("open");
        $("ul.nav-menu > li.menu ul").not($("ul", menuLi)).slideUp(slideDuration);
        $("> ul", menuLi).slideToggle(slideDuration);
        $(menuLi).toggleClass("open");
      });

      $("ul.sub-menu li").click(function (e) {
        var superSubMenu = $(this).parent();
        if (superSubMenu.parent().hasClass("active")) {
          $("li", superSubMenu).not($(this)).removeClass("active");
        } else {
          $("ul.sub-menu li").not($(this)).removeClass("active");
        }

        $(this).toggleClass("active");
        e.stopPropagation();
      });

      var activeLi = $('a[href="' + pathname + '"]'); // select current a element
      var activeNav = activeLi.closest("ul"); // select closest ul
      if (activeNav.hasClass("sub-menu")) {
        activeNav.slideDown(slideDuration);
        activeNav.parent().addClass("open");
        activeLi.parent().addClass("active");
      } else {
        activeLi.parent().addClass("open");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("ul", {
        className: "nav-menu",
        style: {
          backgroundColor: "#E2E3E5"
        },
        ref: function ref(c) {
          _this2.nav = c;
        }
      }, _react2.default.createElement("li", { className: "menu" }), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/summary" }, _react2.default.createElement("i", { className: "zmdi zmdi-star text-black icons", "aria-hidden": "true" }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "Summary"))), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/heartbeat" }, _react2.default.createElement("i", { className: "zmdi zmdi-home text-black icons", "aria-hidden": "true" }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "Device Home"))), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/config" }, _react2.default.createElement("i", {
        className: "zmdi zmdi-settings text-black icons",
        "aria-hidden": "true"
      }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "OTA Update"))), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/deviceCatalogue" }, _react2.default.createElement("i", {
        className: "zmdi zmdi-view-list-alt text-black icons",
        "aria-hidden": "true"
      }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "Device Catalogue"))), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/deviceVitals" }, _react2.default.createElement("i", {
        className: "fa fa-heartbeat text-black mt-1 icons ",
        "aria-hidden": "true"
      }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "Device Vitals"))), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/alerts" }, _react2.default.createElement("i", {
        className: "zmdi zmdi-alert-triangle text-black icons",
        "aria-hidden": "true"
      }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "Alerts"))), _react2.default.createElement("li", { className: "menu no-arrow" }, _react2.default.createElement(_Button2.default, { className: "void d-flex justify-content-start", href: "#/app/components/downloadData" }, _react2.default.createElement("i", {
        className: "zmdi zmdi-download text-black icons",
        "aria-hidden": "true"
      }), "\xA0\xA0\xA0\xA0", _react2.default.createElement("span", { className: "nav-text text-black" }, "Download data"))));
    }
  }]);

  return SidenavContent;
}(_react.Component);

var _default = (0, _reactRouterDom.withRouter)(SidenavContent);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidenavContent, "SidenavContent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_IntlMessages2, "_IntlMessages2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(SidenavContent, "SidenavContent", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SideNav/SidenavContent.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(136);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.button, {
      lineHeight: '1.4em', // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: theme.spacing.unit * 11,
      minHeight: 36,
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 2 + 'px',
      borderRadius: 2,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        // Reset on mouse devices
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.12),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    }),
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    flatPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    flatSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    colorInherit: {
      color: 'inherit'
    },
    raised: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$keyboardFocused': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },
    keyboardFocused: {},
    raisedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    raisedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      fontSize: 24,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },
    mini: {
      width: 40,
      height: 40
    },
    sizeSmall: {
      padding: theme.spacing.unit - 1 + 'px ' + theme.spacing.unit + 'px',
      minWidth: theme.spacing.unit * 8,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
    },
    sizeLarge: {
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px',
      minWidth: theme.spacing.unit * 14,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize + 1)
    },
    fullWidth: {
      width: '100%'
    }
  };
}; // @inheritedComponent ButtonBase

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fullWidth = props.fullWidth,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled', 'disableFocusRipple', 'fullWidth', 'mini', 'size', 'variant']);


  var fab = variant === 'fab';
  var raised = variant === 'raised';
  var flat = !raised && !fab;
  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.raised, raised || fab), (0, _defineProperty3.default)(_classNames, classes.fab, fab), (0, _defineProperty3.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty3.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty3.default)(_classNames, classes.flatPrimary, flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.flatSecondary, flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.raisedPrimary, !flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.raisedSecondary, !flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes['size' + (0, _helpers.capitalize)(size)], size !== 'medium'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), classNameProp);

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: className,
      disabled: disabled,
      focusRipple: !disableFocusRipple,
      classes: {
        keyboardFocused: classes.keyboardFocused
      }
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      children
    )
  );
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes2.default.string,
  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes2.default.bool,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /**
   * @ignore
   */
  type: _propTypes2.default.string,
  /**
   * The type of button.
   */
  variant: _propTypes2.default.oneOf(['flat', 'raised', 'fab'])
} : {};

Button.defaultProps = {
  color: 'default',
  disabled: false,
  disableFocusRipple: false,
  disableRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'flat'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButton' })(Button);

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Avatar = __webpack_require__(356);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _reactRedux = __webpack_require__(30);

var _Menu = __webpack_require__(203);

var _Menu2 = _interopRequireDefault(_Menu);

var _IntlMessages = __webpack_require__(145);

var _IntlMessages2 = _interopRequireDefault(_IntlMessages);

var _reactRouterDom = __webpack_require__(39);

var _userManager = __webpack_require__(117);

var _reactNotifications = __webpack_require__(78);

var _index = __webpack_require__(222);

var _reduxPersist = __webpack_require__(226);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UserInfo = function (_React$Component) {
  _inherits(UserInfo, _React$Component);

  function UserInfo(props) {
    _classCallCheck(this, UserInfo);

    var _this = _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).call(this, props));

    _this.handleClick = function (event) {
      _this.setState({ open: true, anchorEl: event.currentTarget });
    };

    _this.handleRequestClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.openProfileModal = function () {
      _this.props.history.push("/app/components/profile-and-settings");
    };

    _this.updateUsernameInStore = function (name) {
      _this.props.changeUsername(name);
    };

    _this.signUserOutInnerFunctionality = function () {
      _this.props.signOut();
      _this.props.setDefaultTheme();
      var body = $("#body");
      body.removeClass();
      body.addClass(_this.props.themeColor);
      (0, _reduxPersist.purgeStoredState)(_index.persistConfig);
    };

    _this.signUserOut = function () {
      (0, _userManager.signOut)().then(function () {
        _this.signUserOutInnerFunctionality();
      }, function () {
        _this.signUserOutInnerFunctionality();
      });
    };

    _this.openAdminPanel = function () {
      _this.props.history.push("/app/components/admin-panel");
    };

    _this.state = {
      anchorEl: null,
      open: false,
      imageUrl: _react2.default.createElement(_Avatar2.default, {
        alt: "...",
        src: CONST.DEFAULT_PROFILE_IMG,
        className: "user-avatar"
      }),
      deviceId: _this.props.symbioticReducer.deviceId
    };

    _this.updateUsernameInStore.bind(_this);
    return _this;
  }

  _createClass(UserInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // const self = this;
      //
      // $('#profileModal').on('hidden.bs.modal', function (e) {
      //
      //     self.setState({
      //         profileModal: ''
      //     });
      //
      //     self.setState({
      //         profileModal: <ProfileModal resetProfileModal={true}/>
      //     })
      // })

      $(document).ready(function () {
        $(".myImage :first-child").bind("error", function () {
          // Replacing image source
          $(this).attr("src", CONST.DEFAULT_PROFILE_IMG);
        });
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.profileInfo.hasOwnProperty("userAttributes")) {
        if (nextProps.profileInfo.userAttributes !== null && nextProps.profileInfo.userAttributes.hasOwnProperty("picture")) {
          if (nextProps.profileInfo.userAttributes.picture !== this.state.imageUrl) {
            if (nextProps.profileInfo.userAttributes.picture) {
              this.setState({
                imageUrl: _react2.default.createElement(_Avatar2.default, {
                  alt: "...",
                  src: nextProps.profileInfo.userAttributes.picture,
                  className: "user-avatar myImage",
                  id: "profileImg",
                  onError: function onError(e) {
                    e.target.src = CONST.DEFAULT_PROFILE_IMG;
                  }
                })
              });
            }
          }
        }
      }

      if (nextProps.symbioticReducer.deviceId !== this.state.deviceId) {
        this.setState({
          deviceId: nextProps.symbioticReducer.deviceId
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("div", { className: "user-profile d-flex flex-row align-items-center" }, this.state.imageUrl, _react2.default.createElement("div", { className: "user-detail" }, _react2.default.createElement("h4", { className: "user-name text-black", onClick: this.handleClick }, this.props.profileInfo.username, " ", _react2.default.createElement("i", { className: "zmdi zmdi-caret-down zmdi-hc-fw align-middle" }))), _react2.default.createElement(_Menu2.default, {
        className: "user-info",
        id: "simple-menu",
        anchorEl: this.state.anchorEl,
        open: this.state.open,
        onClose: this.handleRequestClose,
        PaperProps: {
          style: {
            width: 150,
            paddingTop: 0,
            paddingBottom: 0
          }
        }
      }, _react2.default.createElement(_Menu.MenuItem, {
        onClick: function onClick() {
          //   this.handleRequestClose();
          //   this.openProfileModal();
        }
      }, _react2.default.createElement("i", { className: "zmdi zmdi-account zmdi-hc-fw mr-2" }), _react2.default.createElement(_IntlMessages2.default, { id: "popup.profile" })), _react2.default.createElement(_Menu.MenuItem, {
        onClick: function onClick() {
          _this2.handleRequestClose();
          _this2.signUserOut();
        }
      }, _react2.default.createElement("i", { className: "zmdi zmdi-sign-in zmdi-hc-fw mr-2" }), _react2.default.createElement(_IntlMessages2.default, { id: "popup.logout" }))), _react2.default.createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return UserInfo;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings,
      profileInfo = _ref.profileInfo,
      symbioticReducer = _ref.symbioticReducer;
  var locale = settings.locale;

  return { locale: locale, profileInfo: profileInfo, symbioticReducer: symbioticReducer };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeUsername: function changeUsername(name) {
      dispatch({ type: "UPDATE_USERNAME", payload: name });
    },
    signOut: function signOut() {
      dispatch({ type: "SIGN_OUT" });
    },
    setDefaultTheme: function setDefaultTheme() {
      dispatch({ type: "SET_DEFAULT_THEME" });
    }
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserInfo));

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UserInfo, "UserInfo", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_Avatar2, "_Avatar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_Menu2, "_Menu2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_IntlMessages2, "_IntlMessages2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(UserInfo, "UserInfo", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/UserInfo/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AuthenticationDetails = __webpack_require__(1530);

Object.defineProperty(exports, 'AuthenticationDetails', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuthenticationDetails).default;
  }
});

var _AuthenticationHelper = __webpack_require__(596);

Object.defineProperty(exports, 'AuthenticationHelper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuthenticationHelper).default;
  }
});

var _CognitoAccessToken = __webpack_require__(599);

Object.defineProperty(exports, 'CognitoAccessToken', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoAccessToken).default;
  }
});

var _CognitoIdToken = __webpack_require__(601);

Object.defineProperty(exports, 'CognitoIdToken', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoIdToken).default;
  }
});

var _CognitoRefreshToken = __webpack_require__(602);

Object.defineProperty(exports, 'CognitoRefreshToken', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoRefreshToken).default;
  }
});

var _CognitoUser = __webpack_require__(603);

Object.defineProperty(exports, 'CognitoUser', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoUser).default;
  }
});

var _CognitoUserAttribute = __webpack_require__(606);

Object.defineProperty(exports, 'CognitoUserAttribute', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoUserAttribute).default;
  }
});

var _CognitoUserPool = __webpack_require__(1535);

Object.defineProperty(exports, 'CognitoUserPool', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoUserPool).default;
  }
});

var _CognitoUserSession = __webpack_require__(604);

Object.defineProperty(exports, 'CognitoUserSession', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CognitoUserSession).default;
  }
});

var _CookieStorage = __webpack_require__(1538);

Object.defineProperty(exports, 'CookieStorage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CookieStorage).default;
  }
});

var _DateHelper = __webpack_require__(605);

Object.defineProperty(exports, 'DateHelper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DateHelper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var AuthenticationDetails = function () {
  /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */
  function AuthenticationDetails(data) {
    _classCallCheck(this, AuthenticationDetails);

    var _ref = data || {},
        ValidationData = _ref.ValidationData,
        Username = _ref.Username,
        Password = _ref.Password,
        AuthParameters = _ref.AuthParameters;

    this.validationData = ValidationData || {};
    this.authParameters = AuthParameters || {};
    this.username = Username;
    this.password = Password;
  }

  /**
   * @returns {string} the record's username
   */


  AuthenticationDetails.prototype.getUsername = function getUsername() {
    return this.username;
  };

  /**
   * @returns {string} the record's password
   */


  AuthenticationDetails.prototype.getPassword = function getPassword() {
    return this.password;
  };

  /**
   * @returns {Array} the record's validationData
   */


  AuthenticationDetails.prototype.getValidationData = function getValidationData() {
    return this.validationData;
  };

  /**
   * @returns {Array} the record's authParameters
   */


  AuthenticationDetails.prototype.getAuthParameters = function getAuthParameters() {
    return this.authParameters;
  };

  return AuthenticationDetails;
}();

exports.default = AuthenticationDetails;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var helpers = __webpack_require__(373);

/*
 * Calculate the SHA-1 of an array of big-endian words, and a bit length
 */
function core_sha1(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << (24 - len % 32);
  x[((len + 64 >> 9) << 4) + 15] = len;

  var w = Array(80);
  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;
  var e = -1009589776;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    var olde = e;

    for(var j = 0; j < 80; j++)
    {
      if(j < 16) w[j] = x[i + j];
      else w[j] = rol(w[j-3] ^ w[j-8] ^ w[j-14] ^ w[j-16], 1);
      var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)),
                       safe_add(safe_add(e, w[j]), sha1_kt(j)));
      e = d;
      d = c;
      c = rol(b, 30);
      b = a;
      a = t;
    }

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
    e = safe_add(e, olde);
  }
  return Array(a, b, c, d, e);

}

/*
 * Perform the appropriate triplet combination function for the current
 * iteration
 */
function sha1_ft(t, b, c, d)
{
  if(t < 20) return (b & c) | ((~b) & d);
  if(t < 40) return b ^ c ^ d;
  if(t < 60) return (b & c) | (b & d) | (c & d);
  return b ^ c ^ d;
}

/*
 * Determine the appropriate additive constant for the current iteration
 */
function sha1_kt(t)
{
  return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
         (t < 60) ? -1894007588 : -899497514;
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function sha1(buf) {
  return helpers.hash(buf, core_sha1, 20, true);
};


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var helpers = __webpack_require__(373);

var safe_add = function(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
};

var S = function(X, n) {
  return (X >>> n) | (X << (32 - n));
};

var R = function(X, n) {
  return (X >>> n);
};

var Ch = function(x, y, z) {
  return ((x & y) ^ ((~x) & z));
};

var Maj = function(x, y, z) {
  return ((x & y) ^ (x & z) ^ (y & z));
};

var Sigma0256 = function(x) {
  return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
};

var Sigma1256 = function(x) {
  return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
};

var Gamma0256 = function(x) {
  return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
};

var Gamma1256 = function(x) {
  return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
};

var core_sha256 = function(m, l) {
  var K = new Array(0x428A2F98,0x71374491,0xB5C0FBCF,0xE9B5DBA5,0x3956C25B,0x59F111F1,0x923F82A4,0xAB1C5ED5,0xD807AA98,0x12835B01,0x243185BE,0x550C7DC3,0x72BE5D74,0x80DEB1FE,0x9BDC06A7,0xC19BF174,0xE49B69C1,0xEFBE4786,0xFC19DC6,0x240CA1CC,0x2DE92C6F,0x4A7484AA,0x5CB0A9DC,0x76F988DA,0x983E5152,0xA831C66D,0xB00327C8,0xBF597FC7,0xC6E00BF3,0xD5A79147,0x6CA6351,0x14292967,0x27B70A85,0x2E1B2138,0x4D2C6DFC,0x53380D13,0x650A7354,0x766A0ABB,0x81C2C92E,0x92722C85,0xA2BFE8A1,0xA81A664B,0xC24B8B70,0xC76C51A3,0xD192E819,0xD6990624,0xF40E3585,0x106AA070,0x19A4C116,0x1E376C08,0x2748774C,0x34B0BCB5,0x391C0CB3,0x4ED8AA4A,0x5B9CCA4F,0x682E6FF3,0x748F82EE,0x78A5636F,0x84C87814,0x8CC70208,0x90BEFFFA,0xA4506CEB,0xBEF9A3F7,0xC67178F2);
  var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
    var W = new Array(64);
    var a, b, c, d, e, f, g, h, i, j;
    var T1, T2;
  /* append padding */
  m[l >> 5] |= 0x80 << (24 - l % 32);
  m[((l + 64 >> 9) << 4) + 15] = l;
  for (var i = 0; i < m.length; i += 16) {
    a = HASH[0]; b = HASH[1]; c = HASH[2]; d = HASH[3]; e = HASH[4]; f = HASH[5]; g = HASH[6]; h = HASH[7];
    for (var j = 0; j < 64; j++) {
      if (j < 16) {
        W[j] = m[j + i];
      } else {
        W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
      }
      T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
      T2 = safe_add(Sigma0256(a), Maj(a, b, c));
      h = g; g = f; f = e; e = safe_add(d, T1); d = c; c = b; b = a; a = safe_add(T1, T2);
    }
    HASH[0] = safe_add(a, HASH[0]); HASH[1] = safe_add(b, HASH[1]); HASH[2] = safe_add(c, HASH[2]); HASH[3] = safe_add(d, HASH[3]);
    HASH[4] = safe_add(e, HASH[4]); HASH[5] = safe_add(f, HASH[5]); HASH[6] = safe_add(g, HASH[6]); HASH[7] = safe_add(h, HASH[7]);
  }
  return HASH;
};

module.exports = function sha256(buf) {
  return helpers.hash(buf, core_sha256, 32, true);
};


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// Original code adapted from Robert Kieffer.
// details at https://github.com/broofa/node-uuid
(function() {
  var _global = this;

  var mathRNG, whatwgRNG;

  // NOTE: Math.random() does not guarantee "cryptographic quality"
  mathRNG = function(size) {
    var bytes = new Array(size);
    var r;

    for (var i = 0, r; i < size; i++) {
      if ((i & 0x03) == 0) r = Math.random() * 0x100000000;
      bytes[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return bytes;
  }

  if (_global.crypto && crypto.getRandomValues) {
    whatwgRNG = function(size) {
      var bytes = new Uint8Array(size);
      crypto.getRandomValues(bytes);
      return bytes;
    }
  }

  module.exports = whatwgRNG || mathRNG;

}())


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

var helpers = __webpack_require__(373);

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test()
{
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t)
{
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t)
{
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t)
{
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t)
{
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t)
{
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function md5(buf) {
  return helpers.hash(buf, core_md5, 16);
};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Client = __webpack_require__(1536);

var _Client2 = _interopRequireDefault(_Client);

var _CognitoUser = __webpack_require__(603);

var _CognitoUser2 = _interopRequireDefault(_CognitoUser);

var _StorageHelper = __webpack_require__(607);

var _StorageHelper2 = _interopRequireDefault(_StorageHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
                                                                                                                                                           * Copyright 2016 Amazon.com,
                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
                                                                                                                                                           *
                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
                                                                                                                                                           * You may not use this file except in compliance with the
                                                                                                                                                           * License. A copy of the License is located at
                                                                                                                                                           *
                                                                                                                                                           *     http://aws.amazon.com/asl/
                                                                                                                                                           *
                                                                                                                                                           * or in the "license" file accompanying this file. This file is
                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
                                                                                                                                                           * for the specific language governing permissions and
                                                                                                                                                           * limitations under the License.
                                                                                                                                                           */

/** @class */
var CognitoUserPool = function () {
  /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */
  function CognitoUserPool(data) {
    _classCallCheck(this, CognitoUserPool);

    var _ref = data || {},
        UserPoolId = _ref.UserPoolId,
        ClientId = _ref.ClientId,
        endpoint = _ref.endpoint,
        AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;

    if (!UserPoolId || !ClientId) {
      throw new Error('Both UserPoolId and ClientId are required.');
    }
    if (!/^[\w-]+_.+$/.test(UserPoolId)) {
      throw new Error('Invalid UserPoolId format.');
    }
    var region = UserPoolId.split('_')[0];

    this.userPoolId = UserPoolId;
    this.clientId = ClientId;

    this.client = new _Client2.default(region, endpoint);

    /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */
    this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;

    this.storage = data.Storage || new _StorageHelper2.default().getStorage();
  }

  /**
   * @returns {string} the user pool id
   */


  CognitoUserPool.prototype.getUserPoolId = function getUserPoolId() {
    return this.userPoolId;
  };

  /**
   * @returns {string} the client id
   */


  CognitoUserPool.prototype.getClientId = function getClientId() {
    return this.clientId;
  };

  /**
   * @typedef {object} SignUpResult
   * @property {CognitoUser} user New user.
   * @property {bool} userConfirmed If the user is already confirmed.
   */
  /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @returns {void}
   */


  CognitoUserPool.prototype.signUp = function signUp(username, password, userAttributes, validationData, callback) {
    var _this = this;

    var jsonReq = {
      ClientId: this.clientId,
      Username: username,
      Password: password,
      UserAttributes: userAttributes,
      ValidationData: validationData
    };
    if (this.getUserContextData(username)) {
      jsonReq.UserContextData = this.getUserContextData(username);
    }
    this.client.request('SignUp', jsonReq, function (err, data) {
      if (err) {
        return callback(err, null);
      }

      var cognitoUser = {
        Username: username,
        Pool: _this,
        Storage: _this.storage
      };

      var returnData = {
        user: new _CognitoUser2.default(cognitoUser),
        userConfirmed: data.UserConfirmed,
        userSub: data.UserSub
      };

      return callback(null, returnData);
    });
  };

  /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */


  CognitoUserPool.prototype.getCurrentUser = function getCurrentUser() {
    var lastUserKey = 'CognitoIdentityServiceProvider.' + this.clientId + '.LastAuthUser';

    var lastAuthUser = this.storage.getItem(lastUserKey);
    if (lastAuthUser) {
      var cognitoUser = {
        Username: lastAuthUser,
        Pool: this,
        Storage: this.storage
      };

      return new _CognitoUser2.default(cognitoUser);
    }

    return null;
  };

  /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/


  CognitoUserPool.prototype.getUserContextData = function getUserContextData(username) {
    if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
      return undefined;
    }
    /* eslint-disable */
    var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
    /* eslint-enable */

    if (this.advancedSecurityDataCollectionFlag) {
      var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
      if (advancedSecurityData) {
        var userContextData = {
          EncodedData: advancedSecurityData
        };
        return userContextData;
      }
    }
    return {};
  };

  return CognitoUserPool;
}();

exports.default = CognitoUserPool;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _UserAgent = __webpack_require__(1537);

var _UserAgent2 = _interopRequireDefault(_UserAgent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @class */
var Client = function () {
  /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   */
  function Client(region, endpoint) {
    _classCallCheck(this, Client);

    this.endpoint = endpoint || 'https://cognito-idp.' + region + '.amazonaws.com/';
    this.userAgent = _UserAgent2.default.prototype.userAgent || 'aws-amplify/0.1.x js';
  }

  /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
  */


  Client.prototype.request = function request(operation, params, callback) {
    var headers = {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.' + operation,
      'X-Amz-User-Agent': this.userAgent
    };

    var options = {
      headers: headers,
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(params)
    };

    var response = void 0;

    fetch(this.endpoint, options).then(function (resp) {
      response = resp;
      return resp;
    }).then(function (resp) {
      return resp.json().catch(function () {
        return {};
      });
    }).then(function (data) {
      if (response.ok) return callback(null, data);

      // Taken from aws-sdk-js/lib/protocol/json.js
      // eslint-disable-next-line no-underscore-dangle
      var code = (data.__type || data.code).split('#').pop();
      var error = {
        code: code,
        name: code,
        message: data.message || data.Message || null
      };
      return callback(error);
    }).catch(function () {
      // Taken from aws-sdk-js/lib/protocol/json.js
      var code = (response.headers.get('x-amzn-errortype') || 'UnknownError').split(':')[0];
      var error = {
        code: code,
        name: code,
        statusCode: response.status,
        message: response.status.toString()
      };
      return callback(error);
    });
  };

  return Client;
}();

exports.default = Client;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// class for defining the amzn user-agent
exports.default = UserAgent;
// constructor

function UserAgent() {}
// public
UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jsCookie = __webpack_require__(1539);

var Cookies = _interopRequireWildcard(_jsCookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @class */
var CookieStorage = function () {

  /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   */
  function CookieStorage(data) {
    _classCallCheck(this, CookieStorage);

    this.domain = data.domain;
    if (data.path) {
      this.path = data.path;
    } else {
      this.path = '/';
    }
    if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
      this.expires = data.expires;
    } else {
      this.expires = 365;
    }
    if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
      this.secure = data.secure;
    } else {
      this.secure = true;
    }
  }

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */


  CookieStorage.prototype.setItem = function setItem(key, value) {
    Cookies.set(key, value, {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    });
    return Cookies.get(key);
  };

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */


  CookieStorage.prototype.getItem = function getItem(key) {
    return Cookies.get(key);
  };

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */


  CookieStorage.prototype.removeItem = function removeItem(key) {
    return Cookies.remove(key, {
      path: this.path,
      domain: this.domain,
      secure: this.secure
    });
  };

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */


  CookieStorage.prototype.clear = function clear() {
    var cookies = Cookies.get();
    var index = void 0;
    for (index = 0; index < cookies.length; ++index) {
      Cookies.remove(cookies[index]);
    }
    return {};
  };

  return CookieStorage;
}();

exports.default = CookieStorage;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _index = __webpack_require__(1541);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1546);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(1663);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(1666);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(1669);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(1906);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(1908);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(1910);

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__(1919);

var _index18 = _interopRequireDefault(_index17);

var _index19 = __webpack_require__(1921);

var _index20 = _interopRequireDefault(_index19);

var _index21 = __webpack_require__(1923);

var _index22 = _interopRequireDefault(_index21);

var _index23 = __webpack_require__(1924);

var _index24 = _interopRequireDefault(_index23);

var _ProfileAndSettings = __webpack_require__(1925);

var _ProfileAndSettings2 = _interopRequireDefault(_ProfileAndSettings);

var _SetThemeColor = __webpack_require__(836);

var _SetThemeColor2 = _interopRequireDefault(_SetThemeColor);

var _reactRedux = __webpack_require__(30);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Components = function Components(_ref) {
    var match = _ref.match,
        profileInfo = _ref.profileInfo;
    return _react2.default.createElement('div', { className: 'app-wrapper' }, _react2.default.createElement(_reactRouterDom.Switch, null, _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: match.url + '/', to: match.url + '/alerts' }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/correlations', component: _index2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/metrics', component: _index22.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/devices', component: _index4.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/config', component: _index6.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/deviceVitals', component: _index10.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/deviceCatalogue', component: _index12.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/alerts', component: _index14.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/downloadData', component: _index20.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/notifications', component: _index8.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/summary', component: _index18.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/heartbeat', component: _index16.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/machineLearning', component: _index24.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/profile-and-settings', component: _ProfileAndSettings2.default }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/admin-panel', component: profileInfo.isAdmin ? _SetThemeColor2.default : _index16.default })));
};

var mapStateToProps = function mapStateToProps(_ref2) {
    var profileInfo = _ref2.profileInfo;

    return { profileInfo: profileInfo };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Components);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(Components, 'Components', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index2, '_index2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index4, '_index4', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index6, '_index6', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index8, '_index8', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index10, '_index10', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index12, '_index12', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index14, '_index14', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index16, '_index16', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index18, '_index18', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index20, '_index20', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index22, '_index22', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_index24, '_index24', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_ProfileAndSettings2, '_ProfileAndSettings2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_SetThemeColor2, '_SetThemeColor2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(Components, 'Components', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/index.js');
}();

;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fusioncharts = __webpack_require__(608);

var _fusioncharts2 = _interopRequireDefault(_fusioncharts);

var _fusioncharts3 = __webpack_require__(609);

var _fusioncharts4 = _interopRequireDefault(_fusioncharts3);

var _fusionChartManager = __webpack_require__(374);

var _reactRedux = __webpack_require__(30);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _fusioncharts4.default)(_fusioncharts2.default);

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    _createClass(App, [{
        key: 'render',
        value: function render() {

            this.dispatchActionToHideLoader();

            return _react2.default.createElement('div', { id: 'correlation', className: 'contentOuter-wrapper' }, _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'page-heading d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Correlations'))), _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'row ' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-6 ' }, _react2.default.createElement('div', { className: 'jr-card set-background' }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-white' }, 'Device Correlation Breakdown Summary')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { id: this.devideCorrelationId }))), _react2.default.createElement('div', { className: 'jr-card set-background' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h3', { className: 'text-white float-right text-nowrap' }, 'Implementation Cost'), _react2.default.createElement('img', { className: 'float-right mr-3',
                src: '../../../../assets/images/green_circle_3.png' }), _react2.default.createElement('img', { className: 'float-right mr-2 pt-1',
                src: '../../../../assets/images/green_circle_2.png' }), _react2.default.createElement('img', { className: 'float-right mr-2 pt-2',
                src: '../../../../assets/images/green_circle_1.png' }), _react2.default.createElement('h3', { className: 'text-white' }, 'Value and Prioritization Mapping')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.valuePrioritizingId })))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card pb-4 set-background' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h3', { className: 'text-white' }, 'Correlation Heat Map')), _react2.default.createElement('div', { className: 'jr-card-body pt-5' }, _react2.default.createElement('div', { id: this.correlationHeatId })))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-12' }, _react2.default.createElement('div', { className: 'jr-card source-systems justify-content-center set-background' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h3', { className: 'text-white' }, 'Source System Data Correlations')), _react2.default.createElement('div', { className: 'jr-card-body row source-systems justify-content-center' }, _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'UDS/DDE'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '2'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'BI Reporting')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'Remedy'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '13'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Incidents')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'Netcool'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '16'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Network Alarms')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'Genesys'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '9'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Call Centre')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'Comptel'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '5'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Order Fulfilment')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'Maximo'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '5'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Workforce Mgtmt.')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'Quittiq'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '12'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Field Force')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'PNI/ELMS'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '14'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Inventory/Location')), _react2.default.createElement('div', { className: 'col-6 col-sm-3 col-lg' }, _react2.default.createElement('img', { className: 'img-container', src: '../../../../assets/images/container.png' }), _react2.default.createElement('p', { className: 'center-the-text' }, 'CRM'), _react2.default.createElement('img', { className: 'blue-circle-position',
                src: '../../../../assets/images/blue_circle.png' }), _react2.default.createElement('p', { className: 'number-position' }, '22'), _react2.default.createElement('p', { className: 'center-the-small-text' }, 'Customer Profile')), _react2.default.createElement('div', null)))))));
        }
    }]);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.devideCorrelationId = "device-correlation";
        _this.valuePrioritizingId = "value-and-prioritizing";
        _this.correlationHeatId = "correlation-heat";

        _this.dispatchActionToHideLoader = function () {

            if (!_this.state.partialLoaderStateDeviceCorrelationBreakdownSummary && !_this.state.partialLoaderStateCorrelationHeatMap && !_this.state.partialLoaderStateValueAndPrioritizationMapping) {
                _this.props.hideLoader();
            }
        };

        _this.componentDidMount = function () {

            var self = _this;

            // initializing device-correlation chart

            var deviceCorrelationCategories = [{
                category: [{
                    label: 'BoM ForeCast'
                }, {
                    label: 'Service Incident'
                }, {
                    label: 'Network Fault'
                }, {
                    label: 'PNI Data Error'
                }, {
                    label: 'Security Breach'
                }, {
                    label: 'Repeat Truck Roll'
                }, {
                    label: 'Long MTTC'
                }, {
                    label: 'Long MTTR'
                }, {
                    label: 'SLA Breach'
                }]
            }];

            var deviceCorrelationDataset = [{
                seriesName: 'This Week',
                color: '#4fb1ec',
                data: [{
                    value: '17'
                }, {
                    value: '130'
                }, {
                    value: '104'
                }, {
                    value: '84'
                }, {
                    value: '14'
                }, {
                    value: '96'
                }, {
                    value: '87'
                }, {
                    value: '64'
                }, {
                    value: '68'
                }]
            }, {
                seriesName: 'Last Week',
                parentYAxis: 'S',
                renderAs: 'line',
                showValues: '0',
                color: '#92d050',
                data: [{
                    value: '34'
                }, {
                    value: '80'
                }, {
                    value: '60'
                }, {
                    value: '84'
                }, {
                    value: '14'
                }, {
                    value: '60'
                }, {
                    value: '40'
                }, {
                    value: '25'
                }, {
                    value: '68'
                }]
            }];

            (0, _fusionChartManager.dualYCombination)('device-correlation', deviceCorrelationCategories, deviceCorrelationDataset).then(function () {
                self.setState({
                    partialLoaderStateDeviceCorrelationBreakdownSummary: false
                });
            }, function () {
                self.setState({
                    partialLoaderStateDeviceCorrelationBreakdownSummary: false
                });
            });

            // initializing correlation-heat chart

            var dataset = [{
                data: [{
                    rowid: 'BoM Forecast',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'BoM Forecast',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Temp',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Temp',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Temp',
                    columnid: 'Service Incident',
                    value: '1',
                    tllabel: '$600'
                }, {
                    rowid: 'Temp',
                    columnid: 'Network Fault',
                    value: '1',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Temp',
                    columnid: 'PNI Data Error',
                    value: '1',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Temp',
                    columnid: 'Poor CSAT',
                    value: '1',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Temp',
                    columnid: 'Repeat Truck Poll',
                    value: '1',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Temp',
                    columnid: 'Long MTTC',
                    value: '1',
                    tllabel: '$600'
                }, {
                    rowid: 'Temp',
                    columnid: 'Long MTTR',
                    value: '1',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Temp',
                    columnid: 'Long MTTR',
                    value: '1',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Temp',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Humidity',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Humidity',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Humidity',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Spacial Depth',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Security Breach',
                    value: '9.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Power Leakage',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Gas Leakage',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Movement',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Movement',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Movement',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Movement',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Movement',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Movement',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Movement',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Movement',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Movement',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Movement',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Movement',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Intrusion',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Security Breach',
                    value: '7.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Battery Life',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }, {
                    rowid: 'Other',
                    columnid: 'SLA Breach',
                    value: '1',
                    tllabel: 'Quad Core 2.5 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Other',
                    columnid: 'Security Breach',
                    value: '9.3',
                    tllabel: '5.1 inch',
                    trlabel: 'AMOLED screen'
                }, {
                    rowid: 'Other',
                    columnid: 'Service Incident',
                    value: '9.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Other',
                    columnid: 'Network Fault',
                    value: '9.7',
                    tllabel: '29 Hrs',
                    trlabel: 'Battery : 2800 MAH'
                }, {
                    rowid: 'Other',
                    columnid: 'PNI Data Error',
                    value: '8',
                    tllabel: '16 MP',
                    trlabel: 'Front Camera : 2.1 MP'
                }, {
                    rowid: 'Other',
                    columnid: 'Poor CSAT',
                    value: '9.2',
                    tllabel: 'Quad Core 2.3 GHz',
                    trlabel: 'OS : Android 4.4 Kitkat'
                }, {
                    rowid: 'Other',
                    columnid: 'Repeat Truck Poll',
                    value: '8.3',
                    tllabel: '5 inch',
                    trlabel: 'LCD screen'
                }, {
                    rowid: 'Other',
                    columnid: 'Long MTTC',
                    value: '7.3',
                    tllabel: '$600'
                }, {
                    rowid: 'Other',
                    columnid: 'Long MTTR',
                    value: '8.8',
                    tllabel: '20 Hrs',
                    trlabel: 'Battery : 2600 MAH'
                }, {
                    rowid: 'Other',
                    columnid: 'Long MTTR',
                    value: '8.7',
                    tllabel: '4 MP',
                    trlabel: 'Front Camera : 5 MP'
                }, {
                    rowid: 'Other',
                    columnid: 'Other',
                    value: '1',
                    tllabel: 'Dual Core',
                    trlabel: 'OS : iOS 7'
                }]
            }];

            (0, _fusionChartManager.heatMapFusionChart)('correlation-heat', dataset).then(function () {
                self.setState({
                    partialLoaderStateCorrelationHeatMap: false
                });
            });

            // initializing value-and-prioritizing

            (0, _fusionChartManager.bubbleChartFusionCharts)('value-and-prioritizing').then(function () {
                self.setState({
                    partialLoaderStateValueAndPrioritizationMapping: false
                });
            });
        };

        _this.props.showLoader();

        _this.state = {
            // Setting initial values for partial loader state for all charts to be rendered
            partialLoaderStateDeviceCorrelationBreakdownSummary: true,
            partialLoaderStateCorrelationHeatMap: true,
            partialLoaderStateValueAndPrioritizationMapping: true
        };
        return _this;
    }

    _createClass(App, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            (0, _fusionChartManager.disposeChart)(this.devideCorrelationId);
            (0, _fusionChartManager.disposeChart)(this.valuePrioritizingId);
            (0, _fusionChartManager.disposeChart)(this.correlationHeatId);
        }
    }]);

    return App;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        showLoader: function showLoader() {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: function hideLoader() {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        }
    };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(App);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(App, 'App', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_fusioncharts2, "_fusioncharts2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_fusioncharts4, "_fusioncharts4", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/correlations/index.js");
}();

;

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

!function(e){"object"==typeof module&&"undefined"!=typeof module.exports?module.exports=e:e()}((function(){(window.webpackJsonpFusionCharts=window.webpackJsonpFusionCharts||[]).push([[15],{1257:function(e,t,o){"use strict";var r=o(219);t.__esModule=!0,t["default"]=void 0;var a=r(o(1258));t.Maps=a["default"];var n={name:"maps",type:"package",requiresFusionCharts:!0,extension:function(e){return e.addDep(a["default"])}};t["default"]=n},1258:function(e,t,o){"use strict";var r=o(219);t.__esModule=!0,t["default"]=void 0;var a=r(o(238)),n=r(o(565)),l=o(240),i=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var o=f(t);if(o&&o.has(e))return o.get(e);var r={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var n in e)if("default"!==n&&Object.prototype.hasOwnProperty.call(e,n)){var l=a?Object.getOwnPropertyDescriptor(e,n):null;l&&(l.get||l.set)?Object.defineProperty(r,n,l):r[n]=e[n]}r["default"]=e,o&&o.set(e,r);return r}(o(477)),s=r(o(226)),c=o(231),h=o(224),d=r(o(1259)),u=r(o(466)),p=r(o(1052)),g=r(o(1056));function f(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,o=new WeakMap;return(f=function(e){return e?o:t})(e)}var m=(0,h.extend2)({foregroundcolor:"333333",foregroundalpha:"100",foregrounddarkcolor:"111111",foregrounddarkalpha:"100",foregroundlightcolor:"666666",foregroundlightalpha:"100",backgroundlightcolor:"FFFFFF",backgroundlightalpha:"100",backgroundlightangle:90,backgroundlightratio:"",backgroundcolor:"FFFFCC",backgroundalpha:"100",backgrounddarkcolor:"ffcc66",backgrounddarkalpha:"100",backgrounddarkangle:270,backgrounddarkratio:"",shadow:1},i),b={basefontcolor:"foregroundcolor",bordercolor:"foregrounddarkcolor",borderalpha:"foregrounddarkalpha",bgcolor:"backgroundlightcolor",bgalpha:"backgroundlightalpha",bgangle:"backgroundlightangle",bgratio:"backgroundlightratio",canvasbordercolor:"foregrounddarkcolor",canvasborderalpha:"foregrounddarkalpha",canvasbgcolor:"backgroundlightcolor",canvasbgalpha:"backgroundlightalpha",canvasbgangle:"backgroundlightangle",canvasbgratio:"backgroundlightratio",tooltipbordercolor:"foregrounddarkcolor",tooltipborderalpha:"foregrounddarkalpha",tooltipbgcolor:"backgroundlightcolor",tooltipbgalpha:"backgroundlightalpha",tooltipfontcolor:"foregroundcolor",legendbordercolor:"foregrounddarkcolor",legendborderalpha:"foregrounddarkalpha",markerbordercolor:"foregroundlightcolor",markerborderalpha:"foregroundlightalpha",markerfillcolor:"backgrounddarkcolor",markerfillalpha:"backgrounddarkalpha",markerfillangle:"backgrounddarkangle",markerfillratio:"backgrounddarkratio",plotfillcolor:"backgroundcolor",plotfillalpha:"backgroundalpha",plotfillangle:"backgroundangle",plotfillratio:"backgroundratio",plothoverfillcolor:"backgrounddarkcolor",plothoverfillalpha:"backgrounddarkalpha",plothoverfillangle:"backgrounddarkangle",plothoverfillratio:"backgrounddarkratio",plotbordercolor:"foregroundcolor",plotborderalpha:"foregroundalpha",shadow:"shadow"},k={getMapName:function(){return this.jsVars.instanceAPI.getName().toLowerCase()},getEntityList:function(){var e,t,o,r,a,n=this.jsVars.instanceAPI.getDatasets()||[],l=n.length,i=[];for(e=0;e<l;e++)if("entities"===(o=n[e]||[]).getName()){t=o;break}for(e in l=(r=t.components.data).length,r)r.hasOwnProperty(e)&&(a=(r[e]||{}).config||{},i.push({id:a.id,originalId:a.originalId||a.id,label:a.label,shortlabel:a.shortLabel,value:a.value,formattedValue:a.formattedValue,toolText:a.toolText}));return i},getMapAttribute:function(){var e=this;return(0,c.raiseWarning)(this,"12061210581","run","JavaScriptRenderer~getMapAttribute()",'Use of deprecated "getMapAttribute()". Replace with "getChartAttribute()".'),e.getChartAttribute.apply(e,arguments)},exportMap:function(){var e=this;return(0,c.raiseWarning)(this,"12061210581","run","JavaScriptRenderer~exportMap()",'Use of deprecated "exportMap()". Replace with "exportChart()".'),e.exportChart&&e.exportChart.apply(e,arguments)},addMarker:function(e){var t,o,r,a=this.jsVars.instanceAPI.getDatasets()||[],n=a.length;for(t=0;t<n;t++)if("markers"===(o=a[t]||[]).getName()){r=o;break}r&&!r.addMarkerItem(e)&&(0,c.raiseWarning)(this,"1309264086","run","MapsRenderer~addMarker()","Failed to add marker. Check the options and try again.")},updateMarker:function(e,t){var o,r,a,n,l=this.jsVars.instanceAPI.getDatasets()||[],i=l.length;for(r=0;r<i;r++)if("markers"===(a=l[r]||[]).getName()){n=a;break}n&&e&&(o=(e+v).toLowerCase(),n.updateMarkerItem(o,t))},removeMarker:function(e){var t,o,r,a,n=this.jsVars.instanceAPI.getDatasets()||[],l=n.length;for(o=0;o<l;o++)if("markers"===(r=n[o]||[]).getName()){a=r;break}e&&(t=(e+v).toLowerCase(),a._removeMarkerItem(t))}},v="",C=window.Math,y=C.min,F=C.max,w=function(e){function t(t,o){var r,a;for(a in(r=e.call(this)||this).subpalette=h.BLANKSTRING,r.key=h.BLANKSTRING,r.index=o,t)r.subpalette=m[t[a]],r[a]=r.subpalette instanceof Array?r.subpalette[o]:r.subpalette,r.key=a;return r}return(0,a["default"])(t,e),t}(l.ComponentInterface),A=function(e){function t(){var t;return(t=e.call(this)||this).friendlyName="Map",t.revision=1,t.hasCanvas=!0,t.standaloneInit=!1,t.defaultDatasetType="maps",t.defaultSeriesType="geo",t.fireGroupEvent=!0,t.legendposition="right",t.hasGradientLegend=!0,t.isMap=!0,t.defaultPaletteOptions={paletteColors:[["A6A6A6","CCCCCC","E1E1E1","F0F0F0"],["A7AA95","C4C6B7","DEDFD7","F2F2EE"],["04C2E3","66E7FD","9CEFFE","CEF8FF"],["FA9101","FEB654","FED7A0","FFEDD5"],["FF2B60","FF6C92","FFB9CB","FFE8EE"]],bgColor:["FFFFFF","CFD4BE,F3F5DD","C5DADD,EDFBFE","A86402,FDC16D","FF7CA0,FFD1DD"],bgAngle:[270,270,270,270,270],bgRatio:["0,100","0,100","0,100","0,100","0,100"],bgAlpha:["100","60,50","40,20","20,10","30,30"],toolTipBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],toolTipBorderColor:["545454","545454","415D6F","845001","68001B"],baseFontColor:["555555","60634E","025B6A","A15E01","68001B"],tickColor:["333333","60634E","025B6A","A15E01","68001B"],trendColor:["545454","60634E","415D6F","845001","68001B"],plotFillColor:["545454","60634E","415D6F","845001","68001B"],borderColor:["767575","545454","415D6F","845001","68001B"],borderAlpha:[50,50,50,50,50]},t.colorPaletteMap=b,t.eiMethods=k,t.registerFactory("legend",g["default"],["canvas"]),t.registerFactory("axis",h.stubFN,["canvas"]),t.registerFactory("colormanager-decider",p["default"],["legend"]),t.registerFactory("dataset",d["default"],["colormanager-decider"]),t.registerFactory("canvas",u["default"]),t}(0,a["default"])(t,e);var o=t.prototype;return o._checkInvalidSpecificData=function(){return this.config.invalid=!1,!1},o.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;!t.baseWidth&&(t.baseWidth=400),!t.baseHeight&&(t.baseHeight=300),!t.baseScaleFactor&&(t.baseScaleFactor=1)},t.getName=function(){return"maps"},t.getType=function(){return"chartAPI"},o.getName=function(){return this.config.name||"GEO"},o.getType=function(){return"chartAPI"},o.configureAttributes=function(t){var o,r=this.getChildren("colorPalette")&&this.getChildren("colorPalette")[0];o=t.chart=t.chart||t.graph||t.map||{},this.jsonData=t,r||(r=new w(this.colorPaletteMap,(o.palette>0&&o.palette<6?o.palette:(0,h.pluckNumber)(this.paletteIndex,1))-1),this.attachChild(r,"colorPalette")),this.config.skipCanvasDrawing=!0,e.prototype.configureAttributes.call(this,t),this._parseBackgroundCosmetics()},o.parseChartAttr=function(t){var o,r,a,n,l,i=this.jsonData,s=i.chart||i.map,c=i.markers,d=new w(this.colorPaletteMap,(s.palette>0&&s.palette<6?s.palette:(0,h.pluckNumber)(this.paletteIndex,1))-1),u=(0,h.pluck)(s.entitybordercolor,s.bordercolor,d.plotbordercolor),p=(0,h.pluck)(s.entityfillcolor,s.fillcolor,d.plotfillcolor),g=(0,h.pluck)(s.entityfillalpha,s.fillalpha,d.plotfillalpha),f=(0,h.pluck)(s.entityfillratio,s.fillratio,d.plotfillratio),m=(0,h.pluck)(s.entityfillangle,s.fillangle,d.plotfillangle),b=(0,h.pluck)(s.nullentityfillcolor,s.nullentitycolor,p),k=(0,h.pluckNumber)(s.usevaluesformarkers,i.markers&&i.markers.items&&i.markers.items.length,!(i.markers&&i.markers.application&&i.markers.application.length&&i.markers.definition&&i.markers.definition.length));e.prototype.parseChartAttr.call(this,t),(o=this.config).origMarginTop=(0,h.pluckNumber)(s.charttopmargin,s.maptopmargin,11),o.origMarginLeft=(0,h.pluckNumber)(s.chartleftmargin,s.mapleftmargin,11),o.origMarginBottom=(0,h.pluckNumber)(s.chartbottommargin,s.mapbottommargin,11),o.origMarginRight=(0,h.pluckNumber)(s.chartrightmargin,s.maprightmargin,11),o.labelsOnTop=(0,h.pluckNumber)(s.entitylabelsontop,1),r=(l=o.style).inCancolor,a=l.inCanfontFamily,n=l.inCanfontSize,o.entityOpts={baseScaleFactor:o.baseScaleFactor,dataLabels:{style:{fontFamily:a,fontSize:n,lineHeight:l.inCanLineHeight,color:(0,h.pluck)(s.entitylabelcolor,l.inCancolor),bgColor:(0,h.pluck)(s.entitylabelbgcolor)||v,borderColor:(0,h.pluck)(s.entitylabelbordercolor)||v}},fillColor:p,fillAlpha:g,fillRatio:f,fillAngle:m,borderColor:u,borderAlpha:(0,h.pluck)(s.entityborderalpha,s.borderalpha,this.borderAlpha,"100"),borderThickness:(0,h.pluckNumber)(s.showentityborder,s.showborder,1)?(0,h.pluckNumber)(s.entityborderthickness,s.borderthickness,1):0,scaleBorder:(0,h.pluckNumber)(s.scaleentityborder,s.scaleborder,0),hoverFillColor:(0,h.pluck)(s.entityfillhovercolor,s.hoverfillcolor,s.hovercolor,d.plothoverfillcolor),hoverFillAlpha:(0,h.pluck)(s.entityfillhoveralpha,s.hoverfillalpha,s.hoveralpha,d.plothoverfillalpha),hoverFillRatio:(0,h.pluck)(s.entityfillhoverratio,s.hoverfillratio,s.hoverratio,d.plothoverfillratio),hoverFillAngle:(0,h.pluck)(s.entityfillhoverangle,s.hoverfillangle,s.hoverangle,d.plothoverfillangle),hoverBorderThickness:(0,h.pluck)(s.entityborderhoverthickness,s.hoverborderthickness),hoverBorderColor:(0,h.pluck)(s.entityborderhovercolor,u,d.plotbordercolor),hoverBorderAlpha:(0,h.pluck)(s.entityborderhoveralpha,d.plotborderalpha),nullEntityColor:b,nullEntityAlpha:(0,h.pluck)(s.nullentityfillalpha,s.nullentityalpha,g),nullEntityRatio:(0,h.pluck)(s.nullentityfillratio,s.nullentityratio,f),nullEntityAngle:(0,h.pluck)(s.nullentityfillangle,s.nullentityangle,m),connectorColor:(0,h.pluck)(s.labelconnectorcolor,s.connectorcolor,r),connectorAlpha:(0,h.pluck)(s.labelconnectoralpha,s.connectoralpha,"100"),connectorThickness:(0,h.pluckNumber)(s.labelconnectorthickness,s.borderthickness,1),showHoverEffect:(0,h.pluckNumber)(s.showentityhovereffect,s.usehovercolor,s.showhovereffect,1),hoverOnNull:(0,h.pluckNumber)(s.hoveronnull,s.entityhoveronnull,1),labelPadding:(0,h.pluckNumber)(s.labelpadding,5),showLabels:(0,h.pluckNumber)(s.showlabels,1),labelsOnTop:(0,h.pluckNumber)(s.entitylabelsontop,1),includeNameInLabels:(0,h.pluckNumber)(s.includenameinlabels,1),includeValueInLabels:(0,h.pluckNumber)(s.includevalueinlabels,0),useSNameInTooltip:(0,h.pluckNumber)(s.usesnameintooltip,0),useShortName:(0,h.pluckNumber)(s.usesnameinlabels,1),labelSepChar:(0,h.pluck)(s.labelsepchar,", "),showTooltip:(0,h.pluckNumber)(s.showentitytooltip,s.showtooltip,1),tooltipSepChar:(0,h.pluck)(s.tooltipsepchar,", "),tooltext:s.entitytooltext,hideNullEntities:(0,h.pluckNumber)(s.hidenullentities,0),showHiddenEntityBorder:(0,h.pluckNumber)(s.showhiddenentityborder,1),showNullEntityBorder:(0,h.pluckNumber)(s.shownullentityborder,1),hiddenEntityColor:(0,h.pluck)(s.hiddenentitycolor,s.hiddenentityfillcolor,s.hiddenentityalpha||s.hiddenentityfillalpha?b:"ffffff"),hiddenEntityAlpha:(0,h.pluck)(s.hiddenentityalpha,s.hiddenentityfillalpha,.001),shadow:(0,h.pluckNumber)(s.showshadow,this.defaultPlotShadow,d.shadow)},o.markerOpts={dataLabels:{style:{fontFamily:(0,h.pluck)(s.markerfont,a),fontSize:(0,h.pluckNumber)(s.markerfontsize,parseInt(n,10)),fontColor:(0,h.pluck)(s.markerlabelcolor,s.markerfontcolor,r),labelBgColor:(0,h.pluck)(s.markerlabelbgcolor)||v,labelBorderColor:(0,h.pluck)(s.markerlabelbordercolor)||v}},showTooltip:(0,h.pluckNumber)(s.showmarkertooltip,s.showtooltip,1),showLabels:(0,h.pluckNumber)(s.showmarkerlabels,s.showlabels,1),showHoverEffect:(0,h.pluckNumber)(s.showmarkerhovereffect,1),labelPadding:(0,h.pluck)(s.markerlabelpadding,"5"),labelWrapWidth:(0,h.pluckNumber)(s.markerlabelwrapwidth,0),labelWrapHeight:(0,h.pluckNumber)(s.markerlabelwrapheight,0),fillColor:(0,h.pluck)(s.markerfillcolor,s.markerbgcolor,d.markerfillcolor),fillAlpha:(0,h.pluck)(s.markerfillalpha,d.markerfillalpha),fillAngle:(0,h.pluck)(s.markerfillangle,d.markerfillangle),fillRatio:(0,h.pluck)(s.markerfillratio,d.markerfillratio),fillPattern:(0,h.pluck)(s.markerfillpattern,d.markerbgpattern),hoverFillColor:s.markerfillhovercolor,hoverFillAlpha:s.markerfillhoveralpha,hoverFillRatio:s.markerfillhoverratio,hoverFillAngle:s.markerfillhoverangle,borderThickness:(0,h.pluck)(s.markerborderthickness,1),borderColor:(0,h.pluck)(s.markerbordercolor,d.markerbordercolor),borderAlpha:(0,h.pluckNumber)(s.markerborderalpha,d.markerborderalpha),hoverBorderThickness:s.markerborderhoverthickness,hoverBorderColor:s.markerborderhovercolor,hoverBorderAlpha:s.markerborderhoveralpha,radius:(0,h.pluckNumber)(s.markerradius&&(0,h.trimString)(s.markerradius),7),shapeId:(0,h.pluck)(s.defaultmarkershape,"circle"),labelSepChar:(0,h.pluck)(s.labelsepchar,", "),tooltipSepChar:(0,h.pluck)(s.tooltipsepchar,", "),autoScale:(0,h.pluckNumber)(s.autoscalemarkers,0),tooltext:(0,h.pluck)(c&&c.tooltext,s.markertooltext),dataEnabled:k,valueToRadius:(0,h.pluckNumber)(s.markerradiusfromvalue,1),valueMarkerAlpha:(0,h.pluck)(s.valuemarkeralpha,"75"),hideNull:(0,h.pluckNumber)(s.hidenullmarkers,0),nullRadius:(0,h.pluckNumber)(s.nullmarkerradius,s.markerradius,7),adjustViewPort:(0,h.pluckNumber)(s.adjustviewportformarkers,0),startAngle:(0,h.pluckNumber)(s.markerstartangle,90),maxRadius:(0,h.pluckNumber)(s.maxmarkerradius,0),minRadius:(0,h.pluckNumber)(s.minmarkerradius,0),applyAll:(0,h.pluckNumber)(s.applyallmarkers,0),shadow:(0,h.pluckNumber)(s.showmarkershadow,s.showshadow,0)},o.connectorOpts={showHoverEffect:(0,h.pluckNumber)(s.showconnectorhovereffect,1),thickness:(0,h.pluckNumber)(s.connectorthickness,s.markerconnthickness,"2"),color:(0,h.pluck)(s.connectorcolor,s.markerconncolor,d.markerbordercolor),alpha:(0,h.pluck)(s.connectoralpha,s.markerconnalpha,"100"),hoverThickness:(0,h.pluckNumber)(s.connectorhoverthickness,s.connectorthickness,s.markerconnthickness,"2"),hoverColor:(0,h.pluck)(s.connectorhovercolor,s.connectorcolor,s.markerconncolor,d.markerbordercolor),hoverAlpha:(0,h.pluck)(s.connectorhoveralpha,s.connectoralpha,s.markerconnalpha,"100"),dashed:(0,h.pluckNumber)(s.connectordashed,s.markerconndashed,0),dashLen:(0,h.pluckNumber)(s.connectordashlen,s.markerconndashlen,3),dashGap:(0,h.pluckNumber)(s.connectordashgap,s.markerconndashgap,2),font:(0,h.pluck)(s.connectorfont,s.markerconnfont,a),fontColor:(0,h.pluck)(s.connectorlabelcolor,s.connectorfontcolor,s.markerconnfontcolor,r),fontSize:(0,h.pluckNumber)(s.connectorfontsize,s.markerconnfontsize,parseInt(n,10)),showLabels:(0,h.pluckNumber)(s.showconnectorlabels,s.showmarkerlabels,s.showlabels,1),labelBgColor:(0,h.pluck)(s.connectorlabelbgcolor,s.markerconnlabelbgcolor,d.plotfillcolor),labelBorderColor:(0,h.pluck)(s.connectorlabelbordercolor,s.markerconnlabelbordercolor,d.markerbordercolor),shadow:(0,h.pluckNumber)(s.showconnectorshadow,s.showmarkershadow,s.showshadow,0),showTooltip:(0,h.pluckNumber)(s.showconnectortooltip,s.showmarkertooltip,s.showtooltip,1),tooltext:(0,h.pluck)(c&&c.connectortooltext,s.connectortooltext),hideOpen:(0,h.pluckNumber)(s.hideopenconnectors,1)},o.adjustViewPortForMarkers=(0,h.pluckNumber)(s.adjustviewportformarkers,k)},o._attachMouseEvents=function(){var e=this.getFromEnv("eventListeners"),o=this.getFromEnv("chart-container");e.push(s["default"].listen(o,h.hasTouch?"touchstart":"click",t.searchMouseMove,this)),e.push(s["default"].listen(window.document,h.hasTouch?"touchstart":"mousemove",t.searchMouseMove,this))},o._dispose=function(){var o=this.getFromEnv("chart-container");h.hasTouch&&(s["default"].unlisten(o,"touchstart",t.searchMouseMove),s["default"].unlisten(window.document,"touchstart",t.searchMouseMove)),s["default"].unlisten(o,"click",t.searchMouseMove),s["default"].unlisten(window.document,"mousemove",t.searchMouseMove),e.prototype._dispose.call(this)},t.searchMouseMove=function(e){var t,o=e.data,r=o.config,a=o.getDatasets()[1],n=a&&a.getFromEnv("toolTipController"),l=a&&a.config.currentToolTip,i=o.config.lastHoveredPoint,s={};o.getFromEnv("chart-container")&&o.config.lastInteractionEvent!==e.originalEvent&&(o.config.lastInteractionEvent=e.originalEvent,(t=function(e,t){var o=(0,h.getMouseCoordinate)(t.getFromEnv("chart-container"),e,t),r=o.chartX,a=o.chartY,n=t.config,l=n.canvasLeft,i=n.canvasTop,s=n.canvasLeft+n.canvasWidth,c=n.canvasHeight+n.canvasTop;return o.insideCanvas=!1,o.originalEvent=e,r>l&&r<s&&a>i&&a<c&&(o.insideCanvas=!0),o}(e,o))&&t.insideCanvas?(r.lastMouseEvent=e,s={x:t.chartX,y:t.chartY},o._searchNearestNeighbour(s,e)):(i&&a&&a.hoverOutFn(i.element),o.config.lastHoveredPoint=null,n&&n.hide(l)))},o._searchNearestNeighbour=function(e,t){var o,r=this.getDatasets()[1];if(r){if(!r.components.kDTree)return;(o=r.getElement(e))?r.highlightPoint(o,t):r.highlightPoint(!1,t)}},o._createLayers=function(){e.prototype._createLayers.call(this),this._attachMouseEvents()},o._parseBackgroundCosmetics=function(){var e,t=this.getChildren("background")[0].config,o=this.getChildren("colorPalette")[0],r=this.getFromEnv("chart-attrib");e=t.showBorder=(0,h.pluckNumber)(r.showcanvasborder,1),t.borderWidth=e?(0,h.pluckNumber)(r.canvasborderthickness,1):0,t.borderRadius=t.borderRadius=(0,h.pluckNumber)(r.canvasborderradius,0),t.borderDashStyle=t.borderDashStyle=(0,h.pluckNumber)(r.borderdashed,0)?(0,h.getDashStyle)((0,h.pluckNumber)(r.borderdashlen,4),(0,h.pluckNumber)(r.borderdashgap,2)):"none",t.borderAlpha=(0,h.pluck)(r.canvasborderalpha,o.borderAlpha),t.borderColor=t.borderColor=(0,h.convertColor)((0,h.pluck)(r.canvasbordercolor,o&&o.borderColor),t.borderAlpha)},o._getBackgroundCosmetics=function(){var e=this.getFromEnv("chart-attrib")||this.jsonData.map,t=this.getChildren("colorPalette")[0];return{FCcolor:{color:(0,h.pluck)(e.bgcolor,e.canvasbgcolor,t.bgcolor),alpha:(0,h.pluck)(e.bgalpha,e.canvasbgalpha,t.bgalpha),angle:(0,h.pluck)(e.bgangle,e.canvasbgangle,t.bgangle),ratio:(0,h.pluck)(e.bgratio,e.canvasbgratio,t.bgratio)}}},o._parseCanvasCosmetics=function(){e.prototype._parseCanvasCosmetics.call(this);var t=this.config,o=this.getFromEnv("chart-attrib")||this.jsonData.map,r=this.getChildren("canvas")[0].config;t.origMarginTop=(0,h.pluckNumber)(o.maptopmargin,11),t.origMarginLeft=(0,h.pluckNumber)(o.mapleftmargin,11),t.origMarginBottom=(0,h.pluckNumber)(o.mapbottommargin,11),t.origMarginRight=(0,h.pluckNumber)(o.maprightmargin,11),t.origCanvasLeftMargin=(0,h.pluckNumber)(o.canvasleftmargin,0),t.origCanvasRightMargin=(0,h.pluckNumber)(o.canvasrightmargin,0),t.origCanvasTopMargin=(0,h.pluckNumber)(o.canvastopmargin,0),t.origCanvasBottomMargin=(0,h.pluckNumber)(o.canvasbottommargin,0),r.canvasBorderRadius=(0,h.pluckNumber)(o.canvasborderradius,0),r.origCanvasTopPad=(0,h.pluckNumber)(o.canvastoppadding,0),r.origCanvasBottomPad=(0,h.pluckNumber)(o.canvasbottompadding,0),r.origCanvasLeftPad=(0,h.pluckNumber)(o.canvasleftpadding,0),r.origCanvasRightPad=(0,h.pluckNumber)(o.canvasrightpadding,0)},o.preliminaryScaling=function(){for(var e,t,o,r=this.jsonData,a=r.markers&&r.markers.items||[],n=a&&a.length||0,l=Infinity,i=Infinity,s=-Infinity,c=-Infinity;n--;)o=a[n],e=Number(o.x),t=Number(o.y),l=y(l,e),i=y(i,t),s=F(s,e),c=F(c,t);return{x:l,y:i,x1:s,y1:c}},o.getScalingParameters=function(e,t,o,r){var a,n,l=e/t,i=o/(e*this.config.baseScaleFactor),s=r/(t*this.config.baseScaleFactor),c=0,h=0;return i>s?(c+=(o-r*l)/2,n=200/(t*(a=s))):(h+=(r-o/l)/2,n=200/(e*(a=i))),{scaleFactor:a,strokeWidth:n,translateX:c,translateY:h}},o.calculateMarkerBounds=function(e,t,o){var r,a,n,l,i,s,c,h,d,u,p,g,f=this.config,m=f.markerOpts,b=this.getDatasets(),k=this.getDataLimits(),v=k.dataMin,C=k.dataMax,w=m.hideNull,A=m.nullRadius,E=m.valueToRadius,L=Infinity,x=Infinity,N=-Infinity,S=-Infinity;for(s=0,h=b.length;s<h;s++)"markers"===(c=b[s]).getName()&&(r=c);if(r)for(s in r.calculateMarkerRadiusLimits(),n=(a=r.config||{}).minRadius,l=a.maxRadius,i=r.components&&r.components.markerObjs||{})g=(f=i[s].config).definition||{},null!==f.cleanValue?(E&&void 0===g.radius&&(f.radius=n+(l-n)*(f.cleanValue-v)/(C-v)),p=Number(f.radius),d=(Number(g.x)+t)*e,u=(Number(g.y)+o)*e,L=y(L,d-p),x=y(x,u-p),N=F(N,d+p),S=F(S,u+p)):w?f.__hideMarker=!0:null===f.radius&&(f.radius=A);return{x:L,y:x,x1:N,y1:S}},o._spaceManager=function(){var e,t,o,r,a,n,l,i,s,c,d=this.config,u=this.getChildren("legend")&&this.getChildren("legend")[0],p=this.getChildren("gLegend")&&this.getChildren("gLegend")[0],g=u&&u.config.legendPos?u.config.legendPos.split("-"):p&&p.conf.legendPosition?p.conf.legendPosition.split("-"):[],f=this.getFromEnv("chart-attrib"),m=d.showBorder,b=d.origMarginLeft,k=d.origMarginTop,v=this.config.baseWidth,C=this.config.baseHeight,y={},F=0,w=0,A=d.markerOpts,E=d.borderWidth=m?(0,h.pluckNumber)(f.borderthickness,1):0;this._allocateSpace({top:E,bottom:E,left:E,right:E}),this._allocateSpace(this._manageActionBarSpace&&this._manageActionBarSpace(.225*d.availableHeight)||{}),s="right"===g[0]||"left"===g[0]?.3*d.canvasWidth:.3*d.canvasHeight,t=g[0]===h.POSITION_TOP||"bottom"===g[0]?d.canvasHeight:d.canvasWidth,d.showLegend&&this._manageLegendSpace(s),e="bottom"===g[0]||g[0]===h.POSITION_TOP?.225*d.canvasHeight:.225*d.canvasWidth,"top"===g[0]&&(k+=t-d.canvasHeight),c=this._manageChartMenuBar(e),"left"===g[0]&&(b+=t-d.canvasWidth),r=d.canvasWidth,a=d.canvasHeight,A.dataEnabled?(d.adjustViewPortForMarkers?((y=this.preliminaryScaling()).x1>v&&(v=y.x1),y.x<0&&(v+=-y.x,F=-y.x),y.y1>C&&(C=y.y1),y.y<0&&(C+=-y.y,w=-y.y),o=this.getScalingParameters(v,C,r,a),l=a,i=r,(y=this.calculateMarkerBounds(o.scaleFactor*this.config.baseScaleFactor,F,w)).x<0&&(b+=-y.x,r+=y.x),y.y<0&&(k+=-y.y,a+=y.y),y.x1>i&&(r-=y.x1-i),y.y1>l&&(a-=y.y1-l)):(o=this.getScalingParameters(v,C,r,a),this.calculateMarkerBounds(o.scaleFactor*this.config.baseScaleFactor,F,w)),b+=F*(o=this.getScalingParameters(v,C,r,a)).scaleFactor*this.config.baseScaleFactor,k+=w*o.scaleFactor*this.config.baseScaleFactor):o=this.getScalingParameters(v,C,r,a),this.config.scalingParams=o,n=o.scaleFactor,o.translateX=o.translateX+b,o.translateY=o.translateY+k+c.top||0,o.sFactor=n*this.config.baseScaleFactor*100/100,o.transformStr=["t",o.translateX,",",o.translateY,"s",n,",",n,",0,0"].join(""),this.config.annotationConfig={id:"Geo",showbelow:0,autoscale:0,grpxshift:o.translateX?o.translateX:0,grpyshift:o.translateY?o.translateY:0,xscale:100*(n?n*this.config.baseScaleFactor:1),yscale:100*(n?n*this.config.baseScaleFactor:1),scaletext:1,options:{useTracker:!0}}},o.getDataLimits=function(){var e,t,o=this.getDatasets(),r=o.length,a=+Infinity,n=-Infinity;for(t=0;t<r;t++)e=o[t].getDataLimits(),a=y(a,e.min),n=F(n,e.max);return{dataMin:a,dataMax:n}},o.getEntityPaths=function(e){var t,o={},r=this.config.entities;if(e){for(t in r)o[t]=r[t];return o}return r},o.checkComplete=function(){this.config.entityFlag&&this.config.entitiesReady&&(this.config.entityFlag=!1,this.config.markersDrawn=!0,this.fireChartInstanceEvent("internal.mapdrawingcomplete",{renderer:this}))},t}(n["default"]);t["default"]=A},1259:function(e,t,o){"use strict";var r=o(219);t.__esModule=!0,t["default"]=function(e){var t,o=e.getFromEnv("dataSource"),r=o.data||{},s=o.markers;(0,a.componentFactory)(e,i["default"],"mapGroup"),t=e.getChildren("mapGroup")[0],(0,a.datasetFactory)(t,n["default"],"entities",1,[r]),s?(0,a.datasetFactory)(t,l["default"],"markers",1,[s]):e.getDatasets()[1]&&e.getDatasets()[1].remove()};var a=o(224),n=r(o(1260)),l=r(o(1262)),i=r(o(1263))},1260:function(e,t,o){"use strict";var r=o(219);t.__esModule=!0,t["default"]=void 0;var a,n=r(o(238)),l=o(240),i=r(o(329)),s=o(232),c=r(o(1261)),h=o(224),d=o(236),u=r(o(598)),p=(0,s.getDep)("redraphael","plugin"),g=window.navigator.userAgent,f=/msie/i.test(g)&&!window.opera,m=window.Math,b=m.min,k=m.max,v=/stroke/gi,C=/AppleWebKit/.test(g),y=m.ceil,F=function(e,t){var o=t?(0,h.extend2)(e.FCcolor,t,!1,!0):{FCcolor:e};return o.toString=h.toRaphaelColor,o},w=function(e,t){var o,r,a={};if(r=t||1,!e||"object"!=typeof e)return a;for(o in e)v.test(o)||("stroke-width"===o?(a[o]=Number(e[o])/r,C&&(a[o]=a[o]&&y(a[o])||0)):a[o]=e[o]);return a},A={right:function(){return arguments[1]},left:function(e,t){return e-t},center:function(e,t){return 2*b(t,e-t)}},E={top:function(){return arguments[1]},middle:function(e,t){return 2*b(t,e-t)},bottom:function(e,t){return e-t}},L=function(e,t){e&&e.graphics.outlines.attr(t)};(0,s.addDep)({name:"mapsAnimation",type:"animationRule",extension:c["default"]}),(0,u["default"])(p);var x=function(e){function t(){var t;return(t=e.call(this)||this).components={},t}(0,n["default"])(t,e);var o=t.prototype;return o.getName=function(){return"entities"},o.getType=function(){return"dataset"},o.configureAttributes=function(e){if(e){this.JSONData={data:e};var o,r,n,l,i,s,c,d,u=this,p=u.getFromEnv("chart").jsonData,g=u.config,f=p.map||p.chart,m=[],b=u.getFromEnv("colorManager"),k=p.entitydef||[];for(i in!g.attachEvent&&b&&(u.addExtEventListener("legendUpdate",(function(){if("legend"===(d=arguments[1]).component)u.legendInteractivity(d.legendItem,d.colorObj);else for(m=d.maxMinArray,s=m.length,c=0;c<s;c++)u.updateEntityColors(m[c].min,m[c].max)}),b),g.attachEvent=!0),o=p.data&&p.data[0]&&p.data[0].data?u.JSONData=p.data[0].data||[]:u.JSONData=p.data||[],g.useSNameAsId=(0,h.pluckNumber)(f.usesnameasid,0),this._redefineEntities(k),r=u.components.data,g.showTooltip=(0,h.pluckNumber)(f.showtooltip,1),g.showHoverEffect=(0,h.pluckNumber)(f.showhovereffect,0),o=function(e){for(var t,o=e&&e.length||0,r={};o--;)(t=e[o]).id!==a&&(r[t.id.toLowerCase()]=t);return r}(o),u.calculateDataLimits(),!p.colorrange&&u._detachChild(u.getChildren("colorRange")&&u.getChildren("colorRange")[0]),r)n=o[i],l=r[i],n?this._configureEntity(i,l,(0,h.imprint)(t._sanitizeEntityOptions((0,h.extend2)({},n)),l.config)):this._configureEntity(i,l,l.config)}},o.updateEntityColors=function(e,t){var o,r,a,n,l,i=this.components.data,s=this.getFromEnv("chart").config.entityOpts,c=s.nullEntityAlpha,h=s.nullEntityColor,d=F({fill:h,alpha:c}),u={"fill-opacity":0};for(n in i)i.hasOwnProperty(n)&&(a=(r=(o=i[n]).config).cleanValue,l={"fill-opacity":(r.alphaArr||[])[0]/100||1},null==a?(L(o,d),o.hidden=!1):a<e||a>t?(L(o,u),o.hidden=!0):(L(o,l),o.hidden=!1))},o.legendInteractivity=function(e,t){var o,r,a,n,l,i,s=this.getFromEnv("chart"),c=this.components.data,h=e.config,d=e.hasState("hidden"),u=this.getFromEnv("colorManager"),p={},g={"fill-opacity":0};for(o in s.getFromEnv("animationManager").setAnimationState("legendInteraction"),c)c.hasOwnProperty(o)&&(a=(h=(r=c[o]).config).cleanValue,i=u.getColorObj(a),n=h.visibleEntityAttr,p["fill-opacity"]=n["fill-opacity"],l=d?p:g,t.code===(!i.outOfRange&&i.code)&&(r.hidden=!d,L(r,l),d?e&&e.removeLegendState("hidden"):e.setLegendState("hidden")))},o.calculateDataLimits=function(){var e,t,o,r,a=this.getFromEnv("chart"),n=this.config,l=a.jsonData.data||[],i=this.getFromEnv("number-formatter"),s=+Infinity,c=-Infinity;for(r=0,o=l.length;r<o;r++)t=l[r].value,e=i.getCleanValue(t),s=b(s,e),c=k(c,e);n.max=c,n.min=s},o._configureEntity=function(e,t,o){var r,n,l,i,s,c,d,u,p,g,f,m,b,k,v,C,y,w,A,E,L,x,N=this.getFromEnv("chart"),S=this.config,_=this.getFromEnv("number-formatter"),T=N.config.entityOpts,I=t.config,M=t.labelConfig,O=o.value,P=I.cleanValue=_.getCleanValue(O),B=I.formattedValue=P!==a?_.dataLabels(P):a,D=(0,h.pluckNumber)(o.showtooltip,T.showTooltip),R=this._getDefaultTooltip(t,o,this),j={formattedValue:B,sName:o.shortLabel,lName:o.label},V=T.dataLabels.style,G=I.toolText=D?(0,h.parseUnsafeString)((0,h.pluck)((0,h.parseTooltext)((0,h.pluck)(o.tooltext,T.tooltext,R),[1,2,7,38,39],j,o)),!1):"",H=I.borderColor=(0,h.pluck)(o.bordercolor,T.borderColor),W=I.borderAlpha=(0,h.pluck)(o.borderalpha,T.borderAlpha),z=I.borderThickness=(0,h.pluckNumber)(o.borderthickness,T.borderThickness),X=T.hoverOnNull,Y=I.useHoverColor=(0,h.pluckNumber)(o.showhovereffect,o.usehovercolor,X?T.showHoverEffect:isNaN(O)?0:T.showHoverEffect),K=I.labelAlignment,J=this.getFromEnv("colorManager");if(t.hidden=!1,I.showLabel=(0,h.pluckNumber)(o.showlabel,T.showLabels),I.labelPadding=(0,h.pluckNumber)(o.labelpadding,T.labelPadding),I.fontFamily=(0,h.pluck)(o.font,V.fontFamily),I.fontSize=(0,h.pluckNumber)(parseInt(o.fontsize,10),parseInt(V.fontSize,10)),I.fontBold=(0,h.pluckNumber)(o.fontbold,0),I.fontColor=(0,h.pluck)(o.labelcolor,o.fontcolor,V.color),I.labelBgColor=(0,h.pluck)(o.labelbgcolor,V.bgColor)||"",I.labelBorderColor=(0,h.pluck)(o.labelbordercolor,V.borderColor)||"",I.connectorColor=(0,h.pluck)(o.labelconnectorcolor,T.connectorColor),I.connectorAlpha=(0,h.pluck)(o.labelconnectoralpha,T.connectorAlpha),I.hoverBorderThickness=(0,h.pluckNumber)(o.borderhoverthickness,o.hoverborderthickness,T.hoverBorderThickness),I.hoverBorderColor=(0,h.pluck)(o.borderhovercolor,o.hoverbordercolor,T.hoverBorderColor,I.borderColor),I.hoverBorderAlpha=(0,h.pluck)(o.borderhoveralpha,o.hoverborderalpha,T.hoverBorderAlpha,I.borderAlpha),I.connectorThickness=(0,h.pluckNumber)(o.labelconnectorthickness,T.connectorThickness),I.origConnectorThickness=I.connectorThickness,I.borderThickness=z,I.link=o.link,I.isVisible=!0,I.id=e,I.originalId=o.origId,null!==P&&(r=J&&J.getColor(P))&&!r.outOfRange&&(C=r.code,r.oriAlpha!==a&&(y=r.oriAlpha+"")),(0,h.pluck)(o.color,o.alpha,o.angle,o.ratio)!==a?(s=(0,h.pluck)(o.color,C,T.fillColor),c=(0,h.pluck)(o.alpha,y,T.fillAlpha),d=(0,h.pluck)(o.angle,T.fillAngle),u=(0,h.pluck)(o.ratio,T.fillRatio),p=F({color:s,alpha:c,angle:d,ratio:u})):(k=F({color:(0,h.pluck)(C,T.fillColor),alpha:(0,h.pluck)(y,T.fillAlpha),angle:(0,h.pluck)(T.fillAngle),ratio:(0,h.pluck)(T.fillRatio)}),b=F({color:(0,h.pluck)(T.nullEntityColor),alpha:(0,h.pluck)(T.nullEntityAlpha),angle:(0,h.pluck)(T.nullEntityAngle),ratio:(0,h.pluck)(T.nullEntityRatio)}),s=(p=null===P?b:k).FCcolor.color,c=p.FCcolor.alpha,d=p.FCcolor.angle,u=p.FCcolor.ratio),""===G&&(S.showTooltip=0),I.visibleEntityAttr={stroke:(0,h.convertColor)(H,W),fill:(I.fillColor=p).toString(),"fill-opacity":c/100},x=c.split(","),I.alphaArr=x,Y&&((0,h.pluck)(o.fillhovercolor,o.fillhoveralpha,o.fillhoverangle,o.fillhoverratio,o.hoverfillcolor,o.hoverfillalpha,o.hoverfillratio,o.hoverfillangle)!==a?(s=(0,h.pluck)(o.fillhovercolor,o.hoverfillcolor,T.hoverFillColor),c=(0,h.pluck)(o.fillhoveralpha,o.hoverfillalpha,T.hoverFillAlpha),d=(0,h.pluck)(o.fillhoverangle,o.hoverfillangle,T.hoverFillAngle),u=(0,h.pluck)(o.fillhoverratio,o.hoverfillratio,T.hoverFillRatio),v=F({color:s,alpha:c,angle:d,ratio:u})):(T.hoverColorObject||(T.hoverColorObject=F({color:T.hoverFillColor,alpha:T.hoverFillAlpha,angle:T.hoverFillAngle,ratio:T.hoverFillRatio})),v=T.hoverColorObject),I.hoverColor=v),!M&&(M=t.labelConfig={}),g=I.fontColor,f=I.fontFamily,m=I.fontBold,G=I.toolText,n=I.link,K?(l=K[0],i=K[1]):(l="center",i="middle"),M.align=l,M.vAlign=i,M.fontColor=g,M.bgColor=I.labelBgColor,M.borderColor=I.labelBorderColor,M.fontFamily=f,M.fontBold=m,M.toolText=G,M.link=n,"object"==typeof I.options)for(w=I.entityLabels=I.entityLabels||[],L=(E=I.labels||[]).length;L--;)w[L]||(w[L]={config:{}}),M=w[L].config,(K=E[L].labelAlignment)?(l=K[0],i=K[1]):(l="center",i="middle"),M.align=l,M.vAlign=i,M.displayValue=this.getDisplayValue(t,E[L],I.options.isDataEnabled,!L,o),M.toolText=G,M.align=l,M.vAlign=i,M.bgColor=I.labelBgColor,M.borderColor=I.labelBorderColor,M.fontColor=g,M.fontFamily=f,M.fontBold=m,M.toolText=G;else A={shortText:I.shortLabel,text:I.label},M.displayValue=this.getDisplayValue(t,A,!0,!0,o)},o.getDisplayValue=function(e,t,o,r,n){var l,i=this.getFromEnv("chart").config.entityOpts,s=e.config,c=s.cleanValue,d=s.formattedValue,u=i.labelSepChar;return o?r&&"undefined"!=typeof n.displayvalue?l=n.displayvalue:(l=(0,h.pluck)(i.includeNameInLabels?i.useShortName?t.shortText:t.text:""),i.includeValueInLabels&&null!==c&&(l=l===a?d:l+u+d)):l=s.label,l},t._sanitizeEntityOptions=function(e){return delete e.outlines,delete e.label,delete e.shortlabel,delete e.labelposition,delete e.labelalignment,delete e.labelconnectors,e},o._redefineEntities=function(e){var t,o,r,a,n,l,i,s,c,d,u,p,g=this.config,f={},m={},b=this.getFromEnv("chart").config.entities,k=g.useSNameAsId,v=0;for(t=e.length;t--;)if(r=(o=e[t]).internalid,a=o.newid?o.newid:r,n=o.sname,l=o.lname,p=b[r],r=(0,h.trimString)(r),a=(a=(0,h.trimString)(a))&&a.toLowerCase(),p){for(u in f[a]=s={origId:r},m[r]=!0,p)s[u]=p[u];s.shortLabel=n||p.shortLabel,s.label=l||p.label,s.showhovereffect=o.showhovereffect,s.fillhovercolor=o.fillhovercolor,s.fillhoveralpha=o.fillhoveralpha,s.fillhoverangle=o.fillhoverangle,s.fillhoverratio=o.fillhoverratio,s.borderhoverthickness=o.borderhoverthickness}for(i in(d=this.components.data)||(d=this.components.data={}),f)d[i=i.toLowerCase()]||(d[i]={config:{}}),d[i].config=f[i],v+=1;for(i in c=d,b)if(s=b[i],!m[i=(0,h.trimString)(i)]){for(u in k?((p=c[s.shortLabel.toLowerCase()])||(p=c[s.shortLabel.toLowerCase()]={}),p.config={},p.origId=s.shortLabel):((p=c[i.toLowerCase()])||(p=c[i.toLowerCase()]={}),p.config={},p.config.origId=i),s)p.config[u]=s[u];v+=1}g.entityCount=v},o.draw=function(){var e=this.config,t=this.getFromEnv("chart"),o=h.hasSVG?200:10;this.createContainer(),this.config.ready=!1,e.BATCH_SIZE=o,e.labelBatchSize=h.hasSVG?200:20,this._batchRender()(0),t.config.entityFlag=!0,t.checkComplete()},o._batchRender=function(){var e,t,o,r,n,l=this,i=l.config,s=l.getFromEnv("chart").config.entities.firstEntity,c=l.components.data,h=i.BATCH_SIZE,u=i.entityKeys=s?l._getKeys(s,c):Object.keys(c),p=i.entityLength=u.length;return function g(i){for(e=i,o=0;u[e]!==a;)if(t=c[u[e]],n=l.drawEntity(t,h),o+=n,t.config.drawn&&((r=e===p-1?t:c[u[e-1]])&&(r.config.drawn=!1,r.config.outlineStartIndex=a),e++),o>=h){l.addJob("entityDraw",g.bind(l,e),d.priorityList.entitydraw);break}e===p&&(l._addEventListenersToEntities(0),l.initComplete())}},o._addEventListenersToEntities=function(e){var t,o,r,a=this.components.data,n=this.config,l=n.BATCH_SIZE,i=n.entityKeys,s=n.entityLength,c=0;for(t=e;t<s;t++)if((r=(o=a[i[t]]).config.options)&&!1===r.isDataEnabled||this.addMouseGestures(o),++c===l){this.addJob("_addEventListenersToEntities",this._addEventListenersToEntities.bind(this,t),d.priorityList.entitydraw);break}},t._getKeys=function(e,t){for(var o=[e],r=e;t[r];)r=t[r].nextId,o.push(r);return o},o._getDefaultTooltip=function(e,t){var o,r,n=e.config.cleanValue,l=e.config.formattedValue,i=this.getFromEnv("chart").config.entityOpts;if("object"==typeof e.config.options){if(!(r=t.labels&&t.labels[0]))return a;o=(i.useSNameInTooltip?r.shortText:r.text)+(null===n?"":i.tooltipSepChar+l)}else o=(i.useSNameInTooltip?t.shortLabel:t.label)+(null===n?"":i.tooltipSepChar+l);return o},o.drawEntity=function(e,t){var o,r,n,l,i,s,c,d,u=this.getFromEnv("chart"),p=u.getFromEnv("animationManager"),g=e.config,m=h.hasSVG||!f?"litepath":"path",b=u.config.entityOpts,k=g.outlines,v=this.getFromEnv("toolTipController"),C=this.getLinkedParent().getChildContainer("plot"),y=this.getLinkedParent().getChildContainer("plotShadow"),F=g.toolText,A=b.shadow,E=[],L={};if(this._configureEntityDrawingParams(e),r=(g=e.config).visibleEntityAttr,d=g.shadowOptions,o=g.outlineStartIndex===a?k.length:g.outlineStartIndex,e.graphics||(e.graphics={}),s=0,E=g.outlinePath||(g.outlinePath=[]),c=g.customStrokeWidthModifier,"object"==typeof g.options){for(;o--;)if(E=k[o].outline,n=!0===g.options.isDataEnabled?r:(0,h.extend2)((0,h.extend2)({},r),w(k[o].style,c)),(l=e.graphics.outlines)||(l=e.graphics.outlines=[]),!l[o]&&(l[o]={}),i=l[o].outline,n[m]=E,(i=l[o].outline=p.setAnimation({el:m,container:C,attr:n,component:this,label:"path"})).shadow(!!A&&d,y),v.enableToolTip(i,F),s++,g.outlineStartIndex=o,s===t)return s;return g.drawn=!0,s}for(;o--;)if(E=k[o].concat(E),s++,g.outlineStartIndex=o,s===t)return g.outlinePath=E,s;return!e.graphics.outlines&&(r[m]=E),Object.assign(L,r,e.hidden&&{"fill-opacity":0}||{}),e.graphics.outlines=p.setAnimation({el:e.graphics.outlines||m,container:C,attr:L,component:this,label:"path"}),g.drawn=!0,g.outlineStartIndex=0,g.outlinePath=[],e.graphics.outlines.shadow(!!A&&d,y),v.enableToolTip(e.graphics.outlines,F),s},o._configureEntityDrawingParams=function(e){var t,o=this.getFromEnv("chart"),r=e.config,a=o.config.entityOpts,n=o.config.scalingParams,l=!f||h.hasSVG,i=n.scaleFactor,s=n.strokeWidth,c=(l?o.baseScaleFactor:1)*s,d=1===a.scaleBorder,u=r.borderThickness,p=r.alphaArr,g=r.origConnectorThickness,b=r.hoverBorderThickness,v=r.visibleEntityAttr,C=v["fill-opacity"];r.shadowOptions={scalefactor:[i,i*o.config.baseScaleFactor],opacity:k.apply(m,p)/100,useFilter:0},r.fillOpacity=e.hidden?0:C,l?(u=r.entityBorderThickness=d?u*c:u/i,g/=i,t=d?i:n.sFactor,b&&(b=r.hoverBorderThickness=d?b*c:b/i)):(u=d?u*s:u,t=d?n.scaleFactor:o.baseScaleFactor),r.entityBorderThickness=u,r.connectorThickness=g,r.customStrokeWidthModifier=t,v["stroke-width"]=u,v.transform=h.hasSVG||!f?"":n.transformStr},o.drawLabels=function(e){var t,o,r,a,n=e,l=this.getFromEnv("chart"),s=this.config,c=s.labelBatchSize,h=s.entityLength,d=[],u=l.getChildContainer("upperAnnotationGroup"),p=0,g=this.getChildren("mapLabelAnnotations")&&this.getChildren("mapLabelAnnotations")[p],f=0,m=0,b=l.config.annotationConfig;for(t in g||(a=new i["default"],this.attachChild(a,"mapLabelAnnotations"),(g=this.getChildren("mapLabelAnnotations")[p]).addCustomGroup(u)),g.destroy(),g._renderer&&(g._renderer=null),b.showbelow=0,n){if(this.drawLabel(n[t],d),++f===c){for(o=0;o<d.length;o++)d[o].animationLabel="entityLabel";for(r=g.addGroup(Object.assign(b,{id:"entityLabels"+p,items:d,animationLabel:"entityLabelGroup"}),this),o=0;o<r.items.length;o++)r.items[o].addEventListener("fc-mouseover",d[o].onmouseover),r.items[o].addEventListener("fc-mouseout",d[o].onmouseout),r.items[o].addEventListener("fc-click",d[o].onclick);p++,(g=this.getChildren("mapLabelAnnotations")&&this.getChildren("mapLabelAnnotations")[p])||(a=new i["default"],this.attachChild(a,"mapLabelAnnotations"),(g=this.getChildren("mapLabelAnnotations")[p]).addCustomGroup(u)),g.destroy(),g._renderer&&(g._renderer=null),f=0,d=[]}else if(m===h-1){for(o=0;o<d.length;o++)d[o].animationLabel="entityLabel";for(r=g.addGroup(Object.assign(b,{id:"entityLabels"+p,items:d,animationLabel:"entityLabelGroup"}),this),o=0;o<r.items.length;o++)r.items[o].addEventListener("fc-mouseover",d[o].onmouseover),r.items[o].addEventListener("fc-mouseout",d[o].onmouseout),r.items[o].addEventListener("fc-click",d[o].onclick)}m++}this.drawLabelConnFn(0)},o.drawLabelConnFn=function(e){var t,o,r,a,n,l=this.config,i=this.components.data,s=l.BATCH_SIZE,c=l.entityKeys,h=c.length,u=0;for(o=e;o<h;o++){if("object"==typeof(a=(n=i[c[o]]).config).options)for(t=(r=a.labels)&&r.length||0;t--;)r[t].labelConnectors&&(this.drawLabelConnectors(n,r[t].labelConnectors,this),u++);else a.labelConnectors&&(this.drawLabelConnectors(n,a.labelConnectors,this),u++);if(u===s){this.addJob("drawLabelConnectors",this.drawLabelConnFn.bind(this,o),d.priorityList.entitydraw);break}}},o._getLabelObject=function(e,t,o){var r,n,l,i,s,c,d,u,p,g,f,m=this,b=m.getFromEnv("chart"),k=m.getFromEnv("chart-attrib"),v=e.config,C=b.config.scalingParams,y=e.graphics&&e.graphics.outlines,F=v.fontSize,w=v.labelPadding,L=v.labels||[],x=v.entityLabels||[];return t!==a?(f=L[t],i=(r=x[t].config).style=f.style,n=f.labelPosition,l=f.labelAlignment):(r=e.labelConfig,n=v.labelPosition,l=v.labelAlignment),n?(s=n[0],c=n[1]):(s=(d=y.getBBox()).x+d.width/2,c=d.y+d.height/2),l?("right"===(u=l[0])?s-=w:"left"===u&&(s+=w),"top"===(p=l[1])?c-=w:"bottom"===p&&(c+=w)):(u="center",p="middle"),g=parseFloat(F)/C.sFactor,!o&&i&&(i.color&&(r.fontColor=i.color),i["font-size"]&&(g=parseFloat(i["font-size"])/C.sFactor),i["font-family"]&&(r.fontFamily=i["font-family"]),i["font-weight"]!==a&&(r.fontBold="bold"===i["font-weight"])),r.x=s.toString(),r.y=c.toString(),r.wrap=1,r.type="text",r.fontSize=g,{x:s.toString(),y:c.toString(),wrapwidth:A[u](void 0,s+void 0)-w,wrapheight:E[p](void 0,c+void 0)-w,wrap:1,type:"text",align:r.align,valign:r.vAlign,text:r.displayValue,tooltext:r.toolText,outlineText:(0,h.pluckNumber)(k.textoutline,0),css:r.link!==a&&{cursor:"pointer",_cursor:"hand"},bgcolor:r.bgColor,bordercolor:r.borderColor,fillcolor:r.fontColor,fontsize:r.fontSize,font:r.fontFamily,bold:r.fontBold,onclick:function(t){var o,r,a=e.graphics.outlines;if(a instanceof Array)for(o=0,r=a.length;o<r;o++)m.entityClick(a[o].outline,t);else m.entityClick(a,t)},onmouseover:function(t){var o,r,a=e.graphics.outlines;if(a instanceof Array)for(o=0,r=a.length;o<r;o++)m.entityRollOver(a[o].outline,t);else m.entityRollOver(a,t)},onmouseout:function(t){var o,r,a=e.graphics.outlines;if(a instanceof Array)for(o=0,r=a.length;o<r;o++)m.entityRollOut(a[o].outline,t);else m.entityRollOut(a,t)},ontouchstart:function(t){var o,r,a=e.graphics.outlines;if(a instanceof Array)for(o=0,r=a.length;o<r;o++)m.entityRollOver(a[o].outline,t);else m.entityRollOver(a,t);m.entityRollOver(a,t)}}},o.drawLabel=function(e,t){var o,r,n,l=e.config;if(l.showLabel)if("object"==typeof l.options)for(r=(n=l.labels)&&n.length||0,o=l.options.isDataEnabled;r--;)t.push(this._getLabelObject(e,r,o,!r));else t.push(this._getLabelObject(e,a,!0,!0))},o.drawLabelConnectors=function(e,t,o){for(var r,a,n=e.config,l=this.getFromEnv("chart"),i=l.getFromEnv("animationManager"),s=l.config.scalingParams,c=o.getLinkedParent().getChildContainer("plot"),d=t&&t.length||0,u=n.showLabel;d--;)a=t[d],r=e.graphics.connectorElem,u?e.graphics.connectorElem=r=i.setAnimation({el:e.graphics.connectorElem||"path",attr:{path:a,opacity:1,transform:h.hasSVG||!f?"":s.transformStr,stroke:(0,h.convertColor)(n.connectorColor,n.connectorAlpha),"shape-rendering":"crisp","stroke-width":n.connectorThickness},container:c,component:this,label:"labelConnectors"}):r&&r.hide()},o.entityClick=function(e,t){var o=e.node.__entity,r=this.getFromEnv("chart"),n=r.config.scalingParams,l=e.getBBox(),i=r.getFromEnv("linkClickFN"),s=o.config,c=s.link;l.width=l.width*n.scaleFactor,l.height=l.height*n.scaleFactor,l.x=l.x*n.scaleFactor+n.translateX,l.y=l.y*n.scaleFactor+n.translateY,l.x2=l.x+l.width,l.y2=l.y+l.height,r.fireChartInstanceEvent("entityclick",s.eventArgs,t),c!==a&&i.call({link:c,entity:o,entityBox:l},!0)},o.entityRollOver=function(e,t){var o=e.node.__entity,r=o.config,a=this.getFromEnv("chart"),n=a.getFromEnv("animationManager"),l=r.hoverAttr;a.plotEventHandler(e,t,"entityRollOver"),e.data("hovered")?clearTimeout(o.config.timer):r.useHoverColor&&r.isVisible&&!o.hidden&&l&&(a.config.hoverEntity=e,n.setAnimation({el:e,attr:l,component:this,state:"updating",label:"path"}),e.data("hovered",!0))},o.entityRollOut=function(e,t){var o=e.node.__entity,r=this,a=r.getFromEnv("chart"),n=a.getFromEnv("animationManager"),l=o.config.revertAttr;a.plotEventHandler(e,t,"entityRollOut"),o.config.timer=setTimeout((function(){!0!==o.hidden&&l&&(n.setAnimation({el:e,attr:l,component:r,state:"updating",label:"path"}),e.data("hovered",!1))}),100)},o.addMouseGestures=function(e){var t,o,r,n,l=e.config,i=l.originalId,s=this,c=e.graphics,d=l.useHoverColor,u=l.hoverBorderThickness,p=l.hoverBorderColor,g=l.hoverBorderAlpha,f=l.entityBorderThickness,m=l.borderColor,b=l.borderAlpha,k=l.link,v=l.visibleEntityAttr,C="groupId"+i,y=function(t){k!==a&&t.css({cursor:"pointer",_cursor:"hand"}),t.data("eventArgs",l.eventArgs),t.data("groupId",C),t.node.__entity=e,e._listenersBinded||t.on("fc-click",s.entityClick.bind(s,t)).hover(s.entityRollOver.bind(s,t),s.entityRollOut.bind(s,t))};for(t in l.eventArgs={value:l.cleanValue,label:l.label,shortLabel:l.shortLabel,originalId:l.origId,id:l.id||l.origId},l.legacyEventArgs={value:l.value,lName:l.label,sName:l.shortLabel,id:l.originalId||l.id},d&&(l.hoverAttr={fill:(0,h.toRaphaelColor)(l.hoverColor)},l.revertAttr={fill:(0,h.toRaphaelColor)(l.fillColor),stroke:(0,h.toRaphaelColor)(l.borderColor,l.borderAlpha)},l.revertAttr["fill-opacity"]=v["fill-opacity"],u!==f&&(l.hoverAttr["stroke-width"]=(0,h.pluckNumber)(u,f),l.revertAttr["stroke-width"]=f),p===m&&g===b||(l.hoverAttr.stroke=(0,h.convertColor)(p,g),l.revertAttr.stroke=(0,h.convertColor)(m,b))),c)if(c.hasOwnProperty(t))if(c[t]instanceof Array){for(o=0,r=(n=c[t]).length;o<r;o++)y(n[o].outline);e._listenersBinded=!0}else y(c[t]),e._listenersBinded=!0},o.getDataLimits=function(){var e=this.config;return{max:e.max,min:e.min}},o.createContainer=function(){var e=this.getLinkedParent(),t=this.getFromEnv("animationManager"),o=e.getChildContainer("layer0");!this.getChildContainer("abovePlotGroup")&&this.addChildContainer("abovePlotGroup",t.setAnimation({el:"group",attr:{name:"abovePlotGroup",opacity:1},container:o,component:this,label:"group"})),!this.getChildContainer("belowPlotGroup")&&this.addChildContainer("belowPlotGroup",t.setAnimation({el:"group",attr:{name:"belowPlotGroup",opacity:1},container:o,component:this,label:"group"}))},o.initComplete=function(){var e=this.getFromEnv("chart"),t=this.components.data;this.drawLabels(t),e.config.entitiesReady=!0,e.checkComplete()},t}(l.ComponentInterface);t["default"]=x},1261:function(e,t,o){"use strict";t.__esModule=!0,t["default"]=void 0;var r=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],a=function(){return r[0].slot="plot",r},n=function(e){return[{finalAttr:function(){return e.finalAttr}}]},l=function(){return r[0].slot="final",r},i=function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},s=function(){return r[0].slot="final",r},c=function(e){return[{finalAttr:function(){return e.finalAttr}}]},h=function(e){return[{initialAttr:function(){return Object.assign({opacity:0},e.attr)},finalAttr:function(){return e.attr},slot:"plot"}]},d=function(e){return[{initialAttr:function(){return Object.assign({opacity:0},e.attr)},finalAttr:function(){return e.attr},slot:"plot"}]},u={"initial.dataset.entities":function(){return{"path.appearing":a,"path.updating":n,"labelConnectors.appearing":l,"labelConnectors.updating":null,"entityLabel.appearing":i,"*":null}},"initial.dataset.markers":function(){return{markers:null,"markerItem.appearing":s,"markerItem.updating":c}},"initial.group.mapGroup":function(){return{"group.appearing":h,"group.updating":d,"*":null}}};t["default"]=u},1262:function(e,t,o){"use strict";var r=o(219);t.__esModule=!0,t["default"]=void 0;var a,n=r(o(238)),l=r(o(1260)),i=r(o(663)),s=r(o(329)),c=o(232),h=r(o(1261)),d=o(224),u=o(231),p=o(236),g=window.Math,f=g.min,m=g.max,b=function(e){var t,o=this.getFromEnv("chart"),r=this.getChildren("mapAnnotations")[0],n=e.markerShape,l=n.groupConfig,i=n.data("unfilteredConfig"),s=i._markerEventArgs,c=e.config;i.hovereffect&&("circle"===n.config.type&&(t=(0,d.extend2)({fillcolor:i.hoverfillcolor,fillalpha:i.hoverfillalpha,fillangle:i.hoverfillangle,fillratio:i.hoverfillratio,gradientUnits:"objectBoundingBox",radialGradient:1},i._hoverattrs)),t=(0,d.extend2)({},i._hoverattrs),r.update(n.getId(),t)),s||(s=i._markerEventArgs={x:+i.x,y:+i.y,scaledX:i.x*l.scaleX,scaledY:i.y*l.scaleY,chartX:i.x*l.scaleX+l.grpXShift,chartY:i.y*l.scaleY+l.grpYShift,id:i.id,label:i.label}),(0,u.raiseEventGroup)(c.options.id,"markerRollOver",s,o.getFromEnv("chartInstance"),c,a,a,a)},k=function(e){var t,o=this.getFromEnv("chart"),r=this.getChildren("mapAnnotations")[0],n=e.markerShape,l=n.getElement(),i=e.config,s=n.data("unfilteredConfig");l&&s.hovereffect&&("circle"===n.config.type&&(t=(0,d.extend2)({fillcolor:n.config.rawColor,fillalpha:n.config.rawAlpha,fillangle:n.config.rawAngle,fillratio:n.config.rawRatio,gradientUnits:"objectBoundingBox",radialGradient:"radial"===n.config.rawFillPattern},s._defaultattrs)),t=(0,d.extend2)({},s._defaultattrs),r.update(n.getId(),t)),(0,u.raiseEventGroup)(i.id,"markerRollOut",s._markerEventArgs,o.getFromEnv("chartInstance"),a,a,a)},v=function(e,t){var o=t.config.options,r=this.getFromEnv("chart"),a=t.markerShape,n=a.config,l=a.groupConfig,i=this.getFromEnv("linkClickFN"),s=a.config.link,c=n._markerEventArgs;s&&i&&i.call({link:s},!0),c||(c=n._markerEventArgs={x:+n.x,y:+n.y,scaledX:n.x*l.scaleX,scaledY:n.y*l.scaleY,chartX:n.x*l.scaleX+l.grpXShift,chartY:n.y*l.scaleY+l.grpYShift,id:o.id,label:o.label}),r.fireChartInstanceEvent("markerClick",c,e)},C=function(e,t){var o,r=e&&e.length||!1,n=t||"id",l={};if(!e)return e;for(;r--;)(o=e[r])[n]!==a&&(l[o[n].toLowerCase()]=o);return l},y=function(e,t,o){return{x:e.toString(),y:(t-o).toString(),align:"center",valign:"top"}},F=function(e,t,o){return{x:(e-o).toString(),y:t.toString(),align:"right",valign:"middle"}},w=function(e,t,o){return{x:(e+o).toString(),y:t.toString(),align:"left",valign:"middle"}},A=function(e,t,o){return{x:e.toString(),y:(t+o).toString(),align:"center",valign:"bottom"}},E=function(e,t){return{x:e.toString(),y:t.toString(),align:"center",valign:"middle"}},L=function(){return arguments[1]},x=function(e,t){return e-t},N=function(e,t){return 2*f(t,e-t)},S=function(){return arguments[1]},_=function(e,t){return 2*f(t,e-t)},T=function(e,t){return e-t};(0,c.addDep)({name:"mapsAnimation",type:"animationRule",extension:h["default"]});var I=function(e){function t(){var t;return(t=e.call(this)||this).components={},t.getLabelAlignment={top:y,left:F,right:w,bottom:A,center:E},t.getWrapWidth={right:L,left:x,center:N},t.getWrapHeight={top:S,middle:_,bottom:T},t.hoverFn=b,t.hoverOutFn=k,t.clickFn=v,t}(0,n["default"])(t,e);var o=t.prototype;return o.getName=function(){return"markers"},o.getType=function(){return"dataset"},o.configureAttributes=function(e){if(e){this.JSONData=e;var t,o=this.getChildren("mapAnnotations")&&this.getChildren("mapAnnotations")[0],r=this.getFromEnv("chart").config.markerOpts;o||(t=new s["default"],this.attachChild(t,"mapAnnotations"),o=this.getChildren("mapAnnotations")[0]),o.destroy(),this.calculateDataLimits(),r.dataEnabled?this._parseMarkers():this.defineMarkersNShapes(),this.configureConnectors()}},o.calculateMarkerRadiusLimits=function(){if(this.JSONData){var e=this.JSONData,o=this.config,r=this.getFromEnv("chart"),a=r.config.width,n=r.config.height,l=e.markermaxradius,i=e.markerminradius,s=t.getMarkerRadiusLimits(a,n,l,i);o.minRadius=s.min,o.maxRadius=s.max}},o.calculateDataLimits=function(){var e,t,o,r,a=this.getFromEnv("chart"),n=this.config,l=(a.jsonData.markers||{}).items||[],i=this.getFromEnv("number-formatter"),s=+Infinity,c=-Infinity;for(r=0,t=l.length;r<t;r++)o=l[r].value,null!==(e=i.getCleanValue(o))&&(s=f(e,s),c=m(e,c));n.min=s,n.max=c},o._parseMarkers=function(){var e,o,r,n,l,i,s,c,h=this.getFromEnv("chart"),u=h.jsonData.markers,p=u.items,g=u.shapes,f=h.config.markerOpts,m=f.dataLabels.style,b=this.getFromEnv("number-formatter"),k=this.components.shapeObjs={},v=this.components.markerObjs={};if(p&&p.length){if(g&&g.length)for(o=g.length;o;o-=1)(c=(n=g[o-1]).id.toLowerCase())&&(k[c]=n);for(o=p.length;o--;)(c=(n=p[o]).id&&n.id.toLowerCase())&&((e=n.value)!==a&&""!==e&&(e=parseFloat(e)),(l=(r=t._initializeMarkerItem(c,n,null,h)).config.options.shapeid)&&"string"==typeof l&&(l=l.toLowerCase()),s=(i=r.config).options,i.cleanValue=b.getCleanValue(e),null!==i.cleanValue?i.formattedValue=b.dataLabels(e):i.formattedValue=a,i.fillColor=(0,d.pluck)(s.fillcolor,s.color,f.fillColor),i.fillAlpha=(0,d.pluck)(s.fillalpha,s.alpha,f.fillAlpha),i.fillRatio=(0,d.pluck)(s.fillratio,f.fillRatio),i.fillAngle=(0,d.pluck)(s.fillangle,f.fillAngle),i.borderThickness=(0,d.pluckNumber)(s.borderthickness,f.borderThickness),i.borderColor=(0,d.pluck)(s.bordercolor,f.borderColor),i.borderAlpha=(0,d.pluck)(s.borderalpha,f.borderAlpha),i.labelPadding=s.labelpadding||f.labelPadding,i.fontColor=(0,d.pluck)(s.labelcolor,m.fontColor),i.labelBgColor=(0,d.pluck)(s.labelbgcolor,m.labelBgColor)||"",i.labelBorderColor=(0,d.pluck)(s.labelbordercolor,m.labelBorderColor)||"",n.__hideMarker&&(r._isHidden=!0),l&&(r.shapeObj=k[l]),v[c]=r)}},o.defineMarkersNShapes=function(){var e,o,r,n,l,i,s,c,h=this.getFromEnv("chart"),u=h.jsonData.markers,p=u.definition,g=this.getFromEnv("number-formatter"),f=h.config.markerOpts,m=f.dataLabels.style,b=C(p)||{},k=C(u.application)||{},v=u.shapes,y=this.components.shapeObjs=this.components.shapeObjs||(this.components.shapeObjs={}),F=this.components.markerObjs=this.components.markerObjs||(this.components.markerObjs={}),w={},A={};if(p&&p.length){for(n in y)w[n]=!1;for(n in F)A[n]=!1;if(v&&v.length)for(n=v.length;n;n-=1)(c=(i=v[n-1]).id.toLowerCase())&&(y[c]=i,w[c]=!0);for(c in b)i=b[c],l=F[c]=t._initializeMarkerItem(c,i,k[c],h),A[c]=!0,s=l.config.options.shapeid,o=l.config,r=i.value,o.cleanValue=g.getCleanValue(r),e=o.options,null!==o.cleanValue?o.formattedValue=g.dataLabels(r):o.formattedValue=a,o.fillColor=(0,d.pluck)(e.fillcolor,e.color,f.fillColor),o.fontColor=(0,d.pluck)(e.labelcolor,m.fontColor),o.fillAlpha=(0,d.pluck)(e.fillalpha,e.alpha,f.fillAlpha),o.fillRatio=(0,d.pluck)(e.fillratio,f.fillRatio),o.fillAngle=(0,d.pluck)(e.fillangle,f.fillAngle),o.borderThickness=(0,d.pluckNumber)(e.borderthickness,f.borderThickness),o.borderColor=(0,d.pluck)(e.bordercolor,f.borderColor),o.borderAlpha=(0,d.pluck)(e.borderalpha,f.borderAlpha),o.labelPadding=e.labelpadding||f.labelPadding,o.options.tooltext=(0,d.pluck)(e.tooltext,f.tooltext),o.link=e.link,s&&(l.shapeObj=y[s.toLowerCase()]);for(n in w)w[n]||delete y[n];for(n in F)A[n]||delete F[n]}},t.getMarkerRadiusLimits=function(e,t,o,r){var a,n,l=f(e,t),i=.02*l,s=.07*l;return a=parseFloat(r),n=parseFloat(o),isNaN(a)||isNaN(n)?isNaN(a)?isNaN(n)?{min:i,max:s}:{min:parseInt(n/10,10),max:n}:{min:a,max:10*a}:a<n?{min:a,max:n}:{min:n,max:a}},o.getDataLimits=function(){var e=this.config;return{min:e.min,max:e.max}},t._initializeMarkerItem=function(e,t,o){var r,a={},n=a.config;return n||(n=a.config={}),n.id=e,n.definition=t,n.application=o,n.hasValue=null,n.value=null,n.options=null,n.label=null,n.markerShape=null,n.markerLabel=null,n.drawOptions={shape:null,label:null},n.drawComplete=!1,r=a.config.options=(0,d.extend2)({},n.definition),n.dataEnabled?isNaN(r.value)||""===r.value||(a.value=parseFloat(r.value),a.hasValue=!0):(n.applyAll||o)&&(n.options=(0,d.extend2)(r,n.application)),a},o.configureConnectors=function(){var e,t,o,r,a,n,l,i,s,c,h,u,p,g,f=this.getFromEnv("chart"),m=this.getChildren("mapAnnotations")[0],b=f.jsonData,k=this.components,v=b.markers||{},C=v.connector||v.connectors||[],y=k.markerObjs,F=C.length,w=this.components.connectors,A=function(e){return function(t){var o=this.data("unfilteredConfig");o.hoverEffect&&m.update(this.getId(),o._hoverAttrs),f.fireChartInstanceEvent("connectorrollover",e,t)}},E=function(e){return function(t){var o=this.data("unfilteredConfig");o.hoverEffect&&m.update(this.getId(),o._defaultAttrs),f.fireChartInstanceEvent("connectorrollout",e,t)}},L=function(e){return function(t){f.fireChartInstanceEvent("connectorClick",e,t)}},x=f.config.connectorOpts,N={};for(w=this.components.connectors=[],g=0;g<F;g++)((p=C[g]).from||p.to)&&(t=y[p.from.toLowerCase()],o=y[p.to.toLowerCase()],t&&o&&(r=C[g].label,!(N=w[g])&&(N=w[g]={}),!N.config&&(e=N.config={}),!N.graphics&&(N.graphics={}),(e=N.config=(0,d.extend2)({},p)).fromMarker=t,e.toMarker=o,e.link=p.link,e.showTooltip=(0,d.pluckNumber)(p.showtooltip,x.showTooltip),a=e.tooltext=e.showTooltip?(0,d.pluck)(p.tooltext,x.tooltext):"",n=e.thickness=(0,d.pluck)(p.thickness,x.thickness),l=e.color=(0,d.pluck)(p.color,x.color),i=e.alpha=(0,d.pluck)(p.alpha,x.alpha),e.hoverEffect=(0,d.pluckNumber)(p.showhovereffect,x.showHoverEffect),s=(0,d.pluck)(p.hovercolor,x.hoverColor,l),c=(0,d.pluck)(p.hoveralpha,x.hoverAlpha,i),h=(0,d.pluck)(p.hoverthickness,x.hoverThickness,n),e.dashed=(0,d.pluck)(p.dashed,x.dashed),e.dashLen=(0,d.pluckNumber)(p.dashlen,x.dashlen),e.dashGap=(0,d.pluckNumber)(p.dashgap,x.dashgap),a&&(e.tooltext=a=(0,d.parseUnsafeString)((0,d.parseTooltext)(a,[3,40,41,42,43],{label:r,fromId:t.config.definition.id,toId:o.config.definition.id,fromLabel:t.config.definition.label,toLabel:o.config.definition.label},void 0),!1)),e.eventArgs={fromMarkerId:t.config.id,toMarkerId:o.config.id,label:r},e._hoverAttrs={color:s,alpha:c,thickness:h},e._defaultAttrs={color:l,alpha:i,thickness:n},e.type="line",e.onclick=L(e.eventArgs),e.onmouseover=A(e.eventArgs),e.onmouseout=E(e.eventArgs),r&&(!(u=N.labelConfig)&&(u=N.labelConfig={}),u.type="text",u.text=r,u.align="center",u.valign="middle",u.font=x.font,u.fillcolor=(0,d.pluck)(p.labelcolor,x.fontColor),u.bgcolor=(0,d.pluck)(p.labelbgcolor,x.labelBgColor),u.bordercolor=(0,d.pluck)(p.labelbordercolor,x.labelBorderColor),u.tooltext=e.tooltext)))},o.draw=function(){var e,t,o,r,a,n,l,i,s=this.getFromEnv("chart"),c=this.config,h=this.getChildren("mapAnnotations")[0],d=this.components.markerObjs,u=s.config,g=u.markerOpts,f=u.scalingParams,m=s.config.annotationConfig,b=[],k=[],v={},C={};for(a in h.destroy(),this.createContainer(),this._drawConnectors(),this.imageLoadCount=0,this.imageCount=0,c.autoScale=g.autoScale?f.sFactor:1,d)e=null,(r=(t=d[a]).config).conIsHidden||(e=this._drawMarkerItem(t)),e&&(C[a]=e,r._annotationIndex=b.length,v[a]=t,e.markerShape&&(o=Object.assign({align:"center",valign:"middle",animationLabel:"markerItem",autoscale:"image"===e.markerShape.type?0:1},e.markerShape),b.push(o)),e.markerLabel&&(o=Object.assign({animationLabel:"markerItem",id:e.markerShape.id},e.markerLabel),k.push(o)));for(a in i=h.addGroup(Object.assign(m,{id:"markers",fillalpha:"100",items:b,scaleimages:1}),this),l=h.addGroup(Object.assign(m,{id:"markerLabels",items:k,scaleimages:1}),this),this.components.markerGroup=i,this.components.markerLabelGroup=l,n=0,d)C[a]&&((t=d[a]).markerShape=i.retrieveItem(b[n].id),t.markerShape.data("unfilteredConfig",b[n]),C[a].markerLabel&&(t.markerLabel=l.retrieveItem(b[n].id),t.markerLabel.data("unfilteredConfig",k[n])),n++);this.addJob("buildKdtree",this._buildKdTree.bind(this),p.priorityList.kdTree)},o._buildKdTree=function(){var e,t,o=this.components.kdArrayMap,r=this.components.markerGroup,a=[],n=r&&r.items,l=n&&n.length||0;for(t=0;t<l;t++)o[e=n[t].config.id]&&a.push(o[e]);this.components.kDTree||(this.components.kDTree=new i["default"](!0)),this.components.kDTree._setSearchLimit(Infinity,Infinity),this.components.kDTree.buildKdTree(a)},o._drawMarkerItem=function(e){var t,o,r,n,l,i,s,c,h,u,p,g,f,m,b,k,v,C,y=this,F=y.getFromEnv("chart"),w=F.config,A=y.config,E=w.scalingParams,L=e.config,x=L.options,N=L.definition,S=w.markerOpts,_=S.dataLabels.style,T=x.shapeid,I=x.scale||1,M=x.label||"",O=F.config.scalingParams.scaleFactor*F.config.baseScaleFactor,P=(x.labelpos||"top").toLowerCase(),B=L.formattedValue===a?a:L.formattedValue,D=x.tooltext||S.tooltext,R=(0,d.pluckNumber)(N.radius,L.radius,S.radius)*I*A.autoScale||1e-4,j=L.fillColor,V=L.fillAlpha,G=L.fillRatio,H=L.fillAngle,W=L.borderThickness,z=L.borderColor,X=L.borderAlpha,Y=y.getChildren("mapAnnotations")[0],K=y.components.kdArrayMap||(y.components.kdArrayMap={}),J=e.config.id;if(L.autoScale=S.autoScale?O:1,T)return D=D?(0,d.parseUnsafeString)((0,d.parseTooltext)(D,[1,2,3],{formattedValue:B,label:M},x),!1):B?M+S.tooltipSepChar+B:M,B!==a&&null!==B?M=M+S.labelSepChar+B:isNaN(I)?I=1:I<0?I=0:I>5&&(I=5),(0,d.extend2)(x,{x:x.x&&x.x.toString(),y:x.y&&x.y.toString(),fillcolor:j,fillalpha:V,fillratio:G,fillangle:H,borderthickness:W,bordercolor:z,borderalpha:X,hovereffect:(0,d.pluck)(S.showHoverEffect),radius:R&&R.toString(),link:x.link,showshadow:(0,d.pluckNumber)(x.showshadow,L.shadow),_markerLabel:M,_markerId:x.id,id:(x.id+"").toLowerCase()}),delete x.tooltext,L.tooltext=!!S.showTooltip&&D,f=Number(x.x)*E.sFactor+E.translateX,m=Number(x.y)*E.sFactor+E.translateY,R=x.radius,"triangle"===T?((0,d.extend2)(x,{type:"polygon",sides:3,startangle:S.startAngle}),C="polygon",v=3):"diamond"===T?((0,d.extend2)(x,{type:"polygon",sides:4,startangle:S.startAngle}),C="polygon",v=4):"arc"===T?(k=.6*R,(0,d.extend2)(x,{type:"arc",startangle:0,endangle:360,innerradius:k}),C="arc"):"circle"===T?(x.type="circle",C="circle"):(p=y.getShapeArgs.call(e),S.dataEnabled&&S.valueToRadius&&x.radius!==a?delete p.radius:(!p.radius&&(p.radius=S.radius),p.radius*=I*L.autoScale),(0,d.extend2)(x,p),x.id=x._markerId&&x._markerId.toLowerCase(),k=p.innerradius,p.radius&&(R=p.radius),C=p.type&&p.type.toLowerCase(),v=p.sides,(R=Number(R))&&k&&R<k&&(g=R,x.radius=R=k,x.innerradius=k=g)),x.type=x.type&&x.type.toLowerCase(),(0,d.extend2)(x,{hoverfillcolor:(0,d.pluck)(x.fillhovercolor,S.hoverFillColor,x.fillcolor),hoverfillalpha:(0,d.pluck)(x.fillhoveralpha,S.hoverFillAlpha,x.fillalpha),hoverfillratio:(0,d.pluck)(x.fillhoverratio,S.hoverFillRatio,x.fillratio),hoverfillangle:(0,d.pluck)(x.fillhoverangle,S.hoverFillAngle,x.fillangle),hoverborderthickness:(0,d.pluckNumber)(x.borderhoverthickness,S.hoverBorderThickness,x.borderthickness),hoverbordercolor:(0,d.pluck)(x.borderhovercolor,S.hoverBorderColor,x.bordercolor),hoverborderalpha:(0,d.pluck)(x.borderhoveralpha,S.hoverBorderAlpha,x.borderalpha)}),x._hoverattrs={fillalpha:x.hoverfillalpha,fillcolor:x.hoverfillcolor,fillangle:x.hoverfillangle,fillratio:x.hoverfillratio,borderThickness:"0"!==x.showborder?x.hoverborderthickness:0,borderColor:x.hoverbordercolor,borderAlpha:x.hoverborderalpha},x._defaultattrs={fillalpha:x.fillalpha,fillcolor:x.fillcolor,fillangle:x.fillangle,fillratio:x.fillratio,borderThickness:"0"!==x.showborder?x.borderthickness:0,borderColor:x.bordercolor,borderAlpha:x.borderalpha},"image"===x.type?(x.borderthickness=x.borderthickness||0,x.onload=function(t){var o=t.width,r=t.height;b={},x=this.config,f=(Number(x.derivedX)-o/(2*E.sFactor))*E.sFactor,m=(Number(x.derivedY)-r/(2*E.sFactor))*E.sFactor,(b=K[J]||(K[J]={})).x=f+E.translateX,b.y=m+E.translateY,b.element=e,b.shapeInfo={type:"rect",width:o,height:r},o&&r&&Y.update(this.getId(),{x:f,y:m,width:o,height:r,autoscale:0}),y.imageLoadCount++,y.imageLoadCount===y.imageCount&&y._buildKdTree()},x.onerror=function(){y.imageLoadCount++,y.imageLoadCount===y.imageCount&&y._buildKdTree()},y.imageCount++):((b=K[J]||(K[J]={})).x=f,b.y=m,b.element=e,b.shapeInfo={type:C,sides:v,radius:Number(R)+x.borderthickness/2,innerradius:k}),L.drawOptions.shape=x,S.showLabels?(u=x.labelpadding||S.labelPadding,o=(t=y._getLabelOptions(P,u,x)).align,r=t.valign,n=L._labelBaseWidth,l=L._labelBaseHeight,i=L._labelXOffset,s=L._labelYOffset,(c=S.labelWrapWidth?S.labelWrapWidth:y.getWrapWidth[o](n,Number(t.x)+i))>u&&(c-=u),(h=S.labelWrapHeight?S.labelWrapHeight:y.getWrapHeight[r](l,Number(t.y)+s))>u&&(h-=u),L.drawOptions.label=(0,d.extend2)({type:"text"},{text:M,tooltext:x.tooltext,x:t.x,y:t.y,align:o,valign:t.valign,wrap:1,wrapwidth:c,wrapheight:h,fontsize:_.fontSize/E.sFactor,font:_.fontFamily,color:L.fontColor,bgcolor:L.labelBgColor||"",bordercolor:L.labelBorderColor||""}),{markerShape:x,markerLabel:L.drawOptions.label}):{markerShape:x}},o.highlightPoint=function(e,t){var o=e.element,r=t.originalEvent,a=this.getFromEnv("chart"),n=this.getFromEnv("toolTipController"),l=this.config.currentToolTip,i=a.config.lastHoveredPoint;i&&i!==e&&(i&&this.hoverOutFn(i.element),a.config.lastHoveredPoint=null,n.hide(l)),!1!==e&&("click"===t.type||"touchstart"===t.type?(a.config.lastHoveredPoint!==e&&this.hoverFn(o),this.clickFn(t,o)):"mousemove"===t.type&&a.config.lastHoveredPoint!==e&&this.hoverFn(o),o.config.tooltext&&(l?n.draw(r,o.config.tooltext,l):l=this.config.currentToolTip=n.draw(r,o.config.tooltext)),a.config.lastHoveredPoint=e)},o._drawConnectors=function(){var e,t,o,r,a,n,l,i,s,c,h,d,u,p=this.getFromEnv("chart"),g=p.config.annotationConfig,f=this.components.connectors||(this.components.connectors=[]),m=f.length,b=p.config.scalingParams,k=p.config.connectorOpts,v=k.showLabels,C=this.getChildren("mapAnnotations")[0],y=[],F=[],w=[],A={};for(w.push({id:"connectorLabels",fillalpha:"100",items:F}),w.push({id:"connectors",fillalpha:"100",items:y}),o=0;o<m;o++)f[o]&&(A[o]=!0,s=f[o].config.fromMarker.config,c=f[o].config.toMarker.config,a=s.options.x,n=s.options.y,l=c.options.x,i=c.options.y,f[o].config.x=a,f[o].config.y=n,f[o].config.tox=l,f[o].config.toy=i,u=Object.assign({animationLabel:"markerItem"},f[o].config),y.push(u),f[o].labelConfig&&v&&(f[o].labelConfig.x=((Number(a)+Number(l))/2).toString(),f[o].labelConfig.y=((Number(n)+Number(i))/2).toString(),f[o].labelConfig.fontsize=k.fontSize/(b.scaleFactor*p.config.baseScaleFactor),u=Object.assign({animationLabel:"markerItem"},f[o].labelConfig),F.push(u)));for(h=C.addGroup(Object.assign(g,w[1]),this),d=C.addGroup(Object.assign(g,w[0]),this),o=0,r=0;o<m;o++)A[o]&&((e=h.items[r])&&(e.data("unfilteredConfig",y[r]),e.addEventListener("fc-mouseover",f[o].config.onmouseover),e.addEventListener("fc-mouseout",f[o].config.onmouseout),e.addEventListener("fc-click",f[o].config.onclick)),f[o].labelConfig&&v&&(t=d.items[r])&&t.data("unfilteredConfig"),r++)},o.getShapeArgs=function(){var e,t=this.config,o=(0,d.extend2)({},this.shapeObj);return t.autoScale=1,o?("polygon"===o.type?o.sides<3?o.type="circle":o.startangle=t.startAngle:"arc"===o.type&&(e=(o.radius||t.markerRadius)*t.autoScale,o.radius=e,o.innerradius=o.innerradius&&o.innerradius*t.autoScale||.6*e),o):null},o._getLabelOptions=function(e,t,o,r,n){var l,i,s,c=e&&e.toLowerCase();return this.getLabelAlignment[c]||(c="center"),i=Number(o.x),s=Number(o.y),l=r===a||n===a?o.radius||0:/^(top|bottom)$/gi.test(c)&&.5*n||/^(left|right)$/gi.test(c)&&.5*r||0,l=Number(l)+Number(t),this.getLabelAlignment[c](i,s,l)},o.addMarkerItem=function(e){var o,r,n,l,i,s,c,h,u=this.getFromEnv("chart"),p=e,g=this.components.markerObjs,f=this.components.shapeObjs,m=this.components.markerGroup,b=this.components.markerLabelGroup,k=this.getChildren("mapAnnotations")[0],v=this.getFromEnv("number-formatter"),C=u.config.markerOpts;if(h=p.id.toLowerCase()){if(g[h])return;delete p.value,this.imageLoadCount=0,(o=t._initializeMarkerItem(h,p,null)).dataset=this,c=o.config.options.shapeid,l=o.config,s=p.value,l.cleanValue=v.getCleanValue(s),r=l.options,null!==l.cleanValue?l.formattedValue=v.dataLabels(s):l.formattedValue=a,l.fillColor=(0,d.pluck)(r.fillcolor,r.color,C.fillColor),l.fillAlpha=(0,d.pluck)(r.fillalpha,r.alpha,C.fillAlpha),l.fillRatio=(0,d.pluck)(r.fillratio,C.fillRatio),l.fillAngle=(0,d.pluck)(r.fillangle,C.fillAngle),l.borderThickness=(0,d.pluckNumber)(r.borderthickness,C.borderThickness),l.borderColor=(0,d.pluck)(r.bordercolor,C.borderColor),l.borderAlpha=(0,d.pluck)(r.borderalpha,C.borderAlpha),l.labelPadding=r.labelpadding||C.labelPadding,l.options.tooltext=(0,d.pluck)(r.tooltext,C.tooltext),l.link=r.link,c&&(o.shapeObj=f[c&&c.toLowerCase()]),g[h]=o,n=this._drawMarkerItem(o),m&&b&&(n.markerShape&&(i=Object.assign({align:"center",valign:"middle",animationLabel:"markerItem",autoscale:"image"===n.markerShape.type?0:1},n.markerShape),o.markerShape=k.addItem(m.getId(),i,this),o.markerShape.data("unfilteredConfig",i)),n.markerLabel&&(i=Object.assign({animationLabel:"markerItem"},n.markerLabel),o.markerLabel=k.addItem(b.getId(),i,this),o.markerLabel.data("unfilteredConfig",i))),this._buildKdTree()}},o.updateMarkerItem=function(e,t){var o,r,a,n,l=this.getFromEnv("chart"),i=this.getChildren("mapAnnotations")[0],s=this.components.markerObjs,c=l.config.markerOpts,h={},u=s[e];if(u){for(r in o=u.config.options,(0,d.extend2)(o,t),this.imageLoadCount=0,a=u.config,t)h[r.toLowerCase()]=t[r]&&t[r].toString();a.fillColor=(0,d.pluck)(h.fillcolor,h.color,c.fillColor),a.fillAlpha=(0,d.pluck)(h.fillalpha,h.alpha,c.fillAlpha),a.fillRatio=(0,d.pluck)(h.fillratio,c.fillRatio),a.fillAngle=(0,d.pluck)(h.fillangle,c.fillAngle),a.borderThickness=(0,d.pluckNumber)(h.borderthickness,c.borderThickness),a.borderColor=(0,d.pluck)(h.bordercolor,c.borderColor),a.borderAlpha=(0,d.pluck)(h.borderalpha,c.borderAlpha),a.labelPadding=h.labelpadding||c.labelPadding,a.options.tooltext=(0,d.pluck)(h.tooltext,c.tooltext),a.link=h.link,n=this._drawMarkerItem(u).markerShape,this._buildKdTree(),i.update(e,n)}},o.createContainer=function(){var e=this.getLinkedParent(),t=this.getFromEnv("animationManager"),o=e.getChildContainer("layer1");!this.getChildContainer("abovePlotGroup")&&this.addChildContainer("abovePlotGroup",t.setAnimation({el:"group",attr:{name:"abovePlotGroup",opacity:1},container:o,component:this,label:"group"})),!this.getChildContainer("belowPlotGroup")&&this.addChildContainer("belowPlotGroup",t.setAnimation({el:"group",attr:{name:"belowPlotGroup",opacity:1},container:o,component:this,label:"group"}))},o._removeMarkerItem=function(e){var t,o,r=this.components,a=r.markerObjs,n=a[e],l=r.kdArrayMap,i=this.getChildren("mapAnnotations")[0];n&&(t=n.markerShape,o=n.markerLabel,t&&i.destroy(t.getId()),o&&i.destroy(o.getId()),delete l[e],this._buildKdTree()),delete a[e]},o.getElement=function(e){if(this.components.kDTree)return this.components.kDTree.getNeighbour(e)},t}(l["default"]);t["default"]=I},1263:function(e,t,o){"use strict";var r=o(219);t.__esModule=!0,t["default"]=void 0;var a=r(o(238)),n=o(240),l=o(224),i=o(232),s=r(o(1261)),c=function(e){e.configure&&e.configure()};(0,i.addDep)({name:"mapsAnimation",type:"animationRule",extension:s["default"]});var h=function(e){function t(){return e.apply(this,arguments)||this}(0,a["default"])(t,e);var o=t.prototype;return o.getType=function(){return"group"},o.getName=function(){return"mapGroup"},o.configure=function(){this._mapChildren(c)},o.createContainer=function(){var e,t=this.getLinkedParent(),o=this.getFromEnv("animationManager"),r=t.getChildContainer();e=r.plotGroup,!this.getChildContainer("plotShadow")&&this.addChildContainer("plotShadow",o.setAnimation({el:"group",attr:{name:"manager-plot-shadow",opacity:1},container:e,component:this,label:"group"})),!this.getChildContainer("plot")&&this.addChildContainer("plot",o.setAnimation({el:"group",attr:{name:"manager-plot",opacity:1},container:e,component:this,label:"group"})),!this.getChildContainer("layer0")&&this.addChildContainer("layer0",o.setAnimation({el:"group",attr:{name:"ann-layer0",opacity:1},container:r.abovePlotGroup,component:this,label:"group"})),!this.getChildContainer("layer1")&&this.addChildContainer("layer1",o.setAnimation({el:"group",attr:{name:"ann-layer1",opacity:1},container:r.abovePlotGroup,component:this,label:"group"})),t.config.labelsOnTop?this.getChildContainer("layer0").toFront():this.getChildContainer("layer0").toBack()},o._transformGroup=function(){var e=this,t=this.getFromEnv("chart"),o=t.getFromEnv("chartInstance"),r=e.getFromEnv("animationManager"),a=t.jsonData,n=e.getChildContainer("plot"),i=e.getChildContainer("plotShadow"),s=t.config.scalingParams;n.hide(),i.hide(),t.config.entitiesReady=!1,o.addEventListener("internal.mapdrawingcomplete",(function(t){t.detachHandler(),l.hasSVG&&(o.args.link&&o.args.clickedEntityBox&&a.chart.linkedcharttransition,n&&r.setAnimation({el:n,attr:{transform:s.transformStr},component:e,label:"group"}),i&&r.setAnimation({el:i,attr:{transform:s.transformStr},component:e,label:"group"})),n.show(),i.show()})),t.checkComplete()},o.draw=function(){this.createContainer(),this._transformGroup()},o.getDataLimits=function(e){var t,o=+Infinity,r=-Infinity,a=0,n=function(e){r=Math.max(r,e.max),o=Math.min(o,e.min)};return this._mapChildren((function(o){o.getState("removed")||!1===o.getState("visible")?e&&(t=o.getDataLimits(e),n(t)):(a++,t=o.getDataLimits(e),n(t))})),a?this.setState("visible",!0):this.setState("visible",!1),this.config.range||(this.config.range={},this.config.range.min=this.config.dataMin,this.config.range.max=this.config.dataMax),{max:r,min:o}},t}(n.ComponentInterface);t["default"]=h}}])}));
//# sourceMappingURL=http://localhost:3052/3.18.0/map/eval/fusioncharts.maps.js.map

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

(function(factory){if(typeof module==="object"&&typeof module.exports!=="undefined"){module.exports=factory}else{factory(FusionCharts)}})(function(FusionCharts){(function(modules){var installedModules={};function __webpack_require__(moduleId){if(installedModules[moduleId]){return installedModules[moduleId].exports}var module=installedModules[moduleId]={i:moduleId,l:false,exports:{}};modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);module.l=true;return module.exports}__webpack_require__.m=modules;__webpack_require__.c=installedModules;__webpack_require__.d=function(exports,name,getter){if(!__webpack_require__.o(exports,name)){Object.defineProperty(exports,name,{configurable:false,enumerable:true,get:getter})}};__webpack_require__.r=function(exports){Object.defineProperty(exports,"__esModule",{value:true})};__webpack_require__.n=function(module){var getter=module&&module.__esModule?function getDefault(){return module["default"]}:function getModuleExports(){return module};__webpack_require__.d(getter,"a",getter);return getter};__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)};__webpack_require__.p="";return __webpack_require__(__webpack_require__.s=212)})({212:function(module,exports,__webpack_require__){"use strict";var _fusioncharts=__webpack_require__(213);var _fusioncharts2=_interopRequireDefault(_fusioncharts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}FusionCharts.addDep(_fusioncharts2["default"])},213:function(module,exports,__webpack_require__){"use strict";exports.__esModule=true;
/**!
 * @license FusionCharts JavaScript Library
 * Copyright FusionCharts, Inc.
 * License Information at <http://www.fusioncharts.com/license>
 *
 * @author FusionCharts, Inc.
 * @meta package_map_pack
 * @id fusionmaps.Australia.20.10-30-2012 06:07:23
 */var M="M",L="L",Z="Z",Q="Q",LFT="left",RGT="right",CEN="center",MID="middle",TOP="top",BTM="bottom",geodefinitions=[{name:"Australia",revision:20,standaloneInit:true,baseWidth:241,baseHeight:196,baseScaleFactor:10,entities:{TA:{outlines:[[M,1960,1685,Q,1961,1697,1971,1700,1978,1702,1981,1708,1988,1704,1992,1698,1988,1695,1986,1690,1986,1689,1985,1687,1983,1673,1976,1663,1973,1660,1965,1659,1959,1665,1959,1671,Q,1959,1678,1960,1685,Z],[M,1785,1764,Q,1793,1767,1799,1774,1802,1776,1804,1777,1806,1778,1807,1779,1810,1781,1810,1783,1811,1789,1812,1792,1813,1794,1814,1796,1815,1798,1815,1800,1820,1812,1826,1823,1832,1834,1841,1844,1851,1857,1864,1864,1876,1872,1890,1870,1902,1869,1912,1864,1916,1862,1923,1859,1932,1855,1938,1851,1945,1846,1955,1848,1965,1850,1974,1853,1980,1820,1987,1788,1990,1778,1987,1767,1985,1759,1983,1751,1982,1746,1982,1741,1983,1740,1983,1738,1986,1731,1978,1723,1977,1721,1974,1720,1971,1719,1968,1720,1949,1722,1941,1735,1935,1746,1923,1747,1920,1748,1918,1747,1913,1745,1912,1738,1906,1741,1899,1743,1890,1746,1883,1748,1876,1749,1872,1747,1870,1746,1867,1745,1843,1734,1817,1729,1797,1725,1782,1736,1775,1742,1778,1756,Q,1779,1761,1785,1764,Z],[M,1737,1675,Q,1744,1688,1759,1695,1759,1695,1761,1692,1762,1691,1762,1690,1762,1686,1760,1682,1760,1681,1760,1680,1760,1671,1754,1667,1752,1666,1750,1665,1748,1664,1746,1664,1743,1663,1741,1665,Q,1735,1671,1737,1675,Z]],label:"Tasmania",shortLabel:"TA",labelPosition:[201.5,181.9],labelAlignment:[LFT,MID],labelConnectors:[[M,2015,1819,L,1925,1819]]},SW:{outlines:[[M,2019,1080,L,1589,1085,1589,1367,1594,1364,Q,1595,1365,1597,1366,1600,1366,1602,1367,1604,1368,1605,1368,1608,1369,1610,1370,1612,1371,1613,1371,1619,1374,1623,1371,1625,1371,1626,1370,1638,1368,1647,1375,1650,1377,1653,1379,1662,1385,1674,1389,1677,1388,1679,1387,1687,1382,1692,1388,1696,1393,1699,1398,1700,1400,1700,1401,1704,1411,1710,1417,1716,1423,1725,1425,1730,1427,1734,1430,1751,1445,1769,1457,1781,1465,1797,1463,1809,1461,1822,1458,1836,1455,1850,1459,1863,1463,1876,1468,1882,1471,1888,1470,1890,1469,1891,1469,1894,1468,1895,1466,1899,1461,1909,1463,1913,1464,1917,1465,1925,1467,1933,1468,1936,1468,1938,1467,1939,1466,1944,1465,1947,1465,1949,1465,1969,1463,1969,1479,1968,1485,1969,1492,1970,1495,1970,1497,1970,1511,1982,1516,1984,1518,1987,1517,1993,1517,1998,1521,2003,1527,2014,1528,2015,1528,2016,1528,2019,1529,2021,1530,2024,1532,2030,1533,2031,1534,2032,1534,2038,1535,2045,1536,2047,1535,2050,1535,2053,1534,2055,1533,2057,1532,2066,1529,2067,1526,2069,1521,2071,1511,2072,1500,2073,1477,2086,1465,2087,1464,2088,1462,2089,1457,2091,1455,2096,1449,2099,1444,2101,1441,2102,1439,2108,1433,2110,1420,2111,1417,2115,1414,2122,1408,2122,1396,2122,1388,2120,1380,2119,1377,2121,1372,2125,1363,2129,1358,2130,1357,2131,1356,2136,1353,2138,1350,2145,1339,2148,1326,2151,1316,2154,1305,2154,1304,2155,1302,2157,1301,2158,1301,2171,1298,2180,1288,L,2180,1293,Q,2182,1292,2184,1290,2207,1269,2217,1243,2219,1237,2222,1233,2226,1226,2227,1222,2231,1210,2234,1198,2234,1197,2235,1195,2236,1193,2237,1190,2237,1189,2237,1187,2243,1163,2248,1139,2250,1129,2253,1118,2259,1093,2267,1070,2268,1067,2268,1064,2268,1062,2266,1060,2264,1057,2262,1051,2260,1045,2258,1039,2247,1035,2233,1038,2232,1039,2230,1039,2223,1040,2217,1038,2213,1037,2209,1037,2191,1037,2183,1049,2182,1051,2183,1053,2184,1055,2184,1056,2185,1064,2179,1066,2173,1070,2166,1072,2148,1079,2132,1074,2118,1069,2104,1058,2094,1051,2081,1052,2072,1053,2061,1056,2049,1060,2035,1062,2030,1063,2027,1066,Q,2022,1072,2019,1080,Z]],label:"New South Wales",shortLabel:"SW",labelPosition:[192.8,128.6],labelAlignment:[CEN,MID]},VI:{outlines:[[M,1710,1417,Q,1704,1411,1700,1401,1700,1400,1699,1398,1696,1393,1692,1388,1687,1382,1679,1387,1677,1388,1674,1389,1662,1385,1653,1379,1650,1377,1647,1375,1638,1368,1626,1370,1625,1371,1623,1371,1619,1374,1613,1371,1612,1371,1610,1370,1608,1369,1605,1368,1604,1368,1602,1367,1600,1366,1597,1366,1595,1365,1594,1364,1590,1365,1589,1366,L,1589,1583,1575,1583,Q,1577,1586,1579,1588,1581,1592,1583,1595,1584,1596,1586,1596,1593,1596,1599,1597,1610,1599,1618,1594,1628,1587,1636,1588,1646,1588,1656,1596,1668,1604,1681,1608,1709,1615,1738,1615,1748,1615,1754,1609,1763,1600,1767,1588,1768,1586,1768,1583,1769,1580,1769,1577,1770,1572,1774,1570,1782,1564,1792,1560,1795,1559,1796,1560,1807,1567,1813,1577,1816,1580,1817,1586,1817,1588,1817,1591,1818,1601,1822,1609,1823,1611,1824,1611,1825,1611,1827,1611,1834,1611,1838,1605,1839,1603,1840,1603,1852,1600,1861,1610,1864,1615,1867,1620,1868,1622,1868,1623,1870,1631,1877,1634,1886,1622,1896,1609,1898,1607,1898,1604,1904,1587,1926,1582,1928,1582,1931,1582,1938,1582,1944,1580,1947,1579,1950,1577,1951,1576,1952,1576,1955,1575,1957,1573,1965,1566,1985,1560,1987,1559,1990,1559,2001,1558,2011,1557,2014,1556,2016,1557,2017,1558,2024,1557,2042,1554,2055,1544,2058,1542,2061,1539,2061,1538,2062,1537,2064,1534,2066,1531,2066,1529,2062,1531,2057,1532,2055,1533,2053,1534,2050,1535,2047,1535,2045,1536,2038,1535,2032,1534,2031,1534,2030,1533,2024,1532,2021,1530,2019,1529,2016,1528,2015,1528,2014,1528,2003,1527,1998,1521,1993,1517,1987,1517,1984,1518,1982,1516,1970,1511,1970,1497,1970,1495,1969,1492,1968,1485,1969,1479,1969,1463,1949,1465,1947,1465,1944,1465,1939,1466,1938,1467,1936,1468,1933,1468,1925,1467,1917,1465,1913,1464,1909,1463,1899,1461,1895,1466,1894,1468,1891,1469,1890,1469,1888,1470,1882,1471,1876,1468,1863,1463,1850,1459,1836,1455,1822,1458,1809,1461,1797,1463,1781,1465,1769,1457,1751,1445,1734,1430,1730,1427,1725,1425,Q,1716,1423,1710,1417,Z]],label:"Victoria",shortLabel:"VI",labelPosition:[167.9,149.3],labelAlignment:[CEN,MID]},SA:{outlines:[[M,1399,1306,Q,1403,1300,1410,1294,1410,1301,1411,1308,1411,1309,1411,1310,1412,1314,1413,1318,1415,1334,1402,1338,1399,1338,1398,1341,1392,1352,1394,1366,1394,1369,1392,1370,1385,1377,1380,1385,1379,1387,1378,1388,1357,1407,1364,1433,1368,1431,1373,1430,1387,1427,1401,1429,1406,1429,1412,1427,1415,1426,1420,1425,1418,1423,1417,1418,1417,1418,1417,1417,1417,1415,1417,1412,1418,1399,1421,1385,1422,1379,1428,1380,1431,1384,1434,1387,1445,1400,1443,1417,1443,1422,1439,1425,1438,1427,1436,1428,1434,1429,1432,1431,1423,1437,1417,1447,1417,1448,1416,1450,1414,1455,1407,1454,1396,1451,1389,1449,1387,1448,1386,1448,1376,1445,1372,1449,1370,1451,1368,1453,1367,1455,1366,1457,1361,1467,1367,1473,1376,1484,1391,1482,1394,1481,1395,1480,1400,1477,1407,1481,1410,1479,1413,1477,1424,1467,1437,1459,1446,1455,1454,1450,1467,1444,1479,1435,1484,1431,1489,1436,1492,1438,1492,1441,1493,1445,1494,1449,1494,1452,1494,1455,1496,1474,1506,1481,1509,1482,1510,1484,1512,1487,1514,1488,1523,1494,1521,1508,1520,1518,1520,1529,1519,1537,1519,1545,1518,1553,1527,1553,1533,1553,1538,1554,1553,1557,1562,1567,1569,1574,1575,1583,L,1589,1583,1589,923,932,923,931,1233,Q,939,1234,948,1236,957,1238,963,1235,966,1233,971,1232,973,1231,975,1230,997,1218,1025,1220,1050,1223,1076,1226,1077,1226,1079,1225,1084,1224,1086,1227,1095,1236,1105,1244,1112,1249,1120,1250,1143,1255,1167,1257,1171,1257,1175,1258,1177,1258,1180,1259,1187,1261,1192,1264,1205,1273,1209,1286,1214,1301,1228,1313,1231,1316,1234,1317,1240,1321,1247,1323,1261,1329,1266,1336,1268,1339,1271,1342,1272,1345,1273,1347,1274,1353,1271,1357,1267,1364,1265,1368,1259,1378,1258,1388,1259,1388,1260,1388,1267,1388,1272,1385,1276,1383,1279,1392,1288,1408,1306,1405,1308,1405,1311,1403,1313,1402,1315,1400,1317,1398,1318,1396,1321,1391,1323,1385,1323,1384,1323,1382,1322,1364,1332,1358,1335,1357,1337,1355,1342,1350,1348,1351,1356,1352,1363,1349,1370,1347,1375,1345,1370,1345,1373,1339,1374,1335,1380,1331,1388,1325,1391,1318,Q,1396,1312,1399,1306,Z]],label:"South Australia",shortLabel:"SA",labelPosition:[124.4,108.3],labelAlignment:[CEN,MID]},QU:{outlines:[[M,1775,290,Q,1773,289,1772,288,1770,285,1765,286,1762,286,1761,287,1760,289,1758,290,1755,294,1754,300,1752,304,1746,308,1745,309,1744,309,1741,310,1740,309,1736,305,1734,299,1729,277,1730,255,1731,243,1730,230,1730,228,1729,226,1723,218,1719,211,1715,205,1713,199,1713,197,1713,195,1714,183,1706,177,1705,175,1703,174,1701,173,1698,171,1690,168,1690,158,1690,147,1691,137,1693,121,1686,108,1678,90,1666,74,1664,71,1660,73,1644,82,1642,102,1642,105,1643,107,1646,116,1648,126,1649,131,1647,135,1642,146,1634,155,1625,166,1620,178,1617,186,1618,195,1622,211,1622,227,1622,234,1621,241,1617,266,1608,289,1606,293,1608,302,1609,304,1609,305,1618,320,1624,335,1625,336,1623,337,1622,339,1621,339,1613,339,1613,345,1613,352,1613,358,1613,374,1608,389,1605,401,1598,412,1593,421,1593,431,1593,436,1590,447,1590,448,1590,449,1589,452,1588,453,1576,460,1561,469,1559,471,1557,472,1554,473,1551,473,1543,475,1535,475,1524,475,1518,463,1514,453,1500,455,1491,458,1490,452,1490,450,1488,445,1498,431,1508,423,1515,417,1516,410,1506,410,1500,414,1498,416,1495,416,1494,416,1492,416,1479,418,1466,422,1448,428,1428,426,1426,426,1425,425,1425,424,1424,424,L,1428,923,1588,923,1588,1085,2019,1080,Q,2022,1072,2027,1066,2030,1063,2035,1062,2048,1060,2061,1056,2071,1053,2081,1052,2094,1051,2103,1058,2118,1069,2132,1074,2147,1079,2166,1072,2173,1070,2179,1066,2184,1064,2183,1056,2183,1055,2183,1053,2182,1051,2183,1049,2190,1037,2209,1037,2213,1037,2216,1038,2223,1040,2230,1039,2231,1039,2233,1038,2247,1035,2257,1039,L,2257,1038,Q,2252,1020,2250,1e3,2250,998,2249,995,2248,983,2248,971,2248,968,2249,968,2250,967,2251,960,2251,957,2250,955,2248,952,2247,949,2246,947,2245,944,2240,935,2238,925,2236,913,2241,906,2246,897,2249,890,2252,881,2256,872,2260,862,2254,856,2253,857,2251,858,2247,859,2245,863,2240,875,2227,882,2224,875,2219,869,2218,868,2216,867,2211,866,2208,862,2195,847,2179,829,2167,816,2155,802,2154,801,2152,800,2146,798,2141,794,2136,790,2133,785,2128,775,2125,768,2124,766,2124,765,2123,756,2118,750,2107,736,2089,730,2083,728,2075,728,2065,728,2060,721,2052,711,2049,698,2047,689,2043,681,2035,665,2023,650,2021,647,2019,643,2019,642,2021,639,2021,639,2022,638,2019,631,2017,623,2015,613,2011,603,2011,602,2008,602,2007,602,2006,601,2004,600,2003,600,1995,599,1987,598,1971,596,1958,588,1950,583,1942,574,1933,561,1920,556,1917,555,1915,555,1907,554,1902,550,1897,546,1887,543,1888,531,1883,527,1881,526,1880,524,1877,521,1872,521,1869,521,1869,520,1862,501,1861,481,1860,467,1856,454,1852,441,1847,429,1844,420,1837,412,1831,405,1824,393,1825,397,1826,398,1817,388,1819,374,1820,373,1820,371,1821,369,1821,366,1822,353,1823,340,1824,337,1823,335,1815,321,1803,311,1793,302,1783,294,Q,1780,292,1775,290,Z]],label:"Queensland",shortLabel:"QU",labelPosition:[173.8,76],labelAlignment:[CEN,MID]},NT:{outlines:[[M,1331,127,Q,1324,143,1311,151,1299,157,1290,167,1288,168,1287,168,1280,169,1276,171,1271,172,1266,172,1244,171,1224,166,1218,164,1211,162,1187,153,1164,143,1152,137,1143,127,1136,120,1128,115,1125,113,1121,112,1120,112,1119,112,1115,112,1111,113,1108,113,1105,114,1103,115,1101,117,1099,119,1099,121,1100,133,1111,132,1113,132,1115,133,1119,134,1124,135,1127,135,1128,136,1136,142,1143,153,1141,152,1140,151,1141,156,1139,158,1122,178,1097,180,1087,180,1077,177,1067,175,1059,167,1057,166,1054,166,1053,166,1052,167,1046,171,1043,177,1043,179,1041,180,1037,182,1034,184,1024,194,1018,206,1010,223,1e3,237,993,246,986,255,981,262,981,274,981,276,980,278,970,278,960,281,958,282,958,283,956,286,956,290,956,297,964,304,973,311,974,324,966,331,953,329,943,328,936,322,935,321,934,320,L,932,923,1428,923,1425,424,Q,1420,417,1415,407,1414,406,1414,405,1413,402,1411,401,1404,393,1394,383,1393,382,1391,382,1380,381,1370,378,1363,375,1359,370,1353,364,1348,359,1347,358,1346,358,1343,357,1342,355,1337,351,1327,350,1326,350,1324,350,1322,349,1319,348,1315,345,1311,344,1302,341,1293,336,1290,334,1287,327,1284,318,1285,309,1286,306,1290,303,1298,298,1305,291,1306,290,1306,287,1307,286,1308,284,1312,276,1319,273,L,1322,273,Q,1330,286,1348,284,1363,282,1360,268,1359,264,1358,263,1344,257,1330,254,1327,254,1324,254,1316,254,1311,250,1308,248,1311,244,1324,227,1340,212,1358,195,1370,175,1365,174,1359,174,1341,175,1322,176,1312,177,1303,177,1307,175,1310,172,1320,163,1330,154,1339,145,1347,136,1352,129,1354,121,1355,114,1346,117,1343,117,1340,118,Q,1334,120,1331,127,Z]],label:"Northern Territory",shortLabel:"NT",labelPosition:[116,63.6],labelAlignment:[CEN,MID]},WA:{outlines:[[M,626,417,Q,625,409,619,404,611,397,606,409,605,414,601,415,595,417,592,421,577,443,567,466,565,471,568,473,577,483,579,494,576,495,573,497,571,499,570,501,569,502,568,503,566,505,563,506,556,509,553,515,547,527,541,537,540,538,539,540,536,547,532,549,521,557,512,570,505,581,490,586,477,591,463,593,450,596,437,596,421,597,406,601,402,602,399,606,397,609,389,610,372,606,362,617,361,619,359,619,343,629,327,631,309,632,289,628,285,628,282,631,281,632,279,633,274,634,269,637,247,645,226,655,224,656,223,657,215,666,209,673,208,675,207,674,188,674,177,684,176,685,176,687,173,697,164,701,156,704,151,697,148,692,142,690,140,689,138,688,130,684,127,695,124,703,116,708,115,710,113,711,103,725,105,743,105,749,108,753,115,761,116,770,117,782,113,788,109,794,106,799,99,812,93,826,92,831,92,836,93,845,102,853,104,854,105,855,108,863,110,871,111,874,112,876,117,889,124,898,127,901,128,904,131,909,130,913,129,918,128,925,128,927,127,930,123,937,116,935,108,932,104,925,100,918,95,911,93,915,91,919,L,88,923,Q,79,914,72,901,68,894,58,898,57,902,58,905,60,912,61,919,61,922,63,924,73,935,84,945,93,954,100,964,103,969,107,976,111,982,114,986,123,995,126,1013,127,1016,128,1018,131,1026,128,1035,128,1036,127,1037,129,1047,135,1059,140,1071,148,1080,160,1092,169,1099,183,1110,176,1126,175,1128,174,1130,167,1143,169,1157,169,1160,170,1162,176,1174,182,1187,191,1203,200,1218,204,1227,207,1236,212,1250,211,1264,210,1274,205,1284,203,1288,207,1291,210,1292,211,1294,222,1307,214,1320,211,1324,206,1326,198,1330,190,1335,178,1343,169,1357,168,1359,170,1363,178,1379,194,1384,196,1385,198,1386,204,1390,209,1396,216,1407,226,1411,240,1417,258,1415,277,1413,295,1416,313,1418,332,1418,335,1418,338,1417,345,1413,355,1404,365,1395,377,1390,391,1385,407,1384,413,1383,416,1381,422,1377,428,1370,437,1358,449,1356,471,1351,495,1352,498,1354,501,1355,505,1356,512,1352,513,1351,514,1351,520,1350,524,1351,543,1358,562,1357,564,1357,565,1356,568,1355,569,1354,573,1350,581,1350,584,1350,586,1349,596,1344,602,1350,609,1355,618,1361,620,1362,621,1362,625,1362,629,1361,636,1361,643,1360,644,1359,645,1358,648,1347,653,1337,660,1323,672,1314,683,1307,694,1301,708,1292,721,1281,723,1280,725,1281,728,1282,730,1281,739,1279,752,1278,L,755,1277,Q,757,1276,758,1275,789,1260,822,1264,825,1264,827,1265,832,1268,841,1267,846,1267,851,1266,866,1263,880,1256,896,1249,908,1241,912,1238,918,1235,925,1232,931,1233,L,934,320,Q,930,318,923,319,922,320,921,320,918,321,916,322,906,329,894,329,892,329,890,327,881,317,886,300,883,294,880,289,879,287,877,286,873,284,867,283,852,279,843,267,842,266,841,265,829,256,822,262,821,265,819,267,810,276,791,271,781,282,770,293,766,297,760,297,758,297,752,297,747,298,743,301,742,302,740,304,737,308,738,318,739,324,737,329,736,332,735,332,727,337,718,339,707,342,700,349,695,353,698,359,701,366,699,380,699,384,698,388,698,390,696,391,683,396,669,398,661,400,653,399,648,399,647,404,647,409,647,414,647,421,649,428,650,429,650,430,650,437,647,443,646,447,642,447,633,450,629,444,623,431,626,422,Q,627,420,626,417,Z]],label:"Western Australia",shortLabel:"WA",labelPosition:[52.6,91.9],labelAlignment:[CEN,MID]}}}];exports["default"]={extension:geodefinitions,name:"australia",type:"maps"}}})});

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

!function(e){"object"==typeof module&&"undefined"!=typeof module.exports?module.exports=e:e()}((function(){(window.webpackJsonpFusionCharts=window.webpackJsonpFusionCharts||[]).push([[4],{1e3:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(555)),l=a(232),s=o(a(1001));(0,l.addDep)({name:"stepLineAnimation",type:"animationRule",extension:s["default"]});var c=function(e){function t(){var t;return(t=e.call(this)||this).getPathArr=function(){var e=this.pathArr,t=this.path2Arr;return e.length||t.length?e.concat(t):[]},t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"stepLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.drawverticaljoins=void 0,t.useforwardsteps=void 0},a._addLegend=function(){var e,t=this.config,a=this.getFromEnv("legend"),o=this.getFromEnv("chart-attrib"),r=(0,i.pluckNumber)(t.drawanchors,1),n=this.config.JSONData||{},l={enabled:t.includeinlegend,type:"line",drawLine:(0,i.pluck)(t.drawLine,!0),anchorSide:r?t.anchorsides:0,label:(0,i.getFirstValue)(this.config.JSONData.seriesname),legendIconAlpha:(0,i.pluckNumber)(n.legendiconalpha)};t.includeinlegend?((e=a.getItem(this.config.legendItemId))||(this.config.legendItemId=a.createItem(this),e=a.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){e.itemClickFn()}),e)),e.configure(l),e.setStateCosmetics("default",{symbol:{fill:(0,i.toRaphaelColor)({color:t.anchorbgcolor,alpha:t.anchorbgalpha}),bgAlpha:(0,i.pluckNumber)(n.legendiconbgalpha,n.legendiconalpha,o.legendiconbgalpha,o.legendiconalpha,t.anchorbgalpha),borderAlpha:(0,i.pluckNumber)(n.legendiconborderalpha,n.legendiconalpha,o.legendiconborderalpha,o.legendiconalpha,"100"),rawFillColor:t.anchorbgcolor,rawStrokeColor:t.anchorbordercolor,stroke:(0,i.toRaphaelColor)({color:t.anchorbordercolor,alpha:"100"}),"stroke-width":t.anchorborderthickness}}),this.getState("visible")?e.removeLegendState("hidden"):e.setLegendState("hidden")):this.config.legendItemId&&a.disposeItem(this.config.legendItemId)},a.getLinePath=function(e,t){var a,o,r,n,l,s,c,d=this.config,h=this.getFromEnv("chartConfig"),u=(0,i.pluckNumber)(h.connectnulldata),p={},g=(0,i.pluckNumber)(d.drawverticaljoins),f=(0,i.pluckNumber)(h.stepatmiddle)?.5*this.getFromEnv("xAxis").getPVR():0,m=p.lastValidValue||!1,v=p.temp||[],b=p.temp2||[],x=p.pathArr||[],k=p.path2Arr||[],y=p.pointsJoined||0,C=t&&t.begin||0,w=t&&t.end||e.length,A=h.viewPortConfig.step||1,S=[];for(S=S.concat(e),o=C;o<w;o+=A)(s=S[o])&&(void 0===(c=(r=s.config).setValue)||r&&!0===r.isSkipped?r&&delete r.isSkipped:(n=r._Px,l=r._Py,null===c||c.isNull?u||(v=[],b=[],m=!1):m?(v.length&&(x=x.concat(v),v=[],y++),(0,i.pluckNumber)(d.useforwardsteps)?(x.push(["H",n-f]),g?x.push(["V",l]):x.push(["M",n-f,l]),f&&x.push(["H",n])):(g?x.push(["V",l]):x.push(["M",a,l]),x.push(["H",n]),a=n)):(v.push(["M",n,l]),a=n,y=0,m=!0)));return{pathArr:x,path2Arr:k,lastValidValue:m,pointsJoined:y,temp:v,temp2:b,getPathArr:this.getPathArr}},t}(n["default"]);t["default"]=c},1001:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.stepLine":o(a(558))["default"]["*.dataset.line"]};t["default"]=r},1002:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1003))["default"];t["default"]=r},1003:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t.configurer=t["default"]=void 0;var r,i=o(a(242)),n=o(a(238)),l=o(a(951)),s=a(1004),c=a(224),d=a(232),h=o(a(1012)),u=a(953),p=o(a(661)),g=a(276);t.configurer=r;var f=function(e){function t(){var t;t=e.call(this)||this;var a=(0,i["default"])(t);return a.fireGroupEvent=!0,a.usesXYinCategory=!0,a.dontShowLegendByDefault=!0,t.registerFactory("dataset",h["default"],["vCanvas"]),t.registerFactory("axis",p["default"],["canvas"]),t}(0,n["default"])(t,e),t.getName=function(){return"DragNode"};var a=t.prototype;return a.getName=function(){return"DragNode"},a._checkInvalidSpecificData=function(){if(!this.getFromEnv("dataSource").dataset)return!0},a._mouseEvtHandler=function(e,t){(0,g._mouseEvtHandler)(this,e,t)},a.parseChartAttr=function(t){var a,o=this.getFromEnv("dataSource").chart,r=(0,d.getDepsByType)("transcoder");e.prototype.parseChartAttr.call(this,t),(a=this.config).formAction=(0,c.getValidValue)(o.formaction),a.showLegend=(0,c.pluckNumber)(o.showlegend,0),o.submitdataasxml!==c.ZEROSTRING||o.formdataformat||(o.formdataformat=r.csv().format),a.formDataFormat=(0,c.pluck)(o.formdataformat,r.xml().format),a.formTarget=(0,c.pluck)(o.formtarget,"_self"),a.formMethod=(0,c.pluck)(o.formmethod,"POST"),a.submitFormAsAjax=(0,c.pluckNumber)(o.submitformusingajax,1),a.viewMode=(0,c.pluckNumber)(o.viewmode,0),a.drawTrendRegion=0},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.hasLegend=!0,t.defaultDatasetType="dragnode",t.limitUpdaterEnabled=!1,t.skipClipping=!0,t.numVDivLines=0,t.numDivLines=0,t.setadaptivexmin=1,t.showLimits=0,t.showdivlinevalues=0,t.showzeroplane=0,t.showyaxisvalues=0,t.enablemousetracking=!0,t.showzeroplaneontop=0},a.addConfigureOptions=function(){var e,t,a=this,o=a.config,r=a.getFromEnv("toolbar"),i=r.getChild("hamburgerMenu-"+r.getId()+"-"+a.getId()+"-0"),n=[{name:"Add Node",handler:function(){a.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].showNodeAddUI()},action:"click"},{name:"Add Connector",handler:function(){a.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].showConnectorAddUI()},action:"click"},{name:"Add Label",handler:function(){a.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].showLabelUpdateUI()},action:"click"}];o.showRestoreBtn&&(e={name:o.restoreBtnTitle,handler:function(){a.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].restoreData()},action:"click"},n.push(e)),o.showFormBtn&&(t={name:o.submitBtnTitle,handler:function(){u.submitData.call(a)},action:"click"},n.push(t)),a.config.viewMode||i.appendInMenu(n)},a.getDSdef=function(e){switch(e){case"connector":return s.DragNodeConnector;case"dragnode":return s.DragNodeDataset;case"dragableLabels":return s.DragNodeLabels}},a.getDSGroupdef=function(){return s.DragNodeGroup},a._setCategories=function(){var e,t,a=this.getFromEnv("dataSource"),o=this.getChildren("xAxis"),r=a.categories&&a.categories[0].category||[],i=r.length,n=[];for(e=0;e<i;e++)void 0!==(t=r[e]||{}).x&&n.push(t);o&&o[0].setTickValues(n)},a.getJSONData=function(){var e,t=this.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0],a={};return t&&(a=t.getJSONData()),(e=(0,c.extend2)({},this.getFromEnv("dataSource"))).dataset=a.dataset,e.connectors=a.connectors,e.labels=a.labels,e},t}(l["default"]);t.configurer=r=f.prototype.configure;var m=f;t["default"]=m},1004:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0;var r=o(a(1005));t.DragNodeDataset=r["default"];var i=o(a(1007));t.DragNodeLabels=i["default"];var n=o(a(1009));t.DragNodeConnector=n["default"];var l=o(a(1011));t.DragNodeGroup=l["default"]},1005:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(556)),n=a(224),l=a(232),s=o(a(1006)),c=o(a(332)),d=o(a(663)),h=(0,l.getDep)("redraphael","plugin"),u=Math.max,p=Math.min,g=n.preDefStr.CIRCLE,f=n.preDefStr.POLYGON,m=n.preDefStr.RECTANGLE,v=n.preDefStr.UNDERSCORE,b=n.preDefStr.GROUPID,x=n.preDefStr.EVENTARGS,k=n.preDefStr.OBJECTBOUNDINGBOX,y=n.preDefStr.DEFAULT,C=n.preDefStr.COMMA,w=n.preDefStr.POSITION_TOP,A=!!n.hasSVG,S=function(){this.hide()},N=function(e){return null!=e},L=function(e,t,a,o){return t.setAnimation({el:"group",attr:{name:e},container:a,component:o})},D=function(e,t,a){var o,r,i,l=e,s=t;return l=(0,n.getFirstColor)(l),s=(0,n.getFirstAlpha)(s),r=(0,n.getLightColor)(l,80),i=(0,n.getDarkColor)(l,65),o={FCcolor:{gradientUnits:k,color:r+C+i,alpha:s+C+s,ratio:n.BGRATIOSTRING}},a?o.FCcolor.angle=1===a?0:180:(o.FCcolor.cx=.4,o.FCcolor.cy=.4,o.FCcolor.r="50%",o.FCcolor.radialGradient=!0),o},E=function(e,t,a){var o,r=e.setTooltext,i=e.formatedVal,l=t.seriesname,s=e.label,c=e.xValue,d=e.pointLabel,h=t.tooltipSepChar;return void 0!==r?o=(0,n.parseTooltext)(r,[3,4,5,6,8,9,10,11],{yaxisName:(0,n.parseUnsafeString)(a.yaxisname),xaxisName:(0,n.parseUnsafeString)(a.xaxisname),yDataValue:i,xDataValue:c,label:s},e,a,t):void 0!==d?o=s:null===i?o=!1:(t.seriesNameInToolTip&&(l=(0,n.getFirstValue)(t.seriesname)),o=l?l+h:n.BLANK,o+=c?c+h:n.BLANK,o+=i),o};(0,l.addDep)({name:"dragNodeAnimation",type:"animationRule",extension:s["default"]}),(0,c["default"])(h);var T=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"dragNode"},a.getType=function(){return"dataset"},a.hide=function(){var e=this.getLinkedParent(),t={hide:!0};this.setState("dirty",!0),this.setState("visible",!1),e.childChanged(t),this.getFromEnv("chart").getChildren("legend")[0].getItem(this.config.legendItemId).setLegendState("hidden"),this.asyncDraw()},a.show=function(){var e=this.getLinkedParent(),t=this.getFromEnv("legend").getItem(this.config.legendItemId),a={show:!0};this.setState("visible",!0),this.setState("dirty",!0),e.childChanged(a),t&&t.removeLegendState("hidden"),this.asyncDraw()},a._setDatasetIndex=function(){var e=this.getLinkedParent().getChildren("dataset");this.config.datasetIndex=e.indexOf(this)},a.pointInShape=function(e,t,a){var o,r,i,n,l,s=this.getFromEnv("chart").getChildren("canvas")[0].config,c=a.symbol,d=a._xPos,h=a._yPos;return!(e<s.canvasLeft||e>s.canvasLeft+s.canvasWidth||t<s.canvasTop||t>s.canvasTop+s.canvasHeight)&&("rectangle"===c?(n=a._plotWidth,h-=(l=a._plotHeight)/2,e>=(d-=n/2)&&t>=h&&e<=d+n&&t<=h+l):(o=(e-d)*(e-d),r=(t-h)*(t-h),i=Number(a.radius),o+r<=(i*=i)))},a._firePlotEvent=function(e,t,a){var o,r,i,l=this.getFromEnv("chart"),s=this.components,c=this.getFromEnv("toolTipController"),d=s.data[t]||{},h=this.getGraphicalElement("sharedAnchor"),u=d.graphics&&d.graphics.element||void 0!==(d.config&&d.config.setValue)&&h,p=this.config.currentToolTip,g=this.config.viewMode,f=this.getLinkedParent(),m=d.graphics.element;if(u)switch(i=(o=d.config).setLink,r=o.eventArgs,e){case"fc-mouseover":this._decideTooltipType(t,a),this._rolloverResponseSetter(l,d,a),i&&(u.node.style.cursor=n.POINTER);break;case"fc-mouseout":c.hide(p),this._rolloutResponseSetter(l,d,a),i&&(u.node.style.cursor=y);break;case"fc-click":m.data("fire_click_event")&&l.plotEventHandler(u,a,"dataplotclick",r);break;case"fc-mousemove":f.hideWaitElem(),this._decideTooltipType(t,a);break;case"fc-mousedown":clearTimeout(m._longpressactive),m.data("fire_click_event",1),g||f.drawWaitingRing(d,this.config.datasetIndex);break;case"fc-mouseup":f.hideWaitElem(),f.clearLongPress()}},a.dragUp=function(e){this.data("drag-options").dataset._dragUp.call(this,e)},a.dragMove=function(e,t){var a=this.data("drag-options").dataset,o=t[0],r=t[1],i=t[2],n=t[3];a._dragMove.call(this,o,r,i,n)},a.dragStart=function(e){this.data("drag-options").dataset._dragStart.call(this,e)},a._dragStart=function(){var e,t=this.data("drag-options"),a=t.dataObj,o=a.graphics.element,r=o.getBBox(),i=a.config,n=t.dataset,l=n.getFromEnv("chart"),s=i.dragStart||(i.dragStart={}),c=a.graphics.cloneGraphic,d=n.getContainer("cloneGraphicGroup"),h=a.graphics.cloneText,u=a.graphics.image,p=a.graphics.cloneImage,g=a.graphics.label;A&&(o._.dirty=1),i.allowDrag&&(!c&&a.graphics.element&&(c=a.graphics.cloneGraphic=a.graphics.element.clone(),d.appendChild(c)),g&&!h&&((h=a.graphics.cloneText=a.graphics.label.clone()).followers[0]&&h.followers[0].el&&d.appendChild(h.followers[0].el),d.appendChild(h)),u&&!p&&(p=a.graphics.cloneImage=a.graphics.image.clone(),d.appendChild(p)),h&&h.show(),p&&p.show(),c&&c.show()),s.xPos=i._xPos,s.yPos=i._yPos,s.x=i.x,s.y=i.y,s.bBox=r,s.origX=s.lastDx||(s.lastDx=0),s.origY=s.lastDy||(s.lastDy=0),e=o.data(x),l.fireChartInstanceEvent("dataplotdragstart",e),c&&c.show(),h&&h.show(),p&&p.show()},a._dragMove=function(e,t){var a,o=e,r=t,i=this.data("drag-options"),n=i.dataObj,l=n.graphics.element,s=n.graphics.cloneGraphic,c=n.graphics.cloneImage,d=n.graphics.cloneText,h=n.config,u=h.dragStart,p=u.bBox.x+o,g=u.bBox.x2+o,f=u.bBox.y+r,m=u.bBox.y2+r,v=i.dataset,b=v.getFromEnv("animationManager"),x=v.getLinkedParent(),k=v.getFromEnv("chartConfig"),y=k.canvasLeft,w=k.canvasRight,A=k.canvasTop,S=k.canvasBottom;p<y&&(o+=y-p),g>w&&(o-=g-w),f<A&&(r+=A-f),m>S&&(r-=m-S),(o||r)&&(l.data("fire_click_event",0),x.hideWaitElem(),x.clearLongPress()),h.allowDrag&&(u.draged=!0,u.lastDx=o,u.lastDy=r,a=i._transformObj={transform:"t"+(u.origX+o)+C+(u.origY+r)},s&&b.setAnimation({el:s,attr:a,component:v}),c&&b.setAnimation({el:c,attr:a,component:v}),d&&b.setAnimation({el:d,attr:{x:h._xPos+o,y:h._yPos+r},component:v}))},a._getHoveredPlot=function(e,t){var a=this.config.tree.getNeighbour({x:e,y:t},!1);if(a)return{pointIndex:a.index||a.i,hovered:!0,pointObj:a.data}},a._rolloutResponseSetter=function(e,t,a){var o=this.getFromEnv("animationManager"),r=t.config,i=t.graphics.element,l=r.dragStart,s=i.data("unHoverAttr");l&&Object.keys(l).length||("poly"!==r.shapeType&&r.shapeType!==g||(s.path=(0,n.polyPathToPath)([r.shapeArg.sides,r._xPos,r._yPos,s.r,r.startAngle,0])),r.rollOverProperties.enabled&&o.setAnimation({el:i,attr:s,component:this}),e&&e.plotEventHandler(i,a,"DataPlotRollOut"))},a._rolloverResponseSetter=function(e,t,a){var o=this.getFromEnv("animationManager"),r=t.config,i=t.graphics.element,l=r.dragStart,s=i.data("hoverAttr");l&&Object.keys(l).length||("poly"!==r.shapeType&&r.shapeType!==g||(s.path=(0,n.polyPathToPath)([r.shapeArg.sides,r._xPos,r._yPos,s.r,r.startAngle,0])),r.rollOverProperties.enabled&&o.setAnimation({el:i,attr:s,component:this}),e&&e.plotEventHandler(i,a,"DataPlotRollOver"))},a._dragUp=function(e){var t,a,o,r,i,l,s=this.data("drag-options"),c=s.dataset,d=c.getFromEnv("chart"),h=c.components.data,u=s.dataObj,p=u.graphics.element,g=c.getLinkedParent(),f=u.config,m=u.config.dragStart||{},v=c.getFromEnv("yAxis"),b=u.graphics.cloneText,k=c.getFromEnv("xAxis"),y={},C=c.config.datasetIndex,w=u.graphics.cloneGraphic,A=u.graphics.cloneImage;if(g.hideWaitElem(),g.clearLongPress(),m.draged){for(m.origX+=m.lastDx,m.origY+=m.lastDy,u.config._xPos=m.xPos+m.lastDx,u.config._yPos=m.yPos+m.lastDy,y.x=k.getValue(u.config._xPos),y.y=v.getValue(u.config._yPos),y.update=!0,o=0,i=h.length;o<i&&(r=h[o],u.config.id!==r.config.id);o++);c.updatePointConfig(y,o),(l=p.data(x)).x=y.x,l.y=y.y,c.parsePlotAttributes(o),c._drawNode(o),t=u.config.startConnectors,a=u.config.endConnectors,g.drawNodeConnectors(t,C),g.drawNodeConnectors(a,C),(0,n.getMouseCoordinate)(d.getFromEnv("chart-container"),e,d).sourceEvent="dataplotdragend",d.fireChartInstanceEvent("chartupdated",(0,n.extend2)({sourceEvent:"dataplotdragend"},l),e),d.fireChartInstanceEvent("dataplotdragend",l,e),m.draged=!1,c._setupKdTree()}b&&b.hide(),w&&w.hide(),A&&A.hide(),delete f.dragStart},a.updatePointConfig=function(e,t){var a,o=this.components.data,r=this.config,i=(o[t]||{}).config,l=this.getFromEnv("number-formatter"),s=this.getFromEnv("chart-attrib");void 0!==i&&(i.y=l.getCleanValue((0,n.pluck)(e.y)),i.x=l.getCleanValue((0,n.pluck)(e.x)),i._options.x=i.x,i._options.y=i.y,a=l.xAxis(i.x),i.formatedVal=null===i.y?i.y:l.dataLabels(i.y),i.xValue=a,r.showTooltip?i.toolText=E(i,r,s):i.toolText=!1,i.update=e.update)},a.getNode=function(e){return e?this.components.nodes[e]:this.components.nodes},a.configureAttributes=function(e){if(e)this.trimData(e),this.config.JSONData=e;else if(!e&&!this.config.JSONData)return!1;var t,a,o,r,i,l,s,c=this.config.datasetIndex,d=this.config.JSONData,h=d.data||[],u=this.getFromEnv("chart-attrib"),p=this.getFromEnv("chartConfig"),g=h.length,f=this.config,m=n.ZEROSTRING,v=this.getFromEnv("color-manager"),b=n.HUNDREDSTRING;for(f.context={},this.components.nodes={},f.showValues=(0,n.pluckNumber)(d.showvalues,u.showvalues,1),s=f.useRoundEdges=(0,n.pluckNumber)(u.useroundedges),f.zIndex=1,f.name=(0,n.getValidValue)(d.seriesname),f.viewMode=(0,n.pluckNumber)(u.viewmode,0),f.id=(0,n.pluck)(d.id,this.index),0!==(0,n.pluckNumber)(d.includeinlegend)&&void 0!==f.name||(f.showInLegend=!1),f.seriesname=(0,n.parseUnsafeString)(d.seriesname),f.includeinlegend=(0,n.pluckNumber)(d.includeinlegend,f.seriesname?1:0),f.showTooltip=(0,n.pluckNumber)(u.showtooltip,1),f.seriesNameInTooltip=(0,n.pluckNumber)(u.seriesnameintooltip,1),f.showTextOutline=(0,n.pluckNumber)(u.textoutline,0),f.tooltipSepChar=(0,n.pluck)(u.tooltipsepchar," - "),a=f.plotFillAlpha=(0,n.pluck)(u.plotfillalpha,b),o=f.showPlotBorder=(0,n.pluckNumber)(u.showplotborder,1),r=f.plotBorderColor=(0,n.getFirstColor)((0,n.pluck)(u.plotbordercolor,"666666")),i=f.plotBorderThickness=(0,n.pluckNumber)(u.plotborderthickness,s?2:1),l=f.plotBorderAlpha=(0,n.pluck)(u.plotborderalpha,u.plotfillalpha,s?"35":"95"),f.use3DLighting=Boolean((0,n.pluckNumber)(u.use3dlighting,u.is3d,s?1:0)),f.color=(0,n.getFirstColor)((0,n.pluck)(d.color,v.getPlotColor(c))),f.alpha=(0,n.pluck)(d.plotfillalpha,d.nodeFillAlpha,d.alpha,a),f.datasetShowPlotBorder=Boolean((0,n.pluckNumber)(d.showplotborder,o)),f.datasetPlotBorderColor=(0,n.getFirstColor)((0,n.pluck)(d.plotbordercolor,d.nodebordercolor,r)),f.datasetPlotBorderThickness=(0,n.pluckNumber)(d.plotborderthickness,d.nodeborderthickness,i),f.datasetPlotBorderAlpha=f.datasetShowPlotBorder?(0,n.pluck)(d.plotborderalpha,d.nodeborderalpha,d.alpha,l):m,f.datasetAllowDrag=Boolean((0,n.pluckNumber)(d.allowdrag,1)),f.colorObj={fillColor:(0,n.convertColor)(f.color,f.alpha),lineColor:{FCcolor:{color:f.datasetPlotBorderColor,alpha:f.datasetPlotBorderAlpha}}},f.lineWidth=void 0,f.symbol="poly_4",this.components.data||(this.components.data=[]),this.setState("visible",1===(0,n.pluckNumber)(d.visible,!Number(d.initiallyhidden),1)),f.yMin=f.yMax=f.xMax=f.xMin=0,this._refreshData=!0,t=0;t<g;t+=1)this._setConfigure(t);this._refreshData=!1,p.showLegend&&this._addLegend(),this._setDatasetIndex(),this.setState("dirty",!0)},a._setConfigure=function(e,t){var a,o,r,i,l,s,c=this.config.JSONData,d=c.data,h=t||d[e],m=this.components.data,v=this.config,b=m[e]=m[e]||(m[e]={}),x=b.config=b.config||(b.config={}),k=v.id,y=v.yMin||+Infinity,C=v.yMax||-Infinity,A=v.xMax||-Infinity,S=v.xMin||+Infinity,L=v.use3DLighting,T=v.datasetPlotBorderThickness,F=v.datasetPlotBorderColor,P=v.datasetPlotBorderAlpha,_=this.getFromEnv("chart-attrib"),V=v.color,I=v.alpha,B=v.datasetAllowDrag,M=this.getFromEnv("number-formatter");if(!b.graphics&&(b.graphics={}),x._options=(0,n.extend2)({},h),h||t){if(o=x.y=M.getCleanValue((0,n.pluck)(h.y)),r=x.x=M.getCleanValue((0,n.pluck)(h.x)),x.index=e,x.dragStart||(x.dragStart={}),C=u(C,x.y),y=p(y,x.y),A=u(A,x.x),S=p(S,x.x),null===o)x.value=null;else{switch(i=M.xAxis(r),x.formatedVal=null===o?o:M.dataLabels(o),x.setTooltext=(0,n.getValidValue)((0,n.parseUnsafeString)((0,n.pluck)(h.tooltext,c.plottooltext,_.plottooltext),!1)),x.pointLabel=(0,n.pluck)(h.label,h.name),l=(0,n.parseUnsafeString)(x.pointLabel),x.label=l,x.name=l,x.displayValue=l,x.xValue=i,t||(x.startConnectors={},x.endConnectors={}),v.showTooltip?x.toolText=E(x,v,_):x.toolText=!1,x.link=h.link,x.id=(0,n.pluck)(h.id,k+n.preDefStr.UNDERSCORE+e),x.allowDrag=Boolean((0,n.pluckNumber)(h.allowdrag,B)),a=x.shape=(0,n.getValidValue)((0,n.pluck)(h.shape),n.preDefStr.RECTANGLE).toLowerCase(),x.height=(0,n.getValidValue)((0,n.pluck)(h.height),10),x.width=(0,n.getValidValue)((0,n.pluck)(h.width),10),x.radius=(0,n.getValidValue)((0,n.pluck)(h.radius),10),x.numSides=(0,n.getValidValue)((0,n.pluck)(h.numsides),4),x.color=(0,n.getFirstColor)((0,n.pluck)(h.color,V)),x.borderColor=(0,n.getFirstColor)((0,n.pluck)(h.bordercolor,F)),x.alpha=(0,n.pluck)(h.alpha,I),x.imageURL=(0,n.getValidValue)(h.imageurl),x.imageNode=Boolean((0,n.pluckNumber)(h.imagenode)),x.imageWidth=h.imagewidth,x.imageHeight=h.imageheight,x.imageAlign=(0,n.getValidValue)(h.imagealign,n.BLANK).toLowerCase(),x.labelAlign=(0,n.pluck)(h.labelalign,x.imageNode&&N(x.imageURL)?w:n.preDefStr.POSITION_MIDDLE),x.hovercolor=(0,n.pluck)(h.hovercolor,c.hovercolor),x.borderhoveralpha=(0,n.pluck)(h.borderhoveralpha,c.borderhoveralpha),x.borderhovercolor=(0,n.pluck)(h.borderhovercolor,c.borderhovercolor),x.borderhoverthickness=(0,n.pluck)(h.borderhoverthickness,c.borderhoverthickness),x.hoveralpha=(0,n.pluck)(h.hoveralpha,c.hoveralpha),x.hoverheight=(0,n.pluck)(h.hoverheight,c.hoverheight),x.hoverradius=(0,n.pluck)(h.hoverradius,c.hoverradius),x.hoverwidth=(0,n.pluck)(h.hoverwidth,c.hoverwidth),x.dataLabelStyle=this._configureDataLabelStyle(h),x.shape){case g:s=0;break;case f:s=2,a=(0,n.mapSymbolName)(x.numSides);break;default:s=1}x.symbol=a,L?(x.fillColor=D(x.color,x.alpha,s),x.cloneFillColor=D(x.color,50,s)):(x.fillColor={color:x.color,alpha:x.alpha},x.cloneFillColor=(0,n.convertColor)(x.color,50)),x.colorArr=[{FCcolor:{color:x.color,alpha:x.alpha}},{FCcolor:{color:x.borderColor,alpha:P}}],x.rollOverProperties=this.pointHoverOptions(b,_,{shapeType:s,use3D:L,height:x.height,width:x.width,radius:x.radius,color:x.color,alpha:x.alpha,borderColor:x.borderColor,borderAlpha:P,borderThickness:T})}!x.update&&t&&(x.update=t.update),!x.add&&t&&(x.add=t.add),!0===this._refreshData&&delete b.removed}b.dataset=this,v.xMax=A,v.xMin=S,v.yMin=y,v.yMax=C},a.pointHoverOptions=function(e,t,a){var o,r,i,l,s=(0,n.pluckNumber)(e.config.showhovereffect,this.config.showhovereffect,t.plothovereffect,t.showhovereffect),c={},d=!!(0,n.pluck)(e.config.hovercolor,this.config.hovercolor,t.plotfillhovercolor,e.config.hoveralpha,this.config.hoveralpha,t.plotfillhoveralpha,e.config.borderhovercolor,this.config.borderhovercolor,t.plotborderhovercolor,e.config.borderhoveralpha,this.config.borderhoveralpha,t.plotborderhoveralpha,e.config.borderhoverthickness,this.config.borderhoverthickness,t.plotborderhoverthickness,e.config.hoverheight,this.config.hoverheight,t.plothoverheight,e.config.hoverwidth,this.config.hoverwidth,t.plothoverwidth,e.config.hoverradius,this.config.hoverradius,t.plothoverradius,s),h=!1;return(void 0===s&&d||s)&&(h=!0,o=(0,n.pluck)(e.config.hovercolor,this.config.hovercolor,t.plotfillhovercolor,(0,n.getLightColor)(a.color,70)),c={rawhoverAlpha:r=(0,n.pluck)(e.config.hoveralpha,this.config.hoveralpha,t.plotfillhoveralpha,a.alpha),rawhoverColor:o,rawhoverBorderColor:i=(0,n.pluck)(e.config.borderhovercolor,this.config.borderhovercolor,t.plotborderhovercolor,a.borderColor),rawhoverBorderAlpha:(0,n.pluckNumber)(e.config.borderhoveralpha,this.config.borderhoveralpha,t.plotborderhoveralpha,r,a.borderAlpha),stroke:(0,n.convertColor)(i,(0,n.pluckNumber)(e.config.borderhoveralpha,this.config.borderhoveralpha,t.plotborderhoveralpha,r,a.borderAlpha)),"stroke-width":(0,n.pluckNumber)(e.config.borderhoverthickness,this.config.borderhoverthickness,t.plotborderhoverthickness,a.borderThickness),height:(0,n.pluckNumber)(e.config.hoverheight,this.config.hoverheight,t.plothoverheight,a.height),width:(0,n.pluckNumber)(e.config.hoverwidth,this.config.hoverwidth,t.plothoverwidth,a.width),r:(0,n.pluckNumber)(e.config.hoverradius,this.config.hoverradius,t.plothoverradius,a.radius)},l=a.use3D?D((0,n.getFirstColor)((0,n.pluck)(e.config.hovercolor,this.config.hovercolor,t.plotfillhovercolor,(0,n.getLightColor)(a.color,70))),(0,n.pluck)(e.config.hoveralpha,this.config.hoveralpha,t.plotfillhoveralpha,a.alpha),a.shapeType):(0,n.convertColor)(o,r),c.fill=(0,n.toRaphaelColor)(l)),{enabled:h,rollOverAttrs:c}},a._addLegend=function(){var e,t=this.config,a=this.getFromEnv("legend"),o={enabled:t.includeInLegend,type:this.type,anchorSide:4,label:(0,n.getFirstValue)(this.config.JSONData.seriesname)};t.includeinlegend?((e=a.getItem(this.config.legendItemId))?e.configure({style:a.config.itemStyle,hiddenStyle:a.config.itemHiddenStyle,datasetVisible:a.config.datasetVisible,hoverStyle:a.config.itemHoverStyle}):(this.config.legendItemId=a.createItem(this),e=a.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){e.itemClickFn()}),e)),e.configure(o),e.setStateCosmetics("default",{symbol:{fill:(0,n.toRaphaelColor)({color:t.color,alpha:t.alpha}),rawFillColor:t.color,stroke:(0,n.toRaphaelColor)({color:t.plotBorderColor,alpha:n.HUNDREDSTRING}),"stroke-width":t.anchorBorderThickness}}),this.getState("visible")?e.removeLegendState("hidden"):e.setLegendState("hidden")):this.config.legendItemId&&a.disposeItem(this.config.legendItemId)},a.createContainer=function(){var e=this.getFromEnv("animationManager"),t=this.getLinkedParent().getChildContainer();!this.getContainer("nodesGroup")&&this.addContainer("nodesGroup",L("nodesGroup",e,t.defaultVcanvasGroup,this)),!this.getContainer("dataLabelsGroup")&&this.addContainer("dataLabelsGroup",L("dataLabelsGroup",e,t.vcanvasLabelGroup,this)),!this.getContainer("cloneGraphicGroup")&&this.addContainer("cloneGraphicGroup",L("cloneGraphicGroup",e,t.defaultVcanvasGroup,this))},a.draw=function(){var e,t,a,o=this.components,r=this.getFromEnv("smartLabel"),i=o.data,n=this.components.removeDataArr||[],l=n.length,s=this.getFromEnv("dataLabelStyle"),c={fontFamily:s.fontFamily,fontSize:s.fontSize,lineHeight:s.lineHeight,fontWeight:s.fontWeight,fontStyle:s.fontStyle};if(this.getState("dirty")||this._contextChanged()){for(this.createContainer(),a=this.getContainer("nodesGroup"),this.getFromEnv("animationManager").setAnimation({el:this.getContainer("cloneGraphicGroup"),attr:{opacity:.3},component:this}),a.css(c),r.useEllipsesOnOverflow(this.getFromEnv("chartConfig").useEllipsesWhenOverflow),e=0,t=i.length;e<t;e+=1)!i[e].removed&&this._drawNode(e);for(this.config.drawn=!0,e=0;e<l;e++)this._removeDataVisuals(n.shift());this._setupKdTree()}},a._setupKdTree=function(){var e,t,a,o,r,i=this.config,l=this.components.data,s=-Infinity;for(r=i.searchDataArr=[],e=l.length,t=0;t<e;t++)a=l[t].config,l[t].removed||void 0===a._yPos||isNaN(a._yPos)||(o=a.props.element.attr,s=Math.max(s,(0,n.pluckNumber)(a.radius,0)),r.push({x:(0,n.pluckNumber)(o.x,a._xPos),y:(0,n.pluckNumber)(o.y,a._yPos),index:t,data:l[t],shapeInfo:{type:a.shape,radius:(0,n.pluck)(a.radius,0),width:(0,n.pluckNumber)(a.width),height:(0,n.pluckNumber)(a.height),sides:(0,n.pluckNumber)(a.numSides)}}));i.tree=new d["default"](!0).buildKdTree(r),i.tree._setSearchLimit(s,s)},a.drawLabel=function(e){var t,a,o,r,i,l,s,c,d,h,u,p,g,f,m,v,k,y,C,A,S,L,D,E,T=this.getFromEnv("chart"),F=this.config,P=F.datasetIndex,_=this.getFromEnv("animationManager"),V=this.components.data,I=V.length,B=this.getContainer("nodesGroup"),M=this.getFromEnv("chartConfig"),O=this.getFromEnv("dataLabelStyle"),R=this.dragUp,G=this.dragMove,H=this.dragStart,z=this.getFromEnv("smartLabel"),W=this.getState("visible");for(z.setStyle(O),void 0!==e?I=(t=e)+1:t=0;t<I;t++)if(k=(i=(u=V[t]).config)._plotWidth,y=i._plotHeight,l=i.displayValue,C=i.labelAlign,v=(A=u.graphics).cloneText,S=u.config.rollOverProperties,L=i.shapeType,W&&N(l)&&l!==n.BLANK){switch(z.useEllipsesOnOverflow(M.useEllipsesWhenOverflow),d=.5*y-.5*(c=z.getSmartText(l,k-1,y-1)).height,C){case w:d=-d;break;case n.POSITION_BOTTOM:break;default:d=0}g=i._xPos,D=i._yPos,u._yAdjustment=p=d,f=D+p,s=i.link?n.POINTER:i.allowDrag?"move":n.BLANKSTRING,r=i.dataLabelStyle,a={text:c.text,title:c.tooltext||n.BLANKSTRING,fill:r.color,"text-bound":[r.backgroundColor,r.borderColor,O.borderThickness,O.borderPadding,O.borderRadius,O.borderDash],x:g,y:f,cursor:s},o=A.label,(o=_.setAnimation({el:o||"text",attr:a,container:B,component:this})).outlineText(F.showTextOutline,a.fill),A.label?o.show():(o=this.addGraphicalElement("plotLabel",o,!0),A.label=o,o.drag(G,H,R)),E=A&&(A.image||A.element),v&&_.setAnimation({el:v,attr:{transform:n.BLANKSTRING,x:g,y:f,text:c.text,title:c.tooltext||n.BLANKSTRING,fill:O.color,"text-bound":[O.backgroundColor,O.borderColor,O.borderThickness,O.borderPadding,O.borderRadius,O.borderDash]},component:this}),o.data("drag-options",{dataObj:u,dataset:this,datasetIndex:P,pointIndex:u.config.index,cursor:s,chart:T,link:u.link}),h={index:t,link:i.link,y:i.y,x:i.x,shape:(0,n.pluck)(L,"rect"),width:i.width,height:i.height,radius:i.radius,sides:i.numSides,label:i.displayValue,toolText:i.toolText,id:i.id,datasetIndex:P,datasetName:this.config.JSONData.seriesname,sourceType:"dataplot",allowDrag:i.allowDrag,numSides:i.numSides,imageNode:i.imageNode,imageAlign:i.imageAlign,imageWidth:i.imageWidth,imageHeight:i.imageHeight,labelAlign:i.labelAlign,color:i.color,alpha:i.alpha,hoverColor:i.rollOverProperties.rollOverAttrs.rawhoverColor,hoverAlpha:i.rollOverProperties.rollOverAttrs.rawhoverAlpha,borderHoverColor:i.rollOverProperties.rollOverAttrs.rawhoverBorderColor,borderHoverAlpha:i.rollOverProperties.rollOverAttrs.rawhoverBorderAlpha,borderHoverThickness:i.rollOverProperties.rollOverAttrs["stroke-width"],hoverHeight:i.rollOverProperties.rollOverAttrs.height,hoverWidth:i.rollOverProperties.rollOverAttrs.width,hoverRadius:i.rollOverProperties.rollOverAttrs.r},m=P+"_"+t,o.data(b,m),o.data(x,h),o.data("hoverAttr",S&&S.rollOverAttrs),o.data("unHoverAttr",E.data("unHoverAttr"))}else A.label&&A.label.hide()},a.parsePlotAttributes=function(e){var t,a,o,r,i,l,s,c,d,h,u,p,f,b,x,k,y,C,w,A,S,N,L,D=this.config.datasetIndex,E=this.components,T=E.nodes,F=this.getFromEnv("xAxis"),P=this.getFromEnv("yAxis"),_=E.data[e],V=_.config,I=this.config,B=_.graphics||(_.graphics={}),M=V.symbol,O=I.colorObj.lineColor,R=I.datasetPlotBorderThickness,G=_.config.rollOverProperties,H=V.shape,z=V.link?n.POINTER:V.allowDrag?"move":n.BLANKSTRING,W=B.cloneImage;if(V._yPos=a=P.getPixel(V.y),V._xPos=t=F.getPixel(V.x),void 0!==a&&!isNaN(a)){if(V.shapeArg={},c=V.shapeArg,r=(0,n.pluckNumber)(V.height),o=(0,n.pluckNumber)(V.width),i=(0,n.pluckNumber)(V.radius),f=M===m,l=V.id,s=V.imageNode,d=V.imageURL,h=V.imageAlign,u=f?o:1.4*i,b=(0,n.pluckNumber)(V.imageWidth,u),p=f?r:1.4*i,x=(0,n.pluckNumber)(V.imageHeight,p),C=(0,n.toRaphaelColor)(V.fillColor),V._plotWidth=u,V._plotHeight=p,y={fill:C,"stroke-width":R,stroke:(0,n.toRaphaelColor)(O)},A=[(M=(M=c.symbol=(0,n.pluck)(V.symbol,I.symbol,n.BLANK)).split(v))[1],t,a,V.radius,V.startAngle,0],"poly"===M[0]||M[0]===g?(V.shapeType=M[0],V.elemType="path",S={path:(0,n.polyPathToPath)(A)},c.x=t,c.y=a,c.radius=V.radius,c.sides=M[1],y.r=V.radius,delete y.width,delete y.x,delete y.y,delete y.height,G&&G.enabled&&(delete(w=G.rollOverAttrs).x,delete w.y,delete w.width,delete w.height)):(V.shapeType=n.SHAPE_RECT,V.elemType=n.SHAPE_RECT,c.x=t-o/2,c.y=a-r/2,c.r=0,c.width=o,c.height=r,S={x:c.x,y:c.y,width:o,height:r,r:0},y.width=o,y.height=r,y.x=t-o/2,y.y=a-r/2,G&&G.enabled&&((w=G.rollOverAttrs).x=t-w.width/2,w.y=a-w.height/2,delete w.r)),S.fill=C,S["stroke-width"]=R,S.stroke=(0,n.toRaphaelColor)(O),V.eventArgs={index:e,link:V.link,y:V.y,x:V.x,shape:(0,n.pluck)(H,"rect"),width:o,height:r,radius:i,sides:V.numSides,label:V.displayValue,toolText:V.toolText,id:V.id,datasetIndex:D,datasetName:this.config.JSONData.seriesname,sourceType:"dataplot",allowDrag:V.allowDrag,numSides:V.numSides,imageNode:V.imageNode,imageAlign:V.imageAlign,imageWidth:V.imageWidth,imageHeight:V.imageHeight,labelAlign:V.labelAlign,color:V.color,alpha:V.alpha,hoverColor:V.rollOverProperties.rollOverAttrs.rawhoverColor,hoverAlpha:V.rollOverProperties.rollOverAttrs.rawhoverAlpha,borderHoverColor:V.rollOverProperties.rollOverAttrs.rawhoverBorderColor,borderHoverAlpha:V.rollOverProperties.rollOverAttrs.rawhoverBorderAlpha,borderHoverThickness:V.rollOverProperties.rollOverAttrs["stroke-width"],hoverHeight:V.rollOverProperties.rollOverAttrs.height,hoverWidth:V.rollOverProperties.rollOverAttrs.width,hoverRadius:V.rollOverProperties.rollOverAttrs.r},s&&d){switch(x>p&&(x=p),b>u&&(b=u),h){case n.POSITION_MIDDLE:k=a-x/2;break;case n.POSITION_BOTTOM:k=p>x?a+p/2-x:a-x/2;break;default:k=p>x?a-.5*p:a-x/2}V.imageX=t-b/2,V.imageY=k,V.imageWidth=b,V.imageHeight=x,L={src:d,x:V.imageX,y:k,width:b,height:x,cursor:z},W&&(N={transform:n.BLANKSTRING,src:d,x:V.imageX,y:k,width:b,height:x})}V.pointAttr=y,T[l]=_,V.props={element:{attr:S},imageElement:{attr:L},cloneImage:{attr:N},cloneGraphic:{attr:S}}}},a.allocatePosition=function(e){var t,a;if(a=this.components.data.length,void 0!==e)this.parsePlotAttributes(e);else for(t=0;t<a;t++)this.parsePlotAttributes(t)},a._drawNode=function(e){var t,a,o=this.getFromEnv("chart"),r=this.config.datasetIndex,i=this.getLinkedParent(),l=this.components,s=this.getFromEnv("animationManager"),c=l.data[e],d=c.config,h=c.graphics||(c.graphics={}),u=d.imageNode,p=d.imageURL,g=this.getContainer("nodesGroup"),f=c.config.rollOverProperties,m=this.dragUp,v=this.dragMove,k=this.dragStart,y=d.link?n.POINTER:d.allowDrag?"move":n.BLANKSTRING,C=h.graphic,w=h.cloneText,A=h.cloneGraphic,N=h.cloneImage,L=h.image,D=h.label,E=this.getState("visible");void 0===d._yPos||isNaN(d._yPos)?(h.element&&(h.element=s.setAnimation({el:h.element,component:this})),h.image&&(h.image=s.setAnimation({el:h.image,component:this})),h.label&&(h.label=s.setAnimation({el:h.label,component:this}))):(a=(C=h.element)&&C.type,-1===d.elemType.indexOf(a)&&C&&(C.remove(),C=h.element=null,D&&D.remove(),L&&L.remove(),delete h.label,delete h.image,L=null,D=null),C=s.setAnimation({el:C||d.elemType,label:"node",attr:d.props.element.attr,container:g,component:this}),h.graphic||C.drag(v,k,m),h.element=C,C.show(),i.animationDone=!0,t=r+"_"+e,A&&(A.type===C.type?s.setAnimation({el:A,attr:d.props.element.attr,component:this}).transform(n.BLANKSTRING):(A.remove(),delete c.graphics.cloneGraphic,w&&(w.remove(),delete c.graphics.cloneText))),u&&p?(L=s.setAnimation({el:h.image||"image",attr:E&&d.props.imageElement.attr,doNotRemove:!0,container:g,component:this,callback:!E&&S}),!h.image&&L&&L.drag(v,k,m),h.image=L,E&&L.show(),L.data("drag-options",{dataObj:c,dataset:this,datasetIndex:this.index,pointIndex:c.config.index,cursor:y,link:c.link}),L.data(b,t),L.data(x,d.eventArgs),L.data("hoverAttr",f&&f.rollOverAttrs),L.data("unHoverAttr",d.pointAttr),N&&s.setAnimation({el:N,attr:d.props.cloneImage.attr,component:this})):h.image&&(h.image=s.setAnimation({el:h.image,component:this})),this.drawLabel(e),s.setAnimation({el:C,attr:{cursor:y},component:this}),C.data("drag-options",{dataObj:c,dataset:this,datasetIndex:this.index,pointIndex:c.config.index,cursor:y,chart:o,link:c.link}),C.data(b,t),C.data(x,d.eventArgs),C.data("hoverAttr",f&&f.rollOverAttrs),C.data("unHoverAttr",d.pointAttr),E?C.show():C.hide())},a.trimData=function(e){if(this.config.JSONData){var t=this.components,a=t.data&&t.data.length,o=e.data&&e.data.length||0,r=a-o;r>0&&this.removeData(o,r)}},a.removeData=function(e,t){var a=e,o=t,r=this.components,i=this.getLinkedParent(),n=r.data,l=r.removeDataArr||(r.removeDataArr=[]);o=o||1,(a=a||0)<0&&(a=0),r.removeDataArr=l=l.concat(n.splice(a,o)),i._clearConnectors()},a._removeDataVisuals=function(e){var t,a,o;if(e)for(t in a=e.graphics)(o=a[t]).hide&&"function"==typeof o.hide&&(this.getFromEnv("animationManager").setAnimation({el:o,attr:{"text-bound":[]},component:this}),o.hide(),o.transform&&o.transform(n.BLANKSTRING))},a.getJSONData=function(){var e,t,a=this.components.data,o=a.length,r=[];for(t=0;t<o;t++)(e=a[t]).removed||e.config._options&&(delete e.config._options.update,delete e.config._options.add,r.push(e.config._options));return r},t}(i["default"]);t["default"]=T},1006:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.dragNode":function(){return{"node.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"axis"}]}}}}},1007:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(1005)),n=a(224),l=a(232),s=o(a(1008)),c=n.preDefStr.PX,d="rgba(192,192,192,"+(n.isIE?.002:1e-6)+")",h=function(e){function t(){var t;return t=e.call(this)||this,(0,l.addDep)({name:"draggablelabelAnimation",type:"animationRule",extension:s["default"]}),t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"dragNodeLabels"},a.configure=function(e){if(e)this.trimData(e),this.config.JSONData=e.label;else if(!e&&!this.config.JSONData)return!1;var t,a=this.getFromEnv("chart-attrib"),o=this.config,r=(this.config.JSONData||[]).length,i=this.components.data;for(o.viewMode=(0,n.pluckNumber)(a.viewmode,0),i||(i=this.components.data=[]),t=0;t<r;t++)this._setConfigure(t)},a._setConfigure=function(e,t){var a,o,r,i,l=this.config.JSONData,s=t||l[e],d=this.components.data,h=this.getFromEnv("style").inCanvasStyle,u=h.fontSize;!(a=d[e])&&(a=d[e]={}),!a.graphics&&(a.graphics={}),r=a.config=a.config||(a.config={}),o=(0,n.parseUnsafeString)((0,n.pluck)(s.text,s.label)),r._options=s,r.add=s.add,o&&(r.text=o,r.x=s.x||0,r.y=s.y||0,r.labelFontSize=i=(0,n.pluckNumber)(s.fontsize,u),r.labelColor=(0,n.hashify)((0,n.pluck)(s.color,h.color)),r.alpha=(0,n.pluckNumber)(s.alpha,100)/100,r.allowDrag=(0,n.pluckNumber)(s.allowdrag,1),r.padding=(0,n.pluckNumber)(s.padding,5),s.fontsize?r.labelCSS={fontSize:i+c}:r.labelCSS={},r.labelBGColor=(0,n.pluck)(s.bgcolor&&s.bgcolor.replace(n.dropHash,n.HASHSTRING)),r.labelBDColor=(0,n.pluck)(s.bordercolor&&s.bordercolor.replace(n.dropHash,n.HASHSTRING)),r.link=s.link,r.borderThickness=s.borderthickness,r.dashLen=s.dashlen,r.dashGap=s.dashgap,r.dashed=s.dashed,r.radius=s.radius)},a.getJSONData=function(){var e,t,a=this.components.data,o=a.length,r=[];for(t=0;t<o;t++)(e=a[t]).removed||e.config._options&&r.push(e.config._options);return r},a.createContainer=function(){var e=this.getFromEnv("animationManager"),t=this.getLinkedParent().getChildContainer();!this.getContainer("dragLabelGroup")&&this.addContainer("dragLabelGroup",e.setAnimation({el:"group",attr:{name:"dragLabelGroup"},label:"group",component:this,container:t.defaultVcanvasGroup}))},a.allocatePosition=function(){this.parsePlotAttributes()},a.parsePlotAttributes=function(){var e,t,a,o,r,i,l,s,c,d,h,u,p,g,f,m,v,b,x,k,y,C=this.components.data,w=this.getFromEnv("yAxis"),A=this.getFromEnv("xAxis"),S=this.getFromEnv("smartLabel"),N=this.getFromEnv("dataLabelStyle"),L=C&&C.length,D=this.getFromEnv("chartConfig");for(k=0;k<L;k++)(p=C[k]).removed||(h=p.config,!p.graphics&&(p.graphics={}),h.index=k,o=A.getPixel(h.x),r=w.getPixel(h.y),l=h.text,s=h.labelBGColor,c=h.labelBDColor,d=h.padding,g=h.allowDrag,f=h.labelFontSize,i=h.labelColor,m=h.radius,a=h.dashed,h.borderThickness,e=h.dashLen,t=h.dashGap,b=h.borderThickness,y=h.labelCSS,u={x:o,y:r,text:l,align:n.POSITION_CENTER,fill:i,"text-bound":[s||n.BLANKSTRING,c||n.BLANKSTRING,(0,n.pluckNumber)(b,1),d,(0,n.pluckNumber)(m,0),(0,n.pluckNumber)(a,0)?(0,n.getDashStyle)((0,n.pluckNumber)(e,5),(0,n.pluckNumber)(t,4)):n.DASH_DEF],visibility:n.visibleStr},x={backgroundColor:s,borderColor:c,borderPadding:d,fontSize:f+n.PXSTRING,fontStyle:N.fontStyle,fontWeight:N.fontWeight,borderRadius:0,borderDash:n.DASH_DEF,fontFamily:N.fontFamily},(0,n.setLineHeight)(x),S.useEllipsesOnOverflow(D.useEllipsesWhenOverflow),S.setStyle(x),y["line-height"]=x.lineHeight,h.eventArgs={link:h.link,text:l,x:o,y:r,allowdrag:g,sourceType:"labelnode"},h.props={element:{attr:u}},h.labelCSSApplied=y,v=S.getOriSize(l),h.width=v.width,h.height=v.height,h.xPos=o,h.yPos=r)},a.draw=function(){var e,t,a,o,r,i,n=this.components.data,l=this.getFromEnv("animationManager"),s=this.getFromEnv("dataLabelStyle"),c=n&&n.length,d=this.components.removeDataArr||[],h=d.length;for(this.createContainer(),(i=this.getContainer("dragLabelGroup")).css({"font-weight":s.fontWeight,"font-style":s.fontStyle,"font-size":s.fontSize,"font-family":s.fontFamily}),r=0;r<c;r++)(t=n[r]).removed||(e=t.config,o=t.graphics.element,a=l.setAnimation({el:o||"text",container:i,css:e.labelCSS,attr:e.props.element.attr,component:this}),o?(e.labelCSSApplied&&a.removeCSS(),a.show().css(e.labelCSS)):t.graphics.element=a,a.data("eventArgs",e.eventArgs));for(this.drawTracker(),r=0;r<h;r++)this._removeDataVisuals(d.shift())},a.drawTracker=function(){var e,t,a,o,r,i,l,s,c,h,u,p,g,f,m=this,v=m.components.data,b=m.getFromEnv("animationManager"),x=m.getFromEnv("chart"),k=m.getLinkedParent(),y=m.config,C=m.getContainer("dragLabelGroup"),w=v&&v.length,A=function(){var e=this.data("drag-options"),t=e.dataset,a=e.index,o=t.components.data[a];this.data("fire_click_event",1),k.clearLongPress(),k.triggerLabelUI(this,o)},S=function(){this.data("fire_click_event")&&(this.data("fire_click_event",0),k.clearLongPress())},N=function(e){var t=this.data("fire_click_event");k.clearLongPress(),t&&x.plotEventHandler(this,e,"LabelClick")},L=function(e){x.plotEventHandler(this,e,"LabelRollover")},D=function(e){x.plotEventHandler(this,e,"LabelRollout")},E=function(e,t){m._labelDragMove.call(this,e,t,x)},T=function(e){m._labelDragStart.call(this,e,x)},F=function(e){m._labelDragUp.call(this,e)};for(f=0;f<w;f++)(e=v[f]).removed||(a=(t=e.config).padding||0,p=t.width,g=t.height,h=t.xPos-p/2,u=t.yPos-g/2,i=t.allowDrag,l=t.text,c=e.graphics.trackerElement,r={x:h-a,y:u-a,width:p+2*a,height:g+2*a,cursor:t.allowDrag?"move":n.BLANKSTRING,fill:d,stroke:d},o={link:t.link,text:l,x:h,y:u,allowdrag:i,sourceType:"labelnode"},s=b.setAnimation({el:c||"rect",container:C,attr:r,component:m}),c||(e.graphics.trackerElement=s,s.on("fc-mousedown",A).on("fc-mousemove",S).on("fc-mouseup",N).data("viewMode",y.viewMode).data(n.preDefStr.EVENTARGS,o).hover(L,D),t.allowDrag&&s.drag(E,T,F)),s.data("drag-options",{index:f,dataset:m}))},a._labelDragStart=function(){var e=this.getBBox(),t=this.data("drag-options"),a=t.dataset,o=a.getLinkedParent(),r=t.index,i=a.components.data[r],n=i.graphics.element,l=i.dragStart=i.dragStart||(i.dragStart={});t.ox=n.attr("x"),t.oy=n.attr("y"),t.bBox=e,l.xPos=i.config.xPos,l.yPos=i.config.yPos,l.bBox=e,this.data("fire_click_event",1),this.data("fire_dragend",0),o.clearLongPress(),o.triggerLabelUI(this,i)},a._labelDragMove=function(e,t){var a,o,r=this.data("drag-options"),i=r.index,n=r.dataset,l=n.getFromEnv("chart"),s=n.getFromEnv("chartConfig"),c=s.canvasLeft,d=s.canvasRight,h=s.canvasBottom,u=s.canvasTop,p=n.getLinkedParent(),g=n.components.data[i],f=g.graphics.element,m=g.dragStart,v=m.bBox,b=t[0],x=t[1],k=m.bBox.x+b,y=m.bBox.x2+b,C=m.bBox.y+x,w=m.bBox.y2+x,A=n.getFromEnv("yAxis"),S=n.getFromEnv("xAxis");k<c&&(b+=c-k),y>d&&(b-=y-d),C<u&&(x+=u-C),w>h&&(x-=w-h),m.draged=!0,this.attr({x:v.x+b,y:v.y+x}),a=r.ox+b,o=r.oy+x,f.attr({x:r.ox+b,y:r.oy+x}),g.config.x=S.getValue(a),g.config.y=A.getValue(o),this.data("fire_dragend")||(l.plotEventHandler(this,e,"LabelDragStart"),this.data("fire_dragend",1)),this.data("fire_click_event")&&(this.data("fire_click_event",0),p.clearLongPress())},a._labelDragUp=function(e){var t=this.data("drag-options"),a=t.index,o=t.dataset,r=o.getFromEnv("chart"),i=r.getChildren("xAxis")[0],l=r.getChildren("yAxis")[0],s=o.getLinkedParent(),c=o.components.data[a].dragStart,d=this.data("eventArgs");d.x=i.getValue(this.attr("x")),d.y=l.getValue(this.attr("y")),c.draged=!1,this.data("fire_dragend")&&(r.fireChartInstanceEvent("chartupdated",(0,n.extend2)({sourceEvent:"labeldragend"},d),e),r.fireChartInstanceEvent("chartupdated",d,e),r.plotEventHandler(this,e,"labeldragend")),s.clearLongPress()},a.removeData=function(e,t){var a=this.components,o=a.data;a.removeDataArr=o.splice(e,t)},a.trimData=function(e){if(this.config.JSONData){var t=this.config.JSONData,a=t&&t.length,o=e.label&&e.label.length||0,r=a-o;r>0&&this.removeData(o,r)}},t}(i["default"]);t["default"]=h},1008:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.dragNodeLabels":function(){return{"group.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}]}}}}},1009:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(1005)),n=a(224),l=a(232),s=o(a(1010)),c=n.preDefStr.EVENTARGS,d=n.preDefStr.configStr,h=function(e){var t,a=e.config,o=a.fromPointObj,r=a.toPointObj,i=a.fromX,l=a.fromY,s=a.toX,c=a.toY,d=["M",i,l];return a.arrowAtStart&&(d=(t=o.config).shapeType===n.SHAPE_RECT?d.concat(p._drawArrow(i,l,s,c,t.shapeArg.width,t.shapeArg.height)):d.concat(p._drawArrow(i,l,s,c,t.shapeArg.radius))),a.arrowAtEnd&&(d=(t=r.config).shapeType===n.SHAPE_RECT?d.concat(p._drawArrow(s,c,i,l,t.shapeArg.width,t.shapeArg.height)):d.concat(p._drawArrow(s,c,i,l,t.shapeArg.radius))),d.push("L",s,c),d},u=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:e},container:t,component:a,label:"group"})};(0,l.addDep)({name:"connectorAnimation",type:"animationRule",extension:s["default"]});var p=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"dragNodeConnector"},a._setDatasetIndex=function(){var e=this.getLinkedParent().getChildren("connector");this.config.datasetIndex=e.indexOf(this)},a.configureAttributes=function(e){if(e)this.trimData(e),this.config.JSONData=e;else if(!e&&!this.config.JSONData)return!1;var t,a=this.getFromEnv("chart-attrib"),o=this.config,r=this.config.JSONData,i=r.connector,l=i&&i.length,s=n.HUNDREDSTRING;for(o.connectorsTooltext=(0,n.getValidValue)((0,n.parseUnsafeString)((0,n.pluck)(r.connectortooltext,a.connectortooltext),!1)),o.stdThickness=(0,n.pluckNumber)(r.stdthickness,1),o.conColor=(0,n.getFirstColor)((0,n.pluck)(r.color,"FF5904")),o.conAlpha=(0,n.pluck)(r.alpha,s),o.conDashGap=(0,n.pluckNumber)(r.dashgap,5),o.conDashLen=(0,n.pluckNumber)(r.dashlen,5),o.conDashed=Boolean((0,n.pluckNumber)(r.dashed,0)),o.arrowAtStart=Boolean((0,n.pluckNumber)(r.arrowatstart,1)),o.arrowAtEnd=Boolean((0,n.pluckNumber)(r.arrowatend,1)),o.conStrength=(0,n.pluckNumber)(r.strength,1),o.toolTipSepChar=(0,n.pluck)(a.tooltipsepchar," - "),o.showTooltip=(0,n.pluckNumber)(a.showtooltip,1),o.showTextOutline=(0,n.pluckNumber)(a.textoutline,0),o.viewMode=(0,n.pluckNumber)(a.viewmode,1),o._refreshData=!0,this._setDatasetIndex("connector"),t=0;t<l;t+=1)this._setConfigure(t,i[t]);o._refreshData=!0},a._setConfigure=function(e,t){var a,o,r,i=this.components.data||(this.components.data=[]),l=i[e]||(i[e]=i[e]={}),s=this.config,c=(0,n.parseUnsafeString)((0,n.pluck)(t.label,t.name)),d=(0,n.pluck)(t.alpha,s.conAlpha),h=this.getFromEnv("smartLabel"),u="$fromLabel"+s.toolTipSepChar+"$toLabel",p={FCcolor:{color:(0,n.getFirstColor)((0,n.pluck)(t.color,s.conColor)),alpha:d}},g=s.connectorsTooltext,f=(0,n.getValidValue)((0,n.parseUnsafeString)((0,n.pluck)(t.tooltext,g),!1)),m=Boolean((0,n.pluckNumber)(t.dashed,s.conDashed));h.setStyle(this.getFromEnv("dataLabelStyle")),h.useEllipsesOnOverflow(this.getFromEnv("chartConfig").useEllipsesWhenOverflow),r=h.getOriSize(c),o=l.config=l.config||(l.config={}),!l.graphics&&(l.graphics={}),a=!!s.showTooltip&&(0,n.pluck)(f,c?"$label":u),(o=l.config={_options:t,id:(0,n.pluck)(t.id,e).toString(),from:(0,n.pluck)(t.from,n.BLANK),to:(0,n.pluck)(t.to,n.BLANK),label:c,toolText:a,customToolText:f,color:p,index:e,dashStyle:m?(0,n.getDashStyle)((0,n.pluckNumber)(t.dashlen,s.conDashLen),(0,n.pluckNumber)(t.dashgap,s.conDashGap)):n.DASH_DEF,dashed:t.dashed,dashlen:t.dashlen,dashgap:t.dashgap,arrowAtStart:Boolean((0,n.pluckNumber)(t.arrowatstart,s.arrowAtStart)),arrowAtEnd:Boolean((0,n.pluckNumber)(t.arrowatend,s.arrowAtEnd)),conStrength:(0,n.pluckNumber)(t.strength,s.conStrength),link:t.link,stdThickness:s.stdThickness,labelWidth:r.widht,labelHeight:r.height}).datasetIndex=this.config.datasetIndex,o.add=t.add,o.update=t.update,o.dataLabelStyle=this._configureDataLabelStyle(t),s._refreshData&&delete l.removed},a.createContainer=function(){var e=this.getLinkedParent().getChildContainer();!this.getContainer("connectorGroup")&&this.addContainer("connectorGroup",u("connectorGroup",e.connectorGroup,this)),!this.getContainer("connectorDataLabelGroup")&&this.addContainer("connectorDataLabelGroup",u("connectorDataLabelGroup",e.connectorGroup,this))},a.draw=function(){var e,t,a,o,r,i,n,l=this.getLinkedParent(),s=this.config,c=this.components.data,d=this.getFromEnv("dataLabelStyle"),h=c.length,u=this.components.removeDataArr||[],p=u.length;for(this.createContainer(),s.cleared=!1,this.getContainer("connectorDataLabelGroup").css(d),i=0;i<h;i++)t=(n=(e=c[i]).config).from,a=n.to,o=l.getNode(t),r=l.getNode(a),o&&r&&!0!==n.deleted&&this.drawConnector(e,o,r,i);for(this.config.drawn=!0,i=0;i<p;i++)this._removeDataVisuals(u.shift())},a.parsePlotAttributes=function(e,t,a){var o,r,i,l,s,c,d,u,p,g,f,m,v=this.getFromEnv("number-formatter"),b=e.config,x=b.eventArgs||(b.eventArgs={});b.fromPointObj=t,b.toPointObj=a,p=t.config,g=a.config,b.fromX=o=p._xPos,b.fromY=i=p._yPos,b.toX=r=g._xPos,b.toY=l=g._yPos,b._labelX=(o+r)/2,b._labelY=(i+l)/2,b.strokeWidth=s=b.conStrength*b.stdThickness,f=b.color,b.textBgColor=f&&f.FCcolor&&f.FCcolor.color,x.label=b.label,x.arrowAtStart=b.arrowAtStart,x.arrowAtEnd=b.arrowAtEnd,x.link=b.link,x.id=b.id,x.fromNodeId=p.id,x.toNodeId=g.id,b.toolText=(0,n.parseTooltext)(b.toolText,[3,83,84,85,86,87,88,89,90,91,92],{label:b.label,fromXValue:v.dataLabels(t.config.x),fromYValue:v.dataLabels(t.config.y),fromXDataValue:t.config.x,fromYDataValue:t.config.y,fromLabel:(0,n.pluck)(t.config.displayValue,t.config.id),toXValue:v.dataLabels(a.config.x),toYValue:v.dataLabels(a.config.y),toXDataValue:a.config.x,toYDataValue:a.config.y,toLabel:(0,n.pluck)(a.config.displayValue,a.config.id)}),p=t.config,g=a.config,d=p.startConnectors||(p.startConnectors={}),u=g.endConnectors||(g.endConnectors={}),d[m=e.config.id+"-"+p.id+"-"+g.id]=e,u[m]=e,c=h(e),b.props={element:{attr:{path:c,"stroke-width":s,"stroke-dasharray":b.dashStyle,cursor:b.link?n.POINTER:n.BLANKSTRING,stroke:(0,n.toRaphaelColor)(f)}}}},a.allocatePosition=function(){var e,t,a,o,r,i,n,l=this.getLinkedParent(),s=this.components.data,c=s.length;for(e=0;e<c;e++)o=(a=(t=s[e]).config).from,r=a.to,i=l.getNode(o),n=l.getNode(r),i&&n&&!0!==a.deleted&&this.parsePlotAttributes(t,i,n,e)},a.drawConnector=function(e){var t,a,o=this.getFromEnv("toolTipController"),r=this.getFromEnv("animationManager"),i=e.graphics,n=this.getContainer("connectorGroup"),l=e.config,s=l.toolText,h=l.eventArgs||(l.eventArgs={}),u=this.config,p=this.components.pool||{};e.removed||(t=a=i.graphic,i.graphic||p.graphic&&p.graphic.path&&p.graphic.path.length&&(a=i.graphic=p.graphic.path.shift()),t=r.setAnimation({el:a||"path",container:n,attr:l.props.element.attr,label:"path",component:this}),a||(i.graphic=t,t.on("fc-mousedown",this.mouseDown).on("fc-mousemove",this.mousemove).on("fc-mouseup",this.mouseup).hover(this.hoverIn,this.hoverOut)),t.show().data(c,h).data("viewMode",u.viewMode).data(d,l).data("dataset",this),u.showTooltip?o.enableToolTip(t,s):o.disableToolTip(t),this.drawLabel(e))},a.drawLabel=function(e){var t,a,o,r,i,l,s,h,u,p,g,f,m=this,v=m.getFromEnv("toolTipController"),b=m.config,x=m.getFromEnv("animationManager"),k=m.getContainer("connectorDataLabelGroup"),y=m.getFromEnv("dataLabelStyle"),C=m.components.data,w=m.components.pool||{},A=C.length,S=function(e){t=e.config,o=t.toolText,h=e.graphics,a=t.label,p=t._labelX,g=t._labelY,i=t.dataLabelStyle||y,f=t.textBgColor,a?(s=h.text=h.text||w.element&&w.element.text&&w.element.text.shift(),r={text:a,fill:i.color,direction:n.BLANKSTRING,cursor:t.link?n.POINTER:n.BLANKSTRING,"text-bound":[(0,n.pluck)(i.backgroundColor,f),(0,n.pluck)(i.borderColor,f),1,"2"],x:p,y:g},(l=x.setAnimation({el:s||"text",attr:r,container:k,label:"text",component:m})).show(),l.outlineText(b.showTextOutline,r.fill),s||(h.text=l,l.on("fc-mousedown",m.mouseDown).on("fc-mousemove",m.mousemove).on("fc-mouseup",m.mouseup).hover(m.hoverIn,m.hoverOut)),l.data(c,t.eventArgs).data("viewMode",b.viewMode).data(d,t).data("dataset",m),b.showTooltip?v.enableToolTip(l,o):v.disableToolTip(l)):h.text&&h.text.hide()};if(e)S(e);else for(u=0;u<A;u++)S(C[u])},a.mouseDown=function(){var e=this.data("dataset").getLinkedParent();e.clearLongPress(),this.data("fire_click_event",1),e.triggerConnectorUI(this)},a.mousemove=function(){var e=this.data("dataset").getLinkedParent();this.data("fire_click_event",0),e.clearLongPress()},a.mouseup=function(){this.data("dataset").getLinkedParent().clearLongPress()},a.hoverIn=function(e){this.data("dataset").getFromEnv("chart").plotEventHandler(this,e,"ConnectorRollover")},a.hoverOut=function(e){this.data("dataset").getFromEnv("chart").plotEventHandler(this,e,"ConnectorRollout")},t._drawArrow=function(e,t,a,o,r,i){var n,l,s,c,d=(t-o)/(e-a),h=Math.atan(d),u=[];return h<0&&(h=2*Math.PI+h),o>t?(a>=e&&h>Math.PI||a<e&&h>Math.PI)&&(h-=Math.PI):(a>=e&&h<Math.PI&&0!==h||a<e&&h<Math.PI)&&(h+=Math.PI),void 0===i?(n=e+r*Math.cos(h),l=t+r*Math.sin(h)):(s=Math.abs(r)/2,c=Math.abs(i)/2,n=e+(s=e<a?s:-s),l=t+s*Math.tan(h),Math.abs(t-l)>Math.abs(c)&&(l=t+(c=t<o?c:-c),n=e+c/Math.tan(h))),u.push("L",n,l,n+10*Math.cos(h+.79),l+10*Math.sin(h+.79),"M",n+10*Math.cos(h-.79),l+10*Math.sin(h-.79),"L",n,l),u},a.removeData=function(e,t){var a=e,o=this.components,r=o.data;a<0&&(a=0),o.removeDataArr=r.splice(a,t)},a.trimData=function(e){if(this.config.JSONData){var t=this.components,a=t.data&&t.data.length,o=e.connector&&e.connector.length||0,r=a-o;r>0&&this.removeData(o,r)}},t}(i["default"]),g=p;t["default"]=g},1010:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.dragNodeConnector":function(){return{"path.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}]},"text.appearing":function(){return[{initialAttr:{opacity:0,"text-bound":"none"},finalAttr:{opacity:1},slot:"final"}]},"*":null}}}},1011:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r,i,n,l,s=o(a(242)),c=o(a(238)),d=a(240),h=o(a(1007)),u=a(224),p={circle:"circ",rectangle:"rect",polygon:"poly"},g=u.preDefStr.INPUT,f=u.preDefStr.BLANKSPACE,m=u.preDefStr.BLANK,v=u.preDefStr.PX,b=u.preDefStr.LABEL,x=u.preDefStr.DATASET,k=u.preDefStr.COMMA,y="appearing",C=function(e){for(var t in e)e[t].remove()},w=function(e){return e!==r&&null!==e},A=function(e,t){switch(e.shape){case u.preDefStr.CIRCLE:e.radius=t.radius;break;case u.preDefStr.POLYGON:e.radius=t.radius,e.sides=t.numsides;break;default:e.width=t.width,e.height=t.height}},S=(i=function(){for(var e,t=this.getGraphicalElement("cacheUpdateUI"),a=t.fields.shape,o=["rectWidth","rectHeight","circPolyRadius","polySides"],r=o.length;r--;)/rect|poly|circ/gi.test(e=o[r])&&(t.labels[e].hide(),t.fields[e].hide()),new RegExp((0,u.pluck)(a.val(),"rect"),"ig").test(e)&&(t.labels[e].show(),t.fields[e].show())},n=function(){var e=this.getGraphicalElement("cacheUpdateUI").fields,t=(0,u.getValidColor)(e.color.val());t&&e.colorOut.css({background:(0,u.parseColor)(t)})},l=function(e){var t,a,o,r=this.getGraphicalElement("cacheUpdateUI"),i=this.getFromEnv("animationManager"),n=this.getFromEnv("chartConfig").height,l=r.fields.image.val(),s=["imgWidth","imgHeight","imgAlign","imgUrl"];for(t=l?250:215,e&&(r.ok.hide(),r.cancel.hide(),r.removeItem.hide(),r.error.hide()),a=s.length;!l&&a--;)o=s[a],r.labels[o].hide(),r.fields[o].hide();e&&i.setAnimationState("uichange"),i.setAnimation({el:r.dialog,state:"updating",attr:{top:(n-t)/2,height:t},component:this,label:"uidialog",callback:function(){for(a=s.length;a--&&l;)o=s[a],r.labels[o].show(),r.fields[o].show();r.ok.attr({y:t-23-5}).show(),r.cancel.attr({y:t-23-5}).show(),r.removeItem.attr({y:t-23-5}),r.error.attr({y:t-23-5+4}).show(),r.edit?r.removeItem.show():r.removeItem.hide()}})},function(e,t){var a,o,s=this,c=s.getGraphicalElement("cacheUpdateUI"),d=s.getFromEnv("paper"),h={width:80+v,border:"1px solid #cccccc",fontSize:10+v,lineHeight:15+v,padding:2+v,fontFamily:(s.getFromEnv("style").inCanvasStyle||{}).fontFamily},p={textAlign:"right"},g=c&&c.fields,f=c&&c.labels;s.getFromEnv("animationManager").setAnimationState("uichange"),c||(a=!0),c=s.addGraphicalElement("cacheUpdateUI",s.createHtmlDialog(350,215,(function(e){e.stopPropagation();var t,a,o,i=c&&c.fields,n=c.edit;if(g){switch(o={x:(0,u.getFirstValue)(g.x.val(),s.getFromEnv("xAxis").getLimit().min),y:(0,u.getFirstValue)(g.y.val(),s.getFromEnv("yAxis").getLimit().min),id:a=g.id.val(),datasetId:g.dataset.val(),name:g.label.val(),tooltext:g.tooltip.val(),color:g.color.val(),alpha:g.alpha.val(),labelalign:g.labelalign.val(),allowdrag:g.draggable.val(),imagenode:g.image.val(),imagewidth:g.imgWidth.val(),imageheight:g.imgHeight.val(),imagealign:g.imgAlign.val(),imageurl:g.imgUrl.val(),link:g.link.val()},i.shape.val()){case"circ":o.shape=u.preDefStr.CIRCLE,o.radius=g.circPolyRadius.val();break;case"poly":o.shape=u.preDefStr.POLYGON,o.radius=g.circPolyRadius.val(),o.numsides=g.polySides.val();break;default:o.shape=u.preDefStr.RECTANGLE,o.width=g.rectWidth.val(),o.height=g.rectHeight.val()}if(s.getNode(o.id)&&(t=!0),!t||n!==r)return void(((a=o.datasetId)!==u.BLANKSTRING||n)&&(a=Number(a),n?s.updateNode(o):s.addNode(o),c.hide(),c.visible=!1));c.error.attr({text:"ID already exist."}),g.label.focus()}c.enableFields()}),(function(e){e.stopPropagation(),c.hide(),c.visible=!1,c.enableFields(),c.error.attr({text:m}),c.visible=!1}),(function(e){e.stopPropagation(),s.deleteNode(c.fields.id.val()),c.hide(),c.visible=!1}),c)),a&&(o=c.dialog,f=c.labels={},g=c.fields={}),c.config=e,c.edit=t,c.error||(c.error=d.html("span",{color:"ff0000",x:30,y:228},r,o)),c.enableFields||(c.enableFields=function(){var t;for(t in e)e[t]&&e[t].disabled&&g[t]&&g[t].element.removeAttribute("disabled")}),c.clearFields||(c.clearFields=function(){var e;for(e in c.fields)g[e].element.disabled||(g[e].element.value=u.BLANKSTRING)}),(0,u.fcEach)(this.nodeUpdateUIDefinition,(function(t){var a,r,v,x=t.key,k={},y=e[x]||{};!f[x]&&(f[x]=d.html(b,{x:t.x,y:t.y,width:t.labelWidth||45,text:t.text},p,o)),t.noInput||((a=g[x])||(h.border="checkbox"===t.type?m:"1px solid #cccccc",a=g[x]=d.html(t.inputType||"input",{x:t.labelWidth&&t.labelWidth+5||50,y:-2+(t.inputPaddingTop||0),width:t.inputWidth||50,name:x||u.BLANKSTRING},h),"select"!==t.inputType&&a.attr({type:t.type||"text"}).on("keyup",c.handleKeyPress),a.add(f[x])),w(r=(0,u.getFirstValue)(y.innerHTML,t.innerHTML))&&(k.innerHTML=r),y.disabled?k.disabled="disabled":a.element&&(a.element.disabled=!1),a.attr(k),w(v=(0,u.getFirstValue)(y.value,t.value))&&a.val(v),"shape"===x&&a.on("change",(function(){i.call(s)})),"image"===x&&a.on("fc-click",(function(){l.call(s,!0)})),"color"===x&&a.on("keyup",(function(){n.call(s)})))})),n.call(this),l.call(this),i.call(this),c.visible=!0,c.fields[t?b:"id"].focus()}),N=function(e){function t(){var t;t=e.call(this)||this;var a=(0,s["default"])(t);return a.setState("visible",!0),a.connectorUpdateUIDefinition=[{key:"fromid",text:"Connect From",inputType:"select",x:10,y:15,labelWidth:80,inputWidth:100},{key:"toid",text:"Connect To",inputType:"select",x:10,y:40,labelWidth:80,inputWidth:100},{key:"arratstart",text:"Arrow At Start",x:200,y:15,type:"checkbox",inputPaddingTop:3,labelWidth:80,inputWidth:15},{key:"arratend",text:"Arrow At End",x:200,y:40,type:"checkbox",inputPaddingTop:3,labelWidth:80,inputWidth:15},{key:b,text:"Label",x:10,y:75,labelWidth:40,inputWidth:120},{key:"id",text:"Node ID",x:190,y:75,inputWidth:55},{key:"color",text:"Color",x:10,y:100,labelWidth:40,inputWidth:35},{key:"alpha",text:"Alpha",x:110,y:100,inputWidth:25,labelWidth:35},{key:"strength",text:"Strength",x:190,y:100,inputWidth:55,val:"0.1"},{key:"url",text:"Link",x:10,y:125,labelWidth:40,inputWidth:120},{key:"tooltext",text:"Tooltip",x:190,y:125,labelWidth:40,inputWidth:60},{key:"dashed",text:"Dashed",x:10,y:150,type:"checkbox",inputPaddingTop:3,inputWidth:15,labelWidth:40},{key:"dashgap",text:"Dash Gap",x:85,y:150,labelWidth:60,inputWidth:25},{key:"dashlen",text:"Dash Length",x:190,y:150,labelWidth:70,inputWidth:30}],a.nodeUpdateUIDefinition=[{key:"id",text:"Id",inputWidth:60,x:10,y:15},{key:x,text:x,inputType:"select",inputWidth:110,innerHTML:r,x:170,y:15},{key:"x",text:"Value",x:10,y:40,inputWidth:21},{key:"y",text:k,x:88,y:40,inputWidth:21,labelWidth:5},{text:"(x, y)",x:125,y:40,labelWidth:33,noInput:!0},{key:"tooltip",text:"Tooltip",inputWidth:105,x:170,y:40},{key:b,text:"Label",inputWidth:92,x:10,y:65},{key:"labelalign",text:"Align",labelWidth:70,inputWidth:110,inputType:"select",innerHTML:'<option></option><option value="top">Top</option><option value="middle">Middle</option><option value="bottom">Bottom</option>',x:145,y:63},{key:"color",text:"Color",x:10,y:90,inputWidth:60},{key:"colorOut",innerHTML:"&nbsp;",x:85,y:90,inputWidth:15,inputType:"span"},{key:"alpha",text:"Alpha",x:170,y:90,inputWidth:20},{key:"draggable",text:"Allow Drag",value:!0,inputWidth:20,x:250,y:90,labelWidth:58,inputPaddingTop:3,type:"checkbox"},{key:"shape",text:"Shape",inputType:"select",inputWidth:97,innerHTML:'<option value="rect">Rectangle</option><option value="circ">Circle</option><option value="poly">Polygon</option>',x:10,y:115},{key:"rectHeight",text:"Height",x:170,y:115,inputWidth:20},{key:"rectWidth",text:"Width",x:255,y:115,inputWidth:20},{key:"circPolyRadius",text:"Radius",x:170,y:115,inputWidth:20},{key:"polySides",text:"Sides",x:255,y:115,inputWidth:20},{key:"link",text:"Link",x:10,y:140,inputWidth:92},{key:"image",text:"Image",type:"checkbox",inputPaddingTop:4,inputWidth:20,x:10,y:170},{key:"imgUrl",text:"URL",inputWidth:105,x:170,y:170},{key:"imgWidth",text:"Width",inputWidth:20,x:10,y:195},{key:"imgHeight",text:"Height",inputWidth:20,x:82,y:195},{key:"imgAlign",text:"Align",inputType:"select",inputWidth:75,innerHTML:'<option value="top">Top</option><option value="middle">Middle</option><option value="bottom">Bottom</option>',x:170,y:195}],a.labelUpdateUIDefinition=[{key:b,text:"Label*",x:10,y:15,inputWidth:235},{key:"size",text:"Size",x:10,y:40},{key:"padding",text:"Padding",x:10,y:65},{key:"x",text:"Position",x:120,y:65,labelWidth:70,inputWidth:25},{key:"y",text:k,x:225,y:65,labelWidth:10,inputWidth:25},{key:"xy",text:"(x, y)",x:260,y:65,noInput:!0},{key:"allowdrag",text:"Allow Drag",x:120,y:40,inputType:"checkbox",inputPaddingTop:3,inputWidth:15,labelWidth:70,val:1},{key:"color",text:"Color",x:10,y:90},{key:"alpha",text:"Alpha",x:145,y:90,inputWidth:30,val:u.preDefStr.HUNDREDSTRING},{key:"bordercolor",text:"Border Color",x:10,y:125,labelWidth:100},{key:"bgcolor",text:"Background Color",x:10,y:150,labelWidth:100}],t}(0,c["default"])(t,e);var a=t.prototype;return a.configure=function(){this.setState("configured",!0)},a.getType=function(){return"group"},a.getName=function(){return"dragNodeGroup"},a.showLabelUpdateUI=function(e){void 0===e&&(e={});var t,a,o,i,n=this,l=n.getFromEnv("paper"),s=n.getGraphicalElement("cacheLabelUpdateUI"),c={border:"1px solid #cccccc",fontSize:10+v,lineHeight:15+v,fontFamily:(n.getFromEnv("style").inCanvasStyle||{}).fontFamily,padding:2+v},d={textAlign:"right"},h=s&&s.fields,p=s&&s.labels;n.getFromEnv("animationManager").setAnimationState("uichange"),s||(t=!0),s=n.addGraphicalElement("cacheLabelUpdateUI",n.createHtmlDialog(315,205,(function(){var e,t=s&&s.fields;t&&((e={text:t.label.val(),x:t.x.val(),y:t.y.val(),color:t.color.val(),alpha:t.alpha.val(),bgcolor:t.bgcolor.val(),bordercolor:t.bordercolor.val(),fontsize:t.size.val(),allowdrag:t.allowdrag.val(),padding:t.padding.val()}).text?(n.addLabel&&n.addLabel(e),s.hide()):(s.error.attr({text:"Label cannot be blank."}),h.label.focus()))}),(function(){s.error.attr({text:u.BLANKSTRING}),s.hide()}),r,s)),t&&(i=s.dialog,p=s.labels={},h=s.fields={}),(0,u.fcEach)(n.labelUpdateUIDefinition,(function(t){var r=t.key;p[r]||(p[r]=l.html(b,{x:t.x,y:t.y,width:t.labelWidth||45,text:t.text},d,i)),t.noInput||((a=h[r])||(a=h[r]=l.html(g,{y:-2+(t.inputPaddingTop||0),x:t.labelWidth&&t.labelWidth+5||50,width:t.inputWidth||50,type:t.inputType||"text",name:r||u.BLANKSTRING},c,p[r]).on("keyup",s.handleKeyPress)),w(o=(0,u.getFirstValue)(e[r],t.val))&&a.val(o))})),s.error||(s.error=l.html("span",{color:"ff0000",x:10,y:180},r,i)),s.fields.label.focus()},a.restoreData=function(){var e,t,a,o,r,i,n,l=this.getChildren("dataset"),s=this.getFromEnv("chart"),c=(0,u.pluckNumber)(s.config.showlegend,0),d=this.getChildren("connector"),h=s.getFromEnv("dataSource"),p=this.getChildren("labels"),g=function(e){var t,a;for(t=0;t<(e&&e.length);t++)if(delete(o=e[t]).removed,o.config.add){for(a in r=e[t].graphics)r[a].remove();e.splice(t,1),t--}},f=function(e,o,r){t=o[e],a=t.components.data,g(a),t.drawn=!1,t.configure(r[e])};for(e=0,n=l&&l.length;e<n;e++)f(e,l,h.dataset);for(e=0,n=d&&d.length;e<n;e++)f(e,d,h.connectors);p&&p.length&&(i=p[0],(a=i.components.data)&&g(a),i.configure(h.labels)),s.fireChartInstanceEvent("dataRestored"),this.asyncDraw(),c&&this.getFromEnv("legend").asyncDraw()},a.addLabel=function(e){var t,a,o=this.getChildren("labels"),r=this.getFromEnv("chart");e.add=!0,o&&o[0]?o=o[0]:((0,u.componentFactory)(this,h["default"],"labels",1,[{}]),o=this.getChildren("labels")[0]),a=(o.components.data||(o.components.data=[])).length,o._setConfigure(a,e),t={text:e.text,x:e.x,y:e.y,allowdrag:e.allowdrag,sourceType:"labelnode",link:e.link},r.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"labeladded"},t)),r.fireChartInstanceEvent("labeladded",t),o.asyncDraw()},a.showNodeAddUI=function(){var e,t,a,o=this.getChildren("dataset"),i=u.BLANKSTRING;for(a=0;a<o.length;a++)e=(t=o[a]||{}).config,"dragNode"===t.getName()&&(i+='<option value="'+t.config.datasetIndex+'">'+(e.name!==m&&e.name!==r&&e.name+u.COMMASTRING+f||m)+t.config.datasetIndex+"</option>");this.showNodeUpdateUI({dataset:{innerHTML:i}})},a.showConnectorAddUI=function(){var e,t,a=this.getNode(),o=u.BLANKSTRING;for(t in a)o+='<option value="'+(e=a[t].config.id)+'">'+e+"</option>";this.showConnectorUpdateUI({fromid:{innerHTML:o},toid:{innerHTML:o}})},a.showConnectorUpdateUI=function(e,t){var a,o,i,n,l,s=this,c=s.getFromEnv("paper"),d="cacheConnectorUpdateUI"+(t?"edit":"new"),h=s.getGraphicalElement(d),p={border:"1px solid #cccccc",fontSize:10+v,lineHeight:15+v,fontFamily:(s.getFromEnv("style").inCanvasStyle||{}).fontFamily,padding:2+v},f={textAlign:"right"},m=h&&h.fields,x=h&&h.labels;s.getFromEnv("animationManager").setAnimationState("uichange"),h||(a=!0),h=s.addGraphicalElement(d,s.createHtmlDialog(315,215,(function(){var e,a=h&&h.fields;a&&((e={from:a.fromid.val(),to:a.toid.val(),id:a.id.val(),label:a.label.val(),color:a.color.val(),alpha:a.alpha.val(),link:a.url.val(),tooltext:a.tooltext.val(),strength:a.strength.val(),arrowatstart:a.arratstart.val(),arrowatend:a.arratend.val(),dashed:a.dashed.val(),dashlen:a.dashlen.val(),dashgap:a.dashgap.val()}).from?e.to?e.from!==e.to?(t?s.editConnector(e):s.addConnector(e),h.enableFields(),h.hide(),h.clearFields()):(h.error.attr({text:"Connector cannot start and end at the same node!"}),m.fromid.focus()):(h.error.attr({text:"Please select a valid connector end."}),m.toid.focus()):(h.error.attr({text:"Please select a valid connector start."}),m.fromid.focus()))}),(function(){h.error.attr({text:u.BLANKSTRING}),h.enableFields(),h.hide()}),(function(){var e=h&&h.fields;s.deleteConnector({from:e.fromid.val(),to:e.toid.val(),id:e.id.val()}),h.hide()}),h)),a&&(l=h.dialog,x=h.labels={},m=h.fields={}),h.config=e,h.enableFields||(h.enableFields=function(){var t;for(t in e)e[t]&&e[t].disabled&&m[t]&&m[t].element.removeAttribute("disabled")}),h.clearFields||(h.clearFields=function(){var e,t=h.fields;for(e in t)t[e].element.disabled||(t[e].element.value=u.BLANKSTRING)}),(0,u.fcEach)(s.connectorUpdateUIDefinition,(function(t){var a=t.key,s=e[a]||{};x[a]||(x[a]=c.html(b,{x:t.x,y:t.y,width:t.labelWidth||45,text:t.text},f,l)),t.noInput||((i=m[a])||(i=m[a]=c.html(t.inputType||g,{y:-2+(t.inputPaddingTop||0),x:t.labelWidth&&t.labelWidth+5||50,width:t.inputWidth||50,name:a||u.BLANKSTRING},p),"select"!==t.inputType&&i.attr({type:t.type||"text"}).on("keyup",h.handleKeyPress),i.add(x[a])),(o=(0,u.pluck)(s.innerHTML,t.innerHTML))&&i.attr({innerHTML:o}),(n=(0,u.pluck)(s.val,t.val))!==r&&i.val(n),s.disabled?i.attr({disabled:"disabled"}):i.element&&(i.element.disabled=!1))})),h.checkDash=function(){var e=m.dashed&&m.dashed.val()?"show":"hide";x.dashgap&&x.dashgap[e](),m.dashgap&&m.dashgap[e](),x.dashlen&&x.dashlen[e](),m.dashlen&&m.dashlen[e]()},h.checkDash(),m.dashed.on("fc-click",h.checkDash),h.error||(h.error=c.html("span",{color:"ff0000",x:10,y:170},r,l)),h.removeItem[t?"show":"hide"]()},a.showNodeUpdateUI=function(){return S.apply(this,arguments)},a.addNode=function(e){var t,a,o,i,n,l,s,c=this.getChildren("dataset"),d=c.length,h=this.getFromEnv("chart");for(n=0;n<d;n++)if((i=(t=c[n]||{}).config.datasetIndex)!==r&&(i=i.toString()),i===e.datasetId){o=!0;break}t&&o&&(s=t.components.data,e.add=!0,l={index:a=s.length,dataIndex:a,link:e.link,y:e.y,x:e.x,shape:e.shape,label:e.name,toolText:e.tooltext,id:e.id,datasetIndex:t.config.datasetIndex,datasetName:t.config.seriesname,sourceType:"dataplot"},A(l,e),t._setConfigure(a,e),t.parsePlotAttributes(a),t._drawNode(a),t.setState("dirty",!0),h.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"nodeAdded"},l)),h.fireChartInstanceEvent("nodeAdded",l),t._setupKdTree())},a.updateNode=function(e){var t,a,o,r,i,n,l,s=this.getChildren("dataset"),c=s.length,d=this.getFromEnv("chart");for(e.update=!0,r=0;r<c;r++)for(t=(i=(o=s[r]).components.data||[]).length,l=0;l<t;l++)if(i[l].config.id===e.id){a=!0;break}o&&a&&(n={index:l,dataIndex:l,link:e.link,y:e.y,x:e.x,shape:e.shape,label:e.name,toolText:e.tooltext,id:e.id,datasetIndex:o.config.datasetIndex,datasetName:o.config.seriesname,sourceType:"dataplot"},A(n,e),o._setConfigure(l,e),o.parsePlotAttributes(l),o._drawNode(l),o.setState("dirty",!0),d.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"nodeupdated"},n)),d.fireChartInstanceEvent("nodeupdated",n),o._setupKdTree())},a.deleteNode=function(e){var t,a,o,r,i,n,l,s,c,d,h,p,g,f=this.getNode(e),m=this.getFromEnv("chart");if(f){for(a=(t=f.dataset).components.data,o=f.config.startConnectors,r=f.config.endConnectors,d=a.length,i=0;i<d;i++)if((s=a[i]).config.id===e){g=!0;break}if(!0===g){for(c in n=s.graphics,C(n),o)n=(l=o[c]||{}).graphics,C(n),delete l.graphics,l.removed=!0;for(c in r)n=(l=r[c]||{}).graphics,C(n),delete l.graphics,l.removed=!0;s.removed=!0,h={index:i,dataIndex:i,link:(p=s.config||{}).link,y:p.y,x:p.x,shape:p.shape,label:p.displayValue,toolText:p.toolText,id:p.id,datasetIndex:t.config.datasetIndex,datasetName:t.config.seriesname,sourceType:"dataplot"},A(h,{width:p.width,height:p.height,radius:p.radius,numsides:p.numSides}),m.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"nodedeleted"},h)),m.fireChartInstanceEvent("nodedeleted",h),t._setupKdTree()}}},a.addConnector=function(e){var t,a=this.getChildren("connector")[0],o=this.getFromEnv("chart");e.add=!0,a._setConfigure(a.components.data.length,e),t={arrowAtEnd:Boolean(e.arrowatend),arrowAtStart:Boolean(e.arrowatstart),fromNodeId:e.from,id:e.id,label:e.label,link:e.connectorLink,sourceType:"connector",toNodeId:e.to},o.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"connectoradded"},t)),o.fireChartInstanceEvent("connectoradded",t),a.asyncDraw()},a.editConnector=function(e){var t,a,o,r,i,n,l,s,c,d,h=this.getChildren("connector"),p=this.getFromEnv("chart"),g=h.length;for(t=0;t<g;t++)for(a=(o=(s=h[t])&&s.components.data||[]).length,n=0;n<a;n++)if(r=(c=o[n].config).from,i=c.to,r===e.from&&i===e.to){l=!0;break}e.update=!0,l&&(s._setConfigure(n,e),d={arrowAtEnd:Boolean(e.arrowatend),arrowAtStart:Boolean(e.arrowatstart),fromNodeId:e.from,id:e.id,label:e.label,link:e.link,sourceType:"connector",toNodeId:e.to},p.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"connectorupdated"},d)),p.fireChartInstanceEvent("connectorupdated",d),s.asyncDraw())},a.deleteConnector=function(e){var t,a,o,r,i,n,l,s=this.getChildren("connector"),c=!1,d=s.length,h=this.getFromEnv("chart");for(t=0;t<d;t++)for(i=(r=s[t].components.data).length,a=0;a<i;a++)if((o=r[a]).config.from===e.from&&o.config.to===e.to){c=!0;break}c&&(n={arrowAtEnd:(l=o.config||{}).arrowAtEnd,arrowAtStart:l.arrowAtStart,fromNodeId:l.from,id:l.id,label:l.label,link:l.connectorLink,sourceType:"connector",toNodeId:l.to},C(o.graphics),delete o.graphics,o.removed=!0,h.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"connectordeleted"},n)),h.fireChartInstanceEvent("connectordeleted",n))},a.createHtmlDialog=function(e,t,a,o,r,i){var n,l,s,c,d,h,p,g,f=this.getFromEnv("chartConfig"),m=this.getFromEnv("style").inCanvasStyle||{},b=Number(f.width),x=Number(f.height),k=this.getFromEnv("animationManager"),C={color:(0,u.hashify)(m.color),textAlign:"center",paddingTop:1+v,border:"1px solid #cccccc",borderRadius:4+v,cursor:u.preDefStr.POINTER,_cursor:"hand",backgroundColor:u.HASHSTRING+"ffffff",zIndex:21,"-webkit-border-radius":4+v},w=i;return g={width:b,height:x},i||(g.fill="transparent",g.type="div"),w=k.setAnimation({el:i||"html",attr:g,component:this,label:"ui",state:y,css:{fontSize:10+v,lineHeight:15+v,fontFamily:m.fontFamily,display:"block"},container:!i&&this.getFromEnv("chart-container")}),g={width:b,height:x,opacity:.3},w.veil||(g.fill="000000",g.type="div"),w.veil=k.setAnimation({el:w.veil||"html",attr:g,component:this,state:y,label:"uiveil",container:!w.veil&&w}),c={x:(b-e)/2,y:(x-t)/2,width:e,height:t},w.dialog||(c.fill="efefef",c.strokeWidth=1,c.stroke="000000",c.type="div"),w.dialog=k.setAnimation({el:w.dialog||"html",attr:c,component:this,state:y,label:"uidialog",container:!w.dialog&&w,css:{borderRadius:5+v,boxShadow:"1px 1px 3px #000000","-webkit-border-radius":5+v,"-webkit-box-shadow":"1px 1px 3px #000000",filter:'progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color="#000000")'}}),d={x:e-70-5,y:t-23-5,width:65,height:17},w.ok||(d.text="Submit",d.tabIndex=1,d.type="div"),n=k.setAnimation({el:w.ok||"html",state:y,attr:d,component:this,label:"uiok",css:C,container:!w.ok&&w.dialog}),!w.ok&&(w.ok=n)&&n.on("fc-mousedown",a),h={x:e-140-5,y:t-23-5,width:65,height:17},w.cancel||(h.text="Cancel",h.tabIndex=2,h.type="div"),l=k.setAnimation({el:w.cancel||"html",state:y,attr:h,component:this,label:"uicancel",css:C,container:!w.cancel&&w.dialog}),!w.cancel&&(w.cancel=l)&&l.on("fc-mousedown",o),p={x:e-210-5,y:t-23-5,width:65,height:17},w.removeItem||(p.text="Delete",p.tabIndex=3,p.type="div"),s=k.setAnimation({el:w.removeItem||"html",state:y,attr:p,component:this,label:"uiremove",css:C,container:!w.removeItem&&w.dialog}),!w.removeItem&&(w.removeItem=s)&&s.on("fc-mousedown",r),w.handleKeyPress||(w.handleKeyPress=function(e){13===e.keyCode?w.ok.element&&a(e):27===e.keyCode&&w.cancel.element&&o(e)}),w},a.getNode=function(e){for(var t,a={},o=this.getChildren("dataset"),r=0,i=o.length;r<i;r++)if(e){if(t=o[r].getNode(e))return t}else Object.assign(a,o[r].getNode());return!e&&a},a.createContainer=function(){var e=this,t=e.getFromEnv("animationManager"),a=e.getLinkedParent().getChildContainer();["connectorGroup","defaultVcanvasGroup","vcanvasLabelGroup","cloneGroup"].forEach((function(o){!e.getChildContainer(o)&&e.addChildContainer(o,t.setAnimation({el:"group",attr:{name:"manager-"+o},component:e,container:a[o]||a.defaultVcanvasGroup}))})),!e.getContainer("waitContainer")&&e.addContainer("waitContainer",t.setAnimation({el:"group",attr:{name:"manager-waitContainer"},container:a.defaultVcanvasGroup,component:e}))},a.draw=function(){var e,t,a={cacheUpdateUI:[350,215],cacheLabelDeleteUI:[250,100],cacheLabelUpdateUI:[350,205],cacheConnectorUpdateUIedit:[315,215],cacheConnectorUpdateUInew:[315,215]};if(!this.getState("configured")){for(e in y="update",a)if((t=this.getGraphicalElement(e))&&t.isVisible()){if("cacheUpdateUI"===e){var o=t.fields.image.val();a[e][1]=o?250:215}this.createHtmlDialog(a[e][0],a[e][1],r,r,r,t)}y="appearing"}this.setState("configured",!1),this.createContainer()},a.getDataLimits=function(){var e,t,a=this.getChildren("dataset"),o=+Infinity,r=-Infinity,i=-Infinity,n=+Infinity;for(e=0;e<a.length;e++)t=a[e].config,r=Math.max(r,t.yMax),o=Math.min(o,t.yMin),i=Math.max(i,t.xMax),n=Math.min(n,t.xMin);return{max:r,min:o,xMax:i,xMin:n}},a.isVisible=function(){return!this.isNotVisible},a.childChanged=function(){return this},a.hideWaitElem=function(){this.getGraphicalElement("waitElement")&&this.getGraphicalElement("waitElement").hide()},a.clearLongPress=function(){clearTimeout(this.config._longpressactive),delete this.config._longpressactive},a.triggerLabelUI=function(e,t){var a=this;a.config._longpressactive=setTimeout((function(){e.data("fire_click_event",0),e.data("viewMode")||a.showLabelDeleteUI(t)}),1e3)},a.triggerConnectorUI=function(e){var t=this,a=e.data("dataset"),o=e.data(u.preDefStr.configStr),r=o||{};t.config._longpressactive=setTimeout((function(){e.data("fire_click_event",0),e.data("viewMode")||t.showConnectorUpdateUI({fromid:{val:r.from,innerHTML:"<option>"+r.from+"</option>",disabled:!0},toid:{val:r.to,innerHTML:"<option>"+r.to+"</option>",disabled:!0},datasetIndex:a.config.datasetIndex,index:o.index,arratstart:{val:Boolean((0,u.pluckNumber)(r.arrowatstart,1))},arratend:{val:Boolean((0,u.pluckNumber)(r.arrowatend,1))},dashed:{val:(0,u.pluckNumber)(r.dashed)},dashgap:{val:r.dashgap},dashlen:{val:r.dashlen},label:{val:r.label},tooltext:{val:r.tooltext},id:{val:a.config.id,disabled:!0},strength:{val:r.conStrength},alpha:{val:r.alpha},color:{val:r.color.FCcolor.color}},!0)}),1e3)},a.deleteLabel=function(e){var t,a,o,r=this.getChildren("labels")[0],i=(0,u.pluckNumber)(e,r.config.lastTappedLabelIndex),n=r.components.data[i],l=this.getFromEnv("chart");t=n.graphics.element,a=n.graphics.trackerElement,t&&(o=t.data("eventArgs"),t.remove(),a&&a.remove(),delete n.graphics),l.fireChartInstanceEvent("chartupdated",(0,u.extend2)({sourceEvent:"labeldeleted"},o)),l.fireChartInstanceEvent("labeldeleted",o),n.removed=!0},a.showLabelDeleteUI=function(e){var t=this,a=t.getGraphicalElement("cacheLabelDeleteUI");t.getChildren("labels")[0].config.lastTappedLabelIndex=e.config.index,a?a.show():((a=t.addGraphicalElement("cacheLabelDeleteUI",t.createHtmlDialog(250,100,r,(function(){a.hide()}),(function(){t.deleteLabel(),a.hide()})))).message=t.getFromEnv("paper").html("span",{x:10,y:10,width:230,height:80}).add(a.dialog),a.ok.hide(),a.removeItem.translate(175).show()),a.message.attr({text:'Would you really like to delete the label: "'+e.config.text+'"?'})},a.drawWaitingRing=function(e,t){var a=this,o=e.config,i=a.getChildren("dataset")[t].config,n=a.getGraphicalElement("waitElement");a.clearLongPress(),n=a.getFromEnv("animationManager").setAnimation({el:n||"ringpath",attr:{ringpath:[o._xPos,o._yPos,8,11,0,0],fill:(0,u.toRaphaelColor)({alpha:"100,100",angle:120,color:"CCCCCC,FFFFFF",ratio:"30,50"}),"stroke-width":0},container:a.getContainer("waitContainer"),component:a}),a.getGraphicalElement("waitElement")||a.addGraphicalElement("waitElement",n),n.show().animate({ringpath:[o._xPos,o._yPos,8,11,0,6.28]},1e3),a.config._longpressactive=setTimeout((function(){var e=i.name!==m&&i.name!==r?i.name+u.preDefStr.BLANKSPACE:m,l=i.id!==r?(e?u.COMMASTRING:e)+i.id:m;n&&n.hide(),a.showNodeUpdateUI({x:{value:o.x},y:{value:o.y},draggable:{value:(0,u.getFirstValue)(o.allowdrag,1)},color:{value:o.color},alpha:{value:o.alpha},label:{value:(0,u.getFirstValue)(o.label,o.name)},tooltip:{value:o.toolText},shape:{value:p[o.shape]},rectWidth:{value:o.width},rectHeight:{value:o.height},circPolyRadius:{value:o.radius},polySides:{value:o.numsides},image:{value:o.imageNode},imgWidth:{value:o.imageWidth},imgHeight:{value:o.imageHeight},imgAlign:{value:o.imageAlign},imgUrl:{value:o.imageURL},id:{value:o.id,disabled:!0},link:{value:o.link},dataset:{innerHTML:'<option value="'+l+'">'+e+l+"</option>",disabled:!0},datasetIndex:t},!0)}),1e3)},a.drawNodeConnectors=function(e){var t,a,o,r,i,n;if(e)for(t in e)(r=e[t])&&(a=r.config.datasetIndex,i=r.config.fromPointObj,n=r.config.toPointObj,(o=this.getChildren("connector")[a])&&(o&&o.parsePlotAttributes(r,i,n),o&&o.drawConnector(r,i,n)))},a._clearConnectors=function(){var e,t,a,o,r,i,n=this.getNode();for(e in n)if(i=n[e]){for(r in t=i.config.startConnectors||{},a=i.config.endConnectors||{},t)o={graphics:t[r].graphics||{}},u.componentDispose.call(o);for(r in a)o={graphics:a[r].graphics||{}},u.componentDispose.call(o)}},a.getJSONData=function(){var e,t,a,o=this.getChildren(),r=o.dataset,i=o.connector,n=o.labels,l={};for(l.dataset=[],l.connectors=[],l.labels=[],e=0,t=r&&r.length;e<t;e++)a=r[e],l.dataset[e]||(l.dataset[e]=(0,u.extend2)({},a.JSONData)),l.dataset[e].data=a.getJSONData();for(e=0,t=i&&i.length;e<t;e++)a=i[e],l.connectors[e]||(l.connectors[e]=(0,u.extend2)({},a.JSONData)),l.connectors[e].connector=a.getJSONData();for(e=0,t=n&&n.length;e<t;e++)a=n[e],l.labels[e]||(l.labels[e]={label:[]}),l.labels[e].label=a.getJSONData();return l},t}(d.ComponentInterface);t["default"]=N},1012:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a,r=e.getFromEnv("dataSource"),i=r.dataset,n=r.connectors,l=r.labels,s=e.getChildren("canvas")[0],c=t=s.getChildren("vCanvas")[0],d=[];if(l&&(l=[l]),!i&&!n&&!l)return void e.setChartMessage();(0,o.componentFactory)(t,e.getDSGroupdef(),"datasetGroup_dragNode"),(a=t.getChildren("datasetGroup_dragNode"))&&(c=a[0]),i&&i.length?(0,o.componentFactory)(c,e.getDSdef("dragnode"),"dataset",i.length,i):d.push("dataset");n&&n.length?(0,o.componentFactory)(c,e.getDSdef("connector"),"connector",n.length,n):d.push("connector");l&&l.length?(0,o.componentFactory)(c,e.getDSdef("dragableLabels"),"labels",l.length,l):d.push("labels");d.length&&function(e,t){var a,o,r,i=e.getChildren();if(t&&t.length)for(r=t.length-1;r>-1;r--)for(o=(a=i[t[r]])&&a.length-1;o>-1;a[o].remove(),o--);}(c,d)};var o=a(224)},1013:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1014))["default"];t["default"]=r},1014:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(565)),l=o(a(533)),s=o(a(1015)),c=o(a(1025)),d=a(1016),h=o(a(366)),u=i.preDefStr.altHGridColorStr,p=i.preDefStr.altHGridAlphaStr,g=Math,f=g.max,m=g.round,v=i.preDefStr.POSITION_BOTTOM,b=i.preDefStr.divLineAlpha3DStr,x=i.preDefStr.defaultFontStr,k=i.preDefStr.divLineAlphaStr,y=i.preDefStr.altVGridColorStr,C=i.preDefStr.altVGridAlphaStr,w=i.preDefStr.colors.c000000,A={chart2D:{bgColor:"bgColor",bgAlpha:"bgAlpha",bgAngle:"bgAngle",bgRatio:"bgRatio",canvasBgColor:"canvasBgColor",canvasBaseColor:"canvasBaseColor",divLineColor:"divLineColor",legendBgColor:"legendBgColor",legendBorderColor:"legendBorderColor",toolTipbgColor:"toolTipbgColor",toolTipBorderColor:"toolTipBorderColor",baseFontColor:"baseFontColor",anchorBgColor:"anchorBgColor"},chart3D:{bgColor:"bgColor3D",bgAlpha:"bgAlpha3D",bgAngle:"bgAngle3D",bgRatio:"bgRatio3D",canvasBgColor:"canvasBgColor3D",canvasBaseColor:"canvasBaseColor3D",divLineColor:"divLineColor3D",divLineAlpha:b,legendBgColor:"legendBgColor3D",legendBorderColor:"legendBorderColor3D",toolTipbgColor:"toolTipbgColor3D",toolTipBorderColor:"toolTipBorderColor3D",baseFontColor:"baseFontColor3D",anchorBgColor:"anchorBgColor3D"}},S=function(e){function t(){var t;return(t=e.call(this)||this).isDual=!0,t.paletteIndex=3,t.hasInteractiveLegend=!1,t.numOfCanvas=2,t.registerFactory("vCanvas",l["default"],["axis"]),t.registerFactory("axis",c["default"],["canvas"]),t.registerFactory("dataset",s["default"],["vCanvas"]),t}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"candlestick"},t.getName=function(){return"candlestick"},a.getDSdef=function(e){return"bar"===e?d.CandleStickBarDataset:"line"===e?d.CandleStickLineDataset:d.CandleStickDataset},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.hasLegend=!0,t.defaultDatasetType="candlestick",t.drawanchors=0,t.enablemousetracking=!0,t.iscandlestick=!0,t.canvasborderthickness=1},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t)},a.parseChartAttr=function(t){e.prototype.parseChartAttr.call(this,t);var a,o=this.config,r=this.getFromEnv("chart-attrib"),n=this.getFromEnv("color-manager");o.showVolumeChart=(0,i.pluckNumber)(r.showvolumechart,function(e){if(!e||!e.dataset)return 0;var t=e.dataset[0].data;return!!(Array.isArray(t)&&t.filter((function(e){return e.volume}))||[]).length}(t),1),o.rollOverBandColor=(0,i.convertColor)((0,i.pluck)(r.rolloverbandcolor,n.getColor(u)),(0,i.pluck)(r.rolloverbandalpha,n.getColor(p))),o.crosslinecolor=(0,i.pluck)(r.crosslinecolor,r.rolloverbandcolor,n.getColor(u)),o.drawcrosslineontop=0,o.crosslinealpha=(0,i.pluckNumber)(r.crosslinealpha,r.rolloverbandalpha,n.getColor(p)),o.drawcrossline=1,o.skipClipping=!0,r=this.getFromEnv("chart-attrib"),o.vplotbordercolor=(0,i.getFirstValue)(r.vplotbordercolor,i.BLANKSTRING),o.vplotborderalpha=(0,i.getFirstValue)(r.vplotborderalpha,i.BLANKSTRING),o.vplotborderthickness=(0,i.pluckNumber)(r.vplotborderthickness,1),o.showplotborder=(0,i.pluckNumber)(r.showvplotborder,1),a=(0,i.pluckNumber)(r.volumeheightpercent,40),o.volumeHeightPercent=a<20?20:a>80?80:a,o.canvasBorderWidth=(0,i.pluckNumber)(r.canvasborderthickness,1)},a._spaceManager=function(){var e,t,a,o,r,n,l,s,c,d,h,u,p,g,b,x,k,y,C,w,A,S,N=this.config,L=this.getChildren(),D=N.legendPosition?N.legendPosition.split("-"):[],E=L.xAxis&&L.xAxis[0],T=L.yAxis&&L.yAxis[0],F=L.yAxis&&L.yAxis[1],P=this.getFromEnv("legend"),_=this.config.showVolumeChart,V=_?N.volumeHeightPercent:0,I=L.canvas[0],B=I.config,M=N.width,O=N.height,R={},G=N.chartBorderWidth,H=B.canvasBorderWidth,z=N.minCanvasHeight,W=N.minCanvasWidth,U=N.canvasMarginLeft,j=N.canvasMarginRight,J=N.canvasMarginTop,K=N.canvasMarginBottom,q=N.origCanvasTopMargin,Y=N.origCanvasBottomMargin,X=N.origCanvasLeftMargin,Q=N.origCanvasRightMargin;this._allocateSpace({top:G,bottom:G,left:G,right:G}),e=.225*N.availableHeight,t=this._manageActionBarSpace&&this._manageActionBarSpace(e)||{},this._allocateSpace(t),u=D[0]===i.POSITION_LEFT||D[0]===i.POSITION_RIGHT?.225*N.canvasWidth:.3*N.canvasHeight,!1!==N.hasLegend&&E&&N.showLegend&&this._allocateSpace(P._manageLegendPosition(u)),a=.7*N.canvasWidth,d=T.placeAxis(a),h=_?F.placeAxis(a):{},R.left=f(d.left,h.left||0),R.right=f(d.right,h.right||0),this._allocateSpace(R),W>M-U-j&&(A=!0,p=N.canvasWidth-W,S=U+j,U=N.canvasMarginLeft=p*U/S,j=N.canvasMarginRight=p*j/S),k=U>N.canvasLeft?U-N.canvasLeft:0,y=j>M-N.canvasRight?j+N.canvasRight-M:0,this._allocateSpace({left:k,right:y}),A&&(S=X+Q,(b=N.canvasWidth)>W&&(k=(p=b-W)*X/S,y=p*Q/S),this._allocateSpace({left:k,right:y})),o=.225*N.canvasHeight,o=D[0]===i.POSITION_TOP||D[0]===v?.6*N.canvasHeight:.6*N.canvasWidth,this._manageChartMenuBar(o),this._allocateSpace({top:N.canvasMarginTop,bottom:N.canvasMarginBottom}),o=.3*N.canvasHeight,n=E.placeAxis(o),E&&this._allocateSpace(n),n.bottom+=6,B.intermediarySpace=n.bottom,_&&this._allocateSpace({bottom:10}),this._allocateSpace({top:H,bottom:2*H,left:H,right:H}),z>O-J-K&&(x=!0,p=N.canvasHeight-z,S=J+K,J=N.canvasMarginTop=p*J/S,K=N.canvasMarginBottom=p*K/S),C=J>N.canvasTop?J-N.canvasTop:0,w=K>O-N.canvasBottom?K+N.canvasBottom-O:0,this._allocateSpace({top:C,bottom:w}),x&&(S=q+Y,(g=N.canvasHeight)>z&&(C=(p=g-z)*q/S,w=p*Y/S),this._allocateSpace({top:C,bottom:w})),r=N.canvasHeight,B.canvasHeight=m((100-V)/100*r),B.canvasTop=N.canvasTop,B.canvasLeft=N.canvasLeft,B.canvasBottom=B.canvasTop+B.canvasHeight,B.canvasWidth=N.canvasWidth,B.canvasRight=N.canvasRight,B.canvasY=N.canvasTop+B.canvasHeight+H,I.setDimension({top:B.canvasTop,left:B.canvasLeft,width:B.canvasWidth,height:B.canvasHeight}),_&&((s=(l=L.canvas[1]).config).canvasHeight=V/100*r,s.canvasTop=B.canvasBottom+n.bottom+2*H,s.canvasLeft=N.canvasLeft,s.canvasBottom=s.canvasTop+s.canvasHeight+2*H,s.canvasRight=N.canvasRight,s.canvasWidth=N.canvasWidth,c=N.canvasTop+B.canvasHeight+n.bottom+2*H,s.canvasY=c,l.setDimension({top:s.canvasTop,left:s.canvasLeft,width:s.canvasWidth,height:s.canvasHeight}))},a._postSpaceManagement=function(){e.prototype._postSpaceManagement.call(this)},a.setAxisDimention=function(){var e,t=this.getChildren(),a=t.xAxis&&t.xAxis[0],o=t.yAxis&&t.yAxis[0],r=t.yAxis&&t.yAxis[1],i=t.canvas,n=i[0].config,l=n.canvasBorderWidth,s=n.canvasLeft-l;a&&a.setAxisDimention({x:n.canvasLeft,y:a.config.isOpposit?n.canvasTop-l:n.canvasY,opposite:a.config.isOpposit?n.canvasY:n.canvasTop-l,axisLength:n.canvasWidth}),o&&o.setAxisDimention({x:o.config.isOpposit?n.canvasRight+l:s,y:n.canvasTop,opposite:o.config.isOpposit?s:n.canvasRight+l,axisLength:n.canvasHeight}),a.setCanvas(n),o.setCanvas(n),this.config.showVolumeChart&&(e=i[1].config,r&&r.setAxisDimention({x:o.config.isOpposit?e.canvasRight+l:s,y:e.canvasTop,opposite:o.config.isOpposit?s:e.canvasRight+l,axisLength:e.canvasHeight}),r&&r.setCanvas(e))},a._feedAxesRawData=function(){var e,t,a,o=this.getFromEnv("color-manager"),r=this.getFromEnv("dataSource"),n=this.getFromEnv("chart-attrib"),l=[],s=[],c=this.config.is3D,d=c?A.chart3D:A.chart2D,g=(0,i.pluckFontSizeMaintainUnit)(n.outcnvbasefontsize,n.basefontsize,10);return(e={isVertical:!1,isReverse:!1,isOpposit:(0,h["default"])(n.xaxisposition,"top"),drawTrendLabels:!0,outCanfontFamily:(0,i.pluck)(n.outcnvbasefont,n.basefont,x),outCanfontSize:this.computeFontSize(g),outCanfontSizeWithUnit:g,outCancolor:(0,i.pluck)(n.outcnvbasefontcolor,n.basefontcolor,o.getColor(d.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),axisNamePadding:n.xaxisnamepadding,axisValuePadding:n.labelpadding,axisNameFont:n.xaxisnamefont,axisNameFontSize:this.computeFontSize(n.xaxisnamefontsize),axisNameFontSizeWithUnit:n.xaxisnamefontsize,axisNameFontColor:n.xaxisnamefontcolor,axisNameFontBold:n.xaxisnamefontbold,axisNameFontItalic:n.xaxisnamefontitalic,axisNameBgColor:n.xaxisnamebgcolor,axisNameBorderColor:n.xaxisnamebordercolor,axisNameAlpha:n.xaxisnamealpha,axisNameFontAlpha:n.xaxisnamefontalpha,axisNameBgAlpha:n.xaxisnamebgalpha,axisNameBorderAlpha:n.xaxisnameborderalpha,axisNameBorderPadding:n.xaxisnameborderpadding,axisNameBorderRadius:n.xaxisnameborderradius,axisNameBorderThickness:n.xaxisnameborderthickness,axisNameBorderDashed:n.xaxisnameborderdashed,axisNameBorderDashLen:n.xaxisnameborderdashlen,axisNameBorderDashGap:n.xaxisnameborderdashgap,useEllipsesWhenOverflow:n.useellipseswhenoverflow,divLineColor:(0,i.pluck)(n.vdivlinecolor,n.divlinecolor,o.getColor(d.divLineColor)),divLineAlpha:(0,i.pluck)(n.vdivlinealpha,n.divlinealpha,c?o.getColor(b):o.getColor(k)),divLineThickness:(0,i.pluckNumber)(n.vdivlinethickness,n.divlinethickness,1),divLineIsDashed:Boolean((0,i.pluckNumber)(n.vdivlinedashed,n.vdivlineisdashed,n.divlinedashed,n.divlineisdashed,0)),divLineDashLen:(0,i.pluckNumber)(n.vdivlinedashlen,n.divlinedashlen,4),divLineDashGap:(0,i.pluckNumber)(n.vdivlinedashgap,n.divlinedashgap,2),showAlternateGridColor:(0,i.pluckNumber)(n.showalternatevgridcolor,0),alternateGridColor:(0,i.pluck)(n.alternatevgridcolor,o.getColor(y)),alternateGridAlpha:(0,i.pluck)(n.alternatevgridalpha,o.getColor(C)),numDivLines:n.numvdivlines,labelFont:n.labelfont,labelFontSize:this.computeFontSize(n.labelfontsize),labelFontSizeWithUnit:n.labelfontsize,labelFontColor:n.labelfontcolor,labelAlpha:n.labelalpha,labelFontBold:n.labelfontbold,labelFontItalic:n.labelfontitalic,labelBdrColor:n.labelbordercolor,labelBdrAlpha:n.labelborderalpha,labelLink:n.labellink,labelBgAlpha:n.labelbgalpha,labelBgColor:n.labelbgcolor,labelBdrThickness:n.labelborderthickness,labelBdrPadding:n.labelborderpadding,labelBdrRadius:n.labelborderradius,labelBdrDashed:n.labelborderdashed,labelBdrDashLen:n.labelborderdashlen,labelBdrDashGap:n.labelborderdashgap,axisName:n.xaxisname,axisMinValue:n.xaxisminvalue,axisMaxValue:n.xaxismaxvalue,setAdaptiveMin:n.setadaptivexmin,adjustDiv:n.adjustvdiv,labelDisplay:n.labeldisplay,showLabels:n.showlabels,rotateLabels:n.rotatelabels,slantLabel:(0,i.pluckNumber)(n.slantlabels,n.slantlabel),labelStep:(0,i.pluckNumber)(n.labelstep,n.xaxisvaluesstep),showAxisValues:(0,i.pluckNumber)(n.showxaxisvalues,n.showxaxisvalue),showLimits:n.showvlimits,showDivLineValues:(0,i.pluckNumber)(n.showvdivlinevalues,n.showvdivlinevalues),showZeroPlane:n.showvzeroplane,zeroPlaneColor:n.vzeroplanecolor,zeroPlaneThickness:n.vzeroplanethickness,zeroPlaneAlpha:n.vzeroplanealpha,showZeroPlaneValue:n.showvzeroplanevalue,trendlineColor:n.trendlinecolor,trendlineToolText:n.trendlinetooltext,trendlineThickness:n.trendlinethickness,trendlineAlpha:n.trendlinealpha,showTrendlinesOnTop:n.showtrendlinesontop,showAxisLine:(0,i.pluckNumber)(n.showxaxisline,n.showaxislines,n.drawAxisLines,0),axisLineThickness:(0,i.pluckNumber)(n.xaxislinethickness,n.axislinethickness,1),axisLineAlpha:(0,i.pluckNumber)(n.xaxislinealpha,n.axislinealpha,100),axisLineColor:(0,i.pluck)(n.xaxislinecolor,n.axislinecolor,w),freezeLimit:!0}).vtrendlines=r.vtrendlines,s.push(e),(t={isVertical:!0,isReverse:!0,isOpposit:(0,h["default"])(n.yaxisposition,"left"),drawLabelsOpposit:1,axisNameAlignCanvas:1,outCanfontFamily:(0,i.pluck)(n.outcnvbasefont,n.basefont,x),outCanfontSize:this.computeFontSize(g),outCanfontSizeWithUnit:g,outCancolor:(0,i.pluck)(n.outcnvbasefontcolor,n.basefontcolor,o.getColor(d.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),axisNamePadding:n.yaxisnamepadding,axisValuePadding:n.yaxisvaluespadding,axisNameFont:n.pyaxisnamefont,axisNameFontSize:n.pyaxisnamefontsize,axisNameFontSizeWithUnit:n.pyaxisnamefontsize,axisNameFontColor:n.pyaxisnamefontcolor,axisNameFontBold:n.pyaxisnamefontbold,axisNameFontItalic:n.pyaxisnamefontitalic,axisNameBgColor:n.pyaxisnamebgcolor,axisNameBorderColor:n.pyaxisnamebordercolor,axisNameAlpha:n.pyaxisnamealpha,axisNameFontAlpha:n.pyaxisnamefontalpha,axisNameBgAlpha:n.pyaxisnamebgalpha,axisNameBorderAlpha:n.pyaxisnameborderalpha,axisNameBorderPadding:n.pyaxisnameborderpadding,axisNameBorderRadius:n.pyaxisnameborderradius,axisNameBorderThickness:n.pyaxisnameborderthickness,axisNameBorderDashed:n.pyaxisnameborderdashed,axisNameBorderDashLen:n.pyaxisnameborderdashlen,axisNameBorderDashGap:n.pyaxisnameborderdashgap,axisNameWidth:n.yaxisnamewidth,useEllipsesWhenOverflow:n.useellipseswhenoverflow,rotateAxisName:(0,i.pluckNumber)(n.rotateyaxisname,1),axisName:n.pyaxisname,divLineColor:(0,i.pluck)(n.divlinecolor,o.getColor(d.divLineColor)),divLineAlpha:(0,i.pluck)(n.divlinealpha,o.getColor(k)),divLineThickness:(0,i.pluckNumber)(n.divlinethickness,1),divLineIsDashed:Boolean((0,i.pluckNumber)(n.divlinedashed,n.divlineisdashed,1)),divLineDashLen:(0,i.pluckNumber)(n.divlinedashlen,4),divLineDashGap:(0,i.pluckNumber)(n.divlinedashgap,2),showAlternateGridColor:(0,i.pluckNumber)(n.showalternatehgridcolor,1),alternateGridColor:(0,i.pluck)(n.alternatehgridcolor,o.getColor(u)),alternateGridAlpha:(0,i.pluck)(n.alternatehgridalpha,o.getColor(p)),numDivLines:(0,i.pluckNumber)(n.numpdivlines,5),axisMinValue:n.pyaxisminvalue,axisMaxValue:n.pyaxismaxvalue,setAdaptiveMin:(0,i.pluckNumber)(n.setadaptiveymin,1),adjustDiv:n.adjustdiv,labelStep:n.yaxisvaluesstep,showAxisValues:(0,i.pluckNumber)(n.showyaxisvalues,n.showyaxisvalue),showLimits:(0,i.pluckNumber)(n.showyaxislimits,n.showlimits,this.showLimits),showDivLineValues:(0,i.pluckNumber)(n.showdivlinevalues,n.showdivlinevalue),showZeroPlane:n.showzeroplane,zeroPlaneColor:n.zeroplanecolor,zeroPlaneThickness:n.zeroplanethickness,zeroPlaneAlpha:n.zeroplanealpha,showZeroPlaneValue:n.showzeroplanevalue,trendlineColor:n.trendlinecolor,trendlineToolText:n.trendlinetooltext,trendlineThickness:n.trendlinethickness,trendlineAlpha:n.trendlinealpha,showTrendlinesOnTop:n.showtrendlinesontop,showAxisLine:(0,i.pluckNumber)(n.showyaxisline,n.showaxislines,n.drawAxisLines,0),axisLineThickness:(0,i.pluckNumber)(n.yaxislinethickness,n.axislinethickness,1),axisLineAlpha:(0,i.pluckNumber)(n.yaxislinealpha,n.axislinealpha,100),axisLineColor:(0,i.pluck)(n.yaxislinecolor,n.axislinecolor,w),labelFont:n.yaxisvaluefont,labelFontSize:this.computeFontSize(n.yaxisvaluefontsize),labelFontSizeWithUnit:n.yaxisvaluefontsize,labelFontColor:n.yaxisvaluefontcolor,labelAlpha:n.yaxisvaluealpha,labelFontBold:n.yaxisvaluefontbold,labelFontItalic:n.yaxisvaluefontitalic,labelBdrColor:n.yaxisvaluebordercolor,labelBgAlpha:n.yaxisvaluebgalpha,labelBdrAlpha:n.yaxisvalueborderalpha,labelLink:n.yaxisvaluelink,labelBgColor:n.yaxisvaluebgcolor,labelBdrThickness:n.yaxisvalueborderthickness,labelBdrPadding:n.yaxisvalueborderpadding,labelBdrRadius:n.yaxisvalueborderradius,labelBdrDashed:n.yaxisvalueborderdashed,labelBdrDashLen:n.yaxisvalueborderdashlen,labelBdrDashGap:n.yaxisvalueborderdashgap}).trendlines=r.trendlines,l.push(t),this.config.showVolumeChart&&(a={isVertical:!0,isReverse:!0,isOpposit:(0,h["default"])(n.yaxisposition,"left"),axisIndex:1,drawLabelsOpposit:1,axisNameAlignCanvas:1,uniqueClassName:1,outCanfontFamily:(0,i.pluck)(n.outcnvbasefont,n.basefont,x),outCanfontSize:this.computeFontSize(g),outCanfontSizeWithUnit:g,outCancolor:(0,i.pluck)(n.outcnvbasefontcolor,n.basefontcolor,o.getColor(d.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),axisNamePadding:n.yaxisnamepadding,axisValuePadding:n.yaxisvaluespadding,axisNameFont:n.vyaxisnamefont,axisNameFontSize:n.vyaxisnamefontsize,axisNameFontSizeWithUnit:n.vyaxisnamefontsize,axisNameFontColor:n.vyaxisnamefontcolor,axisNameFontBold:n.vyaxisnamefontbold,axisNameFontItalic:n.vyaxisnamefontitalic,axisNameBgColor:n.vyaxisnamebgcolor,axisNameBorderColor:n.vyaxisnamebordercolor,axisNameAlpha:n.vyaxisnamealpha,axisNameFontAlpha:n.vyaxisnamefontalpha,axisNameBgAlpha:n.vyaxisnamebgalpha,axisNameBorderAlpha:n.vyaxisnameborderalpha,axisNameBorderPadding:n.vyaxisnameborderpadding,axisNameBorderRadius:n.vyaxisnameborderradius,axisNameBorderThickness:n.vyaxisnameborderthickness,axisNameBorderDashed:n.vyaxisnameborderdashed,axisNameBorderDashLen:n.vyaxisnameborderdashlen,axisNameBorderDashGap:n.vyaxisnameborderdashgap,axisNameWidth:n.yaxisnamewidth,useEllipsesWhenOverflow:n.useellipseswhenoverflow,rotateAxisName:(0,i.pluckNumber)(n.rotateyaxisname,1),axisName:n.vyaxisname,divLineColor:(0,i.pluck)(n.divlinecolor,o.getColor(d.divLineColor)),divLineAlpha:(0,i.pluck)(n.divlinealpha,o.getColor(k)),divLineThickness:(0,i.pluckNumber)(n.divlinethickness,1),divLineIsDashed:Boolean((0,i.pluckNumber)(n.divlinedashed,n.divlineisdashed,1)),divLineDashLen:(0,i.pluckNumber)(n.divlinedashlen,4),divLineDashGap:(0,i.pluckNumber)(n.divlinedashgap,2),showAlternateGridColor:(0,i.pluckNumber)(n.showalternatehgridcolor,1),alternateGridColor:(0,i.pluck)(n.alternatehgridcolor,o.getColor(u)),alternateGridAlpha:(0,i.pluck)(n.alternatehgridalpha,o.getColor(p)),numDivLines:n.numdivlines,axisMinValue:n.vyaxisminvalue,axisMaxValue:n.vyaxismaxvalue,setAdaptiveMin:n.setadaptiveymin,adjustDiv:n.adjustdiv,labelStep:n.yaxisvaluesstep,showAxisValues:(0,i.pluckNumber)(n.showyaxisvalues,n.showyaxisvalue),showLimits:(0,i.pluckNumber)(n.showsecondarylimits,n.showlimits),showDivLineValues:(0,i.pluckNumber)(n.showdivlinevalues,n.showdivlinevalue),showZeroPlane:n.showzeroplane,zeroPlaneColor:n.zeroplanecolor,zeroPlaneThickness:n.zeroplanethickness,zeroPlaneAlpha:n.zeroplanealpha,showZeroPlaneValue:n.showzeroplanevalue,trendlineColor:n.trendlinecolor,trendlineToolText:n.trendlinetooltext,trendlineThickness:n.trendlinethickness,trendlineAlpha:n.trendlinealpha,showTrendlinesOnTop:n.showtrendlinesontop,showAxisLine:(0,i.pluckNumber)(n.showyaxisline,n.showaxislines,n.drawAxisLines,0),axisLineThickness:(0,i.pluckNumber)(n.yaxislinethickness,n.axislinethickness,1),axisLineAlpha:(0,i.pluckNumber)(n.yaxislinealpha,n.axislinealpha,100),axisLineColor:(0,i.pluck)(n.yaxislinecolor,n.axislinecolor,w),labelFont:n.yaxisvaluefont,labelFontSize:this.computeFontSize(n.yaxisvaluefontsize),labelFontSizeWithUnit:n.yaxisvaluefontsize,labelFontColor:n.yaxisvaluefontcolor,labelAlpha:n.yaxisvaluealpha,labelFontBold:n.yaxisvaluefontbold,labelFontItalic:n.yaxisvaluefontitalic,labelBdrColor:n.yaxisvaluebordercolor,labelBgAlpha:n.yaxisvaluebgalpha,labelBdrAlpha:n.yaxisvalueborderalpha,labelLink:n.yaxisvaluelink,labelBgColor:n.yaxisvaluebgcolor,labelBdrThickness:n.yaxisvalueborderthickness,labelBdrPadding:n.yaxisvalueborderpadding,labelBdrRadius:n.yaxisvalueborderradius,labelBdrDashed:n.yaxisvalueborderdashed,labelBdrDashLen:n.yaxisvalueborderdashlen,labelBdrDashGap:n.yaxisvalueborderdashgap},l.push(a)),{xAxisConfigure:s,yAxisConfigure:l}},a.mouseoutHandler=function(e,t,a){var o=this.config.datasetOrder||this.getDatasets(),r=this.getChildren("mouseTracker")[0];o[t]&&o[t].components.data[a]?o[t]._firePlotEvent("fc-mouseout",a,e):this.getFromEnv("toolTipController").hideAll(),delete r._lastDatasetIndex,delete r._lastPointIndex},a._mouseEvtHandler=function(e,t){var a,o,r,n,l,s,c,d=this,h=t.mouseTracker,u=e.originalEvent,p=d.getChildren("canvas").length,g=u&&(0,i.getMouseCoordinate)(d.getFromEnv("chart-container"),u,d),f=g&&g.chartX||0,m=g&&g.chartY||0,v=!1,b=h._lastDatasetIndex,x=h._lastPointIndex;for(n=0;n<p;n++)for(l=(a=d.getDatasets()).length;l--&&!v;)(o=a[l])&&o.getState("visible")&&(r=o._getHoveredPlot&&o._getHoveredPlot(f,m))&&r.hovered&&(v=!0,r.datasetIndex=l,c=h.getMouseEvents(e,r.datasetIndex,r.pointIndex));if((!v||c&&c.fireOut)&&void 0!==b&&a[b]&&a[b]._firePlotEvent&&(c&&!c.events.length?h.mouseoutTimer=setTimeout((function(){d.mouseoutHandler(e,b,x)}),20):(d.mouseoutHandler(e,b,x),clearTimeout(h.mouseoutTimer))),v)for((s=c.events&&c.events.length)&&(h._lastDatasetIndex=r.datasetIndex,x=h._lastPointIndex=r.pointIndex),l=0;l<s;l+=1)o&&o._firePlotEvent&&o._firePlotEvent(c.events[l],x,e,r.datasetIndex)},a._allocateSpace=function(e){var t,a,o=this.getChildren("canvas"),r=o&&o[0].config,i=this.config,n=i.canvasHeight,l=i.canvasWidth;a=i.canvasLeft+=e.left||0,t=i.canvasTop+=e.top||0,l=i.canvasWidth=f(l-((e.left||0)+(e.right||0)),0),n=i.canvasHeight=f(n-((e.top||0)+(e.bottom||0)),0),i.availableHeight=f(i.availableHeight-((e.top||0)+(e.bottom||0)),0),i.availableWidth=f(i.availableWidth-((e.left||0)+(e.right||0)),0),i.canvasRight=a+l,i.canvasBottom=t+n,r&&(r.canvasPaddingLeft=f(r.canvasPaddingLeft,e.paddingLeft||0),r.canvasPaddingRight=f(r.canvasPaddingRight,e.paddingRight||0),r.canvasPaddingTop=f(r.canvasPaddingTop,e.paddingTop||0),r.canvasPaddingBottom=f(r.canvasPaddingBottom,e.paddingBottom||0))},a._checkInvalidSpecificData=function(){var e=this.getFromEnv("dataSource").dataset,t=e&&e[0]&&e[0].data;if(!e||!t||!Array.isArray(t))return!0},t}(n["default"]);t["default"]=S},1015:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a,n,l=e.getFromEnv("dataSource"),s=l.dataset,c=l.trendset,d=e.getFromEnv("chartConfig").showVolumeChart,h=(0,o.pluck)((0,o.parseUnsafeString)(e.getFromEnv("chart-attrib").plotpriceas).toLowerCase(),"candlestick"),u=e.getChildren("canvas")[0].getChildren("vCanvas")[0],p=["candlestick","candlestickbar","candlestickline","trendset"];if(!s)return void e.setChartMessage();(n=s.slice(0))[0]&&n[0].data&&n[0].data.sort((function(e,t){return e.x-t.x})),(0,o.datasetFactory)(u,e.getDSdef(h),"dataset_"+h,s.length,n),i(p,"bar"===h?"candlestickbar":"line"===h?"candlestickline":"candlestick");d&&(t=e.getChildren("canvas")[1],a=t.getChildren("vCanvas")[0],(0,o.datasetFactory)(a,r.VolumeDataset,"dataset_volume",s.length,s));c&&((0,o.datasetFactory)(u,r.TrendSet,"dataset_trendset",c.length,c),i(p,"trendset"));!function(e,t){var a;e&&e.iterateComponents((function(e){for(a=0;a<t.length;a++)e.getName()===t[a]&&e.remove()}))}(u,p)};var o=a(224),r=a(1016),i=function(e,t){var a=e.indexOf(t);-1!==a&&e.splice(a,1)}},1016:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0;var r=o(a(1017));t.CandleStickDataset=r["default"];var i=o(a(1019));t.CandleStickBarDataset=i["default"];var n=o(a(1021));t.CandleStickLineDataset=n["default"];var l=o(a(1022));t.VolumeDataset=l["default"];var s=o(a(1023));t.TrendSet=s["default"]},1017:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t._parseToolText=t._firePlotEvent=t.getPlotIndices=t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(931)),l=a(232),s=o(a(1018)),c=a(538),d=i.preDefStr.colors,h=d.B90000,u=d.FFFFFF,p=function(e,t,a){var o,r,i,n=this.getFromEnv("chart"),l=this.components.data[t],s=this.config.currentToolTip,c=l.graphics.element,d=a.originalEvent,h=n.getFromEnv("paper").canvas.style,u=this.getFromEnv("toolTipController");if(c)switch(o=(r=l.config).toolText,i=r.setLink,e){case"fc-mouseover":o&&(s?u.draw(d,o,s):s=this.config.currentToolTip=u.draw(d,o)),n.plotEventHandler(c,a,"DataPlotRollOver"),i&&(h.cursor="pointer");break;case"fc-mouseout":u.hide(s),n.plotEventHandler(c,a,"DataPlotRollOut"),i&&(h.cursor="default");break;case"fc-click":n.plotEventHandler(c,a);break;case"fc-mousemove":o&&(s?u.draw(d,o,s):s=this.config.currentToolTip=u.draw(d,o))}},g=function(e){var t,a,o=Math.floor(e),r=Math.ceil(e),i=[],n=this.config.JSONData&&this.config.JSONData.data;for(t=n.length;t--;)(a=n[t]).x>=o&&a.x<=r&&i.push(t);return i},f=function(e){var t,a=this.config,o=this.components.data,r=this.getFromEnv("chart-attrib"),n="line"===a.plotType?1:0,l=a.JSONData.data[e],s=o[e].config,c=this.getFromEnv("xAxis").getLabel(s.x).label,d=s.open,h=s.close,u=this.getFromEnv("yAxis"),p=s.high,g=s.low,f=s.volume,m=void 0!==f?l.volumetooltext:void 0;return a.showTooltip?void 0!==(t=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(m,l.tooltext,a.volumeToolText,a.toolText),!1)))?t=(0,i.parseTooltext)(t,[3,5,6,10,54,55,56,57,58,59,60,61,81,82],{label:c,yaxisName:(0,i.parseUnsafeString)(r.yaxisname),xaxisName:(0,i.parseUnsafeString)(r.xaxisname),openValue:l.open,openDataValue:u.dataLabels(d),closeValue:l.close,closeDataValue:u.dataLabels(h),highValue:l.high,highDataValue:u.dataLabels(p),lowValue:l.low,lowDataValue:u.dataLabels(g),volumeValue:l.volume,volumeDataValue:u.dataLabels(f)},l,r):(t=null===d||n?"":"<b>Open:</b> "+u.dataLabels(d)+"<br />",t+=null!==h?"<b>Close:</b> "+u.dataLabels(h)+"<br />":"",t+=null===p||n?"":"<b>High:</b> "+u.dataLabels(p)+"<br />",t+=null===g||n?"":"<b>Low:</b> "+u.dataLabels(g)+"<br />",t+=null!==f?"<b>Volume:</b> "+u.dataLabels(f):""):t="",t};t._parseToolText=f,t.getPlotIndices=g,t._firePlotEvent=p,(0,l.addDep)({name:"candlestickAnimation",type:"animationRule",extension:s["default"]});var m=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.trimData=function(e){if(this.components||!this.components.data||!this.components.data.length){var t=this.components,a=t&&t.data,o=a&&a.length,r=e.data,i=Array.isArray(r)&&r.filter((function(e){return e.high||e.open||e.close||e.low})).length||0,n=o-i;n>0&&this.removeData(i,n,!1)}},a.removePlots=function(){var e=this.components,t=e&&e.removeDataArr;(0,c._removePlots)(t,this.__removeElem)},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,n,l,s,c,d,p,g,f,m,v,b,x,k,y,C,w,A,S=this.config,N=this.getFromEnv("chart"),L=this.config.JSONData,D=L.data||[],E=N.getFromEnv("dataSource").chart,T=D.length,F=this.getFromEnv("number-formatter"),P=this.getFromEnv("color-manager"),_=S.bearBorderColor=(0,i.getFirstColor)((0,i.pluck)(E.bearbordercolor,h)),V=S.bearFillColor=(0,i.getFirstColor)((0,i.pluck)(E.bearfillcolor,h)),I=S.bullBorderColor=(0,i.getFirstColor)((0,i.pluck)(E.bullbordercolor,P.getColor("canvasBorderColor"))),B=S.bullFillColor=(0,i.getFirstColor)((0,i.pluck)(E.bullfillcolor,u)),M=S.linethickness=S.plotBorderThickness=(0,i.pluckNumber)(E.plotlinethickness,1),O=S.plotLineDashLen=(0,i.pluckNumber)(E.plotlinedashlen,5),R=S.plotLineDashGap=(0,i.pluckNumber)(E.plotlinedashgap,4),G=-Infinity,H=+Infinity,z=-Infinity,W=+Infinity;for(this.setState("visible",1===(0,i.pluckNumber)(L.visible,1)),this._conatinerHidden=!!this.getState("visible"),S.minAbsNonZeroValue=Infinity,S.minAbsNonZeroData={},S.defaultPadding={left:.5,right:.5},S.parentYAxis=0,S.toolText=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(L.tooltext,E.plottooltext),!1)),S.name=(0,i.getValidValue)(L.seriesname),S.showTooltip=(0,i.pluckNumber)(E.showtooltip,1),S.showShadow=(0,i.pluckNumber)(E.showshadow,P.getColor("showShadow")),S.showErrorValue=!0,S.errorBarWidthPercent=0,!0,A=(0,i.pluck)(E.maxcolwidth),S.maxColWidth=Math.abs((0,i.pluckNumber)(A,50))||1,w=Math.max((0,i.pluckNumber)(E.plotspacepercent,20)%100,0),S.plotSpacePercent=S.groupPadding=w/200,k=this.components.data=this.components.data||(this.components.data=[]),S.valuePadding=(0,i.pluckNumber)(L.valuepadding,E.valuepadding,2),S.plotBorderThickness=M,n=0;n<T;n+=1)y=D[n],(l=k[n])||(l=k[n]={}),!l.config&&(l.config={}),!l.graphics&&(l.graphics={}),C=l.config,y&&!y.vline&&(C.setLink=(0,i.pluck)(y.link),s=C.open=F.getCleanValue(y.open),c=C.close=F.getCleanValue(y.close),d=C.high=F.getCleanValue(y.high),p=C.low=F.getCleanValue(y.low),null!==(C.volume=F.getCleanValue(y.volume,!0))&&(N.config.drawVolume=!0),m=C.x=F.getCleanValue(y.x),v=C.closeVal=Math.min(s,c),x=C.yVal=Math.max(s,c),g=Math.min(s,c,d,p),f=Math.max(s,c,d,p),C.valuePadding=(0,i.pluckNumber)(y.valuepadding,S.valuePadding),a=(0,i.getFirstColor)((0,i.pluck)(y.bordercolor,c<s?_:I)),o=(0,i.pluckNumber)(y.alpha,100),t=(0,i.getFirstColor)((0,i.pluck)(y.color,c<s?V:B)),C.dashed=(0,i.pluckNumber)(y.dashed,0),C.plotBorderDashStyle=(0,i.pluckNumber)(y.dashed)?(0,i.getDashStyle)(O,R):"none",r={opacity:S.showShadow?o/100:0},C.color=t,C.alpha=o,C.setColor=C.color,C.setAlpha=C.alpha,C.anchorImageUrl=(0,i.pluck)(y.anchorimageurl,L.anchorimageurl,E.anchorimageurl),b=C.borderColor=a,C.borderAlpha=C.plotLineAlpha,C.colorArr=[{color:C.color,alpha:C.alpha},{color:C.borderColor,alpha:C.borderAlpha}],C.showValue=1,C.hoverEffects={},C.y=Math.abs(c-s),C.previousY=v,C.link=(0,i.pluck)(y.link),C.errorValueArr=[],d-x>0&&(C.errorValue=!0,C.errorValueArr.push({errorValue:x-d,errorStartValue:x,errorBarColor:b,errorBarThickness:M,opacity:1})),p-v<0&&(C.errorValue=!0,C.errorValueArr.push({errorValue:v-p,errorStartValue:v,errorBarColor:b,errorBarThickness:M,opacity:1})),C.setValue=x,0!==x&&S.minAbsNonZeroValue>Math.abs(x)&&(S.minAbsNonZeroValue=Math.abs(x),S.minAbsNonZeroData=C),C.dataLabelStyle=this._configureDataLabelStyle(y),null!==g&&(G=Math.max(G,g),H=Math.min(H,g)),null!==f&&(G=Math.max(G,f),H=Math.min(H,f)),null!==m&&(z=Math.max(z,m),W=Math.min(W,m)),m=null!==m?m:n+1,C._x=m,C._y=x,C._b=v,C.high=Math.max(s,c,d,p),C.low=Math.min(s,c,d,p),C.shadow=r,C.toolText=this._parseToolText(n),C.toolTipValue="",C.displayValue=(0,i.parseUnsafeString)((0,i.pluck)(y.displayvalue,y.valuetext,"")));S.yMax=G,S.yMin=H,S.xMax=z,S.xMin=W,this.setState("dirty",!0)},a._parseToolText=function(e){return f.call(this,e)},a.addDatasetSpecificEvtArgs=function(e){var t=e,a=t.config,o=t.trackerConfig.eventArgs;Object.assign(o,{open:a.open,close:a.close,high:a.high,low:a.low,volume:a.volume,alpha:a.alpha,x:a.x,displayValue:a.displayValue,color:a.color,borderColor:a.borderColor,dashed:a.dashed})},a.calculateScrollRange=function(){var e=this.config,t=this.components.data&&this.components.data.length;e.scrollMinVal=e.scrollMinValForLabel=0,e.scrollMaxVal=e.scrollMaxValForLabel=t},a.getPlotIndices=function(e){return g.call(this,e)},a._getHoveredPlot=function(e,t){var a,o,r,i,n;for(a=this.getFromEnv("xAxis").getValue(e),o=(i=this.getPlotIndices(a)).length-1;o>-1&&!(r=(n=i[o])-a>0?this._checkPointerOverPlot(n,e,t)||this._checkPointerOverPlot(n-1,e,t):this._checkPointerOverPlot(n+1,e,t)||this._checkPointerOverPlot(n,e,t));o--);return r},a._firePlotEvent=function(e,t,a){p.call(this,e,t,a)},a.getDataLimits=function(){var e=this.config;return{max:e.yMax,min:e.yMin,xMax:e.xMax,xMin:e.xMin}},a.getName=function(){return"candlestick"},t}(n["default"]);t["default"]=m},1018:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.candlestick":function(){return{"rect.appearing":function(e){return[{initialAttr:{y:e.attr.y+e.attr.height,height:0},slot:"plot"}]},"group.appearing":function(e){return"label-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]},"*":null}},"initial.dataset.volume":function(){return{"rect.appearing":function(e){return[{initialAttr:{y:e.attr.y+e.attr.height,height:0},slot:"plot"}]},"*":null}}}},1019:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(538)),l=a(931),s=a(1017),c=a(232),d=o(a(1020)),h=i.preDefStr.colors,u=h.B90000,p=h.FFFFFF,g=i.preDefStr.ROUND,f=i.preDefStr.visibleStr,m=function(e){return function(){this.shadow(e)}};(0,c.addDep)({name:"candlestickbarAnimation",type:"animationRule",extension:d["default"]});var v=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.trimData=function(e){if(this.components||!this.components.data||!this.components.data.length){var t=this.components,a=t&&t.data,o=a&&a.length,r=e.data,i=Array.isArray(r)&&r.filter((function(e){return e.high||e.open||e.close||e.low})).length||0,n=o-i;n>0&&this.removeData(i,n,!1)}},a.addDatasetSpecificEvtArgs=function(e){var t=e,a=t.config,o=t.trackerConfig.eventArgs;Object.assign(o,{open:a.open,close:a.close,high:a.high,low:a.low,volume:a.volume,alpha:a.alpha,x:a.x,displayValue:a.displayValue,color:a.color,borderColor:a.borderColor,dashed:a.dashed})},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,n,l,s,c,d,h,g,f,m,v,b,x,k=this.config,y=this.getFromEnv("chart").getFromEnv("dataSource"),C=this.config.JSONData,w=C.data||[],A=y.chart,S=w.length,N=this.getFromEnv("number-formatter"),L=this.getFromEnv("color-manager"),D=k.bearBorderColor=(0,i.getFirstColor)((0,i.pluck)(A.bearbordercolor,u)),E=k.bearFillColor=(0,i.getFirstColor)((0,i.pluck)(A.bearfillcolor,u)),T=k.bullBorderColor=(0,i.getFirstColor)((0,i.pluck)(A.bullbordercolor,L.getColor("canvasBorderColor"))),F=k.bullFillColor=(0,i.getFirstColor)((0,i.pluck)(A.bullfillcolor,p)),P=-Infinity,_=+Infinity,V=-Infinity,I=+Infinity;for(this.setState("visible",1===(0,i.pluckNumber)(C.visible,1)),this._conatinerHidden=!!this.getState("visible"),k.defaultPadding={left:.5,right:.5},k.minAbsNonZeroValue=Infinity,k.minAbsNonZeroData={},k.linethickness=(0,i.pluckNumber)(A.plotlinethickness,2),k.toolText=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(C.tooltext,A.plottooltext),!1)),k.name=(0,i.getValidValue)(C.seriesname),k.showTooltip=(0,i.pluckNumber)(A.showtooltip,1),k.showErrorValue=!0,k.errorBarWidthPercent=0,!0,x=(0,i.pluck)(A.maxcolwidth),k.maxColWidth=Math.abs((0,i.pluckNumber)(x,50))||1,k.enableAnimation=(0,i.pluckNumber)(A.animation,A.defaultanimation,1),k.animation=!!k.enableAnimation&&{duration:1e3*(0,i.pluckNumber)(A.animationduration,1)},k.plotLineDashLen=(0,i.pluckNumber)(A.plotlinedashlen,5),k.plotLineDashGap=(0,i.pluckNumber)(A.plotlinedashgap,4),m=this.components.data=this.components.data||(this.components.data=[]),k.valuePadding=(0,i.pluckNumber)(C.valuepadding,A.valuepadding,2),k.showShadow=(0,i.pluckNumber)(A.showshadow,L.getColor("showShadow")),r=0;r<S;r++)v=w[r],(n=m[r])||(n=m[r]={}),!n.config&&(n.config={}),!n.graphics&&(n.graphics={}),b=n.config,v&&!v.vline&&(b.setLink=(0,i.pluck)(v.link),l=b.open=N.getCleanValue(v.open),s=b.close=N.getCleanValue(v.close),c=N.getCleanValue(v.high),d=N.getCleanValue(v.low),b.volume=N.getCleanValue(v.volume,!0),f=b.x=N.getCleanValue(v.x),b.high=Math.max(l,s,c,d),b.low=Math.min(l,s,c,d),b.yVal=Math.max(l,s),h=Math.min(l,s,c,d),g=Math.max(l,s,c,d),b.valuePadding=(0,i.pluckNumber)(v.valuepadding,k.valuePadding),a=(0,i.getFirstColor)((0,i.pluck)(v.bordercolor,s<l?D:T)),o=(0,i.pluckNumber)(v.alpha,100),t=(0,i.getFirstColor)((0,i.pluck)(v.color,s<l?E:F)),b.color=t,b.alpha=o,b.setColor=b.color,b.setAlpha=b.alpha,b.borderColor=a,b.borderAlpha=b.plotLineAlpha,b.colorArr=[{color:b.color,alpha:b.alpha},{color:b.borderColor,alpha:b.borderAlpha}],b.showValue=1,b.hoverEffects={},b.link=(0,i.pluck)(v.link),b.setValue=b.y,0!==b.setValue&&k.minAbsNonZeroValue>Math.abs(b.setValue)&&(k.minAbsNonZeroValue=Math.abs(b.setValue),k.minAbsNonZeroData=b),b.dataLabelStyle=this._configureDataLabelStyle(v),null!==h&&(P=Math.max(P,h),_=Math.min(_,h)),null!==g&&(P=Math.max(P,g),_=Math.min(_,g)),null!==f&&(V=Math.max(V,f),I=Math.min(I,f)),b.dashStyle=(0,i.pluckNumber)(v.dashed)?(0,i.getDashStyle)(k.plotLineDashLen,k.plotLineDashGap):"none",b.shadow={opacity:k.showShadow?o/100:0},f=null!==f?f:r+1,b.toolText=this._parseToolText(r),b.toolTipValue="",b._x=f,b.y=l,b.previousY=s,b.dashed=(0,i.pluckNumber)(k.plotLineDashed,v.dashed,0));k.yMax=P,k.yMin=_,k.xMax=V,k.xMin=I,this.setState("dirty",!0)},a.drawPlots=function(){var e,t,a,o,r,n,l,s,c,d,h,u,p,v,b,x,k=this.getFromEnv("animationManager"),y=this.config,C=this.components.data,w=C.length,A=this.getFromEnv("xAxis"),S=this.getFromEnv("yAxis"),N=y.linethickness>5?y.linethickness/2:2.5,L=this.getContainer("plotGroup");for(k.setAnimation({el:L,attr:{opacity:this.getState("visible")?1:0},component:this}),this.setColumnPosition(),t=0;t<w;t+=1)e=(a=C[t]).config,x=a.graphics,h=null,null===(n=e.y)?h=x.element:(r=e._x,o=e.link,e.setLink=e.link,s=A.getPixel(r),l=e.previousY,d=S.getPixel(l),c=S.getPixel(n),u=S.getPixel(e.high),p=S.getPixel(e.low),v=this.getFromEnv("columnXShift"),a.errorBar=[],a.errorBar.push([{_xPos:s-N,_yPos:u,_height:Math.abs(u-p),_width:2*N},{_xPos:s+v,_yPos:c,_height:2*N,_width:Math.abs(v)},{_xPos:s,_yPos:d,_height:2*N,_width:Math.abs(v)}]),b=["M",s,p,"L",s,u,"M",s,c,"L",s+v,c,"M",s,d,"L",s-v,d],h=x.element,(h=k.setAnimation({el:h||"path",container:L,attr:{path:b,cursor:o?"pointer":"",fill:(0,i.toRaphaelColor)(e.color),stroke:(0,i.toRaphaelColor)(e.borderColor),"stroke-width":y.linethickness,"stroke-dasharray":e.dashStyle,"stroke-linecap":g,"stroke-linejoin":g,"shape-rendering":"crisp",visibility:f},label:"path",component:this,callback:m.call(h,e.shadow)})).data("eventArgs",a.trackerConfig.eventArgs),x.element=h)},a._parseToolText=function(e){return s._parseToolText.call(this,e)},a._firePlotEvent=function(e,t,a){s._firePlotEvent.call(this,e,t,a)},a._checkPointerOverColumn=function(){},a._getHoveredPlot=function(e,t){var a,o,r,i,n;for(a=this.getFromEnv("xAxis").getValue(e),o=(i=s.getPlotIndices.call(this,a)).length-1;o>-1&&!(r=(n=i[o])-a>0?this._checkPointerOverPlot(n,e,t)||this._checkPointerOverPlot(n-1,e,t):this._checkPointerOverPlot(n+1,e,t)||this._checkPointerOverPlot(n,e,t));o--);return r},a._checkPointerOverPlot=function(e,t,a){return l._checkPointerOverPlot.call(this,e,t,a)},a._checkPointerOverErrorBar=function(e,t,a){return l._checkPointerOverErrorBar.call(this,e,t,a)},a.drawLabel=function(){},a.getDataLimits=function(){var e=this.config;return{max:e.yMax,min:e.yMin,xMax:e.xMax,xMin:e.xMin}},a.getName=function(){return"candlestickbar"},t}(n["default"]);t["default"]=v},1020:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.candlestickbar":function(){return{"path.appearing":function(){return[{initialAttr:{opacity:1,"stroke-width":1},finalAttr:{opacity:1}}]},"*":null}}}},1021:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(555)),l=a(1017),s=i.preDefStr.colors,c=s.B90000,d=s.FFFFFF,h=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,n,l,s,h,u,p,g,f,m,v,b,x,k,y,C=this.config,w=this.config.JSONData,A=w.data||[],S=this.getFromEnv("chart-attrib"),N=A.length,L=this.getFromEnv("number-formatter"),D=this.getFromEnv("color-manager"),E=C.bearBorderColor=(0,i.getFirstColor)((0,i.pluck)(S.bearbordercolor,c)),T=C.bearFillColor=(0,i.getFirstColor)((0,i.pluck)(S.bearfillcolor,c)),F=C.bullBorderColor=(0,i.getFirstColor)((0,i.pluck)(S.bullbordercolor,D.getColor("canvasBorderColor"))),P=C.bullFillColor=(0,i.getFirstColor)((0,i.pluck)(S.bullfillcolor,d)),_=C.linethickness=C.plotBorderThickness=(0,i.pluckNumber)(S.plotlinethickness,2),V=!!(0,i.pluckNumber)(S.drawanchors,0),I=(0,i.pluckNumber)(S.anchorstartangle,90),B=(0,i.pluckNumber)(S.anchorradius,this.anchorRadius,3),M=(0,i.getFirstColor)((0,i.pluck)(S.anchorbordercolor,F)),O=(0,i.pluckNumber)(S.anchorborderthickness,this.anchorBorderThickness,1),R=(0,i.getFirstColor)((0,i.pluck)(S.anchorbgcolor,D.getColor("anchorBgColor"))),G=(0,i.pluck)(S.anchoralpha,"0"),H=(0,i.pluck)(S.anchorbgalpha,G),z=-Infinity,W=+Infinity,U=-Infinity,j=+Infinity;for(this.setState("visible",1===(0,i.pluckNumber)(w.visible,1)),C.plotLineDashLen=(0,i.pluckNumber)(S.plotlinedashlen,5),C.plotLineDashGap=(0,i.pluckNumber)(S.plotlinedashgap,4),this._conatinerHidden=!!this.getState("visible"),C.defaultPadding={left:.5,right:.5},C.plotType="line",C.parentYAxis=0,C.toolText=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(w.tooltext,S.plottooltext),!1)),C.name=(0,i.getValidValue)(w.seriesname),C.showTooltip=(0,i.pluckNumber)(S.showtooltip,1),C.maxColWidth=Math.abs((0,i.pluckNumber)((0,i.pluck)(S.maxcolwidth),50))||1,C.enableAnimation=(0,i.pluckNumber)(S.animation,S.defaultanimation,1),C.animation=!!C.enableAnimation&&{duration:1e3*(0,i.pluckNumber)(S.animationduration,1)},C.lineAlpha=(0,i.pluck)(S.plotlinealpha,"100"),y=Math.max((0,i.pluckNumber)(S.plotspacepercent,20)%100,0),C.plotSpacePercent=C.groupPadding=y/200,b=this.components.data=this.components.data||(this.components.data=[]),C.valuePadding=(0,i.pluckNumber)(w.valuepadding,S.valuepadding,2),C.plotBorderThickness=_,C.showvalues=1,C.showShadow=(0,i.pluckNumber)(S.showshadow,D.getColor("showShadow")),l=0;l<N;l+=1)x=A[l],(s=b[l])||(s=b[l]={}),!s.config&&(s.config={}),!s.graphics&&(s.graphics={}),k=s.config,x&&!x.vline&&(k.setLink=(0,i.pluck)(x.link),h=k.open=L.getCleanValue(x.open),u=k.close=L.getCleanValue(x.close),p=k.high=L.getCleanValue(x.high),g=k.low=L.getCleanValue(x.low),k.volume=L.getCleanValue(x.volume,!0),v=k.x=L.getCleanValue(x.x),k.closeVal=Math.min(h,u),k.yVal=Math.max(h,u),f=Math.min(h,u,p,g),m=Math.max(h,u,p,g),k.valuePadding=(0,i.pluckNumber)(x.valuepadding,C.valuePadding),a=(0,i.getFirstColor)((0,i.pluck)(x.bordercolor,u<h?E:F)),o=(0,i.pluck)(x.alpha,C.lineAlpha),t=(0,i.getFirstColor)((0,i.pluck)(x.color,u<h?T:P)),r=(0,i.pluckNumber)(x.dashed)?(0,i.getDashStyle)(C.plotLineDashLen,C.plotLineDashGap):"none",k.dashStyle=r,n={opacity:C.showShadow?o/100:0},k.rawDataColor=t,k.color=a,k.alpha=o,k.dashed=(0,i.pluckNumber)(C.plotLineDashed,x.dashed,0),k.setColor=k.color,k.setAlpha=k.alpha,k.anchorImageUrl=(0,i.pluck)(x.anchorimageurl,w.anchorimageurl,S.anchorimageurl),k.borderColor=a,k.borderAlpha=k.plotLineAlpha,k.colorArr=[{color:k.color,alpha:k.alpha},{color:k.borderColor,alpha:k.borderAlpha}],k.dataLabelStyle=this._configureDataLabelStyle(x),k.anchorSides=(0,i.pluckNumber)(x.anchorsides,w.anchorsides,S.anchorsides),k.symbol=(0,i.mapSymbolName)(k.anchorSides).split("_"),k.anchorProps={enabled:V,bgColor:R,symbol:k.symbol,bgAlpha:H*G/100+"",borderColor:M,borderAlpha:G,anchorAlpha:G,borderThickness:O,imageUrl:k.anchorImageUrl,radius:B,imageScale:(0,i.pluckNumber)(x.imagescale,w.imagescale,S.imagescale,100),imagePadding:(0,i.pluckNumber)(x.anchorimagepadding,w.anchorimagepadding,S.anchorimagepadding,1),imageAlpha:(0,i.pluckNumber)(w.anchorimagealpha,S.anchorimagealpha,100),startAngle:I},k.showValue=x.displayvalue?1:0,k.hoverEffects={},k.anchorSides=(0,i.pluckNumber)(x.anchorsides,w.anchorsides,S.anchorsides),k.symbol=(0,i.mapSymbolName)(k.anchorSides).split("_"),k.hoverEffects={},k.y=u,k.link=(0,i.pluck)(x.link),k.toolText=this._parseToolText(l),k.toolTipValue=i.BLANKSTRING,k.setValue=k._y=k.y,k.displayValue=(0,i.parseUnsafeString)((0,i.pluck)(x.displayvalue,x.valuetext,"")),null!==f&&(z=Math.max(z,f),W=Math.min(W,f)),null!==m&&(z=Math.max(z,m),W=Math.min(W,m)),null!==v&&(U=Math.max(U,v),j=Math.min(j,v)),v=v||l+1,k._x=k.x=v,k.high=Math.max(h,u,p,g),k.low=Math.min(h,u,p,g),k.shadow=n);C.yMax=z,C.yMin=W,C.xMax=U,C.xMin=j,this.setState("dirty",!0)},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.drawLine=1},a.addDatasetSpecificEvtArgs=function(e){var t=e,a=t.config,o=t.config.eventArgs;Object.assign(o,{open:a.open,close:a.close,high:a.high,low:a.low,volume:a.volume,alpha:a.alpha,x:a.x,displayValue:a.displayValue,color:a.rawDataColor,borderColor:a.borderColor,dashed:a.dashed})},a.trimData=function(e){if(this.components||!this.components.data||!this.components.data.length){var t=this.components,a=t&&t.data,o=a&&a.length,r=e.data,i=Array.isArray(r)&&r.filter((function(e){return e.high||e.open||e.close||e.low})).length||0,n=o-i;n>0&&this.removeData(i,n,!1)}},a.calculateScrollRange=function(){var e=this.config,t=this.components.data&&this.components.data.length;e.scrollMinVal=e.scrollMinValForLabel=0,e.scrollMaxVal=e.scrollMaxValForLabel=t},a.getDataLimits=function(){var e=this.config;return{max:e.yMax,min:e.yMin,xMax:e.xMax,xMin:e.xMin}},a.getPlotIndices=function(e){var t,a,o=Math.floor(e),r=Math.ceil(e),i=[],n=this.config.JSONData&&this.config.JSONData.data;for(t=n.length;t--;)(a=n[t]).x>=o&&a.x<=r&&i.push(t);return i},a._parseToolText=function(e){return l._parseToolText.call(this,e)},a._getHoveredPlot=function(e,t){var a,o,r,i,n,l,s=e,c=t,d=this.getFromEnv("xAxis"),h=this.components.data,u=this.config,p=u&&u.radius||0;s+=d.getTranslation();var g=(r=(o=this.getPlotIndices(Math.floor(Math.max(d.getValue(s-p),0))))[0])>(i=(o=this.getPlotIndices(Math.ceil(Math.min(d.getValue(s+p),h.length-1))))[o.length-1])?[i,r]:[r,i];for(r=g[0],l=i=g[1];l>=r&&(!(a=h[l])||!(n=this.isWithinShape(a,l,s,c)));l--);return n},a.getName=function(){return"candlestickline"},t}(n["default"]);t["default"]=h},1022:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(538)),n=a(224),l=a(1017),s=n.preDefStr.colors,c=s.B90000,d=s.FFFFFF,h=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,i,l,s,h,u,p,g,f,m,v,b,x,k,y=this.config,C=this.config.JSONData,w=C.data||[],A=this.getFromEnv("chart-attrib"),S=this.getFromEnv("chartConfig"),N=w.length,L=this.getFromEnv("color-manager"),D=y.bearBorderColor=(0,n.getFirstColor)((0,n.pluck)(A.bearbordercolor,S.vplotbordercolor,c)),E=y.bearFillColor=(0,n.getFirstColor)((0,n.pluck)(A.bearfillcolor,c)),T=y.bullBorderColor=(0,n.getFirstColor)((0,n.pluck)(A.bullbordercolor,S.vplotbordercolor,L.getColor("canvasBorderColor"))),F=y.bullFillColor=(0,n.getFirstColor)((0,n.pluck)(A.bullfillcolor,d)),P=(0,n.pluckNumber)(S.showplotborder,1)?(0,n.pluckNumber)(A.vplotborderthickness,1):0,_=this.getFromEnv("number-formatter"),V=-Infinity,I=+Infinity,B=-Infinity,M=+Infinity;for(this.setState("visible",1===(0,n.pluckNumber)(C.visible,1)),!0===this.getState("visible")?this._conatinerHidden=!1:this._containerHidden=!0,y.minAbsNonZeroValue=Infinity,y.minAbsNonZeroData={},y.parentYAxis=1,y.volumeToolText=(0,n.getValidValue)((0,n.parseUnsafeString)((0,n.pluck)(C.volumetooltext,A.volumetooltext,A.plottooltext),!1)),y.name=(0,n.getValidValue)(C.seriesname),y.showTooltip=(0,n.pluckNumber)(A.showtooltip,1),y.showShadow=(0,n.pluckNumber)(A.showshadow,L.getColor("showShadow")),y.maxColWidth=Math.abs((0,n.pluckNumber)((0,n.pluck)(A.maxcolwidth),50))||1,k=Math.max((0,n.pluckNumber)(A.plotspacepercent,20)%100,0),y.plotSpacePercent=y.groupPadding=k/200,y.plotborderthickness=P,v=this.components.data=this.components.data||(this.components.data=[]),g=(0,n.extend2)((0,n.extend2)({},A),{sforcedecimals:(0,n.getFirstValue)(A.forcevdecimals,A.forcedecimals),sforceyaxisvaluedecimals:(0,n.getFirstValue)(A.forcevyaxisvaluedecimals,A.forceyaxisvaluedecimals),syaxisvaluedecimals:(0,n.getFirstValue)(A.vyaxisvaluedecimals,A.yaxisvaluedecimals),sformatnumber:(0,n.getFirstValue)(A.vformatnumber,A.formatnumber),sformatnumberscale:(0,n.getFirstValue)(A.vformatnumberscale,A.formatnumberscale,"1"),sdefaultnumberscale:(0,n.getFirstValue)(A.vdefaultnumberscale,A.defaultnumberscale),snumberscaleunit:(0,n.getFirstValue)(A.vnumberscaleunit,A.numberscaleunit),vnumberscalevalue:(0,n.getFirstValue)(A.vnumberscalevalue,A.numberscalevalue),sscalerecursively:(0,n.getFirstValue)(A.vscalerecursively,A.scalerecursively),smaxscalerecursion:(0,n.getFirstValue)(A.vmaxscalerecursion,A.maxscalerecursion),sscaleseparator:(0,n.getFirstValue)(A.vscaleseparator,A.scaleseparator),snumberprefix:(0,n.getFirstValue)(A.vnumberprefix,A.numberprefix),snumbersuffix:(0,n.getFirstValue)(A.vnumbersuffix,A.numbersuffix),sdecimals:(0,n.getFirstValue)(A.vdecimals,A.decimals)}),f=y.plotLineDashLen=(0,n.pluckNumber)(A.plotlinedashlen,5),m=y.plotLineDashGap=(0,n.pluckNumber)(A.plotlinedashgap,4),this.getFromEnv("number-formatter").configure(g),r=0;r<N;r+=1)b=w[r],(i=v[r])||(i=v[r]={}),!i.config&&(i.config={}),!i.graphics&&(i.graphics={}),x=i.config,b&&!b.vline&&(l=x.open=_.getCleanValue(b.open),s=x.close=_.getCleanValue(b.close),h=x.volume=_.getCleanValue(b.volume,!0),x.high=_.getCleanValue(b.high),x.low=_.getCleanValue(b.low),u=x.x=_.getCleanValue(b.x),V=Math.max(V,h),I=Math.min(I,h),B=Math.max(B,u),M=Math.min(M,u),x.borderColor=(0,n.getFirstColor)((0,n.pluck)(b.bordercolor,s<l?D:T)),a=(0,n.pluckNumber)(b.alpha,100),p=(0,n.pluckNumber)(S.vplotborderalpha,b.alpha,100),t=(0,n.getFirstColor)((0,n.pluck)(b.color,s<l?E:F)),o={opacity:y.showShadow?a/100:0},x.color=t,x.alpha=a,x.setLink=b.link,x.borderWidth=P,x.borderAlpha=p,x.y=h,x.colorArr=[{color:x.color,alpha:x.alpha},{color:x.borderColor,alpha:x.borderAlpha}],x.toolText=this._parseToolText(r),x.toolTipValue=n.BLANKSTRING,x.setValue=x._y=x.y,0!==h&&y.minAbsNonZeroValue>Math.abs(h)&&(y.minAbsNonZeroValue=Math.abs(h),y.minAbsNonZeroData=x),x.dashed=(0,n.pluckNumber)(y.plotLineDashed,b.dashed,0),x.plotBorderDashStyle=(0,n.pluckNumber)(b.dashed)?(0,n.getDashStyle)(f,m):"none",u=null!==u?u:r+1,x._x=u,x.shadow=o);y.defaultPadding={left:0,right:0},y.yMax=V,y.yMin=I,y.xMax=B,y.xMin=M,this.setState("dirty",!0)},a._parseToolText=function(e){return l._parseToolText.call(this,e)},a.getPlotIndices=function(e){var t,a,o=Math.floor(e),r=Math.ceil(e),i=[],n=this.config.JSONData&&this.config.JSONData.data;for(t=n.length;t--;)(a=n[t]).x>=o&&a.x<=r&&i.push(t);return i},a._getHoveredPlot=function(e,t){var a,o,r,i,n,l=e,s=t,c=this.getFromEnv("xAxis");for(l+=c.getTranslation(),a=c.getValue(l),o=(i=this.getPlotIndices(a)).length-1;o>-1&&!(r=(n=i[o])-a>0?this._checkPointerOverColumn(n,l,s)||this._checkPointerOverColumn(n-1,l,s):this._checkPointerOverColumn(n+1,l,s)||this._checkPointerOverColumn(n,l,s));o--);return r},a.getDataLimits=function(){var e=this.config;return{max:e.yMax,min:e.yMin,xMax:e.xMax,xMin:e.xMin}},a.addDatasetSpecificEvtArgs=function(e){var t=e,a=t.config,o=t.trackerConfig.eventArgs;Object.assign(o,{open:a.open,close:a.close,high:a.high,low:a.low,volume:a.volume,alpha:a.alpha,x:a.x,displayValue:a.displayValue,color:a.color,borderColor:a.borderColor,dashed:a.dashed})},a.calculateScrollRange=function(){var e=this.config;e.scrollMinVal=0,e.scrollMaxVal=this.components.data&&this.components.data.length,e.scrollMinValForLabel=e.scrollMinVal,e.scrollMaxValForLabel=e.scrollMaxVal},a.drawLabel=function(){},a.getName=function(){return"volume"},t}(i["default"]);t["default"]=h},1023:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(555)),n=a(224),l=a(232),s=o(a(1024));(0,l.addDep)({name:"trendsetAnimation",type:"animationRule",extension:s["default"]});var c=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.drawLine=1},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,i,l,s=this.getFromEnv("chart-attrib"),c=this.config.JSONData,d=this.index,h=c.data||c.set||[],u=this.config,p=this.components.data,g=-Infinity,f=+Infinity,m=-Infinity,v=+Infinity,b=this.getFromEnv("number-formatter"),x=(0,n.getFirstColor)((0,n.pluck)(c.color,s.trendsetcolor,"666666")),k=(0,n.pluck)(c.alpha,s.trendsetalpha,"100"),y=(0,n.pluckNumber)(c.thickness,s.trendsetthickness,2),C=Boolean((0,n.pluckNumber)(c.dashed,s.trendsetdashed,0)),w=(0,n.pluckNumber)(c.dashlen,s.trendsetdashlen,4),A=(0,n.pluckNumber)(c.dashgap,s.trendsetdashgap,4);for(u.includeInLegend=(0,n.pluckNumber)(c.includeinlegend,1),u.lineColor=x,u.lineAlpha=k,u.connectNullData=(0,n.pluckNumber)(s.connectnulldata,0),u.linethickness=y,u.lineDashStyle=C?(0,n.getDashStyle)(w,A):"none",u.name=(0,n.getValidValue)(c.name),u.includeInLegend=(0,n.pluckNumber)(c.includeinlegend,1),u.defaultPadding={left:.5,right:.5},p||(p=this.components.data=[]),d=0,l=h.length;d<l;d+=1)(t=h[d])&&!t.vline&&(a=(r=(o=p[d]=p[d]||(p[d]={})).config=o.config||(o.config={}))._y=r.setValue=b.getCleanValue(t.value),r.setColor=u.lineColor,r.setAlpha=u.lineAlpha,i=b.getCleanValue(t.x),i=r._x=r.x=null!==i?i:d+1,g=Math.max(g,a),f=Math.min(f,a),v=Math.min(v,i),m=Math.max(m,i),r.anchorProps=this._parseAnchorProperties(d),r.hoverEffects={},o.graphics||(o.graphics={}));u.max=g,u.min=f,u.xMax=m,u.xMin=v,this.getFromEnv("chartConfig").showLegend&&this._addLegend(),this.setState("visible",!0),this.setState("dirty",!0)},a._addLegend=function(){var e,t=this.config,a=this.getFromEnv("legend");t.includeinlegend?((e=a.getItem(this.config.legendItemId))?e.configure({style:a.config.itemStyle,hiddenStyle:a.config.itemHiddenStyle,datasetVisible:a.config.datasetVisible,hoverStyle:a.config.itemHoverStyle}):(this.config.legendItemId=a.createItem(this),e=a.getItem(this.config.legendItemId)),e.configure({enabled:t.includeInLegend,interactiveLegend:!1,type:this.type,drawLine:!0,label:(0,n.getFirstValue)(this.config.JSONData.name)}),e.setStateCosmetics("default",{symbol:{stroke:(0,n.toRaphaelColor)({color:t.lineColor,alpha:"100"}),rawFillColor:t.lineColor}})):this.config.legendItemId&&a.disposeItem(this.config.legendItemId)},a.getDataLimits=function(){var e=this.config;return{max:e.max,min:e.min,xMax:e.xMax,xMin:e.xMin}},a.getType=function(){return"trendset"},a.drawLabel=function(){},a.getName=function(){return"trendset"},t}(i["default"]);t["default"]=c},1024:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"initial.trendset.trendset":o(a(558))["default"]["initial.dataset.line"]};t["default"]=r},1025:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o,n,l,s=e.getChildren("canvas"),c=s[0],d=s[1],h=e.config.showVolumeChart,u={zoomable:!0,pannable:!0},p=c.getChildren("axisRefVisualCartesian")[0],g=function(){return p.asyncDraw()},f=function(){return a.asyncDraw()};t=e._feedAxesRawData(),(0,r.componentFactory)(e,i["default"],"yAxis",h?2:1,t.yAxisConfigure),(0,r.componentFactory)(e,i["default"],"xAxis",1,t.xAxisConfigure),n=e.getChildren("yAxis")[0],o=e.getChildren("yAxis")[1],n.setAxisConfig({relativeAxis:o}),o&&o.setAxisConfig({relativeAxis:n}),l=e.getChildren("xAxis")[0],n.setLinkedItem("canvas",c),l.setLinkedItem("canvas",c),p.setLinkedItem(n.getId(),n),p.setLinkedItem(l.getId(),l),p.addExtEventListener("visiblerangeset",g,n),p.addExtEventListener("visiblerangeset",g,l),c.attachAxis(l,!1,e.zoomX?u:{}),c.attachAxis(n,!0,e.zoomY?u:{}),h&&(a=d.getChildren("axisRefVisualCartesian")[0],d.attachAxis(l,!1,e.zoomX?u:{}),o.setLinkedItem("canvas",d),a.setLinkedItem(o.getId(),o),a.setLinkedItem(l.getId(),l),a.addExtEventListener("visiblerangeset",f,o),a.addExtEventListener("visiblerangeset",f,l),d.attachAxis(o,!0,e.zoomY?u:{}));e._setCategories()};var r=a(224),i=o(a(481))},1026:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1027))["default"];t["default"]=r},1027:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(242)),i=o(a(238)),n=a(224),l=o(a(482)),s=o(a(634)),c=a(629),d=o(a(1028)),h=o(a(1032)),u=o(a(1034));n.setAttribDefs&&(0,n.setAttribDefs)({whiskerslimitswidthratio:{type:n.attrTypeNum,pAttr:"whiskerslimitswidthratio"},outliersupperrangeratio:{type:n.attrTypeNum,pAttr:"outliersupperrangeratio"},outlierslowerrangeratio:{type:n.attrTypeNum,pAttr:"outlierslowerrangeratio"},showalloutliers:{type:n.attrTypeNum,pAttr:"showalloutliers"},showmean:{type:n.attrTypeNum,pAttr:"showmean"},showsd:{type:n.attrTypeNum,pAttr:"showsd"},showmd:{type:n.attrTypeNum,pAttr:"showmd"},showqd:{type:n.attrTypeNum,pAttr:"showqd"},showminvalues:{type:n.attrTypeNum,pAttr:"showminvalues"},showmaxvalues:{type:n.attrTypeNum,pAttr:"showmaxvalues"},showq1values:{type:n.attrTypeNum,pAttr:"showq1values"},showq3values:{type:n.attrTypeNum,pAttr:"showq3values"},showmedianvalues:{type:n.attrTypeNum,pAttr:"showmedianvalues"}});var p=n.preDefStr.POLYGON,g=n.preDefStr.colors.c000000,f=function(e){(0,i["default"])(a,e),a.getName=function(){return"BoxAndWhisker2D"};var t=a.prototype;function a(){var t;t=e.call(this)||this;var a=(0,r["default"])(t);return a.maxColWidth=+Infinity,a.useErrorAnimation=1,a.avoidCrispError=0,a.plotSpacePercent=20,a.useplotgradientcolor=1,a.fireGroupEvent=!0,a.hasScroll=!0,a.eiMethods.scrollTo=c.scrollTo,t.registerFactory("dataset",h["default"],["vCanvas"]),t}return t.getName=function(){return"BoxAndWhisker2D"},a.includeInputOptions=function(){return["SwipeGesture"]},t.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.avgScrollPointWidth=40,t.decimals=2,t.defaultDatasetType="boxandwhisker2d",t.showplotborder=1,t.plotborderdashlen=5,t.plotborderdashgap=4,t.plotfillalpha=n.HUNDREDSTRING,t.useroundedges=0,t.plotborderthickness=1,t.showvalues=1,t.valuepadding=2,t.decimals=2,t.showtooltip=1,t.maxcolwidth=50,t.rotatevalues=0,t.use3dlighting=1,t.whiskerslimitswidthratio=40,t.outliersupperrangeratio=0,t.outlierslowerrangeratio=0,t.showalloutliers=0,t.showmean=0,t.showsd=0,t.showmd=0,t.showqd=0,t.showminvalues=1,t.showmaxvalues=1,t.showq1values=0,t.showq3values=0,t.showmedianvalues=1,t.tooltipsepchar=": ",t.anchorborderthickness=1,t.anchorimageurl=void 0,t.anchorimagepadding=1,t.anchorsides=1,t.anchoralpha=void 0,t.anchorbgalpha=n.HUNDREDSTRING,t.anchorimagealpha=n.HUNDREDSTRING,t.anchorimagescale=100,t.anchorstartangle=90,t.anchorshadow=0,t.anchorbgcolor=void 0,t.anchorbordercolor=void 0,t.anchorradius=3,t.linedashlen=5,t.linedashgap=4,t.linedashed=void 0,t.linealpha=n.HUNDREDSTRING,t.linethickness=2,t.drawfullareaborder=1,t.connectnulldata=0},t.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t),c.configurer.call(this,t)},t._setAxisScale=function(){c.setAxisScale.call(this,"boxandwhisker2d")},t._resetViewPortConfig=function(){c.resetViewPortConfig.call(this)},t._getLineJSONdata=function(){var e,t,a,o,r,i,s,c,d,h,u,f,m,v,b,x,k,y,C,w,A,S,N,L,D=this.getChildren("BoxAndWhiskerStatisticalCalc")[0],E=this.getFromEnv("dataSource"),T=E.chart,F=E.dataset,P=F.length,_=[],V=[],I=[],B=function(e){k=Number(e);var t=D.values?(0,l["default"])(D.values):[r.min,r.max];b=t[0],x=t[1],(k<b||k>x)&&v.push({showvalue:r.showoutliervalue,valueposition:r.outliervalueposition,value:k,index:S,anchorbgcolor:r.outliericoncolor,anchorbordercolor:r.outliericonbordercolor,anchorradius:r.outliericonradius,anchoralpha:r.outliericonalpha,anchorbgalpha:r.outliericonalpha,anchorsides:r.outliericonsides,dip:r.outliericonshape})};for(L=0;L<P;L++)for(t=F[L],d=V[L]={},s=I[L]={showMean:{seriesname:"Mean",valueposition:(0,n.pluck)(t.meanvalueposition,T.meanvalueposition,"above"),showvalues:(0,n.pluckNumber)(t.showmeanvalues,T.showmeanvalues,0),anchorbgcolor:(0,n.pluck)(t.meaniconcolor,T.meaniconcolor,g),anchorbordercolor:(0,n.pluck)(t.meaniconbordercolor,T.meaniconbordercolor,g),anchorradius:(0,n.pluckNumber)(t.meaniconradius,T.meaniconradius,5),anchoralpha:(0,n.pluck)(t.alpha,t.meaniconalpha,T.meaniconalpha),linethickness:(0,n.pluck)(t.linethickness,T.linethickness,1),anchorsides:(0,n.pluck)(t.meaniconsides,T.meaniconsides,3),showline:!(0,n.pluckNumber)(t.drawmeanconnector,T.drawmeanconnector),dip:(0,n.pluck)(t.meaniconshape,T.meaniconshape,p),color:(0,n.pluck)(t.meaniconcolor,T.meaniconcolor,g),data:[]},showSD:{seriesname:"SD",valueposition:(0,n.pluck)(t.sdvalueposition,T.sdvalueposition,"above"),showvalues:(0,n.pluckNumber)(t.showsdvalues,T.showsdvalues,0),anchorbgcolor:(0,n.pluck)(t.sdiconcolor,T.sdiconcolor,g),anchorbordercolor:(0,n.pluck)(t.sdiconbordercolor,T.sdiconbordercolor,g),anchorradius:(0,n.pluckNumber)(t.sdiconradius,T.sdiconradius,5),anchoralpha:(0,n.pluck)(t.alpha,t.sdiconalpha,T.sdiconalpha),anchorbgalpha:(0,n.pluck)(t.sdiconalpha,T.sdiconalpha,100),linethickness:(0,n.pluck)(t.linethickness,T.linethickness,1),anchorsides:(0,n.pluck)(t.sdiconsides,T.sdiconsides,3),showline:!(0,n.pluckNumber)(t.drawsdconnector,T.drawsdconnector),dip:(0,n.pluck)(t.sdiconshape,T.sdiconshape,p),color:(0,n.pluck)(t.sdiconcolor,T.sdiconcolor,g),data:[]},showQD:{seriesname:"QD",valueposition:(0,n.pluck)(t.qdvalueposition,T.qdvalueposition,"above"),showvalues:(0,n.pluckNumber)(t.showqdvalues,T.showqdvalues,0),anchorbgcolor:(0,n.pluck)(t.qdiconcolor,T.qdiconcolor,g),anchorbordercolor:(0,n.pluck)(t.qdiconbordercolor,T.qdiconbordercolor,g),anchorradius:(0,n.pluckNumber)(t.qdiconradius,T.qdiconradius,5),anchoralpha:(0,n.pluck)(t.alpha,t.qdiconalpha,T.qdiconalpha),anchorbgalpha:(0,n.pluck)(t.qdiconalpha,T.qdiconalpha,100),linethickness:(0,n.pluck)(t.linethickness,T.linethickness,1),anchorsides:(0,n.pluck)(t.qdiconsides,T.qdiconsides,3),showline:!(0,n.pluckNumber)(t.drawqdconnector,T.drawqdconnector),dip:(0,n.pluck)(t.qdiconshape,T.qdiconshape,p),color:(0,n.pluck)(t.qdiconcolor,T.qdiconcolor,g),data:[]},showMD:{seriesname:"MD",valueposition:(0,n.pluck)(t.mdvalueposition,T.mdvalueposition,"above"),showvalues:(0,n.pluckNumber)(t.showmdvalues,T.showmdvalues,0),anchorbgcolor:(0,n.pluck)(t.mdiconcolor,T.mdiconcolor,g),anchorbordercolor:(0,n.pluck)(t.mdiconbordercolor,T.mdiconbordercolor,g),anchorradius:(0,n.pluckNumber)(t.mdiconradius,T.mdiconradius,5),anchoralpha:(0,n.pluck)(t.alpha,t.mdiconalpha,T.mdiconalpha),anchorbgalpha:(0,n.pluck)(t.mdiconalpha,T.mdiconalpha,100),linethickness:(0,n.pluck)(t.linethickness,T.linethickness,1),anchorsides:(0,n.pluck)(t.mdiconsides,T.mdiconsides,3),showline:!(0,n.pluckNumber)(t.drawmdconnector,T.drawmdconnector),dip:(0,n.pluck)(t.mdiconshape,T.mdiconshape,p),color:(0,n.pluck)(t.mdiconcolor,T.mdiconcolor,g),data:[]},outliers:{seriesname:"Outliers",valueposition:(0,n.pluck)(t.outliervalueposition,T.outliervalueposition,"above"),showvalues:(0,n.pluckNumber)(t.showoutliervalues,T.showoutliervalues,0),anchorbgcolor:(0,n.pluck)(t.outliericoncolor,T.outliericoncolor,g),anchorbordercolor:(0,n.pluck)(t.outliericonbordercolor,T.outliericonbordercolor,g),anchorradius:(0,n.pluckNumber)(t.outliericonradius,T.outliericonradius,5),anchoralpha:(0,n.pluck)(t.alpha,t.outliericonalpha,T.outliericonalpha),includeinlegend:t.seriesname?1:0,anchorbgalpha:(0,n.pluck)(t.outliericonalpha,T.outliericonalpha,100),linethickness:(0,n.pluck)(t.linethickness,T.linethickness,1),anchorsides:(0,n.pluck)(t.outliericonsides,T.outliericonsides,3),showline:!(0,n.pluckNumber)(t.drawoutliersconnector,T.drawoutliersconnector),color:(0,n.pluck)(t.outliericoncolor,T.outliericoncolor,g),dip:(0,n.pluck)(t.outliericonshape,T.outliericonshape,p),data:[]}},e=(0,n.pluckNumber)(t.showmean,T.showmean,0),h=(0,n.pluckNumber)(t.showsd,T.showsd,0),u=(0,n.pluckNumber)(t.showqd,T.showqd,0),f=(0,n.pluckNumber)(t.showmd,T.showmd,0),o=(a=t.data)&&a.length||0,S=0;S<o;S++)(r=a[S]).min&&r.max&&r.q1&&r.q3&&r.median?(y=r.mean,C=r.sd,w=r.md,A=r.qd):(D.setArray(r.value),D.getQuartiles(),y=D.getMean(),C=D.getSD(),A=D.getQD(),w=D.getMD()),m=r.outliers,e=d.showMean=d.showMean||(0,n.pluckNumber)(r.showmean,e),h=d.showSD=d.showSD||(0,n.pluckNumber)(r.showsd,h),u=d.showQD=d.showQD||(0,n.pluckNumber)(r.showqd,u),f=d.showMD=d.showMD||(0,n.pluckNumber)(r.showmd,f),s.showMean.data.push({showvalue:r.showmeanvalue,valueposition:r.meanvalueposition,value:e&&(y||void 0),anchorbgcolor:r.meaniconcolor,anchorbordercolor:r.meaniconbordercolor,anchorradius:r.meaniconradius,anchoralpha:r.meaniconalpha,anchorbgalpha:r.meaniconalpha,anchorsides:r.meaniconsides,dip:r.meaniconshape}),s.showSD.data.push({showvalue:r.showsdvalue,valueposition:r.sdvalueposition,value:h&&(C||void 0),anchorbgcolor:r.sdiconcolor,anchorbordercolor:r.sdiconbordercolor,anchorradius:r.sdiconradius,anchoralpha:r.sdiconalpha,anchorbgalpha:r.sdiconalpha,anchorsides:r.sdiconsides,dip:r.sdiconshape}),s.showQD.data.push({showvalue:r.showqdvalue,valueposition:r.qdvalueposition,value:u&&(A||void 0),anchorbgcolor:r.qdiconcolor,anchorbordercolor:r.qdiconbordercolor,anchorradius:r.qdiconradius,anchoralpha:r.qdiconalpha,anchorbgalpha:r.qdiconalpha,anchorsides:r.qdiconsides,dip:r.qdiconshape}),s.showMD.data.push({showvalue:r.showmdvalue,valueposition:r.mdvalueposition,value:f&&(w||void 0),anchorbgcolor:r.mdiconcolor,anchorbordercolor:r.mdiconbordercolor,anchorradius:r.mdiconradius,anchoralpha:r.mdiconalpha,anchorbgalpha:r.mdiconalpha,anchorsides:r.mdiconsides,dip:r.mdiconshape}),m&&(v=s.outliers.data,m.split(n.COMMA).forEach(B),d.outliers=!0);for(c=V.length,N=0;N<c;N++)for(L in d=V[N],i=_[N]=[],d)d[L]&&i.push(I[N][L]);return _},t.getDSdef=function(){return d["default"]},t.getDSGroupdef=function(){return u["default"]},a}(s["default"]);t["default"]=f},1028:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(538)),n=o(a(1029)),l=a(224),s=a(232),c=o(a(1031)),d=l.preDefStr.colors.c000000,h=l.preDefStr.LABEL,u=l.preDefStr.UNDERSCORE,p=l.preDefStr.POINTER,g=l.preDefStr.BLANK,f=l.preDefStr.ROUND,m=l.preDefStr.GROUPID,v=l.preDefStr.POSITION_START,b=l.preDefStr.POSITION_BOTTOM,x=l.preDefStr.POSITION_TOP,k=l.preDefStr.showHoverEffectStr,y=l.preDefStr.EVENTARGS,C=l.preDefStr.POSITION_END,w="M",A="H",S="V",N=l.preDefStr.pStr,L=l.preDefStr.sStr,D=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:e,container:t,component:a,label:"group"})},E=function(){return function(){this.hide()}};(0,s.addDep)({name:"boxandwhisker2dAnimation",type:"animationRule",extension:c["default"]});var T=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.createContainer=function(){var e,t,a=this.getLinkedParent(),o=this.groupName||this.dsGroup||this.type;!a.getChildContainer(o+"VcanvasGroup")&&(o="default"),e=a.getChildContainer(o+"VcanvasGroup"),t=a.getChildContainer(o+"ShadowVcanvasGroup"),!this.getContainer("shadowGroup")&&this.addContainer("shadowGroup",D({name:"shadow-group"},t,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("lowerBoxGroup",D({name:"lower-box-group"},e,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("upperBoxGroup",D({name:"upper-box-group"},e,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("upperWhiskerGroup",D({name:"upper-whisker-group"},e,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("lowerWhiskerGroup",D({name:"lower-whisker-group"},e,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("medianGroup",D({name:"median-group"},e,this)),!this.getContainer("labelGroup")&&this.addContainer("labelGroup",D({name:"label-group","class":"fusioncharts-datalabels"},a.getChildContainer("vcanvasLabelGroup"),this))},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,i,n,s,c,d,h,u,p,g,f,m,v,b,x,k,y,C,w,A,S,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K,q,Y,X,Q,Z,$,ee,te,ae,oe,re,ie,ne,le,se,ce,de,he,ue,pe,ge,fe,me,ve,be,xe,ke,ye,Ce,we,Ae,Se,Ne,Le,De,Ee,Te,Fe=this.config,Pe=this.config.JSONData,_e=Pe.data,Ve=_e&&_e.length,Ie=this.getFromEnv("chartConfig"),Be=this.getFromEnv("xAxis"),Me=Be.getTicksLen(),Oe=Math.min(Me,Ve),Re=this.getFromEnv("chart-attrib"),Ge=this.getFromEnv("color-manager"),He=Fe.index,ze=Fe.plotColor=Ge.getPlotColor(He),We=(0,l.pluckNumber)(Pe.dashed,Re.plotborderdashed),Ue=(0,l.parseUnsafeString)((0,l.pluck)(Re.tooltipsepchar,": ")),je=this.components.data,Je=this.getFromEnv("number-formatter"),Ke=-Infinity,qe=+Infinity,Ye=this.getFromEnv("BoxAndWhiskerStatisticalCalc");for(this.setState("visible",!(1!==(0,l.pluckNumber)(this.config.JSONData.visible,!Number(this.config.JSONData.initiallyhidden),1))),(0,l.parseConfiguration)(Pe,Fe,Ie,{data:!0}),Fe.defaultPadding={left:.5,right:.5},Fe.seriesname=(0,l.parseUnsafeString)(Pe.seriesname),Fe.includeInLegend=(0,l.pluckNumber)(Pe.includeinlegend,Fe.seriesname?1:0),Fe.legendSymbolColor=Fe.plotColor,s=Fe.plotborderdashlen,c=Fe.plotborderdashgap,g=Fe.plotfillalpha,h=Fe.useroundedges,f=Fe.ratio,d=Fe.plotborderthickness,Fe.rotatevalues&&(Fe.rotatevalues=270),Fe.plotfillAngle=p=(0,l.pluckNumber)(360-Re.plotfillangle,90),Fe.plotColor=ze=(0,l.pluck)(Pe.color,ze),Fe.plotRadius=(0,l.pluckNumber)(Re.useroundedges,h?1:0),Fe.showTextOutline=(0,l.pluckNumber)(Re.textoutline,0),Fe.plotgradientcolor=m=(0,l.getDefinedColor)(Re.plotgradientcolor,Ge.getColor("plotGradientColor")),!Ie.useplotgradientcolor&&(m=l.BLANKSTRING),Fe.plotBorderAlpha=v=Fe.showplotborder?(0,l.pluck)(Re.plotborderalpha,g,l.HUNDREDSTRING):0,Fe.plotBorderColor=b=(0,l.pluck)(Re.plotbordercolor,Ge.getColor("plotBorderColor")),Fe.plotBorderDashStyle=x=We?(0,l.getDashStyle)(s,c,d):"none",Fe.showShadow=h?(0,l.pluckNumber)(Re.showshadow,1):(0,l.pluckNumber)(Re.showshadow,Ge.getColor("showShadow")),Fe.showHoverEffect=u=(0,l.pluckNumber)(Re.plothovereffect,Re.showhovereffect,void 0),Fe.parentYAxis=q=(0,l.pluck)(Pe.parentyaxis&&Pe.parentyaxis.toLowerCase(),N)===L?1:0,Fe.dataSeparator=l.COMMASTRING,Fe.textDirection="1"===Re.hasrtltext?"rtl":l.BLANKSTRING,Fe.showMeanLegend=Fe.showSDLegend=Fe.showMDLegend=Fe.showQDLegend=Fe.showOutliersLegend=0,!this.components.data&&(this.components.data=[]),je=this.components.data,Fe.upperBoxColor=de=(0,l.pluck)(Pe.upperboxcolor,Re.upperboxcolor,Ge.getPlotColor(2*He)),he=Fe.upperBoxAlpha=(0,l.pluck)(Pe.upperboxalpha,Re.upperboxalpha,g,l.HUNDREDSTRING),Fe.lowerBoxColor=ue=(0,l.pluck)(Pe.lowerboxcolor,Re.lowerboxcolor,Ge.getPlotColor(2*He+1)),pe=Fe.lowerBoxAlpha=(0,l.pluck)(Pe.lowerboxalpha,Re.lowerboxalpha,g,l.HUNDREDSTRING),Z=0;Z<Oe;Z++){if(k=_e&&_e[Z],w=(C=je[Z])&&C.config,C||(C=je[Z]={graphics:{}}),C.config||(w=je[Z].config={}),k.min&&k.max&&k.q1&&k.q3&&k.median)ee=($={q1:k.q1,q3:k.q3}).q1,te=$.q3,ae={min:k.min,max:k.max},w.min=oe=ae.min,w.max=re=ae.max,ie=k.median,w.mean=ne=k.mean,w.md=le=k.md,w.sd=se=k.sd,w.qd=ce=k.qd,w.outliers=k.outliers,w.explicitData=!0;else{if(!k.value){w.setValue=void 0,w.explicitData=!1;continue}w.outliers=k.outliers,w.rawValue=k.value,Ye.setArray(k.value),ee=($=Ye.getQuartiles()).q1,te=$.q3,ae=Ye.getMinMax(),w.min=oe=ae.min,w.max=re=ae.max,ie=Ye.getMedian(),w.mean=ne=Ye.getMean(),w.md=le=Ye.getMD(),w.sd=se=Ye.getSD(),w.qd=ce=Ye.getQD(),w.explicitData=!1}ye=(0,l.pluck)(k.upperquartilecolor,Pe.upperquartilecolor,Re.upperquartilecolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),Ce=(0,l.pluckNumber)(k.upperquartilealpha,Pe.upperquartilealpha,Re.upperquartilealpha,Re.plotborderalpha,100),w.upperQuartile={value:te,color:(0,l.convertColor)(ye,Ce),rawColor:ye,alpha:Ce,borderWidth:(0,l.pluckNumber)(k.upperquartilethickness,Pe.upperquartilethickness,Re.upperquartilethickness,Re.plotborderthickness,h?0:1),displayValue:Je.dataLabels(te)},Le=(0,l.pluck)(k.lowerquartilecolor,Pe.lowerquartilecolor,Re.lowerquartilecolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),k.lowerquartilealpha,Pe.lowerquartilealpha,Re.lowerquartilealpha,Re.plotborderalpha,De=100,w.lowerQuartile={value:ee,color:(0,l.convertColor)(Le,De),rawColor:Le,alpha:De,borderWidth:(0,l.pluckNumber)(k.lowerquartilethickness,Pe.lowerquartilethickness,Re.lowerquartilethickness,Re.plotborderthickness,h?0:1),displayValue:Je.dataLabels(ee)},w.valuePadding=(0,l.pluckNumber)(k.valuepadding,Fe.valuepadding),we=(0,l.pluck)(k.upperboxbordercolor,Pe.upperboxbordercolor,Re.upperboxbordercolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),Ae=(0,l.pluckNumber)(k.upperboxborderalpha,Pe.upperboxborderalpha,Re.upperboxborderalpha,Re.plotborderalpha,100),w.upperBoxBorder={color:(0,l.convertColor)(we,Ae),rawColor:we,alpha:Ae,borderWidth:(0,l.pluckNumber)(k.upperboxborderthickness,Pe.upperboxborderthickness,Re.upperboxborderthickness,!h&&Re.plotborderthickness,h?0:1)},Se=(0,l.pluck)(k.lowerboxbordercolor,Pe.lowerboxbordercolor,Re.lowerboxbordercolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),Ne=(0,l.pluckNumber)(k.lowerboxborderalpha,Pe.lowerboxborderalpha,Re.lowerboxborderalpha,Re.plotborderalpha,100),w.lowerBoxBorder={color:(0,l.convertColor)(Se,Ne),rawColor:Se,alpha:Ne,borderWidth:(0,l.pluckNumber)(k.lowerboxborderthickness,Pe.lowerboxborderthickness,Re.lowerboxborderthickness,!h&&Re.plotborderthickness,h?0:1)},w.median={value:ie,color:(0,l.convertColor)((0,l.pluck)(k.mediancolor,Pe.mediancolor,Re.mediancolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),(0,l.pluckNumber)(k.medianalpha,Pe.medianalpha,Re.medianalpha,Re.plotborderalpha,100)),borderWidth:(0,l.pluckNumber)(k.medianthickness,Pe.medianthickness,Re.medianthickness,Re.plotborderthickness,1),displayValue:Je.dataLabels(ie)},Fe.upperBoxColor=de=(0,l.pluck)(k.upperboxcolor,Pe.upperboxcolor,Re.upperboxcolor,Ge.getPlotColor(2*He)),he=Fe.upperBoxAlpha=(0,l.pluck)(k.upperboxalpha,Pe.upperboxalpha,Re.upperboxalpha,g,l.HUNDREDSTRING),Fe.lowerBoxColor=ue=(0,l.pluck)(k.lowerboxcolor,Pe.lowerboxcolor,Re.lowerboxcolor,Ge.getPlotColor(2*He+1)),pe=Fe.lowerBoxAlpha=(0,l.pluck)(k.lowerboxalpha,Pe.lowerboxalpha,Re.lowerboxalpha,g,l.HUNDREDSTRING),w.upperBoxColor=de,w.upperBoxAlpha=he,w.upperColorArr=(0,l.getColumnColor)(de,he,void 0,void 0,h,b,v.toString(),0,!1),w.lowerBoxColor=ue,w.lowerBoxAlpha=pe,w.lowerColorArr=(0,l.getColumnColor)(ue,pe,void 0,void 0,h,b,v.toString(),0,!1),ge=(0,l.pluckNumber)(k.showmean,Pe.showmean,Re.showmean)&&(0,l.pluckNumber)(k.showmeanvalue,Pe.showmeanvalues,Re.showmeanvalues),me=(0,l.pluckNumber)(k.showmd,Pe.showmd,Re.showmd)&&(0,l.pluckNumber)(k.showmdvalue,Pe.showmdvalues,Re.showmdvalues),fe=(0,l.pluckNumber)(k.showsd,Pe.showsd,Re.showsd)&&(0,l.pluckNumber)(k.showsdvalue,Pe.showsdvalues,Re.showsdvalues),ve=(0,l.pluckNumber)(k.showqd,Pe.showqd,Re.showqd)&&(0,l.pluckNumber)(k.showqdvalue,Pe.showqdvalues,Re.showqdvalues),be=(0,l.pluckNumber)(k.showoutlier,Pe.showoutlier,Re.showoutlier)&&(0,l.pluckNumber)(k.showoutliervalue,Pe.showoutliervalues,Re.showoutliervalues),Ee=ge||me||fe||ve||be?0:1,w.showMinValues=(0,l.pluckNumber)(k.showminvalue,k.showvalue,Pe.showminvalues,Pe.showvalues,Re.showminvalues,Re.showvalues,Ee),w.showMaxValues=(0,l.pluckNumber)(k.showmaxvalue,k.showvalue,Pe.showmaxvalues,Pe.showvalues,Re.showmaxvalues,Re.showvalues,Ee),w.showMedianValues=(0,l.pluckNumber)(k.showmedianvalue,k.showvalue,Pe.showmedianvalues,Pe.showvalues,Re.showmedianvalues,Re.showvalues,Ee),w.showQ3Values=(0,l.pluckNumber)(k.showq3value,Pe.showq3values,Re.showq3values,0),w.showQ1Values=(0,l.pluckNumber)(k.showq1value,Pe.showq1values,Re.showq1values,0),w.upperWhiskerRawColor=(0,l.getFirstColor)((0,l.pluck)(k.upperwhiskercolor,Pe.upperwhiskercolor,Re.upperwhiskercolor,Re.plotbordercolor,Ge.getColor("plotBorderColor"))),w.upperWhiskerColor=(0,l.convertColor)(w.upperWhiskerRawColor,void 0),w.upperWhiskerThickness=(0,l.pluckNumber)(k.upperwhiskerthickness,Pe.upperwhiskerthickness,Re.upperwhiskerthickness,Re.plotborderthickness,1),w.upperWhiskerShadowOpacity=Fe.showShadow?NaN:0,w.lowerWhiskerAlpha=ke=(0,l.getFirstAlpha)((0,l.pluck)(k.lowerwhiskeralpha,Pe.lowerwhiskeralpha,Re.lowerwhiskeralpha,Re.plotborderalpha,100)),w.lowerWhiskerRawColor=(0,l.getFirstColor)((0,l.pluck)(k.lowerwhiskercolor,Pe.lowerwhiskercolor,Re.lowerwhiskercolor,Re.plotbordercolor,Ge.getColor("plotBorderColor"))),w.lowerWhiskerColor=(0,l.convertColor)(w.lowerWhiskerRawColor,ke),w.lowerWhiskerThickness=(0,l.pluckNumber)(k.lowerwhiskerthickness,Pe.lowerwhiskerthickness,Re.lowerwhiskerthickness,Re.plotborderthickness,1),w.lowerWhiskerShadowOpacity=Fe.showShadow?ke/100:0,w.setValue=y=Je.getCleanValue(k.value),w.setLink=(0,l.pluck)(k.link),w.toolTipValue=J=Je.dataLabels(y,q),w.setDisplayValue=K=(0,l.parseUnsafeString)(k.displayvalue),w.displayValue=(0,l.pluck)(K,J),Y=(0,l.pluckNumber)(k.dashed),X=(0,l.pluckNumber)(k.dashlen,s),Q=c=(0,l.pluckNumber)(k.dashgap,c),Ke=Math.max(Ke,re),qe=Math.min(qe,oe),w.dataLabelStyle=this._configureDataLabelStyle(k),w.plotBorderDashStyle=1===Y?(0,l.getDashStyle)(X,Q,d):0===Y?"none":x,ze=(0,l.pluck)(k.color,Fe.plotColor),g=(0,l.pluck)(k.alpha,Fe.plotfillalpha),y<0&&!h&&(i=p,p=360-p),w.colorArr=(0,l.getColumnColor)(ze+l.COMMA+m,g,f,p,h,b,v.toString(),0,!1),w.label=A=(0,l.getValidValue)((0,l.parseUnsafeString)(Be.getLabel((0,l.pluckNumber)(Z)).label)),0!==u&&(S=(0,l.pluck)(k.upperboxhovercolor,Pe.upperboxhovercolor,Re.upperboxhovercolor,de),D=(0,l.pluck)(k.upperboxhoveralpha,Pe.upperboxhoveralpha,Re.upperboxhoveralpha,he),E=(0,l.pluck)(k.upperboxborderhovercolor,Pe.upperboxborderhovercolor,Re.upperboxborderhovercolor,k.upperboxbordercolor,Pe.upperboxbordercolor,Re.upperboxbordercolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),T=(0,l.pluck)(k.upperboxborderhoveralpha,Pe.upperboxborderhoveralpha,Re.upperboxborderhoveralpha,k.upperboxborderalpha,Pe.upperboxborderalpha,Re.upperboxborderalpha,Re.plotborderalpha,100),F=h?0:(0,l.pluck)(k.upperboxborderhoverthickness,Pe.upperboxborderhoverthickness,Re.upperboxborderhoverthickness,w.upperBoxBorder.borderWidth),P=(0,l.pluck)(k.lowerboxhovercolor,Pe.lowerboxhovercolor,Re.lowerboxhovercolor,ue),_=(0,l.pluck)(k.lowerboxhoveralpha,Pe.lowerboxhoveralpha,Re.lowerboxhoveralpha,pe),V=(0,l.pluck)(k.lowerboxborderhovercolor,Pe.lowerboxborderhovercolor,Re.lowerboxborderhovercolor,k.lowerboxbordercolor,Pe.lowerboxbordercolor,Re.lowerboxbordercolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),I=(0,l.pluck)(k.lowerboxborderhoveralpha,Pe.lowerboxborderhoveralpha,Re.lowerboxborderhoveralpha,k.lowerboxborderalpha,Pe.lowerboxborderalpha,Re.lowerboxborderalpha,Re.plotborderalpha,100),B=h?0:(0,l.pluck)(k.lowerboxborderhoverthickness,Pe.lowerboxborderhoverthickness,Re.lowerboxborderhoverthickness,w.lowerBoxBorder.borderWidth),M=(0,l.pluck)(k.upperquartilehovercolor,Pe.upperquartilehovercolor,Re.upperquartilehovercolor,k.upperquartilecolor,Pe.upperquartilecolor,Re.upperquartilecolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),O=(0,l.pluck)(k.upperquartilehoveralpha,Pe.upperquartilehoveralpha,Re.upperquartilehoveralpha,k.upperquartilealpha,Pe.upperquartilealpha,Re.upperquartilealpha,Re.plotborderalpha,100),R=(0,l.pluck)(k.upperquartilehoverthickness,Pe.upperquartilehoverthickness,Re.upperquartilehoverthickness,w.upperQuartile.borderWidth),G=(0,l.pluck)(k.lowerquartilehovercolor,Pe.lowerquartilehovercolor,Re.lowerquartilehovercolor,k.lowerquartilecolor,Pe.lowerquartilecolor,Re.lowerquartilecolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),H=(0,l.pluck)(k.lowerquartilehoveralpha,Pe.lowerquartilehoveralpha,Re.lowerquartilehoveralpha,k.lowerquartilealpha,Pe.lowerquartilealpha,Re.lowerquartilealpha,Re.plotborderalpha,100),z=(0,l.pluck)(k.lowerquartilehoverthickness,Pe.lowerquartilehoverthickness,Re.lowerquartilehoverthickness,w.lowerQuartile.borderWidth),W=(0,l.pluck)(k.medianhovercolor,Pe.medianhovercolor,Re.medianhovercolor,k.mediancolor,Pe.mediancolor,Re.mediancolor,Re.plotbordercolor,Ge.getColor("plotBorderColor")),U=(0,l.pluck)(k.medianhoveralpha,Pe.medianhoveralpha,Re.medianhoveralpha,k.medianalpha,Pe.medianalpha,Re.medianalpha,Re.plotborderalpha,100),j=(0,l.pluck)(k.medianhoverthickness,Pe.medianhoverthickness,Re.medianhoverthickness,w.median.borderWidth),1===u&&(de===S&&(S=(0,l.getLightColor)(S,70)),ue===P&&(P=(0,l.getLightColor)(P,70))),w.upperBoxHoverColorArr=(0,l.getColumnColor)(S,D,void 0,void 0,h,b,v.toString(),0,!1),w.lowerBoxHoverColorArr=(0,l.getColumnColor)(P,_,void 0,void 0,h,b,v.toString(),0,!1),w.setUpperBoxRolloutAttr={fill:(0,l.toRaphaelColor)(w.upperColorArr[0])},w.setUpperBoxRolloverAttr={fill:(0,l.toRaphaelColor)(w.upperBoxHoverColorArr[0])},w.setLowerBoxRolloutAttr={fill:(0,l.toRaphaelColor)(w.lowerColorArr[0])},w.setLowerBoxRolloverAttr={fill:(0,l.toRaphaelColor)(w.lowerBoxHoverColorArr[0])},w.setUpperBoxBorderRolloverAttr={stroke:(0,l.convertColor)(E,T),"stroke-width":F},w.setUpperBoxBorderRolloutAttr={stroke:w.upperBoxBorder.color,"stroke-width":w.upperBoxBorder.borderWidth},w.setLowerBoxBorderRolloverAttr={stroke:(0,l.convertColor)(V,I),"stroke-width":B},w.setLowerBoxBorderRolloutAttr={stroke:w.lowerBoxBorder.color,"stroke-width":w.lowerBoxBorder.borderWidth},w.setUpperQuartileRolloverAttr={stroke:(0,l.convertColor)(M,O),"stroke-width":R},w.setUpperQuartileRolloutAttr={stroke:w.upperQuartile.color,"stroke-width":w.upperQuartile.borderWidth},w.setLowerQuartileRolloverAttr={stroke:(0,l.convertColor)(G,H),"stroke-width":z},w.setLowerQuartileRolloutAttr={stroke:w.lowerQuartile.color,"stroke-width":w.lowerQuartile.borderWidth},w.setMedianRolloverAttr={stroke:(0,l.convertColor)(W,U),"stroke-width":j},w.setMedianRolloutAttr={stroke:w.median.color,"stroke-width":w.median.borderWidth}),t=w.toolTipValue,o=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(k.tooltext,Pe.plottooltext,Re.plottooltext),!1)),Fe.showtooltip?null===t?n=!1:void 0!==o?(r=[1,2,3,4,5,6,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80],a={maxValue:re,maxDataValue:Je.dataLabels(re),minValue:oe,minDataValue:Je.dataLabels(oe),Q1:Je.dataLabels(ee),unformattedQ1:ee,Q3:Je.dataLabels(te),unformattedQ3:te,median:Je.dataLabels(ie),unformattedMedian:ie,SD:Je.dataLabels(se),unformattedsd:se,QD:Je.dataLabels(ce),unformattedQD:ce,MD:Je.dataLabels(le),unformattedMD:le,mean:Je.dataLabels(ne),unformattedMean:ne,label:A,yaxisName:Ie.yaxisname,xaxisName:Ie.xaxisname,formattedValue:t,value:A},n=(0,l.parseTooltext)(o,r,a,k,Re,Pe)):n="<b>Maximum"+Ue+"</b>"+Je.dataLabels(re)+"<br /><b>Q3"+Ue+"</b>"+Je.dataLabels(te)+"<br /><b>Median"+Ue+"</b>"+Je.dataLabels(ie)+"<br /><b>Q1"+Ue+"</b>"+Je.dataLabels(ee)+"<br /><b>Minimum"+Ue+"</b>"+Je.dataLabels(oe):n=!1,w.toolText=n,w.setTooltext=n,i&&(p=i)}Fe.showalloutliers?(Te=this._getOutLiersLimit(),Ke=Math.max(Ke,Te.max),qe=Math.min(qe,Te.min)):(xe=Ke-qe,Ke+=Fe.outliersupperrangeratio*xe,qe-=Fe.outlierslowerrangeratio*xe),Fe.maxValue=Ke,Fe.minValue=qe,this.setState("dirty",!0),this._createSubDS(),Ie.showLegend&&this._addLegend()},a._createSubDS=function(){var e=this.config.index,t=this.getFromEnv("lineJSON")[e],a=t.length;(0,l.datasetFactory)(this,n["default"],"dataset",a,t,function(e,t){for(var a=[],o=t;o;)a.unshift(e+Number("."+o)),o--;return a}(e,a)),a||this.iterateComponents((function(e){"line"===e.getName()&&e.remove()}))},a._getOutLiersLimit=function(){var e,t,a,o,r,i=this.getFromEnv("lineJSON")[this.config.index],n=i.length,l=-Infinity,s=+Infinity;for(r=0;r<n;r++)if("Outliers"===(e=i[r]).seriesname){for(t=(o=e.data).length,a=0;a<t;a++)l=Math.max(o[a].value,l),s=Math.min(o[a].value,s);return{max:l,min:s}}return{max:l,min:s}},a.parsePlotAttributes=function(e,t){var a,o,r,i,n,s,c,d,h,u,m,k,y,N,L,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K,q,Y,X,Q,Z,$,ee,te,ae,oe,re,ie,ne,le,se,ce,de,he=this.config,ue=t,pe=this.getState("visible"),ge=this.getFromEnv("chartConfig"),fe=this.getFromEnv("xAxis"),me=this.getFromEnv("yAxis"),ve=this.components.data,be=ge.dataLabelStyle,xe=he.rotatevalues,ke=this.getFromEnv("number-formatter"),ye=xe?l.POSITION_LEFT:l.POSITION_MIDDLE,Ce=this.getFromEnv("smartLabel"),we=+Infinity;o=this.getFromEnv("columnWidth"),i=(n=e&&e.config)&&n.setValue,(n.explicitData||void 0!==e&&null!=i)&&(r=n.setLink,e.graphics||(ve[ue].graphics={}),e.graphics.label||(ve[ue].graphics.label=[]),a=fe.getPixel(ue)+this.getFromEnv("columnXShift"),d=((c=(s=n.upperQuartile||{})&&s.value)||0===c)&&me.getPixel(c),m=((u=(h=n.lowerQuartile||{})&&h.value)||0===u)&&me.getPixel(u),L=(N=((y=(k=n.median)&&k.value)||0===y)&&me.getPixel(y))-d,D=m-N,E=n.upperBoxBorder||{},T=n.lowerBoxBorder||{},I=n.valuePadding,n.eventArgs={index:ue,link:r,maximum:n.max,minimum:n.min,median:y,q3:s.value,q1:h.value,maxDisplayValue:n.showMaxValues?ke.dataLabels(n.max):l.BLANKSTRING,minDisplayValue:n.showMinValues?ke.dataLabels(n.min):l.BLANKSTRING,medianDisplayValue:n.showMedianValues?ke.dataLabels(y):l.BLANKSTRING,q1DisplayValue:n.showQ1Values?ke.dataLabels(h.value):l.BLANKSTRING,q3DisplayValue:n.showQ3Values?ke.dataLabels(s.value):l.BLANKSTRING,categoryLabel:n.label,toolText:n.toolText,datasetIndex:he.index,datasetName:this.config.JSONData.seriesname,visible:pe,value:n.rawValue,showValue:n.showValue,upperBoxColor:n.upperBoxColor,upperBoxAlpha:n.upperBoxAlpha,lowerBoxColor:n.lowerBoxColor,lowerBoxAlpha:n.lowerBoxAlpha,upperQuartileColor:s.rawColor,upperQuartileThickness:s.borderWidth,upperQuartileAlpha:s.alpha,lowerQuartileColor:h.rawColor,lowerQuartileThickness:h.borderWidth,lowerQuartileAlpha:h.alpha,upperBoxBorderColor:E.rawColor,upperBoxBorderThickness:E.borderWidth,upperBoxBorderAlpha:E.alpha,lowerBoxBorderColor:T.rawColor,lowerBoxBorderThickness:T.borderWidth,lowerBoxBorderAlpha:T.alpha,upperWhiskerColor:n.upperWhiskerRawColor,upperWhiskerThickness:n.upperWhiskerThickness,lowerWhiskerThickness:n.lowerWhiskerThickness,lowerWhiskerColor:n.lowerWhiskerRawColor,upperWhiskerAlpha:n.upperWhiskerAlpha,lowerWhiskerAlpha:n.lowerWhiskerAlpha,outliers:n.outliers},F=Math.round(a)+E.borderWidth%2*.5,P=Math.round(a+o)+E.borderWidth%2*.5,_=Math.round(d)+s.borderWidth%2*.5,o=P-F,V={upperBox:{fill:(0,l.toRaphaelColor)(n.upperColorArr[0]),"stroke-width":0,"stroke-dasharray":"none",cursor:r?p:l.BLANKSTRING,visibility:pe},lowerBox:{fill:(0,l.toRaphaelColor)(n.lowerColorArr[0]),"stroke-width":0,"stroke-dasharray":"none",cursor:r?p:g,visibility:pe},upperBoxBorder:{stroke:E.color,"stroke-width":E.borderWidth,"stroke-linecap":f,dashstyle:E.dashStyle,visibility:pe},lowerBoxBorder:{stroke:T.color,"stroke-width":T.borderWidth,dashstyle:T.dashStyle,"stroke-linecap":f,visibility:pe},upperQuartile:{stroke:(0,l.toRaphaelColor)(s.color),"stroke-width":s.borderWidth,"stroke-dasharray":s.dashSyle,"stroke-linecap":f,cursor:r?p:g,visibility:pe},lowerQuartile:{stroke:(0,l.toRaphaelColor)(h.color),"stroke-width":h.borderWidth,"stroke-dasharray":h.dashSyle,cursor:r?p:l.BLANKSTRING,"stroke-linecap":f,visibility:pe},median:{stroke:(0,l.toRaphaelColor)(k.color),"stroke-width":k.borderWidth,"stroke-dasharray":k.dashSyle,cursor:r?p:l.BLANKSTRING,"stroke-linecap":f,visibility:pe}},le=_,$=Object.assign({x:F,y:_,width:Math.max(o,0),height:Math.max(Math.min(we,L),0),r:0},V.upperBox),Z=Object.assign({path:[w,F,_,S,_+L,w,P,_,S,_+L]},V.upperBoxBorder),ee=Object.assign({path:[w,F,_,A,F+o]},V.upperQuartile),B=_,M=o*(he.whiskerslimitswidthratio/100)/2,G=O=me.getPixel(n.max),R=F,G=Math.round(O)+n.upperWhiskerThickness%2/2,F=Math.round(F+o/2)+n.upperWhiskerThickness%2/2,te={path:H=[w,F,B,S,Math.min(G,le),w,F-M,Math.min(G,le),A,F+M],"stroke-width":n.upperWhiskerThickness,cursor:r?p:l.BLANKSTRING,"stroke-linecap":f,stroke:n.upperWhiskerColor,visibility:pe},J=n.dataLabelStyle,Ce.useEllipsesOnOverflow(this.getFromEnv("chartConfig").useEllipsesWhenOverflow),Ce.setStyle(be),z=Ce.getOriSize(ke.dataLabels(n.max)),W=xe?z.width:z.height,(j=O-.5*n.upperWhiskerThickness-I-W*(xe?.5:1))-(xe?W/2:0)<ge.canvasTop&&(j=ge.canvasTop+(xe?W/2:0)),ae={text:ke.dataLabels(n.max),x:R+o/2,title:s.originalText||l.BLANKSTRING,y:j,"text-anchor":xe?l.POSITION_MIDDLE:ye,"vertical-align":xe?l.POSITION_MIDDLE:x,visibility:l.visibleStr,direction:he.textDirection,fill:J.color,transform:(0,l.getSuggestiveRotation)(xe,R+o/2,j),"text-bound":[J.backgroundColor,J.borderColor,be.borderThickness,be.borderPadding,be.borderRadius,be.borderDash]},F=Math.round(a)+T.borderWidth%2*.5,P=Math.round(a+o)+T.borderWidth%2*.5,_=Math.round(N+D)+h.borderWidth%2*.5,de=(se=N)+(ce=Math.max(Math.min(we,_-N),0)),q=Object.assign({x:F,y:se,width:Math.max(o,0),height:ce,r:0},V.lowerBox),K=Object.assign({path:[w,F,N,S,N+D,w,P,N,S,N+D]},V.lowerBoxBorder),_=Math.round(N+D)+h.borderWidth%2*.5,Y=Object.assign({path:[w,F,_,A,F+o]},V.lowerQuartile),B=_,M=o*(he.whiskerslimitswidthratio/100)/2,G=O=me.getPixel(n.min),R=F,G=Math.round(O)+n.lowerWhiskerThickness%2/2,R=Math.round(R+o/2)+n.lowerWhiskerThickness%2/2,H=[w,R,B,S,Math.max(G,de),w,R-M,Math.max(G,de),A,R+M],Ce.setStyle(be),z=Ce.getOriSize(ke.dataLabels(n.min)),W=xe?z.width:z.height,(U=O+.5*n.lowerWhiskerThickness+I)+W>ge.canvasBottom&&(U=ge.canvasBottom-W),oe={text:ke.dataLabels(n.min),x:R,title:s.originalText||l.BLANKSTRING,y:U,"text-anchor":xe?C:ye,"vertical-align":xe?l.POSITION_MIDDLE:x,visibility:l.visibleStr,direction:he.textDirection,fill:J.color,transform:(0,l.getSuggestiveRotation)(xe,R,U),"text-bound":[J.backgroundColor,J.borderColor,be.borderThickness,be.borderPadding,be.borderRadius,be.borderDash]},X={path:H,"stroke-width":n.lowerWhiskerThickness,cursor:r?p:l.BLANKSTRING,"stroke-linecap":f,stroke:n.lowerWhiskerColor,visibility:pe},_=Math.round(N)+k.borderWidth%2*.5,Q=Object.assign({path:[w,F,_,A,F+o]},V.median),ye=xe?l.POSITION_LEFT:l.POSITION_MIDDLE,re={text:s.displayValue,x:a+o/2,title:s.originalText||l.BLANKSTRING,y:d-I,"text-anchor":xe?v:ye,"vertical-align":xe?l.POSITION_MIDDLE:b,visibility:l.visibleStr,direction:he.textDirection,fill:J.color,transform:(0,l.getSuggestiveRotation)(xe,a+o/2,d-I),"text-bound":[J.backgroundColor,J.borderColor,be.borderThickness,be.borderPadding,be.borderRadius,be.borderDash]},ne={text:k.displayValue,x:F+o/2,y:N-I,title:k.originalText||l.BLANKSTRING,"text-anchor":xe?v:ye,"vertical-align":xe?l.POSITION_MIDDLE:b,visibility:l.visibleStr,direction:he.textDirection,fill:J.color,transform:(0,l.getSuggestiveRotation)(xe,F+o/2,N-I),"text-bound":[J.backgroundColor,J.borderColor,be.borderThickness,be.borderPadding,be.borderRadius,be.borderDash]},ie={text:h.displayValue,x:a+o/2,y:m+I,title:h.originalText||l.BLANKSTRING,"text-anchor":xe?v:ye,"vertical-align":xe?l.POSITION_MIDDLE:x,visibility:l.visibleStr,direction:he.textDirection,fill:J.color,transform:(0,l.getSuggestiveRotation)(xe,a+o/2,m+I),"text-bound":[J.backgroundColor,J.borderColor,be.borderThickness,be.borderPadding,be.borderRadius,be.borderDash]},n.props={lowerBoxBorderEle:{attr:K},lowerBoxElem:{attr:q},lowerQuartileEle:{attr:Y},lowerWhiskerEle:{attr:X},midLineElem:{attr:Q},upperBoxElem:{attr:$},upperBoxBorderEle:{attr:Z},upperQuartileEle:{attr:ee},upperWhiskerEle:{attr:te},upperQuartileMaxLabel:{attr:ae},upperQuartileMinLabel:{attr:oe},medianLabel:{attr:ne},upperQuartileLabel:{attr:re},lowerQuartileLabel:{attr:ie}})},a.allocatePosition=function(){var e,t,a,o=this.config.JSONData.data,r=o&&o.length,i=this.getFromEnv("xAxis").getTicksLen(),n=this.components.data;for(a=Math.min(i,r),this.setColumnPosition(),t=0;t<a;t++)e=n[t],this.parsePlotAttributes(e,t)},a.drawPlots=function(){var e,t,a,o,r,i,n,s,c,d,p,f,v,b,x,C,w,A,S,N,L,D,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K,q,Y,X,Q,Z,$,ee,te,ae=this,oe=ae.config,re=ae.config.JSONData.data,ie=re&&re.length,ne=ae.getFromEnv("chart"),le=ae.getFromEnv("xAxis").getTicksLen(),se=ae.getFromEnv("toolTipController"),ce=ae.components.data,de=oe.showShadow,he=ae.getContainer("upperBoxGroup").toBack(),ue=ae.getContainer("lowerBoxGroup"),pe=ae.getContainer("medianGroup"),ge=ae.getContainer("upperWhiskerGroup"),fe=ae.getContainer("lowerWhiskerGroup"),me=ae.getContainer("labelGroup"),ve=ae.getContainer("shadowGroup"),be=(ae.components.removeDataArr||[]).length,xe=oe.showHoverEffect,ke=ae.getFromEnv("animationManager"),ye=function(e){return function(t){ne.plotEventHandler(e,t)}},Ce=function(e,t){return function(a){var o;if(0!==t.data(k))for(o in e)o!==h&&(ke.setAnimation({el:e[o],doNotRemove:!0,attr:t.data("setRolloverAttr")[o],component:ae}),ne.plotEventHandler(t,a,"DataPlotRollOver"))}},we=function(e,t){return function(a){var o;if(0!==t.data(k))for(o in e)o!==h&&(ke.setAnimation({el:e[o],doNotRemove:!0,attr:t.data("setRolloutAttr")[o],component:ae}),ne.plotEventHandler(t,a,"DataPlotRollOut"))}};for(s=function(e){return function(){this.show(),this.shadow(e)}},ae.setColumnPosition(),ae.getState("visible")?(he.show(),ue.show(),ge.show(),fe.show(),pe.show(),ve.show(),me.show(),ae._conatinerHidden=!1):(me.hide(),ge.hide(),he.hide(),fe.hide(),ue.hide(),pe.hide(),ve.hide()),e=Math.min(le,ie),t=0;t<e;t++)if(r=(i=(o=ce[t])&&o.config)&&i.setValue,z=!1,W=!1,U=!1,j=!1,J=!1,K=!1,q=!1,Y=!1,X=!1,i.explicitData||void 0!==o&&null!=r)V=o.graphics,o.graphics||(ce[t].graphics={}),V.label||(ce[t].graphics.label=[]),n=i.upperQuartile||{},c=i.lowerQuartile||{},d=i.median,a=i.toolText,I=oe.index+u+t,f=o.graphics.upperBoxElem,p=ke.setAnimation({el:f||"rect",attr:i.props.upperBoxElem.attr,label:"upperBox",container:he,component:ae}),f||(o.graphics.upperBoxElem=p,z=!0),p.shadow({opacity:de?oe.upperBoxAlpha/100:0},ve),b=o.graphics.upperBoxBorderEle,v=ke.setAnimation({el:b||"path",attr:i.props.upperBoxBorderEle.attr,container:he,label:"path",component:ae}),b||(o.graphics.upperBoxBorderEle=v,U=!0),C=o.graphics.upperQuartileEle,x=ke.setAnimation({el:C||"path",attr:i.props.upperQuartileEle.attr,label:"path",container:he,component:ae}),C||(o.graphics.upperQuartileEle=x,J=!0),M=o.graphics.upperWhiskerEle,B=ke.setAnimation({el:M||"path",attr:i.props.upperWhiskerEle.attr,label:"path",container:ge,component:ae}),s({opacity:i.upperWhiskerShadowOpacity}),M||(o.graphics.upperWhiskerEle=B,Y=!0),ae.getFromEnv("smartLabel").useEllipsesOnOverflow(ne.config.useEllipsesWhenOverflow),i.showMaxValues?((_=V.label[3])&&_.show(),P=ke.setAnimation({el:_||"text",attr:i.props.upperQuartileMaxLabel.attr,component:ae,label:"text",container:me}),_||(V.label[3]=P),V.label[3].data(m,I)):V.label[3]&&ke.setAnimation({el:V.label[3],component:ae,attr:{"text-bound":[]},callback:E.call(V.label[3])}),A=o.graphics.lowerBoxElem,w=ke.setAnimation({el:A||"rect",attr:i.props.lowerBoxElem.attr,label:"lowerBox",container:ue,component:ae}),A||(o.graphics.lowerBoxElem=w,W=!0),w.shadow({opacity:de?oe.lowerBoxAlpha/100:0},ve),N=o.graphics.lowerBoxBorderEle,S=ke.setAnimation({el:N||"path",attr:i.props.lowerBoxBorderEle.attr,component:ae,label:"path",container:ue}),N||(o.graphics.lowerBoxBorderEle=S,j=!0),D=o.graphics.lowerQuartileEle,L=ke.setAnimation({el:D||"path",attr:i.props.lowerQuartileEle.attr,component:ae,label:"path",container:ue}),D||(o.graphics.lowerQuartileEle=L,K=!0),O=o.graphics.lowerWhiskerEle,i.showMinValues?((_=V.label[4])&&_.show(),P=ke.setAnimation({el:_||"text",attr:i.props.upperQuartileMinLabel.attr,label:"text",container:me,component:ae}),_||(V.label[4]=P),V.label[4].data(m,I)):V.label[4]&&ke.setAnimation({el:V.label[4],component:ae,attr:{"text-bound":[]},callback:E.call(V.label[4])}),R=o.graphics.lowerWhiskerEle,O=ke.setAnimation({el:R||"path",attr:i.props.lowerWhiskerEle.attr,label:"path",container:fe,component:ae}),s({opacity:i.lowerWhiskerShadowOpacity}),R||(o.graphics.lowerWhiskerEle=O,X=!0),F=o.graphics.midLineElem,T=ke.setAnimation({el:F||"path",component:ae,label:"midline",container:pe,attr:i.props.midLineElem.attr}),F||(o.graphics.midLineElem=T,q=!0),Q={upperBoxElem:i.setUpperBoxRolloverAttr,lowerBoxElem:i.setLowerBoxRolloverAttr,upperBoxBorderEle:i.setUpperBoxBorderRolloverAttr,lowerBoxBorderEle:i.setLowerBoxBorderRolloverAttr,upperQuartileEle:i.setUpperQuartileRolloverAttr,lowerQuartileEle:i.setLowerQuartileRolloverAttr,midLineElem:i.setMedianRolloverAttr},Z={upperBoxElem:i.setUpperBoxRolloutAttr,lowerBoxElem:i.setLowerBoxRolloutAttr,upperBoxBorderEle:i.setUpperBoxBorderRolloutAttr,lowerBoxBorderEle:i.setLowerBoxBorderRolloutAttr,upperQuartileEle:i.setUpperQuartileRolloutAttr,lowerQuartileEle:i.setLowerQuartileRolloutAttr,midLineElem:i.setMedianRolloutAttr},p.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),z&&(p.on("fc-click",ye(p)),p.on("fc-mouseover",Ce(o.graphics,p)),p.on("fc-mouseout",we(o.graphics,p))),w.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),W&&(w.on("fc-click",ye(w)),w.on("fc-mouseover",Ce(o.graphics,w)),w.on("fc-mouseout",we(o.graphics,w))),v.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),U&&(v.on("fc-click",ye(v)),v.on("fc-mouseover",Ce(o.graphics,v)),v.on("fc-mouseout",we(o.graphics,v))),S.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),j&&(S.on("fc-click",ye(S)),S.on("fc-mouseover",Ce(o.graphics,S)),S.on("fc-mouseout",we(o.graphics,S))),x.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),J&&(x.on("fc-click",ye(x)),x.on("fc-mouseover",Ce(o.graphics,x)),x.on("fc-mouseout",we(o.graphics,x))),L.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),K&&(L.on("fc-click",ye(L)),L.on("fc-mouseover",Ce(o.graphics,L)),L.on("fc-mouseout",we(o.graphics,L))),T.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),q&&(T.on("fc-click",ye(T)),T.on("fc-mouseover",Ce(o.graphics,T)),T.on("fc-mouseout",we(o.graphics,T))),B.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),Y&&(B.on("fc-click",ye(B)),B.on("fc-mouseover",Ce(o.graphics,B)),B.on("fc-mouseout",we(o.graphics,B))),O.data(m,I).data(y,i.eventArgs).data(k,xe).data("setRolloverAttr",Q).data("setRolloutAttr",Z),X&&(O.on("fc-click",ye(O)),O.on("fc-mouseover",Ce(o.graphics,O)),O.on("fc-mouseout",we(o.graphics,O))),(0,l.defined)(n.displayValue)&&n.displayValue!==g&&i.showQ3Values?((_=V.label[0])&&_.show(),P=ke.setAnimation({el:_||"text",attr:i.props.upperQuartileLabel.attr,component:ae,label:"text",container:me}),_||(V.label[0]=P),V.label[0].data(m,I)):V.label[0]&&ke.setAnimation({el:V.label[0],component:ae,attr:{"text-bound":[]},callback:E.call(V.label[0])}),(0,l.defined)(d.displayValue)&&d.displayValue!==g&&i.showMedianValues?((_=V.label[1])&&_.show(),(P=ke.setAnimation({el:_||"text",attr:i.props.medianLabel.attr,component:ae,label:"text",container:me})).outlineText(oe.showTextOutline,i.props.medianLabel.attr.fill),_||(V.label[1]=P),V.label[1].data(m,I)):V.label[1]&&ke.setAnimation({el:V.label[1],component:ae,attr:{"text-bound":[]},callback:E.call(V.label[1])}),(0,l.defined)(c.displayValue)&&c.displayValue!==g&&i.showQ1Values?(_=V.label[2],P=ke.setAnimation({el:_||"text",component:ae,attr:i.props.lowerQuartileLabel.attr,container:me}),_||(V.label[2]=P,P.show()),V.label[2].data(m,I)):V.label[2]&&ke.setAnimation({el:V.label[2],component:ae,attr:{"text-bound":[]},callback:E.call(V.label[2])}),oe.showtooltip?(se.enableToolTip(p,a),se.enableToolTip(w,a),se.enableToolTip(v,a),se.enableToolTip(S,a),se.enableToolTip(x,a),se.enableToolTip(L,a),se.enableToolTip(T,a),se.enableToolTip(B,a),se.enableToolTip(O,a)):(se.enableToolTip(p,!1),se.enableToolTip(w,!1),se.enableToolTip(v,!1),se.enableToolTip(S,!1),se.enableToolTip(x,!1),se.enableToolTip(L,!1),se.enableToolTip(T,!1),se.enableToolTip(B,!1),se.enableToolTip(O,!1));else for(G in H=o.graphics)if(H[G]instanceof Array)for($=0,te=(ee=H[G]).length;$<te;$++)ee[$]&&ee[$].hide();else H[G].hide();!1!==ae.getState("visible")||!1!==ae._conatinerHidden&&void 0!==ae._conatinerHidden||(he.hide(),ue.hide(),ge.hide(),fe.hide(),pe.hide(),ve.hide(),me&&me.hide(),ae._conatinerHidden=!0),be&&ae.removePlots()},a.removePlots=function(){var e,t,a,o,r,i,n=this.components.removeDataArr,l=this.getFromEnv("animationManager"),s=n.length;for(o=0;o<s;o++)if(e=n[0],n.splice(0,1),e&&e.graphics)for(t in a=e.graphics)if(t!==h)a[t].shadow({opacity:0}),a[t].hide();else for(r=a[t].length,i=0;i<r;i++)a[t][i]&&(a[t][i].shadow({opacity:0}),l.setAnimation({el:a[t][i],component:this,attr:{"text-bound":[]},callback:E.call(a[t][i])}))},a.removeData=function(e,t,a){var o=e,r=t,i=this.components,n=i.data,l=i.removeDataArr||(i.removeDataArr=[]);(o=o||0)+(r=r||1)===n.length?this.endPosition=!0:0!==o&&void 0!==o||(this.endPosition=!1),i.removeDataArr=l=l.concat(n.splice(o,r)),a&&this.asyncDraw()},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.showplotborder=void 0,t.plotborderdashlen=void 0,t.plotborderdashgap=void 0,t.plotfillalpha=void 0,t.useroundedges=void 0,t.ratio=void 0,t.plotborderthickness=void 0,t.showvalues=void 0,t.valuepadding=void 0,t.showtooltip=void 0,t.maxcolwidth=void 0,t.rotatevalues=void 0,t.use3dlighting=void 0,t.whiskerslimitswidthratio=void 0,t.outliersupperrangeratio=void 0,t.outlierslowerrangeratio=void 0,t.showalloutliers=void 0,t.showmean=void 0,t.showsd=void 0,t.showmd=void 0,t.showqd=void 0,t.showminvalues=void 0,t.showmaxvalues=void 0,t.showq1values=void 0,t.showq3values=void 0,t.showmedianvalues=void 0},a.getDataLimits=function(){var e=this.config,t=this.getState("removed");return{max:t?-Infinity:e.maxValue,min:t?+Infinity:e.minValue}},a._addLegend=function(){var e,t,a,o=this.config,r=this.getFromEnv("legend"),i=this.getFromEnv("chart-attrib"),n=o.JSONData||{},s=o.upperBoxColor,c=o.lowerBoxColor;e={FCcolor:{color:s+l.COMMA+c,angle:90,ratio:"50, 0",alpha:"100, 100"}},t={label:(0,l.getFirstValue)(this.config.JSONData.seriesname),index:this.getJSONIndex(),mainDS:!0},o.includeInLegend?((a=r.getItem(this.config.legendItemId))||(this.config.legendItemId=r.createItem(this),a=r.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){a.itemClickFn()}),a)),a.configure(t),a.setStateCosmetics("default",{symbol:{fill:(0,l.toRaphaelColor)(e),bgAlpha:(0,l.pluckNumber)(n.legendiconbgalpha,n.legendiconalpha,i.legendiconbgalpha,i.legendiconalpha,o.plotfillalpha),borderAlpha:(0,l.pluckNumber)(n.legendiconborderalpha,n.legendiconalpha,i.legendiconborderalpha,i.legendiconalpha,o.plotfillalpha),rawFillColor:o.upperBoxColor,stroke:(0,l.toRaphaelColor)(d)},background:{legendBackgroundColor:(0,l.toRaphaelColor)(s),alpha:20}}),this.getState("visible")?a.removeLegendState("hidden"):a.setLegendState("hidden")):this.config.legendItemId&&r.disposeItem(this.config.legendItemId),this._mapChildren((function(e){e.getState("removed")||(e.addToEnv("legendBackgroundColor",s),e&&e._addLegend(!0))}))},a.legendInteractivity=function(){var e,t,a=this.getChildren("dataset");for(e=this.getState("visible")?"hide":"show",t=0;t<(a&&a.length);t++)a[t][e]();this[e]()},a.drawLabel=function(){return this},a.getName=function(){return"boxandwhisker2D"},a.childChanged=function(){return this},a.show=function(){e.prototype.show.call(this)},a.hide=function(){e.prototype.hide.call(this)},t}(i["default"]);t["default"]=T},1029:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(555)),n=a(224),l=a(232),s=o(a(1030)),c=n.preDefStr.POLYGON,d=n.preDefStr.SPOKE,h=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:e,container:t,component:a,label:"group"})};(0,l.addDep)({name:"boxandwhiskerlineAnimation",type:"animationRule",extension:s["default"]});var u=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"boxandwhiskerline"},a.createCoordinates=function(){var e,t,a,o,r,i=this.components.data,n=this.getFromEnv("yAxis"),l=this.getFromEnv("xAxis"),s=i.length;for(a=0;a<s;a++)t=(e=i[a])&&e.config,void 0!==e&&(o=l.getPixel(t._x),r=n.getPixel(t._y),t._Px=o+this.getFromEnv("columnXShift")+this.getFromEnv("columnWidth")/2,t._Py=r)},a.getAllPlots=function(e,t){var a,o,r=this.components.data,i=[];for(a=0,o=r.length;a<o;a++)(r[a].config._x>=e||r[a].config._x<=t)&&i.push(r[a]);return i},a.calculateScrollRange=function(){var e=this.config,t=this.components.data;e.scrollMinVal=0,e.scrollMaxVal=t.length,e.scrollMinValForLabel=e.scrollMinVal,e.scrollMaxValForLabel=e.scrollMaxVal},a._getHoveredPlot=function(e,t){var a,o,r,i,n,l,s=e,c=t,d=this.getFromEnv("xAxis"),h=this.components.data.length,u=this.config,p=u&&u.radius||0;for(s+=d.getTranslation(),o=Math.floor(Math.max(d.getValue(s-p),0)),r=Math.ceil(Math.min(d.getValue(s+p),h-1)),n=(l=this.getAllPlots(o,r)).length;n>=0&&(!(a=l[n])||!(i=this.isWithinShape(a,n,s,c)));n--);return i},a._addLegend=function(e){if(e){var t,a,o=this.config,r=this.getFromEnv("chart").getChildren("legend")[0],i=(0,n.pluckNumber)(o.drawanchors,1);o.includeinlegend?(a={anchorSide:i?o.anchorsides:0,label:(0,n.getFirstValue)(o.JSONData.seriesname),customLegendIcon:!1,spoke:"spoke"===o.dip?1:0,drawLine:!o.showline,index:this.getJSONIndex()},(t=r.getItem(this.config.legendItemId))||(this.config.legendItemId=r.createItem(this),t=r.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){t.itemClickFn()}),t)),t.configure(a),t.setStateCosmetics("default",{symbol:{fill:(0,n.toRaphaelColor)({color:o.anchorbgcolor,alpha:o.anchorbgalpha}),rawFillColor:o.anchorbgcolor,stroke:(0,n.toRaphaelColor)({color:o.anchorbordercolor,alpha:"100"})},background:{legendBackgroundColor:(0,n.toRaphaelColor)(this.getFromEnv("legendBackgroundColor")),alpha:20}}),this.getState("visible")?t.removeLegendState("hidden"):t.setLegendState("hidden")):this.config.legendItemId&&r.disposeItem(this.config.legendItemId)}},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t);var a=this.config.JSONData,o=this.config;this.setState("visible",this.getLinkedParent().getState("visible")),o.skipCommonElements=a.showline,o.dip=a.dip},a.createContainer=function(){var e,t,a=this.getLinkedParent().getLinkedParent(),o=this.groupName||this.dsGroup||this.getType();!a.getChildContainer(o+"VcanvasGroup")&&(o="default"),e=a.getChildContainer("manager-defaultVcanvasGroup-lines"),t=a.getChildContainer(o+"ShadowVcanvasGroup"),!this.getContainer("shadowGroup")&&this.addContainer("shadowGroup",h({name:"shadow-group"},t,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("commonElemsGroup",h({name:"common-elems-group"},e,this)),!this.getContainer("plotGroup")&&this.addContainer("plotGroup",h({name:"common-elems-group"},e,this)),!this.getContainer("labelGroup")&&this.addContainer("labelGroup",h({name:"label-group","class":"fusioncharts-datalabels",opacity:1},a.getChildContainer("vcanvasLabelGroup"),this))},a._setConfigure=function(e,t){var a,o,r,i,l,s,h,u,p=this.config,g=this.getFromEnv("chartConfig"),f=this.config.JSONData,m=e||f.data||[],v=this.getFromEnv("xAxis").getTicksLen(),b=e&&e.data.length,x="Outliers"===f.seriesname?m.length:b||Math.min(v,m.length);for(p.imageCount=0,(r=this.components.data)||(r=this.components.data=[]),p.maxRadius=-Infinity,i=0;i<x;i++)e?(a=e&&e.data[i]||{},o=void 0!==t?r[u=t+i]:r[u=r.length-x+i],l=u):(o=r[i],a=m&&m[i]||{},l=i),o||(o=r[l]={}),o.config||(o.config={}),o.graphics||(o.graphics={}),this._plotConfigure(l,a,b),u&&u++,s=o&&o.config,h=(0,n.pluck)(a.dip,f.dip),s.dip=h===c?0:h===d?1:0,s.toolText=s.finalTooltext="<b>"+f.seriesname+g.tooltipsepchar+"</b>"+s.displayValue},t}(i["default"]);t["default"]=u},1030:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.boxandwhiskerline":function(){return{"line.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot",startEnd:{start:.5,end:1}}],"anchor.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot",startEnd:{start:.5,end:1}}]}}}},1031:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.boxandwhisker2D":function(){return{"upperBox.appearing":function(e){return[{initialAttr:{x:e.attr.x,y:e.attr.y+e.attr.height,height:0,width:e.attr.width},slot:"plot",startEnd:{start:0,end:.5}}]},"lowerBox.appearing":function(e){return[{initialAttr:{x:e.attr.x,y:e.attr.y,height:0,width:e.attr.width},slot:"plot",startEnd:{start:0,end:.5}}]},"path.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot",startEnd:{start:.5,end:1}}],"midline.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot",startEnd:{start:0,end:.2}}],"group.appearing":function(e){return"label-group"===e.attr.name?[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]:[{initialAttr:{opacity:1},finalAttr:{opacity:1},slot:"final"}]},"*":null}}}},1032:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o=e.getFromEnv("dataSource").dataset,n=e.getChildren("canvas")[0],l=t=n.getChildren("vCanvas")[0],s=e.config.defaultDatasetType||"";o||e.setChartMessage();(0,r.componentFactory)(t,e.getDSGroupdef(),"datasetGroup_"+s),(a=t.getChildren("datasetGroup_"+s))&&(l=a[0]),(0,r.componentFactory)(e,i["default"],"BoxAndWhiskerStatisticalCalc"),t.getChildren("datasetGroup_"+s)[0].addToEnv("BoxAndWhiskerStatisticalCalc",e.getChildren("BoxAndWhiskerStatisticalCalc")[0]),l.addToEnv("lineJSON",e._getLineJSONdata()),(0,r.datasetFactory)(l,e.getDSdef(),"dataset",o.length,o)};var r=a(224),i=o(a(1033))},1033:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(240),n=a(224),l=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.setArray=function(e){var t,a,o=this.getFromEnv("number-formatter"),r=0,i=e;for(!i&&(i=n.BLANK),a=i.replace(/\s/g,n.BLANK).split(n.COMMASTRING),t=this.dataLength=a&&a.length;t--;)r+=a[t]=o.getCleanValue(a[t]);a&&a.sort((function(e,t){return e-t})),this.values=a,this.mean=r/this.dataLength,this.getFrequencies()},a.getQuartiles=function(){var e,t,a,o,r,i,l=this.values,s=this.dataLength,c=s%2;switch(n.BLANKSTRING){case"tukey":c?(e=(s+3)/4,a=(3*s+1)/4):(e=(s+2)/4,a=(3*s+2)/4);break;case"mooremccabe":c?a=3*(e=(s+1)/4):(e=(s+2)/4,a=(3*s+2)/4);break;case"freundperles":e=(s+3)/4,a=(3*s+1)/4;break;case"mendenhallsincich":e=Math.round((s+1)/4),a=Math.round(3*e);break;default:a=3*(e=(s+1)/4)}return e-=1,a-=1,t=Math.floor(e),o=Math.floor(a),r=e-t?l[t]+(l[Math.ceil(e)]-l[t])*(e-t):l[e],i=a-o?l[o]+(l[Math.ceil(a)]-l[o])*(a-o):l[a],this.quartiles={q1:r,q3:i},this.quartiles},a.getMinMax=function(){var e=this.values;return{min:e[0],max:e[this.dataLength-1]}},a.getMean=function(){return this.mean},a.getMD=function(){for(var e,t=this.mean,a=this.frequencies,o=a.length,r=0;o--;)r+=(e=a[o]).frequency*Math.abs(e.value-t);return r/this.dataLength},a.getSD=function(){for(var e=this.mean,t=this.values,a=this.dataLength,o=a,r=0;a--;)r+=Math.pow(t[a]-e,2);return Math.sqrt(r/(o-1))},a.getQD=function(){return.5*(this.quartiles.q3-this.quartiles.q1)},a.getFrequencies=function(){var e,t,a,o=[],r=this.dataLength,i=this.values,l=0;for(a=0;a<r;a+=1)l+=e=i[a],(0,n.defined)(o[a])?o[a].frequency+=1:((t={}).value=e,t.frequency=1,o[a]=t);this.sum=l,this.frequencies=o},a.getMedian=function(){var e=this.dataLength,t=.5*e,a=this.values;return e%2==0?(a[t]+a[t-1])/2:a[Math.floor(t)]},t}(i.ComponentInterface);t["default"]=l},1034:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(628)),n="manager-defaultVcanvasGroup-lines",l=function(e){function t(){return e.apply(this,arguments)||this}return(0,r["default"])(t,e),t.prototype.createContainer=function(){e.prototype.createContainer.call(this);var t=this.getLinkedParent().getChildContainer("defaultVcanvasGroup");!this.getChildContainer(n)&&this.addChildContainer(n,this.getFromEnv("animationManager").setAnimation({el:"group",component:this,attr:{name:n},container:t}))},t}(i["default"]);t["default"]=l},1035:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1036))["default"];t["default"]=r},1036:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(465)),n=o(a(1037)),l=o(a(1045)),s=o(a(291)),c=a(224),d=o(a(568)),h=a(1043),u=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("legend",d["default"]),t.registerFactory("dataset",l["default"],["legend"]),t}(0,r["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;this.legendposition="right",t.legendPosition=c.preDefStr.POSITION_BOTTOM,t.orientation="horizontal",t.skipCanvasDrawing=!0,t.alignCaptionWithCanvas=!1,t.basefontsize=11},t.getName=function(){return"sankey"},a.getName=function(){return"sankey"},a.getDSdef=function(){return n["default"]},a._checkInvalidData=function(){var e=this.getFromEnv("dataSource");return(!(0,s["default"])(e.nodes)||!e.nodes.length)&&(delete this.config.errorMessage,!0)},a._checkInvalidSpecificData=function(){var e,t,a,o,r,i,n,l=(e=this.getFromEnv("dataSource"),a=[],o=[],r=e.nodes||[],i=e.links||[],n={},r.forEach((function(e){(t=(0,c.pluck)(e.id,e.label))&&(n[t.toString()]=e)})),Object.keys(n).forEach((function(e,t){a.push(Object.assign({},n[e],{props:{}})),a[t].id=(0,c.parseUnsafeString)((a[t].id||a[t].label).toString()),a[t].label=(0,c.parseUnsafeString)((a[t].label||a[t].id).toString())})),i.forEach((function(e){n[e.from]&&n[e.to]&&o.push(Object.assign({},e,{props:{source:(0,c.parseUnsafeString)(e.from),target:(0,c.parseUnsafeString)(e.to)},value:(0,c.pluck)(e.value,"0")}))})),{nodes:a,links:o});return(0,h.createNodeLinks)(l),(0,h.traverseGraph)(l)?(delete this.config.errorMessage,this.addToEnv("sankey-graph",l),!1):(this.config.errorMessage="Self loops and circular links are not supported.",!0)},a.setChartMessage=function(t,a,o){var r=this.config.errorMessage;e.prototype.setChartMessage.call(this,t||r,a,o)},a.configureAttributes=function(t){void 0===t&&(t={}),e.prototype.configureAttributes.call(this,t);var a=this.config,o=t.chart||{},r=this.getFromEnv("number-formatter"),i=this.getFromEnv("sankey-graph"),n=i.nodes,l=i.links;"undefined"!=typeof o.orientation?(a.orientation=o.orientation.toString().toLowerCase(),a.orientation="vertical"===a.orientation?"vertical":"horizontal"):a.orientation="horizontal","undefined"!=typeof o.legendposition?a.legendPosition=["top-left","top","top-right","right-top","right","right-bottom","bottom-right","bottom","bottom-left","left-bottom","left","left-top"].includes(o.legendposition.toString().toLowerCase())?o.legendposition.toString().toLowerCase():c.preDefStr.POSITION_BOTTOM:a.legendPosition="right",a.legendposition=a.legendPosition,this.addToEnv("orientation",a.orientation),a.nodeWidth=Math.max(0,r.getCleanValue((0,c.pluck)(o.nodewidth,20))),n.forEach((function(e){e.nodeWidth=a.nodeWidth})),l.forEach((function(e){e.value=Math.max(0,r.getCleanValue((0,c.pluck)(e.value,0)))})),(0,h.createNodeValues)(i)},a._spaceManager=function(){var e,t,a,o=this.config,r=o.legendPosition,i=o.showLegend,n=o.marginLeft,l=o.marginTop,s=o.marginRight,d=o.marginBottom,h=+this.getFromEnv("chartWidth"),u=+this.getFromEnv("chartHeight");h-=n+s,u-=l+d,t=this._manageActionBarSpace(.225*u),this._allocateSpace(t),i&&((r=r||[]).split("-")[0]===c.POSITION_TOP||r.split("-")[0]===c.preDefStr.POSITION_BOTTOM?e=.3*u:(e=.3*h,r.split("-")[0]===c.POSITION_LEFT?this._allocateSpace({left:11}):r.split("-")[0]===c.POSITION_RIGHT&&this._allocateSpace({right:11})),a=this.getChildren("legend")[0]._manageLegendPosition(e),this._allocateSpace(a)),this._manageChartMenuBar(.6*o.availableHeight)},a._postSpaceManagement=function(){var e=this.config.showLegend,t=this.getChildren("legend");t.length&&e&&t.forEach((function(e){return e.postSpaceManager()})),this.allocateDimensionOfChartMenuBar()},t}(i["default"]);t["default"]=u},1037:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(223)),i=o(a(238)),n=a(240),l=o(a(1038)),s=o(a(1040)),c=a(1043),d=a(232),h=o(a(1044));function u(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,o)}return a}function p(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?u(Object(a),!0).forEach((function(t){(0,r["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):u(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var g="start",f="end";(0,d.addDep)({name:"sankeyLinkAnimation",type:"animationRule",extension:h["default"]});var m=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("node",l["default"]),t.registerFactory("link",s["default"],["node"]),t}(0,i["default"])(t,e),t.getName=function(){return"sankey"};var a=t.prototype;return a.getName=function(){return"sankey"},a.getType=function(){return"dataset"},a.configureAttributes=function(e){void 0===e&&(e={}),Object.assign(this.config,e)},a._addLegend=function(){var e,t,a,o,r=this,i=r.config,n=r.getChildren("nodes"),l=r.getFromEnv("legend"),s=i.legendItemMap=i.legendItemMap||{},c=new Set;Object.keys(s).forEach((function(e){return c.add(s[e])})),n.forEach((function(i){o=s[i.getId()],(a=l.getItem(o))?c["delete"](o):(o=l.createItem(r),a=l.getItem(o),s[i.getId()]=o),a.configure({enabled:!0,label:i.config.label}),i.setData({legendItemId:o}),t=i.config,e=t.style,a.setStateCosmetics("default",{symbol:{fill:e.node.normal.fill,rawFillColor:t.rawCosmetics.fill,stroke:e.node.normal.stroke,cursor:"default"},text:{cursor:"default"}})})),c.forEach((function(e){l.disposeItem(e)}))},a.allocatePosition=function(){var e,t=this.getFromEnv("chartConfig"),a=this.getFromEnv("sankey-graph"),o=this.getFromEnv("orientation"),r=t.canvasLeft,i=t.canvasTop,n=t.canvasHeight,l=t.canvasWidth,s=0,d=0,h=0,u=this.config,p=u.nodeWidth,g=u.nodeSpacing,f=u.nodeRelaxation,m=u.style.node.label;e={left:r,top:i,right:r+l,bottom:i+n},this.config.nodeLabelCosmetics={"font-size":this.computeFontSize(m.fontSize),"font-family":m.fontFamily,"font-weight":m.fontWeight,"font-style":m.fontStyle},"horizontal"===o?(this._accomodateBoundaryHLabels(e),(0,c.createNodeDimensions)(a,{width:[e.left,e.right],height:[e.top,e.bottom],nodeGutter:g,orientation:o,nodeRelaxation:f}),a.nodes.forEach((function(e){h=Math.max(h,e.props.depth)})),s=this.config.columnGap=Math.max((e.right-e.left-p*h)/Math.max(h,1),0),this._accomodateInternalHLabels(s)):(this._accomodateBoundaryVLabels(e),(0,c.createNodeDimensions)(a,{width:[e.left,e.right],height:[e.top,e.bottom],nodeGutter:g,orientation:o,nodeRelaxation:f}),a.nodes.forEach((function(e){h=Math.max(h,e.props.depth)})),d=this.config.columnGap=Math.max((e.bottom-e.top-p*h)/Math.max(h,1),0),this._accomodateInternalVLabels(d,e.bottom-e.top))},a._accomodateBoundaryHLabels=function(e){var t,a,o,r,i,n,l,s=this,c=s.config.labelSepChar,d=s.getChildren("nodes"),h=s.getFromEnv("smartLabel"),u=e.right-e.left,p=0,m=0;return d.forEach((function(e){var d=e.config,v=d.showValue,b=d.showLabel,x=d.label,k=d.props,y=d.labelPosition,C=d.value,w=d.rotateLabel,A=d.labelPadding,S=k.sourceLinks,N=k.targetLinks;if(h.setStyle(s.config.nodeLabelCosmetics),a=h.getSize(v?C:""),l=h.getSize(v?c+" "+C:""),i=Math.max(0,u-l.width),S.length&&!N.length){if(y===f)return;n=10*(r=y===g?.1:.2),t=h.getSmartText(b?x:"",r*i,h._lineHeight),w?(o="inside"===y?0:Math.max(t.height/n,a.height/n),p=Math.max(p,o+(o&&y===g?A:0))):(o=(t.width+(t.width?l.width:a.width))/n,p=Math.max(p,o+(o&&y===g?A:0))),e.setData({formattedLabel:t})}else if(!S.length&&N.length){if(y===g)return;n=10*(r=y===f?.1:.2),t=h.getSmartText(b?x:"",r*i,h._lineHeight),w?(o="inside"===y?0:Math.max(t.height/n,a.height/n),m=Math.max(m,o+(o&&y===f?A:0))):(o=(t.width+(t.width?l.width:a.width))/n,m=Math.max(m,o+(o&&y===f?A:0))),e.setData({formattedLabel:t})}})),e.left+=p+(p?5:0),e.right-=m+(m?5:0),e},a._accomodateInternalHLabels=function(e){var t,a,o,r=this,i=r.getChildren("nodes"),n=r.getFromEnv("smartLabel"),l=r.config.labelSepChar;i.forEach((function(i){var s=i.config,c=s.showValue,d=s.showLabel,h=s.label,u=s.value,p=s.props,m=s.rotateLabel,v=s.labelPosition,b=s.labelPadding,x=p.sourceLinks,k=p.targetLinks,y=Math.max(0,p.y1-p.y0);if(h=d?h:"",u=c?u:"",n.setStyle(r.config.nodeLabelCosmetics),a=n.getSize(c?l+" "+u:""),t=Math.max(0,.75*e-b-a.width),m)return o=n.getSmartText(h,y-a.width,n._lineHeight),void i.setData({formattedLabel:o});(x.length&&!k.length&&v===f||!x.length&&k.length&&v===g||x.length&&k.length||!x.length&&!k.length)&&(o=n.getSmartText(h,t,n._lineHeight),i.setData({formattedLabel:o}))}))},a._accomodateBoundaryVLabels=function(e){var t,a,o,r,i,n,l,s=this,c=s.getChildren("nodes"),d=s.getFromEnv("smartLabel"),h=s.config.labelSepChar,u=e.bottom-e.top,p=0,m=0;return c.forEach((function(e){var c=e.config,v=c.props,b=c.labelPosition,x=c.rotateLabel,k=c.showValue,y=c.showLabel,C=c.value,w=c.label,A=c.labelPadding,S=v.sourceLinks,N=v.targetLinks;if(C=k?C:"",w=y?w:"",d.setStyle(s.config.nodeLabelCosmetics),t=d.getSize(C),l=d.getSize(k?h+" "+C:""),i=Math.max(0,u-l.width),S.length&&!N.length){if(b===f)return;n=10*(o=b===g?.1:.2),a=d.getSmartText(w,o*i,d._lineHeight),x?(r=(a.width+(a.width?l.width:t.width))/n,p=Math.max(p,r+(r&&b===g?A:0))):(r="inside"===b?0:Math.max(a.height/n,t.height/n),p=Math.max(p,r+(r&&b===g?A:0))),e.setData({formattedLabel:a})}else if(!S.length&&N.length){if(b===g)return;n=10*(o=b===f?.1:.2),a=d.getSmartText(w,o*i,d._lineHeight),x?(r=(a.width+(a.width?l.width:t.width))/n,m=Math.max(m,r+(r&&b===f?A:0))):(r="inside"===b?0:Math.max(a.height/n,t.height/n),m=Math.max(m,r+(r&&b===f?A:0))),e.setData({formattedLabel:a})}})),e.top+=p+(p?5:0),e.bottom-=m+(m?5:0),e},a._accomodateInternalVLabels=function(e){var t,a,o,r,i=this,n=i.getChildren("nodes"),l=i.getFromEnv("smartLabel"),s=i.config.labelSepChar;n.forEach((function(n){var c=n.config,d=c.showValue,h=c.props,u=c.label,p=c.value,m=c.showLabel,v=c.rotateLabel,b=c.labelPosition,x=c.labelPadding,k=h.sourceLinks,y=h.targetLinks;if(l.setStyle(i.config.nodeLabelCosmetics),u=m?u:"",p=d?p:"",r=l.getSize(d?s+" "+p:""),t=Math.max(0,.75*e-x-r.width),o=h.x1-h.x0,!v)return a=l.getSmartText(u,o-r.width,l._lineHeight),void n.setData({formattedLabel:a});(k.length&&!y.length&&b===f||!k.length&&y.length&&b===g||k.length&&y.length||!k.length&&!y.length)&&(a=l.getSmartText(u,t,l._lineHeight),n.setData({formattedLabel:a}))}))},a.attachListeners=function(){var e=this,t=e.getChildren("nodes"),a=e.getChildren("links");t.forEach((function(t){t.onFocusCallback=t.onFocusCallback||e.interactionCallback(t,"focus"),t.onFocusOutCallback=t.onFocusOutCallback||e.interactionCallback(t,"normal"),t.onClickCallback=t.onClickCallback||e.interactionCallback(t,"click"),t.dragStartCallback=t.dragStartCallback||e.dragCallback(t,"start"),t.dragMoveCallback=t.dragMoveCallback||e.dragCallback(t,"move"),t.dragEndCallback=t.dragEndCallback||e.dragCallback(t,"end"),t.addEventListener("fc-mouseover",t.onFocusCallback),t.addEventListener("fc-mouseout",t.onFocusOutCallback),t.addEventListener("fc-click",t.onClickCallback),t.addEventListener("fc-dragstart",t.dragStartCallback),t.addEventListener("fc-dragmove",t.dragMoveCallback),t.addEventListener("fc-dragend",t.dragEndCallback)})),a&&a.forEach((function(t){t.onFocusCallback=t.onFocusCallback||e.interactionCallback(t,"focus"),t.onFocusOutCallback=t.onFocusOutCallback||e.interactionCallback(t,"normal"),t.onClickCallback=t.onClickCallback||e.interactionCallback(t,"click"),t.addEventListener("fc-mouseover",t.onFocusCallback),t.addEventListener("fc-mouseout",t.onFocusOutCallback),t.addEventListener("fc-click",t.onClickCallback)}))},a.interactionCallback=function(e,t){var a=this,o=a.config,r=a.getLinkedParent();return"node"===e.getType()?function(){var i=a.getChildren("nodes"),n=a.getChildren("links")||[],l=Object.assign({},e.config.eventArgs),s=e.getId();if(!e.config.isDragged)if("click"===t)r.fireChartInstanceEvent("dataPlotClick",l);else if("normal"===t){if(r.fireChartInstanceEvent("dataPlotRollOut",l),!o.highlightEffect)return;i.forEach((function(e){return e.setData({mode:"normal"})})),n.forEach((function(e){return e.setData({mode:"normal"})}))}else{var c=new Set,d=e.config.props,h=d.sourceLinks,u=d.targetLinks;if(r.fireChartInstanceEvent("dataPlotRollOver",l),!o.highlightEffect)return;c.add(s),h.forEach((function(e){c.add(e.to)})),u.forEach((function(e){c.add(e.from)})),i.forEach((function(e){c.has(e.getId())?e.setData({mode:"focus"}):e.setData({mode:"focusOut"})})),n.forEach((function(e){var t=e.config.props,a=t.source,o=t.target;s===a.id||s===o.id?e.setData({mode:"focus"}):e.setData({mode:"focusOut"})}))}}:function(){var i=a.getChildren("nodes"),n=a.getChildren("links")||[],l=Object.assign({},e.config.eventArgs);if(!e.config.isDragged)if("click"===t)r.fireChartInstanceEvent("linkClick",l);else if("normal"===t){if(r.fireChartInstanceEvent("linkRollOut",l),!o.highlightEffect)return;i.forEach((function(e){return e.setData({mode:"normal"})})),n.forEach((function(e){return e.setData({mode:"normal"})}))}else{var s=new Set,c=e.config.props,d=c.source,h=c.target;if(r.fireChartInstanceEvent("linkRollOver",l),!o.highlightEffect)return;s.add(d.id),s.add(h.id),i.forEach((function(e){s.has(e.getId())?e.setData({mode:"focus"}):e.setData({mode:"focusOut"})})),n.forEach((function(e){return e.setData({mode:"focusOut"})})),e.setData({mode:"focus"})}}},a.dragCallback=function(e,t){var a=this,o=a.config;return"start"===t?function(){var t,r,i=e.config.props;o.enableDrag&&(e.onFocusOutCallback(),e.setData({isDragged:!0,curPos:{x0:i.x0,x1:i.x1,y0:i.y0,y1:i.y1}}),i.sourceLinks.forEach((function(e){t=a.getChild(e.props.index,"links"),r=t.config.props,t.setData({isDragged:!0,curPos:{x0:r.x0,x1:r.x1,y0:r.y0,y1:r.y1}})})),i.targetLinks.forEach((function(e){t=a.getChild(e.props.index,"links"),r=t.config.props,t.setData({isDragged:!0,curPos:{x0:r.x0,x1:r.x1,y0:r.y0,y1:r.y1}})})))}:"end"===t?function(){var t=e.config.props;o.enableDrag&&(e.setData({isDragged:!1}),t.sourceLinks.forEach((function(e){a.getChild(e.props.index,"links").setData({isDragged:!1})})),t.targetLinks.forEach((function(e){a.getChild(e.props.index,"links").setData({isDragged:!1})})))}:function(t){var r,i,n,l=t.originalEvent.data,s=l[0],c=l[1],d=a.getFromEnv("orientation"),h=a.getFromEnv("chartConfig"),u=h.canvasLeft,p=h.canvasRight,g=h.canvasTop,f=h.canvasBottom,m=e.config,v=m.curPos,b=m.props;if(o.enableDrag){if("horizontal"===d){if(v.y0+c<g||v.y1+c>f)return;b.y0=v.y0+c,b.y1=v.y1+c,b.sourceLinks.forEach((function(e){r=a.getChild(e.props.index,"links"),i=r.config.props,n=r.config.curPos,i.y0=n.y0+c,r.setData({})})),b.targetLinks.forEach((function(e){r=a.getChild(e.props.index,"links"),i=r.config.props,n=r.config.curPos,i.y1=n.y1+c,r.setData({})}))}else{if(v.x0+s<u||v.x1+s>p)return;b.x0=v.x0+s,b.x1=v.x1+s,b.sourceLinks.forEach((function(e){r=a.getChild(e.props.index,"links"),i=r.config.props,n=r.config.curPos,i.x0=n.x0+s,r.setData({})})),b.targetLinks.forEach((function(e){r=a.getChild(e.props.index,"links"),i=r.config.props,n=r.config.curPos,i.x1=n.x1+s,r.setData({})}))}e.setData({})}}},a.getClip=function(e){var t=this.getFromEnv("orientation"),a=[],o=this.getFromEnv("chartConfig"),r=o.canvasTop,i=o.canvasLeft,n=o.canvasWidth,l=o.canvasHeight;return"horizontal"===t?(a.push(i),a.push(r),"init"===e?a.push(0):a.push(n),a.push(l)):(a.push(i),a.push(r),a.push(n),"init"===e?a.push(0):a.push(l)),a},a.draw=function(){this.addGraphicalElement({el:"group",attr:{name:"sankey-link-group","clip-rect":this.getClip("canvas")},id:"sankey-link-group",component:this,container:{id:"plotGroup",isParent:!0},label:"linkGroup"}),this.addGraphicalElement({el:"group",attr:{name:"sankey-node-group"},id:"sankey-node-group",component:this,container:{id:"plotGroup",isParent:!0},label:"nodeGroup"}),this.addGraphicalElement({el:"group",attr:p({name:"sankey-node-label-group"},this.config.nodeLabelCosmetics),id:"sankey-node-label-group",component:this,container:{id:"datalabelsGroup",isParent:!0},label:"nodeLabelGroup"})},t}(n.SmartRenderer);t["default"]=m},1038:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o,l,s,c,d,h,u,p,g,f,m=e.config,v=m.nodes,b=m.enableDrag,x=m.style,k=e.getFromEnv("dataSource").chart,y=x.node.label,C=(0,r.pluckNumber)(k.inheritlabelcolorfromnode,1),w=e.getFromEnv("color-manager"),A=e.getFromEnv("number-formatter"),S=e.getFromEnv("chartConfig"),N=S.dataLabelStyle,L=S.showLegend;v.forEach((function(m,v){f=(0,r.pluck)(m.id,m.label),s={fill:(0,r.pluck)(m.color,k.nodecolor,w.getPlotColor(v)),alpha:(0,r.pluckNumber)(m.alpha,k.nodealpha,100),focusAlpha:(0,r.pluckNumber)(m.hoveralpha,k.nodehoveralpha,100),focusOutAlpha:40,stroke:"none"},g=(0,r.pluck)(m.labelalpha,k.nodelabelalpha,k.labelalpha,C?s.alpha:100),d=(d=(0,r.pluck)(m.labelbgcolor,k.nodelabelbgcolor,k.labelbgcolor))?(0,r.convertColor)(d,g):r.BLANK,h=(h=(0,r.pluck)(m.labelbordercolor,k.nodelabelbordercolor,k.labelbordercolor))?(0,r.convertColor)(h,g):r.BLANK,c=Object.assign({},N,{labelFill:(0,r.pluck)(m.labelfontcolor,k.nodelabelfontcolor,k.labelfontcolor,k.basefontcolor,C?s.fill:"#5f5f5f"),labelAlpha:g,focusAlpha:s.focusAlpha,focusOutAlpha:s.focusOutAlpha,border:d?y.borderThickness+"px solid":r.BLANK,borderColor:h,backgroundColor:d}),t={cursor:p=b?"move":"default","text-bound":[d,h,y.borderThickness,y.borderPadding,y.borderRadius,y.borderDash],fill:(0,r.convertColor)(c.labelFill,c.labelAlpha)},u=(0,r.pluck)(m.labelposition,k.nodelabelposition,r.preDefStr.POSITION_END).toLowerCase(),n.indexOf(u)<0&&(u=r.preDefStr.POSITION_END),a={fill:(0,r.convertColor)(s.fill,s.alpha),cursor:p,stroke:s.stroke},o={fill:(0,r.convertColor)(s.fill,s.focusAlpha)},l={fill:(0,r.convertColor)(s.fill,s.focusOutAlpha)},e.attachChild(i["default"],"nodes",f).setData({id:f,index:v,mode:"normal",label:(0,r.pluck)(m.label,m.id),value:A.dataLabels(m.props.value),labelPadding:A.getCleanValue((0,r.pluck)(m.labelpadding,k.nodelabelpadding,5)),visible:(0,r.pluckNumber)(m.visible,k.shownodes,1),showLabel:(0,r.pluckNumber)(m.showlabel,k.shownodelabels,1),showValue:(0,r.pluckNumber)(m.showvalue,k.shownodevalues,0),rotateLabel:(0,r.pluckNumber)(m.rotatelabel,k.rotatenodelabels,0),labelPosition:u,valuePosition:(0,r.pluck)(m.labelposition,k.nodelabelposition,r.preDefStr.POSITION_MIDDLE),plotToolText:(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(m.tooltext,k.plottooltext))),toolText:(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(m.tooltext,m.tooltext))),nodeValue:(0,r.pluckNumber)(m.nodevalue,k.nodevalue,0),nodeDataValue:A.dataLabels(m.nodedatavalue),textOutline:(0,r.pluckNumber)(m.textoutline,k.textoutline,0),rawCosmetics:s,rawLabelCosmetics:c,props:m.props,eventArgs:{color:s.fill,alpha:s.alpha,labelFill:c.labelFill,labelAlpha:c.labelAlpha,value:m.props.value,label:m.label,sourceLinks:m.props.sourceLinks.map((function(e){return e.to})),targetLinks:m.props.targetLinks.map((function(e){return e.from}))},style:{node:{normal:a,focus:o,focusOut:l},label:{normal:t,focus:Object.assign({},t,{fill:(0,r.convertColor)(c.labelFill,c.focusAlpha)}),focusOut:Object.assign({},t,{fill:(0,r.convertColor)(c.labelFill,c.focusOutAlpha)})}}})})),L&&e._addLegend()};var r=a(224),i=o(a(1039)),n=["start","inside","end"]},1039:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(223)),i=o(a(238)),n=a(240),l=a(224);function s(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,o)}return a}function c(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?s(Object(a),!0).forEach((function(t){(0,r["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):s(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var d=function(e){function t(){return e.apply(this,arguments)||this}(0,i["default"])(t,e);var a=t.prototype;return a.getType=function(){return"node"},a.getName=function(){return"sankey-node"},a.configureAttributes=function(e){void 0===e&&(e={});var t=this.config;Object.assign(t,e)},a.allocatePosition=function(){var e,t,a,o=this.config,r=o.props,i=o.style,n=o.mode,s=o.labelPosition,d=o.showLabel,h=o.formattedLabel,u=o.showValue,p=o.value,g=o.rotateLabel,f=o.labelPadding,m=i.node[n],v=i.label[n],b=this.getFromEnv("orientation"),x=this.getFromEnv("smartLabel"),k=this.getLinkedParent().config.labelSepChar,y=h.text+(u?k+" "+p:"");d&&h.text||(y=u?p:"",x.setStyle(i.label.normal),h=x.getSmartText(y)),this.config.nodeAttr=c({x:r.x0,y:r.y0,width:Math.max(0,r.x1-r.x0),height:Math.max(0,r.y1-r.y0)},m),"horizontal"===b?g?(e="start"===s?r.x0-f-h.height/2:"inside"===s?Math.abs(r.x0+r.x1)/2:r.x1+f+h.height/2,t=Math.abs(r.y1+r.y0)/2,this.config.labelAttr=c({x:e,y:t,text:y,"text-anchor":"middle",transform:(0,l.getSuggestiveRotation)(-90,e,t)},v)):("start"===s?(e=r.x0-f,a="end"):"inside"===s?(e=Math.abs(r.x0+r.x1)/2,a="middle"):(e=r.x1+f,a="start"),t=Math.abs(r.y1+r.y0)/2,this.config.labelAttr=c({x:e,y:t,text:y,transform:"t0,0","text-anchor":a},v)):g?("start"===s?(t=r.y0-f,a="start"):"inside"===s?(t=Math.abs(r.y0+r.y1)/2,a="middle"):(t=r.y1+f,a="end"),e=Math.abs(r.x1+r.x0)/2,this.config.labelAttr=c({x:e,y:t,text:y,"text-anchor":a,transform:(0,l.getSuggestiveRotation)(-90,e,t)},v)):(t="start"===s?r.y0-f-h.height/2:"inside"===s?Math.abs(r.y0+r.y1)/2:r.y1+f+h.height/2,a="middle",e=(r.x0+r.x1)/2,this.config.labelAttr=c({x:e,y:t,text:y,transform:"t0,0","text-anchor":a},v))},a.draw=function(){var e=this.getFromEnv("chartConfig"),t=this.config,a=t.id,o=t.labelAttr,r=t.nodeAttr,i=t.textOutline,n=function(e,t,a){var o,r,i,n,s,c,d,h,u,p=l.isIpad?"&#9632;":"&#x25FC;",g=[3,133,134,143,144,145],f=t.getLinkedParent(),m=t.getFromEnv("legend"),v=[],b=[],x=a&&a.drawcustomlegendicon&&m&&m.config&&m.config.isActive?m.getItem(f.config.legendItemMap[t.config.label]):null,k=x&&x.getGraphicalElement();if(d=l.BLANKSTRING,x){if(o=(c=k&&k.legendItemSymbol)&&c.attrs.path.split(/(?=[LMCA])/),n=c&&c.node.getBBox(),o&&o.length)for(r=0;r<o.length;r++)b.push(o[r][0]),o[r]=o[r].substring(1,o[r].length),r===o.length-1&&(o[r]=o[r].substring(0,o[r].length-1)),v[r]=o[r].split(",");if(v&&v.length)for(r=0;r<v.length;r++){if(v[r].length)for(i=0;i<v[r].length;i++)v[r][i]=Number(v[r][i]),"A"!==b[r]?0===i?v[r][i]=v[r][i]-n.x:1===i&&(v[r][i]=v[r][i]-n.y):"A"===b[r]&&(5===i?v[r][i]=v[r][i]-n.x:6===i&&(v[r][i]=v[r][i]-n.y));d+=b[r]+v[r].toString()}d+="Z"}return h={label:e.label,value:e.value,nodeValue:e.props.value,nodeDataValue:e.value,plotFillColor:e.rawCosmetics&&"#"+e.rawCosmetics.fill,plotFillAlpha:e.rawCosmetics&&e.rawCosmetics.alpha,plotIdentifier:x?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n      <path d= "+d+" fill = "+k.legendItemSymbol.node.getAttribute("fill")+" stroke = "+k.legendItemSymbol.node.getAttribute("stroke")+"\n      stroke-opacity = "+k.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+k.legendItemSymbol.node.getAttribute("fill-opacity")+" \n      stroke-width = "+k.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+k.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n    </svg>":"<span style='color: "+(0,l.parseColor)(e.rawCosmetics.fill)+";'>"+p+"&nbsp;</span>"},u=(0,l.parseTooltext)(e.toolText,g,h,{value:e.value,nodeValue:e.props.value,nodeDataValue:e.value,plotFillColor:e.rawCosmetics&&"#"+e.rawCosmetics.fill,plotFillAlpha:e.rawCosmetics&&e.rawCosmetics.alpha,plotIdentifier:x?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n        <path d= "+d+" fill = "+k.legendItemSymbol.node.getAttribute("fill")+" stroke = "+k.legendItemSymbol.node.getAttribute("stroke")+"\n        stroke-opacity = "+k.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+k.legendItemSymbol.node.getAttribute("fill-opacity")+" \n        stroke-width = "+k.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+k.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n      </svg>":"<span style='color: "+(0,l.parseColor)(e.rawCosmetics.fill)+";'>"+p+"&nbsp;</span>"}),s=(0,l.parseTooltext)(e.plotToolText,g,h,{value:e.value,nodeValue:e.props.value,nodeDataValue:e.value,plotFillColor:e.rawCosmetics&&"#"+e.rawCosmetics.fill,plotFillAlpha:e.rawCosmetics&&e.rawCosmetics.alpha,plotIdentifier:x?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n        <path d= "+d+" fill = "+k.legendItemSymbol.node.getAttribute("fill")+" stroke = "+k.legendItemSymbol.node.getAttribute("stroke")+"\n        stroke-opacity = "+k.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+k.legendItemSymbol.node.getAttribute("fill-opacity")+" \n        stroke-width = "+k.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+k.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n      </svg>":"<span style='color: "+(0,l.parseColor)(e.rawCosmetics.fill)+";'>"+p+"&nbsp;</span>"}),e.setToolText=u,e.setPlotTooltext=e.setToolText?e.setToolText:s,e.plotToolText?"<div style='padding: 2px; vertical-align: middle;'>\n        <span style='color: "+(0,l.parseColor)(e.rawCosmetics.fill)+";'>"+p+"&nbsp;</span>\n        "+e.setPlotTooltext+"\n      </div>":"<div style='padding: 2px; vertical-align: middle;'>\n          <span style='color: "+(0,l.parseColor)(e.rawCosmetics.fill)+";'>"+p+"&nbsp;</span>"+e.label+"\n          &nbsp;\n          &nbsp;\n          "+e.value+"\n        </div>"}(this.config,this,e);this.addGraphicalElement({el:"rect",attr:r,container:{id:"sankey-node-group",label:"nodeGroup",isParent:!0},tooltext:n,component:this,id:a,label:"node-rect"}),o.text&&this.addGraphicalElement({el:"text",attr:o,container:{id:"sankey-node-label-group",label:"nodeLabelGroup",isParent:!0},tooltext:n,component:this,id:a,css:{},outlineText:i,label:"node-label"})},t}(n.SmartRenderer);t["default"]=d},1040:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o,n,l,s,c,d,h,u,p,g,f,m,v,b,x=e.config.links,k=e.getFromEnv("orientation"),y=e.getFromEnv("number-formatter"),C=e.getFromEnv("dataSource").chart,w=(0,r.pluckNumber)(C.nodelinkpadding,0);x.forEach((function(x){switch(x.props.index+=r.BLANK,b=x.props.index,p=(0,r.parseUnsafeString)((0,r.pluck)(x.from)),m=(0,r.parseUnsafeString)((0,r.pluck)(x.to)),h=e.getChild(p,"nodes"),u=e.getChild(m,"nodes"),v=(0,r.parseUnsafeString)((0,r.pluck)(x.tooltext,C.linktooltext,r.UNDEF)),g=h.config.value,f=u.config.value,a=(0,r.pluck)(x.color,C.linkcolor,"source"),c=h.config.rawCosmetics.fill,d=u.config.rawCosmetics.fill,a.toLowerCase()){case"source":a=c;break;case"target":a=d;break;case"blend":a=c+","+d}s={fill:a,alpha:(0,r.pluckNumber)(x.alpha,C.linkalpha,20),focusAlpha:(0,r.pluckNumber)(x.hoveralpha,C.linkhoveralpha,75),focusOutAlpha:10},t="horizontal"===k?0:90,o={stroke:(0,r.toRaphaelColor)({color:s.fill,alpha:s.alpha,angle:t}),"stroke-linecap":"butt",fill:"none"},n={stroke:(0,r.toRaphaelColor)({color:s.fill,alpha:s.focusAlpha,angle:t})},l={stroke:(0,r.toRaphaelColor)({color:s.fill,alpha:s.focusOutAlpha,angle:t})},e.attachChild(i["default"],"links",b).setData({from:p,to:m,mode:"normal",linkValue:(0,r.pluckNumber)(x.value),value:y.dataLabels((0,r.pluckNumber)(x.value)),fromValue:g,toValue:f,toolText:v,color:s.linkColor,alpha:s.alpha,curvature:(0,r.clampNumber)((0,r.pluckNumber)(x.curvature,C.linkcurvature,.5),0,1),linkType:(0,r.pluck)(x.type,C.linktype),linkPadding:w,sourceFill:c,targetFill:d,props:x.props,rawCosmetics:s,eventArgs:{color:s.fill,alpha:s.alpha,value:x.value,from:x.props.source.label,to:x.props.target.label},style:{link:{normal:o,focus:n,focusOut:l}}})})),e.attachListeners()};var r=a(224),i=o(a(1041))},1041:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(223)),i=o(a(238)),n=a(240),l=a(1042),s=a(224);function c(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,o)}return a}var d=function(e,t,a){var o,r,i,n,l,c,d,h,u=s.isIpad?"&#9632;":"&#x25FC;",p=t.getLinkedParent(),g=t.getFromEnv("legend"),f=a&&a.drawcustomlegendicon,m=[],v=[],b=f&&g&&g.config&&g.config.isActive?g.getItem(p.config.legendItemMap[t.config.from]):null,x=b&&b.getGraphicalElement(),k=f&&g&&g.config&&g.config.isActive?g.getItem(p.config.legendItemMap[t.config.to]):null,y=k&&k.getGraphicalElement();if(c="",b&&x){if(o=(l=x&&x.legendItemSymbol)&&l.attrs.path.split(/(?=[LMCA])/),n=l&&l.node.getBBox(),o&&o.length)for(r=0;r<o.length;r++)v.push(o[r][0]),o[r]=o[r].substring(1,o[r].length),r===o.length-1&&(o[r]=o[r].substring(0,o[r].length-1)),m[r]=o[r].split(",");if(m&&m.length)for(r=0;r<m.length;r++){if(m[r].length)for(i=0;i<m[r].length;i++)m[r][i]=Number(m[r][i]),"A"!==v[r]?0===i?m[r][i]=m[r][i]-n.x:1===i&&(m[r][i]=m[r][i]-n.y):"A"===v[r]&&(5===i?m[r][i]=m[r][i]-n.x:6===i&&(m[r][i]=m[r][i]-n.y));c+=v[r]+m[r].toString()}c+="Z"}return d={linkDataValue:e.value,fromPlotIdentifier:b?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n      <path d= "+c+" fill = "+x.legendItemSymbol.node.getAttribute("fill")+" stroke = "+x.legendItemSymbol.node.getAttribute("stroke")+"\n      stroke-opacity = "+x.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+x.legendItemSymbol.node.getAttribute("fill-opacity")+" \n      stroke-width = "+x.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+x.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n    </svg>":"<span style='color: "+(0,s.parseColor)(e.sourceFill)+";'>"+u+"&nbsp;</span>",toPlotIdentifier:k?"<svg height= "+n.height+" width = "+n.width+" overflow= 'visible' xmlns=\"http://www.w3.org/2000/svg\">\n      <path d= "+c+" fill = "+y.legendItemSymbol.node.getAttribute("fill")+" stroke = "+y.legendItemSymbol.node.getAttribute("stroke")+"\n      stroke-opacity = "+y.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+y.legendItemSymbol.node.getAttribute("fill-opacity")+" \n      stroke-width = "+y.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+y.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n    </svg>":"<span style='color: "+(0,s.parseColor)(e.targetFill)+";'>"+u+"&nbsp;</span>",flowDirection:"&rarr;"},h=(0,s.parseTooltext)(e.toolText,[148,149,142,150,151,152,153],e,d),e.setLinkTooltext=h,e.toolText?"<div style='padding: 2px; vertical-align: middle;'>\n        "+e.setLinkTooltext+"\n      </div>":"<div style='padding: 2px; vertical-align: middle;'>\n        <span style='color: "+(0,s.parseColor)(e.sourceFill)+";'>"+u+"&nbsp;</span>"+e.props.source.label+"\n        &rarr;\n        <span style='color: "+(0,s.parseColor)(e.targetFill)+"'>"+u+"&nbsp;</span>"+e.props.target.label+"\n        &nbsp;\n        "+e.value+"\n      </div>"},h=function(e){function t(){return e.apply(this,arguments)||this}(0,i["default"])(t,e);var a=t.prototype;return a.getType=function(){return"link"},a.getName=function(){return"sankey-link"},a.configureAttributes=function(e){void 0===e&&(e={}),Object.assign(this.config,e)},a.allocatePosition=function(){var e,t,a,o=this.config,i=o.mode,n=o.style,s=o.props,d=o.linkPadding,h=o.linkType,u=o.curvature,p=this.getFromEnv("chartConfig").orientation,g=n.link[i],f={x:s.x0,y:s.y0,width:s.linkWidth},m=s.source,v=s.target,b=m.props.layer,x=v.props.layer,k={x:s.x1,y:s.y1,width:s.linkWidth},y=this.getLinkedParent().config.columnGap;t=Math.max("vertical"===p?m.props.x1-m.props.x0:m.props.y1-m.props.y0,0),a=Math.max("vertical"===p?m.props.x1-m.props.x0:m.props.y1-m.props.y0,0),"custom"!==h&&"uniform"!==h&&(h=s.linkWidth>y*Math.abs(x-b)/3||f.width>.7*t||k.width>.7*a?"custom":"uniform"),e=(0,l.sankeyRibbon)(f,k,{orientation:p,padding:d,curvature:u,linkType:h}),o.linkAttr=function(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?c(Object(a),!0).forEach((function(t){(0,r["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):c(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}({path:e,"stroke-width":"uniform"===h?s.linkWidth:"none"},g),"custom"===h&&(o.linkAttr.fill=o.linkAttr.stroke,o.linkAttr.stroke="none")},a.draw=function(){var e=this.config,t=this.getFromEnv("chartConfig"),a=e.id,o=e.linkAttr;this.addGraphicalElement({el:"path",attr:o,container:{id:"sankey-link-group",label:"linkGroup",isParent:!0},tooltext:d(this.config,this,t),component:this,id:a,label:"sankey-link"})},t}(n.SmartRenderer);t["default"]=h},1042:function(e,t,a){"use strict";t.__esModule=!0,t.sankeyRibbon=void 0;var o="M",r="C",i="L";t.sankeyRibbon=function(e,t,a){var n=a.curvature,l=a.orientation,s=a.padding,c=a.linkType;return"horizontal"===(l=l||"horizontal")?(e.x=Math.floor(e.x+s),t.x=Math.ceil(t.x-s),function(e,t,a,n){void 0===a&&(a=.5),void 0===n&&(n="uniform");var l,s,c,d,h,u,p,g,f,m,v,b,x=e.width,k=t.width;return Math.abs(e.y-t.y)<1e-4&&(t.y+=1e-4),l=e.x+10,h=(s=e.y)-x/2,u=s+x/2,c=t.x-10,p=(d=t.y)-k/2,g=d+k/2,(c<=l||"uniform"!==n)&&(l-=10,c+=10),f=a*Math.abs(c-l)+l,m=s,v=(1-a)*Math.abs(c-l)+l,b=d,"uniform"===n?o+e.x+","+s+" "+i+l+","+s+" "+r+f+","+m+" "+v+","+b+" "+c+","+d+" "+i+t.x+","+d:o+l+","+h+" "+i+l+","+h+" "+r+f+","+h+" "+v+","+p+" "+c+","+p+" "+i+c+","+g+" "+r+v+","+g+" "+f+","+u+" "+l+","+u+" "+i+l+","+h}(e,t,n,c)):(e.y=Math.floor(e.y+s),t.y=Math.ceil(t.y-s),function(e,t,a,n){void 0===a&&(a=.5),void 0===n&&(n="uniform");var l,s,c,d,h,u,p,g,f,m,v,b,x=e.width,k=t.width;return Math.abs(e.x-t.x)<1e-4&&(t.x+=1e-4),h=(l=e.x)-x/2,u=l+x/2,s=e.y+10,p=(c=t.x)-k/2,g=c+k/2,((d=t.y-10)<=s||"uniform"!==n)&&(s-=10,d+=10),f=l,m=a*Math.abs(d-s)+s,v=c,b=(1-a)*Math.abs(d-s)+s,"uniform"===n?o+l+","+e.y+" "+i+l+","+s+" "+r+f+","+m+" "+v+","+b+" "+c+","+d+" "+i+c+","+t.y:o+h+","+s+" "+i+h+","+s+" "+r+h+","+m+" "+p+","+b+" "+p+","+d+" "+i+g+","+d+" "+r+g+","+b+" "+u+","+m+" "+u+","+s+" "+i+h+","+s}(e,t,n,c))}},1043:function(e,t,a){"use strict";function o(e,t){var a="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(a)return(a=a.call(e)).next.bind(a);if(Array.isArray(e)||(a=function(e,t){if(!e)return;if("string"==typeof e)return r(e,t);var a=Object.prototype.toString.call(e).slice(8,-1);"Object"===a&&e.constructor&&(a=e.constructor.name);if("Map"===a||"Set"===a)return Array.from(e);if("Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))return r(e,t)}(e))||t&&e&&"number"==typeof e.length){a&&(e=a);var o=0;return function(){return o>=e.length?{done:!0}:{done:!1,value:e[o++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,o=new Array(t);a<t;a++)o[a]=e[a];return o}t.__esModule=!0,t.createGraph=function(e){return c(e),p(e),e},t.createNodeLinks=c,t.createNodeValues=p,t.traverseGraph=function(e){var t=e.nodes,a=new Set(t),r=new Set,i=0;for(;a.size;){if(a.forEach((function(e){var t=e;t.props.depth=i;for(var a,n=o(t.props.sourceLinks);!(a=n()).done;){var l=a.value;r.add(l.props.target)}})),++i>t.length)return!1;a=r,r=new Set}return!0},t.createNodeDimensions=function(e,t){for(var a,r=t,s=e.nodes,c=i.apply(null,s.map((function(e){return e.props.depth})))+1,d=new Array(c),h=o(s);!(a=h()).done;){var p=a.value,m=i(0,n(c-1,p.props.depth));p.props.layer=m,d[m]?d[m].push(p):d[m]=[p]}if(function(e,t,a){var r,s,c,d,h,u=e,p=a,g=t,f=p.orientation;r=i.apply(null,u[g-1].map((function(e){return e.nodeWidth}))),h=f===l?(p.height[1]-p.height[0]-r)/(g-1):(p.width[1]-p.width[0]-r)/(g-1),c=p.nodeGutter,s=i.apply(null,u.map((function(e){return e.length}))),f===l?((s-1)*c>=p.width[1]-p.width[0]||(s-1)*c<0)&&(c=p.nodeGutter=10):((s-1)*c>=p.height[1]-p.height[0]||(s-1)*c<0)&&(c=p.nodeGutter=10);d=n.apply(null,u.map((function(e){for(var t,a=0,r=o(e);!(t=r()).done;){a+=t.value.props.value}return f===l?(p.width[1]-p.width[0]-(e.length-1)*c)/a:(p.height[1]-p.height[0]-(e.length-1)*c)/a}))),h&&h!==Infinity&&h!==-Infinity||(h=0);d&&d!==Infinity&&d!==-Infinity||(d=0);for(var m,v=o(u);!(m=v()).done;){var b=m.value;if(f===l)for(var x,k=p.width[0],y=o(b);!(x=y()).done;){for(var C,w=x.value,A=o(w.props.sourceLinks);!(C=A()).done;){var S=C.value;S.props.linkWidth=S.value*d}w.props.y0=p.height[0]+w.props.layer*h,w.props.y1=w.props.y0+w.nodeWidth,w.props.x0=k,w.props.x1=w.props.x0+d*w.props.value,k=w.props.x1+c}else for(var N,L=p.height[0],D=o(b);!(N=D()).done;){for(var E,T=N.value,F=o(T.props.sourceLinks);!(E=F()).done;){var P=E.value;P.props.linkWidth=P.value*d}T.props.x0=p.width[0]+T.props.layer*h,T.props.x1=T.props.x0+T.nodeWidth,T.props.y0=L,T.props.y1=T.props.y0+d*T.props.value,L=T.props.y1+c}}}(d,c,r),r.nodeRelaxation)for(var v=0;v<6;++v){var b=Math.pow(.99,v),x=Math.max(1-b,(v+1)/6);f(d,b,x,r),g(d,b,x,r)}!function(e,t){for(var a,r=e.nodes,i=t&&t.orientation,n=o(r);!(a=n()).done;){var s=a.value;if(i===l){for(var c,d=s.props.x0,h=d,p=o(u(s.props.sourceLinks,i));!(c=p()).done;){var g=c.value;g.props.x0=d+g.props.linkWidth/2,g.props.y0=g.props.source.props.y1,d+=g.props.linkWidth}for(var f,m=o(s.props.targetLinks);!(f=m()).done;){var v=f.value;v.props.x1=h+v.props.linkWidth/2,v.props.y1=v.props.target.props.y0,h+=v.props.linkWidth}}else{for(var b,x=s.props.y0,k=x,y=o(u(s.props.sourceLinks));!(b=y()).done;){var C=b.value;C.props.y0=x+C.props.linkWidth/2,C.props.x0=C.props.source.props.x1,x+=C.props.linkWidth}for(var w,A=o(s.props.targetLinks);!(w=A()).done;){var S=w.value;S.props.y1=k+S.props.linkWidth/2,S.props.x1=S.props.target.props.x0,k+=S.props.linkWidth}}}}(e,r)};var i=Math.max,n=Math.min,l="vertical";function s(e,t){var a=t;return e.find((function(e){return e.id===a||e.label===a}))}function c(e){var t=e.nodes,a=e.links;t.forEach((function(e){var t=e;t.props.sourceLinks=[],t.props.targetLinks=[]})),a.forEach((function(e,a){var o=e,r=o.props,i=r.source,n=r.target;"object"!=typeof i&&(i=o.props.source=s(t,i)),"object"!=typeof n&&(n=o.props.target=s(t,n)),i.props.sourceLinks.push(o),n.props.targetLinks.push(o),o.props.index=a}))}function d(e,t){return e.props.target.props.y0-t.props.target.props.y0}function h(e,t){return e.props.target.props.x0-t.props.target.props.x0}function u(e,t){var a=e;return t===l?a.sort(h):a.sort(d),a}function p(e){var t=e.nodes;t&&t.forEach((function(e){for(var t,a=0,r=0,n=e,l=o(n.props.sourceLinks);!(t=l()).done;){var s=t.value.value;a+=Number(s)}for(var c,d=o(n.props.targetLinks);!(c=d()).done;){var h=c.value.value;r+=Number(h)}n.props.value=i(a,r)}))}function g(e,t,a,r){for(var i=r&&r.orientation,n=1,s=e.length;n<s;++n){for(var c,d=void 0,h=e[n],u=o(h);!(c=u()).done;){for(var p,g=c.value,f=0,v=0,b=o(g.props.targetLinks);!(p=b()).done;){var k=p.value,y=k.value*(g.props.layer-k.props.source.props.layer);f+=x(k.props.source,g,r)*y,v+=y}v>0&&(i===l?(d=(f/v-g.props.x0)*t,g.props.x0+=d,g.props.x1+=d):(d=(f/v-g.props.y0)*t,g.props.y0+=d,g.props.y1+=d))}m(h,a,r)}}function f(e,t,a,r){for(var i=r&&r.orientation,n=e.length-2;n>=0;--n){for(var s,c=void 0,d=e[n],h=o(d);!(s=h()).done;){for(var u,p=s.value,g=0,f=0,v=o(p.props.sourceLinks);!(u=v()).done;){var b=u.value,x=b.props.target,y=b.value*(x.props.layer-p.props.layer);g+=k(p,x,r)*y,f+=y}f>0&&(i===l?(c=(g/f-p.props.x0)*t,p.props.x0+=c,p.props.x1+=c):(c=(g/f-p.props.y0)*t,p.props.y0+=c,p.props.y1+=c))}m(d,a,r)}}function m(e,t,a){var o=e.length>>1,r=e[o];(a&&a.orientation)===l?(b(e,r.props.x0-a.nodeGutter,o-1,t,a),v(e,r.props.x1+a.nodeGutter,o+1,t,a),b(e,a.width[1],e.length-1,t,a),v(e,a.width[0],0,t,a)):(b(e,r.props.y0-a.nodeGutter,o-1,t,a),v(e,r.props.y1+a.nodeGutter,o+1,t,a),b(e,a.height[1],e.length-1,t,a),v(e,a.height[0],0,t,a))}function v(e,t,a,o,r){for(var i=a,n=t,s=r&&r.orientation;i<e.length;++i){var c=e[i],d=(n-(s===l?c.props.x0:c.props.y0))*o;s===l?(d>1e-6&&(c.props.x0+=d,c.props.x1+=d),n=c.props.x1+r.nodeGutter):(d>1e-6&&(c.props.y0+=d,c.props.y1+=d),n=c.props.y1+r.nodeGutter)}}function b(e,t,a,o,r){for(var i=a,n=t,s=r&&r.orientation;i>=0;--i){var c=e[i],d=((s===l?c.props.x1:c.props.y1)-n)*o;s===l?(d>1e-6&&(c.props.x0-=d,c.props.x1-=d),n=c.props.x0-r.nodeGutter):(d>1e-6&&(c.props.y0-=d,c.props.y1-=d),n=c.props.y0-r.nodeGutter)}}function x(e,t,a){for(var r,i=((a&&a.orientation)===l?e.props.x0:e.props.y0)-(e.props.sourceLinks.length-1)*a.nodeGutter/2,n=o(e.props.sourceLinks);!(r=n()).done;){var s=r.value,c=s.props.target,d=s.props.linkWidth;if(c===t)break;i+=d+a.nodeGutter}for(var h,u=o(t.props.targetLinks);!(h=u()).done;){var p=h.value,g=p.props.source,f=p.props.linkWidth;if(g===e)break;i-=f}return i}function k(e,t,a){for(var r,i=((a&&a.orientation)===l?t.props.x0:t.props.y0)-(t.props.targetLinks.length-1)*a.nodeGutter/2,n=o(t.props.targetLinks);!(r=n()).done;){var s=r.value,c=s.props.source,d=s.props.linkWidth;if(c===e)break;i+=d+a.nodeGutter}for(var h,u=o(e.props.sourceLinks);!(h=u()).done;){var p=h.value,g=p.props.target,f=p.props.linkWidth;if(g===t)break;i-=f}return i}},1044:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"*.dataset.sankey":function(){var e=this.getClip("canvas"),t=this.getClip("init");return{"linkGroup.appearing":function(){return[{initialAttr:{"clip-rect":t},finalAttr:{"clip-rect":e},slot:"plot"}]},"nodeGroup.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"axis"}]},"nodeLabelGroup.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]}}}}},1045:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=function(e){var t,a,r,i,n,l,s,c=e.getDSdef(),d=e.getFromEnv("dataSource").chart||{},h=e.config.dataLabelStyle,u=e.getFromEnv("sankey-graph"),p=u.nodes,g=u.links;t=(0,o.pluckNumber)(d.nodelabelfontbold,d.labelfontbold,0)?"bold":"normal",a=(0,o.pluckNumber)(d.nodelabelfontitalic,d.labelfontitalic,0)?"italic":"normal",r=(0,o.pluckNumber)(d.nodelabelborderthickness,d.labelborderthickness,1),i=(0,o.pluckNumber)(d.nodelabelborderpadding,d.labelborderpadding,2),n=(0,o.pluckNumber)(d.nodelabelborderradius,d.labelborderradius,0),l=(0,o.pluckNumber)(d.nodelabelborderdashed,d.labelborderdashed,0)?(0,o.getDashStyle)((0,o.pluckNumber)(d.nodelabelborderdashlen,d.labelborderdashlen,4),(0,o.pluckNumber)(d.nodelabelborderdashgap,d.labelborderdashgap,2)):o.DASH_DEF,s=(0,o.pluckNumber)(d.shownodes,1),(0,o.componentFactory)(e,c,"dataset",1),e.getDatasets()[0].configure({showNodes:s,nodeWidth:e.config.nodeWidth,nodeRelaxation:(0,o.pluckNumber)(d.noderelaxation,1),nodeSpacing:(0,o.pluckNumber)(d.nodespacing,10),labelSepChar:(0,o.parseUnsafeString)((0,o.pluck)(d.labelSepChar,",")),enableDrag:(0,o.pluckNumber)(d.enabledrag,!0),highlightEffect:(0,o.pluckNumber)(d.highlighteffect,!0),style:{node:{label:{fontFamily:(0,o.pluck)(d.nodelabelfont,d.labelfont,h.fontFamily),fontSize:(0,o.pluck)(d.nodelabelfontsize,d.labelfontsize,d.basefontsize,11+o.PXSTRING),fontWeight:t,fontStyle:a,borderThickness:r,borderPadding:i,borderRadius:n,borderDash:l}},link:{}},nodes:p,links:g})};var o=a(224)},1046:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1047))["default"];t["default"]=r},1047:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=o(a(1048)),l=o(a(1050)),s=o(a(1051)),c=o(a(567)),d=o(a(1052)),h=o(a(1056)),u=a(224),p=o(a(366)),g=u.preDefStr.defaultFontStr,f=u.preDefStr.divLineAlpha3DStr,m=u.preDefStr.divLineAlphaStr,v=u.preDefStr.altVGridColorStr,b=u.preDefStr.altVGridAlphaStr,x=u.preDefStr.altHGridColorStr,k=u.preDefStr.altHGridAlphaStr,y=u.preDefStr.colors.c000000,C=function(e){return void 0!==e.id},w=function(e){function t(){var t;return(t=e.call(this)||this).tooltipsepchar=" = ",t.hasGradientLegend=!0,t.registerFactory("axis",s["default"],["canvas"]),t.registerFactory("legend",h["default"],["canvas"]),t.registerFactory("colormanager-decider",d["default"],["legend"]),t.registerFactory("dataset",c["default"],["colormanager-decider","vCanvas"]),t}(0,r["default"])(t,e),t.getName=function(){return"HeatMap"};var a=t.prototype;return a.getName=function(){return"HeatMap"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.isSingleSeries=!0,t.hasLegend=!0,t.defaultDatasetType="heatmap",t.enablemousetracking=!0},a._checkInvalidSpecificData=function(){var e,t=this.getFromEnv("dataSource"),a=t.dataset,o=t.colorrange;if(a)for(var r=0;r<a.length;r++)if(a[r].data){e=a[r].data;break}if(!a||!e||0===e.length||!o||!o.color&&!Number(o.gradient))return!0},a.parseChartAttr=function(t){e.prototype.parseChartAttr.call(this,t),this.config.drawTrendRegion=0},a.configureAttributes=function(e){var t,a,o=this.config,r=this.getFromEnv("dataSource"),i=this.config.skipConfigureIteration={},n=e.dataset,l=[];if(t=r.rows&&r.rows.row.filter(C),a=r.columns&&r.columns.column.filter(C),!t||!a){for(var s=0;s<n.length;s++)for(var c=0;c<n[s].data.length;c++)l.push(n[s].data[c]);t||(t=l.map((function(e){return(0,u.getFirstValue)(e.rowid)})).filter((function(e,t,a){return a.indexOf(e)===t}))),a||(a=l.map((function(e){return(0,u.getFirstValue)(e.columnid)})).filter((function(e,t,a){return a.indexOf(e)===t})))}this.parseChartAttr(e),this.addToEnv("chartColorRange",e.colorrange||{}),this.createComponent(e),this._feedAxesRawData(),i.axis=!0,this.addToEnv("totalRows",t.length),this.addToEnv("totalColumns",a.length),this.configureChildren(),this.asyncDraw(),this.getFromEnv("toolTipController").setStyle({backgroundColor:u.hasSVG?(0,u.convertColor)(o.tooltipbgcolor||"FFF",o.tooltipbgalpha||100):(o.tooltipbgcolor||"FFF").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),color:(o.tooltipcolor||o.basefontcolor||"545454").replace(/^#?([a-f0-9]+)/gi,"#$1"),borderColor:u.hasSVG?(0,u.convertColor)(o.tooltipbordercolor||"666",o.tooltipborderalpha||100):(o.tooltipbordercolor||"666").replace(/\s+/g,"").replace(/^#?([a-f0-9]+)/gi,"#$1"),borderWidth:(0,u.pluckNumber)(o.tooltipborderthickness,1)+"px",showToolTipShadow:(0,u.pluckNumber)(o.showtooltipshadow||0),borderRadius:(0,u.pluckNumber)(o.tooltipborderradius,0)+"px",fontSize:(0,u.pluckNumber)(o.basefontsize,10)+"px",fontFamily:o.basefont||this.getFromEnv("style").inCanfontFamily,padding:(0,u.pluckNumber)(o.tooltippadding||3)+"px"})},a._postSpaceManagement=function(){var e=this.getChildren("xAxis")[0],t=this.getFromEnv("legend"),a=this.config.xDepth;this.setAxisDimention(),e&&e.shiftLabels(-a,0),t&&t.postSpaceManager(),this.allocateDimensionOfChartMenuBar()},a.setAxisDimention=function(){var e=this.getChildren("xAxis")&&this.getChildren("xAxis")[0],t=this.getChildren("yAxis")&&this.getChildren("yAxis")[0],a=this.getFromEnv("chartConfig"),o=this.getChildren("canvas")[0],r=o.config,i=o.getEffectiveDimensions(),n=i.left,l=i.top,s=i.width,c=i.height,d=i.paddingLeft,h=i.paddingRight,u=r&&r.canvasBorderWidth,p=r&&r.canvasPadding;e&&e.setAxisConfig({canvasPaddingLeft:Math.max(d,p),canvasPaddingRight:Math.max(h,p)}),e&&e.setAxisDimention({x:n,y:e.config.isOpposit?l+(a.shift||0)-u:l+c+(a.shift||0)+u,opposite:e.config.isOpposit?l+c+u:l-u,axisLength:s}),t&&t.setAxisDimention({x:t.config.isOpposit?n+s+u:n-u,y:l,opposite:t.config.isOpposit?n-u:n+s+u,axisLength:c})},a._feedAxesRawData=function(){var e,t,a=this.getFromEnv("color-manager"),o=this.getFromEnv("dataSource"),r=o.chart,i=this.config.is3D,n=i?u.chartPaletteStr.chart3D:u.chartPaletteStr.chart2D,l=(0,u.parseUnsafeString)(r.xaxisposition).toLowerCase(),s=(0,u.pluckFontSizeMaintainUnit)(r.outcnvbasefontsize,r.basefontsize,10);return e={mapTickValuesById:!0,isVertical:!1,isReverse:!1,isOpposit:(0,u.pluckNumber)("top"===l||void 0,"bottom"!==l&&void 0,!!this.config.placeAxisLabelsOnTop),outCanfontFamily:(0,u.pluck)(r.outcnvbasefont,r.basefont,g),outCanfontSize:this.computeFontSize(s),outCanfontSizeWithUnit:s,outCancolor:(0,u.pluck)(r.outcnvbasefontcolor,r.basefontcolor,a.getColor(n.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),axisNamePadding:r.xaxisnamepadding,axisValuePadding:(0,u.pluckNumber)(r.labelxpadding,r.labelpadding,4),axisNameFont:r.xaxisnamefont,axisNameFontSize:this.computeFontSize(r.xaxisnamefontsize),axisNameFontSizeWithUnit:r.xaxisnamefontsize,axisNameFontColor:r.xaxisnamefontcolor,axisNameFontBold:r.xaxisnamefontbold,axisNameFontItalic:r.xaxisnamefontitalic,axisNameBgColor:r.xaxisnamebgcolor,axisNameBorderColor:r.xaxisnamebordercolor,axisNameAlpha:r.xaxisnamealpha,axisNameFontAlpha:r.xaxisnamefontalpha,axisNameBgAlpha:r.xaxisnamebgalpha,axisNameBorderAlpha:r.xaxisnameborderalpha,axisNameBorderPadding:r.xaxisnameborderpadding,axisNameBorderRadius:r.xaxisnameborderradius,axisNameBorderThickness:r.xaxisnameborderthickness,axisNameBorderDashed:r.xaxisnameborderdashed,axisNameBorderDashLen:r.xaxisnameborderdashlen,axisNameBorderDashGap:r.xaxisnameborderdashgap,useEllipsesWhenOverflow:r.useellipseswhenoverflow,divLineColor:(0,u.pluck)(r.vdivlinecolor,r.divlinecolor,a.getColor(n.divLineColor)),divLineAlpha:(0,u.pluck)(r.vdivlinealpha,r.divlinealpha,i?a.getColor(f):a.getColor(m)),divLineThickness:(0,u.pluckNumber)(r.vdivlinethickness,r.divlinethickness,1),divLineIsDashed:Boolean((0,u.pluckNumber)(r.vdivlinedashed,r.vdivlineisdashed,r.divlinedashed,r.divlineisdashed,0)),divLineDashLen:(0,u.pluckNumber)(r.vdivlinedashlen,r.divlinedashlen,4),divLineDashGap:(0,u.pluckNumber)(r.vdivlinedashgap,r.divlinedashgap,2),showAlternateGridColor:(0,u.pluckNumber)(r.showalternatevgridcolor,0),alternateGridColor:(0,u.pluck)(r.alternatevgridcolor,a.getColor(v)),alternateGridAlpha:(0,u.pluck)(r.alternatevgridalpha,a.getColor(b)),numDivLines:r.numvdivlines,labelFont:r.labelfont,labelFontSize:this.computeFontSize(r.labelfontsize),labelFontSizeWithUnit:r.labelfontsize,labelFontColor:r.labelfontcolor,labelAlpha:r.labelalpha,labelFontBold:r.labelfontbold,labelFontItalic:r.labelfontitalic,labelBdrColor:r.labelbordercolor,labelBdrAlpha:r.labelborderalpha,labelLink:r.labellink,labelBgColor:r.labelbgcolor,labelBgAlpha:r.labelbgalpha,labelBdrThickness:r.labelborderthickness,labelBdrPadding:r.labelborderpadding,labelBdrRadius:r.labelborderradius,labelBdrDashed:r.labelborderdashed,labelBdrDashLen:r.labelborderdashlen,labelBdrDashGap:r.labelborderdashgap,axisName:r.xaxisname,axisMinValue:r.xaxisminvalue,axisMaxValue:r.xaxismaxvalue,setAdaptiveMin:r.setadaptivexmin,adjustDiv:r.adjustvdiv,labelDisplay:r.labeldisplay,showLabels:(0,u.pluckNumber)(r.showxaxislabels,r.showlabels),rotateLabels:r.rotatexaxislabels,slantLabel:(0,u.pluckNumber)(r.slantlabels,r.slantlabel),labelStep:(0,u.pluckNumber)(r.labelstep,r.xaxisvaluesstep),showAxisValues:(0,u.pluckNumber)(r.showxaxisvalues,r.showxaxisvalue),maxLabelHeight:r.maxlabelheight,showZeroPlane:r.showvzeroplane,zeroPlaneColor:r.vzeroplanecolor,zeroPlaneThickness:r.vzeroplanethickness,zeroPlaneAlpha:r.vzeroplanealpha,showZeroPlaneValue:r.showvzeroplanevalue,trendlineColor:r.trendlinecolor,trendlineToolText:r.trendlinetooltext,trendlineThickness:r.trendlinethickness,trendlineAlpha:r.trendlinealpha,showTrendlinesOnTop:r.showtrendlinesontop,showAxisLine:(0,u.pluckNumber)(r.showxaxisline,r.showaxislines,r.drawAxisLines,0),axisLineThickness:(0,u.pluckNumber)(r.xaxislinethickness,r.axislinethickness,1),axisLineAlpha:(0,u.pluckNumber)(r.xaxislinealpha,r.axislinealpha,100),axisLineColor:(0,u.pluck)(r.xaxislinecolor,r.axislinecolor,y)},t={mapTickValuesById:!0,isVertical:!0,isReverse:!1,isOpposit:(0,p["default"])(r.yaxisposition,"right"),outCanfontFamily:(0,u.pluck)(r.outcnvbasefont,r.basefont,g),outCanfontSize:this.computeFontSize(s),outCanfontSizeWithUnit:s,outCancolor:(0,u.pluck)(r.outcnvbasefontcolor,r.basefontcolor,a.getColor(n.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),axisNamePadding:r.yaxisnamepadding,axisValuePadding:(0,u.pluckNumber)(r.labelypadding,r.yaxisvaluespadding,4),axisNameFont:r.yaxisnamefont,axisNameFontSize:this.computeFontSize(r.yaxisnamefontsize),axisNameFontSizeWithUnit:r.yaxisnamefontsize,axisNameFontColor:r.yaxisnamefontcolor,axisNameFontBold:r.yaxisnamefontbold,axisNameFontItalic:r.yaxisnamefontitalic,axisNameBgColor:r.yaxisnamebgcolor,axisNameBorderColor:r.yaxisnamebordercolor,axisNameAlpha:r.yaxisnamealpha,axisNameFontAlpha:r.yaxisnamefontalpha,axisNameBgAlpha:r.yaxisnamebgalpha,axisNameBorderAlpha:r.yaxisnameborderalpha,axisNameBorderPadding:r.yaxisnameborderpadding,axisNameBorderRadius:r.yaxisnameborderradius,axisNameBorderThickness:r.yaxisnameborderthickness,axisNameBorderDashed:r.yaxisnameborderdashed,axisNameBorderDashLen:r.yaxisnameborderdashlen,axisNameBorderDashGap:r.yaxisnameborderdashgap,axisNameWidth:r.yaxisnamewidth,useEllipsesWhenOverflow:r.useellipseswhenoverflow,rotateAxisName:(0,u.pluckNumber)(r.rotateyaxisname,1),axisName:r.yaxisname,showAlternateGridColor:(0,u.pluckNumber)(r.showalternatehgridcolor,1),alternateGridColor:(0,u.pluck)(r.alternatehgridcolor,a.getColor(x)),alternateGridAlpha:(0,u.pluck)(r.alternatehgridalpha,a.getColor(k)),numDivLines:r.numdivlines,axisMinValue:r.yaxisminvalue,axisMaxValue:r.yaxismaxvalue,setAdaptiveMin:r.setadaptiveymin,adjustDiv:r.adjustdiv,labelStep:r.yaxisvaluesstep,showLabels:(0,u.pluckNumber)(r.showyaxislabels,r.showlabels),maxLabelWidthPercent:r.maxlabelwidthpercent,showAxisValues:(0,u.pluckNumber)(r.showyaxisvalues,r.showyaxisvalue),divLineColor:(0,u.pluck)(r.hdivlinecolor,a.getColor(n.divLineColor)),divLineAlpha:(0,u.pluck)(r.hdivlinealpha,a.getColor(m)),divLineThickness:(0,u.pluckNumber)(r.hdivlinethickness,1),divLineIsDashed:Boolean((0,u.pluckNumber)(r.hdivlinedashed,r.hdivlineisdashed,0)),divLineDashLen:(0,u.pluckNumber)(r.hdivlinedashlen,4),divLineDashGap:(0,u.pluckNumber)(r.hdivlinedashgap,2),showZeroPlane:r.showzeroplane,zeroPlaneColor:r.zeroplanecolor,zeroPlaneThickness:r.zeroplanethickness,zeroPlaneAlpha:r.zeroplanealpha,showZeroPlaneValue:r.showzeroplanevalue,trendlineColor:r.trendlinecolor,trendlineToolText:r.trendlinetooltext,trendlineThickness:r.trendlinethickness,trendlineAlpha:r.trendlinealpha,showTrendlinesOnTop:r.showtrendlinesontop,showAxisLine:(0,u.pluckNumber)(r.showyaxisline,r.showaxislines,r.drawAxisLines,0),axisLineThickness:(0,u.pluckNumber)(r.yaxislinethickness,r.axislinethickness,1),axisLineAlpha:(0,u.pluckNumber)(r.yaxislinealpha,r.axislinealpha,100),axisLineColor:(0,u.pluck)(r.yaxislinecolor,r.axislinecolor,y),labelFont:r.labelfont,labelFontSize:this.computeFontSize(r.labelfontsize),labelFontSizeWithUnit:r.labelfontsize,labelFontColor:r.labelfontcolor,labelAlpha:r.labelalpha,labelFontBold:r.labelfontbold,labelFontItalic:r.labelfontitalic,labelBdrColor:r.labelbordercolor,labelBdrAlpha:r.labelborderalpha,labelLink:r.labellink,labelBgColor:r.labelbgcolor,labelBgAlpha:r.labelbgalpha,labelBdrThickness:r.labelborderthickness,labelBdrPadding:r.labelborderpadding,labelBdrRadius:r.labelborderradius,labelBdrDashed:r.labelborderdashed,labelBdrDashLen:r.labelborderdashlen,labelBdrDashGap:r.labelborderdashgap},e.vtrendlines=o.vtrendlines,t.trendlines=o.trendlines,{yAxisConf:[t],xAxisConf:[e]}},a._setCategories=function(){var e,t,a,o,r,i,n,l,s,c,d,h,p=this.getFromEnv("dataSource"),g=this.getChildren("xAxis"),f=this.getChildren("yAxis"),m=[],v=[];if(!p.columns||!p.rows)for(p.columns={},p.columns.column=i=[],p.rows={},p.rows.row=n=[],a=0;a<(p.dataset&&p.dataset.length);a++)for(e=p.dataset&&p.dataset[a].data&&p.dataset[a].data.length,t=0;t<e;t++){for(l=(0,u.getFirstValue)(p.dataset[a].data[t].columnid),s=(0,u.getFirstValue)(p.dataset[a].data[t].rowid),c=!0,d=!0,h=0;h<i.length;h++)l===i[h].id&&(c=!1);for(c&&(o={id:l,label:l},p.columns.column.push(o)),h=0;h<n.length;h++)s===n[h].id&&(d=!1);d&&(r={id:s,label:s},p.rows.row.push(r))}for(i=p.columns.column,n=p.rows.row,t=0;t<(i&&i.length);t++)i[t].label=(0,u.pluck)(i[t].label,i[t].name,i[t].id),m.push(i[t]);for(p.columns.column=m,t=0;t<(n&&n.length);t++)n[t].label=(0,u.pluck)(n[t].label,n[t].name,n[t].id),v.push(n[t]);p.rows.row=v,p.columns&&g[0].setTickValues(p.columns.column),p.rows&&f[0].setTickValues(p.rows.row),g[0].setAxisConfig({categoryNumDivLines:this.getFromEnv("totalColumns")-1,categoryDivLinesFromZero:0,showAlternateGridColor:0}),f[0].setAxisConfig({categoryNumDivLines:this.getFromEnv("totalRows")-1,categoryDivLinesFromZero:0,showAlternateGridColor:0})},a.getDSdef=function(){return n["default"]},a.getDSGroupdef=function(){return l["default"]},t}(i["default"]);t["default"]=w},1048:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(240),n=a(224),l=a(232),s=o(a(1049)),c=a(236),d=n.preDefStr.pStr,h=n.preDefStr.sStr,u=n.preDefStr.miterStr,p=n.preDefStr.hiddenStr,g=n.preDefStr.showHoverEffectStr,f=n.preDefStr.POSITION_START,m=n.preDefStr.POSITION_TOP,v=n.preDefStr.POSITION_END,b=n.preDefStr.POSITION_BOTTOM,x=n.preDefStr.DEFAULT,k=function(e){return null!=e},y=function(e,t,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:e,container:t,component:a,label:"group"})},C="rgba(192,192,192,"+(n.isIE?.002:1e-6)+")",w=n.hasTouch?n.TOUCH_THRESHOLD_PIXELS:n.CLICK_THRESHOLD_PIXELS,A=Math.max,S=Math.min,N=Math.abs;(0,l.addDep)({name:"heatmapAnimation",type:"animationRule",extension:s["default"]});var L=function(e){function t(){var t;return(t=e.call(this)||this).components={},t.graphics={},t.dataSetArray=[],t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"heatMap"},a.configureAttributes=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,i,l,s,c,u=this.getFromEnv("chart"),p=this.config,g=p.JSONData,f=g.data,m=f&&f.length,v=this.getFromEnv("chart-attrib"),b=this.getFromEnv("color-manager"),x=(0,n.pluckNumber)(g.dashed,v.plotborderdashed),k=this.components.data,y=this.components.plotGrid=[],C=u.isBar,w=u.config.is3D,A=-Infinity,S=+Infinity,N=this.getFromEnv("totalRows"),L=this.getFromEnv("totalColumns");for(s=0;s<N;s++)for(y.push([]),c=0;c<L;c++)y[s].push([]);for(this.setState("visible",1===(0,n.pluckNumber)(this.getState("visible"),this.config.JSONData.visible,!Number(this.config.JSONData.initiallyhidden),1)),p.showplotborder=(0,n.pluckNumber)(v.showplotborder,w?0:1),p.plotDashLen=(0,n.pluckNumber)(v.plotborderdashlen,5),p.plotDashGap=(0,n.pluckNumber)(v.plotborderdashgap,4),p.showTextOutLine=(0,n.pluckNumber)(v.textoutline,0),p.plotfillAngle=(0,n.pluckNumber)(360-v.plotfillangle,C?180:90),p.plotFillAlpha=(0,n.pluck)(g.alpha,v.plotfillalpha,"100"),p.plotColor=(0,n.pluck)(g.color,b.getPlotColor(this.index||this.positionIndex)),p.isRoundEdges=(0,n.pluckNumber)(v.useroundedges,0),p.plotRadius=(0,n.pluckNumber)(v.useRoundEdges,p.isRoundEdges?1:0),p.plotFillRatio=(0,n.pluck)(g.ratio,v.plotfillratio),p.plotgradientcolor=(0,n.getDefinedColor)(v.plotgradientcolor,b.getColor("plotGradientColor")),p.plotBorderAlpha=p.showplotborder?(0,n.pluck)(v.plotborderalpha,p.plotFillAlpha,"100"):0,p.plotBorderColor=(0,n.pluck)(v.plotbordercolor,w?"FFFFFF":b.getColor("plotBorderColor")),p.plotBorderThickness=(0,n.pluckNumber)(v.plotborderthickness,1),p.plotBorderDashStyle=x?(0,n.getDashStyle)(p.plotDashLen,p.plotDashGap):"none",p.showValues=(0,n.pluckNumber)(g.showvalues,v.showvalues,1),p.valuePadding=(0,n.pluckNumber)(v.valuepadding,2),p.enableAnimation=i=(0,n.pluckNumber)(v.animation,v.defaultanimation,1),p.animation=!!i&&{duration:1e3*(0,n.pluckNumber)(v.animationduration,1)},p.transposeAnimation=(0,n.pluckNumber)(v.transposeanimation,i),p.transposeAnimDuration=1e3*(0,n.pluckNumber)(v.transposeanimduration,.2),p.showShadow=p.isRoundEdges||w?(0,n.pluckNumber)(v.showshadow,1):(0,n.pluckNumber)(v.showshadow,b.getColor("showShadow")),p.showHoverEffect=(0,n.pluckNumber)(v.plothovereffect,v.showhovereffect,void 0),p.showTooltip=(0,n.pluckNumber)(v.showtooltip,1),p.definedGroupPadding=Math.max((0,n.pluckNumber)(v.plotspacepercent),0),p.plotSpacePercent=Math.max((0,n.pluckNumber)(v.plotspacepercent,20)%100,0),p.maxColWidth=(0,n.pluckNumber)(C?v.maxbarheight:v.maxcolwidth,50),p.plotPaddingPercent=(0,n.pluckNumber)(v.plotpaddingpercent),p.rotateValues=(0,n.pluckNumber)(v.rotatevalues)?270:0,p.placeValuesInside=(0,n.pluckNumber)(v.placevaluesinside,0),p.defaultPadding={left:.5,right:.5,top:.5,bottom:.5},p.use3DLighting=(0,n.pluckNumber)(v.use3dlighting,1),p.parentYAxis=(0,n.pluck)(g.parentyaxis&&g.parentyaxis.toLowerCase(),d)===h?1:0,k||(k=this.components.data=[]),l=0;l<m;l++)t=f&&f[l],r=(o=k[l])&&o.config,o||(o=k[l]={graphics:{}}),o.config||(r=k[l].config={}),r.setValue=a=this.getFromEnv("number-formatter").getCleanValue(t.value),A=Math.max(A,a),S=Math.min(S,a);p.maxValue=A,p.minValue=S,this._setConfigure(),this.setState("dirty",!0)},a._setConfigure=function(){var e,t,a,o,r,i,l,s,c,d,h,u,p,g,f,m,v,b,x,k,y,w,A,S,N,L,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K=this,q=K.getFromEnv("chart"),Y=K.config,X=K.config.JSONData,Q=X.data,Z=Q&&Q.length,$=K.getFromEnv("chartConfig"),ee=K.getFromEnv("chart-attrib"),te=Y.showplotborder,ae=Y.plotColor=K.getFromEnv("color-manager").getPlotColor(K.index||K.positionIndex),oe=(0,n.pluckNumber)(ee.showtooltip,1),re=(0,n.parseUnsafeString)((0,n.pluck)(ee.tooltipsepchar,": ")),ie=(0,n.pluckNumber)(ee.useplotgradientcolor,1),ne=n.BLANKSTRING,le=Y.plotDashLen,se=Y.plotDashGap,ce=Y.plotBorderThickness,de=Y.isRoundEdges,he=Y.showHoverEffect,ue=Y.plotfillAngle,pe=Y.plotFillAlpha,ge=Y.plotFillRatio,fe=Y.plotBorderAlpha,me=Y.plotBorderColor,ve=K.getFromEnv("chartColorRange"),be=Y.mapByPercent=(0,n.pluckNumber)(ve.mapbypercent,0),xe=Y.mapByCategory=(0,n.pluckNumber)(ee.mapbycategory,0),ke=ve&&(0,n.pluckNumber)(ve.gradient),ye=K.getFromEnv("number-formatter"),Ce=q.isBar,we=q.config.is3D,Ae=Y.parentYAxis,Se=Y.maxValue,Ne=Y.minValue,Le=(0,n.getValidValue)(ee.tltype,n.BLANK),De=(0,n.getValidValue)(ee.trtype,n.BLANK),Ee=(0,n.getValidValue)(ee.bltype,n.BLANK),Te=(0,n.getValidValue)(ee.brtype,n.BLANK),Fe=n.BLANK,Pe=n.BLANK,_e=n.BLANK,Ve=n.BLANK,Ie=q.getFromEnv("colorManager");if(W=$.style.inCanfontFamily,J=$.style.inCanfontSize,j=parseInt(J,10||10),U=$.style.inCancolor,"normal","normal",D=Se-Ne,Y.eventAttached||(K.addExtEventListener("legendUpdate",(function(e,t){if("legend"===t.component)t.legendItem.hasState("hidden")?K.show(t.legendItem,e):K.hide(t.legendItem,e);else for(M=t.maxMinArray,O=M.length,L=0;L<O;L++)K.updatePlot(M[L].min,M[L].max)}),Ie),Y.eventAttached=!0),(!ke||xe)&&(Y.colorMap=[],ve.color))for(L=0;L<ve.color.length;L++)Y.colorMap[L]={config:ve.color[L],dataSet:K},Y.colorMap[L].config.visible=!0;for(L=0;L<Z;L++)r=Q&&Q[L],i=(s=(l=K.components.data[L])&&l.config).setValue,s.showValue=(0,n.pluckNumber)(r.showvalue,Y.showValues),s.setLink=(0,n.pluck)(r.link),s.toolTipValue=R=ye.dataLabels(i,Ae),s.setDisplayValue=N=(0,n.parseUnsafeString)(r.displayvalue),s.displayValue=(0,n.pluck)(N,R),G=(0,n.pluckNumber)(r.dashed),H=(0,n.pluckNumber)(r.dashlen,le),z=se=(0,n.pluckNumber)(r.dashgap,se),s.plotBorderDashStyle=1===G?(0,n.getDashStyle)(H,z):0===G?"none":Y.plotBorderDashStyle,s.percentValue=be?V=r.value&&Math.round((r.value-Ne)/D*1e4)/100:void 0,s.dataLabelStyle=K._configureDataLabelStyle(r),s.value=B=xe?r.colorrangelabel||r.categoryid:be?V:s.setValue,E=Ie.getColor(B),s.colorRangeLabel=r.colorrangelabel||E.label,l.legendItemIndex=E.seriesIndex,s.legendItemId=E.legendItemId,E&&!E.code&&(E.code="ffffff"),E&&E.outOfRange&&(E.code="ffffff"),s.plotFillAlpha=pe=(0,n.pluckNumber)(r.alpha,E&&E.oriAlpha,Y.plotFillAlpha),ae=(0,n.pluck)(r.color,E&&E.code),i<0&&!de&&(ue=Ce?180-ue:360-ue),s.colorArr=(0,n.getColumnColor)(ae+","+Y.plotgradientcolor,pe.toString(),ge,ue,de,me,fe.toString(),Ce?1:0,!!we),s.visible=!0,s.color=(0,n.convertColor)(ae,s.plotFillAlpha),s.rawPlotColor=ae,0!==he&&(p=(0,n.pluck)(r.hovercolor,X.hovercolor,ee.plotfillhovercolor,ee.columnhovercolor,ae),g=(0,n.pluck)(r.hoveralpha,X.hoveralpha,ee.plotfillhoveralpha,ee.columnhoveralpha,"25"),!(0,n.pluck)(r.hovergradientcolor,X.hovergradientcolor,ee.plothovergradientcolor,!ie&&n.BLANKSTRING)&&n.BLANKSTRING,f=(0,n.pluck)(r.hoverratio,X.hoverratio,ee.plothoverratio,ge),m=(0,n.pluckNumber)(360-r.hoverangle,360-X.hoverangle,360-ee.plothoverangle,ue),v=(0,n.pluck)(r.borderhovercolor,X.borderhovercolor,ee.plotborderhovercolor,me),b=(0,n.pluck)(r.borderhoveralpha,X.borderhoveralpha,ee.plotborderhoveralpha,fe,pe),x=(0,n.pluckNumber)(r.borderhoverthickness,X.borderhoverthickness,ee.plotborderhoverthickness,ce),k=(0,n.pluckNumber)(r.borderhoverdashed,X.borderhoverdashed,ee.plotborderhoverdashed),y=(0,n.pluckNumber)(r.borderhoverdashgap,X.borderhoverdashgap,ee.plotborderhoverdashgap,le),w=(0,n.pluckNumber)(r.borderhoverdashlen,X.borderhoverdashlen,ee.plotborderhoverdashlen,se),A=k?(0,n.getDashStyle)(w,y):Y.plotBorderDashStyle,1===he&&p===ae&&(p=(0,n.getLightColor)(p,70)),S=(0,n.getColumnColor)(p,g,f,m,de,v,b.toString(),Ce?1:0,!!we),s.setRolloutAttr={fill:(0,n.toRaphaelColor)(s.color),stroke:te&&(0,n.toRaphaelColor)(s.colorArr[1])||C,"stroke-width":ce,"stroke-dasharray":[]},s.setRolloverAttr={fill:(0,n.toRaphaelColor)(S[0]),stroke:te&&(0,n.toRaphaelColor)(S[1])||C,"stroke-width":x,"stroke-dasharray":A}),be&&(V=ye.percentValue(V)),s.setValue=i=ye.getCleanValue(r.value),s.toolTipValue=ye.dataLabels(i,Ae),e=s.toolTipValue,a=(0,n.getValidValue)((0,n.parseUnsafeString)((0,n.pluck)(r.tooltext,X.plottooltext,ee.plottooltext),!1)),s.tlLabel=T=(0,n.parseUnsafeString)((0,n.pluck)(r.tllabel,r.ltlabel)),s.trLabel=F=(0,n.parseUnsafeString)((0,n.pluck)(r.trlabel,r.rtlabel)),s.blLabel=P=(0,n.parseUnsafeString)((0,n.pluck)(r.bllabel,r.lblabel)),s.brLabel=_=(0,n.parseUnsafeString)((0,n.pluck)(r.brlabel,r.rblabel)),s.tlLabelStyle={fontFamily:(0,n.pluck)(E.tlLabelFont,ee.tlfont,W),fontSize:(0,n.pluckNumber)(E.tlLabelFontSize,ee.tlfontsize,j)+"px",color:(0,n.convertColor)((0,n.pluck)(E.tlLabelFontColor,ee.tlfontcolor,U),100),fontWeight:"normal",fontStyle:"normal"},(0,n.setLineHeight)(s.tlLabelStyle),s.trLabelStyle={fontFamily:(0,n.pluck)(E.trLabelFont,ee.trfont,W),fontSize:(0,n.pluckNumber)(E.trLabelFontSize,ee.trfontsize,j)+"px",color:(0,n.convertColor)((0,n.pluck)(E.trLabelFontColor,ee.trfontcolor,U),100),fontWeight:"normal",fontStyle:"normal"},s.brLabelStyle={fontFamily:(0,n.pluck)(E.brLabelFont,ee.brfont,W),fontSize:(0,n.pluckNumber)(E.brLabelFontSize,ee.brfontsize,j)+"px",color:(0,n.convertColor)((0,n.pluck)(E.brLabelFontColor,ee.brfontcolor,U),100),fontWeight:"normal",fontStyle:"normal"},s.blLabelStyle={fontFamily:(0,n.pluck)(E.blLabelFont,ee.blfont,W),fontSize:(0,n.pluckNumber)(E.blLabelFontSize,ee.blfontsize,j)+"px",color:(0,n.convertColor)((0,n.pluck)(E.blLabelFontColor,ee.blfontcolor,U),100),fontWeight:"normal",fontStyle:"normal"},N=(0,n.getValidValue)((0,n.parseUnsafeString)(r.displayvalue)),I=xe?N:(0,n.pluck)(r.displayvalue,e),s.displayValue=(0,n.pluck)(N,V,s.toolTipValue),Le!==n.BLANK&&(Fe="<b>"+Le+re+"</b>"),De!==n.BLANK&&(Pe="<b>"+De+re+"</b>"),Ee!==n.BLANK&&(_e="<b>"+Ee+re+"</b>"),Te!==n.BLANK&&(Ve="<b>"+Te+re+"</b>"),u=(0,n.getFirstValue)(Q[L].columnid),h=(0,n.getFirstValue)(Q[L].rowid),c=K.getFromEnv("xAxis").getCategoryFromId(u.toLowerCase()),d=K.getFromEnv("yAxis").getCategoryFromId(h.toLowerCase()),oe&&(null===e?ne=!1:void 0!==a?(o=[1,2,5,6,7,14,93,94,95,96,97,98,112,113,114,115,116,117],t={formattedValue:e,value:r.value,yaxisName:(0,n.parseUnsafeString)(ee.yaxisname),xaxisName:(0,n.parseUnsafeString)(ee.xaxisname),displayValue:N,percentValue:be?V:n.BLANK,tlLabel:T,trLabel:F,blLabel:P,brLabel:_,rowLabel:d.tickObj&&d.tickObj.label,columnLabel:c.tickObj&&c.tickObj.label,percentDataValue:be?V:n.BLANK,trtype:De,tltype:Le,brType:Te,blType:Ee,colorRangeLabel:s.colorRangeLabel},ne=(0,n.parseTooltext)(a,o,t,r,ee,t)):ne=(be?"<b>Value"+re+"</b>"+e+"<br /><b>Percentage"+re+"</b>"+V:I)+(T!==n.BLANK?"<br />"+(Fe+T):n.BLANK)+(F!==n.BLANK?"<br />"+Pe+F:n.BLANK)+(P!==n.BLANK?"<br />"+_e+P:n.BLANK)+(_!==n.BLANK?"<br />"+Ve+_:n.BLANK)),s.toolText=ne,s.setTooltext=ne},a.hide=function(e){var t,a,o,r,i,n=this.components.data,l=this.getFromEnv("chart").getChildren("colorRange")[0];for(r=e.config.datasetObj.code,t=0,a=n.length;t<a;t++)Object.keys(n[t]).length&&(i=l.getColorObj(n[t].config.value).code,o=n[t].config,r===i&&(n[t].graphics.element&&this.getFromEnv("animationManager").setAnimation({el:n[t].graphics.element,attr:{"fill-opacity":0,"stroke-width":0},component:this}),n[t].graphics.hotElement&&n[t].graphics.hotElement.hide(),o.visible=!1,n[t].visible=!1));e.setLegendState("hidden")},a.show=function(e){var t,a,o,r,i,n,l=this.components.data,s=this.getFromEnv("animationManager"),c=this.getFromEnv("chart").getChildren("colorRange")[0];for(n=e.config.datasetObj.code,r=0,i=l.length;r<i;r++)Object.keys(l[r]).length&&(a=(t=l[r].config).plotFillAlpha/100,n===(!(o=c.getColorObj(l[r].config.value)).outOfRange&&o.code)&&(l[r].graphics.element&&s.setAnimation({el:l[r].graphics.element,attr:{visibility:"visible"},component:this}),l[r].graphics.element&&s.setAnimation({el:l[r].graphics.element,component:this,attr:{"fill-opacity":a,"stroke-width":this.config.plotBorderThickness}}),l[r].graphics.hotElement&&l[r].graphics.hotElement.show(),l[r].graphics.valEle&&l[r].graphics.valEle.show(),l[r].graphics.tlLabel&&l[r].graphics.tlLabel.show(),l[r].graphics.trLabel&&l[r].graphics.trLabel.show(),l[r].graphics.blLabel&&l[r].graphics.blLabel.show(),l[r].graphics.brLabel&&l[r].graphics.brLabel.show(),t.visible=!0,l[r].visible=!0));e&&e.removeLegendState("hidden")},a.updatePlot=function(e,t){var a,o,r,i,n,l=this.getFromEnv("animationManager"),s=this.components.data;for(r=0,i=s.length;r<i;r++)Object.keys(s[r]).length&&(o=(a=s[r].config).plotFillAlpha/100,(n=s[r].config.value)<e||n>t?a.visible&&(s[r].graphics.element&&l.setAnimation({el:s[r].graphics.element,attr:{"fill-opacity":0,"stroke-width":0},component:this}),s[r].graphics.hotElement&&s[r].graphics.hotElement.hide(),a.visible=!1,s[r].visible=!1):a.visible||(s[r].graphics.element&&l.setAnimation({el:s[r].graphics.element,attr:{"fill-opacity":o,"stroke-width":this.config.plotBorderThickness},callback:function(){this.show()},component:this}),s[r].graphics.hotElement&&s[r].graphics.hotElement.show(),s[r].graphics.valEle&&s[r].graphics.valEle.show(),s[r].graphics.tlLabel&&s[r].graphics.tlLabel.show(),s[r].graphics.trLabel&&s[r].graphics.trLabel.show(),s[r].graphics.blLabel&&s[r].graphics.blLabel.show(),s[r].graphics.brLabel&&s[r].graphics.brLabel.show(),a.visible=!0,s[r].visible=!0))},a._checkPointObj=function(e,t,a,o){var r,i,n,l,s,c=this.components.plotGrid,d=this.getFromEnv("chartConfig"),h=d.viewPortConfig,u=d.plotborderthickness;if(r=c[t]&&c[t][e],i=(i=(u=d.showplotborder?u:0)/2)%2==0?i+1:Math.round(i),r&&r.config&&r.config.visible&&(n=a-(r._xPos-h.x*h.scaleX)+i,l=o-r._yPos+i,s=n>=0&&n<=r._width+u&&l>=0&&l<=r._height+u))return{pointIndex:r._index,hovered:s,pointObj:r}},a._getHoveredPlot=function(e,t){var a,o,r,i,n=e,l=t,s=this.getFromEnv("xAxis"),c=this.getFromEnv("yAxis"),d=this.getFromEnv("chartConfig").canvasHeight/this.getFromEnv("totalRows");return n+=s.getTranslation(),l+=c.getTranslation(),o=c.getValue(l+d/2),i=Math.floor(o),a=s.getValue(n),(r=Math.round(a))-a>0?o-i>.5?this._checkPointObj(r,i,n,l)||this._checkPointObj(r-1,i,n,l):this._checkPointObj(r,i-1,n,l)||this._checkPointObj(r,i,n,l):o-i>.5?this._checkPointObj(r+1,i,n,l)||this._checkPointObj(r,i,n,l):this._checkPointObj(r,i-1,n,l)||this._checkPointObj(r+1,i,n,l)||this._checkPointObj(r,i,n,l)},a.parsePlotAttributes=function(e,t){var a,o,r,i,l,s,c,d,h,g,f,m,v,b,x,k,y=this.config,A=this.config.JSONData.data,S=t,N=this.getFromEnv("chart"),L=this.getFromEnv("xAxis"),D=this.getFromEnv("yAxis"),E=this.getFromEnv("chartConfig"),T=y.plotBorderThickness,F=y.plotRadius,P=N.getFromEnv("legend")&&N.getFromEnv("legend").config.isActive,_=this.components.plotGrid;D.yBasePos=D.getPixel(D.getAxisBase()),e&&Object.keys(e).length&&(f=E.canvasWidth/this.getFromEnv("totalColumns"),l=E.canvasHeight/this.getFromEnv("totalRows"),k=e.trackerConfig={},d=(h=e&&e.config).setValue,b=(0,n.getFirstValue)(A[S].columnid),x=(0,n.getFirstValue)(A[S].rowid),m=L.getCategoryFromId(b.toLowerCase()),v=D.getCategoryFromId(x.toLowerCase()),0!==m.index&&!m.index||0!==v.index&&!v.index||(y.mapByCategory||null!==d)&&(c=h.setLink,g=h.colorArr,e.graphics||(this.components.data[S].graphics={}),o=L.getPixel(m.index)-f/2,r=D.getPixel(v.index)-l/2,i=f,s=h.toolText,k.eventArgs={index:S,link:c,value:h.percentValue||d,displayValue:h.displayValue,columnId:m.tickObj.id,rowId:v.tickObj.id,tlLabel:h.tlLabel,trLabel:h.trLabel,blLabel:h.blLabel,brLabel:h.brLabel,colorRangeLabel:h.colorRangeLabel,color:h.rawPlotColor,alpha:h.plotFillAlpha,showValue:h.showValue,toolText:s||"",id:n.BLANKSTRING,datasetIndex:P?e.datasetIndex:void 0,datasetName:P?e.datasetName:void 0,visible:this.getState("visible")},a={x:o,y:r,width:i,height:l||1,r:F,fill:h.color,stroke:(0,n.toRaphaelColor)(g[1]),"stroke-width":T,"stroke-dasharray":void 0,"fill-opacity":h.plotFillAlpha/100,"stroke-linejoin":u,visibility:h.visible?"visible":p,cursor:c?"pointer":n.BLANKSTRING},e._xPos=o,e._yPos=r,e._height=l,e._width=i,e._index=S,_[v.index][m.index]=e,e.graphics.element?((a={x:o,y:r,width:i,height:l||1}).fill=h.color,a.stroke=(0,n.toRaphaelColor)(g[1]),a["fill-opacity"]=h.visible?h.plotFillAlpha/100:0,a["stroke-width"]=h.visible?T:0,a["stroke-dasharray"]=void 0,a["stroke-linejoin"]=u,a.visibility=h.visible?"visible":p,a.cursor=c?"pointer":n.BLANKSTRING):(a["fill-opacity"]=h.plotFillAlpha/100,a["stroke-width"]=T),(c||E.showtooltip)&&(l<w&&(r-=(w-l)/2,l=w),k.attr={x:o,y:r,width:i,height:l,r:F,cursor:c?"pointer":n.BLANKSTRING,stroke:C,"stroke-width":T,fill:C,visibility:h.visible?"visible":p}),h.props={element:{attr:a}}))},a.allocatePosition=function(){var e,t,a,o=this.config.JSONData.data,r=this.components.data;for(e=o&&o.length,t=0;t<e;t++)a=r[t],this.parsePlotAttributes(a,t)},a.drawPlots=function(){var e,t,a,o,r,i,l,s,d,h,u,p,f,m=this.config,v=this.config.JSONData.data,b=this.getFromEnv("animationManager"),x=this.components.data,k=[],y=(this.components.removeDataArr||[]).length;for(e=v&&v.length,t=0;t<e;t++)f=(a=x[t]).trackerConfig,i=a&&a.config,a.graphics&&(l=a.graphics.element?this.getState("visible")?"updating":"hiding":"appearing",r=i.setValue,h=(0,n.getFirstValue)(v[t].columnid),u=(0,n.getFirstValue)(v[t].rowid),s=this.getFromEnv("xAxis").getCategoryFromId(h.toLowerCase()),d=this.getFromEnv("yAxis").getCategoryFromId(u.toLowerCase()),0!==s.index&&!s.index||0!==d.index&&!d.index?a.graphics.element=a.graphics.element&&b.setAnimation({el:a.graphics.element,component:this}):(s.tickObj&&d.tickObj&&i.value!==n.BLANKSTRING||!a.graphics||(a.graphics.element=a.graphics.element&&b.setAnimation({el:a.graphics.element,component:this})),m.mapByCategory||null!==r||!a.graphics?(p=s.index.toString()+d.index.toString(),k.push(p),a.graphics.element?(o=a.graphics.element,i.elemCreated=!1,b.setAnimation({el:o,state:l,attr:i.props.element.attr,component:this})):(o=a.graphics.element=b.setAnimation({el:"rect",component:this,attr:i.props.element.attr,label:"rect",container:this.getContainer("plotGroup")}),i.elemCreated=!0),o.shadow({opacity:m.showShadow},this.getContainer("shadowGroup")).data("BBox",void 0),this.getFromEnv("chartConfig").enablemousetracking&&o.data("eventArgs",f.eventArgs).data(g,m.showHoverEffect).data("setRolloverAttr",i.setRolloverAttr||{}).data("setRolloutAttr",i.setRolloutAttr||{})):(a.graphics.element&&a.graphics.element.hide(),a.graphics.hotElement&&a.graphics.hotElement.hide())));this.drawn?this.drawLabel():this.addJob("labelJob",this.drawLabel.bind(this),c.priorityList.label),this.drawn=!0,y&&this.removeDataElems()},a.drawLabel=function(){var e,t,a,o,r,i,l,s,c,d,h,u,g,x,C,w,A,S,N,L,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W=this.getFromEnv("chartConfig"),U=this.getFromEnv("smartLabel"),j=this.getFromEnv("animationManager"),J=W.dataLabelStyle,K=this.config,q=(this.config.JSONData.data||[]).length,Y=this.components.data,X=this.getContainer("labelGroup"),Q=this.graphics.tlLabelContainer,Z=this.graphics.blLabelContainer,$=this.graphics.trLabelContainer,ee=this.graphics.brLabelContainer;for(j.setAnimation({el:X,attr:{opacity:1},component:this,label:"text"}),Q||(Q=this.graphics.tlLabelContainer=y({name:"tlLabel"},X,this)),Z||(Z=this.graphics.blLabelContainer=y({name:"blLabel"},X,this)),$||($=this.graphics.trLabelContainer=y({name:"trLabel"},X,this)),ee||(ee=this.graphics.brLabelContainer=y({name:"brLabel"},X,this)),U.useEllipsesOnOverflow(W.useEllipsesWhenOverflow),U.setStyle(J),t=0;t<q;t++)void 0!==(e=Y[t])&&e.graphics&&(O=(M=e&&e.config).setValue,K.mapByCategory||null!==O?(a=M.displayValue,x=e.graphics.element,C=e._width,w=e._height,A=e._xPos,S=e._yPos,U.setStyle(J),a=(N=U.getSmartText(a,C,w,!1)).text,c=M.dataLabelStyle,k(a)&&a!==n.BLANK&&M.showValue?(o=S+.5*w,r=A+.5*C,s={text:a,title:N.tooltext||n.BLANKSTRING,visibility:M.visible?"visible":p,fill:c.color,direction:M.textDirection,x:r,y:o,cursor:M.setLink?"pointer":n.BLANKSTRING,"text-bound":[c.backgroundColor,c.borderColor,J.borderThickness,J.borderPadding,J.borderRadius,J.borderDash]},x?(e.graphics.valEle=j.setAnimation({el:e.graphics.valEle||"text",container:X,component:this,label:"text",attr:s}),e.graphics.valEle.outlineText(K.showTextOutLine,s.fill)):e.graphics.valEle&&(e.graphics.valEle=j.setAnimation({el:e.graphics.valEle,component:this})),L=M.tlLabel,D=M.trLabel,E=M.blLabel,T=M.brLabel,d=M.tlLabelStyle,h=M.trLabelStyle,u=M.blLabelStyle,g=M.brLabelStyle,F=k(L)&&L!==n.BLANK,P=k(D)&&D!==n.BLANK,_=k(E)&&E!==n.BLANK,V=k(T)&&T!==n.BLANK,I=C*(F&&P?.5:.9),B=.5*(w-(N&&N.height||0)),i=S+4,F?(U.setStyle(d),l=A,s={text:a=(N=U.getSmartText(L,I,B,!1)).text,title:N.tooltext||n.BLANKSTRING,visibility:M.visible?"visible":p,fill:d.color,"font-family":d.fontFamily,"font-weight":d.fontWeight,"line-height":d.lineHeight,"font-size":d.fontSize,"text-anchor":f,"vertical-align":m,direction:M.textDirection,x:l+4,y:i,"text-bound":[d.backgroundColor,d.borderColor,d.borderThickness,d.borderPadding,d.borderRadius,d.borderDash]},R=Object.assign(s,d),e.graphics.tlLabel=j.setAnimation({el:e.graphics.tlLabel||"text",component:this,attr:R,container:Q}),e.graphics.tlLabel.outlineText(K.showTextOutLine,R.fill)):e.graphics.tlLabel&&(e.graphics.tlLabel=j.setAnimation({el:e.graphics.tlLabel,component:this})),P?(U.setStyle(h),l=A+C,s={text:a=(N=U.getSmartText(D,I,B,!1)).text,title:N.tooltext||n.BLANKSTRING,visibility:M.visible?"visible":p,fill:h.color,"font-family":h.fontFamily,"font-weight":h.fontWeight,"line-height":h.lineHeight,"font-size":h.fontSize,"text-anchor":v,"vertical-align":m,direction:M.textDirection,x:l-4,y:i,"text-bound":[h.backgroundColor,h.borderColor,h.borderThickness,h.borderPadding,h.borderRadius,h.borderDash]},G=Object.assign(s,h),e.graphics.trLabel=j.setAnimation({el:e.graphics.trLabel||"text",attr:G,container:$,component:this}),e.graphics.trLabel.outlineText(K.showTextOutLine,G.fill)):e.graphics.trLabel&&(e.graphics.trLabel=j.setAnimation({el:e.graphics.trLabel,component:this})),i=S+w-4,_?(U.setStyle(u),l=A,s={text:a=(N=U.getSmartText(E,I,B,!1)).text,title:N.tooltext||n.BLANKSTRING,visibility:M.visible?"visible":p,fill:u.color,"font-family":u.fontFamily,"font-weight":u.fontWeight,"line-height":u.lineHeight,"font-size":u.fontSize,"text-anchor":f,"vertical-align":b,direction:M.textDirection,x:l+4,y:i,"text-bound":[u.backgroundColor,u.borderColor,u.borderThickness,u.borderPadding,u.borderRadius,u.borderDash]},H=Object.assign(s,u),e.graphics.blLabel=j.setAnimation({el:e.graphics.blLabel||"text",component:this,container:Z,attr:H}),e.graphics.blLabel.outlineText(K.showTextOutLine,H.fill)):e.graphics.blLabel&&(e.graphics.blLabel=j.setAnimation({el:e.graphics.blLabel,component:this})),V?(U.setStyle(u),l=A+C-4,s={text:a=(N=U.getSmartText(T,I,B,!1)).text,title:N.tooltext||n.BLANKSTRING,visibility:M.visible?"visible":p,fill:g.color,"font-family":g.fontFamily,"font-weight":g.fontWeight,"line-height":g.lineHeight,"font-size":g.fontSize,"text-anchor":v,"vertical-align":b,direction:M.textDirection,x:l,y:i,"text-bound":[g.backgroundColor,g.borderColor,g.borderThickness,g.borderPadding,g.borderRadius,g.borderDash]},z=Object.assign(s,g),e.graphics.brLabel=j.setAnimation({el:e.graphics.brLabel||"text",attr:z,container:ee,component:this}),e.graphics.brLabel.outlineText(K.showTextOutLine,z.fill)):e.graphics.brLabel&&(e.graphics.brLabel=j.setAnimation({el:e.graphics.brLabel,component:this}))):this.removeLabels(e)):this.removeLabels(e));this.labelDrawn=!0},a.removeLabels=function(e){var t=this.getFromEnv("animationManager");e.graphics.valEle&&(e.graphics.valEle=t.setAnimation({el:e.graphics.valEle,component:this})),e.graphics.tlLabel&&(e.graphics.tlLabel=t.setAnimation({el:e.graphics.tlLabel,component:this})),e.graphics.trLabel&&(e.graphics.trLabel=t.setAnimation({el:e.graphics.trLabel,component:this})),e.graphics.blLabel&&(e.graphics.blLabel=t.setAnimation({el:e.graphics.blLabel,component:this})),e.graphics.brLabel&&(e.graphics.brLabel=t.setAnimation({el:e.graphics.brLabel,component:this}))},a.removeDataElems=function(){var e,t,a,o,r=this.components,i=r.removeDataArr,n=r.pool||(r.pool={element:[],hotElement:[],label:[]}),l=i.length;for(o=0;o<l;o++)if(e=i[0],i.splice(0,1),e&&e.graphics){for(t in a=e.graphics)a[t]&&(a[t]=this.getFromEnv("animationManager").setAnimation({el:a[t],component:this}));e.graphics.element&&(n.element=n.element.concat(e.graphics.element)),e.graphics.hotElement&&(n.hotElement=n.hotElement.concat(e.graphics.hotElement)),e.graphics.label&&(n.label=n.label.concat(e.graphics.label))}r.pool=n},a.getAxisValuePadding=function(){return this.config.defaultPadding},a.getDataLimits=function(){var e,t,a=this.components.data,o=this.config,r=a.length,i=-Infinity,n=+Infinity;for(e=0;e<r;e++)a[e]&&Object.keys(a[e]).length&&null!=(t=a[e].config.setValue)&&(i=A(i,t),n=S(n,t));return o.maxValue=i,o.minValue=n,{max:o.maxValue,min:o.minValue}},a.trimData=function(e){if(this.config.JSONData){var t,a,o=this.config,r=o&&o.context,i=r&&r.prevCatlen,n=this.getFromEnv("xAxis").getTicksLen(),l=i-n,s=o.JSONData,c=s.data&&s.data.length,d=e.data&&e.data.length||0,h=c-d;l>h?(t=l,a=n):(t=h,a=d),t>0&&this.removeData(a,t,!1)}},a.draw=function(){var e=this.getFromEnv("xAxis"),t=this.getFromEnv("groupMaxWidth");t||(t=N(e.getPixel(1)-e.getPixel(0)),this.addToEnv("groupMaxWidth",t)),!this.config.drawn&&this.createContainer(),e.getState("scrolling")||this.createCoordinates(),this.drawPlots()},a.createContainer=function(){var e,t,a=this.getLinkedParent(),o=this.groupName||this.dsGroup||this.getType();!a.getChildContainer(o+"VcanvasGroup")&&(o="default"),e=a.getChildContainer(o+"VcanvasGroup"),t=a.getChildContainer(o+"ShadowVcanvasGroup"),!this.getContainer("shadowGroup")&&this.addContainer("shadowGroup",y({name:"shadow-group"},t,this)),!this.getContainer("errorShadowGroup")&&this.addContainer("errorShadowGroup",y({name:"error-shadow-group"},t,this)),!this.getContainer("commonElemsGroup")&&this.addContainer("commonElemsGroup",y({name:"common-elems-group"},e,this)),!this.getContainer("plotGroup")&&this.addContainer("plotGroup",y({name:"plot-group"},e,this)),!this.getContainer("errorPlotGroup")&&this.addContainer("errorPlotGroup",y({name:"error-plot-group"},e,this)),this.getFromEnv("chart").hasAnchor&&this.getContainer("errorPlotGroup").insertBefore(this.getContainer("plotGroup")),!this.getContainer("labelGroup")&&this.addContainer("labelGroup",y({name:"label-group","class":"fusioncharts-datalabels"},a.getChildContainer("vcanvasLabelGroup"),this))},a.createCoordinates=function(){var e,t,a,o,r,i,n,l=this.getFromEnv("chart"),s=l.isBar,c=this.getFromEnv("yAxis"),d=this.getFromEnv("xAxis"),h=c.getPixel(c.getAxisBase()),u=l.config.xDepth||0,p=l.config.yDepth||0,g=this.components.data.length,f=this.getLinkedParent(),m=f.getstackConf&&f.getstackConf(),v=this.components.data;for(!s&&(u=-u),s&&(p=-p),o=0;o<g;o++)t=(e=v[o])&&e.config,void 0!==e&&(a=t._b,r=d.getPixel(m&&m[o].x||t._x)+u,i=c.getPixel(t._y)+p,n=(a?c.getPixel(a):h)+p,d.config.isVertical?(t._Px=i,t._Py=r,t._Pby=r,t._Pbx=n):(t._Px=r,t._Py=i,t._Pby=n,t._Pbx=r),this.getLineShift&&(t._Py+=this.getLineShift("y")))},a._decideTooltipType=function(e,t){var a=this.getFromEnv("chartConfig").drawTrendRegion,o=this.getFromEnv("toolTipController"),r=this.components.data[e],i=r&&(r.config.finalTooltext||r.config.toolText),n=r&&(r.graphics.element||this.graphics.sharedAnchor.element),l=this.config.currentToolTip,s=t.originalEvent;a&&n?this.config.currentToolTip=this.getLinkedParent()._drawTooltip(e,this.config.index,s,l):i&&!a&&(l?o.draw(s,i,l):l=this.config.currentToolTip=o.draw(s,i))},a._firePlotEvent=function(e,t,a){var o,r=this.getFromEnv("chart"),i=this.components.data[t],n=i.graphics.element,l=i.graphics.label;if(n)switch(o=i.config.setLink,e){case"fc-mouseover":this._decideTooltipType(t,a),function(e,t,a,o,r){var i=t.graphics,n=e.getFromEnv("animationManager"),l=i&&i.element,s=l&&l.getData();!0!==s.draged&&(n.setAnimationState("mouseOver"),l&&0!==s.showHoverEffect&&n.setAnimation({el:l,attr:l.getData().setRolloverAttr,component:r}),!o&&l&&e.plotEventHandler(l,a,"DataPlotRollOver"))}(r,i,a,void 0,this),o&&(n.css({cursor:"pointer"}),l&&l.css({cursor:"pointer"}));break;case"fc-mouseout":this.getFromEnv("toolTipController").hide(this.config.currentToolTip),function(e,t,a,o,r){var i=t.graphics,n=e.getFromEnv("animationManager"),l=i&&i.element,s=l&&l.getData();!0!==s.draged&&(n.setAnimationState("mouseOut"),l&&0!==s.showHoverEffect&&n.setAnimation({el:l,attr:l.getData().setRolloutAttr,component:r}),!o&&l&&e.plotEventHandler(l,a,"DataPlotRollOut"))}(r,i,a,void 0,this),o&&(n.css({cursor:x}),l&&l.css({cursor:x}));break;case"fc-click":r.plotEventHandler(n,a);break;case"fc-mousemove":this._decideTooltipType(t,a)}},a.removeData=function(e,t,a){var o,r,i,n=e,l=t,s=this.components,c=s.data,d=s.removeDataArr||(s.removeDataArr=[]),h=this.config,u=this.maxminFlag;for(void 0===l&&(l=1),(n=n||0)+l!==c.length&&this.getFromEnv("chart").isRealTime?0!==n&&void 0!==n||(this.endPosition=!1):this.endPosition=!0,s.removeDataArr=d=d.concat(c.splice(n,l)),o=(i=d.length)-1;o>=0;o--)if(d[o]){if((r=d[o].config).setValue!==h.maxValue&&r.setValue!==h.minValue||(u=this.maxminFlag=!0),r._x-=l,u)break}else d.splice(o,1);this.removeDataLen=i,this.resetCatPos&&this.resetCatPos(),u&&this.getDataLimits&&this.getDataLimits(),a&&this.asyncDraw()},t}(i.ComponentInterface);L.prototype._configureDataLabelStyle=n.configureDataLabelStyle;var D=L;t["default"]=D},1049:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.heatMap":function(){return{"rect.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"plot"}]},"text.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},"*":null}}}},1050:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=function(e){function t(){var t;return(t=e.call(this)||this).setState("visible",!0),t.getDataLimits=null,t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"group"},a.getName=function(){return"heatMapGroup"},a.createContainer=function(){var e,t,a=this.getLinkedParent(),o=this.getFromEnv("animationManager"),r=a.getChildContainer();for(e in r)t=r[e],!this.getChildContainer(e)&&this.addChildContainer(e,o.setAnimation({el:"group",attr:{name:"manager-"+e},container:t,component:this,label:"group"}))},a.getLimits=function(e){var t,a=+Infinity,o=-Infinity,r=0,i=function(e){o=Math.max(o,e.max),a=Math.min(a,e.min)};return this._mapChildren((function(a){a.getState("removed")||!1===a.getState("visible")?e&&(t=a.getDataLimits(e),i(t)):(r++,t=a.getDataLimits(e),i(t))})),r?this.setState("visible",!0):this.setState("visible",!1),this.config.range||(this.config.range={},this.config.range.min=this.config.dataMin,this.config.range.max=this.config.dataMax),{max:o,min:a}},a.draw=function(){var e=this.getLimits(!0);this.addToEnv("datasetMinValue",e.min),this.addToEnv("datasetMaxValue",e.max),this.createContainer()},a.getAxisValuePadding=function(){var e={},t=-Infinity,a=-Infinity,o=-Infinity,r=-Infinity;return this._mapChildren((function(i){i.getState("removed")||(e=i.getAxisValuePadding&&i.getAxisValuePadding()||{},t=Math.max(t,e.left||-Infinity),a=Math.max(a,e.right||-Infinity),o=Math.max(o,e.top||-Infinity),r=Math.max(r,e.bottom||-Infinity))})),t===-Infinity&&(t=0),a===-Infinity&&(a=0),o===-Infinity&&(o=0),r===-Infinity&&(r=0),this.config.padding||(this.config.padding={},this.config.padding.left=t,this.config.padding.right=a,this.config.padding.top=o,this.config.padding.bottom=r),{left:t,right:a,top:o,bottom:r}},t}(a(240).ComponentInterface);t["default"]=i},1051:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o=e.getChildren("canvas")[0],n=o.getChildren("axisRefVisualCartesian")[0],l={zoomable:!0,pannable:!0},s=e._feedAxesRawData(),c=function(){return n.asyncDraw()};(0,r.componentFactory)(e,i["default"],"yAxis",1,s.yAxisConf),(0,r.componentFactory)(e,i["default"],"xAxis",1,s.xAxisConf),t=e.getChildren("yAxis")[0],a=e.getChildren("xAxis")[0],t.setLinkedItem("canvas",o),a.setLinkedItem("canvas",o),n.setLinkedItem(t.getId(),t),n.setLinkedItem(a.getId(),a),n.addExtEventListener("visiblerangeset",c,a),n.addExtEventListener("visiblerangeset",c,t),o.attachAxis(a,!1,e.zoomX?l:{}),o.attachAxis(t,!0,e.zoomY?l:{}),e._setCategories()};var r=a(224),i=o(a(528))},1058:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1059))["default"];t["default"]=r},1059:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(672)),n=o(a(1060)),l=o(a(1063)),s=o(a(1067)),c=a(224),d=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("canvas",s["default"]),t.registerFactory("axis",l["default"],["canvas"]),t}(0,r["default"])(t,e);var a=t.prototype;return a.configureAttributes=function(t){this.config.drawfullareaborder=1,this.config.radarRadius=(0,c.pluckNumber)(t.chart.radarradius),e.prototype.configureAttributes.call(this,t),this.config.alignLegendWithCanvas=0},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.axisType="polar",t.axisValuePadding=10,t.gridLineWidth=1,t.showRadarBorder=1,t.showvalues=0,t.radarBorderThickness=2,t.skipCanvasDrawing=!0,t.useplotgradientcolor=0,t.plotfillalpha=50},a.setAxisDimention=function(){this.getChildren("yAxis")},a._feedAxesRawData=function(){var e,t,a=this.getFromEnv("dataSource");return e=this.getSpecificxAxisConf(),t=this.getSpecificyAxisConf(),e.vtrendlines=a.vtrendlines,t.trendlines=a.trendlines,{xAxisConf:[e],yAxisConf:[t]}},a.getSpecificxAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.getBasexAxisConf();return t.isReverse=this.config.reverseXAxis,t.axisLineColor=(0,c.pluck)(e.xaxislinecolor,e.axislinecolor,"#000000"),t.showAlternateGridColor=(0,c.pluckNumber)(e.showalternatevgridcolor,1),t.numDivLines=e.numvdivlines,t.axisName=e.xaxisname,t.setAdaptiveMin=e.setadaptivexmin,t.showLimits=e.showvlimits,t.showDivLineValues=(0,c.pluckNumber)(e.showvdivlinevalues,e.showvdivlinevalues),t.zeroPlaneThickness=e.vzeroplanethickness,t.zeroPlaneAlpha=e.vzeroplanealpha,t.showZeroPlaneValue=e.showvzeroplanevalue,t.showAxisLine=(0,c.pluckNumber)(e.showxaxisline,e.showaxislines,e.drawAxisLines,0),t.showRadarBorder=e.showradarborder,t.radarBorderColor=e.radarbordercolor,t.radarBorderThickness=e.radarborderthickness,t.radarBorderAlpha=e.radarborderalpha,t.radarFillColor=e.radarfillcolor,t.radarFillAlpha=e.radarfillalpha,t.radarSpikeColor=e.radarspikecolor,t.radarSpikeThickness=e.radarspikethickness,t.radarSpikeAlpha=e.radarspikealpha,t.radarInLineAlpha=e.radarinlinealpha,t.showTooltip=(0,c.pluckNumber)(e.showtooltip,1),t},a.getSpecificyAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config,a=t.is3D?c.chartPaletteStr.chart3D:c.chartPaletteStr.chart2D,o=this.getFromEnv("color-manager"),r=(0,c.pluckFontSizeMaintainUnit)(e.outcnvbasefontsize,e.basefontsize,10);return{isVertical:!0,isReverse:!t.isInverse,isOpposit:!1,outCanfontFamily:(0,c.pluck)(e.outcnvbasefont,e.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(r),outCanfontSizeWithUnit:r,outCancolor:(0,c.pluck)(e.outcnvbasefontcolor,e.basefontcolor,o.getColor(a.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:e.yaxisnamepadding,axisValuePadding:e.yaxisvaluespadding,axisNameFont:e.yaxisnamefont,axisNameFontSize:this.computeFontSize(e.yaxisnamefontsize),axisNameFontSizeWithUnit:e.yaxisnamefontsize,axisNameFontColor:e.yaxisnamefontcolor,axisNameFontBold:e.yaxisnamefontbold,axisNameFontItalic:e.yaxisnamefontitalic,axisNameBgColor:e.yaxisnamebgcolor,axisNameBorderColor:e.yaxisnamebordercolor,axisNameAlpha:e.yaxisnamealpha,axisNameFontAlpha:e.yaxisnamefontalpha,axisNameBgAlpha:e.yaxisnamebgalpha,axisNameBorderAlpha:e.yaxisnameborderalpha,axisNameBorderPadding:e.yaxisnameborderpadding,axisNameBorderRadius:e.yaxisnameborderradius,axisNameBorderThickness:e.yaxisnameborderthickness,axisNameBorderDashed:e.yaxisnameborderdashed,axisNameBorderDashLen:e.yaxisnameborderdashlen,axisNameBorderDashGap:e.yaxisnameborderdashgap,axisNameWidth:e.yaxisnamewidth,useEllipsesWhenOverflow:e.useellipseswhenoverflow,rotateAxisName:(0,c.pluckNumber)(e.rotateyaxisname,1),divLineColor:(0,c.pluck)(e.divlinecolor,o.getColor(a.divLineColor)),divLineAlpha:(0,c.pluck)(e.divlinealpha,o.getColor("divLineAlpha")),divLineThickness:(0,c.pluckNumber)(e.divlinethickness,1),divLineIsDashed:Boolean((0,c.pluckNumber)(e.divlinedashed,e.divlineisdashed,0)),divLineDashLen:(0,c.pluckNumber)(e.divlinedashlen,4),divLineDashGap:(0,c.pluckNumber)(e.divlinedashgap,2),showAlternateGridColor:(0,c.pluckNumber)(e.showalternatehgridcolor,1),alternateGridColor:(0,c.pluck)(e.alternatehgridcolor,o.getColor("altHGridColor")),alternateGridAlpha:(0,c.pluck)(e.alternatehgridalpha,o.getColor("altHGridAlpha")),numDivLines:e.numdivlines,axisMinValue:e.yaxisminvalue,axisMaxValue:e.yaxismaxvalue,setAdaptiveMin:e.setadaptiveymin,adjustDiv:e.adjustvdiv,labelStep:e.yaxisvaluesstep,showAxisValues:(0,c.pluckNumber)(e.showyaxisvalues,e.showyaxisvalue),showLimits:(0,c.pluckNumber)(e.showyaxislimits,e.showlimits,this.showLimits),showDivLineValues:(0,c.pluckNumber)(e.showdivlinevalues,e.showdivlinevalue),zeroPlaneColor:e.zeroplanecolor,zeroPlaneThickness:(0,c.pluckNumber)(e.zeroplanethickness,e.divlinethickness,2),zeroPlaneAlpha:e.zeroplanealpha,showZeroPlaneValue:e.showzeroplanevalue,trendlineColor:e.trendlinecolor,trendlineToolText:e.trendlinetooltext,trendlineThickness:e.trendlinethickness,trendlineAlpha:e.trendlinealpha,showTrendlinesOnTop:e.showtrendlinesontop,axisLineThickness:(0,c.pluckNumber)(e.yaxislinethickness,e.axislinethickness,1),axisLineAlpha:(0,c.pluckNumber)(e.yaxislinealpha,e.axislinealpha,100),axisLineColor:(0,c.pluck)(e.yaxislinecolor,e.axislinecolor,"#000000"),showTooltip:(0,c.pluckNumber)(e.showtooltip,1)}},a._spaceManager=function(){var e,t,a,o,r,i,n,l,s=this.config,d=this.getFromEnv("chart-attrib"),h=s.radarBorderThickness,u=s.legendPosition?s.legendposition.split("-"):[],p=this.getChildren("xAxis")&&this.getChildren("xAxis")[0],g=(this.getChildren("yAxis")&&this.getChildren("yAxis")||[])[0],f=this.getChildren("legend")&&this.getChildren("legend")[0],m=c.preDefStr.POSITION_BOTTOM,v=Math,b=v.min,x=v.max,k=v.abs;s.radarRadius=(0,c.pluckNumber)(d.radarradius),s.radarRadius!==c.UNDEF?(s.radarRadius=s.radarRadius>b(s.canvasHeight,s.canvasWidth)/2?b(s.canvasHeight,s.canvasWidth)/2:s.radarRadius,s.availableHeight=o=s.canvasHeight-2*s.radarRadius,s.availableWidth=a=s.canvasWidth-2*s.radarRadius):(s.availableHeight=o=.7*s.canvasHeight,s.availableWidth=a=.7*s.canvasWidth),u[0]===c.POSITION_TOP||u[0],r=u[0]===c.POSITION_TOP||u[0]===m?o:a,!1!==s.hasLegend&&p&&s.showLegend&&((n=f._manageLegendPosition(r)).bottom=b(x(n.bottom,0),r),n.right=b(x(n.right,0),r),n.top=b(x(n.top,0),r),n.left=b(x(n.left,0),r),this._allocateSpace(n)),p&&(n=p.placeAxis(s.availableWidth,s.availableHeight),this._allocateSpace(n)),g&&(n=g.placeAxis(s.canvasWidth)),n=this._manageChartMenuBar(s.availableHeight),e=.225*s.availableHeight,t=this._manageActionBarSpace&&(this._manageActionBarSpace(e)||{}),this._allocateSpace(t),l=s.radarRadius>0?2*s.radarRadius:b(s.canvasHeight,s.canvasWidth),s.canvasHeight>l&&(i=k((s.canvasHeight-l)/2),this._allocateSpace({top:i,bottom:i})),s.canvasWidth>l&&(i=k((s.canvasWidth-l)/2),this._allocateSpace({left:i,right:i})),l/=2,g.setAxisDimention({x:s.canvasLeft+s.canvasWidth/2,y:s.canvasTop+s.canvasHeight/2-(l-h/2),axisLength:l-h/2}),p.setAxisConfig({radius:l-h/2}),p.setAxisDimention({x:s.canvasLeft+s.canvasWidth/2,y:s.canvasTop+s.canvasHeight/2})},t.getName=function(){return"Radar"},a.getName=function(){return"Radar"},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=d},1060:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(556)),n=o(a(1061)),l=a(232),s=a(1062),c=a(224),d=c.regex.dropHash;(0,l.addDep)({name:"radarAnimation",type:"animationRule",extension:n["default"]});var h=function(e){function t(){var t;return(t=e.call(this)||this).getPathArr=function(){var e=this.pathArr,t=this.path2Arr;return e.length||t.length?e.concat(t):[]},t}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"radar"},a.createCoordinates=function(){var e,t,a,o,r,i,n,l,c=this.getFromEnv("chartConfig"),d=this.components.data.length,h=this.components.data;for(a=0;a<d;a++)l=(t=(e=h[a])&&e.config).setValue,void 0!==e&&(n=this.getFromEnv("yAxis").getPixel(l+0),r=(i=(0,s.getCoordinates)({radius:c.canvasTop+c.canvasHeight/2-n,theta:a},this.getFromEnv("xAxis"))).y,o=i.x,t._Px=o,t._Py=r,t._Pbx=o,t._Pby=r)},a.getLinePath=function(e,t,a){var o,r,i,n,l,c=this.getFromEnv("chartConfig"),d={},h=d.lastValidValue||!1,u=d.temp||[],p=d.temp2||[],g=d.pathArr||[],f=d.pointsJoined||0,m=t&&t.begin||0,v=t&&t.end||e.length,b=c.viewPortConfig.step||1,x=this.getFromEnv("yAxis"),k=this.getFromEnv("xAxis"),y=x.getPixel(0),C=this.removeDataLen||0,w=[];for(w=w.concat(e),o=m;o<v+C;o+=b)(l=w[o])&&(null===(r=l.config).setValue||r&&!0===r.isSkipped?(i=(0,s.getCoordinates)({theta:k.getLimit().min},k).x,n=x.getPixel(x.config.axisRange.min)):(i=r._Px,n=r._Py),"zero"===a?n=y:"base"===a&&(n=r._Pby),h?(u.length&&(g=g.concat(u),u=[],f++),g.push(["L",i,n])):(u.push(["M",i,n]),f=0,h=!0));return"Z"!==g[g.length-1]&&f>0&&g.push("Z"),{pathArr:g,path2Arr:[],lastValidValue:h,pointsJoined:f,temp:u,temp2:p,getPathArr:this.getPathArr}},a.configureAttributes=function(t){if(!t)return!1;this.trimData(t),this.JSONData=t;var a=this.config,o=this.getFromEnv("chart").getFromEnv("dataSource").chart,r=this.JSONData,i=this.getFromEnv("color-manager").getPlotColor(this.index);e.prototype.configureAttributes.call(this,t),a.defaultPadding={left:0,right:0},a.plotfillcolor=(0,c.pluck)(r.color,o.plotfillcolor,i),a.plotbordercolor=(0,c.pluck)(r.plotbordercolor,o.plotbordercolor,o.areabordercolor,i).split(",")[0],a.plotborderColorObject={color:a.plotbordercolor,alpha:a.plotborderalpha,angle:a.plotfillangle},a.fillColor={color:a.plotfillcolor+(a.plotgradientcolor?","+a.plotgradientcolor:c.BLANKSTRING),alpha:a.plotfillalpha,angle:a.plotfillangle},a.legendSymbolColor=a.plotfillcolor},a._getHoveredPlot=function(e,t){var a,o,r,i,n=this.getFromEnv("xAxis"),l=this.components.data,c=l.length,d=this.config,h=360/c;for(o=Math.floor(Math.max((0,s.getPlotFromPixel)({x:e-d.maxRadius,y:t},n)/h-1,0)),i=Math.floor(Math.max((0,s.getPlotFromPixel)({x:e+d.maxRadius,y:t},n)/h,c-1));i>=o&&(!(a=l[i])||!(r=this.isWithinShape(a,i,e,t)));i--);return r},a._contextChanged=function(){this.config.context||(this.config.context={});var t,a,o=this.config.context,r=o.axisCenterX;return t=!((a=this.getFromEnv("xAxis").config.axisDimention.centerX)===r),o.axisCenterX=a,t||e.prototype._contextChanged.call(this)},a.getPlotInCategoryAt=function(e,t){var a=this.components.data,o=this.getFromEnv("xAxis"),r=this.getState("visible"),i=Math.round((0,s.getPlotFromPixel)({x:e,y:t},o)),n=a.find((function(e,t,a){var r,n,l,c,d,h;return 0===t?(d=a[t+1],h=a[a.length-1]):t===a.length-1?(d=a[0],h=a[a.length-2]):(d=a[t+1],h=a[t-1]),r=(0,s.getPlotFromPixel)({x:e.config._Px,y:e.config._Py},o),n=t===a.length-1?360:(0,s.getPlotFromPixel)({x:d.config._Px,y:d.config._Py},o),l=(0,s.getPlotFromPixel)({x:h.config._Px,y:h.config._Py},o),i<=0+(c=(n-r)/2)?i>=0&&i<=0+c:i>360-c?i>=360-c&&i<=360:i>=l+c&&i<=n-c})),l=this._getHoveredPlot(e,t);return r&&l?l:!(!r||!n)&&{pointIndex:n._index,hovered:!1,pointObj:n}},a._addLegend=function(){var e,t,a,o=this.config,r=this.getFromEnv("chart-attrib"),i=this.getFromEnv("legend"),n=o.legendSymbolColor,l=(0,c.pluckNumber)(r.use3dlighting,r.useplotgradientcolor,1);e=(0,c.getLightColor)(n,60).replace(d,c.HASHSTRING),t=l?{FCcolor:{color:n+","+n+","+(0,c.getLightColor)(n,40)+","+n+","+n,ratio:"0,70,30",angle:270,alpha:"100,100,100,100,100"}}:{FCcolor:{color:n,angle:0,ratio:"0",alpha:"100"}},o.includeinlegend?((a=i.getItem(this.config.legendItemId))||(this.config.legendItemId=i.createItem(this),a=i.getItem(this.config.legendItemId),this.addExtEventListener("fc-click",(function(){a.itemClickFn()}),a)),a.configure({enabled:o.includeInLegend,type:this.type,label:(0,c.getFirstValue)(this.JSONData.seriesname),legendIconAlpha:(0,c.pluckNumber)(this.JSONData.legendiconalpha),usePattern:o.usePattern,patternAttr:{patternType:o.patternType,patternAngle:o.patternAngle,patternDensity:o.patternDensity,patternSize:o.patternSize,color:o.plotColor,patternAlpha:o.patternAlpha,patternBgColor:o.patternBgColor,alpha:o.plotfillalpha}}),a.setStateCosmetics("default",{symbol:{fill:(0,c.toRaphaelColor)(t),bgAlpha:(0,c.pluckNumber)(this.JSONData.legendiconbgalpha,this.JSONData.legendiconalpha,r.legendiconbgalpha,r.legendiconalpha,o.plotfillalpha),borderAlpha:(0,c.pluckNumber)(this.JSONData.legendiconborderalpha,this.JSONData.legendiconalpha,r.legendiconborderalpha,r.legendiconalpha,"100"),rawFillColor:n,stroke:(0,c.toRaphaelColor)(e)}}),this.getState("visible")?a.removeLegendState("hidden"):a.setLegendState("hidden")):this.config.legendItemId&&i.disposeItem(this.config.legendItemId)},a.getOldPath=function(e,t){var a,o=e,r=t.x,i=t.y,n=this.config&&this.config.prevLim,l=n.x,s=n.y,d=0,h=o.pathArr.length,u=function(e){var t=e;return(t=((t=(t=(t-l.minPixel.x)/(l.maxPixel.x-l.minPixel.x))*(l.max-l.min)+l.min)-r.min)/(r.max-r.min))*(r.maxPixel.x-r.minPixel.x)+r.minPixel.x+1},p=function(e){return e===s.base?i.base:function(e){var t=e;return(t<s.base&&t>i.base||t>s.base&&t<i.base)&&(t=i.base),t-1}(e)};if(s.min===i.min&&l.min===r.min&&s.max===i.max&&l.max===r.max)return o;if(o=(0,c.extend2)({},o),!n)return[];for(o.pathArr=o.pathArr.slice(0),o.path2Arr=o.path2Arr.slice(0),d=h;d--;)(a=o.pathArr[d].slice(0))[1]&&a.join&&(a[1]=u(a[1]),a[2]=p(a[2]),o.pathArr[d]=a);for(d=o.path2Arr.length;d--;)(a=o.path2Arr[d].slice(0))[1]&&a.join&&(a[1]=u(a[1]),a[2]=p(a[2]),o.path2Arr[d]=a);return o},a._setConfigure=function(){var e,t,a,o,r=this.config,i=this.config.JSONData.data||[],n=this.getFromEnv("xAxis").getTicksLen();for(r.imageCount=0,(a=this.components.data)||(a=this.components.data=[]),r.maxRadius=-Infinity,o=0;o<n;o++)t=a[o],e=i&&i[o]||{},t||(t=a[o]={}),t.config||(a[o].config={}),t.graphics||(t.graphics={}),this._plotConfigure(o,e)},t}(i["default"]);t["default"]=h},1061:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;var o=a(1062),r={"initial.dataset.radar":function(){return{"anchor.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}]},"anchor.updating":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},"anchor.disappearing":function(){return[{finalAttr:{opacity:0,"fill-opacity":0,"stroke-opacity":0},slot:"final"}]},"line.appearing":function(e){var t,a=e.component,r=a.getFromEnv("xAxis"),i=a.getFromEnv("yAxis"),n=r.getTicksLen(),l=a.getFromEnv("chartConfig"),s=e.attr,c=l.canvasTop+l.canvasHeight/2,d=[];for(t=0;t<n;t++)d.push(t?"L":"M"),d.push((0,o.getCoordinates)({radius:c,theta:0},r).x),d.push(i.getPixel(0));return d.push("Z"),[{initialAttr:{opacity:0,path:d},finalAttr:{opacity:1,path:s.path},startEnd:{start:0,end:.5},slot:"middle"}]},"label.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}],"*":null}}};t["default"]=r},1063:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o=e.getChildren("canvas")[0],l=e._feedAxesRawData(),s=o.getChildren("axisRefVisualPolar")[0],c=function(){return s.asyncDraw()};(0,n.componentFactory)(e,r["default"],"yAxis",1,l.yAxisConf),(0,n.componentFactory)(e,i["default"],"xAxis",1,l.xAxisConf),t=e.getChildren("yAxis")[0],a=e.getChildren("xAxis")[0],t.setLinkedItem("canvas",o),s.setLinkedItem(t.getId(),t),s.setLinkedItem(a.getId(),a),s.addExtEventListener("visiblerangeset",c,a),s.addExtEventListener("visiblerangeset",c,t),o.attachAxis(a,!1,{}),o.attachAxis(t,!0,{}),e._setCategories()};var r=o(a(481)),i=o(a(1064)),n=a(224)},1064:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(511)),n=a(224),l=a(1062),s=o(a(513)),c=o(a(507)),d=o(a(1065)),h=a(232),u=o(a(529)),p=a(516),g=n.preDefStr.POSITION_MIDDLE,f=n.preDefStr.POSITION_START,m=n.preDefStr.POSITION_TOP,v=n.preDefStr.POSITION_BOTTOM,b=n.preDefStr.POSITION_END,x=Math,k=x.min,y=x.PI,C=2*y;(0,h.addDep)({name:"polarAnimation",type:"animationRule",extension:d["default"]});var w=function(e){function t(){var t;return(t=e.call(this)||this).config.scale=new u["default"],t.config.referenceInfo=[],t}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"polarCategory"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.drawPlotBands=!1,this.config.forceZeroTick=!1},a.configureAttributes=function(t){var a=this.config,o=t,r=this.getFromEnv("chart").getFromEnv("dataSource").chart,i=this.getFromEnv("color-manager");e.prototype.configureAttributes.call(this,t),a.gridLineColor=(0,n.convertColor)((0,n.pluck)(o.radarSpikeColor,i.getColor("divLineColor")),(0,n.pluckNumber)(o.radarSpikeAlpha,o.radarInLineAlpha,i.getColor("divLineAlpha"))),a.radarSpikeThickness=(0,n.pluckNumber)(r.radarspikethickness,1)},a.setAxisDimention=function(e){var t,a=this.getScale(),o=this.config,r=this.getFromEnv("chart").config,i=o.startAngle||-y/2,l=o.totalAngle||-C,s=i+l,c=l/((o.tickValues.tickValue||[]).length||1),d=o.axisDimention||(o.axisDimention={});d.opposite=(0,n.pluckNumber)(e.opposite,d.opposite),d.centerX=(0,n.pluckNumber)(e.x,d.x,r.canvasLeft),d.centerY=(0,n.pluckNumber)(e.y,d.y,r.canvasTop),d.axisLength=C,s-=c,t=o.clockWise?[s,i]:[i,s],a.setRange(t)},a._parseCategoryPlotLine=function(){var e,t,a,o=this.config,r=o.tickValues.tickValue,i=o.gridLineColor,n=o.radarSpikeThickness,l=o.referenceInfo;if(e={stroke:i,"stroke-width":n},(!r[0]||void 0===r[0].x&&void 0===r[0].y)&&o.lines.isDraw&&o.numDivLines)for(t=0;t<r.length;++t)a=t,l.push({from:a,type:"line",layer:1,attr:e})},a.placeAxis=function(e,t){var a,o,r,i,l,s,c,d,h,u=this.config,p=this.getFromEnv("chart"),g=p.getFromEnv("smartLabel"),f=u.labels.style,m=p.getFromEnv("dataSource").categories,v=u.labelPadding=(0,n.pluckNumber)(u.rawAttr.axisValuePadding,10),b=u.useEllipsesWhenOverflow,x=0,y=0,C=0,w=0,A=t/2,S=t/2,N=e/2,L=e/2,D=u.tickValues&&u.tickValues.tickValue;if(u.labels.isDraw=1,u.labels.drawNormalVal=1,u.labels.drawLimitVal=1,this.components||(this.components={}),this.components.labels=[],u.showLabels){if(m){var E=m[0];l={fontFamily:E.font,fontSize:E.fontsize,color:E.fontcolor}}for(a=0,o=D.length;a<o;a++)s={fontFamily:(r=D[a]).font,fontSize:r.fontsize,fontWeight:r.fontbold?"bold":"normal",fontStyle:r.fontitalic?"italic":"normal"},c={fontFamily:(0,n.pluck)(s.fontFamily,l.fontFamily,f.fontFamily),fontSize:(0,n.pluck)(s.fontSize,l.fontSize,this.computeFontSize(f.fontSizeWithUnit)+n.PXSTRING),fontWeight:(0,n.pluck)(s.fontWeight,f.fontWeight),fontStyle:(0,n.pluck)(s.fontStyle,f.fontStyle)},h=(d=(0,n.setLineHeight)(c)).replace(/px/gi,""),g.useEllipsesOnOverflow(p.config.useEllipsesWhenOverflow),g.setStyle(c),void 0===r.oriLabel&&(r.oriLabel=r.label),0===a?(i=g.getSmartText(r.oriLabel,e,k(h,A),b),r.label=i.text,r.tooltext=i.tooltext,i.width+=i.width?v:0,i.height+=i.height?v:0,i.height>x&&(w=x=i.height)):a===o/2?(i=g.getSmartText(r.oriLabel,e,k(h,S),b),r.label=i.text,r.tooltext=i.tooltext,i.width+=i.width?v:0,i.height+=i.height?v:0,i.height>w&&(w=i.height)):a<o/2?(i=g.getSmartText(r.oriLabel,L,d,b),r.label=i.text,r.tooltext=i.tooltext,i.width+=i.width?v:0,i.height+=i.height?v:0,i.width>y&&(y=i.width)):(i=g.getSmartText(r.oriLabel,N,d,b),r.label=i.text,r.tooltext=i.tooltext,i.width+=i.width?v:0,i.height+=i.height?v:0,i.width>C&&(C=i.width)),this.components.labels.push({config:{width:i.width,height:i.height,props:{label:{attr:{}}}}})}else for(a=0,o=D.length;a<o;a++)this.components.labels.push({config:{width:0,height:0,props:{label:{attr:{}}}}});return{top:x,left:y,right:C,bottom:w}},a._drawComponents=function(){var e=this.config;e.drawLabels&&e.hasCategory&&this._drawCategory()},a.allocatePosition=function(){var e=this.config;e.drawLabels&&e.hasCategory&&this._parseCategory()},a._parseCategory=function(){var e,t,a,o,r,i,s,c,d,h,u,p,x,k,y,C,w,A,S=this.config,N=this.getFromEnv("chart"),L=S.isOpposit,D=S.labels,E=D.style,T=this.config.categoryLabel||(this.config.categoryLabel={}),F=N.getFromEnv("dataSource").categories,P=S.tickValues.tickValue,_=S.labelPadding,V={},I={},B=S.axisDimention.centerX,M=S.axisDimention.centerY,O=this.getScale();if(k=(0,n.pluckNumber)(S.radius,0),0,t=P?P.length-1:0,S.labels.isDraw){if(F){var R=F[0];V.fontFamily=R.font,V.fontSize=R.fontsize,V.color=R.fontcolor}for(E.fontSize=this.computeFontSize(E.fontSizeWithUnit),e=0;e<=t;e++)a=P[e],u=(0,n.pluckNumber)(a.x,a.y,e),(S.labels.drawNormalVal||S.labels.drawLimitVal&&(0===e||u===t))&&(S.labels.drawNormalVal||0===u||u===t)&&(S.labels.drawLimitVal||0!==u&&u!==t)&&(I={fontFamily:(0,n.pluck)(a.font,a.labelfont),fontSize:(0,n.pluck)(a.fontsize,a.labelfontsize),fontWeight:(0,n.pluckNumber)(a.fontbold,a.labelfontbold,0)?"bold":void 0,fontStyle:(0,n.pluckNumber)(a.fontitalic,a.labelfontitalic,0)?"italic":void 0},d=(0,n.convertColor)((0,n.pluck)(a.fontcolor,a.labelfontcolor,V.color,E.color),(0,n.pluckNumber)(a.labelalpha,S.rawAttr.labelFontAlpha,100)),(s={fontFamily:(0,n.pluck)(I.fontFamily,V.fontFamily,E.fontFamily),fontSize:(0,n.pluck)(I.fontSize,V.fontSize,E.fontSize),fontWeight:(0,n.pluck)(I.fontWeight,E.fontWeight),fontStyle:(0,n.pluck)(I.fontStyle,E.fontStyle)}).lineHeight=(0,n.setLineHeight)(s),s.lineHeight&&-1!==(r=s.lineHeight).indexOf("px")&&(r=r.replace(/px/i,""),r=parseFloat(r)),C=O.getRangeValue(u),(h=(0,l.polarToCartesian)(k+_,C)).x+=B,h.y+=M,p=h.x,x=h.y,o=a.label||"",0!==(0,n.pluckNumber)(a.showlabel,1)&&0!==S.showLabels||(o=""),i=a.labelPadding||0,c={fill:d,"line-height":r,"font-size":E.fontSize,text:o,cursor:a.link?"pointer":"default",x:p,y:x},i&&(c.y+=i),c["vertical-align"]=L?v:m,0===e?(c["text-anchor"]=g,c["vertical-align"]=v):e===(t+1)/2?(c["text-anchor"]=g,c["vertical-align"]=m):e<(t+1)/2?(c["text-anchor"]=b,c["vertical-align"]=g):(c["text-anchor"]=f,c["vertical-align"]=g),C=O.getRangeValue(u),(y=(0,l.polarToCartesian)(k,C)).x+=B,y.y+=M,D.shiftX&&(c.x+=D.shiftX),D.shiftY&&(c.y+=D.shiftY),(T=S.categoryLabel=T||{})[A="Label"+e]=T[A]||{},T[A].config=T[A].config||{},T[A].config.labelBox=w={label:o,lineHeight:s.lineHeight,border:(0,n.pluckNumber)(a.borderthickness,a.labelborderthickness)?(0,n.pluckNumber)(a.borderthickness,a.labelborderthickness,1)+"px solid":"",borderColor:a.bordercolor||a.labelbordercolor?(0,n.convertColor)(a.bordercolor||a.labelbordercolor,(0,n.pluckNumber)(a.borderalpha,a.labelborderalpha,a.alpha,a.labelalpha,100)):n.BLANKSTRING,borderThickness:(0,n.pluckNumber)(a.borderthickness,a.labelborderthickness),borderPadding:(0,n.pluckNumber)(a.borderpadding,a.labelborderpadding),borderRadius:(0,n.pluckNumber)(a.borderradius,a.labelborderradius),backgroundColor:a.bgcolor||a.labelbgcolor?(0,n.convertColor)(a.bgcolor||a.labelbgcolor,(0,n.pluckNumber)(a.bgalpha,a.labelbgalpha,a.alpha,a.labelalpha,100)):n.BLANKSTRING,borderDash:(0,n.pluckNumber)(a.borderdashed,a.labelborderdashed,0)?(0,n.getDashStyle)((0,n.pluckNumber)(a.borderdashlen,a.labelborderdashlen,4),(0,n.pluckNumber)(a.borderdashgap,a.labelborderdashgap,2)):0===(0,n.pluckNumber)(a.borderdashed,a.labelborderdashed)?"none":E.borderDash},T[A].config.labelBox["text-bound"]=o?[(0,n.pluck)(w.backgroundColor,E.backgroundColor),(0,n.pluck)(w.borderColor,E.borderColor),(0,n.pluck)(w.borderThickness,E.borderThickness),(0,n.pluck)(w.borderPadding,E.borderPadding),(0,n.pluck)(w.borderRadius,E.borderRadius),(0,n.pluck)(w.borderDash,E.borderDash)]:[],c["text-bound"]=T[A].config.labelBox["text-bound"],this.components.labels[e].config.props.label.css=s,this.components.labels[e].config.props.label.attr=Object.assign(this.components.labels[e].config.props.label.attr,c))}},a._drawCategory=function(){var e,t,a,o,r,i,l,c,d,h,u,p=this,g=p.config,f=p.getFromEnv("chart"),m=f.getFromEnv("animationManager"),v=g.labels.style,b=g.axisContainer,x=g.tickValues.tickValue,k=function(e){return function(t){f.plotEventHandler(this,t,e)}},y=p.getFromEnv("toolTipController"),C=0,w=[];if(0,t=x?x.length-1:0,g.labels.isDraw){for(e=0,C=0;e<=t;e++)a=x[e],c=(0,n.pluckNumber)(a.x,a.y,e),(g.labels.drawNormalVal||g.labels.drawLimitVal&&(0===e||c===t))&&(g.labels.drawNormalVal||0===c||c===t)&&(g.labels.drawLimitVal||0!==c&&c!==t)&&(h="Label"+e,w.push(h),l=p.components.labels[e].config.props.label.attr,i=p.components.labels[e].config.props.label.css,r=p.getGraphicalElement(h),o=m.setAnimation({css:i,el:r||"text",attr:l,container:b,component:p,label:"polarLabel"}),g.showTooltip&&a.tooltext?y.enableToolTip(o,a.tooltext):y.disableToolTip(o),o.data("eventArgs",{link:a.link||a.labellink||v.labelLink,text:l.text,index:C}),r||(p.addGraphicalElement(h,o),o.on("fc-click",k("datalabelclick")).hover(k("dataLabelRollOver"),k("dataLabelRollOut"))),C+=1);g.labelMap=g.labelMap||[],u=(0,s["default"])(g.labelMap,w)}else u=w;g.labelMap=w,function(t){for(e=0;e<t.length;++e)(d=p.getGraphicalElement(t[e]))&&p.removeGraphicalElement(d)}(u)},a.getTranslation=function(){if(this)return 0},a.getReferenceInfo=function(){return this.config.referenceInfo},a.setVisibleConfig=function(e,t){var a,o=this.config,r=this.getScale();return!(e>=t||e<o.axisRange.min||t>o.axisRange.max)&&(a=r.setDomain([e,t]).getDomain(),o.visibleMin=a[0],o.visibleMax=a[1],this.clearReferenceInfo(),this._parseReferenceVisuals(),this.fireEvent("visiblerangeset",{minValue:e,maxValue:t}),this.asyncDraw(),!0)},a._parseReferenceVisuals=function(){this.config.drawPlotlines&&this._parseCategoryPlotLine()},a.clearReferenceInfo=function(){this.config.referenceInfo=[]},a._setAxisRange=function(e){var t,a=e.min,o=e.max,r=this.config,i=r.axisRange,n=e.divGap;a>o||(t=(o-a)/(r.categoryNumDivLines+1),this.getScale().setDomain([a,o]),r.ticks=(0,c["default"])(a,o,t).concat(o),r._allTicks=r.ticks.slice(),i.min=a,i.max=o,i.tickInterval=n||t,this.setVisibleConfig(i.min,i.max))},t}(i["default"]);w.prototype.setTickValues=p.setTickValues,w.prototype.shiftLabels=p.shiftLabels,w.prototype._createContainer=p._createContainer,w.prototype.setAxisPadding=p.setAxisPadding,w.prototype.getPixel=p.getPixel,w.prototype.getLabel=p.getLabel;var A=w;t["default"]=A},1065:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1066)),i={"initial.axis.polar":function(){return{"path.appearing":r["default"],"text.appearing":r["default"]}}};t["default"]=i},1067:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t;(0,n.componentFactory)(e,r["default"],"canvas",e.config.showVolumeChart?2:1),t=e.getChildren("canvas");for(var a=0,o=t.length;a<o;a++)t[a].configure(),(0,n.componentFactory)(t[a],i["default"],"axisRefVisualPolar")};var r=o(a(1068)),i=o(a(1069)),n=a(224)},1068:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(467)),n=a(1062),l=a(224),s=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"polarCanvas"},a.getType=function(){return"canvas"},a.configureAttributes=function(){e.prototype.configureAttributes.call(this);var t=this.config,a=this.getFromEnv("chart"),o=a.getFromEnv("dataSource").chart,r=a.getFromEnv("color-manager");t.radarBorderColor=(0,l.convertColor)((0,l.pluck)(o.radarbordercolor,r.getColor("divLineColor")),(0,l.pluckNumber)(o.radarborderalpha,100)),t.radarFillColor=(0,l.convertColor)((0,l.pluck)(o.radarfillcolor,r.getColor("altHGridColor")),(0,l.pluckNumber)(o.radarfillalpha,r.getColor("altHGridAlpha"))),t.radarBorderThickness=(0,l.pluckNumber)(o.radarborderthickness,2),t.showRadarBorder=(0,l.pluckNumber)(o.showradarborder,1)},a.draw=function(){this.createGroup(),this.drawCanvas()},a.drawCanvas=function(){var e,t,a,o,r,i,s,c=this.config,d=this.getFromEnv("chart"),h=d.config,u=d.getChildren("xAxis")[0],p=d.getFromEnv("animationManager"),g=this.getContainer("radarBorderContainer"),f=this.getContainer("canvasGroup"),m=u.config,v={stroke:c.radarBorderColor,fill:c.radarFillColor,"stroke-width":c.radarBorderThickness,path:[]},b=m.tickValues.tickValue,x=u.getScale(),k=this.getGraphicalElement("radarBorder"),y=m.axisDimention.centerX,C=m.axisDimention.centerY;if(i=(0,l.pluckNumber)(m.radius,0),0,a=b?b.length-1:0,c.canvasLeft=c.canvasLeft||h.canvasLeft,c.canvasTop=c.canvasTop||h.canvasTop,c.canvasWidth=c.canvasWidth||h.canvasWidth,c.canvasHeight=c.canvasHeight||h.canvasHeight,0!==c.showRadarBorder){for(v.path.push("M"),t=0;t<=a;t++)o=x.getRangeValue(t),(r=(0,n.polarToCartesian)(i,o)).x+=y,r.y+=C,v.path.push(r.x,r.y,"L");v.path.pop(),v.path.push("Z")}e=p.setAnimation({el:g||"group",attr:{name:"radarBorderContainer"},container:f,component:this,label:"group"}),g||this.addContainer("radarBorderContainer",e),s=p.setAnimation({el:k||"path",attr:v,container:e,component:u,label:"path"}),k||this.addGraphicalElement("radarBorder",s)},t}(i["default"]);t["default"]=s},1069:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(531)),n=a(1062),l=a(224),s=a(232),c=o(a(1070));(0,s.addDep)({name:"axisRefPolarAnimation",type:"animationRule",extension:c["default"]});var d=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"axisRefVisuals"},a.getName=function(){return"axisRefVisualsPolar"},a.createLine=function(e,t){return"polarCategory"===t.getName()?this.createNormalLine(e,t):"numeric"===t.getName()?this.createRadialLine(e,t):void 0},a.createRadialLine=function(e,t){var a,o,r,i,l,s=this.getFromEnv("xAxis")[0],c=s.config.tickValues.tickValue,d=t,h=this.config.containers[e.layer],u=this.getFromEnv("animationManager"),p=this.getFromEnv("toolTipController"),g=e.attr,f=["M"],m=d.getId()+"_"+(e.id||e.from),v=e.handlers,b=this.getGraphicalElement(m);for(i=function(e,t){var a=e.getScale(),o=e.config.axisRange;return Math.abs(a.getRangeValue(t)-a.getRangeValue(o.min))}(d,e.from),0,r=c?c.length-1:0,a=0;a<=r;a++)l=(0,n.getCoordinates)({radius:i,theta:a},s),f.push(l.x,l.y,"L");for(o in f.pop(),f.push("Z"),g.path=f,b=this.addGraphicalElement(m,u.setAnimation({container:h,el:b||"path",attr:g,component:this,label:"path"})),e.toolText?p.enableToolTip(b,e.toolText):p.disableToolTip(b),v)v.hasOwnProperty(o)&&b.on(o,v[o].bind(t));return[m]},a.createNormalLine=function(e,t){var a,o,r=this.config,i=t.config,s=(0,l.pluckNumber)(i.radius,0),c=["M"],d=r.containers[e.layer],h=this.getFromEnv("animationManager"),u=this.getFromEnv("toolTipController"),p=i.axisDimention.centerX,g=i.axisDimention.centerY,f=t.getId()+"_"+(e.id||e.from),m=e.handlers,v=this.getGraphicalElement(f);for(o in c.push(p,g,"L"),a=(0,n.getCoordinates)({radius:s,theta:e.from},t),c.push(a.x,a.y),e.attr.path=c,v=this.addGraphicalElement(f,h.setAnimation({container:d,el:v||"path",attr:e.attr,component:this,label:"path"})),e.toolText?u.enableToolTip(v,e.toolText):u.disableToolTip(v),m)m.hasOwnProperty(o)&&v.on(o,m[o].bind(t));return[f]},a.createBand=function(){return[]},t}(i["default"]);t["default"]=d},1070:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1066)),i={"initial.axis.axisRefVisualsPolar":function(){return{"path.appearing":r["default"],"text.appearing":r["default"]}}};t["default"]=i},1071:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(1072))["default"];t["default"]=r},1072:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(242)),i=o(a(238)),n=o(a(465)),l=o(a(391)),s=o(a(423)),c=o(a(1073)),d=o(a(1074)),h=o(a(485)),u=a(224),p=o(a(366)),g=o(a(484)),f=o(a(1075)),m=a(566),v=["1E77B4","FF7F0E","2BA02C","D62728","9466BD","8C564B","E376C2","7F7F7F","BCBD22","17BECF"],b=["tangential","outside","inside"],x=function(e){function t(t){var a;a=e.call(this,t)||this;var o=(0,r["default"])(a);return o.deregisterFactory("canvas"),o.registerFactory("legend",c["default"]),o.registerFactory("nodelinkManager",d["default"]),o.defaultPaletteOptions={paletteColors:[v,v,v,v,v],bgColor:["FFFFFF,FFFFFF","FFFFFF,FFFFFF","FFFFFF,FFFFFF","FFFFFF,FFFFFF","FFFFFF,FFFFFF"]},a}(0,i["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.skipCanvasDrawing=!0,t.friendlyName="Chord",t.nodes={},t.mode="post",t.isPost=!0,t.nodeSpacing=2,t.minNodeSize=.01,t.startingAngle=0,t.links={},t.linksOrder=[],t.nodesOrder=[],t.totalAngle=360,t.clockwise=1,t.nodeLabelGap=10,t.nodeLabelPosition=10,t.nodeThickness=12,t.nodeLinkPadding=3,t.linkAlpha=70,t.linkBorderAlpha=100,t.linkBorderThickness=1,t.nodeHoverAlpha=100,t.linkHoverAlpha=100,t.nodeHoverColor=u.UNDEF,t.linkHoverColor=u.UNDEF,t.showNodeLabels=1,t.showNodeBorder=1,t.showLinkBorder=1,t.nodeBorderColor=u.UNDEF,t.nodeBorderThickness=1,t.nodeBorderDashed=0,t.nodeBorderDashedLen=2,t.nodeBorderDashedGap=1,t.nodeBorderAlpha=100,t.showLinkValueOnHover=1,t.nodeAlpha=70,t.nodeLabelPosition="tangential",t.nodeLabelFont="Verdana,sans",t.nodeLabelFontSize=12,t.nodeLabelFontBold=u.NORMAL,t.nodeLabelFontItalic=u.NORMAL,t.highlightEffect=1,t.enableToggle=1,t.chordradius=100,t.nodeLabelColor="#5F5F5F",t.unfocussedAlpha=35,t.deactiveNodeColor="#c4c4c4",t.sortOrder=u.UNDEF,t.tooltipsepchar=u.BLANKSTRING,t.linkColorByDominance=1,t.useEllipsesOnOverflow=1},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t);var a,o,r=this.config,i=r.nodes,n=r.links,c=r.nodesOrder,d=r.linksOrder,f=r.connectors=t.links,m=f.length,v=this.getFromEnv("number-formatter"),x=t.chart,k=this.getFromEnv("color-manager");for(r.mode="pre"===x.mode?"pre":"post",r.isPost=(0,p["default"])(r.mode,"post"),r.minNodeSize=(0,u.pluckNumber)(x.minnodesize,r.minNodeSize),r.startingAngle=(0,u.pluckNumber)(x.startingangle,r.startingAngle),r.totalAngle=(0,u.pluckNumber)(x.totalangle,r.totalAngle),r.nodeLabelGap=(0,u.pluckNumber)(x.nodelabelpadding,r.nodeLabelGap),r.nodeThickness=(0,u.pluckNumber)(x.nodethickness,r.nodeThickness),r.nodeSpacing=(0,u.pluckNumber)(x.nodespacing,r.nodeSpacing),r.clockwise=(0,u.pluckNumber)(x.clockwise,r.clockwise),r.nodeLinkPadding=(0,u.pluckNumber)(x.nodelinkpadding,r.nodeLinkPadding),r.linkAlpha=(0,u.pluckNumber)(x.linkalpha,r.linkAlpha),r.linkBorderAlpha=(0,u.pluckNumber)(x.linkborderalpha,r.linkBorderAlpha),r.linkBorderThickness=(0,u.pluckNumber)(x.linkborderthickness,r.linkBorderThickness),r.nodeHoverAlpha=(0,u.pluckNumber)(x.nodehoveralpha,r.nodeHoverAlpha),r.linkHoverAlpha=(0,u.pluckNumber)(x.linkhoveralpha,r.linkHoverAlpha),r.showLinkValueOnHover=(0,u.pluckNumber)(x.showlinkvalueonhover,r.showLinkValueOnHover),r.showNodeLabels=(0,u.pluckNumber)(x.shownodelabels,r.showNodeLabels),r.showNodeBorder=(0,u.pluckNumber)(x.shownodeborder,r.showNodeBorder),r.showLinkBorder=(0,u.pluckNumber)(x.showlinkborder,r.showLinkBorder),r.nodeBorderColor=(0,u.pluck)(x.nodebordercolor,r.nodeBorderColor),r.nodeBorderThickness=(0,u.pluckNumber)(x.nodeborderthickness,r.nodeBorderThickness),r.nodeBorderDashed=(0,u.pluckNumber)(x.nodeborderdashed,r.nodeBorderDashed),r.nodeBorderDashedLen=(0,u.pluckNumber)(x.nodeborderdashedlen,r.nodeBorderDashedLen),r.nodeBorderDashedGap=(0,u.pluckNumber)(x.nodeborderdashedgap,r.nodeBorderDashedGap),r.nodeBorderAlpha=(0,u.pluckNumber)(x.nodeborderalpha,r.nodeBorderAlpha),r.nodeAlpha=(0,u.pluckNumber)(x.nodealpha,r.nodeAlpha),r.nodeLabelPosition=b.includes(x.nodelabelposition)?x.nodelabelposition:r.nodeLabelPosition,r.nodeLabelFont=(0,u.pluck)(x.nodelabelfont,x.basefont,r.nodeLabelFont),r.nodeLabelFontSize=(0,u.pluckFontSize)(x.nodelabelfontsize,this.computeFontSize(x.basefontsize),r.nodeLabelFontSize),r.nodeLabelFontBold=(0,u.pluckNumber)(x.nodelabelfontbold,0)?u.BOLD:u.NORMAL,r.nodeLabelColor=(0,u.pluck)(x.nodelabelcolor,x.basefontcolor,r.nodeLabelColor),r.nodeLabelFontItalic=(0,u.pluckNumber)(x.nodelabelfontitalic,0)?"italic":u.NORMAL,r.highlightEffect=(0,u.pluckNumber)(x.highlighteffect,r.highlightEffect),r.enableToggle=(0,u.pluckNumber)(x.enabletoggle,r.enableToggle),r.chordradius=Math.max((0,u.pluckNumber)(x.chordradius,r.chordradius),0),r.unfocussedAlpha=(0,u.pluckNumber)(x.unfocussedalpha,r.unfocussedAlpha),r.deactiveNodeColor=(0,u.pluck)(x.deactivenodecolor,r.deactiveNodeColor),r.sortOrder=(0,u.pluck)(x.sortorder,r.sortOrder),r.linkColorByDominance=(0,u.pluckNumber)(x.linkcolorbydominance,r.linkColorByDominance),r.textOutline=(0,u.pluckNumber)(x.textoutline,0),r.useEllipsesOnOverflow=(0,u.pluckNumber)(x.useellipsesonoverflow,r.useEllipsesOnOverflow),r.datalabelStyle={"font-size":r.nodeLabelFontSize,"font-family":r.nodeLabelFont,"font-weight":r.nodeLabelFontBold,"font-style":r.nodeLabelFontItalic},"inside"===r.nodeLabelPosition&&(r.nodeLabelGap=0),a=0;a<m;++a)if(o=f[a],(0,s["default"])(o)&&(0,u.parseUnsafeString)(o.from)&&(0,u.parseUnsafeString)(o.to)){var y,C=f[a],w=C.from,A=C.to,S=C.value,N=C.tooltext,L=(0,g["default"])([v.getCleanValue(S),0],Number),D=void 0;y=[w=(0,u.parseUnsafeString)(w),A=(0,u.parseUnsafeString)(A)].sort().toString(),i[w]||(i[w]={index:c.push(w)-1,total:0,adjustedTotal:0,nodeCovered:0,label:w,linkedLinks:[],scale:new h["default"],active:!0,nodeLabelGap:r.nodeLabelGap,unfocussed:!1,hovered:!1,toolTipSepChar:r.tooltipsepchar,showToolTip:r.showToolTip}),i[A]||(i[A]={index:c.push(A)-1,total:0,adjustedTotal:0,nodeCovered:0,label:A,linkedLinks:[],scale:new h["default"],active:!0,nodeLabelGap:r.nodeLabelGap,unfocussed:!1,hovered:!1,toolTipSepChar:r.tooltipsepchar,showToolTip:r.showToolTip}),n[y]?D=n[y]:(D=n[y]={key:y,points:[],dominantNode:[],subservientNode:[],subservientFlowDataValue:[],dominantFlowDataValue:[],dominantNodeColor:[],subservientNodeColor:[],index:d.push(y)-1,linkedNodes:r.isPost?[A,w]:[w,A],tooltip:{},visible:!0,tooltext:N,unfocussed:!1,hovered:!1,focussedState:{},unfocussedState:{},normalState:{},sanitisedValue:0,toolTipSepChar:r.tooltipsepchar,showToolTip:r.showToolTip},i[w].linkedLinks.push(y),i[A].linkedLinks.push(y),D.alpha=(0,u.pluckNumber)(C.alpha,r.linkAlpha),D.hoverAlpha=(0,u.pluckNumber)(C.hoveralpha,r.linkHoverAlpha),D.borderAlpha=(0,u.pluckNumber)(C.borderalpha,r.linkBorderAlpha),D.tooltext=(0,u.pluck)(C.tooltext,r.linktooltext,u.UNDEF),D.showBorder=r.showLinkBorder,D.borderThickness=r.linkBorderThickness,D.unfocussedAlpha=(0,u.pluckNumber)(C.unfocussedAlpha,r.unfocussedAlpha),D.style=r.datalabelStyle),i[r.isPost?A:w].total+=L,D.tooltip[w+" to "+A]={value:v.dataLabels(L)},D.showLinkValueOnHover=r.showLinkValueOnHover,D[r.isPost?A:w]=L,n[y].sanitisedValue+=L}var E=function(e){n.hasOwnProperty(e)&&0===n[e].sanitisedValue&&(delete n[e],r.linksOrder=d=d.filter((function(t){return t!==e})),e.split(",").forEach((function(t){i[t].linkedLinks=i[t].linkedLinks.filter((function(t){return t!==e}))})))};for(var T in n)E(T);(0,l["default"])(t.nodes)&&t.nodes.forEach((function(e){if(function(e,t){return(0,s["default"])(e)&&(0,u.parseUnsafeString)(e.label)&&t[e.label]}(e,i)){var t=(0,u.parseUnsafeString)(e.label);i[t]=Object.assign({},e,i[t])}})),"ascending"===r.sortOrder?c.sort((function(e,t){return i[e].total-i[t].total})):"descending"===r.sortOrder&&c.sort((function(e,t){return i[t].total-i[e].total})),c.forEach((function(e,t){var a=i[e],o=(r.showNodeBorder?r.nodeBorderThickness:0)||0;a.index=t,a.label=(0,u.parseUnsafeString)(a.label),a.alpha=(0,u.pluckNumber)(a.alpha,r.nodeAlpha),a.borderAlpha=(0,u.pluckNumber)(a.borderalpha,r.nodeBorderAlpha),a.hoverAlpha=(0,u.pluckNumber)(a.hoveralpha,r.nodeHoverAlpha),a.borderDashedLen=(0,u.pluckNumber)(a.borderdashedlen,r.nodeBorderDashedLen),a.borderDashedGap=(0,u.pluckNumber)(a.borderdashedgap,r.nodeBorderDashedGap),a.borderDashed=(0,u.pluckNumber)(a.borderdashed,r.nodeBorderDashed)?[a.borderDashedLen,a.borderDashedGap]:"none",a.rawColor=(0,u.pluck)(a.color,k.getPlotColor(t)),a.unfocussedAlpha=(0,u.pluckNumber)(a.unfocussedalpha,r.unfocussedAlpha),a.borderColor=(0,u.pluck)(a.bordercolor,r.nodeBorderColor,(0,u.getDarkColor)(a.rawColor,80)),a.tooltext=(0,u.pluck)(a.tooltext,x.plottooltext,u.UNDEF),a.color=(0,u.hashify)(a.rawColor),a.labelPosition=(0,u.pluck)(a.labelposition,r.nodeLabelPosition),a.nodeLabelGap=r.nodeLabelGap,!(0,u.pluckNumber)(x.exportenabled)||"outside"!==a.labelPosition&&"inside"!==a.labelPosition?a.showLabel=(0,u.pluckNumber)(a.showlabel,r.showNodeLabels):a.showLabel=0,a.showBorder=r.showNodeBorder,a.labelColor=(0,u.pluck)(a.labelcolor,r.nodeLabelColor),a.style=r.datalabelStyle,a.focussedState={fill:(0,u.convertColor)(a.rawColor,a.hoverAlpha),stroke:(0,u.convertColor)(a.borderColor,a.borderAlpha),"stroke-width":o,"stroke-dasharray":a.borderDashed},a.normalState={fill:(0,u.convertColor)(a.rawColor,a.alpha),stroke:(0,u.convertColor)(a.borderColor,a.borderAlpha),"stroke-width":o,"stroke-dasharray":a.borderDashed},a.unfocussedState={fill:(0,u.convertColor)(a.rawColor,a.unfocussedAlpha),stroke:(0,u.convertColor)(a.borderColor,a.unfocussedAlpha),"stroke-width":o,"stroke-dasharray":a.borderDashed},a.deactiveState={fill:r.deactiveNodeColor,stroke:r.deactiveNodeColor,"stroke-width":o,"stroke-dasharray":a.borderDashed},a.linkedLinks.forEach((function(e){var t=new RegExp("^"+a.label),o=n[e].tooltip;for(var r in o)o.hasOwnProperty(r)&&t.test(r)&&(o[r].color=a.color)}))})),d.forEach((function(e){var t=n[e],a=t.linkedNodes,o=a[0],l=a[1];o===l&&(t.dominantNode.push(o),t.subservientNode.push(o),t.subservientFlowDataValue.push(v.dataLabels(t[o])),t.dominantFlowDataValue.push(v.dataLabels(t[o])),t.dominantNodeColor.push(i[o].color),t.subservientNodeColor.push(i[o].color)),t[l]===t[o]?(t.dominantNode.push(o,l),t.subservientNode.push(l,o),t.subservientFlowDataValue.push(v.dataLabels(t[l])),t.dominantFlowDataValue.push(v.dataLabels(t[o])),t.dominantNodeColor.push(i[o].color,i[l].color),t.subservientNodeColor.push(i[l].color,i[o].color)):r.isPost?(t[l]||0)>(t[o]||0)?(r.linkColorByDominance?t.dominantNode.push(l):t.dominantNode.push(o),r.linkColorByDominance?t.subservientNode.push(o):t.subservientNode.push(l),r.linkColorByDominance?t.dominantFlowDataValue.push(v.dataLabels(t[l])):t.dominantFlowDataValue.push(v.dataLabels(t[o])),r.linkColorByDominance?t.subservientFlowDataValue.push(v.dataLabels(t[o])):t.subservientFlowDataValue.push(v.dataLabels(t[l])),r.linkColorByDominance?t.dominantNodeColor.push(i[l].color):t.dominantNodeColor.push(i[o].color),r.linkColorByDominance?t.subservientNodeColor.push(i[o].color):t.subservientNodeColor.push(i[l].color)):(r.linkColorByDominance?t.dominantNode.push(o):t.dominantNode.push(l),r.linkColorByDominance?t.subservientNode.push(l):t.subservientNode.push(o),r.linkColorByDominance?t.dominantFlowDataValue.push(v.dataLabels(t[o])):t.dominantFlowDataValue.push(v.dataLabels(t[l])),r.linkColorByDominance?t.subservientFlowDataValue.push(v.dataLabels(t[l])):t.subservientFlowDataValue.push(v.dataLabels(t[o])),r.linkColorByDominance?t.dominantNodeColor.push(i[o].color):t.dominantNodeColor.push(i[l].color),r.linkColorByDominance?t.subservientNodeColor.push(i[l].color):t.subservientNodeColor.push(i[o].color)):(t[l]||0)>(t[o]||0)?(r.linkColorByDominance?t.dominantNode.push(o):t.dominantNode.push(l),r.linkColorByDominance?t.subservientNode.push(l):t.subservientNode.push(o),r.linkColorByDominance?t.dominantFlowDataValue.push(v.dataLabels(t[o])):t.dominantFlowDataValue.push(v.dataLabels(t[l])),r.linkColorByDominance?t.subservientFlowDataValue.push(v.dataLabels(t[l])):t.subservientFlowDataValue.push(v.dataLabels(t[o])),r.linkColorByDominance?t.dominantNodeColor.push(i[o].color):t.dominantNodeColor.push(i[l].color),r.linkColorByDominance?t.subservientNodeColor.push(i[l].color):t.subservientNodeColor.push(i[o].color)):(r.linkColorByDominance?t.dominantNode.push(l):t.dominantNode.push(o),r.linkColorByDominance?t.subservientNode.push(o):t.subservientNode.push(l),r.linkColorByDominance?t.dominantFlowDataValue.push(v.dataLabels(t[l])):t.dominantFlowDataValue.push(v.dataLabels(t[o])),r.linkColorByDominance?t.subservientFlowDataValue.push(v.dataLabels(t[o])):t.subservientFlowDataValue.push(v.dataLabels(t[l])),r.linkColorByDominance?t.dominantNodeColor.push(i[l].color):t.dominantNodeColor.push(i[o].color),r.linkColorByDominance?t.subservientNodeColor.push(i[o].color):t.subservientNodeColor.push(i[l].color))}))},t.getName=function(){return"Chord"},a.getName=function(){return"Chord"},a.getDSdef=function(){return f["default"]},a._manageLegendSpace=function(){m._manageLegendSpace.call(this)},a._spaceManager=function(){var e,t,a,o,r,i,n,l,s=this.config,c=this.getChildren("node-link-manager")[0];s.showLegend&&this._manageLegendSpace(),this._manageChartMenuBar(.6*s.availableHeight),this.allocateDimensionOfChartMenuBar(),this.config.showLegend&&this.getChildren("legend")&&this.getChildren("legend")[0].postSpaceManager(),e=s.canvasHeight,t=s.canvasWidth,a=s.canvasLeft+t/2,o=s.canvasTop+e/2,l=(i=Math.min(e,t)/2)-(n=.3*i)-s.nodeLabelGap,r=c._manageSpace({maxSpace:l}),this.config.cx=a,this.config.cy=o;var d=Math.max((i-r.width-s.nodeLabelGap)*s.chordradius/100,n),h=d-s.nodeThickness,u=h-s.nodeLinkPadding;s.ribbonRadius=u,c.setDimension({nodeOuterRadius:d,nodeInnerRadius:h,ribbonRadius:u}),c.setTranslation(a,o)},a._checkInvalidData=function(){var e=this.getFromEnv("chartInstance");return(0,l["default"])(this.getFromEnv("dataSource").links)?!this:(e.__state.dataReady=!1,e.jsVars.hasNativeMessage=!0,e.jsVars.drawCount+=1,!0)},a._checkInvalidSpecificData=function(){return!this},t}(n["default"]);t["default"]=x},1073:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a=e.config.showLegend?1:0;(0,r.componentFactory)(e,i["default"],"legend",a,[{}]),(t=e.getChildren("legend"))&&t[0]&&!t[0].getState("removed")?e.addToEnv("legend",t[0]):e.deleteFromEnv("legend")};var r=a(224),i=o(a(569))},1074:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t=e.config;(0,r.componentFactory)(e,i["default"],"node-link-manager",1,[{nodes:t.nodes,links:t.links,nodesOrder:t.nodesOrder,linksOrder:t.linksOrder,nodeLabelGap:t.nodeLabelGap,nodeLinkPadding:t.nodeLinkPadding,showLegend:t.showLegend,totalAngle:t.totalAngle,nodeSpacing:t.nodeSpacing,isPost:t.isPost,matrix:t.matrix,startingAngle:t.startingAngle,minNodeSize:t.minNodeSize,highlightEffect:t.highlightEffect,enableToggle:t.enableToggle,datalabelStyle:t.datalabelStyle}]),t.showLegend&&e.getChildren("node-link-manager")[0]._addLegend()};var r=a(224),i=o(a(1075))},1075:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(223)),i=o(a(238)),n=a(240),l=o(a(1076)),s=o(a(1079)),c=a(224);function d(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,o)}return a}function h(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?d(Object(a),!0).forEach((function(t){(0,r["default"])(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):d(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var u=function(e,t){return e-t},p=function(e){function t(t){var a;return(a=e.call(this,t)||this).registerFactory("chord-node-factory",l["default"]),a.registerFactory("chord-link-factory",s["default"]),a}(0,i["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.total=0,t.adjustedTotal=0},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t),Object.assign(this.config,t);var a,o=this.config,r=o.totalAngle,i=o.startingAngle,n=o.nodesOrder,l=o.nodes,s=o.linksOrder,d=o.links;r-=o.nodeSpacing*n.length,a=o.total=n.reduce((function(e,t){return e+l[t].total}),0),o.adjustedTotal=n.reduce((function(e,t){var r=l[t];return r.total/(a||1)<o.minNodeSize?r.adjustedTotal=(a||1)*o.minNodeSize:r.adjustedTotal=r.total,e+r.adjustedTotal}),0),o.interactiveLegend=(0,c.pluckNumber)(this.getFromEnv("chart-attrib").interactivelegend,1);var h=r/o.adjustedTotal;n.forEach((function(e){var t=l[e];t.startingAngle=i,t.arcAngle=t.adjustedTotal*h,t.endingAngle=i+t.arcAngle,t.scale.setRange([t.startingAngle,t.endingAngle]).setDomain([0,t.adjustedTotal]),i=t.endingAngle+o.nodeSpacing})),s.forEach((function(e){if(d[e].visible){var t,a,r=d[e],i=o.isPost?r.linkedNodes[1]:r.linkedNodes[0],n=o.isPost?r.linkedNodes[0]:r.linkedNodes[1],s=l[i],c=l[n],h=s.scale,u=c.scale,p=h.getRangeValue(s.nodeCovered),g=h.getRangeValue(s.nodeCovered+=r[i]||0);r.points.length&&(r.points.length=0),i===n?(t=p,a=g):(t=u.getRangeValue(c.nodeCovered),a=u.getRangeValue(c.nodeCovered+=r[n]||0)),r.points.push(p,g,t,a)}})),s.forEach((function(e){var t=d[e],a=t.dominantNode;if(t.angles=t.points.slice(0).sort(u),a.length>1&&l[a[0]].rawColor!==l[a[1]].rawColor){var o=l[a[0]].index>l[a[1]].index?[l[a[1]],l[a[0]]]:[l[a[0]],l[a[1]]];t.rawColor=[o[0].rawColor,o[1].rawColor]}else t.normalState.fill=(0,c.convertColor)(l[a[0]].rawColor,t.alpha),t.normalState.stroke=(0,c.convertColor)(l[a[0]].rawColor,t.borderAlpha),t.focussedState.fill=(0,c.convertColor)(l[a[0]].rawColor,t.hoverAlpha),t.focussedState.stroke=t.focussedState.fill,t.unfocussedState.fill=(0,c.convertColor)(l[a[0]].rawColor,t.unfocussedAlpha),t.unfocussedState.stroke=t.unfocussedState.fill}))},a.setDimension=function(e){var t=this.config;Object.assign(t,e),this.getChildren("node")&&this.getChildren("node").forEach((function(e){return!e.getState("removed")&&e.setDimension({outerRadius:t.nodeOuterRadius,innerRadius:t.nodeInnerRadius})})),this.getChildren("ribbon")&&this.getChildren("ribbon").forEach((function(e){return!e.getState("removed")&&e.setDimension({radius:t.ribbonRadius})}))},a._manageSpace=function(e){var t=this.getChildren("node").map((function(t){return t._manageSpace(e)})),a=Math.max.apply(Math,t);return{width:a,height:a}},a._createContainer=function(){var e=this.config;this.addGraphicalElement({el:"group",container:{id:"plotGroup",isParent:!0},component:this,label:"link-container",id:"link-container",attr:{name:"link-container",transform:e.translate}}),this.addGraphicalElement({el:"group",container:{id:"plotGroup",isParent:!0},component:this,label:"node-container",id:"node-container",attr:h({name:"node-container",transform:e.translate},e.datalabelStyle)})},a.draw=function(){this._createContainer()},a.getName=function(){return"node-link-manager"},a.getType=function(){return"node-link-manager"},a._addLegend=function(){var e,t,a=this,o=a.config,r=o.nodes,i=o.nodesOrder,n=a.getFromEnv("legend"),l=o.legendItemMap||(o.legendItemMap={}),s=new Set;Object.keys(l).forEach((function(e){return s.add(l[e])})),i.forEach((function(o){var i=r[o];t=l[o],(e=n.getItem(t))?(e.removeLegendState("hidden"),s["delete"](t)):(t=n.createItem(),e=n.getItem(t),l[o]=t,a.addExtEventListener("fc-click",(function(){if(a.config.interactiveLegend){var e=a.config.nodes[o],t=n.getItem(l[o]);a.nodeClicked(e.label,t)}}),e),a.addExtEventListener("fc-mouseover",(function(){a.config.interactiveLegend&&a.nodeHoverIn(o)}),e),a.addExtEventListener("fc-mouseout",(function(){a.config.interactiveLegend&&a.nodeHoverOut(o)}),e)),e.configure({enabled:!0,label:o}),e.setStateCosmetics("default",{symbol:{rawFillColor:i.color,rawStrokeColor:i.color,fill:i.color,stroke:i.color}})})),s.forEach((function(e){n.disposeItem(e)}))},a.nodeClicked=function(e,t){if(this.config.enableToggle){var a=this.config,o=a.nodes,r=a.nodesOrder,i=a.links,n=o[e],l=n.linkedLinks,s=n.active;n.active?t&&t.setLegendState("hidden"):t&&t.removeLegendState("hidden"),n.active=!s,l.forEach((function(e){var t=i[e],r=a.isPost?t.linkedNodes[1]:t.linkedNodes[0],n=a.isPost?t.linkedNodes[0]:t.linkedNodes[1],l=o[r],s=o[n],d=t.visible;t.visible=l.active&&s.active,t.visible!==d&&(t.visible?(l.total=(0,c.toPrecision)(l.total+(t[r]||0),4),n!==r&&(s.total=(0,c.toPrecision)(s.total+(t[n]||0),4))):(l.total=(0,c.toPrecision)(l.total-(t[r]||0),4),n!==r&&(s.total=(0,c.toPrecision)(s.total-(t[n]||0),4))))})),r.forEach((function(e){return o[e].nodeCovered=0})),s?this.nodeHoverOut(e,!1):this.nodeHoverIn(e,!1),this.setData({},!0),this.setDimension()}},a.linkHoverIn=function(e,t){if(void 0===t&&(t=!0),this.config.highlightEffect){var a=this,o=a.config,r=o.links,i=o.nodes,n=o.nodesOrder,l=o.linksOrder,s=r[e].linkedNodes;n.forEach((function(e){var o=i[e],r=a.getChild(e);r&&!r.getState("removed")&&(s.includes(e)?(o.hovered=!0,o.unfocussed=!1):(o.hovered=!1,o.unfocussed=!0),t&&r.setData({hovered:o.hovered,unfocussed:o.unfocussed},!0))})),l.forEach((function(o){var i=r[o],n=a.getChild(o);n&&!n.getState("removed")&&(o===e?(i.hovered=!0,i.unfocussed=!1):(i.hovered=!1,i.unfocussed=!0),t&&n.setData({hovered:i.hovered,unfocussed:i.unfocussed},!0))})),t&&this.setDimension()}},a.resetEffect=function(e){void 0===e&&(e=!0);var t=this,a=t.config,o=a.links,r=a.nodes,i=a.nodesOrder,n=a.linksOrder;i.forEach((function(a){var o=r[a],i=t.getChild(a);i&&!i.getState("removed")&&(o.hovered=!1,o.unfocussed=!1,e&&i.setData({hovered:o.hovered,unfocussed:o.unfocussed},!0))})),n.forEach((function(a){var r=o[a],i=t.getChild(a);i&&!i.getState("removed")&&(r.hovered=!1,r.unfocussed=!1,e&&i.setData({hovered:r.hovered,unfocussed:r.unfocussed},!0))})),this.setDimension()},a.linkHoverOut=function(e,t){void 0===t&&(t=!0),this.config.highlightEffect&&this.resetEffect(t)},a.nodeHoverIn=function(e,t){if(void 0===t&&(t=!0),this.config.highlightEffect){var a=this,o=a.config,r=o.links,i=o.nodes,n=o.nodesOrder,l=o.linksOrder,s=i[e],c=s.linkedLinks,d=c.map((function(t){return r[t].linkedNodes[0]===e?r[t].linkedNodes[1]:r[t].linkedNodes[0]}));d.push(e),n.forEach((function(e){var o=i[e],r=a.getChild(e);r&&!r.getState("removed")&&(d.includes(e)?(o.hovered=!0,o.unfocussed=!1):(o.hovered=!1,o.unfocussed=!0),t&&s.active&&r.setData({hovered:o.hovered,unfocussed:o.unfocussed},!0))})),l.forEach((function(e){var o=r[e],i=a.getChild(e);i&&!i.getState("removed")&&(c.includes(e)?(o.hovered=!0,o.unfocussed=!1):(o.hovered=!1,o.unfocussed=!0),t&&s.active&&i.setData({hovered:o.hovered,unfocussed:o.unfocussed},!0))})),t&&s.active&&this.setDimension()}},a.nodeHoverOut=function(e,t){void 0===t&&(t=!0),this.config.highlightEffect&&this.resetEffect(t)},t}(n.SmartRenderer);t["default"]=p},1076:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t=e.config;t.nodesOrder.forEach((function(a){e.attachChild(r["default"],"node",a).configure(t.nodes[a])}))};var r=o(a(1077))},1077:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(240),n=a(1062),l=a(1078),s=a(224),c=a(590),d=function(e,t,a,o){var r=(0,n.polarToCartesian)(o,(0,l.normaliseAngle)(e),!1),i=r.x,s=r.y,c=(0,n.polarToCartesian)(o,(0,l.normaliseAngle)(t),!1);return"M "+i+" "+s+" A "+o+" "+o+" 0 "+(a>180?1:0)+" "+(e>t?0:1)+" "+c.x+" "+c.y},h=function(e){var t=this.getLinkedParent(),a=this.getFromEnv("legend"),o=this.getFromEnv("chart"),r=a?a.getItem(t.config.legendItemMap[this.config.label]):null,i={};g(i,this),t.nodeClicked(this.config.label,r),o.plotEventHandler(null,e,"dataplotclick",i)},u=function(e){var t=this.getFromEnv("chart");this.getLinkedParent().nodeHoverIn(this.config.label);var a={};g(a,this),t.plotEventHandler(null,e,"DataPlotRollOver",a)},p=function(e){var t=this.getFromEnv("chart");this.getLinkedParent().nodeHoverOut(this.config.label);var a={};g(a,this),t.plotEventHandler(null,e,"DataPlotRollOut",a)},g=function(e,t){var a,o=t.getLinkedParent();for(e.label=t.config.label,e.color=t.config.color,e.alpha=t.config.alpha,e.links={},e.value=t.config.total,e.displayValue=t.config.formattedValue,e.nodeValue=t.config.nodevalue,e.nodeDataValue=t.config.nodedatavalue,e.plotFillColor=t.config.plotfillcolor,e.toolText=t.config.tooltext,a=0;a<t.config.linkedLinks.length;a++){var r,i=t.config.linkedLinks[a],n=o.config.links[i],l=[],c=e.label,d={},h={};d[c]=n[c],h[r=i.replace(c,"").replace(",","")]=n[r],l.push(d),r!==c&&n[r]!==s.UNDEF&&l.push(h),e.links[i]=l}},f=function(e){function t(t){var a;return(a=e.call(this,t)||this).addEventListener("fc-click",h),a.addEventListener("fc-mouseover",u),a.addEventListener("fc-mouseout",p),a}(0,r["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.styles={fill:"#ff0000",stroke:"#ff0000","fill-alpha":.7}},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t),Object.assign(this.config,t);this.config.formattedValue=this.getFromEnv("number-formatter").dataLabels(this.config.total),this.config.formattedNodeDataValue=this.getFromEnv("number-formatter").dataLabels(this.config.nodedatavalue)},a.setDimension=function(e){Object.assign(this.config,e)},a.allocatePosition=function(){var e,t,a,o,r,i=this.config,h=i.label,u=this.getFromEnv("chartConfig"),p=u.canvasHeight,g=u.canvasWidth,f=u.cx,m=u.cy,v=u.style,b=i.labelPosition,x=i.outerRadius+i.nodeLabelGap,k=this.getFromEnv("smartLabel"),y=(0,l.normaliseAngle)(i.startingAngle),C=(0,l.normaliseAngle)(i.endingAngle),w={};switch(i.style["font-size"]=a=this.computeFontSize(v.inCanfontSizeWithUnit),o=(0,s.setLineHeight)({fontSize:a}).replace(/px/gi,s.BLANKSTRING),k.setStyle(i.style),k.useEllipsesOnOverflow(this.getFromEnv("chartConfig").useEllipsesOnOverflow),b){case"tangential":var A,S,N=(y+C)/2%360,L=0;switch(r=(0,n.polarToCartesian)(x,N,!1),(0,c.getQuadrant)((0,n.deg2Rad)(N))){case 0:A=g/2,S=p/2,e=Math.tan((0,n.deg2Rad)(360-N)),L=Math.abs(A*e)<=S?(0,l.getCartesianDistance)(r.x+f,r.y+m,f+A,m-A*e):(0,l.getCartesianDistance)(r.x+f,r.y+m,f-S/e,m+S);break;case 1:A=-1*g/2,S=p/2,e=Math.tan((0,n.deg2Rad)(180+N)),L=Math.abs(A*e)<=Math.abs(S)?(0,l.getCartesianDistance)(r.x+f,r.y+m,f+A,m+A*e):(0,l.getCartesianDistance)(r.x+f,r.y+m,f+S/e,m+S);break;case 2:A=-1*g/2,S=p/2*-1,e=Math.tan((0,n.deg2Rad)(360-N)),L=Math.abs(A*e)<=Math.abs(S)?(0,l.getCartesianDistance)(r.x+f,r.y+m,f+A,m-A*e):(0,l.getCartesianDistance)(r.x+f,r.y+m,f-S/e,m+S);break;case 3:A=g/2,S=p/2*-1,e=Math.tan((0,n.deg2Rad)(-1*N)),L=Math.abs(A*e)<=Math.abs(S)?(0,l.getCartesianDistance)(r.x+f,r.y+m,f+A,m-A*e):(0,l.getCartesianDistance)(r.x+f,r.y+m,f-S/e,m+S)}t=k.getSmartText(h,L,o),w.transform=(0,s.getSuggestiveRotation)((0,l.getTextRotationByQuadrant)(N),r.x,r.y),(0,l.isAngleInLeftHemisphere)(N)&&(w["text-anchor"]="end"),w.x=r.x,w.y=r.y;break;case"outside":var D=(y+C)/2%360,E=(0,n.deg2Rad)(D),T=(0,c.getCleanAngle)(E),F=(0,n.rad2Deg)(T),P=(0,l.isAngleInTopHemisphere)(F),_=(0,l.getArcLength)(x,y,C),V=P?i.startingAngle:i.endingAngle,I=P?i.endingAngle:i.startingAngle;t=k.getSmartText(h,_-4,o),s.isIE11&&(P||(x+=.7*t.height)),w.textpath={path:d(V,I,i.arcAngle,x),startOffset:"50%"},w[s.TEXTANCHOR]=s.MIDDLESTR,w["vertical-align"]=P?"top":"bottom",w.transform=null,w.x=0,w.y=0;break;case"inside":default:var B=(y+C)/2%360,M=(0,n.deg2Rad)(B),O=(0,c.getCleanAngle)(M),R=(0,n.rad2Deg)(O),G=(0,l.isAngleInTopHemisphere)(R),H=(i.outerRadius+i.innerRadius)/2,z=(0,l.getArcLength)(H,y,C),W=G?i.startingAngle:i.endingAngle,U=G?i.endingAngle:i.startingAngle;t=k.getSmartText(h,z-4,o),s.isIE11&&(G?H-=.3*t.height:H+=.3*t.height),w.textpath={path:d(W,U,i.arcAngle,H),startOffset:"50%"},w[s.TEXTANCHOR]=s.MIDDLESTR,w["vertical-align"]=s.MIDDLESTR,w.transform=null,w.x=0,w.y=0}w.fill=(0,s.convertColor)(i.labelColor,100),w.text=t.text,w.cursor=s.POINTER,w["text-anchor"]=w["text-anchor"]||"start",this.config.labelAttrs=w,this.config.path=function(e,t,a,o,r){var i=(0,l.normaliseAngle)(e),c=(0,l.normaliseAngle)(t),d=(0,n.polarToCartesian)(o,i,!1),h=d.x,u=d.y,p=(0,n.polarToCartesian)(o,c,!1),g=p.x,f=p.y,m=(0,n.polarToCartesian)(r,i,!1),v=m.x,b=m.y,x=(0,n.polarToCartesian)(r,c,!1),k=x.x,y=x.y;return h=(0,s.toPrecision)(h,4),u=(0,s.toPrecision)(u,4),g=(0,s.toPrecision)(g,4),f=(0,s.toPrecision)(f,4),v=(0,s.toPrecision)(v,4),b=(0,s.toPrecision)(b,4),k=(0,s.toPrecision)(k,4),y=(0,s.toPrecision)(y,4),[l.M,h,u,l.A,o,o,0,a>180?1:0,1,g,f,l.L,k,y,l.A,r,r,0,a>180?1:0,0,v,b,l.Z]}(i.startingAngle,i.endingAngle,i.arcAngle,i.outerRadius,i.innerRadius),this.config.focussedState.path=this.config.path,this.config.normalState.path=this.config.path,this.config.unfocussedState.path=this.config.path,this.config.deactiveState.path=this.config.path},a.draw=function(){var e,t=this.config,a=this.getFromEnv("chartConfig"),o=t.showToolTip?function(e,t,a){var o,r,i,n,c,d,h,u,p,g=s.isIpad?l.SMALLSQUARE:l.MEDIUMSQUARE,f=[3,133,134,143,144,145],m=t.computeFontSize(a.style.inCanfontSizeWithUnit),v=t.getLinkedParent(),b=a&&a.drawcustomlegendicon,x=t.getFromEnv("legend"),k=[],y=[],C=b&&x&&x.config&&x.config.isActive?x.getItem(v.config.legendItemMap[t.config.label]):null,w=C&&C.getGraphicalElement();if(h=s.BLANKSTRING,C){if(o=(c=w&&w.legendItemSymbol)&&c.attrs.path.split(/(?=[LMCA])/),n=c&&c.node.getBBox(),o&&o.length)for(r=0;r<o.length;r++)y.push(o[r][0]),o[r]=o[r].substring(1,o[r].length),r===o.length-1&&(o[r]=o[r].substring(0,o[r].length-1)),k[r]=o[r].split(",");if(k&&k.length)for(r=0;r<k.length;r++){if(k[r].length)for(i=0;i<k[r].length;i++)k[r][i]=Number(k[r][i]),"A"!==y[r]?0===i?k[r][i]=k[r][i]-n.x:1===i&&(k[r][i]=k[r][i]-n.y):"A"===y[r]&&(5===i?k[r][i]=k[r][i]-n.x:6===i&&(k[r][i]=k[r][i]-n.y));h+=y[r]+k[r].toString()}h+="Z"}return u={label:e.label,value:e.total,nodeValue:e.total,nodeDataValue:e.formattedValue,plotFillColor:e.color,plotFillAlpha:e.alpha,plotIdentifier:C?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n      <path d= "+h+" fill = "+w.legendItemSymbol.node.getAttribute("fill")+" stroke = "+w.legendItemSymbol.node.getAttribute("stroke")+"\n      stroke-opacity = "+w.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+w.legendItemSymbol.node.getAttribute("fill-opacity")+" \n      stroke-width = "+w.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+w.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n    </svg>":"<span style='color: "+e.color+";'>"+g+"&nbsp;</span>"},p=(0,s.parseTooltext)(e.tooltext,f,u,{label:e.label,value:e.formattedValue,nodeValue:e.total,nodeDataValue:e.formattedValue,plotFillColor:e.color,plotFillAlpha:e.alpha,plotIdentifier:C?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n        <path d= "+h+" fill = "+w.legendItemSymbol.node.getAttribute("fill")+" stroke = "+w.legendItemSymbol.node.getAttribute("stroke")+"\n        stroke-opacity = "+w.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+w.legendItemSymbol.node.getAttribute("fill-opacity")+" \n        stroke-width = "+w.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+w.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n      </svg>":"<span style='color: "+e.color+";'>"+g+"&nbsp;</span>"}),d=(0,s.parseTooltext)(e.tooltext,f,u,{label:e.label,value:e.formattedValue,nodeValue:e.total,nodeDataValue:e.formattedValue,plotFillColor:e.color,plotFillAlpha:e.alpha,plotIdentifier:C?"<svg height= "+n.height+" width = "+n.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n        <path d= "+h+" fill = "+w.legendItemSymbol.node.getAttribute("fill")+" stroke = "+w.legendItemSymbol.node.getAttribute("stroke")+"\n        stroke-opacity = "+w.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+w.legendItemSymbol.node.getAttribute("fill-opacity")+" \n        stroke-width = "+w.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+w.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n      </svg>":"<span style='color: "+e.color+";'>"+g+"&nbsp;</span>"}),e.setToolText=p,e.setPlotTooltext=e.setToolText?e.setToolText:d,e.tooltext?"<div style='padding: 2px; vertical-align: middle; font-size: "+m+"px;'>\n        <span style='color: "+e.color+";'>\n            "+g+"\n        </span>\n        "+e.setPlotTooltext+"\n      </div>":"<div style='padding: 2px; vertical-align: middle; font-size: "+m+"px;'>\n          <span style='color: "+e.color+";'>\n              "+g+"\n          </span>\n          "+(e.label+e.toolTipSepChar)+"\n          &nbsp;\n          "+e.formattedValue+"\n        </div>"}(t,this,a):s.BLANKSTRING;(e=this.config.active?t.hovered?t.focussedState:t.unfocussed?t.unfocussedState:t.normalState:t.deactiveState).cursor=s.POINTER,this.addGraphicalElement({el:"group",container:{id:"node-container",isParent:!0},tooltext:o,component:this,label:"text-path-container",id:"text-path-container",attr:{name:"text-path-container"}}),this.addGraphicalElement({el:"path",label:"node",tooltext:o,container:{id:"text-path-container"},attr:e,component:this},!0),t.showLabel&&this.addGraphicalElement({el:"text",label:"node-label",container:{id:"text-path-container"},attr:t.labelAttrs,outlineText:!!a.textOutline,css:{},tooltext:o,component:this},!0)},a._manageSpace=function(e){var t,a=this.config,o=this.getFromEnv("smartLabel");return o.setStyle(a.style),t=o.getOriSize(a.label),a.showLabel?"tangential"===a.labelPosition?t.width>e.maxSpace?o.getSmartText(a.label,e.maxSpace,t.height).width:t.width:"outside"===a.labelPosition?t.height:0:0},a.getName=function(){return"node"},a.getType=function(){return"dataset"},t}(i.SmartRenderer);t["default"]=f},1078:function(e,t,a){"use strict";t.__esModule=!0,t.normaliseAngle=function(e){return e-90},t.getArcLength=function(e,t,a){return n*e*Math.abs(a-t)/360},t.getTextRotationByQuadrant=function(e){var t=e;s(t)&&(t-=180);return t},t.isAngleInLeftHemisphere=s,t.isAngleInTopHemisphere=function(e){return Math.abs(e)>180&&Math.abs(e)<360},t.getCartesianDistance=function(e,t,a,o){return Math.sqrt((a-e)*(a-e)+(o-t)*(o-t))},t.MEDIUMSQUARE=t.SMALLSQUARE=t.HALF_PI=t.PI2=t.COS=t.SIN=t.PI=t.C=t.Z=t.L=t.A=t.M=void 0;var o=Math.PI,r=Math.sin,i=Math.cos,n=2*o,l=o/2;function s(e){return Math.abs(e)>90&&Math.abs(e)<270}t.MEDIUMSQUARE="&#9724;",t.SMALLSQUARE="&#9632;",t.HALF_PI=l,t.PI2=n,t.COS=i,t.SIN=r,t.PI=o,t.C="C",t.Z="Z",t.L="L",t.A="A",t.M="M"},1079:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t=e.config.links;for(var a in t)t.hasOwnProperty(a)&&t[a].visible&&e.attachChild(r["default"],"ribbon",a).configure(t[a])};var r=o(a(1080))},1080:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(240),n=a(1062),l=a(224),s=a(1078),c=function(e){return e-s.HALF_PI},d=function(){var e=this.getFromEnv("chart");this.getLinkedParent().linkHoverIn(this.config.key);var t={};p(t,this),e.fireChartInstanceEvent("linkRollOver",t)},h=function(){var e=this.getFromEnv("chart");this.getLinkedParent().linkHoverOut(this.config.key);var t={};p(t,this),e.fireChartInstanceEvent("linkRollOut",t)},u=function(){var e=this.getFromEnv("chart"),t={};p(t,this),e.fireChartInstanceEvent("linkClick",t)},p=function(e,t){var a;for(e.dominantFlowValue=t.config[t.config.dominantNode[0]],a=0;a<t.config.linkedNodes.length&&t.config.linkedNodes[a]===t.config.dominantNode[0];a++);e.subservientFlowValue=t.config[t.config.linkedNodes[a]],e.linkedNodes=t.config.linkedNodes,e.dominantFlowValue===e.subservientFlowValue?e.color=t.config.rawColor||(0,l.rgbaToHex)(t.config.normalState.fill):e.color=(0,l.rgbaToHex)(t.config.normalState.fill),e.alpha=t.config.alpha},g=function(e){return 0===e.length?[]:1===e.length?[e[0]]:e.filter((function(t,a){return e.indexOf(t)===a}))},f=function(e,t){var a,o=e,r=t,i=[];if(!r.length)return[];if(1===r.length)return o[r[0]];for(a=0;a<r.length;a++)i.push(o[r[a]]);return i},m=function(e,t,a,o){var r,i,n,s=l.BLANKSTRING;if(""!==o&&a&&a.length){if(1===a.length)return"<svg height= "+(i=(r=a[0].getGraphicalElement()).legendItemSymbol.node.getBBox()).height+" width = "+i.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n        <path d= "+o+" fill = "+r.legendItemSymbol.node.getAttribute("fill")+" stroke = "+r.legendItemSymbol.node.getAttribute("stroke")+"\n        stroke-opacity = "+r.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+r.legendItemSymbol.node.getAttribute("fill-opacity")+" \n        stroke-width = "+r.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+r.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n      </svg>";for(n=0;n<a.length;n++)s+="<svg height= "+(i=(r=a[n].getGraphicalElement()).legendItemSymbol.node.getBBox()).height+" width = "+i.width+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n          <path d= "+o+" fill = "+r.legendItemSymbol.node.getAttribute("fill")+" stroke = "+r.legendItemSymbol.node.getAttribute("stroke")+"\n          stroke-opacity = "+r.legendItemSymbol.node.getAttribute("stroke-opacity")+" fill-opacity = "+r.legendItemSymbol.node.getAttribute("fill-opacity")+" \n          stroke-width = "+r.legendItemSymbol.node.getAttribute("stroke-width")+" stroke-linecap = "+r.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n        </svg>"}else if(e.length)for(n=0;n<e.length;n++)s+="\n            <span style='color: "+e[n]+";'>\n              "+t+"\n            </span>";return s},v=function(e,t,a){var o,r=[];if(a&&a.length){if(1===a.length)return[e.getItem(t.config.legendItemMap[a[0]])];for(o=0;o<a.length;o++)r.push(e.getItem(t.config.legendItemMap[a[o]]))}return r},b=function(e){function t(t){var a;return(a=e.call(this,t)||this).addEventListener("fc-mouseover",d),a.addEventListener("fc-mouseout",h),a.addEventListener("fc-click",u),a}(0,r["default"])(t,e);var a=t.prototype;return a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t),Object.assign(this.config,t)},a.setDimension=function(e){this.config.radius=e.radius},a.allocatePosition=function(){var e,t,a,o,r=this.config;r.path=(e=r.points,t=r.radius,a=0,o=e.map((function(o,r){var i=(0,n.deg2Rad)(o),d=(0,n.polarToCartesian)(t,c((0,n.deg2Rad)(a))+i),h=d.x,u=d.y,p=.6,g=Math.abs((0,n.deg2Rad)(e[3-r])-i),f=Math.abs((0,n.deg2Rad)(e[(r+1)%4])-i);return g>s.PI&&(g=s.PI2-g),g*t<t&&(p*=g),{x:h=(0,l.toPrecision)(h,4),y:u=(0,l.toPrecision)(u,4),cpX:(1-p)*h,cpY:(1-p)*u,arc:f}})),[s.M,o[0].x,o[0].y,s.A,t,t,0,o[0].arc>s.PI?1:0,1,o[1].x,o[1].y,s.C,o[1].cpX,o[1].cpY,o[2].cpX,o[2].cpY,o[2].x,o[2].y,s.A,t,t,0,o[2].arc>s.PI?1:0,1,o[3].x,o[3].y,s.C,o[3].cpX,o[3].cpY,o[0].cpX,o[0].cpY,o[0].x,o[0].y].join(" ")),r.ribbonAttrs=r.hovered?r.focussedState:r.unfocussed?r.unfocussedState:r.normalState,r.ribbonAttrs.path=r.path,r.ribbonAttrs["stroke-width"]=(r.showBorder?r.borderThickness:0)||0},a.draw=function(){var e=this.getFromEnv("chart").config,t=e.canvasHeight,a=e.canvasWidth,o=e.canvasLeft+a/2,r=e.canvasTop+t/2,i=e.width,d=e.height,h=e.ribbonRadius,u=this.config,p=u.angles,b=u.showToolTip?function(e,t,a,o){var r,i,n,c,d,h,u,p,b,x,k=l.isIpad?s.SMALLSQUARE:s.MEDIUMSQUARE,y=l.BLANKSTRING,C=t&&t.drawcustomlegendicon,w=o.getLinkedParent(),A=o.getFromEnv("legend"),S=[],N=[],L=C&&A&&A.config&&A.config.isActive?v(A,w,g(e.dominantNode)):null,D=C&&A&&A.config&&A.config.isActive?v(A,w,g(e.subservientNode)):null;if(p=l.BLANKSTRING,L&&L.length){if(i=(c=(n=L&&L[0]&&L[0].getGraphicalElement())&&n.legendItemSymbol)&&c.attrs.path.split(/(?=[LMCA])/),u=c&&c.node.getBBox(),i&&i.length)for(d=0;d<i.length;d++)N.push(i[d][0]),i[d]=i[d].substring(1,i[d].length),d===i.length-1&&(i[d]=i[d].substring(0,i[d].length-1)),S[d]=i[d].split(",");if(S&&S.length)for(d=0;d<S.length;d++){if(S[d].length)for(h=0;h<S[d].length;h++)S[d][h]=Number(S[d][h]),"A"!==N[d]?0===h?S[d][h]=S[d][h]-u.x:1===h&&(S[d][h]=S[d][h]-u.y):"A"===N[d]&&(5===h?S[d][h]=S[d][h]-u.x:6===h&&(S[d][h]=S[d][h]-u.y));p+=N[d]+S[d].toString()}p+="Z"}for(r in(b={toolText:e.tooltext,dominantNode:g(e.dominantNode),subservientNode:g(e.subservientNode),dominantFlowDataValue:g(e.dominantFlowDataValue),subservientFlowDataValue:g(e.subservientFlowDataValue)}).dominantFlowValue=f(e,b.dominantNode),b.subservientFlowValue=f(e,b.subservientNode),b.dominantPlotIdentifier=m(g(e.dominantNodeColor),k,L,p),b.subservientPlotIdentifier=m(g(e.subservientNodeColor),k,D,p),x=(0,l.parseTooltext)(e.tooltext,[135,136,137,138,139,140,146,147],b,e),e.setLinkToolText=x,e.tooltip)e.tooltip.hasOwnProperty(r)&&(y+="\n          <span style='color: "+e.tooltip[r].color+";'>\n            "+k+"\n          </span>\n          "+(r+e.toolTipSepChar)+"\n          "+(e.showLinkValueOnHover?" &nbsp;":"")+"\n          "+(e.showLinkValueOnHover?e.tooltip[r].value:"")+"\n        <br>");return e.tooltext?"<div style='padding: 2px; vertical-align: middle; font-size: "+a+"px;'>\n        "+e.setLinkToolText+"\n      </div>":"<div style='padding: 2px; vertical-align: middle; font-size: "+a+"px;'>\n          "+y+"\n        </div>"}(u,e,e.style.baseFontSize,this):l.BLANKSTRING,x=(0,n.polarToCartesian)(h,c((0,n.deg2Rad)(p[0]))),k=x.x,y=x.y,C=(0,n.polarToCartesian)(h,c((0,n.deg2Rad)(p[3]))),w=C.x,A=C.y;u.dominantNode.length>1&&u.rawColor&&(u.ribbonAttrs.fill=(0,l.toRaphaelColor)({color:u.rawColor[0]+","+u.rawColor[1],alpha:u.hovered?u.hoverAlpha:u.unfocussed?u.unfocussedAlpha:u.alpha,x1:(k+o)/i,y1:(y+r)/d,x2:(w+o)/i,y2:(A+r)/d}),u.ribbonAttrs.stroke=(0,l.toRaphaelColor)({color:u.rawColor[0]+","+u.rawColor[1],alpha:u.hovered?u.hoveredAlpha:u.unfocussed?u.unfocussedAlpha:u.borderAlpha,x1:(k+o)/i,y1:(y+r)/d,x2:(w+o)/i,y2:(A+r)/d})),this.addGraphicalElement({el:"path",label:"ribbon",tooltext:b,attr:u.ribbonAttrs,container:{id:"link-container",isParent:!0},component:this})},a.getName=function(){return"ribbon"},a.getType=function(){return"dataset"},t}(i.SmartRenderer);t["default"]=b},1081:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(967))["default"];t["default"]=r},1083:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(408))["default"];t["default"]=r},919:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(720));t.Spline=r["default"];var i=o(a(920));t.Logmscolumn2d=i["default"];var n=o(a(925));t.Logmsline=n["default"];var l=o(a(927));t.LogStackedColumn2d=l["default"];var s=o(a(723));t.Splinearea=s["default"];var c=o(a(725));t.Msspline=c["default"];var d=o(a(728));t.MSSplineDy=d["default"];var h=o(a(730));t.Mssplinearea=h["default"];var u=o(a(929));t.Errorbar2d=u["default"];var p=o(a(933));t.Errorline=p["default"];var g=o(a(938));t.Errorscatter=g["default"];var f=o(a(943));t.Inversemsarea=f["default"];var m=o(a(945));t.Inversemscolumn2d=m["default"];var v=o(a(947));t.Inversemsline=v["default"];var b=o(a(949));t.Dragcolumn2d=b["default"];var x=o(a(961));t.Dragline=x["default"];var k=o(a(968));t.Kagi=k["default"];var y=o(a(975));t.WaterFall2D=y["default"];var C=o(a(976));t.SelectScatter=C["default"];var w=o(a(980));t.MultilevelPie=w["default"];var A=o(a(985));t.Sunburst=A["default"];var S=o(a(990));t.MultiAxisLine=S["default"];var N=o(a(998));t.MSStepLine=N["default"];var L=o(a(1002));t.DragNode=L["default"];var D=o(a(1013));t.CandleStick=D["default"];var E=o(a(1026));t.BoxAndWhisker2D=E["default"];var T=o(a(1035));t.Sankey=T["default"];var F=o(a(1046));t.HeatMap=F["default"];var P=o(a(1058));t.Radar=P["default"];var _=o(a(1071));t.Chord=_["default"];var V=o(a(1081));t.DragArea=V["default"];var I=o(a(1082)),B=o(a(1083)),M={name:"powercharts",type:"package",requiresFusionCharts:!0,extension:function(e){e.addDep(I["default"]),e.addDep(B["default"]),e.addDep(r["default"]),e.addDep(i["default"]),e.addDep(l["default"]),e.addDep(n["default"]),e.addDep(s["default"]),e.addDep(d["default"]),e.addDep(c["default"]),e.addDep(h["default"]),e.addDep(u["default"]),e.addDep(p["default"]),e.addDep(g["default"]),e.addDep(f["default"]),e.addDep(m["default"]),e.addDep(v["default"]),e.addDep(b["default"]),e.addDep(x["default"]),e.addDep(k["default"]),e.addDep(y["default"]),e.addDep(C["default"]),e.addDep(w["default"]),e.addDep(A["default"]),e.addDep(S["default"]),e.addDep(N["default"]),e.addDep(L["default"]),e.addDep(D["default"]),e.addDep(E["default"]),e.addDep(T["default"]),e.addDep(F["default"]),e.addDep(P["default"]),e.addDep(_["default"]),e.addDep(V["default"])}};t["default"]=M},920:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(921))["default"];t["default"]=r},921:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(922)),n=o(a(628)),l=o(a(538)),s=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e),t.getName=function(){return"LogMSColumn2d"};var a=t.prototype;return a.getName=function(){return"LogMSColumn2d"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="column",t.enablemousetracking=!0},a.getDSGroupdef=function(){return n["default"]},a.getDSdef=function(){return l["default"]},t}(i["default"]);t["default"]=s},922:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=o(a(923)),l=a(224),s=o(a(366)),c=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("axis",n["default"],["canvas"]),t}(0,r["default"])(t,e),t.getName=function(){return"MsLog"};var a=t.prototype;return a._feedAxesRawData=function(){var e,t,a=this.getFromEnv("dataSource"),o=this.getFromEnv("chart-attrib");return e=this.getSpecificxAxisConf(),"1"===(t=this.getSpecificyAxisConf()).base&&(t.base=10,t.logBase=10),t.minorDivlinecolor=(0,l.pluck)(o.minordivlinecolor,t.divLineColor),t.minorDivLineThickness=(0,l.pluck)(o.minordivlinethickness,1),t.minorDivLineAlpha=(0,l.pluck)(o.minordivlinealpha,t.divLineAlpha/2),e.vtrendlines=a.vtrendlines,t.trendlines=a.trendlines,{yAxisConf:[t],xAxisConf:[e]}},a.getSpecificxAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.getBasexAxisConf();return t.showZeroPlane=e.showvzeroplane,t.zeroPlaneThickness=e.vzeroplanethickness,t.zeroPlaneAlpha=e.vzeroplanealpha,t.showAxisLine=(0,l.pluckNumber)(e.showxaxisline,e.showaxislines,e.drawAxisLines,0),t.axisLineColor=(0,l.pluck)(e.xaxislinecolor,e.axislinecolor,"#000000"),t.isReverse=!1,t.showAlternateGridColor=(0,l.pluckNumber)(e.showalternatevgridcolor,0),t.numDivLines=e.numvdivlines,t.maxLabelHeight=e.maxlabelheight,t.axisName=e.xaxisname,t.setAdaptiveMin=e.setadaptivexmin,t.showLimits=e.showvlimits,t.showDivLineValues=(0,l.pluckNumber)(e.showvdivlinevalues,e.showvdivlinevalues),t},a.getSpecificyAxisConf=function(){var e=this.getFromEnv("chart-attrib"),t=this.config.is3D?l.chartPaletteStr.chart3D:l.chartPaletteStr.chart2D,a=!!(0,l.pluckNumber)(e.invertyaxis,0),o=this.getFromEnv("color-manager"),r=(0,l.pluckFontSizeMaintainUnit)(e.outcnvbasefontsize,e.basefontsize,10);return{isVertical:!0,isReverse:!a,isOpposit:(0,s["default"])(e.yaxisposition,"right"),outCanfontFamily:(0,l.pluck)(e.outcnvbasefont,e.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(r),outCanfontSizeWithUnit:r,outCancolor:(0,l.pluck)(e.outcnvbasefontcolor,e.basefontcolor,o.getColor(t.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:e.yaxisnamepadding,axisValuePadding:e.yaxisvaluespadding,axisNameFont:e.yaxisnamefont,axisNameFontSize:this.computeFontSize(e.yaxisnamefontsize),axisNameFontSizeWithUnit:e.yaxisnamefontsize,axisNameFontColor:e.yaxisnamefontcolor,axisNameFontBold:e.yaxisnamefontbold,axisNameFontItalic:e.yaxisnamefontitalic,axisNameBgColor:e.yaxisnamebgcolor,axisNameBorderColor:e.yaxisnamebordercolor,axisNameAlpha:e.yaxisnamealpha,axisNameFontAlpha:e.yaxisnamefontalpha,axisNameBgAlpha:e.yaxisnamebgalpha,axisNameBorderAlpha:e.yaxisnameborderalpha,axisNameBorderPadding:e.yaxisnameborderpadding,axisNameBorderRadius:e.yaxisnameborderradius,axisNameBorderThickness:e.yaxisnameborderthickness,axisNameBorderDashed:e.yaxisnameborderdashed,axisNameBorderDashLen:e.yaxisnameborderdashlen,axisNameBorderDashGap:e.yaxisnameborderdashgap,axisNameWidth:e.yaxisnamewidth,useEllipsesWhenOverflow:e.useellipseswhenoverflow,rotateAxisName:(0,l.pluckNumber)(e.rotateyaxisname,1),axisName:e.yaxisname,divLineColor:(0,l.pluck)(e.divlinecolor,o.getColor(t.divLineColor)),divLineAlpha:(0,l.pluck)(e.divlinealpha,o.getColor("divLineAlpha")),divLineThickness:(0,l.pluckNumber)(e.divlinethickness,2),divLineIsDashed:Boolean((0,l.pluckNumber)(e.divlinedashed,e.divlineisdashed,0)),divLineDashLen:(0,l.pluckNumber)(e.divlinedashlen,4),divLineDashGap:(0,l.pluckNumber)(e.divlinedashgap,2),showAlternateGridColor:(0,l.pluckNumber)(e.showalternatehgridcolor,1),alternateGridColor:(0,l.pluck)(e.alternatehgridcolor,o.getColor("altHGridColor")),alternateGridAlpha:(0,l.pluck)(e.alternatehgridalpha,o.getColor("altHGridAlpha")),numDivLines:e.numdivlines,axisMinValue:e.yaxisminvalue,axisMaxValue:e.yaxismaxvalue,setAdaptiveMin:e.setadaptiveymin,adjustDiv:e.adjustdiv,labelStep:e.yaxisvaluesstep,showAxisValues:(0,l.pluckNumber)(e.showyaxisvalues,e.showyaxisvalue),showLimits:(0,l.pluckNumber)(e.showyaxislimits,e.showlimits,this.showLimits),showDivLineValues:(0,l.pluckNumber)(e.showdivlinevalues,e.showdivlinevalue),showZeroPlane:e.showzeroplane,zeroPlaneColor:e.zeroplanecolor,zeroPlaneThickness:e.zeroplanethickness,zeroPlaneAlpha:e.zeroplanealpha,showZeroPlaneValue:e.showzeroplanevalue,trendlineColor:e.trendlinecolor,trendlineToolText:e.trendlinetooltext,trendlineThickness:e.trendlinethickness,trendlineAlpha:e.trendlinealpha,showTrendlinesOnTop:e.showtrendlinesontop,showAxisLine:(0,l.pluckNumber)(e.showyaxisline,e.showaxislines,e.drawAxisLines,0),axisLineThickness:(0,l.pluckNumber)(e.yaxislinethickness,e.axislinethickness,1),axisLineAlpha:(0,l.pluckNumber)(e.yaxislinealpha,e.axislinealpha,100),base:e.base,logBase:e.logbase,axisLineColor:(0,l.pluck)(e.yaxislinecolor,e.axislinecolor,"#000000"),showMinorDivLineValues:(0,l.pluckNumber)(e.showminordivlinevalues,0),numMinorDivLines:e.numminordivlines,labelFont:e.yaxisvaluefont,labelFontSize:this.computeFontSize(e.yaxisvaluefontsize),labelFontSizeWithUnit:e.yaxisvaluefontsize,labelFontColor:e.yaxisvaluefontcolor,labelAlpha:e.yaxisvaluealpha,labelFontBold:e.yaxisvaluefontbold,labelFontItalic:e.yaxisvaluefontitalic,labelBdrColor:e.yaxisvaluebordercolor,labelBdrAlpha:e.yaxisvalueborderalpha,labelBgAlpha:e.yaxisvaluebgalpha,labelLink:e.yaxisvaluelink,labelBgColor:e.yaxisvaluebgcolor,labelBdrThickness:e.yaxisvalueborderthickness,labelBdrPadding:e.yaxisvalueborderpadding,labelBdrRadius:e.yaxisvalueborderradius,labelBdrDashed:e.yaxisvalueborderdashed,labelBdrDashLen:e.yaxisvalueborderdashlen,labelBdrDashGap:e.yaxisvalueborderdashgap}},t}(i["default"]);t["default"]=c},923:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o=e.getChildren("canvas")[0],l=o.getChildren("axisRefVisualCartesian")[0],s={zoomable:!0,pannable:!0},c=e._feedAxesRawData(),d=function(){return l.asyncDraw()};(0,r.componentFactory)(e,i["default"],"yAxis",1,c.yAxisConf),(0,r.componentFactory)(e,n["default"],"xAxis",1,c.xAxisConf),t=e.getChildren("yAxis")[0],a=e.getChildren("xAxis")[0],t.setLinkedItem("canvas",o),a.setLinkedItem("canvas",o),l.setLinkedItem(t.getId(),t),l.setLinkedItem(a.getId(),a),l.addExtEventListener("visiblerangeset",d,a),l.addExtEventListener("visiblerangeset",d,t),o.attachAxis(a,!1,e.zoomX?s:{}),o.attachAxis(t,!0,e.zoomY?s:{}),e._setCategories()};var r=a(224),i=o(a(924)),n=o(a(528))},924:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(797)),n=o(a(513)),l=o(a(482)),s=o(a(510)),c=a(224),d=a(516),h=function(e){return null!==e&&e!==c.UNDEF&&""!==e&&!isNaN(e)},u={wrtVisible:!0},p=c.preDefStr.POSITION_START,g=c.preDefStr.POSITION_TOP,f=c.preDefStr.POSITION_BOTTOM,m=c.preDefStr.POSITION_END,v=function(e,t){if(void 0===e&&(e=[]),void 0===t&&(t=[]),0===e.length)return[];var a=e.length-1,o=t.length-1,r=[e[a]];for(a--;a>=0;)t[o]>e[a]?(r.push(t[o]),o--):(r.push(e[a]),a--);return r},b=function(e){function t(){var t;return(t=e.call(this)||this).config.scale=new i["default"],t.config.labelMap=[],t}(0,r["default"])(t,e);var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.base=10,t.showMinorDivLineValues=1,t.numMinorDivLines=c.UNDEF},a.getName=function(){return"log"},a.configureAttributes=function(t){var a,o=this.config,r=this.getFromEnv("number-formatter"),i=this.getFromEnv("color-manager");e.prototype.configureAttributes.call(this,t),a=o.rawAttr,o.minorDivlinecolor=(0,c.convertColor)((0,c.pluck)(a.minorDivlinecolor,i.getColor("divLineColor")),(0,c.pluckNumber)(a.minorDivLineAlpha,i.getColor("divLineAlpha")/2)),o.axisMinValue=r.getCleanValue(a.axisMinValue),o.axisMaxValue=r.getCleanValue(a.axisMaxValue),o.minorTicks=[],o.axisMinValue<=0&&(o.axisMinValue=c.UNDEF),o.axisMaxValue<=0&&(o.axisMaxValue=c.UNDEF),this.getScale().setBase(o.base),o.minorDivLineThickness=(0,c.pluckNumber)(a.minorDivLineThickness,1),o.band.isDraw=0},a.generateTicks=function(){var e=this.getScale().ticks();return this.config._allTicks=e.slice(),e},a.generateMinorTicks=function(){return this.getScale().minorTicks(this.config.numMinorDivLines)},a._setAxisRange=function(e){var t=e.min,a=void 0===t?.1:t,o=e.max,r=void 0===o?1:o,i=this.getScale().setDomain([a,r]).nice(),n=this.config,l=n.axisRange;n.ticks=this.generateTicks(),n.minorTicks=this.generateMinorTicks();var s=i.getDomain();a=s[0],r=s[1],l.max=r,l.min=a,this.setVisibleConfig(a,r)},a.setDataLimit=function(e,t){var a,o,r=e,i=t,n=this.config,s=n.axisMaxValue,c=n.axisMinValue;h(c)&&Number(c)<=i&&(i=c),h(s)&&Number(s)>=r&&(r=s),0===i&&(i=1),0===r&&(r=n.base);var d=this.getTrendLineLimits();a=d[0],o=d[1];var u=(0,l["default"])([a,o,i,r],(function(e){return Number(e)}));i=u[0],r=u[1],this._setAxisRange({min:i,max:r})},a._parseLabel=function(){var e,t,a,o,r,i,n,l,s,d,h,b,x,k,y,C,w=this.config,A=this.getFromEnv("chart").config,S=w.axisRange,N=w.isOpposit,L=w.labels,D=L.style,E=w.isVertical,T=S.max,F=S.min,P=A.canvasBottom,_=A.canvasLeft,V=A.canvasRight,I=A.canvasTop,B=w.labelPadding,M=this.getFromEnv("number-formatter"),O=w.labelMaxH,R=w.labelMaxW,G=w.axisStartPosition,H=this.components,z=w.minorTicks;if(D.lineHeight&&-1!==(i=D.lineHeight).indexOf("px")&&(i=i.replace("px",""),i=parseFloat(i)),w.labels.isDraw)for(C=1!==this.getZoom(),y=H.labels,e=w.labels.step?S.tickInterval*w.labels.step:S.tickInterval,r=w.labels.rotation,o=this.getVisibleConfig(),H.labelIndexArr=[],w.allTicks=s=v(w.ticks,w.minorTicks),k=E?O:R,d=s.length,t=0;t<d;t++)if(h=s[t],b=this.getPixel(h,u),(!(z.indexOf(h)>=0)||w.showMinorDivLineValues)&&!(x&&b>x-k&&b<x+k)&&(!C||!(h<o.minValue||h>o.maxValue))&&(w.labels.drawNormalVal||w.labels.drawLimitVal&&(h===F||h===T))&&(w.labels.drawNormalVal||h===F||h===T)&&(w.labels.drawLimitVal||h!==F&&h!==T)&&(0!==w.showZeroPlaneValue||0!==w.showZeroPlane||0!==h)){if(1===w.showZeroPlane&&1===w.showZeroPlaneValue&&(h<0&&h+e>0||h>0&&h-e<0))if(E){if(b+O>=this.getPixel(0,u)&&this.getPixel(0,u)>=b-O)continue}else if(b+R>=this.getPixel(0,u)&&this.getPixel(0,u)>=b-R)continue;l={fill:D.color,"font-size":D.fontSize,cursor:D.labelLink?"pointer":""},E?(a=""+(w.numberFormatterFn?M[w.numberFormatterFn]:w.isPercent?M.percentValue:M.yAxis).call(M,h),n=w.hasCategory&&w.categories.category[t].labelPadding||0,l["text-anchor"]=N?p:m,l.text=a,l.x=N?(G||V)+B:(G||_)-B,l.y=n?b+n:b,x=l.y):(a=""+(w.numberFormatterFn?M[w.numberFormatterFn]:w.isPercent?M.percentValue:M.xAxis).call(M,h),n=w.hasCategory&&Number(w.categories.category[t].labelPadding)||0,l.text=a,l.x=b,l.y=N?(G||I)-B:(G||P)+B,n&&(l.y+=n),r?(l["text-anchor"]=N?p:m,l["vertical-align"]="middle"):l["vertical-align"]=N?f:g,x=l.x),L.shiftX&&(l.x+=L.shiftX),L.shiftY&&(l.y+=L.shiftY),l.transform=(0,c.getSuggestiveRotation)(r,l.x,l.y),H.labelIndexArr.push(t),y[t]=y[t]||{config:{props:{label:{}}}},l["text-bound"]=void 0===h?[]:[(0,c.pluck)(D.backgroundColor,""),(0,c.pluck)(D.borderColor,""),(0,c.pluck)(D.borderThickness,""),(0,c.pluck)(D.borderPadding,0),(0,c.pluck)(D.borderRadius,0),(0,c.pluck)(D.borderDash,"none")],y[t].config.props.label.attr=l,y[t].config.props.label.css=a.css,y[t].config.value=h}},a._drawLabel=function(){var e,t,a,o,r,i,l,s,c,d=this,h=d.config,u=d.getFromEnv("animationManager"),p=d.getFromEnv("chart"),g=h.labels.style,f=h.axisContainer,m=[],v=d.components,b=v.labelIndexArr,x={fontFamily:g.fontFamily,fontSize:g.fontSize,fontWeight:g.fontWeight,fontStyle:g.fontStyle,lineHeight:g.lineHeight},k=function(e){return function(t){p.plotEventHandler(this,t,e)}};if(h.labels.isDraw){for(c=v.labels,f.css(x),l=b.length,t=0;t<l;t++)a=(s=c[e=b[t]].config.value)+"_label",i=d.getGraphicalElement(a),m.push(a),(i=this.addGraphicalElement(a,u.setAnimation({container:f,el:i||"text",attr:c[e].config.props.label.attr,data:{value:s},component:this,label:"text",css:c[e].config.props.label.css}))).on("fc-click",k("dataLabelClick")).hover(k("dataLabelRollOver"),k("dataLabelRollOut")),i.data("eventArgs",{link:g.labelLink,text:c[e].config.props.label.attr.text,index:e});o=(0,n["default"])(h.labelMap,m)}else o=h.labelMap;h.labelMap=m,function(t){for(e=0;e<t.length;++e)(r=d.getGraphicalElement(t[e]))&&d.removeGraphicalElement(r)}(o)},a._getVMaxLabelDimention=function(){var e,t,a,o,r,i,n,l,s=this.config,c=this.getFromEnv("chart"),d=this.getFromEnv("smartLabel"),h=this.getFromEnv("number-formatter"),u=s.labels.style,p=0;for(d.useEllipsesOnOverflow(c.config.useEllipsesWhenOverflow),d.setStyle({fontSize:u.fontSize,fontFamily:u.fontFamily,lineHeight:u.lineHeight,fontWeight:u.fontWeight}),n=s.isPercent?h.percentValue:h.xAxis,s.allTicks=e=v(s.ticks,s.minorTicks),t=e.length,o=0;o<t;o++)l=e[o],r=""+n.call(h,l),i=d.getOriSize(r),this.components.labels[o]={config:{width:i.width,height:i.height,props:{label:{}}}},r.length>p&&(a=i,p=r.length);return a},a._getHMaxLabelDimention=function(){return this._getVMaxLabelDimention()},a.getCleanValue=function(e){var t=e,a=null;return(t=Math.abs(t))>0&&(a=this.getFromEnv("number-formatter").getCleanValue(t)),a},t}(s["default"]);b.prototype.getTrendLineLimits=d.getTrendLineLimits;var x=b;t["default"]=x},925:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(926))["default"];t["default"]=r},926:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(922)),n=o(a(555)),l=a(673),s=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t}(0,r["default"])(t,e),t.getName=function(){return"LogMSLine"};var a=t.prototype;return a.getName=function(){return"LogMSLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="line",t.zeroplanethickness=1,t.enablemousetracking=!0,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,l._setDefaultConfig.call(this)},a.getDSGroupdef=function(){},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=s},927:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(928))["default"];t["default"]=r},928:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(921)),n=o(a(637)),l=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e),t.getName=function(){return"LogStackedColumn2d"};var a=t.prototype;return a.getName=function(){return"LogStackedColumn2d"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.isstacked=!0},a.getDSGroupdef=function(){return n["default"]},t}(i["default"]);t["default"]=l},929:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(930))["default"];t["default"]=r},930:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=o(a(628)),l=o(a(931)),s=function(e){function t(){var t;return(t=e.call(this)||this).showValues=0,t.isErrorChart=!0,t.eiMethods={},t}(0,r["default"])(t,e),t.getName=function(){return"ErrorBar2D"};var a=t.prototype;return a.getName=function(){return"ErrorBar2D"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.hasLegend=!0,t.defaultDatasetType="errorbar2d",t.enablemousetracking=!0},a.getDSGroupdef=function(){return n["default"]},a.getDSdef=function(){return l["default"]},t}(i["default"]);t["default"]=s},931:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=t._checkPointerOverPlot=t._checkPointerOverErrorBar=t._firePlotEvent=t._rolloutResponseSetter=t._rolloverResponseSetter=t.removePlots=t._getHoveredPlot=void 0;var r,i,n,l,s,c=o(a(238)),d=a(224),h=o(a(538)),u=a(232),p=o(a(932)),g=d.preDefStr.colors.AAAAAA,f=d.preDefStr.ROUND,m=d.preDefStr.PERCENTAGESTRING,v=d.preDefStr.pStr,b=d.preDefStr.sStr,x=function(e,t,a,o){var r=t.graphics,i=r&&r.element,n=e.getFromEnv("animationManager");!t.errorBarHovered&&i&&0!==i.getData().showHoverEffect&&(n.setAnimationState("mouseOver"),n.setAnimation({el:i,label:"rect",component:o,attr:i.getData().setRolloverAttr,doNotRemove:!0})),i&&e.plotEventHandler(i,a,"DataPlotRollOver")},k=function(e,t,a,o){var r=t.graphics,i=r&&r.element,n=e.getFromEnv("animationManager");!t.errorBarHovered&&i&&0!==i.getData().showHoverEffect&&(n.setAnimationState("mouseOut"),n.setAnimation({el:i,label:"rect",component:o,attr:i.getData().setRolloutAttr,doNotRemove:!0})),i&&e.plotEventHandler(i,a,"DataPlotRollOut")};t._rolloutResponseSetter=k,t._rolloverResponseSetter=x,t._checkPointerOverErrorBar=s,t._checkPointerOverPlot=l,t._firePlotEvent=n,t._getHoveredPlot=i,t.removePlots=r,(0,u.addDep)({name:"errorbar2DColumnAnimation",type:"animationRule",extension:p["default"].column}),(0,u.addDep)({name:"errorbar2DErrorAnimation",type:"animationRule",extension:p["default"].error});var y=function(e){function t(){var t;return(t=e.call(this)||this).drawCallBackFn=function(e){return function(){"disappearing"===e?this.hide():this.show()}},t}(0,c["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"errorBar2D"},a.ErrorValueConfigure=function(){var e,t,a,o,r,i,n,l,s,c,h,u,p,f,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V,I=this.config,B=I.JSONData,M=B.data,O=this.getFromEnv("chart-attrib"),R=this.components.data,G=(0,d.pluckNumber)(O.seriesnameintooltip,1),H=(0,d.parseUnsafeString)((0,d.pluck)(O.tooltipsepchar,", ")),z=this.getFromEnv("number-formatter"),W=-Infinity,U=Infinity,j=this.getFromEnv("xAxis").getTicksLen(),J=Math.min(j,M&&M.length),K=function(t){var o;return I.showTooltip?null===f?o=!1:void 0!==t?(n=[1,2,3,4,5,6,7,99,100,101,102,120,121,131,132],l={yaxisName:(0,d.parseUnsafeString)(O.yaxisname),xaxisName:(0,d.parseUnsafeString)(O.xaxisname),formattedValue:a.toolTipValue,errorValue:h,errorDataValue:a.errorToolTipValue,errorPercentValue:a.errorPercentValue,errorPercentDataValue:a.errorPercentValue,positiveErrorValue:u,negativeErrorValue:p,positiveErrorDataValue:a.positiveErrorToolTipValue,negativeErrorDataValue:a.negativeErrorToolTipValue,label:a.label},o=(0,d.parseTooltext)(t,n,l,e,O,B)):(G&&(r=(0,d.getFirstValue)(B&&B.seriesname)),o=r?r+H:"",o+=a.label?a.label+H:""):o=!1,o};for(I.showTooltip=(0,d.pluckNumber)(O.showtooltip,1),I.errorInPercent=i=(0,d.pluckNumber)(B.errorinpercent,O.errorinpercent),I.showValues=(0,d.pluckNumber)(B.showvalues,O.showvalues,0),I.errorBarShadow=k=(0,d.pluckNumber)(O.errorbarshadow,O.showshadow,1),I.ignoreEmptyDatasets=(0,d.pluckNumber)(B.ignoreemptydatasets,0),N=(0,d.pluckNumber)(O.halferrorbar,1),I.notHalfErrorBar=!(0,d.pluckNumber)(O.halferrorbar,1),c=(0,d.getFirstAlpha)((0,d.pluck)(B.errorbaralpha,O.errorbaralpha,I.plotfillalpha)),I.errorBarWidthPercent=(0,d.pluckNumber)(B.errorbarwidthpercent,O.errorbarwidthpercent,70),I.errorBarColor=(0,d.convertColor)((0,d.getFirstColor)((0,d.pluck)(B.errorbarcolor,O.errorbarcolor,g)),c),I.errorBarThickness=(0,d.pluckNumber)(B.errorbarthickness,O.errorbarthickness,1),I.shadowOpacity=k?c/250:0,I.parentYAxis=y=(0,d.pluck)(B.parentyaxis&&B.parentyaxis.toLowerCase(),v)===b?1:0,I.cumulativeValueOnErrorBar=(0,d.pluckNumber)(B.cumulativevalueonerrorbar,O.cumulativevalueonerrorbar,1),V=0;V<J;V++)(t=R[V])&&(e=M&&M[V],a=t&&t.config,P=void 0,_=void 0,void 0!==(0,d.pluckNumber)(e.value)&&(t||(t=R[V]={graphics:{}}),t.config||(a=R[V].config={}),C=a.setValue,a.setErrorValue=h=z.getCleanValue(e.errorvalue),a.errorInPercent=(0,d.pluckNumber)(e.errorinpercent,i,0),u=z.getCleanValue((0,d.pluckNumber)(e.positiveerrorvalue,h)),p=z.getCleanValue((0,d.pluckNumber)(e.negativeerrorvalue,h)),a.errorInPercent&&(a.setErrorValue=h=(0,d.pluckNumber)((h/100*C).toFixed(2))),a.cumulativeValueOnErrorBar=(0,d.pluckNumber)(e.cumulativevalueonerrorbar,I.cumulativeValueOnErrorBar,1),a.positiveErrorValue=z.getCleanValue((0,d.pluckNumber)(e.positiveerrorvalue,e.errorvalue)),a.errorInPercent&&a.positiveErrorValue&&(a.positiveErrorValue=(0,d.pluckNumber)((a.positiveErrorValue/100*C).toFixed(2))),a.positiveCumulativeErrorValue=C+(0,d.pluckNumber)(a.positiveErrorValue,a.setErrorValue),a.negativeErrorValue=z.getCleanValue((0,d.pluckNumber)(e.negativeerrorvalue,e.errorvalue)),a.errorInPercent&&a.negativeErrorValue&&(a.negativeErrorValue=(0,d.pluckNumber)((a.negativeErrorValue/100*C).toFixed(2))),a.negativeCumulativeErrorValue=C-(0,d.pluckNumber)(a.negativeErrorValue,a.setErrorValue),a.errorToolTipValue=z.dataLabels(h,y),a.negativeErrorToolTipValue=z.dataLabels(a.negativeErrorValue,y),a.negativeCumulativeErrorTooltipValue=z.dataLabels(a.negativeCumulativeErrorValue,y),a.positiveErrorToolTipValue=z.dataLabels(a.positiveErrorValue,y),a.positiveCumulativeErrorTooltipValue=z.dataLabels(a.positiveCumulativeErrorValue,y),a.errorPercentValue=Math.round(h/C*d.HUNDREDSTRING*d.HUNDREDSTRING)/d.HUNDREDSTRING+m,E=a.cumulativeValueOnErrorBar,a.notHalfErrorBar=I.notHalfErrorBar,a.halfErrorBar=N,a.showValue=(0,d.pluckNumber)(e.showvalue,I.showValues),a.hasErrorValue=void 0!==(0,d.pluckNumber)(e.errorvalue)?1:0,w=a.errorValue=h,s=a.errorToolTipValue,f=s,o=K(x=(0,d.getValidValue)((0,d.parseUnsafeString)((0,d.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,f),!1))),P=_=void 0,(x=(0,d.getValidValue)((0,d.parseUnsafeString)((0,d.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.positiveErrorToolTipValue),!1)))&&a.positiveErrorToolTipValue&&(P=K(x)),(x=(0,d.getValidValue)((0,d.parseUnsafeString)((0,d.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.negativeErrorToolTipValue),!1)))&&a.negativeErrorToolTipValue&&(_=K(x)),E&&((x=(0,d.getValidValue)((0,d.parseUnsafeString)((0,d.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.positiveCumulativeErrorTooltipValue),!1)))&&a.positiveCumulativeErrorTooltipValue&&(T=K(x)),(x=(0,d.getValidValue)((0,d.parseUnsafeString)((0,d.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.negativeCumulativeErrorTooltipValue),!1)))&&a.negativeCumulativeErrorTooltipValue&&(F=K(x))),L=a.positiveErrorValue,D=a.negativeErrorValue,(e.positiveerrorvalue||e.negativeerrorvalue)&&(a.halfErrorBar=0,a.notHalfErrorBar=!0),A=C+(null!==L?L:h),S=C-(a.halfErrorBar||D<0&&C<0?0:null!==D?D:h),W=Math.max(W,A,S),U=Math.min(U,A,S),a.errorValueArr=[],null===a.positiveErrorValue&&(a.positiveErrorValue=void 0),w=-a.positiveErrorValue,a.errorValueArr.push({errorValue:w,tooltext:E?T:P||o,errorEdgeBar:!0}),a.errorValueArr.push({errorValue:w,tooltext:P||o}),a.notHalfErrorBar&&(w=a.negativeErrorValue,a.errorValueArr.push({errorValue:w,tooltext:E?F:_||o,errorEdgeBar:!0}),a.errorValueArr.push({errorValue:w,tooltext:_||o})),a.toolText=K(a.setTooltext)));I.maxValue=W,I.minValue=U},a.drawErrorValue=function(){var e,t,a,o,r,i,n,l,s,c,h,u,p,g,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V=this.config,I=this.getState("visible"),B=this.getFromEnv("yAxis"),M=V.errorBarThickness,O=V.errorBarColor,R=V.scrollMaxVal,G=this.getFromEnv("animationManager");for(t=V.scrollMinVal;t<R;t++)if((n=this.components.data[t])&&(F=n.trackerConfig,(_=n.errorTrackerConfig={}).errorTrackerArr=[],l=(s=n&&n.config)&&s.setValue,void 0!==n))if(n&&(null==l||""===s.errorValue||void 0===s.errorValue||null===s.errorValue&&null===s.positiveErrorValue&&null===s.negativeErrorValue))for(y=n.graphics.error&&n.graphics.error.length,a=0;a<y;a++)n.graphics.error&&n.graphics.error[a]&&(G.setAnimation({el:n.graphics.error[a],label:"path",callback:this.drawCallBackFn("disappearing")}),n.graphics.error[a].shadow({opacity:0}));else{for(n.errorBar&&delete n.errorBar,v=s.errorValueArr,_.errorLen=y=v.length,!n.graphics.error&&(n.graphics.error=[]),w=this.getJSONIndex()+"_"+t,o=s.setLink,S=l<0,N=n._xPos,L=n._yPos,D=n._width,E=n._height,i=S?L+E:L,r=N+D/2,n.errorBar||(n.errorBar=[]);y--;)A=null,_.errorTrackerArr[y]={},b=v[y],_.errorTrackerArr[y].tooltext=b.tooltext,T=b.errorStartValue,k=isNaN(T)?i:B.getPixel(T),null===(x=b.errorValue)||isNaN(x)?n.graphics.error&&n.graphics.error[y]&&G.setAnimation({el:n.graphics.error[y],label:"path",doNotRemove:!0,callback:this.drawCallBackFn("disappearing")}).shadow({opacity:0}):(C=D*(V.errorBarWidthPercent/100)/2,m=I?-1:0,g=B.getPixel(B.getValue(isNaN(T)?L:k)+x*m,{wrtVisible:!0}),S&&(g+=E),g,r,P=(M=(0,d.pluckNumber)(b.errorBarThickness,M))>5?M/2:2.5,h=Math.round(g)+M%2/2,u=Math.round(r)+M%2/2,n.errorBar[y]||(n.errorBar[y]=[]),b.errorEdgeBar?(p=["M",u-C,h,"H",u+C],n.errorBar[y][1]={_xPos:u-C-P,_yPos:h-P,_height:2*P,_width:2*(C+P),_toolText:b.tooltext}):(p=["M",u,k,"V",h],n.errorBar[y][0]={_xPos:u-P,_yPos:h<k?h:k,_height:Math.abs(k-h),_width:2*P,_toolText:b.tooltext}),e={path:p,stroke:O=(0,d.pluck)(b.errorBarColor,O),"stroke-width":M,cursor:o?"pointer":"","stroke-linecap":f},c=!n.graphics.error[y]&&I?"appearing":I?"updating":"disappearing",A=n.graphics.error[y]=G.setAnimation({el:n.graphics.error[y]||"path",container:this.getContainer("errorPlotGroup"),component:this,attr:e,label:"path",state:c,callback:this.drawCallBackFn(c)}).shadow({opacity:V.shadowOpacity},this.getContainer("errorShadowGroup")),this.getFromEnv("chartConfig").enablemousetracking&&A.data("groupId",w).data("eventArgs",F.eventArgs));if(!s.notHalfErrorBar)for(a=2;a<4;a++)n.graphics.error&&n.graphics.error[a]&&G.setAnimation({el:n.graphics.error[a],label:"path",doNotRemove:!0,callback:this.drawCallBackFn("disappearing")}).shadow({opacity:0})}},a._firePlotEvent=function(e,t,a){var o=this.getFromEnv("chart"),r=this.components.data[t],i=r.graphics.element,n=r.graphics.label,l=r.errorBarHovered,s=r.config.setLink;if(i)switch(e){case"fc-mouseover":this._decideTooltipType(t,a),x(o,r,a,this),s&&(i.css({cursor:"pointer"}),n&&n.css({cursor:"pointer"}));break;case"fc-mouseout":this.getFromEnv("toolTipController").hide(this.config.currentToolTip),k(o,r,a,this),s&&(i.css({cursor:"default"}),n&&n.css({cursor:"default"}));break;case"fc-click":o.plotEventHandler(i,a);break;case"fc-mousemove":this._decideTooltipType(t,a),l&&!r._isRollover?(0!==i.showHoverEffect&&i.attr(i.getData().setRolloutAttr),r._isRollover=!0,r._isRollout=!1):l||r._isRollout||(0!==i.showHoverEffect&&i.attr(i.getData().setRolloverAttr),r._isRollover=!1,r._isRollout=!0)}},a._checkPointerOverErrorBar=function(e,t,a){var o,r,i,n,l,s,c,d,h,u,p=this.components.data,g=p[e];if(g&&(r=g.errorBar))for(n=r&&r.length;n--;)for(l=(i=r[n])&&i.length;l--;)if(i[l]&&i[l]._xPos&&(c=i[l]._xPos,d=i[l]._yPos,h=i[l]._height,u=i[l]._width,s=i[l]._toolText,o=t>=c&&t<=c+u&&a>=d&&a<=d+h))return{pointIndex:e,hovered:o,pointObj:p[e],toolText:s}},a._checkPointerOverPlot=function(e,t,a){var o,r,i=this.components.data[e],n=i&&i.config;if(i)return o=this.config.JSONData.plottooltext||this.getFromEnv("chart-attrib").plottooltext?"":n.toolTipValue,(r=this._checkPointerOverErrorBar(e,t,a))?(i.errorBarHovered=!0,n.finalTooltext=r.toolText):(r=this._checkPointerOverColumn(e,t,a),i.errorBarHovered=!1,r&&(n.finalTooltext=!1!==n.toolText&&n.toolText+o)),r},a._getHoveredPlot=function(e,t){var a,o;return a=this.getFromEnv("xAxis").getValue(e),(o=Math.round(a))-a>0?this._checkPointerOverPlot(o,e,t)||this._checkPointerOverPlot(o-1,e,t):this._checkPointerOverPlot(o+1,e,t)||this._checkPointerOverPlot(o,e,t)},a.removePlots=function(){var e,t,a,o,r=this.components,i=r.removeDataArr,n=r.pool||(r.pool={element:[],hotElement:[],label:[]}),l=i.length;for(a=0;a<l;a++)if(e=i[0],i.splice(0,1),e&&e.graphics){for((t=e.graphics).element&&t.element.hide()&&t.element.shadow({opacity:0}),o=0;o<4;o++)t.error&&t.error[o]&&this.getFromEnv("animationManager").setAnimation({el:t.error[o],label:"path"});e.graphics.element&&(n.element=n.element.concat(e.graphics.element)),e.graphics.hotElement&&(n.hotElement=n.hotElement.concat(e.graphics.hotElement)),e.graphics.label&&(n.label=n.label.concat(e.graphics.label))}r.pool=n},t}(h["default"]);t.removePlots=r=y.prototype.removePlots,t._getHoveredPlot=i=y.prototype._getHoveredPlot,t._firePlotEvent=n=y.prototype._firePlotEvent,t._checkPointerOverPlot=l=y.prototype._checkPointerOverPlot,t._checkPointerOverErrorBar=s=y.prototype._checkPointerOverErrorBar;var C=y;t["default"]=C},932:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={column:{"initial.dataset.errorBar2D":o(a(539))["default"]["initial.dataset.column"]},error:{"initial.dataset.errorBar2D":function(){return{"path.appearing":[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]}}}};t["default"]=r},933:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(934))["default"];t["default"]=r},934:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=a(673),l=o(a(935)),s=function(e){function t(){var t;return(t=e.call(this)||this).useErrorGroup=!0,t.isErrorChart=!0,t.hasAnchor=!0,t.defaultPlotShadow=1,t.axisPaddingLeft=0,t.axisPaddingRight=0,t.canvasPaddingModifiers=["anchor","errorbar"],t}(0,r["default"])(t,e),t.getName=function(){return"ErrorLine"};var a=t.prototype;return a.getName=function(){return"ErrorLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="errorline",n._setDefaultConfig.call(this),this.zeroplanethickness=1,this.zeroplanealpha=40,t.showzeroplaneontop=0,t.defaultcrosslinethickness=1,t.enablemousetracking=!0},a.getDSGroupdef=function(){},a.getDSdef=function(){return l["default"]},t}(i["default"]);t["default"]=s},935:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=a(931),l=o(a(555)),s=a(232),c=o(a(936)),d=o(a(937)),h=i.preDefStr.colors.AAAAAA,u=i.preDefStr.ROUND,p=i.preDefStr.PERCENTAGESTRING,g="rgba(192,192,192,"+(i.isIE?.002:1e-6)+")",f=Math,m=f.round,v=f.min,b=f.max,x=f.abs,k=i.hasTouch?i.TOUCH_THRESHOLD_PIXELS:i.CLICK_THRESHOLD_PIXELS;(0,s.addDep)({name:"errorlineErrorAnimation",type:"animationRule",extension:c["default"]}),(0,s.addDep)({name:"errorlineLineAnimation",type:"animationRule",extension:d["default"]});var y=function(e){function t(){var t;return(t=e.call(this)||this).drawCallbackFn=function(e){return function(){"disappearing"===e&&this.hide()}},t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"errorLine"},a.ErrorValueConfigure=function(){var e,t,a,o,r,n,l,s,c,d,u,g,f,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_=this.getFromEnv("chart"),V=this.config,I=V.parentYAxis,B=V.JSONData,M=B.data,O=_.getFromEnv("dataSource").chart,R=this.getFromEnv("xAxis").getTicksLen(),G=this.components.data,H=this.getFromEnv("number-formatter"),z=V.linethickness,W=-Infinity,U=Infinity,j=(0,i.pluck)(O.tooltipsepchar,", "),J=(0,i.pluckNumber)(O.seriesnameintooltip,1),K=function(t){var o;return _.config.showtooltip?null===s?o=!1:void 0!==t?(L=[1,2,3,4,5,6,7,99,100,101,102,120,121,131,132],D={yaxisName:(0,i.parseUnsafeString)(O.yaxisname),xaxisName:(0,i.parseUnsafeString)(O.xaxisname),formattedValue:a.toolTipValue,errorValue:l,errorDataValue:a.errorToolTipValue,errorPercentValue:a.errorPercentValue,errorPercentDataValue:a.errorPercentValue,positiveErrorValue:u,negativeErrorValue:d,positiveErrorDataValue:a.positiveErrorToolTipValue,negativeErrorDataValue:a.negativeErrorToolTipValue,label:a.label},o=(0,i.parseTooltext)(t,L,D,e,O,B)):(J&&(E=(0,i.getFirstValue)(B&&B.seriesname)),o=E?E+j:"",o+=a.label?a.label+j:""):o=!1,o};for(V.errorBarShadow=y=(0,i.pluckNumber)(O.errorbarshadow,O.showshadow,1),V.ignoreEmptyDatasets=(0,i.pluckNumber)(B.ignoreemptydatasets,0),V.notHalfErrorBar=!(0,i.pluckNumber)(O.halferrorbar,1),r=(0,i.getFirstAlpha)((0,i.pluck)(B.errorbaralpha,O.errorbaralpha,V.alpha)),V.errorBarWidth=(0,i.pluckNumber)(B.errorbarwidth,O.errorbarwidth,5),V.errorBarColor=(0,i.convertColor)((0,i.getFirstColor)((0,i.pluck)(B.errorbarcolor,O.errorbarcolor,h)),r),n=(0,i.pluckNumber)(B.errorbarthickness,O.errorbarthickness,1),V.errorBarThickness=n>z?z:n,V.shadowOpacity=y?r/250:0,V.errorInPercent=T=(0,i.pluckNumber)(B.errorinpercent,O.errorinpercent),V.cumulativeValueOnErrorBar=(0,i.pluckNumber)(B.cumulativevalueonerrorbar,O.cumulativevalueonerrorbar,1),P=0;P<R;P++)e=M&&M[P],M&&e&&(t=G[P],a=t&&t.config,t||(t=G[P]={graphics:{}}),t.config||(a=G[P].config={}),A=a.setValue,a.notHalfErrorBar=V.notHalfErrorBar,l=H.getCleanValue(e.errorvalue),a.errorToolTipValue=H.dataLabels(l,I),u=H.getCleanValue((0,i.pluckNumber)(e.positiveerrorvalue,l)),d=H.getCleanValue((0,i.pluckNumber)(e.negativeerrorvalue,l)),a.setErrorValue=a.errorValue=S=l,a.hasErrorValue=void 0!==(0,i.pluckNumber)(e.errorvalue)?1:0,o=a.errorToolTipValue,s=o,F=K(c=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,s),!1))),a.errorInPercent=(0,i.pluckNumber)(e.errorinpercent,T,0),a.errorInPercent&&(a.setErrorValue=l=(0,i.pluckNumber)((l/100*A).toFixed(2))),a.cumulativeValueOnErrorBar=N=(0,i.pluckNumber)(e.cumulativevalueonerrorbar,V.cumulativeValueOnErrorBar,1),a.positiveErrorValue=H.getCleanValue((0,i.pluckNumber)(e.positiveerrorvalue,e.errorvalue)),a.errorInPercent&&a.positiveErrorValue&&(a.positiveErrorValue=(0,i.pluckNumber)((a.positiveErrorValue/100*A).toFixed(2))),a.positiveCumulativeErrorValue=A+(0,i.pluckNumber)(a.positiveErrorValue,a.setErrorValue),a.negativeErrorValue=H.getCleanValue((0,i.pluckNumber)(e.negativeerrorvalue,e.errorvalue)),a.errorInPercent&&a.negativeErrorValue&&(a.negativeErrorValue=(0,i.pluckNumber)((a.negativeErrorValue/100*A).toFixed(2))),a.negativeCumulativeErrorValue=A-(0,i.pluckNumber)(a.negativeErrorValue,a.setErrorValue),a.errorToolTipValue=H.dataLabels(l,I),a.negativeErrorToolTipValue=H.dataLabels(a.negativeErrorValue,I),a.negativeCumulativeErrorTooltipValue=H.dataLabels(a.negativeCumulativeErrorValue,I),a.positiveErrorToolTipValue=H.dataLabels(a.positiveErrorValue,I),a.positiveCumulativeErrorTooltipValue=H.dataLabels(a.positiveCumulativeErrorValue,I),a.errorPercentValue=m(l/A*i.HUNDREDSTRING*i.HUNDREDSTRING)/i.HUNDREDSTRING+p,x=k=void 0,(c=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.positiveErrorToolTipValue),!1)))&&a.positiveErrorToolTipValue&&(x=K(c)),(c=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.negativeErrorToolTipValue),!1)))&&a.negativeErrorToolTipValue&&(k=K(c)),(e.positiveerrorvalue||e.negativeerrorvalue)&&(a.halfErrorBar=0,a.notHalfErrorBar=!0),N&&((c=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.positiveCumulativeErrorTooltipValue),!1)))&&a.positiveCumulativeErrorTooltipValue&&(g=K(c)),(c=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(e.errorplottooltext,B.errorplottooltext,O.errorplottooltext,a.negativeCumulativeErrorTooltipValue),!1)))&&a.negativeCumulativeErrorTooltipValue&&(f=K(c))),C=A+(null!==a.positiveErrorValue?a.positiveErrorValue:l),w=A-(a.halfErrorBar||a.negativeErrorValue<0&&A<0?0:null!==a.negativeErrorValue?a.negativeErrorValue:l),W=b(W,C,w),U=v(U,C,w),null===l&&(l=void 0),a.errorValueArr=[],null===a.positiveErrorValue&&(a.positiveErrorValue=void 0),S=-a.positiveErrorValue,a.errorValueArr.push({errorValue:S,tooltext:N?g:x||F,errorEdgeBar:!0}),a.errorValueArr.push({errorValue:S,tooltext:x||F}),a.notHalfErrorBar&&(S=a.negativeErrorValue,a.errorValueArr.push({errorValue:S,tooltext:N?f:k||F,errorEdgeBar:!0}),a.errorValueArr.push({errorValue:S,tooltext:k||F})),a.toolText=K(a.setTooltext));V.maxValue=W,V.minValue=U},a._show=function(){var e=this.chart,t=this.graphics&&this.graphics.container,a=this.graphics&&this.graphics.dataLabelContainer,o=this.graphics&&this.graphics.errorGroupContainer,r=this.graphics&&this.graphics.errorShadowContainer;e._chartAnimation(),t.lineGroup.show(),t.anchorGroup.show(),t.anchorShadowGroup.show(),t.lineShadowGroup.show(),a.show(),this.setState("visible",!0),o&&o.show(),r&&r.show(),this._conatinerHidden=!1,e._setAxisLimits(),this.yAxis.draw(),e._drawDataset()},a._hide=function(){var e=this.chart;e._chartAnimation(),this.setState("visible",!1),e._setAxisLimits(),this.yAxis.draw(),e._drawDataset()},a.draw=function(){e.prototype.draw.call(this),this.drawErrorValue()},a.drawErrorValue=function(){var e,t,a,o,r,i,n,l,s,c,d,h,p,f,v,b,y,C,w,A,S,N,L,D,E,T,F=this.config,P=this.getFromEnv("xAxis").getTicksLen(),_=this.getState("visible"),V=this.getFromEnv("yAxis"),I=this.components.data,B=F.errorBarThickness,M=B>5?B/2:2.5,O=this.getFromEnv("animationManager");for(t=0;t<P;t++)if(c=(d=(s=I[t])&&s.config)&&d.setValue,void 0!==s&&null!=c)if((T=s.errorTrackerConfig={}).errorTrackerArr=[],y=d.errorValueArr,T.errorLen=S=y.length,!s.graphics.error&&(s.graphics.error=[]),!s.graphics.errorTracker&&(s.graphics.errorTracker=[]),""===d.errorValue||void 0===d.errorValue||null===d.errorValue&&null===d.positiveErrorValue&&null===d.negativeErrorValue)for(o=0;o<S;o++)s.graphics.error&&s.graphics.error[o]&&O.setAnimation({el:s.graphics.error[o]||"path",label:"path",component:this,callback:this.drawCallbackFn("disappearing")}).shadow({opacity:0});else{for(i=d.setLink,D=s._xPos,l=E=s._yPos,n=D,s.errorBar&&delete s.errorBar,s.errorBar=[];S--;)L=null,T.errorTrackerArr[S]={},C=y[S],T.errorTrackerArr[S].tooltext=C.tooltext,A=l,null===(w=C.errorValue)||isNaN(w)?s.graphics.error&&s.graphics.error[S]&&(s.graphics.error[S].hide(),s.graphics.error[S].shadow({opacity:0})):(N=F.errorBarWidth/2,b=_?1:0,v=E+(V.getPixel(0)-V.getPixel(1))*w*b,n,h=m(v)+B%2/2,p=m(n)+B%2/2,s.errorBar[S]||(s.errorBar[S]=[]),C.errorEdgeBar?(f=["M",p-N,h,"H",p+N],s.errorBar[S][1]={_xPos:p-N-M,_yPos:h-M,_height:2*M,_width:2*(N+M),_toolText:C.tooltext}):(f=["M",p,A,"V",h],s.errorBar[S][0]={_xPos:p-M,_yPos:h<A?h:A,_height:x(A-h),_width:2*M,_toolText:C.tooltext}),e={path:f,stroke:F.errorBarColor,"stroke-width":B,cursor:i?"pointer":"","stroke-linecap":u},r=!s.graphics.error[S]&&_?"appearing":_?"updating":"disappearing",L=s.graphics.error[S]=O.setAnimation({el:s.graphics.error[S]||"path",state:r,attr:e,label:"path",component:this,container:this.getContainer("errorPlotGroup"),callback:this.drawCallbackFn(r)}),"disappearing"!==r&&L.show(),L&&L.shadow({opacity:F.shadowOpacity},this.getContainer("errorShadowGroup")),T.errorTrackerArr[S].attr={path:f,stroke:g,"stroke-width":B<k?k:B,cursor:i?"pointer":""});if(!d.notHalfErrorBar)for(o=2;o<4;o++)s.graphics.error&&s.graphics.error[o]&&O.setAnimation({el:s.graphics.error[o]||"path",label:"path",component:this,doNotRemove:!0,callback:this.drawCallbackFn("disappearing")}).shadow({opacity:0})}else if(s&&s.graphics.error)for(a=0;a<s.graphics.error.length;a++)s.graphics.error&&s.graphics.error[a]&&O.setAnimation({el:s.graphics.error[a]||"path",label:"path",component:this,doNotRemove:!0,callback:this.drawCallbackFn("disappearing")}).shadow({opacity:0})},a._firePlotEvent=function(e,t,a){n._firePlotEvent.call(this,e,t,a)},a._checkPointerOverErrorBar=function(e,t,a){return n._checkPointerOverErrorBar.call(this,e,t,a)},a._checkPointerOverPlot=function(e,t,a){var o,r=this.components.data[e],i=r&&r.config;if(r)return(o=this.isWithinShape(r,e,t,a))?(r.errorBarHovered=!1,i.finalTooltext=!1!==i.toolText&&i.toolText):(o=this._checkPointerOverErrorBar(e,t,a))&&(r.errorBarHovered=!0,i.finalTooltext=o.toolText),o},a._getHoveredPlot=function(e,t){return n._getHoveredPlot.call(this,e,t)},a.getCanvasPadding=function(){var e,t,a,o,r,n,l=.5*this.config.errorBarWidth,s=this.getFromEnv("chart"),c=s.config.dataLabelStyle,d=this.components&&this.components.data||[],h=d[0],u=d[d.length-1],p={},g=s.getFromEnv("smartLabel"),f={paddingLeft:0,paddingRight:0};return h&&(n=(e=h.config).showValue,a=e&&e.anchorProps||{},n&&(t=e.displayValue,g.useEllipsesOnOverflow(s.config.useEllipsesWhenOverflow),g.setStyle(c),p=g.getOriSize(t)),e.setValue&&(o=b((0,i.pluckNumber)(a.radius,0),l)+(0,i.pluckNumber)(a.borderThickness,0),r=(p.width||0)/2),f.paddingLeft=b(o,r)),u&&(n=(e=u.config).showValue,a=e&&e.anchorProps||{},n&&(t=e.displayValue,g.setStyle(c),p=g.getOriSize(t)),e.setValue&&(o=b((0,i.pluckNumber)(a.radius,0),l)+(0,i.pluckNumber)(a.borderThickness,0),r=(p.width||0)/2),f.paddingRight=b(o,r)),f},a.removePlots=function(){n.removePlots.call(this)},t}(l["default"]);t["default"]=y},936:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.errorLine":function(){return{"path.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},startEnd:{start:.5,end:1},slot:"plot"}]},"*":null}}}},937:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.errorLine":o(a(558))["default"]["*.dataset.line"]};t["default"]=r},938:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(939))["default"];t["default"]=r},939:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(658)),n=o(a(940)),l=function(e){function t(){var t;return(t=e.call(this)||this).isXY=!0,t.defaultZeroPlaneHighlighted=!1,t.useErrorGroup=!0,t.isErrorChart=!0,t.hasAnchor=!0,t.initAnimation=!0,t}(0,r["default"])(t,e),t.getName=function(){return"ErrorScatter"};var a=t.prototype;return a.getName=function(){return"ErrorScatter"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="errorscatter",t.enablemousetracking=!0},a.getDSGroupdef=function(){},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=l},940:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r,i=o(a(238)),n=o(a(662)),l=a(224),s=o(a(663)),c=a(232),d=o(a(941)),h=o(a(942)),u=l.preDefStr.colors.AAAAAA,p=l.preDefStr.ROUND,g=l.preDefStr.PERCENTAGESTRING,f="M";(0,c.addDep)({name:"errorscatterAnimation",type:"animationRule",extension:d["default"]}),(0,c.addDep)({name:"errorscatterErrorAnimation",type:"animationRule",extension:h["default"]});var m=function(e){function t(){var t;return(t=e.call(this)||this).drawCallbackFn=function(e){return function(){"disappearing"===e&&this.hide()}},t.removeCallbackFn=function(){this.hide(),this.shadow({opacity:0})},t}(0,i["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"errorScatter"},a.ErrorValueConfigure=function(){var e,t,a,o,i,n,s,c,d,h,p,f,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K,q,Y,X,Q,Z,$,ee,te,ae,oe=this.config,re=oe.JSONData,ie=this.getFromEnv("dataSource").categories&&this.getFromEnv("dataSource").categories[0].category,ne=this.getFromEnv("chart-attrib"),le=re.data,se=le&&le.length||0,ce=this.components.data,de=this.getFromEnv("number-formatter"),he=(0,l.pluck)(ne.tooltipsepchar,", "),ue=(0,l.parseUnsafeString)(ne.yaxisname),pe=(0,l.parseUnsafeString)(ne.xaxisname),ge=oe.parentYAxis,fe=-Infinity,me=+Infinity,ve=fe,be=me,xe=me,ke=fe,ye=function(t,o){var i;return oe.showTooltip?null===A?i=!1:t!==r?(D=[1,2,3,4,5,6,7,8,9,10,11,99,100,101,102,103,104,105,106,107,109,120,121,123,124,125,126,127,128,129,130],E={yaxisName:ue,xaxisName:pe,yDataValue:A,xDataValue:a.label,formattedValue:a.toolTipValue,horizontalErrorValue:x,horizontalErrorDataValue:y,verticalErrorValue:k,verticalErrorDataValue:C,horizontalErrorPercentValue:N,verticalErrorPercentValue:L,label:a.label,horizontalPositiveErrorValue:a.useHorizontalErrorBar?M:r,horizontalPositiveErrorDataValue:a.useHorizontalErrorBar?R:r,horizontalNegativeErrorValue:c?r:B,horizontalNegativeErrorDataValue:c?r:z,verticalPositiveErrorValue:a.useVerticalErrorBar?I:r,verticalPositiveErrorDataValue:a.useVerticalErrorBar?U:r,verticalNegativeErrorValue:d?r:K,verticalNegativeErrorDataValue:d?r:te,errorValue:o,errorDataValue:o,errorPercentValue:a.errorPercentValue,errorPercentDataValue:a.errorPercentValue},i=(0,l.parseTooltext)(t,D,E,e,ne,re)):null===A?i=!1:(oe.seriesNameInTooltip&&(T=(0,l.getFirstValue)(re&&re.seriesname)),i=T?T+he:"",i+=w.x?de.xAxis(w.x)+he:"",i+=a.toolTipValue):i=!1,i};for(oe.errorBarShadow=i=(0,l.pluckNumber)(ne.errorbarshadow,ne.showshadow,0),oe.ignoreEmptyDatasets=(0,l.pluckNumber)(re.ignoreemptydatasets,0),oe.notHalfErrorBar=!(0,l.pluckNumber)(ne.halferrorbar,1),oe.errorBarAlpha=(0,l.getFirstAlpha)((0,l.pluck)(re.errorbaralpha,ne.errorbaralpha)),oe.errorBarWidth=n=(0,l.pluckNumber)(re.errorbarwidth,ne.errorbarwidth,5),oe.errorBarColor=s=(0,l.convertColor)((0,l.getFirstColor)((0,l.pluck)(re.errorbarcolor,ne.errorbarcolor,u)),void 0),oe.errorBarThickness=o=(0,l.pluckNumber)(re.errorbarthickness,ne.errorbarthickness,1),oe.shadowOpacity=i?NaN:0,oe.halfHorizontalErrorBar=c=(0,l.pluckNumber)(ne.halfhorizontalerrorbar,1),oe.halfVerticalErrorBar=d=(0,l.pluckNumber)(ne.halfverticalerrorbar,1),oe.initAnimation===r&&(oe.initAnimation=this.getFromEnv("chart").initAnimation),h=(0,l.pluck)(re.horizontalerrorbaralpha,re.errorbaralpha,ne.horizontalerrorbaralpha,void 0),p=(0,l.pluckNumber)(re.verticalerrorbaralpha,re.errorbaralpha,ne.verticalerrorbaralpha,void 0),f=(0,l.convertColor)((0,l.pluck)(re.horizontalerrorbarcolor,re.errorbarcolor,ne.horizontalerrorbarcolor,s),h),m=(0,l.convertColor)((0,l.pluck)(re.verticalerrorbarcolor,re.errorbarcolor,ne.verticalerrorbarcolor,s),p),v=(0,l.pluckNumber)(re.horizontalerrorbarthickness,re.errorbarthickness,ne.horizontalerrorbarthickness,o),b=(0,l.pluckNumber)(re.verticalerrorbarthickness,re.errorbarthickness,ne.verticalerrorbarthickness,o),oe.horizontalErrorBarWidth=(0,l.pluckNumber)(re.horizontalerrorbarwidth,ne.horizontalerrorbarwidth,n),oe.verticalErrorBarWidth=(0,l.pluckNumber)(re.verticalerrorbarwidth,ne.verticalerrorbarwidth,n),oe.cumulativeValueOnErrorBar=(0,l.pluckNumber)(re.cumulativevalueonerrorbar,ne.cumulativevalueonerrorbar,1),ae=0;ae<se;ae++)le&&(e=le&&le[ae],t=ce[ae],a=t&&t.config,t||(t=ce[ae]={graphics:{}}),t.config||(a=ce[ae].config={}),w=a.setValue,a.errorValue=e.errorvalue,a.cumulativeValueOnErrorBar=$=(0,l.pluckNumber)(e.cumulativevalueonerrorbar,oe.cumulativeValueOnErrorBar,1),a.hErrorValue=x=de.getCleanValue((0,l.pluck)(e.horizontalerrorvalue,e.errorvalue)),y=de.xAxis(x),a.vErrorValue=k=de.getCleanValue((0,l.pluck)(e.verticalerrorvalue,e.errorvalue)),C=de.dataLabels(k),a.hPositiveErrorValue=M=de.getCleanValue((0,l.pluck)(e.horizontalpositiveerrorvalue,e.positiveerrorvalue,x)),a.hNegativeErrorValue=B=de.getCleanValue((0,l.pluck)(e.horizontalnegativeerrorvalue,e.negativeerrorvalue,x)),a.vPositiveErrorValue=I=de.getCleanValue((0,l.pluck)(e.verticalpositiveerrorvalue,e.positiveerrorvalue,k)),a.vNegativeErrorValue=K=de.getCleanValue((0,l.pluck)(e.verticalnegativeerrorvalue,e.negativeerrorvalue,k)),N=Math.round(x/w.x*l.HUNDREDSTRING*l.HUNDREDSTRING)/l.HUNDREDSTRING+g,L=Math.round(k/w.y*l.HUNDREDSTRING*l.HUNDREDSTRING)/l.HUNDREDSTRING+g,R=de.dataLabels(M,ge),O=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,R),!1)),z=de.dataLabels(B,ge),j=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,z),!1)),U=de.dataLabels(I,ge),X=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,U),!1)),te=de.dataLabels(K,ge),ee=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,te),!1)),G=Q=Z=q=r,$&&(H=de.dataLabels(w.x+M,ge),G=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,H),!1)),W=de.dataLabels(w.x-B,ge),Q=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,W),!1)),J=de.dataLabels(w.y+I,ge),Z=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,J),!1)),Y=de.dataLabels(w.y-K,ge),q=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(e.errorplottooltext,re.errorplottooltext,ne.errorplottooltext,Y),!1))),ie&&ie[ae]&&(a.label=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(ie[ae].tooltext,ie[ae].label)))),e.horizontalpositiveerrorvalue||e.positiveerrorvalue||e.horizontalnegativeerrorvalue||e.negativeerrorvalue?a.halfHorizontalErrorBar=c=0:a.halfHorizontalErrorBar=c=oe.halfHorizontalErrorBar,e.verticalpositiveerrorvalue||e.positiveerrorvalue||e.verticalnegativeerrorvalue||e.negativeerrorvalue?a.halfVerticalErrorBar=d=0:a.halfVerticalErrorBar=d=oe.halfVerticalErrorBar,null!==w.x&&(F=w.x+Number(M),P=w.x-(c?0:Number(B)),ke=Math.max(ke,F,P),xe=Math.min(xe,F,P)),null!==w.y&&(F=w.y+Number(I),P=w.y-(d?0:Number(K)),ve=Math.max(ve,F,P),be=Math.min(be,F,P)),a.useHorizontalErrorBar=(0,l.pluckNumber)(e.usehorizontalerrorbar,re.usehorizontalerrorbar,ne.usehorizontalerrorbar,0),a.useVerticalErrorBar=(0,l.pluckNumber)(e.useverticalerrorbar,re.useverticalerrorbar,ne.useverticalerrorbar,1),a.errorValueConf={},(_=a.errorValueConf.horizontal={}).mandatory={},_.mandatory.marker={errorValue:-(null===M?r:M),tooltext:ye(O,R),errorBarColor:f,isHorizontal:!0,errorBarThickness:v,shadowOpacity:i?h/250:0},_.mandatory.limit={errorValue:-(null===M?r:M),tooltext:$?ye(G,H):ye(O,R),errorBarColor:f,isHorizontal:!0,errorBarThickness:v,shadowOpacity:i?h/250:0,errorEdgeBar:!0},_.optional={},_.optional.marker={errorValue:B,tooltext:ye(j,z),errorBarColor:f,isHorizontal:!0,errorBarThickness:v,shadowOpacity:i?h/250:0},_.optional.limit={errorValue:B,tooltext:$?ye(Q,W):ye(j,z),errorBarColor:f,isHorizontal:!0,errorBarThickness:v,shadowOpacity:i?h/250:0,errorEdgeBar:!0},(V=a.errorValueConf.vertical={}).mandatory={},V.mandatory.marker={errorValue:-(null===I?r:I),tooltext:ye(X,U),errorBarColor:m,errorBarThickness:b,shadowOpacity:i?p/250:0},V.mandatory.limit={errorValue:-(null===I?r:I),tooltext:$?ye(Z,J):ye(X,U),errorBarColor:m,errorBarThickness:b,shadowOpacity:i?p/250:0,errorEdgeBar:!0},V.optional={},V.optional.marker={errorValue:K,tooltext:ye(ee,te),errorBarColor:m,errorBarThickness:b,shadowOpacity:i?p/250:0},V.optional.limit={errorValue:K,tooltext:$?ye(q,Y):ye(ee,te),errorBarColor:m,errorBarThickness:b,shadowOpacity:i?p/250:0,errorEdgeBar:!0},w=a.setValue,A=a.formatedVal,oe.showTooltip?a.setTooltext!==r?(D=[1,2,3,4,5,6,7,8,9,10,11,99,100,101,102,103,104,105,106,107,109,120,121,123,124,125,126,127,128,129,130],E={yaxisName:ue,xaxisName:pe,yDataValue:A,xDataValue:a.label,formattedValue:a.toolTipValue,horizontalErrorValue:x,horizontalErrorDataValue:y,verticalErrorValue:k,verticalErrorDataValue:C,horizontalErrorPercentValue:N,verticalErrorPercentValue:L,label:a.label,horizontalPositiveErrorValue:a.useHorizontalErrorBar?M:r,horizontalPositiveErrorDataValue:a.useHorizontalErrorBar?R:r,horizontalNegativeErrorValue:c?r:B,horizontalNegativeErrorDataValue:c?r:z,verticalPositiveErrorValue:a.useVerticalErrorBar?I:r,verticalPositiveErrorDataValue:a.useVerticalErrorBar?U:r,verticalNegativeErrorValue:d?r:K,verticalNegativeErrorDataValue:d?r:te,errorValue:a.errorValue,errorDataValue:de.dataLabels(a.errorValue,oe.parentYAxis)},S=(0,l.parseTooltext)(a.setTooltext,D,E,e,ne,re)):null===A?S=!1:(oe.seriesNameInTooltip&&(T=(0,l.getFirstValue)(re&&re.seriesname)),S=T?T+he:"",S+=w.x?de.xAxis(w.x)+he:"",S+=a.toolTipValue):S=!1,a.toolText=S);oe.xMax=ke,oe.xMin=xe,oe.yMin=be,oe.yMax=ve},a.drawErrorValue=function(){var e,t,a,o,i,n,l,c,d,h,u,g,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K=this.config,q=this.config.JSONData.data,Y=q&&q.length,X=this.getState("visible"),Q=this.components.data,Z=this.getFromEnv("animationManager"),$=[];for(t=0;t<Y;t++)if((J=(g=Q[t]).errorTrackerConfig={}).errorTrackerArr=[],m=(b=g&&g.config)&&b.setValue,z=b.errorValueConf,g!==r&&m!==r&&null!==m&&z){if(j=Object.keys(o=g.graphics),null===b.vErrorValue&&null===b.vPositiveErrorValue&&null===b.vNegativeErrorValue)for(H=0;H<j.length;H++)j[H].match(/error-horizontal-/)&&(Z.setAnimation({el:o[j[H]],state:"disappearing",callback:this.drawCallbackFn("disappearing")}),o[j[H]].shadow({opacity:0}));if(null===b.hErrorValue&&null===b.hPositiveErrorValue&&null===b.vPositiveErrorValue)for(H=0;H<j.length;H++)j[H].match(/error-vertical-/)&&(Z.setAnimation({el:o[j[H]],state:"disappearing",callback:this.drawCallbackFn("disappearing")}),o[j[H]].shadow({opacity:0}));if(!(null===b.hErrorValue&&null===b.vErrorValue&&b.hPositiveErrorValue&&b.hNegativeErrorValue&&b.vPositiveErrorValue&&b.vNegativeErrorValue))for(W in d=b.setLink,M=g._xPos,u=g._yPos,h=M,z)if(z.hasOwnProperty(W))for(D in E=z[W])if(E.hasOwnProperty(D))for(P in T=E[D])if(T.hasOwnProperty(P)){if(v=r,F=T[P],e={},B=null,(J.errorTrackerArr[0]={}).tooltext=F.tooltext,V=u,_=F.errorValue,x=!b.useHorizontalErrorBar&&"horizontal"===W,k=!b.useVerticalErrorBar&&"vertical"===W,y=b.halfHorizontalErrorBar&&"horizontal"===W&&"optional"===D,C=b.halfVerticalErrorBar&&"vertical"===W&&"optional"===D,x||k||y||C)v="disappearing";else if(null===_||_===r||isNaN(_))v="disappearing";else{if(c=F.errorBarColor,i=F.isHorizontal,n=F.errorBarThickness,l=i?K.horizontalErrorBarWidth:K.verticalErrorBarWidth,I=X?l/2:0,L=X?-1:0,U=n>5?n/2+.5:2.75,i)if(w=N=this.getFromEnv("xAxis").getPixel(g.config._x+_*L),A=h,w=Math.round(V)+n%2/2,A=Math.round(N)+n%2/2,F.errorEdgeBar)for(S=[f,A,w-I,"V",w+I],O=2*I,R=w-I,G=U;G<O;G+=2*U)$.push({x:A,y:R+G,r:U,index:t,data:g,toolText:F.tooltext,barType:"h"});else for(S=[f,h,w,"H",A],O=Math.abs(h-A),R=h>A?A:h,G=U;G<O;G+=2*U)$.push({x:R+G,y:w,r:U,index:t,data:g,toolText:F.tooltext,barType:"h"});else if(w=N=this.getFromEnv("yAxis").getPixel(g.config._y+_*L),A=h,w=Math.round(N)+n%2/2,A=Math.round(h)+n%2/2,F.errorEdgeBar)for(S=[f,A-I,w,"H",A+I],O=2*I,R=A-I,G=U;G<=O;G+=2*U)$.push({x:R+G,y:w,r:U,index:t,data:g,toolText:F.tooltext,barType:"v"});else for(S=[f,A,V,"V",w],O=Math.abs(V-w),R=V>w?w:V,G=U;G<=O;G+=2*U)$.push({x:A,y:R+G,r:U,index:t,data:g,toolText:F.tooltext,barType:"v"});e={path:S,"stroke-width":X?n:0,stroke:c,cursor:d?"pointer":"","stroke-linecap":p}}a=["error",W,D,P].join("-"),v||(v=o[a]?"updating":"appearing"),(o[a]||"disappearing"!==v)&&(B=o[a]=Z.setAnimation({el:o[a]||"path",container:this.getContainer("errorPlotGroup"),component:this,attr:e,state:v,label:"path",callback:this.drawCallbackFn(v)}),"disappearing"!==v&&B.show(),B.shadow({opacity:"disappearing"===v?0:K.shadowOpacity},this.getContainer("errorShadowGroup")))}}$.length&&(this.config.dataTreeB=(new s["default"]).buildKdTree($)),K.initAnimation=!1},a._getHoveredPlot=function(e,t){var a,o,r,i,n,l;return(a=this.config.dataTree.getNeighbour({x:e,y:t},!0))?(r=a.data.config.toolText,a.data.config.finalTooltext=r,n=a.data.config.hoverEffects,(l=a.data.graphics.element).data("hoverEnabled",n.enabled),n.enabled&&l.attr(l.getData().setRolloverAttr),{pointIndex:a.index,hovered:!0,pointObj:a.data}):(o=this.config.dataTreeB&&this.config.dataTreeB.getNeighbour({x:e,y:t},!0))?(("h"===o.barType||"v"===o.barType)&&(i=o.toolText),o.data.config.finalTooltext=i,(l=o.data.graphics.element).data("hoverEnabled",!1),l.attr(l.getData().setRolloutAttr),{pointIndex:o.index,hovered:!0,pointObj:o.data}):void 0},a.removePlots=function(){var e,t,a,o,r=this.components,i=r.removeDataArr,n=r.pool||(r.pool={element:[],hotElement:[],label:[]}),l=i.length;for(a=0;a<l;a++)if(e=i[0],i.splice(0,1),e&&e.graphics){for(o in t=e.graphics)t.hasOwnProperty(o)&&this.getFromEnv("animationManager").setAnimation({el:t[o],component:this,attr:{},state:"disappering",callback:this.removeCallbackFn});e.graphics.element&&(n.element=n.element.concat(e.graphics.element)),e.graphics.label&&(n.label=n.label.concat(e.graphics.label))}r.pool=n},t}(n["default"]);t["default"]=m},941:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"initial.dataset.errorScatter":o(a(558))["default"]["initial.dataset.line"]};t["default"]=r},942:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"initial.dataset.errorScatter":o(a(937))["default"]["initial.dataset.errorLine"]};t["default"]=r},943:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(944))["default"];t["default"]=r},944:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=o(a(556)),l=a(673),s=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e),t.getName=function(){return"InverseMSArea"};var a=t.prototype;return a.getName=function(){return"InverseMSArea"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="area",t.isInverse=!0,t.zeroplanethickness=2,t.zeroplanealpha=80,t.showzeroplaneontop=1,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,l._setDefaultConfig.call(this)},a.getDSdef=function(){return n["default"]},a.getDSGroupdef=function(){},t}(i["default"]);t["default"]=s},945:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(946))["default"];t["default"]=r},946:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=o(a(538)),l=o(a(628)),s=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e),t.getName=function(){return"InverseMSColumn2d"};var a=t.prototype;return a.getName=function(){return"InverseMSColumn2d"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="column",t.isInverse=!0,t.enablemousetracking=!0},a.getDSdef=function(){return n["default"]},a.getDSGroupdef=function(){return l["default"]},t}(i["default"]);t["default"]=s},947:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(948))["default"];t["default"]=r},948:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=o(a(555)),l=a(673),s=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t}(0,r["default"])(t,e),t.getName=function(){return"InverseMSLine"};var a=t.prototype;return a.getName=function(){return"InverseMSLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="line",t.isInverse=!0,t.zeroplanethickness=1,t.zeroplanealpha=4,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,l._setDefaultConfig.call(this)},a.getDSdef=function(){return n["default"]},a.getDSGroupdef=function(){},t}(i["default"]);t["default"]=s},949:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(950))["default"];t["default"]=r},950:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(951)),n=o(a(954)),l=o(a(956)),s=o(a(957)),c=o(a(959)),d=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("limitUpdater",s["default"],["axis"]),t.registerFactory("dragTracker",c["default"],["canvas"]),t}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"DragColumn2D"},t.getName=function(){return"DragColumn2D"},a.getDSGroupdef=function(){return l["default"]},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.isDrag=!0},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=d},951:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(484)),l=o(a(483)),s=a(236),c=o(a(634)),d=o(a(952)),h=a(232),u=a(953),p=(0,h.getDepsByType)("transcoder"),g=i.preDefStr.UNDERSCORE,f=i.BLANKSTRING,m=0,v=function(e){var t,a=e.sender.apiInstance,o=a.getChildren("canvas")[0].getChildren("vCanvas")[0],r=a.config,i=e.data,n=i&&i.endValue,l=i&&i.startValue;(n>r.yMax||n<r.yMin||l===r.yMin||l===r.yMax)&&(t=o.getDataLimits(),r.yMax=t.max,r.yMin=t.min)},b=function(e){function t(){var t;return(t=e.call(this)||this).eiMethods.getDataWithId=function(){for(var e,t,a,o,r,i,n,l,s,c,d=this.apiInstance&&this.apiInstance.getJSONData(),h=[[f]],u=d.dataset,p=d.categories&&d.categories[0]&&d.categories[0].category,m=u&&u.length||0,v=0;m--;)if(r=u[m])for(h[0][m+1]=r.id||r.seriesname,n=r.id||m+1,c=(o=r.data)&&o.length||0,s=0;s<c;s+=1){if(!h[i=s+1]){for(a=p&&p[s+v]||{};a.vline;)a=p[s+(v+=1)]||{};t=a.label||a.name||f,h[i]=[t]}e=h[i],l=o[s].id||i+g+n,e[m+1]=[l,Number(o[s].value)]}return h},t.eiMethods.getData=function(e){var t,a,o=this.apiInstance&&this.apiInstance.getJSONData(),r=o.dataset,i=r&&r.length||0,n=0;if(e)a=e.toString().toLowerCase(),t=/^json$/gi.test(a)?o:p[a]().fromJSON(o,this).data;else for((t=d["default"].call(this.apiInstance)).unshift([f]);n<i;)t[0][n+1]=r[n++].seriesname;return t},t.eiMethods.setUpperLimit=function(e,t){var a,o=this.apiInstance;if(!t)return o.changeUpperLimits(e);o.addJob("setUpperLimitId"+m++,(function(){a=o.changeUpperLimits(e),"function"==typeof t&&t(a)}),s.priorityList.postRender)},t.eiMethods.setLowerLimit=function(e,t){var a,o=this.apiInstance;if(!t)return o.changeLowerLimits(e);o.addJob("setLowerLimitId"+m++,(function(){a=o.changeLowerLimits(e),"function"==typeof t&&t(a)}),s.priorityList.postRender)},t.eiMethods.getLowerLimit=function(e){var t=this.apiInstance,a=t.getChildren("yAxis")[0];if(a){if(!e)return a.config.axisRange.min;t.addJob("getLowerLimitId"+m++,(function(){"function"==typeof e&&e(a.config.axisRange.min)}),s.priorityList.postRender)}},t.eiMethods.getUpperLimit=function(e){var t=this.apiInstance,a=t.getChildren("yAxis")[0];if(a){if(!e)return a.config.axisRange.max;t.addJob("getUpperLimitId"+m++,(function(){"function"==typeof e&&e(a.config.axisRange.max)}),s.priorityList.postRender)}},t}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"DragBase"},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t),"DragNode"!==this.getName()&&this.getFromEnv("chartInstance").addEventListener("dataplotdragend",v)},a.mouseoutHandler=function(e,t,a){var o=this.config.datasetOrder||this.getDatasets(),r=this.getChildren("mouseTracker")[0];o[t]&&o[t].components.data[a]?o[t]._firePlotEvent(i.MOUSEOUT,a,e):this.getFromEnv("toolTipController").hideAll(),delete r._lastDatasetIndex,delete r._lastPointIndex},t.getName=function(){return"DragBase"},a._mouseEvtHandler=function(e,t){var a,o,r,n,l,s,c,d=this,h=t.mouseTracker,u=d.config.datasetOrder||d.getDatasets(),p=(0,i.getMouseCoordinate)(d.getFromEnv("chart-container"),e.originalEvent,d),g=!1,f=u.length,m=h._lastDatasetIndex,v=h._lastPointIndex;if(void 0!==v&&u[m]&&u[m].components.data[v]&&(s=u[m].components.data[v].config.dragStart),!s)for(;f--&&!g;)(a=u[f])&&a.getState("visible")&&(o=a._getHoveredPlot&&a._getHoveredPlot(p.chartX,p.chartY))&&o.hovered&&(g=!0,o.datasetIndex=f,l=h.getMouseEvents(e,o.datasetIndex,o.pointIndex));if(s&&void 0!==m&&(c=e.type===i.MOUSEOUT?i.MOUSEMOVE:e.type,u[m]&&u[m]._firePlotEvent&&u[m]._firePlotEvent(c,v,e)),!s&&(!g||l&&l.fireOut)&&void 0!==m&&u[m]&&u[m]._firePlotEvent&&(l&&!l.events.length?h.mouseoutTimer=setTimeout((function(){d.mouseoutHandler(e,m,v)}),20):(d.mouseoutHandler(e,m,v),clearTimeout(h.mouseoutTimer))),g)for((n=l.events&&l.events.length)&&(h._lastDatasetIndex=o.datasetIndex,v=h._lastPointIndex=o.pointIndex),r=0;r<n;r+=1)a&&a._firePlotEvent&&a._firePlotEvent(l.events[r],v,e)},a.parseChartAttr=function(t){e.prototype.parseChartAttr.call(this,t);var a,o=this.getFromEnv("dataSource").chart;(a=this.config).formAction=(0,i.getValidValue)(o.formaction),o.submitdataasxml!==i.ZEROSTRING||o.formdataformat||(o.formdataformat=p.csv().format),a.formDataFormat=(0,i.pluck)(o.formdataformat,p.xml().format),a.formTarget=(0,i.pluck)(o.formtarget,"_self"),a.formMethod=(0,i.pluck)(o.formmethod,"POST"),a.submitFormAsAjax=(0,i.pluckNumber)(o.submitformusingajax,1),a.restoreBtnTitle=(0,i.pluck)(o.restoretext,o.restorebtntitle,"Restore"),a.submitBtnTitle=(0,i.pluck)(o.submittext,o.formbtntitle,"Submit"),a.showFormBtn=(0,i.pluckNumber)(o.enablesubmit,o.showformbtn,1)&&a.formAction,a.showRestoreBtn=(0,i.pluckNumber)(o.enablerestore,o.showrestorebtn,1),a.formBtnTitle=(0,i.pluck)(o.formbtntitle,"Submit"),a.formBtnStyle={fontSize:a.style.outCanfontSize,fontFamily:a.style.outCanfontFamily,fontWeight:"bold"},a.restoreBtnWidth=(0,i.pluckNumber)(o.restorebtnwidth,0),a.allowAxisChange=(0,i.pluckNumber)(o.allowaxischange,1),o.toolbary||o.toolbarx?a.spaceHardCoded=!0:delete a.spaceHardCoded,a.drawTrendRegion=(0,i.pluckNumber)(o.drawcrossline,0)},a._storeIntialLimit=function(e,t){this.config.axisInitialLimit={min:e,max:t}},a.attachMenuButtons=function(){e.prototype.attachMenuButtons.call(this),this.addConfigureOptions()},a.addConfigureOptions=function(){var e,t,a=this,o=a.getFromEnv("toolbar"),r=o.getChild("hamburgerMenu-"+o.getId()+"-"+a.getId()+"-0"),i=a.config,n=[{name:"Increase Upper Limit",handler:function(){var e=a.getChildren("yAxis")[0].getLimit();a.changeUpperLimits(e.max+e.tickInterval)},action:"click"},{name:"Increase Lower Limit",handler:function(){var e=a.getChildren("yAxis")[0].getLimit();a.changeLowerLimits(e.min+e.tickInterval)},action:"click"},{name:"Decrease Upper Limit",handler:function(){var e=a.getChildren("yAxis")[0].getLimit();a.changeUpperLimits(e.max-e.tickInterval)},action:"click"},{name:"Decrease Lower Limit",handler:function(){var e=a.getChildren("yAxis")[0].getLimit();a.changeLowerLimits(e.min-e.tickInterval)},action:"click"}];i.showFormBtn&&(t={name:i.submitBtnTitle,handler:function(){u.submitData.call(a)},action:"click"},n.push(t)),i.showRestoreBtn&&(e={name:i.restoreBtnTitle,handler:function(){a.restoreData()},action:"click"},n.push(e)),i.allowAxisChange&&r.appendInMenu(n)},a.restoreData=function(){var e=this.getChildren("yAxis")[0],t=this.getFromEnv("chart-attrib"),a=this.config.axisInitialLimit;this.iterateComponents((function(e){var t;(t=e.getChildren("dataset"))&&t.forEach((function(e){e.restore()}))})),e.resetStoredLimits(),e.setAxisConfig({axisMaxValue:t.yaxismaxvalue,axisMinValue:t.yaxisminvalue}),e.setDataLimit(a.max,a.min),this.fireChartInstanceEvent("dataRestored",{}),this._manageInteractiveSpace()},a.changeLowerLimits=function(e){var t=this.getChildren("yAxis")[0],a=t.getLimit(),o=a.min,r=this.config,i=(0,l["default"])([r.yMin,t.getTrendLineLimits()[0]]),n=!1,s=a.max;return this.getFromEnv("animationManager").setAnimationState("update"),void 0!==e&&e<i&&e!==a.min&&r.allowAxisChange&&(o=e,n=!0),n&&(t.resetStoredLimits(),t.setAxisConfig({axisMaxValue:s,axisMinValue:o,showLowerLimit:!0}),t.setDataLimit(s,o),this._manageInteractiveSpace()),n},a.changeUpperLimits=function(e){var t,a=this.getChildren("yAxis")[0],o=a.getLimit(),r=o.min,i=this.config,l=(0,n["default"])([i.yMax,a.getTrendLineLimits()[1]]),s=!1;return this.getFromEnv("animationManager").setAnimationState("update"),void 0!==e&&e>l&&e!==o.max&&i.allowAxisChange&&(t=e,s=!0),s&&(a.resetStoredLimits(),a.setAxisConfig({axisMaxValue:t,axisMinValue:r,showUpperLimit:!0}),a.setDataLimit(t,r),this._manageInteractiveSpace()),s},a.getJSONData=function(){var e,t,a,o,r,n,l,s=this.getChildren("canvas")[0].getChildren("vCanvas")[0],c=this.getFromEnv("dataSource"),d=[];if(s.iterateComponents((function(t){"group"===t.getType()&&(e=t)})),e)d=e.getJSONData&&e.getJSONData();else for(n=(a=this.getDatasets()).length,r=0;r<n;r++)o={seriesname:(t=a[r]).config.seriesname,data:t.getJSONData().data},d.push(o);return(l=(0,i.extend2)({},c)).dataset=d,l},t}(c["default"]);b.prototype._manageInteractiveSpace=i._manageInteractiveSpace;var x=b;t["default"]=x},953:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t.submitData=function(){var e,t,a,o,i,s=this,c=new r["default"],d=s.config,h=l.json(),u=l.csv&&l.csv()||"csv",p=l.xml(),g=d.formAction,f=s.getFromEnv("chartInstance");d.formDataFormat===h.format?(e=h.format,s.getJSONData&&(t=JSON.stringify(s.getJSONData())),s.getCollatedData&&(t=JSON.stringify(s.getCollatedData()))):d.formDataFormat&&d.formDataFormat===u.format?(e=u.format,void 0!==(t=s.getCSVString&&s.getCSVString())&&""!==t||(s.getJSONData&&(t=u.fromJSON(s.getJSONData()).data),s.getCollatedData&&(t=u.fromJSON(s.getCollatedData()).data))):(e=p.format,s.getCollatedData&&(t=p.fromJSON(s.getCollatedData()).data),s.getJSONData&&(t=p.fromJSON(s.getJSONData()).data));s.fireChartInstanceEvent("beforeDataSubmit",{data:t},void 0,(function(){d.submitFormAsAjax?(c.onError=function(e,a,o,r){s.fireChartInstanceEvent("dataSubmitError",{xhrObject:a.xmlhttp,url:r,statusText:e,httpStatus:a.xmlhttp&&a.xmlhttp.status?a.xmlhttp.status:-1,data:t},[f.id,e,a.xmlhttp&&a.xmlhttp.status])},c.onSuccess=function(e,a,o,r){s.fireChartInstanceEvent("dataSubmitted",{xhrObject:c,response:e,url:r,data:t},[f.id,e])},(a={})["str"+e.toUpperCase()]=t,c.open&&c.abort(),c.post(g,a)):((o=window.document.createElement("span")).innerHTML='<form style="display:none" action="'+g+'" method="'+d.formMethod+'" target="'+d.formTarget+'"> <input type="hidden" name="strXML" value="'+(0,n.xssEncode)(t)+'"><input type="hidden" name="dataFormat" value="'+e.toUpperCase()+'" /></form>',i=o.removeChild(o.firstChild),window.document.body.appendChild(i),i.submit&&i.submit(),i.parentNode.removeChild(i),o=i=null)}),(function(){s.fireChartInstanceEvent("dataSubmitCancelled",{data:t})}))};var r=o(a(312)),i=a(232),n=a(224),l=(0,i.getDepsByType)("transcoder")},954:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t.updateDataValue=t._restore=t._getJSONData=t["default"]=void 0;var r,i,n=o(a(238)),l=o(a(538)),s=a(224),c=o(a(955)),d=a(232),h=s.preDefStr.setRolloverAttrStr,u=s.preDefStr.setRolloutAttrStr,p=s.preDefStr.DATAPLOTCLICK,g=s.hasSVG?"ns-resize":"n-resize",f=function(e,t){var a,o=t.getChildren("yAxis")[0],r=t.getFromEnv("chart-container"),i=this.data("eventArgs");a=(0,s.getMouseCoordinate)(r,e,t),i.value=o.getValue(a.chartY),this.data("eventArgs",i)};t.updateDataValue=f,t._restore=i,t._getJSONData=r,(0,d.addDep)({name:"dragColumnAnimation",type:"animationRule",extension:c["default"]});var m=function(e){function t(){return e.apply(this,arguments)||this}(0,n["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"dragColumn"},a.configureAttributes=function(t){var a=this.config,o=this.getFromEnv("chart-attrib"),r=a.JSONData;a.allowDrag=(0,s.pluckNumber)(r.allowdrag,1),a.allowNegDrag=(0,s.pluckNumber)(r.allownegativedrag,1),a.allowAxisChange=(0,s.pluckNumber)(o.allowaxischange,1),a.snapToDivOnly=(0,s.pluckNumber)(o.snaptodivonly,0),a.snapToDiv=a.snapToDivOnly?1:(0,s.pluckNumber)(o.snaptodiv,1),a.doNotSnap=(0,s.pluckNumber)(o.donotsnap,0),a.snapToDivRelaxation=(0,s.pluckNumber)(o.snaptodivrelaxation,10),a.doNotSnap&&(a.snapToDiv=a.snapToDivOnly=0),e.prototype.configureAttributes.call(this,t)},a._plotConfigure=function(t,a){var o,r=this.config,i=this.components.data;e.prototype._plotConfigure.call(this,t,a),(o=i[t].config).allowDrag=(0,s.pluckNumber)(a.allowdrag,r.allowDrag),o.allowNegDrag=(0,s.pluckNumber)(a.allownegativedrag,r.allowNegDrag)},a.drag=function(e,t,a,o){var r,i,n,l,c,d,p,m,v,b,x,k,y,C,w,A,S,N,L,D,E=o,T=this.config,F=this.getFromEnv("chart"),P=F.config,_=P.canvasTop,V=P.canvasBottom,I=this.getFromEnv("toolTipController"),B=this.getFromEnv("number-formatter"),M=this.components.data,O=this.getFromEnv("paper").canvas.style,R=this.getFromEnv("yAxis"),G=R.yBasePos,H=P.yaxisname,z={xaxisName:P.xaxisname,yaxisName:H},W=R.getTicks(),U=P.dragTolerance+1,j=T.JSONData,J=this.getFromEnv("chart-attrib"),K=P.useplotgradientcolor,q=P.useroundedges,Y=this.getFromEnv("chart-container"),X=(0,s.mathAbs)(R.getValue(R.getPixel(0)-T.snapToDivRelaxation)),Q=T.snapToDivOnly?.5*(0,s.mathAbs)(W[1]-W[0]):X;switch(E=E||(0,s.getMouseCoordinate)(Y,t,F),e){case"dragstart":i=(S=M[a]).config,r=S.graphics.element,d=S._yPos,m=S._height,n=i.setValue<0?d+m:d,D=i.allowDrag,x=E.chartY,D&&x>=n-U&&x<=n+U?(i.dragStart=!0,i._pointerDy=0,i._dragStartY=x,i._dragBuffer=n-x,S.startValue=i.setValue,S.name=T.seriesname,S.datasetIndex=T.index,S.dragged=!0):i.dragStart=!1;break;case"dragmove":(i=(S=M[a]).config).dragStart&&(r=S.graphics.element,C=i.plotIndex,b=i.allowNegDrag?V:G,x=E.chartY,i._rollOverResponseSetterFire=!1,O.cursor=g,i._pointerDy++,(x+=i._dragBuffer)<_?x=_:x>b&&(x=b),d=G<x?G:x,m=(0,s.mathAbs)(G-x),S._yPos=d,S._height=m,n=d>=G?d+m:d,i._y=l=i.setValue=R.getValue(n),c=B.dataLabels(l),i.toolTipValue=c,i.displayValue=(0,s.pluck)(i.setDisplayValue,c),K&&!q&&(i.colorArr[0].FCcolor.angle=p=d<G?90:270),r.attr({y:S._yPos,height:S._height}),this.parseLabelAttributes(S),this.drawLabel(C,C+1),S.graphics.element=r,I.hide(T.currentToolTip),1===i._pointerDy&&(w={index:a,dataIndex:a,datasetIndex:S.datasetIndex,startValue:S.startValue,datasetName:S.name,color:i.originalPlotColor,gradientColor:T.plotgradientcolor,alpha:i.plotFillAlpha,borderColor:T.plotbordercolor,borderAlpha:i.plotBorderAlpha,borderThickness:P.plotborderthickness,borderDashed:i.dashed,hoverColor:i.hoverColor,hoverAlpha:i.hoverAlpha,borderHoverColor:i.hoverBorderColor,borderHoverAlpha:i.hoverBorderAlpha},F.fireChartInstanceEvent("dataplotDragStart",w)));break;case"dragend":var Z;i=(S=M[a]).config,Z=S._height,i.dragStart&&(d=S._yPos,r=S.graphics.element,N=(0,s.getValidValue)((0,s.parseUnsafeString)((0,s.pluck)(S.tooltext,j.plottooltext,J.plottooltext),!1)),x=E.chartY,this.setMaxMin(S),0===i.givenPlotShowValue?i.showValue=0:1===i.givenPlotShowValue?i.showValue=1:1!==i.givenPlotShowValue&&T.showValues&&(Math.sqrt(Z*Z)<i.minplotheightforvalue?i.showValue=0:i.showValue=1),(T.snapToDiv||T.snapToDivOnly)&&(i.setValue=(0,s.snapPoint)({snapPixel:Q,datasetConf:T},W,S),d=G<(x=R.getPixel(i.setValue))?G:x,m=(0,s.mathAbs)(G-x),S._yPos=d,S._height=m,r.attr({y:d,height:m}),c=B.dataLabels(i.setValue),i.toolTipValue=c,i.displayValue=(0,s.pluck)(i.setDisplayValue,c),this.parseLabelAttributes(S),this.drawLabel(C,C+1)),w={index:a,dataIndex:a,datasetIndex:S.datasetIndex,startValue:S.startValue,endValue:i.setValue,datasetName:S.name,color:i.originalPlotColor,gradientColor:T.plotgradientcolor,alpha:i.plotFillAlpha,borderColor:T.plotbordercolor,borderAlpha:i.plotBorderAlpha,borderThickness:P.plotborderthickness,borderDashed:i.dashed,hoverColor:i.hoverColor,hoverAlpha:i.hoverAlpha,borderHoverColor:i.hoverBorderColor,borderHoverAlpha:i.hoverBorderAlpha,id:i.id},A=[F.getFromEnv("chartInstance").id,w.dataIndex,w.datasetIndex,w.datasetName,w.startValue,w.endValue],f.call(r,t,F),i._pointerDy&&(F.fireChartInstanceEvent("dataplotDragEnd",w),F.fireChartInstanceEvent("chartupdated",w,A)),K&&!q&&(p=d>=G?90:270,(v=r.data(h))&&v.fill&&((k=(k=v.fill).split("-"))[0]=p,v.fill=k.join("-")),(y=r.data(u))&&y.fill&&((k=(k=y.fill).split("-"))[0]=p,y.fill=k.join("-"))),i._dragBuffer=0,i._pointerDy=0,void 0!==N&&(z.formattedValue=i.toolTipValue,z.label=i.label,L=(0,s.parseTooltext)(N,[1,2,3,4,5,6,7],z,{value:i.toolTipValue},void 0,j),i.setTooltext=L,N=L,i.toolText=L),L=i.finalTooltext=!1!==i.toolText?i.toolText+(N?"":i.toolTipValue):"",x>=n-U&&x<=n+U||(O.cursor="default"),i.dragStart=!1)}},a._firePlotEvent=function(e,a,o){var r,i,n=this.getFromEnv("chart"),l=this.config,c=l.currentToolTip,d=this.getFromEnv("chartConfig"),h=d.drawTrendRegion,u=this.getFromEnv("paper").canvas.style,f=this.getFromEnv("toolTipController"),m=this.components.data[a],v=m.config,b=m.graphics.element,x=v.finalTooltext||v.toolText,k=o.originalEvent,y=(0,s.getMouseCoordinate)(this.getFromEnv("chart-container"),k,n).chartY,C=m._yPos,w=m._height,A=this.getFromEnv("yAxis").yBasePos,S=v.allowDrag,N=C,L=C+w;if(r=d.dragTolerance+1,i=C>=A?C+w:C,b)switch(e){case"fc-mouseover":y<=L-r&&y>=N+r&&!h&&x&&(c?f.draw(k,x,c):c=l.currentToolTip=f.draw(k,x)),!v._rollOverResponseSetterFire&&y<=L&&y>=N&&(t._rolloverResponseSetter(n,b,o,this),v._rollOverResponseSetterFire=!0);break;case"fc-mouseout":u.cursor="default",v._rollOverResponseSetterFire&&t._rolloutResponseSetter(n,b,o,this),v._rollOverResponseSetterFire=!1,f.hide(l.currentToolTip);break;case"fc-click":n.plotEventHandler(b,o,p);break;case"fc-mousemove":v.dragStart||(i=v.setValue<0?C+w:C,S&&y>=i-r&&y<=i+r?(u.cursor=g,f.hide(l.currentToolTip)):(u.cursor="default",v._rollOverResponseSetterFire&&!h&&x&&(c?f.draw(k,x,c):c=l.currentToolTip=f.draw(k,x))),!v._rollOverResponseSetterFire&&y<=L&&y>=N?(t._rolloverResponseSetter(n,b,o),v._rollOverResponseSetterFire=!0):!v._rollOverResponseSetterFire||y<=L&&y>=N||(f.hide(l.currentToolTip),v._rollOverResponseSetterFire=!1,t._rolloutResponseSetter(n,b,o,this)))}},t._rolloverResponseSetter=function(e,t,a,o){var r=t&&t.getData(),i=e.getFromEnv("animationManager");t&&0!==r.showHoverEffect&&!0!==r.draged&&t&&(i.setAnimationState("mouseOver"),i.setAnimation({el:t,label:"rect",component:o,attr:t.getData().setRolloverAttr}),e.plotEventHandler(t,a,"DataPlotRollOver"))},t._rolloutResponseSetter=function(e,t,a,o){var r=t&&t.getData(),i=e.getFromEnv("animationManager");t&&0!==r.showHoverEffect&&!0!==r.draged&&(i.setAnimationState("mouseOut"),i.setAnimation({el:t,label:"rect",component:o,attr:t.getData().setRolloutAttr}),e.plotEventHandler(t,a,"DataPlotRollOut"))},a.getJSONData=function(){var e,t,a,o,r,i=this.config.JSONData.data,n=this.components.data,l=[],s={};for(r=0,o=i.length;r<o;r++){for(a in t=i[r],e=n[r],s={},t)s[a]="value"===a?e.config.setValue:t[a];l.push(s)}return{data:l}},a.restore=function(){this.setData(this.config.JSONData,!0)},t}(l["default"]);t._getJSONData=r=m.prototype.getJSONData,t._restore=i=m.prototype.restore;var v=m;t["default"]=v},955:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"initial.dataset.dragColumn":o(a(539))["default"]["initial.dataset.column"]};t["default"]=r},956:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(628)),n=a(224),l=function(e){function t(){return e.apply(this,arguments)||this}return(0,r["default"])(t,e),t.prototype.getJSONData=function(){var e,t,a,o,r=this.getChildren("dataset"),i=[],l=r.length;for(o=0;o<l;o++)e=r[o],delete(a=(0,n.extend2)({},this.getFromEnv("dataSource").dataset[o])).data,t=e.getJSONData(),i.push((0,n.extend2)(a,t));return i},t}(i["default"]);t["default"]=l},957:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o=e.getChildren("yAxis")[0];(0,r.componentFactory)(o,i["default"],"limitUpdater",e.config.allowAxisChange?1:0),t=o.getChildren("limitUpdater"),(a=t&&t[0])&&a.configure()};var r=a(224),i=o(a(958))},958:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r,i=o(a(238)),n=a(240),l=o(a(226)),s=a(224);function c(e){var t=e.target;t.justFocussed&&(t.justFocussed=!1,s.hasTouch||t.select())}function d(e,t,a){var o=this.config.linkedAxis.getLinkedParent();if(e!==t+"")return a?o.changeUpperLimits&&o.changeUpperLimits(Number(e)):o.changeLowerLimits&&o.changeLowerLimits(Number(e))}function h(e){var t,a=e.target,o={opacity:1,filter:"alpha(opacity=100)",color:(0,s.rgbaToHex)(a.axisLabel.attr("fill"))};for(t in o)a.style[t]=o[t];a.value=a.dataValue,a.justFocussed=!0,a.hasFocus=!0,a.axisLabel&&a.axisLabel.hide()}function u(e){var t=e.target,a=t.value,o=t.oldValue,r=t.isMaxLabel;d.call(this,a,o,r),t.style.opacity=0,t.style.filter="alpha(opacity=0)",t.axisLabel&&t.axisLabel.show(),s.isIE&&document.getElementsByTagName("body")[0].focus&&document.getElementsByTagName("body")[0].focus(),t.justFocussed=!1,t.hasFocus=!1}function p(e){var t=e.target,a=function(e){return"number"==typeof e.which?e.which:e.keyCode}(e.originalEvent),o=t.value,r=t.oldValue,i=t.isMaxLabel;13===a?!1===d.call(this,o,r,i)?t.style.color="#dd0000":l["default"].fire(t,"blur",e):27===a&&(t.value=r,l["default"].fire(t,"blur",e))}function g(e){return function(t){e.parentNode&&l["default"].fire(e,"blur",t)}}function f(e){return function(t){t.target!==e&&e.hasFocus&&l["default"].fire(e,"blur",t)}}function m(e,t){l["default"].unlisten(this.config.linkedAxis.getLinkedParent(),"defaultprevented",t),e.parentNode.removeChild(e)}function v(e,t){return function(){l["default"].unlisten(r.getLinkedParent().getLinkedItem("container"),"mousedown",t),e.parentNode.removeChild(e)}}var b=function(e){function t(){return e.apply(this,arguments)||this}(0,i["default"])(t,e);var a=t.prototype;return a.configureAttributes=function(){this.config.linkedAxis=this.getLinkedParent(),r=this.config.linkedAxis,this.config.onKeyUp=p.bind(this),this.config.onBlur=u.bind(this),this.config.onFocus=h.bind(this),this.config.onMouseUp=c.bind(this)},a.getType=function(){return"helper"},a.getName=function(){return"limitUpdater"},a.draw=function(){var e,t,a,o,r,i,n,c,d,h,u,p,b=this.getFromEnv("chartConfig"),x=this.config.linkedAxis,k=x.getAxisConfig("extremeLabels"),y=x.getLimit(),C=this.getFromEnv("chart-container"),w=this.getFromEnv("style").inCanvasStyle,A=(0,s.extend2)({outline:"none","-webkit-appearance":"none",filter:"alpha(opacity=0)",position:"absolute",background:"transparent",border:"1px solid #cccccc",textAlign:"right",top:0,left:0,width:50,zIndex:20,opacity:0,borderRadius:0,display:"block"},w),S={max:{element:k.lastLabel.graphic,value:y.max},min:{element:k.firstLabel.graphic,value:y.min}};for(o in A.color=(0,s.hashify)(A.color),A.fontSize=A.fontSize+"px",S)if(S.hasOwnProperty(o)){if(i=(a=S[o].element)&&a.getBBox(),c=S[o].value,n="max"===o,t=o+"Input",e=this.getGraphicalElement(t),!i||!a){e&&(e.style.display="none");continue}for(r in e||(e=this.addGraphicalElement(t,(0,s.createElement)("input",{type:"text",value:c,id:"fc-updater-"+o},C))),l["default"].listen(e,["focus","mouseup","blur","keyup"],[this.config.onFocus,this.config.onMouseUp,this.config.onBlur,this.config.onKeyUp]),s.hasSVG?(l["default"].listen(C,"defaultprevented",d=g(e)),l["default"].listen(C,"destroy",m.bind(this,e,d))):(l["default"].listen(C,"mousedown",p=f(e)),l["default"].listen(C,"destroy",v(e,p))),h=i.x+i.width-b.marginLeft,u=b.marginLeft,A.top=i.y+"px",A.left=u+"px",A.width=h+"px",A)A.hasOwnProperty(r)&&(e.style[r]=A[r]);e.dataValue=c,e.value=c,e.oldValue=c,e.name=c||"",e.axisLabel=a,e.isMaxLabel=n}},a.removingDraw=function(){var e,t,a=this.getGraphicalElement();for(e in a)a.hasOwnProperty(e)&&((t=a[e])&&t.parentNode&&t.parentNode.removeChild(t),delete a[e])},t}(n.ComponentInterface);t["default"]=b},959:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){(0,i.componentFactory)(e,r["default"],"dragTracker"),e.getChildren("dragTracker")[0].addEvents()};var r=o(a(960)),i=a(224)},960:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(242)),i=o(a(238)),n=a(240),l=a(224),s=function(e){return function(t){var a=e.config;a.dragStart&&a.hoveredDS.drag("dragmove",t,a.hoveredInfo.pointIndex)}},c=function(e){return function(t){var a=e.config;a.dragStart&&a.hoveredDS.drag("dragend",t,a.hoveredInfo.pointIndex),a.dragStart=!1}},d=["fc-dragstart","fc-dragmove","fc-dragend"],h=function(e){function t(){var t,a;return(t=e.call(this)||this).config.eventCb={"fc-dragstart":(a=(0,r["default"])(t),function(e){for(var t,o,r,i=a.getFromEnv("chart"),n=a.config,s=i.config.datasetOrder||i.getDatasets(),c=(0,l.getMouseCoordinate)(i.getFromEnv("chart-container"),e,i),d=s.length;d--&&!t;)(r=s[d])&&r.getState("visible")&&(o=r._getHoveredPlot&&r._getHoveredPlot(c.chartX,c.chartY))&&o.hovered&&(t=!0,n.dragStart=!0,n.hoveredInfo=o,n.hoveredDS=r,r.drag("dragstart",e,o.pointIndex,c))}),"fc-dragmove":s((0,r["default"])(t)),"fc-dragend":c((0,r["default"])(t))},t}(0,i["default"])(t,e);var a=t.prototype;return a.addEvents=function(){var e=this,t=e.getFromEnv("chart").getChildren("canvas");e.removeEvents(),t.forEach((function(t){d.forEach((function(a){t.addEventListener(a,e.config.eventCb[a])}))}))},a.removeEvents=function(){var e=this;e.getFromEnv("chart").getChildren("canvas").forEach((function(t){d.forEach((function(a){t.removeEventListener(a,e.config.eventCb[a])}))}))},a._dispose=function(){this.removeEvents(),e.prototype._dispose.call(this)},t}(n.ComponentInterface);t["default"]=h},961:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(962))["default"];t["default"]=r},962:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(963)),n=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"DragLine"},t.getName=function(){return"DragLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.isDrag=!0,t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1},a.getDSdef=function(){return i["default"]},t}(o(a(967))["default"]);t["default"]=n},963:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(555)),n=a(964),l=a(224),s=a(954),c=a(232),d=o(a(966));(0,c.addDep)({name:"dragLineAnimation",type:"animationRule",extension:d["default"]});var h=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a._firePlotEvent=function(){n.__firePlotEvent.apply(this,arguments)},a.updateImage=function(e){n._updateImage.call(this,e)},a.drag=function(){n._drag.apply(this,arguments)},a.configureAttributes=function(){n.configurer.apply(this,arguments)},a._plotConfigure=function(t,a){var o,r=this.config,i=this.components.data;e.prototype._plotConfigure.call(this,t,a),(o=i[t].config).allowDrag=(0,l.pluckNumber)(a.allowdrag,r.allowDrag),o.allowNegDrag=(0,l.pluckNumber)(a.allownegativedrag,r.allowNegDrag)},a.getType=function(){return"dataset"},a.getName=function(){return"dragLine"},a.restore=function(){s._restore.call(this)},a.getJSONData=function(){return s._getJSONData.call(this)},t}(i["default"]);t["default"]=h},964:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=t._drag=t._updateImage=t.configurer=t.__firePlotEvent=void 0;var r,i,n,l,s=o(a(238)),c=o(a(556)),d=a(224),h=a(954),u=o(a(965)),p=a(232),g="DataPlotRollOut",f=d.hasSVG?"ns-resize":"n-resize",m=Math.min,v=Math.max;t._drag=l,t.__firePlotEvent=n,t.configurer=i,t._updateImage=r,(0,p.addDep)({name:"dragAreaAnimation",type:"animationRule",extension:u["default"]});var b=function(e){function t(){return e.apply(this,arguments)||this}(0,s["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"dragArea"},a.configureAttributes=function(t){var a=this.config,o=this.getFromEnv("chart-attrib"),r=a.JSONData;a.allowDrag=(0,d.pluckNumber)(r.allowdrag,1),a.allowNegDrag=(0,d.pluckNumber)(r.allownegativedrag,1),a.allowAxisChange=(0,d.pluckNumber)(o.allowaxischange,1),a.snapToDivOnly=(0,d.pluckNumber)(o.snaptodivonly,0),a.doNotSnap=(0,d.pluckNumber)(o.donotsnap,0),a.snapToDiv=(0,d.pluckNumber)(o.snaptodiv,1),a.snapToDivRelaxation=(0,d.pluckNumber)(o.snaptodivrelaxation,10),a.doNotSnap&&(a.snapToDiv=a.snapToDivOnly=0),e.prototype.configureAttributes.call(this,t)},a._plotConfigure=function(t,a){var o,r=this.config;e.prototype._plotConfigure.call(this,t,a),(o=this.components.data[t].config).allowDrag=(0,d.pluckNumber)(a.allowdrag,r.allowDrag),o.allowNegDrag=(0,d.pluckNumber)(a.allownegativedrag,r.allowNegDrag)},t.updateImage=function(e){var t,a=e.graphics,o=a.image||a.element,r=e.config,i=r.anchorProps,n=r.hoverEffects,l=o&&o.data("imgRef"),s=i.imageScale,c=l.height*s*.01,h=l.width*s*.01,u=e._xPos,p=e._yPos,g=n.imageHoverScale,f=l.width*g*.01,v=l.height*g*.01,b=i.radius=i.isAnchorRadius?i.radius:m(h,c)/2,x=i.imagePadding,k=b-x-.5*i.borderThickness,y=n.radius-x-.5*n.anchorBorderThickness,C=i.symbol[1],w=(0,d.polyPathToPath)([C||2,u,p,y>0?y:0,n.startAngle,n.dip]),A=(0,d.polyPathToPath)([C||2,u,p,k>0?k:0,i.startAngle,0]),S={x:u-l.width*s*.005,y:p-l.height*s*.005,width:h,height:c,alpha:100};S["clip-path"]=A,(t={x:u-l.width*g*.005,y:p-l.height*g*.005,width:f,height:v,alpha:100})["clip-path"]=w,o.attr(S),o.data("setRolloverAttr",t),o.data("setRolloutAttr",S)},a.drag=function(e,a,o,r){var i,n,l,s,c,u,p,g,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V=r,I=this.config,B=I.index,M=this.getFromEnv("chart"),O=M.config,R=O.canvasTop,G=this.components.data,H=this.getFromEnv("paper").canvas.style,z=this.getFromEnv("yAxis"),W=z.getTicks(),U=(0,d.mathAbs)(z.getValue(z.getPixel(0)-I.snapToDivRelaxation)),j=I.snapToDivOnly?.5*(0,d.mathAbs)(W[1]-W[0]):U,J={xaxisName:O.xaxisname,yaxisName:O.yaxisname},K=this.getGraphicalElement().lineElement,q=O.dragTolerance+1,Y=this.getName(),X="dragLine"===Y||"dragArea"===Y,Q=I.JSONData,Z=this.getFromEnv("chart-container");switch(V=V||(0,d.getMouseCoordinate)(Z,a,M),e){case"dragstart":l=(i=G[o]).config,u=i._yPos,w=i._xPos,C=l.allowDrag,m=V.chartY,x=V.chartX,C&&m>=u-q&&m<=u+q&&x<=w+q&&x>=w-q?(l.dragStart=!0,l._pointerDy=0,l._dragStartY=m,l._dragBuffer=u-m,i.dragged=!0,i.startValue=l.setValue,i.name=I.seriesname,i.datasetIndex=I.index,b=l.anchorProps,F=l.hoverEffects,v={index:NaN,dataIndex:NaN,datasetIndex:i.datasetIndex,startValue:i.startValue,datasetName:i.name,color:l.color,alpha:l.alpha,anchorBgColor:b.bgColor,anchorBgAlpha:b.anchorBgAlpha,anchorAlpha:b.anchorAlpha,anchorBorderColor:b.borderColor,anchorBorderThickness:b.borderThickness,anchorRadius:b.radius,anchorSides:b.sides,anchorStartAngle:b.startAngle,anchorHoverColor:F.anchorColor,anchorHoverAlpha:F.anchorAlpha,anchorHoverSides:F.anchorSides,dashed:l.dashed,valuePosition:l.valuePosition,id:l.id},l.dragStart=!0):l.dragStart=!1;break;case"dragmove":(l=(i=G[o]).config).dragStart&&(m=V.chartY,l.allowDrag&&(H.cursor=f),n=i.graphics.element,l._pointerDy++,S=i.graphics.image,w=i._xPos,E=n,m+=l._dragBuffer,g=l.allowNegDrag?O.canvasBottom:z.yBasePos,P=(b=l.anchorProps).startAngle||90,F=l.hoverEffects,T=l.hoverEffects&&l.hoverEffects.enabled,b.imageUrl,m<R?m=R:m>g&&(m=g),i._yPos=u=m,l._y=s=l.setValue=z.getValue(u),l._Py=z.getPixel(l._y),c=this.getFromEnv("number-formatter").dataLabels(s),l.toolTipValue=c,l.displayValue=c,this.parseLabelAttributes(i,void 0),this.drawLabel(void 0,NaN),i.graphics.element=n,this.getFromEnv("toolTipController").hide(I.currentToolTip),T&&(p=E.data("setRolloverAttr"))&&(p.path=(0,d.polyPathToPath)([F.anchorSides||2,w,u,F.anchorRadius,F.startAngle,F.dip])),T&&(A=E.data("setRolloutAttr"))&&(A.path=(0,d.polyPathToPath)([b.symbol[1]||2,w,u,b.radius,b.startAngle,l.dip||0])),E&&E.attr(A||{path:(0,d.polyPathToPath)([b.symbol[1]||2,w,u,b.radius,P,0])}),S&&t.updateImage(i),X&&this.drawCommonElements(),K&&(I=this.config,N=l.pathStartIndex,L=l.pathEndIndex,D=l.lastPath,D=this.getLinePath(G,{begin:N,end:L}),K.attr({path:D.getPathArr()})),1===l._pointerDy&&(v={index:o,dataIndex:o,datasetIndex:B,startValue:i.startValue,datasetName:i.name,color:l.color,alpha:l.alpha,anchorBgColor:b.bgColor,anchorBgAlpha:b.anchorBgAlpha,anchorAlpha:b.anchorAlpha,anchorBorderColor:b.borderColor,anchorBorderThickness:b.borderThickness,anchorRadius:b.radius,anchorSides:b.sides,anchorStartAngle:b.startAngle,anchorHoverColor:F.anchorColor,anchorHoverAlpha:F.anchorAlpha,anchorHoverSides:F.anchorSides,dashed:l.dashed,valuePosition:l.valuePosition,id:l.id},M.fireChartInstanceEvent("dataplotDragStart",v)));break;case"dragend":(l=(i=G[o]).config).dragStart&&(this.setMaxMin(i),(I.snapToDiv||I.snapToDivOnly)&&(n=i.graphics.element,S=i.graphics.image,w=i._xPos,E=n,P=(b=l.anchorProps).startAngle||90,F=l.hoverEffects,T=l.hoverEffects&&l.hoverEffects.enabled,b.imageUrl,l.setValue=(0,d.snapPoint)({snapPixel:j,datasetConf:I},W,i),m=z.getPixel(l.setValue),i._yPos=u=m,l._y=s=l.setValue,l._Py=z.getPixel(l._y),c=this.getFromEnv("number-formatter").dataLabels(s),l.toolTipValue=c,l.displayValue=c,this.parseLabelAttributes(i,void 0),this.drawLabel(void 0,NaN),i.graphics.element=n,T&&(p=E.data("setRolloverAttr"))&&(p.path=(0,d.polyPathToPath)([F.anchorSides||2,w,u,F.anchorRadius,F.startAngle,F.dip])),T&&(A=E.data("setRolloutAttr"))&&(A.path=(0,d.polyPathToPath)([b.symbol[1]||2,w,u,b.radius,b.startAngle,l.dip||0])),E&&E.attr(A||{path:(0,d.polyPathToPath)([b.symbol[1]||2,w,u,b.radius,P,0])}),S&&t.updateImage(i),X&&this.drawCommonElements(),K&&(I=this.config,N=l.pathStartIndex,L=l.pathEndIndex,D=l.lastPath,D=this.getLinePath(G,{begin:N,end:L}),K.attr({path:D.getPathArr()}))),v={index:o,dataIndex:o,datasetIndex:B,startValue:i.startValue,endValue:l.setValue,datasetName:i.name,color:l.color,alpha:l.alpha,anchorBgColor:b.bgColor,anchorBgAlpha:b.anchorBgAlpha,anchorAlpha:b.anchorAlpha,anchorBorderColor:b.borderColor,anchorBorderThickness:b.borderThickness,anchorRadius:b.radius,anchorSides:b.sides,anchorStartAngle:b.startAngle,anchorHoverColor:F.anchorColor,anchorHoverAlpha:F.anchorAlpha,anchorHoverSides:F.anchorSides,dashed:l.dashed,valuePosition:l.valuePosition,id:l.id},_=[M.getFromEnv("chartInstance").id,v.dataIndex,v.datasetIndex,v.datasetName,v.startValue,v.endValue],n&&h.updateDataValue.call(n,a,M),l._pointerDy&&(M.fireChartInstanceEvent("dataplotDragEnd",v),M.fireChartInstanceEvent("chartupdated",v,_)),void 0!==(k=(0,d.getValidValue)((0,d.parseUnsafeString)((0,d.pluck)(i.tooltext,Q.plottooltext,this.getFromEnv("chart-attrib").plottooltext),!1)))&&(J.formattedValue=l.toolTipValue,J.label=l.label,y=(0,d.parseTooltext)(k,[1,2,3,4,5,6,7],J,{value:l.toolTipValue},void 0,Q),l.setTooltext=y,k=y,l.toolText=y),y=l.finalTooltext=!1!==l.toolText?k||l.toolText.substring(0,l.toolText.indexOf(l.formatedVal))+l.toolTipValue:"",m>=u-q&&m<=u+q&&x<=w+q&&x>=w-q||(H.cursor="default"),l._dragBuffer=0,l._pointerDy=0,l.dragStart=!1)}},a._firePlotEvent=function(e,t,a){var o,r,i,n,l,s,c,h,u,p,m,b,x,k=this.config,y=this.getFromEnv("chart"),C=this.getFromEnv("chartConfig").drawTrendRegion,w=this.getFromEnv("paper"),A=this.getFromEnv("toolTipController"),S=w.canvas.style,N=this.components.data[t],L=k.currentToolTip,D=a.originalEvent;if("touchend"===e&&(b=D.changedTouches[0],D.pageX=b&&b.pageX,D.pageY=b&&b.pageY),i=(r=(0,d.getMouseCoordinate)(y.getFromEnv("chart-container"),D,y)).chartY,n=r.chartX,N)switch(c=N.graphics.element,x=(m=N.config).anchorProps,u=m.finalTooltext,h=m.hoverEffects.enabled,p=m.eventArgs,l=N._yPos,s=N._xPos,m.dragTolerance=m.dragTolerance<x.markerRadius?x.markerRadius+.5:m.dragTolerance,o=v(m.dragTolerance,m.hoverEffects.anchorRadius||0)+1,e){case"fc-mouseover":m.allowDrag&&(S.cursor=f),m.dragStart||!u||m.dragStart||C||(L?A.draw(D,u,L):L=k.currentToolTip=A.draw(D,u)),m.dragStart||(h&&this._hoverPlotAnchor(N,"DataPlotRollOver"),c&&y.plotEventHandler(c,a,"DataPlotRollOver",p));break;case"fc-mouseout":S.cursor="default",h&&this._hoverPlotAnchor(N,g),c&&y.plotEventHandler(c,a,g,p),A.hide(k.currentToolTip);break;case"fc-mousemove":!m.dragStart&&u&&i>=l-o&&i<=l+o&&n<=s+o&&n>=s-o?(m.allowDrag&&(S.cursor=f),L?A.draw(D,u,L):L=k.currentToolTip=A.draw(D,u)):A.hide(k.currentToolTip);break;case"fc-click":c&&y.plotEventHandler(c,a,"dataplotclick",p)}},a.restore=function(){h._restore.call(this)},a.getJSONData=function(){return h._getJSONData.call(this)},t}(c["default"]);t._updateImage=r=b.prototype.updateImage,t.__firePlotEvent=n=b.prototype._firePlotEvent,t.configurer=i=b.prototype.configureAttributes,t._drag=l=b.prototype.drag;var x=b;t["default"]=x},965:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.dragArea":o(a(557))["default"]["*.dataset.area"]};t["default"]=r},966:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.dragLine":o(a(558))["default"]["*.dataset.line"]};t["default"]=r},967:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(950)),n=o(a(964)),l=a(224),s=a(673),c=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getName=function(){return"DragArea"},t.getName=function(){return"DragArea"},a.getDSGroupdef=function(){},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;s._setDefaultConfig.call(this),t.isDrag=!0,t.anchoralpha=l.HUNDREDSTRING,t.enablemousetracking=!0,t.defaultcrosslinethickness=1},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=c},968:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(969))["default"];t["default"]=r},969:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(970)),n=o(a(973)),l=a(224),s=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e),t.getName=function(){return"Kagi"};var a=t.prototype;return a.getName=function(){return"Kagi"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.singleseries=!0,t.hasLegend=!1,t.defaultDatasetType="kagi",t.setAdaptiveMin=!0,t.anchorborderthickness=1,t.anchorimageurl=void 0,t.anchorimagepadding=1,t.anchorsides=1,t.anchoralpha=void 0,t.anchorbgalpha="100",t.anchorimagealpha="100",t.anchorimagescale=100,t.anchorstartangle=90,t.anchorshadow=0,t.anchorbgcolor=void 0,t.anchorbordercolor=void 0,t.anchorradius=3,t.showvalues=1,t.plotfillalpha="70",t.linedashlen=5,t.linedashgap=4,t.linedashed=void 0,t.linealpha="100",t.linethickness=2,t.drawfullareaborder=1,t.connectnulldata=0,t.zeroplanethickness=1,t.enablemousetracking=!0,t.zeroplanealpha=40,t.showzeroplaneontop=0},a._getDataset=function(){var e=[];return this.iterateComponents((function(t){t.getType&&"dataset"===t.getType()&&e.push(t)})),e},a._postSpaceManagement=function(){var e,t=this.config,a=this.getChildren("xAxis")[0],o=this.getChildren("yAxis")[0],r=this.getChildren("canvas")[0],i=r.config,n=i.canvasBorderWidth,s=(0,l.pluckNumber)(i.canvasPadding,15),c=i.canvasPaddingTop,d=i.canvasPaddingBottom,h=i.canvasPaddingLeft,u=i.canvasPaddingRight,p=this.getFromEnv("dataSource").chart,g=this._getDataset()[0].config,f=g&&g.shiftCount,m=(0,l.pluckNumber)(a.getAxisConfig("axisMinValue"),0),v=(0,l.pluckNumber)(a.getAxisConfig("axisMaxValue"),f-1),b=(0,l.pluckNumber)(p.maxhshiftpercent,10),x=this.config.canvasWidth-2*s,k=t.shift||0;o&&o.setAxisDimention({x:o.config.isOpposit?t.canvasRight+n:t.canvasLeft-n,y:t.canvasTop+c,opposite:o.config.isOpposit?t.canvasLeft-n:t.canvasRight+n,axisLength:t.canvasHeight-c-d}),this._setPosition(),g&&(b=b<=0?10:b,e=g.xShiftLength=Math.min(x/f,b*x/100),v=Math.max(v,1)),r.setCanvasPadding(),a&&a.setAxisConfig({canvasPaddingLeft:Math.max(h,s)+e/2,canvasPaddingRight:Math.max(u,s)+e/2}),a&&a.setAxisDimention({x:this.config.canvasLeft+s+e/2,axisLength:e*(v-m),y:a.config.isOpposit?t.canvasTop-n:t.canvasBottom+k+n,opposite:a.config.isOpposit?t.canvasBottom+k+n:t.canvasTop-n}),this.allocateDimensionOfChartMenuBar()},a._setPosition=function(){var e,t,a,o,r,i,n,s,c=this.getFromEnv("dataSource"),d=this._getDataset()[0],h=c.data||d&&d[0]&&d[0].data,u=d.components.data,p=u&&u.length,g=this.getChildren("yAxis")[0],f=0,m=f,v=[];for(e=0;e<p;e++)a=(t=u[e].config).setValue,(c=u[e])||(c=u[e]={graphics:{}}),t.isDefined||(a=t.plotValue),a=(0,l.pluck)(t.plotValue,a),t.plotY=(0,l.toPrecision)(g.getPixel(t.setValue),2),t.graphY=a&&(0,l.toPrecision)(g.getPixel(a),2),t.plotX=m,t.isShift?(m=f+=1,h&&v.push(h[e])):e===p-1&&h&&v.push(h[e]),e&&(s=u[e-1].config,o=t&&t.objParams&&t.objParams.isRally,r=t&&t.objParams&&t.objParams.lastHigh,i=t&&t.objParams&&t.objParams.lastLow,n=t&&t.objParams&&t.objParams.isRallyInitialised,s&&n&&s.isRally!==t.isRally?(t.isChanged=!0,t.ty=(0,l.toPrecision)(g.getPixel(o?r:i),2)):t.isChanged=!1)},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=s},970:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(462)),n=o(a(971)),l=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e),t.getName=function(){return"WaterFall2D"};var a=t.prototype;return a.getName=function(){return"WaterFall2D"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.singleseries=!0,t.hasLegend=!1,t.defaultDatasetType="Waterfall2D",t.enablemousetracking=!0},a.getDSdef=function(){return n["default"]},t}(i["default"]);t["default"]=l},971:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=function(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{"default":e};var a=c(t);if(a&&a.has(e))return a.get(e);var o={},r=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var n=r?Object.getOwnPropertyDescriptor(e,i):null;n&&(n.get||n.set)?Object.defineProperty(o,i,n):o[i]=e[i]}o["default"]=e,a&&a.set(e,o);return o}(a(538)),l=a(232),s=o(a(972));function c(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,a=new WeakMap;return(c=function(e){return e?a:t})(e)}(0,l.addDep)({name:"waterFall2DAnimation",type:"animationRule",extension:s["default"]});var d=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"waterFall2D"},a.configure=function(e){if(!e)return!1;this.trimData(e),this.config.JSONData=e;var t,a,o,r,l,s,c,d,h,u,p,g,f,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V,I,B,M,O,R,G,H,z,W,U,j,J,K,q,Y,X,Q,Z,$,ee,te,ae,oe,re,ie,ne,le=this.getFromEnv("chart"),se=this.config,ce=this.config.JSONData,de=ce.data,he=de&&de.length,ue=this.getFromEnv("xAxis").getTicksLen(),pe=Math.min(ue,he),ge=le.getFromEnv("dataSource").chart,fe=this.getFromEnv("color-manager"),me=fe.getPlotColor(this.index||this.positionIndex),ve=(0,i.pluckNumber)(ce.dashed,ge.plotborderdashed,0),be=le.config,xe=be.useplotgradientcolor,ke=(0,i.pluckNumber)(ge.showtooltip,1),ye=(0,i.parseUnsafeString)((0,i.pluck)(ge.tooltipsepchar,", ")),Ce=this.components.data,we=this.getFromEnv("number-formatter"),Ae={},Se=Ae.dataObj||(Ae.dataObj={}),Ne=Se.chart||(Se.chart={}),Le=(0,i.pluck)(ge.connectorthickness,1),De=-Infinity,Ee=Infinity,Te=0,Fe=0,Pe=0;for(se.minAbsNonZeroValue=Infinity,se.minAbsNonZeroData={},this.setState("visible",1===(0,i.pluckNumber)(ce.visible,!Number(ce.initiallyhidden),1)),o=se.showplotborder=(0,i.pluckNumber)(ge.showplotborder,1),se.plotBorderThickness=p=o?(0,i.pluckNumber)(ge.plotborderthickness,1):0,se.isRoundEdges=g=(0,i.pluckNumber)(ge.useroundedges,0),se.plotBorderAlpha=k=o?(0,i.pluck)(ge.plotborderalpha,v,"100"):0,se.plotbordercolor=y=(0,i.pluck)(ge.plotbordercolor,fe.getColor("plotBorderColor").split(",")[0]),se.plotgradientcolor=x=xe?(0,i.getDefinedColor)(ge.plotgradientcolor,fe.getColor("plotGradientColor")):"",se.plotDashLen=h=(0,i.pluckNumber)(ge.plotborderdashlen,6),se.showTextOutline=(0,i.pluckNumber)(ge.textoutline,0),se.plotDashGap=u=(0,i.pluckNumber)(ge.plotborderdashgap,3),se.use3DLighting=(0,i.pluckNumber)(ge.use3dlighting,1),se.showSum=X=(0,i.pluckNumber)(ge.showsumatend,1),se.plotColor=me=(0,i.pluck)(ce.color,me),se.plotfillAngle=m=(0,i.pluckNumber)(360-ge.plotfillangle,90),se.showShadow=g?(0,i.pluckNumber)(ge.showshadow,1):(0,i.pluckNumber)(ge.showshadow,fe.getColor("showShadow")),se.usePattern=(0,i.pluckNumber)(be.usePattern,0),se.patternType=n.PATTERN_TYPES.includes(ce.patterntype)?ce.patterntype:be.patternType,se.patternDensity=(0,i.pluckNumber)(ce.patterndensity,be.patternDensity),se.patternAlpha=(0,i.pluckNumber)(ce.patternalpha,be.patternAlpha),se.patternBgColor=(0,i.pluck)(ce.patternbgcolor,se.patternBgColor),se.showHoverEffect=f=(0,i.pluckNumber)(ge.plothovereffect,ge.showhovereffect,void 0),se.usePattern&&(se.showHoverEffect=f=0),se.plotFillAlpha=v=(0,i.pluck)(ce.alpha,ge.plotfillalpha,"100"),se.plotRadius=(0,i.pluckNumber)(ge.useRoundEdges,se.isRoundEdges?1:0),se.plotFillRatio=b=(0,i.pluck)(ce.ratio,ge.plotfillratio),se.dashed=ve,se.plotBorderDashStyle=w=ve?(0,i.getDashStyle)(h,u):"none",se.showValues=(0,i.pluckNumber)(ce.showvalues,ge.showvalues,1),se.valuePadding=(0,i.pluckNumber)(ge.valuepadding,2),se.enableAnimation=U=(0,i.pluckNumber)(ge.animation,ge.defaultanimation,1),se.animation=!!U&&{duration:1e3*(0,i.pluckNumber)(ge.animationduration,1)},Ne.transposeAnimation=se.transposeAnimation=(0,i.pluckNumber)(ge.transposeanimation,Ne.transposeAnimation,U),se.transposeAnimDuration=1e3*(0,i.pluckNumber)(ge.transposeanimduration,.2),se.showTooltip=(0,i.pluckNumber)(ge.showtooltip,1),se.stack100Percent=(0,i.pluckNumber)(le.stack100percent,ge.stack100percent,0),se.definedGroupPadding=Math.max((0,i.pluckNumber)(ge.plotspacepercent),0),se.plotSpacePercent=Math.max((0,i.pluckNumber)(ge.plotspacepercent,20)%100,0),se.maxColWidth=(0,i.pluckNumber)(ge.maxcolwidth,50),se.showPercentValues=(0,i.pluckNumber)(ge.showpercentvalues,0),se.showPercentInToolTip=(0,i.pluckNumber)(ge.showpercentintooltip,0),se.plotPaddingPercent=(0,i.pluckNumber)(ge.plotpaddingpercent),se.rotateValues=(0,i.pluckNumber)(ge.rotatevalues)?270:0,se.placeValuesInside=(0,i.pluckNumber)(ge.placevaluesinside,0),se.parentYAxis=j="s"===(0,i.pluck)(ce.parentyaxis&&ce.parentyaxis.toLowerCase(),"p")?1:0,se.defaultPadding={left:.5,right:.5},this.setState("dirty",!0),Ce||(Ce=this.components.data=[]),se.zLine=te={step:!0,data:[],dashStyle:"1"===ge.connectordashed?(0,i.getDashStyle)((0,i.pluckNumber)(ge.connectordashlen,2),(0,i.pluckNumber)(ge.connectordashgap,2)):"none",useForwardSteps:!0,color:(0,i.convertColor)((0,i.pluck)(ge.connectorcolor,"000000"),(0,i.pluck)(ge.connectoralpha,100)),lineWidth:Le},Y=0;Y<pe;Y+=1)A=de[Y],$=we.getCleanValue(A.value),ee=(0,i.pluckNumber)(A.issum,0),A.vline||ee?delete A._value:(Te+=$,A._value=$);for(X&&(X=!0,pe+=1,re={label:(0,i.getFirstValue)(ge.sumlabel,"Total"),_value:Te,value:Te,issum:1,cumulative:1}),Y=0,ie=0;Y<pe;Y+=1)A=de[Y],L=(N=Ce[Y])&&N.config,N||(N=Ce[Y]={graphics:{}}),N.config||(L=Ce[Y].config={}),!A&&X&&(A=de[Y]=re),me=(0,i.pluck)(A.color,fe.getPlotColor(Y)),N.vline||($=A._value,delete A._value,L.issum=ee=(0,i.pluckNumber)(A.issum,0),oe=L.isCumulative=(0,i.pluckNumber)(A.cumulative,1),ee?($=oe||Fe===Pe?Fe:Fe-Pe,L.lastComTotal=Pe,Pe=Fe,te.data.push({y:null,x:ie-.5})):Fe+=$,L.valuePadding=(0,i.pluckNumber)(A.valuepadding,se.valuePadding),De=Math.max(De,Fe),Ee=Math.min(Ee,Fe),0!==$&&se.minAbsNonZeroValue>Math.abs($)&&(se.minAbsNonZeroValue=Math.abs($),se.minAbsNonZeroData=L),L.total=Fe,Z=L.showLabel=(0,i.pluckNumber)(A.showlabel,ge.showlabels,1),Q=L.dataLabel=(0,i.parseUnsafeString)(Z?(0,i.getFirstValue)(A.label,A.name):""),$>0?(ae=(0,i.pluck)(A.color,ge.positivecolor,me),0!==f&&(E=(0,i.pluck)(A.positivehovercolor,ge.positivehovercolor,ge.plotfillhovercolor,ge.columnhovercolor,ae))):(ae=(0,i.pluck)(A.color,ge.negativecolor,me),0!==f&&(E=(0,i.pluck)(A.negativehovercolor,ge.negativehovercolor,ge.plotfillhovercolor,ge.columnhovercolor,ae))),ne=$<0?360-m:m,v=(0,i.pluck)(A.alpha,se.plotFillAlpha),L.dashed=J=(0,i.pluckNumber)(A.dashed,se.dashed),K=(0,i.pluckNumber)(A.dashlen,h),q=u=(0,i.pluckNumber)(A.dashgap,u),L.plotFillAlpha=v,L.plotBorderAlpha=k,L.showValue=(0,i.pluckNumber)(A.showvalue,se.showValues),L.setValue=S=$,L.setLink=(0,i.pluck)(A.link),L.toolTipValue=z=we.dataLabels(S,j),L.setDisplayValue=W=(0,i.getValidValue)((0,i.parseUnsafeString)(A.displayvalue)),L.displayValue=(0,i.pluck)(W,z),L.plotBorderDashStyle=C=1===J?(0,i.getDashStyle)(K,q):0===J?"none":w,L.shadow={opacity:se.showShadow?v/100:0},L.dataLabelStyle=this._configureDataLabelStyle(A),L.patternType=n.PATTERN_TYPES.includes(A.patterntype)?A.patterntype:se.patternType,L.patternAngle=(0,i.pluckNumber)(A.patternangle,ce.patternangle,ge.patternangle,L.patternType===n.PATTERN_TYPES[0]?40:0),L.patternDensity=(0,i.pluckNumber)(A.patterndensity,se.patternDensity),L.patternSize=(0,i.pluckNumber)(A.patternsize,ce.patternsize,L.patternType===n.PATTERN_TYPES[0]?2:4),L.patternAlpha=(0,i.pluckNumber)(A.patternalpha,se.patternAlpha),L.patternBgColor=(0,i.pluck)(A.patternbgcolor,se.patternBgColor),L.colorArr=D=(0,i.getColumnColor)(ae+","+x.replace(/,+?$/,""),v,b,ne,g,y,k.toString(),0,!1),0!==f&&(T=(0,i.pluck)(A.alpha,A.hoveralpha,ce.hoveralpha,ge.plotfillhoveralpha,ge.columnhoveralpha,v),!(F=(0,i.pluck)(A.hovergradientcolor,ce.hovergradientcolor,ge.plothovergradientcolor,x))&&(F=""),P=(0,i.pluck)(A.hoverratio,ce.hoverratio,A.ratio,ge.plothoverratio,b),_=(0,i.pluckNumber)(360-A.hoverangle,360-ce.hoverangle,360-ge.plothoverangle,ne),V=(0,i.pluck)(A.borderhovercolor,ce.borderhovercolor,ge.plotborderhovercolor,y),I=(0,i.pluck)(A.borderhoveralpha,ce.borderhoveralpha,ge.plotborderhoveralpha,k,v),B=(0,i.pluckNumber)(A.borderhoverthickness,ce.borderhoverthickness,ge.plotborderhoverthickness,p),M=(0,i.pluckNumber)(A.borderhoverdashed,ce.borderhoverdashed,ge.plotborderhoverdashed),O=(0,i.pluckNumber)(A.borderhoverdashgap,ce.borderhoverdashgap,ge.plotborderhoverdashgap,h),R=(0,i.pluckNumber)(A.borderhoverdashlen,ce.borderhoverdashlen,ge.plotborderhoverdashlen,u),G=M?(0,i.getDashStyle)(R,O):C,1===f&&E===me&&(E=(0,i.getLightColor)(E,70)),L.hoverColor=E,L.hoverAlpha=T,L.hoverBorderColor=V,L.hoverBorderAlpha=I,H=(0,i.getColumnColor)(E+","+F,T,P,_,g,V,I.toString(),0,!1),L.setRolloutAttr={fill:(0,i.toRaphaelColor)(D[0]),stroke:o&&(0,i.toRaphaelColor)(D[1]),"stroke-width":p,"stroke-dasharray":C},L.setRolloverAttr={fill:(0,i.toRaphaelColor)(H[0]),stroke:o&&(0,i.toRaphaelColor)(H[1]),"stroke-width":B,"stroke-dasharray":G}),r=L.toolTipValue,L.origToolText=s=(0,i.getValidValue)((0,i.parseUnsafeString)((0,i.pluck)(A.tooltext,ce.plottooltext,ge.plottooltext),!1)),ke?void 0!==s?(c=[1,2,3,5,6,7,20,21,24,25],l={formattedValue:r,label:Q,yaxisName:(0,i.parseUnsafeString)(ge.yaxisname),xaxisName:(0,i.parseUnsafeString)(ge.xaxisname),cumulativeValue:Fe,cumulativeDataValue:we.dataLabels(Fe),sum:we.dataLabels(Te),unformattedSum:Te},d=(0,i.parseTooltext)(s,c,l,A,ge,ce)):d=null!==r&&(""!==Q?Q+ye:""):d=!1,te.data.push({y:null===$?null:Fe,x:ie}),ie+=1,L.originalPlotColor=(0,i.hashify)(me),L.toolText=d,L.setTooltext=d,L._x=Y,L._y=S);for(se.maxValue=De,se.minValue=Ee,se.connectNullData=(0,i.pluckNumber)(ge.connectnulldata,0),se.showConnectors=(0,i.pluckNumber)(ge.showconnectors,1),t=ce.catData,Y=0;Y<t.length;Y+=1)a=t[Y],de.splice(a.index,0,a.data);this.getFromEnv("xAxis").setTickValues(de),this.config.maxminFlag=!1},a.createCoordinates=function(){var e,t,a,o,r,i,n,l,s=this.getFromEnv("chart").isBar,c=this.getFromEnv("yAxis"),d=this.getFromEnv("xAxis"),h=c.getAxisBase(),u=c.getPixel(h),p=this.getFromEnv("chartConfig"),g=p.xDepth||0,f=p.yDepth||0,m=this.components.data.length,v=this.groupManager,b=v&&v.stackConf,x=this.components.data;for(!s&&(g=-g),s&&(f=-f),o=0;o<m;o++)t=(e=x[o])&&e.config,void 0!==e&&(l=t._y,t.issum?t.isCumulative?a=null:(a=t.lastComTotal,l+=t.lastComTotal):(a=x[o-1]&&x[o-1].config.total)&&(l+=a),r=d.getPixel(b&&b[o].x||t._x)+g,i=c.getPixel(l)+f,n=(a?c.getPixel(a):u)+f,d.config.isVertical?(t._Px=i,t._Py=r,t._Pby=r,t._Pbx=n):(t._Px=r,t._Py=i,t._Pby=n,t._Pbx=r))},a.getDataLimits=function(){var e,t,a=this.components.data,o=this.config,r=a.length,i=-Infinity,n=+Infinity;for(e=0;e<r;e++)a[e]&&void 0!==(t=a[e].config.total)&&(i=Math.max(i,t),n=Math.min(n,t));return o.maxValue=i,o.minValue=n,{max:o.maxValue,min:o.minValue}},a.drawPlots=function(t){e.prototype.drawPlots.call(this,t),this.config.showConnectors?this.drawLine():this.getContainer("commonElemsGroup").hide()},a.drawLine=function(){var e,t,a,o,r,n,l,s,c=this.config,d=this.getFromEnv("yAxis"),h=d.getAxisBase(),u=d.getPixel(h),p=this.getContainer("commonElemsGroup"),g=this.getFromEnv("columnWidth")/2,f=c.zLine,m=f.data,v=m.length,b=f.lineWidth,x=this._graphics.zLine,k=null,y=[],C=[];for(d.yBasePos=u,p.toFront().show(),e=0;e<v;e+=1)null===(r=(o=m[e]).y)?(C.length=0,0===c.connectNullData&&(k=null)):(n=(0,i.pluckNumber)(o.x,e),t=d.getPixel(r),a=this.getFromEnv("xAxis").getPixel(n),a=(0,i.getCrispValue)(a,b,b).position,t=(0,i.getCrispValue)(t,b,b).position,null!==k?(C.length&&(y=y.concat(C),C.length=0),y.push("M",l,k,"m",-g,0,"H",a,"h",g,"m",0,t-k)):C.push("M",a,t),l=a,k=t);s=this.getFromEnv("animationManager").setAnimation({el:x||"path",attr:{path:y,"stroke-linecap":"round","stroke-opacity":1,"stroke-dasharray":f.dashStyle,stroke:f.color,"stroke-linejoin":b>=2?"round":"miter","stroke-width":b},container:p,component:this,label:"path"}),x||this.addGraphicalElement("zLine",s)},t}(n["default"]);t["default"]=d},972:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"initial.dataset.waterFall2D":o(a(539))["default"]["initial.dataset.column"]};t["default"]=r},973:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(555)),n=a(224),l=a(232),s=o(a(974)),c=function(e){return null!=e},d="M",h=n.hasTouch?n.TOUCH_THRESHOLD_PIXELS:n.CLICK_THRESHOLD_PIXELS;(0,l.addDep)({name:"kagiAnimation",type:"animationRule",extension:s["default"]});var u=function(e){function t(){var t;return(t=e.call(this)||this).manageSpace=n.stubFN,t.drawCommonElements=n.stubFN,t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"kagi"},a._parseShadowOptions=function(){var e=this.getFromEnv("chart").getFromEnv("dataSource").chart;return{opacity:(0,n.pluckNumber)(e.showshadow,1)?this.config.alpha/100:0}},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t);var a,o,r,i,l,s,d,h,u,p,g,f,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F,P,_,V,I,B,M,O,R=this.getFromEnv("chart"),G=0,H=[],z=0;for(a=this.components,r=a.data,i=this.config,l=this.config.JSONData.data,s=R.getFromEnv("dataSource").chart,o=a.removeDataArr||(a.removeDataArr=[]),d=!1,h=0,u=(0,n.pluckNumber)(s.reversalvalue,-1),p=(0,n.pluckNumber)(s.reversalpercentage,5),y=0;y<r.length;y+=1)r[y].config.__nullCount=z,null===r[y].config.setValue&&(o.push(r.splice(y,1)[0]),z++,y-=1);if(r.length){for(i.rallyColor=(0,n.pluck)(s.rallycolor,"FF0000"),i.rallyAlpha=(0,n.pluckNumber)(s.rallyalpha,s.linealpha,100),i.declineColor=(0,n.pluck)(s.declinecolor,"0000FF"),i.declineAlpha=(0,n.pluckNumber)(s.declinealpha,s.linealpha,100),i.canvasPadding=(0,n.pluckNumber)(s.canvaspadding,15),i.maxHShiftPercent=(0,n.pluckNumber)(s.maxhshiftpercent,10),i.rallyThickness=(0,n.pluckNumber)(s.rallythickness,s.linethickness,2),g=(0,n.pluckNumber)(s.rallydashlen,s.linedashlen,5),f=(0,n.pluckNumber)(s.rallydashgap,s.linedashgap,4),i.declineThickness=(0,n.pluckNumber)(s.declinethickness,s.linethickness,2),m=(0,n.pluckNumber)(s.declinedashlen,s.linedashlen,5),v=(0,n.pluckNumber)(s.declinedashgap,s.linedashgap,4),i.lineDashed={"true":(0,n.pluckNumber)(s.rallydashed,s.linedashed,0),"false":(0,n.pluckNumber)(s.declinedashed,s.linedashed,0)},i.rallyDashed=(0,n.pluckNumber)(s.rallydashed,s.linedashed,0)?(0,n.getDashStyle)(g,f):"none",i.declineDashed=(0,n.pluckNumber)(s.declinedashed,s.linedashed,0)?(0,n.getDashStyle)(m,v):"none",i.canvasPadding=(0,n.pluckNumber)(s.canvaspadding,this.canvasPadding,15),u=u>0?u:p*(i.maxValue-i.minValue)/100,b=r[0].config.setValue,x=function(e,t){for(var a,o=1,i=r[0].config.setValue;o<e;)a=r[o].config.setValue,t?a<=i&&(r[o].config.isDefined=!1):a>=i&&(r[o].config.isDefined=!1),o+=1;r[0].config.vAlign=t?"bottom":"top",r[0].config.align="center"},k=l.length,y=0,C=0;C<k;C+=1,y+=1)if((!(w=l[C])||!w.vline)&&(A&&(A=!1),(L=r[y]&&r[y].config)&&(L.isDefined=!0),y&&L)){if(L.isShift=void 0,S=r[y-1].config,L.vAlign="middle",L.align="right",L.showLabel=!1,N=null,T=L.setValue,D=r[y+1]&&r[y+1].config.setValue,E=Math.abs(b-T),d?T<P&&F?F=!1:T>_&&!F&&(F=!0):(T>b&&E>u?(P=b,_=null,V=!0,d=!0,x(y,F=!0)):T<b&&E>u?(P=null,_=b,V=!1,d=!0,x(y,F=!1)):(F=null,V=null,d=!1),c(S)&&(S.isRally=F),null!==F&&(r[0].config.isRally=F)),L.isRally=F,(V&&T<b||!V&&T>b)&&(N=b),B=N||T,E=Math.abs(B-D),I=null===V?null:V?B>D&&E>=u:B<D&&E>=u,S&&S.isShift)for(V?(P=b,O="bottom"):V||(_=b,O="top"),"center",M=y;M>1;M-=1)if(r[M].y===b){r[M].vAlign=O,r[M].align="center",r[M].showLabel=!0;break}I?(h+=1,A=!0,V=!V,L.isShift=!0,b=B,H.push(l[y+L.__nullCount]),G=this._appendCategory(G,y,H,0)):V&&T>b||!V&&T<b?b=T:N=b,L.plotValue=N,L.objParams={isRally:F,lastHigh:_,lastLow:P,isRallyInitialised:d}}this._appendCategory(G,y,H,1),H.push(w),this.getFromEnv("xAxis").setTickValues(H),i.shiftCount=h+1}},a._appendCategory=function(e,t,a,o){var r,i,l,s,c=e,d=this.config.JSONData.catData;if(c<d.length)for(r=c;r<d.length;c=r+=1){if(l=(i=d[r]).data,(s=i.index-(r+1))<t)l.lineposition=(0,n.pluckNumber)(l.lineposition,o);else if(s>t)break;a.push(l)}return c},a._getHoveredPlot=function(e,t){var a,o,r,i,n,l,s=e,c=t,d=this.getFromEnv("xAxis"),h=this.config,u=h.trackIndex,p=this.components.data,g=p.length;for(s+=d.getTranslation(),n=Math.floor(Math.max(d.getValue(s-h.maxRadius),0)),o=Math.ceil(Math.min(d.getValue(s+h.maxRadius),g-1));o>=n;o--)for(a=g=(l=u[o])&&l.length;a>=0;a--)if(r=l[a],i=this.isWithinShape(p[r],r,s,c))return i},a.getClip=function(e){var t=this.getFromEnv("chart").getChildren("canvas")[0].config,a=[t.canvasLeft,t.canvasTop,0,t.canvasTop+t.canvasHeight];return a[2]+="init"===e?0:t.canvasLeft+t.canvasWidth,a},a.parsePlotAttributes=function(e,t){var a,o,r,i,l,s,c,d,u,p,g,f,m=t,v=e,b={},x=this.getState("visible");v=v.config,g=(l=this.components.data[m]).config,a=v.trackerConfig={},u=g.hoverEffects,o=l._xPos=this.getFromEnv("xAxis").getPixel(v.plotX),r=l._yPos=v.plotY,l._index=v.plotX,p=(b=g.anchorProps).symbol,v.finalTooltext=v.toolText,void 0!==r&&!isNaN(r)&&v.isDefined&&(i=v.eventArgs=v.eventArgs||{},Object.assign(i,{index:m,link:g.setLink,value:g.setValue,displayValue:g.displayValue,categoryLabel:g.label,toolText:v.finalTooltext,id:this.config.userID,datasetIndex:0,datasetName:this.config.JSONData.seriesname,visible:x,color:g.color,alpha:g.alpha,anchorBgColor:b.bgColor,anchorBgAlpha:b.anchorBgAlpha,anchorAlpha:b.anchorAlpha,anchorBorderColor:b.borderColor,anchorBorderThickness:b.borderThickness,anchorRadius:b.radius,anchorSides:b.sides,anchorStartAngle:b.startAngle,anchorHoverColor:u.anchorColor,anchorHoverAlpha:u.anchorAlpha,anchorHoverSides:u.anchorSides,dashed:g.dashed,valuePosition:g.valuePosition}),s=c={},b.imageUrl&&(g.anchorImageLoaded=!1),f={path:(0,n.polyPathToPath)([p[1]||2,o,r,b.radius,b.startAngle,0]),fill:(0,n.toRaphaelColor)({color:b.bgColor,alpha:b.bgAlpha}),stroke:(0,n.toRaphaelColor)({color:b.borderColor,alpha:b.borderAlpha}),"stroke-width":b.borderThickness,visibility:b.radius?x:"hidden"},d=Math.max(b.radius,u&&u.anchorRadius||0,h)+b.borderThickness/2,a.trackerRadius=d,u.enabled&&(c={path:(0,n.polyPathToPath)([u.anchorSides||2,o,r,u.anchorRadius,u.startAngle,u.dip]),fill:(0,n.toRaphaelColor)({color:u.anchorColor,alpha:u.anchorBgAlpha}),stroke:(0,n.toRaphaelColor)({color:u.anchorBorderColor,alpha:u.anchorBorderAlpha}),"stroke-width":u.anchorBorderThickness},s={path:(0,n.polyPathToPath)([b.sides,o,r,b.radius,b.startAngle,0]),fill:(0,n.toRaphaelColor)({color:b.bgColor,alpha:b.bgAlpha}),stroke:(0,n.toRaphaelColor)({color:b.borderColor,alpha:b.borderAlpha}),"stroke-width":b.borderThickness},u.attrs={hoverEnabled:u.enabled,anchorRadius:b.radius,anchorHoverRadius:u.anchorRadius},u.attrs.setRolloverAttr=c,u.attrs.setRolloutAttr=s,b.isAnchorHoverRadius=u.attrs.anchorRadius)),v.props={element:{attr:f}}},a.parseLabelAttributes=function(e,t){var a,o,r,i,l,s,d,h,u,p,g,f,m,v,b,x,k=this.getFromEnv("chart"),y=k.config,C=k.config.dataLabelStyle,w=n.BLANKSTRING,A=y.rotatevalues?270:0,S=y.canvasTop,N=S+y.canvasHeight,L={},D={},E=t,T=this.components.data.length;b=(u=e&&e.config)&&u.setValue,void 0!==e&&null!=b&&!0!==u.labelSkip?(t>0&&(D={x:this.components.data[E-1]._xPos,y:this.components.data[E-1]._yPos}),t<T-1&&(L={x:this.components.data[E+1]._xPos,y:this.components.data[E+1]._yPos}),r=e.graphics,f=e._yPos||e.config._Py,g=e._xPos||e.config._Px,m=r.element?r.image&&.5*r.element.attr("height")||u.anchorProps.radius-3:0,a=u.valuePadding+2+m,w=u.displayValue,c(w)&&""!==w&&u.showValue&&(x={text:w,fill:(v=u.dataLabelStyle).color,"text-bound":[v.backgroundColor,v.borderColor,C.borderThickness,C.borderPadding,C.borderRadius,C.borderDash]},o=this.getFromEnv("smartLabel").getOriSize(w),A?(u._state={labelWidth:o.height,labelHeight:o.width},u._rotated=!0):(u._state={labelWidth:o.width,labelHeight:o.height},u._rotated=!1),i=l=A?o.width:o.height,i+=a,h=.5*l+a,s=f,d=g,i+=4,p=Number(A)>=1?o.height:o.width,u._valueBelowPoint=0,L.y>s?D.y<s?d-=a+3+.5*p:f-i<S?(d-=a+3+.5*p,s=S+i/2):s-=h:D.y>s?d-=a+3+.5*p:f+i>N?(d-=a+3+.5*p,s=N-i/2):(s+=h+2,u._valueBelowPoint=1),x.x=d,x.y=s),u.props=u.props||{},u.props.label={attr:x}):u&&delete u.labelSkip},a.allocatePosition=function(){var e,t,a,o,r,i,l,s,c,h=this,u=h.config,p=h.components.data,g=p&&p.length,f=h.getFromEnv("xAxis"),m=h.components.data,v=f.getPixel(0),b=f.getPixel(1)-v,x={"true":u.rallyThickness,"false":u.declineThickness},k=f.getPixel(0),y=p[0]&&!!p[0].isRally,C=v-b/2;if(u.imagesLoaded=0,p.length){if(a=u.rallyPath=[],o=u.declinePath=[],m=h.components.data=m||[],p[0].config.setValue)i=p[0].config.plotY;else for(e=1;e<g;e+=1)if(p[e].config.setValue){i=p[e].config.plotY;break}for(y=!!p[0].config.isRally,l=Math.round(i)+x[y]%2/2,y?a.push(d,C,l,"H",k):o.push(d,C,l,"H",k),(0,n.fcEach)(p,(function(e,n){var l=e;l=l.config,t=m[n],t.config.setValue,(s=p[n+1]&&p[n+1].config||{})&&(c=[d,k,i],y=l.isRally,l.isShift&&(k+=b,i=l.graphY,c.push("H",k),c[2]=Math.round(c[2])+x[y]%2/2,c=c.toString(),y?a.push(c):o.push(c),c=[d,k,i]),s.isChanged&&(i=s.ty,c.push("V",i),c[1]=Math.round(c[1])+x[!!y]%2/2,c=c.toString(),y?a.push(c):o.push(c),c=[d,k,i]),r=s.isRally,s.graphY!==c[2]&&void 0!==s.graphY&&(c.push("V",s.graphY),c[1]=Math.round(c[1])+x[!!r]%2/2,c=c.toString(),r?a.push(c):o.push(c)),s.graphY&&(i=s.graphY)),h.parsePlotAttributes(t,n)})),e=0;e<p.length;e++)h.parseLabelAttributes(m[e],e)}},a.drawPlots=function(){var e,t,a,o,r,i,l,s,c,d,h=this,u=h.getGraphicalElement(),p=h.getFromEnv("animationManager"),g=h.config,f=g.trackIndex={},m=h.components.data,v=h.components.data,b=g.shadow,x={},k=g.rallyThickness,y=g.declineThickness,C={stroke:(0,n.toRaphaelColor)({color:g.rallyColor,alpha:g.rallyAlpha}),"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":k,"stroke-dasharray":g.rallyDashed},w={stroke:(0,n.toRaphaelColor)({color:g.declineColor,alpha:g.declineAlpha}),"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":y,"stroke-dasharray":g.declineDashed},A=u.rallyElem,S=u.declineElem,N=h.getContainer("commonElemsGroup"),L=h.getContainer("plotGroup"),D=h.getContainer("shadowGroup");if(!m.length)return l&&l.hide(),void(s&&s.hide());l&&l.show(),s&&s.show(),(0,n.fcEach)(m,(function(n,l){var s=n;s=s.config,o=v[l],i=o.config,e=o.graphics,d=e.image,r=i.hoverEffects,t=o._yPos,f[s.plotX]||(f[s.plotX]=[]),f[s.plotX].push(l),o._index=s.plotX,x=i.anchorProps,void 0!==t&&!isNaN(t)&&s.isDefined?(x.imageUrl?h.drawAnchorImage(o):(d&&d.hide(),a=e.element,c=s.props.element.attr,(a=e.element=p.setAnimation({el:a||"path",attr:c,container:L,component:h,label:"anchor"})).show().shadow(x.shadow,D).data("anchorRadius",x.radius).data("anchorHoverRadius",r.anchorRadius).data("hoverEnabled",r.enabled).data("eventArgs",s.eventArgs)),r.enabled&&a&&a.data("anchorRadius",x.radius).data("anchorHoverRadius",r.anchorRadius).data("hoverEnabled",r.enabled).data("setRolloverAttr",r.attrs.setRolloverAttr).data("setRolloutAttr",r.attrs.setRolloutAttr).data("eventArgs",s.eventArgs)):(e.element&&e.element.hide(),d&&d.hide())})),C.path=g.rallyPath,(l=p.setAnimation({el:A||"path",attr:C,container:N,component:h,label:"line"})).shadow(k&&b,D),A||h.addGraphicalElement("rallyElem",l),w.path=g.declinePath,(s=p.setAnimation({el:S||"path",attr:w,container:N,component:h,label:"line"})).shadow(y&&b,D),S||h.addGraphicalElement("declineElem",s)},t}(i["default"]);t["default"]=u},974:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.kagi":o(a(558))["default"]["*.dataset.line"]};t["default"]=r},975:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(970))["default"];t["default"]=r},976:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(977))["default"];t["default"]=r},977:function(e,t,a){"use strict";(function(e){var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(224),n=o(a(658)),l=o(a(978)),s=a(232),c=a(953),d=o(a(387)),h=(0,s.getDep)("redraphael","plugin"),u="rgba(192,192,192,"+(i.isIE?.002:1e-6)+")",p=Math.PI/180,g=function(e){return Object.keys(e).length},f="M",m="L",v="t";function b(e){var t,a=e.chart,o=a.getFromEnv("paper"),r=a.config,n=a.getChildren("yAxis")[0],l=a.getChildren("xAxis")[0],s=e.selectionLeft,c=e.selectionTop,d=e.selectionWidth,h=e.selectionHeight,p=s+d,g=c+h,f=d>15&&h>15,m={resizeEleRadius:15,canvasTop:r.canvasTop,canvasRight:r.canvasLeft+r.canvasWidth,canvasLeft:r.canvasLeft,canvasBottom:r.canvasTop+r.canvasHeight},b=r._selectEleArr||(r._selectEleArr=[]);m.index=b.length,m.id="SELECT_"+m.index,m.selectBoxG=t=o.group("selection-box",a.getChildContainer("trackerGroup")).toFront(),m.selectBoxTracker=o.rect(s,c,d,h,t).attr({"stroke-width":1,stroke:(0,i.toRaphaelColor)(r.selectBorderColor),fill:r.selectFillColor}).css({cursor:"move"}),m.selectBoxTracker.node._isTrackerElem=!0,m.selectBoxTracker.data("config",{position:6,selectEleObj:m,chart:a,xChange:!0,yChange:!0}),m.topTracker=o.rect(s,c-6,d,12,t).attr({"stroke-width":0,fill:u}).css("cursor",i.hasSVG?"ns-resize":"n-resize"),m.topTracker.node._isTrackerElem=!0,m.topTracker.data("config",{position:1,selectEleObj:m,yChange:!0,chart:a}),m.rightTracker=o.rect(s+d-6,c,12,h,t).attr({"stroke-width":0,fill:u}).css("cursor",i.hasSVG?"ew-resize":"w-resize"),m.rightTracker.node._isTrackerElem=!0,m.rightTracker.data("config",{position:2,chart:a,selectEleObj:m,xChange:!0}),m.bottomTracker=o.rect(s,c+h-6,d,12,t).attr({"stroke-width":0,fill:u}).css("cursor",i.hasSVG?"ns-resize":"n-resize"),m.bottomTracker.node._isTrackerElem=!0,m.bottomTracker.data("config",{position:3,chart:a,selectEleObj:m,yChange:!0}),m.leftTracker=o.rect(s-6,c,12,h,t).attr({"stroke-width":0,fill:u}).css("cursor",i.hasSVG?"ew-resize":"e-resize"),m.leftTracker.node._isTrackerElem=!0,m.leftTracker.data("config",{position:4,chart:a,selectEleObj:m,xChange:!0}),m.cornerInnerSymbol=o.symbol("resizeIcon",0,0,15,t).attr({transform:v+p+","+g,"stroke-width":1,visibility:f?"visible":"hidden",stroke:"#999999"}),m.cornerInnerSymbol.node._isTrackerElem=!0,m.cornerOuterSymbol=o.symbol("resizeIcon",0,0,-12,t).attr({transform:v+p+","+g,strokeWidth:1,visibility:f?"hidden":"visible",stroke:"#777777"}),m.cornerOuterSymbol.node._isTrackerElem=!0,m.resizeTracker=o.circle(p,g,12,t).attr({"stroke-width":1,stroke:u,fill:u}).css("cursor",i.hasSVG?"nwse-resize":"nw-resize"),m.resizeTracker.node._isTrackerElem=!0,m.resizeTracker.data("config",{position:5,chart:a,selectEleObj:m,yChange:!0,xChange:!0}),m.closeButton=o.symbol("closeIcon",0,0,6,t).attr({transform:"t"+p+","+c,"stroke-width":2,stroke:r.selectionCancelButtonBorderColor,fill:r.selectionCancelButtonFillColor,"stroke-linecap":"round","stroke-linejoin":"round"}).css({cursor:"pointer",_cursor:"hand"}).on("fc-click",(function(){a.deleteSelection(this,a)})),m.closeButton.node._isTrackerElem=!0,m.closeButton.data("config",{chart:a,index:m.index}),m.startX=l.getValue(s),m.startY=n.getValue(c),m.endX=l.getValue(p),m.endY=n.getValue(g),m.isVisible=!0,b.push(m),a.bindDragEvent(m)}function x(e,t){var a,o,r,i,n,l=e.data("config").index,s=t.config._selectEleArr,c=t.getChildren("xAxis")[0],d=t.getChildren("yAxis")[0];for(r in n={selectionLeft:(i=(a=s.find((function(e){return e.index===l}))).selectBoxTracker.getBBox()).x,selectionTop:i.y,selectionWidth:i.width,selectionHeight:i.height,startXValue:c.getValue(i.x,1),startYValue:d.getValue(i.y,1),endXValue:c.getValue(i.x+i.width,1),endYValue:d.getValue(i.y+i.height,1),data:t.getCollatedData(),id:a.id},a)a.hasOwnProperty(r)&&((o=a[r]).remove&&o.remove(),delete a[r]);s=s.filter(g),t.fireChartInstanceEvent("selectionRemoved",n)}(0,d["default"])(h),h.addSymbol({resizeIcon:function(e,t,a){var o,r=a,n=e,l=t,s=(0,i.pluckNumber)(r,15)/3,c=[];for(s<0&&(n+=(r=-r)-(s=-s)/2,l+=r-s/2),o=3;o>0;o-=1)c.push(f,n-s*o,l-3,m,n-3,l-s*o);return c},closeIcon:function(e,t,a){var o=e,r=t,i=1.3*a,n=43*p,l=48*p,s=o+i*Math.cos(n),c=r+i*Math.sin(n),d=.71*(a-2),h=.71*(a-2),u=function(e,t,a,o,r,i){return["A",a,o,0,i,r,e,t]}(o+i*Math.cos(l),r+i*Math.sin(l),i,i,0,1);return[f,s,c].concat(u).concat([f,e+d,t-h,m,e-d,t+h,f,e-d,t-h,m,e+d,t+h])},configureIcon:function(e,t,a){var o=.5,r=a-1,i=.25,n=.71*r,l=.71*(r+2),s=e-r,c=t-r,d=e+r,h=t+r,u=e+o,p=t+o,g=e-o,v=t-o,b=s-2,x=c-2,k=d+2,y=h+2,C=e+n,w=t+n,A=e-n,S=t-n,N=e+l,L=t+l,D=e-l,E=t-l;return[f,s,p,m,b,p,b,v,s,v,A-i,S+i,D-i,E+i,D+i,E-i,A+i,S-i,g,c,g,x,u,x,u,c,C-i,S-i,N-i,E-i,N+i,E+i,C+i,S+i,d,v,k,v,k,p,d,p,C+i,w-i,N+i,L-i,N-i,L+i,C-i,w+i,u,h,u,y,g,y,g,h,A+i,w+i,D+i,L+i,D-i,L-i,A-i,w-i,"Z"]},axisIcon:function(e,t,a){var o=a-1,r=.33*o,i=o/2,n=e-o,l=t-o,s=e+i,c=t+o,d=e-i,h=t+r,u=t-r;return[f,n,l,m,s,l,s,c,n,c,f,d,h,m,s,h,f,d,u,m,s,u]},loggerIcon:function(e,t,a){var o=a-1,r=t-o,i=e-o,n=i+2*o,l=i+2,s=n-2,c=r+2,d=c+o,h=d+2;return[f,i,r,m,n,r,n,c,s,c,s,d,n,d,n,h,i,h,i,d,l,d,l,c,i,c,i,r]}});var k=function(t){(0,r["default"])(o,t),o.getName=function(){return"SelectScatter"};var a=o.prototype;function o(){var e;return(e=t.call(this)||this).isXY=!0,e.defaultZeroPlaneHighlighted=!1,e.eiMethods={getData:function(e){var t=this.apiInstance;return t&&t.getData(e)},restoreData:function(){var e=this.apiInstance;return e&&e.restoreData()},submitData:function(){var e=this.apiInstance;return e&&e.submitData()}},e}return a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.formBtnTitle=(0,i.pluck)(e.chart.submittext,e.chart.formbtntitle,"Submit"),this.config.restoreBtnTitle=(0,i.pluck)(e.chart.restoretext,e.chart.restorebtntitle,"Restore")},a.getName=function(){return"SelectScatter"},a.configureAttributes=function(e){var a=this.getFromEnv("chart").config,o=this.getFromEnv("dataSource").chart||{};a.formAction=(0,i.getValidValue)(o.formaction),a.enableSubmit=(0,i.pluckNumber)(o.enablesubmit,o.showformbtn,1)&&a.formAction,a.enableRestore=(0,i.pluckNumber)(o.enablerestore,o.showrestorebtn,1),t.prototype.configureAttributes.call(this,e)},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.hasLegend=!0,e.defaultDatasetType="selectScatter",e.allowreversexaxis=!0,e.enablemousetracking=!0},a.attachMenuButtons=function(){t.prototype.attachMenuButtons.call(this);var e,a=this,o=a.getFromEnv("chartConfig"),r=a.getFromEnv("toolbar"),i=r.getChild("hamburgerMenu-"+r.getId()+"-"+a.getId()+"-0"),n=[];o.enableRestore&&n.push({name:o.restoreBtnTitle,handler:function(){a.restoreData()},action:"click"}),o.enableSubmit&&(e={name:o.formBtnTitle,handler:function(){c.submitData.call(a)},action:"click"},n.push(e)),n.length>0&&i.appendInMenu(n)},a.getData=function(t){var a,o,r,n=this.getCollatedData(),l=[],s=n.dataset,c=s&&s.length||0,d=0,h=0;if(t)l=/^json$/gi.test(t)?n:/^csv$/gi.test(t)?this.getCSVString():e.core.transcodeData(n,"json",t);else for(;d<c;d+=1)if(o=s[d]){for((r=a=(o=s[d]&&s[d].data)&&o.length||0)&&(l[h]||(l[h]=[(0,i.getValidValue)(s[d].id,"null")]));r--;)l[h][r+1]=(0,i.getValidValue)(o[r].id,"null");a&&(h+=1)}return l},a.getCSVString=function(){for(var e=this.getData(),t=e.length;t--;)e[t]=e[t].join(",");return e.join("|")},a.getCollatedData=function(e){var t,a,o,r,n,l,s,c,d,h,u,p=this.getDatasets(),g=this.config._selectEleArr,f=g&&g.length||0,m=e||this.getFromEnv("dataSource"),v=(0,i.extend2)({},m),b=v.dataset,x=b&&b.length,k=!1,y=[];if(!f||!x)return m;for(;f--;)if(r=g[f])for(c=r.startX,d=r.endX,h=r.startY,u=r.endY,n=x;n--;)if(p[n].getState("visible"))for(y[n]||(y[n]={data:[]}),s=(o=b[n].data)&&o.length;s--;)t=(l=o[s]).x,a=l.y,t>c&&t<d&&a<h&&a>u&&(y[n].data[s]=k=!0);for(;x--;)for(s=(o=b[x].data)&&o.length;s--;)y[x]&&y[x].data[s]||o.splice(s,1);return k?v:m},a.createSelectionBox=function(e){b.call(this,e)},a._deleteAllSelection=function(){var e,t,a,o,r,i=this.config._selectEleArr;if(i){for(t=0,a=i.length;t<a;t++)for(r in e=i[t])e.hasOwnProperty(r)&&((o=e[r]).remove&&o.remove(),delete e[r]);delete this.config._selectEleArr}},a.deleteSelection=function(e,t){x.call(this,e,t)},a.bindDragEvent=function(e){var t;for(t in e)/Tracker/.test(t)&&e[t].drag(this.move,this.start,this.up)},a.start=function(){var e=this.data("config").selectEleObj,t=e.topTracker,a=e.rightTracker,o=e.bottomTracker,r=e.leftTracker,i=e.resizeTracker,n=t.data("config"),l=a.data("config"),s=o.data("config"),c=r.data("config"),d=i.data("config"),h=e.selectBoxTracker.data("config"),u=e.selectBoxTracker.getBBox();n.ox=u.x,n.oy=u.y,l.ox=u.x2,l.oy=u.y,s.ox=u.x,s.oy=u.y2,c.ox=u.x,c.oy=u.y,n.ox=u.x,n.oy=u.y,d.ox=u.x2,d.oy=u.y2,h.ox=u.x,h.oy=u.y,h.ow=u.width,h.oh=u.height,h.ox2=u.x2,h.oy2=u.y2,e.selectBoxG.toFront(),t.hide(),a.hide(),o.hide(),r.hide(),i.hide(),this.show()},a.move=function(e){var t,a,o,r,i=this.data("config"),n=i.selectEleObj,l=i.chart,s=n.topTracker,c=n.rightTracker,d=n.bottomTracker,h=n.leftTracker,u=n.resizeTracker,p=n.selectBoxTracker,g=n.canvasLeft,f=n.canvasRight,m=n.canvasTop,v=n.canvasBottom,b=l.getChildren("xAxis")[0],x=l.getChildren("yAxis")[0],k=p.data("config"),y={},C=e.data[0],w=e.data[1];switch(C=i.xChange?C:0,w=i.yChange?w:0,o=C+i.ox,r=w+i.oy,o=Math.min(f-(i.ow||0),Math.max(o,g)),r=Math.min(v-(i.oh||0),Math.max(r,m)),i.position){case 1:y.y=Math.min(k.oy2,r),y.height=Math.abs(k.oy2-r)||1,s.attr({y:r+-6});break;case 2:y.x=Math.min(k.ox,o),y.width=Math.abs(k.ox-o)||1,c.attr({x:o+-6});break;case 3:y.y=Math.min(k.oy,r),y.height=Math.abs(k.oy-r)||1,d.attr({y:r+-6});break;case 4:y.x=Math.min(k.ox2,o),y.width=Math.abs(k.ox2-o)||1,h.attr({x:o+-6});break;case 5:y.x=Math.min(k.ox,o),y.width=Math.abs(k.ox-o)||1,y.y=Math.min(k.oy,r),y.height=Math.abs(k.oy-r)||1,u.attr({cx:o,cy:r});break;default:y.x=o,y.y=r}this.data("dragStarted")||(a={selectionLeft:(t=p.getBBox()).x,selectionTop:t.y,selectionWidth:t.width,selectionHeight:t.height,startXValue:b.getValue(t.x),startYValue:x.getValue(t.y),endXValue:b.getValue(t.x+t.width),endYValue:x.getValue(t.y+t.height),id:n.id},l.fireChartInstanceEvent("BeforeSelectionUpdate",a),this.data("dragStarted",1)),p.animate(y),n.isVisible&&(n.closeButton.hide(),n.cornerInnerSymbol.hide(),n.cornerOuterSymbol.hide(),n.isVisible=!1)},a.up=function(){var e,t,a=this,o=a.data("config"),r=o.selectEleObj,i=o.chart,n=i.getChildren("xAxis")[0],l=i.getChildren("yAxis")[0],s=r.topTracker,c=r.rightTracker,d=r.bottomTracker,h=r.leftTracker,u=r.resizeTracker,p=r.selectBoxTracker;setTimeout((function(){e=p.getBBox(),r.startX=n.getValue(e.x),r.startY=l.getValue(e.y),r.endX=n.getValue(e.x2),r.endY=l.getValue(e.y2),s.attr({x:e.x,y:e.y+-6,width:e.width}),c.attr({x:e.x2+-6,y:e.y,height:e.height}),d.attr({x:e.x,y:e.y2+-6,width:e.width}),h.attr({x:e.x+-6,y:e.y,height:e.height}),u.attr({cx:e.x2,cy:e.y2}),r.closeButton.transform(v+e.x2+","+e.y),r.cornerInnerSymbol.transform(v+e.x2+","+e.y2),r.cornerOuterSymbol.transform(v+e.x2+","+e.y2),r.closeButton.show(),e.width<15||e.height<15?(r.cornerInnerSymbol.hide(),r.cornerOuterSymbol.show()):(r.cornerInnerSymbol.show(),r.cornerOuterSymbol.hide()),r.isVisible=!0,s.show(),c.show(),d.show(),h.show(),u.show(),a.data("dragStarted")&&(t={selectionLeft:e.x,selectionTop:e.y,selectionWidth:e.width,selectionHeight:e.height,startXValue:n.getValue(e.x),startYValue:l.getValue(e.y),endXValue:n.getValue(e.x+e.width),endYValue:l.getValue(e.y+e.height),data:i.getCollatedData(),id:r.id},i.fireChartInstanceEvent("SelectionUpdated",t),a.data("dragStarted",0))}),100)},a.restoreData=function(){var e,t=[];for(this.iterateComponents((function(e){e.getType&&"dataset"===e.getType()&&t.push(e)})),this._deleteAllSelection(),e=0;e<t.length;e++)t[e].asyncDraw();return this.fireChartInstanceEvent("dataRestored",{}),!0},a._postSpaceManagement=function(){t.prototype._postSpaceManagement.call(this),this._deleteAllSelection()},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){},o}(n["default"]);t["default"]=k}).call(this,a(6))},978:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(662)),n=a(224),l=a(232),s=o(a(979)),c=n.preDefStr.altHGridColorStr,d=n.preDefStr.altHGridAlphaStr;(0,l.addDep)({name:"selectScatterAnimation",type:"animationRule",extension:s["default"]});var h=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"selectScatter"},a.configure=function(t){e.prototype.configure.call(this,t);var a=this.getFromEnv("chart"),o=a.config,r=a.getFromEnv("dataSource").chart,i=this.getFromEnv("color-manager"),s=(0,n.pluck)(r.selectbordercolor,i.getColor("canvasBorderColor")),h=(0,n.pluckNumber)(r.selectborderalpha,i.getColor("canvasBorderAlpha"));o.selectBorderColor={FCcolor:{color:s,alpha:h}},o.selectFillColor=(0,n.convertColor)((0,n.pluck)(r.selectfillcolor,i.getColor(c)),(0,n.pluckNumber)(r.selectfillalpha,i.getColor(d))),o.selectionCancelButtonBorderColor=(0,n.convertColor)((0,n.pluck)(r.selectioncancelbuttonbordercolor,s),(0,n.pluckNumber)(r.selectioncancelbuttonborderalpha,h)),o.selectionCancelButtonFillColor=(0,n.convertColor)((0,n.pluck)(r.selectioncancelbuttonfillcolor,"FFFFFF"),(0,n.pluckNumber)(r.selectioncancelbuttonfillalpha,100)),o.connativeZoom=!1,o.zoomType="xy",r.submitdataasxml!==n.ZEROSTRING||r.formdataformat||(r.formdataformat=(0,l.getDepsByType)("transcoder").csv&&"csv"),o.formDataFormat=(0,n.pluck)(r.formdataformat),o.formTarget=(0,n.pluck)(r.formtarget,"_self"),o.formMethod=(0,n.pluck)(r.formmethod,"POST"),o.submitFormAsAjax=(0,n.pluckNumber)(r.submitformusingajax,1)},a.draw=function(){e.prototype.draw.call(this);var t=this.getFromEnv("chart"),a=t.getFromEnv("chart-container"),o=this.getFromEnv("xAxis"),r=this.getFromEnv("yAxis");(0,n.bindSelectionEvent)(t,{selectionStart:function(e){var i=(0,n.getMouseCoordinate)(a,e.originalEvent,t),l=(0,n.extend2)({selectionLeft:e.selectionLeft,selectionTop:e.selectionTop,selectionWidth:e.selectionWidth,selectionHeight:e.selectionHeight,startXValue:o.getValue(e.selectionLeft,1),startYValue:r.getValue(e.selectionTop,1)},i);e.chart.fireChartInstanceEvent("selectionStart",l)},selectionEnd:function(e){var i=(0,n.getMouseCoordinate)(a,e.originalEvent,t),l=(0,n.extend2)({selectionLeft:e.selectionLeft,selectionTop:e.selectionTop,selectionWidth:e.selectionWidth,selectionHeight:e.selectionHeight,startXValue:o.getValue(e.selectionLeft,1),startYValue:r.getValue(e.selectionTop,1),endXValue:o.getValue(e.selectionLeft+e.selectionWidth,1),endYValue:r.getValue(e.selectionTop+e.selectionHeight,1)},i);e.chart.fireChartInstanceEvent("selectionEnd",l),e.chart.createSelectionBox(e)}})},t}(i["default"]);t["default"]=h},979:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.selectScatter":o(a(558))["default"]["*.dataset.line"]};t["default"]=r},980:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(981))["default"];t["default"]=r},981:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(465)),n=o(a(982)),l=function(e){function t(){var t;return(t=e.call(this)||this).defaultPaletteOptions=null,t.registerFactory("dataset",n["default"],["canvas"]),t}(0,r["default"])(t,e),t.getName=function(){return"MultilevelPie"};var a=t.prototype;return a.getName=function(){return"MultilevelPie"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.is3D=!1,t.hasLegend=!1,t.defaultDatasetType="multiLevelPie",t.valuefontbold=0,t.skipCanvasDrawing=!0},a._checkInvalidSpecificData=function(){var e=this.getFromEnv("dataSource").category;if(!e||!e[0]||!Array.isArray(e))return!0},a._spaceManager=function(){var e,t=this.config;this._allocateSpace(this._manageActionBarSpace&&this._manageActionBarSpace(.225*t.availableHeight)||{}),e=.7*t.canvasHeight,this._manageChartMenuBar(e),this.allocateDimensionOfChartMenuBar()},t}(i["default"]);t["default"]=l},982:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o,n={};t=e.config.categories=e.getFromEnv("dataSource").category||[],a=t.length,!o&&a&&(n=t,o=a);if(!a)return void e.setChartMessage();(0,r.datasetFactory)(e,i["default"],"dataset",o,[n])};var r=a(224),i=o(a(983))},983:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(588)),n=a(538),l=a(224),s=a(232),c=o(a(984)),d=a(236),h=o(a(332)),u=(0,s.getDep)("redraphael","plugin"),p=/^[0-9]+\%?$|^([0-9]+[.][0-9]+)\%?$/;(0,s.addDep)({name:"multilevelpieAnimation",type:"animationRule",extension:c["default"]}),(0,h["default"])(u);var g=function(e){function t(){var t;return(t=e.call(this)||this).components={data:[]},t.graphics={},t}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"multiLevelPie"},a.configureAttributes=function(e){if(!e)return!1;this.config.JSONData=e;var t,a,o,r=this.getFromEnv("chart"),i=r.config,s=this.config||(this.config={}),c=s.dataLabelOptions||(s.dataLabelOptions={}),d=s.piePlotOptions,h=r.config.style,u=r.getFromEnv("dataSource").chart,g=(0,l.pluckNumber)(-u.centerangle,180),f=(0,l.pluckNumber)(u.totalangle,360),m=function(e,t){for(var a=e;a.graphics.element;)a.graphics.element.attr({fill:"mouseover"===t?s.hoverFillColor:(a.config||this.data("plotItem")).color}),a=a.config.parent},v=function x(e,t){var a;for(e.graphics.element.attr({fill:"mouseover"===t?s.hoverFillColor:(e.config||this.data("plotItem")).color}),a=0;a<(e.components.data&&e.components.data.length);a++)x.call(this,e.components.data[a],t)},b=function(e){if(s.useHoverColor){var t=this.data("plotItem"),a=t.selfRef;s.highlightParentPieSlices||s.highlightChildPieSlices?!s.highlightParentPieSlices&&s.highlightChildPieSlices?v.call(this,a,e):s.highlightParentPieSlices&&!s.highlightChildPieSlices?m.call(this,a,e):s.highlightParentPieSlices&&s.highlightChildPieSlices&&(m.call(this,a,e),v.call(this,a,e)):a.graphics.element.attr({fill:"mouseover"===e?s.hoverFillColor:(a.config||t).color})}};s.usePattern=(0,l.pluckNumber)(i.usePattern,0),s.patternType=n.PATTERN_TYPES.includes(e.patterntype)?e.patterntype:i.patternType,s.patternDensity=(0,l.pluckNumber)(e.patterndensity,i.patternDensity),s.patternAlpha=(0,l.pluckNumber)(e.patternalpha,i.patternAlpha),s.patternBgColor=(0,l.pluck)(e.patternbgcolor,s.patternBgColor),s.enableAnimation=(0,l.pluckNumber)(u.animation,u.defaultanimation,1),s.animation=!!s.enableAnimation&&{duration:1e3*(0,l.pluckNumber)(u.animationduration,u.moveduration,1)},s.showShadow=(0,l.pluckNumber)(u.showshadow,0),s.useHoverColor=Boolean((0,l.pluckNumber)(u.usehovercolor,1)),s.usePattern&&(s.useHoverColor=0),s.showTextOutline=Boolean((0,l.pluckNumber)(u.textoutline,0)),s.hoverFillColor=(0,l.convertColor)((0,l.pluck)(u.hoverfillcolor,"FF5904"),(0,l.pluckNumber)(u.hoverfillalpha,100)),t=(t=(0,l.getFirstValue)(u.valuebordercolor,""))?(0,l.convertColor)(t,(0,l.pluckNumber)(u.valueborderalpha,u.valuebgalpha,u.valuealpha,100)):"",!c.style&&(c.style={fontFamily:(0,l.pluck)(u.valuefont,h.fontFamily),fontSize:(0,l.pluckNumber)(this.computeFontSize(u.valuefontsize),(a=h.fontSize,o=10,parseInt(a,o||10)))+"px",color:(0,l.convertColor)((0,l.pluck)(u.valuefontcolor,h.color),(0,l.pluckNumber)(u.valuefontalpha,u.valuealpha,100)),fontWeight:(0,l.pluckNumber)(u.valuefontbold)?"bold":"normal",fontStyle:(0,l.pluckNumber)(u.valuefontitalic)?"italic":"normal",backgroundColor:u.valuebgcolor?(0,l.convertColor)(u.valuebgcolor,(0,l.pluckNumber)(u.valuebgalpha,u.valuealpha,100)):"",border:t||u.valuebgcolor?(0,l.pluckNumber)(u.valueborderthickness,1)+"px solid":"",borderPadding:(0,l.pluckNumber)(u.valueborderpadding,2),borderThickness:(0,l.pluckNumber)(u.valueborderthickness,h.borderThickness,1),borderRadius:(0,l.pluckNumber)(u.valueborderradius,h.borderRadius,0),borderColor:t,borderDash:(0,l.pluckNumber)(u.valueborderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(u.valueborderdashlen,4),(0,l.pluckNumber)(u.valueborderdashgap,2)):"none"}),!d&&(d=s.piePlotOptions={}),d.allowPointSelect=!1,s.borderAlpha=(0,l.pluck)(u.plotborderalpha,u.pieborderalpha,100),s.borderColor=(0,l.convertColor)((0,l.pluck)(u.plotbordercolor,u.piebordercolor,"FFFFFF"),u.showplotborder!==l.ZEROSTRING?(0,l.pluck)(u.plotborderalpha,u.pieborderalpha,100):0),s.rawborderColor=(0,l.pluck)(u.plotbordercolor,u.piebordercolor,"FFFFFF"),s.showplotborder=(0,l.pluckNumber)(u.showplotborder,1),s.showTooltip=(0,l.pluckNumber)(u.showtooltip,1),s.borderWidth=(0,l.pluckNumber)(u.pieborderthickness,u.plotborderthickness,1),d.startingAngle=0,d.size="100%",s.highlightParentPieSlices=(0,l.pluckNumber)(u.highlightparentpieslices,u.highlightparentpienodes,1),s.highlightChildPieSlices=(0,l.pluckNumber)(u.highlightchildpieslices,u.highlightchildpienodes,0),s.showLabels=(0,l.pluckNumber)(u.showlabels,1),s.showValues=(0,l.pluckNumber)(u.showvalues,0),s.showValuesInTooltip=(0,l.pluckNumber)(u.showvaluesintooltip,u.showvalues,0),s.showPercentValues=(0,l.pluckNumber)(u.showpercentvalues,u.showpercentagevalues,0),s.showPercentInTooltip=(0,l.pluckNumber)(u.showpercentintooltip,0),s.toolTipSepChar=(0,l.pluck)(u.tooltipsepchar,u.hovercapsepchar,l.COMMASPACE),s.labelSepChar=(0,l.parseUnsafeString)((0,l.pluck)(u.labelsepchar,s.toolTipSepChar)),s.tooltext=u.plottooltext,s.alpha=(0,l.pluck)(u.plotfillalpha,u.piefillalpha,100),s.startAngle=(g-f/2)*(Math.PI/180),s.endtAngle=(g+f/2)*(Math.PI/180),s.initialAngle=s.endtAngle,s.originX=(0,l.pluckNumber)(u.originx),s.originY=(0,l.pluckNumber)(u.originy),s.events={mouseOver:function(){b.call(this,"mouseover")},mouseOut:function(){b.call(this,"mouseout")}},i.plotBorderWidth=0,s.autoRotateLabels=i.autorotatelabels?(0,l.pluckNumber)(i.autorotatelabels):0,s.useEllipsesWhenOverflow=i.useellipseswhenoverflow?(0,l.pluckNumber)(i.useellipseswhenoverflow):1,s.skipOverlapLabels=i.skipoverlaplabels?(0,l.pluckNumber)(i.skipoverlaplabels):0,i.plotBorderWidth=0,s.maxLevel=this.addMSPieCat(this.config.JSONData,1,this,s.startAngle,s.endtAngle),s.pieRadius=parseInt(u.pieradius,10),s.innerRadius="0",p.test(u.innerradius)&&(s.innerRadius=(0,l.pluck)(u.innerradius)),c.distance=0,c.placeLabelsInside=!0},a.removalFn=function(e,t){this.getFromEnv("animationManager").setAnimation({el:e,label:"element"===t?"ringpath":"label",component:this,callback:function(){this.remove()}})},a.removeGraphics=function(e){var t,a,o,r=e.components&&e.components.data,i=e.graphics;if(r)for(o=r.length,t=0;t<o;t+=1)this.removeGraphics(r[t]);if(e.graphics)for(a in i)i.hasOwnProperty(a)&&this.removalFn(e.graphics[a],a)},a.removeChild=function(e,t,a){var o,r;if(e.length)for(o=0;o<e.length;o+=1)r=e[o],a?this.removalFn(r,t,a):this.removeGraphics(r,t);else for(o in e)this.removeChild(e[o],t,o)},a.addMSPieCat=function(e,t,a,o,r){var i,s,c,d,h,u,p,g,f,m,v,b,x,k,y,C,w,A,S,N,L,D,E,T,F=(0,l.extend2)([],e),P=F.length,_=this,V=a.components.data,I=_.config,B=_.getFromEnv("number-formatter"),M=0,O=I.labelSepChar,R=t,G=V.length,H=function(){_.removeChild.apply(_,arguments)},z=F.length,W=r-o,U=0;for(p=0;p<P;p+=1)(h=F[p])._userValue=B.getCleanValue(h.value,!0),h._value=(0,l.pluckNumber)(h._userValue,1),M+=h._value;for(d=W/(M=M||1),p=P-1;p>=0;p-=1)u=d*(h=F[p])._value,g=(0,l.parseUnsafeString)((0,l.pluck)(h.label,h.name)),m=null!==h._userValue?B.dataLabels(h._userValue):"",v=B.percentValue(h._value/M*100),f=(0,l.pluckNumber)(h.alpha,I.alpha),y=(0,l.pluckNumber)(h.showlabel,I.showLabels),D=(0,l.pluckNumber)(I.showplotborder,1),x=1===y?g:"",1===(0,l.pluckNumber)(h.showvalue,I.showValues)&&(I.showPercentValues?x+=""!==x?O+v:v:void 0!==m&&""!==m&&(x+=""!==x?O+m:m)),""===(b=I.showTooltip?(0,l.parseUnsafeString)((0,l.pluck)(h.tooltext,h.hovertext,I.tooltext),!1):void 0)?(b=g,I.showValuesInTooltip&&(I.showPercentInTooltip?b+=""!==b?O+v:v:void 0!==m&&""!==m&&(b+=""!==b?O+m:m))):b=(0,l.parseTooltext)(b,[1,2,3,14],{percentValue:v,label:g,formattedValue:m},h),E=o+U,U+=u,(i=V[p])||(i=V[p]={components:{data:[]},config:{},graphics:{}}),i.graphics.element&&(T=i.config.startAngle+i.config.angleStrech),C=n.PATTERN_TYPES.includes(h.patterntype)?h.patterntype:I.patternType,w=(0,l.pluckNumber)(h.patternangle,_.getFromEnv("chart-attrib").patternangle,C===n.PATTERN_TYPES[0]?40:0),A=(0,l.pluckNumber)(h.patterndensity,I.patternDensity),S=(0,l.pluckNumber)(h.patternsize,C===n.PATTERN_TYPES[0]?2:4),N=(0,l.pluckNumber)(h.patternalpha,I.patternAlpha),L=(0,l.pluck)(h.patternbgcolor,I.patternBgColor),k=h.color||_.getFromEnv("color-manager").getPlotColor(),i.config={patternType:C,patternAngle:w,patternDensity:A,patternSize:S,patternAlpha:N,patternBgColor:L,initialAngle:T||(a.config||a.config).initialAngle,startAngle:E,alpha:f,angleStrech:u,level:t,displayValue:x,showLabel:y,showPlotBorder:D,toolText:b,link:(0,l.getValidValue)(h.link),rawColor:k,doNotSlice:!0,color:(0,l.convertColor)(k,f),borderAlpha:(0,l.pluck)(h.plotborderalpha,I.borderAlpha),borderWidth:(0,l.pluckNumber)(h.borderwidth,I.borderWidth),borderColor:(0,l.pluck)(h.bordercolor,I.borderColor),rawborderColor:(0,l.pluck)(h.bordercolor,I.rawborderColor),dashStyle:(0,l.pluckNumber)(h.valueborderdashed,0)?(0,l.getDashStyle)((0,l.pluckNumber)(h.borderdashlen,4),(0,l.pluckNumber)(h.borderdashgap,2)):"none",shadow:{opacity:.01*Math.round(f>50?f*f*f*1e-4:f*f*.01)},isSingleTon:!(P>1)},I.usePattern&&(i.config.borderColor=i.config.color,i.config.rawborderColor=(0,l.hashify)(k)),i.config.parent=a,i.config.dataLabelStyle=_._configureDataLabelStyle(h),h.category?(R=Math.max(R,_.addMSPieCat(h.category,t+1,i,E,u+E)),(s=i.components.data.length)>(c=h.category.length)&&H(i.components.data.splice(s-1,c))):(s=i.components.data.length)&&H(i.components.data.splice(0,s));return G>z&&H(V.splice(z)),R},a.parsePlotAttributes=function(e){var t,a,o,r,i,n,s,c,d,h,u,p,g,f,m,v,b,x=e,k=this.config||{},y=this.getFromEnv("chart"),C=y.config,w=this.components.data.length,A=C.dataLabelStyle,S=C.canvasWidth,N=C.canvasHeight,L=(0,l.pluckNumber)(k.originX,C.canvasLeft+.5*S),D=(0,l.pluckNumber)(k.originY,C.canvasTop+.5*N),E=(0,l.pluckNumber)(2*k.pieRadius,Math.min(S,N)),T=function(e,t){var a,o=e&&e.length;return e&&(a="%"===e.charAt(o-1)?(0,l.pluckNumber)(t)*((0,l.pluckNumber)(e.split("%")[0])/100):(0,l.pluckNumber)(e))<t?a:0}(k.innerRadius,E/2),F=this.config.pool||(this.config.pool={}),P=(E-2*T)/(2*k.maxLevel);for(k.innerSize=2*T,x||(x=this),w=x.components.data.length,f=0;f<w;f+=1)this.parsePlotAttributes(x.components.data[f]);(r=(v=x.config).level)&&(n=r*P+T,s=(r-1)*P+T,v.outerRadius=n,v.innerRadius=s,m=x.graphics,d=v.angleStrech,h=v.displayValue,u=!!v.link,c=v.color,g=(p=v.startAngle)+v.angleStrech,b=m.element,F.element&&F.element.length&&(b=m.element=b||F.element.shift()),v.plotItem={chart:y,link:v.link,value:d,color:c,labelText:h,graphics:{element:b},selfRef:x},v.eventArgs={alpha:v.alpha,borderAlpha:v.borderAlpha,link:v.link,label:v.displayValue,showLabel:v.showLabel,toolText:v.toolText,color:v.rawColor,borderColor:v.rawborderColor,borderThickness:v.borderWidth,showPlotBorder:v.showPlotBorder},k.usePattern&&(v.eventArgs.pattern={patternType:v.patternType,patternColor:v.rawColor,patternBgColor:v.patternBgColor===l.TRACKER_FILL?void 0:v.patternBgColor},delete v.eventArgs.color),v.props={element:{attr:{ringpath:[L,D,n,s,p,g],"stroke-width":v.borderWidth,stroke:v.borderColor,fill:(0,l.toRaphaelColor)(v.color),"stroke-dasharray":v.dashStyle,cursor:u?"pointer":l.BLANKSTRING}}},v.props.element.patternAttr={patternType:v.patternType,patternAngle:v.patternAngle,patternDensity:v.patternDensity,patternSize:v.patternSize,color:v.color,patternAlpha:v.patternAlpha,patternBgColor:v.patternBgColor,alpha:v.alpha,x:L,y:D},void 0!==h&&h!==l.BLANKSTRING&&(t=(p+g)/2,o=0===s&&v.isSingleTon?0:s+(n-s)/2,(a=v._textAttrs)||(a=v._textAttrs={}),i=v.dataLabelStyle,a.text=h,a.fill=i.color||"000000",a.direction=C.textDirection,a.cursor=u?"pointer":l.BLANKSTRING,a.x=L+o*Math.cos(t),a.y=D+o*Math.sin(t),a["line-height"]=A.lineHeight,a["text-bound"]=[i.backgroundColor,i.borderColor,A.borderThickness,A.borderPadding,A.borderRadius,A.borderDash]))},a.parseLabelAttributes=function(e){var t,a,o,r=e,i=this.components.data.length;for(!r&&(r=this),i=r.components.data.length,a=0;a<i;a+=1)this.parseLabelAttributes(r.components.data[a]);t=(o=r.config).displayValue,o.level&&void 0!==t&&t!==l.BLANKSTRING&&(o.props.label={attr:o._textAttrs})},a.draw=function(e){var t,a,o,r,i=e,n=this.config,l=this.getFromEnv("chart"),s=this.components,c=s.data.length,h=l.getChildContainer("datalabelsGroup"),u=n.events||{},p=this.config.pool||(this.config.pool={}),g=s.removeDataArr;for(g&&g.length&&this.removeElement(),i||(i=this,h.css(l.config.dataLabelStyle)),c=i.components.data.length,t=0;t<c;t+=1)this.draw(i.components.data[t]);(o=i.config).level?(r=(a=i.graphics).element,p.element&&p.element.length&&(r=a.element=r||p.element.shift()),(r=a.element=this.getFromEnv("animationManager").setAnimation({el:a.element||"ringpath",attr:o.props.element.attr,container:l.getChildContainer("plotGroup"),component:this,state:"appearing",label:"ringpath"})).addPattern(o.props.element.patternAttr,n.usePattern),r.shadow(n.showShadow&&!!o.shadow).data("plotItem",o.plotItem).data("eventArgs",o.eventArgs).on("fc-mouseover",(function(e){var t=this,a=u.mouseOver,r=t.plotItem||t.data("plotItem"),i=r.chart.getDatasets()[0];l.plotEventHandler(t,e,"DataPlotRollOver"),a&&a.call(t),i.fireEvent("datasetrollover",{pValue:r.pValue,value:r.value,displayValue:o.displayValue})})).on("fc-mouseout",(function(e){var t=this,a=u.mouseOut,r=t.plotItem||t.data("plotItem"),i=r.chart,n=i.getDatasets()[0];i.plotEventHandler(t,e,"DataPlotRollOut"),a&&a.call(t),n.fireEvent("datasetrollout",{pValue:r.pValue,value:r.value,displayValue:o.displayValue})})).on("fc-click",(function(e){l.plotEventHandler(this,e)})),this.getFromEnv("toolTipController").enableToolTip(r,o.toolText),t||n._drawn||(n._drawn=!0,h.show(),this.addJob("labelJob",this.drawLabel.bind(this),d.priorityList.label))):(n._drawn&&this.drawLabel(),this.removeChild(this.config.pool,!0))},a.drawLabel=function(e){var t,a,o,r,i,n,s,c,d,h,u=this.config,p=e,g=this.getFromEnv("chart"),f=this.getFromEnv("smartLabel"),m=this.getFromEnv("animationManager"),v=g.config,b=this.components.data.length,x=v.tooltip||{},k=x&&!1!==x.enabled,y=(u||{}).events||{},C=u.pool||(u.pool={}),w=g.getChildContainer("datalabelsGroup");for(w.show(),!p&&(p=this),b=p.components.data.length,s=0;s<b;s+=1)this.drawLabel(p.components.data[s]);i=(d=p.config).displayValue,d.level?(n=(c=p.graphics).label,o=d.angleStrech,void 0!==i&&i!==l.BLANKSTRING&&(!u.skipOverlapLabels||u.skipOverlapLabels&&o>.1)?(h=c.label,C.label&&C.label.length&&(h=c.label=h||C.label.shift()),r=d.props.label.attr,u.autoRotateLabels?(a=180*(d.startAngle+o/2)/Math.PI,Math.abs(a)>90&&Math.abs(a)<180&&(a=-(180-a)),360===Math.floor(180*o/Math.PI)&&(a=0),f.useEllipsesOnOverflow(u.useEllipsesWhenOverflow),f.setStyle(v.dataLabelStyle),t=f.getSmartText(i,d.outerRadius-d.innerRadius-10,f._lineHeight),r.text=t.text,r.transform=(0,l.getSuggestiveRotation)(parseFloat(a),r.x,r.y)):r.transform=(0,l.getSuggestiveRotation)(0,r.x,r.y),(h=c.label=m.setAnimation({el:n||"text",attr:r,container:w,component:this,state:"appearing",label:"text"})).outlineText(u.showTextOutline,r.fill),n||h.on("fc-click",(function(e){g.plotEventHandler(this,e)})).on("fc-mouseout",(function(e){var t=y.mouseOut;g.plotEventHandler(this,e,"DataPlotRollOut"),t&&t.call(this)})).on("fc-mouseover",(function(e){var t=y.mouseOver;g.plotEventHandler(this,e,"DataPlotRollOver"),t&&t.call(this)})),h.data("plotItem",d.plotItem).data("eventArgs",d.eventArgs),k&&this.getFromEnv("toolTipController").enableToolTip(h,void 0)):(n&&m.setAnimation({el:n,component:this,label:"text"}),delete c.label)):this.removeChild(this.config.pool,!0)},t}(i["default"]);t["default"]=g},984:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.multiLevelPie":function(){var e,t=this.config;return{"ringpath.appearing":function(a){return[{initialAttr:{ringpath:[(e=a.attr.ringpath)[0],e[1],e[2],e[3],t.initialAngle,t.initialAngle]},slot:"plot"}]},"text.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]}}}}},985:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(986))["default"];t["default"]=r},986:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(987)),n=o(a(981)),l=a(224),s=["1E77B4","FF7F0E","2BA02C","D62728","9466BD","8C564B","E376C2","7F7F7F","BCBD22","17BECF"],c=function(e){function t(){var t;return(t=e.call(this)||this).defaultPaletteOptions={paletteColors:[s,s,s,s,s],bgColor:["FFFFFF,FFFFFF","FFFFFF,FFFFFF","FFFFFF,FFFFFF","FFFFFF,FFFFFF","FFFFFF,FFFFFF"]},t.registerFactory("dataset",i["default"],["canvas"]),t}(0,r["default"])(t,e),t.getName=function(){return"Sunburst"};var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this),this.config.allowdrilltonode=1,this.config.showvaluesintooltip=1},a.configureAttributes=function(t){e.prototype.configureAttributes.call(this,t);this.config.allowdrilltonode=(0,l.pluckNumber)(t.chart.allowdrilltonode,1),this.config.allowdrilltonode&&this.addToEnv("linkClickFN",(function(){return null}))},a.getName=function(){return"Sunburst"},a._checkInvalidSpecificData=function(){var e=this.parseAndSanitizeData(),t=0;if(!e||!Array.isArray(e)||0===e.length)return!0;for(;t<e.length;t++)if(e[t].category&&0===e[t].category.length&&!e[t].value)return!0},a.parseAndSanitizeData=function(){var e=[],t=[],a={},o=(0,l.extend2)({},this.getFromEnv("dataSource"));if(o&&o.data&&Array.isArray(o.data)){for(var r in t=o.data.map((function(e){return a[e.id]=e,!e.parent&&(e.isRootNode=!0),!e.categories&&(e.category=[]),e})).filter((function(e){return!(!e.id||e.value&&isNaN(+e.value)||!(!e.parent||e.parent&&a[e.parent]))||(delete a[e.id],!1)})),a)if(a.hasOwnProperty(r)){var i=a[r];i.parent&&a[i.parent].category.push(i),i.isRootNode&&e.push(i)}this.addToEnv("parsedDataSource",e)}return t},t}(n["default"]);t["default"]=c},987:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=a(224),i=o(a(988));t["default"]=function(e){var t,a=e.getFromEnv("parsedDataSource")||[];a.forEach((function(e){var t=function a(e){var t=0;return e.forEach((function(e){var o=e.value?+e.value:0,r=e.category.length>0?a(e.category):o;r>o?e.value=r:(e.value=o,r=o),t+=r})),t}(e.category);!e.value&&(e.value=0),t>+e.value&&(e.value=t)})),e.config.categories=a,(t=a.length)?(0,r.datasetFactory)(e,i["default"],"dataset",t,[{inputTree:a}]):e.setChartMessage()}},988:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(242)),i=o(a(238)),n=a(224),l=a(232),s=o(a(989)),c=a(236),d=o(a(332)),h=o(a(983)),u=(0,l.getDep)("redraphael","plugin"),p=/^[0-9]+\%?$|^([0-9]+[.][0-9]+)\%?$/;(0,l.addDep)({name:"sunburstAnimation",type:"animationRule",extension:s["default"]}),(0,d["default"])(u);var g=function(e){function t(){var t;t=e.call(this)||this;var a=(0,r["default"])(t);return a.components={data:[]},a.graphics={},a.elementClickedFn=function(e){var t=a.getFromEnv("chart"),o=this.data("eventArgs");t.plotEventHandler(this,e),t.config.allowdrilltonode&&a.chartDrillDown(o.nodeId,o.nodeParentId,o.childrenCount)},a.drillDownToId=void 0,a.nodeColorMap={},t}(0,i["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"multiLevelPie"},a.configureAttributes=function(e){if(!e)return!1;this.config.JSONData=e,this.config.inputTree=e.inputTree||[],this.config.isDrilledDown=e.isDrilledDown;var t,a,o,r=this,i=r.getFromEnv("chart"),l=i.config,s=r.config||(r.config={}),c=s.dataLabelOptions||(s.dataLabelOptions={}),d=s.piePlotOptions,h=i.config.style,u=i.getFromEnv("dataSource").chart,g=(0,n.pluckNumber)(-u.centerangle,180),f=(0,n.pluckNumber)(u.totalangle,360),m=function(e,t){var a=e;for(v(r,t);a.graphics.element;)a.graphics.element.attr({fill:"mouseover"===t&&s.hoverFillColor?(0,n.convertColor)(s.hoverFillColor):(a.config||this.data("plotItem")).color,"fill-opacity":"mouseover"===t?s.hoverFillAlpha:(a.config||this.data("plotItem")).alpha}),a=a.config.parent},v=function k(e,t){var a=e.components.data;if(a)for(var o=0;o<a.length;o++)a[o].graphics&&a[o].graphics.element&&a[o].graphics.element.attr({fill:(a[o].config||this.data("plotItem")).color,"fill-opacity":"mouseover"===t?s.unFocussedAlpha:(a[o].config||this.data("plotItem")).alpha});if(e.components&&a)for(var r=0;r<a.length;r++)k(a[r],t)},b=function y(e,t){var a;for(e.graphics.element.attr({fill:"mouseover"===t?s.hoverFillColor:(e.config||this.data("plotItem")).color}),a=0;a<(e.components.data&&e.components.data.length);a++)y.call(this,e.components.data[a],t)},x=function(e){if(s.useHoverColor){var t=this.data("plotItem"),a=t.selfRef;s.highlightParentPieSlices||s.highlightChildPieSlices?!s.highlightParentPieSlices&&s.highlightChildPieSlices?b.call(this,a,e):s.highlightParentPieSlices&&!s.highlightChildPieSlices?m.call(this,a,e):s.highlightParentPieSlices&&s.highlightChildPieSlices&&(m.call(this,a,e),b.call(this,a,e)):a.graphics.element.attr({fill:"mouseover"===e?s.hoverFillColor:(a.config||t).color})}};s.isSingleRootNode=1===s.inputTree.length,s.enableAnimation=(0,n.pluckNumber)(u.animation,u.defaultanimation,1),s.animation=!!s.enableAnimation&&{duration:1e3*(0,n.pluckNumber)(u.animationduration,u.moveduration,1)},s.showShadow=(0,n.pluckNumber)(u.showshadow,0),s.useHoverColor=Boolean((0,n.pluckNumber)(u.usehovercolor,1)),s.showTextOutline=Boolean((0,n.pluckNumber)(u.textoutline,0)),s.hoverFillAlpha=(0,n.pluckNumber)(u.hoverfillalpha,80),s.hoverFillColor=u.hoverfillcolor,s.unFocussedAlpha=(0,n.pluck)(u.unfocussedalpha,"0.35"),t=(t=(0,n.getFirstValue)(u.valuebordercolor,""))?(0,n.convertColor)(t,(0,n.pluckNumber)(u.valueborderalpha,u.valuebgalpha,u.valuealpha,100)):"",!c.style&&(c.style={fontFamily:(0,n.pluck)(u.valuefont,h.fontFamily),fontSize:(0,n.pluckNumber)(this.computeFontSize(u.valuefontsize),(a=h.fontSize,o=10,parseInt(a,o||10)))+"px",color:(0,n.convertColor)((0,n.pluck)(u.valuefontcolor,h.color),(0,n.pluckNumber)(u.valuefontalpha,u.valuealpha,100)),fontWeight:(0,n.pluckNumber)(u.valuefontbold)?"bold":"normal",fontStyle:(0,n.pluckNumber)(u.valuefontitalic)?"italic":"normal",backgroundColor:u.valuebgcolor?(0,n.convertColor)(u.valuebgcolor,(0,n.pluckNumber)(u.valuebgalpha,u.valuealpha,100)):"",border:t||u.valuebgcolor?(0,n.pluckNumber)(u.valueborderthickness,1)+"px solid":"",borderPadding:(0,n.pluckNumber)(u.valueborderpadding,2),borderThickness:(0,n.pluckNumber)(u.valueborderthickness,h.borderThickness,1),borderRadius:(0,n.pluckNumber)(u.valueborderradius,h.borderRadius,0),borderColor:t,borderDash:(0,n.pluckNumber)(u.valueborderdashed,0)?(0,n.getDashStyle)((0,n.pluckNumber)(u.valueborderdashlen,4),(0,n.pluckNumber)(u.valueborderdashgap,2)):"none"}),!d&&(d=s.piePlotOptions={}),d.allowPointSelect=!1,s.borderAlpha=(0,n.pluck)(u.plotborderalpha,u.pieborderalpha,100),s.borderColor=(0,n.convertColor)((0,n.pluck)(u.plotbordercolor,u.piebordercolor,"FFFFFF"),0!=+u.showplotborder?(0,n.pluck)(u.plotborderalpha,u.pieborderalpha,100):0),s.rawborderColor=(0,n.pluck)(u.plotbordercolor,u.piebordercolor,"FFFFFF"),s.showplotborder=(0,n.pluckNumber)(u.showplotborder,1),s.showTooltip=(0,n.pluckNumber)(u.showtooltip,1),s.borderWidth=(0,n.pluckNumber)(u.pieborderthickness,u.plotborderthickness,1),d.startingAngle=0,d.size="100%",s.highlightParentPieSlices=(0,n.pluckNumber)(u.highlightparentpieslices,u.highlightparentpienodes,1),s.highlightChildPieSlices=(0,n.pluckNumber)(u.highlightchildpieslices,u.highlightchildpienodes,0),s.showLabels=(0,n.pluckNumber)(u.showlabels,1),s.showValues=(0,n.pluckNumber)(u.showvalues,0),s.showValuesInTooltip=(0,n.pluckNumber)(l.showvaluesintooltip,u.showvaluesintooltip,u.showvalues,0),s.showPercentValues=(0,n.pluckNumber)(u.showpercentvalues,u.showpercentagevalues,0),s.showPercentInTooltip=(0,n.pluckNumber)(u.showpercentintooltip,0),s.toolTipSepChar=(0,n.pluck)(u.tooltipsepchar,u.hovercapsepchar,n.COMMASPACE),s.labelSepChar=(0,n.parseUnsafeString)((0,n.pluck)(u.labelsepchar,s.toolTipSepChar)),s.tooltext=u.plottooltext,s.alpha=(0,n.pluck)(u.plotfillalpha,u.piefillalpha,100),s.startAngle=(g-f/2)*(Math.PI/180),s.endtAngle=(g+f/2)*(Math.PI/180),s.initialAngle=s.endtAngle,s.originX=(0,n.pluckNumber)(u.originx),s.originY=(0,n.pluckNumber)(u.originy),s.events={mouseOver:function(){x.call(this,"mouseover")},mouseOut:function(){x.call(this,"mouseout")}},l.plotBorderWidth=0,l.plotBorderWidth=0,s.maxLevel=r.addMSPieCat(r.config.inputTree,1,r,s.startAngle,s.endtAngle),s.pieRadius=parseInt(u.pieradius,10),s.innerRadius=s.isSingleRootNode?"0":"30",p.test(u.innerradius)&&(s.isSingleRootNode||+s.innerRadius<+u.innerradius)&&(s.innerRadius=(0,n.pluck)(u.innerradius)),c.distance=0,c.placeLabelsInside=!0},a.removalFn=function(e,t){this.getFromEnv("animationManager").setAnimation({el:e,label:"element"===t?"ringpath":"label",component:this,callback:function(){this.remove()}})},a.removeGraphics=function(e){var t,a,o,r=e.components&&e.components.data,i=e.graphics;if(r)for(o=r.length,t=0;t<o;t+=1)this.removeGraphics(r[t]);if(e.graphics)for(a in i)i.hasOwnProperty(a)&&this.removalFn(e.graphics[a],a)},a.removeChild=function(e,t,a){var o,r;if(e.length)for(o=0;o<e.length;o+=1)r=e[o],a?this.removalFn(r,t,a):this.removeGraphics(r,t);else for(o in e)this.removeChild(e[o],t,o)},a.addMSPieCat=function(e,t,a,o,r,i){void 0===i&&(i=null);var l,s,c,d,h,u,p,g,f,m,v,b,x,k,y,C,w,A,S,N=(0,n.extend2)([],e),L=N.length,D=this,E=a.components.data,T=D.config,F=D.getFromEnv("number-formatter"),P=0,_=T.labelSepChar,V=t,I=E.length,B=function(){D.removeChild.apply(D,arguments)},M=N.length,O=r-o,R=0;for(g=0;g<L;g+=1)(u=N[g])._userValue=F.getCleanValue(u.value,!0),u._value=(0,n.pluckNumber)(u._userValue,1),P+=u._value;for(d=O/(h=i||P||1),g=L-1;g>=0;g-=1)p=d*(u=N[g])._value,f=(0,n.parseUnsafeString)((0,n.pluck)(u.label,u.name)),v=null!==u._userValue?F.dataLabels(u._userValue):"",b=F.percentValue(u._value/h*100),m=(0,n.pluckNumber)(u.alpha,T.alpha),C=(0,n.pluckNumber)(u.showlabel,T.showLabels),w=(0,n.pluckNumber)(T.showplotborder,1),k=1===C?f:"",1===(0,n.pluckNumber)(u.showvalue,T.showValues)&&(T.showPercentValues?k+=""!==k?_+b:b:void 0!==v&&""!==v&&(k+=""!==k?_+v:v)),""===(x=T.showTooltip?(0,n.parseUnsafeString)((0,n.pluck)(u.tooltext,u.hovertext,T.tooltext),!1):void 0)?(x=f,T.showValuesInTooltip&&(T.showPercentInTooltip?x+=""!==x?_+b:b:void 0!==v&&""!==v&&(x+=""!==x?_+v:v))):x=(0,n.parseTooltext)(x,[1,2,3,14],{percentValue:b,label:f,formattedValue:v},u),A=o+R,R+=p,(l=E[g])||(l=E[g]={components:{data:[]},config:{},graphics:{}}),l.graphics.element&&(S=l.config.startAngle+l.config.angleStrech),y=u.color?u.color:t>(T.isSingleRootNode?2:1)?a.config.rawColor:D.config.isDrilledDown&&D.nodeColorMap[u.id]?D.nodeColorMap[u.id]:D.getFromEnv("color-manager").getPlotColor(),D.nodeColorMap[u.id]=y,l.config={initialAngle:S||(a.config||a.config).initialAngle,startAngle:A,alpha:m,angleStrech:p,level:t,displayValue:k,showLabel:C,showPlotBorder:w,toolText:x,link:(0,n.getValidValue)(u.link),drillDownToId:u.id,drillDownParent:u.parent,childrenCount:u.category?u.category.length:0,rawColor:y,doNotSlice:!0,color:(0,n.convertColor)(y,m),borderAlpha:(0,n.pluck)(u.plotborderalpha,T.borderAlpha),borderWidth:(0,n.pluckNumber)(u.borderwidth,T.borderWidth),borderColor:(0,n.pluck)(u.bordercolor,T.borderColor),rawborderColor:(0,n.pluck)(u.bordercolor,T.rawborderColor),dashStyle:(0,n.pluckNumber)(u.valueborderdashed,0)?(0,n.getDashStyle)((0,n.pluckNumber)(u.borderdashlen,4),(0,n.pluckNumber)(u.borderdashgap,2)):"none",shadow:{opacity:.01*Math.round(m>50?m*m*m*1e-4:m*m*.01)},isSingleTon:!(L>1)},l.config.parent=a,l.config.dataLabelStyle=D._configureDataLabelStyle(u),u.category&&u.category.length>0?(V=Math.max(V,D.addMSPieCat(u.category,t+1,l,A,p+A,u._value)),(s=l.components.data.length)>(c=u.category.length)&&B(l.components.data.splice(s-1,c))):(s=l.components.data.length)&&B(l.components.data.splice(0,s));return I>M&&B(E.splice(M)),V},a.chartDrillDown=function(e,t,a){var o=this.getFromEnv("chart").getFromEnv("parsedDataSource"),r=[].concat(o),i=this.getFromEnv("toolTipController"),n=this.drillDownToId===e?t:e,l=null;if(a>0){if(!n)return this.setData({isDrilledDown:!0,inputTree:o},!0),this.drillDownToId=void 0,void i.hideAll();for(;r.length>0;){var s=r.pop();s.id!==n?r.push.apply(r,s.category):l=s}(l.length>0||l.category.length>0)&&(this.drillDownToId=n,this.setData({isDrilledDown:!0,inputTree:[l]},!0),i.hideAll())}},a.parsePlotAttributes=function(e){var t,a,o,r,i,l,s,c,d,h,u,p,g,f,m,v,b,x=e,k=this.config||{},y=this.getFromEnv("chart"),C=y.config,w=this.components.data.length,A=C.dataLabelStyle,S=C.canvasWidth,N=C.canvasHeight,L=(0,n.pluckNumber)(k.originX,C.canvasLeft+.5*S),D=(0,n.pluckNumber)(k.originY,C.canvasTop+.5*N),E=(0,n.pluckNumber)(2*k.pieRadius,Math.min(S,N)),T=function(e,t){var a,o=e&&e.length;return e&&(a="%"===e.charAt(o-1)?(0,n.pluckNumber)(t)*((0,n.pluckNumber)(e.split("%")[0])/100):(0,n.pluckNumber)(e))<t?a:0}(k.innerRadius,E/2),F=this.config.pool||(this.config.pool={}),P=(E-2*T)/(2*k.maxLevel);for(k.innerSize=2*T,x||(x=this),w=x.components.data.length,f=0;f<w;f+=1)this.parsePlotAttributes(x.components.data[f]);(r=(v=x.config).level)&&(l=r*P+T,s=(r-1)*P+T,v.outerRadius=l,v.innerRadius=s,m=x.graphics,d=v.angleStrech,h=v.displayValue,u=!!y.config.allowdrilltonode&&v.childrenCount>0||!!v.link,c=v.color,g=(p=v.startAngle)+v.angleStrech,b=m.element,F.element&&F.element.length&&(b=m.element=b||F.element.shift()),v.plotItem={chart:y,link:v.link,value:d,color:c,labelText:h,graphics:{element:b},selfRef:x},v.eventArgs={alpha:v.alpha,borderAlpha:v.borderAlpha,link:v.link,label:v.displayValue,showLabel:v.showLabel,toolText:v.toolText,color:v.rawColor,borderColor:v.rawborderColor,borderThickness:v.borderWidth,showPlotBorder:v.showPlotBorder,nodeId:v.drillDownToId,nodeParentId:v.drillDownParent,childrenCount:v.childrenCount},v.props={element:{attr:{ringpath:[L,D,l,s,p,g],"stroke-width":v.borderWidth,stroke:v.borderColor,fill:(0,n.toRaphaelColor)(v.color),"stroke-dasharray":v.dashStyle,cursor:u?"pointer":"initial"}}},void 0!==h&&h!==n.BLANKSTRING&&(t=(p+g)/2,o=0===s&&v.isSingleTon?0:s+(l-s)/2,(a=v._textAttrs)||(a=v._textAttrs={}),i=v.dataLabelStyle,a.text=h,a.fill=i.color||"000000",a.direction=C.textDirection,a.cursor=u?"pointer":"initial",a.x=L+o*Math.cos(t),a.y=D+o*Math.sin(t),a["line-height"]=A.lineHeight,a["text-bound"]=[i.backgroundColor,i.borderColor,A.borderThickness,A.borderPadding,A.borderRadius,A.borderDash]))},a.parseLabelAttributes=function(e){var t,a,o,r=e,i=this.components.data.length;for(!r&&(r=this),i=r.components.data.length,a=0;a<i;a+=1)this.parseLabelAttributes(r.components.data[a]);t=(o=r.config).displayValue,o.level&&void 0!==t&&t!==n.BLANKSTRING&&(o.props.label={attr:o._textAttrs})},a.draw=function(e){var t,a,o,r,i,n=e,l=this.config||{},s=this.getFromEnv("chart"),d=this.components,h=d.data.length,u=s.getChildContainer("datalabelsGroup"),p=l.events||{},g=d.removeDataArr;for(g&&g.length&&this.removeElement(),n||(n=this,u.css(s.config.dataLabelStyle)),h=n.components.data.length,t=0;t<h;t+=1)this.draw(n.components.data[t]);(o=n.config).level?(i=(a=n.graphics).element,r=a.element=this.getFromEnv("animationManager").setAnimation({el:i||"ringpath",attr:o.props.element.attr,container:s.getChildContainer("plotGroup"),component:this,state:"appearing",label:"ringpath"}),i||r.on("fc-mouseover",(function(e){var t=this,a=p.mouseOver,r=t.plotItem||t.data("plotItem"),i=r.chart.getDatasets()[0];s.plotEventHandler(t,e,"DataPlotRollOver"),a&&a.call(t),i.fireEvent("datasetrollover",{pValue:r.pValue,value:r.value,displayValue:o.displayValue})})).on("fc-mouseout",(function(e){var t=this,a=p.mouseOut,r=t.plotItem||t.data("plotItem"),i=r.chart,n=i.getDatasets()[0];i.plotEventHandler(t,e,"DataPlotRollOut"),a&&a.call(t),n.fireEvent("datasetrollout",{pValue:r.pValue,value:r.value,displayValue:o.displayValue})})),r.shadow(l.showShadow&&!!o.shadow).data("plotItem",o.plotItem).data("eventArgs",o.eventArgs),r.off("fc-click",this.elementClickedFn),r.on("fc-click",this.elementClickedFn),this.getFromEnv("toolTipController").enableToolTip(r,o.toolText),t||l._drawn||(l._drawn=!0,u.show(),this.addJob("labelJob",this.drawLabel.bind(this),c.priorityList.label))):l._drawn&&this.drawLabel()},a.drawLabel=function(e){var t,a,o,r,i,l,s,c,d,h,u=this.config,p=e,g=this.getFromEnv("chart"),f=this.getFromEnv("animationManager"),m=this.getFromEnv("smartLabel"),v=g.config,b=this.components.data.length,x=v.tooltip||{},k=x&&!1!==x.enabled,y=(u||{}).events||{},C=g.getChildContainer("datalabelsGroup");for(C.show(),!p&&(p=this),b=p.components.data.length,s=0;s<b;s+=1)this.drawLabel(p.components.data[s]);a=(d=p.config).angleStrech,t=180*(d.startAngle+a/2)/Math.PI,Math.abs(t)>90&&Math.abs(t)<270&&(t=-(180-t)),360===Math.floor(180*a/Math.PI)&&(t=0),i=d.displayValue,m.useEllipsesOnOverflow(!0),m.setStyle(v.dataLabelStyle),o=m.getSmartText(i,d.outerRadius-d.innerRadius-10,m._lineHeight),d.level&&(l=(c=p.graphics).label,void 0!==i&&i!==n.BLANKSTRING&&a>.1?(h=c.label,(r=d.props.label.attr).text=o.text,r.transform=(0,n.getSuggestiveRotation)(parseFloat(t),r.x,r.y),(h=c.label=f.setAnimation({el:l||"text",attr:r,container:C,component:this,state:"appearing",label:"text"})).outlineText(u.showTextOutline,r.fill),l||(h.on("fc-mouseout",(function(e){var t=y.mouseOut;g.plotEventHandler(this,e,"DataPlotRollOut"),t&&t.call(this)})).on("fc-mouseover",(function(e){var t=y.mouseOver;g.plotEventHandler(this,e,"DataPlotRollOver"),t&&t.call(this)})),h.off("fc-click",this.elementClickedFn),h.on("fc-click",this.elementClickedFn)),h.data("plotItem",d.plotItem).data("eventArgs",d.eventArgs),k&&this.getFromEnv("toolTipController").enableToolTip(h,void 0)):(l&&f.setAnimation({el:l,component:this,label:"text"}),delete c.label))},t}(h["default"]);t["default"]=g},989:function(e,t,a){"use strict";t.__esModule=!0,t["default"]=void 0;t["default"]={"initial.dataset.multiLevelPie":function(){var e,t=this.config;return{"ringpath.appearing":function(a){return[{initialAttr:{ringpath:[(e=a.attr.ringpath)[0],e[1],e[2],e[3],t.initialAngle,t.initialAngle]},slot:"plot"}]},"text.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]}}}}},990:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(991))["default"];t["default"]=r},991:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(242)),i=o(a(238)),n=o(a(673)),l=o(a(992)),s=o(a(994)),c=o(a(995)),d=a(232),h=o(a(387)),u=a(224),p=o(a(366)),g=u.preDefStr.defaultFontStr,f=u.preDefStr.divLineAlphaStr,m=u.preDefStr.altVGridColorStr,v=u.preDefStr.altVGridAlphaStr,b=u.preDefStr.colors.c000000,x=u.preDefStr.POSITION_BOTTOM,k=u.preDefStr.divLineAlpha3DStr,y=(0,d.getDep)("redraphael","plugin");(0,h["default"])(y);var C=function(e){function t(){var t;t=e.call(this)||this;var a=(0,r["default"])(t);return a.defaultPlotShadow=1,a.axisPaddingLeft=0,a.axisPaddingRight=0,t.registerFactory("axis",l["default"],["canvas"]),t.registerFactory("vCanvas",s["default"],["axis"]),t.registerFactory("dataset",c["default"],["vCanvas"]),t}(0,i["default"])(t,e),t.getName=function(){return"MultiAxisLine"};var a=t.prototype;return a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="multiaxisline",t.defaultcrosslinethickness=1},a.getName=function(){return"MultiAxisLine"},a._checkInvalidSpecificData=function(){var e=this.getFromEnv("dataSource");if(!e.axis||!e.categories)return!0},a._feedAxesRawData=function(){var e,t,a,o,r,i,n,l,s,c,d,h,x,y,C,w,A=this.config,S=this.getFromEnv("color-manager"),N=this.getFromEnv("number-formatter"),L=this.getFromEnv("dataSource"),D=L.chart,E=this.config.is3D,T=E?u.chartPaletteStr.chart3D:u.chartPaletteStr.chart2D,F=(0,u.pluckFontSizeMaintainUnit)(D.outcnvbasefontsize,D.basefontsize,10),P=[],_={},V=[];for(e={isVertical:!1,isReverse:!1,isOpposit:(0,p["default"])(D.xaxisposition,"top"),outCanfontFamily:(0,u.pluck)(D.outcnvbasefont,D.basefont,g),outCanfontSize:this.computeFontSize(F),outCanfontSizeWithUnit:F,outCancolor:(0,u.pluck)(D.outcnvbasefontcolor,D.basefontcolor,S.getColor(T.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),axisNamePadding:D.xaxisnamepadding,axisValuePadding:D.labelpadding,axisNameFont:D.xaxisnamefont,axisNameFontSize:this.computeFontSize(D.xaxisnamefontsize),axisNameFontSizeWithUnit:D.xaxisnamefontsize,axisNameFontColor:D.xaxisnamefontcolor,axisNameFontBold:D.xaxisnamefontbold,axisNameFontItalic:D.xaxisnamefontitalic,axisNameBgColor:D.xaxisnamebgcolor,axisNameBorderColor:D.xaxisnamebordercolor,axisNameAlpha:D.xaxisnamealpha,axisNameFontAlpha:D.xaxisnamefontalpha,axisNameBgAlpha:D.xaxisnamebgalpha,axisNameBorderAlpha:D.xaxisnameborderalpha,axisNameBorderPadding:D.xaxisnameborderpadding,axisNameBorderRadius:D.xaxisnameborderradius,axisNameBorderThickness:D.xaxisnameborderthickness,axisNameBorderDashed:D.xaxisnameborderdashed,axisNameBorderDashLen:D.xaxisnameborderdashlen,axisNameBorderDashGap:D.xaxisnameborderdashgap,useEllipsesWhenOverflow:D.useellipseswhenoverflow,divLineColor:(0,u.pluck)(D.vdivlinecolor,D.divlinecolor,S.getColor(T.divLineColor)),divLineAlpha:(0,u.pluck)(D.vdivlinealpha,D.divlinealpha,E?S.getColor(k):S.getColor(f)),divLineThickness:(0,u.pluckNumber)(D.vdivlinethickness,D.divlinethickness,1),divLineIsDashed:Boolean((0,u.pluckNumber)(D.vdivlinedashed,D.vdivlineisdashed,D.divlinedashed,D.divlineisdashed,0)),divLineDashLen:(0,u.pluckNumber)(D.vdivlinedashlen,D.divlinedashlen,4),divLineDashGap:(0,u.pluckNumber)(D.vdivlinedashgap,D.divlinedashgap,2),showAlternateGridColor:(0,u.pluckNumber)(D.showalternatevgridcolor,0),alternateGridColor:(0,u.pluck)(D.alternatevgridcolor,S.getColor(m)),alternateGridAlpha:(0,u.pluck)(D.alternatevgridalpha,S.getColor(v)),numDivLines:D.numvdivlines,labelFont:D.labelfont,labelFontSize:this.computeFontSize(D.labelfontsize),labelFontSizeWithUnit:D.labelfontsize,labelFontColor:D.labelfontcolor,labelAlpha:D.labelalpha,labelFontBold:D.labelfontbold,labelFontItalic:D.labelfontitalic,labelBdrColor:D.labelbordercolor,labelBdrAlpha:D.labelborderalpha,labelLink:D.labellink,labelBgColor:D.labelbgcolor,labelBgAlpha:D.labelbgalpha,labelBdrThickness:D.labelborderthickness,labelBdrPadding:D.labelborderpadding,labelBdrRadius:D.labelborderradius,labelBdrDashed:D.labelborderdashed,labelBdrDashLen:D.labelborderdashlen,labelBdrDashGap:D.labelborderdashgap,maxLabelHeight:D.maxlabelheight,axisName:D.xaxisname,axisMinValue:D.xaxisminvalue,axisMaxValue:D.xaxismaxvalue,setAdaptiveMin:D.setadaptivexmin,adjustDiv:D.adjustvdiv,labelDisplay:D.labeldisplay,showLabels:D.showlabels,rotateLabels:D.rotatelabels,slantLabel:(0,u.pluckNumber)(D.slantlabels,D.slantlabel),labelStep:(0,u.pluckNumber)(D.labelstep,D.xaxisvaluesstep),showAxisValues:(0,u.pluckNumber)(D.showxaxisvalues,D.showxaxisvalue),showLimits:D.showvlimits,showDivLineValues:(0,u.pluckNumber)(D.showvdivlinevalues,D.showvdivlinevalues),showZeroPlane:D.showvzeroplane,zeroPlaneColor:D.vzeroplanecolor,zeroPlaneThickness:D.vzeroplanethickness,zeroPlaneAlpha:D.vzeroplanealpha,showZeroPlaneValue:D.showvzeroplanevalue,trendlineColor:D.trendlinecolor,trendlineToolText:D.trendlinetooltext,trendlineThickness:D.trendlinethickness,trendlineAlpha:D.trendlinealpha,showTrendlinesOnTop:D.showtrendlinesontop,showAxisLine:(0,u.pluckNumber)(D.showxaxisline,D.showaxislines,D.drawAxisLines,0),axisLineThickness:(0,u.pluckNumber)(D.xaxislinethickness,D.axislinethickness,1),axisLineAlpha:(0,u.pluckNumber)(D.xaxislinealpha,D.axislinealpha,100),axisLineColor:(0,u.pluck)(D.xaxislinecolor,D.axislinecolor,b)},V.push(e),t={outCanfontFamily:(0,u.pluck)(D.outcnvbasefont,D.basefont,g),outCanfontSize:this.computeFontSize(F),outCanfontSizeWithUnit:F,outCancolor:(0,u.pluck)(D.outcnvbasefontcolor,D.basefontcolor,S.getColor(T.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi,"#$1"),useEllipsesWhenOverflow:D.useellipseswhenoverflow,showAlternateGridColor:0,axisNameFont:D.yaxisnamefont,axisNameFontSize:this.computeFontSize(D.yaxisnamefontsize),axisNameFontSizeWithUnit:D.yaxisnamefontsize,axisNameFontColor:D.yaxisnamefontcolor,axisNameFontBold:D.yaxisnamefontbold,axisNameFontItalic:D.yaxisnamefontitalic,axisNameBgColor:D.yaxisnamebgcolor,axisNameBorderColor:D.yaxisnamebordercolor,axisNameAlpha:D.yaxisnamealpha,axisNameFontAlpha:D.yaxisnamefontalpha,axisNameBgAlpha:D.yaxisnamebgalpha,axisNameBorderAlpha:D.yaxisnameborderalpha,axisNameBorderPadding:D.yaxisnameborderpadding,axisNameBorderRadius:D.yaxisnameborderradius,axisNameBorderThickness:D.yaxisnameborderthickness,axisNameBorderDashed:D.yaxisnameborderdashed,axisNameBorderDashLen:D.yaxisnameborderdashlen,axisNameBorderDashGap:D.yaxisnameborderdashgap,labelFont:D.yaxisvaluefont,labelFontSize:this.computeFontSize(D.yaxisvaluefontsize),labelFontSizeWithUnit:D.yaxisvaluefontsize,labelFontColor:D.yaxisvaluefontcolor,labelAlpha:D.yaxisvaluealpha,labelFontBold:D.yaxisvaluefontbold,labelFontItalic:D.yaxisvaluefontitalic,labelBdrColor:D.yaxisvaluebordercolor,labelBdrAlpha:D.yaxisvalueborderalpha,labelLink:D.yaxisvaluelink,labelBgColor:D.yaxisvaluebgcolor,labelBgAlpha:D.yaxisvaluebgalpha,labelBdrThickness:D.yaxisvalueborderthickness,labelBdrPadding:D.yaxisvalueborderpadding,labelBdrRadius:D.yaxisvalueborderradius,labelBdrDashed:D.yaxisvalueborderdashed,labelBdrDashLen:D.yaxisvalueborderdashlen,labelBdrDashGap:D.yaxisvalueborderdashgap},s={side:"l",axesConf:[]},c={side:"r",axesConf:[]},o=0,r=(a=L.axis||[]).length;o<r;o++){for(_={},n=a[o],_.checkBoxChecked=!1,C=0,w=n.dataset?n.dataset.length:0;C<w;C+=1)0!==Number(n.dataset[C].visible)&&(_.checkBoxChecked=!0);l=S.getPlotColor(o),d=(0,u.pluck)(n.color,D.axiscolor,l),h=(0,u.pluckNumber)(n.divlinethickness,D.divlinethickness,1),x=(0,u.pluckNumber)(n.tickwidth,D.axistickwidth,2),y=(0,u.pluckNumber)(n.axislinethickness,D.axislinethickness,2),i=!(0,u.pluckNumber)(n.axisonleft,1),t.isVertical=!0,t.isReverse=!0,t.isOpposit=i,t.labelStep=(0,u.pluckNumber)(n.yaxisvaluesstep,n.yaxisvaluestep,D.yaxisvaluesstep,D.yaxisvaluestep),t.axisMaxValue=n.maxvalue,t.axisMinValue=n.minvalue,t.setAdaptiveMin=(0,u.pluckNumber)(n.setadaptiveymin,D.setadaptiveymin),t.numDivLines=(0,u.pluckNumber)(n.numdivlines,D.numdivlines,4),t.adjustDiv=(0,u.pluckNumber)(n.adjustdiv,D.adjustdiv),t.showAxisValues=(0,u.pluckNumber)(n.showyaxisvalues,n.showyaxisvalue,D.showyaxisvalues,D.showyaxisvalue,1),t.showLimits=(0,u.pluckNumber)(n.showlimits,D.showyaxislimits,D.showlimits,t.showAxisValues),t.showDivLineValues=(0,u.pluckNumber)(n.showdivlinevalue,D.showdivlinevalues,n.showdivlinevalues,t.showAxisValues),t.showZeroPlane=(0,u.pluckNumber)(n.showzeroplane,D.showzeroplane),t.showZeroPlaneValue=(0,u.pluckNumber)(n.showzeroplanevalue,D.showzeroplanevalue),t.zeroPlaneColor=n.zeroplanecolor,t.zeroPlaneThickness=(0,u.pluckNumber)(n.zeroplanethickness,n.divlinethickness,A.zeroplanethickness,2),t.zeroPlaneAlpha=(0,u.pluckNumber)(n.zeroplanealpha,n.divlinealpha,A.zeroplanealpha),t.showZeroPlaneOnTop=A.showzeroplaneontop,t.divLineColor=(0,u.pluck)(n.divlinecolor,d),t.divLineAlpha=(0,u.pluckNumber)(n.divlinealpha,D.divlinealpha,S.getColor(f),100),t.divLineThickness=h,t.divLineIsDashed=Boolean((0,u.pluckNumber)(n.divlinedashed,n.divlineisdashed,D.divlinedashed,D.divlineisdashed,0)),t.divLineDashLen=(0,u.pluckNumber)(n.divlinedashlen,D.divlinedashlen,4),t.divLineDashGap=(0,u.pluckNumber)(n.divlinedashgap,D.divlinedashgap,2),t.showAxisLine=1,t.axisLineThickness=y,t.axisLineAlpha=100,t.axisLineColor=d,t.tickLength=x,t.tickColor=d,t.tickAlpha=100,t.tickWidth=y,t.axisName=n.title,t.rotateAxisName=1,t.axisNameAlignCanvas=!0,t.drawAxisNameFromBottom=!0,(0,u.extend2)(_,t),N.parseMLAxisConf(n,o),0===(0,u.pluckNumber)(n.showaxis)?(0,u.extend2)(_,{axisIndex:o,drawAxisLineWRTCanvas:!1,drawLabels:!1,drawPlotlines:!1,drawAxisLine:!1,drawPlotBands:!1,drawAxisName:!1,drawTrendLines:!1,drawTrendLabels:!1,drawTick:!1,drawTickMinor:!1,showAxis:0}):(0,u.extend2)(_,{axisIndex:o,drawAxisLineWRTCanvas:!1,drawLabels:!0,drawPlotlines:!0,drawAxisLine:!0,drawPlotBands:!0,drawAxisName:!0,drawTrendLines:!0,drawTrendLabels:!0,drawTick:!0,drawTickMinor:!0,showAxis:1}),i?c.axesConf.push(_):s.axesConf.push(_)}return s.axesConf.length&&P.push(s),c.axesConf.length&&P.push(c),{xAxisConfigure:V,yAxisConfigure:P}},a._postSpaceManagement=function(){var e=this.getFromEnv("legend"),t=e&&e.config&&e.config.legendPos?e.config.legendPos.split("-"):[];this.setAxisDimention(),t[0]===u.POSITION_LEFT?this._allocateSpace({left:5}):t[0]===u.POSITION_RIGHT&&this._allocateSpace({right:5}),this.getChildren("yAxisSelectorUI").forEach((function(e){e.setAxisDimention()})),this.getChildren("canvas")[0].setCanvasPadding(),this.setAxisDimention(),this.config.showLegend&&e.postSpaceManager(),this.allocateDimensionOfChartMenuBar()},a.setAxisDimention=function(){var e=this.config,t=this.getChildren("xAxis")[0],a=e.xDepth||0,o=this.getChildren("canvas")[0].config,r=o.canvasBorderWidth,i=o.canvasPadding,n=o.canvasPaddingLeft,l=e.shift||0,s=o.canvasPaddingRight;t&&t.setAxisDimention({x:e.canvasLeft+a+Math.max(n,i),y:t.config.isOpposit?e.canvasTop-r:e.canvasBottom+l+r,opposite:t.config.isOpposit?e.canvasBottom+l+r:e.canvasTop-r,axisLength:e.canvasWidth-a-Math.max(n,i)-Math.max(s,i)})},a._spaceManager=function(){var e,t,a,o,r,i,n,l,s,c,d=this.getChildren("canvas")[0],h=this.config,p=h.legendPosition?h.legendPosition.split("-"):[],g=this.getChildren("xAxis"),f=this.getChildren("yAxisSelectorUI"),m=h.yDepth,v=this.getFromEnv("legend"),b=0,k=0,y=f.length||0,C=this.getFromEnv("dataSource").chart,w=(0,u.pluckNumber)(C.showborder,this.config.is3D?0:1),A=d.config.canvasBorderWidth,S=h.borderWidth=w?(0,u.pluckNumber)(C.borderthickness,1):0,N=h.canvasMarginTop,L=h.canvasMarginBottom,D=h.canvasMarginLeft,E=h.canvasMarginRight,T=(h.minCanvasHeight,h.minCanvasWidth,h.height),F=h.width;h.origCanvasTopMargin,h.origCanvasBottomMargin,h.origCanvasLeftMargin,h.origCanvasRightMargin;for(this._allocateSpace({top:S,bottom:S,left:S,right:S}),this._allocateSpace({left:h.canvasMarginLeft,right:h.canvasMarginRight}),i="left"===p[0]||"right"===p[0]?.3*h.canvasWidth:.3*h.canvasHeight,!1!==h.hasLegend&&g&&h.showLegend&&this._allocateSpace(v._manageLegendPosition(i)),o=0;o<y;o++)b+=(r=f[o].placeAxis(h.canvasWidth)).rightPadding,k+=r.leftPadding,this._allocateSpace(r.dimension);e=.225*h.availableHeight,t=this._manageActionBarSpace&&this._manageActionBarSpace(e)||{},this._allocateSpace(t),a=p[0]===u.POSITION_TOP||p[0]===x?.6*h.canvasHeight:.6*h.canvasWidth,this._manageChartMenuBar(a),.7*h.canvasWidth>b+k&&this._allocateSpace({left:k,right:b}),a=.6*h.canvasHeight,g[0]&&this._allocateSpace(g[0].placeAxis(a)),a=.325*h.canvasHeight,this._getDSspace&&this._allocateSpace(this._getDSspace(a)),m&&this._allocateSpace({bottom:m}),this._allocateSpace({top:A,bottom:A,left:A,right:A}),n=N>h.canvasTop?N-h.canvasTop:0,l=L>T-h.canvasBottom?L+h.canvasBottom-T:0,s=D>h.canvasLeft?D-h.canvasLeft:0,c=E>F-h.canvasRight?E+h.canvasRight-F:0,this._allocateSpace({top:n,bottom:l,left:s,right:c}),h.actualCanvasMarginTop=n,h.actualCanvasMarginLeft=s,h.actualCanvasMarginRight=c,h.actualCanvasMarginBottom=l,d.setDimension({top:h.canvasTop,left:h.canvasLeft,width:h.canvasWidth,height:h.canvasHeight})},a.configure=function(t){e.prototype.configure.call(this,t);var a=this.config,o=this.getFromEnv("dataSource").chart;a.axesPadding=5,a.allowAxisShift=(0,u.pluckNumber)(o.allowaxisshift,1),a.allowSelection=(0,u.pluckNumber)(o.allowselection,1),a.checkBoxColor=(0,u.pluck)(o.checkboxcolor,"#2196f3"),a.axisConfigured=!0},t}(n["default"]);t["default"]=C},992:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o=e.getChildren("canvas")[0],l=o.getChildren("axisRefVisualCartesian")[0];t=e._feedAxesRawData(),n["default"].resetAxisCount(),(0,r.componentFactory)(e,n["default"],"yAxisSelectorUI",t.yAxisConfigure&&t.yAxisConfigure.length,t.yAxisConfigure),(0,r.componentFactory)(e,i["default"],"xAxis",1,t.xAxisConfigure),(a=e.getChildren("xAxis")[0]).setLinkedItem("canvas",o),l.setLinkedItem(a.getId(),a),l.addExtEventListener("visiblerangeset",(function(){return l.asyncDraw()}),a),o.attachAxis(a,!1),o.setPrimaryAxis("xAxis",a),e._setCategories()};var r=a(224),i=o(a(528)),n=o(a(993))},993:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=a(240),n=a(224),l=o(a(481)),s=o(a(372)),c=function(e){var t,a,o,r,i,s=e.config.axesConf,c=e.config.axisMapById,h=c&&Array.from(c.keys())||[],u=!0,p=e.getFromEnv("chart").getChildren("canvas")[0],g=p.getChildren("axisRefVisualCartesian")[0],f=function(){return g.asyncDraw()};(0,n.componentFactory)(e,l["default"],"yAxis",s.length,s),t=(e.getChildren("yAxis")||[]).slice(0),a=e.config.axisMapById=new Map,("l"===e.config.side?t.reverse():t).forEach((function(t){if(!t.getState("removed")&&0!==t.config.showaxis){var n,l,s=t.getId();(i={}).axis=t,r=c&&c.get(s),i.checkbox=r&&r.checkbox,a.set(s,i),0===t.config.showaxis?t.hide():t.show(),p.attachAxis(t,!0),u&&(e.config.besideCanvas=s),u=!1,d||(o=t),t.setLinkedItem("canvas",p),g.setLinkedItem(t.getId(),t),g.addExtEventListener("visiblerangeset",f,t),d++,n=s,-1!==(l=h.indexOf(n))&&h.splice(l,1)}})),o&&p.setPrimaryAxis("yAxis",o),function(e,t){var a,o,r;for(r=e.length-1;r>-1;r--)a=e[r],(o=t.get(a)).checkbox&&o.checkbox.remove(),o.axis&&o.axis.remove(),t["delete"](a)}(h,c)},d=0,h=function(e){function t(){var t;return(t=e.call(this)||this).registerFactory("axis",c),t}(0,r["default"])(t,e),t.resetAxisCount=function(){d=0};var a=t.prototype;return a.configureAttributes=function(e){void 0===e&&(e={});var t=this.config;t.axesConf=e.axesConf||[],t.checkboxesConf=e.checkboxesConf||[],t.side=e.side},a.placeAxis=function(e){var t,a=e,o=this.config.side,r=this.getAxesDetails(),i=this.getFromEnv("chartConfig").axesPadding,n=0,l=0,s={right:0,left:0};return r.forEach((function(e){var r=e.value||(e.value={}),c=e.axis;c.getState("removed")||0===c.config.showaxis||(t=c.placeAxis(.7*a),"r"===o?(a-=r.width=t.right,s.right+=t.right,n+=i):(a-=r.width=t.left,s.left+=t.left,l+=i))})),{dimension:s,rightPadding:n,leftPadding:l}},a.setAxisDimention=function(){var e=this.config,t=this.getAxesDetails(),a=this.getFromEnv("chartConfig").axesPadding,o=this.getFromEnv("chart").getChildren("canvas")[0].config,r=o.canvasBorderWidth,i=o.canvasPaddingTop,n=o.canvasPaddingBottom,l=o.canvasLeft,s=o.canvasTop,c=o.canvasHeight,d=l+o.canvasWidth,h="r"===e.side,u="r"===e.side?l-r:d+r,p=0;t.forEach((function(e){var t=e.value||(e.value={}),o=e.axis;0===o.config.showaxis||o.getState("removed")||(t.x=h?d+r+p+a:l-r-p-a,t.y=s+i,t.height=c-i-n,t.opposite=u,p+=t.width+a,o.setAxisDimention({x:t.x,y:t.y,opposite:t.opposite,axisLength:t.height}))}))},a.drawHotElements=function(){var e,t,a=this,o=a.config,r="r"===o.side,i=a.getFromEnv("chartConfig").allowAxisShift,l=a.getFromEnv("chart"),s=o.axisMapById,c=a.getGraphicalElement("axisHotElement")||[],d=-1,h={cursor:"col-resize",stroke:n.TRACKER_FILL,fill:n.TRACKER_FILL,visibility:!0};for(i&&s.forEach((function(e,t){var o,i=e.value;h.x=i.x+(r?0:-i.width),h.y=i.y,h.width=i.width,h.height=i.height,(o=c[++d])||(o=a.addGraphicalElement("axisHotElement",a.getFromEnv("paper").rect(l.getChildContainer("trackerGroup")),!0)).on("fc-click",a._resuffelAxis),o.attr(h).data("axisDetails",{axisSelectorUI:a,canvas:l.getChildren("canvas")[0],axisId:t})})),e=d+1,t=c.length;e<t;e++)a.removeGraphicalElement(c[e])},a.drawCheckBoxes=function(){var e=this,t=e.config,a=e.getFromEnv("chartConfig"),o="r"===t.side,r=t.axisMapById;a.allowSelection?r.forEach((function(t,r){var i=t.value,n=t.checkbox,l=t.axis.config,c=o?t.axis.getAxisConfig("axisNamePadding"):-i.width;n||(n=t.checkbox=new s["default"],e.attachChild(n,"checkbox",!0),n.configure({isChecked:!0,text:"",stroke:a.checkBoxColor,symbolStroke:a.checkBoxColor,strokeWidth:1,symbolStrokeWidth:1,containerInfo:{id:"buttonGroup",label:"group",isParent:!0}}),n.addEventListener("fc-click",(function(){this.toggle(),e._dolegendInteraction.call(this,r,this.getFromEnv("chart")),l.checkBoxChecked=!l.checkBoxChecked}))),n.setDimension({x:i.x+c,y:i.y+i.height+4})})):r.forEach((function(e,t){e.checkbox&&e.checkbox.remove(),delete e.checkbox}))},a._createLayers=function(){var e=this.getFromEnv("chart").getChildContainer("selectorGroup");this.createContainer("axisBottomGroup",{name:"axis-bottom-group"},e),this.createContainer("axisTopGroup",{name:"axis-top-group"},e),this.createContainer("buttonGroup",{name:"buttons"},e)},a.createContainer=function(e,t,a){return this.addChildContainer(e,this.getFromEnv("animationManager").setAnimation({container:a,attr:t,el:this.getChildContainer(e)||"group",component:this,label:"group"}))},a.draw=function(){this._createLayers(),this.drawHotElements(),this.drawCheckBoxes()},a._resuffelAxis=function(){var e,t,a,o,r,i,n=this.data("axisDetails"),l=n.axisSelectorUI,s=l.config,c=n.canvas,d=n.axisId,h=l.getAxesDetails();s.besideCanvas!==d&&(h=l.config.axisMapById=(e=s.besideCanvas,t=d,o=[e,(a=h).get(e)],r=[t,a.get(t)],i=Array.from(a.entries()).map((function(a){var i=a[0],n=a[1];return i===e?r:i===t?o:[i,n]})),new Map(i))),s.besideCanvas=d,c.setPrimaryAxis("yAxis",h.get(d).axis),l.setAxisDimention(),l.asyncDraw(),c.getChildren("axisRefVisualCartesian")[0].asyncDraw()},a._dolegendInteraction=function(e,t){var a,o,r=[];for(a in t.iterateComponents((function(e){"dataset"===e.getType()&&r.push(e)})),r)r.hasOwnProperty(a)&&(o=r[a]).getFromEnv("yAxis").getId()===e&&(!o.getState("visible")&&this.config.checked?(o.config.legendInteractivity=!0,o.show()):o.getState("visible")&&!this.config.checked&&(o.config.legendInteractivity=!0,o.hide()))},a.manipulateCheckBox=function(e){var t,a,o,r=e.data,i=r.dataset,n=i.getFromEnv("yAxis").getId(),l=i.getLinkedParent().getChildren().dataset,s=!0;if(o=this.getAxesDetails().get(n))if("hide"===r.state){for(t=0,a=l.length;t<a;t++)l[t].getState("visible")&&(s=!1);s&&o.checkbox&&o.checkbox.uncheck()}else o.checkbox&&o.checkbox.check()},a.getAxesDetails=function(){return this.config.axisMapById},a.getType=function(){return"customAxisUI"},a.getName=function(){return"multiAxisSelectorUI"},a.getAxes=function(){return Array.from(this.config.axisMapById.values()).map((function(e){return e.axis}))},t}(i.ComponentInterface);t["default"]=h},994:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){var t,a,o,n,l,s,c=e.getChildren("canvas")[0],d=e.getChildren("yAxisSelectorUI"),h=e.getFromEnv("dataSource").axis,u=[],p=[];for(a=e.getChildren("xAxis"),l=0;l<(a&&a.length);l++)a[l].getState("removed")||u.push(a[l]);for(d.forEach((function(e){for(a=e.getChildren("yAxis"),l=0;l<(a&&a.length);l++)a[l].getState("removed")||p.push(a[l])})),(0,i.componentFactory)(c,r["default"],"vCanvas",u.length*p.length),t=c.getChildren("vCanvas"),n=0,l=0;n<(u&&u.length);n++)for(s=0;s<(p&&p.length);s++,l++)(o=t[l]).configure(),o.xAxis(u[n]).yAxis(p[s]).canvas(c),o.addToEnv("axisData",h[l]),o.addToEnv("vCanvas",t[l])};var r=o(a(534)),i=a(224)},995:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=function(e){for(var t,a,o,n,l=e.getChildren(),s=l.yAxisSelectorUI,c=l.canvas[0],d=(a+"").length,h=c.getChildren("vCanvas"),u=function(e){s.forEach((function(t){t.manipulateCheckBox(e)}))},p=function(e){e.addEventListener("datasetVisibilityChanged",u)},g=0,f=h.length;g<f;g++)(n=h[g]).getState("removed")||(t=n.getFromEnv("axisData").dataset)&&(a=t.length,o=Array(a).fill(n.getFromEnv("yAxis").config.axisIndex).map((function(e,t){return e+(t+1)*(1/Math.pow(10,d))})),(0,r.datasetFactory)(n,i["default"],"dataset",a,t,o),(l=n.getChildren("dataset")).forEach(p))};var r=a(224),i=o(a(996))},996:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(555)),n=a(224),l=a(232),s=o(a(997));(0,l.addDep)({name:"multiAxislineAnimation",type:"animationRule",extension:s["default"]});var c=function(e){function t(){return e.apply(this,arguments)||this}(0,r["default"])(t,e);var a=t.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"multiaxisline"},a.configure=function(t){if(!t)return!1;this.trimData(t),this.config.JSONData=t,e.prototype.configure.call(this,t)},a.parseAttributes=function(){var t,a,o=this.config.JSONData,r=this.config,i=this.getFromEnv("chart-attrib"),l=this.getFromEnv("axisData");e.prototype.parseAttributes.call(this),r.linethickness=(0,n.pluckNumber)(o.linethickness,l.linethickness,i.linethickness,2),r.lineDashLen=(0,n.pluckNumber)(o.linedashlen,l.linedashlen,i.linedashlen,5),r.lineDashGap=(0,n.pluckNumber)(o.linedashgap,l.linedashgap,i.linedashgap,4),r.alpha=(0,n.pluckNumber)(o.alpha,l.linealpha,i.linealpha,n.HUNDREDSTRING),r.linecolor=(0,n.pluck)(o.color,l.linecolor,l.color,i.linecolor,r.plotColor),r.legendSymbolColor="line"===this.getName()?r.lineColor:r.plotFillColor,a=(0,n.pluckNumber)(o.dashed,l.linedashed,i.linedashed),t=(0,n.getDashStyle)(r.lineDashLen,r.lineDashGap),r.anchorbordercolor=(0,n.pluck)(o.anchorbordercolor,o.color,l.color,i.anchorbordercolor,r.lineColor,r.plotColor),r.lineDashStyle=a?t:"none"},t}(i["default"]);t["default"]=c},997:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r={"*.dataset.multiaxisline":o(a(558))["default"]["*.dataset.line"]};t["default"]=r},998:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(999))["default"];t["default"]=r},999:function(e,t,a){"use strict";var o=a(219);t.__esModule=!0,t["default"]=void 0;var r=o(a(238)),i=o(a(565)),n=a(673),l=o(a(1e3)),s=function(e){function t(){var t;return(t=e.call(this)||this).defaultPlotShadow=1,t}(0,r["default"])(t,e),t.getName=function(){return"MSStepLine"};var a=t.prototype;return a.getName=function(){return"MSStepLine"},a.__setDefaultConfig=function(){e.prototype.__setDefaultConfig.call(this);var t=this.config;t.defaultDatasetType="msstepline",t.drawverticaljoins=1,t.useforwardsteps=1,t.zeroplanethickness=1,t.zeroplanealpha=40,t.showzeroplaneontop=0,t.enablemousetracking=!0,t.defaultcrosslinethickness=1,n._setDefaultConfig.call(this)},a.getDSGroupdef=function(){},a.getDSdef=function(){return l["default"]},t}(i["default"]);t["default"]=s}}])}));
//# sourceMappingURL=http://localhost:3052/3.18.0/map/eval/fusioncharts.powercharts.js.map

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

!function(t){"object"==typeof module&&"undefined"!=typeof module.exports?module.exports=t:t()}((function(){(window.webpackJsonpFusionCharts=window.webpackJsonpFusionCharts||[]).push([[5],{1084:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1085));e.Bulb=i["default"];var r=o(a(1093));e.Cylinder=r["default"];var n=o(a(1104));e.AngularGauge=n["default"];var l=o(a(1116));e.Hled=l["default"];var s=o(a(1124));e.Vled=s["default"];var c=o(a(1125));e.Hlineargauge=c["default"];var h=o(a(1128));e.Thermometer=h["default"];var u=o(a(1132));e.SparkLine=u["default"];var d=o(a(1140));e.SparkColumn=d["default"];var g=o(a(1144));e.SparkWinLoss=g["default"];var p=o(a(1145));e.RealTimeArea=p["default"];var f=o(a(1152));e.RealTimeColumn=f["default"];var m=o(a(1153));e.RealTimeLine=m["default"];var v=o(a(1156));e.RealTimeStackedArea=v["default"];var b=o(a(1158));e.RealTimeStackedColumn=b["default"];var k=o(a(1160));e.RealTimeLineDY=k["default"];var C=o(a(1162));e.HorizontalBullet=C["default"];var x=o(a(1164));e.VerticalBullet=x["default"];var w=o(a(1166));e.Funnel=w["default"];var T=o(a(1174));e.Pyramid=T["default"];var y=o(a(1178));e.RadialBar=y["default"];var A=o(a(1089)),S={name:"widgets",type:"package",requiresFusionCharts:!0,extension:function(t){t.addDep(A["default"]),t.addDep(n["default"]),t.addDep(i["default"]),t.addDep(r["default"]),t.addDep(l["default"]),t.addDep(s["default"]),t.addDep(c["default"]),t.addDep(h["default"]),t.addDep(u["default"]),t.addDep(d["default"]),t.addDep(g["default"]),t.addDep(p["default"]),t.addDep(f["default"]),t.addDep(m["default"]),t.addDep(v["default"]),t.addDep(b["default"]),t.addDep(k["default"]),t.addDep(C["default"]),t.addDep(x["default"]),t.addDep(w["default"]),t.addDep(T["default"]),t.addDep(y["default"])}};e["default"]=S},1085:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1086))["default"];e["default"]=i},1086:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1087)),n=o(a(1090)),l=a(224),s=o(a(1054)),c=o(a(1092)),h=function(t){function e(){var e;return(e=t.call(this)||this).isRealTime=!0,e._drawCanvas=function(){},e.registerFactory("dataset",c["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Bulb"};var a=e.prototype;return a.getName=function(){return"Bulb"},a._clearChart=function(){},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.getFromEnv("dataSource").colorrange;(0,l.componentFactory)(this,s["default"],"colorRange",1,[{colorRange:a,numberFormatter:this.getFromEnv("number-formatter")}]),this.addToEnv("colorRange",this.getChildren("colorRange")[0])},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.showRTvalue=!1,e.canvasPadding=!1,e.defaultSeriesType="bulb",e.defaultPlotShadow=1,e.drawAnnotations=!0,e.charttopmargin=10,e.chartrightmargin=10,e.chartbottommargin=10,e.chartleftmargin=10,e.realtimeEnabled=!0,e.isRealTime=!0,e.friendlyName="Bulb Gauge",e.defaultDatasetType="bulb",e.placevaluesinside=0,e.hasgaugeoriginx=void 0,e.gaugeoriginx=void 0,e.hasgaugeoriginy=void 0,e.gaugeoriginy=void 0,e.hasgaugeradius=void 0,e.gaugeradius=void 0,e.valuepadding=2,e.showgaugeborder=0,e.showhovereffect=void 0,e.autoscale=1,e.skipCanvasDrawing=!0},a._spaceManager=function(){var t,a,o,i=this.config,r=this.getChildren("dataset")[0],n=r.config,s=this.config.is3D,c=this.getFromEnv("dataSource").chart,h=(0,l.pluckNumber)(c.showborder,s?0:1),u=i.minChartWidth,d=i.minChartHeight,g=i.borderWidth=h?(0,l.pluckNumber)(c.borderthickness,1):0;i.autoscale?n.scaleFactor=e._getScaleFactor(n.origW,n.origH,i.width,i.height):n.scaleFactor=1,i.canvasWidth-2*g<u&&(o=(i.canvasWidth-u)/2),i.canvasHeight-2*g<d&&(a=(i.canvasHeight-d)/2),this._allocateSpace({top:a||g,bottom:a||g,left:o||g,right:o||g}),this._allocateSpace(this._manageActionBarSpace&&this._manageActionBarSpace(.225*i.availableHeight)||{}),t=.7*i.canvasHeight,this._manageChartMenuBar(t),r._manageSpace&&this._allocateSpace(r._manageSpace(t))},a.allocatePosition=function(){var t,e=this.config,a=this.getDatasets()[0].config,o=e.canvasHeight,i=e.canvasWidth,r=e.canvasTop,n=e.canvasLeft,l=e.gaugeoriginx,s=e.gaugeoriginy,c=e.gaugeradius,h=e.hasgaugeoriginx,u=e.hasgaugeoriginy,d=e.hasgaugeradius;l=void 0!==h?l*a.scaleFactor:n+i/2,s=void 0!==u?s*a.scaleFactor:r+o/2,t=void 0!==d?c*a.scaleFactor:Math.min(i/2,o/2),e.gaugeStartX=l-t,e.gaugeEndX=l+t,e.gaugeStartY=s-t,e.gaugeEndY=s+t,e.gaugeCenterX=l,e.gaugeCenterY=s,e.gaugeRadius=t},a._getData=function(){var t,e,a=this.getChildren("dataset");if(a&&(e=a[0].components.data)&&e[0])return t=e[0].config,(0,l.pluckNumber)(t.setValue,t.itemValue)},a._postSpaceManagement=function(){this.allocateDimensionOfChartMenuBar()},a.getDSdef=function(){return n["default"]},e._getScaleFactor=function(t,e,a,o){var i=e,r=t;return i=(0,l.pluckNumber)(i,o),r=(0,l.pluckNumber)(r,a),i&&r?r/a==i/o?a/r:Math.min(a/r,o/i):1},e}(r["default"]);e["default"]=h},1087:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(1088),n=a(236),l=o(a(465)),s=a(224),c=o(a(537)),h=o(a(222)),u=o(a(1089)),d=(0,s.extend2)({},s.defaultGaugePaletteOptions),g=Math.max;h["default"].addDep(u["default"]);var p=function(t){function e(){var e;return(e=t.call(this)||this).defaultPaletteOptions=d,e.multiValueGauge=!1,e.drawAnnotations=!0,e.includeColorRangeInLimits=!1,e.isWidget=!0,e._feedAxesRawData=e._feedAxesRawData||s.stubFN,e._setCategories=e._setCategories||s.stubFN,e.eiMethods=r.eiMethods,e.registerFactory("dataset",c["default"],["vCanvas"]),e.registerFactory("axis",s.stubFN,["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"GaugeBase"};var a=e.prototype;return a.getName=function(){return"GaugeBase"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.valuefontbold=1,e.useScaleRecursively=!0,e.formatnumberscale=0},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.drawTrendRegion=0},a.realTimeUpdate=function(t){var e,a,o,i=this.getChildren().dataset,r=t.dataset,n=t.categories&&t.categories.category||[],l=this.config.realTimeConfig=this.config.realTimeConfig||(this.config.realTimeConfig={});if(this.fireChartInstanceEvent("updateDataReceived",t),this.fireEvent("realtimeDataUpdate",t),this.config.cachedArrivedJSON||(this.config.cachedArrivedJSON={}),this.config.cachedArrivedJSON=t,i){for(o=0,a=(e=r[0].data).length;o<a;o++)e[o].label=n[o]&&n[o].label;i[0].maxminFlag&&(l.maxminFlag=i[0].maxminFlag)}},a._setData=function(t,e){var a=s.BLANKSTRING;(t&&t.toString||t===s.BLANKSTRING||0===t)&&(a="value="+t.toString()),(e&&e.toString||e===s.BLANKSTRING)&&(a=a+"&label="+e.toString()),a&&this.feedData(a)},a._getData=function(){var t,e,a,o,i,r=this.getChildren(),n=this.getDatasets(),l=r.xAxis&&r.xAxis[0]||r.scale,s=[],c=0;if(n){for(t=n.length,e=0;e<t;e++)c=g(c,n[e].components.data.length);for(e=0;e<c;e++)for((i=s[e]=[])[0]=l.getLabel(e).label,a=1;a<=t;a++)o=n[a-1].components.data[e],i[a]=o&&o.config.setValue;return s}},a._checkInvalidSpecificData=function(){},a.realTimeDraw=function(t){if(void 0===t&&(t={}),this.config.cachedArrivedJSON){var e,a,o,i,r,l,c=this,h=c.config,u=h.prevData,d=(l=[],c.iterateComponents((function(t){"dataset"===t.getType()&&l.push(t)})),l),g=h.cachedArrivedJSON,p=h.realTimeConfig||(h.realTimeConfig={}),f=p.showRTValue,m=[];if(c.__rtDrawStartAt=new Date,c.getFromEnv("animationManager").setAnimationState("realTimeUpdate"),d&&d.length){for(i=g.dataset[0].data,r=(m=Object.keys(d[0].config.dataById||d[0].config.idMap||{})).length,o=0;o<r;o++)g.hasOwnProperty(m[o])&&i.push({value:Number(g[m[o]]),id:m[o]});h.prevData=function(t){void 0===t&&(t=[]);var e,a,o=t.length,i=[];for(e=0;e<o;++e)a=t[e],i.push(a.value);return[i]}(i),(e=g.dataset[0]).data[0]&&(e.data[0].label=g.categories&&g.categories.category&&g.categories.category[0]&&g.categories.category[0].label),d[0].updateData(e),d[0].maxminFlag&&(p.maxminFlag=d[0].maxminFlag),d[0].asyncDraw(),h.cachedArrivedJSON=s.UNDEF,c.rtManageSpace&&c._RTmanageSpace(),c.prepareAttributes&&c.prepareAttributes(),c._preDraw(),f&&c._drawRealTimeValue&&c.asyncRealTimeValueDraw()}h._eventArgs=t,t.prevData=u,c.__realtimeUpdateComplete||(c.__realtimeUpdateComplete=function(){a=new Date-c.__rtDrawStartAt,p.clear||(h._eventArgs.latency=a,h._eventArgs.updateObject=p.legacyUpdateObj),c.getChildren("dataStreamer")[0].addToEnv("realtimeDrawingLatency",a),c.fireChartInstanceEvent("realTimeUpdateComplete",h._eventArgs)}),c.addJob("realtimeupdatecomplete",c.__realtimeUpdateComplete,n.priorityList.postRender)}},a._setRTmenu=function(t,e){r._setRTmenu.call(this,t,e)},a._createLayers=function(){var e,a;t.prototype._createLayers.call(this),e=this.getChildContainer("belowPlotGroup"),a=this.getChildContainer("axisBottomGroup"),e.insertBefore(a)},a._realTimeConfigure=function(){r._realTimeConfigure.call(this)},a._stopUpdate=function(t){r._stopUpdate.call(this,t)},a._restartUpdate=function(){r._restartUpdate.call(this)},a._isUpdateActive=function(){return r._isUpdateActive.call(this)},a.feedData=function(t){r.feedData.call(this,t)},a._linearDataParser=function(t){return r._linearDataParser.call(this,t)},a._clearChart=function(t){r._clearChart.call(this,t)},e}(l["default"]);e["default"]=p},1088:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e._setRTmenu=e._clearChart=e._linearDataParser=e.feedData=e.realTimeDraw=e._RTmanageSpace=e.realTimeUpdate=e._isUpdateActive=e._restartUpdate=e._stopUpdate=e.eiMethods=e._realTimeConfigure=void 0;var i=a(224),r=a(236),n=o(a(484)),l=Math.max,s=i.regex.dropHash,c=0,h=0,u=function(t){return Object.assign({},t)},d=function(t){return t.spaceTaken.left},g=function(t){return t.spaceTaken.right},p=function(t){var e=[];return t.iterateComponents((function(t){"dataset"===t.getType()&&e.push(t)})),e},f={feedData:function(){var t,e,a=this,o=a.apiInstance,i=arguments[1];if(!i)return o.feedData.apply(o,arguments);t=arguments[0],o.addJob("feedDataId"+h+++c++,(function(){e=o.feedData(t),"function"==typeof i&&i(e)}),r.priorityList.postRender)},setData:function(){var t=this.apiInstance,e=arguments[0],a=arguments[1],o=arguments[2];t.addJob("setDataId"+h++,(function(){t._setData(e,a,o)}),r.priorityList.postRender)},stopUpdate:function(){var t=this.apiInstance;t.addJob("stopUpdateId"+h++,(function(){t._stopUpdate()}),r.priorityList.postRender)},restartUpdate:function(){this.apiInstance._restartUpdate.apply(this.apiInstance,arguments)},isUpdateActive:function(){return this.apiInstance._isUpdateActive.apply(this.apiInstance,arguments)},clearChart:function(){var t=this.apiInstance;t.addJob("clearChartId"+h++,(function(){t._clearChart()}),r.priorityList.postRender)},getData:function(){return this.apiInstance._getData.apply(this.apiInstance,arguments)},getDataForId:function(){return this.apiInstance._getDataForId.apply(this.apiInstance,arguments)},setDataForId:function(){return this.apiInstance._setDataForId.apply(this.apiInstance,arguments)},getDataJSON:function(){return this.apiInstance._getDataJSON.apply(this.apiInstance,arguments)}};e._setRTmenu=function(t,e){var a=this,o=a.getFromEnv("hamburger"),i=!0,r=[];t&&r.push({name:"Clear Chart",handler:function(){a._clearChart()},action:"click"}),e&&r.push({name:"Show Log",handler:function(){a.getChildren("messageLogger")[0].show()},action:"click"}),t&&r.push({id:"rt",name:"Stop Update",handler:function(){!function t(){i?(a._stopUpdate(),o.getChild("listContainer").getChild("rt").configure({id:"rt",name:"Restart Update",handler:function(){t()},action:"click"}),o.getChild("listContainer").getChild("rt").asyncDraw(),i=!1):(a._restartUpdate(),o.getChild("listContainer").getChild("rt").configure({id:"rt",name:"Stop Update",handler:function(){t()},action:"click"}),o.getChild("listContainer").getChild("rt").asyncDraw(),i=!0)}()},action:"click"}),r.length&&o.appendInMenu(r)},e._clearChart=function(t){var e,a,o=this.getChildren(),i=o.xAxis&&o.xAxis[0],r=p(this),n=i.getTicksLen(),l=i.getVisibleConfig(),s=l.maxValue,c=l.minValue,h=n>s?s-c:n,u=this.config.realTimeConfig||(this.config.realTimeConfig={}),d=u.showRTValue,g=r.length;if(u.clear=!0,r){for(i&&i.categoryDelete(0,h,!0),this.config._sumValuesUpdated=!1,a=0;a<g;a++)e=r[a],r[a].removeData(0,e.components.data.length),r[a].resetCatPos();this._setCategories()}d&&this._drawRealTimeValue&&this.asyncRealTimeValueDraw(),this.fireChartInstanceEvent("ChartCleared",{source:t},[this.getId(),t])},e._linearDataParser=function(t){var e,a,o,r,n,s,c,h,u,d,g,f,m,v,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O=t,P=p(this),G=P&&P.length,B=this.config.realTimeConfig.legacyUpdateObj={},H=B.values=[],W=B.id=[],z=B.target=[],j=B.valueVisibility=[],U=B.toolTexts=[],X=B.toolTextsTarget=[],K=B.colors=[],Y=B.links=[],J=B.valueFontColors=[],q=B.valueBgColors=[],Z=B.valueBorderColors=[],$=0,Q={categories:{category:[]},dataset:[]},tt=Q.categories.category,et=Q.dataset,at=O;for(O=O&&O.toString&&O.toString()||"",this.rtParserModify&&(at=at.replace(/([^\\])(\|)/g,"$1,"),O=O.replace(/\|/g,",")),v=0,b=(e=O.split("&")).length;v<b;v+=1)if(o=(a=e[v].split("="))[1],(a=a[0])!==i.BLANKSTRING&&void 0!==a&&void 0!==o&&o!==i.BLANKSTRING)switch(a.toLowerCase()){case"label":B.labels=k=o.split(",");break;case"vline":B.vlines=C=o.split(",");break;case"vlinelabel":B.vlineLabels=u=o.split(",");break;case"vlinecolor":B.vlineColors=d=o.split(",");break;case"vlinethickness":B.vlineThickness=g=o.split(",");break;case"vlinedashed":B.vlineDashed=f=o.split(",");break;case"value":x=o.split("|");break;case"valuefontcolor":D=o.split("|");break;case"valuebgcolor":M=o.split("|");break;case"valuebordercolor":R=o.split("|");break;case"target":T=o.split("|");break;case"showlabel":B.showLabels=m=o.split(",");break;case"showvalue":r=o.split("|");break;case"tooltext":n=(n=(n=(n=at.match(/tooltext=(.*?\\&)*.*?[^\\]&/i))?n[0].substr(9,n[0].length-10):at.match(/(tooltext=)(.*)/i)[2])&&n.replace(/([^\\])(\|)/g,"$1_FC@@**")).split("_FC@@**");break;case"targettooltext":s=o.split("|");break;case"link":h=o.split("|");break;case"color":c=o.split("|");break;case"datastamp":B.dataStamp=y=o;break;case"stopupdate":B.pause=A="1"===o;break;case"clear":B.clear=S="1"===o;break;case"id":w=o.split("|");break;default:B[a]=Q[a]=o}for(L=x&&x.length,v=0;v<L;v++)H[v]=x[v].split(","),z[v]=T&&T[v]&&T[v].split(","),j[v]=r&&r[v]&&r[v].split(","),X[v]=s&&s[v]&&s[v].split(","),K[v]=c&&c[v]&&c[v].split(","),Y[v]=h&&h[v]&&h[v].split(","),J[v]=D&&D[v]&&D[v].split(","),q[v]=M&&M[v]&&M[v].split(","),Z[v]=R&&R[v]&&R[v].split(","),W[v]=w?w[v].split(","):null,n&&(V=n[v])&&(V=V.replace(/([^\\])(\,)/g,"$1_FC@@**"),U[v]=V.split("_FC@@**")),$=l($,H[v].length);for(I=k&&k.length,F=l(I||0,$||0),v=0;v<F;v++)tt.push({label:k&&k[v],color:d&&d[v],showlabel:m&&m[v]});for(C&&tt.push({label:u&&u[0],vline:C&&C[0],color:d&&d[0],thickness:g&&g[0],dashed:f&&f[0],showlabel:m&&m[0]}),v=0;v<G;v++){for(N=(_={}).data=[],E=0;E<F;E++)N.push({value:H[v]&&H[v][E],target:z[v]&&z[v][E],showvalue:j[v]&&j[v][E],tooltext:U[v]&&U[v][E]&&decodeURIComponent(U[v][E].replace(/\\/g,"")),tooltexttarget:X[v]&&X[v][E],color:K[v]&&K[v][E],link:Y[v]&&Y[v][E]&&decodeURIComponent(Y[v][E]),valuefontcolor:J[v]&&J[v][E],valuebgcolor:q[v]&&q[v][E],valuebordercolor:Z[v]&&Z[v][E],id:W[v]&&W[v][E]});et.push(_)}return A&&this._stopUpdate(),S&&this._clearChart(),y&&(this.config.dataStamp=y),Q},e.feedData=function(t){var e=this.getFromEnv("dataStreamer");e.responseTextHandler(t),e.refreshVisualHandler({source:"feedData",data:t})},e.realTimeDraw=function(t){void 0===t&&(t={});var e,a,o,i,n=this,l=n.config,s=n.getChildren(),c=s.canvas&&s.canvas[0],h=s.xAxis&&s.xAxis[0],u=s.yAxis&&s.yAxis[0],d=s.yAxis&&s.yAxis[1],g=p(n),f=g.length,m=l.cachedArrivedJSON,v=m&&m.dataset,b=m&&m.categories&&m.categories.category||[],k=h&&h.getTicksLen(),C=l.realTimeConfig=l.realTimeConfig||(l.realTimeConfig={}),x=C.prevData,w=0,T=C.showRTValue,y=C.clear,A=function(t){void 0===t&&(t=[]);var e,a,o=t.length,i=[];for(e=0;e<o;++e)a=t[e],i.push(a.value);return i};if(l._eventArgs=t,t.prevData=x,C.prevData=[],n.getFromEnv("animationManager").setAnimationState("realTimeUpdate"),n.__rtDrawStartAt=new Date,n.__realtimeUpdateComplete||(n.__realtimeUpdateComplete=function(){i=new Date-n.__rtDrawStartAt,y||(l._eventArgs.latency=i,l._eventArgs.updateObject=C.legacyUpdateObj),n.getChildren("dataStreamer")[0].addToEnv("realtimeDrawingLatency",i),n.fireChartInstanceEvent("realTimeUpdateComplete",l._eventArgs)}),n.addJob("realtimeupdatecomplete",n.__realtimeUpdateComplete,r.priorityList.postRender),g){if(c.asyncDraw(),m){if(h){for(h.asyncDraw(),h.categoryInsert(k,b,!0),o=0,e=b.length;o<e;o++)b[o].vline||(w+=1);h.categoryDelete(0,w,!0),h.categoryTranslate(w)}if(l._sumValuesUpdated=!1,y){for(o=0;o<f;o++)g[o]._realTimeConfigure(!0);C.clear=!1}for(o=0;o<f;o++)a=v[o],g[o].addData(a),g[o].removeData(0,a.data.length),g[o].resetCatPos(),g[o].setMaxMin(),g[o].getLinkedParent().childChanged(),C.prevData.push(A(a.data));l.cachedArrivedJSON=void 0}n.rtManageSpace&&n._RTmanageSpace(),l.drawYAxis&&u&&u.asyncDraw(),l.drawSyAxis&&d&&d.asyncDraw(),n._preDraw(),T&&n._drawRealTimeValue&&n.asyncRealTimeValueDraw()}},e._RTmanageSpace=function(){var t,e,a,o,i,r,s,c,h,p,f,m=this.config,v=this.getChildren(),b=v.xAxis[0],k=v.yAxis[0],C=v.yAxis[1],x=v.canvas&&v.canvas[0],w=x.config,T=w.canvasBorderWidth,y=w.canvasPaddingTop,A=w.canvasPaddingBottom,S=w.canvasPadding||0,F=w.canvasPaddingLeft,N=w.canvasPaddingRight,E=m.xAxisSpaceAllocation,L=m.yAxisSpaceAllocation||[],D=L.map(u),M=k&&JSON.stringify(k.getAxisDimension()),R=k&&JSON.stringify(k.getAxisDimension()),_=m.shift||0;t=(e=m.xAxisSpaceAllocation=b.placeAxis(m.availableHeight+(b.config.isOpposit?E.top:E.bottom))).bottom-E.bottom,0===(p=e.top-E.top)&&0===t||(this._allocateSpace({bottom:t,top:p}),a=m.availableWidth,L[0].spaceTaken=k.placeAxis(a+D[0].spaceTaken.left),C&&(L[1].spaceTaken=C.placeAxis(a+D[1].spaceTaken.right)),this._allocateSpace({left:(0,n["default"])(L,d)-(0,n["default"])(D,d),right:(0,n["default"])(L,g)-(0,n["default"])(D,g)}),a=m.availableWidth,o=m.canvasLeft-T,r=m.canvasRight+T,C&&(i=r,s=o,0===m.primaryAxisOnleft&&(c=o,o=i,i=c,c=r,r=s,s=c),C.setAxisDimention({x:i,y:m.canvasTop+y,opposite:s,axisLength:m.canvasHeight-y-A})),b&&b.setAxisDimention({x:m.canvasLeft+l(F,S),y:b.config.isOpposit?m.canvasTop-T:m.canvasBottom+_+T,opposite:b.config.isOpposit?m.canvasBottom+_+T:m.canvasTop-T,axisLength:m.canvasWidth-l(F,S)-l(N,S)}),k&&k.setAxisDimention({x:k.config.isOpposit?r:o,y:m.canvasTop+y,opposite:k.config.isOpposit?o:r,axisLength:m.canvasHeight-y-A})),this.canvasPadding&&x.setCanvasPadding(),x.setDimension({top:m.canvasTop,left:m.canvasLeft,width:m.canvasWidth,height:m.canvasHeight}),T=w.canvasBorderWidth,y=w.canvasPaddingTop,A=w.canvasPaddingBottom,S=w.canvasPadding||0,F=w.canvasPaddingLeft,N=w.canvasPaddingRight,C&&C.setAxisDimention({x:m.canvasRight+T,y:m.canvasTop+y,opposite:s,axisLength:m.canvasHeight-y-A}),b&&b.setAxisDimention({x:m.canvasLeft+l(F,S),y:b.config.isOpposit?m.canvasTop-T:m.canvasBottom+_+T,opposite:b.config.isOpposit?m.canvasBottom+_+T:m.canvasTop-T,axisLength:m.canvasWidth-l(F,S)-l(N,S)}),k&&k.setAxisDimention({x:k.config.isOpposit?m.canvasRight+T:m.canvasLeft-T,y:m.canvasTop+y,opposite:k.config.isOpposit?m.canvasLeft-T:m.canvasRight+T,axisLength:m.canvasHeight-y-A}),h=k&&JSON.stringify(k.getAxisDimension()),f=k&&JSON.stringify(k.getAxisDimension()),m.drawYAxis=h!==M,m.drawSyAxis=f!==R},e.realTimeUpdate=function(t){var e,a,o=p(this),i=this.config.cachedArrivedJSON,r=i&&i.categories,n=t.dataset,l=t.categories&&t.categories.category||[];for(this.fireChartInstanceEvent("updateDataReceived",t),this.fireEvent("realtimeDataUpdate",t),!this.config.cachedArrivedJSON&&(i=this.config.cachedArrivedJSON={}),i.dataset=i.dataset||[],(r=i.categories||(i.categories={})).category=r.category||[],e=0;e<o.length;e++)(a=i.dataset[e]||(i.dataset[e]={})).data||(a.data=[]),a.data.push.apply(a.data,n[e].data);r.category.push.apply(r.category,l)},e.eiMethods=f,e._isUpdateActive=function(){return this.getChildren("dataStreamer")[0]._isUpdateActive()},e._restartUpdate=function(){this.getChildren("dataStreamer")[0]._restartUpdate()},e._stopUpdate=function(t){var e=this.config.realTimeConfig,a=this.config.timers&&this.config.timers.setTimeout.loadData;this.getChildren("dataStreamer")[0]._stopUpdate(),a&&clearTimeout(a),e.clearIntervalFlag=!1,this.fireChartInstanceEvent("dataRestored",{source:t})},e._realTimeConfigure=function(){var t,e,a,o=this.config,r=o.realTimeConfig||(o.realTimeConfig={}),n=this.getFromEnv("dataSource"),c=n.chart,h=(0,i.pluckNumber)(c.usemessagelog,0),u=(0,i.pluckNumber)(c.messagegoestolog,1),d=n.categories&&Array.isArray(n.categories)&&n.categories[0]&&n.categories[0].category&&n.categories[0].category.length||0;r.showRTValue=(0,i.pluckNumber)(c.showrealtimevalue,1),r.dataStreamURL=(0,i.parseUnsafeString)(c.datastreamurl,i.BLANKSTRING),r.dataStamp=c.datastamp,r.useMessageLog=h&&u,r.clearInterval=(0,i.pluckNumber)(c.clearchartinterval,0),r.realtimeValueSeparator=(0,i.pluck)(c.realtimevaluesep,i.COMMASPACE),r.refreshInterval=t=(0,i.pluckNumber)(c.refreshinterval,c.updateinterval,2),r.updateInterval=this.config.updateInterval=(0,i.pluckNumber)(c.updateinterval,t),r.realtimeValuePadding=(0,i.pluckNumber)(c.realtimevaluepadding),r.realtimeValueFont=(0,i.pluck)(c.realtimevaluefont,i.BLANKSTRING),r.realtimeValueFontBold=(0,i.pluck)(c.realtimevaluefontbold,0),r.realtimeValueFontColor=e=(0,i.pluck)(c.realtimevaluefontcolor,i.BLANKSTRING),r.realtimeValueFontSize=a=(0,i.pluckNumber)(c.realtimevaluefontsize,i.BLANKSTRING),r.realTimeValuePadding=(0,i.pluckNumber)(c.realtimevaluepadding,5),r.fontWeight=(0,i.pluckNumber)(c.realtimevaluefontbold,0)?"bold":"normal",r.numDisplaySets=(0,i.pluckNumber)(c.numdisplaysets,l(d,15)),r.refreshInstantly=(0,i.pluckNumber)(c.refreshinstantly,0),r.showRTmenuItem=(0,i.pluckNumber)(c.showrtmenuitem,0),r.sync=(0,i.pluckNumber)(c.sync,t>.6),e&&(r.realtimeValueFontColor=e.replace(s,i.HASHSTRING)),a&&(r.realtimeValueFontSize=a+"px"),t*=1e3}},1089:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(242)),r=o(a(238)),n=o(a(312)),l=a(240),s=a(224),c=function(t){var e,a=t.sender;"chartAPI"===a.getType()&&(e=a).registerFactory("dataStreamer",(function(){var t;h&&e.config.realtimeEnabled&&((0,s.componentFactory)(e,h,"dataStreamer",1),(t=e.getChildren("dataStreamer")[0]).configure(),e.addToEnv("dataStreamer",t))}))},h=function(t){function e(){var e,a;return(e=t.call(this)||this)._handlerFn=(a=(0,i["default"])(e),function(){var t=a.config;t&&(void 0===t.rtPreInit&&(t.rtPreInit=!1),t._rtPaused&&delete t._rtPaused,t.rtStateChanged||(t.rtStateChanged=!0,a.processRealtimeStateChange(arguments)))}),e._handlerStop=function(t){return function(){t._dispose()}}((0,i["default"])(e)),e}(0,r["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataStreamer"},a.getName=function(){return"dataStreamer"},e.resetTimeout=function(t,e,a){return clearTimeout(a),setTimeout(t,e)},a.configure=function(){var t,e,a,o,i=this,r=i.config,n=i.getLinkedParent(),l=n.getFromEnv("dataSource")&&n.getFromEnv("dataSource").chart;a=n.getFromEnv("chartInstance"),o=n.config.realTimeConfig,r.clearMs=1e3*o.clearInterval,r.updateMs=e=1e3*o.updateInterval,r.refreshMs=t=1e3*o.refreshInterval,i.addEvents(),t<e&&(r.refreshMs=e),r.dataStamp=l.datastamp,i.config.chartObj=a,a.jsVars&&(a.jsVars._rtLastUpdatedData=null),i.updateIntervalHandler(0,!0),i.refreshVisualHandler(null,null,!0),i.initiateResetVisual(!0),r._rtAjaxLatencyStart=null,r._rtAjaxLatency=null,i.addToEnv("realtimeDrawingLatency",0)},a._dispose=function(){this.updateIntervalHandler(0,!0),this.refreshVisualHandler(null,null,!0),this.initiateResetVisual(!0),t.prototype._dispose.call(this)},a.processRealtimeStateChange=function(){var t,e=this,a=e.config,o=e.config.chartObj,i=o.__state,r=e.getLinkedParent(),l=r.config,s=l.realtimeEnabled,c=l.realTimeConfig.dataStreamURL;i.dataSetDuringConstruction&&!a.rtStateChanged&&void 0===a.rtPreInit&&(o.dataReady()?(a.rtStateChanged=!0,a.rtPreInit=!0):a.rtPreInit=!1),a.rtStateChanged&&(a.rtStateChanged=!1,r&&(t=a._rtAjaxObj,s&&(void 0===a._rtPaused&&(a._rtPaused=!1),a._rtDataUrl=c,e.initiateResetVisual(),(t=a._rtAjaxObj||(a._rtAjaxObj=new n["default"])).onSuccess||(t.onSuccess=function(){e.getFromEnv("chartConfig").realTimeConfig.dataStreamURL&&(e.setState("ajaxRequested",!0),e.responseTextHandler(arguments[0]),a._rtAjaxLatencyStart&&(a._rtAjaxLatency=new Date-a._rtAjaxLatencyStart||0),e.refreshVisualHandler({data:a.responseText,source:"XmlHttpRequest",url:a.url,networkLatency:a._rtAjaxLatency},a._rtAjaxLatency+(a._firstUpdate?new Date-a._firstUpdate:0),!e.getFromEnv("chartConfig").realTimeConfig.dataStreamURL),a._firstUpdate=void 0,a._rtPaused||a._rtAjaxLatency>=a.updateMs&&(a._rtAjaxLatency=a.updateMs-1),e.updateIntervalHandler(a._rtAjaxLatency,a._rtPaused))}),t.onError||(t.onError=function(){var t=arguments[0],i=arguments[1],n=arguments[3];a._rtAjaxLatencyStart&&(a._rtAjaxLatency=new Date-a._rtAjaxLatencyStart),e.setState("ajaxRequested",!1),r.fireChartInstanceEvent("realTimeUpdateError",{source:"XmlHttpRequest",url:n,xmlHttpRequestObject:i.xmlhttp,error:t,httpStatus:i.xmlhttp&&i.xmlhttp.status?i.xmlhttp.status:-1,networkLatency:a._rtAjaxLatency}),e.updateIntervalHandler(0,!o.isActive())}),a._rtPaused||(e.updateIntervalHandler(0),a._firstUpdate=new Date))))},a.responseTextHandler=function(t){var e=this.config,a=this.getFromEnv("chart"),o=this.getFromEnv("chartConfig").realtimeEnabled,i=a.feedData,r=a._linearDataParser(t);e.responseText=t,this.getFromEnv("chartInstance").isActive()&&i&&o&&(e.dataStamp=r.dataStamp?r.dataStamp:null,a.realTimeUpdate(r))},a.initiateResetVisual=function(t){if(void 0===t&&(t=!1),t)clearTimeout(this.config._toClearChart);else{var a=this.config,o=this.getFromEnv("chart");t||a.clearMs&&(a._toClearChart=e.resetTimeout((function i(){o._clearChart&&o._clearChart(),a.clearMs?a._toClearChart=e.resetTimeout(i,a.clearMs,a._toClearChart):clearTimeout(a._toClearChart)}),a.clearMs,a._toClearChart))}},a.updateIntervalHandler=function(t,a){if(void 0===t&&(t=0),void 0===a&&(a=!1),a)clearTimeout(this.config&&this.config._toRealtimeUpdate);else{var o,i=this,r=i.config,n=r._rtAjaxObj,l=r.updateMs;if(i.requestData||(i.requestData=function(){var t=i.getFromEnv("chartConfig").realTimeConfig.dataStreamURL,e=r.dataStamp,a=r._rtAjaxObj,o=t;o+=(-1===t.indexOf("?")?"?num=":"&num=")+Math.random(),e&&(o+="&dataStamp="+e),r.url=o,a.open&&a.abort(),t&&a.get(o),r._rtAjaxLatencyStart=new Date}),l<=0)return r._toRealtimeUpdate=clearTimeout(r._toRealtimeUpdate),void(n&&n.abort());l<10&&(l=10),a||(o=l-t,r._toRealtimeUpdate=e.resetTimeout(i.requestData,o,r._toRealtimeUpdate))}},a.refreshVisualHandler=function(t,a,o){if(void 0===a&&(a=0),void 0===o&&(o=!1),o)return clearTimeout(this.config._toRealtimeDraw),this._clearCachedData(),void(this.config.isAlive=!1);var i,r=this,n=r.config,l=n.refreshMs,s=r.getFromEnv("chart"),c=r.getFromEnv("chartConfig").realtimeEnabled,h=r.getFromEnv("chartInstance").isActive(),u=(new Date).getTime(),d=s.feedData,g=a;r.getState("ajaxRequested")&&n.lastRTDrawAt||(n.lastRTDrawAt=u),r.config.sourceInfo=t,r._rtDraw||(r._rtDraw=function(){n.isAlive=!1,n.lastRTDrawAt=(new Date).getTime(),s.realTimeDraw(r.config.sourceInfo)}),h&&d&&c&&!o&&!n.isAlive&&(n.isAlive=!0,i=l-(g+=u-n.lastRTDrawAt+r.getFromEnv("realtimeDrawingLatency"))>0?l-g:0,n._toRealtimeDraw=e.resetTimeout(r._rtDraw,i,n._toRealtimeDraw))},a._clearCachedData=function(){this.getFromEnv("chart").config.cachedArrivedJSON={}},a._stopUpdate=function(){var t=this,e=t.config;t.updateIntervalHandler(0,!0),t.refreshVisualHandler(null,null,!0),t.initiateResetVisual(!0),e._rtAjaxObj&&e._rtAjaxObj.abort(),e._rtPaused=!0,t.setState("ajaxRequested",!1)},a._restartUpdate=function(){var t=this.config;t._rtDataUrl&&t._rtPaused&&(t._rtPaused=!1,t.rtStateChanged=!0,this.processRealtimeStateChange())},a._isUpdateActive=function(){return!this.config._rtPaused},a.addEvents=function(){var t=this,e=t.getLinkedParent(),a=t.config;a.eventsAdded||(t.addExtEventListener("renderComplete",t._handlerFn,e.getFromEnv("chartInstance")),t.addExtEventListener("nodatatodisplay",t._handlerStop,e.getFromEnv("chartInstance"))),a.eventsAdded=!0},e}(l.ComponentInterface);var u={extension:function(t){t.addEventListener("instantiated",c)},name:"DataStreamer",type:"extension",requiresFusionCharts:!0};e["default"]=u},1090:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(240),l=a(232),s=o(a(1091)),c=r.BLANK,h=r.preDefStr.POSITION_TOP,u=r.preDefStr.POSITION_MIDDLE,d=r.preDefStr.showHoverEffectStr,g=r.preDefStr.visibleStr,p=r.preDefStr.ROUND,f=Math.min,m=window,v=m.navigator.userAgent,b="rgba(192,192,192,"+(/msie/i.test(v)&&!m.opera?.002:1e-6)+")",k=function(t,e,a){return a.getFromEnv("animationManager").setAnimation({el:"group",attr:{name:t},container:e,component:a,label:"group"})};(0,l.addDep)({name:"bulbAnimation",type:"animationRule",extension:s["default"]});var C=function(t){function e(){var e;return(e=t.call(this)||this).addData=function(){},e.removeData=function(){},e.components={},e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"bulb"},a._manageSpace=function(t){var e,a,o,i=this.config,n=this.components.data,l=this.getFromEnv("chart").config,s=this.getFromEnv("smartLabel"),h=l.dataLabelStyle,u=(0,r.pluckNumber)(parseInt(h.lineHeight,10),12),d=t,g=l.valuepadding,p=0;return o=(e=n[0])&&e.config,s.useEllipsesOnOverflow(l.useEllipsesWhenOverflow),s.setStyle(h),o&&o.displayValue!==c&&!l.placevaluesinside&&i.showValue&&(a=s.getOriSize(o.displayValue),o.displayValue===r.BLANK&&(a={height:u}),a.height>0&&(p=a.height+g),p>d&&(p=d)),i.heightUsed=p,{top:0,bottom:p}},a.configureAttributes=function(t){if(!t)return!1;this.config.JSONData=t;var e,a=this.config.JSONData,o=(0,r.extend2)({},a),i=this.getFromEnv("chart"),n=this.config,l=i.config,s=i.getFromEnv("dataSource").chart;(0,r.parseConfiguration)(o,n,i.config,{data:!0}),n.origW=(0,r.pluckNumber)(s.origw,l.autoscale?i.config.origRenderWidth:l.width||i.config.origRenderWidth),n.origH=(0,r.pluckNumber)(s.origh,l.autoscale?i.config.origRenderHeight:l.height||i.config.origRenderHeight),n.setToolText=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(s.plottooltext,void 0),!1)),n.useColorNameAsValue=(0,r.pluckNumber)(s.usecolornameasvalue,0),n.showTextOutline=(0,r.pluckNumber)(s.textoutline,0),n.enableAnimation=e=(0,r.pluckNumber)(s.animation,s.defaultanimation,1),n.animation=!!e&&{duration:1e3*(0,r.pluckNumber)(s.animationduration,1)},n.showValue=(0,r.pluckNumber)(s.showvalue,1),this._setConfigure()},a._setConfigure=function(t){var e,a,o,i,n,l,s,c,h,u,d,g,p,f,m,v,b,k,C,x,w,T,y,A,S,F,N,E,L,D=this.getFromEnv("chart"),M=this.config,R=D.config,_=this.config.JSONData,I=t||_.data,V=I&&I.length,O=t&&t.data.length||V,P=D.getFromEnv("dataSource").chart,G=this.getFromEnv("color-manager"),B=(0,r.pluckNumber)(P.showtooltip,1),H=((0,r.parseUnsafeString)((0,r.pluck)(P.tooltipsepchar,r.COMMASPACE)),R.showhovereffect),W=this.components.data,z=(0,r.pluckNumber)(P.is3d,1),j=this.getFromEnv("number-formatter"),U=function(t,e,a){return a?{FCcolor:{cx:.4,cy:.4,r:"80%",color:(0,r.getLightColor)(t,65)+r.COMMASTRING+(0,r.getLightColor)(t,75)+r.COMMASTRING+(0,r.getDarkColor)(t,65),alpha:e+r.COMMASTRING+e+r.COMMASTRING+e,ratio:"0,30,70",radialGradient:!0}}:(0,r.convertColor)(t,e)};for(W||(W=this.components.data=[]),c=0;c<O;c++)o=t?t&&t.data[c]:I[c],l=(n=W[c])&&n.config,n||(n=W[c]={}),n.config||(l=W[c].config={}),l.setValue=i=j.getCleanValue(o.value)||0,e=j.dataLabels(i),s=(0,r.getValidValue)((0,r.parseUnsafeString)(o.displayvalue)),l.colorRangeGetter=h=this.getFromEnv("colorRange"),u=h.getColorObj(l.setValue),h.colorArr.length||(u=h.config.defaultObj),d=(0,r.pluckNumber)(P.gaugefillalpha,u.alpha,100),g=(0,r.parseUnsafeString)((0,r.pluck)(u.label,u.name)),p=(0,r.pluck)(u.bordercolor,P.gaugebordercolor,(0,r.getDarkColor)(u.code,70),"000000"),f=(0,r.pluckNumber)(u.borderalpha,P.gaugeborderalpha,"90")*d/100,p=(m=/\{/.test(p))?G.parseColorMix((0,r.pluck)(u.bordercolor,u.code),p)[0]:p,l.gaugeBorderColor=b=(0,r.convertColor)(p,f),l.gaugeBorderThickness=k=R.showgaugeborder?(0,r.pluckNumber)(P.gaugeborderthickness,1):0,l.rawFillColor=u.code,l.fillColor=v=U(u.code,d,z),0!==H&&(H||P.gaugefillhovercolor||P.plotfillhovercolor||P.gaugefillhoveralpha||P.plotfillhoveralpha||0===P.gaugefillhoveralpha||P.is3donhover||0===P.is3donhover||P.showgaugeborderonhover||0===P.showgaugeborderonhover||P.gaugeborderhovercolor||P.gaugeborderhoveralpha||0===P.gaugeborderhoveralpha||P.gaugeborderhoverthickness||0===P.gaugeborderhoverthickness)&&(H=!0,C=(0,r.pluck)(P.gaugefillhovercolor,P.plotfillhovercolor,"{dark-10}"),x=(0,r.pluckNumber)(P.gaugefillhoveralpha,P.plotfillhoveralpha),void 0===(w=(0,r.pluckNumber)(P.showgaugeborderonhover))&&(w=P.gaugeborderhovercolor||P.gaugeborderhoveralpha||0===P.gaugeborderhoveralpha||P.gaugeborderhoverthickness||0===P.gaugeborderhoverthickness?1:R.showgaugeborder),T=(0,r.pluck)(P.gaugeborderhovercolor,"{dark-10}"),y=(0,r.pluckNumber)(P.gaugeborderhoveralpha),A=w?(0,r.pluckNumber)(P.gaugeborderhoverthickness,k||1):0,S=!!(0,r.pluckNumber)(P.is3donhover,z),E={},L={},k!==A&&(E["stroke-width"]=A,L["stroke-width"]=k),L.fill=(0,r.toRaphaelColor)(v),C=/\{/.test(C)?G.parseColorMix(u.code,C)[0]:(0,r.pluck)(C,u.code),E.fill=(0,r.toRaphaelColor)(U(C,(0,r.pluckNumber)(x,d),S)),A&&(L.stroke=b,F=/\{/.test(T),E.stroke=(0,r.convertColor)(F?G.parseColorMix(m?C:p,T)[0]:T,(0,r.pluckNumber)(y,f)))),l.setTooltext=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(o.tooltext,_.plottooltext,P.plottooltext),!1)),a=!!B&&(void 0!==l.setTooltext?(0,r.parseTooltext)(l.setTooltext,[1,2],{formattedValue:e},o,P):M.useColorNameAsValue?g:null!==e&&e),N=void 0!==s?s:o.label||(M.useColorNameAsValue?g:e),l.toolText=a,l.displayValue=N,l.rolloverProperties={enabled:H,hoverAttr:E,hoverAnimAttr:void 0,outAttr:L}},a.updateData=function(t,e,a){this._setConfigure(t,e),a&&this.asynDraw()},a.draw=function(){var t,e,a,o,i,n,l,s,d,m,v,C,x,w,T,y,A=this.components.data,S=this.getFromEnv("chart"),F=this.getFromEnv("toolTipController"),N=this.config,E=S.config,L=E.canvasLeft,D=E.canvasTop,M=E.canvasHeight,R=E.canvasWidth,_=S.getChildContainer().plotGroup,I=this.getContainer("container"),V=this.getContainer("trackerContainer"),O=S.getChildContainer("trackerGroup"),P=A[0],G=P&&P.config,B=E.gaugeoriginx,H=E.gaugeoriginy,W=E.gaugeradius,z=E.hasgaugeoriginx,j=E.hasgaugeoriginy,U=E.hasgaugeradius,X=this.getFromEnv("smartLabel"),K=this.getFromEnv("animationManager"),Y=this.getContainer("dataLabelContainer"),J=S.config.dataLabelStyle,q=S.getChildContainer("datalabelsGroup");X.setStyle(J),I||(I=this.addContainer("container",k("bulb",_,this))),V||(V=this.addContainer("trackerContainer",k("bulb-hot",O,this))),Y||(Y=this.addContainer("dataLabelContainer",K.setAnimation({el:"group",attr:{name:"datalabel"},label:"labelGroup",component:this}))),q&&q.appendChild(Y),y=P.trackerConfig={},t=G.setValue,a=G.toolText,y.eventArgs={value:t,displayValue:G.displayValue,toolText:a||"",color:G.rawFillColor},P.graphics||(P.graphics={}),e={cx:n=B=void 0!==z?B*N.scaleFactor:L+R/2,cy:l=H=void 0!==j?H*N.scaleFactor:D+M/2,r:s=void 0!==U?W*N.scaleFactor:f(R/2,M/2),"stroke-linecap":p,stroke:(0,r.toRaphaelColor)(G.gaugeBorderColor),"stroke-width":G.gaugeBorderThickness,fill:(0,r.toRaphaelColor)(G.fillColor)},m=P.graphics.element,d=K.setAnimation({el:m||"circle",attr:e,container:I,component:this,animType:"easeOut",label:"circle"}),m||(P.graphics.element=d),y.attr={cx:n,cy:l,r:s,cursor:G.setLink?"pointer":r.BLANK,stroke:b,"stroke-width":G.plotBorderThickness,fill:b,visibility:g},x=(v=P.graphics).label,E.placevaluesinside?(w=l,T=u):(w=l+s+E.valuepadding,T=h),G.setValue!==c&&N.showValue&&(o=(i=X.getSmartText(G.displayValue,E.width-E.chartleftmargin-E.chartrightmargin,+E.height-w-E.chartbottommargin)).tooltext||c,e={text:i.text,"text-anchor":u,x:B,y:w,"vertical-align":T,fill:J.color,direction:G.textDirection,"text-bound":[J.backgroundColor,J.borderColor,J.borderThickness,J.borderPadding,J.borderRadius,J.borderDash]},(C=K.setAnimation({el:x||"text",animType:"easeOut",attr:e,label:"text",container:Y,component:this})).outlineText(N.showTextOutline,e.fill),x||(v.label=C),E.showToolTip?F.enableToolTip(C,o):F.disableToolTip(C)),N.showValue?v.label&&v.label.show():v.label&&v.label.hide(),this.drawTracker()},a.drawTracker=function(){var t,e,a,o,i,r,n,l,s=this,c=s.getFromEnv("chart"),h=s.getFromEnv("animationManager"),u=s.getFromEnv("toolTipController"),g=s.components.data,p=c.config.plothovereffect,f=s.getContainer("trackerContainer"),m=!1;e=(a=g[0])&&a.config,t=a.trackerConfig,o=a.graphics.element,n=t.attr,r=a.graphics.hotElement,n&&(i=h.setAnimation({el:r||"circle",attr:n,container:f,component:s,label:"tracker"}),r||(a.graphics.hotElement=i,m=!0),(i||o).data("eventArgs",t.eventArgs).data(d,p).data("setRolloverAttr",e.rolloverProperties.hoverAttr||{}).data("setRolloutAttr",e.rolloverProperties.outAttr||{}),u.enableToolTip(i||o,t.eventArgs.toolText),(m||e.elemCreated)&&(i||o).on("fc-click",(function(t){c.plotEventHandler(this,t)})).hover((l=o,function(t){var e=this.getData(),a=e.setRolloverAttr;0!==e.showHoverEffect&&!0!==e.draged&&(a.fill&&(h.setAnimationState("mouseover"),h.setAnimation({el:l,attr:a,component:s})),c.plotEventHandler(this,t,"DataPlotRollOver"))}),function(t){return function(e){var a=this.getData(),o=a.setRolloutAttr;0!==a.showHoverEffect&&!0!==a.draged&&(o.fill&&(h.setAnimationState("mouseout"),h.setAnimation({el:t,attr:o,component:s})),c.plotEventHandler(this,e,"DataPlotRollOut"))}}(o)))},e}(n.ComponentInterface);e["default"]=C},1091:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;e["default"]={"initial.dataset.bulb":function(){return{"circle.appearing":function(t){return[{initialAttr:{cx:t.attr.cx,cy:t.attr.cy,r:0},slot:"plot"}]},"tracker.appearing":null,"circle.updating":function(t){return[{initialAttr:{cx:t.attr.cx,cy:t.attr.cy,r:t.attr.r},slot:"plot"}]},"labelGroup.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"}]},"*":null}}}},1092:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=function(t){var e,a=t.getFromEnv("dataSource"),i=a.value,r=a.target,n=[],l={};n.push({value:i,target:r}),l.data=n,e=t.getDSdef(),(0,o.datasetFactory)(t,e,"dataset",1,[l])};var o=a(224)},1093:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1094))["default"];e["default"]=i},1094:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1095)),l=o(a(1101)),s=o(a(1092)),c=r.preDefStr.colors.FFFFFF,h=r.preDefStr.gaugeFillColorStr,u=r.preDefStr.gaugeBorderColorStr,d=function(t){return null!=t},g=function(t){function e(){var e;return(e=t.call(this)||this).defaultPaletteOptions=(0,r.extend2)((0,r.extend2)({},r.defaultGaugePaletteOptions),{gaugeBorderColor:["545454","60634E","415D6F","845001","68001B"],gaugeFillColor:["CCCCCC","ADB68F","E1F5FF","FDB548","FF7CA0"],periodColor:["EEEEEE","ECEEE6","E6ECF0","FFF4E6","FFF2F5"]},!1,!0),e.glasscolor=c,e.showRTvalue=!1,e.canvasPadding=!1,e.isHorizontal=!1,e.config.isAxisOpposite=!0,e.config.scalePosition="right",e.config.canBeScalePosition="left",e.hasCanvas=!0,e.drawPlotlines=!1,e.drawPlotBands=!1,e.isAxisReverse=!1,e.isRealTime=!0,e.registerFactory("dataset",s["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Cylinder"};var a=e.prototype;return a.getName=function(){return"Cylinder"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.alignCaptionWithCanvas=1,e.defaultDatasetType="cylinder",e.hasLegend=!1,e.skipCanvasDrawing=!0},a._parseSpecialConfig=function(){var t,e=this.config,a=this.getFromEnv("dataSource").chart,o=this.getFromEnv("number-formatter"),i=this.getFromEnv("color-manager");e.use3DLighting=(0,r.pluckNumber)(a.use3dlighting,1),e.gaugeOriginX=(0,r.pluckNumber)(a.thmoriginx,a.cyloriginx,a.gaugeoriginx),e.gaugeOriginY=(0,r.pluckNumber)(a.thmoriginy,a.cyloriginy,a.gaugeoriginy),e.gaugeRadius=(0,r.pluckNumber)(o.getCleanValue((0,r.pluckNumber)(a.thmbulbradius,a.cylradius,a.gaugeradius),!0)),e.gaugeHeight=(0,r.pluckNumber)(o.getCleanValue((0,r.pluckNumber)(a.thmheight,a.cylheight,a.gaugeheight),!0)),e.origW=(0,r.pluckNumber)(a.origw),e.origH=(0,r.pluckNumber)(a.origh),e.xDefined=d(e.gaugeOriginX),e.yDefined=d(e.gaugeOriginY),e.rDefined=d(e.gaugeRadius),e.hDefined=d(e.gaugeHeight),e.gaugeFillColor=(0,r.pluck)(a.gaugefillcolor,a.cylfillcolor,i.getColor(h)),e.gaugeFillAlpha=(0,r.pluckNumber)(a.gaugefillalpha,a.cylfillalpha,r.HUNDREDSTRING),e.gaugeYScale=(0,r.pluckNumber)(a.cylyscale,a.gaugeyscale,30),(e.gaugeYScale>50||e.gaugeYScale<0)&&(e.gaugeYScale=30),e.gaugeYScale=e.gaugeYScale/100,e.showGaugeBorder=(0,r.pluckNumber)(a.showgaugeborder,1),t=e.showGaugeBorder?(0,r.pluckNumber)(a.gaugeborderalpha,40):0,e.gaugeBorderColor=(0,r.convertColor)((0,r.pluck)(a.gaugebordercolor,i.getColor(u)),t),e.gaugeBorderThickness=(0,r.pluckNumber)(a.gaugeborderthickness,1),e.gaugeContainerColor=(0,r.pluck)(a.cylglasscolor,(0,r.getLightColor)(e.gaugeFillColor,30))},a.getDSdef=function(){return l["default"]},a._getData=function(){var t=this.getChildren("dataset");if(t&&t[0])return t[0].config.value},e}(n["default"]);e["default"]=g},1095:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1096)),n=o(a(1097)),l=a(224),s=function(t){function e(){var e;return(e=t.call(this)||this).registerFactory("axis",n["default"]),e}(0,i["default"])(e,t),e.getName=function(){return"AxisGaugeBase"};var a=e.prototype;return a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this)},a.allocatePosition=function(){var t=this.config,e=t.canvasWidth,a=t.canvasHeight,o=this.getChildren("caption")[0].config.style,i=this.getChildren("subCaption")[0].config.style,r=this.getFromEnv("dataSource").chart,n=this.getFromEnv("style");o.fontSize=(0,l.pluckNumber)(this.computeFontSize(r.captionfontsize),this.computeFontSize(n.fontSizeWithUnit)+3)+l.PXSTRING,(0,l.setLineHeight)(o),i.fontSize=(0,l.pluckNumber)(this.computeFontSize(r.subcaptionfontsize),(0,l.pluckNumber)(Math.max((0,l.pluckNumber)(this.computeFontSize(r.captionfontsize))-3,-1),this.computeFontSize(n.fontSizeWithUnit))+(0,l.pluckNumber)(this.subTitleFontSizeExtender,1))+l.PXSTRING,(0,l.setLineHeight)(i),t.gaugeStartX=t.canvasLeft,t.gaugeEndX=t.canvasLeft+e,t.gaugeStartY=t.canvasTop,t.gaugeEndY=t.canvasTop+a,t.gaugeCenterX=t.canvasLeft+e/2,t.gaugeCenterY=t.canvasTop+a/2},a._spaceManager=function(){var t,e,a,o,i=this.config,r=this.getChildren("dataset")[0],n=this.getChildren("scale")[0],s=this.config.is3D,c=this.getChildren("canvas")[0],h=this.getFromEnv("dataSource").chart,u=(0,l.pluckNumber)(h.showborder,s?0:1),d=this.isHorizontal,g=i.minChartWidth,p=i.minChartHeight,f=i.borderWidth=u?(0,l.pluckNumber)(h.borderthickness,1):0;i.canvasWidth-2*f<g&&(a=(i.canvasWidth-g)/2),i.canvasHeight-2*f<p&&(o=(i.canvasHeight-p)/2),this._allocateSpace({top:o||f,bottom:o||f,left:a||f,right:a||f}),t=.225*i.availableHeight,e=this._manageActionBarSpace&&this._manageActionBarSpace(t)||{},this._allocateSpace(e),d?this._allocateSpace(n.placeAxis(i.availableHeight)):this._allocateSpace(n.placeAxis(i.availableWidth)),this._manageChartMenuBar(.4*i.availableHeight),r._manageSpace&&this._allocateSpace(r._manageSpace(i.availableHeight)),n.setAxisConfig({drawPlotlines:this.drawPlotlines,drawPlotBands:this.drawPlotBands}),c.setDimension({top:i.canvasTop,left:i.canvasLeft,width:i.canvasWidth,height:i.canvasHeight})},e}(r["default"]);e["default"]=s},1096:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1087)),n=o(a(284)),l=o(a(322)),s=o(a(222)),c=a(224),h=o(a(366)),u=function(t){function e(){var e;e=t.call(this)||this,s["default"].addDep(n["default"]),s["default"].addDep(l["default"]);return e.chartLeftMargin=15,e.chartRightMargin=15,e.chartTopMargin=10,e.chartBottomMargin=37,e.minChartHeight=10,e.minCanvasWidth=0,e}(0,i["default"])(e,t);var a=e.prototype;return a._feedAxesRawData=function(){var t,e,a=this.config,o=this.getFromEnv("color-manager"),i=this.getFromEnv("dataSource"),r=i.chart,n=c.chartPaletteStr.chart2D,l=(0,c.pluckNumber)(r.ticksbelowgauge),s=(0,c.pluckNumber)(r.ticksonright),u=(0,c.pluckNumber)((0,h["default"])(r.scaleposition,a.scalePosition)?a.isAxisOpposite:(0,h["default"])(r.scaleposition,a.canBeScalePosition)?!a.isAxisOpposite:void 0,void 0!==l?!l:void 0,void 0!==s?s:void 0,a.isAxisOpposite),d=(0,c.pluckNumber)(r.reverseaxis,this.isAxisReverse),g=(0,c.pluckNumber)(r.reversescale,0),p=(0,c.pluckNumber)(r.showtickmarks,1),f=this.getFromEnv("number-formatter"),m=(0,c.pluckNumber)(r.showtickvalues),v=(0,c.pluckFontSizeMaintainUnit)(r.outcnvbasefontsize,r.basefontsize,10);return e=!(!m&&void 0!==m)&&!(!p&&void 0===m),(t={isVertical:!this.isHorizontal,isReverse:this.isHorizontal?g:!d,isOpposit:u,outCanfontFamily:(0,c.pluck)(r.outcnvbasefont,r.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(v),outCanfontSizeWithUnit:v,outCancolor:(0,c.pluck)(r.outcnvbasefontcolor,r.basefontcolor,o.getColor(n.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),useEllipsesWhenOverflow:r.useellipseswhenoverflow,divLineColor:(0,c.pluck)(r.vdivlinecolor,o.getColor(n.divLineColor)),divLineAlpha:(0,c.pluck)(r.vdivlinealpha,o.getColor("divLineAlpha")),divLineThickness:(0,c.pluckNumber)(r.vdivlinethickness,1),divLineIsDashed:Boolean((0,c.pluckNumber)(r.vdivlinedashed,r.vdivlineisdashed,0)),divLineDashLen:(0,c.pluckNumber)(r.vdivlinedashlen,4),divLineDashGap:(0,c.pluckNumber)(r.vdivlinedashgap,2),showAlternateGridColor:(0,c.pluckNumber)(r.showalternatevgridcolor,0),alternateGridColor:(0,c.pluck)(r.alternatevgridcolor,o.getColor("altVGridColor")),alternateGridAlpha:(0,c.pluck)(r.alternatevgridalpha,o.getColor("altVGridAlpha")),numDivLines:r.numvdivlines,labelFont:r.labelfont,labelFontSize:this.computeFontSize(r.labelfontsize),labelFontSizeWithUnit:r.labelfontsize,labelFontColor:r.labelfontcolor,labelAlpha:r.labelalpha,labelFontBold:r.labelfontbold,labelFontItalic:r.labelfontitalic,axisName:r.xaxisname,axisMinValue:f.getCleanValue(r.lowerlimit),axisMaxValue:f.getCleanValue(r.upperlimit),setAdaptiveMin:r.setadaptivemin,adjustDiv:r.adjusttm,labelDisplay:r.labeldisplay,showLabels:r.showlabels,rotateLabels:r.rotatelabels,slantLabel:(0,c.pluckNumber)(r.slantlabels,r.slantlabel),labelStep:(0,c.pluckNumber)(r.labelstep,r.xaxisvaluesstep),showAxisValues:(0,c.pluckNumber)(r.showxaxisvalues,r.showxaxisvalue),showDivLineValues:(0,c.pluckNumber)(r.showvdivlinevalues,r.showvdivlinevalues),showZeroPlane:r.showvzeroplane,zeroPlaneColor:r.vzeroplanecolor,zeroPlaneThickness:r.vzeroplanethickness,zeroPlaneAlpha:r.vzeroplanealpha,showZeroPlaneValue:r.showvzeroplanevalue,trendlineColor:r.trendlinecolor,trendlineToolText:r.trendlinetooltext,trendlineThickness:r.trendlinethickness,trendlineAlpha:r.trendlinealpha,showTrendlinesOnTop:r.showtrendlinesontop,showAxisLine:(0,c.pluckNumber)(r.showxaxisline,r.showaxislines,r.drawAxisLines,0),axisLineThickness:(0,c.pluckNumber)(r.xaxislinethickness,r.axislinethickness,1),axisLineAlpha:(0,c.pluckNumber)(r.xaxislinealpha,r.axislinealpha,100),axisLineColor:(0,c.pluck)(r.xaxislinecolor,r.axislinecolor,"#000000"),majorTMNumber:r.majortmnumber,majorTMColor:r.majortmcolor,majorTMAlpha:r.majortmalpha,majorTMHeight:r.majortmheight,tickValueStep:r.tickvaluestep,showTickMarks:r.showtickmarks,connectTickMarks:r.connecttickmarks,showTickValues:r.showtickvalues,majorTMThickness:r.majortmthickness,reverseScale:r.reversescale,showLimits:r.showlimits||e,minorTMNumber:(0,c.pluckNumber)(r.minortmnumber,this.minorTMNumber,4),minorTMColor:r.minortmcolor,minorTMAlpha:r.minortmalpha,minorTMHeight:(0,c.pluckNumber)(r.minortmheight,r.minortmwidth),minorTMThickness:r.minortmthickness,tickMarkDistance:(0,c.pluckNumber)(r.tickmarkdistance,r.tickmarkgap),tickValueDistance:(0,c.pluckNumber)(r.tickvaluedistance,r.displayvaluedistance),placeTicksInside:r.placeticksinside,placeValuesInside:r.placevaluesinside,upperLimitDisplay:r.upperlimitdisplay,lowerLimitDisplay:r.lowerlimitdisplay,drawTickMarkConnector:this.isHorizontal?1:0}).vtrendlines=i.trendpoints,[t]},a._setAxisLimits=function(){var t,e=this.getFromEnv("dataSource").chart,a=this.getChildren("scale")[0];(t=this.getChildren("dataset")[0].getDataLimits()).max===-Infinity&&(t.max=0),t.min===Infinity&&(t.min=0),this.colorRange&&a.setAxisConfig({axisMinValue:(0,c.pluckNumber)(e.lowerlimit,t.forceMin?t.min:void 0),axisMaxValue:(0,c.pluckNumber)(e.upperlimit,t.forceMax?t.max:void 0)}),a.setDataLimit(t.max,t.min)},a._getDataJSON=function(){var t,e,a=0,o=[],i=[],r=[],n=this.getChildren("dataset")[0].components.data;for(t=n&&n.length?n.length:0;a<t;a+=1)e=n[a].config,o.push(e.itemValue),i.push(e.formatedVal||c.BLANK),r.push(e.toolText||c.BLANK);return{values:o,labels:i,toolTexts:r}},a._postSpaceManagement=function(){var t=this.config,e=this.getChildren("canvas")[0],a=this.getChildren("scale")[0],o=this.isHorizontal,i=e.config;o?a.setAxisDimention({axisLength:t.canvasWidth,y:i.canvasTop+(a.config.isOpposit?0:i.canvasHeight),x:i.canvasLeft}):a.setAxisDimention({axisLength:t.canvasHeight,x:i.canvasLeft+(a.config.isOpposit?i.canvasWidth:0),y:i.canvasTop}),this.allocateDimensionOfChartMenuBar()},a._clearChart=function(){},e}(r["default"]);e["default"]=u},1097:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=function(t){var e=t.getChildren("canvas")[0];(0,r.componentFactory)(t,i["default"],"scale",1,t._feedAxesRawData()),t.getChildren("scale")[0].setLinkedItem("canvas",e),t.addToEnv("scale",t.getChildren("scale")[0])};var i=o(a(1098)),r=a(224)},1098:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1099)),n=a(224),l=o(a(513)),s=a(232),c=o(a(1100)),h=o(a(485)),u=a(516);(0,s.addDep)({name:"gaugeAnimation",type:"animationRule",extension:c["default"]});var d=function(t){function e(){var e;return(e=t.call(this)||this).config.scale=new h["default"],e.config.labelMap=[],e.config.prevIntervalArr=[],e.config.prevTicksMap=[],e}(0,i["default"])(e,t);var a=e.prototype;return a.getName=function(){return"gaugeAxis"},a.getLabelPos=function(t,e){var a=this.config,o=a.canvas,i=this.getFromEnv("chart").config,r=o.canvasTop||i.canvasTop,l=o.canvasBottom||i.canvasBottom,s=o.canvasLeft||i.canvasLeft,c=a.isVertical,h=(0,n.pluckNumber)(a.isOpposit),u=o.canvasRight||i.canvasRight,d=a.labelPadding,g={x:0,y:0};return c?(g.x=h?u+d:s-d,g.y=this.getPixel(t,e)):(g.x=this.getPixel(t,e),g.y=h?r-d:l+d),g},a._drawComponents=function(){var t=this.config;t.drawTick&&this._drawTick(),t.drawLabels&&this._drawLabel()},a._drawTick=function(){var t,e,a,o,i,r,s,c,h,u,d,g,p,f,m,v,b,k,C=this,x=C.config,w=x.axisRange,T=x.isVertical,y=(0,n.pluckNumber)(x.isOpposit),A=x.drawTick,S=x.drawTickMinor,F=(0,n.pluckNumber)(x.placeTicksInside),N=C.getLinkedItem("canvas").getEffectiveDimensions(),E=N.top,L=E+N.height,D=N.left,M=D+N.width,R=w.max,_=w.min,I=C.getFromEnv("animationManager"),V=x.ticks,O=V.length,P=x.axisAxisLineContainer,G=[],B=x.minorTicks,H=function(t,e,a){var o=C.getPixel(t,{wrtVisible:!0});return T?["M",e,o,"L",a,o]:["M",o,e,"L",o,a]};if(r={stroke:x.majorTMColor,"stroke-width":x.majorTMThickness,"stroke-linecap":"round",opacity:1},s={stroke:x.majorTMColor,"stroke-width":x.majorTMThickness,"stroke-linecap":"round"},i={stroke:x.minorTMColor,"stroke-width":x.minorTMThickness,"stroke-linecap":"round",opacity:1},x.lines.isDraw&&A){for(T?y?F?(h=(c=M-x.tickMarkDistance)-x.majorTMHeight,u=c-x.minorTMHeight):(h=(c=M+x.tickMarkDistance)+x.majorTMHeight,u=c+x.minorTMHeight):F?(h=(c=D+x.tickMarkDistance)+x.majorTMHeight,u=c+x.minorTMHeight):(h=(c=D-x.tickMarkDistance)-x.majorTMHeight,u=c-x.minorTMHeight):y?F?(h=(c=E+x.tickMarkDistance)+x.majorTMHeight,u=c+x.minorTMHeight):(h=(c=E-x.tickMarkDistance)-x.majorTMHeight,u=c-x.minorTMHeight):F?(h=(c=L-x.tickMarkDistance)-x.majorTMHeight,u=c-x.minorTMHeight):(h=(c=L+x.tickMarkDistance)+x.majorTMHeight,u=c+x.minorTMHeight),d=x.drawTickMarkConnector?T?["M",c,C.getPixel(_),"L",c,C.getPixel(R)]:["M",C.getPixel(_),c,"L",C.getPixel(R),c]:["M0,0"],s.path=d,t=!!(a=C.getGraphicalElement("axisLinePath")),a=I.setAnimation({el:a||"path",attr:s,container:P,component:C,label:"path"}),G.push("axisLinePath"),t||C.addGraphicalElement("axisLinePath",a),g=0;g<O;g+=1)e=H(f=V[g],c,h),r.path=e.toString(),G.push(f),t=!!(o=C.getGraphicalElement(f)),o=I.setAnimation({el:o||"path",data:{path:e.slice(),value:f},attr:r,container:P,component:C,label:"path"}),t||C.addGraphicalElement(f,o);if(S)for(p=0;p<B.length;p+=1)e=H(m=B[p],c,u),i.path=e.toString(),G.push(m),t=!!(o=C.getGraphicalElement(m)),o=I.setAnimation({el:o||"path",data:{path:e.slice(),value:m},attr:i,component:C,container:P,label:"path"}),t||C.addGraphicalElement(m,o)}for(g=0,k=(v=(0,l["default"])(x.prevTicksMap,G)).length;g<k;g++)(b=C.getGraphicalElement(v[g]))&&C.removeGraphicalElement(b);x.prevTicksMap=G},a.placeAxis=function(t){var e,a,o,i,r,l,s,c,h,u,d,g,p,f,m,v,b,k,C=this.getFromEnv("chart"),x=t,w=this.getScale(),T=C.getFromEnv("smartLabel"),y=this.config,A=y.axisRange,S=y.isVertical,F=(0,n.pluckNumber)(y.isOpposit),N=y.labels.style,E=A.tickInterval,L=(0,n.pluckNumber)(y.placeTicksInside),D=(0,n.pluckNumber)(y.placeValuesInside),M=A.max,R=A.min,_=0,I=0,V="",O=y.labels.style.lineHeight,P=this.getFromEnv("number-formatter");if(S?w.setRange([C.config.canvasTop,C.config.canvasBottom]):w.setRange([C.config.canvasLeft,C.config.canvasRight]),o={left:0,right:0,top:0,bottom:0},x<=0)return o;if(y.labels.isDraw=!0,y.labels.drawNumericVal=!0,y.labels.drawNormalVal=y.showTickValues,y.labels.drawLimitVal=y.showLimits,y.lines.isDraw=!0,y.labels.step=y.tickValueStep,y.labelPadding=0,T.useEllipsesOnOverflow(C.config.useEllipsesWhenOverflow),T.setStyle({fontSize:N.fontSize,fontFamily:N.fontFamily,lineHeight:N.lineHeight,fontWeight:N.fontWeight}),this.components||(this.components={},this.components.labels=[]),y.drawTick&&y.showTickMarks&&y.lines.isDraw?(x-=y.tickMarkDistance,I=Math.max(y.minorTMHeight,y.majorTMHeight),L?(s=x+y.tickMarkDistance,D&&(y.labelPadding=y.tickMarkDistance+I)):I>x?(y.lines.isDraw=!1,s=x+y.tickMarkDistance,s=x):(S?F?o.right+=I+y.tickMarkDistance:o.left+=I+y.tickMarkDistance:F?o.top+=I+y.tickMarkDistance:o.bottom+=I+y.tickMarkDistance,s=x-I,D||(y.labelPadding=y.tickMarkDistance+I))):(y.lines.isDraw=!1,s=x),s-=y.tickValueDistance,y.drawLabels&&(y.showTickValues||y.showLimits)){for(g=Math.abs(this.getPixel(R)-this.getPixel(R+E))/2,y.labelPadding+=y.tickValueDistance,s-=y.tickValueDistance,b=P.scale,r=R+E,l=0;r<M;r+=E)i=""+b.call(P,(0,n.toPrecision)(r,10)),u=T.getOriSize(i),this.components.labels[l]={config:{width:u.width,height:u.height,props:{label:{attr:{text:i}}}}},l++,i.length>_&&(V=i,_=i.length);if(u=T.getOriSize(V),S?u.width>s&&(y.labels.drawNumericVal=!1,!y.upperLimitDisplay&&!y.lowerLimitDisplay&&(y.labels.isDraw=!1),V="",u=T.getOriSize(V)):u.height>s&&(y.labels.drawNumericVal=!1,!y.upperLimitDisplay&&!y.lowerLimitDisplay&&(y.labels.isDraw=!1),V="",u=T.getOriSize(V)),c=S?s:g,h=S?g:s,y.showLimits?(f=b.call(P,M),m=b.call(P,R),e=y.upperLimitDisplay||""+f,a=y.lowerLimitDisplay||""+m,(k=T.getOriSize(e)).width>u.width&&(p=T.getSmartText(e,c,h),(e===f&&p.text===p.oriText||y.labels.drawNumericVal)&&(V=e,u=k)),T.getOriSize(a).width>u.width&&(p=T.getSmartText(a,c,h),(a===m&&p.text===p.oriText||y.labels.drawNumericVal)&&(V=a)),""===V&&(V=T.getOriSize(y.upperLimitDisplay).width>T.getOriSize(y.lowerLimitDisplay).width?e:a,u=T.getOriSize(V))):y.labels.drawLimitVal=!1,S)d=T.getSmartText(V,c,h);else for(r=R;r<=M&&""===(d=T.getSmartText(V,c,h)).text;r+=E)c+=g;d=T.getSmartText(V,c,h),y.labelMaxW=Math.max(d.width,u.width),y.labelMaxH=Math.max(d.height,u.height),!D&&y.labels.isDraw?S?(y.labelMaxW=Math.min(y.labelMaxW,s),F?o.right+=y.labelMaxW+y.tickValueDistance:o.left+=y.labelMaxW+y.tickValueDistance):(y.labelMaxH=Math.min(y.labelMaxH,s),F?o.top+=y.labelMaxH+y.tickValueDistance:o.bottom+=y.labelMaxH+y.tickValueDistance):y.labelPadding=-y.labelPadding,y.labels.drawLimitVal&&(O&&-1!==O.indexOf("px")&&(O=parseFloat(O.replace("px",""))),y.upperLimitDisplay?u=T.getSmartText(y.upperLimitDisplay,y.labelMaxW,y.labelMaxH+O/2):(i=""+b.call(P,(0,n.toPrecision)(M,10)),u=T.getOriSize(i)),this.components.labels[l]={config:{width:u.width,height:u.height,props:{label:{attr:{text:u.text}}}}},y.lowerLimitDisplay?u=T.getSmartText(y.lowerLimitDisplay,y.labelMaxW,y.labelMaxH+O/2):(i=""+b.call(P,(0,n.toPrecision)(R,10)),u=T.getOriSize(i)),v={config:{width:u.width,height:u.height,props:{label:{attr:{text:u.text}}}}},this.components.labels.unshift(v))}else y.labels.isDraw=!1;return y.spaceTaken=o,o},a.hide=function(){var t=this.config;t.axisContainer&&(t.axisLabelContainerTop.hide(),t.axisContainer.hide(),t.axisTrendLabelContainer.hide(),t.axisAxisLineContainer.hide())},a.show=function(){var t=this.config;t.axisContainer&&(t.axisLabelContainerTop.show(),t.axisContainer.show(),t.axisTrendLabelContainer.show(),t.axisAxisLineContainer.show())},a._computeTranslation=function(){if(this)return 0},e}(r["default"]);d.prototype.setAxisDimention=u.setAxisDimention,d.prototype.getPixel=u.getPixel,d.prototype._parseLabel=u._parseLabel,d.prototype._drawLabel=u._drawLabel;var g=d;e["default"]=g},1099:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(511)),n=a(224),l=a(516),s=o(a(508)),c=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.majorTMNumber=-1,e.adjustDiv=1,e.majorTMHeight=6,e.showTickMarks=1,e.majorTMThickness=1,e.minorTMNumber=4,e.minorTMThickness=1,e.tickMarkDistance=3,e.placeTicksInside=0,e.placeValuesInside=0,e.forceZeroTick=!1},a.configureAttributes=function(e){var a,o=this.config,i=this.getFromEnv("color-manager");t.prototype.configureAttributes.call(this,e),a=o.rawAttr,o.majorTMColor=(0,n.convertColor)((0,n.pluck)(a.majorTMColor,i.getColor("tickColor")),(0,n.pluckNumber)(a.majorTMAlpha,100)),o.tickValueStep=(0,n.pluckNumber)(a.tickValueStep,1),o.tickValueStep=Math.round(o.tickValueStep),o.tickValueStep<=0&&(o.tickValueStep=1),o.connectTickMarks=o.showTickMarks?(0,n.pluckNumber)(a.connectTickMarks,1):0,o.showTickValues=(0,n.pluckNumber)(a.showTickValues,o.showTickMarks),o.reverseScale=1===(0,n.pluckNumber)(a.reverseScale,0),o.minorTMColor=(0,n.convertColor)((0,n.pluck)(a.minorTMColor,o.majorTMColor),(0,n.pluckNumber)(a.minorTMAlpha,o.majorTMAlpha,100)),o.minorTMHeight=o.showTickMarks?(0,n.pluckNumber)(a.minorTMHeight,Math.round(o.majorTMHeight/2)):0,o.tickValueDistance=(0,n.pluckNumber)(a.tickValueDistance,0)+2,o.upperLimitDisplay=(0,n.parseUnsafeString)(a.upperLimitDisplay)||"",o.lowerLimitDisplay=(0,n.parseUnsafeString)(a.lowerLimitDisplay)||"",o.drawTickMarkConnector=a.drawTickMarkConnector||0,o.numDivLines=o.majorTMNumber>=0?o.majorTMNumber:o.numDivLines+1},a._createContainer=function(){var t,e,a,o,i=this.config,r=this.getLinkedParent().getChildContainer(),n=r.axisBottomGroup,l=r.axisTopGroup;o=this.createContainer("axisTrendGroupBottom",{name:"dataset-Trend-group-bottom"},n),t=this.createContainer("axisLineGroup",{name:"axis-Line-group"},l),e=this.createContainer("axisTrendGroupTop",{name:"dataset-Trend-group-top"},l),a=this.createContainer("axisLabelGroupTop",{name:"dataset-Label-group"},l),i.axisLabelContainerTop=i.axisContainer=this.createGroup("axisLabelContainerTop",{name:"dataset-top-label"},a),i.axisAxisLineContainer=this.createGroup("axisAxisLineContainer",{name:"axis-line-tick"},t),i.axisTrendContainerTop=this.createGroup("axisTrendContainerTop",{name:"dataset-axis-trend-top"},e),i.axisTrendContainerBottom=this.createGroup("axisTrendContainerBottom",{name:"dataset-axis-trend-bottom"},o),i.axisTrendLabelContainer=this.createGroup("axisTrendLabelContainer",{name:"dataset-axis-trend-label"},e)},a.allocatePosition=function(){this.config.drawLabels&&this._parseLabel()},a.setVisibleConfig=function(t,e){var a,o=this.config,i=this.getScale();return!(t>=e||t<o.axisRange.min||e>o.axisRange.max)&&(a=i.setDomain([t,e]).getDomain(),o.visibleMin=a[0],o.visibleMax=a[1],this.fireEvent("visiblerangeset",{minValue:t,maxValue:e}),this.asyncDraw(),!0)},a._adjustNumberFormatter=function(){if(this)return 0},a.calculateTicksOnLabelMode=function(){if(this)return 0},a.generateMinorTicks=function(){var t=this.config;return this.getScale().minorTicks(t.minorTMNumber,t.ticks)},a._setAxisRange=function(t){var e=t.min,a=t.max,o=this.config,i=o.axisRange;e>a||((0,s["default"])(e,a,this.getScale(),o),o.minorTicks=this.generateMinorTicks(),this.setVisibleConfig(i.min,i.max))},e}(r["default"]);c.prototype.setDataLimit=l.setDataLimit,c.prototype.getTrendLineLimits=l.getTrendLineLimits;var h=c;e["default"]=h},1100:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(512),i={"initial.axis.gaugeAxis":{"text.appearing":o.appearingAxis,"path.appearing":o.appearingAxis},"update.axis.gaugeAxis":{"text.appearing":o.appearingFinal,"path.appearing":o.appearingFinal}};e["default"]=i},1101:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1102)),l=a(232),s=o(a(1103)),c="A",h=Math,u=h.max,d=h.min,g=window,p=g.navigator.userAgent,f=/msie/i.test(p)&&!g.opera,m="Z",v="rgba(192,192,192,"+(f?.002:1e-6)+")",b="M",k="L",C=r.preDefStr.POSITION_TOP,x=r.preDefStr.POSITION_MIDDLE;(0,l.addDep)({name:"cylinderAnimation",type:"animationRule",extension:s["default"]});var w=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"cylinder"},a._manageSpace=function(){var t,e,a,o,i=this.config,n=this.getFromEnv("chart").config,l=n.width,s=n.height,c=n.canvasWidth,h=n.canvasHeight,g=n.canvasLeft,p=n.canvasTop,f=n.canvasRight,m=n.xDefined,v=n.yDefined,b=n.rDefined,k=n.hDefined,C=n.gaugeOriginX,x=n.gaugeOriginY,w=n.gaugeRadius,T=n.gaugeHeight,y=n.gaugeYScale,A=function(t,e,a,o){var i=e,n=t;return i=(0,r.pluckNumber)(i,o),n=(0,r.pluckNumber)(n,a),i&&n?n/a==i/o?a/n:Math.min(a/n,o/i):1}(n.origW,n.origH,l,s),S=0,F=0,N=0,E=0;return h-=a=this._getLabelSpace(),F+=a,b?w*=A:w=u(d(c,1.2*h)/2,5),n.effectiveR=w,t=2*w,S+=e=w*y,p+=e,F+=e,h-=2*e,m?o=(C*=A)-w-g:(o=(f-g)/2-w)+t>c&&(o=c-t),N+=o,g+=o,E+=(c-=o)-t,v&&(x*=A),k?(T*=A,v?S+=x-T-p:x=p+T):v?T=x-p:x=p+(T=h),F+=p+h-x,i.gaugeOriginX=C,i.gaugeOriginY=x,i.gaugeRadius=w,i.gaugeHeight=T,i.gaugeYScale=y,{top:S,bottom:F+8,left:N,right:E}},a.draw=function(){var t,e,a,o,i,n,l,s,h,d,g,p,f,w,T,y=this,A=y.config,S=y.getFromEnv("smartLabel"),F=y.getFromEnv("chart"),N=y.getFromEnv("toolTipController"),E=F.getChildContainer("trackerGroup"),L=F.getChildContainer().plotGroup,D=y.getGraphicalElement("fluidTop"),M=y.getGraphicalElement("fluid"),R=y.getGraphicalElement("cylinterTop"),_=y.getGraphicalElement("frontLight1"),I=y.getGraphicalElement("frontLight"),V=y.getGraphicalElement("front"),O=y.getGraphicalElement("back"),P=y.getGraphicalElement("btnBorderLight"),G=y.getGraphicalElement("btnBorder1"),B=y.getGraphicalElement("btnBorder"),H=y.getGraphicalElement("label"),W=F.getChildContainer("datalabelsGroup"),z=y.getContainer("dataLabelContainer"),j=y.getContainer("trackerContainer"),U=y.getGraphicalElement("hotElement"),X=y.getFromEnv("scale"),K=F.config,Y=K.canvasLeft,J=K.canvasTop,q=K.canvasHeight,Z=K.effectiveR||40,$=(0,r.pluckNumber)(A.value,X.getLimit().min),Q=X.getPixel($),tt=Y+Z,et=J,at=q,ot=F.config.dataLabelStyle,it=A.gaugeFillColor,rt=(0,r.getDarkColor)(it,70),nt=(0,r.getLightColor)(it,70),lt=(0,r.getDarkColor)(rt,90),st=K.gaugeFillAlpha,ct=A.gaugeContainerColor,ht=(0,r.getDarkColor)(ct,80),ut=(0,r.getDarkColor)(ct,90),dt=(0,r.getLightColor)(ct,80),gt=K.gaugeYScale,pt=y.getContainer("container"),ft=y.getFromEnv("animationManager"),mt=Math.abs(K.width-K.canvasRight-Y),vt=Z*gt,bt=Z-1.5,kt=A.cylBase=et+at,Ct=Q,xt=tt-Z,wt=tt+Z,Tt=xt+1.5,yt=wt-1.5,At=xt-2,St=wt+2,Ft=Z+2,Nt=vt+2,Et=kt+4,Lt=Et+.001,Dt=.85*Z,Mt=tt-Dt,Rt=tt+Dt,_t=Math.sqrt((1-Dt*Dt/(Z*Z))*vt*vt),It=et+_t,Vt=kt+_t,Ot=et-1,Pt=K.use3DLighting,Gt=A.showHoverEffect,Bt=A.plotFillHoverAlpha,Ht=A.plotFillHoverColor,Wt=A.fluidAttr,zt=(0,r.convertColor)(ht,50),jt={"stroke-width":4},Ut={"stroke-width":4},Xt={"stroke-width":0},Kt={"stroke-width":1},Yt={"stroke-width":2},Jt={"stroke-width":1},qt={"stroke-width":0},Zt={"stroke-width":0},$t={"stroke-width":2},Qt={stroke:v,fill:v},te={};Wt||(Wt=A.fluidAttr={}),Wt["stroke-width"]=0,h={value:A.value,displayValue:A.displayValue,toolText:A.toolText,cylOriginX:A.gaugeOriginX,cylOriginY:A.gaugeOriginY,cylRadius:A.gaugeRadius,cylHeight:A.gaugeHeight,cylYScale:A.gaugeYScale,cylFillColor:A.gaugeFillColor,cylGlassColor:A.gaugeContainerColor},Pt?(p=dt+r.COMMASTRING+ht+r.COMMASTRING+dt+r.COMMASTRING+ht+r.COMMASTRING+ut+r.COMMASTRING+ut+r.COMMASTRING+ht+r.COMMASTRING+dt,w=(0,r.toRaphaelColor)({FCcolor:{cx:.5,cy:0,r:"100%",color:nt+r.COMMASTRING+rt,alpha:st+r.COMMASTRING+st,ratio:"0,100",radialGradient:!0}}),o=(0,r.toRaphaelColor)({FCcolor:{cx:.5,cy:.7,r:"100%",color:nt+r.COMMASTRING+rt,alpha:st+r.COMMASTRING+st,ratio:"0,100",radialGradient:!0}}),i=(0,r.convertColor)(nt,st),f=dt+r.COMMASTRING+ht+r.COMMASTRING+dt+r.COMMASTRING+dt+r.COMMASTRING+ht+r.COMMASTRING+dt+r.COMMASTRING+ht+r.COMMASTRING+dt,qt.path=[b,xt,kt,c,Z,vt,1,0,0,Mt,Vt,k,Mt,It,c,Z,vt,0,0,1,xt,et,m],qt.fill=(0,r.toRaphaelColor)({FCcolor:{color:f,alpha:"40,0",ratio:"0,100",angle:0}}),Zt.path=[b,Rt,Vt,c,Z,vt,0,0,0,wt,kt,k,wt,et,c,Z,vt,1,0,0,Rt,It,m],Zt.fill=(0,r.toRaphaelColor)({FCcolor:{color:f,alpha:"40,0",ratio:"0,100",angle:180}})):(p=dt+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+dt,o=w=(0,r.convertColor)(rt,st),i=(0,r.convertColor)(lt),f=ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht+r.COMMASTRING+ht),Wt.bodyOut={fill:w},Wt.topOut={stroke:i,fill:o},Gt&&(n=(0,r.getDarkColor)(Ht,70),l=(0,r.getLightColor)(Ht,70),s=(0,r.getDarkColor)(n,90),Pt?(Wt.bodyHover={fill:(0,r.toRaphaelColor)({FCcolor:{cx:.5,cy:0,r:"100%",color:l+r.COMMASTRING+n,alpha:Bt+r.COMMASTRING+Bt,ratio:"0,100",radialGradient:!0}})},Wt.topHover={stroke:(0,r.convertColor)(l,Bt),fill:(0,r.toRaphaelColor)({FCcolor:{cx:.5,cy:.7,r:"100%",color:l+r.COMMASTRING+n,alpha:Bt+r.COMMASTRING+Bt,ratio:"0,100",radialGradient:!0}})}):(Wt.bodyHover={fill:(0,r.convertColor)(n,Bt)},Wt.topHover={stroke:(0,r.convertColor)(s),fill:(0,r.convertColor)(n,Bt)})),Wt.fill=w,Wt.path=[b,xt,kt,c,Z,u(vt,1),0,0,0,wt,kt,k,wt,Ct,c,Z,u(vt,1),0,0,1,xt,Ct,m],Yt.fill=o,Yt.stroke=i,Yt.path=[b,Tt,Ct,c,bt,vt,0,0,0,yt,Ct,k,yt,Ct,c,bt,vt,0,0,0,Tt,Ct,m],jt.stroke=(0,r.convertColor)(ht,80),jt.path=[b,At,Et,c,Ft,Nt,0,0,0,St,Et,k,St,Lt,c,Ft,Nt,0,0,0,At,Lt,m],Ut.stroke=zt,Ut.path=[b,xt,Et,c,Z,vt,0,0,0,wt,Et,k,wt,Lt,c,Z,vt,0,0,0,xt,Lt,m],Xt.path=[b,xt,kt,c,Z,vt,0,0,0,wt,kt,c,Z,vt,0,0,0,xt,kt,m],Xt.fill=(0,r.toRaphaelColor)({FCcolor:{color:dt+r.COMMASTRING+ht+r.COMMASTRING+dt+r.COMMASTRING+dt+r.COMMASTRING+ht+r.COMMASTRING+rt+r.COMMASTRING+ht+r.COMMASTRING+dt,alpha:"50,50,50,50,50,70,50,50",ratio:"0,15,0,12,0,15,43,15",angle:0}}),Kt.path=[b,xt,kt,c,Z,vt,0,0,0,wt,kt,k,wt,et,c,Z,vt,0,0,0,xt,et,m],Kt.stroke=zt,Kt.fill=(0,r.toRaphaelColor)({FCcolor:{color:p,alpha:"30,30,30,30,30,30,30,30",ratio:"0,15,43,15,0,12,0,15",angle:0}}),Jt.path=[b,xt,kt,c,Z,vt,0,0,0,wt,kt,k,wt,et,c,Z,vt,0,0,1,xt,et,m],Jt.stroke=zt,Jt.fill=(0,r.toRaphaelColor)({FCcolor:{color:f,alpha:"30,30,30,30,30,30,30,30",ratio:"0,15,0,12,0,15,43,15",angle:0}}),$t.stroke=(0,r.convertColor)(ht,40),$t.path=[b,xt,Ot,c,Z,vt,0,0,0,wt,Ot,k,wt,Ot,c,Z,vt,0,0,0,xt,Ot,m],Qt.path=[b,xt,kt,xt,Et+4,c,Z,vt,0,0,0,wt,Et+4,k,wt,kt,wt,et,c,Z,vt,0,0,0,xt,et,m],te.opacity=A.showValue?1:0,S.setStyle(ot),a=kt+vt+(A.valuePadding||0)+8,d=(g=S.getSmartText(A.displayValue,K.width-K.marginLeft-K.marginRight-mt/2,+K.height-a-K.marginBottom)).tooltext||r.BLANKSTRING,T={text:g.text,x:tt,y:a,"text-anchor":x,"vertical-align":C,fill:ot.color,"text-bound":[ot.backgroundColor,ot.borderColor,ot.borderThickness,ot.borderPadding,ot.borderRadius,ot.borderDash]},e=ft.setAnimation({el:pt||"group",attr:{name:"cylinder"},container:L,component:y,label:"group"}),B=ft.setAnimation({el:B||"path",attr:jt,container:e,component:y,label:"path"}),G=ft.setAnimation({el:G||"path",attr:Ut,container:e,component:y,label:"path"}),P=ft.setAnimation({el:P||"path",attr:Xt,container:e,component:y,label:"path"}),O=ft.setAnimation({el:O||"path",attr:Kt,container:e,component:y,label:"path"}),M=ft.setAnimation({el:M||"path",attr:Wt,container:e,component:y,label:"plotFluid"}),D=ft.setAnimation({el:D||"path",attr:Yt,container:e,component:y,label:"plotFluidTop"}),V=ft.setAnimation({el:V||"path",attr:Jt,container:e,component:y,label:"path"}),I=ft.setAnimation({el:I||"path",attr:qt,container:e,component:y,label:"path"}),_=ft.setAnimation({el:_||"path",attr:Zt,container:e,component:y,label:"path"}),R=ft.setAnimation({el:R||"path",attr:$t,container:e,component:y,label:"path"}),j=ft.setAnimation({el:j||"group",attr:{name:"tracker-group"},container:E,component:y,label:"group"}),t=ft.setAnimation({el:z||"group",attr:te,container:W,component:y,label:"labelGroup"}),H=ft.setAnimation({el:H||"text",attr:T,container:t,component:y,label:"text"}),U=ft.setAnimation({el:U||"path",attr:Qt,container:j,component:y,label:"path"}),A.showTooltip?N.enableToolTip(H,d):N.disableToolTip(H),pt||(U.on("fc-click",(function(t){F.plotEventHandler(this,t)})).hover((function(t){A.showHoverEffect&&(y.getGraphicalElement("fluid")&&y.getGraphicalElement("fluid").attr(Wt.bodyHover),y.getGraphicalElement("fluidTop")&&y.getGraphicalElement("fluidTop").attr(Wt.topHover)),F.plotEventHandler(this,t,"DataPlotRollOver")}),(function(t){A.showHoverEffect&&(y.getGraphicalElement("fluid")&&y.getGraphicalElement("fluid").attr(Wt.bodyOut),y.getGraphicalElement("fluidTop")&&y.getGraphicalElement("fluidTop").attr(Wt.topOut)),F.plotEventHandler(this,t,"DataPlotRollOut")})),y.addContainer("container",e),y.addGraphicalElement("btnBorder",B),y.addGraphicalElement("btnBorder1",G),y.addGraphicalElement("btnBorderLight",P),y.addGraphicalElement("back",O),y.addGraphicalElement("fluid",M),y.addGraphicalElement("fluidTop",D),y.addGraphicalElement("front",V),y.addGraphicalElement("frontLight",I),y.addGraphicalElement("frontLight1",_),y.addGraphicalElement("cylinterTop",R),y.addContainer("trackerContainer",j),y.addGraphicalElement("hotElement",U)),z||(y.addContainer("dataLabelContainer",t),y.addGraphicalElement("label",H)),U.data("eventArgs",h),A.toolText?N.enableToolTip(U,A.toolText):N.disableToolTip(U)},e}(n["default"]);e["default"]=w},1102:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(240),l=r.BLANK,s=r.preDefStr.gaugeFillColorStr,c=r.preDefStr.gaugeBorderColorStr,h=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"cylinderThermometerBase"},a.setValue=function(t,e){if(t){var a,o=this.config,i=this.getFromEnv("chart").getFromEnv("dataSource").chart,n=this.getFromEnv("number-formatter"),s=t.value,c=t.tooltext||i.plottooltext;o.value=s=n.getCleanValue(s),null!==s?(a=o.formattedValue=n.dataLabels(o.value),o.showValue?o.displayValue=t.label||(0,r.getValidValue)(a,r.BLANK):o.displayValue=l,o.showTooltip?o.toolText=void 0!==c?(0,r.parseUnsafeString)((0,r.parseTooltext)((0,r.pluck)(t.tooltext,c),[1,2],{formattedValue:a,value:s},t,i),!1):(0,r.parseUnsafeString)((0,r.parseTooltext)((0,r.pluck)(t.tooltext,null===a?l:a)),!1):o.toolText=l):(o.displayValue=l,o.toolText=l,o.formattedValue=null),e&&this.draw()}},a.configure=function(t){if(!t)return!1;this.setValue(t&&t.data&&t.data[0]);var e,a,o,i,n=this.getFromEnv("chart"),l=n.getFromEnv("dataSource"),h=l.chart,u=this.config||(this.config={}),d=this.getFromEnv("color-manager"),g=n.config,p=(0,r.pluckNumber)(h.showhovereffect);u.showValue=(0,r.pluckNumber)(h.showvalue,h.showvalues,1),u.showTooltip=(0,r.pluckNumber)(h.showtooltip,1),u.valuePadding=(0,r.pluckNumber)(h.valuepadding,2),u.tooltipSepChar=(0,r.pluck)(h.tooltipsepchar,r.COMMASTRING),u.pointerOnOpp=(0,r.pluckNumber)(h.pointerontop,0),u.axisPosition=(0,r.pluckNumber)(h.ticksbelowgauge,h.ticksbelowgraph,this.ticksbelowgauge,1)?3:1,u.valueAbovePointer=(0,r.pluckNumber)(h.valueabovepointer,1),u.labelStyle=g.dataLabelStyle,i=u.gaugeFillColor=(0,r.pluck)(h.gaugefillcolor,h.thmfillcolor,h.cylfillcolor,d.getColor(s)),o=u.gaugeFillAlpha=(0,r.pluckNumber)(h.gaugefillalpha,h.cylfillalpha,h.thmfillalpha,r.HUNDREDSTRING),u.showGaugeBorder=(0,r.pluckNumber)(h.showgaugeborder,1),e=u.showGaugeBorder?(0,r.pluckNumber)(h.gaugeborderalpha,40):0,u.rawGaugeBorderColor=(0,r.pluck)(h.gaugebordercolor,d.getColor(c)),u.gaugeBorderAlpha=e,u.gaugeBorderColor=(0,r.convertColor)(u.rawGaugeBorderColor,e),u.gaugeBorderThickness=(0,r.pluckNumber)(h.gaugeborderthickness,1),u.gaugeContainerColor=(0,r.pluck)(h.thmglasscolor,h.cylglasscolor,n.glasscolor,(0,r.getLightColor)(i,30)),0!==p&&(p||h.plotfillhovercolor||h.plotfillhoveralpha||0===h.plotfillhoveralpha)&&(u.showHoverEffect=!0,a=(0,r.pluck)(h.plotfillhovercolor,h.cylfillhovercolor,h.thmfillhovercolor,"{dark-10}"),u.plotFillHoverAlpha=(0,r.pluckNumber)(h.plotfillhoveralpha,h.cylfillhoveralpha,h.thmfillhoveralpha,o),u.plotFillHoverColor=/\{/.test(a)?d.parseColorMix(i,a)[0]:a),this.setValue(l),n._parseSpecialConfig&&n._parseSpecialConfig()},a._getLabelSpace=function(){var t,e=this.config,a=this.getFromEnv("chart"),o=this.getFromEnv("smartLabel");return o.useEllipsesOnOverflow(a.config.useEllipsesWhenOverflow),o.setStyle(e.labelStyle),(t=o.getOriSize(e.displayValue!==r.BLANK?e.displayValue:"dummy")).height?t.height+e.valuePadding:0},a.getDataLimits=function(){var t,e,a=this.config;return e=t=a.value,a.maxValue=e,a.minValue=t,{forceMin:!0,forceMax:!0,max:e,min:t}},a.updateData=function(){var t=this,e=arguments[0],a=arguments[2],o=t.config,i=o.maxValue,r=o.prevMin,n=o.value,l=t.getFromEnv("chart"),s=t.groupManager||t,c=t.getFromEnv("scale");t.setValue(e.data[0]),o.maxValue=n,o.minValue=n,o.maxValue===i&&o.minValue===r||(t.config.maxminFlag=!0),a&&(l._setAxisLimits(),c.draw(),s.draw())},a.setJSONIndex=function(t){this.config.index=t},a.getJSONIndex=function(){return this.config.index||0},e}(n.ComponentInterface);e["default"]=h},1103:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(224),i=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],r={"initial.dataset.cylinder":function(){var t=this.config;return{"plotFluid.appearing":function(t){var e=t.attr.path.slice(0);return e[13]=e[21]=e[2],[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:{path:e},finalAttr:{opacity:1},slot:"middle"}]},"plotFluid.updating":null,"plotFluidTop.appearing":function(e){var a=e.attr.path.slice(0);return a[2]=a[10]=a[13]=a[21]=t.cylBase,[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:{path:a},finalAttr:{opacity:1},slot:"middle"}]},"plotFluidTop.updating":null,"text.appearing":function(){return i[0].slot=o.FINALSTR,i},"text.updating":null,"labelGroup.appearing":function(){return i[0].slot=o.FINALSTR,i},"labelGroup.updating":null,"path.appearing":function(){return i[0].slot=o.INITIALSTR,i},"path.updating":null}}};e["default"]=r},1104:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1105))["default"];e["default"]=i},1105:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(1106),l=o(a(1054)),s=o(a(1096)),c=o(a(1107)),h=o(a(1110)),u=Math,d=u.min,g=u.PI/180,p=function(t){return null!=t},f=function(t){function e(){var e;return(e=t.call(this)||this).isHorizontal=!0,e.isAxisOpposite=!1,e.isRealTime=!0,e.drawPlotlines=!1,e.drawPlotBands=!1,e.isAxisReverse=!1,e.colorRange=!0,e.defaultPaletteOptions=(0,r.extend2)((0,r.extend2)({},r.defaultGaugePaletteOptions),{dialColor:["999999,ffffff,999999","ADB68F,F3F5DD,ADB68F","A2C4C8,EDFBFE,A2C4C8","FDB548,FFF5E8,FDB548","FF7CA0,FFD1DD,FF7CA0"],dialBorderColor:["999999","ADB68F","A2C4C8","FDB548","FF7CA0"],pivotColor:["999999,ffffff,999999","ADB68F,F3F5DD,ADB68F","A2C4C8,EDFBFE,A2C4C8","FDB548,FFF5E8,FDB548","FF7CA0,FFD1DD,FF7CA0"],pivotBorderColor:["999999","ADB68F","A2C4C8","FDB548","FF7CA0"]},!1,!0),e.rtParserModify=!0,e._setCategories=function(){},e.registerFactory("dataset",h["default"],["axis"]),e.registerFactory("axis",c["default"],["canvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"AngularGauge"};var a=e.prototype;return a.getName=function(){return"AngularGauge"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Angular Gauge",e.hasLegend=!1,e.defaultDatasetType="angulargauge",e.animationeffect="easeOut",e.skipCanvasDrawing=!0},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.getFromEnv("dataSource").colorrange;a&&a.color&&a.color.length?((0,r.componentFactory)(this,l["default"],"colorRange",1,[{colorRange:a,numberFormatter:this.getFromEnv("number-formatter")}]),this.addToEnv("colorRange",this.getChildren("colorRange")[0])):this.deleteFromEnv("colorRange")},a._spaceManager=function(){var t,a,o,i,n,l,s,c,h,u,d,g=this.config,p=this.getChildren("dataset")[0],f=this.getFromEnv("scale"),m=f.config,v=p.components.data[0],b=this.getFromEnv("dataSource").chart,k=p.config,C=k.scaleFactor,x=0,w=0,T=k.pivotRadius,y=g.dataLabels.style.lineHeight,A=g.displayValueCount,S=g.borderWidth,F=g.minChartWidth,N=g.minChartHeight,E=0;g.canvasWidth-2*S<F&&(d=(g.canvasWidth-F)/2),g.canvasHeight-2*S<N&&(u=(g.canvasHeight-N)/2),this._allocateSpace({top:u||S,bottom:u||S,left:d||S,right:d||S}),g.autoScale?g.scaleFactor=C=e._getScaleFactor(k.origW,k.origH,g.width,g.height):g.scaleFactor=C=1,y=y.replace(/px/i,""),s=/^\d+\%$/.test(k.gaugeinnerradius)?parseInt(k.gaugeinnerradius,10)/100:.7,c=T=(0,r.pluckNumber)((0,r.getValidValue)(b.pivotradius)*C,5),k.pivotRadius=c,T=Math.max(T,k.rearExtension*C),v&&v.config&&v.config.rearextension&&(T=Math.max(T,v.config.rearextension*C)),k.compositPivotRadius=T,x=A*y+2+c,k.valueBelowPivot||(w=x,x=0),k.gaugeOuterRadius=(0,r.pluckNumber)(Math.abs((0,r.getValidValue)(b.gaugeouterradius)*C)),k.gaugeInnerRadius=(0,r.pluckNumber)(Math.abs((0,r.getValidValue)(b.gaugeinnerradius)*C),k.gaugeOuterRadius*s),t=.7*g.canvasWidth,g.canvasHeight,h=f.placeAxis(t),a=.7*g.canvasHeight,this._manageChartMenuBar(a),o=(l=e._angularGaugeSpaceManager(k.gaugeStartAngle,k.gaugeEndAngle,g.canvasWidth,g.canvasHeight,k.gaugeOuterRadius,(0,r.pluckNumber)((0,r.getValidValue)(b.gaugeoriginx)*C-g.canvasLeft),(0,r.pluckNumber)((0,r.getValidValue)(b.gaugeoriginy)*C-g.canvasTop),T+m.polarPadding,x,w)).radius=(0,r.pluckNumber)(l.radius,l.maxRadius),k.gaugeOriginX=l.centerX+g.canvasLeft,k.gaugeOriginY=l.centerY+g.canvasTop,i=l.centerX,n=l.centerY,E=h.left<h.top?i-h.left>=o-h.left&&n-h.top>=o-h.left?h.left:h.top:i-h.left>=o-h.top&&n-h.top>=o-h.top?h.top:h.left,E+=2*f.config.polarPadding,!k.gaugeOuterRadius&&(k.gaugeOuterRadius=l.radius-E),void 0===k.gaugeInnerRadius&&(k.gaugeInnerRadius=k.gaugeOuterRadius*s),f.setAxisConfig({centerX:k.gaugeOriginX,centerY:k.gaugeOriginY,radius:l.radius||k.gaugeOuterRadius,gaugeOuterRadius:k.gaugeOuterRadius,gaugeInnerRadius:k.gaugeInnerRadius,scaleFactor:C})},a.allocatePosition=function(){var t=this.config,e=this.getChildren("dataset")[0].config;t.gaugeStartX=t.canvasLeft,t.gaugeStartY=t.canvasTop,t.gaugeEndX=t.canvasRight,t.gaugeEndY=t.canvasBottom,t.gaugeCenterX=e.gaugeOriginX,t.gaugeCenterY=e.gaugeOriginY,t.gaugeStartAngle=e.gaugeStartAngle/g,t.gaugeEndAngle=e.gaugeEndAngle/g},a._feedAxesRawData=function(){var t,e=this.getFromEnv("color-manager"),a=this.getFromEnv("dataSource"),o=a.chart,i=this.getFromEnv("number-formatter"),n=r.chartPaletteStr.chart2D,l=(0,r.pluckNumber)(o.axisontop,o.axisonleft,void 0!==o.ticksbelowgauge?!o.ticksbelowgauge:void 0,this.isAxisOpposite),s=(0,r.pluckNumber)(o.reverseaxis,this.isAxisReverse),c=(0,r.pluckFontSizeMaintainUnit)(o.outcnvbasefontsize,o.basefontsize,10);return(t={isVertical:!this.isHorizontal,isReverse:s,isOpposit:l,outCanfontFamily:(0,r.pluck)(o.outcnvbasefont,o.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(c),outCanfontSizeWithUnit:c,outCancolor:(0,r.pluck)(o.outcnvbasefontcolor,o.basefontcolor,e.getColor(n.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),useEllipsesWhenOverflow:o.useellipseswhenoverflow,divLineColor:(0,r.pluck)(o.vdivlinecolor,e.getColor(n.divLineColor)),divLineAlpha:(0,r.pluck)(o.vdivlinealpha,e.getColor("divLineAlpha")),divLineThickness:(0,r.pluckNumber)(o.vdivlinethickness,1),divLineIsDashed:Boolean((0,r.pluckNumber)(o.vdivlinedashed,o.vdivlineisdashed,0)),divLineDashLen:(0,r.pluckNumber)(o.vdivlinedashlen,4),divLineDashGap:(0,r.pluckNumber)(o.vdivlinedashgap,2),showAlternateGridColor:(0,r.pluckNumber)(o.showalternatevgridcolor,0),alternateGridColor:(0,r.pluck)(o.alternatevgridcolor,e.getColor("altVGridColor")),alternateGridAlpha:(0,r.pluck)(o.alternatevgridalpha,e.getColor("altVGridAlpha")),numDivLines:o.numvdivlines,labelFont:o.labelfont,labelFontSize:this.computeFontSize(o.labelfontsize),labelFontSizeWithUnit:o.labelfontsize,labelFontColor:o.labelfontcolor,labelAlpha:o.labelalpha,labelFontBold:o.labelfontbold,labelFontItalic:o.labelfontitalic,axisName:o.xaxisname,axisMinValue:i.getCleanValue(o.lowerlimit),axisMaxValue:i.getCleanValue(o.upperlimit),setAdaptiveMin:o.setadaptivemin,adjustDiv:o.adjusttm,labelDisplay:o.labeldisplay,showLabels:o.showlabels,rotateLabels:o.rotatelabels,slantLabel:(0,r.pluckNumber)(o.slantlabels,o.slantlabel),labelStep:(0,r.pluckNumber)(o.labelstep,o.xaxisvaluesstep),showAxisValues:(0,r.pluckNumber)(o.showxaxisvalues,o.showxaxisvalue),showDivLineValues:(0,r.pluckNumber)(o.showvdivlinevalues,o.showvdivlinevalues),showZeroPlane:o.showvzeroplane,zeroPlaneColor:o.vzeroplanecolor,zeroPlaneThickness:o.vzeroplanethickness,zeroPlaneAlpha:o.vzeroplanealpha,showZeroPlaneValue:o.showvzeroplanevalue,trendlineColor:o.trendlinecolor,trendlineToolText:o.trendlinetooltext,trendlineThickness:o.trendlinethickness,trendlineAlpha:o.trendlinealpha,showTrendlinesOnTop:o.showtrendlinesontop,showAxisLine:(0,r.pluckNumber)(o.showxaxisline,o.showaxislines,o.drawAxisLines,0),axisLineThickness:(0,r.pluckNumber)(o.xaxislinethickness,o.axislinethickness,1),axisLineAlpha:(0,r.pluckNumber)(o.xaxislinealpha,o.axislinealpha,100),axisLineColor:(0,r.pluck)(o.xaxislinecolor,o.axislinecolor,"#000000"),majorTMNumber:o.majortmnumber,majorTMColor:o.majortmcolor,majorTMAlpha:o.majortmalpha,majorTMHeight:o.majortmheight,tickValueStep:o.tickvaluestep,showTickMarks:o.showtickmarks,connectTickMarks:o.connecttickmarks,showTickValues:o.showtickvalues,majorTMThickness:o.majortmthickness,reverseScale:o.reversescale,showLimits:o.showlimits,minorTMNumber:o.minortmnumber,minorTMColor:o.minortmcolor,minorTMAlpha:o.minortmalpha,minorTMHeight:(0,r.pluckNumber)(o.minortmheight,o.minortmwidth),minorTMThickness:o.minortmthickness,tickMarkDistance:(0,r.pluckNumber)(o.tickmarkdistance,o.tickmarkgap),tickValueDistance:(0,r.pluckNumber)(o.tickvaluedistance,o.displayvaluedistance),placeTicksInside:o.placeticksinside,placeValuesInside:o.placevaluesinside,upperLimitDisplay:o.upperlimitdisplay,lowerLimitDisplay:o.lowerlimitdisplay,ticksBelowGauge:o.ticksbelowgauge,ticksBelowGraph:o.ticksbelowgraph,trendValueDistance:o.trendvaluedistance}).trendPoints=a.trendpoints,[t]},e._angularGaugeSpaceManager=function(t,e,a,o,i,r,n,l,s,c){void 0===l&&(l=0);var h,u,g,f,m,v,b,k,C,x,w,T,y,A,S=p(i),F=r,N=n,E=p(F),L=p(N),D=2*Math.PI,M=Math.PI,R=Math.PI/2,_=M+R,I={radius:i,centerX:F,centerY:N},V=s,O=c,P=!1,G=t%D;return G<0&&(G+=D),l&&l<a/2&&l<o/2&&(P=!0),V>o/2&&(V=o/2),O>o/2&&(O=o/2),v=Math.cos(t),b=Math.sin(t),k=Math.cos(e),C=Math.sin(e),u=d(v,k,0),f=Math.max(v,k,0),g=d(b,C,0),m=Math.max(b,C,0),S&&E&&L||(((w=G+(A=e-t))>D||w<0)&&(f=1),A>0?((G<R&&w>R||w>D+R)&&(m=1),(G<M&&w>M||w>D+M)&&(u=-1),(G<_&&w>_||w>D+_)&&(g=-1)):((G>R&&w<R||w<-_)&&(m=1),(G>M&&w<M||w<-M)&&(u=-1),(G>_&&w<_||w<-R)&&(g=-1)),E?S||(T=a-F,y=-F,h=u?d(T/f,y/u):T/f):(F=-(x=a/(f-u))*u,h=x,P&&(a-F<l?(T=a-(F=a-l),y=-F,h=u?d(T/f,y/u):T/f):F<l&&(T=a-(F=l),y=-F,h=u?d(T/f,y/u):T/f)),I.centerX=F),L?S||(T=o-N,y=-N,h=d(h,g?d(T/m,y/g):T/m)):(N=-(x=o/(m-g))*g,P&&(o-N<l?(T=o-(N=o-l),y=-N,h=d(h,g?d(T/m,y/g):T/m)):N<l&&(T=o-(N=l),y=-N,h=d(h,g?d(T/m,y/g):T/m))),o-N<V?(T=o-(N=o-V),y=-N,h=d(h,g?d(T/m,y/g):T/m)):N<O&&(T=o-(N=O),y=-N,h=d(h,g?d(T/m,y/g):T/m)),h=d(h,x),I.centerY=N),I.maxRadius=h,I.maxRadius<=0&&(I.maxRadius=d(a/2,o/2))),I},e._getScaleFactor=function(t,e,a,o){var i=(0,r.pluckNumber)(e,o),n=(0,r.pluckNumber)(t,a);return i&&n?n/a==i/o?a/n:d(a/n,o/i):1},a._getData=function(t,e){return n._getData.call(this,t,e)},a._setData=function(t,e){n._setData.call(this,t,e)},a._getDataForId=function(t,e){return n._getDataForId.call(this,t,e)},a._setDataForId=function(t,e){n._setDataForId.call(this,t,e)},e}(s["default"]);e["default"]=f},1106:function(t,e,a){"use strict";e.__esModule=!0,e._getData=function(t,e){var a,r,n=this.getChildren().dataset,l=t,s=function(){return(r=n[0].components.data)&&r[--l]?(a=r[l].config,(0,o.pluckNumber)(a.setValue,a.itemValue)):null};if(n){if("function"!=typeof e)return s();this.addJob("eiMethods",(function(){e(s())}),i.priorityList.postRender)}},e._setData=function(t,e){var a,i="value=";if(t===o.UNDEF||null===t||e===o.UNDEF||null===e)return;for(a=1;a<Number(t);a++)i+=o.COMMASTRING;e.toString&&(i+=e.toString());i&&this.feedData(i)},e._getDataForId=function(t,e){var a=this.getChildren("dataset")[0].config.idMap;if("function"!=typeof e)return a&&a[t]&&a[t].config.itemValue||null;this.addJob("eiMethods",(function(){e(a&&a[t]&&a[t].config.itemValue||null)}),i.priorityList.postRender)},e._setDataForId=function(t,e){var a=this.getChildren("dataset")[0].config.idMap;return a&&a[t]&&this._setData(a[t].index+1,e)};var o=a(224),i=a(236)},1107:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=function(t){(0,r.componentFactory)(t,i["default"],"scale",1,t._feedAxesRawData()),t.addToEnv("scale",t.getChildren("scale")[0])};var i=o(a(1108)),r=a(224)},1108:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1099)),n=a(224),l=a(1062),s=o(a(513)),c=a(232),h=o(a(1109)),u=o(a(485)),d=n.preDefStr.POSITION_MIDDLE,g=n.preDefStr.POSITION_START,p=n.preDefStr.POSITION_TOP,f=n.preDefStr.POSITION_BOTTOM,m=n.preDefStr.POSITION_END,v=Math,b=2*v.PI,k="_tick";(0,c.addDep)({name:"polarNumericAnimation",type:"animationRule",extension:h["default"]});var C=function(t){function e(){var e;return(e=t.call(this)||this).config.scale=new u["default"],e.config.prevTickMarks=[],e.config.prevIntervalArrLabel=[],e.config.prevIntervalArrTrendLine=[],e}(0,i["default"])(e,t);var a=e.prototype;return a.getName=function(){return"polarNumeric"},a.setAxisDimention=function(){var t,e=this.getScale(),a=this.config,o=a.startAngle||b/2,i=o+(a.totalAngle||b/2),r=a.axisDimention||(a.axisDimention={});r.centerX=a.centerX,r.centerY=a.centerY,r.axisLength=b,t=[o,i],e.setRange(t)},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.trendPoints=void 0,e.ticksBelowGauge=void 0,e.ticksBelowGraph=void 0,e.trendValueDistance=void 0},a.configureAttributes=function(e){var a,o=this.config;t.prototype.configureAttributes.call(this,e),a=o.rawAttr,o.upperLimitDisplay=a.upperLimitDisplay||"",o.lowerLimitDisplay=a.lowerLimitDisplay||"",o.polarPadding=4},a._drawComponents=function(){var t=this.config;t.drawTick&&this._drawTick(),t.drawLabels&&this._drawLabel(),t.drawTrendLines&&this._drawTrendLine()},a.getAngle=function(t){return this.getScale().getRangeValue(t)},a.placeAxis=function(t){var e,a,o,i,r,l,s,c,h,u=this.config,d=this.getFromEnv("chart"),g=d.getFromEnv("smartLabel"),p=u.axisRange,f=u.labels.style,m=p.tickInterval||1,v=u.upperLimitDisplay,b=u.lowerLimitDisplay,k=p.max,C=p.min,x=0,w=d.getFromEnv("number-formatter");if(c={left:0,right:0,top:0,bottom:0},g.useEllipsesOnOverflow(d.config.useEllipsesWhenOverflow),g.setStyle({fontSize:f.fontSize,fontFamily:f.fontFamily,lineHeight:f.lineHeight,fontWeight:f.fontWeight}),this.components||(this.components={},this.components.labels=[]),u.labels.isDraw=1,u.labels.drawNormalVal=1,u.labels.drawLimitVal=1,u.lines.isDraw=1,u.labels.step=u.tickValueStep,u.labelPadding=0,h=t,u.drawLabels&&u.showTickValues&&h>0){for(u.labelPadding+=u.tickValueDistance,h-=u.tickValueDistance,r=w.scale,a=C,o=0;a<=k;a+=m)i=""+r.call(w,(0,n.toPrecision)(a,10)),s=g.getOriSize(i,!0),this.components.labels[o]={config:{width:s.width,height:s.height,props:{label:{attr:{}}}}},o++,i.length>x&&(e=i,x=i.length);if((s=g.getOriSize(e,!0)).width>t/2)return u.labels.isDraw=!1,c;u.showLimits?(v||b)&&((l=g.getOriSize(v,!0)).width>s.width&&(e=v,x=l.width,s=l),(l=g.getOriSize(b,!0)).width>s.width&&(e=b,x=l.width,s=l)):u.labels.drawLimitVal=!1,s=g.getOriSize(e),u.labelMaxW=s.width,u.labelMaxW>t/2&&(u.labelMaxW=t/2),u.labelMaxH=s.height,u.placeValuesInside?u.labelPadding=-u.labelPadding:(c.right+=u.labelMaxW+u.tickValueDistance,c.left+=u.labelMaxW+u.tickValueDistance,c.top+=u.labelMaxH+u.tickValueDistance,c.bottom+=u.labelMaxH+u.tickValueDistance)}else u.labels.isDraw=!1;return c},a._parseLabel=function(){var t,e,a,o,i,r,s,c,h,u,v,b,k,C=this.config,x=this.getFromEnv("chart"),w=C.axisRange,T=this.getScale(),y=x.getFromEnv("smartLabel"),A=C.labels.style,S=C.labelPadding||0,F=C.radius,N=(0,n.pluckNumber)(C.gaugeOuterRadius,F),E=(0,n.pluckNumber)(C.gaugeInnerRadius,F),L=C.centerX,D=C.centerY,M=C.placeValuesInside,R=C.labelMaxH,_=C.labelMaxW,I=w.max,V=w.min,O=C.ticks,P=O.length,G=x.getFromEnv("number-formatter");if(A.lineHeight&&-1!==(u=A.lineHeight).indexOf("px")&&(u=u.replace("px",""),u=parseFloat(u)),y.useEllipsesOnOverflow(x.config.useEllipsesWhenOverflow),y.setStyle({fontSize:A.fontSize,fontFamily:A.fontFamily,lineHeight:A.lineHeight,fontWeight:A.fontWeight}),C.labels.isDraw){for(t=this.components.labels,c=C.labels.step,h=function(a){o=O[a],r=T.getRangeValue(o),(C.labels.drawNormalVal||C.labels.drawLimitVal&&(o===V||o===I))&&(C.labels.drawNormalVal||o===V||o===I)&&(C.labels.drawLimitVal||o!==V&&o!==I)&&(0===C.showZeroPlaneValue&&0===C.showZeroPlane&&0===o||(v=G.scale,o===V&&C.lowerLimitDisplay?(i=y.getSmartText(C.lowerLimitDisplay,_,R),s=i.text):o===I&&C.upperLimitDisplay?(i=y.getSmartText(C.upperLimitDisplay,_,R),s=i.text):s=v.call(G,(0,n.toPrecision)(o,10)),(k=M?(0,l.polarToCartesian)(E+S-C.polarPadding,r):(0,l.polarToCartesian)(N+S+C.polarPadding,r)).x+=L,k.y+=D,b={fill:A.color,"line-height":u,text:s,x:k.x,y:k.y},k.x>L-10&&k.x<L+10&&k.y<D?(b["text-anchor"]=d,b["text-valign"]=M?p:f):k.x>L-10&&k.x<L+10&&k.y<D?(b["text-anchor"]=d,b["text-valign"]=M?f:p):k.x<L?(b["text-anchor"]=M?g:m,b["text-valign"]="center"):(b["text-anchor"]=M?m:g,b["text-valign"]="center"),(e=t[a]=t[a]||{config:{props:{label:{attr:{}}}}}).config.props.label.attr=Object.assign(e.config.props.label.attr,b)))},a=0;a<P;a+=c)h(a);(P-1)%c!=0&&h(P-1)}},a._drawLabel=function(){var t,e,a,o,i,r,n,l,c,h,u=this,d=u.config,g=u.getFromEnv("chart"),p=d.axisRange,f=d.labels.style,m=p.max,v=p.min,b=d.axisLabelContainerTop,k=g.getFromEnv("animationManager"),C={fontFamily:f.fontFamily,fontSize:f.fontSize,fontWeight:f.fontWeight,fontStyle:f.fontStyle,lineHeight:f.lineHeight},x=d.ticks,w=x.length,T=[];if(b.show(),b.css(C),d.labels.isDraw){for(n=d.labels.step,l=function(t){e=x[t],(d.labels.drawNormalVal||d.labels.drawLimitVal&&(e===v||e===m))&&(d.labels.drawNormalVal||e===v||e===m)&&(d.labels.drawLimitVal||e!==v&&e!==m)&&(0===d.showZeroPlaneValue&&0===d.showZeroPlane&&0===e||(T.push(e),h=u.getGraphicalElement(e+"_label"),o=u.components.labels[t].config.props.label.attr,a=k.setAnimation({el:h||"text",attr:o,container:b,component:u,label:"text"}),h||u.addGraphicalElement(e+"_label",a)))},t=0;t<w;t+=n)l(t);(w-1)%n!=0&&l(w-1)}for(r=(0,s["default"])(d.prevIntervalArrLabel,T),e=0,i=r.length;e<i;e++)(c=u.getGraphicalElement(r[e]+"_label"))&&u.removeGraphicalElement(c);d.prevIntervalArrLabel=T},a._drawTick=function(){var t,e,a,o,i,r,c,h,u,d,g,p,f,m,v,b,C,x,w,T=this.config,y=T.drawTick,A=this.getScale(),S=T.drawTickMinor,F=this.getFromEnv("chart").getFromEnv("animationManager"),N=T.radius,E=T.centerX,L=T.centerY,D=(0,n.pluckNumber)(T.gaugeOuterRadius,N),M=(0,n.pluckNumber)(T.gaugeInnerRadius,N),R=T.ticks,_=T.minorTicks;if(g=T.axisAxisLineContainer,i={stroke:T.majorTMColor,"stroke-width":T.majorTMThickness,"stroke-linecap":"round"},o={stroke:T.minorTMColor,"stroke-width":T.minorTMThickness,"stroke-linecap":"round"},g.show(),b=T.prevTickMarks,T.prevTickMarks=[],T.lines.isDraw&&y&&T.showTickMarks){for(T.prevTickMarks=R.slice(),u=0;u<R.length;u++)m=R[u],t=A.getRangeValue(m),T.placeTicksInside?(r=(0,l.polarToCartesian)(M,t),c=(0,l.polarToCartesian)(M+T.majorTMHeight,t)):(r=(0,l.polarToCartesian)(D,t),c=(0,l.polarToCartesian)(D-T.majorTMHeight,t)),r.x+=E,r.y+=L,c.x+=E,c.y+=L,i.path="M"+r.x+" "+r.y+"L"+c.x+" "+c.y,f=Object.assign({},i),v=this.getGraphicalElement(""+R[u]+k),a=F.setAnimation({el:v||"path",attr:f,container:g,component:this,label:"path"}),v||this.addGraphicalElement(""+R[u]+k,a);if(S)for(T.prevTickMarks=T.prevTickMarks.concat(_),u=0;u<_.length;u+=1)d=_[u],e=A.getRangeValue(d),T.placeTicksInside?(r=(0,l.polarToCartesian)(M,e),h=(0,l.polarToCartesian)(M+T.minorTMHeight,e)):(r=(0,l.polarToCartesian)(D,e),h=(0,l.polarToCartesian)(D-T.minorTMHeight,e)),r.x+=E,r.y+=L,h.x+=E,h.y+=L,o.path="M"+r.x+" "+r.y+"L"+h.x+" "+h.y,f=Object.assign({},o),C=this.getGraphicalElement(""+_[u]+k),a=F.setAnimation({el:C||"path",attr:f,container:g,component:this,label:"path"}),C||this.addGraphicalElement(""+_[u]+k,a)}for(u=0,w=(p=(0,s["default"])(b,T.prevTickMarks)).length;u<w;u++)(x=this.getGraphicalElement(""+p[u]+k))&&this.removeGraphicalElement(x)},a._drawTrendLine=function(){var t,e,a,o,i,r,c,h,u,f,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j,U,X,K=this.config,Y=K.axisRange,J=this.getFromEnv("toolTipController"),q=Y.max,Z=this.getScale(),$=Y.min,Q=K.canvas,tt=this.getFromEnv("chart"),et=tt.config,at=tt.getFromEnv("smartLabel"),ot=tt.getFromEnv("color-manager"),it=tt.getFromEnv("animationManager"),rt=K.scaleFactor,nt=K.centerX||0,lt=K.centerY||0,st=Q.canvasWidth||et.canvasWidth,ct=K.trend.trendStyle,ht=K.axisTrendContainerTop,ut=K.axisTrendContainerBottom,dt=K.axisTrendLabelContainer,gt={fontFamily:ct.fontFamily,fontSize:ct.fontSize,lineHeight:ct.lineHeight,fontWeight:ct.fontWeight,fontStyle:ct.fontStyle},pt=tt.getFromEnv("number-formatter"),ft=K.trendPoints,mt=ft&&ft.point,vt=v.PI/180,bt={},kt=mt&&mt.length,Ct={},xt={},wt={},Tt=[];for(at.useEllipsesOnOverflow(et.useEllipsesWhenOverflow),at.setStyle(gt),e=0;e<kt;e+=1)h=ft.point[e],Tt.push(h.startvalue+"_"+h.endvalue+"_"+e);for(e=0,X=(W=(0,s["default"])(K.prevIntervalArrTrendLine,Tt)).length;e<X;e++)z=this.getGraphicalElement(W[e]+"_trendLine"),j=this.getGraphicalElement(W[e]+"_trendLabel"),U=this.getGraphicalElement(W[e]+"_marker"),z&&this.removeGraphicalElement(z),j&&this.removeGraphicalElement(j),U&&this.removeGraphicalElement(U);for(K.prevIntervalArrTrendLine=Tt.slice(),e=0;e<kt;e+=1)H=(h=ft.point[e]).startvalue+"_"+h.endvalue+"_"+e,u=(0,n.pluckNumber)(h.startvalue,h.value),f=(0,n.pluckNumber)(h.endvalue,u),t=Z.getRangeValue(u),c=u!==f,u<=q&&u>=$&&f<=q&&f>=$&&(b={startValue:u,endValue:f,tooltext:(0,n.getValidValue)((0,n.parseUnsafeString)(h.markertooltext,!1)),displayValue:(0,n.getValidValue)((0,n.parseUnsafeString)(h.displayvalue),c?"":pt.scale(u)),showOnTop:(0,n.pluckNumber)(h.showontop,K.ticksBelowGauge,K.ticksBelowGraph,1),color:(0,n.pluck)(h.color,ot.getColor("trendLightColor")),alpha:(0,n.pluckNumber)(h.alpha,99),thickness:(0,n.pluckNumber)(h.thickness,1),dashStyle:h.dashed?(0,n.getDashStyle)(h.dashlen||2,h.dashgap||2):"",useMarker:(0,n.pluckNumber)(h.usemarker,0),markerColor:(0,n.convertColor)((0,n.pluck)(h.markercolor,h.color,ot.getColor("trendLightColor")),100),markerBorderColor:(0,n.convertColor)((0,n.pluck)(h.markerbordercolor,h.bordercolor,ot.getColor("trendDarkColor")),100),markerRadius:(0,n.pluckNumber)((0,n.pluckNumber)(h.markerradius)*rt,5),markerToolText:(0,n.getFirstValue)(h.markertooltext),trendValueDistance:(0,n.pluckNumber)((0,n.pluckNumber)(h.trendvaluedistance,K.trendValueDistance)*rt,K.tickValueDistance),isTrendZone:c,valueInside:(0,n.pluckNumber)(h.valueinside,K.placeValuesInside,0),showBorder:(0,n.pluckNumber)(h.showborder,1),borderColor:(0,n.convertColor)((0,n.pluck)(h.bordercolor,h.color,ot.getColor("trendDarkColor")),(0,n.pluckNumber)(h.borderalpha,h.alpha,100)),radius:(0,n.pluckNumber)((0,n.pluckNumber)(h.radius)*rt),innerRadius:(0,n.pluckNumber)((0,n.pluckNumber)(h.innerradius)*rt)},3,C=-(k=Math.cos(89.99*vt)),x=(0,n.pluckNumber)(b.radius,K.gaugeOuterRadius),w=(0,n.pluckNumber)(b.innerRadius,c?Math.max(K.gaugeInnerRadius-15,0):K.gaugeInnerRadius),T=(0,l.polarToCartesian)(x,t),y=(0,l.polarToCartesian)(w,t),T.x+=nt,T.y+=lt,y.x+=nt,y.y+=lt,A=T.x,S=T.y,F=y.x,N=y.y,E=this.getAngle(f),L=this.getAngle(u),c?(L>E&&(L+=E,L-=E=L-E),Ct={fill:(0,n.convertColor)(b.color,b.alpha),"stroke-width":b.showBorder?b.thickness:0,stroke:b.borderColor,"stroke-dasharray":b.dashStyle,ringpath:[nt,lt,x,w,L,E]}):Ct={"stroke-width":b.showBorder?b.thickness:0,stroke:b.borderColor,"stroke-linecap":"round","stroke-dasharray":b.dashStyle,path:["M",A,S,"L",F,N]},xt=b.useMarker?{fill:b.markerColor,"stroke-width":1,stroke:b.markerBorderColor,polypath:[3,A,S,b.markerRadius,(-L+Math.PI)/vt,0]}:{},""!==b.displayValue?(D=(b.endValue+b.startValue)/2,E=this.getAngle(D),M=Math.cos(E),R=Math.sin(E),_=at.getOriSize(b.displayValue).width,b.valueInside?(I=w-2-b.trendValueDistance,V=M>k?m:M<C?g:d):(I=x+2+b.trendValueDistance,V=M>k?g:M<C?m:d),A=nt+I*M,S=lt+I*R,O=at.getOriSize(b.displayValue).height,bt=at.getSmartText(b.displayValue,st,O),A=st<A+_?st-_-5:A<_?_+5:A,_>st&&(A=st/2),wt={fill:(0,n.convertColor)(h.color,b.alpha)||ct.color,text:bt.text,"text-anchor":V,"vertical-align":p,"text-bound":[ct.backgroundColor,ct.borderColor,ct.borderThickness,ct.borderPadding,ct.borderRadius,ct.borderDash],x:A,y:S},P=bt.height,S+=M>k||M<C?-P/2+.4*P*R*(b.valueInside?-1:1):b.valueInside?-(R<0?0:P):-(R>0?0:P),wt.y=S):wt={text:""},o=this.getGraphicalElement(H+"_trendLine"),i=this.getGraphicalElement(H+"_trendLabel"),B=this.getGraphicalElement(H+"_marker"),(a=c?it.setAnimation({el:o||"ringpath",attr:Ct,container:ut,component:this,label:"ringpath"}):it.setAnimation({el:o||"path",attr:Ct,container:ht,component:this,label:"path"})).show(),a.data("label",c?"ringPath":"path"),(r=it.setAnimation({el:i||"text",attr:wt,container:dt,component:this,label:"text"})).css(gt),r.show(),(G=it.setAnimation({el:B||"polypath",attr:xt,container:ht,component:this,label:"polypath"})).show(),K.showTooltip&&(bt.oriText?J.enableToolTip(r,bt.oriText):J.disableToolTip(r),b.markerToolText?J.enableToolTip(G,b.markerToolText):J.disableToolTip(G)),o||this.addGraphicalElement(H+"_trendLine",a),o||this.addGraphicalElement(H+"_trendLabel",r),B||this.addGraphicalElement(H+"_marker",G))},e}(r["default"]);e["default"]=C},1109:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1066)),r={"initial.axis.polarNumeric":function(){return{"path.appearing":i["default"],"text.appearing":i["default"],"polypath.appearing":i["default"],"ringpath.appearing":i["default"],"*":null}}};e["default"]=r},1110:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=function(t){var e=t.getFromEnv("dataSource"),a=e.pointers||e.dials;a||(e.dials=a={dial:[{value:0}]});(0,i.datasetFactory)(t,r["default"],"dataset",1,[a])};var i=a(224),r=o(a(1111))},1111:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1112)),l=a(232),s=o(a(1114)),c=o(a(332)),h=o(a(1115)),u=(0,l.getDep)("redraphael","plugin"),d=Math,g=d.abs,p=d.atan2,f=d.PI,m=2*f,v=d.max,b=f/180,k=void 0!==window.document.documentElement.ontouchstart,C=function(t){return"string"==typeof t},x=function(t){return null!=t};(0,l.addDep)({name:"angularAnimation",type:"animationRule",extension:s["default"]}),(0,c["default"])(u),(0,h["default"])(u);var w=function(t){function e(){var e;return(e=t.call(this)||this).components=e.components||{},e.config.idMap={},e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"angularGauge"},a.configure=function(t){if(!t)return!1;this.trimData(t),this.config.pointerArr=t;var e,a,o,i,n,l,s,c,h,u,d,g=this.getFromEnv("chart"),p=g.config,f=g.getFromEnv("dataSource"),m=f.chart,v=f.pointers||f.dials,k=v.pointer||v.dial||[],C=this.components.data||(this.components.data=[]),w=this.getFromEnv("scale"),T=this.getFromEnv("color-manager"),y=this.config||(this.config={}),A=(0,r.pluckNumber)(m.gaugescaleangle,180),S=(0,r.pluckNumber)(m.gaugestartangle),F=(0,r.pluckNumber)(m.gaugeendangle),N=x(S),E=r.hasSVG?.001:.01,L=x(F);for(p.displayValueCount=0,h=0,d=k.length;h<d;h+=1)C[h]=C[h]||(C[h]={}),(u=C[h].config||(C[h].config={})).basewidth=k[h].basewidth,u.color=k[h].color,u.alpha=k[h].alpha,u.bgcolor=k[h].bgcolor,u.borderalpha=k[h].borderalpha,u.bordercolor=k[h].bordercolor,u.borderthickness=k[h].borderthickness,u.editmode=k[h].editmode,u.id=(0,r.pluck)(k[h].id,"dial"+h),u.link=k[h].link,u.radius=k[h].radius,u.rearextension=k[h].rearextension,u.showvalue=k[h].showvalue,u.tooltext=k[h].tooltext,u.topwidth=k[h].topwidth,u.value=k[h].value,u.valuex=k[h].valuex,u.valuey=k[h].valuey,u.baseradius=k[h].baseradius,u.displayvalue=k[h].displayvalue,i=y.showValue=(0,r.pluckNumber)(m.showvalue,m.showrealtimevalue,0),n=(0,r.pluckNumber)(u.showvalue,i),u.showPointerValue=n,l=(0,r.pluckNumber)((0,r.getValidValue)(u.valuey)),n&&!x(l)&&(p.displayValueCount+=1);(A>360||A<-360)&&(A=A>0?360:-360),(F>360||F<-360)&&(F%=360),(S>360||S<-360)&&(S%=360),N&&L?((A=S-F)>360||A<-360)&&(F=S-(A%=360)):N?((F=S-A)>360||F<-360)&&(S+=(F%=360)>0?-360:360):L?((S=F+A)>360||S<-360)&&(F+=(S%=360)>0?-360:360):360===A?(S=180,F=-180):-360===A?(S=-180,F=-180):F=(S=90+A/2)-A,360===Math.abs(A)&&(F=S-(A+=A>0?-E:E)),F=360-F,A=-A,((S=360-S)>360||F>360)&&(S-=360,F-=360),y.gaugeStartAngle=S*=b,y.gaugeEndAngle=F*=b,y.gaugeScaleAngle=A*=b,y.upperLimit=(0,r.pluckNumber)(m.upperlimit),y.lowerLimit=(0,r.pluckNumber)(m.lowerlimit),w.setAxisConfig({startAngle:S,totalAngle:-A}),o=(0,r.pluckNumber)(m.scaleonresize,1),y.origW=(0,r.pluckNumber)(m.origw,o?g.config.origRenderWidth:p.width),y.origH=(0,r.pluckNumber)(m.origh,o?g.config.origRenderHeight:p.height),p.showtooltip=(0,r.pluckNumber)(m.showtooltip,1),p.autoScale=(0,r.pluckNumber)(m.autoscale,1),y.rearExtension=(0,r.pluckNumber)(v.rearextension,0),y.gaugeinnerradius=m.gaugeinnerradius,y.valueBelowPivot=(0,r.pluckNumber)(m.valuebelowpivot,0),y.showShadow=(0,r.pluckNumber)(m.showshadow,1),e=(0,r.pluckNumber)(m.showgaugeborder,1),y.gaugeFillMix=(0,r.getFirstDefinedValue)(m.colorrangefillmix,m.gaugefillmix,g.colorRangeFillMix,"{light-10},{light-70},{dark-10}"),y.gaugeFillRatio=(0,r.getFirstDefinedValue)(m.colorrangefillratio,m.gaugefillratio,g.colorRangeFillRatio,m.gaugefillratio),void 0===y.gaugeFillRatio?y.gaugeFillRatio=",6":y.gaugeFillRatio!==r.BLANK&&(y.gaugeFillRatio=r.COMMASTRING+y.gaugeFillRatio),y.gaugeBorderColor=(0,r.pluck)(m.gaugebordercolor,"{dark-20}"),y.gaugeBorderThickness=e?(0,r.pluckNumber)(m.gaugeborderthickness,1):0,y.gaugeBorderAlpha=(0,r.pluckNumber)(m.gaugeborderalpha,100),a=T.parseColorMix((0,r.pluck)(m.pivotfillcolor,m.pivotcolor,m.pivotbgcolor,T.getColor("pivotColor")),(0,r.pluck)(m.pivotfillmix,"{light-10},{light-30},{dark-20}")),y.pivotFillAlpha=T.parseAlphaList((0,r.pluck)(m.pivotfillalpha,r.HUNDREDSTRING),a.length),y.pivotFillRatio=T.parseRatioList((0,r.pluck)(m.pivotfillratio,r.ZEROSTRING),a.length),y.pivotFillColor=a.join(),y.pivotFillAngle=(0,r.pluckNumber)(m.pivotfillangle,0),y.isRadialGradient="radial"===(0,r.pluck)(m.pivotfilltype,"radial").toLowerCase(),y.showPivotBorder=(0,r.pluckNumber)(m.showpivotborder,0),y.pivotBorderThickness=(0,r.pluckNumber)(m.pivotborderthickness,1),y.pivotBorderColor=(0,r.convertColor)((0,r.pluck)(m.pivotbordercolor,T.getColor("pivotBorderColor")),1===y.showPivotBorder?(0,r.pluck)(m.pivotborderalpha,r.HUNDREDSTRING):r.ZEROSTRING),p.dataLabels=p.dataLabels||{},c=(c=(0,r.getFirstValue)(m.valuebordercolor,""))?(0,r.convertColor)(c,(0,r.pluckNumber)(m.valueborderalpha,m.valuealpha,100)):"",s=p.dataLabels.style={fontFamily:(0,r.pluck)(m.valuefont,p.style.inCanfontFamily),fontSize:(0,r.pluck)(this.computeFontSize(m.valuefontsize),parseInt(p.style.inCanfontSize,10))+"px",fontSizeWithUnit:(0,r.pluckFontSizeMaintainUnit)(m.valuefontsize,p.style.inCanfontSizeWithUnit),color:(0,r.convertColor)((0,r.pluck)(m.valuefontcolor,p.style.inCancolor),(0,r.pluckNumber)(m.valuefontalpha,m.valuealpha,100)),fontWeight:(0,r.pluckNumber)(m.valuefontbold)?"bold":"normal",fontStyle:(0,r.pluckNumber)(m.valuefontitalic)?"italic":"normal",border:c||m.valuebgcolor?(0,r.pluckNumber)(m.valueborderthickness,1)+"px solid":void 0,borderColor:c,borderThickness:(0,r.pluckNumber)(m.valueborderthickness,1),borderPadding:(0,r.pluckNumber)(m.valueborderpadding,2),borderRadius:(0,r.pluckNumber)(m.valueborderradius,0),backgroundColor:m.valuebgcolor?(0,r.convertColor)(m.valuebgcolor,(0,r.pluckNumber)(m.valuebgalpha,m.valuealpha,100)):"",borderDash:(0,r.pluckNumber)(m.valueborderdashed,0)?(0,r.getDashStyle)((0,r.pluckNumber)(m.valueborderdashlen,4),(0,r.pluckNumber)(m.valueborderdashgap,2)):r.BLANK},(0,r.setLineHeight)(s)},a.trimData=function(t){var e,a;(e=this.components.data&&this.components.data.length)>(a=t.dial&&t.dial.length||0)&&this.removeData(e-a)},a._drawBackground=function(){var t,e,a,o,i,n,l,s,c,h,u,d,g,p,f,m,b=this.getFromEnv("chart"),k=b.getChildren("canvas")[0],C=this.config,x=this.getFromEnv("scale"),w=this.getFromEnv("color-manager"),T=x.config.axisRange,y=this.getFromEnv("colorRange"),A=b.getChildContainer("plotGroup"),S=b.getChildContainer("defaultShadowGroup"),F=b.getChildContainer("datalabelsGroup"),N=this.getFromEnv("animationManager"),E=C.gaugeOuterRadius,L=C.gaugeInnerRadius,D=C.gaugeFillRatio,M=C.gaugeBorderColor,R=C.gaugeBorderThickness,_=C.gaugeBorderAlpha,I=C.gaugeFillMix,V=C.gaugeOriginX,O=C.gaugeOriginY,P=C.gaugeStartAngle,G=C.showShadow,B=T.min,H=T.max,W=y?y.getColorRangeArr(B,H):[],z=0,j=W.length,U=P,X=this.getContainer("bandGroup"),K=this.getContainer("pointGroup"),Y=0,J=function(){this.hide()},q=function(){this.show()};for(u=N.setAnimation({el:X||"group",attr:{name:"bandGroup"},container:A,component:this,label:"group"}),X||(u=this.addContainer("bandGroup",u)),d=N.setAnimation({el:K||"group",attr:{name:"pointGroup",transform:"t"+V+r.COMMASTRING+O},container:F,component:this,label:"group"}),K||this.addContainer("pointGroup",d);z<j;z+=1)t=W[z],e=x.getAngle(Math.min(t.maxvalue,H)),o=w.parseColorMix(t.code,I),i=w.parseAlphaList(t.alpha,o.length),n=w.parseRatioList(L/E*100+D,o.length),s=t.bordercolor,c=(0,r.pluckNumber)(t.borderAlpha,_),s=s&&-1===s.indexOf("{")?(0,r.convertColor)(s,c):w.parseColorMix(t.code,(0,r.pluck)(s,M))[0],s=(0,r.convertColor)(s,c),l=i.split(r.COMMASTRING),l=v.apply(Math,l),l=G?v(c||0,l):0,a=e,U>e&&(U+=e,U-=e=U-e),t._startAngle=U,t._endAngle=e,f=k.getGraphicalElement("bands")&&k.getGraphicalElement("bands")[z],m=N.setAnimation({el:f||"ringpath",attr:{ringpath:[V,O,E,L,U,e],fill:(0,r.toRaphaelColor)({FCcolor:{cx:V,cy:O,r:E,gradientUnits:"userSpaceOnUse",color:o.join(),alpha:i,ratio:n,radialGradient:!0}}),"stroke-width":R,stroke:s},container:u,callback:q,component:this,label:"plotBackground"}),f||(k.addGraphicalElement("bands",m,!0),m.shadow({apply:G,opacity:l/100})),U=a,Y+=1;for(j=k.getGraphicalElement("bands")&&k.getGraphicalElement("bands").length,z=Y;z<j;z++)(t=W[z]||C.oldColorArr[z])&&N.setAnimation({el:k.getGraphicalElement("bands")[z],attr:{ringpath:[V,O,E,L,t._startAngle,t._startAngle]},component:this,callback:J,label:"plotBackground"});C.oldColorArr=W,h=C.isRadialGradient?{color:C.pivotFillColor,alpha:C.pivotFillAlpha,ratio:C.pivotFillRatio,radialGradient:!0,angle:C.pivotFillAngle,cx:.5,cy:.5,r:"50%"}:{color:C.pivotFillColor,alpha:C.pivotFillAlpha,ratio:C.pivotFillRatio,radialGradient:!1,angle:C.pivotFillAngle},p=this.getGraphicalElement("pivot"),g=N.setAnimation({el:p||"circle",attr:{cx:V,cy:O,r:C.pivotRadius,fill:(0,r.toRaphaelColor)({FCcolor:h}),"stroke-width":C.pivotBorderThickness,stroke:C.pivotBorderColor},container:F,component:this,label:"pivot"}),p||(g=this.addGraphicalElement("pivot",g)).shadow({apply:G},S)},a.removeData=function(t){var e,a=this.getFromEnv("animationManager"),o=function(){this.remove()},i=this.components.data;for(e=0;e<t;e++)i[e].graphics.pointersPath&&a.setAnimation({el:i[e].graphics.pointersPath,attr:{opacity:0},callback:o,component:this}),i[e].graphics.pointersTpath&&a.setAnimation({el:i[e].graphics.pointersTpath,attr:{opacity:0},callback:o,component:this}),i[e].graphics.dataLabel&&a.setAnimation({el:i[e].graphics.dataLabel,attr:{opacity:0},callback:o,component:this});this.removeDataArr||(this.removeDataArr=[]),this.removeDataArr=this.removeDataArr.concat(i.splice(0,t))},a.draw=function(t){this._drawBackground();var e,a,o,i,n,l,s,c,h,d,f,v,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j,U,X,K,Y,J,q,Z,$,Q,tt,et,at,ot,it,rt,nt,lt,st,ct,ht,ut,dt,gt,pt,ft,mt,vt,bt,kt,Ct=this,xt=Ct.getFromEnv("chart"),wt=Ct.getFromEnv("toolTipController"),Tt=Ct.config.idMap,yt=xt.config,At=xt.getFromEnv("dataSource").chart,St=Ct.components.data,Ft=Ct.config,Nt=Ft,Et=Ct.getFromEnv("number-formatter"),Lt=Ct.getFromEnv("color-manager"),Dt=Ct.getFromEnv("scale"),Mt=Ct.getFromEnv("animationManager"),Rt=Number(Ft.gaugeOriginX),_t=Number(Ft.gaugeOriginY),It=Ft.gaugeStartAngle,Vt=Ft.gaugeEndAngle,Ot=Ft.showShadow,Pt=yt.showtooltip,Gt=Dt.config.axisRange,Bt=Gt.min,Ht=Gt.max,Wt=Ct.getContainer("pointGroup"),zt=Ct.getLinkedParent().getChildContainer("datalabelsGroup"),jt=Ht-Bt||1,Ut=Vt-It,Xt=jt/Ut,Kt=At.plottooltext,Yt=(0,r.pluckNumber)(At.showhovereffect),Jt=Ct.showValue=(0,r.pluckNumber)(At.showvalue,At.showrealtimevalue,0),qt=0,Zt=yt.dataLabels.style,$t={fontFamily:Zt.fontFamily,fontSize:this.computeFontSize(Zt.fontSizeWithUnit),lineHeight:Zt.lineHeight,fontWeight:Zt.fontWeight,fontStyle:Zt.fontStyle},Qt=yt.scaleFactor,te=(0,r.pluckNumber)(parseInt(Zt.lineHeight,10),12),ee=Ft.valueBelowPivot,ae=0,oe=St&&St.length,ie={pageX:0,pageY:0},re=function(t,e,a){var o,i,n,l=this,s=this._Attr,c=u.vml?-1.5:0,h=u.vml?-1.5:0,d=t;if(s||(s=l._Attr={}),C(d)&&x(e)&&(o=d,(d={})[o]=e),C(d)||void 0===d)l="angle"===d?l._Attr[d]:l._attr(d);else for(o in d)i=d[o],"angle"===o?(s[o]=i,n=i*b,s.tooltipPos[0]=s.cx+s.toolTipRadius*Math.cos(n),s.tooltipPos[1]=s.cy+s.toolTipRadius*Math.sin(n),s.prevValue=i,a&&a.duration?l.animate({transform:"R"+i+r.COMMASTRING+c+r.COMMASTRING+h},a.duration,"linear"):l.attr({transform:"R"+i+r.COMMASTRING+c+r.COMMASTRING+h})):l._attr(o,i);return l},ne=function(t,e,a,o){return p(e-a[1]-o.top,t-a[0]-o.left)},le=function(t){var e=St[this.pos].config||{},a=t.data[0],o=t.data[1];e.editMode&&(Rt=Number(Ft.gaugeOriginX),_t=Number(Ft.gaugeOriginY),A=(0,r.getPosition)(xt.getFromEnv("chart-container")),yt.rotationStartAngle=ne(a,o,[Rt,_t],A),e.dragStartY=e.value,y=xt._getDataJSON())},se=function(){var t,e=St[this.pos],a=e.config,o=xt.getFromEnv("chartInstance");if(e.config.editMode){(t=o&&o.jsVars)&&(t._rtLastUpdatedData=xt._getDataJSON()),xt.fireChartInstanceEvent("RealTimeUpdateComplete",{data:"&value="+a.updatedValStr,updateObject:{values:[a.updatedValStr]},prevData:y.values,source:"editMode",url:null});try{window.FC_ChartUpdated&&window.FC_ChartUpdated(o.id)}catch(i){setTimeout((function(){throw i}),1)}}},ce=function(t){var e,a,o,i,n,l,s,c,h,u=St[this.pos],d=k&&function(t){return k&&t.sourceEvent&&t.sourceEvent.touches&&t.sourceEvent.touches[0]||t}(t)||ie,p=Dt.config.axisRange,f=t.data[2],v=t.data[3];if(u.config.editMode){for(yt.fromDrag=!0,Rt=Number(Ft.gaugeOriginX),_t=Number(Ft.gaugeOriginY),Bt=p.min,Ht=p.max,It=Ft.gaugeStartAngle,Vt=Ft.gaugeEndAngle,Xt=(jt=Ht-Bt)/(Ut=Vt-It),e=ne(f,v,[Rt,_t],A),o=(a=yt.rotationStartAngle-e)<0?m+a:a-m,i=u.config.dragStartY-a*Xt,n=u.config.dragStartY-o*Xt,(i<Bt||i>Ht)&&n>=Bt&&n<=Ht&&(i=n),i<Bt?i=g(n-Ht)<g(i-Bt)?Ht:Bt:i>Ht&&(i=g(i-Ht)<g(n-Bt)?Ht:Bt),u.config.updatedValStr=i+r.BLANK,l=[],c=[],s=0,h=u.config.index;s<h;s+=1)l.push(r.BLANK),c.push(r.BLANK);l.push({value:i,animation:{duration:0,transposeAnimDuration:0,initAnimDuration:0}}),c.push(i),u.config.y!==i&&Ct.updateData({data:l})&&(u.config.updatedValStr=c.join("|"),u.config.dragStartX=Rt||t.pageX||d.pageX)}},he=Ct.getFromEnv("smartLabel"),ue=u.vml?-1.5:0,de=u.vml?-1.5:0;for(Zt.fontSize=this.computeFontSize(Zt.fontSizeWithUnit),(0,r.setLineHeight)(Zt),nt=lt=Ft.pivotRadius,void 0===Nt.dataById&&(Nt.dataById={}),t&&0===t.duration&&xt.getFromEnv("animationManager").setAnimationState("dialDrag"),V=function(t){yt.fromDrag?yt.fromDrag=!1:xt.plotEventHandler(this,t)},oe||(oe=0),he.setStyle($t),0!==Yt&&(Yt||At.dialborderhovercolor||At.dialborderhoveralpha||0===At.dialborderhoveralpha||At.dialborderhoverthickness||0===At.dialborderhoverthickness||At.dialbghovercolor||At.plotfillhovercolor||At.dialbghoveralpha||At.plotfillhoveralpha||0===At.dialbghoveralpha)&&(Yt=1),pt=function(t){var e,a=this.data("rolloverProperties");xt.plotEventHandler(this,t,"DataPlotRollOver"),a.enabled&&(e=this.attr("transform"),this.attr("transform",r.BLANK),this.attr(a.hoverAttr),this.attr("transform",e))},ft=function(t){var e,a=this.data("rolloverProperties");xt.plotEventHandler(this,t,"DataPlotRollOut"),a.enabled&&(e=this.attr("transform"),this.attr("transform",r.BLANK),this.attr(a.outAttr),this.attr("transform",e))};qt<oe;qt+=1)(n=St[qt]).config=n.config||{},O=n.config,n.config.index=qt,Tt[O.id]={index:qt,config:n.config},kt=!1,void 0!==O.id&&(Nt.dataById[O.id]={index:qt,point:n}),bt=St[qt].graphics||(St[qt].graphics={}),P=Et.getCleanValue(O.value),P=Number((0,r.toPrecision)(P,10)),d=(0,r.pluckNumber)(O.rearextension,0)*Qt,nt=Math.max(nt,d*Qt),G=Et.dataLabels(P),B=(0,r.getValidValue)(O.displayvalue,G,""),z=(0,r.pluckNumber)(O.showvalue,Jt),j=(0,r.pluckNumber)((0,r.getValidValue)(O.valuey)*Qt),st=(0,r.pluckNumber)((0,r.getValidValue)(O.valuex)*Qt),O.itemValue=P,O.formatedVal=G,U=(U=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(O.tooltext,n.hovertext,Kt),!1)))?(0,r.parseTooltext)(U,[1,2],{formattedValue:G},n.config,At):B,X=(0,r.pluck)(O.color,O.bgcolor,Lt.getColor("dialColor")),K=(0,r.pluckNumber)(O.alpha,n.bgalpha,100),Y=(0,r.toRaphaelColor)({FCcolor:{color:X,alpha:K,angle:90}}),J=(0,r.pluck)(O.bordercolor,Lt.getColor("dialBorderColor")),q=(0,r.pluckNumber)(O.borderalpha,100),Z=(0,r.convertColor)(J,q),$=(0,r.pluckNumber)(O.borderthickness,1),l=(0,r.pluckNumber)(O.radius)*Qt,s=(0,r.pluckNumber)((0,r.pluckNumber)(O.basewidth*Qt,1.6*lt)),c=(0,r.pluckNumber)(O.topwidth,0)*Qt,h=(0,r.pluckNumber)(O.baseradius,0),e=(0,r.pluckNumber)(O.editmode,At.editmode,0),(0,r.pluck)(O.link,""),ct=U,O.toolText=ct,ht=(0,r.pluck)(B,""),B=z?(0,r.pluck)(B,r.BLANK):"",0!==(Q=(0,r.pluckNumber)(n.showhovereffect,Yt))&&(Q||n.borderhovercolor||n.borderhoveralpha||0===n.borderhoveralpha||n.borderhoverthickness||0===n.borderhoverthickness||n.bghovercolor||n.bghoveralpha||0===n.bghoveralpha)&&(Q=!0,i={},o={},tt=(0,r.pluck)(n.borderhovercolor,At.dialborderhovercolor,"{dark-10}"),et=(0,r.pluckNumber)(n.borderhoveralpha,At.dialborderhoveralpha,q),(at=(0,r.pluckNumber)(n.borderhoverthickness,At.dialborderhoverthickness,$))&&(i.stroke=Z,ot=/\{/.test(tt),o.stroke=(0,r.convertColor)(ot?Lt.parseColorMix(J,tt)[0]:tt,et)),at!==$&&(o["stroke-width"]=at,i["stroke-width"]=$),it=(0,r.pluck)(n.bghovercolor,At.dialbghovercolor,At.plotfillhovercolor,"{dark-10}"),rt=(0,r.pluckNumber)(n.bghoveralpha,At.dialbghoveralpha,At.plotfillhoveralpha,K),i.fill=Y,a={FCcolor:{color:it=/\{/.test(it)?Lt.parseColorMix(X,it).join():it,alpha:rt,angle:90}},o.fill=(0,r.toRaphaelColor)(a)),N=O.rolloverProperties={enabled:Q,hasHoverSizeChange:void 0,hoverRadius:(0,r.pluckNumber)(L*Qt),baseHoverWidth:(0,r.pluckNumber)(D*Qt,1.6*lt),topHoverWidth:(0,r.pluckNumber)(R*Qt),rearHoverExtension:(0,r.pluckNumber)(I*Qt),hoverFill:a,hoverAttr:o,outAttr:i},l=(0,r.pluckNumber)(l,(Number(Ft.gaugeOuterRadius)+Number(Ft.gaugeInnerRadius))/2),f=s/2,v=c/2,O.tooltipPos=[Rt,_t],S=O.editMode?void 0:O.link,E=["M",l,-v,"L",l,v,-d,f,-d,-f,"Z"],N.hasHoverSizeChange&&(N.outAttr.path=E,L=(0,r.pluckNumber)(N.hoverRadius,l),M=(D=N.baseHoverWidth)/2,_=(R=N.topHoverWidth)/2,I=N.rearHoverExtension,N.hoverAttr.path=["M",L,-_,"L",L,_,-I,M,-I,-M,"Z"]),F={link:O.link,value:P,displayValue:ht,toolText:ct,baseWidth:O.basewidth,bgColor:O.bgcolor,borderAlpha:O.borderalpha,borderColor:O.bordercolor,borderThickness:O.borderthickness,editMode:O.editmode,id:O.id,radius:O.radius,rearExtension:O.rearextension,showValue:O.showPointerValue,topWidth:O.topwidth,valueX:O.valuex,valueY:O.valuey,baseRadius:O.baseradius},P>=Bt&&P<=Ht&&(w=(It+(P-Bt)/jt*Ut)/b),bt.pointersTpath?c?(Mt.setAnimation({el:bt.pointersPath,attr:{path:E,transform:"R"+w+r.COMMASTRING+ue+r.COMMASTRING+de},component:Ct,label:"dialPath"}),bt.pointersTpath._attr({trianglepath:[0,0,0,0,0,0,0,0,0]})):(Mt.setAnimation({el:bt.pointersTpath,attr:{trianglepath:[l,v,-d,f,-d,-f,0,h,h],transform:"R"+w+r.COMMASTRING+ue+r.COMMASTRING+de},component:Ct,label:"trianglepath"}),bt.pointersPath._attr({path:"M0,0"})):(c?(vt=E,mt=[0,0,0,0,0,0,0,0,0]):(vt=["M",0,0],mt=[l,v,-d,f,-d,-f,0,h,h]),bt.pointersPath=Mt.setAnimation({el:"path",attr:{path:vt,transform:"R"+w+r.COMMASTRING+ue+r.COMMASTRING+de},container:Wt,component:Ct,label:"dialPath"}),bt.pointersTpath=Mt.setAnimation({el:"trianglepath",attr:{trianglepath:mt,transform:"R"+w+r.COMMASTRING+ue+r.COMMASTRING+de},container:Wt,component:Ct,label:"dialPath"}),T=c?bt.pointersPath:bt.pointersTpath,(s||c||$)&&T.shadow({apply:Ot}),kt=!0),T=c?bt.pointersPath:bt.pointersTpath,bt.pointersPath._attr||(bt.pointersPath._attr=bt.pointersPath.attr,bt.pointersPath.attr=re),bt.pointersTpath._attr||(bt.pointersTpath._attr=bt.pointersTpath.attr,bt.pointersTpath.attr=re),T._attr({fill:Y,stroke:Z,"stroke-width":$}).data("eventArgs",F).data("rolloverProperties",N),T._Attr={tooltipPos:O.tooltipPos,cx:Rt,cy:_t,toolTipRadius:l-d,color:O.color},kt&&(w=It/b,T.hover(pt,ft)),O.index=qt,O.editMode=e,T.css({cursor:e||S?"pointer":"default",_cursor:e?"hand":"default"}),bt.pointersPath.pos=qt,bt.pointersTpath.pos=qt,kt&&(bt.pointersPath.on("fc-dragstart",le),bt.pointersPath.on("fc-dragmove",ce),bt.pointersPath.on("fc-dragend",se),bt.pointersTpath.on("fc-dragstart",le),bt.pointersTpath.on("fc-dragmove",ce),bt.pointersTpath.on("fc-dragend",se),bt.pointersPath.on("fc-click",V),bt.pointersTpath.on("fc-click",V)),O.y=P,Pt&&ct!==r.BLANK?wt.enableToolTip(T,ct):wt.disableToolTip(T),x(B)&&B!==r.BLANK?(ut=_t+(ee?te/2+lt+2:-te/2-lt-2),dt=j,gt=(0,r.pluckNumber)(st,Rt),x(dt)||(dt=ee?ut+te*ae:ut-te*ae),B=(H=he.getSmartText(B)).text,W=H.tooltext||"",bt.dataLabel=Mt.setAnimation({el:bt.dataLabel||"text",attr:{x:gt,y:dt,direction:yt.textDirection,text:B,title:n.originalText||r.BLANK,fill:Zt.color,"text-bound":[Zt.backgroundColor,Zt.borderColor,Zt.borderThickness,Zt.borderPadding,Zt.borderRadius,Zt.borderDash]},css:$t,container:zt,component:Ct,label:"text"}),bt.dataLabel.show(),ae+=1,Pt?wt.enableToolTip(bt.dataLabel,W):wt.disableToolTip(bt.dataLabel)):(bt.dataLabel&&bt.dataLabel.hide(),bt.dataLabel&&wt.disableToolTip(bt.dataLabel))},a.updateData=function(t){var e,a,o,i,n,l,s,c,h,u,d,g,p,f,m={},v=t;if(v===this.config.lastUpdatedObj)return!1;for(this,e=this.getFromEnv("chart"),a=this.components.data,s=(l=this.components.data)&&l.length||0,d=(v=v.data).length,c=0;c<d;c++)(h=v[c].id)&&(m[h]=v[c]);if(u=Object.keys(m).length,s){for(;s--;)h=(o=a[s].config).id,g=void 0,g=u?m[h]:v[s],g&&(p=g.animation||e.get("config","animationObj"),f=g.value,n=g.tooltext,i=g.label,o.value=(0,r.pluckNumber)(f,o.value,0),o.tooltext=(0,r.pluck)(n,o.value),o.displayvalue=i);return this.config.lastUpdatedObj=v,this.draw(p),!0}},e}(n["default"]);e["default"]=w},1112:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(484)),l=o(a(483)),s=a(232),c=a(240),h=o(a(1113)),u=r.BLANK,d=r.preDefStr.configStr,g=r.preDefStr.animationObjStr,p=r.preDefStr.POSITION_TOP,f=r.preDefStr.POSITION_BOTTOM,m=r.preDefStr.POSITION_MIDDLE,v=r.preDefStr.POSITION_START,b=r.preDefStr.POSITION_END,k=window,C=void 0!==k.document.documentElement.ontouchstart,x=Math,w=x.max,T=x.min,y={right:b,left:v,middle:m,start:v,end:b,center:m,undefined:r.BLANK,BLANK:r.BLANK};(0,s.addDep)({name:"hlineargaugeAnimation",type:"animationRule",extension:h["default"]});var A=function(t){function e(){var e;return(e=t.call(this)||this).config.idMap={},e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"hlineargauge"},a._drawBackground=function(){var t,e,a,o,i,n,l,s,c,h,u,d,g,m,v,b,k,C,x,T,y,A,S,F,N,E=this.getFromEnv("chart"),L=E.getFromEnv(),D=E.config,M=E.getChildContainer().plotGroup,R=E.getFromEnv("toolTipController"),_=D.canvasWidth,I=D.canvasHeight,V=D.canvasTop,O=D.canvasLeft,P=L.scale,G=this.config.isScaleReversed,B=P.config.axisRange.min,H=P.config.axisRange.max,W=E.getFromEnv("dataSource"),z=W.chart,j=W.trendpoints&&W.trendpoints.point,U=(0,r.pluckNumber)(z.showgaugeborder,1),X=(0,r.getFirstDefinedValue)(z.colorrangefillmix,z.gaugefillmix,"{light-10},{dark-20},{light-50},{light-85}"),K=(0,r.getFirstDefinedValue)(z.colorrangefillratio,z.gaugefillratio,z.gaugefillratio,"0,8,84,8"),Y=(0,r.pluck)(z.colorrangebordercolor,z.gaugebordercolor,"{dark-20}"),J=(0,r.pluckNumber)(z.colorrangeborderalpha,z.gaugeborderalpha,100),q=U?(0,r.pluckNumber)(z.colorrangeborderthickness,z.gaugeborderthickness,1):0,Z=W.colorrange&&L.colorRange&&L.colorRange.getColorRangeArr(B,H),$=(0,r.pluckNumber)(z.showshadow,1),Q=E.getChildren("canvas")[0],tt=Q.getGraphicalElement("linear"),et=Q.getGraphicalElement("outerRect"),at=L.animationManager,ot=L["color-manager"],it={top:1,bottom:3},rt=0,nt=0,lt=0;for(at.setAnimation({el:M,state:"initial",attr:{transform:["T",O,V]},component:this,container:E.getContainer("parentgroup"),label:"parentgroup"}),tt=at.setAnimation({el:tt||"group",attr:{name:"colorrange"},component:this,container:M,label:"background"}),et=at.setAnimation({el:et||"rect",attr:{x:0,y:0,width:_,height:I,stroke:"none",r:0},component:this,container:M}),Q.getGraphicalElement("linear")||(tt=Q.addGraphicalElement("linear",tt),Q.addGraphicalElement("outerRect",et)),n=function(t,e){return F=(e-t)*_/(H-B),{x:G?_-F-t*_/(H-B):t*_/(H-B),y:0,width:F,height:I}},l=270,t=0,a=Z&&Z.length;t<a;t+=1)u=n((c=G?Z[a-1-t]:Z[t]).minvalue-B,c.maxvalue-B),c.x=u.x,c.y=u.y,c.width=u.width,c.height=u.height,s=c.code,h=(0,r.convertColor)((0,r.getColorCodeString)((0,r.pluck)(c.bordercolor,s),Y),(0,r.pluckNumber)(c.borderalpha,J)),C=ot.parseColorMix(c.code,X),x=ot.parseAlphaList(c.alpha,C.length),T=(0,r.pluckNumber)(c.borderAlpha,J),y=x.split(r.COMMASTRING),y=w.apply(Math,y),y=w(q&&T||0,y),N={x:u.x,y:u.y,width:u.width,height:u.height,r:0,"stroke-width":q,stroke:h,fill:(0,r.toRaphaelColor)({FCcolor:{color:C.toString(),ratio:K,alpha:x,angle:l}})},S=Q.getGraphicalElement("colorRangeElems")&&Q.getGraphicalElement("colorRangeElems")[t],S=at.setAnimation({el:S||"rect",attr:N,component:this,container:tt}),Q.getGraphicalElement("colorRangeElems")&&Q.getGraphicalElement("colorRangeElems")[t]||(S=Q.addGraphicalElement("colorRangeElems",S,!0,t)).shadow({apply:$,opacity:y/100}),S.show();if(!u&&Q.getGraphicalElement("colorRangeElems")&&Q.getGraphicalElement("colorRangeElems").length>0&&(u=Q.getGraphicalElement("colorRangeElems")[Q.getGraphicalElement("colorRangeElems").length-1].attr()),Q.getGraphicalElement("colorRangeElems"))for(;Q.getGraphicalElement("colorRangeElems")[t];)Q.getGraphicalElement("colorRangeElems")[t].shadow(!1),Q.getGraphicalElement("colorRangeElems")[t].hide(),t++;if(j)for(t=0,a=(d=D.trendPointConfig).length;t<a;t+=1)u=n((k=d[t]).startValue-B,k.endValue-B),k.isTrendZone?(g=Q.getGraphicalElement("trendZoneElems")&&Q.getGraphicalElement("trendZoneElems")[rt],g=at.setAnimation({el:g||"rect",attr:{x:u.x,y:u.y,width:u.width>0?u.width:0,height:u.height>0?u.height:0,r:0,"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:k.color,alpha:k.alpha}})},component:this,container:tt,label:"final"}),Q.getGraphicalElement("trendZoneElems")&&Q.getGraphicalElement("trendZoneElems")[rt]||(g=Q.addGraphicalElement("trendZoneElems",g,!0,rt)),g.show(),R.enableToolTip(g,k.tooltext),rt++):(v=Q.getGraphicalElement("trendObjElems")&&Q.getGraphicalElement("trendObjElems")[nt],g=at.setAnimation({el:v||"path",attr:{stroke:(0,r.convertColor)(k.color,k.alpha),"stroke-dasharray":k.dashStyle,"stroke-width":k.thickness,path:["M",u.x,u.y,"L",u.x,u.y+u.height]},component:this,container:tt,label:"final"}),v||(v=Q.addGraphicalElement("trendObjElems",g,!0,nt)),v.show(),R.enableToolTip(v,k.tooltext),nt++),k.useMarker&&(k.showOnTop?(i=f,e=0):(i=p,e=I),A=90*it[i],o=Q.getGraphicalElement("marker")&&Q.getGraphicalElement("marker")[lt],o=at.setAnimation({el:o||"polypath",attr:{fill:k.markerColor,stroke:k.markerBorderColor,polypath:[3,u.x,e,k.markerRadius,A,0],"stroke-width":1},component:this,container:tt,label:"final"}),Q.getGraphicalElement("marker")&&Q.getGraphicalElement("marker")[lt]||(o=Q.addGraphicalElement("marker",o,!0,lt)).shadow({apply:$}),R.enableToolTip(o,k.tooltext),o.show(),lt++);if(b=Q.getGraphicalElement("trendObjElems"))for(;b[nt];)b[nt].hide(),nt++;if(m=Q.getGraphicalElement("trendZoneElems"))for(;m[rt];)m[rt].hide(),rt++;if(o=Q.getGraphicalElement("marker"))for(;o[lt];)o[lt].hide(),o[lt].shadow(!1),lt++},a.configureAttributes=function(t){this.trimData(t),this.config.pointerArr=t;var e,a,o,i,n,l,s,c,h,d,g,m,v,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j,U,X=this.getFromEnv("chart"),K=X.getFromEnv("dataSource"),Y=K.chart,J=this.getFromEnv("number-formatter"),q=this.getFromEnv("color-manager"),Z=this.getFromEnv("scale"),$=Y.plottooltext,Q=this.config||(this.config={}),tt=this.components||(this.components={}),et=K.pointers&&K.pointers.pointer,at=et&&et.length||0,ot=X.config.style;for(Q.isScaleReversed=Z.config.isReverse,Q.valuePadding=(0,r.pluckNumber)(Y.valuepadding,2),Q.tooltipSepChar=(0,r.pluck)(Y.tooltipsepchar,r.COMMASTRING),H=(0,r.pluckNumber)(Y.ticksbelowgauge,Y.ticksbelowgraph,1),Q.axisPosition=H?3:1,Q.pointerOnOpp=m=Number(!(0,r.pluckNumber)(Y.pointerontop,H,1)),Q.valueabovepointer=C=(0,r.pluckNumber)(Y.valueabovepointer,!m,1),Q.valueInsideGauge=C===m?1:0,Q.showPointerShadow=(0,r.pluckNumber)(Y.showpointershadow,Y.showshadow,1),Q.showTooltip=(0,r.pluckNumber)(Y.showtooltip,1),Q.textDirection="1"===Y.hasrtltext?"rtl":r.BLANK,Q.showGaugeLabels=(0,r.pluckNumber)(Y.showgaugelabels,1),Q.colorRangeStyle={fontFamily:ot.inCanfontFamily,fontSize:ot.inCanfontSize,lineHeight:ot.inCanLineHeight,color:ot.inCancolor.replace(/^#?/,"#")},Q.showTextOutline=(0,r.pluckNumber)(Y.textoutline,0),Q.showValue=(0,r.pluckNumber)(Y.showvalue,1),Q.editMode=(0,r.pluckNumber)(Y.editmode,0),Q.pointerSides=W=(0,r.pluckNumber)(Y.pointersides,3),Q.pointerBorderThickness=j=(0,r.pluckNumber)(Y.pointerborderthickness),Q.showHoverEffect=z=(0,r.pluckNumber)(Y.showhovereffect,Y.plothovereffect),Q.upperLimit=(0,r.pluckNumber)(Y.upperlimit),Q.lowerLimit=(0,r.pluckNumber)(Y.lowerlimit),g=m?p:f,Q.startAngle=90*{top:1,right:0,left:2,bottom:3}[g],d=tt.data||(tt.data=[]),n=0;n<at;n++)o=(a=d[n]||(tt.data[n]={})).config||(a.config={}),e=et&&et[n]||{},o.value=e.value,o.itemValue=i=J.getCleanValue(e.value),o.formatedVal=s=J.dataLabels(i),o.setDisplayValue=c=(0,r.getValidValue)((0,r.parseUnsafeString)(e.displayvalue)),o.setToolText=l=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(e.tooltext,$),!1)),o.id=(0,r.pluck)(e.id,"pointer_"+n),o.showHoverEffect=D=(0,r.pluckNumber)(e.showhovereffect,z),o.showBorder=G=(0,r.pluckNumber)(e.showborder,Y.showplotborder,1),o.borderWidth=L=G?(0,r.pluckNumber)(e.borderthickness,j):0,o.showValue=U=(0,r.pluckNumber)(e.showvalue,Q.showValue),o.dataLabelStyle=this._configureDataLabelStyle(e,K.pointers),U?void 0!==c?(o.displayValue=c,o.isLabelString=!0):o.displayValue=(0,r.getValidValue)(s,r.BLANK):o.displayValue=u,o.sides=h=(0,r.pluckNumber)(e.sides,W),h<3&&(o.sides=3),o.radius=w=(0,r.pluckNumber)(e.radius,Y.pointerradius,10),void 0!==l?(o.toolText=(0,r.parseTooltext)(l,[1,2],{formattedValue:s},e,Y),o.isTooltextString=!0):o.toolText=null!==s&&s,o.tempToolText=o.toolText,o.bgAlpha=k=(0,r.pluckNumber)(e.alpha,e.bgalpha,Y.pointerbgalpha,100),o.bgColor=x=(0,r.pluck)(e.color,e.bgcolor,Y.pointerbgcolor,Y.pointercolor,q.getColor("pointerBgColor")),o.fillColor=B=(0,r.convertColor)(x,k),o.showBorder=(0,r.pluckNumber)(e.showborder,Y.showplotborder,1),o.borderAlpha=b=(0,r.pluckNumber)(e.borderalpha,Y.pointerborderalpha,100),o.borderColor=v=(0,r.pluck)(e.bordercolor,Y.pointerbordercolor,q.getColor("pointerBorderColor")),o.pointerBorderColor=T=(0,r.convertColor)(v,b),o.dataLink=(0,r.getValidValue)(e.link),o.editMode=(0,r.pluckNumber)(e.editmode,Q.editMode),0!==D&&(D||e.bghovercolor||Y.pointerbghovercolor||Y.plotfillhovercolor||e.bghoveralpha||Y.pointerbghoveralpha||Y.plotfillhoveralpha||0===e.bghoveralpha||0===Y.pointerbghoveralpha||e.showborderonhover||Y.showborderonhover||0===e.showborderonhover||0===Y.showborderonhover||e.borderhoverthickness||Y.pointerborderhoverthickness||0===e.borderhoverthickness||0===Y.pointerborderhoverthickness||e.borderhovercolor||Y.pointerborderhovercolor||e.borderhoveralpha||Y.pointerborderhoveralpha||0===e.borderhoveralpha||0===Y.pointerborderhoveralpha||e.hoverradius||Y.pointerhoverradius||0===e.hoverradius||0===Y.pointerhoverradius)&&(D=!0,S=(0,r.pluck)(e.bghovercolor,Y.pointerbghovercolor,Y.plotfillhovercolor,"{dark-10}"),A=(0,r.pluckNumber)(e.bghoveralpha,Y.pointerbghoveralpha,Y.plotfillhoveralpha),void 0===(R=(0,r.pluckNumber)(e.showborderonhover,Y.showborderonhover))&&(R=e.borderhoverthickness||0===e.borderhoverthickness||e.borderhovercolor||e.borderhoveralpha||0===e.borderhoveralpha?1:G),F=(0,r.pluck)(e.borderhovercolor,Y.pointerborderhovercolor,"{dark-10}"),y=(0,r.pluckNumber)(e.borderhoveralpha,Y.pointerborderhoveralpha),N=R?(0,r.pluckNumber)(e.borderhoverthickness,Y.pointerborderhoverthickness,L||1):0,E=(0,r.pluckNumber)(e.hoverradius,Y.pointerhoverradius,w+2),_=!!(0,r.pluckNumber)(e.showhoveranimation,Y.showhoveranimation,1),o.hoverAttr=M={},o.outAttr=I={},L!==N&&(M["stroke-width"]=N,I["stroke-width"]=L),I.fill=B,S=/\{/.test(S)?q.parseColorMix(x,S)[0]:S,M.fill=(0,r.convertColor)(S,(0,r.pluckNumber)(A,k)),N&&(I.stroke=T,V=/\{/.test(F),M.stroke=(0,r.convertColor)(V?q.parseColorMix(v,F)[0]:F,(0,r.pluckNumber)(y,b))),E&&(_?(O={r:E},P={r:w}):(M.r=E,I.r=w))),o.rolloverProperties={enabled:D,hoverAttr:M,hoverAnimAttr:O,outAttr:I,outAnimAttr:P}},a.trimData=function(t){var e,a;(e=this.config.pointerArr&&this.config.pointerArr.pointer&&this.config.pointerArr.pointer.length)>(a=t&&t.pointer&&t.pointer.length||0)&&this.removeData(e-a)},a._manageSpace=function(t){var e,a,o,i,n,l,s,c=this.getFromEnv("chart"),h=this.components,d=c.config,g=this.config,p=this.getFromEnv("smartLabel"),f=d.canvasWidth,m=d.dataLabelStyle,v=d.style.trendStyle,b=c.getFromEnv("dataSource"),k=b.trendpoints&&b.trendpoints.point,C=(0,r.pluckNumber)(parseInt(m.lineHeight,10),12),x=t,w=g.valuePadding,T=g.valueInsideGauge,y=0,A=0,S=0,F=0,N=0,E=0,L=0,D=this.getFromEnv("scale").config.spaceTaken,M=0,R=this.config.pointerArr&&this.config.pointerArr.pointer&&this.config.pointerArr.pointer.length,_=g.pointerOnOpp,I=h.data;for(k&&c._configueTrendPoints(),p.useEllipsesOnOverflow(d.useEllipsesWhenOverflow),p.setStyle(m);M<R;M+=1)o=w+(s=I[M].config).radius*(s.sides<=3?.5:s.sides%2?1.1-1/s.sides:1),F=Math.max(F,o),s.showValue&&s.displayValue!==u&&(s.isLabelString?(e=p.getSmartText(s.displayValue,f,x-F),s.displayValue=e.text,e.tooltext&&(s.originalText=e.tooltext)):e=p.getOriSize(s.displayValue),s.displayValue===r.BLANK&&(e={height:C})),(y=e&&e.height>0&&!T?e.height+o:o)>x&&(o=(a=y-x)<o?o-a:0,y=x),_?(3===g.axisPosition&&(E=Math.max(D.bottom,E),y=Math.max(D.bottom,y)),A=Math.max(A,y)):(1===g.axisPosition&&(L=Math.max(D.top,L),y=Math.max(D.top,y)),S=Math.max(y,S)),g.align=r.POSITION_CENTER;if(g.currentValuePadding=F,p.setStyle(v),k){for(M=0,R=(i=d.trendPointConfig).length;M<R;M+=1)(n=i[M])&&n.displayValue!==u&&(l=w+.5*n.markerRadius,N=Math.max(l,N),(e=p.getOriSize(n.displayValue)).height>0&&(y=e.height+l),y>x&&(l=(a=y-x)<l?l-a:0,y=x),n.showOnTop?(1===g.axisPosition&&(L=Math.max(D.top,L),y=Math.max(D.top,y)),S=Math.max(S,y)):(3===g.axisPosition&&(E=Math.max(D.bottom,E),y=Math.max(D.bottom,y)),A=Math.max(y,A)));g.currentTrendPadding=N}return{top:S-L,bottom:A-E}},a.draw=function(t,e){var a,o,i,n,l,s,c,h,u,d,g,p,f,m=this,v=m.config.idMap,b=m.getFromEnv("chart"),x=b.config,w=b.getChildContainer("datalabelsGroup"),T=m.getFromEnv("toolTipController"),y=m.getGraphicalElement("tempGroup"),A=m.getFromEnv("scale"),S=m.getFromEnv("animationManager"),F=m.config.pointerArr&&m.config.pointerArr.pointer,N=x.canvasWidth,E=x.canvasHeight,L=m.config,D=L.isScaleReversed,M=m.getFromEnv("number-formatter"),R=L.pointerOnOpp?E:0,_=L.showPointerShadow,I=L.showTooltip,V=A.config.axisRange.min,O=A.config.axisRange.max,P=(O-V)/N,G=F&&F.length||0,B=m.components.data,H={pageX:0,pageY:0},W=function(t){var e=t.data[0];!1!==this.editMode&&(i=b._getDataJSON(),this.dragStartX=e)},z=function(){var t,e=this.config,a=b.getFromEnv("chartInstance");if(!1!==this.config.editMode){(t=a&&a.jsVars)&&(t._rtLastUpdatedData=b._getDataJSON()),b.fireChartInstanceEvent("RealTimeUpdateComplete",{data:"&value="+e.updatedValStr,updateObject:{values:[e.updatedValStr]},prevData:i.values,source:"editMode",url:null});try{k.FC_ChartUpdated&&k.FC_ChartUpdated(a.id)}catch(o){setTimeout((function(){throw o}),1)}L.showTooltip?T.enableToolTip(s,e.toolText):T.disableToolTip(s)}},j=function(t){var e=t.data[2],a=C&&function(t){return C&&t.sourceEvent&&t.sourceEvent.touches&&t.sourceEvent.touches[0]||t}(t)||H,o=A.getLimit(),i=o.min,n=o.max,l=(0,r.pluckNumber)(this.itemValue,i),s=l-(D?e-this.dragStartX:this.dragStartX-e)*P,c=0,h=[],u=[];if(!1!==this.editMode){for(this.drag=!0,s<i?s=i:s>n&&(s=n);c<this.index;c+=1)h.push(r.BLANK),u.push(r.BLANK);h.push({value:s}),u.push(s),l!==s&&m.updateData({data:h},{duration:0})&&(this.updatedValStr=u.join("|"),this.dragStartX=e||t.pageX||a.pageX)}};for(t&&0===t.duration&&(b.state="noAnim"),y||(y=m.addGraphicalElement("tempGroup",S.setAnimation({el:"group",state:b.state,attr:{opacity:1,name:"tempGroup"},container:w,component:m}))),g=function(t){var e=this.data("eventArgs").index,a=B[e].config;!0!==a.drag?b.plotEventHandler(this,t):a.drag=!1},p=function(t){var e=this.data("rolloverProperties");e.enabled&&(this.attr(e.hoverAttr),e.hoverAnimAttr&&this.animate(e.hoverAnimAttr,100,"easeIn")),b.plotEventHandler(this,t,"DataPlotRollOver")},f=function(t){var e=this.data("rolloverProperties");e.enabled&&(this.attr(e.outAttr),e.outAnimAttr&&this.animate(e.outAnimAttr,100,"easeIn")),b.plotEventHandler(this,t,"DataPlotRollOut")};G--;)B[G]&&(o=B[G].config,a=M.getCleanValue(o.value),a=Number((0,r.toPrecision)(a,10)),o.itemValue=a,c=B[G].graphics||(B[G].graphics={}),u=o.rolloverProperties||{},l=L.startAngle,v[o.id]={index:G,config:o},l+=.2,n=!!_&&{opacity:Math.max(o.bgAlpha,o.borderAlpha)/100},d={index:G,link:h=o.dataLink,value:o.itemValue,displayValue:o.displayValue,toolText:o.toolText,bgAlpha:o.bgAlpha,borderAlpha:o.borderAlpha,borderColor:o.borderColor,borderThickness:o.borderWidth,color:o.bgColor,editMode:o.editMode,id:o.id,radius:o.radius,showValue:o.showValue,sides:o.sides},s=c.pointer,s=S.setAnimation({el:s||"polypath",attr:{polypath:[o.sides,D?N-N*((0,r.pluckNumber)(o.itemValue,V)-V)/(O-V):N*((0,r.pluckNumber)(o.itemValue,V)-V)/(O-V),R||0,o.radius,l,0],r:o.radius,fill:o.fillColor,stroke:o.pointerBorderColor,"stroke-width":o.borderWidth},css:h||o.editMode?{cursor:"pointer",_cursor:"hand"}:{cursor:r.BLANK,_cursor:r.BLANK},label:"pointers",container:y,component:m}).show(),c.pointer||(c.pointer=s.on("fc-click",g).shadow(!!n,n&&n.opacity).hover(p,f),s.show()),e||(s.data("eventArgs",d).data("rolloverProperties",u),o._startAngle=l,o.editMode?(o.index=G,o.editMode=!0):o.editMode=!1,s.undrag(),o.editMode&&s.drag(j,W,z,o,o,B[G])),I?T.enableToolTip(s,o.toolText):T.disableToolTip(s));m._drawBackground(),e?m.drawPointerValues(t):m._drawWidgetLabel(t)},a.removeData=function(t){var e,a,o=this.components.data,i=function(){this.hide()};this.removeDataArr||(this.removeDataArr=[]);for(var r=0;r<t;r++)(a=o[r])&&((e=a.graphics).pointer&&this.getFromEnv("animationManager").setAnimation({el:e.pointer,callback:i,component:this}),e.pointerValue&&this.getFromEnv("animationManager").setAnimation({el:e.pointerValue,callback:i,component:this}),e.pointerValueCont&&this.getFromEnv("animationManager").setAnimation({el:e.pointerValueCont,callback:i,component:this}));this.removeDataArr=this.removeDataArr.concat(o.splice(0,t))},a._drawWidgetLabel=function(t){var e,a,o,i,n,l,s,c,h,d,g,p,f,v,b,k,C,x,w,T,A,S,F,N,E,L,D,M=this.getFromEnv("chart"),R=this.getFromEnv("toolTipController"),_=M.config,I=this.getFromEnv("number-formatter"),V=this.getFromEnv("scale"),O=this.getFromEnv("animationManager"),P=M.getChildren("canvas")[0],G=M.getChildContainer("datalabelsGroup"),B=P.getGraphicalElement("dataLabelContainer"),H=V.config.axisRange.min,W=V.config.axisRange.max,z=this.config,j=z.textDirection,U=this.getFromEnv("colorRange"),X=M.getFromEnv("dataSource").colorrange&&U&&U.getColorRangeArr(H,W),K=z.colorRangeStyle||{},Y=z.showvalue,J=M.getFromEnv("dataSource").trendpoints&&M.getFromEnv("dataSource").trendpoints.point,q=_.trendPointConfig,Z=_.canvasWidth,$=_.canvasHeight,Q=_.marginRight,tt=z.pointerOnOpp,et=z.valueInsideGauge,at=z.showGaugeLabels,ot=z.isScaleReversed,it=_.dataLabelStyle,rt=!1,nt=this.getFromEnv("smartLabel"),lt=(0,r.pluckNumber)(parseInt(it.fontHeight,10),parseInt(it.lineHeight,10),12),st=z.currentValuePadding+.5*lt,ct=z.currentTrendPadding+.5*lt,ht=z.currentTrendPadding,ut={fontFamily:it.fontFamily,fontSize:it.fontSize,lineHeight:it.lineHeight,fontWeight:it.fontWeight,fontStyle:it.fontStyle},dt=this.config.pointerArr&&this.config.pointerArr.pointer,gt=this.components.data;if(B=O.setAnimation({el:B||"group",attr:{name:"label-container"},container:G,component:this}),G=O.setAnimation({el:G||"group",state:"initial",attr:{transform:["T",_.canvasLeft,_.canvasTop]},label:"datalabel",component:this}),!P.getGraphicalElement("dataLabelContainer")&&(B=P.addGraphicalElement("dataLabelContainer",B)),st=et===tt?st-lt/4:st+lt/4,nt.useEllipsesOnOverflow(_.useEllipsesWhenOverflow),nt.setStyle(ut),T=nt.getOriSize("W...").width,K.fontWeight=r.NORMAL,c=this.getPointerLabelXY=function(t,e,a,o,i){return(A=(t-H)*Z/(W-H))+i>Z+Q&&(A=Z-i+Q),{x:A,y:a?e?$-o-st:$+st:e?st:-(st+o),align:m}},h=function(t,e){return a=(e-t)*Z/(W-H),{x:(ot?Z-a-t*Z/(W-H):t*Z/(W-H))+a/2,y:$/2,width:(e-t)*Z/(W-H),height:$}},dt&&dt.length)for(l=dt.length;l--;)if(gt[l]&&(N=gt[l].config,0!==Y&&N.displayValue!==u&&(w=nt.getOriSize(N.displayValue),N.setWidth&&(w=nt.getSmartText(N.displayValue,N.setWidth,w.height,!0)),d=this.getPointerLabelXY(N.itemValue,et,tt,w.height/2,w.width/2),N.isLabelString))){for(rt=!1,k=1;!rt&&(g=dt[l+k]);)g.isLabelString?rt=!0:k+=1;g&&(p=nt.getOriSize(g.displayValue),b=(v=c(g.y,et,tt,p.height/2)).x-p.width/2-(d.x+w.width/2),i=v.x-d.x,b<0&&((n=w.width+b)>i&&(N.setWidth=n=i),n>T?N.setWidth&&N.setWidth<=n?(f=nt.getSmartText(N.displayValue,N.setWidth,w.height,!0),N.displayValue=f.text,f.tooltext&&(N.originalText=f.tooltext)):(f=nt.getSmartText(N.displayValue,n,w.height,!0),N.displayValue=f.text,f.tooltext&&(N.originalText=f.tooltext)):(f=nt.getSmartText(N.displayValue,T,w.height,!0),N.displayValue=f.text,f.tooltext&&(N.originalText=f.tooltext),b=2*b+T-4),N.setWidth=null,n=p.width+b-4,g.setWidth=n>i?i:n>T?n:T)),N.setWidth&&(f=nt.getSmartText(N.displayValue,N.setWidth,w.height,!0),N.displayValue=f.text,f.tooltext&&(N.originalText=f.tooltext),N.setWidth=null)}if(this.drawPointerValues(t),nt.setStyle(K),X&&at)for(l=0,s=X.length;l<s;l+=1)e=ot?X[s-1-l]:X[l],o=(0,r.pluck)(e.label,e.name),w=(d=h(e.minvalue-H,e.maxvalue-H)).width-4>T&&d.height-4>lt?nt.getSmartText(o,d.width-4,d.height-4):nt.getSmartText(o,d.width,d.height),S={"text-anchor":m,"vertical-align":m,x:d.x,y:d.y,direction:j,fill:(0,r.convertColor)(K.color),text:w.text},L=P.getGraphicalElement("colorRangeLabelsCont")&&P.getGraphicalElement("colorRangeLabelsCont")[l],L=O.setAnimation({el:L||"group",attr:{name:"color-range-label"},component:this,container:B,label:"final"}),E=P.getGraphicalElement("colorRangeLabels")&&P.getGraphicalElement("colorRangeLabels")[l],(E=O.setAnimation({el:E||"text",attr:S,css:K,component:this,container:L,label:"final"})).outlineText(z.showTextOutline,S.fill),P.getGraphicalElement("colorRangeLabels")&&P.getGraphicalElement("colorRangeLabels")[l]?(E.show(),R.enableToolTip(E,w.tooltext)):(L=P.addGraphicalElement("colorRangeLabelsCont",L,!0,l),E=P.addGraphicalElement("colorRangeLabels",E,!0,l));else l=0;for(;P.getGraphicalElement("colorRangeLabelsCont")&&P.getGraphicalElement("colorRangeLabelsCont")[l];)P.getGraphicalElement("colorRangeLabelsCont")[l].hide(),l++;if(J)for(l=0,s=q.length;l<s;l+=1){for((F=q[l]).displayValue=(0,r.pluck)(F.displayValue,I.dataLabels(F.startValue)),nt.setStyle(F.style),lt=nt.getOriSize("Wg").height,w=nt.getOriSize(F.displayValue),d=c(F.startValue,0,!F.showOnTop),F.setWidth&&(w=nt.getSmartText(F.displayValue,F.setWidth,w.height,!0)),rt=!1,k=1;!rt&&(g=J[l+k]);)g.showOnTop===F.showOnTop?rt=!0:k+=1;g&&(p=nt.getOriSize(g.displayValue),(b=(v=c(g.startValue,0,!g.showOnTop)).x-p.width/2-(d.x+w.width/2))<0&&(i=v.x-d.x,(n=w.width+b)>i&&(F.setWidth=n=i),n>T?F.setWidth&&F.setWidth<=n?(w=nt.getSmartText(F.displayValue,F.setWidth,w.height,!0),F.displayValue=w.text,w.tooltext&&(F.originalText=w.tooltext)):(w=nt.getSmartText(F.displayValue,w.width+b-4,w.height,!0),F.displayValue=w.text,w.tooltext&&(F.originalText=w.tooltext)):(w=nt.getSmartText(F.displayValue,T,w.height,!0),F.displayValue=w.text,w.tooltext&&(F.originalText=w.tooltext),b=2*b+T-4),F.setWidth=null,n=p.width+b-4,g.setWidth=n>i?i:n>T?n:T)),F.setWidth&&(w=nt.getSmartText(F.displayValue,F.setWidth,w.height,!0),F.displayValue=w.text,w.tooltext&&(F.originalText=w.tooltext),F.setWidth=null),x=F.showOnTop?-(ht+w.height/2):$+ct,C=F.isTrendZone?h(F.startValue,F.endValue).x:d.x,D=P.getGraphicalElement("trendTextElems")&&P.getGraphicalElement("trendTextElems")[l],D=O.setAnimation({el:D||"text",attr:{x:C,y:x,text:F.displayValue,"text-anchor":y[d.align],fill:(0,r.convertColor)(F.textColor||K.color),"font-weight":"normal",direction:j,opacity:1,title:F.originalText||r.BLANK},container:B,component:this,label:"final"}),P.getGraphicalElement("trendTextElems")&&P.getGraphicalElement("trendTextElems")[l]||(D=P.addGraphicalElement("trendTextElems",D,!0,l)),D.show()}else l=0;for(;P.getGraphicalElement("trendTextElems")&&P.getGraphicalElement("trendTextElems")[l];)P.getGraphicalElement("trendTextElems")[l].hide(),l++},a.drawPointerValues=function(){var t,e,a,o,i,n,l,s,c,h,d,g,p,f,m=this.getFromEnv("chart"),v=m.getChildContainer("datalabelsGroup"),b=this.components.data,k=this.config,C=k.showTooltip,x=this.getFromEnv("toolTipController"),w=k.pointerOnOpp,T=k.valueInsideGauge,A=k.textDirection,S=this.getFromEnv("animationManager"),F=this.getFromEnv("smartLabel"),N=this.config.pointerArr&&this.config.pointerArr.pointer,E=m.config.dataLabelStyle,L=N&&N.length,D=m.config,M=D.canvasWidth,R=D.marginLeft,_={fontFamily:E.fontFamily,fontSize:E.fontSize,lineHeight:E.lineHeight,fontWeight:E.fontWeight,fontStyle:E.fontStyle},I=this.pool;for("initial"===m.state&&S.setAnimation({state:"initial",el:v,attr:{opacity:1},component:this}),F.setStyle(E);L--;)b[L]&&(f=!1,d=b[L].graphics,l=(a=b[L].config).displayValue,e=a.showValue,n=a.dataLabelStyle,0!==e&&l!==u?(h=(g=F.getOriSize(l)).height,(c=(g=F.getSmartText(l,D.width,h)).width/2)>R+(s=this.getPointerLabelXY(a.itemValue,T,w,.5*h,c)).x&&(s.x=c-R),t=g.tooltext||u,p={x:k.isScaleReversed?M-s.x:s.x,y:s.y,"text-anchor":y[s.align],title:a.originalText||r.BLANK,text:g.text,fill:n.color,direction:A,"text-bound":[n.backgroundColor,n.borderColor,E.borderThickness,E.borderPadding,E.borderRadius,E.borderDash]},i=S.setAnimation({el:d.pointerValueCont||I&&I.pointerValueCont[0]||"group",attr:{name:"label-group"},container:v,component:this,label:"labelGroup"}).show(),(o=S.setAnimation({el:d.pointerValue||I&&I.pointerValue[0]||"text",attr:p,css:_,container:i,component:this,label:"pointerValues"}).show()).outlineText(k.showTextOutline,p.fill),C?x.enableToolTip(o,t):x.disableToolTip(o),d.pointerValue||(I&&I.pointerValue[0]?(I.pointerValue.splice(0,1),I.pointerValueCont.splice(0,1)):f=!0),d.pointerValue=o,d.pointerValueCont=i,f||o.show()):(d.pointerValue&&d.pointerValue.hide(),d.pointerValueCont&&d.pointerValueCont.hide(),d.pointerValue&&x.disableToolTip(d.pointerValue)))},a.getDataLimits=function(){var t,e,a,o,i,s,c=this.config,h=this.getFromEnv("chart").getFromEnv("dataSource"),u=this.components.data||this.config.pointerArr&&this.config.pointerArr.pointer||h.dials&&h.dials.dial,d=h.colorrange,g=d&&d.color,p=u&&u.length,f=c.upperLimit,m=c.lowerLimit,v=-Infinity,b=+Infinity;for(t=0;t<p;t++)(o=u[t].config.value)!==r.BLANK&&(a=v=w(v,Number(o)),e=b=T(b,Number(o)));for(p=g&&g.length,t=0;t<p;t++)i=Number(g[t].maxvalue),s=Number(g[t].minvalue),f&&i>f&&(i=f),m&&s<m&&(s=m),b=(0,l["default"])([b,s]),v=(0,n["default"])([v,i]);return{forceMin:e!==b,forceMax:a!==v,max:v,min:b}},a.updateData=function(t,e){if(t===this.config.lastUpdatedObj)return!1;var a,o,i,n,l,s,c,h,p,f,m,v,b,k,C,x,w=this.getFromEnv("chart"),T=this.getFromEnv("number-formatter"),y=this.components.data,A=this.components.data,S=A&&A.length||0,F={},N=null,E=[],L=this.getFromEnv("chart-attrib").plottooltext,D=t;for(D=D.data,C=e||w.get(d,g),c=D.length,n=0;n<c;n++)(l=D[n].id)&&(F[l]=D[n]);if(s=Object.keys(F).length,S){for(;S--;)h={},x={},l=(p=y[S].config).id,f=void 0,f=s?F[l]:D[S],f&&(k=f.value,o=f.tooltext,a=f.label,i=f.showlabel,m=f.valuefontcolor,v=f.valuebgcolor,b=f.valuebordercolor,void 0!==k&&k!==r.BLANK?(h.value=x.value=k,N=x.displayvalue=x.tooltext=T.dataLabels(x.value),x.hasNewData=!0):x.value=p.formatedVal,m&&(p.dataLabelStyle.color=(0,r.convertColor)(m)),v&&(p.dataLabelStyle.backgroundColor=(0,r.convertColor)(v)),b&&(p.dataLabelStyle.borderColor=(0,r.convertColor)(b)),a&&(x.displayvalue=a,x.hasNewData=!0),"0"===i&&(x.displayvalue=u,x.hasNewData=!0),o&&(x.hasNewData=!0),o=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(o,L),!1)),x.hasNewData&&(E[S]=x,p.value=x.value,p.displayValue=p.displayValue||"1"===i?x.displayvalue:u,p.toolText=void 0!==o?(0,r.parseTooltext)(o,[1,2],{formattedValue:N},h):N));return E.length&&(this.config.lastUpdatedObj=D,this.draw(C,!0)),Boolean(E.length)}},e}(c.ComponentInterface);A.prototype._configureDataLabelStyle=r.configureDataLabelStyle;var S=A;e["default"]=S},1113:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(224),i=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],r={"initial.dataset.hlineargauge":function(){return{"parentgroup.initial":function(t){return[{initialAttr:{transform:t.attr.transform},finalAttr:{transform:t.attr.transform},slot:"initial"}]},"datalabel.initial":function(t){return[{initialAttr:{transform:t.attr.transform},finalAttr:{transform:t.attr.transform}}]},"background.appearing":function(){return i[0].slot=o.INITIALSTR,i},"background.updating":null,"final.appearing":function(){return i[0].slot=o.FINALSTR,i},"final.updating":null,"pointers.appearing":function(t){var e=t.component,a=e.config&&e.config.isScaleReversed,o=t.attr.polypath.slice(0),i=e.getFromEnv("chart")&&e.getFromEnv("chart").config&&e.getFromEnv("chart").config.canvasWidth;return o[1]=a?i:0,[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:{polypath:o},finalAttr:{opacity:1},slot:"middle"}]},"pointers.updating":null,"pointerValues.appearing":function(t){var e=t.component,a=e.config&&e.config.isScaleReversed,o=e.getFromEnv("chart")&&e.getFromEnv("chart").config&&e.getFromEnv("chart").config.canvasWidth;return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:{x:a?o:0},finalAttr:{opacity:1},slot:"middle"}]},"pointerValues.updating":null,"*":null}}};e["default"]=r},1114:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(232),i=a(224),r=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],n={"initial.dataset.angularGauge":function(){var t=this.config,e=(0,o.getDep)("redraphael","plugin"),a=Math.PI/180,n=e.vml?-1.5:0,l=e.vml?-1.5:0;return{"dialPath.appearing":function(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:{transform:"R"+t.gaugeStartAngle/a+","+n+","+l},finalAttr:{opacity:1},slot:"middle"}]},"dialPath.updating":null,"text.appearing":function(){return r[0].slot=i.FINALSTR,r},"text.updating":null,"pivot.appearing":function(){return r[0].slot=i.INITIALSTR,r},"pivot.updating":null,"plotBackground.appearing":function(){return r[0].slot=i.INITIALSTR,r},"plotBackground.updating":null}}};e["default"]=n},1115:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=function(t){var e=Math,a=e.pow,o=e.tan,i=e.acos,r=e.min,n=e.sqrt,l="M",s="L",c="Q",h=t._cacher((function(t,e,o,i){return n(a(o-t,2)+a(i-e,2))})),u=t._cacher((function(t,e,a,o,i){var r,n=a-t,l=o-e;return{x:t+(n/=r=h(t,e,a,o))*i,y:e+(l/=r)*i}}));t.define&&t.define([{name:"trianglepath",trianglepath:function(){var e=this,a=arguments,o=t._lastArgIfGroup(a),i=e.path(o);return i.attr("trianglepath",[a[0],a[1],a[2],a[3],a[4],a[5],a[6]||0,a[7]||0,a[8]||0])},fn:{sides:function(){var t=this._args;return[h(t[0],t[1],t[2],t[3]),h(t[2],t[3],t[4],t[5]),h(t[4],t[5],t[0],t[1])]},enclosedAngles:function(){var t=this._sides;return[i((a(t[0],2)+a(t[2],2)-a(t[1],2))/(2*t[0]*t[2])),i((a(t[0],2)+a(t[1],2)-a(t[2],2))/(2*t[0]*t[1])),i((a(t[2],2)+a(t[1],2)-a(t[0],2))/(2*t[2]*t[1]))]},semiperimeter:function(){var t=this._sides||this.sides();return(t[0]+t[1]+t[2])/2}},ca:{trianglepath:function(t,e,a,i,h,d,g,p,f){if(g||p||f){this._args=arguments,this._sides=this.sides();var m,v,b,k=this.enclosedAngles(),C=this.semiperimeter();b=n(C*(C-this._sides[0])*(C-this._sides[1])*(C-this._sides[2]))/C,m=[r(g,b)/o(k[0]/2),r(p,b)/o(k[1]/2),r(f,b)/o(k[2]/2)],v=[u(t,e,h,d,m[0]),u(t,e,a,i,m[0]),u(a,i,t,e,m[1]),u(a,i,h,d,m[1]),u(h,d,a,i,m[2]),u(h,d,t,e,m[2])],this.attr({path:[l,v[0].x,v[0].y,c,t,e,v[1].x,v[1].y,s,v[2].x,v[2].y,c,a,i,v[3].x,v[3].y,s,v[4].x,v[4].y,c,h,d,v[5].x,v[5].y,s,v[0].x,v[0].y]})}else this.attr({path:[l,t,e,s,a,i,h,d,"Z"]})}}}])}},1116:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1117))["default"];e["default"]=i},1117:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1118)),n=function(t){function e(){var e;return(e=t.call(this)||this).defaultSeriesType="led",e.defaultPlotShadow=1,e.realtimeEnabled=!0,e.chartleftmargin=15,e.chartrightmargin=15,e.charttopmargin=10,e.chartbottommargin=10,e.showTooltip=0,e.connectTickMarks=0,e.isHorizontal=!0,e.config.isAxisOpposite=!1,e.config.scalePosition="bottom",e.config.canBeScalePosition="top",e}(0,i["default"])(e,t),e.getName=function(){return"Hled"};var a=e.prototype;return a._feedAxesRawData=function(){var e=t.prototype._feedAxesRawData.call(this);return e[0].isReverse=!1,e},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),this.config.friendlyName="Vertical LED Gauge"},a.getName=function(){return"Hled"},e}(r["default"]);e["default"]=n},1118:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(1119),n=o(a(1095)),l=o(a(1120)),s=o(a(1092)),c=function(t){function e(){var e;return(e=t.call(this)||this).showRTvalue=!1,e.canvasPadding=!1,e.defaultSeriesType="led",e.defaultPlotShadow=1,e.realtimeEnabled=!0,e.chartleftmargin=15,e.chartrightmargin=15,e.charttopmargin=10,e.chartbottommargin=10,e.showTooltip=0,e.connectTickMarks=0,e.isHorizontal=!1,e.config.isAxisOpposite=!0,e.config.scalePosition="right",e.config.canBeScalePosition="left",e.drawPlotlines=!1,e.drawPlotBands=!1,e.isAxisReverse=!1,e.isRealTime=!0,e.colorRange=!0,e.registerFactory("dataset",s["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Vled"};var a=e.prototype;return a.getName=function(){return"Vled"},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),r.configureAttributes.call(this)},a._getData=function(){return r._getData.call(this)},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Vertical LED Gauge",e.hasLegend=!1,e.defaultDatasetType="led",e.skipCanvasDrawing=!0,e.majorTMNumber=-1,e.majorTMHeight=6,e.showTickMarks=1,e.majorTMThickness=1,e.minorTMNumber=4,e.minorTMThickness=1,e.tickMarkDistance=3,e.placeTicksInside=0,e.placeValuesInside=0},a.getDSdef=function(){return l["default"]},e}(n["default"]);e["default"]=c},1119:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e.configureAttributes=function(){var t=this.getFromEnv("dataSource").colorrange;t&&t.color&&t.color.length?((0,i.componentFactory)(this,r["default"],"colorRange",1,[{colorRange:t,numberFormatter:this.getFromEnv("number-formatter")}]),this.addToEnv("colorRange",this.getChildren("colorRange")&&this.getChildren("colorRange")[0])):this.deleteFromEnv("colorRange")},e._getData=function(){var t,e,a=this.getDatasets();if(a&&(e=a[0].components.data)&&e[0])return t=e[0].config,(0,i.pluckNumber)(t.setValue,t.itemValue)};var i=a(224),r=o(a(1054))},1120:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1121)),l=a(232),s=o(a(1123)),c=r.BLANK,h=r.preDefStr.colors.c000000,u=r.preDefStr.showHoverEffectStr,d=r.preDefStr.POSITION_MIDDLE,g=window,p=g.navigator.userAgent,f="rgba(192,192,192,"+(/msie/i.test(p)&&!g.opera?.002:1e-6)+")",m=Math,v=m.round,b=m.max,k=r.regex.dropHash;(0,l.addDep)({name:"ledAnimation",type:"animationRule",extension:s["default"]});var C=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"led"},a.draw=function(){var t,e,a,o,i,n,l,s,c,d,g,p,m,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j,U,X,K,Y,J,q,Z,$,Q,tt,et,at,ot,it,rt,nt,lt,st,ct=this.getFromEnv("chart"),ht=this.config,ut=ct.getFromEnv("dataSource").chart,dt=ct.config,gt=ct.getChildren("canvas")[0],pt=gt.getGraphicalElement(),ft=gt.config,mt=pt.canvasBorderElement,vt=pt.colorRangeElems,bt=pt.canvasElementPath,kt=pt.canvasHotElement,Ct=dt.canvasLeft,xt=dt.canvasRight,wt=dt.canvasTop,Tt=dt.canvasBottom,yt=dt.canvasWidth,At=dt.canvasHeight,St=ct.getChildContainer().plotGroup,Ft=this.getFromEnv("scale"),Nt=Ft.getLimit().min,Et=Ft.getLimit().max,Lt=(0,r.pluckNumber)(ct.getFromEnv("dataSource").chart.reverseaxis,ct.isAxisReverse),Dt=ct.isHorizontal,Mt=this.getFromEnv("color-manager"),Rt=this.getFromEnv("number-formatter"),_t=ct.getFromEnv("animationManager"),It=ht.showHoverEffect,Vt=[],Ot=[],Pt=this.getContainer("trackerContainer"),Gt=ct.getChildContainer("trackerGroup"),Bt=0,Ht=!1;if(Pt||(Pt=this.addContainer("trackerContainer",_t.setAnimation({el:"group",attr:{name:"led-hot"},container:Gt,component:this}))),l=(0,r.pluckNumber)(ut.showgaugeborder,1),o=(0,r.pluck)(ut.gaugebordercolor,ct.gaugeBorderColor,"333333"),l?(0,r.pluckNumber)(ut.gaugeborderthickness,ct.gaugeBorderThickness,2):0,(0,r.pluck)(ut.gaugeborderalpha,r.HUNDREDSTRING),ft.gaugeFillColor=E=(0,r.pluck)(ut.gaugefillcolor,ut.ledbgcolor,h),A=(0,r.pluckNumber)(ut.usesamefillcolor,0),S=(0,r.pluckNumber)(ut.usesamefillbgcolor,A),ht.ledGap=F=(0,r.pluckNumber)(ut.ledgap,2),ht.ledSize=N=(0,r.pluckNumber)(ut.ledsize,2),ft.colorRangeFillMix=t=(0,r.getFirstDefinedValue)(ut.colorrangefillmix,ut.gaugefillmix,ct.colorRangeFillMix,"{light-10},{dark-10},{light-10},{dark-10}"),ft.colorRangeFillRatio=e=(0,r.getFirstDefinedValue)(ut.colorrangefillratio,ut.gaugefillratio,ct.colorRangeFillRatio,ut.gaugefillratio,"0,10,80,10"),ft.colorRangeGetter=W=this.getFromEnv("colorRange"),ft.colorArray=a=W&&W.getColorRangeArr(Nt,Et),o=(0,r.pluck)(o,h).replace(k,r.HASHSTRING),i=(0,r.pluckNumber)(ut.colorrangeborderalpha,ut.gaugeborderalpha,100),n=(0,r.pluckNumber)(ut.showshadow,1),l=(0,r.pluckNumber)(ut.showgaugeborder,1),ft.colorRangeBorderThickness=s=l?(0,r.pluckNumber)(ut.colorrangeborderthickness,ut.gaugeborderthickness,2):0,M=Et-Nt,_=Ct-(R=s/2),I=wt-R,V=Ct+yt+R,O=wt+At+R,N+=(D=(Dt?yt:At)-N)%(L=F+N||1)/(P=parseInt(D/L,10)+1),ht.sizeGapSum=L=N+F,ht.perLEDValueLength=q=M/P,G=Ct,B=wt,Y=(0,r.pluck)(ut.clickurl),U=Rt.getCleanValue(ct.getFromEnv("dataSource").value),A||S)for(d=0,g=a.length;d<g;d+=1)if(U>=a[d].minvalue&&U<=a[d].maxvalue){z=a[d].code||Mt.getPlotColor(d),X=d;break}for(a&&a.length>0&&(j=a[0].code||Mt.getPlotColor(0)),Z=Lt?xt:Ct,$=Lt?wt:Tt,d=0,g=a&&a.length;d<g;d+=1)c=a[d],ot=c.minvalue-Nt,it=c.maxvalue-Nt,p=Lt&&!Dt?{x:Ct,y:wt+ot*At/(Et-Nt),width:yt,height:(it-ot)*At/(Et-Nt)}:Lt||Dt?Lt&&Dt?{x:Ct+(yt-it*yt/(Et-Nt)),y:wt,width:(it-ot)*yt/(Et-Nt),height:At}:!Lt&&Dt?{x:Ct+ot*yt/(Et-Nt),y:wt,width:(it-ot)*yt/(Et-Nt),height:At}:void 0:{x:Ct,y:wt+(At-it*At/(Et-Nt)),width:yt,height:(it-ot)*At/(Et-Nt)},et=(Q=v((c.maxvalue-Nt)/q))-Bt,Bt=Q,tt=et*L,Dt||Lt?!Dt&&Lt?(p.height=tt-F,p.y=$,$+=tt):Dt&&!Lt?(p.width=tt-F,p.x=Z,Z+=tt):Dt&&Lt&&(p.width=tt-F,p.x=Z-p.width,Z-=tt):(p.height=tt-F,p.y=$-p.height,$-=tt),c.x=p.x,c.y=p.y,c.width=p.width,c.height=p.height,m=A?z:S&&d>X?j:j=c.code||Mt.getPlotColor(d),C=(0,r.convertColor)((0,r.getColorCodeString)((0,r.pluck)(c.bordercolor,m),o),(0,r.pluckNumber)(c.borderalpha,i)),x=Mt.parseColorMix(c.code,t),w=Mt.parseAlphaList(c.alpha,x.length),T=(0,r.pluckNumber)(c.borderAlpha,i),y=w.split(r.COMMASTRING),y=b.apply(Math,y),y=b(s&&T||0,y),at={x:p.x,y:p.y,width:p.width<0?0:p.width,height:p.height<0?0:p.height,r:0,"stroke-width":0,stroke:C,fill:(0,r.toRaphaelColor)({FCcolor:{color:m,ratio:e,alpha:w,angle:180}})},K=_t.setAnimation({el:vt&&vt[d]||"rect",attr:at,container:St,component:this,label:"plotBackground"}).toBack(),vt&&vt[d]||(gt.addGraphicalElement("colorRangeElems",K,!0),K.shadow({apply:n,opacity:y/100})),Vt.push({"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:(0,r.getDarkColor)((0,r.pluck)(m,h),80)+r.COMMASTRING+(0,r.getLightColor)((0,r.pluck)(m,h),80),alpha:(0,r.pluckNumber)(c.alpha,100),angle:Dt?90:0}})}),Ot.push({"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:(0,r.pluck)(m,h),alpha:(0,r.pluckNumber)(c.alpha,100)}})});for(g=(vt=gt.getGraphicalElement("colorRangeElems")||[]).length-1;g>=d;)gt.removeGraphicalElement(vt[g]),g--;for(J={link:Y,value:U},at={x:Ct,y:wt,width:yt,height:At,"stroke-width":0,fill:f},kt?_t.setAnimation({el:kt,attr:at,container:Pt,component:this}):(kt=pt.canvasHotElement=_t.setAnimation({el:"rect",attr:at,container:Pt,component:this}),Ht=!0),kt.data("eventArgs",J).data(u,It).data("setRolloverAttr",Vt).data("setRolloutAttr",Ot),Ht&&(Y&&kt.on("fc-click",(function(t){ct.plotEventHandler(this,t)})),kt.hover((rt=vt,st=0,function(){if(0!==(lt=this).data(u))for(st=0,nt=rt.length;st<nt;st+=1)rt[st].attr(lt.data("setRolloverAttr")[st])}),function(t){var e,a,o=0;return function(){if(0!==(a=this).data(u))for(o=0,e=t.length;o<e;o+=1)t[o].attr(a.data("setRolloutAttr")[o])}}(vt))),Dt?G+=L-F/2:B+=L-F/2,H=[],at={path:["M",_,I,"L",V,I,V,O,_,O,"Z"],stroke:(0,r.convertColor)(o,i),"stroke-width":s,"stroke-linecap":"butt"},mt?_t.setAnimation({el:mt,attr:at,component:this}):pt.canvasBorderElement=_t.setAnimation({el:"path",attr:at,container:St,component:this,label:"plotBackground"}).shadow({apply:n}).toBack(),d=1;d<P;d+=1)Dt?(H.push("M",G,B,"L",G,B+At),G+=L):(H.push("M",G,B,"L",G+yt,B),B+=L);at={path:H,stroke:(0,r.convertColor)(E,100),"stroke-width":F,"stroke-linecap":"butt"},bt?_t.setAnimation({el:bt,attr:at,component:this}):(bt=_t.setAnimation({el:"path",attr:at,container:St,component:this,label:"plotBackground"}),gt.addGraphicalElement("canvasElementPath",bt)),this.drawShade()},a.drawShade=function(){var t,e,a,o,i,n,l,s,h,u,g,p,f,m,b,k=this.config,C=this.components.data,x=this.getFromEnv("chart"),w=x.getChildren("caption")[0],T=x.getChildren("subCaption")[0],y=w&&w.config.text&&w.config.height||0,A=w&&w.config.text&&w.config.captionPadding||0,S=T&&T.config.text&&T.config.height||0,F=x.getFromEnv("dataSource").chart,N=x.getFromEnv("animationManager"),E=this.getFromEnv("toolTipController"),L=this.getFromEnv("smartLabel"),D=x.config,M=D.canvasLeft,R=D.canvasTop,_=D.canvasHeight,I=D.canvasWidth,V=x.getChildContainer().plotGroup,O=this.getContainer("container"),P=this.getFromEnv("number-formatter"),G=k.isAxisReverse=(0,r.pluckNumber)(F.reverseaxis,x.isaxisreverse),B=k.isHorizontal=x.isHorizontal,H=C[0],W=H.graphics,z=H&&H.config,j=this.getContainer("dataLabelContainer"),U=x.getChildContainer("datalabelsGroup"),X=x.getChildren("canvas")[0],K=x.config.dataLabelStyle,Y=k.heightUsed,J=this.getFromEnv("scale").getLimit().min;L.setStyle(K),o=x.getChildren("canvas")[0].config.gaugeFillColor,O||(O=this.addContainer("container",N.setAnimation({el:"group",attr:{name:"shade"},container:V,component:this}))),j||(j=this.addContainer("dataLabelContainer",N.setAnimation({el:"group",attr:{name:"datalabel"},container:U,component:this,label:"labelGroup"}))),i=P.getCleanValue(z.setValue),H.graphics||(H.graphics={}),p=(i-J)/k.perLEDValueLength,f=v(p)*k.sizeGapSum-k.ledGap,m=Math.ceil(_-f),b=Math.ceil(I-f),G&&!B?l={x:M,y:R+f,width:I,height:m,r:0,"stroke-width":0,fill:(0,r.convertColor)(o,50)}:G||B?!G&&B?l={x:M+f,y:R,width:b,height:_,r:0,"stroke-width":0,fill:(0,r.convertColor)(o,50)}:G&&B&&(l={x:M,y:R,width:b,height:_,r:0,"stroke-width":0,fill:(0,r.convertColor)(o,50)}):l={x:M,y:R,width:I,height:m,r:0,"stroke-width":0,fill:(0,r.convertColor)(o,50)},H.graphics.element=N.setAnimation({el:H.graphics.element||"rect",attr:l,container:O,component:this,label:"plotRect"}),g=z.setTooltext===r.BLANK||void 0===z.setTooltext?z.toolTipValue:z.setTooltext,k.showTooltip?E.enableToolTip(X._graphics.canvasHotElement,g):E.disableToolTip(X._graphics.canvasHotElement),n=(s=parseInt(K.lineHeight,10))>Y?D.height-D.marginBottom-Y+s/2:D.height-D.marginBottom-s/2,n-=D.borderWidth,n-=(x._manageActionBarSpace&&x._manageActionBarSpace(.225*z.availableHeight)||{}).bottom,0===w.config.isOnTop&&(n-=y+S+A),W=H.graphics,z.displayValue!==c&&void 0!==z.displayValue&&k.showValue?(a=(t=L.getSmartText(z.displayValue,D.width,k.heightUsed)).text,e=t.tooltext||c,l={text:a,"text-anchor":d,x:I/2+M,y:n,"vertical-align":d,fill:K.color,direction:z.textDirection,"text-bound":[K.backgroundColor,K.borderColor,K.borderThickness,K.borderPadding,K.borderRadius,K.borderDash]},W.label=N.setAnimation({el:W.label||"text",attr:l,container:j,component:this,label:"text"}),k.showTooltip?E.enableToolTip(W.label,e):E.disableToolTip(W.label),(h=W.label.getBBox()).x+D.marginLeft<0&&(u=h.width-D.marginLeft,D.width<u&&(u=D.width-D.marginLeft),l={x:u/2},N.setAnimation({el:W.label,attr:l,component:this,label:"text"}))):(W.label&&E.disableToolTip(W.label),W.label=W.label&&N.setAnimation({el:W.label,component:this}))},e}(n["default"]);e["default"]=C},1121:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(232),l=a(240),s=o(a(1122)),c=(0,n.getDep)("redraphael","plugin"),h=r.BLANK,u=r.preDefStr.showHoverEffectStr,d=r.preDefStr.ROUND,g=r.preDefStr.miterStr,p=r.preDefStr.colors,f=Math,m=f.max,v=f.min,b=f.abs,k=p.FFFFFF,C=void 0!==window.document.documentElement.ontouchstart,x={"true":void 0,"false":"crisp"},w=r.preDefStr.POSITION_START,T=r.preDefStr.POSITION_MIDDLE,y=r.preDefStr.PLOTFILLCOLOR_STR,A=C?r.TOUCH_THRESHOLD_PIXELS:r.CLICK_THRESHOLD_PIXELS;(0,n.addDep)({name:"bulletAnimation",type:"animationRule",extension:s["default"]});var S=function(t){function e(){var e;return(e=t.call(this)||this).addData=function(){},e.removeData=function(){},e.components={},e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"bullet"},a.configure=function(t){if(!t)return!1;this.config.JSONData=t;var e,a,o,i,n,l,s,c,h,u=this.getFromEnv("chart"),g=this.config,p=this.config.JSONData,f=u.getFromEnv("dataSource").chart,v=this.getFromEnv("color-manager"),b=g.plotColor=v.getColor(y),C=(0,r.pluckNumber)(p.dashed,f.plotborderdashed),x=this.components.data,w=u.isBar,T=u.config.is3D,A=u.isStacked;this.setState("visible",1===(0,r.pluckNumber)(p.visible,1)),g.targetCapStyle=h=(0,r.pluck)(f.targetcapstyle,d).toLowerCase(),"butt"!==h&&h!==d&&"square"!==h&&"inherit"!==h&&(g.targetCapStyle=d),g.upperLimit=(0,r.pluckNumber)(f.upperlimit),g.lowerLimit=(0,r.pluckNumber)(f.lowerlimit),g.initAnimation=!0,e=g.showplotborder=(0,r.pluckNumber)(f.showplotborder,0),g.plotDashLen=a=(0,r.pluckNumber)(f.plotborderdashlen,5),g.plotDashGap=o=(0,r.pluckNumber)(f.plotborderdashgap,4),g.plotfillAngle=(0,r.pluckNumber)(360-f.plotfillangle,w?180:90),g.plotFillAlpha=n=(0,r.pluck)(p.alpha,f.plotfillalpha,r.HUNDREDSTRING),g.plotColor=b=(0,r.pluck)(f.plotfillcolor,b),g.isRoundEdges=i=(0,r.pluckNumber)(f.useroundedges,0),g.plotRadius=(0,r.pluckNumber)(f.useRoundEdges,g.isRoundEdges?1:0),g.plotFillRatio=(0,r.pluck)(p.ratio,f.plotfillratio),g.plotgradientcolor=(0,r.getDefinedColor)(f.plotgradientcolor,v.getColor("plotGradientColor")),g.showPlotBorderOnHover=(0,r.pluckNumber)(f.showplotborderonhover,0),g.plotBorderAlpha=(0,r.pluck)(f.plotborderalpha,n,r.HUNDREDSTRING),g.plotBorderColor=(0,r.pluck)(f.plotbordercolor,T?k:v.getColor("plotBorderColor")),g.plotBorderThickness=e?(0,r.pluckNumber)(f.plotborderthickness,0):0,g.plotBorderDashStyle=C?(0,r.getDashStyle)(a,o):"none",g.showValue=(0,r.pluckNumber)(p.showvalue,f.showvalue,1),g.valuePadding=(0,r.pluckNumber)(f.valuepadding,2),g.showShadow=i||T?(0,r.pluckNumber)(f.showshadow,1):(0,r.pluckNumber)(f.showshadow,v.getColor("showShadow")),g.showHoverEffect=(0,r.pluckNumber)(f.plothovereffect,f.showhovereffect,0),g.showTooltip=(0,r.pluckNumber)(f.showtooltip,1),g.stack100Percent=l=(0,r.pluckNumber)(u.stack100percent,f.stack100percent,0),g.definedGroupPadding=m((0,r.pluckNumber)(f.plotspacepercent),0),g.plotSpacePercent=m((0,r.pluckNumber)(f.plotspacepercent,20)%100,0),g.maxColWidth=(0,r.pluckNumber)(w?f.maxbarheight:f.maxcolwidth,50),g.showPercentValues=(0,r.pluckNumber)(f.showpercentvalues,A&&l?1:0),g.showPercentInToolTip=(0,r.pluckNumber)(f.showpercentintooltip,A&&l?1:0),g.plotPaddingPercent=(0,r.pluckNumber)(f.plotpaddingpercent),g.rotateValues=(0,r.pluckNumber)(f.rotatevalues)?270:0,g.placeValuesInside=(0,r.pluckNumber)(f.placevaluesinside,0),g.use3DLighting=(0,r.pluckNumber)(f.use3dlighting,1),x||(x=this.components.data=[]),g.plotAsDot=c=(0,r.pluckNumber)(f.plotasdot,0),g.plotFillPercent=(0,r.pluckNumber)(f.plotfillpercent,c?25:40),g.targetFillPercent=(0,r.pluckNumber)(f.targetfillpercent,60),g.targetThickness=(0,r.pluckNumber)(f.targetthickness,3),s=g.targetalpha=(0,r.pluckNumber)(f.targetalpha,100),g.rawTargetColor=(0,r.pluck)(f.targetcolor,v.getColor(y)),g.targetColor=(0,r.convertColor)(g.rawTargetColor,s),this._setConfigure()},a._setConfigure=function(t){var e,a,o,i,n,l,s,c,h,u,d,g,p,f,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j=this.getFromEnv("chart"),U=this.config,X=this.config.JSONData,K=t||X.data,Y=K&&K.length,J=t&&t.data.length||Y,q=j.getFromEnv("dataSource").chart,Z=this.getFromEnv("color-manager"),$=U.showplotborder,Q=U.showPlotBorderOnHover,tt=U.plotColor,et=(0,r.parseUnsafeString)((0,r.pluck)(q.tooltipsepchar,r.COMMASPACE)),at=(0,r.pluckNumber)(q.seriesnameintooltip,1),ot=U.plotBorderThickness,it=U.isRoundEdges,rt=U.showHoverEffect,nt=U.plotFillAngle,lt=U.plotBorderAlpha,st=U.plotBorderDashStyle,ct=this.components.data,ht=j.isBar,ut=j.config.is3D,dt=-Infinity,gt=Infinity,pt=this.getFromEnv("number-formatter"),ft=function(t){var o;return U.showTooltip?null===e?o=!1:void 0!==t?(n=[1,2,3,4,5,6,7,26,27],a={formattedValue:e,targetValue:p.target,targetDataValue:p.toolTipValueTarget},o=(0,r.parseTooltext)(t,n,a,u,q,X)):(at&&(i=(0,r.getFirstValue)(X&&X.seriesname)),o=i?i+et:r.BLANK,o+=p.toolTipValue?p.toolTipValue:r.BLANK):o=!1,o};for(ct||(ct=this.components.data=[]),I=0;I<J;I++)u=t?t&&t.data[I]:K[I],g=ct[I],p=g&&g.config,g||(g=ct[I]={}),g.config||(p=ct[I].config={}),p.showValue=(0,r.pluckNumber)(u.showvalue,U.showValues),p.valuePadding=(0,r.pluckNumber)(q.valuepadding,2),p.setValue=d=pt.getCleanValue(u.value),p.target=V=pt.getCleanValue(u.target),p.setLink=(0,r.pluck)(u.link),p.toolTipValue=L=pt.dataLabels(d),p.toolTipValueTarget=pt.dataLabels(V),p.setDisplayValue=D=(0,r.parseUnsafeString)(u.displayvalue),p.displayValue=(0,r.pluck)(u.label,D,L),M=(0,r.pluckNumber)(u.dashed),R=(0,r.pluckNumber)(u.dashlen,void 0),_=s=(0,r.pluckNumber)(u.dashgap,s),dt=m(dt,d,V),gt=v(gt,d,V),p.plotBorderDashStyle=h=1===M?(0,r.getDashStyle)(R,_):0===M?"none":st,tt=(0,r.pluck)(u.color,U.plotColor),c=(0,r.pluck)(u.alpha,U.plotFillAlpha),d<0&&!it&&(l=nt,nt=ht?180-nt:360-nt),p.colorArr=f=(0,r.getColumnColor)(tt,c,void 0,nt,it,U.plotBorderColor,lt.toString(),ht?1:0,!!ut),0!==rt&&(b=(0,r.pluck)(u.hovercolor,X.hovercolor,q.plotfillhovercolor,q.columnhovercolor,tt),k=(0,r.pluck)(u.hoveralpha,X.hoveralpha,q.plotfillhoveralpha,q.columnhoveralpha,c),!(0,r.pluck)(u.hovergradientcolor,X.hovergradientcolor,q.plothovergradientcolor,U.plotgradientcolor)&&r.BLANK,C=(0,r.pluck)(u.hoverratio,X.hoverratio,q.plothoverratio,void 0),x=(0,r.pluckNumber)(360-u.hoverangle,360-X.hoverangle,360-q.plothoverangle,nt),w=(0,r.pluck)(u.borderhovercolor,X.borderhovercolor,q.plotborderhovercolor,q.plotfillhovercolor,U.plotBorderColor),T=(0,r.pluck)(u.borderhoveralpha,X.borderhoveralpha,q.plotborderhoveralpha,lt,c),y=(0,r.pluckNumber)(u.borderhoverthickness,X.borderhoverthickness,q.plotborderhoverthickness,ot),A=(0,r.pluckNumber)(u.borderhoverdashed,X.borderhoverdashed,q.plotborderhoverdashed),S=(0,r.pluckNumber)(u.borderhoverdashgap,X.borderhoverdashgap,q.plotborderhoverdashgap,void 0),F=(0,r.pluckNumber)(u.borderhoverdashlen,X.borderhoverdashlen,q.plotborderhoverdashlen,s),N=A?(0,r.getDashStyle)(F,S):h,1===rt&&b===tt&&(b=(0,r.getDarkColor)(b,90)),E=(0,r.getColumnColor)(b,k,C,x,it,w,T.toString(),ht?1:0,!1),p.setPlotRolloutAttr={fill:ut?[(0,r.toRaphaelColor)(f[0]),!U.use3DLighting]:(0,r.toRaphaelColor)(f[0]),stroke:$&&(0,r.toRaphaelColor)(f[1]),"stroke-width":ot,"stroke-dasharray":h},p.setPlotRolloverAttr={fill:ut?[(0,r.toRaphaelColor)(E[0]),!U.use3DLighting]:(0,r.toRaphaelColor)(E[0]),stroke:(0,r.toRaphaelColor)(E[1]),"stroke-width":Q?y||1:y,"stroke-dasharray":N}),0!==rt&&(rt||q.targethovercolor||q.targethoveralpha||0===q.targethoveralpha||q.targethoverthickness||0===q.targethoverthickness)&&(rt=!0,O={},P={},G=(0,r.pluckNumber)(q.targethoverthickness,U.targetThickness+2),U.targetThickness!==G&&(O["stroke-width"]=G,P["stroke-width"]=U.targetThickness),B=(0,r.pluck)(q.targethovercolor,"{dark-10}"),H=(0,r.pluckNumber)(q.targethoveralpha,U.targetalpha),G&&(P.stroke=U.targetColor,W=/\{/.test(B),O.stroke=(0,r.convertColor)(W?Z.parseColorMix((0,r.pluck)(q.targetcolor,tt),B)[0]:B,H)),p.tagetHoverAttr=O,p.targetOutAttr=P),e=p.toolTipValue,o=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(u.tooltext,X.plottooltext,q.plottooltext),!1)),p.toolText=ft(o),p.setTooltext=p.toolText,l&&(nt=l),z=(0,r.getValidValue)((0,r.parseUnsafeString)((0,r.pluck)(u.tooltexttarget,X.targettooltext,q.targettooltext),!1)),p.toolTextTarget=ft(z);U.maxValue=dt,U.minValue=gt},a._manageSpace=function(t){var e,a,o,i=this.config,n=this.components.data,l=this.getFromEnv("chart"),s=l.config,c=l.getFromEnv("smartLabel"),h=s.dataLabelStyle,u=(0,r.pluckNumber)(parseInt(h.lineHeight,10),12),d=t,g=i.valuePadding,p=0,f=0;for(o=(e=n[f])&&e.config,c.useEllipsesOnOverflow(s.useEllipsesWhenOverflow),c.setStyle(h);f<1;f+=1)i.showValue&&(a=c.getOriSize(o.toolTipValue),o.toolTipValue===r.BLANK&&(a={height:u}),a.height>0&&(p=a.height+g),p>d&&(p=d));return i.heightUsed=p,{top:0,bottom:p}},a._manageSpaceHorizontal=function(t){var e,a,o,i=this.config,n=this.components.data,l=this.getFromEnv("chart"),s=l.config,c=l.getFromEnv("smartLabel"),u=s.dataLabelStyle,d=(0,r.pluckNumber)(parseInt(u.lineHeight,10),12),g=t,p=i.valuePadding,f=0,m=0;for(o=(e=n[m])&&e.config,c.useEllipsesOnOverflow(s.useEllipsesWhenOverflow),c.setStyle(u);m<1;m+=1)o&&o.displayValue!==h&&void 0!==o.displayValue&&i.showValue&&(a=c.getOriSize(o.displayValue),o.displayValue===r.BLANK&&(a={height:d}),a.height>0&&(f=a.width+p+2),f>g&&(f=g));return i.widthUsed=f,{top:0,right:f}},a.updateData=function(t,e,a){var o=this.config,i=o.maxValue,r=o.prevMin,n=this.getFromEnv("chart"),l=this.groupManager||this,s=this.getFromEnv("scale");this._setConfigure(t,e),this.setMaxMin(),o.maxValue===i&&o.minValue===r||(this.config.maxminFlag=!0),a&&(n._setAxisLimits(),s.draw(),l.draw())},a.setMaxMin=function(){var t,e,a=this.components.data,o=this.config,i=a.length,r=-Infinity,n=+Infinity;for(t=0;t<i;t++)a[t]&&(e=a[t].config,r=m(r,e.setValue,e.target),n=v(n,e.setValue,e.target));o.maxValue=r,o.minValue=n},a.draw=function(){var t,e,a,o,i,n,l,s,c,h,u,d,g,p,f,v,b,k,C,x,w,T,y,A,S,F=this.getFromEnv("chart"),N=F.getFromEnv("dataSource").chart,E=F.config,L=F.getChildren("canvas")[0],D=L.config,M=this.getGraphicalElement("backgroundRect")||[],R=E.canvasLeft,_=E.canvasTop,I=E.canvasWidth,V=E.canvasHeight,O=L.getContainer("canvasGroup"),P=this.getFromEnv("scale"),G=P.getLimit().min,B=P.getLimit().max,H=F.isHorizontal,W=this.getFromEnv("color-manager"),z=F.getFromEnv("animationManager");for(e=H?270:180,D.colorRangeFillMix=a=(0,r.getFirstDefinedValue)(N.colorrangefillmix,N.gaugefillmix,F.colorRangeFillMix,"{light-10},{dark-10},{light-10},{dark-10}"),D.colorRangeFillRatio=o=(0,r.getFirstDefinedValue)(N.colorrangefillratio,N.gaugefillratio,F.colorRangeFillRatio,N.gaugefillratio,"0,10,80,10"),D.colorRangeGetter=i=F.getFromEnv("colorRange"),D.colorArray=n=i&&i.getColorRangeArr(G,B),l=(0,r.pluck)(N.colorrangebordercolor,N.gaugebordercolor,"{dark-20}"),s=(0,r.pluckNumber)(N.colorrangeborderalpha,N.gaugeborderalpha,100),c=(0,r.pluckNumber)(N.showshadow,1),h=(0,r.pluckNumber)(N.showgaugeborder,N.showcolorrangeborder,0),D.colorRangeBorderThickness=u=h?(0,r.pluckNumber)(N.colorrangeborderthickness,N.gaugeborderthickness,2):0,f=F.getFromEnv("dataSource").colorrange&&n&&n.length||0,g=0,p=0;g<f;g+=1)d=n[g],A=d.minvalue-G,S=d.maxvalue-G,v=H?H?{x:R+A*I/(B-G),y:_,width:(S-A)*I/(B-G),height:V}:void 0:{x:R,y:_+(V-S*V/(B-G)),width:I,height:(S-A)*V/(B-G)},d.x=v.x,d.y=v.y,d.width=v.width,d.height=v.height,b=d.code,k=(0,r.convertColor)((0,r.getColorCodeString)((0,r.pluck)(d.bordercolor,b),l),(0,r.pluckNumber)(d.borderalpha,s)),C=W.parseColorMix(d.code,a),x=W.parseAlphaList(d.alpha,C.length),w=(0,r.pluckNumber)(d.borderAlpha,s),T=x.split(r.COMMASTRING),T=m.apply(Math,T),T=m(u&&w||0,T),t={x:v.x,y:v.y,width:v.width,height:v.height,r:0,"stroke-width":u,stroke:k,fill:(0,r.toRaphaelColor)({FCcolor:{color:C.toString(),ratio:o,alpha:x,angle:e}})},y=z.setAnimation({el:M[g]||"rect",attr:t,container:O,component:this,doNotRemove:!0,label:"backgroundRect"}),!M[g]&&this.addGraphicalElement("backgroundRect",y,!0),y.show(),y.shadow({apply:c,opacity:T/100}),p++;for(f=M&&M.length;f>p;)M&&M[f-1]&&this.removeGraphicalElement(M[f-1]),f--;this.drawPlot()},a.drawPlot=function(){var t,e,a,o,i,n,l,s,d,p,f,m,v,k,C,y,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j,U,X,K,Y,J=this.config,q=this.getState("visible"),Z=this.getFromEnv("chart"),$=Z.getChildren("caption")[0],Q=Z.getChildren("subCaption")[0],tt=$&&$.config.text&&$.config.height||0,et=$&&$.config.text&&$.config.captionPadding||0,at=Q&&Q.config.text&&Q.config.height||0,ot=this.getFromEnv("toolTipController"),it=Z.config,rt=it.canvasLeft,nt=it.canvasRight,lt=it.canvasTop,st=it.canvasBottom,ct=it.canvasHeight,ht=it.canvasWidth,ut=this.getFromEnv("smartLabel"),dt=this.getFromEnv("scale"),gt=Z.getChildContainer().plotGroup,pt=c,ft=J.showTooltip,mt=this.components.data,vt=J.showShadow,bt=J.plotBorderThickness,kt=J.plotRadius,Ct=this.getContainer("container"),xt=this.getContainer("targetContainer"),wt=this.getContainer("dataLabelContainer"),Tt=this.getContainer("shadowContainer"),yt=this.getContainer("shadowTargetContainer"),At=!1,St=Z.getChildContainer("datalabelsGroup"),Ft=Z.config.dataLabelStyle,Nt=Z.getFromEnv("animationManager"),Et=J.heightUsed,Lt=J.lowerLimit,Dt=J.showHoverEffect,Mt=function(t){Z.plotEventHandler(this,t)},Rt=function(t){return function(e){0!==this.data(u)&&t.attr(this.data("setRolloverAttr")),Z.plotEventHandler(this,e,"DataPlotRollOver")}},_t=function(t){return function(e){0!==this.data(u)&&t.attr(this.data("setRolloutAttr")),Z.plotEventHandler(this,e,"DataPlotRollOut")}},It=function(){this.hide()};for(F=Nt.setAnimation({el:Ct||"group",attr:{name:"bar"},component:this,container:gt,doNotRemove:!0,label:"group"}),Ct||(F=this.addContainer("container",F)),E=Nt.setAnimation({el:wt||"group",attr:{name:"datalabel"},component:this,container:St,doNotRemove:!0,label:"labelGroup"}),wt||(E=this.addContainer("dataLabelContainer",E)),N=Nt.setAnimation({el:xt||"group",attr:{name:"target"},container:gt,doNotRemove:!0,component:this,label:"group"}),xt||(N=this.addContainer("targetContainer",N)),L=Nt.setAnimation({el:Tt||"group",attr:{name:"shadow"},component:this,container:gt,doNotRemove:!0,label:"group"}),Tt||(L=this.addContainer("shadowContainer",L.toBack()),q||L.hide()),D=Nt.setAnimation({el:yt||"group",attr:{name:"shadow"},component:this,container:gt,doNotRemove:!0,label:"group"}),yt||(D=this.addContainer("shadowTargetContainer",D.toBack()),q||D.hide()),ut.setStyle(Ft),e=0;e<1;e++)(C=(S=(m=mt[e])&&m.config).setValue)<0&&(At=!0),k=S.setLink,M=S.colorArr,j=!1,m.graphics||(mt[e].graphics={}),y=S.displayValue,Z.isHorizontal?(p=J.plotFillPercent/100*ct,i=b(lt+st)/2-p/2,J.plotAsDot?(o=dt.getPixel(C)-p/2,B=p):(U=Lt&&Lt<=C&&dt.config.axisRange.min>=0?Lt:0,o=At?dt.getPixel(C):dt.getPixel(U),B=At?dt.getPixel(0)-dt.getPixel(C):dt.getPixel(C)-dt.getPixel(U)),o=(n=pt.crispBound(o,i,B,p,bt)).x,i=n.y,d=n.width,p=n.height,f=S.toolText===r.BLANK?S.toolTipValue:S.toolText,R=S.plotBorderDashStyle,t={x:o,y:i,width:d||1,height:p,r:kt,fill:(0,r.toRaphaelColor)(M[0]),stroke:(0,r.toRaphaelColor)(M[1]),"stroke-width":bt,"stroke-dasharray":R,"stroke-linejoin":g,visibility:q},null!==C&&(m.graphics.element&&m.graphics.element.show(),(k||ft)&&p<A&&(i-=(A-p)/2,p=A)),S.elemCreated=void 0!==m.graphics.element,C?v=m.graphics.element=Nt.setAnimation({el:m.graphics.element||"rect",attr:t,container:F,component:this,label:"plotRect"}):m.graphics.element&&Nt.setAnimation({el:m.graphics.element,component:this,doNotRemove:!0,callback:It,label:"plotRect"}),v&&v.shadow({opacity:vt},L).data("BBox",n),S.target&&(f=S.toolTipValueTarget,I=J.targetFillPercent/100*ct,_=["M",V=O=dt.getPixel(S.target),P=(lt+st)/2-I/2,"L",O,G=P+I],K={stroke:J.targetColor,"stroke-width":J.targetThickness,"stroke-linecap":J.targetCapStyle,path:_,"shape-rendering":x[!1]},m.graphics.targetElement&&m.graphics.targetElement.show()),j=void 0===m.graphics.targetElement,Y=m.graphics.targetElement=Nt.setAnimation({el:m.graphics.targetElement||"path",attr:K,container:N,component:this,doNotRemove:!0,callback:S.target?r.stubFN:It,label:"path"}),S.target&&(v=m.graphics.targetElement),H=parseInt(Ft.lineHeight,10),i=.5*(lt+ct),y!==h&&void 0!==y&&J.showValue&&(y=(s=ut.getSmartText(y,J.widthUsed,it.height)).text,l=s.tooltext,X={text:y,"text-anchor":w,x:nt+J.valuePadding+2,y:i,"vertical-align":r.POSITION_TOP,fill:Ft.color,direction:S.textDirection,"text-bound":[Ft.backgroundColor,Ft.borderColor,Ft.borderThickness,Ft.borderPadding,Ft.borderRadius,Ft.borderDash]},m.graphics.label&&m.graphics.label.show()),m.graphics.label=Nt.setAnimation({el:m.graphics.label||"text",attr:X,component:this,container:E,doNotRemove:!0,callback:y&&J.showValue?r.stubFN:It,label:"text"}),(W=m.graphics.label.getBBox()).x+it.marginLeft<0&&(z=W.width-it.marginLeft,it.width<z&&(z=it.width-it.marginLeft),X.x=z/2,Nt.setAnimation({el:m.graphics.label,attr:X,component:this,doNotRemove:!0,callback:y&&J.showValue?r.stubFN:It,label:"text"}))):(B=J.plotFillPercent/100*ht,o=b(rt+nt)/2-B/2,J.plotAsDot?(i=dt.getPixel(C)-B/2,p=B):(J.base=U=Lt&&Lt<=C&&dt.config.axisRange.min>=0?Lt:0,i=At?dt.getPixel(0):dt.getPixel(C),p=At?dt.getPixel(C)-dt.getPixel(0):dt.getPixel(Lt&&Lt<=C&&dt.config.axisRange.min>=0?Lt:0)-i),o=(n=pt.crispBound(o,i,B,p,bt)).x,i=n.y,d=n.width,p=n.height,f=S.toolText===r.BLANK?S.toolTipValue:S.toolText,R=S.plotBorderDashStyle,t={x:o,y:i,width:d,height:p||1,r:kt,fill:(0,r.toRaphaelColor)(M[0]),stroke:(0,r.toRaphaelColor)(M[1]),"stroke-width":bt,"stroke-dasharray":R,"stroke-linejoin":g,visibility:q},m._xPos=o,m._yPos=i+p,m._height=p,m._width=d,null!==C&&(m.graphics.element&&m.graphics.element.show(),(k||ft)&&p<A&&(i-=(A-p)/2,p=A)),S.elemCreated=void 0!==m.graphics.element,C?v=m.graphics.element=Nt.setAnimation({el:m.graphics.element||"rect",attr:t,container:F,component:this,label:"plotRect"}):m.graphics.element&&Nt.setAnimation({el:m.graphics.element,label:"plotRect",doNotRemove:!0,callback:It,component:this}),v&&v.shadow({opacity:vt},L).data("BBox",n),S.target&&(f=S.toolTipValueTarget,O=(V=(rt+nt)/2-(I=J.targetFillPercent/100*ht)/2)+I,_=["M",V,P=G=dt.getPixel(S.target),"L",O,G],K={stroke:J.targetColor,"stroke-width":J.targetThickness,"stroke-linecap":J.targetCapStyle,path:_,"shape-rendering":x[!1]},m.graphics.targetElement&&m.graphics.targetElement.show()),j=void 0===m.graphics.targetElement,Y=m.graphics.targetElement=Nt.setAnimation({el:m.graphics.targetElement||"path",attr:K,container:N,component:this,doNotRemove:!0,callback:S.target?r.stubFN:It,label:"path"}),i=(H=parseInt(Ft.lineHeight,10))>Et?it.height-it.marginBottom-Et+H/2:it.height-it.marginBottom-H/2,i-=it.borderWidth,i-=(Z._manageActionBarSpace&&Z._manageActionBarSpace(.225*S.availableHeight)||{}).bottom,0===$.config.isOnTop&&(i-=tt+at+et),y!==h&&void 0!==y&&J.showValue&&(y=(s=ut.getSmartText(y,it.width,Et)).text,l=s.tooltext||h,X={text:y,"text-anchor":T,x:ht/2+rt,y:i,"vertical-align":T,fill:Ft.color,direction:S.textDirection,"text-bound":[Ft.backgroundColor,Ft.borderColor,Ft.borderThickness,Ft.borderPadding,Ft.borderRadius,Ft.borderDash]},m.graphics.label&&m.graphics.label.show()),m.graphics.label=Nt.setAnimation({el:m.graphics.label||"text",attr:X,component:this,container:E,doNotRemove:!0,callback:y&&J.showValue?r.stubFN:It,label:"text"}),(W=m.graphics.label.getBBox()).x+it.marginLeft<0&&(z=W.width-it.marginLeft,it.width<z&&(z=it.width-it.marginLeft),X.x=z/2,Nt.setAnimation({el:m.graphics.label,attr:X,component:this,doNotRemove:!0,callback:y&&J.showValue?r.stubFN:It,label:"text"}))),a={showValue:J.showValue,plotAsDot:J.plotAsDot,plotFillPercent:J.plotFillPercent,plotFillColor:J.plotColor,plotFillAlpha:J.plotFillAlpha,showPlotBorder:J.showplotborder,plotBorderColor:J.plotBorderColor,plotBorderThickness:J.plotBorderThickness,plotBorderAlpha:J.plotBorderAlpha,target:S.target,targetColor:J.rawTargetColor,targetThickness:J.targetThickness,targetFillPercent:J.targetFillPercent,targetCapStyle:J.targetCapStyle},m.graphics.element?(m.graphics.element.data(u,Dt).data("setRolloverAttr",S.setPlotRolloverAttr||{}).data("setRolloutAttr",S.setPlotRolloutAttr||{}).data("eventArgs",a),S.elemCreated||m.graphics.element.on("fc-click",Mt).hover(Rt(m.graphics.element),_t(m.graphics.element)),ft?(ot.enableToolTip(Y,f),ot.enableToolTip(m.graphics.element,S.toolText),ot.enableToolTip(m.graphics.label,l)):(ot.disableToolTip(Y),ot.disableToolTip(m.graphics.element),ot.disableToolTip(m.graphics.label))):!ft||0!==C&&null!==C||(ot.enableToolTip(Y,f),ot.enableToolTip(m.graphics.label,l)),j&&Y.on("fc-click",Mt).hover(Rt(Y),_t(Y)),Y.shadow({opacity:vt},L).data("BBox",n).data("eventArgs",a).data("groupId",void 0).data(u,Dt).data("setRolloverAttr",S.tagetHoverAttr).data("setRolloutAttr",S.targetOutAttr)},a.getDataLimits=function(){var t,e,a,o=this.config,i=this.pointerArr&&this.pointerArr.pointer,r=this.getFromEnv("chart").getFromEnv("dataSource").colorrange,n=r&&r.color,l=i&&i.length,s=o.upperLimit,c=o.lowerLimit,h=o.maxValue,u=o.minValue;for(l=n&&n.length,t=0;t<l;t++)e=Number(n[t].maxvalue),a=Number(n[t].minvalue),s&&e>s&&(e=s),c&&a<c&&(a=c),h=m(h,e),u=v(c,a);return{forceMin:!0,forceMax:!0,max:h,min:u}},e}(l.ComponentInterface);e["default"]=S},1122:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(224),i=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],r={"initial.dataset.bullet":function(){var t=this.config,e=this.getFromEnv("chart"),a=this.getFromEnv("scale"),r=a.max,n=a.min,l=r<=0&&n<0?r:r>0&&n>=0?n:0,s=a.yBasePos=a.getPixel(l);return{"plotRect.appearing":function(){var o,i=e.isHorizontal;return t.plotAsDot||(s=a.getPixel(t.base)),o=i?{width:0}:{height:0,y:s},[{initialAttr:function(){return o},slot:"middle"}]},"plotRect.updating":null,"path.appearing":function(){return i[0].slot=o.MIDDLESTR,i},"path.updating":null,"text.appearing":function(){return i[0].slot=o.FINALSTR,i},"text.updating":null,"labelGroup.appearing":function(){return i[0].slot=o.FINALSTR,i},"labelGroup.updating":null,"backgroundRect.appearing":function(){return i[0].slot=o.INITIALSTR,i},"backgroundRect.updating":null}}};e["default"]=r},1123:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(224),i=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],r={"initial.dataset.led":function(){var t=this.config,e=this.getFromEnv("chart").config,a=e.canvasLeft,r=e.canvasTop,n=e.canvasHeight,l=e.canvasWidth;return{"plotRect.appearing":function(){var e,o=t.isAxisReverse,i=t.isHorizontal;return o&&!i?e={y:r,height:n}:o||i?!o&&i?e={x:a,width:l}:o&&i&&(e={width:l}):e={height:n},[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:e,finalAttr:{opacity:1},slot:"middle"}]},"plotRect.updating":null,"text.appearing":function(){return i[0].slot=o.FINALSTR,i},"text.updating":null,"plotBackground.appearing":function(){return[Object.assign({},i[0],{slot:"initial"})]},"plotBackground.updating":null}}};e["default"]=r},1124:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1118))["default"];e["default"]=i},1125:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1126))["default"];e["default"]=i},1126:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1127)),l=o(a(1095)),s=o(a(1112)),c=a(1106),h=r.BLANK,u=function(t){function e(){var e;return(e=t.call(this)||this).showRTvalue=!1,e.canvasPadding=!1,e.isHorizontal=!0,e.config.isAxisOpposite=!1,e.config.scalePosition="bottom",e.config.canBeScalePosition="top",e.drawPlotlines=!1,e.drawPlotBands=!1,e.isAxisReverse=!1,e.minorTMNumber=4,e.isRealTime=!0,e.colorRange=!0,e.rtParserModify=!0,e.registerFactory("dataset",(function(t){var e=t.getFromEnv("dataSource").pointers;(0,r.datasetFactory)(t,s["default"],"dataset",1,[e])}),["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Hlineargauge"};var a=e.prototype;return a.getName=function(){return"Hlineargauge"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Horizontal Linear Gauge",e.hasLegend=!1,e.defaultDatasetType="hlineargauge",e.skipCanvasDrawing=!0},a.configure=function(e){t.prototype.configure.call(this,e);var a=this.getFromEnv("dataSource").colorrange;a&&a.color&&a.color.length?((0,r.componentFactory)(this,n["default"],"colorRange",1,[{colorRange:a,numberFormatter:this.getFromEnv("number-formatter")}]),this.addToEnv("colorRange",this.getChildren("colorRange")[0])):this.deleteFromEnv("colorRange")},a._configueTrendPoints=function(){var t,e,a,o,i,n=this.getFromEnv("dataSource"),l=this.config,s=l.style,c=n.trendpoints&&n.trendpoints.point,u=this.getFromEnv("scale").config,d=u.axisRange,g=d.max,p=d.min,f=u.scaleFactor||1,m=this.getFromEnv("color-manager"),v=l.trendPointConfig=[],b=n.chart,k=c.length;for(s.trendStyle={fontFamily:s.outCanfontFamily,color:s.outCancolor,fontSize:s.outCanfontSize},e=0;e<k;e++)t=c[e],i=(a=(0,r.pluckNumber)(t.startvalue,t.value))!==(o=(0,r.pluckNumber)(t.endvalue,a)),a<=g&&a>=p&&o<=g&&o>=p&&v.push({startValue:a,endValue:o,tooltext:(0,r.getValidValue)((0,r.parseUnsafeString)(t.markertooltext,!1)),displayValue:(0,r.getValidValue)((0,r.parseUnsafeString)(t.displayvalue),i?h:this.getFromEnv("number-formatter").scale(a)),showOnTop:(0,r.pluckNumber)(t.showontop,b.ticksbelowgauge,1),color:(0,r.pluck)(t.color,m.getColor("trendLightColor")),textColor:t.color,alpha:(0,r.pluckNumber)(t.alpha,99),thickness:(0,r.pluckNumber)(t.thickness,1),dashStyle:Number(t.dashed)?(0,r.getDashStyle)(t.dashlen||2,t.dashgap||2):r.BLANK,useMarker:(0,r.pluckNumber)(t.usemarker,0),markerColor:(0,r.convertColor)((0,r.pluck)(t.markercolor,t.color,m.getColor("trendLightColor")),100),markerBorderColor:(0,r.convertColor)((0,r.pluck)(t.markerbordercolor,t.bordercolor,m.getColor("trendDarkColor")),100),markerRadius:(0,r.pluckNumber)((0,r.pluckNumber)(t.markerradius)*f,5),markerToolText:(0,r.getFirstValue)(t.markertooltext),trendValueDistance:(0,r.pluckNumber)((0,r.pluckNumber)(t.trendvaluedistance)*f,d.tickInterval),isTrendZone:i});r.stableSort&&(0,r.stableSort)(l.trendPointConfig,(function(t,e){return t.startValue-e.startValue}))},a._getData=function(t,e){return c._getData.call(this,t,e)},a._setData=function(t,e){c._setData.call(this,t,e)},a._getDataForId=function(t,e){return c._getDataForId.call(this,t,e)},a._setDataForId=function(t,e){c._setDataForId.call(this,t,e)},e}(l["default"]);e["default"]=u},1127:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(240),l=(0,r.getComparatorFN)(!0,"minvalue"),s=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"colorComponent"},a.getName=function(){return"colorGradient"},a.configure=function(t){var e,a,o,i,n,s,c,h,u,d,g=this,p=g.colorArr,f=g.getFromEnv("color-manager"),m=g.getFromEnv("number-formatter"),v=t.colorRange&&(0,r.extend2)({},t.colorRange).color,b=f.getColor("paletteColors");if(delete g.defaultAsigned,b instanceof Array||(b=f.getPlotColor(0)),v&&v.length>0){for(i=n=v.length-1;i>=0;i-=1)(a=v[i])&&(a.minvalue=m.getCleanValue(a.minvalue),a.maxvalue=m.getCleanValue(a.maxvalue),null===a.minvalue&&(null!==a.maxvalue?a.minvalue=a.maxvalue:i!==n&&v.splice(i,1)),void 0!==a.label&&(a.label=(0,r.parseUnsafeString)(a.label)),void 0!==a.name&&(a.name=(0,r.parseUnsafeString)(a.name)),null!==a.maxvalue&&a.minvalue>a.maxvalue&&(s=a.minvalue,a.minvalue=a.maxvalue,a.maxvalue=s));for(v.sort(l),v[0].code||(v[0].code=b[0]),void 0===(0,r.getValidValue)(v[0].alpha)&&(v[0].alpha=r.HUNDREDSTRING),i=0,n=v.length-1;i<n;i+=1)if(d=i+1,a=v[i],(o=v[d]).code||(o.code=b[d]),void 0===(0,r.getValidValue)(o.alpha)&&(o.alpha=r.HUNDREDSTRING),null===a.maxvalue&&(a.maxvalue=o.minvalue),a.maxvalue>o.minvalue){if(a.maxvalue>o.maxvalue){for((c=(0,r.extend2)(a)).maxvalue=a.maxvalue,u=c.minvalue=o.maxvalue,h=i+2;h<n&&v[h].minvalue<u;)h+=1;v.splice(h,0,c),n+=1}a.maxvalue=o.minvalue}null===(a=v[i]).maxvalue&&(a.maxvalue=a.minvalue)}v&&v.length||(e||(e={code:"CCCCCC",alpha:"100",bordercolor:"000000",borderalpha:"100"}),v=[e],g.defaultAsigned=!0),g.colorArr=v||p},a.getColorObj=function(t){for(var e,a,o=this.colorArr,i=0,r=o.length,n={};i<r;i+=1){if(n.index=i,e=o[i],a=o[i+1],t<e.minvalue)return n.nextObj=e,n;if(t>=e.minvalue&&t<=e.maxvalue)return n.colorObj=e,a&&t===a.minvalue&&(n.nextObj=a,n.isOnMeetPoint=!0),n;n.prevObj=e}return n.index=i-1,n},a.getColorRangeArr=function(t,e){var a,o,i,n,l,s,c,h,u=this.colorArr,d=[],g=t,p=e;if(!this.defaultAsigned&&(g>p&&(a=g,g=p,p=a),g<p&&(n=this.getColorObj(g),s=this.getColorObj(p),n&&s))){for(l=g,o=n.index,i=s.index;o<=i;o+=1)(c=(0,r.extend2)({},u[o])).minvalue!==l&&(c.minvalue=l),d.push(c),h=c,l=c.maxvalue;h.maxvalue=p}return d},e}(n.ComponentInterface);e["default"]=s},1128:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1129))["default"];e["default"]=i},1129:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1130)),l=o(a(1092)),s=o(a(1095)),c=r.preDefStr.gaugeFillColorStr,h=r.preDefStr.gaugeBorderColorStr,u=function(t){return null!=t},d=function(t){function e(){var e;return(e=t.call(this)||this).showRTvalue=!1,e.canvasPadding=!1,e.defaultPaletteOptions=(0,r.extend2)((0,r.extend2)({},r.defaultGaugePaletteOptions),{gaugeBorderColor:["545454","60634E","415D6F","845001","68001B"],gaugeFillColor:["999999","ADB68F","A2C4C8","FDB548","FF7CA0"],periodColor:["EEEEEE","ECEEE6","E6ECF0","FFF4E6","FFF2F5"]},!1,!0),e.isHorizontal=!1,e.config.isAxisOpposite=!0,e.config.scalePosition="right",e.config.canBeScalePosition="left",e.hasCanvas=!0,e.drawPlotlines=!1,e.drawPlotBands=!1,e.isAxisReverse=!1,e.isRealTime=!0,e.registerFactory("dataset",l["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Thermometer"};var a=e.prototype;return a.getName=function(){return"Thermometer"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.alignCaptionWithCanvas=1,e.friendlyName="Horizontal Linear Gauge",e.hasLegend=!1,e.defaultDatasetType="thermometer",e.animationeffect="easeOut",e.skipCanvasDrawing=!0},a._getData=function(){var t=this.getChildren("dataset");if(t&&t[0])return t[0].config.value},a._parseSpecialConfig=function(){var t,e=this.config,a=this.getFromEnv("dataSource").chart,o=this.getFromEnv("number-formatter"),i=this.getFromEnv("color-manager");e.use3DLighting=(0,r.pluckNumber)(a.use3dlighting,1),e.thmOriginX=(0,r.pluckNumber)(a.thmoriginx,a.gaugeoriginx),e.thmOriginY=(0,r.pluckNumber)(a.thmoriginy,a.gaugeoriginy),e.thmBulbRadius=(0,r.pluckNumber)(o.getCleanValue(a.thmbulbradius,!0)),e.thmHeight=(0,r.pluckNumber)(o.getCleanValue((0,r.pluckNumber)(a.thmheight,a.gaugeheight),!0)),e.origW=(0,r.pluckNumber)(a.origw),e.origH=(0,r.pluckNumber)(a.origh),e.xDefined=u(e.thmOriginX),e.yDefined=u(e.thmOriginY),e.rDefined=u(e.thmBulbRadius),e.hDefined=u(e.thmHeight),e.gaugeFillColor=(0,r.pluck)(a.gaugefillcolor,a.thmfillcolor,i.getColor(c)),e.gaugeFillAlpha=(0,r.pluckNumber)(a.gaugefillalpha,a.thmfillalpha,r.HUNDREDSTRING),e.showGaugeBorder=(0,r.pluckNumber)(a.showgaugeborder,1),t=e.showGaugeBorder?(0,r.pluckNumber)(a.gaugeborderalpha,40):0,e.gaugeBorderColor=(0,r.convertColor)((0,r.pluck)(a.gaugebordercolor,i.getColor(h)),t),e.gaugeBorderThickness=(0,r.pluckNumber)(a.gaugeborderthickness,1),e.gaugeContainerColor=(0,r.pluck)(a.thmglasscolor,(0,r.getLightColor)(e.gaugeFillColor,30))},a.allocatePosition=function(){var t=this.config,e=t.canvasLeft,a=t.canvasRight,o=t.canvasTop,i=t.canvasWidth,r=t.canvasHeight,n=t.canvasBottom;t.gaugeStartX=e,t.gaugeEndX=a,t.gaugeStartY=o,t.gaugeEndY=n,t.gaugeCenterX=e+.5*i,t.gaugeCenterY=o+.5*r,t.gaugeRadius=.5*i},a.getDSdef=function(){return n["default"]},e}(s["default"]);e["default"]=d},1130:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(232),l=o(a(1131)),s=o(a(1102)),c=r.preDefStr.configStr,h=r.preDefStr.POSITION_TOP,u=r.preDefStr.POSITION_MIDDLE,d="M",g="A",p="L",f="Z",m=window,v=m.navigator.userAgent,b="rgba(192,192,192,"+(/msie/i.test(v)&&!m.opera?.002:1e-6)+")";(0,n.addDep)({name:"thermometerAnimation",type:"animationRule",extension:l["default"]});var k=function(t){function e(){var e;return(e=t.call(this)||this).addData=r.stubFN,e.removeData=r.stubFN,e}(0,i["default"])(e,t);var a=e.prototype;return a.getName=function(){return"thermometer"},a.getType=function(){return"dataset"},a._manageSpace=function(){var t,e,a,o,i,n=this.config,l=this.getFromEnv("chart").config,s=l.width,c=l.height,h=l.canvasWidth,u=l.canvasHeight,d=l.canvasLeft,g=l.canvasRight,p=l.canvasTop,f=l.xDefined,m=l.yDefined,v=l.rDefined,b=l.hDefined,k=l.thmOriginX,C=l.thmOriginY,x=l.thmBulbRadius,w=l.thmHeight,T=function(t,e,a,o){var i=e,n=t;return i=(0,r.pluckNumber)(i,o),n=(0,r.pluckNumber)(n,a),i&&n?n/a==i/o?a/n:Math.min(a/n,o/i):1}(l.origW,l.origH,s,c),y=0,A=0,S=0,F=0;return l.dataLabelStyle.fontSize=this.computeFontSize(l.dataLabelStyle.fontSizeWithUnit),u-=o=this._getLabelSpace(),A+=o,v?x*=T:(x=Math.min(h/2,.13*(0,r.pluckNumber)(w,u)),v=!0),l.effectiveR=x,e=2*(t=.643*x),a=1.766*x,y+=t,p+=t,u-=t,f?i=(k*=T)-t-d:(i=(g-d)/2-t)+e>h&&(i=h-e),S+=i,d+=i,F+=(h-=i)-e,m&&(C*=T),b?(w*=T,m?y+=C-w-p:C=p+w):m?w=C-p:C=p+(w=Math.max(u-a,3*x)),A+=p+u-C,n.thmBulbRadius=x,n.thmHeight=w,{top:y,bottom:A,left:S,right:F}},a.draw=function(){var t,e,a,o,i,n,l,s,m,v,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W=this,z=W.config,j=W.getFromEnv("smartLabel"),U=W.getFromEnv("chart"),X=U.getChildContainer("datalabelsGroup"),K=U.getChildContainer("trackerGroup"),Y=W.getFromEnv("toolTipController"),J=W.getFromEnv("scale"),q=U.getChildContainer().plotGroup,Z=U.get(c),$=Z.canvasLeft,Q=Z.canvasTop,tt=Z.canvasHeight,et=Z.effectiveR||10,at=.643*et,ot=Z.use3DLighting,it=$+at,rt=Q-at,nt=tt,lt=Math.abs(Z.width-Z.canvasRight-$),st=rt+at,ct=st+nt,ht=ct+.766*et,ut=(0,r.pluckNumber)(z.value,J.getLimit().min),dt=.33*at,gt=rt+dt,pt=J.getPixel(ut),ft=.9*at,mt=at-dt,vt=et+ft-at,bt=it-at,kt=it+at,Ct=it-mt,xt=it+mt,wt=it-ft,Tt=it+ft,yt=parseInt(it-.6*at,10),At=it+at/2,St=z.thmBaseY=ht-Math.abs(Math.sqrt(vt*vt-ft*ft)),Ft=W.getContainer("container"),Nt=W.getGraphicalElement("fluid"),Et=W.getGraphicalElement("topLightGlow"),Lt=W.getGraphicalElement("topLight"),Dt=W.getGraphicalElement("label"),Mt=W.getContainer("dataLabelContainer"),Rt=W.getGraphicalElement("canvasBorderElement"),_t=W.getGraphicalElement("bulbBorderLight"),It=W.getGraphicalElement("bulbTopLight"),Vt=W.getGraphicalElement("bulbCenterLight"),Ot=W.getContainer("trackerContainer"),Pt=W.getGraphicalElement("cylLeftLight"),Gt=W.getGraphicalElement("cylRightLight"),Bt=W.getGraphicalElement("cylLeftLight1"),Ht=W.getGraphicalElement("cylRightLight1"),Wt=W.getGraphicalElement("hotElement"),zt=(0,r.getDarkColor)(z.gaugeFillColor,ot?70:80),jt=z.gaugeFillAlpha,Ut=z.gaugeContainerColor,Xt=(0,r.getDarkColor)(Ut,80),Kt=(0,r.getLightColor)(Ut,80),Yt=z.gaugeBorderThickness,Jt=z.gaugeBorderColor,qt=z.showHoverEffect,Zt=z.plotFillHoverAlpha,$t=z.plotFillHoverColor,Qt=W.getFromEnv("animationManager"),te=U.config.dataLabelStyle,ee=z.fluidAttr;ee||(ee=z.fluidAttr={}),qt&&(ee.hover={fill:(0,r.convertColor)((0,r.getDarkColor)($t,ot?70:80),Zt)}),ee.out={fill:(0,r.convertColor)(zt,jt)},N=[d,Ct,rt,g,dt,dt,0,0,0,bt,gt,p,bt,ct,g,et,et,0,1,0,kt,ct,p,kt,gt,g,dt,dt,0,0,0,xt,rt,f],L={value:z.value,displayValue:z.displayValue,toolText:z.toolText,thmFillColor:z.gaugeFillColor,thmBulbRadius:z.thmBulbRadius,thmHeight:z.thmHeight,thmGlassColor:z.gaugeContainerColor,gaugeFillColor:z.gaugeFillColor,gaugeFillAlpha:z.gaugeFillAlpha,showGaugeBorder:z.showGaugeBorder,gaugeBorderColor:z.rawGaugeBorderColor,gaugeBorderThickness:z.gaugeBorderThickness,gaugeBorderAlpha:z.gaugeBorderAlpha},ee.out.path=[d,wt,St,g,vt,vt,0,1,0,Tt,St,p,Tt,pt,wt,pt,f],ee.out["stroke-width"]=0,D={"stroke-width":Yt,stroke:Jt,path:N},M={path:[d,wt,st,p,Tt,st],stroke:(0,r.convertColor)(zt,40)},R={path:N},i=Qt.setAnimation({el:Ft||"group",attr:{name:"thermometer"},container:q,component:W,label:"group"}),!Ft&&W.addContainer("container",i),v=Qt.setAnimation({el:Rt||"path",attr:D,container:i,component:W,label:"path"}),!Rt&&W.addGraphicalElement("canvasBorderElement",v),n=Qt.setAnimation({el:Nt||"path",attr:ee.out,container:i,component:W,label:"plot"}),!Nt&&W.addGraphicalElement("fluid",n),s=Qt.setAnimation({el:Lt||"path",attr:M,container:i,component:W,label:"path"}),!Lt&&W.addGraphicalElement("topLight",s),ot?(_={path:[d,wt,st,p,Tt,st,Tt,gt,wt,gt,f],"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:zt+r.COMMASTRING+zt,alpha:"40,0",ratio:"0,80",radialGradient:!0,cx:.5,cy:1,r:"70%"}})},l=Qt.setAnimation({el:Et||"path",attr:_,container:i,component:W,label:"path"}),!Et&&W.addGraphicalElement("topLightGlow",l),I={path:E=[d,bt,ct,g,et,et,0,0,1,kt,ct,g,et,et,0,0,0,bt,ct,g,et,et,0,1,0,kt,ct,f],"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{cx:.5,cy:.5,r:"50%",color:Xt+r.COMMASTRING+Kt,alpha:"0,50",ratio:"78,30",radialGradient:!0}})},k=Qt.setAnimation({el:_t||"path",attr:I,container:i,component:W,label:"path"}),!_t&&W.addGraphicalElement("bulbBorderLight",k),V={path:E,"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{cx:.3,cy:.1,r:"100%",color:Kt+r.COMMASTRING+Xt,alpha:"60,0",ratio:"0,30",radialGradient:!0}})},C=Qt.setAnimation({el:It||"path",attr:V,container:i,component:W,label:"path"}),!It&&W.addGraphicalElement("bulbTopLight",C),O={path:E,"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{cx:.25,cy:.7,r:"100%",color:Kt+r.COMMASTRING+Xt,alpha:"80,0",ratio:"0,70",radialGradient:!0}})},x=Qt.setAnimation({el:Vt||"path",attr:O,container:i,component:W,label:"path"}),!Vt&&W.addGraphicalElement("bulbCenterLight",x),P={path:[d,it,rt,p,Ct,rt,g,dt,dt,0,0,0,bt,gt,p,bt,ct,it,ct,f],"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:Kt+r.COMMASTRING+Xt,alpha:"50,0",ratio:"0,80",angle:0}})},T=Qt.setAnimation({el:Pt||"path",attr:P,container:i,component:W,label:"path"}),!Pt&&W.addGraphicalElement("cylLeftLight",T),G={path:[d,bt,rt,p,xt,rt,g,dt,dt,0,0,1,kt,gt,p,kt,ct,bt,ct,f],"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:Kt+r.COMMASTRING+Xt+r.COMMASTRING+Xt,alpha:"50,0,0",ratio:"0,40,60",angle:180}})},y=Qt.setAnimation({el:Gt||"path",attr:G,container:i,component:W,label:"path"}),!Gt&&W.addGraphicalElement("cylRightLight",y),B={path:[d,yt,gt,p,bt,gt,bt,ct,yt,ct,f],"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:Kt+r.COMMASTRING+Xt,alpha:"60,0",ratio:"0,100",angle:180}})},A=Qt.setAnimation({el:Bt||"path",attr:B,container:i,component:W,label:"path"}),!Bt&&W.addGraphicalElement("cylLeftLight1",A),H={path:[d,yt-.01,gt,p,At,gt,At,ct,yt-.01,ct,f],"stroke-width":0,fill:(0,r.toRaphaelColor)({FCcolor:{color:Kt+r.COMMASTRING+Xt,alpha:"60,0",ratio:"0,100",angle:0}})},S=Qt.setAnimation({el:Ht||"path",attr:H,container:i,component:W,label:"path"}),!Ht&&W.addGraphicalElement("cylRightLight1",S)):(W.removeGraphicalElement(Et),W.removeGraphicalElement(_t),W.removeGraphicalElement(It),W.removeGraphicalElement(Vt),W.removeGraphicalElement(Pt),W.removeGraphicalElement(Gt),W.removeGraphicalElement(Bt),W.removeGraphicalElement(Ht)),w=Qt.setAnimation({el:Ot||"group",attr:{name:"col-hot"},container:K,component:W,label:"group"}),!Ot&&W.addContainer("trackerContainer",w),R.stroke=R.fill=b,F=Qt.setAnimation({el:Wt||"path",attr:R,container:w,component:W,label:"path"}),Wt||(W.addGraphicalElement("hotElement",F),F.on("fc-click",(function(t){U.plotEventHandler(this,t)})).hover((function(t){z.showHoverEffect&&W.getGraphicalElement("fluid")&&W.getGraphicalElement("fluid").attr(ee.hover),U.plotEventHandler(this,t,"DataPlotRollOver")}),(function(t){z.showHoverEffect&&W.getGraphicalElement("fluid")&&W.getGraphicalElement("fluid").attr(ee.out),U.plotEventHandler(this,t,"DataPlotRollOut")}))),z.toolText?Y.enableToolTip(F,z.toolText):Y.disableToolTip(F),F.data("eventArgs",L),m=Qt.setAnimation({el:Mt||"group",attr:{name:"datalabel"},container:X,component:W,label:"labelGroup"}),j.setStyle(te),Mt||W.addContainer("dataLabelContainer",m),z.showValue&&(t=ht+et+(z.valuePadding||0),a=(o=j.getSmartText(z.displayValue,Z.width-Z.marginLeft-Z.marginRight-lt/2,Z.height-t-Z.marginBottom)).tooltext||r.BLANKSTRING,e=Qt.setAnimation({el:Dt||"text",attr:{text:o.text,x:it,y:t,"text-anchor":u,"vertical-align":h,fill:te.color,"text-bound":[te.backgroundColor,te.borderColor,te.borderThickness,te.borderPadding,te.borderRadius,te.borderDash]},container:m,component:W,label:"text"}),z.showTooltip?Y.enableToolTip(e,a):Y.disableToolTip(e),Dt||W.addGraphicalElement("label",e),e.show())},e}(s["default"]);e["default"]=k},1131:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o=a(224),i=[{initialAttr:function(){return{opacity:0}},finalAttr:function(){return{opacity:1}}}],r=function(){return i[0].slot=o.FINALSTR,i},n=function(){return i[0].slot=o.INITIALSTR,i},l=function(){return i[0].slot=o.FINALSTR,i},s={"initial.dataset.thermometer":function(){var t=this.config;return{"plot.appearing":function(e){var a=e.attr.path.slice(0);return a[13]=a[15]=t.thmBaseY,[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"},{initialAttr:{path:a},finalAttr:{opacity:1},slot:"middle"}]},"plot.updating":null,"text.appearing":r,"text.updating":null,"labelGroup.appearing":l,"labelGroup.updating":null,"path.appearing":n,"path.updating":null}}};e["default"]=s},1132:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1133))["default"];e["default"]=i},1133:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1134)),n=o(a(1135)),l=a(1137),s=function(t){function e(){var e;return(e=t.call(this)||this).showValues=0,e._parseCanvasCosmetics=l._parseCanvasCosmetics,e._placeOpenCloseValues=l._placeOpenCloseValues,e.defaultPlotShadow=0,e.axisPaddingLeft=0,e.axisPaddingRight=0,e}(0,i["default"])(e,t),e.getName=function(){return"SparkLine"};var a=e.prototype;return a.getName=function(){return"SparkLine"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="SparkLine Chart",e.singleseries=!0,e.defaultDatasetType="sparkline",e.showvalues=0,e.anchorsides=1,e.anchorstartangle=90,e.enablemousetracking=!0},a.getDSdef=function(){return n["default"]},e}(r["default"]);e["default"]=s},1134:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(462)),l=Math,s=l.min,c=l.max,h=l.ceil,u=(0,r.extend2)({},r.defaultGaugePaletteOptions),d=function(t){function e(){var e;return(e=t.call(this)||this).showBorder=0,e.chartTopMargin=3,e.chartRightMargin=3,e.chartBottomMargin=3,e.chartLeftMargin=3,e.canvasborderthickness=0,e.subTitleFontSizeExtender=0,e.subTitleFontWeight=0,e.defaultPaletteOptions=(0,r.extend2)((0,r.extend2)({},u),{paletteColors:[["555555","A6A6A6","CCCCCC","E1E1E1","F0F0F0"],["A7AA95","C4C6B7","DEDFD7","F2F2EE"],["04C2E3","66E7FD","9CEFFE","CEF8FF"],["FA9101","FEB654","FED7A0","FFEDD5"],["FF2B60","FF6C92","FFB9CB","FFE8EE"]],bgColor:["FFFFFF","CFD4BE,F3F5DD","C5DADD,EDFBFE","A86402,FDC16D","FF7CA0,FFD1DD"],bgAngle:[270,270,270,270,270],bgRatio:["0,100","0,100","0,100","0,100","0,100"],bgAlpha:["100","60,50","40,20","20,10","30,30"],canvasBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],canvasBgAngle:[0,0,0,0,0],canvasBgAlpha:["100","100","100","100","100"],canvasBgRatio:[r.BLANKSTRING,r.BLANKSTRING,r.BLANKSTRING,r.BLANKSTRING,r.BLANKSTRING],canvasBorderColor:["BCBCBC","BEC5A7","93ADBF","C97901","FF97B1"],toolTipBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],toolTipBorderColor:["545454","545454","415D6F","845001","68001B"],baseFontColor:["333333","60634E","025B6A","A15E01","68001B"],trendColor:["666666","60634E","415D6F","845001","68001B"],plotFillColor:["666666","A5AE84","93ADBF","C97901","FF97B1"],borderColor:["767575","545454","415D6F","845001","68001B"],borderAlpha:[50,50,50,50,50],periodColor:["EEEEEE","ECEEE6","E6ECF0","FFF4E6","FFF2F5"],winColor:["666666","60634E","025B6A","A15E01","FF97B1"],lossColor:["CC0000","CC0000","CC0000","CC0000","CC0000"],drawColor:["666666","A5AE84","93ADBF","C97901","FF97B1"],scorelessColor:["FF0000","FF0000","FF0000","FF0000","FF0000"]},!1,!0),e}(0,i["default"])(e,t),e.getName=function(){return"SparkChartBase"};var a=e.prototype;return a.getName=function(){return"SparkChartBase"},a._fetchCaptionPos=function(){return this.getChildren("caption")[0].config.isOnLeft,-1},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e);var a=this.getFromEnv("dataSource").chart,o=this.config;o.origCanvasLeftMargin=(0,r.pluckNumber)(a.canvasleftmargin),o.origCanvasRightMargin=(0,r.pluckNumber)(a.canvasrightmargin),o.origCanvasTopMargin=(0,r.pluckNumber)(a.canvastopmargin),o.origCanvasBottomMargin=(0,r.pluckNumber)(a.canvasbottommargin),o.showBorder=(0,r.pluckNumber)(a.showborder,0)},a._spaceManager=function(){var t,e,a,o,i,n,l,s,h,u,d=this.config,g=d.canvasBaseDepth,p=this.getChildren("canvas")[0],f=this.getChildren("caption")[0].config.style,m=this.getChildren("subCaption")[0].config.style,v=this.getFromEnv("dataSource").chart,b=this.getFromEnv("style"),k=p.config.canvasBorderWidth,C=d.borderWidth,x=d.canvasMarginTop,w=d.canvasMarginBottom,T=d.canvasMarginLeft,y=d.canvasMarginRight,A=d.minCanvasHeight,S=d.minCanvasWidth,F=d.height,N=d.width,E=!1,L=!1,D=d.origCanvasTopMargin,M=d.origCanvasBottomMargin,R=d.origCanvasLeftMargin,_=d.origCanvasRightMargin;f.fontSize=(0,r.pluckNumber)(this.computeFontSize(v.captionfontsize),this.computeFontSize(b.fontSizeWithUnit)+3)+r.PXSTRING,(0,r.setLineHeight)(f),m.fontSize=(0,r.pluckNumber)(this.computeFontSize(v.subcaptionfontsize),(0,r.pluckNumber)(c((0,r.pluckNumber)(this.computeFontSize(v.captionfontsize))-3,-1),this.computeFontSize(b.fontSizeWithUnit))+(0,r.pluckNumber)(this.subTitleFontSizeExtender,1))+r.PXSTRING,(0,r.setLineHeight)(m),this._allocateSpace({top:C,bottom:C,left:C,right:C}),e=.325*d.availableHeight,this._getDSspace&&this._allocateSpace(this._getDSspace(e)),this._allocateSpace(this._manageActionBarSpace&&this._manageActionBarSpace(.225*d.availableHeight)||{}),d.availableWidth=d.width,t=(t=.75*d.availableWidth)-d.origMarginLeft-d.origMarginRight-2*d.borderWidth,t=c(.1*d.availableWidth,t),this._manageChartMenuBar(t),t=.75*(d.availableWidth-2*d.borderWidth),this._placeOpenCloseValues&&this._allocateSpace(this._placeOpenCloseValues(t)),this._allocateSpace({top:k,bottom:k,left:k,right:k}),this._allocateSpace({bottom:g}),A>F-x-w&&(E=!0,a=d.canvasHeight-A,u=x+w,x=d.canvasMarginTop=a*x/u,w=d.canvasMarginBottom=a*w/u),S>N-T-y&&(L=!0,a=d.canvasWidth-S,u=T+y,T=d.canvasMarginLeft=a*T/u,y=d.canvasMarginRight=a*y/u),o=x>d.canvasTop?x-d.canvasTop:0,i=w>F-d.canvasBottom?w+d.canvasBottom-F:0,n=T>d.canvasLeft?T-d.canvasLeft:0,l=y>N-d.canvasRight?y+d.canvasRight-N:0,this._allocateSpace({top:o,bottom:i,left:n,right:l}),E&&(u=D+M,(s=d.canvasHeight)>A&&(o=(a=s-A)*D/u,i=a*M/u),this._allocateSpace({top:o,bottom:i})),L&&(u=R+_,(h=d.canvasWidth)>S&&(n=(a=h-S)*R/u,l=a*_/u),this._allocateSpace({left:n,right:l})),void 0!==d.origCanvasLeftMargin&&(d.canvasWidth=c(d.canvasWidth+d.canvasLeft-d.origCanvasLeftMargin,.2*d.availableWidth),d.canvasLeft=d.origCanvasLeftMargin),p.setDimension({top:d.canvasTop,left:d.canvasLeft,width:d.canvasWidth,height:d.canvasHeight})},a._manageCaptionSpacing=function(t){var e,a,o,i,n,l=this.config,u=this.getChildren(),d=u.caption&&u.caption[0],g=u.subCaption&&u.subCaption[0],p=d.config,f=g.config,m=d.components,v=this.getFromEnv("dataSource").chart,b=this.getFromEnv("smartLabel"),k=(0,r.parseUnsafeString)(v.caption),C=(0,r.parseUnsafeString)(v.subcaption),x=p.captionPadding=(0,r.pluckNumber)(v.captionpadding,2),w=u.chartMenuBar&&u.chartMenuBar[0],T=w&&w.getLogicalSpace(),y=l.height-(T&&T.height||0),A=0,S=0,F=c(u.canvas&&u.canvas[0].config.canvasBorderThickness,0),N=0,E=t,L={};return.7*y>3&&(x<F&&(x=F+2),p.captionPadding=f.captionPadding=x,k!==r.BLANKSTRING&&(i=p.style,A=p.captionLineHeight=h(parseFloat((0,r.pluck)(i.fontHeight,i.lineHeight),10),12)),C!==r.BLANKSTRING&&(n=f.style,S=h(parseInt((0,r.pluck)(n.lineHeight,n.fontHeight),10),12)),b.useEllipsesOnOverflow(l.useEllipsesWhenOverflow),(A>0||S>0)&&(b.setStyle(i),(a=b.getSmartText(k,E,y)).width>0&&(a.width+=2,N=a.height),b.setStyle(n),(o=b.getSmartText(C,E,y-N)).width>0&&(o.width+=2),p.captionSubCaptionGap=a.height+0+.2*S,e=Math.max(a.width,o.width),p.height=N=a.height,p.width=a.width,p.tooltext&&(m.originalText=a.tooltext),f.height=N=o.height,f.width=o.width,f.tooltext&&(m.originalText=o.tooltext),e=Math.max(a.width,o.width),p.captionPadding=x=s(t-e,x),e>0&&(e=s(t,e+x)),p.maxCaptionWidth=f.maxCaptionWidth=e,p.isOnLeft?L.left=e:L.right=e)),L},a._manageCaptionPosition=function(){var t=this.config,e=this.getChildren("caption")[0],a=this.getChildren("subCaption")[0],o=e.config,i=a.config,n=o.captionPosition,l=c(o.width,i.width),s=t.borderWidth||0,h=t.height,u=(t.sparkValues||{}).openValueWidth||0,d=o.captionPadding,g=o.captionSubCaptionGap;switch(n){case r.POSITION_MIDDLE:o.y=(h-(o.height+i.height))/2+.5*(o._offsetHeight||0);break;case r.POSITION_BOTTOM:o.y=h-(o.height+i.height)-t.marginBottom-s;break;default:o.y=t.marginTop+s+(o._offsetHeight||0)}i.y=o.y+g,o.isOnLeft?(o.align=i.align=r.POSITION_END,o.x=i.x=t.canvasLeft-(s+u+2+d)+t.borderWidth):(o.align=i.align=r.POSITION_START,o.x=i.x=t.width-t.marginRight-l-s)},a._feedAxesRawData=function(){var e=t.prototype._feedAxesRawData.call(this),a=e.xAxisConf[0],o=e.yAxisConf[0],i=this.getFromEnv("chart-attrib"),n=this.getFromEnv("color-manager"),l=(0,r.pluckNumber)(i.periodlength,0);return a.lines=o.lines=a.band=o.band={isDraw:0},l&&(a.alternateGridColor=(0,r.pluck)(i.periodcolor,n.getColor("periodColor")),a.alternateGridAlpha=(0,r.pluck)(i.periodalpha,100),a.showAlternateGridColor=!0,a.categoryDivLinesFromZero=0,a.periodLength=l,a.band={isDraw:1}),e},a._checkInvalidSpecificData=function(){var t=this.getFromEnv("dataSource").dataset;if(!(t&&t.length&&t[0].data&&t[0].data.length))return!0},e}(n["default"]);e["default"]=d},1135:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(555)),l=a(232),s=o(a(1136)),c=function(){var t,e,a,o,i,n,l,s=this.getFromEnv("chart"),c=s.config,h=c.dataLabelStyle,u=c.valuepadding+2,d=this.getContainer("labelGroup"),g=this.getFromEnv("animationManager"),p=this.getGraphicalElement("closeValue"),f=this.getGraphicalElement("openValue"),m=this.getGraphicalElement("startBraces"),v=this.getGraphicalElement("highValue"),b=this.getGraphicalElement("separator"),k=this.getGraphicalElement("lowValue"),C=this.getGraphicalElement("endBraces"),x=c.sparkValues||(c.sparkValues={}),w=this.getFromEnv("smartLabel"),T="[",y="]",A="|",S={"class":"fusioncharts-label","text-anchor":r.POSITION_END,fill:h.color,"font-size":h.fontSize,"font-weight":h.fontWeight,"font-style":h.fontStyle,"font-family":h.fontFamily,visibility:"visible"},F={x:0,y:0};s.getChildContainer("datalabelsGroup").attr({"clip-rect":null}),F.y=.5*c.canvasHeight+c.canvasTop,F.x=c.canvasLeft-u,(x.openValue&&x.openValue.label||e)&&(e=g.setAnimation({el:f||"text",state:"appearing",container:d,attr:{text:x.openValue.label,x:F.x,y:F.y,fill:x.openValue.color||S.fill,"text-anchor":r.POSITION_END,"line-height":h.lineHeight,"text-bound":[h.backgroundColor,h.borderColor,h.borderThickness,h.borderPadding,h.borderRadius,h.borderDash],visibility:"visible"},label:"label",component:this}),f||this.addGraphicalElement("openValue",e)),S["text-anchor"]=r.POSITION_START,F.x=c.canvasWidth+c.canvasLeft+u,(x.closeValue&&x.closeValue.label||t)&&(t=g.setAnimation({el:p||"text",container:d,state:"appearing",attr:{text:x.closeValue.label,x:F.x,y:F.y,fill:x.closeValue.color||S.fill,"text-anchor":r.POSITION_START,"line-height":h.lineHeight,"text-bound":[h.backgroundColor,h.borderColor,h.borderThickness,h.borderPadding,h.borderRadius,h.borderDash],visibility:"visible"},label:"label",component:this}),p||this.addGraphicalElement("closeValue",t),F.x+=x.closeValue.smartObj&&x.closeValue.smartObj.width+2+u||0),(x.highLowValue&&x.highLowValue.label||o)&&(x.highLowValue&&x.highLowValue.label===r.BLANKSTRING&&(A=T=y=r.BLANKSTRING),w.useEllipsesOnOverflow(c.useEllipsesWhenOverflow),w.setStyle(h),a=g.setAnimation({el:m||"text",state:"appearing",container:d,attr:{text:T,x:F.x,y:F.y,"text-anchor":r.POSITION_START,visibility:"visible"},label:"label",component:this}),m||this.addGraphicalElement("startBraces",a),F.x+=w.getSmartText(T).width,o=g.setAnimation({el:v||"text",state:"appearing",container:d,attr:{text:x.highValue.label,x:F.x,y:F.y,"text-anchor":r.POSITION_START,fill:x.highValue.color||S.fill,visibility:"visible"},label:"label",component:this}),v||this.addGraphicalElement("highValue",o),F.x+=w.getSmartText(x.highValue.label).width,i=g.setAnimation({el:b||"text",state:"appearing",container:d,attr:{text:A,x:F.x,y:F.y,"text-anchor":r.POSITION_START,visibility:"visible"},label:"label",component:this}),b||this.addGraphicalElement("separator",i),F.x+=w.getSmartText(A).width,n=g.setAnimation({el:k||"text",container:d,state:"appearing",attr:{text:x.lowValue.label,x:F.x,y:F.y,"text-anchor":r.POSITION_START,fill:x.lowValue.color||S.fill,visibility:"visible"},label:"label",component:this}),k||this.addGraphicalElement("lowValue",n),F.x+=w.getSmartText(x.lowValue.label).width,l=g.setAnimation({el:C||"text",state:"appearing",container:d,attr:{text:y,x:F.x,y:F.y,"text-anchor":r.POSITION_START,visibility:"visible"},label:"label",component:this}),C||this.addGraphicalElement("endBraces",l)),this.labelDrawn=!0};(0,l.addDep)({name:"sparklineAnimation",type:"animationRule",extension:s["default"]});var h=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"sparkLine"},a.parseAttributes=function(){t.prototype.parseAttributes.call(this);var e=this.getFromEnv("chart"),a=this.config,o=this.config.JSONData,i=e.getFromEnv("chart-attrib");a.showValues=(0,r.pluckNumber)(o.showvalues,i.showvalues,0),a.linethickness=(0,r.pluckNumber)(o.linethickness,i.linethickness,1)},a._setConfigure=function(e){t.prototype._setConfigure.call(this);var a,o,i,n,l,s,c,h,u,d,g,p,f,m,v,b,k=this.getFromEnv("chart"),C=this.config,x=this.config.JSONData,w=k.getFromEnv("dataSource").chart,T=e||x.data,y=this.getFromEnv("xAxis"),A=e&&e.data.length||y.getTicksLen(),S=this.getFromEnv("color-manager"),F=k.config,N=(0,r.parseColor)((0,r.pluck)(w.opencolor,"0099FF")),E=(0,r.parseColor)((0,r.pluck)(w.closecolor,"0099FF")),L=(0,r.parseColor)((0,r.pluck)(w.highcolor,"00CC00")),D=(0,r.parseColor)((0,r.pluck)(w.lowcolor,"CC0000")),M=(0,r.parseColor)((0,r.pluck)(w.anchorcolor,S.getColor("plotFillColor"))),R=(0,r.pluckNumber)(w.showopenanchor,w.drawanchors,w.showanchors,1),_=(0,r.pluckNumber)(w.showcloseanchor,w.drawanchors,w.showanchors,1),I=(0,r.pluckNumber)(w.showhighanchor,w.drawanchors,w.showanchors,1),V=(0,r.pluckNumber)(w.showlowanchor,w.drawanchors,w.showanchors,1),O=(0,r.pluckNumber)(w.anchoralpha,100),P=(0,r.pluckNumber)(w.drawanchors,w.showanchors,0)?(0,r.pluckNumber)(w.anchoralpha,100):0,G=(0,r.pluck)(w.linecolor,S.getColor("plotFillColor"));for(i=this.components.data,h=C.maxValue,u=C.minValue,C.shadow={opacity:(0,r.pluckNumber)(w.showshadow,0)?C.alpha/100:0},(n=(o=i[0]).config).anchorProps.bgColor=(0,r.pluck)(o.anchorbgcolor,N),n.anchorProps.enabled=!!R,n.anchorProps.bgAlpha=R?d:0,n.anchorProps.enabled&&n.hoverEffects&&(n.hoverEffects.anchorColor=(0,r.pluck)(w.openhovercolor,w.anchorhovercolor,w.plotfillhovercolor,(0,r.getLightColor)(N,70)),n.hoverEffects.anchorBgAlpha=(0,r.pluckNumber)(w.openhoveralpha,w.anchorhoveralpha,w.plotfillhoveralpha,100)),f=n.displayValue,(n=(o=i[A-1]).config).anchorProps.bgColor=(0,r.pluck)(o.anchorbgcolor,E),n.anchorProps.enabled=!!_,n.anchorProps.bgAlpha=_?d:0,n.anchorProps.enabled&&n.hoverEffects&&(n.hoverEffects.anchorColor=(0,r.pluck)(w.closehovercolor,w.anchorhovercolor,w.plotfillhovercolor,(0,r.getLightColor)(E,70)),n.hoverEffects.anchorBgAlpha=(0,r.pluckNumber)(w.closehoveralpha,w.anchorhoveralpha,w.plotfillhoveralpha,100)),b=n.displayValue,l=0;l<A;l++)n=(o=i[l]).config,a=T[l],d=(0,r.pluckNumber)(a.anchorbgalpha,O),C.maxRadius=-Infinity,0!==l&&l!==A-1&&(n.anchorProps.bgColor=(0,r.pluck)(a.anchorbgcolor,M),n.anchorProps.bgAlpha=(0,r.pluckNumber)(a.anchorbgalpha,P),n.hoverEffects.anchorColor=(0,r.parseColor)((0,r.pluck)(w.anchorhovercolor,w.plotfillhovercolor,(0,r.getLightColor)(G,70))),n.hoverEffects.anchorBgAlpha=(0,r.pluckNumber)(w.lowhoveralpha,w.anchorhoveralpha,w.plotfillhoveralpha,100)),n.dataLabelStyle=this._configureDataLabelStyle(a),n.anchorProps.radius=(0,r.pluckNumber)(w.anchorradius,a.anchorradius,2),n.anchorProps.borderThickness=0,n.hoverEffects.anchorBorderThickness=0,n.hoverEffects.anchorRadius=(0,r.pluckNumber)(w.anchorhoverradius,w.anchorradius,a.anchorradius,3),C.maxRadius=Math.max(n.anchorProps.radius+n.anchorProps.borderThickness/2,C.maxRadius),n.setValue===u&&(n.anchorProps.bgColor=(0,r.pluck)(a.anchorbgcolor,D),n.hoverEffects.anchorColor=(0,r.pluck)(w.lowhovercolor,w.anchorhovercolor,w.plotfillhovercolor,(0,r.getLightColor)(D,70)),n.hoverEffects.anchorBgAlpha=(0,r.pluckNumber)(w.lowhoveralpha,w.anchorhoveralpha,w.plotfillhoveralpha,100),n.anchorProps.enabled=!!V,n.anchorProps.bgAlpha=V?d:0,p=n.displayValue),n.setValue===h&&(n.anchorProps.bgColor=(0,r.pluck)(a.anchorbgcolor,L),n.hoverEffects.anchorColor=(0,r.pluck)(w.highhovercolor,w.anchorhovercolor,w.plotfillhovercolor,(0,r.getLightColor)(L,70)),n.hoverEffects.anchorBgAlpha=(0,r.pluckNumber)(w.highhoveralpha,w.anchorhoveralpha,w.plotfillhoveralpha,100),n.anchorProps.enabled=!!I,n.anchorProps.bgAlpha=I?d:0,g=n.displayValue),null!=n.setValue&&(c=1),n._x=l,n._y=n.setValue;for(s=F.sparkValues={openValue:{color:N},closeValue:{color:E},highValue:{color:L},lowValue:{color:D},highLowValue:{}},c&&(s.openValue.label=(0,r.pluckNumber)(w.showopenvalue,1)?f:r.BLANKSTRING,s.closeValue.label=(0,r.pluckNumber)(w.showclosevalue,1)?b:r.BLANKSTRING,(0,r.pluckNumber)(w.showhighlowvalue,1)&&(s.highLowValue.label="["+g+" | "+p+"]",s.highValue.label=g,s.lowValue.label=p)),l=0;l<A;l++){var B=i[l].config;void 0!==B.setTooltext&&(m=[54,55,56,57,58,59,60,61],v={openValue:s.openValue.label,openDataValue:s.openValue.label,closeValue:s.closeValue.label,closeDataValue:s.closeValue.label,highValue:s.highValue.label,highDataValue:s.highValue.label,lowValue:s.lowValue.label,lowDataValue:s.lowValue.label},B.toolText=(0,r.parseTooltext)(B.setTooltext,m,v,a,w,x),B.finalTooltext=B.setTooltext=B.toolText)}},a.draw=function(){t.prototype.draw.call(this),this._drawSparkValues()},a._drawSparkValues=function(){c.call(this)},e}(n["default"]);e["default"]=h},1136:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i={"*.dataset.sparkLine":o(a(558))["default"]["*.dataset.line"]};e["default"]=i},1137:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e._placeOpenCloseValues=c,e._parseCanvasCosmetics=h,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1134)),l=o(a(1138)),s=Math.min;function c(t){var e,a=this.config,o=this.getFromEnv("smartLabel"),i=a.dataLabelStyle,n=(0,r.pluckNumber)(i.borderThickness,0),l=this.config.valuepadding+2+n,c=0,h=0,u=a.sparkValues||{};return o.useEllipsesOnOverflow(a.useEllipsesWhenOverflow),o.setStyle(i),u.openValue&&u.openValue.label&&(u.openValue.smartObj=o.getSmartText(u.openValue.label),c=u.openValue.smartObj.width+l),u.closeValue&&u.closeValue.label&&(u.closeValue.smartObj=o.getSmartText(u.closeValue.label),h+=u.closeValue.smartObj.width+l),u.highValue&&u.highValue.label&&(u.highValue.smartObj=o.getSmartText(u.highValue.label)),u.lowValue&&u.lowValue.label&&(u.lowValue.smartObj=o.getSmartText(u.lowValue.label)),u.highLowValue&&u.highLowValue.label&&(u.highLowValue.smartObj=o.getSmartText(u.highLowValue.label),h+=u.highLowValue.smartObj.width+l),{left:e=u.openValueWidth=s(c,t),right:u.closeValueWidth=s(h,t-e)}}function h(){var t,e,a,o={},i=this.getFromEnv("dataSource").chart,n=this.getFromEnv("color-manager");return o.canvasBorderRadius=0,t=o.canvasBorderThickness=0,e=o.showCanvasBorder=0,o.canvasBorderWidth=e?t:0,o.canvasBorderColor=(0,r.convertColor)((0,r.pluck)(i.canvasbordercolor,n.getColor("canvasBorderColor"))),o.canBGColor={FCcolor:{color:"ffffff",alpha:0,angle:0,ratio:r.UNDEF}},a=o.shadow=0,o.shadowOnCanvasFill=a&&a.enabled,o.origCanvasTopPad=(0,r.pluckNumber)(i.canvastoppadding,0),o.origCanvasBottomPad=(0,r.pluckNumber)(i.canvasbottompadding,0),o.origCanvasLeftPad=(0,r.pluckNumber)(i.canvasleftpadding,0),o.origCanvasRightPad=(0,r.pluckNumber)(i.canvasrightpadding,0),o.canvasPadding=0,o}var u=function(t){function e(){var e;return(e=t.call(this)||this)._placeOpenCloseValues=c,e._parseCanvasCosmetics=h,e}(0,i["default"])(e,t),e.getName=function(){return"SparkWinLoss"};var a=e.prototype;return a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.drawTrendRegion=0},a.getName=function(){return"SparkWinLoss"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="sparkwinloss Chart",e.singleseries=!0,e.defaultDatasetType="sparkwinloss",e.enablemousetracking=!0,e.yRangeMin=-1,e.yRangeMax=1,e.canvasborderthickness=0},a.getDSdef=function(){return l["default"]},e}(n["default"]);e["default"]=u},1138:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(538)),l=a(232),s=o(a(1139)),c=Math,h=c.min,u=c.max,d=function(){var t=this.getFromEnv("chart"),e=t.config,a=e.dataLabelStyle,o=e.valuepadding+2,i=this.getContainer("labelGroup"),n=e.sparkValues||(e.sparkValues={}),l=this.getGraphicalElement("closeValue"),s=this.getFromEnv("animationManager"),c={"class":"fusioncharts-label","text-anchor":r.POSITION_END,fill:a.color,"font-size":a.fontSize,"font-weight":a.fontWeight,"font-style":a.fontStyle,"font-family":a.fontFamily,visibility:"visible"},h={x:0,y:0};t.getChildContainer("datalabelsGroup").attr({"clip-rect":null}),h.y=.5*e.canvasHeight+e.canvasTop,c["text-anchor"]=r.POSITION_START,h.x=e.canvasWidth+e.canvasLeft+o,n.closeValue&&n.closeValue.label&&(this.addGraphicalElement("closeValue",s.setAnimation({el:l||"text",attr:{text:n.closeValue.label,x:h.x,y:h.y,fill:n.closeValue.color||c.fill,"text-anchor":r.POSITION_START,"line-height":a.lineHeight,"text-bound":[a.backgroundColor,a.borderColor,a.borderThickness,a.borderPadding,a.borderRadius,a.borderDash],visibility:"visible"},container:i,component:this,label:"text"})),h.x+=n.closeValue.smartObj&&n.closeValue.smartObj.width+2+o||0),this.labelDrawn=!0};(0,l.addDep)({name:"sparkwinlossAnimation",type:"animationRule",extension:s["default"]});var g=function(t){function e(){var e;return(e=t.call(this)||this).drawLabel=d,e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"sparkWinLoss"},a._setConfigure=function(e,a){var o,i,n,l,s,c,d,g,p,f,m,v,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V=this.getFromEnv("chart"),O=V.config,P=this.config,G=this.config.JSONData,B=e||G.data,H=B&&B.length,W=this.getFromEnv("xAxis"),z=W.getTicksLen(),j=e&&e.data.length||h(z,H),U=V.getFromEnv("dataSource").chart,X=this.getFromEnv("color-manager"),K=this.index||this.positionIndex,Y=O.showplotborder,J=P.plotColor=X.getPlotColor(K),q=(0,r.pluck)(U.plotfillcolor,X.getColor("plotFillColor")),Z=(0,r.pluck)(U.wincolor,X.getColor("winColor")),$=(0,r.pluck)(U.losscolor,X.getColor("lossColor")),Q=(0,r.pluck)(U.drawcolor,X.getColor("drawColor")),tt=(0,r.pluck)(U.scorelesscolor,X.getColor("scorelessColor")),et=U.winhovercolor,at=U.losshovercolor,ot=U.drawhovercolor,it=U.scorelesshovercolor,rt=0,nt=0,lt=0,st=O.plotborderthickness,ct=O.isroundedges,ht=O.plothovereffect,ut=P.plotfillangle,dt=P.plotBorderDashStyle,gt=this.components.data,pt=V.isBar,ft=V.is3D,mt=P.maxValue||-Infinity,vt=P.minValue||+Infinity;for(gt||(gt=this.components.data=[]),t.prototype._setConfigure.call(this),P.plotgradientcolor=r.BLANKSTRING,_=P.showPlotBorder=(0,r.pluckNumber)(U.showplotborder,P.usePattern?1:0),P.plotborderalpha=s=_?(0,r.pluck)(U.plotborderalpha,n,r.HUNDREDSTRING):0,P.showTooltip=0,O.showtooltip=0,R=0;R<j;R++){switch(e?(d=e&&e.data[R],p=void 0!==a?gt[I=a+R]:gt[I=gt.length-j+R]):(p=gt[R],d=B[R]),f=p&&p.config,p||(p=gt[R]={}),p.config||(f=gt[R].config={}),(d.value||"").toLowerCase()){case"w":J=(0,r.pluck)(d.color,Z,q),v=(0,r.pluck)(d.hovercolor,et,J),f.setValue=g=1,rt+=1;break;case"l":J=(0,r.pluck)(d.color,$,q),v=(0,r.pluck)(d.hovercolor,at,J),f.setValue=g=-1,nt+=1;break;case"d":J=(0,r.pluck)(d.color,Q,q),v=(0,r.pluck)(d.hovercolor,ot,J),f.setValue=g=.1,lt+=1;break;default:f.setValue=g=null}1===Number(d.scoreless)&&(J=(0,r.pluck)(d.color,tt,q),v=(0,r.pluck)(d.hovercolor,it,d.color,tt,v)),f.originalPlotColor=(0,r.hashify)(J),f.toolText=!1,f.setLink=(0,r.pluck)(d.link),f.setDisplayValue=(0,r.parseUnsafeString)(d.displayvalue),L=(0,r.pluckNumber)(d.dashed),D=(0,r.pluckNumber)(d.dashlen,void 0),M=i=(0,r.pluckNumber)(d.dashgap,P.plotDashGap),null!==g&&(mt=u(mt,g),vt=h(vt,g)),f.plotBorderDashStyle=c=1===L?(0,r.getDashStyle)(D,M):0===L?"none":dt,n=(0,r.pluck)(d.alpha,P.plotfillalpha),s=(0,r.pluck)(d.alpha,P.plotborderalpha,n).toString(),g<0&&!ct&&(o=P.plotfillAngle,ut=pt?180-ut:360-ut),f.plotbordercolor=P.usePattern&&!U.plotbordercolor?J:P.plotbordercolor,f.colorArr=m=(0,r.getColumnColor)(J+","+P.plotgradientcolor,n,l=P.plotfillratio,ut,ct,f.plotbordercolor,s,pt?1:0,!!ft),f.label=(0,r.getValidValue)((0,r.parseUnsafeString)(W.getLabel((0,r.pluckNumber)(I-j,R)).label)),0!==ht&&(v=(0,r.pluck)(d.hovercolor,G.hovercolor,U.plotfillhovercolor,U.columnhovercolor,J),b=(0,r.pluck)(d.hoveralpha,G.hoveralpha,U.plotfillhoveralpha,U.columnhoveralpha,n),!(k=(0,r.pluck)(d.hovergradientcolor,G.hovergradientcolor,U.plothovergradientcolor,P.plotgradientcolor))&&(k=""),C=(0,r.pluck)(d.hoverratio,G.hoverratio,U.plothoverratio,l),x=(0,r.pluckNumber)(360-d.hoverangle,360-G.hoverangle,360-U.plothoverangle,ut),w=(0,r.pluck)(d.borderhovercolor,G.borderhovercolor,U.plotborderhovercolor,P.plotbordercolor),T=(0,r.pluck)(d.borderhoveralpha,G.borderhoveralpha,U.plotborderhoveralpha,s,n),y=(0,r.pluckNumber)(d.borderhoverthickness,G.borderhoverthickness,U.plotborderhoverthickness,st),A=(0,r.pluckNumber)(d.borderhoverdashed,G.borderhoverdashed,U.plotborderhoverdashed),S=(0,r.pluckNumber)(d.borderhoverdashgap,G.borderhoverdashgap,U.plotborderhoverdashgap,void 0),F=(0,r.pluckNumber)(d.borderhoverdashlen,G.borderhoverdashlen,U.plotborderhoverdashlen,i),N=A?(0,r.getDashStyle)(F,S):c,f.hoverColor=v,1===ht&&v===J&&(v=(0,r.getLightColor)(v,70)),E=(0,r.getColumnColor)(v+","+k,b,C,x,ct,w,T.toString(),pt?1:0,!!ft),f.setRolloutAttr={fill:ft?[(0,r.toRaphaelColor)(m[0]),!O.use3dlighting]:(0,r.toRaphaelColor)(m[0]),stroke:Y&&(0,r.toRaphaelColor)(m[1]),"stroke-width":st,"stroke-dasharray":c},f.setRolloverAttr={fill:ft?[(0,r.toRaphaelColor)(E[0]),!O.use3dlighting]:(0,r.toRaphaelColor)(E[0]),stroke:Y&&(0,r.toRaphaelColor)(E[1]),"stroke-width":y,"stroke-dasharray":N}),o&&(ut=o),I++,f._x=R,f._y=g}P.maxValue=1,P.minValue=-1,1===(0,r.pluckNumber)(U.showvalue,1)?(O.sparkValues={closeValue:{}},O.sparkValues.closeValue.label=rt+"-"+nt+(lt>0?"-"+lt:r.BLANKSTRING)):O.sparkValues=void 0},e}(n["default"]);e["default"]=g},1139:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i={"initial.dataset.sparkWinLoss":o(a(539))["default"]["initial.dataset.column"]};e["default"]=i},1140:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1141))["default"];e["default"]=i},1141:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1134)),l=o(a(1142)),s=Math.max,c=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t),e.getName=function(){return"SparkColumn"};var a=e.prototype;return a.getName=function(){return"SparkColumn"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="sparkcolumn Chart",e.singleseries=!1,e.defaultDatasetType="sparkcolumn",e.showplotborder=0,e.enablemousetracking=!0,e.canvasborderthickness=1},a.getDSdef=function(){return l["default"]},a._parseCanvasCosmetics=function(){var t,e,a,o,i,n={},l=this.getFromEnv("dataSource").chart,c=this.getFromEnv("color-manager"),h=this.config.is3D?r.chartPaletteStr.chart3D:r.chartPaletteStr.chart2D,u=n.isRoundEdges=(0,r.pluckNumber)(l.useroundedges,0),d=(0,r.pluckNumber)(l.showxaxisline,l.showyaxisline,0)?0:1;return n.canvasBorderRadius=(0,r.pluckNumber)(l.plotborderradius,u?2:0),a=n.showCanvasBorder=Boolean((0,r.pluckNumber)(l.showcanvasborder,d,t,u?0:1)),i=n.oriCanvasBorderThickness=s((0,r.pluckNumber)(l.canvasborderthickness,u?0:(0,r.pluckNumber)(this.config.canvasborderthickness,1),0)),t=n.canvasBorderWidth=this.is3D?0:a?i:0,n.canvasBorderColor=(0,r.convertColor)((0,r.pluck)(l.canvasbordercolor,c.getColor("canvasBorderColor")),(0,r.pluck)(l.canvasborderalpha,c.getColor("canvasBorderAlpha"))),e=n.canBGAlpha=(0,r.pluck)(l.canvasbgalpha,c.getColor("canvasBgAlpha")),n.canBGColor={FCcolor:{color:(0,r.pluck)(l.canvasbgcolor,c.getColor(h.canvasBgColor)),alpha:(0,r.pluck)(l.canvasbgalpha,100),angle:(0,r.pluck)(l.canvasbgangle,0),ratio:(0,r.pluck)(l.canvasbgratio)}},o=n.shadow=(0,r.pluckNumber)(l.showshadow,u,0)&&u?{enabled:!0,opacity:e/100}:0,n.shadowOnCanvasFill=o&&o.enabled,n.canvasPadding=(0,r.pluckNumber)(l.canvaspadding,0),n.origCanvasTopPad=(0,r.pluckNumber)(l.canvastoppadding,0),n.origCanvasBottomPad=(0,r.pluckNumber)(l.canvasbottompadding,0),n.origCanvasLeftPad=(0,r.pluckNumber)(l.canvasleftpadding,0),n.origCanvasRightPad=(0,r.pluckNumber)(l.canvasrightpadding,0),n},e}(n["default"]);e["default"]=c},1142:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=a(232),l=o(a(538)),s=o(a(1143)),c=Math.min;(0,n.addDep)({name:"sparkcolumnAnimation",type:"animationRule",extension:s["default"]});var h=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"sparkColumn"},a.parseAttributes=function(){t.prototype.parseAttributes.call(this);var e=this.getFromEnv("chart"),a=this.config,o=this.config.JSONData,i=e.getFromEnv("chart-attrib");a.showValues=(0,r.pluckNumber)(o.showvalues,i.showvalues,0)},a._setConfigure=function(e){var a,o,i,n,l,s,h,u,d,g,p,f,m,v,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I=this.getFromEnv("chart"),V=I.getFromEnv("dataSource").chart,O=this.config,P=I.config,G=this.config.JSONData,B=e||G.data,H=B&&B.length,W=this.getFromEnv("xAxis").getTicksLen(),z=e&&e.data.length||c(W,H),j=P.plothovereffect,U=this.getFromEnv("color-manager"),X=P.useroundedges;for(O.plotgradientcolor=r.BLANKSTRING,O.showvalues=(0,r.pluckNumber)(G.showvalues,V.showvalues,0),O.showShadow=(0,r.pluckNumber)(V.showshadow,0),t.prototype._setConfigure.call(this),M=this.components.data,R=O.maxValue,_=O.minValue,a=(0,r.pluck)(V.plotfillcolor,U.getColor("plotFillColor")),p=(0,r.pluck)(V.plotfillalpha,r.HUNDREDSTRING),f=(0,r.pluck)(V.plotborderalpha,r.HUNDREDSTRING),m=(0,r.pluck)(V.plotbordercolor,a),v=(0,r.pluck)(V.highcolor,"000000"),b=(0,r.pluck)(V.lowcolor,"000000"),k=(0,r.pluck)(V.highbordercolor,V.plotbordercolor,v),C=(0,r.pluck)(V.lowbordercolor,V.plotbordercolor,b),E=0;E<z;E++){if(A=B[E],null,o=a,i=m,(g=(S=M[E]).config).setValue===R&&(o=v,i=k,x=g.displayValue),S.config.setValue===_&&(o=b,i=C,w=g.displayValue),g.originalPlotColor=(0,r.hashify)(o),g.plotbordercolor=i,g.colorArr=F=(0,r.getColumnColor)(o+r.COMMASTRING+O.plotgradientcolor,p,"0","90",X,i,f,0,0),0!==j&&F){for(l=s=void 0,g.setValue===R&&(l=V.highhovercolor,s=V.highhoveralpha),S.config.setValue===_&&(l=V.lowhovercolor,s=V.lowhoveralpha),L=(l=(l=n=(0,r.pluck)(A.hovercolor,G.hovercolor,l,V.plotfillhovercolor,V.columnhovercolor,F[0].FCcolor.color)).split(/\s{0,},\s{0,}/)).length,D=0;D<L;D++)l[D]=(0,r.getLightColor)(l[D],70);l=l.join(","),s=(0,r.pluck)(A.hoveralpha,G.hoveralpha,s,V.plotfillhoveralpha,V.columnhoveralpha,p),g.hoverColor=n,g.hoverAlpha=s,!(h=(0,r.pluck)(A.hovergradientcolor,G.hovergradientcolor,V.plothovergradientcolor,O.plotgradientcolor))&&(h=r.BLANKSTRING),u=(0,r.pluck)(A.borderhovercolor,G.borderhovercolor,V.plotborderhovercolor,O.plotbordercolor),d=(0,r.pluck)(A.borderhoveralpha,G.borderhoveralpha,V.plotborderhoveralpha,V.plotfillhoveralpha,f,p),1===j&&l===F[0].FCcolor.color&&(l=(0,r.getLightColor)(l,70)),N=(0,r.getColumnColor)(l+r.COMMASTRING+h,s,"0","90",X,u,d.toString(),0,0),g.setRolloutAttr={fill:(0,r.toRaphaelColor)(F[0]),stroke:void 0,"stroke-width":void 0},g.setRolloverAttr={fill:(0,r.toRaphaelColor)(N[0]),stroke:void 0,"stroke-width":void 0}}g._x=E,g._y=g.setValue}for(E=0;E<z;E++){var K=M[E].config;void 0!==K.setTooltext&&(T=[56,57,60,61],y={highValue:x,highDataValue:x,lowValue:w,lowDataValue:w},K.toolText=(0,r.parseTooltext)(K.setTooltext,T,y,A,V,G),K.finalTooltext=K.setTooltext=K.toolText)}},e}(l["default"]);e["default"]=h},1143:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i={"initial.dataset.sparkColumn":o(a(539))["default"]["initial.dataset.column"]};e["default"]=i},1144:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1137))["default"];e["default"]=i},1145:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1146))["default"];e["default"]=i},1146:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(673),n=o(a(1147)),l=o(a(1151)),s=function(t){function e(){var e;return(e=t.call(this)||this).axisPaddingLeft=0,e.axisPaddingRight=0,e}(0,i["default"])(e,t),e.getName=function(){return"RealtimeArea"};var a=e.prototype;return a.getName=function(){return"RealtimeArea"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),r._setDefaultConfig.call(this);var e=this.config;e.defaultDatasetType="realtimearea",e.enablemousetracking=!0},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){},e}(n["default"]);e["default"]=s},1147:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(242)),r=o(a(238)),n=o(a(565)),l=a(224),s=o(a(1148)),c=o(a(628)),h=o(a(284)),u=o(a(322)),d=o(a(222)),g=a(232),p=o(a(1150)),f=a(1088),m=o(a(952)),v=a(236),b=o(a(1089)),k=l.preDefStr.visibleStr;function C(t,e,a){var o=l.BLANKSTRING;(t&&t.toString||t===l.BLANKSTRING||0===t)&&(o="value="+t.toString()),(e&&e.toString||e===l.BLANKSTRING)&&(o=o+"&label="+e.toString()),(a&&a.toString||a===l.BLANKSTRING)&&(o=o+"&id="+a.toString()),o&&this.feedData(o)}(0,g.addDep)({name:"realtimeColumnChartAnimation",type:"animationRule",extension:p["default"]}),d["default"].addDep(b["default"]);var x=function(t){function e(){var e;e=t.call(this)||this;var a=(0,i["default"])(e);return d["default"].addDep(h["default"]),d["default"].addDep(u["default"]),e.showRTvalue=!0,e.canvasPadding=!0,e.isRealTime=!0,e.rtManageSpace=!0,e.transposeAxis=!0,e._setData=C,e.eiMethods=f.eiMethods,e._drawRTValue=function(){a._drawRealTimeValue()},e}(0,r["default"])(e,t),e.getName=function(){return"RealtimeColumn"};var a=e.prototype;return a.getName=function(){return"RealtimeColumn"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.defaultDatasetType="realtimecolumn",e.enablemousetracking=!0},a.asyncRealTimeValueDraw=function(){this.addJob("realtimevaluedraw",this._drawRTValue,v.priorityList&&v.priorityList.draw)},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e),this.config.drawTrendRegion=0},a._setCategories=function(){var t,e=this.getChildren("xAxis")[0],a=[],o=this.config.realTimeConfig,i=o&&o.clear?void 0:this.getFromEnv("dataSource").categories&&this.getFromEnv("dataSource").categories[0]&&this.getFromEnv("dataSource").categories[0].category,r=i&&Array.isArray(i)&&i.filter((function(t){return!t.vline})).length||0,n=o.numDisplaySets;r<n?(a.length=n-r,t=i?a.concat(i):a):t=r>n&&n>=0?n?i.slice(-n):[]:i.slice(0),e.setTickValues(t)},a._realTimeValuePositioning=function(t){var e,a,o=this.getChildren(),i=this.getFromEnv("smartLabel"),r=this.config,n=r.realTimeConfig||(r.realTimeConfig={}),s=n.realTimeValuePadding,c=o.xAxis[0].config,h=c.trend.trendStyle,u=n.style={color:(0,l.convertColor)((0,l.pluck)(n.realtimeValueFontColor,h.color),(0,l.pluck)(c.trendlineAlpha,99)),fontFamily:(0,l.pluck)(n.realtimeValueFont,h.fontFamily),fontSize:(0,l.pluck)(n.realtimeValueFontSize,h.fontSize),fontWeight:(0,l.pluck)(n.fontWeight,h.fontWeight),lineHeight:(0,l.pluckNumber)(h.lineHeight)};return i.useEllipsesOnOverflow(r.useEllipsesWhenOverflow),i.setStyle(u),n.height=e=i.getOriSize(l.TESTSTR).height,n.canvasBottom=r.canvasBottom,(a=e+s)>t&&(a=t),{bottom:a}},a.draw=function(){t.prototype.draw.call(this),this.showRTvalue&&this.config.realTimeConfig.showRTValue&&this._drawRealTimeValue()},a._drawRealTimeValue=function(){var t,e,a,o,i,r,n=this.getFromEnv("chart"),s=this.config,c=n.getDatasets(),h=n.getFromEnv("animationManager"),u=this.getFromEnv("smartLabel"),d=s.realTimeConfig,g=d.realtimeValueSeparator,p=c.length,f=l.BLANKSTRING,m=d.canvasBottom,v=d.height,b=s.canvasLeft,C=s.canvasRight,x=d.style||{},w=this.getGraphicalElement("realTimeValue"),T=this.getChildContainer(),y=n.getContainer().parentGroup,A=T.realTimeValueGroup;if(this.removeJob("realtimevaluedraw"),d.clear&&t&&h.setAnimation({el:t,attr:{text:l.BLANKSTRING},component:this,label:"label"}),A){for(r=0;r<p;r++)f+=(i=(o=(a=c[r].components.data)[a.length-1])&&o.config.displayValue)?void 0===i?l.BLANKSTRING:i+g:l.BLANKSTRING;f=f.substring(0,f.length-g.length),u.useEllipsesOnOverflow(s.useEllipsesWhenOverflow),u.setStyle(x),e={x:(b+C)/2||0,y:m-v/2||0,"font-size":x.fontSize,"font-weight":x.fontWeight,"font-family":x.fontFamily,"line-height":x.lineHeight,text:f,fill:x.color,visibility:k},t=h.setAnimation({el:w||"text",attr:e,container:A,label:"rtValue",component:n}),!0,w||this.addGraphicalElement("realTimeValue",t)}else A=n.addChildContainer("realTimeValueGroup",h.setAnimation({el:"group",attr:{name:"realTimeValue"},container:y,label:"group",component:n}).insertBefore(T.datalabelsGroup))},a._hideRealTimeValue=function(){var t=this.getGraphicalElement("realTimeValue");t&&t.hide()},a._setRTmenu=function(t,e){f._setRTmenu.call(this,t,e)},a._getDataJSON=function(){return this.config.realTimeConfig.legacyUpdateObj||{values:[]}},a._checkInvalidSpecificData=function(){var t=this.getFromEnv("dataSource").dataset,e=this.getChildren("dataStreamer")&&this.getChildren("dataStreamer")[0];if(!t)return e&&e._stopUpdate(),!0},a._checkInvalidData=function(){var t=this.getFromEnv("dataSource"),e=this.getChildren("dataStreamer")&&this.getChildren("dataStreamer")[0];if(t==={})return e&&e._stopUpdate(),!0},a.getDSGroupdef=function(){return c["default"]},a.getDSdef=function(){return s["default"]},a._realTimeConfigure=function(){f._realTimeConfigure.call(this)},a._stopUpdate=function(t){f._stopUpdate.call(this,t)},a._restartUpdate=function(){f._restartUpdate.call(this)},a._isUpdateActive=function(){return f._isUpdateActive.call(this)},a._getData=function(){return m["default"].call(this)},a.realTimeUpdate=function(t){f.realTimeUpdate.call(this,t)},a._RTmanageSpace=function(){f._RTmanageSpace.call(this)},a.realTimeDraw=function(t){void 0===t&&(t={}),f.realTimeDraw.call(this,t)},a.feedData=function(t){return f.feedData.call(this,t)},a._linearDataParser=function(t){return f._linearDataParser.call(this,t)},a._clearChart=function(t){f._clearChart.call(this,t)},e}(n["default"]);e["default"]=x},1148:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=e.resetCatPos=e._realTimeConfigure=void 0;var i=o(a(238)),r=o(a(538)),n=a(232),l=o(a(1149));(0,n.addDep)({name:"realtimeColumnAnimation",type:"animationRule",extension:l["default"]});var s=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a._realTimeConfigure=function(t){var e,a=this.getFromEnv("chart"),o=this.components.data,i=[],r=a.config.realTimeConfig.numDisplaySets;(e=t?0:Math.min(this.getFromEnv("xAxis").getTicksLen(),o&&o.length))<r?(i.length=r-e,this.components.data=i.concat(o)):e>r&&this.components.data.splice(r,e-r),this.resetCatPos&&this.resetCatPos()},a.getType=function(){return"dataset"},a.getName=function(){return"realtimeColumn"},a.resetCatPos=function(){var t,e=this.components.data,a=e.length;if(e&&a)for(t=0;t<a;t++)e[t]&&e[t].config&&(e[t].config._x=t)},e}(r["default"]),c=s.prototype._realTimeConfigure,h=s.prototype.resetCatPos;e.resetCatPos=h,e._realTimeConfigure=c;var u=s;e["default"]=u},1149:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i={"initial.dataset.realtimeColumn":o(a(539))["default"]["initial.dataset.column"]};e["default"]=i},1150:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;e["default"]={"initial.chartAPI.RealtimeColumn":function(){return{"*":null}}}},1151:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(556)),n=a(1148),l=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a._realTimeConfigure=function(t){n._realTimeConfigure.call(this,t)},a.getType=function(){return"dataset"},a.getName=function(){return"realTimeArea"},e}(r["default"]);l.prototype.resetCatPos=n.resetCatPos;var s=l;e["default"]=s},1152:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1147))["default"];e["default"]=i},1153:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1154))["default"];e["default"]=i},1154:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(673),n=o(a(1147)),l=o(a(1155)),s=function(t){function e(){var e;return(e=t.call(this)||this).axisPaddingLeft=0,e.axisPaddingRight=0,e}(0,i["default"])(e,t),e.getName=function(){return"RealtimeLine"};var a=e.prototype;return a.getName=function(){return"RealtimeLine"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),r._setDefaultConfig.call(this);var e=this.config;e.defaultDatasetType="realtimeline",e.zeroplanethickness=1,e.zeroplanealpha=40,e.showzeroplaneontop=0,e.enablemousetracking=!0},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){},e}(n["default"]);e["default"]=s},1155:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(555)),n=a(1148),l=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a._realTimeConfigure=function(t){n._realTimeConfigure.call(this,t)},a.getType=function(){return"dataset"},a.getName=function(){return"realtimeLine"},e}(r["default"]);l.prototype.resetCatPos=n.resetCatPos;var s=l;e["default"]=s},1156:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1157))["default"];e["default"]=i},1157:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(673),n=o(a(1146)),l=o(a(1151)),s=o(a(637)),c=a(224),h=o(a(230)),u=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t),e.getName=function(){return"RealtimeStackedArea"};var a=e.prototype;return a.getName=function(){return"RealtimeStackedArea"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),r._setDefaultConfig.call(this);var e=this.config;e.defaultDatasetType="realtimearea",e.isstacked=!0,e.enablemousetracking=!0,this.addToEnv("useImprovedLabelPlacement",!0),this.addToEnv("useLinePlotGroupForAnchorPlacement",!0)},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a=this.config,o=this.getFromEnv("chart-attrib");a.showSum=(0,h["default"])(o.showsum,0),a.showSum&&(a.valueposition=(0,c.parseUnsafeString)((0,c.pluck)(o.valueposition,"below")))},a.getDSdef=function(){return l["default"]},a.getDSGroupdef=function(){return s["default"]},e}(n["default"]);e["default"]=u},1158:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1159))["default"];e["default"]=i},1159:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1147)),n=o(a(637)),l=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t),e.getName=function(){return"RealtimeStackedColumn"};var a=e.prototype;return a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.isstacked=!0,e.enablemousetracking=!0},a.getName=function(){return"RealtimeStackedColumn"},a.getDSGroupdef=function(){return n["default"]},e}(r["default"]);e["default"]=l},1160:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1161))["default"];e["default"]=i},1161:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(673),n=o(a(1147)),l=o(a(1155)),s=a(607),c=o(a(608)),h=o(a(609)),u=function(t){function e(){var e;return(e=t.call(this)||this).isRealTime=!0,e.axisPaddingLeft=0,e.isDual=!0,e.axisPaddingRight=0,e.getSpecificxAxisConf=s.getSpecificxAxisConf,e.getSpecificyAxisConf=s.getSpecificyAxisConf,e.registerFactory("axis",c["default"],["canvas"]),e.registerFactory("dataset",h["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"RealtimeLineDy"};var a=e.prototype;return a.getName=function(){return"RealtimeLineDy"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this),r._setDefaultConfig.call(this);var e=this.config;e.defaultDatasetType="RealtimeLine",e.zeroplanethickness=1,e.zeroplanealpha=40,e.showzeroplaneontop=0,e.enablemousetracking=!0,e.isdual=!0,e.syncaxislimits=0},a._feedAxesRawData=function(){return s._feedAxesRawData.call(this)},a.getDSdef=function(){return l["default"]},a.getDSType=function(){return"RealtimeLine"},a.getDSGroupdef=function(){},e}(n["default"]);u.prototype.setAxisDimention=s.setAxisDimention;var d=u;e["default"]=d},1162:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1163))["default"];e["default"]=i},1163:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1095)),l=a(1119),s=o(a(1121)),c=o(a(1092)),h=o(a(366)),u=r.BLANK,d=r.preDefStr.POSITION_START,g=r.preDefStr.POSITION_END,p=r.preDefStr.POSITION_BOTTOM,f=r.preDefStr.POSITION_MIDDLE,m=Math,v=m.ceil,b=m.max,k=function(t){function e(){var e;return(e=t.call(this)||this).defaultSeriesType="hbullet",e.gaugeType=1,e.defaultCaptionPadding=5,e.rendererId="hbullet",e.isHorizontal=!0,e.config.isAxisOpposite=!1,e.config.scalePosition=p,e.config.canBeScalePosition="top",e.rtManageSpace=!0,e.ticksOnRight=0,e.hasCanvas=!0,e.isAxisReverse=!1,e.defaultPaletteOptions={paletteColors:[["A6A6A6","CCCCCC","E1E1E1","F0F0F0"],["A7AA95","C4C6B7","DEDFD7","F2F2EE"],["04C2E3","66E7FD","9CEFFE","CEF8FF"],["FA9101","FEB654","FED7A0","FFEDD5"],["FF2B60","FF6C92","FFB9CB","FFE8EE"]],bgColor:["FFFFFF","CFD4BE,F3F5DD","C5DADD,EDFBFE","A86402,FDC16D","FF7CA0,FFD1DD"],bgAngle:[270,270,270,270,270],bgRatio:["0,100","0,100","0,100","0,100","0,100"],bgAlpha:["100","60,50","40,20","20,10","30,30"],toolTipBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],toolTipBorderColor:["545454","545454","415D6F","845001","68001B"],baseFontColor:["333333","60634E","025B6A","A15E01","68001B"],tickColor:["333333","60634E","025B6A","A15E01","68001B"],trendColor:["545454","60634E","415D6F","845001","68001B"],plotFillColor:["545454","60634E","415D6F","845001","68001B"],borderColor:["767575","545454","415D6F","845001","68001B"],borderAlpha:[50,50,50,50,50]},e.showRTvalue=!1,e.canvasPadding=!1,e.defaultPlotShadow=1,e.realtimeEnabled=!0,e.chartleftmargin=15,e.chartrightmargin=15,e.charttopmargin=10,e.chartbottommargin=10,e.showTooltip=0,e.connectTickMarks=0,e.drawPlotlines=!1,e.drawPlotBands=!1,e.isRealTime=!0,e.colorRange=!0,e.registerFactory("dataset",c["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Hbullet"};var a=e.prototype;return a.getName=function(){return"Hbullet"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Horizontal Bullet Gauge",e.defaultDatasetType="bullet",e.singleseries=!0,e.skipCanvasDrawing=!0},a._RTmanageSpace=function(){var t,e,a=this.config,o=this.getChildren("scale")[0];t=(e=this.getChildren("dataset")[0]._manageSpaceHorizontal(.7*a.oriCanvasWidth)).right-a.labelSpace.right,this._allocateSpace({right:t}),o.setAxisDimention({axisLength:a.canvasWidth}),a.labelSpace=e},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),l.configureAttributes.call(this)},a._getData=function(){return l._getData.call(this)},a._spaceManager=function(){var t,e,a,o,i,n=this.config,l=this.getChildren("canvas")[0],s=this.getChildren("dataset")[0],c=this.getChildren("scale")[0],h=this.config.is3D,u=this.getFromEnv("dataSource").chart,d=(0,r.pluckNumber)(u.showborder,h?0:1),g=n.minChartWidth,p=n.minChartHeight,f=n.borderWidth=d?(0,r.pluckNumber)(u.borderthickness,1):0;n.canvasWidth-2*f<g&&(i=(n.canvasWidth-g)/2),n.canvasHeight-2*f<p&&(o=(n.canvasHeight-p)/2),this._allocateSpace({top:o||f,bottom:o||f,left:i||f,right:i||f}),t=.7*n.canvasWidth,this._allocateSpace(c.placeAxis(n.availableHeight)),this._allocateSpace(this._manageActionBarSpace&&this._manageActionBarSpace(.225*n.availableHeight)||{}),n.oriCanvasWidth=n.canvasWidth,e=.225*n.canvasHeight,this._manageChartMenuBar(e),a=b(this.getChildren("subCaption")[0].config.width||0,this.getChildren("caption")[0].config.width||0),n.labelSpace=s._manageSpaceHorizontal(t-.7*a),s._manageSpace&&this._allocateSpace(n.labelSpace),n.oriCanvasWidth-=a,e=.325*n.canvasHeight,l.setDimension({top:n.canvasTop,left:n.canvasLeft,width:n.canvasWidth,height:n.canvasHeight})},a._manageCaptionSpacing=function(){var t,e,a,o,i,n=this.config,l=this.getChildren("caption")[0],s=this.getChildren("subCaption")[0],c=l.config,h=s.config,p=this.getFromEnv("dataSource").chart,f=this.getFromEnv("smartLabel"),m=(0,r.parseUnsafeString)(p.caption),b=(0,r.parseUnsafeString)(p.subcaption),k=(0,r.pluckNumber)(p.captionpadding,2),C=n.height,x=0,w=0,T=0,y=.3*n.width,A={};return.3*C>3&&(c.captionPadding=h.captionPadding=k,m!==u&&(o=c.style,x=c.captionLineHeight=v(parseFloat((0,r.pluck)(o.fontHeight,o.lineHeight),10),12)),b!==u&&(i=h.style,w=v(parseInt((0,r.pluck)(i.lineHeight,i.fontHeight),10),12)),(x>0||w>0)&&(f.useEllipsesOnOverflow(n.useEllipsesWhenOverflow),f.setStyle(o),(e=f.getSmartText(m,y,C)).width>0&&(e.width+=2,T=e.height),f.setStyle(i),(a=f.getSmartText(b,y,C-T)).width>0&&(a.width+=2),c.captionSubCaptionGap=e.height+0+.2*w,t=Math.max(e.width,a.width),c.text=e.text,c.height=T=e.height,c.width=e.width,c.tooltext&&(c.originalText=e.tooltext),h.text=a.text,h.height=T=a.height,h.width=a.width,h.tooltext&&(c.originalText=a.tooltext),(t=Math.max(e.width,a.width))>0&&(t+=k),c.maxCaptionWidth=h.maxCaptionWidth=t,c.isOnLeft?A.left=t:A.right=t)),c.isOnLeft?c.align=h.align=g:c.align=h.align=d,A},a._manageCaptionPosition=function(){var t=this.config,e=this.getChildren("caption")[0],a=this.getChildren("subCaption")[0],o=e.config,i=a.config,r=o.captionPosition,n=b(o.width,i.width),l=t.borderWidth||0,s=o.captionSubCaptionGap;switch(r){case f:o.y=.5*(t.canvasTop+t.canvasHeight);break;case p:o.y=t.canvasBottom-(o.height+i.height);break;default:o.y=t.canvasTop}i.y=o.y+s,o.isOnLeft?o.x=i.x=t.marginLeft+n+l:o.x=i.x=t.width-t.marginRight-n-l},a._feedAxesRawData=function(){var t=this.config,e=this.getFromEnv("color-manager"),a=this.getFromEnv("number-formatter"),o=this.getFromEnv("dataSource").chart,i=r.chartPaletteStr.chart2D,n=(0,r.pluckNumber)(o.ticksbelowgraph,!t.isAxisOpposite),l=(0,r.pluckNumber)((0,h["default"])(o.scaleposition,t.scalePosition)?t.isAxisOpposite:(0,h["default"])(o.scaleposition,t.canBeScalePosition)?!t.isAxisOpposite:void 0,!n),s=(0,r.pluckFontSizeMaintainUnit)(o.outcnvbasefontsize,o.basefontsize,10);return[{isVertical:!this.isHorizontal,isReverse:!1,isOpposit:l,outCanfontFamily:(0,r.pluck)(o.outcnvbasefont,o.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(s),outCanfontSizeWithUnit:s,outCancolor:(0,r.pluck)(o.outcnvbasefontcolor,o.basefontcolor,e.getColor(i.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),useEllipsesWhenOverflow:o.useellipseswhenoverflow,divLineColor:(0,r.pluck)(o.vdivlinecolor,e.getColor(i.divLineColor)),divLineAlpha:(0,r.pluck)(o.vdivlinealpha,e.getColor("divLineAlpha")),divLineThickness:(0,r.pluckNumber)(o.vdivlinethickness,1),divLineIsDashed:Boolean((0,r.pluckNumber)(o.vdivlinedashed,o.vdivlineisdashed,0)),divLineDashLen:(0,r.pluckNumber)(o.vdivlinedashlen,4),divLineDashGap:(0,r.pluckNumber)(o.vdivlinedashgap,2),showAlternateGridColor:(0,r.pluckNumber)(o.showalternatevgridcolor,0),alternateGridColor:(0,r.pluck)(o.alternatevgridcolor,e.getColor("altVGridColor")),alternateGridAlpha:(0,r.pluck)(o.alternatevgridalpha,e.getColor("altVGridAlpha")),numDivLines:o.numvdivlines,labelFont:o.labelfont,labelFontSize:this.computeFontSize(o.labelfontsize),labelFontSizeWithUnit:o.labelfontsize,labelFontColor:o.labelfontcolor,labelAlpha:o.labelalpha,labelFontBold:o.labelfontbold,labelFontItalic:o.labelfontitalic,axisName:o.xaxisname,axisMinValue:a.getCleanValue(o.lowerlimit),axisMaxValue:a.getCleanValue(o.upperlimit),setAdaptiveMin:o.setadaptivexmin,adjustDiv:o.adjusttm,labelDisplay:o.labeldisplay,showLabels:o.showlabels,rotateLabels:o.rotatelabels,slantLabel:(0,r.pluckNumber)(o.slantlabels,o.slantlabel),labelStep:(0,r.pluckNumber)(o.labelstep,o.xaxisvaluesstep),showAxisValues:(0,r.pluckNumber)(o.showxaxisvalues,o.showxaxisvalue),showDivLineValues:(0,r.pluckNumber)(o.showvdivlinevalues,o.showvdivlinevalues),showZeroPlane:o.showvzeroplane,zeroPlaneColor:o.vzeroplanecolor,zeroPlaneThickness:o.vzeroplanethickness,zeroPlaneAlpha:o.vzeroplanealpha,showZeroPlaneValue:o.showvzeroplanevalue,trendlineColor:o.trendlinecolor,trendlineToolText:o.trendlinetooltext,trendlineThickness:o.trendlinethickness,trendlineAlpha:o.trendlinealpha,showTrendlinesOnTop:o.showtrendlinesontop,showAxisLine:(0,r.pluckNumber)(o.showxaxisline,o.showaxislines,o.drawAxisLines,0),axisLineThickness:(0,r.pluckNumber)(o.xaxislinethickness,o.axislinethickness,1),axisLineAlpha:(0,r.pluckNumber)(o.xaxislinealpha,o.axislinealpha,100),axisLineColor:(0,r.pluck)(o.xaxislinecolor,o.axislinecolor,"#000000"),majorTMNumber:o.majortmnumber,majorTMColor:o.majortmcolor,majorTMAlpha:o.majortmalpha,majorTMHeight:o.majortmheight,tickValueStep:o.tickvaluestep,showTickMarks:o.showtickmarks,connectTickMarks:o.connecttickmarks,showTickValues:o.showtickvalues,majorTMThickness:o.majortmthickness,reverseScale:o.reversescale,showLimits:(0,r.pluckNumber)(o.showlimits,o.showtickmarks),minorTMNumber:(0,r.pluckNumber)(o.minortmnumber,0),minorTMColor:o.minortmcolor,minorTMAlpha:o.minortmalpha,minorTMHeight:(0,r.pluckNumber)(o.minortmheight,o.minortmwidth),minorTMThickness:o.minortmthickness,tickMarkDistance:(0,r.pluckNumber)(o.tickmarkdistance,o.tickmarkgap),tickValueDistance:(0,r.pluckNumber)(o.tickvaluedistance,o.displayvaluedistance),placeTicksInside:o.placeticksinside,placeValuesInside:o.placevaluesinside,upperLimitDisplay:o.upperlimitdisplay,lowerLimitDisplay:o.lowerlimitdisplay}]},a.getDSdef=function(){return s["default"]},a._fetchCaptionPos=function(){return this.getChildren("caption")[0].config.align===g?0:-1},e}(n["default"]);e["default"]=k},1164:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1165))["default"];e["default"]=i},1165:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1095)),l=a(1119),s=o(a(1121)),c=o(a(1092)),h=o(a(366)),u=function(t){function e(){var e;return(e=t.call(this)||this).defaultSeriesType="bullet",e.gaugeType=4,e.ticksOnRight=0,e.hasCanvas=!0,e.isHorizontal=!1,e.config.isAxisOpposite=!1,e.config.scalePosition="left",e.config.canBeScalePosition="right",e.isAxisReverse=!1,e.defaultPaletteOptions={paletteColors:[["A6A6A6","CCCCCC","E1E1E1","F0F0F0"],["A7AA95","C4C6B7","DEDFD7","F2F2EE"],["04C2E3","66E7FD","9CEFFE","CEF8FF"],["FA9101","FEB654","FED7A0","FFEDD5"],["FF2B60","FF6C92","FFB9CB","FFE8EE"]],bgColor:["FFFFFF","CFD4BE,F3F5DD","C5DADD,EDFBFE","A86402,FDC16D","FF7CA0,FFD1DD"],bgAngle:[270,270,270,270,270],bgRatio:["0,100","0,100","0,100","0,100","0,100"],bgAlpha:["100","60,50","40,20","20,10","30,30"],toolTipBgColor:["FFFFFF","FFFFFF","FFFFFF","FFFFFF","FFFFFF"],toolTipBorderColor:["545454","545454","415D6F","845001","68001B"],baseFontColor:["333333","60634E","025B6A","A15E01","68001B"],tickColor:["333333","60634E","025B6A","A15E01","68001B"],trendColor:["545454","60634E","415D6F","845001","68001B"],plotFillColor:["545454","60634E","415D6F","845001","68001B"],borderColor:["767575","545454","415D6F","845001","68001B"],borderAlpha:[50,50,50,50,50]},e.showRTvalue=!1,e.canvasPadding=!1,e.defaultPlotShadow=1,e.realtimeEnabled=!0,e.chartleftmargin=15,e.chartrightmargin=15,e.charttopmargin=10,e.chartbottommargin=10,e.showTooltip=0,e.connectTickMarks=0,e.drawPlotlines=!1,e.drawPlotBands=!1,e.isRealTime=!0,e.colorRange=!0,e.registerFactory("dataset",c["default"],["vCanvas"]),e}(0,i["default"])(e,t),e.getName=function(){return"Vbullet"};var a=e.prototype;return a.getName=function(){return"Vbullet"},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),l.configureAttributes.call(this)},a._getData=function(){return l._getData.call(this)},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Vertical Bullet Gauge",e.defaultDatasetType="bullet",e.singleseries=!0,e.skipCanvasDrawing=!0},a.getDSdef=function(){return s["default"]},a._feedAxesRawData=function(){var t=this.config,e=this.getFromEnv("color-manager"),a=this.getFromEnv("dataSource").chart,o=this.getFromEnv("number-formatter"),i=r.chartPaletteStr.chart2D,n=(0,r.pluckNumber)(a.ticksonright),l=(0,r.pluckNumber)((0,h["default"])(a.scaleposition,t.scalePosition)?t.isAxisOpposite:(0,h["default"])(a.scaleposition,t.canBeScalePosition)?!t.isAxisOpposite:void 0,void 0!==n?n:void 0,t.isAxisOpposite),s=(0,r.pluckFontSizeMaintainUnit)(a.outcnvbasefontsize,a.basefontsize,10);return[{isVertical:!this.isHorizontal,isReverse:!0,isOpposit:l,outCanfontFamily:(0,r.pluck)(a.outcnvbasefont,a.basefont,"Verdana,sans"),outCanfontSize:this.computeFontSize(s),outCanfontSizeWithUnit:s,outCancolor:(0,r.pluck)(a.outcnvbasefontcolor,a.basefontcolor,e.getColor(i.baseFontColor)).replace(/^#?([a-f0-9]+)/gi,"#$1"),useEllipsesWhenOverflow:a.useellipseswhenoverflow,divLineColor:(0,r.pluck)(a.vdivlinecolor,e.getColor(i.divLineColor)),divLineAlpha:(0,r.pluck)(a.vdivlinealpha,e.getColor("divLineAlpha")),divLineThickness:(0,r.pluckNumber)(a.vdivlinethickness,1),divLineIsDashed:Boolean((0,r.pluckNumber)(a.vdivlinedashed,a.vdivlineisdashed,0)),divLineDashLen:(0,r.pluckNumber)(a.vdivlinedashlen,4),divLineDashGap:(0,r.pluckNumber)(a.vdivlinedashgap,2),showAlternateGridColor:(0,r.pluckNumber)(a.showalternatevgridcolor,0),alternateGridColor:(0,r.pluck)(a.alternatevgridcolor,e.getColor("altVGridColor")),alternateGridAlpha:(0,r.pluck)(a.alternatevgridalpha,e.getColor("altVGridAlpha")),numDivLines:a.numvdivlines,labelFont:a.labelfont,labelFontSize:this.computeFontSize(a.labelfontsize),labelFontSizeWithUnit:a.labelfontsize,labelFontColor:a.labelfontcolor,labelAlpha:a.labelalpha,labelFontBold:a.labelfontbold,labelFontItalic:a.labelfontitalic,axisName:a.xaxisname,axisMinValue:o.getCleanValue(a.lowerlimit),axisMaxValue:o.getCleanValue(a.upperlimit),setAdaptiveMin:a.setadaptivexmin,adjustDiv:a.adjusttm,labelDisplay:a.labeldisplay,showLabels:a.showlabels,rotateLabels:a.rotatelabels,slantLabel:(0,r.pluckNumber)(a.slantlabels,a.slantlabel),labelStep:(0,r.pluckNumber)(a.labelstep,a.xaxisvaluesstep),showAxisValues:(0,r.pluckNumber)(a.showxaxisvalues,a.showxaxisvalue),showDivLineValues:(0,r.pluckNumber)(a.showvdivlinevalues,a.showvdivlinevalues),showZeroPlane:a.showvzeroplane,zeroPlaneColor:a.vzeroplanecolor,zeroPlaneThickness:a.vzeroplanethickness,zeroPlaneAlpha:a.vzeroplanealpha,showZeroPlaneValue:a.showvzeroplanevalue,trendlineColor:a.trendlinecolor,trendlineToolText:a.trendlinetooltext,trendlineThickness:a.trendlinethickness,trendlineAlpha:a.trendlinealpha,showTrendlinesOnTop:a.showtrendlinesontop,showAxisLine:(0,r.pluckNumber)(a.showxaxisline,a.showaxislines,a.drawAxisLines,0),axisLineThickness:(0,r.pluckNumber)(a.xaxislinethickness,a.axislinethickness,1),axisLineAlpha:(0,r.pluckNumber)(a.xaxislinealpha,a.axislinealpha,100),axisLineColor:(0,r.pluck)(a.xaxislinecolor,a.axislinecolor,"#000000"),majorTMNumber:a.majortmnumber,majorTMColor:a.majortmcolor,majorTMAlpha:a.majortmalpha,majorTMHeight:a.majortmheight,tickValueStep:a.tickvaluestep,showTickMarks:a.showtickmarks,connectTickMarks:a.connecttickmarks,showTickValues:a.showtickvalues,majorTMThickness:a.majortmthickness,reverseScale:a.reversescale,showLimits:(0,r.pluckNumber)(a.showlimits,a.showtickmarks),minorTMNumber:(0,r.pluckNumber)(a.minortmnumber,0),minorTMColor:a.minortmcolor,minorTMAlpha:a.minortmalpha,minorTMHeight:(0,r.pluckNumber)(a.minortmheight,a.minortmwidth),minorTMThickness:a.minortmthickness,tickMarkDistance:(0,r.pluckNumber)(a.tickmarkdistance,a.tickmarkgap),tickValueDistance:(0,r.pluckNumber)(a.tickvaluedistance,a.displayvaluedistance),placeTicksInside:a.placeticksinside,placeValuesInside:a.placevaluesinside,upperLimitDisplay:a.upperlimitdisplay,lowerLimitDisplay:a.lowerlimitdisplay}]},e}(n["default"]);e["default"]=u},1166:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1167))["default"];e["default"]=i},1167:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1168)),n=o(a(1169)),l=a(224),s=function(t){function e(){var e;return(e=t.call(this)||this).useSortedData=!0,e}(0,i["default"])(e,t),e.getName=function(){return"Funnel"};var a=e.prototype;return a.getName=function(){return"funnel"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Funnel Chart",e.defaultDatasetType="funnel",e.enablemousetracking=!0},a.configureAttributes=function(){t.prototype.configureAttributes.call(this);var e=this.getFromEnv("dataSource"),a=(0,l.pluckNumber)(e.chart.streamlineddata,1);this.config.PLOT_COLOR_INDEX_START=a?-1:0,this.config.alignLegendWithCanvas=0},a.getDSdef=function(){return n["default"]},e}(r["default"]);e["default"]=s},1168:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(464)),l=function(t,e){if(!e&&t&&t.__esModule)return t;if(null===t||"object"!=typeof t&&"function"!=typeof t)return{"default":t};var a=u(e);if(a&&a.has(t))return a.get(t);var o={},i=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var r in t)if("default"!==r&&Object.prototype.hasOwnProperty.call(t,r)){var n=i?Object.getOwnPropertyDescriptor(t,r):null;n&&(n.get||n.set)?Object.defineProperty(o,r,n):o[r]=t[r]}o["default"]=t,a&&a.set(t,o);return o}(a(477)),s=o(a(537)),c=o(a(568)),h=a(566);function u(t){if("function"!=typeof WeakMap)return null;var e=new WeakMap,a=new WeakMap;return(u=function(t){return t?a:e})(t)}var d=function(t){function e(){var e;return(e=t.call(this)||this).showRTvalue=!1,e.canvasPadding=!1,e.sliceOnLegendClick=!0,e.defaultPlotShadow=1,e.subTitleFontSizeExtender=0,e.tooltippadding=3,e.defaultPaletteOptions=l,e.drawAnnotations=!0,e.isDataLabelBold=!1,e.dontShowLegendByDefault=!0,e.formatnumberscale=1,e.alignCaptionWithCanvas=0,e.registerFactory("dataset",s["default"],["vCanvas","legend"]),e.registerFactory("legend",c["default"]),e}(0,i["default"])(e,t),e.getName=function(){return"FunnelPyramidBase"};var a=e.prototype;return a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.showRTvalue=!1,e.canvasPadding=!1,e.sliceOnLegendClick=!0,e.defaultPlotShadow=1,e.subTitleFontSizeExtender=0,e.tooltippadding=3,e.defaultPaletteOptions=l,e.drawAnnotations=!0,e.isDataLabelBold=!1,e.dontShowLegendByDefault=!0,e.alignCaptionWithCanvas=0,e.formatnumberscale=1,e.isSingleSeries=!0,e.hasLegend=!0,e.decimals=2,e.defaultDatasetType="funnelpyramidbaseds",e.skipCanvasDrawing=!0},a.parseChartAttr=function(e){t.prototype.parseChartAttr.call(this,e);var a=this.getFromEnv("chart-attrib");this.config.showLegend=(0,r.pluckNumber)(a.showlegend,0),this.config.usePattern&&(this.config.is2d=1)},a._checkInvalidSpecificData=function(){var t,e,a,o=0,i=0,r=this.getFromEnv("dataSource").data;if(!r)return!0;for(e=r.length,t=0;t<e;t++)a=Number(r[t].value),o+=isNaN(a)||0!==a?0:1,i+=isNaN(a)?1:0;return o+i>=e||void 0},a._manageLegendSpace=function(){h._manageLegendSpace.call(this)},a.getName=function(){return"FunnelPyramidBase"},e}(n["default"]);e["default"]=d},1169:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1170)),l=a(236),s=o(a(1172)),c=function(t){function e(){var e;return(e=t.call(this)||this).config.pointInContext=s["default"],e.config.LABEL_PLACEMENT_ITERATOR_INDEX_START=1,e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"funnel"},a.configure=function(t){if(!t)return!1;this.config.JSONData=t;var e,a,o,i,n=this.getFromEnv("chart"),l=this.getFromEnv("number-formatter"),s=this.utils(this).sortObjArrByKey,c=n.getFromEnv("dataSource")?n.getFromEnv("dataSource").chart:{},h=this.config.JSONData.data;if(this._checkValidData(h)){for(a=0,i=h.length;a<i;a++)(o=h[a])&&void 0!==o.value&&(o.value=l.getCleanValue(o.value,!0));e=this.config.streamLinedData=(0,r.pluckNumber)(c.streamlineddata,1),this.config.JSONData.data=e?s(h,"value"):h,this._configure(),h=this.getChildren("data"),e&&(h[0].pseudoPoint=!0),n.config.showLegend&&this.addLegend()}},a.configureSpecifics=function(){var t=this.getFromEnv("chart"),e=this.config,a=t.getFromEnv("dataSource")?t.getFromEnv("dataSource").chart:{};(0,this.utils(this).copyProperties)(a,e,[["funnelyscale","yScale",r.pluckNumber,void 0,function(t){var e=t.yScale;t.yScale=e>=0&&e<=40?e/200:.2}],["usesameslantangle","useSameSlantAngle",r.pluckNumber,function(t){return t.streamLinedData?0:1}],["ishollow","isHollow",r.pluckNumber,void 0,function(t){void 0===t.isHollow&&(t.isHollow=t.streamLinedData?1:0)}]])},a.prePointProcessingHookFn=function(t){var e,a,o,i,n=this.getFromEnv("chart"),l=n.config,s=this.config,c=l.canvasWidth,h=n.getFromEnv("smartLabel"),u=!s.streamLinedData;(e=t[0])&&(e.pseudoPoint=!0),e&&e.displayValue&&(h.useEllipsesOnOverflow(n.config.useEllipsesWhenOverflow),e.style.fontSize=this.computeFontSize(e.style.fontSizeWithUnit)+r.PXSTRING,h.setStyle(e.style),(0,r.setLineHeight)(e.style),a=parseFloat(e.style.lineHeight.match(/^\d+/)[0]||s.lineHeight,10),i=h.getOriSize(e.displayValue).height,o=h.getSmartText(e.displayValue,c,i),e.displayValue=o.text,o.tooltext&&(e.originalText=o.tooltext),e.labelWidth=h.getOriSize(o.text).width,l.marginTop+=a+4),s.totalValue=u?t[0].y-t[1].y:0,s.offsetVal=function(a){return u?-(t[a+1]&&t[a+1].y||0):e.y}},a.datasetCalculations=function(t){var e,a,o,i,r=this.config,n=this.getFromEnv("number-formatter"),l={},s=r.streamLinedData,c=r.percentOfPrevious;for(l.highestValue=Number.NEGATIVE_INFINITY,l.refreshedData=[],l.sumValue=l.countPoint=0,e=0,a=t.length;e<a;e++)(o=t[e]).vline||(o.cleanValue=i=Math.abs(n.getCleanValue(o.value,!0)),null!==i&&(l.hasValidPoint=!0,l.highestValue=l.highestValue||i,l.refreshedData.push(o),l.sumValue+=i,l.countPoint+=1,l.highestValue=Math.max(l.highestValue,i)));return s&&(l.sumValue=l.highestValue,c&&(l.prevPerValReq=!0)),l},a.calculatePositionOfPlots=function(){var t,e,a,o,i,n,l,s,c,h,u,d,g,p,f,m,v,b,k=this.getFromEnv("chart").config,C=this.config,x=this.utils(this),w=x.getSumValueOfObjArrByKey,T=x.DistributionMatrix,y=this.calculatePositionCoordinate,A=C.psmMargin,S=this.getChildren("data"),F=C.streamLinedData,N=2,E=this.getDataLength(),L=C.maxValue=S[0].y,D=C.minValue=S[E-1].y,M=0,R=0,_=C.lineHeight,I=Math.floor;if(C.sumValue&&(this.postPlotCallback=r.stubFN,k.canvasTop+=k.marginTop-A.top,k.effCanvasHeight=i=k.canvasHeight-(k.marginTop+k.marginBottom)+(A.top+A.bottom),k.effCanvasWidth=n=k.width-(k.marginLeft+k.marginRight),l=C.drawingRadius=n/N,C.x=k.canvasLeft+(k.canvasRight-k.canvasLeft)/2,!(F&&E<2))){for(F?(o=i/(L-D),h=(s=w(S,"value"))?i/s:i):h=o=L?i/L:i,C.unitHeight=o,C.lastRadius=l,C.globalMinXShift=0,(c=C.alignmentType={})["default"]=1,c.alternate=2,b=new T(I(i/_)),t=0,e=E;t<e;t++)(a=S[t]).getState("removed")||(!F&&0===t||!F&&t===e-1?b.forcePush(a,t):(M=a.y*h,u=I(((R+=a.y*h)-M+M/2)/_),b.push(a,u)));if(d=b.getDistributedResult(),S.length=0,void 0===d.matrix[1])[].push.apply(S,d.matrix[0]);else for(g=d.matrix[0],p=d.matrix[1],e=Math.max(g.length,p.length),t=0;t<e;t++)m=g[t],f=p[t],S.push(m||f);if(Object.keys(d.forceMatrix).length>0)for(v in d.forceMatrix)[].splice.apply(S,[parseInt(v,10),0].concat(d.forceMatrix[v]));switch(d.suggestion){case c["default"]:y.call(this,S,!1);break;case c.alternate:C.labelAlignment=c.alternate,l=n/(N=3),k.canvasLeft=k.canvasWidth/2-l,C.x=k.canvasLeft+l,y.call(this,S,!0)}}},a.draw=function(){var t,e,a,o,i,r,n,s=this,c=s.getFromEnv("chart"),h=s.config,u=s.config.trackerArgs=[],d=s.getChildren("data"),g=c.getChildContainer("datalabelsGroup"),p=h.streamLinedData,f=d.length,m=Math.min;if(s.config.labelDrawingConfig=s.config.labelDrawingConfig||[],s.config.labelDrawingConfig.length=0,h.sumValue)if(s.animateFunction=function(t){return function(){t.attr({opacity:1})}},i=(a=h.slicingDistance)/2,p&&f<2)s.hide(s.getChildren("data"),f);else{for(t=0,e=d.length;t<e;t++)d[t]&&d[t].shapeArgs&&!d[t].getState("removed")&&(d[t].shapeArgs.renderer=c.getFromEnv("paper"));for((o=h.noOfGap)&&(h.perGapDistance=m(1.5*i,a/o),h.distanceAvailed=i),t=d.length,h.alreadyPlotted&&(s.postPlotCallback=function(){n||(n=!0,s.animateFunction(g)())});t--;)(r=d[t]).index=t,r.syncDraw();for(h.oldLastData=Object.assign({},d[d.length-1].shapeArgs),s.hide(s.getChildren("data"),f),h.connectorEndSwitchHistoryY={},t=d.length;t--;)d[t].getState("removed")||u.push(d[t]);s.addJob("labelDrawID",s.drawAllLabels.bind(s),l.priorityList.label),s.addJob("trackerDrawID",s.drawAllTrackers.bind(s),l.priorityList.tracker),s.removePlots(),h.alreadyPlotted=!0,h.prevIs2d=h.is2d}},a.getTooltipMacroStub=function(e){var a,o,i=this.config,r=this.getFromEnv("number-formatter");return i.streamLinedData&&(o=i.percentOfPrevious?e.pValue:r.percentValue(e.dataValue/e.prevValue*100)),(a=t.prototype.getTooltipMacroStub.call(this,e)).percentValue=i.percentOfPrevious?r.percentValue(e.dataValue/e.highestValue*100):e.pValue,a.percentOfPrevValue=o,a},e}(n["default"]);e["default"]=c},1170:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(242)),r=o(a(238)),n=a(224),l=a(240),s=a(588),c=o(a(1171)),h=a(232),u=["line","circle","square"],d=n.preDefStr.showHoverEffectStr,g=Math,p=g.round,f=g.ceil,m=g.max,v=g.min,b=g.pow,k=g.sqrt,C={},x=n.preDefStr.colors.c000000,w=n.preDefStr.POSITION_START,T=n.preDefStr.POSITION_MIDDLE,y=window,A=y.navigator.userAgent,S=/msie/i.test(A)&&!y.opera,F=n.regex.hexcode,N="rgba(192,192,192,"+(S?.002:1e-6)+")",E=n.regex.dropHash,L=function(t){return"object"==typeof t},D=function(t){return"string"==typeof t},M=function(t){return null!=t},R=function(t){return{formattedValue:t.formatedVal,label:t.name,percentValue:t.pValue,sum:t.sum,unformattedSum:t.sumValue}},_="M",I="L",V="Z",O=n.regex.startsRGBA,P=function(t){var e,a,o=[];return(e=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/.exec(a=t))?o=[parseInt(e[1],10),parseInt(e[2],10),parseInt(e[3],10),parseFloat(e[4])]:(e=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(a))&&(o=[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16),1]),{get:function(e){return o&&!isNaN(o[0])?"rgb"===e?"rgb("+o[0]+","+o[1]+","+o[2]+")":"hex"===e?"#"+(x+(o[0]<<16|o[1]<<8|o[2]).toString(16)).slice(-6):"a"===e?o[3]:"rgba("+o.join(",")+")":t},brighten:function(t){var e;if(!isNaN(t)&&0!==t)for(e=0;e<3;e++)o[e]+=parseInt(255*t,10),o[e]<0&&(o[e]=0),o[e]>255&&(o[e]=255);return this},setOpacity:function(t){return o[3]=t,this}}};(0,h.addDep)({name:"funnelPyramidBaseAnimation",type:"animationRule",extension:c["default"]});var G=function(t){(0,r["default"])(a,t);var e=a.prototype;function a(){var e,a,o,r,l,s,c;return(e=t.call(this)||this).components={},e.utils=function(t){var e=t;function a(){var t=[],e=0;this.set=function(a,o){e++,t[a]=o},this.get=function(e){return t[e]},this.getAll=function(){return t},this.mergeWith=function(e){var o,i,r,n=t.slice(0);if(e instanceof Array)o=e;else{if(!(e instanceof a))return;o=e.getAll()}for(i in o)r=o[i],n[i]||(n[i]=r);return n},this.getEffectiveLength=function(){return e}}function o(t){this.distributionLength=t,this.distributedMatrix=[],this.altDistributedMatrix=[],this.nonDistributedMatrix={},this.forcePushObj={},this.flags={exhaustion:!1}}return a.prototype.constructor=a,o.prototype.constructor=o,o.prototype.push=function(t,e){this.nonDistributedMatrix[e]=this.nonDistributedMatrix[e]||[],this.nonDistributedMatrix[e].push(t)},o.prototype.forcePush=function(t,e){this.forcePushObj[e]=t},o.prototype.distribute=function(t){var o,i,r,l,s,c,h,u=e,d=!0,g=new a,p=new a,f=new a,m=new a,v=this.flags,b=0,k=u.getDataLength();if(t){if(k-this.distributionLength>0)for(r in this.nonDistributedMatrix)for(o=this.nonDistributedMatrix[r],s=1;s<o.length;s++)(h=o[s]).dontPlot=!0,h.displayValue=n.BLANK}else if(k-2*this.distributionLength>0)for(r in this.nonDistributedMatrix)for(o=this.nonDistributedMatrix[r],s=1;s<o.length-1;s++)(h=o[s]).dontPlot=!0,h.displayValue=n.BLANK;if(k>this.distributionLength&&!t){for(r in v.exhaustion=!0,this.nonDistributedMatrix)for(s=0,c=(o=this.nonDistributedMatrix[r]).length;s<c;s++)(h=o[s]).dontPlot?i=d?f:m:(i=d?g:p).getEffectiveLength()>parseInt(r,10)?h.distributionFactor=i.getEffectiveLength()-1-r:h.distributionFactor=0,i.set(b++,h),d=!d;this.distributedMatrix=g.mergeWith(f),this.altDistributedMatrix=p.mergeWith(m)}else{for(l in this.nonDistributedMatrix)for(s=0,c=(o=this.nonDistributedMatrix[l]).length;s<c;s++)(h=o[s]).dontPlot?i=f:(i=g).getEffectiveLength()>parseInt(l,10)?h.distributionFactor=i.getEffectiveLength()-1-l:h.distributionFactor=0,i.set(b++,h);this.distributedMatrix=g.mergeWith(f)}},o.prototype.getDistributedResult=function(){var t,a=e,o=a.getFromEnv("chart"),i=o.config,r=o.getFromEnv("legend"),n=a.config,l=n.alignmentType,s=[],c=o.isLegendRight;i.width,n.blankSpace;return i.showLegend&&r.config.width?c&&r.config.width+i.marginRight:c=0,o.isLegendRight=c,this.distribute(c),c?(t=l["default"],s.push(this.distributedMatrix)):(t=this.flags.exhaustion?l.alternate:l["default"],this.flags.exhaustion?[].push.call(s,this.distributedMatrix,this.altDistributedMatrix):s.push(this.distributedMatrix)),{forceMatrix:this.forcePushObj,suggestion:t,matrix:s}},{DistributionMatrix:o,setContext:function(t){e=t},invokeHookFns:function(){var t,a=[],o=e;switch(arguments.length){case 3:o=arguments[2];case 2:a=arguments[1];case 1:t=arguments[0];break;default:return}t&&"function"==typeof t&&t.apply(o,a)},copyProperties:function(t,a,o){var i,r,l,s,c,h,u,d,g,p,f=n.stubFN;for(i=0,r=o.length;i<r;i++)s=(l=o[i])[0],c=l[1],h=l[2],g=l[3],p=void 0,u="string"==typeof g&&0===g.indexOf("$")?(p=g.substring(1),a[p]):"function"==typeof g?g.call(e,a):g,d=l[4]||f,a[c]=h(t[s],u),d(a)},sortObjArrByKey:function(t,e){return t.sort((function(t,a){return Math.abs(a[e])-Math.abs(t[e])}))},getSumValueOfObjArrByKey:function(t,e){var a,o,i=0;for(a=0,o=t.length;a<o;a++)i+=parseFloat(t[a][e],10);return i}}},e.hide=function(t,e){var a,o,i=this.getFromEnv("animationManager"),r=function(){this.hide()},n=e;if(t&&0!==t.length)for(n=n<2&&"funnel"===this.getName()?0:n,a=t.length-1;a>=n;a--)(o=t[a].getGraphicalElement()).graphic&&(o.graphic.front&&i.setAnimation({el:o.graphic.front,callback:r,component:this}),o.graphic.back&&i.setAnimation({el:o.graphic.back,callback:r,component:this}),o.graphic.funnel2D&&i.setAnimation({el:o.graphic.funnel2D,callback:r,component:this}),o.graphic.lighterHalf&&i.setAnimation({el:o.graphic.lighterHalf,callback:r,component:this}),o.graphic.darkerHalf&&i.setAnimation({el:o.graphic.darkerHalf,callback:r,component:this}),o.graphic.borderElement&&i.setAnimation({el:o.graphic.borderElement,callback:r,component:this}),o.graphic.centerLight&&i.setAnimation({el:o.graphic.centerLight,callback:r,component:this}),o.graphic.centerLight1&&i.setAnimation({el:o.graphic.centerLight1,callback:r,component:this}),o.graphic.toptop&&i.setAnimation({el:o.graphic.toptop,callback:r,component:this}),o.graphic.topLight&&i.setAnimation({el:o.graphic.topLight,callback:r,component:this}),o.graphic.topLight1&&i.setAnimation({el:o.graphic.topLight1,callback:r,component:this})),o.dataLabel&&i.setAnimation({el:o.dataLabel,callback:r,component:this}),o.trackerObj&&i.setAnimation({el:o.trackerObj,callback:r,component:this})},e.pyramidFunnelShape=(a={y:!0,R1:!0,R2:!0,h:!0,r3dFactor:!0,color:!0,opacity:!0,fill:!0,stroke:!0,strokeColor:!0,strokeAlpha:!0,"stroke-width":!0},o=function(t,e,a,o,i,r){return["A",a,o,0,r,i,t,e]},r=function(t,e,a,i,r,n,l){var s,c=a*n,h=i*n,u=function(t,e,a,o,i,r){var n,l,s,c,h,u,d,g=b(o,2)-b(t,2),f=-2*(b(o,2)*a-b(t,2)*r),m=b(t*i,2)+b(o*a,2)-b(o*e,2)-b(t*r,2),v=k(b(f,2)-4*g*m),C=(-f+v)/(2*g),x=(-f-v)/(2*g);for(d in C<r&&C>a?l=x:x<r&&x>a&&(l=C),c=-(s=k((b(l-a,2)-b(e,2))/b(t,2))),h={x:p(b(t,2)*s/(l-a)*100)/100,y:p(100*(b(e,2)/(l-a)+a))/100},u={x:p(b(o,2)*s/(l-r)*100)/100,y:p(100*(b(i,2)/(l-r)+r))/100},n={topLeft:{x:p(b(t,2)*c/(l-a)*100)/100,y:p(100*(b(e,2)/(l-a)+a))/100},bottomLeft:{x:p(b(o,2)*c/(l-r)*100)/100,y:p(100*(b(i,2)/(l-r)+r))/100},topRight:h,bottomRight:u})(isNaN(n[d].x)||isNaN(n[d].y))&&(n[d].x="topLeft"===d||"bottomLeft"===d?-t:t,n[d].y="bottomRight"===d||"bottomLeft"===d?r:a);return n}(a,c,e,i,h,e+r),d=u.topLeft,g=u.bottomLeft,f=u.topRight,m=u.bottomRight,v=t+d.x,C=t+f.x,x=t+g.x,w=t+m.x,T=d.y,y=g.y,A=o(C,T,a,c,0,0),S=o(C,T,a,c,1,1),F=o(x,y,i,h,1,0),N=o(x,y,i,h,0,1);return s={front:[_,v,T].concat(A,[I,w,y],F,[V]),back:[_,v,T].concat(S,[I,w,y],N,[V]),silhuette:[_,v,T].concat(S,[I,w,y],F,[V])},l||(s.top=[_,v,T].concat(A,[I,C,T],o(v,T,a,c,0,1),[V])),s},l=function(t,e,a,o,i,n,l,s,c,h){var u=t,d=e,g=a,p=o,f=i,m=n,b=l,k=c,C=h;L(u)&&(d=u.y,g=u.R1,p=u.R2,f=u.h,m=u.r3dFactor,b=u.is2D,C=u.isHollow,k=u.isFunnel,u.renderer,u=u.x);var x,w,T,y,A,S,F,N=u-g,E=u+g,D=u-p,M=u+p,R=d+f;return b?(x={silhuette:[_,N,d,I,E,d,M,R,D,R,V]},k||(u=Math.round(u),x.lighterHalf=[_,N,d,I,u,d,u,R,D,R,V],x.darkerHalf=[_,u,d,I,E,d,M,R,u,R,V])):k?x=r(u,d,g||.01,p||.01,f,m,C):(w=g*m,T=p*m,y=v(5,g),A=v(2,2*w),S=v(2,A),x={top:[_,N,d,I,u,d+w,E,d,u,d-w,V],front:[_,N,d,I,u,d+w,E,d,M,R,u,R+T,D,R,V],topLight:[_,N,d+.5,I,u,d+w+.5,u,d+w-A,N+(F=S/m),d,V],topLight1:[_,E,d+.5,I,u,d+w+.5,u,d+w-S,E-F,d,V],silhuette:[_,N,d,I,u,d-w,E,d,M,R,u,R+T,D,R,V],centerLight:[_,u,d+w,I,u,R+T,u-5,R+T,u-y,d+w,V],centerLight1:[_,u,d+w,I,u,R+T,u+5,R+T,u+y,d+w,V]}),x},s=function(t,e){var o,i,r,s,c,h,u,d,g,p,f,m,v,b,k=this,C=!1,x=!1,w=this._3dAttr,T=t;if(D(T)&&M(e)&&(o=T,(T={})[o]=e),D(T))k=a[T]?this._3dAttr[T]:this._attr(T);else{for(o in T)i=T[o],a[o]?(w[o]=i,"fill"===o?(i&&i.linearGradient&&i.stops&&i.stops[0]&&(i=i.stops[0][1]),O.test(i)?(r=(c=new P(i)).get("hex"),s=100*c.get("a")):i&&i.FCcolor?(r=i.FCcolor.color.split(n.COMMASTRING)[0],s=i.FCcolor.opacity.split(n.COMMASTRING)[0]):F.test(i)&&(r=i.replace(E,n.HASHSTRING),s=(0,n.pluckNumber)(w.opacity,100)),w.color=r,w.opacity=s,x=!0):"color"===o||"opacity"===o?(w.fill=(0,n.toRaphaelColor)((0,n.convertColor)(w.color,(0,n.pluckNumber)(w.opacity,100))),x=!0):"stroke"===o||"strokeColor"===o||"strokeAlpha"===o?w.is2D&&("stroke"===o?(i&&i.linearGradient&&i.stops&&i.stops[0]&&(i=i.stops[0][1]),O.test(i)?(r=(c=new P(i)).get("hex"),s=100*c.get("a")):i&&i.FCcolor?(r=i.FCcolor.color.split(n.COMMASTRING)[0],s=i.FCcolor.opacity.split(n.COMMASTRING)[0]):F.test(i)&&(r=i.replace(E,n.HASHSTRING),s=(0,n.pluckNumber)(w.opacity,100)),w.strokeColor=r,w.strokeAlpha=s):w.stroke=(0,n.convertColor)(w.strokeColor,(0,n.pluckNumber)(w.strokeAlpha,100)),w.isFunnel?this.funnel2D.attr("stroke",w.stroke):this.borderElement.attr("stroke",w.stroke)):"stroke-width"===o?w.is2D&&(w.isFunnel?this.funnel2D.attr(o,i):this.borderElement.attr(o,i)):C=!0):this._attr(o,i);w.is2D?(C&&(g=l(w.x,w.y,w.R1,w.R2,w.h,w.r3dFactor,w.is2D),k.shadowElement.attr({path:g.silhuette}),w.isFunnel?k.funnel2D.attr({path:g.silhuette}):(k.lighterHalf.attr({path:g.lighterHalf}),k.darkerHalf.attr({path:g.darkerHalf}),k.borderElement.attr({path:g.silhuette}))),x&&(w.isFunnel?k.funnel2D.attr("fill",(0,n.toRaphaelColor)((0,n.convertColor)(w.color,(0,n.pluckNumber)(w.opacity,100)))):(!1===w.use3DLighting?p=f=w.color:(p=(0,n.getDarkColor)(w.color,80),f=(0,n.getLightColor)(w.color,80)),k.lighterHalf.attr("fill",(0,n.toRaphaelColor)((0,n.convertColor)(f,(0,n.pluckNumber)(w.opacity,100)))),k.darkerHalf.attr("fill",(0,n.toRaphaelColor)((0,n.convertColor)(p,(0,n.pluckNumber)(w.opacity,100))))))):(C&&(g=l(w.x,w.y,w.R1,w.R2,w.h,w.r3dFactor,w.is2D),k.shadowElement.attr("path",g.silhuette),w.isFunnel?(k.front.attr("path",g.front),k.back.attr("path",g.back),k.toptop&&g.top&&k.toptop.attr("path",g.top)):(k.front.attr("path",g.front),k.toptop.attr("path",g.top),k.topLight.attr("path",g.topLight),k.topLight1.attr("path",g.topLight1),k.centerLight.attr("path",g.centerLight),k.centerLight1.attr("path",g.centerLight1))),x&&(r=w.color,s=w.opacity,w.isFunnel?(h=(0,n.getLightColor)(r,60),d=(0,n.getDarkColor)(r,60),k.back.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:d+n.COMMASTRING+h+n.COMMASTRING+r,alpha:s+n.COMMASTRING+s+n.COMMASTRING+s,ratio:"0,60,40",angle:0}})),k.front.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:r+n.COMMASTRING+h+n.COMMASTRING+d,alpha:s+n.COMMASTRING+s+n.COMMASTRING+s,ratio:"0,40,60",angle:0}})),k.toptop&&k.toptop.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:h+n.COMMASTRING+d,alpha:s+n.COMMASTRING+s,ratio:"0,100",angle:-65}}))):(h=(0,n.getLightColor)(r,80),u=(0,n.getLightColor)(r,70),d=(0,n.getDarkColor)(r,80),m="0,"+s,v=r+n.COMMASTRING+u,b=5/(w.R1*w.r3dFactor)*100,k.centerLight.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:v,alpha:m,ratio:"0,100",angle:0}})),k.centerLight1.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:v,alpha:m,ratio:"0,100",angle:180}})),k.topLight.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:u+n.COMMASTRING+u+n.COMMASTRING+r+n.COMMASTRING+r,alpha:s+n.COMMASTRING+s+n.COMMASTRING+0+n.COMMASTRING+0,ratio:"0,50,"+b+n.COMMASTRING+(50-b),angle:-45}})),k.topLight1.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:u+n.COMMASTRING+r+n.COMMASTRING+d,alpha:s+n.COMMASTRING+s+n.COMMASTRING+s,ratio:"0,50,50",angle:0}})),k.front.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:r+n.COMMASTRING+r+n.COMMASTRING+d+n.COMMASTRING+d,alpha:s+n.COMMASTRING+s+n.COMMASTRING+s+n.COMMASTRING+s,ratio:"0,50,0,50",angle:0}})),k.toptop.attr("fill",(0,n.toRaphaelColor)({FCcolor:{color:h+n.COMMASTRING+r+n.COMMASTRING+d+n.COMMASTRING+d,alpha:s+n.COMMASTRING+s+n.COMMASTRING+s+n.COMMASTRING+s,ratio:"0,25,30,45",angle:-45}})))))}return k},c=function h(){var t=this.shadowElement;h&&t.shadow.apply(t,arguments)},function(t,e,a,o,i,r,h,u,d,g,p,f){var m,v,b,k,x,w,T,y,A=this.getFromEnv("chart").getChildContainer().plotGroup,S=this.config.oldLastData,F=t,E=e,D=a,M=o,R=i,_=r,I=h,V=u,O=d,P=g,G=p,B=f;return L(F)&&(E=F.y,D=F.R1,M=F.R2,R=F.h,_=F.r3dFactor,I=F.gStr,V=F.is2D,B=F.use3DLighting,O=F.renderer,G=F.isHollow,P=F.isFunnel,T=F.graphics,F=F.x),(k=function(t,e){var a,o,i,r,n,l=["silhuette","lighterHalf","darkerHalf","centerLight","centerLight1","front","toptop","topLight","topLight1","shadowElement","funnel2D","borderElement","back"];if(t){if((r=t._3dAttr).isFunnel===e.isFunnel&&r.is2D===e.is2D&&r.isHollow===e.isHollow)return t;for(o=0,n=l.length;o<n;o++)(a=t[i=l[o]])&&(delete t[i],a.remove());return t}}(T,m={x:F,y:E,R1:D,R2:M,h:R,r3dFactor:_=(0,n.pluckNumber)(_,.15),is2D:V,use3DLighting:B,isHollow:G,isFunnel:P,renderer:O})||O.group(I,A)).toFront(),(!k.front&&!V||!k.funnel2D&&!k.lighterHalf&&V)&&this.getState("notInitial")&&this.config.prevIs2d===m.is2D?(b=l(m),S.y=S.y+S.h,S.R1=S.R2,S.h=0,v=l(S)):(v=l(m),this.getState("notInitial",!0)),(w=Object.assign({},m)).y=w.y+w.h,w.R1=w.R2,w.h=0,x=l(w),k.squeezedFormPathObj=x,k.Shapeargs=b||v,y=function(t,e){var a=t.getFromEnv("chart");return function(o,i,r){void 0===r&&(r=C);var n=e[o];return n?(a.getFromEnv("animationManager").setAnimation({el:n,attr:{path:i},component:t}),n):(t.postPlotCallback(),a.getFromEnv("animationManager").setAnimation({el:"path",label:"path",attr:Object.assign({path:i},r),container:e,component:t}))}}(this,k),k.shadowElement=y("shadowElement",v.silhuette,{fill:N,stroke:"none"}),k._attr=k._attr||k.attr,k.attr=s,k.shadow=c,k._3dAttr=m,P?V?(k.funnel2D=y("funnel2D",v.silhuette),b&&(k.funnel2D=y("funnel2D",b.silhuette))):(k.back=y("back",v.back,{"stroke-width":0,stroke:"none"}),k.front=y("front",v.front,{"stroke-width":0,stroke:"none"}),b&&(k.back=y("back",b.back,{"stroke-width":0,stroke:"none"})),b&&(k.front=y("front",b.front,{"stroke-width":0,stroke:"none"})),v.top&&(k.toptop=y("toptop",v.top,{"stroke-width":0,stroke:"none"}),b&&(k.toptop=y("toptop",b.top,{"stroke-width":0,stroke:"none"})))):V?(k.lighterHalf=y("lighterHalf",v.lighterHalf,{"stroke-width":0}),b&&(k.lighterHalf=y("lighterHalf",b.lighterHalf,{"stroke-width":0})),k.darkerHalf=y("darkerHalf",v.darkerHalf,{"stroke-width":0}),b&&(k.darkerHalf=y("darkerHalf",b.darkerHalf,{"stroke-width":0})),k.borderElement=y("borderElement",v.silhuette,{fill:N,stroke:"none"}),b&&(k.borderElement=y("borderElement",b.silhuette,{fill:N,stroke:"none"}))):(k.front=y("front",v.front,{"stroke-width":0}),b&&(k.front=y("front",b.front,{"stroke-width":0})),k.centerLight=y("centerLight",v.centerLight,{"stroke-width":0}),b&&(k.centerLight=y("centerLight",b.centerLight,{"stroke-width":0})),k.centerLight1=y("centerLight1",v.centerLight1,{"stroke-width":0}),b&&(k.centerLight1=y("centerLight1",b.centerLight1,{"stroke-width":0})),k.toptop=y("toptop",v.top,{"stroke-width":0}),b&&(k.toptop=y("toptop",b.top,{"stroke-width":0})),k.topLight=y("topLight",v.topLight,{"stroke-width":0}),b&&(k.topLight=y("topLight",b.topLight,{"stroke-width":0})),k.topLight1=y("topLight1",v.topLight1,{"stroke-width":0}),b&&(k.topLight1=y("topLight1",b.topLight1,{"stroke-width":0}))),k}),e.config.legendItemIds=[],(0,e.utils((0,i["default"])(e)).invokeHookFns)(e.postInitHook),e}return e.getType=function(){return"dataset"},e.getName=function(){return"funnelPyramidBase"},e.trimData=function(t){s.trimData.call(this,t)},e.getDataLength=function(){var t,e=this.getChildren("data"),a=0,o=e.length;for(t=0;t<o;t++)e[t].getState("removed")||a++;return a},e.removeData=function(t,e,a){void 0===a&&(a=!1);var o,i,r,l=this.components,s=this.getChildren("data"),c=e,h=t;for(c=(0,n.pluckNumber)(c,1),h=(0,n.pluckNumber)(h,0),r=(o=l.removedDataArr=s.splice(h,c)).length,i=0;i<r;i++)o[i]||o.splice(i,1);a&&this.asyncDraw()},e.removePlots=function(){var t,e,a,o,i=this.components.removedDataArr;if(i)for(t=i.length-1;t>=0;t--){for(e in a=(o=i[t]).getGraphicalElement())o.removeGraphicalElement(a[e]);i.splice(t,1)}},e._configure=function(){var t=this.getFromEnv("chart"),e=this.getFromEnv("color-manager"),a=t.config,o=a.style,i=this.config||{},r=this.config.JSONData,l=r.data||[],s=t.getFromEnv("dataSource")?t.getFromEnv("dataSource").chart:{},c=this.utils(this),h=c.invokeHookFns,g=c.copyProperties,p=this.configureSpecifics,f=e.getColor("baseFontColor");g(s,i,[["showlabels","showLabels",n.pluckNumber,1],["showvalues","showValues",n.pluckNumber,1],["plottooltext","toolText",n.pluck,n.BLANK],["enableslicing","enableSlicing",n.pluckNumber,1],["plotfillalpha","plotFillAlpha",n.pluckNumber,100],["showplotborder","showPlotBorder",n.pluckNumber,0],["plotborderalpha","plotBorderAlpha",n.pluckNumber,void 0],["plotbordercolor","plotBorderColor",n.pluck,void 0],["plotborderthickness","plotBorderThickness",n.pluckNumber,1],["showshadow","showShadow",n.pluckNumber,1],["showhovereffect",d,n.pluckNumber,0],["hovercapsepchar","hoverCapSepChar",n.pluck,n.COMMASPACE],["tooltipsepchar","tooltipSepChar",n.pluck,"$hoverCapSepChar"],["labelsepchar","labelSepChar",function(){return(0,n.parseUnsafeString)(n.pluck.apply(void 0,arguments))},"$tooltipSepChar"],["showpercentintooltip","showPercentInToolTip",n.pluckNumber,1],["showpercentvalues","showPercentValues",n.pluckNumber,0],[n.BLANK,"blankSpace",n.pluckNumber,3],["labeldistance","labelDistance",n.pluckNumber,50],["issliced","isSliced",n.pluckNumber,0],["is2d","is2d",n.pluckNumber,0],[n.BLANK,"blankSpace",n.pluckNumber,3],["showlabelsatcenter","showLabelsAtCenter",n.pluckNumber,0],["smartlinethickness","connectorWidth",n.pluckNumber,1],["smartlinealpha","connectorAlpha",n.pluckNumber,100],["smartlinecolor","rawSmartLineColorCode",n.pluck,function(){return e.getColor("baseFontColor")}],["labelalpha","labelAlpha",n.pluckNumber,100],["basefont","baseFont",n.pluck,"Verdana,sans"],["basefontsize","baseFontSize",n.pluckNumber,10],["basefontcolor","baseFontColor",n.pluck,f],["labelfontcolor","labelFontColor",n.pluck,"$baseFontColor"],["showtooltip","showTooltip",n.pluckNumber,1],["percentofprevious","percentOfPrevious",n.pluckNumber,0],["animationduration","animationDuration",n.pluckNumber,1,function(t){t.animationDuration*=1e3}]]),i.usePattern=(0,n.pluckNumber)(a.usePattern,0),i.patternType=u.includes(r.patterntype)?r.patterntype:a.patternType,i.patternDensity=(0,n.pluckNumber)(r.patterndensity,a.patternDensity),i.patternAlpha=(0,n.pluckNumber)(r.patternalpha,a.patternAlpha),i.patternBgColor=(0,n.pluck)(r.patternbgcolor,N),i.usePattern&&(i.is2d=1,i.showPlotBorder=(0,n.pluck)(s.showplotorder,1),i.showHoverEffect=0),i.connectorColor=(0,n.convertColor)(i.rawSmartLineColorCode,i.connectorAlpha),i.origLabelDistance=i.labelDistance,(0,n.setLineHeight)(o),o.nLineHeight=o.lineHeight.match(/^\d+/)[0],g(o,i,[[n.BLANK,"lineHeight",n.pluckNumber,i.baseFontSize]]),i.isSliced&&(i.clicked=!0),delete o.nLineHeight,h(p),i.showLabels||i.showValues?i.datalabelDisabled=!1:i.datalabelDisabled=!0,this.getNormalizeDataSet(l)},e._preDrawingHook=function(){var t=this.getFromEnv("chart"),e=this.config,a=t.config,o=this.utils(this),i=t.getFromEnv("dataSource")?t.getFromEnv("dataSource").chart:{},r=a.canvasHeight;(0,o.copyProperties)(i,e,[[n.BLANK,"slicingDistance",n.pluckNumber,.1*r],["slicingdistance","slicingHeight",n.pluckNumber,"$slicingDistance",function(){e.slicingHeight>2*e.slicingDistance?e.slicingDistance=0:e.slicingDistance=e.slicingHeight}]])},e._checkValidData=function(t){var e=this.getFromEnv("chart");return!(!t||!t.length)||(e.setChartMessage(),!1)},e.addLegend=function(){var t,e,a,o,i,r=this.getFromEnv("chart"),l=0,s=r.getFromEnv("dataSource").chart,c=this.getChildren("data")||this.config.JSONData.data,h=r.getFromEnv("legend"),u=h.getChildren("legendItem");for(o=0;o<c.length;o++)if(e=(i=c[o]).config,i.pseudoPoint||i.getState("removed")||!i.label&&!i.categoryLabel){if(i.pseudoPoint)continue;i.categoryLabel,l++,e.legendItemId&&((u=h.getItem(e.legendItemId))&&h.disposeItem(u.getId()),delete e.legendItemId)}else t={type:this.getName(),label:i.label||i.categoryLabel,index:l,enabled:(0,n.pluckNumber)(s.includeinlegend,1),legendItemId:i.legendItemId,usePattern:this.config.usePattern,legendIconAlpha:(0,n.pluckNumber)(c[o].legendiconalpha),patternAttr:i.patternAttr},(u=h.getItem(e.legendItemId))||(a=h.createItem(this),i.config.legendItemId=a,(u=h.getItem(e.legendItemId)).addEventListener("fc-click",u.itemClickFn)),u.configure(t),l++,u.setStateCosmetics("default",{symbol:{bgAlpha:(0,n.pluckNumber)(c[o].legendiconbgalpha,c[o].legendiconalpha,s.legendiconbgalpha,s.legendiconalpha,c[o].alpha),borderAlpha:(0,n.pluckNumber)(c[o].legendiconborderalpha,c[o].legendiconalpha,s.legendiconborderalpha,s.legendiconalpha,"100"),fill:c[o].legendColor,rawFillColor:c[o].rawColor,stroke:(0,n.getLightColor)(c[o].rawColor,60).replace(E,n.HASHSTRING)}})},e.legendInteractivity=function(t){var e,a,o=this.getChildren("data"),i=t.getId();for(e=0,a=o.length;e<a;e++)if(o[e].config.legendItemId===i){this.legendClick({datasetStore:this,plotItem:o[e].plot},!0,!1);break}},e.getNormalizeDataSet=function(t){var e,a,o,i,r,l,s,c,h,u,d=this.getChildren("data")||[],g=this.getFromEnv("chart"),p=this.config,f=this.getFromEnv("smartLabel"),m=p.pointInContext,v=g.getFromEnv("dataSource").chart,b=p.dataConnectorStyle={},k=g.config.PLOT_COLOR_INDEX_START,C=0;if((0,n.extend2)(s=p.style={},g.config.style),p.noOFSlicedElement=0,s.borderDash="none",s.borderPadding=2,s.borderRadius=0,s.borderThickness=1,s.color=(0,n.convertColor)(p.labelFontColor,p.labelAlpha),s.fontFamily=p.baseFont,s.fontSize=p.baseFontSize+"px",s.fontSizeWithUnit=p.baseFontSize+"px",s.fontStyle="normal",s.fontWeight="normal",b.connectorWidth=p.connectorWidth,b.connectorColor=p.connectorColor,i=(c=this.datasetCalculations(t)).hasValidPoint,o=c.refreshedData,r=c.sumValue,u=+(!p.streamLinedData&&"funnel"===this.getName()),this._chartLevelAttr=n.parsexAxisStyles.apply(this,[{},{},v,s]),i)for(p.sumValue=r,l=o.length,(0,n.componentFactory)(this,m,"data",l+u),d=this.getChildren("data"),f.useEllipsesOnOverflow(g.config.useEllipsesWhenOverflow),e=0,C=u;e<l;e+=1,C+=1)a=o[e],(h=d[C]).getState("removed")||h.parseAndConfigurePoint(a,c,k++,e);u&&d[0]&&d[0].configure({displayValue:n.BLANK,y:p.sumValue,index:0})},e.datasetCalculations=function(t){var e,a,o,i,r=this.getFromEnv("number-formatter"),n={refreshedData:[]};for(n.sumValue=n.countPoint=0,n.highestValue=Number.NEGATIVE_INFINITY,e=0,a=t.length;e<a;e++)(o=t[e]).vline||(o.cleanValue=i=Math.abs(r.getCleanValue(o.value,!0)),null!==i&&(n.hasValidPoint=!0,n.highestValue=n.highestValue||i,n.refreshedData.push(o),n.sumValue+=i,n.countPoint+=1,n.highestValue=Math.max(n.highestValue,n.itemValue)));return n},e.pointHoverOptions=function(t,e){var a,o,i,r=this.config,l=this.getFromEnv("chart"),s=r.usePattern?0:(0,n.pluckNumber)(t.showhovereffect,r.showHoverEffect),c={enabled:s},h={},u=l.getFromEnv("dataSource")?l.getFromEnv("dataSource").chart:{};if(s||r.usePattern||(s=c.enabled=void 0!==(0,n.pluck)(t.hovercolor,u.plotfillhovercolor,t.hoveralpha,u.plotfillhoveralpha,t.borderhovercolor,u.plotborderhovercolor,t.borderhoverthickness,u.plotborderhoverthickness,t.borderhoveralpha,u.plotborderhoveralpha)),s){if(c.highlight=(0,n.pluckNumber)(t.highlightonhover,u.highlightonhover),c.color=(0,n.pluck)(t.hovercolor,u.plotfillhovercolor),c.alpha=(0,n.pluck)(t.hoveralpha,u.plotfillhoveralpha,e.alpha),c.borderColor=(0,n.pluck)(t.borderhovercolor,u.plotborderhovercolor,e.borderColor),c.borderThickness=(0,n.pluckNumber)(t.borderhoverthickness,u.plotborderhoverthickness,e.borderWidth),c.borderAlpha=(0,n.pluck)(t.borderhoveralpha,u.plotborderhoveralpha,e.borderAlpha),0!==c.highlight&&void 0===c.color&&(c.highlight=1),c.color=(0,n.pluck)(c.color,e.color).replace(/,+?$/,n.BLANK),1===c.highlight){for(o=(a=c.color.split(/\s{0,},\s{0,}/)).length,i=0;i<o;i+=1)a[i]=(0,n.getLightColor)(a[i],70);c.color=a.join(",")}h={color:c.color,alpha:+c.alpha,borderColor:(0,n.convertColor)(c.borderColor,c.borderAlpha),rawBorderColor:c.borderColor,borderAlpha:c.borderAlpha,borderWidth:c.borderThickness}}return{enabled:s,options:c,rolloverOptions:h}},e.getTooltipMacroStub=function(t){return R.call(this,t)},e.allocatePosition=function(){var t=this.getFromEnv("chart").config,e=this.config;t.style.fontSize=this.computeFontSize(t.style.fontSizeWithUnit),e.lineHeight=0===e.lineHeight?0:parseInt(this._chartLevelAttr.lineHeight,10),e.showLabelsAtCenter||"<br>"!==e.labelSepChar&&"<br/>"!==e.labelSepChar||(e.lineHeight=2*e.lineHeight),this._preDrawingHook(),e.sumValue&&(e.labelDrawingConfig=e.labelDrawingConfig||[],e.labelDrawingConfig.length=0,e.psmMargin={top:t.marginTop,bottom:t.marginBottom},this.preDrawingSpaceManagement())},e.preDrawingSpaceManagement=function(){var t,e,a,o,i,r,l,s,c,h,u,d,g,p,v,b,k,C,x,w,T,y,A,S,F,N=this.getFromEnv("chart"),E=N.config,L=N.getChildren("caption")[0],D=N.getChildren("subCaption")[0],M=L.config.height||0,R=D.config.height||0,_=this.config,I=_.showTooltip,V=_.slicingDistance,O=E.height-(E.marginTop+E.marginBottom),P=E.width-(E.marginRight+E.marginLeft),G=this.getChildren("data"),B=_.blankSpace,H=this.config.LABEL_PLACEMENT_ITERATOR_INDEX_START,W="funnel"===this.getName()?1:0,z=this.getFromEnv("smartLabel"),j=0,U=0,X=this.utils(this).invokeHookFns,K=this.prePointProcessingHookFn,Y=N.getFromEnv("legend"),J=E.showLegend&&Y&&Y.config&&Y.config.legendPos?Y.config.legendPos.split("-"):[],q=0;for(!E.showLegend||"right"!==J[0]&&"left"!==J[0]||(q=Y.config.width+10),E.oriCanvasLeft=N.config.canvasLeft,E.oriBottomSpace=N.config.marginBottom,E.oriTopSpace=N.config.marginTop,y=_._tempSnap={top3DSpace:0,bottom3DSpace:0,topLabelSpace:0,rightLabelSpace:0},t=O-V,e=Math.min(2*t,P),E.marginTop+=V/2,E.marginBottom+=V/2,a=this.getDataLength(),o=_.origLabelDistance+B,i=_.showLabelsAtCenter,l=P-(r=Math.min(e,.3*P)),s=(P-=q)/2-r/2-o-E.marginLeft,c=0,u=.8/(h=G[0]&&G[0].y?G[0].y:1),X(K,[G]),d=_.totalValue||0,z.useEllipsesOnOverflow(E.useEllipsesWhenOverflow);H<a;H+=1)(g=G[H]).legendItemId&&Y.configureItems&&Y.configureItems(g.legendItemId,{configuration:{fillColor:g.legendColor}}),F=g.style,(0,n.setLineHeight)(F),p=(0,n.pluckNumber)(f(parseFloat(F.lineHeight)+F.borderPadding+F.borderThickness+5),10),z.setStyle(F),k=g.y,i?v=z.getSmartText(g.origValue,P,p):(k=g.getModifiedCurrentValue&&g.getModifiedCurrentValue(d)||k,w=s+(r-(x=r*(C=g.getRatioK(this,k,u,d,h))))/2,"<br>"!==_.labelSepChar&&"<br/>"!==_.labelSepChar||(p*=2),v=z.getSmartText(g.origValue,w,p),g.displayValue=v.text,I&&v.tooltext&&(g.originalText=v.tooltext),c=Math.max(c,v.width),l>0&&(j=1/(C+1)*(x+2*(v.width>0?w-v.width:w+o)+r),l=Math.min(l,j-r)),d+=void 0===_.offsetVal?g.y:"function"==typeof _.offsetVal?_.offsetVal(H):_.offsetVal);if(!E.showLegend||"right"!==J[0]&&"left"!==J[0]?N.isLegendRight=!1:(N.isLegendRight=!0,E.marginRight+=q),g&&(T=g.getLowestRadiusFactor(this,h)),(b=r+l)>e&&(b=e),d=void 0===_.offsetVal?0:"function"==typeof _.offsetVal?_.offsetVal():_.offsetVal,!i)for(H=this.config.LABEL_PLACEMENT_ITERATOR_INDEX_START,a=this.getDataLength();H<a;H+=1)k=(g=G[H]).y,k=g.getModifiedCurrentValue&&g.getModifiedCurrentValue(d)||k,w=s+(r-(x=b*(C=g.getRatioK(this,k,u,d,h))))/2-q,v=z.getSmartText(g.displayValue,w,p),U=m(U,.5*x+v.width+o),d+=void 0===_.offsetVal?g.y:"function"==typeof _.offsetVal?_.offsetVal():_.offsetVal;c>0?(y.rightLabelSpace=P-b,(A=U-.5*E.canvasWidth)>0&&(E.marginRight+=A,E.marginLeft-=A),E.marginRight+=.5*y.rightLabelSpace,E.marginLeft+=.5*y.rightLabelSpace):o=0,_.labelDistance=_.connectorWidth=o,(i||!c)&&e<P&&(E.marginLeft+=.5*(P-e-o),E.marginRight+=.5*(P-e-o)),_.is2d||(E.marginTop+=y.top3DSpace=b*_.yScale*W/2,E.marginBottom+=y.bottom3DSpace=b*_.yScale*T/2),this.calculatePositionOfPlots(),S=M+R+5,"funnel"===this.getName()?_.streamLinedData&&G.length<2?(E.gaugeStartX=E.marginLeft,E.gaugeStartY=E.marginTop+S,E.gaugeEndX=b+E.marginLeft,E.gaugeEndY=E.canvasHeight+E.marginTop):(E.gaugeStartX=G[0].plotX-G[1].shapeArgs.R1,E.gaugeEndX=G[0].plotX+G[1].shapeArgs.R1,E.gaugeStartY=G[0].plotY,E.gaugeEndY=G[a-1].plotY):(E.gaugeStartX=G[a-1].plotX-G[a-1].shapeArgs.R2,E.gaugeEndX=G[a-1].plotX+G[a-1].shapeArgs.R2,E.gaugeStartY=G[0].shapeArgs.y,E.gaugeEndY=G[a-1].shapeArgs.y+G[a-1].shapeArgs.h),E.gaugeCenterX=E.canvasCenterX=(E.gaugeStartX+E.gaugeEndX)/2,E.gaugeCenterY=(E.gaugeStartY+E.gaugeEndY)/2,E.plotSemiWidth=(E.canvasWidth-y.rightLabelSpace)/2},e.animateElements=function(t,e,a,o){void 0===a&&(a=[]);var i,r,n,l,s,c=this;function h(t,e){var a=(e||{}).alpha;a=void 0===a?o.post:{opacity:a},t&&c.getFromEnv("animationManager").setAnimation({el:t,attr:a,component:c})}for(i=0,r=t.length;i<r;i++)if(n=t[i])if(a.length)for(l=0,s=a.length;l<s;l++)h(t[i][e][a[l]],n.point);else h(n[e],n.point)},e.drawAllLabels=function(){var t,e,a,o,i,r=this.getFromEnv("chart"),n=this.config.labelDrawingConfig,l=r.getChildContainer("datalabelsGroup"),s=["fontFamily","fontSize","fontWeight","fontStyle"],c={};for(a=0,o=s.length;a<o;a++)(i=s[a])in this._chartLevelAttr&&(c[i]=this._chartLevelAttr[i]);for(l.css(c),a=n.length-1;a>-1;a--)(t=n[a]).css&&(t.css.fontSize=this.computeFontSize(t.css.fontSizeWithUnit)),(e=t.point).index=a,e.drawLabel()},e.drawAllTrackers=function(){var t,e,a=this.config.trackerArgs;for(t=0,e=a.length;t<e;t++)a[t].drawTracker()},e.calculatePositionCoordinate=function(t,e){var a,o,i,r,l,s,c,h,u,d,g=this.config,p=g.maxValue,f=g.is2d,m=g.x,v=this.getFromEnv("chart"),b=v.config,C=b.canvasTop,x=g.unitHeight,y=g.drawingRadius,A=g.labelDistance,S=g.showLabelsAtCenter,F=g.isHollow,N=.3*b.style.fontSize,E=g.yScale,L=g.blankSpace,D=g.lastRadius,M=this.getFromEnv("smartLabel"),R=0,_=this.getDataLength()-1,I=!1,V=0,O=g.lineHeight,P=.8/b.effCanvasHeight,G=v.config.width-2,B=g.streamLinedData,H={flag:!1,point:void 0,sLabel:void 0,setAll:function(t,e,a){this.flag=t,this.point=e,this.sLabel=a}},W={point:void 0,sLabel:void 0,set:function(t,e){var a=t,o=e;return function(t,e){var i,r;if(!t.dontPlot){if(!this.point||!this.sLabel)return this.point=t,void(this.sLabel=e);i=a(this.point,this.sLabel),r=a(t,e),o(i,r)&&(this.point=t,this.sLabel=e)}}}},z={},j={},U={},X={},K=g.slicingGapPosition={};for((0,n.extend2)(z,H),(0,n.extend2)(j,H),z.setAll=function(t,e,a){var o=this.point,i=this.sLabel;if(this.flag=t,!o||!i)return this.point=e,void(this.sLabel=a);o.labelX-(i.oriTextWidth-i.width)>e.labelX-(a.oriTextWidth-a.width)&&(this.point=e,this.sLabel=a)},j.setAll=function(t,e,a){var o=this.point,i=this.sLabel;if(this.flag=t,!o||!i)return this.point=e,void(this.sLabel=a);o.labelX+i.oriTextWidth<e.labelX+a.oriTextWidth&&(this.point=e,this.sLabel=a)},(0,n.extend2)(U,W),(0,n.extend2)(X,W),U.set=W.set.apply(U,[function(t){return t.labelX},function(t,e){return t>e}]),X.set=W.set.apply(X,[function(t,e){return t.labelX+e.oriTextWidth},function(t,e){return t<e}]),g.noOfGap=0,M.useEllipsesOnOverflow(b.useEllipsesWhenOverflow),a=0,o=t.length;a<o;a++)(i=t[a])&&(i.x=a,i.plot&&(i.isSliced=!!i.isSliced||!!g.isSliced),i.isSliced=(0,n.pluckNumber)(i.isSliced,g.isSliced),a?(e&&(I=!I),i.isSliced&&((d=i.x)>1&&!K[d]&&(K[d]=!0,g.noOfGap+=1),d<_&&(K[d+1]=!0,g.noOfGap+=1)),B?(s=1===g.useSameSlantAngle?p?y*i.y/p:y:p?y*k(i.y/p):y,r=x*(t[a-1].y-i.y)||1):s=y*(1-(R+=r=x*t[a].y)*P),i.shapeArgs={x:m,y:C,R1:D,R2:s,h:r||1,r3dFactor:E,isHollow:F,gStr:"point",is2D:f,renderer:v.getFromEnv("paper"),isFunnel:!0},M.setStyle(i.style),i.oriText=i.displayValue,l=l=M.getSmartText(i.displayValue,Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY),S?(i.labelAline=T,i.labelX=m,i.labelY=(f?C:C+E*D)+r/2+N,i.shapeArgs.h<i.minplotheightforvalue?i.showValue=0:i.showValue=1):(i.labelAline=w,i.alignmentSwitch=I,i.distributionFactor=i.distributionFactor||0,I?(i.labelX=m-(A+s+L+l.width),i.labelX-=i.distributionFactor*g.globalMinXShift,U.set(i,l)):(i.labelX=m+A+s+L,i.labelX+=i.distributionFactor*g.globalMinXShift,X.set(i,l)),V=i.distributionFactor*O,i.labelY=C+N+r+V),e&&(I&&i.labelX<0?(c=i.labelX+l.width,h=M.getSmartText(i.displayValue,c,Number.POSITIVE_INFINITY,!0),i.labelX=2,i.isLabelTruncated=!0,i.displayValue=h.text,i.virtualWidth=h.maxWidth,z.setAll(!0,i,h)):!I&&i.labelX+l.width>G&&(h=M.getSmartText(i.displayValue,G-i.labelX,Number.POSITIVE_INFINITY,!0),i.isLabelTruncated=!0,i.displayValue=h.text,i.virtualWidth=h.maxWidth,j.setAll(!0,i,h))),i.pWidth=i.virtualWidth=l.width,C+=r,D=s):(i.oriText=i.displayValue,s=1===g.useSameSlantAngle?p?y*i.y/p:y:p?y*k(i.y/p):y,i.labelWidth>2*s&&!e?(i.labelAline=w,i.labelX=g.x-i.labelWidth/2):(i.labelAline=T,i.labelX=m),u=2*A,i.displayValue=M.getSmartText(i.origValue,2*s+u,Number.POSITIVE_INFINITY,!0).text,i.labelY=(f?C:C-E*D)-N-L),i.plotX=m,i.plotY=C);this.findBestPosition(t,{lTrimmedInfo:z,rTrimmedInfo:j,lLargestLabel:U,rLargestLabel:X})},e.findBestPosition=function(t,e){var a,o,i,r,n,l,s,c,h,u=this.config,d=this.getFromEnv("chart"),g=d.config,p=0,f=e.lTrimmedInfo,m=e.rTrimmedInfo,v=e.lLargestLabel,b=e.rLargestLabel,k=this.getFromEnv("smartLabel"),C=0,x=u.streamLinedData,w=u.blankSpace,T=g.width-u.blankSpace;if(!f.flag||!m.flag){if(m.flag){if(!v.point)return;a=(o=m.sLabel).oriTextWidth-o.width,i=v.point.labelX-w,p=-Math.ceil(Math.min(a,i))}else if(f.flag){if(!b.point)return;a=(o=f.sLabel).oriTextWidth-o.width,r=T-(b.point.labelX+b.sLabel.width),p=Math.ceil(Math.min(a,r))}if(p)for(s=0,c=t.length;s<c;s++)l=t[s],s||!x?(l.alignmentSwitch?(n=p<0?k.getSmartText(l.oriText,l.pWidth,Number.POSITIVE_INFINITY,!0):k.getSmartText(l.oriText,l.pWidth+p,Number.POSITIVE_INFINITY,!0),l.isLabelTruncated&&(C=n.width-l.pWidth),l.virtualWidth=n.width):(n=p>0?k.getSmartText(l.oriText,l.pWidth,Number.POSITIVE_INFINITY,!0):k.getSmartText(l.oriText,l.pWidth-p,Number.POSITIVE_INFINITY,!0),l.virtualWidth=n.width),l.displayValue=n.text,l.labelX+=p-C,l.shapeArgs&&(l.shapeArgs.x+=p),C=0):l.labelX+=p;else for(k.useEllipsesOnOverflow(g.useEllipsesWhenOverflow),s=0,c=t.length;s<c;s++)(h=(l=t[s]).labelX+l.pWidth-T)>0&&(l.lOverflow=h,l.labelX-=h,d.isLegendRight?l.displayValue=k.getSmartText(l.oriText,l.pWidth-h,Number.POSITIVE_INFINITY,!0).text:(l.lOverflow=h,l.labelX-=h))}},e.getPlotData=function(t){var e,a,o,i=this.getChildren("data")[t],r=this.userData||(this.userData=[]),n=["y","name","color","alpha","borderColor","borderWidth","link","label","displayValue","datasetIndex","toolText"];if(r[t])e=r[t];else{for(e=r[t]={},a=0;a<n.length;a++)e[o=n[a]]=i[o];e.value=e.y,e.label=e.name,delete e.y,delete e.name}return e},e.slice=function(){var t,e,a,o,i,r,n,l,s,c,h=this,u=h.datasetStore,d=h.plotItem,g=d.index,p=u.getChildren("data"),f=p[g],m=f.getGraphicalElement(),v=u.getFromEnv("chart"),b=u.getFromEnv("animationManager"),k=u.config,C=arguments[3]||k.clicked,x=k.slicingDistance,w=x/2,T=0,y=0,A=p.length,S=[];if(!k.sliceLock){for(k.sliceLock=1,C=d.sliced=M(C)?C:!d.sliced,i=-w,r=w,c=function(){return function(){k.sliceLock=0,v.fireChartInstanceEvent("SlicingEnd",{slicedState:C,data:u.getPlotData(o)})}},T=0;T<A;T+=1)(e=p[T].plot)&&!p[T].getState("removed")&&(m=p[T].getGraphicalElement(),e!==d?(p[T].isSliced=0,e.sliced=!1,S[T]={isSliced:!1},a=!1):(p[T].isSliced=+!p[T].isSliced,S[T]={isSliced:C},a=!0,o=T),m.graphic&&(n=-e.dy,C&&(e.x<d.x?(n+=i,y+=1):e.x===d.x?y?T===A-1&&(n+=.5*w):n+=.5*-w:n+=r),m.graphic.attr({transform:"t0,"+e.dy}),e.dy+=n,t={transform:"...t0,"+n},a&&v.fireChartInstanceEvent("SlicingStart",{slicedState:!C,data:u.getPlotData(o)}),b.setAnimation({el:m.graphic,attr:t,component:u,callback:a&&c(C,o)}),m.dataLabel&&b.setAnimation({el:m.dataLabel,attr:t,component:u}),m.connector&&b.setAnimation({el:m.connector,attr:t,component:u}),m.trackerObj&&b.setAnimation({el:m.trackerObj,attr:t,component:u}),l=p[0].getGraphicalElement("graphic"),s=p[0].getGraphicalElement("dataLabel"),1===T&&!l&&s&&b.setAnimation({el:s,attr:t,component:u})));delete k.clicked}},e.legendClick=function(t){this.slice.call(t)},e.getEventArgs=function(t){var e=this.getChildren("data")[t.config.index]||{};return{alpha:e.alpha,value:e.y,color:e.color,borderColor:e.borderColor,borderWidth:e.borderWidth,link:e.link,displayValue:e.displayValue,datasetIndex:e.datasetIndex,toolText:e.toolText,label:e.categoryLabel}},e.plotMouseUp=function(t){var e=this.plotItem,a=this.datasetStore,o=a.getChildren("data")[e.index],i=a.getFromEnv("chart"),r=o.getGraphicalElement("trackerObj");r.data("eventArgs",Object.assign(r.data("eventArgs"),{isSliced:o.isSliced})),i.plotEventHandler(r,t,"dataplotclick")},a}(l.ComponentInterface);e["default"]=G},1171:function(t,e,a){"use strict";e.__esModule=!0,e["default"]=void 0;var o={initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"final"},i=function(){return{"connector.appearing":function(){return[o]},"connector.transform":function(t){return[{initialAttr:{path:t.attr.path},finalAttr:{path:t.attr.path}}]},"dataLabel.appearing":function(){return[o]},"dataLabel.transform":function(t){return[{initialAttr:{transform:t.attr.transform},finalAttr:{transform:t.attr.transform}}]},"path.appearing":function(){return[Object.assign({},o,{slot:"plot"})]}}},r={"initial.dataset.funnel":i,"initial.dataset.pyramid":i};e["default"]=r},1172:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1173)),n=a(224),l=n.preDefStr.POSITION_START,s=n.preDefStr.POSITION_END,c=n.preDefStr.POSITION_MIDDLE,h={right:s,left:l,middle:c,start:l,end:s,center:c,undefined:n.BLANK,BLANK:n.BLANK},u=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.configure=function(t){for(var e in void 0===t&&(t={}),t)this[e]=t[e];this.upperRadiusFactor=1},a.getType=function(){return"data"},a.getName=function(){return"funnelpoint"},a.getModifiedCurrentValue=function(){},a.getRatioK=function(t,e,a,o,i){var r=t.config,n=!r.streamLinedData,l=r.useSameSlantAngle;return n?.2+a*o:this.y?l?this.y/i:Math.sqrt(this.y/i):1},a.getLowestRadiusFactor=function(t,e){var a=t.config,o=!a.streamLinedData,i=a.useSameSlantAngle;return o?.2:this.y?i?this.y/e:Math.sqrt(this.y/e):1},a.allocatePosition=function(){},a.drawPlots=function(){var t,e,a,o,i,r,l,s=this.index,c=this.getLinkedParent(),u=c.getFromEnv("toolTipController"),d=c.config,g=this.y,p=this.displayValue,f=d.isSliced,m=this.labelAline,v=this.appliedStyle,b=this.style,k=n.BLANK,C=c.getFromEnv("chart").getChildContainer("trackerGroup"),x=this.plot,w=!!this.link,T=this.hoverHandler,y=d.distanceAvailed,A=c.config.labelDrawingConfig,S=c.getFromEnv("animationManager"),F=this.setRolloutAttr,N=this.setRolloverAttr,E=this.rolloverProperties,L={};if(t=f?1:this.isSliced,i=v&&v.color||b&&b.color||c._chartLevelAttr.color,l={text:p,direction:k,cursor:w?"pointer":n.BLANK,x:0,y:0,fill:i,"text-anchor":h[m]},null!=g&&this.shapeArgs)return a=this.getGraphicalElement("graphic"),o=this.getGraphicalElement("trackerObj"),!F&&(this.setRolloutAttr=F={}),!N&&(this.setRolloverAttr=N={}),this.hoverEffects?(F.color=this.rawColor,F.opacity=this.rawAlpha,F["stroke-width"]=this.borderWidth,F.stroke=this.borderColor,N.color=E.color,N.opacity=E.alpha,N["stroke-width"]=E.borderWidth,N.stroke=E.borderColor,N.rawBorderColor=E.rawBorderColor,N.borderAlpha=E.borderAlpha):(F=this.setRolloutAttr={},N=this.setRolloverAttr={}),x?(this.shapeArgs.graphics=a,a=c.pyramidFunnelShape(this.shapeArgs),this.addGraphicalElement("graphic",a),a=S.setAnimation({el:a,attr:{fill:this.color,"stroke-width":this.borderWidth,stroke:this.borderColor},component:c}),this.addGraphicalElement("graphic",a),a.show(),A[s]=r={args:l,css:v,point:this}):(this.shapeArgs.graphics=x,this.plot=x={},a=c.pyramidFunnelShape(this.shapeArgs).attr({fill:this.color,"stroke-width":this.borderWidth,stroke:this.borderColor}),o=S.setAnimation({el:"path",container:C,component:c}).on("fc-click",c.plotMouseUp,L).hover(T,T),this.addGraphicalElement("graphic",a),this.addGraphicalElement("trackerObj",o),A[s]=r={args:l,css:v,point:this}),a.funnel2D&&a.funnel2D.addPattern(this.patternAttr,d.usePattern),d.showTooltip?u.enableToolTip(o,this.toolText):u.disableToolTip(o),x.value=g,x.displayValue=p,x.sliced=!!t,x.cursor=w?"pointer":n.BLANK,x.x=this.x,x.index=s,L.datasetStore=c,L.plotItem=x,o.off("fc-click",c.slice),!this.doNotSlice&&o.on("fc-click",c.slice,L),r.context=L,r.actions={click:c.slice,hover:[T,T]},x.dy=0,d.noOfGap?(y&&(x._startTranslateY=e="t0,"+y,x.dy=x.distanceAvailed=y),d.slicingGapPosition[this.x]&&(d.distanceAvailed-=d.perGapDistance)):x._startTranslateY=e="t0,0",S.setAnimation({el:a,attr:{transform:e},component:c}),r.transform=e,x;A[s]=r={args:l,css:v,point:this}},e}(r["default"]);e["default"]=u},1173:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(242)),r=o(a(238)),n=a(240),l=a(224),s=a(588),c=a(538),h=a(236),u=window,d=u.navigator.userAgent,g=/msie/i.test(d)&&!u.opera,p="rgba(192,192,192,"+(g?.002:1e-6)+")",f=["fontFamily","fontSize","fontWeight","fontStyle"],m=function(){this.hide()},v=function(t,e){var a,o,i={labelfont:"fontFamily",labelfontcolor:"color",labelfontsize:"fontSize",labelfontbold:"fontWeight",labelfontitalic:"fontStyle",labelalpha:"alpha"};for(o in i)(o in t||o in e)&&(a=a||{},"labelfontsize"===o?(a[i[o]]=(0,l.pluck)(t[o],this.computeFontSize(e[o])),a.fontSizeWithUnit=(0,l.pluckFontSizeMaintainUnit)(t.labelfontsize,e.labelfontsize)):a[i[o]]=(0,l.pluck)(t[o],e[o]));return a?(a.fontWeight&&(a.fontWeight=(0,l.pluckNumber)(a.fontWeight)?"bold":"normal"),a.fontStyle&&(a.fontStyle=(0,l.pluckNumber)(a.fontStyle)?"italic":"normal"),a.color=(0,l.convertColor)(a.color,a.alpha),a):a},b=function(t){function e(){var e;e=t.call(this)||this;var a=(0,i["default"])(e);return e.hoverHandler=function(t){var e=a.getGraphicalElement("graphic"),o=a.getLinkedParent().getFromEnv("chart");this.data("eventArgs",Object.assign(this.data("eventArgs"),{isSliced:a.isSliced})),"mouseover"===t.type?(e.attr(a.setRolloverAttr),o.plotEventHandler(this,t,"DataPlotRollOver")):(e.attr(a.setRolloutAttr),o.plotEventHandler(this,t,"DataPlotRollOut"))},e}(0,r["default"])(e,t);var a=e.prototype;return a.parseAndConfigurePoint=function(t,e,a,o){var i,r,n,s,h,u,d,g,p,f,m,b,k,C,x,w,T,y,A,S,F,N,E,L,D,M,R,_,I,V,O,P,G,B,H,W,z,j=this.getLinkedParent(),U=j.getFromEnv("chart"),X=j.config,K=j.getFromEnv("number-formatter"),Y=j.getFromEnv("smartLabel"),J=j.getFromEnv("color-manager"),q=0,Z=X.showPercentValues,$=X.labelSepChar,Q=U.getFromEnv("chart-attrib"),tt=X.isSliced,et={apply:X.showShadow,opacity:1},at=(0,l.pluckNumber)(t.minplotheightforvalue,Q.minplotheightforvalue,0),ot=X.plotBorderThickness,it=X.style;X.showTextOutline=(0,l.pluckNumber)(Q.textoutline,0),r=e.refreshedData,q=e.sumValue,f=K.dataLabels(q),n=e.highestValue,B=(0,l.pluck)(t.labellink,Q.labellink,t.link,l.UNDEF),P=t.legendItemId,m=t.cleanValue,b=o?r[o-1].value:m,k=(0,l.parseUnsafeString)((0,l.pluck)(t.label,t.name,l.BLANKSTRING)),L=t.id?(0,l.parseUnsafeString)((0,l.pluck)(t.id)):k,Y.setStyle(this.getFromEnv("dataLabelStyle")),C=Y.getOriSize(k),s=c.PATTERN_TYPES.includes(t.patterntype)?t.patterntype:X.patternType,h=(0,l.pluckNumber)(t.patternangle,U.getFromEnv("chart-attrib").patternangle,s===c.PATTERN_TYPES[0]?40:0),u=(0,l.pluckNumber)(t.patterndensity,X.patternDensity),d=(0,l.pluckNumber)(t.patternsize,s===c.PATTERN_TYPES[0]?2:4),g=(0,l.pluckNumber)(t.patternalpha,X.patternAlpha),p=(0,l.pluck)(t.patternbgcolor,X.patternBgColor),M=t.alpha||X.plotFillAlpha,G=(0,l.pluck)(t.color,J.getPlotColor(a)),H=(0,l.convertColor)(G),W=t.legendiconalpha,z=t.legendiconbgalpha,D=(0,l.convertColor)(G,M),R=(0,l.pluck)(t.bordercolor,X.plotBorderColor,X.usePattern?G:(0,l.getLightColor)(G,25)).split(l.COMMASTRING)[0],_=X.showPlotBorder?(0,l.pluck)(t.borderalpha,X.plotBorderAlpha,X.usePattern?"100":"80"):l.ZEROSTRING,et.opacity=Math.max(M,_)/100,(x=(0,l.pluckNumber)(t.issliced,tt))&&(X.noOFSlicedElement+=1,X.preSliced=x),e.prevPerValReq&&(q=b),w=K.percentValue(m/q*100),X.datalabelDisabled||(T=K.dataLabels(m)||l.BLANKSTRING,y=1===X.showLabels?k:l.BLANKSTRING,A=1===(i=(0,l.pluckNumber)(t.showvalue,X.showValues,1))?1===Z?w:T:l.BLANKSTRING,S=(0,l.getValidValue)((0,l.parseUnsafeString)(t.displayvalue)),O=(0,l.pluck)(S,k+$+(Z?w:T),l.BLANKSTRING),A=S||(A!==l.BLANKSTRING&&y!==l.BLANKSTRING?y+$+A:(0,l.pluck)(y,A)||l.BLANKSTRING)),(F=(0,l.getValidValue)((0,l.parseUnsafeString)((0,l.pluck)(t.tooltext,X.toolText),!1)))!==l.UNDEF?(I={formatedVal:T,name:k,pValue:w,sum:f,sumValue:f,dataValue:m,prevValue:b,highestValue:n},F=(0,l.parseTooltext)(F,[1,2,3,7,14,24,25,37],j.getTooltipMacroStub(I),t,Q)):(N=1===X.showPercentInToolTip?w:T,F=k!==l.BLANKSTRING?k+X.tooltipSepChar+N:N),V=j.pointHoverOptions(t,{color:G,alpha:M,borderColor:R,borderAlpha:_,borderWidth:ot}),E={displayValue:A,origValue:A,displayValueArgs:O,style:l.parsexAxisStyles.apply(this,[t,{},Q,it,D]),appliedStyle:v.apply(this,[t,Q]),name:k,categoryLabel:k,rawColor:G,rawAlpha:M,toolText:F,legendCosmetics:l.UNDEF,legendItemId:P||this&&this.legendItemId,showInLegend:l.UNDEF,y:m,shadow:et,smartTextObj:C,legendColor:H,color:D,alpha:M,legendiconalpha:W,legendiconbgalpha:z,borderColor:(0,l.convertColor)(R,_),plotBorderColor:R,plotBorderAlpha:_,borderWidth:ot,link:(0,l.getValidValue)(t.link),isSliced:x,doNotSlice:!X.enableSlicing,hoverEffects:V.enabled&&V.options,labellink:B,rolloverProperties:V.enabled&&V.rolloverOptions,minplotheightforvalue:at,showValue:i,id:L,patternAttr:{patternType:s,patternAngle:h,patternDensity:u,patternSize:d,patternAlpha:g,patternBgColor:p,color:D,alpha:M,x:0,y:0}},this.configure(E)},a.drawLabel=function(){var t,e,a,o,i,r,n,c,h,u,d,g,p,v,b,k,C=this,x=C.index,w=C.getLinkedParent(),T=w.getFromEnv("chart"),y=w.getFromEnv("animationManager"),A=w.getFromEnv("toolTipController"),S=w.config,F=T.getChildContainer("datalabelsGroup"),N=w.getChildren("data"),E=C.displayValue,L=C.plot||{},D=C.getGraphicalElement("dataLabel"),M=C.getGraphicalElement("connector"),R=!D,_=C.labelY,I=C.labelX,V=C.style||{},O=(0,l.pluckNumber)(parseInt(V.fontSize,10),S.baseFontSize),P="funnel"===w.getName(),G=S.lineHeight,B=.3*O,H=.3*G,W=S.showLabelsAtCenter,z=C.setRolloverAttr,j=S.connectorEndSwitchHistoryY,U=S.labelDistance,X=S.blankSpace,K=S.streamLinedData,Y=C.shapeArgs,J=!Y||Y.h>C.minplotheightforvalue;if(!C.displayValue||P&&!S.streamLinedData&&!x)return D&&y.setAnimation({el:D,component:w,callback:m,doNotRemove:!0}),void(M&&y.setAnimation({el:M,component:w,callback:m,doNotRemove:!0}));i=w.config.labelDrawingConfig[x],a=i.actions,t=C.y,e={"stroke-width":S.dataConnectorStyle.connectorWidth,stroke:S.dataConnectorStyle.connectorColor,transform:i.transform},i.args.cursor=C.labellink?"pointer":"default",i.args&&i.css&&(i.args.fill=i.css.color||i.css.fill),null!==t&&t!==l.UNDEF&&Y?(o=!(P&&0===x&&S.streamLinedData),C.plot&&(D&&D.removeCSS(f),(D=y.setAnimation({el:D||"text",label:"dataLabel",attr:i.args,css:i.css,container:F,component:w})).outlineText(S.showTextOutline,i.args.fill),C.addGraphicalElement("dataLabel",D),M=y.setAnimation({el:M||"path",attr:o&&e,container:F,callback:function(){S.showLabelsAtCenter&&this.hide()},component:w,label:"connector"}),o&&C.addGraphicalElement("connector",M)),A.enableToolTip(D,C.originalText),R||(C.labelClickFn&&D.off("fc-click",C.labelClickFn),C.actionsClick&&D.off("fc-click",C.actionsClick)),h={index:C.index,link:C.link,value:C.y,displayValue:C.displayValueArgs,categoryLabel:C.categoryLabel,dataIndex:C.index||l.BLANK,toolText:C.toolText,label:C.categoryLabel,color:C.rawColor,alpha:C.rawAlpha,showValue:C.showValue,isSliced:C.isSliced,borderColor:C.plotBorderColor,borderAlpha:C.plotBorderAlpha,hoverColor:z.color,hoverAlpha:z.opacity,borderHoverColor:z.rawBorderColor,borderHoverAlpha:z.borderAlpha,borderHoverThickness:z["stroke-width"],id:C.id},D.data("eventArgs",h),C.labellink&&D.on("fc-click",(b=D,k=C.labellink,C.labelClickFn=function(){s.labelClickFn.call(b,T,k)},C.labelClickFn)),!C.doNotSlice&&D.on("fc-click",(v=i.context,C.actionsClick=function(){a.click.call(v)},C.actionsClick)),R&&D.hover(a.hover[0],a.hover[1])):(D?(D.removeCSS(f),D&&y.setAnimation({el:D,attr:i.args,component:w}),D&&D.css(i.css)):(D=y.setAnimation({el:"text",label:"dataLabel",attr:i.args,css:i.css,container:F,component:w}),C.addGraphicalElement("dataLabel",D)),D.outlineText(S.showTextOutline,i.args.fill)),W?(p=0===x&&K?_-H+(N[1].plot.distanceAvailed||0):_-H+(L.distanceAvailed||0),E!==l.BLANKSTRING?(y.setAnimation({el:D,attr:{transform:["t",I,p]},component:w}),D.show()):D&&y.setAnimation({el:D,component:w}),!J&&C.getGraphicalElement("dataLabel")&&C.getGraphicalElement("dataLabel").hide()):(r=_-B-C.distributionFactor*G,n=_-B,c=j[C.alignmentSwitch],S.lastplotY!==l.UNDEF&&c!==l.UNDEF&&c-n<G&&(_=n=c-G),C.displayValue&&(j[C.alignmentSwitch]=n),S.lastplotY=C.plotY,d=S.labelAlignment===S.alignmentType.alternate&&C.alignmentSwitch?(u=I+X+C.virtualWidth)+U+C.distributionFactor*S.globalMinXShift:(u=I-X)-(U-(C.lOverflow||0))-C.distributionFactor*S.globalMinXShift,void 0===E||E===l.BLANKSTRING||P&&0===x&&K?M&&y.setAnimation({el:M,component:w}):(g=["M",d,r,"L",u,n],y.setAnimation({el:M,state:"transform",label:"connector",attr:{path:g,"shape-rendering":r===n&&n<1?"crisp":l.BLANK},component:w}),M.show()),p=0===x&&K?_+(N[1].plot.dy||0):n+(L.dy||0),E!==l.BLANKSTRING?(y.setAnimation({el:D,state:"transform",attr:{transform:["t",I,p]},component:w,label:"dataLabel"}),D.show()):D&&y.setAnimation({el:D,component:w})),D.attr({"text-bound":[V.backgroundColor,V.borderColor,V.borderThickness,V.borderPadding,V.borderRadius,V.borderDash]})},a.drawTracker=function(){var t,e,a,o,i,r=this.getLinkedParent(),n=r.getFromEnv("chart"),s=n.getFromEnv("paper"),c=n.getChildContainer("trackerGroup"),h=+new Date;this&&(a=this.getGraphicalElement("graphic"),e=this.getGraphicalElement("trackerObj"),a&&(t=a.Shapeargs.silhuette,o=this.setRolloverAttr,i={index:this.index,link:this.link,value:this.y,displayValue:this.displayValueArgs,categoryLabel:this.categoryLabel,dataIndex:this.index||l.BLANK,toolText:this.toolText,label:this.categoryLabel,color:this.rawColor,alpha:this.rawAlpha,showValue:this.showValue,isSliced:this.isSliced,borderColor:this.plotBorderColor,borderAlpha:this.plotBorderAlpha,hoverColor:o.color,hoverAlpha:o.opacity,borderHoverColor:o.rawBorderColor,borderHoverAlpha:o.borderAlpha,borderHoverThickness:o["stroke-width"],id:this.id},r.config.usePattern&&(i.pattern={patternType:this.patternAttr.patternType,patternColor:this.patternAttr.color,patternBgColor:this.patternAttr.patternBgColor===p?l.UNDEF:this.patternAttr.patternBgColor},delete i.color),this.datasetIndex=this.index,e?e.attr({path:t,isTracker:h,fill:p,stroke:"none",transform:"t0,"+(this.plot._startTranslateY||0),cursor:this.link?"pointer":"default"}):(e=s.path(t,c).attr({isTracker:h,fill:p,stroke:"none",transform:"t0,"+(this.plot._startTranslateY||0),cursor:this.link?"pointer":"default"}),this.addGraphicalElement("trackerObj",e)),e.data("eventArgs",i),e.show()))},a.syncDraw=function(){var t=this;t.fireEvent("predraw"),t.removeJob("draw"),t.getState("removed")?t.removingDraw():t.drawPlots&&t.drawPlots(),t.addExtEventListener("animationComplete",t.__remove,t.getFromEnv("animationManager")),t.childrenSyncDraw(),t.setState("dirty",!1),t.setState("parentChanged",!1),t.addJob("draw-complete",(function(){t.fireEvent("drawn")}),h.priorityList.instant)},e}(n.ComponentInterface);e["default"]=b},1174:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1175))["default"];e["default"]=i},1175:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1168)),n=o(a(1176)),l=function(t){function e(){var e;return(e=t.call(this)||this).useSortedData=!1,e}(0,i["default"])(e,t),e.getName=function(){return"Pyramid"};var a=e.prototype;return a.getName=function(){return"Pyramid"},a.__setDefaultConfig=function(){t.prototype.__setDefaultConfig.call(this);var e=this.config;e.friendlyName="Funnel Chart",e.defaultDatasetType="pyramid"},a.configureAttributes=function(){t.prototype.configureAttributes.call(this),this.config.PLOT_COLOR_INDEX_START=0,this.alignLegendWithCanvas=0},a.getDSdef=function(){return n["default"]},e}(r["default"]);e["default"]=l},1176:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=a(224),n=o(a(1170)),l=a(236),s=o(a(1177)),c=r.preDefStr.POSITION_START,h=r.preDefStr.POSITION_MIDDLE,u=function(t){function e(){var e;return(e=t.call(this)||this).preDrawingHook=function(){},e.config.pointInContext=s["default"],e.config.LABEL_PLACEMENT_ITERATOR_INDEX_START=0,e}(0,i["default"])(e,t);var a=e.prototype;return a.getType=function(){return"dataset"},a.getName=function(){return"pyramid"},a.configure=function(t){if(!t)return!1;this.config.JSONData=t;var e=this.getFromEnv("chartConfig");this._checkValidData(this.config.JSONData.data)&&(this._configure(),e.showLegend&&this.addLegend())},a.configureSpecifics=function(){var t=this.getFromEnv("chart"),e=this.config,a=t.getFromEnv("dataSource")?t.getFromEnv("dataSource").chart:{};(0,this.utils(this).copyProperties)(a,e,[["pyramidyscale","yScale",r.pluckNumber,void 0,function(t){var e=t.yScale;t.yScale=e>=0&&e<=40?e/200:.2}],["use3dlighting","use3DLighting",r.pluckNumber,1]])},a.calculatePositionOfPlots=function(){var t,e,a,o,i,n,l,s,c,h,u,d,g,p,f,m,v=this.getFromEnv("chart").config,b=this.config,k=this.utils(this).DistributionMatrix,C=this.calculatePositionCoordinate,x=b.psmMargin,w=this.getChildren("data"),T=2,y=w.length,A=0,S=0,F=b.lineHeight,N=Math.floor;for(this.postPlotCallback=r.stubFN,v.canvasTop+=v.marginTop-x.top,v.effCanvasHeight=i=v.canvasHeight-(v.marginTop+v.marginBottom)+(x.top+x.bottom),v.effCanvasWidth=n=v.width-(v.marginLeft+v.marginRight),l=b.drawingRadius=n/T,b.x=v.canvasLeft+(v.canvasRight-v.canvasLeft)/2,m=Math.atan(n/2/i),b.unitHeight=o=i/b.sumValue,b.lastRadius=0,b.globalMinXShift=Math.floor(F/Math.cos(m)),(s=b.alignmentType={})["default"]=1,s.alternate=2,f=new k(N(i/F)),t=0,e=y;t<e;t++)(a=w[t]).getState("removed")||(A=a.y*o,c=N(((S+=a.y*o)-A+A/2)/F),f.push(a,c));if(h=f.getDistributedResult(),w.length=0,void 0===h.matrix[1])[].push.apply(w,h.matrix[0]);else for(u=h.matrix[0],d=h.matrix[1],e=Math.max(u.length,d.length),t=0;t<e;t++)p=u[t],g=d[t],w.push(p||g);switch(h.suggestion){case s["default"]:C.call(this,w,!1);break;case s.alternate:b.labelAlignment=s.alternate,T=3,b.drawingRadius=l=n/T,v.canvasLeft=v.canvasWidth/2-l,b.x=v.canvasLeft+l,C.call(this,w,!0)}},a.draw=function(){var t,e,a,o,i,r,n,s=this.getFromEnv("chart"),c=this.config,h=this.config.trackerArgs=[],u=this.getChildren("data"),d=u.length,g=Math.min;if(c.sumValue){for(this.config.labelDrawingConfig=this.config.labelDrawingConfig||[],this.config.labelDrawingConfig.length=0,this.animateFunction=function(t){return function(){t.attr({opacity:1})}},i=(a=c.slicingDistance)/2,t=0,e=u.length;t<e;t++)u[t]&&u[t].shapeArgs&&(u[t].shapeArgs.renderer=s.getFromEnv("paper"));for((o=c.noOfGap)&&(c.perGapDistance=g(1.5*i,a/o),c.distanceAvailed=i),t=u.length,c.alreadyPlotted&&(this.postPlotCallback=function(){n||(n=!0)});t--;)(r=u[t]).index=t,r.syncDraw();for(c.oldLastData=Object.assign({},u[u.length-1].shapeArgs),this.hide(this.getChildren("data"),d),c.connectorEndSwitchHistoryY={},t=u.length;t--;)h.push(u[t]);this.addJob("labelDrawID",this.drawAllLabels.bind(this),l.priorityList.label),this.addJob("trackerDrawID",this.drawAllTrackers.bind(this),l.priorityList.tracker),this.removePlots(),c.alreadyPlotted=!0,c.prevIs2d=c.is2d}},a.calculatePositionCoordinate=function(t,e){var a,o,i,n,l,s,u,d,g,p=this.config,f=p.is2d,m=p.x,v=this.getFromEnv("chart"),b=v.config,k=b.canvasTop,C=p.unitHeight,x=p.labelDistance,w=p.showLabelsAtCenter,T=.3*b.style.fontSize,y=p.yScale,A=p.blankSpace,S=p.lastRadius,F=this.getFromEnv("smartLabel"),N=t.length-1,E=!1,L=0,D=p.lineHeight,M=0,R={flag:!1,point:void 0,sLabel:void 0,setAll:function(t,e,a){this.flag=t,this.point=e,this.sLabel=a}},_={point:void 0,sLabel:void 0,set:function(t,e){var a=t,o=e;return function(t,e){var i,r;if(!t.dontPlot){if(!this.point||!this.sLabel)return this.point=t,void(this.sLabel=e);i=a(this.point,this.sLabel),r=a(t,e),o(i,r)&&(this.point=t,this.sLabel=e)}}}},I={},V={},O={},P={},G=v.config.width-2,B=p.slicingGapPosition={};for((0,r.extend2)(I,R),(0,r.extend2)(V,R),I.setAll=function(t,e,a){var o=this.point,i=this.sLabel;if(this.flag=t,!o||!i)return this.point=e,void(this.sLabel=a);o.labelX-(i.oriTextWidth-i.width)>e.labelX-(a.oriTextWidth-a.width)&&(this.point=e,this.sLabel=a)},V.setAll=function(t,e,a){var o=this.point,i=this.sLabel;if(this.flag=t,!o||!i)return this.point=e,void(this.sLabel=a);o.labelX+i.oriTextWidth<e.labelX+a.oriTextWidth&&(this.point=e,this.sLabel=a)},(0,r.extend2)(O,_),(0,r.extend2)(P,_),O.set=_.set.apply(O,[function(t){return t.labelX},function(t,e){return t>e}]),P.set=_.set.apply(P,[function(t,e){return t.labelX+e.oriTextWidth},function(t,e){return t<e}]),p.noOfGap=0,F.useEllipsesOnOverflow(b.useEllipsesWhenOverflow),a=0,o=t.length;a<o;a++)(i=t[a])&&(i.x=a,i.plot&&(i.isSliced=!!i.isSliced||!!p.isSliced),i.isSliced=(0,r.pluckNumber)(i.isSliced,p.isSliced),e&&(E=!E),i.isSliced&&((g=i.x)&&!B[g]&&(B[g]=!0,p.noOfGap+=1),g<N&&(B[g+1]=!0,p.noOfGap+=1)),F.setStyle(i.style),i.oriText=i.displayValue,l=l=F.getSmartText(i.displayValue,Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY),M+=i.y,s=p.drawingRadius*M/p.sumValue,n=C*i.y,i.shapeArgs={x:m,y:k,R1:S,R2:s,h:n,r3dFactor:y,gStr:"point",is2D:f,use3DLighting:!!p.use3DLighting,renderer:this.getFromEnv("paper")},w?(i.labelAline=h,i.labelX=m,i.labelY=(f?k:k+y*S)+n/2+T):(i.labelAline=c,i.alignmentSwitch=E,i.distributionFactor=i.distributionFactor||0,E?(i.labelX=m-(x+(s+S)/2+A+l.width),i.labelX-=i.distributionFactor*p.globalMinXShift,O.set(i,l)):(i.labelX=m+x+(s+S)/2+A,i.labelX+=i.distributionFactor*p.globalMinXShift,P.set(i,l)),L=i.distributionFactor*D,i.labelY=k+T+n/2+L),e&&(E&&i.labelX<0?(u=i.labelX+l.width,d=F.getSmartText(i.displayValue,u,Number.POSITIVE_INFINITY,!0),i.labelX=2,i.isLabelTruncated=!0,i.displayValue=d.text,i.virtualWidth=d.maxWidth,I.setAll(!0,i,d)):!E&&i.labelX+l.width>G&&(d=F.getSmartText(i.displayValue,G-i.labelX,Number.POSITIVE_INFINITY,!0),i.isLabelTruncated=!0,i.displayValue=d.text,i.virtualWidth=d.maxWidth,V.setAll(!0,i,d)),i.pWidth=i.virtualWidth||l.width,L=i.distributionFactor*D,i.labelY=k+T+n/2+L),k+=n,i.plotX=m,i.plotY=k-n/2,S=s,i.virtualWidth=i.virtualWidth||l.width);this.findBestPosition(t,{lTrimmedInfo:I,rTrimmedInfo:V,lLargestLabel:O,rLargestLabel:P})},a.getTooltipMacroStub=function(e){var a,o,i=this.config,r=this.getFromEnv("number-formatter");return o=i.percentOfPrevious?e.pValue:r.percentValue(e.dataValue/e.prevValue*100),(a=t.prototype.getTooltipMacroStub.call(this,e)).percentValue=i.percentOfPrevious?r.percentValue(e.dataValue/e.highestValue*100):e.pValue,a.percentOfPrevValue=o,a},e}(n["default"]);e["default"]=u},1177:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(1173)),n=a(224),l=n.preDefStr.POSITION_START,s=n.preDefStr.POSITION_END,c=n.preDefStr.POSITION_MIDDLE,h={right:s,left:l,middle:c,start:l,end:s,center:c,undefined:n.BLANK,BLANK:n.BLANK},u=function(t){function e(){return t.apply(this,arguments)||this}(0,i["default"])(e,t);var a=e.prototype;return a.configure=function(t){for(var e in void 0===t&&(t={}),t)this[e]=t[e];this.upperRadiusFactor=0},a.getType=function(){return"data"},a.getName=function(){return"pyramidpoint"},a.getModifiedCurrentValue=function(t){return t+this.y/2},a.getRatioK=function(t,e){var a=t.config;return e?e/a.sumValue:1},a.getLowestRadiusFactor=function(){return 1},a.allocatePosition=function(){},a.drawPlots=function(){var t,a,o,i,r,l,s,c,u=this,d=u.index,g=u.getLinkedParent(),p=g.config,f=g.getFromEnv("toolTipController"),m=u.y,v=u.displayValue,b=p.isSliced,k=n.BLANK,C=g.getFromEnv("chart"),x=g.getFromEnv("animationManager"),w=C.getChildContainer("trackerGroup"),T=C.getChildContainer("datalabelsGroup"),y=C.getChildContainer().plotGroup,A=u.plot,S=!!u.link,F=p.pointInContext,N=p.distanceAvailed,E=u.labelAline,L=u.appliedStyle,D=this.hoverHandler,M=u.style,R=u.setRolloutAttr,_=u.setRolloverAttr,I=u.rolloverProperties,V={},O=g.config.labelDrawingConfig;if(u instanceof e||(i=u,(u=new F).configure(i),g.components.data[d]=u),p.prevIs2d&&p.prevIs2d!==p.is2d&&(x.setAnimation({el:y,attr:{opacity:1},component:g}),x.setAnimation({el:T,attr:{opacity:1},component:g})),s=L&&L.color||M&&M.color||g._chartLevelAttr.color,t=b?1:u.isSliced,l={text:v,direction:k,cursor:S?"pointer":n.BLANK,x:0,y:0,fill:s,"text-anchor":h[E]},null!=m&&u.shapeArgs)return o=u.getGraphicalElement("graphic"),r=u.getGraphicalElement("trackerObj"),!R&&(u.setRolloutAttr=R={}),!_&&(u.setRolloverAttr=_={}),u.hoverEffects?(R.color=u.rawColor,R.opacity=u.rawAlpha,R["stroke-width"]=u.borderWidth,R.stroke=u.borderColor,_.color=I.color,_.opacity=I.alpha,_["stroke-width"]=I.borderWidth,_.stroke=I.borderColor,_.rawBorderColor=I.rawBorderColor,_.borderAlpha=I.borderAlpha):(R=u.setRolloutAttr={},_=u.setRolloverAttr={}),A?(u.shapeArgs.graphics=o,o=g.pyramidFunnelShape(u.shapeArgs),u.addGraphicalElement("graphic",o),x.setAnimation({el:o,attr:{fill:u.color,"stroke-width":u.borderWidth,stroke:u.borderColor},component:g}),o.show(),O[d]=c={args:l,css:L,point:u}):(u.shapeArgs.graphics=A,u.plot=A={},o=g.pyramidFunnelShape(u.shapeArgs).attr({fill:u.color,"stroke-width":u.borderWidth,stroke:u.borderColor}),r=x.setAnimation({el:"path",container:w,component:g}).on("fc-click",g.plotMouseUp,V).hover(D,D),u.addGraphicalElement("graphic",o),u.addGraphicalElement("trackerObj",r),O[d]=c={args:l,css:L,point:u}),o.lighterHalf&&o.lighterHalf.addPattern(u.patternAttr,p.usePattern),o.darkerHalf&&o.darkerHalf.addPattern(u.patternAttr,p.usePattern),p.showTooltip?f.enableToolTip(r,u.toolText):f.disableToolTip(r),A.value=m,A.displayValue=v,A.sliced=!!t,A.cursor=S?"pointer":n.BLANK,A.x=u.x,A.index=d,V.datasetStore=g,V.plotItem=A,r.off("fc-click",g.slice),!u.doNotSlice&&r.on("fc-click",g.slice,V),c.context=V,c.actions={click:g.slice,hover:[D,D]},A.dy=0,p.noOfGap?(N&&(A._startTranslateY=a="t0,"+N,A.dy=A.distanceAvailed=N),p.slicingGapPosition[u.x]&&(p.distanceAvailed-=p.perGapDistance)):A._startTranslateY=a="t0,0",x.setAnimation({el:o,attr:{transform:a},component:g}),c.transform=a,A;O[d]=c={args:l,css:L,point:u}},e}(r["default"]);e["default"]=u},1178:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(1179))["default"];e["default"]=i},1179:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(238)),r=o(a(465)),n=o(a(568)),l=a(566),s=o(a(1180)),c=o(a(1181)),h=a(224),u=a(1062);function d(t){var e=t,a=t.config,o=e.getChildren(c["default"].getType()),i=o?o.length:0,r=t.getFromEnv("dataSource");if(Array.isArray(r.data))if(r.data.length>i){for(var n=e.getChildren("plot"),l=0;l<i;l++)n[l].configure({startangle:a.startangle,endangle:a.endangle,barstartradius:a.barstartradius,barendradius:a.barendradius,barborder:a.barborder,barbordercolor:a.barbordercolor,barborderalpha:a.barborderalpha,barborderthickness:a.barborderthickness,color:a.plots[l].color,baralpha:a.plots[l].baralpha,legenditemalpha:a.plots[l].baralpha,legenditemcolor:a.plots[l].color,legenditembordercolor:a.barbordercolor,value:a.plots[l].value,dataValue:a.plots[l].dataValue,label:a.plots[l].label,iconurl:a.plots[l].iconurl,contexttext:a.plots[l].contextlabeltext,tooltext:a.plots[l].tooltext,plotHidden:a.plots[l].initiallyhidden,plotIndex:l});for(var s=0;s<r.data.length-i;s++){var h=new c["default"];e.attachChild(h,"plot").configure({startangle:a.startangle,endangle:a.endangle,barstartradius:a.barstartradius,barendradius:a.barendradius,barborder:a.barborder,barbordercolor:a.barbordercolor,barborderalpha:a.barborderalpha,barborderthickness:a.barborderthickness,color:a.plots[s].color,baralpha:a.plots[s].baralpha,legenditemalpha:a.plots[s].baralpha,legenditemcolor:a.plots[s].color,legenditembordercolor:a.barbordercolor,value:a.plots[s].value,dataValue:a.plots[s].dataValue,label:a.plots[s].label,iconurl:a.plots[s].iconurl,contexttext:a.plots[s].contextlabeltext,tooltext:a.plots[s].tooltext,plotHidden:a.plots[s].initiallyhidden,plotIndex:s})}}else if(r.data.length===i)for(var u=e.getChildren("plot"),d=0;d<i;d++)u[d].configure({startangle:a.startangle,endangle:a.endangle,barstartradius:a.barstartradius,barendradius:a.barendradius,barborder:a.barborder,barbordercolor:a.barbordercolor,barborderalpha:a.barborderalpha,barborderthickness:a.barborderthickness,color:a.plots[d].color,baralpha:a.plots[d].baralpha,legenditemalpha:a.plots[d].baralpha,legenditemcolor:a.plots[d].color,legenditembordercolor:a.barbordercolor,value:a.plots[d].value,dataValue:a.plots[d].dataValue,label:a.plots[d].label,iconurl:a.plots[d].iconurl,contexttext:a.plots[d].contextlabeltext,tooltext:a.plots[d].tooltext,plotHidden:a.plots[d].initiallyhidden,plotIndex:d});else{for(var g=e.getChildren("plot"),p=0;p<r.data.length;p++)g[p].configure({startangle:a.startangle,endangle:a.endangle,barstartradius:a.barstartradius,barendradius:a.barendradius,barborder:a.barborder,barbordercolor:a.barbordercolor,barborderalpha:a.barborderalpha,barborderthickness:a.barborderthickness,color:a.plots[p].color,baralpha:a.plots[p].baralpha,legenditemalpha:a.plots[p].baralpha,legenditemcolor:a.plots[p].color,legenditembordercolor:a.barbordercolor,value:a.plots[p].value,dataValue:a.plots[p].dataValue,label:a.plots[p].label,iconurl:a.plots[p].iconurl,contexttext:a.plots[p].contextlabeltext,tooltext:a.plots[p].tooltext,plotHidden:a.plots[p].initiallyhidden,plotIndex:p});for(var f=r.data.length;f<i;f++)g[f].remove()}else for(var m=e.getChildren("plot"),v=0;v<i;v++)m[v].remove()}function g(t){var e=t,a=t.config,o=e.getChildren(s["default"].getType()),i=o?o.length:0,r=t.getFromEnv("dataSource");if(Array.isArray(r.data))if(r.data.length>i){for(var n=e.getChildren("dataset"),l=0;l<i;l++)n[l].configure({startangle:a.startangle,endangle:a.endangle,trackpadding:a.trackpadding,trackmargin:a.trackmargin,trackstartradius:a.trackstartradius,trackendradius:a.trackendradius,trackfillcolor:a.tracks[l].trackfillcolor,trackalpha:a.tracks[l].trackalpha,trackborder:a.trackborder,trackbordercolor:a.trackbordercolor,trackborderalpha:a.trackborderalpha,trackborderthickness:a.trackborderthickness,numTicks:a.numticks,tickMarkLength:a.tickmarklength,tickvaluefontsizeWithUnit:a.tickvaluefontsizeWithUnit,showticks:a.showticks,showtickmarks:a.showtickmarks,showtickvalues:a.showtickvalues,tickmarkcolor:a.tickmarkcolor,tickmarkthickness:a.tickmarkthickness,tickalpha:a.tickalpha,tickvaluealpha:a.tickvaluealpha,tickvaluelabelfont:a.tickvaluelabelfont,tickvaluefontcolor:a.tickvaluefontcolor,baseFontColor:a.baseFontColor,tickvaluegap:8,label:a.tracks[l].label,iconurl:a.tracks[l].iconurl,labelFontColor:a.tracks[l].labelFontColor,value:a.tracks[l].value});for(var c=0;c<r.data.length-i;c++){var h=new s["default"];e.attachChild(h,"dataset").configure({startangle:a.startangle,endangle:a.endangle,trackpadding:a.trackpadding,trackmargin:a.trackmargin,trackstartradius:a.trackstartradius,trackendradius:a.trackendradius,trackfillcolor:a.tracks[c].trackfillcolor,trackalpha:a.tracks[c].trackalpha,trackborder:a.trackborder,trackbordercolor:a.trackbordercolor,trackborderalpha:a.trackborderalpha,trackborderthickness:a.trackborderthickness,numTicks:a.numticks,tickMarkLength:a.tickmarklength,tickvaluefontsizeWithUnit:a.tickvaluefontsizeWithUnit,showticks:a.showticks,showtickmarks:a.showtickmarks,showtickvalues:a.showtickvalues,tickmarkcolor:a.tickmarkcolor,tickmarkthickness:a.tickmarkthickness,tickalpha:a.tickalpha,tickvaluealpha:a.tickvaluealpha,tickvaluelabelfont:a.tickvaluelabelfont,tickvaluefontcolor:a.tickvaluefontcolor,baseFontColor:a.baseFontColor,tickvaluegap:8,label:a.tracks[c].label,iconurl:a.tracks[c].iconurl,labelFontColor:a.tracks[c].labelFontColor,value:a.tracks[c].value})}}else if(r.data.length===i)for(var u=e.getChildren("dataset"),d=0;d<i;d++)u[d].configure({startangle:a.startangle,endangle:a.endangle,trackpadding:a.trackpadding,trackmargin:a.trackmargin,trackstartradius:a.trackstartradius,trackendradius:a.trackendradius,trackfillcolor:a.tracks[d].trackfillcolor,trackalpha:a.tracks[d].trackalpha,trackborder:a.trackborder,trackbordercolor:a.trackbordercolor,trackborderalpha:a.trackborderalpha,trackborderthickness:a.trackborderthickness,numTicks:a.numticks,tickMarkLength:a.tickmarklength,tickvaluefontsizeWithUnit:a.tickvaluefontsizeWithUnit,showticks:a.showticks,showtickmarks:a.showtickmarks,showtickvalues:a.showtickvalues,tickmarkcolor:a.tickmarkcolor,tickmarkthickness:a.tickmarkthickness,tickalpha:a.tickalpha,tickvaluealpha:a.tickvaluealpha,tickvaluelabelfont:a.tickvaluelabelfont,tickvaluefontcolor:a.tickvaluefontcolor,baseFontColor:a.baseFontColor,tickvaluegap:8,label:a.tracks[d].label,iconurl:a.tracks[d].iconurl,labelFontColor:a.tracks[d].labelFontColor,value:a.tracks[d].value});else for(var g=e.getChildren("dataset"),p=r.data.length;p<i;p++)g[p].remove();else if(0===i){var f=new s["default"];e.attachChild(f,"dataset"),f.configure({startangle:a.startangle,endangle:a.endangle,trackpadding:a.trackpadding,trackmargin:a.trackmargin,trackstartradius:a.trackstartradius,trackendradius:a.trackendradius,trackfillcolor:a.tracks[0].trackfillcolor,trackalpha:a.tracks[0].trackalpha,trackborder:a.trackborder,trackbordercolor:a.trackbordercolor,trackborderalpha:a.trackborderalpha,trackborderthickness:a.trackborderthickness,numTicks:a.numticks,tickMarkLength:a.tickmarklength,tickvaluefontsizeWithUnit:a.tickvaluefontsizeWithUnit,showticks:a.showticks,showtickmarks:a.showtickmarks,showtickvalues:a.showtickvalues,tickmarkcolor:a.tickmarkcolor,tickmarkthickness:a.tickmarkthickness,tickalpha:a.tickalpha,tickvaluealpha:a.tickvaluealpha,tickvaluelabelfont:a.tickvaluelabelfont,tickvaluefontcolor:a.tickvaluefontcolor,baseFontColor:a.baseFontColor,tickvaluegap:8,label:a.tracks[0].label,iconurl:a.tracks[0].iconurl,labelFontColor:a.tracks[0].labelFontColor,value:a.tracks[0].value})}else for(var m=e.getChildren("dataset"),v=0;v<i-1;v++)0===v?o[v].configure({startangle:a.startangle,endangle:a.endangle,trackpadding:a.trackpadding,trackmargin:a.trackmargin,trackstartradius:a.trackstartradius,trackendradius:a.trackendradius,trackfillcolor:a.tracks[v].trackfillcolor,trackalpha:a.tracks[v].trackalpha,trackborder:a.trackborder,trackbordercolor:a.trackbordercolor,trackborderalpha:a.trackborderalpha,trackborderthickness:a.trackborderthickness,numTicks:a.numticks,tickMarkLength:a.tickmarklength,tickvaluefontsizeWithUnit:a.tickvaluefontsizeWithUnit,showticks:a.showticks,showtickmarks:a.showtickmarks,showtickvalues:a.showtickvalues,tickmarkcolor:a.tickmarkcolor,tickmarkthickness:a.tickmarkthickness,tickalpha:a.tickalpha,tickvaluealpha:a.tickvaluealpha,tickvaluelabelfont:a.tickvaluelabelfont,tickvaluefontcolor:a.tickvaluefontcolor,baseFontColor:a.baseFontColor,tickvaluegap:8,label:a.tracks[v].label,iconurl:a.tracks[v].iconurl,labelFontColor:a.tracks[v].labelFontColor,value:a.tracks[v].value}):m[v].remove()}var p=function(t){(0,i["default"])(a,t),a.getName=function(){return"RadialBar"};var e=a.prototype;function a(){var e;return(e=t.call(this)||this).deregisterFactory("canvas"),e.registerFactory("RadialTrack",g),e.registerFactory("RadialBarPlot",d,["legend"]),e.registerFactory("legend",n["default"]),e}return e.getName=function(){return"RadialBar"},a.getType=function(){return"chartAPI"},e.getType=function(){return"chartAPI"},e._checkInvalidData=function(){return!1},e._checkInvalidSpecificData=function(){return!this.getFromEnv("dataSource").data},e.__setDefaultConfig=function(){var t=this.config;t.innerradius=55,t.outerradius=77,t.startangle=90,t.endangle=180,t.trackpadding=0,t.trackmargin=6,t.trackstartradius="100%",t.trackendradius="100%",t.trackfillcolor="#cdcdcd",t.trackborder="none",t.trackbordercolor="#000000",t.trackborderalpha="100%",t.trackborderthickness=1,t.barstartradius="100%",t.barendradius="100%",t.barborder="none",t.barbordercolor="#000000",t.barborderalpha="100%",t.barborderthickness=1,t.plots=[{color:"#0000ff",baralpha:"100%",value:0}],t.tracks=[{trackfillcolor:"#cdcdcd",trackalpha:"40%"}],t.showticks=1,t.numticks="auto",t.showtickvalues=1,t.tickvaluelabelfont="Verdana,sans",t.tickvaluefontsize="10"+h.PXSTRING,t.tickvaluefontcolor="#000000",t.showtickmarks=1,t.tickmarkcolor="#000000",t.tickmarklength=5,t.tickmarkthickness=1,t.tickalpha="100%",t.showcontextlabel=0,t.defaultcontextlabel="",t.contextlabeltext="",t.contextlabelfont="Verdana,sans",t.contextlabelfontsize="10"+h.PXSTRING,t.contextlabelfontcolor="#000000",t.contextlabelalpha="100%",t.showlabels=0,t.usedataplotcolorforlabels=0,t.labeltext="$label, $datavalue",t.placevaluesinside=0,t.labelposition="start",t.labelpadding="6px 10px 6px 10px",t.showlabelicon=0,t.iconscale="100%",t.iconposition="end",t.interactivelegend=1,t.showtooltip=1,this.config.style={inCanvasStyle:{}},this.config.dataLabelStyle={}},e.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e);var a,o,i,r=this.config,n=e.chart,l=n.trackfillcolor;if(r.innerradius=(0,h.pluck)(n.innerradius,r.innerradius),r.outerradius=(0,h.pluck)(n.outerradius,r.outerradius),r.interactivelegend=parseInt((0,h.pluck)(n.interactivelegend,r.interactivelegend,1),10),r.showLegend=parseInt(n.showlegend,10),r.startangle=(0,h.pluckNumber)(n.startangle,r.startangle),r.endangle=(0,h.pluckNumber)(n.endangle,r.endangle),r.startangle=r.startangle>=0&&r.startangle<=360?r.startangle:90,r.endangle=r.endangle>=0&&r.endangle<=360?r.endangle:180,r.trackpadding=(0,h.pluck)(n.trackpadding,r.trackpadding),r.trackmargin=(0,h.pluck)(n.trackmargin,r.trackmargin),r.trackstartradius=(0,h.pluck)(n.trackstartradius,r.trackstartradius),r.trackendradius=(0,h.pluck)(n.trackendradius,r.trackendradius),r.trackfillcolor=(0,h.pluck)(n.trackfillcolor,r.trackfillcolor),r.trackborder=(0,h.pluck)(n.trackborder,r.trackborder),r.trackbordercolor=(0,h.pluck)(n.trackbordercolor,r.trackbordercolor),r.trackborderalpha=parseInt((0,h.pluck)(n.trackborderalpha,r.trackborderalpha),10)/100,r.trackborderthickness=(0,h.pluck)(n.trackborderthickness,r.trackborderthickness),r.barstartradius=(0,h.pluck)(n.barstartradius,r.barstartradius),r.barendradius=(0,h.pluck)(n.barendradius,r.barendradius),r.barborder=(0,h.pluck)(n.barborder,r.barborder),r.barbordercolor=(0,h.pluck)(n.barbordercolor,r.barbordercolor),r.barborderalpha=parseInt((0,h.pluck)(n.barborderalpha,r.barborderalpha),10)/100,r.barborderthickness=(0,h.pluck)(n.barborderthickness,r.barborderthickness),-1===r.style.inCancolor.indexOf("#")&&(r.style.inCancolor="#"+r.style.inCancolor),r.baseFontColor=(0,h.pluck)(n.baseFontColor,r.style.inCancolor),a=(0,h.pluck)(n.numticks,r.numticks),r.numticks=isNaN(a)?"auto":a,r.tickmarklength=parseInt((0,h.pluck)(n.tickmarklength,r.tickmarklength),10),r.showticks=(0,h.pluck)(n.showticks,r.showticks),r.showtickmarks=(0,h.pluck)(n.showtickmarks,r.showtickmarks,r.showticks),r.showtickvalues=(0,h.pluck)(n.showtickvalues,r.showtickvalues,r.showticks),r.tickmarkcolor=(0,h.pluck)(n.tickmarkcolor,r.tickmarkcolor),r.tickmarkthickness=parseInt((0,h.pluck)(n.tickmarkthickness,r.tickmarkthickness),10),r.tickalpha=parseInt((0,h.pluck)(n.tickalpha,r.tickalpha),10)/100,r.tickvaluealpha=parseInt((0,h.pluck)(n.tickvaluealpha,n.tickalpha,"100%"),10)/100,r.tickvaluelabelfont=(0,h.pluck)(n.tickvaluelabelfont,r.style.inCanfontFamily),r.tickvaluefontcolor=(0,h.pluck)(n.tickvaluefontcolor,r.baseFontColor),r.tickvaluefontsizeWithUnit=(0,h.pluckFontSizeMaintainUnit)(n.tickvaluefontsize,r.style.inCanfontSizeWithUnit),r.tickvaluefontsize=this.computeFontSize(r.tickvaluefontsizeWithUnit),r.palettecolors=(0,h.pluck)(n.palettecolors,r.palettecolors),r.palettecolors&&(r.paletteColorsArray=r.palettecolors.trim().split(","),r.paletteColorsArray=r.paletteColorsArray.filter((function(t){return t}))),r.showcontextlabel=parseInt((0,h.pluck)(n.showcontextlabel,r.showcontextlabel),10),r.defaultcontextlabel=(0,h.parseUnsafeString)((0,h.pluck)(n.defaultcontextlabel,r.defaultcontextlabel)),r.contextlabeltext=(0,h.pluck)(n.contextlabeltext,r.contextlabeltext),r.contextlabelfont=(0,h.pluck)(n.contextlabelfont,r.style.inCanfontFamily),r.contextlabelfontsizewithunit=(0,h.pluckFontSizeMaintainUnit)(n.contextlabelfontsize,r.style.inCanfontSizeWithUnit),r.contextlabelfontsize=this.computeFontSize(r.contextlabelfontsizewithunit),r.contextlabelfontcolor=(0,h.pluck)(n.contextlabelfontcolor,r.baseFontColor),r.contextlabelalpha=parseInt((0,h.pluck)(n.contextlabelalpha,r.contextlabelalpha),10)/100,r.contexttext=n.contextlabeltext,r.showlabels=(0,h.pluckNumber)(n.showlabels,r.showlabels)||0,r.usedataplotcolorforlabels=(0,h.pluckNumber)(n.usedataplotcolorforlabels,r.usedataplotcolorforlabels)||0,r.labeltext=(0,h.pluck)(n.labeltext,r.labeltext),r.placevaluesinside=parseInt((0,h.pluckNumber)(n.placevaluesinside,r.placevaluesinside)||0,10),r.labelposition=(0,h.pluck)(n.labelposition,r.labelposition),r.labelpadding="6px "+(r.placevaluesinside?"10px":"15px"),r.labelpadding=(o=(0,h.pluck)(n.labelpadding,r.labelpadding),(i=o.split(" ").map((function(t){return parseInt(t,10)}))).every((function(t){return isNaN(t)}))?{top:6,right:10,bottom:6,left:10}:(1===i.length?(i.push(i[0]),i.push(i[0]),i.push(i[0])):2===i.length?(i.push(i[0]),i.push(i[1])):3===i.length&&i.push(i[1]),i.map((function(t,e){return isNaN(t)?0===e?6:1===e?i[e-1]:i[e-2]:t})),{top:i[0],right:i[1],bottom:i[2],left:i[3]})),r.showlabelicon=(0,h.pluckNumber)(n.showlabelicon,r.showlabelicon)||0,r.iconscale=(0,h.pluck)(n.iconscale,r.iconscale),r.iconposition=(0,h.pluck)(n.iconposition,r.iconposition),Array.isArray(e.data))for(var s=0;s<e.data.length;s++)r.tracks[s]={},r.tracks[s].trackfillcolor=l&&e.data[s].trackfillcolor?(0,h.pluck)(r.trackfillcolor,e.data[s].trackfillcolor):(0,h.pluck)(e.data[s].trackfillcolor,r.trackfillcolor),r.tracks[s].trackalpha=parseInt((0,h.pluck)(e.data[s].trackalpha,"40%"),10)/100,r.tracks[s].value=(0,h.pluckNumber)(e.data[s].value,0),r.tracks[s].label=(0,h.pluck)(e.data[s].label,""),r.tracks[s].iconurl=(0,h.pluck)(e.data[s].icon,""),r.tracks[s].labelFontColor=(0,h.pluck)(e.data[s].color,"#0000ff"),r.plots[s]={},r.plots[s].color=(0,h.pluck)(e.data[s].color,r.paletteColorsArray?r.paletteColorsArray[s]:"#0000ff"),r.plots[s].baralpha=parseInt((0,h.pluck)(e.data[s].baralpha,"100"),10)/100,r.plots[s].value=(0,h.pluckNumber)(parseInt(e.data[s].value,10),0),r.plots[s].iconurl=(0,h.pluck)(e.data[s].icon,""),r.plots[s].label=(0,h.pluck)(e.data[s].label,""),r.plots[s].contextlabeltext=(0,h.pluck)(e.data[s].contextlabeltext,r.contextlabeltext),r.plots[s].tooltext=(0,h.pluck)(e.data[s].tooltext,n.plottooltext),r.plots[s].initiallyhidden=r.interactivelegend?(0,h.pluckNumber)(e.data[s].initiallyhidden,0):0,r.plots[s].dataValue=r.plots[s].value+"%";r.rings=Array.isArray(e.data)&&e.data.length||1,this.addToEnv("chartConfig",this.config),this.createBaseComponent()},e._manageLegendSpace=function(){l._manageLegendSpace.call(this)},e.legendInteractivity=function(t){if(t.getFromEnv("chart-attrib").interactivelegend){var e,a,o=this.getChildren("plot"),i=this.getChildren("dataset"),r=t.getId();t.hasState("highlight")&&t.removeLegendState("highlight");for(var n=0;n<o.length;n++)e=o[n],a=i[n],e.config.legendItemId===r&&(e.config.plotHidden?(e.setData({baralpha:e.config.realBarAlpha,barborderalpha:e.config.realBarBorderAlpha},!0),this.drawLabel(a,e),t.removeLegendState("hidden"),e.config.plotHidden=!1):(e.config.realBarAlpha=e.config.realBarAlpha||e.config.baralpha,e.config.realBarBorderAlpha=e.config.realBarBorderAlpha||e.config.barborderalpha,e.setData({baralpha:0,barborderalpha:0},!0),e.label&&this.removeGraphicalElement(e.label),e.iconImage&&this.removeGraphicalElement(e.iconImage),e.plotIdentifier&&this.removeGraphicalElement(e.plotIdentifier),e.labelDiv&&(this.getFromEnv("chart-container").removeChild(e.labelDiv),delete e.labelDiv),t.setLegendState("hidden",!0),e.config.plotHidden=!0),t.getFromEnv("chart-attrib").interactivelegend=0)}},e._spaceManager=function(){var t,e,a,o,i,r=this,n=this.config,l=this.getFromEnv("dataSource").data,s=h.UNDEF,c=0;this.config.showLegend&&this._manageLegendSpace(),n.tickvaluefontsize=this.computeFontSize(n.tickvaluefontsizeWithUnit),n.availableHeight=this.getFromEnv("chartConfig").availableHeight,n.availableWidth=this.getFromEnv("chartConfig").availableWidth,t=n.availableHeight>n.availableWidth?n.availableWidth:n.availableHeight,n.outerradius=(0,h.convertToPixels)(n.outerradius,t/2),n.outerradius=n.outerradius<0?77:n.outerradius,n.innerradius=(0,h.convertToPixels)(n.innerradius,t/2),n.innerradius=n.innerradius<0?55:n.innerradius,n.trackstartradius=(0,h.convertToPixels)(n.trackstartradius,t/2),n.trackstartradius=n.trackstartradius>100?100:n.trackstartradius,n.trackendradius=(0,h.convertToPixels)(n.trackendradius,t/2),n.trackendradius=n.trackendradius>100?100:n.trackendradius,n.barstartradius=(0,h.convertToPixels)(n.barstartradius,t/2),n.barstartradius=n.barstartradius>100?100:n.barstartradius,n.barendradius=(0,h.convertToPixels)(n.barendradius,t/2),n.barendradius=n.barendradius>100?100:n.barendradius,n.trackmargin=(0,h.convertToPixels)(n.trackmargin,t/2),n.innerradius>=n.outerradius&&(n.innerradius=55,n.outerradius=77),e=2*(n.outerradius+(n.showticks?n.tickmarklength:0)+(n.showtickvalues?8+n.tickvaluefontsize:0)),(e-=((i=this._manageChartMenuBar(e<n.availableHeight?n.availableHeight-e:n.availableHeight/2)).top||0)+(i.bottom||0))>t&&(n.outerradius=t/2-(n.showticks?n.tickmarklength:0)-(n.showtickvalues?n.tickvaluefontsize:0)),(a=(n.outerradius-n.innerradius-(n.rings-1)*n.trackmargin)/n.rings)<0&&(n.trackmargin=0,a=(n.outerradius-n.innerradius)/n.rings),n.trackpadding=(0,h.convertToPixels)(n.trackpadding,a/2),n.trackpadding>a/2&&(n.trackpadding=0),(o=a-2*n.trackpadding)<0&&(o=(n.outerradius-n.innerradius)/n.rings),this.getChildren("dataset")&&this.getChildren("dataset").forEach((function(e,o){s=h.UNDEF,!l||Array.isArray(l)&&0===l.length?s=t:(n.tracks[c].thickness||(n.tracks[c].thickness=a),s=2*(n.innerradius+(c+1)*a+c*n.trackmargin)),e.setNodePath(s,a,n),c+=1,c%=n.rings,o===r.getChildren("dataset").length-1&&(e.config.isLast=!0)})),c=0,this.getChildren("plot")&&this.getChildren("plot").forEach((function(e){s=h.UNDEF,!l||Array.isArray(l)&&0===l.length?s=t:(n.plots[c].thickness||(n.plots[c].thickness=a),s=2*(n.innerradius+(c+1)*a+c*n.trackmargin)-2*n.trackpadding),e.setNodePath(s,o,n),c+=1,c%=n.rings}))},e._postSpaceManagement=function(){this.allocateDimensionOfChartMenuBar(),this.config.showLegend&&this.getChildren("legend")&&this.getChildren("legend")[0].postSpaceManager()},e.draw=function(){t.prototype.draw.call(this);var e=this.getFromEnv("animationManager"),a=this.getChildContainer("node-container"),o=this.getChildContainer("ticks-container");this.addChildContainer("node-container",e.setAnimation({el:a||"group",component:this,label:"node-container",id:"node-container",attr:{name:"node-container"},container:this.getChildContainer("plotGroup")})),this.addChildContainer("ticks-container",e.setAnimation({el:o||"group",component:this,label:"ticks-container",id:"ticks-container",attr:{name:"ticks-container"},container:this.getChildContainer("node-container")}));for(var i=0;i<this.config.plots.length&&i<this.config.tracks.length;i++){var r=this.getChildren("plot")[i];this.addExtEventListener("fc-mouseover",r._mouseOverHandler,r),this.addExtEventListener("fc-mouseout",r._mouseOutHandler,r)}this.config.defaultcontextlabel||(this.config.defaultcontextlabel=""),this.drawContextLabel(this.config.defaultcontextlabel)},e.drawLabel=function(t,e){var a,o,i,r,n,l,s=this.getFromEnv("chartConfig"),c=this.getFromEnv("animationManager"),h=this.getFromEnv("toolTipController"),d=this.getFromEnv("smartLabel"),g=this.config,p=s.canvasLeft,f=s.canvasTop,m=p+s.canvasWidth/2,v=f+s.canvasHeight/2,b=(0,u.changeAngleBase)(t.config.startingAngle),k=(0,u.changeAngleBase)(t.config.endingAngle),C=b===k?k-.1:k,x=t.config.thickness-g.labelpadding.top-g.labelpadding.bottom,w=g.usedataplotcolorforlabels?e.config.color:g.style.inCancolor,T=g.labeltext,y=T.toLowerCase().indexOf("$plotidentifier")>-1,A=this.config.showlabelicon;if(e.config.labelFontSize=x=x<5?t.config.thickness:x,(i=x*parseInt(g.iconscale,10)/100)>=Math.abs(g.innerradius-g.outerradius)&&(i=x),i=i<0?x:i,e.label&&this.removeGraphicalElement(e.label),e.iconImage&&this.removeGraphicalElement(e.iconImage),e.plotIdentifier&&this.removeGraphicalElement(e.plotIdentifier),e.labelDiv&&(this.getFromEnv("chart-container").removeChild(e.labelDiv),delete e.labelDiv),g.placevaluesinside){var S,F,N;if(g.showlabels&&0!==T.length||(g.iconposition="start"),y&&(T=T.toLowerCase().replace("$plotidentifier",""),n=e.getParsedText("$plotIdentifier",!1,x)),T=e.getParsedText(T,!1,x)||t.config.label,g.showlabelicon&&t.config.iconurl)if("end"!==g.iconposition)"end"===g.labelposition?(l=t.config.innerRadius+(t.config.thickness-i)/2,N="R"+((S=(0,u.normaliseAngle)(C)-t.config.paddingAngle)-180)+", "+(F=(0,u.pointOnCircleFromCenter)(m,v,l,S)).x+", "+F.y):(l=t.config.outerRadius-(t.config.thickness-i)/2,N="R"+(S=(0,u.normaliseAngle)(b)+t.config.paddingAngle)+", "+(F=(0,u.pointOnCircleFromCenter)(m,v,l,S)).x+", "+F.y),e.iconImage=c.setAnimation({el:"image",attr:{src:t.config.iconurl,x:F.x,y:F.y,width:i,height:i,transform:N},container:{id:"node-container",isParent:!0},component:this,label:"image"}),this.addGraphicalElement("iconImage",e.iconImage,!0);if(g.showlabels&&y){var E=document.createElement("div");E.innerHTML=n;var L,D,M,R=E.firstChild.firstElementChild||E.firstChild,_=R&&R.attributes,I={},V=this.getFromEnv("legend"),O=g.showLegend&&V.getItem(e.config.legendItemId),P=O&&O.getGraphicalElement(),G=P&&P.legendItemSymbol,B="end"!==g.iconposition?t.config.iconAngle:0,H=G&&G.node.getBBox(),W=1;if(H||(H={width:x}),x&&H&&x<H.height&&(W=x/H.height),"end"===g.labelposition?(l=t.config.innerRadius+(t.config.thickness-x)/2,M=(0,u.normaliseAngle)(C)-t.config.paddingAngle-B,D=(0,u.pointOnCircleFromCenter)(m,v,l,M),M-=180):(l=t.config.outerRadius-(t.config.thickness-x)/2,M=(0,u.normaliseAngle)(b)+t.config.paddingAngle+B,D=(0,u.pointOnCircleFromCenter)(m,v,l,M)),"path"===R.tagName){for(var z=0;z<_.length;z++)"d"===_[z].name?L=_[z].nodeValue:I[_[z].name]=_[z].nodeValue;I.path=L}else I.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",I["stroke-width"]=.1,I.fill=e.config.realColor||e.config.color;I.transform="T"+D.x+", "+D.y+" R"+M+", "+D.x+", "+D.y+" S"+W,e.plotIdentifier=c.setAnimation({el:"path",attr:I,container:{id:"plot",isParent:!0},label:"plotIdentifier",component:this}),this.addGraphicalElement("plotIdentifier",e.plotIdentifier,!0)}if(g.showlabels&&T.length>0){var j=(0,u.findArc)(b,b===k?k-.1:k),U=2*Math.PI*t.config.innerRadius/360*j,X={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(X),r={text:(a=d.getSmartText(T,U-g.labelpadding.left-g.labelpadding.right-(g.showlabelicon?i+15:0)-(y?x:0),1.2*x,!1)).text,x:t.config.path_d[1],y:t.config.path_d[2],fill:w,"font-family":g.style.inCanfontFamily,"font-size":x,"text-anchor":"start",textpath:{path:t.config.labelPath[g.labelposition][g.iconposition]}},e.label=c.setAnimation({el:"text",attr:r,container:{id:"plot",isParent:!0},label:"label",component:this}),this.addGraphicalElement("trackLabel",e.label,!0)}if(g.showlabelicon&&t.config.iconurl&&"end"===g.iconposition){var K,Y,J,q=e.label.node.getNumberOfChars()-1;"start"===g.labelposition?(l=t.config.outerRadius-(t.config.thickness-i)/2,J="R"+(K=e.label.node.getRotationOfChar(q)+t.config.iconAngle)+", "+(Y=(0,u.pointOnCircleFromCenter)(m,v,l,K)).x+", "+Y.y):(l=t.config.innerRadius+(t.config.thickness-i)/2,J="R"+((K=e.label.node.getRotationOfChar(q)-180-t.config.iconAngle)-180)+", "+(Y=(0,u.pointOnCircleFromCenter)(m,v,l,K)).x+", "+Y.y),e.iconImage=c.setAnimation({el:"image",attr:{src:t.config.iconurl,x:Y.x,y:Y.y,width:i,height:i,transform:J},container:{id:"node-container",isParent:!0},component:this,label:"image"}),this.addGraphicalElement("iconImage",e.iconImage,!0)}}else if(b!==k){var Z,$={},Q={},tt={},et=0;if("end"===g.labelposition){if(C>=0&&C<180||360===C)if("end"===g.iconposition){if(et+=g.labelpadding.left,y&&g.showlabels){var at=document.createElement("div");at.innerHTML=e.getParsedText("$plotIdentifier");var ot,it,rt=at.firstChild.firstElementChild||at.firstChild,nt=rt&&rt.attributes,lt=this.getFromEnv("legend"),st=g.showLegend&&lt.getItem(e.config.legendItemId),ct=st&&st.getGraphicalElement(),ht=ct&&ct.legendItemSymbol,ut=ht&&ht.node.getBBox(),dt=1;if(et+=x/2,Z=Math.sqrt(Math.pow(t.config.outerRadius-t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),it=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)+o),ut||(ut={width:x}),x&&ut&&x<ut.height&&(dt=x/ut.height),"path"===rt.tagName){for(var gt=0;gt<nt.length;gt++)"d"===nt[gt].name?ot=nt[gt].nodeValue:tt[nt[gt].name]=nt[gt].nodeValue;tt.path=ot}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(it.x-ut.width*dt/2)+", "+(it.y-ut.height*dt/2)+" R"+(C-90)+", "+it.x+", "+it.y+" S"+dt,this.addPlotIdentifier(tt,e),et=et+x+1}if(g.showlabels){l=t.config.outerRadius-(t.config.thickness-x)/2-x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var pt=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)+o),ft={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(ft),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=pt.x,Q.y=pt.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="start",Q.transform="R"+(C-90)+", "+Q.x+", "+Q.y,Q.text=a.text,et+=this.addLabel(Q,e)}A&&t.config.iconurl&&(et+=10,Z=Math.sqrt(Math.pow(t.config.outerRadius+(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)+o),$.transform="R"+(C-90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t))}else{if(et+=g.labelpadding.left,A&&(t.config.iconurl&&(Z=Math.sqrt(Math.pow(t.config.outerRadius+(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)+o),$.transform="R"+(C-90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t)),et=et+x+10),y&&g.showlabels){et+=x/2;var mt=document.createElement("div");mt.innerHTML=e.getParsedText("$plotIdentifier");var vt,bt,kt=mt.firstChild.firstElementChild||mt.firstChild,Ct=kt&&kt.attributes,xt=this.getFromEnv("legend"),wt=g.showLegend&&xt.getItem(e.config.legendItemId),Tt=wt&&wt.getGraphicalElement(),yt=Tt&&Tt.legendItemSymbol,At=yt&&yt.node.getBBox(),St=1;if(Z=Math.sqrt(Math.pow(t.config.outerRadius-t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),bt=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)+o),At||(At={width:x}),x&&At&&x<At.height&&(St=x/At.height),"path"===kt.tagName){for(var Ft=0;Ft<Ct.length;Ft++)"d"===Ct[Ft].name?vt=Ct[Ft].nodeValue:tt[Ct[Ft].name]=Ct[Ft].nodeValue;tt.path=vt}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(bt.x-At.width*St/2)+", "+(bt.y-At.height*St/2)+" R"+(C-90)+", "+bt.x+", "+bt.y+" S"+St,this.addPlotIdentifier(tt,e),et+=x}if(g.showlabels){l=t.config.outerRadius-(t.config.thickness-x)/2-x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/l)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var Nt=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)+o),Et={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(Et),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=Nt.x,Q.y=Nt.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="start",Q.transform="R"+(C-90)+", "+Q.x+", "+Q.y,Q.text=a.text,this.addLabel(Q,e)}}else if(C>=180&&C<360)if("end"===g.iconposition){if(et-=g.labelpadding.right,A&&(et-=x,t.config.iconurl&&(Z=Math.sqrt(Math.pow(t.config.innerRadius-(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)-o),$.transform="R"+(C+90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t)),et-=10),g.showlabels){l=t.config.innerRadius+(t.config.thickness-x)/2+x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/l)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var Lt=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)-o),Dt={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(Dt),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=Lt.x,Q.y=Lt.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="end",Q.transform="R"+(C+90)+", "+Q.x+", "+Q.y,Q.text=a.text,et=et-this.addLabel(Q,e)-x}if(y&&g.showlabels){var Mt=document.createElement("div");Mt.innerHTML=e.getParsedText("$plotIdentifier");var Rt,_t,It=Mt.firstChild.firstElementChild||Mt.firstChild,Vt=It&&It.attributes,Ot=this.getFromEnv("legend"),Pt=g.showLegend&&Ot.getItem(e.config.legendItemId),Gt=Pt&&Pt.getGraphicalElement(),Bt=Gt&&Gt.legendItemSymbol,Ht=Bt&&Bt.node.getBBox(),Wt=1;if(Z=Math.sqrt(Math.pow(t.config.innerRadius+t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),_t=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)-o),Ht||(Ht={width:x}),x&&Ht&&x<Ht.height&&(Wt=x/Ht.height),"path"===It.tagName){for(var zt=0;zt<Vt.length;zt++)"d"===Vt[zt].name?Rt=Vt[zt].nodeValue:tt[Vt[zt].name]=Vt[zt].nodeValue;tt.path=Rt}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(_t.x-Ht.width*Wt/2)+", "+(_t.y-Ht.height*Wt/2)+" R"+(C+90)+", "+_t.x+", "+_t.y+" S"+Wt,this.addPlotIdentifier(tt,e)}}else{if(et-=g.labelpadding.right,g.showlabels){l=t.config.innerRadius+(t.config.thickness-x)/2+x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/l)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var jt=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)-o),Ut={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(Ut),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=jt.x,Q.y=jt.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="end",Q.transform="R"+(C+90)+", "+Q.x+", "+Q.y,Q.text=a.text,et=et-this.addLabel(Q,e)-x}if(y&&g.showlabels){var Xt=document.createElement("div");Xt.innerHTML=e.getParsedText("$plotIdentifier");var Kt,Yt,Jt=Xt.firstChild.firstElementChild||Xt.firstChild,qt=Jt&&Jt.attributes,Zt=this.getFromEnv("legend"),$t=g.showLegend&&Zt.getItem(e.config.legendItemId),Qt=$t&&$t.getGraphicalElement(),te=Qt&&Qt.legendItemSymbol,ee=te&&te.node.getBBox(),ae=1;if(Z=Math.sqrt(Math.pow(t.config.innerRadius+t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),Yt=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)-o),ee||(ee={width:x}),x&&ee&&x<ee.height&&(ae=x/ee.height),"path"===Jt.tagName){for(var oe=0;oe<qt.length;oe++)"d"===qt[oe].name?Kt=qt[oe].nodeValue:tt[qt[oe].name]=qt[oe].nodeValue;tt.path=Kt}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(Yt.x-ee.width*ae/2)+", "+(Yt.y-ee.height*ae/2)+" R"+(C+90)+", "+Yt.x+", "+Yt.y+" S"+ae,this.addPlotIdentifier(tt,e),et-=x}A&&t.config.iconurl&&(et-=10,Z=Math.sqrt(Math.pow(t.config.innerRadius-(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(C)-o),$.transform="R"+(C+90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t))}}else if(b>=0&&b<180||360===b)if("end"===g.iconposition){if(et+=g.labelpadding.right,A&&(et+=x,t.config.iconurl&&(Z=Math.sqrt(Math.pow(t.config.outerRadius-(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)-o),$.transform="R"+(b-90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t)),et+=10),y&&g.showlabels){var ie=document.createElement("div");ie.innerHTML=e.getParsedText("$plotIdentifier");var re,ne,le=ie.firstChild.firstElementChild||ie.firstChild,se=le&&le.attributes,ce=this.getFromEnv("legend"),he=g.showLegend&&ce.getItem(e.config.legendItemId),ue=he&&he.getGraphicalElement(),de=ue&&ue.legendItemSymbol,ge=de&&de.node.getBBox(),pe=1;if(Z=Math.sqrt(Math.pow(t.config.outerRadius-t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),ne=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)-o),ge||(ge={width:x}),x&&ge&&x<ge.height&&(pe=x/ge.height),"path"===le.tagName){for(var fe=0;fe<se.length;fe++)"d"===se[fe].name?re=se[fe].nodeValue:tt[se[fe].name]=se[fe].nodeValue;tt.path=re}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(ne.x-ge.width*pe/2)+", "+(ne.y-ge.height*pe/2)+" R"+(b-90)+", "+ne.x+", "+ne.y+" S"+pe,this.addPlotIdentifier(tt,e),et+=x}if(g.showlabels){l=t.config.outerRadius-(t.config.thickness-x)/2-x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/l)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var me=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)-o),ve={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(ve),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=me.x,Q.y=me.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="end",Q.transform="R"+(b-90)+", "+Q.x+", "+Q.y,Q.text=a.text,this.addLabel(Q,e)}}else{if(g.showlabels){et+=g.labelpadding.right,l=t.config.outerRadius-(t.config.thickness-x)/2-x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/l)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var be=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)-o),ke={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(ke),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=be.x,Q.y=be.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="end",Q.transform="R"+(b-90)+", "+Q.x+", "+Q.y,Q.text=a.text,et+=this.addLabel(Q,e)}if(y&&g.showlabels){et+=x;var Ce=document.createElement("div");Ce.innerHTML=e.getParsedText("$plotIdentifier");var xe,we,Te=Ce.firstChild.firstElementChild||Ce.firstChild,ye=Te&&Te.attributes,Ae=this.getFromEnv("legend"),Se=g.showLegend&&Ae.getItem(e.config.legendItemId),Fe=Se&&Se.getGraphicalElement(),Ne=Fe&&Fe.legendItemSymbol,Ee=Ne&&Ne.node.getBBox(),Le=1;if(Z=Math.sqrt(Math.pow(t.config.outerRadius-t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),we=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)-o),Ee||(Ee={width:x}),x&&Ee&&x<Ee.height&&(Le=x/Ee.height),"path"===Te.tagName){for(var De=0;De<ye.length;De++)"d"===ye[De].name?xe=ye[De].nodeValue:tt[ye[De].name]=ye[De].nodeValue;tt.path=xe}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(we.x-Ee.width*Le/2)+", "+(we.y-Ee.height*Le/2)+" R"+(b-90)+", "+we.x+", "+we.y+" S"+Le,this.addPlotIdentifier(tt,e),et+=x}A&&t.config.iconurl&&(et=et+x+10,Z=Math.sqrt(Math.pow(t.config.outerRadius-(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.outerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)-o),$.transform="R"+(b-90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t))}else if(b>=180&&b<360)if("end"===g.iconposition){if(et-=g.labelpadding.left,y&&g.showlabels){var Me=document.createElement("div");Me.innerHTML=e.getParsedText("$plotIdentifier");var Re,_e,Ie=Me.firstChild.firstElementChild||Me.firstChild,Ve=Ie&&Ie.attributes,Oe=this.getFromEnv("legend"),Pe=g.showLegend&&Oe.getItem(e.config.legendItemId),Ge=Pe&&Pe.getGraphicalElement(),Be=Ge&&Ge.legendItemSymbol,He=Be&&Be.node.getBBox(),We=1;if(Z=Math.sqrt(Math.pow(t.config.innerRadius+t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),_e=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)+o),He||(He={width:x}),x&&He&&x<He.height&&(We=x/He.height),"path"===Ie.tagName){for(var ze=0;ze<Ve.length;ze++)"d"===Ve[ze].name?Re=Ve[ze].nodeValue:tt[Ve[ze].name]=Ve[ze].nodeValue;tt.path=Re}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(_e.x-He.width*We/2)+", "+(_e.y-He.height*We/2)+" R"+(b+90)+", "+_e.x+", "+_e.y+" S"+We,this.addPlotIdentifier(tt,e),et-=x}if(g.showlabels){l=t.config.innerRadius+(t.config.thickness-x)/2+x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var je=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)+o),Ue={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(Ue),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=je.x,Q.y=je.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="start",Q.transform="R"+(b+90)+", "+Q.x+", "+Q.y,Q.text=a.text,et-=this.addLabel(Q,e)}A&&t.config.iconurl&&(et-=10,Z=Math.sqrt(Math.pow(t.config.innerRadius+(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)+o),$.transform="R"+(b+90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t))}else{if(et-=g.labelpadding.left,A&&(t.config.iconurl&&(Z=Math.sqrt(Math.pow(t.config.innerRadius+(t.config.thickness-x)/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),$.iconCoords=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)+o),$.transform="R"+(b+90)+", "+$.iconCoords.x+", "+$.iconCoords.y,$.iconSize=x,this.addIcon($,e,t)),et=et-x-10),y&&g.showlabels){var Xe=document.createElement("div");Xe.innerHTML=e.getParsedText("$plotIdentifier");var Ke,Ye,Je=Xe.firstChild.firstElementChild||Xe.firstChild,qe=Je&&Je.attributes,Ze=this.getFromEnv("legend"),$e=g.showLegend&&Ze.getItem(e.config.legendItemId),Qe=$e&&$e.getGraphicalElement(),ta=Qe&&Qe.legendItemSymbol,ea=ta&&ta.node.getBBox(),aa=1;if(Z=Math.sqrt(Math.pow(t.config.innerRadius+t.config.thickness/2,2)+Math.pow(et,2)),o=Math.atan(et/t.config.innerRadius)*(180/Math.PI),Ye=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)+o),ea||(ea={width:x}),x&&ea&&x<ea.height&&(aa=x/ea.height),"path"===Je.tagName){for(var oa=0;oa<qe.length;oa++)"d"===qe[oa].name?Ke=qe[oa].nodeValue:tt[qe[oa].name]=qe[oa].nodeValue;tt.path=Ke}else tt.path="M0,0L"+x+",0,"+x+","+x+",0,"+x+"Z",tt["stroke-width"]=.1,tt.fill=e.config.realColor||e.config.color;tt.transform="T"+(Ye.x-ea.width*aa/2)+", "+(Ye.y-ea.height*aa/2)+" R"+(b+90)+", "+Ye.x+", "+Ye.y+" S"+aa,this.addPlotIdentifier(tt,e),et=et-x-1}if(g.showlabels){l=t.config.innerRadius+(t.config.thickness-x)/2+x/2,Z=Math.sqrt(Math.pow(l,2)+Math.pow(et,2)),o=Math.atan(et/l)*(180/Math.PI),T=e.getParsedText(T.replace("$plotIdentifier","").replace("$plotidentifier",""));var ia=(0,u.pointOnCircleFromCenter)(m,v,Z,(0,u.normaliseAngle)(b)+o),ra={"font-family":g.style.inCanfontFamily,"font-size":x,"line-height":1.2*x};d.setStyle(ra),a=d.getSmartText(T,g.outerradius,1.2*x,!1),Q.x=ia.x,Q.y=ia.y,Q.fill=w,Q["font-family"]=g.style.inCanfontFamily,Q["font-size"]=x,Q["text-anchor"]="start",Q.transform="R"+(b+90)+", "+Q.x+", "+Q.y,Q.text=a.text,this.addLabel(Q,e)}}}a&&(g.showToolTip&&a.oriText!==a.text?h.enableToolTip(e.label,a.oriText):h.disableToolTip(e.label))},e.addIcon=function(t,e,a){var o=this.getFromEnv("animationManager");e.iconImage=o.setAnimation({el:"image",attr:{src:a.config.iconurl,x:t.iconCoords.x,y:t.iconCoords.y,width:t.iconSize,height:t.iconSize,transform:t.transform},container:{id:"node-container",isParent:!0},component:this,label:"image"}),this.addGraphicalElement("iconImage",e.iconImage,!0)},e.addPlotIdentifier=function(t,e){var a=this.getFromEnv("animationManager");e.plotIdentifier=a.setAnimation({el:"path",attr:t,container:{id:"plot",isParent:!0},label:"plotIdentifier",component:this}),this.addGraphicalElement("plotIdentifier",e.plotIdentifier,!0)},e.addLabel=function(t,e){var a=this.getFromEnv("animationManager");return e.label=a.setAnimation({el:"text",attr:t,container:{id:"plot",isParent:!0},label:"label",component:this}),this.addGraphicalElement("trackLabel",e.label,!0),e.label.node.getBBox().width},e.drawContextLabel=function(t,e){if(this.config.showcontextlabel){var a,o,i,r=this.getFromEnv("chartConfig"),n=this.getFromEnv("smartLabel"),l=this.getFromEnv("animationManager"),s=this.config,c=r.canvasLeft,u=r.canvasTop,d=c+r.canvasWidth/2,g=u+r.canvasHeight/2,p=2*s.innerradius,f=this.computeFontSize(s.contextlabelfontsizewithunit),m=Math.sqrt(2)*s.innerradius;if(s.contextlabelObject&&this.removeGraphicalElement(s.contextlabelObject),e)s.div||(s.div=document.createElement("div"),s.span=document.createElement("span"),s.div.setAttribute("style",""),s.span.setAttribute("style","")),a=s.div.style,o=s.span.style,a.color=s.contextlabelfontcolor,a.fontSize=f+h.PXSTRING,a.overflow="hidden",a["text-overflow"]="ellipsis",a["word-break"]="break-all",a["text-align"]="center",a["font-family"]=s.contextlabelfont,a.opacity=s.contextlabelalpha,a.top=g-m/2+h.PXSTRING,a.left=d-m/2+h.PXSTRING,a.visibility="visible",a.position="absolute",a.width=m+h.PXSTRING,a.height=m+h.PXSTRING,o["margin-top"]="auto",o["margin-bottom"]="auto",o.display="flex",o["flex-direction"]="row",o["justify-content"]="center",o["flex-wrap"]="wrap",o["align-items"]="flex-start",s.div.id="contextlabeldiv",s.span.innerHTML=t,s.div.appendChild(s.span),this.getFromEnv("chart-container").appendChild(s.div);else{this.getFromEnv("chart-container").querySelector("#contextlabeldiv")&&this.getFromEnv("chart-container").removeChild(s.div);var v={"font-family":s.style.inCanfontFamily,"font-size":f,"line-height":1.2*f};n.setStyle(v),i={text:n.getSmartText(t,p-10,p-10,!1).text,x:d,y:g,fill:s.contextlabelfontcolor,"font-family":s.contextlabelfont,"font-size":f+h.PXSTRING,"fill-opacity":s.contextlabelalpha},s.contextlabelObject=l.setAnimation({el:"text",attr:i,container:{id:"plot",isParent:!0},label:"label",component:this}),this.addGraphicalElement("contentLabel",s.contextlabelObject,!0)}}},a}(r["default"]);e["default"]=p},1180:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(223)),r=o(a(238)),n=a(240),l=a(1062),s=a(224),c=o(a(278)),h=a(232);function u(t,e){var a=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),a.push.apply(a,o)}return a}function d(t){for(var e=1;e<arguments.length;e++){var a=null!=arguments[e]?arguments[e]:{};e%2?u(Object(a),!0).forEach((function(e){(0,i["default"])(t,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(a)):u(Object(a)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(a,e))}))}return t}var g="A";function p(t,e,a,o,i,r,n){var c=(0,l.normaliseAngle)(t),h=(0,l.normaliseAngle)(e),u=(0,l.pointOnCircleFromCenter)(i,r,o,c),d=u.x,g=u.y,p=(0,l.pointOnCircleFromCenter)(i,r,o,h),f=p.x,m=p.y;return"M "+(d=(0,s.toPrecision)(d,4))+" "+(g=(0,s.toPrecision)(g,4))+" A "+o+" "+o+" 0 "+(a<=180?0:1)+" "+(n?1:0)+" "+(f=(0,s.toPrecision)(f,4))+" "+(m=(0,s.toPrecision)(m,4))+" Z"}var f=function(t){function e(){return t.apply(this,arguments)||this}(0,r["default"])(e,t);var a=e.prototype;return a.getName=function(){return"RadialTrack"},a.getType=function(){return"dataset"},e.getName=function(){return"RadialTrack"},e.getType=function(){return"dataset"},a.__setDefaultConfig=function(){this.config.startangle=90,this.config.endangle=180,this.config.trackpadding=0,this.config.trackmargin=6,this.config.trackstartradius="100%",this.config.trackendradius="100%",this.config.trackfillcolor="#0000ff",this.config.trackalpha=.4,this.config.trackborder="none",this.config.trackbordercolor="#000000",this.config.trackborderalpha=1,this.config.trackborderthickness=1,this.config.value=0},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),this.config=d(d({},this.config),e),this.getFromEnv("chartConfig")||this.addToEnv("chartConfig",this.config),this.createBaseComponent(),e.thickness&&(this.config.thickness=e.thickness),(e.startangle||0===e.startangle)&&(this.config.startingAngle=e.startangle),(e.endangle||0===e.endangle)&&(this.config.endingAngle=e.endangle),"none"===this.config.trackborder&&(this.config.trackborderalpha=0,this.config.trackborderthickness=0)},a.createBaseComponent=function(){var t=this.getFromEnv("animationManager");t||(t=new c["default"],this.addToEnv("animationManager",t),t.addToEnv("chart",this)),t.configure(),t._setAnimDuration()},a.addPaperToEnv=function(){var t=this.getFromEnv("chart-container"),e=new((0,h.getDep)("redraphael","plugin"))(t,this.getFromEnv("chartWidth"),this.getFromEnv("chartHeight"));e.setHTMLClassName("fusioncharts-div"),this.getFromEnv("animationManager").addToEnv("paper",e)},a.setNodePath=function(t,e,a){this.config.thickness=e,this.config.outerRadius=t/2,this.config.innerRadius=this.config.outerRadius-this.config.thickness,this.config.trackstartradius=a.trackstartradius,this.config.trackendradius=a.trackendradius,this.manageSpace()},a.manageSpace=function(){var t,e=this.getFromEnv("chartConfig"),a=this.config,o=this.getLinkedParent(),i=e.canvasLeft,r=e.canvasTop,n=i+e.canvasWidth/2,c=r+e.canvasHeight/2,h=(0,l.changeAngleBase)(a.startingAngle),u=(0,l.changeAngleBase)(a.endingAngle),d=h===u?u-.1:u,f=(0,l.findArc)(h,d),m=parseInt(a.trackstartradius,10)/100*(a.thickness/2),v=parseInt(a.trackendradius,10)/100*(a.thickness/2),b=a.thickness-o.config.labelpadding.top-o.config.labelpadding.bottom,k=parseInt(f/(o.config.tickvaluefontsize/(2*Math.PI*o.config.outerradius)*360)/2,10);b=t=b<5?a.thickness:b,(t=t*parseInt(o.config.iconscale,10)/100)>=Math.abs(a.outerRadius-a.innerRadius)&&(t=Math.abs(a.outerRadius-a.innerRadius)),t=t<0?Math.abs(a.outerRadius-a.innerRadius):t,a.numTicks=parseInt(a.numTicks,10),isNaN(a.numTicks)?a.numTicks=k>10?10:k:a.numTicks=a.numTicks>k?k:a.numTicks,t="end"===o.config.iconposition?t/2+10:t+10,a.iconAngle=t/(2*Math.PI*(a.outerRadius-a.thickness/2))*360,a.iconAngle=o.config.showlabelicon?a.iconAngle:0,a.plotIdentifierAngle=o.config.labeltext.toLowerCase().indexOf("$plotidentifier")>-1?(b+1)/(2*Math.PI*(a.outerRadius-a.thickness))*360:0,a.paddingAngle=o.config.labelpadding.left/(2*Math.PI*(a.outerRadius-a.thickness/2))*360,a.labelPath={start:{start:p(h+a.paddingAngle+a.iconAngle+a.plotIdentifierAngle,d,f,a.outerRadius-a.thickness/2,n,c,a.thickness),end:p(h+a.paddingAngle+a.plotIdentifierAngle,d,f,a.outerRadius-a.thickness/2,n,c,!0)},end:{start:p(d-a.paddingAngle-a.iconAngle-a.plotIdentifierAngle,h,f,a.outerRadius-a.thickness/2,n,c,!1),end:p(d-a.paddingAngle-a.plotIdentifierAngle,h,f,a.outerRadius-a.thickness/2,n,c,!1)}},a.arcLength=f/360*(2*Math.PI*(a.outerRadius-a.thickness/2)),a.path_d=function(t,e,a,o,i,r,n,c,h,u,d){h>0&&360!==a&&(t+=(0,l.radiansInAngle)(h,i+h)),u>0&&360!==a&&(e-=(0,l.radiansInAngle)(u,i+u));var p=(0,l.normaliseAngle)(t),f=(0,l.normaliseAngle)(e),m=(0,l.pointOnCircleFromCenter)(r,n,o,p),v=m.x,b=m.y,k=(0,l.pointOnCircleFromCenter)(r,n,o,f),C=k.x,x=k.y,w=(0,l.pointOnCircleFromCenter)(r,n,i,p),T=w.x,y=w.y,A=(0,l.pointOnCircleFromCenter)(r,n,i,f),S=A.x,F=A.y;return v=(0,s.toPrecision)(v,4),b=(0,s.toPrecision)(b,4),C=(0,s.toPrecision)(C,4),x=(0,s.toPrecision)(x,4),T=(0,s.toPrecision)(T,4),y=(0,s.toPrecision)(y,4),S=(0,s.toPrecision)(S,4),F=(0,s.toPrecision)(F,4),["M",v,b,g,o,o,0,a<=180?0:1,d?1:0,C,x,u>0&&360!==a?"A, "+c/2+", "+u+", 0, 1, 1, "+S+", "+F:"L, "+S+", "+F,g,i,i,0,a<=180?0:1,d?0:1,T,y,h>0&&360!==a?"A, "+h+", "+c/2+", 0, 1, 1, "+v+", "+b:"","Z"]}(h,d,f,a.outerRadius,a.innerRadius,n,c,a.thickness,m,v,!0)},a.allocatePosition=function(){return!1},a.checkInvalidData=function(){return!1},a.checkInvalidSpecificData=function(){return!1},a.draw=function(){this.addGraphicalElement({el:"path",attr:{path:this.config.path_d,fill:this.config.trackfillcolor,stroke:this.config.trackbordercolor,"stroke-width":this.config.trackborderthickness,"stroke-opacity":this.config.trackborderalpha,"stroke-dasharray":"dashed"===this.config.trackborder?5:s.UNDEF,"fill-opacity":this.config.trackalpha},container:{id:"node-container",isParent:!0},label:"track",component:this}),this.config.isLast&&this.drawTicks()},a.drawTicks=function(){var t,e,a,o,i,r=this,n=this.getFromEnv("chartConfig"),s=n.canvasLeft,c=n.canvasTop,h=s+n.canvasWidth/2,u=c+n.canvasHeight/2,d=(0,l.changeAngleBase)(this.config.startingAngle),g=(0,l.changeAngleBase)(this.config.endingAngle),p=(0,l.findArc)(d,d===g?g-.1:g)/this.config.numTicks,f=100/this.config.numTicks,m=[];d===g&&(this.config.numTicks-=1);for(var v=0;v<=this.config.numTicks;v++)a=(0,l.normaliseAngle)(d)+v*p,i=this.config.outerRadius+this.config.tickMarkLength+this.config.tickvaluegap,o=(0,l.pointOnCircleFromCenter)(h,u,i,a),this.config.showtickvalues&&m.push(o),e=(0,l.pointOnCircleFromCenter)(h,u,this.config.outerRadius+this.config.tickMarkLength,a),t=(0,l.pointOnCircleFromCenter)(h,u,this.config.outerRadius,a),this.config.showtickmarks&&this.config.showticks&&this.addGraphicalElement({el:"path",attr:{path:"M "+t.x+" "+t.y+" L "+e.x+" "+e.y+" Z",stroke:this.config.tickmarkcolor,"stroke-width":this.config.tickmarkthickness/2,"stroke-opacity":this.config.tickalpha},container:{id:"ticks-container",isParent:!0},label:"tick",component:this});this.config.showtickvalues&&this.config.showticks&&m.forEach((function(t,e){a=(a=(0,l.changeAngleBase)((0,l.normaliseAngle)(d)+e*p))<0?360+a:a,a%=360,r.addGraphicalElement({el:"text",attr:{text:Math.round(e*f)+"%",x:t.x,y:t.y,fill:r.config.tickvaluefontcolor,"font-family":r.config.tickvaluelabelfont,"font-size":r.computeFontSize(r.config.tickvaluefontsizeWithUnit),opacity:r.config.tickvaluealpha,"text-anchor":a>180?"end":"start"},container:{id:"ticks-container",isParent:!0},label:"label",component:r})}))},e}(n.SmartRenderer);e["default"]=f},1181:function(t,e,a){"use strict";var o=a(219);e.__esModule=!0,e["default"]=void 0;var i=o(a(223)),r=o(a(238)),n=a(240),l=a(224),s=o(a(278)),c=a(232),h=a(1062);function u(t,e){var a=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),a.push.apply(a,o)}return a}function d(t){for(var e=1;e<arguments.length;e++){var a=null!=arguments[e]?arguments[e]:{};e%2?u(Object(a),!0).forEach((function(e){(0,i["default"])(t,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(a)):u(Object(a)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(a,e))}))}return t}var g="A";var p=function(t){function e(){return t.apply(this,arguments)||this}(0,r["default"])(e,t);var a=e.prototype;return a.getName=function(){return"RadialBarPlot"},a.getType=function(){return"plot"},e.getName=function(){return"RadialBarPlot"},e.getType=function(){return"plot"},a._mouseOverHandler=function(t){var e=this.getFromEnv("toolTipController"),a=this.getLinkedParent();a.config.showcontextlabel&&a.drawContextLabel(this.getParsedText(this.config.contexttext,!0),!0),a.config.showtooltip&&!this.config.currentToolTip&&(this.config.currentToolTip=e.draw(t.originalEvent,this.getParsedText(this.config.tooltext,!0))),this.config.realBarAlpha=this.config.realBarAlpha||this.config.baralpha,this.config.realBarBorderAlpha=this.config.realBarBorderAlpha||this.config.barborderalpha,this.setData({baralpha:.25*this.config.realBarAlpha,barborderalpha:.25*this.config.realBarBorderAlpha},!0)},a._mouseOutHandler=function(t){var e=this.getFromEnv("toolTipController"),a=this.getLinkedParent();this.config.currentToolTip&&(e.hide(this.config.currentToolTip),this.config.currentToolTip=l.UNDEF),this.setData({baralpha:this.config.realBarAlpha,barborderalpha:this.config.realBarBorderAlpha},!0),a.config.showcontextlabel&&a.drawContextLabel(a.config.defaultcontextlabel)},a.__setDefaultConfig=function(){this.config.startangle=90,this.config.endangle=180,this.config.barstartradius="100%",this.config.barendradius="100%",this.config.barborder="none",this.config.barbordercolor="#000000",this.config.barborderalpha=1,this.config.barborderthickness=1,this.config.color="#0000ff",this.config.baralpha=1,this.config.value=0},a.configureAttributes=function(e){t.prototype.configureAttributes.call(this,e),this.config=d(d({},this.config),e),this.getFromEnv("chartConfig")||this.addToEnv("chartConfig",this.config),this.createBaseComponent(),e.thickness&&(this.config.thickness=e.thickness),(e.startangle||0===e.startangle)&&(this.config.startingAngle=e.startangle),(e.endangle||0===e.endangle)&&(this.config.endingAngle=e.endangle),"none"===this.config.barborder&&(this.config.barborderalpha=0,this.config.barborderthickness=0),this.getLinkedParent().config.showLegend&&this._addLegend()},a.createBaseComponent=function(){var t=this.getFromEnv("animationManager");t||(t=new s["default"],this.addToEnv("animationManager",t),t.addToEnv("chart",this)),t.configure(),t._setAnimDuration()},a.addPaperToEnv=function(){var t=this.getFromEnv("chart-container"),e=new((0,c.getDep)("redraphael","plugin"))(t,this.getFromEnv("chartWidth"),this.getFromEnv("chartHeight"));e.setHTMLClassName("fusioncharts-div"),this.getFromEnv("animationManager").addToEnv("paper",e)},a.setNodePath=function(t,e,a){this.config.thickness=e,this.config.outerRadius=t/2,this.config.innerRadius=this.config.outerRadius-this.config.thickness,this.config.barstartradius=a.barstartradius,this.config.barendradius=a.barendradius,this.manageSpace()},a.manageSpace=function(){var t,e=this.getFromEnv("chartConfig"),a=this.getLinkedParent(),o=e.canvasLeft,i=e.canvasTop,r=o+e.canvasWidth/2,n=i+e.canvasHeight/2,s=(0,h.changeAngleBase)(this.config.startingAngle),c=(0,h.changeAngleBase)(this.config.endingAngle),u=(0,h.findArc)(s,s===c?c-.1:c),d=s+Math.round((this.config.value>100?100:this.config.value)/100*u),p=parseInt(this.config.barstartradius,10)/100*(this.config.thickness/2),f=parseInt(this.config.barendradius,10)/100*(this.config.thickness/2);d=s===c?d-.01:d,t=(0,h.findArc)(s,d),this.getFromEnv("chart-attrib").interactivelegend=a.config.interactivelegend,this.config.path_d=function(t,e,a,o,i,r,n,s,c,u){c>0&&360!==a&&(t+=(0,h.radiansInAngle)(c,i+c)),u>0&&360!==a&&(e-=(0,h.radiansInAngle)(u,i+u));var d=(0,h.normaliseAngle)(t),p=(0,h.normaliseAngle)(e),f=(0,h.pointOnCircleFromCenter)(r,n,o,d),m=f.x,v=f.y,b=(0,h.pointOnCircleFromCenter)(r,n,o,p),k=b.x,C=b.y,x=(0,h.pointOnCircleFromCenter)(r,n,i,d),w=x.x,T=x.y,y=(0,h.pointOnCircleFromCenter)(r,n,i,p),A=y.x,S=y.y;return m=(0,l.toPrecision)(m,4),v=(0,l.toPrecision)(v,4),k=(0,l.toPrecision)(k,4),C=(0,l.toPrecision)(C,4),w=(0,l.toPrecision)(w,4),T=(0,l.toPrecision)(T,4),A=(0,l.toPrecision)(A,4),S=(0,l.toPrecision)(S,4),["M",m,v,g,o,o,0,a<=180?0:1,1,k,C,u>0&&360!==a?"A, "+u+", "+u+", 0, 1, 1, "+A+", "+S:"L, "+A+", "+S,g,i,i,0,a<=180?0:1,0,w,T,c>0&&360!==a?"A, "+c+", "+c+", 0, 1, 1, "+m+", "+v:"","Z"]}(s,d,t,this.config.outerRadius,this.config.innerRadius,r,n,this.config.thickness,p,f)},a.allocatePosition=function(){return!1},a.checkInvalidData=function(){return!1},a.checkInvalidSpecificData=function(){return!1},a._addLegend=function(){var t=this.getFromEnv("legend"),e=t.getItem(this.config.legendItemId),a=this.getLinkedParent(),o={label:this.config.label,type:"radialBar",showIcon:parseInt(a.config.showiconinlegend,10)&&this.config.iconurl,iconUrl:this.config.iconurl};e||(this.config.legendItemId=t.createItem(this.getLinkedParent()),e=t.getItem(this.config.legendItemId)),e.configure(o),e.setStateCosmetics("default",{symbol:{fill:this.config.realColor||this.config.color,stroke:this.config.barbordercolor,rawFillColor:this.config.realColor||this.config.color,rawStrokeColor:this.config.barbordercolor,bgColor:this.config.realColor||this.config.color,bgAlpha:100*(this.config.realBarAlpha||this.config.baralpha),opacity:100*(this.config.realBarAlpha||this.config.baralpha)}}),e.setStateCosmetics("highlight",{symbol:{fill:this.config.legenditemcolor,stroke:this.config.legenditembordercolor,rawFillColor:this.config.legenditemcolor,rawStrokeColor:this.config.legenditembordercolor,bgColor:this.config.legenditemcolor,bgAlpha:25,opacity:25},text:{fill:(0,l.toRaphaelColor)({alpha:25})}}),this.addExtEventListener("fc-click",(function(){e.itemClickFn()}),e)},a.getParsedText=function(t,e,a){var o,i,r,n,s,c,h,u,d,g,p,f=this.getFromEnv("legend"),m=this.getFromEnv("chartConfig"),v=this.getLinkedParent(),b=l.isIpad?"&#9632;":"&#x25FC;",k=[],C=[],x=l.BLANKSTRING,w=this.getLinkedParent().config.showLegend&&f.getItem(this.config.legendItemId),T=w&&w.getGraphicalElement(),y="",A=a||this.config.labelFontSize;if(w&&!m.showiconinlegend){if(o=(s=T&&T.legendItemSymbol)&&s.attrs.path.split(/(?=[LMCA])/),A=(n=s&&s.node.getBBox()).height,g=T.legendItemSymbol.node.getAttribute("stroke-width"),a&&a<n.height&&(A=a,g=g*(d=a/n.height)/2,y="transform=scale("+d+","+d+")"),o&&o.length)for(i=0;i<o.length;i++)C.push(o[i][0]),o[i]=o[i].substring(1,o[i].length),i===o.length-1&&(o[i]=o[i].substring(0,o[i].length-1)),k[i]=o[i].split(",");if(k&&k.length)for(i=0;i<k.length;i++){if(k[i].length)for(r=0;r<k[i].length;r++)k[i][r]=Number(k[i][r]),"A"!==C[i]?k[i][r]=r%2==0?k[i][r]-n.x:k[i][r]-n.y:"A"===C[i]&&(5===r?k[i][r]=k[i][r]-n.x:6===r&&(k[i][r]=k[i][r]-n.y));x+=C[i]+k[i].toString()}x+="Z"}return c=w&&x?'<svg style="margin:0px 1px 0px 1px;" height= '+A+" width = "+A+" overflow='visible' xmlns=\"http://www.w3.org/2000/svg\">\n      <path d= "+x+" fill = "+(this.config.realColor||this.config.color)+" stroke = "+T.legendItemSymbol.node.getAttribute("stroke")+"\n      stroke-opacity = 1 fill-opacity = 1 "+y+"\n      stroke-width = "+g+" stroke-linecap = "+T.legendItemSymbol.node.getAttribute("stroke-linecap")+"></path>\n    </svg>":"<span style='color: "+(this.config.realColor||this.config.color)+";'>"+b+"&nbsp;</span>",h={value:this.config.value,barColor:this.config.realColor||this.config.color,plotIdentifier:c},e&&(this.config.iconurl?((u=A*parseInt(v.config.iconscale,10)/100)>=Math.abs(this.config.outerRadius-this.config.innerRadius)&&(u=Math.abs(this.config.outerRadius-this.config.innerRadius)),u=u<0?Math.abs(this.config.outerRadius-this.config.innerRadius):u,a&&(p="end"===v.config.iconposition?"0px 0px 0px 10px":"0px 10px 0px 0px"),h.icon='<svg style="margin:'+p+';" height= '+u+" width = "+u+' overflow=\'visible\' xmlns="http://www.w3.org/2000/svg">\n          <image preserveAspectRatio="none" href='+this.config.iconurl+'\n          x="0" y="0" width= '+u+" height="+u+"></image>\n        </svg>"):h.icon=c),(0,l.parseTooltext)(t,[1,2,3,172,145,173],{label:this.config.label,formattedValue:this.config.dataValue},h)||this.config.label},a.draw=function(){var t=this.getLinkedParent();this.addGraphicalElement({el:"path",attr:{path:this.config.path_d,fill:this.config.color,stroke:this.config.barbordercolor,"stroke-width":this.config.barborderthickness,"stroke-opacity":this.config.plotHidden?0:this.config.barborderalpha,"stroke-dasharray":"dashed"===this.config.barborder?5:l.UNDEF,"fill-opacity":this.config.plotHidden?0:this.config.baralpha},container:{id:"node-container",isParent:!0},label:"bar",component:this}),this.config.plotHidden||t.drawLabel(t.getChildren("dataset")[this.config.plotIndex],this)},e}(n.SmartRenderer);e["default"]=p}}])}));
//# sourceMappingURL=http://localhost:3052/3.18.0/map/eval/fusioncharts.widgets.js.map

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactstrap = __webpack_require__(92);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _awsManager = __webpack_require__(59);

var _reactCheckboxGroup = __webpack_require__(594);

var _SymbioticMarkerClusterer = __webpack_require__(376);

var _SymbioticMarkerClusterer2 = _interopRequireDefault(_SymbioticMarkerClusterer);

var _CardBox = __webpack_require__(1662);

var _CardBox2 = _interopRequireDefault(_CardBox);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import { stackedChart } from 'util/fusionChartManager';
// import { greyShade, white } from '../../../../../styles/colorCharts';


var Devices = function (_Component) {
    _inherits(Devices, _Component);

    function Devices() {
        _classCallCheck(this, Devices);

        var _this = _possibleConstructorReturn(this, (Devices.__proto__ || Object.getPrototypeOf(Devices)).call(this));

        _this.stateToggle = function () {
            _this.setState({
                stateDropDownOpen: !_this.state.stateDropDownOpen
            });
        };

        _this.regionDropDownOpen = function () {
            _this.setState({
                regionDropDownOpen: !_this.state.regionDropDownOpen
            });
        };

        _this.sdpDropDownOpen = function () {
            _this.setState({
                sdpDropDownOpen: !_this.state.sdpDropDownOpen
            });
        };

        _this.techDropDownOpen = function () {
            _this.setState({
                techDropDownOpen: !_this.state.techDropDownOpen
            });
        };

        _this.roleDropDownOpen = function () {
            _this.setState({
                roleDropDownOpen: !_this.state.roleDropDownOpen
            });
        };

        _this.refreshData = function () {
            (0, _awsManager.refreshDevicesData)().then(function () {
                _this.getData();
            });
        };

        _this.getData = function () {
            (0, _awsManager.getDevicesData)(_this.state.selectedStates, _this.state.mapBounds).then(function (deviceData) {
                _this.setState({ deviceData: JSON.parse(deviceData) });
            }).catch(function (e) {
                console.error("Error Fetching device Data", e);
            });
        };

        _this.stateChanged = function (selected) {
            _this.setState({ selectedStates: selected }, function () {
                _this.getData();
            });
        };

        _this.onBoundsChanged = function (bounds) {
            _this.setState({ mapBounds: bounds ? [bounds.getSouthWest(), bounds.getNorthEast()] : [] });
            _this.getData();
        };

        _this.getPercentDevices = function () {
            return _this.state.deviceData.Summary.TotalFilteredDevices !== undefined && _this.state.deviceData.MetaData.TotalDevices !== undefined ? _this.state.deviceData.Summary.TotalFilteredDevices === 0 ? 0 : _this.state.deviceData.Summary.TotalFilteredDevices === _this.state.deviceData.MetaData.TotalDevices ? 100 : _this.state.deviceData.MetaData.TotalDevices > 0 ? (_this.state.deviceData.Summary.TotalFilteredDevices / _this.state.deviceData.MetaData.TotalDevices * 100).toFixed(2) : 0 : 0;
        };

        _this.getPercentTechOnsite = function () {
            return _this.state.deviceData.Summary.TotalFilteredTechOnsite !== undefined && _this.state.deviceData.MetaData.TotalTechOnsite !== undefined ? _this.state.deviceData.Summary.TotalFilteredTechOnsite === 0 ? 0 : _this.state.deviceData.Summary.TotalFilteredTechOnsite === _this.state.deviceData.MetaData.TotalTechOnsite ? 100 : _this.state.deviceData.MetaData.TotalTechOnsite > 0 ? (_this.state.deviceData.Summary.TotalFilteredTechOnsite / _this.state.deviceData.MetaData.TotalTechOnsite * 100).toFixed(2) : 0 : 0;
        };

        _this.getPercentActiveNotifications = function () {
            return _this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion !== undefined && _this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion !== undefined ? _this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion === 0 ? 0 : _this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion === _this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion ? 100 : _this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion > 0 ? (_this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion / _this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion * 100).toFixed(2) : 0 : 0;
        };

        _this.getPercentClosedNotifications = function () {
            return _this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion !== undefined && _this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion !== undefined ? _this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion === 0 ? 0 : _this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion === _this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion ? 100 : _this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion > 0 ? (_this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion / _this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion * 100).toFixed(2) : 0 : 0;
        };

        _this.state = {
            stateDropDownOpen: false,
            regionDropDownOpen: false,
            sdpDropDownOpen: false,
            techDropDownOpen: false,
            roleDropDownOpen: false,
            selectedStates: [],
            mapBounds: [],
            deviceData: {}
        };
        return _this;
    }

    _createClass(Devices, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            this.getData();

            // let devices = this;
            // const categorie = [
            //     {
            //         "category": [
            //             {
            //                 "label": ""
            //             }
            //         ]
            //     }];
            // const categories = [
            //     {
            //         "category": [
            //             {
            //                 "label": "Telstra"
            //             },
            //             {
            //                 "label": "Optus"
            //             },
            //             {
            //                 "label": "Lend Lease"
            //             },
            //             {
            //                 "label": "Other"
            //             }
            //         ]
            //     }
            // ];
            // const accessType = [
            //     {
            //         "category": [
            //             {
            //                 "label": "Residential"
            //             },
            //             {
            //                 "label": "Business"
            //             },
            //         ]
            //     }
            // ];
            // const sdpRspData = [
            //     {
            //         "seriesname": "Good",
            //         "data": [
            //             {
            //                 "value": "30",
            //                 displayValue: "30% Good",
            //             },
            //             {
            //                 "value": "26",
            //                 displayValue: "26% Good",
            //             },
            //             {
            //                 "value": "27",
            //                 displayValue: "27% Good",
            //             },
            //             {
            //                 "value": "37",
            //                 displayValue: "37% Good",
            //             }
            //         ]
            //     },
            //     {
            //         "seriesname": "Bad",
            //         "data": [
            //             {
            //                 "value": "64",
            //                 displayValue: "64% Bad",
            //             },
            //             {
            //                 "value": "59",
            //                 displayValue: "59% Bad",
            //             },
            //             {
            //                 "value": "61",
            //                 displayValue: "61% Bad",
            //             },
            //             {
            //                 "value": "75",
            //                 displayValue: "75% Bad",
            //             }
            //         ]
            //     }
            // ];
            // const dataset = [{
            //     seriesname: "Good",
            //     data: [{
            //         displayValue: `${30}% Good`,
            //         value: 30,
            //     },
            //     ]
            // },
            //     {
            //         seriesname: "Bad",
            //         data: [{
            //             displayValue: `${70}% Bad`,
            //             value: 70,
            //         },
            //         ]
            //     },
            // ]
            // stackedChart("gaschart", dataset, categorie, 100, greyShade);
            // stackedChart("floodingChart", dataset, categorie, 100, greyShade);
            // stackedChart("securityChart", dataset, categorie, 100, greyShade);
            // stackedChart("techOnSite", dataset, categorie, 100, greyShade);
            // stackedChart("sdpChart", sdpRspData, categories, 400, white);
            // stackedChart("deviceDistributionChart", sdpRspData, categories, 320, white);
            // stackedChart("deviceSplitByAccessType", sdpRspData, accessType, 200, white);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement('div', { className: 'row devices-page' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'jr-card d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('div', { className: 'col-12 col-sm-2 col-lg-2' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Devices')), _react2.default.createElement('div', { className: 'col-12 col-sm-10 col-lg-10' }, _react2.default.createElement(_reactstrap.ButtonGroup, { className: 'd-flex', vertical: this.props.isVertical }, _react2.default.createElement(_reactstrap.ButtonDropdown, { className: 'btn-width mr-1', isOpen: this.state.stateDropDownOpen, toggle: this.stateToggle }, _react2.default.createElement(_reactstrap.DropdownToggle, { className: 'bg-secondary text-white', caret: true }, 'State'), _react2.default.createElement(_reactstrap.DropdownMenu, null, _react2.default.createElement(_reactCheckboxGroup.CheckboxGroup, {
                checkboxDepth: 2,
                name: 'states',
                value: this.state.selectedStates,
                onChange: this.stateChanged }, _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'NSW' }), 'NSW'), _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'QLD' }), 'QLD'), _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'VIC' }), 'VIC'), _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'SA' }), 'SA'), _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'WA' }), 'WA'), _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'NT' }), 'NT'), _react2.default.createElement('label', { className: 'dropdown-item' }, _react2.default.createElement(_reactCheckboxGroup.Checkbox, { className: 'mr-2', value: 'TAS' }), 'TAS')))), _react2.default.createElement(_Button2.default, { className: 'jr-btn btn-refresh text-white', onClick: this.refreshData }, _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true' })))))), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement(_CardBox2.default, { styleName: 'col-12 col-sm-12 col-lg-6 col-centered map-height', heading: 'Device Distribution by Region' }, _react2.default.createElement(_SymbioticMarkerClusterer2.default, {
                markerData: this.state.deviceData.MapData ? this.state.deviceData.MapData : [],
                onBoundsChanged: function onBoundsChanged(bounds) {
                    return _this2.onBoundsChanged(bounds);
                } })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-lg-6' }, _react2.default.createElement('div', { className: 'row card-height' }, _react2.default.createElement('div', { className: 'col-12 col-sm-6 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card' }, _react2.default.createElement('div', { className: 'row h-100 ' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'jr-card-header ml-2 mb-0' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, ' Number Of Devices Deployed '))), _react2.default.createElement('div', { className: 'row w-100 mx-0' }, _react2.default.createElement('div', { className: 'inner-height' }, _react2.default.createElement('div', { className: 'col-12 jr-card-body set-background' }, _react2.default.createElement('div', { className: 'info-card d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredDevices : 0)), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/ico-device.png', alt: '' }))), this.state.deviceData.Summary && this.state.deviceData.MetaData ? _react2.default.createElement('p', { className: 't-blue mb-0' }, ' ', this.getPercentDevices(), '% of total devices.', _react2.default.createElement('br', null)) : "")))))), _react2.default.createElement('div', { className: 'col-12 col-sm-6 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card' }, _react2.default.createElement('div', { className: 'row h-100' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'jr-card-header ml-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, ' Number Of Techs Onsite '))), _react2.default.createElement('div', { className: 'row w-100 mx-0' }, _react2.default.createElement('div', { className: 'inner-height' }, _react2.default.createElement('div', { className: 'col-12 jr-card-body set-background' }, _react2.default.createElement('div', { className: 'info-card d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredTechOnsite : 0)), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/hse.png', alt: '' }))), this.state.deviceData.Summary && this.state.deviceData.MetaData ? _react2.default.createElement('p', { className: 't-blue mb-0' }, this.getPercentTechOnsite(), '% of total devices with notification visited.', _react2.default.createElement('br', null)) : "")))))), _react2.default.createElement('div', { className: 'col-12 col-sm-6 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card' }, _react2.default.createElement('div', { className: 'row h-100' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'jr-card-header ml-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, ' Number Of Devices with Active Notifications '))), _react2.default.createElement('div', { className: 'row w-100 mx-0' }, _react2.default.createElement('div', { className: 'inner-height' }, _react2.default.createElement('div', { className: 'col-12 jr-card-body set-background' }, _react2.default.createElement('div', { className: 'info-card d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion : 0)), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/ico-notification.png', alt: '' }))), this.state.deviceData.Summary && this.state.deviceData.MetaData ? _react2.default.createElement('p', { className: 't-blue mb-0' }, this.getPercentActiveNotifications(), '% of total Devices with Active notifications.', _react2.default.createElement('br', null)) : "")))))), _react2.default.createElement('div', { className: 'col-12 col-sm-6 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card' }, _react2.default.createElement('div', { className: 'row h-100' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'jr-card-header ml-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, ' Number Of Devices with Closed Notifications '))), _react2.default.createElement('div', { className: 'row w-100 mx-0' }, _react2.default.createElement('div', { className: 'inner-height' }, _react2.default.createElement('div', { className: 'col-12 jr-card-body set-background' }, _react2.default.createElement('div', { className: 'info-card d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion : 0)), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/ico-notification.png', alt: '' }))), this.state.deviceData.Summary && this.state.deviceData.MetaData ? _react2.default.createElement('p', { className: 't-blue mb-0' }, ' ', this.getPercentClosedNotifications(), '% of total Devices with Closed Notifications.', _react2.default.createElement('br', null)) : "")))))))))));
        }
    }]);

    return Devices;
}(_react.Component);

var _default = Devices;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(Devices, 'Devices', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_SymbioticMarkerClusterer2, "_SymbioticMarkerClusterer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_CardBox2, "_CardBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(Devices, "Devices", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/devices/index.js");
}();

;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(5)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(249)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(421)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(626)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(1574)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1549),
    defineProperty = __webpack_require__(610),
    identity = __webpack_require__(147);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(201),
    isMasked = __webpack_require__(1551),
    isObject = __webpack_require__(105),
    toSource = __webpack_require__(611);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1552);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(49);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(613),
    createBind = __webpack_require__(1555),
    createCurry = __webpack_require__(1556),
    createHybrid = __webpack_require__(616),
    createPartial = __webpack_require__(1570),
    getData = __webpack_require__(620),
    mergeData = __webpack_require__(1571),
    setData = __webpack_require__(622),
    setWrapToString = __webpack_require__(623),
    toInteger = __webpack_require__(625);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(250),
    root = __webpack_require__(49);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(377),
    createCtor = __webpack_require__(250),
    createHybrid = __webpack_require__(616),
    createRecurry = __webpack_require__(619),
    getHolder = __webpack_require__(380),
    replaceHolders = __webpack_require__(252),
    root = __webpack_require__(49);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1557 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(378),
    getData = __webpack_require__(620),
    getFuncName = __webpack_require__(1559),
    lodash = __webpack_require__(1561);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1560);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1560 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(378),
    LodashWrapper = __webpack_require__(621),
    baseLodash = __webpack_require__(379),
    isArray = __webpack_require__(51),
    isObjectLike = __webpack_require__(146),
    wrapperClone = __webpack_require__(1562);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(378),
    LodashWrapper = __webpack_require__(621),
    copyArray = __webpack_require__(429);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1563 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1564 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(430),
    arrayIncludes = __webpack_require__(860);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(624),
    baseIsNaN = __webpack_require__(1567),
    strictIndexOf = __webpack_require__(1568);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1567 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1568 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(429),
    isIndex = __webpack_require__(251);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(377),
    createCtor = __webpack_require__(250),
    root = __webpack_require__(49);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(617),
    composeArgsRight = __webpack_require__(618),
    replaceHolders = __webpack_require__(252);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(5)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(249)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(24)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(626)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(160)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(1578),
    baseEach = __webpack_require__(285),
    baseIteratee = __webpack_require__(202),
    baseReduce = __webpack_require__(1631),
    isArray = __webpack_require__(51);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 1578 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1580);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isObjectLike = __webpack_require__(146);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1583 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(169),
    isLength = __webpack_require__(382),
    isObjectLike = __webpack_require__(146);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(422),
    nativeKeys = __webpack_require__(1586);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(902);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(148);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1589),
    getMatchData = __webpack_require__(1620),
    matchesStrictComparable = __webpack_require__(630);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(432),
    baseIsEqual = __webpack_require__(433);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(254);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(254);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(254);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(254);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(253);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(253),
    Map = __webpack_require__(383),
    MapCache = __webpack_require__(384);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1601),
    ListCache = __webpack_require__(253),
    Map = __webpack_require__(383);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1602),
    hashDelete = __webpack_require__(1603),
    hashGet = __webpack_require__(1604),
    hashHas = __webpack_require__(1605),
    hashSet = __webpack_require__(1606);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(256);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1603 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(256);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(256);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(256);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(257);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1608 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(257);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(257);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(257);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(432),
    equalArrays = __webpack_require__(628),
    equalByTag = __webpack_require__(1615),
    equalObjects = __webpack_require__(1617),
    getTag = __webpack_require__(857),
    isArray = __webpack_require__(51),
    isBuffer = __webpack_require__(431),
    isTypedArray = __webpack_require__(627);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1613 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1614 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(172),
    Uint8Array = __webpack_require__(904),
    eq = __webpack_require__(255),
    equalArrays = __webpack_require__(628),
    mapToArray = __webpack_require__(1616),
    setToArray = __webpack_require__(864);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1616 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(905);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141),
    root = __webpack_require__(49);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(141),
    root = __webpack_require__(49);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(629),
    keys = __webpack_require__(170);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(433),
    get = __webpack_require__(855),
    hasIn = __webpack_require__(1626),
    isKey = __webpack_require__(385),
    isStrictComparable = __webpack_require__(629),
    matchesStrictComparable = __webpack_require__(630),
    toKey = __webpack_require__(205);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1623);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1624);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(384);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(172),
    arrayMap = __webpack_require__(418),
    isArray = __webpack_require__(51),
    isSymbol = __webpack_require__(171);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1627),
    hasPath = __webpack_require__(632);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1627 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1629),
    basePropertyDeep = __webpack_require__(1630),
    isKey = __webpack_require__(385),
    toKey = __webpack_require__(205);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1629 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(288);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1631 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(430),
    baseEach = __webpack_require__(285),
    castFunction = __webpack_require__(1633),
    isArray = __webpack_require__(51);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(147);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1635);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(1636),
    hasUnicode = __webpack_require__(633),
    stringToArray = __webpack_require__(1637),
    toString = __webpack_require__(631);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(910);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1638),
    hasUnicode = __webpack_require__(633),
    unicodeToArray = __webpack_require__(1639);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1638 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1639 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1641),
    hasPath = __webpack_require__(632);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1641 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(421)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(21)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(4)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(1649)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(1651)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(249)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(21)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _OverlayViewHelper = __webpack_require__(1653)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(1650),
    baseRest = __webpack_require__(204),
    toNumber = __webpack_require__(360);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 1650 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(435),
    copyObject = __webpack_require__(856),
    createAssigner = __webpack_require__(1652),
    isArrayLike = __webpack_require__(148),
    isPrototype = __webpack_require__(422),
    keys = __webpack_require__(170);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(204),
    isIterateeCall = __webpack_require__(420);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(201)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(24)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(8)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(13)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(10)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(11)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(14)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(15)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(1)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(44)

var _constants = __webpack_require__(40)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 1661 */
/***/ (function(module, exports) {

/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */
/**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */
/**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */
function ClusterIcon(cluster, styles) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.cluster_ = cluster;
  this.className_ = cluster.getMarkerClusterer().getClusterClass();
  this.styles_ = styles;
  this.center_ = null;
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}


/**
 * Adds the icon to the DOM.
 */
ClusterIcon.prototype.onAdd = function () {
  var cClusterIcon = this;
  var cMouseDownInCluster;
  var cDraggingMapByCluster;

  this.div_ = document.createElement("div");
  this.div_.className = this.className_;
  if (this.visible_) {
    this.show();
  }

  this.getPanes().overlayMouseTarget.appendChild(this.div_);

  // Fix for Issue 157
  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
    cDraggingMapByCluster = cMouseDownInCluster;
  });

  google.maps.event.addDomListener(this.div_, "mousedown", function () {
    cMouseDownInCluster = true;
    cDraggingMapByCluster = false;
  });

  google.maps.event.addDomListener(this.div_, "click", function (e) {
    cMouseDownInCluster = false;
    if (!cDraggingMapByCluster) {
      var theBounds;
      var mz;
      var mc = cClusterIcon.cluster_.getMarkerClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name

      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (mc.getZoomOnClick()) {
        // Zoom into the cluster.
        mz = mc.getMaxZoom();
        theBounds = cClusterIcon.cluster_.getBounds();
        mc.getMap().fitBounds(theBounds);
        // There is a fix for Issue 170 here:
        setTimeout(function () {
          mc.getMap().fitBounds(theBounds);
          // Don't zoom beyond the max zoom level
          if (mz !== null && (mc.getMap().getZoom() > mz)) {
            mc.getMap().setZoom(mz + 1);
          }
        }, 100);
      }

      // Prevent event propagation to the map:
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  });

  google.maps.event.addDomListener(this.div_, "mouseover", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
  });

  google.maps.event.addDomListener(this.div_, "mouseout", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
  });
};


/**
 * Removes the icon from the DOM.
 */
ClusterIcon.prototype.onRemove = function () {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    google.maps.event.removeListener(this.boundsChangedListener_);
    google.maps.event.clearInstanceListeners(this.div_);
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Draws the icon.
 */
ClusterIcon.prototype.draw = function () {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + "px";
    this.div_.style.left = pos.x + "px";
  }
};


/**
 * Hides the icon.
 */
ClusterIcon.prototype.hide = function () {
  if (this.div_) {
    this.div_.style.display = "none";
  }
  this.visible_ = false;
};


/**
 * Positions and shows the icon.
 */
ClusterIcon.prototype.show = function () {
  if (this.div_) {
    var img = "";
    // NOTE: values must be specified in px units
    var bp = this.backgroundPosition_.split(" ");
    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
      img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
          ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
    }
    img += "'>";
    this.div_.innerHTML = img + "<div style='" +
        "position: absolute;" +
        "top: " + this.anchorText_[0] + "px;" +
        "left: " + this.anchorText_[1] + "px;" +
        "color: " + this.textColor_ + ";" +
        "font-size: " + this.textSize_ + "px;" +
        "font-family: " + this.fontFamily_ + ";" +
        "font-weight: " + this.fontWeight_ + ";" +
        "font-style: " + this.fontStyle_ + ";" +
        "text-decoration: " + this.textDecoration_ + ";" +
        "text-align: center;" +
        "width: " + this.width_ + "px;" +
        "line-height:" + this.height_ + "px;" +
        "'>" + this.sums_.text + "</div>";
    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
    } else {
      this.div_.title = this.sums_.title;
    }
    this.div_.style.display = "";
  }
  this.visible_ = true;
};


/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */
ClusterIcon.prototype.useStyle = function (sums) {
  this.sums_ = sums;
  var index = Math.max(0, sums.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style.url;
  this.height_ = style.height;
  this.width_ = style.width;
  this.anchorText_ = style.anchorText || [0, 0];
  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
  this.textColor_ = style.textColor || "black";
  this.textSize_ = style.textSize || 11;
  this.textDecoration_ = style.textDecoration || "none";
  this.fontWeight_ = style.fontWeight || "bold";
  this.fontStyle_ = style.fontStyle || "normal";
  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
  this.backgroundPosition_ = style.backgroundPosition || "0 0";
};


/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
  this.center_ = center;
};


/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
  var style = [];
  style.push("cursor: pointer;");
  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
  return style.join("");
};


/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= this.anchorIcon_[1];
  pos.y -= this.anchorIcon_[0];
  pos.x = parseInt(pos.x, 10);
  pos.y = parseInt(pos.y, 10);
  return pos;
};


/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */
function Cluster(mc) {
  this.markerClusterer_ = mc;
  this.map_ = mc.getMap();
  this.gridSize_ = mc.getGridSize();
  this.minClusterSize_ = mc.getMinimumClusterSize();
  this.averageCenter_ = mc.getAverageCenter();
  this.markers_ = [];
  this.center_ = null;
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
}


/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function () {
  return this.markers_.length;
};


/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */
Cluster.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */
Cluster.prototype.getCenter = function () {
  return this.center_;
};


/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */
Cluster.prototype.getMap = function () {
  return this.map_;
};


/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */
Cluster.prototype.getMarkerClusterer = function () {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */
Cluster.prototype.getBounds = function () {
  var i;
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster from the map.
 *
 * @ignore
 */
Cluster.prototype.remove = function () {
  this.clusterIcon_.setMap(null);
  this.markers_ = [];
  delete this.markers_;
};


/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */
Cluster.prototype.addMarker = function (marker) {
  var i;
  var mCount;
  var mz;

  if (this.isMarkerAlreadyAdded_(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  mCount = this.markers_.length;
  mz = this.markerClusterer_.getMaxZoom();
  if (mz !== null && this.map_.getZoom() > mz) {
    // Zoomed in past max zoom, so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount < this.minClusterSize_) {
    // Min cluster size not reached so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount === this.minClusterSize_) {
    // Hide the markers that were showing.
    for (i = 0; i < mCount; i++) {
      this.markers_[i].setMap(null);
    }
  } else {
    marker.setMap(null);
  }

  this.updateIcon_();
  return true;
};


/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Calculates the extended bounds of the cluster with the grid.
 */
Cluster.prototype.calculateBounds_ = function () {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Updates the cluster icon.
 */
Cluster.prototype.updateIcon_ = function () {
  var mCount = this.markers_.length;
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz !== null && this.map_.getZoom() > mz) {
    this.clusterIcon_.hide();
    return;
  }

  if (mCount < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.useStyle(sums);
  this.clusterIcon_.show();
};


/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */
Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
  var i;
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) !== -1;
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        return true;
      }
    }
  }
  return false;
};


/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */
/**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);

  opt_markers = opt_markers || [];
  opt_options = opt_options || {};

  this.markers_ = [];
  this.clusters_ = [];
  this.listeners_ = [];
  this.activeMap_ = null;
  this.ready_ = false;

  this.gridSize_ = opt_options.gridSize || 60;
  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
  this.maxZoom_ = opt_options.maxZoom || null;
  this.styles_ = opt_options.styles || [];
  this.title_ = opt_options.title || "";
  this.zoomOnClick_ = true;
  if (opt_options.zoomOnClick !== undefined) {
    this.zoomOnClick_ = opt_options.zoomOnClick;
  }
  this.averageCenter_ = false;
  if (opt_options.averageCenter !== undefined) {
    this.averageCenter_ = opt_options.averageCenter;
  }
  this.ignoreHidden_ = false;
  if (opt_options.ignoreHidden !== undefined) {
    this.ignoreHidden_ = opt_options.ignoreHidden;
  }
  this.enableRetinaIcons_ = false;
  if (opt_options.enableRetinaIcons !== undefined) {
    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
  }
  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
  this.clusterClass_ = opt_options.clusterClass || "cluster";

  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
    // Try to avoid IE timeout when processing a huge number of markers:
    this.batchSize_ = this.batchSizeIE_;
  }

  this.setupStyles_();

  this.addMarkers(opt_markers, true);
  this.setMap(map); // Note: this causes onAdd to be called
}


/**
 * Implementation of the onAdd interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
  var cMarkerClusterer = this;

  this.activeMap_ = this.getMap();
  this.ready_ = true;

  this.repaint();

  // Add the map event listeners
  this.listeners_ = [
    google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
      cMarkerClusterer.resetViewport_(false);
      // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.
      if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
        google.maps.event.trigger(this, "idle");
      }
    }),
    google.maps.event.addListener(this.getMap(), "idle", function () {
      cMarkerClusterer.redraw_();
    })
  ];
};


/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */
MarkerClusterer.prototype.onRemove = function () {
  var i;

  // Put all the managed markers back on the map:
  for (i = 0; i < this.markers_.length; i++) {
    if (this.markers_[i].getMap() !== this.activeMap_) {
      this.markers_[i].setMap(this.activeMap_);
    }
  }

  // Remove all clusters:
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Remove map event listeners:
  for (i = 0; i < this.listeners_.length; i++) {
    google.maps.event.removeListener(this.listeners_[i]);
  }
  this.listeners_ = [];

  this.activeMap_ = null;
  this.ready_ = false;
};


/**
 * Implementation of the draw interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () {};


/**
 * Sets up the styles object.
 */
MarkerClusterer.prototype.setupStyles_ = function () {
  var i, size;
  if (this.styles_.length > 0) {
    return;
  }

  for (i = 0; i < this.imageSizes_.length; i++) {
    size = this.imageSizes_[i];
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
      height: size,
      width: size
    });
  }
};


/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
  var i;
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }

  this.getMap().fitBounds(bounds);
};


/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
  return this.gridSize_;
};


/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (gridSize) {
  this.gridSize_ = gridSize;
};


/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */
MarkerClusterer.prototype.getMinimumClusterSize = function () {
  return this.minClusterSize_;
};

/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */
MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
  this.minClusterSize_ = minimumClusterSize;
};


/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
  return this.maxZoom_;
};


/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */
MarkerClusterer.prototype.getStyles = function () {
  return this.styles_;
};


/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
  this.styles_ = styles;
};


/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */
MarkerClusterer.prototype.getTitle = function () {
  return this.title_;
};


/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */
MarkerClusterer.prototype.setTitle = function (title) {
  this.title_ = title;
};


/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */
MarkerClusterer.prototype.getZoomOnClick = function () {
  return this.zoomOnClick_;
};


/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */
MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
  this.zoomOnClick_ = zoomOnClick;
};


/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */
MarkerClusterer.prototype.getAverageCenter = function () {
  return this.averageCenter_;
};


/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */
MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
  this.averageCenter_ = averageCenter;
};


/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */
MarkerClusterer.prototype.getIgnoreHidden = function () {
  return this.ignoreHidden_;
};


/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */
MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
  this.ignoreHidden_ = ignoreHidden;
};


/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */
MarkerClusterer.prototype.getEnableRetinaIcons = function () {
  return this.enableRetinaIcons_;
};


/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */
MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
  this.enableRetinaIcons_ = enableRetinaIcons;
};


/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */
MarkerClusterer.prototype.getImageExtension = function () {
  return this.imageExtension_;
};


/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */
MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
  this.imageExtension_ = imageExtension;
};


/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */
MarkerClusterer.prototype.getImagePath = function () {
  return this.imagePath_;
};


/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */
MarkerClusterer.prototype.setImagePath = function (imagePath) {
  this.imagePath_ = imagePath;
};


/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */
MarkerClusterer.prototype.getImageSizes = function () {
  return this.imageSizes_;
};


/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */
MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
  this.imageSizes_ = imageSizes;
};


/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */
MarkerClusterer.prototype.getCalculator = function () {
  return this.calculator_;
};


/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
  this.calculator_ = calculator;
};


/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */
MarkerClusterer.prototype.getBatchSizeIE = function () {
  return this.batchSizeIE_;
};


/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */
MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
  this.batchSizeIE_ = batchSizeIE;
};


/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */
MarkerClusterer.prototype.getClusterClass = function () {
  return this.clusterClass_;
};


/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */
MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
  this.clusterClass_ = clusterClass;
};


/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */
MarkerClusterer.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
  return this.markers_.length;
};


/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getClusters = function () {
  return this.clusters_;
};


/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
  return this.clusters_.length;
};


/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
  var key;
  for (key in markers) {
    if (markers.hasOwnProperty(key)) {
      this.pushMarkerTo_(markers[key]);
    }
  }  
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
  // If the marker is draggable add a listener so we can update the clusters on the dragend:
  if (marker.getDraggable()) {
    var cMarkerClusterer = this;
    google.maps.event.addListener(marker, "dragend", function () {
      if (cMarkerClusterer.ready_) {
        this.isAdded = false;
        cMarkerClusterer.repaint();
      }
    });
  }
  marker.isAdded = false;
  this.markers_.push(marker);
};


/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
  var i, r;
  var removed = false;

  for (i = 0; i < markers.length; i++) {
    r = this.removeMarker_(markers[i]);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
  var i;
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        index = i;
        break;
      }
    }
  }

  if (index === -1) {
    // Marker is not in our list of markers, so do nothing:
    return false;
  }

  marker.setMap(null);
  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
  return true;
};


/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
  this.resetViewport_(true);
  this.markers_ = [];
};


/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */
MarkerClusterer.prototype.repaint = function () {
  var oldClusters = this.clusters_.slice();
  this.clusters_ = [];
  this.resetViewport_(false);
  this.redraw_();

  // Remove the old clusters.
  // Do it in a timeout to prevent blinking effect.
  setTimeout(function () {
    var i;
    for (i = 0; i < oldClusters.length; i++) {
      oldClusters[i].remove();
    }
  }, 0);
};


/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Redraws all the clusters.
 */
MarkerClusterer.prototype.redraw_ = function () {
  this.createClusters_(0);
};


/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */
MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
  var i, marker;
  // Remove all the clusters
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Reset the markers to not be added and to be removed from the map.
  for (i = 0; i < this.markers_.length; i++) {
    marker = this.markers_[i];
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }
};


/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
  var i, d, cluster, center;
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  for (i = 0; i < this.clusters_.length; i++) {
    cluster = this.clusters_[i];
    center = cluster.getCenter();
    if (center) {
      d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */
MarkerClusterer.prototype.createClusters_ = function (iFirst) {
  var i, marker;
  var mapBounds;
  var cMarkerClusterer = this;
  if (!this.ready_) {
    return;
  }

  // Cancel previous batch processing if we're working on the first batch:
  if (iFirst === 0) {
    /**
     * This event is fired when the <code>MarkerClusterer</code> begins
     *  clustering markers.
     * @name MarkerClusterer#clusteringbegin
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringbegin", this);

    if (typeof this.timerRefStatic !== "undefined") {
      clearTimeout(this.timerRefStatic);
      delete this.timerRefStatic;
    }
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  //
  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
  if (this.getMap().getZoom() > 3) {
    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
      this.getMap().getBounds().getNorthEast());
  } else {
    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
  }
  var bounds = this.getExtendedBounds(mapBounds);

  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

  for (i = iFirst; i < iLast; i++) {
    marker = this.markers_[i];
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
        this.addToClosestCluster_(marker);
      }
    }
  }

  if (iLast < this.markers_.length) {
    this.timerRefStatic = setTimeout(function () {
      cMarkerClusterer.createClusters_(iLast);
    }, 0);
  } else {
    delete this.timerRefStatic;

    /**
     * This event is fired when the <code>MarkerClusterer</code> stops
     *  clustering markers.
     * @name MarkerClusterer#clusteringend
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringend", this);
  }
};


/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
  return (function (object) {
    var property;
    for (property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */
MarkerClusterer.CALCULATOR = function (markers, numStyles) {
  var index = 0;
  var title = "";
  var count = markers.length.toString();

  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index,
    title: title
  };
};


/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE = 2000;


/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE_IE = 500;


/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";


/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_EXTENSION = "png";


/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */
MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];

module.exports = MarkerClusterer


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var CardBox = function CardBox(_ref) {
    var heading = _ref.heading,
        children = _ref.children,
        styleName = _ref.styleName,
        cardStyle = _ref.cardStyle,
        childrenStyle = _ref.childrenStyle,
        headerOutside = _ref.headerOutside;

    if (!cardStyle) {
        cardStyle = "";
    }
    if (!childrenStyle) {
        childrenStyle = "";
    }
    if (!styleName) {
        styleName = "col-lg-6 col-sm-12";
    }
    return _react2.default.createElement("div", { className: "" + styleName }, headerOutside && _react2.default.createElement("div", { className: "jr-entry-header" }, _react2.default.createElement("h3", { className: "entry-heading" }, heading), children.length > 1 && _react2.default.createElement("div", { className: "entry-description" }, children[0])), _react2.default.createElement("div", { className: "jr-card " + cardStyle }, !headerOutside && heading && _react2.default.createElement("div", { className: "jr-card-header" }, _react2.default.createElement("h3", { className: "card-heading" }, heading), children.length > 1 && _react2.default.createElement("div", { className: "sub-heading" }, children[0])), _react2.default.createElement("div", { className: "jr-card-body " + childrenStyle }, children.length > 1 ? children[1] : children)));
};

var _default = CardBox;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(CardBox, "CardBox", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");

    __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");

    __REACT_HOT_LOADER__.register(CardBox, "CardBox", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/components/CardBox/index.js");
}();

;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _awsManager = __webpack_require__(59);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactstrap = __webpack_require__(92);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(30);

var _lodash = __webpack_require__(165);

var _lodash2 = _interopRequireDefault(_lodash);

var _searchModal = __webpack_require__(1665);

var _searchModal2 = _interopRequireDefault(_searchModal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Config = function (_Component) {
  _inherits(Config, _Component);

  function Config(props) {
    _classCallCheck(this, Config);

    var _this = _possibleConstructorReturn(this, (Config.__proto__ || Object.getPrototypeOf(Config)).call(this, props));

    _this.dropdownToggle = function () {
      if (_this.state.options.length > 0) {
        _this.setState({
          searchToggle: !_this.state.searchToggle
        });
      }
    };

    _this.onChangeDepth = function (event) {
      if (!isNaN(event.target.value)) {
        _this.setState({
          depthOfPit: event.target.value
        });
      }
    };

    _this.onChangeSensorRead = function (event) {
      if (!isNaN(event.target.value)) {
        _this.setState({
          sensorReadInterval: event.target.value
        });
      }
    };

    _this.onChangeTransmitInterval = function (event) {
      if (!isNaN(event.target.value)) {
        _this.setState({
          transmitInterval: event.target.value
        });
      }
    };

    _this.onChangeBatteryLevelRead = function (event) {
      if (!isNaN(event.target.value)) {
        _this.setState({
          batteryReadInterval: event.target.value
        });
      }
    };

    _this.onChangeCurrentSensorRead = function (event) {
      if (!isNaN(event.target.value)) {
        _this.setState({
          currentSensorRead: event.target.value
        });
      }
    };

    _this.onChangeTemperatureProbes = function (event) {
      if (!isNaN(event.target.value)) {
        _this.setState({
          temperatureProbes: event.target.value
        });
      }
    };

    _this.filterObject = function (object) {
      for (var propName in object) {
        if (object[propName] === "" || object[propName] === null || object[propName] === undefined) {
          delete object[propName];
        }
      }
      return object;
    };

    _this.getSearchedDevices = function () {
      if (_this.state.searchText !== "") {
        (0, _awsManager.searchDevices)(_this.state.searchText).then(function (data) {
          var uniqueRecords = data.filter(_this.unique);
          var records = uniqueRecords.map(function (item) {
            return item;
          });

          var concatRecords = _this.state.selected.concat(records);
          var uniqueList = _lodash2.default.uniqWith(concatRecords, _lodash2.default.isEqual);
          _this.setState({
            options: uniqueList
          });
        }).catch(function (error) {
          console.log("error: ", error);
        });
      }
    };

    _this.getPitDepth = function () {
      (0, _awsManager.getPitDepth)(_this.props.deviceId).then(function (item) {
        _this.setState({
          pitDepth: item.pitDepth
        });
      }).catch(function (error) {
        console.log("error: ", error);
      });
    };

    _this.formatDate = function (item) {
      return "( " + (0, _moment2.default)(item * 1000).format("DD-MM-YYYY hh:mm:ss") + " )";
    };

    _this.getAllConfiguration = function () {
      (0, _awsManager.getAllConfiguration)(_this.props.deviceId).then(function (item) {
        _this.setState({
          configurationValues: item
          // {
          //   sensors: { status: "PENDING", device: 10, value: 20 },
          //   network: { status: "PENDING", device: 20, value: 30 },
          //   maintenance: { status: "PENDING", device: 30, value: 40 },
          //   current: { status: "PENDING", device: 40, value: 50 },
          //   probes: { status: "PENDING", device: 50, value: 60 },
          // },
        });
      }).catch(function (error) {
        console.log("error: ", error);
      });
    };

    _this.unique = function (value, index, self) {
      return self.indexOf(value) === index;
    };

    _this.saveAllConfiguration = function () {
      var message = void 0;
      var _this$state = _this.state,
          sensorReadInterval = _this$state.sensorReadInterval,
          transmitInterval = _this$state.transmitInterval,
          batteryReadInterval = _this$state.batteryReadInterval,
          currentSensorRead = _this$state.currentSensorRead,
          temperatureProbes = _this$state.temperatureProbes;

      var data = {
        sensors: sensorReadInterval,
        network: transmitInterval,
        maintenance: batteryReadInterval,
        current: currentSensorRead,
        probes: temperatureProbes
      };
      var item = _this.filterObject(data);
      var length = Object.keys(item).length;
      if (length > 0) {
        (0, _awsManager.setAllConfiguration)(_this.props.deviceId, item).then(function (data) {
          console.log("data: ", data);
          message = "Configuration updated successfully";
          alert(message);
          _this.getAllConfiguration();
          _this.setState({
            sensorReadInterval: "",
            transmitInterval: "",
            batteryReadInterval: "",
            currentSensorRead: "",
            temperatureProbes: ""
          });
        }).catch(function (error) {
          message = "Unable to update configuration";
          alert(message);
          console.log("error: ", error);
        });
      }
    };

    _this.renderImage = function (active) {
      if (active) {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block pl-0",
          src: "../../../../assets/images/online.png",
          alt: "Online",
          style: {
            borderRadius: 15,
            marginLeft: 10
          },
          width: 15,
          height: 15
        });
      }
      return _react2.default.createElement("img", {
        className: "battery-charge-img d-inline-block pl-0",
        src: "../../../../assets/images/redIc.png",
        alt: "Offline",
        width: 15,
        style: {
          borderRadius: 15,
          marginLeft: 10
        },
        height: 15
      });
    };

    _this.saveDepthOfPit = function () {
      var message = void 0;
      (0, _awsManager.setDepthOfPit)(_this.props.deviceId, _this.state.depthOfPit).then(function (data) {
        _this.getPitDepth();
        _this.setState({
          depthOfPit: ""
        });
        message = "Depth updated successfully";
        alert(message);
      }).catch(function (error) {
        message = "Unable to set depth";
        console.log("error: ", error);
      });
    };

    _this.state = {
      depthOfPit: "",
      pitDepth: "",
      sensorReadInterval: "",
      transmitInterval: "",
      batteryReadInterval: "",
      currentSensorRead: "",
      temperatureProbes: "",
      deviceId: "",
      options: [],
      selected: [],
      searchText: "",
      configurationValues: {},
      searchToggle: false
    };
    return _this;
  }

  _createClass(Config, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAllConfiguration();
      this.getPitDepth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          depthOfPit = _state.depthOfPit,
          sensorReadInterval = _state.sensorReadInterval,
          transmitInterval = _state.transmitInterval,
          batteryReadInterval = _state.batteryReadInterval,
          currentSensorRead = _state.currentSensorRead,
          temperatureProbes = _state.temperatureProbes,
          configurationValues = _state.configurationValues;
      // const depthActive =
      //   parseFloat(depthOfPit) === parseFloat(currentValue.depthOfPit);

      var sensorReadActive = parseFloat(configurationValues.sensors && configurationValues.sensors.reported) === parseFloat(configurationValues.sensors && configurationValues.sensors.desired) || configurationValues.sensors && configurationValues.sensors.status === "UPDATED";
      var transmitIntervalActive = parseFloat(configurationValues.network && configurationValues.network.reported) === parseFloat(configurationValues.network && configurationValues.network.desired) || configurationValues.network && configurationValues.network.status === "UPDATED";
      var batteryReadActive = parseFloat(configurationValues.maintenance && configurationValues.maintenance.reported) === parseFloat(configurationValues.maintenance && configurationValues.maintenance.desired) || configurationValues.maintenance && configurationValues.maintenance.status === "UPDATED";
      var currentSensorActive = parseFloat(configurationValues.current && configurationValues.current.reported) === parseFloat(configurationValues.current && configurationValues.current.desired) || configurationValues.current && configurationValues.current.status === "UPDATED";
      var temperatureProbeActive = parseFloat(configurationValues.probes && configurationValues.probes.reported) === parseFloat(configurationValues.probes && configurationValues.probes.desired) || configurationValues.probes && configurationValues.probes.status === "UPDATED";
      var disabled = depthOfPit === "" && sensorReadInterval === "" && transmitInterval === "" && batteryReadInterval === "" && currentSensorRead === "" && temperatureProbes === "";
      var uniqueList = _lodash2.default.uniqWith(this.state.selected, _lodash2.default.isEqual);
      return _react2.default.createElement("div", { className: "row configuration-page" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "jr-card d-sm-flex justify-content-sm-between align-items-sm-center" }, _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-8" }, _react2.default.createElement("h1", { className: "mb-0" }, "OTA Update")), _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-4" }, "Device ID: ", this.props.deviceId))), _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "col-12 col-sm-12 col-lg-12 col-xl-8" }, _react2.default.createElement("div", { className: "row card-height" }, _react2.default.createElement("div", { className: "col-12 col-sm-12 col-lg-12" }, _react2.default.createElement("div", { className: "jr-card h-100" }, _react2.default.createElement("div", { className: "col-12 d-flex justify-content-end" }, _react2.default.createElement(_Button2.default, {
        disabled: disabled,
        onClick: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(_this2.state.depthOfPit !== "")) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return _this2.saveDepthOfPit();

                case 3:
                  _this2.saveAllConfiguration();

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        })),
        variant: "raised",
        color: disabled ? "default" : "primary",
        className: "jr-btn text-white mt-2"
      }, "SAVE CHANGES")), _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", {
        className: "col-12 col-lg-4 px-0",
        style: {
          border: "1px solid #ccc",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginLeft: 12,
          marginRight: 12,
          borderRadius: 5
        }
      }, _react2.default.createElement(_SearchBox2.default, {
        styleName: "col-12 d-sm-block px-0",
        placeholder: "Search by Device ID",
        onChange: function onChange(text) {
          _this2.setState({
            searchText: text.target.value
          });
        },
        value: this.state.searchText,
        onKeyPress: function onKeyPress(e) {
          if (e.key === "Enter") {
            _this2.getSearchedDevices();
            $("#searchModalComponent").modal();
          }
        },
        onButtonClick: function onButtonClick() {
          _this2.getSearchedDevices();
          $("#searchModalComponent").modal();
        }
      }), _react2.default.createElement(_searchModal2.default, {
        selectAll: function selectAll(checked) {
          // let data = this.state.options;
          // if (checked) {
          //   data = this.state.options;
          // } else {
          //   data = [];
          // }
          // this.setState({
          //   selected: data,
          // });
        },
        data: this.state.options,
        searchText: this.state.searchText,
        onChangeText: function onChangeText(text) {
          _this2.setState({
            searchText: text.target.value
          });
        },
        selected: this.state.selected,
        searchDevices: function searchDevices() {
          _this2.getSearchedDevices();
        },
        selectDevice: function selectDevice(data) {
          var item = _this2.state.selected;
          var isExist = item.findIndex(function (res) {
            return res === data;
          });
          if (isExist !== -1) {
            item.splice(isExist, 1);
          } else {
            item.push(data);
          }
          _this2.setState({
            selected: item
          });
        }
      }))), uniqueList.length > 0 && _react2.default.createElement("div", {
        className: "col-12",
        style: {
          border: "1px solid #ccc",
          display: "flex",
          alignItems: "center",
          borderRadius: 5,
          marginTop: 10,
          marginBottom: 10,
          padding: 10
        }
      }, _react2.default.createElement("div", { className: "col-12" }, uniqueList.map(function (data, index) {
        return _react2.default.createElement("span", {
          className: "pr-2",
          style: {
            color: "#1E90FF"
          },
          key: index,
          onClick: function onClick() {
            var filter = _this2.state.selected;
            filter.splice(filter.findIndex(function (item) {
              return item === data;
            }), 1);
            _this2.setState({
              selected: filter
            });
          }
        }, data, _react2.default.createElement("i", { className: "zmdi zmdi-close-circle-o zmdi-hc-lg" }));
      }))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex align-items-center jr-card-header mb-0" }), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("h4", { className: "col-4 col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block" }, " ", "CURRENT", " "), _react2.default.createElement("h4", { className: "col-4 col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block" }, " ", "DESIRED", " "), _react2.default.createElement("h4", { className: "col-4 col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block" }, "UPDATE"))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex align-items-center jr-card-header mb-0" }, _react2.default.createElement("h4", { className: "card-heading d-inline-block" }, " ", "Depth of pit (mms)", " ")), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("h4", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, this.state.pitDepth), _react2.default.createElement("h4", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, "NA"), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, _react2.default.createElement("input", {
        className: "inputContainer",
        type: "text",
        placeholder: "",
        onChange: this.onChangeDepth,
        value: this.state.depthOfPit
      })))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0" }, _react2.default.createElement("h4", { className: "card-heading d-inline-block" }, " ", "Sensor read interval (secs)", " "), _react2.default.createElement("div", { className: "col-3 text-right card-heading d-inline-block my-0" }, this.renderImage(sensorReadActive))), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.sensors && configurationValues.sensors.reported), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.sensors && this.formatDate(configurationValues.sensors.lastReportedAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.sensors && configurationValues.sensors.status === "PENDING" && configurationValues.sensors.desired), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.sensors && configurationValues.sensors.status === "PENDING" && this.formatDate(configurationValues.sensors.lastDesiredAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, _react2.default.createElement("input", {
        className: "inputContainer",
        type: "text",
        placeholder: "",
        onChange: this.onChangeSensorRead,
        value: this.state.sensorReadInterval
      })))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0" }, _react2.default.createElement("h4", { className: "card-heading d-inline-block" }, " ", "Transmit interval (secs)", " "), _react2.default.createElement("div", { className: "col-3 text-right card-heading d-inline-block my-0" }, this.renderImage(transmitIntervalActive))), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("div", { className: "col-lg-4 col-xl-4  col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.network && configurationValues.network.reported), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.network && this.formatDate(configurationValues.network.lastReportedAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4  col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.network && configurationValues.network.status === "PENDING" && configurationValues.network.desired), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.network && configurationValues.network.status === "PENDING" && configurationValues.network.desired && this.formatDate(configurationValues.network.lastDesiredAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4  col-sm-4 text-center card-heading d-inline-block my-0" }, _react2.default.createElement("input", {
        className: "inputContainer",
        type: "text",
        placeholder: "",
        onChange: this.onChangeTransmitInterval,
        value: this.state.transmitInterval
      })))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0" }, _react2.default.createElement("h4", { className: "card-heading d-inline-block" }, " ", "Battery level read interval (secs)", " "), _react2.default.createElement("div", { className: "col-3 text-right card-heading d-inline-block my-0" }, this.renderImage(batteryReadActive))), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("div", { className: "col-lg-4 col-xl-4  col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.maintenance && configurationValues.maintenance.reported), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.maintenance && this.formatDate(configurationValues.maintenance.lastReportedAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4  col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.maintenance && configurationValues.maintenance.status === "PENDING" && configurationValues.maintenance.desired), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.maintenance && configurationValues.maintenance.status === "PENDING" && configurationValues.maintenance.desired && this.formatDate(configurationValues.maintenance.lastDesiredAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, _react2.default.createElement("input", {
        className: "inputContainer",
        type: "text",
        placeholder: "",
        onChange: this.onChangeBatteryLevelRead,
        value: this.state.batteryReadInterval
      })))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex justify-content-between align-items-center jr-card-header mb-0" }, _react2.default.createElement("h4", { className: "card-heading d-inline-block" }, " ", "Current sensor read interval (secs)", " "), _react2.default.createElement("div", { className: "col-3 text-right card-heading d-inline-block my-0" }, this.renderImage(currentSensorActive))), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.current && configurationValues.current.reported), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.current && this.formatDate(configurationValues.current.lastReportedAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.current && configurationValues.current.status === "PENDING" && configurationValues.current.desired), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.current && configurationValues.current.status === "PENDING" && configurationValues.current.desired && this.formatDate(configurationValues.current.lastDesiredAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, _react2.default.createElement("input", {
        className: "inputContainer",
        type: "text",
        placeholder: "",
        onChange: this.onChangeCurrentSensorRead,
        value: this.state.currentSensorRead
      })))), _react2.default.createElement("div", { className: "col-12 jr-card-body row my-3" }, _react2.default.createElement("div", { className: "col-12 col-lg-4 d-flex justify-content-between align-items-center0 jr-card-header mb-0" }, _react2.default.createElement("h4", { className: "card-heading d-inline-block" }, " ", "Number of temperature probes", " "), _react2.default.createElement("div", { className: "col-3 text-right card-heading d-inline-block my-0" }, this.renderImage(temperatureProbeActive))), _react2.default.createElement(_reactstrap.CardText, { className: "col-12 col-xl-8 col-lg-12 row d-flex align-items-center" }, _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.probes && configurationValues.probes.reported), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.probes && this.formatDate(configurationValues.probes.lastReportedAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4" }, _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.probes && configurationValues.probes.status === "PENDING" && configurationValues.probes.desired), _react2.default.createElement("h4", { className: "col-12 text-center card-heading d-inline-block my-0" }, configurationValues.probes && configurationValues.probes.status === "PENDING" && configurationValues.probes.desired && this.formatDate(configurationValues.probes.lastDesiredAt))), _react2.default.createElement("div", { className: "col-lg-4 col-xl-4 col-sm-4 text-center card-heading d-inline-block my-0" }, _react2.default.createElement("input", {
        className: "inputContainer",
        type: "text",
        placeholder: "",
        onChange: this.onChangeTemperatureProbes,
        value: this.state.temperatureProbes
      })))))))))));
    }
  }]);

  return Config;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var symbioticReducer = _ref2.symbioticReducer;

  return {
    deviceId: symbioticReducer.deviceId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Config);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Config, "Config", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_moment2, "_moment2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_lodash2, "_lodash2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_searchModal2, "_searchModal2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(Config, "Config", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 634,
	"./af.js": 634,
	"./ar": 635,
	"./ar-dz": 636,
	"./ar-dz.js": 636,
	"./ar-kw": 637,
	"./ar-kw.js": 637,
	"./ar-ly": 638,
	"./ar-ly.js": 638,
	"./ar-ma": 639,
	"./ar-ma.js": 639,
	"./ar-sa": 640,
	"./ar-sa.js": 640,
	"./ar-tn": 641,
	"./ar-tn.js": 641,
	"./ar.js": 635,
	"./az": 642,
	"./az.js": 642,
	"./be": 643,
	"./be.js": 643,
	"./bg": 644,
	"./bg.js": 644,
	"./bm": 645,
	"./bm.js": 645,
	"./bn": 646,
	"./bn-bd": 647,
	"./bn-bd.js": 647,
	"./bn.js": 646,
	"./bo": 648,
	"./bo.js": 648,
	"./br": 649,
	"./br.js": 649,
	"./bs": 650,
	"./bs.js": 650,
	"./ca": 651,
	"./ca.js": 651,
	"./cs": 652,
	"./cs.js": 652,
	"./cv": 653,
	"./cv.js": 653,
	"./cy": 654,
	"./cy.js": 654,
	"./da": 655,
	"./da.js": 655,
	"./de": 656,
	"./de-at": 657,
	"./de-at.js": 657,
	"./de-ch": 658,
	"./de-ch.js": 658,
	"./de.js": 656,
	"./dv": 659,
	"./dv.js": 659,
	"./el": 660,
	"./el.js": 660,
	"./en-au": 661,
	"./en-au.js": 661,
	"./en-ca": 662,
	"./en-ca.js": 662,
	"./en-gb": 663,
	"./en-gb.js": 663,
	"./en-ie": 664,
	"./en-ie.js": 664,
	"./en-il": 665,
	"./en-il.js": 665,
	"./en-in": 666,
	"./en-in.js": 666,
	"./en-nz": 667,
	"./en-nz.js": 667,
	"./en-sg": 668,
	"./en-sg.js": 668,
	"./eo": 669,
	"./eo.js": 669,
	"./es": 670,
	"./es-do": 671,
	"./es-do.js": 671,
	"./es-mx": 672,
	"./es-mx.js": 672,
	"./es-us": 673,
	"./es-us.js": 673,
	"./es.js": 670,
	"./et": 674,
	"./et.js": 674,
	"./eu": 675,
	"./eu.js": 675,
	"./fa": 676,
	"./fa.js": 676,
	"./fi": 677,
	"./fi.js": 677,
	"./fil": 678,
	"./fil.js": 678,
	"./fo": 679,
	"./fo.js": 679,
	"./fr": 680,
	"./fr-ca": 681,
	"./fr-ca.js": 681,
	"./fr-ch": 682,
	"./fr-ch.js": 682,
	"./fr.js": 680,
	"./fy": 683,
	"./fy.js": 683,
	"./ga": 684,
	"./ga.js": 684,
	"./gd": 685,
	"./gd.js": 685,
	"./gl": 686,
	"./gl.js": 686,
	"./gom-deva": 687,
	"./gom-deva.js": 687,
	"./gom-latn": 688,
	"./gom-latn.js": 688,
	"./gu": 689,
	"./gu.js": 689,
	"./he": 690,
	"./he.js": 690,
	"./hi": 691,
	"./hi.js": 691,
	"./hr": 692,
	"./hr.js": 692,
	"./hu": 693,
	"./hu.js": 693,
	"./hy-am": 694,
	"./hy-am.js": 694,
	"./id": 695,
	"./id.js": 695,
	"./is": 696,
	"./is.js": 696,
	"./it": 697,
	"./it-ch": 698,
	"./it-ch.js": 698,
	"./it.js": 697,
	"./ja": 699,
	"./ja.js": 699,
	"./jv": 700,
	"./jv.js": 700,
	"./ka": 701,
	"./ka.js": 701,
	"./kk": 702,
	"./kk.js": 702,
	"./km": 703,
	"./km.js": 703,
	"./kn": 704,
	"./kn.js": 704,
	"./ko": 705,
	"./ko.js": 705,
	"./ku": 706,
	"./ku.js": 706,
	"./ky": 707,
	"./ky.js": 707,
	"./lb": 708,
	"./lb.js": 708,
	"./lo": 709,
	"./lo.js": 709,
	"./lt": 710,
	"./lt.js": 710,
	"./lv": 711,
	"./lv.js": 711,
	"./me": 712,
	"./me.js": 712,
	"./mi": 713,
	"./mi.js": 713,
	"./mk": 714,
	"./mk.js": 714,
	"./ml": 715,
	"./ml.js": 715,
	"./mn": 716,
	"./mn.js": 716,
	"./mr": 717,
	"./mr.js": 717,
	"./ms": 718,
	"./ms-my": 719,
	"./ms-my.js": 719,
	"./ms.js": 718,
	"./mt": 720,
	"./mt.js": 720,
	"./my": 721,
	"./my.js": 721,
	"./nb": 722,
	"./nb.js": 722,
	"./ne": 723,
	"./ne.js": 723,
	"./nl": 724,
	"./nl-be": 725,
	"./nl-be.js": 725,
	"./nl.js": 724,
	"./nn": 726,
	"./nn.js": 726,
	"./oc-lnc": 727,
	"./oc-lnc.js": 727,
	"./pa-in": 728,
	"./pa-in.js": 728,
	"./pl": 729,
	"./pl.js": 729,
	"./pt": 730,
	"./pt-br": 731,
	"./pt-br.js": 731,
	"./pt.js": 730,
	"./ro": 732,
	"./ro.js": 732,
	"./ru": 733,
	"./ru.js": 733,
	"./sd": 734,
	"./sd.js": 734,
	"./se": 735,
	"./se.js": 735,
	"./si": 736,
	"./si.js": 736,
	"./sk": 737,
	"./sk.js": 737,
	"./sl": 738,
	"./sl.js": 738,
	"./sq": 739,
	"./sq.js": 739,
	"./sr": 740,
	"./sr-cyrl": 741,
	"./sr-cyrl.js": 741,
	"./sr.js": 740,
	"./ss": 742,
	"./ss.js": 742,
	"./sv": 743,
	"./sv.js": 743,
	"./sw": 744,
	"./sw.js": 744,
	"./ta": 745,
	"./ta.js": 745,
	"./te": 746,
	"./te.js": 746,
	"./tet": 747,
	"./tet.js": 747,
	"./tg": 748,
	"./tg.js": 748,
	"./th": 749,
	"./th.js": 749,
	"./tk": 750,
	"./tk.js": 750,
	"./tl-ph": 751,
	"./tl-ph.js": 751,
	"./tlh": 752,
	"./tlh.js": 752,
	"./tr": 753,
	"./tr.js": 753,
	"./tzl": 754,
	"./tzl.js": 754,
	"./tzm": 755,
	"./tzm-latn": 756,
	"./tzm-latn.js": 756,
	"./tzm.js": 755,
	"./ug-cn": 757,
	"./ug-cn.js": 757,
	"./uk": 758,
	"./uk.js": 758,
	"./ur": 759,
	"./ur.js": 759,
	"./uz": 760,
	"./uz-latn": 761,
	"./uz-latn.js": 761,
	"./uz.js": 760,
	"./vi": 762,
	"./vi.js": 762,
	"./x-pseudo": 763,
	"./x-pseudo.js": 763,
	"./yo": 764,
	"./yo.js": 764,
	"./zh-cn": 765,
	"./zh-cn.js": 765,
	"./zh-hk": 766,
	"./zh-hk.js": 766,
	"./zh-mo": 767,
	"./zh-mo.js": 767,
	"./zh-tw": 768,
	"./zh-tw.js": 768
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1664;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import SearchFilter from "./SearchFilter";


// import SearchBox from "../../components/SearchBox/index";

var SearchModal = function (_Component) {
  _inherits(SearchModal, _Component);

  function SearchModal(props) {
    _classCallCheck(this, SearchModal);

    var _this = _possibleConstructorReturn(this, (SearchModal.__proto__ || Object.getPrototypeOf(SearchModal)).call(this, props));

    _this.render = function () {
      return _react2.default.createElement("div", {
        className: "modal fade",
        id: "searchModalComponent",
        style: { top: "25%" }
      }, _react2.default.createElement("div", { className: "modal-dialog modal-lg" }, _react2.default.createElement("div", { className: "modal-content" }, _react2.default.createElement("div", { className: "modal-header py-2 border-0" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "col-9" }, _react2.default.createElement("h4", { className: "modal-title" }, "Search Results")), _react2.default.createElement("div", { className: "col-3" }, _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "d-flex align-items-center justify-content-end col-6" }, _react2.default.createElement("h5", { className: "mb-0 pl-2" })), _react2.default.createElement("div", { className: "d-flex align-items-center col-6 justify-content-end" }, _react2.default.createElement("button", {
        type: "button",
        className: "close",
        "data-dismiss": "modal"
      }, _react2.default.createElement("h6", { className: "input-for-search" }, "\xD7"), _react2.default.createElement("h4", { className: "pl-1 modal-title" }, "Close")))))))), _react2.default.createElement("div", { className: "modal-body" }, _react2.default.createElement("div", { className: "d-flex" }, _react2.default.createElement("div", { className: "col-8" }, _react2.default.createElement(_SearchBox2.default, {
        onChange: function onChange(text) {
          _this.props.onChangeText(text);
        },
        value: _this.props.searchText,
        onKeyPress: function onKeyPress(e) {
          if (e.key === "Enter") {
            _this.props.searchDevices();
          }
        },
        onButtonClick: function onButtonClick() {
          _this.props.searchDevices();
        }
      }), " "), _react2.default.createElement("div", { className: "col-4 d-flex justify-content-end align-items-center" })), _react2.default.createElement("div", {
        className: "slimScrollDiv",
        style: {
          position: "relative",
          overflow: "overlay",
          width: "auto",
          height: "100%"
        }
      }, _react2.default.createElement("div", { className: "inner-height" }, _this.props.data.length > 0 ? _react2.default.createElement("table", { className: "table search-table mt-3 table-bordered" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "ID"), _react2.default.createElement("th", null, "Select device"))), _react2.default.createElement("tbody", null, _this.props.data.length > 0 && _this.props.data.map(function (item, index) {
        var filter = _this.props.selected;
        var isExist = filter.findIndex(function (data) {
          return data === item;
        });
        var selected = isExist !== -1;
        return _react2.default.createElement("tr", { key: index }, _react2.default.createElement("td", null, item), _react2.default.createElement("td", null, _react2.default.createElement("input", {
          onChange: function onChange() {
            _this.props.selectDevice(item);
          },
          checked: selected,
          type: "checkbox",
          id: "",
          name: "",
          value: ""
        })));
      }))) : _react2.default.createElement("h3", null, "No results to display"))), _this.state.showMoreDevices))));
    };

    _this.state = {};
    return _this;
  }

  return SearchModal;
}(_react.Component);

var _default = SearchModal;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchModal, "SearchModal", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(SearchModal, "SearchModal", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/configuration/searchModal.js");
}();

;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CircularIndeterminate = __webpack_require__(386);

var _util = __webpack_require__(77);

var _reactRouterDom = __webpack_require__(39);

var _awsManager = __webpack_require__(59);

var _userManager = __webpack_require__(117);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

var _reactRedux = __webpack_require__(30);

var _reactNotifications = __webpack_require__(78);

var _highlightSidebarOption = __webpack_require__(140);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.activeNotifications = [];
        _this.closedNotifications = [];
        _this.pageNumberClosed = 1;
        _this.pageNumberActive = 1;

        _this.toggleSMSCheckbox = function () {
            _this.setState({
                isSMSChecked: !_this.state.isSMSChecked
            }, function () {
                _this.updateAttribute([{
                    Name: 'custom:smsNotification',
                    Value: _this.state.isSMSChecked.toString()
                }]);
            });
        };

        _this.setSMSCheckboxValueInBoolean = function () {
            if (_this.state.isSMSChecked === 'true') {
                _this.setState({
                    isSMSChecked: true
                });
            } else if (_this.state.isSMSChecked === 'false') {
                _this.setState({
                    isSMSChecked: false
                });
            }
        };

        _this.updateAttribute = function (attibuteList) {
            (0, _userManager.updateUserAttributes)(attibuteList).then(function () {
                var data = _this.props.userAttributes;
                if (attibuteList[0].Name === 'custom:smsNotification') {
                    (0, _util.createNotification)('Update successful.', 'Success', 'Success');
                    data['custom:smsNotification'] = _this.state.isSMSChecked;
                    _this.props.smsNotification(_this.state.isSMSChecked);
                    // this.props.profileDetailsUpdate(data);
                }
            }, function (error) {
                (0, _util.createNotification)(error.message, 'Error', 'Error');
            });
        };

        _this.requestActiveNotificationsWrapper = function (pageNumberActive) {
            var deviceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.deviceId;

            var self = _this;

            (0, _awsManager.getNotifications)(pageNumberActive, deviceId).then(function (data) {
                _this.populateActiveNotificationsJSX(data.open);
                self.setState({
                    partialLoaderStateActiveNotificationsData: false
                });
                // this.populateClosedNotificationsJSX(data);
            }, function () {
                self.setState({
                    partialLoaderStateActiveNotificationsData: false
                });
            });
        };

        _this.requestClosedNotificationsWrapper = function (pageNumberClosed) {
            var deviceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.deviceId;

            var self = _this;

            (0, _awsManager.getNotifications)(pageNumberClosed, deviceId).then(function (data) {

                console.log("Closed notifications", data.closed);

                _this.populateClosedNotificationsJSX(data.closed);
                self.setState({
                    partialLoaderStateClosedNotificationsData: false
                });
                // this.populateClosedNotificationsJSX(data);
            }, function () {

                self.setState({
                    partialLoaderStateClosedNotificationsData: false
                });
            });
        };

        _this.populateActiveNotificationsJSX = function (data) {
            var buttonValue = '';
            if (data) {
                // if (data.Items.length != data.Count) {
                //     this.pageNumberActive = this.pageNumberActive + 1;
                //     buttonValue = (<button
                //         className="btn-showMore"
                //         onClick={() => {
                //             this.onActiveNotificationsShowMoreClick(this.pageNumberActive);
                //         }}
                //     >Show More...</button>);
                // }

                data.forEach(function (item) {
                    _this.activeNotifications.push(item);
                });
            }
            if (!_this.state.activeNotifications.length) {
                _this.setState({
                    activeResults: 'No results to display'
                });
            }
            var activeNotificationsJSX = _this.activeNotifications.map(function (el) {
                return _this.returnJSXRow(el);
            });

            _this.setState({
                loadStatusActiveTable: '',
                showRefreshButtonActive: true,
                refreshActiveTable: '',
                activeNotificationsJSX: activeNotificationsJSX,
                showMoreActiveNotifications: buttonValue,
                activeNotifications: _this.activeNotifications
            });
        };

        _this.onActiveNotificationsShowMoreClick = function (pageNumberActive) {
            _this.setState({
                loadStatusActiveTable: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate, null)),
                showMoreActiveNotifications: ''
            });

            if (pageNumberActive) {
                _this.requestActiveNotificationsWrapper(pageNumberActive);
            }
        };

        _this.onClosedNotificationsShowMoreClick = function (pageNumberClosed) {
            _this.setState({
                loadStatusCloseTable: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate, null)),
                showMoreClosedNotifications: ''
            });

            if (pageNumberClosed) {
                _this.requestClosedNotificationsWrapper(pageNumberClosed);
            }
        };

        _this.populateClosedNotificationsJSX = function (data) {
            var buttonValue = null;
            if (data) {
                // if (data.Items.length != data.Count) {
                //     this.pageNumberClosed = this.pageNumberClosed + 1;
                //     buttonValue = (<button
                //         className="btn-showMore"
                //         onClick={() => {
                //             this.onClosedNotificationsShowMoreClick(this.pageNumberClosed);
                //         }}
                //     >Show More...</button>);
                // }

                data.forEach(function (item) {
                    _this.closedNotifications.push(item);
                });
            }
            if (!_this.state.closedNotifications.length) {
                _this.setState({
                    closedResults: 'No results to display'
                });
            }
            var closedNotificationsJSX = _this.closedNotifications.map(function (el) {
                return _this.returnJSXRowClosed(el);
            });

            _this.setState({
                loadStatusCloseTable: '',
                showRefressButtonClose: true,
                refreshCloseTable: '',
                closedNotificationsJSX: closedNotificationsJSX,
                showMoreClosedNotifications: buttonValue,
                closedNotifications: _this.closedNotifications
            });
        };

        _this.returnJSXRowClosed = function (el) {
            return _react2.default.createElement('tr', { key: el.time }, _react2.default.createElement('td', null, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'd-flex justify-content-center align-items-center' }, _react2.default.createElement('div', { className: 'col-4' }, _react2.default.createElement('img', { src: (0, _util.getImageSourceFromType)(el.event) })), _react2.default.createElement('div', { className: 'col-8' }, _react2.default.createElement('span', null, el.event))))), _react2.default.createElement('td', null, (0, _util.getFormattedDate)(el.time, false)), _react2.default.createElement('td', null, _react2.default.createElement('p', null, _react2.default.createElement(_reactRouterDom.Link, { to: '/app/components/heartbeat', onClick: function onClick() {
                    (0, _highlightSidebarOption.highlightNavigatedMenu)('heartbeat', _this.oldPath);
                } }, _react2.default.createElement('span', null, 'Click to view pit.')))), _react2.default.createElement('td', null, el.val, (0, _util.getUnitFromType)(el.event)), _react2.default.createElement('td', null, _react2.default.createElement('u', null, 'Cleared Manually')));
        };

        _this.returnJSXRow = function (el) {

            return _react2.default.createElement('tr', { key: el.time, className: el.time === _this.props.notificationPageTimestampOfElementToHighlight ? "selectedNotification" : "" }, _react2.default.createElement('td', null, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'd-flex justify-content-center align-items-center' }, _react2.default.createElement('div', { className: 'col-4' }, _react2.default.createElement('img', { src: (0, _util.getImageSourceFromType)(el.event) })), _react2.default.createElement('div', { className: 'col-8' }, _react2.default.createElement('span', null, el.event))))), _react2.default.createElement('td', null, (0, _util.getFormattedDate)(el.time, false)), _react2.default.createElement('td', null, _react2.default.createElement('p', null, _react2.default.createElement(_reactRouterDom.Link, { to: '/app/components/heartbeat' }, _react2.default.createElement('span', null, 'Click to view pit.')))), _react2.default.createElement('td', null, el.val, (0, _util.getUnitFromType)(el.event)), _react2.default.createElement('td', { className: 'manual-clear-hover',
                onClick: function onClick() {
                    _this.onManualClearClick(_this.props.deviceId, el.time);
                }
            }, _react2.default.createElement('u', null, 'Manual Clear')));
        };

        _this.onManualClearClick = function (deviceId, notificationTimestamp) {
            (0, _awsManager.closeNotification)(notificationTimestamp, deviceId).then(function () {
                (0, _util.createNotification)('Manual clear successful', 'Success', 'Success');
                _this.props.manualClearClicked(deviceId, notificationTimestamp);
                _this.pageNumberActive = 1;
                _this.pageNumberClosed = 1;
                _this.activeNotifications = [];
                _this.closedNotifications = [];

                _this.requestActiveNotificationsWrapper(_this.pageNumberActive);
                _this.requestClosedNotificationsWrapper(_this.pageNumberClosed);
            }).catch(function () {
                (0, _util.createNotification)('Manual clear error. Please try again', 'Error', 'Error');
            });
        };

        _this.spatialDepthThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdSpatialValue: evt.target.value });
            }
        };

        _this.waterTimeThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdWaterTime: evt.target.value });
            }
        };

        _this.gasLeakageThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdGasValue: evt.target.value });
            }
        };

        _this.gasTimeThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdGasTime: evt.target.value });
            }
        };

        _this.powerLeakageThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdPowerValue: evt.target.value });
            }
        };

        _this.powerVoltThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdPowerVolt: evt.target.value });
            }
        };

        _this.intrusionThresholdChange = function (evt) {
            if (!isNaN(evt.target.value)) {
                _this.setState({ thresholdIntrusionValue: evt.target.value });
            }
        };

        _this.onUpdateClick = function () {
            _this.setState({
                showUpdateButton: false,
                loadStatusUpdateThreshold: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate2, null))
            });

            var updatedThresholds = {
                thresholdGasTime: _this.state.thresholdGasTime,
                thresholdGasValue: _this.state.thresholdGasValue,
                thresholdIntrusionValue: _this.state.thresholdIntrusionValue,
                thresholdPowerValue: _this.state.thresholdPowerValue,
                thresholdPowerVolt: _this.state.thresholdPowerVolt,
                thresholdSpatialValue: _this.state.thresholdSpatialValue,
                thresholdWaterTime: _this.state.thresholdWaterTime
            };

            (0, _awsManager.updateThresholdsData)(_this.props.deviceId, updatedThresholds).then(function () {
                (0, _util.createNotification)('Update Successful', 'Done', 'Success');
                _this.props.updateThresholds([updatedThresholds]);
                _this.setState({ showUpdateButton: true, loadStatusUpdateThreshold: '' });
            }).catch(function (error) {
                (0, _util.createNotification)(error.message, 'Error', 'Error');
                _this.setState({ showUpdateButton: true });
            });
        };

        _this.refreshActiveNotifications = function () {
            _this.setState({
                showRefreshButtonActive: false,
                refreshActiveTable: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate2, null)),
                activeResults: ''
            });
            _this.activeNotifications = [];
            _this.pageNumberActive = 1;
            _this.requestActiveNotificationsWrapper(_this.pageNumberActive);
        };

        _this.refreshClosedNotifications = function () {
            _this.setState({
                showRefressButtonClose: false,
                refreshCloseTable: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate2, null)),
                closedResults: ''
            });
            _this.closedNotifications = [];
            _this.pageNumberClosed = 1;
            _this.requestClosedNotificationsWrapper(_this.pageNumberClosed);
        };

        _this.dispatchActionToHideLoader = function () {
            if (!_this.state.partialLoaderStateActiveNotificationsData && !_this.state.partialLoaderStateClosedNotificationsData) {
                _this.props.hideLoader();
            }
        };

        _this.state = {
            isSMSChecked: _this.props.isSMSNotificationChecked,
            setToAllDevices: false,
            activeNotificationsJSX: null,
            closedNotificationsJSX: null,
            showMoreActiveNotifications: null,
            showMoreClosedNotifications: null,
            thresholdSpatialValue: _this.props.thresholds.thresholdSpatialValue,
            thresholdPowerValue: _this.props.thresholds.thresholdPowerValue,
            thresholdGasValue: _this.props.thresholds.thresholdGasValue,
            thresholdWaterTime: _this.props.thresholds.thresholdWaterTime,
            thresholdGasTime: _this.props.thresholds.thresholdGasTime,
            thresholdPowerVolt: _this.props.thresholds.thresholdPowerVolt,
            thresholdIntrusionValue: _this.props.thresholds.thresholdIntrusionValue,
            showUpdateButton: true,
            showRefreshButtonActive: true,
            showRefressButtonClose: true,
            loadStatusActiveTable: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate, null)),
            loadStatusCloseTable: _react2.default.createElement('div', { className: 'forCenter' }, _react2.default.createElement(_CircularIndeterminate.CircularIndeterminate, null)),
            loadStatusUpdateThreshold: '',
            refreshActiveTable: '',
            refreshCloseTable: '',
            activeNotifications: [],
            closedNotifications: [],
            activeResults: '',
            closedResults: '',

            // Setting initial values for partial loader state for active notifications data
            // and closed notifications data
            partialLoaderStateActiveNotificationsData: true,
            partialLoaderStateClosedNotificationsData: true,

            hasPageRenderedOnce: false
        };

        _this.updateAttribute.bind(_this);
        _this.onManualClearClick.bind(_this);
        _this.onActiveNotificationsShowMoreClick.bind(_this);
        _this.onClosedNotificationsShowMoreClick.bind(_this);

        _this.spatialDepthThresholdChange.bind(_this);
        _this.waterTimeThresholdChange.bind(_this);
        _this.gasLeakageThresholdChange.bind(_this);
        _this.gasTimeThresholdChange.bind(_this);
        _this.powerLeakageThresholdChange.bind(_this);
        _this.powerVoltThresholdChange.bind(_this);
        _this.intrusionThresholdChange.bind(_this);
        return _this;
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.requestActiveNotificationsWrapper(this.pageNumberActive);
            this.requestClosedNotificationsWrapper(this.pageNumberClosed);
            var history = this.props.history;

            this.setSMSCheckboxValueInBoolean();
            this.oldPath = '#' + history.location.pathname;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.removeActiveNotificationTimestampFromProps(this.props.deviceId);
        }
    }, {
        key: 'handleProcessLoadedActiveTable',
        value: function handleProcessLoadedActiveTable() {
            this.setState({ loadStatusActiveTable: '' });
        }
    }, {
        key: 'handleProcessLoadedClosedTable',
        value: function handleProcessLoadedClosedTable() {
            this.setState({ loadStatusCloseTable: '' });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.deviceId !== this.props.deviceId || nextProps.notificationPageTimestampOfElementToHighlight !== this.props.notificationPageTimestampOfElementToHighlight) {
                this.activeNotifications = [];
                this.closedNotifications = [];
                this.pageNumberClosed = 1;
                this.pageNumberActive = 1;
                this.requestActiveNotificationsWrapper(this.pageNumberActive, nextProps.deviceId);
                this.requestClosedNotificationsWrapper(this.pageNumberClosed, nextProps.deviceId);
            }

            if (nextProps.isSMSChecked !== this.state.isSMSChecked) {
                this.setState({
                    isSMSChecked: nextProps.isSMSNotificationChecked
                });
            }

            if (!Object.is(nextProps, this.props)) {
                this.setState({
                    thresholdSpatialValue: nextProps.thresholds.thresholdSpatialValue,
                    thresholdPowerValue: nextProps.thresholds.thresholdPowerValue,
                    thresholdGasValue: nextProps.thresholds.thresholdGasValue,
                    thresholdWaterTime: nextProps.thresholds.thresholdWaterTime,
                    thresholdGasTime: nextProps.thresholds.thresholdGasTime,
                    thresholdPowerVolt: nextProps.thresholds.thresholdPowerVolt,
                    thresholdIntrusionValue: nextProps.thresholds.thresholdIntrusionValue,
                    activeNotifications: this.activeNotifications,
                    closedNotifications: this.closedNotifications
                });
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.showLoader();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.dispatchActionToHideLoader();

            return _react2.default.createElement('div', { className: 'notifications-page' }, _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'page-heading d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Notifications'), 'Device ID: ', this.props.deviceId)), _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 ' }, _react2.default.createElement('div', { className: 'jr-card activeNotification-wrapper' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Active Notifications'), this.state.refreshActiveTable, this.state.showRefreshButtonActive ? _react2.default.createElement('button', {
                onClick: function onClick() {
                    _this2.refreshActiveNotifications();
                },
                className: 'float-right btn-refresh'
            }, _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true' })) : ''), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'table-responsive' }, this.state.activeNotifications.length ? _react2.default.createElement('table', { className: 'table table-bordered mb-0' }, _react2.default.createElement('thead', { className: 'background-color-blue' }, _react2.default.createElement('tr', null, _react2.default.createElement('th', { scope: 'col' }, 'Type'), _react2.default.createElement('th', { scope: 'col' }, 'Date'), _react2.default.createElement('th', { scope: 'col' }, 'Description'), _react2.default.createElement('th', { scope: 'col' }, 'Measured Value'), _react2.default.createElement('th', { scope: 'col' }, 'Action'))), _react2.default.createElement('tbody', { onLoad: this.handleProcessLoadedActiveTable.bind(this) }, this.state.activeNotificationsJSX)) : _react2.default.createElement('h3', null, this.state.activeResults), _react2.default.createElement('br', null)), this.state.loadStatusActiveTable, this.state.showMoreActiveNotifications)), _react2.default.createElement('div', { className: 'jr-card clearedNotification-wrapper' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Notification History'), this.state.refreshCloseTable, this.state.showRefressButtonClose ? _react2.default.createElement('button', {
                onClick: function onClick() {
                    _this2.refreshClosedNotifications();
                },
                className: 'float-right btn-refresh'
            }, _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true' })) : ''), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'table-responsive' }, this.state.closedNotifications.length ? _react2.default.createElement('table', { className: 'table table-bordered mb-0' }, _react2.default.createElement('thead', { className: 'background-color-blue' }, _react2.default.createElement('tr', null, _react2.default.createElement('th', { scope: 'col' }, 'Type'), _react2.default.createElement('th', { scope: 'col' }, 'Date'), _react2.default.createElement('th', { scope: 'col' }, 'Description'), _react2.default.createElement('th', { scope: 'col' }, 'Measured Value'), _react2.default.createElement('th', { scope: 'col' }, 'Action'))), _react2.default.createElement('tbody', { onLoad: this.handleProcessLoadedClosedTable.bind(this) }, this.state.closedNotificationsJSX)) : _react2.default.createElement('h3', null, this.state.closedResults), _react2.default.createElement('br', null)), this.state.loadStatusCloseTable, this.state.showMoreClosedNotifications))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4' }, _react2.default.createElement('div', { className: 'jr-card descriptionNotification-wrapper' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Rules & Thresholds')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'table-responsive' }, _react2.default.createElement('table', { className: 'table table-bordered mb-0' }, _react2.default.createElement('thead', { className: 'background-color-blue' }, _react2.default.createElement('tr', null, _react2.default.createElement('th', { className: 'text-center', colSpan: '2' }, _react2.default.createElement('span', null, _react2.default.createElement('strong', null, 'Notification')), _react2.default.createElement('span', { className: 'ml-2' }, 'Description')))), _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', { className: 'text-center vertical-align-middle' }, _react2.default.createElement('div', null, 'Assurance', _react2.default.createElement('br', null), _react2.default.createElement('img', { className: 'pt-2',
                src: '../../../../assets/images/water-droplet.png' }))), _react2.default.createElement('td', null, _react2.default.createElement('strong', null, _react2.default.createElement('p', null, 'Water Flooding')), _react2.default.createElement('span', null, 'Trigger notification when the spatial depth in the pit reduces below'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdSpatialValue,
                onChange: function onChange(e) {
                    _this2.spatialDepthThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'cm,'), _react2.default.createElement('span', { className: 'ml-1' }, 'within'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdWaterTime,
                onChange: function onChange(e) {
                    _this2.waterTimeThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'minutes.'))), _react2.default.createElement('tr', null, _react2.default.createElement('td', { className: 'text-center vertical-align-middle' }, _react2.default.createElement('div', null, 'HSE', _react2.default.createElement('br', null), _react2.default.createElement('img', { className: 'pt-2', src: '../../../../assets/images/fire.png' }))), _react2.default.createElement('td', null, _react2.default.createElement('strong', null, _react2.default.createElement('p', null, 'Gas Leakage')), _react2.default.createElement('span', null, 'Trigger notification when the air quality in the pit reduces below'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdGasValue,
                onChange: function onChange(e) {
                    _this2.gasLeakageThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'g/m', _react2.default.createElement('sup', null, '3'), ','), _react2.default.createElement('span', { className: 'ml-1' }, 'within'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdGasTime,
                onChange: function onChange(e) {
                    _this2.gasTimeThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'minutes.'))), _react2.default.createElement('tr', null, _react2.default.createElement('td', { className: 'text-center vertical-align-middle' }, _react2.default.createElement('div', null, 'HSE', _react2.default.createElement('br', null), _react2.default.createElement('img', { className: 'pt-2', src: '../../../../assets/images/power.png' }))), _react2.default.createElement('td', null, _react2.default.createElement('strong', null, _react2.default.createElement('p', null, 'Power Leakage')), _react2.default.createElement('span', null, 'Trigger notification when the current measurement in the pit exceeds'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdPowerValue,
                onChange: function onChange(e) {
                    _this2.powerLeakageThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'mA,'), _react2.default.createElement('span', { className: 'ml-1' }, 'or the voltage measurement exceeds'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdPowerVolt,
                onChange: function onChange(e) {
                    _this2.powerVoltThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'V'))), _react2.default.createElement('tr', null, _react2.default.createElement('td', { className: 'text-center vertical-align-middle' }, _react2.default.createElement('div', null, 'Security', _react2.default.createElement('br', null), _react2.default.createElement('img', { className: 'pt-2', src: '../../../../assets/images/lock.png' }))), _react2.default.createElement('td', null, _react2.default.createElement('strong', null, _react2.default.createElement('p', null, 'Intrusion Detected')), _react2.default.createElement('span', null, 'Trigger notification when the accelerometer Z-axis moves by more than'), _react2.default.createElement('input', {
                className: 'mx-1',
                value: this.state.thresholdIntrusionValue,
                onChange: function onChange(e) {
                    _this2.intrusionThresholdChange(e);
                }
            }), _react2.default.createElement('span', null, 'degrees'))))))), _react2.default.createElement('div', null, _react2.default.createElement('input', { type: 'checkbox',
                checked: this.state.isSMSChecked,
                onChange: this.toggleSMSCheckbox }), _react2.default.createElement('span', { className: 'ml-2' }, 'Send SMS Notification when triggered')), _react2.default.createElement('div', null, _react2.default.createElement('input', { type: 'checkbox' }), _react2.default.createElement('span', { className: 'ml-2' }, 'Apply to All Devices')), this.state.loadStatusUpdateThreshold, this.state.showUpdateButton ? _react2.default.createElement('button', { onClick: this.onUpdateClick, className: 'mt-2 btn-showMore' }, 'Update Thresholds') : '', _react2.default.createElement(_reactNotifications.NotificationContainer, null))))));
        }
    }]);

    return App;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var symbioticReducer = _ref.symbioticReducer,
        profileInfo = _ref.profileInfo;

    return {
        deviceId: symbioticReducer.deviceId,
        thresholds: symbioticReducer.thresholds,
        isSMSNotificationChecked: profileInfo.smsNotification,
        userAttributes: profileInfo.userAttributes,
        notificationPageTimestampOfElementToHighlight: symbioticReducer.notificationPageTimestampOfElementToHighlight
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        smsNotification: function smsNotification(isSMSChecked) {
            dispatch({ type: 'UPDATE_SMS_NOTIFICATION', isSMSNotificationChecked: isSMSChecked });
        },
        showLoader: function showLoader() {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: function hideLoader() {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        },
        manualClearClicked: function manualClearClicked(id, ts) {
            dispatch({ type: 'MANUAL_CLEAR_CLICKED', notificationDeviceId: id, notificationTimestamp: ts });
        },
        removeActiveNotificationTimestampFromProps: function removeActiveNotificationTimestampFromProps(deviceId) {
            dispatch({ type: 'UPDATE_DEVICE_ID_AND_TIMESTAMP', deviceId: deviceId, notificationPageTimestampOfElementToHighlight: null });
        },
        updateThresholds: function updateThresholds(data) {
            if (data && data[0]) {
                dispatch({ type: 'UPDATE_THRESHOLDS', data: data });
            }
        }
    };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(App, 'App', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/notifications/index.js");
}();

;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIZE = 50;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1);
  // https://gist.github.com/gre/1650294
  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    svg: {},
    svgIndeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
    },
    circle: {
      stroke: 'currentColor',
      strokeLinecap: 'round'
    },
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-120px'
      }
    }
  };
};

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
function CircularProgress(props) {
  var _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      max = props.max,
      min = props.min,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'max', 'min', 'size', 'style', 'thickness', 'value', 'variant']);


  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var relVal = getRelativeValue(value, min, max) * 100;
    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(relVal);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = ((100 - relVal) / 100 * circumference).toFixed(3) + 'px';
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = (easeIn((100 - relVal) / 100) * circumference).toFixed(3) + 'px';
      rootStyle.transform = 'rotate(' + (easeOut(relVal / 70) * 270).toFixed(3) + 'deg)';
    }
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), className),
      style: (0, _extends3.default)({ width: size, height: size }, rootStyle, style),
      role: 'progressbar'
    }, rootProps, other),
    _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(classes.svg, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.svgIndeterminate, variant === 'indeterminate'), (0, _defineProperty3.default)(_classNames2, classes.svgStatic, variant === 'static'), _classNames2)),
        viewBox: '0 0 ' + SIZE + ' ' + SIZE
      },
      _react2.default.createElement('circle', {
        className: (0, _classnames2.default)(classes.circle, (0, _defineProperty3.default)({}, classes.circleIndeterminate, variant === 'indeterminate')),
        style: circleStyle,
        cx: SIZE / 2,
        cy: SIZE / 2,
        r: SIZE / 2 - 5,
        fill: 'none',
        strokeWidth: thickness
      })
    )
  );
}

CircularProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary', 'inherit']),
  /**
   * The max value of progress in determinate variant.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress in determinate variant.
   */
  min: _propTypes2.default.number,
  /**
   * The size of the circle.
   */
  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * The thickness of the circle.
   */
  thickness: _propTypes2.default.number,
  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The variant of progress indicator. Use indeterminate
   * when there is no progress value.
   */
  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'static'])
} : {};

CircularProgress.defaultProps = {
  color: 'primary',
  max: 100,
  min: 0,
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCircularProgress', flip: false })(CircularProgress);

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSITION_DURATION = 4; // 400ms

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },
    buffer: {
      backgroundColor: 'transparent'
    },
    query: {
      transform: 'rotate(180deg)'
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },
    dashedColorPrimary: {
      backgroundImage: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    dashedColorSecondary: {
      backgroundImage: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6) + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    bar1Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    bar2Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },
    bar1Determinate: {
      willChange: 'transform',
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    bar1Buffer: {
      zIndex: 1,
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    bar2Buffer: {
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'value', 'valueBuffer', 'variant']);


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty3.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames2.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames2.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty3.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty3.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty3.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames2.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty3.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = { bar1: {}, bar2: {} };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = 'scaleX(' + value / 100 + ')';
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = 'scaleX(' + (valueBuffer || 0) / 100 + ')';
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className, role: 'progressbar' }, rootProps, other),
    variant === 'buffer' ? _react2.default.createElement('div', { className: dashedClass }) : null,
    _react2.default.createElement('div', { className: bar1ClassName, style: inlineStyles.bar1 }),
    variant === 'determinate' ? null : _react2.default.createElement('div', { className: bar2ClassName, style: inlineStyles.bar2 })
  );
}

LinearProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes2.default.number,
  /**
   * The variant of progress indicator. Use indeterminate or query
   * when there is no progress value.
   */
  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};

LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiLinearProgress' })(LinearProgress);

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _awsManager = __webpack_require__(59);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactstrap = __webpack_require__(92);

var _filterModal = __webpack_require__(387);

var _filterModal2 = _interopRequireDefault(_filterModal);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(30);

var _lodash = __webpack_require__(165);

var _lodash2 = _interopRequireDefault(_lodash);

var _highlightSidebarOption = __webpack_require__(140);

var _EnhancedTable = __webpack_require__(1766);

var _EnhancedTable2 = _interopRequireDefault(_EnhancedTable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var NodeVitals = function (_Component) {
  _inherits(NodeVitals, _Component);

  function NodeVitals(props) {
    _classCallCheck(this, NodeVitals);

    var _this = _possibleConstructorReturn(this, (NodeVitals.__proto__ || Object.getPrototypeOf(NodeVitals)).call(this, props));

    _this.state = {
      // nodeVitalsData: []
      filterData: []
    };
    return _this;
  }

  _createClass(NodeVitals, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _awsManager.getNodeVitals)().then(function (data) {
        _this2.props.updateNodeVitalsData({ data: data, pageNumber: _this2.props.nodeVitalsData.pageNumber });
        _this2.props.updateNodeVitalsFilterData({ data: data, pageNumber: _this2.props.nodeVitalsData.pageNumber });
        // this.setState({
        //   nodeVitalsData: data
        // })
      }).catch(function (error) {
        console.log('error: ', error);
      });
      this.currentPath = this.props.location.pathname;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      this.unlisten = this.props.history.listen(function (location) {
        _this3.currentPath = location.pathname;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement("div", { className: "row configuration-page" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "jr-card d-sm-flex justify-content-sm-between align-items-sm-center" }, _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-10" }, _react2.default.createElement("h1", { className: "mb-0" }, "Device Vitals")), _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-2" }))), _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement(_filterModal2.default, {
        filter: [],
        data: this.state.filterData, setFilteredData: function setFilteredData(data) {
          _this4.props.updateNodeVitalsFilterData({ data: data, pageNumber: 0 });
        } }), _react2.default.createElement("div", { className: "row" }, _react2.default.createElement(_EnhancedTable2.default, {
        passDataForFilter: function passDataForFilter(item) {
          _this4.setState({
            filterData: item
          });
        },
        updateDeviceId: function updateDeviceId(deviceId) {
          _this4.props.updateDeviceId(deviceId);
          if (!(_this4.currentPath === "/app/components/heartbeat" || _this4.currentPath === "/app/components/notifications")) {
            (0, _highlightSidebarOption.highlightNavigatedMenu)("heartbeat", "#" + _this4.currentPath);
            _this4.props.history.push("/app/components/heartbeat");
          }
        } }))));
    }
  }]);

  return NodeVitals;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var symbioticReducer = _ref.symbioticReducer;

  return {
    deviceId: symbioticReducer.deviceId,
    nodeVitalsData: symbioticReducer.nodeVitals,
    nodeVitalFilter: symbioticReducer.nodeVitalFilter
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateDeviceId: function updateDeviceId(id) {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateNodeVitalsData: function updateNodeVitalsData(data) {
      dispatch({ type: "NODE_VITALS_DATA", nodeVitals: data });
    },
    updateNodeVitalsFilterData: function updateNodeVitalsFilterData(data) {
      dispatch({ type: "NODE_VITALS_FILTER_DATA", nodeVitalsFilter: data });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NodeVitals);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NodeVitals, "NodeVitals", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_filterModal2, "_filterModal2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_moment2, "_moment2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_lodash2, "_lodash2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_EnhancedTable2, "_EnhancedTable2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(NodeVitals, "NodeVitals", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/index.js");
}();

;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(0),__webpack_require__(1),__webpack_require__(6),__webpack_require__(769),__webpack_require__(770),__webpack_require__(1671),__webpack_require__(779),__webpack_require__(780),__webpack_require__(390),__webpack_require__(781),__webpack_require__(391),__webpack_require__(782),__webpack_require__(1686),__webpack_require__(1687),__webpack_require__(1688),__webpack_require__(1689),__webpack_require__(1690),__webpack_require__(1691),__webpack_require__(1692),__webpack_require__(1693),__webpack_require__(1694),__webpack_require__(1695),__webpack_require__(1696),__webpack_require__(1697),__webpack_require__(1700),__webpack_require__(1701),__webpack_require__(1702),__webpack_require__(1703),__webpack_require__(1704),__webpack_require__(1705),__webpack_require__(1706),__webpack_require__(783),__webpack_require__(1708),__webpack_require__(1709),__webpack_require__(1710),__webpack_require__(1711),__webpack_require__(1712),__webpack_require__(1713),__webpack_require__(1714),__webpack_require__(1715),__webpack_require__(394),__webpack_require__(393),__webpack_require__(1716),__webpack_require__(784),__webpack_require__(1717),__webpack_require__(1718),__webpack_require__(1719),__webpack_require__(1720),__webpack_require__(1721),__webpack_require__(1722),__webpack_require__(1723),__webpack_require__(1724),__webpack_require__(1725),__webpack_require__(1726),__webpack_require__(1727),__webpack_require__(1728),__webpack_require__(16),__webpack_require__(1729),__webpack_require__(1736),__webpack_require__(1738),__webpack_require__(1739),__webpack_require__(21)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getISOWeek","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper","react-dom"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.addDays,e.addWeeks,e.addMonths,e.addYears,null,null,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getISOWeek,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.setMonth,e.setQuarter,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,null,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,null,null,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper,e.ReactDOM)}(this,(function(e,t,r,a,n,o,s,i,p,l,d,c,u,f,h,m,y,v,D,w,k,g,b,C,S,_,M,P,E,N,O,Y,x,T,I,L,F,R,q,A,W,B,j,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe){"use strict";function le(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=le(t),ce=le(a),ue=le(n),fe=le(o),he=le(s),me=le(i),ye=le(p),ve=le(l),De=le(d),we=le(c),ke=le(u),ge=le(m),be=le(y),Ce=le(v),Se=le(D),_e=le(w),Me=le(k),Pe=le(g),Ee=le(b),Ne=le(C),Oe=le(S),Ye=le(_),xe=le(M),Te=le(P),Ie=le(E),Le=le(N),Fe=le(O),Re=le(Y),qe=le(x),Ae=le(T),We=le(I),Be=le(L),je=le(F),He=le(R),Ke=le(q),Qe=le(W),Ve=le(B),Ue=le(j),$e=le(H),ze=le(K),Ge=le(Q),Je=le(V),Xe=le(z),Ze=le(G),et=le(J),tt=le(X),rt=le(Z),at=le(ee),nt=le(te),ot=le(re),st=le(ae),it=le(ne),pt=le(oe),lt=le(se),dt=le(pe);function ct(e){return(ct="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ut(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ft(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ht(e,t,r){return t&&ft(e.prototype,t),r&&ft(e,r),e}function mt(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function yt(){return(yt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e}).apply(this,arguments)}function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),!0).forEach((function(t){mt(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function wt(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&gt(e,t)}function kt(e){return(kt=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function gt(e,t){return(gt=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function bt(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ct(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?bt(e):t}function St(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=kt(e);if(t){var n=kt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return Ct(this,r)}}function _t(e){return function(e){if(Array.isArray(e))return Mt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Mt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Mt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Mt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Pt(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Et(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var Nt={p:Et,P:function(e,t){var r,a=e.match(/(P+)(p+)?/),n=a[1],o=a[2];if(!o)return Pt(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",Pt(n,t)).replace("{{time}}",Et(o,t))}},Ot=12,Yt=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function xt(e){var t=e?"string"==typeof e||e instanceof String?pt.default(e):st.default(e):new Date;return It(t)?t:null}function Tt(e,t,r,a){var n=null,o=Jt(r)||Jt(Gt()),s=!0;return Array.isArray(t)?(t.forEach((function(t){var r=it.default(e,t,new Date,{locale:o});a&&(s=It(r)&&e===he.default(r,t,{awareOfUnicodeTokens:!0})),It(r)&&s&&(n=r)})),n):(n=it.default(e,t,new Date,{locale:o}),a?s=It(n)&&e===he.default(n,t,{awareOfUnicodeTokens:!0}):It(n)||(t=t.match(Yt).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,Nt[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(n=it.default(e,t.slice(0,e.length),new Date)),It(n)||(n=new Date(e))),It(n)&&s?n:null)}function It(e){return fe.default(e)&&at.default(e,new Date("1/1/1000"))}function Lt(e,t,r){if("en"===r)return he.default(e,t,{awareOfUnicodeTokens:!0});var a=Jt(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&Gt()&&Jt(Gt())&&(a=Jt(Gt())),he.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Ft(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return Re.default(Fe.default(Le.default(e,i),o),a)}function Rt(e,t){var r=t&&Jt(t)||Gt()&&Jt(Gt());return Oe.default(e,r?{locale:r}:null)}function qt(e,t){return Lt(e,"ddd",t)}function At(e){return Ve.default(e)}function Wt(e,t){var r=Jt(t||Gt());return Ue.default(e,{locale:r})}function Bt(e){return $e.default(e)}function jt(e){return Ge.default(e)}function Ht(e){return ze.default(e)}function Kt(e,t){return e&&t?tt.default(e,t):!e&&!t}function Qt(e,t){return e&&t?et.default(e,t):!e&&!t}function Vt(e,t){return e&&t?rt.default(e,t):!e&&!t}function Ut(e,t){return e&&t?Ze.default(e,t):!e&&!t}function $t(e,t){return e&&t?Xe.default(e,t):!e&&!t}function zt(e,t,r){var a,n=Ve.default(t),o=Je.default(r);try{a=ot.default(e,{start:n,end:o})}catch(e){a=!1}return a}function Gt(){return("undefined"!=typeof window?window:global).__localeId__}function Jt(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Xt(e,t){return Lt(qe.default(xt(),e),"LLLL",t)}function Zt(e,t){return Lt(qe.default(xt(),e),"LLL",t)}function er(e,t){return Lt(Ae.default(xt(),e),"QQQ",t)}function tr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Ut(e,t)}))||o&&!o.some((function(t){return Ut(e,t)}))||s&&!s(xt(e))||!1}function rr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Ut(e,t)}))||!1}function ar(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Qt(e,t)}))||o&&!o.some((function(t){return Qt(e,t)}))||s&&!s(xt(e))||!1}function nr(e,t,r,a){var n=Te.default(e),o=Ye.default(e),s=Te.default(t),i=Ye.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Vt(e,t)}))||o&&!o.some((function(t){return Vt(e,t)}))||s&&!s(xt(e))||!1}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=new Date(e,0,1);return pr(n,{minDate:r,maxDate:a})||!1}function ir(e,t,r,a){var n=Te.default(e),o=xe.default(e),s=Te.default(t),i=xe.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&He.default(e,r)<0||a&&He.default(e,a)>0}function lr(e,t){return t.some((function(t){return Pe.default(t)===Pe.default(e)&&Me.default(t)===Me.default(e)}))}function dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&lr(e,r)||a&&!lr(e,a)||n&&!n(e)||!1}function cr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=xt(),s=Re.default(Fe.default(o,Me.default(e)),Pe.default(e)),i=Re.default(Fe.default(o,Me.default(r)),Pe.default(r)),p=Re.default(Fe.default(o,Me.default(a)),Pe.default(a));try{n=!ot.default(s,{start:i,end:p})}catch(e){n=!1}return n}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Ce.default(e,1);return r&&Ke.default(r,n)>0||a&&a.every((function(e){return Ke.default(e,n)>0}))||!1}function fr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=we.default(e,1);return r&&Ke.default(n,r)>0||a&&a.every((function(e){return Ke.default(n,e)>0}))||!1}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Se.default(e,1);return r&&Qe.default(r,n)>0||a&&a.every((function(e){return Qe.default(e,n)>0}))||!1}function mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ke.default(e,1);return r&&Qe.default(n,r)>0||a&&a.every((function(e){return Qe.default(n,e)>0}))||!1}function yr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)>=0}));return Be.default(a)}return r?Be.default(r):t}function vr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function Dr(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(ue.default(o)){var s=Lt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===ct(o)){var p=Object.keys(o),l=p[0],d=o[p[0]];if("string"==typeof l&&d.constructor===Array)for(var c=0,u=d.length;c<u;c++){var f=Lt(d[c],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function wr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=me.default(ye.default(e,Pe.default(n[i])),Me.default(n[i])),l=me.default(e,(r+1)*a);at.default(p,t)&&nt.default(p,l)&&s.push(n[i])}return s}function kr(e){return e<10?"0".concat(e):"".concat(e)}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ot,r=Math.ceil(Te.default(e)/t)*t,a=r-(t-1);return{startPeriod:a,endPeriod:r}}function br(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Te.default(r)<=s),a&&i&&(i=Te.default(a)>=s),i&&n.push(s)}return n}var Cr=function(e){wt(r,e);var t=St(r);function r(e){var a;ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){var e=a.props.year,t=a.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:a.onChange.bind(bt(a),t)},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=a.props.minDate?Te.default(a.props.minDate):null,n=a.props.maxDate?Te.default(a.props.maxDate):null;return n&&a.state.yearsList.find((function(e){return e===n}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:a.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&a.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:a.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),mt(bt(a),"onChange",(function(e){a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),mt(bt(a),"shiftYears",(function(e){var t=a.state.yearsList.map((function(t){return t+e}));a.setState({yearsList:t})})),mt(bt(a),"incrementYears",(function(){return a.shiftYears(1)})),mt(bt(a),"decrementYears",(function(){return a.shiftYears(-1)}));var n=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=n||(o?10:5);return a.state={yearsList:br(a.props.year,s,a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Sr=lt.default(Cr),_r=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Te.default(e.props.minDate):1900,r=e.props.maxDate?Te.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Sr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),mt(bt(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),mt(bt(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),mt(bt(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Mr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(bt(e),r)},e.props.month===r?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),mt(bt(e),"onChange",(function(t){return e.props.onChange(t)})),mt(bt(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Pr=lt.default(Mr),Er=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),mt(bt(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),mt(bt(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),mt(bt(e),"renderDropdown",(function(t){return de.default.createElement(Pr,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),mt(bt(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Zt(e,t.props.locale)}:function(e){return Xt(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Nr(e,t){for(var r=[],a=Bt(e),n=Bt(t);!at.default(a,n);)r.push(xt(a)),a=we.default(a,1);return r}var Or=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Ie.default(e),r=Kt(a.props.date,e)&&Qt(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(bt(a),t)},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Lt(e,a.props.dateFormat,a.props.locale))}))})),mt(bt(a),"onChange",(function(e){return a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:Nr(a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Yr=lt.default(Or),xr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=Bt(e.props.minDate),r=Bt(e.props.maxDate),a=[];!at.default(t,r);){var n=Ie.default(t);a.push(de.default.createElement("option",{key:n,value:n},Lt(t,e.props.dateFormat,e.props.locale))),t=we.default(t,1)}return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Ie.default(Bt(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){var r=Lt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Yr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown();var r=xt(parseInt(t));Kt(e.props.date,r)&&Qt(e.props.date,r)||e.props.onChange(r)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Tr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),mt(bt(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),mt(bt(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),mt(bt(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),mt(bt(e),"isSameDay",(function(t){return Ut(e.props.day,t)})),mt(bt(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),mt(bt(e),"isDisabled",(function(){return tr(e.props.day,e.props)})),mt(bt(e),"isExcluded",(function(){return rr(e.props.day,e.props)})),mt(bt(e),"getHighLightedClass",(function(t){var r=e.props,a=r.day,n=r.highlightDates;if(!n)return!1;var o=Lt(a,"MM.dd.yyyy");return n.get(o)})),mt(bt(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&zt(r,a,n)})),mt(bt(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,a=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.selectingDate,i=t.startDate,p=t.endDate;return!(!(a||n||o)||!s||e.isDisabled())&&(a&&p&&(nt.default(s,p)||$t(s,p))?zt(r,s,p):(n&&i&&(at.default(s,i)||$t(s,i))||!(!o||!i||p||!at.default(s,i)&&!$t(s,i)))&&zt(r,i,s))})),mt(bt(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.startDate;return Ut(r,t.selectsStart?a:n)})),mt(bt(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.endDate;return Ut(r,t.selectsEnd?a:n)})),mt(bt(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(a,r)})),mt(bt(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(n,r)})),mt(bt(e),"isWeekend",(function(){var t=Ee.default(e.props.day);return 0===t||6===t})),mt(bt(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==Ye.default(e.props.day)})),mt(bt(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return ce.default("react-datepicker__day",r,"react-datepicker__day--"+qt(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(xt()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),mt(bt(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(Lt(r,"PPPP"))})),mt(bt(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(a)&&Ut(n,a)?0:-1})),mt(bt(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus({preventScroll:!0})})),mt(bt(e),"renderDayContents",(function(){if(e.isOutsideMonth()){if(e.props.monthShowsDuplicateDaysEnd&&Ne.default(e.props.day)<10)return null;if(e.props.monthShowsDuplicateDaysStart&&Ne.default(e.props.day)>20)return null}return e.props.renderDayContents?e.props.renderDayContents(Ne.default(e.props.day),e.props.day):Ne.default(e.props.day)})),mt(bt(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.renderDayContents())})),e}return ht(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),Ir=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return de.default.createElement("div",{className:ce.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},t)}}]),r}(de.default.Component),Lr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleWeekClick",(function(t,r,a){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),mt(bt(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):Rt(t)})),mt(bt(e),"renderDays",(function(){var t=Wt(e.props.day,e.props.locale),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect?e.handleWeekClick.bind(bt(e),t,a):void 0;r.push(de.default.createElement(Ir,{key:"W",weekNumber:a,onClick:n,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=ve.default(t,r);return de.default.createElement(Tr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(bt(e),a),onMouseEnter:e.handleDayMouseEnter.bind(bt(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})})))})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Fr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",_t(Array(12)).map((function(){return de.default.createRef()}))),mt(bt(e),"isDisabled",(function(t){return tr(t,e.props)})),mt(bt(e),"isExcluded",(function(t){return rr(t,e.props)})),mt(bt(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),mt(bt(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),n)})),mt(bt(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),n)})),mt(bt(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),o)})),mt(bt(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),o)})),mt(bt(e),"isWeekInMonth",(function(t){var r=e.props.day,a=ve.default(t,6);return Qt(t,r)||Qt(a,r)})),mt(bt(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=Wt(Bt(e.props.day),e.props.locale),n=0,o=!1;t.push(de.default.createElement(Lr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:n,day:a,month:Ye.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!o;){n++,a=De.default(a,1);var s=r&&n>=6,i=!r&&!e.isWeekInMonth(a);if(s||i){if(!e.props.peekNextMonth)break;o=!0}}return t})),mt(bt(e),"onMonthClick",(function(t,r){e.handleDayClick(Bt(qe.default(e.props.day,r)),t)})),mt(bt(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),mt(bt(e),"onMonthKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onMonthClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,we.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,Ce.default(e.props.preSelection,1))}})),mt(bt(e),"onQuarterClick",(function(t,r){e.handleDayClick(Ht(Ae.default(e.props.day,r)),t)})),mt(bt(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,d=r.monthClassName,c=d?d(a):void 0;return ce.default("react-datepicker__month-text","react-datepicker__month-".concat(t),c,{"react-datepicker__month--disabled":(i||p)&&ar(qe.default(a,t),e.props),"react-datepicker__month--selected":Ye.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__month-text--keyboard-selected":Ye.default(l)===t,"react-datepicker__month--in-range":nr(n,o,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),mt(bt(e),"getTabIndex",(function(t){var r=Ye.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),mt(bt(e),"getAriaLabel",(function(t){var r=e.props,a=r.ariaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=qe.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(Lt(p,"MMMM yyyy"))})),mt(bt(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate;return ce.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||p)&&or(Ae.default(a,t),e.props),"react-datepicker__quarter--selected":xe.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__quarter--in-range":ir(n,o,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),mt(bt(e),"renderMonths",(function(){var t=e.props,r=t.showFullMonthYearPicker,a=t.showTwoColumnMonthYearPicker,n=t.showFourColumnMonthYearPicker,o=t.locale;return(n?[[0,1,2,3],[4,5,6,7],[8,9,10,11]]:a?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(t,a){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:a},t.map((function(t,a){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:a,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"button","aria-label":e.getAriaLabel(t)},r?Xt(t,o):Zt(t,o))})))}))})),mt(bt(e),"renderQuarters",(function(){return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,r){return de.default.createElement("div",{key:r,onClick:function(r){e.onQuarterClick(r,t)},className:e.getQuarterClassNames(t)},er(t,e.props.locale))})))})),mt(bt(e),"getClassNames",(function(){var t=e.props;t.day;var r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker;return ce.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s})})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Lt(a,"yyyy-MM"))},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),Rr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),mt(bt(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props)||e.props.onChange(t)})),mt(bt(e),"liClasses",(function(t,r,a){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,a):void 0];return e.props.selected&&r===Pe.default(t)&&a===Me.default(t)&&n.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props))&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*Pe.default(t)+Me.default(t))%e.props.intervals!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),mt(bt(e),"renderTimes",(function(){for(var t=[],r=e.props.format?e.props.format:"p",a=e.props.intervals,n=At(xt(e.props.selected)),o=1440/a,s=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),i=e.props.selected||e.props.openToDate||xt(),p=Pe.default(i),l=Me.default(i),d=Re.default(Fe.default(n,l),p),c=0;c<o;c++){var u=me.default(n,c*a);if(t.push(u),s){var f=wr(n,u,c,a,s);t=t.concat(f)}}return t.map((function(t,a){return de.default.createElement("li",{key:a,onClick:e.handleClick.bind(bt(e),t),className:e.liClasses(t,p,l),ref:function(r){(nt.default(t,d)||$t(t,d))&&(e.centerLi=r)},tabIndex:"0"},Lt(t,r,e.props.locale))}))})),e}return ht(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);mt(Rr,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),mt(bt(a),"isSameDay",(function(e,t){return Ut(e,t)})),mt(bt(a),"isKeyboardSelected",(function(e){var t=jt(We.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Ut(t,jt(a.props.selected))&&Ut(t,jt(a.props.preSelection))})),mt(bt(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(We.default(r,t)),e)})),mt(bt(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected;return ce.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Te.default(o),"react-datepicker__year-text--disabled":(r||n)&&sr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--today":e===Te.default(xt())})})),a}return ht(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=gr(r.date,r.yearItemNumber),n=a.startPeriod,o=a.endPeriod,s=function(r){t.push(de.default.createElement("div",{onClick:function(t){e.onYearClick(t,r)},className:e.getYearClassNames(r),key:r},r))},i=n;i<=o;i++)s(i);return de.default.createElement("div",{className:"react-datepicker__year"},de.default.createElement("div",{className:"react-datepicker__year-wrapper"},t))}}]),r}(de.default.Component),Ar=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),mt(bt(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Wr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",yt({className:"react-datepicker__triangle"},o)),r)}var Br=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],jr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),mt(bt(a),"setClickOutsideRef",(function(){return a.containerRef.current})),mt(bt(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Br.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),mt(bt(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=yr(a.props),s=vr(a.props),i=xt(),p=n||r||t;return p||(o&&nt.default(i,o)?o:s&&at.default(i,s)?s:i)})),mt(bt(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:we.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:Ce.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),mt(bt(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),mt(bt(a),"handleYearChange",(function(e){a.props.onYearChange&&a.props.onYearChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthChange",(function(e){a.props.onMonthChange&&a.props.onMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),mt(bt(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:qe.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(qe.default(r,Ye.default(e)),Te.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),mt(bt(a),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=Wt(e,a.props.locale),r=[];return a.props.showWeekNumbers&&r.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map((function(e){var r=ve.default(t,e),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:e,className:ce.default("react-datepicker__day-name",o)},n)})))})),mt(bt(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Lt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Lt(e,"EEE",t)}(e,t):function(e,t){return Lt(e,"EEEEEE",t)}(e,t)})),mt(bt(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Se.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=hr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(jt(Se.default(e,n)),n).endPeriod,s=r&&Te.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=ur(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthAriaLabel,i=void 0===s?"Previous Month":s,p=o.previousYearAriaLabel,l=void 0===p?"Previous Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel)}}})),mt(bt(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:ke.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=mr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(ke.default(e,n),n).startPeriod,s=r&&Te.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=fr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthAriaLabel,i=void 0===s?"Next Month":s,p=o.nextYearAriaLabel,l=void 0===p?"Next Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel)}}})),mt(bt(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Lt(e,a.props.dateFormat,a.props.locale))})),mt(bt(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(_r,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Te.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),mt(bt(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Er,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Ye.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),mt(bt(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(xr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),mt(bt(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.props.onSelect(Ve.default(xt()),e)}},a.props.todayButton)})),mt(bt(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=ur(a.state.date,a.props),o=fr(a.state.date,a.props),s=hr(a.state.date,a.props),i=mr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=gr(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Te.default(e))})),mt(bt(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),mt(bt(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var e=[],t=a.props.showPreviousMonths?a.props.monthsShown-1:0,r=Ce.default(a.state.date,t),n=0;n<a.props.monthsShown;++n){var o=n-a.props.monthSelectedIn,s=we.default(r,o),i="month-".concat(n),p=n<a.props.monthsShown-1,l=n>0;e.push(de.default.createElement("div",{key:i,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:s,i:n}),de.default.createElement(Fr,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,onChange:a.changeMonthYear,day:s,dayClassName:a.props.dayClassName,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:n,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:p,monthShowsDuplicateDaysStart:l})))}return e}})),mt(bt(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement(qr,yt({onDayClick:a.handleDayClick,date:a.state.date},a.props))):void 0})),mt(bt(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(Rr,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,showTimeSelectOnly:a.props.showTimeSelectOnly})})),mt(bt(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=It(e)&&Boolean(a.props.selected)?"".concat(kr(e.getHours()),":").concat(kr(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Ar,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null},a}return ht(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Ut(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Ut(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Wr;return de.default.createElement("div",{ref:this.containerRef},de.default.createElement(e,{className:ce.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ot}}}]),r}(de.default.Component),Hr=function(e){return!e.disabled&&-1!==e.tabIndex},Kr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Hr)})),mt(bt(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),mt(bt(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return ht(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),Qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return ht(r,[{key:"componentDidMount",value:function(){this.portalRoot=document.getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),document.body.appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return dt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),Vr=function(e){wt(r,e);var t=St(r);function r(){return ut(this,r),t.apply(this,arguments)}return ht(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,d=t.enableTabLoop,c=t.popperOnKeyDown,u=t.portalId;if(!n){var f=ce.default("react-datepicker-popper",r);e=de.default.createElement(ie.Popper,yt({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(Kr,{enableTabLoop:d},de.default.createElement("div",{ref:t,style:r,className:f,"data-placement":a,onKeyDown:c},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(Qr,{portalId:u},e));var h=ce.default("react-datepicker-wrapper",a);return de.default.createElement(ie.Manager,{className:"react-datepicker-manager"},de.default.createElement(ie.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:h},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),Ur="react-datepicker-ignore-onclickoutside",$r=lt.default(jr);var zr="Date input not valid.",Gr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:xt()})),mt(bt(a),"calcInitialState",(function(){var e=a.getPreSelection(),t=yr(a.props),r=vr(a.props),n=t&&nt.default(e,Ve.default(t))?t:r&&at.default(e,Je.default(r))?r:e;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:a.props.selected?a.props.selected:n,highlightDates:Dr(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1}})),mt(bt(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),mt(bt(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),mt(bt(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),mt(bt(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:Xr},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),mt(bt(a),"inputOk",(function(){return ue.default(a.state.preSelection)})),mt(bt(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),mt(bt(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),mt(bt(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),mt(bt(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),mt(bt(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),mt(bt(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),mt(bt(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),mt(bt(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(bt(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:Jr});var o=Tt(n.target.value,a.props.dateFormat,a.props.locale,a.props.strictParsing);!o&&n.target.value||a.setSelected(o,n,!0)}})),mt(bt(a),"handleSelect",(function(e,t,r){a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.setSelected(e,t,!1,r),!a.props.shouldCloseOnSelect||a.props.showTimeSelect?a.setPreSelection(e):a.props.inline||a.setOpen(!1)})),mt(bt(a),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!tr(o,a.props)){var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,d=s.endDate;if(!$t(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Ft(o,{hour:Pe.default(a.props.selected),minute:Me.default(a.props.selected),second:_e.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var c=l&&!d,u=l&&d;!l&&!d?i([o,null],t):c&&(nt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))}})),mt(bt(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;if(e){var o=Ve.default(e);if(t&&r)n=zt(e,a.props.minDate,a.props.maxDate);else if(t){var s=Ve.default(a.props.minDate);n=at.default(e,s)||$t(o,s)}else if(r){var i=Je.default(a.props.maxDate);n=nt.default(e,i)||$t(o,i)}}n&&a.setState({preSelection:e})})),mt(bt(a),"handleTimeChange",(function(e){var t=Ft(a.props.selected?a.props.selected:a.getPreSelection(),{hour:Pe.default(e),minute:Me.default(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),a.setState({inputValue:null})})),mt(bt(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),mt(bt(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=xt(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===Xr?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t&&(e.preventDefault(),a.setOpen(!1)),a.inputOk()||a.props.onInputError({code:1,msg:zr})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),mt(bt(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=xt(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:zr});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=ge.default(r,1);break;case"ArrowRight":n=ve.default(r,1);break;case"ArrowUp":n=be.default(r,1);break;case"ArrowDown":n=De.default(r,1);break;case"PageUp":n=Ce.default(r,1);break;case"PageDown":n=we.default(r,1);break;case"Home":n=Se.default(r,1);break;case"End":n=ke.default(r,1)}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:zr}));if(e.preventDefault(),a.setState({lastPreSelectChange:Xr}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Ye.default(r),s=Ye.default(n),i=Te.default(r),p=Te.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),mt(bt(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),mt(bt(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.onChange(null,e),a.setState({inputValue:null})})),mt(bt(a),"clear",(function(){a.onClearClick()})),mt(bt(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),mt(bt(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement($r,{ref:function(e){a.calendar=e},locale:a.props.locale,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:Ur,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),mt(bt(a),"renderDateInput",(function(){var e,t,r,n,o,s=ce.default(a.props.className,mt({},Ur,a.state.open)),i=a.props.customInput||de.default.createElement("input",{type:"text"}),p=a.props.customInputRef||"ref",l="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:(t=a.props.selected,r=a.props,n=r.dateFormat,o=r.locale,t&&Lt(t,Array.isArray(n)?n[0]:n,o)||"");return de.default.cloneElement(i,(mt(e={},p,(function(e){a.input=e})),mt(e,"value",l),mt(e,"onBlur",a.handleBlur),mt(e,"onChange",a.handleChange),mt(e,"onClick",a.onInputClick),mt(e,"onFocus",a.handleFocus),mt(e,"onKeyDown",a.onInputKeyDown),mt(e,"id",a.props.id),mt(e,"name",a.props.name),mt(e,"autoFocus",a.props.autoFocus),mt(e,"placeholder",a.props.placeholderText),mt(e,"disabled",a.props.disabled),mt(e,"autoComplete",a.props.autoComplete),mt(e,"className",ce.default(i.props.className,s)),mt(e,"title",a.props.title),mt(e,"readOnly",a.props.readOnly),mt(e,"required",a.props.required),mt(e,"tabIndex",a.props.tabIndex),mt(e,"aria-describedby",a.props.ariaDescribedBy),mt(e,"aria-invalid",a.props.ariaInvalid),mt(e,"aria-labelledby",a.props.ariaLabelledBy),mt(e,"aria-required",a.props.ariaRequired),e))})),mt(bt(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.selected,n=e.clearButtonTitle,o=e.clearButtonClassName,s=e.ariaLabelClose,i=void 0===s?"Close":s;return t&&null!=r?de.default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(o),"aria-label":i,onClick:a.onClearClick,title:n,tabIndex:-1}):null})),a.state=a.calcInitialState(),a}return ht(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Ye.default(r)!==Ye.default(a)||Te.default(r)!==Te.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Dr(this.props.highlightDates)}),t.focused||$t(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?de.default.createElement("div",null,this.props.inline?null:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?de.default.createElement("div",{className:"react-datepicker__portal"},e):null):de.default.createElement(Vr,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,popperModifiers:this.props.popperModifiers,targetComponent:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ot,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),r}(de.default.Component),Jr="input",Xr="navigate";e.CalendarContainer=Wr,e.default=Gr,e.getDefaultLocale=Gt,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(9);









 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__["a" /* default */];
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["default"])(dirtyDate);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(originalDate);
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__["a" /* default */])(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__["a" /* default */][firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (formatDistance);

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(1674);

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (formatLong);

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ __webpack_exports__["a"] = (formatRelative);

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(1677);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (localize);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(1680);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a" /* default */])({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchFn;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCWeek_index_js__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeekYear_index_js__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__ = __webpack_require__(1685);







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = Object(__WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date); // Padding

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = Object(__WEBPACK_IMPORTED_MODULE_3__lib_getUTCWeek_index_js__["a" /* default */])(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__["a" /* default */])(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__["a" /* default */])(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(Math.floor(absOffset / 60), 2);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);


var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(9);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCWeekYear_index_js__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__(25);



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCWeekYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeek, dirtyOptions);
  return date;
}

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(776);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, token.length);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addHours_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addYears_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(9);




var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a" /* default */])(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate).getFullYear();
}

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var seconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDaysInMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(9);




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var quarter = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return Object(__WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `min` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   const date1 = new Date(1989, 6, 10)
 *   const date2 = new Date(1987, 1, 11)
 *   const minDate = min(date1, date2)
 *
 *   // v2.0.0 onward:
 *   const dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   const minDate = min(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `max` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var maxDate = max(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var maxDate = max(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var startOfDayLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["default"])(dirtyDateLeft);
  var startOfDayRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);



var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var startOfWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var cleanDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(9);




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyLeftDate);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 * 
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isAfter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isWithinInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var time = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate).getTime();
  var startTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(interval.start).getTime();
  var endTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(9);










var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a" /* default */])(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a" /* default */];

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["default"])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(token)) {
      Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(token)) {
      Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__["a" /* default */][firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["default"])(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__["a" /* default */])(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__ = __webpack_require__(259);







var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a" /* default */])(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__["a" /* default */])(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__["a" /* default */])(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (parsers);

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(25);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(25);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var day = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(9);



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyISOWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__["a" /* default */])(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(9);



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var week = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__["a" /* default */])(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parseISO;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(25);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? 2 : Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["a" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInMinute */] + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["a" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInMinute */]);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export daysInWeek */
/* unused harmony export maxTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return millisecondsInMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return millisecondsInHour; });
/* unused harmony export millisecondsInSecond */
/* unused harmony export minTime */
/* unused harmony export minutesInHour */
/* unused harmony export monthsInQuarter */
/* unused harmony export monthsInYear */
/* unused harmony export quartersInYear */
/* unused harmony export secondsInHour */
/* unused harmony export secondsInMinute */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(794);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(786);
var isArguments = __webpack_require__(1745);
var is = __webpack_require__(1749);
var isRegex = __webpack_require__(1752);
var flags = __webpack_require__(1753);
var isDate = __webpack_require__(1756);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(787); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(398)();
var callBound = __webpack_require__(789);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(788);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(400);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(196);
var callBind = __webpack_require__(401);

var implementation = __webpack_require__(790);
var getPolyfill = __webpack_require__(791);
var shim = __webpack_require__(1751);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(399);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(791);
var define = __webpack_require__(196);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(789);
var hasToStringTag = __webpack_require__(398)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(196);
var callBind = __webpack_require__(401);

var implementation = __webpack_require__(792);
var getPolyfill = __webpack_require__(793);
var shim = __webpack_require__(1755);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(196).supportsDescriptors;
var getPolyfill = __webpack_require__(793);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(398)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1759);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1760);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1761);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(794);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1765);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./react-datepicker.css", function() {
			var newContent = require("!!../../css-loader/index.js!./react-datepicker.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(115)(false);
// imports


// module
exports.push([module.i, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker-wrapper{display:inline-block;padding:0;border:0}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;display:inline-block;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle,.react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle{left:auto;right:50px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__header--time:not(.react-datepicker__header--time--only){border-top-left-radius:0}.react-datepicker__header:not(.react-datepicker__header--has-time-select){border-top-right-radius:.3rem}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker-year-header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.45rem solid transparent;z-index:1;height:10px;width:10px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:95px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__year{margin:.4rem;text-align:center}.react-datepicker__year-wrapper{display:flex;flex-wrap:wrap;max-width:180px}.react-datepicker__year .react-datepicker__year-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:auto}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__month--in-range,.react-datepicker__month--in-selecting-range,.react-datepicker__month--selected,.react-datepicker__quarter--in-range,.react-datepicker__quarter--in-selecting-range,.react-datepicker__quarter--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__month--in-range:hover,.react-datepicker__month--in-selecting-range:hover,.react-datepicker__month--selected:hover,.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter--in-selecting-range:hover,.react-datepicker__quarter--selected:hover{background-color:#1d5d90}.react-datepicker__month--disabled,.react-datepicker__quarter--disabled{color:#ccc;pointer-events:none}.react-datepicker__month--disabled:hover,.react-datepicker__quarter--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text,.react-datepicker__year-text{cursor:pointer}.react-datepicker__day:hover,.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover,.react-datepicker__year-text:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today,.react-datepicker__year-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted,.react-datepicker__year-text--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover,.react-datepicker__month-text--highlighted:hover,.react-datepicker__quarter-text--highlighted:hover,.react-datepicker__year-text--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1,.react-datepicker__year-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2,.react-datepicker__year-text--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected,.react-datepicker__month-text--in-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--selected,.react-datepicker__quarter-text--in-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--selected,.react-datepicker__year-text--in-range,.react-datepicker__year-text--in-selecting-range,.react-datepicker__year-text--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover,.react-datepicker__month-text--in-range:hover,.react-datepicker__month-text--in-selecting-range:hover,.react-datepicker__month-text--selected:hover,.react-datepicker__quarter-text--in-range:hover,.react-datepicker__quarter-text--in-selecting-range:hover,.react-datepicker__quarter-text--selected:hover,.react-datepicker__year-text--in-range:hover,.react-datepicker__year-text--in-selecting-range:hover,.react-datepicker__year-text--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected,.react-datepicker__year-text--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover,.react-datepicker__month-text--keyboard-selected:hover,.react-datepicker__quarter-text--keyboard-selected:hover,.react-datepicker__year-text--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range{background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range,.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range,.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range{background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled,.react-datepicker__year-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover,.react-datepicker__month-text--disabled:hover,.react-datepicker__quarter-text--disabled:hover,.react-datepicker__year-text--disabled:hover{background-color:transparent}.react-datepicker__month-text.react-datepicker__month--in-range:hover,.react-datepicker__month-text.react-datepicker__month--selected:hover,.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,.react-datepicker__month-text.react-datepicker__quarter--selected:hover,.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,.react-datepicker__quarter-text.react-datepicker__month--selected:hover,.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover{background-color:#216ba5}.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover{background-color:#f0f0f0}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#216ba5;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:\"\\D7\"}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);

// exports


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _TableFooter = __webpack_require__(261);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _Table = __webpack_require__(269);

var _Table2 = _interopRequireDefault(_Table);

var _reactRedux = __webpack_require__(30);

var _TableBody = __webpack_require__(270);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableCell = __webpack_require__(200);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableContainer = __webpack_require__(271);

var _TableContainer2 = _interopRequireDefault(_TableContainer);

var _TableHead = __webpack_require__(272);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableSortLabel = __webpack_require__(273);

var _TableSortLabel2 = _interopRequireDefault(_TableSortLabel);

var _TablePagination = __webpack_require__(275);

var _TablePagination2 = _interopRequireDefault(_TablePagination);

var _TableRow = __webpack_require__(278);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _Toolbar = __webpack_require__(137);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _Checkbox = __webpack_require__(168);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _util = __webpack_require__(77);

var _Tooltip = __webpack_require__(167);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Delete = __webpack_require__(279);

var _Delete2 = _interopRequireDefault(_Delete);

var _FilterList = __webpack_require__(280);

var _FilterList2 = _interopRequireDefault(_FilterList);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return { id: counter, name: name, calories: calories, fat: fat, carbs: carbs, protein: protein };
}

var columnData = [{ id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' }, { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator', type: 'string' }, { id: 'time', numeric: false, disablePadding: false, label: 'Last Seen', type: 'date' }, { id: 'batteryVoltage', numeric: true, disablePadding: false, label: 'Battery Level', type: 'number' }, { id: 'signalStrength', numeric: true, disablePadding: false, label: 'Signal Strength', type: 'number' }, { id: 'firmware', numeric: false, disablePadding: false, label: 'Firmware', type: 'string' }];

var EnhancedTableHead = function (_React$Component) {
    _inherits(EnhancedTableHead, _React$Component);

    function EnhancedTableHead() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, EnhancedTableHead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnhancedTableHead.__proto__ || Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref, [this].concat(args))), _this), _this.createSortHandler = function (property) {
            return function (event) {
                _this.props.onRequestSort(event, property);
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnhancedTableHead, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                onSelectAllClick = _props.onSelectAllClick,
                order = _props.order,
                orderBy = _props.orderBy,
                numSelected = _props.numSelected,
                rowCount = _props.rowCount;

            return _react2.default.createElement(_TableHead2.default, null, _react2.default.createElement(_TableRow2.default, null, columnData.map(function (column) {
                return _react2.default.createElement(_TableCell2.default, {
                    style: {
                        background: '#E2E3E5'
                    },
                    className: column.id !== 'deviceId' && "text-center",
                    key: column.id,
                    numeric: column.numeric,
                    padding: column.disablePadding ? 'none' : 'default'
                }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Sort',
                    placement: column.numeric ? 'bottom-end' : 'bottom-start',
                    enterDelay: 300
                }, _react2.default.createElement(_TableSortLabel2.default, {
                    active: orderBy === column.id,
                    direction: order,
                    onClick: _this2.createSortHandler(column.id)
                }, column.label)));
            }, this)));
        }
    }]);

    return EnhancedTableHead;
}(_react2.default.Component);

EnhancedTableHead.propTypes = {
    numSelected: _propTypes2.default.number.isRequired,
    onRequestSort: _propTypes2.default.func.isRequired,
    onSelectAllClick: _propTypes2.default.func.isRequired,
    order: _propTypes2.default.string.isRequired,
    orderBy: _propTypes2.default.string.isRequired,
    rowCount: _propTypes2.default.number.isRequired
};

var EnhancedTableToolbar = function EnhancedTableToolbar(props) {
    var numSelected = props.numSelected;

    return _react2.default.createElement(_Toolbar2.default, {
        className: (0, _classnames2.default)("table-header", _defineProperty({}, "highlight-light", numSelected > 0))
    }, _react2.default.createElement('div', { className: 'title' }, _react2.default.createElement(_Typography2.default, { type: 'title' }, 'Add Filter')), _react2.default.createElement('div', { className: 'actions' }, numSelected > 0 ? _react2.default.createElement(_Tooltip2.default, { title: 'Delete' }, _react2.default.createElement(_IconButton2.default, { 'aria-label': 'Delete' }, _react2.default.createElement(_Delete2.default, null))) : _react2.default.createElement(_Tooltip2.default, { title: 'Filter list' }, _react2.default.createElement(_IconButton2.default, { 'aria-label': 'Filter list' }, _react2.default.createElement(_FilterList2.default, { onClick: function onClick() {
            props.openModal();
        } })))));
};

EnhancedTableToolbar.propTypes = {
    numSelected: _propTypes2.default.number.isRequired
};

var EnhancedTable = function (_React$Component2) {
    _inherits(EnhancedTable, _React$Component2);

    function EnhancedTable(props, context) {
        _classCallCheck(this, EnhancedTable);

        var _this3 = _possibleConstructorReturn(this, (EnhancedTable.__proto__ || Object.getPrototypeOf(EnhancedTable)).call(this, props, context));

        _this3.handleRequestSort = function (event, property) {
            var orderBy = property;
            var order = 'desc';

            if (_this3.state.orderBy === property && _this3.state.order === 'desc') {
                order = 'asc';
            }
            var data = [];
            if (orderBy === 'nodeId' || orderBy === 'status') {
                data = order === 'desc' ? _this3.state.data.sort(function (a, b) {
                    return b[orderBy] < a[orderBy] ? -1 : 1;
                }) : _this3.state.data.sort(function (a, b) {
                    return a[orderBy] < b[orderBy] ? -1 : 1;
                });
            } else {
                data = order === 'desc' ? _this3.state.data.sort(function (aItem, bItem) {
                    var a = aItem.n ? aItem.n : aItem;;
                    var b = bItem.n ? bItem.n : bItem;
                    return (b.data && b.data.vitals && b.data.vitals[orderBy] !== undefined && b.data.vitals[orderBy]) < (a.data && a.data.vitals && a.data.vitals[orderBy] !== undefined && a.data.vitals[orderBy]) ? -1 : 1;
                }) : _this3.state.data.sort(function (aItem, bItem) {
                    var a = aItem.n ? aItem.n : aItem;
                    var b = bItem.n ? bItem.n : bItem;
                    return (a.data && a.data.vitals && a.data.vitals[orderBy] !== undefined && a.data.vitals[orderBy]) < (b.data && b.data.vitals && b.data.vitals[orderBy] !== undefined && b.data.vitals[orderBy]) ? -1 : 1;
                });
            }
            _this3.setState({ data: data, order: order, orderBy: orderBy });
        };

        _this3.handleSelectAllClick = function (event, checked) {
            if (checked) {
                _this3.setState({ selected: _this3.state.data.map(function (n) {
                        return n.id;
                    }) });
                return;
            }
            _this3.setState({ selected: [] });
        };

        _this3.handleKeyDown = function (event, id) {
            if ((0, _keycode2.default)(event) === 'space') {
                _this3.handleClick(event, id);
            }
        };

        _this3.handleClick = function (event, deviceId) {

            _this3.props.updateDeviceId(deviceId);
            // const { selected } = this.state;
            // const selectedIndex = selected.indexOf(id);
            // let newSelected = [];

            // if (selectedIndex === -1) {
            //     newSelected = newSelected.concat(selected, id);
            // } else if (selectedIndex === 0) {
            //     newSelected = newSelected.concat(selected.slice(1));
            // } else if (selectedIndex === selected.length - 1) {
            //     newSelected = newSelected.concat(selected.slice(0, -1));
            // } else if (selectedIndex > 0) {
            //     newSelected = newSelected.concat(
            //         selected.slice(0, selectedIndex),
            //         selected.slice(selectedIndex + 1),
            //     );
            // }

            // this.setState({ selected: newSelected });
        };

        _this3.handleChangePage = function (event, page) {
            // this.setState({ page });
            _this3.props.updateNodeVitalsFilterData({
                data: _this3.state.data,
                pageNumber: page
            });
        };

        _this3.handleChangeRowsPerPage = function (event) {
            _this3.setState({ rowsPerPage: event.target.value });
        };

        _this3.isSelected = function (id) {
            return _this3.state.selected.indexOf(id) !== -1;
        };

        _this3.showBatteryLevel = function (batteryVoltage) {
            if (batteryVoltage > 6.8) {
                return _react2.default.createElement('i', {
                    className: 'fa fa-battery-full text-green mx-2 signalBatteryIcon',
                    'aria-hidden': 'true'
                });
            } else if (batteryVoltage >= 6.6 && batteryVoltage <= 6.89) {
                return _react2.default.createElement('i', {
                    className: 'fa fa-battery-three-quarters text-yellow mx-2 signalBatteryIcon',
                    'aria-hidden': 'true'
                });
            } else if (batteryVoltage >= 6.0 && batteryVoltage <= 6.59) {
                return _react2.default.createElement('i', {
                    className: 'fa fa-battery-half display-1 text-orange mx-2 signalBatteryIcon',
                    'aria-hidden': 'true'
                });
            } else {
                return _react2.default.createElement('i', {
                    className: 'fa fa-battery-quarter text-red mx-2 signalBatteryIcon',
                    'aria-hidden': 'true'
                });
            }
        };

        _this3.showSignalLevel = function (signalStrength) {
            if (signalStrength > 25) {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/signal4.png',
                    alt: 'signal4'
                });
            } else if (signalStrength >= 14 && signalStrength <= 25) {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/signal3.png',
                    alt: 'signal3'
                });
            } else if (signalStrength >= 8 && signalStrength <= 13) {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/signal2.png',
                    alt: 'signal2'
                });
            } else {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/signal1.png',
                    alt: 'signal1'
                });
            }
        };

        _this3.getdeviceOnline = function (status) {
            if (status === "ACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/online.png',
                    alt: 'Online',
                    style: {
                        borderRadius: 15
                    }
                });
            } else if (status === "INACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/redIc.png',
                    alt: 'Offline',
                    style: {
                        borderRadius: 15
                    }
                });
            }
            return _react2.default.createElement('img', {
                className: 'statusImage d-inline-block mx-2 pl-0',
                src: '../../../../assets/images/offline.png',
                alt: 'Offline',
                style: {
                    borderRadius: 15
                }
            });
        };

        _this3.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.nodeVitalsFilter.data,
            page: props.nodeVitalsFilter.pageNumber,
            filterData: props.nodeVitalsData.data,
            rowsPerPage: 25
        };
        return _this3;
    }

    _createClass(EnhancedTable, [{
        key: 'setData',
        value: function setData(data) {
            this.setState({
                data: data.nodeVitalsFilter.data,
                page: data.nodeVitalsFilter.pageNumber,
                filterData: data.nodeVitalsData.data
            });
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            var updatedTime = new Date(date * 1000).getFullYear() + '-' + ("0" + (new Date(date * 1000).getMonth() + 1)).substr(-2) + '-' + ("0" + new Date(date * 1000).getDate()).substr(-2) + ', ' + ("0" + new Date(date * 1000).getHours()).substr(-2) + ':' + ("0" + new Date(date * 1000).getMinutes()).substr(-2) + ':' + ("0" + new Date(date * 1000).getSeconds()).substr(-2);
            return updatedTime;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setData(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                data = _state.data,
                order = _state.order,
                orderBy = _state.orderBy,
                filterData = _state.filterData,
                selected = _state.selected,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page;

            var filteredData = [];
            filterData.map(function (n, index) {
                var isSelected = _this4.isSelected(n.id);
                var batteryVoltage = n.data && n.data.vitals && n.data.vitals.batteryVoltage;
                var signalStrength = n.data && n.data.vitals && n.data.vitals.signalStrength;
                var status = n && n.status;
                var firmware = n.data && n.data.vitals && n.data.vitals.firmware;
                var time = n.data && n.data.vitals && _this4.formatDate(n.data.vitals.time);
                filteredData.push({
                    id: index,
                    nodeId: n.nodeId,
                    status: status,
                    time: time,
                    batteryVoltage: batteryVoltage,
                    signalStrength: signalStrength,
                    firmware: firmware,
                    n: n
                });
            });
            return _react2.default.createElement('div', { className: 'w-100 px-2 node-vitals' }, _react2.default.createElement(EnhancedTableToolbar, { openModal: function openModal() {
                    $("#searchModalComponent").modal();
                    _this4.props.passDataForFilter({ filteredData: filteredData, columnData: columnData });
                } }), _react2.default.createElement('div', { className: 'flex-auto', style: {
                    background: 'white'
                } }, _react2.default.createElement(_TableContainer2.default, { className: 'table-responsive-material',
                style: {
                    maxHeight: window.innerHeight - 300
                }
            }, _react2.default.createElement(_Table2.default, { stickyHeader: true }, _react2.default.createElement(EnhancedTableHead, {
                numSelected: selected.length,
                order: order,
                orderBy: orderBy,
                onSelectAllClick: this.handleSelectAllClick,
                onRequestSort: this.handleRequestSort,
                rowCount: data.length
            }), _react2.default.createElement(_TableBody2.default, null, data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (item) {
                var n = item.n ? item.n : item;
                var isSelected = _this4.isSelected(n.id);
                var batteryVoltage = n.data && n.data.vitals && n.data.vitals.batteryVoltage;
                var signalStrength = n.data && n.data.vitals && n.data.vitals.signalStrength;
                var status = n && n.status;
                return _react2.default.createElement(_TableRow2.default, {
                    hover: true
                    // onClick={event => this.handleClick(event, n.nodeId)}
                    // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                    , role: 'checkbox',
                    'aria-checked': isSelected,
                    tabIndex: -1,
                    key: n.nodeId,
                    selected: isSelected
                }, _react2.default.createElement(_TableCell2.default, {
                    onClick: function onClick(event) {
                        return _this4.handleClick(event, n.nodeId);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return _this4.handleKeyDown(event, n.nodeId);
                    },
                    padding: 'none',
                    id: 'deviceId'
                }, n.nodeId), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center' }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Status: ' + (status === "UNKNOWN" ? "NEVER ACTIVE" : status),
                    placement: 'bottom-end'
                }, _this4.getdeviceOnline(status))), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center' }, n.data && n.data.vitals && _this4.formatDate(n.data.vitals.time)), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center' }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Battery Level: ' + (batteryVoltage ? batteryVoltage : 'Not Available'),
                    placement: 'bottom-end'
                }, _this4.showBatteryLevel(batteryVoltage))), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center' }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Signal Strength: ' + (signalStrength ? signalStrength : 'Not Available'),
                    placement: 'bottom-end'
                }, _this4.showSignalLevel(signalStrength))), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, n.data && n.data.vitals && n.data.vitals.firmware));
            })))), _react2.default.createElement(_TablePagination2.default, {
                style: {
                    width: window.innerWidth
                },
                count: data.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onChangePage: this.handleChangePage,
                onChangeRowsPerPage: this.handleChangeRowsPerPage
            })));
        }
    }]);

    return EnhancedTable;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var symbioticReducer = _ref2.symbioticReducer;

    return {
        deviceId: symbioticReducer.deviceId,
        nodeVitalsData: symbioticReducer.nodeVitals,
        nodeVitalsFilter: symbioticReducer.nodeVitalsFilter
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateNodeVitalsData: function updateNodeVitalsData(data) {
            dispatch({ type: "NODE_VITALS_DATA", nodeVitals: data });
        },
        updateNodeVitalsFilterData: function updateNodeVitalsFilterData(data) {
            dispatch({ type: "NODE_VITALS_FILTER_DATA", nodeVitalsFilter: data });
        }
    };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnhancedTable);

exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(createData, 'createData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(counter, 'counter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(columnData, 'columnData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableHead, 'EnhancedTableHead', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableToolbar, 'EnhancedTableToolbar', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTable, 'EnhancedTable', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js');
}();

;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classnames2, "_classnames2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_propTypes2, "_propTypes2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_keycode2, "_keycode2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableFooter2, "_TableFooter2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Table2, "_Table2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableBody2, "_TableBody2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableCell2, "_TableCell2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableContainer2, "_TableContainer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableHead2, "_TableHead2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableSortLabel2, "_TableSortLabel2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TablePagination2, "_TablePagination2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableRow2, "_TableRow2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Toolbar2, "_Toolbar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Typography2, "_Typography2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Checkbox2, "_Checkbox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Tooltip2, "_Tooltip2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Delete2, "_Delete2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_FilterList2, "_FilterList2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(counter, "counter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(createData, "createData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(columnData, "columnData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableHead, "EnhancedTableHead", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableToolbar, "EnhancedTableToolbar", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTable, "EnhancedTable", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/nodeVitals/EnhancedTable.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(199);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
var tablelvl2 = {
  variant: 'footer'
};
var defaultComponent = 'tfoot';
var TableFooter = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableFooter(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableFooter.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableFooter'
})(TableFooter));

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPlainObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepmerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(197);


function isPlainObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(404);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
/* unused harmony default export */ var _unused_webpack_default_export = (elementAcceptingRef);

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(404);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export specialProperty */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFunctionName */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case __WEBPACK_IMPORTED_MODULE_1_react_is__["Memo"]:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* unused harmony default export */ var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]);
/* unused harmony default export */ var _unused_webpack_default_export = (refType);

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGenerateClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__ = __webpack_require__(795);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[__WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__["a" /* default */]] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function createStyles(styles) {
  return styles;
}

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThemeProps;
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jssPreset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__ = __webpack_require__(1792);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__["a" /* default */])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__["a" /* default */])()]
  };
}

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(114);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["createRule"])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (functionPlugin);


/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(114);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["RuleList"](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssGlobal);


/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(180);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssNested);


/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(517);


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["default"])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["default"])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(114);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["hasCSSTOMSupport"] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["hasCSSTOMSupport"] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["hasCSSTOMSupport"] && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (defaultUnit);


/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(114);



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" /* supportedKeyframes */])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" /* supportedProperty */])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["toCssValue"])(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["toCssValue"])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssVendorPrefixer);


/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(198);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["default"] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["default"]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["default"]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["default"]) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(797);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPropsSort);


/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeClasses__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StylesProvider__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indexCounter__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getStylesCreator__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__ = __webpack_require__(801);












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_3_jss__["getDynamicStyles"])(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__["a" /* default */] : _options$defaultTheme,
      stylesOptions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = Object(__WEBPACK_IMPORTED_MODULE_9__getStylesCreator__["a" /* default */])(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: Object(__WEBPACK_IMPORTED_MODULE_8__indexCounter__["a" /* increment */])(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;

    var stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__StylesProvider__["a" /* StylesContext */]), stylesOptions2);

    var instance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    var shouldUpdate = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(19);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (multiKeyStore);

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeContext__ = __webpack_require__(799);


function useTheme() {
  var theme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__ThemeContext__["a" /* default */]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = increment;
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__ = __webpack_require__(1799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__["a"]; });


/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStylesCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noopTheme__ = __webpack_require__(801);




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StylesProvider__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__ = __webpack_require__(264);








var ServerStyleSheets = /*#__PURE__*/function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new __WEBPACK_IMPORTED_MODULE_4_jss__["SheetsRegistry"](); // A new class name generator

      var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__["a" /* default */])();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StylesProvider__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();



/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__makeStyles__ = __webpack_require__(265);









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_7__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FinalComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: PropTypes
      /* @typescript-to-proptypes-ignore */
      .elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTheme__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nested__ = __webpack_require__(795);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = Object(__WEBPACK_IMPORTED_MODULE_5__useTheme__["a" /* default */])();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[__WEBPACK_IMPORTED_MODULE_6__nested__["a" /* default */]] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__["a" /* default */].Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (ThemeProvider);

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__makeStyles__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getThemeProps__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(166);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_6__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = Object(__WEBPACK_IMPORTED_MODULE_8__useTheme__["a" /* default */])() || defaultTheme;

        if (name) {
          more = Object(__WEBPACK_IMPORTED_MODULE_7__getThemeProps__["a" /* default */])({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createMuiTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createBreakpoints__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createMixins__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createPalette__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createTypography__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shadows__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__createSpacing__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transitions__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zIndex__ = __webpack_require__(820);













function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = Object(__WEBPACK_IMPORTED_MODULE_5__createPalette__["a" /* default */])(paletteInput);
  var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_3__createBreakpoints__["a" /* default */])(breakpointsInput);
  var spacing = Object(__WEBPACK_IMPORTED_MODULE_9__createSpacing__["a" /* default */])(spacingInput);
  var muiTheme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: Object(__WEBPACK_IMPORTED_MODULE_4__createMixins__["a" /* default */])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: __WEBPACK_IMPORTED_MODULE_7__shadows__["a" /* default */],
    typography: Object(__WEBPACK_IMPORTED_MODULE_6__createTypography__["a" /* default */])(palette, typographyInput),
    spacing: spacing,
    shape: __WEBPACK_IMPORTED_MODULE_8__shape__["a" /* default */],
    transitions: __WEBPACK_IMPORTED_MODULE_10__transitions__["a" /* default */],
    zIndex: __WEBPACK_IMPORTED_MODULE_11__zIndex__["a" /* default */]
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(acc, argument);
  }, muiTheme);

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://mui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var warnedOnce = false;
function createMuiTheme() {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the createMuiTheme function was renamed to createTheme.', '', "You should use `import { createTheme } from '@material-ui/core/styles'`"].join('\n'));
    }
  }

  return createTheme.apply(void 0, arguments);
}
/* harmony default export */ __webpack_exports__["a"] = (createTheme);

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keys */
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (false) {
      if (!warnedOnce) {
        warnedOnce = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
      }
    }

    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMixins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export light */
/* unused harmony export dark */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPalette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_common__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors_grey__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_indigo__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__colors_pink__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors_red__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colors_orange__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors_blue__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors_green__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colorManipulator__ = __webpack_require__(267);













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    default: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][800],
    default: '#303030'
  },
  action: {
    active: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["d" /* lighten */])(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["b" /* darken */])(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A200,
    main: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A400,
    dark: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["c" /* getContrastRatio */])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // A collection of common colors.
    common: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */],
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["a"] = (grey);

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["a"] = (indigo);

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["a"] = (pink);

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["a"] = (red);

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["a"] = (orange);

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["a"] = (blue);

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["a"] = (green);

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTypography;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(19);




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (false) {
    if (!warnedOnce) {
      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://mui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
      warnedOnce = true;
    }
  }

  return round(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ __webpack_exports__["a"] = (shadows);

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shape = {
  borderRadius: 4
};
/* harmony default export */ __webpack_exports__["a"] = (shape);

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(1820);

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["a" /* createUnarySpacing */])({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__borders__ = __webpack_require__(810);
/* unused harmony reexport borders */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__(408);
/* unused harmony reexport breakpoints */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(103);
/* unused harmony reexport compose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styleFunctionSx__ = __webpack_require__(812);
/* unused harmony reexport styleFunctionSx */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__display__ = __webpack_require__(1821);
/* unused harmony reexport display */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(813);
/* unused harmony reexport flexbox */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__grid__ = __webpack_require__(814);
/* unused harmony reexport grid */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__palette__ = __webpack_require__(815);
/* unused harmony reexport palette */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__positions__ = __webpack_require__(816);
/* unused harmony reexport positions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shadows__ = __webpack_require__(1822);
/* unused harmony reexport shadows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sizing__ = __webpack_require__(817);
/* unused harmony reexport sizing */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__spacing__ = __webpack_require__(818);
/* unused harmony reexport spacing */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__(90);
/* unused harmony reexport style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__typography__ = __webpack_require__(819);
/* unused harmony reexport typography */
/* unused harmony namespace reexport */
/** @license Material-UI v4.12.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
























/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export displayPrint */
/* unused harmony export displayRaw */
/* unused harmony export overflow */
/* unused harmony export textOverflow */
/* unused harmony export visibility */
/* unused harmony export whiteSpace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(103);


var displayPrint = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'display'
});
var overflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'overflow'
});
var textOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textOverflow'
});
var visibility = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'visibility'
});
var whiteSpace = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'whiteSpace'
});
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(90);

var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* unused harmony default export */ var _unused_webpack_default_export = (boxShadow);

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export easing */
/* unused harmony export duration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["duration", "easing", "delay"]);

    if (false) {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableContext__ = __webpack_require__(821);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent = 'table';
var Table = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'normal' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__TableContext__["a" /* default */].Provider, {
    value: table
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: Component === defaultComponent ? null : 'table',
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   * `default` is deprecated, use `normal` instead.
   */
  padding: chainPropTypes(PropTypes.oneOf(['normal', 'checkbox', 'none', 'default']), function (props) {
    if (props.padding === 'default') {
      return new Error('Material-UI: padding="default" was renamed to padding="normal" for consistency.');
    }

    return null;
  }),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTable'
})(Table));

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(199);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var defaultComponent = 'tbody';
var TableBody = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableBody'
})(TableBody));

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table_TableContext__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Table_Tablelvl2Context__ = __webpack_require__(199);











var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["d" /* lighten */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["a" /* alpha */])(theme.palette.divider, 1), 0.88) : Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["b" /* darken */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["a" /* alpha */])(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__Table_TableContext__["a" /* default */]);
  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__Table_Tablelvl2Context__["a" /* default */]);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(align))], padding !== 'normal' && classes["padding".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(padding))], size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
 false ? TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`normal`).
   * `default` is deprecated, use `normal` instead.
   */
  padding: chainPropTypes(PropTypes.oneOf(['normal', 'checkbox', 'none', 'default']), function (props) {
    if (props.padding === 'default') {
      return new Error('Material-UI: padding="default" was renamed to padding="normal" for consistency.');
    }

    return null;
  }),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableCell'
})(TableCell));

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);






var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    overflowX: 'auto'
  }
};
var TableContainer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableContainer(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className)
  }, other));
});
 false ? TableContainer.propTypes = {
  /**
   * The table itself, normally `<Table />`
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableContainer'
})(TableContainer));

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(199);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2 = {
  variant: 'head'
};
var defaultComponent = 'thead';
var TableHead = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableHead'
})(TableHead));

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(104);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:focus': {
        color: theme.palette.text.secondary
      },
      '&:hover': {
        color: theme.palette.text.secondary,
        '& $icon': {
          opacity: 0.5
        }
      },
      '&$active': {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        '&& $icon': {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the icon component. */
    icon: {
      fontSize: 18,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none'
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

var TableSortLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableSortLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'asc' : _props$direction,
      _props$hideSortIcon = props.hideSortIcon,
      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__["a" /* default */] : _props$IconComponent,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref: ref
  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["iconDirection".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(direction))])
  }));
});
 false ? TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: PropTypes.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The current sort direction.
   */
  direction: PropTypes.oneOf(['asc', 'desc']),

  /**
   * Hide sort icon when active is false.
   */
  hideSortIcon: PropTypes.bool,

  /**
   * Sort icon to use.
   */
  IconComponent: PropTypes.elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel));

/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(274);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgIcon__ = __webpack_require__(1836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SvgIcon__["a"]; });


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(104);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, titleAccess) : null);
});
 false ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: chainPropTypes(PropTypes.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
    var fontSize = props.fontSize;

    if (fontSize === 'default') {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }

    return null;
  }),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_deprecatedPropType__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TouchRipple__ = __webpack_require__(1839);













var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  function getButtonNode() {
    // #StrictMode ready
    return __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](buttonRef.current);
  }

  var rippleRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false);
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(buttonRefProp, ref);
  var handleOwnRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(focusVisibleRef, buttonRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(handleUserRef, handleOwnRef);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__TouchRipple__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
 false ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: deprecatedPropType(refType, 'Use `ref` instead.'),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonBase'
})(ButtonBase));

/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export teardown */
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsFocusVisible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    var node = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DELAY_RIPPLE */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Ripple__ = __webpack_require__(1840);









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["center", "classes", "className"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](0);
  var rippleCallback = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var container = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(oldRipples), [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Ripple__["a" /* default */], {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["TransitionGroup"], {
    component: null,
    exit: true
  }, ripples));
});
 false ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["memo"](TouchRipple)));

/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__ = __webpack_require__(412);




var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"];
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = Object(__WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__["a" /* default */])(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: childClassName
  }));
}

 false ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Ripple);

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_deprecatedPropType__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputBase__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuItem__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Select__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableCell__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Toolbar__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Typography__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TablePaginationActions__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__ = __webpack_require__(1889);
















var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      overflow: 'auto',
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      minHeight: 52,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },
    // TODO v5: `.selectRoot` should be merged with `.input`

    /* Styles applied to the Select component root element. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: 'right',
      textAlignLast: 'right' // Align <select> on Chrome.

    },
    // TODO v5: remove

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {},

    /* Styles applied to the `InputBase` component. */
    input: {
      color: 'inherit',
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};

var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
  var from = _ref.from,
      to = _ref.to,
      count = _ref.count;
  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};

var defaultRowsPerPageOptions = [10, 25, 50, 100];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TablePagination(props, ref) {
  var _props$ActionsCompone = props.ActionsComponent,
      ActionsComponent = _props$ActionsCompone === void 0 ? __WEBPACK_IMPORTED_MODULE_14__TablePaginationActions__["a" /* default */] : _props$ActionsCompone,
      backIconButtonProps = props.backIconButtonProps,
      _props$backIconButton = props.backIconButtonText,
      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
      classes = props.classes,
      className = props.className,
      colSpanProp = props.colSpan,
      _props$component = props.component,
      Component = _props$component === void 0 ? __WEBPACK_IMPORTED_MODULE_11__TableCell__["default"] : _props$component,
      count = props.count,
      _props$labelDisplayed = props.labelDisplayedRows,
      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
      _props$labelRowsPerPa = props.labelRowsPerPage,
      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
      nextIconButtonProps = props.nextIconButtonProps,
      _props$nextIconButton = props.nextIconButtonText,
      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
      onChangePage = props.onChangePage,
      onPageChange = props.onPageChange,
      onChangeRowsPerPageProp = props.onChangeRowsPerPage,
      onRowsPerPageChangeProp = props.onRowsPerPageChange,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      _props$rowsPerPageOpt = props.rowsPerPageOptions,
      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
      _props$SelectProps = props.SelectProps,
      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onPageChange", "onChangeRowsPerPage", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);

  var onChangeRowsPerPage = onChangeRowsPerPageProp || onRowsPerPageChangeProp;
  var colSpan;

  if (Component === __WEBPACK_IMPORTED_MODULE_11__TableCell__["default"] || Component === 'td') {
    colSpan = colSpanProp || 1000; // col-span over everything
  }

  var selectId = Object(__WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__["a" /* default */])();
  var labelId = Object(__WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__["a" /* default */])();
  var MenuItemComponent = SelectProps.native ? 'option' : __WEBPACK_IMPORTED_MODULE_9__MenuItem__["a" /* default */];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    colSpan: colSpan,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Toolbar__["a" /* default */], {
    className: classes.toolbar
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.spacer
  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption,
    id: labelId
  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Select__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: {
      select: classes.select,
      icon: classes.selectIcon
    },
    input: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__InputBase__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, classes.selectRoot)
    }),
    value: rowsPerPage,
    onChange: onChangeRowsPerPage,
    id: selectId,
    labelId: labelId
  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](MenuItemComponent, {
      className: classes.menuItem,
      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelDisplayedRows({
    from: count === 0 ? 0 : page * rowsPerPage + 1,
    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
    count: count === -1 ? -1 : count,
    page: page
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ActionsComponent, {
    className: classes.actions,
    backIconButtonProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      title: backIconButtonText,
      'aria-label': backIconButtonText
    }, backIconButtonProps),
    count: count,
    nextIconButtonProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      title: nextIconButtonText,
      'aria-label': nextIconButtonText
    }, nextIconButtonProps),
    onChangePage: onChangePage,
    onPageChange: onPageChange,
    page: page,
    rowsPerPage: rowsPerPage
  })));
});
 false ? TablePagination.propTypes = {
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   */
  ActionsComponent: PropTypes.elementType,

  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * Text label for the back arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  backIconButtonText: PropTypes.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  colSpan: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: PropTypes.number.isRequired,

  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelDisplayedRows: PropTypes.func,

  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelRowsPerPage: PropTypes.node,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Text label for the next arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  nextIconButtonText: PropTypes.string,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   * @deprecated Use the onPageChange prop instead.
   */
  onChangePage: deprecatedPropType(PropTypes.func, 'Use the `onPageChange` prop instead.'),

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   * @deprecated Use the onRowsPerPageChange prop instead.
   */
  onChangeRowsPerPage: deprecatedPropType(PropTypes.func, 'Use the `onRowsPerPageChange` prop instead.'),

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   */
  onRowsPerPageChange: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(PropTypes.number.isRequired, function (props) {
    var count = props.count,
        page = props.page,
        rowsPerPage = props.rowsPerPage;

    if (count === -1) {
      return null;
    }

    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    if (page < 0 || page > newLastPage) {
      return new Error('Material-UI: The page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
    }

    return null;
  }),

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: PropTypes.array,

  /**
   * Props applied to the rows per page [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTablePagination'
})(TablePagination));

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(824);




/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */











var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_3_react__["useLayoutEffect"];
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className,
      color = props.color,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment,
      error = props.error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      margin = props.margin,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      maxRows = props.maxRows,
      minRows = props.minRows,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var handleInputRefWarning = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (instance) {
    if (false) {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRef, handleInputRefProp);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* isFilled */])(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minRows: rows || minRows,
        rowsMax: rowsMax,
        maxRows: maxRows
      }, inputProps);
      InputComponent = __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__["a" /* default */];
    }
  } else {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
 false ? InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputBase'
})(InputBase));

/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__ = __webpack_require__(1844);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__["a"]; });


/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_deprecatedPropType__ = __webpack_require__(143);








function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var styles = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMinProp = props.rowsMin,
      maxRowsProp = props.maxRows,
      _props$minRows = props.minRows,
      minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows,
      style = props.style,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);

  var maxRows = maxRowsProp || rowsMax;
  var minRows = rows || rowsMinProp || minRowsProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])(ref, inputRef);
  var shadowRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var renders = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](0);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"]({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (false) {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function () {
    syncHeight();
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: minRows,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.shadow, style)
  }));
});
 false ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  placeholder: PropTypes.string,

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rows: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `maxRows` instead.'),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosize);

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuItem__ = __webpack_require__(1846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuItem__["a"]; });


/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ListItem__ = __webpack_require__(1847);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ListItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      dense: classes.dense
    }, ListItemClasses),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
   */
  ListItemClasses: PropTypes.object,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItem__ = __webpack_require__(1848);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItem__["a"]; });


/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List_ListContext__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */]);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(childrenProp);
  var hasSecondaryAction = children.length && Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listItemRef.current = __WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);

  var componentProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName);
    Component = __WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */];
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
      value: childContext
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ContainerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
    value: childContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef
  }, componentProps), children));
});
 false ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItem'
})(ListItem));

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMuiElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });


/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_styles__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectInput__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Input__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FilledInput__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OutlinedInput__ = __webpack_require__(1877);















var styles = __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__["a" /* styles */];

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Input__["a" /* default */], null);

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__FilledInput__["a" /* default */], null);

var Select = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__SelectInput__["a" /* default */];
  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__OutlinedInput__["a" /* default */], {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_styles__["b" /* mergeClasses */])({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: PropTypes.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select.muiName = 'Select';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSelect'
})(Select));

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Menu_Menu__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InputBase_utils__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useControlled__ = __webpack_require__(1872);

















function areEqualValues(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex,
      type = props.type,
      valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" /* default */])(ref, inputRefProp);
  __WEBPACK_IMPORTED_MODULE_5_react__["useImperativeHandle"](handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (displayNode) {
      var label = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__["a" /* default */])(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (Object(__WEBPACK_IMPORTED_MODULE_12__InputBase_utils__["a" /* isFilled */])({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_utils__["b" /* formatMuiErrorMessage */])(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Menu_Menu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, MenuProps.PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,

  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  type: PropTypes.any,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SelectInput);

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popover__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuList__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_setRef__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_deprecatedPropType__ = __webpack_require__(143);














var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEnteringProp = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps;
  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;

  var onEntering = _props$TransitionProp.onEntering,
      TransitionProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$TransitionProp, ["onEntering"]),
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var contentAnchorRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEnteringProp) {
      onEnteringProp(element, isAppearing);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = __WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"](instance);
          Object(__WEBPACK_IMPORTED_MODULE_11__utils_setRef__["a" /* default */])(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    TransitionProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      onEntering: handleEntering
    }, TransitionProps),
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__MenuList__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.list, MenuListProps.className)
  }), items));
});
 false ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the Menu exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the menu is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
   */
  TransitionProps: PropTypes.object,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenu'
})(Menu));

/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(1855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["a"]; });


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOffsetTop */
/* unused harmony export getOffsetLeft */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_deprecatedPropType__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modal__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Grow__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Paper__ = __webpack_require__(1866);
















function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_14__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (false) {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (false) {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (false) {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (false) {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    paperRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      setPositioningStyles();
    }
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open) {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(getAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the popover is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: elementTypeAcceptingRef
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPopover'
})(Popover));

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalManager__ = __webpack_require__(828);
/* unused harmony reexport ModalManager */



/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_deprecatedPropType__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Portal__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_useEventCallback__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_zIndex__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ModalManager__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Unstable_TrapFocus__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SimpleBackdrop__ = __webpack_require__(1862);


















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return __WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"](container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new __WEBPACK_IMPORTED_MODULE_14__ModalManager__["b" /* default */]();
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Modal(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["c" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["a" /* getThemeProps */])({
    name: 'MuiModal',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? __WEBPACK_IMPORTED_MODULE_16__SimpleBackdrop__["a" /* default */] : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({});
  var mountNodeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var modalRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useForkRef__["a" /* default */])(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = Object(__WEBPACK_IMPORTED_MODULE_12__utils_useEventCallback__["a" /* default */])(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = Object(__WEBPACK_IMPORTED_MODULE_12__utils_useEventCallback__["a" /* default */])(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_14__ModalManager__["a" /* ariaHidden */])(modalRef.current, true);
    }
  });
  var handleClose = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    manager.remove(getModal());
  }, [manager]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = styles(theme || {
    zIndex: __WEBPACK_IMPORTED_MODULE_13__styles_zIndex__["a" /* default */]
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEnter, children.props.onEnter);
    childProps.onExited = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Portal__["a" /* default */], {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](BackdropComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Unstable_TrapFocus__["a" /* default */], {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, childProps))));
});
 false ? Modal.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: PropTypes.bool,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */
  disableBackdropClick: deprecatedPropType(PropTypes.bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire `onClose`.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: PropTypes.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: PropTypes.bool,

  /**
   * @ignore
   */
  manager: PropTypes.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be removed in v5, the ref can be used instead.
   */
  onRendered: deprecatedPropType(PropTypes.func, 'Use the ref instead.'),

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(1859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_deprecatedPropType__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_setRef__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__ = __webpack_require__(91);








function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_setRef__["a" /* default */])(ref, mountNode);
      return function () {
        Object(__WEBPACK_IMPORTED_MODULE_5__utils_setRef__["a" /* default */])(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](children, mountNode) : mountNode;
});
 false ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be removed in v5, the ref can be used instead.
   * @deprecated Use the ref instead.
   */
  onRendered: deprecatedPropType(PropTypes.func, 'Use the ref instead.')
} : void 0;

if (false) {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__ = __webpack_require__(1861);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__["a"]; });


/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */






/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var sentinelStart = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var sentinelEnd = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var nodeToRestore = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var rootRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    // #StrictMode ready
    rootRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var prevOpenRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (!open) {
      return;
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {
          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
    ref: handleRef
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? Unstable_TrapFocus.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.node,

  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: PropTypes.func.isRequired,

  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: PropTypes.func.isRequired,

  /**
   * If `true`, focus will be locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;

if (false) {
  // eslint-disable-next-line
  Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Unstable_TrapFocus);

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? SimpleBackdrop.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SimpleBackdrop);

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grow__ = __webpack_require__(1864);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grow__["a"]; });


/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions_utils__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(91);










function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["Transition"] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var autoTimeout = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Grow);

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reflow; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionProps;
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paper__ = __webpack_require__(1867);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paper__["a"]; });


/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuList__ = __webpack_require__(1869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuList__["a"]; });


/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(91);











function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var textCriteriaRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__["a" /* default */])(true), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = Object(__WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__["a" /* default */])(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listRef.current = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__List__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (MenuList);

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1871);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });


/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListContext__ = __webpack_require__(825);







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ListContext__["a" /* default */].Provider, {
    value: context
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiList'
})(List));

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useControlled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(29);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInput'
})(Input));

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Input__ = __webpack_require__(832);










var styles = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Input__["a" /* default */], null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](input, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__["a" /* default */],
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect));

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilledInput__ = __webpack_require__(1876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilledInput__["a"]; });


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(29);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFilledInput'
})(FilledInput));

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__ = __webpack_require__(1878);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__["a"]; });


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotchedOutline__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(29);









var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NotchedOutline__["a" /* default */], {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: PropTypes.node,

  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput));

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(104);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function NotchedOutline(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-hidden": true,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", null, label) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "padding".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(align)), 8), style),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
 false ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The label.
   */
  label: PropTypes.node,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline));

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(1881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiToolbar'
})(Toolbar));

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Typography__ = __webpack_require__(1883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Typography__["a"]; });


/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(104);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], display !== 'initial' && classes["display".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(display))]),
    ref: ref
  }, other));
});
 false ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTypography'
})(Typography));

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton__ = __webpack_require__(1887);








/**
 * @ignore - internal component.
 */

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var TablePaginationActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TablePaginationActions(props, ref) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      _props$onChangePage = props.onChangePage,
      onChangePage = _props$onChangePage === void 0 ? function () {} : _props$onChangePage,
      _props$onPageChange = props.onPageChange,
      onPageChange = _props$onPageChange === void 0 ? function () {} : _props$onPageChange,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "onPageChange", "page", "rowsPerPage"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
    onPageChange(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
    onPageChange(event, page + 1);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleNextButtonClick,
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
});
 false ? TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: PropTypes.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TablePaginationActions);

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(274);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(274);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconButton__ = __webpack_require__(1888);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconButton__["a"]; });


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(104);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))], disabled && classes.disabled, size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(267);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent ? null : 'row'
  }, other));
});
 false ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableRow'
})(TableRow));

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = __webpack_require__(414);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

var _IndeterminateCheckBox = __webpack_require__(1898);

var _IndeterminateCheckBox2 = _interopRequireDefault(_IndeterminateCheckBox);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    default: {
      color: theme.palette.text.secondary
    },
    checked: {},
    checkedPrimary: {
      color: theme.palette.primary.main
    },
    checkedSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};

function Checkbox(props) {
  var _classNames;

  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties3.default)(props, ['checkedIcon', 'classes', 'color', 'icon', 'indeterminate', 'indeterminateIcon']);

  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      default: classes.default,
      checked: checkedClass,
      disabled: classes.disabled
    },
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes2.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes2.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Checkbox.defaultProps = {
  color: 'secondary',
  indeterminate: false,
  indeterminateIcon: _react2.default.createElement(_IndeterminateCheckBox2.default, null)
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCheckbox' })(Checkbox);

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' });

var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBoxOutlineBlank = (0, _pure2.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = CheckBoxOutlineBlank;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(834);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(191);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(361);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function SvgIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'nativeColor', 'titleAccess', 'viewBox']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), classNameProp);

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({
      className: className,
      focusable: 'false',
      viewBox: viewBox,
      color: nativeColor,
      'aria-hidden': titleAccess ? 'false' : 'true'
    }, other),
    titleAccess ? _react2.default.createElement(
      'title',
      null,
      titleAccess
    ) : null,
    children
  );
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes2.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes2.default.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes2.default.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};

SvgIcon.defaultProps = {
  color: 'inherit',
  viewBox: '0 0 24 24'
};

SvgIcon.muiName = 'SvgIcon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSvgIcon' })(SvgIcon);

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' });

var CheckBox = function CheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBox = (0, _pure2.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';

exports.default = CheckBox;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' });

var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
IndeterminateCheckBox = (0, _pure2.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';

exports.default = IndeterminateCheckBox;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPopper = __webpack_require__(1900);

var _helpers = __webpack_require__(35);

var _RefHolder = __webpack_require__(563);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _common = __webpack_require__(340);

var _common2 = _interopRequireDefault(_common);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, no-underscore-dangle */

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline',
      flexDirection: 'inherit' // Makes the wrapper more transparent.
    },
    popper: {
      zIndex: theme.zIndex.tooltip
    },
    popperClose: {
      pointerEvents: 'none'
    },
    tooltip: (0, _defineProperty3.default)({
      backgroundColor: theme.palette.grey[700],
      borderRadius: 2,
      color: _common2.default.white,
      fontFamily: theme.typography.fontFamily,
      opacity: 0,
      transform: 'scale(0)',
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      minHeight: 0,
      padding: theme.spacing.unit,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.round(16 / 14) + 'em'
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing.unit / 2 + 'px ' + theme.spacing.unit + 'px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.round(14 / 10) + 'em'
    }),
    tooltipPlacementLeft: (0, _defineProperty3.default)({
      transformOrigin: 'right center',
      margin: '0 ' + theme.spacing.unit * 3 + 'px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),
    tooltipPlacementRight: (0, _defineProperty3.default)({
      transformOrigin: 'left center',
      margin: '0 ' + theme.spacing.unit * 3 + 'px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),
    tooltipPlacementTop: (0, _defineProperty3.default)({
      transformOrigin: 'center bottom',
      margin: theme.spacing.unit * 3 + 'px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),
    tooltipPlacementBottom: (0, _defineProperty3.default)({
      transformOrigin: 'center top',
      margin: theme.spacing.unit * 3 + 'px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),
    tooltipOpen: {
      opacity: 0.9,
      transform: 'scale(1)'
    }
  };
};

function flipPlacement(placement) {
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';
    case 'bottom-start':
      return 'bottom-end';
    case 'top-end':
      return 'top-start';
    case 'top-start':
      return 'top-end';
    default:
      return placement;
  }
}

var Tooltip = function (_React$Component) {
  (0, _inherits3.default)(Tooltip, _React$Component);

  function Tooltip(props, context) {
    (0, _classCallCheck3.default)(this, Tooltip);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call(this, props, context));

    _this.state = {};
    _this.enterTimer = null;
    _this.leaveTimer = null;
    _this.touchTimer = null;
    _this.isControlled = null;
    _this.popper = null;
    _this.children = null;
    _this.ignoreNonTouchEvents = false;
    _this.handleResize = (0, _debounce2.default)(function () {
      if (_this.popper) {
        _this.popper._popper.scheduleUpdate();
      }
    }, 166);

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;

      var childrenProps = children.props;

      if (event.type === 'focus' && childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);
      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      if (!_this.isControlled) {
        _this.setState({ open: true });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event, true);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;

      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);
      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      _this.ignoreNonTouchEvents = false;

      if (!_this.isControlled) {
        _this.setState({ open: false });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event, false);
      }
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;

      var childrenProps = children.props;

      if (childrenProps.onTouchStart) {
        childrenProps.onTouchStart(event);
      }

      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;

      var childrenProps = children.props;

      if (childrenProps.onTouchEnd) {
        childrenProps.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;
    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }
    return _this;
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
       false ? (0, _warning2.default)(!this.children || !this.children.disabled || !this.children.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled button children to the Tooltip component.', 'A disabled element do not fire events.', 'But the Tooltip needs to listen to the children element events to display the title.', '', 'Place a `div` over top of the element.'].join('\n')) : void 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
      this.handleResize.cancel();
    } // Corresponds to 10 frames at 60 Hz.

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disableTriggerFocus = _props.disableTriggerFocus,
          disableTriggerHover = _props.disableTriggerHover,
          disableTriggerTouch = _props.disableTriggerTouch,
          enterDelay = _props.enterDelay,
          enterTouchDelay = _props.enterTouchDelay,
          id = _props.id,
          leaveDelay = _props.leaveDelay,
          leaveTouchDelay = _props.leaveTouchDelay,
          onClose = _props.onClose,
          onOpen = _props.onOpen,
          openProp = _props.open,
          placementProp = _props.placement,
          _props$PopperProps = _props.PopperProps;
      _props$PopperProps = _props$PopperProps === undefined ? {} : _props$PopperProps;
      var PopperClassName = _props$PopperProps.className,
          PopperOther = (0, _objectWithoutProperties3.default)(_props$PopperProps, ['className']),
          theme = _props.theme,
          title = _props.title,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disableTriggerFocus', 'disableTriggerHover', 'disableTriggerTouch', 'enterDelay', 'enterTouchDelay', 'id', 'leaveDelay', 'leaveTouchDelay', 'onClose', 'onOpen', 'open', 'placement', 'PopperProps', 'theme', 'title']);


      var placement = theme.direction === 'rtl' ? flipPlacement(placementProp) : placementProp;
      var open = this.isControlled ? openProp : this.state.open;
      var childrenProps = {
        'aria-describedby': id
      };

      if (title === '') {
        open = false;
      }

      if (!disableTriggerTouch) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableTriggerHover) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableTriggerFocus) {
        childrenProps.onFocus = this.handleEnter;
        childrenProps.onBlur = this.handleLeave;
      }

       false ? (0, _warning2.default)(!children.props.title, ['Material-UI: you have been providing a `title` property to the child of <Tooltip />.', 'Remove this title property `' + children.props.title + '` or the Tooltip component.'].join('\n')) : void 0;

      return _react2.default.createElement(
        _reactEventListener2.default,
        { target: 'window', onResize: this.handleResize },
        _react2.default.createElement(
          _reactPopper.Manager,
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
          _react2.default.createElement(
            _reactPopper.Target,
            null,
            function (_ref) {
              var targetProps = _ref.targetProps;
              return _react2.default.createElement(
                _RefHolder2.default,
                {
                  ref: function ref(node) {
                    _this2.children = (0, _reactDom.findDOMNode)(node);
                    targetProps.ref(_this2.children);
                  }
                },
                _react2.default.cloneElement(children, childrenProps)
              );
            }
          ),
          _react2.default.createElement(
            _reactPopper.Popper,
            (0, _extends3.default)({
              placement: placement,
              eventsEnabled: open,
              className: (0, _classnames2.default)(classes.popper, (0, _defineProperty3.default)({}, classes.popperClose, !open), PopperClassName),
              ref: function ref(node) {
                _this2.popper = node;
              }
            }, PopperOther),
            function (_ref2) {
              var popperProps = _ref2.popperProps,
                  restProps = _ref2.restProps;

              var actualPlacement = popperProps['data-placement'] || placement;
              return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, popperProps, restProps, {
                  style: (0, _extends3.default)({}, popperProps.style, {
                    top: popperProps.style.top || 0,
                    left: popperProps.style.left || 0
                  }, restProps.style)
                }),
                _react2.default.createElement(
                  'div',
                  {
                    id: id,
                    role: 'tooltip',
                    'aria-hidden': !open,
                    className: (0, _classnames2.default)(classes.tooltip, (0, _defineProperty3.default)({}, classes.tooltipOpen, open), classes['tooltipPlacement' + (0, _helpers.capitalize)(actualPlacement.split('-')[0])])
                  },
                  title
                )
              );
            }
          )
        )
      );
    }
  }]);
  return Tooltip;
}(_react2.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Do not respond to focus events.
   */
  disableTriggerFocus: _propTypes2.default.bool,
  /**
   * Do not respond to hover events.
   */
  disableTriggerHover: _propTypes2.default.bool,
  /**
   * Do not respond to long press touch events.
   */
  disableTriggerTouch: _propTypes2.default.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes2.default.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes2.default.number,
  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * By providing this property, we can use aria-describedby to solve the accessibility issue.
   */
  id: _propTypes2.default.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes2.default.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes2.default.number,
  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes2.default.bool,
  /**
   * Tooltip placement
   */
  placement: _propTypes2.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Properties applied to the `Popper` element.
   */
  PopperProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes2.default.node.isRequired
} : {};

Tooltip.defaultProps = {
  disableTriggerFocus: false,
  disableTriggerHover: false,
  disableTriggerTouch: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTooltip', withTheme: true })(Tooltip);

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(1901);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(1902);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(1903);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(1905);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(1904);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }
      this._popper = new _popper2.default(this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _awsManager = __webpack_require__(59);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactstrap = __webpack_require__(92);

var _filterModal = __webpack_require__(387);

var _filterModal2 = _interopRequireDefault(_filterModal);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _highlightSidebarOption = __webpack_require__(140);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(30);

var _filterFunction = __webpack_require__(403);

var _lodash = __webpack_require__(165);

var _lodash2 = _interopRequireDefault(_lodash);

var _EnhancedTable = __webpack_require__(1907);

var _EnhancedTable2 = _interopRequireDefault(_EnhancedTable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DeviceCatalogue = function (_Component) {
  _inherits(DeviceCatalogue, _Component);

  function DeviceCatalogue(props) {
    _classCallCheck(this, DeviceCatalogue);

    var _this = _possibleConstructorReturn(this, (DeviceCatalogue.__proto__ || Object.getPrototypeOf(DeviceCatalogue)).call(this, props));

    _this.state = {
      // nodeVitalsData: []
      filterData: []
    };
    return _this;
  }

  _createClass(DeviceCatalogue, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _awsManager.getDeviceCatalogue)(this.props.deviceId).then(function (data) {
        if (_this2.props.deviceCatalogueFilters.length > 0) {
          _this2.props.updateDeviceCatalogueData({ data: data, pageNumber: _this2.props.deviceCatalogue.pageNumber });
          // let items = filterDeviceCatalogueData(data);
          var filterData = (0, _filterFunction.filterRecords)(data, _this2.props.deviceCatalogueFilters);
          _this2.props.updateDeviceCatalogueFilterData({ data: filterData, pageNumber: _this2.props.deviceCatalogue.pageNumber });
          _this2.props.addDeviceCatalogueFilter([]);
        } else {
          _this2.props.updateDeviceCatalogueData({ data: data, pageNumber: _this2.props.deviceCatalogue.pageNumber });
          _this2.props.updateDeviceCatalogueFilterData({ data: data, pageNumber: _this2.props.deviceCatalogue.pageNumber });
        }
      }).catch(function (error) {
        console.log('error: ', error);
      });
      this.currentPath = this.props.location.pathname;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      this.unlisten = this.props.history.listen(function (location) {
        _this3.currentPath = location.pathname;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement("div", { className: "row configuration-page" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "jr-card d-sm-flex justify-content-sm-between align-items-sm-center" }, _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-10" }, _react2.default.createElement("h1", { className: "mb-0" }, "Device Catalogue")), _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-2" }))), _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement(_filterModal2.default, {
        filter: this.props.deviceCatalogueFilters,
        data: this.state.filterData,
        setFilteredData: function setFilteredData(data) {
          _this4.props.updateDeviceCatalogueFilterData({ data: data, pageNumber: 0 });
        } }), _react2.default.createElement("div", { className: "row" }, _react2.default.createElement(_EnhancedTable2.default, {
        passDataForFilter: function passDataForFilter(item) {
          _this4.setState({
            filterData: item
          });
        },
        updateDeviceId: function updateDeviceId(deviceId) {
          _this4.props.updateDeviceId(deviceId);
          if (!(_this4.currentPath === "/app/components/heartbeat" || _this4.currentPath === "/app/components/notifications")) {
            (0, _highlightSidebarOption.highlightNavigatedMenu)("heartbeat", "#" + _this4.currentPath);
            _this4.props.history.push("/app/components/heartbeat");
          }
        } }))));
    }
  }]);

  return DeviceCatalogue;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var symbioticReducer = _ref.symbioticReducer;

  return {
    deviceId: symbioticReducer.deviceId,
    deviceCatalogue: symbioticReducer.deviceCatalogue,
    deviceCatalogueFilters: symbioticReducer.deviceCatalogueFilters
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateDeviceId: function updateDeviceId(id) {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateDeviceCatalogueData: function updateDeviceCatalogueData(data) {
      dispatch({ type: "DEVICE_CATELOGUE_DATA", deviceCatalogue: data });
    },
    addDeviceCatalogueFilter: function addDeviceCatalogueFilter(data) {
      dispatch({
        type: 'DEVICE_CATALOGUE_FILTER',
        deviceCatalogueFilters: data
      });
    },

    updateDeviceCatalogueFilterData: function updateDeviceCatalogueFilterData(data) {
      dispatch({ type: "DEVICE_CATELOGUE_FILTER_DATA", deviceCatalogueFilter: data });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DeviceCatalogue);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeviceCatalogue, "DeviceCatalogue", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_filterModal2, "_filterModal2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_moment2, "_moment2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_lodash2, "_lodash2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_EnhancedTable2, "_EnhancedTable2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(DeviceCatalogue, "DeviceCatalogue", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/index.js");
}();

;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _reactRedux = __webpack_require__(30);

var _TableFooter = __webpack_require__(261);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _Table = __webpack_require__(269);

var _Table2 = _interopRequireDefault(_Table);

var _TableBody = __webpack_require__(270);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableCell = __webpack_require__(200);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableContainer = __webpack_require__(271);

var _TableContainer2 = _interopRequireDefault(_TableContainer);

var _TableHead = __webpack_require__(272);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TablePagination = __webpack_require__(275);

var _TablePagination2 = _interopRequireDefault(_TablePagination);

var _TableRow = __webpack_require__(278);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableSortLabel = __webpack_require__(273);

var _TableSortLabel2 = _interopRequireDefault(_TableSortLabel);

var _Toolbar = __webpack_require__(137);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _Checkbox = __webpack_require__(168);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Tooltip = __webpack_require__(167);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Delete = __webpack_require__(279);

var _Delete2 = _interopRequireDefault(_Delete);

var _FilterList = __webpack_require__(280);

var _FilterList2 = _interopRequireDefault(_FilterList);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return { id: counter, name: name, calories: calories, fat: fat, carbs: carbs, protein: protein };
}

var columnData = [{ id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' }, { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator', type: 'string' }, { id: 'time', numeric: false, disablePadding: false, label: 'Last Seen', type: 'date' }, { id: 'current1', numeric: true, disablePadding: true, label: 'Current 1', type: 'number' }, { id: 'current2', numeric: true, disablePadding: false, label: 'Current 2', type: 'number' }, { id: 'temperature1', numeric: true, disablePadding: false, label: 'Temperature 1', type: 'number' }, { id: 'temperature2', numeric: true, disablePadding: false, label: 'Temperature 2', type: 'number' }, { id: 'temperature3', numeric: true, disablePadding: false, label: 'Temperature 3', type: 'number' }, { id: 'water', numeric: true, disablePadding: false, label: 'Water', type: 'number' }, { id: 'lid', numeric: false, disablePadding: false, label: 'Lid' }];

var EnhancedTableHead = function (_React$Component) {
    _inherits(EnhancedTableHead, _React$Component);

    function EnhancedTableHead() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, EnhancedTableHead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnhancedTableHead.__proto__ || Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref, [this].concat(args))), _this), _this.createSortHandler = function (property) {
            return function (event) {
                _this.props.onRequestSort(event, property);
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnhancedTableHead, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                onSelectAllClick = _props.onSelectAllClick,
                order = _props.order,
                orderBy = _props.orderBy,
                numSelected = _props.numSelected,
                rowCount = _props.rowCount;

            return _react2.default.createElement(_TableHead2.default, null, _react2.default.createElement(_TableRow2.default, null, columnData.map(function (column) {
                return _react2.default.createElement(_TableCell2.default, {
                    style: {
                        background: '#E2E3E5'
                    },
                    className: column.id !== 'deviceId' && "text-center",
                    key: column.id,
                    numeric: column.numeric,
                    padding: column.disablePadding ? 'none' : 'default'
                }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Sort',
                    placement: column.numeric ? 'bottom-end' : 'bottom-start',
                    enterDelay: 300
                }, _react2.default.createElement(_TableSortLabel2.default, {
                    active: orderBy === column.id,
                    direction: order,
                    onClick: _this2.createSortHandler(column.id)
                }, column.label)));
            }, this)));
        }
    }]);

    return EnhancedTableHead;
}(_react2.default.Component);

EnhancedTableHead.propTypes = {
    numSelected: _propTypes2.default.number.isRequired,
    onRequestSort: _propTypes2.default.func.isRequired,
    onSelectAllClick: _propTypes2.default.func.isRequired,
    order: _propTypes2.default.string.isRequired,
    orderBy: _propTypes2.default.string.isRequired,
    rowCount: _propTypes2.default.number.isRequired
};

var EnhancedTableToolbar = function EnhancedTableToolbar(props) {
    var numSelected = props.numSelected;

    return _react2.default.createElement(_Toolbar2.default, {
        className: (0, _classnames2.default)("table-header", _defineProperty({}, "highlight-light", numSelected > 0))
    }, _react2.default.createElement('div', { className: 'title' }, _react2.default.createElement(_Typography2.default, { type: 'title' }, 'Add Filter')), _react2.default.createElement('div', { className: 'actions' }, numSelected > 0 ? _react2.default.createElement(_Tooltip2.default, { title: 'Delete' }, _react2.default.createElement(_IconButton2.default, { 'aria-label': 'Delete' }, _react2.default.createElement(_Delete2.default, null))) : _react2.default.createElement(_Tooltip2.default, { title: 'Filter list' }, _react2.default.createElement(_IconButton2.default, { 'aria-label': 'Filter list' }, _react2.default.createElement(_FilterList2.default, { onClick: function onClick() {
            props.openModal();
        } })))));
};

EnhancedTableToolbar.propTypes = {
    numSelected: _propTypes2.default.number.isRequired
};

var EnhancedTable = function (_React$Component2) {
    _inherits(EnhancedTable, _React$Component2);

    function EnhancedTable(props, context) {
        _classCallCheck(this, EnhancedTable);

        var _this3 = _possibleConstructorReturn(this, (EnhancedTable.__proto__ || Object.getPrototypeOf(EnhancedTable)).call(this, props, context));

        _this3.handleRequestSort = function (event, property) {
            var orderBy = property;
            var order = 'desc';
            if (_this3.state.orderBy === property && _this3.state.order === 'desc') {
                order = 'asc';
            }
            var data = [];
            if (orderBy === 'nodeId' || orderBy === 'status') {
                data = order === 'desc' ? _this3.state.data.sort(function (a, b) {
                    return b[orderBy] < a[orderBy] ? -1 : 1;
                }) : _this3.state.data.sort(function (a, b) {
                    return a[orderBy] < b[orderBy] ? -1 : 1;
                });
            } else {
                data = order === 'desc' ? _this3.state.data.sort(function (aItem, bItem) {
                    var a = aItem.n ? aItem.n : aItem;
                    var b = bItem.n ? bItem.n : bItem;
                    return (b.data && b.data.sensors && b.data.sensors[orderBy] !== undefined && b.data.sensors[orderBy]) < (a.data && a.data.sensors && a.data.sensors[orderBy] !== undefined && a.data.sensors[orderBy]) ? -1 : 1;
                }) : _this3.state.data.sort(function (aItem, bItem) {
                    var a = aItem.n ? aItem.n : aItem;
                    var b = bItem.n ? bItem.n : bItem;
                    return (a.data && a.data.sensors && a.data.sensors[orderBy] !== undefined && a.data.sensors[orderBy]) < (b.data && b.data.sensors && b.data.sensors[orderBy] !== undefined && b.data.sensors[orderBy]) ? -1 : 1;
                });
            }
            _this3.setState({ data: data, order: order, orderBy: orderBy });
        };

        _this3.handleSelectAllClick = function (event, checked) {
            if (checked) {
                _this3.setState({ selected: _this3.state.data.map(function (n) {
                        return n.id;
                    }) });
                return;
            }
            _this3.setState({ selected: [] });
        };

        _this3.handleKeyDown = function (event, id) {
            if ((0, _keycode2.default)(event) === 'space') {
                _this3.handleClick(event, id);
            }
        };

        _this3.handleClick = function (event, deviceId) {
            _this3.props.updateDeviceId(deviceId);
            // const { selected } = this.state;
            // const selectedIndex = selected.indexOf(id);
            // let newSelected = [];

            // if (selectedIndex === -1) {
            //     newSelected = newSelected.concat(selected, id);
            // } else if (selectedIndex === 0) {
            //     newSelected = newSelected.concat(selected.slice(1));
            // } else if (selectedIndex === selected.length - 1) {
            //     newSelected = newSelected.concat(selected.slice(0, -1));
            // } else if (selectedIndex > 0) {
            //     newSelected = newSelected.concat(
            //         selected.slice(0, selectedIndex),
            //         selected.slice(selectedIndex + 1),
            //     );
            // }

            // this.setState({ selected: newSelected });
        };

        _this3.handleChangePage = function (event, page) {
            // this.setState({ page });
            _this3.props.updateDeviceCatalogueFilterData({
                data: _this3.state.data,
                pageNumber: page
            });
        };

        _this3.handleChangeRowsPerPage = function (event) {
            _this3.setState({ rowsPerPage: event.target.value });
        };

        _this3.isSelected = function (id) {
            return _this3.state.selected.indexOf(id) !== -1;
        };

        _this3.checkWaterLevel = function (threshold, water) {
            var waterLevel = threshold.data && threshold.data.thresholds && threshold.data.thresholds.water;
            if (water < (waterLevel && waterLevel.min) || water > (waterLevel && waterLevel.max)) {
                return true;
            }
            return false;
        };

        _this3.checkTemperatureThreshold = function (threshold, temperature) {
            var temperatureThreshold = threshold.data && threshold.data.thresholds && threshold.data.thresholds.temperature;
            if (temperature < (temperatureThreshold && temperatureThreshold.min) || temperature > (temperatureThreshold && temperatureThreshold.max)) {
                return true;
            }
            return false;
        };

        _this3.checkCurrentThreshold = function (threshold, current) {
            if (current < threshold && threshold.min || current > threshold && threshold.max) {
                return true;
            }
            return false;
        };

        _this3.getdeviceOnline = function (status) {
            if (status === "ACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/online.png',
                    alt: 'Online',
                    style: {
                        borderRadius: 15
                    }
                });
            } else if (status === "INACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/redIc.png',
                    alt: 'Offline',
                    style: {
                        borderRadius: 15
                    }
                });
            }
            return _react2.default.createElement('img', {
                className: 'statusImage d-inline-block mx-2 pl-0',
                src: '../../../../assets/images/offline.png',
                alt: 'Offline',
                style: {
                    borderRadius: 15
                }
            });
        };

        _this3.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.deviceCatalogueFilter.data,
            page: props.deviceCatalogueFilter.pageNumber,
            filterData: props.deviceCatalogue.data,
            rowsPerPage: 25
        };
        return _this3;
    }

    _createClass(EnhancedTable, [{
        key: 'setData',
        value: function setData(data) {
            this.setState({
                data: data.deviceCatalogueFilter.data,
                page: data.deviceCatalogueFilter.pageNumber,
                filterData: data.deviceCatalogue.data
            });
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            var updatedTime = new Date(date * 1000).getFullYear() + '-' + ("0" + (new Date(date * 1000).getMonth() + 1)).substr(-2) + '-' + ("0" + new Date(date * 1000).getDate()).substr(-2) + ', ' + ("0" + new Date(date * 1000).getHours()).substr(-2) + ':' + ("0" + new Date(date * 1000).getMinutes()).substr(-2) + ':' + ("0" + new Date(date * 1000).getSeconds()).substr(-2);
            return updatedTime;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setData(nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                data = _state.data,
                order = _state.order,
                filterData = _state.filterData,
                orderBy = _state.orderBy,
                selected = _state.selected,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page;

            var filteredData = [];
            filterData.map(function (n, index) {
                var isSelected = _this4.isSelected(n.id);
                var status = n && n.status;
                var temperature1 = n.data && n.data.sensors && n.data.sensors.temperature1;
                var temperature2 = n.data && n.data.sensors && n.data.sensors.temperature2;
                var temperature3 = n.data && n.data.sensors && n.data.sensors.temperature3;
                var current1 = n.data && n.data.sensors && n.data.sensors.current1;
                var current2 = n.data && n.data.sensors && n.data.sensors.current2;
                var water = n.data && n.data.sensors && n.data.sensors.water;
                var lid = n.data && n.data.notification && n.data.notification.eventVal;
                var time = n.data && n.data.sensors && _this4.formatDate(n.data.sensors.time);
                var currentThreshold1 = n.data && n.data.thresholds && n.data.thresholds.current1;
                var currentThreshold2 = n.data && n.data.thresholds && n.data.thresholds.current2;
                filteredData.push({
                    id: index,
                    nodeId: n.nodeId,
                    time: time,
                    status: status,
                    temperature1: temperature1,
                    temperature2: temperature2,
                    temperature3: temperature3,
                    current1: current1,
                    current2: current2,
                    water: water,
                    lid: lid,
                    n: n,
                    currentThreshold1: currentThreshold1,
                    currentThreshold2: currentThreshold2
                });
            });
            return _react2.default.createElement('div', { className: 'w-100 px-2 device-catalogue' }, _react2.default.createElement(EnhancedTableToolbar, { openModal: function openModal() {
                    $("#searchModalComponent").modal();
                    _this4.props.passDataForFilter({ filteredData: filteredData, columnData: columnData });
                } }), _react2.default.createElement('div', { className: 'flex-auto',
                style: {
                    background: 'white'
                } }, _react2.default.createElement(_TableContainer2.default, { className: 'table-responsive-material',
                style: {
                    maxHeight: window.innerHeight - 300
                }
            }, _react2.default.createElement(_Table2.default, { stickyHeader: true }, _react2.default.createElement(EnhancedTableHead, {
                numSelected: selected.length,
                order: order,
                orderBy: orderBy,
                onSelectAllClick: this.handleSelectAllClick,
                onRequestSort: this.handleRequestSort,
                rowCount: data.length
            }), _react2.default.createElement(_TableBody2.default, null, data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (item) {

                var n = item.n ? item.n : item;
                var isSelected = _this4.isSelected(n.id);
                var status = n && n.status;
                var temperature1 = n.data && n.data.sensors && n.data.sensors.temperature1;
                var temperature2 = n.data && n.data.sensors && n.data.sensors.temperature2;
                var temperature3 = n.data && n.data.sensors && n.data.sensors.temperature3;
                var current1 = n.data && n.data.sensors && n.data.sensors.current1;
                var current2 = n.data && n.data.sensors && n.data.sensors.current2;
                var water = n.data && n.data.sensors && n.data.sensors.water;
                var lid = n.data && n.data.notification && n.data.notification.eventVal;
                var currentThreshold1 = n.data && n.data.thresholds && n.data.thresholds.current1;
                var currentThreshold2 = n.data && n.data.thresholds && n.data.thresholds.current2;
                return _react2.default.createElement(_TableRow2.default, {
                    hover: true
                    // onClick={event => this.handleClick(event, n.nodeId)}
                    // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                    , role: 'checkbox',
                    'aria-checked': isSelected,
                    tabIndex: -1,
                    key: n.id,
                    selected: isSelected
                }, _react2.default.createElement(_TableCell2.default, { padding: 'none',
                    onClick: function onClick(event) {
                        return _this4.handleClick(event, n.nodeId);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return _this4.handleKeyDown(event, n.nodeId);
                    },
                    id: 'deviceId'
                }, n.nodeId), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Status: ' + (status === "UNKNOWN" ? "NEVER ACTIVE" : status),
                    placement: 'bottom-end'
                }, _this4.getdeviceOnline(status))), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, n.data && n.data.sensors && _this4.formatDate(n.data.sensors.time)), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkCurrentThreshold(currentThreshold1, current1) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkCurrentThreshold(currentThreshold1, current1) && 'red'
                    }
                }, current1), _react2.default.createElement(_TableCell2.default, { className: 'text-center',
                    style: {
                        border: _this4.checkCurrentThreshold(currentThreshold2, current2) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkCurrentThreshold(currentThreshold2, current2) && 'red'
                    }
                }, current2), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkTemperatureThreshold(n, temperature1) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkTemperatureThreshold(n, temperature1) && 'red'
                    } }, temperature1), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkTemperatureThreshold(n, temperature2) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkTemperatureThreshold(n, temperature2) && 'red'
                    } }, temperature2), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkTemperatureThreshold(n, temperature2) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkTemperatureThreshold(n, temperature3) && 'red'
                    } }, temperature3), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkWaterLevel(n, water) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkWaterLevel(n, water) && 'red'
                    } }, water), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: lid === 'Open' && '1px solid rgb(226, 227, 229)',
                        background: lid === 'Open' && 'red'
                    } }, lid));
            })))), _react2.default.createElement(_TablePagination2.default, {
                style: {
                    width: window.innerWidth
                },
                count: data.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onChangePage: this.handleChangePage,
                onChangeRowsPerPage: this.handleChangeRowsPerPage
            })));
        }
    }]);

    return EnhancedTable;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var symbioticReducer = _ref2.symbioticReducer;

    return {
        deviceId: symbioticReducer.deviceId,
        deviceCatalogue: symbioticReducer.deviceCatalogue,
        deviceCatalogueFilter: symbioticReducer.deviceCatalogueFilter
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateDeviceCatalogueData: function updateDeviceCatalogueData(data) {
            dispatch({ type: "DEVICE_CATELOGUE_DATA", deviceCatalogue: data });
        },
        updateDeviceCatalogueFilterData: function updateDeviceCatalogueFilterData(data) {
            dispatch({ type: "DEVICE_CATELOGUE_FILTER_DATA", deviceCatalogueFilter: data });
        }
    };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnhancedTable);

exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(createData, 'createData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(counter, 'counter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(columnData, 'columnData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableHead, 'EnhancedTableHead', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableToolbar, 'EnhancedTableToolbar', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTable, 'EnhancedTable', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js');
}();

;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classnames2, "_classnames2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_propTypes2, "_propTypes2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_keycode2, "_keycode2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableFooter2, "_TableFooter2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Table2, "_Table2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableBody2, "_TableBody2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableCell2, "_TableCell2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableContainer2, "_TableContainer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableHead2, "_TableHead2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TablePagination2, "_TablePagination2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableRow2, "_TableRow2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableSortLabel2, "_TableSortLabel2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Toolbar2, "_Toolbar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Typography2, "_Typography2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Checkbox2, "_Checkbox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Tooltip2, "_Tooltip2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Delete2, "_Delete2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_FilterList2, "_FilterList2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(counter, "counter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(createData, "createData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(columnData, "columnData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableHead, "EnhancedTableHead", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableToolbar, "EnhancedTableToolbar", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTable, "EnhancedTable", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/deviceCatalogue/EnhancedTable.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _awsManager = __webpack_require__(59);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactstrap = __webpack_require__(92);

var _filterModal = __webpack_require__(387);

var _filterModal2 = _interopRequireDefault(_filterModal);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _highlightSidebarOption = __webpack_require__(140);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(30);

var _filterFunction = __webpack_require__(403);

var _lodash = __webpack_require__(165);

var _lodash2 = _interopRequireDefault(_lodash);

var _EnhancedTable = __webpack_require__(1909);

var _EnhancedTable2 = _interopRequireDefault(_EnhancedTable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";


var AlertModification = function (_Component) {
  _inherits(AlertModification, _Component);

  function AlertModification(props) {
    _classCallCheck(this, AlertModification);

    var _this = _possibleConstructorReturn(this, (AlertModification.__proto__ || Object.getPrototypeOf(AlertModification)).call(this, props));

    _this.getData = function () {
      (0, _awsManager.alertsModificationData)(_this.props.deviceId).then(function (data) {
        _this.props.updateAlertModification({ data: data, pageNumber: _this.props.alertModification.pageNumber });
        if (_this.props.alertFilter.length > 0) {
          var filterData = (0, _filterFunction.filterRecords)(data, _this.props.alertFilter);
          _this.props.updateFilterAlertModification({ data: filterData, pageNumber: _this.props.alertModificationFilter.pageNumber });
        } else {
          _this.props.updateAlertModification({ data: data, pageNumber: _this.props.alertModification.pageNumber });
          _this.props.updateFilterAlertModification({ data: data, pageNumber: _this.props.alertModificationFilter.pageNumber });
        }
        _this.props.hideLoader();
      }).catch(function (error) {
        _this.props.hideLoader();
        console.log('error: ', error);
      });
    };

    _this.addAlert = function () {
      if (_this.props.alertFilter.length === 0) {
        var data = [{
          condition: { type: "is equals", key: "equal" },
          key: {
            disablePadding: false,
            id: "alertStatus",
            label: "Alert Status",
            numeric: false,
            type: "string"
          },
          value: "Open"
        }];
        _this.props.addAlert(data);
      }
    };

    _this.state = {
      filterData: []
      // startDate: new Date(),
      // endDate: new Date()
    };
    return _this;
  }

  _createClass(AlertModification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addAlert();
      this.getData();
      this.currentPath = this.props.location.pathname;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.unlisten = this.props.history.listen(function (location) {
        _this2.currentPath = location.pathname;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
      this.props.addAlert([]);
    }

    // setStartDate = (date) => {
    //   this.setState({ startDate: date })
    // }
    // setEndDate = (date) => {
    //   this.setState({ endDate: date })
    // }

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement("div", { className: "row configuration-page" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "jr-card d-sm-flex justify-content-sm-between align-items-sm-center" }, _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-10" }, _react2.default.createElement("h1", { className: "mb-0" }, "Alerts")), _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-2" }))), _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement(_filterModal2.default, {
        filter: this.props.alertFilter,
        data: this.state.filterData,
        setFilteredData: function setFilteredData(data) {
          _this3.props.updateFilterAlertModification({ data: data, pageNumber: 0 });
        } }), _react2.default.createElement("div", { className: "row" }, _react2.default.createElement(_EnhancedTable2.default, {
        passDataForFilter: function passDataForFilter(item) {
          _this3.setState({
            filterData: item
          });
        },
        updateAlertStatus: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, nodeId) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this3.props.showLoader();

                  case 2:
                    _context.next = 4;
                    return _this3.props.updateAlertModification({ data: [], pageNumber: _this3.props.alertModification.pageNumber });

                  case 4:
                    _context.next = 6;
                    return _this3.props.updateFilterAlertModification({ data: [], pageNumber: _this3.props.alertModificationFilter.pageNumber });

                  case 6:
                    _context.next = 8;
                    return (0, _awsManager.updateAlertStatus)(data, nodeId);

                  case 8:
                    _this3.addAlert();
                    _context.next = 11;
                    return _this3.getData();

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }(),
        updateDeviceId: function updateDeviceId(deviceId) {
          _this3.props.updateDeviceId(deviceId);
          if (!(_this3.currentPath === "/app/components/heartbeat" || _this3.currentPath === "/app/components/notifications")) {
            (0, _highlightSidebarOption.highlightNavigatedMenu)("heartbeat", "#" + _this3.currentPath);
            _this3.props.history.push("/app/components/heartbeat");
          }
        } }))));
    }
  }]);

  return AlertModification;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var symbioticReducer = _ref2.symbioticReducer;

  return {
    deviceId: symbioticReducer.deviceId,
    alertFilter: symbioticReducer.alertFilter,
    alertModification: symbioticReducer.alertModification,
    alertModificationFilter: symbioticReducer.alertModificationFilter
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateDeviceId: function updateDeviceId(id) {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateAlertModification: function updateAlertModification(data) {
      dispatch({ type: "ALERT_MODIFICATION_DATA", alertModification: data });
    },
    updateFilterAlertModification: function updateFilterAlertModification(data) {
      dispatch({ type: "ALERT_MODIFICATION_FILTER_DATA", alertModification: data });
    },
    showLoader: function showLoader() {
      dispatch({ type: "SHOW_OVERALL_APP_LOADER" });
    },
    // Dispatch action to hide loader
    hideLoader: function hideLoader() {
      dispatch({
        type: "HIDE_OVERALL_APP_LOADER"
      });
    },
    addAlert: function addAlert(data) {
      dispatch({
        type: 'ALERT_FILTER',
        alertFilter: data
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlertModification);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AlertModification, "AlertModification", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_filterModal2, "_filterModal2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_moment2, "_moment2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_lodash2, "_lodash2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_EnhancedTable2, "_EnhancedTable2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_asyncToGenerator, "_asyncToGenerator", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(AlertModification, "AlertModification", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/index.js");
}();

;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _reactRedux = __webpack_require__(30);

var _TableFooter = __webpack_require__(261);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _Table = __webpack_require__(269);

var _Table2 = _interopRequireDefault(_Table);

var _TableBody = __webpack_require__(270);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableCell = __webpack_require__(200);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableContainer = __webpack_require__(271);

var _TableContainer2 = _interopRequireDefault(_TableContainer);

var _TableHead = __webpack_require__(272);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TablePagination = __webpack_require__(275);

var _TablePagination2 = _interopRequireDefault(_TablePagination);

var _TableRow = __webpack_require__(278);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableSortLabel = __webpack_require__(273);

var _TableSortLabel2 = _interopRequireDefault(_TableSortLabel);

var _Toolbar = __webpack_require__(137);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _Checkbox = __webpack_require__(168);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Tooltip = __webpack_require__(167);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Delete = __webpack_require__(279);

var _Delete2 = _interopRequireDefault(_Delete);

var _FilterList = __webpack_require__(280);

var _FilterList2 = _interopRequireDefault(_FilterList);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var counter = 0;

var alertType = [{ status: 'Closed' }, { status: 'Open' }, { status: 'In Progress' }];

var columnData = [{ id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' }, { id: 'time', numeric: false, disablePadding: false, label: 'Time', type: 'date' }, { id: 'event', numeric: false, disablePadding: false, label: 'Event Type', type: 'string' }, { id: 'eventVal', numeric: false, disablePadding: true, label: 'Event Value', type: 'string' }, { id: 'dataValue', numeric: true, disablePadding: false, label: 'Alert Value', type: 'number' }, { id: 'threshold', numeric: true, disablePadding: false, label: 'Threshold', type: 'number' }, { id: 'alertStatus', numeric: false, disablePadding: false, label: 'Alert Status', type: 'string' }, { id: 'ticketNumber', numeric: false, disablePadding: false, label: 'Ticket#', type: 'string' }];

var EnhancedTableHead = function (_React$Component) {
    _inherits(EnhancedTableHead, _React$Component);

    function EnhancedTableHead() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, EnhancedTableHead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnhancedTableHead.__proto__ || Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref, [this].concat(args))), _this), _this.createSortHandler = function (property) {
            return function (event) {
                _this.props.onRequestSort(event, property);
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnhancedTableHead, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                onSelectAllClick = _props.onSelectAllClick,
                order = _props.order,
                orderBy = _props.orderBy,
                numSelected = _props.numSelected,
                rowCount = _props.rowCount;

            return _react2.default.createElement(_TableHead2.default, null, _react2.default.createElement(_TableRow2.default, null, columnData.map(function (column) {
                return _react2.default.createElement(_TableCell2.default, {
                    style: {
                        background: '#E2E3E5'
                    },
                    className: column.id !== 'deviceId' && "text-center",
                    key: column.id,
                    numeric: column.numeric,
                    padding: column.disablePadding ? 'none' : 'default'
                }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Sort',
                    placement: column.numeric ? 'bottom-end' : 'bottom-start',
                    enterDelay: 300
                }, _react2.default.createElement(_TableSortLabel2.default, {
                    active: orderBy === column.id,
                    direction: order,
                    onClick: _this2.createSortHandler(column.id)
                }, column.label)));
            }, this)));
        }
    }]);

    return EnhancedTableHead;
}(_react2.default.Component);

EnhancedTableHead.propTypes = {
    numSelected: _propTypes2.default.number.isRequired,
    onRequestSort: _propTypes2.default.func.isRequired,
    onSelectAllClick: _propTypes2.default.func.isRequired,
    order: _propTypes2.default.string.isRequired,
    orderBy: _propTypes2.default.string.isRequired,
    rowCount: _propTypes2.default.number.isRequired
};

var EnhancedTableToolbar = function EnhancedTableToolbar(props) {
    var numSelected = props.numSelected;

    return _react2.default.createElement(_Toolbar2.default, {
        className: (0, _classnames2.default)("table-header", _defineProperty({}, "highlight-light", numSelected > 0))
    }, _react2.default.createElement('div', { className: 'title' }, _react2.default.createElement(_Typography2.default, { type: 'title' }, 'Add Filter')), _react2.default.createElement('div', { className: 'actions' }, numSelected > 0 ? _react2.default.createElement(_Tooltip2.default, { title: 'Delete' }, _react2.default.createElement(_IconButton2.default, { 'aria-label': 'Delete' }, _react2.default.createElement(_Delete2.default, null))) : _react2.default.createElement(_Tooltip2.default, { title: 'Filter list' }, _react2.default.createElement(_IconButton2.default, { 'aria-label': 'Filter list' }, _react2.default.createElement(_FilterList2.default, { onClick: function onClick() {
            props.openModal();
        } })))));
};

EnhancedTableToolbar.propTypes = {
    numSelected: _propTypes2.default.number.isRequired
};

var EnhancedTable = function (_React$Component2) {
    _inherits(EnhancedTable, _React$Component2);

    function EnhancedTable(props, context) {
        _classCallCheck(this, EnhancedTable);

        var _this3 = _possibleConstructorReturn(this, (EnhancedTable.__proto__ || Object.getPrototypeOf(EnhancedTable)).call(this, props, context));

        _this3.handleRequestSort = function (event, property) {
            var orderBy = property;
            var order = 'desc';
            if (_this3.state.orderBy === property && _this3.state.order === 'desc') {
                order = 'asc';
            }
            var data = [];
            data = order === 'desc' ? _this3.state.data.sort(function (a, b) {
                return b[orderBy] < a[orderBy] ? -1 : 1;
            }) : _this3.state.data.sort(function (a, b) {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            });
            _this3.setState({ data: data, order: order, orderBy: orderBy });
        };

        _this3.handleSelectAllClick = function (event, checked) {
            if (checked) {
                _this3.setState({ selected: _this3.state.data.map(function (n) {
                        return n.id;
                    }) });
                return;
            }
            _this3.setState({ selected: [] });
        };

        _this3.handleKeyDown = function (event, id) {
            if ((0, _keycode2.default)(event) === 'space') {
                _this3.handleClick(event, id);
            }
        };

        _this3.handleClick = function (event, deviceId) {
            _this3.props.updateDeviceId(deviceId);
            // const { selected } = this.state;
            // const selectedIndex = selected.indexOf(id);
            // let newSelected = [];

            // if (selectedIndex === -1) {
            //     newSelected = newSelected.concat(selected, id);
            // } else if (selectedIndex === 0) {
            //     newSelected = newSelected.concat(selected.slice(1));
            // } else if (selectedIndex === selected.length - 1) {
            //     newSelected = newSelected.concat(selected.slice(0, -1));
            // } else if (selectedIndex > 0) {
            //     newSelected = newSelected.concat(
            //         selected.slice(0, selectedIndex),
            //         selected.slice(selectedIndex + 1),
            //     );
            // }

            // this.setState({ selected: newSelected });
        };

        _this3.handleChangePage = function (event, page) {
            // this.setState({ page });
            _this3.props.updateFilterAlertModification({
                data: _this3.state.data,
                pageNumber: page
            });
        };

        _this3.handleChangeRowsPerPage = function (event) {
            _this3.setState({ rowsPerPage: event.target.value });
        };

        _this3.isSelected = function (id) {
            return _this3.state.selected.indexOf(id) !== -1;
        };

        _this3.checkWaterLevel = function (threshold, water) {
            var waterLevel = threshold.data && threshold.data.thresholds && threshold.data.thresholds.water;
            if (water < (waterLevel && waterLevel.min) || water > (waterLevel && waterLevel.max)) {
                return true;
            }
            return false;
        };

        _this3.checkTemperatureThreshold = function (threshold, temperature) {
            var temperatureThreshold = threshold.data && threshold.data.thresholds && threshold.data.thresholds.temperature;
            if (temperature < (temperatureThreshold && temperatureThreshold.min) || temperature > (temperatureThreshold && temperatureThreshold.max)) {
                return true;
            }
            return false;
        };

        _this3.checkCurrentThreshold = function (threshold, current) {
            if (current < threshold && threshold.min || current > threshold && threshold.max) {
                return true;
            }
            return false;
        };

        _this3.getdeviceOnline = function (status) {
            if (status === "ACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/online.png',
                    alt: 'Online',
                    style: {
                        borderRadius: 15
                    }
                });
            } else if (status === "INACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/redIc.png',
                    alt: 'Offline',
                    style: {
                        borderRadius: 15
                    }
                });
            }
            return _react2.default.createElement('img', {
                className: 'statusImage d-inline-block mx-2 pl-0',
                src: '../../../../assets/images/offline.png',
                alt: 'Offline',
                style: {
                    borderRadius: 15
                }
            });
        };

        _this3.handleSelectStatus = function (item, nodeData) {
            var data = {
                alertStatus: item.target.value,
                time: nodeData.time
            };
            _this3.props.updateAlertStatus(data, nodeData.nodeId);
        };

        _this3.handleInput = function (index, n) {
            _this3.setState({
                selectedIndex: {
                    n: n,
                    index: index
                }
            });
        };

        _this3.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.alertModificationFilter.data,
            page: props.alertModificationFilter.pageNumber,
            filterData: props.alertModification.data,
            rowsPerPage: 25,
            selectedIndex: null
        };
        return _this3;
    }

    _createClass(EnhancedTable, [{
        key: 'setData',
        value: function setData(data) {
            this.setState({
                data: data.alertModificationFilter.data,
                page: data.alertModificationFilter.pageNumber,
                filterData: data.alertModification.data
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setData(nextProps);
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            var updatedTime = new Date(date * 1000).getFullYear() + '-' + ("0" + (new Date(date * 1000).getMonth() + 1)).substr(-2) + '-' + ("0" + new Date(date * 1000).getDate()).substr(-2) + ', ' + ("0" + new Date(date * 1000).getHours()).substr(-2) + ':' + ("0" + new Date(date * 1000).getMinutes()).substr(-2) + ':' + ("0" + new Date(date * 1000).getSeconds()).substr(-2);
            return updatedTime;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                data = _state.data,
                filterData = _state.filterData,
                order = _state.order,
                orderBy = _state.orderBy,
                selected = _state.selected,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page,
                selectedIndex = _state.selectedIndex;

            var filteredData = [];
            filterData.map(function (n, index) {
                var isSelected = _this4.isSelected(n.id);
                var time = _this4.formatDate(n.time);
                var event = n.event;
                var eventVal = n.eventVal;
                var dataValue = n.dataValue;
                var threshold = n.threshold;
                var alertStatus = n.alertStatus;
                var ticketNumber = n.ticketNumber;
                filteredData.push({
                    id: index,
                    n: n,
                    nodeId: n.nodeId,
                    time: time,
                    event: event,
                    eventVal: eventVal,
                    dataValue: dataValue,
                    threshold: threshold,
                    alertStatus: alertStatus,
                    ticketNumber: ticketNumber
                });
            });
            return _react2.default.createElement('div', { className: 'w-100 px-2 device-catalogue' }, _react2.default.createElement(EnhancedTableToolbar, { openModal: function openModal() {
                    $("#searchModalComponent").modal();
                    _this4.props.passDataForFilter({ filteredData: filteredData, columnData: columnData });
                } }), _react2.default.createElement('div', { className: 'flex-auto',
                style: {
                    background: 'white'
                } }, _react2.default.createElement(_TableContainer2.default, { className: 'table-responsive-material',
                style: {
                    maxHeight: window.innerHeight - 300
                }
            }, _react2.default.createElement(_Table2.default, { stickyHeader: true }, _react2.default.createElement(EnhancedTableHead, {
                numSelected: selected.length,
                order: order,
                orderBy: orderBy,
                onSelectAllClick: this.handleSelectAllClick,
                onRequestSort: this.handleRequestSort,
                rowCount: data.length
            }), _react2.default.createElement(_TableBody2.default, null, data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (item, index) {
                var n = item.n ? item.n : item;
                var isSelected = _this4.isSelected(n.id);
                var time = _this4.formatDate(n.time);
                var event = n.event;
                var eventVal = n.eventVal;
                var dataValue = n.dataValue;
                var threshold = n.threshold;
                var alertStatus = n.alertStatus;
                var ticketNumber = n.ticketNumber;

                return _react2.default.createElement(_TableRow2.default, {
                    hover: true
                    // onClick={event => this.handleClick(event, n.nodeId)}
                    // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                    , role: 'checkbox',
                    'aria-checked': isSelected,
                    tabIndex: -1,
                    key: n.id,
                    selected: isSelected
                }, _react2.default.createElement(_TableCell2.default, { padding: 'none',
                    onClick: function onClick(event) {
                        return _this4.handleClick(event, n.nodeId);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return _this4.handleKeyDown(event, n.nodeId);
                    },
                    id: 'deviceId'
                }, n.nodeId), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, time), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, event), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, eventVal), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, dataValue), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, threshold), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, _react2.default.createElement('select', { className: 'border-0', name: 'alertStatus', id: 'alertStatus', onChange: function onChange(item) {
                        return _this4.handleSelectStatus(item, n);
                    } }, _react2.default.createElement('option', { value: 'none', disabled: true }, 'Select an Status'), alertType.map(function (item) {
                    return _react2.default.createElement('option', { value: item.status, selected: alertStatus === item.status }, item.status);
                }))), _react2.default.createElement(_TableCell2.default, { className: 'text-center', onClick: function onClick(event) {
                        return _this4.handleInput(index, n);
                    } }, index === (selectedIndex !== null && selectedIndex.index) ? _react2.default.createElement('input', {
                    className: 'border-0',
                    type: 'text',
                    placeholder: '',
                    onBlur: function onBlur(event) {
                        if (event.target.value !== '') {
                            var _data = {
                                ticketNumber: event.target.value,
                                time: n.time
                            };
                            _this4.setState({
                                selectedIndex: null
                            });
                            _this4.props.updateAlertStatus(_data, n.nodeId);
                        }
                    },
                    onChange: function onChange(event) {
                        var n = selectedIndex.n;
                        n.ticketNumber = event.target.value;
                        _this4.setState({
                            selectedIndex: {
                                n: n,
                                index: selectedIndex.index
                            }
                        });
                    },
                    value: selectedIndex.n.ticketNumber
                }) : ticketNumber));
            })))), _react2.default.createElement(_TablePagination2.default, {
                style: {
                    width: window.innerWidth
                },
                count: data.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onChangePage: this.handleChangePage,
                onChangeRowsPerPage: this.handleChangeRowsPerPage
            })));
        }
    }]);

    return EnhancedTable;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var symbioticReducer = _ref2.symbioticReducer;

    return {
        deviceId: symbioticReducer.deviceId,
        alertModification: symbioticReducer.alertModification,
        alertModificationFilter: symbioticReducer.alertModificationFilter
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateAlertModification: function updateAlertModification(data) {
            dispatch({ type: "ALERT_MODIFICATION_DATA", alertModification: data });
        },
        updateFilterAlertModification: function updateFilterAlertModification(data) {
            dispatch({ type: "ALERT_MODIFICATION_FILTER_DATA", alertModification: data });
        }
    };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnhancedTable);

exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(counter, 'counter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(alertType, 'alertType', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(columnData, 'columnData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableHead, 'EnhancedTableHead', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableToolbar, 'EnhancedTableToolbar', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTable, 'EnhancedTable', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js');
}();

;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classnames2, "_classnames2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_propTypes2, "_propTypes2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_keycode2, "_keycode2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableFooter2, "_TableFooter2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Table2, "_Table2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableBody2, "_TableBody2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableCell2, "_TableCell2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableContainer2, "_TableContainer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableHead2, "_TableHead2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TablePagination2, "_TablePagination2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableRow2, "_TableRow2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableSortLabel2, "_TableSortLabel2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Toolbar2, "_Toolbar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Typography2, "_Typography2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Checkbox2, "_Checkbox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Tooltip2, "_Tooltip2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Delete2, "_Delete2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_FilterList2, "_FilterList2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_defineProperty, "_defineProperty", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(counter, "counter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(alertType, "alertType", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(columnData, "columnData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableHead, "EnhancedTableHead", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableToolbar, "EnhancedTableToolbar", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTable, "EnhancedTable", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/alertModification/EnhancedTable.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(30);

var _jquery = __webpack_require__(31);

var _jquery2 = _interopRequireDefault(_jquery);

var _chartManager = __webpack_require__(1911);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Tooltip = __webpack_require__(167);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _util = __webpack_require__(77);

var _reactstrap = __webpack_require__(92);

var _awsManager = __webpack_require__(59);

var _reactTimeago = __webpack_require__(1916);

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

var _SymbioticMarkerClusterer = __webpack_require__(376);

var _SymbioticMarkerClusterer2 = _interopRequireDefault(_SymbioticMarkerClusterer);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-lone-blocks */
// export NODE_OPTIONS="--max-old-space-size=8192"


var filter = [{
  item: "Latest 10 Records"
}, {
  item: "1 Day"
}, {
  item: "7 Days"
}, {
  item: "14 Days"
}, {
  item: "28 Days"
}];

var tempTypeSensor = [
// {
//   item: "All Sensors",
//   type: "All",
// },
{
  item: "Sensor 1",
  type: "temperature1"
}, {
  item: "Sensor 2",
  type: "temperature2"
}, {
  item: "Sensor 3",
  type: "temperature3"
}];

var powerTypeSensor = [{
  item: "Sensor 1",
  type: "current1"
}, {
  item: "Sensor 2",
  type: "current2"
}];

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.temperatureChart = {};
    _this.waterLevelChart = {};
    _this.batteryChargeChart = {};
    _this.powerChart = {};
    _this.pitStatusModalBubbleChart = {};
    _this.securityPitStatusChart = {};
    _this.securityTechOnSiteChart = {};
    _this.temperatureChartModal = {};
    _this.waterLevelChartModal = {};
    _this.batteryChargeChartModal = {};
    _this.securityPitStatusModal = {};
    _this.securityTechOnSiteModal = {};
    _this.temperatureId = "temperature";
    _this.waterLevelId = "waterLevel";
    _this.powerId = "powerId";
    _this.batteryChargeId = "batteryCharge";
    _this.securityPitStatusId = "securityPitStatus";
    _this.securityTechOnSiteId = "securityTechOnSite";
    _this.temperatureModalId = "temperature-modal";
    _this.waterLevelModalId = "water-level-modal";
    _this.batteryChargeModalId = "battery-charge-modal";
    _this.securityPitStatusModalId = "securityPitStatusModalId";
    _this.securityTechOnSiteModalId = "securityTechOnSiteModalId";
    _this.latestT = "0º";
    _this.latestP = "0 amp";
    _this.latestSD = "0cm";
    _this.latestBC = "0V";
    _this.latestTM = "0º";
    _this.latestSDM = "0cm";
    _this.latestBCM = "0V";
    _this.lastInteractionReceived = "Friday 8 December, 08:13 am";

    _this.UpdateTemperatureChartWithId = function () {
      _this.temperatureChartWithId = {
        chartJSX: _react2.default.createElement("div", {
          "data-toggle": "modal",
          "data-target": "#temperatureModal",
          className: "col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
        }, _react2.default.createElement("canvas", { id: _this.temperatureId })),
        id: 1457690402
      };
    };

    _this.UpdateWaterLevelChartWithId = function () {
      _this.waterLevelChartWithId = {
        chartJSX: _react2.default.createElement("div", {
          "data-toggle": "modal",
          "data-target": "#waterLevelModal",
          className: "col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
        }, _react2.default.createElement("canvas", { id: _this.waterLevelId })),
        id: 1457690403
      };
    };

    _this.selectTempToggle = function () {
      _this.setState({
        temperaturetoggle: !_this.state.temperaturetoggle
      });
    };

    _this.selectTempTypeToggle = function () {
      _this.setState({
        tempSensorToggle: !_this.state.tempSensorToggle
      });
    };

    _this.selectPowerTypeToggle = function () {
      _this.setState({
        powerSensorToggle: !_this.state.powerSensorToggle
      });
    };

    _this.selectWaterToggle = function () {
      _this.setState({
        watertoggle: !_this.state.watertoggle
      });
    };

    _this.selectPowerToggle = function () {
      _this.setState({
        powerToggle: !_this.state.powerToggle
      });
    };

    _this.selectPitStatusToggle = function () {
      _this.setState({
        pitStatustoggle: !_this.state.pitStatustoggle
      });
    };

    _this.findAverage = function (data) {
      var sum = data.reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b);
      }, 0);
      var average = sum / data.length;
      if (Number.isNaN(average)) {
        return 0;
      }
      return average;
    };

    _this.calculateOpenPit = function (data) {
      var count = data.filter(function (item) {
        return item === "Open" || item === "open";
      }).length;
      return count;
    };

    _this.findMaximumValue = function (data) {
      var maxValue = Math.max.apply(Math, _toConsumableArray(data));
      if (Number.isFinite(maxValue)) {
        return maxValue.toFixed(2);
      }
      return 0;
    };

    _this.findMinimumValue = function (data) {
      var minValue = Math.min.apply(Math, _toConsumableArray(data));
      if (Number.isFinite(minValue)) {
        return minValue.toFixed(2);
      }
      return 0;
    };

    _this.findIncreasePercentage = function (data) {
      var percentageIncrease = (data[data.length - 1] - data[0]) / 2 * 100;
      if (Number.isNaN(percentageIncrease)) {
        return 0 + "%";
      }
      return percentageIncrease.toFixed(2) + "%";
    };

    _this.renderTempFilter = function () {
      return _react2.default.createElement(_reactstrap.Card, { className: "shadow border-1 recordOuterContainer" }, _react2.default.createElement(_reactstrap.CardBody, { className: "recordContainer" }, _react2.default.createElement(_reactstrap.CardText, { className: "row" }, _react2.default.createElement("div", { className: "col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12 px-0" }, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.tempSensorToggle,
        toggle: _this.selectTempTypeToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true }, _this.state.tempSensorType), _react2.default.createElement(_reactstrap.DropdownMenu, null, tempTypeSensor.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: _this.selectTempSensorType }, data.item);
      })))), _react2.default.createElement("div", { className: "col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12 px-0" }, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.temperaturetoggle,
        toggle: _this.selectTempToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true }, _this.state.temperatureFilter), _react2.default.createElement(_reactstrap.DropdownMenu, null, filter.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: _this.selectTemperatureFilter }, data.item);
      }))))), _react2.default.createElement(_reactstrap.CardText, null, "Average", _react2.default.createElement("h2", null, _this.findAverage(_this.state.temperatureData).toFixed(2), "\xBA")), _react2.default.createElement(_reactstrap.CardText, null, "Percentage Change", _react2.default.createElement("h2", null, _this.findIncreasePercentage(_this.state.temperatureData))), _react2.default.createElement(_reactstrap.CardText, { className: "row" }, _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("h3", null, "Min", _react2.default.createElement("h3", {
        style: {
          fontWeight: "bold"
        }
      }, _this.findMinimumValue(_this.state.temperatureData), "\xBA"))), _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("h3", null, "Max", _react2.default.createElement("h3", {
        style: {
          fontWeight: "bold"
        }
      }, _this.findMaximumValue(_this.state.temperatureData), "\xBA"))))));
    };

    _this.renderPowerFilter = function () {
      return _react2.default.createElement(_reactstrap.Card, { className: "shadow border-1 recordOuterContainer" }, _react2.default.createElement(_reactstrap.CardBody, { className: "recordContainer" }, _react2.default.createElement(_reactstrap.CardText, { className: "row" }, _react2.default.createElement("div", { className: "col-12 col-lg-12 col-sm-12 col-xs-12 px-0" }, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.powerSensorToggle,
        toggle: _this.selectPowerTypeToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true }, _this.state.powerSensorType), _react2.default.createElement(_reactstrap.DropdownMenu, null, powerTypeSensor.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: _this.selectPowerSensorType }, data.item);
      })))), _react2.default.createElement("div", { className: "col-12 col-lg-12 col-sm-12 col-xs-12 px-0" }, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.powerToggle,
        toggle: _this.selectPowerToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true }, _this.state.powerFilter), _react2.default.createElement(_reactstrap.DropdownMenu, null, filter.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: _this.selectPowerFilter }, data.item);
      }))))), _react2.default.createElement(_reactstrap.CardText, null, "Average", _react2.default.createElement("h2", null, _this.findAverage(_this.state.powerData).toFixed(2))), _react2.default.createElement(_reactstrap.CardText, null, "Percentage Change", _react2.default.createElement("h2", null, _this.findIncreasePercentage(_this.state.powerData))), _react2.default.createElement(_reactstrap.CardText, { className: "row" }, _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("h3", null, "Min", _react2.default.createElement("h3", {
        style: {
          fontWeight: "bold"
        }
      }, _this.findMinimumValue(_this.state.powerData)))), _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("h3", null, "Max", _react2.default.createElement("h3", {
        style: {
          fontWeight: "bold"
        }
      }, _this.findMaximumValue(_this.state.powerData)))))));
    };

    _this.renderWaterFilter = function () {
      return _react2.default.createElement(_reactstrap.Card, { className: "shadow border-1 recordOuterContainer" }, _react2.default.createElement(_reactstrap.CardBody, { className: "recordContainer" }, _react2.default.createElement(_reactstrap.CardText, null, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.watertoggle,
        toggle: _this.selectWaterToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true }, _this.state.waterFilter), _react2.default.createElement(_reactstrap.DropdownMenu, null, filter.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: _this.selectWaterFilter }, data.item);
      })))), _react2.default.createElement(_reactstrap.CardText, null, "Average", _react2.default.createElement("h2", null, _this.findAverage(_this.state.waterLevelData).toFixed(2), "cm")), _react2.default.createElement(_reactstrap.CardText, null, "Percentage Change", _react2.default.createElement("h2", null, _this.findIncreasePercentage(_this.state.waterLevelData))), _react2.default.createElement(_reactstrap.CardText, { className: "row" }, _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("h3", null, "Min", _react2.default.createElement("h3", {
        style: {
          fontWeight: "bold"
        }
      }, _this.findMinimumValue(_this.state.waterLevelData), "cm"))), _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("h3", null, "Max", _react2.default.createElement("h3", {
        style: {
          fontWeight: "bold"
        }
      }, _this.findMaximumValue(_this.state.waterLevelData), "cm"))))));
    };

    _this.renderPitStatusFilter = function () {
      return _react2.default.createElement(_reactstrap.Card, { className: "shadow border-1 recordOuterContainer" }, _react2.default.createElement(_reactstrap.CardBody, { className: "recordContainer" }, _react2.default.createElement(_reactstrap.CardText, null, _react2.default.createElement(_reactstrap.Dropdown, {
        isOpen: _this.state.pitStatustoggle,
        toggle: _this.selectPitStatusToggle
      }, _react2.default.createElement(_reactstrap.DropdownToggle, { color: "Secondary", caret: true }, _this.state.pitStatusFilter), _react2.default.createElement(_reactstrap.DropdownMenu, null, filter.map(function (data) {
        return _react2.default.createElement(_reactstrap.DropdownItem, { onClick: _this.selectPitStatusFilter }, data.item);
      })))), _react2.default.createElement(_reactstrap.CardText, null, "How many times open", _react2.default.createElement("h2", null, _this.calculateOpenPit(_this.state.pitStatus)))));
    };

    _this.selectTemperatureFilter = function (event) {
      _this.setState({
        temperatureFilter: event.target.innerText
      }, function () {
        _this.getChartData();
      });
    };

    _this.selectTempSensorType = function (event) {
      _this.setState({
        tempSensorType: event.target.innerText
      }, function () {
        _this.getChartData();
      });
    };

    _this.selectPowerSensorType = function (event) {
      _this.setState({
        powerSensorType: event.target.innerText
      }, function () {
        _this.getChartData();
      });
    };

    _this.selectPowerFilter = function (event) {
      _this.setState({
        powerFilter: event.target.innerText
      }, function () {
        _this.getChartData();
      });
    };

    _this.selectWaterFilter = function (event) {
      _this.setState({
        waterFilter: event.target.innerText
      }, function () {
        _this.getChartData();
      });
    };

    _this.selectPitStatusFilter = function (event) {
      _this.setState({
        pitStatusFilter: event.target.innerText
      }, function () {
        _this.getChartData();
      });
    };

    _this.renderGraph = function () {
      return _react2.default.createElement("div", { className: "col-12 col-xl-6 col-lg-6 col-sm-6 col-xs-12" }, _react2.default.createElement(_SymbioticMarkerClusterer2.default, {
        navigate: function navigate() {},
        markerData: [_this.state.deviceLocation],
        onBoundsChanged: function onBoundsChanged(bounds) {}
      }));
    };

    _this.render = function () {
      var batteryVoltage = _this.state.nodeVitals.length > 0 && _this.state.nodeVitals[0] && _this.state.nodeVitals[0].values && _this.state.nodeVitals[0].values.batteryVoltage;
      var signalStrength = _this.state.nodeVitals.length > 0 && _this.state.nodeVitals[0] && _this.state.nodeVitals[0].values && _this.state.nodeVitals[0].values.signalStrength;
      var deviceId = _this.props.deviceId;

      var isRevDevices = deviceId.includes('rev');
      var isEptDevices = deviceId.includes('ept');
      var otherDevices = !deviceId.includes('ept') && !deviceId.includes('rev');
      return _react2.default.createElement("div", { className: "row heartbeat-page" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "row page-heading d-sm-flex justify-content-sm-between align-items-sm-center" }, _react2.default.createElement("div", { className: "col-12 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("div", { className: "d-flex align-items-end mb-2" }, "Device ID: ", _this.state.deviceId, _this.getdeviceOnline(), _react2.default.createElement(_Tooltip2.default, {
        title: "Signal Strength: " + (signalStrength ? signalStrength : 'Not Available'),
        placement: 'bottom-end'
      }, _this.showSignalLevel(signalStrength)), _react2.default.createElement(_Tooltip2.default, {
        title: "Battery Level: " + (batteryVoltage ? batteryVoltage : 'Not Available'),
        placement: 'bottom-end'
      }, _this.showBatteryLevel(batteryVoltage))), _react2.default.createElement("div", null, "Last Updated: ", _this.getLastUpdatedTime()), _react2.default.createElement("div", { className: "mt-2" }, _this.getNextUpdatedTime())), _react2.default.createElement("div", null, _react2.default.createElement("i", {
        className: "fa fa-map-marker mt-1 pr-2",
        style: {
          fontSize: 18,
          color: 'red'
        },
        "aria-hidden": "true"
      }), _this.state.deviceLocation.streetAddress))), _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "col-12 col-sm-12 col-md-12 col-lg-12" }, _react2.default.createElement("div", { className: "row" }, (!isRevDevices && isEptDevices || otherDevices) && _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-6" }, _react2.default.createElement("div", { className: "jr-card mainHeight" }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
        className: "jr-card-header w-100 clickable",
        role: "button",
        id: "header-" + _this.temperatureId,
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        href: "#collapseFour",
        "aria-expanded": "true",
        "aria-controls": "collapseFour"
      }, _react2.default.createElement("h2", { className: "card-heading d-inline-block" }, "Temperature", " "), _react2.default.createElement("h3", { className: "mb-0 d-inline-block float-right popupHeading" }, " ", _this.state.latestTemperature, " ")), _react2.default.createElement("div", {
        id: "collapseFour",
        className: "collapse show",
        role: "tabpanel",
        "aria-labelledby": "header-" + _this.temperatureId
      }, _react2.default.createElement("div", { className: "jr-card-body row" }, _this.state.chartsToShow[0], _react2.default.createElement("div", { className: "col-12  col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center d-flex" }, _this.renderTempFilter())))))), !isRevDevices && _this.renderGraph(), (!isRevDevices && isEptDevices || otherDevices) && _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-6" }, _react2.default.createElement("div", { className: "jr-card mainHeight" }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
        className: "jr-card-header w-100 clickable",
        role: "button",
        id: "header-" + _this.waterLevelId,
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        href: "#collapseFive",
        "aria-expanded": "true",
        "aria-controls": "collapseFive"
      }, _react2.default.createElement("h2", { className: "card-heading d-inline-block" }, " ", "Water level in the pit", " "), _react2.default.createElement("h3", { className: "mb-0 d-inline-block float-right popupHeading" }, " ", _this.state.latestWaterLevel, " ")), _react2.default.createElement("div", {
        id: "collapseFive",
        className: "collapse show",
        role: "tabpanel",
        "aria-labelledby": "header-" + _this.waterLevelId
      }, _react2.default.createElement("div", { className: "jr-card-body row" }, _this.state.chartsToShow[1], _react2.default.createElement("div", { className: "col-12 col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center  d-flex" }, _this.renderWaterFilter())))))), (!isRevDevices && isEptDevices || otherDevices) && _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-6" }, _react2.default.createElement("div", { className: "jr-card mainHeight" }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
        className: "jr-card-header w-100 clickable",
        role: "button",
        id: "header-" + _this.securityPitStatusId,
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        href: "#collapseTwo",
        "aria-expanded": "true",
        "aria-controls": "collapseTwo"
      }, _react2.default.createElement("h1", { className: "card-heading d-inline-block" }, "Switch Status", " "), _this.state.latestPitStatus == "Open" ? _react2.default.createElement("div", { className: "d-inline-block float-right" }, _react2.default.createElement("img", {
        className: "battery-charge-img d-inline-block float-left",
        src: "../../../../assets/images/pitOpen.png",
        alt: "switch status"
      }), _react2.default.createElement("h2", { className: "mb-0 ml-2 d-inline-block float-right popupHeading" }, " ", _this.state.latestPitStatus, " ")) : _react2.default.createElement("div", { className: "d-inline-block float-right" }, _react2.default.createElement("img", {
        className: "battery-charge-img d-inline-block float-left",
        src: "../../../../assets/images/pitClose.png",
        alt: "switch status"
      }), _react2.default.createElement("h2", { className: "mb-0 ml-2 d-inline-block float-right popupHeading" }, " ", _this.state.latestPitStatus, " "))), _react2.default.createElement("div", {
        id: "collapseTwo",
        className: "collapse show",
        role: "tabpanel",
        "aria-labelledby": "header-" + _this.securityPitStatusId
      }, _react2.default.createElement("div", { className: "jr-card-body row" }, _react2.default.createElement("div", {
        "data-toggle": "modal",
        "data-target": "#securityPitStatusModal",
        className: "col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
      }, _react2.default.createElement("canvas", { id: "securityPitStatus" })), _react2.default.createElement("div", { className: "col-12 col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center d-flex" }, _this.renderPitStatusFilter())))))), (isRevDevices && !isEptDevices || otherDevices) && _react2.default.createElement("div", { className: "col-12 col-xl-6 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("div", { className: "jr-card mainHeight" }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
        className: "jr-card-header w-100 clickable",
        role: "button",
        id: "header-" + _this.powerId,
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        href: "#collapseFive",
        "aria-expanded": "true",
        "aria-controls": "collapseFive"
      }, _react2.default.createElement("h2", { className: "card-heading d-inline-block" }, " ", "Power", " "), _react2.default.createElement("h3", { className: "mb-0 d-inline-block float-right popupHeading" }, " ", _this.state.latestPower, " ")), _react2.default.createElement("div", {
        id: "collapseFive",
        className: "collapse show",
        role: "tabpanel",
        "aria-labelledby": "header-" + _this.powerId
      }, _react2.default.createElement("div", { className: "jr-card-body row" }, _react2.default.createElement("div", {
        "data-toggle": "modal",
        "data-target": "#currentModal",
        className: "col-12 col-xl-7 col-lg-12 col-sm-12 col-xs-12"
      }, _react2.default.createElement("canvas", { id: _this.powerId })), _react2.default.createElement("div", { className: "col-12 col-xl-5 col-lg-12 col-sm-12 col-xs-12 justify-content-center  d-flex" }, _this.renderPowerFilter())))))), (!isRevDevices && isEptDevices || otherDevices) && _react2.default.createElement("div", { className: isEptDevices ? "col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12" : "col-12 col-xl-6 col-lg-6 col-sm-12 col-xs-12" }, _react2.default.createElement("div", { className: "jr-card mainHeight" }, _react2.default.createElement("div", {
        "data-toggle": "modal",
        "data-target": "#securityTechOnSiteModal"
      }, _react2.default.createElement("div", {
        className: "jr-card-header w-100 clickable",
        role: "button",
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        href: "#collapseThree",
        "aria-expanded": "true",
        "aria-controls": "collapseThree"
      }, _react2.default.createElement("h1", { className: "card-heading d-inline-block" }, "Security (Tech on site)", " ")), _react2.default.createElement("div", {
        id: "collapseThree",
        className: "collapse show",
        role: "tabpanel"
      }, _react2.default.createElement("div", { className: "jr-card-body row" }, _react2.default.createElement("div", { className: "col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12" }, _this.state.techOnSiteStatus.length > 0 ? _react2.default.createElement(_reactstrap.Table, { striped: true, responsive: true, className: "pl-2 " }, _react2.default.createElement("tbody", { className: "w-100 d-block d-md-table d-sm-table" }, _react2.default.createElement("tr", null, _react2.default.createElement("th", { className: "tableHeading" }, "Date and Time"), _react2.default.createElement("th", { className: "tableHeading" }, "Technician Name"), _react2.default.createElement("th", { className: "tableHeading" }, "Comment")), _this.state.techOnSiteStatus.map(function (items, index) {
        return _react2.default.createElement("tr", { key: index }, _react2.default.createElement("td", { scope: "row" }, new Date(items.timestamp * 1000).getFullYear(), "-", ("0" + (new Date(items.timestamp * 1000).getMonth() + 1)).substr(-2), "-", ("0" + new Date(items.timestamp * 1000).getDate()).substr(-2), ",", " ", ("0" + new Date(items.timestamp * 1000).getHours()).substr(-2), ":", ("0" + new Date(items.timestamp * 1000).getMinutes()).substr(-2), ":", ("0" + new Date(items.timestamp * 1000).getSeconds()).substr(-2), " "), _react2.default.createElement("td", null, items.techId), _react2.default.createElement("td", null, items.techNotes));
      }))) : _react2.default.createElement("div", null, _react2.default.createElement("div", { className: "w-100 d-flex justify-content-center" }, _react2.default.createElement("h2", { className: "pl-1" }, "No data found")), _react2.default.createElement("canvas", { id: "securityPitStatus" })))))))), isRevDevices && _this.renderGraph())))));
    };

    _this.destroyChartJsModalCharts = function () {
      if (_this.temperatureChartModal && !_jquery2.default.isEmptyObject(_this.temperatureChartModal)) {
        _this.temperatureChartModal.destroy();
        _this.temperatureChartModal = {};
      }
      if (_this.waterLevelChartModal && !_jquery2.default.isEmptyObject(_this.waterLevelChartModal)) {
        _this.waterLevelChartModal.destroy();
        _this.waterLevelChartModal = {};
      }
      // if (this.batteryChargeChartModal && !$.isEmptyObject(this.batteryChargeChartModal)) {
      //   this.batteryChargeChartModal.destroy();
      //   this.batteryChargeChartModal = {};
      // }
      if (_this.securityPitStatusModal && !_jquery2.default.isEmptyObject(_this.securityPitStatusModal)) {
        _this.securityPitStatusModal.destroy();
        _this.securityPitStatusModal = {};
      }
      if (_this.securityTechOnSiteModal && !_jquery2.default.isEmptyObject(_this.securityTechOnSiteModal)) {
        _this.securityTechOnSiteModal.destroy();
        _this.securityTechOnSiteModal = {};
      }
    };

    _this.destroyChartJsCharts = function () {
      if (_this.temperatureChart && !_jquery2.default.isEmptyObject(_this.temperatureChart)) {
        _this.temperatureChart.destroy();
        _this.temperatureChart = {};
      }
      if (_this.waterLevelChart && !_jquery2.default.isEmptyObject(_this.waterLevelChart)) {
        _this.waterLevelChart.destroy();
        _this.waterLevelChart = {};
      }
      if (_this.batteryChargeChart && !_jquery2.default.isEmptyObject(_this.batteryChargeChart)) {
        _this.batteryChargeChart.destroy();
        _this.batteryChargeChart = {};
      }

      if (_this.securityPitStatusChart && !_jquery2.default.isEmptyObject(_this.securityPitStatusChart)) {
        _this.securityPitStatusChart.destroy();
        _this.securityPitStatusChart = {};
      }
      if (_this.securityTechOnSiteChart && !_jquery2.default.isEmptyObject(_this.securityTechOnSiteChart)) {
        _this.securityTechOnSiteChart.destroy();
        _this.securityTechOnSiteChart = {};
      }
    };

    _this.disposeAllChartsAndModalsAndUnsusbcribe = function () {
      _this.destroyChartJsCharts();

      _this.destroyChartJsModalCharts();

      // this.disconnectMQTT();

      _this.clearDeviceChartsPollingSetInterval();
    };

    _this.evaluateTemperatureThresholdAndReturnBooleanValue = function (value, min, max) {
      // Have to check whether min and max are null, because both these values are optional responses in API

      var satisfiesMinConstraint = false;
      var satisfiesMaxConstraint = false;

      if (min === null) {
        satisfiesMinConstraint = true;
      } else if (min !== null && value >= min) {
        satisfiesMinConstraint = true;
      }

      if (max === null) {
        satisfiesMaxConstraint = true;
      } else if (max !== null && value <= max) {
        satisfiesMaxConstraint = true;
      }

      if (satisfiesMinConstraint && satisfiesMaxConstraint) {
        return false;
      }
      return true;
    };

    _this.evaluateWaterLevelThresholdAndReturnBooleanValue = function (value, min, max) {
      // Have to check whether min and max are null, because both these values are optional responses in API

      var satisfiesMinConstraint = false;
      var satisfiesMaxConstraint = false;

      if (min === null) {
        satisfiesMinConstraint = true;
      } else if (min !== null && value >= min) {
        satisfiesMinConstraint = true;
      }

      if (max === null) {
        satisfiesMaxConstraint = true;
      } else if (max !== null && value <= max) {
        satisfiesMaxConstraint = true;
      }

      if (satisfiesMinConstraint && satisfiesMaxConstraint) {
        return false;
      }
      return true;
    };

    _this.evaluateThresholds = function (data, minTemperatureThresholdPropertyName, maxTemperatureThresholdPropertyName, minWaterLevelThresholdPropertyName, maxWaterLevelThresholdPropertyName) {
      var lastTemperatureObject = data[data.length - 1].values.find(function (item) {
        if (item.hasOwnProperty("temperature")) {
          return true;
        }
        return false;
      });

      var minTemperatureThreshold = null,
          maxTemperatureThreshold = null;
      if (lastTemperatureObject.hasOwnProperty(minTemperatureThresholdPropertyName)) {
        minTemperatureThreshold = lastTemperatureObject[minTemperatureThresholdPropertyName];
      }

      if (lastTemperatureObject.hasOwnProperty(maxTemperatureThresholdPropertyName)) {
        maxTemperatureThreshold = lastTemperatureObject[maxTemperatureThresholdPropertyName];
      }

      var latestTemperatureThresholdBool = void 0;
      var latestTemperatureValue = lastTemperatureObject.temperature;
      latestTemperatureThresholdBool = _this.evaluateTemperatureThresholdAndReturnBooleanValue(latestTemperatureValue, minTemperatureThreshold, maxTemperatureThreshold);

      var lastWaterLevelObject = data[data.length - 1].values.find(function (item) {
        if (item.hasOwnProperty("water")) {
          return true;
        }
        return false;
      });

      var minWaterLevelThreshold = null,
          maxWaterLevelThreshold = null;
      if (lastWaterLevelObject.hasOwnProperty(minWaterLevelThresholdPropertyName)) {
        minWaterLevelThreshold = lastWaterLevelObject[minWaterLevelThresholdPropertyName];
      }

      if (lastWaterLevelObject.hasOwnProperty(maxWaterLevelThresholdPropertyName)) {
        maxWaterLevelThreshold = lastWaterLevelObject[maxWaterLevelThresholdPropertyName];
      }

      var latestWaterLevelThresholdBool = void 0;
      var latestWaterLevelValue = lastWaterLevelObject.water;
      latestWaterLevelThresholdBool = _this.evaluateWaterLevelThresholdAndReturnBooleanValue(latestWaterLevelValue, minWaterLevelThreshold, maxWaterLevelThreshold);

      return {
        latestTemperatureThresholdBool: latestTemperatureThresholdBool,
        latestWaterLevelThresholdBool: latestWaterLevelThresholdBool
      };
    };

    _this.getDateWiseData = function (timestamp, toDate) {
      var date = (0, _moment2.default)(timestamp * 1000).subtract(toDate, "days");
      return date;
    };

    _this.findAverageOfFilteredData = function (data, filter) {
      var arrayForDays = [];
      var time = [];

      var _loop = function _loop(i) {
        var date = _this.getDateWiseData((0, _moment2.default)().format("X"), i);
        var internalArray = [];
        data && data.map(function (item) {
          var itemDate = (0, _moment2.default)(item.time * 1000).format("DD-MM-YYYY");
          var currentDate = date.format("DD-MM-YYYY");
          if (itemDate === currentDate) {
            internalArray.push(item.values);
          }
        });
        arrayForDays.push(internalArray);
        time.push(date.format("MMM-DD"));
      };

      for (var i = 0; i < filter; i++) {
        _loop(i);
      }
      return { arrayForDays: arrayForDays.reverse(), time: time.reverse() };
    };

    _this.findAverageOfPitStatus = function (data, filter) {
      var arrayForDays = [];
      var time = [];

      var _loop2 = function _loop2(i) {
        var date = _this.getDateWiseData((0, _moment2.default)().format("X"), i);
        var internalArray = [];
        data && data.map(function (item) {
          var itemDate = (0, _moment2.default)(item.timestamp * 1000).format("DD-MM-YYYY");
          var currentDate = date.format("DD-MM-YYYY");
          if (itemDate === currentDate) {
            internalArray.push(item);
          }
        });
        arrayForDays.push(internalArray);
        time.push(date.format("MMM-DD"));
      };

      for (var i = 0; i < filter; i++) {
        _loop2(i);
      }
      return { arrayForDays: arrayForDays.reverse(), time: time.reverse() };
    };

    _this.filterAndMapDataPitStatus = function (data) {
      var yAxisData = [];
      var dayArray = data.arrayForDays.map(function (item) {
        if (item.length > 0) {
          if (item[0].security === "Open") {
            yAxisData.push(1);
          } else {
            yAxisData.push(0);
          }
          return item[0].security;
        }
        yAxisData.push(0);
        return "Closed";
      });
      return {
        dayArray: dayArray,
        yAxisData: yAxisData
      };
    };

    _this.getPitStatus = function () {
      (0, _awsManager.getPitStatus)(_this.props.deviceId, _this.state.pitStatusFilter).then(function (data) {
        var heartbeat = _this;
        var timeForPit = [],
            pitStatus = [],
            yAxisData = [],
            dateForPit = [];
        var averageData = [];
        var averageTime = [],
            dateStringToShow = [],
            pitStatusForYaxis = [];
        data.forEach(function (item) {
          if (item.eventVal === "Open") {
            yAxisData.push(1);
          } else {
            yAxisData.push(0);
          }
          timeForPit.push((0, _util.getTimeFromTimestamp)(item.time * 1000));
          pitStatus.push(item.eventVal);
          dateForPit.push(new Date(item.time * 1000).toLocaleString());
        });
        heartbeat.setState({
          pitStatus: pitStatus.reverse(),
          pitStatusTime: timeForPit.reverse(),
          pitStatusForYaxis: yAxisData.reverse(),
          pitStatusTimeWithDate: dateForPit.reverse(),
          latestPitStatus: pitStatus[pitStatus.length - 1]
        });

        if (_this.state.pitStatusFilter !== "Latest 10 Records" && _this.state.pitStatusFilter !== "1 Day") {
          var _filter = _this.getFilteredRecord(_this.state.pitStatusFilter);
          var filteredArrays = _this.findAverageOfPitStatus(data, _filter);
          var dataToShow = _this.filterAndMapDataPitStatus(filteredArrays);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = dataToShow.dayArray;
          pitStatusForYaxis = dataToShow.yAxisData;
        } else {
          averageTime = timeForPit;
          averageData = pitStatus;
          dateStringToShow = dateForPit;
          pitStatusForYaxis = yAxisData;
        }

        heartbeat.pitStatusBubbleChart = (0, _chartManager.pitStatusSteppedCharts)(heartbeat.securityPitStatusId, heartbeat.pitStatusBubbleChart, "line", averageData, averageTime, dateStringToShow, pitStatusForYaxis, heartbeat.pitStatusBubbleChart && !_jquery2.default.isEmptyObject(heartbeat.pitStatusBubbleChart), _this.state.pitStatusFilter);
      });
    };

    _this.getWaterLevelData = function (data) {
      var index = 0;
      var maxThresholdWaterLevel = data.sensors[1].max;

      var heartbeat = _this;
      (0, _awsManager.getLastNRecordsFromAllSensors)(_this.state.waterFilter, _this.state.deviceId, "water").then(function (data) {
        var timestamps = [],
            dateString = [],
            waterLevels = [],
            waterLevelValueToShow = [];
        var averageData = [];
        var averageTime = [],
            dateStringToShow = [];
        data.forEach(function (item) {
          timestamps.push((0, _util.getTimeFromTimestamp)(item.time * 1000));
          dateString.push(new Date(item.time * 1000).toLocaleString());

          var currentWaterLevel = item.values.find(function (currentItem) {
            if (currentItem.hasOwnProperty("water")) {
              return true;
            }
            return false;
          });
          waterLevels.push(item && currentWaterLevel && currentWaterLevel.water ? currentWaterLevel.water / 10 : 0);

          // batteryCharges.push(item && item.voltage ? Number.parseFloat(item.voltage) / 1000 : 0);
          if (index === 0) {
            heartbeat.lastInteractionReceived = (0, _util.getFormattedDate)(item.time, false);
          }
          index++;
        });

        var depthOfPit = _this.state.pitDepth / 10;
        // const findLargestValueOfWater = Math.max(...waterLevels);
        waterLevels.forEach(function (item) {
          waterLevelValueToShow.push((depthOfPit - item).toFixed(2));
        });
        heartbeat.latestSD = (waterLevels.length > 0 ? (depthOfPit - waterLevels[0]).toFixed(2) : 0) + "cm";

        heartbeat.UpdateTemperatureChartWithId(heartbeat.latestT);
        heartbeat.UpdateWaterLevelChartWithId(heartbeat.latestSD);

        var thresholdBooleanWaterLevel = false;
        if (maxThresholdWaterLevel) {
          if (waterLevelValueToShow[0] > maxThresholdWaterLevel) {
            thresholdBooleanWaterLevel = true;
          }
        }
        heartbeat.setState({
          timestamps: timestamps.reverse(),
          dateString: dateString.reverse(),
          latestWaterLevel: heartbeat.latestSD,
          waterLevelData: waterLevelValueToShow.reverse(),
          // waterLevelValueToShow: waterLevelValueToShow.reverse(),
          lastUpdatedTimeWater: data.length > 0 && data[0].time
        });

        if (_this.state.waterFilter !== "Latest 10 Records" && _this.state.waterFilter !== "1 Day") {
          var _filter2 = _this.getFilteredRecord(_this.state.waterFilter);
          var filteredArrays = _this.findAverageOfFilteredData(data, _filter2);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = filteredArrays.arrayForDays.map(function (item) {
            if (item.length > 0) {
              var sum = item.reduce(function (a, b) {
                var water = b[0] && b[0].water ? b[0].water : 0;
                return a + water / 10;
              }, 0);
              var average = sum / item.length;
              if (Number.isNaN(average)) {
                return depthOfPit;
              }
              return (depthOfPit - average).toFixed(2);
            }
            return 0;
          });
        } else {
          averageTime = timestamps;
          averageData = waterLevelValueToShow;
          dateStringToShow = dateString;
        }
        heartbeat.waterLevelChart = (0, _chartManager.realtimeChart)(heartbeat.waterLevelId, heartbeat.waterLevelChart, "line", averageTime, averageData, thresholdBooleanWaterLevel, 20, heartbeat.waterLevelChart && !_jquery2.default.isEmptyObject(heartbeat.waterLevelChart), dateStringToShow, averageData, depthOfPit, _this.state.waterFilter);
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.getAllConfiguration = function () {
      (0, _awsManager.getAllConfiguration)(_this.props.deviceId).then(function (item) {
        _this.setState({
          configurationValues: item
        });
      }).catch(function (error) {
        console.log("error: ", error);
      });
    };

    _this.getPowerData = function () {
      var index = 0;
      // const minThresholdTemperature = data.sensors[0].min;
      // const maxThresholdTemperature = data.sensors[0].max;

      var heartbeat = _this;
      var powerType = powerTypeSensor.filter(function (items) {
        return items.item === _this.state.powerSensorType;
      });
      var type = powerType[0].type;
      (0, _awsManager.getLastNRecordsFromAllSensors)(_this.state.powerFilter, _this.state.deviceId, type).then(function (data) {
        var timestamps = [],
            currentValues = [],
            dateString = [];
        var averageData = [];
        var averageTime = [];
        var dateStringToShow = [];
        data.length > 0 && data.forEach(function (item) {
          timestamps.push((0, _util.getTimeFromTimestamp)(item.time * 1000));
          dateString.push(new Date(item.time * 1000).toLocaleString());

          var currentPower = item.values.find(function (currentItem) {
            if (currentItem.hasOwnProperty(type)) {
              return true;
            }
            return false;
          });
          currentValues.push(item && currentPower && currentPower[type] ? currentPower[type] : 0);

          if (index === 0) {
            heartbeat.lastInteractionReceived = (0, _util.getFormattedDate)(item.time, false);
          }
          index++;
        });

        if (_this.state.powerFilter !== "Latest 10 Records" && _this.state.powerFilter !== "1 Day") {
          var _filter3 = _this.getFilteredRecord(_this.state.powerFilter);
          var filteredArrays = _this.findAverageOfFilteredData(data, _filter3);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = filteredArrays.arrayForDays.map(function (item) {
            if (item.length > 0) {
              var sum = item.reduce(function (a, b) {
                var powerData = b[0] && b[0][type] ? b[0][type] : 0;
                return a + powerData;
              }, 0);
              var average = sum / item.length;
              if (Number.isNaN(average)) {
                return 0;
              }
              return average.toFixed(2);
            }
            return 0;
          });
        } else {
          averageTime = timestamps;
          dateStringToShow = dateString;
          averageData = currentValues;
        }

        heartbeat.latestP = (currentValues.length > 0 ? currentValues[0] : 0) + " amp";

        // heartbeat.UpdateTemperatureChartWithId(heartbeat.latestT);

        var thresholdsBoolTemperature = false;
        // if (maxThresholdTemperature && minThresholdTemperature) {
        //   if (
        //     currentValues[0] > maxThresholdTemperature ||
        //     currentValues[0] < minThresholdTemperature
        //   ) {
        //     thresholdsBoolTemperature = true;
        //   }
        // }
        heartbeat.setState({
          timestamps: timestamps.reverse(),
          dateString: dateString.reverse(),
          latestPower: heartbeat.latestP,
          powerData: currentValues.reverse(),
          lastUpdatedTimePower: data.length > 0 && data[0].time
        });

        heartbeat.powerChart = (0, _chartManager.realtimeChart)(heartbeat.powerId, heartbeat.powerChart, "line", averageTime, averageData, thresholdsBoolTemperature, null, heartbeat.powerChart && !_jquery2.default.isEmptyObject(heartbeat.powerChart), dateStringToShow, null, null, _this.state.powerFilter);
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.getTemperatureData = function (data) {
      var index = 0;
      var minThresholdTemperature = data.sensors[0].min;
      var maxThresholdTemperature = data.sensors[0].max;
      var heartbeat = _this;
      var tempType = tempTypeSensor.filter(function (items) {
        return items.item === _this.state.tempSensorType;
      });
      var type = tempType[0].type;
      // if (type === tempTypeSensor[0].type) {
      //   heartbeat.temperatureChart = groupLineChart(
      //     heartbeat.temperatureId,
      //     heartbeat.temperatureChart,
      //     heartbeat.temperatureChart &&
      //     !$.isEmptyObject(heartbeat.temperatureChart),
      //   );
      // } else {
      (0, _awsManager.getLastNRecordsFromAllSensors)(_this.state.temperatureFilter, _this.state.deviceId, type).then(function (data) {
        var timestamps = [],
            temperatures = [],
            dateString = [];
        var averageData = [];
        var averageTime = [];
        var dateStringToShow = [];
        data.length > 0 && data.forEach(function (item) {
          timestamps.push((0, _util.getTimeFromTimestamp)(item.time * 1000));
          dateString.push(new Date(item.time * 1000).toLocaleString());

          var currentTemperature = item.values.find(function (currentItem) {
            if (currentItem.hasOwnProperty(type)) {
              return true;
            }
            return false;
          });
          temperatures.push(item && currentTemperature && currentTemperature[type] ? currentTemperature[type] : 0);

          if (index === 0) {
            heartbeat.lastInteractionReceived = (0, _util.getFormattedDate)(item.time, false);
          }
          index++;
        });

        if (_this.state.temperatureFilter !== "Latest 10 Records" && _this.state.temperatureFilter !== "1 Day") {
          var _filter4 = _this.getFilteredRecord(_this.state.temperatureFilter);
          var filteredArrays = _this.findAverageOfFilteredData(data, _filter4);
          averageTime = filteredArrays.time;
          dateStringToShow = filteredArrays.time;
          averageData = filteredArrays.arrayForDays.map(function (item) {
            if (item.length > 0) {
              var sum = item.reduce(function (a, b) {
                var temperatureData = b[0] && b[0][type] ? b[0][type] : 0;
                return a + temperatureData;
              }, 0);
              var average = sum / item.length;
              if (Number.isNaN(average)) {
                return 0;
              }
              return average.toFixed(2);
            }
            return 0;
          });
        } else {
          averageTime = timestamps;
          dateStringToShow = dateString;
          averageData = temperatures;
        }

        heartbeat.latestT = (temperatures.length > 0 ? temperatures[0] : 0) + "\xBA";

        heartbeat.UpdateTemperatureChartWithId(heartbeat.latestT);

        var thresholdsBoolTemperature = false;
        if (maxThresholdTemperature && minThresholdTemperature) {
          if (temperatures[0] > maxThresholdTemperature || temperatures[0] < minThresholdTemperature) {
            thresholdsBoolTemperature = true;
          }
        }
        heartbeat.setState({
          timestamps: timestamps.reverse(),
          dateString: dateString.reverse(),
          latestTemperature: heartbeat.latestT,
          temperatureData: temperatures.reverse(),
          lastUpdatedTimeTemperature: data.length > 0 && data[0].time
        });
        heartbeat.temperatureChart = (0, _chartManager.realtimeChart)(heartbeat.temperatureId, heartbeat.temperatureChart, "line", averageTime, averageData, thresholdsBoolTemperature, null, heartbeat.temperatureChart && !_jquery2.default.isEmptyObject(heartbeat.temperatureChart), dateStringToShow, null, null, _this.state.temperatureFilter);
      }).catch(function (err) {
        console.log(err);
      });
      // }
    };

    _this.querySensorAPIAndPlotDeviceCharts = function () {
      _this.getPowerData();
      (0, _awsManager.getPitWarningLevel)(_this.props.deviceId).then(function (data) {
        (0, _awsManager.getLocation)(_this.props.deviceId).then(function (item) {
          _this.setState({
            deviceLocation: {
              latitude: item.lat,
              longitude: item.lon,
              deviceID: _this.props.deviceId,
              streetAddress: item.streetAddress
            }
          });
        });
        _this.getTemperatureData(data);
        _this.getWaterLevelData(data);
      }).catch(function (error) {
        console.log("error: ", error);
      });
    };

    _this.getTimeStampsInSeconds = function (minsBack) {
      var timeStampOfNowInSeconds = Math.trunc(+new Date() / 1000) - 10 * 60 * 60;
      var pollingFromTimeStampInSeconds = timeStampOfNowInSeconds - minsBack * 60;
      var pollingToTimeStampInSeconds = timeStampOfNowInSeconds;

      return {
        pollingFromTimeStampInSeconds: pollingFromTimeStampInSeconds,
        pollingToTimeStampInSeconds: pollingToTimeStampInSeconds
      };
    };

    _this.fetchTechOnSiteData = function () {
      (0, _awsManager.requestTechOnSiteData)(_this.props.deviceId, "Checkin").then(function (data) {
        _this.setState({
          techOnSiteStatus: data
        });
      }).catch(function (error) {
        _this.setState({
          techOnSiteStatus: []
        });
      });
    };

    _this.getChartData = function () {
      (0, _awsManager.getPitDepth)(_this.props.deviceId).then(function (item) {
        _this.setState({
          pitDepth: item.pitDepth
        });
      }).catch(function (error) {
        console.log("error: ", error);
      });
      _this.getPitStatus();
      _this.querySensorAPIAndPlotDeviceCharts();
      _this.fetchTechOnSiteData();
    };

    _this.getLastUpdatedTime = function () {
      var nodeVitalsUpdatedTime = _this.state.nodeVitals.length > 0 && _this.state.nodeVitals[0] && _this.state.nodeVitals[0].time;
      var maxTime = Math.max(_this.state.lastUpdatedTimeWater, _this.state.lastUpdatedTimeTemperature, _this.state.lastUpdatedTimePower, nodeVitalsUpdatedTime);
      if (_this.state.lastUpdatedTimeWater || _this.state.lastUpdatedTimeTemperature || _this.state.lastUpdatedTimePower || nodeVitalsUpdatedTime) {
        var _date = maxTime;
        var updatedTime = new Date(_date * 1000).getFullYear() + "-" + ("0" + (new Date(_date * 1000).getMonth() + 1)).substr(-2) + "-" + ("0" + new Date(_date * 1000).getDate()).substr(-2) + ", " + ("0" + new Date(_date * 1000).getHours()).substr(-2) + ":" + ("0" + new Date(_date * 1000).getMinutes()).substr(-2) + ":" + ("0" + new Date(_date * 1000).getSeconds()).substr(-2);
        return updatedTime;
      }
    };

    _this.getNextUpdatedTime = function () {
      var nodeVitalsUpdatedTime = _this.state.nodeVitals.length > 0 && _this.state.nodeVitals[0] && _this.state.nodeVitals[0].time;
      var maxTime = Math.max(_this.state.lastUpdatedTimeWater, _this.state.lastUpdatedTimeTemperature, _this.state.lastUpdatedTimePower, nodeVitalsUpdatedTime);
      var transmitInterval = Object.keys(_this.state.configurationValues).length > 0 ? _this.state.configurationValues.network && _this.state.configurationValues.network.reported : 0;
      var currentDate = new Date();
      var nextUpdatedTime = (new Date((maxTime + transmitInterval) * 1000) - currentDate) / 1000;
      // let hours = Math.floor(nextUpdatedTime / 3600).toString().replace('-', '');
      // let minutes = (Math.floor(nextUpdatedTime / 60) - (hours * 60)).toString().replace('-', '');
      var d = Number(nextUpdatedTime.toString().replace('-', ''));
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour" : " hours") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute" : " minutes") : "";
      // let sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      if (transmitInterval) {
        if (nextUpdatedTime >= 0) {
          return "Next update in " + hDisplay + " " + mDisplay;
        } else {
          return "Update delayed by " + hDisplay + " " + mDisplay;
        }
      }
    };

    _this.getUpdatedTimeAgo = function () {
      var nodeVitalsUpdatedTime = _this.state.nodeVitals.length > 0 && _this.state.nodeVitals[0] && _this.state.nodeVitals[0].time;
      if (_this.state.lastUpdatedTimeWater || _this.state.lastUpdatedTimeTemperature || _this.state.lastUpdatedTimePower || nodeVitalsUpdatedTime) {
        return Math.max(_this.state.lastUpdatedTimeWater, _this.state.lastUpdatedTimeTemperature, _this.state.lastUpdatedTimePower, nodeVitalsUpdatedTime);
      }
    };

    _this.getdeviceOnline = function () {
      var nodeVitalsUpdatedTime = _this.state.nodeVitals.length > 0 && _this.state.nodeVitals[0] && _this.state.nodeVitals[0].time;
      var transmitInterval = Object.keys(_this.state.configurationValues).length > 0 ? _this.state.configurationValues.network && _this.state.configurationValues.network.reported : 0;
      var currentDate = new Date();
      var lastUpdatedTime = Math.max(_this.state.lastUpdatedTimeWater, _this.state.lastUpdatedTimeTemperature, _this.state.lastUpdatedTimePower, nodeVitalsUpdatedTime);
      var isActive = (currentDate < new Date((lastUpdatedTime + transmitInterval) * 1000)) / 1000;
      if (isActive) {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block mx-2 pl-0",
          src: "../../../../assets/images/online.png",
          alt: "Online",
          style: {
            borderRadius: 15
          }
        });
      } else if (lastUpdatedTime === null) {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block mx-2 pl-0",
          src: "../../../../assets/images/offline.png",
          alt: "Offline",
          style: {
            borderRadius: 15
          }
        });
      }
      return _react2.default.createElement("img", {
        className: "battery-charge-img d-inline-block mx-2 pl-0",
        src: "../../../../assets/images/redIc.png",
        alt: "Offline",
        style: {
          borderRadius: 15
        }
      });
    };

    _this.showBatteryLevel = function (batteryVoltage) {
      if (batteryVoltage > 6.8) {
        return _react2.default.createElement("i", {
          className: "fa fa-battery-full text-green mx-2 signalBatteryIcon",
          "aria-hidden": "true"
        });
      } else if (batteryVoltage >= 6.6 && batteryVoltage <= 6.89) {
        return _react2.default.createElement("i", {
          className: "fa fa-battery-three-quarters text-yellow mx-2 signalBatteryIcon",
          "aria-hidden": "true"
        });
      } else if (batteryVoltage >= 6.0 && batteryVoltage <= 6.59) {
        return _react2.default.createElement("i", {
          className: "fa fa-battery-half display-1 text-orange mx-2 signalBatteryIcon",
          "aria-hidden": "true"
        });
      } else {
        return _react2.default.createElement("i", {
          className: "fa fa-battery-quarter text-red mx-2 signalBatteryIcon",
          "aria-hidden": "true"
        });
      }
    };

    _this.showSignalLevel = function (signalStrength) {
      if (signalStrength > 25) {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block mx-2 pl-0",
          src: "../../../../assets/images/signal4.png",
          alt: "signal4"
        });
      } else if (signalStrength >= 14 && signalStrength <= 25) {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block mx-2 pl-0",
          src: "../../../../assets/images/signal3.png",
          alt: "signal3"
        });
      } else if (signalStrength >= 8 && signalStrength <= 13) {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block mx-2 pl-0",
          src: "../../../../assets/images/signal2.png",
          alt: "signal2"
        });
      } else {
        return _react2.default.createElement("img", {
          className: "battery-charge-img d-inline-block mx-2 pl-0",
          src: "../../../../assets/images/signal1.png",
          alt: "signal1"
        });
      }
    };

    _this.pollForDeviceChartData = function () {
      _this.getChartData();
      _this.getAllConfiguration();
      (0, _awsManager.getIndividualNodeVitals)(_this.props.deviceId).then(function (data) {
        _this.setState({
          nodeVitals: data
        });
      }).catch(function (error) {
        console.log('error: ', error);
      });
      _this.deviceChartsPollingSetInterval = setInterval(function () {
        _this.getChartData();
        _this.getAllConfiguration();
      }, CONST.UPDATE_INTERVAL);
    };

    _this.clearDeviceChartsPollingSetInterval = function () {
      clearInterval(_this.deviceChartsPollingSetInterval);
    };

    _this.props.showLoader();

    _this.UpdateTemperatureChartWithId("");
    _this.UpdateWaterLevelChartWithId("");
    // this.UpdateSecurityPitStatusChartWithId();
    _this.state = {
      timestamps: [],
      dateString: [],
      temperatureData: [],
      waterLevelData: [],
      powerData: [],
      batteryChargeData: [],
      pitStatusData: [],
      techStatusData: [],
      temperature_threshold_bool: false,
      waterLevel_threshold_bool: false,
      batteryCharge_threshold_bool: false,
      temperature_threshold_boolM: false,
      waterLevel_threshold_boolM: false,
      batteryCharge_threshold_boolM: false,
      showStore: true,
      showStore1: false,
      timestampsM: [],
      dateStringM: [],
      temperaturesM: [],
      waterLevelsM: [],
      batteryChargesM: [],
      pitStatusDataM: [],
      pitStatus: [],
      techStatusDataM: [],
      temperatureDropdown: false,
      latestTemperature: "",
      latestWaterLevel: "",
      latestPower: "",
      pitDepth: 45,
      chartsToShow: [_this.temperatureChartWithId.chartJSX, _this.waterLevelChartWithId.chartJSX],
      subscribedTopic: CONST.DEVICE_SUBSCRIBE_TOPIC.replace(CONST.DEVICE_ID, _this.props.deviceId),
      pitStatusTopic: CONST.DEVICE_PIT_STATUS_TOPIC.replace(CONST.DEVICE_ID, _this.props.deviceId),
      techStatusTopic: CONST.DEVICE_TECH_STATUS_TOPIC.replace(CONST.DEVICE_ID, _this.props.deviceId),
      deviceId: _this.props.deviceId,
      nameOfDevicePit: "",
      currentPitStatus: "",
      currentTechOnSite: "",
      lastTechOnSite: "",
      techOnSiteStatus: [],
      lastFloodAlertInPit: null,
      pitStatusTime: [],
      latestPitStatus: "Closed",
      pitStatusTimeWithDate: [],
      pitStatusForYaxis: [],
      pitStatusModalData: [],
      pitStatusTimeModalData: [],
      pitStatusForYaxisModalData: [],
      pitStatusTimeWithDateModalData: [],
      waterLevelValueToShow: [],
      waterLevelModalValueToShow: [],
      lastUpdatedTimeWater: "",
      lastUpdatedTimeTemperature: "",
      lastUpdatedTimePower: "",
      temperatureFilter: "Latest 10 Records",
      temperaturetoggle: false,
      tempSensorType: "Sensor 1",
      tempSensorToggle: false,
      powerSensorType: "Sensor 1",
      powerSensorToggle: false,
      waterFilter: "Latest 10 Records",
      watertoggle: false,
      pitStatusFilter: "1 Day",
      pitStatustoggle: false,
      powerFilter: "Latest 10 Records",
      powerToggle: false,
      deviceLocation: {
        latitude: -24.397,
        longitude: 135.644,
        deviceID: _this.props.deviceId,
        streetAddress: ''
      },
      temp: false,
      configurationValues: {},
      nodeVitals: []
    };
    return _this;
  }

  _createClass(App, [{
    key: "plotInitialPitStatusChart",
    value: function plotInitialPitStatusChart(heartbeat) {
      heartbeat.securityPitStatusChart = (0, _chartManager.pitStatusBubbleChart)(heartbeat.securityPitStatusId, heartbeat.securityPitStatusChart, "bubble", heartbeat.state.pitStatusData, null);
      this.props.hideLoader();
    }
  }, {
    key: "plotInitialTechStatusChart",
    value: function plotInitialTechStatusChart(heartbeat) {
      heartbeat.securityTechOnSiteChart = (0, _chartManager.pitStatusBubbleChart)(heartbeat.securityTechOnSiteId, heartbeat.securityTechOnSiteChart, "bubble", heartbeat.state.techStatusData, null);
      this.props.hideLoader();
    }
  }, {
    key: "getFilteredRecord",
    value: function getFilteredRecord(data) {
      switch (data) {
        case "Latest 10 Records":
          {
            return 10;
          }
        case "1 Day":
          {
            return 1;
          }
        case "7 Days":
          {
            return 7;
          }
        case "14 Days":
          {
            return 14;
          }
        case "28 Days":
          {
            return 28;
          }
        default:
          return 10;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.pollForDeviceChartData();
      this.props.hideLoader();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.deviceId !== this.state.deviceId) {
        this.UpdateTemperatureChartWithId("");
        this.UpdateWaterLevelChartWithId("");
        this.disposeAllChartsAndModalsAndUnsusbcribe();
        this.setState({
          deviceId: nextProps.deviceId
        }, function () {
          _this2.pollForDeviceChartData();
        });
      } else if (nextProps.payload !== this.props.payload) {
        console.log("Next props");
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var windowWidth = (0, _jquery2.default)(window).width();
      if (windowWidth <= 567) {
        this.setState({
          isLarge: false
        });
      } else {
        this.setState({
          isLarge: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposeAllChartsAndModalsAndUnsusbcribe();
    }
  }]);

  return App;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var symbioticReducer = _ref.symbioticReducer;

  return {
    deviceId: symbioticReducer.deviceId,
    thresholds: symbioticReducer.thresholds,
    layoutHeartBeat: symbioticReducer.layoutHeartbeat,
    isMARight: symbioticReducer.isMARight,
    payload: symbioticReducer.payload
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    // Dispatch action to show loader
    showLoader: function showLoader() {
      dispatch({ type: "SHOW_OVERALL_APP_LOADER" });
    },
    // Dispatch action to hide loader
    hideLoader: function hideLoader() {
      dispatch({
        type: "HIDE_OVERALL_APP_LOADER"
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(filter, "filter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(tempTypeSensor, "tempTypeSensor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(powerTypeSensor, "powerTypeSensor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_jquery2, "_jquery2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_moment2, "_moment2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_Tooltip2, "_Tooltip2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_reactTimeago2, "_reactTimeago2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_SymbioticMarkerClusterer2, "_SymbioticMarkerClusterer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_toConsumableArray, "_toConsumableArray", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(filter, "filter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(tempTypeSensor, "tempTypeSensor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(powerTypeSensor, "powerTypeSensor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/heartbeat/index.js");
}();

;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pitStatusBubbleChart = exports.getBubbleColor = exports.pitStatusSteppedCharts = exports.realtimeChart = exports.groupLineChart = exports.displayChartManager = undefined;

var _chart = __webpack_require__(1912);

var _chart2 = _interopRequireDefault(_chart);

var _colorCharts = __webpack_require__(375);

var _momentTimezone = __webpack_require__(1913);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var local_date = _momentTimezone2.default.tz.guess();
var timeZoneOffset = new Date().getTimezoneOffset();
var zone = _momentTimezone2.default.tz.zone(local_date).abbr(timeZoneOffset);

_chart2.default.defaults.global.defaultFontColor = "#fff";

var thresholdCrossedTurnRed = function thresholdCrossedTurnRed(chart, threshold, chartId) {
  if (!chart.config || !chart.config.data || !chart.config.data.datasets || chart.config.data.datasets.length === 0) return;

  if (threshold) {
    $("#header-" + chartId).addClass("threshold");
    chart.config.data.datasets[0].backgroundColor = _colorCharts.redTranslucent;

    chart.config.data.datasets[0].borderColor = _colorCharts.red;
  } else {
    $("#header-" + chartId).removeClass("threshold");
    chart.config.data.datasets[0].backgroundColor = "rgb(111, 170, 225, 0.6)";

    chart.config.data.datasets[0].borderColor = _colorCharts.blue;
  }
  chart.update();
};

var displayChartManager = exports.displayChartManager = function displayChartManager(id, chart, chartType, chartLabels, chartData, threshold, stepValue, update, dateString, waterLevelModalData) {
  var yAxis = void 0,
      labelTag = void 0,
      labelExtension = void 0,
      chartName = void 0,
      yAxisDataToShow = void 0;
  var maxValue = Math.max.apply(Math, _toConsumableArray(chartData));
  var minValue = Math.min.apply(Math, _toConsumableArray(chartData));
  var stepValueData = maxValue - minValue;
  var stepValueM = void 0;
  if (stepValueData > 6) {
    stepValueM = parseInt(maxValue / 6);
  } else {
    stepValueM = 1;
  }
  if (id == "water-level-modal") {
    chartName = "water-level-modal";
    yAxisDataToShow = waterLevelModalData;
    yAxis = [{
      gridLines: {
        display: false
      },
      ticks: {
        // callback: function (chartLabels) {
        //   return '';
        // },
        fontColor: _colorCharts.black,
        max: 45,
        min: 0,
        // reverse: true,
        stepSize: 5
      },
      beginAtZero: false
    }];

    labelTag = "Water level";
    labelExtension = "cm";
  } else {
    chartName = "temperature-modal";
    yAxisDataToShow = chartData;
    yAxis = [{
      gridLines: {
        display: false
      },
      // position:'right',
      ticks: {
        fontColor: _colorCharts.black,
        // max: parseInt(maxValue) + 1,
        // min: parseInt(minValue) - 1,
        stepSize: stepValueM
      },
      beginAtZero: false
      // stepSize: stepValue
    }];
    labelTag = "Temperature";
    labelExtension = "º";
  }
  if (update && chart) {
    thresholdCrossedTurnRed(chart, threshold, id);
    chart.config.data.datasets[0].data = chartData;
    if (id == "water-level-modal") {
      chart.config.data.waterData = waterLevelModalData;
    }
    chart.config.options.scales.yAxes = yAxis;
    chart.config.data.date = dateString;
    chart.config.data.labels = chartLabels;
    chart.update();
  } else {
    var ctx = document.getElementById(id).getContext("2d");
    var config = {
      responsive: true,
      type: chartType,
      data: {
        labels: chartLabels,
        date: dateString,
        waterData: yAxisDataToShow,
        datasets: [{
          pointRadius: 0,
          // pointHitRadius: 200,
          data: chartData,
          backgroundColor: "rgba(100, 16, 219, 0.3)",
          borderColor: _colorCharts.blue,
          borderWidth: 1
        }]
      },
      options: {
        hover: {
          mode: "index",
          intersect: false
        },
        tooltips: {
          callbacks: {
            title: function title(tooltipItem, data) {
              return data["date"][tooltipItem[0]["index"]];
            },
            label: function label(tooltipItem, data) {
              // if (chartName == 'water-level-modal') {
              //   return `${labelTag}: ${data['waterData'][tooltipItem['index']]}${labelExtension}`;
              // }
              // else {
              return labelTag + ": " + data["datasets"][0]["data"][tooltipItem["index"]] + labelExtension;
              // }
            }
            // titleFontSize: 16,
            // bodyFontSize: 16,
          },
          backgroundColor: "white",
          titleFontSize: 14,
          borderColor: "black",
          borderWidth: 1,
          titleFontColor: "#000",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: yAxis,
          xAxes: [{
            ticks: {
              fontColor: _colorCharts.black
            }
          }]
        }
      }
    };
    chart = new _chart2.default(ctx, config);
    thresholdCrossedTurnRed(chart, threshold, id);
  }

  return chart;
};
// export const realtimeChart = (id, chart, chartType, chartLabels, chartData, threshold, stepSize, update) => {
//   let yAxis;
//   if (id == 'waterLevel') {
//     yAxis = [{
//       ticks: {
//         callback: function (chartLabels) {
//           return chartLabels + '%';
//         },
//         max: 100,
//         min: 0,
//         stepSize: stepSize
//       }
//     }]
//   }
//   else {
//     yAxis = {
//       beginAtZero: false
//     }
//   }
//   if (update && chart) {
//     thresholdCrossedTurnRed(chart, threshold, id);
//     chart.config.data.datasets[0].data.push(chartData);
//     chart.config.data.datasets[0].data.shift();
//     chart.config.data.labels.push(chartLabels);
//     chart.config.data.labels.shift();
//     chart.update();
//   } else {
//     const ctx = document.getElementById(id).getContext('2d');
//     const config = {
//       responsive: true,
//       type: chartType,
//       data: {
//         labels: chartLabels,
//         datasets: [{
//           data: chartData,
//           backgroundColor: blueTranslucent,
//           borderColor: blue,
//           borderWidth: 1,
//         }],
//       },
//       options: {
//         tooltips: {
//           mode: 'nearest',
//         },
//         legend: {
//           display: false,
//         },
//         scales: {
//           yAxes: yAxis
//         },
//       },
//     };
//     chart = new Chart(ctx, config);
//     thresholdCrossedTurnRed(chart, threshold, id);
//   }

//   return chart;
// };

var groupLineChart = exports.groupLineChart = function groupLineChart(id, chart, update) {
  var ctx = document.getElementById(id).getContext("2d");
  if (update && chart) {
    chart.update();
  } else {
    var config = {
      type: "line",
      data: {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [{
          fillColor: "rgba(220,220,220,0.2)",
          strokeColor: "rgba(220,220,220,1)",
          data: [65, 59, 80, 81, 56, 55, 40]
        }, {
          fillColor: "rgba(151,187,205,0.2)",
          strokeColor: "rgba(151,187,205,1)",
          data: [28, 48, 40, 19, 86, 27, 90]
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    };
    chart = new _chart2.default(ctx, config);
  }
};

var realtimeChart = exports.realtimeChart = function realtimeChart(id, chart, chartType, chartLabels, chartData, threshold, stepSize, update, dateString, waterLevelData, depthOfPit, filter) {
  var filterTitle = filter !== "Latest 10 Records" && filter !== "1 Day";
  var yAxis = void 0,
      labelTag = void 0,
      labelExtension = void 0,
      chartName = void 0,
      yAxisDataToShow = void 0;
  var maxValue = Math.max.apply(Math, _toConsumableArray(chartData));
  var minValue = Math.min.apply(Math, _toConsumableArray(chartData));
  var stepValueData = maxValue - minValue;
  var stepValue = void 0;
  if (stepValueData > 6) {
    stepValue = parseInt(maxValue / 6);
  } else {
    stepValue = 1;
  }
  if (id == "waterLevel") {
    chartName = "waterLevel";
    yAxisDataToShow = waterLevelData;
    yAxis = [{
      scaleLabel: {
        display: true,
        fontSize: 14,
        fontColor: "black",
        labelString: "Depth (Cms)"
      },
      gridLines: {
        display: false
      },
      ticks: {
        // callback: function () {
        //   return '';
        // },
        fontColor: _colorCharts.black,
        max: depthOfPit,
        min: 0,
        stepSize: parseInt(depthOfPit / 10)
      }
    }];
    labelTag = "Water level";
    labelExtension = "cm";
  } else if (id == "temperature") {
    chartName = "temperature";
    yAxisDataToShow = chartData;
    yAxis = [{
      gridLines: {
        display: false
      },
      scaleLabel: {
        display: true,
        fontSize: 14,
        fontColor: "black",
        labelString: "Temperature (Celsius)"
      },
      ticks: {
        fontColor: _colorCharts.black,
        max: parseInt(maxValue) + 2,
        min: parseInt(minValue) === 0 ? 0 : parseInt(minValue) - 2,
        stepSize: stepValue
      },
      beginAtZero: false
    }];
    labelTag = "Temperature";
    labelExtension = "º";
  } else {
    chartName = "current";
    yAxisDataToShow = chartData;
    yAxis = [{
      gridLines: {
        display: false
      },
      scaleLabel: {
        display: true,
        fontSize: 14,
        fontColor: "black",
        labelString: "Power (Amp)"
      },
      ticks: {
        fontColor: _colorCharts.black,
        max: parseInt(maxValue) + 2,
        min: parseInt(minValue) === 0 ? 0 : parseInt(minValue) - 2,
        stepSize: stepValue
      },
      beginAtZero: false
    }];
    labelTag = "Power";
    labelExtension = " Amp";
  }
  if (update && chart) {
    thresholdCrossedTurnRed(chart, threshold, id);
    chart.config.data.datasets[0].data = chartData;
    if (id === "waterLevel") {
      chart.config.data.waterData = waterLevelData;
    }
    chart.config.options.scales.yAxes = yAxis;
    chart.config.options.scales.xAxes = [{
      // gridLines: {
      //   display: false,
      // },
      ticks: {
        fontColor: _colorCharts.black
      },
      scaleLabel: {
        display: true,
        fontSize: 14,
        fontColor: "black",
        labelString: filterTitle ? "Date (" + zone + ")" : "Time (" + zone + ")"
      }
    }];
    chart.config.data.date = dateString;
    chart.config.data.labels = chartLabels;
    chart.update();
  } else {
    var ctx = document.getElementById(id).getContext("2d");
    var config = {
      responsive: true,
      type: chartType,
      data: {
        labels: chartLabels,
        date: dateString,
        waterData: yAxisDataToShow,
        datasets: [{
          pointRadius: 0,
          pointHitRadius: 60,
          data: chartData,
          backgroundColor: "rgba(100, 16, 219, 0.3)",
          borderColor: _colorCharts.blue,
          borderWidth: 1
        }]
      },
      options: {
        hover: {
          mode: "index",
          intersect: false
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            title: function title(tooltipItem, data) {
              return data["date"][tooltipItem[0]["index"]];
            },
            label: function label(tooltipItem, data) {
              // if (chartName == 'waterLevel') {
              //   return `${labelTag}: ${data['waterData'][tooltipItem['index']]}${labelExtension}`;
              // }
              // else {
              return labelTag + ": " + data["datasets"][0]["data"][tooltipItem["index"]] + labelExtension;
              // }
            }
          },
          backgroundColor: "white",
          titleFontSize: 14,
          borderColor: "black",
          borderWidth: 1,
          titleFontColor: "#000",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: yAxis,
          xAxes: [{
            // gridLines: {
            //   display: false,
            // },
            ticks: {
              fontColor: _colorCharts.black
            },
            scaleLabel: {
              display: true,
              fontSize: 14,
              fontColor: "black",
              labelString: "Time (" + zone + ")"
            }
          }]
        }
      }
    };
    chart = new _chart2.default(ctx, config);
    thresholdCrossedTurnRed(chart, threshold, id);
  }

  return chart;
};

var pitStatusSteppedCharts = exports.pitStatusSteppedCharts = function pitStatusSteppedCharts(id, chart, chartType, chartData, timeStamp, timeWithDate, yAxisData, update, filter) {
  var timeData = timeWithDate;
  var filterTitle = filter !== "Latest 10 Records" && filter !== "1 Day";
  var color = void 0,
      borderForPit = void 0;
  if (chartData[chartData.length - 1] === "Open") {
    $("#header-" + id).addClass("threshold");
    borderForPit = _colorCharts.red;
    color = _colorCharts.redTranslucent;
  } else {
    $("#header-" + id).removeClass("threshold");
    borderForPit = _colorCharts.blue;
    color = "rgb(111, 170, 225, 0.6)";
  }

  if (update && chart) {
    chart.config.data.datasets[0].backgroundColor = color;
    chart.config.data.datasets[0].borderColor = borderForPit;
    chart.config.data.datasets[0].data = yAxisData;
    chart.config.data.status = chartData;
    chart.config.data.labels = timeStamp;
    chart.config.options.scales.xAxes = [{
      scaleLabel: {
        display: true,
        fontSize: 14,
        fontColor: "black",
        labelString: filterTitle ? "Date (" + zone + ")" : "Time (" + zone + ")"
      },
      gridLines: {
        display: false
      },
      ticks: {
        fontColor: _colorCharts.black
      }
    }], chart.config.data.timeDataToShow = timeData;
    chart.update();
  } else {
    var ctx = document.getElementById(id).getContext("2d");
    var config = {
      responsive: true,
      type: chartType,
      data: {
        labels: timeStamp,
        status: chartData,
        timeDataToShow: timeData,
        datasets: [{
          pointRadius: 5,
          pointHitRadius: 60,
          data: yAxisData,
          backgroundColor: color,
          borderColor: borderForPit,
          borderWidth: 1,
          steppedLine: true
        }]
      },
      options: {
        hover: {
          mode: "index",
          intersect: false
        },
        animation: false,
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            title: function title(tooltipItem, data) {
              return "" + data.timeDataToShow[tooltipItem[0]["index"]];
            },
            label: function label(tooltipItem, data) {
              return "Status: " + data["status"][tooltipItem["index"]];
            }
          },
          backgroundColor: "white",
          titleFontSize: 14,
          borderColor: "black",
          borderWidth: 1,
          titleFontColor: "#000",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              callback: function callback(data) {
                if (data === 1) {
                  return "Open";
                } else if (data === 0) {
                  return "Closed";
                } else {
                  return "";
                }
              },
              fontColor: "black",
              max: 1.2
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              fontSize: 14,
              fontColor: "black",
              labelString: "Time (" + zone + ")"
            },
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: _colorCharts.black
            }
          }]
        }
      }
    };
    chart = new _chart2.default(ctx, config);
  }
  return chart;
};

var getBubbleColor = exports.getBubbleColor = function getBubbleColor(color) {
  switch (color) {
    case "Red":
      return _colorCharts.red;
    case "Green":
      return _colorCharts.green;
    case "Amber":
      return _colorCharts.amber;
  }
};

var pitStatusBubbleChart = exports.pitStatusBubbleChart = function pitStatusBubbleChart(id, chart, type, chartData, update) {
  var Y_VALUE = 20,
      RADIUS = 20;
  if (update && chart) {
    if (!chart.config || !chart.config.data || !chart.config.data.datasets || chart.config.data.datasets.length === 0) return;

    var xValue = chart.config.data.datasets[0].data.length;
    var value = void 0,
        labelValue = void 0,
        colorValue = void 0,
        date = void 0;

    if (chartData.date && chartData.details) {
      value = { x: xValue, y: Y_VALUE, r: RADIUS };
      labelValue = chartData.details;
      date = chartData.date;
      colorValue = getBubbleColor(chartData.color);

      if (chartData.date == chart.config.data.labels[xValue - 1]) {
        chart.config.data.datasets[0].data.pop();
        chart.config.data.labels.pop();

        chart.config.data.datasets[0].details.pop();
        chart.config.data.datasets[0].backgroundColor.pop();

        chart.config.data.labels.push(date);
        chart.config.data.datasets[0].data.push(value);

        chart.config.data.datasets[0].backgroundColor.push(colorValue);
        chart.config.data.datasets[0].details.push(labelValue);
      } else {
        chart.config.data.labels.push(date);
        chart.config.data.labels.shift();

        chart.config.data.datasets[0].data.push(value);
        chart.config.data.datasets[0].data.shift();

        chart.config.data.datasets[0].backgroundColor.push(colorValue);
        chart.config.data.datasets[0].backgroundColor.shift();

        chart.config.data.datasets[0].details.push(labelValue);
        chart.config.data.datasets[0].details.shift();
      }
    }
    chart.update();
  } else {
    var chartValues = [];
    var valuesLabels = [];
    var valueColors = [];
    var _date = [];
    var i = 1;
    chartData.map(function (item) {
      if (item.date && item.details) {
        chartValues.push({ x: i++, y: Y_VALUE, r: RADIUS });
        valuesLabels.push(item.details);
        _date.push(item.date);
        valueColors.push(getBubbleColor(item.color));
      } else {
        chartValues.push({ x: i++, y: Y_VALUE, r: 0 });
        valuesLabels.push("");
        valueColors.push("");
        _date.push(item.date);
      }
    });

    // console.log("### chartValues", chartValues, valueColors, valuesLabels);
    _date.reverse();
    valueColors.reverse();
    valuesLabels.reverse();
    chartValues.reverse();
    var ctx = document.getElementById(id).getContext("2d");
    var config = {
      responsive: true,
      maintainAspectRatio: true,
      data: {
        labels: _date,
        datasets: [{
          type: type,
          backgroundColor: valueColors,
          data: chartValues,
          details: valuesLabels,
          borderColor: valueColors
        }, {
          type: "line",
          data: chartValues,
          details: valuesLabels,
          fill: false,
          borderColor: _colorCharts.white
        }]
      },
      options: {
        elements: {
          point: {
            radius: 0
          }
        },
        legend: {
          display: false
        },
        tooltips: {
          custom: function custom(tooltip) {
            if (!tooltip) return;
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            // use label callback to return the desired label
            label: function label(tooltipItem, data) {
              //return "Testing Tooltip :" + tooltipItem.xLabel;
              return data.datasets[0].details[tooltipItem.index];
            },
            title: function title() {
              return;
            }
          }
        },
        scales: {
          xAxes: [{
            offset: true,
            display: true,
            ticks: {
              // display: false,
              beginAtZero: true,
              fontSize: 9
            },
            gridLines: {
              display: false,
              // lineWidth: 1,
              color: _colorCharts.white
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              display: false,
              beginAtZero: false
            },
            gridLines: {
              display: false,
              // lineWidth: 1,
              color: _colorCharts.white
            }
          }]
        }
      }
    };
    chart = new _chart2.default(ctx, config);
  }
  return chart;
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(displayChartManager, "displayChartManager", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(groupLineChart, "groupLineChart", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(realtimeChart, "realtimeChart", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(pitStatusSteppedCharts, "pitStatusSteppedCharts", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(getBubbleColor, "getBubbleColor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(pitStatusBubbleChart, "pitStatusBubbleChart", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(local_date, "local_date", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(timeZoneOffset, "timeZoneOffset", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(zone, "zone", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(thresholdCrossedTurnRed, "thresholdCrossedTurnRed", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_chart2, "_chart2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(_momentTimezone2, "_momentTimezone2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(_toConsumableArray, "_toConsumableArray", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(local_date, "local_date", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(timeZoneOffset, "timeZoneOffset", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(zone, "zone", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(thresholdCrossedTurnRed, "thresholdCrossedTurnRed", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(displayChartManager, "displayChartManager", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(groupLineChart, "groupLineChart", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(realtimeChart, "realtimeChart", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(pitStatusSteppedCharts, "pitStatusSteppedCharts", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(getBubbleColor, "getBubbleColor", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(pitStatusBubbleChart, "pitStatusBubbleChart", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/util/chartManager.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(2); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1914);
moment.tz.load(__webpack_require__(1915));


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.34
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(2)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.34",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1915 */
/***/ (function(module, exports) {

module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _defaultFormatter = __webpack_require__(1917);

var _defaultFormatter2 = _interopRequireDefault(_defaultFormatter);

var _dateParser = __webpack_require__(1918);

var _dateParser2 = _interopRequireDefault(_dateParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = React.Component;


// Just some simple constants for readability
var MINUTE = 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var WEEK = DAY * 7;
var MONTH = DAY * 30;
var YEAR = DAY * 365;

var TimeAgo = function (_Component) {
  _inherits(TimeAgo, _Component);

  function TimeAgo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeAgo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeAgo.__proto__ || Object.getPrototypeOf(TimeAgo)).call.apply(_ref, [this].concat(args))), _this), _this.isStillMounted = false, _this.tick = function (refresh) {
      if (!_this.isStillMounted || !_this.props.live) {
        return;
      }

      var then = (0, _dateParser2.default)(_this.props.date).valueOf();
      if (!then) {
        console.warn('[react-timeago] Invalid Date provided');
        return;
      }

      var now = _this.props.now();
      var seconds = Math.round(Math.abs(now - then) / 1000);

      var unboundPeriod = seconds < MINUTE ? 1000 : seconds < HOUR ? 1000 * MINUTE : seconds < DAY ? 1000 * HOUR : 0;
      var period = Math.min(Math.max(unboundPeriod, _this.props.minPeriod * 1000), _this.props.maxPeriod * 1000);

      if (period) {
        if (_this.timeoutId) {
          clearTimeout(_this.timeoutId);
        }
        _this.timeoutId = setTimeout(_this.tick, period);
      }

      if (!refresh) {
        _this.forceUpdate();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeAgo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isStillMounted = true;
      if (this.props.live) {
        this.tick(true);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (this.props.live !== lastProps.live || this.props.date !== lastProps.date) {
        if (!this.props.live && this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.tick();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isStillMounted = false;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _props = this.props,
          date = _props.date,
          formatter = _props.formatter,
          Komponent = _props.component,
          live = _props.live,
          minPeriod = _props.minPeriod,
          maxPeriod = _props.maxPeriod,
          title = _props.title,
          now = _props.now,
          passDownProps = _objectWithoutProperties(_props, ['date', 'formatter', 'component', 'live', 'minPeriod', 'maxPeriod', 'title', 'now']);
      /* eslint-enable no-unused-vars */


      var then = (0, _dateParser2.default)(date).valueOf();
      if (!then) {
        return null;
      }
      var timeNow = now();
      var seconds = Math.round(Math.abs(timeNow - then) / 1000);
      var suffix = then < timeNow ? 'ago' : 'from now';

      var _ref2 = seconds < MINUTE ? [Math.round(seconds), 'second'] : seconds < HOUR ? [Math.round(seconds / MINUTE), 'minute'] : seconds < DAY ? [Math.round(seconds / HOUR), 'hour'] : seconds < WEEK ? [Math.round(seconds / DAY), 'day'] : seconds < MONTH ? [Math.round(seconds / WEEK), 'week'] : seconds < YEAR ? [Math.round(seconds / MONTH), 'month'] : [Math.round(seconds / YEAR), 'year'],
          _ref3 = _slicedToArray(_ref2, 2),
          value = _ref3[0],
          unit = _ref3[1];

      var passDownTitle = typeof title === 'undefined' ? typeof date === 'string' ? date : (0, _dateParser2.default)(date).toISOString().substr(0, 16).replace('T', ' ') : title;

      var spreadProps = Komponent === 'time' ? Object.assign({}, passDownProps, {
        dateTime: (0, _dateParser2.default)(date).toISOString()
      }) : passDownProps;

      var nextFormatter = _defaultFormatter2.default.bind(null, value, unit, suffix);

      return React.createElement(
        Komponent,
        _extends({}, spreadProps, { title: passDownTitle }),
        formatter(value, unit, suffix, then, nextFormatter, now)
      );
    }
  }]);

  return TimeAgo;
}(Component);

TimeAgo.displayName = 'TimeAgo';
TimeAgo.defaultProps = {
  live: true,
  component: 'time',
  minPeriod: 0,
  maxPeriod: Infinity,
  formatter: _defaultFormatter2.default,
  now: function now() {
    return Date.now();
  }
};
exports.default = TimeAgo;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFormatter;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function defaultFormatter(value, unit, suffix) {
  if (value !== 1) {
    unit += 's';
  }
  return value + ' ' + unit + ' ' + suffix;
}

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dateParser;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function dateParser(date) {
  var parsed = new Date(date);
  if (!Number.isNaN(parsed.valueOf())) {
    return parsed;
  }

  var parts = String(date).match(/\d+/g);
  if (parts == null || parts.length <= 2) {
    return parsed;
  } else {
    var _parts$map = parts.map(function (x) {
      return parseInt(x);
    }),
        _parts$map2 = _toArray(_parts$map),
        firstP = _parts$map2[0],
        secondP = _parts$map2[1],
        restPs = _parts$map2.slice(2);

    var correctedParts = [firstP, secondP - 1].concat(_toConsumableArray(restPs));
    var isoDate = new Date(Date.UTC.apply(Date, _toConsumableArray(correctedParts)));
    return isoDate;
  }
}

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(30);

var _SymbioticMarkerClusterer = __webpack_require__(376);

var _SymbioticMarkerClusterer2 = _interopRequireDefault(_SymbioticMarkerClusterer);

var _location = __webpack_require__(1920);

var _location2 = _interopRequireDefault(_location);

var _highlightSidebarOption = __webpack_require__(140);

var _awsManager = __webpack_require__(59);

var _lodash = __webpack_require__(165);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.navigateToCataologue = function (isTrue, isInactive, deviceType) {
            if (!(_this.currentPath === "/app/components/heartbeat" || _this.currentPath === "/app/components/notifications" || isTrue)) {
                (0, _highlightSidebarOption.highlightNavigatedMenu)("deviceCatalogue", '#' + _this.currentPath);
                _this.props.history.push("/app/components/deviceCatalogue");
                var _data = [{
                    condition: {
                        type: 'contains',
                        key: 'contains'
                    },
                    key: { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' },
                    value: deviceType
                }];
                if (isInactive) {
                    _data.push({
                        condition: { type: "is equals", key: "equal" },
                        key: { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator', type: 'string' },
                        value: "INACTIVE"
                    });
                }
                _this.props.addDeviceCatalogueFilter(_data);
            } else {
                (0, _highlightSidebarOption.highlightNavigatedMenu)("heartbeat", '#' + _this.currentPath);
                _this.props.history.push("/app/components/heartbeat");
            }
        };

        _this.navigateToAlertsPage = function (deviceType) {
            if (!(_this.currentPath === "/app/components/heartbeat" || _this.currentPath === "/app/components/notifications")) {
                (0, _highlightSidebarOption.highlightNavigatedMenu)("alerts", '#' + _this.currentPath);
                _this.props.history.push("/app/components/alerts");
                var _data2 = [{
                    condition: { type: "is equals", key: "equal" },
                    key: {
                        disablePadding: false,
                        id: "alertStatus",
                        label: "Alert Status",
                        numeric: false,
                        type: "string"
                    },
                    value: "Open"
                }, {
                    condition: {
                        type: 'contains',
                        key: 'contains'
                    },
                    key: { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' },
                    value: deviceType
                }];
                _this.props.addAlert(_data2);
            }
        };

        _this.renderGraph = function () {
            return _react2.default.createElement('div', { className: 'col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12 h-100 pl-0 ml-0 pr-3' }, _react2.default.createElement(_SymbioticMarkerClusterer2.default, {
                navigate: function navigate(deviceId) {
                    _this.props.updateDeviceId(deviceId);
                    _this.navigateToCataologue(true);
                },
                markerData: _this.state.deviceLocation,
                onBoundsChanged: function onBoundsChanged(bounds) {}
            }));
        };

        _this.state = {
            deviceLocation: _location2.default,
            eptTotal: [],
            revTotal: [],
            eptInactive: [],
            revInactive: [],
            revOpenAlert: [],
            eptOpenAlert: []
        };

        return _this;
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var revTotal = [],
                eptTotal = [],
                eptInactive = [],
                revInactive = [],
                revOpenAlert = [],
                eptOpenAlert = [];
            (0, _awsManager.getDeviceCatalogue)(this.props.deviceId).then(function (data) {
                (0, _awsManager.getNodeVitals)().then(function (nodeResult) {
                    var item = [].concat(_toConsumableArray(data), _toConsumableArray(nodeResult));
                    item.push(nodeResult);
                    eptInactive = item.filter(function (items) {
                        return items.status === "INACTIVE" && items.nodeId.includes('ept-nbn');
                    });
                    revInactive = item.filter(function (items) {
                        return items.status === "INACTIVE" && items.nodeId.includes('rev-nbn');
                    });
                    var filterEptInactive = _lodash2.default.uniqBy(eptInactive, 'nodeId');
                    var filterRevInactive = _lodash2.default.uniqBy(revInactive, 'nodeId');
                    _this2.setState({
                        eptInactive: filterEptInactive,
                        revInactive: filterRevInactive
                    });
                }).catch(function (error) {
                    console.log('error: ', error);
                });
                revTotal = data.filter(function (item) {
                    return (item.status === "ACTIVE" || item.status === "INACTIVE") && item.nodeId.includes('rev-nbn');
                });
                eptTotal = data.filter(function (item) {
                    return (item.status === "ACTIVE" || item.status === "INACTIVE") && item.nodeId.includes('ept-nbn');
                });
                _this2.setState({
                    eptTotal: eptTotal,
                    revTotal: revTotal
                });
            }).catch(function (error) {
                console.log('error: ', error);
            });
            (0, _awsManager.alertsModificationData)().then(function (data) {
                revOpenAlert = data.filter(function (item) {
                    return item.alertStatus === "Open" && item.nodeId.includes('rev-nbn');
                });
                eptOpenAlert = data.filter(function (item) {
                    return item.alertStatus === "Open" && item.nodeId.includes('ept-nbn');
                });
                var filterRev = _lodash2.default.uniqBy(revOpenAlert, 'nodeId');
                var filterEpt = _lodash2.default.uniqBy(eptOpenAlert, 'nodeId');
                _this2.setState({
                    revOpenAlert: filterRev,
                    eptOpenAlert: filterEpt
                });
            }).catch(function (error) {
                console.log('error: ', error);
            });
            this.currentPath = this.props.location.pathname;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            this.unlisten = this.props.history.listen(function (location) {
                _this3.currentPath = location.pathname;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement('div', { id: 'landing-screen', className: 'contentOuter-wrapper row' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'jr-card d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('div', { onClick: function onClick() {
                    console.log("Test");
                }, className: 'col-12 col-sm-12 col-lg-12' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Summary')))), _react2.default.createElement('h1', { className: 'mx-4 my-3' }, 'ePITome DEVICES'), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-12 row' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-4 col-lg-4', onClick: function onClick() {
                    _this4.navigateToCataologue(false, false, 'ept-nbn');
                } }, _react2.default.createElement('div', { className: 'jr-card' }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-black text-center' }, 'Total Devices')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { className: 'col-12 text-center caption-outer' }, _react2.default.createElement('h1', null, ' ', this.state.eptTotal.length, ' '))))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-4 col-lg-4' }, _react2.default.createElement('div', { className: 'jr-card', onClick: function onClick() {
                    _this4.navigateToCataologue(false, true, 'ept-nbn');
                } }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-black text-center' }, 'Inactive Devices')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { className: 'col-12 text-center caption-outer' }, _react2.default.createElement('h1', null, ' ', this.state.eptInactive.length, ' '))))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-4 col-lg-4' }, _react2.default.createElement('div', { className: 'jr-card', onClick: function onClick() {
                    _this4.navigateToAlertsPage('ept-nbn');
                } }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-black text-center' }, 'Devices with Open Alerts')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { className: 'col-12 text-center caption-outer' }, _react2.default.createElement('h1', null, ' ', this.state.eptOpenAlert.length, ' ')))))), _react2.default.createElement('h1', { className: 'mx-4 my-3' }, 'reVOLT DEVICES'), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-12 row' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-4 col-lg-4' }, _react2.default.createElement('div', { className: 'jr-card', onClick: function onClick() {
                    _this4.navigateToCataologue(false, false, 'rev-nbn');
                } }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-black text-center' }, 'Total Devices')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { className: 'col-12 text-center caption-outer' }, _react2.default.createElement('h1', null, ' ', this.state.revTotal.length, ' '))))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-4 col-lg-4' }, _react2.default.createElement('div', { className: 'jr-card', onClick: function onClick() {
                    _this4.navigateToCataologue(false, true, 'rev-nbn');
                } }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-black text-center' }, 'Inactive Devices')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { className: 'col-12 text-center caption-outer' }, _react2.default.createElement('h1', null, ' ', this.state.revInactive.length, ' '))))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-4 col-lg-4' }, _react2.default.createElement('div', { className: 'jr-card', onClick: function onClick() {
                    _this4.navigateToAlertsPage('rev-nbn');
                } }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h3', { className: 'text-black text-center' }, 'Devices with Open Alerts')), _react2.default.createElement('div', { className: 'jr-card-body contentInner-wrapper' }, _react2.default.createElement('div', { className: 'col-12 text-center caption-outer' }, _react2.default.createElement('h1', null, ' ', this.state.revOpenAlert.length, '  ')))))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-12' }, this.renderGraph()));
        }
    }]);

    return App;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateDeviceId: function updateDeviceId(id) {
            dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
        },
        showLoader: function showLoader() {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: function hideLoader() {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        },
        addAlert: function addAlert(data) {
            dispatch({
                type: 'ALERT_FILTER',
                alertFilter: data
            });
        },
        addDeviceCatalogueFilter: function addDeviceCatalogueFilter(data) {
            dispatch({
                type: 'DEVICE_CATALOGUE_FILTER',
                deviceCatalogueFilters: data
            });
        }
    };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(App);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(App, 'App', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_SymbioticMarkerClusterer2, "_SymbioticMarkerClusterer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_location2, "_location2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_lodash2, "_lodash2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_toConsumableArray, "_toConsumableArray", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/landingPage/index.js");
}();

;

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

module.exports = [{"deviceID":"ept-nbn-au-000001","assetId":"NSW - WETH WK04","latitude":-33.8674,"longitude":150.9178},{"deviceID":"ept-nbn-au-000002","assetId":"NSW - MILL ME79","latitude":-33.9177,"longitude":150.881},{"deviceID":"ept-nbn-au-000003","assetId":"NSW - MILL ME90","latitude":-33.9048,"longitude":150.8842},{"deviceID":"ept-nbn-au-000004","assetId":"NSW - ESPK ER14","latitude":-33.7932,"longitude":150.7943},{"deviceID":"ept-nbn-au-000005","assetId":"NSW - QUAK QL04","latitude":-33.741796,"longitude":150.893915},{"deviceID":"ept-nbn-au-000006","assetId":"NSW - ROSE RB05","latitude":-33.8725,"longitude":151.2743},{"deviceID":"ept-nbn-au-000007","assetId":"VIC - HTLL HOAB","latitude":-37.85247378,"longitude":145.0767819},{"deviceID":"ept-nbn-au-000008","assetId":"NSW - PETE PM47","latitude":-33.877385,"longitude":151.156463},{"deviceID":"ept-nbn-au-000009","assetId":"VIC - HTLL HWBB","latitude":-37.85470839,"longitude":145.0830552},{"deviceID":"ept-nbn-au-000010","assetId":"VIC - GLIS GIWM","latitude":-37.865134,"longitude":145.058687},{"deviceID":"rev-nbn-au-000001","assetId":"PYMB PE23","latitude":-33.743641,"longitude":151.148476},{"deviceID":"rev-nbn-au-000002","assetId":"PENN PH13","latitude":-33.725069,"longitude":151.084145},{"deviceID":"rev-nbn-au-000003","assetId":"PYMB PE31","latitude":-33.731395,"longitude":151.130052},{"deviceID":"rev-nbn-au-000004","assetId":"PENN PH17","latitude":-33.732037,"longitude":151.060639},{"deviceID":"rev-nbn-au-000005","assetId":"PYMB PE17","latitude":-33.731619,"longitude":151.164542},{"deviceID":"rev-nbn-au-000006","assetId":"PENN PH12","latitude":-33.72313,"longitude":151.07665},{"deviceID":"rev-nbn-au-000007","assetId":"PENN PH12","latitude":-33.714907,"longitude":151.070978},{"deviceID":"rev-nbn-au-000008","assetId":"PENN PH16","latitude":-33.724539,"longitude":151.080724},{"deviceID":"rev-nbn-au-000009","assetId":"PYMB PE31","latitude":-33.734548,"longitude":151.127512},{"deviceID":"rev-nbn-au-000010","assetId":"CARL CI27","latitude":-33.776753,"longitude":151.023379},{"deviceID":"rev-nbn-au-000011","assetId":"BAUL BL39","latitude":-33.781804,"longitude":150.983103},{"deviceID":"rev-nbn-au-000012","assetId":"BAUL BL40","latitude":-33.774788,"longitude":150.987477},{"deviceID":"rev-nbn-au-000013","assetId":"SHAL SY78","latitude":-33.73103,"longitude":150.808421},{"deviceID":"rev-nbn-au-000014","assetId":"PYMB PE22","latitude":-33.739792,"longitude":151.152416},{"deviceID":"rev-nbn-au-000015","assetId":"CAST CL33","latitude":-33.735826,"longitude":150.997249},{"deviceID":"rev-nbn-au-000016","assetId":"CAST CL33","latitude":-33.738965,"longitude":151.00704},{"deviceID":"rev-nbn-au-000017","assetId":"CAST CL33","latitude":-33.737414,"longitude":151.001397},{"deviceID":"rev-nbn-au-000018","assetId":"SHAL SY78","latitude":-33.729741,"longitude":150.804836},{"deviceID":"rev-nbn-au-000019","assetId":"PENN PH17","latitude":-33.732078,"longitude":151.069755},{"deviceID":"rev-nbn-au-000020","assetId":"CARL CI27","latitude":-33.775272,"longitude":151.024911},{"deviceID":"rev-nbn-au-000021","assetId":"CARR CR76","latitude":-33.900595,"longitude":150.990644},{"deviceID":"rev-nbn-au-000022","assetId":"PENN PH16","latitude":-33.725,"longitude":151.075383},{"deviceID":"rev-nbn-au-000023","assetId":"PYMB PE21","latitude":-33.73893,"longitude":151.163877},{"deviceID":"rev-nbn-au-000024","assetId":"PENN PH16","latitude":-33.728311,"longitude":151.080345},{"deviceID":"rev-nbn-au-000025","assetId":"BAUL BL40","latitude":-33.772494,"longitude":150.993099},{"deviceID":"rev-nbn-au-000026","assetId":"BAUL BL39","latitude":-33.781993,"longitude":150.987418},{"deviceID":"rev-nbn-au-000027","assetId":"EPPI EG13","latitude":-33.771708,"longitude":151.078024},{"deviceID":"rev-nbn-au-000028","assetId":"EPPI EG13","latitude":-33.77188,"longitude":151.077128},{"deviceID":"rev-nbn-au-000029","assetId":"PENN PH13","latitude":-33.726663,"longitude":151.084995},{"deviceID":"rev-nbn-au-000030","assetId":"BOXL BX18","latitude":-37.825632,"longitude":145.130379},{"deviceID":"rev-nbn-au-000031","assetId":"HTLL HWGI","latitude":-37.850901,"longitude":145.06689},{"deviceID":"rev-nbn-au-000032","assetId":"HTLL HWGI","latitude":-37.850908,"longitude":145.059017},{"deviceID":"rev-nbn-au-000033","assetId":"BOXL BX23","latitude":-37.835426,"longitude":145.139474},{"deviceID":"rev-nbn-au-000034","assetId":"HTLL HWTR","latitude":-37.84744,"longitude":145.05427},{"deviceID":"rev-nbn-au-000035","assetId":"RWOD RG05","latitude":-37.8061,"longitude":145.243232},{"deviceID":"rev-nbn-au-000036","assetId":"HTLL HWGI","latitude":-37.850908,"longitude":145.059017},{"deviceID":"rev-nbn-au-000037","assetId":"BOXL BX08","latitude":-37.805003,"longitude":145.121925},{"deviceID":"rev-nbn-au-000038","assetId":"BOXL BX15","latitude":-37.8189,"longitude":145.11603},{"deviceID":"rev-nbn-au-000039","assetId":"BOXL BX12","latitude":-37.814832,"longitude":145.108516},{"deviceID":"rev-nbn-au-000040","assetId":"BOXL BX12","latitude":-37.815034,"longitude":145.106805}]

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _awsManager = __webpack_require__(59);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactstrap = __webpack_require__(92);

var _SearchBox = __webpack_require__(93);

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _highlightSidebarOption = __webpack_require__(140);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(30);

var _lodash = __webpack_require__(165);

var _lodash2 = _interopRequireDefault(_lodash);

var _EnhancedTable = __webpack_require__(1922);

var _EnhancedTable2 = _interopRequireDefault(_EnhancedTable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DataExtract = function (_Component) {
  _inherits(DataExtract, _Component);

  function DataExtract(props) {
    _classCallCheck(this, DataExtract);

    var _this = _possibleConstructorReturn(this, (DataExtract.__proto__ || Object.getPrototypeOf(DataExtract)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(DataExtract, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // extractDataForPdf(this.props.deviceId)
      //   .then((data) => {
      //     this.props.updateExtractData({ data, pageNumber: this.props.dataExtract.pageNumber });
      //   })
      //   .catch((error) => {
      //     console.log('error: ', error);
      //   })
      this.currentPath = this.props.location.pathname;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.unlisten = this.props.history.listen(function (location) {
        _this2.currentPath = location.pathname;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement("div", { className: "row configuration-page" }, _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "jr-card d-sm-flex justify-content-sm-between align-items-sm-center" }, _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-10" }, _react2.default.createElement("h1", { className: "mb-0" }, "Download Data")), _react2.default.createElement("div", { className: "col-12 col-sm-6 col-lg-2" }))), _react2.default.createElement("div", { className: "col-12" }, _react2.default.createElement("div", { className: "row", id: 'print' }, _react2.default.createElement(_EnhancedTable2.default, { updateDeviceId: function updateDeviceId(deviceId) {
          _this3.props.updateDeviceId(deviceId);
          if (!(_this3.currentPath === "/app/components/heartbeat" || _this3.currentPath === "/app/components/notifications")) {
            (0, _highlightSidebarOption.highlightNavigatedMenu)("heartbeat", "#" + _this3.currentPath);
            _this3.props.history.push("/app/components/heartbeat");
          }
        } }))));
    }
  }]);

  return DataExtract;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var symbioticReducer = _ref.symbioticReducer;

  return {
    deviceId: symbioticReducer.deviceId,
    dataExtract: symbioticReducer.dataExtract
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateDeviceId: function updateDeviceId(id) {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateExtractData: function updateExtractData(data) {
      dispatch({ type: "EXTRACT_DATA", dataExtract: data });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DataExtract);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DataExtract, "DataExtract", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_SearchBox2, "_SearchBox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_moment2, "_moment2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_lodash2, "_lodash2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_EnhancedTable2, "_EnhancedTable2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(DataExtract, "DataExtract", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/index.js");
}();

;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _reactRedux = __webpack_require__(30);

var _TableFooter = __webpack_require__(261);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _Table = __webpack_require__(269);

var _Table2 = _interopRequireDefault(_Table);

var _TableBody = __webpack_require__(270);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableCell = __webpack_require__(200);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableContainer = __webpack_require__(271);

var _TableContainer2 = _interopRequireDefault(_TableContainer);

var _TableHead = __webpack_require__(272);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TablePagination = __webpack_require__(275);

var _TablePagination2 = _interopRequireDefault(_TablePagination);

var _TableRow = __webpack_require__(278);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableSortLabel = __webpack_require__(273);

var _TableSortLabel2 = _interopRequireDefault(_TableSortLabel);

var _Toolbar = __webpack_require__(137);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _Checkbox = __webpack_require__(168);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _util = __webpack_require__(77);

var _Tooltip = __webpack_require__(167);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Delete = __webpack_require__(279);

var _Delete2 = _interopRequireDefault(_Delete);

var _FilterList = __webpack_require__(280);

var _FilterList2 = _interopRequireDefault(_FilterList);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return { id: counter, name: name, calories: calories, fat: fat, carbs: carbs, protein: protein };
}

var columnData = [{ id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID' }, { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator' }, { id: 'time', numeric: false, disablePadding: false, label: 'Last Seen' }, { id: 'current1', numeric: false, disablePadding: true, label: 'Current 1' }, { id: 'current2', numeric: false, disablePadding: false, label: 'Current 2' }, { id: 'temperature1', numeric: false, disablePadding: false, label: 'Temperature 1' }, { id: 'temperature2', numeric: false, disablePadding: false, label: 'Temperature 2' }, { id: 'temperature3', numeric: false, disablePadding: false, label: 'Temperature 3' }, { id: 'water', numeric: false, disablePadding: false, label: 'Water' }, { id: 'lid', numeric: false, disablePadding: false, label: 'Lid' }];

var EnhancedTableHead = function (_React$Component) {
    _inherits(EnhancedTableHead, _React$Component);

    function EnhancedTableHead() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, EnhancedTableHead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnhancedTableHead.__proto__ || Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref, [this].concat(args))), _this), _this.createSortHandler = function (property) {
            return function (event) {
                _this.props.onRequestSort(event, property);
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnhancedTableHead, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                onSelectAllClick = _props.onSelectAllClick,
                order = _props.order,
                orderBy = _props.orderBy,
                numSelected = _props.numSelected,
                rowCount = _props.rowCount;

            return _react2.default.createElement(_TableHead2.default, null, _react2.default.createElement(_TableRow2.default, null, columnData.map(function (column) {
                return _react2.default.createElement(_TableCell2.default, {
                    style: {
                        background: '#E2E3E5'
                    },
                    className: column.id !== 'deviceId' && "text-center",
                    key: column.id,
                    numeric: column.numeric,
                    padding: column.disablePadding ? 'none' : 'default'
                }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Sort',
                    placement: column.numeric ? 'bottom-end' : 'bottom-start',
                    enterDelay: 300
                }, _react2.default.createElement(_TableSortLabel2.default, {
                    active: orderBy === column.id,
                    direction: order,
                    onClick: _this2.createSortHandler(column.id)
                }, column.label)));
            }, this)));
        }
    }]);

    return EnhancedTableHead;
}(_react2.default.Component);

// let EnhancedTableToolbar = props => {
//     const { numSelected } = props;

//     return (
//         <Toolbar
//             className={classNames("table-header", {
//                 ["highlight-light"]: numSelected > 0,
//             })}
//         >
//             <div className="title">
//                 {numSelected > 0 ? (
//                     <Typography type="subheading">{numSelected} selected</Typography>
//                 ) : (
//                         <Typography type="title">Nutrition</Typography>
//                     )}
//             </div>
//             <div className="spacer" />
//             <div className="actions">
//                 {numSelected > 0 ? (
//                     <Tooltip title="Delete">
//                         <IconButton aria-label="Delete">
//                             <DeleteIcon />
//                         </IconButton>
//                     </Tooltip>
//                 ) : (
//                         <Tooltip title="Filter list">
//                             <IconButton aria-label="Filter list">
//                                 <FilterListIcon />
//                             </IconButton>
//                         </Tooltip>
//                     )}
//             </div>
//         </Toolbar>
//     );
// };

// EnhancedTableToolbar.propTypes = {
//     numSelected: PropTypes.number.isRequired,
// };


EnhancedTableHead.propTypes = {
    numSelected: _propTypes2.default.number.isRequired,
    onRequestSort: _propTypes2.default.func.isRequired,
    onSelectAllClick: _propTypes2.default.func.isRequired,
    order: _propTypes2.default.string.isRequired,
    orderBy: _propTypes2.default.string.isRequired,
    rowCount: _propTypes2.default.number.isRequired
};

var EnhancedTable = function (_React$Component2) {
    _inherits(EnhancedTable, _React$Component2);

    function EnhancedTable(props, context) {
        _classCallCheck(this, EnhancedTable);

        var _this3 = _possibleConstructorReturn(this, (EnhancedTable.__proto__ || Object.getPrototypeOf(EnhancedTable)).call(this, props, context));

        _this3.handleRequestSort = function (event, property) {
            var orderBy = property;
            var order = 'desc';
            if (_this3.state.orderBy === property && _this3.state.order === 'desc') {
                order = 'asc';
            }
            var data = [];
            if (orderBy === 'nodeId' || orderBy === 'status') {
                data = order === 'desc' ? _this3.state.data.sort(function (a, b) {
                    return b[orderBy] < a[orderBy] ? -1 : 1;
                }) : _this3.state.data.sort(function (a, b) {
                    return a[orderBy] < b[orderBy] ? -1 : 1;
                });
            } else {
                data = order === 'desc' ? _this3.state.data.sort(function (a, b) {
                    return (b.data && b.data.sensors && b.data.sensors[orderBy] !== undefined && b.data.sensors[orderBy]) < (a.data && a.data.sensors && a.data.sensors[orderBy] !== undefined && a.data.sensors[orderBy]) ? -1 : 1;
                }) : _this3.state.data.sort(function (a, b) {
                    return (a.data && a.data.sensors && a.data.sensors[orderBy] !== undefined && a.data.sensors[orderBy]) < (b.data && b.data.sensors && b.data.sensors[orderBy] !== undefined && b.data.sensors[orderBy]) ? -1 : 1;
                });
            }
            _this3.setState({ data: data, order: order, orderBy: orderBy });
        };

        _this3.handleSelectAllClick = function (event, checked) {
            if (checked) {
                _this3.setState({ selected: _this3.state.data.map(function (n) {
                        return n.id;
                    }) });
                return;
            }
            _this3.setState({ selected: [] });
        };

        _this3.handleKeyDown = function (event, id) {
            if ((0, _keycode2.default)(event) === 'space') {
                _this3.handleClick(event, id);
            }
        };

        _this3.handleClick = function (event, deviceId) {
            _this3.props.updateDeviceId(deviceId);
            // const { selected } = this.state;
            // const selectedIndex = selected.indexOf(id);
            // let newSelected = [];

            // if (selectedIndex === -1) {
            //     newSelected = newSelected.concat(selected, id);
            // } else if (selectedIndex === 0) {
            //     newSelected = newSelected.concat(selected.slice(1));
            // } else if (selectedIndex === selected.length - 1) {
            //     newSelected = newSelected.concat(selected.slice(0, -1));
            // } else if (selectedIndex > 0) {
            //     newSelected = newSelected.concat(
            //         selected.slice(0, selectedIndex),
            //         selected.slice(selectedIndex + 1),
            //     );
            // }

            // this.setState({ selected: newSelected });
        };

        _this3.handleChangePage = function (event, page) {
            // this.setState({ page });
            _this3.props.updateExtractData({
                data: _this3.state.data,
                pageNumber: page
            });
        };

        _this3.handleChangeRowsPerPage = function (event) {
            _this3.setState({ rowsPerPage: event.target.value });
        };

        _this3.isSelected = function (id) {
            return _this3.state.selected.indexOf(id) !== -1;
        };

        _this3.checkWaterLevel = function (threshold, water) {
            var waterLevel = threshold.data && threshold.data.thresholds && threshold.data.thresholds.water;
            if (water < (waterLevel && waterLevel.min) || water > (waterLevel && waterLevel.max)) {
                return true;
            }
            return false;
        };

        _this3.checkTemperatureThreshold = function (threshold, temperature) {
            var temperatureThreshold = threshold.data && threshold.data.thresholds && threshold.data.thresholds.temperature;
            if (temperature < (temperatureThreshold && temperatureThreshold.min) || temperature > (temperatureThreshold && temperatureThreshold.max)) {
                return true;
            }
            return false;
        };

        _this3.checkCurrentThreshold = function (threshold, current) {
            if (current < threshold && threshold.min || current > threshold && threshold.max) {
                return true;
            }
            return false;
        };

        _this3.getdeviceOnline = function (status) {
            if (status === "ACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/online.png',
                    alt: 'Online',
                    style: {
                        borderRadius: 15
                    }
                });
            } else if (status === "INACTIVE") {
                return _react2.default.createElement('img', {
                    className: 'statusImage d-inline-block mx-2 pl-0',
                    src: '../../../../assets/images/redIc.png',
                    alt: 'Offline',
                    style: {
                        borderRadius: 15
                    }
                });
            }
            return _react2.default.createElement('img', {
                className: 'statusImage d-inline-block mx-2 pl-0',
                src: '../../../../assets/images/offline.png',
                alt: 'Offline',
                style: {
                    borderRadius: 15
                }
            });
        };

        _this3.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: props.dataExtract.data,
            page: props.dataExtract.pageNumber,
            rowsPerPage: 25
        };
        return _this3;
    }

    _createClass(EnhancedTable, [{
        key: 'setData',
        value: function setData(dataExtract) {
            console.log('dataExtract: ', dataExtract);
            this.setState({
                data: dataExtract.data,
                page: dataExtract.pageNumber
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setData(nextProps.dataExtract);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                data = _state.data,
                order = _state.order,
                orderBy = _state.orderBy,
                selected = _state.selected,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page;

            return _react2.default.createElement('div', { className: 'w-100 px-2 device-catalogue' }, _react2.default.createElement('div', { className: 'flex-auto',
                style: {
                    background: 'white'
                } }, _react2.default.createElement(_TableContainer2.default, { className: 'table-responsive-material',
                style: {
                    maxHeight: window.innerHeight - 240
                }
            }, _react2.default.createElement(_Table2.default, { stickyHeader: true }, _react2.default.createElement(EnhancedTableHead, {
                numSelected: selected.length,
                order: order,
                orderBy: orderBy,
                onSelectAllClick: this.handleSelectAllClick,
                onRequestSort: this.handleRequestSort,
                rowCount: data.length
            }), _react2.default.createElement(_TableBody2.default, null, data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (n) {
                var isSelected = _this4.isSelected(n.id);
                var status = n && n.status;
                var temperature1 = n.data && n.data.sensors && n.data.sensors.temperature1;
                var temperature2 = n.data && n.data.sensors && n.data.sensors.temperature2;
                var temperature3 = n.data && n.data.sensors && n.data.sensors.temperature3;
                var current1 = n.data && n.data.sensors && n.data.sensors.current1;
                var current2 = n.data && n.data.sensors && n.data.sensors.current2;
                var water = n.data && n.data.sensors && n.data.sensors.water;
                var lid = n.data && n.data.notification && n.data.notification.eventVal;
                var currentThreshold1 = n.data && n.data.thresholds && n.data.thresholds.current1;
                var currentThreshold2 = n.data && n.data.thresholds && n.data.thresholds.current2;
                return _react2.default.createElement(_TableRow2.default, {
                    hover: true
                    // onClick={event => this.handleClick(event, n.nodeId)}
                    // onKeyDown={event => this.handleKeyDown(event, n.nodeId)}
                    , role: 'checkbox',
                    'aria-checked': isSelected,
                    tabIndex: -1,
                    key: n.id,
                    selected: isSelected
                }, _react2.default.createElement(_TableCell2.default, { padding: 'none',
                    onClick: function onClick(event) {
                        return _this4.handleClick(event, n.nodeId);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return _this4.handleKeyDown(event, n.nodeId);
                    },
                    id: 'deviceId'
                }, n.nodeId), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, _react2.default.createElement(_Tooltip2.default, {
                    title: 'Status: ' + (status === "UNKNOWN" ? "NEVER ACTIVE" : status),
                    placement: 'bottom-end'
                }, _this4.getdeviceOnline(status))), _react2.default.createElement(_TableCell2.default, { className: 'text-center' }, n.data && n.data.sensors && (0, _util.getFormattedDate)(n.data.sensors.time)), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkCurrentThreshold(currentThreshold1, current1) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkCurrentThreshold(currentThreshold1, current1) && 'red'
                    }
                }, current1), _react2.default.createElement(_TableCell2.default, { className: 'text-center',
                    style: {
                        border: _this4.checkCurrentThreshold(currentThreshold2, current2) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkCurrentThreshold(currentThreshold2, current2) && 'red'
                    }
                }, current2), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkTemperatureThreshold(n, temperature1) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkTemperatureThreshold(n, temperature1) && 'red'
                    } }, temperature1), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkTemperatureThreshold(n, temperature2) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkTemperatureThreshold(n, temperature2) && 'red'
                    } }, temperature2), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkTemperatureThreshold(n, temperature2) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkTemperatureThreshold(n, temperature3) && 'red'
                    } }, temperature3), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: _this4.checkWaterLevel(n, water) && '1px solid rgb(226, 227, 229)',
                        background: _this4.checkWaterLevel(n, water) && 'red'
                    } }, water), _react2.default.createElement(_TableCell2.default, {
                    className: 'text-center',
                    style: {
                        border: lid === 'Open' && '1px solid rgb(226, 227, 229)',
                        background: lid === 'Open' && 'red'
                    } }, lid));
            })))), _react2.default.createElement(_TablePagination2.default, {
                style: {
                    width: window.innerWidth
                },
                count: data.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onChangePage: this.handleChangePage,
                onChangeRowsPerPage: this.handleChangeRowsPerPage
            })));
        }
    }]);

    return EnhancedTable;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var symbioticReducer = _ref2.symbioticReducer;

    return {
        deviceId: symbioticReducer.deviceId,
        dataExtract: symbioticReducer.dataExtract
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateDeviceId: function updateDeviceId(id) {
            dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
        },
        updateExtractData: function updateExtractData(data) {
            dispatch({ type: "EXTRACT_DATA", dataExtract: data });
        }
    };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnhancedTable);

exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(createData, 'createData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(counter, 'counter', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(columnData, 'columnData', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTableHead, 'EnhancedTableHead', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(EnhancedTable, 'EnhancedTable', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js');
}();

;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classnames2, "_classnames2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_propTypes2, "_propTypes2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_keycode2, "_keycode2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableFooter2, "_TableFooter2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Table2, "_Table2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableBody2, "_TableBody2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableCell2, "_TableCell2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableContainer2, "_TableContainer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableHead2, "_TableHead2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TablePagination2, "_TablePagination2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableRow2, "_TableRow2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_TableSortLabel2, "_TableSortLabel2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Toolbar2, "_Toolbar2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Typography2, "_Typography2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Checkbox2, "_Checkbox2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Tooltip2, "_Tooltip2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_Delete2, "_Delete2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_FilterList2, "_FilterList2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(counter, "counter", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(createData, "createData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(columnData, "columnData", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTableHead, "EnhancedTableHead", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(EnhancedTable, "EnhancedTable", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");

    __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/dataExtract/EnhancedTable.js");
}();

;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fusionChartManager = __webpack_require__(374);

var _reactRedux = __webpack_require__(30);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Metrics = function (_React$Component) {
    _inherits(Metrics, _React$Component);

    function Metrics(props) {
        _classCallCheck(this, Metrics);

        var _this = _possibleConstructorReturn(this, (Metrics.__proto__ || Object.getPrototypeOf(Metrics)).call(this, props));

        _this.leadIndicatorsId = "leadIndicators";
        _this.csatId = "csat";
        _this.networkEngineeringId = "networkEngineering";
        _this.networkEngineeringInId = "networkEngineering-in";
        _this.networkEngineeringOutId = "networkEngineering-out";
        _this.networkEngineeringAgedId = "networkEngineering-aged";
        _this.networkEngineeringMttrId = "networkEngineering-mttr";
        _this.networkEngineeringRftId = "networkEngineering-rft";
        _this.networkEngineeringSlaId = "networkEngineering-sla";
        _this.customerConnectionsId = "customerConnections";
        _this.customerConnectionsInId = "customerConnections-in";
        _this.customerConnectionsOutId = "customerConnections-out";
        _this.customerConnectionsAgedId = "customerConnections-aged";
        _this.customerConnectionsMttrId = "customerConnections-mttr";
        _this.customerConnectionsRftId = "customerConnections-rft";
        _this.customerConnectionsSlaId = "customerConnections-sla";
        _this.serviceAssuranceId = "serviceAssurance";
        _this.serviceAssuranceInId = "serviceAssurance-in";
        _this.serviceAssuranceOutId = "serviceAssurance-out";
        _this.serviceAssuranceAgedId = "serviceAssurance-aged";
        _this.serviceAssuranceMttrId = "serviceAssurance-mttr";
        _this.serviceAssuranceRftId = "serviceAssurance-rft";
        _this.serviceAssuranceSlaId = "serviceAssurance-sla";
        _this.networkOpsAssuranceId = "networkOpsAssurance";
        _this.networkOpsAssuranceInId = "networkOpsAssurance-in";
        _this.networkOpsAssuranceOutId = "networkOpsAssurance-out";
        _this.networkOpsAssuranceAgedId = "networkOpsAssurance-aged";
        _this.networkOpsAssuranceMttrId = "networkOpsAssurance-mttr";
        _this.networkOpsAssuranceRftId = "networkOpsAssurance-rft";
        _this.networkOpsAssuranceSlaId = "networkOpsAssurance-sla";

        _this.dispatchActionToHideLoader = function () {

            if (!_this.state.partialLoaderStateLeadIndicators && !_this.state.partialLoaderStateCustomerSatisfaction && !_this.state.partialLoaderStateNetworkEngineering && !_this.state.partialLoaderStateCustomerConnections && !_this.state.partialLoaderStateServiceAssurance && !_this.state.partialLoaderStateNetworkOpsAndAssurance && !_this.state.partialLoaderStateReadyForServiceIn && !_this.state.partialLoaderStateReadyForServiceOut && !_this.state.partialLoaderStateReadyForServiceAged && !_this.state.partialLoaderStateReadyForServiceInMTTR && !_this.state.partialLoaderStateReadyForServiceInRFT && !_this.state.partialLoaderStateReadyForServiceInSLA && !_this.state.partialLoaderStateNetPremisesActivatedIn && !_this.state.partialLoaderStateNetPremisesActivatedOut && !_this.state.partialLoaderStateNetPremisesActivatedAged && !_this.state.partialLoaderStateNetPremisesActivatedInMTTR && !_this.state.partialLoaderStateNetPremisesActivatedInRFT && !_this.state.partialLoaderStateNetPremisesActivatedInSLA && !_this.state.partialLoaderStateServiceIncidentsIn && !_this.state.partialLoaderStateServiceIncidentsOut && !_this.state.partialLoaderStateServiceIncidentsAged && !_this.state.partialLoaderStateServiceIncidentsInMTTR && !_this.state.partialLoaderStateServiceIncidentsInRFT && !_this.state.partialLoaderStateServiceIncidentsInSLA && !_this.state.partialLoaderStateNetworkFaultsIn && !_this.state.partialLoaderStateNetworkFaultsOut && !_this.state.partialLoaderStateNetworkFaultsAged && !_this.state.partialLoaderStateNetworkFaultsInMTTR && !_this.state.partialLoaderStateNetworkFaultsInRFT && !_this.state.partialLoaderStateNetworkFaultsInSLA) {
                _this.props.hideLoader();
            }
        };

        _this.props.showLoader();

        _this.state = {

            // Setting initial value of partial loader state for each of the charts
            // present on the page
            partialLoaderStateLeadIndicators: true,
            partialLoaderStateCustomerSatisfaction: true,
            partialLoaderStateNetworkEngineering: true,
            partialLoaderStateCustomerConnections: true,
            partialLoaderStateServiceAssurance: true,
            partialLoaderStateNetworkOpsAndAssurance: true,

            partialLoaderStateReadyForServiceIn: true,
            partialLoaderStateReadyForServiceOut: true,
            partialLoaderStateReadyForServiceAged: true,
            partialLoaderStateReadyForServiceInMTTR: true,
            partialLoaderStateReadyForServiceInRFT: true,
            partialLoaderStateReadyForServiceInSLA: true,

            partialLoaderStateNetPremisesActivatedIn: true,
            partialLoaderStateNetPremisesActivatedOut: true,
            partialLoaderStateNetPremisesActivatedAged: true,
            partialLoaderStateNetPremisesActivatedInMTTR: true,
            partialLoaderStateNetPremisesActivatedInRFT: true,
            partialLoaderStateNetPremisesActivatedInSLA: true,

            partialLoaderStateServiceIncidentsIn: true,
            partialLoaderStateServiceIncidentsOut: true,
            partialLoaderStateServiceIncidentsAged: true,
            partialLoaderStateServiceIncidentsInMTTR: true,
            partialLoaderStateServiceIncidentsInRFT: true,
            partialLoaderStateServiceIncidentsInSLA: true,

            partialLoaderStateNetworkFaultsIn: true,
            partialLoaderStateNetworkFaultsOut: true,
            partialLoaderStateNetworkFaultsAged: true,
            partialLoaderStateNetworkFaultsInMTTR: true,
            partialLoaderStateNetworkFaultsInRFT: true,
            partialLoaderStateNetworkFaultsInSLA: true
        };
        return _this;
    }

    _createClass(Metrics, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            var self = this;
            var leadIndicatorsCategories = [{
                category: [{
                    label: 'OTD Performance'
                }, {
                    label: 'Right First Time'
                }, {
                    label: 'Cost per Premise'
                }, {
                    label: 'Forecast Accuracy'
                }, {
                    label: 'Service Incidents'
                }, {
                    label: 'Network Availability'
                }, {
                    label: 'Truck Roll Cost Rate'
                }]
            }];

            var leadIndicatorsDataset = [{
                seriesName: 'This Week',
                color: '#4fb1ec',
                data: [{
                    value: '17'
                }, {
                    value: '130'
                }, {
                    value: '104'
                }, {
                    value: '84'
                }, {
                    value: '14'
                }, {
                    value: '96'
                }, {
                    value: '87'
                }]
            }, {
                seriesName: 'Last Week',
                parentYAxis: 'S',
                renderAs: 'line',
                showValues: '0',
                color: '#92d050',
                data: [{
                    value: '17'
                }, {
                    value: '130'
                }, {
                    value: '104'
                }, {
                    value: '84'
                }, {
                    value: '14'
                }, {
                    value: '96'
                }, {
                    value: '87'
                }]
            }];

            var csatCategories = [{
                category: [{
                    label: ''
                }, {
                    label: '11 Dec'
                }, {
                    label: '12 Dec'
                }, {
                    label: ''
                }, {
                    label: '13 Dec'
                }, {
                    label: '14 Dec'
                }, {
                    label: '15 Dec'
                }]
            }];

            var csatDataset = [{
                seriesName: 'This Week',
                color: '#4fb1ec',
                data: [{
                    value: '17'
                }, {
                    value: '130'
                }, {
                    value: '104'
                }, {
                    value: '84'
                }, {
                    value: '14'
                }, {
                    value: '96'
                }, {
                    value: '87'
                }]
            }, {
                seriesName: 'Last Week',
                color: '#92d050',
                data: [{
                    value: '84'
                }, {
                    value: '20'
                }, {
                    value: '104'
                }, {
                    value: '54'
                }, {
                    value: '84'
                }, {
                    value: '73'
                }, {
                    value: '25'
                }]
            }];

            (0, _fusionChartManager.dualYCombination)('leadIndicators', leadIndicatorsCategories, leadIndicatorsDataset).then(function (data) {
                self.setState({
                    partialLoaderStateLeadIndicators: false
                });
            }, function () {});

            (0, _fusionChartManager.dualLineCombination)('csat', csatCategories, csatDataset).then(function (data) {
                self.setState({
                    partialLoaderStateCustomerSatisfaction: false
                });
            });

            var widthOfNetworkEngineering = $('#networkEngineering').width();

            // Col - 1 : Network engineering
            (0, _fusionChartManager.doughnutFusionChartManager)('networkEngineering', '', [{
                label: 'Device',
                value: '15'
            }, {
                label: 'No Device',
                value: '85'
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0'
            }], 'Ready for Service', widthOfNetworkEngineering / 2).then(function (data) {
                self.setState({
                    partialLoaderStateNetworkEngineering: false
                });
            });

            (0, _fusionChartManager.horizontalLed2)('networkEngineering-in', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateReadyForServiceIn: false
                });
            });
            (0, _fusionChartManager.horizontalLed2)('networkEngineering-out', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateReadyForServiceOut: false
                });
            });
            (0, _fusionChartManager.horizontalLed2)('networkEngineering-aged', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateReadyForServiceAged: false
                });
            }); // AGED

            (0, _fusionChartManager.horizontalLed2)('networkEngineering-mttr', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateReadyForServiceInMTTR: false
                });
            }); // MTTR
            (0, _fusionChartManager.horizontalLed2)('networkEngineering-rft', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateReadyForServiceInRFT: false
                });
            }); // RFT
            (0, _fusionChartManager.horizontalLed2)('networkEngineering-sla', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateReadyForServiceInSLA: false
                });
            }); // SLA

            var widthOfCustomerConnections = $('#customerConnections').width();

            // Col - 2 : Customer connections
            (0, _fusionChartManager.doughnutFusionChartManager)('customerConnections', '', [{
                label: 'Device',
                value: '15'
            }, {
                label: 'No Device',
                value: '85'
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0'
            }], 'Net Premises Activated', widthOfCustomerConnections / 2).then(function (data) {
                self.setState({
                    partialLoaderStateCustomerConnections: false
                });
            });

            (0, _fusionChartManager.horizontalLed2)('customerConnections-in', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateNetPremisesActivatedIn: false
                });
            }); // IN
            (0, _fusionChartManager.horizontalLed2)('customerConnections-out', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateNetPremisesActivatedOut: false
                });
            }); // OUT
            (0, _fusionChartManager.horizontalLed2)('customerConnections-aged', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateNetPremisesActivatedAged: false
                });
            }); // AGED

            (0, _fusionChartManager.horizontalLed2)('customerConnections-mttr', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateNetPremisesActivatedInMTTR: false
                });
            }); // MTTR
            (0, _fusionChartManager.horizontalLed2)('customerConnections-rft', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateNetPremisesActivatedInRFT: false
                });
            }); // RFT
            (0, _fusionChartManager.horizontalLed2)('customerConnections-sla', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateNetPremisesActivatedInSLA: false
                });
            }); // SLA

            var widthOfServiceAssurance = $('#serviceAssurance').width();

            // Col - 3 : Service Assurance
            (0, _fusionChartManager.doughnutFusionChartManager)('serviceAssurance', '', [{
                label: 'Device',
                value: '15'
            }, {
                label: 'No Device',
                value: '85'
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0'
            }], 'Service Incidents', widthOfServiceAssurance / 2).then(function (data) {
                self.setState({
                    partialLoaderStateServiceAssurance: false
                });
            });

            (0, _fusionChartManager.horizontalLed2)('serviceAssurance-in', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateServiceIncidentsIn: false
                });
            }); // IN
            (0, _fusionChartManager.horizontalLed2)('serviceAssurance-out', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateServiceIncidentsOut: false
                });
            }); // OUT
            (0, _fusionChartManager.horizontalLed2)('serviceAssurance-aged', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateServiceIncidentsAged: false
                });
            }); // AGED

            (0, _fusionChartManager.horizontalLed2)('serviceAssurance-mttr', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateServiceIncidentsInMTTR: false
                });
            }); // MTTR
            (0, _fusionChartManager.horizontalLed2)('serviceAssurance-rft', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateServiceIncidentsInRFT: false
                });
            }); // RFT
            (0, _fusionChartManager.horizontalLed2)('serviceAssurance-sla', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateServiceIncidentsInSLA: false
                });
            }); // SLA

            var widthOfNetworkOpsAssurance = $('#networkOpsAssurance').width();

            // Col - 4 : Network Ops & Assurance
            (0, _fusionChartManager.doughnutFusionChartManager)('networkOpsAssurance', '', [{
                label: 'Device',
                value: '15'
            }, {
                label: 'No Device',
                value: '85'
            }, {
                label: '',
                value: '100',
                showValue: '0',
                alpha: '0'
            }], 'Network Faults', widthOfNetworkOpsAssurance / 2).then(function (data) {
                self.setState({
                    partialLoaderStateNetworkOpsAndAssurance: false
                });
            });

            (0, _fusionChartManager.horizontalLed2)('networkOpsAssurance-in', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateNetworkFaultsIn: false
                });
            }); // IN
            (0, _fusionChartManager.horizontalLed2)('networkOpsAssurance-out', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateNetworkFaultsOut: false
                });
            }); // OUT
            (0, _fusionChartManager.horizontalLed2)('networkOpsAssurance-aged', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateNetworkFaultsAged: false
                });
            }); // AGED

            (0, _fusionChartManager.horizontalLed2)('networkOpsAssurance-mttr', ' ', ' ', ' ', '80').then(function (data) {
                self.setState({
                    partialLoaderStateNetworkFaultsInMTTR: false
                });
            }); // MTTR
            (0, _fusionChartManager.horizontalLed2)('networkOpsAssurance-rft', ' ', ' ', ' ', '54').then(function (data) {
                self.setState({
                    partialLoaderStateNetworkFaultsInRFT: false
                });
            }); // RFT
            (0, _fusionChartManager.horizontalLed2)('networkOpsAssurance-sla', ' ', ' ', ' ', '16').then(function (data) {
                self.setState({
                    partialLoaderStateNetworkFaultsInSLA: false
                });
            }); // SLA
        } // End of componentDidMount function

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            (0, _fusionChartManager.disposeChart)(this.leadIndicatorsId);
            (0, _fusionChartManager.disposeChart)(this.csatId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringInId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringOutId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringAgedId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringMttrId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringRftId);
            (0, _fusionChartManager.disposeChart)(this.networkEngineeringSlaId);

            (0, _fusionChartManager.disposeChart)(this.customerConnectionsId);
            (0, _fusionChartManager.disposeChart)(this.customerConnectionsInId);
            (0, _fusionChartManager.disposeChart)(this.customerConnectionsOutId);
            (0, _fusionChartManager.disposeChart)(this.customerConnectionsAgedId);
            (0, _fusionChartManager.disposeChart)(this.customerConnectionsMttrId);
            (0, _fusionChartManager.disposeChart)(this.customerConnectionsRftId);
            (0, _fusionChartManager.disposeChart)(this.customerConnectionsSlaId);

            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceId);
            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceInId);
            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceOutId);
            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceAgedId);
            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceMttrId);
            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceRftId);
            (0, _fusionChartManager.disposeChart)(this.serviceAssuranceSlaId);

            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceId);
            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceInId);
            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceOutId);
            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceAgedId);
            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceMttrId);
            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceRftId);
            (0, _fusionChartManager.disposeChart)(this.networkOpsAssuranceSlaId);
        }
    }, {
        key: 'render',
        value: function render() {

            this.dispatchActionToHideLoader();

            return _react2.default.createElement('div', { className: 'row', id: 'metrics' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'page-heading d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Metrics'))), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-lg-9' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12 col-sm-6 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Lead Indicators')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.leadIndicatorsId })))), _react2.default.createElement('div', { className: 'col-12 col-sm-6 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Customer Satisfaction (CSAT)')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.csatId }))))), _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-sm-6 col-lg-3' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-3' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Network Engineering')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.networkEngineeringId }), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Volume:'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 float-left label-min-width' }, 'IN'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkEngineeringInId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '2%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'OUT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkEngineeringOutId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '4%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'AGED'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkEngineeringAgedId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '3%'))), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center text-nowrap' }, 'Key Metrics:'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'MTTR'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkEngineeringMttrId }), _react2.default.createElement('div', { className: 'col-1 pt-2 text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: { color: 'red' },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'RFT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkEngineeringRftId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'SLA'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkEngineeringSlaId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '7%')))))), _react2.default.createElement('div', { className: 'col-sm-6 col-lg-3' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-3' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Customer Connections')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.customerConnectionsId }), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Volume:'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'IN'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.customerConnectionsInId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '2%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'OUT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.customerConnectionsOutId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '4%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'AGED'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.customerConnectionsAgedId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '3%'))), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Key Metrics::'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'MTTR'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.customerConnectionsMttrId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'RFT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.customerConnectionsRftId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'SLA'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.customerConnectionsSlaId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '7%')))))), _react2.default.createElement('div', { className: 'col-sm-6 col-lg-3' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-3' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Service Assurance')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.serviceAssuranceId }), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Volume:'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'IN'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.serviceAssuranceInId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '2%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'OUT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.serviceAssuranceOutId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '4%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'AGED'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.serviceAssuranceAgedId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '3%'))), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Key Metrics::'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'MTTR'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.serviceAssuranceMttrId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'RFT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.serviceAssuranceRftId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'SLA'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.serviceAssuranceSlaId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '7%')))))), _react2.default.createElement('div', { className: 'col-sm-6 col-lg-3' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-3' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block ' }, 'Network Ops & Assurance')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { id: this.networkOpsAssuranceId }), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Volume:'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'IN'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkOpsAssuranceInId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '2%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'OUT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkOpsAssuranceOutId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '4%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'AGED'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkOpsAssuranceAgedId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '3%'))), _react2.default.createElement('div', { className: 'd-flex text-heading ma-font' }, _react2.default.createElement('div', { className: 'col-6 text-left align-self-center' }, 'Key Metrics:'), _react2.default.createElement('div', { className: 'col-6 text-center align-self-center text-nowrap' }, 'Trend ', _react2.default.createElement('br', null), '(Last Week):')), _react2.default.createElement('div', { className: 'horizontalBarWrapper p-2 ma-font' }, _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'MTTR'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkOpsAssuranceMttrId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'RFT'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkOpsAssuranceRftId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-up mt-1',
                style: {
                    color: 'red'
                },
                'aria-hidden': 'true'
            }), '1%')), _react2.default.createElement('div', { className: 'col-12 p-0 inline' }, _react2.default.createElement('div', { className: 'col-3 px-0 pt-2 label-min-width' }, 'SLA'), _react2.default.createElement('div', { className: 'col-8 px-1', id: this.networkOpsAssuranceSlaId }), _react2.default.createElement('div', { className: 'col-1 text-right text-nowrap px-0 pt-2' }, _react2.default.createElement('i', {
                className: 'fa fa fa-long-arrow-down mt-1',
                style: {
                    color: 'green'
                },
                'aria-hidden': 'true'
            }), '7%')))))))), _react2.default.createElement('div', { className: 'col-lg-3' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Finance')), _react2.default.createElement('div', { className: 'jr-card-body set-background ' }, _react2.default.createElement('div', { id: 'finance' }), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'finance-section d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, _react2.default.createElement('sup', { className: 'dollar' }, '$'), '67', _react2.default.createElement('sub', {
                className: 'cost-suffix' }, 'm'))), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/finance.png', alt: '' }))), _react2.default.createElement('p', { className: 't-blue' }, 'Capital Expenditure', _react2.default.createElement('br', null), _react2.default.createElement('span', null, '(Last month)')), _react2.default.createElement('div', { className: 'text-options li-font' }, _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, 'Capital Expenditure (YTD)'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, '$ XXXm')), _react2.default.createElement('br', null), _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, 'Capital Expenditure (Budget)'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, '$ XXXm')), _react2.default.createElement('br', null), _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, 'Total Operating Expenses'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, '$ XXXm')))))))), _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12 ' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'HSE')), _react2.default.createElement('div', { className: 'jr-card-body set-background ' }, _react2.default.createElement('div', { id: 'hse' }), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'finance-section d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, '72')), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/hse.png', alt: '' }))), _react2.default.createElement('p', { className: 't-blue' }, 'Total Recordable Injuries', _react2.default.createElement('br', null), _react2.default.createElement('span', null, '(Last month)')), _react2.default.createElement('div', { className: 'text-options li-font' }, _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, 'High Potential Injury Freq. Rate.'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, 'XXX')), _react2.default.createElement('br', null), _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, 'Workforce Headcount'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, 'XXX')))))))), _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'jr-card jr-card-sb' }, _react2.default.createElement('div', { className: 'jr-card-header px-2' }, _react2.default.createElement('h3', { className: 'card-heading d-inline-block' }, 'Security')), _react2.default.createElement('div', { className: 'jr-card-body set-background ' }, _react2.default.createElement('div', { id: 'security' }), _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'finance-section d-inline-flex w-100' }, _react2.default.createElement('div', { className: 'col left-text w-50 float-left px-0' }, _react2.default.createElement('h5', { className: 't-cost' }, '14')), _react2.default.createElement('div', { className: 'col text-right w-50 float-right px-0' }, _react2.default.createElement('img', { src: '../../../../../assets/images/security.png' }))), _react2.default.createElement('p', { className: 't-blue' }, 'Security Breaches', _react2.default.createElement('br', null), _react2.default.createElement('span', null, '(Last month)')), _react2.default.createElement('div', { className: 'text-options li-font' }, _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, '# of High Security Site'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, 'XXX')), _react2.default.createElement('br', null), _react2.default.createElement('ul', { className: 'list-inline' }, _react2.default.createElement('li', { className: 'text-underline left inline' }, 'High Potential Security Risk.'), _react2.default.createElement('li', { className: 'text-underline text-nowrap right inline' }, 'XXX')))))))), _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('button', { className: 'metric-export pt-2 pb-2' }, 'Export Reports')))))));
        }
    }]);

    return Metrics;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        showLoader: function showLoader() {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: function hideLoader() {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        }
    };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Metrics);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(Metrics, 'Metrics', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(Metrics, "Metrics", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/metrics/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fusionChartManager = __webpack_require__(374);

var _reactRedux = __webpack_require__(30);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.predictNetworkId = "predict-network";
        _this.predictHseId = "predict-hse";
        _this.predictCustomerId = "predict-customer";
        _this.predictServiceId = "predict-service";
        _this.predictRepeatId = "predict-repeat";
        _this.predictSecurityId = "predict-security";

        _this.dispatchActionToHideLoader = function () {
            if (!_this.state.partialLoaderStatePredictNetwork && !_this.state.partialLoaderStatePredictHSE && !_this.state.partialLoaderStatePredictCustomer && !_this.state.partialLoaderStatePredictService && !_this.state.partialLoaderStatePredictRepeat && !_this.state.partialLoaderStatePredictSecurity) {
                _this.props.hideLoader();
            }
        };

        _this.componentDidMount = function () {

            var self = _this;

            var categoriesPredictNetwork = [{
                category: [{
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Wed'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }, {
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    vline: 'true',
                    color: '#92d050',
                    thickness: '2'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }]
            }];

            var categoriesPredictHSE = [{
                category: [{
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Wed'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }, {
                    label: 'Mon'
                }, {
                    vline: 'true',
                    color: '#92d050',
                    thickness: '2'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }]
            }];

            var categoriesPredictCustomer = [{
                category: [{
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Wed'
                }, {
                    vline: 'true',
                    color: '#92d050',
                    thickness: '2'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }, {
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }]
            }];

            var categoriesPredictService = [{
                category: [{
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Wed'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }, {
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    vline: 'true',
                    color: '#92d050',
                    thickness: '2'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }]
            }];

            var categoriesPredictRepeat = [{
                category: [{
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Wed'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    vline: 'true',
                    color: '#92d050',
                    thickness: '2'
                }, {
                    label: 'Sun'
                }, {
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }]
            }];

            var categoriesPredictSecurity = [{
                category: [{
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    label: 'Wed'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }, {
                    label: 'Mon'
                }, {
                    label: 'Tue'
                }, {
                    vline: 'true',
                    color: '#92d050',
                    thickness: '2'
                }, {
                    label: 'Thu'
                }, {
                    label: 'Fri'
                }, {
                    label: 'Sat'
                }, {
                    label: 'Sun'
                }]
            }];

            (0, _fusionChartManager.msAreaChartFusionChart)('predict-network', categoriesPredictNetwork, '$dataset.2.set.8.centerx + 15', '$dataset.2.set.9.centerx + 55', '$dataset.2.set.8.centerx - 30', '0.7').then(function () {
                self.setState({
                    partialLoaderStatePredictNetwork: false
                });
            }); // 285
            (0, _fusionChartManager.msAreaChartFusionChart)('predict-hse', categoriesPredictHSE, '$dataset.2.set.7.centerx + 15', '$dataset.2.set.8.endx + 55', '$dataset.2.set.7.centerx -30', '0.6').then(function () {
                self.setState({
                    partialLoaderStatePredictHSE: false
                });
            }); // 257
            (0, _fusionChartManager.msAreaChartFusionChart)('predict-customer', categoriesPredictCustomer, '$dataset.1.set.2.centerx + 15', '$dataset.1.set.3.endx + 55', '$dataset.1.set.2.centerx -30', '0.2').then(function () {
                self.setState({
                    partialLoaderStatePredictCustomer: false
                });
            });
            (0, _fusionChartManager.msAreaChartFusionChart)('predict-service', categoriesPredictService, '$dataset.2.set.10.centerx + 15', '$dataset.2.set.11.endx + 55', '$dataset.2.set.10.centerx -30', '0.9').then(function () {
                self.setState({
                    partialLoaderStatePredictService: false
                });
            });
            (0, _fusionChartManager.msAreaChartFusionChart)('predict-repeat', categoriesPredictRepeat, '$dataset.1.set.5.centerx + 15', '$dataset.1.set.6.endx + 55', '$dataset.1.set.5.centerx -30', '0.5').then(function () {
                self.setState({
                    partialLoaderStatePredictRepeat: false
                });
            });
            (0, _fusionChartManager.msAreaChartFusionChart)('predict-security', categoriesPredictSecurity, '$dataset.2.set.8.centerx + 15', '$dataset.2.set.9.endx + 55', '$dataset.2.set.8.centerx -30', '0.7').then(function () {
                self.setState({
                    partialLoaderStatePredictSecurity: false
                });
            });
        };

        _this.props.showLoader();

        _this.state = {
            isMobileView: false,

            // Setting initial values for partial loader state for all 6 six charts
            partialLoaderStatePredictNetwork: true,
            partialLoaderStatePredictHSE: true,
            partialLoaderStatePredictCustomer: true,
            partialLoaderStatePredictService: true,
            partialLoaderStatePredictRepeat: true,
            partialLoaderStatePredictSecurity: true
        };
        return _this;
    }

    _createClass(App, [{
        key: 'render',
        value: function render() {

            this.dispatchActionToHideLoader();

            return _react2.default.createElement('div', { id: 'machine-learning', className: 'contentOuter-wrapper' }, _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'page-heading d-sm-flex justify-content-sm-between align-items-sm-center' }, _react2.default.createElement('h1', { className: 'mb-0' }, 'Machine Learning'))), _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-6 ' }, _react2.default.createElement('div', { className: 'jr-card ' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h4', null, 'Predict Network Fault or Outage')), _react2.default.createElement('div', { className: 'jr-card-body' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0' }, _react2.default.createElement('div', { id: this.predictNetworkId })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4 px-0' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '91% are correct'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '955 are true positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '20,071 are true negative'), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '9% are errors'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '431 false positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '1,635 false negative')), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, "6% of records predicted as \u201D1\u201D"), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, "94% of records predicted as \u201C0\u201D")), _react2.default.createElement('button', { className: 'btn' }, 'RPA Trigger'))))), _react2.default.createElement('div', { className: 'jr-card ' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h4', null, 'Predict HSE Injury')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0' }, _react2.default.createElement('div', { id: this.predictHseId })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4 px-0' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '91% are correct'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '955 are true positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '20,071 are true negative'), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '9% are errors'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '431 false positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '1,635 false negative')), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, "6% of records predicted as \u201D1\u201D"), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, "94% of records predicted as \u201C0\u201D")), _react2.default.createElement('button', { className: 'btn' }, 'RPA Trigger'))))), _react2.default.createElement('div', { className: 'jr-card ' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h4', null, 'Predict Customer Experience (CSAT) Issue')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0' }, _react2.default.createElement('div', { id: this.predictCustomerId })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4 px-0' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '91% are correct'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '955 are true positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '20,071 are true negative'), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '9% are errors'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '431 false positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '1,635 false negative')), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, "6% of records predicted as \u201D1\u201D"), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, "94% of records predicted as \u201C0\u201D")), _react2.default.createElement('button', { className: 'btn' }, 'RPA Trigger')))))), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-6' }, _react2.default.createElement('div', { className: 'jr-card ' }, _react2.default.createElement('div', { className: 'jr-card-header ' }, _react2.default.createElement('h4', null, 'Predict Service Incident')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'row mx-0 ' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0' }, _react2.default.createElement('div', { id: this.predictServiceId })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4 px-0' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '91% are correct'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '955 are true positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '20,071 are true negative'), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '9% are errors'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '431 false positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '1,635 false negative')), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, "6% of records predicted as \u201D1\u201D"), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, "94% of records predicted as \u201C0\u201D")), _react2.default.createElement('button', { className: 'btn' }, 'RPA Trigger'))))), _react2.default.createElement('div', { className: 'jr-card ' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h4', null, 'Predict Repeat Truck Roll')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0' }, _react2.default.createElement('div', { id: this.predictRepeatId })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4 px-0' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '91% are correct'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '955 are true positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '20,071 are true negative'), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '9% are errors'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '431 false positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '1,635 false negative')), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, "6% of records predicted as \u201D1\u201D"), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, "94% of records predicted as \u201C0\u201D")), _react2.default.createElement('button', { className: 'btn' }, 'RPA Trigger'))))), _react2.default.createElement('div', { className: 'jr-card ' }, _react2.default.createElement('div', { className: 'jr-card-header' }, _react2.default.createElement('h4', null, 'Predict Security Breach')), _react2.default.createElement('div', { className: 'jr-card-body ' }, _react2.default.createElement('div', { className: 'row mx-0' }, _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0' }, _react2.default.createElement('div', { id: this.predictSecurityId })), _react2.default.createElement('div', { className: 'col-12 col-sm-12 col-md-12 col-lg-4 px-0' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '91% are correct'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '955 are true positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '20,071 are true negative'), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'first-line p-0 m-0' }, '9% are errors'), _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, '431 false positive'), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, '1,635 false negative')), _react2.default.createElement('div', { className: 'pt-2' }, _react2.default.createElement('p', { className: 'second-line p-0 m-0' }, "6% of records predicted as \u201D1\u201D"), _react2.default.createElement('p', { className: 'third-line p-0 m-0' }, "94% of records predicted as \u201C0\u201D")), _react2.default.createElement('button', { className: 'btn' }, 'RPA Trigger')))))))));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            (0, _fusionChartManager.disposeChart)(this.predictNetworkId);
            (0, _fusionChartManager.disposeChart)(this.predictHseId);
            (0, _fusionChartManager.disposeChart)(this.predictCustomerId);
            (0, _fusionChartManager.disposeChart)(this.predictServiceId);
            (0, _fusionChartManager.disposeChart)(this.predictRepeatId);
            (0, _fusionChartManager.disposeChart)(this.predictSecurityId);
        }
    }]);

    return App;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        showLoader: function showLoader() {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: function hideLoader() {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        }
    };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(App);

exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(App, 'App', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js');

    __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(App, "App", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");

    __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/machineLearning/index.js");
}();

;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Drawer = __webpack_require__(286);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _reactRedux = __webpack_require__(30);

var _userManager = __webpack_require__(117);

var _reactNotifications = __webpack_require__(78);

var _util = __webpack_require__(77);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _fileManager = __webpack_require__(835);

var _index = __webpack_require__(222);

var _reduxPersist = __webpack_require__(226);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProfileAndSettings = function (_Component) {
  _inherits(ProfileAndSettings, _Component);

  function ProfileAndSettings(props) {
    _classCallCheck(this, ProfileAndSettings);

    var _this = _possibleConstructorReturn(this, (ProfileAndSettings.__proto__ || Object.getPrototypeOf(ProfileAndSettings)).call(this, props));

    _this.updateProfile = function () {
      _this.setState({
        content: 'default'
      });
    };

    _this.nameChange = function (e) {
      _this.setState({
        name: e.target.value
      });
    };

    _this.positionChange = function (e) {
      _this.setState({
        position: e.target.value
      });
    };

    _this.teamChange = function (e) {
      _this.setState({
        team: e.target.value
      });
    };

    _this.oldPasswordChange = function (e) {
      _this.setState({
        oldPassword: e.target.value
      });
    };

    _this.newPasswordChange = function (e) {
      _this.setState({
        newPassword: e.target.value
      });
    };

    _this.confirmPasswordChange = function (e) {
      _this.setState({
        confirmPassword: e.target.value
      });
    };

    _this.onVerificationCodeChange = function (e) {
      _this.setState({
        verificationCode: e.target.value
      });
    };

    _this.onNameSaveClick = function () {
      // this.props.updateUsername(this.state.username);
      _this.setState({
        showNameInput: false
      });
    };

    _this.onPositionSaveClick = function () {
      // this.props.updateUsername(this.state.username);
      _this.setState({
        showPositionInput: false
      });
    };

    _this.onTeamSaveClick = function () {
      // this.props.updateUsername(this.state.username);
      _this.setState({
        showTeamInput: false
      });
    };

    _this.changePasswordWrapper = function () {
      (0, _userManager.changePassword)(_this.state.oldPassword, _this.state.newPassword, _this.props.userData).then(function () {
        (0, _util.createNotification)('Password change successful.', 'Success', 'Success');
        _this.setState({ content: 'default' });
      }, function (error) {
        _reactNotifications.NotificationManager.error(error.message);
      });
    };

    _this.signUserOut = function () {
      (0, _userManager.signOut)().then(function () {
        _this.props.signOut();
        _this.props.setDefaultTheme();

        var body = $('#body');
        body.removeClass();
        body.addClass(_this.props.themeColor);
        (0, _reduxPersist.purgeStoredState)(_index.persistConfig);
      }, function () {
        _this.props.signOut();
        _this.props.setDefaultTheme();

        var body = $('#body');
        body.removeClass();
        body.addClass(_this.props.themeColor);
        (0, _reduxPersist.purgeStoredState)(_index.persistConfig);
      });
    };

    _this.sideNavJSX = function () {
      return _react2.default.createElement('ul', { className: 'profile-side-nav p-3' }, _react2.default.createElement('h1', null, 'Profile'), _react2.default.createElement('li', { onClick: _this.updateProfile }, 'Profile Details'), _react2.default.createElement('li', { onClick: function onClick() {
          _this.setState({ content: 'changePassword' });
        }
      }, 'Change Password'), _react2.default.createElement('li', { onClick: function onClick() {
          _this.setState({ content: 'changeProfileImage' });
        }
      }, 'Change Profile Photo'), _this.state.verifyEmail ? _react2.default.createElement('li', { onClick: function onClick() {
          _this.setState({ content: 'confirmEmail' });
        }
      }, 'Verify Email Address') : '', _react2.default.createElement('li', null, 'Create Teams'), _react2.default.createElement('li', null, 'Create New Report'), _react2.default.createElement('li', null, 'Log an Incident'), _react2.default.createElement('li', null, 'Provide Feedback'), _react2.default.createElement('li', { onClick: _this.signUserOut }, 'SignOut'));
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.onSaveClick();
      }
    };

    _this.updatePassword = function () {
      if (_this.state.newPassword !== _this.state.confirmPassword) {
        (0, _util.createNotification)('Passwords do not match.', 'Error', 'Error');
      } else {
        _this.changePasswordWrapper();
      }
    };

    _this.verifyEmail = function () {
      (0, _userManager.verifyEmailAddress)(_this.state.verificationCode).then(function () {
        (0, _util.createNotification)('Email verified.', 'Success', 'Success');
        // let loginData = this.props.data;
        // loginData.idToken.email_verified = true;
        // this.props.updateVerifyEmailField(loginData);
        _this.setState({ content: 'default' });
      }, function (error) {
        (0, _util.createNotification)(error.message, 'Error', 'Error');
      });
    };

    _this.resendVerification = function () {
      (0, _userManager.resendVerificationCode)().then(function () {
        (0, _util.createNotification)('Verification code resent successful', 'Success', 'Success');
      }, function () {
        (0, _util.createNotification)('There was an error. Please try again', 'Error', 'Error');
      });
    };

    _this.updateAttribute = function (attibuteList) {
      (0, _userManager.updateUserAttributes)(attibuteList).then(function () {
        var data = _this.props.userAttributes;
        if (attibuteList[0].Name === 'nickname') {
          (0, _util.createNotification)('Attribute update successful.', 'Success', 'Success');
          data.nickname = _this.state.name;
          _this.props.profileDetailsUpdate(data);
        }
        if (attibuteList[0].Name === 'custom:position') {
          (0, _util.createNotification)('Attribute update successful.', 'Success', 'Success');
          data['custom:position'] = _this.state.position;
          _this.props.profileDetailsUpdate(data);
        }
        if (attibuteList[0].Name === 'custom:team') {
          (0, _util.createNotification)('Attribute update successful.', 'Success', 'Success');
          data['custom:team'] = _this.state.team;
          _this.props.profileDetailsUpdate(data);
        }
        if (attibuteList[0].Name === 'picture') {
          (0, _util.createNotification)('Image upload successful.', 'Success', 'Success');
          data.picture = _this.imageUrl;
          _this.props.profileDetailsUpdate(data);
          _this.setState({
            imageUrl: _this.imageUrl
          });
        }
      }, function (error) {
        (0, _util.createNotification)(error.message, 'Error', 'Error');
      });
    };

    _this.toggleName = function () {
      _this.setState({
        showNameInput: !_this.state.showNameInput
      });
    };

    _this.togglePosition = function () {
      _this.setState({
        showPositionInput: !_this.state.showPositionInput
      });
    };

    _this.toggleTeam = function () {
      _this.setState({
        showTeamInput: !_this.state.showTeamInput
      });
    };

    _this.profileDetailsUpdate = function () {};

    _this.uploadProfileImage = function () {
      var fileChooser = document.getElementById('file-chooser');
      var imageExtension = fileChooser.files[0].name.split('.').pop().toLowerCase();
      (0, _fileManager.uploadProfileImage)(fileChooser, _this.props.username.toLowerCase() + '.' + imageExtension).then(function () {
        _this.imageUrl = 'http://' + CONST.BUCKET_NAME + '.s3.amazonaws.com/profile/' + _this.props.username.toLowerCase() + '.' + imageExtension;
        _this.updateAttribute([{ Name: 'picture', Value: _this.imageUrl }]);
      }, function (err) {
        (0, _util.createNotification)(err.message, 'Error', 'Error');
      });
    };

    _this.content = function () {
      if (_this.state.content === 'default') {
        return _react2.default.createElement('div', { className: 'col-lg-12' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-lg-3 profile-img image-size' }, _react2.default.createElement('img', { className: 'w-75', src: _this.state.imageUrl, onError: function onError(e) {
            e.target.src = CONST.DEFAULT_PROFILE_IMG;
          } })), _react2.default.createElement('div', { className: 'col-lg-9 profile-detail pt-4' }, _react2.default.createElement('table', { className: 'table' }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Name:'), _react2.default.createElement('td', null, _this.state.showNameInput ? _react2.default.createElement('input', {
          onChange: function onChange(e) {
            _this.nameChange(e);
          },
          value: _this.state.name
        }) : _this.state.name), _react2.default.createElement('td', null, _this.state.showNameInput ? _react2.default.createElement('span', null, _react2.default.createElement('i', {
          className: 'fa fa-check fa-2x text-green mr-2',
          'aria-hidden': 'true',
          onClick: function onClick() {
            _this.updateAttribute([{ Name: 'nickname', Value: _this.state.name }]);
            _this.onNameSaveClick();
          }
        }), _react2.default.createElement('i', { onClick: function onClick() {
            _this.setState({ showNameInput: false });
          }, className: 'fa fa-times fa-2x text-red', 'aria-hidden': 'true' })) : '', _this.state.showNameInput ? '' : _react2.default.createElement('i', { onClick: _this.toggleName, className: 'ml-5 fa fa-edit' }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Username:'), _react2.default.createElement('td', null, _this.state.username), _react2.default.createElement('td', null)), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Position:'), _react2.default.createElement('td', null, _this.state.showPositionInput ? _react2.default.createElement('input', {
          onChange: function onChange(e) {
            _this.positionChange(e);
          },
          value: _this.state.position
        }) : _this.state.position), _react2.default.createElement('td', null, _this.state.showPositionInput ? _react2.default.createElement('span', null, _react2.default.createElement('i', {
          className: 'fa fa-check fa-2x text-green mr-2',
          'aria-hidden': 'true',
          onClick: function onClick() {
            _this.updateAttribute([{
              Name: 'custom:position',
              Value: _this.state.position
            }]);
            _this.onPositionSaveClick();
          }
        }), _react2.default.createElement('i', { onClick: function onClick() {
            _this.setState({ showPositionInput: false });
          }, className: 'fa fa-times fa-2x text-red', 'aria-hidden': 'true' })) : '', _this.state.showPositionInput ? '' : _react2.default.createElement('i', { onClick: _this.togglePosition, className: 'ml-5 fa fa-edit' }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Team:'), _react2.default.createElement('td', null, _this.state.showTeamInput ? _react2.default.createElement('input', {
          onChange: function onChange(e) {
            _this.teamChange(e);
          },
          value: _this.state.team
        }) : _this.state.team), _react2.default.createElement('td', null, _this.state.showTeamInput ? _react2.default.createElement('span', null, _react2.default.createElement('i', {
          className: 'fa fa-check fa-2x text-green mr-2',
          'aria-hidden': 'true',
          onClick: function onClick() {
            _this.updateAttribute([{ Name: 'custom:team', Value: _this.state.team }]);
            _this.onTeamSaveClick();
          }
        }), _react2.default.createElement('i', { onClick: function onClick() {
            _this.setState({ showTeamInput: false });
          }, className: 'fa fa-times fa-2x text-red', 'aria-hidden': 'true' })) : '', _this.state.showTeamInput ? '' : _react2.default.createElement('i', { onClick: _this.toggleTeam, className: 'ml-5 fa fa-edit' }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Mobile Number:'), _react2.default.createElement('td', null, _this.state.phoneNumber), _react2.default.createElement('td', null)), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Email Address:'), _react2.default.createElement('td', null, _this.state.email), _react2.default.createElement('td', null)))))));
      }

      if (_this.state.content === 'changePassword') {
        return _react2.default.createElement('div', { className: 'profile-detail' }, _react2.default.createElement('table', { className: 'table' }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Old Password'), _react2.default.createElement('td', null, _react2.default.createElement('input', {
          type: 'password',
          onChange: function onChange(e) {
            _this.oldPasswordChange(e);
          }
        }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'New password'), _react2.default.createElement('td', null, _react2.default.createElement('input', {
          type: 'password',
          onChange: function onChange(e) {
            _this.newPasswordChange(e);
          }
        }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Confirm password'), _react2.default.createElement('td', null, _react2.default.createElement('input', {
          type: 'password',
          onChange: function onChange(e) {
            _this.confirmPasswordChange(e);
          }
        }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null), _react2.default.createElement('td', null, _react2.default.createElement(_Button2.default, { onClick: _this.updatePassword, variant: 'raised', className: 'jr-btn bg-success text-white' }, 'Update Password'))))));
      }

      if (_this.state.content === 'confirmEmail') {
        return _react2.default.createElement('div', { className: 'profile-detail' }, _react2.default.createElement('table', { className: 'table' }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Enter Verification Code'), _react2.default.createElement('td', null, _react2.default.createElement('input', {
          type: 'password',
          onChange: function onChange(e) {
            _this.onVerificationCodeChange(e);
          }
        }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null), _react2.default.createElement('td', null, _react2.default.createElement(_Button2.default, { onClick: _this.verifyEmail, variant: 'raised', className: 'jr-btn bg-success text-white' }, 'Verify Email'), _react2.default.createElement(_Button2.default, { variant: 'raised', className: 'jr-btn bg-success text-white', onClick: _this.resendVerification }, 'Resend verification code'))))));
      }

      if (_this.state.content === 'changeProfileImage') {
        return _react2.default.createElement('div', { className: 'profile-detail' }, _react2.default.createElement('table', { className: 'table' }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Upload Image'), _react2.default.createElement('td', null, _react2.default.createElement('input', { type: 'file', id: 'file-chooser' }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null), _react2.default.createElement('td', null, _react2.default.createElement(_Button2.default, {
          variant: 'raised',
          className: 'jr-btn bg-success text-white',
          id: 'upload-button',
          onClick: function onClick() {
            _this.uploadProfileImage();
          }
        }, 'Upload'))))));
      }
    };

    _this.render = function () {
      if (window.innerWidth < 992) {
        $('#profileImg').toggleClass('w-75').toggleClass('w-25');
      }

      return _react2.default.createElement('div', { className: 'profile-and-settings' }, _react2.default.createElement('div', { className: 'd-block d-xl-none' }, _react2.default.createElement(_Drawer2.default, {
        type: 'temporary',
        className: 'profile-sidebar',
        open: _this.state.drawerState,
        onClose: _this.onToggleDrawer.bind(_this)
      }, _this.sideNavJSX())), _react2.default.createElement(_IconButton2.default, {
        className: 'd-block d-xl-none',
        'aria-label': 'Menu',
        onClick: _this.onToggleDrawer.bind(_this)
      }, _react2.default.createElement('i', { className: 'zmdi zmdi-menu text-white' })), _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-0 col-xl-block' }, _react2.default.createElement('div', { className: 'd-none d-xl-block' }, _this.sideNavJSX())), _react2.default.createElement('div', { className: 'col-xl-9' }, _this.content())), _react2.default.createElement(_reactNotifications.NotificationContainer, null));
    };

    var defaultImage = _this.props.userAttributes.picture || CONST.DEFAULT_PROFILE_IMG;

    _this.state = {
      drawerState: false,
      username: _this.props.username,
      name: _this.props.userAttributes.nickname,
      showNameInput: false,
      position: _this.props.userAttributes['custom:position'],
      showPositionInput: false,
      team: _this.props.userAttributes['custom:team'],
      showTeamInput: false,
      nameInput: false,
      content: 'default',
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      verifyEmail: !_this.props.data.email_verified,
      verificationCode: null,
      profileImageUrl: null,
      imageUrl: defaultImage,
      phoneNumber: '+61428765435',
      email: 'jalderson@nbnco.com.au'
    };

    _this.oldPasswordChange.bind(_this);
    _this.newPasswordChange.bind(_this);
    _this.confirmPasswordChange.bind(_this);
    _this.updateAttribute.bind(_this);
    _this.positionChange.bind(_this);
    _this.nameChange.bind(_this);
    return _this;
  }

  _createClass(ProfileAndSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ verifyEmail: !this.props.data.email_verified, phoneNumber: this.props.data.phone_number, email: this.props.data.email });
    }
  }, {
    key: 'onToggleDrawer',
    value: function onToggleDrawer() {
      this.setState({
        drawerState: !this.state.drawerState
      });
    }
  }]);

  return ProfileAndSettings;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var profileInfo = _ref.profileInfo;

  return {
    username: profileInfo.username,
    data: profileInfo.data,
    userAttributes: profileInfo.userAttributes,
    userData: profileInfo.data
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateUsername: function updateUsername(username) {
      dispatch({ type: 'UPDATE_USERNAME', username: username });
    },
    signOut: function signOut() {
      dispatch({ type: 'SIGN_OUT' });
    },
    updateVerifyEmailField: function updateVerifyEmailField(data) {
      dispatch({ type: 'UPDATE_EMAIL_VERIFY_FIELD', payload: data });
    },
    profileDetailsUpdate: function profileDetailsUpdate(data) {
      dispatch({ type: 'PROFILE_DETAILS_UPDATE', payload: data });
    },
    setDefaultTheme: function setDefaultTheme() {
      dispatch({ type: 'SET_DEFAULT_THEME' });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProfileAndSettings);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProfileAndSettings, 'ProfileAndSettings', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_Drawer2, "_Drawer2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_IconButton2, "_IconButton2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(ProfileAndSettings, "ProfileAndSettings", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/ProfileAndSettings/ProfileAndSettings.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _SwitchBase = __webpack_require__(414);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },
    bar: {
      borderRadius: 14 / 2,
      display: 'block',
      position: 'absolute',
      width: 34,
      height: 14,
      top: '50%',
      marginTop: -14 / 2,
      left: '50%',
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    },
    icon: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },
    iconChecked: {
      boxShadow: theme.shadows[2]
    },
    // For SwitchBase
    default: {
      zIndex: 1,
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {
      transform: 'translateX(14px)',
      '& + $bar': {
        opacity: 0.5
      }
    },
    checkedPrimary: {
      color: theme.palette.primary.main,
      '& + $bar': {
        backgroundColor: theme.palette.primary.main
      }
    },
    checkedSecondary: {
      color: theme.palette.secondary.main,
      '& + $bar': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    disabled: {
      color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
      '& + $bar': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      },
      '& $icon': {
        boxShadow: theme.shadows[1]
      }
    }
  };
};

function Switch(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color']);

  var icon = _react2.default.createElement('span', { className: classes.icon });
  var checkedIcon = _react2.default.createElement('span', { className: (0, _classnames2.default)(classes.icon, classes.iconChecked) });
  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(classes.root, className) },
    _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
      icon: icon,
      classes: {
        default: classes.default,
        checked: checkedClass,
        disabled: classes.disabled
      },
      checkedIcon: checkedIcon
    }, other)),
    _react2.default.createElement('span', { className: classes.bar })
  );
}

Switch.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Switch.defaultProps = {
  color: 'secondary'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitch' })(Switch);

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSortableHoc = __webpack_require__(424);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react2.default.createElement('i', { className: 'zmdi zmdi-menu fa fa-arrows-alt fa-rotate-45 dragger' });
});

var UpdateLayoutt = function (_React$Component) {
  _inherits(UpdateLayoutt, _React$Component);

  function UpdateLayoutt() {
    _classCallCheck(this, UpdateLayoutt);

    return _possibleConstructorReturn(this, (UpdateLayoutt.__proto__ || Object.getPrototypeOf(UpdateLayoutt)).apply(this, arguments));
  }

  _createClass(UpdateLayoutt, [{
    key: 'render',
    value: function render() {
      var contact = this.props.contact;
      var name = contact.name,
          thumb = contact.thumb;

      return _react2.default.createElement('div', { className: 'col-4 contact-item ripple row no-gutters align-items-center py-2 px-3 py-sm-4 px-sm-6 drag-border' }, _react2.default.createElement('div', { className: 'col-12' }, _react2.default.createElement('div', { className: 'position-absolute cursor-pointer' }, _react2.default.createElement(DragHandle, null)), _react2.default.createElement('div', { className: 'text-center text-white', style: { fontSize: 10 } }, _react2.default.createElement('img', { className: 'size-40', alt: name, src: thumb }), _react2.default.createElement('div', { className: 'font-weight-bold' }, name))));
    }
  }]);

  return UpdateLayoutt;
}(_react2.default.Component);

var _default = (0, _reactSortableHoc.SortableElement)(UpdateLayoutt);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DragHandle, 'DragHandle', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js');

  __REACT_HOT_LOADER__.register(UpdateLayoutt, 'UpdateLayoutt', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(DragHandle, "DragHandle", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(UpdateLayoutt, "UpdateLayoutt", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/LayoutCell/index.js");
}();

;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__(1929);

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (e) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (e.button === 2 || shouldCancelStart(e)) {
          return false;
        }

        _this._touched = true;
        _this._pos = {
          x: e.pageX,
          y: e.pageY
        };

        var node = (0, _utils.closest)(e.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(e);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(e);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (e) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          _this._delta = {
            x: _this._pos.x - e.pageX,
            y: _this._pos.y - e.pageY
          };
          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && delta >= distance && _this.manager.isActive()) {
            _this.handlePress(e);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (e) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = _this.getEdgeOffset(node);
          _this.initialOffset = _this.getOffset(e);
          _this.initialScroll = {
            top: _this.scrollContainer.scrollTop,
            left: _this.scrollContainer.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = e.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
        }
      };

      _this.handleSortMove = function (e) {
        var onSortMove = _this.props.onSortMove;

        e.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(e);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) onSortMove(e);
      };

      _this.handleSortEnd = function (e) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, e);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            getContainer = _props.getContainer,
            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var contentWindow = this.props.contentWindow || window;

        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
        this.document = this.container.ownerDocument || document;
        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

        var _loop = function _loop(key) {
          if (_this2.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          }
        };

        for (var key in this.events) {
          _loop(key);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var _loop2 = function _loop2(key) {
          if (_this3.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this3.container.removeEventListener(eventName, _this3.events[key]);
            });
          }
        };

        for (var key in this.events) {
          _loop2(key);
        }
      }
    }, {
      key: 'getEdgeOffset',
      value: function getEdgeOffset(node) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
        if (node) {
          var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
          };
          if (node.parentNode !== this.container) {
            return this.getEdgeOffset(node.parentNode, nodeOffset);
          } else {
            return nodeOffset;
          }
        }
      }
    }, {
      key: 'getOffset',
      value: function getOffset(e) {
        return {
          x: e.touches ? e.touches[0].pageX : e.pageX,
          y: e.touches ? e.touches[0].pageY : e.pageY
        };
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var lockOffset = this.props.lockOffset;


        if (!Array.isArray(lockOffset)) {
          lockOffset = [lockOffset, lockOffset];
        }

        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _lockOffset = lockOffset,
            _lockOffset2 = _slicedToArray(_lockOffset, 2),
            minLockOffset = _lockOffset2[0],
            maxLockOffset = _lockOffset2[1];

        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
      }
    }, {
      key: 'getLockPixelOffset',
      value: function getLockPixelOffset(lockOffset) {
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';

        if (typeof lockOffset === 'string') {
          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

          offsetX = offsetY = parseFloat(lockOffset);
          unit = match[1];
        }

        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

        if (unit === '%') {
          offsetX = offsetX * this.width / 100;
          offsetY = offsetY * this.height / 100;
        }

        return {
          x: offsetX,
          y: offsetY
        };
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(e) {
        var _props2 = this.props,
            lockAxis = _props2.lockAxis,
            lockToContainerEdges = _props2.lockToContainerEdges;


        var offset = this.getOffset(e);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props3 = this.props,
            transitionDuration = _props3.transitionDuration,
            hideSortableGhost = _props3.hideSortableGhost;

        var nodes = this.manager.getOrderedRefs();
        var deltaScroll = {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
        };
        var scrollDifference = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(912);

var _find2 = _interopRequireDefault(_find);

var _sortBy = __webpack_require__(858);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: 'add',
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: 'remove',
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.active;
    }
  }, {
    key: 'getActive',
    value: function getActive() {
      var _this = this;

      return (0, _find2.default)(this.refs[this.active.collection],
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: 'getOrderedRefs',
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
        var node = _ref2.node;
        return node.sortableInfo.index;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(202),
    isArrayLike = __webpack_require__(148),
    keys = __webpack_require__(170);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(624),
    baseIteratee = __webpack_require__(202),
    toInteger = __webpack_require__(625);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(172),
    isArguments = __webpack_require__(381),
    isArray = __webpack_require__(51);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(418),
    baseGet = __webpack_require__(288),
    baseIteratee = __webpack_require__(202),
    baseMap = __webpack_require__(913),
    baseSortBy = __webpack_require__(1934),
    baseUnary = __webpack_require__(419),
    compareMultiple = __webpack_require__(1935),
    identity = __webpack_require__(147),
    isArray = __webpack_require__(51);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1934 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1936);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(171);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _default = [{
  id: 1457690400,
  name: 'Temperature',
  thumb: 'assets/images/ico-waterLevel.png'
}, {
  id: 1457690401,
  name: 'Spatial Depth',
  thumb: 'assets/images/ico-2.png'
}, {
  id: 1457690402,
  name: 'Humidity',
  thumb: 'assets/images/ico-3.png'
}, {
  id: 1457690403,
  name: 'Power Leakage',
  thumb: 'assets/images/ico-4.png'

}, {
  id: 1457690404,
  name: 'Gas Leakage',
  thumb: 'assets/images/fire.png'
}, {
  id: 1457690405,
  name: 'Battery Charge',
  thumb: 'assets/images/ico-5.png'

}];
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/data/heartbeatList.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/data/heartbeatList.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/AdminPanel/data/heartbeatList.js');
}();

;

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AppBar", function() { return __WEBPACK_IMPORTED_MODULE_0__AppBar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Avatar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return __WEBPACK_IMPORTED_MODULE_1__Avatar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Badge__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_2__Badge___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BottomNavigation__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BottomNavigation__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BottomNavigation", function() { return __WEBPACK_IMPORTED_MODULE_3__BottomNavigation___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__BottomNavigation__, "BottomNavigationAction")) __webpack_require__.d(__webpack_exports__, "BottomNavigationAction", function() { return __WEBPACK_IMPORTED_MODULE_3__BottomNavigation__["BottomNavigationAction"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Button__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_4__Button___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ButtonBase__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ButtonBase", function() { return __WEBPACK_IMPORTED_MODULE_5__ButtonBase___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Card__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_6__Card___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__Card__, "CardActions")) __webpack_require__.d(__webpack_exports__, "CardActions", function() { return __WEBPACK_IMPORTED_MODULE_6__Card__["CardActions"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__Card__, "CardContent")) __webpack_require__.d(__webpack_exports__, "CardContent", function() { return __WEBPACK_IMPORTED_MODULE_6__Card__["CardContent"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__Card__, "CardHeader")) __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return __WEBPACK_IMPORTED_MODULE_6__Card__["CardHeader"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__Card__, "CardMedia")) __webpack_require__.d(__webpack_exports__, "CardMedia", function() { return __WEBPACK_IMPORTED_MODULE_6__Card__["CardMedia"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkbox__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Checkbox__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_7__Checkbox___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Chip__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Chip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Chip", function() { return __WEBPACK_IMPORTED_MODULE_8__Chip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClickAwayListener", function() { return __WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CssBaseline__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CssBaseline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CssBaseline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CssBaseline", function() { return __WEBPACK_IMPORTED_MODULE_10__CssBaseline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Dialog__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Dialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Dialog", function() { return __WEBPACK_IMPORTED_MODULE_11__Dialog___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11__Dialog__, "DialogActions")) __webpack_require__.d(__webpack_exports__, "DialogActions", function() { return __WEBPACK_IMPORTED_MODULE_11__Dialog__["DialogActions"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11__Dialog__, "DialogContent")) __webpack_require__.d(__webpack_exports__, "DialogContent", function() { return __WEBPACK_IMPORTED_MODULE_11__Dialog__["DialogContent"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11__Dialog__, "DialogContentText")) __webpack_require__.d(__webpack_exports__, "DialogContentText", function() { return __WEBPACK_IMPORTED_MODULE_11__Dialog__["DialogContentText"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11__Dialog__, "DialogTitle")) __webpack_require__.d(__webpack_exports__, "DialogTitle", function() { return __WEBPACK_IMPORTED_MODULE_11__Dialog__["DialogTitle"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11__Dialog__, "withMobileDialog")) __webpack_require__.d(__webpack_exports__, "withMobileDialog", function() { return __WEBPACK_IMPORTED_MODULE_11__Dialog__["withMobileDialog"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Divider__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Divider__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_12__Divider___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Drawer__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Drawer__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return __WEBPACK_IMPORTED_MODULE_13__Drawer___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExpansionPanel", function() { return __WEBPACK_IMPORTED_MODULE_14__ExpansionPanel___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__, "ExpansionPanelActions")) __webpack_require__.d(__webpack_exports__, "ExpansionPanelActions", function() { return __WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__["ExpansionPanelActions"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__, "ExpansionPanelDetails")) __webpack_require__.d(__webpack_exports__, "ExpansionPanelDetails", function() { return __WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__["ExpansionPanelDetails"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__, "ExpansionPanelSummary")) __webpack_require__.d(__webpack_exports__, "ExpansionPanelSummary", function() { return __WEBPACK_IMPORTED_MODULE_14__ExpansionPanel__["ExpansionPanelSummary"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Form__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Form__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_15__Form__, "FormControl")) __webpack_require__.d(__webpack_exports__, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_15__Form__["FormControl"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_15__Form__, "FormGroup")) __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_15__Form__["FormGroup"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_15__Form__, "FormLabel")) __webpack_require__.d(__webpack_exports__, "FormLabel", function() { return __WEBPACK_IMPORTED_MODULE_15__Form__["FormLabel"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_15__Form__, "FormHelperText")) __webpack_require__.d(__webpack_exports__, "FormHelperText", function() { return __WEBPACK_IMPORTED_MODULE_15__Form__["FormHelperText"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_15__Form__, "FormControlLabel")) __webpack_require__.d(__webpack_exports__, "FormControlLabel", function() { return __WEBPACK_IMPORTED_MODULE_15__Form__["FormControlLabel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Hidden__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Hidden__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Hidden", function() { return __WEBPACK_IMPORTED_MODULE_16__Hidden___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Icon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_17__Icon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__IconButton__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__IconButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return __WEBPACK_IMPORTED_MODULE_18__IconButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Input__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Input__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_19__Input___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_19__Input__, "InputLabel")) __webpack_require__.d(__webpack_exports__, "InputLabel", function() { return __WEBPACK_IMPORTED_MODULE_19__Input__["InputLabel"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_19__Input__, "InputAdornment")) __webpack_require__.d(__webpack_exports__, "InputAdornment", function() { return __WEBPACK_IMPORTED_MODULE_19__Input__["InputAdornment"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Grid__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Grid__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_20__Grid___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__GridList__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__GridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__GridList__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GridList", function() { return __WEBPACK_IMPORTED_MODULE_21__GridList___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_21__GridList__, "GridListTile")) __webpack_require__.d(__webpack_exports__, "GridListTile", function() { return __WEBPACK_IMPORTED_MODULE_21__GridList__["GridListTile"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_21__GridList__, "GridListTileBar")) __webpack_require__.d(__webpack_exports__, "GridListTileBar", function() { return __WEBPACK_IMPORTED_MODULE_21__GridList__["GridListTileBar"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__List__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_22__List___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_22__List__, "ListItem")) __webpack_require__.d(__webpack_exports__, "ListItem", function() { return __WEBPACK_IMPORTED_MODULE_22__List__["ListItem"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_22__List__, "ListItemAvatar")) __webpack_require__.d(__webpack_exports__, "ListItemAvatar", function() { return __WEBPACK_IMPORTED_MODULE_22__List__["ListItemAvatar"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_22__List__, "ListItemIcon")) __webpack_require__.d(__webpack_exports__, "ListItemIcon", function() { return __WEBPACK_IMPORTED_MODULE_22__List__["ListItemIcon"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_22__List__, "ListItemSecondaryAction")) __webpack_require__.d(__webpack_exports__, "ListItemSecondaryAction", function() { return __WEBPACK_IMPORTED_MODULE_22__List__["ListItemSecondaryAction"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_22__List__, "ListItemText")) __webpack_require__.d(__webpack_exports__, "ListItemText", function() { return __WEBPACK_IMPORTED_MODULE_22__List__["ListItemText"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_22__List__, "ListSubheader")) __webpack_require__.d(__webpack_exports__, "ListSubheader", function() { return __WEBPACK_IMPORTED_MODULE_22__List__["ListSubheader"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Menu__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Menu__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_23__Menu___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_23__Menu__, "MenuItem")) __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_23__Menu__["MenuItem"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_23__Menu__, "MenuList")) __webpack_require__.d(__webpack_exports__, "MenuList", function() { return __WEBPACK_IMPORTED_MODULE_23__Menu__["MenuList"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__MobileStepper__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__MobileStepper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MobileStepper", function() { return __WEBPACK_IMPORTED_MODULE_24__MobileStepper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Modal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__Modal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_25__Modal___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_25__Modal__, "Backdrop")) __webpack_require__.d(__webpack_exports__, "Backdrop", function() { return __WEBPACK_IMPORTED_MODULE_25__Modal__["Backdrop"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_25__Modal__, "ModalManager")) __webpack_require__.d(__webpack_exports__, "ModalManager", function() { return __WEBPACK_IMPORTED_MODULE_25__Modal__["ModalManager"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Paper__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__Paper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Paper", function() { return __WEBPACK_IMPORTED_MODULE_26__Paper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Popover__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Popover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_27__Popover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Portal__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__Portal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_28__Portal___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Progress__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__Progress__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_29__Progress__, "CircularProgress")) __webpack_require__.d(__webpack_exports__, "CircularProgress", function() { return __WEBPACK_IMPORTED_MODULE_29__Progress__["CircularProgress"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_29__Progress__, "LinearProgress")) __webpack_require__.d(__webpack_exports__, "LinearProgress", function() { return __WEBPACK_IMPORTED_MODULE_29__Progress__["LinearProgress"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Radio__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__Radio__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_30__Radio___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_30__Radio__, "RadioGroup")) __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_30__Radio__["RadioGroup"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Select__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__Select__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_31__Select___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Snackbar__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__Snackbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Snackbar", function() { return __WEBPACK_IMPORTED_MODULE_32__Snackbar___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_32__Snackbar__, "SnackbarContent")) __webpack_require__.d(__webpack_exports__, "SnackbarContent", function() { return __WEBPACK_IMPORTED_MODULE_32__Snackbar__["SnackbarContent"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Stepper__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__Stepper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Stepper", function() { return __WEBPACK_IMPORTED_MODULE_33__Stepper___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_33__Stepper__, "Step")) __webpack_require__.d(__webpack_exports__, "Step", function() { return __WEBPACK_IMPORTED_MODULE_33__Stepper__["Step"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_33__Stepper__, "StepButton")) __webpack_require__.d(__webpack_exports__, "StepButton", function() { return __WEBPACK_IMPORTED_MODULE_33__Stepper__["StepButton"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_33__Stepper__, "StepIcon")) __webpack_require__.d(__webpack_exports__, "StepIcon", function() { return __WEBPACK_IMPORTED_MODULE_33__Stepper__["StepIcon"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_33__Stepper__, "StepContent")) __webpack_require__.d(__webpack_exports__, "StepContent", function() { return __WEBPACK_IMPORTED_MODULE_33__Stepper__["StepContent"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_33__Stepper__, "StepLabel")) __webpack_require__.d(__webpack_exports__, "StepLabel", function() { return __WEBPACK_IMPORTED_MODULE_33__Stepper__["StepLabel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__styles__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__styles__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_34__styles__, "MuiThemeProvider")) __webpack_require__.d(__webpack_exports__, "MuiThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_34__styles__["MuiThemeProvider"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_34__styles__, "withStyles")) __webpack_require__.d(__webpack_exports__, "withStyles", function() { return __WEBPACK_IMPORTED_MODULE_34__styles__["withStyles"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_34__styles__, "withTheme")) __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_34__styles__["withTheme"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_34__styles__, "createMuiTheme")) __webpack_require__.d(__webpack_exports__, "createMuiTheme", function() { return __WEBPACK_IMPORTED_MODULE_34__styles__["createMuiTheme"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_34__styles__, "jssPreset")) __webpack_require__.d(__webpack_exports__, "jssPreset", function() { return __WEBPACK_IMPORTED_MODULE_34__styles__["jssPreset"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__colors__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__colors__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_35__colors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SvgIcon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__SvgIcon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SvgIcon", function() { return __WEBPACK_IMPORTED_MODULE_36__SvgIcon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Switch__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__Switch__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_37__Switch___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Table__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__Table__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_38__Table___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TableBody")) __webpack_require__.d(__webpack_exports__, "TableBody", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TableBody"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TableCell")) __webpack_require__.d(__webpack_exports__, "TableCell", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TableCell"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TableFooter")) __webpack_require__.d(__webpack_exports__, "TableFooter", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TableFooter"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TableHead")) __webpack_require__.d(__webpack_exports__, "TableHead", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TableHead"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TablePagination")) __webpack_require__.d(__webpack_exports__, "TablePagination", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TablePagination"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TableRow")) __webpack_require__.d(__webpack_exports__, "TableRow", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TableRow"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_38__Table__, "TableSortLabel")) __webpack_require__.d(__webpack_exports__, "TableSortLabel", function() { return __WEBPACK_IMPORTED_MODULE_38__Table__["TableSortLabel"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Tabs__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__Tabs__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_39__Tabs___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_39__Tabs__, "Tab")) __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_39__Tabs__["Tab"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Typography__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__Typography__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Typography", function() { return __WEBPACK_IMPORTED_MODULE_40__Typography___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__TextField__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__TextField__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return __WEBPACK_IMPORTED_MODULE_41__TextField___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Toolbar__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Toolbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return __WEBPACK_IMPORTED_MODULE_42__Toolbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Tooltip__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__Tooltip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_43__Tooltip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__transitions__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__transitions__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_44__transitions__, "Slide")) __webpack_require__.d(__webpack_exports__, "Slide", function() { return __WEBPACK_IMPORTED_MODULE_44__transitions__["Slide"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_44__transitions__, "Grow")) __webpack_require__.d(__webpack_exports__, "Grow", function() { return __WEBPACK_IMPORTED_MODULE_44__transitions__["Grow"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_44__transitions__, "Fade")) __webpack_require__.d(__webpack_exports__, "Fade", function() { return __WEBPACK_IMPORTED_MODULE_44__transitions__["Fade"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_44__transitions__, "Collapse")) __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_44__transitions__["Collapse"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_44__transitions__, "Zoom")) __webpack_require__.d(__webpack_exports__, "Zoom", function() { return __WEBPACK_IMPORTED_MODULE_44__transitions__["Zoom"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_withWidth__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__utils_withWidth__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "withWidth", function() { return __WEBPACK_IMPORTED_MODULE_45__utils_withWidth___default.a; });
/** @license Material-UI v1.0.0-beta.37
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




































// eslint-disable-next-line import/first

















/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = __webpack_require__(1942);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Badge).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RADIUS = 12;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: -RADIUS,
      right: -RADIUS,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.pxToRem(RADIUS),
      width: RADIUS * 2,
      height: RADIUS * 2,
      borderRadius: '50%',
      backgroundColor: theme.palette.color,
      color: theme.palette.textColor,
      zIndex: 1 // Render the badge on top of potential ripples.
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    }
  };
};

function Badge(props) {
  var badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      ComponentProp = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['badgeContent', 'children', 'classes', 'className', 'color', 'component']);


  var badgeClassName = (0, _classnames2.default)(classes.badge, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'));

  return _react2.default.createElement(
    ComponentProp,
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
    children,
    _react2.default.createElement(
      'span',
      { className: badgeClassName },
      badgeContent
    )
  );
}

Badge.propTypes =  false ? {
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes2.default.node.isRequired,
  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'primary', 'secondary', 'error']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

Badge.defaultProps = {
  color: 'default',
  component: 'span'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBadge' })(Badge);

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BottomNavigation = __webpack_require__(1944);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BottomNavigation).default;
  }
});

var _BottomNavigationAction = __webpack_require__(1945);

Object.defineProperty(exports, 'BottomNavigationAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BottomNavigationAction).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};

function BottomNavigation(props) {
  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      onChange = props.onChange,
      showLabels = props.showLabels,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'onChange', 'showLabels', 'value']);


  var className = (0, _classnames2.default)(classes.root, classNameProp);

  var children = _react2.default.Children.map(childrenProp, function (child, childIndex) {
    if (!_react2.default.isValidElement(child)) {
      return null;
    }

    var childValue = child.props.value || childIndex;
    return _react2.default.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

BottomNavigation.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: _propTypes2.default.func,
  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: _propTypes2.default.bool,
  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes2.default.any
} : {};

BottomNavigation.defaultProps = {
  showLabels: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBottomNavigation' })(BottomNavigation);

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      paddingTop: theme.spacing.unit,
      paddingBottom: 10,
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1'
    },
    selected: {
      paddingTop: 6,
      color: theme.palette.primary.main
    },
    selectedIconOnly: {
      paddingTop: theme.spacing.unit * 2
    },
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 2),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s'
    },
    labelSelected: {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
    },
    labelHidden: {
      opacity: 0,
      transitionDelay: '0s'
    }
  };
}; // @inheritedComponent ButtonBase

var BottomNavigationAction = function (_React$Component) {
  (0, _inherits3.default)(BottomNavigationAction, _React$Component);

  function BottomNavigationAction() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BottomNavigationAction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BottomNavigationAction.__proto__ || (0, _getPrototypeOf2.default)(BottomNavigationAction)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;


      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BottomNavigationAction, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          icon = _props.icon,
          label = _props.label,
          onChange = _props.onChange,
          onClick = _props.onClick,
          selected = _props.selected,
          showLabelProp = _props.showLabel,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'icon', 'label', 'onChange', 'onClick', 'selected', 'showLabel', 'value']);


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.selected, selected), (0, _defineProperty3.default)(_classNames, classes.selectedIconOnly, !showLabelProp && !selected), _classNames), classNameProp);

      var labelClassName = (0, _classnames2.default)(classes.label, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.labelSelected, selected), (0, _defineProperty3.default)(_classNames2, classes.labelHidden, !showLabelProp && !selected), _classNames2));

      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends3.default)({ className: className, focusRipple: true, onClick: this.handleChange }, other),
        _react2.default.createElement(
          'span',
          { className: classes.wrapper },
          icon,
          _react2.default.createElement(
            'span',
            { className: labelClassName },
            label
          )
        )
      );
    }
  }]);
  return BottomNavigationAction;
}(_react2.default.Component);

BottomNavigationAction.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The icon element.
   */
  icon: _propTypes2.default.node,
  /**
   * The label element.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  selected: _propTypes2.default.bool,
  /**
   * If `true`, the BottomNavigationAction will show its label.
   */
  showLabel: _propTypes2.default.bool,
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes2.default.any
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBottomNavigationAction' })(BottomNavigationAction);

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Card = __webpack_require__(1947);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Card).default;
  }
});

var _CardContent = __webpack_require__(1948);

Object.defineProperty(exports, 'CardContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardContent).default;
  }
});

var _CardActions = __webpack_require__(1949);

Object.defineProperty(exports, 'CardActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardActions).default;
  }
});

var _CardMedia = __webpack_require__(1950);

Object.defineProperty(exports, 'CardMedia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardMedia).default;
  }
});

var _CardHeader = __webpack_require__(1951);

Object.defineProperty(exports, 'CardHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Card(props) {
  var raised = props.raised,
      other = (0, _objectWithoutProperties3.default)(props, ['raised']);


  return _react2.default.createElement(_Paper2.default, (0, _extends3.default)({ elevation: raised ? 8 : 2 }, other));
} // @inheritedComponent Paper

Card.propTypes =  false ? {
  /**
   * If `true`, the card will use raised styling.
   */
  raised: _propTypes2.default.bool
} : {};

Card.defaultProps = {
  raised: false
};

exports.default = Card;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      '&:last-child': {
        paddingBottom: theme.spacing.unit * 3
      }
    })
  };
};

function CardContent(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component']);


  return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other));
}

CardContent.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

CardContent.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardContent' })(CardContent);

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _defineProperty3.default)({
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit / 2 + 'px'
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 1.5 + 'px'
    }),
    action: {
      margin: '0 ' + theme.spacing.unit / 2 + 'px'
    }
  };
};

function CardActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['disableActionSpacing', 'children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
  );
}

CardActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableActionSpacing: _propTypes2.default.bool
} : {};

CardActions.defaultProps = {
  disableActionSpacing: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardActions' })(CardActions);

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  media: {
    width: '100%'
  }
};

var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function CardMedia(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'image', 'src', 'style']);


   false ? (0, _warning2.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? (0, _extends3.default)({ backgroundImage: 'url(' + image + ')' }, style) : style;

  return _react2.default.createElement(Component, (0, _extends3.default)({
    className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.media, isMediaComponent), className),
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other));
}

CardMedia.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes2.default.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes2.default.string,
  /**
   * @ignore
   */
  style: _propTypes2.default.object
} : {};

CardMedia.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardMedia' })(CardMedia);

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      display: 'flex',
      alignItems: 'center',
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2
    }),
    avatar: {
      flex: '0 0 auto',
      marginRight: theme.spacing.unit * 2
    },
    action: {
      flex: '0 0 auto',
      alignSelf: 'flex-start',
      marginTop: theme.spacing.unit * -1,
      marginRight: theme.spacing.unit * -2
    },
    content: {
      flex: '1 1 auto'
    },
    title: {},
    subheader: {}
  };
};

function CardHeader(props) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      subheader = props.subheader,
      title = props.title,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'avatar', 'classes', 'className', 'component', 'subheader', 'title']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
    avatar && _react2.default.createElement(
      'div',
      { className: classes.avatar },
      avatar
    ),
    _react2.default.createElement(
      'div',
      { className: classes.content },
      _react2.default.createElement(
        _Typography2.default,
        {
          variant: avatar ? 'body2' : 'headline',
          component: 'span',
          className: classes.title
        },
        title
      ),
      subheader && _react2.default.createElement(
        _Typography2.default,
        {
          variant: avatar ? 'body2' : 'body1',
          component: 'span',
          color: 'textSecondary',
          className: classes.subheader
        },
        subheader
      )
    ),
    action && _react2.default.createElement(
      'div',
      { className: classes.action },
      action
    )
  );
}

CardHeader.propTypes =  false ? {
  /**
   * The action to display in the card header.
   */
  action: _propTypes2.default.node,
  /**
   * The Avatar for the Card Header.
   */
  avatar: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The content of the component.
   */
  subheader: _propTypes2.default.node,
  /**
   * The content of the Card Title.
   */
  title: _propTypes2.default.node
} : {};

CardHeader.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardHeader' })(CardHeader);

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Chip = __webpack_require__(1953);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chip).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _Cancel = __webpack_require__(1954);

var _Cancel2 = _interopRequireDefault(_Cancel);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(136);

__webpack_require__(551);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// So we don't have any override priority issue.

var styles = exports.styles = function styles(theme) {
  var height = 32;
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);

  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: height,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: height / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      outline: 'none', // No outline on focused element in Chrome (as triggered by tabIndex prop)
      border: 'none', // Remove `button` border
      padding: 0 // Remove `button` padding
    },
    clickable: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
      }
    },
    deletable: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      }
    },
    avatar: {
      marginRight: -4,
      width: height,
      height: height,
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(16)
    },
    avatarChildren: {
      width: 19,
      height: 19
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'inherit'
    },
    deleteIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      cursor: 'pointer',
      height: 'auto',
      margin: '0 4px 0 -8px',
      '&:hover': {
        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
      }
    }
  };
};

/**
 * Chips represent complex entities in small blocks, such as a contact.
 */

var Chip = function (_React$Component) {
  (0, _inherits3.default)(Chip, _React$Component);

  function Chip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Chip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.chipRef = null, _this.handleDeleteIconClick = function (event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();
      var onDelete = _this.props.onDelete;

      if (onDelete) {
        onDelete(event);
      }
    }, _this.handleKeyDown = function (event) {
      // Ignore events from children of `Chip`.
      if (event.currentTarget !== event.target) {
        return;
      }

      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onKeyDown = _this$props.onKeyDown;

      var key = (0, _keycode2.default)(event);

      if (onClick && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      } else if (onDelete && key === 'backspace') {
        event.preventDefault();
        onDelete(event);
      } else if (key === 'esc') {
        event.preventDefault();
        if (_this.chipRef) {
          _this.chipRef.blur();
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Chip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          avatarProp = _props.avatar,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          deleteIconProp = _props.deleteIcon,
          label = _props.label,
          onClick = _props.onClick,
          onDelete = _props.onDelete,
          onKeyDown = _props.onKeyDown,
          tabIndexProp = _props.tabIndex,
          other = (0, _objectWithoutProperties3.default)(_props, ['avatar', 'classes', 'className', 'component', 'deleteIcon', 'label', 'onClick', 'onDelete', 'onKeyDown', 'tabIndex']);


      var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.clickable, onClick), (0, _defineProperty3.default)({}, classes.deletable, onDelete), classNameProp);

      var deleteIcon = null;
      if (onDelete) {
        deleteIcon = deleteIconProp && _react2.default.isValidElement(deleteIconProp) ? _react2.default.cloneElement(deleteIconProp, {
          className: (0, _classnames2.default)(deleteIconProp.props.className, classes.deleteIcon),
          onClick: this.handleDeleteIconClick
        }) : _react2.default.createElement(_Cancel2.default, { className: classes.deleteIcon, onClick: this.handleDeleteIconClick });
      }

      var avatar = null;
      if (avatarProp && _react2.default.isValidElement(avatarProp)) {
        avatar = _react2.default.cloneElement(avatarProp, {
          className: (0, _classnames2.default)(classes.avatar, avatarProp.props.className),
          childrenClassName: (0, _classnames2.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
        });
      }

      var tabIndex = tabIndexProp;

      if (!tabIndex) {
        tabIndex = onClick || onDelete ? 0 : -1;
      }

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({
          role: 'button',
          className: className,
          tabIndex: tabIndex,
          onClick: onClick,
          onKeyDown: this.handleKeyDown,
          ref: function ref(node) {
            _this2.chipRef = node;
          }
        }, other),
        avatar,
        _react2.default.createElement(
          'span',
          { className: classes.label },
          label
        ),
        deleteIcon
      );
    }
  }]);
  return Chip;
}(_react2.default.Component);

Chip.propTypes =  false ? {
  /**
   * Avatar element.
   */
  avatar: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes2.default.element,
  /**
   * The content of the label.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
} : {};

Chip.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiChip' })(Chip);

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' });

var Cancel = function Cancel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
Cancel = (0, _pure2.default)(Cancel);
Cancel.muiName = 'SvgIcon';

exports.default = Cancel;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CssBaseline = __webpack_require__(1956);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CssBaseline).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(327);

var _exactProp = __webpack_require__(190);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased', // Antialiasing.
        MozOsxFontSmoothing: 'grayscale', // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      body: {
        margin: 0, // Remove the margin in all browsers.
        backgroundColor: theme.palette.background.default,
        '@media print': {
          // Save printer ink.
          backgroundColor: theme.palette.common.white
        }
      }
    }
  };
};

/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

var CssBaseline = function (_React$Component) {
  (0, _inherits3.default)(CssBaseline, _React$Component);

  function CssBaseline() {
    (0, _classCallCheck3.default)(this, CssBaseline);
    return (0, _possibleConstructorReturn3.default)(this, (CssBaseline.__proto__ || (0, _getPrototypeOf2.default)(CssBaseline)).apply(this, arguments));
  }

  (0, _createClass3.default)(CssBaseline, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return CssBaseline;
}(_react2.default.Component);

CssBaseline.propTypes =  false ? {
  /**
   * You can only provide a single element with react@15, a node with react@16.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired
} : {};

CssBaseline.propTypes =  false ? (0, _exactProp2.default)(CssBaseline.propTypes, 'CssBaseline') : {};

CssBaseline.defaultProps = {
  children: null
};

exports.default = (0, _styles.withStyles)(styles, { name: 'MuiCssBaseline' })(CssBaseline);

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(1958);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dialog).default;
  }
});

var _DialogActions = __webpack_require__(1959);

Object.defineProperty(exports, 'DialogActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogActions).default;
  }
});

var _DialogTitle = __webpack_require__(1960);

Object.defineProperty(exports, 'DialogTitle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogTitle).default;
  }
});

var _DialogContent = __webpack_require__(1961);

Object.defineProperty(exports, 'DialogContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogContent).default;
  }
});

var _DialogContentText = __webpack_require__(1962);

Object.defineProperty(exports, 'DialogContentText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogContentText).default;
  }
});

var _withMobileDialog = __webpack_require__(1963);

Object.defineProperty(exports, 'withMobileDialog', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withMobileDialog).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

var _Modal = __webpack_require__(244);

var _Modal2 = _interopRequireDefault(_Modal);

var _Fade = __webpack_require__(362);

var _Fade2 = _interopRequireDefault(_Fade);

var _transitions = __webpack_require__(112);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    paper: {
      display: 'flex',
      margin: theme.spacing.unit * 4,
      flexDirection: 'column',
      flex: '0 1 auto',
      position: 'relative',
      maxHeight: '90vh',
      overflowY: 'auto', // Fix IE11 issue, to remove at some point.
      '&:focus': {
        outline: 'none'
      }
    },
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360)
    },
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm
    },
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md
    },
    paperFullWidth: {
      width: '100%'
    },
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
      borderRadius: 0
    }
  };
};

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
// @inheritedComponent Modal

function Dialog(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      fullScreen = props.fullScreen,
      fullWidth = props.fullWidth,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      maxWidth = props.maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      PaperProps = props.PaperProps,
      TransitionProp = props.transition,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'fullScreen', 'fullWidth', 'disableBackdropClick', 'disableEscapeKeyDown', 'maxWidth', 'onBackdropClick', 'onClose', 'onEnter', 'onEntered', 'onEntering', 'onEscapeKeyDown', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'transition', 'transitionDuration']);


  return _react2.default.createElement(
    _Modal2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, className),
      BackdropProps: {
        transitionDuration: transitionDuration
      },
      disableBackdropClick: disableBackdropClick,
      disableEscapeKeyDown: disableEscapeKeyDown,
      onBackdropClick: onBackdropClick,
      onEscapeKeyDown: onEscapeKeyDown,
      onClose: onClose,
      open: open,
      role: 'dialog'
    }, other),
    _react2.default.createElement(
      TransitionProp,
      {
        appear: true,
        'in': open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
      },
      _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({
          elevation: 24,
          className: (0, _classnames2.default)(classes.paper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['paperWidth' + (maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty3.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty3.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
        }, PaperProps),
        children
      )
    )
  );
}

Dialog.propTypes =  false ? {
  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes2.default.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes2.default.bool,
  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes2.default.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', false]),
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes2.default.func,
  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Dialog.defaultProps = {
  fullScreen: false,
  fullWidth: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  maxWidth: 'sm',
  transition: _Fade2.default,
  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen }
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialog' })(Dialog);

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(138);

__webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// So we don't have any override priority issue.

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '0 0 auto',
      margin: theme.spacing.unit + 'px ' + theme.spacing.unit / 2 + 'px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    action: {
      margin: '0 ' + theme.spacing.unit / 2 + 'px',
      minWidth: 64
    }
  };
};

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['disableActionSpacing', 'children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
  );
}

DialogActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableActionSpacing: _propTypes2.default.bool
} : {};

DialogActions.defaultProps = {
  disableActionSpacing: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogActions' })(DialogActions);

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px       20px ' + theme.spacing.unit * 3 + 'px',
      flex: '0 0 auto'
    }
  };
};

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableTypography']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    disableTypography ? children : _react2.default.createElement(
      _Typography2.default,
      { variant: 'title' },
      children
    )
  );
}

DialogTitle.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes2.default.bool
} : {};

DialogTitle.defaultProps = {
  disableTypography: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogTitle' })(DialogTitle);

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var spacing = theme.spacing.unit * 3;
  return {
    root: {
      flex: '1 1 auto',
      overflowY: 'auto',
      padding: '0 ' + spacing + 'px ' + spacing + 'px ' + spacing + 'px',
      '&:first-child': {
        paddingTop: spacing
      }
    }
  };
};

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

DialogContent.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContent' })(DialogContent);

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.subheading, {
      color: theme.palette.text.secondary,
      margin: 0
    })
  };
};

function DialogContentText(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'p',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

DialogContentText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContentText' })(DialogContentText);

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withWidth = __webpack_require__(415);

var _withWidth2 = _interopRequireDefault(_withWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server side rendering.
 */
var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === undefined ? 'sm' : _options$breakpoint;


    function WithMobileDialog(props) {
      return _react2.default.createElement(Component, (0, _extends3.default)({ fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width) }, props));
    }

    WithMobileDialog.propTypes =  false ? {
      width: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : {};

    return (0, _withWidth2.default)()(WithMobileDialog);
  };
};

exports.default = withMobileDialog;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Divider = __webpack_require__(1965);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Divider).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 1,
      margin: 0, // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },
    inset: {
      marginLeft: theme.spacing.unit * 9
    },
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    }
  };
};

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      other = (0, _objectWithoutProperties3.default)(props, ['absolute', 'classes', 'className', 'component', 'inset', 'light']);


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.absolute, absolute), (0, _defineProperty3.default)(_classNames, classes.inset, inset), (0, _defineProperty3.default)(_classNames, classes.light, light), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Divider.propTypes =  false ? {
  absolute: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the divider will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes2.default.bool
} : {};

Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  inset: false,
  light: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDivider' })(Divider);

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpansionPanel = __webpack_require__(1967);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanel).default;
  }
});

var _ExpansionPanelActions = __webpack_require__(1968);

Object.defineProperty(exports, 'ExpansionPanelActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelActions).default;
  }
});

var _ExpansionPanelDetails = __webpack_require__(1969);

Object.defineProperty(exports, 'ExpansionPanelDetails', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelDetails).default;
  }
});

var _ExpansionPanelSummary = __webpack_require__(1970);

Object.defineProperty(exports, 'ExpansionPanelSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelSummary).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Collapse = __webpack_require__(416);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };

  return {
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': {
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },
    expanded: {
      margin: theme.spacing.unit * 2 + 'px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
}; // @inheritedComponent Paper

var ExpansionPanel = function (_React$Component) {
  (0, _inherits3.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props, context) {
    (0, _classCallCheck3.default)(this, ExpansionPanel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExpansionPanel.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanel)).call(this, props, context));

    _this.state = {};
    _this.isControlled = null;

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({ expanded: !expanded });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;
    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }
    return _this;
  }

  (0, _createClass3.default)(ExpansionPanel, [{
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          CollapsePropsProp = _props.CollapseProps,
          defaultExpanded = _props.defaultExpanded,
          disabled = _props.disabled,
          expandedProp = _props.expanded,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'CollapseProps', 'defaultExpanded', 'disabled', 'expanded', 'onChange']);

      var expanded = this.isControlled ? expandedProp : this.state.expanded;

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);

      var summary = null;

      var children = _react2.default.Children.map(childrenProp, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react2.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({ className: className, elevation: 1, square: true }, other),
        summary,
        _react2.default.createElement(
          _Collapse2.default,
          (0, _extends3.default)({ 'in': expanded, timeout: 'auto' }, CollapseProps, CollapsePropsProp),
          children
        )
      );
    }
  }]);
  return ExpansionPanel;
}(_react2.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Properties applied to the `Collapse` element.
   */
  CollapseProps: _propTypes2.default.object,
  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes2.default.bool,
  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes2.default.func
} : {};

ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanel' })(ExpansionPanel);

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: theme.spacing.unit * 2 + 'px ' + theme.spacing.unit + 'px'
    },
    action: {
      marginLeft: theme.spacing.unit
    }
  };
};

function ExpansionPanelActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
  );
}

ExpansionPanelActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelActions' })(ExpansionPanelActions);

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px'
    }
  };
};

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelDetails' })(ExpansionPanelDetails);

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    root: {
      display: 'flex',
      minHeight: theme.spacing.unit * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 ' + theme.spacing.unit * 3 + 'px 0 ' + theme.spacing.unit * 3 + 'px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      }
    },
    expanded: {
      minHeight: 64
    },
    focused: {
      backgroundColor: theme.palette.grey[300]
    },
    disabled: {
      opacity: 0.38
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: theme.spacing.unit * 4
      }
    },
    contentExpanded: {
      margin: '20px 0'
    },
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: theme.spacing.unit,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition)
    },
    expandIconExpanded: {
      transform: 'translateY(-50%) rotate(180deg)'
    }
  };
};

var ExpansionPanelSummary = function (_React$Component) {
  (0, _inherits3.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanelSummary.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    }, _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }
      if (onClick) {
        onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpansionPanelSummary, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          expanded = _props.expanded,
          expandIcon = _props.expandIcon,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disabled', 'expanded', 'expandIcon', 'onChange']);
      var focused = this.state.focused;


      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends3.default)({
          focusRipple: false,
          disableRipple: true,
          disabled: disabled,
          component: 'div',
          'aria-expanded': expanded,
          className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.focused, focused), _classNames), className)
        }, other, {
          onKeyboardFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleChange
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(classes.content, (0, _defineProperty3.default)({}, classes.contentExpanded, expanded)) },
          children
        ),
        expandIcon && _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: disabled,
            className: (0, _classnames2.default)(classes.expandIcon, (0, _defineProperty3.default)({}, classes.expandIconExpanded, expanded)),
            component: 'div',
            tabIndex: -1,
            'aria-hidden': 'true'
          },
          expandIcon
        )
      );
    }
  }]);
  return ExpansionPanelSummary;
}(_react2.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes2.default.bool,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func
} : {};

ExpansionPanelSummary.defaultProps = {
  disabled: false
};

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelSummary' })(ExpansionPanelSummary);

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0
    },
    focused: {
      color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
    },
    disabled: {
      color: theme.palette.text.disabled
    },
    error: {
      color: theme.palette.error.main
    },
    asterisk: {},
    asteriskError: {
      color: theme.palette.error.main
    }
  };
};

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      focusedProp = props.focused,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'disabled', 'error', 'focused', 'required']);
  var muiFormControl = context.muiFormControl;


  var required = requiredProp;
  var focused = focusedProp;
  var disabled = disabledProp;
  var error = errorProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }
    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.focused, focused), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), _classNames), classNameProp);

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className }, other),
    children,
    required && _react2.default.createElement(
      'span',
      {
        className: (0, _classnames2.default)(classes.asterisk, (0, _defineProperty3.default)({}, classes.asteriskError, error))
      },
      '\u2009*'
    )
  );
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes2.default.bool,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool
} : {};

FormLabel.defaultProps = {
  component: 'label'
};

FormLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormLabel' })(FormLabel);

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROWS_HEIGHT = 19;

var styles = exports.styles = {
  root: {
    position: 'relative', // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    resize: 'none',
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};

/**
 * @ignore - internal component.
 */

var Textarea = function (_React$Component) {
  (0, _inherits3.default)(Textarea, _React$Component);

  function Textarea(props, context) {
    (0, _classCallCheck3.default)(this, Textarea);

    // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are dirty
    var _this = (0, _possibleConstructorReturn3.default)(this, (Textarea.__proto__ || (0, _getPrototypeOf2.default)(Textarea)).call(this, props, context));

    _this.state = {
      height: null
    };
    _this.shadow = null;
    _this.singlelineShadow = null;
    _this.input = null;
    _this.value = null;
    _this.handleResize = (0, _debounce2.default)(function () {
      _this.syncHeightWithShadow();
    }, 166);

    _this.handleRefInput = function (node) {
      _this.input = node;
      if (_this.props.textareaRef) {
        _this.props.textareaRef(node);
      }
    };

    _this.handleRefSinglelineShadow = function (node) {
      _this.singlelineShadow = node;
    };

    _this.handleRefShadow = function (node) {
      _this.shadow = node;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (typeof _this.props.value === 'undefined' && _this.shadow) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadow.value = _this.value;
        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };
    return _this;
  }

  (0, _createClass3.default)(Textarea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'syncHeightWithShadow',
    // Corresponds to 10 frames at 60 Hz.

    value: function syncHeightWithShadow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (!this.shadow || !this.singlelineShadow) {
        return;
      }

      // The component is controlled, we need to update the shallow value.
      if (typeof this.props.value !== 'undefined') {
        this.shadow.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadow.scrollHeight;
      var newHeight = this.shadow.scrollHeight;

      // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013
      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight);

      if (this.state.height !== newHeight) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          textareaRef = _props.textareaRef,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'defaultValue', 'onChange', 'rows', 'rowsMax', 'textareaRef', 'value']);


      return _react2.default.createElement(
        'div',
        { className: classes.root, style: { height: this.state.height } },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', {
          ref: this.handleRefSinglelineShadow,
          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
          tabIndex: -1,
          rows: '1',
          readOnly: true,
          'aria-hidden': 'true',
          value: ''
        }),
        _react2.default.createElement('textarea', {
          ref: this.handleRefShadow,
          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
          tabIndex: -1,
          rows: rows,
          'aria-hidden': 'true',
          readOnly: true,
          defaultValue: defaultValue,
          value: value
        }),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          rows: rows,
          className: (0, _classnames2.default)(classes.textarea, className),
          defaultValue: defaultValue,
          value: value,
          onChange: this.handleChange,
          ref: this.handleRefInput
        }, other))
      );
    }
  }]);
  return Textarea;
}(_react2.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * @ignore
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes2.default.func,
  /**
   * @ignore
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
} : {};

Textarea.defaultProps = {
  rows: 1
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTextarea' })(Textarea);

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: theme.spacing.unit * 2 // used for row presentation of radio/checkbox
    },
    disabled: {
      color: theme.palette.text.disabled,
      cursor: 'default'
    },
    label: {}
  };
};

/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
/* eslint-disable jsx-a11y/label-has-for */

function FormControlLabel(props, context) {
  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['checked', 'classes', 'className', 'control', 'disabled', 'inputRef', 'label', 'name', 'onChange', 'value']);
  var muiFormControl = context.muiFormControl;

  var disabled = disabledProp;

  if (typeof control.props.disabled !== 'undefined') {
    if (typeof disabled === 'undefined') {
      disabled = control.props.disabled;
    }
  }

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp);

  return _react2.default.createElement(
    'label',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.cloneElement(control, {
      disabled: disabled,
      checked: typeof control.props.checked === 'undefined' ? checked : control.props.checked,
      name: control.props.name || name,
      onChange: control.props.onChange || onChange,
      value: control.props.value || value,
      inputRef: control.props.inputRef || inputRef
    }),
    _react2.default.createElement(
      _Typography2.default,
      { component: 'span', className: classes.label },
      label
    )
  );
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes2.default.element,
  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes2.default.node,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

FormControlLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControlLabel' })(FormControlLabel);

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HiddenJs = __webpack_require__(1975);

var _HiddenJs2 = _interopRequireDefault(_HiddenJs);

var _HiddenCss = __webpack_require__(1976);

var _HiddenCss2 = _interopRequireDefault(_HiddenCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties3.default)(props, ['implementation']);


  if (implementation === 'js') {
    return _react2.default.createElement(_HiddenJs2.default, other);
  }

  return _react2.default.createElement(_HiddenCss2.default, other);
}

Hidden.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes2.default.oneOf(['js', 'css']),
  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes2.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes2.default.bool
} : {};

Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};

exports.default = Hidden;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createBreakpoints = __webpack_require__(188);

var _withWidth = __webpack_require__(415);

var _withWidth2 = _interopRequireDefault(_withWidth);

var _exactProp = __webpack_require__(190);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;


  var visible = true;

  // `only` check is faster to get out sooner if used.
  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];
        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  }

  // Allow `only` to be combined with other props. If already hidden, no need to check others.
  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props[_breakpoint + 'Up'];
      var breakpointDown = props[_breakpoint + 'Down'];
      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes2.default.oneOf(['js', 'css']),
  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes2.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes2.default.bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes2.default.string.isRequired,
  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes2.default.bool
};

HiddenJs.propTypes = (0, _exactProp2.default)(HiddenJs.propTypes, 'HiddenJs');

exports.default = (0, _withWidth2.default)()(HiddenJs);

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _createBreakpoints = __webpack_require__(188);

var _helpers = __webpack_require__(35);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };

  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc['only' + (0, _helpers.capitalize)(key)] = (0, _defineProperty3.default)({}, theme.breakpoints.only(key), hidden);
    acc[key + 'Up'] = (0, _defineProperty3.default)({}, theme.breakpoints.up(key), hidden);
    acc[key + 'Down'] = (0, _defineProperty3.default)({}, theme.breakpoints.down(key), hidden);

    return acc;
  }, {});
};

/**
 * @ignore - internal component.
 */
function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'lgDown', 'lgUp', 'mdDown', 'mdUp', 'only', 'smDown', 'smUp', 'xlDown', 'xlUp', 'xsDown', 'xsUp']);


   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0 || (0, _keys2.default)(other).length === 1 && other.hasOwnProperty('ref'), 'Material-UI: unsupported properties received ' + (0, _keys2.default)(other).join(', ') + ' by `<Hidden />`.') : void 0;

  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props[breakpoint + 'Up'];
    var breakpointDown = props[breakpoint + 'Down'];

    if (breakpointUp) {
      classNames.push(classes[breakpoint + 'Up']);
    }
    if (breakpointDown) {
      classNames.push(classes[breakpoint + 'Down']);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes['only' + (0, _helpers.capitalize)(breakpoint)]);
    });
  }

  return _react2.default.createElement(
    'div',
    { className: classNames.join(' ') },
    children
  );
}

HiddenCss.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes2.default.oneOf(['js', 'css']),
  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes2.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes2.default.bool
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiHiddenCss' })(HiddenCss);

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(1978);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function Icon(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color']);


  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('material-icons', classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), className),
      'aria-hidden': 'true'
    }, other),
    children
  );
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['inherit', 'secondary', 'action', 'disabled', 'error', 'primary'])
} : {};

Icon.defaultProps = {
  color: 'inherit'
};

Icon.muiName = 'Icon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIcon' })(Icon);

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      maxHeight: '2em',
      alignItems: 'center'
    },
    positionStart: {
      marginRight: theme.spacing.unit
    },
    positionEnd: {
      marginLeft: theme.spacing.unit
    }
  };
};

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'component', 'classes', 'className', 'disableTypography', 'position']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty3.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
    }, other),
    typeof children === 'string' && !disableTypography ? _react2.default.createElement(
      _Typography2.default,
      { color: 'textSecondary' },
      children
    ) : children
  );
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes2.default.oneOf(['start', 'end'])
} : {};

InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputAdornment' })(InputAdornment);

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Form = __webpack_require__(425);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      transformOrigin: 'top left'
    },
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, ' + theme.spacing.unit * 3 + 'px) scale(1)'
    },
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, ' + (theme.spacing.unit * 2.5 + 1) + 'px) scale(1)'
    },
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },
    animated: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
}; // @inheritedComponent FormLabel

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      disabled = props.disabled,
      FormControlClasses = props.FormControlClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableAnimation', 'disabled', 'FormControlClasses', 'margin', 'shrink']);
  var muiFormControl = context.muiFormControl;

  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.dirty || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var margin = marginProp;
  if (typeof margin === 'undefined' && muiFormControl) {
    margin = muiFormControl.margin;
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty3.default)(_classNames, classes.shrink, shrink), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);

  return _react2.default.createElement(
    _Form.FormLabel,
    (0, _extends3.default)({ 'data-shrink': shrink, className: className, classes: FormControlClasses }, other),
    children
  );
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes2.default.bool,
  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes2.default.bool,
  /**
   * `classes` property applied to the `FormControl` element.
   */
  FormControlClasses: _propTypes2.default.object,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense']),
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes2.default.bool
} : {};

InputLabel.defaultProps = {
  disabled: false,
  disableAnimation: false
};

InputLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputLabel' })(InputLabel);

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Grid = __webpack_require__(1982);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _createBreakpoints = __webpack_require__(188);

var _requirePropFactory = __webpack_require__(1983);

var _requirePropFactory2 = _interopRequireDefault(_requirePropFactory);

var _Hidden = __webpack_require__(842);

var _Hidden2 = _interopRequireDefault(_Hidden);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GUTTERS = [0, 8, 16, 24, 40]; // A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/

var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  // For the auto layouting
  var styles = (0, _defineProperty3.default)({}, 'grid-' + breakpoint, {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  });

  GRID_SIZES.forEach(function (size) {
    if (typeof size === 'boolean') {
      // Skip the first one as handle above.
      return;
    }

    // Only keep 6 significant numbers.
    var width = Math.round(size / 12 * 10e6) / 10e4 + '%';

    /* eslint-disable max-len */
    // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
    /* eslint-enable max-len */
    styles['grid-' + breakpoint + '-' + size] = {
      flexBasis: width,
      maxWidth: width
    };
  });

  // No need for a media query for the first size.
  if (breakpoint === 'xs') {
    (0, _extends3.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};

  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles['spacing-' + breakpoint + '-' + spacing] = {
      margin: -spacing / 2,
      width: 'calc(100% + ' + spacing + 'px)',
      '& > $typeItem': {
        padding: spacing / 2
      }
    };
  });

  return styles;
}

// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
var styles = exports.styles = function styles(theme) {
  return (0, _extends3.default)({
    typeContainer: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    typeItem: {
      boxSizing: 'border-box',
      flex: '0 0 auto',
      margin: '0' // For instance, it's useful when used with a `figure` element.
    },
    zeroMinWidth: {
      minWidth: 0
    },
    'direction-xs-column': {
      flexDirection: 'column'
    },
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },
    'align-items-xs-center': {
      alignItems: 'center'
    },
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },
    'align-content-xs-center': {
      alignContent: 'center'
    },
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },
    'justify-xs-center': {
      justifyContent: 'center'
    },
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      hidden = props.hidden,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      zeroMinWidth = props.zeroMinWidth,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      other = (0, _objectWithoutProperties3.default)(props, ['alignContent', 'alignItems', 'classes', 'className', 'component', 'container', 'direction', 'hidden', 'item', 'justify', 'lg', 'md', 'zeroMinWidth', 'sm', 'spacing', 'wrap', 'xl', 'xs']);


  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeContainer, container), (0, _defineProperty3.default)(_classNames, classes.typeItem, item), (0, _defineProperty3.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty3.default)(_classNames, classes['spacing-xs-' + String(spacing)], container && spacing !== 0), (0, _defineProperty3.default)(_classNames, classes['direction-xs-' + String(direction)], direction !== Grid.defaultProps.direction), (0, _defineProperty3.default)(_classNames, classes['wrap-xs-' + String(wrap)], wrap !== Grid.defaultProps.wrap), (0, _defineProperty3.default)(_classNames, classes['align-items-xs-' + String(alignItems)], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty3.default)(_classNames, classes['align-content-xs-' + String(alignContent)], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty3.default)(_classNames, classes['justify-xs-' + String(justify)], justify !== Grid.defaultProps.justify), (0, _defineProperty3.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty3.default)(_classNames, classes['grid-xs-' + String(xs)], xs && xs !== true), (0, _defineProperty3.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty3.default)(_classNames, classes['grid-sm-' + String(sm)], sm && sm !== true), (0, _defineProperty3.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty3.default)(_classNames, classes['grid-md-' + String(md)], md && md !== true), (0, _defineProperty3.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty3.default)(_classNames, classes['grid-lg-' + String(lg)], lg && lg !== true), (0, _defineProperty3.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty3.default)(_classNames, classes['grid-xl-' + String(xl)], xl && xl !== true), _classNames), classNameProp);
  var gridProps = (0, _extends3.default)({ className: className }, other);

  if (hidden) {
    return _react2.default.createElement(
      _Hidden2.default,
      hidden,
      _react2.default.createElement(Component, gridProps)
    );
  }

  return _react2.default.createElement(Component, gridProps);
}

Grid.propTypes =  false ? {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes2.default.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes2.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  /**
   * If provided, will wrap with [Hidden](/api/hidden) component and given properties.
   */
  hidden: _propTypes2.default.object,
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes2.default.bool,
  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes2.default.oneOf(GUTTERS),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes2.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes2.default.bool
} : {};

Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  zeroMinWidth: false,
  spacing: 16,
  wrap: 'wrap'
};

// Add a wrapper component to generate some helper messages in the development
// environment.
/* eslint-disable react/no-multi-comp */
// eslint-disable-next-line import/no-mutable-exports
var GridWrapper = Grid;

if (false) {
  GridWrapper = function GridWrapper(props) {
    return _react2.default.createElement(Grid, props);
  };

  var requireProp = (0, _requirePropFactory2.default)('Grid');
  GridWrapper.propTypes = {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  };
}

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGrid' })(GridWrapper);

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

var requirePropFactory = function requirePropFactory(componentNameInError) {
  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error('The property `' + propFullNameSafe + '` of ' + ('`' + componentNameInError + '` must be used on `' + requiredProp + '`.'));
      }

      return null;
    };
  };
  return requireProp;
};

exports.default = requirePropFactory;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GridList = __webpack_require__(1985);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridList).default;
  }
});

var _GridListTile = __webpack_require__(1986);

Object.defineProperty(exports, 'GridListTile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridListTile).default;
  }
});

var _GridListTileBar = __webpack_require__(1987);

Object.defineProperty(exports, 'GridListTileBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridListTileBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
  }
};

function GridList(props) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      cols = props.cols,
      Component = props.component,
      spacing = props.spacing,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['cellHeight', 'children', 'classes', 'className', 'cols', 'component', 'spacing', 'style']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, classNameProp),
      style: (0, _extends3.default)({ margin: -spacing / 2 }, style)
    }, other),
    _react2.default.Children.map(children, function (currentChild) {
      var childCols = currentChild.props.cols || 1;
      var childRows = currentChild.props.rows || 1;

      return _react2.default.cloneElement(currentChild, {
        style: (0, _extends3.default)({
          width: 100 / cols * childCols + '%',
          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
          padding: spacing / 2
        }, currentChild.props.style)
      });
    })
  );
}

GridList.propTypes =  false ? {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
  /**
   * Grid Tiles that will be in Grid List.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Number of columns.
   */
  cols: _propTypes2.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Number of px for the spacing between tiles.
   */
  spacing: _propTypes2.default.number,
  /**
   * @ignore
   */
  style: _propTypes2.default.object
} : {};

GridList.defaultProps = {
  cellHeight: 180,
  cols: 2,
  component: 'ul',
  spacing: 4
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridList' })(GridList);

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(160);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },
  tile: {
    position: 'relative',
    display: 'block', // In case it's not renderd with a div.
    height: '100%',
    overflow: 'hidden'
  },
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var GridListTile = function (_React$Component) {
  (0, _inherits3.default)(GridListTile, _React$Component);

  function GridListTile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GridListTile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GridListTile.__proto__ || (0, _getPrototypeOf2.default)(GridListTile)).call.apply(_ref, [this].concat(args))), _this), _this.imgElement = null, _this.handleResize = (0, _debounce2.default)(function () {
      _this.fit();
    }, 166), _this.fit = function () {
      var imgElement = _this.imgElement;

      if (!imgElement) {
        return;
      }

      if (!imgElement.complete) {
        return;
      }

      if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
        var _imgElement$classList, _imgElement$classList2;

        (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray3.default)(_this.props.classes.imgFullWidth.split(' ')));
        (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray3.default)(_this.props.classes.imgFullHeight.split(' ')));
      } else {
        var _imgElement$classList3, _imgElement$classList4;

        (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray3.default)(_this.props.classes.imgFullHeight.split(' ')));
        (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray3.default)(_this.props.classes.imgFullWidth.split(' ')));
      }

      imgElement.removeEventListener('load', _this.fit);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GridListTile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureImageCover();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureImageCover();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    } // Corresponds to 10 frames at 60 Hz.

  }, {
    key: 'ensureImageCover',
    value: function ensureImageCover() {
      if (!this.imgElement) {
        return;
      }

      if (this.imgElement.complete) {
        this.fit();
      } else {
        this.imgElement.addEventListener('load', this.fit);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          cols = _props.cols,
          Component = _props.component,
          rows = _props.rows,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'cols', 'component', 'rows']);


      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement(
          'div',
          { className: classes.tile },
          _react2.default.Children.map(children, function (child) {
            if (child && child.type === 'img') {
              return _react2.default.cloneElement(child, {
                key: 'img',
                ref: function ref(node) {
                  _this2.imgElement = node;
                }
              });
            }

            return child;
          })
        )
      );
    }
  }]);
  return GridListTile;
}(_react2.default.Component);

GridListTile.propTypes =  false ? {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Width of the tile in number of grid cells.
   */
  cols: _propTypes2.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Height of the tile in number of grid cells.
   */
  rows: _propTypes2.default.number
} : {};

GridListTile.defaultProps = {
  cols: 1,
  component: 'li',
  rows: 1
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridListTile' })(GridListTile);

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },
    titlePositionBottom: {
      bottom: 0
    },
    titlePositionTop: {
      top: 0
    },
    rootSubtitle: {
      height: 68
    },
    titleWrap: {
      flexGrow: 1,
      marginLeft: theme.mixins.gutters().paddingLeft,
      marginRight: theme.mixins.gutters().paddingRight,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },
    titleWrapActionPosLeft: {
      marginLeft: 0
    },
    titleWrapActionPosRight: {
      marginRight: 0
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    actionIcon: {},
    actionIconActionPosLeft: {
      order: -1
    }
  };
};

function GridListTileBar(props) {
  var _classNames, _classNames2;

  var actionIcon = props.actionIcon,
      actionPosition = props.actionPosition,
      classes = props.classes,
      classNameProp = props.className,
      subtitle = props.subtitle,
      title = props.title,
      titlePosition = props.titlePosition,
      other = (0, _objectWithoutProperties3.default)(props, ['actionIcon', 'actionPosition', 'classes', 'className', 'subtitle', 'title', 'titlePosition']);


  var actionPos = actionIcon && actionPosition;
  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.titlePositionBottom, titlePosition === 'bottom'), (0, _defineProperty3.default)(_classNames, classes.titlePositionTop, titlePosition === 'top'), (0, _defineProperty3.default)(_classNames, classes.rootSubtitle, subtitle), _classNames), classNameProp);

  // Remove the margin between the title / subtitle wrapper, and the Action Icon
  var titleWrapClassName = (0, _classnames2.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.titleWrapActionPosLeft, actionPos === 'left'), (0, _defineProperty3.default)(_classNames2, classes.titleWrapActionPosRight, actionPos === 'right'), _classNames2));

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.createElement(
      'div',
      { className: titleWrapClassName },
      _react2.default.createElement(
        'div',
        { className: classes.title },
        title
      ),
      subtitle ? _react2.default.createElement(
        'div',
        { className: classes.subtitle },
        subtitle
      ) : null
    ),
    actionIcon ? _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)(classes.actionIcon, (0, _defineProperty3.default)({}, classes.actionIconActionPosLeft, actionPos === 'left'))
      },
      actionIcon
    ) : null
  );
}

GridListTileBar.propTypes =  false ? {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: _propTypes2.default.node,
  /**
   * Position of secondary action IconButton.
   */
  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes2.default.node,
  /**
   * Title to be displayed on tile.
   */
  title: _propTypes2.default.node,
  /**
   * Position of the title bar.
   */
  titlePosition: _propTypes2.default.oneOf(['top', 'bottom'])
} : {};

GridListTileBar.defaultProps = {
  actionPosition: 'right',
  titlePosition: 'bottom'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridListTileBar' })(GridListTileBar);

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileStepper = __webpack_require__(1989);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MobileStepper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(160);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

var _helpers = __webpack_require__(35);

var _Progress = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: theme.spacing.unit
    },
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    positionStatic: {},
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: theme.spacing.unit,
      height: theme.spacing.unit,
      margin: '0 2px'
    },
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },
    progress: {
      width: '50%'
    }
  };
}; // @inheritedComponent Paper

function MobileStepper(props) {
  var activeStep = props.activeStep,
      backButton = props.backButton,
      classes = props.classes,
      classNameProp = props.className,
      nextButton = props.nextButton,
      position = props.position,
      steps = props.steps,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['activeStep', 'backButton', 'classes', 'className', 'nextButton', 'position', 'steps', 'variant']);


  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalize)(position)], classNameProp);

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, elevation: 0, className: className }, other),
    backButton,
    variant === 'dots' && _react2.default.createElement(
      'div',
      { className: classes.dots },
      [].concat((0, _toConsumableArray3.default)(new Array(steps))).map(function (_, step) {
        var dotClassName = (0, _classnames2.default)(classes.dot, (0, _defineProperty3.default)({}, classes.dotActive, step === activeStep));
        // eslint-disable-next-line react/no-array-index-key
        return _react2.default.createElement('div', { key: step, className: dotClassName });
      })
    ),
    variant === 'progress' && _react2.default.createElement(_Progress.LinearProgress, {
      className: classes.progress,
      variant: 'determinate',
      value: Math.ceil(activeStep / (steps - 1) * 100)
    }),
    nextButton
  );
}

MobileStepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: _propTypes2.default.number,
  /**
   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  backButton: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  nextButton: _propTypes2.default.node,
  /**
   * Set the positioning type.
   */
  position: _propTypes2.default.oneOf(['bottom', 'top', 'static']),
  /**
   * The total steps.
   */
  steps: _propTypes2.default.number.isRequired,
  /**
   * The type of mobile stepper to use.
   */
  variant: _propTypes2.default.oneOf(['text', 'dots', 'progress'])
} : {};

MobileStepper.defaultProps = {
  activeStep: 0,
  position: 'bottom',
  variant: 'dots'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMobileStepper' })(MobileStepper);

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__(1991);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Radio).default;
  }
});

var _RadioGroup = __webpack_require__(1994);

Object.defineProperty(exports, 'RadioGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = __webpack_require__(414);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

var _RadioButtonChecked = __webpack_require__(1992);

var _RadioButtonChecked2 = _interopRequireDefault(_RadioButtonChecked);

var _RadioButtonUnchecked = __webpack_require__(1993);

var _RadioButtonUnchecked2 = _interopRequireDefault(_RadioButtonUnchecked);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    default: {
      color: theme.palette.text.secondary
    },
    checked: {},
    checkedPrimary: {
      color: theme.palette.primary.main
    },
    checkedSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};

var _ref = _react2.default.createElement(_RadioButtonUnchecked2.default, null);

var _ref2 = _react2.default.createElement(_RadioButtonChecked2.default, null);

function Radio(props) {
  var _classNames;

  var classes = props.classes,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'color']);

  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
    type: 'radio',
    icon: _ref,
    checkedIcon: _ref2,
    classes: {
      default: classes.default,
      checked: checkedClass,
      disabled: classes.disabled
    }
  }, other));
}

Radio.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Radio.defaultProps = {
  color: 'secondary'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiRadio' })(Radio);

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });

var RadioButtonChecked = function RadioButtonChecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
RadioButtonChecked = (0, _pure2.default)(RadioButtonChecked);
RadioButtonChecked.muiName = 'SvgIcon';

exports.default = RadioButtonChecked;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });

var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
RadioButtonUnchecked = (0, _pure2.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';

exports.default = RadioButtonUnchecked;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = __webpack_require__(839);

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent FormGroup

var RadioGroup = function (_React$Component) {
  (0, _inherits3.default)(RadioGroup, _React$Component);

  function RadioGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.radios = [], _this.focus = function () {
      if (!_this.radios || !_this.radios.length) {
        return;
      }

      var focusRadios = _this.radios.filter(function (n) {
        return !n.disabled;
      });

      if (!focusRadios.length) {
        return;
      }

      var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
        return n.checked;
      });

      if (selectedRadio) {
        selectedRadio.focus();
        return;
      }

      focusRadios[0].focus();
    }, _this.handleRadioChange = function (event, checked) {
      if (checked && _this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RadioGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          name = _props.name,
          value = _props.value,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'value', 'onChange']);


      this.radios = [];

      return _react2.default.createElement(
        _FormGroup2.default,
        (0, _extends3.default)({ role: 'radiogroup' }, other),
        _react2.default.Children.map(children, function (child, index) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          return _react2.default.cloneElement(child, {
            key: index,
            name: name,
            inputRef: function inputRef(node) {
              if (node) {
                _this2.radios.push(node);
              }
            },
            checked: value === child.props.value,
            onChange: _this2.handleRadioChange
          });
        })
      );
    }
  }]);
  return RadioGroup;
}(_react2.default.Component);

RadioGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback
   * @param {string} value The `value` of the selected radio button
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * Value of the selected radio button.
   */
  value: _propTypes2.default.string
} : {};

exports.default = RadioGroup;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(160);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(87);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _ArrowDropDown = __webpack_require__(1996);

var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);

var _Menu = __webpack_require__(557);

var _Menu2 = _interopRequireDefault(_Menu);

var _Input = __webpack_require__(417);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var SelectInput = function (_React$Component) {
  (0, _inherits3.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectInput.__proto__ || (0, _getPrototypeOf2.default)(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.ignoreNextBlur = false, _this.displayNode = null, _this.isControlled = _this.props.open !== undefined, _this.update = _this.isControlled ? function (_ref2) {
      var event = _ref2.event,
          open = _ref2.open;

      if (open) {
        _this.props.onOpen(event);
      } else {
        _this.props.onClose(event);
      }
    } : function (_ref3) {
      var open = _ref3.open;
      return _this.setState({ open: open });
    }, _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;
      _this.update({
        open: true,
        event: event
      });
    }, _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    }, _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;


        if (onChange) {
          var value = void 0;
          var target = void 0;

          if (event.target) {
            target = event.target;
          }

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? [].concat((0, _toConsumableArray3.default)(_this.props.value)) : [];
            var itemIndex = value.indexOf(child.props.value);
            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = (0, _extends3.default)({}, target, { value: value, name: name });

          onChange(event, child);
        }
      };
    }, _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].indexOf((0, _keycode2.default)(event)) !== -1) {
        event.preventDefault();
        // Opening the menu is going to blur the. It will be focused back when closed.
        _this.ignoreNextBlur = true;
        _this.update({
          open: true,
          event: event
        });
      }
    }, _this.handleSelectRef = function (node) {
      if (!_this.props.inputRef) {
        return;
      }

      _this.props.inputRef({
        node: node,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SelectInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayNode.focus();
        // Rerender with the resolve `displayNode` reference.
        this.forceUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          disabled = _props.disabled,
          displayEmpty = _props.displayEmpty,
          inputRef = _props.inputRef,
          _props$MenuProps = _props.MenuProps,
          MenuProps = _props$MenuProps === undefined ? {} : _props$MenuProps,
          multiple = _props.multiple,
          name = _props.name,
          native = _props.native,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onOpen = _props.onOpen,
          openProp = _props.open,
          readOnly = _props.readOnly,
          renderValue = _props.renderValue,
          SelectDisplayProps = _props.SelectDisplayProps,
          tabIndexProp = _props.tabIndex,
          _props$type = _props.type,
          type = _props$type === undefined ? 'hidden' : _props$type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'classes', 'className', 'disabled', 'displayEmpty', 'inputRef', 'MenuProps', 'multiple', 'name', 'native', 'onBlur', 'onChange', 'onClose', 'onFocus', 'onOpen', 'open', 'readOnly', 'renderValue', 'SelectDisplayProps', 'tabIndex', 'type', 'value']);

      var open = this.isControlled && this.displayNode ? openProp : this.state.open;

      if (native) {
         false ? (0, _warning2.default)(multiple === false, 'Material-UI: you can not use the `native` and `multiple` properties ' + 'at the same time on a `Select` component.') : void 0;
         false ? (0, _warning2.default)(!renderValue, 'Material-UI: the `renderValue` property is not used by the native implementation.') : void 0;
         false ? (0, _warning2.default)(!displayEmpty, 'Material-UI: the `displayEmpty` property is not used by the native implementation.') : void 0;

        return _react2.default.createElement(
          'div',
          { className: classes.root },
          _react2.default.createElement(
            'select',
            (0, _extends3.default)({
              className: (0, _classnames2.default)(classes.select, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
              name: name,
              disabled: disabled,
              onBlur: onBlur,
              onChange: onChange,
              onFocus: onFocus,
              value: value,
              readOnly: readOnly,
              ref: inputRef
            }, other),
            children
          ),
          _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon })
        );
      }

      if (value === undefined) {
        throw new Error('Material-UI: the `value` property is required ' + 'when using the `Select` component with `native=false` (default).');
      }

      var display = void 0;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false;

      // No need to display any value if the field is empty.
      if ((0, _Input.isDirty)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react2.default.Children.map(children, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }
        var selected = void 0;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;
          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;
          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react2.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined, // The value is most likely not a valid HTML attribute.
          'data-value': value // Instead, we provide it as a data attribute.
        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      }

      var MenuMinWidth = this.displayNode && !autoWidth ? this.displayNode.clientWidth : undefined;

      var tabIndex = void 0;
      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react2.default.createElement(
        'div',
        { className: classes.root },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({
            className: (0, _classnames2.default)(classes.select, classes.selectMenu, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
            ref: function ref(node) {
              _this2.displayNode = node;
            },

            'aria-pressed': open ? 'true' : 'false',
            tabIndex: tabIndex,
            role: 'button',
            'aria-owns': open ? 'menu-' + (name || '') : null,
            'aria-haspopup': 'true',
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleBlur,
            onClick: disabled || readOnly ? null : this.handleClick,
            onFocus: onFocus
          }, SelectDisplayProps),
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: '&#8203' } }),
          display
        ),
        _react2.default.createElement('input', (0, _extends3.default)({
          value: Array.isArray(value) ? value.join(',') : value,
          name: name,
          readOnly: readOnly,
          ref: this.handleSelectRef,
          type: type
        }, other)),
        _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon }),
        _react2.default.createElement(
          _Menu2.default,
          (0, _extends3.default)({
            id: 'menu-' + (name || ''),
            anchorEl: this.displayNode,
            open: open,
            onClose: this.handleClose
          }, MenuProps, {
            MenuListProps: (0, _extends3.default)({
              role: 'listbox'
            }, MenuProps.MenuListProps),
            PaperProps: (0, _extends3.default)({}, MenuProps.PaperProps, {
              style: (0, _extends3.default)({
                minWidth: MenuMinWidth
              }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
            })
          }),
          items
        )
      );
    }
  }]);
  return SelectInput;
}(_react2.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The CSS class name of the select element.
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes2.default.func,
  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes2.default.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback
   * @param {object} child The react element that was selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes2.default.bool,
  /**
   * @ignore
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes2.default.func,
  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * @ignore
   */
  type: _propTypes2.default.string,
  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

exports.default = SelectInput;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' });

var ArrowDropDown = function ArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};

ArrowDropDown = (0, _pure2.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';

exports.default = ArrowDropDown;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends8 = __webpack_require__(4);

var _extends9 = _interopRequireDefault(_extends8);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _reactLifecyclesCompat = __webpack_require__(595);

var _reactLifecyclesCompat2 = _interopRequireDefault(_reactLifecyclesCompat);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _transitions = __webpack_require__(112);

var _ClickAwayListener = __webpack_require__(838);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _helpers = __webpack_require__(35);

var _Slide = __webpack_require__(372);

var _Slide2 = _interopRequireDefault(_Slide);

var _SnackbarContent = __webpack_require__(845);

var _SnackbarContent2 = _interopRequireDefault(_SnackbarContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var gutter = theme.spacing.unit * 3;
  var top = { top: 0 };
  var bottom = { bottom: 0 };
  var right = { justifyContent: 'flex-end' };
  var left = { justifyContent: 'flex-start' };
  var topSpace = { top: gutter };
  var bottomSpace = { bottom: gutter };
  var rightSpace = { right: gutter };
  var leftSpace = { left: gutter };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };

  return {
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },
    anchorOriginTopCenter: (0, _extends9.default)({}, top, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({}, center))),
    anchorOriginBottomCenter: (0, _extends9.default)({}, bottom, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({}, center))),
    anchorOriginTopRight: (0, _extends9.default)({}, top, right, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      left: 'auto'
    }, topSpace, rightSpace))),
    anchorOriginBottomRight: (0, _extends9.default)({}, bottom, right, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),
    anchorOriginTopLeft: (0, _extends9.default)({}, top, left, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      right: 'auto'
    }, topSpace, leftSpace))),
    anchorOriginBottomLeft: (0, _extends9.default)({}, bottom, left, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};

var Snackbar = function (_React$Component) {
  (0, _inherits3.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.timerAutoHide = null, _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
      _this.handlePause();
    }, _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
      _this.handleResume();
    }, _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    }, _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    }, _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration !== undefined) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);
          return;
        }
        _this.setAutoHideTimer((_this.props.autoHideDuration || 0) * 0.5);
      }
    }, _this.handleExited = function () {
      _this.setState({ exited: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    }

    // Timer that controls delay before snackbar auto hides

  }, {
    key: 'setAutoHideTimer',
    value: function setAutoHideTimer() {
      var _this2 = this;

      var autoHideDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.props.onClose || this.props.autoHideDuration == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        if (!_this2.props.onClose || _this2.props.autoHideDuration == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDuration || this.props.autoHideDuration || 0);
    }

    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.


    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          _props$anchorOrigin = _props.anchorOrigin,
          vertical = _props$anchorOrigin.vertical,
          horizontal = _props$anchorOrigin.horizontal,
          autoHideDuration = _props.autoHideDuration,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disableWindowBlurListener = _props.disableWindowBlurListener,
          message = _props.message,
          onClose = _props.onClose,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          onExiting = _props.onExiting,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          open = _props.open,
          resumeHideDuration = _props.resumeHideDuration,
          SnackbarContentProps = _props.SnackbarContentProps,
          TransitionProp = _props.transition,
          transitionDuration = _props.transitionDuration,
          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'anchorOrigin', 'autoHideDuration', 'children', 'classes', 'className', 'disableWindowBlurListener', 'message', 'onClose', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'onMouseEnter', 'onMouseLeave', 'open', 'resumeHideDuration', 'SnackbarContentProps', 'transition', 'transitionDuration']);

      // So we only render active snackbars.

      if (!open && this.state.exited) {
        return null;
      }

      var transitionProps = {};

      // The provided transition might not support the direction property.
      if (TransitionProp === _Slide2.default) {
        transitionProps.direction = vertical === 'top' ? 'down' : 'up';
      }

      return _react2.default.createElement(
        _reactEventListener2.default,
        {
          target: 'window',
          onFocus: disableWindowBlurListener ? undefined : this.handleResume,
          onBlur: disableWindowBlurListener ? undefined : this.handlePause
        },
        _react2.default.createElement(
          _ClickAwayListener2.default,
          { onClickAway: this.handleClickAway },
          _react2.default.createElement(
            'div',
            (0, _extends9.default)({
              className: (0, _classnames2.default)(classes.root, classes['anchorOrigin' + (0, _helpers.capitalize)(vertical) + (0, _helpers.capitalize)(horizontal)], className),
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }, other),
            _react2.default.createElement(
              TransitionProp,
              (0, _extends9.default)({
                appear: true,
                'in': open,
                onEnter: onEnter,
                onEntered: onEntered,
                onEntering: onEntering,
                onExit: onExit,
                onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
                onExiting: onExiting,
                timeout: transitionDuration
              }, transitionProps),
              children || _react2.default.createElement(_SnackbarContent2.default, (0, _extends9.default)({ message: message, action: action }, SnackbarContentProps))
            )
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.exited === 'undefined') {
        return {
          exited: !nextProps.open
        };
      }

      if (nextProps.open) {
        return {
          exited: false
        };
      }

      return null;
    }
  }]);
  return Snackbar;
}(_react2.default.Component);

Snackbar.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes2.default.node,
  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes2.default.number,
  /**
   * If you wish the take control over the children of the component you can use this property.
   * When used, you replace the `SnackbarContent` component with the children.
   */
  children: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: _propTypes2.default.bool,
  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes2.default.any,
  /**
   * The message to display.
   */
  message: _propTypes2.default.node,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes2.default.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes2.default.number,
  /**
   * Properties applied to the `SnackbarContent` element.
   */
  SnackbarContentProps: _propTypes2.default.object,
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  disableWindowBlurListener: false,
  transition: _Slide2.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiSnackbar' })((0, _reactLifecyclesCompat2.default)(Snackbar));

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stepper = __webpack_require__(1999);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Stepper).default;
  }
});

var _Step = __webpack_require__(2001);

Object.defineProperty(exports, 'Step', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Step).default;
  }
});

var _StepButton = __webpack_require__(2002);

Object.defineProperty(exports, 'StepButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepButton).default;
  }
});

var _StepContent = __webpack_require__(2005);

Object.defineProperty(exports, 'StepContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepContent).default;
  }
});

var _StepIcon = __webpack_require__(847);

Object.defineProperty(exports, 'StepIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepIcon).default;
  }
});

var _StepLabel = __webpack_require__(846);

Object.defineProperty(exports, 'StepLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Paper = __webpack_require__(85);

var _Paper2 = _interopRequireDefault(_Paper);

var _StepConnector = __webpack_require__(2000);

var _StepConnector2 = _interopRequireDefault(_StepConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Paper

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      padding: theme.spacing.unit * 3
    },
    horizontal: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    vertical: {
      flexDirection: 'column'
    },
    alternativeLabel: {
      alignItems: 'flex-start'
    }
  };
};

function Stepper(props) {
  var activeStep = props.activeStep,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      connectorProp = props.connector,
      nonLinear = props.nonLinear,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['activeStep', 'alternativeLabel', 'children', 'classes', 'className', 'connector', 'nonLinear', 'orientation']);


  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);

  var connector = _react2.default.isValidElement(connectorProp) ? _react2.default.cloneElement(connectorProp, { orientation: orientation }) : null;
  var childrenArray = _react2.default.Children.toArray(children);
  var steps = childrenArray.map(function (step, index) {
    var controlProps = {
      index: index,
      orientation: orientation,
      active: false,
      completed: false,
      disabled: false,
      last: index + 1 === childrenArray.length,
      alternativeLabel: alternativeLabel,
      connector: connectorProp
    };

    if (activeStep === index) {
      controlProps.active = true;
    } else if (!nonLinear && activeStep > index) {
      controlProps.completed = true;
    } else if (!nonLinear && activeStep < index) {
      controlProps.disabled = true;
    }

    return [!alternativeLabel && connector && index > 0 && _react2.default.cloneElement(connector, {
      key: index // eslint-disable-line react/no-array-index-key
    }), _react2.default.cloneElement(step, (0, _extends3.default)({}, controlProps, step.props))];
  });

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, elevation: 0, className: className }, other),
    steps
  );
}

Stepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes2.default.number,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A component to be placed between each step.
   */
  connector: _propTypes2.default.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes2.default.bool,
  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

Stepper.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  connector: _react2.default.createElement(_StepConnector2.default, null),
  nonLinear: false,
  orientation: 'horizontal'
};

Stepper.muiName = 'Stepper';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepper' })(Stepper);

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto'
    },
    horizontal: {},
    vertical: {
      marginLeft: 12, // half icon
      padding: '0 0 ' + theme.spacing.unit + 'px'
    },
    alternativeLabel: {
      position: 'absolute',
      top: theme.spacing.unit + 4,
      left: 'calc(50% + 20px)',
      right: 'calc(-50% + 20px)'
    },
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: theme.spacing.unit * 3
    }
  };
};

/**
 * @ignore - internal component.
 */
function StepConnector(props) {
  var _classNames2;

  var alternativeLabel = props.alternativeLabel,
      classNameProp = props.className,
      classes = props.classes,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['alternativeLabel', 'className', 'classes', 'orientation']);


  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var lineClassName = (0, _classnames2.default)(classes.line, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty3.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), _classNames2));

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.createElement('span', { className: lineClassName })
  );
}

StepConnector.propTypes =  false ? {
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to the component.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

StepConnector.defaultProps = {
  alternativeLabel: false,
  orientation: 'horizontal'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepConnector' })(StepConnector);

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {},
    horizontal: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0
      }
    },
    vertical: {},
    alternativeLabel: {
      flex: 1,
      position: 'relative'
    }
  };
};

function Step(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      connector = props.connector,
      disabled = props.disabled,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'connector', 'disabled', 'index', 'last', 'orientation']);


  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.Children.map(children, function (child) {
      return _react2.default.cloneElement(child, (0, _extends3.default)({
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        icon: index + 1,
        last: last,
        orientation: orientation
      }, child.props));
    }),
    connector && alternativeLabel && !last && _react2.default.cloneElement(connector, { orientation: orientation, alternativeLabel: alternativeLabel })
  );
}

Step.propTypes =  false ? {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   * Passed down from Stepper if alternativeLabel is also set.
   */
  connector: _propTypes2.default.element,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   * Used internally for numbering.
   */
  index: _propTypes2.default.number,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

Step.defaultProps = {
  active: false,
  completed: false,
  disabled: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStep' })(Step);

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _StepLabel = __webpack_require__(846);

var _StepLabel2 = _interopRequireDefault(_StepLabel);

var _reactHelpers = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      padding: theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 2 + 'px',
      margin: -theme.spacing.unit * 3 + 'px ' + -theme.spacing.unit * 2 + 'px',
      boxSizing: 'content-box'
    }
  };
}; // @inheritedComponent ButtonBase

function StepButton(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'disabled', 'icon', 'last', 'optional', 'orientation']);


  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react2.default.cloneElement(children, childProps) : _react2.default.createElement(
    _StepLabel2.default,
    childProps,
    children
  );

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({ disabled: disabled, className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
    child
  );
}

StepButton.propTypes =  false ? {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * The optional node to display.
   */
  optional: _propTypes2.default.node,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepButton' })(StepButton);

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z' });

var CheckCircle = function CheckCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckCircle = (0, _pure2.default)(CheckCircle);
CheckCircle.muiName = 'SvgIcon';

exports.default = CheckCircle;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.disabled
    },
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    }
  };
};

/**
 * @ignore - internal component.
 */

var _ref = _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12' });

function StepPositionIcon(props) {
  var position = props.position,
      classes = props.classes,
      className = props.className;


  return _react2.default.createElement(
    _SvgIcon2.default,
    { className: (0, _classnames2.default)(classes.root, className) },
    _ref,
    _react2.default.createElement(
      'text',
      { className: classes.text, x: '12', y: '16', textAnchor: 'middle' },
      position
    )
  );
}

StepPositionIcon.propTypes =  false ? {
  /**
   * Classses for component style customizations.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The step position as a number.
   */
  position: _propTypes2.default.node
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepPositionIcon' })(StepPositionIcon);

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Collapse = __webpack_require__(416);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing.unit,
      marginLeft: 12, // half icon
      paddingLeft: theme.spacing.unit + 12, // margin + half icon
      paddingRight: theme.spacing.unit,
      borderLeft: '1px solid ' + (theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },
    last: {
      borderLeft: 'none'
    },
    transition: {}
  };
};

function StepContent(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      Transition = props.transition,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'last', 'optional', 'orientation', 'transition', 'transitionDuration']);


   false ? (0, _warning2.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.last, last), className) }, other),
    _react2.default.createElement(
      Transition,
      {
        'in': active,
        className: classes.transition,
        timeout: transitionDuration,
        unmountOnExit: true
      },
      children
    )
  );
}

StepContent.propTypes =  false ? {
  /**
   * @ignore
   * Expands the content.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Step content.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional property.
   */
  optional: _propTypes2.default.bool,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  /**
   * Collapse component.
   */
  transition: _propTypes2.default.func,
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a property to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

StepContent.defaultProps = {
  transition: _Collapse2.default,
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepContent' })(StepContent);

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(340);

Object.defineProperty(exports, 'common', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_common).default;
  }
});

var _red = __webpack_require__(512);

Object.defineProperty(exports, 'red', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_red).default;
  }
});

var _pink = __webpack_require__(232);

Object.defineProperty(exports, 'pink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pink).default;
  }
});

var _purple = __webpack_require__(2007);

Object.defineProperty(exports, 'purple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_purple).default;
  }
});

var _deepPurple = __webpack_require__(546);

Object.defineProperty(exports, 'deepPurple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepPurple).default;
  }
});

var _indigo = __webpack_require__(338);

Object.defineProperty(exports, 'indigo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_indigo).default;
  }
});

var _blue = __webpack_require__(545);

Object.defineProperty(exports, 'blue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blue).default;
  }
});

var _lightBlue = __webpack_require__(543);

Object.defineProperty(exports, 'lightBlue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightBlue).default;
  }
});

var _cyan = __webpack_require__(542);

Object.defineProperty(exports, 'cyan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cyan).default;
  }
});

var _teal = __webpack_require__(544);

Object.defineProperty(exports, 'teal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_teal).default;
  }
});

var _green = __webpack_require__(354);

Object.defineProperty(exports, 'green', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_green).default;
  }
});

var _lightGreen = __webpack_require__(2008);

Object.defineProperty(exports, 'lightGreen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightGreen).default;
  }
});

var _lime = __webpack_require__(2009);

Object.defineProperty(exports, 'lime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lime).default;
  }
});

var _yellow = __webpack_require__(2010);

Object.defineProperty(exports, 'yellow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yellow).default;
  }
});

var _amber = __webpack_require__(355);

Object.defineProperty(exports, 'amber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_amber).default;
  }
});

var _orange = __webpack_require__(547);

Object.defineProperty(exports, 'orange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_orange).default;
  }
});

var _deepOrange = __webpack_require__(239);

Object.defineProperty(exports, 'deepOrange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepOrange).default;
  }
});

var _brown = __webpack_require__(2011);

Object.defineProperty(exports, 'brown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_brown).default;
  }
});

var _grey = __webpack_require__(339);

Object.defineProperty(exports, 'grey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_grey).default;
  }
});

var _blueGrey = __webpack_require__(2012);

Object.defineProperty(exports, 'blueGrey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blueGrey).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};

exports.default = purple;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};

exports.default = lightGreen;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};

exports.default = lime;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};

exports.default = yellow;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};

exports.default = brown;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};

exports.default = blueGrey;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Table = __webpack_require__(2014);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Table).default;
  }
});

var _TableBody = __webpack_require__(2015);

Object.defineProperty(exports, 'TableBody', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableBody).default;
  }
});

var _TableCell = __webpack_require__(848);

Object.defineProperty(exports, 'TableCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableCell).default;
  }
});

var _TableFooter = __webpack_require__(2016);

Object.defineProperty(exports, 'TableFooter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableFooter).default;
  }
});

var _TableHead = __webpack_require__(2017);

Object.defineProperty(exports, 'TableHead', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableHead).default;
  }
});

var _TablePagination = __webpack_require__(2018);

Object.defineProperty(exports, 'TablePagination', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TablePagination).default;
  }
});

var _TableRow = __webpack_require__(2020);

Object.defineProperty(exports, 'TableRow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableRow).default;
  }
});

var _TableSortLabel = __webpack_require__(2021);

Object.defineProperty(exports, 'TableSortLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableSortLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'table',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      overflow: 'hidden'
    }
  };
};

var Table = function (_React$Component) {
  (0, _inherits3.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck3.default)(this, Table);
    return (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).apply(this, arguments));
  }

  (0, _createClass3.default)(Table, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {}
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'component']);


      return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other));
    }
  }]);
  return Table;
}(_react2.default.Component);

Table.propTypes =  false ? {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

Table.defaultProps = {
  component: 'table'
};

Table.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTable' })(Table);

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'table-row-group'
  }
};

var TableBody = function (_React$Component) {
  (0, _inherits3.default)(TableBody, _React$Component);

  function TableBody() {
    (0, _classCallCheck3.default)(this, TableBody);
    return (0, _possibleConstructorReturn3.default)(this, (TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableBody, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          body: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'component']);


      return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other));
    }
  }]);
  return TableBody;
}(_react2.default.Component);

TableBody.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

TableBody.defaultProps = {
  component: 'tbody'
};

TableBody.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableBody' })(TableBody);

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableFooter = function (_React$Component) {
  (0, _inherits3.default)(TableFooter, _React$Component);

  function TableFooter() {
    (0, _classCallCheck3.default)(this, TableFooter);
    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableFooter, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          footer: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['component']);


      return _react2.default.createElement(Component, other);
    }
  }]);
  return TableFooter;
}(_react2.default.Component);

TableFooter.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes2.default.node,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

TableFooter.defaultProps = {
  component: 'tfoot'
};

TableFooter.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = TableFooter;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'table-header-group'
  }
};

var TableHead = function (_React$Component) {
  (0, _inherits3.default)(TableHead, _React$Component);

  function TableHead() {
    (0, _classCallCheck3.default)(this, TableHead);
    return (0, _possibleConstructorReturn3.default)(this, (TableHead.__proto__ || (0, _getPrototypeOf2.default)(TableHead)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableHead, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          head: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'component']);


      return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other));
    }
  }]);
  return TableHead;
}(_react2.default.Component);

TableHead.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

TableHead.defaultProps = {
  component: 'thead'
};

TableHead.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableHead' })(TableHead);

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(282);

var _Input2 = _interopRequireDefault(_Input);

var _Menu = __webpack_require__(203);

var _Select = __webpack_require__(843);

var _Select2 = _interopRequireDefault(_Select);

var _TableCell = __webpack_require__(848);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _Toolbar = __webpack_require__(137);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = __webpack_require__(58);

var _Typography2 = _interopRequireDefault(_Typography);

var _TablePaginationActions = __webpack_require__(2019);

var _TablePaginationActions2 = _interopRequireDefault(_TablePaginationActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent TableCell

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },
    toolbar: {
      height: 56,
      minHeight: 56,
      paddingRight: 2
    },
    spacer: {
      flex: '1 1 100%'
    },
    caption: {
      flexShrink: 0
    },
    input: {
      fontSize: 'inherit',
      flexShrink: 0
    },
    selectRoot: {
      marginRight: theme.spacing.unit * 4,
      marginLeft: theme.spacing.unit,
      color: theme.palette.text.secondary
    },
    select: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit * 2
    },
    selectIcon: {
      top: 1
    },
    actions: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing.unit * 2.5
    }
  };
};

/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination = function (_React$Component) {
  (0, _inherits3.default)(TablePagination, _React$Component);

  function TablePagination() {
    (0, _classCallCheck3.default)(this, TablePagination);
    return (0, _possibleConstructorReturn3.default)(this, (TablePagination.__proto__ || (0, _getPrototypeOf2.default)(TablePagination)).apply(this, arguments));
  }

  (0, _createClass3.default)(TablePagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var count = nextProps.count,
          onChangePage = nextProps.onChangePage,
          rowsPerPage = nextProps.rowsPerPage;

      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
      if (this.props.page > newLastPage) {
        onChangePage(null, newLastPage);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Actions = _props.Actions,
          backIconButtonProps = _props.backIconButtonProps,
          classes = _props.classes,
          colSpanProp = _props.colSpan,
          Component = _props.component,
          count = _props.count,
          labelDisplayedRows = _props.labelDisplayedRows,
          labelRowsPerPage = _props.labelRowsPerPage,
          nextIconButtonProps = _props.nextIconButtonProps,
          onChangePage = _props.onChangePage,
          onChangeRowsPerPage = _props.onChangeRowsPerPage,
          page = _props.page,
          rowsPerPage = _props.rowsPerPage,
          rowsPerPageOptions = _props.rowsPerPageOptions,
          other = (0, _objectWithoutProperties3.default)(_props, ['Actions', 'backIconButtonProps', 'classes', 'colSpan', 'component', 'count', 'labelDisplayedRows', 'labelRowsPerPage', 'nextIconButtonProps', 'onChangePage', 'onChangeRowsPerPage', 'page', 'rowsPerPage', 'rowsPerPageOptions']);


      var colSpan = void 0;

      if (Component === _TableCell2.default || Component === 'td') {
        colSpan = colSpanProp || 1000; // col-span over everything
      }

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: classes.root, colSpan: colSpan }, other),
        _react2.default.createElement(
          _Toolbar2.default,
          { className: classes.toolbar },
          _react2.default.createElement('div', { className: classes.spacer }),
          rowsPerPageOptions.length > 1 && _react2.default.createElement(
            _Typography2.default,
            { variant: 'caption', className: classes.caption },
            labelRowsPerPage
          ),
          rowsPerPageOptions.length > 1 && _react2.default.createElement(
            _Select2.default,
            {
              classes: {
                root: classes.selectRoot,
                select: classes.select,
                icon: classes.selectIcon
              },
              input: _react2.default.createElement(_Input2.default, { className: classes.input, disableUnderline: true }),
              value: rowsPerPage,
              onChange: onChangeRowsPerPage
            },
            rowsPerPageOptions.map(function (rowsPerPageOption) {
              return _react2.default.createElement(
                _Menu.MenuItem,
                { key: rowsPerPageOption, value: rowsPerPageOption },
                rowsPerPageOption
              );
            })
          ),
          _react2.default.createElement(
            _Typography2.default,
            { variant: 'caption', className: classes.caption },
            labelDisplayedRows({
              from: count === 0 ? 0 : page * rowsPerPage + 1,
              to: Math.min(count, (page + 1) * rowsPerPage),
              count: count,
              page: page
            })
          ),
          _react2.default.createElement(Actions, {
            backIconButtonProps: backIconButtonProps,
            count: count,
            nextIconButtonProps: nextIconButtonProps,
            onChangePage: onChangePage,
            page: page,
            rowsPerPage: rowsPerPage
          })
        )
      );
    }
  }]);
  return TablePagination;
}(_react2.default.Component);

TablePagination.propTypes =  false ? {
  /**
   * The component used for displaying the actions.
   * Either a string to use a DOM element or a component.
   */
  Actions: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the back arrow `IconButton` component.
   */
  backIconButtonProps: _propTypes2.default.object,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  colSpan: _propTypes2.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The total number of rows.
   */
  count: _propTypes2.default.number.isRequired,
  /**
   * Useful to customize the displayed rows label.
   */
  labelDisplayedRows: _propTypes2.default.func,
  /**
   * Useful to customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelRowsPerPage: _propTypes2.default.node,
  /**
   * Properties applied to the next arrow `IconButton` component.
   */
  nextIconButtonProps: _propTypes2.default.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes2.default.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChangeRowsPerPage: _propTypes2.default.func,
  /**
   * The zero-based index of the current page.
   */
  page: _propTypes2.default.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes2.default.number.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes2.default.array
} : {};

TablePagination.defaultProps = {
  Actions: _TablePaginationActions2.default,
  component: _TableCell2.default,
  labelDisplayedRows: function labelDisplayedRows(_ref) {
    var from = _ref.from,
        to = _ref.to,
        count = _ref.count;
    return from + '-' + to + ' of ' + count;
  },
  labelRowsPerPage: 'Rows per page:',
  rowsPerPageOptions: [5, 10, 25]
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTablePagination' })(TablePagination);

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyboardArrowLeft = __webpack_require__(849);

var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);

var _KeyboardArrowRight = __webpack_require__(850);

var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = __webpack_require__(60);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing.unit * 2.5
    }
  };
};

/**
 * @ignore - internal component.
 */

var _ref2 = _react2.default.createElement(_KeyboardArrowRight2.default, null);

var _ref3 = _react2.default.createElement(_KeyboardArrowLeft2.default, null);

var _ref4 = _react2.default.createElement(_KeyboardArrowLeft2.default, null);

var _ref5 = _react2.default.createElement(_KeyboardArrowRight2.default, null);

var TablePaginationActions = function (_React$Component) {
  (0, _inherits3.default)(TablePaginationActions, _React$Component);

  function TablePaginationActions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TablePaginationActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TablePaginationActions.__proto__ || (0, _getPrototypeOf2.default)(TablePaginationActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    }, _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TablePaginationActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backIconButtonProps = _props.backIconButtonProps,
          classes = _props.classes,
          count = _props.count,
          nextIconButtonProps = _props.nextIconButtonProps,
          onChangePage = _props.onChangePage,
          page = _props.page,
          rowsPerPage = _props.rowsPerPage,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['backIconButtonProps', 'classes', 'count', 'nextIconButtonProps', 'onChangePage', 'page', 'rowsPerPage', 'theme']);


      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: classes.root }, other),
        _react2.default.createElement(
          _IconButton2.default,
          (0, _extends3.default)({
            onClick: this.handleBackButtonClick,
            disabled: page === 0
          }, backIconButtonProps),
          theme.direction === 'rtl' ? _ref2 : _ref3
        ),
        _react2.default.createElement(
          _IconButton2.default,
          (0, _extends3.default)({
            onClick: this.handleNextButtonClick,
            disabled: page >= Math.ceil(count / rowsPerPage) - 1
          }, nextIconButtonProps),
          theme.direction === 'rtl' ? _ref4 : _ref5
        )
      );
    }
  }]);
  return TablePaginationActions;
}(_react2.default.Component);

TablePaginationActions.propTypes =  false ? {
  /**
   * Properties applied to the back arrow `IconButton` component.
   */
  backIconButtonProps: _propTypes2.default.object,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The total number of rows.
   */
  count: _propTypes2.default.number.isRequired,
  /**
   * Properties applied to the next arrow `IconButton` component.
   */
  nextIconButtonProps: _propTypes2.default.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes2.default.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: _propTypes2.default.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes2.default.number.isRequired,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTablePaginationActions', withTheme: true })(TablePaginationActions);

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      verticalAlign: 'middle',
      '&:focus': {
        outline: 'none'
      }
    },
    head: {
      height: 56
    },
    footer: {
      height: 56
    },
    selected: {
      backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
      : 'rgba(255, 255, 255, 0.08)'
    },
    hover: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    }
  };
};

/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */
function TableRow(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'hover', 'selected']);
  var table = context.table;


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.head, table && table.head), (0, _defineProperty3.default)(_classNames, classes.footer, table && table.footer), (0, _defineProperty3.default)(_classNames, classes.hover, table && hover), (0, _defineProperty3.default)(_classNames, classes.selected, table && selected), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

TableRow.propTypes =  false ? {
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes2.default.bool,
  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes2.default.bool
} : {};

TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};

TableRow.contextTypes = {
  table: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableRow' })(TableRow);

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ArrowDownward = __webpack_require__(2022);

var _ArrowDownward2 = _interopRequireDefault(_ArrowDownward);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:hover': {
        color: theme.palette.text.primary
      },
      '&:focus': {
        color: theme.palette.text.primary
      }
    },
    active: {
      color: theme.palette.text.primary,
      '& $icon': {
        opacity: 1
      }
    },
    icon: {
      height: 16,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none',
      width: 16
    },
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};

/**
 * A button based label for placing inside `TableCell` for column sorting.
 */
// @inheritedComponent ButtonBase

function TableSortLabel(props) {
  var active = props.active,
      classes = props.classes,
      className = props.className,
      children = props.children,
      direction = props.direction,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'classes', 'className', 'children', 'direction']);


  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.active, active), className),
      component: 'span',
      disableRipple: true
    }, other),
    children,
    _react2.default.createElement(_ArrowDownward2.default, {
      className: (0, _classnames2.default)(classes.icon, classes['iconDirection' + (0, _helpers.capitalize)(direction)])
    })
  );
}

TableSortLabel.propTypes =  false ? {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: _propTypes2.default.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The current sort direction.
   */
  direction: _propTypes2.default.oneOf(['asc', 'desc'])
} : {};

TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableSortLabel' })(TableSortLabel);

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(52);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(46);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' });

var ArrowDownward = function ArrowDownward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};

ArrowDownward = (0, _pure2.default)(ArrowDownward);
ArrowDownward.muiName = 'SvgIcon';

exports.default = ArrowDownward;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(2024);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

var _Tab = __webpack_require__(2034);

Object.defineProperty(exports, 'Tab', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tab).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNan = __webpack_require__(515);

var _isNan2 = _interopRequireDefault(_isNan);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(118);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactScrollbarSize = __webpack_require__(2025);

var _reactScrollbarSize2 = _interopRequireDefault(_reactScrollbarSize);

var _normalizeScrollLeft = __webpack_require__(2028);

var _scroll = __webpack_require__(2029);

var _scroll2 = _interopRequireDefault(_scroll);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _TabIndicator = __webpack_require__(2032);

var _TabIndicator2 = _interopRequireDefault(_TabIndicator);

var _TabScrollButton = __webpack_require__(2033);

var _TabScrollButton2 = _interopRequireDefault(_TabScrollButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
    },
    flexContainer: {
      display: 'flex'
    },
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },
    scrollable: {
      overflowX: 'scroll'
    },
    centered: {
      justifyContent: 'center'
    },
    scrollButtons: {},
    scrollButtonsAuto: (0, _defineProperty3.default)({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    indicator: {}
  };
};

var Tabs = function (_React$Component) {
  (0, _inherits3.default)(Tabs, _React$Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indicatorStyle: {},
      scrollerStyle: {
        marginBottom: 0
      },
      showLeftScroll: false,
      showRightScroll: false,
      mounted: false
    }, _this.getConditionalElements = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          scrollable = _this$props.scrollable,
          scrollButtons = _this$props.scrollButtons,
          TabScrollButtonProp = _this$props.TabScrollButton,
          theme = _this$props.theme;

      var conditionalElements = {};
      conditionalElements.scrollbarSizeListener = scrollable ? _react2.default.createElement(_reactScrollbarSize2.default, {
        onLoad: _this.handleScrollbarSizeChange,
        onChange: _this.handleScrollbarSizeChange
      }) : null;

      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');

      conditionalElements.scrollButtonLeft = showScrollButtons ? _react2.default.createElement(TabScrollButtonProp, {
        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
        onClick: _this.handleLeftScrollClick,
        visible: _this.state.showLeftScroll,
        className: (0, _classnames2.default)(classes.scrollButtons, (0, _defineProperty3.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;

      conditionalElements.scrollButtonRight = showScrollButtons ? _react2.default.createElement(TabScrollButtonProp, {
        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
        onClick: _this.handleRightScrollClick,
        visible: _this.state.showRightScroll,
        className: (0, _classnames2.default)(classes.scrollButtons, (0, _defineProperty3.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;

      return conditionalElements;
    }, _this.getTabsMeta = function (value, direction) {
      var tabsMeta = void 0;
      if (_this.tabs) {
        var rect = _this.tabs.getBoundingClientRect();
        // create a new object with ClientRect class props + scrollLeft
        tabsMeta = {
          clientWidth: _this.tabs ? _this.tabs.clientWidth : 0,
          scrollLeft: _this.tabs ? _this.tabs.scrollLeft : 0,
          scrollLeftNormalized: _this.tabs ? (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, direction) : 0,
          scrollWidth: _this.tabs ? _this.tabs.scrollWidth : 0,
          left: rect.left,
          right: rect.right
        };
      }

      var tabMeta = void 0;
      if (_this.tabs && value !== false) {
        var children = _this.tabs.children[0].children;

        if (children.length > 0) {
          var tab = children[_this.valueToIndex[value]];
           false ? (0, _warning2.default)(tab, 'Material-UI: the value provided `' + value + '` is invalid') : void 0;
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }
      return { tabsMeta: tabsMeta, tabMeta: tabMeta };
    }, _this.tabs = undefined, _this.valueToIndex = {}, _this.handleResize = (0, _debounce2.default)(function () {
      _this.updateIndicatorState(_this.props);
      _this.updateScrollButtonState();
    }, 166), _this.handleLeftScrollClick = function () {
      if (_this.tabs) {
        _this.moveTabsScroll(-_this.tabs.clientWidth);
      }
    }, _this.handleRightScrollClick = function () {
      if (_this.tabs) {
        _this.moveTabsScroll(_this.tabs.clientWidth);
      }
    }, _this.handleScrollbarSizeChange = function (_ref2) {
      var scrollbarHeight = _ref2.scrollbarHeight;

      _this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    }, _this.handleTabsScroll = (0, _debounce2.default)(function () {
      _this.updateScrollButtonState();
    }, 166), _this.moveTabsScroll = function (delta) {
      var theme = _this.props.theme;


      if (_this.tabs) {
        var multiplier = theme.direction === 'rtl' ? -1 : 1;
        var nextScrollLeft = _this.tabs.scrollLeft + delta * multiplier;
        // Fix for Edge
        var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
        _scroll2.default.left(_this.tabs, invert * nextScrollLeft);
      }
    }, _this.scrollSelectedIntoView = function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          value = _this$props2.value;

      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta.tabsMeta,
          tabMeta = _this$getTabsMeta.tabMeta;

      if (!tabMeta || !tabsMeta) {
        return;
      }

      if (tabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);
        _scroll2.default.left(_this.tabs, nextScrollLeft);
      } else if (tabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);
        _scroll2.default.left(_this.tabs, _nextScrollLeft);
      }
    }, _this.updateScrollButtonState = function () {
      var _this$props3 = _this.props,
          scrollable = _this$props3.scrollable,
          scrollButtons = _this$props3.scrollButtons,
          theme = _this$props3.theme;


      if (_this.tabs && scrollable && scrollButtons !== 'off') {
        var _this$tabs = _this.tabs,
            scrollWidth = _this$tabs.scrollWidth,
            clientWidth = _this$tabs.clientWidth;

        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, theme.direction);

        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;

        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;

        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
          _this.setState({ showLeftScroll: showLeftScroll, showRightScroll: showRightScroll });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ mounted: true });
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.props.action) {
        this.props.action({
          updateIndicator: this.handleResize
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.updateScrollButtonState();

      // The index might have changed at the same time.
      // We need to check again the right indicator position.
      this.updateIndicatorState(this.props);

      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      this.handleTabsScroll.cancel();
    } // Corresponds to 10 frames at 60 Hz.

    // Corresponds to 10 frames at 60 Hz.

  }, {
    key: 'updateIndicatorState',
    value: function updateIndicatorState(props) {
      var theme = props.theme,
          value = props.value;

      var _getTabsMeta = this.getTabsMeta(value, theme.direction),
          tabsMeta = _getTabsMeta.tabsMeta,
          tabMeta = _getTabsMeta.tabMeta;

      var left = 0;

      if (tabMeta && tabsMeta) {
        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        left = tabMeta.left - tabsMeta.left + correction;
      }

      var indicatorStyle = {
        left: left,
        // May be wrong until the font is loaded.
        width: tabMeta ? tabMeta.width : 0
      };

      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !(0, _isNan2.default)(indicatorStyle.left) && !(0, _isNan2.default)(indicatorStyle.width)) {
        this.setState({ indicatorStyle: indicatorStyle });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames3,
          _this2 = this;

      var _props = this.props,
          action = _props.action,
          centered = _props.centered,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          fullWidth = _props.fullWidth,
          indicatorColor = _props.indicatorColor,
          onChange = _props.onChange,
          scrollable = _props.scrollable,
          scrollButtons = _props.scrollButtons,
          TabScrollButtonProp = _props.TabScrollButton,
          textColor = _props.textColor,
          theme = _props.theme,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'centered', 'children', 'classes', 'className', 'fullWidth', 'indicatorColor', 'onChange', 'scrollable', 'scrollButtons', 'TabScrollButton', 'textColor', 'theme', 'value']);


      var className = (0, _classnames2.default)(classes.root, classNameProp);
      var scrollerClassName = (0, _classnames2.default)(classes.scroller, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.fixed, !scrollable), (0, _defineProperty3.default)(_classNames3, classes.scrollable, scrollable), _classNames3));
      var flexContainerClassName = (0, _classnames2.default)(classes.flexContainer, (0, _defineProperty3.default)({}, classes.centered, centered && !scrollable));

      var indicator = _react2.default.createElement(_TabIndicator2.default, {
        style: this.state.indicatorStyle,
        className: classes.indicator,
        color: indicatorColor
      });

      this.valueToIndex = {};
      var childIndex = 0;
      var children = _react2.default.Children.map(childrenProp, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }

        var childValue = child.props.value || childIndex;
        _this2.valueToIndex[childValue] = childIndex;
        var selected = childValue === value;

        childIndex += 1;
        return _react2.default.cloneElement(child, {
          fullWidth: fullWidth,
          indicator: selected && !_this2.state.mounted && indicator,
          selected: selected,
          onChange: onChange,
          textColor: textColor,
          value: childValue
        });
      });

      var conditionalElements = this.getConditionalElements();

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: className }, other),
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        conditionalElements.scrollbarSizeListener,
        _react2.default.createElement(
          'div',
          { className: classes.flexContainer },
          conditionalElements.scrollButtonLeft,
          _react2.default.createElement(
            'div',
            {
              className: scrollerClassName,
              style: this.state.scrollerStyle,
              ref: function ref(node) {
                _this2.tabs = node;
              },
              role: 'tablist',
              onScroll: this.handleTabsScroll
            },
            _react2.default.createElement(
              'div',
              { className: flexContainerClassName },
              children
            ),
            this.state.mounted && indicator
          ),
          conditionalElements.scrollButtonRight
        )
      );
    }
  }]);
  return Tabs;
}(_react2.default.Component);

Tabs.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['secondary', 'primary'])]),
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes2.default.func,
  /**
   * True invokes scrolling properties and allow for horizontally scrolling
   * (or swiping) the tab bar.
   */
  scrollable: _propTypes2.default.bool,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes2.default.oneOf(['auto', 'on', 'off']),
  /**
   * The component used to render the scroll buttons.
   */
  TabScrollButton: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes2.default.oneOf(['secondary', 'primary', 'inherit']),
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes2.default.any
} : {};

Tabs.defaultProps = {
  centered: false,
  fullWidth: false,
  indicatorColor: 'secondary',
  scrollable: false,
  scrollButtons: 'auto',
  TabScrollButton: _TabScrollButton2.default,
  textColor: 'inherit'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabs', withTheme: true })(Tabs);

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollbarSize = __webpack_require__(2026);

var _ScrollbarSize2 = _interopRequireDefault(_ScrollbarSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ScrollbarSize2.default;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(88);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _stifle = __webpack_require__(2027);

var _stifle2 = _interopRequireDefault(_stifle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
	width: '100px',
	height: '100px',
	position: 'absolute',
	top: '-100000px',
	overflow: 'scroll',
	msOverflowStyle: 'scrollbar'
};

var ScrollbarSize = function (_Component) {
	(0, _inherits3.default)(ScrollbarSize, _Component);

	function ScrollbarSize() {
		var _ref;

		var _temp, _this, _ret;

		(0, _classCallCheck3.default)(this, ScrollbarSize);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollbarSize.__proto__ || (0, _getPrototypeOf2.default)(ScrollbarSize)).call.apply(_ref, [this].concat(args))), _this), _this.setMeasurements = function () {
			_this.scrollbarHeight = _this.node.offsetHeight - _this.node.clientHeight;
			_this.scrollbarWidth = _this.node.offsetWidth - _this.node.clientWidth;
		}, _this.handleResize = (0, _stifle2.default)(function () {
			var onChange = _this.props.onChange;


			var prevHeight = _this.scrollbarHeight;
			var prevWidth = _this.scrollbarWidth;
			_this.setMeasurements();
			if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
				onChange({ scrollbarHeight: _this.scrollbarHeight, scrollbarWidth: _this.scrollbarWidth });
			}
		}, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	}

	(0, _createClass3.default)(ScrollbarSize, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var onLoad = this.props.onLoad;


			if (onLoad) {
				this.setMeasurements();
				onLoad({ scrollbarHeight: this.scrollbarHeight, scrollbarWidth: this.scrollbarWidth });
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.handleResize.cancel();
		}
	}, {
		key: 'render',
		// Corresponds to 10 frames at 60 Hz.

		value: function render() {
			var _this2 = this;

			var onChange = this.props.onChange;


			return _react2.default.createElement(
				'div',
				null,
				onChange ? _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }) : null,
				_react2.default.createElement('div', {
					style: styles,
					ref: function ref(node) {
						_this2.node = node;
					}
				})
			);
		}
	}]);
	return ScrollbarSize;
}(_react.Component);

ScrollbarSize.defaultProps = {
	onLoad: null,
	onChange: null
};
exports.default = ScrollbarSize;

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = stifle;
function stifle (fn, wait) {
  if (typeof fn !== 'function' || typeof wait !== 'number') {
    throw new Error('stifle(fn, wait) -- expected a function and number of milliseconds, got (' + typeof fn + ', ' + typeof wait + ')');
  }

  var timer;    // Timer to fire after `wait` has elapsed
  var called;   // Keep track if it gets called during the `wait`

  var wrapper = function () {

    // Check if still "cooling down" from a previous call
    if (timer) {
      called = true;
    } else {
      // Start a timer to fire after the `wait` is over
      timer = setTimeout(afterWait, wait);
      // And call the wrapped function
      fn();
    }
  }

  // Add a cancel method, to kill any pending calls
  wrapper.cancel = function () {
    // Clear the called flag, or it would fire twice when called again later
    called = false;

    // Turn off the timer, so it won't fire after the wait expires
    if (timer) {
      clearTimeout(timer);
      timer = undefined;
    }
  }

  function afterWait() {
    // Empty out the timer
    timer = undefined;

    // If it was called during the `wait`, fire it again
    if (called) {
      called = false;
      wrapper();
    }
  }

  return wrapper;
}


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
exports._setScrollType = _setScrollType;
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
exports.detectScrollType = detectScrollType;
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}
exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

var raf = __webpack_require__(2030)
var E_NOSCROLL = new Error('Element already at target scroll position')
var E_CANCELLED = new Error('Scroll cancelled')
var min = Math.min

module.exports = {
  left: make('scrollLeft'),
  top: make('scrollTop')
}

function make (prop) {
  return function scroll (el, to, opts, cb) {
    opts = opts || {}

    if (typeof opts == 'function') cb = opts, opts = {}
    if (typeof cb != 'function') cb = noop

    var start = +new Date
    var from = el[prop]
    var ease = opts.ease || inOutSine
    var duration = !isNaN(opts.duration) ? +opts.duration : 350
    var cancelled = false

    return from === to ?
      cb(E_NOSCROLL, el[prop]) :
      raf(animate), cancel

    function cancel () {
      cancelled = true
    }

    function animate (timestamp) {
      if (cancelled) return cb(E_CANCELLED, el[prop])

      var now = +new Date
      var time = min(1, ((now - start) / duration))
      var eased = ease(time)

      el[prop] = (eased * (to - from)) + from

      time < 1 ? raf(animate) : raf(function () {
        cb(null, el[prop])
      })
    }
  }
}

function inOutSine (n) {
  return 0.5 * (1 - Math.cos(Math.PI * n))
}

function noop () {}


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2031)

/**
 * `requestAnimationFrame()`
 */

var request = global.requestAnimationFrame
  || global.webkitRequestAnimationFrame
  || global.mozRequestAnimationFrame
  || fallback

var prev = +new Date
function fallback (fn) {
  var curr = +new Date
  var ms = Math.max(0, 16 - (curr - prev))
  var req = setTimeout(fn, ms)
  return prev = curr, req
}

/**
 * `cancelAnimationFrame()`
 */

var cancel = global.cancelAnimationFrame
  || global.webkitCancelAnimationFrame
  || global.mozCancelAnimationFrame
  || clearTimeout

if (Function.prototype.bind) {
  request = request.bind(global)
  cancel = cancel.bind(global)
}

exports = module.exports = request
exports.cancel = cancel


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create(),
      willChange: 'left, width'
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    }
  };
};

/**
 * @ignore - internal component.
 */
function TabIndicator(props) {
  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      styleProp = props.style;

  var colorPredefined = ['primary', 'secondary'].indexOf(color) !== -1;
  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], colorPredefined), classNameProp);

  var style = colorPredefined ? styleProp : (0, _extends3.default)({}, styleProp, {
    backgroundColor: color
  });

  return _react2.default.createElement('span', { className: className, style: style });
}

TabIndicator.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['primary', 'secondary'])]),
  /**
   * @ignore
   * The style of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabIndicator' })(TabIndicator);

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _KeyboardArrowLeft = __webpack_require__(849);

var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);

var _KeyboardArrowRight = __webpack_require__(850);

var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: 'inherit',
      flex: '0 0 ' + theme.spacing.unit * 7 + 'px'
    }
  };
};

/**
 * @ignore - internal component.
 */

var _ref = _react2.default.createElement(_KeyboardArrowLeft2.default, null);

var _ref2 = _react2.default.createElement(_KeyboardArrowRight2.default, null);

function TabScrollButton(props) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      onClick = props.onClick,
      visible = props.visible,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'direction', 'onClick', 'visible']);


  var className = (0, _classnames2.default)(classes.root, classNameProp);

  if (!visible) {
    return _react2.default.createElement('div', { className: className });
  }

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({ className: className, onClick: onClick, tabIndex: -1 }, other),
    direction === 'left' ? _ref : _ref2
  );
}

TabScrollButton.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes2.default.func,
  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes2.default.bool
} : {};

TabScrollButton.defaultProps = {
  visible: true
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabScrollButton' })(TabScrollButton);

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _keys = __webpack_require__(113);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(8);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(7);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(86);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends4.default)({}, theme.typography.button, (0, _defineProperty3.default)({
      maxWidth: 264,
      position: 'relative',
      minWidth: 72,
      padding: 0,
      height: 48,
      flex: 'none',
      overflow: 'hidden'
    }, theme.breakpoints.up('md'), {
      minWidth: 160
    })),
    labelIcon: {
      height: 72
    },
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7
    },
    textColorPrimary: {
      color: theme.palette.text.secondary
    },
    textColorPrimarySelected: {
      color: theme.palette.primary.main
    },
    textColorPrimaryDisabled: {
      color: theme.palette.text.disabled
    },
    textColorSecondary: {
      color: theme.palette.text.secondary
    },
    textColorSecondarySelected: {
      color: theme.palette.secondary.main
    },
    textColorSecondaryDisabled: {
      color: theme.palette.text.disabled
    },
    textColorInheritSelected: {
      opacity: 1
    },
    textColorInheritDisabled: {
      opacity: 0.4
    },
    fullWidth: {
      flexGrow: 1
    },
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },
    labelContainer: (0, _defineProperty3.default)({
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12
    }, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing.unit * 3,
      paddingRight: theme.spacing.unit * 3
    }),
    label: (0, _defineProperty3.default)({
      fontSize: theme.typography.pxToRem(theme.typography.fontSize),
      whiteSpace: 'normal'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
    }),
    labelWrapped: (0, _defineProperty3.default)({}, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 2)
    })
  };
};

var Tab = function (_React$Component) {
  (0, _inherits3.default)(Tab, _React$Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      wrappedText: false
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;


      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    }, _this.label = undefined, _this.checkTextWrap = function () {
      if (_this.label) {
        var wrappedText = _this.label.getClientRects().length > 1;
        if (_this.state.wrappedText !== wrappedText) {
          _this.setState({ wrappedText: wrappedText });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tab, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkTextWrap();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.wrappedText === prevState.wrappedText) {
        /**
         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
         * font size still only requires one line.  This check will prevent an infinite render loop
         * fron occurring in that scenario.
         */
        this.checkTextWrap();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          icon = _props.icon,
          indicator = _props.indicator,
          labelProp = _props.label,
          onChange = _props.onChange,
          selected = _props.selected,
          styleProp = _props.style,
          textColor = _props.textColor,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'disabled', 'fullWidth', 'icon', 'indicator', 'label', 'onChange', 'selected', 'style', 'textColor', 'value']);


      var label = void 0;

      if (labelProp !== undefined) {
        label = _react2.default.createElement(
          'span',
          { className: classes.labelContainer },
          _react2.default.createElement(
            'span',
            {
              className: (0, _classnames2.default)(classes.label, (0, _defineProperty3.default)({}, classes.labelWrapped, this.state.wrappedText)),
              ref: function ref(node) {
                _this2.label = node;
              }
            },
            labelProp
          )
        );
      }

      var className = (0, _classnames2.default)(classes.root, classes['textColor' + (0, _helpers.capitalize)(textColor)], (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes['textColor' + (0, _helpers.capitalize)(textColor) + 'Disabled'], disabled), (0, _defineProperty3.default)(_classNames2, classes['textColor' + (0, _helpers.capitalize)(textColor) + 'Selected'], selected), (0, _defineProperty3.default)(_classNames2, classes.labelIcon, icon && label), (0, _defineProperty3.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);

      var style = {};

      if (textColor !== 'secondary' && textColor !== 'inherit') {
        style.color = textColor;
      }

      style = (0, _keys2.default)(style).length > 0 ? (0, _extends4.default)({}, style, styleProp) : styleProp;

      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends4.default)({
          focusRipple: true,
          className: className,
          style: style,
          role: 'tab',
          'aria-selected': selected,
          disabled: disabled
        }, other, {
          onClick: this.handleChange
        }),
        _react2.default.createElement(
          'span',
          { className: classes.wrapper },
          icon,
          label
        ),
        indicator
      );
    }
  }]);
  return Tab;
}(_react2.default.Component);

Tab.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the tab will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The icon element.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   * For server side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes2.default.node,
  /**
   * The label element.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  selected: _propTypes2.default.bool,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  textColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['secondary', 'primary', 'inherit'])]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes2.default.any
} : {};

Tab.defaultProps = {
  disabled: false,
  textColor: 'inherit'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTab' })(Tab);

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(24);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__(282);

var _Input2 = _interopRequireDefault(_Input);

var _FormControl = __webpack_require__(840);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormHelperText = __webpack_require__(841);

var _FormHelperText2 = _interopRequireDefault(_FormHelperText);

var _Select = __webpack_require__(844);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control)
 * - [InputLabel](/api/input-label)
 * - [Input](/api/input)
 * - [FormHelperText](/api/form-helper-text)
 *
 * If you wish to alter the properties applied to the native input, you can do as follow:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values direct to the components.
 * - using the underlying components directly as shown in the demos.
 */
function TextField(props) {
  var autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      error = props.error,
      FormHelperTextProps = props.FormHelperTextProps,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      multiline = props.multiline,
      name = props.name,
      onChange = props.onChange,
      placeholder = props.placeholder,
      required = props.required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      select = props.select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['autoComplete', 'autoFocus', 'children', 'className', 'defaultValue', 'disabled', 'error', 'FormHelperTextProps', 'fullWidth', 'helperText', 'id', 'InputLabelProps', 'inputProps', 'InputProps', 'inputRef', 'label', 'multiline', 'name', 'onChange', 'placeholder', 'required', 'rows', 'rowsMax', 'select', 'SelectProps', 'type', 'value']);


   false ? (0, _warning2.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;

  var helperTextId = helperText && id ? id + '-helper-text' : undefined;
  var InputComponent = _react2.default.createElement(_Input2.default, (0, _extends3.default)({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: disabled,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onChange: onChange,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps));

  return _react2.default.createElement(
    _FormControl2.default,
    (0, _extends3.default)({
      'aria-describedby': helperTextId,
      className: className,
      error: error,
      fullWidth: fullWidth,
      required: required
    }, other),
    label && _react2.default.createElement(
      _Input.InputLabel,
      (0, _extends3.default)({ htmlFor: id }, InputLabelProps),
      label
    ),
    select ? _react2.default.createElement(
      _Select2.default,
      (0, _extends3.default)({ value: value, input: InputComponent }, SelectProps),
      children
    ) : InputComponent,
    helperText && _react2.default.createElement(
      _FormHelperText2.default,
      (0, _extends3.default)({ id: helperTextId }, FormHelperTextProps),
      helperText
    )
  );
} // @inheritedComponent FormControl

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes2.default.string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * @ignore
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes2.default.string,
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * Properties applied to the `FormHelperText` element.
   */
  FormHelperTextProps: _propTypes2.default.object,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `InputLabel` element.
   */
  InputLabelProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes2.default.object,
  /**
   * Properties applied to the native `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * The label content.
   */
  label: _propTypes2.default.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChange: _propTypes2.default.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes2.default.string,
  /**
   * If `true`, the label is displayed as required.
   */
  required: _propTypes2.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes2.default.bool,
  /**
   * Properties applied to the `Select` element.
   */
  SelectProps: _propTypes2.default.object,
  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

TextField.defaultProps = {
  required: false,
  select: false
};

exports.default = TextField;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Slide = __webpack_require__(372);

Object.defineProperty(exports, 'Slide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slide).default;
  }
});

var _Grow = __webpack_require__(568);

Object.defineProperty(exports, 'Grow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grow).default;
  }
});

var _Fade = __webpack_require__(362);

Object.defineProperty(exports, 'Fade', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Fade).default;
  }
});

var _Collapse = __webpack_require__(416);

Object.defineProperty(exports, 'Collapse', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Collapse).default;
  }
});

var _Zoom = __webpack_require__(2037);

Object.defineProperty(exports, 'Zoom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Zoom).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(5);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(13);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(11);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(14);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(15);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(161);

var _Transition2 = _interopRequireDefault(_Transition);

var _transitions = __webpack_require__(112);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _utils = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Transition

var styles = {
  entering: {
    transform: 'scale(1)'
  },
  entered: {
    transform: 'scale(1)'
  }
};

/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](https://material-ui-next.com/demos/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom = function (_React$Component) {
  (0, _inherits3.default)(Zoom, _React$Component);

  function Zoom() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Zoom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Zoom.__proto__ || (0, _getPrototypeOf2.default)(Zoom)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (node) {
      var theme = _this.props.theme;

      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Zoom, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme']);


      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ appear: true, onEnter: this.handleEnter, onExit: this.handleExit }, other),
        function (state, childProps) {
          return _react2.default.cloneElement(children, (0, _extends3.default)({
            style: (0, _extends3.default)({
              transform: 'scale(0)'
            }, styles[state], style)
          }, childProps));
        }
      );
    }
  }]);
  return Zoom;
}(_react2.default.Component);

Zoom.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Zoom.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Zoom);

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _AsyncFunc = __webpack_require__(283);

var _AsyncFunc2 = _interopRequireDefault(_AsyncFunc);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Extensions = function Extensions(_ref) {
    var match = _ref.match;
    return _react2.default.createElement('div', { className: 'app-wrapper' }, _react2.default.createElement(_reactRouterDom.Switch, null, _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: match.url + '/', to: match.url + '/dnd' }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/dnd', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 2069));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/sweet-alert', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 2070));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/notification',
        component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 2071));
        }) })));
};

var _default = Extensions;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(Extensions, 'Extensions', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');

    __REACT_HOT_LOADER__.register(_AsyncFunc2, '_AsyncFunc2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');

    __REACT_HOT_LOADER__.register(Extensions, 'Extensions', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/extensions/index.js');
}();

;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ReactPlaceholder = __webpack_require__(2041);

var _ReactPlaceholder2 = _interopRequireDefault(_ReactPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReactPlaceholder2.default;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _placeholders = __webpack_require__(2042);

var placeholders = _interopRequireWildcard(_placeholders);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactPlaceholder = (_temp2 = _class = function (_React$Component) {
  _inherits(ReactPlaceholder, _React$Component);

  function ReactPlaceholder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlaceholder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlaceholder.__proto__ || Object.getPrototypeOf(ReactPlaceholder)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ready: _this.props.ready
    }, _this.getFiller = function () {
      var _this$props = _this.props,
          firstLaunchOnly = _this$props.firstLaunchOnly,
          children = _this$props.children,
          ready = _this$props.ready,
          className = _this$props.className,
          type = _this$props.type,
          customPlaceholder = _this$props.customPlaceholder,
          showLoadingAnimation = _this$props.showLoadingAnimation,
          rest = _objectWithoutProperties(_this$props, ['firstLaunchOnly', 'children', 'ready', 'className', 'type', 'customPlaceholder', 'showLoadingAnimation']);

      var classes = showLoadingAnimation ? ['show-loading-animation', className].filter(function (c) {
        return c;
      }).join(' ') : className;

      if (customPlaceholder && _react2.default.isValidElement(customPlaceholder)) {
        var mergedCustomClasses = [customPlaceholder.props.className, classes].filter(function (c) {
          return c;
        }).join(' ');
        return _react2.default.cloneElement(customPlaceholder, { className: mergedCustomClasses });
      } else if (customPlaceholder) {
        return customPlaceholder;
      }

      var Placeholder = placeholders[type];

      return _react2.default.createElement(Placeholder, _extends({}, rest, { className: classes }));
    }, _this.setNotReady = function () {
      var delay = _this.props.delay;


      if (delay > 0) {
        _this.timeout = setTimeout(function () {
          _this.setState({ ready: false });
        }, delay);
      } else {
        _this.setState({ ready: false });
      }
    }, _this.setReady = function () {
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }

      if (!_this.state.ready) {
        _this.setState({ ready: true });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlaceholder, [{
    key: 'render',
    value: function render() {
      return this.state.ready ? this.props.children : this.getFiller();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.firstLaunchOnly && this.state.ready && !nextProps.ready) {
        this.setNotReady();
      } else if (nextProps.ready) {
        this.setReady();
      }
    }
  }]);

  return ReactPlaceholder;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element]).isRequired,
  delay: _propTypes2.default.number,
  ready: _propTypes2.default.bool.isRequired,
  firstLaunchOnly: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['text', 'media', 'textRow', 'rect', 'round']),
  rows: _propTypes2.default.number,
  color: _propTypes2.default.string,
  showLoadingAnimation: _propTypes2.default.bool,
  customPlaceholder: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element])
}, _class.defaultProps = {
  delay: 0,
  type: 'text',
  color: '#CDCDCD'
}, _temp2);
exports.default = ReactPlaceholder;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.text = exports.rect = exports.round = exports.textRow = exports.MediaBlock = exports.TextBlock = exports.RectShape = exports.RoundShape = exports.TextRow = undefined;

var _TextRow2 = __webpack_require__(851);

var _TextRow3 = _interopRequireDefault(_TextRow2);

var _RoundShape2 = __webpack_require__(852);

var _RoundShape3 = _interopRequireDefault(_RoundShape2);

var _RectShape2 = __webpack_require__(2043);

var _RectShape3 = _interopRequireDefault(_RectShape2);

var _TextBlock2 = __webpack_require__(853);

var _TextBlock3 = _interopRequireDefault(_TextBlock2);

var _MediaBlock2 = __webpack_require__(2044);

var _MediaBlock3 = _interopRequireDefault(_MediaBlock2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TextRow = _TextRow3.default;
// import Card from 'Card';

exports.RoundShape = _RoundShape3.default;
exports.RectShape = _RectShape3.default;
exports.TextBlock = _TextBlock3.default;
exports.MediaBlock = _MediaBlock3.default;
var textRow = exports.textRow = _TextRow3.default;
var round = exports.round = _RoundShape3.default;
var rect = exports.rect = _RectShape3.default;
var text = exports.text = _TextBlock3.default;
var media = exports.media = _MediaBlock3.default;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RectShape = (_temp = _class = function (_React$Component) {
  _inherits(RectShape, _React$Component);

  function RectShape() {
    _classCallCheck(this, RectShape);

    return _possibleConstructorReturn(this, (RectShape.__proto__ || Object.getPrototypeOf(RectShape)).apply(this, arguments));
  }

  _createClass(RectShape, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color;


      var defaultStyle = {
        backgroundColor: color,
        width: '100%',
        height: '100%',
        marginRight: 10
      };

      var classes = ['rect-shape', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement('div', { className: classes, style: _extends({}, defaultStyle, style) });
    }
  }]);

  return RectShape;
}(_react2.default.Component), _class.propTypes = {
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
}, _temp);
exports.default = RectShape;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextBlock = __webpack_require__(853);

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _RoundShape = __webpack_require__(852);

var _RoundShape2 = _interopRequireDefault(_RoundShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaBlock = (_temp = _class = function (_React$Component) {
  _inherits(MediaBlock, _React$Component);

  function MediaBlock() {
    _classCallCheck(this, MediaBlock);

    return _possibleConstructorReturn(this, (MediaBlock.__proto__ || Object.getPrototypeOf(MediaBlock)).apply(this, arguments));
  }

  _createClass(MediaBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          color = _props.color,
          rows = _props.rows;


      var classes = ['media-block', className].filter(function (c) {
        return c;
      }).join(' ');

      return _react2.default.createElement(
        'div',
        { className: classes, style: _extends({}, style, { display: 'flex' }) },
        _react2.default.createElement(_RoundShape2.default, {
          color: color,
          style: { minHeight: 55, width: 55, minWidth: 55, marginRight: 10 }
        }),
        _react2.default.createElement(_TextBlock2.default, { color: color, rows: rows })
      );
    }
  }]);

  return MediaBlock;
}(_react2.default.Component), _class.propTypes = {
  rows: _propTypes2.default.number.isRequired,
  color: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _temp);
exports.default = MediaBlock;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2046);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./nprogress.css", function() {
			var newContent = require("!!../css-loader/index.js!./nprogress.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(115)(false);
// imports


// module
exports.push([module.i, "#nprogress{pointer-events:none}#nprogress .bar{background:#29d;position:fixed;z-index:1031;top:0;left:0;width:100%;height:2px}#nprogress .peg{display:block;position:absolute;right:0;width:100px;height:100%;box-shadow:0 0 10px #29d,0 0 5px #29d;opacity:1;-webkit-transform:rotate(3deg) translateY(-4px);-ms-transform:rotate(3deg) translateY(-4px);transform:rotate(3deg) translateY(-4px)}#nprogress .spinner{display:block;position:fixed;z-index:1031;top:15px;right:15px}#nprogress .spinner-icon{width:18px;height:18px;box-sizing:border-box;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:nprogress-spinner .4s linear infinite;animation:nprogress-spinner .4s linear infinite}.nprogress-custom-parent{overflow:hidden;position:relative}.nprogress-custom-parent #nprogress .bar,.nprogress-custom-parent #nprogress .spinner{position:absolute}@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes nprogress-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2048);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./reactPlaceholder.css", function() {
			var newContent = require("!!../../css-loader/index.js!./reactPlaceholder.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(115)(false);
// imports


// module
exports.push([module.i, ".show-loading-animation.rect-shape,.show-loading-animation .rect-shape,.show-loading-animation.round-shape,.show-loading-animation .round-shape,.show-loading-animation.text-row,.show-loading-animation .text-row{animation:react-placeholder-pulse 1.5s infinite}@keyframes react-placeholder-pulse{0%{opacity:.6}50%{opacity:1}to{opacity:.6}}", ""]);

// exports


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _AsyncFunc = __webpack_require__(283);

var _AsyncFunc2 = _interopRequireDefault(_AsyncFunc);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var Map = function Map(_ref) {
    var match = _ref.match;
    return _react2.default.createElement('div', { className: 'app-wrapper' }, _react2.default.createElement(_reactRouterDom.Switch, null, _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: match.url + '/', to: match.url + '/simple' }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/directions', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 2072));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/drawing', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 2073));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/event', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 2074));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/geo-location', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2075));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/kml', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 2076));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/clustering', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2077));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/overlay', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 2078));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/popup-info', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 2079));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/simple', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 2080));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/street-view', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 2081));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/styled', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2082));
        }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/traffic', component: (0, _AsyncFunc2.default)(function () {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 2083));
        }) })));
};

var _default = Map;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(Map, 'Map', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');

    __REACT_HOT_LOADER__.register(_AsyncFunc2, '_AsyncFunc2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');

    __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');

    __REACT_HOT_LOADER__.register(Map, 'Map', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');

    __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/map/index.js');
}();

;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _AsyncFunc = __webpack_require__(283);

var _AsyncFunc2 = _interopRequireDefault(_AsyncFunc);

function _interopRequireDefault(obj) {
       return obj && obj.__esModule ? obj : { default: obj };
}

var AppModule = function AppModule(_ref) {
       var match = _ref.match;
       return _react2.default.createElement('div', { className: 'app-wrapper h-100' }, _react2.default.createElement(_reactRouterDom.Switch, null, _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: match.url + '/', to: match.url + '/login-1' }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/login-1', component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 2084));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/login-2', component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 2085));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/login-with-stepper',
              component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 2086));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/sign-up-1', component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 2087));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/sign-up-2', component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 2088));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/forgot-password-1',
              component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 2089));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/forgot-password-2',
              component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 2090));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/lock-screen-1',
              component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 2091));
              }) }), _react2.default.createElement(_reactRouterDom.Route, { path: match.url + '/lock-screen-2',
              component: (0, _AsyncFunc2.default)(function () {
                     return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 2092));
              }) })));
};

var _default = AppModule;
exports.default = _default;
;

var _temp = function () {
       if (typeof __REACT_HOT_LOADER__ === 'undefined') {
              return;
       }

       __REACT_HOT_LOADER__.register(AppModule, 'AppModule', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');

       __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');
}();

;
;

var _temp2 = function () {
       if (typeof __REACT_HOT_LOADER__ === 'undefined') {
              return;
       }

       __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');

       __REACT_HOT_LOADER__.register(_AsyncFunc2, '_AsyncFunc2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');

       __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');

       __REACT_HOT_LOADER__.register(AppModule, 'AppModule', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');

       __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');

       __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/appModule/index.js');
}();

;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UAParser = __webpack_require__(5);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setStr = exports.setStr = function setStr(uaStr) {
    return UA.setUA(uaStr);
};
var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
    var nav = window.navigator;
    nav.__defineGetter__('userAgent', function () {
        return userAgent;
    });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = exports.isMobileOnly = exports.isWinPhone = exports.isTablet = exports.isSafari = exports.isOpera = exports.isMobile = exports.isIOS = exports.isIE = exports.isFirefox = exports.isChrome = exports.isBrowser = exports.isAndroid = exports.MobileOnlyView = exports.WinPhoneView = exports.IEView = exports.IOSView = exports.AndroidView = exports.TabletView = exports.BrowserView = exports.MobileView = undefined;

var _views = __webpack_require__(2);

var _detect = __webpack_require__(4);

var _detect2 = _interopRequireDefault(_detect);

var _selectors = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//detect
exports.MobileView = _views.MobileView;
exports.BrowserView = _views.BrowserView;
exports.TabletView = _views.TabletView;
exports.AndroidView = _views.AndroidView;
exports.IOSView = _views.IOSView;
exports.IEView = _views.IEView;
exports.WinPhoneView = _views.WinPhoneView;
exports.MobileOnlyView = _views.MobileOnlyView;
exports.isAndroid = _selectors.isAndroid;
exports.isBrowser = _selectors.isBrowser;
exports.isChrome = _selectors.isChrome;
exports.isFirefox = _selectors.isFirefox;
exports.isIE = _selectors.isIE;
exports.isIOS = _selectors.isIOS;
exports.isMobile = _selectors.isMobile;
exports.isOpera = _selectors.isOpera;
exports.isSafari = _selectors.isSafari;
exports.isTablet = _selectors.isTablet;
exports.isWinPhone = _selectors.isWinPhone;
exports.isMobileOnly = _selectors.isMobileOnly;
exports.deviceDetect = _detect2.default;

//selectors
//views

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var IEView = exports.IEView = function IEView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var IOSView = exports.IOSView = function IOSView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var MobileView = exports.MobileView = function MobileView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var TabletView = exports.TabletView = function TabletView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(props) {
    return props.device ? _react2.default.createElement(
        'div',
        { className: props.viewClassName, style: props.style },
        props.children
    ) : null;
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUaData = __webpack_require__(0);

var checkDeviceType = function checkDeviceType() {
    switch (_getUaData.device.type) {
        case 'mobile':
            return {
                isMobile: true
            };
        case 'tablet':
            return {
                isTablet: true
            };
        case undefined:
            return {
                isBrowser: true
            };
        default:
            return {
                isMobile: false,
                isTablet: false,
                isBrowser: false
            };
    };
};

var getCurrentBrowser = function getCurrentBrowser() {
    var name = _getUaData.browser.name;
    if (name === 'Chrome' || name === 'Firefox' || name === 'Opera' || name === 'Yandex' || name === 'Safari') {
        return true;
    } else {
        return false;
    }
};

var type = checkDeviceType();

var deviceDetect = function deviceDetect() {
    var isBrowser = type.isBrowser,
        isMobile = type.isMobile,
        isTablet = type.isTablet;

    if (isBrowser) {
        var result = {
            isBrowser: getCurrentBrowser(),
            browserMajorVersion: _getUaData.browser.major,
            browserFullVersion: _getUaData.browser.version,
            browserName: _getUaData.browser.name,
            engineName: _getUaData.engine.name || false,
            engineVersion: _getUaData.engine.version,
            osName: _getUaData.os.name,
            osVersion: _getUaData.os.version,
            userAgent: _getUaData.ua
        };
        return result;
    }

    if (isMobile || isTablet) {
        var _result = _extends({}, type, {
            vendor: _getUaData.device.vendor || "none",
            model: _getUaData.device.model || "none",
            os: _getUaData.os.name || "none",
            osVersion: _getUaData.os.version || "none",
            ua: _getUaData.ua || "none"
        });
        return _result;
    }
};

exports.default = deviceDetect;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.17",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge)\/((\d+)?[\w\.]+)/i],[NAME,VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w+)*/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],[[VENDOR,"ZTE"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?.+)\s+build/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android.+)[;\/].+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]+).*(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.]+\d)*/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(6)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = undefined;

var _getUaData = __webpack_require__(0);

var isMobileType = function isMobileType() {
    return _getUaData.device.type === 'mobile' ? true : false;
};

var isTabletType = function isTabletType() {
    return _getUaData.device.type === 'tablet' ? true : false;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
    switch (_getUaData.device.type) {
        case 'mobile':
            return true;
        case 'tablet':
            return true;
        default:
            return false;
    };
};

var isBrowserType = function isBrowserType() {
    return _getUaData.device.type === undefined ? true : false;
};

var isAndroidType = function isAndroidType() {
    return _getUaData.os.name === 'Android' ? true : false;
};

var isWinPhoneType = function isWinPhoneType() {
    return _getUaData.os.name === 'Windows Phone' ? true : false;
};

var isIOSType = function isIOSType() {
    return _getUaData.os.name === 'iOS' ? true : false;
};

var isChromeType = function isChromeType() {
    return _getUaData.browser.name === 'Chrome' ? true : false;
};

var isFirefoxType = function isFirefoxType() {
    return _getUaData.browser.name === 'Firefox' ? true : false;
};

var isSafariType = function isSafariType() {
    return _getUaData.browser.name === 'Safari' ? true : false;
};

var isOperaType = function isOperaType() {
    return _getUaData.browser.name === 'Opera' ? true : false;
};

var isIEType = function isIEType() {
    return _getUaData.browser.name === 'Internet Explorer' ? true : false;
};

var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();

/***/ })
/******/ ]);

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

var _reactRedux = __webpack_require__(30);

var _TextField = __webpack_require__(284);

var _TextField2 = _interopRequireDefault(_TextField);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactNotifications = __webpack_require__(78);

var _IntlMessages = __webpack_require__(145);

var _IntlMessages2 = _interopRequireDefault(_IntlMessages);

var _Progress = __webpack_require__(174);

var _CustomAuth = __webpack_require__(2053);

var _NewPasswordModal = __webpack_require__(2054);

var _NewPasswordModal2 = _interopRequireDefault(_NewPasswordModal);

var _userManager = __webpack_require__(117);

var _util = __webpack_require__(77);

var _awsManager = __webpack_require__(59);

var _appConstants = __webpack_require__(73);

var CONST = _interopRequireWildcard(_appConstants);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SignIn = function (_React$Component) {
  _inherits(SignIn, _React$Component);

  function SignIn() {
    _classCallCheck(this, SignIn);

    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this));

    _this.onNewPasswordChange = function (e) {
      _this.setState({
        newPassword: e.target.value
      });
    };

    _this.onConfirmPasswordChange = function (e) {
      _this.setState({
        confirmPassword: e.target.value
      });
    };

    _this.checkAndSetPassword = function () {
      if (_this.state.newPassword === _this.state.confirmPassword) {
        (0, _userManager.setFirstTimePassword)(_this.state.newPassword).then(function () {
          _reactNotifications.NotificationManager.success('Password successfully updated.');
        }, function (error) {
          _reactNotifications.NotificationManager.error(error.message);
        });
      } else {
        (0, _util.createNotification)('Password do not match.', 'Error', 'Error');
      }
    };

    _this.toggleToResetPassword = function () {
      $('#signin').toggleClass('d-none');
      $('#forgotPassword').toggleClass('d-none');
    };

    _this.getVerificationCode = function () {
      (0, _userManager.sendVerificationCode)(_this.state.username).then(function () {
        _reactNotifications.NotificationManager.success('Verification Code Sent on your Registered Email');
        _this.toggleResetPasswordFields();
        $('#backToSignIn').toggleClass('d-none');
      }, function (error) {
        _reactNotifications.NotificationManager.error(error.message);
        _this.setState({ isVerificationCodeButtonDisable: false });
      });
      _this.toggleButtonsState();
    };

    _this.toggleResetPasswordFields = function () {
      $('#resetPasswordFields').toggleClass('d-none');
      // $('#backToSignIn').toggleClass('d-none')
    };

    _this.toggleButtonsState = function () {
      _this.setState({

        isVerificationCodeButtonDisable: true,
        isResetPasswordButtonDisable: false,
        isUsernameResetFieldDisable: false,
        verificationCode: null,
        resetToNewPassword: null,
        confirmResetToNewPassword: null,
        username: null
      });
    };

    _this.resetPasswordFieldsToNull = function () {
      _this.setState({

        isUsernameResetFieldDisable: true,
        verificationCode: '',
        resetToNewPassword: '',
        confirmResetToNewPassword: ''

      });
    };

    _this.setNewPassword = function () {
      if (_this.state.resetToNewPassword === _this.state.confirmResetToNewPassword) {
        (0, _userManager.confirmResetPassword)(_this.state.verificationCode, _this.state.resetToNewPassword).then(function () {
          _reactNotifications.NotificationManager.success('Password successfully updated.');
          _this.resetToInitialState();
          _this.toggleToResetPassword();
          _this.toggleResetPasswordFields();
        }, function (error) {
          _reactNotifications.NotificationManager.error(error.message);
          _this.resetPasswordFieldsToNull();
          // this.resetToInitialState();
        });
      } else {
        (0, _util.createNotification)('Password do not match.', 'Error', 'Error');
        _this.resetPasswordFieldsToNull();
        // this.resetToInitialState();
      }
    };

    _this.resetToInitialState = function () {
      _this.setState({
        isVerificationCodeButtonDisable: false,
        isResetPasswordButtonDisable: true,
        isUsernameResetFieldDisable: false
      });
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.props.authenticate({
          username: _this.state.email,
          password: _this.state.password
        }, _this.props.profileInfo.themeToApply);
      }
    };

    _this.onNewPasswordChange.bind(_this);
    _this.onConfirmPasswordChange.bind(_this);
    _this.state = {
      email: '',
      password: '',
      newPassword: '',
      confirmPassword: '',
      verificationCode: '',
      resetToNewPassword: '',
      confirmResetToNewPassword: '',
      username: null,
      isVerificationCodeButtonDisable: false,
      isResetPasswordButtonDisable: true

    };
    return _this;
  }

  _createClass(SignIn, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.profileInfo.signedIn !== null) {
        this.props.history.push('/');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('.app-main').toggleClass('bg-wrapper');
      $('#signin').toggleClass('d-none');

      this.props.fetchTheme();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $('.app-main').toggleClass('bg-wrapper');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          email = _state.email,
          password = _state.password;
      var _props = this.props,
          showMessage = _props.showMessage,
          loader = _props.loader,
          alertMessage = _props.alertMessage;

      return _react2.default.createElement('div', {
        className: 'app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3',
        id: 'sign-in'
      }, _react2.default.createElement('div', { className: 'app-login-main-content' }, _react2.default.createElement('div', { className: 'app-logo-content d-flex align-items-center justify-content-center' }, _react2.default.createElement(_reactRouterDom.Link, { className: 'logo-lg', to: '/homePage' }, _react2.default.createElement('img', {
        className: 'img-responsive w-100',
        src: '/assets/images/Senstra_logo-2.png',
        alt: 'Symbiotic',
        title: 'Symbiotic'
      }))), _react2.default.createElement('div', { className: 'app-login-content' }, _react2.default.createElement('div', { className: 'app-login-header mb-4' }, _react2.default.createElement('h1', { className: 'text-dark', id: 'signin-header' }, ' Log - In ')), _react2.default.createElement('div', { className: 'app-login-form d-none active', id: 'signin' }, _react2.default.createElement('form', null, _react2.default.createElement('fieldset', null, _react2.default.createElement(_TextField2.default, {
        id: 'requiredEmail',
        label: 'Username',
        fullWidth: true,
        onChange: function onChange(event) {
          return _this2.setState({ email: event.target.value });
        },
        defaultValue: email,
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'password',
        id: 'requiredPassword',
        label: _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.password' }),
        fullWidth: true,
        onKeyPress: this.handleKeyPress.bind(this),
        onChange: function onChange(event) {
          return _this2.setState({ password: event.target.value });
        },
        defaultValue: password,
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement('div', { className: 'mb-3 d-flex align-items-center justify-content-between' }, _react2.default.createElement(_Button2.default, {
        onClick: function onClick() {
          // this.props.showAuthLoader();
          _this2.props.authenticate({
            username: _this2.state.email,
            password: _this2.state.password
          }, _this2.props.profileInfo.themeToApply);
        },
        variant: 'raised',
        color: 'primary'
      }, _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.signIn' }))), _react2.default.createElement('div', null, 'To get access to a complementary demo,', _react2.default.createElement('br', null), _react2.default.createElement('b', null, 'Email us at: '), 'iot@senstra.com.au')))), _react2.default.createElement('div', { className: 'app-login-form d-none', id: 'newPassword' }, _react2.default.createElement('form', null, _react2.default.createElement('fieldset', null, _react2.default.createElement(_TextField2.default, {
        type: 'password',
        id: 'newPassword',
        label: _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.password' }),
        fullWidth: true,
        onChange: function onChange(e) {
          _this2.onNewPasswordChange(e);
        },
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'password',
        id: 'confirmNewPassword',
        label: _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.password' }),
        fullWidth: true,
        onChange: function onChange(e) {
          _this2.onConfirmPasswordChange(e);
        },
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement(_Button2.default, { onClick: this.checkAndSetPassword, variant: 'raised', color: 'primary' }, 'Update Password')))), _react2.default.createElement('div', { className: 'app-login-form d-none', id: 'forgotPassword' }, _react2.default.createElement('form', null, _react2.default.createElement('fieldset', null, _react2.default.createElement(_TextField2.default, {
        id: 'user',
        label: 'Username',
        fullWidth: true,
        onChange: function onChange(event) {
          return _this2.setState({ username: event.target.value });
        },
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true,
        disabled: this.state.isUsernameResetFieldDisable
      }), _react2.default.createElement(_Button2.default, {
        onClick: this.getVerificationCode,
        disabled: this.state.isVerificationCodeButtonDisable,
        variant: 'raised',
        color: 'primary'
      }, 'Get Verification Code'), _react2.default.createElement(_reactRouterDom.Link, {
        className: 'float-right link-color ',
        to: '/',
        id: 'backToSignIn',
        onClick: this.toggleToResetPassword
      }, 'Sign In'), _react2.default.createElement('div', { className: 'd-none', id: 'resetPasswordFields' }, _react2.default.createElement(_TextField2.default, {
        id: 'verificationCode',
        label: 'Verification Code',
        fullWidth: true,
        value: this.state.verificationCode,
        onChange: function onChange(event) {
          return _this2.setState({ verificationCode: event.target.value });
        },
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'password',
        id: 'resetPassword',
        label: 'Reset Password',
        fullWidth: true,
        value: this.state.resetToNewPassword,
        onChange: function onChange(event) {
          return _this2.setState({ resetToNewPassword: event.target.value });
        },
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'password',
        id: 'confirmResetPassword',
        label: 'Confirm Reset Password',
        fullWidth: true,
        value: this.state.confirmResetToNewPassword,
        onChange: function onChange(event) {
          return _this2.setState({ confirmResetToNewPassword: event.target.value });
        },
        margin: 'normal',
        className: 'mt-1 my-sm-3',
        required: true
      }), _react2.default.createElement(_Button2.default, {
        onClick: this.setNewPassword,
        disabled: this.state.isResetPasswordButtonDisable,
        variant: 'raised',
        color: 'primary'
      }, 'Reset Password'), _react2.default.createElement(_reactRouterDom.Link, {
        className: 'float-right link-color text-nowrap',
        to: '/',
        onClick: this.toggleToResetPassword
      }, 'Sign In'))))))), loader && _react2.default.createElement('div', { className: 'loader-view' }, _react2.default.createElement(_Progress.CircularProgress, null)), showMessage && _reactNotifications.NotificationManager.error(alertMessage), _react2.default.createElement(_reactNotifications.NotificationContainer, null), _react2.default.createElement(_NewPasswordModal2.default, null));
    }
  }]);

  return SignIn;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var auth = _ref.auth,
      profileInfo = _ref.profileInfo;
  var loader = auth.loader,
      alertMessage = auth.alertMessage,
      showMessage = auth.showMessage,
      authUser = auth.authUser;

  return {
    loader: loader, alertMessage: alertMessage, showMessage: showMessage, authUser: authUser, profileInfo: profileInfo, cognitoUser: profileInfo.cognitoUser
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authenticate: function authenticate(payload, themeToApply) {
      dispatch((0, _CustomAuth.signIn)(payload, themeToApply));
    },
    fetchTheme: function fetchTheme() {
      (0, _awsManager.getThemeConfiguration)(CONST.USER_POOL_ID).then(function (data) {
        var content = data.themeID;
        var themeColor = JSON.parse(content).theme.name;
        var maPos = JSON.parse(data.layoutHeartbeat).maPosition;
        var layoutHeartbeat = JSON.parse(data.layoutHeartbeat).heartbeatData;
        var linkOfLogo = JSON.parse(data.link).link;
        var linkToLogo = data.linkToLogo;
        dispatch({ type: 'CHANGE_THEME_IN_STORE', color: themeColor });
        dispatch({ type: 'CHANGE_HEARTBEAT_LAYOUT', layout: layoutHeartbeat });
        dispatch({ type: 'CHANGE_HEARTBEAT_MA', isRight: maPos });
        dispatch({
          type: 'UPDATE_LOGO_AND_LINK',
          payload: {
            linkOfLogo: linkOfLogo,
            linkToLogo: linkToLogo
          }
        });
      }, function () {
        dispatch({ type: 'CHANGE_THEME_IN_STORE', color: 'indigo' });
        dispatch({ type: 'CHANGE_HEARTBEAT_MA', isRight: true });
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignIn);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SignIn, 'SignIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_TextField2, "_TextField2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_IntlMessages2, "_IntlMessages2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_NewPasswordModal2, "_NewPasswordModal2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(CONST, "CONST", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_interopRequireWildcard, "_interopRequireWildcard", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(SignIn, "SignIn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(mapDispatchToProps, "mapDispatchToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignIn.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.signIn = undefined;

var _userManager = __webpack_require__(117);

var _reactNotifications = __webpack_require__(78);

var signIn = exports.signIn = function signIn(credentials, themeToApply) {
    return function (dispatch) {
        (0, _userManager.authenticateUser)(credentials.username, credentials.password).then(function (data) {
            if (data.idToken.payload['cognito:groups']) {
                if (data.idToken.payload['cognito:groups'].includes('sym-admin')) {
                    dispatch({ type: "IS_ADMIN?", payload: true });
                } else {
                    dispatch({ type: "IS_ADMIN?", payload: false });
                }
            }

            if (themeToApply === 'dark_theme') {
                dispatch({ type: 'dark_theme' });
            } else {
                dispatch({ type: 'theme_color', color: themeToApply });
            }
            dispatch({ type: "SIGN_IN", payload: credentials, loginData: data.idToken.payload });
            (0, _userManager.getUserAttributes)().then(function (data) {
                dispatch({ type: "FETCHED_USER_ATTRIBUTES", payload: data });
            }, function (error) {
                console.log("Error Attributes", error);
            });
        }, function (error) {
            _reactNotifications.NotificationManager.error(error.message);
        });
    };
};
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(signIn, 'signIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/CustomAuth.js');
}();

;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(signIn, 'signIn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/CustomAuth.js');

    __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/actions/CustomAuth.js');
}();

;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userManager = __webpack_require__(117);

var _util = __webpack_require__(77);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var NewPasswordModal = function (_Component) {
  _inherits(NewPasswordModal, _Component);

  function NewPasswordModal(props) {
    _classCallCheck(this, NewPasswordModal);

    var _this = _possibleConstructorReturn(this, (NewPasswordModal.__proto__ || Object.getPrototypeOf(NewPasswordModal)).call(this, props));

    _this.onNewPasswordChange = function (e) {
      _this.setState({
        newPassword: e.target.value
      });
    };

    _this.onConfirmPasswordChange = function (e) {
      _this.setState({
        confirmPassword: e.target.value
      });
    };

    _this.checkAndSetPassword = function () {
      if (_this.state.newPassword === _this.state.confirmPassword) {
        (0, _userManager.setFirstTimePassword)(_this.state.newPassword, cognitoUser);
      } else {
        (0, _util.createNotification)('Password do not match.', 'Error', 'Error');
      }
    };

    _this.render = function () {
      return _react2.default.createElement('div', { className: 'modal fade profile-popupWrapper', id: 'newPasswordModal' }, _react2.default.createElement('div', { className: 'modal-dialog' }, _react2.default.createElement('div', { className: 'modal-content' }, _react2.default.createElement('div', { className: 'modal-header py-2' }, _react2.default.createElement('h4', { className: 'modal-title' }, 'Create New Password'), _react2.default.createElement('button', { type: 'button', className: 'close', 'data-dismiss': 'modal' }, '\xD7 ', _react2.default.createElement('p', null, 'Close'))), _react2.default.createElement('div', { className: 'modal-body' }, _react2.default.createElement('div', { className: 'row' }, _react2.default.createElement('div', { className: 'col-3 profile-img pb-3' }, _react2.default.createElement('img', { src: '../../../../../assets/images/profile-img1.png', alt: 'profile-img' })), _react2.default.createElement('div', { className: 'col-9 profile-detail pt-4' }, _react2.default.createElement('table', { className: 'table' }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'New password'), _react2.default.createElement('td', null, _react2.default.createElement('input', { type: 'password', onChange: function onChange(e) {
          _this.onNewPasswordChange(e);
        } }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null, 'Confirm password'), _react2.default.createElement('td', null, _react2.default.createElement('input', { type: 'password', onChange: function onChange(e) {
          _this.onConfirmPasswordChange(e);
        } }))), _react2.default.createElement('tr', null, _react2.default.createElement('td', null), _react2.default.createElement('td', null, _react2.default.createElement('button', { onClick: _this.checkAndSetPassword, className: 'btn btn-success' }, 'Update Password')))))))))));
    };

    _this.onNewPasswordChange.bind(_this);
    _this.onConfirmPasswordChange.bind(_this);
    _this.state = {
      newPassword: null,
      confirmPassword: null
    };
    return _this;
  }

  return NewPasswordModal;
}(_react.Component);

var _default = NewPasswordModal;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(NewPasswordModal, 'NewPasswordModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_react2, '_react2', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_interopRequireDefault, '_interopRequireDefault', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_classCallCheck, '_classCallCheck', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, '_possibleConstructorReturn', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_inherits, '_inherits', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(NewPasswordModal, 'NewPasswordModal', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_default, '_default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');

  __REACT_HOT_LOADER__.register(_temp, '_temp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/NewPasswordModal/NewPasswordModal.js');
}();

;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(30);

var _TextField = __webpack_require__(284);

var _TextField2 = _interopRequireDefault(_TextField);

var _Button = __webpack_require__(48);

var _Button2 = _interopRequireDefault(_Button);

var _reactNotifications = __webpack_require__(78);

var _Progress = __webpack_require__(174);

var _reactRouterDom = __webpack_require__(39);

var _IntlMessages = __webpack_require__(145);

var _IntlMessages2 = _interopRequireDefault(_IntlMessages);

var _util = __webpack_require__(77);

var _Auth = __webpack_require__(185);

var _userManager = __webpack_require__(117);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SignUp = function (_React$Component) {
  _inherits(SignUp, _React$Component);

  function SignUp() {
    _classCallCheck(this, SignUp);

    var _this = _possibleConstructorReturn(this, (SignUp.__proto__ || Object.getPrototypeOf(SignUp)).call(this));

    _this.signup = function () {
      (0, _userManager.signUp)(_this.state.username, _this.state.email, _this.state.password, _this.state.mobile).then(function (data) {
        _this.props.history.push('/signin');
        _reactNotifications.NotificationManager.success('Signup Successful', 'Hey! ' + data.user.username + '. ');
      }, function (error) {
        _reactNotifications.NotificationManager.error(error.message);
      });
    };

    _this.changeMobileNumberFormat = function () {
      var newNumber = void 0,
          newNumberFormat = void 0;
      if (_this.state.mobile.charAt(0) === '0') {
        console.log("char. at 0 " + _this.state.mobile.charAt(0));
        newNumber = _this.state.mobile.slice(1, 10);
        newNumberFormat = '+61' + newNumber;
        _this.setState({
          mobile: newNumberFormat
        }, function () {
          _this.validatingMobileNumber(newNumberFormat);
        });
      } else {
        _this.validatingMobileNumber(_this.state.mobile);
      }
    };

    _this.validatingMobileNumber = function (mobileNumber) {
      //   let phoneExpression = /^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
      var phoneExpression = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;
      if (mobileNumber !== null || mobileNumber !== '') {
        if (mobileNumber.match(phoneExpression) && mobileNumber.length === 12) {
          _this.signup();
        } else {
          (0, _util.createNotification)('Invalid Mobile number.', 'Error', 'Error');
        }
      }
    };

    _this.state = {
      username: '',
      mobile: '',
      email: '',
      password: ''
    };
    _this.signup.bind(_this);
    return _this;
  }

  _createClass(SignUp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      $('.app-main').toggleClass('bg-wrapper');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      $('.app-main').toggleClass('bg-wrapper');
    }

    // componentDidUpdate() {
    //     if (this.props.showMessage) {
    //         setTimeout(() => {
    //             this.props.hideMessage();
    //         }, 3000);
    //     }
    //     if (this.props.authUser !== null) {
    //         this.props.history.push('/');
    //     }
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          username = _state.username,
          mobile = _state.mobile,
          email = _state.email,
          password = _state.password;
      var _props = this.props,
          showMessage = _props.showMessage,
          loader = _props.loader,
          alertMessage = _props.alertMessage;

      return _react2.default.createElement('div', {
        id: 'signup',
        className: 'app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3'
      }, _react2.default.createElement('div', { className: 'app-login-main-content' }, _react2.default.createElement('div', { className: 'app-logo-content d-flex align-items-center justify-content-center' }, _react2.default.createElement('a', { className: 'logo-lg', href: 'http://www.symbioticnexus.com/' }, _react2.default.createElement('img', {
        className: 'img-responsive w-100',
        src: '/assets/images/symbiotic.png',
        alt: 'Symbiotic',
        title: 'Symbiotic'
      }))), _react2.default.createElement('div', { className: 'app-login-content' }, _react2.default.createElement('div', { className: 'app-login-header' }, _react2.default.createElement('h1', { className: 'text-dark' }, 'Sign Up')), _react2.default.createElement('div', { className: 'mb-4' }, _react2.default.createElement('h2', null, _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.createAccount' }))), _react2.default.createElement('div', { className: 'app-login-form' }, _react2.default.createElement('form', { method: 'post', action: '/' }, _react2.default.createElement(_TextField2.default, {
        type: 'text',
        id: 'username',
        label: 'Username',
        onChange: function onChange(event) {
          return _this2.setState({ username: event.target.value });
        },
        fullWidth: true,
        defaultValue: this.state.username,
        margin: 'normal',
        className: 'mt-0 mb-2',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'tel',
        id: 'mobile',
        label: 'Mobile Number',
        onChange: function onChange(event) {
          return _this2.setState({ mobile: event.target.value });
        }
        // onChange={this.validatingMobileNumber}
        , fullWidth: true,
        defaultValue: mobile,
        margin: 'normal',
        className: 'mt-0 mb-2',
        minLength: '10',
        maxLength: '12',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'email',
        onChange: function onChange(event) {
          return _this2.setState({ email: event.target.value });
        },
        id: 'email',
        label: _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.email' }),
        fullWidth: true,
        defaultValue: email,
        margin: 'normal',
        className: 'mt-0 mb-2',
        required: true
      }), _react2.default.createElement(_TextField2.default, {
        type: 'password',
        onChange: function onChange(event) {
          return _this2.setState({ password: event.target.value });
        },
        id: 'password',
        label: _react2.default.createElement(_IntlMessages2.default, { id: 'appModule.password' }),
        fullWidth: true,
        defaultValue: password,
        margin: 'normal',
        className: 'mt-0 mb-4',
        required: true
      }), _react2.default.createElement('div', { className: 'mb-3 d-flex align-items-center justify-content-between' }, _react2.default.createElement(_Button2.default, {
        variant: 'raised',
        onClick: this.changeMobileNumberFormat,
        color: 'primary'
      }, 'Register'), _react2.default.createElement(_reactRouterDom.Link, { className: 'link-color', to: '/signin' }, _react2.default.createElement(_IntlMessages2.default, { id: 'signUp.alreadyMember' }))))))), loader && _react2.default.createElement('div', { className: 'loader-view' }, _react2.default.createElement(_Progress.CircularProgress, null)), showMessage && _reactNotifications.NotificationManager.error(alertMessage), _react2.default.createElement(_reactNotifications.NotificationContainer, null));
    }
  }]);

  return SignUp;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var auth = _ref.auth,
      profileInfo = _ref.profileInfo;
  var loader = auth.loader,
      alertMessage = auth.alertMessage,
      showMessage = auth.showMessage,
      authUser = auth.authUser;

  return {
    loader: loader, alertMessage: alertMessage, showMessage: showMessage, authUser: authUser, cognitoUser: profileInfo.cognitoUser
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  userSignUp: _Auth.userSignUp,
  hideMessage: _Auth.hideMessage,
  showAuthLoader: _Auth.showAuthLoader,
  userFacebookSignIn: _Auth.userFacebookSignIn,
  userGoogleSignIn: _Auth.userGoogleSignIn,
  userGithubSignIn: _Auth.userGithubSignIn,
  userTwitterSignIn: _Auth.userTwitterSignIn
})(SignUp);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SignUp, 'SignUp', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js');
}();

;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_createClass, "_createClass", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_TextField2, "_TextField2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_Button2, "_Button2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_IntlMessages2, "_IntlMessages2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(SignUp, "SignUp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(mapStateToProps, "mapStateToProps", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");

  __REACT_HOT_LOADER__.register(_temp, "_temp", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/containers/SignUp.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

module.exports = {"theme":{"name":"dark-theme"}}

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(39);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var LandingPage = function (_Component) {
    _inherits(LandingPage, _Component);

    function LandingPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LandingPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LandingPage.__proto__ || Object.getPrototypeOf(LandingPage)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {

            return _react2.default.createElement("div", { className: "container-fluid sos-body-container px-0" }, _react2.default.createElement("div", { className: "row parentContent-wrapper w-100 mx-0" }, " ", _react2.default.createElement("div", { className: "col-12 landingPage-wrapper" }, _react2.default.createElement("div", { className: "row pt-3" }, _react2.default.createElement("div", { className: "col-6 left-logo" }, _react2.default.createElement("a", { href: "", target: "_blank" }, _react2.default.createElement("img", { src: "/assets/images/Senstra_logo-2.png", alt: "logo", className: "img-fluid" }))), _react2.default.createElement("div", { className: "col-6 text-right right-awsIcon" }, _react2.default.createElement("img", { src: "/assets/images/aws-icon.png", alt: "aws-icon" }))), _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "col-12 text-center caption-outer" }, _react2.default.createElement("h1", null, " Senstra "), _react2.default.createElement("p", null, " A scalable, modular, secure, cloud-based IOT solution "))), _react2.default.createElement("div", { className: "row" }, _react2.default.createElement("div", { className: "col-12 text-center videoBtn-outer" }, _react2.default.createElement("img", { src: "/assets/images/video-icon.png", alt: "video-icon" }), _react2.default.createElement("br", null), _react2.default.createElement("a", { href: "#/signin" }, _react2.default.createElement("button", { className: "getStarted-btn" }, "Get Started !")), _react2.default.createElement("h6", { className: "pt-5" }, " App Catalogue "))))));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return LandingPage;
}(_react.Component);

var _default = LandingPage;
exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(LandingPage, "LandingPage", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_default, "default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");
}();

;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(_react2, "_react2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_interopRequireDefault, "_interopRequireDefault", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_classCallCheck, "_classCallCheck", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_possibleConstructorReturn, "_possibleConstructorReturn", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_inherits, "_inherits", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(LandingPage, "LandingPage", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_default, "_default", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");

    __REACT_HOT_LOADER__.register(_temp2, "_temp2", "F:/Australia Projects/senstra04052022/heartbeat-dashboard/src/app/routes/components/routes/homePage/homePage.js");
}();

;

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PersistGate", function() { return PersistGate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * Bootstrap v4.6.1 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function (global, factory) {
   true ? factory(exports, __webpack_require__(31), __webpack_require__(2060)) :
  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.bootstrap = {}, global.jQuery, global.Popper));
})(this, (function (exports, $, Popper) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
  var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;

    _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.1): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * Private TransitionEnd Helpers
   */

  var TRANSITION_END = 'transitionend';
  var MAX_UID = 1000000;
  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

  function toType(obj) {
    if (obj === null || typeof obj === 'undefined') {
      return "" + obj;
    }

    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: TRANSITION_END,
      delegateType: TRANSITION_END,
      handle: function handle(event) {
        if ($__default["default"](event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }

        return undefined;
      }
    };
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;
    $__default["default"](this).one(Util.TRANSITION_END, function () {
      called = true;
    });
    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);
    return this;
  }

  function setTransitionEndSupport() {
    $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
    $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
  }
  /**
   * Public Util API
   */


  var Util = {
    TRANSITION_END: 'bsTransitionEnd',
    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));

      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        var hrefAttr = element.getAttribute('href');
        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
      }

      try {
        return document.querySelector(selector) ? selector : null;
      } catch (_) {
        return null;
      }
    },
    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
      if (!element) {
        return 0;
      } // Get transition-duration of the element


      var transitionDuration = $__default["default"](element).css('transition-duration');
      var transitionDelay = $__default["default"](element).css('transition-delay');
      var floatTransitionDuration = parseFloat(transitionDuration);
      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

      if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
      } // If multiple durations are defined, take the first


      transitionDuration = transitionDuration.split(',')[0];
      transitionDelay = transitionDelay.split(',')[0];
      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $__default["default"](element).trigger(TRANSITION_END);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(TRANSITION_END);
    },
    isElement: function isElement(obj) {
      return (obj[0] || obj).nodeType;
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && Util.isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
          }
        }
      }
    },
    findShadowRoot: function findShadowRoot(element) {
      if (!document.documentElement.attachShadow) {
        return null;
      } // Can find the shadow root otherwise it'll return the document


      if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
      }

      if (element instanceof ShadowRoot) {
        return element;
      } // when we don't find a shadow root


      if (!element.parentNode) {
        return null;
      }

      return Util.findShadowRoot(element.parentNode);
    },
    jQueryDetection: function jQueryDetection() {
      if (typeof $__default["default"] === 'undefined') {
        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
      }

      var version = $__default["default"].fn.jquery.split(' ')[0].split('.');
      var minMajor = 1;
      var ltMajor = 2;
      var minMinor = 9;
      var minPatch = 1;
      var maxMajor = 4;

      if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
      }
    }
  };
  Util.jQueryDetection();
  setTransitionEndSupport();

  /**
   * Constants
   */

  var NAME$a = 'alert';
  var VERSION$a = '4.6.1';
  var DATA_KEY$a = 'bs.alert';
  var EVENT_KEY$a = "." + DATA_KEY$a;
  var DATA_API_KEY$7 = '.data-api';
  var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
  var CLASS_NAME_ALERT = 'alert';
  var CLASS_NAME_FADE$5 = 'fade';
  var CLASS_NAME_SHOW$7 = 'show';
  var EVENT_CLOSE = "close" + EVENT_KEY$a;
  var EVENT_CLOSED = "closed" + EVENT_KEY$a;
  var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
  var SELECTOR_DISMISS = '[data-dismiss="alert"]';
  /**
   * Class definition
   */

  var Alert = /*#__PURE__*/function () {
    function Alert(element) {
      this._element = element;
    } // Getters


    var _proto = Alert.prototype;

    // Public
    _proto.close = function close(element) {
      var rootElement = this._element;

      if (element) {
        rootElement = this._getRootElement(element);
      }

      var customEvent = this._triggerCloseEvent(rootElement);

      if (customEvent.isDefaultPrevented()) {
        return;
      }

      this._removeElement(rootElement);
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$a);
      this._element = null;
    } // Private
    ;

    _proto._getRootElement = function _getRootElement(element) {
      var selector = Util.getSelectorFromElement(element);
      var parent = false;

      if (selector) {
        parent = document.querySelector(selector);
      }

      if (!parent) {
        parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
      }

      return parent;
    };

    _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
      var closeEvent = $__default["default"].Event(EVENT_CLOSE);
      $__default["default"](element).trigger(closeEvent);
      return closeEvent;
    };

    _proto._removeElement = function _removeElement(element) {
      var _this = this;

      $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);

      if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
        this._destroyElement(element);

        return;
      }

      var transitionDuration = Util.getTransitionDurationFromElement(element);
      $__default["default"](element).one(Util.TRANSITION_END, function (event) {
        return _this._destroyElement(element, event);
      }).emulateTransitionEnd(transitionDuration);
    };

    _proto._destroyElement = function _destroyElement(element) {
      $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
    } // Static
    ;

    Alert._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$a);

        if (!data) {
          data = new Alert(this);
          $element.data(DATA_KEY$a, data);
        }

        if (config === 'close') {
          data[config](this);
        }
      });
    };

    Alert._handleDismiss = function _handleDismiss(alertInstance) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        alertInstance.close(this);
      };
    };

    _createClass(Alert, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$a;
      }
    }]);

    return Alert;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
  $__default["default"].fn[NAME$a].Constructor = Alert;

  $__default["default"].fn[NAME$a].noConflict = function () {
    $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
    return Alert._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$9 = 'button';
  var VERSION$9 = '4.6.1';
  var DATA_KEY$9 = 'bs.button';
  var EVENT_KEY$9 = "." + DATA_KEY$9;
  var DATA_API_KEY$6 = '.data-api';
  var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
  var CLASS_NAME_ACTIVE$3 = 'active';
  var CLASS_NAME_BUTTON = 'btn';
  var CLASS_NAME_FOCUS = 'focus';
  var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
  var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
  var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
  var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
  var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
  var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
  var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
  var SELECTOR_INPUT = 'input:not([type="hidden"])';
  var SELECTOR_ACTIVE$2 = '.active';
  var SELECTOR_BUTTON = '.btn';
  /**
   * Class definition
   */

  var Button = /*#__PURE__*/function () {
    function Button(element) {
      this._element = element;
      this.shouldAvoidTriggerChange = false;
    } // Getters


    var _proto = Button.prototype;

    // Public
    _proto.toggle = function toggle() {
      var triggerChangeEvent = true;
      var addAriaPressed = true;
      var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];

      if (rootElement) {
        var input = this._element.querySelector(SELECTOR_INPUT);

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);

              if (activeElement) {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
              }
            }
          }

          if (triggerChangeEvent) {
            // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
            if (input.type === 'checkbox' || input.type === 'radio') {
              input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
            }

            if (!this.shouldAvoidTriggerChange) {
              $__default["default"](input).trigger('change');
            }
          }

          input.focus();
          addAriaPressed = false;
        }
      }

      if (!(this._element.hasAttribute('disabled') || this._element.classList.contains('disabled'))) {
        if (addAriaPressed) {
          this._element.setAttribute('aria-pressed', !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
        }

        if (triggerChangeEvent) {
          $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
        }
      }
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$9);
      this._element = null;
    } // Static
    ;

    Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$9);

        if (!data) {
          data = new Button(this);
          $element.data(DATA_KEY$9, data);
        }

        data.shouldAvoidTriggerChange = avoidTriggerChange;

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$9;
      }
    }]);

    return Button;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
    var button = event.target;
    var initialButton = button;

    if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) {
      button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
    }

    if (!button || button.hasAttribute('disabled') || button.classList.contains('disabled')) {
      event.preventDefault(); // work around Firefox bug #1540995
    } else {
      var inputBtn = button.querySelector(SELECTOR_INPUT);

      if (inputBtn && (inputBtn.hasAttribute('disabled') || inputBtn.classList.contains('disabled'))) {
        event.preventDefault(); // work around Firefox bug #1540995

        return;
      }

      if (initialButton.tagName === 'INPUT' || button.tagName !== 'LABEL') {
        Button._jQueryInterface.call($__default["default"](button), 'toggle', initialButton.tagName === 'INPUT');
      }
    }
  }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
    var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
    $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
  });
  $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function () {
    // ensure correct active class is set to match the controls' actual values/states
    // find all checkboxes/readio buttons inside data-toggle groups
    var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));

    for (var i = 0, len = buttons.length; i < len; i++) {
      var button = buttons[i];
      var input = button.querySelector(SELECTOR_INPUT);

      if (input.checked || input.hasAttribute('checked')) {
        button.classList.add(CLASS_NAME_ACTIVE$3);
      } else {
        button.classList.remove(CLASS_NAME_ACTIVE$3);
      }
    } // find all button toggles


    buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));

    for (var _i = 0, _len = buttons.length; _i < _len; _i++) {
      var _button = buttons[_i];

      if (_button.getAttribute('aria-pressed') === 'true') {
        _button.classList.add(CLASS_NAME_ACTIVE$3);
      } else {
        _button.classList.remove(CLASS_NAME_ACTIVE$3);
      }
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$9] = Button._jQueryInterface;
  $__default["default"].fn[NAME$9].Constructor = Button;

  $__default["default"].fn[NAME$9].noConflict = function () {
    $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
    return Button._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$8 = 'carousel';
  var VERSION$8 = '4.6.1';
  var DATA_KEY$8 = 'bs.carousel';
  var EVENT_KEY$8 = "." + DATA_KEY$8;
  var DATA_API_KEY$5 = '.data-api';
  var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

  var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

  var SWIPE_THRESHOLD = 40;
  var CLASS_NAME_CAROUSEL = 'carousel';
  var CLASS_NAME_ACTIVE$2 = 'active';
  var CLASS_NAME_SLIDE = 'slide';
  var CLASS_NAME_RIGHT = 'carousel-item-right';
  var CLASS_NAME_LEFT = 'carousel-item-left';
  var CLASS_NAME_NEXT = 'carousel-item-next';
  var CLASS_NAME_PREV = 'carousel-item-prev';
  var CLASS_NAME_POINTER_EVENT = 'pointer-event';
  var DIRECTION_NEXT = 'next';
  var DIRECTION_PREV = 'prev';
  var DIRECTION_LEFT = 'left';
  var DIRECTION_RIGHT = 'right';
  var EVENT_SLIDE = "slide" + EVENT_KEY$8;
  var EVENT_SLID = "slid" + EVENT_KEY$8;
  var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
  var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
  var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
  var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
  var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
  var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
  var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
  var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
  var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
  var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
  var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
  var SELECTOR_ACTIVE$1 = '.active';
  var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
  var SELECTOR_ITEM = '.carousel-item';
  var SELECTOR_ITEM_IMG = '.carousel-item img';
  var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
  var SELECTOR_INDICATORS = '.carousel-indicators';
  var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
  var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
  var Default$7 = {
    interval: 5000,
    keyboard: true,
    slide: false,
    pause: 'hover',
    wrap: true,
    touch: true
  };
  var DefaultType$7 = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    slide: '(boolean|string)',
    pause: '(string|boolean)',
    wrap: 'boolean',
    touch: 'boolean'
  };
  var PointerType = {
    TOUCH: 'touch',
    PEN: 'pen'
  };
  /**
   * Class definition
   */

  var Carousel = /*#__PURE__*/function () {
    function Carousel(element, config) {
      this._items = null;
      this._interval = null;
      this._activeElement = null;
      this._isPaused = false;
      this._isSliding = false;
      this.touchTimeout = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;
      this._config = this._getConfig(config);
      this._element = element;
      this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
      this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
      this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);

      this._addEventListeners();
    } // Getters


    var _proto = Carousel.prototype;

    // Public
    _proto.next = function next() {
      if (!this._isSliding) {
        this._slide(DIRECTION_NEXT);
      }
    };

    _proto.nextWhenVisible = function nextWhenVisible() {
      var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
      // or the carousel or its parent isn't visible

      if (!document.hidden && $element.is(':visible') && $element.css('visibility') !== 'hidden') {
        this.next();
      }
    };

    _proto.prev = function prev() {
      if (!this._isSliding) {
        this._slide(DIRECTION_PREV);
      }
    };

    _proto.pause = function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
        Util.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    };

    _proto.cycle = function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._updateInterval();

        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    };

    _proto.to = function to(index) {
      var _this = this;

      this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        $__default["default"](this._element).one(EVENT_SLID, function () {
          return _this.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;

      this._slide(direction, this._items[index]);
    };

    _proto.dispose = function dispose() {
      $__default["default"](this._element).off(EVENT_KEY$8);
      $__default["default"].removeData(this._element, DATA_KEY$8);
      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$7, config);
      Util.typeCheckConfig(NAME$8, config, DefaultType$7);
      return config;
    };

    _proto._handleSwipe = function _handleSwipe() {
      var absDeltax = Math.abs(this.touchDeltaX);

      if (absDeltax <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltax / this.touchDeltaX;
      this.touchDeltaX = 0; // swipe left

      if (direction > 0) {
        this.prev();
      } // swipe right


      if (direction < 0) {
        this.next();
      }
    };

    _proto._addEventListeners = function _addEventListeners() {
      var _this2 = this;

      if (this._config.keyboard) {
        $__default["default"](this._element).on(EVENT_KEYDOWN, function (event) {
          return _this2._keydown(event);
        });
      }

      if (this._config.pause === 'hover') {
        $__default["default"](this._element).on(EVENT_MOUSEENTER, function (event) {
          return _this2.pause(event);
        }).on(EVENT_MOUSELEAVE, function (event) {
          return _this2.cycle(event);
        });
      }

      if (this._config.touch) {
        this._addTouchEventListeners();
      }
    };

    _proto._addTouchEventListeners = function _addTouchEventListeners() {
      var _this3 = this;

      if (!this._touchSupported) {
        return;
      }

      var start = function start(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchStartX = event.originalEvent.clientX;
        } else if (!_this3._pointerEvent) {
          _this3.touchStartX = event.originalEvent.touches[0].clientX;
        }
      };

      var move = function move(event) {
        // ensure swiping with one touch and not pinching
        _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
      };

      var end = function end(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
        }

        _this3._handleSwipe();

        if (_this3._config.pause === 'hover') {
          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling
          _this3.pause();

          if (_this3.touchTimeout) {
            clearTimeout(_this3.touchTimeout);
          }

          _this3.touchTimeout = setTimeout(function (event) {
            return _this3.cycle(event);
          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
        }
      };

      $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function (e) {
        return e.preventDefault();
      });

      if (this._pointerEvent) {
        $__default["default"](this._element).on(EVENT_POINTERDOWN, function (event) {
          return start(event);
        });
        $__default["default"](this._element).on(EVENT_POINTERUP, function (event) {
          return end(event);
        });

        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
      } else {
        $__default["default"](this._element).on(EVENT_TOUCHSTART, function (event) {
          return start(event);
        });
        $__default["default"](this._element).on(EVENT_TOUCHMOVE, function (event) {
          return move(event);
        });
        $__default["default"](this._element).on(EVENT_TOUCHEND, function (event) {
          return end(event);
        });
      }
    };

    _proto._keydown = function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;

        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;
      }
    };

    _proto._getItemIndex = function _getItemIndex(element) {
      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
      return this._items.indexOf(element);
    };

    _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === DIRECTION_NEXT;
      var isPrevDirection = direction === DIRECTION_PREV;

      var activeIndex = this._getItemIndex(activeElement);

      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === DIRECTION_PREV ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;
      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    };

    _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var targetIndex = this._getItemIndex(relatedTarget);

      var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));

      var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName,
        from: fromIndex,
        to: targetIndex
      });
      $__default["default"](this._element).trigger(slideEvent);
      return slideEvent;
    };

    _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
        $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
        }
      }
    };

    _proto._updateInterval = function _updateInterval() {
      var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      if (!element) {
        return;
      }

      var elementInterval = parseInt(element.getAttribute('data-interval'), 10);

      if (elementInterval) {
        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
        this._config.interval = elementInterval;
      } else {
        this._config.interval = this._config.defaultInterval || this._config.interval;
      }
    };

    _proto._slide = function _slide(direction, element) {
      var _this4 = this;

      var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      var activeElementIndex = this._getItemIndex(activeElement);

      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

      var nextElementIndex = this._getItemIndex(nextElement);

      var isCycling = Boolean(this._interval);
      var directionalClassName;
      var orderClassName;
      var eventDirectionName;

      if (direction === DIRECTION_NEXT) {
        directionalClassName = CLASS_NAME_LEFT;
        orderClassName = CLASS_NAME_NEXT;
        eventDirectionName = DIRECTION_LEFT;
      } else {
        directionalClassName = CLASS_NAME_RIGHT;
        orderClassName = CLASS_NAME_PREV;
        eventDirectionName = DIRECTION_RIGHT;
      }

      if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // Some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      this._activeElement = nextElement;
      var slidEvent = $__default["default"].Event(EVENT_SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName,
        from: activeElementIndex,
        to: nextElementIndex
      });

      if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
        $__default["default"](nextElement).addClass(orderClassName);
        Util.reflow(nextElement);
        $__default["default"](activeElement).addClass(directionalClassName);
        $__default["default"](nextElement).addClass(directionalClassName);
        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
        $__default["default"](activeElement).one(Util.TRANSITION_END, function () {
          $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
          $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
          _this4._isSliding = false;
          setTimeout(function () {
            return $__default["default"](_this4._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
        $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
        this._isSliding = false;
        $__default["default"](this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    } // Static
    ;

    Carousel._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$8);

        var _config = _extends({}, Default$7, $__default["default"](this).data());

        if (typeof config === 'object') {
          _config = _extends({}, _config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          $__default["default"](this).data(DATA_KEY$8, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (typeof data[action] === 'undefined') {
            throw new TypeError("No method named \"" + action + "\"");
          }

          data[action]();
        } else if (_config.interval && _config.ride) {
          data.pause();
          data.cycle();
        }
      });
    };

    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
      var selector = Util.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = $__default["default"](selector)[0];

      if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) {
        return;
      }

      var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());

      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call($__default["default"](target), config);

      if (slideIndex) {
        $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
      }

      event.preventDefault();
    };

    _createClass(Carousel, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$8;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$7;
      }
    }]);

    return Carousel;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
  $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function () {
    var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));

    for (var i = 0, len = carousels.length; i < len; i++) {
      var $carousel = $__default["default"](carousels[i]);

      Carousel._jQueryInterface.call($carousel, $carousel.data());
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
  $__default["default"].fn[NAME$8].Constructor = Carousel;

  $__default["default"].fn[NAME$8].noConflict = function () {
    $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
    return Carousel._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$7 = 'collapse';
  var VERSION$7 = '4.6.1';
  var DATA_KEY$7 = 'bs.collapse';
  var EVENT_KEY$7 = "." + DATA_KEY$7;
  var DATA_API_KEY$4 = '.data-api';
  var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
  var CLASS_NAME_SHOW$6 = 'show';
  var CLASS_NAME_COLLAPSE = 'collapse';
  var CLASS_NAME_COLLAPSING = 'collapsing';
  var CLASS_NAME_COLLAPSED = 'collapsed';
  var DIMENSION_WIDTH = 'width';
  var DIMENSION_HEIGHT = 'height';
  var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
  var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
  var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
  var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
  var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
  var SELECTOR_ACTIVES = '.show, .collapsing';
  var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
  var Default$6 = {
    toggle: true,
    parent: ''
  };
  var DefaultType$6 = {
    toggle: 'boolean',
    parent: '(string|element)'
  };
  /**
   * Class definition
   */

  var Collapse = /*#__PURE__*/function () {
    function Collapse(element, config) {
      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
      var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));

      for (var i = 0, len = toggleList.length; i < len; i++) {
        var elem = toggleList[i];
        var selector = Util.getSelectorFromElement(elem);
        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
          return foundElem === element;
        });

        if (selector !== null && filterElement.length > 0) {
          this._selector = selector;

          this._triggerArray.push(elem);
        }
      }

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    } // Getters


    var _proto = Collapse.prototype;

    // Public
    _proto.toggle = function toggle() {
      if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        this.hide();
      } else {
        this.show();
      }
    };

    _proto.show = function show() {
      var _this = this;

      if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        return;
      }

      var actives;
      var activesData;

      if (this._parent) {
        actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function (elem) {
          if (typeof _this._config.parent === 'string') {
            return elem.getAttribute('data-parent') === _this._config.parent;
          }

          return elem.classList.contains(CLASS_NAME_COLLAPSE);
        });

        if (actives.length === 0) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $__default["default"].Event(EVENT_SHOW$4);
      $__default["default"](this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), 'hide');

        if (!activesData) {
          $__default["default"](actives).data(DATA_KEY$7, null);
        }
      }

      var dimension = this._getDimension();

      $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
      this._element.style[dimension] = 0;

      if (this._triggerArray.length) {
        $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
        _this._element.style[dimension] = '';

        _this.setTransitioning(false);

        $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
      };

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = "scroll" + capitalizedDimension;
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      this._element.style[dimension] = this._element[scrollSize] + "px";
    };

    _proto.hide = function hide() {
      var _this2 = this;

      if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        return;
      }

      var startEvent = $__default["default"].Event(EVENT_HIDE$4);
      $__default["default"](this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();

      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
      Util.reflow(this._element);
      $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
      var triggerArrayLength = this._triggerArray.length;

      if (triggerArrayLength > 0) {
        for (var i = 0; i < triggerArrayLength; i++) {
          var trigger = this._triggerArray[i];
          var selector = Util.getSelectorFromElement(trigger);

          if (selector !== null) {
            var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));

            if (!$elem.hasClass(CLASS_NAME_SHOW$6)) {
              $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', false);
            }
          }
        }
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this2.setTransitioning(false);

        $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
      };

      this._element.style[dimension] = '';
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
    };

    _proto.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$7);
      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$6, config);
      config.toggle = Boolean(config.toggle); // Coerce string values

      Util.typeCheckConfig(NAME$7, config, DefaultType$6);
      return config;
    };

    _proto._getDimension = function _getDimension() {
      var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
      return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
    };

    _proto._getParent = function _getParent() {
      var _this3 = this;

      var parent;

      if (Util.isElement(this._config.parent)) {
        parent = this._config.parent; // It's a jQuery object

        if (typeof this._config.parent.jquery !== 'undefined') {
          parent = this._config.parent[0];
        }
      } else {
        parent = document.querySelector(this._config.parent);
      }

      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
      var children = [].slice.call(parent.querySelectorAll(selector));
      $__default["default"](children).each(function (i, element) {
        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });
      return parent;
    };

    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);

      if (triggerArray.length) {
        $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
      }
    } // Static
    ;

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? document.querySelector(selector) : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$7);

        var _config = _extends({}, Default$6, $element.data(), typeof config === 'object' && config ? config : {});

        if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $element.data(DATA_KEY$7, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$7;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$6;
      }
    }]);

    return Collapse;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }

    var $trigger = $__default["default"](this);
    var selector = Util.getSelectorFromElement(this);
    var selectors = [].slice.call(document.querySelectorAll(selector));
    $__default["default"](selectors).each(function () {
      var $target = $__default["default"](this);
      var data = $target.data(DATA_KEY$7);
      var config = data ? 'toggle' : $trigger.data();

      Collapse._jQueryInterface.call($target, config);
    });
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
  $__default["default"].fn[NAME$7].Constructor = Collapse;

  $__default["default"].fn[NAME$7].noConflict = function () {
    $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
    return Collapse._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$6 = 'dropdown';
  var VERSION$6 = '4.6.1';
  var DATA_KEY$6 = 'bs.dropdown';
  var EVENT_KEY$6 = "." + DATA_KEY$6;
  var DATA_API_KEY$3 = '.data-api';
  var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
  var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key

  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
  var CLASS_NAME_DISABLED$1 = 'disabled';
  var CLASS_NAME_SHOW$5 = 'show';
  var CLASS_NAME_DROPUP = 'dropup';
  var CLASS_NAME_DROPRIGHT = 'dropright';
  var CLASS_NAME_DROPLEFT = 'dropleft';
  var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
  var CLASS_NAME_POSITION_STATIC = 'position-static';
  var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
  var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
  var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
  var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
  var EVENT_CLICK = "click" + EVENT_KEY$6;
  var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
  var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
  var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
  var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
  var SELECTOR_FORM_CHILD = '.dropdown form';
  var SELECTOR_MENU = '.dropdown-menu';
  var SELECTOR_NAVBAR_NAV = '.navbar-nav';
  var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
  var PLACEMENT_TOP = 'top-start';
  var PLACEMENT_TOPEND = 'top-end';
  var PLACEMENT_BOTTOM = 'bottom-start';
  var PLACEMENT_BOTTOMEND = 'bottom-end';
  var PLACEMENT_RIGHT = 'right-start';
  var PLACEMENT_LEFT = 'left-start';
  var Default$5 = {
    offset: 0,
    flip: true,
    boundary: 'scrollParent',
    reference: 'toggle',
    display: 'dynamic',
    popperConfig: null
  };
  var DefaultType$5 = {
    offset: '(number|string|function)',
    flip: 'boolean',
    boundary: '(string|element)',
    reference: '(string|element)',
    display: 'string',
    popperConfig: '(null|object)'
  };
  /**
   * Class definition
   */

  var Dropdown = /*#__PURE__*/function () {
    function Dropdown(element, config) {
      this._element = element;
      this._popper = null;
      this._config = this._getConfig(config);
      this._menu = this._getMenuElement();
      this._inNavbar = this._detectNavbar();

      this._addEventListeners();
    } // Getters


    var _proto = Dropdown.prototype;

    // Public
    _proto.toggle = function toggle() {
      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) {
        return;
      }

      var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);

      Dropdown._clearMenus();

      if (isActive) {
        return;
      }

      this.show(true);
    };

    _proto.show = function show(usePopper) {
      if (usePopper === void 0) {
        usePopper = false;
      }

      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $__default["default"](parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      } // Totally disable Popper for Dropdowns in Navbar


      if (!this._inNavbar && usePopper) {
        // Check for Popper dependency
        if (typeof Popper__default["default"] === 'undefined') {
          throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        }

        var referenceElement = this._element;

        if (this._config.reference === 'parent') {
          referenceElement = parent;
        } else if (Util.isElement(this._config.reference)) {
          referenceElement = this._config.reference; // Check if it's jQuery element

          if (typeof this._config.reference.jquery !== 'undefined') {
            referenceElement = this._config.reference[0];
          }
        } // If boundary is not `scrollParent`, then set position to `static`
        // to allow the menu to "escape" the scroll parent's boundaries
        // https://github.com/twbs/bootstrap/issues/24251


        if (this._config.boundary !== 'scrollParent') {
          $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
        }

        this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) {
        $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
    };

    _proto.hide = function hide() {
      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $__default["default"](parent).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      if (this._popper) {
        this._popper.destroy();
      }

      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$6);
      $__default["default"](this._element).off(EVENT_KEY$6);
      this._element = null;
      this._menu = null;

      if (this._popper !== null) {
        this._popper.destroy();

        this._popper = null;
      }
    };

    _proto.update = function update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Private
    ;

    _proto._addEventListeners = function _addEventListeners() {
      var _this = this;

      $__default["default"](this._element).on(EVENT_CLICK, function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.toggle();
      });
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
      Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getMenuElement = function _getMenuElement() {
      if (!this._menu) {
        var parent = Dropdown._getParentFromElement(this._element);

        if (parent) {
          this._menu = parent.querySelector(SELECTOR_MENU);
        }
      }

      return this._menu;
    };

    _proto._getPlacement = function _getPlacement() {
      var $parentDropdown = $__default["default"](this._element.parentNode);
      var placement = PLACEMENT_BOTTOM; // Handle dropup

      if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) {
        placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) {
        placement = PLACEMENT_RIGHT;
      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) {
        placement = PLACEMENT_LEFT;
      } else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) {
        placement = PLACEMENT_BOTTOMEND;
      }

      return placement;
    };

    _proto._detectNavbar = function _detectNavbar() {
      return $__default["default"](this._element).closest('.navbar').length > 0;
    };

    _proto._getOffset = function _getOffset() {
      var _this2 = this;

      var offset = {};

      if (typeof this._config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
          return data;
        };
      } else {
        offset.offset = this._config.offset;
      }

      return offset;
    };

    _proto._getPopperConfig = function _getPopperConfig() {
      var popperConfig = {
        placement: this._getPlacement(),
        modifiers: {
          offset: this._getOffset(),
          flip: {
            enabled: this._config.flip
          },
          preventOverflow: {
            boundariesElement: this._config.boundary
          }
        }
      }; // Disable Popper if we have a static display

      if (this._config.display === 'static') {
        popperConfig.modifiers.applyStyle = {
          enabled: false
        };
      }

      return _extends({}, popperConfig, this._config.popperConfig);
    } // Static
    ;

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$6);

        var _config = typeof config === 'object' ? config : null;

        if (!data) {
          data = new Dropdown(this, _config);
          $__default["default"](this).data(DATA_KEY$6, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
        return;
      }

      var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));

      for (var i = 0, len = toggles.length; i < len; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);

        var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (event && event.type === 'click') {
          relatedTarget.clickEvent = event;
        }

        if (!context) {
          continue;
        }

        var dropdownMenu = context._menu;

        if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
        $__default["default"](parent).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          continue;
        } // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support


        if ('ontouchstart' in document.documentElement) {
          $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
        }

        toggles[i].setAttribute('aria-expanded', 'false');

        if (context._popper) {
          context._popper.destroy();
        }

        $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
        $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = document.querySelector(selector);
      }

      return parent || element.parentNode;
    } // eslint-disable-next-line complexity
    ;

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
        return;
      }

      if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);

      var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);

      if (!isActive && event.which === ESCAPE_KEYCODE$1) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
        if (event.which === ESCAPE_KEYCODE$1) {
          $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger('focus');
        }

        $__default["default"](this).trigger('click');
        return;
      }

      var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function (item) {
        return $__default["default"](item).is(':visible');
      });

      if (items.length === 0) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // Up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // Down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$6;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$5;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$5;
      }
    }]);

    return Dropdown;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
    event.preventDefault();
    event.stopPropagation();

    Dropdown._jQueryInterface.call($__default["default"](this), 'toggle');
  }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function (e) {
    e.stopPropagation();
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
  $__default["default"].fn[NAME$6].Constructor = Dropdown;

  $__default["default"].fn[NAME$6].noConflict = function () {
    $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
    return Dropdown._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$5 = 'modal';
  var VERSION$5 = '4.6.1';
  var DATA_KEY$5 = 'bs.modal';
  var EVENT_KEY$5 = "." + DATA_KEY$5;
  var DATA_API_KEY$2 = '.data-api';
  var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var CLASS_NAME_SCROLLABLE = 'modal-dialog-scrollable';
  var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
  var CLASS_NAME_BACKDROP = 'modal-backdrop';
  var CLASS_NAME_OPEN = 'modal-open';
  var CLASS_NAME_FADE$4 = 'fade';
  var CLASS_NAME_SHOW$4 = 'show';
  var CLASS_NAME_STATIC = 'modal-static';
  var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
  var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
  var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
  var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
  var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
  var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
  var EVENT_RESIZE = "resize" + EVENT_KEY$5;
  var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
  var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
  var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
  var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
  var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
  var SELECTOR_DIALOG = '.modal-dialog';
  var SELECTOR_MODAL_BODY = '.modal-body';
  var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
  var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
  var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
  var SELECTOR_STICKY_CONTENT = '.sticky-top';
  var Default$4 = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };
  var DefaultType$4 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };
  /**
   * Class definition
   */

  var Modal = /*#__PURE__*/function () {
    function Modal(element, config) {
      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = element.querySelector(SELECTOR_DIALOG);
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._scrollbarWidth = 0;
    } // Getters


    var _proto = Modal.prototype;

    // Public
    _proto.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    _proto.show = function show(relatedTarget) {
      var _this = this;

      if (this._isShown || this._isTransitioning) {
        return;
      }

      var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
        relatedTarget: relatedTarget
      });
      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
        this._isTransitioning = true;
      }

      this._checkScrollbar();

      this._setScrollbar();

      this._adjustDialog();

      this._setEscapeEvent();

      this._setResizeEvent();

      $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function (event) {
        return _this.hide(event);
      });
      $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function () {
        $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function (event) {
          if ($__default["default"](event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    _proto.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (!this._isShown || this._isTransitioning) {
        return;
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
      $__default["default"](this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;
      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);

      if (transition) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      $__default["default"](document).off(EVENT_FOCUSIN);
      $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
      $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
      $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        this._hideModal();
      }
    };

    _proto.dispose = function dispose() {
      [window, this._element, this._dialog].forEach(function (htmlElement) {
        return $__default["default"](htmlElement).off(EVENT_KEY$5);
      });
      /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */

      $__default["default"](document).off(EVENT_FOCUSIN);
      $__default["default"].removeData(this._element, DATA_KEY$5);
      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._isTransitioning = null;
      this._scrollbarWidth = null;
    };

    _proto.handleUpdate = function handleUpdate() {
      this._adjustDialog();
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$4, config);
      Util.typeCheckConfig(NAME$5, config, DefaultType$4);
      return config;
    };

    _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
      var _this3 = this;

      var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
      $__default["default"](this._element).trigger(hideEventPrevented);

      if (hideEventPrevented.isDefaultPrevented()) {
        return;
      }

      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!isModalOverflowing) {
        this._element.style.overflowY = 'hidden';
      }

      this._element.classList.add(CLASS_NAME_STATIC);

      var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
      $__default["default"](this._element).off(Util.TRANSITION_END);
      $__default["default"](this._element).one(Util.TRANSITION_END, function () {
        _this3._element.classList.remove(CLASS_NAME_STATIC);

        if (!isModalOverflowing) {
          $__default["default"](_this3._element).one(Util.TRANSITION_END, function () {
            _this3._element.style.overflowY = '';
          }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
        }
      }).emulateTransitionEnd(modalTransitionDuration);

      this._element.focus();
    };

    _proto._showElement = function _showElement(relatedTarget) {
      var _this4 = this;

      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
      var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) {
        modalBody.scrollTop = 0;
      } else {
        this._element.scrollTop = 0;
      }

      if (transition) {
        Util.reflow(this._element);
      }

      $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this4._config.focus) {
          _this4._element.focus();
        }

        _this4._isTransitioning = false;
        $__default["default"](_this4._element).trigger(shownEvent);
      };

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
        $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
      } else {
        transitionComplete();
      }
    };

    _proto._enforceFocus = function _enforceFocus() {
      var _this5 = this;

      $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
      .on(EVENT_FOCUSIN, function (event) {
        if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) {
          _this5._element.focus();
        }
      });
    };

    _proto._setEscapeEvent = function _setEscapeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function (event) {
          if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
            event.preventDefault();

            _this6.hide();
          } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
            _this6._triggerBackdropTransition();
          }
        });
      } else if (!this._isShown) {
        $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
      }
    };

    _proto._setResizeEvent = function _setResizeEvent() {
      var _this7 = this;

      if (this._isShown) {
        $__default["default"](window).on(EVENT_RESIZE, function (event) {
          return _this7.handleUpdate(event);
        });
      } else {
        $__default["default"](window).off(EVENT_RESIZE);
      }
    };

    _proto._hideModal = function _hideModal() {
      var _this8 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._element.removeAttribute('role');

      this._isTransitioning = false;

      this._showBackdrop(function () {
        $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);

        _this8._resetAdjustments();

        _this8._resetScrollbar();

        $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
      });
    };

    _proto._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $__default["default"](this._backdrop).remove();
        this._backdrop = null;
      }
    };

    _proto._showBackdrop = function _showBackdrop(callback) {
      var _this9 = this;

      var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : '';

      if (this._isShown && this._config.backdrop) {
        this._backdrop = document.createElement('div');
        this._backdrop.className = CLASS_NAME_BACKDROP;

        if (animate) {
          this._backdrop.classList.add(animate);
        }

        $__default["default"](this._backdrop).appendTo(document.body);
        $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function (event) {
          if (_this9._ignoreBackdropClick) {
            _this9._ignoreBackdropClick = false;
            return;
          }

          if (event.target !== event.currentTarget) {
            return;
          }

          if (_this9._config.backdrop === 'static') {
            _this9._triggerBackdropTransition();
          } else {
            _this9.hide();
          }
        });

        if (animate) {
          Util.reflow(this._backdrop);
        }

        $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);

        if (!callback) {
          return;
        }

        if (!animate) {
          callback();
          return;
        }

        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
        $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
      } else if (!this._isShown && this._backdrop) {
        $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);

        var callbackRemove = function callbackRemove() {
          _this9._removeBackdrop();

          if (callback) {
            callback();
          }
        };

        if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
          var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

          $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    } // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------
    ;

    _proto._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + "px";
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + "px";
      }
    };

    _proto._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    _proto._checkScrollbar = function _checkScrollbar() {
      var rect = document.body.getBoundingClientRect();
      this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    _proto._setScrollbar = function _setScrollbar() {
      var _this10 = this;

      if (this._isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
        var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding

        $__default["default"](fixedContent).each(function (index, element) {
          var actualPadding = element.style.paddingRight;
          var calculatedPadding = $__default["default"](element).css('padding-right');
          $__default["default"](element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
        }); // Adjust sticky content margin

        $__default["default"](stickyContent).each(function (index, element) {
          var actualMargin = element.style.marginRight;
          var calculatedMargin = $__default["default"](element).css('margin-right');
          $__default["default"](element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
        }); // Adjust body padding

        var actualPadding = document.body.style.paddingRight;
        var calculatedPadding = $__default["default"](document.body).css('padding-right');
        $__default["default"](document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
      }

      $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
    };

    _proto._resetScrollbar = function _resetScrollbar() {
      // Restore fixed content padding
      var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
      $__default["default"](fixedContent).each(function (index, element) {
        var padding = $__default["default"](element).data('padding-right');
        $__default["default"](element).removeData('padding-right');
        element.style.paddingRight = padding ? padding : '';
      }); // Restore sticky content

      var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
      $__default["default"](elements).each(function (index, element) {
        var margin = $__default["default"](element).data('margin-right');

        if (typeof margin !== 'undefined') {
          $__default["default"](element).css('margin-right', margin).removeData('margin-right');
        }
      }); // Restore body padding

      var padding = $__default["default"](document.body).data('padding-right');
      $__default["default"](document.body).removeData('padding-right');
      document.body.style.paddingRight = padding ? padding : '';
    };

    _proto._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    } // Static
    ;

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$5);

        var _config = _extends({}, Default$4, $__default["default"](this).data(), typeof config === 'object' && config ? config : {});

        if (!data) {
          data = new Modal(this, _config);
          $__default["default"](this).data(DATA_KEY$5, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$5;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$4;
      }
    }]);

    return Modal;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
    var _this11 = this;

    var target;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = document.querySelector(selector);
    }

    var config = $__default["default"](target).data(DATA_KEY$5) ? 'toggle' : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $__default["default"](target).one(EVENT_SHOW$2, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // Only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(EVENT_HIDDEN$2, function () {
        if ($__default["default"](_this11).is(':visible')) {
          _this11.focus();
        }
      });
    });

    Modal._jQueryInterface.call($__default["default"](target), config, this);
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
  $__default["default"].fn[NAME$5].Constructor = Modal;

  $__default["default"].fn[NAME$5].noConflict = function () {
    $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
    return Modal._jQueryInterface;
  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.1): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  };
  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */

  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */

  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase();

    if (allowedAttributeList.indexOf(attrName) !== -1) {
      if (uriAttrs.indexOf(attrName) !== -1) {
        return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
      }

      return true;
    }

    var regExp = allowedAttributeList.filter(function (attrRegex) {
      return attrRegex instanceof RegExp;
    }); // Check if a regular expression validates the attribute.

    for (var i = 0, len = regExp.length; i < len; i++) {
      if (regExp[i].test(attrName)) {
        return true;
      }
    }

    return false;
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml;
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml);
    }

    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var whitelistKeys = Object.keys(whiteList);
    var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));

    var _loop = function _loop(i, len) {
      var el = elements[i];
      var elName = el.nodeName.toLowerCase();

      if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
        el.parentNode.removeChild(el);
        return "continue";
      }

      var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread

      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
      attributeList.forEach(function (attr) {
        if (!allowedAttribute(attr, whitelistedAttributes)) {
          el.removeAttribute(attr.nodeName);
        }
      });
    };

    for (var i = 0, len = elements.length; i < len; i++) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }

    return createdDocument.body.innerHTML;
  }

  /**
   * Constants
   */

  var NAME$4 = 'tooltip';
  var VERSION$4 = '4.6.1';
  var DATA_KEY$4 = 'bs.tooltip';
  var EVENT_KEY$4 = "." + DATA_KEY$4;
  var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
  var CLASS_PREFIX$1 = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');
  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
  var CLASS_NAME_FADE$3 = 'fade';
  var CLASS_NAME_SHOW$3 = 'show';
  var HOVER_STATE_SHOW = 'show';
  var HOVER_STATE_OUT = 'out';
  var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
  var SELECTOR_ARROW = '.arrow';
  var TRIGGER_HOVER = 'hover';
  var TRIGGER_FOCUS = 'focus';
  var TRIGGER_CLICK = 'click';
  var TRIGGER_MANUAL = 'manual';
  var AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default$3 = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent',
    customClass: '',
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist,
    popperConfig: null
  };
  var DefaultType$3 = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string|function)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)',
    customClass: '(string|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    whiteList: 'object',
    popperConfig: '(null|object)'
  };
  var Event$1 = {
    HIDE: "hide" + EVENT_KEY$4,
    HIDDEN: "hidden" + EVENT_KEY$4,
    SHOW: "show" + EVENT_KEY$4,
    SHOWN: "shown" + EVENT_KEY$4,
    INSERTED: "inserted" + EVENT_KEY$4,
    CLICK: "click" + EVENT_KEY$4,
    FOCUSIN: "focusin" + EVENT_KEY$4,
    FOCUSOUT: "focusout" + EVENT_KEY$4,
    MOUSEENTER: "mouseenter" + EVENT_KEY$4,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$4
  };
  /**
   * Class definition
   */

  var Tooltip = /*#__PURE__*/function () {
    function Tooltip(element, config) {
      if (typeof Popper__default["default"] === 'undefined') {
        throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
      } // Private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $__default["default"](event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $__default["default"](event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
      $__default["default"](this.element).off(this.constructor.EVENT_KEY);
      $__default["default"](this.element).closest('.modal').off('hide.bs.modal', this._hideModalHandler);

      if (this.tip) {
        $__default["default"](this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($__default["default"](this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $__default["default"](this.element).trigger(showEvent);
        var shadowRoot = Util.findShadowRoot(this.element);
        var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);

        var container = this._getContainer();

        $__default["default"](tip).data(this.constructor.DATA_KEY, this);

        if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) {
          $__default["default"](tip).appendTo(container);
        }

        $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
        $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
        $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HOVER_STATE_OUT) {
            _this._leave(null, _this);
          }
        };

        if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
          var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
          $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $__default["default"](this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
      }

      this._activeTrigger[TRIGGER_CLICK] = false;
      this._activeTrigger[TRIGGER_FOCUS] = false;
      this._activeTrigger[TRIGGER_HOVER] = false;

      if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
        var transitionDuration = Util.getTransitionDurationFromElement(tip);
        $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Protected
    ;

    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $__default["default"](this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var tip = this.getTipElement();
      this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (this.config.html) {
          if (!$__default["default"](content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($__default["default"](content).text());
        }

        return;
      }

      if (this.config.html) {
        if (this.config.sanitize) {
          content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
        }

        $element.html(content);
      } else {
        $element.text(content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    } // Private
    ;

    _proto._getPopperConfig = function _getPopperConfig(attachment) {
      var _this3 = this;

      var defaultBsConfig = {
        placement: attachment,
        modifiers: {
          offset: this._getOffset(),
          flip: {
            behavior: this.config.fallbackPlacement
          },
          arrow: {
            element: SELECTOR_ARROW
          },
          preventOverflow: {
            boundariesElement: this.config.boundary
          }
        },
        onCreate: function onCreate(data) {
          if (data.originalPlacement !== data.placement) {
            _this3._handlePopperPlacementChange(data);
          }
        },
        onUpdate: function onUpdate(data) {
          return _this3._handlePopperPlacementChange(data);
        }
      };
      return _extends({}, defaultBsConfig, this.config.popperConfig);
    };

    _proto._getOffset = function _getOffset() {
      var _this4 = this;

      var offset = {};

      if (typeof this.config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
          return data;
        };
      } else {
        offset.offset = this.config.offset;
      }

      return offset;
    };

    _proto._getContainer = function _getContainer() {
      if (this.config.container === false) {
        return document.body;
      }

      if (Util.isElement(this.config.container)) {
        return $__default["default"](this.config.container);
      }

      return $__default["default"](document).find(this.config.container);
    };

    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this5 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function (event) {
            return _this5.toggle(event);
          });
        } else if (trigger !== TRIGGER_MANUAL) {
          var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
          var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
          $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function (event) {
            return _this5._enter(event);
          }).on(eventOut, _this5.config.selector, function (event) {
            return _this5._leave(event);
          });
        }
      });

      this._hideModalHandler = function () {
        if (_this5.element) {
          _this5.hide();
        }
      };

      $__default["default"](this.element).closest('.modal').on('hide.bs.modal', this._hideModalHandler);

      if (this.config.selector) {
        this.config = _extends({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = typeof this.element.getAttribute('data-original-title');

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $__default["default"](event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $__default["default"](event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
      }

      if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
        context._hoverState = HOVER_STATE_SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $__default["default"](event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $__default["default"](event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      var dataAttributes = $__default["default"](this.element).data();
      Object.keys(dataAttributes).forEach(function (dataAttr) {
        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
          delete dataAttributes[dataAttr];
        }
      });
      config = _extends({}, this.constructor.Default, dataAttributes, typeof config === 'object' && config ? config : {});

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);

      if (config.sanitize) {
        config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
      }

      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $__default["default"](this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);

      if (tabClass !== null && tabClass.length) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
      this.tip = popperData.instance.popper;

      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(popperData.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    } // Static
    ;

    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$4);

        var _config = typeof config === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $element.data(DATA_KEY$4, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$4;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$3;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$4;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$4;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event$1;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$4;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$3;
      }
    }]);

    return Tooltip;
  }();
  /**
   * jQuery
   */


  $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
  $__default["default"].fn[NAME$4].Constructor = Tooltip;

  $__default["default"].fn[NAME$4].noConflict = function () {
    $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
    return Tooltip._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$3 = 'popover';
  var VERSION$3 = '4.6.1';
  var DATA_KEY$3 = 'bs.popover';
  var EVENT_KEY$3 = "." + DATA_KEY$3;
  var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
  var CLASS_PREFIX = 'bs-popover';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var CLASS_NAME_FADE$2 = 'fade';
  var CLASS_NAME_SHOW$2 = 'show';
  var SELECTOR_TITLE = '.popover-header';
  var SELECTOR_CONTENT = '.popover-body';

  var Default$2 = _extends({}, Tooltip.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
  });

  var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
    content: '(string|element|function)'
  });

  var Event = {
    HIDE: "hide" + EVENT_KEY$3,
    HIDDEN: "hidden" + EVENT_KEY$3,
    SHOW: "show" + EVENT_KEY$3,
    SHOWN: "shown" + EVENT_KEY$3,
    INSERTED: "inserted" + EVENT_KEY$3,
    CLICK: "click" + EVENT_KEY$3,
    FOCUSIN: "focusin" + EVENT_KEY$3,
    FOCUSOUT: "focusout" + EVENT_KEY$3,
    MOUSEENTER: "mouseenter" + EVENT_KEY$3,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$3
  };
  /**
   * Class definition
   */

  var Popover = /*#__PURE__*/function (_Tooltip) {
    _inheritsLoose(Popover, _Tooltip);

    function Popover() {
      return _Tooltip.apply(this, arguments) || this;
    }

    var _proto = Popover.prototype;

    // Overrides
    _proto.isWithContent = function isWithContent() {
      return this.getTitle() || this._getContent();
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $__default["default"](this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events

      this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());

      var content = this._getContent();

      if (typeof content === 'function') {
        content = content.call(this.element);
      }

      this.setElementContent($tip.find(SELECTOR_CONTENT), content);
      $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
    } // Private
    ;

    _proto._getContent = function _getContent() {
      return this.element.getAttribute('data-content') || this.config.content;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $__default["default"](this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    } // Static
    ;

    Popover._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$3);

        var _config = typeof config === 'object' ? config : null;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Popover(this, _config);
          $__default["default"](this).data(DATA_KEY$3, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Popover, null, [{
      key: "VERSION",
      get: // Getters
      function get() {
        return VERSION$3;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$2;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$3;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$3;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$3;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$2;
      }
    }]);

    return Popover;
  }(Tooltip);
  /**
   * jQuery
   */


  $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
  $__default["default"].fn[NAME$3].Constructor = Popover;

  $__default["default"].fn[NAME$3].noConflict = function () {
    $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
    return Popover._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$2 = 'scrollspy';
  var VERSION$2 = '4.6.1';
  var DATA_KEY$2 = 'bs.scrollspy';
  var EVENT_KEY$2 = "." + DATA_KEY$2;
  var DATA_API_KEY$1 = '.data-api';
  var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
  var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
  var CLASS_NAME_ACTIVE$1 = 'active';
  var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
  var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
  var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
  var METHOD_OFFSET = 'offset';
  var METHOD_POSITION = 'position';
  var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
  var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
  var SELECTOR_NAV_LINKS = '.nav-link';
  var SELECTOR_NAV_ITEMS = '.nav-item';
  var SELECTOR_LIST_ITEMS = '.list-group-item';
  var SELECTOR_DROPDOWN$1 = '.dropdown';
  var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
  var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
  var Default$1 = {
    offset: 10,
    method: 'auto',
    target: ''
  };
  var DefaultType$1 = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };
  /**
   * Class definition
   */

  var ScrollSpy = /*#__PURE__*/function () {
    function ScrollSpy(element, config) {
      var _this = this;

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;
      $__default["default"](this._scrollElement).on(EVENT_SCROLL, function (event) {
        return _this._process(event);
      });
      this.refresh();

      this._process();
    } // Getters


    var _proto = ScrollSpy.prototype;

    // Public
    _proto.refresh = function refresh() {
      var _this2 = this;

      var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
      var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
      this._offsets = [];
      this._targets = [];
      this._scrollHeight = this._getScrollHeight();
      var targets = [].slice.call(document.querySelectorAll(this._selector));
      targets.map(function (element) {
        var target;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = document.querySelector(targetSelector);
        }

        if (target) {
          var targetBCR = target.getBoundingClientRect();

          if (targetBCR.width || targetBCR.height) {
            // TODO (fat): remove sketch reliance on jQuery position/offset
            return [$__default["default"](target)[offsetMethod]().top + offsetBase, targetSelector];
          }
        }

        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this2._offsets.push(item[0]);

        _this2._targets.push(item[1]);
      });
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$2);
      $__default["default"](this._scrollElement).off(EVENT_KEY$2);
      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$1, typeof config === 'object' && config ? config : {});

      if (typeof config.target !== 'string' && Util.isElement(config.target)) {
        var id = $__default["default"](config.target).attr('id');

        if (!id) {
          id = Util.getUID(NAME$2);
          $__default["default"](config.target).attr('id', id);
        }

        config.target = "#" + id;
      }

      Util.typeCheckConfig(NAME$2, config, DefaultType$1);
      return config;
    };

    _proto._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    _proto._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    _proto._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    };

    _proto._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;

      var scrollHeight = this._getScrollHeight();

      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }

        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;

        this._clear();

        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    _proto._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(',').map(function (selector) {
        return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
      });

      var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(','))));

      if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
        $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
        $link.addClass(CLASS_NAME_ACTIVE$1);
      } else {
        // Set triggered link as active
        $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item

        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
      }

      $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
        relatedTarget: target
      });
    };

    _proto._clear = function _clear() {
      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
        return node.classList.contains(CLASS_NAME_ACTIVE$1);
      }).forEach(function (node) {
        return node.classList.remove(CLASS_NAME_ACTIVE$1);
      });
    } // Static
    ;

    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$2);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $__default["default"](this).data(DATA_KEY$2, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$2;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$1;
      }
    }]);

    return ScrollSpy;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](window).on(EVENT_LOAD_DATA_API, function () {
    var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
    var scrollSpysLength = scrollSpys.length;

    for (var i = scrollSpysLength; i--;) {
      var $spy = $__default["default"](scrollSpys[i]);

      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
  $__default["default"].fn[NAME$2].Constructor = ScrollSpy;

  $__default["default"].fn[NAME$2].noConflict = function () {
    $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
    return ScrollSpy._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$1 = 'tab';
  var VERSION$1 = '4.6.1';
  var DATA_KEY$1 = 'bs.tab';
  var EVENT_KEY$1 = "." + DATA_KEY$1;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
  var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
  var CLASS_NAME_ACTIVE = 'active';
  var CLASS_NAME_DISABLED = 'disabled';
  var CLASS_NAME_FADE$1 = 'fade';
  var CLASS_NAME_SHOW$1 = 'show';
  var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
  var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
  var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
  var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
  var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
  var SELECTOR_DROPDOWN = '.dropdown';
  var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
  var SELECTOR_ACTIVE = '.active';
  var SELECTOR_ACTIVE_UL = '> li > .active';
  var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
  var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
  var SELECTOR_DROPDOWN_ACTIVE_CHILD = '> .dropdown-menu .active';
  /**
   * Class definition
   */

  var Tab = /*#__PURE__*/function () {
    function Tab(element) {
      this._element = element;
    } // Getters


    var _proto = Tab.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED)) {
        return;
      }

      var target;
      var previous;
      var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
      var selector = Util.getSelectorFromElement(this._element);

      if (listElement) {
        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
        previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
        previous = previous[previous.length - 1];
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
        relatedTarget: this._element
      });
      var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
        relatedTarget: previous
      });

      if (previous) {
        $__default["default"](previous).trigger(hideEvent);
      }

      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
        return;
      }

      if (selector) {
        target = document.querySelector(selector);
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
          relatedTarget: _this._element
        });
        var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
          relatedTarget: previous
        });
        $__default["default"](previous).trigger(hiddenEvent);
        $__default["default"](_this._element).trigger(shownEvent);
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$1);
      this._element = null;
    } // Private
    ;

    _proto._activate = function _activate(element, container, callback) {
      var _this2 = this;

      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
      var active = activeElements[0];
      var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);

      var complete = function complete() {
        return _this2._transitionComplete(element, active, callback);
      };

      if (active && isTransitioning) {
        var transitionDuration = Util.getTransitionDurationFromElement(active);
        $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._transitionComplete = function _transitionComplete(element, active, callback) {
      if (active) {
        $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
        var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];

        if (dropdownChild) {
          $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
        }

        if (active.getAttribute('role') === 'tab') {
          active.setAttribute('aria-selected', false);
        }
      }

      $__default["default"](element).addClass(CLASS_NAME_ACTIVE);

      if (element.getAttribute('role') === 'tab') {
        element.setAttribute('aria-selected', true);
      }

      Util.reflow(element);

      if (element.classList.contains(CLASS_NAME_FADE$1)) {
        element.classList.add(CLASS_NAME_SHOW$1);
      }

      var parent = element.parentNode;

      if (parent && parent.nodeName === 'LI') {
        parent = parent.parentNode;
      }

      if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
        var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];

        if (dropdownElement) {
          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
          $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    } // Static
    ;

    Tab._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $__default["default"](this);
        var data = $this.data(DATA_KEY$1);

        if (!data) {
          data = new Tab(this);
          $this.data(DATA_KEY$1, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tab, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$1;
      }
    }]);

    return Tab;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
    event.preventDefault();

    Tab._jQueryInterface.call($__default["default"](this), 'show');
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
  $__default["default"].fn[NAME$1].Constructor = Tab;

  $__default["default"].fn[NAME$1].noConflict = function () {
    $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
    return Tab._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME = 'toast';
  var VERSION = '4.6.1';
  var DATA_KEY = 'bs.toast';
  var EVENT_KEY = "." + DATA_KEY;
  var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
  var CLASS_NAME_FADE = 'fade';
  var CLASS_NAME_HIDE = 'hide';
  var CLASS_NAME_SHOW = 'show';
  var CLASS_NAME_SHOWING = 'showing';
  var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
  var EVENT_HIDE = "hide" + EVENT_KEY;
  var EVENT_HIDDEN = "hidden" + EVENT_KEY;
  var EVENT_SHOW = "show" + EVENT_KEY;
  var EVENT_SHOWN = "shown" + EVENT_KEY;
  var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
  var Default = {
    animation: true,
    autohide: true,
    delay: 500
  };
  var DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
  };
  /**
   * Class definition
   */

  var Toast = /*#__PURE__*/function () {
    function Toast(element, config) {
      this._element = element;
      this._config = this._getConfig(config);
      this._timeout = null;

      this._setListeners();
    } // Getters


    var _proto = Toast.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      var showEvent = $__default["default"].Event(EVENT_SHOW);
      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      this._clearTimeout();

      if (this._config.animation) {
        this._element.classList.add(CLASS_NAME_FADE);
      }

      var complete = function complete() {
        _this._element.classList.remove(CLASS_NAME_SHOWING);

        _this._element.classList.add(CLASS_NAME_SHOW);

        $__default["default"](_this._element).trigger(EVENT_SHOWN);

        if (_this._config.autohide) {
          _this._timeout = setTimeout(function () {
            _this.hide();
          }, _this._config.delay);
        }
      };

      this._element.classList.remove(CLASS_NAME_HIDE);

      Util.reflow(this._element);

      this._element.classList.add(CLASS_NAME_SHOWING);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto.hide = function hide() {
      if (!this._element.classList.contains(CLASS_NAME_SHOW)) {
        return;
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE);
      $__default["default"](this._element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      this._close();
    };

    _proto.dispose = function dispose() {
      this._clearTimeout();

      if (this._element.classList.contains(CLASS_NAME_SHOW)) {
        this._element.classList.remove(CLASS_NAME_SHOW);
      }

      $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
      $__default["default"].removeData(this._element, DATA_KEY);
      this._element = null;
      this._config = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, $__default["default"](this._element).data(), typeof config === 'object' && config ? config : {});
      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._setListeners = function _setListeners() {
      var _this2 = this;

      $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function () {
        return _this2.hide();
      });
    };

    _proto._close = function _close() {
      var _this3 = this;

      var complete = function complete() {
        _this3._element.classList.add(CLASS_NAME_HIDE);

        $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
      };

      this._element.classList.remove(CLASS_NAME_SHOW);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._clearTimeout = function _clearTimeout() {
      clearTimeout(this._timeout);
      this._timeout = null;
    } // Static
    ;

    Toast._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new Toast(this, _config);
          $element.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](this);
        }
      });
    };

    _createClass(Toast, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Toast;
  }();
  /**
   * jQuery
   */


  $__default["default"].fn[NAME] = Toast._jQueryInterface;
  $__default["default"].fn[NAME].Constructor = Toast;

  $__default["default"].fn[NAME].noConflict = function () {
    $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
    return Toast._jQueryInterface;
  };

  exports.Alert = Alert;
  exports.Button = Button;
  exports.Carousel = Carousel;
  exports.Collapse = Collapse;
  exports.Dropdown = Dropdown;
  exports.Modal = Modal;
  exports.Popover = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab = Tab;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;
  exports.Util = Util;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=bootstrap.js.map


/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2062);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(116)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./font-awesome.css", function() {
			var newContent = require("!!../../css-loader/index.js!./font-awesome.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(238);
exports = module.exports = __webpack_require__(115)(false);
// imports


// module
exports.push([module.i, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + escape(__webpack_require__(2063)) + ");src:url(" + escape(__webpack_require__(2064)) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(2065)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(2066)) + ") format(\"woff\"),url(" + escape(__webpack_require__(2067)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(2068)) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);

// exports


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "912ec66d7572ff821749319396470bde.svg";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/app.js